
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("YxYfk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d17b695829e550ab$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ApolloClientProvider", () => (parcelRequire("yuXsW")).ApolloClientProvider);
$parcel$export(module.exports, "IssueCreateModal", () => (parcelRequire("kk6kW")).default);
$parcel$export(module.exports, "messages", () => (parcelRequire("7QQh7")).default);

var $eUqFw = parcelRequire("eUqFw");

var $yuXsW = parcelRequire("yuXsW");

var $0cdA8 = parcelRequire("0cdA8");

var $e9DxM = parcelRequire("e9DxM");

var $1QpcB = parcelRequire("1QpcB");

var $ctR9z = parcelRequire("ctR9z");

var $69PXx = parcelRequire("69PXx");

var $7QQh7 = parcelRequire("7QQh7");

var $04KnN = parcelRequire("04KnN");

var $lq8gO = parcelRequire("lq8gO");

var $8naas = parcelRequire("8naas");

var $f9Boa = parcelRequire("f9Boa");

var $kk6kW = parcelRequire("kk6kW");

var $avcum = parcelRequire("avcum");
const $d17b695829e550ab$var$IssueCreateAppWithApolloProvider = ({ onError: onError })=>{
    const [{ isModalOpen: isModalOpen }] = (0, $ctR9z.useTriggerIssueCreateModal)();
    const { deleteIssueRestoreMeta: deleteIssueRestoreMeta } = (0, $1QpcB.useIssueRestoreMetaService)();
    const { isModalOpen: isX2CModalOpen, project: project, shouldShowX2CModal: shouldShowX2CModal, closeModal: closeModal } = (0, $f9Boa.useX2CModal)();
    const _onError = (0, $eUqFw.useCallback)(()=>{
        onError?.();
        deleteIssueRestoreMeta();
    }, [
        onError,
        deleteIssueRestoreMeta
    ]);
    const { giraClient: giraClient } = (0, $lq8gO.useIssueCreateFromAnywhereContext)();
    (0, $8naas.usePublishUseTriggerIssueCreateModalChange)();
    (0, $e9DxM.usePublishFormContext)();
    const renderIssueCreateModal = ({ onTransformCreateFormProps: onTransformCreateFormProps, setShouldRestore: setShouldRestore } = {})=>{
        if (isModalOpen) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kk6kW.default), {
            onTransformCreateFormProps: onTransformCreateFormProps,
            setShouldRestore: setShouldRestore,
            onResetApolloCache: ()=>(0, $yuXsW.resetCache)((0, $4c30c171b9221ecc$export$9c9ee93e509f8666))
        });
        return null;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "issue-create-app",
        packageName: "jiraIssueCreate",
        fallback: "flag",
        onError: _onError,
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $yuXsW.ApolloClientProvider), {
        client: giraClient
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $04KnN.NavigationDiscardChangesContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $avcum.IssueRestoreWrapper), null, ({ onTransformCreateFormProps: onTransformCreateFormProps, setShouldRestore: setShouldRestore })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            id: "issue-create-app-children",
            packageName: "jiraIssueCreate",
            fallback: "flag",
            onError: _onError,
            sendToPrivacyUnsafeSplunk: true
        }, renderIssueCreateModal({
            onTransformCreateFormProps: onTransformCreateFormProps,
            setShouldRestore: setShouldRestore
        }), shouldShowX2CModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $69PXx.ImportProjectModal), {
            isOpen: isX2CModalOpen,
            onClose: closeModal,
            project: project
        }))))));
};
var $d17b695829e550ab$export$2e2bcd8739ae039 = $d17b695829e550ab$var$IssueCreateAppWithApolloProvider;

});
parcelRegister("yuXsW", function(module, exports) {

$parcel$export(module.exports, "resetCache", () => $343a391851b41a38$export$6e5dca841bdf93e3);
$parcel$export(module.exports, "getClient", () => $343a391851b41a38$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "ApolloClientProvider", () => $343a391851b41a38$export$8e363dbef886ff17);

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $4ErPU = parcelRequire("4ErPU");

var $gd0Sp = parcelRequire("gd0Sp");
const $343a391851b41a38$var$CLIENTS_CACHE = {};
const $343a391851b41a38$export$6e5dca841bdf93e3 = (clientId)=>{
    // we need to `clearStore` directly to the InMemoryCache instance
    $343a391851b41a38$var$CLIENTS_CACHE[clientId]?.clearStore();
    delete $343a391851b41a38$var$CLIENTS_CACHE[clientId];
};
const $343a391851b41a38$export$44dd3e9494f887fc = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys($343a391851b41a38$var$CLIENTS_CACHE).reduce((acc, key)=>Object.assign(acc, {
            [`apollo-cache/${key}`]: $343a391851b41a38$var$CLIENTS_CACHE[key].extract()
        }), {});
const $343a391851b41a38$export$6bb76d6eba7e258c = (baseUrl, { clientId: clientId, clientCreator: clientCreator }, xsrfToken)=>{
    let client = $343a391851b41a38$var$CLIENTS_CACHE[clientId];
    if (!client) {
        client = clientCreator(baseUrl, xsrfToken);
        $343a391851b41a38$var$CLIENTS_CACHE[clientId] = client;
    }
    return client;
};
class $343a391851b41a38$export$8e363dbef886ff17 extends (0, $eUqFw.Component) {
    getClient(baseUrl, xsrfToken) {
        return $343a391851b41a38$export$6bb76d6eba7e258c(baseUrl, this.props.client, xsrfToken != null ? xsrfToken : undefined);
    }
    render() {
        const { children: children } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(this.props, 'client.clientId')) throw new Error('Please provide a client configuration');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
            const client = this.getClient(tenantContext.baseUrl, tenantContext.xsrfToken);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ErPU.ApolloProvider), {
                client: client
            }, children);
        });
    }
}

});
parcelRegister("4ErPU", function(module, exports) {

$parcel$export(module.exports, "getApolloContext", () => $36307d91b5e24fba$export$a47505d961ee3a1);
$parcel$export(module.exports, "ApolloProvider", () => $36307d91b5e24fba$export$c16b04c8a9956446);
$parcel$export(module.exports, "DocumentType", () => $36307d91b5e24fba$export$d1d99cf900472499);
$parcel$export(module.exports, "operationName", () => $36307d91b5e24fba$export$5db520940cf00715);
$parcel$export(module.exports, "parser", () => $36307d91b5e24fba$export$8f49e4af10703ce3);

var $eUqFw = parcelRequire("eUqFw");

var $8j2fP = parcelRequire("8j2fP");
var $36307d91b5e24fba$var$apolloContext;
function $36307d91b5e24fba$export$a47505d961ee3a1() {
    if (!$36307d91b5e24fba$var$apolloContext) $36307d91b5e24fba$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({});
    return $36307d91b5e24fba$var$apolloContext;
}
function $36307d91b5e24fba$export$c2ee824bcc89ca6a() {
    $36307d91b5e24fba$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({});
}
var $36307d91b5e24fba$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = $36307d91b5e24fba$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApolloContext.Consumer, null, function(context) {
        if (context === void 0) context = {};
        if (client && context.client !== client) context = Object.assign({}, context, {
            client: client
        });
        (0, $8j2fP.invariant)(context.client, 5);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApolloContext.Provider, {
            value: context
        }, children);
    });
};
var $36307d91b5e24fba$export$ed5ceab8c2bb5ce4 = function(props) {
    var ApolloContext = $36307d91b5e24fba$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ApolloContext.Consumer, null, function(context) {
        (0, $8j2fP.invariant)(context && context.client, 6);
        return props.children(context.client);
    });
};
var $36307d91b5e24fba$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($36307d91b5e24fba$export$d1d99cf900472499 || ($36307d91b5e24fba$export$d1d99cf900472499 = {}));
var $36307d91b5e24fba$var$cache = new Map();
function $36307d91b5e24fba$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $36307d91b5e24fba$export$d1d99cf900472499.Query:
            name = 'Query';
            break;
        case $36307d91b5e24fba$export$d1d99cf900472499.Mutation:
            name = 'Mutation';
            break;
        case $36307d91b5e24fba$export$d1d99cf900472499.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function $36307d91b5e24fba$export$8f49e4af10703ce3(document) {
    var cached = $36307d91b5e24fba$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $8j2fP.invariant)(!!document && !!document.kind, 1);
    var fragments = document.definitions.filter(function(x) {
        return x.kind === 'FragmentDefinition';
    });
    var queries = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'query';
    });
    var mutations = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'mutation';
    });
    var subscriptions = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'subscription';
    });
    (0, $8j2fP.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
    (0, $8j2fP.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
    type = queries.length ? $36307d91b5e24fba$export$d1d99cf900472499.Query : $36307d91b5e24fba$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $36307d91b5e24fba$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $8j2fP.invariant)(definitions.length === 1, 4);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
    else name = 'data';
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $36307d91b5e24fba$var$cache.set(document, payload);
    return payload;
}

});
parcelRegister("8j2fP", function(module, exports) {

$parcel$export(module.exports, "InvariantError", () => $60c1d8bb20ac9f24$export$cea12affaee22fe8);
$parcel$export(module.exports, "invariant", () => $60c1d8bb20ac9f24$export$f5708dca728d7177);

var $fKE23 = parcelRequire("fKE23");

var $2fFJv = parcelRequire("2fFJv");
var $60c1d8bb20ac9f24$var$genericMessage = "Invariant Violation";
var $60c1d8bb20ac9f24$var$_a = Object.setPrototypeOf, $60c1d8bb20ac9f24$var$setPrototypeOf = $60c1d8bb20ac9f24$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $60c1d8bb20ac9f24$var$_a;
var $60c1d8bb20ac9f24$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $fKE23.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $60c1d8bb20ac9f24$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $60c1d8bb20ac9f24$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $60c1d8bb20ac9f24$var$genericMessage;
        $60c1d8bb20ac9f24$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $60c1d8bb20ac9f24$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $60c1d8bb20ac9f24$export$cea12affaee22fe8(message);
}
function $60c1d8bb20ac9f24$var$wrapConsoleMethod(method) {
    return function() {
        return console[method].apply(console, arguments);
    };
}
(function(invariant) {
    invariant.warn = $60c1d8bb20ac9f24$var$wrapConsoleMethod("warn");
    invariant.error = $60c1d8bb20ac9f24$var$wrapConsoleMethod("error");
})($60c1d8bb20ac9f24$export$f5708dca728d7177 || ($60c1d8bb20ac9f24$export$f5708dca728d7177 = {}));
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var $60c1d8bb20ac9f24$export$e54fe5b0f43758f7 = {
    env: {}
};
if (typeof $2fFJv === "object") $60c1d8bb20ac9f24$export$e54fe5b0f43758f7 = $2fFJv;
else try {
    // Using Function to evaluate this assignment in global scope also escapes
    // the strict mode of the current module, thereby allowing the assignment.
    // Inspired by https://github.com/facebook/regenerator/pull/369.
    Function("stub", "process = stub")($60c1d8bb20ac9f24$export$e54fe5b0f43758f7);
} catch (atLeastWeTried) {
// The assignment can fail if a Content Security Policy heavy-handedly
// forbids Function usage. In those environments, developers should take
// extra care to replace process.env.NODE_ENV in their production builds,
// or define an appropriate global.process polyfill.
}
var $60c1d8bb20ac9f24$var$invariant$1 = $60c1d8bb20ac9f24$export$f5708dca728d7177;
var $60c1d8bb20ac9f24$export$2e2bcd8739ae039 = $60c1d8bb20ac9f24$var$invariant$1;

});



const $4c30c171b9221ecc$export$2eeebb625d70ae49 = 'SWAG';
const $4c30c171b9221ecc$export$9c9ee93e509f8666 = 'gira';
const $4c30c171b9221ecc$export$14a05c678c2af272 = 'REST';
const $4c30c171b9221ecc$export$b19c7b383ca04a4d = 'POLARIS';

parcelRegister("e9DxM", function(module, exports) {

$parcel$export(module.exports, "usePublishFormContext", () => $a77b5575ab4f91d6$export$9454401a65fa3f6c);

var $eUqFw = parcelRequire("eUqFw");

var $dNWQB = parcelRequire("dNWQB");
var $2gOs4 = parcelRequire("2gOs4");

var $fswni = parcelRequire("fswni");
const $a77b5575ab4f91d6$export$9454401a65fa3f6c = ()=>{
    const [state] = (0, $fswni.useFormContext)();
    const { publish: publish } = (0, $2gOs4.useGICLifeCycleEvents)();
    (0, $eUqFw.useEffect)(()=>{
        publish((0, $dNWQB.GIC_LIFECYCLE_EVENTS).FORM_CONTEXT_STATE_CHANGE, state);
    }, [
        publish,
        state
    ]);
};

});
parcelRegister("dNWQB", function(module, exports) {

$parcel$export(module.exports, "GIC_LIFECYCLE_EVENTS", () => $21eb2e23e0bf69c0$export$876003a5b887f37e);
const $21eb2e23e0bf69c0$export$876003a5b887f37e = {
    MODAL_OPENED: 'MODAL_OPENED',
    MODAL_CLOSED: 'MODAL_CLOSED',
    MODAL_KEEP_EDITING_EXISTING_ISSUE: 'MODAL_KEEP_EDITING',
    MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE: 'MODAL_DISCARD',
    MODAL_DISCARD_SUGGESTED_ISSUE: 'MODAL_DISCARD_SUGGESTED_ISSUE',
    MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES: 'MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES',
    MODAL_DISCARD_ALL_SUGGESTED_ISSUES: 'MODAL_DISCARD_ALL_SUGGESTED_ISSUES',
    CREATE_FORM_FIELD_CONFIG_UPDATE: 'CREATE_FORM_FIELD_CONFIG_UPDATE',
    CREATE_FORM_FIELD_VALUE_CHANGE: 'CREATE_FORM_FIELD_VALUE_CHANGE',
    ISSUE_CREATE_SUCCESS: 'ISSUE_CREATE_SUCCESS',
    PROJECT_FIELD_VALUE_CHANGE: 'PROJECT_FIELD_VALUE_CHANGE',
    ISSUE_TYPE_FIELD_VALUE_CHANGE: 'ISSUE_TYPE_FIELD_VALUE_CHANGE',
    RESET_FORM_FIELDS_FOR_CREATE_ANOTHER: 'RESET_FORM_FIELDS_FOR_CREATE_ANOTHER',
    USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE: 'USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE',
    STATUS_FIELD_STATE_CHANGE: 'STATUS_FIELD_STATE_CHANGE',
    CREATE_FORM_FIELD_BLUR: 'CREATE_FORM_FIELD_BLUR',
    CLASSIFICATION_LEVEL_FIELD_CHANGE: 'CLASSIFICATION_LEVEL_FIELD_CHANGE',
    FORM_CONTEXT_STATE_CHANGE: 'FORM_CONTEXT_STATE_CHANGE'
};

});

parcelRegister("2gOs4", function(module, exports) {

$parcel$export(module.exports, "useGICLifeCycleEvents", () => $c9d12900db50c35b$export$e3ff72f196296fcc);

var $jcERi = parcelRequire("jcERi");
const $c9d12900db50c35b$var$GICLifeCycleEventsService = new (0, $jcERi.PubSubHub)();
const $c9d12900db50c35b$export$e3ff72f196296fcc = ()=>({
        ...$c9d12900db50c35b$var$GICLifeCycleEventsService
    });

});
parcelRegister("jcERi", function(module, exports) {

$parcel$export(module.exports, "PubSubHub", () => $a1db2e8ca1046c74$export$e3607828f8f2c01e);
class $a1db2e8ca1046c74$export$e3607828f8f2c01e {
    constructor(){
        this.subscribers = {};
        this.subscribe = (event, subscriber)=>{
            let subs = this.subscribers[event];
            if (!subs) {
                subs = [];
                this.subscribers[event] = subs;
            }
            subs?.push(subscriber);
            return ()=>this.unsubscribe(event, subscriber);
        };
        this.unsubscribe = (event, subscriber)=>{
            const subs = this.subscribers[event];
            if (subs) this.subscribers[event] = subs.filter((subscription)=>subscription !== subscriber);
        };
        this.publish = (event, data)=>{
            const subs = this.subscribers[event];
            if (subs?.length) subs?.forEach((subscriber)=>subscriber(data));
        };
        this.clearAll = ()=>{
            this.subscribers = {};
        };
    }
}

});


parcelRegister("fswni", function(module, exports) {

$parcel$export(module.exports, "useCreateFormState", () => $bba86109863a7c8f$export$64ff4e8b244effca);
$parcel$export(module.exports, "useFormContext", () => $bba86109863a7c8f$export$4d957a5e1be13b03);
$parcel$export(module.exports, "useFormContextInteractedFields", () => $bba86109863a7c8f$export$43c5716796c2329e);
$parcel$export(module.exports, "useIsCollapsedAreaExpanded", () => $bba86109863a7c8f$export$ee8f126c0e25d653);
$parcel$export(module.exports, "useIsSmartFieldsNew", () => $bba86109863a7c8f$export$52b9b0c902b0ae2b);

var $kFGm5 = parcelRequire("kFGm5");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $bba86109863a7c8f$export$d4c72bab9d6cc13a = {
    selectedProject: null,
    selectedIssueType: null,
    requestBackedIssueType: null,
    isEpicLinkSelected: false,
    isSubmitting: false,
    isOperationInProgress: false,
    shouldShowConfigureFieldModal: false,
    shouldShowFindFieldModal: false,
    meta: {
        areRequiredFieldsSupported: true,
        queryErrorMessage: '',
        submitErrorMessage: '',
        submitFieldwiseErrors: {},
        inlineCreateError: null
    },
    shouldShowTempSwitchModal: false,
    dataFetchError: null,
    isFormDirty: false,
    areConfiguredFieldsModified: false,
    timeTrackingValue: '',
    ecosystem: {
        forge: {
            customFields: [],
            filteredOutModules: [],
            issueAdjustmentModules: [],
            hasFinishedLoading: false
        }
    },
    currentActiveTabIndex: 0,
    shouldAutoFocus: true,
    resetFormAction: null,
    isForgeFieldsDetected: false,
    canCreateAnotherIssue: false,
    createdIssues: [],
    watchers: [],
    interactedFields: {},
    expandedCollapsedAreas: [],
    isSmartFieldsNew: undefined,
    isFormLoaded: false
};
const $bba86109863a7c8f$export$e324594224ef24da = {
    restoreState: (state)=>({ setState: setState })=>{
            setState((0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(state, [
                'isSubmitting',
                'isOperationInProgress'
            ]));
        },
    setCurrentActiveTabIndex: (tabIndex)=>({ setState: setState, getState: getState })=>{
            const { currentActiveTabIndex: currentActiveTabIndex } = getState();
            if (tabIndex >= 0 && currentActiveTabIndex !== tabIndex) setState({
                currentActiveTabIndex: tabIndex
            });
        },
    // To enable/disable autofocus of the "create issue" form element - https://a11y.atlassian.net/browse/JCA11Y-318
    setShouldAutoFocus: (shouldAutoFocus)=>({ setState: setState })=>{
            setState({
                shouldAutoFocus: shouldAutoFocus
            });
        },
    setSelectedProject: (project)=>({ setState: setState })=>{
            setState({
                selectedProject: project
            });
        },
    setSelectedIssueType: (issueType)=>({ setState: setState })=>{
            setState({
                selectedIssueType: issueType
            });
        },
    setRequestBackedIssueType: (issueType)=>({ setState: setState })=>{
            setState({
                requestBackedIssueType: issueType
            });
        },
    setIsEpicLinkSelected: (isEpicLinkSelected)=>({ setState: setState })=>{
            setState({
                isEpicLinkSelected: isEpicLinkSelected
            });
        },
    setMeta: (meta)=>({ setState: setState })=>{
            setState({
                meta: meta
            });
        },
    setSubmitErrorMessage: (submitErrorMessage)=>({ setState: setState, getState: getState })=>{
            const { meta: meta } = getState();
            setState({
                meta: {
                    ...meta,
                    submitErrorMessage: submitErrorMessage
                }
            });
        },
    setTimeTrackingValue: (timeTrackingValue)=>({ setState: setState })=>{
            setState({
                timeTrackingValue: timeTrackingValue
            });
        },
    setSubmitFieldwiseErrors: (fieldwiseErrors)=>({ setState: setState, getState: getState })=>{
            const { meta: meta } = getState();
            setState({
                meta: {
                    ...meta,
                    submitFieldwiseErrors: fieldwiseErrors
                }
            });
        },
    setInlineErrorMessage: (inlineCreateError)=>({ setState: setState, getState: getState })=>{
            const { meta: meta } = getState();
            setState({
                meta: {
                    ...meta,
                    inlineCreateError: inlineCreateError
                }
            });
        },
    setSubmitting: (isSubmitting)=>({ setState: setState })=>{
            setState({
                isSubmitting: isSubmitting
            });
        },
    setIsOperationInProgress: (isOperationInProgress)=>({ setState: setState })=>{
            setState({
                isOperationInProgress: isOperationInProgress
            });
        },
    toggleConfigureFieldsModalVisibility: (shouldShowConfigureFieldModal)=>({ setState: setState })=>{
            setState({
                shouldShowConfigureFieldModal: shouldShowConfigureFieldModal
            });
        },
    toggleFindFieldsModalVisibility: (shouldShowFindFieldModal)=>({ setState: setState })=>{
            setState({
                shouldShowFindFieldModal: shouldShowFindFieldModal
            });
        },
    resetFormContext: ()=>({ setState: setState })=>{
            setState({
                ...$bba86109863a7c8f$export$d4c72bab9d6cc13a
            });
        },
    openTempSwitchModal: ()=>({ setState: setState })=>{
            setState({
                shouldShowTempSwitchModal: true
            });
        },
    closeTempSwitchModal: ()=>({ setState: setState })=>{
            setState({
                shouldShowTempSwitchModal: false
            });
        },
    setDataFetchError: (error)=>({ setState: setState })=>{
            setState({
                dataFetchError: error
            });
        },
    setIsFormDirty: (isFormDirty)=>({ setState: setState })=>{
            setState({
                isFormDirty: isFormDirty
            });
        },
    setAreConfiguredFieldsModified: (areConfiguredFieldsModified)=>({ setState: setState })=>{
            setState({
                areConfiguredFieldsModified: areConfiguredFieldsModified
            });
        },
    setForgeModules: (customFields, issueAdjustmentModules, filteredOutModules, hasFinishedLoading)=>({ setState: setState, getState: getState })=>{
            const { ecosystem: ecosystem } = getState();
            setState({
                ecosystem: {
                    ...ecosystem,
                    forge: {
                        customFields: customFields,
                        issueAdjustmentModules: issueAdjustmentModules,
                        hasFinishedLoading: !!hasFinishedLoading,
                        filteredOutModules: filteredOutModules
                    }
                }
            });
        },
    setResetFormAction: (resetFormAction)=>({ setState: setState })=>{
            setState({
                resetFormAction: resetFormAction
            });
        },
    setIsForgeFieldsDetected: (isForgeFieldsDetected)=>({ setState: setState })=>{
            setState({
                isForgeFieldsDetected: isForgeFieldsDetected
            });
        },
    setCanCreateAnotherIssue: (canCreateAnotherIssue)=>({ setState: setState })=>{
            setState({
                canCreateAnotherIssue: canCreateAnotherIssue
            });
        },
    addCreatedIssue: (createdIssue)=>({ getState: getState, setState: setState })=>{
            const { createdIssues: createdIssues } = getState();
            const mergedCreatedIssues = [
                ...createdIssues,
                createdIssue
            ];
            setState({
                createdIssues: mergedCreatedIssues
            });
            return mergedCreatedIssues;
        },
    setWatchers: (watchers)=>({ setState: setState })=>{
            setState({
                watchers: watchers
            });
        },
    setInteractedWithField: (fieldId)=>({ setState: setState, getState: getState })=>{
            const { interactedFields: interactedFields } = getState();
            setState({
                interactedFields: {
                    ...interactedFields,
                    [fieldId]: true
                }
            });
        },
    setExpandedCollapsedArea: (index, shouldExpand)=>({ setState: setState, getState: getState })=>{
            const { expandedCollapsedAreas: expandedCollapsedAreas } = getState();
            const newExpandedCollapsedAreas = expandedCollapsedAreas.slice(0);
            const isCurrentExpanded = expandedCollapsedAreas.includes(index);
            let shouldUpdate = false;
            if (!isCurrentExpanded && shouldExpand) {
                newExpandedCollapsedAreas.push(index);
                shouldUpdate = true;
            }
            if (isCurrentExpanded && !shouldExpand) {
                newExpandedCollapsedAreas.splice(newExpandedCollapsedAreas.indexOf(index), 1);
                shouldUpdate = true;
            }
            if (shouldUpdate) setState({
                expandedCollapsedAreas: newExpandedCollapsedAreas
            });
        },
    resetExpandedCollapsedArea: ()=>({ setState: setState })=>{
            setState({
                expandedCollapsedAreas: []
            });
        },
    setIsSmartFieldsNew: (isSmartFieldsNew)=>({ setState: setState })=>{
            setState({
                isSmartFieldsNew: isSmartFieldsNew
            });
        },
    setIsFormLoaded: (isFormLoaded)=>({ setState: setState })=>{
            setState({
                isFormLoaded: isFormLoaded
            });
        }
};
const $bba86109863a7c8f$var$store = (0, $a61MH.createStore)({
    name: 'issue-create.issue-create-form.form-context',
    initialState: $bba86109863a7c8f$export$d4c72bab9d6cc13a,
    actions: $bba86109863a7c8f$export$e324594224ef24da
});
const $bba86109863a7c8f$export$e6a162613d6e6e63 = (state)=>{
    const { selectedProject: selectedProject, selectedIssueType: selectedIssueType, meta: meta, areConfiguredFieldsModified: areConfiguredFieldsModified, requestBackedIssueType: requestBackedIssueType, isFormDirty: isFormDirty } = state;
    return {
        selectedProject: selectedProject,
        selectedIssueType: selectedIssueType,
        requestBackedIssueType: requestBackedIssueType,
        meta: meta,
        areConfiguredFieldsModified: areConfiguredFieldsModified,
        isFormDirty: isFormDirty
    };
};
const $bba86109863a7c8f$export$64ff4e8b244effca = (0, $ggKAj.createHook)($bba86109863a7c8f$var$store, {
    selector: $bba86109863a7c8f$export$e6a162613d6e6e63
});
const $bba86109863a7c8f$export$4d957a5e1be13b03 = (0, $ggKAj.createHook)($bba86109863a7c8f$var$store);
const $bba86109863a7c8f$export$8b2a836c011f987c = (0, $ggKAj.createActionsHook)($bba86109863a7c8f$var$store);
const $bba86109863a7c8f$var$getInteractedFieldsSelector = (state)=>state.interactedFields;
const $bba86109863a7c8f$export$43c5716796c2329e = (0, $ggKAj.createHook)($bba86109863a7c8f$var$store, {
    selector: $bba86109863a7c8f$var$getInteractedFieldsSelector
});
const $bba86109863a7c8f$var$getIsCollapsedAreaExpandedSelector = (state, index)=>state.expandedCollapsedAreas.includes(index);
const $bba86109863a7c8f$export$ee8f126c0e25d653 = (0, $ggKAj.createHook)($bba86109863a7c8f$var$store, {
    selector: (state, index)=>$bba86109863a7c8f$var$getIsCollapsedAreaExpandedSelector(state, index)
});
const $bba86109863a7c8f$export$52b9b0c902b0ae2b = (0, $ggKAj.createHook)($bba86109863a7c8f$var$store, {
    selector: (state)=>state.isSmartFieldsNew
});

});


parcelRegister("1QpcB", function(module, exports) {

$parcel$export(module.exports, "useIssueRestoreMetaService", () => $d58cb85ab77decb2$export$8f688cfe533ab228);

var $eUqFw = parcelRequire("eUqFw");

var $89bO2 = parcelRequire("89bO2");

const $d58cb85ab77decb2$var$KEY = 'issue-restore-meta';
const $d58cb85ab77decb2$export$8f688cfe533ab228 = ()=>{
    const [storage] = (0, $eUqFw.useState)((0, $89bO2.createSessionStorageProvider)(`${(0, $97b8f59b8f2fa98e$export$8fa5032778cf7801)}`));
    return {
        getIssueRestoreMeta: async ()=>storage.get($d58cb85ab77decb2$var$KEY),
        createIssueRestoreMeta: async (data)=>{
            storage.set($d58cb85ab77decb2$var$KEY, data);
            return data;
        },
        updateIssueRestoreMeta: async (data)=>{
            storage.set($d58cb85ab77decb2$var$KEY, data);
            return data;
        },
        deleteIssueRestoreMeta: async ()=>{
            storage.remove($d58cb85ab77decb2$var$KEY);
        }
    };
};

});
const $97b8f59b8f2fa98e$export$8fa5032778cf7801 = 'jira-issue-create-restore-';


parcelRegister("69PXx", function(module, exports) {

$parcel$export(module.exports, "ImportProjectModal", () => $ea4e9052edb1a70a$export$cd120907470da85);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $gyZoj = parcelRequire("gyZoj");

var $c48h0 = parcelRequire("c48h0");
const $ea4e9052edb1a70a$var$APP_IDENTIFIER = 'jira-business.project-create-import-modal';
const $ea4e9052edb1a70a$export$cd120907470da85 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        teamName: (0, $gyZoj.APP_TEAM_NAME),
        id: "projectCreateImportModal",
        packageName: $ea4e9052edb1a70a$var$APP_IDENTIFIER,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c48h0.ImportModal), props));

});
parcelRegister("gyZoj", function(module, exports) {

$parcel$export(module.exports, "X2C_SERVICE_URL_PREFIX", () => $9e7d75593aa31169$export$e8e1caec1dfda22c);
$parcel$export(module.exports, "APP_IDENTIFIER", () => $9e7d75593aa31169$export$2cea7f14750b8c19);
$parcel$export(module.exports, "APP_TEAM_NAME", () => $9e7d75593aa31169$export$a5a8ee89d936ca29);
$parcel$export(module.exports, "INITIAL_MIGRATION_STATUS", () => $9e7d75593aa31169$export$7198445d3ab0721e);
$parcel$export(module.exports, "FEEDBACK_GROUP_ID", () => $9e7d75593aa31169$export$14b33d63628336c2);
$parcel$export(module.exports, "IMPORT_TYPE_PARAM_KEY", () => $9e7d75593aa31169$export$85c452e39fc36d3d);
$parcel$export(module.exports, "WORKSPACE_ID_PARAM_KEY", () => $9e7d75593aa31169$export$ad63f63c74460d35);
$parcel$export(module.exports, "ENTITY_ID_PARAM_KEY", () => $9e7d75593aa31169$export$a14f08973e10eb93);

var $516Dl = parcelRequire("516Dl");
const $9e7d75593aa31169$export$e8e1caec1dfda22c = '/gateway/api/jira-x2c-service/api/v1';
const $9e7d75593aa31169$export$2cea7f14750b8c19 = 'jira-business.project-create-importer-common';
const $9e7d75593aa31169$export$a5a8ee89d936ca29 = 'jira-warepil';
const $9e7d75593aa31169$export$7198445d3ab0721e = {
    overallProgress: 0.05,
    overallStatus: (0, $516Dl.Status).READY,
    createdIssues: 0,
    totalIssues: 0,
    detailedProgress: {
        dataTransformStatus: (0, $516Dl.Status).READY,
        userImportStatus: (0, $516Dl.Status).READY,
        projectCreateStatus: (0, $516Dl.Status).READY
    }
};
const $9e7d75593aa31169$export$14b33d63628336c2 = 'jwm-feedback-importer';
const $9e7d75593aa31169$export$85c452e39fc36d3d = 'importType';
const $9e7d75593aa31169$export$ad63f63c74460d35 = 'workspaceId';
const $9e7d75593aa31169$export$a14f08973e10eb93 = 'entityId';

});
parcelRegister("516Dl", function(module, exports) {

$parcel$export(module.exports, "Status", () => $24855aa6ce822b00$export$96e9906d6d93a972);
const $24855aa6ce822b00$export$96e9906d6d93a972 = {
    READY: 'READY',
    IN_PROGRESS: 'IN_PROGRESS',
    SUCCESS: 'SUCCESS',
    FAILED: 'FAILED'
};

});


parcelRegister("c48h0", function(module, exports) {

$parcel$export(module.exports, "ImportModal", () => $d6620e08245182e6$export$a33dddbbf5a3ef1);

var $eUqFw = parcelRequire("eUqFw");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $dxopF = parcelRequire("dxopF");

var $kGQen = parcelRequire("kGQen");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $8z1VF = parcelRequire("8z1VF");
const $d6620e08245182e6$var$IMPORT_PROJECT_MODAL = 'projectImportModal';
const $d6620e08245182e6$var$INITIAL_DIMENSIONS = {
    width: 'large',
    height: 'auto'
};
const $d6620e08245182e6$export$a33dddbbf5a3ef1 = ({ isOpen: isOpen, onClose: onClose, project: project })=>{
    const [dimensions, setDimensions] = (0, $eUqFw.useState)($d6620e08245182e6$var$INITIAL_DIMENSIONS);
    const expandModal = (0, $eUqFw.useCallback)(()=>{
        setDimensions({
            height: '100vh',
            width: '100vw'
        });
    }, []);
    const shrinkModal = (0, $eUqFw.useCallback)(()=>{
        setDimensions($d6620e08245182e6$var$INITIAL_DIMENSIONS);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: $d6620e08245182e6$var$IMPORT_PROJECT_MODAL,
        sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        width: dimensions.width,
        height: dimensions.height,
        shouldCloseOnOverlayClick: false,
        onClose: onClose,
        testId: "project-create-import-modal.ui.template-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8z1VF.default), {
        onEnterFullScreenMode: expandModal,
        onExitFullScreenMode: shrinkModal,
        project: project,
        projectType: null,
        onClose: onClose
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null))));
};

});
// SCREENS
const $41ea3621645e2acc$export$f636b5b56f1d624a = 'Screen';
const $41ea3621645e2acc$export$9d2de6eebf7462b5 = 'Drawer';
const $41ea3621645e2acc$export$1171103ea9083ffa = 'Modal';
const $41ea3621645e2acc$export$cae2783c9279926 = 'InlineDialog';
const $41ea3621645e2acc$export$d1123261ca8831d2 = 'Dropdown';
const $41ea3621645e2acc$export$238d30785c4bca84 = 'Banner';
const $41ea3621645e2acc$export$a1562d08625f5d7e = 'UI';
const $41ea3621645e2acc$export$947dac6c72b26f81 = 'TRACK';
const $41ea3621645e2acc$export$f1d537d508d2945a = 'SCREEN';
const $41ea3621645e2acc$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("8z1VF", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f5472ab1d349866$export$2e2bcd8739ae039);

var $aWLVm = parcelRequire("aWLVm");

var $fOTfX = parcelRequire("fOTfX");

var $gyzna = parcelRequire("gyzna");

var $6f5472ab1d349866$export$2e2bcd8739ae039 = (0, $fOTfX.default);

});
parcelRegister("aWLVm", function(module, exports) {

$parcel$export(module.exports, "getNewValidationState", () => $1a35a172a98f6d8e$export$98416add1f189349);
$parcel$export(module.exports, "makeColumnVisible", () => $1a35a172a98f6d8e$export$8f7705e715629319);
$parcel$export(module.exports, "makeColumnHidden", () => $1a35a172a98f6d8e$export$de46879be9cbf16b);
$parcel$export(module.exports, "setFieldIncluded", () => $1a35a172a98f6d8e$export$9d2a89741a7be16e);
$parcel$export(module.exports, "transformMappingStateToFieldMapping", () => $1a35a172a98f6d8e$export$767a800919e3876e);
$parcel$export(module.exports, "transformMappingStateToIssueLinkMapping", () => $1a35a172a98f6d8e$export$6d02b96ee5612bd1);
$parcel$export(module.exports, "transformToDateProperties", () => $1a35a172a98f6d8e$export$73a43130f957c9e9);
$parcel$export(module.exports, "transformToUserEmailMappings", () => $1a35a172a98f6d8e$export$e4c271a0295a7e9c);
$parcel$export(module.exports, "useGetValidationErrorMessage", () => $1a35a172a98f6d8e$export$cc5e0442da068faa);
$parcel$export(module.exports, "hasTableColumnErrors", () => $1a35a172a98f6d8e$export$4f8f67e5eea72468);
$parcel$export(module.exports, "getColumnErrors", () => $1a35a172a98f6d8e$export$59e2a21c1bc37b0e);
$parcel$export(module.exports, "hasMissingFields", () => $1a35a172a98f6d8e$export$ac7f804f3c8a56a9);
$parcel$export(module.exports, "getLocaleOptionForUserLocale", () => $1a35a172a98f6d8e$export$5f4315c210225eaa);
$parcel$export(module.exports, "getTimeZoneOptionForUserTimeZone", () => $1a35a172a98f6d8e$export$c612b59520c555b6);
$parcel$export(module.exports, "getSiteUrl", () => $1a35a172a98f6d8e$export$63fdf20f02fdbaf2);
$parcel$export(module.exports, "getSetOfProductsAvailable", () => $1a35a172a98f6d8e$export$d0ec5cc1449969f8);
$parcel$export(module.exports, "hasOnlyJWMLicense", () => $1a35a172a98f6d8e$export$b39f5b7fae04a41b);
$parcel$export(module.exports, "useIsImportSupportedByLicensedProducts", () => $1a35a172a98f6d8e$export$a00b0a29420ccf0e);
$parcel$export(module.exports, "useHasJSWLicense", () => $1a35a172a98f6d8e$export$8a92b5edbcedeea7);
$parcel$export(module.exports, "useUrlForThirdParty", () => $1a35a172a98f6d8e$export$985b32420af75345);
$parcel$export(module.exports, "redirectToProjectTemplatesScreen", () => $1a35a172a98f6d8e$export$124ee6d5a85ef14f);

var $eUqFw = parcelRequire("eUqFw");

var $6HC1D = parcelRequire("6HC1D");

var $7ZZxN = parcelRequire("7ZZxN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $j3FUN = parcelRequire("j3FUN");

var $kzTj7 = parcelRequire("kzTj7");

var $bGKgW = parcelRequire("bGKgW");

var $dc4s1 = parcelRequire("dc4s1");

var $agB2z = parcelRequire("agB2z");

var $3ak5x = parcelRequire("3ak5x");

var $9R4E5 = parcelRequire("9R4E5");

var $9HsT0 = parcelRequire("9HsT0");

var $l2OLr = parcelRequire("l2OLr");

var $cDLTA = parcelRequire("cDLTA");
const $1a35a172a98f6d8e$var$getDefaultField = (columnName)=>({
        fieldId: null,
        fieldType: (0, $agB2z.TEXT_FIELDTYPE),
        fieldName: columnName
    });
const $1a35a172a98f6d8e$export$98416add1f189349 = (mappingState, columnName, mappedLinkFieldsCount, fieldId)=>{
    const newValidationErrors = mappingState.validationError;
    if (newValidationErrors?.columnErrors?.[columnName]) delete newValidationErrors?.columnErrors?.[columnName];
    if (fieldId && newValidationErrors?.missingFields?.includes(fieldId)) {
        const missingFieldIndex = newValidationErrors?.missingFields.indexOf(fieldId);
        newValidationErrors?.missingFields.splice(missingFieldIndex, 1);
    }
    // Remove issue_id missing error if there are no issue_links mapped anymore.
    if (mappedLinkFieldsCount === 0 && newValidationErrors?.missingFields?.includes((0, $agB2z.ISSUEID_FIELDTYPE))) {
        const missingFieldIndex = newValidationErrors?.missingFields.indexOf((0, $agB2z.ISSUEID_FIELDTYPE));
        newValidationErrors?.missingFields.splice(missingFieldIndex, 1);
    }
    return newValidationErrors;
};
const $1a35a172a98f6d8e$var$getUpdatedVisibleColumnEnsuringUniqueField = (mappingState, columnName)=>{
    const column = mappingState.columns[columnName];
    if (!!column.field?.fieldId && mappingState.mappedJiraFieldIds.has(column.field.fieldId)) return {
        ...column,
        field: $1a35a172a98f6d8e$var$getDefaultField(columnName),
        isVisible: true
    };
    return {
        ...column,
        isVisible: true
    };
};
const $1a35a172a98f6d8e$export$8f7705e715629319 = (mappingState, columnName)=>{
    const updatedColumn = $1a35a172a98f6d8e$var$getUpdatedVisibleColumnEnsuringUniqueField(mappingState, columnName);
    const updatedMappedJiraFieldIds = mappingState.mappedJiraFieldIds;
    if (updatedColumn.field?.fieldId) updatedMappedJiraFieldIds.add(updatedColumn.field.fieldId);
    return (0, $6HC1D.chain)(mappingState).setIn([
        'columns',
        columnName
    ], updatedColumn).setIn([
        'mappedJiraFieldIds'
    ], updatedMappedJiraFieldIds).setIn([
        'validationError'
    ], $1a35a172a98f6d8e$export$98416add1f189349(mappingState, columnName, mappingState.mappedLinkFieldsCount)).value();
};
const $1a35a172a98f6d8e$export$de46879be9cbf16b = (mappingState, columnName)=>{
    const updatedColumn = {
        ...mappingState.columns[columnName],
        isVisible: false
    };
    const updatedMappedJiraFieldIds = mappingState.mappedJiraFieldIds;
    if (updatedColumn.field?.fieldId) updatedMappedJiraFieldIds.delete(updatedColumn.field.fieldId);
    return (0, $6HC1D.chain)(mappingState).setIn([
        'columns',
        columnName
    ], updatedColumn).setIn([
        'mappedJiraFieldIds'
    ], updatedMappedJiraFieldIds).setIn([
        'validationError'
    ], $1a35a172a98f6d8e$export$98416add1f189349(mappingState, columnName, mappingState.mappedLinkFieldsCount)).value();
};
const $1a35a172a98f6d8e$export$9d2a89741a7be16e = (mappingState, columnName, isIncluded)=>{
    const updatedColumn = {
        ...mappingState.columns[columnName],
        isIncluded: isIncluded
    };
    const updatedMappedJiraFieldIds = mappingState.mappedJiraFieldIds;
    let { mappedLinkFieldsCount: mappedLinkFieldsCount } = mappingState;
    if (!isIncluded && updatedColumn.field) {
        updatedColumn.field.fieldId && updatedMappedJiraFieldIds.delete(updatedColumn.field.fieldId);
        if (updatedColumn.field.fieldType === (0, $agB2z.ISSUE_LINKS_FIELDTYPE)) mappedLinkFieldsCount--;
        updatedColumn.field = null;
    }
    return (0, $6HC1D.chain)(mappingState).setIn([
        'columns',
        columnName
    ], updatedColumn).setIn([
        'mappedJiraFieldIds'
    ], updatedMappedJiraFieldIds).setIn([
        'validationError'
    ], $1a35a172a98f6d8e$export$98416add1f189349(mappingState, columnName, mappedLinkFieldsCount)).setIn([
        'mappedLinkFieldsCount'
    ], mappedLinkFieldsCount).setIn([
        'userMapping'
    ], null) // reset userMapping if field is changed
    .value();
};
const $1a35a172a98f6d8e$export$767a800919e3876e = (mappingState)=>mappingState.columnOrder.map((name)=>mappingState.columns[name]).filter((col)=>col.isVisible).filter((col)=>!!col.field && col.field.fieldType !== (0, $agB2z.ISSUE_LINKS_FIELDTYPE)).map(({ columnName: columnName, field: field })=>({
            columnName: columnName,
            field: field
        }));
const $1a35a172a98f6d8e$export$6d02b96ee5612bd1 = (mappingState)=>{
    const issueLinkColumns = [];
    mappingState.columnOrder.map((name)=>mappingState.columns[name]).filter((col)=>col.isVisible).filter((col)=>!!col.field && col.field.fieldType === (0, $agB2z.ISSUE_LINKS_FIELDTYPE)).forEach(({ columnName: columnName, field: field })=>{
        if (field && field.fieldDirection && field.fieldId) issueLinkColumns.push({
            columnName: columnName,
            issueLink: {
                linkName: field.fieldName,
                linkId: field.fieldId,
                linkDirection: field.fieldDirection
            }
        });
    });
    return issueLinkColumns;
};
const $1a35a172a98f6d8e$export$73a43130f957c9e9 = ({ dateFormat: dateFormat, timeZoneOption: timeZoneOption, localeOption: localeOption })=>({
        dateFormat: dateFormat,
        timeZone: timeZoneOption.value,
        locale: localeOption.value
    });
const $1a35a172a98f6d8e$export$e4c271a0295a7e9c = (mappingState)=>mappingState.userMapping ? Object.values(mappingState.userMapping).filter((user)=>!!user.userValue) : [];
const $1a35a172a98f6d8e$export$cc5e0442da068faa = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const getValidationErrorMessage = (errorType, showLink = false)=>{
        switch(errorType){
            case 0, $dc4s1.INVALID_DATE:
                return formatMessage((0, $l2OLr.default).invalidDate);
            case 0, $dc4s1.INVALID_DATETIME:
                return formatMessage((0, $l2OLr.default).invalidDateTime);
            case 0, $dc4s1.INVALID_NUMBER:
                return formatMessage((0, $l2OLr.default).invalidNumber);
            case 0, $dc4s1.INVALID_USER_ID:
                return formatMessage((0, $l2OLr.default).invalidUserId);
            case 0, $dc4s1.INVALID_CASCADE_SELECT_FORMAT:
                return formatMessage((0, $l2OLr.default).invalidCascadingSelectFormat);
            case 0, $dc4s1.INVALID_WORKLOG_FORMAT:
                return showLink ? formatMessage((0, $l2OLr.default).invalidWorkLogFormatWithLink, {
                    link: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                        href: (0, $kzTj7.MAPPING_FIELDS_INFO_LINK),
                        target: "_blank"
                    }, formatMessage((0, $l2OLr.default).invalidWorkLogFormatLinkText))
                }) : formatMessage((0, $l2OLr.default).invalidWorkLogFormatWithoutLink);
            case 0, $dc4s1.INVALID_COMMENT_FORMAT:
                return formatMessage((0, $l2OLr.default).invalidCommentFormat);
            case 0, $dc4s1.EMPTY_SUMMARY:
                return formatMessage((0, $l2OLr.default).emptySummary);
            default:
                return formatMessage((0, $l2OLr.default).genericErrors);
        }
    };
    return {
        getValidationErrorMessage: getValidationErrorMessage
    };
};
const $1a35a172a98f6d8e$export$4f8f67e5eea72468 = (mappingState)=>{
    const columnErrors = mappingState?.validationError?.columnErrors;
    return !!columnErrors && Object.keys(columnErrors).length > 0;
};
const $1a35a172a98f6d8e$export$59e2a21c1bc37b0e = (mappingState)=>{
    const issueLinkingColumnErrors = {};
    const otherColumnErrors = {};
    Object.entries(mappingState?.validationError?.columnErrors || {}).forEach(([name, errorType])=>{
        if (errorType === (0, $dc4s1.INVALID_ISSUE_ID)) issueLinkingColumnErrors[name] = errorType;
        else otherColumnErrors[name] = errorType;
    });
    return {
        issueLinkingColumnErrors: issueLinkingColumnErrors,
        otherColumnErrors: otherColumnErrors
    };
};
const $1a35a172a98f6d8e$export$ac7f804f3c8a56a9 = (mappingState)=>{
    const missingFields = mappingState?.validationError?.missingFields;
    return !!missingFields && missingFields.length > 0;
};
const $1a35a172a98f6d8e$export$ccda1d8d277406fe = (name, customProps)=>(props)=>/*#__PURE__*/ (0, $eUqFw.createElement)(name, {
            ...customProps,
            ...props
        }, props.children);
const $1a35a172a98f6d8e$export$5f4315c210225eaa = (locale)=>(0, $bGKgW.LOCALES).find((option)=>!!locale && locale.startsWith(option.value)) || (0, $9HsT0.DEFAULT_LOCALE);
const $1a35a172a98f6d8e$export$c612b59520c555b6 = (timeZone)=>(0, $bGKgW.TIMEZONES).find((option)=>option.value === timeZone) || (0, $9HsT0.DEFAULT_TIMEZONE);
const $1a35a172a98f6d8e$export$63fdf20f02fdbaf2 = ()=>`https://${window.location.hostname}`;
const $1a35a172a98f6d8e$var$PRODUCTS_INCLUDED_WITH_LICENSE = {
    [(0, $7ZZxN.SOFTWARE_PROJECT)]: [
        (0, $7ZZxN.SOFTWARE_PROJECT),
        (0, $7ZZxN.CORE_PROJECT)
    ],
    [(0, $7ZZxN.SERVICE_DESK_PROJECT)]: [
        (0, $7ZZxN.SERVICE_DESK_PROJECT),
        (0, $7ZZxN.CORE_PROJECT)
    ],
    [(0, $7ZZxN.CORE_PROJECT)]: [
        (0, $7ZZxN.CORE_PROJECT)
    ]
};
const $1a35a172a98f6d8e$export$d0ec5cc1449969f8 = (licensedProducts)=>new Set([
        (0, $7ZZxN.CORE_PROJECT),
        (0, $7ZZxN.SOFTWARE_PROJECT),
        (0, $7ZZxN.SERVICE_DESK_PROJECT)
    ].filter((type)=>licensedProducts[(0, $7ZZxN.projectTypeToCanonicalId)(type)]).flatMap((type)=>$1a35a172a98f6d8e$var$PRODUCTS_INCLUDED_WITH_LICENSE[type]));
const $1a35a172a98f6d8e$export$b39f5b7fae04a41b = (setOfProductsAvailable)=>setOfProductsAvailable.size === 1 && setOfProductsAvailable.has((0, $7ZZxN.CORE_PROJECT));
const $1a35a172a98f6d8e$export$a00b0a29420ccf0e = ()=>{
    const licensedProducts = (0, $j3FUN.useLicensedProducts)();
    return !!(licensedProducts[(0, $7ZZxN.projectTypeToCanonicalId)((0, $7ZZxN.SOFTWARE_PROJECT))] || licensedProducts[(0, $7ZZxN.projectTypeToCanonicalId)((0, $7ZZxN.CORE_PROJECT))] || licensedProducts[(0, $7ZZxN.projectTypeToCanonicalId)((0, $7ZZxN.SERVICE_DESK_PROJECT))]);
};
const $1a35a172a98f6d8e$export$8a92b5edbcedeea7 = ()=>{
    const licensedProducts = (0, $j3FUN.useLicensedProducts)();
    return Boolean(licensedProducts[(0, $7ZZxN.projectTypeToCanonicalId)((0, $7ZZxN.SOFTWARE_PROJECT))]);
};
const $1a35a172a98f6d8e$export$985b32420af75345 = (thirdParty, projectType)=>(0, $eUqFw.useMemo)(()=>{
        switch(thirdParty){
            case 0, $3ak5x.MONDAY:
                return {
                    appDownloadUrl: (0, $kzTj7.MONDAY_IMPORT_APP_DOWNLOAD_URL),
                    reviewScreenDescriptionURL: (0, $kzTj7.MONDAY_LEARN_MORE_ABOUT_PROJECT_SETUP),
                    hierarchyPageDescriptionURL: (0, $kzTj7.LEARN_MORE_ABOUT_PROJECT_HIERARCHY),
                    fieldURL: (0, $kzTj7.MONDAY_LEARN_MORE_ABOUT_FIELDS_MAPPING),
                    customFieldURL: '',
                    generateAPIToken: (0, $kzTj7.LEARN_MORE_ABOUT_GENERATE_MONDAY_API_TOKEN),
                    fieldMappingURL: '',
                    rateLimitURL: '',
                    statusMappingURL: '',
                    thirdPartyEntityDescriptionURL: ''
                };
            case 0, $3ak5x.ASANA:
                return {
                    appDownloadUrl: '',
                    reviewScreenDescriptionURL: (0, $kzTj7.ASANA_LEARN_MORE_ABOUT_PROJECT_SETUP),
                    hierarchyPageDescriptionURL: (0, $kzTj7.LEARN_MORE_ABOUT_ISSUES),
                    fieldURL: (0, $kzTj7.ASANA_LEARN_MORE_ABOUT_FIELDS_MAPPING),
                    customFieldURL: '',
                    generateAPIToken: '',
                    fieldMappingURL: '',
                    rateLimitURL: '',
                    statusMappingURL: '',
                    thirdPartyEntityDescriptionURL: '',
                    ...projectType === (0, $9R4E5.ProjectTypes).SOFTWARE && {
                        reviewScreenDescriptionURL: (0, $kzTj7.ASANA_LEARN_MORE_ABOUT_PROJECT_SETUP_SOFTWARE),
                        hierarchyPageDescriptionURL: (0, $kzTj7.LEARN_MORE_ABOUT_ISSUES_SOFTWARE),
                        fieldURL: (0, $kzTj7.ASANA_LEARN_MORE_ABOUT_FIELDS_MAPPING_SOFTWARE)
                    }
                };
            case 0, $3ak5x.JIRA_SOFTWARE:
                return {
                    appDownloadUrl: '',
                    reviewScreenDescriptionURL: (0, $kzTj7.JIRA_LEARN_MORE_ABOUT_PROJECT_SETUP),
                    hierarchyPageDescriptionURL: '',
                    fieldURL: '',
                    customFieldURL: '',
                    generateAPIToken: '',
                    fieldMappingURL: (0, $kzTj7.JIRA_FIELD_MAPPING),
                    rateLimitURL: '',
                    statusMappingURL: '',
                    thirdPartyEntityDescriptionURL: ''
                };
            case 0, $3ak5x.CLICK_UP:
                return {
                    appDownloadUrl: '',
                    reviewScreenDescriptionURL: (0, $kzTj7.CLICKUP_LEARN_MORE_ABOUT_PROJECT_SETUP),
                    hierarchyPageDescriptionURL: (0, $kzTj7.CLICKUP_LEARN_MORE_ABOUT_PROJECT_HIERARCHY),
                    fieldURL: (0, $kzTj7.CLICKUP_LEARN_MORE_ABOUT_FIELDS_MAPPING),
                    customFieldURL: '',
                    generateAPIToken: '',
                    fieldMappingURL: (0, $kzTj7.CLICKUP_LEARN_MORE_ABOUT_FIELDS_MAPPING),
                    statusMappingURL: (0, $kzTj7.CLICKUP_LEARN_MORE_ABOUT_STATUS_MAPPING),
                    rateLimitURL: (0, $kzTj7.CLICK_UP_RATE_LIMIT),
                    thirdPartyEntityDescriptionURL: ''
                };
            case 0, $3ak5x.JIRA_BUSINESS:
                return {
                    appDownloadUrl: '',
                    reviewScreenDescriptionURL: (0, $kzTj7.JIRA_BUSINESS_LEARN_MORE_ABOUT_PROJECT_MAPPING),
                    hierarchyPageDescriptionURL: '',
                    fieldURL: '',
                    customFieldURL: '',
                    generateAPIToken: '',
                    fieldMappingURL: (0, $kzTj7.JIRA_BUSINESS_LEARN_MORE_ABOUT_UNSUPPORTED_FIELDS),
                    rateLimitURL: '',
                    statusMappingURL: '',
                    thirdPartyEntityDescriptionURL: (0, $kzTj7.JIRA_BUSINESS_LEARN_MORE_ABOUT_IMPORTING)
                };
            default:
                return {
                    appDownloadUrl: '',
                    reviewScreenDescriptionURL: '',
                    hierarchyPageDescriptionURL: '',
                    fieldURL: '',
                    customFieldURL: '',
                    generateAPIToken: '',
                    fieldMappingURL: '',
                    rateLimitURL: '',
                    statusMappingURL: '',
                    thirdPartyEntityDescriptionURL: ''
                };
        }
    }, [
        projectType,
        thirdParty
    ]);
const $1a35a172a98f6d8e$export$124ee6d5a85ef14f = ()=>{
    window.location.href = (0, $kzTj7.DEFAULT_PROJECT_CREATE_ROUTE);
};

});
parcelRegister("j3FUN", function(module, exports) {

$parcel$export(module.exports, "useLicensedProducts", () => $02df0e5ac33ae573$export$54d534cc91e54850);

var $gd0Sp = parcelRequire("gd0Sp");
const $02df0e5ac33ae573$export$54d534cc91e54850 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.licensedProducts || {};
};

});

parcelRegister("kzTj7", function(module, exports) {

$parcel$export(module.exports, "APP_IDENTIFIER", () => $2394e882be26852c$export$2cea7f14750b8c19);
$parcel$export(module.exports, "CSV_FILE_UPLOAD_TYPE", () => $2394e882be26852c$export$9fd42c7164bba564);
$parcel$export(module.exports, "CSV_MAX_SIZE_BYTES", () => $2394e882be26852c$export$d437537f8bec93b2);
$parcel$export(module.exports, "IMPORT_URL_SUFFIX", () => $2394e882be26852c$export$52a0148d615c09dd);
$parcel$export(module.exports, "NEW_EXTERNAL_IMPORT_URL", () => $2394e882be26852c$export$1c44704e731052b3);
$parcel$export(module.exports, "PROJECT_ROUTE_PREFIX", () => $2394e882be26852c$export$68f1df3f2cd060d9);
$parcel$export(module.exports, "DEFAULT_PROJECT_CREATE_ROUTE", () => $2394e882be26852c$export$ea2334d6312d4c85);
$parcel$export(module.exports, "MONDAY_IMPORT_APP_DOWNLOAD_URL", () => $2394e882be26852c$export$34c97b84e98a4f22);
$parcel$export(module.exports, "LEARN_MORE_LINK", () => $2394e882be26852c$export$997e23a0aec74966);
$parcel$export(module.exports, "LEARN_MORE_LINK_JSW", () => $2394e882be26852c$export$9c2f78830e9782e0);
$parcel$export(module.exports, "CSV_MAPPING_SUPPORT_LINK", () => $2394e882be26852c$export$433c571c67930c88);
$parcel$export(module.exports, "SIMPLE_DATE_FORMAT_LINK", () => $2394e882be26852c$export$e2c6a235e9aacc05);
$parcel$export(module.exports, "LEARN_MORE_ABOUT_OTHER_TOOLS_LINK", () => $2394e882be26852c$export$6d6f5d7a36b86516);
$parcel$export(module.exports, "ASANA_LEARN_MORE_ABOUT_PROJECT_SETUP", () => $2394e882be26852c$export$4f38767e82772757);
$parcel$export(module.exports, "ASANA_LEARN_MORE_ABOUT_PROJECT_SETUP_SOFTWARE", () => $2394e882be26852c$export$15dd6fa8f7d833e7);
$parcel$export(module.exports, "ASANA_LEARN_MORE_ABOUT_FIELDS_MAPPING", () => $2394e882be26852c$export$6c9fd72e9728dc1d);
$parcel$export(module.exports, "ASANA_LEARN_MORE_ABOUT_FIELDS_MAPPING_SOFTWARE", () => $2394e882be26852c$export$440d69703e922f96);
$parcel$export(module.exports, "LEARN_MORE_ABOUT_TIMELINE", () => $2394e882be26852c$export$81fa1ecb5cc10484);
$parcel$export(module.exports, "LEARN_MORE_ABOUT_ISSUES", () => $2394e882be26852c$export$62da72d3b2b24919);
$parcel$export(module.exports, "LEARN_MORE_ABOUT_ISSUES_SOFTWARE", () => $2394e882be26852c$export$bb8b6131f0e3b150);
$parcel$export(module.exports, "MONDAY_LEARN_MORE_ABOUT_PROJECT_SETUP", () => $2394e882be26852c$export$aeb0a92522c330eb);
$parcel$export(module.exports, "MONDAY_LEARN_MORE_ABOUT_FIELDS_MAPPING", () => $2394e882be26852c$export$24abe49d33718441);
$parcel$export(module.exports, "LEARN_MORE_ABOUT_PROJECT_HIERARCHY", () => $2394e882be26852c$export$d0736a9038fca7f);
$parcel$export(module.exports, "LEARN_MORE_ABOUT_GENERATE_MONDAY_API_TOKEN", () => $2394e882be26852c$export$a77b3a14490bdf91);
$parcel$export(module.exports, "JIRA_LEARN_MORE_ABOUT_PROJECT_SETUP", () => $2394e882be26852c$export$9c21a9d673fefbc7);
$parcel$export(module.exports, "JIRA_FIELD_MAPPING", () => $2394e882be26852c$export$745f88cfee601ac6);
$parcel$export(module.exports, "JIRA_BUSINESS_LEARN_MORE_ABOUT_IMPORTING", () => $2394e882be26852c$export$e2ecf81a2606aedb);
$parcel$export(module.exports, "JIRA_BUSINESS_LEARN_MORE_ABOUT_PROJECT_MAPPING", () => $2394e882be26852c$export$b48765605589f7b3);
$parcel$export(module.exports, "JIRA_BUSINESS_LEARN_MORE_ABOUT_UNSUPPORTED_FIELDS", () => $2394e882be26852c$export$2a57cce5263500e9);
$parcel$export(module.exports, "CLICKUP_LEARN_MORE_ABOUT_PROJECT_SETUP", () => $2394e882be26852c$export$dd1818dcfe685e6d);
$parcel$export(module.exports, "CLICKUP_LEARN_MORE_ABOUT_FIELDS_MAPPING", () => $2394e882be26852c$export$697d174780c4a0db);
$parcel$export(module.exports, "CLICKUP_LEARN_MORE_ABOUT_PROJECT_HIERARCHY", () => $2394e882be26852c$export$6c1173c70291706d);
$parcel$export(module.exports, "CLICK_UP_RATE_LIMIT", () => $2394e882be26852c$export$7da7bb988232000d);
$parcel$export(module.exports, "CLICKUP_MULTI_LIST_INFO", () => $2394e882be26852c$export$155ad86cb8957445);
$parcel$export(module.exports, "CLICKUP_LEARN_MORE_ABOUT_STATUS_MAPPING", () => $2394e882be26852c$export$1b321d028382fa58);
$parcel$export(module.exports, "CONTACT_ADMIN_LINK", () => $2394e882be26852c$export$1a04dfea900412a8);
$parcel$export(module.exports, "REQUEST_OTHER_TOOLS", () => $2394e882be26852c$export$af150fcdcf3df449);
$parcel$export(module.exports, "CHANGE_TEMPLATE_MODAL", () => $2394e882be26852c$export$9619e281f4a934db);
$parcel$export(module.exports, "DEBOUNCE_DELAY", () => $2394e882be26852c$export$1ec3328eed0aedd9);
$parcel$export(module.exports, "PROJECT_CREATE_IMPORTER_SEEN_IT_FLAG", () => $2394e882be26852c$export$9fd0948d1cce7fa1);
$parcel$export(module.exports, "CONTACT_SUPPORT_URL", () => $2394e882be26852c$export$2c16bd1d8b68b11f);
$parcel$export(module.exports, "TROUBLESHOOT_PAGE_URL", () => $2394e882be26852c$export$508fd8f98a4914c);
$parcel$export(module.exports, "TROUBLESHOOT_PAGE_URL_SOFTWARE", () => $2394e882be26852c$export$2597fd0ae3605fad);
$parcel$export(module.exports, "JIRA_WAC_LINK", () => $2394e882be26852c$export$fa2aa9c8759c7467);
$parcel$export(module.exports, "JSM_WAC_LINK", () => $2394e882be26852c$export$2967141a045d78ba);
$parcel$export(module.exports, "MAPPING_FIELDS_INFO_LINK", () => $2394e882be26852c$export$36f138122c6639c1);
$parcel$export(module.exports, "COLUMN_HEADER_TEST_ID_PREFIX", () => $2394e882be26852c$export$e9442c85e51d9a04);
$parcel$export(module.exports, "SEARCH_TEXTFIELD_TEST_ID", () => $2394e882be26852c$export$71f9f3d0bffa418);
$parcel$export(module.exports, "FIELDS_DROPDOWN_TEST_ID_PREFIX", () => $2394e882be26852c$export$c078abb14a1c95b7);
$parcel$export(module.exports, "OTHER_TOOLS_REQUEST_MODAL_TEST_ID", () => $2394e882be26852c$export$cb50e342656160dd);
$parcel$export(module.exports, "OTHER_TOOLS_REQUEST_MODAL_CLOSE_ICON_TEST_ID", () => $2394e882be26852c$export$8af4234f0adb0304);
$parcel$export(module.exports, "PRE_OAUTH_MODAL_TEST_ID", () => $2394e882be26852c$export$8f17426dcd99c0c3);
$parcel$export(module.exports, "FILE_ENCODING_DROPDOWN_TESTID_PREFIX", () => $2394e882be26852c$export$bf131127a2c2e8ab);
$parcel$export(module.exports, "THIRD_PARTY_FIELD_SELECTOR_TEST_ID_PREFIX", () => $2394e882be26852c$export$5a631c669d544a1d);
$parcel$export(module.exports, "THIRD_PARTY_HIERARCHY_SELECTOR_TEST_ID_PREFIX", () => $2394e882be26852c$export$e586b47b2626e794);
$parcel$export(module.exports, "REVIEW_SCREEN_CARD_TEST_ID", () => $2394e882be26852c$export$eeb33748f1d0430c);
$parcel$export(module.exports, "ATLASKIT_PORTAL_CLASSNAME", () => $2394e882be26852c$export$f050ccc41c479cea);
$parcel$export(module.exports, "PROJECT_TYPE_DROPDOWN_ID", () => $2394e882be26852c$export$69d11a14afb0fa7d);
$parcel$export(module.exports, "PROJECT_MANAGEMENT_TYPE_DROPDOWN_ID", () => $2394e882be26852c$export$5fac970d8fbf4964);
$parcel$export(module.exports, "PROJECT_TEMPLATE_DROPDOWN_ID", () => $2394e882be26852c$export$2b0f97dec349e6b8);
$parcel$export(module.exports, "ESCAPE_WHITELIST_TESTIDS", () => $2394e882be26852c$export$8f8bfd904a400546);
$parcel$export(module.exports, "ESCAPE_WHITELIST_IDS", () => $2394e882be26852c$export$20325841bf6254df);
$parcel$export(module.exports, "MAPPING_FIELD_UPDATE_SUCCESS_FLAG_ID", () => $2394e882be26852c$export$696bfade2d3d7d2a);
$parcel$export(module.exports, "MAPPING_HIERARCHY_UPDATE_SUCCESS_FLAG_ID", () => $2394e882be26852c$export$a23117c7ba528a58);
$parcel$export(module.exports, "MAPPING_STATUS_UPDATE_SUCCESS_FLAG_ID", () => $2394e882be26852c$export$ddfded65fc7422d9);
$parcel$export(module.exports, "OAUTH_UNSUCCESS_FLAG_ID", () => $2394e882be26852c$export$db26aa6519236891);
$parcel$export(module.exports, "DEFAULT_ITEM_TYPE", () => $2394e882be26852c$export$a0e31fb0e953ef51);
$parcel$export(module.exports, "DEFAULT_SUBITEM_TYPE", () => $2394e882be26852c$export$d6eb6f3eb7b0c9c1);
$parcel$export(module.exports, "CLICKUP_MAX_LISTS", () => $2394e882be26852c$export$bbd6b3221bbad4cc);
$parcel$export(module.exports, "DEFAULT_TABLE_ROWS_PER_PAGE", () => $2394e882be26852c$export$8c906b52f822b29b);
$parcel$export(module.exports, "STRUCTURE_CSV_LINK", () => $2394e882be26852c$export$371d7e26acef6c8e);
$parcel$export(module.exports, "MAPPING_GUIDE_SOFTWARE", () => $2394e882be26852c$export$ac7096f9ea680b96);
$parcel$export(module.exports, "MAPPING_GUIDE_BUSINESS", () => $2394e882be26852c$export$15ed8e1e15eb7080);
$parcel$export(module.exports, "WHAT_IS_AN_ISSUE_LINK", () => $2394e882be26852c$export$553708bc05532eb5);
const $2394e882be26852c$export$2cea7f14750b8c19 = 'jira-business.project-create-importer-upload-flow';
const $2394e882be26852c$export$9fd42c7164bba564 = 'text/csv';
const $2394e882be26852c$export$d437537f8bec93b2 = 500000000; // 500Mb
const $2394e882be26852c$export$52a0148d615c09dd = '/secure/admin/ExternalImport1.jspa';
const $2394e882be26852c$export$1c44704e731052b3 = '/jira/settings/system/external-import';
const $2394e882be26852c$export$68f1df3f2cd060d9 = '/browse';
const $2394e882be26852c$export$ea2334d6312d4c85 = '/jira/create-project';
const $2394e882be26852c$export$34c97b84e98a4f22 = 'https://auth.monday.com/oauth2/authorize?client_id=64f3709a529f71593977b890275a2c07&response_type=install';
const $2394e882be26852c$export$997e23a0aec74966 = 'https://support.atlassian.com/jira-work-management/docs/import-data-into-jira-work-management-using-a-csv-file/';
const $2394e882be26852c$export$9c2f78830e9782e0 = 'https://support.atlassian.com/jira-software-cloud/docs/import-data-to-a-software-project-using-a-csv-file/';
const $2394e882be26852c$export$433c571c67930c88 = 'https://support.atlassian.com/jira-work-management/docs/map-data-from-a-csv-file/';
const $2394e882be26852c$export$e2c6a235e9aacc05 = 'https://docs.oracle.com/javase/1.5.0/docs/api/java/text/SimpleDateFormat.html';
const $2394e882be26852c$export$6d6f5d7a36b86516 = 'https://support.atlassian.com/jira-work-management/docs/import-data-from-other-tools-into-jira-work-management/';
const $2394e882be26852c$export$4f38767e82772757 = 'https://support.atlassian.com/jira-work-management/docs/import-data-directly-from-asana-into-jira-work-management/#Structure-of-your-Asana-project-in-Jira-Work-Management';
const $2394e882be26852c$export$15dd6fa8f7d833e7 = 'https://support.atlassian.com/jira-software-cloud/docs/import-data-directly-from-asana-into-jira/';
const $2394e882be26852c$export$6c9fd72e9728dc1d = 'https://support.atlassian.com/jira-work-management/docs/import-data-directly-from-asana-into-jira-work-management/';
const $2394e882be26852c$export$440d69703e922f96 = 'https://support.atlassian.com/jira-software-cloud/docs/import-data-directly-from-asana-into-jira/';
const $2394e882be26852c$export$81fa1ecb5cc10484 = 'https://support.atlassian.com/jira-work-management/docs/what-is-the-timeline-view-and-how-do-i-use-it/';
const $2394e882be26852c$export$62da72d3b2b24919 = 'https://support.atlassian.com/jira-work-management/docs/create-and-work-with-issues/';
const $2394e882be26852c$export$bb8b6131f0e3b150 = 'https://support.atlassian.com/jira-software-cloud/docs/import-data-directly-from-asana-into-jira/';
const $2394e882be26852c$export$aeb0a92522c330eb = 'https://support.atlassian.com/jira-work-management/docs/import-data-directly-from-monday-into-jira-work-management/';
const $2394e882be26852c$export$24abe49d33718441 = 'https://support.atlassian.com/jira-work-management/docs/import-data-directly-from-monday-into-jira-work-management/';
const $2394e882be26852c$export$d0736a9038fca7f = 'https://support.atlassian.com/jira-work-management/docs/create-and-work-with-issues/';
const $2394e882be26852c$export$a77b3a14490bdf91 = 'https://developer.monday.com/api-reference/docs/authentication#admin-tab';
const $2394e882be26852c$export$9c21a9d673fefbc7 = 'https://support.atlassian.com/jira-work-management/docs/import-data-from-jira-software-to-jira-work-management/';
const $2394e882be26852c$export$745f88cfee601ac6 = 'https://support.atlassian.com/jira-work-management/docs/import-data-from-jira-software-to-jira-work-management/';
const $2394e882be26852c$export$e2ecf81a2606aedb = 'https://support.atlassian.com/jira-work-management/docs/import-data-from-a-business-project-to-a-software-project/';
const $2394e882be26852c$export$b48765605589f7b3 = 'https://support.atlassian.com/jira-work-management/docs/import-data-from-a-business-project-to-a-software-project/#Edit-fields';
const $2394e882be26852c$export$2a57cce5263500e9 = 'https://support.atlassian.com/jira-work-management/docs/import-data-from-a-business-project-to-a-software-project/#Unsupported-business-project-field-types';
const $2394e882be26852c$export$dd1818dcfe685e6d = 'https://support.atlassian.com/jira-work-management/docs/import-data-directly-from-clickup-into-jira-work-management/';
const $2394e882be26852c$export$697d174780c4a0db = 'https://support.atlassian.com/jira-work-management/docs/import-data-directly-from-clickup-into-jira-work-management/';
const $2394e882be26852c$export$6c1173c70291706d = 'https://support.atlassian.com/jira-work-management/docs/create-and-work-with-issues/';
const $2394e882be26852c$export$7da7bb988232000d = 'https://support.atlassian.com/jira-work-management/docs/import-data-directly-from-clickup-into-jira-work-management/';
const $2394e882be26852c$export$155ad86cb8957445 = 'https://support.atlassian.com/jira-work-management/docs/import-data-directly-from-clickup-into-jira-work-management/#ClickUp-import-times-and-rate-limit';
const $2394e882be26852c$export$1b321d028382fa58 = 'https://support.atlassian.com/jira-work-management/docs/import-data-directly-from-clickup-into-jira-work-management/#Customize-your-statuses';
const $2394e882be26852c$export$1a04dfea900412a8 = '/secure/ContactAdministrators!default.jspa';
const $2394e882be26852c$export$6f1e5632722db6a2 = 'unavailable_tools';
const $2394e882be26852c$export$af150fcdcf3df449 = 'request_other_tools';
const $2394e882be26852c$export$9619e281f4a934db = 'change_template_modal';
const $2394e882be26852c$export$1ec3328eed0aedd9 = 500;
const $2394e882be26852c$export$9fd0948d1cce7fa1 = 'jwm.project-create-importer';
const $2394e882be26852c$export$2c16bd1d8b68b11f = 'https://support.atlassian.com/contact/#/?inquiry_category=technical_issues&is_cloud=true&product_key=jira-work-management&support_type=customer';
const $2394e882be26852c$export$508fd8f98a4914c = 'https://support.atlassian.com/jira-work-management/docs/fix-errors-in-a-business-project-import/';
const $2394e882be26852c$export$2597fd0ae3605fad = 'https://support.atlassian.com/jira-software-cloud/docs/fix-errors-in-a-project-import/';
const $2394e882be26852c$export$fa2aa9c8759c7467 = 'https://www.atlassian.com/software/jira';
const $2394e882be26852c$export$2967141a045d78ba = 'https://www.atlassian.com/software/jira/service-management';
const $2394e882be26852c$export$36f138122c6639c1 = 'https://support.atlassian.com/jira-work-management/docs/map-data-from-a-csv-file/';
const $2394e882be26852c$export$e9442c85e51d9a04 = 'project-create-importer-upload-flow.ui.mapping-screen.mapping-table.column-header';
const $2394e882be26852c$export$71f9f3d0bffa418 = 'project-create-importer-upload-flow.common.ui.search-bar.textfield';
const $2394e882be26852c$export$c078abb14a1c95b7 = 'project-create-importer-upload-flow.ui.mapping-screen.fields-dropdown';
const $2394e882be26852c$export$cb50e342656160dd = 'project-create-importer-upload-flow.ui.upload-screen.import-from-other-tools.other-tools-request-modal.modal';
const $2394e882be26852c$export$8af4234f0adb0304 = 'project-create-importer-upload-flow.ui.upload-screen.import-from-other-tools.other-tools-request-modal.close-icon';
const $2394e882be26852c$export$8f17426dcd99c0c3 = 'project-create-importer-upload-flow.ui.upload-screen.import-from-other-tools.pre-oauth-modal';
const $2394e882be26852c$export$bf131127a2c2e8ab = 'project-create-importer-upload-flow.ui.upload-screen.upload-csv-dropzone.upload-advanced-options.file-encoding-dropdown';
const $2394e882be26852c$export$5a631c669d544a1d = 'project-create-importer-upload-flow.ui.third-party-review-screen.fields-mapping.fields-mapping-content.field-selector';
const $2394e882be26852c$export$e586b47b2626e794 = 'project-create-importer-upload-flow.ui.third-party-review-screen.project-hierarchy.item-selector';
const $2394e882be26852c$export$eeb33748f1d0430c = 'project-create-importer-upload-flow.ui.third-party-review-screen.review-tiles.card.wrapper';
const $2394e882be26852c$export$459ce9a448082790 = 'react-select';
const $2394e882be26852c$export$f050ccc41c479cea = 'atlaskit-portal';
const $2394e882be26852c$export$2f14e633c2181ea7 = 'entityDropdown';
const $2394e882be26852c$export$69d11a14afb0fa7d = 'DropdownProjectType';
const $2394e882be26852c$export$5fac970d8fbf4964 = 'DropdownProjectManagementType';
const $2394e882be26852c$export$2b0f97dec349e6b8 = 'DropdownProjectTemplate';
const $2394e882be26852c$export$8f8bfd904a400546 = [
    $2394e882be26852c$export$e9442c85e51d9a04,
    $2394e882be26852c$export$c078abb14a1c95b7,
    $2394e882be26852c$export$cb50e342656160dd,
    $2394e882be26852c$export$8f17426dcd99c0c3,
    $2394e882be26852c$export$bf131127a2c2e8ab,
    $2394e882be26852c$export$71f9f3d0bffa418,
    $2394e882be26852c$export$5a631c669d544a1d,
    $2394e882be26852c$export$e586b47b2626e794
];
const $2394e882be26852c$export$20325841bf6254df = [
    $2394e882be26852c$export$459ce9a448082790,
    $2394e882be26852c$export$2f14e633c2181ea7,
    $2394e882be26852c$export$69d11a14afb0fa7d,
    $2394e882be26852c$export$5fac970d8fbf4964,
    $2394e882be26852c$export$2b0f97dec349e6b8
];
const $2394e882be26852c$export$696bfade2d3d7d2a = 'mapping-field-update-success-flag';
const $2394e882be26852c$export$a23117c7ba528a58 = 'mapping-hierarchy-update-success-flag';
const $2394e882be26852c$export$ddfded65fc7422d9 = 'mapping-status-update-success-flag';
const $2394e882be26852c$export$db26aa6519236891 = 'import-3p-oauth-unsuccess-flag';
const $2394e882be26852c$export$a0e31fb0e953ef51 = 'ITEM';
const $2394e882be26852c$export$d6eb6f3eb7b0c9c1 = 'SUBITEM';
const $2394e882be26852c$export$bbd6b3221bbad4cc = 10;
const $2394e882be26852c$export$8c906b52f822b29b = 8;
const $2394e882be26852c$export$371d7e26acef6c8e = 'https://support.atlassian.com/jira-software-cloud/docs/prepare-a-csv-file-for-import/';
const $2394e882be26852c$export$ac7096f9ea680b96 = 'https://support.atlassian.com/jira-software-cloud/docs/mapping-csv-data-to-jira-fields/';
const $2394e882be26852c$export$15ed8e1e15eb7080 = 'https://support.atlassian.com/jira-work-management/docs/map-data-from-a-csv-file/';
const $2394e882be26852c$export$553708bc05532eb5 = 'https://support.atlassian.com/jira-software-cloud/docs/what-is-an-issue/';

});

parcelRegister("bGKgW", function(module, exports) {

$parcel$export(module.exports, "LOCALES", () => $d9ac3bfb6a847a6a$export$e49c1078bc46f17);
$parcel$export(module.exports, "TIMEZONES", () => $d9ac3bfb6a847a6a$export$a1293b6f12329fc4);
const $d9ac3bfb6a847a6a$export$e49c1078bc46f17 = [
    {
        label: 'English (US)',
        value: 'en_US'
    },
    {
        label: 'English (UK)',
        value: 'en_GB'
    },
    {
        label: "\u4E2D\u6587 (\u7B80\u4F53)",
        value: 'zh_CN'
    },
    {
        label: "\u4E2D\u6587 (\u7E41\u9AD4)",
        value: 'zh_TW'
    },
    {
        label: "\u010Ce\u0161tina",
        value: 'cs'
    },
    {
        label: 'Dansk',
        value: 'da'
    },
    {
        label: 'Nederlands',
        value: 'nl'
    },
    {
        label: 'Eesti',
        value: 'et'
    },
    {
        label: 'Suomi',
        value: 'fi'
    },
    {
        label: "Fran\xe7ais",
        value: 'fr'
    },
    {
        label: 'Deutsch',
        value: 'de'
    },
    {
        label: 'Magyar',
        value: 'hu'
    },
    {
        label: "\xcdslenska",
        value: 'is'
    },
    {
        label: 'Italiano',
        value: 'it'
    },
    {
        label: "\u65E5\u672C\u8A9E",
        value: 'ja'
    },
    {
        label: "\uD55C\uAD6D\uC5B4",
        value: 'ko'
    },
    {
        label: 'Norsk',
        value: 'nb'
    },
    {
        label: 'Polski',
        value: 'pl'
    },
    {
        label: "Portugu\xeas (Brasil)",
        value: 'pt_BR'
    },
    {
        label: "Portugu\xeas (Portugal)",
        value: 'pt_PT'
    },
    {
        label: "Rom\xe2n\u0103",
        value: 'ro'
    },
    {
        label: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439",
        value: 'ru'
    },
    {
        label: "Sloven\u010Dina",
        value: 'sk'
    },
    {
        label: "\u0E20\u0E32\u0E29\u0E32\u0E44\u0E17\u0E22\u200E",
        value: 'th'
    },
    {
        label: "T\xfcrk\xe7e",
        value: 'tr'
    },
    {
        label: "Espa\xf1ol",
        value: 'es'
    },
    {
        label: "\u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430",
        value: 'uk'
    },
    {
        label: "Ti\u1EBFng Vi\u1EC7t",
        value: 'vi'
    },
    {
        label: 'Svenska',
        value: 'sv'
    }
];
const $d9ac3bfb6a847a6a$export$a1293b6f12329fc4 = [
    {
        label: 'Etc/GMT+12 (UTC-12:00)',
        value: 'Etc/GMT+12'
    },
    {
        label: 'Pacific/Pago_Pago (UTC-11:00)',
        value: 'Pacific/Pago_Pago'
    },
    {
        label: 'Pacific/Samoa (UTC-11:00)',
        value: 'Pacific/Samoa'
    },
    {
        label: 'Pacific/Niue (UTC-11:00)',
        value: 'Pacific/Niue'
    },
    {
        label: 'US/Samoa (UTC-11:00)',
        value: 'US/Samoa'
    },
    {
        label: 'Etc/GMT+11 (UTC-11:00)',
        value: 'Etc/GMT+11'
    },
    {
        label: 'Pacific/Midway (UTC-11:00)',
        value: 'Pacific/Midway'
    },
    {
        label: 'Pacific/Honolulu (UTC-10:00)',
        value: 'Pacific/Honolulu'
    },
    {
        label: 'Pacific/Rarotonga (UTC-10:00)',
        value: 'Pacific/Rarotonga'
    },
    {
        label: 'Pacific/Tahiti (UTC-10:00)',
        value: 'Pacific/Tahiti'
    },
    {
        label: 'Pacific/Johnston (UTC-10:00)',
        value: 'Pacific/Johnston'
    },
    {
        label: 'US/Hawaii (UTC-10:00)',
        value: 'US/Hawaii'
    },
    {
        label: 'SystemV/HST10 (UTC-10:00)',
        value: 'SystemV/HST10'
    },
    {
        label: 'Etc/GMT+10 (UTC-10:00)',
        value: 'Etc/GMT+10'
    },
    {
        label: 'Pacific/Marquesas (UTC-09:30)',
        value: 'Pacific/Marquesas'
    },
    {
        label: 'Etc/GMT+9 (UTC-09:00)',
        value: 'Etc/GMT+9'
    },
    {
        label: 'Pacific/Gambier (UTC-09:00)',
        value: 'Pacific/Gambier'
    },
    {
        label: 'America/Atka (UTC-09:00)',
        value: 'America/Atka'
    },
    {
        label: 'SystemV/YST9 (UTC-09:00)',
        value: 'SystemV/YST9'
    },
    {
        label: 'America/Adak (UTC-09:00)',
        value: 'America/Adak'
    },
    {
        label: 'US/Aleutian (UTC-09:00)',
        value: 'US/Aleutian'
    },
    {
        label: 'Etc/GMT+8 (UTC-08:00)',
        value: 'Etc/GMT+8'
    },
    {
        label: 'US/Alaska (UTC-08:00)',
        value: 'US/Alaska'
    },
    {
        label: 'America/Juneau (UTC-08:00)',
        value: 'America/Juneau'
    },
    {
        label: 'America/Metlakatla (UTC-08:00)',
        value: 'America/Metlakatla'
    },
    {
        label: 'America/Yakutat (UTC-08:00)',
        value: 'America/Yakutat'
    },
    {
        label: 'Pacific/Pitcairn (UTC-08:00)',
        value: 'Pacific/Pitcairn'
    },
    {
        label: 'America/Sitka (UTC-08:00)',
        value: 'America/Sitka'
    },
    {
        label: 'America/Anchorage (UTC-08:00)',
        value: 'America/Anchorage'
    },
    {
        label: 'SystemV/PST8 (UTC-08:00)',
        value: 'SystemV/PST8'
    },
    {
        label: 'America/Nome (UTC-08:00)',
        value: 'America/Nome'
    },
    {
        label: 'SystemV/YST9YDT (UTC-08:00)',
        value: 'SystemV/YST9YDT'
    },
    {
        label: 'Canada/Yukon (UTC-07:00)',
        value: 'Canada/Yukon'
    },
    {
        label: 'US/Pacific-New (UTC-07:00)',
        value: 'US/Pacific-New'
    },
    {
        label: 'Etc/GMT+7 (UTC-07:00)',
        value: 'Etc/GMT+7'
    },
    {
        label: 'US/Arizona (UTC-07:00)',
        value: 'US/Arizona'
    },
    {
        label: 'America/Dawson_Creek (UTC-07:00)',
        value: 'America/Dawson_Creek'
    },
    {
        label: 'Canada/Pacific (UTC-07:00)',
        value: 'Canada/Pacific'
    },
    {
        label: 'PST8PDT (UTC-07:00)',
        value: 'PST8PDT'
    },
    {
        label: 'SystemV/MST7 (UTC-07:00)',
        value: 'SystemV/MST7'
    },
    {
        label: 'America/Dawson (UTC-07:00)',
        value: 'America/Dawson'
    },
    {
        label: 'Mexico/BajaNorte (UTC-07:00)',
        value: 'Mexico/BajaNorte'
    },
    {
        label: 'America/Tijuana (UTC-07:00)',
        value: 'America/Tijuana'
    },
    {
        label: 'America/Creston (UTC-07:00)',
        value: 'America/Creston'
    },
    {
        label: 'America/Hermosillo (UTC-07:00)',
        value: 'America/Hermosillo'
    },
    {
        label: 'America/Santa_Isabel (UTC-07:00)',
        value: 'America/Santa_Isabel'
    },
    {
        label: 'America/Vancouver (UTC-07:00)',
        value: 'America/Vancouver'
    },
    {
        label: 'America/Ensenada (UTC-07:00)',
        value: 'America/Ensenada'
    },
    {
        label: 'America/Phoenix (UTC-07:00)',
        value: 'America/Phoenix'
    },
    {
        label: 'America/Whitehorse (UTC-07:00)',
        value: 'America/Whitehorse'
    },
    {
        label: 'America/Fort_Nelson (UTC-07:00)',
        value: 'America/Fort_Nelson'
    },
    {
        label: 'SystemV/PST8PDT (UTC-07:00)',
        value: 'SystemV/PST8PDT'
    },
    {
        label: 'America/Los_Angeles (UTC-07:00)',
        value: 'America/Los_Angeles'
    },
    {
        label: 'US/Pacific (UTC-07:00)',
        value: 'US/Pacific'
    },
    {
        label: 'America/El_Salvador (UTC-06:00)',
        value: 'America/El_Salvador'
    },
    {
        label: 'America/Guatemala (UTC-06:00)',
        value: 'America/Guatemala'
    },
    {
        label: 'America/Belize (UTC-06:00)',
        value: 'America/Belize'
    },
    {
        label: 'America/Managua (UTC-06:00)',
        value: 'America/Managua'
    },
    {
        label: 'America/Tegucigalpa (UTC-06:00)',
        value: 'America/Tegucigalpa'
    },
    {
        label: 'Etc/GMT+6 (UTC-06:00)',
        value: 'Etc/GMT+6'
    },
    {
        label: 'Pacific/Easter (UTC-06:00)',
        value: 'Pacific/Easter'
    },
    {
        label: 'Mexico/BajaSur (UTC-06:00)',
        value: 'Mexico/BajaSur'
    },
    {
        label: 'America/Regina (UTC-06:00)',
        value: 'America/Regina'
    },
    {
        label: 'America/Denver (UTC-06:00)',
        value: 'America/Denver'
    },
    {
        label: 'Pacific/Galapagos (UTC-06:00)',
        value: 'Pacific/Galapagos'
    },
    {
        label: 'America/Yellowknife (UTC-06:00)',
        value: 'America/Yellowknife'
    },
    {
        label: 'America/Swift_Current (UTC-06:00)',
        value: 'America/Swift_Current'
    },
    {
        label: 'America/Inuvik (UTC-06:00)',
        value: 'America/Inuvik'
    },
    {
        label: 'America/Mazatlan (UTC-06:00)',
        value: 'America/Mazatlan'
    },
    {
        label: 'America/Boise (UTC-06:00)',
        value: 'America/Boise'
    },
    {
        label: 'America/Costa_Rica (UTC-06:00)',
        value: 'America/Costa_Rica'
    },
    {
        label: 'MST7MDT (UTC-06:00)',
        value: 'MST7MDT'
    },
    {
        label: 'SystemV/CST6 (UTC-06:00)',
        value: 'SystemV/CST6'
    },
    {
        label: 'America/Chihuahua (UTC-06:00)',
        value: 'America/Chihuahua'
    },
    {
        label: 'America/Ojinaga (UTC-06:00)',
        value: 'America/Ojinaga'
    },
    {
        label: 'Chile/EasterIsland (UTC-06:00)',
        value: 'Chile/EasterIsland'
    },
    {
        label: 'US/Mountain (UTC-06:00)',
        value: 'US/Mountain'
    },
    {
        label: 'America/Edmonton (UTC-06:00)',
        value: 'America/Edmonton'
    },
    {
        label: 'Canada/Mountain (UTC-06:00)',
        value: 'Canada/Mountain'
    },
    {
        label: 'America/Cambridge_Bay (UTC-06:00)',
        value: 'America/Cambridge_Bay'
    },
    {
        label: 'Navajo (UTC-06:00)',
        value: 'Navajo'
    },
    {
        label: 'SystemV/MST7MDT (UTC-06:00)',
        value: 'SystemV/MST7MDT'
    },
    {
        label: 'Canada/Saskatchewan (UTC-06:00)',
        value: 'Canada/Saskatchewan'
    },
    {
        label: 'America/Shiprock (UTC-06:00)',
        value: 'America/Shiprock'
    },
    {
        label: 'America/Panama (UTC-05:00)',
        value: 'America/Panama'
    },
    {
        label: 'America/Chicago (UTC-05:00)',
        value: 'America/Chicago'
    },
    {
        label: 'America/Eirunepe (UTC-05:00)',
        value: 'America/Eirunepe'
    },
    {
        label: 'Etc/GMT+5 (UTC-05:00)',
        value: 'Etc/GMT+5'
    },
    {
        label: 'Mexico/General (UTC-05:00)',
        value: 'Mexico/General'
    },
    {
        label: 'America/Porto_Acre (UTC-05:00)',
        value: 'America/Porto_Acre'
    },
    {
        label: 'America/Guayaquil (UTC-05:00)',
        value: 'America/Guayaquil'
    },
    {
        label: 'America/Rankin_Inlet (UTC-05:00)',
        value: 'America/Rankin_Inlet'
    },
    {
        label: 'US/Central (UTC-05:00)',
        value: 'US/Central'
    },
    {
        label: 'America/Rainy_River (UTC-05:00)',
        value: 'America/Rainy_River'
    },
    {
        label: 'America/Indiana/Knox (UTC-05:00)',
        value: 'America/Indiana/Knox'
    },
    {
        label: 'America/North_Dakota/Beulah (UTC-05:00)',
        value: 'America/North_Dakota/Beulah'
    },
    {
        label: 'America/Monterrey (UTC-05:00)',
        value: 'America/Monterrey'
    },
    {
        label: 'America/Jamaica (UTC-05:00)',
        value: 'America/Jamaica'
    },
    {
        label: 'America/Atikokan (UTC-05:00)',
        value: 'America/Atikokan'
    },
    {
        label: 'America/Coral_Harbour (UTC-05:00)',
        value: 'America/Coral_Harbour'
    },
    {
        label: 'America/North_Dakota/Center (UTC-05:00)',
        value: 'America/North_Dakota/Center'
    },
    {
        label: 'America/Cayman (UTC-05:00)',
        value: 'America/Cayman'
    },
    {
        label: 'America/Indiana/Tell_City (UTC-05:00)',
        value: 'America/Indiana/Tell_City'
    },
    {
        label: 'America/Mexico_City (UTC-05:00)',
        value: 'America/Mexico_City'
    },
    {
        label: 'America/Matamoros (UTC-05:00)',
        value: 'America/Matamoros'
    },
    {
        label: 'CST6CDT (UTC-05:00)',
        value: 'CST6CDT'
    },
    {
        label: 'America/Knox_IN (UTC-05:00)',
        value: 'America/Knox_IN'
    },
    {
        label: 'America/Bogota (UTC-05:00)',
        value: 'America/Bogota'
    },
    {
        label: 'America/Menominee (UTC-05:00)',
        value: 'America/Menominee'
    },
    {
        label: 'America/Resolute (UTC-05:00)',
        value: 'America/Resolute'
    },
    {
        label: 'SystemV/EST5 (UTC-05:00)',
        value: 'SystemV/EST5'
    },
    {
        label: 'Canada/Central (UTC-05:00)',
        value: 'Canada/Central'
    },
    {
        label: 'Brazil/Acre (UTC-05:00)',
        value: 'Brazil/Acre'
    },
    {
        label: 'America/Cancun (UTC-05:00)',
        value: 'America/Cancun'
    },
    {
        label: 'America/Lima (UTC-05:00)',
        value: 'America/Lima'
    },
    {
        label: 'America/Bahia_Banderas (UTC-05:00)',
        value: 'America/Bahia_Banderas'
    },
    {
        label: 'US/Indiana-Starke (UTC-05:00)',
        value: 'US/Indiana-Starke'
    },
    {
        label: 'America/Rio_Branco (UTC-05:00)',
        value: 'America/Rio_Branco'
    },
    {
        label: 'SystemV/CST6CDT (UTC-05:00)',
        value: 'SystemV/CST6CDT'
    },
    {
        label: 'Jamaica (UTC-05:00)',
        value: 'Jamaica'
    },
    {
        label: 'America/Merida (UTC-05:00)',
        value: 'America/Merida'
    },
    {
        label: 'America/North_Dakota/New_Salem (UTC-05:00)',
        value: 'America/North_Dakota/New_Salem'
    },
    {
        label: 'America/Winnipeg (UTC-05:00)',
        value: 'America/Winnipeg'
    },
    {
        label: 'America/Cuiaba (UTC-04:00)',
        value: 'America/Cuiaba'
    },
    {
        label: 'America/Marigot (UTC-04:00)',
        value: 'America/Marigot'
    },
    {
        label: 'America/Indiana/Petersburg (UTC-04:00)',
        value: 'America/Indiana/Petersburg'
    },
    {
        label: 'Chile/Continental (UTC-04:00)',
        value: 'Chile/Continental'
    },
    {
        label: 'America/Grand_Turk (UTC-04:00)',
        value: 'America/Grand_Turk'
    },
    {
        label: 'Cuba (UTC-04:00)',
        value: 'Cuba'
    },
    {
        label: 'Etc/GMT+4 (UTC-04:00)',
        value: 'Etc/GMT+4'
    },
    {
        label: 'America/Manaus (UTC-04:00)',
        value: 'America/Manaus'
    },
    {
        label: 'America/Fort_Wayne (UTC-04:00)',
        value: 'America/Fort_Wayne'
    },
    {
        label: 'America/St_Thomas (UTC-04:00)',
        value: 'America/St_Thomas'
    },
    {
        label: 'America/Anguilla (UTC-04:00)',
        value: 'America/Anguilla'
    },
    {
        label: 'America/Havana (UTC-04:00)',
        value: 'America/Havana'
    },
    {
        label: 'US/Michigan (UTC-04:00)',
        value: 'US/Michigan'
    },
    {
        label: 'America/Barbados (UTC-04:00)',
        value: 'America/Barbados'
    },
    {
        label: 'America/Louisville (UTC-04:00)',
        value: 'America/Louisville'
    },
    {
        label: 'America/Curacao (UTC-04:00)',
        value: 'America/Curacao'
    },
    {
        label: 'America/Guyana (UTC-04:00)',
        value: 'America/Guyana'
    },
    {
        label: 'America/Martinique (UTC-04:00)',
        value: 'America/Martinique'
    },
    {
        label: 'America/Puerto_Rico (UTC-04:00)',
        value: 'America/Puerto_Rico'
    },
    {
        label: 'America/Port_of_Spain (UTC-04:00)',
        value: 'America/Port_of_Spain'
    },
    {
        label: 'SystemV/AST4 (UTC-04:00)',
        value: 'SystemV/AST4'
    },
    {
        label: 'America/Indiana/Vevay (UTC-04:00)',
        value: 'America/Indiana/Vevay'
    },
    {
        label: 'America/Indiana/Vincennes (UTC-04:00)',
        value: 'America/Indiana/Vincennes'
    },
    {
        label: 'America/Kralendijk (UTC-04:00)',
        value: 'America/Kralendijk'
    },
    {
        label: 'America/Antigua (UTC-04:00)',
        value: 'America/Antigua'
    },
    {
        label: 'America/Indianapolis (UTC-04:00)',
        value: 'America/Indianapolis'
    },
    {
        label: 'America/Iqaluit (UTC-04:00)',
        value: 'America/Iqaluit'
    },
    {
        label: 'America/St_Vincent (UTC-04:00)',
        value: 'America/St_Vincent'
    },
    {
        label: 'America/Kentucky/Louisville (UTC-04:00)',
        value: 'America/Kentucky/Louisville'
    },
    {
        label: 'America/Dominica (UTC-04:00)',
        value: 'America/Dominica'
    },
    {
        label: 'America/Asuncion (UTC-04:00)',
        value: 'America/Asuncion'
    },
    {
        label: 'EST5EDT (UTC-04:00)',
        value: 'EST5EDT'
    },
    {
        label: 'America/Nassau (UTC-04:00)',
        value: 'America/Nassau'
    },
    {
        label: 'America/Kentucky/Monticello (UTC-04:00)',
        value: 'America/Kentucky/Monticello'
    },
    {
        label: 'Brazil/West (UTC-04:00)',
        value: 'Brazil/West'
    },
    {
        label: 'America/Aruba (UTC-04:00)',
        value: 'America/Aruba'
    },
    {
        label: 'America/Indiana/Indianapolis (UTC-04:00)',
        value: 'America/Indiana/Indianapolis'
    },
    {
        label: 'America/Santiago (UTC-04:00)',
        value: 'America/Santiago'
    },
    {
        label: 'America/La_Paz (UTC-04:00)',
        value: 'America/La_Paz'
    },
    {
        label: 'America/Thunder_Bay (UTC-04:00)',
        value: 'America/Thunder_Bay'
    },
    {
        label: 'America/Indiana/Marengo (UTC-04:00)',
        value: 'America/Indiana/Marengo'
    },
    {
        label: 'America/Blanc-Sablon (UTC-04:00)',
        value: 'America/Blanc-Sablon'
    },
    {
        label: 'America/Santo_Domingo (UTC-04:00)',
        value: 'America/Santo_Domingo'
    },
    {
        label: 'US/Eastern (UTC-04:00)',
        value: 'US/Eastern'
    },
    {
        label: 'Canada/Eastern (UTC-04:00)',
        value: 'Canada/Eastern'
    },
    {
        label: 'America/Port-au-Prince (UTC-04:00)',
        value: 'America/Port-au-Prince'
    },
    {
        label: 'America/St_Barthelemy (UTC-04:00)',
        value: 'America/St_Barthelemy'
    },
    {
        label: 'America/Nipigon (UTC-04:00)',
        value: 'America/Nipigon'
    },
    {
        label: 'US/East-Indiana (UTC-04:00)',
        value: 'US/East-Indiana'
    },
    {
        label: 'America/St_Lucia (UTC-04:00)',
        value: 'America/St_Lucia'
    },
    {
        label: 'America/Montserrat (UTC-04:00)',
        value: 'America/Montserrat'
    },
    {
        label: 'America/Lower_Princes (UTC-04:00)',
        value: 'America/Lower_Princes'
    },
    {
        label: 'America/Detroit (UTC-04:00)',
        value: 'America/Detroit'
    },
    {
        label: 'America/Tortola (UTC-04:00)',
        value: 'America/Tortola'
    },
    {
        label: 'America/Porto_Velho (UTC-04:00)',
        value: 'America/Porto_Velho'
    },
    {
        label: 'America/Campo_Grande (UTC-04:00)',
        value: 'America/Campo_Grande'
    },
    {
        label: 'America/Virgin (UTC-04:00)',
        value: 'America/Virgin'
    },
    {
        label: 'America/Pangnirtung (UTC-04:00)',
        value: 'America/Pangnirtung'
    },
    {
        label: 'America/Montreal (UTC-04:00)',
        value: 'America/Montreal'
    },
    {
        label: 'America/Indiana/Winamac (UTC-04:00)',
        value: 'America/Indiana/Winamac'
    },
    {
        label: 'America/Boa_Vista (UTC-04:00)',
        value: 'America/Boa_Vista'
    },
    {
        label: 'America/Grenada (UTC-04:00)',
        value: 'America/Grenada'
    },
    {
        label: 'America/New_York (UTC-04:00)',
        value: 'America/New_York'
    },
    {
        label: 'America/St_Kitts (UTC-04:00)',
        value: 'America/St_Kitts'
    },
    {
        label: 'America/Caracas (UTC-04:00)',
        value: 'America/Caracas'
    },
    {
        label: 'America/Guadeloupe (UTC-04:00)',
        value: 'America/Guadeloupe'
    },
    {
        label: 'America/Toronto (UTC-04:00)',
        value: 'America/Toronto'
    },
    {
        label: 'SystemV/EST5EDT (UTC-04:00)',
        value: 'SystemV/EST5EDT'
    },
    {
        label: 'America/Argentina/Catamarca (UTC-03:00)',
        value: 'America/Argentina/Catamarca'
    },
    {
        label: 'Canada/Atlantic (UTC-03:00)',
        value: 'Canada/Atlantic'
    },
    {
        label: 'America/Argentina/Cordoba (UTC-03:00)',
        value: 'America/Argentina/Cordoba'
    },
    {
        label: 'America/Araguaina (UTC-03:00)',
        value: 'America/Araguaina'
    },
    {
        label: 'America/Argentina/Salta (UTC-03:00)',
        value: 'America/Argentina/Salta'
    },
    {
        label: 'Etc/GMT+3 (UTC-03:00)',
        value: 'Etc/GMT+3'
    },
    {
        label: 'America/Montevideo (UTC-03:00)',
        value: 'America/Montevideo'
    },
    {
        label: 'Brazil/East (UTC-03:00)',
        value: 'Brazil/East'
    },
    {
        label: 'America/Argentina/Mendoza (UTC-03:00)',
        value: 'America/Argentina/Mendoza'
    },
    {
        label: 'America/Argentina/Rio_Gallegos (UTC-03:00)',
        value: 'America/Argentina/Rio_Gallegos'
    },
    {
        label: 'America/Catamarca (UTC-03:00)',
        value: 'America/Catamarca'
    },
    {
        label: 'America/Cordoba (UTC-03:00)',
        value: 'America/Cordoba'
    },
    {
        label: 'America/Sao_Paulo (UTC-03:00)',
        value: 'America/Sao_Paulo'
    },
    {
        label: 'America/Argentina/Jujuy (UTC-03:00)',
        value: 'America/Argentina/Jujuy'
    },
    {
        label: 'America/Cayenne (UTC-03:00)',
        value: 'America/Cayenne'
    },
    {
        label: 'America/Recife (UTC-03:00)',
        value: 'America/Recife'
    },
    {
        label: 'America/Buenos_Aires (UTC-03:00)',
        value: 'America/Buenos_Aires'
    },
    {
        label: 'America/Paramaribo (UTC-03:00)',
        value: 'America/Paramaribo'
    },
    {
        label: 'America/Moncton (UTC-03:00)',
        value: 'America/Moncton'
    },
    {
        label: 'America/Mendoza (UTC-03:00)',
        value: 'America/Mendoza'
    },
    {
        label: 'America/Santarem (UTC-03:00)',
        value: 'America/Santarem'
    },
    {
        label: 'Atlantic/Bermuda (UTC-03:00)',
        value: 'Atlantic/Bermuda'
    },
    {
        label: 'America/Maceio (UTC-03:00)',
        value: 'America/Maceio'
    },
    {
        label: 'Atlantic/Stanley (UTC-03:00)',
        value: 'Atlantic/Stanley'
    },
    {
        label: 'America/Halifax (UTC-03:00)',
        value: 'America/Halifax'
    },
    {
        label: 'Antarctica/Rothera (UTC-03:00)',
        value: 'Antarctica/Rothera'
    },
    {
        label: 'America/Argentina/San_Luis (UTC-03:00)',
        value: 'America/Argentina/San_Luis'
    },
    {
        label: 'America/Argentina/Ushuaia (UTC-03:00)',
        value: 'America/Argentina/Ushuaia'
    },
    {
        label: 'Antarctica/Palmer (UTC-03:00)',
        value: 'Antarctica/Palmer'
    },
    {
        label: 'America/Punta_Arenas (UTC-03:00)',
        value: 'America/Punta_Arenas'
    },
    {
        label: 'America/Glace_Bay (UTC-03:00)',
        value: 'America/Glace_Bay'
    },
    {
        label: 'America/Fortaleza (UTC-03:00)',
        value: 'America/Fortaleza'
    },
    {
        label: 'America/Thule (UTC-03:00)',
        value: 'America/Thule'
    },
    {
        label: 'America/Argentina/La_Rioja (UTC-03:00)',
        value: 'America/Argentina/La_Rioja'
    },
    {
        label: 'America/Belem (UTC-03:00)',
        value: 'America/Belem'
    },
    {
        label: 'America/Jujuy (UTC-03:00)',
        value: 'America/Jujuy'
    },
    {
        label: 'America/Bahia (UTC-03:00)',
        value: 'America/Bahia'
    },
    {
        label: 'America/Goose_Bay (UTC-03:00)',
        value: 'America/Goose_Bay'
    },
    {
        label: 'America/Argentina/San_Juan (UTC-03:00)',
        value: 'America/Argentina/San_Juan'
    },
    {
        label: 'America/Argentina/ComodRivadavia (UTC-03:00)',
        value: 'America/Argentina/ComodRivadavia'
    },
    {
        label: 'America/Argentina/Tucuman (UTC-03:00)',
        value: 'America/Argentina/Tucuman'
    },
    {
        label: 'America/Rosario (UTC-03:00)',
        value: 'America/Rosario'
    },
    {
        label: 'SystemV/AST4ADT (UTC-03:00)',
        value: 'SystemV/AST4ADT'
    },
    {
        label: 'America/Argentina/Buenos_Aires (UTC-03:00)',
        value: 'America/Argentina/Buenos_Aires'
    },
    {
        label: 'America/St_Johns (UTC-02:30)',
        value: 'America/St_Johns'
    },
    {
        label: 'Canada/Newfoundland (UTC-02:30)',
        value: 'Canada/Newfoundland'
    },
    {
        label: 'America/Miquelon (UTC-02:00)',
        value: 'America/Miquelon'
    },
    {
        label: 'Etc/GMT+2 (UTC-02:00)',
        value: 'Etc/GMT+2'
    },
    {
        label: 'America/Godthab (UTC-02:00)',
        value: 'America/Godthab'
    },
    {
        label: 'America/Noronha (UTC-02:00)',
        value: 'America/Noronha'
    },
    {
        label: 'Brazil/DeNoronha (UTC-02:00)',
        value: 'Brazil/DeNoronha'
    },
    {
        label: 'Atlantic/South_Georgia (UTC-02:00)',
        value: 'Atlantic/South_Georgia'
    },
    {
        label: 'Etc/GMT+1 (UTC-01:00)',
        value: 'Etc/GMT+1'
    },
    {
        label: 'Atlantic/Cape_Verde (UTC-01:00)',
        value: 'Atlantic/Cape_Verde'
    },
    {
        label: 'Pacific/Kiritimati (UTC+14:00)',
        value: 'Pacific/Kiritimati'
    },
    {
        label: 'Etc/GMT-14 (UTC+14:00)',
        value: 'Etc/GMT-14'
    },
    {
        label: 'Pacific/Fakaofo (UTC+13:00)',
        value: 'Pacific/Fakaofo'
    },
    {
        label: 'Pacific/Enderbury (UTC+13:00)',
        value: 'Pacific/Enderbury'
    },
    {
        label: 'Pacific/Apia (UTC+13:00)',
        value: 'Pacific/Apia'
    },
    {
        label: 'Pacific/Tongatapu (UTC+13:00)',
        value: 'Pacific/Tongatapu'
    },
    {
        label: 'Etc/GMT-13 (UTC+13:00)',
        value: 'Etc/GMT-13'
    },
    {
        label: 'NZ-CHAT (UTC+12:45)',
        value: 'NZ-CHAT'
    },
    {
        label: 'Pacific/Chatham (UTC+12:45)',
        value: 'Pacific/Chatham'
    },
    {
        label: 'Pacific/Kwajalein (UTC+12:00)',
        value: 'Pacific/Kwajalein'
    },
    {
        label: 'Antarctica/McMurdo (UTC+12:00)',
        value: 'Antarctica/McMurdo'
    },
    {
        label: 'Pacific/Wallis (UTC+12:00)',
        value: 'Pacific/Wallis'
    },
    {
        label: 'Pacific/Fiji (UTC+12:00)',
        value: 'Pacific/Fiji'
    },
    {
        label: 'Pacific/Funafuti (UTC+12:00)',
        value: 'Pacific/Funafuti'
    },
    {
        label: 'Pacific/Nauru (UTC+12:00)',
        value: 'Pacific/Nauru'
    },
    {
        label: 'Kwajalein (UTC+12:00)',
        value: 'Kwajalein'
    },
    {
        label: 'NZ (UTC+12:00)',
        value: 'NZ'
    },
    {
        label: 'Pacific/Wake (UTC+12:00)',
        value: 'Pacific/Wake'
    },
    {
        label: 'Antarctica/South_Pole (UTC+12:00)',
        value: 'Antarctica/South_Pole'
    },
    {
        label: 'Pacific/Tarawa (UTC+12:00)',
        value: 'Pacific/Tarawa'
    },
    {
        label: 'Pacific/Auckland (UTC+12:00)',
        value: 'Pacific/Auckland'
    },
    {
        label: 'Asia/Kamchatka (UTC+12:00)',
        value: 'Asia/Kamchatka'
    },
    {
        label: 'Etc/GMT-12 (UTC+12:00)',
        value: 'Etc/GMT-12'
    },
    {
        label: 'Asia/Anadyr (UTC+12:00)',
        value: 'Asia/Anadyr'
    },
    {
        label: 'Pacific/Majuro (UTC+12:00)',
        value: 'Pacific/Majuro'
    },
    {
        label: 'Pacific/Ponape (UTC+11:00)',
        value: 'Pacific/Ponape'
    },
    {
        label: 'Pacific/Bougainville (UTC+11:00)',
        value: 'Pacific/Bougainville'
    },
    {
        label: 'Antarctica/Macquarie (UTC+11:00)',
        value: 'Antarctica/Macquarie'
    },
    {
        label: 'Pacific/Pohnpei (UTC+11:00)',
        value: 'Pacific/Pohnpei'
    },
    {
        label: 'Pacific/Efate (UTC+11:00)',
        value: 'Pacific/Efate'
    },
    {
        label: 'Pacific/Norfolk (UTC+11:00)',
        value: 'Pacific/Norfolk'
    },
    {
        label: 'Asia/Magadan (UTC+11:00)',
        value: 'Asia/Magadan'
    },
    {
        label: 'Pacific/Kosrae (UTC+11:00)',
        value: 'Pacific/Kosrae'
    },
    {
        label: 'Asia/Sakhalin (UTC+11:00)',
        value: 'Asia/Sakhalin'
    },
    {
        label: 'Pacific/Noumea (UTC+11:00)',
        value: 'Pacific/Noumea'
    },
    {
        label: 'Etc/GMT-11 (UTC+11:00)',
        value: 'Etc/GMT-11'
    },
    {
        label: 'Asia/Srednekolymsk (UTC+11:00)',
        value: 'Asia/Srednekolymsk'
    },
    {
        label: 'Pacific/Guadalcanal (UTC+11:00)',
        value: 'Pacific/Guadalcanal'
    },
    {
        label: 'Australia/Lord_Howe (UTC+10:30)',
        value: 'Australia/Lord_Howe'
    },
    {
        label: 'Australia/LHI (UTC+10:30)',
        value: 'Australia/LHI'
    },
    {
        label: 'Australia/Hobart (UTC+10:00)',
        value: 'Australia/Hobart'
    },
    {
        label: 'Pacific/Yap (UTC+10:00)',
        value: 'Pacific/Yap'
    },
    {
        label: 'Australia/Tasmania (UTC+10:00)',
        value: 'Australia/Tasmania'
    },
    {
        label: 'Pacific/Port_Moresby (UTC+10:00)',
        value: 'Pacific/Port_Moresby'
    },
    {
        label: 'Australia/ACT (UTC+10:00)',
        value: 'Australia/ACT'
    },
    {
        label: 'Australia/Victoria (UTC+10:00)',
        value: 'Australia/Victoria'
    },
    {
        label: 'Pacific/Chuuk (UTC+10:00)',
        value: 'Pacific/Chuuk'
    },
    {
        label: 'Australia/Queensland (UTC+10:00)',
        value: 'Australia/Queensland'
    },
    {
        label: 'Australia/Canberra (UTC+10:00)',
        value: 'Australia/Canberra'
    },
    {
        label: 'Australia/Currie (UTC+10:00)',
        value: 'Australia/Currie'
    },
    {
        label: 'Pacific/Guam (UTC+10:00)',
        value: 'Pacific/Guam'
    },
    {
        label: 'Pacific/Truk (UTC+10:00)',
        value: 'Pacific/Truk'
    },
    {
        label: 'Australia/NSW (UTC+10:00)',
        value: 'Australia/NSW'
    },
    {
        label: 'Asia/Vladivostok (UTC+10:00)',
        value: 'Asia/Vladivostok'
    },
    {
        label: 'Pacific/Saipan (UTC+10:00)',
        value: 'Pacific/Saipan'
    },
    {
        label: 'Antarctica/DumontDUrville (UTC+10:00)',
        value: 'Antarctica/DumontDUrville'
    },
    {
        label: 'Australia/Sydney (UTC+10:00)',
        value: 'Australia/Sydney'
    },
    {
        label: 'Australia/Brisbane (UTC+10:00)',
        value: 'Australia/Brisbane'
    },
    {
        label: 'Etc/GMT-10 (UTC+10:00)',
        value: 'Etc/GMT-10'
    },
    {
        label: 'Asia/Ust-Nera (UTC+10:00)',
        value: 'Asia/Ust-Nera'
    },
    {
        label: 'Australia/Melbourne (UTC+10:00)',
        value: 'Australia/Melbourne'
    },
    {
        label: 'Australia/Lindeman (UTC+10:00)',
        value: 'Australia/Lindeman'
    },
    {
        label: 'Australia/North (UTC+09:30)',
        value: 'Australia/North'
    },
    {
        label: 'Australia/Yancowinna (UTC+09:30)',
        value: 'Australia/Yancowinna'
    },
    {
        label: 'Australia/Adelaide (UTC+09:30)',
        value: 'Australia/Adelaide'
    },
    {
        label: 'Australia/Broken_Hill (UTC+09:30)',
        value: 'Australia/Broken_Hill'
    },
    {
        label: 'Australia/South (UTC+09:30)',
        value: 'Australia/South'
    },
    {
        label: 'Australia/Darwin (UTC+09:30)',
        value: 'Australia/Darwin'
    },
    {
        label: 'Etc/GMT-9 (UTC+09:00)',
        value: 'Etc/GMT-9'
    },
    {
        label: 'Pacific/Palau (UTC+09:00)',
        value: 'Pacific/Palau'
    },
    {
        label: 'Asia/Chita (UTC+09:00)',
        value: 'Asia/Chita'
    },
    {
        label: 'Asia/Dili (UTC+09:00)',
        value: 'Asia/Dili'
    },
    {
        label: 'Asia/Jayapura (UTC+09:00)',
        value: 'Asia/Jayapura'
    },
    {
        label: 'Asia/Yakutsk (UTC+09:00)',
        value: 'Asia/Yakutsk'
    },
    {
        label: 'Asia/Pyongyang (UTC+09:00)',
        value: 'Asia/Pyongyang'
    },
    {
        label: 'ROK (UTC+09:00)',
        value: 'ROK'
    },
    {
        label: 'Asia/Seoul (UTC+09:00)',
        value: 'Asia/Seoul'
    },
    {
        label: 'Asia/Khandyga (UTC+09:00)',
        value: 'Asia/Khandyga'
    },
    {
        label: 'Japan (UTC+09:00)',
        value: 'Japan'
    },
    {
        label: 'Asia/Tokyo (UTC+09:00)',
        value: 'Asia/Tokyo'
    },
    {
        label: 'Australia/Eucla (UTC+08:45)',
        value: 'Australia/Eucla'
    },
    {
        label: 'Asia/Kuching (UTC+08:00)',
        value: 'Asia/Kuching'
    },
    {
        label: 'Asia/Chungking (UTC+08:00)',
        value: 'Asia/Chungking'
    },
    {
        label: 'Etc/GMT-8 (UTC+08:00)',
        value: 'Etc/GMT-8'
    },
    {
        label: 'Australia/Perth (UTC+08:00)',
        value: 'Australia/Perth'
    },
    {
        label: 'Asia/Macao (UTC+08:00)',
        value: 'Asia/Macao'
    },
    {
        label: 'Asia/Macau (UTC+08:00)',
        value: 'Asia/Macau'
    },
    {
        label: 'Asia/Choibalsan (UTC+08:00)',
        value: 'Asia/Choibalsan'
    },
    {
        label: 'Asia/Shanghai (UTC+08:00)',
        value: 'Asia/Shanghai'
    },
    {
        label: 'Antarctica/Casey (UTC+08:00)',
        value: 'Antarctica/Casey'
    },
    {
        label: 'Asia/Ulan_Bator (UTC+08:00)',
        value: 'Asia/Ulan_Bator'
    },
    {
        label: 'Asia/Chongqing (UTC+08:00)',
        value: 'Asia/Chongqing'
    },
    {
        label: 'Asia/Ulaanbaatar (UTC+08:00)',
        value: 'Asia/Ulaanbaatar'
    },
    {
        label: 'Asia/Taipei (UTC+08:00)',
        value: 'Asia/Taipei'
    },
    {
        label: 'Asia/Manila (UTC+08:00)',
        value: 'Asia/Manila'
    },
    {
        label: 'PRC (UTC+08:00)',
        value: 'PRC'
    },
    {
        label: 'Asia/Ujung_Pandang (UTC+08:00)',
        value: 'Asia/Ujung_Pandang'
    },
    {
        label: 'Asia/Harbin (UTC+08:00)',
        value: 'Asia/Harbin'
    },
    {
        label: 'Singapore (UTC+08:00)',
        value: 'Singapore'
    },
    {
        label: 'Asia/Brunei (UTC+08:00)',
        value: 'Asia/Brunei'
    },
    {
        label: 'Australia/West (UTC+08:00)',
        value: 'Australia/West'
    },
    {
        label: 'Asia/Hong_Kong (UTC+08:00)',
        value: 'Asia/Hong_Kong'
    },
    {
        label: 'Asia/Makassar (UTC+08:00)',
        value: 'Asia/Makassar'
    },
    {
        label: 'Hongkong (UTC+08:00)',
        value: 'Hongkong'
    },
    {
        label: 'Asia/Kuala_Lumpur (UTC+08:00)',
        value: 'Asia/Kuala_Lumpur'
    },
    {
        label: 'Asia/Irkutsk (UTC+08:00)',
        value: 'Asia/Irkutsk'
    },
    {
        label: 'Asia/Singapore (UTC+08:00)',
        value: 'Asia/Singapore'
    },
    {
        label: 'Asia/Pontianak (UTC+07:00)',
        value: 'Asia/Pontianak'
    },
    {
        label: 'Etc/GMT-7 (UTC+07:00)',
        value: 'Etc/GMT-7'
    },
    {
        label: 'Asia/Phnom_Penh (UTC+07:00)',
        value: 'Asia/Phnom_Penh'
    },
    {
        label: 'Asia/Novosibirsk (UTC+07:00)',
        value: 'Asia/Novosibirsk'
    },
    {
        label: 'Antarctica/Davis (UTC+07:00)',
        value: 'Antarctica/Davis'
    },
    {
        label: 'Asia/Tomsk (UTC+07:00)',
        value: 'Asia/Tomsk'
    },
    {
        label: 'Asia/Jakarta (UTC+07:00)',
        value: 'Asia/Jakarta'
    },
    {
        label: 'Asia/Barnaul (UTC+07:00)',
        value: 'Asia/Barnaul'
    },
    {
        label: 'Indian/Christmas (UTC+07:00)',
        value: 'Indian/Christmas'
    },
    {
        label: 'Asia/Ho_Chi_Minh (UTC+07:00)',
        value: 'Asia/Ho_Chi_Minh'
    },
    {
        label: 'Asia/Hovd (UTC+07:00)',
        value: 'Asia/Hovd'
    },
    {
        label: 'Asia/Bangkok (UTC+07:00)',
        value: 'Asia/Bangkok'
    },
    {
        label: 'Asia/Vientiane (UTC+07:00)',
        value: 'Asia/Vientiane'
    },
    {
        label: 'Asia/Novokuznetsk (UTC+07:00)',
        value: 'Asia/Novokuznetsk'
    },
    {
        label: 'Asia/Krasnoyarsk (UTC+07:00)',
        value: 'Asia/Krasnoyarsk'
    },
    {
        label: 'Asia/Saigon (UTC+07:00)',
        value: 'Asia/Saigon'
    },
    {
        label: 'Asia/Yangon (UTC+06:30)',
        value: 'Asia/Yangon'
    },
    {
        label: 'Asia/Rangoon (UTC+06:30)',
        value: 'Asia/Rangoon'
    },
    {
        label: 'Indian/Cocos (UTC+06:30)',
        value: 'Indian/Cocos'
    },
    {
        label: 'Asia/Kashgar (UTC+06:00)',
        value: 'Asia/Kashgar'
    },
    {
        label: 'Etc/GMT-6 (UTC+06:00)',
        value: 'Etc/GMT-6'
    },
    {
        label: 'Asia/Almaty (UTC+06:00)',
        value: 'Asia/Almaty'
    },
    {
        label: 'Asia/Dacca (UTC+06:00)',
        value: 'Asia/Dacca'
    },
    {
        label: 'Asia/Omsk (UTC+06:00)',
        value: 'Asia/Omsk'
    },
    {
        label: 'Asia/Dhaka (UTC+06:00)',
        value: 'Asia/Dhaka'
    },
    {
        label: 'Indian/Chagos (UTC+06:00)',
        value: 'Indian/Chagos'
    },
    {
        label: 'Asia/Qyzylorda (UTC+06:00)',
        value: 'Asia/Qyzylorda'
    },
    {
        label: 'Asia/Bishkek (UTC+06:00)',
        value: 'Asia/Bishkek'
    },
    {
        label: 'Antarctica/Vostok (UTC+06:00)',
        value: 'Antarctica/Vostok'
    },
    {
        label: 'Asia/Urumqi (UTC+06:00)',
        value: 'Asia/Urumqi'
    },
    {
        label: 'Asia/Thimbu (UTC+06:00)',
        value: 'Asia/Thimbu'
    },
    {
        label: 'Asia/Thimphu (UTC+06:00)',
        value: 'Asia/Thimphu'
    },
    {
        label: 'Asia/Kathmandu (UTC+05:45)',
        value: 'Asia/Kathmandu'
    },
    {
        label: 'Asia/Katmandu (UTC+05:45)',
        value: 'Asia/Katmandu'
    },
    {
        label: 'Asia/Kolkata (UTC+05:30)',
        value: 'Asia/Kolkata'
    },
    {
        label: 'Asia/Colombo (UTC+05:30)',
        value: 'Asia/Colombo'
    },
    {
        label: 'Asia/Calcutta (UTC+05:30)',
        value: 'Asia/Calcutta'
    },
    {
        label: 'Asia/Aqtau (UTC+05:00)',
        value: 'Asia/Aqtau'
    },
    {
        label: 'Etc/GMT-5 (UTC+05:00)',
        value: 'Etc/GMT-5'
    },
    {
        label: 'Asia/Samarkand (UTC+05:00)',
        value: 'Asia/Samarkand'
    },
    {
        label: 'Asia/Karachi (UTC+05:00)',
        value: 'Asia/Karachi'
    },
    {
        label: 'Asia/Yekaterinburg (UTC+05:00)',
        value: 'Asia/Yekaterinburg'
    },
    {
        label: 'Asia/Dushanbe (UTC+05:00)',
        value: 'Asia/Dushanbe'
    },
    {
        label: 'Indian/Maldives (UTC+05:00)',
        value: 'Indian/Maldives'
    },
    {
        label: 'Asia/Oral (UTC+05:00)',
        value: 'Asia/Oral'
    },
    {
        label: 'Asia/Tashkent (UTC+05:00)',
        value: 'Asia/Tashkent'
    },
    {
        label: 'Antarctica/Mawson (UTC+05:00)',
        value: 'Antarctica/Mawson'
    },
    {
        label: 'Asia/Aqtobe (UTC+05:00)',
        value: 'Asia/Aqtobe'
    },
    {
        label: 'Asia/Ashkhabad (UTC+05:00)',
        value: 'Asia/Ashkhabad'
    },
    {
        label: 'Asia/Ashgabat (UTC+05:00)',
        value: 'Asia/Ashgabat'
    },
    {
        label: 'Asia/Atyrau (UTC+05:00)',
        value: 'Asia/Atyrau'
    },
    {
        label: 'Indian/Kerguelen (UTC+05:00)',
        value: 'Indian/Kerguelen'
    },
    {
        label: 'Iran (UTC+04:30)',
        value: 'Iran'
    },
    {
        label: 'Asia/Tehran (UTC+04:30)',
        value: 'Asia/Tehran'
    },
    {
        label: 'Asia/Kabul (UTC+04:30)',
        value: 'Asia/Kabul'
    },
    {
        label: 'Asia/Yerevan (UTC+04:00)',
        value: 'Asia/Yerevan'
    },
    {
        label: 'Etc/GMT-4 (UTC+04:00)',
        value: 'Etc/GMT-4'
    },
    {
        label: 'Asia/Dubai (UTC+04:00)',
        value: 'Asia/Dubai'
    },
    {
        label: 'Indian/Reunion (UTC+04:00)',
        value: 'Indian/Reunion'
    },
    {
        label: 'Indian/Mauritius (UTC+04:00)',
        value: 'Indian/Mauritius'
    },
    {
        label: 'Europe/Saratov (UTC+04:00)',
        value: 'Europe/Saratov'
    },
    {
        label: 'Europe/Samara (UTC+04:00)',
        value: 'Europe/Samara'
    },
    {
        label: 'Indian/Mahe (UTC+04:00)',
        value: 'Indian/Mahe'
    },
    {
        label: 'Asia/Baku (UTC+04:00)',
        value: 'Asia/Baku'
    },
    {
        label: 'Asia/Muscat (UTC+04:00)',
        value: 'Asia/Muscat'
    },
    {
        label: 'Europe/Volgograd (UTC+04:00)',
        value: 'Europe/Volgograd'
    },
    {
        label: 'Europe/Astrakhan (UTC+04:00)',
        value: 'Europe/Astrakhan'
    },
    {
        label: 'Asia/Tbilisi (UTC+04:00)',
        value: 'Asia/Tbilisi'
    },
    {
        label: 'Europe/Ulyanovsk (UTC+04:00)',
        value: 'Europe/Ulyanovsk'
    },
    {
        label: 'Asia/Aden (UTC+03:00)',
        value: 'Asia/Aden'
    },
    {
        label: 'Africa/Nairobi (UTC+03:00)',
        value: 'Africa/Nairobi'
    },
    {
        label: 'Europe/Istanbul (UTC+03:00)',
        value: 'Europe/Istanbul'
    },
    {
        label: 'Etc/GMT-3 (UTC+03:00)',
        value: 'Etc/GMT-3'
    },
    {
        label: 'Europe/Zaporozhye (UTC+03:00)',
        value: 'Europe/Zaporozhye'
    },
    {
        label: 'Israel (UTC+03:00)',
        value: 'Israel'
    },
    {
        label: 'Indian/Comoro (UTC+03:00)',
        value: 'Indian/Comoro'
    },
    {
        label: 'Antarctica/Syowa (UTC+03:00)',
        value: 'Antarctica/Syowa'
    },
    {
        label: 'Africa/Mogadishu (UTC+03:00)',
        value: 'Africa/Mogadishu'
    },
    {
        label: 'Europe/Bucharest (UTC+03:00)',
        value: 'Europe/Bucharest'
    },
    {
        label: 'Africa/Asmera (UTC+03:00)',
        value: 'Africa/Asmera'
    },
    {
        label: 'Europe/Mariehamn (UTC+03:00)',
        value: 'Europe/Mariehamn'
    },
    {
        label: 'Asia/Istanbul (UTC+03:00)',
        value: 'Asia/Istanbul'
    },
    {
        label: 'Europe/Tiraspol (UTC+03:00)',
        value: 'Europe/Tiraspol'
    },
    {
        label: 'Europe/Moscow (UTC+03:00)',
        value: 'Europe/Moscow'
    },
    {
        label: 'Europe/Chisinau (UTC+03:00)',
        value: 'Europe/Chisinau'
    },
    {
        label: 'Europe/Helsinki (UTC+03:00)',
        value: 'Europe/Helsinki'
    },
    {
        label: 'Asia/Beirut (UTC+03:00)',
        value: 'Asia/Beirut'
    },
    {
        label: 'Asia/Tel_Aviv (UTC+03:00)',
        value: 'Asia/Tel_Aviv'
    },
    {
        label: 'Africa/Djibouti (UTC+03:00)',
        value: 'Africa/Djibouti'
    },
    {
        label: 'Europe/Simferopol (UTC+03:00)',
        value: 'Europe/Simferopol'
    },
    {
        label: 'Europe/Sofia (UTC+03:00)',
        value: 'Europe/Sofia'
    },
    {
        label: 'Asia/Gaza (UTC+03:00)',
        value: 'Asia/Gaza'
    },
    {
        label: 'Africa/Asmara (UTC+03:00)',
        value: 'Africa/Asmara'
    },
    {
        label: 'Europe/Riga (UTC+03:00)',
        value: 'Europe/Riga'
    },
    {
        label: 'Asia/Baghdad (UTC+03:00)',
        value: 'Asia/Baghdad'
    },
    {
        label: 'Asia/Damascus (UTC+03:00)',
        value: 'Asia/Damascus'
    },
    {
        label: 'Africa/Dar_es_Salaam (UTC+03:00)',
        value: 'Africa/Dar_es_Salaam'
    },
    {
        label: 'Africa/Addis_Ababa (UTC+03:00)',
        value: 'Africa/Addis_Ababa'
    },
    {
        label: 'Europe/Uzhgorod (UTC+03:00)',
        value: 'Europe/Uzhgorod'
    },
    {
        label: 'Asia/Jerusalem (UTC+03:00)',
        value: 'Asia/Jerusalem'
    },
    {
        label: 'Asia/Riyadh (UTC+03:00)',
        value: 'Asia/Riyadh'
    },
    {
        label: 'Asia/Kuwait (UTC+03:00)',
        value: 'Asia/Kuwait'
    },
    {
        label: 'Europe/Kirov (UTC+03:00)',
        value: 'Europe/Kirov'
    },
    {
        label: 'Africa/Kampala (UTC+03:00)',
        value: 'Africa/Kampala'
    },
    {
        label: 'Europe/Minsk (UTC+03:00)',
        value: 'Europe/Minsk'
    },
    {
        label: 'Asia/Qatar (UTC+03:00)',
        value: 'Asia/Qatar'
    },
    {
        label: 'Europe/Kiev (UTC+03:00)',
        value: 'Europe/Kiev'
    },
    {
        label: 'Asia/Bahrain (UTC+03:00)',
        value: 'Asia/Bahrain'
    },
    {
        label: 'Europe/Vilnius (UTC+03:00)',
        value: 'Europe/Vilnius'
    },
    {
        label: 'Indian/Antananarivo (UTC+03:00)',
        value: 'Indian/Antananarivo'
    },
    {
        label: 'Indian/Mayotte (UTC+03:00)',
        value: 'Indian/Mayotte'
    },
    {
        label: 'Europe/Tallinn (UTC+03:00)',
        value: 'Europe/Tallinn'
    },
    {
        label: 'Turkey (UTC+03:00)',
        value: 'Turkey'
    },
    {
        label: 'Africa/Juba (UTC+03:00)',
        value: 'Africa/Juba'
    },
    {
        label: 'Asia/Nicosia (UTC+03:00)',
        value: 'Asia/Nicosia'
    },
    {
        label: 'Asia/Famagusta (UTC+03:00)',
        value: 'Asia/Famagusta'
    },
    {
        label: 'W-SU (UTC+03:00)',
        value: 'W-SU'
    },
    {
        label: 'EET (UTC+03:00)',
        value: 'EET'
    },
    {
        label: 'Asia/Hebron (UTC+03:00)',
        value: 'Asia/Hebron'
    },
    {
        label: 'Asia/Amman (UTC+03:00)',
        value: 'Asia/Amman'
    },
    {
        label: 'Europe/Nicosia (UTC+03:00)',
        value: 'Europe/Nicosia'
    },
    {
        label: 'Europe/Athens (UTC+03:00)',
        value: 'Europe/Athens'
    },
    {
        label: 'Africa/Cairo (UTC+02:00)',
        value: 'Africa/Cairo'
    },
    {
        label: 'Africa/Mbabane (UTC+02:00)',
        value: 'Africa/Mbabane'
    },
    {
        label: 'Europe/Brussels (UTC+02:00)',
        value: 'Europe/Brussels'
    },
    {
        label: 'Europe/Warsaw (UTC+02:00)',
        value: 'Europe/Warsaw'
    },
    {
        label: 'CET (UTC+02:00)',
        value: 'CET'
    },
    {
        label: 'Europe/Luxembourg (UTC+02:00)',
        value: 'Europe/Luxembourg'
    },
    {
        label: 'Etc/GMT-2 (UTC+02:00)',
        value: 'Etc/GMT-2'
    },
    {
        label: 'Libya (UTC+02:00)',
        value: 'Libya'
    },
    {
        label: 'Africa/Kigali (UTC+02:00)',
        value: 'Africa/Kigali'
    },
    {
        label: 'Africa/Tripoli (UTC+02:00)',
        value: 'Africa/Tripoli'
    },
    {
        label: 'Europe/Kaliningrad (UTC+02:00)',
        value: 'Europe/Kaliningrad'
    },
    {
        label: 'Africa/Windhoek (UTC+02:00)',
        value: 'Africa/Windhoek'
    },
    {
        label: 'Europe/Malta (UTC+02:00)',
        value: 'Europe/Malta'
    },
    {
        label: 'Europe/Busingen (UTC+02:00)',
        value: 'Europe/Busingen'
    },
    {
        label: 'Europe/Skopje (UTC+02:00)',
        value: 'Europe/Skopje'
    },
    {
        label: 'Europe/Sarajevo (UTC+02:00)',
        value: 'Europe/Sarajevo'
    },
    {
        label: 'Europe/Rome (UTC+02:00)',
        value: 'Europe/Rome'
    },
    {
        label: 'Europe/Zurich (UTC+02:00)',
        value: 'Europe/Zurich'
    },
    {
        label: 'Europe/Gibraltar (UTC+02:00)',
        value: 'Europe/Gibraltar'
    },
    {
        label: 'Africa/Lubumbashi (UTC+02:00)',
        value: 'Africa/Lubumbashi'
    },
    {
        label: 'Europe/Vaduz (UTC+02:00)',
        value: 'Europe/Vaduz'
    },
    {
        label: 'Europe/Ljubljana (UTC+02:00)',
        value: 'Europe/Ljubljana'
    },
    {
        label: 'Europe/Berlin (UTC+02:00)',
        value: 'Europe/Berlin'
    },
    {
        label: 'Europe/Stockholm (UTC+02:00)',
        value: 'Europe/Stockholm'
    },
    {
        label: 'Europe/Budapest (UTC+02:00)',
        value: 'Europe/Budapest'
    },
    {
        label: 'Europe/Zagreb (UTC+02:00)',
        value: 'Europe/Zagreb'
    },
    {
        label: 'Europe/Paris (UTC+02:00)',
        value: 'Europe/Paris'
    },
    {
        label: 'Africa/Ceuta (UTC+02:00)',
        value: 'Africa/Ceuta'
    },
    {
        label: 'Europe/Prague (UTC+02:00)',
        value: 'Europe/Prague'
    },
    {
        label: 'Antarctica/Troll (UTC+02:00)',
        value: 'Antarctica/Troll'
    },
    {
        label: 'Africa/Gaborone (UTC+02:00)',
        value: 'Africa/Gaborone'
    },
    {
        label: 'Europe/Copenhagen (UTC+02:00)',
        value: 'Europe/Copenhagen'
    },
    {
        label: 'Europe/Vienna (UTC+02:00)',
        value: 'Europe/Vienna'
    },
    {
        label: 'Europe/Tirane (UTC+02:00)',
        value: 'Europe/Tirane'
    },
    {
        label: 'MET (UTC+02:00)',
        value: 'MET'
    },
    {
        label: 'Europe/Amsterdam (UTC+02:00)',
        value: 'Europe/Amsterdam'
    },
    {
        label: 'Africa/Maputo (UTC+02:00)',
        value: 'Africa/Maputo'
    },
    {
        label: 'Europe/San_Marino (UTC+02:00)',
        value: 'Europe/San_Marino'
    },
    {
        label: 'Poland (UTC+02:00)',
        value: 'Poland'
    },
    {
        label: 'Europe/Andorra (UTC+02:00)',
        value: 'Europe/Andorra'
    },
    {
        label: 'Europe/Oslo (UTC+02:00)',
        value: 'Europe/Oslo'
    },
    {
        label: 'Europe/Podgorica (UTC+02:00)',
        value: 'Europe/Podgorica'
    },
    {
        label: 'Africa/Bujumbura (UTC+02:00)',
        value: 'Africa/Bujumbura'
    },
    {
        label: 'Atlantic/Jan_Mayen (UTC+02:00)',
        value: 'Atlantic/Jan_Mayen'
    },
    {
        label: 'Africa/Maseru (UTC+02:00)',
        value: 'Africa/Maseru'
    },
    {
        label: 'Europe/Madrid (UTC+02:00)',
        value: 'Europe/Madrid'
    },
    {
        label: 'Africa/Blantyre (UTC+02:00)',
        value: 'Africa/Blantyre'
    },
    {
        label: 'Africa/Lusaka (UTC+02:00)',
        value: 'Africa/Lusaka'
    },
    {
        label: 'Africa/Harare (UTC+02:00)',
        value: 'Africa/Harare'
    },
    {
        label: 'Africa/Khartoum (UTC+02:00)',
        value: 'Africa/Khartoum'
    },
    {
        label: 'Africa/Johannesburg (UTC+02:00)',
        value: 'Africa/Johannesburg'
    },
    {
        label: 'Europe/Belgrade (UTC+02:00)',
        value: 'Europe/Belgrade'
    },
    {
        label: 'Europe/Bratislava (UTC+02:00)',
        value: 'Europe/Bratislava'
    },
    {
        label: 'Arctic/Longyearbyen (UTC+02:00)',
        value: 'Arctic/Longyearbyen'
    },
    {
        label: 'Egypt (UTC+02:00)',
        value: 'Egypt'
    },
    {
        label: 'Europe/Vatican (UTC+02:00)',
        value: 'Europe/Vatican'
    },
    {
        label: 'Europe/Monaco (UTC+02:00)',
        value: 'Europe/Monaco'
    },
    {
        label: 'Europe/London (UTC+01:00)',
        value: 'Europe/London'
    },
    {
        label: 'Etc/GMT-1 (UTC+01:00)',
        value: 'Etc/GMT-1'
    },
    {
        label: 'Europe/Jersey (UTC+01:00)',
        value: 'Europe/Jersey'
    },
    {
        label: 'Europe/Guernsey (UTC+01:00)',
        value: 'Europe/Guernsey'
    },
    {
        label: 'Europe/Isle_of_Man (UTC+01:00)',
        value: 'Europe/Isle_of_Man'
    },
    {
        label: 'Africa/Tunis (UTC+01:00)',
        value: 'Africa/Tunis'
    },
    {
        label: 'Africa/Malabo (UTC+01:00)',
        value: 'Africa/Malabo'
    },
    {
        label: 'GB-Eire (UTC+01:00)',
        value: 'GB-Eire'
    },
    {
        label: 'Africa/Lagos (UTC+01:00)',
        value: 'Africa/Lagos'
    },
    {
        label: 'Africa/Algiers (UTC+01:00)',
        value: 'Africa/Algiers'
    },
    {
        label: 'GB (UTC+01:00)',
        value: 'GB'
    },
    {
        label: 'Portugal (UTC+01:00)',
        value: 'Portugal'
    },
    {
        label: 'Africa/Sao_Tome (UTC+01:00)',
        value: 'Africa/Sao_Tome'
    },
    {
        label: 'Africa/Ndjamena (UTC+01:00)',
        value: 'Africa/Ndjamena'
    },
    {
        label: 'Atlantic/Faeroe (UTC+01:00)',
        value: 'Atlantic/Faeroe'
    },
    {
        label: 'Eire (UTC+01:00)',
        value: 'Eire'
    },
    {
        label: 'Atlantic/Faroe (UTC+01:00)',
        value: 'Atlantic/Faroe'
    },
    {
        label: 'Europe/Dublin (UTC+01:00)',
        value: 'Europe/Dublin'
    },
    {
        label: 'Africa/Libreville (UTC+01:00)',
        value: 'Africa/Libreville'
    },
    {
        label: 'Africa/El_Aaiun (UTC+01:00)',
        value: 'Africa/El_Aaiun'
    },
    {
        label: 'Africa/Douala (UTC+01:00)',
        value: 'Africa/Douala'
    },
    {
        label: 'Africa/Brazzaville (UTC+01:00)',
        value: 'Africa/Brazzaville'
    },
    {
        label: 'Africa/Porto-Novo (UTC+01:00)',
        value: 'Africa/Porto-Novo'
    },
    {
        label: 'Atlantic/Madeira (UTC+01:00)',
        value: 'Atlantic/Madeira'
    },
    {
        label: 'Europe/Lisbon (UTC+01:00)',
        value: 'Europe/Lisbon'
    },
    {
        label: 'Atlantic/Canary (UTC+01:00)',
        value: 'Atlantic/Canary'
    },
    {
        label: 'Africa/Casablanca (UTC+01:00)',
        value: 'Africa/Casablanca'
    },
    {
        label: 'Europe/Belfast (UTC+01:00)',
        value: 'Europe/Belfast'
    },
    {
        label: 'Africa/Luanda (UTC+01:00)',
        value: 'Africa/Luanda'
    },
    {
        label: 'Africa/Kinshasa (UTC+01:00)',
        value: 'Africa/Kinshasa'
    },
    {
        label: 'Africa/Bangui (UTC+01:00)',
        value: 'Africa/Bangui'
    },
    {
        label: 'WET (UTC+01:00)',
        value: 'WET'
    },
    {
        label: 'Africa/Niamey (UTC+01:00)',
        value: 'Africa/Niamey'
    },
    {
        label: 'GMT (UTC+00:00)',
        value: 'GMT'
    },
    {
        label: 'Etc/GMT-0 (UTC+00:00)',
        value: 'Etc/GMT-0'
    },
    {
        label: 'Atlantic/St_Helena (UTC+00:00)',
        value: 'Atlantic/St_Helena'
    },
    {
        label: 'Etc/GMT+0 (UTC+00:00)',
        value: 'Etc/GMT+0'
    },
    {
        label: 'Africa/Banjul (UTC+00:00)',
        value: 'Africa/Banjul'
    },
    {
        label: 'Etc/GMT (UTC+00:00)',
        value: 'Etc/GMT'
    },
    {
        label: 'Africa/Freetown (UTC+00:00)',
        value: 'Africa/Freetown'
    },
    {
        label: 'Africa/Bamako (UTC+00:00)',
        value: 'Africa/Bamako'
    },
    {
        label: 'Africa/Conakry (UTC+00:00)',
        value: 'Africa/Conakry'
    },
    {
        label: 'Universal (UTC+00:00)',
        value: 'Universal'
    },
    {
        label: 'Africa/Nouakchott (UTC+00:00)',
        value: 'Africa/Nouakchott'
    },
    {
        label: 'UTC (UTC+00:00)',
        value: 'UTC'
    },
    {
        label: 'Etc/Universal (UTC+00:00)',
        value: 'Etc/Universal'
    },
    {
        label: 'Atlantic/Azores (UTC+00:00)',
        value: 'Atlantic/Azores'
    },
    {
        label: 'Africa/Abidjan (UTC+00:00)',
        value: 'Africa/Abidjan'
    },
    {
        label: 'Africa/Accra (UTC+00:00)',
        value: 'Africa/Accra'
    },
    {
        label: 'Etc/UCT (UTC+00:00)',
        value: 'Etc/UCT'
    },
    {
        label: 'GMT0 (UTC+00:00)',
        value: 'GMT0'
    },
    {
        label: 'Zulu (UTC+00:00)',
        value: 'Zulu'
    },
    {
        label: 'Africa/Ouagadougou (UTC+00:00)',
        value: 'Africa/Ouagadougou'
    },
    {
        label: 'Atlantic/Reykjavik (UTC+00:00)',
        value: 'Atlantic/Reykjavik'
    },
    {
        label: 'Etc/Zulu (UTC+00:00)',
        value: 'Etc/Zulu'
    },
    {
        label: 'Iceland (UTC+00:00)',
        value: 'Iceland'
    },
    {
        label: 'Africa/Lome (UTC+00:00)',
        value: 'Africa/Lome'
    },
    {
        label: 'Greenwich (UTC+00:00)',
        value: 'Greenwich'
    },
    {
        label: 'Etc/GMT0 (UTC+00:00)',
        value: 'Etc/GMT0'
    },
    {
        label: 'America/Danmarkshavn (UTC+00:00)',
        value: 'America/Danmarkshavn'
    },
    {
        label: 'Africa/Dakar (UTC+00:00)',
        value: 'Africa/Dakar'
    },
    {
        label: 'America/Scoresbysund (UTC+00:00)',
        value: 'America/Scoresbysund'
    },
    {
        label: 'Africa/Bissau (UTC+00:00)',
        value: 'Africa/Bissau'
    },
    {
        label: 'Etc/Greenwich (UTC+00:00)',
        value: 'Etc/Greenwich'
    },
    {
        label: 'Africa/Timbuktu (UTC+00:00)',
        value: 'Africa/Timbuktu'
    },
    {
        label: 'UCT (UTC+00:00)',
        value: 'UCT'
    },
    {
        label: 'Africa/Monrovia (UTC+00:00)',
        value: 'Africa/Monrovia'
    },
    {
        label: 'Etc/UTC (UTC+00:00)',
        value: 'Etc/UTC'
    }
];

});

parcelRegister("dc4s1", function(module, exports) {

$parcel$export(module.exports, "INVALID_DATE", () => $3ef01ca309169d8e$export$3b8cfd9c1b194028);
$parcel$export(module.exports, "INVALID_DATETIME", () => $3ef01ca309169d8e$export$9956ac2cc7666063);
$parcel$export(module.exports, "INVALID_NUMBER", () => $3ef01ca309169d8e$export$64106e7de826a6ea);
$parcel$export(module.exports, "INVALID_USER_ID", () => $3ef01ca309169d8e$export$7f7df2bf49f036f7);
$parcel$export(module.exports, "INVALID_CASCADE_SELECT_FORMAT", () => $3ef01ca309169d8e$export$1a239b2d7d8be3b9);
$parcel$export(module.exports, "INVALID_COMMENT_FORMAT", () => $3ef01ca309169d8e$export$d9697145fab9f2c5);
$parcel$export(module.exports, "INVALID_WORKLOG_FORMAT", () => $3ef01ca309169d8e$export$cbcb6d11f3c8bd0a);
$parcel$export(module.exports, "EMPTY_SUMMARY", () => $3ef01ca309169d8e$export$454fcf2a39afa653);
$parcel$export(module.exports, "GENERIC_ERRORS", () => $3ef01ca309169d8e$export$c78a5999e0f349e0);
$parcel$export(module.exports, "INVALID_ISSUE_ID", () => $3ef01ca309169d8e$export$27f64a7126e8cce);
$parcel$export(module.exports, "DATE_ERROR_TYPES", () => $3ef01ca309169d8e$export$a75743627a6f76c9);
const $3ef01ca309169d8e$export$3b8cfd9c1b194028 = 'INVALID_DATE';
const $3ef01ca309169d8e$export$9956ac2cc7666063 = 'INVALID_DATETIME';
const $3ef01ca309169d8e$export$64106e7de826a6ea = 'INVALID_NUMBER';
const $3ef01ca309169d8e$export$7f7df2bf49f036f7 = 'INVALID_USER_ID';
const $3ef01ca309169d8e$export$1a239b2d7d8be3b9 = 'INVALID_CASCADE_SELECT_FORMAT';
const $3ef01ca309169d8e$export$d9697145fab9f2c5 = 'INVALID_COMMENT_FORMAT';
const $3ef01ca309169d8e$export$cbcb6d11f3c8bd0a = 'INVALID_WORKLOG_FORMAT';
const $3ef01ca309169d8e$export$454fcf2a39afa653 = 'EMPTY_SUMMARY';
const $3ef01ca309169d8e$export$c78a5999e0f349e0 = 'GENERIC_ERRORS';
const $3ef01ca309169d8e$export$27f64a7126e8cce = 'INVALID_ISSUE_ID';
const $3ef01ca309169d8e$export$a75743627a6f76c9 = new Set([
    $3ef01ca309169d8e$export$3b8cfd9c1b194028,
    $3ef01ca309169d8e$export$9956ac2cc7666063
]);

});

parcelRegister("agB2z", function(module, exports) {

$parcel$export(module.exports, "TEXT_FIELDTYPE", () => $e22b846f88d02522$export$bca21636762b3fb9);
$parcel$export(module.exports, "TEXT_AREA_FIELDTYPE", () => $e22b846f88d02522$export$1bfb7be4ccf43db0);
$parcel$export(module.exports, "DATE_PICKER_FIELDTYPE", () => $e22b846f88d02522$export$ba1f5b6a374f91e0);
$parcel$export(module.exports, "NUMBER_FIELDTYPE", () => $e22b846f88d02522$export$12de1aa96d9901c0);
$parcel$export(module.exports, "DATE_TIME_FIELDTYPE", () => $e22b846f88d02522$export$e98e1a642fc7f072);
$parcel$export(module.exports, "LABEL_FIELDTYPE", () => $e22b846f88d02522$export$39e294f64f10a701);
$parcel$export(module.exports, "SELECT_FIELDTYPE", () => $e22b846f88d02522$export$43bcf3129db95383);
$parcel$export(module.exports, "CASCADING_SELECT_FIELDTYPE", () => $e22b846f88d02522$export$a5832c4bcf480768);
$parcel$export(module.exports, "CHECKBOX_FIELDTYPE", () => $e22b846f88d02522$export$aef1a043ca706a64);
$parcel$export(module.exports, "USERPICKER_FIELDTYPE", () => $e22b846f88d02522$export$4cf998d66e3e3142);
$parcel$export(module.exports, "MULTI_USERPICKER_FIELDTYPE", () => $e22b846f88d02522$export$db720e50f1929282);
$parcel$export(module.exports, "MULTI_SELECT_FIELDTYPE", () => $e22b846f88d02522$export$7e846ff157fec849);
$parcel$export(module.exports, "RADIO_BUTTON_FIELDTYPE", () => $e22b846f88d02522$export$3e7888f5acb08f90);
$parcel$export(module.exports, "URL_FIELDTYPE", () => $e22b846f88d02522$export$2de3c1de4a4b21cf);
$parcel$export(module.exports, "ENVIRONMENT_FIELDTYPE", () => $e22b846f88d02522$export$9357b12877c62b5e);
$parcel$export(module.exports, "COMMENT_FIELDTYPE", () => $e22b846f88d02522$export$8171ea8302235096);
$parcel$export(module.exports, "STATUS_FIELDTYPE", () => $e22b846f88d02522$export$4a627db0e8738703);
$parcel$export(module.exports, "CATEGORY_FIELDTYPE", () => $e22b846f88d02522$export$d3259c5e4602dfad);
$parcel$export(module.exports, "EPIC_FIELDTYPE", () => $e22b846f88d02522$export$f207cad752d67147);
$parcel$export(module.exports, "REPORTER_FIELDTYPE", () => $e22b846f88d02522$export$66aed92b6ffed243);
$parcel$export(module.exports, "ASSIGNEE_FIELDTYPE", () => $e22b846f88d02522$export$11018c2b4c2eb836);
$parcel$export(module.exports, "ISSUETYPE_FIELDTYPE", () => $e22b846f88d02522$export$a45bd20a4bb9e9);
$parcel$export(module.exports, "CREATOR_FIELDTYPE", () => $e22b846f88d02522$export$319e85b601df8784);
$parcel$export(module.exports, "CREATED_FIELDTYPE", () => $e22b846f88d02522$export$306c2869680d206e);
$parcel$export(module.exports, "UPDATED_FIELDTYPE", () => $e22b846f88d02522$export$3f104c65bffff8c4);
$parcel$export(module.exports, "DESCRIPTION_FIELDTYPE", () => $e22b846f88d02522$export$d0de10c8625ea09d);
$parcel$export(module.exports, "PRIORITY_FIELDTYPE", () => $e22b846f88d02522$export$a3e8e6b0779f1491);
$parcel$export(module.exports, "DUEDATE_FIELDTYPE", () => $e22b846f88d02522$export$c4de17d170d60ba1);
$parcel$export(module.exports, "VOTES_FIELDTYPE", () => $e22b846f88d02522$export$abce7d30b6a1ddc4);
$parcel$export(module.exports, "TIME_SPENT_FIELDTYPE", () => $e22b846f88d02522$export$f72d140dae976d38);
$parcel$export(module.exports, "TIME_REMAINING_ESTIMATE_FIELDTYPE", () => $e22b846f88d02522$export$6509401c849a6ab6);
$parcel$export(module.exports, "TIME_ORIGINAL_ESTIMATE_FIELDTYPE", () => $e22b846f88d02522$export$2a1b4cb4b95f2cec);
$parcel$export(module.exports, "WORKLOG_FIELDTYPE", () => $e22b846f88d02522$export$2a18a76ba324bc8d);
$parcel$export(module.exports, "SYSTEM_LABELS_FIELDTYPE", () => $e22b846f88d02522$export$a0c32c4899268b38);
$parcel$export(module.exports, "WATCHERS_FIELDTYPE", () => $e22b846f88d02522$export$82ecc346760f76ed);
$parcel$export(module.exports, "PARENT_FIELDTYPE", () => $e22b846f88d02522$export$de3712a5333400e2);
$parcel$export(module.exports, "ISSUEID_FIELDTYPE", () => $e22b846f88d02522$export$e6d543ba097f731b);
$parcel$export(module.exports, "ISSUE_LINKS_FIELDTYPE", () => $e22b846f88d02522$export$2b501058c0f8de7b);
$parcel$export(module.exports, "supportedCustomFieldTypes", () => $e22b846f88d02522$export$b51df28ba3b8b682);
// Field Type Constants
const $e22b846f88d02522$export$bca21636762b3fb9 = 'com.atlassian.jira.plugin.system.customfieldtypes:textfield';
const $e22b846f88d02522$export$1bfb7be4ccf43db0 = 'com.atlassian.jira.plugin.system.customfieldtypes:textarea';
const $e22b846f88d02522$export$ba1f5b6a374f91e0 = 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker';
const $e22b846f88d02522$export$12de1aa96d9901c0 = 'com.atlassian.jira.plugin.system.customfieldtypes:float';
const $e22b846f88d02522$export$e98e1a642fc7f072 = 'com.atlassian.jira.plugin.system.customfieldtypes:datetime';
const $e22b846f88d02522$export$39e294f64f10a701 = 'com.atlassian.jira.plugin.system.customfieldtypes:labels';
const $e22b846f88d02522$export$43bcf3129db95383 = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
const $e22b846f88d02522$export$a5832c4bcf480768 = 'com.atlassian.jira.plugin.system.customfieldtypes:cascadingselect';
const $e22b846f88d02522$export$aef1a043ca706a64 = 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes';
const $e22b846f88d02522$export$4cf998d66e3e3142 = 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker';
const $e22b846f88d02522$export$db720e50f1929282 = 'com.atlassian.jira.plugin.system.customfieldtypes:multiuserpicker';
const $e22b846f88d02522$export$7e846ff157fec849 = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
const $e22b846f88d02522$export$3e7888f5acb08f90 = 'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons';
const $e22b846f88d02522$export$2de3c1de4a4b21cf = 'com.atlassian.jira.plugin.system.customfieldtypes:url';
const $e22b846f88d02522$export$1dfb417994688f0a = 'summary';
const $e22b846f88d02522$export$9357b12877c62b5e = 'environment';
const $e22b846f88d02522$export$8171ea8302235096 = 'comment';
const $e22b846f88d02522$export$4a627db0e8738703 = 'status';
const $e22b846f88d02522$export$d3259c5e4602dfad = 'com.atlassian.jira.plugin.system.customfieldtypes:jwm-category';
const $e22b846f88d02522$export$f207cad752d67147 = 'epic';
const $e22b846f88d02522$export$66aed92b6ffed243 = 'reporter';
const $e22b846f88d02522$export$11018c2b4c2eb836 = 'assignee';
const $e22b846f88d02522$export$a45bd20a4bb9e9 = 'issuetype';
const $e22b846f88d02522$export$319e85b601df8784 = 'creator';
const $e22b846f88d02522$export$306c2869680d206e = 'created';
const $e22b846f88d02522$export$3f104c65bffff8c4 = 'updated';
const $e22b846f88d02522$export$d0de10c8625ea09d = 'description';
const $e22b846f88d02522$export$a3e8e6b0779f1491 = 'priority';
const $e22b846f88d02522$export$c4de17d170d60ba1 = 'duedate';
const $e22b846f88d02522$export$e68364601ec228a3 = 'resolution';
const $e22b846f88d02522$export$abce7d30b6a1ddc4 = 'votes';
const $e22b846f88d02522$export$f72d140dae976d38 = 'timespent';
const $e22b846f88d02522$export$6509401c849a6ab6 = 'timeestimate';
const $e22b846f88d02522$export$2a1b4cb4b95f2cec = 'timeoriginalestimate';
const $e22b846f88d02522$export$2a18a76ba324bc8d = 'worklog';
const $e22b846f88d02522$export$a0c32c4899268b38 = 'labels';
const $e22b846f88d02522$export$82ecc346760f76ed = 'watches';
const $e22b846f88d02522$export$de3712a5333400e2 = 'parent';
const $e22b846f88d02522$export$e6d543ba097f731b = 'issueId';
const $e22b846f88d02522$export$2b501058c0f8de7b = 'issuelinks';
const $e22b846f88d02522$export$318984cdbacb0db0 = new Set([
    $e22b846f88d02522$export$11018c2b4c2eb836,
    $e22b846f88d02522$export$319e85b601df8784,
    $e22b846f88d02522$export$66aed92b6ffed243,
    $e22b846f88d02522$export$4cf998d66e3e3142,
    $e22b846f88d02522$export$db720e50f1929282
]);
const $e22b846f88d02522$export$b51df28ba3b8b682 = new Set([
    $e22b846f88d02522$export$bca21636762b3fb9,
    $e22b846f88d02522$export$1bfb7be4ccf43db0,
    $e22b846f88d02522$export$ba1f5b6a374f91e0,
    $e22b846f88d02522$export$12de1aa96d9901c0,
    $e22b846f88d02522$export$39e294f64f10a701,
    $e22b846f88d02522$export$43bcf3129db95383,
    $e22b846f88d02522$export$a5832c4bcf480768,
    $e22b846f88d02522$export$aef1a043ca706a64,
    $e22b846f88d02522$export$4cf998d66e3e3142,
    $e22b846f88d02522$export$db720e50f1929282,
    $e22b846f88d02522$export$e98e1a642fc7f072,
    $e22b846f88d02522$export$7e846ff157fec849,
    $e22b846f88d02522$export$3e7888f5acb08f90,
    $e22b846f88d02522$export$2de3c1de4a4b21cf
]);

});

parcelRegister("3ak5x", function(module, exports) {

$parcel$export(module.exports, "DEFAULT", () => $643888deed2b2db0$export$e6952b12ade67489);
$parcel$export(module.exports, "CSV", () => $643888deed2b2db0$export$cb65967a373a848f);
$parcel$export(module.exports, "JIRA_SOFTWARE", () => $643888deed2b2db0$export$ad9850d60736acbb);
$parcel$export(module.exports, "JIRA_BUSINESS", () => $643888deed2b2db0$export$6874fd70ad3b2f4c);
$parcel$export(module.exports, "TRELLO", () => $643888deed2b2db0$export$9c95d39d8f488b22);
$parcel$export(module.exports, "SHEETS", () => $643888deed2b2db0$export$38fac4657e6be5eb);
$parcel$export(module.exports, "EXCEL", () => $643888deed2b2db0$export$d4730c192350c1aa);
$parcel$export(module.exports, "MONDAY", () => $643888deed2b2db0$export$f553f4faf24ab170);
$parcel$export(module.exports, "ASANA", () => $643888deed2b2db0$export$22297259f5f3d478);
$parcel$export(module.exports, "CLICK_UP", () => $643888deed2b2db0$export$a09c7bd4552548d2);
$parcel$export(module.exports, "AIRTABLE", () => $643888deed2b2db0$export$29c9b4c7674e800a);
$parcel$export(module.exports, "SMART_SHEET", () => $643888deed2b2db0$export$4109491c0a23b7da);
$parcel$export(module.exports, "GITHUB", () => $643888deed2b2db0$export$8606c40cc696b7b);
$parcel$export(module.exports, "GITLAB", () => $643888deed2b2db0$export$b54ecf54ae9ea39e);
$parcel$export(module.exports, "LINEAR", () => $643888deed2b2db0$export$8244104593af74a6);
$parcel$export(module.exports, "AZURE_DEVOPS", () => $643888deed2b2db0$export$ba2e5304b31f1cda);
$parcel$export(module.exports, "NOTION", () => $643888deed2b2db0$export$8cfeda671ad86643);
$parcel$export(module.exports, "WRIKE", () => $643888deed2b2db0$export$ac9b6decaec0d9bd);
$parcel$export(module.exports, "JETBRAINS_YOUTRACK", () => $643888deed2b2db0$export$4d2341e0e2de12b8);
$parcel$export(module.exports, "JIRA_DISPLAY_NAME", () => $643888deed2b2db0$export$9e38048dae3edc37);
$parcel$export(module.exports, "TRELLO_DISPLAY_NAME", () => $643888deed2b2db0$export$56dedd69cb1a2c74);
$parcel$export(module.exports, "GOOGLE_SHEETS_DISPLAY_NAME", () => $643888deed2b2db0$export$cf2adf7bad641899);
$parcel$export(module.exports, "EXCEL_DISPLAY_NAME", () => $643888deed2b2db0$export$784c0e0faed94863);
$parcel$export(module.exports, "MONDAY_DISPLAY_NAME", () => $643888deed2b2db0$export$98920be74d6e47ba);
$parcel$export(module.exports, "ASANA_DISPLAY_NAME", () => $643888deed2b2db0$export$b576c545d8158ad2);
$parcel$export(module.exports, "CLICK_UP_DISPLAY_NAME", () => $643888deed2b2db0$export$73470753ce81531b);
$parcel$export(module.exports, "AIRTABLE_DISPLAY_NAME", () => $643888deed2b2db0$export$9536556d8952ff75);
$parcel$export(module.exports, "SMART_SHEET_DISPLAY_NAME", () => $643888deed2b2db0$export$f798a911fb394acb);
$parcel$export(module.exports, "GITHUB_DISPLAY_NAME", () => $643888deed2b2db0$export$5e0bcd649e019167);
$parcel$export(module.exports, "LINEAR_DISPLAY_NAME", () => $643888deed2b2db0$export$5a9f56219d3fc074);
$parcel$export(module.exports, "GITLAB_DISPLAY_NAME", () => $643888deed2b2db0$export$50abda23fe91fb5d);
$parcel$export(module.exports, "AZURE_DEVOPS_DISPLAY_NAME", () => $643888deed2b2db0$export$8e9bb6aa45de13a4);
$parcel$export(module.exports, "NOTION_DISPLAY_NAME", () => $643888deed2b2db0$export$9e710923301e5b35);
$parcel$export(module.exports, "WRIKE_DISPLAY_NAME", () => $643888deed2b2db0$export$aee9233f829f68bf);
$parcel$export(module.exports, "JETBRAINS_YOUTRACK_DISPLAY_NAME", () => $643888deed2b2db0$export$31417737d8a9be01);
$parcel$export(module.exports, "SITE_ADMIN", () => $643888deed2b2db0$export$a0ca02a3173d01c8);
$parcel$export(module.exports, "CREATE_PROJECT", () => $643888deed2b2db0$export$76d59f24748e8a2d);
$parcel$export(module.exports, "SupportedThirdParties", () => $643888deed2b2db0$export$9498511f45a8b438);
$parcel$export(module.exports, "supportedImportTypesFromQueryParam", () => $643888deed2b2db0$export$d4150c945c26ce30);
$parcel$export(module.exports, "SourceItemKeys", () => $643888deed2b2db0$export$1d516d012a41e637);
const $643888deed2b2db0$export$e6952b12ade67489 = 'default';
const $643888deed2b2db0$export$cb65967a373a848f = 'CSV';
const $643888deed2b2db0$export$ad9850d60736acbb = 'jiraSoftware';
const $643888deed2b2db0$export$6874fd70ad3b2f4c = 'jiraBusiness';
const $643888deed2b2db0$export$9c95d39d8f488b22 = 'Trello';
const $643888deed2b2db0$export$38fac4657e6be5eb = 'Sheets';
const $643888deed2b2db0$export$d4730c192350c1aa = 'Excel';
const $643888deed2b2db0$export$f553f4faf24ab170 = 'monday';
const $643888deed2b2db0$export$22297259f5f3d478 = 'Asana';
const $643888deed2b2db0$export$a09c7bd4552548d2 = 'ClickUp';
const $643888deed2b2db0$export$29c9b4c7674e800a = 'Airtable';
const $643888deed2b2db0$export$4109491c0a23b7da = 'Smartsheet';
const $643888deed2b2db0$export$8606c40cc696b7b = 'GitHub';
const $643888deed2b2db0$export$b54ecf54ae9ea39e = 'GitLab';
const $643888deed2b2db0$export$8244104593af74a6 = 'Linear';
const $643888deed2b2db0$export$ba2e5304b31f1cda = 'Azure Devops';
const $643888deed2b2db0$export$8cfeda671ad86643 = 'Notion';
const $643888deed2b2db0$export$ac9b6decaec0d9bd = 'Wrike';
const $643888deed2b2db0$export$4d2341e0e2de12b8 = 'Jetbrains YouTrack';
const $643888deed2b2db0$export$9e38048dae3edc37 = 'Jira';
const $643888deed2b2db0$export$56dedd69cb1a2c74 = 'Trello';
const $643888deed2b2db0$export$cf2adf7bad641899 = 'Sheets';
const $643888deed2b2db0$export$784c0e0faed94863 = 'Excel';
const $643888deed2b2db0$export$98920be74d6e47ba = 'monday';
const $643888deed2b2db0$export$b576c545d8158ad2 = 'Asana';
const $643888deed2b2db0$export$73470753ce81531b = 'ClickUp';
const $643888deed2b2db0$export$9536556d8952ff75 = 'Airtable';
const $643888deed2b2db0$export$f798a911fb394acb = 'Smartsheet';
const $643888deed2b2db0$export$5e0bcd649e019167 = 'GitHub';
const $643888deed2b2db0$export$5a9f56219d3fc074 = 'Linear';
const $643888deed2b2db0$export$50abda23fe91fb5d = 'GitLab';
const $643888deed2b2db0$export$8e9bb6aa45de13a4 = 'Azure DevOps';
const $643888deed2b2db0$export$9e710923301e5b35 = 'Notion';
const $643888deed2b2db0$export$aee9233f829f68bf = 'Wrike';
const $643888deed2b2db0$export$31417737d8a9be01 = 'Jetbrains YouTrack';
const $643888deed2b2db0$export$a0ca02a3173d01c8 = 'SITE_ADMIN';
const $643888deed2b2db0$export$76d59f24748e8a2d = 'CREATE_PROJECT';
const $643888deed2b2db0$export$9498511f45a8b438 = new Set([
    $643888deed2b2db0$export$9c95d39d8f488b22,
    $643888deed2b2db0$export$22297259f5f3d478,
    $643888deed2b2db0$export$f553f4faf24ab170,
    $643888deed2b2db0$export$ad9850d60736acbb,
    $643888deed2b2db0$export$a09c7bd4552548d2
]);
const $643888deed2b2db0$export$d4150c945c26ce30 = new Set([
    $643888deed2b2db0$export$e6952b12ade67489,
    $643888deed2b2db0$export$9c95d39d8f488b22
]);
const $643888deed2b2db0$export$1d516d012a41e637 = new Set([
    $643888deed2b2db0$export$cb65967a373a848f,
    $643888deed2b2db0$export$9c95d39d8f488b22,
    $643888deed2b2db0$export$ad9850d60736acbb,
    $643888deed2b2db0$export$38fac4657e6be5eb,
    $643888deed2b2db0$export$d4730c192350c1aa,
    $643888deed2b2db0$export$f553f4faf24ab170,
    $643888deed2b2db0$export$22297259f5f3d478,
    $643888deed2b2db0$export$a09c7bd4552548d2,
    $643888deed2b2db0$export$29c9b4c7674e800a,
    $643888deed2b2db0$export$4109491c0a23b7da,
    $643888deed2b2db0$export$8606c40cc696b7b,
    $643888deed2b2db0$export$8244104593af74a6,
    $643888deed2b2db0$export$b54ecf54ae9ea39e,
    $643888deed2b2db0$export$ba2e5304b31f1cda,
    $643888deed2b2db0$export$8cfeda671ad86643,
    $643888deed2b2db0$export$ac9b6decaec0d9bd,
    $643888deed2b2db0$export$4d2341e0e2de12b8
]);

});

parcelRegister("9R4E5", function(module, exports) {

$parcel$export(module.exports, "ProjectStyles", () => $88627373f078f4ba$export$13d53f9fd546f3cd);
$parcel$export(module.exports, "PROJECT_NAME_START_LIMIT", () => $88627373f078f4ba$export$546be9b00151bbcf);
$parcel$export(module.exports, "PROJECT_NAME_END_LIMIT", () => $88627373f078f4ba$export$78d2a0d93d5b6932);
$parcel$export(module.exports, "ProjectTypes", () => $88627373f078f4ba$export$35d2da3dc9db8e13);
$parcel$export(module.exports, "TemplateTypes", () => $88627373f078f4ba$export$9d02fd444a495ef9);
$parcel$export(module.exports, "PROJECT_KEY_LEARN_MORE_LINK", () => $88627373f078f4ba$export$5ee464f4a1c6b8c8);

var $7ZZxN = parcelRequire("7ZZxN");

var $7ZZxN = parcelRequire("7ZZxN");
const $88627373f078f4ba$export$13d53f9fd546f3cd = {
    COMPANY_MANAGED_PROJECT: $7ZZxN.COMPANY_MANAGED_PROJECT,
    TEAM_MANAGED_PROJECT: $7ZZxN.TEAM_MANAGED_PROJECT
};
const $88627373f078f4ba$export$546be9b00151bbcf = 2;
const $88627373f078f4ba$export$78d2a0d93d5b6932 = 80;
const $88627373f078f4ba$export$35d2da3dc9db8e13 = {
    BUSINESS: (0, $7ZZxN.CORE_PROJECT),
    SOFTWARE: (0, $7ZZxN.SOFTWARE_PROJECT),
    SERVICE_DESK: (0, $7ZZxN.SERVICE_DESK_PROJECT)
};
const $88627373f078f4ba$export$9d02fd444a495ef9 = {
    SCRUM: 'jsw.scrum',
    KANBAN: 'jsw.kanban'
};
const $88627373f078f4ba$export$5ee464f4a1c6b8c8 = 'https://support.atlassian.com/jira-core-cloud/docs/work-with-issues-in-jira-cloud/#Workingwithissues-Projectkeys';

});

parcelRegister("9HsT0", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_DATE_FORMAT", () => $3ddc3993d4e27469$export$70f1a05ef05bbe0e);
$parcel$export(module.exports, "DEFAULT_LOCALE", () => $3ddc3993d4e27469$export$1af4c7e47ad72f44);
$parcel$export(module.exports, "DEFAULT_TIMEZONE", () => $3ddc3993d4e27469$export$3d6925841111ef4c);
$parcel$export(module.exports, "INITIAL_STATE", () => $3ddc3993d4e27469$export$36d128238e6b60f5);
$parcel$export(module.exports, "INITIAL_UI_STATE", () => $3ddc3993d4e27469$export$bbb7ebe5667ee8fa);

var $eI5EY = parcelRequire("eI5EY");

var $PVrB2 = parcelRequire("PVrB2");

var $bGKgW = parcelRequire("bGKgW");

var $3ak5x = parcelRequire("3ak5x");

var $9R4E5 = parcelRequire("9R4E5");


var $1pm5p = parcelRequire("1pm5p");
const $3ddc3993d4e27469$export$70f1a05ef05bbe0e = 'dd/MMM/yy h:mm a';
const $3ddc3993d4e27469$export$1af4c7e47ad72f44 = (0, $bGKgW.LOCALES)[0];
const $3ddc3993d4e27469$export$3d6925841111ef4c = (0, $bGKgW.TIMEZONES)[(0, $bGKgW.TIMEZONES).length - 1];
const $3ddc3993d4e27469$var$getInitialState = ()=>({
        sourceItems: null,
        importType: (0, $3ak5x.DEFAULT),
        step: (0, $eI5EY.fg)('enable-x2c-standardised-flow') ? (0, $1pm5p.SELECT_SOURCE_STEP) : (0, $1pm5p.SELECT_PRODUCT_STEP),
        mappingState: null,
        migrationId: null,
        uploadedFileName: null,
        advancedOptions: {
            dateFormat: $3ddc3993d4e27469$export$70f1a05ef05bbe0e,
            fileEncoding: 'UTF-8',
            delimiter: ',',
            timeZoneOption: $3ddc3993d4e27469$export$3d6925841111ef4c,
            localeOption: $3ddc3993d4e27469$export$1af4c7e47ad72f44
        },
        projectData: {
            name: '',
            key: '',
            type: (0, $eI5EY.fg)('enable-x2c-standardised-flow') ? null : (0, $9R4E5.ProjectTypes).BUSINESS,
            style: null,
            accessLevel: undefined,
            template: undefined
        },
        thirdPartyState: {
            workspaces: null,
            spaces: null,
            folders: null,
            subfolders: null,
            entities: null,
            entityStats: null,
            selectedEntities: null,
            selectedEntityId: null,
            selectedEntityName: null,
            selectedEntityStyle: null,
            selectedWorkspaceId: null,
            selectedSpaceId: null,
            selectedSpaceName: null,
            selectedFolderId: null,
            selectedSubfolderId: null,
            siteName: null,
            members: null,
            userEmails: {},
            thirdPartyFieldConfigState: null,
            thirdPartyImportSettings: {
                shouldImportAttachments: true,
                shouldImportComments: true,
                shouldImportUsers: true
            },
            thirdPartyStatusMapping: null
        },
        source: (0, $85ba070c29b4a3bd$export$92cbbf5cba2bea96)
    });
const $3ddc3993d4e27469$export$36d128238e6b60f5 = $3ddc3993d4e27469$var$getInitialState();
const $3ddc3993d4e27469$export$bbb7ebe5667ee8fa = {
    hasUnsavedFieldMappingChanges: false,
    hasUnsavedHierarchyMappingChanges: false,
    hasUnsavedStatusMappingChanges: false,
    cancelModal: {
        isCancelImportModalOpen: false,
        shouldCloseDrawerOnCancel: true
    },
    accessTokenModal: {
        isModalOpen: false,
        modalType: (0, $PVrB2.AccessTokenModalType).ADD_NEW_TOKEN
    }
};

});
parcelRegister("PVrB2", function(module, exports) {

$parcel$export(module.exports, "AccessTokenModalType", () => $85a03b165e1cd31d$export$bbaa581b8c3bde3a);
const $85a03b165e1cd31d$export$bbaa581b8c3bde3a = {
    ADD_NEW_TOKEN: 'addNewToken',
    EDIT_TOKEN: 'editToken',
    EXPIRED_TOKEN: 'expiredToken'
};
const $85a03b165e1cd31d$export$3c4f0bb2775d2670 = 'VALID';
const $85a03b165e1cd31d$export$ce57b468109fbc3 = 'EXPIRING';
const $85a03b165e1cd31d$export$bbb5bd7b048fb0e4 = 'NOT_FOUND';

});

const $85ba070c29b4a3bd$export$44f7961a4c8dc451 = 'CROSS_FLOW';
const $85ba070c29b4a3bd$export$92cbbf5cba2bea96 = 'PROJECT_CREATE';
const $85ba070c29b4a3bd$export$ec4d35718915f521 = 'EXISTING_PROJECT';

parcelRegister("1pm5p", function(module, exports) {

$parcel$export(module.exports, "SELECT_PRODUCT_STEP", () => $889452e6fd358320$export$c7df060d12482ca6);
$parcel$export(module.exports, "SELECT_SOURCE_STEP", () => $889452e6fd358320$export$9197136254f6da12);
$parcel$export(module.exports, "UPLOAD_CSV_STEP", () => $889452e6fd358320$export$9f5c89225643cc8a);
$parcel$export(module.exports, "MAPPING_STEP", () => $889452e6fd358320$export$539be22a75f02fa6);
$parcel$export(module.exports, "THIRD_PARTY_REVIEW_STEP", () => $889452e6fd358320$export$18341d10641814dc);
$parcel$export(module.exports, "PROJECT_CREATE_STEP", () => $889452e6fd358320$export$a0a3413b4eee7be6);
$parcel$export(module.exports, "IMPORT_IN_PROGRESS_STEP", () => $889452e6fd358320$export$a2bebc33ede05635);
$parcel$export(module.exports, "SELECT_THIRD_PARTY_ENTITY_STEP", () => $889452e6fd358320$export$51012e68a9ae2ca1);
$parcel$export(module.exports, "USER_MAPPING_STEP", () => $889452e6fd358320$export$92f12b38a88a743a);
$parcel$export(module.exports, "CSV_USER_MAPPING_STEP", () => $889452e6fd358320$export$e0f0113072b9ca1d);
$parcel$export(module.exports, "UPLOAD_CSV_STANDARD_STEP", () => $889452e6fd358320$export$16372020989219a5);
$parcel$export(module.exports, "REVIEW_SCREEN_STANDARD_STEP", () => $889452e6fd358320$export$4e1c4418734a8db3);
$parcel$export(module.exports, "ReviewTilesType", () => $889452e6fd358320$export$3984cd9d61c27ee0);
$parcel$export(module.exports, "CSVReviewTilesType", () => $889452e6fd358320$export$ec5fcbda14afcbd9);
$parcel$export(module.exports, "StatisticsType", () => $889452e6fd358320$export$78c90a3e8a572a77);
$parcel$export(module.exports, "DEFAULT_CONFIG", () => $889452e6fd358320$export$c2f8e0cc249a8d8f);
$parcel$export(module.exports, "templatesJSW", () => $889452e6fd358320$export$cb40be2a8ae94bf9);

var $eUqFw = parcelRequire("eUqFw");

var $28ybo = parcelRequire("28ybo");

var $gk7tF = parcelRequire("gk7tF");

var $6TNEm = parcelRequire("6TNEm");

var $kE7Zg = parcelRequire("kE7Zg");

var $9R4E5 = parcelRequire("9R4E5");

var $gQNqE = parcelRequire("gQNqE");
const $889452e6fd358320$export$c7df060d12482ca6 = 'SELECT_PRODUCT_STEP';
const $889452e6fd358320$export$9197136254f6da12 = 'SELECT_SOURCE_STEP';
const $889452e6fd358320$export$9f5c89225643cc8a = 'UPLOAD_CSV_STEP';
const $889452e6fd358320$export$539be22a75f02fa6 = 'MAPPING_STEP';
const $889452e6fd358320$export$18341d10641814dc = 'THIRD_PARTY_REVIEW_STEP';
const $889452e6fd358320$export$a0a3413b4eee7be6 = 'PROJECT_CREATE_STEP';
const $889452e6fd358320$export$a2bebc33ede05635 = 'IMPORT_IN_PROGRESS_STEP';
const $889452e6fd358320$export$51012e68a9ae2ca1 = 'SELECT_THIRD_PARTY_ENTITY_STEP';
const $889452e6fd358320$export$92f12b38a88a743a = 'USER_MAPPING_STEP';
const $889452e6fd358320$export$e0f0113072b9ca1d = 'CSV_USER_MAPPING_STEP';
const $889452e6fd358320$export$16372020989219a5 = 'UPLOAD_CSV_STANDARD_STEP';
const $889452e6fd358320$export$4e1c4418734a8db3 = 'REVIEW_SCREEN_STANDARD_STEP';
const $889452e6fd358320$export$3984cd9d61c27ee0 = {
    FIELDS: 'FIELDS',
    ATTACHMENTS: 'ATTACHMENTS',
    HIERARCHY: 'HIERARCHY',
    USERS: 'USERS',
    COMMENTS: 'COMMENTS',
    STATUS: 'STATUS'
};
const $889452e6fd358320$export$ec5fcbda14afcbd9 = {
    PROJECT_DETAILS: 'PROJECT_DETAILS',
    FIELDS: 'FIELDS',
    USERS: 'USERS',
    ISSUES: 'ISSUES'
};
const $889452e6fd358320$export$78c90a3e8a572a77 = {
    TASKS: 'TASKS',
    MEMBERS: 'MEMBERS'
};
const $889452e6fd358320$export$c2f8e0cc249a8d8f = {
    overrides: {},
    stepProps: {}
};
const $889452e6fd358320$export$cb40be2a8ae94bf9 = [
    {
        key: (0, $9R4E5.TemplateTypes).KANBAN,
        title: (0, $gQNqE.default).kanbanTemplateTitle,
        description: (0, $gQNqE.default).kanbanTemplateDescription,
        iconUrl: (0, (/*@__PURE__*/$parcel$interopDefault($6TNEm))),
        isDefault: true,
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($28ybo))), {
            label: "Kanban"
        })
    },
    {
        key: (0, $9R4E5.TemplateTypes).SCRUM,
        title: (0, $gQNqE.default).scrumTemplateTitle,
        description: (0, $gQNqE.default).scrumTemplateDescription,
        iconUrl: (0, (/*@__PURE__*/$parcel$interopDefault($kE7Zg))),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gk7tF))), {
            label: "Scrum"
        })
    }
];

});
parcelRegister("28ybo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $18e6d81a18ae6069$var$_react = $18e6d81a18ae6069$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $18e6d81a18ae6069$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $18e6d81a18ae6069$var$BoardIcon = (props)=>/*#__PURE__*/ $18e6d81a18ae6069$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor"><path d="M4 18h16.008C20 18 20 6 20 6H3.992C4 6 4 18 4 18zM2 5.994C2 4.893 2.898 4 3.99 4h16.02C21.108 4 22 4.895 22 5.994v12.012A1.997 1.997 0 0120.01 20H3.99A1.994 1.994 0 012 18.006V5.994z"/><path d="M8 6v12h2V6zm6 0v12h2V6z"/></g></svg>`
    }, props));
$18e6d81a18ae6069$var$BoardIcon.displayName = 'BoardIcon';
var $18e6d81a18ae6069$var$_default = $18e6d81a18ae6069$var$BoardIcon;
module.exports.default = $18e6d81a18ae6069$var$_default;

});

parcelRegister("gk7tF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $be245075b7e5aee7$var$_react = $be245075b7e5aee7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $be245075b7e5aee7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $be245075b7e5aee7$var$SprintIcon = (props)=>/*#__PURE__*/ $be245075b7e5aee7$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M17.717 17.137l-1.436-1.438a1.003 1.003 0 011.418-1.418l3.007 3.01a1.002 1.002 0 010 1.417l-3.007 3.01a1.003 1.003 0 01-1.417-1.42l1.3-1.3-6.072-.003A8 8 0 014 11.01C4 6.587 7.582 3 12 3s8 3.587 8 8.01a7.982 7.982 0 01-.789 3.451l-1.438-1.44a6.11 6.11 0 00.345-2.01A6.121 6.121 0 0012 4.884a6.121 6.121 0 00-6.118 6.125 6.119 6.119 0 005.647 6.102l6.188.025zm-12.163-.119c.561.759 1.456 1.49 2.457 1.981L3.937 19C3.42 19 3 18.552 3 18s.42-1 .937-1l1.614.005.003.013z" fill="currentColor"/></svg>`
    }, props));
$be245075b7e5aee7$var$SprintIcon.displayName = 'SprintIcon';
var $be245075b7e5aee7$var$_default = $be245075b7e5aee7$var$SprintIcon;
module.exports.default = $be245075b7e5aee7$var$_default;

});

parcelRegister("6TNEm", function(module, exports) {
module.exports = new URL("Kanban.8d42db93.svg", import.meta.url).toString();

});

parcelRegister("kE7Zg", function(module, exports) {
module.exports = new URL("Scrum.5153fd82.svg", import.meta.url).toString();

});

parcelRegister("gQNqE", function(module, exports) {

$parcel$export(module.exports, "default", () => $df4735287b40e92a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $df4735287b40e92a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    scrumTemplateTitle: {
        "id": "project-create-importer-upload-flow.common.constants.steps.scrum-template-title",
        "defaultMessage": "Scrum"
    },
    scrumTemplateDescription: {
        "id": "project-create-importer-upload-flow.common.constants.steps.scrum-template-description",
        "defaultMessage": "Sprint toward your project goals with a board, backlog, and timeline."
    },
    kanbanTemplateTitle: {
        "id": "project-create-importer-upload-flow.common.constants.steps.kanban-template-title",
        "defaultMessage": "Kanban"
    },
    kanbanTemplateDescription: {
        "id": "project-create-importer-upload-flow.common.constants.steps.kanban-template-description",
        "defaultMessage": "Visualise and advance your project forward using issues on a powerful board."
    }
});

});



parcelRegister("l2OLr", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccdfe8e8d6471bb3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ccdfe8e8d6471bb3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    invalidDate: {
        "id": "project-create-importer-upload-flow.common.utils.invalid-date",
        "defaultMessage": "Format for this date field is invalid"
    },
    invalidNumber: {
        "id": "project-create-importer-upload-flow.common.utils.invalid-number",
        "defaultMessage": "Format for this field is invalid. Values for this field must be numerical"
    },
    invalidDateTime: {
        "id": "project-create-importer-upload-flow.common.utils.invalid-date-time",
        "defaultMessage": "Format for this date time field is invalid"
    },
    emptySummary: {
        "id": "project-create-importer-upload-flow.common.utils.empty-summary",
        "defaultMessage": "Summary field is empty. Make sure the summary is not left empty as it's a required field"
    },
    invalidUserId: {
        "id": "project-create-importer-upload-flow.common.utils.invalid-user-id",
        "defaultMessage": "Use an email address when importing people into your project as approvers, assignees, reporters."
    },
    invalidCascadingSelectFormat: {
        "id": "project-create-importer-upload-flow.common.utils.invalid-cascading-select-format",
        "defaultMessage": "Format for this field is invalid. Try parentValue -> childValue to continue."
    },
    invalidCommentFormat: {
        "id": "project-create-importer-upload-flow.common.utils.invalid-comment-format",
        "defaultMessage": "Format for this field is invalid. Try date-time;author;body to continue."
    },
    invalidWorkLogFormatWithLink: {
        "id": "project-create-importer-upload-flow.common.utils.invalid-work-log-format-with-link",
        "defaultMessage": "Format for this field is invalid. {link}"
    },
    invalidWorkLogFormatWithoutLink: {
        "id": "project-create-importer-upload-flow.common.utils.invalid-work-log-format-without-link",
        "defaultMessage": "Format for this field is invalid."
    },
    invalidWorkLogFormatLinkText: {
        "id": "project-create-importer-upload-flow.common.utils.invalid-work-log-format-link-text",
        "defaultMessage": "Learn more about mapping fields."
    },
    genericErrors: {
        "id": "project-create-importer-upload-flow.common.utils.generic-errors",
        "defaultMessage": "Data for this field is invalid"
    },
    trelloHeading: {
        "id": "project-create-importer-upload-flow.common.utils.trello-heading",
        "defaultMessage": "Select your Trello board"
    },
    trelloDescription: {
        "id": "project-create-importer-upload-flow.common.utils.trello-description",
        "defaultMessage": "Select the workspace and board you\u2019d like to import data from."
    },
    trelloWorkspacesSelectorLabel: {
        "id": "project-create-importer-upload-flow.common.utils.trello-workspaces-selector-label",
        "defaultMessage": "Trello workspace"
    },
    trelloWorkspacesSelectorPlaceholder: {
        "id": "project-create-importer-upload-flow.common.utils.trello-workspaces-selector-placeholder",
        "defaultMessage": "Select Trello workspace"
    },
    trelloBoardsSelectorLabel: {
        "id": "project-create-importer-upload-flow.common.utils.trello-boards-selector-label",
        "defaultMessage": "Trello board"
    },
    trelloBoardsSelectorPlaceholder: {
        "id": "project-create-importer-upload-flow.common.utils.trello-boards-selector-placeholder",
        "defaultMessage": "Select Trello board"
    },
    trelloStarredWorkspacesLabel: {
        "id": "project-create-importer-upload-flow.common.utils.trello-starred-workspaces-label",
        "defaultMessage": "Starred workspaces"
    },
    trelloOtherWorkspacesLabel: {
        "id": "project-create-importer-upload-flow.common.utils.trello-other-workspaces-label",
        "defaultMessage": "All workspaces"
    },
    trelloStarredBoardsLabel: {
        "id": "project-create-importer-upload-flow.common.utils.trello-starred-boards-label",
        "defaultMessage": "Starred boards"
    },
    trelloOtherBoardsLabel: {
        "id": "project-create-importer-upload-flow.common.utils.trello-other-boards-label",
        "defaultMessage": "All boards"
    },
    trelloStatsHeading: {
        "id": "project-create-importer-upload-flow.common.utils.trello-stats-heading",
        "defaultMessage": "About this Board"
    },
    trelloImportStep1Description: {
        "id": "project-create-importer-upload-flow.common.utils.trello-import-step-1-description",
        "defaultMessage": "Importing your Trello board data"
    },
    trelloNoWorkspacesFoundHeader: {
        "id": "project-create-importer-upload-flow.common.utils.trello-no-workspaces-found-header",
        "defaultMessage": "No workspaces found"
    },
    trelloNoWorkspacesFoundDescription: {
        "id": "project-create-importer-upload-flow.common.utils.trello-no-workspaces-found-description",
        "defaultMessage": "There are no workspaces linked to your account."
    },
    trelloErrorOccurredFetchingWorkspacesHeader: {
        "id": "project-create-importer-upload-flow.common.utils.trello-error-occurred-fetching-workspaces-header",
        "defaultMessage": "We couldn\u2019t load your workspaces"
    },
    trelloNoEntitiesFoundHeader: {
        "id": "project-create-importer-upload-flow.common.utils.trello-no-entities-found-header",
        "defaultMessage": "No boards found"
    },
    trelloNoEntitiesFoundDescription: {
        "id": "project-create-importer-upload-flow.common.utils.trello-no-entities-found-description",
        "defaultMessage": "Try selecting another workspace."
    },
    trelloErrorOccurredFetchingEntitiesHeader: {
        "id": "project-create-importer-upload-flow.common.utils.trello-error-occurred-fetching-entities-header",
        "defaultMessage": "We couldn't load your boards"
    },
    trelloNoAccountErrorHeader: {
        "id": "project-create-importer-upload-flow.common.utils.trello-no-account-error-header",
        "defaultMessage": "We couldn't find your Trello account"
    },
    asanaHeading: {
        "id": "project-create-importer-upload-flow.common.utils.asana-heading",
        "defaultMessage": "Select an Asana project"
    },
    asanaDescription: {
        "id": "project-create-importer-upload-flow.common.utils.asana-description",
        "defaultMessage": "Select the workspace and project you\u2019d like to import data from."
    },
    asanaWorkspacesSelectorLabel: {
        "id": "project-create-importer-upload-flow.common.utils.asana-workspaces-selector-label",
        "defaultMessage": "Asana workspace"
    },
    asanaWorkspacesSelectorPlaceholder: {
        "id": "project-create-importer-upload-flow.common.utils.asana-workspaces-selector-placeholder",
        "defaultMessage": "Select an Asana workspace"
    },
    asanaProjectsSelectorLabel: {
        "id": "project-create-importer-upload-flow.common.utils.asana-projects-selector-label",
        "defaultMessage": "Asana project"
    },
    asanaProjectsSelectorPlaceholder: {
        "id": "project-create-importer-upload-flow.common.utils.asana-projects-selector-placeholder",
        "defaultMessage": "Select an Asana project"
    },
    asanaStarredWorkspacesLabel: {
        "id": "project-create-importer-upload-flow.common.utils.asana-starred-workspaces-label",
        "defaultMessage": "Starred workspaces"
    },
    asanaOtherWorkspacesLabel: {
        "id": "project-create-importer-upload-flow.common.utils.asana-other-workspaces-label",
        "defaultMessage": "All workspaces"
    },
    asanaStarredProjectsLabel: {
        "id": "project-create-importer-upload-flow.common.utils.asana-starred-projects-label",
        "defaultMessage": "Starred projects"
    },
    asanaOtherProjectsLabel: {
        "id": "project-create-importer-upload-flow.common.utils.asana-other-projects-label",
        "defaultMessage": "All projects"
    },
    asanaStatsHeading: {
        "id": "project-create-importer-upload-flow.common.utils.asana-stats-heading",
        "defaultMessage": "About the Asana project"
    },
    asanaImportStep1Description: {
        "id": "project-create-importer-upload-flow.common.utils.asana-import-step-1-description",
        "defaultMessage": "Importing Asana project data"
    },
    asanaNoWorkspacesFoundHeader: {
        "id": "project-create-importer-upload-flow.common.utils.asana-no-workspaces-found-header",
        "defaultMessage": "No workspaces found"
    },
    asanaNoWorkspacesFoundDescription: {
        "id": "project-create-importer-upload-flow.common.utils.asana-no-workspaces-found-description",
        "defaultMessage": "There are no workspaces linked to your account."
    },
    asanaErrorOccurredFetchingWorkspacesHeader: {
        "id": "project-create-importer-upload-flow.common.utils.asana-error-occurred-fetching-workspaces-header",
        "defaultMessage": "We couldn't load your workspaces"
    },
    asanaNoEntitiesFoundHeader: {
        "id": "project-create-importer-upload-flow.common.utils.asana-no-entities-found-header",
        "defaultMessage": "No projects found"
    },
    asanaNoEntitiesFoundDescription: {
        "id": "project-create-importer-upload-flow.common.utils.asana-no-entities-found-description",
        "defaultMessage": "Try selecting another workspace."
    },
    asanaErrorOccurredFetchingEntitiesHeader: {
        "id": "project-create-importer-upload-flow.common.utils.asana-error-occurred-fetching-entities-header",
        "defaultMessage": "We couldn't load your projects"
    },
    asanaSearchEntitiesErrorOccurredDescription: {
        "id": "project-create-importer-upload-flow.common.utils.asana-search-entities-error-occurred-description",
        "defaultMessage": "We couldn't search for your projects. Try entering the project name once again."
    },
    asanaLoadingMoreEntitiesErrorOccurredDescription: {
        "id": "project-create-importer-upload-flow.common.utils.asana-loading-more-entities-error-occurred-description",
        "defaultMessage": "We couldn't load your projects."
    },
    asanaNoAccountErrorHeader: {
        "id": "project-create-importer-upload-flow.common.utils.asana-no-account-error-header",
        "defaultMessage": "We couldn't find your Asana account"
    },
    asanaReviewScreenDescriptionSpork: {
        "id": "project-create-importer-upload-flow.common.utils.asana-review-screen-description-spork",
        "defaultMessage": "We've mapped your project and you're ready to import. Here\u2019s how the Asana data will be imported into the Jira project. <link>Learn more about the project setup</link>"
    },
    asanaFieldsTileLoadingDescriptionSpork: {
        "id": "project-create-importer-upload-flow.common.utils.asana-fields-tile-loading-description-spork",
        "defaultMessage": "Mapping your Asana fields to Jira"
    },
    asanaFieldsMappingPageDescriptionSpork: {
        "id": "project-create-importer-upload-flow.common.utils.asana-fields-mapping-page-description-spork",
        "defaultMessage": "We've automatically mapped your Asana data into system and custom fields in Jira. You can customize some fields that have other compatible field types. <link>More about field mapping</link>"
    },
    asanaHierarchyTileDescription: {
        "id": "project-create-importer-upload-flow.common.utils.asana-hierarchy-tile-description",
        "defaultMessage": "Sections from Asana are mapped to issue statuses"
    },
    asanaHierarchyMappingTileDescription: {
        "id": "project-create-importer-upload-flow.common.utils.asana-hierarchy-mapping-tile-description",
        "defaultMessage": "Sections from Asana are mapped to {jiraHierarchyItem}"
    },
    asanaHierarchyTileLoadingDescription: {
        "id": "project-create-importer-upload-flow.common.utils.asana-hierarchy-tile-loading-description",
        "defaultMessage": "Mapping your Asana section to issue statuses"
    },
    asanaHierarchyStatusToolTip: {
        "id": "project-create-importer-upload-flow.common.utils.asana-hierarchy-status-tool-tip",
        "defaultMessage": "Map your Section to Issue status if your tasks and subtasks are grouped by status such as Open, In progress or Done."
    },
    asanaHierarchyCategoryToolTip: {
        "id": "project-create-importer-upload-flow.common.utils.asana-hierarchy-category-tool-tip",
        "defaultMessage": "Map Section to Category when work is grouped using custom attributes."
    },
    asanaHierarchyEpicToolTip: {
        "id": "project-create-importer-upload-flow.common.utils.asana-hierarchy-epic-tool-tip",
        "defaultMessage": "Map Section to Epic when grouping by large buckets of work that can then be broken down into smaller tasks."
    },
    asanaHierarchySubtaskToolTip: {
        "id": "project-create-importer-upload-flow.common.utils.asana-hierarchy-subtask-tool-tip",
        "defaultMessage": "To maintain project hierarchy we'll import any nested subtasks as subtasks and link them to their respective subtasks."
    },
    asanaDisabledFieldTooltip: {
        "id": "project-create-importer-upload-flow.common.utils.asana-disabled-field-tooltip",
        "defaultMessage": "This field is already mapped to another Asana field."
    },
    asanaHierarchyPageDescriptionSpork: {
        "id": "project-create-importer-upload-flow.common.utils.asana-hierarchy-page-description-spork",
        "defaultMessage": "Here\u2019s how we've mapped your Asana data to Jira: <ul><li>Sections will be imported as issue statuses.</li><li>Tasks will be imported as issues. <link>Learn more about issues</link></li><li>Subtasks will be imported as subtasks and will be linked to their respective parent subtasks within each issue.</li></ul>"
    },
    asanaHierarchyMappingDescriptionSpork: {
        "id": "project-create-importer-upload-flow.common.utils.asana-hierarchy-mapping-description-spork",
        "defaultMessage": "Here\u2019s how we've mapped your Asana data to Jira. <link>More about project hierarchy in Jira</link>"
    },
    asanaMemberStats: {
        "id": "project-create-importer-upload-flow.common.utils.asana-member-stats",
        "defaultMessage": "<stats>{statistic}</stats> {statistic, plural, one {<header>Member</header> <description>Will be added as a user to the new project</description>} other {<header>Members</header> <description>Will be added as users to the new project</description>}}"
    },
    asanaCardStats: {
        "id": "project-create-importer-upload-flow.common.utils.asana-card-stats",
        "defaultMessage": "<stats>{statistic}</stats> {statistic, plural, one {<header>Task</header> <description>Will be imported as an issue in the new project</description>} other {<header>Tasks</header> <description>Will be imported as issues in the new project</description>}}"
    },
    asanaAddAccessTokenModalDescriptionSpork: {
        "id": "project-create-importer-upload-flow.common.utils.asana-add-access-token-modal-description-spork",
        "defaultMessage": "The token allows Jira to access your Asana data for import. To create a personal access token, log into your Asana account > select your profile picture > Settings > Apps > Manage developer apps > Copy. {br}{br}Once you have your personal access token, paste it here to continue."
    },
    asanaEditAccessTokenModalDescription: {
        "id": "project-create-importer-upload-flow.common.utils.asana-edit-access-token-modal-description",
        "defaultMessage": "To switch to a different Asana account, copy your personal access token for the account where you\u2019d like to continue importing data from. Log into your Asana account > select your profile picture > Settings > Apps > Manage developer apps > Copy. {br}{br}Once you have your personal access token, paste it here to continue."
    },
    asanaChangeCurrentAccount: {
        "id": "project-create-importer-upload-flow.common.utils.asana-change-current-account",
        "defaultMessage": "Not the project you\u2019re looking for? <link>Switch to another Asana account </link>"
    },
    asanaInvalidAccessTokenModalDescription: {
        "id": "project-create-importer-upload-flow.common.utils.asana-invalid-access-token-modal-description",
        "defaultMessage": "Your personal access token has expired. To continue importing data you\u2019ll need to regenerate a new token. To create a personal access token, log into your Asana account > select your profile picture > Settings > Apps > Manage developer apps > Copy.{br}{br}Once you have your personal access token, paste it here to continue. This token won\u2019t be valid here after 7 days."
    },
    asanaUsersTileHeading: {
        "id": "project-create-importer-upload-flow.common.utils.asana-users-tile-heading",
        "defaultMessage": "Import all members from Asana project"
    },
    asanaUsersTileDescriptionUnchecked: {
        "id": "project-create-importer-upload-flow.common.utils.asana-users-tile-description-unchecked",
        "defaultMessage": "Imported tasks will remain unassigned. Add assignees to tasks later from project settings"
    },
    mondayHeading: {
        "id": "project-create-importer-upload-flow.common.utils.monday-heading",
        "defaultMessage": "Select a monday board"
    },
    mondayDescription: {
        "id": "project-create-importer-upload-flow.common.utils.monday-description",
        "defaultMessage": "Select the workspace and board you\u2019d like to import data from."
    },
    mondayWorkspacesSelectorLabel: {
        "id": "project-create-importer-upload-flow.common.utils.monday-workspaces-selector-label",
        "defaultMessage": "Monday workspace"
    },
    mondayWorkspacesSelectorPlaceholder: {
        "id": "project-create-importer-upload-flow.common.utils.monday-workspaces-selector-placeholder",
        "defaultMessage": "Select workspace"
    },
    mondayFoldersSelectorLabel: {
        "id": "project-create-importer-upload-flow.common.utils.monday-folders-selector-label",
        "defaultMessage": "Monday folder"
    },
    mondayFoldersSelectorPlaceholder: {
        "id": "project-create-importer-upload-flow.common.utils.monday-folders-selector-placeholder",
        "defaultMessage": "Select folder"
    },
    mondayErrorOccurredFetchingFoldersHeader: {
        "id": "project-create-importer-upload-flow.common.utils.monday-error-occurred-fetching-folders-header",
        "defaultMessage": "We couldn\u2019t load your folders"
    },
    mondaySubfoldersSelectorLabel: {
        "id": "project-create-importer-upload-flow.common.utils.monday-subfolders-selector-label",
        "defaultMessage": "Monday subfolder"
    },
    mondaySubfoldersSelectorPlaceholder: {
        "id": "project-create-importer-upload-flow.common.utils.monday-subfolders-selector-placeholder",
        "defaultMessage": "Select subfolder"
    },
    mondayProjectsSelectorLabel: {
        "id": "project-create-importer-upload-flow.common.utils.monday-projects-selector-label",
        "defaultMessage": "Monday board"
    },
    mondayProjectsSelectorPlaceholder: {
        "id": "project-create-importer-upload-flow.common.utils.monday-projects-selector-placeholder",
        "defaultMessage": "Select board"
    },
    mondayStarredWorkspacesLabel: {
        "id": "project-create-importer-upload-flow.common.utils.monday-starred-workspaces-label",
        "defaultMessage": "Starred workspaces"
    },
    mondayOtherWorkspacesLabel: {
        "id": "project-create-importer-upload-flow.common.utils.monday-other-workspaces-label",
        "defaultMessage": "All workspaces"
    },
    mondayStarredProjectsLabel: {
        "id": "project-create-importer-upload-flow.common.utils.monday-starred-projects-label",
        "defaultMessage": "Starred boards"
    },
    mondayOtherProjectsLabel: {
        "id": "project-create-importer-upload-flow.common.utils.monday-other-projects-label",
        "defaultMessage": "All boards"
    },
    mondayStatsHeading: {
        "id": "project-create-importer-upload-flow.common.utils.monday-stats-heading",
        "defaultMessage": "About this monday board"
    },
    mondayImportStep1Description: {
        "id": "project-create-importer-upload-flow.common.utils.monday-import-step-1-description",
        "defaultMessage": "Importing monday board"
    },
    mondayNoWorkspacesFoundHeader: {
        "id": "project-create-importer-upload-flow.common.utils.monday-no-workspaces-found-header",
        "defaultMessage": "No workspaces found"
    },
    mondayNoWorkspacesFoundDescription: {
        "id": "project-create-importer-upload-flow.common.utils.monday-no-workspaces-found-description",
        "defaultMessage": "There are no workspaces linked to your account."
    },
    mondayErrorOccurredFetchingWorkspacesHeader: {
        "id": "project-create-importer-upload-flow.common.utils.monday-error-occurred-fetching-workspaces-header",
        "defaultMessage": "We couldn\u2019t load your workspaces"
    },
    mondayNoEntitiesFoundHeader: {
        "id": "project-create-importer-upload-flow.common.utils.monday-no-entities-found-header",
        "defaultMessage": "No boards found"
    },
    mondayNoEntitiesFoundDescription: {
        "id": "project-create-importer-upload-flow.common.utils.monday-no-entities-found-description",
        "defaultMessage": "Try selecting another workspace."
    },
    mondayNoEntitiesFoundWithFolderDescription: {
        "id": "project-create-importer-upload-flow.common.utils.monday-no-entities-found-with-folder-description",
        "defaultMessage": "Try selecting another folder."
    },
    mondayNoEntitiesFoundWithSubfolderDescription: {
        "id": "project-create-importer-upload-flow.common.utils.monday-no-entities-found-with-subfolder-description",
        "defaultMessage": "Try selecting another subfolder."
    },
    mondayErrorOccurredFetchingEntitiesHeader: {
        "id": "project-create-importer-upload-flow.common.utils.monday-error-occurred-fetching-entities-header",
        "defaultMessage": "We couldn't load your boards"
    },
    mondayNoAccountErrorHeader: {
        "id": "project-create-importer-upload-flow.common.utils.monday-no-account-error-header",
        "defaultMessage": "We couldn't find your monday account"
    },
    mondayReviewScreenDescriptionSpork: {
        "id": "project-create-importer-upload-flow.common.utils.monday-review-screen-description-spork",
        "defaultMessage": "We\u2019ve mapped the monday board to the new Jira project. Check the details to see how everything has been mapped, make any changes, and then confirm the import. <link>More about project setup</link>"
    },
    mondayFieldsTileLoadingDescriptionSpork: {
        "id": "project-create-importer-upload-flow.common.utils.monday-fields-tile-loading-description-spork",
        "defaultMessage": "Mapping your monday fields to Jira"
    },
    mondayFieldsMappingPageDescriptionSpork: {
        "id": "project-create-importer-upload-flow.common.utils.monday-fields-mapping-page-description-spork",
        "defaultMessage": "We've automatically mapped your monday data into system and custom fields in Jira. You can customize some fields that have other compatible field types. <link>More about field mapping</link>"
    },
    mondayHierarchyTileDescriptionSpork: {
        "id": "project-create-importer-upload-flow.common.utils.monday-hierarchy-tile-description-spork",
        "defaultMessage": "Groups in monday are mapped as epics in Jira"
    },
    mondayHierarchyMappingTileDescriptionSpork: {
        "id": "project-create-importer-upload-flow.common.utils.monday-hierarchy-mapping-tile-description-spork",
        "defaultMessage": "Groups in monday are mapped as {jiraHierarchyItem} in Jira"
    },
    mondayHierarchyTileLoadingDescriptionSpork: {
        "id": "project-create-importer-upload-flow.common.utils.monday-hierarchy-tile-loading-description-spork",
        "defaultMessage": "Mapping your monday Groups in monday as epics in Jira"
    },
    mondayDisabledFieldTooltip: {
        "id": "project-create-importer-upload-flow.common.utils.monday-disabled-field-tooltip",
        "defaultMessage": "This field is already mapped to another monday field."
    },
    mondayHierarchyStatusToolTip: {
        "id": "project-create-importer-upload-flow.common.utils.monday-hierarchy-status-tool-tip",
        "defaultMessage": "Map your Group to Issue status if your tasks and subtasks are grouped by status such as Open, In progress or Done."
    },
    mondayHierarchyCategoryToolTip: {
        "id": "project-create-importer-upload-flow.common.utils.monday-hierarchy-category-tool-tip",
        "defaultMessage": "Map Group to Category when work is grouped using custom attributes."
    },
    mondayHierarchyEpicToolTip: {
        "id": "project-create-importer-upload-flow.common.utils.monday-hierarchy-epic-tool-tip",
        "defaultMessage": "Map Group to Epic when grouping by large buckets of work that can then be broken down into smaller tasks."
    },
    mondayHierarchyPageDescriptionSpork: {
        "id": "project-create-importer-upload-flow.common.utils.monday-hierarchy-page-description-spork",
        "defaultMessage": "To match the hierarchy of your monday project we\u2019re mapping the following: <ul><li>Groups will be imported as epics.</li><li>Items will be imported as issues.</li><li> Subitems will be imported as subtasks.</li></ul><link>More about project hierarchy in Jira</link>"
    },
    mondayHierarchyMappingDescriptionSpork: {
        "id": "project-create-importer-upload-flow.common.utils.monday-hierarchy-mapping-description-spork",
        "defaultMessage": "Here\u2019s how we've mapped your monday data to Jira. <link>More about project hierarchy in Jira</link>"
    },
    mondayUsersTileHeading: {
        "id": "project-create-importer-upload-flow.common.utils.monday-users-tile-heading",
        "defaultMessage": "Import all members from monday board"
    },
    mondayUsersTileDescriptionUnchecked: {
        "id": "project-create-importer-upload-flow.common.utils.monday-users-tile-description-unchecked",
        "defaultMessage": "Imported tasks will remain unassigned. Add assignees to tasks later from project settings"
    },
    mondayCardStats: {
        "id": "project-create-importer-upload-flow.common.utils.monday-card-stats",
        "defaultMessage": "<stats>{statistic}</stats> {statistic, plural, one {<header>Task</header> <description>Will be imported as an issue in the new project.</description>} other {<header>Tasks</header> <description>Will be imported as issues in the new project.</description>}}"
    },
    mondayCardStatsShort: {
        "id": "project-create-importer-upload-flow.common.utils.monday-card-stats-short",
        "defaultMessage": "<stats>{statistic}</stats> {statistic, plural, one {<header>Item</header> <description>will be created as an issue</description>} other {<header>Items</header> <description>will be created as issues</description>}}"
    },
    mondayUsersStatsShort: {
        "id": "project-create-importer-upload-flow.common.utils.monday-users-stats-short",
        "defaultMessage": "<stats>{statistic}</stats> {statistic, plural, one {<header>Member</header> <description>will be invited as a member</description>} other {<header>Members</header> <description>will be invited as members</description>}}"
    },
    mondayPreOAuthModalTitle: {
        "id": "project-create-importer-upload-flow.common.utils.monday-pre-o-auth-modal-title",
        "defaultMessage": "Connect to your monday account"
    },
    mondayPreOAuthModalDescription: {
        "id": "project-create-importer-upload-flow.common.utils.monday-pre-o-auth-modal-description",
        "defaultMessage": "We\u2019ll need to get authorization from you to connect to your monday account so you can begin importing data. Before you proceed, make sure you <link>install the monday importer app</link>."
    },
    mondayOAuthUnsuccessFlagTitle: {
        "id": "project-create-importer-upload-flow.common.utils.monday-o-auth-unsuccess-flag-title",
        "defaultMessage": "Couldn't connect to your monday account"
    },
    mondayOAuthUnsuccessFlagDescription: {
        "id": "project-create-importer-upload-flow.common.utils.monday-o-auth-unsuccess-flag-description",
        "defaultMessage": "Try reauthorizing your account. If you continue experiencing issues, <link>contact your admin</link>."
    },
    mondayAddAccessTokenModalDescriptionSpork: {
        "id": "project-create-importer-upload-flow.common.utils.monday-add-access-token-modal-description-spork",
        "defaultMessage": "This token will allow Jira to access your monday data for import. To create a personal access token, log into your monday account > select your avatar/profile picture > Developers > My access tokens > Copy. <link>More about generating a token in monday</link> {br}{br}Once you have your personal access token, paste it here to continue."
    },
    mondayEditAccessTokenModalDescription: {
        "id": "project-create-importer-upload-flow.common.utils.monday-edit-access-token-modal-description",
        "defaultMessage": "To switch to a different monday account, copy your personal access token for the account where you\u2019d like to continue importing data from. Log into the monday account > select your avatar/profile picture > Developers > My access tokens > Copy.{br} {br}Once you have your personal access token, paste it here to continue."
    },
    mondayChangeCurrentAccount: {
        "id": "project-create-importer-upload-flow.common.utils.monday-change-current-account",
        "defaultMessage": "Not the board you\u2019re looking for? <link>Switch to another monday account </link>"
    },
    mondayLoadingSiteNameErrorOccurredDescription: {
        "id": "project-create-importer-upload-flow.common.utils.monday-loading-site-name-error-occurred-description",
        "defaultMessage": "We\u2019re unable to find this account. Retry or switch to another monday account."
    },
    mondayInvalidAccessTokenModalDescription: {
        "id": "project-create-importer-upload-flow.common.utils.monday-invalid-access-token-modal-description",
        "defaultMessage": "Your personal access token has expired. To continue importing data you\u2019ll need to regenerate a new token. To create a new token log into your monday account > select your avatar/profile picture > Developers > My access tokens > Regenerate > Copy.{br}{br}Once you have your personal access token, paste it here to continue. This token won\u2019t be valid here after 7 days."
    },
    memberStats: {
        "id": "project-create-importer-upload-flow.common.utils.member-stats",
        "defaultMessage": "<stats>{statistic}</stats> {statistic, plural, one {<header>User</header> <description>This user is a member of the selected board.</description>} other {<header>Users</header> <description>These users are members of the selected board.</description>}}"
    },
    jiraHeading: {
        "id": "project-create-importer-upload-flow.common.utils.jira-heading",
        "defaultMessage": "Select a software project"
    },
    jiraDescriptionSpork: {
        "id": "project-create-importer-upload-flow.common.utils.jira-description-spork",
        "defaultMessage": "Select which software project you'd like to import data from."
    },
    jiraProjectSelectorLabel: {
        "id": "project-create-importer-upload-flow.common.utils.jira-project-selector-label",
        "defaultMessage": "Software project"
    },
    jiraProjectSelectorPlaceholder: {
        "id": "project-create-importer-upload-flow.common.utils.jira-project-selector-placeholder",
        "defaultMessage": "Select project"
    },
    jiraStarredProjectsLabel: {
        "id": "project-create-importer-upload-flow.common.utils.jira-starred-projects-label",
        "defaultMessage": "Starred projects"
    },
    jiraOtherProjectsLabel: {
        "id": "project-create-importer-upload-flow.common.utils.jira-other-projects-label",
        "defaultMessage": "All projects"
    },
    jiraStatsHeading: {
        "id": "project-create-importer-upload-flow.common.utils.jira-stats-heading",
        "defaultMessage": "About this software project"
    },
    jiraProjectCreateHeading: {
        "id": "project-create-importer-upload-flow.common.utils.jira-project-create-heading",
        "defaultMessage": "Create a business project"
    },
    jiraReviewScreenDescriptionComplexspork: {
        "id": "project-create-importer-upload-flow.common.utils.jira-review-screen-description-complexspork",
        "defaultMessage": "We've mapped the software project to the new business project. Check the details to see how everything is mapped, make any changes, then confirm the import. <link>More about the project setup</link>"
    },
    jiraFieldsTileLoadingDescriptionSpork: {
        "id": "project-create-importer-upload-flow.common.utils.jira-fields-tile-loading-description-spork",
        "defaultMessage": "Mapping your software project into business project fields"
    },
    jiraFieldsMappingPageDescription: {
        "id": "project-create-importer-upload-flow.common.utils.jira-fields-mapping-page-description",
        "defaultMessage": "We've automatically mapped the software project data into system and custom fields in your business project. You can customize some fields that have other compatible field types."
    },
    jiraFieldsMappingPageDisclaimer: {
        "id": "project-create-importer-upload-flow.common.utils.jira-fields-mapping-page-disclaimer",
        "defaultMessage": "Some fields may not be supported by business projects. <link>Read more</link>"
    },
    jiraFieldsMappingPageIssueTypesMessage: {
        "id": "project-create-importer-upload-flow.common.utils.jira-fields-mapping-page-issue-types-message",
        "defaultMessage": "Issue types:"
    },
    jiraFieldsTileInfoDescription: {
        "id": "project-create-importer-upload-flow.common.utils.jira-fields-tile-info-description",
        "defaultMessage": "Some fields may not be supported by business projects."
    },
    jiraUsersTileHeading: {
        "id": "project-create-importer-upload-flow.common.utils.jira-users-tile-heading",
        "defaultMessage": "Import all users"
    },
    jiraUserTileDescription: {
        "id": "project-create-importer-upload-flow.common.utils.jira-user-tile-description",
        "defaultMessage": "Anyone assigned, added in a comment, or mentioned anywhere on the project. Imported users won't be notified."
    },
    jiraUsersTileDescriptionUnchecked: {
        "id": "project-create-importer-upload-flow.common.utils.jira-users-tile-description-unchecked",
        "defaultMessage": "Imported data will remain unassigned. You can add assignees to issues later from project settings"
    },
    jiraDisabledFieldTooltip: {
        "id": "project-create-importer-upload-flow.common.utils.jira-disabled-field-tooltip",
        "defaultMessage": "This field is already mapped to another software field."
    },
    jiraImportStep1Description: {
        "id": "project-create-importer-upload-flow.common.utils.jira-import-step-1-description",
        "defaultMessage": "Importing your software project"
    },
    jiraNoEntitiesFoundHeader: {
        "id": "project-create-importer-upload-flow.common.utils.jira-no-entities-found-header",
        "defaultMessage": "No projects found"
    },
    jiraNoEntitiesFoundDescription: {
        "id": "project-create-importer-upload-flow.common.utils.jira-no-entities-found-description",
        "defaultMessage": "There are no projects in your account."
    },
    jiraErrorOccurredFetchingEntitiesHeader: {
        "id": "project-create-importer-upload-flow.common.utils.jira-error-occurred-fetching-entities-header",
        "defaultMessage": "We couldn't load your projects"
    },
    cardStats: {
        "id": "project-create-importer-upload-flow.common.utils.card-stats",
        "defaultMessage": "<stats>{statistic}</stats> {statistic, plural, one {<header>Card</header> <description>This is the active card on the selected board.</description>} other {<header>Cards</header> <description>These are the active cards on the selected board.</description>}}"
    },
    cardStatsShort: {
        "id": "project-create-importer-upload-flow.common.utils.card-stats-short",
        "defaultMessage": "<stats>{statistic}</stats> {statistic, plural, one {<header>Card</header> <description>will be created as an issue</description>} other {<header>Cards</header> <description>will be created as issues</description>}}"
    },
    usersStatsShort: {
        "id": "project-create-importer-upload-flow.common.utils.users-stats-short",
        "defaultMessage": "<stats>{statistic}</stats> {statistic, plural, one {<header>User</header> <description>will be invited as a member</description>} other {<header>Users</header> <description>will be invited as members</description>}}"
    },
    clickupHeading: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-heading",
        "defaultMessage": "Select a ClickUp list"
    },
    clickupDescription: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-description",
        "defaultMessage": "We'll import the details from ClickUp to your new project. "
    },
    clickupWorkspaceSelectorLabel: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-workspace-selector-label",
        "defaultMessage": "ClickUp workspace"
    },
    clickupWorkspaceSelectorPlaceholder: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-workspace-selector-placeholder",
        "defaultMessage": "Select workspace"
    },
    clickupNoWorkspacesFoundHeader: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-no-workspaces-found-header",
        "defaultMessage": "No workspaces found"
    },
    clickupSpaceSelector: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-space-selector",
        "defaultMessage": "ClickUp space"
    },
    clickupSpaceSelectorPlaceholder: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-space-selector-placeholder",
        "defaultMessage": "Select space"
    },
    clickupErrorOccurredFetchingSpacesHeader: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-error-occurred-fetching-spaces-header",
        "defaultMessage": "We couldn\u2019t load your spaces"
    },
    clickupNoSpacesFoundHeader: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-no-spaces-found-header",
        "defaultMessage": "No spaces found"
    },
    clickupNoSpacesFoundDescription: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-no-spaces-found-description",
        "defaultMessage": "There are no spaces linked to your account."
    },
    clickupFolderSelector: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-folder-selector",
        "defaultMessage": "ClickUp folder"
    },
    clickupFolderSelectorPlaceholder: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-folder-selector-placeholder",
        "defaultMessage": "Select folder"
    },
    clickupListSelector: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-list-selector",
        "defaultMessage": "ClickUp list"
    },
    clickupListSelectorPlaceholder: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-list-selector-placeholder",
        "defaultMessage": "Select list"
    },
    clickupNoEntitiesFoundHeader: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-no-entities-found-header",
        "defaultMessage": "No lists found"
    },
    clickupNoEntitiesFoundDescription: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-no-entities-found-description",
        "defaultMessage": "Try selecting another space."
    },
    clickupNoEntitiesFoundWithFolderDescription: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-no-entities-found-with-folder-description",
        "defaultMessage": "Try selecting another folder."
    },
    clickupErrorOccurredFetchingEntitiesHeader: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-error-occurred-fetching-entities-header",
        "defaultMessage": "We couldn't load your lists"
    },
    clickupNoWorkspacesFoundDescription: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-no-workspaces-found-description",
        "defaultMessage": "There are no workspaces linked to your account."
    },
    clickupErrorOccurredFetchingWorkspacesHeader: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-error-occurred-fetching-workspaces-header",
        "defaultMessage": "We couldn\u2019t load your workspaces"
    },
    clickupStatsHeading: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-stats-heading",
        "defaultMessage": "About this ClickUp list"
    },
    clickupReviewScreenDescriptionSpork: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-review-screen-description-spork",
        "defaultMessage": "Take a minute to review the details we\u2019re about to import to your new project. <link>Read more about project setup</link>"
    },
    clickupFieldsTileLoadingDescriptionSpork: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-fields-tile-loading-description-spork",
        "defaultMessage": "Mapping your ClickUp fields to Jira"
    },
    clickupFieldsMappingPageDescription: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-fields-mapping-page-description",
        "defaultMessage": "We\u2019ve automatically mapped your list fields. Some field types may be customizable. <link>Read more about field mapping</link>"
    },
    clickupUsersTileHeading: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-users-tile-heading",
        "defaultMessage": "Import users"
    },
    clickupUserTileDescription: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-user-tile-description",
        "defaultMessage": "Imported users won't be notified"
    },
    clickupUsersTileDescriptionUnchecked: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-users-tile-description-unchecked",
        "defaultMessage": "Imported tasks will remain unassigned. Add users to tasks later from project settings"
    },
    clickupAttachmentTileEnabledDescription: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-attachment-tile-enabled-description",
        "defaultMessage": "Importing attachments may take extra time"
    },
    clickupImportStep1Description: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-import-step-1-description",
        "defaultMessage": "Importing ClickUp list"
    },
    clickupImportStep1DescriptionMultiLists: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-import-step-1-description-multi-lists",
        "defaultMessage": "Importing ClickUp lists"
    },
    clickupHierarchyMappingTileDescriptionSpork: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-hierarchy-mapping-tile-description-spork",
        "defaultMessage": "ClickUp lists are mapped as {jiraHierarchyItem} in Jira"
    },
    clickupHierarchyTileLoadingDescriptionSpork: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-hierarchy-tile-loading-description-spork",
        "defaultMessage": "Mapping your lists in ClickUp as epics in Jira"
    },
    clickupHierarchyEpicToolTip: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-hierarchy-epic-tool-tip",
        "defaultMessage": "An epic is a large body of work that can be broken down into a number of smaller tasks."
    },
    clickupHierarchyMappingDescriptionSpork: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-hierarchy-mapping-description-spork",
        "defaultMessage": "Here\u2019s how we've mapped your ClickUp list to Jira. <link>Read more about project hierarchy</link>"
    },
    clickupHierarchySubtaskToolTip: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-hierarchy-subtask-tool-tip",
        "defaultMessage": "Nested subtasks will be imported as subtasks, and link to their parent task."
    },
    clickupRateLimitWarning: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-rate-limit-warning",
        "defaultMessage": "Time to import your list will depend on your <link>ClickUp plan and rate limit</link>."
    },
    clickupCardStats: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-card-stats",
        "defaultMessage": "<stats>{statistic}</stats> {statistic, plural, one {<header>Task</header> <description>Will be imported from the selected list.</description>} other {<header>Tasks</header> <description>Will be imported from the selected list.</description>}}"
    },
    clickupCardStatsShort: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-card-stats-short",
        "defaultMessage": "<stats>{statistic}</stats> {statistic, plural, one {<header>Task</header> <description>will be created as an issue</description>} other {<header>Tasks</header> <description>will be created as issues</description>}}"
    },
    clickupStatsInfo: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-stats-info",
        "defaultMessage": "Tasks in another list will not be imported."
    },
    clickupStatsInfoMultiList: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-stats-info-multi-list",
        "defaultMessage": "Tasks that originate in other lists will not be imported."
    },
    clickupOAuthUnsuccessFlagTitle: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-o-auth-unsuccess-flag-title",
        "defaultMessage": "Couldn't connect to your ClickUp account"
    },
    clickupOAuthUnsuccessFlagDescription: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-o-auth-unsuccess-flag-description",
        "defaultMessage": "Try reauthorizing your account. If you continue experiencing issues, <link>contact your admin</link>."
    },
    clickupMultiListInfo: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-multi-list-info",
        "defaultMessage": "The more lists you import, the longer it may take. <link>Read more about importing lists</link>"
    },
    clickupStatusMappingDescription: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-status-mapping-description",
        "defaultMessage": "We've automatically mapped your statuses. Select a field to change a status, or start typing to add your own. <link>Read more about status mapping</link>"
    },
    clickupStatusMappingEntityName: {
        "id": "project-create-importer-upload-flow.common.utils.clickup-status-mapping-entity-name",
        "defaultMessage": "ClickUp lists:"
    },
    jiraBusinessHeading: {
        "id": "project-create-importer-upload-flow.common.utils.jira-business-heading",
        "defaultMessage": "Select a project to import"
    },
    jiraBusinessDescription: {
        "id": "project-create-importer-upload-flow.common.utils.jira-business-description",
        "defaultMessage": "We'll import the details, supported fields, and issues to your new project. <link>Read more about importing projects</link>"
    },
    jiraBusinessProjectSelectorLabel: {
        "id": "project-create-importer-upload-flow.common.utils.jira-business-project-selector-label",
        "defaultMessage": "Business project"
    },
    jiraBusinessStatsHeading: {
        "id": "project-create-importer-upload-flow.common.utils.jira-business-stats-heading",
        "defaultMessage": "About your business project"
    },
    jiraBusinessCardStats: {
        "id": "project-create-importer-upload-flow.common.utils.jira-business-card-stats",
        "defaultMessage": "<stats>{statistic}</stats> {statistic, plural, one {<header>Issue</header> <description>Will be imported from the selected project</description>} other {<header>Issues</header> <description>Will be imported from the selected project</description>}}"
    },
    jiraBusinessReviewScreenDescription: {
        "id": "project-create-importer-upload-flow.common.utils.jira-business-review-screen-description",
        "defaultMessage": "Take a minute to review the details we're about to import to your new project. <link>Read more about project mapping</link>"
    },
    jiraBusinessFieldsTileLoadingDescription: {
        "id": "project-create-importer-upload-flow.common.utils.jira-business-fields-tile-loading-description",
        "defaultMessage": "Mapping your project fields"
    },
    jiraBusinessUserTileDescription: {
        "id": "project-create-importer-upload-flow.common.utils.jira-business-user-tile-description",
        "defaultMessage": "Users won't be notified"
    },
    jiraBusinessFieldsMappingPageDescription: {
        "id": "project-create-importer-upload-flow.common.utils.jira-business-fields-mapping-page-description",
        "defaultMessage": "We've automatically mapped your new project fields. Some fields may be customizable. <link>Read more about field mapping</link>"
    },
    jiraBusinessFieldsMappingPageDisclaimer: {
        "id": "project-create-importer-upload-flow.common.utils.jira-business-fields-mapping-page-disclaimer",
        "defaultMessage": "Some fields may not be supported by software projects. <link>Read more</link>"
    },
    jiraBusinessDisabledFieldTooltip: {
        "id": "project-create-importer-upload-flow.common.utils.jira-business-disabled-field-tooltip",
        "defaultMessage": "This field is already mapped to another business field."
    },
    jiraBusinessImportStep1Description: {
        "id": "project-create-importer-upload-flow.common.utils.jira-business-import-step-1-description",
        "defaultMessage": "Mapping project fields"
    },
    usersTileWarningDescription: {
        "id": "project-create-importer-upload-flow.common.utils.users-tile-warning-description",
        "defaultMessage": "You don\u2019t have permission to invite new users. Any information provided about new users will not be imported."
    },
    jiraBusinessFieldsTileInfoDescription: {
        "id": "project-create-importer-upload-flow.common.utils.jira-business-fields-tile-info-description",
        "defaultMessage": "Some fields may not be supported by software projects."
    }
});

});

parcelRegister("cDLTA", function(module, exports) {

$parcel$export(module.exports, "useContentForThirdParty", () => $86129959c9e85f9e$export$391f43d0a4728729);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3ak5x = parcelRequire("3ak5x");

var $l2OLr = parcelRequire("l2OLr");
const $86129959c9e85f9e$export$391f43d0a4728729 = (thirdParty)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return (0, $eUqFw.useMemo)(()=>{
        switch(thirdParty){
            case 0, $3ak5x.TRELLO:
                return {
                    heading: formatMessage((0, $l2OLr.default).trelloHeading),
                    description: formatMessage((0, $l2OLr.default).trelloDescription),
                    entityScreenDescription: (0, $l2OLr.default).trelloDescription,
                    workspacesSelectorLabel: formatMessage((0, $l2OLr.default).trelloWorkspacesSelectorLabel),
                    spaceSelectorLabel: '',
                    spaceSelectorPlaceholder: '',
                    workspacesSelectorPlaceholder: formatMessage((0, $l2OLr.default).trelloWorkspacesSelectorPlaceholder),
                    foldersSelectorLabel: '',
                    foldersSelectorPlaceholder: '',
                    errorOccurredFetchingFoldersHeader: '',
                    subfoldersSelectorLabel: '',
                    subfoldersSelectorPlaceholder: '',
                    entitySelectorLabel: formatMessage((0, $l2OLr.default).trelloBoardsSelectorLabel),
                    entitySelectorPlaceholder: formatMessage((0, $l2OLr.default).trelloBoardsSelectorPlaceholder),
                    starredWorkspacesLabel: formatMessage((0, $l2OLr.default).trelloStarredWorkspacesLabel),
                    otherWorkspacesLabel: formatMessage((0, $l2OLr.default).trelloOtherWorkspacesLabel),
                    starredEntitiesLabel: formatMessage((0, $l2OLr.default).trelloStarredBoardsLabel),
                    otherEntitiesLabel: formatMessage((0, $l2OLr.default).trelloOtherBoardsLabel),
                    statsHeading: formatMessage((0, $l2OLr.default).trelloStatsHeading),
                    memberStats: (0, $l2OLr.default).memberStats,
                    cardStats: (0, $l2OLr.default).cardStats,
                    cardStatsShort: (0, $l2OLr.default).cardStatsShort,
                    usersStatsShort: (0, $l2OLr.default).usersStatsShort,
                    importStep1Description: formatMessage((0, $l2OLr.default).trelloImportStep1Description),
                    noWorkspacesFoundHeader: formatMessage((0, $l2OLr.default).trelloNoWorkspacesFoundHeader),
                    noWorkspacesFoundDescription: formatMessage((0, $l2OLr.default).trelloNoWorkspacesFoundDescription),
                    errorOccurredFetchingWorkspacesHeader: formatMessage((0, $l2OLr.default).trelloErrorOccurredFetchingWorkspacesHeader),
                    errorOccurredFetchingSpacesHeader: '',
                    noSpacesFoundHeader: '',
                    noSpacesFoundDescription: '',
                    noEntitiesFoundHeader: formatMessage((0, $l2OLr.default).trelloNoEntitiesFoundHeader),
                    noEntitiesFoundDescription: formatMessage((0, $l2OLr.default).trelloNoEntitiesFoundDescription),
                    errorOccurredFetchingEntitiesHeader: formatMessage((0, $l2OLr.default).trelloErrorOccurredFetchingEntitiesHeader),
                    noAccountErrorHeader: formatMessage((0, $l2OLr.default).trelloNoAccountErrorHeader),
                    searchEntitiesErrorOccurredDescription: '',
                    loadingMoreEntitiesErrorOccurredDescription: ''
                };
            case 0, $3ak5x.MONDAY:
                return {
                    heading: formatMessage((0, $l2OLr.default).mondayHeading),
                    description: formatMessage((0, $l2OLr.default).mondayDescription),
                    entityScreenDescription: (0, $l2OLr.default).mondayDescription,
                    workspacesSelectorLabel: formatMessage((0, $l2OLr.default).mondayWorkspacesSelectorLabel),
                    workspacesSelectorPlaceholder: formatMessage((0, $l2OLr.default).mondayWorkspacesSelectorPlaceholder),
                    spaceSelectorLabel: '',
                    spaceSelectorPlaceholder: '',
                    foldersSelectorLabel: formatMessage((0, $l2OLr.default).mondayFoldersSelectorLabel),
                    foldersSelectorPlaceholder: formatMessage((0, $l2OLr.default).mondayFoldersSelectorPlaceholder),
                    errorOccurredFetchingFoldersHeader: formatMessage((0, $l2OLr.default).mondayErrorOccurredFetchingFoldersHeader),
                    subfoldersSelectorLabel: formatMessage((0, $l2OLr.default).mondaySubfoldersSelectorLabel),
                    subfoldersSelectorPlaceholder: formatMessage((0, $l2OLr.default).mondaySubfoldersSelectorPlaceholder),
                    entitySelectorLabel: formatMessage((0, $l2OLr.default).mondayProjectsSelectorLabel),
                    entitySelectorPlaceholder: formatMessage((0, $l2OLr.default).mondayProjectsSelectorPlaceholder),
                    starredWorkspacesLabel: formatMessage((0, $l2OLr.default).mondayStarredWorkspacesLabel),
                    otherWorkspacesLabel: formatMessage((0, $l2OLr.default).mondayOtherWorkspacesLabel),
                    starredEntitiesLabel: formatMessage((0, $l2OLr.default).mondayStarredProjectsLabel),
                    otherEntitiesLabel: formatMessage((0, $l2OLr.default).mondayOtherProjectsLabel),
                    statsHeading: formatMessage((0, $l2OLr.default).mondayStatsHeading),
                    memberStats: (0, $l2OLr.default).memberStats,
                    cardStats: (0, $l2OLr.default).mondayCardStats,
                    cardStatsShort: (0, $l2OLr.default).mondayCardStatsShort,
                    usersStatsShort: (0, $l2OLr.default).mondayUsersStatsShort,
                    importStep1Description: formatMessage((0, $l2OLr.default).mondayImportStep1Description),
                    noWorkspacesFoundHeader: formatMessage((0, $l2OLr.default).mondayNoWorkspacesFoundHeader),
                    noWorkspacesFoundDescription: formatMessage((0, $l2OLr.default).mondayNoWorkspacesFoundDescription),
                    errorOccurredFetchingWorkspacesHeader: formatMessage((0, $l2OLr.default).mondayErrorOccurredFetchingWorkspacesHeader),
                    errorOccurredFetchingSpacesHeader: '',
                    noSpacesFoundHeader: '',
                    noSpacesFoundDescription: '',
                    noEntitiesFoundHeader: formatMessage((0, $l2OLr.default).mondayNoEntitiesFoundHeader),
                    noEntitiesFoundDescription: formatMessage((0, $l2OLr.default).mondayNoEntitiesFoundDescription),
                    noEntitiesFoundWithFolderDescription: formatMessage((0, $l2OLr.default).mondayNoEntitiesFoundWithFolderDescription),
                    noEntitiesFoundWithSubfolderDescription: formatMessage((0, $l2OLr.default).mondayNoEntitiesFoundWithSubfolderDescription),
                    errorOccurredFetchingEntitiesHeader: formatMessage((0, $l2OLr.default).mondayErrorOccurredFetchingEntitiesHeader),
                    searchEntitiesErrorOccurredDescription: '',
                    loadingMoreEntitiesErrorOccurredDescription: '',
                    noAccountErrorHeader: formatMessage((0, $l2OLr.default).mondayNoAccountErrorHeader),
                    reviewScreenDescription: (0, $l2OLr.default).mondayReviewScreenDescriptionSpork,
                    fieldsTileLoadingDescription: formatMessage((0, $l2OLr.default).mondayFieldsTileLoadingDescriptionSpork),
                    fieldsMappingPageDescription: (0, $l2OLr.default).mondayFieldsMappingPageDescriptionSpork,
                    disabledFieldTooltip: formatMessage((0, $l2OLr.default).mondayDisabledFieldTooltip),
                    hierarchyTileDescription: formatMessage((0, $l2OLr.default).mondayHierarchyTileDescriptionSpork),
                    hierarchyMappingTileDescription: (0, $l2OLr.default).mondayHierarchyMappingTileDescriptionSpork,
                    hierarchyTileLoadingDescription: formatMessage((0, $l2OLr.default).mondayHierarchyTileLoadingDescriptionSpork),
                    hierarchyPageDescription: (0, $l2OLr.default).mondayHierarchyPageDescriptionSpork,
                    hierarchyMappingDescription: (0, $l2OLr.default).mondayHierarchyMappingDescriptionSpork,
                    hierarchyStatusToolTip: formatMessage((0, $l2OLr.default).mondayHierarchyStatusToolTip),
                    hierarchyCategoryToolTip: formatMessage((0, $l2OLr.default).mondayHierarchyCategoryToolTip),
                    hierarchyEpicToolTip: formatMessage((0, $l2OLr.default).mondayHierarchyEpicToolTip),
                    usersTileHeading: formatMessage((0, $l2OLr.default).mondayUsersTileHeading),
                    usersTileDescription: '',
                    usersTileDescriptionUnchecked: formatMessage((0, $l2OLr.default).mondayUsersTileDescriptionUnchecked),
                    usersTileWarningDescription: formatMessage((0, $l2OLr.default).usersTileWarningDescription),
                    preOAuthModalTitle: formatMessage((0, $l2OLr.default).mondayPreOAuthModalTitle),
                    preOAuthModalDescription: (0, $l2OLr.default).mondayPreOAuthModalDescription,
                    oAuthUnsuccessFlagTitle: formatMessage((0, $l2OLr.default).mondayOAuthUnsuccessFlagTitle),
                    oAuthUnsuccessFlagDescription: (0, $l2OLr.default).mondayOAuthUnsuccessFlagDescription,
                    addAccessTokenModalDescription: (0, $l2OLr.default).mondayAddAccessTokenModalDescriptionSpork,
                    editAccessTokenModalDescription: (0, $l2OLr.default).mondayEditAccessTokenModalDescription,
                    invalidAccessTokenModalDescription: (0, $l2OLr.default).mondayInvalidAccessTokenModalDescription,
                    changeCurrentAccount: (0, $l2OLr.default).mondayChangeCurrentAccount,
                    loadingSiteNameErrorOccurredDescription: (0, $l2OLr.default).mondayLoadingSiteNameErrorOccurredDescription
                };
            case 0, $3ak5x.ASANA:
                return {
                    heading: formatMessage((0, $l2OLr.default).asanaHeading),
                    description: formatMessage((0, $l2OLr.default).asanaDescription),
                    entityScreenDescription: (0, $l2OLr.default).asanaDescription,
                    workspacesSelectorLabel: formatMessage((0, $l2OLr.default).asanaWorkspacesSelectorLabel),
                    workspacesSelectorPlaceholder: formatMessage((0, $l2OLr.default).asanaWorkspacesSelectorPlaceholder),
                    spaceSelectorLabel: '',
                    spaceSelectorPlaceholder: '',
                    foldersSelectorLabel: '',
                    foldersSelectorPlaceholder: '',
                    errorOccurredFetchingFoldersHeader: '',
                    subfoldersSelectorLabel: '',
                    subfoldersSelectorPlaceholder: '',
                    entitySelectorLabel: formatMessage((0, $l2OLr.default).asanaProjectsSelectorLabel),
                    entitySelectorPlaceholder: formatMessage((0, $l2OLr.default).asanaProjectsSelectorPlaceholder),
                    starredWorkspacesLabel: formatMessage((0, $l2OLr.default).asanaStarredWorkspacesLabel),
                    otherWorkspacesLabel: formatMessage((0, $l2OLr.default).asanaOtherWorkspacesLabel),
                    starredEntitiesLabel: formatMessage((0, $l2OLr.default).asanaStarredProjectsLabel),
                    otherEntitiesLabel: formatMessage((0, $l2OLr.default).asanaOtherProjectsLabel),
                    statsHeading: formatMessage((0, $l2OLr.default).asanaStatsHeading),
                    memberStats: (0, $l2OLr.default).asanaMemberStats,
                    cardStats: (0, $l2OLr.default).asanaCardStats,
                    cardStatsShort: (0, $l2OLr.default).cardStatsShort,
                    usersStatsShort: (0, $l2OLr.default).usersStatsShort,
                    importStep1Description: formatMessage((0, $l2OLr.default).asanaImportStep1Description),
                    noWorkspacesFoundHeader: formatMessage((0, $l2OLr.default).asanaNoWorkspacesFoundHeader),
                    noWorkspacesFoundDescription: formatMessage((0, $l2OLr.default).asanaNoWorkspacesFoundDescription),
                    errorOccurredFetchingWorkspacesHeader: formatMessage((0, $l2OLr.default).asanaErrorOccurredFetchingWorkspacesHeader),
                    errorOccurredFetchingSpacesHeader: '',
                    noSpacesFoundHeader: '',
                    noSpacesFoundDescription: '',
                    noEntitiesFoundHeader: formatMessage((0, $l2OLr.default).asanaNoEntitiesFoundHeader),
                    noEntitiesFoundDescription: formatMessage((0, $l2OLr.default).asanaNoEntitiesFoundDescription),
                    errorOccurredFetchingEntitiesHeader: formatMessage((0, $l2OLr.default).asanaErrorOccurredFetchingEntitiesHeader),
                    searchEntitiesErrorOccurredDescription: formatMessage((0, $l2OLr.default).asanaSearchEntitiesErrorOccurredDescription),
                    loadingMoreEntitiesErrorOccurredDescription: formatMessage((0, $l2OLr.default).asanaLoadingMoreEntitiesErrorOccurredDescription),
                    noAccountErrorHeader: formatMessage((0, $l2OLr.default).asanaNoAccountErrorHeader),
                    reviewScreenDescription: (0, $l2OLr.default).asanaReviewScreenDescriptionSpork,
                    fieldsTileLoadingDescription: formatMessage((0, $l2OLr.default).asanaFieldsTileLoadingDescriptionSpork),
                    fieldsMappingPageDescription: (0, $l2OLr.default).asanaFieldsMappingPageDescriptionSpork,
                    hierarchyTileDescription: formatMessage((0, $l2OLr.default).asanaHierarchyTileDescription),
                    hierarchyTileLoadingDescription: formatMessage((0, $l2OLr.default).asanaHierarchyTileLoadingDescription),
                    hierarchyMappingTileDescription: (0, $l2OLr.default).asanaHierarchyMappingTileDescription,
                    hierarchyPageDescription: (0, $l2OLr.default).asanaHierarchyPageDescriptionSpork,
                    hierarchyMappingDescription: (0, $l2OLr.default).asanaHierarchyMappingDescriptionSpork,
                    hierarchyStatusToolTip: formatMessage((0, $l2OLr.default).asanaHierarchyStatusToolTip),
                    hierarchyCategoryToolTip: formatMessage((0, $l2OLr.default).asanaHierarchyCategoryToolTip),
                    hierarchyEpicToolTip: formatMessage((0, $l2OLr.default).asanaHierarchyEpicToolTip),
                    hierarchySubtaskToolTip: formatMessage((0, $l2OLr.default).asanaHierarchySubtaskToolTip),
                    usersTileHeading: formatMessage((0, $l2OLr.default).asanaUsersTileHeading),
                    usersTileDescription: '',
                    usersTileDescriptionUnchecked: formatMessage((0, $l2OLr.default).asanaUsersTileDescriptionUnchecked),
                    usersTileWarningDescription: formatMessage((0, $l2OLr.default).usersTileWarningDescription),
                    disabledFieldTooltip: formatMessage((0, $l2OLr.default).asanaDisabledFieldTooltip),
                    addAccessTokenModalDescription: (0, $l2OLr.default).asanaAddAccessTokenModalDescriptionSpork,
                    editAccessTokenModalDescription: (0, $l2OLr.default).asanaEditAccessTokenModalDescription,
                    invalidAccessTokenModalDescription: (0, $l2OLr.default).asanaInvalidAccessTokenModalDescription,
                    changeCurrentAccount: (0, $l2OLr.default).asanaChangeCurrentAccount
                };
            case 0, $3ak5x.JIRA_SOFTWARE:
                return {
                    heading: formatMessage((0, $l2OLr.default).jiraHeading),
                    description: formatMessage((0, $l2OLr.default).jiraDescriptionSpork),
                    entityScreenDescription: (0, $l2OLr.default).jiraDescriptionSpork,
                    workspacesSelectorLabel: formatMessage((0, $l2OLr.default).jiraProjectSelectorLabel),
                    workspacesSelectorPlaceholder: formatMessage((0, $l2OLr.default).jiraProjectSelectorPlaceholder),
                    spaceSelectorLabel: '',
                    spaceSelectorPlaceholder: '',
                    foldersSelectorLabel: '',
                    foldersSelectorPlaceholder: '',
                    errorOccurredFetchingFoldersHeader: '',
                    subfoldersSelectorLabel: '',
                    subfoldersSelectorPlaceholder: '',
                    entitySelectorLabel: formatMessage((0, $l2OLr.default).jiraProjectSelectorLabel),
                    entitySelectorPlaceholder: formatMessage((0, $l2OLr.default).jiraProjectSelectorPlaceholder),
                    starredWorkspacesLabel: '',
                    otherWorkspacesLabel: '',
                    starredEntitiesLabel: formatMessage((0, $l2OLr.default).jiraStarredProjectsLabel),
                    otherEntitiesLabel: formatMessage((0, $l2OLr.default).jiraOtherProjectsLabel),
                    statsHeading: formatMessage((0, $l2OLr.default).jiraStatsHeading),
                    memberStats: (0, $l2OLr.default).memberStats,
                    cardStats: (0, $l2OLr.default).cardStats,
                    cardStatsShort: (0, $l2OLr.default).cardStatsShort,
                    usersStatsShort: (0, $l2OLr.default).usersStatsShort,
                    projectCreateHeading: formatMessage((0, $l2OLr.default).jiraProjectCreateHeading),
                    reviewScreenDescription: (0, $l2OLr.default).jiraReviewScreenDescriptionComplexspork,
                    fieldsTileLoadingDescription: formatMessage((0, $l2OLr.default).jiraFieldsTileLoadingDescriptionSpork),
                    fieldsMappingPageDescription: (0, $l2OLr.default).jiraFieldsMappingPageDescription,
                    fieldsMappingPageDisclaimer: (0, $l2OLr.default).jiraFieldsMappingPageDisclaimer,
                    fieldsMappingPageIssueTypesMessage: formatMessage((0, $l2OLr.default).jiraFieldsMappingPageIssueTypesMessage),
                    fieldsTileInfoDescription: (0, $l2OLr.default).jiraFieldsTileInfoDescription,
                    usersTileHeading: formatMessage((0, $l2OLr.default).jiraUsersTileHeading),
                    usersTileDescription: formatMessage((0, $l2OLr.default).jiraUserTileDescription),
                    usersTileDescriptionUnchecked: formatMessage((0, $l2OLr.default).jiraUsersTileDescriptionUnchecked),
                    usersTileWarningDescription: formatMessage((0, $l2OLr.default).usersTileWarningDescription),
                    disabledFieldTooltip: formatMessage((0, $l2OLr.default).jiraDisabledFieldTooltip),
                    importStep1Description: formatMessage((0, $l2OLr.default).jiraImportStep1Description),
                    noWorkspacesFoundHeader: '',
                    noWorkspacesFoundDescription: '',
                    errorOccurredFetchingWorkspacesHeader: '',
                    noEntitiesFoundHeader: formatMessage((0, $l2OLr.default).jiraNoEntitiesFoundHeader),
                    noEntitiesFoundDescription: formatMessage((0, $l2OLr.default).jiraNoEntitiesFoundDescription),
                    errorOccurredFetchingEntitiesHeader: formatMessage((0, $l2OLr.default).jiraErrorOccurredFetchingEntitiesHeader),
                    errorOccurredFetchingSpacesHeader: '',
                    noSpacesFoundHeader: '',
                    noSpacesFoundDescription: '',
                    noAccountErrorHeader: '',
                    searchEntitiesErrorOccurredDescription: '',
                    loadingMoreEntitiesErrorOccurredDescription: ''
                };
            case 0, $3ak5x.CLICK_UP:
                return {
                    heading: formatMessage((0, $l2OLr.default).clickupHeading),
                    description: formatMessage((0, $l2OLr.default).clickupDescription),
                    entityScreenDescription: (0, $l2OLr.default).clickupDescription,
                    workspacesSelectorLabel: formatMessage((0, $l2OLr.default).clickupWorkspaceSelectorLabel),
                    workspacesSelectorPlaceholder: formatMessage((0, $l2OLr.default).clickupWorkspaceSelectorPlaceholder),
                    spaceSelectorLabel: formatMessage((0, $l2OLr.default).clickupSpaceSelector),
                    spaceSelectorPlaceholder: formatMessage((0, $l2OLr.default).clickupSpaceSelectorPlaceholder),
                    foldersSelectorLabel: formatMessage((0, $l2OLr.default).clickupFolderSelector),
                    foldersSelectorPlaceholder: formatMessage((0, $l2OLr.default).clickupFolderSelectorPlaceholder),
                    errorOccurredFetchingFoldersHeader: '',
                    subfoldersSelectorLabel: '',
                    subfoldersSelectorPlaceholder: '',
                    entitySelectorLabel: formatMessage((0, $l2OLr.default).clickupListSelector),
                    entitySelectorPlaceholder: formatMessage((0, $l2OLr.default).clickupListSelectorPlaceholder),
                    starredWorkspacesLabel: '',
                    otherWorkspacesLabel: '',
                    starredEntitiesLabel: '',
                    otherEntitiesLabel: '',
                    statsHeading: formatMessage((0, $l2OLr.default).clickupStatsHeading),
                    memberStats: (0, $l2OLr.default).memberStats,
                    cardStats: (0, $l2OLr.default).clickupCardStats,
                    cardStatsShort: (0, $l2OLr.default).clickupCardStatsShort,
                    usersStatsShort: (0, $l2OLr.default).usersStatsShort,
                    reviewScreenDescription: (0, $l2OLr.default).clickupReviewScreenDescriptionSpork,
                    fieldsTileLoadingDescription: formatMessage((0, $l2OLr.default).clickupFieldsTileLoadingDescriptionSpork),
                    fieldsMappingPageDescription: (0, $l2OLr.default).clickupFieldsMappingPageDescription,
                    fieldsMappingPageIssueTypesMessage: (0, $1ybV0.ff)('x2c-clickup-importer-multi-list') ? formatMessage((0, $l2OLr.default).clickupStatusMappingEntityName) : undefined,
                    usersTileHeading: formatMessage((0, $l2OLr.default).clickupUsersTileHeading),
                    usersTileDescription: formatMessage((0, $l2OLr.default).clickupUserTileDescription),
                    usersTileDescriptionUnchecked: formatMessage((0, $l2OLr.default).clickupUsersTileDescriptionUnchecked),
                    usersTileWarningDescription: formatMessage((0, $l2OLr.default).usersTileWarningDescription),
                    attachmentTileEnabledDescription: formatMessage((0, $l2OLr.default).clickupAttachmentTileEnabledDescription),
                    importStep1Description: (0, $1ybV0.ff)('x2c-clickup-importer-multi-list') ? formatMessage((0, $l2OLr.default).clickupImportStep1DescriptionMultiLists) : formatMessage((0, $l2OLr.default).clickupImportStep1Description),
                    noWorkspacesFoundHeader: formatMessage((0, $l2OLr.default).clickupNoWorkspacesFoundHeader),
                    noWorkspacesFoundDescription: formatMessage((0, $l2OLr.default).clickupNoWorkspacesFoundDescription),
                    errorOccurredFetchingWorkspacesHeader: formatMessage((0, $l2OLr.default).clickupErrorOccurredFetchingWorkspacesHeader),
                    errorOccurredFetchingSpacesHeader: formatMessage((0, $l2OLr.default).clickupErrorOccurredFetchingSpacesHeader),
                    noSpacesFoundHeader: formatMessage((0, $l2OLr.default).clickupNoSpacesFoundHeader),
                    noSpacesFoundDescription: formatMessage((0, $l2OLr.default).clickupNoSpacesFoundDescription),
                    noEntitiesFoundHeader: formatMessage((0, $l2OLr.default).clickupNoEntitiesFoundHeader),
                    noEntitiesFoundDescription: formatMessage((0, $l2OLr.default).clickupNoEntitiesFoundDescription),
                    noEntitiesFoundWithFolderDescription: formatMessage((0, $l2OLr.default).clickupNoEntitiesFoundWithFolderDescription),
                    errorOccurredFetchingEntitiesHeader: formatMessage((0, $l2OLr.default).clickupErrorOccurredFetchingEntitiesHeader),
                    noAccountErrorHeader: '',
                    searchEntitiesErrorOccurredDescription: '',
                    loadingMoreEntitiesErrorOccurredDescription: '',
                    hierarchyMappingTileDescription: (0, $l2OLr.default).clickupHierarchyMappingTileDescriptionSpork,
                    hierarchyTileLoadingDescription: formatMessage((0, $l2OLr.default).clickupHierarchyTileLoadingDescriptionSpork),
                    hierarchyMappingDescription: (0, $l2OLr.default).clickupHierarchyMappingDescriptionSpork,
                    hierarchyEpicToolTip: formatMessage((0, $l2OLr.default).clickupHierarchyEpicToolTip),
                    hierarchySubtaskToolTip: formatMessage((0, $l2OLr.default).clickupHierarchySubtaskToolTip),
                    statusMappingDescription: (0, $l2OLr.default).clickupStatusMappingDescription,
                    statusMappingEntityName: formatMessage((0, $l2OLr.default).clickupStatusMappingEntityName),
                    rateLimitWarning: (0, $l2OLr.default).clickupRateLimitWarning,
                    cardStatsInfo: (0, $1ybV0.ff)('x2c-clickup-importer-multi-list') ? (0, $l2OLr.default).clickupStatsInfoMultiList : (0, $l2OLr.default).clickupStatsInfo,
                    multiEntityInfo: (0, $l2OLr.default).clickupMultiListInfo,
                    oAuthUnsuccessFlagTitle: formatMessage((0, $l2OLr.default).clickupOAuthUnsuccessFlagTitle),
                    oAuthUnsuccessFlagDescription: (0, $l2OLr.default).clickupOAuthUnsuccessFlagDescription
                };
            case 0, $3ak5x.JIRA_BUSINESS:
                return {
                    heading: formatMessage((0, $l2OLr.default).jiraBusinessHeading),
                    description: '',
                    entityScreenDescription: (0, $l2OLr.default).jiraBusinessDescription,
                    workspacesSelectorLabel: formatMessage((0, $l2OLr.default).jiraBusinessProjectSelectorLabel),
                    workspacesSelectorPlaceholder: formatMessage((0, $l2OLr.default).jiraProjectSelectorPlaceholder),
                    spaceSelectorLabel: '',
                    spaceSelectorPlaceholder: '',
                    foldersSelectorLabel: '',
                    foldersSelectorPlaceholder: '',
                    errorOccurredFetchingFoldersHeader: '',
                    subfoldersSelectorLabel: '',
                    subfoldersSelectorPlaceholder: '',
                    entitySelectorLabel: formatMessage((0, $l2OLr.default).jiraBusinessProjectSelectorLabel),
                    entitySelectorPlaceholder: formatMessage((0, $l2OLr.default).jiraProjectSelectorPlaceholder),
                    starredWorkspacesLabel: '',
                    otherWorkspacesLabel: '',
                    starredEntitiesLabel: formatMessage((0, $l2OLr.default).jiraStarredProjectsLabel),
                    otherEntitiesLabel: formatMessage((0, $l2OLr.default).jiraOtherProjectsLabel),
                    statsHeading: formatMessage((0, $l2OLr.default).jiraBusinessStatsHeading),
                    memberStats: (0, $l2OLr.default).memberStats,
                    cardStats: (0, $l2OLr.default).jiraBusinessCardStats,
                    cardStatsShort: (0, $l2OLr.default).cardStatsShort,
                    usersStatsShort: (0, $l2OLr.default).usersStatsShort,
                    reviewScreenDescription: (0, $l2OLr.default).jiraBusinessReviewScreenDescription,
                    usersTileHeading: formatMessage((0, $l2OLr.default).jiraUsersTileHeading),
                    usersTileDescription: formatMessage((0, $l2OLr.default).jiraBusinessUserTileDescription),
                    usersTileDescriptionUnchecked: '',
                    usersTileWarningDescription: formatMessage((0, $l2OLr.default).usersTileWarningDescription),
                    fieldsTileLoadingDescription: formatMessage((0, $l2OLr.default).jiraBusinessFieldsTileLoadingDescription),
                    fieldsTileInfoDescription: (0, $l2OLr.default).jiraBusinessFieldsTileInfoDescription,
                    fieldsMappingPageDescription: (0, $l2OLr.default).jiraBusinessFieldsMappingPageDescription,
                    fieldsMappingPageDisclaimer: (0, $l2OLr.default).jiraBusinessFieldsMappingPageDisclaimer,
                    fieldsMappingPageIssueTypesMessage: formatMessage((0, $l2OLr.default).jiraFieldsMappingPageIssueTypesMessage),
                    disabledFieldTooltip: formatMessage((0, $l2OLr.default).jiraBusinessDisabledFieldTooltip),
                    importStep1Description: formatMessage((0, $l2OLr.default).jiraBusinessImportStep1Description),
                    noWorkspacesFoundHeader: '',
                    noWorkspacesFoundDescription: '',
                    noSpacesFoundHeader: '',
                    noSpacesFoundDescription: '',
                    errorOccurredFetchingWorkspacesHeader: '',
                    errorOccurredFetchingSpacesHeader: '',
                    noEntitiesFoundHeader: formatMessage((0, $l2OLr.default).jiraNoEntitiesFoundHeader),
                    noEntitiesFoundDescription: formatMessage((0, $l2OLr.default).jiraNoEntitiesFoundDescription),
                    errorOccurredFetchingEntitiesHeader: formatMessage((0, $l2OLr.default).jiraErrorOccurredFetchingEntitiesHeader),
                    searchEntitiesErrorOccurredDescription: '',
                    loadingMoreEntitiesErrorOccurredDescription: '',
                    noAccountErrorHeader: ''
                };
            default:
                return {
                    heading: '',
                    description: '',
                    workspacesSelectorLabel: '',
                    workspacesSelectorPlaceholder: '',
                    spaceSelectorLabel: '',
                    spaceSelectorPlaceholder: '',
                    foldersSelectorLabel: '',
                    foldersSelectorPlaceholder: '',
                    errorOccurredFetchingFoldersHeader: '',
                    subfoldersSelectorLabel: '',
                    subfoldersSelectorPlaceholder: '',
                    entitySelectorLabel: '',
                    entitySelectorPlaceholder: '',
                    starredWorkspacesLabel: '',
                    otherWorkspacesLabel: '',
                    starredEntitiesLabel: '',
                    otherEntitiesLabel: '',
                    statsHeading: '',
                    memberStats: (0, $l2OLr.default).memberStats,
                    cardStats: (0, $l2OLr.default).cardStats,
                    cardStatsShort: (0, $l2OLr.default).cardStatsShort,
                    usersStatsShort: (0, $l2OLr.default).usersStatsShort,
                    importStep1Description: '',
                    noWorkspacesFoundHeader: '',
                    noWorkspacesFoundDescription: '',
                    noSpacesFoundHeader: '',
                    noSpacesFoundDescription: '',
                    errorOccurredFetchingWorkspacesHeader: '',
                    errorOccurredFetchingSpacesHeader: '',
                    noEntitiesFoundHeader: '',
                    noEntitiesFoundDescription: '',
                    errorOccurredFetchingEntitiesHeader: '',
                    searchEntitiesErrorOccurredDescription: '',
                    loadingMoreEntitiesErrorOccurredDescription: '',
                    noAccountErrorHeader: ''
                };
        }
    }, [
        formatMessage,
        thirdParty
    ]);
};

});


parcelRegister("fOTfX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ba2713e1b02f2913$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $eI5EY = parcelRequire("eI5EY");

var $8WuJm = parcelRequire("8WuJm");

var $3ak5x = parcelRequire("3ak5x");

var $1pm5p = parcelRequire("1pm5p");

var $jNdPf = parcelRequire("jNdPf");

var $l58Ze = parcelRequire("l58Ze");

var $63nHt = parcelRequire("63nHt");

var $8JicK = parcelRequire("8JicK");
var $aEdcH = parcelRequire("aEdcH");
var $d0wrd = parcelRequire("d0wrd");
var $j5Nf5 = parcelRequire("j5Nf5");
var $irKna = parcelRequire("irKna");

var $2sRUp = parcelRequire("2sRUp");

var $8BfOE = parcelRequire("8BfOE");
var $fiH3o = parcelRequire("fiH3o");

var $8I0FM = parcelRequire("8I0FM");

var $eMHXg = parcelRequire("eMHXg");

var $11Kyb = parcelRequire("11Kyb");

var $hqUzy = parcelRequire("hqUzy");

var $6ErCG = parcelRequire("6ErCG");

var $2RwaJ = parcelRequire("2RwaJ");

var $6xfPA = parcelRequire("6xfPA");

var $lGXk2 = parcelRequire("lGXk2");

var $9Qxbv = parcelRequire("9Qxbv");

var $hrOrS = parcelRequire("hrOrS");

var $1jsZA = parcelRequire("1jsZA");

var $1SsJn = parcelRequire("1SsJn");

var $jXfNZ = parcelRequire("jXfNZ");

var $2PJOp = parcelRequire("2PJOp");
const $ba2713e1b02f2913$var$ProjectCreateImporterUploadFlow = ({ onEnterFullScreenMode: onEnterFullScreenMode, onExitFullScreenMode: onExitFullScreenMode, onClose: onClose, onDrawerClose: onDrawerClose })=>{
    const [, { setStep: setStep, setImportTypeAndStep: setImportTypeAndStep, resetStateAndReturnToUploadStep: resetStateAndReturnToUploadStep, resetState: resetState }] = (0, $j5Nf5.useStep)();
    const [{ type: projectType, style: projectStyle }, { resetProjectData: resetProjectData }] = (0, $d0wrd.useProjectData)();
    const { productSteps: productSteps, currentStepIndex: currentStepIndex, currentStepConfig: currentStepConfig } = (0, $fiH3o.useProductSteps)();
    (0, $8BfOE.usePreventCancelImport)();
    const [importType] = (0, $aEdcH.useImportType)();
    const [, { setThirdPartyImportSettings: setThirdPartyImportSettings }] = (0, $irKna.useThirdPartyState)();
    const [source] = (0, $2sRUp.useSource)();
    const userAccess = (0, $jNdPf.useUserAccess)();
    (0, $eUqFw.useEffect)(()=>()=>{
            setImportTypeAndStep({
                importType: (0, $3ak5x.DEFAULT),
                step: (0, $eI5EY.fg)('enable-x2c-standardised-flow') ? (0, $1pm5p.SELECT_SOURCE_STEP) : (0, $1pm5p.SELECT_PRODUCT_STEP)
            });
        }, [
        setImportTypeAndStep
    ]);
    // used by left hand corner close and return button
    const onCloseAndReturnToUploadStep = (0, $eUqFw.useCallback)(()=>{
        onExitFullScreenMode();
        if ((0, $eI5EY.fg)('enable-x2c-standardised-flow')) resetState();
        else resetStateAndReturnToUploadStep();
        onClose && onClose();
    }, [
        onClose,
        onExitFullScreenMode,
        resetStateAndReturnToUploadStep,
        resetState
    ]);
    const onReturn = (0, $eUqFw.useCallback)(()=>{
        const prevStep = currentStepConfig?.overrides?.overrideReturnStep || productSteps[currentStepIndex - 1].step;
        const shouldExitFullScreen = (0, $eI5EY.fg)('enable-x2c-standardised-flow') ? prevStep === (0, $1pm5p.SELECT_SOURCE_STEP) : prevStep === (0, $1pm5p.UPLOAD_CSV_STEP) || prevStep === (0, $1pm5p.UPLOAD_CSV_STANDARD_STEP);
        if (shouldExitFullScreen) {
            onExitFullScreenMode();
            // do not reset projectData when navigating back in the csv flow
            if (importType !== (0, $3ak5x.CSV)) resetProjectData();
            setImportTypeAndStep({
                importType: (0, $3ak5x.DEFAULT),
                step: prevStep
            });
            return;
        }
        setStep(prevStep);
    }, [
        currentStepConfig,
        productSteps,
        currentStepIndex,
        setStep,
        onExitFullScreenMode,
        importType,
        setImportTypeAndStep,
        resetProjectData
    ]);
    const onNext = (0, $eUqFw.useCallback)((nextImportType, supportedFlow)=>{
        const currentStep = productSteps[currentStepIndex].step;
        const shouldEnterFullScreen = (0, $eI5EY.fg)('enable-x2c-standardised-flow') ? currentStep === (0, $1pm5p.SELECT_SOURCE_STEP) : currentStep === (0, $1pm5p.UPLOAD_CSV_STEP) || currentStep === (0, $1pm5p.UPLOAD_CSV_STANDARD_STEP);
        if (shouldEnterFullScreen && nextImportType) {
            onEnterFullScreenMode();
            const nextStepAfterUploadCSV = (0, $l58Ze.getFirstStep)({
                importType: nextImportType,
                projectType: projectType,
                source: source,
                supportedFlow: supportedFlow
            });
            // clear projectData if the user selects 3P importType
            if (nextImportType !== (0, $3ak5x.CSV)) resetProjectData();
            if (nextImportType === (0, $3ak5x.CLICK_UP)) setThirdPartyImportSettings({
                shouldImportComments: false,
                shouldImportAttachments: false
            });
            setImportTypeAndStep({
                importType: nextImportType,
                step: nextStepAfterUploadCSV
            });
            return;
        }
        const nextStep = currentStepConfig.overrides.overrideNextStep || productSteps[currentStepIndex + 1].step;
        setStep(nextStep);
    }, [
        productSteps,
        currentStepIndex,
        currentStepConfig.overrides.overrideNextStep,
        setStep,
        onEnterFullScreenMode,
        projectType,
        source,
        setImportTypeAndStep,
        resetProjectData,
        setThirdPartyImportSettings
    ]);
    const baseStepsProps = {
        onNext: onNext,
        onReturn: onReturn,
        onCloseAndReturnToUploadStep: onCloseAndReturnToUploadStep
    };
    const getContent = ()=>{
        switch(currentStepConfig.step){
            case 0, $1pm5p.UPLOAD_CSV_STEP:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1SsJn.UploadScreen), baseStepsProps);
            case 0, $1pm5p.UPLOAD_CSV_STANDARD_STEP:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jXfNZ.UploadScreenStandard), {
                    ...currentStepConfig?.stepProps,
                    ...baseStepsProps,
                    onClose: ()=>onClose && onClose()
                });
            case 0, $1pm5p.MAPPING_STEP:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hqUzy.MappingScreen), {
                    ...baseStepsProps,
                    ...currentStepConfig.stepProps
                });
            case 0, $1pm5p.PROJECT_CREATE_STEP:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ErCG.ProjectCreateScreen), {
                    ...baseStepsProps,
                    ...currentStepConfig.stepProps
                });
            case 0, $1pm5p.IMPORT_IN_PROGRESS_STEP:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $11Kyb.ImportInProgressScreen), {
                    ...baseStepsProps,
                    ...currentStepConfig.stepProps,
                    onDrawerClose: onDrawerClose
                });
            case 0, $1pm5p.SELECT_THIRD_PARTY_ENTITY_STEP:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hrOrS.SelectThirdPartyEntityScreen), {
                    ...baseStepsProps,
                    ...currentStepConfig.stepProps
                });
            case 0, $1pm5p.USER_MAPPING_STEP:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2PJOp.UserMappingScreen), {
                    ...baseStepsProps,
                    ...currentStepConfig.stepProps
                });
            case 0, $1pm5p.CSV_USER_MAPPING_STEP:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eMHXg.CSVUserMappingScreen), {
                    ...baseStepsProps,
                    ...currentStepConfig.stepProps
                });
            case 0, $1pm5p.THIRD_PARTY_REVIEW_STEP:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1jsZA.ThirdPartyReviewScreen), {
                    ...baseStepsProps,
                    ...currentStepConfig.stepProps
                });
            case 0, $1pm5p.REVIEW_SCREEN_STANDARD_STEP:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6xfPA.ReviewScreenStandard), {
                    ...baseStepsProps,
                    ...currentStepConfig.stepProps
                });
            default:
                return (0, $eI5EY.fg)('enable-x2c-standardised-flow') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Qxbv.SelectSourceScreen), baseStepsProps) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lGXk2.SelectProductScreen), null);
        }
    };
    const analyticsAttributes = (0, $eUqFw.useMemo)(()=>({
            projectType: projectType,
            projectStyle: projectStyle,
            importType: importType,
            userAccess: userAccess,
            source: source
        }), [
        userAccess,
        importType,
        projectStyle,
        projectType,
        source
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jNdPf.AnalyticsAttributesContext).Provider, {
        value: analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        attributes: analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ba2713e1b02f2913$var$Wrapper, null, getContent()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8I0FM.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RwaJ.default), {
        onCloseAndReturnToUploadStep: onCloseAndReturnToUploadStep,
        showCurrentAccount: 'shouldShowAccountInfoIfUsingPAT' in currentStepConfig.stepProps && currentStepConfig.stepProps.shouldShowAccountInfoIfUsingPAT === true
    })));
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ba2713e1b02f2913$export$2e2bcd8739ae039 = (props)=>{
    const importerContext = (0, $63nHt.useImporterContextFromQueryParams)();
    (0, $eUqFw.useEffect)(()=>{
        if (importerContext && importerContext?.importType !== (0, $3ak5x.DEFAULT)) props.onEnterFullScreenMode();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        importerContext?.importType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8JicK.Container), {
        projectType: props.projectType,
        importerContext: importerContext,
        project: props.project
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ba2713e1b02f2913$var$ProjectCreateImporterUploadFlow, props));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ba2713e1b02f2913$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb1osq _4t3i1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jNdPf", function(module, exports) {

$parcel$export(module.exports, "useUserAccess", () => $73457b58a3237de0$export$365cffb4b16060d5);
$parcel$export(module.exports, "AnalyticsAttributesContext", () => $73457b58a3237de0$export$d85a999a714c8f14);
$parcel$export(module.exports, "useAnalyticsAttributesContext", () => $73457b58a3237de0$export$da4da5285a2fd344);

var $eUqFw = parcelRequire("eUqFw");

var $gd0Sp = parcelRequire("gd0Sp");

var $3ak5x = parcelRequire("3ak5x");

var $9HsT0 = parcelRequire("9HsT0");
const $73457b58a3237de0$export$365cffb4b16060d5 = ()=>{
    const { isSiteAdmin: isSiteAdmin } = (0, $gd0Sp.useTenantContext)();
    if (isSiteAdmin) return 0, $3ak5x.SITE_ADMIN;
    return 0, $3ak5x.CREATE_PROJECT;
};
const $73457b58a3237de0$export$d85a999a714c8f14 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    projectType: (0, $9HsT0.INITIAL_STATE).projectData.type,
    projectStyle: (0, $9HsT0.INITIAL_STATE).projectData.style,
    importType: (0, $9HsT0.INITIAL_STATE).importType,
    userAccess: (0, $3ak5x.CREATE_PROJECT),
    source: (0, $9HsT0.INITIAL_STATE).source
});
const $73457b58a3237de0$export$da4da5285a2fd344 = ()=>(0, $eUqFw.useContext)($73457b58a3237de0$export$d85a999a714c8f14);

});

parcelRegister("l58Ze", function(module, exports) {

$parcel$export(module.exports, "getStepConfig", () => $897fdcee3d2ded78$export$ccdb3af44073db91);
$parcel$export(module.exports, "getFirstStep", () => $897fdcee3d2ded78$export$30c4b219166978f);

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $3ak5x = parcelRequire("3ak5x");

var $9R4E5 = parcelRequire("9R4E5");


var $1pm5p = parcelRequire("1pm5p");


var $3bWBd = parcelRequire("3bWBd");

var $5Xfp1 = parcelRequire("5Xfp1");

var $14kdu = parcelRequire("14kdu");

var $443LC = parcelRequire("443LC");

var $1Lm9W = parcelRequire("1Lm9W");

var $mStu1 = parcelRequire("mStu1");
const $897fdcee3d2ded78$var$getDefaultStepConfig = (source, skipProductStep)=>skipProductStep ? [
        {
            ...(0, $1pm5p.DEFAULT_CONFIG),
            overrides: source === (0, $85ba070c29b4a3bd$export$ec4d35718915f521) ? {} : {
                overrideReturnStep: (0, $1pm5p.SELECT_PRODUCT_STEP)
            },
            step: source === (0, $85ba070c29b4a3bd$export$ec4d35718915f521) ? (0, $1pm5p.UPLOAD_CSV_STANDARD_STEP) : (0, $1pm5p.UPLOAD_CSV_STEP)
        }
    ] : [
        {
            ...(0, $1pm5p.DEFAULT_CONFIG),
            step: (0, $1pm5p.SELECT_PRODUCT_STEP)
        },
        {
            ...(0, $1pm5p.DEFAULT_CONFIG),
            step: source === (0, $85ba070c29b4a3bd$export$ec4d35718915f521) ? (0, $1pm5p.UPLOAD_CSV_STANDARD_STEP) : (0, $1pm5p.UPLOAD_CSV_STEP)
        }
    ];
const $897fdcee3d2ded78$var$getJWMStepConfig = ({ importType: importType, isSiteAdmin: isSiteAdmin, isAdmin: isAdmin, source: source })=>{
    const hiddenUsers = (0, $1ybV0.ff)('gun-2207-non-admin-support-in-tmp-migration_k7z9p') && !isSiteAdmin && (!isAdmin || !(0, $1ybV0.ff)('enable-product-admin-for-x2c-migration_zmlsv'));
    switch(importType){
        case 0, $3ak5x.CSV:
            return (0, $14kdu.getCSVSteps)((0, $9R4E5.ProjectTypes).BUSINESS, source);
        case 0, $3ak5x.TRELLO:
            return (0, $mStu1.getTrelloSteps)(hiddenUsers);
        case 0, $3ak5x.ASANA:
            return (0, $3bWBd.getAsanaSteps)(hiddenUsers, (0, $9R4E5.ProjectTypes).BUSINESS);
        case 0, $3ak5x.MONDAY:
            return (0, $1Lm9W.getMondaySteps)();
        case 0, $3ak5x.JIRA_SOFTWARE:
            return (0, $443LC.getSoftwareToBusinessSteps)();
        case 0, $3ak5x.CLICK_UP:
            return (0, $5Xfp1.getClickUpSteps)();
        default:
            return $897fdcee3d2ded78$var$getDefaultStepConfig(source, true);
    }
};
const $897fdcee3d2ded78$var$getJSWStepConfig = ({ importType: importType, isSiteAdmin: isSiteAdmin, isAdmin: isAdmin, source: source })=>{
    const hiddenUsers = (0, $1ybV0.ff)('gun-2207-non-admin-support-in-tmp-migration_k7z9p') && !isSiteAdmin && (!isAdmin || !(0, $1ybV0.ff)('enable-product-admin-for-x2c-migration_zmlsv'));
    switch(importType){
        case 0, $3ak5x.CSV:
            return (0, $14kdu.getCSVSteps)((0, $9R4E5.ProjectTypes).SOFTWARE, source);
        case 0, $3ak5x.TRELLO:
            return (0, $mStu1.getTrelloSteps)(hiddenUsers);
        case 0, $3ak5x.ASANA:
            return (0, $3bWBd.getAsanaSteps)(hiddenUsers, (0, $9R4E5.ProjectTypes).SOFTWARE);
        case 0, $3ak5x.JIRA_BUSINESS:
            return (0, $443LC.getBusinessToSoftwareSteps)();
        default:
            return $897fdcee3d2ded78$var$getDefaultStepConfig(source, true);
    }
};
const $897fdcee3d2ded78$var$getStandardizedStepConfig = ({ importType: importType, isSiteAdmin: isSiteAdmin, isAdmin: isAdmin, source: source, supportedFlow: supportedFlow })=>{
    const hiddenUsers = (0, $1ybV0.ff)('gun-2207-non-admin-support-in-tmp-migration_k7z9p') && !isSiteAdmin && (!isAdmin || !(0, $1ybV0.ff)('enable-product-admin-for-x2c-migration_zmlsv'));
    const isAPIFlow = supportedFlow === (0, $d46558193b478af8$export$5a613e161b9e89e5);
    if (isAPIFlow) switch(importType){
        case 0, $3ak5x.TRELLO:
            return (0, $mStu1.getTrelloSteps)(hiddenUsers);
        case 0, $3ak5x.ASANA:
            return (0, $3bWBd.getAsanaSteps)(hiddenUsers);
        case 0, $3ak5x.MONDAY:
            return (0, $1Lm9W.getMondaySteps)();
        case 0, $3ak5x.JIRA_SOFTWARE:
            return (0, $443LC.getSoftwareToBusinessSteps)();
        case 0, $3ak5x.JIRA_BUSINESS:
            return (0, $443LC.getBusinessToSoftwareSteps)();
        case 0, $3ak5x.CLICK_UP:
            return (0, $5Xfp1.getClickUpSteps)();
        default:
            break;
    }
    if (importType === (0, $3ak5x.DEFAULT) && source !== (0, $85ba070c29b4a3bd$export$ec4d35718915f521) || source === (0, $85ba070c29b4a3bd$export$44f7961a4c8dc451)) return [
        {
            ...(0, $1pm5p.DEFAULT_CONFIG),
            step: (0, $1pm5p.SELECT_SOURCE_STEP)
        }
    ];
    return (0, $14kdu.getStandardisedCSVSteps)({
        importType: importType,
        source: source,
        isSiteAdmin: isSiteAdmin,
        isAdmin: isAdmin
    });
};
const $897fdcee3d2ded78$export$ccdb3af44073db91 = (props)=>{
    const { importType: importType, projectType: projectType, isSiteAdmin: isSiteAdmin, source: source, skipProductStep: skipProductStep } = props;
    if ((0, $eI5EY.fg)('enable-x2c-standardised-flow')) return $897fdcee3d2ded78$var$getStandardizedStepConfig(props);
    switch(projectType){
        case (0, $9R4E5.ProjectTypes).SOFTWARE:
            return $897fdcee3d2ded78$var$getJSWStepConfig({
                importType: importType,
                isSiteAdmin: isSiteAdmin,
                source: source
            });
        case (0, $9R4E5.ProjectTypes).BUSINESS:
            return $897fdcee3d2ded78$var$getJWMStepConfig({
                importType: importType,
                isSiteAdmin: isSiteAdmin,
                source: source
            });
        default:
            return $897fdcee3d2ded78$var$getDefaultStepConfig(source, skipProductStep);
    }
};
const $897fdcee3d2ded78$export$30c4b219166978f = (props)=>{
    const steps = $897fdcee3d2ded78$export$ccdb3af44073db91(props);
    return steps[0].step;
};

});
const $d46558193b478af8$export$e87ab702cc1b919b = 'CSV';
const $d46558193b478af8$export$5a613e161b9e89e5 = 'API';

parcelRegister("3bWBd", function(module, exports) {

$parcel$export(module.exports, "getAsanaSteps", () => $b774db7665d88258$export$f0de51d1f2435dbc);

var $eI5EY = parcelRequire("eI5EY");

var $3ak5x = parcelRequire("3ak5x");

var $9R4E5 = parcelRequire("9R4E5");

var $1pm5p = parcelRequire("1pm5p");

var $5uhLI = parcelRequire("5uhLI");

var $gAV7B = parcelRequire("gAV7B");
const $b774db7665d88258$export$f0de51d1f2435dbc = (hiddenUsers, projectType)=>[
        {
            step: (0, $1pm5p.SELECT_THIRD_PARTY_ENTITY_STEP),
            overrides: {
                overrideReturnStep: (0, $eI5EY.fg)('enable-x2c-standardised-flow') ? (0, $1pm5p.SELECT_SOURCE_STEP) : (0, $1pm5p.UPLOAD_CSV_STEP)
            },
            stepProps: {
                thirdParty: (0, $3ak5x.ASANA),
                stats: hiddenUsers ? [
                    (0, $1pm5p.StatisticsType).TASKS
                ] : [
                    (0, $1pm5p.StatisticsType).TASKS,
                    (0, $1pm5p.StatisticsType).MEMBERS
                ],
                hasSearchableEntities: true
            },
            progressBarStepLabel: (0, $gAV7B.default).asanaStepLabel
        },
        {
            ...(0, $1pm5p.DEFAULT_CONFIG),
            step: (0, $1pm5p.PROJECT_CREATE_STEP),
            stepProps: {
                hasProgressBar: true,
                shouldPrefillThirdPartyProjectName: true,
                shouldShowThirdPartyStats: false,
                thirdParty: (0, $3ak5x.ASANA),
                shouldStartImportOnNext: false,
                isTMPSupported: true,
                templates: projectType === (0, $9R4E5.ProjectTypes).SOFTWARE || (0, $eI5EY.fg)('enable-x2c-standardised-flow') ? (0, $1pm5p.templatesJSW) : []
            },
            progressBarStepLabel: (0, $5uhLI.default).projectCreateStepLabel
        },
        {
            ...(0, $1pm5p.DEFAULT_CONFIG),
            step: (0, $1pm5p.THIRD_PARTY_REVIEW_STEP),
            stepProps: {
                thirdParty: (0, $3ak5x.ASANA),
                tiles: hiddenUsers ? [
                    (0, $1pm5p.ReviewTilesType).HIERARCHY,
                    (0, $1pm5p.ReviewTilesType).FIELDS,
                    (0, $1pm5p.ReviewTilesType).ATTACHMENTS
                ] : [
                    (0, $1pm5p.ReviewTilesType).HIERARCHY,
                    (0, $1pm5p.ReviewTilesType).FIELDS,
                    (0, $1pm5p.ReviewTilesType).USERS,
                    (0, $1pm5p.ReviewTilesType).ATTACHMENTS
                ]
            },
            progressBarStepLabel: (0, $5uhLI.default).reviewStepLabel
        },
        {
            step: (0, $1pm5p.IMPORT_IN_PROGRESS_STEP),
            overrides: {
                overrideReturnStep: (0, $eI5EY.fg)('enable-x2c-standardised-flow') ? (0, $1pm5p.SELECT_SOURCE_STEP) : (0, $1pm5p.UPLOAD_CSV_STEP)
            },
            stepProps: {
                hasProgressBar: true,
                thirdParty: (0, $3ak5x.ASANA)
            },
            progressBarStepLabel: (0, $5uhLI.default).importInProgressStepLabel
        }
    ];

});
parcelRegister("5uhLI", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6cf6ff132abf6ce$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e6cf6ff132abf6ce$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    jiraProjectCreateStepLabel: {
        "id": "project-create-importer-upload-flow.common.utils.import-steps.jira-project-create-step-label",
        "defaultMessage": "Create business project"
    },
    projectCreateStepLabel: {
        "id": "project-create-importer-upload-flow.common.utils.import-steps.project-create-step-label",
        "defaultMessage": "Create project"
    },
    reviewStepLabel: {
        "id": "project-create-importer-upload-flow.common.utils.import-steps.review-step-label",
        "defaultMessage": "Review details"
    },
    importInProgressStepLabel: {
        "id": "project-create-importer-upload-flow.common.utils.import-steps.import-in-progress-step-label",
        "defaultMessage": "Import data"
    },
    uploadCsv: {
        "id": "project-create-importer-upload-flow.common.utils.import-steps.upload-csv",
        "defaultMessage": "Upload CSV"
    },
    setupProject: {
        "id": "project-create-importer-upload-flow.common.utils.import-steps.setup-project",
        "defaultMessage": "Set up project"
    },
    mapFields: {
        "id": "project-create-importer-upload-flow.common.utils.import-steps.map-fields",
        "defaultMessage": "Map fields"
    },
    usersMapping: {
        "id": "project-create-importer-upload-flow.common.utils.import-steps.users-mapping",
        "defaultMessage": "Move users"
    },
    review: {
        "id": "project-create-importer-upload-flow.common.utils.import-steps.review",
        "defaultMessage": "Review details"
    }
});

});

parcelRegister("gAV7B", function(module, exports) {

$parcel$export(module.exports, "default", () => $747cb83f1d15cf8b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $747cb83f1d15cf8b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    asanaStepLabel: {
        "id": "project-create-importer-upload-flow.common.utils.import-steps.asana.asana-step-label",
        "defaultMessage": "Select project"
    }
});

});


parcelRegister("5Xfp1", function(module, exports) {

$parcel$export(module.exports, "getClickUpSteps", () => $14976d3cdb72667d$export$daef60a30c2880b7);

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $3ak5x = parcelRequire("3ak5x");

var $1pm5p = parcelRequire("1pm5p");

var $5uhLI = parcelRequire("5uhLI");

var $8hS7v = parcelRequire("8hS7v");
const $14976d3cdb72667d$export$daef60a30c2880b7 = ()=>[
        {
            step: (0, $1pm5p.SELECT_THIRD_PARTY_ENTITY_STEP),
            overrides: {
                overrideReturnStep: (0, $eI5EY.fg)('enable-x2c-standardised-flow') ? (0, $1pm5p.SELECT_SOURCE_STEP) : (0, $1pm5p.UPLOAD_CSV_STEP)
            },
            stepProps: {
                thirdParty: (0, $3ak5x.CLICK_UP),
                stats: [
                    (0, $1pm5p.StatisticsType).TASKS
                ],
                shouldShowSpaceSelector: true,
                shouldShowFolderSelector: true,
                isMultipleEntitiesSupported: (0, $1ybV0.ff)('x2c-clickup-importer-multi-list')
            },
            progressBarStepLabel: (0, $8hS7v.default).clickupStepLabel
        },
        {
            ...(0, $1pm5p.DEFAULT_CONFIG),
            step: (0, $1pm5p.PROJECT_CREATE_STEP),
            stepProps: {
                hasProgressBar: true,
                shouldPrefillThirdPartyProjectName: true,
                shouldShowThirdPartyStats: false,
                thirdParty: (0, $3ak5x.CLICK_UP),
                shouldStartImportOnNext: false,
                isTMPSupported: true,
                templates: []
            },
            progressBarStepLabel: (0, $5uhLI.default).projectCreateStepLabel
        },
        {
            ...(0, $1pm5p.DEFAULT_CONFIG),
            step: (0, $1pm5p.THIRD_PARTY_REVIEW_STEP),
            stepProps: {
                thirdParty: (0, $3ak5x.CLICK_UP),
                isMultipleEntitiesSupported: (0, $1ybV0.ff)('x2c-clickup-importer-multi-list'),
                tiles: (0, $1ybV0.ff)('x2c-clickup-importer-multi-list') ? [
                    (0, $1pm5p.ReviewTilesType).HIERARCHY,
                    (0, $1pm5p.ReviewTilesType).STATUS,
                    (0, $1pm5p.ReviewTilesType).FIELDS,
                    (0, $1pm5p.ReviewTilesType).USERS,
                    (0, $1pm5p.ReviewTilesType).ATTACHMENTS,
                    (0, $1pm5p.ReviewTilesType).COMMENTS
                ] : [
                    (0, $1pm5p.ReviewTilesType).HIERARCHY,
                    (0, $1pm5p.ReviewTilesType).FIELDS,
                    (0, $1pm5p.ReviewTilesType).USERS,
                    (0, $1pm5p.ReviewTilesType).ATTACHMENTS,
                    (0, $1pm5p.ReviewTilesType).COMMENTS
                ]
            },
            progressBarStepLabel: (0, $5uhLI.default).reviewStepLabel
        },
        {
            step: (0, $1pm5p.IMPORT_IN_PROGRESS_STEP),
            overrides: {
                overrideReturnStep: (0, $eI5EY.fg)('enable-x2c-standardised-flow') ? (0, $1pm5p.SELECT_SOURCE_STEP) : (0, $1pm5p.UPLOAD_CSV_STEP)
            },
            stepProps: {
                hasProgressBar: true,
                thirdParty: (0, $3ak5x.CLICK_UP)
            },
            progressBarStepLabel: (0, $5uhLI.default).importInProgressStepLabel
        }
    ];

});
parcelRegister("8hS7v", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e518953d333dec5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7e518953d333dec5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    clickupStepLabel: {
        "id": "project-create-importer-upload-flow.common.utils.import-steps.clickup.clickup-step-label",
        "defaultMessage": "Select list"
    }
});

});


parcelRegister("14kdu", function(module, exports) {

$parcel$export(module.exports, "getCSVSteps", () => $e484ed7894d39ed2$export$d55e53e532dfea89);
$parcel$export(module.exports, "getStandardisedCSVSteps", () => $e484ed7894d39ed2$export$ea5bfbcc9f18c2a);

var $1ybV0 = parcelRequire("1ybV0");

var $9R4E5 = parcelRequire("9R4E5");


var $1pm5p = parcelRequire("1pm5p");

var $5uhLI = parcelRequire("5uhLI");
const $e484ed7894d39ed2$export$d55e53e532dfea89 = (projectType, source)=>{
    if (source === (0, $85ba070c29b4a3bd$export$ec4d35718915f521)) return [
        {
            ...(0, $1pm5p.DEFAULT_CONFIG),
            step: (0, $1pm5p.MAPPING_STEP),
            overrides: {
                overrideReturnStep: (0, $1pm5p.UPLOAD_CSV_STANDARD_STEP)
            },
            stepProps: {
                shouldStartImportOnNext: true,
                showLearnMoreLink: projectType === (0, $9R4E5.ProjectTypes).BUSINESS,
                isCompact: true,
                hideFeedback: true,
                rightAlignFooter: true,
                offsetModalY: 60
            }
        },
        {
            step: (0, $1pm5p.IMPORT_IN_PROGRESS_STEP),
            overrides: {
                overrideReturnStep: (0, $1pm5p.UPLOAD_CSV_STANDARD_STEP)
            },
            stepProps: {
                hasProgressBar: false,
                showCrossButton: true,
                isCompact: true
            }
        }
    ];
    return [
        {
            ...(0, $1pm5p.DEFAULT_CONFIG),
            step: (0, $1pm5p.PROJECT_CREATE_STEP),
            overrides: {
                overrideReturnStep: (0, $1pm5p.UPLOAD_CSV_STEP)
            },
            stepProps: {
                hasProgressBar: false,
                shouldPrefillThirdPartyProjectName: false,
                shouldShowThirdPartyStats: false,
                shouldStartImportOnNext: false,
                isTMPSupported: true,
                templates: projectType === (0, $9R4E5.ProjectTypes).SOFTWARE ? (0, $1pm5p.templatesJSW) : []
            },
            progressBarStepLabel: (0, $5uhLI.default).projectCreateStepLabel
        },
        {
            ...(0, $1pm5p.DEFAULT_CONFIG),
            step: (0, $1pm5p.MAPPING_STEP),
            stepProps: {
                shouldStartImportOnNext: true,
                showLearnMoreLink: projectType === (0, $9R4E5.ProjectTypes).BUSINESS
            }
        },
        {
            step: (0, $1pm5p.IMPORT_IN_PROGRESS_STEP),
            overrides: {
                overrideReturnStep: (0, $1pm5p.UPLOAD_CSV_STEP)
            },
            stepProps: {
                hasProgressBar: false
            }
        }
    ];
};
const $e484ed7894d39ed2$export$ea5bfbcc9f18c2a = ({ importType: importType, source: source, isSiteAdmin: isSiteAdmin, isAdmin: isAdmin })=>{
    if (source === (0, $85ba070c29b4a3bd$export$ec4d35718915f521)) return [
        {
            ...(0, $1pm5p.DEFAULT_CONFIG),
            step: (0, $1pm5p.UPLOAD_CSV_STANDARD_STEP),
            overrides: {
                overrideReturnStep: (0, $1pm5p.SELECT_SOURCE_STEP)
            },
            stepProps: {
                isCompact: true,
                importType: importType
            }
        },
        {
            ...(0, $1pm5p.DEFAULT_CONFIG),
            step: (0, $1pm5p.MAPPING_STEP),
            overrides: {
                overrideReturnStep: (0, $1pm5p.UPLOAD_CSV_STANDARD_STEP)
            },
            stepProps: {
                shouldStartImportOnNext: false,
                isCompact: true
            }
        },
        {
            step: (0, $1pm5p.IMPORT_IN_PROGRESS_STEP),
            overrides: {
                overrideReturnStep: (0, $1pm5p.SELECT_SOURCE_STEP)
            },
            stepProps: {
                hasProgressBar: false,
                showCrossButton: true,
                isCompact: true
            }
        }
    ];
    let steps = [
        {
            ...(0, $1pm5p.DEFAULT_CONFIG),
            step: (0, $1pm5p.UPLOAD_CSV_STANDARD_STEP),
            overrides: {
                overrideReturnStep: (0, $1pm5p.SELECT_SOURCE_STEP)
            },
            stepProps: {
                isCompact: false,
                importType: importType
            },
            progressBarStepLabel: (0, $5uhLI.default).uploadCsv
        },
        {
            ...(0, $1pm5p.DEFAULT_CONFIG),
            step: (0, $1pm5p.PROJECT_CREATE_STEP),
            overrides: {
                overrideReturnStep: (0, $1pm5p.UPLOAD_CSV_STANDARD_STEP)
            },
            stepProps: {
                // TODO: remove hasProgressBar and isTMPSupported when clean up FF 'enable-x2c-standardised-flow'
                hasProgressBar: true,
                isTMPSupported: true,
                shouldPrefillThirdPartyProjectName: false,
                shouldShowThirdPartyStats: false,
                shouldStartImportOnNext: false,
                templates: (0, $1pm5p.templatesJSW),
                importType: importType
            },
            progressBarStepLabel: (0, $5uhLI.default).setupProject
        },
        {
            ...(0, $1pm5p.DEFAULT_CONFIG),
            step: (0, $1pm5p.MAPPING_STEP),
            stepProps: {
                shouldStartImportOnNext: false,
                showLearnMoreLink: false
            },
            progressBarStepLabel: (0, $5uhLI.default).mapFields
        },
        {
            ...(0, $1pm5p.DEFAULT_CONFIG),
            step: (0, $1pm5p.CSV_USER_MAPPING_STEP),
            stepProps: {
                importType: importType
            },
            progressBarStepLabel: (0, $5uhLI.default).usersMapping
        },
        {
            ...(0, $1pm5p.DEFAULT_CONFIG),
            step: (0, $1pm5p.REVIEW_SCREEN_STANDARD_STEP),
            stepProps: {
                tiles: isSiteAdmin || isAdmin && (0, $1ybV0.ff)('enable-product-admin-for-x2c-migration_zmlsv') ? [
                    (0, $1pm5p.CSVReviewTilesType).PROJECT_DETAILS,
                    (0, $1pm5p.CSVReviewTilesType).FIELDS,
                    (0, $1pm5p.CSVReviewTilesType).USERS,
                    (0, $1pm5p.CSVReviewTilesType).ISSUES
                ] : [
                    (0, $1pm5p.CSVReviewTilesType).PROJECT_DETAILS,
                    (0, $1pm5p.CSVReviewTilesType).FIELDS
                ],
                shouldStartImportOnNext: true
            },
            progressBarStepLabel: (0, $5uhLI.default).review
        },
        {
            step: (0, $1pm5p.IMPORT_IN_PROGRESS_STEP),
            overrides: {
                overrideReturnStep: (0, $1pm5p.SELECT_SOURCE_STEP)
            },
            stepProps: {
                hasProgressBar: false
            }
        }
    ];
    if (!isSiteAdmin && (!isAdmin || !(0, $1ybV0.ff)('enable-product-admin-for-x2c-migration_zmlsv'))) steps = steps.filter((step)=>step.step !== (0, $1pm5p.CSV_USER_MAPPING_STEP));
    return steps;
};

});

parcelRegister("443LC", function(module, exports) {

$parcel$export(module.exports, "getSoftwareToBusinessSteps", () => $de17e0518f1712a3$export$4725df1ca2be01fc);
$parcel$export(module.exports, "getBusinessToSoftwareSteps", () => $de17e0518f1712a3$export$54ecf754086d412f);

var $eI5EY = parcelRequire("eI5EY");

var $3ak5x = parcelRequire("3ak5x");

var $1pm5p = parcelRequire("1pm5p");

var $5uhLI = parcelRequire("5uhLI");

var $8Dq0p = parcelRequire("8Dq0p");
const $de17e0518f1712a3$export$4725df1ca2be01fc = ()=>[
        {
            step: (0, $1pm5p.SELECT_THIRD_PARTY_ENTITY_STEP),
            overrides: {
                overrideReturnStep: (0, $eI5EY.fg)('enable-x2c-standardised-flow') ? (0, $1pm5p.SELECT_SOURCE_STEP) : (0, $1pm5p.UPLOAD_CSV_STEP)
            },
            stepProps: {
                thirdParty: (0, $3ak5x.JIRA_SOFTWARE),
                stats: [
                    (0, $1pm5p.StatisticsType).TASKS
                ],
                shouldShowPlaceholderIcons: true,
                hideWorkspaceSelector: true,
                hasSearchableEntities: true
            },
            progressBarStepLabel: (0, $8Dq0p.default).jiraStepLabel
        },
        {
            ...(0, $1pm5p.DEFAULT_CONFIG),
            step: (0, $1pm5p.PROJECT_CREATE_STEP),
            stepProps: {
                hasProgressBar: true,
                shouldPrefillThirdPartyProjectName: false,
                shouldShowThirdPartyStats: false,
                thirdParty: (0, $3ak5x.JIRA_SOFTWARE),
                shouldStartImportOnNext: false,
                isTMPSupported: true,
                templates: []
            },
            progressBarStepLabel: (0, $5uhLI.default).jiraProjectCreateStepLabel
        },
        {
            ...(0, $1pm5p.DEFAULT_CONFIG),
            step: (0, $1pm5p.THIRD_PARTY_REVIEW_STEP),
            stepProps: {
                thirdParty: (0, $3ak5x.JIRA_SOFTWARE),
                tiles: [
                    (0, $1pm5p.ReviewTilesType).FIELDS,
                    (0, $1pm5p.ReviewTilesType).USERS,
                    (0, $1pm5p.ReviewTilesType).ATTACHMENTS
                ]
            },
            progressBarStepLabel: (0, $5uhLI.default).reviewStepLabel
        },
        {
            step: (0, $1pm5p.IMPORT_IN_PROGRESS_STEP),
            overrides: {
                overrideReturnStep: (0, $eI5EY.fg)('enable-x2c-standardised-flow') ? (0, $1pm5p.SELECT_SOURCE_STEP) : (0, $1pm5p.UPLOAD_CSV_STEP)
            },
            stepProps: {
                hasProgressBar: true,
                hasImportUsers: false,
                thirdParty: (0, $3ak5x.JIRA_SOFTWARE)
            },
            progressBarStepLabel: (0, $5uhLI.default).importInProgressStepLabel
        }
    ];
const $de17e0518f1712a3$export$54ecf754086d412f = ()=>[
        {
            step: (0, $1pm5p.SELECT_THIRD_PARTY_ENTITY_STEP),
            overrides: {
                overrideReturnStep: (0, $eI5EY.fg)('enable-x2c-standardised-flow') ? (0, $1pm5p.SELECT_SOURCE_STEP) : (0, $1pm5p.UPLOAD_CSV_STEP)
            },
            stepProps: {
                thirdParty: (0, $3ak5x.JIRA_BUSINESS),
                stats: [
                    (0, $1pm5p.StatisticsType).TASKS
                ],
                shouldShowPlaceholderIcons: true,
                hideWorkspaceSelector: true,
                hasSearchableEntities: true
            },
            progressBarStepLabel: (0, $8Dq0p.default).jiraBusinessStepLabel
        },
        {
            ...(0, $1pm5p.DEFAULT_CONFIG),
            step: (0, $1pm5p.PROJECT_CREATE_STEP),
            stepProps: {
                hasProgressBar: true,
                shouldPrefillThirdPartyProjectName: false,
                shouldShowThirdPartyStats: false,
                thirdParty: (0, $3ak5x.JIRA_BUSINESS),
                shouldStartImportOnNext: false,
                isTMPSupported: true,
                templates: (0, $1pm5p.templatesJSW)
            },
            progressBarStepLabel: (0, $8Dq0p.default).jiraSoftwareProjectCreateStepLabel
        },
        {
            ...(0, $1pm5p.DEFAULT_CONFIG),
            step: (0, $1pm5p.THIRD_PARTY_REVIEW_STEP),
            stepProps: {
                thirdParty: (0, $3ak5x.JIRA_BUSINESS),
                tiles: [
                    (0, $1pm5p.ReviewTilesType).FIELDS,
                    (0, $1pm5p.ReviewTilesType).USERS,
                    (0, $1pm5p.ReviewTilesType).ATTACHMENTS
                ]
            },
            progressBarStepLabel: (0, $5uhLI.default).reviewStepLabel
        },
        {
            step: (0, $1pm5p.IMPORT_IN_PROGRESS_STEP),
            overrides: {
                overrideReturnStep: (0, $eI5EY.fg)('enable-x2c-standardised-flow') ? (0, $1pm5p.SELECT_SOURCE_STEP) : (0, $1pm5p.UPLOAD_CSV_STEP)
            },
            stepProps: {
                hasProgressBar: true,
                hasImportUsers: false,
                thirdParty: (0, $3ak5x.JIRA_BUSINESS)
            },
            progressBarStepLabel: (0, $5uhLI.default).importInProgressStepLabel
        }
    ];

});
parcelRegister("8Dq0p", function(module, exports) {

$parcel$export(module.exports, "default", () => $50cd5793780ab06a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $50cd5793780ab06a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    jiraStepLabel: {
        "id": "project-create-importer-upload-flow.common.utils.import-steps.jira.jira-step-label",
        "defaultMessage": "Select software project"
    },
    jiraBusinessStepLabel: {
        "id": "project-create-importer-upload-flow.common.utils.import-steps.jira.jira-business-step-label",
        "defaultMessage": "Select project"
    },
    jiraSoftwareProjectCreateStepLabel: {
        "id": "project-create-importer-upload-flow.common.utils.import-steps.jira.jira-software-project-create-step-label",
        "defaultMessage": "Create project"
    }
});

});


parcelRegister("1Lm9W", function(module, exports) {

$parcel$export(module.exports, "getMondaySteps", () => $e32d216a18877089$export$a3abbc9ac7cc5d4d);

var $eI5EY = parcelRequire("eI5EY");

var $3ak5x = parcelRequire("3ak5x");

var $1pm5p = parcelRequire("1pm5p");

var $5uhLI = parcelRequire("5uhLI");

var $lTrfQ = parcelRequire("lTrfQ");
const $e32d216a18877089$export$a3abbc9ac7cc5d4d = ()=>[
        {
            step: (0, $1pm5p.SELECT_THIRD_PARTY_ENTITY_STEP),
            overrides: {
                overrideReturnStep: (0, $eI5EY.fg)('enable-x2c-standardised-flow') ? (0, $1pm5p.SELECT_SOURCE_STEP) : (0, $1pm5p.UPLOAD_CSV_STEP)
            },
            stepProps: {
                thirdParty: (0, $3ak5x.MONDAY),
                stats: [
                    (0, $1pm5p.StatisticsType).TASKS
                ],
                shouldShowFolderSelector: true,
                shouldShowAccountInfoIfUsingPAT: true
            },
            progressBarStepLabel: (0, $lTrfQ.default).mondayStepLabel
        },
        {
            ...(0, $1pm5p.DEFAULT_CONFIG),
            step: (0, $1pm5p.PROJECT_CREATE_STEP),
            stepProps: {
                hasProgressBar: true,
                shouldPrefillThirdPartyProjectName: true,
                shouldShowThirdPartyStats: false,
                thirdParty: (0, $3ak5x.MONDAY),
                shouldStartImportOnNext: false,
                isTMPSupported: true,
                templates: []
            },
            progressBarStepLabel: (0, $5uhLI.default).projectCreateStepLabel
        },
        {
            ...(0, $1pm5p.DEFAULT_CONFIG),
            step: (0, $1pm5p.THIRD_PARTY_REVIEW_STEP),
            stepProps: {
                thirdParty: (0, $3ak5x.MONDAY),
                tiles: [
                    (0, $1pm5p.ReviewTilesType).HIERARCHY,
                    (0, $1pm5p.ReviewTilesType).FIELDS,
                    (0, $1pm5p.ReviewTilesType).USERS,
                    (0, $1pm5p.ReviewTilesType).ATTACHMENTS
                ]
            },
            progressBarStepLabel: (0, $5uhLI.default).reviewStepLabel
        },
        {
            step: (0, $1pm5p.IMPORT_IN_PROGRESS_STEP),
            overrides: {
                overrideReturnStep: (0, $eI5EY.fg)('enable-x2c-standardised-flow') ? (0, $1pm5p.SELECT_SOURCE_STEP) : (0, $1pm5p.UPLOAD_CSV_STEP)
            },
            stepProps: {
                hasProgressBar: true,
                thirdParty: (0, $3ak5x.MONDAY)
            },
            progressBarStepLabel: (0, $5uhLI.default).importInProgressStepLabel
        }
    ];

});
parcelRegister("lTrfQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b117882e946199e4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b117882e946199e4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    mondayStepLabel: {
        "id": "project-create-importer-upload-flow.common.utils.import-steps.monday.monday-step-label",
        "defaultMessage": "Select board"
    }
});

});


parcelRegister("mStu1", function(module, exports) {

$parcel$export(module.exports, "getTrelloSteps", () => $646bf01f0b8e9726$export$2141d1b5d3738bc2);

var $eI5EY = parcelRequire("eI5EY");

var $3ak5x = parcelRequire("3ak5x");

var $1pm5p = parcelRequire("1pm5p");

var $5uhLI = parcelRequire("5uhLI");

var $rwYN6 = parcelRequire("rwYN6");
const $646bf01f0b8e9726$export$2141d1b5d3738bc2 = (hiddenUsers)=>{
    let steps = [
        {
            step: (0, $1pm5p.SELECT_THIRD_PARTY_ENTITY_STEP),
            overrides: {
                overrideReturnStep: (0, $eI5EY.fg)('enable-x2c-standardised-flow') ? (0, $1pm5p.SELECT_SOURCE_STEP) : (0, $1pm5p.UPLOAD_CSV_STEP)
            },
            stepProps: {
                thirdParty: (0, $3ak5x.TRELLO),
                stats: hiddenUsers ? [
                    (0, $1pm5p.StatisticsType).TASKS
                ] : [
                    (0, $1pm5p.StatisticsType).TASKS,
                    (0, $1pm5p.StatisticsType).MEMBERS
                ],
                shouldShowPlaceholderIcons: true
            },
            progressBarStepLabel: (0, $rwYN6.default).trelloStepLabel
        },
        {
            ...(0, $1pm5p.DEFAULT_CONFIG),
            step: (0, $1pm5p.USER_MAPPING_STEP),
            stepProps: {
                hasProgressBar: true,
                thirdParty: (0, $3ak5x.TRELLO)
            },
            progressBarStepLabel: (0, $rwYN6.default).userMappingStepLabel
        },
        {
            ...(0, $1pm5p.DEFAULT_CONFIG),
            step: (0, $1pm5p.PROJECT_CREATE_STEP),
            stepProps: {
                hasProgressBar: true,
                shouldPrefillThirdPartyProjectName: true,
                shouldShowThirdPartyStats: !hiddenUsers,
                thirdParty: (0, $3ak5x.TRELLO),
                shouldStartImportOnNext: true,
                isTMPSupported: true,
                templates: []
            },
            progressBarStepLabel: (0, $5uhLI.default).projectCreateStepLabel
        },
        {
            step: (0, $1pm5p.IMPORT_IN_PROGRESS_STEP),
            overrides: {
                overrideReturnStep: (0, $eI5EY.fg)('enable-x2c-standardised-flow') ? (0, $1pm5p.SELECT_SOURCE_STEP) : (0, $1pm5p.UPLOAD_CSV_STEP)
            },
            stepProps: {
                hasProgressBar: true,
                thirdParty: (0, $3ak5x.TRELLO)
            },
            progressBarStepLabel: (0, $5uhLI.default).importInProgressStepLabel
        }
    ];
    if (hiddenUsers) steps = steps.filter((step)=>step.step !== (0, $1pm5p.USER_MAPPING_STEP));
    return steps;
};

});
parcelRegister("rwYN6", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f8f9fdd9e1d9bc3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6f8f9fdd9e1d9bc3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    trelloStepLabel: {
        "id": "project-create-importer-upload-flow.common.utils.import-steps.trello.trello-step-label",
        "defaultMessage": "Select board"
    },
    userMappingStepLabel: {
        "id": "project-create-importer-upload-flow.common.utils.import-steps.trello.user-mapping-step-label",
        "defaultMessage": "Invite users"
    }
});

});



parcelRegister("63nHt", function(module, exports) {

$parcel$export(module.exports, "useImporterContextFromQueryParams", () => $b7dd318a96a36326$export$b8c9725e6bd40af9);

var $eUqFw = parcelRequire("eUqFw");

var $gyZoj = parcelRequire("gyZoj");

var $kJlBc = parcelRequire("kJlBc");

var $3ak5x = parcelRequire("3ak5x");
const $b7dd318a96a36326$var$getImporterContext = ({ importTypeParam: importTypeParam, workspaceIdParam: workspaceIdParam, entityIdParam: entityIdParam })=>{
    if (!importTypeParam || !(0, $3ak5x.supportedImportTypesFromQueryParam).has(importTypeParam)) return null;
    return {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        importType: importTypeParam,
        workspaceId: workspaceIdParam || null,
        entityId: entityIdParam || null
    };
};
const $b7dd318a96a36326$export$b8c9725e6bd40af9 = ()=>{
    const [{ location: location }, { replace: replace }] = (0, $kJlBc.useRouter)();
    const [importTypeParam] = (0, $kJlBc.useQueryParam)((0, $gyZoj.IMPORT_TYPE_PARAM_KEY));
    const [workspaceIdParam] = (0, $kJlBc.useQueryParam)((0, $gyZoj.WORKSPACE_ID_PARAM_KEY));
    const [entityIdParam] = (0, $kJlBc.useQueryParam)((0, $gyZoj.ENTITY_ID_PARAM_KEY));
    const importerContext = (0, $eUqFw.useMemo)(()=>$b7dd318a96a36326$var$getImporterContext({
            importTypeParam: importTypeParam,
            workspaceIdParam: workspaceIdParam,
            entityIdParam: entityIdParam
        }), [
        entityIdParam,
        importTypeParam,
        workspaceIdParam
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (importerContext) // reset query params to avoid always defaulting to these when exiting the importer and the navigating back
        replace(location.pathname);
    }, [
        importerContext,
        location.pathname,
        replace
    ]);
    return importerContext;
};

});

parcelRegister("8JicK", function(module, exports) {

$parcel$export(module.exports, "Store", () => $f994b2ac2aa1338a$export$390f32400eaf98c9);
$parcel$export(module.exports, "Container", () => $f994b2ac2aa1338a$export$42a852a2b6b56249);

var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");

var $1ybV0 = parcelRequire("1ybV0");

var $3ak5x = parcelRequire("3ak5x");


var $9HsT0 = parcelRequire("9HsT0");

var $l58Ze = parcelRequire("l58Ze");

var $fCYDw = parcelRequire("fCYDw");
const $f994b2ac2aa1338a$export$390f32400eaf98c9 = (0, $a61MH.createStore)({
    name: 'ProjectCreateImporterStore',
    initialState: (0, $9HsT0.INITIAL_STATE),
    actions: $fCYDw.actions
});
const $f994b2ac2aa1338a$export$1c37e6703c03840d = ({ projectType: projectType, importerContext: importerContext, project: project })=>{
    const type = projectType || (0, $9HsT0.INITIAL_STATE).projectData.type;
    if (importerContext === null) {
        if (project) return {
            ...(0, $9HsT0.INITIAL_STATE),
            step: (0, $l58Ze.getFirstStep)({
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                projectType: project.type,
                importType: (0, $9HsT0.INITIAL_STATE).importType,
                source: (0, $85ba070c29b4a3bd$export$ec4d35718915f521)
            }),
            projectData: {
                ...(0, $9HsT0.INITIAL_STATE).projectData,
                key: project.key,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                type: project.type,
                name: project.name
            },
            source: (0, $85ba070c29b4a3bd$export$ec4d35718915f521)
        };
        return {
            ...(0, $9HsT0.INITIAL_STATE),
            step: (0, $l58Ze.getFirstStep)({
                projectType: projectType,
                importType: (0, $9HsT0.INITIAL_STATE).importType
            }),
            projectData: {
                ...(0, $9HsT0.INITIAL_STATE).projectData,
                type: type
            }
        };
    }
    const { importType: importType } = importerContext;
    if ((0, $1ybV0.ff)('enabling-jim-deprecation-banner_inrpz') && importType === (0, $3ak5x.DEFAULT)) return 0, $9HsT0.INITIAL_STATE;
    return {
        ...(0, $9HsT0.INITIAL_STATE),
        step: (0, $l58Ze.getFirstStep)({
            projectType: projectType,
            importType: importType,
            source: (0, $85ba070c29b4a3bd$export$44f7961a4c8dc451)
        }),
        importType: importType,
        thirdPartyState: {
            ...(0, $9HsT0.INITIAL_STATE).thirdPartyState,
            selectedEntityId: importerContext.entityId,
            selectedWorkspaceId: importerContext.workspaceId
        },
        projectData: {
            ...(0, $9HsT0.INITIAL_STATE).projectData,
            type: type
        },
        source: (0, $85ba070c29b4a3bd$export$44f7961a4c8dc451)
    };
};
const $f994b2ac2aa1338a$export$42a852a2b6b56249 = (0, $heB5U.createContainer)($f994b2ac2aa1338a$export$390f32400eaf98c9, {
    onInit: ()=>({ setState: setState }, props)=>{
            setState($f994b2ac2aa1338a$export$1c37e6703c03840d(props));
        }
});

});
parcelRegister("fCYDw", function(module, exports) {

$parcel$export(module.exports, "actions", () => $a98b44eb2b5fd65c$export$e324594224ef24da);

var $eALKb = parcelRequire("eALKb");

var $6y8Sz = parcelRequire("6y8Sz");

var $5DjqG = parcelRequire("5DjqG");

var $6d6na = parcelRequire("6d6na");

var $dZjem = parcelRequire("dZjem");

var $l7OEn = parcelRequire("l7OEn");

var $3UvTB = parcelRequire("3UvTB");

var $1GElw = parcelRequire("1GElw");

var $iSHxP = parcelRequire("iSHxP");

var $aSq1c = parcelRequire("aSq1c");

var $8vTrw = parcelRequire("8vTrw");

var $9naSZ = parcelRequire("9naSZ");

var $2zJhA = parcelRequire("2zJhA");

var $1dV6M = parcelRequire("1dV6M");

var $2XqII = parcelRequire("2XqII");

var $kfAjF = parcelRequire("kfAjF");

var $g96s3 = parcelRequire("g96s3");

var $48IUh = parcelRequire("48IUh");

var $8kOht = parcelRequire("8kOht");

var $4t5bK = parcelRequire("4t5bK");

var $8wTVN = parcelRequire("8wTVN");

var $eAwhG = parcelRequire("eAwhG");

var $gl1rL = parcelRequire("gl1rL");

var $5xfVb = parcelRequire("5xfVb");

var $gg3mD = parcelRequire("gg3mD");

var $jOLuR = parcelRequire("jOLuR");

var $b11PM = parcelRequire("b11PM");

var $1rzuq = parcelRequire("1rzuq");

var $dagAk = parcelRequire("dagAk");

var $617R6 = parcelRequire("617R6");

var $dp9av = parcelRequire("dp9av");
const $a98b44eb2b5fd65c$export$e324594224ef24da = {
    removeDateValidationErrors: $6y8Sz.removeDateValidationErrors,
    setMappingState: $1dV6M.setMappingState,
    setMappingStateValidationError: $2XqII.setMappingStateValidationError,
    setMigrationId: $kfAjF.setMigrationId,
    setStep: $eAwhG.setStep,
    setImportType: $1GElw.setImportType,
    setUploadedFileName: $dp9av.setUploadedFileName,
    setIsVisibleForColumn: $2zJhA.setIsVisibleForColumn,
    setFieldForColumn: $3UvTB.setFieldForColumn,
    setIsVisibleForAll: $9naSZ.setIsVisibleForAll,
    updateAdvancedOptions: $l7OEn.updateAdvancedOptions,
    setProjectData: $8kOht.setProjectData,
    setProjectType: $4t5bK.setProjectType,
    resetProjectData: $5DjqG.resetProjectData,
    setNextSelectedColumn: $g96s3.setNextSelectedColumn,
    setNextSelectedUnmappedColumn: $48IUh.setNextSelectedUnmappedColumn,
    clearSelectedColumn: $eALKb.clearSelectedColumn,
    setImportTypeAndStep: $iSHxP.setImportTypeAndStep,
    setThirdPartyState: $5xfVb.setThirdPartyState,
    setThirdPartyImportSettings: $gg3mD.setThirdPartyImportSettings,
    resetStateAndReturnToUploadStep: $dZjem.resetStateAndReturnToUploadStep,
    setIsThirdPartyFieldIncluded: $8vTrw.setIsThirdPartyFieldIncluded,
    setThirdPartyFieldMapping: $gl1rL.setThirdPartyFieldMapping,
    setThirdPartyStateWithPreselectedWorkspaceId: $b11PM.setThirdPartyStateWithPreselectedWorkspaceId,
    setThirdPartyStateWithPreselectedEntityId: $jOLuR.setThirdPartyStateWithPreselectedEntityId,
    setThirdPartyStatusMapping: $1rzuq.setThirdPartyStatusMapping,
    setThirdPartyStatusOption: $dagAk.setThirdPartyStatusOption,
    resetState: $6d6na.resetState,
    setSourceItems: $8wTVN.setSourceItems,
    setIsIncludedForColumn: $aSq1c.setIsIncludedForColumn,
    setUnmappedColumnsNotIncluded: $617R6.setUnmappedColumnsNotIncluded
};

});
parcelRegister("eALKb", function(module, exports) {

$parcel$export(module.exports, "clearSelectedColumn", () => $0a1be850b138539f$export$2322c9e756e0ce3a);
const $0a1be850b138539f$export$2322c9e756e0ce3a = ()=>({ setState: setState, getState: getState })=>{
        const { mappingState: mappingState } = getState();
        if (mappingState === null) return;
        setState({
            mappingState: {
                ...mappingState,
                selectedColumn: undefined
            }
        });
    };

});

parcelRegister("6y8Sz", function(module, exports) {

$parcel$export(module.exports, "removeDateValidationErrors", () => $3bb1e4822e7a2af8$export$a341a54b6611f234);

var $6HC1D = parcelRequire("6HC1D");

var $dc4s1 = parcelRequire("dc4s1");
const $3bb1e4822e7a2af8$export$a341a54b6611f234 = ()=>({ setState: setState, getState: getState })=>{
        const state = getState();
        if (!state.mappingState || !state.mappingState.validationError) return;
        const { columnErrors: columnErrors } = state.mappingState.validationError;
        Object.entries(columnErrors).forEach(([columnName, errorType])=>{
            if ((0, $dc4s1.DATE_ERROR_TYPES).has(errorType)) delete columnErrors[columnName];
        });
        const newState = (0, $6HC1D.chain)(state).setIn([
            'mappingState',
            'validationError',
            'columnErrors'
        ], columnErrors).value();
        setState(newState);
    };

});

parcelRegister("5DjqG", function(module, exports) {

$parcel$export(module.exports, "resetProjectData", () => $7df5c509625e7bf8$export$f3d52cd3bdd32c71);


var $9HsT0 = parcelRequire("9HsT0");
const $7df5c509625e7bf8$export$f3d52cd3bdd32c71 = ()=>({ setState: setState, getState: getState })=>{
        const { projectData: { type: type, key: key }, source: source } = getState();
        setState({
            projectData: {
                ...(0, $9HsT0.INITIAL_STATE).projectData,
                type: type,
                ...source === (0, $85ba070c29b4a3bd$export$ec4d35718915f521) && {
                    key: key
                }
            }
        });
    };

});

parcelRegister("6d6na", function(module, exports) {

$parcel$export(module.exports, "resetState", () => $64a2524b4398e005$export$8e84bad0b35de9e8);

var $9HsT0 = parcelRequire("9HsT0");

var $1pm5p = parcelRequire("1pm5p");
const $64a2524b4398e005$export$8e84bad0b35de9e8 = ()=>({ setState: setState })=>{
        setState({
            ...(0, $9HsT0.INITIAL_STATE),
            step: (0, $1pm5p.SELECT_SOURCE_STEP)
        });
    };

});

parcelRegister("dZjem", function(module, exports) {

$parcel$export(module.exports, "resetStateAndReturnToUploadStep", () => $97cee4ef025460da$export$9e8086bbe8e4d75c);

var $9HsT0 = parcelRequire("9HsT0");

var $1pm5p = parcelRequire("1pm5p");
const $97cee4ef025460da$export$9e8086bbe8e4d75c = ()=>({ setState: setState, getState: getState })=>{
        /*
            We need to reset the state to initial state to avoid the scenarios where the import is started or partially
            started but errors occur and we try to reuse the same migrationId & file
        */ const { projectData: { type: type } } = getState();
        setState({
            ...(0, $9HsT0.INITIAL_STATE),
            step: (0, $1pm5p.UPLOAD_CSV_STEP),
            projectData: {
                ...(0, $9HsT0.INITIAL_STATE).projectData,
                type: type
            }
        });
    };

});

parcelRegister("l7OEn", function(module, exports) {

$parcel$export(module.exports, "updateAdvancedOptions", () => $8c29bc1c57d46f5a$export$fe5d227222df111e);
const $8c29bc1c57d46f5a$export$fe5d227222df111e = (updatedAdvancedOptions)=>({ setState: setState, getState: getState })=>{
        const { advancedOptions: advancedOptions } = getState();
        setState({
            advancedOptions: {
                ...advancedOptions,
                ...updatedAdvancedOptions
            }
        });
    };

});

parcelRegister("3UvTB", function(module, exports) {

$parcel$export(module.exports, "setFieldForColumn", () => $2ea43f3e0e4630fb$export$e48c73089c92548c);

var $6HC1D = parcelRequire("6HC1D");

var $ldoFd = parcelRequire("ldoFd");

var $agB2z = parcelRequire("agB2z");

var $aWLVm = parcelRequire("aWLVm");
const $2ea43f3e0e4630fb$var$getNewMappedJiraFieldIds = (mappingState, columnName, newField)=>{
    const newMappedJiraFieldIds = mappingState.mappedJiraFieldIds;
    const existingFieldId = mappingState.columns[columnName].field?.fieldId;
    const newFieldId = newField?.fieldId;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(existingFieldId)) newMappedJiraFieldIds.delete(existingFieldId);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(newFieldId)) newMappedJiraFieldIds.add(newFieldId);
    return newMappedJiraFieldIds;
};
const $2ea43f3e0e4630fb$var$getMappedLinkFieldsCount = (mappingState, columnName, newField)=>{
    const existingFieldId = mappingState.columns[columnName].field;
    let { mappedLinkFieldsCount: mappedLinkFieldsCount } = mappingState;
    if (existingFieldId?.fieldType === (0, $agB2z.ISSUE_LINKS_FIELDTYPE)) mappedLinkFieldsCount--;
    if (newField?.fieldType === (0, $agB2z.ISSUE_LINKS_FIELDTYPE)) mappedLinkFieldsCount++;
    return mappedLinkFieldsCount;
};
const $2ea43f3e0e4630fb$export$e48c73089c92548c = (columnName, field)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        if (state.mappingState === null) return;
        const mappedLinkFieldsCount = $2ea43f3e0e4630fb$var$getMappedLinkFieldsCount(state.mappingState, columnName, field);
        const newState = (0, $6HC1D.chain)(state).setIn([
            'mappingState',
            'columns',
            columnName,
            'field'
        ], field).setIn([
            'mappingState',
            'mappedJiraFieldIds'
        ], $2ea43f3e0e4630fb$var$getNewMappedJiraFieldIds(state.mappingState, columnName, field)).setIn([
            'mappingState',
            'validationError'
        ], (0, $aWLVm.getNewValidationState)(state.mappingState, columnName, mappedLinkFieldsCount, field?.fieldId)).setIn([
            'mappingState',
            'mappedLinkFieldsCount'
        ], mappedLinkFieldsCount).setIn([
            'mappingState',
            'userMapping'
        ], null) // reset userMapping if field is changed
        .value();
        setState(newState);
    };

});

parcelRegister("1GElw", function(module, exports) {

$parcel$export(module.exports, "setImportType", () => $84f32470603b82c8$export$55797414cbcb4666);
const $84f32470603b82c8$export$55797414cbcb4666 = (importType)=>({ setState: setState })=>{
        setState({
            importType: importType
        });
    };

});

parcelRegister("iSHxP", function(module, exports) {

$parcel$export(module.exports, "setImportTypeAndStep", () => $1003ea97e89c3ecf$export$5fc2bf731a3401ab);
const $1003ea97e89c3ecf$export$5fc2bf731a3401ab = ({ importType: importType, step: step })=>({ setState: setState })=>{
        setState({
            importType: importType,
            step: step
        });
    };

});

parcelRegister("aSq1c", function(module, exports) {

$parcel$export(module.exports, "setIsIncludedForColumn", () => $3ee704028d72d826$export$cae413c9e2950243);

var $aWLVm = parcelRequire("aWLVm");
const $3ee704028d72d826$export$cae413c9e2950243 = (columnName, isIncludeInImport)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        if (state.mappingState === null) return;
        const updatedMappingState = (0, $aWLVm.setFieldIncluded)(state.mappingState, columnName, isIncludeInImport);
        setState({
            mappingState: updatedMappingState
        });
    };

});

parcelRegister("8vTrw", function(module, exports) {

$parcel$export(module.exports, "setIsThirdPartyFieldIncluded", () => $5649512e584d0079$export$4bf86d02d0188c37);

var $6HC1D = parcelRequire("6HC1D");
const $5649512e584d0079$export$82d5fec2c5e6f338 = (thirdPartyFieldConfigState, thirdPartyFieldId, isIncluded)=>{
    const newIncludedJiraFieldIds = new Set([
        ...thirdPartyFieldConfigState.includedJiraFieldIds
    ]);
    const prevMappedJiraField = thirdPartyFieldConfigState.thirdPartyFieldMappings[thirdPartyFieldId].mappedJiraField;
    const { isFieldDisabled: isFieldDisabled } = thirdPartyFieldConfigState.thirdPartyFieldMappings[thirdPartyFieldId].mappingContext;
    // toggle OFF - make the field available for selection if field is not disabled
    if (!isIncluded && !isFieldDisabled && prevMappedJiraField.fieldId) newIncludedJiraFieldIds.delete(prevMappedJiraField.fieldId);
    // toggle ON - add mappedJiraField to mappedJiraFields
    if (isIncluded && prevMappedJiraField.fieldId) newIncludedJiraFieldIds.add(prevMappedJiraField.fieldId);
    return newIncludedJiraFieldIds;
};
const $5649512e584d0079$export$4557e713234f7778 = (itemType, thirdPartyFieldConfigState, thirdPartyFieldId, isIncluded)=>{
    const newIncludedJiraFieldIds = new Set([
        ...thirdPartyFieldConfigState.fieldMappingState[itemType].includedJiraFieldIds
    ]);
    const prevMappedJiraField = thirdPartyFieldConfigState.fieldMappingState[itemType].thirdPartyFieldMappings[thirdPartyFieldId].mappedJiraField;
    const { isFieldDisabled: isFieldDisabled } = thirdPartyFieldConfigState.fieldMappingState[itemType].thirdPartyFieldMappings[thirdPartyFieldId].mappingContext;
    // toggle OFF - make the field available for selection if field is not disabled
    if (!isIncluded && !isFieldDisabled && prevMappedJiraField.fieldId) newIncludedJiraFieldIds.delete(prevMappedJiraField.fieldId);
    // toggle ON - add mappedJiraField to mappedJiraFields
    if (isIncluded && prevMappedJiraField.fieldId) newIncludedJiraFieldIds.add(prevMappedJiraField.fieldId);
    return newIncludedJiraFieldIds;
};
const $5649512e584d0079$export$4bf86d02d0188c37 = (itemType, fieldId, isIncluded)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        if (itemType == null || state.thirdPartyState.thirdPartyFieldConfigState === null) return;
        const { fieldMappingState: fieldMappingState } = state.thirdPartyState.thirdPartyFieldConfigState;
        const updatedFieldMappingContext = {
            ...fieldMappingState[itemType].thirdPartyFieldMappings[fieldId].mappingContext,
            isIncluded: isIncluded
        };
        const newState = (0, $6HC1D.chain)(state).setIn([
            'thirdPartyState',
            'thirdPartyFieldConfigState',
            'fieldMappingState',
            itemType,
            'thirdPartyFieldMappings',
            fieldId,
            'mappingContext'
        ], updatedFieldMappingContext).setIn([
            'thirdPartyState',
            'thirdPartyFieldConfigState',
            'fieldMappingState',
            itemType,
            'includedJiraFieldIds'
        ], $5649512e584d0079$export$4557e713234f7778(itemType, state.thirdPartyState.thirdPartyFieldConfigState, fieldId, isIncluded)).value();
        setState(newState);
    };

});

parcelRegister("9naSZ", function(module, exports) {

$parcel$export(module.exports, "setIsVisibleForAll", () => $8c5e81a10450e7de$export$8fdc651a871fbf45);

var $aWLVm = parcelRequire("aWLVm");
const $8c5e81a10450e7de$var$hideAllColumns = (mappingState)=>{
    const newColumnState = {};
    mappingState.columnOrder.forEach((colName)=>{
        newColumnState[colName] = {
            ...mappingState.columns[colName],
            isVisible: false
        };
    });
    return {
        ...mappingState,
        columns: newColumnState,
        mappedJiraFieldIds: new Set(),
        validationError: null
    };
};
const $8c5e81a10450e7de$var$showAllColumns = (mappingState)=>{
    let updatedMappingState = mappingState;
    mappingState.columnOrder.forEach((colName)=>{
        if (!updatedMappingState.columns[colName].isVisible) updatedMappingState = (0, $aWLVm.makeColumnVisible)(updatedMappingState, colName);
    });
    return updatedMappingState;
};
const $8c5e81a10450e7de$export$8fdc651a871fbf45 = (isVisible)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        if (state.mappingState === null) return;
        const updatedMappingState = isVisible ? $8c5e81a10450e7de$var$showAllColumns(state.mappingState) : $8c5e81a10450e7de$var$hideAllColumns(state.mappingState);
        setState({
            mappingState: updatedMappingState
        });
    };

});

parcelRegister("2zJhA", function(module, exports) {

$parcel$export(module.exports, "setIsVisibleForColumn", () => $3506e2514981d2ee$export$ecc68aeb33796640);

var $aWLVm = parcelRequire("aWLVm");
const $3506e2514981d2ee$export$ecc68aeb33796640 = (columnName, isVisible)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        if (state.mappingState === null) return;
        const updatedMappingState = isVisible ? (0, $aWLVm.makeColumnVisible)(state.mappingState, columnName) : (0, $aWLVm.makeColumnHidden)(state.mappingState, columnName);
        setState({
            mappingState: updatedMappingState
        });
    };

});

parcelRegister("1dV6M", function(module, exports) {

$parcel$export(module.exports, "setMappingState", () => $ecdf21e697bd1473$export$95f60c68aca7fa11);
const $ecdf21e697bd1473$export$95f60c68aca7fa11 = (mappingState)=>({ setState: setState })=>{
        setState({
            mappingState: mappingState
        });
    };

});

parcelRegister("2XqII", function(module, exports) {

$parcel$export(module.exports, "setMappingStateValidationError", () => $80e40639beaf4521$export$7d38a0c4046d242a);

var $eI5EY = parcelRequire("eI5EY");
const $80e40639beaf4521$export$7d38a0c4046d242a = (validationError)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        if (!state.mappingState) return;
        if ((0, $eI5EY.fg)('enable-x2c-standardised-flow')) {
            setState({
                mappingState: {
                    ...state.mappingState,
                    validationError: validationError,
                    errorsFilter: Object.keys(validationError.columnErrors)
                }
            });
            return;
        }
        const columnOrder = [
            ...state.mappingState.columnOrder
        ];
        columnOrder.sort((a, b)=>{
            if (validationError.columnErrors[a] && validationError.columnErrors[b]) return 0;
            if (validationError.columnErrors[a]) return -1;
            return 0;
        });
        setState({
            mappingState: {
                ...state.mappingState,
                validationError: validationError,
                columnOrder: columnOrder
            }
        });
    };

});

parcelRegister("kfAjF", function(module, exports) {

$parcel$export(module.exports, "setMigrationId", () => $df43ef4d9014be5c$export$46836ef232d6d22c);
const $df43ef4d9014be5c$export$46836ef232d6d22c = (migrationId)=>({ setState: setState })=>{
        setState({
            migrationId: migrationId
        });
    };

});

parcelRegister("g96s3", function(module, exports) {

$parcel$export(module.exports, "setNextSelectedColumn", () => $43a7ab37c5765a74$export$452ac4d80cea5a9d);
const $43a7ab37c5765a74$var$getNextSelectedColumn = (mappingState, goForward)=>{
    const visibleColumns = mappingState.columnOrder.filter((colName)=>mappingState.columns[colName].isVisible);
    if (visibleColumns.length <= 1) return undefined;
    if (!mappingState.selectedColumn) return goForward ? visibleColumns[1] : visibleColumns[visibleColumns.length - 2];
    const indexOfSelected = visibleColumns.findIndex((colName)=>colName === mappingState.selectedColumn);
    const nextIndex = goForward ? indexOfSelected + 1 : indexOfSelected - 1;
    if (nextIndex < 0 || nextIndex >= visibleColumns.length) return undefined;
    return visibleColumns[nextIndex];
};
const $43a7ab37c5765a74$export$452ac4d80cea5a9d = (goForward)=>({ setState: setState, getState: getState })=>{
        const { mappingState: mappingState } = getState();
        if (mappingState === null) return;
        setState({
            mappingState: {
                ...mappingState,
                selectedColumn: $43a7ab37c5765a74$var$getNextSelectedColumn(mappingState, goForward)
            }
        });
    };

});

parcelRegister("48IUh", function(module, exports) {

$parcel$export(module.exports, "setNextSelectedUnmappedColumn", () => $f6ce58a7a3436ce6$export$b7bd7af0fc7bf07d);
const $f6ce58a7a3436ce6$var$getNextSelectedUnmappedColumn = (mappingState)=>{
    const unmappedColumns = mappingState.columnOrder.filter((colName)=>mappingState.columns[colName].isVisible && !mappingState.columns[colName].field);
    if (unmappedColumns.length === 0) return undefined;
    if (!mappingState.selectedColumn) return unmappedColumns[0];
    if (unmappedColumns.length === 1) return unmappedColumns[0];
    const indexOfSelected = unmappedColumns.findIndex((colName)=>colName === mappingState.selectedColumn);
    return indexOfSelected < unmappedColumns.length - 1 ? unmappedColumns[indexOfSelected + 1] : unmappedColumns[0];
};
const $f6ce58a7a3436ce6$export$b7bd7af0fc7bf07d = ()=>({ setState: setState, getState: getState })=>{
        const { mappingState: mappingState } = getState();
        if (mappingState === null) return;
        setState({
            mappingState: {
                ...mappingState,
                selectedColumn: $f6ce58a7a3436ce6$var$getNextSelectedUnmappedColumn(mappingState)
            }
        });
    };

});

parcelRegister("8kOht", function(module, exports) {

$parcel$export(module.exports, "setProjectData", () => $ef9e67e3e8f0a565$export$5145b27ce66fbe0a);
const $ef9e67e3e8f0a565$export$5145b27ce66fbe0a = (newProjectData)=>({ setState: setState, getState: getState })=>{
        const { projectData: projectData } = getState();
        setState({
            projectData: {
                ...projectData,
                ...newProjectData
            }
        });
    };

});

parcelRegister("4t5bK", function(module, exports) {

$parcel$export(module.exports, "setProjectType", () => $6fdcce0039657fbb$export$bf0c2d889ef9ec57);

var $9HsT0 = parcelRequire("9HsT0");

var $l58Ze = parcelRequire("l58Ze");
const $6fdcce0039657fbb$export$bf0c2d889ef9ec57 = (type)=>({ setState: setState })=>{
        setState({
            projectData: {
                ...(0, $9HsT0.INITIAL_STATE).projectData,
                type: type
            },
            migrationId: null,
            uploadedFileName: null,
            step: (0, $l58Ze.getFirstStep)({
                projectType: type,
                importType: (0, $9HsT0.INITIAL_STATE).importType
            })
        });
    };

});

parcelRegister("8wTVN", function(module, exports) {

$parcel$export(module.exports, "setSourceItems", () => $d98a3bfe30fe8625$export$e97089b929970ada);
const $d98a3bfe30fe8625$export$e97089b929970ada = (sourceItems)=>({ setState: setState })=>{
        setState({
            sourceItems: sourceItems
        });
    };

});

parcelRegister("eAwhG", function(module, exports) {

$parcel$export(module.exports, "setStep", () => $ab9ee3a60a2ea363$export$5305615f76bbd5b5);
const $ab9ee3a60a2ea363$export$5305615f76bbd5b5 = (step)=>({ setState: setState })=>{
        setState({
            step: step
        });
    };

});

parcelRegister("gl1rL", function(module, exports) {

$parcel$export(module.exports, "setThirdPartyFieldMapping", () => $dbb41b64bd0f960f$export$6b27e9263b75ba2d);

var $6HC1D = parcelRequire("6HC1D");

var $ldoFd = parcelRequire("ldoFd");

var $agB2z = parcelRequire("agB2z");
const $dbb41b64bd0f960f$export$253e31e69bb39d1b = (thirdPartyFieldConfigState, thirdPartyFieldId, newJiraField)=>{
    const newMappedJiraFields = {
        ...thirdPartyFieldConfigState.mappedJiraFields
    };
    const newMappedJiraFieldId = newJiraField.fieldId;
    const prevMappedJiraField = thirdPartyFieldConfigState.thirdPartyFieldMappings[thirdPartyFieldId].mappedJiraField;
    // remove the previously mappedJiraField
    if (prevMappedJiraField.fieldId) delete newMappedJiraFields[prevMappedJiraField.fieldId];
    // add the new mappedJira Field
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(newMappedJiraFieldId)) newMappedJiraFields[newMappedJiraFieldId] = thirdPartyFieldId;
    return newMappedJiraFields;
};
const $dbb41b64bd0f960f$export$9241317445ec7684 = (itemType, thirdPartyFieldConfigState, thirdPartyFieldId, newJiraField)=>{
    const newMappedJiraFields = {
        ...thirdPartyFieldConfigState.fieldMappingState[itemType].mappedJiraFields
    };
    const newMappedJiraFieldId = newJiraField.fieldId;
    const prevMappedJiraField = thirdPartyFieldConfigState.fieldMappingState[itemType].thirdPartyFieldMappings[thirdPartyFieldId].mappedJiraField;
    // remove the previously mappedJiraField
    if (prevMappedJiraField.fieldId) delete newMappedJiraFields[prevMappedJiraField.fieldId];
    // add the new mappedJira Field
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(newMappedJiraFieldId)) newMappedJiraFields[newMappedJiraFieldId] = thirdPartyFieldId;
    return newMappedJiraFields;
};
const $dbb41b64bd0f960f$export$8facb4a9d0571281 = (thirdPartyFieldConfigState, prevMappedThirdPartyFieldId)=>{
    const prevMappedThirdPartyFieldMapping = thirdPartyFieldConfigState.thirdPartyFieldMappings[prevMappedThirdPartyFieldId];
    // defaulting to text field if there are no compatible new field
    const prevFirstCompatibleNextFieldType = prevMappedThirdPartyFieldMapping.compatibleNewFieldTypes[0] ?? (0, $agB2z.TEXT_FIELDTYPE);
    const newMappedJiraField = {
        fieldType: prevFirstCompatibleNextFieldType,
        fieldName: prevMappedThirdPartyFieldMapping.thirdPartyField.fieldName
    };
    return newMappedJiraField;
};
const $dbb41b64bd0f960f$export$c8e8773d79e4aaa4 = (itemType, thirdPartyFieldConfigState, prevMappedThirdPartyFieldId)=>{
    const prevMappedThirdPartyFieldMapping = thirdPartyFieldConfigState.fieldMappingState[itemType].thirdPartyFieldMappings[prevMappedThirdPartyFieldId];
    // defaulting to text field if there are no compatible new field
    const prevFirstCompatibleNextFieldType = prevMappedThirdPartyFieldMapping.compatibleNewFieldTypes[0] ?? (0, $agB2z.TEXT_FIELDTYPE);
    const newMappedJiraField = {
        fieldType: prevFirstCompatibleNextFieldType,
        fieldName: prevMappedThirdPartyFieldMapping.thirdPartyField.fieldName
    };
    return newMappedJiraField;
};
const $dbb41b64bd0f960f$export$82d5fec2c5e6f338 = (thirdPartyFieldConfigState, thirdPartyFieldId, newJiraField)=>{
    const newIncludedJiraFieldIds = new Set([
        ...thirdPartyFieldConfigState.includedJiraFieldIds
    ]);
    const prevMappedJiraField = thirdPartyFieldConfigState.thirdPartyFieldMappings[thirdPartyFieldId].mappedJiraField;
    if (prevMappedJiraField.fieldId) newIncludedJiraFieldIds.delete(prevMappedJiraField.fieldId);
    if (newJiraField.fieldId) newIncludedJiraFieldIds.add(newJiraField.fieldId);
    return newIncludedJiraFieldIds;
};
const $dbb41b64bd0f960f$export$4557e713234f7778 = (itemType, thirdPartyFieldConfigState, thirdPartyFieldId, newJiraField)=>{
    const newIncludedJiraFieldIds = new Set([
        ...thirdPartyFieldConfigState.fieldMappingState[itemType].includedJiraFieldIds
    ]);
    const prevMappedJiraField = thirdPartyFieldConfigState.fieldMappingState[itemType].thirdPartyFieldMappings[thirdPartyFieldId].mappedJiraField;
    if (prevMappedJiraField.fieldId) newIncludedJiraFieldIds.delete(prevMappedJiraField.fieldId);
    if (newJiraField.fieldId) newIncludedJiraFieldIds.add(newJiraField.fieldId);
    return newIncludedJiraFieldIds;
};
const $dbb41b64bd0f960f$export$6b27e9263b75ba2d = (itemType, fieldId, jiraField)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        if (itemType === null || state.thirdPartyState.thirdPartyFieldConfigState === null) return;
        const prevMappedThirdPartyFieldId = jiraField.fieldId ? state.thirdPartyState.thirdPartyFieldConfigState.fieldMappingState[itemType].mappedJiraFields[jiraField.fieldId] : undefined;
        let newState = (0, $6HC1D.chain)(state).setIn([
            'thirdPartyState',
            'thirdPartyFieldConfigState',
            'fieldMappingState',
            itemType,
            'thirdPartyFieldMappings',
            fieldId,
            'mappedJiraField'
        ], jiraField).setIn([
            'thirdPartyState',
            'thirdPartyFieldConfigState',
            'fieldMappingState',
            itemType,
            'mappedJiraFields'
        ], $dbb41b64bd0f960f$export$9241317445ec7684(itemType, state.thirdPartyState.thirdPartyFieldConfigState, fieldId, jiraField)).setIn([
            'thirdPartyState',
            'thirdPartyFieldConfigState',
            'fieldMappingState',
            itemType,
            'includedJiraFieldIds'
        ], $dbb41b64bd0f960f$export$4557e713234f7778(itemType, state.thirdPartyState.thirdPartyFieldConfigState, fieldId, jiraField)).value();
        // replace the mapped jira field of any excluded third party fields that are currently mapped to the jiraField
        // we replace it with a new jira field using the first compatibleNewFieldType
        if (prevMappedThirdPartyFieldId) newState = (0, $6HC1D.setIn)(newState, [
            'thirdPartyState',
            'thirdPartyFieldConfigState',
            'fieldMappingState',
            itemType,
            'thirdPartyFieldMappings',
            prevMappedThirdPartyFieldId,
            'mappedJiraField'
        ], $dbb41b64bd0f960f$export$c8e8773d79e4aaa4(itemType, state.thirdPartyState.thirdPartyFieldConfigState, prevMappedThirdPartyFieldId));
        setState(newState);
    };

});

parcelRegister("5xfVb", function(module, exports) {

$parcel$export(module.exports, "setThirdPartyState", () => $4b84cedd60981655$export$24dfcbfb4ff0ec70);
const $4b84cedd60981655$export$24dfcbfb4ff0ec70 = (newThirdPartyState)=>({ getState: getState, setState: setState })=>{
        const { thirdPartyState: thirdPartyState } = getState();
        setState({
            thirdPartyState: {
                ...thirdPartyState,
                ...newThirdPartyState
            }
        });
    };

});

parcelRegister("gg3mD", function(module, exports) {

$parcel$export(module.exports, "setThirdPartyImportSettings", () => $b54f1fabb080350c$export$984000f1069adbd7);
const $b54f1fabb080350c$export$984000f1069adbd7 = (settings)=>({ getState: getState, setState: setState })=>{
        const { thirdPartyState: thirdPartyState } = getState();
        const { thirdPartyImportSettings: thirdPartyImportSettings } = thirdPartyState;
        setState({
            thirdPartyState: {
                ...thirdPartyState,
                thirdPartyImportSettings: {
                    ...thirdPartyImportSettings,
                    ...settings
                }
            }
        });
    };

});

parcelRegister("jOLuR", function(module, exports) {

$parcel$export(module.exports, "setThirdPartyStateWithPreselectedEntityId", () => $dcb48b5553875f38$export$93ec0e44bdab0e55);

var $eI5EY = parcelRequire("eI5EY");
const $dcb48b5553875f38$export$93ec0e44bdab0e55 = ({ entities: entities, preSelectedEntityId: preSelectedEntityId })=>({ getState: getState, setState: setState })=>{
        const { thirdPartyState: thirdPartyState } = getState();
        const baseThirdPartyState = {
            ...thirdPartyState,
            entities: entities
        };
        if (preSelectedEntityId === null) {
            setState({
                thirdPartyState: baseThirdPartyState
            });
            return;
        }
        const preSelectedEntity = entities?.find((entity)=>entity.id === preSelectedEntityId);
        const selectedEntities = preSelectedEntity && (0, $eI5EY.fg)('jira_importer_third_party_state_refactor') ? [
            preSelectedEntity
        ] : null;
        if (preSelectedEntity) {
            setState({
                thirdPartyState: {
                    ...baseThirdPartyState,
                    selectedEntityName: preSelectedEntity.name,
                    selectedEntityId: preSelectedEntityId,
                    selectedEntities: selectedEntities
                }
            });
            return;
        }
        // Reset selectedEntityId if not valid
        setState({
            thirdPartyState: {
                ...baseThirdPartyState,
                selectedEntityId: null,
                selectedEntities: null
            }
        });
    };

});

parcelRegister("b11PM", function(module, exports) {

$parcel$export(module.exports, "setThirdPartyStateWithPreselectedWorkspaceId", () => $83511f8b4d704b08$export$a29eb648d2a97b38);
const $83511f8b4d704b08$export$a29eb648d2a97b38 = ({ workspaces: workspaces, preSelectedWorkspaceId: preSelectedWorkspaceId })=>({ getState: getState, setState: setState })=>{
        const { thirdPartyState: thirdPartyState } = getState();
        const baseThirdPartyState = {
            ...thirdPartyState,
            workspaces: workspaces
        };
        if (preSelectedWorkspaceId === null) {
            setState({
                thirdPartyState: baseThirdPartyState
            });
            return;
        }
        const isValidWorkspaceId = !!workspaces?.find((workspace)=>workspace.id === preSelectedWorkspaceId);
        setState({
            thirdPartyState: {
                ...baseThirdPartyState,
                selectedWorkspaceId: isValidWorkspaceId ? preSelectedWorkspaceId : null
            }
        });
    };

});

parcelRegister("1rzuq", function(module, exports) {

$parcel$export(module.exports, "setThirdPartyStatusMapping", () => $14460dfb9b5b6044$export$54d7bd31da919a7f);

var $6HC1D = parcelRequire("6HC1D");
const $14460dfb9b5b6044$export$54d7bd31da919a7f = (entityName, updatedStatus)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        if (state.thirdPartyState.thirdPartyStatusMapping == null || entityName == null) return;
        const newStatus = {
            mappedStatusName: updatedStatus.mappedStatusName,
            statusCategory: updatedStatus.statusCategory
        };
        const newState = (0, $6HC1D.chain)(state).setIn([
            'thirdPartyState',
            'thirdPartyStatusMapping',
            'entityStatusMappings',
            entityName,
            'statusMappings',
            updatedStatus.sourceStatusName
        ], newStatus).value();
        setState(newState);
    };

});

parcelRegister("dagAk", function(module, exports) {

$parcel$export(module.exports, "setThirdPartyStatusOption", () => $39a712bf0ddb3d98$export$545aa998833e5745);
const $39a712bf0ddb3d98$export$545aa998833e5745 = (newStatus)=>({ setState: setState, getState: getState })=>{
        const { thirdPartyState: thirdPartyState } = getState();
        if (thirdPartyState.thirdPartyStatusMapping == null) return;
        const newOptions = thirdPartyState.thirdPartyStatusMapping.availableJiraStatuses.concat([
            newStatus
        ]).sort((a, b)=>a.name.localeCompare(b.name));
        setState({
            thirdPartyState: {
                ...thirdPartyState,
                thirdPartyStatusMapping: {
                    ...thirdPartyState.thirdPartyStatusMapping,
                    availableJiraStatuses: newOptions
                }
            }
        });
    };

});

parcelRegister("617R6", function(module, exports) {

$parcel$export(module.exports, "setUnmappedColumnsNotIncluded", () => $37ea0aa0550d822c$export$bd3505797ad9fb41);
const $37ea0aa0550d822c$export$bd3505797ad9fb41 = ()=>({ setState: setState, getState: getState })=>{
        const { mappingState: mappingState } = getState();
        if (mappingState === null) return;
        const columns = {};
        mappingState.columnOrder.forEach((name)=>{
            columns[name] = {
                ...mappingState.columns[name],
                isIncluded: !!mappingState.columns[name].field
            };
        });
        setState({
            mappingState: {
                ...mappingState,
                columns: columns
            }
        });
    };

});

parcelRegister("dp9av", function(module, exports) {

$parcel$export(module.exports, "setUploadedFileName", () => $941b882954a76ee3$export$11b66d360f9fe4b2);
const $941b882954a76ee3$export$11b66d360f9fe4b2 = (uploadedFileName)=>({ setState: setState })=>{
        setState({
            uploadedFileName: uploadedFileName
        });
    };

});



parcelRegister("aEdcH", function(module, exports) {

$parcel$export(module.exports, "useImportType", () => $369e7acd5a88d334$export$5590f3378177a131);

var $ggKAj = parcelRequire("ggKAj");
var $bj4JM = parcelRequire("bj4JM");

var $8JicK = parcelRequire("8JicK");
const $369e7acd5a88d334$export$956e2c257187f88a = (0, $bj4JM.createSelector)((state)=>state.importType, (newState)=>newState);
const $369e7acd5a88d334$export$5590f3378177a131 = (0, $ggKAj.createHook)((0, $8JicK.Store), {
    selector: $369e7acd5a88d334$export$956e2c257187f88a
});

});

parcelRegister("d0wrd", function(module, exports) {

$parcel$export(module.exports, "useProjectData", () => $e3cacf1606e02561$export$3d34b80052fb5c8c);

var $ggKAj = parcelRequire("ggKAj");
var $bj4JM = parcelRequire("bj4JM");

var $8JicK = parcelRequire("8JicK");
const $e3cacf1606e02561$export$6e3a6d836080b8de = (0, $bj4JM.createSelector)((state)=>state.projectData, (newState)=>newState);
const $e3cacf1606e02561$export$3d34b80052fb5c8c = (0, $ggKAj.createHook)((0, $8JicK.Store), {
    selector: $e3cacf1606e02561$export$6e3a6d836080b8de
});

});

parcelRegister("j5Nf5", function(module, exports) {

$parcel$export(module.exports, "useStep", () => $b6aae8e97a1e13bc$export$7896576cb7635832);

var $ggKAj = parcelRequire("ggKAj");
var $bj4JM = parcelRequire("bj4JM");

var $8JicK = parcelRequire("8JicK");
const $b6aae8e97a1e13bc$export$4bfb60e9f782bac9 = (0, $bj4JM.createSelector)((state)=>state.step, (newState)=>newState);
const $b6aae8e97a1e13bc$export$7896576cb7635832 = (0, $ggKAj.createHook)((0, $8JicK.Store), {
    selector: $b6aae8e97a1e13bc$export$4bfb60e9f782bac9
});

});

parcelRegister("irKna", function(module, exports) {

$parcel$export(module.exports, "useThirdPartyState", () => $abc7ec8ac0d29d9f$export$8569d1ff85ba1bfc);

var $ggKAj = parcelRequire("ggKAj");
var $bj4JM = parcelRequire("bj4JM");

var $8JicK = parcelRequire("8JicK");
const $abc7ec8ac0d29d9f$export$eb42e4eb1d33840 = (0, $bj4JM.createSelector)((state)=>state.thirdPartyState, (newState)=>newState);
const $abc7ec8ac0d29d9f$export$8569d1ff85ba1bfc = (0, $ggKAj.createHook)((0, $8JicK.Store), {
    selector: $abc7ec8ac0d29d9f$export$eb42e4eb1d33840
});

});

parcelRegister("2sRUp", function(module, exports) {

$parcel$export(module.exports, "useSource", () => $cdd7b4059c405790$export$fe488720f15adbf8);

var $ggKAj = parcelRequire("ggKAj");
var $bj4JM = parcelRequire("bj4JM");

var $8JicK = parcelRequire("8JicK");
const $cdd7b4059c405790$export$db89ce3e649a56ea = (0, $bj4JM.createSelector)((state)=>state.source, (newState)=>newState);
const $cdd7b4059c405790$export$fe488720f15adbf8 = (0, $ggKAj.createHook)((0, $8JicK.Store), {
    selector: $cdd7b4059c405790$export$db89ce3e649a56ea
});

});

parcelRegister("8BfOE", function(module, exports) {

$parcel$export(module.exports, "usePreventCancelImport", () => $075f05339f457450$export$289091f7f0490d10);

var $eUqFw = parcelRequire("eUqFw");

var $kzTj7 = parcelRequire("kzTj7");


var $aWLVm = parcelRequire("aWLVm");

var $4uta0 = parcelRequire("4uta0");
var $2sRUp = parcelRequire("2sRUp");
var $irKna = parcelRequire("irKna");

var $fua3W = parcelRequire("fua3W");
const $075f05339f457450$export$289091f7f0490d10 = ()=>{
    const [{ isCancelImportModalOpen: isCancelImportModalOpen }, { setCancelImportModalState: setCancelImportModalState, setIsCancelImportModalOpen: setIsCancelImportModalOpen }] = (0, $fua3W.useCancelImportModalState)();
    const [{ selectedWorkspaceId: selectedWorkspaceId, selectedEntityId: selectedEntityId }] = (0, $irKna.useThirdPartyState)();
    const [source] = (0, $2sRUp.useSource)();
    const [migrationId] = (0, $4uta0.useMigrationId)();
    const shouldPreventCancelImport = migrationId != null || selectedWorkspaceId != null || selectedEntityId != null;
    const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Escape') {
            // if the event target is whitelisted close the event target
            if (event.target instanceof HTMLElement && ((0, $kzTj7.ESCAPE_WHITELIST_TESTIDS).some((testId)=>event.target instanceof HTMLElement && (event?.target?.dataset?.testid?.includes(testId) || event?.target?.parentElement?.dataset?.testid?.includes(testId))) || (0, $kzTj7.ESCAPE_WHITELIST_IDS).some((id)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                event.target.id?.includes(id)) || event?.target?.parentElement?.className?.includes((0, $kzTj7.ATLASKIT_PORTAL_CLASSNAME)) || event?.target?.nodeName === 'INPUT')) {
                event.preventDefault();
                event.stopPropagation();
                // close the dropdown menu by clicking the document body
                document.body.click();
                return;
            }
            // prevent closing the project create drawer and exiting import
            if (shouldPreventCancelImport) {
                event.preventDefault();
                event.stopPropagation();
                // Remove this when the new project create integration is implemented
                source === (0, $85ba070c29b4a3bd$export$44f7961a4c8dc451) ? setCancelImportModalState({
                    isCancelImportModalOpen: true,
                    shouldCloseDrawerOnCancel: false,
                    onCloseModalCallback: (0, $aWLVm.redirectToProjectTemplatesScreen)
                }) : setIsCancelImportModalOpen(true);
            }
        }
    }, [
        setCancelImportModalState,
        setIsCancelImportModalOpen,
        shouldPreventCancelImport,
        source
    ]);
    const closeCancelImportModal = (0, $eUqFw.useCallback)(()=>{
        setIsCancelImportModalOpen(false);
    }, [
        setIsCancelImportModalOpen
    ]);
    (0, $eUqFw.useEffect)(()=>{
        document.addEventListener('keydown', handleKeyDown);
        let initOverscrollBehaviorX = '';
        // swiping the mapping table horizontally can accidentally result in swiping back in browser history
        // due to OS settings.
        // this will wipe the user's import progress and close the project create drawer
        // add `overscroll-behavior-x: contain` to the <html> element to prevent horizontal scroll going
        // back in history https://stackoverflow.com/questions/50616221/prevent-page-navigation-on-horizontal-scroll
        // NOTE this won't work in storybook because of the iframe. You can "open canvas in new tab" to see it work in storybook.
        if (document.body && shouldPreventCancelImport) {
            initOverscrollBehaviorX = document.body.style.overscrollBehaviorX ?? '';
            document.body.style.overscrollBehaviorX = 'contain';
        }
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
            if (document.body) document.body.style.overscrollBehaviorX = initOverscrollBehaviorX;
        };
    }, [
        handleKeyDown,
        shouldPreventCancelImport
    ]);
    return {
        isCancelImportModalOpen: isCancelImportModalOpen,
        closeCancelImportModal: closeCancelImportModal
    };
};

});
parcelRegister("4uta0", function(module, exports) {

$parcel$export(module.exports, "useMigrationId", () => $1ae42becb1bf1716$export$70259a43ab843972);

var $ggKAj = parcelRequire("ggKAj");
var $bj4JM = parcelRequire("bj4JM");

var $8JicK = parcelRequire("8JicK");
const $1ae42becb1bf1716$export$7fdce1f93136ef79 = (0, $bj4JM.createSelector)((state)=>state.migrationId, (newState)=>newState);
const $1ae42becb1bf1716$export$70259a43ab843972 = (0, $ggKAj.createHook)((0, $8JicK.Store), {
    selector: $1ae42becb1bf1716$export$7fdce1f93136ef79
});

});

parcelRegister("fua3W", function(module, exports) {

$parcel$export(module.exports, "useCancelImportModalState", () => $29777827f61dac5a$export$6af3f6f5545d3ae5);

var $ggKAj = parcelRequire("ggKAj");
var $bj4JM = parcelRequire("bj4JM");

var $irjtd = parcelRequire("irjtd");
const $29777827f61dac5a$export$42ebc326d4ddd701 = (0, $bj4JM.createSelector)((state)=>state.cancelModal, (newState)=>newState);
const $29777827f61dac5a$export$6af3f6f5545d3ae5 = (0, $ggKAj.createHook)((0, $irjtd.Store), {
    selector: $29777827f61dac5a$export$42ebc326d4ddd701
});

});
parcelRegister("irjtd", function(module, exports) {

$parcel$export(module.exports, "Store", () => $8638263fe7697be9$export$390f32400eaf98c9);
$parcel$export(module.exports, "useUIState", () => $8638263fe7697be9$export$fe5c3dd398c32c18);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $9HsT0 = parcelRequire("9HsT0");

var $94527 = parcelRequire("94527");
const $8638263fe7697be9$export$390f32400eaf98c9 = (0, $a61MH.createStore)({
    initialState: (0, $9HsT0.INITIAL_UI_STATE),
    actions: $94527.actions,
    name: 'ProjectCreateImporterUIStore'
});
const $8638263fe7697be9$export$fe5c3dd398c32c18 = (0, $ggKAj.createHook)($8638263fe7697be9$export$390f32400eaf98c9);

});
parcelRegister("94527", function(module, exports) {

$parcel$export(module.exports, "actions", () => $39c719a119d73a85$export$e324594224ef24da);

var $9HsT0 = parcelRequire("9HsT0");

var $9eqWv = parcelRequire("9eqWv");

var $6l6PQ = parcelRequire("6l6PQ");
const $39c719a119d73a85$export$ad3bed7477f17147 = (newState)=>({ setState: setState })=>{
        setState(newState);
    };
const $39c719a119d73a85$export$eaf355627c4aef80 = ()=>({ setState: setState })=>{
        setState((0, $9HsT0.INITIAL_UI_STATE));
    };
const $39c719a119d73a85$export$e324594224ef24da = {
    setUIState: $39c719a119d73a85$export$ad3bed7477f17147,
    resetUIState: $39c719a119d73a85$export$eaf355627c4aef80,
    setIsCancelImportModalOpen: $6l6PQ.setIsCancelImportModalOpen,
    resetCloseModalImportState: $6l6PQ.resetCloseModalImportState,
    setCancelImportModalState: $6l6PQ.setCancelImportModalState,
    setAccessTokenModalState: $9eqWv.setAccessTokenModalState,
    resetAccessTokenModalState: $9eqWv.resetAccessTokenModalState,
    setRequestAuthenticationToken: $9eqWv.setRequestAuthenticationToken
};

});
parcelRegister("9eqWv", function(module, exports) {

$parcel$export(module.exports, "setAccessTokenModalState", () => $854eec0df8abe1e8$export$4c96e1b216b83295);
$parcel$export(module.exports, "resetAccessTokenModalState", () => $854eec0df8abe1e8$export$b3e506c454cdcdcc);
$parcel$export(module.exports, "setRequestAuthenticationToken", () => $854eec0df8abe1e8$export$7b71767bed339758);

var $9HsT0 = parcelRequire("9HsT0");
const $854eec0df8abe1e8$export$4c96e1b216b83295 = (accessTokenModal)=>({ setState: setState, getState: getState })=>{
        setState({
            accessTokenModal: {
                ...getState().accessTokenModal,
                ...accessTokenModal
            }
        });
    };
const $854eec0df8abe1e8$export$b3e506c454cdcdcc = ()=>({ setState: setState })=>{
        setState({
            accessTokenModal: (0, $9HsT0.INITIAL_UI_STATE).accessTokenModal
        });
    };
const $854eec0df8abe1e8$export$7b71767bed339758 = (props)=>({ setState: setState, getState: getState })=>{
        let resolve = (value)=>value;
        const promise = new Promise((resolveProp)=>{
            resolve = (value)=>{
                resolveProp(value);
                return value;
            };
        });
        setState({
            accessTokenModal: {
                ...getState().accessTokenModal,
                isModalOpen: true,
                onFinishAccessTokenValidation: resolve,
                ...props
            }
        });
        return promise;
    };

});

parcelRegister("6l6PQ", function(module, exports) {

$parcel$export(module.exports, "setIsCancelImportModalOpen", () => $61bf56dc5462cebb$export$34a71770a9fa5ea4);
$parcel$export(module.exports, "setCancelImportModalState", () => $61bf56dc5462cebb$export$ccf204326395886e);
$parcel$export(module.exports, "resetCloseModalImportState", () => $61bf56dc5462cebb$export$607434fbdaaea13b);

var $9HsT0 = parcelRequire("9HsT0");
const $61bf56dc5462cebb$export$34a71770a9fa5ea4 = (isCancelImportModalOpen)=>({ setState: setState, getState: getState })=>{
        setState({
            cancelModal: {
                ...getState().cancelModal,
                isCancelImportModalOpen: isCancelImportModalOpen
            }
        });
    };
const $61bf56dc5462cebb$export$ccf204326395886e = (cancelImportModalState)=>({ setState: setState, getState: getState })=>{
        setState({
            cancelModal: {
                ...getState().cancelModal,
                ...cancelImportModalState
            }
        });
    };
const $61bf56dc5462cebb$export$607434fbdaaea13b = ()=>({ setState: setState })=>{
        setState({
            cancelModal: (0, $9HsT0.INITIAL_UI_STATE).cancelModal
        });
    };

});





parcelRegister("fiH3o", function(module, exports) {

$parcel$export(module.exports, "useProductSteps", () => $86287859457f7a97$export$9df16d4071d77679);

var $eUqFw = parcelRequire("eUqFw");

var $gd0Sp = parcelRequire("gd0Sp");

var $1pm5p = parcelRequire("1pm5p");

var $l58Ze = parcelRequire("l58Ze");

var $aEdcH = parcelRequire("aEdcH");
var $d0wrd = parcelRequire("d0wrd");
var $jFv2N = parcelRequire("jFv2N");
var $2sRUp = parcelRequire("2sRUp");
var $j5Nf5 = parcelRequire("j5Nf5");

var $8BfOE = parcelRequire("8BfOE");

var $4R50N = parcelRequire("4R50N");
const $86287859457f7a97$export$9df16d4071d77679 = ()=>{
    const [step] = (0, $j5Nf5.useStep)();
    const [importType] = (0, $aEdcH.useImportType)();
    const [{ type: type }] = (0, $d0wrd.useProjectData)();
    const { isSiteAdmin: isSiteAdmin, isAdmin: isAdmin } = (0, $gd0Sp.useTenantContext)();
    const [source] = (0, $2sRUp.useSource)();
    const [selectedSourceItem] = (0, $jFv2N.useSelectedSourceItem)();
    const productSteps = (0, $eUqFw.useMemo)(()=>(0, $l58Ze.getStepConfig)({
            importType: importType,
            projectType: type,
            isSiteAdmin: isSiteAdmin,
            isAdmin: isAdmin,
            source: source,
            supportedFlow: selectedSourceItem?.supportedFlow
        }), [
        importType,
        isAdmin,
        isSiteAdmin,
        selectedSourceItem?.supportedFlow,
        source,
        type
    ]);
    const currentStepIndex = productSteps.findIndex((productStep)=>productStep.step === step);
    return {
        productSteps: productSteps,
        currentStepIndex: currentStepIndex,
        currentStepConfig: productSteps[currentStepIndex] ?? (0, $1pm5p.DEFAULT_CONFIG)
    };
};

});
parcelRegister("jFv2N", function(module, exports) {

$parcel$export(module.exports, "useSourceItems", () => $79082e8f4e772cbd$export$3af11950d8de340);
$parcel$export(module.exports, "useSelectedSourceItem", () => $79082e8f4e772cbd$export$a9d04cf5934b64ad);

var $ggKAj = parcelRequire("ggKAj");
var $bj4JM = parcelRequire("bj4JM");

var $8JicK = parcelRequire("8JicK");
const $79082e8f4e772cbd$export$9d572347dc61a4b4 = (0, $bj4JM.createSelector)((state)=>state.sourceItems, (newState)=>newState);
const $79082e8f4e772cbd$export$3af11950d8de340 = (0, $ggKAj.createHook)((0, $8JicK.Store), {
    selector: $79082e8f4e772cbd$export$9d572347dc61a4b4
});
const $79082e8f4e772cbd$export$58c5d052359e22b6 = (0, $bj4JM.createSelector)((state)=>state.sourceItems?.find((item)=>item.key === state.importType), (newState)=>newState);
const $79082e8f4e772cbd$export$a9d04cf5934b64ad = (0, $ggKAj.createHook)((0, $8JicK.Store), {
    selector: $79082e8f4e772cbd$export$58c5d052359e22b6
});

});

parcelRegister("4R50N", function(module, exports) {

$parcel$export(module.exports, "useTools", () => $244c131b86f333a4$export$746cb67d959fd2b5);
$parcel$export(module.exports, "useImportTool", () => $244c131b86f333a4$export$1fe9260abde596eb);

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");

var $gd0Sp = parcelRequire("gd0Sp");

var $f7Zxq = parcelRequire("f7Zxq");

var $d0wrd = parcelRequire("d0wrd");
var $jFv2N = parcelRequire("jFv2N");
const $244c131b86f333a4$var$EMPTY_SUPPORTED_TOOLS = [];
const $244c131b86f333a4$var$EMPTY_UNAVAILABLE_TOOLS = [];
const $244c131b86f333a4$export$746cb67d959fd2b5 = ()=>{
    const [{ type: type }] = (0, $d0wrd.useProjectData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $gd0Sp.useTenantContext)();
    const [supportedTools, unavailableTools] = (0, $eUqFw.useMemo)(()=>{
        const tools = (0, $f7Zxq.getTools)(type, isSiteAdmin);
        return tools.reduce(([supported, unavailable], tool)=>tool.isSupported ? [
                [
                    ...supported,
                    tool
                ],
                unavailable
            ] : [
                supported,
                [
                    ...unavailable,
                    tool
                ]
            ], [
            $244c131b86f333a4$var$EMPTY_SUPPORTED_TOOLS,
            $244c131b86f333a4$var$EMPTY_UNAVAILABLE_TOOLS
        ]);
    }, [
        isSiteAdmin,
        type
    ]);
    return {
        supportedTools: supportedTools,
        unavailableTools: unavailableTools
    };
};
const $244c131b86f333a4$export$1fe9260abde596eb = (key)=>{
    const [{ type: type }] = (0, $d0wrd.useProjectData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $gd0Sp.useTenantContext)();
    const [selectedSourceItem] = (0, $jFv2N.useSelectedSourceItem)();
    return (0, $eUqFw.useMemo)(()=>{
        if ((0, $eI5EY.fg)('enable-x2c-standardised-flow')) return selectedSourceItem;
        const result = (0, $f7Zxq.getTools)(type, isSiteAdmin).find((tool)=>tool.key === key);
        return result && result.isSupported ? result : undefined;
    }, [
        isSiteAdmin,
        key,
        selectedSourceItem,
        type
    ]);
};

});
parcelRegister("f7Zxq", function(module, exports) {

$parcel$export(module.exports, "getTools", () => $07d62d4c77e40443$export$ffc9f93b394316dd);

var $77CtJ = parcelRequire("77CtJ");
var $11o4b = parcelRequire("11o4b");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $6hHg9 = parcelRequire("6hHg9");

var $70vb9 = parcelRequire("70vb9");

var $f7YdI = parcelRequire("f7YdI");

var $ijZeV = parcelRequire("ijZeV");

var $4vsbN = parcelRequire("4vsbN");

var $bLmGd = parcelRequire("bLmGd");

var $4HdID = parcelRequire("4HdID");

var $kLm4p = parcelRequire("kLm4p");

var $sPD6N = parcelRequire("sPD6N");

var $7J5LG = parcelRequire("7J5LG");

var $3ak5x = parcelRequire("3ak5x");

var $9R4E5 = parcelRequire("9R4E5");

var $fhbQi = parcelRequire("fhbQi");
const $07d62d4c77e40443$export$a7a2c3ce83b60c43 = {
    [(0, $3ak5x.JIRA_SOFTWARE)]: {
        key: (0, $3ak5x.JIRA_SOFTWARE),
        name: (0, $3ak5x.JIRA_DISPLAY_NAME),
        icon: {
            type: (0, $7J5LG.IconType).LOGO,
            component: (0, $77CtJ.JiraIcon),
            props: {
                size: 'large',
                appearance: 'brand'
            }
        },
        isSupported: false,
        label: (0, $fhbQi.default).jiraAppLabelSpork.defaultMessage
    },
    [(0, $3ak5x.TRELLO)]: {
        key: (0, $3ak5x.TRELLO),
        name: (0, $3ak5x.TRELLO_DISPLAY_NAME),
        icon: {
            type: (0, $7J5LG.IconType).LOGO,
            component: (0, $11o4b.TrelloIcon),
            props: {
                size: 'large',
                appearance: 'brand'
            }
        },
        isSupported: false
    },
    [(0, $3ak5x.SHEETS)]: {
        key: (0, $3ak5x.SHEETS),
        name: (0, $3ak5x.GOOGLE_SHEETS_DISPLAY_NAME),
        icon: {
            type: (0, $7J5LG.IconType).IMAGE,
            props: {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($4vsbN))),
                alt: (0, $3ak5x.GOOGLE_SHEETS_DISPLAY_NAME)
            }
        },
        isSupported: false
    },
    [(0, $3ak5x.EXCEL)]: {
        key: (0, $3ak5x.EXCEL),
        name: (0, $3ak5x.EXCEL_DISPLAY_NAME),
        icon: {
            type: (0, $7J5LG.IconType).IMAGE,
            props: {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($kLm4p))),
                alt: (0, $3ak5x.EXCEL_DISPLAY_NAME)
            }
        },
        isSupported: false
    },
    [(0, $3ak5x.MONDAY)]: {
        key: (0, $3ak5x.MONDAY),
        name: (0, $3ak5x.MONDAY_DISPLAY_NAME),
        icon: {
            type: (0, $7J5LG.IconType).IMAGE,
            props: {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($4HdID))),
                alt: 'Monday Icon'
            }
        },
        isSupported: false
    },
    [(0, $3ak5x.ASANA)]: {
        key: (0, $3ak5x.ASANA),
        name: (0, $3ak5x.ASANA_DISPLAY_NAME),
        icon: {
            type: (0, $7J5LG.IconType).IMAGE,
            props: {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($70vb9))),
                alt: 'Asana Icon'
            }
        },
        isSupported: false
    },
    [(0, $3ak5x.CLICK_UP)]: {
        key: (0, $3ak5x.CLICK_UP),
        name: (0, $3ak5x.CLICK_UP_DISPLAY_NAME),
        icon: {
            type: (0, $7J5LG.IconType).IMAGE,
            props: {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($f7YdI))),
                alt: (0, $3ak5x.CLICK_UP_DISPLAY_NAME)
            }
        },
        isSupported: false
    },
    [(0, $3ak5x.AIRTABLE)]: {
        key: (0, $3ak5x.AIRTABLE),
        name: (0, $3ak5x.AIRTABLE_DISPLAY_NAME),
        icon: {
            type: (0, $7J5LG.IconType).IMAGE,
            props: {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($6hHg9))),
                alt: (0, $3ak5x.AIRTABLE_DISPLAY_NAME)
            }
        },
        isSupported: false
    },
    [(0, $3ak5x.SMART_SHEET)]: {
        key: (0, $3ak5x.SMART_SHEET),
        name: (0, $3ak5x.SMART_SHEET_DISPLAY_NAME),
        icon: {
            type: (0, $7J5LG.IconType).LOGO,
            component: (0, $sPD6N.default),
            props: {}
        },
        isSupported: false
    },
    [(0, $3ak5x.GITHUB)]: {
        key: (0, $3ak5x.GITHUB),
        name: (0, $3ak5x.GITHUB_DISPLAY_NAME),
        icon: {
            type: (0, $7J5LG.IconType).LOGO,
            component: (0, $ijZeV.default),
            props: {}
        },
        isSupported: false
    },
    [(0, $3ak5x.LINEAR)]: {
        key: (0, $3ak5x.LINEAR),
        name: (0, $3ak5x.LINEAR_DISPLAY_NAME),
        icon: {
            type: (0, $7J5LG.IconType).LOGO,
            component: (0, $bLmGd.default),
            props: {}
        },
        isSupported: false
    },
    [(0, $3ak5x.JIRA_BUSINESS)]: {
        key: (0, $3ak5x.JIRA_BUSINESS),
        name: (0, $3ak5x.JIRA_DISPLAY_NAME),
        icon: {
            type: (0, $7J5LG.IconType).LOGO,
            component: (0, $77CtJ.JiraIcon),
            props: {
                size: 'large',
                appearance: 'brand'
            }
        },
        isSupported: false,
        label: (0, $fhbQi.default).jiraBusinessAppLabel.defaultMessage
    }
};
const $07d62d4c77e40443$var$getJWMTools = ()=>[
        {
            ...$07d62d4c77e40443$export$a7a2c3ce83b60c43[0, $3ak5x.JIRA_SOFTWARE],
            key: (0, $3ak5x.JIRA_SOFTWARE),
            isSupported: true,
            requiresOAuth: false,
            showPreOAuthModal: false,
            requiresPersonalAccessToken: false
        },
        {
            ...$07d62d4c77e40443$export$a7a2c3ce83b60c43[0, $3ak5x.TRELLO],
            key: (0, $3ak5x.TRELLO),
            isSupported: true,
            requiresOAuth: false,
            showPreOAuthModal: false,
            requiresPersonalAccessToken: false
        },
        {
            ...$07d62d4c77e40443$export$a7a2c3ce83b60c43[0, $3ak5x.MONDAY],
            key: (0, $3ak5x.MONDAY),
            isSupported: true,
            requiresOAuth: false,
            showPreOAuthModal: false,
            requiresPersonalAccessToken: true
        },
        {
            ...$07d62d4c77e40443$export$a7a2c3ce83b60c43[0, $3ak5x.ASANA],
            key: (0, $3ak5x.ASANA),
            showPreOAuthModal: false,
            isSupported: true,
            requiresOAuth: true,
            requiresPersonalAccessToken: false
        },
        {
            ...$07d62d4c77e40443$export$a7a2c3ce83b60c43[0, $3ak5x.CLICK_UP],
            key: (0, $3ak5x.CLICK_UP),
            isSupported: (0, $eI5EY.fg)('jwm_clickup_importer'),
            requiresOAuth: true,
            showPreOAuthModal: false,
            requiresPersonalAccessToken: false
        },
        $07d62d4c77e40443$export$a7a2c3ce83b60c43[0, $3ak5x.SHEETS],
        $07d62d4c77e40443$export$a7a2c3ce83b60c43[0, $3ak5x.EXCEL],
        $07d62d4c77e40443$export$a7a2c3ce83b60c43[0, $3ak5x.AIRTABLE],
        $07d62d4c77e40443$export$a7a2c3ce83b60c43[0, $3ak5x.SMART_SHEET]
    ];
const $07d62d4c77e40443$var$getJWMNonAdminTools = ()=>[
        {
            ...$07d62d4c77e40443$export$a7a2c3ce83b60c43[0, $3ak5x.TRELLO],
            key: (0, $3ak5x.TRELLO),
            isSupported: true,
            requiresOAuth: false,
            showPreOAuthModal: false,
            requiresPersonalAccessToken: false
        },
        {
            ...$07d62d4c77e40443$export$a7a2c3ce83b60c43[0, $3ak5x.ASANA],
            key: (0, $3ak5x.ASANA),
            showPreOAuthModal: false,
            isSupported: true,
            requiresOAuth: true,
            requiresPersonalAccessToken: false
        },
        $07d62d4c77e40443$export$a7a2c3ce83b60c43[0, $3ak5x.MONDAY],
        $07d62d4c77e40443$export$a7a2c3ce83b60c43[0, $3ak5x.JIRA_SOFTWARE],
        $07d62d4c77e40443$export$a7a2c3ce83b60c43[0, $3ak5x.SHEETS],
        $07d62d4c77e40443$export$a7a2c3ce83b60c43[0, $3ak5x.EXCEL],
        $07d62d4c77e40443$export$a7a2c3ce83b60c43[0, $3ak5x.CLICK_UP],
        $07d62d4c77e40443$export$a7a2c3ce83b60c43[0, $3ak5x.AIRTABLE],
        $07d62d4c77e40443$export$a7a2c3ce83b60c43[0, $3ak5x.SMART_SHEET]
    ];
const $07d62d4c77e40443$var$getJSWTools = ()=>[
        {
            ...$07d62d4c77e40443$export$a7a2c3ce83b60c43[0, $3ak5x.TRELLO],
            key: (0, $3ak5x.TRELLO),
            isSupported: (0, $1ybV0.ff)('enable-trello-importer-in-jsw-x2c_k25qu'),
            requiresOAuth: false,
            showPreOAuthModal: false,
            requiresPersonalAccessToken: false
        },
        {
            ...$07d62d4c77e40443$export$a7a2c3ce83b60c43[0, $3ak5x.ASANA],
            key: (0, $3ak5x.ASANA),
            showPreOAuthModal: false,
            isSupported: (0, $1ybV0.ff)('enable-x2c-asana-jsw-importer_ygp38'),
            requiresOAuth: true,
            requiresPersonalAccessToken: false
        },
        $07d62d4c77e40443$export$a7a2c3ce83b60c43[0, $3ak5x.MONDAY],
        $07d62d4c77e40443$export$a7a2c3ce83b60c43[0, $3ak5x.CLICK_UP],
        $07d62d4c77e40443$export$a7a2c3ce83b60c43[0, $3ak5x.GITHUB],
        $07d62d4c77e40443$export$a7a2c3ce83b60c43[0, $3ak5x.LINEAR]
    ];
const $07d62d4c77e40443$var$getJSWToolsWithBusinessProject = ()=>[
        {
            ...$07d62d4c77e40443$export$a7a2c3ce83b60c43[0, $3ak5x.JIRA_BUSINESS],
            key: (0, $3ak5x.JIRA_BUSINESS),
            isSupported: true,
            requiresOAuth: false,
            showPreOAuthModal: false,
            requiresPersonalAccessToken: false
        },
        ...$07d62d4c77e40443$var$getJSWTools()
    ];
const $07d62d4c77e40443$export$ffc9f93b394316dd = (type, isSiteAdmin = true)=>{
    switch(type){
        case (0, $9R4E5.ProjectTypes).BUSINESS:
            return (0, $1ybV0.ff)('gun-2207-non-admin-support-in-tmp-migration_k7z9p') && !isSiteAdmin ? $07d62d4c77e40443$var$getJWMNonAdminTools() : $07d62d4c77e40443$var$getJWMTools();
        case (0, $9R4E5.ProjectTypes).SOFTWARE:
            return (0, $1ybV0.ff)('jira-business-to-software-project-imports') ? $07d62d4c77e40443$var$getJSWToolsWithBusinessProject() : $07d62d4c77e40443$var$getJSWTools();
        default:
            return [];
    }
};

});
parcelRegister("11o4b", function(module, exports) {

$parcel$export(module.exports, "TrelloIcon", () => $a849d7cdf43e7ee7$export$4384da9b8b140bf4);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");

var $lpzFL = parcelRequire("lpzFL");

var $9m0Eq = parcelRequire("9m0Eq");

var $urYMl = parcelRequire("urYMl");
const $a849d7cdf43e7ee7$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $9m0Eq.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} clip-rule="evenodd" d="M24.286 5.337H7.714a2.585 2.585 0 0 0-2.585 2.585v16.572a2.585 2.585 0 0 0 2.585 2.584h16.572a2.585 2.585 0 0 0 2.585-2.584V7.922a2.585 2.585 0 0 0-2.585-2.585m-9.791 15.66a.86.86 0 0 1-.859.858h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86zm8.362-4.953a.86.86 0 0 1-.859.859h-3.634a.86.86 0 0 1-.859-.859V10.21a.86.86 0 0 1 .859-.86h3.634a.86.86 0 0 1 .859.86z" fill-rule="evenodd"/>
    </svg>`;
};
const $a849d7cdf43e7ee7$export$4384da9b8b140bf4 = ({ appearance: appearance, label: label = 'Trello', size: size = (0, $lpzFL.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $lpzFL.defaultLogoParams).iconColor, textColor: textColor = (0, $lpzFL.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $urYMl.default), {
        appearance: appearance,
        label: label,
        svg: $a849d7cdf43e7ee7$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("6hHg9", function(module, exports) {
module.exports = new URL("Airtable.84de76a4.svg", import.meta.url).toString();

});

parcelRegister("70vb9", function(module, exports) {
module.exports = new URL("Asana.68a46524.svg", import.meta.url).toString();

});

parcelRegister("f7YdI", function(module, exports) {
module.exports = new URL("ClickUp.fc84f5a1.svg", import.meta.url).toString();

});

parcelRegister("ijZeV", function(module, exports) {

$parcel$export(module.exports, "default", () => $617b920be1dc5294$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $juktg = parcelRequire("juktg");
const $617b920be1dc5294$var$GitHubIcon = ()=>{
    const { colorMode: colorMode } = (0, $juktg.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12 0C5.37 0 0 5.37 0 12C0 17.31 3.435 21.795 8.205 23.385C8.805 23.49 9.03 23.13 9.03 22.815C9.03 22.53 9.015 21.585 9.015 20.58C6 21.135 5.22 19.845 4.98 19.17C4.845 18.825 4.26 17.76 3.75 17.475C3.33 17.25 2.73 16.695 3.735 16.68C4.68 16.665 5.355 17.55 5.58 17.91C6.66 19.725 8.385 19.215 9.075 18.9C9.18 18.12 9.495 17.595 9.84 17.295C7.17 16.995 4.38 15.96 4.38 11.37C4.38 10.065 4.845 8.985 5.61 8.145C5.49 7.845 5.07 6.615 5.73 4.965C5.73 4.965 6.735 4.65 9.03 6.195C9.99 5.925 11.01 5.79 12.03 5.79C13.05 5.79 14.07 5.925 15.03 6.195C17.325 4.635 18.33 4.965 18.33 4.965C18.99 6.615 18.57 7.845 18.45 8.145C19.215 8.985 19.68 10.05 19.68 11.37C19.68 15.975 16.875 16.995 14.205 17.295C14.64 17.67 15.015 18.39 15.015 19.515C15.015 21.12 15 22.41 15 22.815C15 23.13 15.225 23.505 15.825 23.385C20.565 21.795 24 17.295 24 12C24 5.37 18.63 0 12 0Z",
        fill: colorMode === 'dark' ? '#FFFFFF' : '#24292f'
    }));
};
var $617b920be1dc5294$export$2e2bcd8739ae039 = $617b920be1dc5294$var$GitHubIcon;

});

parcelRegister("4vsbN", function(module, exports) {
module.exports = new URL("GoogleSheet.3f1e9841.svg", import.meta.url).toString();

});

parcelRegister("bLmGd", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc273706a781dc86$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $juktg = parcelRequire("juktg");
const $cc273706a781dc86$var$LinearIcon = ()=>{
    const { colorMode: colorMode } = (0, $juktg.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M0.294098 14.7655C0.240698 14.5378 0.511894 14.3945 0.67723 14.5598L9.44021 23.3228C9.60554 23.4881 9.46217 23.7593 9.23453 23.7059C4.81236 22.6685 1.33147 19.1876 0.294098 14.7655ZM0.000453923 11.2534C-0.00378058 11.3214 0.0217832 11.3878 0.0699511 11.4359L12.5641 23.93C12.6122 23.9782 12.6786 24.0038 12.7466 23.9995C13.3152 23.9641 13.8731 23.8891 14.4176 23.7773C14.6011 23.7396 14.6648 23.5142 14.5324 23.3818L0.618228 9.46764C0.485782 9.33518 0.260347 9.39892 0.222666 9.5824C0.110847 10.1269 0.0358694 10.6848 0.000453923 11.2534ZM1.01062 7.12929C0.970666 7.21901 0.991018 7.32384 1.06046 7.39329L16.6067 22.9395C16.6762 23.009 16.781 23.0293 16.8707 22.9894C17.2994 22.7984 17.7148 22.5831 18.1152 22.3452C18.2477 22.2665 18.2682 22.0844 18.1592 21.9754L2.02456 5.84081C1.91558 5.73182 1.73351 5.75227 1.65478 5.88477C1.41686 6.28519 1.20156 6.70063 1.01062 7.12929ZM3.03809 4.33776C2.94926 4.24893 2.94377 4.10647 3.02746 4.01277C5.22708 1.55023 8.42674 0 11.9885 0C18.6222 0 24 5.37775 24 12.0115C24 15.5733 22.4498 18.7729 19.9872 20.9725C19.8936 21.0562 19.7511 21.0507 19.6622 20.9619L3.03809 4.33776Z",
        fill: colorMode === 'dark' ? '#FFFFFF' : '#222326'
    }));
};
var $cc273706a781dc86$export$2e2bcd8739ae039 = $cc273706a781dc86$var$LinearIcon;

});

parcelRegister("4HdID", function(module, exports) {
module.exports = new URL("Monday.aa2f5c1e.svg", import.meta.url).toString();

});

parcelRegister("kLm4p", function(module, exports) {
module.exports = new URL("MSExcel.09868f4b.svg", import.meta.url).toString();

});

parcelRegister("sPD6N", function(module, exports) {

$parcel$export(module.exports, "default", () => $52864abe55411a65$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $juktg = parcelRequire("juktg");
const $52864abe55411a65$var$SmartSheetIcon = ()=>{
    const { colorMode: colorMode } = (0, $juktg.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M5.65566 9.80586C5.65566 9.80586 6.65758 8.3702 8.03861 8.31602C10.1508 8.28893 11.8567 12.0542 12.1275 12.5959C14.4563 7.36795 18.3286 2.9526 21.4427 0H2.21663C2.21663 1.78781 2.24371 20.0993 2.24371 21.5892C2.24371 22.7539 2.08124 23.6208 2 24C2.86653 23.8916 6.08892 23.2957 9.36547 22.1309C15.2145 20.0181 17.5162 17.7968 17.5162 17.7698L17.6787 17.6072L17.7599 17.7968C17.7599 17.7968 18.4911 19.4492 19.1951 20.2889C20.0075 21.237 20.4408 21.3454 20.6845 21.2641C21.0094 21.1558 21.226 20.6411 21.3073 19.7472C21.3885 18.8804 21.4698 16.9029 21.4698 14.5192V1.67945C15.8644 8.61399 11.6672 19.0971 11.6672 19.0971C11.6672 19.0971 8.93221 9.7246 5.65566 9.80586Z",
        fill: colorMode === 'dark' ? '#FFFFFF' : '#003059'
    }));
};
var $52864abe55411a65$export$2e2bcd8739ae039 = $52864abe55411a65$var$SmartSheetIcon;

});

parcelRegister("7J5LG", function(module, exports) {

$parcel$export(module.exports, "IconType", () => $861d73109e2c003b$export$13ff1290a9e22e77);
$parcel$export(module.exports, "renderIcon", () => $861d73109e2c003b$export$c9ee7e78f3ab4cc2);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $861d73109e2c003b$export$13ff1290a9e22e77 = {
    LOGO: 'logo',
    IMAGE: 'image'
};
const $861d73109e2c003b$export$c9ee7e78f3ab4cc2 = (icon, smallIcon)=>{
    if (icon.type === $861d73109e2c003b$export$13ff1290a9e22e77.LOGO) {
        const { component: Component, props: props } = icon;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
            ...props,
            ...smallIcon && {
                size: 'small'
            }
        });
    }
    if (icon.type === $861d73109e2c003b$export$13ff1290a9e22e77.IMAGE) return smallIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($861d73109e2c003b$var$IconImage, icon.props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($861d73109e2c003b$var$LargeIconImage, icon.props);
    return null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $861d73109e2c003b$var$LargeIconImage = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbxy5q _4t3ixy5q",
            __cmplp.className
        ])
    });
});
const $861d73109e2c003b$var$IconImage = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbv47k _4t3iv47k _1yt4v77o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("fhbQi", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c247d1549d548c1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7c247d1549d548c1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    jiraAppLabelSpork: {
        "id": "project-create-importer-upload-flow.common.constants.tools.jira-app-label-spork",
        "defaultMessage": "(software project)"
    },
    jiraBusinessAppLabel: {
        "id": "project-create-importer-upload-flow.common.constants.tools.jira-business-app-label",
        "defaultMessage": "(business project)"
    }
});

});




parcelRegister("8I0FM", function(module, exports) {

$parcel$export(module.exports, "default", () => $242ddc0f6f67c147$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
var $dxopF = parcelRequire("dxopF");

var $kGQen = parcelRequire("kGQen");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $lbttE = parcelRequire("lbttE");

var $fua3W = parcelRequire("fua3W");

var $6OWvL = parcelRequire("6OWvL");
const $242ddc0f6f67c147$var$CancelImportModal = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [{ isCancelImportModalOpen: isCancelImportModalOpen, shouldCloseDrawerOnCancel: shouldCloseDrawerOnCancel, onCloseModalCallback: onCloseModalCallback, offsetModalY: offsetModalY }, { resetCloseModalImportState: resetCloseModalImportState }] = (0, $fua3W.useCancelImportModalState)();
    const onClose = (0, $eUqFw.useCallback)(()=>{
        resetCloseModalImportState();
    }, [
        resetCloseModalImportState
    ]);
    const handleLeaveClick = (0, $eUqFw.useCallback)((closeDrawer)=>()=>{
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'leaveImport');
            onCloseModalCallback && onCloseModalCallback();
            shouldCloseDrawerOnCancel && closeDrawer();
            resetCloseModalImportState();
        }, [
        createAnalyticsEvent,
        shouldCloseDrawerOnCancel,
        onCloseModalCallback,
        resetCloseModalImportState
    ]);
    const handleStayClick = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'stayImport');
        resetCloseModalImportState();
    }, [
        createAnalyticsEvent,
        resetCloseModalImportState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lbttE.ProjectCreateDrawerConsumer), null, ({ methods: { close: close } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isCancelImportModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
            onClose: onClose,
            stackIndex: (offsetModalY || 0) / 8,
            testId: "project-create-importer-upload-flow.ui.cancel-import-modal.modal"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), {
            appearance: "warning"
        }, formatMessage((0, $6OWvL.default).cancelImportModalTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $6OWvL.default).cancelImportModalDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "subtle",
            onClick: handleStayClick,
            testId: "project-create-importer-upload-flow.ui.cancel-import-modal.continue-button",
            autoFocus: true
        }, formatMessage((0, $6OWvL.default).continueImport)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            testId: "project-create-importer-upload-flow.ui.cancel-import-modal.exit-button",
            appearance: "warning",
            onClick: handleLeaveClick(close)
        }, formatMessage((0, $6OWvL.default).exitImport)))))));
};
var $242ddc0f6f67c147$export$2e2bcd8739ae039 = $242ddc0f6f67c147$var$CancelImportModal;

});
parcelRegister("6OWvL", function(module, exports) {

$parcel$export(module.exports, "default", () => $3611524552705861$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3611524552705861$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    cancelImportModalTitle: {
        "id": "project-create-importer-upload-flow.cancel-import-modal.cancel-import-modal-title",
        "defaultMessage": "Are you sure you want to exit?"
    },
    cancelImportModalDescription: {
        "id": "project-create-importer-upload-flow.cancel-import-modal.cancel-import-modal-description",
        "defaultMessage": "You'll lose any progress you\u2019ve made with the import."
    },
    continueImport: {
        "id": "project-create-importer-upload-flow.cancel-import-modal.continue-import",
        "defaultMessage": "Continue"
    },
    exitImport: {
        "id": "project-create-importer-upload-flow.cancel-import-modal.exit-import",
        "defaultMessage": "Exit"
    }
});

});


parcelRegister("eMHXg", function(module, exports) {

$parcel$export(module.exports, "CSVUserMappingScreen", () => $91aec9c43ca3cce3$export$d1e1f029bbd70dba);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lzLxZ = parcelRequire("lzLxZ");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $lRvnl = parcelRequire("lRvnl");

var $4lTFP = parcelRequire("4lTFP");

var $e270j = parcelRequire("e270j");

var $4ixnM = parcelRequire("4ixnM");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2jdHI = parcelRequire("2jdHI");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $gd0Sp = parcelRequire("gd0Sp");

var $cHKP9 = parcelRequire("cHKP9");

var $kzTj7 = parcelRequire("kzTj7");

var $3yuWi = parcelRequire("3yuWi");

var $4nt6G = parcelRequire("4nt6G");

var $elKPF = parcelRequire("elKPF");

var $1T7vu = parcelRequire("1T7vu");

var $7cdKR = parcelRequire("7cdKR");

var $bLalW = parcelRequire("bLalW");
var $lUC5l = parcelRequire("lUC5l");
var $4uta0 = parcelRequire("4uta0");
var $2sRUp = parcelRequire("2sRUp");

var $fiH3o = parcelRequire("fiH3o");

var $lhF5g = parcelRequire("lhF5g");

var $84XLS = parcelRequire("84XLS");

var $iu9zr = parcelRequire("iu9zr");
const $91aec9c43ca3cce3$export$d1e1f029bbd70dba = ({ onReturn: onReturn, onNext: onNext, onCloseAndReturnToUploadStep: onCloseAndReturnToUploadStep, isCompact: isCompact, importType: importType })=>{
    const { productSteps: productSteps, currentStepIndex: currentStepIndex } = (0, $fiH3o.useProductSteps)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [source] = (0, $2sRUp.useSource)();
    const [migrationId] = (0, $4uta0.useMigrationId)();
    const [mappingState, { setMappingState: setMappingState }] = (0, $lUC5l.useMappingState)();
    const [advancedOptions] = (0, $bLalW.useAdvancedOptions)();
    const { isLoading: isLoading, hasErrorOccurred: hasErrorOccurred, readCSVMetadata: readCSVMetadata } = (0, $lhF5g.useReadCSVMetadata)(source);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [userMapping, setUserMapping] = (0, $eUqFw.useState)(mappingState?.userMapping || null);
    const { isAdmin: isAdmin, isSiteAdmin: isSiteAdmin } = (0, $gd0Sp.useTenantContext)();
    const onReadCSVUser = (0, $eUqFw.useCallback)(()=>{
        if (migrationId !== null && mappingState?.userMapping === null) readCSVMetadata({
            migrationId: migrationId,
            mappingState: mappingState,
            advancedOptions: advancedOptions
        }).then((resp)=>{
            if (!resp) return;
            setMappingState({
                ...mappingState,
                userMapping: resp.userMapping,
                issueCount: resp.issueCount,
                preFilledUsersCount: resp.preFilledUserCount
            });
            setUserMapping(resp.userMapping);
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'csvUser read', {
                numberOfUsers: Object.keys(resp.userMapping).length
            });
        });
    }, [
        migrationId,
        mappingState,
        readCSVMetadata,
        advancedOptions,
        setMappingState,
        createAnalyticsEvent
    ]);
    (0, $eUqFw.useEffect)(()=>{
        onReadCSVUser();
    }, [
        onReadCSVUser
    ]);
    const handleToggle = (0, $eUqFw.useCallback)(()=>{
        if (!mappingState) return;
        setMappingState({
            ...mappingState,
            shouldImportUsers: !mappingState.shouldImportUsers
        });
    }, [
        mappingState,
        setMappingState
    ]);
    const [handleEmailChange] = (0, $2jdHI.default)((userValue, data)=>{
        if (mappingState && (userValue === '' || (0, $4ixnM.default)(userValue))) setMappingState({
            ...mappingState,
            userMapping: data
        });
    }, (0, $kzTj7.DEBOUNCE_DELAY));
    const handleOnchange = (0, $eUqFw.useCallback)((userKey, userValue)=>{
        if (userMapping) {
            const data = {
                ...userMapping,
                [userKey]: {
                    ...userMapping[userKey],
                    userValue: userValue
                }
            };
            setUserMapping(data); // if validate email, save to mappingState
            handleEmailChange(userValue, data);
        }
    }, [
        handleEmailChange,
        userMapping
    ]);
    const getContent = (0, $eUqFw.useCallback)(()=>{
        if (hasErrorOccurred) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4nt6G.ErrorScreen), {
            onClick: onReadCSVUser,
            illustration: (0, (/*@__PURE__*/$parcel$interopDefault($cHKP9))),
            header: formatMessage((0, $84XLS.default).errorHeading),
            description: formatMessage((0, $84XLS.default).errorDescription),
            testId: "project-create-importer-upload-flow.ui.csv-user-mapping-screen.error-screen"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $elKPF.StepFooterStandard), {
            alignRight: true,
            isFixedPosition: !isCompact,
            onReturn: onReturn,
            shouldDisableNext: true
        }));
        // no users in csv file
        if (!isLoading && userMapping && Object.keys(userMapping).length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
            title: formatMessage((0, $84XLS.default).titleForNoUsers)
        }, formatMessage((0, $84XLS.default).descriptionForNoUsers, {
            ul: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($91aec9c43ca3cce3$var$StyledUl, null, chunks),
            li: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", null, chunks),
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                    as: "strong"
                }, chunks)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $elKPF.StepFooterStandard), {
            alignRight: true,
            isFixedPosition: !isCompact,
            onReturn: onReturn,
            onClickNext: onNext
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            space: "space.050",
            alignBlock: "center",
            xcss: $91aec9c43ca3cce3$var$toggleWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e270j.default), {
            id: "toggle-map-user",
            isChecked: mappingState?.shouldImportUsers,
            onChange: handleToggle,
            isDisabled: isLoading
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($91aec9c43ca3cce3$var$Label, {
            htmlFor: "toggle-map-user"
        }, formatMessage((0, $84XLS.default).toggleLabel))), mappingState?.shouldImportUsers ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $91aec9c43ca3cce3$var$descriptionStyles
        }, formatMessage((0, $84XLS.default).description)), (0, $1ybV0.ff)('enable-product-admin-for-x2c-migration_zmlsv') && !isSiteAdmin && isAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            paddingBlockEnd: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
            title: formatMessage((0, $84XLS.default).newUserNotAllowedToImportBannerHeading)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            as: "p"
        }, formatMessage((0, $84XLS.default).newUserNotAllowedToImportBannerDescription)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lzLxZ.default), {
            onSubmit: onNext
        }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iu9zr.UserMappingTable), {
                isLoading: isLoading,
                users: userMapping,
                importType: importType,
                onChange: handleOnchange
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $elKPF.StepFooterStandard), {
                alignRight: true,
                isFixedPosition: !isCompact,
                onReturn: onReturn,
                nextButtonType: "submit",
                shouldDisableNext: isLoading
            })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), null, formatMessage((0, $84XLS.default).descriptionForNotImportUsers)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $elKPF.StepFooterStandard), {
            alignRight: true,
            isFixedPosition: !isCompact,
            onReturn: onReturn,
            onClickNext: onNext
        })));
    }, [
        formatMessage,
        handleOnchange,
        handleToggle,
        hasErrorOccurred,
        importType,
        isAdmin,
        isCompact,
        isLoading,
        isSiteAdmin,
        mappingState?.shouldImportUsers,
        onNext,
        onReadCSVUser,
        onReturn,
        userMapping
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: (0, $3yuWi.X2C_SCREENS).USER_MAPPING,
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7cdKR.StepScreen), {
        testId: "project-create-importer-upload-flow.ui.csv-user-mapping-screen.step-screen",
        renderProgressBar: !isCompact && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1T7vu.ProgressBarStandard), {
            productSteps: productSteps,
            currentStepIndex: currentStepIndex,
            onClose: onCloseAndReturnToUploadStep
        }),
        header: formatMessage((0, $84XLS.default).heading),
        maxWidth: "674px"
    }, getContent(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null)));
};
const $91aec9c43ca3cce3$var$toggleWrapperStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.200',
    marginBottom: 'space.200'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $91aec9c43ca3cce3$var$Label = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81il0",
            __cmplp.className
        ])
    });
});
const $91aec9c43ca3cce3$var$descriptionStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.subtle',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    font: `var(--ds-font-body, ${(0, $4lTFP.fontFallback).body.medium})`,
    paddingBottom: 'space.400'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $91aec9c43ca3cce3$var$StyledUl = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bozg1ejb _19pk1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lzLxZ", function(module, exports) {

$parcel$export(module.exports, "FormContext", () => $35270e9129320e50$export$c24727297075ec6a);
$parcel$export(module.exports, "IsDisabledContext", () => $35270e9129320e50$export$c17cf6b332a82dbc);
$parcel$export(module.exports, "default", () => $35270e9129320e50$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3DX5R = parcelRequire("3DX5R");

var $519wV = parcelRequire("519wV");

var $a0i0f = parcelRequire("a0i0f");
const $35270e9129320e50$export$c24727297075ec6a = /*#__PURE__*/ (0, $eUqFw.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});
const $35270e9129320e50$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
function $35270e9129320e50$export$2e2bcd8739ae039(props) {
    const formRef = (0, $eUqFw.useRef)(null);
    const onSubmitRef = (0, $eUqFw.useRef)(props.onSubmit);
    onSubmitRef.current = props.onSubmit;
    const [form] = (0, $eUqFw.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $3DX5R.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        /* eslint-disable no-param-reassign */ (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(values, name, value);
                    /* eslint-enable */ }
                }
            }
        });
        (0, $519wV.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $eUqFw.useState)({
        dirty: false,
        submitting: false
    });
    (0, $eUqFw.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $eUqFw.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
	 * This method is needed in FormContext to use it on the field level
	 * to check the current value of the field in case of the component re-mounting.
	 */ const getCurrentValue = (0, $eUqFw.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $eUqFw.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35270e9129320e50$export$c24727297075ec6a.Provider, {
        value: FormContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35270e9129320e50$export$c17cf6b332a82dbc.Provider, {
        value: isDisabled
    }, children({
        formProps: {
            onSubmit: handleSubmit,
            ref: formRef,
            onKeyDown: handleKeyDown
        },
        dirty: dirty,
        reset: handleReset,
        submitting: submitting,
        disabled: isDisabled,
        getState: ()=>form.getState(),
        getValues: ()=>form.getState().values,
        setFieldValue: form.change
    })));
}

});
parcelRegister("3DX5R", function(module, exports) {

$parcel$export(module.exports, "getIn", () => $2a72da5b7ec16659$export$c52e5867d5879e24);
$parcel$export(module.exports, "FORM_ERROR", () => $2a72da5b7ec16659$export$97cd7fc25dd32915);
$parcel$export(module.exports, "fieldSubscriptionItems", () => $2a72da5b7ec16659$export$41e855cb628c1b55);
$parcel$export(module.exports, "formSubscriptionItems", () => $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3);
$parcel$export(module.exports, "version", () => $2a72da5b7ec16659$export$83d89fbfd8236492);
$parcel$export(module.exports, "createForm", () => $2a72da5b7ec16659$export$f681a8129d2e9d28);

var $kU09D = parcelRequire("kU09D");

var $6XgOP = parcelRequire("6XgOP");
//      
var $2a72da5b7ec16659$var$charCodeOfDot = ".".charCodeAt(0);
var $2a72da5b7ec16659$var$reEscapeChar = /\\(\\)?/g;
var $2a72da5b7ec16659$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $2a72da5b7ec16659$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $2a72da5b7ec16659$var$charCodeOfDot) result.push("");
    string.replace($2a72da5b7ec16659$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($2a72da5b7ec16659$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $2a72da5b7ec16659$var$keysCache = {};
var $2a72da5b7ec16659$var$keysRegex = /[.[\]]+/;
var $2a72da5b7ec16659$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($2a72da5b7ec16659$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $2a72da5b7ec16659$var$keysCache[key] = key.split($2a72da5b7ec16659$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $2a72da5b7ec16659$var$keysCache[key] = $2a72da5b7ec16659$var$stringToPath(key);
    }
    return $2a72da5b7ec16659$var$keysCache[key];
};
//      
var $2a72da5b7ec16659$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $2a72da5b7ec16659$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $2a72da5b7ec16659$var$_toPropertyKey(arg) {
    var key = $2a72da5b7ec16659$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $2a72da5b7ec16659$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $2a72da5b7ec16659$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $6XgOP.default)(current, [
                key
            ].map($2a72da5b7ec16659$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $kU09D.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $2a72da5b7ec16659$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $2a72da5b7ec16659$var$setInRecursor(state, 0, $2a72da5b7ec16659$var$toPath(key), value1, destroyArrays);
};
var $2a72da5b7ec16659$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $2a72da5b7ec16659$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $2a72da5b7ec16659$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $2a72da5b7ec16659$export$c52e5867d5879e24(values, name);
    var error = $2a72da5b7ec16659$export$c52e5867d5879e24(errors, name);
    if (error && error[$2a72da5b7ec16659$export$735bebc8ffabf28a]) error = error[$2a72da5b7ec16659$export$735bebc8ffabf28a];
    var submitError = submitErrors && $2a72da5b7ec16659$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $2a72da5b7ec16659$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $2a72da5b7ec16659$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $2a72da5b7ec16659$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $2a72da5b7ec16659$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$2a72da5b7ec16659$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $2a72da5b7ec16659$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $2a72da5b7ec16659$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $2a72da5b7ec16659$var$subscriptionFilter(result, state, previousState, subscription, $2a72da5b7ec16659$export$41e855cb628c1b55, $2a72da5b7ec16659$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $2a72da5b7ec16659$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $2a72da5b7ec16659$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $2a72da5b7ec16659$var$subscriptionFilter(result, state, previousState, subscription, $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3, $2a72da5b7ec16659$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $2a72da5b7ec16659$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$2a72da5b7ec16659$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $2a72da5b7ec16659$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $2a72da5b7ec16659$export$83d89fbfd8236492 = "4.20.10";
var $2a72da5b7ec16659$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $2a72da5b7ec16659$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $2a72da5b7ec16659$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $2a72da5b7ec16659$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $2a72da5b7ec16659$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $2a72da5b7ec16659$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $2a72da5b7ec16659$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $2a72da5b7ec16659$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($2a72da5b7ec16659$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $2a72da5b7ec16659$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $kU09D.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $kU09D.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $kU09D.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $kU09D.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $kU09D.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $2a72da5b7ec16659$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $2a72da5b7ec16659$export$e6bdf135a54e021b,
                    shallowEqual: $2a72da5b7ec16659$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $kU09D.default)({}, state.formState.values)); // clone to avoid writing
            if ($2a72da5b7ec16659$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $2a72da5b7ec16659$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $2a72da5b7ec16659$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $kU09D.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $2a72da5b7ec16659$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $2a72da5b7ec16659$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $2a72da5b7ec16659$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$2a72da5b7ec16659$export$735bebc8ffabf28a]) {
                    var existing = $2a72da5b7ec16659$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$2a72da5b7ec16659$export$735bebc8ffabf28a] = error[$2a72da5b7ec16659$export$735bebc8ffabf28a];
                    merged = $2a72da5b7ec16659$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$2a72da5b7ec16659$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$2a72da5b7ec16659$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $2a72da5b7ec16659$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $2a72da5b7ec16659$var$notify(fieldSubscriber, fieldState, lastFieldState, $2a72da5b7ec16659$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $2a72da5b7ec16659$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$2a72da5b7ec16659$var$hasAnyError(formState.errors) && !(formState.submitErrors && $2a72da5b7ec16659$var$hasAnyError(formState.submitErrors));
        var nextFormState = $2a72da5b7ec16659$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $2a72da5b7ec16659$var$notify(state.subscribers, nextFormState, lastFormState, $2a72da5b7ec16659$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $kU09D.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $kU09D.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $kU09D.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $2a72da5b7ec16659$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $2a72da5b7ec16659$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name) === $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $kU09D.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $kU09D.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $kU09D.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $2a72da5b7ec16659$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$2a72da5b7ec16659$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $kU09D.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $2a72da5b7ec16659$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $2a72da5b7ec16659$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $2a72da5b7ec16659$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $2a72da5b7ec16659$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("519wV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a747034649a7960$export$2e2bcd8739ae039);

var $3DX5R = parcelRequire("3DX5R");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $3a747034649a7960$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $3a747034649a7960$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($3a747034649a7960$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $3a747034649a7960$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $3DX5R.getIn)(errors, input.name);
    });
};
//      
var $3a747034649a7960$var$noop = function noop() {};
var $3a747034649a7960$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $3a747034649a7960$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $3a747034649a7960$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $3a747034649a7960$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $3a747034649a7960$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($3a747034649a7960$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$3a747034649a7960$export$2e2bcd8739ae039 = $3a747034649a7960$var$createDecorator;

});

parcelRegister("a0i0f", function(module, exports) {

var $buvff = parcelRequire("buvff");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $7487de7aebcafd99$var$set(object, path, value) {
    return object == null ? object : $buvff(object, path, value);
}
module.exports = $7487de7aebcafd99$var$set;

});


parcelRegister("lRvnl", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dc3a504e8cabc14$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hI5oG = parcelRequire("hI5oG");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $gf4A3 = parcelRequire("gf4A3");
const $4dc3a504e8cabc14$var$sectionMessageStyles = (0, $1ZAYh.xcss)({
    wordBreak: 'break-word',
    borderRadius: 'border.radius'
});
const $4dc3a504e8cabc14$var$bleedStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    marginBlock: 'space.negative.025'
});
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ const $4dc3a504e8cabc14$var$SectionMessage = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, icon: icon, testId: testId }, ref) {
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $gf4A3.getAppearanceIconStyles)(appearance, icon);
    const actionElements = actions && actions.type === (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment ? actions.props.children : actions;
    const actionsArray = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(actionElements);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "section",
        backgroundColor: $4dc3a504e8cabc14$var$appearanceMap[appearance],
        padding: "space.200",
        testId: testId,
        ref: ref,
        xcss: $4dc3a504e8cabc14$var$sectionMessageStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.200",
        alignBlock: "stretch"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $4dc3a504e8cabc14$var$bleedStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
        size: "medium",
        primaryColor: primaryColor,
        secondaryColor: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.100",
        testId: testId && `${testId}--content`
    }, !!title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        as: "h2",
        level: "h500"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), null, children), actionsArray.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        shouldWrap: true,
        testId: testId && `${testId}--actions`,
        separator: "\xb7",
        space: "space.100",
        rowSpace: "space.0"
    }, actionsArray))));
});
const $4dc3a504e8cabc14$var$appearanceMap = {
    information: 'color.background.information',
    warning: 'color.background.warning',
    error: 'color.background.danger',
    success: 'color.background.success',
    discovery: 'color.background.discovery'
};
$4dc3a504e8cabc14$var$SectionMessage.displayName = 'SectionMessage';
var $4dc3a504e8cabc14$export$2e2bcd8739ae039 = $4dc3a504e8cabc14$var$SectionMessage;

});
parcelRegister("gf4A3", function(module, exports) {

$parcel$export(module.exports, "getAppearanceIconStyles", () => $5e1f1f04e3e69c39$export$e9b82d2e21ac0c1f);

var $eUqFw = parcelRequire("eUqFw");

var $aWvIp = parcelRequire("aWvIp");

var $96IgR = parcelRequire("96IgR");

var $2bv8J = parcelRequire("2bv8J");

var $ioiQ7 = parcelRequire("ioiQ7");

var $5YsMl = parcelRequire("5YsMl");

var $PdmhA = parcelRequire("PdmhA");
const $5e1f1f04e3e69c39$export$faa35441caff5bb6 = {
    information: {
        backgroundColor: `var(--ds-background-information, ${(0, $PdmhA.B50)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($2bv8J))),
        primaryIconColor: `var(--ds-icon-information, ${(0, $PdmhA.B500)})`
    },
    warning: {
        backgroundColor: `var(--ds-background-warning, ${(0, $PdmhA.Y50)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))),
        primaryIconColor: `var(--ds-icon-warning, ${(0, $PdmhA.Y500)})`
    },
    error: {
        backgroundColor: `var(--ds-background-danger, ${(0, $PdmhA.R50)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($96IgR))),
        primaryIconColor: `var(--ds-icon-danger, ${(0, $PdmhA.R500)})`
    },
    success: {
        backgroundColor: `var(--ds-background-success, ${(0, $PdmhA.G50)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))),
        primaryIconColor: `var(--ds-icon-success, ${(0, $PdmhA.G500)})`
    },
    discovery: {
        backgroundColor: `var(--ds-background-discovery, ${(0, $PdmhA.P50)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($ioiQ7))),
        primaryIconColor: `var(--ds-icon-discovery, ${(0, $PdmhA.P500)})`
    }
};
function $5e1f1f04e3e69c39$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $5e1f1f04e3e69c39$export$faa35441caff5bb6[appearance] || $5e1f1f04e3e69c39$export$faa35441caff5bb6.information;
    const AppearanceIcon = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(appearanceIconStyles.Icon, {
            size: size,
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}

});
parcelRegister("aWvIp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f77ec2b05210607$var$_react = $7f77ec2b05210607$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $7f77ec2b05210607$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $7f77ec2b05210607$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $7f77ec2b05210607$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="10"/><path d="M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z" fill="inherit"/></g></svg>`
    }, props));
$7f77ec2b05210607$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $7f77ec2b05210607$var$_default = $7f77ec2b05210607$var$CheckCircleIcon;
module.exports.default = $7f77ec2b05210607$var$_default;

});

parcelRegister("2bv8J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1974c390fcca76c2$var$_react = $1974c390fcca76c2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $1974c390fcca76c2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $1974c390fcca76c2$var$InfoIcon = (props)=>/*#__PURE__*/ $1974c390fcca76c2$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12z" fill="currentColor"/><rect fill="inherit" x="11" y="10" width="2" height="7" rx="1"/><circle fill="inherit" cx="12" cy="8" r="1"/></g></svg>`
    }, props));
$1974c390fcca76c2$var$InfoIcon.displayName = 'InfoIcon';
var $1974c390fcca76c2$var$_default = $1974c390fcca76c2$var$InfoIcon;
module.exports.default = $1974c390fcca76c2$var$_default;

});



parcelRegister("e270j", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d3122f1d9f9fa05$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $jFtVs = parcelRequire("jFtVs");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

var $je5kZ = parcelRequire("je5kZ");

var $k9Z3M = parcelRequire("k9Z3M");

var $gnr5M = parcelRequire("gnr5M");
const $4d3122f1d9f9fa05$export$3eb7d6130acfda37 = (size)=>size === 'large' ? 'large' : 'small';
const $4d3122f1d9f9fa05$var$noop = (0, $5Q9wj.default);
const $4d3122f1d9f9fa05$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: undefined,
    packageVersion: undefined
};
/**
 * __Toggle__
 *
 * A toggle is used to view or switch between enabled or disabled states.
 *
 * - [Examples](https://atlassian.design/components/toggle/examples)
 * - [Code](https://atlassian.design/components/toggle/code)
 * - [Usage](https://atlassian.design/components/toggle/usage)
 */ const $4d3122f1d9f9fa05$var$Toggle = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $4d3122f1d9f9fa05$var$noop, onChange: providedChange = $4d3122f1d9f9fa05$var$noop, onFocus: providedFocus = $4d3122f1d9f9fa05$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $eUqFw.useState)(defaultChecked);
    const handleBlur = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: providedOnBlur,
        action: 'blur',
        analyticsData: analyticsContext,
        ...$4d3122f1d9f9fa05$var$analyticsAttributes
    });
    const handleFocus = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$4d3122f1d9f9fa05$var$analyticsAttributes
    });
    const handleChange = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$4d3122f1d9f9fa05$var$analyticsAttributes
    });
    const shouldChecked = isControlled ? checked : isChecked;
    const controlProps = {
        'data-checked': shouldChecked ? shouldChecked : undefined,
        'data-disabled': isDisabled ? isDisabled : undefined,
        'data-size': size,
        'data-testid': testId ? testId : undefined
    };
    const toggleStyles = (0, $eUqFw.useMemo)(()=>(0, $gnr5M.getStyles)(size), [
        size
    ]);
    const uuid = (0, $jFtVs.useUIDSeed)()('toggle');
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("label", {
        ...controlProps,
        css: toggleStyles
    }, label ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        id: `${uuid}-label`,
        hidden: true
    }, label) : null, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ref: ref,
        checked: shouldChecked,
        disabled: isDisabled,
        id: id,
        name: name,
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus,
        type: "checkbox",
        value: value,
        "data-testid": testId && `${testId}--input`,
        "aria-labelledby": label ? `${uuid}-label` : undefined,
        "aria-describedby": descriptionId
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($k9Z3M))), {
        label: "",
        size: $4d3122f1d9f9fa05$export$3eb7d6130acfda37(size),
        testId: testId && `${testId}--toggle-check-icon`
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($je5kZ))), {
        label: "",
        size: $4d3122f1d9f9fa05$export$3eb7d6130acfda37(size),
        testId: testId && `${testId}--toggle-cross-icon`
    })));
}));
$4d3122f1d9f9fa05$var$Toggle.displayName = 'Toggle';
var $4d3122f1d9f9fa05$export$2e2bcd8739ae039 = $4d3122f1d9f9fa05$var$Toggle;

});
parcelRegister("je5kZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dff3771012ed2785$var$_react = $dff3771012ed2785$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $dff3771012ed2785$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $dff3771012ed2785$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $dff3771012ed2785$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M15.185 7.4l-3.184 3.185-3.186-3.186a.507.507 0 00-.712.003l-.7.701a.496.496 0 00-.004.712l3.185 3.184L7.4 15.185a.507.507 0 00.004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 00.712-.004l.701-.7a.496.496 0 00.003-.712l-3.186-3.186 3.186-3.184a.507.507 0 00-.003-.712l-.7-.7a.508.508 0 00-.36-.153.5.5 0 00-.353.15z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$dff3771012ed2785$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $dff3771012ed2785$var$_default = $dff3771012ed2785$var$EditorCloseIcon;
module.exports.default = $dff3771012ed2785$var$_default;

});

parcelRegister("k9Z3M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ead4032469749d51$var$_react = $ead4032469749d51$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $ead4032469749d51$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $ead4032469749d51$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $ead4032469749d51$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M7.356 10.942a.497.497 0 00-.713 0l-.7.701a.501.501 0 00-.003.71l3.706 3.707a.501.501 0 00.705.003l7.712-7.712a.493.493 0 00-.006-.708l-.7-.7a.504.504 0 00-.714 0l-6.286 6.286a.506.506 0 01-.713 0l-2.288-2.287z" fill="currentColor"/></svg>`
    }, props));
$ead4032469749d51$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $ead4032469749d51$var$_default = $ead4032469749d51$var$EditorDoneIcon;
module.exports.default = $ead4032469749d51$var$_default;

});

parcelRegister("gnr5M", function(module, exports) {

$parcel$export(module.exports, "getStyles", () => $f3c1d4ec47a37a63$export$ffd58b7f6f099a57);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $lcnyw = parcelRequire("lcnyw");

var $3Vu5P = parcelRequire("3Vu5P");
const $f3c1d4ec47a37a63$var$globalGridSize = (0, $lcnyw.gridSize)();
const $f3c1d4ec47a37a63$var$dimensions = {
    regular: {
        height: $f3c1d4ec47a37a63$var$globalGridSize * 2,
        width: $f3c1d4ec47a37a63$var$globalGridSize * 4
    },
    large: {
        height: $f3c1d4ec47a37a63$var$globalGridSize * 2 + $f3c1d4ec47a37a63$var$globalGridSize / 2,
        width: $f3c1d4ec47a37a63$var$globalGridSize * 5
    }
};
const $f3c1d4ec47a37a63$var$getHeight = ({ size: size })=>$f3c1d4ec47a37a63$var$dimensions[size].height;
const $f3c1d4ec47a37a63$var$getWidth = ({ size: size })=>$f3c1d4ec47a37a63$var$dimensions[size].width;
const $f3c1d4ec47a37a63$var$borderWidth = 2;
const $f3c1d4ec47a37a63$var$paddingUnitless = $f3c1d4ec47a37a63$var$globalGridSize / 4;
const $f3c1d4ec47a37a63$var$transition = 'transform 0.2s ease';
const $f3c1d4ec47a37a63$export$ffd58b7f6f099a57 = (size)=>{
    const colors = (0, $3Vu5P.getColors)();
    // TODO: Use tokens and reorganize to alphasemantic ordering (DSP-11769 DSP-11770)
    /* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview,@repo/internal/styles/consistent-style-ordering */ return /*#__PURE__*/ (0, $byn9U.css)({
        boxSizing: 'content-box',
        display: 'inline-block',
        padding: $f3c1d4ec47a37a63$var$borderWidth,
        margin: $f3c1d4ec47a37a63$var$borderWidth,
        backgroundClip: 'content-box',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: colors.backgroundColorUnchecked,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderRadius: `${$f3c1d4ec47a37a63$var$getHeight({
            size: size
        })}px`,
        border: `${$f3c1d4ec47a37a63$var$borderWidth}px solid transparent`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${$f3c1d4ec47a37a63$var$getHeight({
            size: size
        })}px`,
        position: 'relative',
        transition: `${$f3c1d4ec47a37a63$var$transition}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${$f3c1d4ec47a37a63$var$getWidth({
            size: size
        })}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-checked]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorChecked,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: colors.iconColorChecked
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]:not([data-checked])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorUncheckedDisabled
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-disabled][data-checked],&[data-disabled][data-checked]:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorCheckedDisabled
        },
        '&:focus-within': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            border: `${$f3c1d4ec47a37a63$var$borderWidth}px solid ${colors.borderColorFocus}`
        },
        '&:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorUncheckedHover,
            cursor: 'pointer'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]:hover,&[data-disabled][data-checked]:hover,&[data-disabled]:not([data-checked]):hover': {
            cursor: 'not-allowed'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-checked]:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorCheckedHover
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not([data-checked]):hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorUncheckedHover
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]:not([data-checked]):hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.backgroundColorCheckedDisabled
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: colors.iconColorUnchecked,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-disabled], &[data-disabled][data-checked], &[data-disabled][data-checked]:hover': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: colors.iconColorDisabled
        },
        // the input element underneath
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        'input[type="checkbox"]': {
            opacity: 0,
            margin: 0,
            padding: 0,
            border: 'none',
            '&:focus': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
                outline: 'none !important'
            }
        },
        // slider
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.handleBackgroundColor,
            borderRadius: "var(--ds-border-radius-circle, 50%)",
            content: '""',
            position: 'absolute',
            transform: 'initial',
            transition: $f3c1d4ec47a37a63$var$transition,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            insetBlockEnd: `${2 * $f3c1d4ec47a37a63$var$paddingUnitless}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${$f3c1d4ec47a37a63$var$getHeight({
                size: size
            }) - $f3c1d4ec47a37a63$var$paddingUnitless * 2}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${$f3c1d4ec47a37a63$var$getHeight({
                size: size
            }) - $f3c1d4ec47a37a63$var$paddingUnitless * 2}px`,
            // initially we set left as left-most position
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            insetInlineStart: `${2 * $f3c1d4ec47a37a63$var$paddingUnitless}px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-checked]::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.handleBackgroundColorChecked,
            // when  it's checked, slide the pseudo-element to right-most postion
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            transform: `translateX(${$f3c1d4ec47a37a63$var$getHeight({
                size: size
            })}px)`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-disabled]::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: colors.handleBackgroundColorDisabled,
            zIndex: 1
        },
        // icons - check and cross
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> span': {
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            insetBlockStart: `${$f3c1d4ec47a37a63$var$paddingUnitless}px`
        },
        // This is the first of the two on/off symbols. The first of type is a
        // hidden text `span` for labeling
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> span:nth-last-of-type(2)': {
            insetInlineStart: `3px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> span:last-of-type': {
            insetInlineEnd: `3px`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...size === 'large' && {
            '> span': {
                position: 'absolute',
                height: '20px',
                width: '20px'
            }
        },
        '@media screen and (forced-colors: active)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '::before': {
                filter: 'grayscale(100%) invert(1)'
            },
            '&:focus-within': {
                outline: '1px solid'
            }
        }
    });
};

});
parcelRegister("3Vu5P", function(module, exports) {

$parcel$export(module.exports, "getColors", () => $a04fcc2fd7c04036$export$6cee60e8aa85e528);

var $PdmhA = parcelRequire("PdmhA");
const $a04fcc2fd7c04036$var$colorMap = {
    backgroundColorChecked: `var(--ds-background-success-bold, ${(0, $PdmhA.G400)})`,
    backgroundColorCheckedHover: `var(--ds-background-success-bold-hovered, ${(0, $PdmhA.G500)})`,
    backgroundColorCheckedDisabled: `var(--ds-background-disabled, ${(0, $PdmhA.N20)})`,
    backgroundColorUnchecked: `var(--ds-background-neutral-bold, ${(0, $PdmhA.N200)})`,
    backgroundColorUncheckedHover: `var(--ds-background-neutral-bold-hovered, ${(0, $PdmhA.N400)})`,
    backgroundColorUncheckedDisabled: `var(--ds-background-disabled, ${(0, $PdmhA.N20)})`,
    borderColorFocus: `var(--ds-border-focused, ${(0, $PdmhA.B200)})`,
    iconColorChecked: `var(--ds-icon-inverse, ${(0, $PdmhA.N0)})`,
    iconColorDisabled: `var(--ds-icon-disabled, ${(0, $PdmhA.N70)})`,
    iconColorUnchecked: `var(--ds-icon-inverse, ${(0, $PdmhA.N0)})`,
    handleBackgroundColor: `var(--ds-icon-inverse, ${(0, $PdmhA.N0)})`,
    handleBackgroundColorChecked: `var(--ds-icon-inverse, ${(0, $PdmhA.N0)})`,
    handleBackgroundColorDisabled: `var(--ds-icon-inverse, ${(0, $PdmhA.N0)})`
};
const $a04fcc2fd7c04036$export$6cee60e8aa85e528 = ()=>$a04fcc2fd7c04036$var$colorMap;

});



parcelRegister("4ixnM", function(module, exports) {

$parcel$export(module.exports, "default", () => $03220679a6b885f0$export$2e2bcd8739ae039);
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
var $03220679a6b885f0$export$2e2bcd8739ae039 = (string)=>{
    if (!string || typeof string !== 'string') return false;
    return /\S+@\S+/.test(string);
};

});

parcelRegister("2jdHI", function(module, exports) {

$parcel$export(module.exports, "default", () => $3243fa342b695d88$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");
function $3243fa342b695d88$export$2e2bcd8739ae039(callback, delay, options) {
    const optionsRef = (0, $eUqFw.useRef)(options);
    // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    const callbackRef = (0, $eUqFw.useRef)((...args)=>{
        callback(...args);
    });
    callbackRef.current = callback;
    const debouncedCallBack = (0, $eUqFw.useMemo)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ()=>(0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((...args)=>callbackRef.current(...args), delay, optionsRef.current), [
        delay
    ]);
    (0, $eUqFw.useEffect)(()=>debouncedCallBack.cancel, [
        debouncedCallBack
    ]);
    return [
        debouncedCallBack,
        debouncedCallBack.cancel
    ];
}

});

parcelRegister("cHKP9", function(module, exports) {
module.exports = new URL("GenericError.8c2b9505.svg", import.meta.url).toString();

});

parcelRegister("3yuWi", function(module, exports) {

$parcel$export(module.exports, "X2C_SCREENS", () => $427b9df34b513c98$export$ff4b3425b39a0344);
$parcel$export(module.exports, "EXPERIENCES", () => $427b9df34b513c98$export$a2008ed3b02411a3);
$parcel$export(module.exports, "uploadInteractionMetric", () => $427b9df34b513c98$export$46ee37d5743a7d4e);
$parcel$export(module.exports, "readCSVInteractionMetric", () => $427b9df34b513c98$export$cdbee521d549e947);
$parcel$export(module.exports, "readCSVMetadataInteractionMetric", () => $427b9df34b513c98$export$914b4ba6c6935398);
$parcel$export(module.exports, "thirdPartyPostAccessTokenMetric", () => $427b9df34b513c98$export$3a82fa6be874db27);
$parcel$export(module.exports, "thirdPartySiteNameMetric", () => $427b9df34b513c98$export$1977cda5be779892);
$parcel$export(module.exports, "thirdPartyAccessTokenStatusMetric", () => $427b9df34b513c98$export$d948b90fd7da0355);
$parcel$export(module.exports, "thirdPartyWorkspacesInteractionMetric", () => $427b9df34b513c98$export$2e77364e67630b4);
$parcel$export(module.exports, "thirdPartyEntitiesInteractionMetric", () => $427b9df34b513c98$export$80dec78db6beb118);
$parcel$export(module.exports, "thirdPartyEntitiesPageInteractionMetric", () => $427b9df34b513c98$export$c971fcb60c959350);
$parcel$export(module.exports, "searchThirdPartyEntitiesInteractionMetric", () => $427b9df34b513c98$export$cd97f15fdd38a039);
$parcel$export(module.exports, "thirdPartyFoldersInteractionMetric", () => $427b9df34b513c98$export$76d4dad73182d098);
$parcel$export(module.exports, "thirdPartyMembersInteractionMetric", () => $427b9df34b513c98$export$974a6e91ec17b2e0);
$parcel$export(module.exports, "thirdPartyEntityStatsInteractionMetric", () => $427b9df34b513c98$export$eeaa1c0981972144);
$parcel$export(module.exports, "thirdPartyMultiEntityStatsInteractionMetric", () => $427b9df34b513c98$export$9c0fc0792d935043);
$parcel$export(module.exports, "thirdPartyFieldConfigInteractionMetric", () => $427b9df34b513c98$export$b3df1d190b73f597);
$parcel$export(module.exports, "thirdPartySpacesInteractionMetric", () => $427b9df34b513c98$export$50f22953e87b219a);
$parcel$export(module.exports, "thirdPartyMultiEntityStatusesInteractionMetric", () => $427b9df34b513c98$export$5f3159a39f7b0e8f);
$parcel$export(module.exports, "validateMappingInteractionMetric", () => $427b9df34b513c98$export$8e26e302ad829899);
$parcel$export(module.exports, "startImportInteractionMetric", () => $427b9df34b513c98$export$53b49f12932c7474);
$parcel$export(module.exports, "startThirdPartyImportInteractionMetric", () => $427b9df34b513c98$export$f0b1197c05950a7e);
$parcel$export(module.exports, "importerSourceInteractionMetric", () => $427b9df34b513c98$export$dcd82b5355e5853c);

var $lNfG4 = parcelRequire("lNfG4");

var $kzTj7 = parcelRequire("kzTj7");
const $427b9df34b513c98$export$ff4b3425b39a0344 = {
    SELECT_PRODUCT: 'projectCreateImporterSelectProduct',
    SELECT_SOURCE_SCREEN: 'projectCreateImporterSelectSource',
    UPLOAD_CSV: 'projectCreateImporterUploadCSV',
    MAPPING: 'projectCreateImporterMapping',
    SETUP_PROJECT: 'projectCreateImporterSetupProject',
    IMPORT_IN_PROGRESS: 'projectCreateImporterImportInProgress',
    SELECT_THIRD_PARTY_ENTITY_SCREEN: 'projectCreateImporterSelectThirdPartyEntity',
    USER_MAPPING: 'projectCreateImporterUserMapping',
    THIRD_PARTY_REVIEW_SCREEN: 'projectCreateImporterThirdPartyReview',
    REVIEW_SCREEN_STANDARD: 'projectCreateImporterReviewScreenStandard'
};
const $427b9df34b513c98$export$a2008ed3b02411a3 = {
    UPLOAD_CSV: 'projectCreateImporterUploadCSV',
    READ_CSV: 'projectCreateImporterReadCSV',
    READ_CSV_METADATA: 'projectCreateImporterReadCSVMetadata',
    THIRD_PARTY_OAUTH: 'projectCreateImporterThirdPartyOAuth',
    THIRD_PARTY_POST_ACCESS_TOKEN: 'projectCreateImporterThirdPartyPostToken',
    THIRD_PARTY_POST_ACCESS_TOKEN_STATUS: 'projectCreateImporterThirdPartyPostTokenStatus',
    THIRD_PARTY_GET_SITE_NAME: 'projectCreateImporterThirdPartyGetSiteName',
    THIRD_PARTY_WORKSPACES: 'projectCreateImporterFetchThirdPartyWorkspaces',
    THIRD_PARTY_ENTITIES: 'projectCreateImporterFetchThirdPartyEntities',
    THIRD_PARTY_ENTITIES_PAGE: 'projectCreateImporterFetchThirdPartyEntitiesPage',
    SEARCH_THIRD_PARTY_ENTITIES: 'projectCreateImporterSearchThirdPartyEntities',
    THIRD_PARTY_FOLDERS: 'projectCreateImporterFetchThirdPartyFolders',
    THIRD_PARTY_FIELD_CONFIG: 'projectCreateImporterFetchThirdPartyFieldConfig',
    THIRD_PARTY_ENTITY_STATS: 'projectCreateImporterFetchThirdPartyEntityStats',
    THIRD_PARTY_MULTI_ENTITY_STATS: 'projectCreateImporterFetchThirdPartyMultiEntityStats',
    THIRD_PARTY_MULTI_ENTITY_STATUSES: 'projectCreateImporterFetchThirdPartyMultiEntityStatuses',
    THIRD_PARTY_MEMBERS: 'projectCreateImporterFetchThirdPartyMembers',
    VALIDATE: 'projectCreateImporterValidateMapping',
    START_IMPORT: 'projectCreateImporterStartImport',
    START_THIRD_PARTY_IMPORT: 'projectCreateImporterStartThirdPartyImport',
    IMPORT_PART_1: 'projectCreateImporterImportPart1',
    THIRD_PARTY_SPACES: 'projectCreateImporterFetchThirdPartySpaces',
    IMPORTER_SOURCE: 'projectCreateImporterImporterSource'
};
const $427b9df34b513c98$var$UPLOAD_CSV_INTERACTION_METRIC_KEY = `${(0, $kzTj7.APP_IDENTIFIER)}.upload-csv`;
const $427b9df34b513c98$export$46ee37d5743a7d4e = (0, $lNfG4.metrics).interaction({
    key: $427b9df34b513c98$var$UPLOAD_CSV_INTERACTION_METRIC_KEY,
    histogram: {
        result: '200_500_1000_2000_3000_4000_5000_10000',
        response: '200_500_1000_2000_3000_4000_5000_10000'
    }
});
const $427b9df34b513c98$var$READ_CSV_INTERACTION_METRIC_KEY = `${(0, $kzTj7.APP_IDENTIFIER)}.read-csv`;
const $427b9df34b513c98$export$cdbee521d549e947 = (0, $lNfG4.metrics).interaction({
    key: $427b9df34b513c98$var$READ_CSV_INTERACTION_METRIC_KEY,
    histogram: {
        result: '200_500_1000_2000_3000_4000_5000_10000',
        response: '200_500_1000_2000_3000_4000_5000_10000'
    }
});
const $427b9df34b513c98$var$READ_CSV_METADATA_INTERACTION_METRIC_KEY = `${(0, $kzTj7.APP_IDENTIFIER)}.read-csv-metadata`;
const $427b9df34b513c98$export$914b4ba6c6935398 = (0, $lNfG4.metrics).interaction({
    key: $427b9df34b513c98$var$READ_CSV_METADATA_INTERACTION_METRIC_KEY,
    histogram: {
        result: '200_500_1000_2000_3000_4000_5000_10000',
        response: '200_500_1000_2000_3000_4000_5000_10000'
    }
});
const $427b9df34b513c98$var$THIRD_PARTY_POST_ACCESS_TOKEN_METRIC_KEY = `${(0, $kzTj7.APP_IDENTIFIER)}.third-party-post-access-token`;
const $427b9df34b513c98$export$3a82fa6be874db27 = (0, $lNfG4.metrics).interaction({
    key: $427b9df34b513c98$var$THIRD_PARTY_POST_ACCESS_TOKEN_METRIC_KEY,
    histogram: {
        result: '200_500_1000_2000_3000_4000_5000_10000',
        response: '200_500_1000_2000_3000_4000_5000_10000'
    }
});
const $427b9df34b513c98$var$THIRD_PARTY_GET_SITE_NAME_METRIC_KEY = `${(0, $kzTj7.APP_IDENTIFIER)}.third-party-site-name`;
const $427b9df34b513c98$export$1977cda5be779892 = (0, $lNfG4.metrics).interaction({
    key: $427b9df34b513c98$var$THIRD_PARTY_GET_SITE_NAME_METRIC_KEY,
    histogram: {
        result: '200_500_1000_2000_3000_4000_5000_10000',
        response: '200_500_1000_2000_3000_4000_5000_10000'
    }
});
const $427b9df34b513c98$var$THIRD_PARTY_ACCESS_TOKEN_STATUS_METRIC_KEY = `${(0, $kzTj7.APP_IDENTIFIER)}.third-party-access-token-status`;
const $427b9df34b513c98$export$d948b90fd7da0355 = (0, $lNfG4.metrics).interaction({
    key: $427b9df34b513c98$var$THIRD_PARTY_ACCESS_TOKEN_STATUS_METRIC_KEY,
    histogram: {
        result: '200_500_1000_2000_3000_4000_5000_10000',
        response: '200_500_1000_2000_3000_4000_5000_10000'
    }
});
const $427b9df34b513c98$var$THIRD_PARTY_WORKSPACES_INTERACTION_METRIC_KEY = `${(0, $kzTj7.APP_IDENTIFIER)}.third-party-workspaces`;
const $427b9df34b513c98$export$2e77364e67630b4 = (0, $lNfG4.metrics).interaction({
    key: $427b9df34b513c98$var$THIRD_PARTY_WORKSPACES_INTERACTION_METRIC_KEY,
    histogram: {
        result: '200_500_1000_2000_3000_4000_5000_10000',
        response: '200_500_1000_2000_3000_4000_5000_10000'
    }
});
const $427b9df34b513c98$var$THIRD_PARTY_ENTITIES_INTERACTION_METRIC_KEY = `${(0, $kzTj7.APP_IDENTIFIER)}.third-party-entities`;
const $427b9df34b513c98$export$80dec78db6beb118 = (0, $lNfG4.metrics).interaction({
    key: $427b9df34b513c98$var$THIRD_PARTY_ENTITIES_INTERACTION_METRIC_KEY,
    histogram: {
        result: '200_500_1000_2000_3000_4000_5000_10000',
        response: '200_500_1000_2000_3000_4000_5000_10000'
    }
});
const $427b9df34b513c98$var$THIRD_PARTY_ENTITIES_PAGE_INTERACTION_METRIC_KEY = `${(0, $kzTj7.APP_IDENTIFIER)}.third-party-entities-page`;
const $427b9df34b513c98$export$c971fcb60c959350 = (0, $lNfG4.metrics).interaction({
    key: $427b9df34b513c98$var$THIRD_PARTY_ENTITIES_PAGE_INTERACTION_METRIC_KEY,
    histogram: {
        result: '200_500_1000_2000_3000_4000_5000_10000',
        response: '200_500_1000_2000_3000_4000_5000_10000'
    }
});
const $427b9df34b513c98$var$SEARCH_THIRD_PARTY_ENTITIES_INTERACTION_METRIC_KEY = `${(0, $kzTj7.APP_IDENTIFIER)}.search-third-party-entities`;
const $427b9df34b513c98$export$cd97f15fdd38a039 = (0, $lNfG4.metrics).interaction({
    key: $427b9df34b513c98$var$SEARCH_THIRD_PARTY_ENTITIES_INTERACTION_METRIC_KEY,
    histogram: {
        result: '200_500_1000_2000_3000_4000_5000_10000',
        response: '200_500_1000_2000_3000_4000_5000_10000'
    }
});
const $427b9df34b513c98$var$THIRD_PARTY_FOLDERS_INTERACTION_METRIC_KEY = `${(0, $kzTj7.APP_IDENTIFIER)}.third-party-folders`;
const $427b9df34b513c98$export$76d4dad73182d098 = (0, $lNfG4.metrics).interaction({
    key: $427b9df34b513c98$var$THIRD_PARTY_FOLDERS_INTERACTION_METRIC_KEY,
    histogram: {
        result: '200_500_1000_2000_3000_4000_5000_10000',
        response: '200_500_1000_2000_3000_4000_5000_10000'
    }
});
const $427b9df34b513c98$var$THIRD_PARTY_MEMBERS_INTERACTION_METRIC_KEY = `${(0, $kzTj7.APP_IDENTIFIER)}.third-party-members`;
const $427b9df34b513c98$export$974a6e91ec17b2e0 = (0, $lNfG4.metrics).interaction({
    key: $427b9df34b513c98$var$THIRD_PARTY_MEMBERS_INTERACTION_METRIC_KEY,
    histogram: {
        result: '200_500_1000_2000_3000_4000_5000_10000',
        response: '200_500_1000_2000_3000_4000_5000_10000'
    }
});
const $427b9df34b513c98$var$THIRD_PARTY_ENTITY_STATS_INTERACTION_METRIC_KEY = `${(0, $kzTj7.APP_IDENTIFIER)}.third-party-entity-stats`;
const $427b9df34b513c98$export$eeaa1c0981972144 = (0, $lNfG4.metrics).interaction({
    key: $427b9df34b513c98$var$THIRD_PARTY_ENTITY_STATS_INTERACTION_METRIC_KEY,
    histogram: {
        result: '200_500_1000_2000_3000_4000_5000_10000',
        response: '200_500_1000_2000_3000_4000_5000_10000'
    }
});
const $427b9df34b513c98$var$THIRD_PARTY_MULTI_ENTITY_STATS_INTERACTION_METRIC_KEY = `${(0, $kzTj7.APP_IDENTIFIER)}.third-party-multi-entity-stats`;
const $427b9df34b513c98$export$9c0fc0792d935043 = (0, $lNfG4.metrics).interaction({
    key: $427b9df34b513c98$var$THIRD_PARTY_MULTI_ENTITY_STATS_INTERACTION_METRIC_KEY,
    histogram: {
        result: '200_500_1000_2000_3000_4000_5000_10000',
        response: '200_500_1000_2000_3000_4000_5000_10000'
    }
});
const $427b9df34b513c98$var$THIRD_PARTY_FIELD_CONFIG_INTERACTION_METRIC_KEY = `${(0, $kzTj7.APP_IDENTIFIER)}.third-party-field-config`;
const $427b9df34b513c98$export$b3df1d190b73f597 = (0, $lNfG4.metrics).interaction({
    key: $427b9df34b513c98$var$THIRD_PARTY_FIELD_CONFIG_INTERACTION_METRIC_KEY,
    histogram: {
        result: '200_500_1000_2000_3000_4000_5000_10000',
        response: '200_500_1000_2000_3000_4000_5000_10000'
    }
});
const $427b9df34b513c98$var$THIRD_PARTY_SPACES_INTERACTION_METRIC_KEY = `${(0, $kzTj7.APP_IDENTIFIER)}.third-party-spaces`;
const $427b9df34b513c98$export$50f22953e87b219a = (0, $lNfG4.metrics).interaction({
    key: $427b9df34b513c98$var$THIRD_PARTY_SPACES_INTERACTION_METRIC_KEY,
    histogram: {
        result: '200_500_1000_2000_3000_4000_5000_10000',
        response: '200_500_1000_2000_3000_4000_5000_10000'
    }
});
const $427b9df34b513c98$var$THIRD_PARTY_MULTI_ENTITY_STATUSES_INTERACTION_METRIC_KEY = `${(0, $kzTj7.APP_IDENTIFIER)}.third-party-multi-entity-statuses`;
const $427b9df34b513c98$export$5f3159a39f7b0e8f = (0, $lNfG4.metrics).interaction({
    key: $427b9df34b513c98$var$THIRD_PARTY_MULTI_ENTITY_STATUSES_INTERACTION_METRIC_KEY,
    histogram: {
        result: '200_500_1000_2000_3000_4000_5000_10000',
        response: '200_500_1000_2000_3000_4000_5000_10000'
    }
});
const $427b9df34b513c98$var$VALIDATE_MAPPING_INTERACTION_METRIC_KEY = `${(0, $kzTj7.APP_IDENTIFIER)}.validate-mapping`;
const $427b9df34b513c98$export$8e26e302ad829899 = (0, $lNfG4.metrics).interaction({
    key: $427b9df34b513c98$var$VALIDATE_MAPPING_INTERACTION_METRIC_KEY,
    histogram: {
        result: '200_500_1000_2000_3000_4000_5000_10000',
        response: '200_500_1000_2000_3000_4000_5000_10000'
    }
});
const $427b9df34b513c98$var$START_IMPORT_INTERACTION_METRIC_KEY = `${(0, $kzTj7.APP_IDENTIFIER)}.start-import`;
const $427b9df34b513c98$export$53b49f12932c7474 = (0, $lNfG4.metrics).interaction({
    key: $427b9df34b513c98$var$START_IMPORT_INTERACTION_METRIC_KEY,
    histogram: {
        result: '200_500_1000_2000_3000_4000_5000_10000',
        response: '200_500_1000_2000_3000_4000_5000_10000'
    }
});
const $427b9df34b513c98$var$START_THIRD_PARTY_IMPORT_INTERACTION_METRIC_KEY = `${(0, $kzTj7.APP_IDENTIFIER)}.third-party-start-import`;
const $427b9df34b513c98$export$f0b1197c05950a7e = (0, $lNfG4.metrics).interaction({
    key: $427b9df34b513c98$var$START_THIRD_PARTY_IMPORT_INTERACTION_METRIC_KEY,
    histogram: {
        result: '200_500_1000_2000_3000_4000_5000_10000',
        response: '200_500_1000_2000_3000_4000_5000_10000'
    }
});
const $427b9df34b513c98$var$IMPORTER_SOURCE_INTERACTION_METRIC_KEY = `${(0, $kzTj7.APP_IDENTIFIER)}.importer-source`;
const $427b9df34b513c98$export$dcd82b5355e5853c = (0, $lNfG4.metrics).interaction({
    key: $427b9df34b513c98$var$IMPORTER_SOURCE_INTERACTION_METRIC_KEY,
    histogram: {
        result: '200_500_1000_2000_3000_4000_5000_10000',
        response: '200_500_1000_2000_3000_4000_5000_10000'
    }
});

});

parcelRegister("4nt6G", function(module, exports) {

$parcel$export(module.exports, "ErrorScreen", () => $5f796ac8e4414dfe$export$42f84e610f279c31);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4lTFP = parcelRequire("4lTFP");

var $5JgJ2 = parcelRequire("5JgJ2");

var $042jE = parcelRequire("042jE");
const $5f796ac8e4414dfe$export$42f84e610f279c31 = ({ onClick: onClick, illustration: illustration, header: header, description: description, buttonMessage: buttonMessage, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $5f796ac8e4414dfe$var$errorStyles,
        testId: testId
    }, illustration && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5f796ac8e4414dfe$var$Illustration, {
        src: illustration,
        "aria-describedby": "error-icon",
        role: "img",
        alt: ""
    }), header && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $5f796ac8e4414dfe$var$headingStyles
    }, header), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $5f796ac8e4414dfe$var$descriptionStyles
    }, description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "primary",
        onClick: onClick
    }, buttonMessage || formatMessage((0, $042jE.default).refresh))));
};
const $5f796ac8e4414dfe$var$errorStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    flexDirection: 'column',
    justifyContent: 'center'
});
const $5f796ac8e4414dfe$var$headingStyles = (0, $1ZAYh.xcss)({
    font: "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    marginTop: 'space.400',
    marginBottom: 'space.100'
});
const $5f796ac8e4414dfe$var$descriptionStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.subtle',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    font: `var(--ds-font-body, ${(0, $4lTFP.fontFallback).body.medium})`,
    paddingBottom: 'space.200'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $5f796ac8e4414dfe$var$Illustration = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1lit _1bsb1ssb _4t3i1ssb _19pk1epz",
            __cmplp.className
        ])
    });
});

});
parcelRegister("042jE", function(module, exports) {

$parcel$export(module.exports, "default", () => $13c81c361a4521a1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $13c81c361a4521a1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    refresh: {
        "id": "project-create-importer-upload-flow.common.error-screen.refresh",
        "defaultMessage": "Refresh"
    }
});

});


parcelRegister("elKPF", function(module, exports) {

$parcel$export(module.exports, "StepFooter", () => $5e8292b173afc48f$export$c04f2700655605a4);
$parcel$export(module.exports, "StepFooterStandard", () => $5e8292b173afc48f$export$e4af5a79e928779e);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");
var $7opLA = parcelRequire("7opLA");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $czNUl = parcelRequire("czNUl");

var $guPSs = parcelRequire("guPSs");
const $5e8292b173afc48f$export$c04f2700655605a4 = ({ onReturn: onReturn, shouldStartImportOnNext: shouldStartImportOnNext = false, isLoading: isLoading = false, shouldDisableNext: shouldDisableNext = false, shouldDisableReturn: shouldDisableReturn = false, nextButtonType: nextButtonType = 'button', onClickNext: onClickNext, shouldRenderNextButton: shouldRenderNextButton = true, hasImportErrorOccurred: hasImportErrorOccurred = false, backButtonMessage: backButtonMessage = (0, $guPSs.default).back, alignRight: alignRight = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, hasImportErrorOccurred && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $czNUl.ImportErrorMessage), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        gap: "space.100",
        justifyContent: alignRight ? 'end' : 'start'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: onReturn,
        isDisabled: shouldDisableReturn,
        testId: "project-create-importer-upload-flow.common.ui.step-footer.back-button"
    }, formatMessage(backButtonMessage)), shouldRenderNextButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        testId: "project-create-importer-upload-flow.common.ui.step-footer.next-button",
        type: nextButtonType,
        onClick: onClickNext,
        appearance: "primary",
        isLoading: isLoading,
        isDisabled: shouldDisableNext
    }, shouldStartImportOnNext ? formatMessage((0, $guPSs.default).import) : formatMessage((0, $guPSs.default).next))));
};
const $5e8292b173afc48f$export$e4af5a79e928779e = ({ isFixedPosition: isFixedPosition = true, hasImportErrorOccurred: hasImportErrorOccurred, ...otherProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, hasImportErrorOccurred && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $czNUl.ImportErrorMessage), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $5e8292b173afc48f$var$wrapperStyles,
            ...isFixedPosition ? [
                $5e8292b173afc48f$var$wrapperWithFixedPosition
            ] : []
        ],
        testId: "project-create-importer-upload-flow.common.ui.step-footer.wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $5e8292b173afc48f$var$buttonsWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5e8292b173afc48f$export$c04f2700655605a4, otherProps))));
const $5e8292b173afc48f$var$wrapperStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center',
    height: '64px',
    width: '100%',
    borderTopWidth: 'space.025',
    borderTopColor: 'color.border',
    borderTopStyle: 'solid',
    backgroundColor: 'color.background.input'
});
const $5e8292b173afc48f$var$wrapperWithFixedPosition = (0, $1ZAYh.xcss)({
    position: 'fixed',
    bottom: 'space.0',
    left: 'space.0'
});
const $5e8292b173afc48f$var$buttonsWrapper = (0, $1ZAYh.xcss)({
    width: '80%',
    maxWidth: '1008px',
    margin: 'auto'
});

});
parcelRegister("czNUl", function(module, exports) {

$parcel$export(module.exports, "ImportErrorMessage", () => $499006d6a3861cb9$export$136865290cc6ebe8);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lRvnl = parcelRequire("lRvnl");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bnPGY = parcelRequire("bnPGY");
const $499006d6a3861cb9$export$136865290cc6ebe8 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($499006d6a3861cb9$var$Wrapper, {
        "data-testid": "project-create-importer-upload-flow.common.ui.import-error-message.wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        title: formatMessage((0, $bnPGY.default).errorHeader),
        appearance: "warning"
    }, formatMessage((0, $bnPGY.default).errorDescription)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $499006d6a3861cb9$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pku2gc _otyr1ejb _1bsb1osq _p12fufrr",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bnPGY", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4ba298654841957$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e4ba298654841957$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorHeader: {
        "id": "project-create-importer-upload-flow.common.import-error-message.error-header",
        "defaultMessage": "We couldn\u2019t begin the import"
    },
    errorDescription: {
        "id": "project-create-importer-upload-flow.common.import-error-message.error-description",
        "defaultMessage": "Select Import to try again."
    }
});

});


parcelRegister("guPSs", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb89fb73597b6ab3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $fb89fb73597b6ab3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    back: {
        "id": "project-create-importer-upload-flow.common.step-footer.back",
        "defaultMessage": "Back"
    },
    next: {
        "id": "project-create-importer-upload-flow.common.step-footer.next",
        "defaultMessage": "Next"
    },
    import: {
        "id": "project-create-importer-upload-flow.common.step-footer.import",
        "defaultMessage": "Import"
    }
});

});


parcelRegister("1T7vu", function(module, exports) {

$parcel$export(module.exports, "StepProgressBar", () => $7dceba2c6d4279c4$export$f0d1dd259b719f04);
$parcel$export(module.exports, "ProgressBarStandard", () => $7dceba2c6d4279c4$export$35dfba31409199aa);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5bkby = parcelRequire("5bkby");

var $kjXsi = parcelRequire("kjXsi");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3EVB9 = parcelRequire("3EVB9");

var $fZVQQ = parcelRequire("fZVQQ");
const $7dceba2c6d4279c4$export$f0d1dd259b719f04 = ({ productSteps: productSteps, currentStepIndex: currentStepIndex })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const getPercentageComplete = (0, $eUqFw.useCallback)((index, currStepIndex)=>index < currStepIndex ? 100 : 0, []);
    const getStatus = (0, $eUqFw.useCallback)((index, currStepIndex)=>{
        if (index < currStepIndex) return 'visited';
        if (index === currStepIndex) return 'current';
        return 'unvisited';
    }, []);
    const items = (0, $eUqFw.useMemo)(()=>(0, $eI5EY.fg)('enable-x2c-standardised-flow') ? productSteps.filter((step)=>step.progressBarStepLabel).map(({ step: configStep, progressBarStepLabel: progressBarStepLabel }, index)=>({
                id: configStep,
                label: progressBarStepLabel ? formatMessage(progressBarStepLabel) : '',
                percentageComplete: getPercentageComplete(index, currentStepIndex),
                status: getStatus(index, currentStepIndex),
                noLink: true
            })) : productSteps.map(({ step: configStep, progressBarStepLabel: progressBarStepLabel }, index)=>({
                id: configStep,
                label: progressBarStepLabel ? formatMessage(progressBarStepLabel) : '',
                percentageComplete: getPercentageComplete(index, currentStepIndex),
                status: getStatus(index, currentStepIndex),
                noLink: true
            })), [
        currentStepIndex,
        formatMessage,
        getPercentageComplete,
        getStatus,
        productSteps
    ]);
    if (!productSteps || currentStepIndex < 0) return null;
    let currentStepLabel = productSteps[currentStepIndex].progressBarStepLabel ? // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    formatMessage(productSteps[currentStepIndex].progressBarStepLabel) : '';
    if ((0, $eI5EY.fg)('enable-x2c-standardised-flow')) currentStepLabel = items[currentStepIndex].label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kjXsi.ScreenReaderText), null, formatMessage((0, $fZVQQ.default).screenReaderText, {
        currentStepIndex: currentStepIndex + 1,
        numSteps: productSteps.length,
        currentStepLabel: currentStepLabel
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5bkby.default), {
        items: items,
        animated: false,
        testId: "project-create-importer-upload-flow.common.ui.step-progress-bar.progress-tracker"
    }));
};
const $7dceba2c6d4279c4$export$35dfba31409199aa = ({ onClose: onClose, showCrossButton: showCrossButton = true, shouldShowCancelModal: shouldShowCancelModal = true, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $7dceba2c6d4279c4$var$wrapperStyles,
        testId: "project-create-importer-upload-flow.common.ui.step-progress-bar.standard"
    }, showCrossButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $7dceba2c6d4279c4$var$crossStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3EVB9.CloseAndReturnButton), {
        iconOnly: true,
        iconSize: "medium",
        onCloseAndReturnToUploadStep: onClose,
        shouldShowCancelModal: shouldShowCancelModal
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7dceba2c6d4279c4$export$f0d1dd259b719f04, props));
const $7dceba2c6d4279c4$var$wrapperStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    position: 'fixed',
    height: '120px',
    width: '100%',
    top: 'space.0',
    left: 'space.0',
    borderBottomStyle: 'solid',
    borderBottomWidth: 'space.025',
    borderBottomColor: 'color.border',
    backgroundColor: 'color.background.input',
    zIndex: 'navigation'
});
const $7dceba2c6d4279c4$var$crossStyles = (0, $1ZAYh.xcss)({
    position: 'fixed',
    top: 'space.0',
    left: 'space.0',
    paddingInline: 'space.300',
    paddingBlock: 'space.400'
});

});
parcelRegister("5bkby", function(module, exports) {

$parcel$export(module.exports, "default", () => $a41d363626e67585$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/no-nested-styles */ /**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $aHw5m = parcelRequire("aHw5m");


var $3huBA = parcelRequire("3huBA");

var $2Ir6q = parcelRequire("2Ir6q");
const $a41d363626e67585$var$containerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'grid',
    width: '100%',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    margin: '0 auto',
    padding: "var(--ds-space-0, 0px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gap: `var(${(0, $459410c1277bcfa8$export$8b95aa1f3c260313)})`,
    listStyleType: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        marginBlockStart: "var(--ds-space-500, 40px)"
    }
});
class $a41d363626e67585$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            items: [],
            spacing: 'cosy',
            render: {
                // Anchor content is coming from another location
                // eslint-disable-next-line jsx-a11y/anchor-has-content
                link: ({ item: item })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $3huBA.default), item)
            },
            animated: true,
            label: 'Progress'
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const prevStages = nextProps.items.map((stage)=>{
            const oldStage = this.props.items.find((st)=>st.id === stage.id);
            return oldStage !== undefined ? oldStage : stage;
        });
        this.setState({
            prevStages: prevStages
        });
    }
    render() {
        const { testId: testId, label: label } = this.props;
        const progressChanges = this.props.items.filter((stage, index)=>stage.percentageComplete !== this.state.prevStages[index].percentageComplete).length;
        const totalStepsForward = this.props.items.filter((stage, index)=>stage.percentageComplete > this.state.prevStages[index].percentageComplete).length;
        const totalStepsBack = this.props.items.filter((stage, index)=>stage.percentageComplete < this.state.prevStages[index].percentageComplete).length;
        let stepsForward = totalStepsForward;
        let stepsBack = totalStepsBack;
        const items = this.props.items.map((stage, index)=>{
            let transitionSpeed = 0;
            let transitionDelay = 0;
            const transitionEasing = progressChanges > 1 ? 'linear' : (0, $459410c1277bcfa8$export$9f1588e1da4caa2b);
            if (this.props.animated) {
                transitionSpeed = progressChanges > 1 ? (0, $459410c1277bcfa8$export$8ea7300306607b63) : (0, $459410c1277bcfa8$export$33083dc7635d0dd8);
                if (stage.percentageComplete < this.state.prevStages[index].percentageComplete) {
                    /**
           * Load each transition sequentially in reverse.
           */ transitionDelay = (stepsBack - 1) * transitionSpeed;
                    stepsBack -= 1;
                } else if (stage.percentageComplete > this.state.prevStages[index].percentageComplete) {
                    /**
           * Load each transition sequentially.
           */ transitionDelay = (totalStepsForward - stepsForward) * transitionSpeed;
                    stepsForward -= 1;
                }
            }
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $2Ir6q.default), {
                transitionSpeed: transitionSpeed,
                transitionDelay: transitionDelay,
                transitionEasing: transitionEasing,
                key: stage.id,
                item: stage,
                render: this.props.render
            });
        });
        const listInlineStyles = {
            gridTemplateColumns: `repeat(${items.length}, 1fr)`,
            [(0, $459410c1277bcfa8$export$8b95aa1f3c260313)]: (0, $aHw5m.spacing)[this.props.spacing],
            maxWidth: 80 * items.length * 2
        };
        return /*#__PURE__*/ (0, $byn9U.jsx)("ul", {
            "data-testid": testId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: listInlineStyles,
            css: $a41d363626e67585$var$containerStyles,
            "aria-label": label
        }, items);
    }
    constructor(...args){
        super(...args);
        this.state = {
            prevStages: this.props.items.map((stage)=>({
                    ...stage,
                    percentageComplete: 0
                }))
        };
    }
}

});
parcelRegister("aHw5m", function(module, exports) {

$parcel$export(module.exports, "spacing", () => $8a75d642c52fc45a$export$5458b64234d1333c);
/**
 * Ideally these are exported by @atlaskit/page
 */ const $8a75d642c52fc45a$export$5458b64234d1333c = {
    comfortable: "var(--ds-space-500, 40px)",
    cosy: "var(--ds-space-200, 16px)",
    compact: "var(--ds-space-050, 4px)"
};

});

const $459410c1277bcfa8$export$33083dc7635d0dd8 = 300;
const $459410c1277bcfa8$export$8ea7300306607b63 = 50;
const $459410c1277bcfa8$export$9f1588e1da4caa2b = 'cubic-bezier(0.15,1,0.3,1)';
const $459410c1277bcfa8$export$8b95aa1f3c260313 = '--ds--pt--sp';
const $459410c1277bcfa8$export$ec2ea4802ae8f59e = '--ds--pt--ts';
const $459410c1277bcfa8$export$93afff06fa2d80d6 = '--ds--pt--td';
const $459410c1277bcfa8$export$dcd1050c05546fdc = '--ds--pt--te';
const $459410c1277bcfa8$export$cbcf706d596883 = '--ds--pt--mc';
const $459410c1277bcfa8$export$7306fb930f0ec2b = '--ds--pt--bg';
const $459410c1277bcfa8$export$49679f81f603a5da = "var(--ds-space-050, 4px)";
const $459410c1277bcfa8$export$cc6cd6bda2304549 = "var(--ds-space-100, 8px)";
const $459410c1277bcfa8$export$34481ab614337bec = "var(--ds-space-250, 20px)";

parcelRegister("3huBA", function(module, exports) {

$parcel$export(module.exports, "default", () => $400cb3ef3bc655b0$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
const $400cb3ef3bc655b0$var$linkStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text, ${(0, $PdmhA.N800)})`,
    cursor: 'pointer'
});
/**
 * __Progress tracker link__
 */ const $400cb3ef3bc655b0$var$Link = ({ href: href, onClick: onClick, label: label, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("a", {
        css: $400cb3ef3bc655b0$var$linkStyles,
        href: href,
        onClick: onClick,
        "data-testid": testId
    }, label);
var $400cb3ef3bc655b0$export$2e2bcd8739ae039 = $400cb3ef3bc655b0$var$Link;

});

parcelRegister("2Ir6q", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c101ea3289c1902$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/no-nested-styles */ /**
                                                               * @jsxRuntime classic
                                                               */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $l5PRC = parcelRequire("l5PRC");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $f3aQK = parcelRequire("f3aQK");


var $ltcpW = parcelRequire("ltcpW");

var $f9ozW = parcelRequire("f9ozW");
function $4c101ea3289c1902$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4c101ea3289c1902$var$listItemContentStyles = (0, $1ZAYh.xcss)({
    width: '100%',
    position: 'relative'
});
const $4c101ea3289c1902$var$listItemStyles = {
    name: "bgyufd",
    styles: "margin:var(--ds-space-0, 0px);overflow-wrap:break-word"
};
const $4c101ea3289c1902$var$titleStyles = /*#__PURE__*/ (0, $byn9U.css)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginBlockStart: (0, $459410c1277bcfa8$export$34481ab614337bec),
    textAlign: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.fade-appear': {
        opacity: 0.01
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.fade-appear.fade-appear-active': {
        opacity: 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transition: `opacity var(${(0, $459410c1277bcfa8$export$ec2ea4802ae8f59e)}) cubic-bezier(0.2, 0, 0, 1)`
    }
});
class $4c101ea3289c1902$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    constructor(props){
        super(props);
        this.onEntered = ()=>{
            this.setState({
                transitioning: false,
                oldMarkerColor: (0, $f9ozW.getMarkerColor)(this.props.item.status),
                oldPercentageComplete: this.props.item.percentageComplete
            });
        };
        this.state = {
            transitioning: false,
            oldMarkerColor: (0, $f9ozW.getMarkerColor)(this.props.item.status),
            oldPercentageComplete: 0
        };
    }
    UNSAFE_componentWillMount() {
        this.setState({
            ...this.state,
            transitioning: true
        });
    }
    UNSAFE_componentWillReceiveProps() {
        this.setState({
            ...this.state,
            transitioning: true
        });
    }
    shouldShowLink() {
        return this.props.item.status === 'visited' && !this.props.item.noLink;
    }
    render() {
        const { item: item, render: render, transitionDelay: transitionDelay, transitionSpeed: transitionSpeed, transitionEasing: transitionEasing, testId: testId } = this.props;
        const ariaCurrent = item.status === 'current' ? 'step' : 'false';
        const listInlineStyles = {
            [(0, $459410c1277bcfa8$export$ec2ea4802ae8f59e)]: `${transitionSpeed}ms`,
            [(0, $459410c1277bcfa8$export$93afff06fa2d80d6)]: `${transitionDelay}ms`,
            [(0, $459410c1277bcfa8$export$dcd1050c05546fdc)]: transitionEasing,
            [(0, $459410c1277bcfa8$export$cbcf706d596883)]: this.state.oldMarkerColor,
            [(0, $459410c1277bcfa8$export$7306fb930f0ec2b)]: (0, $f9ozW.getMarkerColor)(item.status)
        };
        return /*#__PURE__*/ (0, $byn9U.jsx)("li", {
            "data-testid": testId,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: listInlineStyles,
            css: $4c101ea3289c1902$var$listItemStyles,
            "aria-current": ariaCurrent
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
            xcss: $4c101ea3289c1902$var$listItemContentStyles
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $l5PRC.default), {
            appear: true,
            in: this.state.transitioning,
            onEntered: this.onEntered,
            timeout: transitionDelay + transitionSpeed,
            classNames: "fade"
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $ltcpW.default), {
            testId: testId && `${testId}-marker`
        })), /*#__PURE__*/ (0, $byn9U.jsx)((0, $l5PRC.default), {
            appear: true,
            in: this.state.transitioning,
            onEntered: this.onEntered,
            timeout: transitionDelay + transitionSpeed,
            classNames: "fade"
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $f3aQK.default), {
            testId: testId && `${testId}-bar`,
            percentageComplete: item.percentageComplete
        })), /*#__PURE__*/ (0, $byn9U.jsx)((0, $l5PRC.default), {
            appear: true,
            in: this.state.transitioning,
            onEntered: this.onEntered,
            timeout: transitionDelay + transitionSpeed,
            classNames: "fade"
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $4c101ea3289c1902$var$titleStyles,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                color: (0, $f9ozW.getTextColor)(item.status),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                fontWeight: (0, $f9ozW.getFontWeight)(item.status)
            },
            "data-testid": testId && `${testId}-title`
        }, this.shouldShowLink() ? render.link({
            item: item
        }) : item.label))));
    }
}

});
parcelRegister("f3aQK", function(module, exports) {

$parcel$export(module.exports, "default", () => $75dcac8218611c67$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $aHw5m = parcelRequire("aHw5m");

const $75dcac8218611c67$var$progressBarStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $459410c1277bcfa8$export$cc6cd6bda2304549),
    position: 'absolute',
    backgroundColor: `var(--ds-background-brand-bold, ${(0, $PdmhA.B300)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderEndEndRadius: (0, $459410c1277bcfa8$export$cc6cd6bda2304549),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderStartEndRadius: (0, $459410c1277bcfa8$export$cc6cd6bda2304549),
    insetInlineStart: '50%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transform: `translate(0, calc(-1 * ${(0, $459410c1277bcfa8$export$34481ab614337bec)}))`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `width var(${(0, $459410c1277bcfa8$export$ec2ea4802ae8f59e)}) var(${(0, $459410c1277bcfa8$export$dcd1050c05546fdc)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transitionDelay: `var(${(0, $459410c1277bcfa8$export$93afff06fa2d80d6)})`
});
/**
 * __Progress bar__
 *
 * A progress bar describes the horizontal tracking bar that traverses each individual step.
 *
 */ const $75dcac8218611c67$var$ProgressBar = ({ percentageComplete: percentageComplete, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        style: {
            width: `calc(${percentageComplete}% + ${percentageComplete / 100} * calc(var(${(0, $459410c1277bcfa8$export$8b95aa1f3c260313)}, ${(0, $aHw5m.spacing).cosy}) + ${(0, $459410c1277bcfa8$export$49679f81f603a5da)}))`
        },
        css: $75dcac8218611c67$var$progressBarStyles
    });
var $75dcac8218611c67$export$2e2bcd8739ae039 = $75dcac8218611c67$var$ProgressBar;

});

parcelRegister("ltcpW", function(module, exports) {

$parcel$export(module.exports, "default", () => $01e48a66dff94d99$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/no-nested-styles */ /**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

const $01e48a66dff94d99$var$progressMarkerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: (0, $459410c1277bcfa8$export$cc6cd6bda2304549),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $459410c1277bcfa8$export$cc6cd6bda2304549),
    position: 'absolute',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: `var(${(0, $459410c1277bcfa8$export$7306fb930f0ec2b)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: (0, $459410c1277bcfa8$export$cc6cd6bda2304549),
    insetInlineStart: '50%',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transform: `translate(-50%, calc(-1 * ${(0, $459410c1277bcfa8$export$34481ab614337bec)}))`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transition: `opacity var(${(0, $459410c1277bcfa8$export$ec2ea4802ae8f59e)}) var(${(0, $459410c1277bcfa8$export$dcd1050c05546fdc)}), background-color var(${(0, $459410c1277bcfa8$export$ec2ea4802ae8f59e)}) var(${(0, $459410c1277bcfa8$export$dcd1050c05546fdc)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    transitionDelay: `var(${(0, $459410c1277bcfa8$export$93afff06fa2d80d6)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.fade-appear': {
        opacity: 0.01
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.fade-appear.fade-appear-active': {
        opacity: 1
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.fade-enter': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: `var(${(0, $459410c1277bcfa8$export$cbcf706d596883)})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.fade-enter.fade-enter-active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: `var(${(0, $459410c1277bcfa8$export$7306fb930f0ec2b)})`
    }
});
/**
 * __Progress marker__
 *
 * Similar to `@atlaskit/progress-indicator`, a small visual circle marker
 */ const $01e48a66dff94d99$var$ProgressMarker = ({ testId: testId })=>// too many props that would go in UNSAFE_style + css transition prop having issues
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        css: $01e48a66dff94d99$var$progressMarkerStyles
    });
var $01e48a66dff94d99$export$2e2bcd8739ae039 = $01e48a66dff94d99$var$ProgressMarker;

});

parcelRegister("f9ozW", function(module, exports) {

$parcel$export(module.exports, "getMarkerColor", () => $c915cee6a2d6994c$export$8a6676d8d76e6e1d);
$parcel$export(module.exports, "getTextColor", () => $c915cee6a2d6994c$export$5357fe757c335c0d);
$parcel$export(module.exports, "getFontWeight", () => $c915cee6a2d6994c$export$16eeca46eca75f64);

var $PdmhA = parcelRequire("PdmhA");
const $c915cee6a2d6994c$export$8a6676d8d76e6e1d = (status)=>{
    switch(status){
        case 'unvisited':
            return `var(--ds-icon-subtle, ${0, $PdmhA.N70})`;
        case 'current':
        case 'visited':
        case 'disabled':
            return `var(--ds-icon-brand, ${0, $PdmhA.B300})`;
        default:
            return;
    }
};
const $c915cee6a2d6994c$export$5357fe757c335c0d = (status)=>{
    switch(status){
        case 'unvisited':
            return "var(--ds-text-subtlest, #626F86)";
        case 'current':
            return "var(--ds-text-brand, #0C66E4)";
        case 'visited':
            return "var(--ds-text, #172B4D)";
        case 'disabled':
            return "var(--ds-text-disabled, #091E424F)";
        default:
            return;
    }
};
const $c915cee6a2d6994c$export$16eeca46eca75f64 = (status)=>{
    switch(status){
        case 'unvisited':
            return "var(--ds-font-weight-regular, 400)";
        case 'current':
        case 'visited':
        case 'disabled':
            return "var(--ds-font-weight-semibold, 600)";
        default:
            return undefined;
    }
};

});



parcelRegister("kjXsi", function(module, exports) {

$parcel$export(module.exports, "visuallyHiddenStyles", () => $cfcbcec828cf2e62$export$8dd524ceb40e3d16);
$parcel$export(module.exports, "ScreenReaderText", () => $cfcbcec828cf2e62$export$88fad6aa294f111c);
$parcel$export(module.exports, "ScreenReaderCaption", () => $cfcbcec828cf2e62$export$200c8e5d652aa9af);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $eWeL8 = parcelRequire("eWeL8");

var $1ybV0 = parcelRequire("1ybV0");
const $cfcbcec828cf2e62$export$8dd524ceb40e3d16 = {
    clip: 'rect(1px, 1px, 1px, 1px)',
    clipPath: 'inset(50%)',
    height: '1px',
    width: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute'
};
// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $cfcbcec828cf2e62$var$ScreenReaderTextControl = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1wqp2jw-0"
})($cfcbcec828cf2e62$export$8dd524ceb40e3d16);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $cfcbcec828cf2e62$var$ScreenReaderTextExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ogto7mnp _mkrz1wmp _4t3it94y _1bsbt94y _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw",
            __cmplp.className
        ])
    });
});
const $cfcbcec828cf2e62$export$88fad6aa294f111c = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $cfcbcec828cf2e62$var$ScreenReaderTextExperiment, $cfcbcec828cf2e62$var$ScreenReaderTextControl);
// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $cfcbcec828cf2e62$var$ScreenReaderCaptionControl = /*#__PURE__*/ (0, $kwce8.default).caption.withConfig({
    componentId: "sc-1wqp2jw-1"
})($cfcbcec828cf2e62$export$8dd524ceb40e3d16);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $cfcbcec828cf2e62$var$ScreenReaderCaptionExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "caption", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ogto7mnp _mkrz1wmp _4t3it94y _1bsbt94y _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw",
            __cmplp.className
        ])
    });
});
const $cfcbcec828cf2e62$export$200c8e5d652aa9af = (0, $eWeL8.styledComponentWithCondition)(()=>(0, $1ybV0.ff)('compiled.migration.jsw.tanuki'), $cfcbcec828cf2e62$var$ScreenReaderCaptionExperiment, $cfcbcec828cf2e62$var$ScreenReaderCaptionControl);

});
parcelRegister("eWeL8", function(module, exports) {

$parcel$export(module.exports, "styledComponentWithCondition", () => $e0c5c7e39a960e0c$export$62d8d8fbf238d6af);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");
const $e0c5c7e39a960e0c$export$62d8d8fbf238d6af = (useCompiled, CompiledComponent, StyledComponent)=>// Couldn't destructure like {innerRef, ...rest} as
    // typescript is suspcious on destructing generics
    ({ innerRef: innerRef, ...rest })=>useCompiled() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CompiledComponent, {
            ...rest,
            ref: innerRef
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StyledComponent, {
            ...rest,
            innerRef: innerRef
        });
const $e0c5c7e39a960e0c$export$f5b752428255ba78 = (useCompiled, CompiledComponent, StyledComponent)=>({ innerRef: innerRef, ...rest })=>useCompiled() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(CompiledComponent, {
            ...rest,
            ref: innerRef
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(StyledComponent, {
            ...rest,
            innerRef: innerRef
        });

});


parcelRegister("3EVB9", function(module, exports) {

$parcel$export(module.exports, "CloseAndReturnButton", () => $00b5ef505ec4ec55$export$80520bfa4803c891);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $jWuk1 = parcelRequire("jWuk1");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2sRUp = parcelRequire("2sRUp");

var $fua3W = parcelRequire("fua3W");


var $aWLVm = parcelRequire("aWLVm");

var $3Iwft = parcelRequire("3Iwft");
const $00b5ef505ec4ec55$export$80520bfa4803c891 = ({ onCloseAndReturnToUploadStep: onCloseAndReturnToUploadStep, shouldShowCancelModal: shouldShowCancelModal = true, iconOnly: iconOnly = false, iconSize: iconSize = 'small' })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [, { setCancelImportModalState: setCancelImportModalState }] = (0, $fua3W.useCancelImportModalState)();
    const [source] = (0, $2sRUp.useSource)();
    const onCloseModalCallback = (0, $eUqFw.useCallback)(()=>{
        // Remove this when the new project create integration is implemented
        source === (0, $85ba070c29b4a3bd$export$44f7961a4c8dc451) ? (0, $aWLVm.redirectToProjectTemplatesScreen)() : onCloseAndReturnToUploadStep();
    }, [
        onCloseAndReturnToUploadStep,
        source
    ]);
    const handleOpenCancelImport = (0, $eUqFw.useCallback)(()=>{
        setCancelImportModalState({
            isCancelImportModalOpen: true,
            shouldCloseDrawerOnCancel: false,
            onCloseModalCallback: onCloseModalCallback
        });
    }, [
        onCloseModalCallback,
        setCancelImportModalState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "project-create-importer-upload-flow.common.ui.close-and-return-button.return-button",
        onClick: shouldShowCancelModal ? handleOpenCancelImport : onCloseModalCallback,
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
            label: "",
            size: iconSize
        }),
        "aria-label": (0, $3Iwft.default).closeAndReturn.defaultMessage
    }, source !== (0, $85ba070c29b4a3bd$export$44f7961a4c8dc451) && !iconOnly && formatMessage((0, $3Iwft.default).closeAndReturn));
};

});
parcelRegister("3Iwft", function(module, exports) {

$parcel$export(module.exports, "default", () => $addfd49f527c06b1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $addfd49f527c06b1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    closeAndReturn: {
        "id": "project-create-importer-upload-flow.common.close-and-return-button.close-and-return",
        "defaultMessage": "Close and return to import from apps"
    }
});

});


parcelRegister("fZVQQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cd0a5a251085484$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2cd0a5a251085484$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    screenReaderText: {
        "id": "project-create-importer-upload-flow.common.step-progress-bar.screen-reader-text",
        "defaultMessage": "Step {currentStepIndex} of {numSteps} {currentStepLabel}"
    }
});

});


parcelRegister("7cdKR", function(module, exports) {

$parcel$export(module.exports, "StepScreen", () => $56dd56f6dea85ac8$export$9d8cbfda2f320635);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $56dd56f6dea85ac8$export$9d8cbfda2f320635 = ({ renderProgressBar: renderProgressBar, header: header, description: description, children: children, renderFooter: renderFooter, testId: testId, maxWidth: maxWidth })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $56dd56f6dea85ac8$var$wrapperStyles,
        testId: testId
    }, renderProgressBar && renderProgressBar, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        padding: "space.400",
        xcss: [
            $56dd56f6dea85ac8$var$contentWrapperStyles,
            ...renderProgressBar ? [
                $56dd56f6dea85ac8$var$wrapperWithProgressBar
            ] : [],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            ...maxWidth ? [
                (0, $1ZAYh.xcss)({
                    maxWidth: maxWidth
                })
            ] : []
        ]
    }, header && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $56dd56f6dea85ac8$var$headerStyles
    }, header), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $56dd56f6dea85ac8$var$descriptionStyles
    }, description), children), renderFooter && renderFooter);
const $56dd56f6dea85ac8$var$wrapperStyles = (0, $1ZAYh.xcss)({
    width: '100%',
    backgroundColor: 'color.background.input',
    overflowY: 'auto'
});
const $56dd56f6dea85ac8$var$contentWrapperStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '1008px',
    margin: 'auto',
    minWidth: '375px'
});
const $56dd56f6dea85ac8$var$wrapperWithProgressBar = (0, $1ZAYh.xcss)({
    position: 'relative',
    top: '120px',
    paddingBottom: 'space.1000'
});
const $56dd56f6dea85ac8$var$headerStyles = (0, $1ZAYh.xcss)({
    color: 'color.text',
    font: "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    paddingBottom: 'space.100'
});
const $56dd56f6dea85ac8$var$descriptionStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.subtle',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    paddingBottom: 'space.200'
});

});

parcelRegister("bLalW", function(module, exports) {

$parcel$export(module.exports, "useAdvancedOptions", () => $8da63011d8c6c044$export$b7674cb522e54a66);

var $ggKAj = parcelRequire("ggKAj");
var $bj4JM = parcelRequire("bj4JM");

var $8JicK = parcelRequire("8JicK");
const $8da63011d8c6c044$export$ba597b9d5fb5a5e0 = (0, $bj4JM.createSelector)((state)=>state.advancedOptions, (newState)=>newState);
const $8da63011d8c6c044$export$b7674cb522e54a66 = (0, $ggKAj.createHook)((0, $8JicK.Store), {
    selector: $8da63011d8c6c044$export$ba597b9d5fb5a5e0
});

});

parcelRegister("lUC5l", function(module, exports) {

$parcel$export(module.exports, "useMappingState", () => $5d736735ed3620ce$export$3cae29b31f1ff284);
$parcel$export(module.exports, "useColumnsVisibleState", () => $5d736735ed3620ce$export$ea983b62c63e5cb);
$parcel$export(module.exports, "useNumVisibleUnmappedColumns", () => $5d736735ed3620ce$export$a041138dfab3564d);
$parcel$export(module.exports, "useNumUnmappedColumnsIncluded", () => $5d736735ed3620ce$export$bf645bc7445be745);

var $ggKAj = parcelRequire("ggKAj");
var $bj4JM = parcelRequire("bj4JM");

var $8JicK = parcelRequire("8JicK");
const $5d736735ed3620ce$var$mappingSelector = (state)=>state.mappingState;
const $5d736735ed3620ce$export$332e9bf153421587 = (0, $bj4JM.createSelector)($5d736735ed3620ce$var$mappingSelector, (newState)=>newState);
const $5d736735ed3620ce$export$3cae29b31f1ff284 = (0, $ggKAj.createHook)((0, $8JicK.Store), {
    selector: $5d736735ed3620ce$export$332e9bf153421587
});
const $5d736735ed3620ce$export$45e89e8615dd97d6 = (0, $bj4JM.createSelector)($5d736735ed3620ce$var$mappingSelector, (mappingState)=>{
    if (mappingState === null) return {
        numColumnsVisible: 0,
        numColumnsHidden: 0,
        areAllColumnsVisible: true
    };
    const numColumnsVisible = mappingState.columnOrder.filter((colName)=>mappingState.columns[colName].isVisible).length;
    const areAllColumnsVisible = mappingState.columnOrder.length === numColumnsVisible;
    const numColumnsHidden = mappingState.columnOrder.length - numColumnsVisible;
    return {
        numColumnsVisible: numColumnsVisible,
        numColumnsHidden: numColumnsHidden,
        areAllColumnsVisible: areAllColumnsVisible
    };
});
const $5d736735ed3620ce$export$ea983b62c63e5cb = (0, $ggKAj.createHook)((0, $8JicK.Store), {
    selector: $5d736735ed3620ce$export$45e89e8615dd97d6
});
const $5d736735ed3620ce$export$96718643fd489157 = (0, $bj4JM.createSelector)($5d736735ed3620ce$var$mappingSelector, (mappingState)=>{
    if (!mappingState) return 0;
    return mappingState.columnOrder.filter((col)=>mappingState.columns[col].isVisible && !mappingState.columns[col].field).length;
});
const $5d736735ed3620ce$export$a041138dfab3564d = (0, $ggKAj.createHook)((0, $8JicK.Store), {
    selector: $5d736735ed3620ce$export$96718643fd489157
});
const $5d736735ed3620ce$export$b4f3e232fea620c1 = (0, $bj4JM.createSelector)($5d736735ed3620ce$var$mappingSelector, (mappingState)=>{
    if (!mappingState) return 0;
    return mappingState.columnOrder.filter((col)=>mappingState.columns[col].isIncluded && !mappingState.columns[col].field).length;
});
const $5d736735ed3620ce$export$bf645bc7445be745 = (0, $ggKAj.createHook)((0, $8JicK.Store), {
    selector: $5d736735ed3620ce$export$b4f3e232fea620c1
});

});

parcelRegister("lhF5g", function(module, exports) {

$parcel$export(module.exports, "useReadCSVMetadata", () => $32ab4cf134bebe00$export$b1ce3d8e291bd2da);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $gyZoj = parcelRequire("gyZoj");
var $5GSA7 = parcelRequire("5GSA7");

var $kzTj7 = parcelRequire("kzTj7");

var $3yuWi = parcelRequire("3yuWi");

var $jNdPf = parcelRequire("jNdPf");

var $il2VC = parcelRequire("il2VC");

var $dotpg = parcelRequire("dotpg");
const $32ab4cf134bebe00$export$b1ce3d8e291bd2da = (source)=>{
    const [onExperienceStart, onExperienceSuccess, onExperienceFail] = (0, $5GSA7.useExperienceTracker)((0, $3yuWi.EXPERIENCES).READ_CSV_METADATA);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [hasErrorOccurred, setHasErrorOccurred] = (0, $eUqFw.useState)(false);
    const analtyticsAttributes = (0, $jNdPf.useAnalyticsAttributesContext)();
    const client = (0, $il2VC.useGetCSVImportClient)(source);
    const readCSVMetadata = (0, $eUqFw.useCallback)(async ({ migrationId: migrationId, mappingState: mappingState, advancedOptions: advancedOptions })=>{
        setIsLoading(true);
        setHasErrorOccurred(false);
        (0, $3yuWi.readCSVMetadataInteractionMetric).start();
        onExperienceStart();
        try {
            const data = await client.getMetadata({
                migrationId: migrationId,
                mappingState: mappingState,
                advancedOptions: advancedOptions
            });
            (0, $3yuWi.readCSVMetadataInteractionMetric).stop();
            onExperienceSuccess();
            setIsLoading(false);
            return (0, $dotpg.transformToUserMappingsState)(data);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $3yuWi.readCSVMetadataInteractionMetric).stop();
            onExperienceFail((0, $kzTj7.APP_IDENTIFIER), error, {
                migrationId: migrationId,
                ...analtyticsAttributes
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'read-csv-metadata-error',
                    packageName: (0, $kzTj7.APP_IDENTIFIER),
                    teamName: (0, $gyZoj.APP_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true,
                error: error
            });
            setHasErrorOccurred(true);
            setIsLoading(false);
            return null;
        }
    }, [
        analtyticsAttributes,
        client,
        onExperienceFail,
        onExperienceStart,
        onExperienceSuccess
    ]);
    return {
        isLoading: isLoading,
        hasErrorOccurred: hasErrorOccurred,
        readCSVMetadata: readCSVMetadata
    };
};

});
parcelRegister("5GSA7", function(module, exports) {

$parcel$export(module.exports, "useExperienceTracker", () => $9a3a2479a1bed829$export$cdefb2a8b53f879f);

var $eUqFw = parcelRequire("eUqFw");

var $hompL = parcelRequire("hompL");

var $4qhD6 = parcelRequire("4qhD6");
var $bDhRl = parcelRequire("bDhRl");
var $fDZ6r = parcelRequire("fDZ6r");

var $JRB5w = parcelRequire("JRB5w");

var $kgv5c = parcelRequire("kgv5c");
const $9a3a2479a1bed829$var$analyticsSource = 'ProjectCreateImporter';
const $9a3a2479a1bed829$export$cdefb2a8b53f879f = (experience)=>{
    const onExperienceStart = (0, $bDhRl.useExperienceStart)({
        experienceId: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
        experience: experience,
        analyticsSource: $9a3a2479a1bed829$var$analyticsSource
    });
    const onExperienceSuccess = (0, $fDZ6r.useExperienceSuccess)({
        experience: experience,
        attributes: {}
    });
    const onFail = (0, $4qhD6.useExperienceFail)({
        experience: experience,
        attributes: {}
    });
    const onExperienceFail = (0, $eUqFw.useCallback)((location, error, extraAttributes)=>{
        if ((0, $JRB5w.isClientFetchError)(error) || (0, $JRB5w.isHttpClientErrorResponse)(error)) {
            onExperienceSuccess();
            return;
        }
        onFail(location, error, {
            errorName: (0, $kgv5c.extractErrorName)(error),
            errorMessage: (0, $kgv5c.extractErrorMessage)(error),
            statusCode: (0, $kgv5c.extractStatusCode)(error),
            traceId: (0, $kgv5c.extractTraceId)(error),
            buildKey: (0, $kgv5c.getBuildKey)(),
            ...extraAttributes || {}
        });
    }, [
        onExperienceSuccess,
        onFail
    ]);
    return [
        onExperienceStart,
        onExperienceSuccess,
        onExperienceFail
    ];
};

});
parcelRegister("kgv5c", function(module, exports) {

$parcel$export(module.exports, "getBuildKey", () => $38e2ebfd977c2aef$export$14551268fbd9a06f);
$parcel$export(module.exports, "extractStatusCode", () => $38e2ebfd977c2aef$export$1fdf7c1c0741a7e7);
$parcel$export(module.exports, "extractTraceId", () => $38e2ebfd977c2aef$export$431eacb6aecbacdf);
$parcel$export(module.exports, "extractErrorName", () => $38e2ebfd977c2aef$export$ebcf8325c79b7706);
$parcel$export(module.exports, "extractErrorMessage", () => $38e2ebfd977c2aef$export$8cc545829c7461b0);

var $illlw = parcelRequire("illlw");
const $38e2ebfd977c2aef$export$ba068cc3610b559d = 'NOT_PRESENT';
const $38e2ebfd977c2aef$export$14551268fbd9a06f = ()=>window.BUILD_KEY;
const $38e2ebfd977c2aef$export$1fdf7c1c0741a7e7 = (error)=>(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
        'statusCode'
    ], $38e2ebfd977c2aef$export$ba068cc3610b559d);
const $38e2ebfd977c2aef$export$431eacb6aecbacdf = (error)=>(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
        'traceId'
    ], $38e2ebfd977c2aef$export$ba068cc3610b559d);
const $38e2ebfd977c2aef$export$ebcf8325c79b7706 = (error)=>(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
        'name'
    ], $38e2ebfd977c2aef$export$ba068cc3610b559d);
const $38e2ebfd977c2aef$export$8cc545829c7461b0 = (error)=>(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(error, [
        'message'
    ], $38e2ebfd977c2aef$export$ba068cc3610b559d);

});


parcelRegister("il2VC", function(module, exports) {

$parcel$export(module.exports, "useGetCSVImportClient", () => $e31ddaa0be4a3280$export$1dcc59a08ca6ef04);

var $eUqFw = parcelRequire("eUqFw");

var $dWLk9 = parcelRequire("dWLk9");


var $2tCWU = parcelRequire("2tCWU");

var $11Oka = parcelRequire("11Oka");
const $e31ddaa0be4a3280$export$1dcc59a08ca6ef04 = (source, serviceName)=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    return (0, $eUqFw.useMemo)(()=>{
        if (source === (0, $85ba070c29b4a3bd$export$ec4d35718915f521)) return new (0, $2tCWU.ExistingProjectClient)(cloudId, serviceName);
        return new (0, $11Oka.NewProjectClient)(cloudId, serviceName);
    }, [
        cloudId,
        serviceName,
        source
    ]);
};

});
parcelRegister("dWLk9", function(module, exports) {

$parcel$export(module.exports, "useCloudId", () => $15ea95bdeaf03a79$export$9da0f7c65f28ed16);

var $gd0Sp = parcelRequire("gd0Sp");
const $15ea95bdeaf03a79$export$9da0f7c65f28ed16 = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.cloudId;
};

});

parcelRegister("2tCWU", function(module, exports) {

$parcel$export(module.exports, "ExistingProjectClient", () => $396267609f65dd0f$export$bbfa066740d62ea3);

var $eI5EY = parcelRequire("eI5EY");

var $2OdyW = parcelRequire("2OdyW");
var $lRmyA = parcelRequire("lRmyA");

var $cpweK = parcelRequire("cpweK");
var $gyZoj = parcelRequire("gyZoj");

var $aWLVm = parcelRequire("aWLVm");

var $dWwV8 = parcelRequire("dWwV8");
class $396267609f65dd0f$export$bbfa066740d62ea3 {
    constructor(cloudId, serviceName){
        this.BASE_URL = `${0, $gyZoj.X2C_SERVICE_URL_PREFIX}/${cloudId}/import/bulk/csv`;
        this.serviceName = serviceName;
    }
    getUploadUrlAndMigrationId({ signal: signal, projectKey: projectKey }) {
        return (0, $2OdyW.default)(`${this.BASE_URL}/uploadUrl`, {
            body: JSON.stringify({
                url: (0, $dWwV8.getSiteUrl)(),
                projectKey: projectKey
            }),
            method: 'POST',
            signal: signal,
            headers: {
                'x-issynthetic-traffic': String((0, $cpweK.isSynthetic)())
            }
        });
    }
    getPreview({ migrationId: migrationId, projectData: { key: key, type: type }, advancedOptions: advancedOptions }) {
        const payload = {
            fileEncoding: advancedOptions.fileEncoding.trim(),
            delimiter: advancedOptions.delimiter,
            dateProperties: (0, $aWLVm.transformToDateProperties)(advancedOptions),
            projectDetails: {
                key: key,
                type: type
            },
            ...this.serviceName && {
                serviceName: this.serviceName
            }
        };
        return (0, $2OdyW.default)(`${this.BASE_URL}/${migrationId}/preview`, {
            method: 'POST',
            body: JSON.stringify(payload),
            headers: {
                'x-issynthetic-traffic': String((0, $cpweK.isSynthetic)())
            }
        });
    }
    getMetadata() {
        return Promise.reject(new Error('getMetadata method is not implemented in ExistingProjectClient'));
    }
    startImport({ migrationId: migrationId, projectData: { key: key, type: type, name: name }, advancedOptions: advancedOptions, mappingState: mappingState }) {
        const payload = {
            projectData: {
                key: key,
                type: type,
                name: name
            },
            ...(0, $dWwV8.transformToValidateImportPayload)(mappingState, advancedOptions),
            ...mappingState.shouldImportUsers && (0, $eI5EY.fg)('enable-x2c-standardised-flow') && {
                userMapping: (0, $aWLVm.transformToUserEmailMappings)(mappingState)
            },
            ...(0, $eI5EY.fg)('enable-x2c-standardised-flow') && {
                serviceName: this.serviceName
            }
        };
        return (0, $lRmyA.performPostRequest)(`${this.BASE_URL}/${migrationId}/start`, {
            body: JSON.stringify(payload),
            headers: {
                'x-issynthetic-traffic': String((0, $cpweK.isSynthetic)()),
                'Content-Type': 'application/json'
            }
        });
    }
    validateRequest({ migrationId: migrationId, mappingState: mappingState, advancedOptions: advancedOptions }) {
        const payload = {
            ...(0, $dWwV8.transformToValidateImportPayload)(mappingState, advancedOptions),
            ...this.serviceName && {
                serviceName: this.serviceName
            }
        };
        return (0, $2OdyW.default)(`${this.BASE_URL}/${migrationId}/validate`, {
            body: JSON.stringify(payload),
            method: 'POST',
            headers: {
                'x-issynthetic-traffic': String((0, $cpweK.isSynthetic)())
            }
        });
    }
}

});
parcelRegister("cpweK", function(module, exports) {

$parcel$export(module.exports, "isSynthetic", () => $b47bae627f38a14c$export$947749d756ccb0a);
$parcel$export(module.exports, "createDownloadLogsUrl", () => $b47bae627f38a14c$export$441dc85364beea74);
$parcel$export(module.exports, "useErrorLogFileName", () => $b47bae627f38a14c$export$b3518e4126b755e4);

var $1ybV0 = parcelRequire("1ybV0");

var $6rW04 = parcelRequire("6rW04");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gyZoj = parcelRequire("gyZoj");

var $8RNqP = parcelRequire("8RNqP");
const $b47bae627f38a14c$export$947749d756ccb0a = ()=>// Filter out synthetic tests using all known ways
    (0, $6rW04.default)('ajs-is-synthetic') === 'true' || (0, $1ybV0.ff)('jsw.pollinator.tenants');
const $b47bae627f38a14c$export$441dc85364beea74 = ({ cloudId: cloudId, migrationId: migrationId, fileName: fileName })=>`${0, $gyZoj.X2C_SERVICE_URL_PREFIX}/${cloudId}/import/${migrationId}/logs?${new URLSearchParams({
        fileName: fileName
    }).toString()}`;
const $b47bae627f38a14c$export$b3518e4126b755e4 = (projectName)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return formatMessage((0, $8RNqP.default).errorLogFileName, {
        projectName: projectName.replace(/[&*()[\];'"?!() ]/g, '_')
    });
};

});
parcelRegister("8RNqP", function(module, exports) {

$parcel$export(module.exports, "default", () => $38feacea0bfcfb4b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $38feacea0bfcfb4b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorLogFileName: {
        "id": "project-create-importer-common.common.error-log-file-name",
        "defaultMessage": "{projectName}_import_error_log.zip"
    }
});

});


parcelRegister("dWwV8", function(module, exports) {

$parcel$export(module.exports, "getSiteUrl", () => $613c14fcf2fcddde$export$63fdf20f02fdbaf2);
$parcel$export(module.exports, "transformToValidateImportPayload", () => $613c14fcf2fcddde$export$73e736ac1792aa70);
$parcel$export(module.exports, "transformToValidateUserImportPayload", () => $613c14fcf2fcddde$export$39e98c34de60d403);

var $aWLVm = parcelRequire("aWLVm");
const $613c14fcf2fcddde$export$63fdf20f02fdbaf2 = ()=>`https://${window.location.hostname}`;
const $613c14fcf2fcddde$export$73e736ac1792aa70 = (mappingState, advancedOptions, isIssueLinkingAllowed = false)=>({
        fileEncoding: advancedOptions.fileEncoding,
        delimiter: advancedOptions.delimiter,
        dateProperties: (0, $aWLVm.transformToDateProperties)(advancedOptions),
        columns: (0, $aWLVm.transformMappingStateToFieldMapping)(mappingState),
        ...isIssueLinkingAllowed && {
            issueLinkColumns: (0, $aWLVm.transformMappingStateToIssueLinkMapping)(mappingState)
        }
    });
const $613c14fcf2fcddde$export$39e98c34de60d403 = (mappingState, advancedOptions)=>({
        fileEncoding: advancedOptions.fileEncoding,
        delimiter: advancedOptions.delimiter,
        columns: (0, $aWLVm.transformMappingStateToFieldMapping)(mappingState)
    });

});


parcelRegister("11Oka", function(module, exports) {

$parcel$export(module.exports, "NewProjectClient", () => $63dc13e7517f513d$export$ecb5fd4ee7b6394d);

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $2OdyW = parcelRequire("2OdyW");
var $lRmyA = parcelRequire("lRmyA");

var $cpweK = parcelRequire("cpweK");
var $gyZoj = parcelRequire("gyZoj");

var $aWLVm = parcelRequire("aWLVm");

var $dWwV8 = parcelRequire("dWwV8");
class $63dc13e7517f513d$export$ecb5fd4ee7b6394d {
    constructor(cloudId, serviceName){
        this.BASE_URL = `${0, $gyZoj.X2C_SERVICE_URL_PREFIX}/${cloudId}/import/csv`;
        this.serviceName = serviceName;
    }
    getUploadUrlAndMigrationId({ signal: signal }) {
        return (0, $2OdyW.default)(`${this.BASE_URL}/uploadUrl`, {
            body: JSON.stringify({
                url: (0, $dWwV8.getSiteUrl)()
            }),
            method: 'POST',
            signal: signal,
            headers: {
                'x-issynthetic-traffic': String((0, $cpweK.isSynthetic)())
            }
        });
    }
    getPreview({ migrationId: migrationId, projectData: projectData, advancedOptions: advancedOptions }) {
        const payload = {
            fileEncoding: advancedOptions.fileEncoding.trim(),
            delimiter: advancedOptions.delimiter,
            dateProperties: (0, $aWLVm.transformToDateProperties)(advancedOptions),
            projectDetails: {
                type: projectData.type,
                style: projectData.style,
                template: projectData.template
            },
            ...this.serviceName && {
                serviceName: this.serviceName
            }
        };
        return (0, $2OdyW.default)(`${this.BASE_URL}/${migrationId}/preview`, {
            method: 'POST',
            body: JSON.stringify(payload),
            headers: {
                'x-issynthetic-traffic': String((0, $cpweK.isSynthetic)())
            }
        });
    }
    getMetadata({ migrationId: migrationId, mappingState: mappingState, advancedOptions: advancedOptions }) {
        const payload = (0, $dWwV8.transformToValidateUserImportPayload)(mappingState, advancedOptions);
        return (0, $2OdyW.default)(`${this.BASE_URL}/${migrationId}/metadata`, {
            body: JSON.stringify(payload),
            method: 'POST',
            headers: {
                'x-issynthetic-traffic': String((0, $cpweK.isSynthetic)())
            }
        });
    }
    startImport({ migrationId: migrationId, projectData: projectData, advancedOptions: advancedOptions, mappingState: mappingState }) {
        const payload = {
            projectData: projectData,
            ...(0, $dWwV8.transformToValidateImportPayload)(mappingState, advancedOptions, (0, $1ybV0.ff)('x2c-issuelinking-frontend_tuyzk')),
            ...mappingState.shouldImportUsers && (0, $eI5EY.fg)('enable-x2c-standardised-flow') && {
                userMapping: (0, $aWLVm.transformToUserEmailMappings)(mappingState)
            },
            ...(0, $eI5EY.fg)('enable-x2c-standardised-flow') && {
                ...this.serviceName && {
                    serviceName: this.serviceName
                }
            }
        };
        return (0, $lRmyA.performPostRequest)(`${this.BASE_URL}/${migrationId}/start`, {
            body: JSON.stringify(payload),
            headers: {
                'x-issynthetic-traffic': String((0, $cpweK.isSynthetic)()),
                'Content-Type': 'application/json'
            }
        });
    }
    validateRequest({ migrationId: migrationId, mappingState: mappingState, advancedOptions: advancedOptions }) {
        const payload = {
            ...(0, $dWwV8.transformToValidateImportPayload)(mappingState, advancedOptions, (0, $1ybV0.ff)('x2c-issuelinking-frontend_tuyzk')),
            ...this.serviceName && {
                serviceName: this.serviceName
            }
        };
        return (0, $2OdyW.default)(`${this.BASE_URL}/${migrationId}/validate`, {
            body: JSON.stringify(payload),
            method: 'POST',
            headers: {
                'x-issynthetic-traffic': String((0, $cpweK.isSynthetic)())
            }
        });
    }
}

});


parcelRegister("dotpg", function(module, exports) {

$parcel$export(module.exports, "transformToUserMappingsState", () => $14804260bea56c33$export$93a112f11a5b130e);
const $14804260bea56c33$export$93a112f11a5b130e = ({ issueCount: issueCount, users: users })=>{
    const userMappingMap = {};
    users.forEach((user)=>{
        userMappingMap[user.userKey] = {
            ...user
        };
    });
    const preFilledUserCount = users.filter((user)=>!!user.userValue).length;
    return {
        issueCount: issueCount,
        userMapping: userMappingMap,
        preFilledUserCount: preFilledUserCount
    };
};

});


parcelRegister("84XLS", function(module, exports) {

$parcel$export(module.exports, "default", () => $31f61f39669fd238$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $31f61f39669fd238$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    heading: {
        "id": "project-create-importer-upload-flow.csv-user-mapping-screen.heading",
        "defaultMessage": "Move users to Jira"
    },
    toggleLabel: {
        "id": "project-create-importer-upload-flow.csv-user-mapping-screen.toggle-label",
        "defaultMessage": "Add users into your project"
    },
    description: {
        "id": "project-create-importer-upload-flow.csv-user-mapping-screen.description",
        "defaultMessage": "Enter a valid email address next to the user information to add a user to the project. Users without a corresponding email address won\u2019t be imported."
    },
    descriptionForNotImportUsers: {
        "id": "project-create-importer-upload-flow.csv-user-mapping-screen.description-for-not-import-users",
        "defaultMessage": "Adding users ensures that user information is displayed in issues, comments, and tags. Without users, assignee and reporter fields in Jira will be unassigned and user @mentions in comments will be converted to plain text."
    },
    errorHeading: {
        "id": "project-create-importer-upload-flow.csv-user-mapping-screen.error-heading",
        "defaultMessage": "We couldn\u2019t load this page"
    },
    errorDescription: {
        "id": "project-create-importer-upload-flow.csv-user-mapping-screen.error-description",
        "defaultMessage": "Try refreshing the page or wait for a few minutes before importing the project again."
    },
    titleForNoUsers: {
        "id": "project-create-importer-upload-flow.csv-user-mapping-screen.title-for-no-users",
        "defaultMessage": "There are no users in the CSV file"
    },
    descriptionForNoUsers: {
        "id": "project-create-importer-upload-flow.csv-user-mapping-screen.description-for-no-users",
        "defaultMessage": "You can proceed with the import by selecting <strong>Next</strong> or restart the import by uploading a CSV file with user information. If you choose to proceed without adding user information:<ul><li>Assignee and reporter fields will be unassigned.</li><li>User @mentions in comments will be converted to plain text. </li><li>Commenter names will change to Anonymous.</li></ul>"
    },
    newUserNotAllowedToImportBannerHeading: {
        "id": "project-create-importer-upload-flow.csv-user-mapping-screen.new-user-not-allowed-to-import-banner-heading",
        "defaultMessage": "You do not have permission to invite new users"
    },
    newUserNotAllowedToImportBannerDescription: {
        "id": "project-create-importer-upload-flow.csv-user-mapping-screen.new-user-not-allowed-to-import-banner-description",
        "defaultMessage": "You can either ask an organization admin to invite new users before moving ahead with your import or continue without them. Any information of new users added here will not be imported."
    }
});

});

parcelRegister("iu9zr", function(module, exports) {

$parcel$export(module.exports, "UserMappingTable", () => $5c8eb52bfc2c5820$export$f7ef210a3e8f4f2d);

var $eUqFw = parcelRequire("eUqFw");

var $4LhB6 = parcelRequire("4LhB6");

var $cSu9v = parcelRequire("cSu9v");

var $77CtJ = parcelRequire("77CtJ");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $cf2Y4 = parcelRequire("cf2Y4");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kzTj7 = parcelRequire("kzTj7");

var $fQU5k = parcelRequire("fQU5k");

var $bgSxq = parcelRequire("bgSxq");

var $7k17U = parcelRequire("7k17U");
const $5c8eb52bfc2c5820$var$useTableHead = ({ numberOfUsers: numberOfUsers, numberOfImportedUsers: numberOfImportedUsers, importType: importType })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { usersMappingScreenColumnHeader: usersMappingScreenColumnHeader } = (0, $bgSxq.useContentForCSV)(importType);
    const tableHead = (0, $eUqFw.useMemo)(()=>({
            cells: [
                {
                    key: 'csvUser',
                    content: usersMappingScreenColumnHeader(numberOfUsers),
                    width: 30
                },
                {
                    key: 'arrow',
                    width: 10
                },
                {
                    key: 'JiraUser',
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
                        space: "space.050",
                        alignBlock: "center"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77CtJ.JiraIcon), {
                        label: "",
                        size: "small",
                        appearance: "brand"
                    }), formatMessage((0, $7k17U.default).importedUser, {
                        numberOfUsers: numberOfImportedUsers
                    }))
                }
            ]
        }), [
        formatMessage,
        numberOfImportedUsers,
        numberOfUsers,
        usersMappingScreenColumnHeader
    ]);
    return tableHead;
};
const $5c8eb52bfc2c5820$var$useTableRows = (users, onChange)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const tableRows = (0, $eUqFw.useMemo)(()=>users ? Object.values(users).map((user, index)=>({
                key: `row-${user.userKey}`,
                cells: [
                    {
                        key: user.userKey,
                        content: user.userKey
                    },
                    {
                        key: `${user.userKey}-arrow`,
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
                            size: "medium",
                            label: "Arrow Right"
                        })
                    },
                    {
                        key: `${user.userKey}-email`,
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
                            name: `${index}-email`
                        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                                xcss: $5c8eb52bfc2c5820$var$textInputWrapperStyles
                            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
                                type: "email",
                                ...fieldProps,
                                "aria-label": formatMessage((0, $7k17U.default).textFieldLabel, {
                                    name: user.userKey
                                }),
                                placeholder: formatMessage((0, $7k17U.default).textFieldPlaceholder),
                                isCompact: true,
                                value: user.userValue || '',
                                onChange: (event)=>onChange(user.userKey, event.target.value)
                            })))
                    }
                ]
            })) : [], [
        formatMessage,
        onChange,
        users
    ]);
    return tableRows;
};
const $5c8eb52bfc2c5820$export$f7ef210a3e8f4f2d = ({ isLoading: isLoading, users: users, importType: importType, onChange: onChange })=>{
    const tableHead = $5c8eb52bfc2c5820$var$useTableHead({
        numberOfUsers: users ? Object.keys(users).length : 0,
        numberOfImportedUsers: users ? Object.values(users).filter((user)=>!!user.userValue).length : 0,
        importType: importType
    });
    const tableRows = $5c8eb52bfc2c5820$var$useTableRows(users, onChange);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fQU5k.AsyncMappingTable), {
        head: tableHead,
        rows: tableRows,
        rowsPerPage: (0, $kzTj7.DEFAULT_TABLE_ROWS_PER_PAGE),
        emptyMessage: (0, $7k17U.default).noUsers,
        isLoading: isLoading
    });
};
const $5c8eb52bfc2c5820$var$textInputWrapperStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.negative.100'
});

});
parcelRegister("4LhB6", function(module, exports) {

$parcel$export(module.exports, "default", () => $dde75f35762e3dcb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $tkrFt = parcelRequire("tkrFt");
parcelRequire("8ynlC");

var $gaA9C = parcelRequire("gaA9C");

var $lzLxZ = parcelRequire("lzLxZ");

var $6ROLN = parcelRequire("6ROLN");

var $jeetE = parcelRequire("jeetE");

var $2fFJv = parcelRequire("2fFJv");
function $dde75f35762e3dcb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $dde75f35762e3dcb$var$fieldWrapperStyles = {
    name: "wkpnc",
    styles: "margin-block-start:var(--ds-space-100, 8px)"
};
function $dde75f35762e3dcb$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $dde75f35762e3dcb$var$isFunction(x) {
    return typeof x === 'function';
}
function $dde75f35762e3dcb$var$usePreviousRef(current) {
    const ref = (0, $eUqFw.useRef)(current);
    // will be updated on the next render
    (0, $eUqFw.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $dde75f35762e3dcb$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $dde75f35762e3dcb$export$2e2bcd8739ae039(props) {
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $eUqFw.useContext)((0, $lzLxZ.FormContext));
    const isDisabled = (0, $eUqFw.useContext)((0, $lzLxZ.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $dde75f35762e3dcb$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $dde75f35762e3dcb$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$dde75f35762e3dcb$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $eUqFw.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explictly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $dde75f35762e3dcb$var$usePreviousRef(state);
    (0, $eUqFw.useEffect)(()=>{
        typeof $2fFJv;
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $dde75f35762e3dcb$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($dde75f35762e3dcb$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    const fieldId = (0, $eUqFw.useMemo)(// eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    ()=>props.id ? props.id : `${props.name}-${(0, $tkrFt.uid)({
            id: props.name
        })}`, [
        props.id,
        props.name
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $dde75f35762e3dcb$var$fieldWrapperStyles,
        "data-testid": props.testId
    }, props.label && /*#__PURE__*/ (0, $byn9U.jsx)((0, $6ROLN.Label), {
        htmlFor: fieldId,
        id: `${fieldId}-label`,
        testId: props.testId && `${props.testId}--label`
    }, props.label, props.isRequired && /*#__PURE__*/ (0, $byn9U.jsx)((0, $jeetE.default), null), props.elementAfterLabel), /*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Provider, {
        value: fieldId
    }, props.children({
        fieldProps: extendedFieldProps,
        error: state.error,
        valid: state.valid,
        meta: state.meta
    })));
}

});
parcelRegister("gaA9C", function(module, exports) {

$parcel$export(module.exports, "FieldId", () => $d60d84c188ee2cc0$export$3c4232819458a302);

var $eUqFw = parcelRequire("eUqFw");
const $d60d84c188ee2cc0$export$3c4232819458a302 = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);

});

parcelRegister("6ROLN", function(module, exports) {

$parcel$export(module.exports, "Label", () => $7dbb02f7c217159b$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Legend", () => $7dbb02f7c217159b$export$ed247974535929c7);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $PdmhA = parcelRequire("PdmhA");
function $7dbb02f7c217159b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7dbb02f7c217159b$var$fieldsetLabelStyles = {
    name: "1v8a0r4",
    styles: "display:inline-block;font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-end:var(--ds-space-050, 4px);margin-block-start:var(--ds-space-0, 0px)"
};
const $7dbb02f7c217159b$var$oldFieldsetLabelStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-subtle, ${(0, $PdmhA.N200)})`,
    fontWeight: "var(--ds-font-weight-semibold, 600)"
});
const $7dbb02f7c217159b$var$newFieldsetLabelStyles = {
    name: "1btbeoi",
    styles: "color:var(--ds-text-subtle, #44546F);font-weight:var(--ds-font-weight-bold, 700)"
};
const $7dbb02f7c217159b$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("label", {
        css: [
            $7dbb02f7c217159b$var$fieldsetLabelStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $XHGTv.getBooleanFF)('platform.design-system-team.form-label-typography-updates') ? $7dbb02f7c217159b$var$newFieldsetLabelStyles : $7dbb02f7c217159b$var$oldFieldsetLabelStyles
        ],
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId
    }, children);
const $7dbb02f7c217159b$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("legend", {
        css: [
            $7dbb02f7c217159b$var$fieldsetLabelStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $XHGTv.getBooleanFF)('platform.design-system-team.form-label-typography-updates') ? $7dbb02f7c217159b$var$newFieldsetLabelStyles : $7dbb02f7c217159b$var$oldFieldsetLabelStyles
        ]
    }, children);
};
var $7dbb02f7c217159b$export$2e2bcd8739ae039 = $7dbb02f7c217159b$export$b04be29aa201d4f5;

});

parcelRegister("jeetE", function(module, exports) {

$parcel$export(module.exports, "default", () => $d43a5e2537ba41ea$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
const $d43a5e2537ba41ea$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-danger, ${(0, $PdmhA.R400)})`,
    fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $d43a5e2537ba41ea$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $d43a5e2537ba41ea$var$requiredIndicatorStyles,
        "aria-hidden": "true",
        title: "required"
    }, "*");
}

});


parcelRegister("cSu9v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9601eacac1d33448$var$_react = $9601eacac1d33448$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $9601eacac1d33448$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9601eacac1d33448$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $9601eacac1d33448$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M11.793 5.793a.999.999 0 000 1.414L15.586 11H6a1 1 0 000 2h9.586l-3.793 3.793a.999.999 0 000 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a.997.997 0 00.293-.679v-.057a.996.996 0 00-.293-.678l-5.499-5.5a1 1 0 00-1.415 0z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$9601eacac1d33448$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $9601eacac1d33448$var$_default = $9601eacac1d33448$var$ArrowRightIcon;
module.exports.default = $9601eacac1d33448$var$_default;

});

parcelRegister("cf2Y4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecaf8c9a10cf48c9$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $abUSh = parcelRequire("abUSh");
const $ecaf8c9a10cf48c9$var$analyticsParams = {
    componentName: 'textField',
    packageName: undefined,
    packageVersion: undefined
};
const $ecaf8c9a10cf48c9$var$TextfieldComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $eUqFw.useRef)(null);
    const handleOnFocus = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnBlur = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$ecaf8c9a10cf48c9$var$analyticsParams
    });
    const handleOnMouseDown = (0, $eUqFw.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $eUqFw.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    const containerStyles = (0, $eUqFw.useMemo)(()=>(0, $abUSh.containerStyles)(appearance, width), [
        appearance,
        width
    ]);
    const inputStyle = (0, $abUSh.inputStyles)();
    return(/**
     * It is not normally acceptable to add click and key handlers to
     * non-interactive elements as this is an accessibility anti-pattern.
     * However, because this instance is to handle events on all children that
     * should be associated with the input, we can add role="presentation" so
     * that there are no negative impacts to assistive technologies.
     */ /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: containerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, elemBeforeInput, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ...spreadProps,
        "aria-invalid": isInvalid ? isInvalid : undefined,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: inputStyle,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired
    }), elemAfterInput));
});
$ecaf8c9a10cf48c9$var$TextfieldComponent.displayName = 'Textfield';
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ const $ecaf8c9a10cf48c9$var$Textfield = /*#__PURE__*/ (0, $eUqFw.memo)($ecaf8c9a10cf48c9$var$TextfieldComponent);
var // The above generic is used to let ERTC know what props to extract.
// See: https://github.com/atlassian/extract-react-types/issues/201
$ecaf8c9a10cf48c9$export$2e2bcd8739ae039 = $ecaf8c9a10cf48c9$var$Textfield;

});
parcelRegister("abUSh", function(module, exports) {

$parcel$export(module.exports, "containerStyles", () => $6ff5b404db052892$export$5972a68b6e54f38f);
$parcel$export(module.exports, "inputStyles", () => $6ff5b404db052892$export$3eeb47dc8e6249d9);

var $PdmhA = parcelRequire("PdmhA");
const $6ff5b404db052892$var$backgroundColor = {
    standard: `var(--ds-background-input, ${(0, $PdmhA.N10)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorFocus = {
    standard: `var(--ds-background-input-pressed, ${(0, $PdmhA.N0)})`,
    subtle: `var(--ds-background-input-pressed, ${(0, $PdmhA.N0)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$backgroundColorHover = {
    standard: `var(--ds-background-input-hovered, ${(0, $PdmhA.N30)})`,
    subtle: `var(--ds-background-input-hovered, ${(0, $PdmhA.N30)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColor = {
    standard: `var(--ds-border-input, ${(0, $PdmhA.N100)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorFocus = {
    standard: `var(--ds-border-focused, ${(0, $PdmhA.B200)})`,
    subtle: `var(--ds-border-focused, ${(0, $PdmhA.B200)})`,
    none: 'transparent'
};
const $6ff5b404db052892$var$borderColorHover = {
    standard: `var(--ds-border-input, ${(0, $PdmhA.N100)})`,
    subtle: "var(--ds-border-input, transparent)",
    none: 'transparent'
};
const $6ff5b404db052892$var$getContainerTextBgAndBorderColor = (appearance)=>({
        backgroundColor: $6ff5b404db052892$var$backgroundColor[appearance],
        borderColor: $6ff5b404db052892$var$borderColor[appearance],
        color: `var(--ds-text, ${0, $PdmhA.N900})`,
        cursor: 'text',
        '&:hover:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorHover[appearance],
            borderColor: $6ff5b404db052892$var$borderColorHover[appearance]
        },
        '&:focus-within:not([data-disabled])': {
            backgroundColor: $6ff5b404db052892$var$backgroundColorFocus[appearance],
            borderColor: $6ff5b404db052892$var$borderColorFocus[appearance],
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$6ff5b404db052892$var$borderColorFocus[appearance]}`
        },
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${0, $PdmhA.N70})`,
            cursor: 'not-allowed',
            // Disabled background and border styles should not be applied to components that
            // have either no background or transparent background to begin with
            ...appearance === 'standard' && {
                backgroundColor: `var(--ds-background-disabled, ${0, $PdmhA.N10})`,
                borderColor: `var(--ds-background-disabled, ${0, $PdmhA.N10})`
            }
        },
        '&[data-invalid], &[data-invalid]:hover': {
            borderColor: `var(--ds-border-danger, ${0, $PdmhA.R400})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $PdmhA.R400})`}`
        },
        '&[data-invalid]:focus-within': {
            backgroundColor: `var(--ds-background-input-pressed, ${0, $PdmhA.N0})`,
            borderColor: `var(--ds-border-focused, ${0, $PdmhA.B200})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $PdmhA.B200})`}`
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[data-invalid]:focus-within': {
                borderColor: 'Highlight'
            },
            '&:focus-within': {
                borderColor: 'Highlight'
            },
            '&[data-disabled]': {
                borderColor: 'GrayText'
            }
        }
    });
const $6ff5b404db052892$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $6ff5b404db052892$var$getMaxWidth = (width)=>!width ? `100%` : width in $6ff5b404db052892$var$widthMap ? $6ff5b404db052892$var$widthMap[width] : +width;
const $6ff5b404db052892$export$5972a68b6e54f38f = (appearance, width)=>({
        alignItems: 'center',
        ...$6ff5b404db052892$var$getContainerTextBgAndBorderColor(appearance),
        borderRadius: 3,
        borderWidth: "var(--ds-border-width, 1px)",
        // add 1px padding on both top and bottom to keep the same overall height after border reduced from 2px to 1px under feature flag
        ...appearance !== 'none' ? {
            padding: `${"var(--ds-border-width, 1px)"} 0`
        } : {},
        borderStyle: appearance === 'none' ? 'none' : 'solid',
        boxSizing: 'border-box',
        display: 'flex',
        flex: '1 1 100%',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        justifyContent: 'space-between',
        maxWidth: $6ff5b404db052892$var$getMaxWidth(width),
        overflow: 'hidden',
        transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
        wordWrap: 'break-word',
        verticalAlign: 'top',
        pointerEvents: 'auto'
    });
const $6ff5b404db052892$export$3eeb47dc8e6249d9 = ()=>({
        backgroundColor: 'transparent',
        border: 0,
        boxSizing: 'border-box',
        color: 'inherit',
        cursor: 'inherit',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        minWidth: '0',
        outline: 'none',
        width: '100%',
        '&[data-monospaced]': {
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
        },
        '&[data-compact]': {
            padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&:not([data-compact])': {
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&[disabled]': {
            // Safari (WebKit) adds a -webkit-text-fill-color style to disabled inputs
            // which takes priority over color and makes the text unreadable. Need to
            // override it with the color we want.
            WebkitTextFillColor: `var(--ds-text-disabled, ${0, $PdmhA.N70})`
        },
        // Hide the clear indicator on Edge (Windows only)
        '&::-ms-clear': {
            display: 'none'
        },
        '&:invalid': {
            boxShadow: 'none'
        },
        '&:placeholder-shown': {
            textOverflow: 'ellipsis'
        },
        '&::placeholder': {
            color: `var(--ds-text-subtlest, ${0, $PdmhA.N200})`,
            '&:disabled': {
                color: `var(--ds-text-disabled, ${0, $PdmhA.N70})`
            }
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[disabled]': {
                color: 'GrayText'
            }
        }
    });

});


parcelRegister("fQU5k", function(module, exports) {

$parcel$export(module.exports, "AsyncMappingTable", () => $d7978bc8857ef844$export$40cc7d9177d592ba);
/**
 * You are encouraged to use entry point export in src
 * However, at the time of development, this was mounted in JWM onboarding which had no relay environment
 * Hence we have this rll export as an alternative way to chunk the mapping table
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

const $d7978bc8857ef844$var$MappingTable = (0, $7rh0R.lazyForPaint)(()=>(parcelRequire("5V8Jm")), {
    moduleId: "./src/packages/project-create-importer/project-create-importer-upload-flow/src/common/ui/mapping-table/main.tsx"
});
const $d7978bc8857ef844$export$40cc7d9177d592ba = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "mapping-table",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d7978bc8857ef844$var$MappingTable, props));

});
parcelRegister("5V8Jm", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('4J23j');
        const value = parcelRequire('eJFXB');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("4J23j").then(()=>parcelRequire('eJFXB'));
}

});


parcelRegister("bgSxq", function(module, exports) {

$parcel$export(module.exports, "useContentForCSV", () => $62e6273da889e3ab$export$53f3b67bb6b400be);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $29Y8f = parcelRequire("29Y8f");

var $9Amv1 = parcelRequire("9Amv1");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kzTj7 = parcelRequire("kzTj7");

var $3ak5x = parcelRequire("3ak5x");

var $9R4E5 = parcelRequire("9R4E5");

var $eYjP0 = parcelRequire("eYjP0");

var $7J5LG = parcelRequire("7J5LG");

var $38ThW = parcelRequire("38ThW");
const $62e6273da889e3ab$export$53f3b67bb6b400be = (importType, projectType)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return (0, $eUqFw.useMemo)(()=>{
        const mappingLink = projectType === (0, $9R4E5.ProjectTypes).SOFTWARE ? (0, $kzTj7.MAPPING_GUIDE_SOFTWARE) : (0, $kzTj7.MAPPING_GUIDE_BUSINESS);
        if (!importType || importType === (0, $3ak5x.CSV) || importType === (0, $3ak5x.DEFAULT)) return {
            uploadScreenDescription: formatMessage((0, $38ThW.default).uploadScreenDescription, {
                link: (content)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                        href: (0, $kzTj7.STRUCTURE_CSV_LINK),
                        target: "_blank",
                        appearance: "link",
                        spacing: "none"
                    }, content),
                b: (content)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, content)
            }),
            setupProjectScreenDescription: formatMessage((0, $38ThW.default).setupProjectScreenDescription),
            usersMappingScreenColumnHeader: (numberOfUsers)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
                    space: "space.050",
                    alignBlock: "center"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($29Y8f))), {
                    label: "",
                    size: "medium"
                }), `${formatMessage((0, $38ThW.default).usersMappingScreenColumnHeader)} (${numberOfUsers})`),
            fieldMappingDescription: formatMessage((0, $38ThW.default).fieldMappingDescription, {
                link: (content)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                        href: mappingLink,
                        target: "_blank",
                        appearance: "link",
                        spacing: "none"
                    }, content)
            }),
            fieldMappingTableHeading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
                space: "space.050",
                alignBlock: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($29Y8f))), {
                label: "",
                size: "medium"
            }), formatMessage((0, $38ThW.default).fieldMappingTableHeading))
        };
        const sources = (0, $eYjP0.getSourceItemMap)(formatMessage);
        const sourceName = sources[importType]?.name || importType;
        const sourceIcon = sources[importType]?.icon || sources[0, $3ak5x.CSV]?.icon;
        return {
            uploadScreenDescription: formatMessage((0, $38ThW.default).uploadScreenCustomisedDescription, {
                importType: sourceName
            }),
            setupProjectScreenDescription: formatMessage((0, $38ThW.default).setupProjectScreenCustomisedDescription, {
                importType: sourceName
            }),
            usersMappingScreenColumnHeader: (numberOfUsers)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
                    space: "space.050",
                    alignBlock: "center"
                }, (0, $7J5LG.renderIcon)(sourceIcon, true), `${formatMessage((0, $38ThW.default).usersMappingScreenCustomisedColumnHeader, {
                    importType: sourceName
                })} (${numberOfUsers})`),
            fieldMappingDescription: formatMessage((0, $38ThW.default).fieldMappingCustomisedDescription, {
                link: (content)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                        href: mappingLink,
                        target: "_blank",
                        appearance: "link",
                        spacing: "none"
                    }, content),
                importType: sourceName
            }),
            fieldMappingTableHeading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
                space: "space.050",
                alignBlock: "center"
            }, (0, $7J5LG.renderIcon)(sourceIcon, true), formatMessage((0, $38ThW.default).fieldMappingTableCustomisedHeading, {
                importType: sourceName
            }))
        };
    }, [
        formatMessage,
        importType,
        projectType
    ]);
};

});
parcelRegister("29Y8f", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $192b110733c90331$var$_react = $192b110733c90331$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $192b110733c90331$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $192b110733c90331$var$FileIcon = (props)=>/*#__PURE__*/ $192b110733c90331$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M17 10.005V19H7V5h5.99v2.49a1.5 1.5 0 001.5 1.5h4.5v-.522c0-.297-.132-.578-.359-.768l-5.074-4.236c-.36-.3-.813-.464-1.282-.464H7a2 2 0 00-2 2v14a2 2 0 002 2h10a2 2 0 002-2v-8.995h-2z"/><rect x="8" y="12" width="8" height="2" rx="1"/><rect x="8" y="15" width="4" height="2" rx="1"/></g></svg>`
    }, props));
$192b110733c90331$var$FileIcon.displayName = 'FileIcon';
var $192b110733c90331$var$_default = $192b110733c90331$var$FileIcon;
module.exports.default = $192b110733c90331$var$_default;

});

parcelRegister("eYjP0", function(module, exports) {

$parcel$export(module.exports, "SourceType", () => $1c65c3ae0cc7b3d4$export$d95e7684b6658cc2);
$parcel$export(module.exports, "getSourceItemMap", () => $1c65c3ae0cc7b3d4$export$77e216121d7e941c);
$parcel$export(module.exports, "getJiraProjects", () => $1c65c3ae0cc7b3d4$export$9e28e4d92e9a4215);

var $eUqFw = parcelRequire("eUqFw");

var $2Q5Ee = parcelRequire("2Q5Ee");

var $29Y8f = parcelRequire("29Y8f");

var $1kt3H = parcelRequire("1kt3H");

var $77CtJ = parcelRequire("77CtJ");
var $11o4b = parcelRequire("11o4b");

var $6hHg9 = parcelRequire("6hHg9");

var $70vb9 = parcelRequire("70vb9");

var $8B4Rm = parcelRequire("8B4Rm");

var $f7YdI = parcelRequire("f7YdI");

var $ijZeV = parcelRequire("ijZeV");

var $5MtDo = parcelRequire("5MtDo");

var $4vsbN = parcelRequire("4vsbN");

var $fIcqL = parcelRequire("fIcqL");

var $bLmGd = parcelRequire("bLmGd");

var $4HdID = parcelRequire("4HdID");

var $kLm4p = parcelRequire("kLm4p");

var $bQHSh = parcelRequire("bQHSh");

var $sPD6N = parcelRequire("sPD6N");

var $jH66N = parcelRequire("jH66N");

var $7J5LG = parcelRequire("7J5LG");

var $3ak5x = parcelRequire("3ak5x");

var $9R4E5 = parcelRequire("9R4E5");

var $haZpO = parcelRequire("haZpO");
const $1c65c3ae0cc7b3d4$export$d95e7684b6658cc2 = {
    THIRD_PARTY: 'thirdParty',
    CSV: 'CSV',
    JIRA: 'Jira'
};
const $1c65c3ae0cc7b3d4$export$77e216121d7e941c = (formatMessage)=>({
        [(0, $3ak5x.CSV)]: {
            key: (0, $3ak5x.CSV),
            name: (0, $3ak5x.CSV),
            icon: {
                type: (0, $7J5LG.IconType).LOGO,
                component: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($29Y8f))), {
                        label: ""
                    }),
                props: {
                    size: 'medium',
                    appearance: 'brand'
                }
            },
            sourceType: $1c65c3ae0cc7b3d4$export$d95e7684b6658cc2.CSV
        },
        [(0, $3ak5x.ASANA)]: {
            key: (0, $3ak5x.ASANA),
            name: (0, $3ak5x.ASANA_DISPLAY_NAME),
            icon: {
                type: (0, $7J5LG.IconType).IMAGE,
                props: {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($70vb9))),
                    alt: 'Asana Icon'
                }
            },
            requiresOAuth: true,
            sourceType: $1c65c3ae0cc7b3d4$export$d95e7684b6658cc2.THIRD_PARTY
        },
        [(0, $3ak5x.JIRA_SOFTWARE)]: {
            key: (0, $3ak5x.JIRA_SOFTWARE),
            name: formatMessage((0, $haZpO.default).jiraSoftwareName),
            icon: {
                type: (0, $7J5LG.IconType).LOGO,
                component: (0, $77CtJ.JiraIcon),
                props: {
                    appearance: 'brand'
                }
            },
            sourceType: $1c65c3ae0cc7b3d4$export$d95e7684b6658cc2.THIRD_PARTY
        },
        [(0, $3ak5x.JIRA_BUSINESS)]: {
            key: (0, $3ak5x.JIRA_BUSINESS),
            name: formatMessage((0, $haZpO.default).jiraBusinessName),
            icon: {
                type: (0, $7J5LG.IconType).LOGO,
                component: (0, $77CtJ.JiraIcon),
                props: {
                    appearance: 'brand'
                }
            },
            sourceType: $1c65c3ae0cc7b3d4$export$d95e7684b6658cc2.THIRD_PARTY
        },
        [(0, $3ak5x.TRELLO)]: {
            key: (0, $3ak5x.TRELLO),
            name: (0, $3ak5x.TRELLO_DISPLAY_NAME),
            icon: {
                type: (0, $7J5LG.IconType).LOGO,
                component: (0, $11o4b.TrelloIcon),
                props: {
                    appearance: 'brand'
                }
            },
            sourceType: $1c65c3ae0cc7b3d4$export$d95e7684b6658cc2.THIRD_PARTY
        },
        [(0, $3ak5x.MONDAY)]: {
            key: (0, $3ak5x.MONDAY),
            name: (0, $3ak5x.MONDAY_DISPLAY_NAME),
            icon: {
                type: (0, $7J5LG.IconType).IMAGE,
                props: {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($4HdID))),
                    alt: 'Monday Icon'
                }
            },
            sourceType: $1c65c3ae0cc7b3d4$export$d95e7684b6658cc2.THIRD_PARTY,
            requiresPersonalAccessToken: true
        },
        [(0, $3ak5x.CLICK_UP)]: {
            key: (0, $3ak5x.CLICK_UP),
            name: (0, $3ak5x.CLICK_UP_DISPLAY_NAME),
            icon: {
                type: (0, $7J5LG.IconType).IMAGE,
                props: {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($f7YdI))),
                    alt: 'ClickUp Icon'
                }
            },
            sourceType: $1c65c3ae0cc7b3d4$export$d95e7684b6658cc2.THIRD_PARTY,
            requiresOAuth: true
        },
        [(0, $3ak5x.SHEETS)]: {
            key: (0, $3ak5x.SHEETS),
            name: (0, $3ak5x.GOOGLE_SHEETS_DISPLAY_NAME),
            icon: {
                type: (0, $7J5LG.IconType).IMAGE,
                props: {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($4vsbN))),
                    alt: 'GoogleSheet Icon'
                }
            },
            sourceType: $1c65c3ae0cc7b3d4$export$d95e7684b6658cc2.THIRD_PARTY
        },
        [(0, $3ak5x.EXCEL)]: {
            key: (0, $3ak5x.EXCEL),
            name: (0, $3ak5x.EXCEL_DISPLAY_NAME),
            icon: {
                type: (0, $7J5LG.IconType).IMAGE,
                props: {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($kLm4p))),
                    alt: 'MSExcel Icon'
                }
            },
            sourceType: $1c65c3ae0cc7b3d4$export$d95e7684b6658cc2.THIRD_PARTY
        },
        [(0, $3ak5x.AIRTABLE)]: {
            key: (0, $3ak5x.AIRTABLE),
            name: (0, $3ak5x.AIRTABLE_DISPLAY_NAME),
            icon: {
                type: (0, $7J5LG.IconType).IMAGE,
                props: {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($6hHg9))),
                    alt: 'Airtable Icon'
                }
            },
            sourceType: $1c65c3ae0cc7b3d4$export$d95e7684b6658cc2.THIRD_PARTY
        },
        [(0, $3ak5x.SMART_SHEET)]: {
            key: (0, $3ak5x.SMART_SHEET),
            name: (0, $3ak5x.SMART_SHEET_DISPLAY_NAME),
            icon: {
                type: (0, $7J5LG.IconType).LOGO,
                component: (0, $sPD6N.default),
                props: {}
            },
            sourceType: $1c65c3ae0cc7b3d4$export$d95e7684b6658cc2.THIRD_PARTY
        },
        [(0, $3ak5x.GITHUB)]: {
            key: (0, $3ak5x.GITHUB),
            name: (0, $3ak5x.GITHUB_DISPLAY_NAME),
            icon: {
                type: (0, $7J5LG.IconType).LOGO,
                component: (0, $ijZeV.default),
                props: {}
            },
            sourceType: $1c65c3ae0cc7b3d4$export$d95e7684b6658cc2.THIRD_PARTY
        },
        [(0, $3ak5x.LINEAR)]: {
            key: (0, $3ak5x.LINEAR),
            name: (0, $3ak5x.LINEAR_DISPLAY_NAME),
            icon: {
                type: (0, $7J5LG.IconType).LOGO,
                component: (0, $bLmGd.default),
                props: {}
            },
            sourceType: $1c65c3ae0cc7b3d4$export$d95e7684b6658cc2.THIRD_PARTY
        },
        [(0, $3ak5x.GITLAB)]: {
            key: (0, $3ak5x.GITLAB),
            name: (0, $3ak5x.GITLAB_DISPLAY_NAME),
            icon: {
                type: (0, $7J5LG.IconType).IMAGE,
                props: {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($5MtDo))),
                    alt: 'GitLab Icon'
                }
            },
            sourceType: $1c65c3ae0cc7b3d4$export$d95e7684b6658cc2.THIRD_PARTY
        },
        [(0, $3ak5x.AZURE_DEVOPS)]: {
            key: (0, $3ak5x.AZURE_DEVOPS),
            name: (0, $3ak5x.AZURE_DEVOPS_DISPLAY_NAME),
            icon: {
                type: (0, $7J5LG.IconType).IMAGE,
                props: {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($8B4Rm))),
                    alt: 'Azure DevOps Icon'
                }
            },
            sourceType: $1c65c3ae0cc7b3d4$export$d95e7684b6658cc2.THIRD_PARTY
        },
        [(0, $3ak5x.NOTION)]: {
            key: (0, $3ak5x.NOTION),
            name: (0, $3ak5x.NOTION_DISPLAY_NAME),
            icon: {
                type: (0, $7J5LG.IconType).LOGO,
                component: (0, $bQHSh.default),
                props: {}
            },
            sourceType: $1c65c3ae0cc7b3d4$export$d95e7684b6658cc2.THIRD_PARTY
        },
        [(0, $3ak5x.WRIKE)]: {
            key: (0, $3ak5x.WRIKE),
            name: (0, $3ak5x.WRIKE_DISPLAY_NAME),
            icon: {
                type: (0, $7J5LG.IconType).IMAGE,
                props: {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($jH66N))),
                    alt: 'Notion Icon'
                }
            },
            sourceType: $1c65c3ae0cc7b3d4$export$d95e7684b6658cc2.THIRD_PARTY
        },
        [(0, $3ak5x.JETBRAINS_YOUTRACK)]: {
            key: (0, $3ak5x.JETBRAINS_YOUTRACK),
            name: (0, $3ak5x.JETBRAINS_YOUTRACK_DISPLAY_NAME),
            icon: {
                type: (0, $7J5LG.IconType).IMAGE,
                props: {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($fIcqL))),
                    alt: 'Notion Icon'
                }
            },
            sourceType: $1c65c3ae0cc7b3d4$export$d95e7684b6658cc2.THIRD_PARTY
        }
    });
const $1c65c3ae0cc7b3d4$export$9e28e4d92e9a4215 = ()=>({
        [(0, $9R4E5.ProjectTypes).SOFTWARE]: {
            name: (0, $haZpO.default).jiraSoftware,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2Q5Ee))), {
                label: "Software project",
                primaryColor: "var(--ds-text-accent-blue, #0052CC)",
                size: "medium"
            }),
            description: (0, $haZpO.default).jiraSoftwareDescription
        },
        [(0, $9R4E5.ProjectTypes).BUSINESS]: {
            name: (0, $haZpO.default).jiraBusiness,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1kt3H))), {
                label: "Business project",
                primaryColor: "var(--ds-text-accent-blue, #0052CC)",
                size: "medium"
            }),
            description: (0, $haZpO.default).jiraBusinessDescription
        },
        customer_service: undefined,
        service_desk: undefined,
        product_discovery: undefined
    });

});
parcelRegister("2Q5Ee", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2114d1ad49e5b359$var$_react = $2114d1ad49e5b359$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $2114d1ad49e5b359$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $2114d1ad49e5b359$var$CodeIcon = (props)=>/*#__PURE__*/ $2114d1ad49e5b359$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M14.155 4.055a1 1 0 00-1.271.62l-4.83 14.046a1 1 0 001.891.65l4.83-14.045a1 1 0 00-.62-1.271m-6.138 8.21l-2.58-2.501L8.236 7.05a.999.999 0 10-1.392-1.436l-3.54 3.432a1 1 0 000 1.436l3.32 3.219a1 1 0 101.393-1.436m12.219 1.568l-3.32-3.22a.999.999 0 10-1.393 1.437l2.58 2.5-2.799 2.715a.999.999 0 101.392 1.436l3.54-3.432a1 1 0 000-1.436" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$2114d1ad49e5b359$var$CodeIcon.displayName = 'CodeIcon';
var $2114d1ad49e5b359$var$_default = $2114d1ad49e5b359$var$CodeIcon;
module.exports.default = $2114d1ad49e5b359$var$_default;

});

parcelRegister("1kt3H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0f7e332bc6256e33$var$_react = $0f7e332bc6256e33$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $0f7e332bc6256e33$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $0f7e332bc6256e33$var$SuitcaseIcon = (props)=>/*#__PURE__*/ $0f7e332bc6256e33$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M17 14h2V9H5v5h2v-1a1 1 0 012 0v1h6v-1a1 1 0 012 0v1zm0 2v1a1 1 0 01-2 0v-1H9v1a1 1 0 01-2 0v-1H5v3h14v-3h-2zM9 7h6V6H9v1zM7 7V5a1 1 0 011-1h8a1 1 0 011 1v2h2a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V9a2 2 0 012-2h2z"/></svg>`
    }, props));
$0f7e332bc6256e33$var$SuitcaseIcon.displayName = 'SuitcaseIcon';
var $0f7e332bc6256e33$var$_default = $0f7e332bc6256e33$var$SuitcaseIcon;
module.exports.default = $0f7e332bc6256e33$var$_default;

});

parcelRegister("8B4Rm", function(module, exports) {
module.exports = new URL("Azure.add6b4f5.svg", import.meta.url).toString();

});

parcelRegister("5MtDo", function(module, exports) {
module.exports = new URL("GitLab.af604b0d.svg", import.meta.url).toString();

});

parcelRegister("fIcqL", function(module, exports) {
module.exports = new URL("JetbrainsYouTrack.c4874903.svg", import.meta.url).toString();

});

parcelRegister("bQHSh", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c3f863466fd615b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $juktg = parcelRequire("juktg");
const $7c3f863466fd615b$var$NotionIcon = ()=>{
    const { colorMode: colorMode } = (0, $juktg.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        clipPath: "url(#clip0_2574_18970)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        clipPath: "url(#clip1_2574_18970)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.49653 4.27103C5.23916 4.87439 5.51775 4.82836 6.91231 4.7353L20.0592 3.94589C20.3381 3.94589 20.1062 3.66772 20.0132 3.6215L17.8298 2.04305C17.4114 1.71824 16.8541 1.34626 15.7858 1.43932L3.05556 2.36781C2.59129 2.41385 2.49857 2.64598 2.68345 2.83204L4.49653 4.27103ZM5.28585 7.33493V21.1678C5.28585 21.9112 5.65735 22.1894 6.4935 22.1434L20.942 21.3073C21.7786 21.2613 21.8718 20.75 21.8718 20.1461V6.40601C21.8718 5.80308 21.6398 5.47793 21.1277 5.52434L6.0289 6.40601C5.47167 6.45284 5.2858 6.73157 5.2858 7.33493H5.28585ZM19.5494 8.07695C19.642 8.49514 19.5494 8.91296 19.1304 8.95998L18.4342 9.09869V19.311C17.8298 19.6359 17.2724 19.8216 16.808 19.8216C16.0644 19.8216 15.8781 19.5893 15.3211 18.8934L10.7675 11.7447V18.6613L12.2084 18.9864C12.2084 18.9864 12.2084 19.8216 11.0459 19.8216L7.84095 20.0075C7.74785 19.8216 7.84095 19.3578 8.16604 19.2649L9.00238 19.0331V9.88806L7.84118 9.795C7.74803 9.37681 7.97998 8.77383 8.63088 8.72705L12.069 8.49529L16.808 15.737V9.33078L15.5997 9.19212C15.507 8.68087 15.8781 8.30965 16.3428 8.26362L19.5494 8.07695ZM1.98671 1.11455L15.2282 0.139408C16.8542 -5.19529e-05 17.2726 0.0933756 18.2946 0.835771L22.5215 3.80662C23.2189 4.31749 23.4514 4.45657 23.4514 5.01347V21.3073C23.4514 22.3285 23.0794 22.9324 21.7788 23.0248L6.40148 23.9534C5.42517 23.9999 4.96052 23.8608 4.44923 23.2105L1.33652 19.172C0.778824 18.4285 0.546875 17.8724 0.546875 17.2217V2.73866C0.546875 1.90359 0.918988 1.20699 1.98671 1.11455Z",
        fill: colorMode === 'dark' ? 'white' : 'black'
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip0_2574_18970"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "24",
        height: "24",
        fill: colorMode === 'dark' ? 'black' : 'white'
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip1_2574_18970"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "24",
        height: "24",
        fill: colorMode === 'dark' ? 'black' : 'white'
    }))));
};
var $7c3f863466fd615b$export$2e2bcd8739ae039 = $7c3f863466fd615b$var$NotionIcon;

});

parcelRegister("jH66N", function(module, exports) {
module.exports = new URL("Wrike.67006734.svg", import.meta.url).toString();

});

parcelRegister("haZpO", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cf7e5e0b74158b8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8cf7e5e0b74158b8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    jiraSoftwareName: {
        "id": "project-create-importer-upload-flow.common.constants.source-items.jira-software-name",
        "defaultMessage": "Jira (software project)"
    },
    jiraBusinessName: {
        "id": "project-create-importer-upload-flow.common.constants.source-items.jira-business-name",
        "defaultMessage": "Jira (business project)"
    },
    jiraSoftware: {
        "id": "project-create-importer-upload-flow.common.constants.source-items.jira-software",
        "defaultMessage": "Software project"
    },
    jiraSoftwareDescription: {
        "id": "project-create-importer-upload-flow.common.constants.source-items.jira-software-description",
        "defaultMessage": "Designed to plan, track, release, and support software development."
    },
    jiraBusiness: {
        "id": "project-create-importer-upload-flow.common.constants.source-items.jira-business",
        "defaultMessage": "Business project"
    },
    jiraBusinessDescription: {
        "id": "project-create-importer-upload-flow.common.constants.source-items.jira-business-description",
        "defaultMessage": "Designed for business teams across marketing, operations, sales, HR, finance, legal, and design."
    }
});

});


parcelRegister("38ThW", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6e176e28b798c80$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c6e176e28b798c80$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    uploadScreenDescription: {
        "id": "project-create-importer-upload-flow.common.utils.get-content-for-csv.upload-screen-description",
        "defaultMessage": "Start by finding the <b>Download</b> or <b>Export</b> option on your app and export a CSV file. You will need to <link>structure the CSV</link> and upload it to begin the import. Structuring the file will help avoid errors and ensure that the data is in the right format."
    },
    uploadScreenCustomisedDescription: {
        "id": "project-create-importer-upload-flow.common.utils.get-content-for-csv.upload-screen-customised-description",
        "defaultMessage": "Let's bring your data into Jira. Upload a CSV file from {importType} to begin your import."
    },
    setupProjectScreenDescription: {
        "id": "project-create-importer-upload-flow.common.utils.get-content-for-csv.setup-project-screen-description",
        "defaultMessage": "Your team\u2019s data will be imported into this project. Check if you\u2019re selecting the right Jira project, template, and project type as these options can\u2019t be modified later."
    },
    setupProjectScreenCustomisedDescription: {
        "id": "project-create-importer-upload-flow.common.utils.get-content-for-csv.setup-project-screen-customised-description",
        "defaultMessage": "Your team\u2019s data from {importType} will be imported into this project. Check if you\u2019re selecting the right Jira project, template, and project type as these options can\u2019t be modified later."
    },
    usersMappingScreenColumnHeader: {
        "id": "project-create-importer-upload-flow.common.utils.get-content-for-csv.users-mapping-screen-column-header",
        "defaultMessage": "Users in CSV"
    },
    usersMappingScreenCustomisedColumnHeader: {
        "id": "project-create-importer-upload-flow.common.utils.get-content-for-csv.users-mapping-screen-customised-column-header",
        "defaultMessage": "Users from {importType}"
    },
    fieldMappingDescription: {
        "id": "project-create-importer-upload-flow.common.utils.get-content-for-csv.field-mapping-description",
        "defaultMessage": "We\u2019ve tried to map columns from the CSV file to Jira fields. Organize how your data is presented by verifying and mapping any remaining columns. <link>Read about mapping data</link>"
    },
    fieldMappingCustomisedDescription: {
        "id": "project-create-importer-upload-flow.common.utils.get-content-for-csv.field-mapping-customised-description",
        "defaultMessage": "We\u2019ve automatically mapped a few columns from the CSV file to Jira fields. Organize how your data is presented by verifying and mapping any remaining columns. Read about mapping {importType} data to Jira fields"
    },
    fieldMappingTableHeading: {
        "id": "project-create-importer-upload-flow.common.utils.get-content-for-csv.field-mapping-table-heading",
        "defaultMessage": "Columns in CSV"
    },
    fieldMappingTableCustomisedHeading: {
        "id": "project-create-importer-upload-flow.common.utils.get-content-for-csv.field-mapping-table-customised-heading",
        "defaultMessage": "Columns in {importType} CSV"
    }
});

});


parcelRegister("7k17U", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf7215459d67c75f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $bf7215459d67c75f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    importedUser: {
        "id": "project-create-importer-upload-flow.csv-user-mapping-screen.user-mapping-table.imported-user",
        "defaultMessage": "Users moving to Jira ({numberOfUsers})"
    },
    textFieldPlaceholder: {
        "id": "project-create-importer-upload-flow.csv-user-mapping-screen.user-mapping-table.text-field-placeholder",
        "defaultMessage": "Enter email"
    },
    textFieldLabel: {
        "id": "project-create-importer-upload-flow.csv-user-mapping-screen.user-mapping-table.text-field-label",
        "defaultMessage": "Enter email for {name}"
    },
    noUsers: {
        "id": "project-create-importer-upload-flow.csv-user-mapping-screen.user-mapping-table.no-users",
        "defaultMessage": "There are no users in your CSV"
    }
});

});



parcelRegister("11Kyb", function(module, exports) {

$parcel$export(module.exports, "ImportInProgressScreen", () => $86441108214ab1ad$export$336b87394b7499f9);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bLFgh = parcelRequire("bLFgh");
var $7u4fN = parcelRequire("7u4fN");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $lRvnl = parcelRequire("lRvnl");

var $5xIu6 = parcelRequire("5xIu6");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $cpweK = parcelRequire("cpweK");
var $516Dl = parcelRequire("516Dl");
var $5GSA7 = parcelRequire("5GSA7");
var $acCHb = parcelRequire("acCHb");
var $3tVfR = parcelRequire("3tVfR");

var $dWLk9 = parcelRequire("dWLk9");
var $gd0Sp = parcelRequire("gd0Sp");

var $66xY8 = parcelRequire("66xY8");

var $PZvef = parcelRequire("PZvef");

var $kzTj7 = parcelRequire("kzTj7");

var $3yuWi = parcelRequire("3yuWi");

var $3EVB9 = parcelRequire("3EVB9");

var $1T7vu = parcelRequire("1T7vu");

var $cDLTA = parcelRequire("cDLTA");
var $aWLVm = parcelRequire("aWLVm");

var $jNdPf = parcelRequire("jNdPf");

var $bz2yd = parcelRequire("bz2yd");

var $4uta0 = parcelRequire("4uta0");
var $d0wrd = parcelRequire("d0wrd");

var $2sRUp = parcelRequire("2sRUp");

var $fiH3o = parcelRequire("fiH3o");

var $aGmSP = parcelRequire("aGmSP");

var $kVstV = parcelRequire("kVstV");

var $hReaD = parcelRequire("hReaD");
const $86441108214ab1ad$var$BASE_POLLING_INTERVAL_MS = 2000;
const $86441108214ab1ad$var$ERROR_HEADING_ID = 'import-error';
const $86441108214ab1ad$var$IN_PROGRESS_HEADING_ID = 'import-in-progress';
const $86441108214ab1ad$var$FEEDBACK_GROUP_ID = 'x2c-post-import-feedback';
const $86441108214ab1ad$export$8ad01d79632f569b = (url)=>{
    window.location.href = url;
};
const $86441108214ab1ad$export$336b87394b7499f9 = ({ hasProgressBar: hasProgressBar = false, hasImportUsers: hasImportUsers = true, thirdParty: thirdParty, showCrossButton: showCrossButton = false, isCompact: isCompact = false, onCloseAndReturnToUploadStep: onCloseAndReturnToUploadStep, onDrawerClose: onDrawerClose })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const { isSiteAdmin: isSiteAdmin } = (0, $gd0Sp.useTenantContext)();
    const [migrationId, { setMigrationId: setMigrationId, setMappingState: setMappingState, setUploadedFileName: setUploadedFileName }] = (0, $4uta0.useMigrationId)();
    const { removeMigrationId: removeMigrationId } = (0, $acCHb.useMigrationIdManager)();
    const [{ key: key, style: style, name: name }] = (0, $d0wrd.useProjectData)();
    const errorLogFileName = (0, $cpweK.useErrorLogFileName)(name);
    const analyticsAttributes = (0, $jNdPf.useAnalyticsAttributesContext)();
    const { migrationStatus: { overallStatus: overallStatus, detailedProgress: { dataTransformStatus: dataTransformStatus, userImportStatus: userImportStatus, projectCreateStatus: projectCreateStatus }, hasErrorLogs: hasErrorLogs } } = (0, $3tVfR.usePollMigrationStatus)(migrationId, $86441108214ab1ad$var$BASE_POLLING_INTERVAL_MS);
    const [onExperienceStart, onExperienceSuccess, onExperienceFail] = (0, $5GSA7.useExperienceTracker)((0, $3yuWi.EXPERIENCES).IMPORT_PART_1);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [source] = (0, $2sRUp.useSource)();
    const { productSteps: productSteps, currentStepIndex: currentStepIndex } = (0, $fiH3o.useProductSteps)();
    const { importStep1Description: importStep1Description, rateLimitWarning: rateLimitWarning } = (0, $cDLTA.useContentForThirdParty)(thirdParty);
    const { rateLimitURL: rateLimitURL } = (0, $aWLVm.useUrlForThirdParty)(thirdParty);
    const [{ type: type }] = (0, $d0wrd.useProjectData)();
    const { importInProgressHeading: importInProgressHeading, importInProgressDescription: importInProgressDescription, importInProgressProjectStep: importInProgressProjectStep, importInProgressErrorHeading: importInProgressErrorHeading, closeButtonLabel: closeButtonLabel, importInProgressTroubleshootLink: importInProgressTroubleshootLink } = (0, $bz2yd.useProjectSpecificContent)(type, source);
    const [isFeedbackModalOpen, setIsFeedbackModalOpen] = (0, $eUqFw.useState)(false);
    const openFeedbackModal = (0, $5xIu6.useFeedbackCollector)();
    const onSubmitFeedbackClick = (0, $eUqFw.useCallback)(()=>{
        const uiEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'clickX2CPostImportFeedback'
        });
        (0, $jMP2a.fireUIAnalytics)(uiEvent);
        setIsFeedbackModalOpen(true);
        openFeedbackModal($86441108214ab1ad$var$FEEDBACK_GROUP_ID, ()=>setIsFeedbackModalOpen(false));
    }, [
        createAnalyticsEvent,
        openFeedbackModal
    ]);
    const resetStore = (0, $eUqFw.useCallback)(()=>{
        setMigrationId(null);
        setMappingState(null);
        setUploadedFileName(null);
    }, [
        setMappingState,
        setMigrationId,
        setUploadedFileName
    ]);
    const handleStartNewImport = (0, $eUqFw.useCallback)(()=>{
        const uiEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'clickX2CStartNewImport'
        });
        (0, $jMP2a.fireUIAnalytics)(uiEvent);
        onCloseAndReturnToUploadStep();
    }, [
        createAnalyticsEvent,
        onCloseAndReturnToUploadStep
    ]);
    const handleDownloadLogsClick = (0, $eUqFw.useCallback)(()=>{
        const uiEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'downloadX2CLogsLink'
        });
        (0, $jMP2a.fireUIAnalytics)(uiEvent);
    }, [
        createAnalyticsEvent
    ]);
    const handleOnCloseImportWindow = (0, $eUqFw.useCallback)((e)=>{
        const uiEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'closeX2CImportWindow'
        });
        (0, $jMP2a.fireUIAnalytics)(uiEvent);
        onDrawerClose && onDrawerClose(e, uiEvent);
    }, [
        createAnalyticsEvent,
        onDrawerClose
    ]);
    const hasFailed = overallStatus === (0, $516Dl.Status).FAILED || dataTransformStatus === (0, $516Dl.Status).FAILED || userImportStatus === (0, $516Dl.Status).FAILED || projectCreateStatus === (0, $516Dl.Status).FAILED;
    (0, $eUqFw.useEffect)(()=>{
        onExperienceStart();
    }, [
        onExperienceStart
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if ((projectCreateStatus === (0, $516Dl.Status).SUCCESS || overallStatus === (0, $516Dl.Status).SUCCESS) && (!(0, $eI5EY.fg)('enable-x2c-standardised-flow') || !isFeedbackModalOpen)) {
            resetStore();
            onExperienceSuccess({
                migrationId: migrationId,
                thirdParty: thirdParty || '',
                ...analyticsAttributes
            }); /*
           * Redirect to newly created project
           * Note: using react router push does not close project create draw.
           */ 
            $86441108214ab1ad$export$8ad01d79632f569b(`${(0, $kzTj7.PROJECT_ROUTE_PREFIX)}/${key}`);
        }
    }, [
        key,
        onExperienceSuccess,
        overallStatus,
        projectCreateStatus,
        analyticsAttributes,
        resetStore,
        migrationId,
        thirdParty,
        isFeedbackModalOpen
    ]);
    const getErrorMessage = (0, $eUqFw.useCallback)(()=>{
        if (dataTransformStatus === (0, $516Dl.Status).FAILED) return 'Data Transform Failed';
        if (userImportStatus === (0, $516Dl.Status).FAILED) return 'User Import Failed';
        if (projectCreateStatus === (0, $516Dl.Status).FAILED) return 'Project Create Failed';
        return 'Overall Import Failed';
    }, [
        dataTransformStatus,
        projectCreateStatus,
        userImportStatus
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (hasFailed) {
            onExperienceFail((0, $kzTj7.APP_IDENTIFIER), {
                name: 'Import Failed',
                message: getErrorMessage()
            }, {
                migrationId: migrationId,
                thirdParty: thirdParty || '',
                ...analyticsAttributes
            });
            removeMigrationId(key);
        }
    }, [
        analyticsAttributes,
        getErrorMessage,
        hasFailed,
        key,
        migrationId,
        onExperienceFail,
        removeMigrationId,
        style,
        thirdParty
    ]);
    const progressBarComponent = (0, $eUqFw.useMemo)(()=>{
        if ((0, $eI5EY.fg)('enable-x2c-standardised-flow')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, hasProgressBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1T7vu.ProgressBarStandard), {
            productSteps: productSteps,
            currentStepIndex: currentStepIndex,
            onClose: onCloseAndReturnToUploadStep,
            showCrossButton: showCrossButton
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $86441108214ab1ad$var$paddingForProgressBar
        })));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, showCrossButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aGmSP.CrossButton), {
            onClose: onCloseAndReturnToUploadStep,
            label: formatMessage(closeButtonLabel)
        }), hasProgressBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1T7vu.StepProgressBar), {
            productSteps: productSteps,
            currentStepIndex: currentStepIndex
        }));
    }, [
        showCrossButton,
        onCloseAndReturnToUploadStep,
        formatMessage,
        closeButtonLabel,
        hasProgressBar,
        productSteps,
        currentStepIndex
    ]);
    if (hasFailed) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($86441108214ab1ad$var$ErrorScreenWrapper, {
        isCompact: isCompact
    }, showCrossButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aGmSP.CrossButton), {
        onClose: onCloseAndReturnToUploadStep,
        label: formatMessage(closeButtonLabel)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3EVB9.CloseAndReturnButton), {
        shouldShowCancelModal: false,
        onCloseAndReturnToUploadStep: onCloseAndReturnToUploadStep
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($86441108214ab1ad$var$Wrapper, {
        isCompact: isCompact
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($86441108214ab1ad$var$Illustration, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($66xY8))),
        "aria-describedby": $86441108214ab1ad$var$ERROR_HEADING_ID,
        role: "img",
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($86441108214ab1ad$var$Heading, {
        id: $86441108214ab1ad$var$ERROR_HEADING_ID
    }, formatMessage(importInProgressErrorHeading)), migrationId && hasErrorLogs ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($86441108214ab1ad$var$ErrorDescription, null, formatMessage((0, $hReaD.default).advanceErrorDesc, {
        br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null),
        link: (children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                href: (0, $kzTj7.CONTACT_SUPPORT_URL),
                target: "_blank"
            }, children)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($86441108214ab1ad$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($86441108214ab1ad$var$TroubleshootButton, {
        href: importInProgressTroubleshootLink,
        target: "_blank"
    }, formatMessage((0, $hReaD.default).viewTroubleshootingPage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "primary",
        onClick: handleDownloadLogsClick,
        href: (0, $cpweK.createDownloadLogsUrl)({
            cloudId: cloudId,
            migrationId: migrationId,
            fileName: errorLogFileName
        }),
        download: errorLogFileName
    }, formatMessage((0, $hReaD.default).downloadLog)))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($86441108214ab1ad$var$ErrorDescription, null, formatMessage((0, $hReaD.default).errorDescription, {
        br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($86441108214ab1ad$var$ContactSupportButton, {
        appearance: "primary",
        href: (0, $kzTj7.CONTACT_SUPPORT_URL),
        target: "_blank"
    }, formatMessage((0, $hReaD.default).contactSupport)))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: (0, $3yuWi.X2C_SCREENS).IMPORT_IN_PROGRESS,
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        attributes: {
            thirdParty: thirdParty || ''
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($86441108214ab1ad$var$Wrapper, {
        "data-testid": "project-create-importer-upload-flow.ui.import-in-progress-screen.wrapper",
        hasProgressBar: hasProgressBar,
        isCompact: isCompact
    }, progressBarComponent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($86441108214ab1ad$var$Illustration, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($PZvef))),
        "aria-describedby": $86441108214ab1ad$var$IN_PROGRESS_HEADING_ID,
        role: "img",
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($86441108214ab1ad$var$Heading, {
        id: $86441108214ab1ad$var$IN_PROGRESS_HEADING_ID
    }, formatMessage(importInProgressHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($86441108214ab1ad$var$Description, null, formatMessage(importInProgressDescription, {
        br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($86441108214ab1ad$var$DetailsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kVstV.ImportStepProgress), {
        status: dataTransformStatus,
        description: thirdParty ? importStep1Description : formatMessage((0, $hReaD.default).verifyingCsvData)
    }), hasImportUsers && isSiteAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kVstV.ImportStepProgress), {
        status: userImportStatus,
        description: formatMessage((0, $hReaD.default).userImport)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kVstV.ImportStepProgress), {
        status: projectCreateStatus,
        description: formatMessage(importInProgressProjectStep)
    })), rateLimitWarning && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $86441108214ab1ad$var$sectionMessageStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        testId: "project-create-importer-upload-flow.ui.import-in-progress-screen.rate-limit-warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage(rateLimitWarning, {
        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                href: rateLimitURL,
                target: "_blank"
            }, chunks)
    })))), (0, $eI5EY.fg)('enable-x2c-standardised-flow') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $86441108214ab1ad$var$startNewImportStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: handleStartNewImport,
        appearance: "primary",
        testId: "project-create-importer-upload-flow.ui.import-in-progress-screen.start-new-import-button"
    }, formatMessage((0, $hReaD.default).startNewImport))), onDrawerClose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "project-create-importer-upload-flow.ui.import-in-progress-screen.close-import-button",
        onClick: handleOnCloseImportWindow
    }, formatMessage((0, $hReaD.default).closeImportWindow))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $86441108214ab1ad$var$paddingForFeedbackModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "project-create-importer-upload-flow.ui.import-in-progress-screen.feedback-button",
        appearance: "link",
        spacing: "compact",
        onClick: onSubmitFeedbackClick
    }, formatMessage((0, $hReaD.default).submitFeedbackCallToAction)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $86441108214ab1ad$var$ErrorScreenWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCompact: isCompact, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1n261q9c _4t3i1osq _1bsb1osq _vchhusvi _1yt41avh _11381ns9",
            __cmplp.isCompact ? "_bfhk1kw7" : "_bfhk1j9a",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $86441108214ab1ad$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasProgressBar: hasProgressBar, isCompact: isCompact, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1n261q9c _4cvr1h6o _1bsb1osq _vchhusvi _n3td1ejb _19bv1epz _u5f31epz _13w3oahv",
            __cmplp.hasProgressBar ? "_ca0qoahv" : "_ca0q1epz",
            __cmplp.isCompact ? "_bfhk1kw7" : "_bfhk1j9a",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $86441108214ab1ad$var$Illustration = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1to9 _c71lo812 _1bsb1ssb _4t3i1ssb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $86441108214ab1ad$var$Heading = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h1", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48pni7l _1wybgktf _vwz4zwfg _19pkpxbi _otyru2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $86441108214ab1ad$var$Description = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $86441108214ab1ad$var$DetailsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _19pk1ejb _otyr1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $86441108214ab1ad$var$ErrorDescription = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $86441108214ab1ad$var$ButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _19pk1jfw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $86441108214ab1ad$var$TroubleshootButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $86441108214ab1ad$var$ContactSupportButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1ejb",
            __cmplp.className
        ])
    });
});
const $86441108214ab1ad$var$paddingForProgressBar = (0, $1ZAYh.xcss)({
    paddingTop: 'space.1000'
});
const $86441108214ab1ad$var$paddingForFeedbackModal = (0, $1ZAYh.xcss)({
    paddingTop: 'space.200'
});
const $86441108214ab1ad$var$startNewImportStyles = (0, $1ZAYh.xcss)({
    marginRight: 'space.075'
});
const $86441108214ab1ad$var$sectionMessageStyles = (0, $1ZAYh.xcss)({
    paddingBottom: 'space.200'
});

});
parcelRegister("5xIu6", function(module, exports) {

$parcel$export(module.exports, "useFeedbackCollector", () => $41c842a9ff9149b0$export$4be696be8a3bff13);

var $eUqFw = parcelRequire("eUqFw");

var $1c02D = parcelRequire("1c02D");
var $irg9D = parcelRequire("irg9D");

var $5JgJ2 = parcelRequire("5JgJ2");

var $10fdS = parcelRequire("10fdS");

var $bNe1g = parcelRequire("bNe1g");

var $c7H0g = parcelRequire("c7H0g");
var $gd0Sp = parcelRequire("gd0Sp");

var $6YoSc = parcelRequire("6YoSc");

var $loHEm = parcelRequire("loHEm");
const $41c842a9ff9149b0$export$698ff856156a88fe = /*#__PURE__*/ (0, $eUqFw.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $6YoSc.default).canContactPrompt), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        href: "https://www.atlassian.com/legal/privacy-policy",
        target: "_blank",
        rel: "noopener noreferrer"
    }, formatMessage((0, $6YoSc.default).canContactPromptLink)));
});
const $41c842a9ff9149b0$export$4f77effad9540593 = /*#__PURE__*/ (0, $eUqFw.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $6YoSc.default).enrollInResearchPrompt, {
        link: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
            href: "https://www.atlassian.com/research-group",
            target: "_blank",
            rel: "noopener noreferrer"
        }, formatMessage((0, $6YoSc.default).enrollInResearchLink))
    }));
});
const $41c842a9ff9149b0$export$4be696be8a3bff13 = ({ projectType: projectType = 'business' } = {})=>{
    const { openFeedbackCollector: openFeedbackCollector } = (0, $irg9D.useFeedbackCollectorActions)();
    const { licensedProducts: licensedProducts } = (0, $gd0Sp.useTenantContext)();
    const route = (0, $10fdS.useCurrentRoute)();
    const { data: project } = (0, $bNe1g.useProjectContext)();
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const getFeedbackContext = (0, $eUqFw.useCallback)((feedbackGroupId)=>{
        const baseFeedbackContext = [
            {
                id: (0, $1c02D.EntryKeys).INLINE_FEEDBACK_ID,
                value: feedbackGroupId
            },
            {
                id: (0, $1c02D.EntryKeys).ROUTE_NAME,
                value: route.name ?? 'unknown'
            },
            {
                id: (0, $1c02D.EntryKeys).ROUTE_GROUP,
                value: route.group ?? 'unknown'
            },
            {
                id: (0, $1c02D.EntryKeys).IS_ADMIN,
                value: isAdmin
            },
            {
                id: (0, $1c02D.EntryKeys).PROJECT_TYPE,
                value: project?.projectType || projectType
            },
            {
                id: (0, $1c02D.EntryKeys).SUPPORTED_PROJECT_TYPES,
                value: (0, $loHEm.licensedProductsToString)(licensedProducts)
            }
        ];
        // Only send project specific information if project is available
        if (project) baseFeedbackContext.push({
            id: (0, $1c02D.EntryKeys).IS_SIMPLIFIED_PROJECT,
            value: project.simplified
        });
        return baseFeedbackContext;
    }, [
        isAdmin,
        licensedProducts,
        project,
        projectType,
        route.group,
        route.name
    ]);
    return (0, $eUqFw.useCallback)((feedbackGroupId, onClose, triggerRef)=>{
        const feedbackContext = getFeedbackContext(feedbackGroupId);
        openFeedbackCollector({
            entrypointId: (0, $1c02D.ENTRYPOINT_ID_JIRA_PLATFORM),
            feedbackGroupId: feedbackGroupId,
            canBeContactedLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($41c842a9ff9149b0$export$698ff856156a88fe, null),
            enrolInResearchLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($41c842a9ff9149b0$export$4f77effad9540593, null),
            feedbackContext: feedbackContext,
            onClose: onClose,
            ...triggerRef != null ? {
                triggerRef: triggerRef
            } : {}
        });
    }, [
        getFeedbackContext,
        openFeedbackCollector
    ]);
};

});
parcelRegister("1c02D", function(module, exports) {

$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PLATFORM", () => $ccbba0a7f0f3304b$export$baea5c8192e79adc);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT", () => $ccbba0a7f0f3304b$export$4eda1e3a4a311d13);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_PRODUCT_DISCOVERY", () => $ccbba0a7f0f3304b$export$5fb38521eb7ad63c);
$parcel$export(module.exports, "ENTRYPOINT_ID_THEME_JSM_INSIGHT_CMDB", () => $ccbba0a7f0f3304b$export$345c45dd28f28a32);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_COMMAND_PALETTE", () => $ccbba0a7f0f3304b$export$8962f2e618411469);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_VIEW", () => $ccbba0a7f0f3304b$export$7d7f2319141db3c5);
$parcel$export(module.exports, "ENTRYPOINT_ID_JIRA_ISSUE_NAVIGATOR", () => $ccbba0a7f0f3304b$export$4725635e6fe1907a);
$parcel$export(module.exports, "ENTRY_POINT_ID_GENERATIVE_AI", () => $ccbba0a7f0f3304b$export$3a50f2efd6cfd6f3);
$parcel$export(module.exports, "ENTRY_POINT_ID_COMPASS", () => $ccbba0a7f0f3304b$export$b4de0744c1fd450d);
$parcel$export(module.exports, "ENTRY_POINT_ID_JSM_ASSETS_REPORTING", () => $ccbba0a7f0f3304b$export$1a7c42187130faf9);
$parcel$export(module.exports, "ENTRY_POINT_ID_JSM_VIRTUAL_AGENT", () => $ccbba0a7f0f3304b$export$e84c34a7e1dbcf78);
$parcel$export(module.exports, "EntryKeys", () => $ccbba0a7f0f3304b$export$12d01b6c311a909a);
// Jira platform project feedback JSD widget configuration
// https://customerfeedback.atlassian.net/jira/servicedesk/projects/JGF/queues/custom/448
const $ccbba0a7f0f3304b$export$baea5c8192e79adc = '1ff0a150-1d4f-4225-8e7b-3577fb9d9764';
const $ccbba0a7f0f3304b$export$4eda1e3a4a311d13 = 'f60db8bd-1904-4af4-a0ef-f140598ebada';
const $ccbba0a7f0f3304b$export$5fb38521eb7ad63c = '3508b77a-0aa1-4ad5-a397-621bd308c828';
const $ccbba0a7f0f3304b$export$4a288e389131b3de = 'b6176efc-e703-426b-b4f8-3e43ce4aa0db';
const $ccbba0a7f0f3304b$export$345c45dd28f28a32 = 'cdb5199a-4c4e-4692-b006-4e2628ed4771';
const $ccbba0a7f0f3304b$export$8962f2e618411469 = '3d204590-d14a-419f-a042-f0b1a92e005b';
const $ccbba0a7f0f3304b$export$7d7f2319141db3c5 = 'af9ace2f-61a9-45ac-8e67-b54f74246b94';
const $ccbba0a7f0f3304b$export$4725635e6fe1907a = 'cd375e0e-ae56-4a2f-bad8-6114c617bf2f';
const $ccbba0a7f0f3304b$export$3a50f2efd6cfd6f3 = '73cf1eae-42a3-418a-a7ac-976ba0b5735d';
const $ccbba0a7f0f3304b$export$b4de0744c1fd450d = 'e6321572-aa72-47b3-b261-e142b81ad4b2';
const $ccbba0a7f0f3304b$export$1a7c42187130faf9 = 'b4ac51f3-c235-4f9e-97d0-d450e76aa13a';
const $ccbba0a7f0f3304b$export$e84c34a7e1dbcf78 = '1b1c9a31-ebef-44b4-9eaa-4ee884672259';
const $ccbba0a7f0f3304b$export$12d01b6c311a909a = Object.freeze({
    CLOUD_ID: 'cloud-id',
    OPT_OUT: 'Opt-out',
    REASON: 'reason',
    FEELING: 'feeling',
    IS_ADMIN: 'is-admin',
    IS_SITE_ADMIN: 'is-site-admin',
    IS_PROJECT_SETTINGS: 'is-project-settings',
    INLINE_FEEDBACK_ID: 'inlineFeedbackId',
    IS_JSD_EVALUATOR: 'is-jsd-evaluator',
    IS_SIMPLIFIED_PROJECT: 'is-simplified-project',
    SUPPORTED_PROJECT_TYPES: 'supported-project-types',
    FEEDBACK_COLLECTOR_LOCATION: 'feedback-collector-location',
    FEEDBACK_COLLECTOR_ID: 'feedback-collector-id',
    FEEDBACK_EMBEDDABLE_KEY: 'feedback-embeddable-key',
    LOCATION: 'Location',
    PROJECT_TYPE: 'project-type',
    BOARD_TYPE: 'board-type',
    REFERER: 'Referer',
    ROUTE_GROUP: 'route-group',
    ROUTE_NAME: 'route-name',
    USER_AGENT: 'User-Agent',
    SCREEN_RESOLUTION: 'Screen Resolution',
    SOURCE: 'Source',
    SUB_PRODUCT: 'Sub-product',
    JSM_REQUEST_TYPE_CHANGE_WORKFLOW: 'jsm-request-type-change-workflow',
    JSD_REQUEST_TYPE_REDESIGN: 'jsd-request-type-redesign',
    DEPLOYMENT_PROVIDERS: 'deployment-providers',
    JSM_QUEUES_SIDE_BAR: 'jsm-queue-side-bar',
    VERSION_CONTROL_PROVIDERS: 'version-control-providers',
    DEV_DETAILS_DIALOG_TAB: 'dev-details-dialog-tab',
    CODE_IN_JIRA_PROVIDERS: 'code-in-jira-providers',
    SECURITY_IN_JIRA_PROVIDERS: 'security-in-jira-providers',
    INCIDENTS_IN_JIRA_PROVIDERS: 'incidents-in-jira-providers',
    IS_ATLASKIT_FEEDBACK_COMPONENT: 'is-atlaskit-feedback-component',
    FEEDBACK_GROUP_ID: 'feedback-group-id',
    EDITION: 'edition',
    ENV: 'environment'
});

});

parcelRegister("irg9D", function(module, exports) {

$parcel$export(module.exports, "useFeedbackCollector", () => $8d3d8a971c5329dd$export$4be696be8a3bff13);
$parcel$export(module.exports, "useFeedbackCollectorActions", () => $8d3d8a971c5329dd$export$dfb2ee2d9e73fa48);
$parcel$export(module.exports, "FeedbackActionsSubscriber", () => $8d3d8a971c5329dd$export$c35dbf16ebe9df04);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");
const $8d3d8a971c5329dd$export$d4c72bab9d6cc13a = {
    isFeedbackCollectorOpen: false,
    entrypointId: undefined,
    email: undefined,
    additionalFields: undefined,
    feedbackTitle: undefined,
    feedbackContext: undefined,
    feedbackCollectorId: undefined,
    // default value of this prop is true so making sure inititally it is true
    showTypeField: true,
    submitButtonLabel: undefined,
    canBeContactedLabel: undefined,
    summaryPlaceholder: undefined,
    feedbackGroupLabels: undefined,
    onClose: undefined,
    feedbackTitleDetails: undefined,
    triggerRef: undefined,
    renderCustomContent: undefined
};
const $8d3d8a971c5329dd$export$e324594224ef24da = {
    openFeedbackCollector: (feedbackCollectorProps)=>({ setState: setState, dispatch: dispatch })=>{
            // Reset to initial state to clear any leftover state
            dispatch($8d3d8a971c5329dd$export$e324594224ef24da.resetFeedbackCollectorState());
            setState({
                ...feedbackCollectorProps,
                isFeedbackCollectorOpen: true
            });
        },
    closeFeedbackCollector: ()=>({ getState: getState, setState: setState })=>{
            const { triggerRef: triggerRef } = getState();
            if (triggerRef) // Unfortunately we need a setTimeout here to delay the execution cycle because modal is yet to be closed
            setTimeout(()=>triggerRef.current?.focus(), 50);
            setState({
                isFeedbackCollectorOpen: false,
                triggerRef: undefined
            });
        },
    resetFeedbackCollectorState: ()=>({ setState: setState })=>{
            setState({
                ...$8d3d8a971c5329dd$export$d4c72bab9d6cc13a
            });
        },
    updateCustomRenderComponent: (updatedCustomRenderContent)=>({ setState: setState })=>{
            setState({
                renderCustomContent: updatedCustomRenderContent
            });
        },
    updateAdditionalFields: (updatedAdditionalFields)=>({ setState: setState })=>{
            setState({
                additionalFields: updatedAdditionalFields
            });
        }
};
const $8d3d8a971c5329dd$var$Store = (0, $a61MH.createStore)({
    name: 'feedback-collector',
    initialState: $8d3d8a971c5329dd$export$d4c72bab9d6cc13a,
    actions: $8d3d8a971c5329dd$export$e324594224ef24da
});
const $8d3d8a971c5329dd$export$4be696be8a3bff13 = (0, $ggKAj.createHook)($8d3d8a971c5329dd$var$Store);
const $8d3d8a971c5329dd$export$dfb2ee2d9e73fa48 = (0, $ggKAj.createActionsHook)($8d3d8a971c5329dd$var$Store);
const $8d3d8a971c5329dd$export$c35dbf16ebe9df04 = (0, $dYfll.createSubscriber)($8d3d8a971c5329dd$var$Store, {
    selector: null
});

});

parcelRegister("bNe1g", function(module, exports) {

$parcel$export(module.exports, "useProjectContext", () => $a10c8c1f49371370$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useIsSimplifiedProject", () => $a10c8c1f49371370$export$524ef4f6102ed540);
$parcel$export(module.exports, "ProjectContextProvider", () => $a10c8c1f49371370$export$a85f6b5857d2176);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $OUdnA = parcelRequire("OUdnA");

var $dUsMe = parcelRequire("dUsMe");
var $iZJHG = parcelRequire("iZJHG");

var $3HCkE = parcelRequire("3HCkE");

var $ixwgj = parcelRequire("ixwgj");
const $a10c8c1f49371370$var$useProjectContextNew = (customContext)=>{
    // TODO remove useInitFetchResource() wrapper on 'jira.call-useinitfetchresource-from-useresourcewithcustomroutercontext_hiyz0' FF cleanup
    const { data: data, error: error, loading: loading, update: update, key: key } = (0, $dUsMe.useInitFetchResource)((0, $iZJHG.useResourceWithCustomRouterContext)((0, $ixwgj.projectContextResourceWithCache), customContext), !customContext || (0, $1ybV0.ff)('jira.call-useinitfetchresource-from-useresourcewithcustomroutercontext_hiyz0'));
    const updateCache = (0, $eUqFw.useCallback)((d)=>update(()=>d), [
        update
    ]);
    return {
        data: data,
        error: error,
        loading: loading,
        updateCache: updateCache,
        key: key
    };
};
const $a10c8c1f49371370$var$useProjectContextOld = (_)=>{
    const { data: data, error: error, loading: loading, update: update, key: key } = (0, $3HCkE.useResource)((0, $ixwgj.projectContextResourceWithCache));
    const updateCache = (0, $eUqFw.useCallback)((d)=>update(()=>d), [
        update
    ]);
    return {
        data: data,
        error: error,
        loading: loading,
        updateCache: updateCache,
        key: key
    };
};
const $a10c8c1f49371370$export$8f31c2503e1efa93 = (0, $OUdnA.functionWithFF)('passing-projectid-to-useisgettingstartedpageenabled', $a10c8c1f49371370$var$useProjectContextNew, $a10c8c1f49371370$var$useProjectContextOld);
const $a10c8c1f49371370$export$524ef4f6102ed540 = ()=>{
    const { data: data } = $a10c8c1f49371370$export$8f31c2503e1efa93();
    return data?.simplified || false;
};
const $a10c8c1f49371370$export$a85f6b5857d2176 = ({ children: children })=>{
    const projectContext = $a10c8c1f49371370$export$8f31c2503e1efa93();
    return children(projectContext);
};

});
parcelRegister("OUdnA", function(module, exports) {

$parcel$export(module.exports, "functionWithFF", () => $4f946782842d29a3$export$3b8cbae22108d228);

var $1ybV0 = parcelRequire("1ybV0");

var $8LJqN = parcelRequire("8LJqN");
const $4f946782842d29a3$export$3b8cbae22108d228 = (featureFlagName, functionTrue, functionFalse)=>(0, $8LJqN.functionWithCondition)(()=>(0, $1ybV0.ff)(featureFlagName), functionTrue, functionFalse);

});
parcelRegister("8LJqN", function(module, exports) {

$parcel$export(module.exports, "functionWithCondition", () => $96fc75653c9b207d$export$af3c0e82a18fc057);
/**
 * Returns one of functions depending on a boolean condition.
 * Both functions should have the same signature.
 * @see {@link functionUnionWithCondition} for functions with different return types
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $96fc75653c9b207d$export$af3c0e82a18fc057(condition, functionTrue, functionFalse) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const fnWithCondition = (...args)=>condition() ? functionTrue(...args) : functionFalse(...args);
    // Improvement: set name on a function. Requires external helper, not required for production
    return fnWithCondition;
}
function $96fc75653c9b207d$export$c41c28c1d883fcd5(condition, functionTrue, functionFalse) {
    // @ts-expect-error TS2345: Argument of type '(...args: C) => R2' is not assignable to parameter of type '(...args: C) => R1'.
    return $96fc75653c9b207d$export$af3c0e82a18fc057(condition, functionTrue, functionFalse);
}

});


parcelRegister("dUsMe", function(module, exports) {

$parcel$export(module.exports, "useInitFetchResource", () => $e60431eaa4374b0b$export$5b98692301d8680);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");
const $e60431eaa4374b0b$export$5b98692301d8680 = (resource, skipInitFetch = false)=>{
    const { data: data, loading: loading, error: error, refresh: refresh, ...rest } = resource;
    (0, $eUqFw.useEffect)(()=>{
        // skip init fetch resource when ff is off
        if (!(0, $1ybV0.ff)('fission-nav4-fetch-from-router_ma0x8') || skipInitFetch) return;
        if (!data && !loading && !error && refresh) refresh();
    // we only need this to happen only once at initial time. In addition, some resources return `data` = null when user does not have permissions etc., which makes all `data`, `loading` and `error` have falsy values.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return {
        data: data,
        loading: loading,
        error: error,
        refresh: refresh,
        ...rest
    };
};

});

parcelRegister("iZJHG", function(module, exports) {

$parcel$export(module.exports, "useResourceWithCustomRouterContext", () => $8cce526bdc89f636$export$61dad767cf446185);

var $1ybV0 = parcelRequire("1ybV0");

var $kJlBc = parcelRequire("kJlBc");
var $3HCkE = parcelRequire("3HCkE");

var $dUsMe = parcelRequire("dUsMe");
/**
 * DUMMY_ROUTE needs to be used by default, because `route` must not be undefined, it is required/used internally by RRR, e.g. in findRouterContext() on createRouterContext() call.
 * If `route` is undefined, those will throw runtime exceptions.
 * `project-sidebar-navigation-resource/software-cmp-nav-synchronizer/index.tsx` uses dummy route as well.
 *
 * Jfyi, createProjectRouteRouterContext() function in JSW uses dummy route, with :projectKey in its path (that resource fetch function uses)
 */ const $8cce526bdc89f636$var$DUMMY_ROUTE = {
    name: 'DUMMY_ROUTE_NAME',
    path: '/projects/:projectKey/dummyroute'
};
const $8cce526bdc89f636$export$61dad767cf446185 = (resource, customRouterContext)=>{
    let useResourceArgCustomContext;
    if (customRouterContext) {
        // NOTE: `route` must include /.../:paramKey/... in its url for all `matchParams` passed to the `createRouterContext`, otherwise they will be ignored. createRouterContext will throw an error if route is undefined: `route.path` is used in the library code at least.
        const { route: route = $8cce526bdc89f636$var$DUMMY_ROUTE, matchParams: matchParams } = customRouterContext;
        if (matchParams && Object.keys(matchParams).length > 0) useResourceArgCustomContext = {
            routerContext: (0, $kJlBc.createRouterContext)(route, {
                params: matchParams
            })
        };
    }
    const resourceResponse = (0, $3HCkE.useResource)(resource, useResourceArgCustomContext);
    // we must call "fetch data" / refresh() manually, because react-resource-router will not fetch resources which are not defined in the current route's required resources.
    (0, $dUsMe.useInitFetchResource)(resourceResponse, !customRouterContext || !(0, $1ybV0.ff)('jira.call-useinitfetchresource-from-useresourcewithcustomroutercontext_hiyz0'));
    return resourceResponse;
};

});

parcelRegister("ixwgj", function(module, exports) {

$parcel$export(module.exports, "projectContextResource", () => $97b06b2828b1be93$export$27ad0d75c619be68);
$parcel$export(module.exports, "projectContextResourceWithCache", () => $97b06b2828b1be93$export$d75816e37af81473);

var $3HCkE = parcelRequire("3HCkE");

var $9zYls = parcelRequire("9zYls");


const $97b06b2828b1be93$var$getDataLoader = ()=>(parcelRequire("ajizA"));
const $97b06b2828b1be93$export$27ad0d75c619be68 = (0, $3HCkE.createResource)({
    type: (0, $e9754370217fd66e$export$80a60a092d9ab81),
    getKey: (matchedRoute)=>{
        const { projectKey: projectKey, projectId: projectId } = (0, $9zYls.getProjectKeyId)(matchedRoute.match, matchedRoute.query);
        return projectKey || projectId;
    },
    getDataLoader: $97b06b2828b1be93$var$getDataLoader,
    maxAge: 1800000
});
const $97b06b2828b1be93$export$d75816e37af81473 = $97b06b2828b1be93$export$27ad0d75c619be68;

});
const $e9754370217fd66e$export$80a60a092d9ab81 = 'PROJECT_CONTEXT';

parcelRegister("ajizA", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('cLVTX');
        const value = parcelRequire('6oUEv');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("cLVTX").then(()=>parcelRequire('6oUEv'));
}

});



parcelRegister("6YoSc", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bddfc6628ca4ec5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7bddfc6628ca4ec5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    canContactPrompt: {
        "id": "business-feedback-collector.can-contact-prompt",
        "defaultMessage": "Atlassian may contact me about this feedback."
    },
    canContactPromptLink: {
        "id": "business-feedback-collector.can-contact-prompt-link",
        "defaultMessage": "Privacy policy"
    },
    enrollInResearchPrompt: {
        "id": "business-feedback-collector.enroll-in-research-prompt",
        "defaultMessage": "I'd like to help improve Atlassian products by joining the {link}"
    },
    enrollInResearchLink: {
        "id": "business-feedback-collector.enroll-in-research-link",
        "defaultMessage": "Atlassian Research Group"
    }
});

});

parcelRegister("loHEm", function(module, exports) {

$parcel$export(module.exports, "licensedProductsToString", () => $7f7875a39a6a39a8$export$f57a7f1d32485807);
const $7f7875a39a6a39a8$export$f57a7f1d32485807 = (licensedProducts)=>Object.keys(licensedProducts).map((productKey)=>licensedProducts[productKey] ? productKey : '').join(', ');

});


parcelRegister("acCHb", function(module, exports) {

$parcel$export(module.exports, "useMigrationIdManager", () => $8b78f5735ae2265b$export$b6df8a64ae5b060b);

var $eUqFw = parcelRequire("eUqFw");

var $6HC1D = parcelRequire("6HC1D");

var $kE9FQ = parcelRequire("kE9FQ");
const $8b78f5735ae2265b$export$b6df8a64ae5b060b = ()=>{
    const fetchMigrationId = (0, $eUqFw.useCallback)((projectKey)=>{
        const migrationIdStore = (0, $kE9FQ.getMigrationIdStore)();
        return migrationIdStore[projectKey];
    }, []);
    const storeMigrationId = (0, $eUqFw.useCallback)((projectKey, migrationId)=>{
        const migrationIdStore = (0, $kE9FQ.getMigrationIdStore)();
        (0, $kE9FQ.setMigrationIdStore)({
            ...migrationIdStore,
            [projectKey]: migrationId
        });
    }, []);
    const removeMigrationId = (0, $eUqFw.useCallback)((projectKey)=>{
        const migrationIdStore = (0, $kE9FQ.getMigrationIdStore)();
        if (!(projectKey in migrationIdStore)) return;
        const newMigrationIdStore = (0, $6HC1D.unset)(migrationIdStore, projectKey);
        if (Object.keys(newMigrationIdStore).length === 0) {
            (0, $kE9FQ.removeMigrationIdStore)();
            return;
        }
        (0, $kE9FQ.setMigrationIdStore)(newMigrationIdStore);
    }, []);
    return {
        fetchMigrationId: fetchMigrationId,
        storeMigrationId: storeMigrationId,
        removeMigrationId: removeMigrationId
    };
};

});
parcelRegister("kE9FQ", function(module, exports) {

$parcel$export(module.exports, "getMigrationIdStore", () => $13be0f644b019d9b$export$caa1665a7b4680f6);
$parcel$export(module.exports, "setMigrationIdStore", () => $13be0f644b019d9b$export$d5f201daa9ea05b7);
$parcel$export(module.exports, "removeMigrationIdStore", () => $13be0f644b019d9b$export$7a4ecb0a9136dcec);
const $13be0f644b019d9b$var$MIGRATION_ID_STORE_KEY = 'X2C-Migration-Id-Store';
const $13be0f644b019d9b$export$caa1665a7b4680f6 = ()=>JSON.parse(localStorage.getItem($13be0f644b019d9b$var$MIGRATION_ID_STORE_KEY) || '{}');
const $13be0f644b019d9b$export$d5f201daa9ea05b7 = (migrationIdStore)=>localStorage.setItem($13be0f644b019d9b$var$MIGRATION_ID_STORE_KEY, JSON.stringify(migrationIdStore));
const $13be0f644b019d9b$export$7a4ecb0a9136dcec = ()=>localStorage.removeItem($13be0f644b019d9b$var$MIGRATION_ID_STORE_KEY);

});


parcelRegister("3tVfR", function(module, exports) {

$parcel$export(module.exports, "usePollMigrationStatus", () => $18d35b757efda3c1$export$523c1933cb8cd7a6);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");

var $dWLk9 = parcelRequire("dWLk9");

var $gyZoj = parcelRequire("gyZoj");

var $4cCEB = parcelRequire("4cCEB");

var $516Dl = parcelRequire("516Dl");

var $cpweK = parcelRequire("cpweK");

var $5GSA7 = parcelRequire("5GSA7");

var $7Zxg8 = parcelRequire("7Zxg8");
const $18d35b757efda3c1$export$84e2f2da851426a9 = 1800000;
const $18d35b757efda3c1$export$a1301e284b39cd56 = 1.3;
const $18d35b757efda3c1$var$getX2CMigrationStatusUrl = (cloudId, migrationId)=>`${0, $gyZoj.X2C_SERVICE_URL_PREFIX}/${cloudId}/import/${migrationId}/status`;
const $18d35b757efda3c1$export$7edd275ea1b9d090 = (cloudId, migrationId)=>(0, $2OdyW.default)($18d35b757efda3c1$var$getX2CMigrationStatusUrl(cloudId, migrationId), {
        method: 'GET',
        headers: {
            'x-issynthetic-traffic': String((0, $cpweK.isSynthetic)())
        }
    });
const $18d35b757efda3c1$export$523c1933cb8cd7a6 = (migrationId, basePollingIntervalMs)=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const [migrationStatus, setMigrationStatus] = (0, $eUqFw.useState)((0, $gyZoj.INITIAL_MIGRATION_STATUS));
    const [onExperienceStart, onExperienceSuccess, onExperienceFail] = (0, $5GSA7.useExperienceTracker)((0, $4cCEB.EXPERIENCES).POLLING);
    const getPollingRetryStatus = (0, $eUqFw.useCallback)(async ()=>{
        if (!migrationId) return false;
        try {
            onExperienceStart();
            (0, $4cCEB.pollingInteractionMetric).start();
            const containerTransferStatus = await $18d35b757efda3c1$export$7edd275ea1b9d090(cloudId, migrationId);
            const status = (0, $7Zxg8.calculateMigrationStatus)(containerTransferStatus);
            setMigrationStatus(status);
            (0, $4cCEB.pollingInteractionMetric).stop();
            onExperienceSuccess();
            return status.overallStatus !== (0, $516Dl.Status).SUCCESS && status.overallStatus !== (0, $516Dl.Status).FAILED;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $4cCEB.pollingInteractionMetric).stop();
            onExperienceFail((0, $gyZoj.APP_IDENTIFIER), error, {
                migrationId: migrationId
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'fetch-migration-status-error',
                    packageName: (0, $gyZoj.APP_IDENTIFIER),
                    teamName: (0, $gyZoj.APP_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true,
                error: error
            });
            if ((0, $7Zxg8.isRetryable)(error)) return true;
            setMigrationStatus({
                ...migrationStatus,
                overallStatus: (0, $516Dl.Status).FAILED
            });
            return false;
        }
    }, [
        cloudId,
        migrationId,
        migrationStatus,
        onExperienceFail,
        onExperienceStart,
        onExperienceSuccess
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (migrationId) (0, $7Zxg8.withExponentialBackoff)(getPollingRetryStatus, basePollingIntervalMs, $18d35b757efda3c1$export$84e2f2da851426a9, $18d35b757efda3c1$export$a1301e284b39cd56);
    // Only setup new polling if migrationId or interval changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        migrationId,
        basePollingIntervalMs
    ]);
    return {
        migrationStatus: migrationStatus
    };
};

});
parcelRegister("4cCEB", function(module, exports) {

$parcel$export(module.exports, "EXPERIENCES", () => $f19b2873602f9de5$export$a2008ed3b02411a3);
$parcel$export(module.exports, "pollingInteractionMetric", () => $f19b2873602f9de5$export$40607ce86ffe9e76);

var $lNfG4 = parcelRequire("lNfG4");

var $gyZoj = parcelRequire("gyZoj");
const $f19b2873602f9de5$export$a2008ed3b02411a3 = {
    POLLING: 'projectCreateImporterPolling'
};
const $f19b2873602f9de5$var$POLLING_ITERACTION_METRIC_KEY = `${(0, $gyZoj.APP_IDENTIFIER)}.polling`;
const $f19b2873602f9de5$export$40607ce86ffe9e76 = (0, $lNfG4.metrics).interaction({
    key: $f19b2873602f9de5$var$POLLING_ITERACTION_METRIC_KEY,
    histogram: {
        result: '200_500_1000_2000_3000_4000_5000_10000',
        response: '200_500_1000_2000_3000_4000_5000_10000'
    }
});

});

parcelRegister("7Zxg8", function(module, exports) {

$parcel$export(module.exports, "calculateMigrationStatus", () => $7656bc5f7739b24e$export$214c69f9b592e736);
$parcel$export(module.exports, "isRetryable", () => $7656bc5f7739b24e$export$f146c102d7613638);
$parcel$export(module.exports, "withExponentialBackoff", () => $7656bc5f7739b24e$export$20eaa22f2295996f);

var $illlw = parcelRequire("illlw");

var $gyZoj = parcelRequire("gyZoj");

var $516Dl = parcelRequire("516Dl");

var $2rXvr = parcelRequire("2rXvr");
const $7656bc5f7739b24e$var$JIRA_IMPORT_OPERATION_KEY = 'jiraImport';
const $7656bc5f7739b24e$var$JIRA_IMPORT_V4_OPERATION_KEY = 'jiraX2CProjectImport';
const $7656bc5f7739b24e$var$JIRA_DATA_TRANSFORM_OPERATION_KEY = 'jiraDataTransform';
const $7656bc5f7739b24e$var$ALL_USER_IMPORT_OPERATION_KEY = 'allUserImport';
const $7656bc5f7739b24e$var$PROJECT_ENTITY_KEY = 'jira/classic:project';
const $7656bc5f7739b24e$var$ISSUE_ENTITY_KEY = 'jira:issue';
const $7656bc5f7739b24e$var$PROGRESS_WEIGHTING = {
    jiraImport: 0.5,
    allUserImport: 0.3,
    jiraProjectFinalise: 0.1,
    jiraDataTransfer: 0.1
};
const $7656bc5f7739b24e$var$isFailedStatus = (status)=>status === (0, $2rXvr.TransferStatus).FAILED || status === (0, $2rXvr.TransferStatus).INCOMPLETE || status === (0, $2rXvr.TransferStatus).CANCELLED || status === (0, $2rXvr.TransferStatus).SKIPPED;
const $7656bc5f7739b24e$var$getCreatedJiraImportCountForEntity = (transfer, entityKey)=>(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(transfer, [
        'progressProperties',
        'completedEntityCounts',
        entityKey,
        'completed',
        'created'
    ], 0);
const $7656bc5f7739b24e$var$getFailedJiraImportCountForEntity = (transfer, entityKey)=>(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(transfer, [
        'progressProperties',
        'completedEntityCounts',
        entityKey,
        'completed',
        'failed'
    ], 0);
const $7656bc5f7739b24e$var$getTotalJiraImportCountForEntity = (transfer, entityKey)=>(0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(transfer, [
        'progressProperties',
        'completedEntityCounts',
        entityKey,
        'totalEntities'
    ], 0);
const $7656bc5f7739b24e$export$37d331774442a79a = (containerTransferStatus)=>{
    const jiraImportTransfer = containerTransferStatus.transfers?.find((transfer)=>transfer.operationKey === $7656bc5f7739b24e$var$JIRA_IMPORT_OPERATION_KEY || transfer.operationKey === $7656bc5f7739b24e$var$JIRA_IMPORT_V4_OPERATION_KEY);
    if (!jiraImportTransfer) return {
        createdIssues: 0,
        totalIssues: 0
    };
    return {
        createdIssues: $7656bc5f7739b24e$var$getCreatedJiraImportCountForEntity(jiraImportTransfer, $7656bc5f7739b24e$var$ISSUE_ENTITY_KEY),
        totalIssues: $7656bc5f7739b24e$var$getTotalJiraImportCountForEntity(jiraImportTransfer, $7656bc5f7739b24e$var$ISSUE_ENTITY_KEY)
    };
};
const $7656bc5f7739b24e$var$transformTranferStatusToStatus = (transferStatus)=>{
    if ($7656bc5f7739b24e$var$isFailedStatus(transferStatus)) return (0, $516Dl.Status).FAILED;
    if (transferStatus === (0, $2rXvr.TransferStatus).SUCCESS) return (0, $516Dl.Status).SUCCESS;
    if (transferStatus === (0, $2rXvr.TransferStatus).IN_PROGRESS) return (0, $516Dl.Status).IN_PROGRESS;
    return (0, $516Dl.Status).READY;
};
const $7656bc5f7739b24e$var$getStatusForOperation = (containerTransferStatus, operationKey)=>{
    const transfer = containerTransferStatus.transfers?.find((t)=>t.operationKey === operationKey);
    return transfer?.status ? $7656bc5f7739b24e$var$transformTranferStatusToStatus(transfer.status) : (0, $516Dl.Status).READY;
};
const $7656bc5f7739b24e$var$getProjectCreateStatus = (containerTransferStatus)=>{
    const jiraImportTransfer = containerTransferStatus.transfers?.find((transfer)=>transfer.operationKey === $7656bc5f7739b24e$var$JIRA_IMPORT_OPERATION_KEY || transfer.operationKey === $7656bc5f7739b24e$var$JIRA_IMPORT_V4_OPERATION_KEY);
    if (!jiraImportTransfer) return (0, $516Dl.Status).READY;
    const createdProjectEntities = $7656bc5f7739b24e$var$getCreatedJiraImportCountForEntity(jiraImportTransfer, $7656bc5f7739b24e$var$PROJECT_ENTITY_KEY);
    const totalProjectEntities = $7656bc5f7739b24e$var$getTotalJiraImportCountForEntity(jiraImportTransfer, $7656bc5f7739b24e$var$PROJECT_ENTITY_KEY);
    const failedProjectEntities = $7656bc5f7739b24e$var$getFailedJiraImportCountForEntity(jiraImportTransfer, $7656bc5f7739b24e$var$PROJECT_ENTITY_KEY);
    if (failedProjectEntities !== 0) return (0, $516Dl.Status).FAILED;
    if (createdProjectEntities === 0) return (0, $516Dl.Status).READY;
    if (createdProjectEntities === totalProjectEntities) return (0, $516Dl.Status).SUCCESS;
    return (0, $516Dl.Status).IN_PROGRESS;
};
const $7656bc5f7739b24e$export$ad5f54dfa4c25e4b = (containerTransferStatus)=>({
        dataTransformStatus: $7656bc5f7739b24e$var$getStatusForOperation(containerTransferStatus, $7656bc5f7739b24e$var$JIRA_DATA_TRANSFORM_OPERATION_KEY),
        userImportStatus: $7656bc5f7739b24e$var$getStatusForOperation(containerTransferStatus, $7656bc5f7739b24e$var$ALL_USER_IMPORT_OPERATION_KEY),
        projectCreateStatus: $7656bc5f7739b24e$var$getProjectCreateStatus(containerTransferStatus)
    });
const $7656bc5f7739b24e$var$getProgressForTransfer = (transfer)=>{
    if (transfer.status === (0, $2rXvr.TransferStatus).SUCCESS) return 1;
    if (transfer.status === (0, $2rXvr.TransferStatus).READY) return 0;
    if (transfer.progressProperties === undefined || transfer.progressProperties === null) return 0;
    const { createdEntities: createdEntities, totalEntities: totalEntities } = transfer.progressProperties;
    if (createdEntities === undefined || totalEntities === undefined) return 0;
    return createdEntities / totalEntities;
};
const $7656bc5f7739b24e$var$calculateProgress = (containerTransferStatus)=>{
    let progress = 0;
    containerTransferStatus.transfers?.forEach((transfer)=>{
        const weighting = $7656bc5f7739b24e$var$PROGRESS_WEIGHTING[transfer.operationKey] || 0;
        progress += $7656bc5f7739b24e$var$getProgressForTransfer(transfer) * weighting;
    });
    return progress;
};
const $7656bc5f7739b24e$export$214c69f9b592e736 = (containerTransferStatus)=>{
    if (containerTransferStatus.status === (0, $2rXvr.TransferStatus).READY) return 0, $gyZoj.INITIAL_MIGRATION_STATUS;
    const issueStats = $7656bc5f7739b24e$export$37d331774442a79a(containerTransferStatus);
    const detailedProgress = $7656bc5f7739b24e$export$ad5f54dfa4c25e4b(containerTransferStatus);
    if (containerTransferStatus.status === (0, $2rXvr.TransferStatus).SUCCESS) return {
        overallProgress: 1,
        overallStatus: (0, $516Dl.Status).SUCCESS,
        detailedProgress: detailedProgress,
        ...issueStats
    };
    const progress = $7656bc5f7739b24e$var$calculateProgress(containerTransferStatus);
    if ($7656bc5f7739b24e$var$isFailedStatus(containerTransferStatus.status)) {
        const migrationFailedStatus = {
            overallProgress: progress,
            overallStatus: (0, $516Dl.Status).FAILED,
            detailedProgress: detailedProgress,
            ...issueStats
        };
        return {
            ...migrationFailedStatus,
            hasErrorLogs: containerTransferStatus.hasErrorLogs
        };
    }
    return {
        overallProgress: progress,
        overallStatus: (0, $516Dl.Status).IN_PROGRESS,
        detailedProgress: detailedProgress,
        ...issueStats
    };
};
const $7656bc5f7739b24e$export$f146c102d7613638 = (error)=>error?.statusCode === 429 || error?.statusCode === 503 || error?.name === 'NetworkError';
const $7656bc5f7739b24e$var$waitTimeMs = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
const $7656bc5f7739b24e$export$c3c863e65cddb513 = (baseIntervalMs, maxPollingIntervalMs, exponentialBase, retryCount)=>{
    const time = baseIntervalMs * exponentialBase ** retryCount;
    return time > maxPollingIntervalMs ? maxPollingIntervalMs : time;
};
const $7656bc5f7739b24e$export$20eaa22f2295996f = (callback, baseIntervalMs, maxPollingInterval, exponentialBase, retryCount = 0)=>callback().then((shouldRetry)=>shouldRetry && $7656bc5f7739b24e$var$waitTimeMs($7656bc5f7739b24e$export$c3c863e65cddb513(baseIntervalMs, maxPollingInterval, exponentialBase, retryCount)).then(()=>$7656bc5f7739b24e$export$20eaa22f2295996f(callback, baseIntervalMs, maxPollingInterval, exponentialBase, retryCount + 1)));

});
parcelRegister("2rXvr", function(module, exports) {

$parcel$export(module.exports, "TransferStatus", () => $8d09ee2f1dcf46a8$export$91301ebb6ad45fab);
const $8d09ee2f1dcf46a8$export$7d7a98f44861e6f7 = {
    JIRA_PROJECT: 'JiraProject',
    SITE: 'Site'
};
const $8d09ee2f1dcf46a8$export$91301ebb6ad45fab = {
    READY: 'READY',
    IN_PROGRESS: 'IN_PROGRESS',
    SUCCESS: 'SUCCESS',
    FAILED: 'FAILED',
    SKIPPED: 'SKIPPED',
    INCOMPLETE: 'INCOMPLETE',
    CANCELLED: 'CANCELLED'
};

});



parcelRegister("66xY8", function(module, exports) {
module.exports = new URL("ImportErrorIllustration.db4fa603.svg", import.meta.url).toString();

});

parcelRegister("PZvef", function(module, exports) {
module.exports = new URL("ImportInProgressIllustration.5721ebc1.svg", import.meta.url).toString();

});

parcelRegister("bz2yd", function(module, exports) {

$parcel$export(module.exports, "useProjectSpecificContent", () => $a0bc2753bb1affb5$export$a8d2a3912bdbb190);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $kzTj7 = parcelRequire("kzTj7");

var $9R4E5 = parcelRequire("9R4E5");


var $ymjiO = parcelRequire("ymjiO");
const $a0bc2753bb1affb5$export$a8d2a3912bdbb190 = (type, source)=>(0, $eUqFw.useMemo)(()=>{
        let messagesObject;
        switch(type){
            case (0, $9R4E5.ProjectTypes).SOFTWARE:
                messagesObject = {
                    uploadHeading: (0, $ymjiO.default).uploadHeadingJswSpork,
                    uploadDescription: (0, $ymjiO.default).uploadDescriptionWithLinkJswSpork,
                    projectCreateHeading: (0, $1ybV0.ff)('jira-business-to-software-project-imports') ? (0, $ymjiO.default).projectCreateHeadingSoftwareProject : (0, $ymjiO.default).projectCreateHeadingJsw,
                    projectCreateDescription: (0, $1ybV0.ff)('jira-business-to-software-project-imports') ? (0, $ymjiO.default).projectCreateDescriptionSoftwareProject : (0, $ymjiO.default).projectCreateDescriptionJsw,
                    uploadCsvDropzoneHeading: (0, $ymjiO.default).uploadCsvDropzoneHeadingJsw,
                    uploadCsvDropzoneLearnMore: (0, $ymjiO.default).uploadCsvDropzoneLearnMoreJsw,
                    uploadFooterContinue: (0, $ymjiO.default).uploadFooterContinue,
                    uploadFooterCancel: (0, $ymjiO.default).uploadFooterCancel,
                    mappingHeading: (0, $ymjiO.default).mappingHeadingJsw,
                    mappingDescription: (0, $ymjiO.default).mappingDescriptionJswSpork,
                    mappingDescriptionWithLink: (0, $ymjiO.default).mappingDescriptionWithLinkJswSpork,
                    mappingLearnMore: (0, $ymjiO.default).mappingLearnMoreJsw,
                    importFromOtherAppsHeading: (0, $ymjiO.default).importFromOtherAppsHeadingJsw,
                    importFromOtherAppsHelperMessage: (0, $ymjiO.default).importFromOtherAppsHelperMessageJsw,
                    projectCreateMoreOptions: (0, $ymjiO.default).projectCreateMoreOptionsJsw,
                    projectCreateHideMoreOptions: (0, $ymjiO.default).projectCreateHideMoreOptionsJsw,
                    mappingAdvancedOptionsHeading: (0, $ymjiO.default).mappingAdvancedOptionsHeading,
                    mappingAdvancedOptionsPopupHeading: (0, $ymjiO.default).mappingAdvancedOptionsPopupHeading,
                    mappingAdvancedOptionsPopupDescription: (0, $ymjiO.default).mappingAdvancedOptionsPopupDescriptionJsw,
                    importInProgressHeading: (0, $ymjiO.default).importInProgressHeading,
                    importInProgressDescription: (0, $ymjiO.default).importInProgressDescription,
                    importInProgressProjectStep: (0, $ymjiO.default).importInProgressCreateProjectStep,
                    importInProgressErrorHeading: (0, $ymjiO.default).importInProgressErrorHeading,
                    closeButtonLabel: (0, $ymjiO.default).close,
                    userMappingScreenDescription: (0, $ymjiO.default).userMappingScreenDescriptionJswSpork,
                    entityStatsUserMessage: (0, $ymjiO.default).entityStatsUserMessageJswSpork,
                    uploadLearnMoreLink: (0, $kzTj7.LEARN_MORE_LINK_JSW),
                    importInProgressTroubleshootLink: (0, $kzTj7.TROUBLESHOOT_PAGE_URL_SOFTWARE)
                };
                break;
            case (0, $9R4E5.ProjectTypes).BUSINESS:
                messagesObject = {
                    uploadHeading: (0, $ymjiO.default).uploadHeadingJwmSpork,
                    uploadDescription: (0, $ymjiO.default).uploadDescriptionWithLinkJwmComplexspork,
                    projectCreateHeading: (0, $ymjiO.default).projectCreateHeadingJwm,
                    projectCreateDescription: (0, $ymjiO.default).projectCreateDescriptionJwmSpork,
                    uploadCsvDropzoneHeading: (0, $ymjiO.default).uploadCsvDropzoneHeadingJwm,
                    uploadCsvDropzoneLearnMore: (0, $ymjiO.default).uploadCsvDropzoneLearnMoreJwm,
                    uploadFooterContinue: (0, $ymjiO.default).uploadFooterContinue,
                    uploadFooterCancel: (0, $ymjiO.default).uploadFooterCancel,
                    mappingHeading: (0, $ymjiO.default).mappingHeadingJwm,
                    mappingDescription: (0, $ymjiO.default).mappingDescriptionJwmSpork,
                    mappingDescriptionWithLink: (0, $ymjiO.default).mappingDescriptionWithLinkJwmSpork,
                    mappingLearnMore: (0, $ymjiO.default).mappingLearnMoreJwm,
                    importFromOtherAppsHeading: (0, $ymjiO.default).importFromOtherAppsHeadingJwm,
                    importFromOtherAppsHelperMessage: (0, $ymjiO.default).importFromOtherAppsHelperMessageJwm,
                    importFromOtherAppsLearnMoreOtherApps: (0, $ymjiO.default).importFromOtherAppsLearnMoreOtherAppsJwm,
                    projectCreateMoreOptions: (0, $ymjiO.default).projectCreateMoreOptionsJwm,
                    projectCreateHideMoreOptions: (0, $ymjiO.default).projectCreateHideMoreOptionsJwm,
                    mappingAdvancedOptionsHeading: (0, $ymjiO.default).mappingAdvancedOptionsHeading,
                    mappingAdvancedOptionsPopupHeading: (0, $ymjiO.default).mappingAdvancedOptionsPopupHeading,
                    mappingAdvancedOptionsPopupDescription: (0, $ymjiO.default).mappingAdvancedOptionsPopupDescriptionJwm,
                    importInProgressHeading: (0, $ymjiO.default).importInProgressHeading,
                    importInProgressDescription: (0, $ymjiO.default).importInProgressDescription,
                    importInProgressProjectStep: (0, $ymjiO.default).importInProgressCreateProjectStep,
                    importInProgressErrorHeading: (0, $ymjiO.default).importInProgressErrorHeading,
                    closeButtonLabel: (0, $ymjiO.default).close,
                    userMappingScreenDescription: (0, $ymjiO.default).userMappingScreenDescriptionJwmSpork,
                    entityStatsUserMessage: (0, $ymjiO.default).entityStatsUserMessageJwmSpork,
                    uploadLearnMoreLink: (0, $kzTj7.LEARN_MORE_LINK),
                    importInProgressTroubleshootLink: (0, $kzTj7.TROUBLESHOOT_PAGE_URL)
                };
                break;
            default:
                messagesObject = {
                    uploadHeading: (0, $ymjiO.default).emptyMessageNoTranslate,
                    uploadDescription: (0, $ymjiO.default).emptyMessageNoTranslate,
                    uploadLearnMore: (0, $ymjiO.default).emptyMessageNoTranslate,
                    uploadReturn: (0, $ymjiO.default).emptyMessageNoTranslate,
                    uploadFooterContinue: (0, $ymjiO.default).emptyMessageNoTranslate,
                    uploadFooterCancel: (0, $ymjiO.default).emptyMessageNoTranslate,
                    projectCreateHeading: (0, $ymjiO.default).emptyMessageNoTranslate,
                    projectCreateDescription: (0, $ymjiO.default).emptyMessageNoTranslate,
                    uploadCsvDropzoneHeading: (0, $ymjiO.default).emptyMessageNoTranslate,
                    uploadCsvDropzoneLearnMore: (0, $ymjiO.default).emptyMessageNoTranslate,
                    mappingHeading: (0, $ymjiO.default).emptyMessageNoTranslate,
                    mappingDescription: (0, $ymjiO.default).emptyMessageNoTranslate,
                    mappingDescriptionWithLink: (0, $ymjiO.default).emptyMessageNoTranslate,
                    mappingLearnMore: (0, $ymjiO.default).emptyMessageNoTranslate,
                    importFromOtherAppsHeading: (0, $ymjiO.default).emptyMessageNoTranslate,
                    importFromOtherAppsHelperMessage: (0, $ymjiO.default).emptyMessageNoTranslate,
                    importFromOtherAppsLearnMoreOtherApps: (0, $ymjiO.default).emptyMessageNoTranslate,
                    projectCreateMoreOptions: (0, $ymjiO.default).emptyMessageNoTranslate,
                    projectCreateHideMoreOptions: (0, $ymjiO.default).emptyMessageNoTranslate,
                    mappingAdvancedOptionsHeading: (0, $ymjiO.default).emptyMessageNoTranslate,
                    mappingAdvancedOptionsPopupHeading: (0, $ymjiO.default).emptyMessageNoTranslate,
                    mappingAdvancedOptionsPopupDescription: (0, $ymjiO.default).emptyMessageNoTranslate,
                    importInProgressHeading: (0, $ymjiO.default).emptyMessageNoTranslate,
                    importInProgressDescription: (0, $ymjiO.default).emptyMessageNoTranslate,
                    importInProgressProjectStep: (0, $ymjiO.default).emptyMessageNoTranslate,
                    importInProgressErrorHeading: (0, $ymjiO.default).emptyMessageNoTranslate,
                    closeButtonLabel: (0, $ymjiO.default).emptyMessageNoTranslate,
                    userMappingScreenDescription: (0, $ymjiO.default).emptyMessageNoTranslate,
                    entityStatsUserMessage: (0, $ymjiO.default).emptyMessageNoTranslate,
                    uploadLearnMoreLink: (0, $kzTj7.LEARN_MORE_LINK),
                    importInProgressTroubleshootLink: (0, $kzTj7.TROUBLESHOOT_PAGE_URL)
                };
        }
        if (source === (0, $85ba070c29b4a3bd$export$ec4d35718915f521)) messagesObject = {
            ...messagesObject,
            mappingHeading: (0, $ymjiO.default).mappingHeadingJsw,
            mappingDescription: (0, $ymjiO.default).mappingDescriptionExistingProjectNonFinal,
            mappingDescriptionWithLink: (0, $ymjiO.default).mappingDescriptionWithLinkExistingProject,
            mappingLearnMore: (0, $ymjiO.default).mappingLearnMoreExistingProjectNonFinal,
            importInProgressHeading: (0, $ymjiO.default).importInProgressHeadingExistingProject,
            importInProgressDescription: (0, $ymjiO.default).importInProgressDescriptionExistingProject,
            importInProgressProjectStep: (0, $ymjiO.default).importInProgressMappingDataStep,
            importInProgressErrorHeading: (0, $ymjiO.default).importInProgressErrorExistingProjectHeading
        };
        return messagesObject;
    }, [
        source,
        type
    ]);

});
parcelRegister("ymjiO", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3f8403935eba959$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e3f8403935eba959$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    uploadHeadingJwmSpork: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.upload-heading-jwm-spork",
        "defaultMessage": "Import data to a new business project"
    },
    uploadDescriptionWithLinkJwmComplexspork: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.upload-description-with-link-jwm-complexspork",
        "defaultMessage": "Create a new business project using imported data. If you\u2019d like to import into an existing business project, <link>switch to the old experience</link>."
    },
    projectCreateHeadingJwm: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.project-create-heading-jwm",
        "defaultMessage": "Create a project"
    },
    projectCreateDescriptionJwmSpork: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.project-create-description-jwm-spork",
        "defaultMessage": "Create a new business project to import your data into. Aside from the project type, you can edit project details anytime in project settings. {br} {br}Required fields are marked with an asterisk."
    },
    uploadCsvDropzoneHeadingJwm: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.upload-csv-dropzone-heading-jwm",
        "defaultMessage": "Import from CSV"
    },
    uploadCsvDropzoneLearnMoreJwm: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.upload-csv-dropzone-learn-more-jwm",
        "defaultMessage": "Learn more about importing from a CSV file"
    },
    mappingHeadingJwm: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.mapping-heading-jwm",
        "defaultMessage": "Preview mapped data"
    },
    mappingDescriptionWithLinkJwmSpork: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.mapping-description-with-link-jwm-spork",
        "defaultMessage": "Use this preview screen to map columns from your CSV to fields in the new project, or select columns you want to exclude from the import. We\u2019ll create an issue in the Jira project for each row of data. <link>Learn more about how to map data from a CSV.</link>"
    },
    mappingDescriptionJwmSpork: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.mapping-description-jwm-spork",
        "defaultMessage": "Use this preview screen to map columns from your CSV to fields in the new project, or select columns you want to exclude from the import. We\u2019ll create an issue in the Jira project for each row of data. {link}"
    },
    mappingLearnMoreJwm: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.mapping-learn-more-jwm",
        "defaultMessage": "Learn more about how to map data from a CSV."
    },
    importFromOtherAppsHeadingJwm: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.import-from-other-apps-heading-jwm",
        "defaultMessage": "Other apps"
    },
    importFromOtherAppsHelperMessageJwm: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.import-from-other-apps-helper-message-jwm",
        "defaultMessage": "We\u2019re working on the ability to directly import data from other apps. For now, you can import from other apps using our CSV importer. {link}"
    },
    importFromOtherAppsLearnMoreOtherAppsJwm: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.import-from-other-apps-learn-more-other-apps-jwm",
        "defaultMessage": "Learn more about importing from other apps"
    },
    projectCreateMoreOptionsJwm: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.project-create-more-options-jwm",
        "defaultMessage": "Show project type and key"
    },
    projectCreateHideMoreOptionsJwm: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.project-create-hide-more-options-jwm",
        "defaultMessage": "Hide project type and key"
    },
    mappingAdvancedOptionsHeading: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.mapping-advanced-options-heading",
        "defaultMessage": "Date and time format options"
    },
    mappingAdvancedOptionsPopupHeading: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.mapping-advanced-options-popup-heading",
        "defaultMessage": "Date and time format"
    },
    mappingAdvancedOptionsPopupDescriptionJwm: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.mapping-advanced-options-popup-description-jwm",
        "defaultMessage": "Specify how dates and times are formatted in your CSV file. We\u2019ll read these based on your CSV language and region preferences. Use syntax valid for {linkStart}Simple Date Format{linkEnd}."
    },
    uploadHeadingJswSpork: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.upload-heading-jsw-spork",
        "defaultMessage": "Import data to a new software project"
    },
    uploadDescriptionWithLinkJswSpork: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.upload-description-with-link-jsw-spork",
        "defaultMessage": "Create a new software project using imported data. If you\u2019d like to import into an existing software project, <link>switch to the old experience</link>."
    },
    projectCreateHeadingJsw: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.project-create-heading-jsw",
        "defaultMessage": "Set up a project"
    },
    projectCreateHeadingSoftwareProject: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.project-create-heading-software-project",
        "defaultMessage": "Set up your new project"
    },
    projectCreateDescriptionJsw: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.project-create-description-jsw",
        "defaultMessage": "Create a software project to import your data. Except for the project type, you can update other details in the Project settings anytime."
    },
    projectCreateDescriptionSoftwareProject: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.project-create-description-software-project",
        "defaultMessage": "Name and create your new project. Aside from the project type, you can update these details later. {br} {br}Required fields are marked with an asterisk."
    },
    uploadCsvDropzoneHeadingJsw: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.upload-csv-dropzone-heading-jsw",
        "defaultMessage": "Import from CSV"
    },
    uploadCsvDropzoneLearnMoreJsw: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.upload-csv-dropzone-learn-more-jsw",
        "defaultMessage": "How to import from a CSV file"
    },
    mappingHeadingJsw: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.mapping-heading-jsw",
        "defaultMessage": "Preview mapped data"
    },
    mappingDescriptionWithLinkJswSpork: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.mapping-description-with-link-jsw-spork",
        "defaultMessage": "Use this preview screen to map columns from your CSV to fields in the new project, or select columns you want to exclude from the import. We\u2019ll create an issue in the Jira project for each row of data. <link>How to map data from a CSV.</link>"
    },
    mappingDescriptionJswSpork: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.mapping-description-jsw-spork",
        "defaultMessage": "Use this preview screen to map columns from your CSV to fields in the new project, or select columns you want to exclude from the import. We\u2019ll create an issue in the Jira project for each row of data. {link}"
    },
    mappingLearnMoreJsw: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.mapping-learn-more-jsw",
        "defaultMessage": "How to map data from a CSV."
    },
    importFromOtherAppsHeadingJsw: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.import-from-other-apps-heading-jsw",
        "defaultMessage": "Import from apps"
    },
    importFromOtherAppsHelperMessageJsw: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.import-from-other-apps-helper-message-jsw",
        "defaultMessage": "We\u2019re working on importers that will directly move your data from these apps."
    },
    projectCreateMoreOptionsJsw: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.project-create-more-options-jsw",
        "defaultMessage": "Show more"
    },
    projectCreateHideMoreOptionsJsw: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.project-create-hide-more-options-jsw",
        "defaultMessage": "Hide more"
    },
    mappingAdvancedOptionsPopupDescriptionJsw: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.mapping-advanced-options-popup-description-jsw",
        "defaultMessage": "Select how dates and times are formatted in your CSV file. We\u2019ll read these based on your CSV language and region preferences. Use syntax valid for {linkStart}Simple Date Format{linkEnd}."
    },
    importInProgressHeading: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.import-in-progress-heading",
        "defaultMessage": "We\u2019re mapping out the new project"
    },
    importInProgressDescription: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.import-in-progress-description",
        "defaultMessage": "Take a quick break and we'll do the rest.{br}We'll take you to the project once it\u2019s ready."
    },
    importInProgressCreateProjectStep: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.import-in-progress-create-project-step",
        "defaultMessage": "Creating a new project"
    },
    mappingDescriptionExistingProjectNonFinal: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.mapping-description-existing-project-non-final",
        "defaultMessage": "{link} in the selected project, or select columns you want to exclude from the import. Using your CSV, we\u2019ll create an issue for each row of data. This import won't alter any issues in the existing project."
    },
    mappingDescriptionWithLinkExistingProject: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.mapping-description-with-link-existing-project",
        "defaultMessage": "<link>Map columns from your CSV to fields</link> in the selected project, or select columns you want to exclude from the import. Using your CSV, we\u2019ll create an issue for each row of data. This import won't alter any issues in the existing project."
    },
    mappingLearnMoreExistingProjectNonFinal: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.mapping-learn-more-existing-project-non-final",
        "defaultMessage": "Map columns from your CSV to fields"
    },
    emptyMessageNoTranslate: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.empty-message-no-translate"
    },
    close: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.close",
        "defaultMessage": "Close"
    },
    importInProgressHeadingExistingProject: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.import-in-progress-heading-existing-project",
        "defaultMessage": "We\u2019re importing your project"
    },
    importInProgressDescriptionExistingProject: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.import-in-progress-description-existing-project",
        "defaultMessage": "Feel free to close this window. You can continue to work in the background.{br}We will notify you once the import is complete. You can also track the progress from the project page."
    },
    importInProgressMappingDataStep: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.import-in-progress-mapping-data-step",
        "defaultMessage": "Mapping data to your project"
    },
    importInProgressErrorHeading: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.import-in-progress-error-heading",
        "defaultMessage": "We couldn't set up your project"
    },
    importInProgressErrorExistingProjectHeading: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.import-in-progress-error-existing-project-heading",
        "defaultMessage": "We couldn't import your data"
    },
    uploadFooterContinue: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.upload-footer-continue",
        "defaultMessage": "Continue"
    },
    uploadFooterCancel: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.upload-footer-cancel",
        "defaultMessage": "Cancel"
    },
    userMappingScreenDescriptionJwmSpork: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.user-mapping-screen-description-jwm-spork",
        "defaultMessage": "Enter a valid email address for each user to add them into your Jira project. Users without an email address won\u2019t be imported into the project."
    },
    userMappingScreenDescriptionJswSpork: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.user-mapping-screen-description-jsw-spork",
        "defaultMessage": "Enter a valid email address for each user to add them into your Jira project. Users without an email address won\u2019t be imported into the project."
    },
    entityStatsUserMessageJwmSpork: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.entity-stats-user-message-jwm-spork",
        "defaultMessage": "Users won\u2019t get an email when they\u2019re added to Jira."
    },
    entityStatsUserMessageJswSpork: {
        "id": "project-create-importer-upload-flow.common.utils.project-specific-content.entity-stats-user-message-jsw-spork",
        "defaultMessage": "Users won\u2019t get an email when they\u2019re added to Jira."
    }
});

});


parcelRegister("aGmSP", function(module, exports) {

$parcel$export(module.exports, "CrossButton", () => $4786c85966412b2c$export$eceda513ad14fae1);

var $eUqFw = parcelRequire("eUqFw");

var $j9fWg = parcelRequire("j9fWg");

var $jWuk1 = parcelRequire("jWuk1");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $4786c85966412b2c$export$eceda513ad14fae1 = ({ onClose: onClose, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $4786c85966412b2c$var$closeButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))),
        label: label,
        appearance: "subtle",
        onClick: onClose
    }));
const $4786c85966412b2c$var$closeButtonStyles = (0, $1ZAYh.xcss)({
    position: 'absolute',
    top: '24px',
    right: '24px'
});

});

parcelRegister("kVstV", function(module, exports) {

$parcel$export(module.exports, "ImportStepProgress", () => $1b27b892d2da5b02$export$fd045af86f129884);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $9nt1B = parcelRequire("9nt1B");

var $4Bees = parcelRequire("4Bees");

var $PdmhA = parcelRequire("PdmhA");

var $516Dl = parcelRequire("516Dl");
const $1b27b892d2da5b02$var$SUCCESS_ICON_COLOR = `var(--ds-icon-success, ${(0, $PdmhA).G500})`;
const $1b27b892d2da5b02$var$getIcon = (status)=>status === (0, $516Dl.Status).SUCCESS ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nt1B))), {
        label: "",
        primaryColor: $1b27b892d2da5b02$var$SUCCESS_ICON_COLOR,
        size: "small",
        testId: "project-create-importer-upload-flow.ui.import-in-progress-screen.import-step-progress.check-icon"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "small",
        testId: "project-create-importer-upload-flow.ui.import-in-progress-screen.import-step-progress.spinner"
    });
const $1b27b892d2da5b02$export$fd045af86f129884 = ({ status: status, description: description })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b27b892d2da5b02$var$Wrapper, {
        "data-testid": "project-create-importer-upload-flow.ui.import-in-progress-screen.import-step-progress.wrapper"
    }, $1b27b892d2da5b02$var$getIcon(status), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, description));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1b27b892d2da5b02$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o _1tke1ejb _24rcpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9nt1B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6d3cc6c41555bcf7$var$_react = $6d3cc6c41555bcf7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $6d3cc6c41555bcf7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $6d3cc6c41555bcf7$var$CheckIcon = (props)=>/*#__PURE__*/ $6d3cc6c41555bcf7$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M6.735 12.322a1 1 0 00-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2335.638 2335.638 0 003.939-3.883l.04-.04a492.598 492.598 0 003.658-3.643 1 1 0 00-1.424-1.404 518.42 518.42 0 01-3.64 3.625l-.04.04a2049.114 2049.114 0 01-3.775 3.722l-3.098-3.363z" fill="currentColor"/></svg>`
    }, props));
$6d3cc6c41555bcf7$var$CheckIcon.displayName = 'CheckIcon';
var $6d3cc6c41555bcf7$var$_default = $6d3cc6c41555bcf7$var$CheckIcon;
module.exports.default = $6d3cc6c41555bcf7$var$_default;

});


parcelRegister("hReaD", function(module, exports) {

$parcel$export(module.exports, "default", () => $17cbf84e27470d58$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $17cbf84e27470d58$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    verifyingCsvData: {
        "id": "project-create-importer-upload-flow.import-in-progress-screen.verifying-csv-data",
        "defaultMessage": "Verifying your CSV data"
    },
    userImport: {
        "id": "project-create-importer-upload-flow.import-in-progress-screen.user-import",
        "defaultMessage": "Setting up user profiles"
    },
    creatingProject: {
        "id": "project-create-importer-upload-flow.import-in-progress-screen.creating-project",
        "defaultMessage": "Creating a new project"
    },
    errorDescription: {
        "id": "project-create-importer-upload-flow.import-in-progress-screen.error-description",
        "defaultMessage": "Contact our support team for assistance."
    },
    advanceErrorDescription: {
        "id": "project-create-importer-upload-flow.import-in-progress-screen.advance-error-description",
        "defaultMessage": "Try fixing errors in the <link>error log</link> before importing again.{br}If you continue experiencing problems with your import, contact support."
    },
    advanceErrorDesc: {
        "id": "project-create-importer-upload-flow.import-in-progress-screen.advance-error-desc",
        "defaultMessage": "Try fixing errors in the error log before importing again.{br}If you continue experiencing problems with your import, <link>contact support</link>."
    },
    contactSupport: {
        "id": "project-create-importer-upload-flow.import-in-progress-screen.contact-support",
        "defaultMessage": "Contact support"
    },
    viewTroubleshootingPage: {
        "id": "project-create-importer-upload-flow.import-in-progress-screen.view-troubleshooting-page",
        "defaultMessage": "View troubleshooting page"
    },
    downloadLog: {
        "id": "project-create-importer-upload-flow.import-in-progress-screen.download-log",
        "defaultMessage": "Download log"
    },
    startNewImport: {
        "id": "project-create-importer-upload-flow.import-in-progress-screen.start-new-import",
        "defaultMessage": "Start a new import"
    },
    closeImportWindow: {
        "id": "project-create-importer-upload-flow.import-in-progress-screen.close-import-window",
        "defaultMessage": "Close import window"
    },
    submitFeedbackCallToAction: {
        "id": "project-create-importer-upload-flow.import-in-progress-screen.submit-feedback-call-to-action",
        "defaultMessage": "Give feedback"
    }
});

});


parcelRegister("hqUzy", function(module, exports) {

$parcel$export(module.exports, "MappingScreen", () => $6cef73e9a5ed8be5$export$53931efe96888f5c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $6Pq2D = parcelRequire("6Pq2D");

var $7u4fN = parcelRequire("7u4fN");

var $lzLxZ = parcelRequire("lzLxZ");

var $d3vNK = parcelRequire("d3vNK");

var $5xIu6 = parcelRequire("5xIu6");

var $eI5EY = parcelRequire("eI5EY");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $gyZoj = parcelRequire("gyZoj");

var $4oLAo = parcelRequire("4oLAo");

var $3yuWi = parcelRequire("3yuWi");

var $elKPF = parcelRequire("elKPF");

var $aWLVm = parcelRequire("aWLVm");

var $bLalW = parcelRequire("bLalW");
var $lUC5l = parcelRequire("lUC5l");
var $4uta0 = parcelRequire("4uta0");
var $d0wrd = parcelRequire("d0wrd");

var $2sRUp = parcelRequire("2sRUp");

var $1dxi7 = parcelRequire("1dxi7");

var $ap0Nu = parcelRequire("ap0Nu");

var $6rHYD = parcelRequire("6rHYD");

var $1mEdD = parcelRequire("1mEdD");

var $2laZm = parcelRequire("2laZm");

var $2wmz9 = parcelRequire("2wmz9");

var $84Q9E = parcelRequire("84Q9E");

var $5MhMl = parcelRequire("5MhMl");

var $2SUld = parcelRequire("2SUld");

var $3Ucrz = parcelRequire("3Ucrz");

var $hbUUM = parcelRequire("hbUUM");

var $iuOqp = parcelRequire("iuOqp");
const $6cef73e9a5ed8be5$export$c79b6465941604f5 = ({ onNext: onNext, onReturn: onReturn, shouldStartImportOnNext: shouldStartImportOnNext, onCloseAndReturnToUploadStep: onCloseAndReturnToUploadStep, showLearnMoreLink: showLearnMoreLink, isCompact: isCompact, hideFeedback: hideFeedback, rightAlignFooter: rightAlignFooter, offsetModalY: offsetModalY })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [mappingState, { setMappingStateValidationError: setMappingStateValidationError, clearSelectedColumn: clearSelectedColumn }] = (0, $lUC5l.useMappingState)();
    const openFeedbackModal = (0, $5xIu6.useFeedbackCollector)();
    const [migrationId] = (0, $4uta0.useMigrationId)();
    const [advancedOptions] = (0, $bLalW.useAdvancedOptions)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const [numVisibleUnmappedColumns] = (0, $lUC5l.useNumVisibleUnmappedColumns)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { startImport: startImport, isStartImportDisabled: isStartImportDisabled, hasImportErrorOccurred: hasImportErrorOccurred } = (0, $1dxi7.useStartImportController)();
    const [projectData] = (0, $d0wrd.useProjectData)();
    const [isUnmappedWarningModalOpen, setIsUnmappedWarningModalOpen] = (0, $eUqFw.useState)(false);
    const onSubmitFeedbackClick = (0, $eUqFw.useCallback)(()=>{
        openFeedbackModal((0, $gyZoj.FEEDBACK_GROUP_ID));
    }, [
        openFeedbackModal
    ]);
    const [source] = (0, $2sRUp.useSource)();
    const { isLoading: isLoading, validateX2CImport: validateX2CImport } = (0, $ap0Nu.useValidateX2CImport)(source);
    const onValidateFetchFail = (0, $eUqFw.useCallback)(()=>{
        showFlag((0, $6rHYD.VALIDATION_FAILED_FLAG));
    }, [
        showFlag
    ]);
    const handleOnNext = (0, $eUqFw.useCallback)(()=>{
        clearSelectedColumn();
        shouldStartImportOnNext ? startImport({
            projectData: projectData,
            onNext: onNext
        }) : onNext();
    }, [
        clearSelectedColumn,
        onNext,
        projectData,
        shouldStartImportOnNext,
        startImport
    ]);
    const handleOnReturn = (0, $eUqFw.useCallback)(()=>{
        clearSelectedColumn();
        onReturn();
    }, [
        clearSelectedColumn,
        onReturn
    ]);
    const onValidationError = (0, $eUqFw.useCallback)((err)=>{
        setMappingStateValidationError(err);
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'columnMappingValidation failed', {
            numberOfColumnErrors: Object.keys(err.columnErrors).length,
            missingFields: err.missingFields
        });
    }, [
        createAnalyticsEvent,
        setMappingStateValidationError
    ]);
    const onCloseUnmappedWarningModal = (0, $eUqFw.useCallback)(()=>{
        setIsUnmappedWarningModalOpen(false);
    }, []);
    const onNextOrOpenWarningModal = (0, $eUqFw.useCallback)(()=>{
        numVisibleUnmappedColumns === 0 ? handleOnNext() : setIsUnmappedWarningModalOpen(true);
    }, [
        numVisibleUnmappedColumns,
        handleOnNext
    ]);
    const validateOnContinue = (0, $eUqFw.useCallback)(()=>{
        if (mappingState === null || migrationId === null) return;
        validateX2CImport({
            migrationId: migrationId,
            mappingState: mappingState,
            advancedOptions: advancedOptions,
            onSuccess: onNextOrOpenWarningModal,
            onFetchFail: onValidateFetchFail,
            onValidationError: onValidationError
        });
    }, [
        mappingState,
        migrationId,
        validateX2CImport,
        advancedOptions,
        onNextOrOpenWarningModal,
        onValidateFetchFail,
        onValidationError
    ]);
    const hasValidationErrors = (0, $aWLVm.hasTableColumnErrors)(mappingState) || (0, $aWLVm.hasMissingFields)(mappingState);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: (0, $3yuWi.X2C_SCREENS).MAPPING,
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6cef73e9a5ed8be5$var$Wrapper, {
        "data-testid": "project-create-importer-upload-flow.ui.mapping-screen.wrapper",
        isCompact: isCompact
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6cef73e9a5ed8be5$export$7a582db85404fda3, {
        autoFocus: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2laZm.Header), {
        onCloseAndReturnToUploadStep: onCloseAndReturnToUploadStep,
        isCompactHeader: isCompact,
        offsetModalY: offsetModalY
    }), hasValidationErrors && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iuOqp.ValidationError), {
        showLearnMoreLink: showLearnMoreLink
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6cef73e9a5ed8be5$var$RowWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Ucrz.UnmappedColumnsBanner), {
        hasValidationErrors: hasValidationErrors
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1mEdD.FieldsDropdown), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5MhMl.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lzLxZ.default), {
        onSubmit: validateOnContinue
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("form", {
            ...formProps,
            "data-testid": "project-create-importer-upload-flow.ui.mapping-screen.form"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6cef73e9a5ed8be5$var$FooterWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6cef73e9a5ed8be5$var$ContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $84Q9E.MappingAdvancedOptions), null), !hideFeedback && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            testId: "project-create-importer-upload-flow.ui.mapping-screen.feedback-button",
            appearance: "link",
            spacing: "compact",
            onClick: onSubmitFeedbackClick,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d3vNK))), {
                label: ""
            })
        }, formatMessage((0, $2SUld.default).submitFeedbackCallToAction))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $elKPF.StepFooter), {
            onReturn: handleOnReturn,
            shouldStartImportOnNext: shouldStartImportOnNext,
            isLoading: isLoading,
            shouldDisableNext: shouldStartImportOnNext ? isStartImportDisabled : mappingState === null,
            nextButtonType: "submit",
            hasImportErrorOccurred: hasImportErrorOccurred,
            alignRight: rightAlignFooter
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hbUUM.UnmappedColumnsWarningModal), {
        isModalOpen: isUnmappedWarningModalOpen,
        onCancel: onCloseUnmappedWarningModal,
        onContinue: handleOnNext,
        offsetModalY: offsetModalY
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null), mappingState !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4oLAo.default), null))));
};
const $6cef73e9a5ed8be5$export$53931efe96888f5c = (props)=>{
    if ((0, $eI5EY.fg)('enable-x2c-standardised-flow')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2wmz9.CSVFieldMappingScreen), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6cef73e9a5ed8be5$export$c79b6465941604f5, props);
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6cef73e9a5ed8be5$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCompact: isCompact, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_cqtecp": (0, $9t7rW.default)(`${"var(--ds-space-300, 24px)"} ${__cmplp.isCompact ? 0 : "var(--ds-space-1000, 80px)"}`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1n261q9c _1bsb1osq _vchhusvi _1yt41471",
            __cmplp.isCompact ? "_bfhk1kw7" : "_bfhk1j9a",
            __cmplp.isCompact ? "_4t3i1osq" : "_4t3i1wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6cef73e9a5ed8be5$var$FooterWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zkb7n _i0dlghg7 _19pkpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6cef73e9a5ed8be5$var$ContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1q9y _otyru2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6cef73e9a5ed8be5$var$RowWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o _c71l1osq _otyrpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $6cef73e9a5ed8be5$export$7a582db85404fda3 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $6Pq2D.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _2lx21bp4 _4t3i1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("d3vNK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $98143944cdbffe97$var$_react = $98143944cdbffe97$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $98143944cdbffe97$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $98143944cdbffe97$var$CommentIcon = (props)=>/*#__PURE__*/ $98143944cdbffe97$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M4.998 11.513c0-3.038 3.141-5.51 7.002-5.51 3.861 0 7.002 2.472 7.002 5.51 0 3.039-3.141 5.51-7.002 5.51-3.861 0-7.002-2.471-7.002-5.51zm14.84 7.771v-.002s-1.564-2.26-.767-3.116l-.037.02C20.261 14.902 21 13.279 21 11.513 21 7.371 16.963 4 12 4s-9 3.37-9 7.513 4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003a.524.524 0 00.164.033.515.515 0 00.474-.716z"/><rect x="7" y="9" width="10" height="2" rx="1"/><rect x="7" y="12" width="5" height="2" rx="1"/></g></svg>`
    }, props));
$98143944cdbffe97$var$CommentIcon.displayName = 'CommentIcon';
var $98143944cdbffe97$var$_default = $98143944cdbffe97$var$CommentIcon;
module.exports.default = $98143944cdbffe97$var$_default;

});

parcelRegister("4oLAo", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fc7281c1ee25ebd$export$2e2bcd8739ae039);
/**
 * You are encouraged to use entry point export in src
 * However, at the time of development, this was mounted in JWM onboarding which had no relay environment
 * Hence we have this rll export as an alternative way to chunk the spotlight
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $8fc7281c1ee25ebd$var$X2COnboarding = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("fCgBS")), {
    ssr: false,
    moduleId: "./src/packages/project-create-importer/project-create-importer-onboarding/src/ui/main.tsx"
});
const $8fc7281c1ee25ebd$var$X2COnboardingAsync = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: (0, $b8facdd16b032a29$export$54c2b010e40afb87),
        packageName: (0, $b8facdd16b032a29$export$2cea7f14750b8c19)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "x2c-onboarding",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8fc7281c1ee25ebd$var$X2COnboarding, null)));
var $8fc7281c1ee25ebd$export$2e2bcd8739ae039 = $8fc7281c1ee25ebd$var$X2COnboardingAsync;

});
const $b8facdd16b032a29$export$af95284079b18767 = 'HEADER_DROPDOWN_X2C_NUDGE_STEP';
const $b8facdd16b032a29$export$26bb1007e6167496 = 'HEADER_X2C_NUDGE_STEP';
const $b8facdd16b032a29$export$2cea7f14750b8c19 = 'jira-business.project-create-importer-onboarding';
const $b8facdd16b032a29$export$54c2b010e40afb87 = 'asyncJWMX2CTourNudge';
const $b8facdd16b032a29$export$6826d33e9a2c0119 = 275;
const $b8facdd16b032a29$export$e0c37c09ff0ea77f = 'bottom left';
const $b8facdd16b032a29$export$293d9a36f5457b57 = 'right top';

parcelRegister("fCgBS", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('aAeYg')
        ]);
        const value = parcelRequire('hiDqS');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("aAeYg")
    ]).then(()=>parcelRequire('hiDqS'));
}

});


parcelRegister("1dxi7", function(module, exports) {

$parcel$export(module.exports, "useStartImportController", () => $bb51bf6328932fdb$export$18c02ac99a5d2c93);

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");

var $lCCwK = parcelRequire("lCCwK");

var $c0kt6 = parcelRequire("c0kt6");

var $bLalW = parcelRequire("bLalW");
var $aEdcH = parcelRequire("aEdcH");
var $lUC5l = parcelRequire("lUC5l");
var $4uta0 = parcelRequire("4uta0");
var $2sRUp = parcelRequire("2sRUp");
var $irKna = parcelRequire("irKna");

var $asXeB = parcelRequire("asXeB");
const $bb51bf6328932fdb$export$18c02ac99a5d2c93 = ({ thirdParty: thirdParty, isMultipleEntitiesSupported: isMultipleEntitiesSupported = false } = {})=>{
    const [migrationId, { setMigrationId: setMigrationId }] = (0, $4uta0.useMigrationId)();
    const [{ selectedEntityId: selectedEntityId, userEmails: userEmails, thirdPartyFieldConfigState: thirdPartyFieldConfigState, thirdPartyStatusMapping: thirdPartyStatusMapping, thirdPartyImportSettings: thirdPartyImportSettings, selectedWorkspaceId: selectedWorkspaceId, selectedEntities: selectedEntities }] = (0, $irKna.useThirdPartyState)();
    const [mappingState] = (0, $lUC5l.useMappingState)();
    const [advancedOptions] = (0, $bLalW.useAdvancedOptions)();
    const [source] = (0, $2sRUp.useSource)();
    const [serviceName] = (0, $aEdcH.useImportType)();
    const { isLoading: isLoading, hasErrorOccurred: hasErrorOccurred, startX2CImport: startX2CImport } = (0, $lCCwK.useStartX2CImport)(source, serviceName);
    const [, { setRequestAuthenticationToken: setRequestAuthenticationToken }] = (0, $asXeB.useAccessTokenModalState)();
    const { isLoading: isLoadingThirdPartyImport, hasErrorOccurred: hasThirdPartyErrorOccurred, startThirdPartyImport: startThirdPartyImport } = (0, $c0kt6.useStartThirdPartyImport)({
        thirdParty: thirdParty,
        requestAuthenticationToken: setRequestAuthenticationToken
    });
    const isImportLoading = isLoading || isLoadingThirdPartyImport;
    const hasImportErrorOccurred = hasErrorOccurred || hasThirdPartyErrorOccurred;
    const entityIsSelected = isMultipleEntitiesSupported ? (selectedEntities?.length || 0) > 0 : selectedEntityId !== null;
    const isStartImportDisabled = (mappingState === null || migrationId === null) && !entityIsSelected;
    const startImport = (0, $eUqFw.useCallback)(({ projectData: projectData, onNext: onNext })=>{
        const onThirdPartyImportSuccess = (migrationIdThirdParty)=>{
            setMigrationId(migrationIdThirdParty);
            onNext();
        };
        if (entityIsSelected && thirdParty) {
            startThirdPartyImport({
                projectData: projectData,
                selectedEntityId: (isMultipleEntitiesSupported ? selectedEntities && selectedEntities[0].id : selectedEntityId) || '',
                selectedEntities: selectedEntities,
                userEmails: userEmails,
                thirdPartyConfigState: thirdPartyFieldConfigState,
                thirdPartyStatusMapping: thirdPartyStatusMapping,
                importSettings: thirdPartyImportSettings,
                onSuccess: onThirdPartyImportSuccess,
                parentEntityId: (0, $eI5EY.fg)('jwm_clickup_importer') ? selectedWorkspaceId || undefined : undefined,
                isMultiEntity: isMultipleEntitiesSupported
            });
            return;
        }
        if (migrationId !== null && mappingState !== null) startX2CImport(migrationId, mappingState, projectData, advancedOptions, onNext);
    }, [
        advancedOptions,
        entityIsSelected,
        isMultipleEntitiesSupported,
        mappingState,
        migrationId,
        selectedEntities,
        selectedEntityId,
        selectedWorkspaceId,
        setMigrationId,
        startThirdPartyImport,
        startX2CImport,
        thirdParty,
        thirdPartyFieldConfigState,
        thirdPartyImportSettings,
        thirdPartyStatusMapping,
        userEmails
    ]);
    return {
        startImport: startImport,
        isImportLoading: isImportLoading,
        hasImportErrorOccurred: hasImportErrorOccurred,
        isStartImportDisabled: isStartImportDisabled
    };
};

});
parcelRegister("lCCwK", function(module, exports) {

$parcel$export(module.exports, "useStartX2CImport", () => $88375f80dc0a4864$export$babb75dc28545c67);

var $eUqFw = parcelRequire("eUqFw");

var $lyOYo = parcelRequire("lyOYo");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $lRmyA = parcelRequire("lRmyA");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $gyZoj = parcelRequire("gyZoj");
var $cpweK = parcelRequire("cpweK");
var $5GSA7 = parcelRequire("5GSA7");
var $acCHb = parcelRequire("acCHb");

var $dWLk9 = parcelRequire("dWLk9");

var $kzTj7 = parcelRequire("kzTj7");

var $3yuWi = parcelRequire("3yuWi");

var $jNdPf = parcelRequire("jNdPf");

var $il2VC = parcelRequire("il2VC");

var $h9TDD = parcelRequire("h9TDD");
const $88375f80dc0a4864$var$getStartX2CImportUrl = (cloudId, migrationId)=>`${0, $gyZoj.X2C_SERVICE_URL_PREFIX}/${cloudId}/import/csv/${migrationId}/start`;
const $88375f80dc0a4864$export$71da0ced5ef51ff = (cloudId, migrationId, payload)=>(0, $lRmyA.performPostRequest)($88375f80dc0a4864$var$getStartX2CImportUrl(cloudId, migrationId), {
        body: JSON.stringify(payload),
        headers: {
            'x-issynthetic-traffic': String((0, $cpweK.isSynthetic)()),
            'Content-Type': 'application/json'
        }
    });
const $88375f80dc0a4864$export$babb75dc28545c67 = (source, serviceName)=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [onExperienceStart, onExperienceSuccess, onExperienceFail] = (0, $5GSA7.useExperienceTracker)((0, $3yuWi.EXPERIENCES).START_IMPORT);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [hasErrorOccurred, setHasErrorOccurred] = (0, $eUqFw.useState)(false);
    const { storeMigrationId: storeMigrationId } = (0, $acCHb.useMigrationIdManager)();
    const analyticsAttributes = (0, $jNdPf.useAnalyticsAttributesContext)();
    const client = (0, $il2VC.useGetCSVImportClient)(source, serviceName);
    const startX2CImport = (0, $eUqFw.useCallback)(async (migrationId, mappingState, projectData, advancedOptions, onSuccess)=>{
        setIsLoading(true);
        setHasErrorOccurred(false);
        (0, $3yuWi.startImportInteractionMetric).start();
        onExperienceStart();
        try {
            const payload = (0, $h9TDD.transformToStartImportPayload)(mappingState, projectData, advancedOptions, (0, $1ybV0.ff)('x2c-issuelinking-frontend_tuyzk'));
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'import started', {
                numberOfColumnsInCSV: Object.keys(mappingState.columns).length,
                numberOfFieldsMappedAutomatically: mappingState.preMappedFieldCount,
                numberOfFieldsExcluded: Object.keys(mappingState.columns).filter((name)=>!mappingState.columns[name].isIncluded).length,
                numberOfColumnsToImport: payload.issueLinkColumns ? payload.columns.length + payload.issueLinkColumns.length : payload.columns.length,
                numberOfNewFieldsToCreate: payload.columns.filter((c)=>!!c.field && c.field.fieldId === null).length,
                numIssueLinksMapped: payload.issueLinkColumns ? payload.issueLinkColumns.length : 0,
                numJiraFieldsMapped: payload.columns.length,
                fileEncoding: payload.fileEncoding,
                delimiter: payload.delimiter,
                projectStyle: payload.projectData.style,
                accessLevel: payload.projectData.accessLevel,
                template: payload.projectData.template,
                shouldImportUsersToggle: mappingState.shouldImportUsers,
                numberOfPrefilledUsers: mappingState.preFilledUsersCount,
                usersMapped: payload.userMapping ? payload.userMapping.length : 0,
                numberOfUniqueUsers: mappingState.shouldImportUsers && payload.userMapping ? (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))(Object.values(payload.userMapping), 'userValue').filter((user)=>user.userValue).length : 0,
                ...payload.dateProperties
            });
            if ((0, $1ybV0.ff)('enable-importing-data-to-existing-project_k8uub')) await client.startImport({
                migrationId: migrationId,
                mappingState: mappingState,
                projectData: projectData,
                advancedOptions: advancedOptions
            });
            else await $88375f80dc0a4864$export$71da0ced5ef51ff(cloudId, migrationId, payload);
            setIsLoading(false);
            storeMigrationId(projectData.key, migrationId);
            (0, $3yuWi.startImportInteractionMetric).stop();
            onExperienceSuccess({
                migrationId: migrationId,
                ...analyticsAttributes
            });
            onSuccess();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $3yuWi.startImportInteractionMetric).stop();
            onExperienceFail((0, $kzTj7.APP_IDENTIFIER), error, {
                migrationId: migrationId,
                ...analyticsAttributes
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'start-x2c-import-error',
                    packageName: (0, $kzTj7.APP_IDENTIFIER),
                    teamName: (0, $gyZoj.APP_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true,
                error: error
            });
            setHasErrorOccurred(true);
            setIsLoading(false);
        }
    }, [
        onExperienceStart,
        createAnalyticsEvent,
        storeMigrationId,
        onExperienceSuccess,
        analyticsAttributes,
        client,
        cloudId,
        onExperienceFail
    ]);
    return {
        isLoading: isLoading,
        hasErrorOccurred: hasErrorOccurred,
        startX2CImport: startX2CImport
    };
};

});
parcelRegister("h9TDD", function(module, exports) {

$parcel$export(module.exports, "transformToStartImportPayload", () => $683748cbaf614204$export$c51069e52a3b1ede);

var $eI5EY = parcelRequire("eI5EY");

var $aWLVm = parcelRequire("aWLVm");
const $683748cbaf614204$export$c51069e52a3b1ede = (mappingState, projectData, advancedOptions, isIssueLinkingAllowed = false)=>({
        projectData: projectData,
        fileEncoding: advancedOptions.fileEncoding,
        delimiter: advancedOptions.delimiter,
        dateProperties: (0, $aWLVm.transformToDateProperties)(advancedOptions),
        columns: (0, $aWLVm.transformMappingStateToFieldMapping)(mappingState),
        ...isIssueLinkingAllowed && {
            issueLinkColumns: (0, $aWLVm.transformMappingStateToIssueLinkMapping)(mappingState)
        },
        ...mappingState.shouldImportUsers && (0, $eI5EY.fg)('enable-x2c-standardised-flow') && {
            userMapping: (0, $aWLVm.transformToUserEmailMappings)(mappingState)
        }
    });

});


parcelRegister("c0kt6", function(module, exports) {

$parcel$export(module.exports, "useStartThirdPartyImport", () => $8f7974a4d23624a3$export$7c4ddbcdb4abfbc);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $eI5EY = parcelRequire("eI5EY");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $gyZoj = parcelRequire("gyZoj");
var $5GSA7 = parcelRequire("5GSA7");
var $acCHb = parcelRequire("acCHb");

var $kzTj7 = parcelRequire("kzTj7");

var $3yuWi = parcelRequire("3yuWi");

var $aWLVm = parcelRequire("aWLVm");

var $jNdPf = parcelRequire("jNdPf");

var $8OWUq = parcelRequire("8OWUq");

var $1DPDL = parcelRequire("1DPDL");
const $8f7974a4d23624a3$export$7c4ddbcdb4abfbc = ({ thirdParty: thirdParty, requestAuthenticationToken: requestAuthenticationToken })=>{
    const thirdPartyClient = (0, $8OWUq.useThirdPartyClient)({
        thirdParty: thirdParty,
        requestAuthenticationToken: requestAuthenticationToken
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [onExperienceStart, onExperienceSuccess, onExperienceFail] = (0, $5GSA7.useExperienceTracker)((0, $3yuWi.EXPERIENCES).START_THIRD_PARTY_IMPORT);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [hasErrorOccurred, setHasErrorOccurred] = (0, $eUqFw.useState)(false);
    const { storeMigrationId: storeMigrationId } = (0, $acCHb.useMigrationIdManager)();
    const analtyticsAttributes = (0, $jNdPf.useAnalyticsAttributesContext)();
    const startThirdPartyImport = (0, $eUqFw.useCallback)(async (args)=>{
        const { projectData: projectData, selectedEntityId: selectedEntityId, selectedEntities: selectedEntities, userEmails: userEmails, thirdPartyConfigState: thirdPartyConfigState, thirdPartyStatusMapping: thirdPartyStatusMapping, importSettings: importSettings, onSuccess: onSuccess, parentEntityId: parentEntityId, isMultiEntity: isMultiEntity } = args;
        setIsLoading(true);
        setHasErrorOccurred(false);
        (0, $3yuWi.startThirdPartyImportInteractionMetric).start();
        onExperienceStart();
        try {
            const additionalProps = thirdPartyConfigState ? (0, $1DPDL.getImportAdditionalProps)({
                state: thirdPartyConfigState,
                importSettings: importSettings,
                thirdParty: thirdParty,
                statusMapping: thirdPartyStatusMapping
            }) : {
                additionalPayload: {},
                additionalAttributes: {}
            };
            const payload = {
                projectData: projectData,
                jiraUrl: (0, $aWLVm.getSiteUrl)(),
                userEmailMappings: userEmails,
                ...additionalProps.additionalPayload
            };
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'thirdPartyImport started', {
                thirdParty: thirdParty,
                numberOfSelectedEntities: isMultiEntity ? selectedEntities?.length : 1,
                ...additionalProps.additionalAttributes
            });
            const { migrationId: migrationId } = await thirdPartyClient.startImport({
                entityId: isMultiEntity ? selectedEntities && selectedEntities[0].id || '' : selectedEntityId,
                payload: payload,
                ...(0, $eI5EY.fg)('jwm_clickup_importer') && {
                    parentEntityId: parentEntityId
                },
                isMultiEntity: isMultiEntity
            });
            setIsLoading(false);
            storeMigrationId(projectData.key, migrationId);
            (0, $3yuWi.startThirdPartyImportInteractionMetric).stop();
            onExperienceSuccess({
                thirdParty: thirdParty || '',
                ...analtyticsAttributes
            });
            onSuccess(migrationId);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $3yuWi.startThirdPartyImportInteractionMetric).stop();
            onExperienceFail((0, $kzTj7.APP_IDENTIFIER), error, {
                thirdParty: thirdParty || '',
                ...analtyticsAttributes
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'start-third-party-import-error',
                    packageName: (0, $kzTj7.APP_IDENTIFIER),
                    teamName: (0, $gyZoj.APP_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true,
                error: error
            });
            setHasErrorOccurred(true);
            setIsLoading(false);
        }
    }, [
        onExperienceStart,
        thirdParty,
        createAnalyticsEvent,
        analtyticsAttributes,
        thirdPartyClient,
        storeMigrationId,
        onExperienceSuccess,
        onExperienceFail
    ]);
    return {
        isLoading: isLoading,
        hasErrorOccurred: hasErrorOccurred,
        startThirdPartyImport: startThirdPartyImport
    };
};

});
parcelRegister("8OWUq", function(module, exports) {

$parcel$export(module.exports, "useGetThirdPartyClient", () => $ef51b2d99f292c47$export$7706740229b1bee9);
$parcel$export(module.exports, "useThirdPartyClient", () => $ef51b2d99f292c47$export$73a99a9cb882d2c3);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dWLk9 = parcelRequire("dWLk9");

var $PVrB2 = parcelRequire("PVrB2");

var $3ak5x = parcelRequire("3ak5x");

var $cNWRm = parcelRequire("cNWRm");

var $9eJ7U = parcelRequire("9eJ7U");

var $bjfDf = parcelRequire("bjfDf");

var $ebdAn = parcelRequire("ebdAn");

var $4KEkw = parcelRequire("4KEkw");

var $jTXjR = parcelRequire("jTXjR");
const $ef51b2d99f292c47$export$7706740229b1bee9 = ({ requestAuthenticationToken: requestAuthenticationToken } = {})=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return (0, $eUqFw.useCallback)((thirdParty)=>{
        switch(thirdParty){
            case 0, $3ak5x.ASANA:
                return new (0, $cNWRm.AsanaClient)({
                    cloudId: cloudId,
                    formatMessage: formatMessage
                });
            case 0, $3ak5x.TRELLO:
                return new (0, $jTXjR.TrelloClient)({
                    cloudId: cloudId
                });
            case 0, $3ak5x.MONDAY:
                return new (0, $ebdAn.MondayClient)({
                    cloudId: cloudId,
                    formatMessage: formatMessage,
                    requestAuthenticationToken: requestAuthenticationToken ? ()=>requestAuthenticationToken({
                            thirdParty: (0, $3ak5x.MONDAY),
                            modalType: (0, $PVrB2.AccessTokenModalType).EXPIRED_TOKEN,
                            shouldCloseAndReturnToUploadStep: true
                        }) : undefined
                });
            case 0, $3ak5x.JIRA_SOFTWARE:
                return new (0, $bjfDf.JiraClient)({
                    cloudId: cloudId
                });
            case 0, $3ak5x.JIRA_BUSINESS:
                if ((0, $1ybV0.ff)('jira-business-to-software-project-imports')) return new (0, $bjfDf.JiraClient)({
                    cloudId: cloudId,
                    thirdPartyType: (0, $3ak5x.JIRA_BUSINESS)
                });
                return new (0, $4KEkw.NotSupportedClient)(thirdParty);
            case 0, $3ak5x.CLICK_UP:
                return new (0, $9eJ7U.ClickupClient)({
                    cloudId: cloudId,
                    formatMessage: formatMessage
                });
            default:
                return new (0, $4KEkw.NotSupportedClient)(thirdParty);
        }
    }, [
        cloudId,
        formatMessage,
        requestAuthenticationToken
    ]);
};
const $ef51b2d99f292c47$export$73a99a9cb882d2c3 = ({ thirdParty: thirdParty, requestAuthenticationToken: requestAuthenticationToken } = {})=>{
    const getThirdPartyClient = $ef51b2d99f292c47$export$7706740229b1bee9({
        requestAuthenticationToken: requestAuthenticationToken
    });
    return (0, $eUqFw.useMemo)(()=>thirdParty ? getThirdPartyClient(thirdParty) : new (0, $4KEkw.NotSupportedClient)(thirdParty), [
        getThirdPartyClient,
        thirdParty
    ]);
};

});
parcelRegister("cNWRm", function(module, exports) {

$parcel$export(module.exports, "AsanaClient", () => $5e8b83ccc6ae9550$export$3d68d0eed7039726);

var $1ybV0 = parcelRequire("1ybV0");

var $2OdyW = parcelRequire("2OdyW");
var $lRmyA = parcelRequire("lRmyA");

var $cpweK = parcelRequire("cpweK");
var $gyZoj = parcelRequire("gyZoj");

var $1KMAD = parcelRequire("1KMAD");
const $5e8b83ccc6ae9550$var$ENTITY_PAGE_LIMIT = 100;
class $5e8b83ccc6ae9550$export$3d68d0eed7039726 {
    constructor({ cloudId: cloudId, formatMessage: formatMessage }){
        this.BASE_HEADERS = {
            'x-issynthetic-traffic': String((0, $cpweK.isSynthetic)()),
            'x-migration-authentication-type': 'oauth'
        };
        this.BASE_URL = `${0, $gyZoj.X2C_SERVICE_URL_PREFIX}/${cloudId}/import/asana`;
        this.formatMessage = formatMessage;
    }
    async getEntities({ workspaceId: workspaceId }) {
        const url = `${this.BASE_URL}/workspaces/${workspaceId}/projects`;
        return (0, $2OdyW.default)(url, {
            method: 'GET',
            headers: this.BASE_HEADERS
        });
    }
    getEntitiesPage({ workspaceId: workspaceId, offset: offset }) {
        const url = `${this.BASE_URL}/workspaces/${workspaceId}/projects/page?limit=${$5e8b83ccc6ae9550$var$ENTITY_PAGE_LIMIT}`;
        const urlWithOffset = offset ? `${url}&offset=${offset}` : url;
        return (0, $2OdyW.default)(urlWithOffset, {
            method: 'GET',
            headers: this.BASE_HEADERS
        });
    }
    searchEntities({ workspaceId: workspaceId, query: query }) {
        const url = `${this.BASE_URL}/workspaces/${workspaceId}/projects/search?query=${encodeURIComponent(query)}`;
        return (0, $2OdyW.default)(url, {
            method: 'GET',
            headers: this.BASE_HEADERS
        }).then((resp)=>resp.data);
    }
    getEntityStats({ entityId: entityId }) {
        const url = `${this.BASE_URL}/project/${entityId}/stats`;
        return (0, $2OdyW.default)(url, {
            method: 'GET',
            headers: {
                ...this.BASE_HEADERS
            }
        });
    }
    getEntityMembers() {
        return Promise.reject(new Error('getEntityMembers method is not implemented in Asana'));
    }
    getWorkspaces() {
        const url = `${this.BASE_URL}/workspaces`;
        return (0, $2OdyW.default)(url, {
            method: 'GET',
            headers: this.BASE_HEADERS
        });
    }
    startImport({ entityId: entityId, payload: payload }) {
        const url = `${this.BASE_URL}/project/${entityId}/migration/start`;
        return (0, $lRmyA.performPostRequest)(url, {
            body: JSON.stringify(payload),
            headers: {
                ...this.BASE_HEADERS,
                'Content-Type': 'application/json'
            }
        });
    }
    async getFieldConfig({ entityId: entityId, entities: entities, projectData: projectData }) {
        if (entities.length === 0 && (0, $1ybV0.ff)('x2c-clickup-importer-multi-list')) return Promise.reject(new Error('No entities provided'));
        const url = (0, $1ybV0.ff)('x2c-clickup-importer-multi-list') ? `${this.BASE_URL}/project/${entities[0].id}/fields` : `${this.BASE_URL}/project/${entityId}/fields`;
        const data = await (0, $2OdyW.default)(url, {
            method: 'POST',
            body: JSON.stringify({
                projectDetails: {
                    type: projectData.type,
                    style: projectData.style
                }
            }),
            headers: this.BASE_HEADERS
        });
        const thirdPartyFieldMappings = data.thirdPartyFieldMappings.map((0, $1KMAD.sanitizeAsanaFieldNames)(this.formatMessage));
        return {
            ...data,
            thirdPartyFieldMappings: thirdPartyFieldMappings
        };
    }
    validateAccessToken() {
        return Promise.reject(new Error('validateAccessToken method is not implemented in Asana'));
    }
    postAccessToken() {
        return Promise.reject(new Error('postAccessToken method is not implemented in Asana'));
    }
    getFolders() {
        return Promise.reject(new Error('getFolders method is not implemented in Asana'));
    }
    getSiteName() {
        return Promise.reject(new Error('getSiteName method is not implemented in Asana'));
    }
    getSpaces() {
        return Promise.reject(new Error('getSpaces method is not implemented in Asana'));
    }
    getMultiEntityStats() {
        return Promise.reject(new Error('getMultiEntityStats method is not implemented in Asana'));
    }
    getMultiEntityStatuses() {
        return Promise.reject(new Error('getMultiEntityStatuses method is not implemented in Asana'));
    }
}

});
parcelRegister("1KMAD", function(module, exports) {

$parcel$export(module.exports, "sanitizeAsanaFieldNames", () => $7edf445efb3552e0$export$5523234c6a9ce7e8);

var $a6DaD = parcelRequire("a6DaD");

var $iZnSg = parcelRequire("iZnSg");
const $7edf445efb3552e0$export$e3f88bd67bda208c = (fieldId, formatMessage)=>{
    switch(fieldId){
        case 0, $a6DaD.ASANA_ASSIGNEE_FIELD_ID:
            return formatMessage((0, $iZnSg.default).asanaAssignee);
        case 0, $a6DaD.ASANA_NAME_FIELD_ID:
            return formatMessage((0, $iZnSg.default).asanaName);
        case 0, $a6DaD.ASANA_SECTION_FIELD_ID:
            return formatMessage((0, $iZnSg.default).asanaSection);
        case 0, $a6DaD.ASANA_DESCRIPTION_FIELD_ID:
            return formatMessage((0, $iZnSg.default).asanaDescription);
        case 0, $a6DaD.ASANA_DUE_ON_FIELD_ID:
            return formatMessage((0, $iZnSg.default).asanaDueOn);
        case 0, $a6DaD.ASANA_START_DATE_FIELD_ID:
            return formatMessage((0, $iZnSg.default).asanaStartDate);
        case 0, $a6DaD.ASANA_COLLABORATORS_FIELD_ID:
            return formatMessage((0, $iZnSg.default).asanaCollaborators);
        case 0, $a6DaD.ASANA_LIKES_FIELD_ID:
            return formatMessage((0, $iZnSg.default).asanaLikes);
        case 0, $a6DaD.ASANA_TAGS_FIELD_ID:
            return formatMessage((0, $iZnSg.default).asanaTags);
        case 0, $a6DaD.ASANA_CREATED_BY_FIELD_ID:
            return formatMessage((0, $iZnSg.default).asanaCreatedBy);
        default:
            return '';
    }
};
const $7edf445efb3552e0$export$5523234c6a9ce7e8 = (formatMessage)=>({ thirdPartyField: thirdPartyField, ...rest })=>({
            ...rest,
            thirdPartyField: {
                ...thirdPartyField,
                fieldName: thirdPartyField.fieldName ? thirdPartyField.fieldName : $7edf445efb3552e0$export$e3f88bd67bda208c(thirdPartyField.fieldId, formatMessage)
            }
        });

});
parcelRegister("a6DaD", function(module, exports) {

$parcel$export(module.exports, "ASANA_ASSIGNEE_FIELD_ID", () => $594db2c5e6581c7c$export$cbd7cf9b82dfa361);
$parcel$export(module.exports, "ASANA_NAME_FIELD_ID", () => $594db2c5e6581c7c$export$f80580ecc832e07f);
$parcel$export(module.exports, "ASANA_SECTION_FIELD_ID", () => $594db2c5e6581c7c$export$69a8c8816efb5937);
$parcel$export(module.exports, "ASANA_DESCRIPTION_FIELD_ID", () => $594db2c5e6581c7c$export$b108b61b559c689);
$parcel$export(module.exports, "ASANA_DUE_ON_FIELD_ID", () => $594db2c5e6581c7c$export$12179c6c512d9036);
$parcel$export(module.exports, "ASANA_START_DATE_FIELD_ID", () => $594db2c5e6581c7c$export$8bf826237fc05693);
$parcel$export(module.exports, "ASANA_COLLABORATORS_FIELD_ID", () => $594db2c5e6581c7c$export$6553d28e6bfe5205);
$parcel$export(module.exports, "ASANA_LIKES_FIELD_ID", () => $594db2c5e6581c7c$export$ec86cec975bd09fc);
$parcel$export(module.exports, "ASANA_TAGS_FIELD_ID", () => $594db2c5e6581c7c$export$b4c6314204f31ecc);
$parcel$export(module.exports, "ASANA_CREATED_BY_FIELD_ID", () => $594db2c5e6581c7c$export$6d43735e0c96fe81);

var $aYMEC = parcelRequire("aYMEC");
const $594db2c5e6581c7c$export$cbd7cf9b82dfa361 = 'assignee';
const $594db2c5e6581c7c$export$f80580ecc832e07f = 'name';
const $594db2c5e6581c7c$export$69a8c8816efb5937 = (0, $aYMEC.SECTION);
const $594db2c5e6581c7c$export$b108b61b559c689 = 'notes';
const $594db2c5e6581c7c$export$12179c6c512d9036 = 'due_on';
const $594db2c5e6581c7c$export$8bf826237fc05693 = 'start_on';
const $594db2c5e6581c7c$export$6553d28e6bfe5205 = 'followers';
const $594db2c5e6581c7c$export$ec86cec975bd09fc = 'likes';
const $594db2c5e6581c7c$export$b4c6314204f31ecc = 'tags';
const $594db2c5e6581c7c$export$6d43735e0c96fe81 = 'created_by';

});
parcelRegister("aYMEC", function(module, exports) {

$parcel$export(module.exports, "SECTION", () => $91e0a0a10938e5b7$export$524548702ba0011d);
$parcel$export(module.exports, "TASK", () => $91e0a0a10938e5b7$export$9355e489ad16f98e);
$parcel$export(module.exports, "SUBTASK", () => $91e0a0a10938e5b7$export$395dd73a4f46241b);
$parcel$export(module.exports, "NESTED_SUBTASK", () => $91e0a0a10938e5b7$export$e005ce39b6b3dd7e);
$parcel$export(module.exports, "GROUP", () => $91e0a0a10938e5b7$export$2b9b886dddb4ba32);
$parcel$export(module.exports, "ITEM", () => $91e0a0a10938e5b7$export$25d99ac3e552cf7a);
$parcel$export(module.exports, "SUBITEM", () => $91e0a0a10938e5b7$export$3a82114f77fb6462);
$parcel$export(module.exports, "LIST", () => $91e0a0a10938e5b7$export$84cc8e12a434d4e);
$parcel$export(module.exports, "AsanaHierarchyTypes", () => $91e0a0a10938e5b7$export$72302d8b5565ab9d);
$parcel$export(module.exports, "MondayHierarchyTypes", () => $91e0a0a10938e5b7$export$348d3e6a95eaa3c0);
$parcel$export(module.exports, "ClickupHierarchyTypes", () => $91e0a0a10938e5b7$export$78f39ac610be5529);
const $91e0a0a10938e5b7$export$524548702ba0011d = 'section';
const $91e0a0a10938e5b7$export$9355e489ad16f98e = 'task';
const $91e0a0a10938e5b7$export$395dd73a4f46241b = 'subtask';
const $91e0a0a10938e5b7$export$e005ce39b6b3dd7e = 'nested subtask';
const $91e0a0a10938e5b7$export$2b9b886dddb4ba32 = 'group';
const $91e0a0a10938e5b7$export$25d99ac3e552cf7a = 'item';
const $91e0a0a10938e5b7$export$3a82114f77fb6462 = 'subitem';
const $91e0a0a10938e5b7$export$84cc8e12a434d4e = 'list';
const $91e0a0a10938e5b7$export$72302d8b5565ab9d = [
    $91e0a0a10938e5b7$export$524548702ba0011d,
    $91e0a0a10938e5b7$export$9355e489ad16f98e,
    $91e0a0a10938e5b7$export$395dd73a4f46241b,
    $91e0a0a10938e5b7$export$e005ce39b6b3dd7e
];
const $91e0a0a10938e5b7$export$348d3e6a95eaa3c0 = [
    $91e0a0a10938e5b7$export$2b9b886dddb4ba32,
    $91e0a0a10938e5b7$export$25d99ac3e552cf7a,
    $91e0a0a10938e5b7$export$3a82114f77fb6462
];
const $91e0a0a10938e5b7$export$78f39ac610be5529 = [
    $91e0a0a10938e5b7$export$84cc8e12a434d4e,
    $91e0a0a10938e5b7$export$9355e489ad16f98e,
    $91e0a0a10938e5b7$export$395dd73a4f46241b,
    $91e0a0a10938e5b7$export$e005ce39b6b3dd7e
];

});


parcelRegister("iZnSg", function(module, exports) {

$parcel$export(module.exports, "default", () => $d927d27242463be3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d927d27242463be3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    asanaAssignee: {
        "id": "project-create-importer-upload-flow.common.utils.third-party-clients.asana.asana-assignee",
        "defaultMessage": "Assignee"
    },
    asanaName: {
        "id": "project-create-importer-upload-flow.common.utils.third-party-clients.asana.asana-name",
        "defaultMessage": "Task name"
    },
    asanaSection: {
        "id": "project-create-importer-upload-flow.common.utils.third-party-clients.asana.asana-section",
        "defaultMessage": "Section"
    },
    asanaDescription: {
        "id": "project-create-importer-upload-flow.common.utils.third-party-clients.asana.asana-description",
        "defaultMessage": "Description"
    },
    asanaDueOn: {
        "id": "project-create-importer-upload-flow.common.utils.third-party-clients.asana.asana-due-on",
        "defaultMessage": "Due on"
    },
    asanaStartDate: {
        "id": "project-create-importer-upload-flow.common.utils.third-party-clients.asana.asana-start-date",
        "defaultMessage": "Start date"
    },
    asanaCollaborators: {
        "id": "project-create-importer-upload-flow.common.utils.third-party-clients.asana.asana-collaborators",
        "defaultMessage": "Collaborators"
    },
    asanaLikes: {
        "id": "project-create-importer-upload-flow.common.utils.third-party-clients.asana.asana-likes",
        "defaultMessage": "Likes"
    },
    asanaTags: {
        "id": "project-create-importer-upload-flow.common.utils.third-party-clients.asana.asana-tags",
        "defaultMessage": "Tags"
    },
    asanaCreatedBy: {
        "id": "project-create-importer-upload-flow.common.utils.third-party-clients.asana.asana-created-by",
        "defaultMessage": "Created by"
    }
});

});



parcelRegister("9eJ7U", function(module, exports) {

$parcel$export(module.exports, "ClickupClient", () => $574c1032d192f4fe$export$c76ced09776bbd0a);

var $1ybV0 = parcelRequire("1ybV0");

var $2OdyW = parcelRequire("2OdyW");
var $lRmyA = parcelRequire("lRmyA");

var $cpweK = parcelRequire("cpweK");
var $gyZoj = parcelRequire("gyZoj");

var $dmwfW = parcelRequire("dmwfW");

var $jjAZS = parcelRequire("jjAZS");
class $574c1032d192f4fe$export$c76ced09776bbd0a {
    constructor({ cloudId: cloudId, formatMessage: formatMessage }){
        this.BASE_HEADERS = {
            'x-issynthetic-traffic': String((0, $cpweK.isSynthetic)()),
            'x-migration-authentication-type': 'oauth'
        };
        this.BASE_URL = `${0, $gyZoj.X2C_SERVICE_URL_PREFIX}/${cloudId}/import/clickup`;
        this.formatMessage = formatMessage;
    }
    async getEntities({ spaceId: spaceId, folderIds: folderIds }) {
        let url = `${this.BASE_URL}/space/${spaceId}/lists`;
        if (folderIds) url = `${url}?folderId=${folderIds}`;
        const entities = await (0, $2OdyW.default)(url, {
            method: 'GET',
            headers: this.BASE_HEADERS
        });
        return entities;
    }
    getEntitiesPage() {
        return Promise.reject(new Error('getEntitiesPage method is not implemented in Clickup'));
    }
    searchEntities() {
        return Promise.reject(new Error('searchEntities method is not implemented in Clickup'));
    }
    getEntityStats({ entityId: entityId }) {
        const url = `${this.BASE_URL}/list/${entityId}/stats`;
        return (0, $2OdyW.default)(url, {
            method: 'GET',
            headers: {
                ...this.BASE_HEADERS
            }
        });
    }
    getMultiEntityStats({ entityIds: entityIds }) {
        const url = `${this.BASE_URL}/list/stats`;
        return (0, $2OdyW.default)(url, {
            method: 'POST',
            body: JSON.stringify({
                listIds: entityIds
            }),
            headers: this.BASE_HEADERS
        });
    }
    getEntityMembers() {
        return Promise.reject(new Error('getEntityMembers method is not implemented in Clickup'));
    }
    getWorkspaces() {
        const url = `${this.BASE_URL}/workspaces`;
        return (0, $2OdyW.default)(url, {
            method: 'GET',
            headers: this.BASE_HEADERS
        });
    }
    startImport({ entityId: entityId, parentEntityId: parentEntityId, isMultiEntity: isMultiEntity = false, payload: payload }) {
        const url = isMultiEntity ? `${this.BASE_URL}/workspace/${parentEntityId}/list/migration/start` : `${this.BASE_URL}/workspace/${parentEntityId}/list/${entityId}/migration/start`;
        return (0, $lRmyA.performPostRequest)(url, {
            body: JSON.stringify(payload),
            headers: {
                ...this.BASE_HEADERS,
                'Content-Type': 'application/json'
            }
        });
    }
    async getFieldConfig({ entityId: entityId, entities: entities, projectData: projectData }) {
        if (entities.length === 0 && (0, $1ybV0.ff)('x2c-clickup-importer-multi-list')) return Promise.reject(new Error('No entities provided'));
        const url = (0, $1ybV0.ff)('x2c-clickup-importer-multi-list') ? `${this.BASE_URL}/list/fields` : `${this.BASE_URL}/list/${entityId}/fields`;
        const data = await (0, $2OdyW.default)(url, {
            method: 'POST',
            body: JSON.stringify({
                projectDetails: {
                    type: projectData.type,
                    style: projectData.style
                },
                ...(0, $1ybV0.ff)('x2c-clickup-importer-multi-list') ? {
                    entities: entities
                } : {}
            }),
            headers: this.BASE_HEADERS
        });
        return {
            ...data,
            itemTypes: (0, $jjAZS.mapItemTypes)(data.itemTypes, this.formatMessage)
        };
    }
    validateAccessToken() {
        return Promise.reject(new Error('validateAccessToken method is not implemented in Clickup'));
    }
    postAccessToken() {
        return Promise.reject(new Error('postAccessToken method is not implemented in Clickup'));
    }
    async getFolders({ entityId: entityId }) {
        const url = `${this.BASE_URL}/space/${entityId}/folders`;
        const folders = await (0, $2OdyW.default)(url, {
            method: 'GET',
            headers: this.BASE_HEADERS
        });
        const data = (0, $dmwfW.transformToFolderAndSubfolderState)(folders);
        return data;
    }
    getSiteName() {
        return Promise.reject(new Error('getSiteName method is not implemented in Clickup'));
    }
    getSpaces({ workspaceId: workspaceId }) {
        const url = `${this.BASE_URL}/workspace/${workspaceId}/spaces`;
        return (0, $2OdyW.default)(url, {
            method: 'GET',
            headers: this.BASE_HEADERS
        });
    }
    getMultiEntityStatuses({ entityIds: entityIds, projectData: projectData }) {
        const url = `${this.BASE_URL}/list/statuses`;
        return (0, $2OdyW.default)(url, {
            method: 'POST',
            body: JSON.stringify({
                projectDetails: {
                    type: projectData.type,
                    style: projectData.style
                },
                listIds: entityIds
            }),
            headers: this.BASE_HEADERS
        });
    }
}

});
parcelRegister("dmwfW", function(module, exports) {

$parcel$export(module.exports, "handleAuthenticationFactory", () => $d9385723f9018efe$export$9e52153f4f4fc1a0);
$parcel$export(module.exports, "transformToFolderAndSubfolderState", () => $d9385723f9018efe$export$aa66693fa22c6580);

var $7byHA = parcelRequire("7byHA");
// Currently each request creates a new ThirdPartyClient, so this needs to be a global variable.
// TODO: We should fix this to make each third party use the same ThirdPartyClient https://hello.atlassian.net/browse/GUN-2124
let $d9385723f9018efe$var$multiplesAuthenticationProps = {
    isRequestingAuthentication: false,
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    requestFailedByAuthentication: []
};
const $d9385723f9018efe$export$9fdc5d19d81ae644 = ()=>{
    $d9385723f9018efe$var$multiplesAuthenticationProps = {
        isRequestingAuthentication: false,
        requestFailedByAuthentication: []
    };
};
const $d9385723f9018efe$export$9e52153f4f4fc1a0 = ({ retries: retries, requestAuthenticationToken: requestAuthenticationToken })=>async (doRequest)=>{
        if (retries < 0) throw new Error('Too many authentication retries');
        let response;
        try {
            response = await doRequest();
        } catch (error) {
            if (error instanceof (0, $7byHA.default) && error.statusCode === 400 && error.originalResponse && (await error.originalResponse.json()).errorCode === 'INVALID_AUTH_TOKEN') {
                let resolve;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                let reject;
                const promise = new Promise((r, rj)=>{
                    resolve = r;
                    reject = rj;
                });
                $d9385723f9018efe$var$multiplesAuthenticationProps.requestFailedByAuthentication.push(()=>doRequest().then(resolve, reject));
                if (!$d9385723f9018efe$var$multiplesAuthenticationProps.isRequestingAuthentication) {
                    $d9385723f9018efe$var$multiplesAuthenticationProps.isRequestingAuthentication = true;
                    const done = await requestAuthenticationToken();
                    if (!done) {
                        $d9385723f9018efe$export$9fdc5d19d81ae644();
                        throw new Error('Authentication cancelled');
                    }
                    $d9385723f9018efe$var$multiplesAuthenticationProps.isRequestingAuthentication = false;
                    const factory = $d9385723f9018efe$export$9e52153f4f4fc1a0({
                        retries: retries - 1,
                        requestAuthenticationToken: requestAuthenticationToken
                    });
                    await Promise.allSettled($d9385723f9018efe$var$multiplesAuthenticationProps.requestFailedByAuthentication.map((doRequestAgain)=>factory(doRequestAgain).catch(reject)));
                    $d9385723f9018efe$var$multiplesAuthenticationProps.requestFailedByAuthentication = [];
                }
                return promise;
            }
            throw error;
        }
        return response;
    };
const $d9385723f9018efe$export$aa66693fa22c6580 = (data)=>{
    const subfolders = {};
    const folders = data.map((folder)=>{
        if (folder.subfolders && folder.subfolders.length > 0) subfolders[folder.id] = folder.subfolders;
        return {
            id: folder.id,
            name: folder.name
        };
    });
    return {
        folders: folders,
        subfolders: subfolders
    };
};

});

parcelRegister("jjAZS", function(module, exports) {

$parcel$export(module.exports, "mapItemTypes", () => $0a12bb01c3d906ef$export$ebf64e99c6a48fdb);

var $cuqXL = parcelRequire("cuqXL");

var $fGKD8 = parcelRequire("fGKD8");
const $0a12bb01c3d906ef$var$getFieldNameForThirdPartyFieldId = (fieldType, formatMessage)=>{
    switch(fieldType){
        case 0, $cuqXL.CLICKUP_ASSIGNEES:
            return formatMessage((0, $fGKD8.default).clickupAssignees);
        case 0, $cuqXL.CLICKUP_CREATOR:
            return formatMessage((0, $fGKD8.default).clickupCreator);
        case 0, $cuqXL.CLICKUP_WATCHERS:
            return formatMessage((0, $fGKD8.default).clickupWatchers);
        case 0, $cuqXL.CLICKUP_DESCRIPTION:
            return formatMessage((0, $fGKD8.default).clickupDescription);
        case 0, $cuqXL.CLICKUP_NAME:
            return formatMessage((0, $fGKD8.default).clickupName);
        case 0, $cuqXL.CLICKUP_TAGS:
            return formatMessage((0, $fGKD8.default).clickupTags);
        case 0, $cuqXL.CLICKUP_STATUS:
            return formatMessage((0, $fGKD8.default).clickupStatus);
        case 0, $cuqXL.CLICKUP_PRIORITY:
            return formatMessage((0, $fGKD8.default).clickupPriority);
        case 0, $cuqXL.CLICKUP_DUE_DATE:
            return formatMessage((0, $fGKD8.default).clickupDueDate);
        case 0, $cuqXL.CLICKUP_START_DATE:
            return formatMessage((0, $fGKD8.default).clickupStartDate);
        case 0, $cuqXL.CLICKUP_SPRINT_POINTS:
            return formatMessage((0, $fGKD8.default).clickupSprintPoints);
        case 0, $cuqXL.CLICKUP_TIME_SPENT:
            return formatMessage((0, $fGKD8.default).clickupTimeSpent);
        case 0, $cuqXL.CLICKUP_TIME_ESTIMATE:
            return formatMessage((0, $fGKD8.default).clickupTimeEstimate);
        default:
            return '';
    }
};
const $0a12bb01c3d906ef$export$ebf64e99c6a48fdb = (itemTypes, formatMessage)=>{
    if (!itemTypes) return [];
    return itemTypes.map((itemType)=>({
            ...itemType,
            itemTypeFieldMappings: itemType.itemTypeFieldMappings.map((fieldMapping)=>{
                const { fieldId: fieldId, fieldName: fieldName } = fieldMapping.thirdPartyField;
                return {
                    ...fieldMapping,
                    thirdPartyField: {
                        ...fieldMapping.thirdPartyField,
                        // We only translate system fields and retain the custom field names as is
                        fieldName: (0, $cuqXL.CLICKUP_SYSTEM_FIELDS).includes(fieldId) ? $0a12bb01c3d906ef$var$getFieldNameForThirdPartyFieldId(fieldId, formatMessage) : fieldName
                    }
                };
            })
        }));
};

});
parcelRegister("cuqXL", function(module, exports) {

$parcel$export(module.exports, "CLICKUP_ASSIGNEES", () => $23756c28e826faf9$export$9168cd2b2071abfb);
$parcel$export(module.exports, "CLICKUP_CREATOR", () => $23756c28e826faf9$export$849e07dce8a2163c);
$parcel$export(module.exports, "CLICKUP_WATCHERS", () => $23756c28e826faf9$export$4986ee0b6ba851cf);
$parcel$export(module.exports, "CLICKUP_DESCRIPTION", () => $23756c28e826faf9$export$12f93c2fb1118094);
$parcel$export(module.exports, "CLICKUP_NAME", () => $23756c28e826faf9$export$e8867b091465b151);
$parcel$export(module.exports, "CLICKUP_STATUS", () => $23756c28e826faf9$export$62f487617a5ce5ec);
$parcel$export(module.exports, "CLICKUP_TAGS", () => $23756c28e826faf9$export$3be1469333f19d12);
$parcel$export(module.exports, "CLICKUP_PRIORITY", () => $23756c28e826faf9$export$a0588f9a3eb6dd9c);
$parcel$export(module.exports, "CLICKUP_DUE_DATE", () => $23756c28e826faf9$export$b25da76969f58dfd);
$parcel$export(module.exports, "CLICKUP_START_DATE", () => $23756c28e826faf9$export$fc9fe3f685e73ca2);
$parcel$export(module.exports, "CLICKUP_SPRINT_POINTS", () => $23756c28e826faf9$export$d0e2509287c1d26b);
$parcel$export(module.exports, "CLICKUP_TIME_ESTIMATE", () => $23756c28e826faf9$export$4f235fd9380c6505);
$parcel$export(module.exports, "CLICKUP_TIME_SPENT", () => $23756c28e826faf9$export$b15314c860fefe4c);
$parcel$export(module.exports, "CLICKUP_SYSTEM_FIELDS", () => $23756c28e826faf9$export$7e78195af6e5c9d8);
// System fields
const $23756c28e826faf9$export$9168cd2b2071abfb = 'assignees';
const $23756c28e826faf9$export$849e07dce8a2163c = 'creator';
const $23756c28e826faf9$export$4986ee0b6ba851cf = 'watchers';
const $23756c28e826faf9$export$12f93c2fb1118094 = 'description';
const $23756c28e826faf9$export$e8867b091465b151 = 'name';
const $23756c28e826faf9$export$62f487617a5ce5ec = 'status';
const $23756c28e826faf9$export$3be1469333f19d12 = 'tags';
const $23756c28e826faf9$export$a0588f9a3eb6dd9c = 'priority';
const $23756c28e826faf9$export$b25da76969f58dfd = 'due_date';
const $23756c28e826faf9$export$fc9fe3f685e73ca2 = 'start_date';
const $23756c28e826faf9$export$d0e2509287c1d26b = 'points';
const $23756c28e826faf9$export$4f235fd9380c6505 = 'time_estimate';
const $23756c28e826faf9$export$b15314c860fefe4c = 'time_spent';
const $23756c28e826faf9$export$7e78195af6e5c9d8 = [
    $23756c28e826faf9$export$9168cd2b2071abfb,
    $23756c28e826faf9$export$849e07dce8a2163c,
    $23756c28e826faf9$export$4986ee0b6ba851cf,
    $23756c28e826faf9$export$12f93c2fb1118094,
    $23756c28e826faf9$export$e8867b091465b151,
    $23756c28e826faf9$export$62f487617a5ce5ec,
    $23756c28e826faf9$export$3be1469333f19d12,
    $23756c28e826faf9$export$a0588f9a3eb6dd9c,
    $23756c28e826faf9$export$b25da76969f58dfd,
    $23756c28e826faf9$export$fc9fe3f685e73ca2,
    $23756c28e826faf9$export$d0e2509287c1d26b,
    $23756c28e826faf9$export$4f235fd9380c6505,
    $23756c28e826faf9$export$b15314c860fefe4c
];

});

parcelRegister("fGKD8", function(module, exports) {

$parcel$export(module.exports, "default", () => $8456075be471c6ba$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8456075be471c6ba$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    clickupAssignees: {
        "id": "project-create-importer-upload-flow.common.utils.third-party-clients.clickup.clickup-assignees",
        "defaultMessage": "Assignees"
    },
    clickupCreator: {
        "id": "project-create-importer-upload-flow.common.utils.third-party-clients.clickup.clickup-creator",
        "defaultMessage": "Creator"
    },
    clickupWatchers: {
        "id": "project-create-importer-upload-flow.common.utils.third-party-clients.clickup.clickup-watchers",
        "defaultMessage": "Watchers"
    },
    clickupName: {
        "id": "project-create-importer-upload-flow.common.utils.third-party-clients.clickup.clickup-name",
        "defaultMessage": "Name"
    },
    clickupDescription: {
        "id": "project-create-importer-upload-flow.common.utils.third-party-clients.clickup.clickup-description",
        "defaultMessage": "Description"
    },
    clickupDueDate: {
        "id": "project-create-importer-upload-flow.common.utils.third-party-clients.clickup.clickup-due-date",
        "defaultMessage": "Due date"
    },
    clickupStartDate: {
        "id": "project-create-importer-upload-flow.common.utils.third-party-clients.clickup.clickup-start-date",
        "defaultMessage": "Start date"
    },
    clickupTags: {
        "id": "project-create-importer-upload-flow.common.utils.third-party-clients.clickup.clickup-tags",
        "defaultMessage": "Tags"
    },
    clickupStatus: {
        "id": "project-create-importer-upload-flow.common.utils.third-party-clients.clickup.clickup-status",
        "defaultMessage": "Status"
    },
    clickupPriority: {
        "id": "project-create-importer-upload-flow.common.utils.third-party-clients.clickup.clickup-priority",
        "defaultMessage": "Priority"
    },
    clickupSprintPoints: {
        "id": "project-create-importer-upload-flow.common.utils.third-party-clients.clickup.clickup-sprint-points",
        "defaultMessage": "Points"
    },
    clickupTimeSpent: {
        "id": "project-create-importer-upload-flow.common.utils.third-party-clients.clickup.clickup-time-spent",
        "defaultMessage": "Time spent"
    },
    clickupTimeEstimate: {
        "id": "project-create-importer-upload-flow.common.utils.third-party-clients.clickup.clickup-time-estimate",
        "defaultMessage": "Time estimate"
    }
});

});



parcelRegister("bjfDf", function(module, exports) {

$parcel$export(module.exports, "JiraClient", () => $50af04fb7c0b9183$export$b3502e4412baa702);

var $1ybV0 = parcelRequire("1ybV0");

var $2OdyW = parcelRequire("2OdyW");
var $lRmyA = parcelRequire("lRmyA");

var $cpweK = parcelRequire("cpweK");
var $gyZoj = parcelRequire("gyZoj");

var $3ak5x = parcelRequire("3ak5x");
class $50af04fb7c0b9183$export$b3502e4412baa702 {
    constructor({ cloudId: cloudId, thirdPartyType: thirdPartyType }){
        this.BASE_HEADERS = {
            'x-issynthetic-traffic': String((0, $cpweK.isSynthetic)())
        };
        this.BASE_URL = `${0, $gyZoj.X2C_SERVICE_URL_PREFIX}/${cloudId}/import/jsw`;
        if ((0, $1ybV0.ff)('jira-business-to-software-project-imports') && thirdPartyType === (0, $3ak5x.JIRA_BUSINESS)) {
            this.BASE_URL = `${0, $gyZoj.X2C_SERVICE_URL_PREFIX}/${cloudId}/import/jira`;
            this.THIRD_PARTY_TYPE = thirdPartyType;
        }
    }
    startImport({ entityId: entityId, payload: payload }) {
        const url = `${this.BASE_URL}/project/${entityId}/migration/start`;
        return (0, $lRmyA.performPostRequest)(url, {
            body: JSON.stringify(payload),
            headers: {
                ...this.BASE_HEADERS,
                'Content-Type': 'application/json'
            }
        });
    }
    getEntitiesPage({ offset: offset }) {
        let url = `${this.BASE_URL}/projects`;
        if ((0, $1ybV0.ff)('jira-business-to-software-project-imports') && this.THIRD_PARTY_TYPE === (0, $3ak5x.JIRA_BUSINESS)) url = `${url}/business`;
        const urlWithOffset = offset ? `${url}?startAt=${offset}` : url;
        return (0, $2OdyW.default)(urlWithOffset, {
            method: 'GET',
            headers: this.BASE_HEADERS
        });
    }
    searchEntities({ query: query }) {
        let url = `${this.BASE_URL}/projects/search?query=${encodeURIComponent(query)}`;
        if ((0, $1ybV0.ff)('jira-business-to-software-project-imports') && this.THIRD_PARTY_TYPE === (0, $3ak5x.JIRA_BUSINESS)) url = `${this.BASE_URL}/projects/business/search?query=${encodeURIComponent(query)}`;
        return (0, $2OdyW.default)(url, {
            method: 'GET',
            headers: this.BASE_HEADERS
        });
    }
    getEntityStats({ entityId: entityId }) {
        const url = `${this.BASE_URL}/project/${entityId}/stats`;
        return (0, $2OdyW.default)(url, {
            method: 'GET',
            headers: {
                ...this.BASE_HEADERS
            }
        });
    }
    getFieldConfig({ entityId: entityId, entities: entities, projectData: projectData }) {
        if (entities.length === 0 && (0, $1ybV0.ff)('x2c-clickup-importer-multi-list')) return Promise.reject(new Error('No entities provided'));
        const url = (0, $1ybV0.ff)('x2c-clickup-importer-multi-list') ? `${this.BASE_URL}/project/${entities[0].id}/fields` : `${this.BASE_URL}/project/${entityId}/fields`;
        return (0, $2OdyW.default)(url, {
            method: 'POST',
            body: JSON.stringify({
                projectDetails: {
                    type: projectData.type,
                    style: projectData.style
                }
            }),
            headers: this.BASE_HEADERS
        });
    }
    validateAccessToken() {
        return Promise.reject(new Error('validateAccessToken method is not implemented in Jira'));
    }
    postAccessToken() {
        return Promise.reject(new Error('postAccessToken method is not implemented in Jira'));
    }
    getEntities() {
        return Promise.reject(new Error('getEntities method is not implemented in Jira'));
    }
    getMultiEntityStats() {
        return Promise.reject(new Error('getMultiEntityStats method is not implemented in Jira'));
    }
    getEntityMembers() {
        return Promise.reject(new Error('getEntityMembers method is not implemented in Jira'));
    }
    getWorkspaces() {
        return Promise.reject(new Error('getWorkspaces method is not implemented in Jira'));
    }
    getFolders() {
        return Promise.reject(new Error('getFolders method is not implemented in jira'));
    }
    getSiteName() {
        return Promise.reject(new Error('getSiteName method is not implemented in jira'));
    }
    getSpaces() {
        return Promise.reject(new Error('getSpaces method is not implemented in jira'));
    }
    getMultiEntityStatuses() {
        return Promise.reject(new Error('getMultiEntityStatuses method is not implemented in jira'));
    }
}

});

parcelRegister("ebdAn", function(module, exports) {

$parcel$export(module.exports, "MondayClient", () => $ab1568775d268272$export$32fc08d2b7c80438);

var $1ybV0 = parcelRequire("1ybV0");

var $2OdyW = parcelRequire("2OdyW");
var $lRmyA = parcelRequire("lRmyA");

var $cpweK = parcelRequire("cpweK");
var $gyZoj = parcelRequire("gyZoj");

var $dmwfW = parcelRequire("dmwfW");

var $624Xb = parcelRequire("624Xb");

var $8xYnH = parcelRequire("8xYnH");
const $ab1568775d268272$var$BACKEND_MAIN_WORKSPACE_ID = '-1';
const $ab1568775d268272$var$MAX_RETRIES = 1;
class $ab1568775d268272$export$32fc08d2b7c80438 {
    constructor({ cloudId: cloudId, formatMessage: formatMessage, requestAuthenticationToken: requestAuthenticationToken }){
        this.BASE_HEADERS = {
            'x-issynthetic-traffic': String((0, $cpweK.isSynthetic)()),
            'x-migration-authentication-type': 'personal-access-token'
        };
        this.BASE_URL = `${0, $gyZoj.X2C_SERVICE_URL_PREFIX}/${cloudId}/import/monday`;
        this.formatMessage = formatMessage;
        this.withAuthentication = requestAuthenticationToken ? (0, $dmwfW.handleAuthenticationFactory)({
            retries: $ab1568775d268272$var$MAX_RETRIES,
            requestAuthenticationToken: requestAuthenticationToken
        }) : (doRequest)=>doRequest();
    }
    startImport({ entityId: entityId, payload: payload }) {
        const url = `${this.BASE_URL}/board/${entityId}/migration/start`;
        return (0, $lRmyA.performPostRequest)(url, {
            body: JSON.stringify(payload),
            headers: {
                ...this.BASE_HEADERS,
                'Content-Type': 'application/json'
            }
        });
    }
    async getEntities({ workspaceId: workspaceId, folderIds: folderIds }) {
        let url = `${this.BASE_URL}/workspaces/${workspaceId}/boards`;
        if (folderIds) url = `${url}?folderIds=${folderIds}`;
        const entities = await this.withAuthentication(()=>(0, $2OdyW.default)(url, {
                method: 'GET',
                headers: this.BASE_HEADERS
            }));
        return entities.map((workspace)=>{
            if (workspace.id === $ab1568775d268272$var$BACKEND_MAIN_WORKSPACE_ID) return {
                ...workspace,
                name: this.formatMessage((0, $624Xb.default).mainWorkspace)
            };
            return workspace;
        });
    }
    getEntityStats({ entityId: entityId }) {
        const url = `${this.BASE_URL}/board/${entityId}/stats`;
        return this.withAuthentication(()=>(0, $2OdyW.default)(url, {
                method: 'GET',
                headers: {
                    ...this.BASE_HEADERS
                }
            }));
    }
    getWorkspaces() {
        const url = `${this.BASE_URL}/workspaces`;
        return this.withAuthentication(()=>(0, $2OdyW.default)(url, {
                method: 'GET',
                headers: this.BASE_HEADERS
            }));
    }
    getEntityMembers() {
        return Promise.reject(new Error('getEntityMembers method is not implemented in Monday'));
    }
    async getFolders({ entityId: entityId }) {
        const url = `${this.BASE_URL}/workspaces/${entityId}/folders`;
        const folders = await this.withAuthentication(()=>(0, $2OdyW.default)(url, {
                method: 'GET',
                headers: this.BASE_HEADERS
            }));
        const data = (0, $dmwfW.transformToFolderAndSubfolderState)(folders);
        return data;
    }
    getFieldConfig({ entityId: entityId, entities: entities, projectData: projectData }) {
        if (entities.length === 0 && (0, $1ybV0.ff)('x2c-clickup-importer-multi-list')) return Promise.reject(new Error('No entities provided'));
        const url = (0, $1ybV0.ff)('x2c-clickup-importer-multi-list') ? `${this.BASE_URL}/board/${entities[0].id}/fields` : `${this.BASE_URL}/board/${entityId}/fields`;
        return this.withAuthentication(()=>(0, $2OdyW.default)(url, {
                method: 'POST',
                body: JSON.stringify({
                    projectDetails: {
                        type: projectData.type,
                        style: projectData.style
                    }
                }),
                headers: this.BASE_HEADERS
            }));
    }
    validateAccessToken() {
        const url = `${this.BASE_URL}/token/status`;
        return (0, $2OdyW.default)(url, {
            method: 'GET',
            headers: this.BASE_HEADERS
        });
    }
    async getSiteName() {
        const url = `${this.BASE_URL}/account`;
        const data = await this.withAuthentication(()=>(0, $2OdyW.default)(url, {
                method: 'GET',
                headers: this.BASE_HEADERS
            }));
        return (0, $8xYnH.transformToMondaySiteName)(data);
    }
    postAccessToken({ accessToken: accessToken }) {
        const url = `${this.BASE_URL}/token`;
        return (0, $lRmyA.performPostRequest)(url, {
            body: JSON.stringify({
                accessToken: accessToken
            }),
            headers: {
                ...this.BASE_HEADERS,
                'Content-Type': 'application/json'
            }
        });
    }
    getEntitiesPage() {
        return Promise.reject(new Error('getEntitiesPage method is not implemented in Monday'));
    }
    searchEntities() {
        return Promise.reject(new Error('searchEntities method is not implemented in Monday'));
    }
    getSpaces() {
        return Promise.reject(new Error('getSpaces method is not implemented in Monday'));
    }
    getMultiEntityStats() {
        return Promise.reject(new Error('getMultiEntityStats method is not implemented in Monday'));
    }
    getMultiEntityStatuses() {
        return Promise.reject(new Error('getMultiEntityStatuses method is not implemented in Monday'));
    }
}

});
parcelRegister("624Xb", function(module, exports) {

$parcel$export(module.exports, "default", () => $55b7d7242b07e176$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $55b7d7242b07e176$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    mainWorkspace: {
        "id": "project-create-importer-upload-flow.common.utils.third-party-clients.monday.main-workspace",
        "defaultMessage": "Main workspace"
    }
});

});

parcelRegister("8xYnH", function(module, exports) {

$parcel$export(module.exports, "transformToMondaySiteName", () => $da33875be9a6240b$export$82b8a1a58d172ef5);
const $da33875be9a6240b$export$82b8a1a58d172ef5 = ({ slug: slug })=>`https://${slug}.monday.com`;

});


parcelRegister("4KEkw", function(module, exports) {

$parcel$export(module.exports, "NotSupportedClient", () => $b72de221c8580e1a$export$fe38380cf6367a35);
class $b72de221c8580e1a$export$fe38380cf6367a35 {
    constructor(thirdParty){
        this.ThirdParty = thirdParty;
    }
    getSpaces() {
        return Promise.reject(new Error(`ThirdParty: '${this.ThirdParty}' is not currently supported.`));
    }
    getEntities() {
        return Promise.reject(new Error(`ThirdParty: '${this.ThirdParty}' is not currently supported.`));
    }
    getEntityMembers() {
        return Promise.reject(new Error(`ThirdParty: '${this.ThirdParty}' is not currently supported.`));
    }
    getEntityStats() {
        return Promise.reject(new Error(`ThirdParty: '${this.ThirdParty}' is not currently supported.`));
    }
    getWorkspaces() {
        return Promise.reject(new Error(`ThirdParty: '${this.ThirdParty}' is not currently supported.`));
    }
    startImport() {
        return Promise.reject(new Error(`ThirdParty: '${this.ThirdParty}' is not currently supported.`));
    }
    getFieldConfig() {
        return Promise.reject(new Error(`ThirdParty: '${this.ThirdParty}' is not currently supported.`));
    }
    validateAccessToken() {
        return Promise.reject(new Error(`ThirdParty: '${this.ThirdParty}' is not currently supported.`));
    }
    getSiteName() {
        return Promise.reject(new Error(`ThirdParty: '${this.ThirdParty}' is not currently supported.`));
    }
    postAccessToken() {
        return Promise.reject(new Error(`ThirdParty: '${this.ThirdParty}' is not currently supported.`));
    }
    getEntitiesPage() {
        return Promise.reject(new Error(`ThirdParty: '${this.ThirdParty}' is not currently supported.`));
    }
    searchEntities() {
        return Promise.reject(new Error(`ThirdParty: '${this.ThirdParty}' is not currently supported.`));
    }
    getFolders() {
        return Promise.reject(new Error('getFolders method is not currently supported'));
    }
    getMultiEntityStats() {
        return Promise.reject(new Error(`ThirdParty: '${this.ThirdParty}' is not currently supported.`));
    }
    getMultiEntityStatuses() {
        return Promise.reject(new Error(`ThirdParty: '${this.ThirdParty}' is not currently supported.`));
    }
}

});

parcelRegister("jTXjR", function(module, exports) {

$parcel$export(module.exports, "TrelloClient", () => $ff5ee7d789e5d729$export$235c4986b8ca4832);

var $2OdyW = parcelRequire("2OdyW");
var $lRmyA = parcelRequire("lRmyA");

var $cpweK = parcelRequire("cpweK");
var $gyZoj = parcelRequire("gyZoj");
class $ff5ee7d789e5d729$export$235c4986b8ca4832 {
    constructor({ cloudId: cloudId }){
        this.BASE_HEADERS = {
            'x-issynthetic-traffic': String((0, $cpweK.isSynthetic)())
        };
        this.BASE_URL = `${0, $gyZoj.X2C_SERVICE_URL_PREFIX}/${cloudId}/import/trello`;
    }
    startImport({ entityId: entityId, payload: payload }) {
        const url = `${this.BASE_URL}/board/${entityId}/migration/start`;
        return (0, $lRmyA.performPostRequest)(url, {
            body: JSON.stringify(payload),
            headers: {
                ...this.BASE_HEADERS,
                'Content-Type': 'application/json'
            }
        });
    }
    getEntities({ workspaceId: workspaceId }) {
        const url = `${this.BASE_URL}/workspaces/${workspaceId}/boards`;
        return (0, $2OdyW.default)(url, {
            method: 'GET',
            headers: this.BASE_HEADERS
        });
    }
    getEntityStats({ entityId: entityId }) {
        const url = `${this.BASE_URL}/board/${entityId}/stats`;
        return (0, $2OdyW.default)(url, {
            method: 'GET',
            headers: {
                ...this.BASE_HEADERS
            }
        });
    }
    getEntityMembers({ entityId: entityId }) {
        const url = `${this.BASE_URL}/board/${entityId}/members`;
        return (0, $2OdyW.default)(url, {
            method: 'GET',
            headers: this.BASE_HEADERS
        });
    }
    getWorkspaces() {
        const url = `${this.BASE_URL}/workspaces`;
        return (0, $2OdyW.default)(url, {
            method: 'GET',
            headers: this.BASE_HEADERS
        });
    }
    getFieldConfig() {
        return Promise.reject(new Error('getFieldConfig method is not implemented in Trello'));
    }
    validateAccessToken() {
        return Promise.reject(new Error('validateAccessToken method is not implemented in Trello'));
    }
    postAccessToken() {
        return Promise.reject(new Error('postAccessToken method is not implemented in Trello'));
    }
    getEntitiesPage() {
        return Promise.reject(new Error('getEntitiesPage method is not implemented in Trello'));
    }
    searchEntities() {
        return Promise.reject(new Error('searchEntities method is not implemented in Trello'));
    }
    getFolders() {
        return Promise.reject(new Error('getFolders method is not implemented in trello'));
    }
    getSiteName() {
        return Promise.reject(new Error('getSiteName method is not implemented in Trello'));
    }
    getSpaces() {
        return Promise.reject(new Error('getSpaces method is not implemented in Trello'));
    }
    getMultiEntityStats() {
        return Promise.reject(new Error('getMultiEntityStats method is not implemented in Trello'));
    }
    getMultiEntityStatuses() {
        return Promise.reject(new Error('getMultiEntityStatuses method is not implemented in Trello'));
    }
}

});


parcelRegister("1DPDL", function(module, exports) {

$parcel$export(module.exports, "getImportAdditionalProps", () => $24240f2fb6bfaae3$export$cd20d07b06af7c55);

var $6HC1D = parcelRequire("6HC1D");

var $hTLlD = parcelRequire("hTLlD");

var $1ybV0 = parcelRequire("1ybV0");

var $kzTj7 = parcelRequire("kzTj7");

var $3ak5x = parcelRequire("3ak5x");
const $24240f2fb6bfaae3$var$ASANA_PREFIX = '(Asana) ';
const $24240f2fb6bfaae3$var$MONDAY_PREFIX = '(monday) ';
const $24240f2fb6bfaae3$var$getPrefix = (thirdParty)=>{
    switch(thirdParty){
        case 0, $3ak5x.ASANA:
            return $24240f2fb6bfaae3$var$ASANA_PREFIX;
        case 0, $3ak5x.MONDAY:
            return $24240f2fb6bfaae3$var$MONDAY_PREFIX;
        default:
            return '';
    }
};
const $24240f2fb6bfaae3$var$generateKey = (field)=>`${field.fieldType}-${field.fieldName}`;
const $24240f2fb6bfaae3$var$generateExistingFieldNameTypeSet = (availableJiraFields)=>new Set(Object.keys(availableJiraFields).flatMap((type)=>availableJiraFields[type].map($24240f2fb6bfaae3$var$generateKey)));
const $24240f2fb6bfaae3$var$generateNewFieldName = (existingFieldName, count, thirdParty)=>count === 0 ? `${$24240f2fb6bfaae3$var$getPrefix(thirdParty)}${existingFieldName}` : `${$24240f2fb6bfaae3$var$getPrefix(thirdParty)}${existingFieldName} ${count}`;
const $24240f2fb6bfaae3$export$d4edfe294602882f = (field, fieldNameTypeSet, count = 0, thirdParty)=>{
    const key = $24240f2fb6bfaae3$var$generateKey(field);
    if (!fieldNameTypeSet.has(key)) {
        fieldNameTypeSet.add(key);
        return field;
    }
    const newField = (0, $6HC1D.setIn)(field, [
        'fieldName'
    ], $24240f2fb6bfaae3$var$generateNewFieldName(field.fieldName, count, thirdParty));
    const newKey = $24240f2fb6bfaae3$var$generateKey(newField);
    if (!fieldNameTypeSet.has(newKey)) {
        fieldNameTypeSet.add(newKey);
        return newField;
    }
    return $24240f2fb6bfaae3$export$d4edfe294602882f(field, fieldNameTypeSet, count + 1, thirdParty);
};
const $24240f2fb6bfaae3$var$generateFieldMappingsForItem = (thirdPartyFieldMappings, availableJiraFieldsNameTypeSet, updateAdditionalAttributes, thirdParty)=>{
    const itemFieldMappings = {};
    const fieldNameTypeSet = new Set(availableJiraFieldsNameTypeSet);
    const getMappedField = (fieldMapping)=>{
        if (!fieldMapping.mappingContext.isIncluded) return;
        if (fieldMapping.mappedJiraField.fieldId) return fieldMapping.mappedJiraField;
        // Ensure unique names for new custom fields
        return $24240f2fb6bfaae3$export$d4edfe294602882f(fieldMapping.mappedJiraField, fieldNameTypeSet, 0, thirdParty);
    };
    Object.values(thirdPartyFieldMappings).forEach((fieldMapping)=>{
        updateAdditionalAttributes(fieldMapping);
        const field = getMappedField(fieldMapping);
        if (field) itemFieldMappings[fieldMapping.thirdPartyField.fieldId] = field;
    });
    return itemFieldMappings;
};
const $24240f2fb6bfaae3$export$cd20d07b06af7c55 = ({ state: state, importSettings: importSettings, statusMapping: statusMapping, thirdParty: thirdParty })=>{
    const availableJiraFieldsNameTypeSet = $24240f2fb6bfaae3$var$generateExistingFieldNameTypeSet(state.availableJiraFields);
    let fieldMappings = {};
    const itemsConfig = {};
    const additionalAttributes = {
        attachmentsEnabled: importSettings.shouldImportAttachments,
        importUsersEnabled: importSettings.shouldImportUsers,
        importCommentsEnabled: importSettings.shouldImportComments,
        numFieldsTotal: 0,
        numFieldsExcluded: 0,
        numFieldsChangedFromDefault: 0,
        ...(0, $1ybV0.ff)('jwm-x2c-hierarchy-mapping_kkjnd') && {
            defaultHierarchyItem: '',
            selectedHierarchyItem: ''
        }
    };
    const updateAdditionalAttributes = (itemType, hierarchyMapping)=>(fieldMapping)=>{
            if (!fieldMapping.mappingContext.isIncluded) {
                additionalAttributes.numFieldsExcluded += 1;
                return;
            }
            additionalAttributes.numFieldsTotal += 1;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(fieldMapping.defaultMappedJiraField, fieldMapping.mappedJiraField)) additionalAttributes.numFieldsChangedFromDefault += 1;
            if ((0, $1ybV0.ff)('jwm-x2c-hierarchy-mapping_kkjnd') && hierarchyMapping && itemType === (hierarchyMapping.itemType || (0, $kzTj7.DEFAULT_ITEM_TYPE)) && // TODO: Remove DEFAULT_ITEM_TYPE once Asana API is updated to support itemsConfig
            fieldMapping.thirdPartyField.fieldId === hierarchyMapping.mappingFieldId) {
                additionalAttributes.defaultHierarchyItem = fieldMapping.defaultMappedJiraField?.fieldName || '';
                additionalAttributes.selectedHierarchyItem = fieldMapping.mappedJiraField.fieldName;
            }
        };
    Object.entries(state.fieldMappingState).forEach(([itemType, itemTypeFieldMapping])=>{
        const itemFieldMappings = $24240f2fb6bfaae3$var$generateFieldMappingsForItem(itemTypeFieldMapping.thirdPartyFieldMappings, availableJiraFieldsNameTypeSet, updateAdditionalAttributes(itemType, state.hierarchyMapping), thirdParty);
        const itemStatusMappings = statusMapping && itemType in statusMapping.entityStatusMappings ? statusMapping.entityStatusMappings[itemType].statusMappings : {};
        itemsConfig[itemType] = {
            itemTypeId: itemTypeFieldMapping.itemTypeId,
            fieldMappings: itemFieldMappings,
            ...(0, $1ybV0.ff)('x2c-clickup-importer-multi-list') ? {
                statusMappings: itemStatusMappings
            } : {}
        };
        // TODO: Remove this once Asana API is updated to support itemsConfig
        fieldMappings = {
            ...fieldMappings,
            ...itemFieldMappings
        };
    });
    return {
        additionalPayload: {
            fieldMappings: fieldMappings,
            itemsConfig: itemsConfig,
            importSettings: importSettings
        },
        additionalAttributes: additionalAttributes
    };
};

});


parcelRegister("asXeB", function(module, exports) {

$parcel$export(module.exports, "useAccessTokenModalState", () => $11429049d219de07$export$49441dc53e9f54df);

var $ggKAj = parcelRequire("ggKAj");
var $bj4JM = parcelRequire("bj4JM");

var $irjtd = parcelRequire("irjtd");
const $11429049d219de07$export$81cd354663f02c59 = (0, $bj4JM.createSelector)((state)=>state.accessTokenModal, (newState)=>newState);
const $11429049d219de07$export$49441dc53e9f54df = (0, $ggKAj.createHook)((0, $irjtd.Store), {
    selector: $11429049d219de07$export$81cd354663f02c59
});

});


parcelRegister("ap0Nu", function(module, exports) {

$parcel$export(module.exports, "useValidateX2CImport", () => $511931cee3607a69$export$cafe5f4ded4b0314);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $2OdyW = parcelRequire("2OdyW");

var $gyZoj = parcelRequire("gyZoj");
var $cpweK = parcelRequire("cpweK");
var $5GSA7 = parcelRequire("5GSA7");

var $dWLk9 = parcelRequire("dWLk9");

var $kzTj7 = parcelRequire("kzTj7");

var $3yuWi = parcelRequire("3yuWi");

var $jNdPf = parcelRequire("jNdPf");

var $il2VC = parcelRequire("il2VC");

var $dWwV8 = parcelRequire("dWwV8");
const $511931cee3607a69$var$getX2CImportUrl = (cloudId, migrationId)=>`${0, $gyZoj.X2C_SERVICE_URL_PREFIX}/${cloudId}/import/csv/${migrationId}/validate`;
const $511931cee3607a69$export$eb03fa31a52f6a7a = (cloudId, migrationId, payload)=>(0, $2OdyW.default)($511931cee3607a69$var$getX2CImportUrl(cloudId, migrationId), {
        body: JSON.stringify(payload),
        method: 'POST',
        headers: {
            'x-issynthetic-traffic': String((0, $cpweK.isSynthetic)())
        }
    });
const $511931cee3607a69$export$cafe5f4ded4b0314 = (source, serviceName)=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const [onExperienceStart, onExperienceSuccess, onExperienceFail] = (0, $5GSA7.useExperienceTracker)((0, $3yuWi.EXPERIENCES).VALIDATE);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const additionalAttributes = (0, $jNdPf.useAnalyticsAttributesContext)();
    const client = (0, $il2VC.useGetCSVImportClient)(source, serviceName);
    const validateX2CImport = (0, $eUqFw.useCallback)(async ({ migrationId: migrationId, mappingState: mappingState, advancedOptions: advancedOptions, onSuccess: onSuccess, onFetchFail: onFetchFail, onValidationError: onValidationError })=>{
        setIsLoading(true);
        const payload = (0, $dWwV8.transformToValidateImportPayload)(mappingState, advancedOptions, (0, $1ybV0.ff)('x2c-issuelinking-frontend_tuyzk'));
        let validationResponse;
        (0, $3yuWi.validateMappingInteractionMetric).start();
        onExperienceStart();
        try {
            if ((0, $1ybV0.ff)('enable-importing-data-to-existing-project_k8uub')) validationResponse = await client.validateRequest({
                migrationId: migrationId,
                mappingState: mappingState,
                advancedOptions: advancedOptions
            });
            else validationResponse = await $511931cee3607a69$export$eb03fa31a52f6a7a(cloudId, migrationId, payload);
            (0, $3yuWi.validateMappingInteractionMetric).stop();
            onExperienceSuccess({
                migrationId: migrationId,
                ...additionalAttributes
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $3yuWi.validateMappingInteractionMetric).stop();
            onExperienceFail((0, $kzTj7.APP_IDENTIFIER), error, {
                migrationId: migrationId,
                ...additionalAttributes
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'validate-x2c-import-error',
                    packageName: (0, $kzTj7.APP_IDENTIFIER),
                    teamName: (0, $gyZoj.APP_TEAM_NAME)
                },
                attributes: {
                    message: 'Failed to validate payload for jwm import'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            setIsLoading(false);
            onFetchFail();
            return;
        }
        setIsLoading(false);
        if (Object.keys(validationResponse?.columnErrors ?? {}).length > 0 || validationResponse?.missingFields?.length > 0) {
            onValidationError(validationResponse);
            return;
        }
        onSuccess();
    }, [
        onExperienceStart,
        onExperienceSuccess,
        additionalAttributes,
        client,
        cloudId,
        onExperienceFail
    ]);
    return {
        isLoading: isLoading,
        validateX2CImport: validateX2CImport
    };
};

});

parcelRegister("6rHYD", function(module, exports) {

$parcel$export(module.exports, "VALIDATION_FAILED_FLAG", () => $447576d11e881fe8$export$6e12a401fc3eb406);

var $2SUld = parcelRequire("2SUld");
const $447576d11e881fe8$export$6e12a401fc3eb406 = {
    type: 'error',
    title: (0, $2SUld.default).validationErrorFlagTitle,
    description: (0, $2SUld.default).validationErrorFlagMessage
};

});
parcelRegister("2SUld", function(module, exports) {

$parcel$export(module.exports, "default", () => $204436f5f5e034ae$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $204436f5f5e034ae$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    csvFieldMappingHeading: {
        "id": "project-create-importer-upload-flow.mapping-screen.csv-field-mapping-heading",
        "defaultMessage": "Map project fields"
    },
    submitFeedbackCallToAction: {
        "id": "project-create-importer-upload-flow.mapping-screen.submit-feedback-call-to-action",
        "defaultMessage": "Give feedback"
    },
    validationErrorFlagTitle: {
        "id": "project-create-importer-upload-flow.mapping-screen.validation-error-flag-title",
        "defaultMessage": "Something went wrong"
    },
    validationErrorFlagMessage: {
        "id": "project-create-importer-upload-flow.mapping-screen.validation-error-flag-message",
        "defaultMessage": "Check your connection, then give it another try."
    },
    summaryRequiredTitle: {
        "id": "project-create-importer-upload-flow.mapping-screen.summary-required-title",
        "defaultMessage": "Summary is a required field in Jira"
    },
    summaryRequiredMessage: {
        "id": "project-create-importer-upload-flow.mapping-screen.summary-required-message",
        "defaultMessage": "Make sure to map the summary field to the appropriate CSV column to proceed with the import."
    },
    postValidationBannerHeading: {
        "id": "project-create-importer-upload-flow.mapping-screen.post-validation-banner-heading",
        "defaultMessage": "All good to proceed"
    },
    postValidationBannerDescription: {
        "id": "project-create-importer-upload-flow.mapping-screen.post-validation-banner-description",
        "defaultMessage": "Please click on next to validate fields and proceed to the next step"
    },
    networkErrorHeading: {
        "id": "project-create-importer-upload-flow.mapping-screen.network-error-heading",
        "defaultMessage": "We couldn\u2019t load this page"
    },
    networkErrorDescription: {
        "id": "project-create-importer-upload-flow.mapping-screen.network-error-description",
        "defaultMessage": "Try refreshing the page or wait for a few minutes before importing the project again."
    }
});

});


parcelRegister("1mEdD", function(module, exports) {

$parcel$export(module.exports, "FieldsDropdown", () => $e204b75c55e64091$export$9904678d4b303072);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $6OfWd = parcelRequire("6OfWd");
var $9mc6u = parcelRequire("9mc6u");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kzTj7 = parcelRequire("kzTj7");

var $lUC5l = parcelRequire("lUC5l");

var $lS3Pk = parcelRequire("lS3Pk");
const $e204b75c55e64091$export$9904678d4b303072 = /*#__PURE__*/ (0, $eUqFw.memo)(({ testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [mappingState] = (0, $lUC5l.useMappingState)();
    const [{ numColumnsVisible: numColumnsVisible, numColumnsHidden: numColumnsHidden, areAllColumnsVisible: areAllColumnsVisible }, { setIsVisibleForAll: setIsVisibleForAll, setIsVisibleForColumn: setIsVisibleForColumn }] = (0, $lUC5l.useColumnsVisibleState)();
    const onToggleAllColumnsVisible = (0, $eUqFw.useCallback)(()=>{
        setIsVisibleForAll(!areAllColumnsVisible);
    }, [
        areAllColumnsVisible,
        setIsVisibleForAll
    ]);
    const getOnToggleIsVisibleForColumn = (0, $eUqFw.useCallback)((colName)=>()=>{
            setIsVisibleForColumn(colName, !mappingState?.columns[colName]?.isVisible);
        }, [
        mappingState?.columns,
        setIsVisibleForColumn
    ]);
    const dropdownItems = (0, $eUqFw.useMemo)(()=>mappingState?.columnOrder.map((colName)=>mappingState.columns[colName]).map((col, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9mc6u.default), {
                id: col.columnName,
                key: `${col.columnName}-${index}`,
                isSelected: col.isVisible,
                onClick: getOnToggleIsVisibleForColumn(col.columnName),
                testId: `${(0, $kzTj7.FIELDS_DROPDOWN_TEST_ID_PREFIX)}.${col.columnName}-${index}`
            }, col.columnName)), [
        getOnToggleIsVisibleForColumn,
        mappingState?.columnOrder,
        mappingState?.columns
    ]);
    const getTriggerContent = (0, $eUqFw.useCallback)(()=>{
        if (numColumnsHidden === 0) return formatMessage((0, $lS3Pk.default).includedColumns, {
            count: numColumnsVisible
        });
        return `${formatMessage((0, $lS3Pk.default).includedColumns, {
            count: numColumnsVisible
        })} / ${formatMessage((0, $lS3Pk.default).ignoredColumns, {
            count: numColumnsHidden
        })}`;
    }, [
        formatMessage,
        numColumnsHidden,
        numColumnsVisible
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e204b75c55e64091$var$Wrapper, {
        "data-testid": "project-create-importer-upload-flow.ui.mapping-screen.fields-dropdown.wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e204b75c55e64091$var$HeadingWrapper, null, formatMessage((0, $lS3Pk.default).importData)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        trigger: getTriggerContent(),
        isLoading: mappingState === null,
        shouldFlip: false,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e204b75c55e64091$var$DropdownItemsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9mc6u.default), {
        id: "All Fields",
        isSelected: areAllColumnsVisible,
        onClick: onToggleAllColumnsVisible,
        testId: `${(0, $kzTj7.FIELDS_DROPDOWN_TEST_ID_PREFIX)}.all-fields`
    }, formatMessage((0, $lS3Pk.default).allColumns)), dropdownItems)));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e204b75c55e64091$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _c71l1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e204b75c55e64091$var$HeadingWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwx1ejb _k48pni7l _syaz1n3s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e204b75c55e64091$var$DropdownItemsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_c71l17as",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6OfWd", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd131b446ad30d0e$export$2e2bcd8739ae039);
/* eslint-disable import/order */ 
var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $6zOB7 = parcelRequire("6zOB7");


var $1lQG9 = parcelRequire("1lQG9");

var $5Q9wj = parcelRequire("5Q9wj");

var $2WwAS = parcelRequire("2WwAS");

var $7PTrT = parcelRequire("7PTrT");

var $86Ndv = parcelRequire("86Ndv");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $dkYal = parcelRequire("dkYal");

var $jiH6M = parcelRequire("jiH6M");

var $7mYCs = parcelRequire("7mYCs");

var $h1Q9j = parcelRequire("h1Q9j");

var $8gwL5 = parcelRequire("8gwL5");
const $cd131b446ad30d0e$var$gridSize = (0, $lcnyw.gridSize)();
const $cd131b446ad30d0e$var$MAX_HEIGHT = `calc(100vh - ${$cd131b446ad30d0e$var$gridSize * 2}px)`;
const $cd131b446ad30d0e$var$opposites = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
    start: 'end',
    auto: 'auto',
    end: 'start'
};
const $cd131b446ad30d0e$var$getFallbackPlacements = (placement)=>{
    const placementPieces = placement.split('-');
    const mainAxis = placementPieces[0];
    // Left, right and auto placements can rely on standard popper sliding behaviour
    if (![
        'top',
        'bottom'
    ].includes(mainAxis)) return undefined;
    else if (placementPieces.length === 2 && [
        'start',
        'end'
    ].includes(placementPieces[1])) {
        const crossAxis = placementPieces[1];
        return [
            `${mainAxis}`,
            `${mainAxis}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${crossAxis}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
            `${$cd131b446ad30d0e$var$opposites[mainAxis]}-${$cd131b446ad30d0e$var$opposites[crossAxis]}`,
            'auto'
        ];
    } else return [
        `${mainAxis}-start`,
        `${mainAxis}-end`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-start`,
        `${$cd131b446ad30d0e$var$opposites[mainAxis]}-end`,
        `auto`
    ];
};
/**
 * __Dropdown menu__
 *
 * A dropdown menu displays a list of actions or options to a user.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/usage)
 */ const $cd131b446ad30d0e$var$DropdownMenu = ({ autoFocus: autoFocus = false, children: children, defaultOpen: defaultOpen = false, isLoading: isLoading = false, isOpen: isOpen, onOpenChange: onOpenChange = (0, $5Q9wj.default), placement: placement = 'bottom-start', shouldFitContainer: shouldFitContainer = false, shouldFlip: shouldFlip = true, shouldRenderToParent: shouldRenderToParent = false, spacing: spacing, statusLabel: statusLabel, testId: testId, trigger: trigger, zIndex: zIndex = (0, $lcnyw.layers).modal(), label: label })=>{
    const [isLocalOpen, setLocalIsOpen] = (0, $2WwAS.default)(isOpen, ()=>defaultOpen);
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const id = (0, $8gwL5.default)();
    const itemRef = (0, $h1Q9j.default)();
    const fallbackPlacements = (0, $eUqFw.useMemo)(()=>$cd131b446ad30d0e$var$getFallbackPlacements(placement), [
        placement
    ]);
    const handleTriggerClicked = (0, $eUqFw.useCallback)(// TODO: event is an `any` and is being cast incorrectly
    // This means that the public type for `onOpenChange` is incorrect
    // current: (event: React.MouseEvent | React.KeyboardEvent) => void;
    // correct: (event: React.MouseEvent | KeyboardEvent) => void;
    // https://product-fabric.atlassian.net/browse/DSP-4692
    (event)=>{
        const newValue = !isLocalOpen;
        const { clientX: clientX, clientY: clientY, type: type, detail: detail } = event;
        if (type === 'keydown') setTriggeredUsingKeyboard(true);
        else if (clientX === 0 || clientY === 0) // Hitting enter/space is registered as a click
        // with both clientX and clientY === 0
        setTriggeredUsingKeyboard(true);
        else if (detail === 0) // Fix for Safari. clientX and clientY !== 0 in Safari
        setTriggeredUsingKeyboard(true);
        else {
            // The trigger element must be focused to avoid problems with an incorrectly focused element after closing DropdownMenu
            itemRef?.current?.focus();
            setTriggeredUsingKeyboard(false);
        }
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        itemRef,
        onOpenChange,
        isLocalOpen,
        setLocalIsOpen
    ]);
    const handleOnClose = (0, $eUqFw.useCallback)((event)=>{
        if (event.key !== 'Escape' && event.key !== 'Tab' && event.target?.closest?.(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`)) // Check if it is within dropdown and it is a trigger button
        // if it is a nested dropdown, clicking trigger won't close the dropdown
        // Dropdown can be closed by pressing Escape, Tab or Shift + Tab
        return;
        if (event.key === 'Tab' && event.shiftKey || event.key === 'Escape') requestAnimationFrame(()=>{
            itemRef.current?.focus();
        });
        const newValue = false;
        setLocalIsOpen(newValue);
        onOpenChange({
            isOpen: newValue,
            event: event
        });
    }, [
        onOpenChange,
        setLocalIsOpen,
        itemRef
    ]);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $7PTrT.default)();
    // When a trigger is focused, we want to open the dropdown if
    // the user presses the DownArrow
    (0, $eUqFw.useEffect)(()=>{
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $5Q9wj.default;
        // Being safe: we don't want to open the dropdown if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isLocalOpen) return 0, $5Q9wj.default;
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                let isNestedTriggerButton;
                if (e.target instanceof HTMLElement) isNestedTriggerButton = e.target.closest(`[id^=${(0, $8gwL5.PREFIX)}] [aria-haspopup]`);
                if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe) && !isNestedTriggerButton) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                } else if ((e.code === (0, $54717ce5fa2c74b1$export$e51a3576c045c8d5) || e.key === (0, $54717ce5fa2c74b1$export$8152f929a25a0ff4)) && e.detail === 0) // This allows us to focus on the first element if the dropdown was triggered by a custom trigger with a custom onClick
                setTriggeredUsingKeyboard(true);
                else if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && isNestedTriggerButton) // This closes dropdown if it is a nested dropdown
                handleOnClose(e);
            }
        });
    }, [
        isFocused,
        isLocalOpen,
        handleTriggerClicked,
        handleOnClose
    ]);
    /*
	 * The Popup component requires either:
	 * - shouldFitContainer={true} and shouldRenderToParent={true | undefined}
	 * or
	 * - shouldFitContainer={false | undefined} and shouldRenderToParent={true | false | undefined}
	 *
	 * But not:
	 * - shouldFitContainer={true} and shouldRenderToParent={false}
	 *
	 * By only including either shouldFitContainer or shouldRenderToParent, we can ensure that the Popup component
	 * types are satisfied.
	 */ const conditionalProps = shouldFitContainer ? {
        shouldFitContainer: shouldFitContainer
    } : {
        shouldRenderToParent: shouldRenderToParent
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7mYCs.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        id: isLocalOpen ? id : undefined,
        shouldFlip: shouldFlip,
        isOpen: isLocalOpen,
        onClose: handleOnClose,
        zIndex: zIndex,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        testId: testId && `${testId}--content`,
        shouldUseCaptureOnOutsideClick: true,
        ...conditionalProps,
        shouldDisableFocusLock: true,
        trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, // DSP-13312 TODO: remove spread props in future major release
        ...rest })=>{
            if (typeof trigger === 'function') return trigger({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup,
                ...rest,
                ...bindFocus,
                triggerRef: (0, $1lQG9.default)([
                    ref,
                    itemRef
                ]),
                isSelected: isLocalOpen,
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
                ...bindFocus,
                ref: (0, $1lQG9.default)([
                    ref,
                    itemRef
                ]),
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                isSelected: isLocalOpen,
                iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))),
                onClick: handleTriggerClicked,
                testId: testId && `${testId}--trigger`,
                "aria-label": label
            }, trigger);
        },
        content: ({ setInitialFocusRef: setInitialFocusRef, update: update })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dkYal.default), {
                onClose: handleOnClose
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jiH6M.default), {
                spacing: spacing,
                maxHeight: $cd131b446ad30d0e$var$MAX_HEIGHT,
                maxWidth: shouldFitContainer ? undefined : 800,
                onClose: handleOnClose,
                onUpdate: update,
                isLoading: isLoading,
                statusLabel: statusLabel,
                setInitialFocusRef: isTriggeredUsingKeyboard || autoFocus ? setInitialFocusRef : undefined,
                shouldRenderToParent: shouldRenderToParent || shouldFitContainer,
                isTriggeredUsingKeyboard: isTriggeredUsingKeyboard,
                autoFocus: autoFocus,
                testId: testId && `${testId}--menu-wrapper`
            }, children))
    }));
};
var $cd131b446ad30d0e$export$2e2bcd8739ae039 = $cd131b446ad30d0e$var$DropdownMenu;

});
/**
 * Character key codes which can be used in keyboard events.
 */ const $54717ce5fa2c74b1$export$390330c10ff2b9a1 = 'ArrowUp';
const $54717ce5fa2c74b1$export$a80636c6f41931fe = 'ArrowDown';
const $54717ce5fa2c74b1$export$4af703091671bc = 'Home';
const $54717ce5fa2c74b1$export$e2bc30913faa5db7 = 'End';
const $54717ce5fa2c74b1$export$10f6869ed0a7d75b = 'Tab';
const $54717ce5fa2c74b1$export$8152f929a25a0ff4 = 'Enter';
const $54717ce5fa2c74b1$export$e51a3576c045c8d5 = 'Space';
const $54717ce5fa2c74b1$export$2bb790b9008907b4 = 'Escape';

parcelRegister("2WwAS", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc974ed9b9ba7adb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $fc974ed9b9ba7adb$export$2e2bcd8739ae039(propValue, getDefaultPropValue = ()=>propValue) {
    const isControlled = propValue !== undefined;
    const [valueState, setValue] = (0, $eUqFw.useState)(getDefaultPropValue);
    const isControlledRef = (0, $eUqFw.useRef)(isControlled);
    (0, $eUqFw.useEffect)(()=>{
        isControlledRef.current = isControlled;
    }, [
        isControlled
    ]);
    const value = isControlled ? propValue : valueState;
    const setValueIfUncontrolled = (0, $eUqFw.useCallback)((newValue)=>{
        if (!isControlledRef.current) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}

});

parcelRegister("7PTrT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cf74c53325012fd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $2cf74c53325012fd$export$2e2bcd8739ae039() {
    const [isFocused, setIsFocused] = (0, $eUqFw.useState)(false);
    // ensure bindFocus has a stable ref
    const bindFocus = (0, $eUqFw.useRef)({
        onFocus: ()=>setIsFocused(true),
        onBlur: ()=>setIsFocused(false)
    });
    (0, $eUqFw.useEffect)(()=>{
        // handle the case where a component might
        // unmount while being focused.
        return ()=>setIsFocused(false);
    }, []);
    return {
        isFocused: isFocused,
        bindFocus: bindFocus.current
    };
}

});

parcelRegister("dkYal", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $cf3cae93cc4408b7$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $cf3cae93cc4408b7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $5Q9wj = parcelRequire("5Q9wj");

var $eN43R = parcelRequire("eN43R");

var $9wjz6 = parcelRequire("9wjz6");
const $cf3cae93cc4408b7$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    menuItemRefs: [],
    registerRef: (0, $5Q9wj.default)
});
/**
 * Focus manager logic.
 */ const $cf3cae93cc4408b7$var$FocusManager = ({ children: children, onClose: onClose })=>{
    const menuItemRefs = (0, $eUqFw.useRef)([]);
    const registerRef = (0, $eUqFw.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    const { isLayerDisabled: isLayerDisabled } = (0, $eN43R.UNSAFE_useLayering)();
    // Intentionally rebinding on each render
    (0, $eUqFw.useEffect)(()=>{
        return (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: (0, $9wjz6.default)(menuItemRefs.current, isLayerDisabled, onClose)
        });
    });
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cf3cae93cc4408b7$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $cf3cae93cc4408b7$export$2e2bcd8739ae039 = $cf3cae93cc4408b7$var$FocusManager;

});
parcelRegister("9wjz6", function(module, exports) {

$parcel$export(module.exports, "default", () => $66539497081f56cc$export$2e2bcd8739ae039);

const $66539497081f56cc$var$actionMap = {
    [(0, $54717ce5fa2c74b1$export$a80636c6f41931fe)]: 'next',
    [(0, $54717ce5fa2c74b1$export$390330c10ff2b9a1)]: 'prev',
    [(0, $54717ce5fa2c74b1$export$4af703091671bc)]: 'first',
    [(0, $54717ce5fa2c74b1$export$e2bc30913faa5db7)]: 'last'
};
/**
 * `currentFocusedIdx + 1` will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * `currentFocusedIdx - 1` will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $66539497081f56cc$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].hasAttribute('disabled');
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $66539497081f56cc$export$2e2bcd8739ae039(refs, isLayerDisabled, onClose) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        if (isLayerDisabled()) {
            // if nested dropdown isOpen we need to close on Tab key press
            if (e.key === (0, $54717ce5fa2c74b1$export$10f6869ed0a7d75b) && !e.shiftKey) onClose(e);
            // if it is a nested dropdown and the level of the given dropdown is not the current level,
            // we don't need to have focus on it
            return;
        }
        const action = $66539497081f56cc$var$actionMap[e.key];
        switch(action){
            case 'next':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx < refs.length - 1) {
                    const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement?.focus();
                } else {
                    const firstFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                    firstFocusableElement?.focus();
                }
                break;
            case 'prev':
                // Always cancelling the event to prevent scrolling
                e.preventDefault();
                if (currentFocusedIdx > 0) {
                    const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement?.focus();
                } else {
                    const lastFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                    lastFocusableElement?.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $66539497081f56cc$var$getNextFocusableElement(refs, -1);
                nextFocusableElement?.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $66539497081f56cc$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement?.focus();
                break;
            default:
                return;
        }
    };
}

});


parcelRegister("jiH6M", function(module, exports) {

$parcel$export(module.exports, "default", () => $964014f36228d6e8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8PFhw = parcelRequire("8PFhw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $dkYal = parcelRequire("dkYal");

var $fccfd = parcelRequire("fccfd");

var $1g0c9 = parcelRequire("1g0c9");
const $964014f36228d6e8$var$spinnerContainerStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    minWidth: '160px',
    padding: 'space.250',
    justifyContent: 'center'
});
const $964014f36228d6e8$var$LoadingIndicator = ({ statusLabel: statusLabel = 'Loading', testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $964014f36228d6e8$var$spinnerContainerStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        size: "small",
        label: statusLabel,
        testId: testId
    }));
/**
 *
 * MenuWrapper wraps all the menu items.
 * It handles the logic to close the menu when a MenuItem is clicked, but leaves it open
 * if a CheckboxItem or RadioItem is clicked.
 * It also sets focus to the first menu item when opened.
 */ const $964014f36228d6e8$var$MenuWrapper = ({ children: children, isLoading: isLoading, maxHeight: maxHeight, maxWidth: maxWidth, onClose: onClose, onUpdate: onUpdate, statusLabel: statusLabel, setInitialFocusRef: setInitialFocusRef, shouldRenderToParent: shouldRenderToParent, spacing: spacing, testId: testId, isTriggeredUsingKeyboard: isTriggeredUsingKeyboard, autoFocus: autoFocus })=>{
    const { menuItemRefs: menuItemRefs } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const closeOnMenuItemClick = (e)=>{
        const isTargetMenuItemOrDecendant = menuItemRefs.some((menuItem)=>{
            const isCheckboxOrRadio = (0, $fccfd.default)(menuItem) || (0, $1g0c9.default)(menuItem);
            return menuItem.contains(e.target) && !isCheckboxOrRadio;
        });
        // Close menu if the click is triggered from a MenuItem or
        // its descendant. Don't close the menu if the click is triggered
        // from a MenuItemRadio or MenuItemCheckbox so that the user can
        // select multiple items.
        if (isTargetMenuItemOrDecendant && onClose) onClose(e);
    };
    // Using useEffect here causes a flicker.
    // useLayoutEffect ensures that the update and render happen in the same
    // rAF tick.
    (0, $eUqFw.useLayoutEffect)(()=>{
        onUpdate();
    }, [
        isLoading,
        onUpdate
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const firstFocusableRef = menuItemRefs.find((ref)=>!ref.hasAttribute('disabled')) ?? null;
        if (shouldRenderToParent && (isTriggeredUsingKeyboard || autoFocus)) firstFocusableRef?.focus();
        setInitialFocusRef?.(firstFocusableRef);
    }, [
        menuItemRefs,
        setInitialFocusRef,
        autoFocus,
        shouldRenderToParent,
        isTriggeredUsingKeyboard
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
        isLoading: isLoading,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        onClick: closeOnMenuItemClick,
        role: "menu",
        spacing: spacing,
        testId: testId && `${testId}--menu-group`
    }, isLoading ? /*#__PURE__*/ (0, $byn9U.jsx)($964014f36228d6e8$var$LoadingIndicator, {
        statusLabel: statusLabel,
        testId: testId && `${testId}--loading-indicator`
    }) : children);
};
var $964014f36228d6e8$export$2e2bcd8739ae039 = $964014f36228d6e8$var$MenuWrapper;

});
parcelRegister("fccfd", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cc914649461e3b8$export$2e2bcd8739ae039);
function $2cc914649461e3b8$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'checkbox' || role === 'menuitemcheckbox';
}

});

parcelRegister("1g0c9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3727e20ee9b5acb1$export$2e2bcd8739ae039);
function $3727e20ee9b5acb1$export$2e2bcd8739ae039(element) {
    const role = element.getAttribute('role');
    return role === 'radio' || role === 'menuitemradio';
}

});


parcelRegister("7mYCs", function(module, exports) {

$parcel$export(module.exports, "SelectionStoreContext", () => $9b55d88a204a2c6b$export$756f795847463ebd);
$parcel$export(module.exports, "default", () => $9b55d88a204a2c6b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");
const $9b55d88a204a2c6b$export$756f795847463ebd = /*#__PURE__*/ (0, $eUqFw.createContext)({
    setItemState: (0, $5Q9wj.default),
    getItemState: ()=>undefined,
    setGroupState: (0, $5Q9wj.default),
    getGroupState: ()=>({})
});
/**
 * Selection store will persist data as long as it remains mounted.
 * It handles the uncontrolled story for dropdown menu when the menu
 * items can be mounted/unmounted depending if the menu is open or closed.
 */ const $9b55d88a204a2c6b$var$SelectionStore = (props)=>{
    const { children: children } = props;
    const store = (0, $eUqFw.useRef)({});
    const context = (0, $eUqFw.useMemo)(()=>({
            setItemState: (group, id, value)=>{
                if (!store.current[group]) store.current[group] = {};
                store.current[group][id] = value;
            },
            getItemState: (group, id)=>{
                if (!store.current[group]) return undefined;
                return store.current[group][id];
            },
            setGroupState: (group, value)=>{
                store.current[group] = value;
            },
            getGroupState: (group)=>{
                return store.current[group] || {};
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9b55d88a204a2c6b$export$756f795847463ebd.Provider, {
        value: context
    }, children);
};
var $9b55d88a204a2c6b$export$2e2bcd8739ae039 = $9b55d88a204a2c6b$var$SelectionStore;

});

parcelRegister("h1Q9j", function(module, exports) {

$parcel$export(module.exports, "default", () => $6def866028b8c887$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dkYal = parcelRequire("dkYal");
// This function is called whenever a MenuItem mounts.
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $6def866028b8c887$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $eUqFw.useContext)((0, $dkYal.FocusManagerContext));
    const itemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $6def866028b8c887$export$2e2bcd8739ae039 = $6def866028b8c887$var$useRegisterItemWithFocusManager;

});

parcelRegister("8gwL5", function(module, exports) {

$parcel$export(module.exports, "PREFIX", () => $bbafb6080e6e0b27$export$8a682ae47622dbb9);
$parcel$export(module.exports, "default", () => $bbafb6080e6e0b27$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $bbafb6080e6e0b27$export$8a682ae47622dbb9 = 'ds--dropdown--';
const $bbafb6080e6e0b27$var$generateRandomString = ()=>// This string is used only on client side usually triggered after a user interaction.
    // Therefore, so there is no risk of mismatch
    // between server and client generated markup.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    `${$bbafb6080e6e0b27$export$8a682ae47622dbb9}${Math.random().toString(16).substr(2, 8)}`;
function $bbafb6080e6e0b27$export$2e2bcd8739ae039() {
    const cachedId = (0, $eUqFw.useRef)($bbafb6080e6e0b27$var$generateRandomString());
    return cachedId.current;
}

});


parcelRegister("9mc6u", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdd85e99771c9c60$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");

var $8jcoK = parcelRequire("8jcoK");

var $bULPy = parcelRequire("bULPy");

var $caOPr = parcelRequire("caOPr");

var $4lVNM = parcelRequire("4lVNM");

var $h1Q9j = parcelRequire("h1Q9j");

var $2fFJv = parcelRequire("2fFJv");
/**
 * __Dropdown item checkbox__
 *
 * A dropdown item checkbox creates groups that have multiple selections.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/usage)
 */ const $bdd85e99771c9c60$var$DropdownItemCheckbox = ({ children: children, defaultSelected: defaultSelected, description: description, id: id, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, $5Q9wj.default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, testId: testId, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    typeof $2fFJv;
    const [selected, setSelected] = (0, $4lVNM.default)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    });
    const onClickHandler = (0, $eUqFw.useCallback)((event)=>{
        setSelected((selected)=>!selected);
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    const itemRef = (0, $h1Q9j.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8jcoK.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        "aria-checked": selected,
        description: description,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $caOPr.default), {
            checked: selected
        }),
        id: id,
        isDisabled: isDisabled,
        isSelected: selected,
        onClick: onClickHandler,
        ref: itemRef,
        role: "menuitemcheckbox",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        ...rest
    }, children));
};
var $bdd85e99771c9c60$export$2e2bcd8739ae039 = $bdd85e99771c9c60$var$DropdownItemCheckbox;

});
parcelRegister("caOPr", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f70ae4045f17c28$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ce8OV = parcelRequire("ce8OV");

var $PdmhA = parcelRequire("PdmhA");
/**
 * __Checkbox icon__
 *
 * Used to visually represent the selected state in DropdownItemCheckbox
 *
 * @internal
 */ const $0f70ae4045f17c28$var$CheckboxIcon = ({ checked: checked })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ce8OV.default), {
        label: "",
        size: "medium",
        primaryColor: checked ? `var(--ds-background-selected-bold, ${0, $PdmhA.B400})` : `var(--ds-background-input, ${0, $PdmhA.N10})`,
        secondaryColor: checked ? `var(--ds-icon-inverse, ${0, $PdmhA.N10})` : 'transparent'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2",
        stroke: checked ? `var(--ds-border-selected, ${0, $PdmhA.B400})` : `var(--ds-border-input, ${0, $PdmhA.N100})`,
        strokeWidth: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "inherit"
    })));
};
var $0f70ae4045f17c28$export$2e2bcd8739ae039 = $0f70ae4045f17c28$var$CheckboxIcon;

});

parcelRegister("4lVNM", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f55dd9044769050$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b9WHI = parcelRequire("b9WHI");

var $7mYCs = parcelRequire("7mYCs");
/**
 * Custom hook to handle checkbox state for dropdown menu.
 * It works in tandem with the selection store context when the
 * component is uncontrolled.
 */ const $4f55dd9044769050$var$useCheckboxState = ({ isSelected: isSelected, id: id, defaultSelected: defaultSelected })=>{
    const { setItemState: setItemState, getItemState: getItemState } = (0, $eUqFw.useContext)((0, $7mYCs.SelectionStoreContext));
    const groupId = (0, $eUqFw.useContext)((0, $b9WHI.CheckboxGroupContext));
    const persistedIsSelected = getItemState(groupId, id);
    const [localIsSelected, setLocalIsSelected] = (0, $eUqFw.useState)(// Initial state is set depending on value being defined or not.
    // This state is only utilised if the checkbox is uncontrolled.
    ()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
    const setLocalState = (0, $eUqFw.useCallback)((newValue)=>{
        const nextValue = newValue(persistedIsSelected);
        setLocalIsSelected(nextValue);
        setItemState(groupId, id, nextValue);
    }, [
        setItemState,
        persistedIsSelected,
        groupId,
        id
    ]);
    // Checkbox is controlled - do nothing!
    if (typeof isSelected === 'boolean') return [
        isSelected,
        ()=>false
    ];
    // Checkbox is going through its first render pass!
    if (persistedIsSelected === undefined) // Set the item so we have this state to access next time the checkbox renders (either by mounting or re-rendering!)
    setItemState(groupId, id, defaultSelected || false);
    // Return the value and setter!
    // Remember this flow is only returned if the checkbox is uncontrolled.
    return [
        localIsSelected,
        setLocalState
    ];
};
var $4f55dd9044769050$export$2e2bcd8739ae039 = $4f55dd9044769050$var$useCheckboxState;

});
parcelRegister("b9WHI", function(module, exports) {

$parcel$export(module.exports, "CheckboxGroupContext", () => $7d37fbf6df8e3733$export$baf37c4be89255b8);

var $eUqFw = parcelRequire("eUqFw");
const $7d37fbf6df8e3733$export$baf37c4be89255b8 = /*#__PURE__*/ (0, $eUqFw.createContext)('');

});



parcelRegister("lS3Pk", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6142e11dfeb428d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a6142e11dfeb428d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    importData: {
        "id": "project-create-importer-upload-flow.mapping-screen.fields-dropdown.import-data",
        "defaultMessage": "Columns:"
    },
    includedColumns: {
        "id": "project-create-importer-upload-flow.mapping-screen.fields-dropdown.included-columns",
        "defaultMessage": "{count, plural, one {# included} other {# included}}"
    },
    ignoredColumns: {
        "id": "project-create-importer-upload-flow.mapping-screen.fields-dropdown.ignored-columns",
        "defaultMessage": "{count, plural, one {# excluded} other {# excluded}}"
    },
    allColumns: {
        "id": "project-create-importer-upload-flow.mapping-screen.fields-dropdown.all-columns",
        "defaultMessage": "All columns"
    }
});

});


parcelRegister("2laZm", function(module, exports) {

$parcel$export(module.exports, "Header", () => $9e7214bdefff1311$export$8b251419efc915eb);

var $eUqFw = parcelRequire("eUqFw");

var $j9fWg = parcelRequire("j9fWg");

var $jWuk1 = parcelRequire("jWuk1");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kzTj7 = parcelRequire("kzTj7");

var $1VyqP = parcelRequire("1VyqP");

var $3EVB9 = parcelRequire("3EVB9");

var $bz2yd = parcelRequire("bz2yd");

var $d0wrd = parcelRequire("d0wrd");
var $2sRUp = parcelRequire("2sRUp");

var $fua3W = parcelRequire("fua3W");
const $9e7214bdefff1311$export$8b251419efc915eb = ({ onCloseAndReturnToUploadStep: onCloseAndReturnToUploadStep, isCompactHeader: isCompactHeader, offsetModalY: offsetModalY })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ type: type }] = (0, $d0wrd.useProjectData)();
    const [source] = (0, $2sRUp.useSource)();
    const { mappingHeading: mappingHeading, mappingDescription: mappingDescription, mappingDescriptionWithLink: mappingDescriptionWithLink, mappingLearnMore: mappingLearnMore, closeButtonLabel: closeButtonLabel } = (0, $bz2yd.useProjectSpecificContent)(type, source);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [, { setCancelImportModalState: setCancelImportModalState }] = (0, $fua3W.useCancelImportModalState)();
    const learnMoreLinkClick = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'x2cLearnMoreToMapCsvLink'
        }));
    }, [
        createAnalyticsEvent
    ]);
    const handleOpenCancelImport = (0, $eUqFw.useCallback)(()=>{
        setCancelImportModalState({
            isCancelImportModalOpen: true,
            shouldCloseDrawerOnCancel: false,
            onCloseModalCallback: onCloseAndReturnToUploadStep,
            offsetModalY: offsetModalY
        });
    }, [
        offsetModalY,
        onCloseAndReturnToUploadStep,
        setCancelImportModalState
    ]);
    if (isCompactHeader) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        justifyContent: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1VyqP.PageHeading), null, formatMessage(mappingHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))),
        appearance: "subtle",
        label: formatMessage(closeButtonLabel),
        onClick: handleOpenCancelImport
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1VyqP.PageDescription), {
        "data-testid": "project-create-importer-upload-flow.ui.mapping-screen.header.compact-description"
    }, formatMessage(mappingDescriptionWithLink, {
        link: (content)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                as: "a",
                href: (0, $kzTj7.CSV_MAPPING_SUPPORT_LINK),
                target: "_blank"
            }, content)
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "div",
        xcss: $9e7214bdefff1311$var$headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3EVB9.CloseAndReturnButton), {
        onCloseAndReturnToUploadStep: onCloseAndReturnToUploadStep
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1VyqP.PageHeading), null, formatMessage(mappingHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1VyqP.PageDescription), {
        "data-testid": "project-create-importer-upload-flow.ui.mapping-screen.header.description"
    }, formatMessage(mappingDescription, {
        link: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1VyqP.LearnMore), {
            href: (0, $kzTj7.CSV_MAPPING_SUPPORT_LINK),
            target: "_blank",
            onClick: learnMoreLinkClick
        }, formatMessage(mappingLearnMore))
    })));
};
const $9e7214bdefff1311$var$headingStyles = (0, $1ZAYh.xcss)({
    marginBlockEnd: 'space.300',
    flex: '0 1 auto'
});

});
parcelRegister("1VyqP", function(module, exports) {

$parcel$export(module.exports, "LearnMore", () => $20cd26f8860d73f6$export$e1cc8c99082b8f05);
$parcel$export(module.exports, "PageHeading", () => $20cd26f8860d73f6$export$9716a88f5535df7c);
$parcel$export(module.exports, "SectionHeading", () => $20cd26f8860d73f6$export$72d7ca7a5d1d4807);
$parcel$export(module.exports, "PageDescription", () => $20cd26f8860d73f6$export$5f24e1347551b2c2);
$parcel$export(module.exports, "ErrorHeading", () => $20cd26f8860d73f6$export$f1b333dd56782094);
$parcel$export(module.exports, "DropdownSectionWrapper", () => $20cd26f8860d73f6$export$eb48b2704e4c9933);
$parcel$export(module.exports, "DropdownSectionHeader", () => $20cd26f8860d73f6$export$79454d4d81898eb3);
$parcel$export(module.exports, "DropdownSectionDivider", () => $20cd26f8860d73f6$export$dd56df8e1139130b);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $20cd26f8860d73f6$export$7ac7d6a768c2e9b2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1tke10j7 _4t3i1osq _bfhk10p6",
            __cmplp.className
        ])
    });
});
const $20cd26f8860d73f6$export$e1cc8c99082b8f05 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz11ce",
            __cmplp.className
        ])
    });
});
const $20cd26f8860d73f6$export$9716a88f5535df7c = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h1", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyb1pa9 _k48pbfng _vwz4zwfg _19pk1epz _otyr1ejb",
            __cmplp.className
        ])
    });
});
const $20cd26f8860d73f6$export$72d7ca7a5d1d4807 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h1", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _k48pbfng _1wybgktf _vwz41tcg _syaz1dv3",
            __cmplp.className
        ])
    });
});
const $20cd26f8860d73f6$export$5f24e1347551b2c2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaznoz8 _19pkidpf _otyrpxbi",
            __cmplp.className
        ])
    });
});
const $20cd26f8860d73f6$export$f1b333dd56782094 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wybgktf _k48pbfng _vwz41tcg _19pkllek _otyrpxbi",
            __cmplp.className
        ])
    });
});
const $20cd26f8860d73f6$export$eb48b2704e4c9933 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s81s3g",
            __cmplp.className
        ])
    });
});
const $20cd26f8860d73f6$export$79454d4d81898eb3 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h3", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1p1dangw _1wyb1crf _vwz47vkz",
            __cmplp.className
        ])
    });
});
const $20cd26f8860d73f6$export$dd56df8e1139130b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3iv77o _bfhk1cs6 _2rkot94y _otyru2gc",
            __cmplp.className
        ])
    });
});

});


parcelRegister("2wmz9", function(module, exports) {

$parcel$export(module.exports, "CSVFieldMappingScreen", () => $ec2421f982e9c702$export$cc7cb6dcdb5dcdc3);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $lRvnl = parcelRequire("lRvnl");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $cHKP9 = parcelRequire("cHKP9");

var $3yuWi = parcelRequire("3yuWi");

var $4nt6G = parcelRequire("4nt6G");

var $elKPF = parcelRequire("elKPF");

var $1T7vu = parcelRequire("1T7vu");

var $7cdKR = parcelRequire("7cdKR");

var $aWLVm = parcelRequire("aWLVm");

var $bgSxq = parcelRequire("bgSxq");

var $bLalW = parcelRequire("bLalW");
var $4uta0 = parcelRequire("4uta0");

var $aEdcH = parcelRequire("aEdcH");
var $lUC5l = parcelRequire("lUC5l");
var $d0wrd = parcelRequire("d0wrd");
var $2sRUp = parcelRequire("2sRUp");

var $fiH3o = parcelRequire("fiH3o");

var $ap0Nu = parcelRequire("ap0Nu");

var $6rHYD = parcelRequire("6rHYD");

var $beIv9 = parcelRequire("beIv9");

var $84Q9E = parcelRequire("84Q9E");

var $2SUld = parcelRequire("2SUld");

var $hbUUM = parcelRequire("hbUUM");

var $eZ21r = parcelRequire("eZ21r");

var $iuOqp = parcelRequire("iuOqp");
const $ec2421f982e9c702$export$cc7cb6dcdb5dcdc3 = ({ onNext: onNext, onReturn: onReturn, onCloseAndReturnToUploadStep: onCloseAndReturnToUploadStep, isCompact: isCompact })=>{
    const [isUnmappedWarningModalOpen, setIsUnmappedWarningModalOpen] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { isLoading: isPreviewLoading, hasErrorOccurred: hasErrorOccurred, onRefresh: onRefresh, mappingState: mappingState, setMappingStateValidationError: setMappingStateValidationError, setUnmappedColumnsNotIncluded: setUnmappedColumnsNotIncluded } = (0, $eZ21r.useMappings)();
    const [migrationId] = (0, $4uta0.useMigrationId)();
    const [advancedOptions] = (0, $bLalW.useAdvancedOptions)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { productSteps: productSteps, currentStepIndex: currentStepIndex } = (0, $fiH3o.useProductSteps)();
    const [source] = (0, $2sRUp.useSource)();
    const [serviceName] = (0, $aEdcH.useImportType)();
    const [{ type: type }] = (0, $d0wrd.useProjectData)();
    const { isLoading: isLoading, validateX2CImport: validateX2CImport } = (0, $ap0Nu.useValidateX2CImport)(source, serviceName);
    const { fieldMappingDescription: fieldMappingDescription } = (0, $bgSxq.useContentForCSV)(serviceName, type);
    const [numOfUnmappedColumnsIncluded] = (0, $lUC5l.useNumUnmappedColumnsIncluded)();
    const onCloseUnmappedWarningModal = (0, $eUqFw.useCallback)(()=>{
        setIsUnmappedWarningModalOpen(false);
    }, []);
    const handleOnNext = (0, $eUqFw.useCallback)(()=>{
        setUnmappedColumnsNotIncluded();
        onNext();
    }, [
        onNext,
        setUnmappedColumnsNotIncluded
    ]);
    const onNextOrOpenWarningModal = (0, $eUqFw.useCallback)(()=>{
        numOfUnmappedColumnsIncluded === 0 ? handleOnNext() : setIsUnmappedWarningModalOpen(true);
    }, [
        handleOnNext,
        numOfUnmappedColumnsIncluded
    ]);
    const onValidateFetchFail = (0, $eUqFw.useCallback)(()=>{
        showFlag((0, $6rHYD.VALIDATION_FAILED_FLAG));
    }, [
        showFlag
    ]);
    const onValidationError = (0, $eUqFw.useCallback)((err)=>{
        setMappingStateValidationError(err);
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'columnMappingValidation failed', {
            numberOfColumnErrors: Object.keys(err.columnErrors).length,
            missingFields: err.missingFields
        });
    }, [
        createAnalyticsEvent,
        setMappingStateValidationError
    ]);
    const validateOnContinue = (0, $eUqFw.useCallback)(()=>{
        if (mappingState === null || migrationId === null) return;
        validateX2CImport({
            migrationId: migrationId,
            mappingState: mappingState,
            advancedOptions: advancedOptions,
            onSuccess: onNextOrOpenWarningModal,
            onFetchFail: onValidateFetchFail,
            onValidationError: onValidationError
        });
    }, [
        mappingState,
        migrationId,
        validateX2CImport,
        advancedOptions,
        onNextOrOpenWarningModal,
        onValidateFetchFail,
        onValidationError
    ]);
    const hasValidationErrors = (0, $aWLVm.hasTableColumnErrors)(mappingState) || (0, $aWLVm.hasMissingFields)(mappingState);
    const sectionMessage = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            paddingBlockEnd: "space.200"
        }, !hasValidationErrors && (!mappingState || mappingState.validationError === null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
            title: formatMessage((0, $2SUld.default).summaryRequiredTitle)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            as: "p"
        }, formatMessage((0, $2SUld.default).summaryRequiredMessage))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
            title: formatMessage((0, $2SUld.default).postValidationBannerHeading)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            as: "p"
        }, formatMessage((0, $2SUld.default).postValidationBannerDescription))))), [
        formatMessage,
        hasValidationErrors,
        mappingState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: (0, $3yuWi.X2C_SCREENS).MAPPING,
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7cdKR.StepScreen), {
        renderProgressBar: !isCompact && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1T7vu.ProgressBarStandard), {
            productSteps: productSteps,
            currentStepIndex: currentStepIndex,
            onClose: onCloseAndReturnToUploadStep
        }),
        renderFooter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $elKPF.StepFooterStandard), {
            alignRight: true,
            isFixedPosition: !isCompact,
            onReturn: onReturn,
            isLoading: isLoading,
            shouldDisableNext: mappingState === null || hasValidationErrors,
            nextButtonType: "submit",
            onClickNext: validateOnContinue
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $ec2421f982e9c702$var$headerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $ec2421f982e9c702$var$headerStyles
    }, formatMessage((0, $2SUld.default).csvFieldMappingHeading)), !hasErrorOccurred && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $ec2421f982e9c702$var$descriptionStyles
    }, fieldMappingDescription), sectionMessage)), !hasErrorOccurred && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, hasValidationErrors && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iuOqp.ValidationError), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $84Q9E.MappingAdvancedOptions), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $beIv9.FieldMapping), {
        isLoading: isPreviewLoading
    })), hasErrorOccurred && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4nt6G.ErrorScreen), {
        onClick: onRefresh,
        illustration: (0, (/*@__PURE__*/$parcel$interopDefault($cHKP9))),
        header: formatMessage((0, $2SUld.default).networkErrorHeading),
        description: formatMessage((0, $2SUld.default).networkErrorDescription)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hbUUM.UnmappedColumnsWarningModal), {
        isModalOpen: isUnmappedWarningModalOpen,
        onCancel: onCloseUnmappedWarningModal,
        onContinue: handleOnNext,
        offsetModalY: 64
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null)));
};
const $ec2421f982e9c702$var$headerWrapperStyles = (0, $1ZAYh.xcss)({
    width: '610px',
    marginInline: 'space.200',
    alignSelf: 'center'
});
const $ec2421f982e9c702$var$headerStyles = (0, $1ZAYh.xcss)({
    color: 'color.text',
    font: "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    paddingBottom: 'space.100'
});
const $ec2421f982e9c702$var$descriptionStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.subtle',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    paddingBottom: 'space.200'
});

});
parcelRegister("beIv9", function(module, exports) {

$parcel$export(module.exports, "FieldMapping", () => $a2ee03f87b21d518$export$48c83e5df1121237);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gGm3k = parcelRequire("gGm3k");

var $fQU5k = parcelRequire("fQU5k");

var $lUC5l = parcelRequire("lUC5l");

var $2jhyd = parcelRequire("2jhyd");

var $cpb00 = parcelRequire("cpb00");

var $fVhIF = parcelRequire("fVhIF");

var $dUz2i = parcelRequire("dUz2i");
const $a2ee03f87b21d518$var$ROWS_PER_PAGE = 8;
const $a2ee03f87b21d518$export$48c83e5df1121237 = ({ isLoading: isLoading })=>{
    const [mappingState, { setMappingStateValidationError: setMappingStateValidationError }] = (0, $lUC5l.useMappingState)();
    const [selectedFilter, setFilter] = (0, $eUqFw.useState)((0, $cpb00.ALL));
    const [searchTerm, setSearchTerm] = (0, $eUqFw.useState)('');
    const [isErrorToggleEnabled, setIsErrorToggleEnabled] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const tableHead = (0, $dUz2i.useTableHead)();
    const tableRows = (0, $dUz2i.useTableRows)({
        mappingState: mappingState,
        searchTerm: searchTerm,
        filter: selectedFilter,
        isErrorToggleEnabled: isErrorToggleEnabled
    });
    const onErrorColumnsToggle = (0, $eUqFw.useCallback)((isChecked)=>{
        if (isChecked && mappingState !== null && mappingState.validationError !== null) setMappingStateValidationError(mappingState.validationError);
        setIsErrorToggleEnabled(isChecked);
    }, [
        mappingState,
        setMappingStateValidationError
    ]);
    const emptyView = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
            alignInline: "center",
            alignBlock: "center",
            grow: "fill"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            as: "img",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($gGm3k))),
            alt: "",
            xcss: $a2ee03f87b21d518$var$illustrationStyles
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            as: "p",
            xcss: $a2ee03f87b21d518$var$emptyDescriptionStyles
        }, formatMessage((0, $fVhIF.default).emptyViewMessage))), [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: "project-create-importer-upload-flow.ui.mapping-screen.field-mapping.box"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2jhyd.Filters), {
        selectedFilter: selectedFilter || (0, $cpb00.ALL),
        onSearch: setSearchTerm,
        onFilterChange: setFilter,
        onToggleChange: onErrorColumnsToggle,
        showErrorToggle: !!mappingState && mappingState.validationError !== null
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fQU5k.AsyncMappingTable), {
        head: tableHead,
        rows: tableRows,
        rowsPerPage: $a2ee03f87b21d518$var$ROWS_PER_PAGE,
        isLoading: isLoading,
        emptyView: emptyView
    }));
};
const $a2ee03f87b21d518$var$illustrationStyles = (0, $1ZAYh.xcss)({
    maxHeight: '120px',
    marginBlockEnd: 'space.300'
});
const $a2ee03f87b21d518$var$emptyDescriptionStyles = (0, $1ZAYh.xcss)({
    font: "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    color: 'color.text'
});

});
parcelRegister("gGm3k", function(module, exports) {
module.exports = new URL("GenericErrorNoResults.307e3cc6.svg", import.meta.url).toString();

});

parcelRegister("2jhyd", function(module, exports) {

$parcel$export(module.exports, "Filters", () => $09be1c56005a1dc1$export$92a576f896a9bf72);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $86Ndv = parcelRequire("86Ndv");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1ZAYh = parcelRequire("1ZAYh");

var $e270j = parcelRequire("e270j");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $eft4l = parcelRequire("eft4l");

var $cpb00 = parcelRequire("cpb00");

var $dKXUc = parcelRequire("dKXUc");
const $09be1c56005a1dc1$export$92a576f896a9bf72 = ({ onSearch: onSearch, onFilterChange: onFilterChange, selectedFilter: selectedFilter, onToggleChange: onToggleChange, showErrorToggle: showErrorToggle })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isSearchEventSent = (0, $eUqFw.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const dropdownTrigger = (0, $eUqFw.useCallback)(({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            ...props,
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                size: "medium",
                label: ""
            }),
            ref: triggerRef
        }, formatMessage((0, $cpb00.filterMessages)[selectedFilter])), [
        formatMessage,
        selectedFilter
    ]);
    const onChangeOfFilter = (0, $eUqFw.useCallback)((filter)=>{
        onFilterChange(filter);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'fieldMappingFilter selected', {
            filter: filter
        });
    }, [
        createAnalyticsEvent,
        onFilterChange
    ]);
    const filterList = (0, $eUqFw.useMemo)(()=>(0, $cpb00.availableFilters).map((filter)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
                onClick: ()=>onChangeOfFilter(filter),
                key: filter,
                isSelected: selectedFilter === filter
            }, formatMessage((0, $cpb00.filterMessages)[filter]))), [
        formatMessage,
        onChangeOfFilter,
        selectedFilter
    ]);
    const onChange = (0, $eUqFw.useCallback)((e)=>{
        onSearch(e.target.value);
        if (!isSearchEventSent.current) {
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'fieldMappingSearch searched');
            isSearchEventSent.current = true;
        }
    }, [
        createAnalyticsEvent,
        onSearch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        justifyContent: "space-between",
        xcss: $09be1c56005a1dc1$var$wrapperStyles,
        testId: "project-create-importer-upload-flow.ui.mapping-screen.field-mapping.filters.flex"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        gap: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $09be1c56005a1dc1$var$searchWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eft4l.SearchBar), {
        onSearchTermChange: onChange,
        placeholder: (0, $dKXUc.default).searchPlacholder,
        isCompact: true
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        trigger: dropdownTrigger
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, filterList))), showErrorToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        alignItems: "center",
        gap: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e270j.default), {
        onChange: (event)=>onToggleChange(event.target.checked),
        label: formatMessage((0, $dKXUc.default).showOnlyFieldsWithErrors)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, formatMessage((0, $dKXUc.default).showOnlyFieldsWithErrors))));
};
const $09be1c56005a1dc1$var$wrapperStyles = (0, $1ZAYh.xcss)({
    paddingBlock: 'space.300'
});
const $09be1c56005a1dc1$var$searchWrapperStyles = (0, $1ZAYh.xcss)({
    width: '240px'
});

});
parcelRegister("hD6GJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $67738981858b3f25$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1lQG9 = parcelRequire("1lQG9");

var $bULPy = parcelRequire("bULPy");

var $e7PSD = parcelRequire("e7PSD");

var $bo4OB = parcelRequire("bo4OB");

var $h1Q9j = parcelRequire("h1Q9j");
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-item/usage)
 */ const $67738981858b3f25$var$DropdownMenuItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, ...rest }, ref)=>{
    const itemRef = (0, $h1Q9j.default)();
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7PSD.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...rest
    }, children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        ...rest
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...rest
    }, children);
});
var $67738981858b3f25$export$2e2bcd8739ae039 = $67738981858b3f25$var$DropdownMenuItem;

});

parcelRegister("fEubG", function(module, exports) {

$parcel$export(module.exports, "default", () => $920365f1041780e0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jFtVs = parcelRequire("jFtVs");

var $8BKky = parcelRequire("8BKky");

var $lmkW0 = parcelRequire("lmkW0");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $920365f1041780e0$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
    const uid = (0, $jFtVs.useUID)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BKky.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-deprecated-apis
        overrides: overrides,
        ...rest
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lmkW0.default), {
        id: titleId,
        title: title
    }), children);
});
var $920365f1041780e0$export$2e2bcd8739ae039 = $920365f1041780e0$var$DropdownMenuItemGroup;

});
parcelRegister("lmkW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c8b6b0ed3e98f7b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $4lTFP = parcelRequire("4lTFP");
const $4c8b6b0ed3e98f7b$var$itemHeadingContentHeight = (0, $4lTFP.headingSizes).h100.lineHeight;
const $4c8b6b0ed3e98f7b$var$itemHeadingFontSize = (0, $4lTFP.headingSizes).h100.size;
const $4c8b6b0ed3e98f7b$var$headingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-subtle, ${(0, $PdmhA.N300)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: $4c8b6b0ed3e98f7b$var$itemHeadingFontSize,
    fontWeight: "var(--ds-font-weight-bold, 700)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    lineHeight: $4c8b6b0ed3e98f7b$var$itemHeadingContentHeight / $4c8b6b0ed3e98f7b$var$itemHeadingFontSize,
    paddingBlock: "var(--ds-space-0, 0px)",
    paddingInline: "var(--ds-space-200, 16px)",
    textTransform: 'uppercase'
});
/**
 * __Group title__
 *
 * Used to visually represent the title for DropdownMenu groups
 *
 * @internal
 */ const $4c8b6b0ed3e98f7b$var$GroupTitle = ({ id: id, title: title })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-ds--menu--heading-item": true,
        role: "menuitem",
        id: id,
        "aria-hidden": "true",
        css: $4c8b6b0ed3e98f7b$var$headingStyles
    }, title);
var $4c8b6b0ed3e98f7b$export$2e2bcd8739ae039 = $4c8b6b0ed3e98f7b$var$GroupTitle;

});


parcelRegister("eft4l", function(module, exports) {

$parcel$export(module.exports, "SearchBar", () => $88d4807a796c67fc$export$79d13b60110f33be);

var $eUqFw = parcelRequire("eUqFw");

var $dsroq = parcelRequire("dsroq");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $cf2Y4 = parcelRequire("cf2Y4");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kzTj7 = parcelRequire("kzTj7");

var $2Y9lr = parcelRequire("2Y9lr");
const $88d4807a796c67fc$export$79d13b60110f33be = ({ onSearchTermChange: onSearchTermChange, placeholder: placeholder, isCompact: isCompact })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
        testId: (0, $kzTj7.SEARCH_TEXTFIELD_TEST_ID),
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $88d4807a796c67fc$var$searchIconWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dsroq))), {
            size: "small",
            label: ""
        })),
        placeholder: formatMessage(placeholder || (0, $2Y9lr.default).search),
        onChange: onSearchTermChange,
        "aria-label": formatMessage(placeholder || (0, $2Y9lr.default).search),
        isCompact: isCompact
    });
};
const $88d4807a796c67fc$var$searchIconWrapperStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.100'
});

});
parcelRegister("2Y9lr", function(module, exports) {

$parcel$export(module.exports, "default", () => $23603bca9a2d9115$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $23603bca9a2d9115$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    search: {
        "id": "project-create-importer-upload-flow.common.search-bar.search",
        "defaultMessage": "Search all fields"
    }
});

});


parcelRegister("cpb00", function(module, exports) {

$parcel$export(module.exports, "ALL", () => $4a7d0765196be896$export$61b49a5ae59d663);
$parcel$export(module.exports, "MAPPED", () => $4a7d0765196be896$export$192b5d5f85a41138);
$parcel$export(module.exports, "availableFilters", () => $4a7d0765196be896$export$16a138bde9d9de87);
$parcel$export(module.exports, "filterMessages", () => $4a7d0765196be896$export$1c7f7f3bbe522ebc);

var $dKXUc = parcelRequire("dKXUc");
const $4a7d0765196be896$export$61b49a5ae59d663 = 'ALL';
const $4a7d0765196be896$export$192b5d5f85a41138 = 'MAPPED';
const $4a7d0765196be896$export$a404d8a18351cf3e = 'UNMAPPED';
const $4a7d0765196be896$export$16a138bde9d9de87 = [
    $4a7d0765196be896$export$61b49a5ae59d663,
    $4a7d0765196be896$export$192b5d5f85a41138,
    $4a7d0765196be896$export$a404d8a18351cf3e
];
const $4a7d0765196be896$export$1c7f7f3bbe522ebc = {
    ALL: (0, $dKXUc.default).allFields,
    MAPPED: (0, $dKXUc.default).mappedFields,
    UNMAPPED: (0, $dKXUc.default).unmappedFields
};

});
parcelRegister("dKXUc", function(module, exports) {

$parcel$export(module.exports, "default", () => $df5ba789d774e66c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $df5ba789d774e66c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    searchPlacholder: {
        "id": "project-create-importer-upload-flow.mapping-screen.field-mapping.filters.search-placholder",
        "defaultMessage": "Search columns in CSV"
    },
    allFields: {
        "id": "project-create-importer-upload-flow.mapping-screen.field-mapping.filters.all-fields",
        "defaultMessage": "All fields"
    },
    mappedFields: {
        "id": "project-create-importer-upload-flow.mapping-screen.field-mapping.filters.mapped-fields",
        "defaultMessage": "Mapped fields"
    },
    unmappedFields: {
        "id": "project-create-importer-upload-flow.mapping-screen.field-mapping.filters.unmapped-fields",
        "defaultMessage": "Unmapped fields"
    },
    showOnlyFieldsWithErrors: {
        "id": "project-create-importer-upload-flow.mapping-screen.field-mapping.filters.show-only-fields-with-errors",
        "defaultMessage": "Show only fields with errors"
    }
});

});



parcelRegister("fVhIF", function(module, exports) {

$parcel$export(module.exports, "default", () => $36b5d56ef96c7758$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $36b5d56ef96c7758$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    jiraFields: {
        "id": "project-create-importer-upload-flow.mapping-screen.field-mapping.jira-fields",
        "defaultMessage": "Jira fields"
    },
    includeInImport: {
        "id": "project-create-importer-upload-flow.mapping-screen.field-mapping.include-in-import",
        "defaultMessage": "Include in import"
    },
    emptyViewMessage: {
        "id": "project-create-importer-upload-flow.mapping-screen.field-mapping.empty-view-message",
        "defaultMessage": "No fields found"
    }
});

});

parcelRegister("dUz2i", function(module, exports) {

$parcel$export(module.exports, "useTableHead", () => $afab7db9df9b90ef$export$c1593f9fc5eec62b);
$parcel$export(module.exports, "useTableRows", () => $afab7db9df9b90ef$export$a190e1af00082b41);

var $eUqFw = parcelRequire("eUqFw");

var $cSu9v = parcelRequire("cSu9v");

var $77CtJ = parcelRequire("77CtJ");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bgSxq = parcelRequire("bgSxq");

var $aEdcH = parcelRequire("aEdcH");

var $lsvFu = parcelRequire("lsvFu");

var $cpb00 = parcelRequire("cpb00");

var $dEDL0 = parcelRequire("dEDL0");

var $fVhIF = parcelRequire("fVhIF");
const $afab7db9df9b90ef$export$c1593f9fc5eec62b = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [importType] = (0, $aEdcH.useImportType)();
    const { fieldMappingTableHeading: fieldMappingTableHeading } = (0, $bgSxq.useContentForCSV)(importType);
    const tableHead = (0, $eUqFw.useMemo)(()=>({
            cells: [
                {
                    key: 'csvField',
                    content: fieldMappingTableHeading
                },
                {
                    key: 'arrow',
                    width: 8
                },
                {
                    key: 'jiraField',
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
                        space: "space.050",
                        alignBlock: "center"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77CtJ.JiraIcon), {
                        label: formatMessage((0, $fVhIF.default).jiraFields),
                        size: "small",
                        appearance: "brand"
                    }), formatMessage((0, $fVhIF.default).jiraFields)),
                    width: 30
                },
                {
                    key: 'field-checkbox',
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
                        alignInline: "center"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                        as: "p"
                    }, formatMessage((0, $fVhIF.default).includeInImport))),
                    width: 15
                }
            ]
        }), [
        fieldMappingTableHeading,
        formatMessage
    ]);
    return tableHead;
};
const $afab7db9df9b90ef$export$a190e1af00082b41 = ({ mappingState: mappingState, searchTerm: searchTerm, filter: filter, isErrorToggleEnabled: isErrorToggleEnabled })=>{
    const filterCompare = (0, $eUqFw.useCallback)((columnName)=>{
        if (filter === (0, $cpb00.ALL)) return true;
        if (filter === (0, $cpb00.MAPPED)) return mappingState?.columns[columnName].field !== null;
        return mappingState?.columns[columnName].field === null;
    }, [
        filter,
        mappingState?.columns
    ]);
    const combinedFilter = (0, $eUqFw.useCallback)((name)=>name.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase()) && filterCompare(name), [
        filterCompare,
        searchTerm
    ]);
    const tableRows = (0, $eUqFw.useMemo)(()=>{
        if (mappingState === null) return [];
        const columns = (isErrorToggleEnabled ? mappingState.errorsFilter : mappingState.columnOrder) || [];
        return columns.filter(combinedFilter).map((columnName)=>({
                key: `row-${columnName}`,
                cells: [
                    {
                        key: `${columnName}-name`,
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                            as: "p"
                        }, columnName)
                    },
                    {
                        key: `${columnName}-arrow`,
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
                            label: "",
                            size: "medium"
                        })
                    },
                    {
                        key: `${columnName}-jira-field`,
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lsvFu.FieldSelector), {
                            fieldMap: mappingState.columns[columnName]
                        })
                    },
                    {
                        key: `${columnName}-checkbox`,
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
                            alignInline: "center"
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dEDL0.IncludeInImport), {
                            fieldMap: mappingState.columns[columnName]
                        }))
                    }
                ]
            }));
    }, [
        combinedFilter,
        isErrorToggleEnabled,
        mappingState
    ]);
    return tableRows;
};

});
parcelRegister("lsvFu", function(module, exports) {

$parcel$export(module.exports, "FieldSelector", () => $59d6249dbf737fd2$export$1e75f01162ffc4f1);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $6OfWd = parcelRequire("6OfWd");

var $86Ndv = parcelRequire("86Ndv");

var $96IgR = parcelRequire("96IgR");

var $ffiyv = parcelRequire("ffiyv");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $4lTFP = parcelRequire("4lTFP");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hlez9 = parcelRequire("hlez9");

var $cpndv = parcelRequire("cpndv");

var $qhrvv = parcelRequire("qhrvv");

var $3tnMR = parcelRequire("3tnMR");

var $iMmmw = parcelRequire("iMmmw");
const $59d6249dbf737fd2$export$1e75f01162ffc4f1 = ({ fieldMap: fieldMap })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const [isCustomFieldsMenuOpen, setIsCustomFieldsMenuOpen] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { hasValidationError: hasValidationError, validationMessage: validationMessage } = (0, $iMmmw.useValidationError)(fieldMap.columnName);
    const toggleMenuOpenState = (0, $eUqFw.useCallback)((attrs)=>{
        setIsOpen(attrs.isOpen);
        if (!attrs.isOpen) setIsCustomFieldsMenuOpen(false);
    }, []);
    const dropdownTrigger = (0, $eUqFw.useCallback)(({ triggerRef: triggerRef, ...props })=>{
        const isSelected = Boolean(fieldMap.field);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: hasValidationError ? $59d6249dbf737fd2$var$validationErrorBorderStyles : []
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            ...props,
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                size: "medium",
                label: ""
            }),
            ref: triggerRef,
            isDisabled: !fieldMap.isIncluded
        }, isSelected && fieldMap.isIncluded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $59d6249dbf737fd2$var$buttonSelectedStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            alignBlock: "center",
            space: "space.150"
        }, (0, $hlez9.getIcon)({
            fieldType: fieldMap.field?.fieldType,
            isSelected: isOpen
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, fieldMap.field?.fieldName)), fieldMap.field?.fieldId === null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
            appearance: "new"
        }, formatMessage((0, $qhrvv.default).newField))), !fieldMap.isIncluded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $59d6249dbf737fd2$var$buttonPlaceholderStyles
        }, formatMessage((0, $qhrvv.default).doNotImport)), !isSelected && fieldMap.isIncluded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $59d6249dbf737fd2$var$buttonPlaceholderStyles
        }, formatMessage((0, $qhrvv.default).fieldSelectorPlaceholder)))), hasValidationError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            xcss: $59d6249dbf737fd2$var$errorMessageStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
            size: "small",
            label: "error",
            primaryColor: "color.icon.danger"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            as: "span"
        }, validationMessage)));
    }, [
        fieldMap.field,
        fieldMap.isIncluded,
        formatMessage,
        hasValidationError,
        isOpen,
        validationMessage
    ]);
    const onCustomFieldMenuOpen = (0, $eUqFw.useCallback)((event)=>{
        event.stopPropagation();
        setIsCustomFieldsMenuOpen(true);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: "project-create-importer-upload-flow.ui.mapping-screen.field-mapping.field-selector.wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        testId: "project-create-importer-upload-flow.ui.mapping-screen.field-mapping.field-selector.dropdown-menu",
        onOpenChange: toggleMenuOpenState,
        shouldFlip: true,
        isOpen: isOpen,
        placement: "bottom-end",
        autoFocus: false,
        trigger: dropdownTrigger
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, isCustomFieldsMenuOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3tnMR.NewCustomFields), {
        fieldMap: fieldMap,
        onBack: ()=>setIsCustomFieldsMenuOpen(false)
    }), !isCustomFieldsMenuOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cpndv.ExistingFields), {
        fieldMap: fieldMap,
        onCustomFieldMenuOpen: onCustomFieldMenuOpen
    }))));
};
const $59d6249dbf737fd2$var$buttonPlaceholderStyles = (0, $1ZAYh.xcss)({
    textAlign: 'left',
    width: '252px',
    alignItems: 'center',
    color: 'color.text.subtlest'
});
const $59d6249dbf737fd2$var$buttonSelectedStyles = (0, $1ZAYh.xcss)({
    width: '252px',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    minWidth: '0'
});
const $59d6249dbf737fd2$var$errorMessageStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.danger',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    font: `var(--ds-font-body-small, ${(0, $4lTFP.fontFallback).body.small})`,
    lineHeight: '14px',
    fontWeight: '400',
    gap: 'space.050',
    marginBlockStart: 'space.100'
});
const $59d6249dbf737fd2$var$validationErrorBorderStyles = (0, $1ZAYh.xcss)({
    borderWidth: 'border.width.outline',
    borderStyle: 'solid',
    borderColor: 'color.border.danger',
    borderRadius: 'border.radius.050'
});

});
parcelRegister("hlez9", function(module, exports) {

$parcel$export(module.exports, "ICON_COLOR_INVALID", () => $faf61a973e1f52be$export$22f0b02dd941193d);
$parcel$export(module.exports, "getIcon", () => $faf61a973e1f52be$export$16b26cd5e98d9100);
$parcel$export(module.exports, "getDescriptorForNewFieldType", () => $faf61a973e1f52be$export$6762f514d8e63c51);
$parcel$export(module.exports, "getDescriptionForNewFieldType", () => $faf61a973e1f52be$export$56d8aa05182be1a3);

var $eUqFw = parcelRequire("eUqFw");

var $k4jc8 = parcelRequire("k4jc8");

var $fD5Ev = parcelRequire("fD5Ev");

var $kMHOY = parcelRequire("kMHOY");

var $hSJ9G = parcelRequire("hSJ9G");

var $lBXn2 = parcelRequire("lBXn2");

var $ciWKE = parcelRequire("ciWKE");

var $jfQfF = parcelRequire("jfQfF");

var $d3vNK = parcelRequire("d3vNK");

var $dZhDV = parcelRequire("dZhDV");

var $jhzap = parcelRequire("jhzap");

var $75j3W = parcelRequire("75j3W");

var $eoKor = parcelRequire("eoKor");

var $2OpmI = parcelRequire("2OpmI");

var $fvQWm = parcelRequire("fvQWm");

var $hUwRB = parcelRequire("hUwRB");

var $b8123 = parcelRequire("b8123");

var $4nfxm = parcelRequire("4nfxm");

var $iwsIy = parcelRequire("iwsIy");

var $c6Z6Z = parcelRequire("c6Z6Z");

var $k6W9R = parcelRequire("k6W9R");

var $cglEj = parcelRequire("cglEj");

var $jHMvH = parcelRequire("jHMvH");

var $PdmhA = parcelRequire("PdmhA");

var $aTFGL = parcelRequire("aTFGL");

var $8IVyB = parcelRequire("8IVyB");

var $gVdQC = parcelRequire("gVdQC");

var $agB2z = parcelRequire("agB2z");

var $aYMEC = parcelRequire("aYMEC");

var $hVFYn = parcelRequire("hVFYn");
const $faf61a973e1f52be$var$ICON_COLOR = `var(--ds-icon-subtle, ${(0, $PdmhA).N700})`;
const $faf61a973e1f52be$var$ICON_COLOR_DISABLED = `var(--ds-icon-disabled, ${(0, $PdmhA).N400})`;
const $faf61a973e1f52be$var$ICON_COLOR_SUBTLE = `var(--ds-icon-subtle, ${(0, $PdmhA).N700})`;
const $faf61a973e1f52be$export$22f0b02dd941193d = "var(--ds-icon-danger, #EF5C48)";
const $faf61a973e1f52be$var$ICON_COLOR_SELECTED = `var(--ds-text-accent-blue, ${(0, $PdmhA).B400})`;
const $faf61a973e1f52be$var$getIconColor = ({ isDisabled: isDisabled, hasValidationError: hasValidationError, isSelected: isSelected, isSubtle: isSubtle })=>{
    if (hasValidationError) return $faf61a973e1f52be$export$22f0b02dd941193d;
    if (isSelected) return $faf61a973e1f52be$var$ICON_COLOR_SELECTED;
    if (isDisabled) return $faf61a973e1f52be$var$ICON_COLOR_DISABLED;
    if (isSubtle) return $faf61a973e1f52be$var$ICON_COLOR_SUBTLE;
    return $faf61a973e1f52be$var$ICON_COLOR;
};
const $faf61a973e1f52be$export$16b26cd5e98d9100 = ({ fieldType: fieldType, ...iconColorProps })=>{
    const props = {
        label: '',
        size: 'medium',
        primaryColor: $faf61a973e1f52be$var$getIconColor(iconColorProps)
    };
    switch(fieldType){
        case 0, $agB2z.TEXT_AREA_FIELDTYPE:
        case 0, $agB2z.DESCRIPTION_FIELDTYPE:
        case 0, $agB2z.ENVIRONMENT_FIELDTYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4nfxm))), {
                ...props,
                testId: "project-create-importer-upload-flow.common.utils.fields.overview-icon"
            });
        case 0, $agB2z.STATUS_FIELDTYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k4jc8))), {
                ...props,
                testId: "project-create-importer-upload-flow.common.utils.fields.arrow-right-circle-icon"
            });
        case 0, $agB2z.CATEGORY_FIELDTYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b8123))), {
                ...props,
                testId: "project-create-importer-upload-flow.common.utils.fields.menu-expand-icon"
            });
        case 0, $agB2z.EPIC_FIELDTYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aTFGL.default), {
                ...props,
                primaryColor: iconColorProps.isDisabled ? props.primaryColor : '#904EE2',
                "data-testId": "project-create-importer-upload-flow.common.utils.fields.epic-issue-type-icon"
            });
        case 0, $aYMEC.TASK:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gVdQC.default), {
                ...props,
                "data-testId": "project-create-importer-upload-flow.common.utils.fields.task-issue-type-icon"
            });
        case 0, $aYMEC.SUBTASK:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8IVyB.default), {
                ...props,
                "data-testId": "project-create-importer-upload-flow.common.utils.fields.subtask-issue-type-icon"
            });
        case 0, $agB2z.USERPICKER_FIELDTYPE:
        case 0, $agB2z.CREATOR_FIELDTYPE:
        case 0, $agB2z.REPORTER_FIELDTYPE:
        case 0, $agB2z.ASSIGNEE_FIELDTYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZhDV))), {
                ...props,
                testId: "project-create-importer-upload-flow.common.utils.fields.editor-mention-icon"
            });
        case 0, $agB2z.DATE_PICKER_FIELDTYPE:
        case 0, $agB2z.CREATED_FIELDTYPE:
        case 0, $agB2z.DUEDATE_FIELDTYPE:
        case 0, $agB2z.UPDATED_FIELDTYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kMHOY))), {
                ...props,
                testId: "project-create-importer-upload-flow.common.utils.fields.calendar-icon"
            });
        case 0, $agB2z.VOTES_FIELDTYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fvQWm))), {
                ...props,
                testId: "project-create-importer-upload-flow.common.utils.fields.like-icon"
            });
        case 0, $agB2z.MULTI_USERPICKER_FIELDTYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iwsIy))), {
                ...props,
                testId: "project-create-importer-upload-flow.common.utils.fields.people-group-icon"
            });
        case 0, $agB2z.WATCHERS_FIELDTYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jHMvH))), {
                ...props,
                testId: "project-create-importer-upload-flow.common.utils.fields.watch-icon"
            });
        case 0, $agB2z.NUMBER_FIELDTYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jhzap))), {
                ...props,
                testId: "project-create-importer-upload-flow.common.utils.fields.editor-number-list-icon"
            });
        case 0, $agB2z.DATE_TIME_FIELDTYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k6W9R))), {
                ...props,
                testId: "project-create-importer-upload-flow.common.utils.fields.recent-icon"
            });
        case 0, $agB2z.LABEL_FIELDTYPE:
        case 0, $agB2z.SYSTEM_LABELS_FIELDTYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2OpmI))), {
                ...props,
                testId: "project-create-importer-upload-flow.common.utils.fields.label-icon"
            });
        case 0, $agB2z.SELECT_FIELDTYPE:
        case 0, $agB2z.MULTI_SELECT_FIELDTYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lBXn2))), {
                ...props,
                testId: "project-create-importer-upload-flow.common.utils.fields.chevron-down-circle-icon"
            });
        case 0, $agB2z.CASCADING_SELECT_FIELDTYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fD5Ev))), {
                ...props,
                testId: "project-create-importer-upload-flow.common.utils.fields.bullet-list-icon"
            });
        case 0, $agB2z.CHECKBOX_FIELDTYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hSJ9G))), {
                ...props,
                testId: "project-create-importer-upload-flow.common.utils.fields.checkbox-icon"
            });
        case 0, $agB2z.PRIORITY_FIELDTYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ciWKE))), {
                ...props,
                testId: "project-create-importer-upload-flow.common.utils.fields.chevron-up-circle-icon"
            });
        case 0, $agB2z.RADIO_BUTTON_FIELDTYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c6Z6Z))), {
                ...props,
                testId: "project-create-importer-upload-flow.common.utils.fields.radio-icon"
            });
        case 0, $agB2z.COMMENT_FIELDTYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($d3vNK))), {
                ...props,
                testId: "project-create-importer-upload-flow.common.utils.fields.comment-icon"
            });
        case 0, $agB2z.URL_FIELDTYPE:
        case 0, $agB2z.ISSUE_LINKS_FIELDTYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hUwRB))), {
                ...props,
                testId: "project-create-importer-upload-flow.common.utils.fields.link-icon"
            });
        case 0, $agB2z.ISSUETYPE_FIELDTYPE:
        case 0, $agB2z.ISSUEID_FIELDTYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eoKor))), {
                ...props,
                testId: "project-create-importer-upload-flow.common.utils.fields.issue-icon"
            });
        case 0, $agB2z.TIME_REMAINING_ESTIMATE_FIELDTYPE:
        case 0, $agB2z.TIME_SPENT_FIELDTYPE:
        case 0, $agB2z.TIME_ORIGINAL_ESTIMATE_FIELDTYPE:
        case 0, $agB2z.WORKLOG_FIELDTYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cglEj))), {
                ...props,
                testId: "project-create-importer-upload-flow.common.utils.fields.stopwatch-icon"
            });
        case 0, $agB2z.PARENT_FIELDTYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jfQfF))), {
                ...props,
                testId: "project-create-importer-upload-flow.common.utils.fields.child-issues-icon"
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($75j3W))), {
                ...props,
                testId: "project-create-importer-upload-flow.common.utils.fields.editor-text-style-icon"
            });
    }
};
const $faf61a973e1f52be$export$6762f514d8e63c51 = (fieldType)=>{
    switch(fieldType){
        case 0, $agB2z.TEXT_FIELDTYPE:
            return (0, $hVFYn.default).textField;
        case 0, $agB2z.TEXT_AREA_FIELDTYPE:
            return (0, $hVFYn.default).paragraph;
        case 0, $agB2z.DATE_PICKER_FIELDTYPE:
            return (0, $hVFYn.default).datePicker;
        case 0, $agB2z.NUMBER_FIELDTYPE:
            return (0, $hVFYn.default).number;
        case 0, $agB2z.DATE_TIME_FIELDTYPE:
            return (0, $hVFYn.default).dateTime;
        case 0, $agB2z.LABEL_FIELDTYPE:
            return (0, $hVFYn.default).label;
        case 0, $agB2z.SELECT_FIELDTYPE:
            return (0, $hVFYn.default).select;
        case 0, $agB2z.CASCADING_SELECT_FIELDTYPE:
            return (0, $hVFYn.default).cascadingSelect;
        case 0, $agB2z.CHECKBOX_FIELDTYPE:
            return (0, $hVFYn.default).checkbox;
        case 0, $agB2z.USERPICKER_FIELDTYPE:
            return (0, $hVFYn.default).userPicker;
        case 0, $agB2z.MULTI_USERPICKER_FIELDTYPE:
            return (0, $hVFYn.default).multiUserPicker;
        case 0, $agB2z.MULTI_SELECT_FIELDTYPE:
            return (0, $hVFYn.default).multiSelect;
        case 0, $agB2z.RADIO_BUTTON_FIELDTYPE:
            return (0, $hVFYn.default).radio;
        case 0, $agB2z.URL_FIELDTYPE:
            return (0, $hVFYn.default).url;
        default:
            return (0, $hVFYn.default).textField;
    }
};
const $faf61a973e1f52be$export$56d8aa05182be1a3 = (fieldType)=>{
    switch(fieldType){
        case 0, $agB2z.TEXT_FIELDTYPE:
            return (0, $hVFYn.default).textFieldDescription;
        case 0, $agB2z.TEXT_AREA_FIELDTYPE:
            return (0, $hVFYn.default).paragraphDescription;
        case 0, $agB2z.DATE_TIME_FIELDTYPE:
            return (0, $hVFYn.default).dateTimeDescription;
        case 0, $agB2z.MULTI_USERPICKER_FIELDTYPE:
            return (0, $hVFYn.default).multiUserPickerDescription;
        case 0, $agB2z.NUMBER_FIELDTYPE:
            return (0, $hVFYn.default).numberDescription;
        case 0, $agB2z.SELECT_FIELDTYPE:
            return (0, $hVFYn.default).selectDescription;
        case 0, $agB2z.MULTI_SELECT_FIELDTYPE:
            return (0, $hVFYn.default).multiSelectDescription;
        default:
            return undefined;
    }
};

});
parcelRegister("k4jc8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e9c31206c0c7e54b$var$_react = $e9c31206c0c7e54b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $e9c31206c0c7e54b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $e9c31206c0c7e54b$var$ArrowRightCircleIcon = (props)=>/*#__PURE__*/ $e9c31206c0c7e54b$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" fill-rule="nonzero" cx="12" cy="12" r="10"/><path d="M12.314 8.294a1.01 1.01 0 000 1.422l1.271 1.279H8c-.553 0-1.001.45-1.001 1.005 0 .555.448 1.005 1.001 1.005h5.585l-1.271 1.279a1.01 1.01 0 000 1.422 1.001 1.001 0 001.415 0l2.978-2.995a1.01 1.01 0 000-1.422l-2.978-2.995a.998.998 0 00-1.415 0z" fill="inherit"/></g></svg>`
    }, props));
$e9c31206c0c7e54b$var$ArrowRightCircleIcon.displayName = 'ArrowRightCircleIcon';
var $e9c31206c0c7e54b$var$_default = $e9c31206c0c7e54b$var$ArrowRightCircleIcon;
module.exports.default = $e9c31206c0c7e54b$var$_default;

});

parcelRegister("fD5Ev", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b60ee1f4d4329714$var$_react = $b60ee1f4d4329714$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $b60ee1f4d4329714$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $b60ee1f4d4329714$var$BulletListIcon = (props)=>/*#__PURE__*/ $b60ee1f4d4329714$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><rect x="10" y="15" width="8" height="2" rx="1"/><rect x="6" y="15" width="2" height="2" rx="1"/><rect x="10" y="11" width="8" height="2" rx="1"/><rect x="6" y="11" width="2" height="2" rx="1"/><rect x="10" y="7" width="8" height="2" rx="1"/><rect x="6" y="7" width="2" height="2" rx="1"/></g></svg>`
    }, props));
$b60ee1f4d4329714$var$BulletListIcon.displayName = 'BulletListIcon';
var $b60ee1f4d4329714$var$_default = $b60ee1f4d4329714$var$BulletListIcon;
module.exports.default = $b60ee1f4d4329714$var$_default;

});

parcelRegister("kMHOY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f21a4850a620a60b$var$_react = $f21a4850a620a60b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $f21a4850a620a60b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $f21a4850a620a60b$var$CalendarIcon = (props)=>/*#__PURE__*/ $f21a4850a620a60b$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0119.005 21H4.995A1.995 1.995 0 013 19.006V6.994C3 5.893 3.892 5 4.995 5zM5 9v9a1 1 0 001 1h12a1 1 0 001-1V9H5zm1-5a1 1 0 012 0v1H6V4zm10 0a1 1 0 012 0v1h-2V4zm-9 9v-2.001h2V13H7zm8 0v-2.001h2V13h-2zm-4 0v-2.001h2.001V13H11zm-4 4v-2h2v2H7zm4 0v-2h2.001v2H11zm4 0v-2h2v2h-2z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$f21a4850a620a60b$var$CalendarIcon.displayName = 'CalendarIcon';
var $f21a4850a620a60b$var$_default = $f21a4850a620a60b$var$CalendarIcon;
module.exports.default = $f21a4850a620a60b$var$_default;

});

parcelRegister("hSJ9G", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d04a81b304c826a5$var$_react = $d04a81b304c826a5$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $d04a81b304c826a5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d04a81b304c826a5$var$CheckboxIcon = (props)=>/*#__PURE__*/ $d04a81b304c826a5$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect fill="currentColor" x="6" y="6" width="12" height="12" rx="2"/><path d="M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z" fill="inherit"/></g></svg>`
    }, props));
$d04a81b304c826a5$var$CheckboxIcon.displayName = 'CheckboxIcon';
var $d04a81b304c826a5$var$_default = $d04a81b304c826a5$var$CheckboxIcon;
module.exports.default = $d04a81b304c826a5$var$_default;

});

parcelRegister("lBXn2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fbbb1b7540180857$var$_react = $fbbb1b7540180857$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $fbbb1b7540180857$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $fbbb1b7540180857$var$ChevronDownCircleIcon = (props)=>/*#__PURE__*/ $fbbb1b7540180857$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="10"/><path d="M8.292 10.293a1.009 1.009 0 000 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 000-1.419.987.987 0 00-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 00-1.406 0z" fill="inherit"/></g></svg>`
    }, props));
$fbbb1b7540180857$var$ChevronDownCircleIcon.displayName = 'ChevronDownCircleIcon';
var $fbbb1b7540180857$var$_default = $fbbb1b7540180857$var$ChevronDownCircleIcon;
module.exports.default = $fbbb1b7540180857$var$_default;

});

parcelRegister("ciWKE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8f54bd4865697807$var$_react = $8f54bd4865697807$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $8f54bd4865697807$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $8f54bd4865697807$var$ChevronUpCircleIcon = (props)=>/*#__PURE__*/ $8f54bd4865697807$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="10"/><path d="M11.221 9.322l-2.929 2.955a1.009 1.009 0 000 1.419.986.986 0 001.405 0l2.298-2.317 2.307 2.327a.989.989 0 001.407 0 1.01 1.01 0 000-1.419l-2.94-2.965A1.106 1.106 0 0011.991 9c-.279 0-.557.107-.77.322z" fill="inherit"/></g></svg>`
    }, props));
$8f54bd4865697807$var$ChevronUpCircleIcon.displayName = 'ChevronUpCircleIcon';
var $8f54bd4865697807$var$_default = $8f54bd4865697807$var$ChevronUpCircleIcon;
module.exports.default = $8f54bd4865697807$var$_default;

});

parcelRegister("jfQfF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e047f322faad4563$var$_react = $e047f322faad4563$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $e047f322faad4563$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $e047f322faad4563$var$ChildIssuesIcon = (props)=>/*#__PURE__*/ $e047f322faad4563$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M11 7h2v5h-2zm5 6h2v3h-2zM6 13h2v3H6z"/><path d="M7 11h10a1 1 0 011 1v1H6v-1a1 1 0 011-1z"/><path d="M5 18v1h4v-1H5zm0-2h4a2 2 0 012 2v1a2 2 0 01-2 2H5a2 2 0 01-2-2v-1a2 2 0 012-2zm10 2v1h4v-1h-4zm0-2h4a2 2 0 012 2v1a2 2 0 01-2 2h-4a2 2 0 01-2-2v-1a2 2 0 012-2zM10 5v1h4V5h-4zm0-2h4a2 2 0 012 2v1a2 2 0 01-2 2h-4a2 2 0 01-2-2V5a2 2 0 012-2z" fill-rule="nonzero"/></g></svg>`
    }, props));
$e047f322faad4563$var$ChildIssuesIcon.displayName = 'ChildIssuesIcon';
var $e047f322faad4563$var$_default = $e047f322faad4563$var$ChildIssuesIcon;
module.exports.default = $e047f322faad4563$var$_default;

});

parcelRegister("dZhDV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a2eea8678fc0743c$var$_react = $a2eea8678fc0743c$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $a2eea8678fc0743c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a2eea8678fc0743c$var$EditorMentionIcon = (props)=>/*#__PURE__*/ $a2eea8678fc0743c$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12.062 13.93c-.904 0-1.451-.734-1.451-1.945 0-1.226.538-1.952 1.466-1.952.928 0 1.422.764 1.422 1.967 0 1.195-.502 1.93-1.438 1.93M12 5c-3.925 0-7 3.075-7 7 0 4.596 3.522 7 7 7 .874 0 1.614-.09 2.26-.279a.751.751 0 00-.42-1.44c-.508.147-1.11.22-1.84.22-2.648 0-5.5-1.722-5.5-5.5 0-3.085 2.417-5.5 5.5-5.5 3.24 0 5.5 1.952 5.5 4.75 0 2.045-1.043 3-1.748 3-.008 0-.752-.11-.752-.75v-4a.75.75 0 10-1.5 0v.187c-.346-.585-1.016-.952-1.795-.952C10.102 8.736 9 10.04 9 11.938c0 1.984 1.103 3.312 2.753 3.312.865 0 1.51-.387 1.865-1.076.334 1.016 1.37 1.576 2.132 1.576 1.598 0 3.25-1.683 3.25-4.5C19 7.628 16.058 5 12 5" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$a2eea8678fc0743c$var$EditorMentionIcon.displayName = 'EditorMentionIcon';
var $a2eea8678fc0743c$var$_default = $a2eea8678fc0743c$var$EditorMentionIcon;
module.exports.default = $a2eea8678fc0743c$var$_default;

});

parcelRegister("jhzap", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e09ae2492df37f92$var$_react = $e09ae2492df37f92$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $e09ae2492df37f92$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $e09ae2492df37f92$var$EditorNumberListIcon = (props)=>/*#__PURE__*/ $e09ae2492df37f92$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M11 7h6a1 1 0 010 2h-6a1 1 0 010-2zm0 4h6a1 1 0 010 2h-6a1 1 0 010-2zm0 4h6a1 1 0 010 2h-6a1 1 0 010-2zm-5 0h3v1H6v-1zm0 2h3v1H6v-1zm1-9H6V7h2v3H7V8zm-1 3h3v1.333h-.6V13H7.2v-.667H6V11zm0 2h3v1H6v-1zm2 3h2v1H8v-1z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$e09ae2492df37f92$var$EditorNumberListIcon.displayName = 'EditorNumberListIcon';
var $e09ae2492df37f92$var$_default = $e09ae2492df37f92$var$EditorNumberListIcon;
module.exports.default = $e09ae2492df37f92$var$_default;

});

parcelRegister("75j3W", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5287c9742bce3c50$var$_react = $5287c9742bce3c50$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $5287c9742bce3c50$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $5287c9742bce3c50$var$EditorTextStyleIcon = (props)=>/*#__PURE__*/ $5287c9742bce3c50$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M6.26 6.678l-3.237 9.534a.5.5 0 00.473.66h1.032a.75.75 0 00.717-.53l.648-2.107H9.63l.647 2.107a.75.75 0 00.717.53h1.113a.5.5 0 00.473-.66L9.337 6.677A1 1 0 008.39 6H7.207a1 1 0 00-.947.678zM7.736 8.08h.051l1.364 4.453H6.372L7.736 8.08zm11.113 2.043v-.327a1 1 0 011-1H20a1 1 0 011 1v6.078a1 1 0 01-1 1h-.151a1 1 0 01-1-1v-.312h-.088c-.392.874-1.232 1.439-2.418 1.439-1.975 0-3.221-1.613-3.221-4.182 0-2.546 1.254-4.15 3.221-4.15 1.172 0 2.026.595 2.418 1.454h.088zm-.045 2.712c0-1.47-.685-2.404-1.754-2.404-1.068 0-1.725.92-1.725 2.404 0 1.491.657 2.395 1.725 2.395 1.076 0 1.754-.911 1.754-2.395z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$5287c9742bce3c50$var$EditorTextStyleIcon.displayName = 'EditorTextStyleIcon';
var $5287c9742bce3c50$var$_default = $5287c9742bce3c50$var$EditorTextStyleIcon;
module.exports.default = $5287c9742bce3c50$var$_default;

});

parcelRegister("eoKor", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a7b74b48f7cf034b$var$_react = $a7b74b48f7cf034b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $a7b74b48f7cf034b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a7b74b48f7cf034b$var$IssueIcon = (props)=>/*#__PURE__*/ $a7b74b48f7cf034b$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M5 15.991c0 .007 14.005.009 14.005.009C18.999 16 19 8.009 19 8.009 19 8.002 4.995 8 4.995 8 5.001 8 5 15.991 5 15.991zM3 8.01C3 6.899 3.893 6 4.995 6h14.01C20.107 6 21 6.902 21 8.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 013 15.991V8.01z" fill-rule="nonzero"/><path d="M10.674 14.331c.36.36.941.36 1.3 0l2.758-2.763a.92.92 0 00-1.301-1.298l-2.108 2.11-.755-.754a.92.92 0 00-1.3 1.3l1.406 1.405z"/></g></svg>`
    }, props));
$a7b74b48f7cf034b$var$IssueIcon.displayName = 'IssueIcon';
var $a7b74b48f7cf034b$var$_default = $a7b74b48f7cf034b$var$IssueIcon;
module.exports.default = $a7b74b48f7cf034b$var$_default;

});

parcelRegister("2OpmI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $20c3ed57b318b9b4$var$_react = $20c3ed57b318b9b4$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $20c3ed57b318b9b4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $20c3ed57b318b9b4$var$LabelIcon = (props)=>/*#__PURE__*/ $20c3ed57b318b9b4$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M11.433 5.428l-4.207.6A2 2 0 005.53 7.727l-.6 4.207a1 1 0 00.281.849l6.895 6.894a.999.999 0 001.414 0l5.657-5.657a1 1 0 000-1.414L12.282 5.71a.998.998 0 00-.849-.283m-.647 5.858A1.666 1.666 0 118.43 8.929a1.666 1.666 0 012.357 2.357" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$20c3ed57b318b9b4$var$LabelIcon.displayName = 'LabelIcon';
var $20c3ed57b318b9b4$var$_default = $20c3ed57b318b9b4$var$LabelIcon;
module.exports.default = $20c3ed57b318b9b4$var$_default;

});

parcelRegister("fvQWm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b4b2d116ed1df772$var$_react = $b4b2d116ed1df772$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $b4b2d116ed1df772$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $b4b2d116ed1df772$var$LikeIcon = (props)=>/*#__PURE__*/ $b4b2d116ed1df772$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M4 12v7a.971.971 0 00.278.704.99.99 0 00.701.296H6v-9H4.98a.99.99 0 00-.701.296A.971.971 0 004 12zm15.281-.96a3.046 3.046 0 00-2.321-1.061h-2.634c.04-.181.08-.36.11-.532.515-2.934 0-4-.504-4.594A2.432 2.432 0 0012.075 4a3.078 3.078 0 00-2.968 2.751c-.393 1.839-.454 2-.968 2.725l-.768 1.089a2.011 2.011 0 00-.363 1.141v6.273c.001.532.216 1.041.596 1.416s.896.585 1.433.584h7.247a3.014 3.014 0 002.997-2.507l.677-4a2.963 2.963 0 00-.677-2.432zm-1.998 6.1a1.007 1.007 0 01-1 .835H9.038v-6.269l.767-1.089a7.577 7.577 0 001.302-3.509c.036-.543.255-1.209.969-1.108.714.1.575 1.916.363 3.1a19.712 19.712 0 01-.868 2.882l5.39-.008c.297-.001.58.128.773.352a.993.993 0 01.226.813l-.676 4.001z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$b4b2d116ed1df772$var$LikeIcon.displayName = 'LikeIcon';
var $b4b2d116ed1df772$var$_default = $b4b2d116ed1df772$var$LikeIcon;
module.exports.default = $b4b2d116ed1df772$var$_default;

});

parcelRegister("hUwRB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d0a128a0d80d703a$var$_react = $d0a128a0d80d703a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $d0a128a0d80d703a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d0a128a0d80d703a$var$LinkIcon = (props)=>/*#__PURE__*/ $d0a128a0d80d703a$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M12.856 5.457l-.937.92a1.002 1.002 0 000 1.437 1.047 1.047 0 001.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 01.203 3.81l-2.903 2.852a2.646 2.646 0 01-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 00-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="M11.144 19.543l.937-.92a1.002 1.002 0 000-1.437 1.047 1.047 0 00-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 01-.203-3.81l2.903-2.852a2.646 2.646 0 013.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 00.357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props));
$d0a128a0d80d703a$var$LinkIcon.displayName = 'LinkIcon';
var $d0a128a0d80d703a$var$_default = $d0a128a0d80d703a$var$LinkIcon;
module.exports.default = $d0a128a0d80d703a$var$_default;

});

parcelRegister("b8123", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $81a13e0001b9fa39$var$_react = $81a13e0001b9fa39$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $81a13e0001b9fa39$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $81a13e0001b9fa39$var$MenuExpandIcon = (props)=>/*#__PURE__*/ $81a13e0001b9fa39$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M6 12c0-.552.456-1 1.002-1h9.996a.999.999 0 110 2H7.002A.999.999 0 016 12zm0 4c0-.552.456-1 1.002-1h9.996a.999.999 0 110 2H7.002A.999.999 0 016 16zm0-8c0-.552.456-1 1.002-1h9.996a.999.999 0 110 2H7.002A.999.999 0 016 8z" fill="currentColor"/></svg>`
    }, props));
$81a13e0001b9fa39$var$MenuExpandIcon.displayName = 'MenuExpandIcon';
var $81a13e0001b9fa39$var$_default = $81a13e0001b9fa39$var$MenuExpandIcon;
module.exports.default = $81a13e0001b9fa39$var$_default;

});

parcelRegister("4nfxm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $32f55cbb5b32c083$var$_react = $32f55cbb5b32c083$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $32f55cbb5b32c083$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $32f55cbb5b32c083$var$OverviewIcon = (props)=>/*#__PURE__*/ $32f55cbb5b32c083$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M8.01 18c.546 0 .99-.444.99-1a1 1 0 00-.99-1H3.99A.993.993 0 003 17a1 1 0 00.99 1h4.02zM3 7c0 .552.445 1 .993 1h16.014A.994.994 0 0021 7c0-.552-.445-1-.993-1H3.993A.994.994 0 003 7zm10.998 6A.999.999 0 0015 12c0-.552-.456-1-1.002-1H4.002A.999.999 0 003 12c0 .552.456 1 1.002 1h9.996z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$32f55cbb5b32c083$var$OverviewIcon.displayName = 'OverviewIcon';
var $32f55cbb5b32c083$var$_default = $32f55cbb5b32c083$var$OverviewIcon;
module.exports.default = $32f55cbb5b32c083$var$_default;

});

parcelRegister("c6Z6Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02468a1d390d1515$var$_react = $02468a1d390d1515$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $02468a1d390d1515$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $02468a1d390d1515$var$RadioIcon = (props)=>/*#__PURE__*/ $02468a1d390d1515$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="6"/><circle fill="inherit" cx="12" cy="12" r="2"/></g></svg>`
    }, props));
$02468a1d390d1515$var$RadioIcon.displayName = 'RadioIcon';
var $02468a1d390d1515$var$_default = $02468a1d390d1515$var$RadioIcon;
module.exports.default = $02468a1d390d1515$var$_default;

});

parcelRegister("cglEj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8ed7c5ba5e4768aa$var$_react = $8ed7c5ba5e4768aa$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $8ed7c5ba5e4768aa$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $8ed7c5ba5e4768aa$var$StopwatchIcon = (props)=>/*#__PURE__*/ $8ed7c5ba5e4768aa$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M15.587 6.988l.626-.664c.203-.215.481-.324.76-.324.247 0 .496.086.694.262a.982.982 0 01.063 1.414l-.565.6a7 7 0 11-10.33 0l-.564-.6a.981.981 0 01.062-1.414A1.04 1.04 0 017.03 6c.278 0 .556.109.76.324l.624.664a6.955 6.955 0 012.582-.916L10.998 5H10.5a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h3a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-.498l.001 1.071a6.955 6.955 0 012.584.917zM12 18a5 5 0 100-10 5 5 0 000 10zm.368-4.232a.796.796 0 01-1.14-.018.834.834 0 01.018-1.163l2.386-2.355a.796.796 0 011.14.018.834.834 0 01-.018 1.163l-2.386 2.355z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$8ed7c5ba5e4768aa$var$StopwatchIcon.displayName = 'StopwatchIcon';
var $8ed7c5ba5e4768aa$var$_default = $8ed7c5ba5e4768aa$var$StopwatchIcon;
module.exports.default = $8ed7c5ba5e4768aa$var$_default;

});

parcelRegister("jHMvH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e587a998fd060edd$var$_react = $e587a998fd060edd$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $e587a998fd060edd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $e587a998fd060edd$var$WatchIcon = (props)=>/*#__PURE__*/ $e587a998fd060edd$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M12 18c-4.536 0-7.999-4.26-7.999-6 0-2.001 3.459-6 8-6 4.376 0 7.998 3.973 7.998 6 0 1.74-3.462 6-7.998 6m0-14C6.48 4 2 8.841 2 12c0 3.086 4.576 8 10 8 5.423 0 10-4.914 10-8 0-3.159-4.48-8-10-8"/><path d="M11.977 13.984c-1.103 0-2-.897-2-2s.897-2 2-2c1.104 0 2 .897 2 2s-.896 2-2 2m0-6c-2.206 0-4 1.794-4 4s1.794 4 4 4c2.207 0 4-1.794 4-4s-1.793-4-4-4"/></g></svg>`
    }, props));
$e587a998fd060edd$var$WatchIcon.displayName = 'WatchIcon';
var $e587a998fd060edd$var$_default = $e587a998fd060edd$var$WatchIcon;
module.exports.default = $e587a998fd060edd$var$_default;

});

parcelRegister("aTFGL", function(module, exports) {

$parcel$export(module.exports, "default", () => $f88165a0698160e4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $f88165a0698160e4$var$EpicIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "-3 -3 22 22",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid']
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        clipPath: "url(#clip0_2056_311)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M13.7143 0H2.28571C1.02335 0 0 1.02335 0 2.28571V13.7143C0 14.9767 1.02335 16 2.28571 16H13.7143C14.9767 16 16 14.9767 16 13.7143V2.28571C16 1.02335 14.9767 0 13.7143 0Z",
        fill: props.primaryColor || '#904EE2'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.3408 7.72169L11.3385 7.71712C11.3911 7.63141 11.4288 7.53655 11.4288 7.42798C11.4288 7.11255 11.1728 6.85655 10.8574 6.85655H8.00023V3.99941C8.00023 3.68398 7.74423 3.42798 7.4288 3.42798C7.23223 3.42798 7.0688 3.53312 6.96594 3.68284C6.93394 3.72969 6.90766 3.77769 6.89051 3.83141L4.66423 8.27026L4.66651 8.27369C4.61166 8.36169 4.57166 8.45998 4.57166 8.57084C4.57166 8.88741 4.82766 9.14226 5.14308 9.14226H8.00023V11.9994C8.00023 12.316 8.25623 12.5708 8.57166 12.5708C8.77623 12.5708 8.94766 12.4577 9.04937 12.2954L9.0528 12.2965L9.06766 12.2668C9.08023 12.2428 9.09394 12.2211 9.10308 12.196L11.3408 7.72169Z",
        fill: "var(--ds-icon-inverse, white)"
    })));
var $f88165a0698160e4$export$2e2bcd8739ae039 = $f88165a0698160e4$var$EpicIcon;

});

parcelRegister("8IVyB", function(module, exports) {

$parcel$export(module.exports, "default", () => $73250db1ac44fd1c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $PdmhA = parcelRequire("PdmhA");
const $73250db1ac44fd1c$var$SubtaskIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        clipPath: "url(#clip0_1839_54411)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9 7V4C9 3.73478 8.89464 3.48043 8.70711 3.29289C8.51957 3.10536 8.26522 3 8 3H4C3.73478 3 3.48043 3.10536 3.29289 3.29289C3.10536 3.48043 3 3.73478 3 4V8C3 8.26522 3.10536 8.51957 3.29289 8.70711C3.48043 8.89464 3.73478 9 4 9H7V12C7 12.2652 7.10536 12.5196 7.29289 12.7071C7.48043 12.8946 7.73478 13 8 13H12C12.2652 13 12.5196 12.8946 12.7071 12.7071C12.8946 12.5196 13 12.2652 13 12V8C13 7.73478 12.8946 7.48043 12.7071 7.29289C12.5196 7.10536 12.2652 7 12 7H9ZM0 1.994C0 0.893 0.895 0 1.994 0H14.006C15.107 0 16 0.895 16 1.994V14.006C15.9997 14.5348 15.7896 15.0418 15.4157 15.4157C15.0418 15.7896 14.5348 15.9997 14.006 16H1.994C1.46524 15.9997 0.958212 15.7896 0.584322 15.4157C0.210432 15.0418 0.000264976 14.5348 0 14.006L0 1.994ZM9 9H11V11H9V9ZM5 5H7V7H5V5Z",
        fill: `var(--ds-icon-subtle, ${(0, $PdmhA).N700})`,
        "fill-opacity": "0.31",
        "data-testid": props['data-testid']
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip0_1839_54411"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "16",
        height: "16",
        fill: "var(--ds-icon-inverse, white)"
    }))));
var $73250db1ac44fd1c$export$2e2bcd8739ae039 = $73250db1ac44fd1c$var$SubtaskIcon;

});

parcelRegister("gVdQC", function(module, exports) {

$parcel$export(module.exports, "default", () => $d45efe46914fd85e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $PdmhA = parcelRequire("PdmhA");
const $d45efe46914fd85e$var$TaskIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        clipPath: "url(#clip0_1839_54402)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M0 2.66667C0 1.19391 1.19391 0 2.66667 0H13.3333C14.8061 0 16 1.19391 16 2.66667V13.3333C16 14.8061 14.8061 16 13.3333 16H2.66667C1.19391 16 0 14.8061 0 13.3333V2.66667Z",
        fill: `var(--ds-icon-subtle, ${(0, $PdmhA).N700})`,
        "fill-opacity": "0.31",
        "data-testid": props['data-testid']
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.6905 4.61002C13.09 4.99136 13.1047 5.62435 12.7234 6.02385L7.87357 11.1046C7.34831 11.6549 6.46987 11.6548 5.94462 11.1046L3.27665 8.30957C2.89531 7.91007 2.91003 7.27707 3.30953 6.89573C3.70902 6.5144 4.34202 6.52912 4.72336 6.92861L6.90909 9.21843L11.2766 4.6429C11.658 4.2434 12.291 4.22868 12.6905 4.61002Z",
        fill: "var(--ds-icon-inverse, white)"
    })));
var $d45efe46914fd85e$export$2e2bcd8739ae039 = $d45efe46914fd85e$var$TaskIcon;

});

parcelRegister("hVFYn", function(module, exports) {

$parcel$export(module.exports, "default", () => $e73b8723aa55aba4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e73b8723aa55aba4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    textField: {
        "id": "project-create-importer-upload-flow.common.utils.fields.text-field",
        "defaultMessage": "Text field"
    },
    paragraph: {
        "id": "project-create-importer-upload-flow.common.utils.fields.paragraph",
        "defaultMessage": "Paragraph"
    },
    datePicker: {
        "id": "project-create-importer-upload-flow.common.utils.fields.date-picker",
        "defaultMessage": "Date"
    },
    number: {
        "id": "project-create-importer-upload-flow.common.utils.fields.number",
        "defaultMessage": "Number"
    },
    dateTime: {
        "id": "project-create-importer-upload-flow.common.utils.fields.date-time",
        "defaultMessage": "Time stamp"
    },
    label: {
        "id": "project-create-importer-upload-flow.common.utils.fields.label",
        "defaultMessage": "Labels"
    },
    select: {
        "id": "project-create-importer-upload-flow.common.utils.fields.select",
        "defaultMessage": "Dropdown"
    },
    cascadingSelect: {
        "id": "project-create-importer-upload-flow.common.utils.fields.cascading-select",
        "defaultMessage": "Select List (Cascading)"
    },
    checkbox: {
        "id": "project-create-importer-upload-flow.common.utils.fields.checkbox",
        "defaultMessage": "Checkbox"
    },
    userPicker: {
        "id": "project-create-importer-upload-flow.common.utils.fields.user-picker",
        "defaultMessage": "User Picker"
    },
    multiUserPicker: {
        "id": "project-create-importer-upload-flow.common.utils.fields.multi-user-picker",
        "defaultMessage": "Multi User Picker"
    },
    multiSelect: {
        "id": "project-create-importer-upload-flow.common.utils.fields.multi-select",
        "defaultMessage": "Multi Select"
    },
    radio: {
        "id": "project-create-importer-upload-flow.common.utils.fields.radio",
        "defaultMessage": "Radio"
    },
    url: {
        "id": "project-create-importer-upload-flow.common.utils.fields.url",
        "defaultMessage": "Url"
    },
    textFieldDescription: {
        "id": "project-create-importer-upload-flow.common.utils.fields.text-field-description",
        "defaultMessage": "Supports single line of plain text"
    },
    paragraphDescription: {
        "id": "project-create-importer-upload-flow.common.utils.fields.paragraph-description",
        "defaultMessage": "Supports long form rich text"
    },
    dateTimeDescription: {
        "id": "project-create-importer-upload-flow.common.utils.fields.date-time-description",
        "defaultMessage": "Stores date and time"
    },
    multiUserPickerDescription: {
        "id": "project-create-importer-upload-flow.common.utils.fields.multi-user-picker-description",
        "defaultMessage": "To select multiple users"
    },
    numberDescription: {
        "id": "project-create-importer-upload-flow.common.utils.fields.number-description",
        "defaultMessage": "Stores numerical values"
    },
    selectDescription: {
        "id": "project-create-importer-upload-flow.common.utils.fields.select-description",
        "defaultMessage": "To select single options in a list"
    },
    multiSelectDescription: {
        "id": "project-create-importer-upload-flow.common.utils.fields.multi-select-description",
        "defaultMessage": "To select multiple options in a list"
    }
});

});


parcelRegister("cpndv", function(module, exports) {

$parcel$export(module.exports, "ExistingFields", () => $eaa7a64f3d5c12fc$export$368004e775d6246c);

var $eUqFw = parcelRequire("eUqFw");

var $6Pq2D = parcelRequire("6Pq2D");

var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $dtaN9 = parcelRequire("dtaN9");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $4lTFP = parcelRequire("4lTFP");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1XXvr = parcelRequire("1XXvr");

var $eft4l = parcelRequire("eft4l");

var $hlez9 = parcelRequire("hlez9");

var $lUC5l = parcelRequire("lUC5l");

var $1yENh = parcelRequire("1yENh");
const $eaa7a64f3d5c12fc$var$isCustomField = (field)=>!field.fieldId?.startsWith('customfield');
const $eaa7a64f3d5c12fc$export$368004e775d6246c = ({ fieldMap: fieldMap, onCustomFieldMenuOpen: onCustomFieldMenuOpen })=>{
    const [mappingState, { setFieldForColumn: setFieldForColumn }] = (0, $lUC5l.useMappingState)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [searchTerm, setSearchTerm] = (0, $eUqFw.useState)('');
    const onItemClick = (0, $eUqFw.useCallback)((field)=>{
        setFieldForColumn(fieldMap.columnName, field);
    }, [
        fieldMap.columnName,
        setFieldForColumn
    ]);
    const getJiraFields = (0, $eUqFw.useCallback)((compare)=>mappingState?.availableJiraFields?.filter((field)=>field.fieldId !== fieldMap.field?.fieldId).filter(compare).map((field)=>{
            const isDisabled = !!field.fieldId && mappingState?.mappedJiraFieldIds.has(field.fieldId);
            return {
                name: field.fieldName,
                node: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1XXvr.FieldSelectorItem), {
                    key: `${field.fieldName}-${field.fieldType}`,
                    name: field.fieldName,
                    icon: (0, $hlez9.getIcon)({
                        fieldType: field.fieldType,
                        isSelected: false,
                        isDisabled: isDisabled
                    }),
                    onClick: ()=>onItemClick(field),
                    isDisabled: isDisabled,
                    tooltipContent: formatMessage((0, $1yENh.default).disabledTooltip),
                    tooltipPosition: "bottom-end"
                })
            };
        }), [
        fieldMap.field,
        formatMessage,
        mappingState?.availableJiraFields,
        mappingState?.mappedJiraFieldIds,
        onItemClick
    ]);
    const availableLinkFieldTypeItems = (0, $eUqFw.useMemo)(()=>mappingState?.availableIssueLinkFields?.filter((field)=>!(field.fieldId === fieldMap.field?.fieldId && field.fieldDirection === fieldMap.field?.fieldDirection)).map((field)=>{
            const isDisabled = !!field.fieldId && field.fieldId !== fieldMap.field?.fieldId && mappingState?.mappedJiraFieldIds.has(field.fieldId);
            return {
                name: field.fieldName,
                node: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1XXvr.FieldSelectorItem), {
                    key: `${field.fieldId}-${field.fieldName}`,
                    name: field.fieldName,
                    icon: (0, $hlez9.getIcon)({
                        fieldType: field.fieldType,
                        isSelected: false,
                        isDisabled: isDisabled
                    }),
                    onClick: ()=>onItemClick(field),
                    isDisabled: isDisabled,
                    tooltipContent: formatMessage((0, $1yENh.default).disabledTooltip)
                })
            };
        }) || [], [
        fieldMap.field?.fieldDirection,
        fieldMap.field?.fieldId,
        formatMessage,
        mappingState?.availableIssueLinkFields,
        mappingState?.mappedJiraFieldIds,
        onItemClick
    ]);
    const availableSystemFieldItems = (0, $eUqFw.useMemo)(()=>getJiraFields((field)=>$eaa7a64f3d5c12fc$var$isCustomField(field)) || [], [
        getJiraFields
    ]);
    const availableCustomFieldItems = (0, $eUqFw.useMemo)(()=>getJiraFields((field)=>!$eaa7a64f3d5c12fc$var$isCustomField(field)) || [], [
        getJiraFields
    ]);
    const getSearchFilteredFields = (0, $eUqFw.useCallback)((mappedFields)=>mappedFields?.filter((field)=>field.name.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase())).map((field)=>field.node) || [], [
        searchTerm
    ]);
    const selectedCustomFieldItem = (0, $eUqFw.useMemo)(()=>{
        if (fieldMap.field && fieldMap.field.fieldId === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1XXvr.FieldSelectorItem), {
            name: fieldMap.field.fieldName,
            icon: (0, $hlez9.getIcon)({
                fieldType: fieldMap.field.fieldType,
                isSelected: true
            }),
            isSelected: true
        });
        return null;
    }, [
        fieldMap.field
    ]);
    const selectedFieldItem = (0, $eUqFw.useMemo)(()=>{
        if (fieldMap.field && fieldMap.field.fieldId !== null && fieldMap.field.fieldName.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase())) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1XXvr.FieldSelectorItem), {
            name: fieldMap.field.fieldName,
            icon: (0, $hlez9.getIcon)({
                fieldType: fieldMap.field.fieldType,
                isSelected: true
            }),
            isSelected: true
        });
        return null;
    }, [
        fieldMap.field,
        searchTerm
    ]);
    const systemFields = (0, $eUqFw.useMemo)(()=>getSearchFilteredFields(availableSystemFieldItems), [
        availableSystemFieldItems,
        getSearchFilteredFields
    ]);
    const customFields = (0, $eUqFw.useMemo)(()=>getSearchFilteredFields(availableCustomFieldItems), [
        availableCustomFieldItems,
        getSearchFilteredFields
    ]);
    const issueLinks = (0, $eUqFw.useMemo)(()=>getSearchFilteredFields(availableLinkFieldTypeItems), [
        availableLinkFieldTypeItems,
        getSearchFilteredFields
    ]);
    const isEmptyView = systemFields.length === 0 && customFields.length === 0 && issueLinks.length === 0 && (!fieldMap.field || !fieldMap.field.fieldName.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase()));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Pq2D.default), {
        autoFocus: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: "project-create-importer-upload-flow.ui.mapping-screen.field-mapping.field-selector.existing-fields.box",
        xcss: $eaa7a64f3d5c12fc$var$dropdownWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $eaa7a64f3d5c12fc$var$searchWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eft4l.SearchBar), {
        placeholder: (0, $1yENh.default).searchAllFieldsPlaceholder,
        onSearchTermChange: (e)=>setSearchTerm(e.target.value)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $eaa7a64f3d5c12fc$var$scrollStyles
    }, selectedFieldItem, systemFields.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $eaa7a64f3d5c12fc$var$headingStyles
    }, formatMessage((0, $1yENh.default).mapToSystemField)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, systemFields)), customFields.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $eaa7a64f3d5c12fc$var$headingStyles
    }, formatMessage((0, $1yENh.default).mapToCustomField)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, customFields)), issueLinks.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $eaa7a64f3d5c12fc$var$headingStyles
    }, formatMessage((0, $1yENh.default).mapToIssueLink)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, issueLinks)), isEmptyView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        xcss: $eaa7a64f3d5c12fc$var$emptyViewStyles,
        alignInline: "center",
        alignBlock: "center",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, formatMessage((0, $1yENh.default).noOptionsFound)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        role: "menu",
        xcss: $eaa7a64f3d5c12fc$var$fixedStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))), {
            size: "medium",
            label: ""
        }),
        onClick: onCustomFieldMenuOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: $eaa7a64f3d5c12fc$var$newCustomFieldStyle
    }, formatMessage((0, $1yENh.default).createNewCustomField))), selectedCustomFieldItem, fieldMap.field && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $eaa7a64f3d5c12fc$var$dividerStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        onClick: ()=>onItemClick(null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: $eaa7a64f3d5c12fc$var$clearSelectionStyle
    }, formatMessage((0, $1yENh.default).clearSelection)))))));
};
const $eaa7a64f3d5c12fc$var$dropdownWrapperStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '47vh',
    width: '300px',
    paddingBlockEnd: 'space.100'
});
const $eaa7a64f3d5c12fc$var$dividerStyles = (0, $1ZAYh.xcss)({
    borderTopWidth: '2px',
    borderTopStyle: 'solid',
    borderTopColor: 'color.border',
    marginBlock: 'space.075'
});
const $eaa7a64f3d5c12fc$var$searchWrapperStyles = (0, $1ZAYh.xcss)({
    marginInline: 'space.200',
    marginBlock: 'space.200'
});
const $eaa7a64f3d5c12fc$var$scrollStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    flexGrow: '1'
});
const $eaa7a64f3d5c12fc$var$fixedStyles = (0, $1ZAYh.xcss)({
    flex: '0 1 auto',
    borderTopWidth: '2px',
    borderTopStyle: 'solid',
    borderTopColor: 'color.border',
    paddingBlockStart: 'space.075'
});
const $eaa7a64f3d5c12fc$var$headingStyles = (0, $1ZAYh.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    font: `var(--ds-font-body-small, ${(0, $4lTFP.fontFallback).body.small})`,
    fontWeight: "var(--ds-font-weight-bold, 700)",
    marginInline: 'space.200',
    marginBlockStart: 'space.100'
});
const $eaa7a64f3d5c12fc$var$emptyViewStyles = (0, $1ZAYh.xcss)({
    height: '100px',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $eaa7a64f3d5c12fc$var$newCustomFieldStyle = (0, $1ZAYh.xcss)({
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtle',
    fontWeight: '700'
});
const $eaa7a64f3d5c12fc$var$clearSelectionStyle = (0, $1ZAYh.xcss)({
    color: 'color.link'
});

});
parcelRegister("1XXvr", function(module, exports) {

$parcel$export(module.exports, "FieldSelectorItem", () => $c74013957fe51010$export$fdbf3a2e4456478a);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hD6GJ = parcelRequire("hD6GJ");

var $8cU5f = parcelRequire("8cU5f");
const $c74013957fe51010$export$fdbf3a2e4456478a = ({ name: name, description: description, icon: icon, isSelected: isSelected, isDisabled: isDisabled, tooltipContent: tooltipContent, tooltipPosition: tooltipPosition = 'right', onClick: onClick })=>{
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c74013957fe51010$var$DropdownItemHeading, null, name), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c74013957fe51010$var$DropdownItemDescription, {
        isSelected: isSelected
    }, description));
    if (isSelected) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c74013957fe51010$var$SelectedFieldWrapper, {
        "data-testId": "project-create-importer-upload-flow.common.ui.field-selector-item.selected-field-wrapper"
    }, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c74013957fe51010$var$SelectedContentWrapper, null, content));
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: tooltipContent,
        position: tooltipPosition,
        ignoreTooltipPointerEvents: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c74013957fe51010$var$StyledDropdownItem, {
        onClick: onClick,
        elemBefore: icon,
        isDisabled: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c74013957fe51010$var$ContentWrapper, null, content)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c74013957fe51010$var$StyledDropdownItem, {
        onClick: onClick,
        elemBefore: icon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c74013957fe51010$var$ContentWrapper, null, content));
};
// Needed to match dropdown item styling
const $c74013957fe51010$var$customPadding = `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"} ${"var(--ds-space-100, 8px)"} 14px`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $c74013957fe51010$var$StyledDropdownItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $hD6GJ.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_gv1fib4f _162l1qux",
            __cmplp.className
        ])
    });
});
const $c74013957fe51010$var$SelectedFieldWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o _80om73ad _1yt41qux _bfhk1hdx _syaz1ldt _1kl7ib4f",
            __cmplp.className
        ])
    });
});
const $c74013957fe51010$var$SelectedContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _18u0utpp",
            __cmplp.className
        ])
    });
});
const $c74013957fe51010$var$ContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c74013957fe51010$var$DropdownItemDescription = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c8qk37",
            __cmplp.isSelected ? "_syaz1ldt" : "_syaz1wmz",
            __cmplp.className
        ])
    });
});
const $c74013957fe51010$var$DropdownItemHeading = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81oud",
            __cmplp.className
        ])
    });
});

});

parcelRegister("1yENh", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c63544536067752$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4c63544536067752$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    mapToSystemField: {
        "id": "project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.existing-fields.map-to-system-field",
        "defaultMessage": "MAP TO A SYSTEM FIELD"
    },
    mapToCustomField: {
        "id": "project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.existing-fields.map-to-custom-field",
        "defaultMessage": "MAP TO AN EXISTING CUSTOM FIELD"
    },
    mapToIssueLink: {
        "id": "project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.existing-fields.map-to-issue-link",
        "defaultMessage": "MAP TO A LINK TYPE"
    },
    createNewCustomField: {
        "id": "project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.existing-fields.create-new-custom-field",
        "defaultMessage": "CREATE A NEW CUSTOM FIELD"
    },
    searchAllFieldsPlaceholder: {
        "id": "project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.existing-fields.search-all-fields-placeholder",
        "defaultMessage": "Search all fields"
    },
    clearSelection: {
        "id": "project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.existing-fields.clear-selection",
        "defaultMessage": "Clear selection"
    },
    disabledTooltip: {
        "id": "project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.existing-fields.disabled-tooltip",
        "defaultMessage": "This field is already mapped to another CSV field."
    },
    noOptionsFound: {
        "id": "project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.existing-fields.no-options-found",
        "defaultMessage": "No options found"
    }
});

});


parcelRegister("qhrvv", function(module, exports) {

$parcel$export(module.exports, "default", () => $83436a00470ae55f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $83436a00470ae55f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    fieldSelectorPlaceholder: {
        "id": "project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.field-selector-placeholder",
        "defaultMessage": "Select a field to map"
    },
    newField: {
        "id": "project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.new-field",
        "defaultMessage": "New field"
    },
    doNotImport: {
        "id": "project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.do-not-import",
        "defaultMessage": "Do not import"
    },
    dateFormatError: {
        "id": "project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.date-format-error",
        "defaultMessage": "Invalid date format"
    },
    dateTimeFormatError: {
        "id": "project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.date-time-format-error",
        "defaultMessage": "Invalid date time format"
    },
    numericalFormatError: {
        "id": "project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.numerical-format-error",
        "defaultMessage": "Invalid field format. The field only supports numerical characters."
    },
    issueIdFormatError: {
        "id": "project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.issue-id-format-error",
        "defaultMessage": "Invalid field format. The field only supports alphanumeric characters and hyphens."
    },
    cascadingFormatError: {
        "id": "project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.cascading-format-error",
        "defaultMessage": "Invalid field format. The field only supports the format parentValue -> childValue."
    },
    worklogFormatError: {
        "id": "project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.worklog-format-error",
        "defaultMessage": "Invalid work log format. <link>Read about the formats supported in this field.</link>"
    },
    emptySummaryError: {
        "id": "project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.empty-summary-error",
        "defaultMessage": "Missing summary content in CSV"
    },
    genericError: {
        "id": "project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.generic-error",
        "defaultMessage": "Invalid field format"
    }
});

});

parcelRegister("3tnMR", function(module, exports) {

$parcel$export(module.exports, "NewCustomFields", () => $bdc7064c3d0dbd64$export$bc89da51cce08f33);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $6Pq2D = parcelRequire("6Pq2D");

var $7u4fN = parcelRequire("7u4fN");

var $fEubG = parcelRequire("fEubG");

var $4GOUU = parcelRequire("4GOUU");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $4lTFP = parcelRequire("4lTFP");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1XXvr = parcelRequire("1XXvr");

var $hlez9 = parcelRequire("hlez9");

var $lUC5l = parcelRequire("lUC5l");

var $apbjZ = parcelRequire("apbjZ");
const $bdc7064c3d0dbd64$export$bc89da51cce08f33 = ({ fieldMap: fieldMap, onBack: onBack })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [mappingState, { setFieldForColumn: setFieldForColumn }] = (0, $lUC5l.useMappingState)();
    const onItemClick = (0, $eUqFw.useCallback)((fieldType)=>{
        setFieldForColumn(fieldMap.columnName, {
            fieldId: null,
            fieldName: fieldMap.columnName,
            fieldType: fieldType
        });
        onBack();
    }, [
        fieldMap.columnName,
        onBack,
        setFieldForColumn
    ]);
    const availableCustomFieldTypeItems = (0, $eUqFw.useMemo)(()=>mappingState?.availableNewFieldTypes?.map((type)=>{
            const isSelected = fieldMap.field?.fieldId === null && fieldMap.field?.fieldType === type;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1XXvr.FieldSelectorItem), {
                key: type,
                name: formatMessage((0, $hlez9.getDescriptorForNewFieldType)(type)),
                icon: (0, $hlez9.getIcon)({
                    fieldType: type,
                    isSelected: isSelected
                }),
                onClick: ()=>onItemClick(type),
                isDisabled: false,
                isSelected: isSelected
            });
        }), [
        fieldMap.field?.fieldId,
        fieldMap.field?.fieldType,
        formatMessage,
        mappingState?.availableNewFieldTypes,
        onItemClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Pq2D.default), {
        autoFocus: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $bdc7064c3d0dbd64$var$wrapperStyles,
        testId: "project-create-importer-upload-flow.ui.mapping-screen.field-mapping.field-selector.new-custom-fields.dropdown-item-group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $bdc7064c3d0dbd64$var$backStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bdc7064c3d0dbd64$var$RoundButton, {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4GOUU))), {
            label: formatMessage((0, $apbjZ.default).goBack),
            size: "large",
            primaryColor: `var(--ds-icon-subtle, ${(0, $PdmhA).N300})`
        }),
        "aria-label": formatMessage((0, $apbjZ.default).createNewCustomField),
        appearance: "subtle",
        spacing: "none",
        onClick: onBack
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $bdc7064c3d0dbd64$var$backHeadingStyles
    }, formatMessage((0, $apbjZ.default).createNewCustomField))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $bdc7064c3d0dbd64$var$headingStyles
    }, formatMessage((0, $apbjZ.default).selectCustomFieldType))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, availableCustomFieldTypeItems)));
};
const $bdc7064c3d0dbd64$var$wrapperStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '47vh',
    width: '300px',
    paddingBlockEnd: 'space.100'
});
const $bdc7064c3d0dbd64$var$headingStyles = (0, $1ZAYh.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    font: `var(--ds-font-body-small, ${(0, $4lTFP.fontFallback).body.small})`,
    fontWeight: "var(--ds-font-weight-bold, 700)",
    lineHeight: '16px',
    marginInline: 'space.200'
});
const $bdc7064c3d0dbd64$var$backStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center',
    paddingInline: 'space.100',
    paddingBlockStart: 'space.200',
    paddingBlockEnd: 'space.150'
});
const $bdc7064c3d0dbd64$var$backHeadingStyles = (0, $1ZAYh.xcss)({
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    color: 'color.text.subtle',
    alignItems: 'center',
    paddingInline: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $bdc7064c3d0dbd64$var$RoundButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1njd",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4GOUU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36a294b3fe9eadec$var$_react = $36a294b3fe9eadec$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $36a294b3fe9eadec$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $36a294b3fe9eadec$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $36a294b3fe9eadec$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M13.706 9.698a.988.988 0 000-1.407 1.01 1.01 0 00-1.419 0l-2.965 2.94a1.09 1.09 0 000 1.548l2.955 2.93a1.01 1.01 0 001.42 0 .988.988 0 000-1.407l-2.318-2.297 2.327-2.307z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$36a294b3fe9eadec$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $36a294b3fe9eadec$var$_default = $36a294b3fe9eadec$var$ChevronLeftIcon;
module.exports.default = $36a294b3fe9eadec$var$_default;

});

parcelRegister("apbjZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dbe0c92ac3279fc$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9dbe0c92ac3279fc$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createNewCustomField: {
        "id": "project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.new-custom-fields.create-new-custom-field",
        "defaultMessage": "CREATE A NEW CUSTOM FIELD"
    },
    selectCustomFieldType: {
        "id": "project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.new-custom-fields.select-custom-field-type",
        "defaultMessage": "SELECT A CUSTOM FIELD TYPE"
    },
    goBack: {
        "id": "project-create-importer-upload-flow.mapping-screen.field-mapping.field-selector.new-custom-fields.go-back",
        "defaultMessage": "Go back"
    }
});

});


parcelRegister("iMmmw", function(module, exports) {

$parcel$export(module.exports, "useValidationError", () => $8ac0f60806347a5f$export$5cd1b4d33b82a70e);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kzTj7 = parcelRequire("kzTj7");

var $dc4s1 = parcelRequire("dc4s1");

var $lUC5l = parcelRequire("lUC5l");

var $qhrvv = parcelRequire("qhrvv");
const $8ac0f60806347a5f$export$5cd1b4d33b82a70e = (columnName)=>{
    const [mappingState] = (0, $lUC5l.useMappingState)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const error = mappingState?.validationError?.columnErrors?.[columnName] || null;
    const errorMap = (0, $eUqFw.useMemo)(()=>({
            [(0, $dc4s1.INVALID_DATE)]: formatMessage((0, $qhrvv.default).dateFormatError),
            [(0, $dc4s1.INVALID_DATETIME)]: formatMessage((0, $qhrvv.default).dateTimeFormatError),
            [(0, $dc4s1.INVALID_NUMBER)]: formatMessage((0, $qhrvv.default).numericalFormatError),
            [(0, $dc4s1.INVALID_CASCADE_SELECT_FORMAT)]: formatMessage((0, $qhrvv.default).cascadingFormatError),
            [(0, $dc4s1.EMPTY_SUMMARY)]: formatMessage((0, $qhrvv.default).emptySummaryError),
            [(0, $dc4s1.INVALID_ISSUE_ID)]: formatMessage((0, $qhrvv.default).issueIdFormatError),
            [(0, $dc4s1.GENERIC_ERRORS)]: formatMessage((0, $qhrvv.default).genericError),
            [(0, $dc4s1.INVALID_USER_ID)]: formatMessage((0, $qhrvv.default).genericError),
            [(0, $dc4s1.INVALID_COMMENT_FORMAT)]: formatMessage((0, $qhrvv.default).genericError),
            [(0, $dc4s1.INVALID_WORKLOG_FORMAT)]: formatMessage((0, $qhrvv.default).worklogFormatError, {
                link: (content)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                        as: "a",
                        href: (0, $kzTj7.MAPPING_FIELDS_INFO_LINK),
                        target: "_blank"
                    }, content)
            })
        }), [
        formatMessage
    ]);
    return {
        hasValidationError: !!error,
        validationMessage: error && (errorMap[error] || formatMessage((0, $qhrvv.default).genericError))
    };
};

});


parcelRegister("dEDL0", function(module, exports) {

$parcel$export(module.exports, "IncludeInImport", () => $3a7d21dc5610ad8d$export$d049f9b645ec69);

var $eUqFw = parcelRequire("eUqFw");

var $bT7k5 = parcelRequire("bT7k5");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lUC5l = parcelRequire("lUC5l");

var $e8Hcf = parcelRequire("e8Hcf");
const $3a7d21dc5610ad8d$export$d049f9b645ec69 = ({ fieldMap: fieldMap })=>{
    const [, { setIsIncludedForColumn: setIsIncludedForColumn }] = (0, $lUC5l.useMappingState)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onChange = (0, $eUqFw.useCallback)((event)=>{
        setIsIncludedForColumn(fieldMap.columnName, event.target.checked);
    }, [
        fieldMap.columnName,
        setIsIncludedForColumn
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
        isChecked: fieldMap.isIncluded,
        onChange: onChange,
        size: "large",
        "aria-label": formatMessage((0, $e8Hcf.default).checkboxAriaLabelNonFinal, {
            fieldName: fieldMap.columnName
        })
    });
};

});
parcelRegister("bT7k5", function(module, exports) {

$parcel$export(module.exports, "default", () => $562b222d8d94ede5$export$2e2bcd8739ae039);
/**  @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $1lQG9 = parcelRequire("1lQG9");

var $PdmhA = parcelRequire("PdmhA");

var $eYWZs = parcelRequire("eYWZs");
var $kzlpH = parcelRequire("kzlpH");
var $kbQR9 = parcelRequire("kbQR9");
var $1BPvG = parcelRequire("1BPvG");
/* eslint-disable @atlaskit/design-system/no-nested-styles */ const $562b222d8d94ede5$var$checkboxStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: '100%',
    height: '100%',
    margin: "var(--ds-space-0, 0px)",
    appearance: 'none',
    border: 'none',
    gridArea: '1 / 1 / 2 / 2',
    opacity: 0,
    outline: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& + svg': {
        /**
     *  Change the variables --checkbox-background-color, --checkbox-border-color
     *  and --checkbox-tick-color according to user interactions.
     *  All other variables are constant.
     *  All styles from the input target the sibling svg.
     */ '--checkbox-background-color': 'var(--local-background)',
        '--checkbox-border-color': 'var(--local-border)',
        '--checkbox-tick-color': 'var(--local-tick-rest)',
        color: 'var(--checkbox-background-color)',
        fill: 'var(--checkbox-tick-color)',
        gridArea: '1 / 1 / 2 / 2',
        pointerEvents: 'none',
        transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        'rect:first-of-type': {
            stroke: 'var(--checkbox-border-color)',
            strokeWidth: "var(--ds-border-width, 1px)",
            transition: 'stroke 0.2s ease-in-out'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&:focus + svg, &&:checked:focus + svg': {
        borderRadius: "var(--ds-border-radius, 0.25rem)",
        outline: `${"var(--ds-border-width-outline, 2px)"} solid ${`var(--ds-border-focused, ${(0, $PdmhA.B200)})`}`,
        outlineOffset: "var(--ds-space-negative-025, -2px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-hover)',
        '--checkbox-border-color': 'var(--local-border-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-checked-hover)',
        '--checkbox-border-color': 'var(--local-border-checked-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-checked-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)',
        '--checkbox-tick-color': 'var(--local-tick-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        cursor: 'not-allowed',
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled:checked + svg': {
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked + svg, &:checked:hover + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:focus + svg rect:first-of-type': {
            stroke: 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'GrayText',
            '--checkbox-tick-color': 'GrayText'
        }
    }
});
/* eslint-enable @atlaskit/design-system/no-nested-styles */ /**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ const $562b222d8d94ede5$var$Checkbox = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Checkbox(props, ref) {
    const { isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, size: size = 'medium', onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, ...rest } = props;
    const [isCheckedState, setIsCheckedState] = (0, $eUqFw.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: undefined,
        packageVersion: undefined
    });
    const internalRef = (0, $eUqFw.useRef)(null);
    const mergedRefs = (0, $1lQG9.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $kzlpH.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // Currently the rule hasn't been updated to enable "allowed" dynamic pass-throughs.
        // When there is more usage of this pattern we'll update the lint rule.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: xcss
    }, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0,
        ...rest,
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        css: $562b222d8d94ede5$var$checkboxStyles,
        onChange: onChangeAnalytics,
        "aria-checked": isIndeterminate ? 'mixed' : isChecked,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && `${testId}--hidden-checkbox`,
        "data-invalid": isInvalid ? 'true' : undefined
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $eYWZs.default), {
        size: size,
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ (0, $byn9U.jsx)((0, $kbQR9.default), null, label, isRequired && /*#__PURE__*/ (0, $byn9U.jsx)((0, $1BPvG.default), null)));
}));
$562b222d8d94ede5$var$Checkbox.displayName = 'Checkbox';
var $562b222d8d94ede5$export$2e2bcd8739ae039 = $562b222d8d94ede5$var$Checkbox;

});
parcelRegister("eYWZs", function(module, exports) {

$parcel$export(module.exports, "default", () => $3da93fd40e0e88a3$export$2e2bcd8739ae039);
/**  @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ce8OV = parcelRequire("ce8OV");
function $3da93fd40e0e88a3$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ (0, $byn9U.jsx)("rect", {
        fill: "inherit",
        x: "8",
        y: "11",
        width: "8",
        height: "2",
        rx: "1"
    });
    if (isChecked) return /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "inherit"
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $3da93fd40e0e88a3$var$CheckboxIcon = /*#__PURE__*/ (0, $eUqFw.memo)(({ size: size, isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $eUqFw.useMemo)(()=>$3da93fd40e0e88a3$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $ce8OV.default), {
        label: "",
        size: size,
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2"
    }), icon));
});
var $3da93fd40e0e88a3$export$2e2bcd8739ae039 = $3da93fd40e0e88a3$var$CheckboxIcon;

});

parcelRegister("kzlpH", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4f9422953e9457b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
const $f4f9422953e9457b$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'grid',
    gridAutoColumns: '1fr',
    gridAutoRows: 'min-content',
    color: `var(--ds-text, ${(0, $PdmhA.N900)})`,
    cursor: 'default',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $f4f9422953e9457b$var$textLabelLayoutStyles = /*#__PURE__*/ (0, $byn9U.css)({
    gap: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
    gridTemplateColumns: 'min-content auto'
});
const $f4f9422953e9457b$var$disabledStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-disabled, ${(0, $PdmhA.N80)})`,
    cursor: 'not-allowed'
});
const $f4f9422953e9457b$var$labelStyles = /*#__PURE__*/ (0, $byn9U.css)({
    /**
   * Background
   */ '--local-background': `var(--ds-background-input, ${(0, $PdmhA.N10)})`,
    '--local-background-active': `var(--ds-background-input-pressed, ${(0, $PdmhA.B50)})`,
    '--local-background-checked': `var(--ds-background-selected-bold, ${(0, $PdmhA.B400)})`,
    '--local-background-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $PdmhA.B300)})`,
    '--local-background-disabled': `var(--ds-background-disabled, ${(0, $PdmhA.N20)})`,
    '--local-background-hover': `var(--ds-background-input-hovered, ${(0, $PdmhA.N30)})`,
    /**
   * Border
   */ '--local-border': `var(--ds-border-input, ${(0, $PdmhA.N100)})`,
    '--local-border-active': `var(--ds-border, ${(0, $PdmhA.B50)})`,
    '--local-border-checked': `var(--ds-background-selected-bold, ${(0, $PdmhA.B400)})`,
    '--local-border-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $PdmhA.B300)})`,
    '--local-border-checked-invalid': `var(--ds-border-danger, ${(0, $PdmhA.R300)})`,
    '--local-border-disabled': `var(--ds-background-disabled, ${(0, $PdmhA.N20)})`,
    '--local-border-focus': `var(--ds-border-focused, ${(0, $PdmhA.B200)})`,
    '--local-border-hover': `var(--ds-border-input, ${(0, $PdmhA.N100)})`,
    '--local-border-invalid': `var(--ds-border-danger, ${(0, $PdmhA.R300)})`,
    /**
   * Tick
   */ '--local-tick-active': `var(--ds-icon-inverse, ${(0, $PdmhA.B400)})`,
    '--local-tick-checked': `var(--ds-icon-inverse, ${(0, $PdmhA.N10)})`,
    '--local-tick-disabled': `var(--ds-icon-disabled, ${(0, $PdmhA.N70)})`,
    '--local-tick-rest': 'transparent'
});
function $f4f9422953e9457b$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("label", {
        // Because we're using Emotion local jsx namespace we have to coerce xcss prop to a string.
        // When we're fully on Compiled its local jsx namespace accepts the output of xcss prop.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: xcss,
        css: [
            $f4f9422953e9457b$var$baseStyles,
            label && $f4f9422953e9457b$var$textLabelLayoutStyles,
            isDisabled && $f4f9422953e9457b$var$disabledStyles,
            $f4f9422953e9457b$var$labelStyles
        ],
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}

});

parcelRegister("kbQR9", function(module, exports) {

$parcel$export(module.exports, "default", () => $582b6523b23912df$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
function $582b6523b23912df$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $582b6523b23912df$var$labelTextStyles = {
    name: "12hofyr",
    styles: "align-self:center;grid-area:1 / 2 / 2 / 3"
};
function $582b6523b23912df$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $582b6523b23912df$var$labelTextStyles
    }, children);
}

});

parcelRegister("1BPvG", function(module, exports) {

$parcel$export(module.exports, "default", () => $87ac167f9dd7ee34$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
const $87ac167f9dd7ee34$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-danger, ${(0, $PdmhA.R500)})`,
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $87ac167f9dd7ee34$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $87ac167f9dd7ee34$var$requiredIndicatorStyles,
        "aria-hidden": true
    }, "*");
}

});


parcelRegister("e8Hcf", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f58d84a2a561061$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7f58d84a2a561061$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    checkboxAriaLabelNonFinal: {
        "id": "project-create-importer-upload-flow.mapping-screen.field-mapping.include-in-import.checkbox-aria-label-non-final",
        "defaultMessage": "Include {fieldName} in import"
    }
});

});




parcelRegister("84Q9E", function(module, exports) {

$parcel$export(module.exports, "MappingAdvancedOptions", () => $03d710a88814d20b$export$db82c84189acdb82);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7jPhn = parcelRequire("7jPhn");
var $4LhB6 = parcelRequire("4LhB6");

var $5wCDk = parcelRequire("5wCDk");

var $cf2Y4 = parcelRequire("cf2Y4");

var $3x4sL = parcelRequire("3x4sL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kzTj7 = parcelRequire("kzTj7");

var $bGKgW = parcelRequire("bGKgW");

var $1WR91 = parcelRequire("1WR91");

var $bz2yd = parcelRequire("bz2yd");

var $bLalW = parcelRequire("bLalW");
var $d0wrd = parcelRequire("d0wrd");

var $2sRUp = parcelRequire("2sRUp");

var $8Olbu = parcelRequire("8Olbu");
const $03d710a88814d20b$export$db82c84189acdb82 = ()=>{
    const dateTimeRef = (0, $eUqFw.useRef)(null);
    const sendDateFormatUpdateEvent = (0, $eUqFw.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [advancedOptions, { updateAdvancedOptions: updateAdvancedOptions, removeDateValidationErrors: removeDateValidationErrors }] = (0, $bLalW.useAdvancedOptions)();
    const [hasDateTimeFormatError, setHasDateTimeFormatError] = (0, $eUqFw.useState)(false);
    const validateDateTimeFormat = (0, $eUqFw.useCallback)((value)=>{
        if (!value || value.trim().length === 0) return setHasDateTimeFormatError(true);
        return setHasDateTimeFormatError(false);
    }, []);
    const [{ type: type }] = (0, $d0wrd.useProjectData)();
    const [source] = (0, $2sRUp.useSource)();
    const { mappingAdvancedOptionsHeading: mappingAdvancedOptionsHeading, mappingAdvancedOptionsPopupHeading: mappingAdvancedOptionsPopupHeading, mappingAdvancedOptionsPopupDescription: mappingAdvancedOptionsPopupDescription } = (0, $bz2yd.useProjectSpecificContent)(type, source);
    const onDateFormatChange = (event)=>{
        validateDateTimeFormat(event.target.value);
        updateAdvancedOptions({
            dateFormat: event.target.value.trim()
        });
        removeDateValidationErrors();
        if (!sendDateFormatUpdateEvent.current) {
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'fieldMappingDateTimeFormat updated');
            sendDateFormatUpdateEvent.current = true;
        }
    };
    const onTimezoneChange = (0, $eUqFw.useCallback)((timeZoneOption)=>{
        if (!timeZoneOption) return;
        updateAdvancedOptions({
            timeZoneOption: timeZoneOption
        });
        removeDateValidationErrors();
    }, [
        removeDateValidationErrors,
        updateAdvancedOptions
    ]);
    const onLocaleChange = (0, $eUqFw.useCallback)((localeOption)=>{
        if (!localeOption) return;
        updateAdvancedOptions({
            localeOption: localeOption
        });
        removeDateValidationErrors();
    }, [
        removeDateValidationErrors,
        updateAdvancedOptions
    ]);
    const onAccordionClick = (0, $eUqFw.useCallback)(()=>{
        dateTimeRef.current?.focus();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1WR91.Accordion), {
        testId: "project-create-importer-upload-flow.ui.mapping-screen.mapping-advanced-options.accordion",
        ...hasDateTimeFormatError ? {
            onCloseClick: onAccordionClick
        } : {},
        heading: mappingAdvancedOptionsHeading,
        infoHeading: formatMessage(mappingAdvancedOptionsPopupHeading),
        infoDescription: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3x4sL.FormattedI18nMessage), {
            message: formatMessage(mappingAdvancedOptionsPopupDescription, {
                linkStart: '{linkStart}',
                linkEnd: '{linkEnd}'
            }),
            componentsMapping: {
                link: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($03d710a88814d20b$var$Link, {
                        href: (0, $kzTj7.SIMPLE_DATE_FORMAT_LINK),
                        target: "_blank"
                    }, children)
            }
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($03d710a88814d20b$var$ContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        label: formatMessage((0, $8Olbu.default).dateAndTimeFormat),
        name: "dateAndTimeFormat",
        isRequired: true
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
            ...fieldProps,
            ref: dateTimeRef,
            isRequired: true,
            onChange: onDateFormatChange,
            isInvalid: hasDateTimeFormatError,
            testId: "project-create-importer-upload-flow.ui.mapping-screen.mapping-advanced-options.date-time-format-text-field",
            defaultValue: advancedOptions.dateFormat
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.HelperMessage), null, formatMessage((0, $8Olbu.default).dateFormatHelperMessage)), hasDateTimeFormatError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), {
            testId: "project-create-importer-upload-flow.ui.mapping-screen.mapping-advanced-options.error-message"
        }, formatMessage((0, $8Olbu.default).dateFormatEmpty)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        label: formatMessage((0, $8Olbu.default).locale),
        name: "locale"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
            ...fieldProps,
            value: advancedOptions.localeOption,
            options: (0, $bGKgW.LOCALES),
            onChange: onLocaleChange,
            menuPlacement: "auto"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        label: formatMessage((0, $8Olbu.default).timezone),
        name: "timezone"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
            ...fieldProps,
            value: advancedOptions.timeZoneOption,
            options: (0, $bGKgW.TIMEZONES),
            onChange: onTimezoneChange,
            menuPlacement: "auto"
        }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $03d710a88814d20b$var$ContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _10c916et _bhl9uuw1 _1ik5uuw1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $03d710a88814d20b$var$Link = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz11ce",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7jPhn", function(module, exports) {

$parcel$export(module.exports, "HelperMessage", () => $8d7fd15aabd72279$export$8fbe3c7d0ed2c683);
$parcel$export(module.exports, "ErrorMessage", () => $8d7fd15aabd72279$export$915e9e7bd4f0f96d);
$parcel$export(module.exports, "ValidMessage", () => $8d7fd15aabd72279$export$5505afb209a532c8);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $lD2Nx = parcelRequire("lD2Nx");

var $96IgR = parcelRequire("96IgR");

var $PdmhA = parcelRequire("PdmhA");

var $gaA9C = parcelRequire("gaA9C");
function $8d7fd15aabd72279$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8d7fd15aabd72279$var$messageStyles = {
    name: "ywqxo4",
    styles: "display:flex;justify-content:baseline;gap:var(--ds-space-050, 4px);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-start:var(--ds-space-050, 4px)"
};
const $8d7fd15aabd72279$var$messageAppearanceStyles = {
    default: /*#__PURE__*/ (0, $byn9U.css)({
        color: `var(--ds-text-subtlest, ${(0, $PdmhA.N200)})`
    }),
    error: {
        name: "g75jq6",
        styles: "color:var(--ds-text-danger, #AE2A19)"
    },
    valid: {
        name: "118r6eb",
        styles: "color:var(--ds-text-success, #216E4E)"
    }
};
const $8d7fd15aabd72279$var$iconWrapperStyles = {
    name: "zjik7",
    styles: "display:flex"
};
const $8d7fd15aabd72279$var$IconWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $8d7fd15aabd72279$var$iconWrapperStyles
    }, children);
};
const $8d7fd15aabd72279$var$messageIcons = {
    error: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        size: "small",
        label: "error"
    }),
    valid: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lD2Nx))), {
        size: "small",
        label: "success"
    })
};
const $8d7fd15aabd72279$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
    const icon = $8d7fd15aabd72279$var$messageIcons[appearance];
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ const content = typeof children === 'string' ? children : /*#__PURE__*/ (0, $byn9U.jsx)("span", null, children);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $8d7fd15aabd72279$var$messageStyles,
            $8d7fd15aabd72279$var$messageAppearanceStyles[appearance]
        ],
        "data-testid": testId,
        id: fieldId,
        "aria-live": "polite"
    }, icon && /*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$IconWrapper, null, icon), content);
};
const $8d7fd15aabd72279$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$Message, {
            fieldId: fieldId ? `${fieldId}-helper` : undefined,
            testId: testId
        }, children));
const $8d7fd15aabd72279$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$Message, {
            appearance: "error",
            fieldId: fieldId ? `${fieldId}-error` : undefined,
            testId: testId
        }, children));
const $8d7fd15aabd72279$export$5505afb209a532c8 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $gaA9C.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $byn9U.jsx)($8d7fd15aabd72279$var$Message, {
            appearance: "valid",
            fieldId: fieldId ? `${fieldId}-valid` : undefined,
            testId: testId
        }, children));

});
parcelRegister("lD2Nx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fbef6921e18df378$var$_react = $fbef6921e18df378$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $fbef6921e18df378$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $fbef6921e18df378$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $fbef6921e18df378$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12 20a8 8 0 110-16 8 8 0 010 16zm1.364-10.964l-2.152 4.11-1.543-1.39a1 1 0 10-1.338 1.487l2.5 2.25a1 1 0 001.555-.279l2.75-5.25a1 1 0 00-1.772-.928z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$fbef6921e18df378$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
var $fbef6921e18df378$var$_default = $fbef6921e18df378$var$EditorSuccessIcon;
module.exports.default = $fbef6921e18df378$var$_default;

});


parcelRegister("5wCDk", function(module, exports) {

$parcel$export(module.exports, "SelectWithoutAnalytics", () => $eb73e877c5661200$export$d1de3b251ccaa8a3);
$parcel$export(module.exports, "default", () => $eb73e877c5661200$export$2e2bcd8739ae039);

var $hOLnS = parcelRequire("hOLnS");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $5FjBr = parcelRequire("5FjBr");
const $eb73e877c5661200$var$packageName = undefined;
const $eb73e877c5661200$var$packageVersion = undefined;
const $eb73e877c5661200$export$d1de3b251ccaa8a3 = (0, $5FjBr.default)((0, $hOLnS.default));
const $eb73e877c5661200$var$createAndFireEventOnAtlaskit = (0, $hM7RE.default)('atlaskit');
const $eb73e877c5661200$var$Select = (0, $1ngde.default)({
    componentName: 'select',
    packageName: $eb73e877c5661200$var$packageName,
    packageVersion: $eb73e877c5661200$var$packageVersion
})((0, $2jDha.default)({
    onChange: $eb73e877c5661200$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $eb73e877c5661200$var$packageName,
            packageVersion: $eb73e877c5661200$var$packageVersion
        }
    })
})($eb73e877c5661200$export$d1de3b251ccaa8a3));
var $eb73e877c5661200$export$2e2bcd8739ae039 = $eb73e877c5661200$var$Select;

});
parcelRegister("hOLnS", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf8bdca71ec4c4b4$export$2e2bcd8739ae039);

var $7IqRg = parcelRequire("7IqRg");

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $4WmDP = parcelRequire("4WmDP");

var $i4xqP = parcelRequire("i4xqP");

var $jQxSL = parcelRequire("jQxSL");
parcelRequire("1Xn5q");
parcelRequire("aKcqM");
parcelRequire("bwPfh");
parcelRequire("lDSrn");
parcelRequire("lIEGP");
parcelRequire("eT4IF");
parcelRequire("7Dzgl");
parcelRequire("fVK4C");

parcelRequire("5sKOb");
parcelRequire("jqNEH");
parcelRequire("5zQU9");
parcelRequire("lEfVV");

parcelRequire("k286k");
var $cf8bdca71ec4c4b4$var$StateManagedSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $7IqRg.u)(props);
    return /*#__PURE__*/ $eUqFw.createElement((0, $cEc3i.S), (0, $kU09D.default)({
        ref: ref
    }, baseSelectProps));
});
var $cf8bdca71ec4c4b4$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $eUqFw.useMemo)(function() {
        return (0, $i4xqP.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $eUqFw.createElement((0, $4WmDP.C), {
        value: emotionCache
    }, children);
};
var $cf8bdca71ec4c4b4$export$2e2bcd8739ae039 = $cf8bdca71ec4c4b4$var$StateManagedSelect;

});
parcelRegister("7IqRg", function(module, exports) {

$parcel$export(module.exports, "u", () => $59e179ee89746bd6$export$3b14a55fb2447963);

var $1Xn5q = parcelRequire("1Xn5q");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");
var $59e179ee89746bd6$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $59e179ee89746bd6$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $bwPfh.default)(_ref, $59e179ee89746bd6$var$_excluded);
    var _useState = (0, $eUqFw.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $aKcqM.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $aKcqM.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $eUqFw.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $aKcqM.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $eUqFw.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $eUqFw.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $eUqFw.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $eUqFw.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

});
parcelRegister("1Xn5q", function(module, exports) {

$parcel$export(module.exports, "default", () => $16cd35a30248fb20$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
function $16cd35a30248fb20$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $16cd35a30248fb20$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $16cd35a30248fb20$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $16cd35a30248fb20$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});

parcelRegister("aKcqM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d27d7cb7c770f64$export$2e2bcd8739ae039);

var $kcDiK = parcelRequire("kcDiK");

var $61Jn4 = parcelRequire("61Jn4");

var $e5SQy = parcelRequire("e5SQy");

var $gP5fl = parcelRequire("gP5fl");
function $7d27d7cb7c770f64$export$2e2bcd8739ae039(arr, i) {
    return (0, $kcDiK.default)(arr) || (0, $61Jn4.default)(arr, i) || (0, $e5SQy.default)(arr, i) || (0, $gP5fl.default)();
}

});
parcelRegister("kcDiK", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb536a1805ce1726$export$2e2bcd8739ae039);
function $eb536a1805ce1726$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("61Jn4", function(module, exports) {

$parcel$export(module.exports, "default", () => $463607d84fb47652$export$2e2bcd8739ae039);
function $463607d84fb47652$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("e5SQy", function(module, exports) {

$parcel$export(module.exports, "default", () => $a42c13bbb83e195c$export$2e2bcd8739ae039);

var $aLrjs = parcelRequire("aLrjs");
function $a42c13bbb83e195c$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $aLrjs.default)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $aLrjs.default)(o, minLen);
}

});
parcelRegister("aLrjs", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d637af256120630$export$2e2bcd8739ae039);
function $7d637af256120630$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("gP5fl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3f57a97be8f63bf$export$2e2bcd8739ae039);
function $c3f57a97be8f63bf$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});



parcelRegister("cEc3i", function(module, exports) {

$parcel$export(module.exports, "c", () => $935291c440101c41$export$db3b6bfb95261072);
$parcel$export(module.exports, "b", () => $935291c440101c41$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "g", () => $935291c440101c41$export$39b482c5e57630a8);
$parcel$export(module.exports, "m", () => $935291c440101c41$export$953cecd6e717a553);
$parcel$export(module.exports, "S", () => $935291c440101c41$export$25ce5a424b770e84);

var $kU09D = parcelRequire("kU09D");

var $1Xn5q = parcelRequire("1Xn5q");

var $lDSrn = parcelRequire("lDSrn");

var $lIEGP = parcelRequire("lIEGP");

var $eT4IF = parcelRequire("eT4IF");

var $7Dzgl = parcelRequire("7Dzgl");

var $fVK4C = parcelRequire("fVK4C");

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $byn9U = parcelRequire("byn9U");

var $5iWql = parcelRequire("5iWql");

var $bwPfh = parcelRequire("bwPfh");
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $935291c440101c41$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $935291c440101c41$var$A11yText = function A11yText(props) {
    return (0, $byn9U.jsx)("span", (0, $kU09D.default)({
        css: $935291c440101c41$var$_ref
    }, props));
};
var $935291c440101c41$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, isDisabled = props.isDisabled, tabSelectsValue = props.tabSelectsValue, context = props.context;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options".concat(isDisabled ? '' : ', press Enter to select the currently focused option', ", press Escape to exit the menu").concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '');
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu') {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? 'selected' : 'focused').concat(disabled);
            return "option ".concat(label, " ").concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var $935291c440101c41$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $eUqFw.useMemo)(function() {
        return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $935291c440101c41$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $eUqFw.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $1Xn5q.default)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $eUqFw.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue
    ]);
    var ariaResults = (0, $eUqFw.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus
    ]);
    var ariaGuidance = (0, $eUqFw.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue
    ]);
    var ariaContext = "".concat(ariaFocused, " ").concat(ariaResults, " ").concat(ariaGuidance);
    var ScreenReaderText = (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $byn9U.jsx)("span", {
        id: "aria-context"
    }, ariaContext));
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)($935291c440101c41$var$A11yText, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $byn9U.jsx)($935291c440101c41$var$A11yText, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $935291c440101c41$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $935291c440101c41$var$anyDiacritic = new RegExp('[' + $935291c440101c41$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $935291c440101c41$var$diacriticToBase = {};
for(var $935291c440101c41$var$i = 0; $935291c440101c41$var$i < $935291c440101c41$var$diacritics.length; $935291c440101c41$var$i++){
    var $935291c440101c41$var$diacritic = $935291c440101c41$var$diacritics[$935291c440101c41$var$i];
    for(var $935291c440101c41$var$j = 0; $935291c440101c41$var$j < $935291c440101c41$var$diacritic.letters.length; $935291c440101c41$var$j++)$935291c440101c41$var$diacriticToBase[$935291c440101c41$var$diacritic.letters[$935291c440101c41$var$j]] = $935291c440101c41$var$diacritic.base;
}
var $935291c440101c41$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($935291c440101c41$var$anyDiacritic, function(match) {
        return $935291c440101c41$var$diacriticToBase[match];
    });
};
var $935291c440101c41$var$memoizedStripDiacriticsForInput = (0, $5iWql.default)($935291c440101c41$var$stripDiacritics);
var $935291c440101c41$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $935291c440101c41$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $935291c440101c41$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $1Xn5q.default)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $935291c440101c41$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $935291c440101c41$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $935291c440101c41$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $935291c440101c41$var$memoizedStripDiacriticsForInput(input);
            candidate = $935291c440101c41$var$stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $935291c440101c41$var$_excluded = [
    "innerRef"
];
function $935291c440101c41$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $bwPfh.default)(_ref, $935291c440101c41$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $jQxSL.r)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, $byn9U.jsx)("input", (0, $kU09D.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $byn9U.css)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var $935291c440101c41$var$cancelScroll = function cancelScroll(event) {
    event.preventDefault();
    event.stopPropagation();
};
function $935291c440101c41$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $eUqFw.useRef)(false);
    var isTop = (0, $eUqFw.useRef)(false);
    var touchStart = (0, $eUqFw.useRef)(0);
    var scrollTarget = (0, $eUqFw.useRef)(null);
    var handleEventDelta = (0, $eUqFw.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $935291c440101c41$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $eUqFw.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $eUqFw.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $eUqFw.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $eUqFw.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $jQxSL.s) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $eUqFw.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $935291c440101c41$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $935291c440101c41$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $935291c440101c41$var$preventTouchMove(e) {
    e.preventDefault();
}
function $935291c440101c41$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $935291c440101c41$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $935291c440101c41$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $935291c440101c41$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $935291c440101c41$var$activeScrollLocks = 0;
var $935291c440101c41$var$listenerOptions = {
    capture: false,
    passive: false
};
function $935291c440101c41$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $eUqFw.useRef)({});
    var scrollTarget = (0, $eUqFw.useRef)(null);
    var addScrollLock = (0, $eUqFw.useCallback)(function(touchScrollTarget) {
        if (!$935291c440101c41$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $935291c440101c41$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $935291c440101c41$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($935291c440101c41$var$LOCK_STYLES).forEach(function(key) {
                var val = $935291c440101c41$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $935291c440101c41$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', $935291c440101c41$var$preventTouchMove, $935291c440101c41$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', $935291c440101c41$var$preventInertiaScroll, $935291c440101c41$var$listenerOptions);
                touchScrollTarget.addEventListener('touchmove', $935291c440101c41$var$allowTouchMove, $935291c440101c41$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $935291c440101c41$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $eUqFw.useCallback)(function(touchScrollTarget) {
        if (!$935291c440101c41$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $935291c440101c41$var$activeScrollLocks = Math.max($935291c440101c41$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $935291c440101c41$var$activeScrollLocks < 1) $935291c440101c41$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $935291c440101c41$var$isTouchDevice()) {
            target.removeEventListener('touchmove', $935291c440101c41$var$preventTouchMove, $935291c440101c41$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', $935291c440101c41$var$preventInertiaScroll, $935291c440101c41$var$listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', $935291c440101c41$var$allowTouchMove, $935291c440101c41$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $935291c440101c41$var$blurSelectInput = function blurSelectInput() {
    return document.activeElement && document.activeElement.blur();
};
var $935291c440101c41$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $935291c440101c41$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $935291c440101c41$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $935291c440101c41$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, lockEnabled && (0, $byn9U.jsx)("div", {
        onClick: $935291c440101c41$var$blurSelectInput,
        css: $935291c440101c41$var$_ref2$1
    }), children(targetRef));
}
function $935291c440101c41$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $935291c440101c41$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $935291c440101c41$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $byn9U.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $935291c440101c41$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $935291c440101c41$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $935291c440101c41$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $935291c440101c41$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $935291c440101c41$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $935291c440101c41$var$defaultStyles = {
    clearIndicator: (0, $jQxSL.a),
    container: (0, $jQxSL.b),
    control: (0, $jQxSL.d),
    dropdownIndicator: (0, $jQxSL.e),
    group: (0, $jQxSL.g),
    groupHeading: (0, $jQxSL.f),
    indicatorsContainer: (0, $jQxSL.i),
    indicatorSeparator: (0, $jQxSL.h),
    input: (0, $jQxSL.j),
    loadingIndicator: (0, $jQxSL.l),
    loadingMessage: (0, $jQxSL.k),
    menu: (0, $jQxSL.m),
    menuList: (0, $jQxSL.n),
    menuPortal: (0, $jQxSL.o),
    multiValue: (0, $jQxSL.p),
    multiValueLabel: (0, $jQxSL.q),
    multiValueRemove: (0, $jQxSL.t),
    noOptionsMessage: (0, $jQxSL.u),
    option: (0, $jQxSL.v),
    placeholder: (0, $jQxSL.w),
    singleValue: (0, $jQxSL.x),
    valueContainer: (0, $jQxSL.y)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $935291c440101c41$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $1Xn5q.default)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $935291c440101c41$var$colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var $935291c440101c41$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $935291c440101c41$var$baseUnit = 4;
// The minimum height of the control
var $935291c440101c41$var$controlHeight = 38;
// The amount of space between the control and menu */
var $935291c440101c41$var$menuGutter = $935291c440101c41$var$baseUnit * 2;
var $935291c440101c41$var$spacing = {
    baseUnit: $935291c440101c41$var$baseUnit,
    controlHeight: $935291c440101c41$var$controlHeight,
    menuGutter: $935291c440101c41$var$menuGutter
};
var $935291c440101c41$export$4368d992c4eafac0 = {
    borderRadius: $935291c440101c41$var$borderRadius,
    colors: $935291c440101c41$var$colors,
    spacing: $935291c440101c41$var$spacing
};
var $935291c440101c41$export$407448d2b89b1813 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $jQxSL.z)(),
    captureMenuScroll: !(0, $jQxSL.z)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $935291c440101c41$export$db3b6bfb95261072(),
    formatGroupLabel: $935291c440101c41$var$formatGroupLabel,
    getOptionLabel: $935291c440101c41$export$8b22cf2602fb60ce,
    getOptionValue: $935291c440101c41$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $935291c440101c41$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $jQxSL.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $935291c440101c41$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $935291c440101c41$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $935291c440101c41$var$_isOptionSelected(props, option, selectValue);
    var label = $935291c440101c41$var$getOptionLabel(props, option);
    var value = $935291c440101c41$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $935291c440101c41$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $935291c440101c41$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $935291c440101c41$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $935291c440101c41$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $935291c440101c41$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $jQxSL.G));
}
function $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $fVK4C.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $935291c440101c41$var$buildFocusableOptions(props, selectValue) {
    return $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions($935291c440101c41$var$buildCategorizedOptions(props, selectValue));
}
function $935291c440101c41$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$935291c440101c41$var$shouldHideSelectedOptions(props) || !isSelected) && $935291c440101c41$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $935291c440101c41$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $935291c440101c41$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $935291c440101c41$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $935291c440101c41$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $935291c440101c41$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $935291c440101c41$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $935291c440101c41$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $935291c440101c41$var$getOptionValue(props, i) === candidate;
    });
}
function $935291c440101c41$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $935291c440101c41$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $935291c440101c41$var$instanceId = 1;
var $935291c440101c41$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $eT4IF.default)(Select, _Component);
    var _super = (0, $7Dzgl.default)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $lDSrn.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.instancePrefix = '';
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $jQxSL.B)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $jQxSL.B)([].concat((0, $fVK4C.default)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $jQxSL.C)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $jQxSL.C)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $jQxSL.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $jQxSL.D)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $jQxSL.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $jQxSL.E).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $935291c440101c41$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $935291c440101c41$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $935291c440101c41$var$defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $jQxSL.F)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $935291c440101c41$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $935291c440101c41$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $1Xn5q.default)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
            event.stopPropagation();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            event.stopPropagation();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $jQxSL.H)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            _this.setState({
                focusedOption: focusedOption
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $935291c440101c41$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$935291c440101c41$var$instanceId);
        _this.state.selectValue = (0, $jQxSL.I)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusedOption = focusableOptions[optionIndex];
        }
        return _this;
    }
    (0, $lIEGP.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $jQxSL.J)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $jQxSL.J)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex]
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $935291c440101c41$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme($935291c440101c41$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $935291c440101c41$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $935291c440101c41$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $935291c440101c41$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $935291c440101c41$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $1Xn5q.default)((0, $1Xn5q.default)((0, $1Xn5q.default)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox'
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox'),
                    'aria-owns': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$DummyInput, (0, $kU09D.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $jQxSL.K),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $eUqFw.createElement(Input, (0, $kU09D.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $eUqFw.createElement(Placeholder, (0, $kU09D.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $eUqFw.createElement(MultiValue, (0, $kU09D.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $eUqFw.createElement(SingleValue, (0, $kU09D.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(ClearIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(LoadingIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $eUqFw.createElement(IndicatorSeparator, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(DropdownIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1
                    };
                    return /*#__PURE__*/ $eUqFw.createElement(Option, (0, $kU09D.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $eUqFw.createElement(Group, (0, $kU09D.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $eUqFw.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $eUqFw.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $eUqFw.createElement((0, $jQxSL.M), (0, $kU09D.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $eUqFw.createElement(Menu, (0, $kU09D.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove,
                            id: _this4.getElementId('listbox')
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $eUqFw.createElement(MenuList, (0, $kU09D.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ $eUqFw.createElement(MenuPortal, (0, $kU09D.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$RequiredInput, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $eUqFw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $eUqFw.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $eUqFw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $eUqFw.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ $eUqFw.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $eUqFw.createElement($935291c440101c41$var$LiveRegion, (0, $kU09D.default)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $eUqFw.createElement(SelectContainer, (0, $kU09D.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $eUqFw.createElement(Control, (0, $kU09D.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $eUqFw.createElement(ValueContainer, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $eUqFw.createElement(IndicatorsContainer, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $jQxSL.I)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $935291c440101c41$var$buildFocusableOptions(props, selectValue) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $935291c440101c41$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $935291c440101c41$var$getNextFocusedOption(state, focusableOptions);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $jQxSL.D)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, $1Xn5q.default)((0, $1Xn5q.default)((0, $1Xn5q.default)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $eUqFw.Component));
$935291c440101c41$export$25ce5a424b770e84.defaultProps = $935291c440101c41$export$407448d2b89b1813;

});
parcelRegister("lDSrn", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc177843783b087f$export$2e2bcd8739ae039);
function $fc177843783b087f$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("lIEGP", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcfd452a83bb612a$export$2e2bcd8739ae039);

var $aM0Ke = parcelRequire("aM0Ke");
function $fcfd452a83bb612a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $aM0Ke.default)(descriptor.key), descriptor);
    }
}
function $fcfd452a83bb612a$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $fcfd452a83bb612a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fcfd452a83bb612a$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}

});

parcelRegister("eT4IF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad69dceb97fc37d0$export$2e2bcd8739ae039);

var $c2pQl = parcelRequire("c2pQl");
function $ad69dceb97fc37d0$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $c2pQl.default)(subClass, superClass);
}

});

parcelRegister("7Dzgl", function(module, exports) {

$parcel$export(module.exports, "default", () => $58f7875a71af82f1$export$2e2bcd8739ae039);

var $i3rTN = parcelRequire("i3rTN");

var $8c5pC = parcelRequire("8c5pC");

var $4mIeV = parcelRequire("4mIeV");
function $58f7875a71af82f1$export$2e2bcd8739ae039(Derived) {
    var hasNativeReflectConstruct = (0, $8c5pC.default)();
    return function _createSuperInternal() {
        var Super = (0, $i3rTN.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $i3rTN.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $4mIeV.default)(this, result);
    };
}

});
parcelRegister("i3rTN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d24e25f7bdedc6a7$export$2e2bcd8739ae039);
function $d24e25f7bdedc6a7$export$2e2bcd8739ae039(o) {
    $d24e25f7bdedc6a7$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d24e25f7bdedc6a7$export$2e2bcd8739ae039(o);
}

});

parcelRegister("8c5pC", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f73a47aa7a9581c$export$2e2bcd8739ae039);
function $5f73a47aa7a9581c$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5f73a47aa7a9581c$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("4mIeV", function(module, exports) {

$parcel$export(module.exports, "default", () => $32db889076b63d40$export$2e2bcd8739ae039);

var $5sKOb = parcelRequire("5sKOb");

var $aCdHv = parcelRequire("aCdHv");
function $32db889076b63d40$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $5sKOb.default)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $aCdHv.default)(self);
}

});


parcelRegister("fVK4C", function(module, exports) {

$parcel$export(module.exports, "default", () => $b98feb1d5dd86921$export$2e2bcd8739ae039);

var $b7OIr = parcelRequire("b7OIr");

var $2B3l3 = parcelRequire("2B3l3");

var $e5SQy = parcelRequire("e5SQy");

var $csAMF = parcelRequire("csAMF");
function $b98feb1d5dd86921$export$2e2bcd8739ae039(arr) {
    return (0, $b7OIr.default)(arr) || (0, $2B3l3.default)(arr) || (0, $e5SQy.default)(arr) || (0, $csAMF.default)();
}

});
parcelRegister("b7OIr", function(module, exports) {

$parcel$export(module.exports, "default", () => $8197b040df4187a0$export$2e2bcd8739ae039);

var $aLrjs = parcelRequire("aLrjs");
function $8197b040df4187a0$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $aLrjs.default)(arr);
}

});

parcelRegister("2B3l3", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e41a0710a3b4a62$export$2e2bcd8739ae039);
function $1e41a0710a3b4a62$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRegister("csAMF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9124a21752235a23$export$2e2bcd8739ae039);
function $9124a21752235a23$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("jQxSL", function(module, exports) {

$parcel$export(module.exports, "K", () => $e72d27f6b1599862$export$3466f893ebf79586);
$parcel$export(module.exports, "E", () => $e72d27f6b1599862$export$a9c23c6ac3fc3eca);
$parcel$export(module.exports, "I", () => $e72d27f6b1599862$export$9bb611d729802a56);
$parcel$export(module.exports, "L", () => $e72d27f6b1599862$export$61196ced6d74a310);
$parcel$export(module.exports, "H", () => $e72d27f6b1599862$export$7f8ddf7c7c20b3cd);
$parcel$export(module.exports, "J", () => $e72d27f6b1599862$export$b4171a6734a65d42);
$parcel$export(module.exports, "z", () => $e72d27f6b1599862$export$df995fae86a55f06);
$parcel$export(module.exports, "A", () => $e72d27f6b1599862$export$ebd11618f299a286);
$parcel$export(module.exports, "s", () => $e72d27f6b1599862$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "G", () => $e72d27f6b1599862$export$2329c99376c9d0a4);
$parcel$export(module.exports, "D", () => $e72d27f6b1599862$export$96f57966bedc81b4);
$parcel$export(module.exports, "C", () => $e72d27f6b1599862$export$e7094788287c5e9b);
$parcel$export(module.exports, "B", () => $e72d27f6b1599862$export$ef35774e6d314e91);
$parcel$export(module.exports, "r", () => $e72d27f6b1599862$export$43caf9889c228507);
$parcel$export(module.exports, "m", () => $e72d27f6b1599862$export$953cecd6e717a553);
$parcel$export(module.exports, "M", () => $e72d27f6b1599862$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "n", () => $e72d27f6b1599862$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "u", () => $e72d27f6b1599862$export$3b14a55fb2447963);
$parcel$export(module.exports, "k", () => $e72d27f6b1599862$export$342063e11d6c3cad);
$parcel$export(module.exports, "o", () => $e72d27f6b1599862$export$ae1af26003f05816);
$parcel$export(module.exports, "b", () => $e72d27f6b1599862$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "y", () => $e72d27f6b1599862$export$4a5767248b18ef41);
$parcel$export(module.exports, "i", () => $e72d27f6b1599862$export$23f2a1d2818174ef);
$parcel$export(module.exports, "e", () => $e72d27f6b1599862$export$f1e1789686576879);
$parcel$export(module.exports, "a", () => $e72d27f6b1599862$export$407448d2b89b1813);
$parcel$export(module.exports, "h", () => $e72d27f6b1599862$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "l", () => $e72d27f6b1599862$export$882b5998b3b9117c);
$parcel$export(module.exports, "d", () => $e72d27f6b1599862$export$4368d992c4eafac0);
$parcel$export(module.exports, "g", () => $e72d27f6b1599862$export$39b482c5e57630a8);
$parcel$export(module.exports, "f", () => $e72d27f6b1599862$export$2d1720544b23b823);
$parcel$export(module.exports, "j", () => $e72d27f6b1599862$export$35e795649ee09318);
$parcel$export(module.exports, "p", () => $e72d27f6b1599862$export$ffb5f4729a158638);
$parcel$export(module.exports, "q", () => $e72d27f6b1599862$export$9e5f44173e64f162);
$parcel$export(module.exports, "t", () => $e72d27f6b1599862$export$625550452a3fa3ec);
$parcel$export(module.exports, "v", () => $e72d27f6b1599862$export$90a7f3efeed30595);
$parcel$export(module.exports, "w", () => $e72d27f6b1599862$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "x", () => $e72d27f6b1599862$export$d141bba7fdc215a3);
$parcel$export(module.exports, "c", () => $e72d27f6b1599862$export$db3b6bfb95261072);
$parcel$export(module.exports, "F", () => $e72d27f6b1599862$export$d66501df72047452);

var $1Xn5q = parcelRequire("1Xn5q");

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $5sKOb = parcelRequire("5sKOb");

var $jqNEH = parcelRequire("jqNEH");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $5O3G9 = parcelRequire("5O3G9");

var $k286k = parcelRequire("k286k");
var $e72d27f6b1599862$var$_excluded$3 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $e72d27f6b1599862$export$3466f893ebf79586 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $e72d27f6b1599862$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $e72d27f6b1599862$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($e72d27f6b1599862$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var $e72d27f6b1599862$export$9bb611d729802a56 = function cleanValue(value) {
    if ($e72d27f6b1599862$var$isArray(value)) return value.filter(Boolean);
    if ((0, $5sKOb.default)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $e72d27f6b1599862$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $bwPfh.default)(props, $e72d27f6b1599862$var$_excluded$3);
    return (0, $1Xn5q.default)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $e72d27f6b1599862$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $e72d27f6b1599862$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $e72d27f6b1599862$var$normalizedHeight(el) {
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $e72d27f6b1599862$var$getScrollTop(el) {
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $e72d27f6b1599862$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($e72d27f6b1599862$export$7f8ddf7c7c20b3cd(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $e72d27f6b1599862$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $e72d27f6b1599862$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $e72d27f6b1599862$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $e72d27f6b1599862$export$3466f893ebf79586;
    var start = $e72d27f6b1599862$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $e72d27f6b1599862$var$easeOutCubic(currentTime, start, change, duration);
        $e72d27f6b1599862$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $e72d27f6b1599862$export$b4171a6734a65d42(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $e72d27f6b1599862$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $e72d27f6b1599862$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $e72d27f6b1599862$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $e72d27f6b1599862$export$df995fae86a55f06() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $e72d27f6b1599862$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $e72d27f6b1599862$var$passiveOptionAccessed = false;
var $e72d27f6b1599862$var$options = {
    get passive () {
        return $e72d27f6b1599862$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $e72d27f6b1599862$var$w = typeof window !== 'undefined' ? window : {};
if ($e72d27f6b1599862$var$w.addEventListener && $e72d27f6b1599862$var$w.removeEventListener) {
    $e72d27f6b1599862$var$w.addEventListener('p', $e72d27f6b1599862$export$3466f893ebf79586, $e72d27f6b1599862$var$options);
    $e72d27f6b1599862$var$w.removeEventListener('p', $e72d27f6b1599862$export$3466f893ebf79586, false);
}
var $e72d27f6b1599862$export$2408f22a0fab9ae5 = $e72d27f6b1599862$var$passiveOptionAccessed;
function $e72d27f6b1599862$export$2329c99376c9d0a4(item) {
    return item != null;
}
function $e72d27f6b1599862$var$isArray(arg) {
    return Array.isArray(arg);
}
function $e72d27f6b1599862$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $e72d27f6b1599862$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $e72d27f6b1599862$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $e72d27f6b1599862$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $aKcqM.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $aKcqM.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
function $e72d27f6b1599862$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $e72d27f6b1599862$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $e72d27f6b1599862$var$normalizedHeight(scrollParent);
    var scrollTop = $e72d27f6b1599862$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $e72d27f6b1599862$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $e72d27f6b1599862$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $e72d27f6b1599862$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var $e72d27f6b1599862$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $e72d27f6b1599862$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $1Xn5q.default)((_objectSpread2 = {
        label: 'menu'
    }, (0, $5zQU9.default)(_objectSpread2, $e72d27f6b1599862$var$alignToControl(placement), '100%'), (0, $5zQU9.default)(_objectSpread2, "position", 'absolute'), (0, $5zQU9.default)(_objectSpread2, "width", '100%'), (0, $5zQU9.default)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $e72d27f6b1599862$var$PortalPlacementContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
// NOTE: internal only
var $e72d27f6b1599862$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $eUqFw.useContext)($e72d27f6b1599862$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $eUqFw.useRef)(null);
    var _useState = (0, $eUqFw.useState)(maxMenuHeight), _useState2 = (0, $aKcqM.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(null), _useState4 = (0, $aKcqM.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $k286k.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $e72d27f6b1599862$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, props), {}, {
            placement: placement || $e72d27f6b1599862$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $e72d27f6b1599862$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu List
// ==============================
var $e72d27f6b1599862$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $1Xn5q.default)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $e72d27f6b1599862$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $e72d27f6b1599862$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $1Xn5q.default)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $e72d27f6b1599862$export$3b14a55fb2447963 = $e72d27f6b1599862$var$noticeCSS;
var $e72d27f6b1599862$export$342063e11d6c3cad = $e72d27f6b1599862$var$noticeCSS;
var $e72d27f6b1599862$var$NoOptionsMessage = function NoOptionsMessage(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
$e72d27f6b1599862$var$NoOptionsMessage.defaultProps = {
    children: 'No options'
};
var $e72d27f6b1599862$var$LoadingMessage = function LoadingMessage(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
$e72d27f6b1599862$var$LoadingMessage.defaultProps = {
    children: 'Loading...'
};
// ==============================
// Menu Portal
// ==============================
var $e72d27f6b1599862$export$ae1af26003f05816 = function menuPortalCSS(_ref6) {
    var rect = _ref6.rect, offset = _ref6.offset, position = _ref6.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $e72d27f6b1599862$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $eUqFw.useRef)(null);
    var cleanupRef = (0, $eUqFw.useRef)(null);
    var _useState5 = (0, $eUqFw.useState)($e72d27f6b1599862$var$coercePlacement(menuPlacement)), _useState6 = (0, $aKcqM.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $eUqFw.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $eUqFw.useState)(null), _useState8 = (0, $aKcqM.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $eUqFw.useCallback)(function() {
        if (!controlElement) return;
        var rect = $e72d27f6b1599862$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $k286k.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $eUqFw.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $5O3G9.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $k286k.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $eUqFw.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        ref: setMenuPortalElement
    }, $e72d27f6b1599862$var$getStyleProps((0, $1Xn5q.default)((0, $1Xn5q.default)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $lEfVV.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $e72d27f6b1599862$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var $e72d27f6b1599862$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $e72d27f6b1599862$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $1Xn5q.default)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $e72d27f6b1599862$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $e72d27f6b1599862$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var $e72d27f6b1599862$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var $e72d27f6b1599862$var$_templateObject;
var $e72d27f6b1599862$var$_excluded$2 = [
    "size"
];
function $e72d27f6b1599862$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $e72d27f6b1599862$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $e72d27f6b1599862$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $bwPfh.default)(_ref, $e72d27f6b1599862$var$_excluded$2);
    return (0, $byn9U.jsx)("svg", (0, $kU09D.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $e72d27f6b1599862$var$_ref2
    }, props));
};
var $e72d27f6b1599862$var$CrossIcon = function CrossIcon(props) {
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$Svg, (0, $kU09D.default)({
        size: 20
    }, props), (0, $byn9U.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $e72d27f6b1599862$var$DownChevron = function DownChevron(props) {
    return (0, $byn9U.jsx)($e72d27f6b1599862$var$Svg, (0, $kU09D.default)({
        size: 20
    }, props), (0, $byn9U.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $e72d27f6b1599862$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $e72d27f6b1599862$export$f1e1789686576879 = $e72d27f6b1599862$var$baseCSS;
var $e72d27f6b1599862$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$DownChevron, null));
};
var $e72d27f6b1599862$export$407448d2b89b1813 = $e72d27f6b1599862$var$baseCSS;
var $e72d27f6b1599862$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $e72d27f6b1599862$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $e72d27f6b1599862$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $byn9U.jsx)("span", (0, $kU09D.default)({}, innerProps, $e72d27f6b1599862$var$getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var $e72d27f6b1599862$var$loadingDotAnimations = (0, $byn9U.keyframes)($e72d27f6b1599862$var$_templateObject || ($e72d27f6b1599862$var$_templateObject = (0, $jqNEH.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $e72d27f6b1599862$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $1Xn5q.default)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $e72d27f6b1599862$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $byn9U.jsx)("span", {
        css: /*#__PURE__*/ (0, $byn9U.css)({
            animation: "".concat($e72d27f6b1599862$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var $e72d27f6b1599862$var$LoadingIndicator = function LoadingIndicator(props) {
    var innerProps = props.innerProps, isRtl = props.isRtl;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $byn9U.jsx)($e72d27f6b1599862$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
$e72d27f6b1599862$var$LoadingIndicator.defaultProps = {
    size: 4
};
var $e72d27f6b1599862$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $1Xn5q.default)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $e72d27f6b1599862$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        ref: innerRef
    }, $e72d27f6b1599862$var$getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps), children);
};
var $e72d27f6b1599862$var$_excluded$1 = [
    "data"
];
var $e72d27f6b1599862$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $e72d27f6b1599862$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, $byn9U.jsx)(Heading, (0, $kU09D.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $byn9U.jsx)("div", null, children));
};
var $e72d27f6b1599862$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $1Xn5q.default)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var $e72d27f6b1599862$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $e72d27f6b1599862$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $bwPfh.default)(_cleanCommonProps, $e72d27f6b1599862$var$_excluded$1);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var $e72d27f6b1599862$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $e72d27f6b1599862$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, $e72d27f6b1599862$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $e72d27f6b1599862$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $e72d27f6b1599862$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, $1Xn5q.default)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, $e72d27f6b1599862$var$spacingStyle)
};
var $e72d27f6b1599862$var$inputStyle = function inputStyle(isHidden) {
    return (0, $1Xn5q.default)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, $e72d27f6b1599862$var$spacingStyle);
};
var $e72d27f6b1599862$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $e72d27f6b1599862$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $bwPfh.default)(_cleanCommonProps, $e72d27f6b1599862$var$_excluded);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, $byn9U.jsx)("input", (0, $kU09D.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $e72d27f6b1599862$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $e72d27f6b1599862$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $1Xn5q.default)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var $e72d27f6b1599862$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $1Xn5q.default)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $e72d27f6b1599862$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $byn9U.jsx)("div", innerProps, children);
};
var $e72d27f6b1599862$var$MultiValueContainer = $e72d27f6b1599862$var$MultiValueGeneric;
var $e72d27f6b1599862$var$MultiValueLabel = $e72d27f6b1599862$var$MultiValueGeneric;
function $e72d27f6b1599862$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        role: "button"
    }, innerProps), children || (0, $byn9U.jsx)($e72d27f6b1599862$var$CrossIcon, {
        size: 14
    }));
}
var $e72d27f6b1599862$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $byn9U.jsx)(Container, {
        data: data,
        innerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $byn9U.jsx)(Label, {
        data: data,
        innerProps: (0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, $byn9U.jsx)(Remove, {
        data: data,
        innerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var $e72d27f6b1599862$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $e72d27f6b1599862$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $e72d27f6b1599862$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var $e72d27f6b1599862$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $e72d27f6b1599862$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $e72d27f6b1599862$var$getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var $e72d27f6b1599862$export$db3b6bfb95261072 = {
    ClearIndicator: $e72d27f6b1599862$var$ClearIndicator,
    Control: $e72d27f6b1599862$var$Control,
    DropdownIndicator: $e72d27f6b1599862$var$DropdownIndicator,
    DownChevron: $e72d27f6b1599862$var$DownChevron,
    CrossIcon: $e72d27f6b1599862$var$CrossIcon,
    Group: $e72d27f6b1599862$var$Group,
    GroupHeading: $e72d27f6b1599862$var$GroupHeading,
    IndicatorsContainer: $e72d27f6b1599862$var$IndicatorsContainer,
    IndicatorSeparator: $e72d27f6b1599862$var$IndicatorSeparator,
    Input: $e72d27f6b1599862$var$Input,
    LoadingIndicator: $e72d27f6b1599862$var$LoadingIndicator,
    Menu: $e72d27f6b1599862$var$Menu,
    MenuList: $e72d27f6b1599862$var$MenuList,
    MenuPortal: $e72d27f6b1599862$var$MenuPortal,
    LoadingMessage: $e72d27f6b1599862$var$LoadingMessage,
    NoOptionsMessage: $e72d27f6b1599862$var$NoOptionsMessage,
    MultiValue: $e72d27f6b1599862$var$MultiValue,
    MultiValueContainer: $e72d27f6b1599862$var$MultiValueContainer,
    MultiValueLabel: $e72d27f6b1599862$var$MultiValueLabel,
    MultiValueRemove: $e72d27f6b1599862$var$MultiValueRemove,
    Option: $e72d27f6b1599862$var$Option,
    Placeholder: $e72d27f6b1599862$var$Placeholder,
    SelectContainer: $e72d27f6b1599862$var$SelectContainer,
    SingleValue: $e72d27f6b1599862$var$SingleValue,
    ValueContainer: $e72d27f6b1599862$var$ValueContainer
};
var $e72d27f6b1599862$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $e72d27f6b1599862$export$db3b6bfb95261072), props.components);
};

});
parcelRegister("jqNEH", function(module, exports) {

$parcel$export(module.exports, "default", () => $e256f68f3295e6bf$export$2e2bcd8739ae039);
function $e256f68f3295e6bf$export$2e2bcd8739ae039(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

});

parcelRegister("5O3G9", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $023d07731ce8610f$export$deee3a793edee05f);

var $7MIdi = parcelRequire("7MIdi");
function $023d07731ce8610f$var$n(t) {
    var e;
    return (null == (e = t.ownerDocument) ? void 0 : e.defaultView) || window;
}
function $023d07731ce8610f$var$o(t) {
    return $023d07731ce8610f$var$n(t).getComputedStyle(t);
}
function $023d07731ce8610f$var$i(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Node;
}
function $023d07731ce8610f$var$r(t) {
    return $023d07731ce8610f$var$i(t) ? (t.nodeName || "").toLowerCase() : "";
}
let $023d07731ce8610f$var$l;
function $023d07731ce8610f$var$c() {
    if ($023d07731ce8610f$var$l) return $023d07731ce8610f$var$l;
    const t = navigator.userAgentData;
    return t && Array.isArray(t.brands) ? ($023d07731ce8610f$var$l = t.brands.map((t)=>t.brand + "/" + t.version).join(" "), $023d07731ce8610f$var$l) : navigator.userAgent;
}
function $023d07731ce8610f$var$s(t) {
    return t instanceof $023d07731ce8610f$var$n(t).HTMLElement;
}
function $023d07731ce8610f$var$f(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Element;
}
function $023d07731ce8610f$var$u(t) {
    if ("undefined" == typeof ShadowRoot) return !1;
    return t instanceof $023d07731ce8610f$var$n(t).ShadowRoot || t instanceof ShadowRoot;
}
function $023d07731ce8610f$var$a(t) {
    const { overflow: e, overflowX: n, overflowY: i, display: r } = $023d07731ce8610f$var$o(t);
    return /auto|scroll|overlay|hidden|clip/.test(e + i + n) && ![
        "inline",
        "contents"
    ].includes(r);
}
function $023d07731ce8610f$var$d(t) {
    return [
        "table",
        "td",
        "th"
    ].includes($023d07731ce8610f$var$r(t));
}
function $023d07731ce8610f$var$h(t) {
    const e = /firefox/i.test($023d07731ce8610f$var$c()), n = $023d07731ce8610f$var$o(t), i = n.backdropFilter || n.WebkitBackdropFilter;
    return "none" !== n.transform || "none" !== n.perspective || !!i && "none" !== i || e && "filter" === n.willChange || e && !!n.filter && "none" !== n.filter || [
        "transform",
        "perspective"
    ].some((t)=>n.willChange.includes(t)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((t)=>{
        const e = n.contain;
        return null != e && e.includes(t);
    });
}
function $023d07731ce8610f$var$p() {
    return /^((?!chrome|android).)*safari/i.test($023d07731ce8610f$var$c());
}
function $023d07731ce8610f$var$g(t) {
    return [
        "html",
        "body",
        "#document"
    ].includes($023d07731ce8610f$var$r(t));
}
const $023d07731ce8610f$var$m = Math.min, $023d07731ce8610f$var$y = Math.max, $023d07731ce8610f$var$x = Math.round;
function $023d07731ce8610f$var$w(t) {
    const e = $023d07731ce8610f$var$o(t);
    let n = parseFloat(e.width), i = parseFloat(e.height);
    const r = $023d07731ce8610f$var$s(t), l = r ? t.offsetWidth : n, c = r ? t.offsetHeight : i, f = $023d07731ce8610f$var$x(n) !== l || $023d07731ce8610f$var$x(i) !== c;
    return f && (n = l, i = c), {
        width: n,
        height: i,
        fallback: f
    };
}
function $023d07731ce8610f$var$v(t) {
    return $023d07731ce8610f$var$f(t) ? t : t.contextElement;
}
const $023d07731ce8610f$var$b = {
    x: 1,
    y: 1
};
function $023d07731ce8610f$var$L(t) {
    const e = $023d07731ce8610f$var$v(t);
    if (!$023d07731ce8610f$var$s(e)) return $023d07731ce8610f$var$b;
    const n = e.getBoundingClientRect(), { width: o, height: i, fallback: r } = $023d07731ce8610f$var$w(e);
    let l = (r ? $023d07731ce8610f$var$x(n.width) : n.width) / o, c = (r ? $023d07731ce8610f$var$x(n.height) : n.height) / i;
    return l && Number.isFinite(l) || (l = 1), c && Number.isFinite(c) || (c = 1), {
        x: l,
        y: c
    };
}
function $023d07731ce8610f$var$E(e, o, i, r) {
    var l, c;
    void 0 === o && (o = !1), void 0 === i && (i = !1);
    const s = e.getBoundingClientRect(), u = $023d07731ce8610f$var$v(e);
    let a = $023d07731ce8610f$var$b;
    o && (r ? $023d07731ce8610f$var$f(r) && (a = $023d07731ce8610f$var$L(r)) : a = $023d07731ce8610f$var$L(e));
    const d = u ? $023d07731ce8610f$var$n(u) : window, h = $023d07731ce8610f$var$p() && i;
    let g = (s.left + (h && (null == (l = d.visualViewport) ? void 0 : l.offsetLeft) || 0)) / a.x, m = (s.top + (h && (null == (c = d.visualViewport) ? void 0 : c.offsetTop) || 0)) / a.y, y = s.width / a.x, x = s.height / a.y;
    if (u) {
        const t = $023d07731ce8610f$var$n(u), e = r && $023d07731ce8610f$var$f(r) ? $023d07731ce8610f$var$n(r) : r;
        let o = t.frameElement;
        for(; o && r && e !== t;){
            const t = $023d07731ce8610f$var$L(o), e = o.getBoundingClientRect(), i = getComputedStyle(o);
            e.x += (o.clientLeft + parseFloat(i.paddingLeft)) * t.x, e.y += (o.clientTop + parseFloat(i.paddingTop)) * t.y, g *= t.x, m *= t.y, y *= t.x, x *= t.y, g += e.x, m += e.y, o = $023d07731ce8610f$var$n(o).frameElement;
        }
    }
    return (0, $7MIdi.rectToClientRect)({
        width: y,
        height: x,
        x: g,
        y: m
    });
}
function $023d07731ce8610f$var$T(t) {
    return (($023d07731ce8610f$var$i(t) ? t.ownerDocument : t.document) || window.document).documentElement;
}
function $023d07731ce8610f$var$R(t) {
    return $023d07731ce8610f$var$f(t) ? {
        scrollLeft: t.scrollLeft,
        scrollTop: t.scrollTop
    } : {
        scrollLeft: t.pageXOffset,
        scrollTop: t.pageYOffset
    };
}
function $023d07731ce8610f$var$C(t) {
    return $023d07731ce8610f$var$E($023d07731ce8610f$var$T(t)).left + $023d07731ce8610f$var$R(t).scrollLeft;
}
function $023d07731ce8610f$var$F(t) {
    if ("html" === $023d07731ce8610f$var$r(t)) return t;
    const e = t.assignedSlot || t.parentNode || $023d07731ce8610f$var$u(t) && t.host || $023d07731ce8610f$var$T(t);
    return $023d07731ce8610f$var$u(e) ? e.host : e;
}
function $023d07731ce8610f$var$W(t) {
    const e = $023d07731ce8610f$var$F(t);
    return $023d07731ce8610f$var$g(e) ? e.ownerDocument.body : $023d07731ce8610f$var$s(e) && $023d07731ce8610f$var$a(e) ? e : $023d07731ce8610f$var$W(e);
}
function $023d07731ce8610f$export$3b57c1601291186b(t, e) {
    var o;
    void 0 === e && (e = []);
    const i = $023d07731ce8610f$var$W(t), r = i === (null == (o = t.ownerDocument) ? void 0 : o.body), l = $023d07731ce8610f$var$n(i);
    return r ? e.concat(l, l.visualViewport || [], $023d07731ce8610f$var$a(i) ? i : []) : e.concat(i, $023d07731ce8610f$export$3b57c1601291186b(i));
}
function $023d07731ce8610f$var$S(e, i, r) {
    let l;
    if ("viewport" === i) l = function(t, e) {
        const o = $023d07731ce8610f$var$n(t), i = $023d07731ce8610f$var$T(t), r = o.visualViewport;
        let l = i.clientWidth, c = i.clientHeight, s = 0, f = 0;
        if (r) {
            l = r.width, c = r.height;
            const t = $023d07731ce8610f$var$p();
            (!t || t && "fixed" === e) && (s = r.offsetLeft, f = r.offsetTop);
        }
        return {
            width: l,
            height: c,
            x: s,
            y: f
        };
    }(e, r);
    else if ("document" === i) l = function(t) {
        const e = $023d07731ce8610f$var$T(t), n = $023d07731ce8610f$var$R(t), i = t.ownerDocument.body, r = $023d07731ce8610f$var$y(e.scrollWidth, e.clientWidth, i.scrollWidth, i.clientWidth), l = $023d07731ce8610f$var$y(e.scrollHeight, e.clientHeight, i.scrollHeight, i.clientHeight);
        let c = -n.scrollLeft + $023d07731ce8610f$var$C(t);
        const s = -n.scrollTop;
        return "rtl" === $023d07731ce8610f$var$o(i).direction && (c += $023d07731ce8610f$var$y(e.clientWidth, i.clientWidth) - r), {
            width: r,
            height: l,
            x: c,
            y: s
        };
    }($023d07731ce8610f$var$T(e));
    else if ($023d07731ce8610f$var$f(i)) l = function(t, e) {
        const n = $023d07731ce8610f$var$E(t, !0, "fixed" === e), o = n.top + t.clientTop, i = n.left + t.clientLeft, r = $023d07731ce8610f$var$s(t) ? $023d07731ce8610f$var$L(t) : {
            x: 1,
            y: 1
        };
        return {
            width: t.clientWidth * r.x,
            height: t.clientHeight * r.y,
            x: i * r.x,
            y: o * r.y
        };
    }(i, r);
    else {
        const t = {
            ...i
        };
        if ($023d07731ce8610f$var$p()) {
            var c, u;
            const o = $023d07731ce8610f$var$n(e);
            t.x -= (null == (c = o.visualViewport) ? void 0 : c.offsetLeft) || 0, t.y -= (null == (u = o.visualViewport) ? void 0 : u.offsetTop) || 0;
        }
        l = t;
    }
    return (0, $7MIdi.rectToClientRect)(l);
}
function $023d07731ce8610f$var$A(t, e) {
    return $023d07731ce8610f$var$s(t) && "fixed" !== $023d07731ce8610f$var$o(t).position ? e ? e(t) : t.offsetParent : null;
}
function $023d07731ce8610f$var$H(t, e) {
    const i = $023d07731ce8610f$var$n(t);
    if (!$023d07731ce8610f$var$s(t)) return i;
    let l = $023d07731ce8610f$var$A(t, e);
    for(; l && $023d07731ce8610f$var$d(l) && "static" === $023d07731ce8610f$var$o(l).position;)l = $023d07731ce8610f$var$A(l, e);
    return l && ("html" === $023d07731ce8610f$var$r(l) || "body" === $023d07731ce8610f$var$r(l) && "static" === $023d07731ce8610f$var$o(l).position && !$023d07731ce8610f$var$h(l)) ? i : l || function(t) {
        let e = $023d07731ce8610f$var$F(t);
        for(; $023d07731ce8610f$var$s(e) && !$023d07731ce8610f$var$g(e);){
            if ($023d07731ce8610f$var$h(e)) return e;
            e = $023d07731ce8610f$var$F(e);
        }
        return null;
    }(t) || i;
}
function $023d07731ce8610f$var$V(t, e, n) {
    const o = $023d07731ce8610f$var$s(e), i = $023d07731ce8610f$var$T(e), l = $023d07731ce8610f$var$E(t, !0, "fixed" === n, e);
    let c = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const f = {
        x: 0,
        y: 0
    };
    if (o || !o && "fixed" !== n) {
        if (("body" !== $023d07731ce8610f$var$r(e) || $023d07731ce8610f$var$a(i)) && (c = $023d07731ce8610f$var$R(e)), $023d07731ce8610f$var$s(e)) {
            const t = $023d07731ce8610f$var$E(e, !0);
            f.x = t.x + e.clientLeft, f.y = t.y + e.clientTop;
        } else i && (f.x = $023d07731ce8610f$var$C(i));
    }
    return {
        x: l.left + c.scrollLeft - f.x,
        y: l.top + c.scrollTop - f.y,
        width: l.width,
        height: l.height
    };
}
const $023d07731ce8610f$export$722a64dea1b767dc = {
    getClippingRect: function(t) {
        let { element: e, boundary: n, rootBoundary: i, strategy: l } = t;
        const c = "clippingAncestors" === n ? function(t, e) {
            const n = e.get(t);
            if (n) return n;
            let i = $023d07731ce8610f$export$3b57c1601291186b(t).filter((t)=>$023d07731ce8610f$var$f(t) && "body" !== $023d07731ce8610f$var$r(t)), l = null;
            const c = "fixed" === $023d07731ce8610f$var$o(t).position;
            let s = c ? $023d07731ce8610f$var$F(t) : t;
            for(; $023d07731ce8610f$var$f(s) && !$023d07731ce8610f$var$g(s);){
                const t = $023d07731ce8610f$var$o(s), e = $023d07731ce8610f$var$h(s);
                "fixed" === t.position ? l = null : (c ? e || l : e || "static" !== t.position || !l || ![
                    "absolute",
                    "fixed"
                ].includes(l.position)) ? l = t : i = i.filter((t)=>t !== s), s = $023d07731ce8610f$var$F(s);
            }
            return e.set(t, i), i;
        }(e, this._c) : [].concat(n), s = [
            ...c,
            i
        ], u = s[0], a = s.reduce((t, n)=>{
            const o = $023d07731ce8610f$var$S(e, n, l);
            return t.top = $023d07731ce8610f$var$y(o.top, t.top), t.right = $023d07731ce8610f$var$m(o.right, t.right), t.bottom = $023d07731ce8610f$var$m(o.bottom, t.bottom), t.left = $023d07731ce8610f$var$y(o.left, t.left), t;
        }, $023d07731ce8610f$var$S(e, u, l));
        return {
            width: a.right - a.left,
            height: a.bottom - a.top,
            x: a.left,
            y: a.top
        };
    },
    convertOffsetParentRelativeRectToViewportRelativeRect: function(t) {
        let { rect: e, offsetParent: n, strategy: o } = t;
        const i = $023d07731ce8610f$var$s(n), l = $023d07731ce8610f$var$T(n);
        if (n === l) return e;
        let c = {
            scrollLeft: 0,
            scrollTop: 0
        }, f = {
            x: 1,
            y: 1
        };
        const u = {
            x: 0,
            y: 0
        };
        if ((i || !i && "fixed" !== o) && (("body" !== $023d07731ce8610f$var$r(n) || $023d07731ce8610f$var$a(l)) && (c = $023d07731ce8610f$var$R(n)), $023d07731ce8610f$var$s(n))) {
            const t = $023d07731ce8610f$var$E(n);
            f = $023d07731ce8610f$var$L(n), u.x = t.x + n.clientLeft, u.y = t.y + n.clientTop;
        }
        return {
            width: e.width * f.x,
            height: e.height * f.y,
            x: e.x * f.x - c.scrollLeft * f.x + u.x,
            y: e.y * f.y - c.scrollTop * f.y + u.y
        };
    },
    isElement: $023d07731ce8610f$var$f,
    getDimensions: function(t) {
        return $023d07731ce8610f$var$w(t);
    },
    getOffsetParent: $023d07731ce8610f$var$H,
    getDocumentElement: $023d07731ce8610f$var$T,
    getScale: $023d07731ce8610f$var$L,
    async getElementRects (t) {
        let { reference: e, floating: n, strategy: o } = t;
        const i = this.getOffsetParent || $023d07731ce8610f$var$H, r = this.getDimensions;
        return {
            reference: $023d07731ce8610f$var$V(e, await i(n), o),
            floating: {
                x: 0,
                y: 0,
                ...await r(n)
            }
        };
    },
    getClientRects: (t)=>Array.from(t.getClientRects()),
    isRTL: (t)=>"rtl" === $023d07731ce8610f$var$o(t).direction
};
function $023d07731ce8610f$export$deee3a793edee05f(t, e, n, o) {
    void 0 === o && (o = {});
    const { ancestorScroll: i = !0, ancestorResize: r = !0, elementResize: l = !0, animationFrame: c = !1 } = o, s = i && !c, u = s || r ? [
        ...$023d07731ce8610f$var$f(t) ? $023d07731ce8610f$export$3b57c1601291186b(t) : t.contextElement ? $023d07731ce8610f$export$3b57c1601291186b(t.contextElement) : [],
        ...$023d07731ce8610f$export$3b57c1601291186b(e)
    ] : [];
    u.forEach((t)=>{
        s && t.addEventListener("scroll", n, {
            passive: !0
        }), r && t.addEventListener("resize", n);
    });
    let a, d = null;
    l && (d = new ResizeObserver(()=>{
        n();
    }), $023d07731ce8610f$var$f(t) && !c && d.observe(t), $023d07731ce8610f$var$f(t) || !t.contextElement || c || d.observe(t.contextElement), d.observe(e));
    let h = c ? $023d07731ce8610f$var$E(t) : null;
    return c && function e() {
        const o = $023d07731ce8610f$var$E(t);
        !h || o.x === h.x && o.y === h.y && o.width === h.width && o.height === h.height || n();
        h = o, a = requestAnimationFrame(e);
    }(), n(), ()=>{
        var t;
        u.forEach((t)=>{
            s && t.removeEventListener("scroll", n), r && t.removeEventListener("resize", n);
        }), null == (t = d) || t.disconnect(), d = null, c && cancelAnimationFrame(a);
    };
}
const $023d07731ce8610f$export$48a53dcb22e581d0 = (t, n, o)=>{
    const i = new Map, r = {
        platform: $023d07731ce8610f$export$722a64dea1b767dc,
        ...o
    }, l = {
        ...r.platform,
        _c: i
    };
    return (0, $7MIdi.computePosition)(t, n, {
        ...r,
        platform: l
    });
};

});
parcelRegister("7MIdi", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $4dacbd6c81f90f16$export$48a53dcb22e581d0);
$parcel$export(module.exports, "rectToClientRect", () => $4dacbd6c81f90f16$export$ee05aea0aeecbad4);
function $4dacbd6c81f90f16$var$t(t) {
    return t.split("-")[1];
}
function $4dacbd6c81f90f16$var$e(t) {
    return "y" === t ? "height" : "width";
}
function $4dacbd6c81f90f16$var$n(t) {
    return t.split("-")[0];
}
function $4dacbd6c81f90f16$var$o(t) {
    return [
        "top",
        "bottom"
    ].includes($4dacbd6c81f90f16$var$n(t)) ? "x" : "y";
}
function $4dacbd6c81f90f16$var$i(i, r, a) {
    let { reference: l, floating: s } = i;
    const c = l.x + l.width / 2 - s.width / 2, f = l.y + l.height / 2 - s.height / 2, m = $4dacbd6c81f90f16$var$o(r), u = $4dacbd6c81f90f16$var$e(m), g = l[u] / 2 - s[u] / 2, d = "x" === m;
    let p;
    switch($4dacbd6c81f90f16$var$n(r)){
        case "top":
            p = {
                x: c,
                y: l.y - s.height
            };
            break;
        case "bottom":
            p = {
                x: c,
                y: l.y + l.height
            };
            break;
        case "right":
            p = {
                x: l.x + l.width,
                y: f
            };
            break;
        case "left":
            p = {
                x: l.x - s.width,
                y: f
            };
            break;
        default:
            p = {
                x: l.x,
                y: l.y
            };
    }
    switch($4dacbd6c81f90f16$var$t(r)){
        case "start":
            p[m] -= g * (a && d ? -1 : 1);
            break;
        case "end":
            p[m] += g * (a && d ? -1 : 1);
    }
    return p;
}
const $4dacbd6c81f90f16$export$48a53dcb22e581d0 = async (t, e, n)=>{
    const { placement: o = "bottom", strategy: r = "absolute", middleware: a = [], platform: l } = n, s = a.filter(Boolean), c = await (null == l.isRTL ? void 0 : l.isRTL(e));
    let f = await l.getElementRects({
        reference: t,
        floating: e,
        strategy: r
    }), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, o, c), g = o, d = {}, p = 0;
    for(let n = 0; n < s.length; n++){
        const { name: a, fn: h } = s[n], { x: y, y: x, data: w, reset: v } = await h({
            x: m,
            y: u,
            initialPlacement: o,
            placement: g,
            strategy: r,
            middlewareData: d,
            rects: f,
            platform: l,
            elements: {
                reference: t,
                floating: e
            }
        });
        m = null != y ? y : m, u = null != x ? x : u, d = {
            ...d,
            [a]: {
                ...d[a],
                ...w
            }
        }, v && p <= 50 && (p++, "object" == typeof v && (v.placement && (g = v.placement), v.rects && (f = !0 === v.rects ? await l.getElementRects({
            reference: t,
            floating: e,
            strategy: r
        }) : v.rects), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, g, c)), n = -1);
    }
    return {
        x: m,
        y: u,
        placement: g,
        strategy: r,
        middlewareData: d
    };
};
function $4dacbd6c81f90f16$var$a(t) {
    return "number" != typeof t ? function(t) {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...t
        };
    }(t) : {
        top: t,
        right: t,
        bottom: t,
        left: t
    };
}
function $4dacbd6c81f90f16$export$ee05aea0aeecbad4(t) {
    return {
        ...t,
        top: t.y,
        left: t.x,
        right: t.x + t.width,
        bottom: t.y + t.height
    };
}
async function $4dacbd6c81f90f16$export$37b6bde19b108ecc(t, e) {
    var n;
    void 0 === e && (e = {});
    const { x: o, y: i, platform: r, rects: s, elements: c, strategy: f } = t, { boundary: m = "clippingAncestors", rootBoundary: u = "viewport", elementContext: g = "floating", altBoundary: d = !1, padding: p = 0 } = e, h = $4dacbd6c81f90f16$var$a(p), y = c[d ? "floating" === g ? "reference" : "floating" : g], x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(await r.getClippingRect({
        element: null == (n = await (null == r.isElement ? void 0 : r.isElement(y))) || n ? y : y.contextElement || await (null == r.getDocumentElement ? void 0 : r.getDocumentElement(c.floating)),
        boundary: m,
        rootBoundary: u,
        strategy: f
    })), w = "floating" === g ? {
        ...s.floating,
        x: o,
        y: i
    } : s.reference, v = await (null == r.getOffsetParent ? void 0 : r.getOffsetParent(c.floating)), b = await (null == r.isElement ? void 0 : r.isElement(v)) && await (null == r.getScale ? void 0 : r.getScale(v)) || {
        x: 1,
        y: 1
    }, A = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: w,
        offsetParent: v,
        strategy: f
    }) : w);
    return {
        top: (x.top - A.top + h.top) / b.y,
        bottom: (A.bottom - x.bottom + h.bottom) / b.y,
        left: (x.left - A.left + h.left) / b.x,
        right: (A.right - x.right + h.right) / b.x
    };
}
const $4dacbd6c81f90f16$var$c = Math.min, $4dacbd6c81f90f16$var$f = Math.max;
function $4dacbd6c81f90f16$var$m(t, e, n) {
    return $4dacbd6c81f90f16$var$f(t, $4dacbd6c81f90f16$var$c(e, n));
}
const $4dacbd6c81f90f16$export$f2120bbfa5450bd2 = (n)=>({
        name: "arrow",
        options: n,
        async fn (i) {
            const { element: r, padding: l = 0 } = n || {}, { x: s, y: c, placement: f, rects: u, platform: g, elements: d } = i;
            if (null == r) return {};
            const p = $4dacbd6c81f90f16$var$a(l), h = {
                x: s,
                y: c
            }, y = $4dacbd6c81f90f16$var$o(f), x = $4dacbd6c81f90f16$var$e(y), w = await g.getDimensions(r), v = "y" === y, b = v ? "top" : "left", A = v ? "bottom" : "right", R = v ? "clientHeight" : "clientWidth", P = u.reference[x] + u.reference[y] - h[y] - u.floating[x], E = h[y] - u.reference[y], T = await (null == g.getOffsetParent ? void 0 : g.getOffsetParent(r));
            let D = T ? T[R] : 0;
            D && await (null == g.isElement ? void 0 : g.isElement(T)) || (D = d.floating[R] || u.floating[x]);
            const L = P / 2 - E / 2, k = p[b], O = D - w[x] - p[A], B = D / 2 - w[x] / 2 + L, C = $4dacbd6c81f90f16$var$m(k, B, O), H = null != $4dacbd6c81f90f16$var$t(f) && B != C && u.reference[x] / 2 - (B < k ? p[b] : p[A]) - w[x] / 2 < 0;
            return {
                [y]: h[y] - (H ? B < k ? k - B : O - B : 0),
                data: {
                    [y]: C,
                    centerOffset: B - C
                }
            };
        }
    }), $4dacbd6c81f90f16$var$g = [
    "top",
    "right",
    "bottom",
    "left"
], $4dacbd6c81f90f16$var$d = $4dacbd6c81f90f16$var$g.reduce((t, e)=>t.concat(e, e + "-start", e + "-end"), []), $4dacbd6c81f90f16$var$p = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $4dacbd6c81f90f16$var$h(t) {
    return t.replace(/left|right|bottom|top/g, (t)=>$4dacbd6c81f90f16$var$p[t]);
}
function $4dacbd6c81f90f16$var$y(n, i, r) {
    void 0 === r && (r = !1);
    const a = $4dacbd6c81f90f16$var$t(n), l = $4dacbd6c81f90f16$var$o(n), s = $4dacbd6c81f90f16$var$e(l);
    let c = "x" === l ? a === (r ? "end" : "start") ? "right" : "left" : "start" === a ? "bottom" : "top";
    return i.reference[s] > i.floating[s] && (c = $4dacbd6c81f90f16$var$h(c)), {
        main: c,
        cross: $4dacbd6c81f90f16$var$h(c)
    };
}
const $4dacbd6c81f90f16$var$x = {
    start: "end",
    end: "start"
};
function $4dacbd6c81f90f16$var$w(t) {
    return t.replace(/start|end/g, (t)=>$4dacbd6c81f90f16$var$x[t]);
}
const $4dacbd6c81f90f16$export$91fb6ecbd551914 = function(e) {
    return void 0 === e && (e = {}), {
        name: "autoPlacement",
        options: e,
        async fn (o) {
            var i, r, a;
            const { rects: l, middlewareData: c, placement: f, platform: m, elements: u } = o, { crossAxis: g = !1, alignment: p, allowedPlacements: h = $4dacbd6c81f90f16$var$d, autoAlignment: x = !0, ...v } = e, b = void 0 !== p || h === $4dacbd6c81f90f16$var$d ? function(e, o, i) {
                return (e ? [
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) === e),
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) !== e)
                ] : i.filter((t)=>$4dacbd6c81f90f16$var$n(t) === t)).filter((n)=>!e || $4dacbd6c81f90f16$var$t(n) === e || !!o && $4dacbd6c81f90f16$var$w(n) !== n);
            }(p || null, x, h) : h, A = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, v), R = (null == (i = c.autoPlacement) ? void 0 : i.index) || 0, P = b[R];
            if (null == P) return {};
            const { main: E, cross: T } = $4dacbd6c81f90f16$var$y(P, l, await (null == m.isRTL ? void 0 : m.isRTL(u.floating)));
            if (f !== P) return {
                reset: {
                    placement: b[0]
                }
            };
            const D = [
                A[$4dacbd6c81f90f16$var$n(P)],
                A[E],
                A[T]
            ], L = [
                ...(null == (r = c.autoPlacement) ? void 0 : r.overflows) || [],
                {
                    placement: P,
                    overflows: D
                }
            ], k = b[R + 1];
            if (k) return {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: k
                }
            };
            const O = L.map((e)=>{
                const n = $4dacbd6c81f90f16$var$t(e.placement);
                return [
                    e.placement,
                    n && g ? e.overflows.slice(0, 2).reduce((t, e)=>t + e, 0) : e.overflows[0],
                    e.overflows
                ];
            }).sort((t, e)=>t[1] - e[1]), B = (null == (a = O.filter((e)=>e[2].slice(0, $4dacbd6c81f90f16$var$t(e[0]) ? 2 : 3).every((t)=>t <= 0))[0]) ? void 0 : a[0]) || O[0][0];
            return B !== f ? {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: B
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$8a83211c878a3f1f = function(e) {
    return void 0 === e && (e = {}), {
        name: "flip",
        options: e,
        async fn (o) {
            var i;
            const { placement: r, middlewareData: a, rects: l, initialPlacement: c, platform: f, elements: m } = o, { mainAxis: u = !0, crossAxis: g = !0, fallbackPlacements: d, fallbackStrategy: p = "bestFit", fallbackAxisSideDirection: x = "none", flipAlignment: v = !0, ...b } = e, A = $4dacbd6c81f90f16$var$n(r), R = $4dacbd6c81f90f16$var$n(c) === c, P = await (null == f.isRTL ? void 0 : f.isRTL(m.floating)), E = d || (R || !v ? [
                $4dacbd6c81f90f16$var$h(c)
            ] : function(t) {
                const e = $4dacbd6c81f90f16$var$h(t);
                return [
                    $4dacbd6c81f90f16$var$w(t),
                    e,
                    $4dacbd6c81f90f16$var$w(e)
                ];
            }(c));
            d || "none" === x || E.push(...function(e, o, i, r) {
                const a = $4dacbd6c81f90f16$var$t(e);
                let l = function(t, e, n) {
                    const o = [
                        "left",
                        "right"
                    ], i = [
                        "right",
                        "left"
                    ], r = [
                        "top",
                        "bottom"
                    ], a = [
                        "bottom",
                        "top"
                    ];
                    switch(t){
                        case "top":
                        case "bottom":
                            return n ? e ? i : o : e ? o : i;
                        case "left":
                        case "right":
                            return e ? r : a;
                        default:
                            return [];
                    }
                }($4dacbd6c81f90f16$var$n(e), "start" === i, r);
                return a && (l = l.map((t)=>t + "-" + a), o && (l = l.concat(l.map($4dacbd6c81f90f16$var$w)))), l;
            }(c, v, x, P));
            const T = [
                c,
                ...E
            ], D = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, b), L = [];
            let k = (null == (i = a.flip) ? void 0 : i.overflows) || [];
            if (u && L.push(D[A]), g) {
                const { main: t, cross: e } = $4dacbd6c81f90f16$var$y(r, l, P);
                L.push(D[t], D[e]);
            }
            if (k = [
                ...k,
                {
                    placement: r,
                    overflows: L
                }
            ], !L.every((t)=>t <= 0)) {
                var O, B;
                const t = ((null == (O = a.flip) ? void 0 : O.index) || 0) + 1, e = T[t];
                if (e) return {
                    data: {
                        index: t,
                        overflows: k
                    },
                    reset: {
                        placement: e
                    }
                };
                let n = null == (B = k.filter((t)=>t.overflows[0] <= 0).sort((t, e)=>t.overflows[1] - e.overflows[1])[0]) ? void 0 : B.placement;
                if (!n) switch(p){
                    case "bestFit":
                        {
                            var C;
                            const t = null == (C = k.map((t)=>[
                                    t.placement,
                                    t.overflows.filter((t)=>t > 0).reduce((t, e)=>t + e, 0)
                                ]).sort((t, e)=>t[1] - e[1])[0]) ? void 0 : C[0];
                            t && (n = t);
                            break;
                        }
                    case "initialPlacement":
                        n = c;
                }
                if (r !== n) return {
                    reset: {
                        placement: n
                    }
                };
            }
            return {};
        }
    };
};
function $4dacbd6c81f90f16$var$A(t, e) {
    return {
        top: t.top - e.height,
        right: t.right - e.width,
        bottom: t.bottom - e.height,
        left: t.left - e.width
    };
}
function $4dacbd6c81f90f16$var$R(t) {
    return $4dacbd6c81f90f16$var$g.some((e)=>t[e] >= 0);
}
const $4dacbd6c81f90f16$export$fe8985bb6374093c = function(t) {
    return void 0 === t && (t = {}), {
        name: "hide",
        options: t,
        async fn (e) {
            const { strategy: n = "referenceHidden", ...o } = t, { rects: i } = e;
            switch(n){
                case "referenceHidden":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            elementContext: "reference"
                        }), i.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: t,
                                referenceHidden: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                case "escaped":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            altBoundary: !0
                        }), i.floating);
                        return {
                            data: {
                                escapedOffsets: t,
                                escaped: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $4dacbd6c81f90f16$var$E(t) {
    const e = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.left)), n = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.top));
    return {
        x: e,
        y: n,
        width: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.right)) - e,
        height: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.bottom)) - n
    };
}
const $4dacbd6c81f90f16$export$18c8ad048e32c7d5 = function(t) {
    return void 0 === t && (t = {}), {
        name: "inline",
        options: t,
        async fn (e) {
            const { placement: i, elements: r, rects: s, platform: m, strategy: u } = e, { padding: g = 2, x: d, y: p } = t, h = Array.from(await (null == m.getClientRects ? void 0 : m.getClientRects(r.reference)) || []), y = function(t) {
                const e = t.slice().sort((t, e)=>t.y - e.y), n = [];
                let o = null;
                for(let t = 0; t < e.length; t++){
                    const i = e[t];
                    !o || i.y - o.y > o.height / 2 ? n.push([
                        i
                    ]) : n[n.length - 1].push(i), o = i;
                }
                return n.map((t)=>$4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(t)));
            }(h), x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(h)), w = $4dacbd6c81f90f16$var$a(g);
            const v = await m.getElementRects({
                reference: {
                    getBoundingClientRect: function() {
                        if (2 === y.length && y[0].left > y[1].right && null != d && null != p) return y.find((t)=>d > t.left - w.left && d < t.right + w.right && p > t.top - w.top && p < t.bottom + w.bottom) || x;
                        if (y.length >= 2) {
                            if ("x" === $4dacbd6c81f90f16$var$o(i)) {
                                const t = y[0], e = y[y.length - 1], o = "top" === $4dacbd6c81f90f16$var$n(i), r = t.top, a = e.bottom, l = o ? t.left : e.left, s = o ? t.right : e.right;
                                return {
                                    top: r,
                                    bottom: a,
                                    left: l,
                                    right: s,
                                    width: s - l,
                                    height: a - r,
                                    x: l,
                                    y: r
                                };
                            }
                            const t = "left" === $4dacbd6c81f90f16$var$n(i), e = $4dacbd6c81f90f16$var$f(...y.map((t)=>t.right)), r = $4dacbd6c81f90f16$var$c(...y.map((t)=>t.left)), a = y.filter((n)=>t ? n.left === r : n.right === e), l = a[0].top, s = a[a.length - 1].bottom;
                            return {
                                top: l,
                                bottom: s,
                                left: r,
                                right: e,
                                width: e - r,
                                height: s - l,
                                x: r,
                                y: l
                            };
                        }
                        return x;
                    }
                },
                floating: r.floating,
                strategy: u
            });
            return s.reference.x !== v.reference.x || s.reference.y !== v.reference.y || s.reference.width !== v.reference.width || s.reference.height !== v.reference.height ? {
                reset: {
                    rects: v
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$cc800923e997bb8 = function(e) {
    return void 0 === e && (e = 0), {
        name: "offset",
        options: e,
        async fn (i) {
            const { x: r, y: a } = i, l = await async function(e, i) {
                const { placement: r, platform: a, elements: l } = e, s = await (null == a.isRTL ? void 0 : a.isRTL(l.floating)), c = $4dacbd6c81f90f16$var$n(r), f = $4dacbd6c81f90f16$var$t(r), m = "x" === $4dacbd6c81f90f16$var$o(r), u = [
                    "left",
                    "top"
                ].includes(c) ? -1 : 1, g = s && m ? -1 : 1, d = "function" == typeof i ? i(e) : i;
                let { mainAxis: p, crossAxis: h, alignmentAxis: y } = "number" == typeof d ? {
                    mainAxis: d,
                    crossAxis: 0,
                    alignmentAxis: null
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    alignmentAxis: null,
                    ...d
                };
                return f && "number" == typeof y && (h = "end" === f ? -1 * y : y), m ? {
                    x: h * g,
                    y: p * u
                } : {
                    x: p * u,
                    y: h * g
                };
            }(i, e);
            return {
                x: r + l.x,
                y: a + l.y,
                data: l
            };
        }
    };
};
function $4dacbd6c81f90f16$var$L(t) {
    return "x" === t ? "y" : "x";
}
const $4dacbd6c81f90f16$export$fba63a578e423eb = function(t) {
    return void 0 === t && (t = {}), {
        name: "shift",
        options: t,
        async fn (e) {
            const { x: i, y: r, placement: a } = e, { mainAxis: l = !0, crossAxis: c = !1, limiter: f = {
                fn: (t)=>{
                    let { x: e, y: n } = t;
                    return {
                        x: e,
                        y: n
                    };
                }
            }, ...u } = t, g = {
                x: i,
                y: r
            }, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, u), p = $4dacbd6c81f90f16$var$o($4dacbd6c81f90f16$var$n(a)), h = $4dacbd6c81f90f16$var$L(p);
            let y = g[p], x = g[h];
            if (l) {
                const t = "y" === p ? "bottom" : "right";
                y = $4dacbd6c81f90f16$var$m(y + d["y" === p ? "top" : "left"], y, y - d[t]);
            }
            if (c) {
                const t = "y" === h ? "bottom" : "right";
                x = $4dacbd6c81f90f16$var$m(x + d["y" === h ? "top" : "left"], x, x - d[t]);
            }
            const w = f.fn({
                ...e,
                [p]: y,
                [h]: x
            });
            return {
                ...w,
                data: {
                    x: w.x - i,
                    y: w.y - r
                }
            };
        }
    };
}, $4dacbd6c81f90f16$export$7bf07e38f3dc4b69 = function(t) {
    return void 0 === t && (t = {}), {
        options: t,
        fn (e) {
            const { x: i, y: r, placement: a, rects: l, middlewareData: s } = e, { offset: c = 0, mainAxis: f = !0, crossAxis: m = !0 } = t, u = {
                x: i,
                y: r
            }, g = $4dacbd6c81f90f16$var$o(a), d = $4dacbd6c81f90f16$var$L(g);
            let p = u[g], h = u[d];
            const y = "function" == typeof c ? c(e) : c, x = "number" == typeof y ? {
                mainAxis: y,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...y
            };
            if (f) {
                const t = "y" === g ? "height" : "width", e = l.reference[g] - l.floating[t] + x.mainAxis, n = l.reference[g] + l.reference[t] - x.mainAxis;
                p < e ? p = e : p > n && (p = n);
            }
            if (m) {
                var w, v;
                const t = "y" === g ? "width" : "height", e = [
                    "top",
                    "left"
                ].includes($4dacbd6c81f90f16$var$n(a)), o = l.reference[d] - l.floating[t] + (e && (null == (w = s.offset) ? void 0 : w[d]) || 0) + (e ? 0 : x.crossAxis), i = l.reference[d] + l.reference[t] + (e ? 0 : (null == (v = s.offset) ? void 0 : v[d]) || 0) - (e ? x.crossAxis : 0);
                h < o ? h = o : h > i && (h = i);
            }
            return {
                [g]: p,
                [d]: h
            };
        }
    };
}, $4dacbd6c81f90f16$export$346677f925de839c = function(e) {
    return void 0 === e && (e = {}), {
        name: "size",
        options: e,
        async fn (i) {
            const { placement: r, rects: a, platform: l, elements: m } = i, { apply: u = ()=>{}, ...g } = e, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(i, g), p = $4dacbd6c81f90f16$var$n(r), h = $4dacbd6c81f90f16$var$t(r), y = "x" === $4dacbd6c81f90f16$var$o(r), { width: x, height: w } = a.floating;
            let v, b;
            "top" === p || "bottom" === p ? (v = p, b = h === (await (null == l.isRTL ? void 0 : l.isRTL(m.floating)) ? "start" : "end") ? "left" : "right") : (b = p, v = "end" === h ? "top" : "bottom");
            const A = w - d[v], R = x - d[b];
            let P = A, E = R;
            if (y ? E = $4dacbd6c81f90f16$var$c(x - d.right - d.left, R) : P = $4dacbd6c81f90f16$var$c(w - d.bottom - d.top, A), !i.middlewareData.shift && !h) {
                const t = $4dacbd6c81f90f16$var$f(d.left, 0), e = $4dacbd6c81f90f16$var$f(d.right, 0), n = $4dacbd6c81f90f16$var$f(d.top, 0), o = $4dacbd6c81f90f16$var$f(d.bottom, 0);
                y ? E = x - 2 * (0 !== t || 0 !== e ? t + e : $4dacbd6c81f90f16$var$f(d.left, d.right)) : P = w - 2 * (0 !== n || 0 !== o ? n + o : $4dacbd6c81f90f16$var$f(d.top, d.bottom));
            }
            await u({
                ...i,
                availableWidth: E,
                availableHeight: P
            });
            const T = await l.getDimensions(m.floating);
            return x !== T.width || w !== T.height ? {
                reset: {
                    rects: !0
                }
            } : {};
        }
    };
};

});


parcelRegister("k286k", function(module, exports) {

$parcel$export(module.exports, "default", () => $e95a473d1e65c2a9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var $e95a473d1e65c2a9$var$index = (0, $eUqFw.useLayoutEffect);
var $e95a473d1e65c2a9$export$2e2bcd8739ae039 = $e95a473d1e65c2a9$var$index;

});




parcelRegister("5FjBr", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba6ba00681316b2f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $jQirI = parcelRequire("jQirI");

var $hgqfZ = parcelRequire("hgqfZ");

var $o2lI9 = parcelRequire("o2lI9");
var $7HYS7 = parcelRequire("7HYS7");

var $bKJfr = parcelRequire("bKJfr");

var $lT14u = parcelRequire("lT14u");
function $ba6ba00681316b2f$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { appearance: appearance, ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, spacing: spacing = 'default', styles: styles = {}, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $eUqFw.useRef)(null);
        const components = (0, $eUqFw.useMemo)(()=>({
                ClearIndicator: $o2lI9.ClearIndicator,
                DropdownIndicator: $o2lI9.DropdownIndicator,
                LoadingIndicator: $o2lI9.LoadingIndicator,
                MultiValueRemove: $7HYS7.MultiValueRemove,
                IndicatorSeparator: $7HYS7.IndicatorSeparator,
                Input: $jQirI.Input,
                NoOptionsMessage: $hgqfZ.NoOptionsMessage,
                ...componentsProp
            }), [
            componentsProp
        ]);
        const descriptionId = props['aria-describedby'];
        const isSearchable = props.isSearchable;
        (0, $eUqFw.useEffect)(()=>{
            if (!isSearchable && descriptionId) {
                // when isSearchable is false, react-select will create its own dummy input instead of using ours,
                // so we need to manually add the additional aria-describedby using ref.
                const input = internalSelectRef.current?.inputRef;
                const ariaDescribedby = input?.getAttribute('aria-describedby');
                if (!ariaDescribedby?.includes(descriptionId)) input?.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
            }
        }, [
            descriptionId,
            isSearchable
        ]);
        const isCompact = spacing === 'compact';
        /**
		 * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
		 * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
		 * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
		 * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
		 * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
		 */ (0, $eUqFw.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>internalSelectRef.current?.focus(),
                blur: ()=>internalSelectRef.current?.blur()
            }), []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ref: internalSelectRef,
            "aria-live": "assertive",
            ariaLiveMessages: (0, $lT14u.isOptionsGrouped)(props.options) ? {
                onFocus: $lT14u.onFocus,
                ...ariaLiveMessages
            } : {
                ...ariaLiveMessages
            },
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            ...restProps,
            components: components,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            styles: (0, $cEc3i.m)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $bKJfr.default)(// This will cover both props for invalid state while giving priority to isInvalid. When cleaning up validationState, we can just keep the inner condition.
            typeof isInvalid !== 'undefined' ? isInvalid ? 'error' : 'default' : validationState, isCompact, appearance || 'default'), styles)
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});
parcelRegister("jQirI", function(module, exports) {

$parcel$export(module.exports, "Input", () => $644d9bc3d652d5d7$export$f5b8910cec6cf069);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
function $644d9bc3d652d5d7$export$f5b8910cec6cf069(props) {
    let ariaDescribedByAttribute;
    const passed_describedby = props.selectProps['aria-describedby'];
    if (props['aria-describedby'] && passed_describedby) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
    else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Input, {
        ...props,
        "aria-describedby": ariaDescribedByAttribute
    });
}

});

parcelRegister("hgqfZ", function(module, exports) {

$parcel$export(module.exports, "NoOptionsMessage", () => $4d0dc96eef1d75f0$export$d58b72b7d3c4072c);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
const $4d0dc96eef1d75f0$export$d58b72b7d3c4072c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).NoOptionsMessage, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        id: "no-options",
        role: "alert"
    }, props.children || `No options`));
};

});

parcelRegister("o2lI9", function(module, exports) {

$parcel$export(module.exports, "ClearIndicator", () => $a14d8b5e9bff27a8$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "DropdownIndicator", () => $a14d8b5e9bff27a8$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "LoadingIndicator", () => $a14d8b5e9bff27a8$export$7c20be4c1d342248);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $jQxSL = parcelRequire("jQxSL");

var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $hUbUe = parcelRequire("hUbUe");

var $86Ndv = parcelRequire("86Ndv");
const $a14d8b5e9bff27a8$var$iconContainerStyles = (0, $1ZAYh.xcss)({
    all: 'unset',
    outline: 'revert',
    display: 'flex',
    alignItems: 'center'
});
const $a14d8b5e9bff27a8$export$ecf9cf59142dd54a = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).ClearIndicator, {
        ...props,
        innerProps: {
            ...props.innerProps,
            'aria-hidden': 'false'
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4ZL0y.default), {
        xcss: $a14d8b5e9bff27a8$var$iconContainerStyles,
        tabIndex: -1
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hUbUe))), {
        size: "small",
        label: "clear"
    })));
const $a14d8b5e9bff27a8$export$ec98719d3db7f2e4 = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).DropdownIndicator, props, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
        label: "open"
    }));
const $a14d8b5e9bff27a8$export$7c20be4c1d342248 = (props)=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const loadingStyles = /*#__PURE__*/ (0, $byn9U.css)(props.getStyles('loadingIndicator', props));
    return(// This *must* be constructed this way because this is being consumed by
    // `react-select` and we don't control what it wants.
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: loadingStyles,
        ...props.innerProps
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4Bees.default), {
        size: "small"
    })));
};

});
parcelRegister("hUbUe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d090e6e9cc89e346$var$_react = $d090e6e9cc89e346$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $d090e6e9cc89e346$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d090e6e9cc89e346$var$SelectClearIcon = (props)=>/*#__PURE__*/ $d090e6e9cc89e346$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="9"/><path d="M16.155 14.493a1.174 1.174 0 11-1.662 1.663L12 13.662l-2.494 2.494a1.172 1.172 0 01-1.662 0 1.176 1.176 0 010-1.663L10.337 12 7.844 9.507a1.176 1.176 0 011.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 111.662 1.662L13.662 12l2.493 2.493z" fill="inherit"/></g></svg>`
    }, props));
$d090e6e9cc89e346$var$SelectClearIcon.displayName = 'SelectClearIcon';
var $d090e6e9cc89e346$var$_default = $d090e6e9cc89e346$var$SelectClearIcon;
module.exports.default = $d090e6e9cc89e346$var$_default;

});


parcelRegister("7HYS7", function(module, exports) {

$parcel$export(module.exports, "MultiValueRemove", () => $7fda2332979a5c13$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "IndicatorSeparator", () => $7fda2332979a5c13$export$bd638c2ba7915668);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $hUbUe = parcelRequire("hUbUe");

var $jQxSL = parcelRequire("jQxSL");

var $o2lI9 = parcelRequire("o2lI9");
function $7fda2332979a5c13$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7fda2332979a5c13$var$disabledStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $7fda2332979a5c13$var$enabledStyles = {
    name: "ck88l6",
    styles: "display:inherit"
};
const $7fda2332979a5c13$export$8e1fd1a40e7a2f4a = (props)=>{
    const { isDisabled: isDisabled } = props.selectProps;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).MultiValueRemove, props, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: isDisabled ? $7fda2332979a5c13$var$disabledStyles : $7fda2332979a5c13$var$enabledStyles,
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hUbUe))), {
        label: "Clear",
        size: "small",
        primaryColor: "transparent",
        secondaryColor: "inherit"
    })));
};
const $7fda2332979a5c13$export$bd638c2ba7915668 = null;

});

parcelRegister("bKJfr", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eba8612e97e7e89$export$2e2bcd8739ae039);

var $PdmhA = parcelRequire("PdmhA");

var $XHGTv = parcelRequire("XHGTv");
function $6eba8612e97e7e89$export$2e2bcd8739ae039(validationState, isCompact = false, appearance) {
    return {
        container: (css, { isDisabled: isDisabled })=>({
                ...css,
                ...(0, $XHGTv.getBooleanFF)('platform.design-system-team.select-new-typography_7m89c') ? {
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
                } : {
                    fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
                },
                // react-select disables pointer events when isDisabled is true.
                // We override this and make the inner container turn it off instead.
                pointerEvents: 'all',
                cursor: isDisabled ? 'not-allowed' : css.cursor
            }),
        input: (css)=>({
                ...css,
                color: "var(--ds-text, hsl(0, 0%, 20%))"
            }),
        control: (css, { isFocused: isFocused, isDisabled: isDisabled })=>{
            let borderColor = isFocused ? `var(--ds-border-focused, ${0, $PdmhA.B100})` : `var(--ds-border-input, ${0, $PdmhA.N100})`;
            let backgroundColor = isFocused ? `var(--ds-background-input-pressed, ${0, $PdmhA.N0})` : `var(--ds-background-input, ${0, $PdmhA.N20})`;
            let backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $PdmhA.N0})` : `var(--ds-background-input-hovered, ${0, $PdmhA.N30})`;
            if (isDisabled) {
                backgroundColor = `var(--ds-background-disabled, ${0, $PdmhA.N20})`;
                borderColor = `var(--ds-background-disabled, ${0, $PdmhA.N20})`;
            }
            if (validationState === 'error') borderColor = `var(--ds-border-danger, ${0, $PdmhA.R400})`;
            if (validationState === 'success') borderColor = `var(--ds-border-success, ${0, $PdmhA.G400})`;
            let borderColorHover = isFocused ? `var(--ds-border-focused, ${0, $PdmhA.B100})` : `var(--ds-border-input, ${0, $PdmhA.N100})`;
            if (validationState === 'error') borderColorHover = `var(--ds-border-danger, ${0, $PdmhA.R400})`;
            if (validationState === 'success') borderColorHover = `var(--ds-border-success, ${0, $PdmhA.G400})`;
            const transitionDuration = '200ms';
            if (appearance === 'subtle') {
                borderColor = isFocused ? `var(--ds-border-focused, ${0, $PdmhA.B100})` : 'transparent';
                backgroundColor = isFocused ? `var(--ds-surface, ${0, $PdmhA.N0})` : 'transparent';
                backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $PdmhA.N0})` : `var(--ds-background-input-hovered, ${0, $PdmhA.N30})`;
            }
            if (appearance === 'none') {
                borderColor = 'transparent';
                backgroundColor = 'transparent';
                backgroundColorHover = 'transparent';
                borderColorHover = 'transparent';
            }
            return {
                ...css,
                // Turn pointer events off when disabled - this makes it so hover etc don't work.
                pointerEvents: isDisabled ? 'none' : undefined,
                backgroundColor: backgroundColor,
                borderColor: borderColor,
                borderStyle: 'solid',
                borderRadius: "var(--ds-border-radius-100, 3px)",
                borderWidth: "var(--ds-border-width, 1px)",
                boxShadow: validationState === 'error' ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
                '&:focus-within': {
                    boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
                },
                minHeight: isCompact ? 32 : 40,
                padding: 0,
                transition: `background-color ${transitionDuration} ease-in-out,
        border-color ${transitionDuration} ease-in-out`,
                '::-webkit-scrollbar': {
                    height: 8,
                    width: 8
                },
                '::-webkit-scrollbar-corner': {
                    display: 'none'
                },
                ':hover': {
                    '::-webkit-scrollbar-thumb': {
                        // scrollbars occur only if the user passes in a custom component with overflow: scroll
                        backgroundColor: 'rgba(0,0,0,0.2)'
                    },
                    cursor: 'pointer',
                    backgroundColor: backgroundColorHover,
                    borderColor: borderColorHover
                },
                '::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: 'rgba(0,0,0,0.4)'
                }
            };
        },
        valueContainer: (css)=>({
                ...css,
                paddingLeft: "var(--ds-space-075, 6px)",
                paddingRight: "var(--ds-space-075, 6px)",
                paddingBottom: isCompact ? 0 : 2,
                paddingTop: isCompact ? 0 : 2
            }),
        clearIndicator: (css)=>({
                ...css,
                color: `var(--ds-text-subtlest, ${0, $PdmhA.N70})`,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $PdmhA.N500})`
                }
            }),
        loadingIndicator: (css)=>({
                ...css,
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6
            }),
        dropdownIndicator: (css, { isDisabled: isDisabled })=>{
            let color = `var(--ds-text-subtle, ${(0, $PdmhA.N500)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $PdmhA.N70})`;
            return {
                ...css,
                color: color,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $PdmhA.N200})`
                }
            };
        },
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        option: (css, { isFocused: isFocused, isSelected: isSelected, isDisabled: isDisabled })=>{
            let color = `var(--ds-text, ${(0, $PdmhA.N800)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $PdmhA.N70})`;
            else if (isSelected) color = `var(--ds-text-selected, ${0, $PdmhA.B400})`;
            let boxShadow;
            let backgroundColor;
            if (isDisabled) backgroundColor = undefined;
            else if (isSelected && isFocused) backgroundColor = `var(--ds-background-selected-hovered, ${0, $PdmhA.B50})`;
            else if (isSelected) backgroundColor = `var(--ds-background-selected, ${0, $PdmhA.B50})`;
            else if (isFocused) backgroundColor = `var(--ds-background-neutral-subtle-hovered, ${0, $PdmhA.N20})`;
            if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${`var(--ds-border-selected, ${0, $PdmhA.B400})`}`;
            const cursor = isDisabled ? 'not-allowed' : css.cursor;
            return {
                ...css,
                padding: '6px 12px',
                backgroundColor: backgroundColor,
                color: color,
                cursor: cursor,
                boxShadow: boxShadow,
                ':active': {
                    backgroundColor: !isDisabled ? isSelected ? `var(--ds-background-selected-pressed, ${0, $PdmhA.N20})` : `var(--ds-background-neutral-subtle-pressed, ${0, $PdmhA.N30})` : undefined
                },
                '@media screen and (-ms-high-contrast: active)': {
                    borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
                }
            };
        },
        placeholder: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $PdmhA.N300})` : `var(--ds-text-subtlest, ${0, $PdmhA.N200})`
            }),
        singleValue: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $PdmhA.N70})` : `var(--ds-text, ${0, $PdmhA.N800})`,
                ...!(0, $XHGTv.getBooleanFF)('platform.design-system-team.select-new-typography_7m89c') && {
                    lineHeight: '1rem'
                }
            }),
        menu: (css)=>({
                ...css,
                backgroundColor: "var(--ds-surface-overlay, white)",
                boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
            }),
        menuList: (css)=>({
                ...css,
                paddingTop: "var(--ds-space-100, 8px)",
                paddingBottom: "var(--ds-space-100, 8px)"
            }),
        multiValue: (css, { isDisabled: isDisabled, isFocused: isFocused })=>{
            let backgroundColor;
            let color;
            if (isDisabled) {
                // Use the basic neutral background so it is slightly separate from the
                // field's background
                backgroundColor = `var(--ds-background-neutral, ${0, $PdmhA.N40})`;
                color = `var(--ds-text-disabled, ${0, $PdmhA.N70})`;
            } else if (isFocused) {
                backgroundColor = `var(--ds-background-selected, ${0, $PdmhA.N40})`;
                color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
            } else {
                backgroundColor = `var(--ds-background-neutral, ${0, $PdmhA.N40})`;
                color = "var(--ds-text, hsl(0, 0%, 20%))";
            }
            return {
                ...css,
                borderRadius: "var(--ds-border-radius-050, 2px)",
                backgroundColor: backgroundColor,
                boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
                maxWidth: '100%',
                '@media screen and (-ms-high-contrast: active)': {
                    border: isFocused ? '1px solid transparent' : 'none'
                },
                color: color
            };
        },
        multiValueLabel: (css, { isDisabled: isDisabled })=>({
                ...css,
                padding: "var(--ds-space-025, 2px)",
                color: isDisabled ? `var(--ds-text-disabled, ${0, $PdmhA.N70})` : 'inherit',
                paddingRight: "var(--ds-space-025, 2px)"
            }),
        multiValueRemove: (css, { isFocused: isFocused })=>({
                ...css,
                backgroundColor: isFocused ? `var(--ds-UNSAFE-transparent, ${0, $PdmhA.R75})` : undefined,
                fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                borderRadius: '0px 2px 2px 0px',
                // DSP-6470 we should style like Tag once we have the :has selector
                ':hover': {
                    backgroundColor: `var(--ds-background-danger-hovered, ${0, $PdmhA.R75})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ':active': {
                    backgroundColor: `var(--ds-background-danger-pressed, ${0, $PdmhA.R75})`,
                    fill: "var(--ds-text-danger, #000)"
                }
            }),
        groupHeading: (css)=>({
                ...css,
                ...(0, $XHGTv.getBooleanFF)('platform.design-system-team.select-new-typography_7m89c') && {
                    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
                },
                color: `var(--ds-text-subtle, ${0, $PdmhA.N200})`
            })
    };
}

});

parcelRegister("lT14u", function(module, exports) {

$parcel$export(module.exports, "onFocus", () => $7ccc5140c845bc58$export$ecf9bf35ad97eb74);
$parcel$export(module.exports, "isOptionsGrouped", () => $7ccc5140c845bc58$export$d2756249f53f9f8);
function $7ccc5140c845bc58$export$ecf9bf35ad97eb74(props) {
    const { focused: focused, options: options } = props;
    const isOptionFocused = (option)=>{
        return option === focused;
    };
    const groupData = options?.find((option)=>{
        return option.options?.some(isOptionFocused);
    });
    const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
    return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
}
const $7ccc5140c845bc58$export$d2756249f53f9f8 = (arr)=>{
    return arr?.every((obj)=>obj.hasOwnProperty('options'));
};

});



parcelRegister("3x4sL", function(module, exports) {

$parcel$export(module.exports, "FormattedI18nMessage", () => $88ddecd12f0773cd$export$200d7bd7633253ce);

var $eUqFw = parcelRequire("eUqFw");

var $dO2kc = parcelRequire("dO2kc");

var $6nVYw = parcelRequire("6nVYw");
const $88ddecd12f0773cd$export$200d7bd7633253ce = (props)=>{
    const { message: message, packageName: packageName, componentsMapping: componentsMapping } = props;
    const messageParts = (0, $eUqFw.useMemo)(()=>{
        const { tags: tags, openTags: openTags, closeTags: closeTags } = (0, $6nVYw.getTags)(componentsMapping);
        try {
            const parts = [];
            let token = '';
            let TagComponent;
            let closeTagLookup;
            for(let i = 0; i < message.length; i += 1){
                const letter = message[i];
                token += letter;
                if ((0, $6nVYw.isCloseTagDelimiter)(letter)) {
                    const firstTagFound = (0, $6nVYw.findTag)(token, {
                        tags: openTags
                    });
                    if (firstTagFound !== null && firstTagFound !== undefined) {
                        // if we have a tag already means it is a malformed message since it is 2 subsequent open tags
                        if (TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                        const text = token.replace(firstTagFound, '');
                        parts.push(text);
                        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
                        const tagInfo = tags[firstTagFound];
                        TagComponent = tagInfo.component;
                        closeTagLookup = tagInfo.close;
                        token = '';
                    }
                }
                if (closeTagLookup !== null && closeTagLookup !== undefined && (0, $6nVYw.isCloseTagDelimiter)(letter) && (0, $6nVYw.isAnyTag)(token, {
                    tags: [
                        closeTagLookup
                    ]
                })) {
                    // this mean that we do not have an open tag for this closing tag
                    if (!TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                    const text = token.replace(closeTagLookup, '');
                    parts.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TagComponent, null, text));
                    TagComponent = undefined;
                    token = '';
                    closeTagLookup = undefined;
                }
                if ((0, $6nVYw.isCloseTagDelimiter)(letter) && (0, $6nVYw.isAnyTag)(token, {
                    tags: closeTags
                })) {
                    // if we do not have an open tag mean we are closing a tag that is not open
                    if (!TagComponent) throw new (0, $dO2kc.MalformedMessageError)();
                }
            }
            // if we reached the end and we have an open tag, mean this message is malformed
            if (TagComponent || closeTagLookup) throw new (0, $dO2kc.MalformedMessageError)();
            // flush anything we keep in the current token
            if (token.length > 0) parts.push(token);
            return parts;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e instanceof (0, $dO2kc.MalformedMessageError)) {
                (0, $dO2kc.logMalformedMessageError)({
                    message: message,
                    packageName: packageName
                });
                return [
                    (0, $dO2kc.getMalformedMessage)({
                        message: message,
                        closeTags: closeTags,
                        openTags: openTags
                    })
                ];
            }
            throw e;
        }
    }, [
        message,
        packageName,
        componentsMapping
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, messageParts.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), {
            key: index
        }, item)));
};

});
parcelRegister("dO2kc", function(module, exports) {

$parcel$export(module.exports, "getMalformedMessage", () => $1a42e2705665fc85$export$f085cf20ec1f69ab);
$parcel$export(module.exports, "logMalformedMessageError", () => $1a42e2705665fc85$export$954c3e6aad1c9429);
$parcel$export(module.exports, "MalformedMessageError", () => $1a42e2705665fc85$export$40d900e818b9630e);

var $gUUjF = parcelRequire("gUUjF");

var $guiFP = parcelRequire("guiFP");

const $1a42e2705665fc85$export$f085cf20ec1f69ab = ({ message: message, openTags: openTags, closeTags: closeTags })=>[
        ...openTags,
        ...closeTags
    ].reduce((acc, tag)=>acc.replace(new RegExp(tag, 'g'), ''), message);
const $1a42e2705665fc85$export$954c3e6aad1c9429 = ({ message: message, packageName: packageName })=>{
    if (packageName !== null && packageName !== undefined) {
        const errorMessage = `Malformed message: ${message}`;
        // Send error log to analytics pipeline (i.e. SFX) and Sentry
        (0, $guiFP.default)({
            meta: {
                packageName: packageName,
                id: (0, $376af31d5cd90f0d$export$f3390a0e172fee41)
            },
            attributes: {
                message: errorMessage
            }
        });
        // Send error log to Splunk
        const location = `${packageName}.${(0, $376af31d5cd90f0d$export$f3390a0e172fee41)}`;
        (0, $gUUjF.default).unsafeErrorWithCustomerData(location, errorMessage);
    }
};
class $1a42e2705665fc85$export$40d900e818b9630e extends Error {
    constructor(){
        super('Malformed i18n message');
    }
}

});
const $376af31d5cd90f0d$export$f3390a0e172fee41 = 'formattedI18NMessage';


parcelRegister("6nVYw", function(module, exports) {

$parcel$export(module.exports, "getTags", () => $ec16d76793463e9e$export$af63d7414243dad3);
$parcel$export(module.exports, "isAnyTag", () => $ec16d76793463e9e$export$38ffa64fc639355f);
$parcel$export(module.exports, "findTag", () => $ec16d76793463e9e$export$dfca0f74034f8657);
$parcel$export(module.exports, "isCloseTagDelimiter", () => $ec16d76793463e9e$export$d5170904651e91b1);

const $ec16d76793463e9e$export$af63d7414243dad3 = (componentsMapping)=>Object.entries(componentsMapping).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (acc, [key, value])=>{
        const open = `{${key}Start}`;
        const close = `{${key}End}`;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        acc.tags[open] = {
            close: close,
            component: value
        };
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.openTags.push(open);
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.closeTags.push(close);
        return acc;
    }, {
        tags: {},
        openTags: [],
        closeTags: []
    });
const $ec16d76793463e9e$export$38ffa64fc639355f = (text, { tags: tags })=>tags.some((tag)=>text.includes(tag));
const $ec16d76793463e9e$export$dfca0f74034f8657 = (text, { tags: tags })=>tags.find((tag)=>text.includes(tag));
const $ec16d76793463e9e$export$d5170904651e91b1 = (letter)=>letter === (0, $a86f32165c278403$export$a10c567c3288a6b4);

});
const $a86f32165c278403$export$a10c567c3288a6b4 = '}';



parcelRegister("1WR91", function(module, exports) {

$parcel$export(module.exports, "Accordion", () => $d3beb0ac288d4f83$export$a766cd26d0d69044);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $86Ndv = parcelRequire("86Ndv");

var $dtaN9 = parcelRequire("dtaN9");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $2nryu = parcelRequire("2nryu");
const $d3beb0ac288d4f83$export$a766cd26d0d69044 = ({ children: children, heading: heading, expandedHeading: expandedHeading, infoHeading: infoHeading, infoDescription: infoDescription, onCloseClick: onCloseClick, testId: testId, shouldForceOpen: shouldForceOpen = false, ariaRoleDescription: ariaRoleDescription })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const handleClick = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'newProjectCreateMoreOptions'
        }));
        if (isOpen && onCloseClick) {
            onCloseClick();
            return;
        }
        setIsOpen(!isOpen);
    }, [
        createAnalyticsEvent,
        isOpen,
        onCloseClick
    ]);
    (0, $eUqFw.useEffect)(()=>{
        shouldForceOpen && setIsOpen(true);
    }, [
        shouldForceOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d3beb0ac288d4f83$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d3beb0ac288d4f83$var$HeadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        "aria-roledescription": ariaRoleDescription && formatMessage(ariaRoleDescription),
        isDisabled: shouldForceOpen,
        testId: testId,
        onClick: handleClick,
        appearance: "link",
        spacing: "none",
        iconBefore: isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
            label: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))), {
            label: ""
        })
    }, isOpen && expandedHeading ? formatMessage(expandedHeading) : formatMessage(heading)), infoHeading && infoDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2nryu.InfoButton), {
        heading: infoHeading,
        description: infoDescription
    })), isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d3beb0ac288d4f83$var$ChildrenWrapper, null, children));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d3beb0ac288d4f83$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d3beb0ac288d4f83$var$ChildrenWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _19pku2gc _4cvr1q9y _1bah1yb4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d3beb0ac288d4f83$var$HeadingWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _11381ns9 _18iz1h6o _15h61b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2nryu", function(module, exports) {

$parcel$export(module.exports, "InfoButton", () => $83460942afe4b809$export$10d4b9c1046c21df);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $2bv8J = parcelRequire("2bv8J");

var $3MV1G = parcelRequire("3MV1G");

var $PdmhA = parcelRequire("PdmhA");

var $c9TLT = parcelRequire("c9TLT");
const $83460942afe4b809$var$ICON_COLOR = `var(--ds-icon-discovery, ${(0, $PdmhA).P300})`;
const $83460942afe4b809$export$10d4b9c1046c21df = ({ heading: heading, description: description })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const onClose = (0, $eUqFw.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    const toggleIsOpen = (0, $eUqFw.useCallback)(()=>{
        setIsOpen(!isOpen);
    }, [
        isOpen
    ]);
    const getContent = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($83460942afe4b809$var$ContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($83460942afe4b809$var$Heading, null, heading), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, description)), [
        description,
        heading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        onClose: onClose,
        placement: "bottom-start",
        content: getContent,
        zIndex: (0, $c9TLT.layers).modal + 1,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...triggerProps,
                appearance: "link",
                spacing: "none",
                onClick: toggleIsOpen,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2bv8J))), {
                    size: "small",
                    label: "info",
                    primaryColor: $83460942afe4b809$var$ICON_COLOR
                }),
                testId: "project-create-importer-upload-flow.common.ui.info-button.button"
            })
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $83460942afe4b809$var$ContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41ejb _p12flti4",
            __cmplp.className
        ])
    });
});
const $83460942afe4b809$var$Heading = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48pni7l _otyru2gc",
            __cmplp.className
        ])
    });
});

});


parcelRegister("8Olbu", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f1e515c2bdf6e04$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1f1e515c2bdf6e04$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    heading: {
        "id": "project-create-importer-upload-flow.mapping-screen.mapping-advanced-options.heading",
        "defaultMessage": "Date and time format options"
    },
    dateAndTimeFormat: {
        "id": "project-create-importer-upload-flow.mapping-screen.mapping-advanced-options.date-and-time-format",
        "defaultMessage": "Date and time format"
    },
    locale: {
        "id": "project-create-importer-upload-flow.mapping-screen.mapping-advanced-options.locale",
        "defaultMessage": "Locale"
    },
    timezone: {
        "id": "project-create-importer-upload-flow.mapping-screen.mapping-advanced-options.timezone",
        "defaultMessage": "Timezone"
    },
    dateFormatEmpty: {
        "id": "project-create-importer-upload-flow.mapping-screen.mapping-advanced-options.date-format-empty",
        "defaultMessage": "Date and time format is required"
    },
    dateFormatHelperMessage: {
        "id": "project-create-importer-upload-flow.mapping-screen.mapping-advanced-options.date-format-helper-message",
        "defaultMessage": "e.g. dd/MMM/yy h:mm a"
    }
});

});


parcelRegister("hbUUM", function(module, exports) {

$parcel$export(module.exports, "UnmappedColumnsWarningModal", () => $f9c215789d6152e5$export$6ea8c055b0cdc099);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
var $dxopF = parcelRequire("dxopF");

var $1Yimi = parcelRequire("1Yimi");

var $iv47I = parcelRequire("iv47I");
const $f9c215789d6152e5$export$6ea8c055b0cdc099 = ({ isModalOpen: isModalOpen, onContinue: onContinue, onCancel: onCancel, offsetModalY: offsetModalY })=>{
    const { title: title, description: description, nextButtonText: nextButtonText, cancelButtonText: cancelButtonText } = (0, $iv47I.useContent)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onClose: onCancel,
        stackIndex: (offsetModalY || 0) / 8
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), {
        appearance: "warning"
    }, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "p"
    }, description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        onClick: onCancel
    }, cancelButtonText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "warning",
        onClick: onContinue,
        autoFocus: true
    }, nextButtonText))));
};

});
parcelRegister("iv47I", function(module, exports) {

$parcel$export(module.exports, "useContent", () => $805ea99ff5261238$export$ee83783e2ce4cc63);

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lUC5l = parcelRequire("lUC5l");

var $lUC5l = parcelRequire("lUC5l");

var $aHeOv = parcelRequire("aHeOv");
const $805ea99ff5261238$export$ee83783e2ce4cc63 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [numVisibleUnmappedColumns] = (0, $lUC5l.useNumVisibleUnmappedColumns)();
    const [numUnmappedColumnsIncludedSelector] = (0, $lUC5l.useNumUnmappedColumnsIncluded)();
    if ((0, $eI5EY.fg)('enable-x2c-standardised-flow')) return {
        title: formatMessage((0, $aHeOv.default).titleStandard, {
            count: numUnmappedColumnsIncludedSelector
        }),
        description: formatMessage((0, $aHeOv.default).descriptionStandard, {
            b: (content)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, content)
        }),
        nextButtonText: formatMessage((0, $aHeOv.default).excludeFromImport),
        cancelButtonText: formatMessage((0, $aHeOv.default).cancel)
    };
    return {
        title: formatMessage((0, $aHeOv.default).title),
        description: formatMessage((0, $aHeOv.default).description, {
            count: numVisibleUnmappedColumns
        }),
        nextButtonText: formatMessage((0, $aHeOv.default).continue),
        cancelButtonText: formatMessage((0, $aHeOv.default).cancel)
    };
};

});
parcelRegister("aHeOv", function(module, exports) {

$parcel$export(module.exports, "default", () => $72668364eb27f8f3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $72668364eb27f8f3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "project-create-importer-upload-flow.mapping-screen.unmapped-columns-warning-modal.title",
        "defaultMessage": "Exclude columns from your import"
    },
    description: {
        "id": "project-create-importer-upload-flow.mapping-screen.unmapped-columns-warning-modal.description",
        "defaultMessage": "{count, plural, one {# column hasn't been mapped to a field and will be excluded from your import. To include it, go back and map this column to a field.} other {# columns haven't been mapped to a field and will be excluded from your import. To include them, go back and map these columns to a field.}}"
    },
    cancel: {
        "id": "project-create-importer-upload-flow.mapping-screen.unmapped-columns-warning-modal.cancel",
        "defaultMessage": "Go back"
    },
    continue: {
        "id": "project-create-importer-upload-flow.mapping-screen.unmapped-columns-warning-modal.continue",
        "defaultMessage": "Import"
    },
    titleStandard: {
        "id": "project-create-importer-upload-flow.mapping-screen.unmapped-columns-warning-modal.title-standard",
        "defaultMessage": "{count, plural, one {# column is not mapped} other {# columns are not mapped}}"
    },
    descriptionStandard: {
        "id": "project-create-importer-upload-flow.mapping-screen.unmapped-columns-warning-modal.description-standard",
        "defaultMessage": "Some columns from the CSV file are not mapped to Jira fields. To include them in the import, go back and map these columns to the appropriate Jira fields. Select the <b>All fields</b> dropdown for filtering options."
    },
    excludeFromImport: {
        "id": "project-create-importer-upload-flow.mapping-screen.unmapped-columns-warning-modal.exclude-from-import",
        "defaultMessage": "Exclude from Import"
    }
});

});



parcelRegister("eZ21r", function(module, exports) {

$parcel$export(module.exports, "useMappings", () => $702b9740fdf0026d$export$3f488c5eecd87706);

var $eUqFw = parcelRequire("eUqFw");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $9HsT0 = parcelRequire("9HsT0");

var $bLalW = parcelRequire("bLalW");
var $aEdcH = parcelRequire("aEdcH");
var $lUC5l = parcelRequire("lUC5l");
var $4uta0 = parcelRequire("4uta0");
var $d0wrd = parcelRequire("d0wrd");
var $2sRUp = parcelRequire("2sRUp");

var $iLEk6 = parcelRequire("iLEk6");
const $702b9740fdf0026d$export$3f488c5eecd87706 = ()=>{
    const [source] = (0, $2sRUp.useSource)();
    const [serviceName] = (0, $aEdcH.useImportType)();
    const { isLoading: isLoading, hasErrorOccurred: hasErrorOccurred, errorCode: errorCode, readCSVPreview: readCSVPreview } = (0, $iLEk6.useReadCSVPreview)(source, serviceName);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [projectData] = (0, $d0wrd.useProjectData)();
    const [migrationId] = (0, $4uta0.useMigrationId)();
    const [mappingState, { setMappingState: setMappingState, setMappingStateValidationError: setMappingStateValidationError, setUnmappedColumnsNotIncluded: setUnmappedColumnsNotIncluded }] = (0, $lUC5l.useMappingState)();
    const [advancedOptions, { updateAdvancedOptions: updateAdvancedOptions }] = (0, $bLalW.useAdvancedOptions)();
    const onReadCSV = (0, $eUqFw.useCallback)(()=>{
        if (migrationId !== null && mappingState === null) readCSVPreview(migrationId, advancedOptions, projectData).then((resp)=>{
            if (!resp) {
                setMappingState(null);
                return;
            }
            const { suggestedDateFormat: suggestedDateFormat, ...state } = resp;
            setMappingState(state);
            updateAdvancedOptions({
                dateFormat: suggestedDateFormat || (0, $9HsT0.DEFAULT_DATE_FORMAT)
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'csvFile read', {
                numberOfColumns: Object.keys(state.columns).length,
                numberOfMappedJiraFields: state.mappedJiraFieldIds.size,
                numberOfRows: state.rows.length,
                projectType: projectData.type,
                projectStyle: projectData.style,
                accessLevel: projectData.accessLevel
            });
        });
    }, [
        migrationId,
        mappingState,
        readCSVPreview,
        advancedOptions,
        projectData,
        setMappingState,
        updateAdvancedOptions,
        createAnalyticsEvent
    ]);
    (0, $eUqFw.useEffect)(()=>{
        onReadCSV();
    }, [
        onReadCSV
    ]);
    return {
        isLoading: isLoading,
        hasErrorOccurred: hasErrorOccurred,
        mappingState: mappingState,
        errorCode: errorCode,
        onRefresh: onReadCSV,
        setMappingStateValidationError: setMappingStateValidationError,
        setUnmappedColumnsNotIncluded: setUnmappedColumnsNotIncluded
    };
};

});
parcelRegister("iLEk6", function(module, exports) {

$parcel$export(module.exports, "useReadCSVPreview", () => $6640dfa2d68862aa$export$89382e1e0a8c406d);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $2OdyW = parcelRequire("2OdyW");

var $gyZoj = parcelRequire("gyZoj");
var $cpweK = parcelRequire("cpweK");
var $5GSA7 = parcelRequire("5GSA7");

var $dWLk9 = parcelRequire("dWLk9");

var $kzTj7 = parcelRequire("kzTj7");

var $3yuWi = parcelRequire("3yuWi");

var $aWLVm = parcelRequire("aWLVm");

var $jNdPf = parcelRequire("jNdPf");

var $il2VC = parcelRequire("il2VC");

var $89SXi = parcelRequire("89SXi");
const $6640dfa2d68862aa$var$getX2CFetchCSVPreview = (cloudId, migrationId)=>`${0, $gyZoj.X2C_SERVICE_URL_PREFIX}/${cloudId}/import/csv/${migrationId}/preview`;
const $6640dfa2d68862aa$export$66479cd52bb9bdb9 = (cloudId, migrationId, advancedOptions, projectData)=>(0, $2OdyW.default)($6640dfa2d68862aa$var$getX2CFetchCSVPreview(cloudId, migrationId), {
        method: 'POST',
        body: JSON.stringify({
            fileEncoding: advancedOptions.fileEncoding.trim(),
            delimiter: advancedOptions.delimiter,
            dateProperties: (0, $aWLVm.transformToDateProperties)(advancedOptions),
            projectDetails: {
                type: projectData.type,
                style: projectData.style,
                template: projectData.template
            }
        }),
        headers: {
            'x-issynthetic-traffic': String((0, $cpweK.isSynthetic)())
        }
    });
const $6640dfa2d68862aa$export$89382e1e0a8c406d = (source, serviceName)=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const [onExperienceStart, onExperienceSuccess, onExperienceFail] = (0, $5GSA7.useExperienceTracker)((0, $3yuWi.EXPERIENCES).READ_CSV);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [hasErrorOccurred, setHasErrorOccurred] = (0, $eUqFw.useState)(false);
    const [errorCode, setErrorCode] = (0, $eUqFw.useState)(null);
    const analtyticsAttributes = (0, $jNdPf.useAnalyticsAttributesContext)();
    const client = (0, $il2VC.useGetCSVImportClient)(source, serviceName);
    const readCSVPreview = (0, $eUqFw.useCallback)(async (migrationId, advancedOptions, projectData)=>{
        setIsLoading(true);
        setHasErrorOccurred(false);
        (0, $3yuWi.readCSVInteractionMetric).start();
        onExperienceStart();
        try {
            let csvData;
            if ((0, $1ybV0.ff)('enable-importing-data-to-existing-project_k8uub')) csvData = await client.getPreview({
                migrationId: migrationId,
                advancedOptions: advancedOptions,
                projectData: projectData
            });
            else csvData = await $6640dfa2d68862aa$export$66479cd52bb9bdb9(cloudId, migrationId, advancedOptions, projectData);
            (0, $3yuWi.readCSVInteractionMetric).stop();
            onExperienceSuccess({
                migrationId: migrationId,
                ...analtyticsAttributes
            });
            setIsLoading(false);
            return (0, $89SXi.transformToMappingStateWithSuggestedDateFormat)(csvData);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $3yuWi.readCSVInteractionMetric).stop();
            onExperienceFail((0, $kzTj7.APP_IDENTIFIER), error, {
                migrationId: migrationId,
                ...analtyticsAttributes
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'read-csv-error',
                    packageName: (0, $kzTj7.APP_IDENTIFIER),
                    teamName: (0, $gyZoj.APP_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true,
                error: error
            });
            setHasErrorOccurred(true);
            setIsLoading(false);
            setErrorCode(error.statusCode);
            return null;
        }
    }, [
        analtyticsAttributes,
        client,
        cloudId,
        onExperienceFail,
        onExperienceStart,
        onExperienceSuccess
    ]);
    return {
        isLoading: isLoading,
        hasErrorOccurred: hasErrorOccurred,
        errorCode: errorCode,
        readCSVPreview: readCSVPreview
    };
};

});
parcelRegister("89SXi", function(module, exports) {

$parcel$export(module.exports, "transformToMappingStateWithSuggestedDateFormat", () => $e0106098e8140f34$export$1a63abbffd03bc12);

var $agB2z = parcelRequire("agB2z");
const $e0106098e8140f34$export$103e67a903597028 = (columns)=>{
    const columnMap = {};
    columns.forEach((column)=>{
        columnMap[column.columnName] = {
            ...column,
            isVisible: true,
            isIncluded: true
        };
    });
    return columnMap;
};
const $e0106098e8140f34$export$517542a6c818e8ea = (columns)=>columns.map((column)=>column.columnName);
const $e0106098e8140f34$export$ffce50d7e98a8c92 = (columns)=>new Set(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    columns.filter((col)=>!!col.field?.fieldId).map((col)=>col.field?.fieldId));
const $e0106098e8140f34$export$4edd2e25fddc0d05 = (availableIssueLinks)=>availableIssueLinks ? availableIssueLinks.map((issueLink)=>({
            fieldName: issueLink.linkName,
            fieldType: (0, $agB2z.ISSUE_LINKS_FIELDTYPE),
            fieldId: issueLink.linkId,
            fieldDirection: issueLink.linkDirection
        })) : [];
const $e0106098e8140f34$export$1a63abbffd03bc12 = ({ columns: columns, rows: rows, availableNewFieldTypes: availableNewFieldTypes, availableJiraFields: availableJiraFields, availableIssueLinks: availableIssueLinks, suggestedDateFormat: suggestedDateFormat })=>{
    const mappedJiraFieldIds = $e0106098e8140f34$export$ffce50d7e98a8c92(columns);
    return {
        columnOrder: $e0106098e8140f34$export$517542a6c818e8ea(columns),
        columns: $e0106098e8140f34$export$103e67a903597028(columns),
        rows: rows,
        availableNewFieldTypes: availableNewFieldTypes,
        availableJiraFields: availableJiraFields,
        availableIssueLinkFields: $e0106098e8140f34$export$4edd2e25fddc0d05(availableIssueLinks),
        mappedJiraFieldIds: mappedJiraFieldIds,
        validationError: null,
        suggestedDateFormat: suggestedDateFormat,
        selectedColumn: undefined,
        userMapping: null,
        shouldImportUsers: true,
        issueCount: null,
        errorsFilter: null,
        preMappedFieldCount: mappedJiraFieldIds.size,
        mappedLinkFieldsCount: 0,
        preFilledUsersCount: 0
    };
};

});



parcelRegister("iuOqp", function(module, exports) {

$parcel$export(module.exports, "ValidationError", () => $1f8bc71ecb521c13$export$2191b9da168c6cf0);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $lRvnl = parcelRequire("lRvnl");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $kzTj7 = parcelRequire("kzTj7");

var $agB2z = parcelRequire("agB2z");

var $aWLVm = parcelRequire("aWLVm");

var $lUC5l = parcelRequire("lUC5l");

var $9HAAd = parcelRequire("9HAAd");

var $a1fOf = parcelRequire("a1fOf");
const $1f8bc71ecb521c13$export$2191b9da168c6cf0 = ({ showLearnMoreLink: showLearnMoreLink })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [mappingState] = (0, $lUC5l.useMappingState)();
    const { getValidationErrorMessage: getValidationErrorMessage } = (0, $aWLVm.useGetValidationErrorMessage)();
    const { issueLinkingColumnErrors: issueLinkingColumnErrors, otherColumnErrors: otherColumnErrors } = (0, $aWLVm.getColumnErrors)(mappingState);
    const { columnErrors: columnErrors, missingErrors: missingErrors, count: count } = (0, $a1fOf.useValidationErrors)(mappingState);
    const getColumnError = (0, $eUqFw.useCallback)(([name, errorType])=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1f8bc71ecb521c13$var$ListItem, {
            key: name
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1f8bc71ecb521c13$var$LightBold, null, mappingState?.columns[name].field?.fieldName, ":"), ' ', getValidationErrorMessage(errorType, true)), [
        getValidationErrorMessage,
        mappingState?.columns
    ]);
    const getOtherColumnErrors = (0, $eUqFw.useCallback)(()=>{
        if (Object.keys(otherColumnErrors).length === 0) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            values: {
                heading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1f8bc71ecb521c13$var$Bold, null, formatMessage((0, $9HAAd.default).columnErrorsHeading))
            },
            ...(0, $9HAAd.default).columnErrors
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1f8bc71ecb521c13$var$List, null, Object.entries(otherColumnErrors).map(getColumnError)));
    }, [
        formatMessage,
        getColumnError,
        otherColumnErrors
    ]);
    const getIssueLinkingColumnError = (0, $eUqFw.useCallback)(()=>Object.keys(issueLinkingColumnErrors).map((name)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", {
                key: name
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                values: {
                    heading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1f8bc71ecb521c13$var$Bold, null, formatMessage((0, $9HAAd.default).issueLinkingColumnErrorHeading, {
                        name: name
                    }))
                },
                ...(0, $9HAAd.default).issueLinkingColumnError
            }))), [
        formatMessage,
        issueLinkingColumnErrors
    ]);
    const getMissingFieldErrors = (0, $eUqFw.useCallback)(()=>{
        if (!(0, $aWLVm.hasMissingFields)(mappingState)) return null;
        const isIssueLinksSelected = (0, $1ybV0.ff)('x2c-issuelinking-frontend_tuyzk') ? !!mappingState && mappingState.availableIssueLinkFields.some((issueLinkField)=>!!issueLinkField.fieldId && mappingState.mappedJiraFieldIds.has(issueLinkField.fieldId)) : false;
        return mappingState?.validationError?.missingFields.map((fieldId)=>{
            const missingField = (0, $a1fOf.getMissingFieldName)(fieldId, mappingState);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", {
                key: fieldId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                values: {
                    heading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1f8bc71ecb521c13$var$Bold, null, fieldId === (0, $agB2z.ISSUEID_FIELDTYPE) && isIssueLinksSelected ? formatMessage((0, $9HAAd.default).missingIssueIdHeading) : formatMessage((0, $9HAAd.default).missingFieldHeading, {
                        missingField: missingField
                    })),
                    missingField: missingField,
                    isIssueId: fieldId === 'issueId',
                    isIssueLinksSelected: isIssueLinksSelected
                },
                ...(0, $9HAAd.default).missingField
            }));
        });
    }, [
        formatMessage,
        mappingState
    ]);
    if ((0, $eI5EY.fg)('enable-x2c-standardised-flow')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $1f8bc71ecb521c13$var$sectionWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        testId: "project-create-importer-upload-flow.ui.mapping-screen.validation-error.section-message",
        appearance: "error",
        title: formatMessage((0, $9HAAd.default).titleStandard, {
            count: count
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $1f8bc71ecb521c13$var$contentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "ol",
        xcss: $1f8bc71ecb521c13$var$listStyle
    }, missingErrors.map((message, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            as: "li",
            key: index
        }, message)), columnErrors.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "li"
    }, formatMessage((0, $9HAAd.default).formattingErrorHeading, {
        b: (0, $a1fOf.boldElement)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "ol",
        xcss: $1f8bc71ecb521c13$var$sublistStyle
    }, columnErrors.map((column)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            as: "li",
            key: column
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            as: "b"
        }, column)))))))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $1f8bc71ecb521c13$var$sectionWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        testId: "project-create-importer-upload-flow.ui.mapping-screen.validation-error.section-message",
        appearance: "error",
        title: formatMessage((0, $9HAAd.default).validationErrorTitle)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1f8bc71ecb521c13$var$ContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1f8bc71ecb521c13$var$OrderedList, {
        "data-testid": "project-create-importer-upload-flow.ui.mapping-screen.validation-error.list"
    }, getMissingFieldErrors(), getOtherColumnErrors(), getIssueLinkingColumnError()), showLearnMoreLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1f8bc71ecb521c13$var$LearnMore, {
        href: (0, $kzTj7.LEARN_MORE_LINK),
        target: "_blank"
    }, formatMessage((0, $9HAAd.default).learnMoreSpork)))));
};
const $1f8bc71ecb521c13$var$contentStyles = (0, $1ZAYh.xcss)({
    maxHeight: '10vh',
    overflowY: 'auto'
});
const $1f8bc71ecb521c13$var$listStyle = (0, $1ZAYh.xcss)({
    paddingLeft: 'space.200'
});
const $1f8bc71ecb521c13$var$sublistStyle = (0, $1ZAYh.xcss)({
    paddingLeft: 'space.200',
    listStyleType: 'lower-alpha'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1f8bc71ecb521c13$var$OrderedList = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "ol", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19bvpxbi _otyrpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1f8bc71ecb521c13$var$List = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1f8bc71ecb521c13$var$ListItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_qtt81vji",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1f8bc71ecb521c13$var$Bold = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48p8n31",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1f8bc71ecb521c13$var$LightBold = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48pbfng",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1f8bc71ecb521c13$var$LearnMore = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz11ce",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1f8bc71ecb521c13$var$ContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_c71ldvcx _18m91wug",
            __cmplp.className
        ])
    });
});
const $1f8bc71ecb521c13$var$sectionWrapperStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.300'
});

});
parcelRegister("9HAAd", function(module, exports) {

$parcel$export(module.exports, "default", () => $713a0b851197e9af$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $713a0b851197e9af$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    validationErrorTitle: {
        "id": "project-create-importer-upload-flow.mapping-screen.validation-error.validation-error-title",
        "defaultMessage": "We found errors in your import"
    },
    learnMoreSpork: {
        "id": "project-create-importer-upload-flow.mapping-screen.validation-error.learn-more-spork",
        "defaultMessage": "Learn more about importing data into Jira"
    },
    columnErrorsHeading: {
        "id": "project-create-importer-upload-flow.mapping-screen.validation-error.column-errors-heading",
        "defaultMessage": "Formatting error:"
    },
    columnErrors: {
        "id": "project-create-importer-upload-flow.mapping-screen.validation-error.column-errors",
        "defaultMessage": "{heading} The header used for the following columns must match the formatting style of the data in the column. Change to another field type or remove the field from import."
    },
    missingFieldHeading: {
        "id": "project-create-importer-upload-flow.mapping-screen.validation-error.missing-field-heading",
        "defaultMessage": "Missing required {missingField} field: "
    },
    issueLinkingColumnErrorHeading: {
        "id": "project-create-importer-upload-flow.mapping-screen.validation-error.issue-linking-column-error-heading",
        "defaultMessage": "Format issues in {name} column:"
    },
    issueLinkingColumnError: {
        "id": "project-create-importer-upload-flow.mapping-screen.validation-error.issue-linking-column-error",
        "defaultMessage": "{heading} The format only supports alphanumeric characters and hyphens. Check and remove unsupported characters to move ahead with the import."
    },
    missingIssueIdHeading: {
        "id": "project-create-importer-upload-flow.mapping-screen.validation-error.missing-issue-id-heading",
        "defaultMessage": "Missing issue ID column: "
    },
    missingField: {
        "id": "project-create-importer-upload-flow.mapping-screen.validation-error.missing-field",
        "defaultMessage": "{heading} {isIssueId, select, true {{isIssueLinksSelected, select, true {Issue links are dependent on issue IDs. Add the Issue ID column to your import to ensure issue links are imported} other {Parent fields are mapped to and dependent on an issue id. To create this relationship in your data add an issue id to one of your column headers}}} other {We map the information in that column to a task name. Add a {missingField} field to continue the import}}."
    },
    summaryMissing: {
        "id": "project-create-importer-upload-flow.mapping-screen.validation-error.summary-missing",
        "defaultMessage": "<b>Missing summary</b>: Summary is a required field in Jira. It can be the task name or an overview of a task. Map the summary field to a CSV column to proceed with the import."
    },
    issueIdMissing: {
        "id": "project-create-importer-upload-flow.mapping-screen.validation-error.issue-id-missing",
        "defaultMessage": "<b>Missing issue IDs</b>: Issue links are dependent on issue IDs. Add the issue ID column to your import to ensure issue links are imported."
    },
    emptySummary: {
        "id": "project-create-importer-upload-flow.mapping-screen.validation-error.empty-summary",
        "defaultMessage": "<b>Missing summary content</b>: One or more cells in the CSV column mapped to the summary field are empty. Summary is a required field. Make sure to fill in the missing content and begin the import once again."
    },
    formattingErrorHeading: {
        "id": "project-create-importer-upload-flow.mapping-screen.validation-error.formatting-error-heading",
        "defaultMessage": "<b>Formatting error</b>: The data in the following CSV columns must match the selected field\u2019s formatting style. Check and correct the format in the CSV column before restarting the import or remove the column from import."
    },
    titleStandard: {
        "id": "project-create-importer-upload-flow.mapping-screen.validation-error.title-standard",
        "defaultMessage": "{count, plural, one {We found # error in your import} other {We found # errors in your import}}"
    }
});

});

parcelRegister("a1fOf", function(module, exports) {

$parcel$export(module.exports, "boldElement", () => $35fdbf787a5c1a10$export$984afab09d2e53ec);
$parcel$export(module.exports, "getMissingFieldName", () => $35fdbf787a5c1a10$export$5d335b5e1e468108);
$parcel$export(module.exports, "useValidationErrors", () => $35fdbf787a5c1a10$export$21f4cb7da25144ed);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dc4s1 = parcelRequire("dc4s1");

var $9HAAd = parcelRequire("9HAAd");
const $35fdbf787a5c1a10$var$SUMMARY = 'summary';
const $35fdbf787a5c1a10$var$ISSUEID = 'issueId';
const $35fdbf787a5c1a10$export$984afab09d2e53ec = (content)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, content);
const $35fdbf787a5c1a10$export$5d335b5e1e468108 = (fieldId, mappingState)=>mappingState?.availableJiraFields.find((field)=>field?.fieldId === fieldId)?.fieldName.toLowerCase() || fieldId;
const $35fdbf787a5c1a10$export$21f4cb7da25144ed = (mappingState)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const columnErrorMap = mappingState?.validationError?.columnErrors || {};
    const missingFields = mappingState?.validationError?.missingFields || [];
    const missingErrorMap = (0, $eUqFw.useMemo)(()=>({
            [$35fdbf787a5c1a10$var$SUMMARY]: formatMessage((0, $9HAAd.default).summaryMissing, {
                b: $35fdbf787a5c1a10$export$984afab09d2e53ec
            }),
            [$35fdbf787a5c1a10$var$ISSUEID]: formatMessage((0, $9HAAd.default).issueIdMissing, {
                b: $35fdbf787a5c1a10$export$984afab09d2e53ec
            }),
            [(0, $dc4s1.EMPTY_SUMMARY)]: formatMessage((0, $9HAAd.default).emptySummary, {
                b: $35fdbf787a5c1a10$export$984afab09d2e53ec
            })
        }), [
        formatMessage
    ]);
    const missingErrors = missingFields.map((error)=>missingErrorMap[error]);
    if (Object.values(columnErrorMap || []).includes((0, $dc4s1.EMPTY_SUMMARY))) missingErrors.push(missingErrorMap[0, $dc4s1.EMPTY_SUMMARY]);
    const columnErrors = Object.keys(columnErrorMap).filter((key)=>columnErrorMap[key] !== (0, $dc4s1.EMPTY_SUMMARY));
    return {
        missingErrors: missingErrors,
        columnErrors: columnErrors,
        count: missingErrors.length + columnErrors.length
    };
};

});



parcelRegister("5MhMl", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c7e3637c71b813f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
parcelRequire("9vHOT");
var $1AUfu = parcelRequire("1AUfu");
var $5rVGx = parcelRequire("5rVGx");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $ltfxy = parcelRequire("ltfxy");

var $4Bees = parcelRequire("4Bees");

var $PdmhA = parcelRequire("PdmhA");

var $7eqzD = parcelRequire("7eqzD");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $8UvJe = parcelRequire("8UvJe");

var $43pn3 = parcelRequire("43pn3");

var $9HsT0 = parcelRequire("9HsT0");

var $aWLVm = parcelRequire("aWLVm");

var $bLalW = parcelRequire("bLalW");
var $lUC5l = parcelRequire("lUC5l");
var $4uta0 = parcelRequire("4uta0");
var $d0wrd = parcelRequire("d0wrd");

var $2sRUp = parcelRequire("2sRUp");

var $cTFYy = parcelRequire("cTFYy");

var $iLEk6 = parcelRequire("iLEk6");

var $ji4el = parcelRequire("ji4el");

var $jrj5D = parcelRequire("jrj5D");
const $0c7e3637c71b813f$var$HEADER_HEIGHT = 64;
const $0c7e3637c71b813f$var$MappingTable = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [source] = (0, $2sRUp.useSource)();
    const { isLoading: isLoading, hasErrorOccurred: hasErrorOccurred, readCSVPreview: readCSVPreview } = (0, $iLEk6.useReadCSVPreview)(source);
    const { data: priorities, isLoading: isPrioritiesLoading } = (0, $cTFYy.useGetPriorities)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const tableRef = (0, $eUqFw.useRef)(null);
    const [projectData] = (0, $d0wrd.useProjectData)();
    const [migrationId] = (0, $4uta0.useMigrationId)();
    const [mappingState, { setMappingState: setMappingState, setNextSelectedColumn: setNextSelectedColumn }] = (0, $lUC5l.useMappingState)();
    const [advancedOptions, { updateAdvancedOptions: updateAdvancedOptions }] = (0, $bLalW.useAdvancedOptions)();
    const [columnWidths, setColumnWidths] = (0, $eUqFw.useState)({});
    const columns = (0, $eUqFw.useMemo)(()=>(0, $jrj5D.getTableColumns)(mappingState, columnWidths, priorities), [
        columnWidths,
        mappingState,
        priorities
    ]);
    const [{ nudgeStep: nudgeStep }] = (0, $8UvJe.useX2CNudgeStep)();
    const onReadCSV = (0, $eUqFw.useCallback)(()=>{
        if (migrationId !== null && mappingState === null) readCSVPreview(migrationId, advancedOptions, projectData).then((resp)=>{
            if (!resp) {
                setMappingState(null);
                return;
            }
            const { suggestedDateFormat: suggestedDateFormat, ...state } = resp;
            setMappingState(state);
            updateAdvancedOptions({
                dateFormat: suggestedDateFormat || (0, $9HsT0.DEFAULT_DATE_FORMAT)
            });
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'csvFile read', {
                numberOfColumns: Object.keys(state.columns).length,
                numberOfMappedJiraFields: state.mappedJiraFieldIds.size,
                numberOfRows: state.rows.length,
                projectType: projectData.type,
                projectStyle: projectData.style,
                accessLevel: projectData.accessLevel
            });
        });
    }, [
        migrationId,
        mappingState,
        readCSVPreview,
        advancedOptions,
        projectData,
        setMappingState,
        updateAdvancedOptions,
        createAnalyticsEvent
    ]);
    const onKeyDownHandler = (0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Tab') setNextSelectedColumn(!event.shiftKey);
    }, [
        setNextSelectedColumn
    ]);
    const onColumnResizeEnd = (0, $eUqFw.useCallback)(({ column: column, width: width })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setColumnWidths({
            ...columnWidths,
            [column.key]: width
        });
    }, [
        columnWidths
    ]);
    (0, $eUqFw.useEffect)(()=>{
        onReadCSV();
    }, [
        onReadCSV
    ]);
    const shouldScrollToStart = (0, $aWLVm.hasTableColumnErrors)(mappingState);
    (0, $eUqFw.useEffect)(()=>{
        // scroll table to the start when there are column validation errors
        if (shouldScrollToStart) tableRef.current?.scrollToLeft(0);
    }, [
        shouldScrollToStart,
        mappingState?.validationError
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (mappingState && mappingState.selectedColumn) {
            const newScrollLeftPosition = (0, $jrj5D.getNewScrollLeftPosition)(mappingState, columnWidths, mappingState.selectedColumn, tableRef?.current);
            newScrollLeftPosition !== undefined && tableRef.current?.scrollToLeft(newScrollLeftPosition);
        } // Only scroll if selected column changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        mappingState?.selectedColumn
    ]);
    const getColumnNameRow = (0, $eUqFw.useCallback)(()=>{
        if (!mappingState) return [];
        const columnNameRow = {};
        mappingState.columnOrder.forEach((columnName)=>{
            columnNameRow[columnName] = columnName;
        });
        return [
            columnNameRow
        ];
    }, [
        mappingState
    ]);
    if (hasErrorOccurred) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0c7e3637c71b813f$var$DisabledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0c7e3637c71b813f$var$Image, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($43pn3))),
        "aria-describedby": "mapping-table-read-error",
        role: "img",
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0c7e3637c71b813f$var$ErrorDescription, {
        level: "h700",
        as: "h3",
        id: "mapping-table-read-error"
    }, formatMessage((0, $ji4el.default).error)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "primary",
        onClick: onReadCSV
    }, formatMessage((0, $ji4el.default).retry)));
    if (isLoading || mappingState === null || isPrioritiesLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0c7e3637c71b813f$var$DisabledWrapper, {
        "data-testid": "project-create-importer-upload-flow.ui.mapping-screen.mapping-table.disabled-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "xlarge"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0c7e3637c71b813f$var$LoadingDescription, {
        level: "h400",
        as: "span"
    }, formatMessage((0, $ji4el.default).loading)));
    const footerOptions = mappingState.rows.length >= 30 ? {
        footerHeight: 20,
        footerRenderer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, formatMessage((0, $ji4el.default).preview))
    } : {};
    const headerRenderer = ({ cells: cells })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), {
            name: (0, $b8facdd16b032a29$export$26bb1007e6167496)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eqzD.ConditionalWrapper), {
            condition: nudgeStep === (0, $b8facdd16b032a29$export$26bb1007e6167496),
            renderWrapper: (children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0c7e3637c71b813f$var$HeaderRow, null, children)
        }, cells));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0c7e3637c71b813f$var$Wrapper, {
        "data-testid": "project-create-importer-upload-flow.ui.mapping-screen.mapping-table.wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0c7e3637c71b813f$var$TableWrapper, {
        onKeyDown: onKeyDownHandler,
        "data-testid": "project-create-importer-upload-flow.ui.mapping-screen.mapping-table.table-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1AUfu.default), null, ({ width: width, height: height })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5rVGx.default // @ts-expect-error - TS2769 - No overload matches this call.
        ), {
            ref: tableRef,
            fixed: true,
            width: width,
            height: height,
            columns: columns,
            data: mappingState.rows,
            frozenData: getColumnNameRow(),
            onColumnResizeEnd: onColumnResizeEnd,
            headerHeight: $0c7e3637c71b813f$var$HEADER_HEIGHT,
            ...footerOptions,
            headerRenderer: headerRenderer
        }))));
};
$0c7e3637c71b813f$var$MappingTable.displayName = 'MappingTable';
var $0c7e3637c71b813f$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($0c7e3637c71b813f$var$MappingTable);
const $0c7e3637c71b813f$var$defaultBorder = `1px solid ${`var(--ds-border, ${(0, $PdmhA).N40})`}`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c7e3637c71b813f$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1tkeuuw1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c7e3637c71b813f$var$DisabledWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _16jlkb7n _1o9zkb7n _i0dl1wug _2rko1y44 _19ith6cr _bfhk1y1w _2gv6pxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c7e3637c71b813f$var$Image = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb16xz _4t3i16xz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c7e3637c71b813f$var$ErrorDescription = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $hI5oG.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pku2gc _otyr1jfw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c7e3637c71b813f$var$LoadingDescription = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $hI5oG.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1jfw _syazc8hx",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c7e3637c71b813f$var$TableWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1q7slas": (0, $9t7rW.default)($0c7e3637c71b813f$var$defaultBorder)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _1j0qvuon _1wha1fxt _h40nftgi _1ruzgga3 _9dkch2mm _mrg5vuon _1msgstnw _8gicidpf _199h1txw _1ts21sxn _1tqd1wug _1ewt1wug _wds7stnw _fbykidpf _13zq1gi7 _a5h51e9r _hjdqdlk8 _1dwv1txw _1fo21h6o _1ekm1h6o _hgc51osq _152o1txw _1esu1h6o _txajusvi _1wwow1gv _109z1txw _1v8pvrvc _zfqvh2mm _1fvgidpf _1d5g1osq _juz01txw _1yws1h6o _1kgousvi _1l2cv77o _7hlv1q9c _bx6ygga3 _9saa1s4m _ix151ve8 _1velidpf _t87z1osq _18rc1txw _py3i1h6o _mnpzu2gc _cnphusvi _ddd51q9c _d72wgga3 _1a82ewfl _r6k8kb7n _pi0g19bv _1xrr15vq _rvi5stnw _vn9widpf _ftctidpf _1ofeidpf _43w515vq _ub4f15vq _1mkub3bt _3isayh40 _1idlhloo _h3dk11mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c7e3637c71b813f$var$HeaderRow = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bsbwtch _4t3i1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9vHOT", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("5rVGx")).default);
$parcel$export(module.exports, "BaseTableV2", () => (parcelRequire("7NdQE")).default);
$parcel$export(module.exports, "Column", () => (parcelRequire("aymWH")).default);
$parcel$export(module.exports, "AutoResizer", () => (parcelRequire("1AUfu")).default);

var $5rVGx = parcelRequire("5rVGx");

var $7NdQE = parcelRequire("7NdQE");

var $aymWH = parcelRequire("aymWH");

var $bFxRm = parcelRequire("bFxRm");

var $1AUfu = parcelRequire("1AUfu");

var $b1H5u = parcelRequire("b1H5u");

var $gdyfF = parcelRequire("gdyfF");

var $7h8T1 = parcelRequire("7h8T1");

});
parcelRegister("5rVGx", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f7c386c5bf5ff56$export$2e2bcd8739ae039);

var $6XgOP = parcelRequire("6XgOP");

var $kU09D = parcelRequire("kU09D");

var $5zQU9 = parcelRequire("5zQU9");

var $aCdHv = parcelRequire("aCdHv");

var $6MEf7 = parcelRequire("6MEf7");

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $hjlb6 = parcelRequire("hjlb6");

var $dCUwp = parcelRequire("dCUwp");

var $6z2Iy = parcelRequire("6z2Iy");

var $eEtBg = parcelRequire("eEtBg");

var $gdyfF = parcelRequire("gdyfF");

var $O52GH = parcelRequire("O52GH");

var $ljkyQ = parcelRequire("ljkyQ");

var $aymWH = parcelRequire("aymWH");

var $bFxRm = parcelRequire("bFxRm");

var $3Rqfe = parcelRequire("3Rqfe");

var $aziI9 = parcelRequire("aziI9");

var $g0W2r = parcelRequire("g0W2r");

var $i1YES = parcelRequire("i1YES");

var $7h8T1 = parcelRequire("7h8T1");
function $3f7c386c5bf5ff56$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3f7c386c5bf5ff56$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $3f7c386c5bf5ff56$var$ownKeys(source, true).forEach(function(key) {
            (0, $5zQU9.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $3f7c386c5bf5ff56$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $3f7c386c5bf5ff56$var$getColumns = (0, $dCUwp.default)(function(columns, children) {
    return columns || (0, $7h8T1.normalizeColumns)(children);
});
var $3f7c386c5bf5ff56$var$getContainerStyle = function getContainerStyle(width, maxWidth, height) {
    return {
        width: width,
        maxWidth: maxWidth,
        height: height,
        overflow: 'hidden'
    };
};
var $3f7c386c5bf5ff56$var$DEFAULT_COMPONENTS = {
    TableCell: (0, $ljkyQ.default),
    TableHeaderCell: (0, $O52GH.default),
    ExpandIcon: (0, $3Rqfe.default),
    SortIndicator: (0, $aziI9.default)
};
var $3f7c386c5bf5ff56$var$RESIZE_THROTTLE_WAIT = 50; // used for memoization
var $3f7c386c5bf5ff56$var$EMPTY_ARRAY = [];
/**
 * React table component
 */ var $3f7c386c5bf5ff56$var$BaseTable = /*#__PURE__*/ function(_React$PureComponent) {
    (0, $6MEf7.default)(BaseTable, _React$PureComponent);
    function BaseTable(props) {
        var _this;
        _this = _React$PureComponent.call(this, props) || this;
        var columns = props.columns, children = props.children, defaultExpandedRowKeys = props.defaultExpandedRowKeys;
        _this.state = {
            scrollbarSize: 0,
            hoveredRowKey: null,
            resizingKey: null,
            resizingWidth: 0,
            expandedRowKeys: (0, $7h8T1.cloneArray)(defaultExpandedRowKeys)
        };
        _this.columnManager = new (0, $i1YES.default)($3f7c386c5bf5ff56$var$getColumns(columns, children), props.fixed);
        _this._setContainerRef = _this._setContainerRef.bind((0, $aCdHv.default)(_this));
        _this._setMainTableRef = _this._setMainTableRef.bind((0, $aCdHv.default)(_this));
        _this._setLeftTableRef = _this._setLeftTableRef.bind((0, $aCdHv.default)(_this));
        _this._setRightTableRef = _this._setRightTableRef.bind((0, $aCdHv.default)(_this));
        _this.renderExpandIcon = _this.renderExpandIcon.bind((0, $aCdHv.default)(_this));
        _this.renderRow = _this.renderRow.bind((0, $aCdHv.default)(_this));
        _this.renderRowCell = _this.renderRowCell.bind((0, $aCdHv.default)(_this));
        _this.renderHeader = _this.renderHeader.bind((0, $aCdHv.default)(_this));
        _this.renderHeaderCell = _this.renderHeaderCell.bind((0, $aCdHv.default)(_this));
        _this._handleScroll = _this._handleScroll.bind((0, $aCdHv.default)(_this));
        _this._handleVerticalScroll = _this._handleVerticalScroll.bind((0, $aCdHv.default)(_this));
        _this._handleRowsRendered = _this._handleRowsRendered.bind((0, $aCdHv.default)(_this));
        _this._handleRowHover = _this._handleRowHover.bind((0, $aCdHv.default)(_this));
        _this._handleRowExpand = _this._handleRowExpand.bind((0, $aCdHv.default)(_this));
        _this._handleColumnResize = (0, $7h8T1.throttle)(_this._handleColumnResize.bind((0, $aCdHv.default)(_this)), $3f7c386c5bf5ff56$var$RESIZE_THROTTLE_WAIT);
        _this._handleColumnResizeStart = _this._handleColumnResizeStart.bind((0, $aCdHv.default)(_this));
        _this._handleColumnResizeStop = _this._handleColumnResizeStop.bind((0, $aCdHv.default)(_this));
        _this._handleColumnSort = _this._handleColumnSort.bind((0, $aCdHv.default)(_this));
        _this._handleFrozenRowHeightChange = _this._handleFrozenRowHeightChange.bind((0, $aCdHv.default)(_this));
        _this._handleRowHeightChange = _this._handleRowHeightChange.bind((0, $aCdHv.default)(_this));
        _this._getLeftTableContainerStyle = (0, $dCUwp.default)($3f7c386c5bf5ff56$var$getContainerStyle);
        _this._getRightTableContainerStyle = (0, $dCUwp.default)($3f7c386c5bf5ff56$var$getContainerStyle);
        _this._flattenOnKeys = (0, $dCUwp.default)(function(tree, keys, dataKey) {
            _this._depthMap = {};
            return (0, $7h8T1.flattenOnKeys)(tree, keys, _this._depthMap, dataKey);
        });
        _this._resetColumnManager = (0, $dCUwp.default)(function(columns, fixed) {
            _this.columnManager.reset(columns, fixed);
            if (_this.props.estimatedRowHeight && fixed) {
                if (!_this.columnManager.hasLeftFrozenColumns()) _this._leftRowHeightMap = {};
                if (!_this.columnManager.hasRightFrozenColumns()) _this._rightRowHeightMap = {};
            }
        }, function(newArgs, lastArgs) {
            return (0, $7h8T1.isObjectEqual)(newArgs, lastArgs, _this.props.ignoreFunctionInColumnCompare);
        });
        _this._isResetting = false;
        _this._resetIndex = null;
        _this._rowHeightMap = {};
        _this._rowHeightMapBuffer = {};
        _this._mainRowHeightMap = {};
        _this._leftRowHeightMap = {};
        _this._rightRowHeightMap = {};
        _this._getEstimatedTotalRowsHeight = (0, $dCUwp.default)((0, $7h8T1.getEstimatedTotalRowsHeight));
        _this._getRowHeight = _this._getRowHeight.bind((0, $aCdHv.default)(_this));
        _this._updateRowHeights = (0, $7h8T1.debounce)(function() {
            _this._isResetting = true;
            _this._rowHeightMap = $3f7c386c5bf5ff56$var$_objectSpread({}, _this._rowHeightMap, {}, _this._rowHeightMapBuffer);
            _this.resetAfterRowIndex(_this._resetIndex, false);
            _this._rowHeightMapBuffer = {};
            _this._resetIndex = null;
            _this.forceUpdateTable();
            _this.forceUpdate();
            _this._isResetting = false;
        }, 0);
        _this._scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        _this._scrollHeight = 0;
        _this._lastScannedRowIndex = -1;
        _this._hasDataChangedSinceEndReached = true;
        _this._data = props.data;
        _this._depthMap = {};
        _this._horizontalScrollbarSize = 0;
        _this._verticalScrollbarSize = 0;
        _this._scrollbarPresenceChanged = false;
        return _this;
    }
    /**
   * Get the DOM node of the table
   */ var _proto = BaseTable.prototype;
    _proto.getDOMNode = function getDOMNode() {
        return this.tableNode;
    } /**
   * Get the column manager
   */ ;
    _proto.getColumnManager = function getColumnManager() {
        return this.columnManager;
    } /**
   * Get internal `expandedRowKeys` state
   */ ;
    _proto.getExpandedRowKeys = function getExpandedRowKeys() {
        var expandedRowKeys = this.props.expandedRowKeys;
        return expandedRowKeys !== undefined ? expandedRowKeys || $3f7c386c5bf5ff56$var$EMPTY_ARRAY : this.state.expandedRowKeys;
    } /**
   * Get the expanded state, fallback to normal state if not expandable.
   */ ;
    _proto.getExpandedState = function getExpandedState() {
        return {
            expandedData: this._data,
            expandedRowKeys: this.getExpandedRowKeys(),
            expandedDepthMap: this._depthMap
        };
    } /**
   * Get the total height of all rows, including expanded rows.
   */ ;
    _proto.getTotalRowsHeight = function getTotalRowsHeight() {
        var _this$props = this.props, rowHeight = _this$props.rowHeight, estimatedRowHeight = _this$props.estimatedRowHeight;
        if (estimatedRowHeight) return this.table ? this.table.getTotalRowsHeight() : this._getEstimatedTotalRowsHeight(this._data, estimatedRowHeight);
        return this._data.length * rowHeight;
    } /**
   * Get the total width of all columns.
   */ ;
    _proto.getTotalColumnsWidth = function getTotalColumnsWidth() {
        return this.columnManager.getColumnsWidth();
    } /**
   * Forcefully re-render the inner Grid component.
   *
   * Calling `forceUpdate` on `Table` may not re-render the inner Grid since it uses `shallowCompare` as a performance optimization.
   * Use this method if you want to manually trigger a re-render.
   * This may be appropriate if the underlying row data has changed but the row sizes themselves have not.
   */ ;
    _proto.forceUpdateTable = function forceUpdateTable() {
        this.table && this.table.forceUpdateTable();
        this.leftTable && this.leftTable.forceUpdateTable();
        this.rightTable && this.rightTable.forceUpdateTable();
    } /**
   * Reset cached offsets for positioning after a specific rowIndex, should be used only in dynamic mode(estimatedRowHeight is provided)
   *
   * @param {number} rowIndex
   * @param {boolean} shouldForceUpdate
   */ ;
    _proto.resetAfterRowIndex = function resetAfterRowIndex(rowIndex, shouldForceUpdate) {
        if (rowIndex === void 0) rowIndex = 0;
        if (shouldForceUpdate === void 0) shouldForceUpdate = true;
        if (!this.props.estimatedRowHeight) return;
        this.table && this.table.resetAfterRowIndex(rowIndex, shouldForceUpdate);
        this.leftTable && this.leftTable.resetAfterRowIndex(rowIndex, shouldForceUpdate);
        this.rightTable && this.rightTable.resetAfterRowIndex(rowIndex, shouldForceUpdate);
    } /**
   * Reset row height cache, useful if `data` changed entirely, should be used only in dynamic mode(estimatedRowHeight is provided)
   */ ;
    _proto.resetRowHeightCache = function resetRowHeightCache() {
        if (!this.props.estimatedRowHeight) return;
        this._resetIndex = null;
        this._rowHeightMapBuffer = {};
        this._rowHeightMap = {};
        this._mainRowHeightMap = {};
        this._leftRowHeightMap = {};
        this._rightRowHeightMap = {};
    } /**
   * Scroll to the specified offset.
   * Useful for animating position changes.
   *
   * @param {object} offset
   */ ;
    _proto.scrollToPosition = function scrollToPosition(offset) {
        this._scroll = offset;
        this.table && this.table.scrollToPosition(offset);
        this.leftTable && this.leftTable.scrollToTop(offset.scrollTop);
        this.rightTable && this.rightTable.scrollToTop(offset.scrollTop);
    } /**
   * Scroll to the specified offset vertically.
   *
   * @param {number} scrollTop
   */ ;
    _proto.scrollToTop = function scrollToTop(scrollTop) {
        this._scroll.scrollTop = scrollTop;
        this.table && this.table.scrollToPosition(this._scroll);
        this.leftTable && this.leftTable.scrollToTop(scrollTop);
        this.rightTable && this.rightTable.scrollToTop(scrollTop);
    } /**
   * Scroll to the specified offset horizontally.
   *
   * @param {number} scrollLeft
   */ ;
    _proto.scrollToLeft = function scrollToLeft(scrollLeft) {
        this._scroll.scrollLeft = scrollLeft;
        this.table && this.table.scrollToPosition(this._scroll);
    } /**
   * Scroll to the specified row.
   * By default, the table will scroll as little as possible to ensure the row is visible.
   * You can control the alignment of the row though by specifying an align property. Acceptable values are:
   *
   * - `auto` (default) - Scroll as little as possible to ensure the row is visible.
   * - `smart` - Same as `auto` if it is less than one viewport away, or it's the same as`center`.
   * - `center` - Center align the row within the table.
   * - `end` - Align the row to the bottom side of the table.
   * - `start` - Align the row to the top side of the table.
   *
   * @param {number} rowIndex
   * @param {string} align
   */ ;
    _proto.scrollToRow = function scrollToRow(rowIndex, align) {
        if (rowIndex === void 0) rowIndex = 0;
        if (align === void 0) align = 'auto';
        this.table && this.table.scrollToRow(rowIndex, align);
        this.leftTable && this.leftTable.scrollToRow(rowIndex, align);
        this.rightTable && this.rightTable.scrollToRow(rowIndex, align);
    } /**
   * Set `expandedRowKeys` manually.
   * This method is available only if `expandedRowKeys` is uncontrolled.
   *
   * @param {array} expandedRowKeys
   */ ;
    _proto.setExpandedRowKeys = function setExpandedRowKeys(expandedRowKeys) {
        // if `expandedRowKeys` is controlled
        if (this.props.expandedRowKeys !== undefined) return;
        this.setState({
            expandedRowKeys: (0, $7h8T1.cloneArray)(expandedRowKeys)
        });
    };
    _proto.renderExpandIcon = function renderExpandIcon(_ref) {
        var rowData = _ref.rowData, rowIndex = _ref.rowIndex, depth = _ref.depth, onExpand = _ref.onExpand;
        var _this$props2 = this.props, rowKey = _this$props2.rowKey, expandColumnKey = _this$props2.expandColumnKey, expandIconProps = _this$props2.expandIconProps;
        if (!expandColumnKey) return null;
        var expandable = rowIndex >= 0 && (0, $7h8T1.hasChildren)(rowData);
        var expanded = rowIndex >= 0 && this.getExpandedRowKeys().indexOf(rowData[rowKey]) >= 0;
        var extraProps = (0, $7h8T1.callOrReturn)(expandIconProps, {
            rowData: rowData,
            rowIndex: rowIndex,
            depth: depth,
            expandable: expandable,
            expanded: expanded
        });
        var ExpandIcon = this._getComponent('ExpandIcon');
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ExpandIcon, (0, $kU09D.default)({
            depth: depth,
            expandable: expandable,
            expanded: expanded
        }, extraProps, {
            onExpand: onExpand
        }));
    };
    _proto.renderRow = function renderRow(_ref2) {
        var _cn;
        var isScrolling = _ref2.isScrolling, columns = _ref2.columns, rowData = _ref2.rowData, rowIndex = _ref2.rowIndex, style = _ref2.style;
        var _this$props3 = this.props, rowClassName = _this$props3.rowClassName, rowRenderer = _this$props3.rowRenderer, rowEventHandlers = _this$props3.rowEventHandlers, expandColumnKey = _this$props3.expandColumnKey, estimatedRowHeight = _this$props3.estimatedRowHeight;
        var rowClass = (0, $7h8T1.callOrReturn)(rowClassName, {
            columns: columns,
            rowData: rowData,
            rowIndex: rowIndex
        });
        var extraProps = (0, $7h8T1.callOrReturn)(this.props.rowProps, {
            columns: columns,
            rowData: rowData,
            rowIndex: rowIndex
        });
        var rowKey = rowData[this.props.rowKey];
        var depth = this._depthMap[rowKey] || 0;
        var className = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))(this._prefixClass('row'), rowClass, (_cn = {}, _cn[this._prefixClass("row--depth-" + depth)] = !!expandColumnKey && rowIndex >= 0, _cn[this._prefixClass('row--expanded')] = !!expandColumnKey && this.getExpandedRowKeys().indexOf(rowKey) >= 0, _cn[this._prefixClass('row--hovered')] = !isScrolling && rowKey === this.state.hoveredRowKey, _cn[this._prefixClass('row--frozen')] = depth === 0 && rowIndex < 0, _cn[this._prefixClass('row--customized')] = rowRenderer, _cn));
        var hasFrozenColumns = this.columnManager.hasFrozenColumns();
        var rowProps = $3f7c386c5bf5ff56$var$_objectSpread({}, extraProps, {
            role: 'row',
            key: "row-" + rowKey,
            isScrolling: isScrolling,
            className: className,
            style: style,
            columns: columns,
            rowIndex: rowIndex,
            rowData: rowData,
            rowKey: rowKey,
            expandColumnKey: expandColumnKey,
            depth: depth,
            rowEventHandlers: rowEventHandlers,
            rowRenderer: rowRenderer,
            // for frozen rows we use fixed rowHeight
            estimatedRowHeight: rowIndex >= 0 ? estimatedRowHeight : undefined,
            getIsResetting: this._getIsResetting,
            cellRenderer: this.renderRowCell,
            expandIconRenderer: this.renderExpandIcon,
            onRowExpand: this._handleRowExpand,
            // for fixed table, we need to sync the hover state across the inner tables
            onRowHover: hasFrozenColumns ? this._handleRowHover : null,
            onRowHeightChange: hasFrozenColumns ? this._handleFrozenRowHeightChange : this._handleRowHeightChange
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gdyfF.default), rowProps);
    };
    _proto.renderRowCell = function renderRowCell(_ref3) {
        var _cn2;
        var isScrolling = _ref3.isScrolling, columns = _ref3.columns, column = _ref3.column, columnIndex = _ref3.columnIndex, rowData = _ref3.rowData, rowIndex = _ref3.rowIndex, expandIcon = _ref3.expandIcon;
        if (column[(0, $i1YES.default).PlaceholderKey]) return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            key: "row-" + rowData[this.props.rowKey] + "-cell-" + column.key + "-placeholder",
            className: this._prefixClass('row-cell-placeholder'),
            style: this.columnManager.getColumnStyle(column.key)
        });
        var className = column.className, dataKey = column.dataKey, dataGetter = column.dataGetter, cellRenderer = column.cellRenderer;
        var TableCell = this._getComponent('TableCell');
        var cellData = dataGetter ? dataGetter({
            columns: columns,
            column: column,
            columnIndex: columnIndex,
            rowData: rowData,
            rowIndex: rowIndex
        }) : (0, $7h8T1.getValue)(rowData, dataKey);
        var cellProps = {
            isScrolling: isScrolling,
            cellData: cellData,
            columns: columns,
            column: column,
            columnIndex: columnIndex,
            rowData: rowData,
            rowIndex: rowIndex,
            container: this
        };
        var cell = (0, $7h8T1.renderElement)(cellRenderer || (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TableCell, {
            className: this._prefixClass('row-cell-text')
        }), cellProps);
        var cellCls = (0, $7h8T1.callOrReturn)(className, {
            cellData: cellData,
            columns: columns,
            column: column,
            columnIndex: columnIndex,
            rowData: rowData,
            rowIndex: rowIndex
        });
        var cls = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))(this._prefixClass('row-cell'), cellCls, (_cn2 = {}, _cn2[this._prefixClass('row-cell--align-center')] = column.align === (0, $aymWH.Alignment).CENTER, _cn2[this._prefixClass('row-cell--align-right')] = column.align === (0, $aymWH.Alignment).RIGHT, _cn2));
        var extraProps = (0, $7h8T1.callOrReturn)(this.props.cellProps, {
            columns: columns,
            column: column,
            columnIndex: columnIndex,
            rowData: rowData,
            rowIndex: rowIndex
        });
        var _ref4 = extraProps || {}, tagName = _ref4.tagName, rest = (0, $6XgOP.default)(_ref4, [
            "tagName"
        ]);
        var Tag = tagName || 'div';
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Tag, (0, $kU09D.default)({
            role: "gridcell",
            key: "row-" + rowData[this.props.rowKey] + "-cell-" + column.key
        }, rest, {
            className: cls,
            style: this.columnManager.getColumnStyle(column.key)
        }), expandIcon, cell);
    };
    _proto.renderHeader = function renderHeader(_ref5) {
        var _cn3;
        var columns = _ref5.columns, headerIndex = _ref5.headerIndex, style = _ref5.style;
        var _this$props4 = this.props, headerClassName = _this$props4.headerClassName, headerRenderer = _this$props4.headerRenderer;
        var headerClass = (0, $7h8T1.callOrReturn)(headerClassName, {
            columns: columns,
            headerIndex: headerIndex
        });
        var extraProps = (0, $7h8T1.callOrReturn)(this.props.headerProps, {
            columns: columns,
            headerIndex: headerIndex
        });
        var className = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))(this._prefixClass('header-row'), headerClass, (_cn3 = {}, _cn3[this._prefixClass('header-row--resizing')] = !!this.state.resizingKey, _cn3[this._prefixClass('header-row--customized')] = headerRenderer, _cn3));
        var headerProps = $3f7c386c5bf5ff56$var$_objectSpread({}, extraProps, {
            role: 'row',
            key: "header-" + headerIndex,
            className: className,
            style: style,
            columns: columns,
            headerIndex: headerIndex,
            headerRenderer: headerRenderer,
            cellRenderer: this.renderHeaderCell,
            expandColumnKey: this.props.expandColumnKey,
            expandIcon: this._getComponent('ExpandIcon')
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eEtBg.default), headerProps);
    };
    _proto.renderHeaderCell = function renderHeaderCell(_ref6) {
        var _cn4, _cn5;
        var columns = _ref6.columns, column = _ref6.column, columnIndex = _ref6.columnIndex, headerIndex = _ref6.headerIndex, expandIcon = _ref6.expandIcon;
        if (column[(0, $i1YES.default).PlaceholderKey]) return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            key: "header-" + headerIndex + "-cell-" + column.key + "-placeholder",
            className: this._prefixClass('header-cell-placeholder'),
            style: this.columnManager.getColumnStyle(column.key)
        });
        var headerClassName = column.headerClassName, headerRenderer = column.headerRenderer;
        var _this$props5 = this.props, sortBy = _this$props5.sortBy, sortState = _this$props5.sortState, headerCellProps = _this$props5.headerCellProps;
        var TableHeaderCell = this._getComponent('TableHeaderCell');
        var SortIndicator = this._getComponent('SortIndicator');
        var cellProps = {
            columns: columns,
            column: column,
            columnIndex: columnIndex,
            headerIndex: headerIndex,
            container: this
        };
        var cell = (0, $7h8T1.renderElement)(headerRenderer || (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TableHeaderCell, {
            className: this._prefixClass('header-cell-text')
        }), cellProps);
        var sorting, sortOrder;
        if (sortState) {
            var order = sortState[column.key];
            sorting = order === (0, $bFxRm.default).ASC || order === (0, $bFxRm.default).DESC;
            sortOrder = sorting ? order : (0, $bFxRm.default).ASC;
        } else {
            sorting = column.key === sortBy.key;
            sortOrder = sorting ? sortBy.order : (0, $bFxRm.default).ASC;
        }
        var cellCls = (0, $7h8T1.callOrReturn)(headerClassName, {
            columns: columns,
            column: column,
            columnIndex: columnIndex,
            headerIndex: headerIndex
        });
        var cls = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))(this._prefixClass('header-cell'), cellCls, (_cn4 = {}, _cn4[this._prefixClass('header-cell--align-center')] = column.align === (0, $aymWH.Alignment).CENTER, _cn4[this._prefixClass('header-cell--align-right')] = column.align === (0, $aymWH.Alignment).RIGHT, _cn4[this._prefixClass('header-cell--sortable')] = column.sortable, _cn4[this._prefixClass('header-cell--sorting')] = sorting, _cn4[this._prefixClass('header-cell--resizing')] = column.key === this.state.resizingKey, _cn4));
        var extraProps = (0, $7h8T1.callOrReturn)(headerCellProps, {
            columns: columns,
            column: column,
            columnIndex: columnIndex,
            headerIndex: headerIndex
        });
        var _ref7 = extraProps || {}, tagName = _ref7.tagName, rest = (0, $6XgOP.default)(_ref7, [
            "tagName"
        ]);
        var Tag = tagName || 'div';
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Tag, (0, $kU09D.default)({
            role: "gridcell",
            key: "header-" + headerIndex + "-cell-" + column.key,
            onClick: column.sortable ? this._handleColumnSort : null
        }, rest, {
            className: cls,
            style: this.columnManager.getColumnStyle(column.key),
            "data-key": column.key
        }), expandIcon, cell, column.sortable && (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SortIndicator, {
            sortOrder: sortOrder,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))(this._prefixClass('sort-indicator'), (_cn5 = {}, _cn5[this._prefixClass('sort-indicator--descending')] = sortOrder === (0, $bFxRm.default).DESC, _cn5))
        }), column.resizable && (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g0W2r.default), {
            className: this._prefixClass('column-resizer'),
            column: column,
            onResizeStart: this._handleColumnResizeStart,
            onResizeStop: this._handleColumnResizeStop,
            onResize: this._handleColumnResize
        }));
    };
    _proto.renderMainTable = function renderMainTable() {
        var _this$props6 = this.props, width = _this$props6.width, headerHeight = _this$props6.headerHeight, rowHeight = _this$props6.rowHeight, fixed = _this$props6.fixed, estimatedRowHeight = _this$props6.estimatedRowHeight, rest = (0, $6XgOP.default)(_this$props6, [
            "width",
            "headerHeight",
            "rowHeight",
            "fixed",
            "estimatedRowHeight"
        ]);
        var height = this._getTableHeight();
        var tableWidth = width - this._verticalScrollbarSize;
        if (fixed) {
            var columnsWidth = this.columnManager.getColumnsWidth(); // make sure `scrollLeft` is always integer to fix a sync bug when scrolling to end horizontally
            tableWidth = Math.max(Math.round(columnsWidth), tableWidth);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6z2Iy.default), (0, $kU09D.default)({}, rest, this.state, {
            className: this._prefixClass('table-main'),
            ref: this._setMainTableRef,
            data: this._data,
            columns: this.columnManager.getMainColumns(),
            width: width,
            height: height,
            headerHeight: headerHeight,
            rowHeight: rowHeight,
            estimatedRowHeight: estimatedRowHeight,
            getRowHeight: estimatedRowHeight ? this._getRowHeight : undefined,
            headerWidth: tableWidth + (fixed ? this._verticalScrollbarSize : 0),
            bodyWidth: tableWidth,
            headerRenderer: this.renderHeader,
            rowRenderer: this.renderRow,
            onScroll: this._handleScroll,
            onRowsRendered: this._handleRowsRendered
        }));
    };
    _proto.renderLeftTable = function renderLeftTable() {
        if (!this.columnManager.hasLeftFrozenColumns()) return null;
        var _this$props7 = this.props, width = _this$props7.width, headerHeight = _this$props7.headerHeight, rowHeight = _this$props7.rowHeight, estimatedRowHeight = _this$props7.estimatedRowHeight, rest = (0, $6XgOP.default)(_this$props7, [
            "width",
            "headerHeight",
            "rowHeight",
            "estimatedRowHeight"
        ]);
        var containerHeight = this._getFrozenContainerHeight();
        var offset = this._verticalScrollbarSize || 20;
        var columnsWidth = this.columnManager.getLeftFrozenColumnsWidth();
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6z2Iy.default), (0, $kU09D.default)({}, rest, this.state, {
            containerStyle: this._getLeftTableContainerStyle(columnsWidth, width, containerHeight),
            className: this._prefixClass('table-frozen-left'),
            ref: this._setLeftTableRef,
            data: this._data,
            columns: this.columnManager.getLeftFrozenColumns(),
            initialScrollTop: this._scroll.scrollTop,
            width: columnsWidth + offset,
            height: containerHeight,
            headerHeight: headerHeight,
            rowHeight: rowHeight,
            estimatedRowHeight: estimatedRowHeight,
            getRowHeight: estimatedRowHeight ? this._getRowHeight : undefined,
            headerWidth: columnsWidth + offset,
            bodyWidth: columnsWidth + offset,
            headerRenderer: this.renderHeader,
            rowRenderer: this.renderRow,
            onScroll: this._handleVerticalScroll,
            onRowsRendered: (0, $7h8T1.noop)
        }));
    };
    _proto.renderRightTable = function renderRightTable() {
        if (!this.columnManager.hasRightFrozenColumns()) return null;
        var _this$props8 = this.props, width = _this$props8.width, headerHeight = _this$props8.headerHeight, rowHeight = _this$props8.rowHeight, estimatedRowHeight = _this$props8.estimatedRowHeight, rest = (0, $6XgOP.default)(_this$props8, [
            "width",
            "headerHeight",
            "rowHeight",
            "estimatedRowHeight"
        ]);
        var containerHeight = this._getFrozenContainerHeight();
        var columnsWidth = this.columnManager.getRightFrozenColumnsWidth();
        var scrollbarWidth = this._verticalScrollbarSize;
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6z2Iy.default), (0, $kU09D.default)({}, rest, this.state, {
            containerStyle: this._getLeftTableContainerStyle(columnsWidth + scrollbarWidth, width, containerHeight),
            className: this._prefixClass('table-frozen-right'),
            ref: this._setRightTableRef,
            data: this._data,
            columns: this.columnManager.getRightFrozenColumns(),
            initialScrollTop: this._scroll.scrollTop,
            width: columnsWidth + scrollbarWidth,
            height: containerHeight,
            headerHeight: headerHeight,
            rowHeight: rowHeight,
            estimatedRowHeight: estimatedRowHeight,
            getRowHeight: estimatedRowHeight ? this._getRowHeight : undefined,
            headerWidth: columnsWidth + scrollbarWidth,
            bodyWidth: columnsWidth,
            headerRenderer: this.renderHeader,
            rowRenderer: this.renderRow,
            onScroll: this._handleVerticalScroll,
            onRowsRendered: (0, $7h8T1.noop)
        }));
    };
    _proto.renderResizingLine = function renderResizingLine() {
        var _this$props9 = this.props, width = _this$props9.width, fixed = _this$props9.fixed;
        var resizingKey = this.state.resizingKey;
        if (!fixed || !resizingKey) return null;
        var columns = this.columnManager.getMainColumns();
        var idx = columns.findIndex(function(column) {
            return column.key === resizingKey;
        });
        var column = columns[idx];
        var columnWidth = column.width, frozen = column.frozen;
        var leftWidth = this.columnManager.recomputeColumnsWidth(columns.slice(0, idx));
        var left = leftWidth + columnWidth;
        if (!frozen) left -= this._scroll.scrollLeft;
        else if (frozen === (0, $aymWH.FrozenDirection).RIGHT) {
            var rightWidth = this.columnManager.recomputeColumnsWidth(columns.slice(idx + 1));
            if (rightWidth + columnWidth > width - this._verticalScrollbarSize) left = columnWidth;
            else left = width - this._verticalScrollbarSize - rightWidth;
        }
        var style = {
            left: left,
            height: this._getTableHeight() - this._horizontalScrollbarSize
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: this._prefixClass('resizing-line'),
            style: style
        });
    };
    _proto.renderFooter = function renderFooter() {
        var _this$props10 = this.props, footerHeight = _this$props10.footerHeight, footerRenderer = _this$props10.footerRenderer;
        if (footerHeight === 0) return null;
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: this._prefixClass('footer'),
            style: {
                height: footerHeight
            }
        }, (0, $7h8T1.renderElement)(footerRenderer));
    };
    _proto.renderEmptyLayer = function renderEmptyLayer() {
        var _this$props11 = this.props, data = _this$props11.data, frozenData = _this$props11.frozenData, footerHeight = _this$props11.footerHeight, emptyRenderer = _this$props11.emptyRenderer;
        if (data && data.length || frozenData && frozenData.length) return null;
        var headerHeight = this._getHeaderHeight();
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: this._prefixClass('empty-layer'),
            style: {
                top: headerHeight,
                bottom: footerHeight
            }
        }, (0, $7h8T1.renderElement)(emptyRenderer));
    };
    _proto.renderOverlay = function renderOverlay() {
        var overlayRenderer = this.props.overlayRenderer;
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: this._prefixClass('overlay')
        }, !!overlayRenderer && (0, $7h8T1.renderElement)(overlayRenderer));
    };
    _proto.render = function render() {
        var _cn6;
        var _this$props12 = this.props, columns = _this$props12.columns, children = _this$props12.children, width = _this$props12.width, fixed = _this$props12.fixed, data = _this$props12.data, frozenData = _this$props12.frozenData, expandColumnKey = _this$props12.expandColumnKey, disabled = _this$props12.disabled, className = _this$props12.className, style = _this$props12.style, footerHeight = _this$props12.footerHeight, classPrefix = _this$props12.classPrefix, estimatedRowHeight = _this$props12.estimatedRowHeight;
        this._resetColumnManager($3f7c386c5bf5ff56$var$getColumns(columns, children), fixed);
        var _data = expandColumnKey ? this._flattenOnKeys(data, this.getExpandedRowKeys(), this.props.rowKey) : data;
        if (this._data !== _data) {
            this.resetAfterRowIndex(0, false);
            this._data = _data;
        } // should be after `this._data` assigned
        this._calcScrollbarSizes();
        this._totalRowsHeight = this.getTotalRowsHeight();
        var containerStyle = $3f7c386c5bf5ff56$var$_objectSpread({}, style, {
            width: width,
            height: this._getTableHeight() + footerHeight,
            position: 'relative'
        });
        var cls = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))(classPrefix, className, (_cn6 = {}, _cn6[classPrefix + "--fixed"] = fixed, _cn6[classPrefix + "--expandable"] = !!expandColumnKey, _cn6[classPrefix + "--empty"] = data.length === 0, _cn6[classPrefix + "--has-frozen-rows"] = frozenData.length > 0, _cn6[classPrefix + "--has-frozen-columns"] = this.columnManager.hasFrozenColumns(), _cn6[classPrefix + "--disabled"] = disabled, _cn6[classPrefix + "--dynamic"] = !!estimatedRowHeight, _cn6));
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ref: this._setContainerRef,
            className: cls,
            style: containerStyle
        }, this.renderFooter(), this.renderMainTable(), this.renderLeftTable(), this.renderRightTable(), this.renderResizingLine(), this.renderEmptyLayer(), this.renderOverlay());
    };
    _proto.componentDidMount = function componentDidMount() {
        var scrollbarSize = this.props.getScrollbarSize();
        if (scrollbarSize > 0) this.setState({
            scrollbarSize: scrollbarSize
        });
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        var _this$props13 = this.props, data = _this$props13.data, height = _this$props13.height, maxHeight = _this$props13.maxHeight, estimatedRowHeight = _this$props13.estimatedRowHeight;
        if (data !== prevProps.data) {
            this._lastScannedRowIndex = -1;
            this._hasDataChangedSinceEndReached = true;
        }
        if (maxHeight !== prevProps.maxHeight || height !== prevProps.height) this._maybeCallOnEndReached();
        this._maybeScrollbarPresenceChange();
        if (estimatedRowHeight) {
            if (this.getTotalRowsHeight() !== this._totalRowsHeight) this.forceUpdate();
        }
    };
    _proto._prefixClass = function _prefixClass(className) {
        return this.props.classPrefix + "__" + className;
    };
    _proto._setContainerRef = function _setContainerRef(ref) {
        this.tableNode = ref;
    };
    _proto._setMainTableRef = function _setMainTableRef(ref) {
        this.table = ref;
    };
    _proto._setLeftTableRef = function _setLeftTableRef(ref) {
        this.leftTable = ref;
    };
    _proto._setRightTableRef = function _setRightTableRef(ref) {
        this.rightTable = ref;
    };
    _proto._getComponent = function _getComponent(name) {
        if (this.props.components && this.props.components[name]) return this.props.components[name];
        return $3f7c386c5bf5ff56$var$DEFAULT_COMPONENTS[name];
    } // for dynamic row height
    ;
    _proto._getRowHeight = function _getRowHeight(rowIndex) {
        var _this$props14 = this.props, estimatedRowHeight = _this$props14.estimatedRowHeight, rowKey = _this$props14.rowKey;
        return this._rowHeightMap[this._data[rowIndex][rowKey]] || (0, $7h8T1.callOrReturn)(estimatedRowHeight, {
            rowData: this._data[rowIndex],
            rowIndex: rowIndex
        });
    };
    _proto._getIsResetting = function _getIsResetting() {
        return this._isResetting;
    };
    _proto._getHeaderHeight = function _getHeaderHeight() {
        var headerHeight = this.props.headerHeight;
        if (Array.isArray(headerHeight)) return headerHeight.reduce(function(sum, height) {
            return sum + height;
        }, 0);
        return headerHeight;
    };
    _proto._getFrozenRowsHeight = function _getFrozenRowsHeight() {
        var _this$props15 = this.props, frozenData = _this$props15.frozenData, rowHeight = _this$props15.rowHeight;
        return frozenData.length * rowHeight;
    };
    _proto._getTableHeight = function _getTableHeight() {
        var _this$props16 = this.props, height = _this$props16.height, maxHeight = _this$props16.maxHeight, footerHeight = _this$props16.footerHeight;
        var tableHeight = height - footerHeight;
        if (maxHeight > 0) {
            var frozenRowsHeight = this._getFrozenRowsHeight();
            var totalRowsHeight = this.getTotalRowsHeight();
            var headerHeight = this._getHeaderHeight();
            var totalHeight = headerHeight + frozenRowsHeight + totalRowsHeight + this._horizontalScrollbarSize;
            tableHeight = Math.min(totalHeight, maxHeight - footerHeight);
        }
        return tableHeight;
    };
    _proto._getBodyHeight = function _getBodyHeight() {
        return this._getTableHeight() - this._getHeaderHeight() - this._getFrozenRowsHeight();
    };
    _proto._getFrozenContainerHeight = function _getFrozenContainerHeight() {
        var maxHeight = this.props.maxHeight;
        var tableHeight = this._getTableHeight() - (this._data.length > 0 ? this._horizontalScrollbarSize : 0); // in auto height mode tableHeight = totalHeight
        if (maxHeight > 0) return tableHeight;
        var totalHeight = this.getTotalRowsHeight() + this._getHeaderHeight() + this._getFrozenRowsHeight();
        return Math.min(tableHeight, totalHeight);
    };
    _proto._calcScrollbarSizes = function _calcScrollbarSizes() {
        var _this$props17 = this.props, fixed = _this$props17.fixed, width = _this$props17.width;
        var scrollbarSize = this.state.scrollbarSize;
        var totalRowsHeight = this.getTotalRowsHeight();
        var totalColumnsWidth = this.getTotalColumnsWidth();
        var prevHorizontalScrollbarSize = this._horizontalScrollbarSize;
        var prevVerticalScrollbarSize = this._verticalScrollbarSize;
        if (scrollbarSize === 0) {
            this._horizontalScrollbarSize = 0;
            this._verticalScrollbarSize = 0;
        } else {
            // we have to set `this._horizontalScrollbarSize` before calling `this._getBodyHeight`
            if (!fixed || totalColumnsWidth <= width - scrollbarSize) {
                this._horizontalScrollbarSize = 0;
                this._verticalScrollbarSize = totalRowsHeight > this._getBodyHeight() ? scrollbarSize : 0;
            } else if (totalColumnsWidth > width) {
                this._horizontalScrollbarSize = scrollbarSize;
                this._verticalScrollbarSize = totalRowsHeight > this._getBodyHeight() - this._horizontalScrollbarSize ? scrollbarSize : 0;
            } else {
                this._horizontalScrollbarSize = 0;
                this._verticalScrollbarSize = 0;
                if (totalRowsHeight > this._getBodyHeight()) {
                    this._horizontalScrollbarSize = scrollbarSize;
                    this._verticalScrollbarSize = scrollbarSize;
                }
            }
        }
        if (prevHorizontalScrollbarSize !== this._horizontalScrollbarSize || prevVerticalScrollbarSize !== this._verticalScrollbarSize) this._scrollbarPresenceChanged = true;
    };
    _proto._maybeScrollbarPresenceChange = function _maybeScrollbarPresenceChange() {
        if (this._scrollbarPresenceChanged) {
            var onScrollbarPresenceChange = this.props.onScrollbarPresenceChange;
            this._scrollbarPresenceChanged = false;
            onScrollbarPresenceChange({
                size: this.state.scrollbarSize,
                horizontal: this._horizontalScrollbarSize > 0,
                vertical: this._verticalScrollbarSize > 0
            });
        }
    };
    _proto._maybeCallOnEndReached = function _maybeCallOnEndReached() {
        var _this$props18 = this.props, onEndReached = _this$props18.onEndReached, onEndReachedThreshold = _this$props18.onEndReachedThreshold;
        var scrollTop = this._scroll.scrollTop;
        var scrollHeight = this.getTotalRowsHeight();
        var clientHeight = this._getBodyHeight();
        if (!onEndReached || !clientHeight || !scrollHeight) return;
        var distanceFromEnd = scrollHeight - scrollTop - clientHeight + this._horizontalScrollbarSize;
        if (this._lastScannedRowIndex >= 0 && distanceFromEnd <= onEndReachedThreshold && (this._hasDataChangedSinceEndReached || scrollHeight !== this._scrollHeight)) {
            this._hasDataChangedSinceEndReached = false;
            this._scrollHeight = scrollHeight;
            onEndReached({
                distanceFromEnd: distanceFromEnd
            });
        }
    };
    _proto._handleScroll = function _handleScroll(args) {
        var lastScrollTop = this._scroll.scrollTop;
        this.scrollToPosition(args);
        this.props.onScroll(args);
        if (args.scrollTop > lastScrollTop) this._maybeCallOnEndReached();
    };
    _proto._handleVerticalScroll = function _handleVerticalScroll(_ref8) {
        var scrollTop = _ref8.scrollTop;
        var lastScrollTop = this._scroll.scrollTop;
        if (scrollTop !== lastScrollTop) this.scrollToTop(scrollTop);
        if (scrollTop > lastScrollTop) this._maybeCallOnEndReached();
    };
    _proto._handleRowsRendered = function _handleRowsRendered(args) {
        this.props.onRowsRendered(args);
        if (args.overscanStopIndex > this._lastScannedRowIndex) {
            this._lastScannedRowIndex = args.overscanStopIndex;
            this._maybeCallOnEndReached();
        }
    };
    _proto._handleRowHover = function _handleRowHover(_ref9) {
        var hovered = _ref9.hovered, rowKey = _ref9.rowKey;
        this.setState({
            hoveredRowKey: hovered ? rowKey : null
        });
    };
    _proto._handleRowExpand = function _handleRowExpand(_ref10) {
        var expanded = _ref10.expanded, rowData = _ref10.rowData, rowIndex = _ref10.rowIndex, rowKey = _ref10.rowKey;
        var expandedRowKeys = (0, $7h8T1.cloneArray)(this.getExpandedRowKeys());
        if (expanded) {
            if (!expandedRowKeys.indexOf(rowKey) >= 0) expandedRowKeys.push(rowKey);
        } else {
            var index = expandedRowKeys.indexOf(rowKey);
            if (index > -1) expandedRowKeys.splice(index, 1);
        } // if `expandedRowKeys` is uncontrolled, update internal state
        if (this.props.expandedRowKeys === undefined) this.setState({
            expandedRowKeys: expandedRowKeys
        });
        this.props.onRowExpand({
            expanded: expanded,
            rowData: rowData,
            rowIndex: rowIndex,
            rowKey: rowKey
        });
        this.props.onExpandedRowsChange(expandedRowKeys);
    };
    _proto._handleColumnResize = function _handleColumnResize(_ref11, width) {
        var key = _ref11.key;
        this.columnManager.setColumnWidth(key, width);
        this.setState({
            resizingWidth: width
        });
        var column = this.columnManager.getColumn(key);
        this.props.onColumnResize({
            column: column,
            width: width
        });
    };
    _proto._handleColumnResizeStart = function _handleColumnResizeStart(_ref12) {
        var key = _ref12.key;
        this.setState({
            resizingKey: key
        });
    };
    _proto._handleColumnResizeStop = function _handleColumnResizeStop() {
        var _this$state = this.state, resizingKey = _this$state.resizingKey, resizingWidth = _this$state.resizingWidth;
        this.setState({
            resizingKey: null,
            resizingWidth: 0
        });
        if (!resizingKey || !resizingWidth) return;
        var column = this.columnManager.getColumn(resizingKey);
        this.props.onColumnResizeEnd({
            column: column,
            width: resizingWidth
        });
    };
    _proto._handleColumnSort = function _handleColumnSort(event) {
        var key = event.currentTarget.dataset.key;
        var _this$props19 = this.props, sortBy = _this$props19.sortBy, sortState = _this$props19.sortState, onColumnSort = _this$props19.onColumnSort;
        var order = (0, $bFxRm.default).ASC;
        if (sortState) order = sortState[key] === (0, $bFxRm.default).ASC ? (0, $bFxRm.default).DESC : (0, $bFxRm.default).ASC;
        else if (key === sortBy.key) order = sortBy.order === (0, $bFxRm.default).ASC ? (0, $bFxRm.default).DESC : (0, $bFxRm.default).ASC;
        var column = this.columnManager.getColumn(key);
        onColumnSort({
            column: column,
            key: key,
            order: order
        });
    };
    _proto._handleFrozenRowHeightChange = function _handleFrozenRowHeightChange(rowKey, size, rowIndex, frozen) {
        if (!frozen) this._mainRowHeightMap[rowKey] = size;
        else if (frozen === (0, $aymWH.FrozenDirection).RIGHT) this._rightRowHeightMap[rowKey] = size;
        else this._leftRowHeightMap[rowKey] = size;
        var height = Math.max(this._mainRowHeightMap[rowKey] || 0, this._leftRowHeightMap[rowKey] || 0, this._rightRowHeightMap[rowKey] || 0);
        if (this._rowHeightMap[rowKey] !== height) this._handleRowHeightChange(rowKey, height, rowIndex);
    };
    _proto._handleRowHeightChange = function _handleRowHeightChange(rowKey, size, rowIndex) {
        if (this._resetIndex === null) this._resetIndex = rowIndex;
        else if (this._resetIndex > rowIndex) this._resetIndex = rowIndex;
        this._rowHeightMapBuffer[rowKey] = size;
        this._updateRowHeights();
    };
    return BaseTable;
}((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent);
$3f7c386c5bf5ff56$var$BaseTable.Column = (0, $aymWH.default);
$3f7c386c5bf5ff56$var$BaseTable.PlaceholderKey = (0, $i1YES.default).PlaceholderKey;
$3f7c386c5bf5ff56$var$BaseTable.defaultProps = {
    classPrefix: 'BaseTable',
    rowKey: 'id',
    data: [],
    frozenData: [],
    fixed: false,
    headerHeight: 50,
    rowHeight: 50,
    footerHeight: 0,
    defaultExpandedRowKeys: [],
    sortBy: {},
    useIsScrolling: false,
    overscanRowCount: 1,
    onEndReachedThreshold: 500,
    getScrollbarSize: (0, $7h8T1.getScrollbarSize),
    ignoreFunctionInColumnCompare: true,
    onScroll: (0, $7h8T1.noop),
    onRowsRendered: (0, $7h8T1.noop),
    onScrollbarPresenceChange: (0, $7h8T1.noop),
    onRowExpand: (0, $7h8T1.noop),
    onExpandedRowsChange: (0, $7h8T1.noop),
    onColumnSort: (0, $7h8T1.noop),
    onColumnResize: (0, $7h8T1.noop),
    onColumnResizeEnd: (0, $7h8T1.noop)
};
$3f7c386c5bf5ff56$var$BaseTable.propTypes = {
    /**
   * Prefix for table's inner className
   */ classPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    /**
   * Class name for the table
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    /**
   * Custom style for the table
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
    /**
   * A collection of Column
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node,
    /**
   * Columns for the table
   */ columns: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).shape((0, $aymWH.default).propTypes)),
    /**
   * The data for the table
   */ data: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).array.isRequired,
    /**
   * The data be frozen to top, `rowIndex` is negative and started from `-1`
   */ frozenData: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).array,
    /**
   * The key field of each data item
   */ rowKey: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number
    ]).isRequired,
    /**
   * The width of the table
   */ width: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number.isRequired,
    /**
   * The height of the table, will be ignored if `maxHeight` is set
   */ height: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    /**
   * The max height of the table, the table's height will auto change when data changes,
   * will turns to vertical scroll if reaches the max height
   */ maxHeight: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    /**
   * The height of each table row, will be only used by frozen rows if `estimatedRowHeight` is set
   */ rowHeight: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    /**
   * Estimated row height, the real height will be measure dynamically according to the content
   * The callback is of the shape of `({ rowData, rowIndex }) => number`
   */ estimatedRowHeight: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
    ]),
    /**
   * The height of the table header, set to 0 to hide the header, could be an array to render multi headers.
   */ headerHeight: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number)
    ]).isRequired,
    /**
   * The height of the table footer
   */ footerHeight: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    /**
   * Whether the width of the columns are fixed or flexible
   */ fixed: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    /**
   * Whether the table is disabled
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    /**
   * Custom renderer on top of the table component
   */ overlayRenderer: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).element
    ]),
    /**
   * Custom renderer when the length of data is 0
   */ emptyRenderer: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).element
    ]),
    /**
   * Custom footer renderer, available only if `footerHeight` is larger then 0
   */ footerRenderer: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).element
    ]),
    /**
   * Custom header renderer
   * The renderer receives props `{ cells, columns, headerIndex }`
   */ headerRenderer: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).element
    ]),
    /**
   * Custom row renderer
   * The renderer receives props `{ isScrolling, cells, columns, rowData, rowIndex, depth }`
   */ rowRenderer: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).element
    ]),
    /**
   * Class name for the table header, could be a callback to return the class name
   * The callback is of the shape of `({ columns, headerIndex }) => string`
   */ headerClassName: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
    ]),
    /**
   * Class name for the table row, could be a callback to return the class name
   * The callback is of the shape of `({ columns, rowData, rowIndex }) => string`
   */ rowClassName: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
    ]),
    /**
   * Extra props applied to header element
   * The handler is of the shape of `({ columns, headerIndex }) object`
   */ headerProps: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
    ]),
    /**
   * Extra props applied to header cell element
   * The handler is of the shape of `({ columns, column, columnIndex, headerIndex }) => object`
   */ headerCellProps: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
    ]),
    /**
   * Extra props applied to row element
   * The handler is of the shape of `({ columns, rowData, rowIndex }) => object`
   */ rowProps: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
    ]),
    /**
   * Extra props applied to row cell element
   * The handler is of the shape of `({ columns, column, columnIndex, rowData, rowIndex }) => object`
   */ cellProps: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
    ]),
    /**
   * Extra props applied to ExpandIcon component
   * The handler is of the shape of `({ rowData, rowIndex, depth, expandable, expanded }) => object`
   */ expandIconProps: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
    ]),
    /**
   * The key for the expand column which render the expand icon if the data is a tree
   */ expandColumnKey: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    /**
   * Default expanded row keys when initialize the table
   */ defaultExpandedRowKeys: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number
    ])),
    /**
   * Controlled expanded row keys
   */ expandedRowKeys: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number
    ])),
    /**
   * A callback function when expand or collapse a tree node
   * The handler is of the shape of `({ expanded, rowData, rowIndex, rowKey }) => *`
   */ onRowExpand: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    /**
   * A callback function when the expanded row keys changed
   * The handler is of the shape of `(expandedRowKeys) => *`
   */ onExpandedRowsChange: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    /**
   * The sort state for the table, will be ignored if `sortState` is set
   */ sortBy: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).shape({
        /**
     * Sort key
     */ key: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
        /**
     * Sort order
     */ order: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOf([
            (0, $bFxRm.default).ASC,
            (0, $bFxRm.default).DESC
        ])
    }),
    /**
   * Multiple columns sort state for the table
   *
   * example:
   * ```js
   * {
   *   'column-0': SortOrder.ASC,
   *   'column-1': SortOrder.DESC,
   * }
   * ```
   */ sortState: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
    /**
   * A callback function for the header cell click event
   * The handler is of the shape of `({ column, key, order }) => *`
   */ onColumnSort: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    /**
   * A callback function when resizing the column width
   * The handler is of the shape of `({ column, width }) => *`
   */ onColumnResize: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    /**
   * A callback function when resizing the column width ends
   * The handler is of the shape of `({ column, width }) => *`
   */ onColumnResizeEnd: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    /**
   * Adds an additional isScrolling parameter to the row renderer.
   * This parameter can be used to show a placeholder row while scrolling.
   */ useIsScrolling: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    /**
   * Number of rows to render above/below the visible bounds of the list
   */ overscanRowCount: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    /**
   * Custom scrollbar size measurement
   */ getScrollbarSize: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    /**
   * A callback function when scrolling the table
   * The handler is of the shape of `({ scrollLeft, scrollTop, horizontalScrollDirection, verticalScrollDirection, scrollUpdateWasRequested }) => *`
   *
   * `scrollLeft` and `scrollTop` are numbers.
   *
   * `horizontalDirection` and `verticalDirection` are either `forward` or `backward`.
   *
   * `scrollUpdateWasRequested` is a boolean. This value is true if the scroll was caused by `scrollTo*`,
   * and false if it was the result of a user interaction in the browser.
   */ onScroll: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    /**
   * A callback function when scrolling the table within `onEndReachedThreshold` of the bottom
   * The handler is of the shape of `({ distanceFromEnd }) => *`
   */ onEndReached: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    /**
   * Threshold in pixels for calling `onEndReached`.
   */ onEndReachedThreshold: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    /**
   * A callback function with information about the slice of rows that were just rendered
   * The handler is of the shape of `({ overscanStartIndex, overscanStopIndex, startIndex， stopIndex }) => *`
   */ onRowsRendered: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    /**
   * A callback function when the scrollbar presence state changed
   * The handler is of the shape of `({ size, vertical, horizontal }) => *`
   */ onScrollbarPresenceChange: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    /**
   * A object for the row event handlers
   * Each of the keys is row event name, like `onClick`, `onDoubleClick` and etc.
   * Each of the handlers is of the shape of `({ rowData, rowIndex, rowKey, event }) => *`
   */ rowEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
    /**
   * whether to ignore function properties while comparing column definition
   */ ignoreFunctionInColumnCompare: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    /**
   * A object for the custom components, like `ExpandIcon` and `SortIndicator`
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).shape({
        TableCell: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        TableHeaderCell: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        ExpandIcon: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        SortIndicator: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
    })
};
var $3f7c386c5bf5ff56$export$2e2bcd8739ae039 = $3f7c386c5bf5ff56$var$BaseTable;

});
parcelRegister("hjlb6", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("dCUwp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9ebaaafca6cfcfc3$export$2e2bcd8739ae039);
var $9ebaaafca6cfcfc3$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $9ebaaafca6cfcfc3$var$isEqual(first, second) {
    if (first === second) return true;
    if ($9ebaaafca6cfcfc3$var$safeIsNaN(first) && $9ebaaafca6cfcfc3$var$safeIsNaN(second)) return true;
    return false;
}
function $9ebaaafca6cfcfc3$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$9ebaaafca6cfcfc3$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $9ebaaafca6cfcfc3$var$memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $9ebaaafca6cfcfc3$var$areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
var $9ebaaafca6cfcfc3$export$2e2bcd8739ae039 = $9ebaaafca6cfcfc3$var$memoizeOne;

});

parcelRegister("6z2Iy", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c781e9a38c25699$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $6XgOP = parcelRequire("6XgOP");

var $5zQU9 = parcelRequire("5zQU9");

var $aCdHv = parcelRequire("aCdHv");

var $6MEf7 = parcelRequire("6MEf7");

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $hjlb6 = parcelRequire("hjlb6");

var $dmrua = parcelRequire("dmrua");

var $dCUwp = parcelRequire("dCUwp");

var $b1H5u = parcelRequire("b1H5u");

var $7h8T1 = parcelRequire("7h8T1");
function $4c781e9a38c25699$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4c781e9a38c25699$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $4c781e9a38c25699$var$ownKeys(source, true).forEach(function(key) {
            (0, $5zQU9.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $4c781e9a38c25699$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * A wrapper of the Grid for internal only
 */ var $4c781e9a38c25699$var$GridTable = /*#__PURE__*/ function(_React$PureComponent) {
    (0, $6MEf7.default)(GridTable, _React$PureComponent);
    function GridTable(props) {
        var _this;
        _this = _React$PureComponent.call(this, props) || this;
        _this._setHeaderRef = _this._setHeaderRef.bind((0, $aCdHv.default)(_this));
        _this._setBodyRef = _this._setBodyRef.bind((0, $aCdHv.default)(_this));
        _this._setInnerRef = _this._setInnerRef.bind((0, $aCdHv.default)(_this));
        _this._itemKey = _this._itemKey.bind((0, $aCdHv.default)(_this));
        _this._getBodyWidth = _this._getBodyWidth.bind((0, $aCdHv.default)(_this));
        _this._handleItemsRendered = _this._handleItemsRendered.bind((0, $aCdHv.default)(_this));
        _this._resetColumnWidthCache = (0, $dCUwp.default)(function(bodyWidth) {
            if (!_this.props.estimatedRowHeight) return;
            _this.bodyRef && _this.bodyRef.resetAfterColumnIndex(0, false);
        });
        _this._getEstimatedTotalRowsHeight = (0, $dCUwp.default)((0, $7h8T1.getEstimatedTotalRowsHeight));
        _this.renderRow = _this.renderRow.bind((0, $aCdHv.default)(_this));
        return _this;
    }
    var _proto = GridTable.prototype;
    _proto.resetAfterRowIndex = function resetAfterRowIndex(rowIndex, shouldForceUpdate) {
        if (rowIndex === void 0) rowIndex = 0;
        if (!this.props.estimatedRowHeight) return;
        this.bodyRef && this.bodyRef.resetAfterRowIndex(rowIndex, shouldForceUpdate);
    };
    _proto.forceUpdateTable = function forceUpdateTable() {
        this.headerRef && this.headerRef.forceUpdate();
        this.bodyRef && this.bodyRef.forceUpdate();
    };
    _proto.scrollToPosition = function scrollToPosition(args) {
        this.headerRef && this.headerRef.scrollTo(args.scrollLeft);
        this.bodyRef && this.bodyRef.scrollTo(args);
    };
    _proto.scrollToTop = function scrollToTop(scrollTop) {
        this.bodyRef && this.bodyRef.scrollTo({
            scrollTop: scrollTop
        });
    };
    _proto.scrollToLeft = function scrollToLeft(scrollLeft) {
        this.headerRef && this.headerRef.scrollTo(scrollLeft);
        this.bodyRef && this.bodyRef.scrollToPosition({
            scrollLeft: scrollLeft
        });
    };
    _proto.scrollToRow = function scrollToRow(rowIndex, align) {
        if (rowIndex === void 0) rowIndex = 0;
        if (align === void 0) align = 'auto';
        this.bodyRef && this.bodyRef.scrollToItem({
            rowIndex: rowIndex,
            align: align
        });
    };
    _proto.getTotalRowsHeight = function getTotalRowsHeight() {
        var _this$props = this.props, data = _this$props.data, rowHeight = _this$props.rowHeight, estimatedRowHeight = _this$props.estimatedRowHeight;
        if (estimatedRowHeight) return this.innerRef && this.innerRef.clientHeight || this._getEstimatedTotalRowsHeight(data, estimatedRowHeight);
        return data.length * rowHeight;
    };
    _proto.renderRow = function renderRow(args) {
        var _this$props2 = this.props, data = _this$props2.data, columns = _this$props2.columns, rowRenderer = _this$props2.rowRenderer;
        var rowData = data[args.rowIndex];
        return rowRenderer($4c781e9a38c25699$var$_objectSpread({}, args, {
            columns: columns,
            rowData: rowData
        }));
    };
    _proto.render = function render() {
        var _this$props3 = this.props, containerStyle = _this$props3.containerStyle, classPrefix = _this$props3.classPrefix, className = _this$props3.className, data = _this$props3.data, frozenData = _this$props3.frozenData, width = _this$props3.width, height = _this$props3.height, rowHeight = _this$props3.rowHeight, estimatedRowHeight = _this$props3.estimatedRowHeight, getRowHeight = _this$props3.getRowHeight, headerWidth = _this$props3.headerWidth, bodyWidth = _this$props3.bodyWidth, useIsScrolling = _this$props3.useIsScrolling, onScroll = _this$props3.onScroll, hoveredRowKey = _this$props3.hoveredRowKey, overscanRowCount = _this$props3.overscanRowCount, style = _this$props3.style, onScrollbarPresenceChange = _this$props3.onScrollbarPresenceChange, rest = (0, $6XgOP.default)(_this$props3, [
            "containerStyle",
            "classPrefix",
            "className",
            "data",
            "frozenData",
            "width",
            "height",
            "rowHeight",
            "estimatedRowHeight",
            "getRowHeight",
            "headerWidth",
            "bodyWidth",
            "useIsScrolling",
            "onScroll",
            "hoveredRowKey",
            "overscanRowCount",
            "style",
            "onScrollbarPresenceChange"
        ]);
        var headerHeight = this._getHeaderHeight();
        var frozenRowCount = frozenData.length;
        var frozenRowsHeight = rowHeight * frozenRowCount;
        var cls = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))(classPrefix + "__table", className);
        var containerProps = containerStyle ? {
            style: containerStyle
        } : null;
        var Grid = estimatedRowHeight ? (0, $dmrua.VariableSizeGrid) : (0, $dmrua.FixedSizeGrid);
        this._resetColumnWidthCache(bodyWidth);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", (0, $kU09D.default)({
            role: "table",
            className: cls
        }, containerProps), (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Grid, (0, $kU09D.default)({}, rest, {
            className: classPrefix + "__body",
            ref: this._setBodyRef,
            innerRef: this._setInnerRef,
            itemKey: this._itemKey,
            data: data,
            frozenData: frozenData,
            width: width,
            height: Math.max(height - headerHeight - frozenRowsHeight, 0),
            rowHeight: estimatedRowHeight ? getRowHeight : rowHeight,
            estimatedRowHeight: typeof estimatedRowHeight === 'function' ? undefined : estimatedRowHeight,
            rowCount: data.length,
            overscanRowCount: overscanRowCount,
            columnWidth: estimatedRowHeight ? this._getBodyWidth : bodyWidth,
            columnCount: 1,
            overscanColumnCount: 0,
            useIsScrolling: useIsScrolling,
            hoveredRowKey: hoveredRowKey,
            onScroll: onScroll,
            onItemsRendered: this._handleItemsRendered,
            children: this.renderRow
        })), headerHeight + frozenRowsHeight > 0 && // put header after body and reverse the display order via css
        // to prevent header's shadow being covered by body
        (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b1H5u.default), (0, $kU09D.default)({}, rest, {
            className: classPrefix + "__header",
            ref: this._setHeaderRef,
            data: data,
            frozenData: frozenData,
            width: width,
            height: Math.min(headerHeight + frozenRowsHeight, height),
            rowWidth: headerWidth,
            rowHeight: rowHeight,
            headerHeight: this.props.headerHeight,
            headerRenderer: this.props.headerRenderer,
            rowRenderer: this.props.rowRenderer,
            hoveredRowKey: frozenRowCount > 0 ? hoveredRowKey : null
        })));
    };
    _proto._setHeaderRef = function _setHeaderRef(ref) {
        this.headerRef = ref;
    };
    _proto._setBodyRef = function _setBodyRef(ref) {
        this.bodyRef = ref;
    };
    _proto._setInnerRef = function _setInnerRef(ref) {
        this.innerRef = ref;
    };
    _proto._itemKey = function _itemKey(_ref) {
        var rowIndex = _ref.rowIndex;
        var _this$props4 = this.props, data = _this$props4.data, rowKey = _this$props4.rowKey;
        return data[rowIndex][rowKey];
    };
    _proto._getHeaderHeight = function _getHeaderHeight() {
        var headerHeight = this.props.headerHeight;
        if (Array.isArray(headerHeight)) return headerHeight.reduce(function(sum, height) {
            return sum + height;
        }, 0);
        return headerHeight;
    };
    _proto._getBodyWidth = function _getBodyWidth() {
        return this.props.bodyWidth;
    };
    _proto._handleItemsRendered = function _handleItemsRendered(_ref2) {
        var overscanRowStartIndex = _ref2.overscanRowStartIndex, overscanRowStopIndex = _ref2.overscanRowStopIndex, visibleRowStartIndex = _ref2.visibleRowStartIndex, visibleRowStopIndex = _ref2.visibleRowStopIndex;
        this.props.onRowsRendered({
            overscanStartIndex: overscanRowStartIndex,
            overscanStopIndex: overscanRowStopIndex,
            startIndex: visibleRowStartIndex,
            stopIndex: visibleRowStopIndex
        });
    };
    return GridTable;
}((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent);
$4c781e9a38c25699$var$GridTable.propTypes = {
    containerStyle: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
    classPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number.isRequired,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number.isRequired,
    headerHeight: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number)
    ]).isRequired,
    headerWidth: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number.isRequired,
    bodyWidth: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number.isRequired,
    rowHeight: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number.isRequired,
    estimatedRowHeight: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number
    ]),
    getRowHeight: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    columns: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object).isRequired,
    data: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).array.isRequired,
    frozenData: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).array,
    rowKey: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number
    ]).isRequired,
    useIsScrolling: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    overscanRowCount: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    hoveredRowKey: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number
    ]),
    style: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
    onScrollbarPresenceChange: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    onScroll: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    onRowsRendered: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    headerRenderer: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    rowRenderer: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired
};
var $4c781e9a38c25699$export$2e2bcd8739ae039 = $4c781e9a38c25699$var$GridTable;

});
parcelRegister("dmrua", function(module, exports) {

$parcel$export(module.exports, "VariableSizeGrid", () => $9ba2a6856f422a0d$export$32c206c84102e73c);
$parcel$export(module.exports, "FixedSizeGrid", () => $9ba2a6856f422a0d$export$f331158cccad7361);

var $kU09D = parcelRequire("kU09D");

var $6MEf7 = parcelRequire("6MEf7");

var $aCdHv = parcelRequire("aCdHv");

var $dCUwp = parcelRequire("dCUwp");

var $eUqFw = parcelRequire("eUqFw");

var $6XgOP = parcelRequire("6XgOP");
// Animation frame based implementation of setTimeout.
// Inspired by Joe Lambert, https://gist.github.com/joelambert/1002116#file-requesttimeout-js
var $9ba2a6856f422a0d$var$hasNativePerformanceNow = typeof performance === 'object' && typeof performance.now === 'function';
var $9ba2a6856f422a0d$var$now = $9ba2a6856f422a0d$var$hasNativePerformanceNow ? function() {
    return performance.now();
} : function() {
    return Date.now();
};
function $9ba2a6856f422a0d$var$cancelTimeout(timeoutID) {
    cancelAnimationFrame(timeoutID.id);
}
function $9ba2a6856f422a0d$var$requestTimeout(callback, delay) {
    var start = $9ba2a6856f422a0d$var$now();
    function tick() {
        if ($9ba2a6856f422a0d$var$now() - start >= delay) callback.call(null);
        else timeoutID.id = requestAnimationFrame(tick);
    }
    var timeoutID = {
        id: requestAnimationFrame(tick)
    };
    return timeoutID;
}
var $9ba2a6856f422a0d$var$size = -1; // This utility copied from "dom-helpers" package.
function $9ba2a6856f422a0d$var$getScrollbarSize(recalculate) {
    if (recalculate === void 0) recalculate = false;
    if ($9ba2a6856f422a0d$var$size === -1 || recalculate) {
        var div = document.createElement('div');
        var style = div.style;
        style.width = '50px';
        style.height = '50px';
        style.overflow = 'scroll';
        document.body.appendChild(div);
        $9ba2a6856f422a0d$var$size = div.offsetWidth - div.clientWidth;
        document.body.removeChild(div);
    }
    return $9ba2a6856f422a0d$var$size;
}
var $9ba2a6856f422a0d$var$cachedRTLResult = null; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
// Chrome does not seem to adhere; its scrollLeft values are positive (measured relative to the left).
// Safari's elastic bounce makes detecting this even more complicated wrt potential false positives.
// The safest way to check this is to intentionally set a negative offset,
// and then verify that the subsequent "scroll" event matches the negative offset.
// If it does not match, then we can assume a non-standard RTL scroll implementation.
function $9ba2a6856f422a0d$var$getRTLOffsetType(recalculate) {
    if (recalculate === void 0) recalculate = false;
    if ($9ba2a6856f422a0d$var$cachedRTLResult === null || recalculate) {
        var outerDiv = document.createElement('div');
        var outerStyle = outerDiv.style;
        outerStyle.width = '50px';
        outerStyle.height = '50px';
        outerStyle.overflow = 'scroll';
        outerStyle.direction = 'rtl';
        var innerDiv = document.createElement('div');
        var innerStyle = innerDiv.style;
        innerStyle.width = '100px';
        innerStyle.height = '100px';
        outerDiv.appendChild(innerDiv);
        document.body.appendChild(outerDiv);
        if (outerDiv.scrollLeft > 0) $9ba2a6856f422a0d$var$cachedRTLResult = 'positive-descending';
        else {
            outerDiv.scrollLeft = 1;
            if (outerDiv.scrollLeft === 0) $9ba2a6856f422a0d$var$cachedRTLResult = 'negative';
            else $9ba2a6856f422a0d$var$cachedRTLResult = 'positive-ascending';
        }
        document.body.removeChild(outerDiv);
        return $9ba2a6856f422a0d$var$cachedRTLResult;
    }
    return $9ba2a6856f422a0d$var$cachedRTLResult;
}
var $9ba2a6856f422a0d$var$IS_SCROLLING_DEBOUNCE_INTERVAL = 150;
var $9ba2a6856f422a0d$var$defaultItemKey = function defaultItemKey(_ref) {
    var columnIndex = _ref.columnIndex, data = _ref.data, rowIndex = _ref.rowIndex;
    return rowIndex + ":" + columnIndex;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.
var $9ba2a6856f422a0d$var$devWarningsOverscanCount = null;
var $9ba2a6856f422a0d$var$devWarningsOverscanRowsColumnsCount = null;
var $9ba2a6856f422a0d$var$devWarningsTagName = null;
function $9ba2a6856f422a0d$var$createGridComponent(_ref2) {
    var _class, _temp;
    var getColumnOffset = _ref2.getColumnOffset, getColumnStartIndexForOffset = _ref2.getColumnStartIndexForOffset, getColumnStopIndexForStartIndex = _ref2.getColumnStopIndexForStartIndex, getColumnWidth = _ref2.getColumnWidth, getEstimatedTotalHeight = _ref2.getEstimatedTotalHeight, getEstimatedTotalWidth = _ref2.getEstimatedTotalWidth, getOffsetForColumnAndAlignment = _ref2.getOffsetForColumnAndAlignment, getOffsetForRowAndAlignment = _ref2.getOffsetForRowAndAlignment, getRowHeight = _ref2.getRowHeight, getRowOffset = _ref2.getRowOffset, getRowStartIndexForOffset = _ref2.getRowStartIndexForOffset, getRowStopIndexForStartIndex = _ref2.getRowStopIndexForStartIndex, initInstanceProps = _ref2.initInstanceProps, shouldResetStyleCacheOnItemSizeChange = _ref2.shouldResetStyleCacheOnItemSizeChange, validateProps = _ref2.validateProps;
    return _temp = _class = /*#__PURE__*/ function(_PureComponent) {
        (0, $6MEf7.default)(Grid, _PureComponent);
        // Always use explicit constructor for React components.
        // It produces less code after transpilation. (#26)
        // eslint-disable-next-line no-useless-constructor
        function Grid(props) {
            var _this;
            _this = _PureComponent.call(this, props) || this;
            _this._instanceProps = initInstanceProps(_this.props, (0, $aCdHv.default)((0, $aCdHv.default)(_this)));
            _this._resetIsScrollingTimeoutId = null;
            _this._outerRef = void 0;
            _this.state = {
                instance: (0, $aCdHv.default)((0, $aCdHv.default)(_this)),
                isScrolling: false,
                horizontalScrollDirection: 'forward',
                scrollLeft: typeof _this.props.initialScrollLeft === 'number' ? _this.props.initialScrollLeft : 0,
                scrollTop: typeof _this.props.initialScrollTop === 'number' ? _this.props.initialScrollTop : 0,
                scrollUpdateWasRequested: false,
                verticalScrollDirection: 'forward'
            };
            _this._callOnItemsRendered = void 0;
            _this._callOnItemsRendered = (0, $dCUwp.default)(function(overscanColumnStartIndex, overscanColumnStopIndex, overscanRowStartIndex, overscanRowStopIndex, visibleColumnStartIndex, visibleColumnStopIndex, visibleRowStartIndex, visibleRowStopIndex) {
                return _this.props.onItemsRendered({
                    overscanColumnStartIndex: overscanColumnStartIndex,
                    overscanColumnStopIndex: overscanColumnStopIndex,
                    overscanRowStartIndex: overscanRowStartIndex,
                    overscanRowStopIndex: overscanRowStopIndex,
                    visibleColumnStartIndex: visibleColumnStartIndex,
                    visibleColumnStopIndex: visibleColumnStopIndex,
                    visibleRowStartIndex: visibleRowStartIndex,
                    visibleRowStopIndex: visibleRowStopIndex
                });
            });
            _this._callOnScroll = void 0;
            _this._callOnScroll = (0, $dCUwp.default)(function(scrollLeft, scrollTop, horizontalScrollDirection, verticalScrollDirection, scrollUpdateWasRequested) {
                return _this.props.onScroll({
                    horizontalScrollDirection: horizontalScrollDirection,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    verticalScrollDirection: verticalScrollDirection,
                    scrollUpdateWasRequested: scrollUpdateWasRequested
                });
            });
            _this._getItemStyle = void 0;
            _this._getItemStyle = function(rowIndex, columnIndex) {
                var _this$props = _this.props, columnWidth = _this$props.columnWidth, direction = _this$props.direction, rowHeight = _this$props.rowHeight;
                var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && columnWidth, shouldResetStyleCacheOnItemSizeChange && direction, shouldResetStyleCacheOnItemSizeChange && rowHeight);
                var key = rowIndex + ":" + columnIndex;
                var style;
                if (itemStyleCache.hasOwnProperty(key)) style = itemStyleCache[key];
                else {
                    var _offset = getColumnOffset(_this.props, columnIndex, _this._instanceProps);
                    var isRtl = direction === 'rtl';
                    itemStyleCache[key] = style = {
                        position: 'absolute',
                        left: isRtl ? undefined : _offset,
                        right: isRtl ? _offset : undefined,
                        top: getRowOffset(_this.props, rowIndex, _this._instanceProps),
                        height: getRowHeight(_this.props, rowIndex, _this._instanceProps),
                        width: getColumnWidth(_this.props, columnIndex, _this._instanceProps)
                    };
                }
                return style;
            };
            _this._getItemStyleCache = void 0;
            _this._getItemStyleCache = (0, $dCUwp.default)(function(_, __, ___) {
                return {};
            });
            _this._onScroll = function(event) {
                var _event$currentTarget = event.currentTarget, clientHeight = _event$currentTarget.clientHeight, clientWidth = _event$currentTarget.clientWidth, scrollLeft = _event$currentTarget.scrollLeft, scrollTop = _event$currentTarget.scrollTop, scrollHeight = _event$currentTarget.scrollHeight, scrollWidth = _event$currentTarget.scrollWidth;
                _this.setState(function(prevState) {
                    if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                    var direction = _this.props.direction; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
                    // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.
                    var calculatedScrollLeft = scrollLeft;
                    if (direction === 'rtl') switch($9ba2a6856f422a0d$var$getRTLOffsetType()){
                        case 'negative':
                            calculatedScrollLeft = -scrollLeft;
                            break;
                        case 'positive-descending':
                            calculatedScrollLeft = scrollWidth - clientWidth - scrollLeft;
                            break;
                    }
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    calculatedScrollLeft = Math.max(0, Math.min(calculatedScrollLeft, scrollWidth - clientWidth));
                    var calculatedScrollTop = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
                    return {
                        isScrolling: true,
                        horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? 'forward' : 'backward',
                        scrollLeft: calculatedScrollLeft,
                        scrollTop: calculatedScrollTop,
                        verticalScrollDirection: prevState.scrollTop < scrollTop ? 'forward' : 'backward',
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._outerRefSetter = function(ref) {
                var outerRef = _this.props.outerRef;
                _this._outerRef = ref;
                if (typeof outerRef === 'function') outerRef(ref);
                else if (outerRef != null && typeof outerRef === 'object' && outerRef.hasOwnProperty('current')) outerRef.current = ref;
            };
            _this._resetIsScrollingDebounced = function() {
                if (_this._resetIsScrollingTimeoutId !== null) $9ba2a6856f422a0d$var$cancelTimeout(_this._resetIsScrollingTimeoutId);
                _this._resetIsScrollingTimeoutId = $9ba2a6856f422a0d$var$requestTimeout(_this._resetIsScrolling, $9ba2a6856f422a0d$var$IS_SCROLLING_DEBOUNCE_INTERVAL);
            };
            _this._resetIsScrolling = function() {
                _this._resetIsScrollingTimeoutId = null;
                _this.setState({
                    isScrolling: false
                }, function() {
                    // Clear style cache after state update has been committed.
                    // This way we don't break pure sCU for items that don't use isScrolling param.
                    _this._getItemStyleCache(-1);
                });
            };
            return _this;
        }
        Grid.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            $9ba2a6856f422a0d$var$validateSharedProps(nextProps, prevState);
            validateProps(nextProps);
            return null;
        };
        var _proto = Grid.prototype;
        _proto.scrollTo = function scrollTo(_ref3) {
            var scrollLeft = _ref3.scrollLeft, scrollTop = _ref3.scrollTop;
            if (scrollLeft !== undefined) scrollLeft = Math.max(0, scrollLeft);
            if (scrollTop !== undefined) scrollTop = Math.max(0, scrollTop);
            this.setState(function(prevState) {
                if (scrollLeft === undefined) scrollLeft = prevState.scrollLeft;
                if (scrollTop === undefined) scrollTop = prevState.scrollTop;
                if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) return null;
                return {
                    horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? 'forward' : 'backward',
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    scrollUpdateWasRequested: true,
                    verticalScrollDirection: prevState.scrollTop < scrollTop ? 'forward' : 'backward'
                };
            }, this._resetIsScrollingDebounced);
        };
        _proto.scrollToItem = function scrollToItem(_ref4) {
            var _ref4$align = _ref4.align, align = _ref4$align === void 0 ? 'auto' : _ref4$align, columnIndex = _ref4.columnIndex, rowIndex = _ref4.rowIndex;
            var _this$props2 = this.props, columnCount = _this$props2.columnCount, height = _this$props2.height, rowCount = _this$props2.rowCount, width = _this$props2.width;
            var _this$state = this.state, scrollLeft = _this$state.scrollLeft, scrollTop = _this$state.scrollTop;
            var scrollbarSize = $9ba2a6856f422a0d$var$getScrollbarSize();
            if (columnIndex !== undefined) columnIndex = Math.max(0, Math.min(columnIndex, columnCount - 1));
            if (rowIndex !== undefined) rowIndex = Math.max(0, Math.min(rowIndex, rowCount - 1));
            var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
            var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps); // The scrollbar size should be considered when scrolling an item into view,
            // to ensure it's fully visible.
            // But we only need to account for its size when it's actually visible.
            var horizontalScrollbarSize = estimatedTotalWidth > width ? scrollbarSize : 0;
            var verticalScrollbarSize = estimatedTotalHeight > height ? scrollbarSize : 0;
            this.scrollTo({
                scrollLeft: columnIndex !== undefined ? getOffsetForColumnAndAlignment(this.props, columnIndex, align, scrollLeft, this._instanceProps, verticalScrollbarSize) : scrollLeft,
                scrollTop: rowIndex !== undefined ? getOffsetForRowAndAlignment(this.props, rowIndex, align, scrollTop, this._instanceProps, horizontalScrollbarSize) : scrollTop
            });
        };
        _proto.componentDidMount = function componentDidMount() {
            var _this$props3 = this.props, initialScrollLeft = _this$props3.initialScrollLeft, initialScrollTop = _this$props3.initialScrollTop;
            if (this._outerRef != null) {
                var outerRef = this._outerRef;
                if (typeof initialScrollLeft === 'number') outerRef.scrollLeft = initialScrollLeft;
                if (typeof initialScrollTop === 'number') outerRef.scrollTop = initialScrollTop;
            }
            this._callPropsCallbacks();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            var direction = this.props.direction;
            var _this$state2 = this.state, scrollLeft = _this$state2.scrollLeft, scrollTop = _this$state2.scrollTop, scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;
            if (scrollUpdateWasRequested && this._outerRef != null) {
                // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                // So we need to determine which browser behavior we're dealing with, and mimic it.
                var outerRef = this._outerRef;
                if (direction === 'rtl') switch($9ba2a6856f422a0d$var$getRTLOffsetType()){
                    case 'negative':
                        outerRef.scrollLeft = -scrollLeft;
                        break;
                    case 'positive-ascending':
                        outerRef.scrollLeft = scrollLeft;
                        break;
                    default:
                        var clientWidth = outerRef.clientWidth, scrollWidth = outerRef.scrollWidth;
                        outerRef.scrollLeft = scrollWidth - clientWidth - scrollLeft;
                        break;
                }
                else outerRef.scrollLeft = Math.max(0, scrollLeft);
                outerRef.scrollTop = Math.max(0, scrollTop);
            }
            this._callPropsCallbacks();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            if (this._resetIsScrollingTimeoutId !== null) $9ba2a6856f422a0d$var$cancelTimeout(this._resetIsScrollingTimeoutId);
        };
        _proto.render = function render() {
            var _this$props4 = this.props, children = _this$props4.children, className = _this$props4.className, columnCount = _this$props4.columnCount, direction = _this$props4.direction, height = _this$props4.height, innerRef = _this$props4.innerRef, innerElementType = _this$props4.innerElementType, innerTagName = _this$props4.innerTagName, itemData = _this$props4.itemData, _this$props4$itemKey = _this$props4.itemKey, itemKey = _this$props4$itemKey === void 0 ? $9ba2a6856f422a0d$var$defaultItemKey : _this$props4$itemKey, outerElementType = _this$props4.outerElementType, outerTagName = _this$props4.outerTagName, rowCount = _this$props4.rowCount, style = _this$props4.style, useIsScrolling = _this$props4.useIsScrolling, width = _this$props4.width;
            var isScrolling = this.state.isScrolling;
            var _this$_getHorizontalR = this._getHorizontalRangeToRender(), columnStartIndex = _this$_getHorizontalR[0], columnStopIndex = _this$_getHorizontalR[1];
            var _this$_getVerticalRan = this._getVerticalRangeToRender(), rowStartIndex = _this$_getVerticalRan[0], rowStopIndex = _this$_getVerticalRan[1];
            var items = [];
            if (columnCount > 0 && rowCount) {
                for(var _rowIndex = rowStartIndex; _rowIndex <= rowStopIndex; _rowIndex++)for(var _columnIndex = columnStartIndex; _columnIndex <= columnStopIndex; _columnIndex++)items.push((0, $eUqFw.createElement)(children, {
                    columnIndex: _columnIndex,
                    data: itemData,
                    isScrolling: useIsScrolling ? isScrolling : undefined,
                    key: itemKey({
                        columnIndex: _columnIndex,
                        data: itemData,
                        rowIndex: _rowIndex
                    }),
                    rowIndex: _rowIndex,
                    style: this._getItemStyle(_rowIndex, _columnIndex)
                }));
            } // Read this value AFTER items have been created,
            // So their actual sizes (if variable) are taken into consideration.
            var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
            var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps);
            return (0, $eUqFw.createElement)(outerElementType || outerTagName || 'div', {
                className: className,
                onScroll: this._onScroll,
                ref: this._outerRefSetter,
                style: (0, $kU09D.default)({
                    position: 'relative',
                    height: height,
                    width: width,
                    overflow: 'auto',
                    WebkitOverflowScrolling: 'touch',
                    willChange: 'transform',
                    direction: direction
                }, style)
            }, (0, $eUqFw.createElement)(innerElementType || innerTagName || 'div', {
                children: items,
                ref: innerRef,
                style: {
                    height: estimatedTotalHeight,
                    pointerEvents: isScrolling ? 'none' : undefined,
                    width: estimatedTotalWidth
                }
            }));
        };
        _proto._callPropsCallbacks = function _callPropsCallbacks() {
            var _this$props5 = this.props, columnCount = _this$props5.columnCount, onItemsRendered = _this$props5.onItemsRendered, onScroll = _this$props5.onScroll, rowCount = _this$props5.rowCount;
            if (typeof onItemsRendered === 'function') {
                if (columnCount > 0 && rowCount > 0) {
                    var _this$_getHorizontalR2 = this._getHorizontalRangeToRender(), _overscanColumnStartIndex = _this$_getHorizontalR2[0], _overscanColumnStopIndex = _this$_getHorizontalR2[1], _visibleColumnStartIndex = _this$_getHorizontalR2[2], _visibleColumnStopIndex = _this$_getHorizontalR2[3];
                    var _this$_getVerticalRan2 = this._getVerticalRangeToRender(), _overscanRowStartIndex = _this$_getVerticalRan2[0], _overscanRowStopIndex = _this$_getVerticalRan2[1], _visibleRowStartIndex = _this$_getVerticalRan2[2], _visibleRowStopIndex = _this$_getVerticalRan2[3];
                    this._callOnItemsRendered(_overscanColumnStartIndex, _overscanColumnStopIndex, _overscanRowStartIndex, _overscanRowStopIndex, _visibleColumnStartIndex, _visibleColumnStopIndex, _visibleRowStartIndex, _visibleRowStopIndex);
                }
            }
            if (typeof onScroll === 'function') {
                var _this$state3 = this.state, _horizontalScrollDirection = _this$state3.horizontalScrollDirection, _scrollLeft = _this$state3.scrollLeft, _scrollTop = _this$state3.scrollTop, _scrollUpdateWasRequested = _this$state3.scrollUpdateWasRequested, _verticalScrollDirection = _this$state3.verticalScrollDirection;
                this._callOnScroll(_scrollLeft, _scrollTop, _horizontalScrollDirection, _verticalScrollDirection, _scrollUpdateWasRequested);
            }
        }; // Lazily create and cache item styles while scrolling,
        // So that pure component sCU will prevent re-renders.
        // We maintain this cache, and pass a style prop rather than index,
        // So that List can clear cached styles and force item re-render if necessary.
        _proto._getHorizontalRangeToRender = function _getHorizontalRangeToRender() {
            var _this$props6 = this.props, columnCount = _this$props6.columnCount, overscanColumnCount = _this$props6.overscanColumnCount, overscanColumnsCount = _this$props6.overscanColumnsCount, overscanCount = _this$props6.overscanCount, rowCount = _this$props6.rowCount;
            var _this$state4 = this.state, horizontalScrollDirection = _this$state4.horizontalScrollDirection, isScrolling = _this$state4.isScrolling, scrollLeft = _this$state4.scrollLeft;
            var overscanCountResolved = overscanColumnCount || overscanColumnsCount || overscanCount || 1;
            if (columnCount === 0 || rowCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getColumnStartIndexForOffset(this.props, scrollLeft, this._instanceProps);
            var stopIndex = getColumnStopIndexForStartIndex(this.props, startIndex, scrollLeft, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || horizontalScrollDirection === 'backward' ? Math.max(1, overscanCountResolved) : 1;
            var overscanForward = !isScrolling || horizontalScrollDirection === 'forward' ? Math.max(1, overscanCountResolved) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(columnCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        _proto._getVerticalRangeToRender = function _getVerticalRangeToRender() {
            var _this$props7 = this.props, columnCount = _this$props7.columnCount, overscanCount = _this$props7.overscanCount, overscanRowCount = _this$props7.overscanRowCount, overscanRowsCount = _this$props7.overscanRowsCount, rowCount = _this$props7.rowCount;
            var _this$state5 = this.state, isScrolling = _this$state5.isScrolling, verticalScrollDirection = _this$state5.verticalScrollDirection, scrollTop = _this$state5.scrollTop;
            var overscanCountResolved = overscanRowCount || overscanRowsCount || overscanCount || 1;
            if (columnCount === 0 || rowCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getRowStartIndexForOffset(this.props, scrollTop, this._instanceProps);
            var stopIndex = getRowStopIndexForStartIndex(this.props, startIndex, scrollTop, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || verticalScrollDirection === 'backward' ? Math.max(1, overscanCountResolved) : 1;
            var overscanForward = !isScrolling || verticalScrollDirection === 'forward' ? Math.max(1, overscanCountResolved) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(rowCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        return Grid;
    }((0, $eUqFw.PureComponent)), _class.defaultProps = {
        direction: 'ltr',
        itemData: undefined,
        useIsScrolling: false
    }, _temp;
}
var $9ba2a6856f422a0d$var$validateSharedProps = function validateSharedProps(_ref5, _ref6) {
    var children = _ref5.children, direction = _ref5.direction, height = _ref5.height, innerTagName = _ref5.innerTagName, outerTagName = _ref5.outerTagName, overscanColumnsCount = _ref5.overscanColumnsCount, overscanCount = _ref5.overscanCount, overscanRowsCount = _ref5.overscanRowsCount, width = _ref5.width;
    var instance = _ref6.instance;
};
var $9ba2a6856f422a0d$var$DEFAULT_ESTIMATED_ITEM_SIZE = 50;
var $9ba2a6856f422a0d$var$getEstimatedTotalHeight = function getEstimatedTotalHeight(_ref, _ref2) {
    var rowCount = _ref.rowCount;
    var rowMetadataMap = _ref2.rowMetadataMap, estimatedRowHeight = _ref2.estimatedRowHeight, lastMeasuredRowIndex = _ref2.lastMeasuredRowIndex;
    var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredRowIndex >= rowCount) lastMeasuredRowIndex = rowCount - 1;
    if (lastMeasuredRowIndex >= 0) {
        var itemMetadata = rowMetadataMap[lastMeasuredRowIndex];
        totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = rowCount - lastMeasuredRowIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedRowHeight;
    return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};
var $9ba2a6856f422a0d$var$getEstimatedTotalWidth = function getEstimatedTotalWidth(_ref3, _ref4) {
    var columnCount = _ref3.columnCount;
    var columnMetadataMap = _ref4.columnMetadataMap, estimatedColumnWidth = _ref4.estimatedColumnWidth, lastMeasuredColumnIndex = _ref4.lastMeasuredColumnIndex;
    var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredColumnIndex >= columnCount) lastMeasuredColumnIndex = columnCount - 1;
    if (lastMeasuredColumnIndex >= 0) {
        var itemMetadata = columnMetadataMap[lastMeasuredColumnIndex];
        totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = columnCount - lastMeasuredColumnIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedColumnWidth;
    return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};
var $9ba2a6856f422a0d$var$getItemMetadata = function getItemMetadata(itemType, props, index, instanceProps) {
    var itemMetadataMap, itemSize, lastMeasuredIndex;
    if (itemType === 'column') {
        itemMetadataMap = instanceProps.columnMetadataMap;
        itemSize = props.columnWidth;
        lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
    } else {
        itemMetadataMap = instanceProps.rowMetadataMap;
        itemSize = props.rowHeight;
        lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
    }
    if (index > lastMeasuredIndex) {
        var offset = 0;
        if (lastMeasuredIndex >= 0) {
            var itemMetadata = itemMetadataMap[lastMeasuredIndex];
            offset = itemMetadata.offset + itemMetadata.size;
        }
        for(var i = lastMeasuredIndex + 1; i <= index; i++){
            var size = itemSize(i);
            itemMetadataMap[i] = {
                offset: offset,
                size: size
            };
            offset += size;
        }
        if (itemType === 'column') instanceProps.lastMeasuredColumnIndex = index;
        else instanceProps.lastMeasuredRowIndex = index;
    }
    return itemMetadataMap[index];
};
var $9ba2a6856f422a0d$var$findNearestItem = function findNearestItem(itemType, props, instanceProps, offset) {
    var itemMetadataMap, lastMeasuredIndex;
    if (itemType === 'column') {
        itemMetadataMap = instanceProps.columnMetadataMap;
        lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
    } else {
        itemMetadataMap = instanceProps.rowMetadataMap;
        lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
    }
    var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;
    if (lastMeasuredItemOffset >= offset) // If we've already measured items within this range just use a binary search as it's faster.
    return $9ba2a6856f422a0d$var$findNearestItemBinarySearch(itemType, props, instanceProps, lastMeasuredIndex, 0, offset);
    else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return $9ba2a6856f422a0d$var$findNearestItemExponentialSearch(itemType, props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
};
var $9ba2a6856f422a0d$var$findNearestItemBinarySearch = function findNearestItemBinarySearch(itemType, props, instanceProps, high, low, offset) {
    while(low <= high){
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = $9ba2a6856f422a0d$var$getItemMetadata(itemType, props, middle, instanceProps).offset;
        if (currentOffset === offset) return middle;
        else if (currentOffset < offset) low = middle + 1;
        else if (currentOffset > offset) high = middle - 1;
    }
    if (low > 0) return low - 1;
    else return 0;
};
var $9ba2a6856f422a0d$var$findNearestItemExponentialSearch = function findNearestItemExponentialSearch(itemType, props, instanceProps, index, offset) {
    var itemCount = itemType === 'column' ? props.columnCount : props.rowCount;
    var interval = 1;
    while(index < itemCount && $9ba2a6856f422a0d$var$getItemMetadata(itemType, props, index, instanceProps).offset < offset){
        index += interval;
        interval *= 2;
    }
    return $9ba2a6856f422a0d$var$findNearestItemBinarySearch(itemType, props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};
var $9ba2a6856f422a0d$var$getOffsetForIndexAndAlignment = function getOffsetForIndexAndAlignment(itemType, props, index, align, scrollOffset, instanceProps, scrollbarSize) {
    var size = itemType === 'column' ? props.width : props.height;
    var itemMetadata = $9ba2a6856f422a0d$var$getItemMetadata(itemType, props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
    // To ensure it reflects actual measurements instead of just estimates.
    var estimatedTotalSize = itemType === 'column' ? $9ba2a6856f422a0d$var$getEstimatedTotalWidth(props, instanceProps) : $9ba2a6856f422a0d$var$getEstimatedTotalHeight(props, instanceProps);
    var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
    var minOffset = Math.max(0, itemMetadata.offset - size + scrollbarSize + itemMetadata.size);
    if (align === 'smart') {
        if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = 'auto';
        else align = 'center';
    }
    switch(align){
        case 'start':
            return maxOffset;
        case 'end':
            return minOffset;
        case 'center':
            return Math.round(minOffset + (maxOffset - minOffset) / 2);
        case 'auto':
        default:
            if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
            else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
            // this value can be larger than maxOffset when at the end of the list
            return minOffset;
            else if (scrollOffset < minOffset) return minOffset;
            else return maxOffset;
    }
};
var $9ba2a6856f422a0d$export$32c206c84102e73c = /*#__PURE__*/ $9ba2a6856f422a0d$var$createGridComponent({
    getColumnOffset: function getColumnOffset(props, index, instanceProps) {
        return $9ba2a6856f422a0d$var$getItemMetadata('column', props, index, instanceProps).offset;
    },
    getColumnStartIndexForOffset: function getColumnStartIndexForOffset(props, scrollLeft, instanceProps) {
        return $9ba2a6856f422a0d$var$findNearestItem('column', props, instanceProps, scrollLeft);
    },
    getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(props, startIndex, scrollLeft, instanceProps) {
        var columnCount = props.columnCount, width = props.width;
        var itemMetadata = $9ba2a6856f422a0d$var$getItemMetadata('column', props, startIndex, instanceProps);
        var maxOffset = scrollLeft + width;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < columnCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $9ba2a6856f422a0d$var$getItemMetadata('column', props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    getColumnWidth: function getColumnWidth(props, index, instanceProps) {
        return instanceProps.columnMetadataMap[index].size;
    },
    getEstimatedTotalHeight: $9ba2a6856f422a0d$var$getEstimatedTotalHeight,
    getEstimatedTotalWidth: $9ba2a6856f422a0d$var$getEstimatedTotalWidth,
    getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        return $9ba2a6856f422a0d$var$getOffsetForIndexAndAlignment('column', props, index, align, scrollOffset, instanceProps, scrollbarSize);
    },
    getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        return $9ba2a6856f422a0d$var$getOffsetForIndexAndAlignment('row', props, index, align, scrollOffset, instanceProps, scrollbarSize);
    },
    getRowOffset: function getRowOffset(props, index, instanceProps) {
        return $9ba2a6856f422a0d$var$getItemMetadata('row', props, index, instanceProps).offset;
    },
    getRowHeight: function getRowHeight(props, index, instanceProps) {
        return instanceProps.rowMetadataMap[index].size;
    },
    getRowStartIndexForOffset: function getRowStartIndexForOffset(props, scrollTop, instanceProps) {
        return $9ba2a6856f422a0d$var$findNearestItem('row', props, instanceProps, scrollTop);
    },
    getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(props, startIndex, scrollTop, instanceProps) {
        var rowCount = props.rowCount, height = props.height;
        var itemMetadata = $9ba2a6856f422a0d$var$getItemMetadata('row', props, startIndex, instanceProps);
        var maxOffset = scrollTop + height;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < rowCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $9ba2a6856f422a0d$var$getItemMetadata('row', props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    initInstanceProps: function initInstanceProps(props, instance) {
        var _ref5 = props, estimatedColumnWidth = _ref5.estimatedColumnWidth, estimatedRowHeight = _ref5.estimatedRowHeight;
        var instanceProps = {
            columnMetadataMap: {},
            estimatedColumnWidth: estimatedColumnWidth || $9ba2a6856f422a0d$var$DEFAULT_ESTIMATED_ITEM_SIZE,
            estimatedRowHeight: estimatedRowHeight || $9ba2a6856f422a0d$var$DEFAULT_ESTIMATED_ITEM_SIZE,
            lastMeasuredColumnIndex: -1,
            lastMeasuredRowIndex: -1,
            rowMetadataMap: {}
        };
        instance.resetAfterColumnIndex = function(columnIndex, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instance.resetAfterIndices({
                columnIndex: columnIndex,
                shouldForceUpdate: shouldForceUpdate
            });
        };
        instance.resetAfterRowIndex = function(rowIndex, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instance.resetAfterIndices({
                rowIndex: rowIndex,
                shouldForceUpdate: shouldForceUpdate
            });
        };
        instance.resetAfterIndices = function(_ref6) {
            var columnIndex = _ref6.columnIndex, rowIndex = _ref6.rowIndex, _ref6$shouldForceUpda = _ref6.shouldForceUpdate, shouldForceUpdate = _ref6$shouldForceUpda === void 0 ? true : _ref6$shouldForceUpda;
            if (typeof columnIndex === 'number') instanceProps.lastMeasuredColumnIndex = Math.min(instanceProps.lastMeasuredColumnIndex, columnIndex - 1);
            if (typeof rowIndex === 'number') instanceProps.lastMeasuredRowIndex = Math.min(instanceProps.lastMeasuredRowIndex, rowIndex - 1);
             // We could potentially optimize further by only evicting styles after this index,
            // But since styles are only cached while scrolling is in progress-
            // It seems an unnecessary optimization.
            // It's unlikely that resetAfterIndex() will be called while a user is scrolling.
            instance._getItemStyleCache(-1);
            if (shouldForceUpdate) instance.forceUpdate();
        };
        return instanceProps;
    },
    shouldResetStyleCacheOnItemSizeChange: false,
    validateProps: function validateProps(_ref7) {
        var columnWidth = _ref7.columnWidth, rowHeight = _ref7.rowHeight;
    }
});
var $9ba2a6856f422a0d$var$IS_SCROLLING_DEBOUNCE_INTERVAL$1 = 150;
var $9ba2a6856f422a0d$var$defaultItemKey$1 = function defaultItemKey(index, data) {
    return index;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.
var $9ba2a6856f422a0d$var$devWarningsDirection = null;
var $9ba2a6856f422a0d$var$devWarningsTagName$1 = null;
function $9ba2a6856f422a0d$var$createListComponent(_ref) {
    var _class, _temp;
    var getItemOffset = _ref.getItemOffset, getEstimatedTotalSize = _ref.getEstimatedTotalSize, getItemSize = _ref.getItemSize, getOffsetForIndexAndAlignment = _ref.getOffsetForIndexAndAlignment, getStartIndexForOffset = _ref.getStartIndexForOffset, getStopIndexForStartIndex = _ref.getStopIndexForStartIndex, initInstanceProps = _ref.initInstanceProps, shouldResetStyleCacheOnItemSizeChange = _ref.shouldResetStyleCacheOnItemSizeChange, validateProps = _ref.validateProps;
    return _temp = _class = /*#__PURE__*/ function(_PureComponent) {
        (0, $6MEf7.default)(List, _PureComponent);
        // Always use explicit constructor for React components.
        // It produces less code after transpilation. (#26)
        // eslint-disable-next-line no-useless-constructor
        function List(props) {
            var _this;
            _this = _PureComponent.call(this, props) || this;
            _this._instanceProps = initInstanceProps(_this.props, (0, $aCdHv.default)((0, $aCdHv.default)(_this)));
            _this._outerRef = void 0;
            _this._resetIsScrollingTimeoutId = null;
            _this.state = {
                instance: (0, $aCdHv.default)((0, $aCdHv.default)(_this)),
                isScrolling: false,
                scrollDirection: 'forward',
                scrollOffset: typeof _this.props.initialScrollOffset === 'number' ? _this.props.initialScrollOffset : 0,
                scrollUpdateWasRequested: false
            };
            _this._callOnItemsRendered = void 0;
            _this._callOnItemsRendered = (0, $dCUwp.default)(function(overscanStartIndex, overscanStopIndex, visibleStartIndex, visibleStopIndex) {
                return _this.props.onItemsRendered({
                    overscanStartIndex: overscanStartIndex,
                    overscanStopIndex: overscanStopIndex,
                    visibleStartIndex: visibleStartIndex,
                    visibleStopIndex: visibleStopIndex
                });
            });
            _this._callOnScroll = void 0;
            _this._callOnScroll = (0, $dCUwp.default)(function(scrollDirection, scrollOffset, scrollUpdateWasRequested) {
                return _this.props.onScroll({
                    scrollDirection: scrollDirection,
                    scrollOffset: scrollOffset,
                    scrollUpdateWasRequested: scrollUpdateWasRequested
                });
            });
            _this._getItemStyle = void 0;
            _this._getItemStyle = function(index) {
                var _this$props = _this.props, direction = _this$props.direction, itemSize = _this$props.itemSize, layout = _this$props.layout;
                var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && itemSize, shouldResetStyleCacheOnItemSizeChange && layout, shouldResetStyleCacheOnItemSizeChange && direction);
                var style;
                if (itemStyleCache.hasOwnProperty(index)) style = itemStyleCache[index];
                else {
                    var _offset = getItemOffset(_this.props, index, _this._instanceProps);
                    var size = getItemSize(_this.props, index, _this._instanceProps); // TODO Deprecate direction "horizontal"
                    var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
                    var isRtl = direction === 'rtl';
                    var offsetHorizontal = isHorizontal ? _offset : 0;
                    itemStyleCache[index] = style = {
                        position: 'absolute',
                        left: isRtl ? undefined : offsetHorizontal,
                        right: isRtl ? offsetHorizontal : undefined,
                        top: !isHorizontal ? _offset : 0,
                        height: !isHorizontal ? size : '100%',
                        width: isHorizontal ? size : '100%'
                    };
                }
                return style;
            };
            _this._getItemStyleCache = void 0;
            _this._getItemStyleCache = (0, $dCUwp.default)(function(_, __, ___) {
                return {};
            });
            _this._onScrollHorizontal = function(event) {
                var _event$currentTarget = event.currentTarget, clientWidth = _event$currentTarget.clientWidth, scrollLeft = _event$currentTarget.scrollLeft, scrollWidth = _event$currentTarget.scrollWidth;
                _this.setState(function(prevState) {
                    if (prevState.scrollOffset === scrollLeft) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                    var direction = _this.props.direction;
                    var scrollOffset = scrollLeft;
                    if (direction === 'rtl') // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
                    // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.
                    switch($9ba2a6856f422a0d$var$getRTLOffsetType()){
                        case 'negative':
                            scrollOffset = -scrollLeft;
                            break;
                        case 'positive-descending':
                            scrollOffset = scrollWidth - clientWidth - scrollLeft;
                            break;
                    }
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    scrollOffset = Math.max(0, Math.min(scrollOffset, scrollWidth - clientWidth));
                    return {
                        isScrolling: true,
                        scrollDirection: prevState.scrollOffset < scrollLeft ? 'forward' : 'backward',
                        scrollOffset: scrollOffset,
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._onScrollVertical = function(event) {
                var _event$currentTarget2 = event.currentTarget, clientHeight = _event$currentTarget2.clientHeight, scrollHeight = _event$currentTarget2.scrollHeight, scrollTop = _event$currentTarget2.scrollTop;
                _this.setState(function(prevState) {
                    if (prevState.scrollOffset === scrollTop) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    var scrollOffset = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
                    return {
                        isScrolling: true,
                        scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
                        scrollOffset: scrollOffset,
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._outerRefSetter = function(ref) {
                var outerRef = _this.props.outerRef;
                _this._outerRef = ref;
                if (typeof outerRef === 'function') outerRef(ref);
                else if (outerRef != null && typeof outerRef === 'object' && outerRef.hasOwnProperty('current')) outerRef.current = ref;
            };
            _this._resetIsScrollingDebounced = function() {
                if (_this._resetIsScrollingTimeoutId !== null) $9ba2a6856f422a0d$var$cancelTimeout(_this._resetIsScrollingTimeoutId);
                _this._resetIsScrollingTimeoutId = $9ba2a6856f422a0d$var$requestTimeout(_this._resetIsScrolling, $9ba2a6856f422a0d$var$IS_SCROLLING_DEBOUNCE_INTERVAL$1);
            };
            _this._resetIsScrolling = function() {
                _this._resetIsScrollingTimeoutId = null;
                _this.setState({
                    isScrolling: false
                }, function() {
                    // Clear style cache after state update has been committed.
                    // This way we don't break pure sCU for items that don't use isScrolling param.
                    _this._getItemStyleCache(-1, null);
                });
            };
            return _this;
        }
        List.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            $9ba2a6856f422a0d$var$validateSharedProps$1(nextProps, prevState);
            validateProps(nextProps);
            return null;
        };
        var _proto = List.prototype;
        _proto.scrollTo = function scrollTo(scrollOffset) {
            scrollOffset = Math.max(0, scrollOffset);
            this.setState(function(prevState) {
                if (prevState.scrollOffset === scrollOffset) return null;
                return {
                    scrollDirection: prevState.scrollOffset < scrollOffset ? 'forward' : 'backward',
                    scrollOffset: scrollOffset,
                    scrollUpdateWasRequested: true
                };
            }, this._resetIsScrollingDebounced);
        };
        _proto.scrollToItem = function scrollToItem(index, align) {
            if (align === void 0) align = 'auto';
            var itemCount = this.props.itemCount;
            var scrollOffset = this.state.scrollOffset;
            index = Math.max(0, Math.min(index, itemCount - 1));
            this.scrollTo(getOffsetForIndexAndAlignment(this.props, index, align, scrollOffset, this._instanceProps));
        };
        _proto.componentDidMount = function componentDidMount() {
            var _this$props2 = this.props, direction = _this$props2.direction, initialScrollOffset = _this$props2.initialScrollOffset, layout = _this$props2.layout;
            if (typeof initialScrollOffset === 'number' && this._outerRef != null) {
                var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"
                if (direction === 'horizontal' || layout === 'horizontal') outerRef.scrollLeft = initialScrollOffset;
                else outerRef.scrollTop = initialScrollOffset;
            }
            this._callPropsCallbacks();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            var _this$props3 = this.props, direction = _this$props3.direction, layout = _this$props3.layout;
            var _this$state = this.state, scrollOffset = _this$state.scrollOffset, scrollUpdateWasRequested = _this$state.scrollUpdateWasRequested;
            if (scrollUpdateWasRequested && this._outerRef != null) {
                var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"
                if (direction === 'horizontal' || layout === 'horizontal') {
                    if (direction === 'rtl') // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // So we need to determine which browser behavior we're dealing with, and mimic it.
                    switch($9ba2a6856f422a0d$var$getRTLOffsetType()){
                        case 'negative':
                            outerRef.scrollLeft = -scrollOffset;
                            break;
                        case 'positive-ascending':
                            outerRef.scrollLeft = scrollOffset;
                            break;
                        default:
                            var clientWidth = outerRef.clientWidth, scrollWidth = outerRef.scrollWidth;
                            outerRef.scrollLeft = scrollWidth - clientWidth - scrollOffset;
                            break;
                    }
                    else outerRef.scrollLeft = scrollOffset;
                } else outerRef.scrollTop = scrollOffset;
            }
            this._callPropsCallbacks();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            if (this._resetIsScrollingTimeoutId !== null) $9ba2a6856f422a0d$var$cancelTimeout(this._resetIsScrollingTimeoutId);
        };
        _proto.render = function render() {
            var _this$props4 = this.props, children = _this$props4.children, className = _this$props4.className, direction = _this$props4.direction, height = _this$props4.height, innerRef = _this$props4.innerRef, innerElementType = _this$props4.innerElementType, innerTagName = _this$props4.innerTagName, itemCount = _this$props4.itemCount, itemData = _this$props4.itemData, _this$props4$itemKey = _this$props4.itemKey, itemKey = _this$props4$itemKey === void 0 ? $9ba2a6856f422a0d$var$defaultItemKey$1 : _this$props4$itemKey, layout = _this$props4.layout, outerElementType = _this$props4.outerElementType, outerTagName = _this$props4.outerTagName, style = _this$props4.style, useIsScrolling = _this$props4.useIsScrolling, width = _this$props4.width;
            var isScrolling = this.state.isScrolling; // TODO Deprecate direction "horizontal"
            var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
            var onScroll = isHorizontal ? this._onScrollHorizontal : this._onScrollVertical;
            var _this$_getRangeToRend = this._getRangeToRender(), startIndex = _this$_getRangeToRend[0], stopIndex = _this$_getRangeToRend[1];
            var items = [];
            if (itemCount > 0) for(var _index = startIndex; _index <= stopIndex; _index++)items.push((0, $eUqFw.createElement)(children, {
                data: itemData,
                key: itemKey(_index, itemData),
                index: _index,
                isScrolling: useIsScrolling ? isScrolling : undefined,
                style: this._getItemStyle(_index)
            }));
             // Read this value AFTER items have been created,
            // So their actual sizes (if variable) are taken into consideration.
            var estimatedTotalSize = getEstimatedTotalSize(this.props, this._instanceProps);
            return (0, $eUqFw.createElement)(outerElementType || outerTagName || 'div', {
                className: className,
                onScroll: onScroll,
                ref: this._outerRefSetter,
                style: (0, $kU09D.default)({
                    position: 'relative',
                    height: height,
                    width: width,
                    overflow: 'auto',
                    WebkitOverflowScrolling: 'touch',
                    willChange: 'transform',
                    direction: direction
                }, style)
            }, (0, $eUqFw.createElement)(innerElementType || innerTagName || 'div', {
                children: items,
                ref: innerRef,
                style: {
                    height: isHorizontal ? '100%' : estimatedTotalSize,
                    pointerEvents: isScrolling ? 'none' : undefined,
                    width: isHorizontal ? estimatedTotalSize : '100%'
                }
            }));
        };
        _proto._callPropsCallbacks = function _callPropsCallbacks() {
            if (typeof this.props.onItemsRendered === 'function') {
                var itemCount = this.props.itemCount;
                if (itemCount > 0) {
                    var _this$_getRangeToRend2 = this._getRangeToRender(), _overscanStartIndex = _this$_getRangeToRend2[0], _overscanStopIndex = _this$_getRangeToRend2[1], _visibleStartIndex = _this$_getRangeToRend2[2], _visibleStopIndex = _this$_getRangeToRend2[3];
                    this._callOnItemsRendered(_overscanStartIndex, _overscanStopIndex, _visibleStartIndex, _visibleStopIndex);
                }
            }
            if (typeof this.props.onScroll === 'function') {
                var _this$state2 = this.state, _scrollDirection = _this$state2.scrollDirection, _scrollOffset = _this$state2.scrollOffset, _scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;
                this._callOnScroll(_scrollDirection, _scrollOffset, _scrollUpdateWasRequested);
            }
        }; // Lazily create and cache item styles while scrolling,
        // So that pure component sCU will prevent re-renders.
        // We maintain this cache, and pass a style prop rather than index,
        // So that List can clear cached styles and force item re-render if necessary.
        _proto._getRangeToRender = function _getRangeToRender() {
            var _this$props5 = this.props, itemCount = _this$props5.itemCount, overscanCount = _this$props5.overscanCount;
            var _this$state3 = this.state, isScrolling = _this$state3.isScrolling, scrollDirection = _this$state3.scrollDirection, scrollOffset = _this$state3.scrollOffset;
            if (itemCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getStartIndexForOffset(this.props, scrollOffset, this._instanceProps);
            var stopIndex = getStopIndexForStartIndex(this.props, startIndex, scrollOffset, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || scrollDirection === 'backward' ? Math.max(1, overscanCount) : 1;
            var overscanForward = !isScrolling || scrollDirection === 'forward' ? Math.max(1, overscanCount) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(itemCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        return List;
    }((0, $eUqFw.PureComponent)), _class.defaultProps = {
        direction: 'ltr',
        itemData: undefined,
        layout: 'vertical',
        overscanCount: 2,
        useIsScrolling: false
    }, _temp;
} // NOTE: I considered further wrapping individual items with a pure ListItem component.
// This would avoid ever calling the render function for the same index more than once,
// But it would also add the overhead of a lot of components/fibers.
// I assume people already do this (render function returning a class component),
// So my doing it would just unnecessarily double the wrappers.
var $9ba2a6856f422a0d$var$validateSharedProps$1 = function validateSharedProps(_ref2, _ref3) {
    var children = _ref2.children, direction = _ref2.direction, height = _ref2.height, layout = _ref2.layout, innerTagName = _ref2.innerTagName, outerTagName = _ref2.outerTagName, width = _ref2.width;
    var instance = _ref3.instance;
    var isHorizontal;
};
var $9ba2a6856f422a0d$var$DEFAULT_ESTIMATED_ITEM_SIZE$1 = 50;
var $9ba2a6856f422a0d$var$getItemMetadata$1 = function getItemMetadata(props, index, instanceProps) {
    var _ref = props, itemSize = _ref.itemSize;
    var itemMetadataMap = instanceProps.itemMetadataMap, lastMeasuredIndex = instanceProps.lastMeasuredIndex;
    if (index > lastMeasuredIndex) {
        var offset = 0;
        if (lastMeasuredIndex >= 0) {
            var itemMetadata = itemMetadataMap[lastMeasuredIndex];
            offset = itemMetadata.offset + itemMetadata.size;
        }
        for(var i = lastMeasuredIndex + 1; i <= index; i++){
            var size = itemSize(i);
            itemMetadataMap[i] = {
                offset: offset,
                size: size
            };
            offset += size;
        }
        instanceProps.lastMeasuredIndex = index;
    }
    return itemMetadataMap[index];
};
var $9ba2a6856f422a0d$var$findNearestItem$1 = function findNearestItem(props, instanceProps, offset) {
    var itemMetadataMap = instanceProps.itemMetadataMap, lastMeasuredIndex = instanceProps.lastMeasuredIndex;
    var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;
    if (lastMeasuredItemOffset >= offset) // If we've already measured items within this range just use a binary search as it's faster.
    return $9ba2a6856f422a0d$var$findNearestItemBinarySearch$1(props, instanceProps, lastMeasuredIndex, 0, offset);
    else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return $9ba2a6856f422a0d$var$findNearestItemExponentialSearch$1(props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
};
var $9ba2a6856f422a0d$var$findNearestItemBinarySearch$1 = function findNearestItemBinarySearch(props, instanceProps, high, low, offset) {
    while(low <= high){
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = $9ba2a6856f422a0d$var$getItemMetadata$1(props, middle, instanceProps).offset;
        if (currentOffset === offset) return middle;
        else if (currentOffset < offset) low = middle + 1;
        else if (currentOffset > offset) high = middle - 1;
    }
    if (low > 0) return low - 1;
    else return 0;
};
var $9ba2a6856f422a0d$var$findNearestItemExponentialSearch$1 = function findNearestItemExponentialSearch(props, instanceProps, index, offset) {
    var itemCount = props.itemCount;
    var interval = 1;
    while(index < itemCount && $9ba2a6856f422a0d$var$getItemMetadata$1(props, index, instanceProps).offset < offset){
        index += interval;
        interval *= 2;
    }
    return $9ba2a6856f422a0d$var$findNearestItemBinarySearch$1(props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};
var $9ba2a6856f422a0d$var$getEstimatedTotalSize = function getEstimatedTotalSize(_ref2, _ref3) {
    var itemCount = _ref2.itemCount;
    var itemMetadataMap = _ref3.itemMetadataMap, estimatedItemSize = _ref3.estimatedItemSize, lastMeasuredIndex = _ref3.lastMeasuredIndex;
    var totalSizeOfMeasuredItems = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredIndex >= itemCount) lastMeasuredIndex = itemCount - 1;
    if (lastMeasuredIndex >= 0) {
        var itemMetadata = itemMetadataMap[lastMeasuredIndex];
        totalSizeOfMeasuredItems = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = itemCount - lastMeasuredIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedItemSize;
    return totalSizeOfMeasuredItems + totalSizeOfUnmeasuredItems;
};
var $9ba2a6856f422a0d$export$d8ac3b6b20be856e = /*#__PURE__*/ $9ba2a6856f422a0d$var$createListComponent({
    getItemOffset: function getItemOffset(props, index, instanceProps) {
        return $9ba2a6856f422a0d$var$getItemMetadata$1(props, index, instanceProps).offset;
    },
    getItemSize: function getItemSize(props, index, instanceProps) {
        return instanceProps.itemMetadataMap[index].size;
    },
    getEstimatedTotalSize: $9ba2a6856f422a0d$var$getEstimatedTotalSize,
    getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(props, index, align, scrollOffset, instanceProps) {
        var direction = props.direction, height = props.height, layout = props.layout, width = props.width; // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
        var size = isHorizontal ? width : height;
        var itemMetadata = $9ba2a6856f422a0d$var$getItemMetadata$1(props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
        // To ensure it reflects actual measurements instead of just estimates.
        var estimatedTotalSize = $9ba2a6856f422a0d$var$getEstimatedTotalSize(props, instanceProps);
        var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
        var minOffset = Math.max(0, itemMetadata.offset - size + itemMetadata.size);
        if (align === 'smart') {
            if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = 'auto';
            else align = 'center';
        }
        switch(align){
            case 'start':
                return maxOffset;
            case 'end':
                return minOffset;
            case 'center':
                return Math.round(minOffset + (maxOffset - minOffset) / 2);
            case 'auto':
            default:
                if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
                else if (scrollOffset < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getStartIndexForOffset: function getStartIndexForOffset(props, offset, instanceProps) {
        return $9ba2a6856f422a0d$var$findNearestItem$1(props, instanceProps, offset);
    },
    getStopIndexForStartIndex: function getStopIndexForStartIndex(props, startIndex, scrollOffset, instanceProps) {
        var direction = props.direction, height = props.height, itemCount = props.itemCount, layout = props.layout, width = props.width; // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
        var size = isHorizontal ? width : height;
        var itemMetadata = $9ba2a6856f422a0d$var$getItemMetadata$1(props, startIndex, instanceProps);
        var maxOffset = scrollOffset + size;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < itemCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $9ba2a6856f422a0d$var$getItemMetadata$1(props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    initInstanceProps: function initInstanceProps(props, instance) {
        var _ref4 = props, estimatedItemSize = _ref4.estimatedItemSize;
        var instanceProps = {
            itemMetadataMap: {},
            estimatedItemSize: estimatedItemSize || $9ba2a6856f422a0d$var$DEFAULT_ESTIMATED_ITEM_SIZE$1,
            lastMeasuredIndex: -1
        };
        instance.resetAfterIndex = function(index, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instanceProps.lastMeasuredIndex = Math.min(instanceProps.lastMeasuredIndex, index - 1); // We could potentially optimize further by only evicting styles after this index,
            // But since styles are only cached while scrolling is in progress-
            // It seems an unnecessary optimization.
            // It's unlikely that resetAfterIndex() will be called while a user is scrolling.
            instance._getItemStyleCache(-1);
            if (shouldForceUpdate) instance.forceUpdate();
        };
        return instanceProps;
    },
    shouldResetStyleCacheOnItemSizeChange: false,
    validateProps: function validateProps(_ref5) {
        var itemSize = _ref5.itemSize;
    }
});
var $9ba2a6856f422a0d$export$f331158cccad7361 = /*#__PURE__*/ $9ba2a6856f422a0d$var$createGridComponent({
    getColumnOffset: function getColumnOffset(_ref, index) {
        var columnWidth = _ref.columnWidth;
        return index * columnWidth;
    },
    getColumnWidth: function getColumnWidth(_ref2, index) {
        var columnWidth = _ref2.columnWidth;
        return columnWidth;
    },
    getRowOffset: function getRowOffset(_ref3, index) {
        var rowHeight = _ref3.rowHeight;
        return index * rowHeight;
    },
    getRowHeight: function getRowHeight(_ref4, index) {
        var rowHeight = _ref4.rowHeight;
        return rowHeight;
    },
    getEstimatedTotalHeight: function getEstimatedTotalHeight(_ref5) {
        var rowCount = _ref5.rowCount, rowHeight = _ref5.rowHeight;
        return rowHeight * rowCount;
    },
    getEstimatedTotalWidth: function getEstimatedTotalWidth(_ref6) {
        var columnCount = _ref6.columnCount, columnWidth = _ref6.columnWidth;
        return columnWidth * columnCount;
    },
    getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(_ref7, columnIndex, align, scrollLeft, instanceProps, scrollbarSize) {
        var columnCount = _ref7.columnCount, columnWidth = _ref7.columnWidth, width = _ref7.width;
        var lastColumnOffset = Math.max(0, columnCount * columnWidth - width);
        var maxOffset = Math.min(lastColumnOffset, columnIndex * columnWidth);
        var minOffset = Math.max(0, columnIndex * columnWidth - width + scrollbarSize + columnWidth);
        if (align === 'smart') {
            if (scrollLeft >= minOffset - width && scrollLeft <= maxOffset + width) align = 'auto';
            else align = 'center';
        }
        switch(align){
            case 'start':
                return maxOffset;
            case 'end':
                return minOffset;
            case 'center':
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(width / 2)) return 0; // near the beginning
                else if (middleOffset > lastColumnOffset + Math.floor(width / 2)) return lastColumnOffset; // near the end
                else return middleOffset;
            case 'auto':
            default:
                if (scrollLeft >= minOffset && scrollLeft <= maxOffset) return scrollLeft;
                else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
                // this value can be larger than maxOffset when at the end of the list
                return minOffset;
                else if (scrollLeft < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(_ref8, rowIndex, align, scrollTop, instanceProps, scrollbarSize) {
        var rowHeight = _ref8.rowHeight, height = _ref8.height, rowCount = _ref8.rowCount;
        var lastRowOffset = Math.max(0, rowCount * rowHeight - height);
        var maxOffset = Math.min(lastRowOffset, rowIndex * rowHeight);
        var minOffset = Math.max(0, rowIndex * rowHeight - height + scrollbarSize + rowHeight);
        if (align === 'smart') {
            if (scrollTop >= minOffset - height && scrollTop <= maxOffset + height) align = 'auto';
            else align = 'center';
        }
        switch(align){
            case 'start':
                return maxOffset;
            case 'end':
                return minOffset;
            case 'center':
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(height / 2)) return 0; // near the beginning
                else if (middleOffset > lastRowOffset + Math.floor(height / 2)) return lastRowOffset; // near the end
                else return middleOffset;
            case 'auto':
            default:
                if (scrollTop >= minOffset && scrollTop <= maxOffset) return scrollTop;
                else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
                // this value can be larger than maxOffset when at the end of the list
                return minOffset;
                else if (scrollTop < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getColumnStartIndexForOffset: function getColumnStartIndexForOffset(_ref9, scrollLeft) {
        var columnWidth = _ref9.columnWidth, columnCount = _ref9.columnCount;
        return Math.max(0, Math.min(columnCount - 1, Math.floor(scrollLeft / columnWidth)));
    },
    getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(_ref10, startIndex, scrollLeft) {
        var columnWidth = _ref10.columnWidth, columnCount = _ref10.columnCount, width = _ref10.width;
        var left = startIndex * columnWidth;
        var numVisibleColumns = Math.ceil((width + scrollLeft - left) / columnWidth);
        return Math.max(0, Math.min(columnCount - 1, startIndex + numVisibleColumns - 1 // -1 is because stop index is inclusive
        ));
    },
    getRowStartIndexForOffset: function getRowStartIndexForOffset(_ref11, scrollTop) {
        var rowHeight = _ref11.rowHeight, rowCount = _ref11.rowCount;
        return Math.max(0, Math.min(rowCount - 1, Math.floor(scrollTop / rowHeight)));
    },
    getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(_ref12, startIndex, scrollTop) {
        var rowHeight = _ref12.rowHeight, rowCount = _ref12.rowCount, height = _ref12.height;
        var top = startIndex * rowHeight;
        var numVisibleRows = Math.ceil((height + scrollTop - top) / rowHeight);
        return Math.max(0, Math.min(rowCount - 1, startIndex + numVisibleRows - 1 // -1 is because stop index is inclusive
        ));
    },
    initInstanceProps: function initInstanceProps(props) {},
    shouldResetStyleCacheOnItemSizeChange: true,
    validateProps: function validateProps(_ref13) {
        var columnWidth = _ref13.columnWidth, rowHeight = _ref13.rowHeight;
    }
});
var $9ba2a6856f422a0d$export$ae9e55e1d8a2f4b7 = /*#__PURE__*/ $9ba2a6856f422a0d$var$createListComponent({
    getItemOffset: function getItemOffset(_ref, index) {
        var itemSize = _ref.itemSize;
        return index * itemSize;
    },
    getItemSize: function getItemSize(_ref2, index) {
        var itemSize = _ref2.itemSize;
        return itemSize;
    },
    getEstimatedTotalSize: function getEstimatedTotalSize(_ref3) {
        var itemCount = _ref3.itemCount, itemSize = _ref3.itemSize;
        return itemSize * itemCount;
    },
    getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(_ref4, index, align, scrollOffset) {
        var direction = _ref4.direction, height = _ref4.height, itemCount = _ref4.itemCount, itemSize = _ref4.itemSize, layout = _ref4.layout, width = _ref4.width;
        // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
        var size = isHorizontal ? width : height;
        var lastItemOffset = Math.max(0, itemCount * itemSize - size);
        var maxOffset = Math.min(lastItemOffset, index * itemSize);
        var minOffset = Math.max(0, index * itemSize - size + itemSize);
        if (align === 'smart') {
            if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = 'auto';
            else align = 'center';
        }
        switch(align){
            case 'start':
                return maxOffset;
            case 'end':
                return minOffset;
            case 'center':
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(size / 2)) return 0; // near the beginning
                else if (middleOffset > lastItemOffset + Math.floor(size / 2)) return lastItemOffset; // near the end
                else return middleOffset;
            case 'auto':
            default:
                if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
                else if (scrollOffset < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getStartIndexForOffset: function getStartIndexForOffset(_ref5, offset) {
        var itemCount = _ref5.itemCount, itemSize = _ref5.itemSize;
        return Math.max(0, Math.min(itemCount - 1, Math.floor(offset / itemSize)));
    },
    getStopIndexForStartIndex: function getStopIndexForStartIndex(_ref6, startIndex, scrollOffset) {
        var direction = _ref6.direction, height = _ref6.height, itemCount = _ref6.itemCount, itemSize = _ref6.itemSize, layout = _ref6.layout, width = _ref6.width;
        // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === 'horizontal' || layout === 'horizontal';
        var offset = startIndex * itemSize;
        var size = isHorizontal ? width : height;
        var numVisibleItems = Math.ceil((size + scrollOffset - offset) / itemSize);
        return Math.max(0, Math.min(itemCount - 1, startIndex + numVisibleItems - 1 // -1 is because stop index is inclusive
        ));
    },
    initInstanceProps: function initInstanceProps(props) {},
    shouldResetStyleCacheOnItemSizeChange: true,
    validateProps: function validateProps(_ref7) {
        var itemSize = _ref7.itemSize;
    }
});
// Pulled from react-compat
// https://github.com/developit/preact-compat/blob/7c5de00e7c85e2ffd011bf3af02899b63f699d3a/src/index.js#L349
function $9ba2a6856f422a0d$var$shallowDiffers(prev, next) {
    for(var attribute in prev){
        if (!(attribute in next)) return true;
    }
    for(var _attribute in next){
        if (prev[_attribute] !== next[_attribute]) return true;
    }
    return false;
}
// It knows to compare individual style props and ignore the wrapper object.
// See https://reactjs.org/docs/react-api.html#reactmemo
function $9ba2a6856f422a0d$export$b141efd0b0fb9174(prevProps, nextProps) {
    var prevStyle = prevProps.style, prevRest = (0, $6XgOP.default)(prevProps, [
        "style"
    ]);
    var nextStyle = nextProps.style, nextRest = (0, $6XgOP.default)(nextProps, [
        "style"
    ]);
    return !$9ba2a6856f422a0d$var$shallowDiffers(prevStyle, nextStyle) && !$9ba2a6856f422a0d$var$shallowDiffers(prevRest, nextRest);
}
// It knows to compare individual style props and ignore the wrapper object.
// See https://reactjs.org/docs/react-component.html#shouldcomponentupdate
function $9ba2a6856f422a0d$export$aa365c903ed149ff(nextProps, nextState) {
    return !$9ba2a6856f422a0d$export$b141efd0b0fb9174(this.props, nextProps) || $9ba2a6856f422a0d$var$shallowDiffers(this.state, nextState);
}

});

parcelRegister("b1H5u", function(module, exports) {

$parcel$export(module.exports, "default", () => $807135fdb7ac6ffb$export$2e2bcd8739ae039);

var $aCdHv = parcelRequire("aCdHv");

var $6MEf7 = parcelRequire("6MEf7");

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");
var $807135fdb7ac6ffb$var$TableHeader = /*#__PURE__*/ function(_React$PureComponent) {
    (0, $6MEf7.default)(TableHeader, _React$PureComponent);
    function TableHeader(props) {
        var _this;
        _this = _React$PureComponent.call(this, props) || this;
        _this.renderHeaderRow = _this.renderHeaderRow.bind((0, $aCdHv.default)(_this));
        _this.renderFrozenRow = _this.renderFrozenRow.bind((0, $aCdHv.default)(_this));
        _this._setRef = _this._setRef.bind((0, $aCdHv.default)(_this));
        return _this;
    }
    var _proto = TableHeader.prototype;
    _proto.scrollTo = function scrollTo(offset) {
        if (this.headerRef) this.headerRef.scrollLeft = offset;
    };
    _proto.renderHeaderRow = function renderHeaderRow(height, index) {
        var _this$props = this.props, columns = _this$props.columns, headerRenderer = _this$props.headerRenderer;
        if (height <= 0) return null;
        var style = {
            width: '100%',
            height: height
        };
        return headerRenderer({
            style: style,
            columns: columns,
            headerIndex: index
        });
    };
    _proto.renderFrozenRow = function renderFrozenRow(rowData, index) {
        var _this$props2 = this.props, columns = _this$props2.columns, rowHeight = _this$props2.rowHeight, rowRenderer = _this$props2.rowRenderer;
        var style = {
            width: '100%',
            height: rowHeight
        }; // for frozen row the `rowIndex` is negative
        var rowIndex = -index - 1;
        return rowRenderer({
            style: style,
            columns: columns,
            rowData: rowData,
            rowIndex: rowIndex
        });
    };
    _proto.render = function render() {
        var _this$props3 = this.props, className = _this$props3.className, width = _this$props3.width, height = _this$props3.height, rowWidth = _this$props3.rowWidth, headerHeight = _this$props3.headerHeight, frozenData = _this$props3.frozenData;
        if (height <= 0) return null;
        var style = {
            width: width,
            height: height,
            position: 'relative',
            overflow: 'hidden'
        };
        var innerStyle = {
            width: rowWidth,
            height: height
        };
        var rowHeights = Array.isArray(headerHeight) ? headerHeight : [
            headerHeight
        ];
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            role: "grid",
            ref: this._setRef,
            className: className,
            style: style
        }, (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            role: "rowgroup",
            style: innerStyle
        }, rowHeights.map(this.renderHeaderRow), frozenData.map(this.renderFrozenRow)));
    };
    _proto._setRef = function _setRef(ref) {
        this.headerRef = ref;
    };
    return TableHeader;
}((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent);
$807135fdb7ac6ffb$var$TableHeader.propTypes = {
    className: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number.isRequired,
    height: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number.isRequired,
    headerHeight: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number)
    ]).isRequired,
    rowWidth: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number.isRequired,
    rowHeight: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number.isRequired,
    columns: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object).isRequired,
    data: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).array.isRequired,
    frozenData: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).array,
    headerRenderer: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    rowRenderer: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired
};
var $807135fdb7ac6ffb$export$2e2bcd8739ae039 = $807135fdb7ac6ffb$var$TableHeader;

});

parcelRegister("7h8T1", function(module, exports) {

$parcel$export(module.exports, "renderElement", () => $54c1039a0112df58$export$d544df0d2baa9f2c);
$parcel$export(module.exports, "normalizeColumns", () => $54c1039a0112df58$export$6eea807a108152a2);
$parcel$export(module.exports, "isObjectEqual", () => $54c1039a0112df58$export$2ec3988ee92e21d0);
$parcel$export(module.exports, "callOrReturn", () => $54c1039a0112df58$export$592682234826c0bd);
$parcel$export(module.exports, "hasChildren", () => $54c1039a0112df58$export$bd5ff50f0e53d41c);
$parcel$export(module.exports, "flattenOnKeys", () => $54c1039a0112df58$export$a18aa97d7c17e5aa);
$parcel$export(module.exports, "cloneArray", () => $54c1039a0112df58$export$fb653c219fcc4270);
$parcel$export(module.exports, "noop", () => $54c1039a0112df58$export$8793edee2d425525);
$parcel$export(module.exports, "toString", () => $54c1039a0112df58$export$f84e8e69fd4488a5);
$parcel$export(module.exports, "getValue", () => $54c1039a0112df58$export$bf7199a9ebcb84a9);
$parcel$export(module.exports, "debounce", () => $54c1039a0112df58$export$61fc7d43ac8f84b0);
$parcel$export(module.exports, "throttle", () => $54c1039a0112df58$export$de363e709c412c8a);
$parcel$export(module.exports, "getScrollbarSize", () => $54c1039a0112df58$export$728dbf35b325565b);
$parcel$export(module.exports, "addClassName", () => $54c1039a0112df58$export$5cf2b5b76bc9d0c);
$parcel$export(module.exports, "removeClassName", () => $54c1039a0112df58$export$1789407f05ca7654);
$parcel$export(module.exports, "getEstimatedTotalRowsHeight", () => $54c1039a0112df58$export$e16ad95cf4e69feb);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");
function $54c1039a0112df58$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $54c1039a0112df58$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $54c1039a0112df58$var$ownKeys(source, true).forEach(function(key) {
            (0, $5zQU9.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $54c1039a0112df58$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $54c1039a0112df58$export$d544df0d2baa9f2c(renderer, props) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(renderer)) {
        if (!props) return renderer;
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(renderer, props);
    } else if (typeof renderer === 'function') {
        if (renderer.prototype && renderer.prototype.isReactComponent) return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(renderer, props);
        else if (renderer.defaultProps) return renderer($54c1039a0112df58$var$_objectSpread({}, renderer.defaultProps, {}, props));
        return renderer(props);
    } else return null;
}
function $54c1039a0112df58$export$6eea807a108152a2(elements) {
    var columns = [];
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.forEach(elements, function(element) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(element) && element.key) {
            var column = $54c1039a0112df58$var$_objectSpread({}, element.props, {
                key: element.key
            });
            columns.push(column);
        }
    });
    return columns;
}
function $54c1039a0112df58$export$2ec3988ee92e21d0(objA, objB, ignoreFunction) {
    if (ignoreFunction === void 0) ignoreFunction = true;
    if (objA === objB) return true;
    if (objA === null && objB === null) return true;
    if (objA === null || objB === null) return false;
    if (typeof objA !== 'object' || typeof objB !== 'object') return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        var key = keysA[i];
        if (key === '_owner' && objA.$$typeof) continue;
        var valueA = objA[key];
        var valueB = objB[key];
        var valueAType = typeof valueA;
        if (valueAType !== typeof valueB) return false;
        if (valueAType === 'function' && ignoreFunction) continue;
        if (valueAType === 'object') {
            if (!$54c1039a0112df58$export$2ec3988ee92e21d0(valueA, valueB, ignoreFunction)) return false;
            else continue;
        }
        if (valueA !== valueB) return false;
    }
    return true;
}
function $54c1039a0112df58$export$592682234826c0bd(funcOrValue) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    return typeof funcOrValue === 'function' ? funcOrValue.apply(void 0, args) : funcOrValue;
}
function $54c1039a0112df58$export$bd5ff50f0e53d41c(data) {
    return Array.isArray(data.children) && data.children.length > 0;
}
function $54c1039a0112df58$export$4315a2af848d75d7(array, rootId, dataKey, parentKey) {
    if (rootId === void 0) rootId = null;
    if (dataKey === void 0) dataKey = 'id';
    if (parentKey === void 0) parentKey = 'parentId';
    var tree = [];
    var childrenMap = {};
    var length = array.length;
    for(var i = 0; i < length; i++){
        var item = $54c1039a0112df58$var$_objectSpread({}, array[i]);
        var id = item[dataKey];
        var parentId = item[parentKey];
        if (Array.isArray(item.children)) childrenMap[id] = item.children.concat(childrenMap[id] || []);
        else if (!childrenMap[id]) childrenMap[id] = [];
        item.children = childrenMap[id];
        if (parentId !== undefined && parentId !== rootId) {
            if (!childrenMap[parentId]) childrenMap[parentId] = [];
            childrenMap[parentId].push(item);
        } else tree.push(item);
    }
    return tree;
}
function $54c1039a0112df58$export$a18aa97d7c17e5aa(tree, keys, depthMap, dataKey) {
    if (depthMap === void 0) depthMap = {};
    if (dataKey === void 0) dataKey = 'id';
    if (!keys || !keys.length) return tree;
    var array = [];
    var keysSet = new Set();
    keys.forEach(function(x) {
        return keysSet.add(x);
    });
    var stack = [].concat(tree);
    stack.forEach(function(x) {
        return depthMap[x[dataKey]] = 0;
    });
    var _loop = function _loop() {
        var item = stack.shift();
        array.push(item);
        if (keysSet.has(item[dataKey]) && Array.isArray(item.children) && item.children.length > 0) {
            stack = [].concat(item.children, stack);
            item.children.forEach(function(x) {
                return depthMap[x[dataKey]] = depthMap[item[dataKey]] + 1;
            });
        }
    };
    while(stack.length > 0)_loop();
    return array;
} // Babel7 changed the behavior of @babel/plugin-transform-spread in https://github.com/babel/babel/pull/6763
function $54c1039a0112df58$export$fb653c219fcc4270(array) {
    if (!Array.isArray(array)) return [];
    return [].concat(array);
}
function $54c1039a0112df58$export$8793edee2d425525() {}
function $54c1039a0112df58$export$f84e8e69fd4488a5(value) {
    if (typeof value === 'string') return value;
    if (value === null || value === undefined) return '';
    return value.toString ? value.toString() : '';
}
function $54c1039a0112df58$var$getPathSegments(path) {
    var pathArray = path.split('.');
    var parts = [];
    for(var i = 0; i < pathArray.length; i++){
        var p = pathArray[i];
        while(p[p.length - 1] === '\\' && pathArray[i + 1] !== undefined){
            p = p.slice(0, -1) + '.';
            p += pathArray[++i];
        }
        parts.push(p);
    }
    return parts;
} // changed from https://github.com/sindresorhus/dot-prop/blob/master/index.js
function $54c1039a0112df58$export$bf7199a9ebcb84a9(object, path, defaultValue) {
    if (object === null || typeof object !== 'object' || typeof path !== 'string') return defaultValue;
    var pathArray = $54c1039a0112df58$var$getPathSegments(path);
    for(var i = 0; i < pathArray.length; i++){
        if (!Object.prototype.propertyIsEnumerable.call(object, pathArray[i])) return defaultValue;
        object = object[pathArray[i]];
        if (object === undefined || object === null) {
            if (i !== pathArray.length - 1) return defaultValue;
            break;
        }
    }
    return object;
} // copied from https://www.30secondsofcode.org/js/s/debounce
var $54c1039a0112df58$export$61fc7d43ac8f84b0 = function debounce(fn, ms) {
    if (ms === void 0) ms = 0;
    var timeoutId;
    return function() {
        var _this = this;
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        clearTimeout(timeoutId);
        timeoutId = setTimeout(function() {
            return fn.apply(_this, args);
        }, ms);
    };
}; // copied from https://www.30secondsofcode.org/js/s/throttle
var $54c1039a0112df58$export$de363e709c412c8a = function throttle(fn, wait) {
    var inThrottle, lastFn, lastTime;
    return function() {
        var context = this, args = arguments;
        if (!inThrottle) {
            fn.apply(context, args);
            lastTime = Date.now();
            inThrottle = true;
        } else {
            clearTimeout(lastFn);
            lastFn = setTimeout(function() {
                if (Date.now() - lastTime >= wait) {
                    fn.apply(context, args);
                    lastTime = Date.now();
                }
            }, Math.max(wait - (Date.now() - lastTime), 0));
        }
    };
}; // copied from https://github.com/react-bootstrap/dom-helpers
var $54c1039a0112df58$var$scrollbarSize;
function $54c1039a0112df58$export$728dbf35b325565b(recalculate) {
    if (!$54c1039a0112df58$var$scrollbarSize && $54c1039a0112df58$var$scrollbarSize !== 0 || recalculate) {
        if (typeof window !== 'undefined' && window.document && window.document.createElement) {
            var scrollDiv = document.createElement('div');
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.top = '-9999px';
            scrollDiv.style.width = '50px';
            scrollDiv.style.height = '50px';
            scrollDiv.style.overflow = 'scroll';
            document.body.appendChild(scrollDiv);
            $54c1039a0112df58$var$scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $54c1039a0112df58$var$scrollbarSize;
}
function $54c1039a0112df58$export$5cf2b5b76bc9d0c(el, className) {
    if (el.classList) el.classList.add(className);
    else if (!el.className.match(new RegExp("(?:^|\\s)" + className + "(?!\\S)"))) el.className += " " + className;
}
function $54c1039a0112df58$export$1789407f05ca7654(el, className) {
    if (el.classList) el.classList.remove(className);
    else el.className = el.className.replace(new RegExp("(?:^|\\s)" + className + "(?!\\S)", 'g'), '');
}
function $54c1039a0112df58$export$e16ad95cf4e69feb(data, estimatedRowHeight) {
    return typeof estimatedRowHeight === 'function' ? data.reduce(function(height, rowData, rowIndex) {
        return height + estimatedRowHeight({
            rowData: rowData,
            rowIndex: rowIndex
        });
    }, 0) : data.length * estimatedRowHeight;
}

});


parcelRegister("eEtBg", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaabc30b2173efba$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $6XgOP = parcelRequire("6XgOP");

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $7h8T1 = parcelRequire("7h8T1");
/**
 * HeaderRow component for BaseTable
 */ var $aaabc30b2173efba$var$TableHeaderRow = function TableHeaderRow(_ref) {
    var className = _ref.className, style = _ref.style, columns = _ref.columns, headerIndex = _ref.headerIndex, cellRenderer = _ref.cellRenderer, headerRenderer = _ref.headerRenderer, expandColumnKey = _ref.expandColumnKey, ExpandIcon = _ref.expandIcon, Tag = _ref.tagName, rest = (0, $6XgOP.default)(_ref, [
        "className",
        "style",
        "columns",
        "headerIndex",
        "cellRenderer",
        "headerRenderer",
        "expandColumnKey",
        "expandIcon",
        "tagName"
    ]);
    var cells = columns.map(function(column, columnIndex) {
        return cellRenderer({
            columns: columns,
            column: column,
            columnIndex: columnIndex,
            headerIndex: headerIndex,
            expandIcon: column.key === expandColumnKey && (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ExpandIcon, null)
        });
    });
    if (headerRenderer) cells = (0, $7h8T1.renderElement)(headerRenderer, {
        cells: cells,
        columns: columns,
        headerIndex: headerIndex
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Tag, (0, $kU09D.default)({}, rest, {
        className: className,
        style: style
    }), cells);
};
$aaabc30b2173efba$var$TableHeaderRow.defaultProps = {
    tagName: 'div'
};
$aaabc30b2173efba$var$TableHeaderRow.propTypes = {
    isScrolling: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
    columns: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object).isRequired,
    headerIndex: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    cellRenderer: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    headerRenderer: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).element
    ]),
    expandColumnKey: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    expandIcon: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    tagName: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).elementType
};
var $aaabc30b2173efba$export$2e2bcd8739ae039 = $aaabc30b2173efba$var$TableHeaderRow;

});

parcelRegister("gdyfF", function(module, exports) {

$parcel$export(module.exports, "default", () => $bce86dec7e36416b$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $6XgOP = parcelRequire("6XgOP");

var $aCdHv = parcelRequire("aCdHv");

var $6MEf7 = parcelRequire("6MEf7");

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $7h8T1 = parcelRequire("7h8T1");
/**
 * Row component for BaseTable
 */ var $bce86dec7e36416b$var$TableRow = /*#__PURE__*/ function(_React$PureComponent) {
    (0, $6MEf7.default)(TableRow, _React$PureComponent);
    function TableRow(props) {
        var _this;
        _this = _React$PureComponent.call(this, props) || this;
        _this.state = {
            measured: false
        };
        _this._setRef = _this._setRef.bind((0, $aCdHv.default)(_this));
        _this._handleExpand = _this._handleExpand.bind((0, $aCdHv.default)(_this));
        return _this;
    }
    var _proto = TableRow.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.props.estimatedRowHeight && this.props.rowIndex >= 0 && this._measureHeight(true);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        var _this2 = this;
        if (this.props.estimatedRowHeight && this.props.rowIndex >= 0 && // should not re-measure if it's updated after measured and reset
        !this.props.getIsResetting() && this.state.measured && prevState.measured) this.setState({
            measured: false
        }, function() {
            return _this2._measureHeight();
        });
    };
    _proto.render = function render() {
        /* eslint-disable no-unused-vars */ var _this$props = this.props, isScrolling = _this$props.isScrolling, className = _this$props.className, style = _this$props.style, columns = _this$props.columns, rowIndex = _this$props.rowIndex, rowData = _this$props.rowData, expandColumnKey = _this$props.expandColumnKey, depth = _this$props.depth, rowEventHandlers = _this$props.rowEventHandlers, estimatedRowHeight = _this$props.estimatedRowHeight, rowRenderer = _this$props.rowRenderer, cellRenderer = _this$props.cellRenderer, expandIconRenderer = _this$props.expandIconRenderer, Tag = _this$props.tagName, rowKey = _this$props.rowKey, getIsResetting = _this$props.getIsResetting, onRowHover = _this$props.onRowHover, onRowExpand = _this$props.onRowExpand, onRowHeightChange = _this$props.onRowHeightChange, rest = (0, $6XgOP.default)(_this$props, [
            "isScrolling",
            "className",
            "style",
            "columns",
            "rowIndex",
            "rowData",
            "expandColumnKey",
            "depth",
            "rowEventHandlers",
            "estimatedRowHeight",
            "rowRenderer",
            "cellRenderer",
            "expandIconRenderer",
            "tagName",
            "rowKey",
            "getIsResetting",
            "onRowHover",
            "onRowExpand",
            "onRowHeightChange"
        ]);
        /* eslint-enable no-unused-vars */ var expandIcon = expandIconRenderer({
            rowData: rowData,
            rowIndex: rowIndex,
            depth: depth,
            onExpand: this._handleExpand
        });
        var cells = columns.map(function(column, columnIndex) {
            return cellRenderer({
                isScrolling: isScrolling,
                columns: columns,
                column: column,
                columnIndex: columnIndex,
                rowData: rowData,
                rowIndex: rowIndex,
                expandIcon: column.key === expandColumnKey && expandIcon
            });
        });
        if (rowRenderer) cells = (0, $7h8T1.renderElement)(rowRenderer, {
            isScrolling: isScrolling,
            cells: cells,
            columns: columns,
            rowData: rowData,
            rowIndex: rowIndex,
            depth: depth
        });
        var eventHandlers = this._getEventHandlers(rowEventHandlers);
        if (estimatedRowHeight && rowIndex >= 0) {
            var height = style.height, otherStyles = (0, $6XgOP.default)(style, [
                "height"
            ]);
            return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Tag, (0, $kU09D.default)({}, rest, {
                ref: this._setRef,
                className: className,
                style: this.state.measured ? style : otherStyles
            }, this.state.measured && eventHandlers), cells);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Tag, (0, $kU09D.default)({}, rest, {
            className: className,
            style: style
        }, eventHandlers), cells);
    };
    _proto._setRef = function _setRef(ref) {
        this.ref = ref;
    };
    _proto._handleExpand = function _handleExpand(expanded) {
        var _this$props2 = this.props, onRowExpand = _this$props2.onRowExpand, rowData = _this$props2.rowData, rowIndex = _this$props2.rowIndex, rowKey = _this$props2.rowKey;
        onRowExpand && onRowExpand({
            expanded: expanded,
            rowData: rowData,
            rowIndex: rowIndex,
            rowKey: rowKey
        });
    };
    _proto._measureHeight = function _measureHeight(initialMeasure) {
        if (!this.ref) return;
        var _this$props3 = this.props, style = _this$props3.style, rowKey = _this$props3.rowKey, onRowHeightChange = _this$props3.onRowHeightChange, rowIndex = _this$props3.rowIndex, columns = _this$props3.columns;
        var height = this.ref.getBoundingClientRect().height;
        this.setState({
            measured: true
        }, function() {
            if (initialMeasure || height !== style.height) onRowHeightChange(rowKey, height, rowIndex, columns[0] && !columns[0].__placeholder__ && columns[0].frozen);
        });
    };
    _proto._getEventHandlers = function _getEventHandlers(handlers) {
        if (handlers === void 0) handlers = {};
        var _this$props4 = this.props, rowData = _this$props4.rowData, rowIndex = _this$props4.rowIndex, rowKey = _this$props4.rowKey, onRowHover = _this$props4.onRowHover;
        var eventHandlers = {};
        Object.keys(handlers).forEach(function(eventKey) {
            var callback = handlers[eventKey];
            if (typeof callback === 'function') eventHandlers[eventKey] = function(event) {
                callback({
                    rowData: rowData,
                    rowIndex: rowIndex,
                    rowKey: rowKey,
                    event: event
                });
            };
        });
        if (onRowHover) {
            var mouseEnterHandler = eventHandlers['onMouseEnter'];
            eventHandlers['onMouseEnter'] = function(event) {
                onRowHover({
                    hovered: true,
                    rowData: rowData,
                    rowIndex: rowIndex,
                    rowKey: rowKey,
                    event: event
                });
                mouseEnterHandler && mouseEnterHandler(event);
            };
            var mouseLeaveHandler = eventHandlers['onMouseLeave'];
            eventHandlers['onMouseLeave'] = function(event) {
                onRowHover({
                    hovered: false,
                    rowData: rowData,
                    rowIndex: rowIndex,
                    rowKey: rowKey,
                    event: event
                });
                mouseLeaveHandler && mouseLeaveHandler(event);
            };
        }
        return eventHandlers;
    };
    return TableRow;
}((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent);
$bce86dec7e36416b$var$TableRow.defaultProps = {
    tagName: 'div'
};
$bce86dec7e36416b$var$TableRow.propTypes = {
    isScrolling: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
    columns: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object).isRequired,
    rowData: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired,
    rowIndex: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number.isRequired,
    rowKey: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number
    ]),
    expandColumnKey: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    depth: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    rowEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
    rowRenderer: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).element
    ]),
    cellRenderer: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    expandIconRenderer: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    estimatedRowHeight: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
    ]),
    getIsResetting: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    onRowHover: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    onRowExpand: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    onRowHeightChange: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    tagName: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).elementType
};
var $bce86dec7e36416b$export$2e2bcd8739ae039 = $bce86dec7e36416b$var$TableRow;

});

parcelRegister("O52GH", function(module, exports) {

$parcel$export(module.exports, "default", () => $096894ee8ce0e130$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");
/**
 * HeaderCell component for BaseTable
 */ var $096894ee8ce0e130$var$TableHeaderCell = function TableHeaderCell(_ref) {
    var className = _ref.className, column = _ref.column, columnIndex = _ref.columnIndex;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: className
    }, column.title);
};
$096894ee8ce0e130$var$TableHeaderCell.propTypes = {
    className: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    column: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
    columnIndex: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number
};
var $096894ee8ce0e130$export$2e2bcd8739ae039 = $096894ee8ce0e130$var$TableHeaderCell;

});

parcelRegister("ljkyQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f83b524e104b381f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $7h8T1 = parcelRequire("7h8T1");
/**
 * Cell component for BaseTable
 */ var $f83b524e104b381f$var$TableCell = function TableCell(_ref) {
    var className = _ref.className, cellData = _ref.cellData, column = _ref.column, columnIndex = _ref.columnIndex, rowData = _ref.rowData, rowIndex = _ref.rowIndex;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(cellData) ? cellData : (0, $7h8T1.toString)(cellData));
};
$f83b524e104b381f$var$TableCell.propTypes = {
    className: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    cellData: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).any,
    column: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
    columnIndex: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    rowData: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
    rowIndex: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number
};
var $f83b524e104b381f$export$2e2bcd8739ae039 = $f83b524e104b381f$var$TableCell;

});

parcelRegister("aymWH", function(module, exports) {

$parcel$export(module.exports, "Alignment", () => $7aeee0e6e40bcc5f$export$9d7927214ed7d2cf);
$parcel$export(module.exports, "FrozenDirection", () => $7aeee0e6e40bcc5f$export$6e107cb83d03f2fe);
$parcel$export(module.exports, "default", () => $7aeee0e6e40bcc5f$export$2e2bcd8739ae039);

var $6MEf7 = parcelRequire("6MEf7");

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");
var $7aeee0e6e40bcc5f$export$9d7927214ed7d2cf = {
    LEFT: 'left',
    CENTER: 'center',
    RIGHT: 'right'
};
var $7aeee0e6e40bcc5f$export$6e107cb83d03f2fe = {
    LEFT: 'left',
    RIGHT: 'right',
    DEFAULT: true,
    NONE: false
};
/**
 * Column for BaseTable
 */ var $7aeee0e6e40bcc5f$var$Column = /*#__PURE__*/ function(_React$Component) {
    (0, $6MEf7.default)(Column, _React$Component);
    function Column() {
        return _React$Component.apply(this, arguments) || this;
    }
    return Column;
}((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component);
$7aeee0e6e40bcc5f$var$Column.propTypes = {
    /**
   * Class name for the column cell, could be a callback to return the class name
   * The callback is of the shape of `({ cellData, columns, column, columnIndex, rowData, rowIndex }) => string`
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
    ]),
    /**
   * Class name for the column header, could be a callback to return the class name
   * The callback is of the shape of `({ columns, column, columnIndex, headerIndex }) => string`
   */ headerClassName: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
    ]),
    /**
   * Custom style for the column cell, including the header cells
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
    /**
   * Title for the column header
   */ title: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    /**
   * Data key for the column cell, could be "a.b.c"
   */ dataKey: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    /**
   * Custom cell data getter
   * The handler is of the shape of `({ columns, column, columnIndex, rowData, rowIndex }) => node`
   */ dataGetter: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    /**
   * Alignment of the column cell
   */ align: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOf([
        'left',
        'center',
        'right'
    ]),
    /**
   * Flex grow style, defaults to 0
   */ flexGrow: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    /**
   * Flex shrink style, defaults to 1 for flexible table and 0 for fixed table
   */ flexShrink: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    /**
   * The width of the column, gutter width is not included
   */ width: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number.isRequired,
    /**
   * Maximum width of the column, used if the column is resizable
   */ maxWidth: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    /**
   * Minimum width of the column, used if the column is resizable
   */ minWidth: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    /**
   * Whether the column is frozen and what's the frozen side
   */ frozen: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOf([
        'left',
        'right',
        true,
        false
    ]),
    /**
   * Whether the column is hidden
   */ hidden: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    /**
   * Whether the column is resizable, defaults to false
   */ resizable: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    /**
   * Whether the column is sortable, defaults to false
   */ sortable: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    /**
   * Custom column cell renderer
   * The renderer receives props `{ cellData, columns, column, columnIndex, rowData, rowIndex, container, isScrolling }`
   */ cellRenderer: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).element
    ]),
    /**
   * Custom column header renderer
   * The renderer receives props `{ columns, column, columnIndex, headerIndex, container }`
   */ headerRenderer: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).element
    ])
};
$7aeee0e6e40bcc5f$var$Column.Alignment = $7aeee0e6e40bcc5f$export$9d7927214ed7d2cf;
$7aeee0e6e40bcc5f$var$Column.FrozenDirection = $7aeee0e6e40bcc5f$export$6e107cb83d03f2fe;
var $7aeee0e6e40bcc5f$export$2e2bcd8739ae039 = $7aeee0e6e40bcc5f$var$Column;

});

parcelRegister("bFxRm", function(module, exports) {

$parcel$export(module.exports, "default", () => $87edc9de9650eddc$export$2e2bcd8739ae039);
/**
 * Sort order for BaseTable
 */ var $87edc9de9650eddc$var$SortOrder = {
    /**
   * Sort data in ascending order
   */ ASC: 'asc',
    /**
   * Sort data in descending order
   */ DESC: 'desc'
};
var $87edc9de9650eddc$export$2e2bcd8739ae039 = $87edc9de9650eddc$var$SortOrder;

});

parcelRegister("3Rqfe", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cfaae000eb63d46$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $6XgOP = parcelRequire("6XgOP");

var $aCdHv = parcelRequire("aCdHv");

var $6MEf7 = parcelRequire("6MEf7");

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $hjlb6 = parcelRequire("hjlb6");
/**
 * default ExpandIcon for BaseTable
 */ var $2cfaae000eb63d46$var$ExpandIcon = /*#__PURE__*/ function(_React$PureComponent) {
    (0, $6MEf7.default)(ExpandIcon, _React$PureComponent);
    function ExpandIcon(props) {
        var _this;
        _this = _React$PureComponent.call(this, props) || this;
        _this._handleClick = _this._handleClick.bind((0, $aCdHv.default)(_this));
        return _this;
    }
    var _proto = ExpandIcon.prototype;
    _proto.render = function render() {
        var _this$props = this.props, expandable = _this$props.expandable, expanded = _this$props.expanded, indentSize = _this$props.indentSize, depth = _this$props.depth, onExpand = _this$props.onExpand, rest = (0, $6XgOP.default)(_this$props, [
            "expandable",
            "expanded",
            "indentSize",
            "depth",
            "onExpand"
        ]);
        if (!expandable && indentSize === 0) return null;
        var cls = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))('BaseTable__expand-icon', {
            'BaseTable__expand-icon--expanded': expanded
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", (0, $kU09D.default)({}, rest, {
            className: cls,
            onClick: expandable && onExpand ? this._handleClick : null,
            style: {
                fontFamily: 'initial',
                cursor: 'pointer',
                userSelect: 'none',
                width: '16px',
                minWidth: '16px',
                height: '16px',
                lineHeight: '16px',
                fontSize: '16px',
                textAlign: 'center',
                transition: 'transform 0.15s ease-out',
                transform: "rotate(" + (expandable && expanded ? 90 : 0) + "deg)",
                marginLeft: depth * indentSize
            }
        }), expandable && "\u25B8");
    };
    _proto._handleClick = function _handleClick(e) {
        e.stopPropagation();
        e.preventDefault();
        var _this$props2 = this.props, onExpand = _this$props2.onExpand, expanded = _this$props2.expanded;
        onExpand(!expanded);
    };
    return ExpandIcon;
}((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent);
$2cfaae000eb63d46$var$ExpandIcon.defaultProps = {
    depth: 0,
    indentSize: 16
};
$2cfaae000eb63d46$var$ExpandIcon.propTypes = {
    expandable: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    expanded: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    indentSize: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    depth: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    onExpand: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
};
var $2cfaae000eb63d46$export$2e2bcd8739ae039 = $2cfaae000eb63d46$var$ExpandIcon;

});

parcelRegister("aziI9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b1bafebb2956300$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $hjlb6 = parcelRequire("hjlb6");

var $bFxRm = parcelRequire("bFxRm");
function $7b1bafebb2956300$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7b1bafebb2956300$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $7b1bafebb2956300$var$ownKeys(source, true).forEach(function(key) {
            (0, $5zQU9.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $7b1bafebb2956300$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * default SortIndicator for BaseTable
 */ var $7b1bafebb2956300$var$SortIndicator = function SortIndicator(_ref) {
    var sortOrder = _ref.sortOrder, className = _ref.className, style = _ref.style;
    var cls = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))('BaseTable__sort-indicator', className, {
        'BaseTable__sort-indicator--descending': sortOrder === (0, $bFxRm.default).DESC
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: cls,
        style: $7b1bafebb2956300$var$_objectSpread({
            userSelect: 'none',
            width: '16px',
            height: '16px',
            lineHeight: '16px',
            textAlign: 'center'
        }, style)
    }, sortOrder === (0, $bFxRm.default).DESC ? "\u2193" : "\u2191");
};
$7b1bafebb2956300$var$SortIndicator.propTypes = {
    sortOrder: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOf([
        (0, $bFxRm.default).ASC,
        (0, $bFxRm.default).DESC
    ]),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    style: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
};
var $7b1bafebb2956300$export$2e2bcd8739ae039 = $7b1bafebb2956300$var$SortIndicator;

});

parcelRegister("g0W2r", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba89aaa85160c319$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $5zQU9 = parcelRequire("5zQU9");

var $6XgOP = parcelRequire("6XgOP");

var $aCdHv = parcelRequire("aCdHv");

var $6MEf7 = parcelRequire("6MEf7");

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $7h8T1 = parcelRequire("7h8T1");
function $ba89aaa85160c319$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ba89aaa85160c319$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $ba89aaa85160c319$var$ownKeys(source, true).forEach(function(key) {
            (0, $5zQU9.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $ba89aaa85160c319$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $ba89aaa85160c319$var$INVALID_VALUE = null; // copied from https://github.com/mzabriskie/react-draggable/blob/master/lib/utils/domFns.js
function $ba89aaa85160c319$export$3e51ec887013437b(doc) {
    if (!doc) return;
    var styleEl = doc.getElementById('react-draggable-style-el');
    if (!styleEl) {
        styleEl = doc.createElement('style');
        styleEl.type = 'text/css';
        styleEl.id = 'react-draggable-style-el';
        styleEl.innerHTML = '.react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n';
        styleEl.innerHTML += '.react-draggable-transparent-selection *::selection {all: inherit;}\n';
        doc.getElementsByTagName('head')[0].appendChild(styleEl);
    }
    if (doc.body) (0, $7h8T1.addClassName)(doc.body, 'react-draggable-transparent-selection');
}
function $ba89aaa85160c319$export$6f58ea783c356452(doc) {
    if (!doc) return;
    try {
        if (doc.body) (0, $7h8T1.removeClassName)(doc.body, 'react-draggable-transparent-selection');
        if (doc.selection) doc.selection.empty();
        else {
            // Remove selection caused by scroll, unless it's a focused input
            // (we use doc.defaultView in case we're in an iframe)
            var selection = (doc.defaultView || window).getSelection();
            if (selection && selection.type !== 'Caret') selection.removeAllRanges();
        }
    } catch (e) {}
}
var $ba89aaa85160c319$var$eventsFor = {
    touch: {
        start: 'touchstart',
        move: 'touchmove',
        stop: 'touchend'
    },
    mouse: {
        start: 'mousedown',
        move: 'mousemove',
        stop: 'mouseup'
    }
};
var $ba89aaa85160c319$var$dragEventFor = $ba89aaa85160c319$var$eventsFor.mouse;
/**
 * ColumnResizer for BaseTable
 */ var $ba89aaa85160c319$var$ColumnResizer = /*#__PURE__*/ function(_React$PureComponent) {
    (0, $6MEf7.default)(ColumnResizer, _React$PureComponent);
    function ColumnResizer(props) {
        var _this;
        _this = _React$PureComponent.call(this, props) || this;
        _this.isDragging = false;
        _this.lastX = $ba89aaa85160c319$var$INVALID_VALUE;
        _this.width = 0;
        _this._setHandleRef = _this._setHandleRef.bind((0, $aCdHv.default)(_this));
        _this._handleClick = _this._handleClick.bind((0, $aCdHv.default)(_this));
        _this._handleMouseDown = _this._handleMouseDown.bind((0, $aCdHv.default)(_this));
        _this._handleMouseUp = _this._handleMouseUp.bind((0, $aCdHv.default)(_this));
        _this._handleTouchStart = _this._handleTouchStart.bind((0, $aCdHv.default)(_this));
        _this._handleTouchEnd = _this._handleTouchEnd.bind((0, $aCdHv.default)(_this));
        _this._handleDragStart = _this._handleDragStart.bind((0, $aCdHv.default)(_this));
        _this._handleDragStop = _this._handleDragStop.bind((0, $aCdHv.default)(_this));
        _this._handleDrag = _this._handleDrag.bind((0, $aCdHv.default)(_this));
        return _this;
    }
    var _proto = ColumnResizer.prototype;
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.handleRef) {
            var ownerDocument = this.handleRef.ownerDocument;
            ownerDocument.removeEventListener($ba89aaa85160c319$var$eventsFor.mouse.move, this._handleDrag);
            ownerDocument.removeEventListener($ba89aaa85160c319$var$eventsFor.mouse.stop, this._handleDragStop);
            ownerDocument.removeEventListener($ba89aaa85160c319$var$eventsFor.touch.move, this._handleDrag);
            ownerDocument.removeEventListener($ba89aaa85160c319$var$eventsFor.touch.stop, this._handleDragStop);
            $ba89aaa85160c319$export$6f58ea783c356452(ownerDocument);
        }
    };
    _proto.render = function render() {
        var _this$props = this.props, style = _this$props.style, column = _this$props.column, onResizeStart = _this$props.onResizeStart, onResize = _this$props.onResize, onResizeStop = _this$props.onResizeStop, minWidth = _this$props.minWidth, rest = (0, $6XgOP.default)(_this$props, [
            "style",
            "column",
            "onResizeStart",
            "onResize",
            "onResizeStop",
            "minWidth"
        ]);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", (0, $kU09D.default)({}, rest, {
            ref: this._setHandleRef,
            onClick: this._handleClick,
            onMouseDown: this._handleMouseDown,
            onMouseUp: this._handleMouseUp,
            onTouchStart: this._handleTouchStart,
            onTouchEnd: this._handleTouchEnd,
            style: $ba89aaa85160c319$var$_objectSpread({
                userSelect: 'none',
                touchAction: 'none',
                position: 'absolute',
                top: 0,
                bottom: 0,
                right: 0,
                cursor: 'col-resize'
            }, style)
        }));
    };
    _proto._setHandleRef = function _setHandleRef(ref) {
        this.handleRef = ref;
    };
    _proto._handleClick = function _handleClick(e) {
        e.stopPropagation();
    };
    _proto._handleMouseDown = function _handleMouseDown(e) {
        $ba89aaa85160c319$var$dragEventFor = $ba89aaa85160c319$var$eventsFor.mouse;
        this._handleDragStart(e);
    };
    _proto._handleMouseUp = function _handleMouseUp(e) {
        $ba89aaa85160c319$var$dragEventFor = $ba89aaa85160c319$var$eventsFor.mouse;
        this._handleDragStop(e);
    };
    _proto._handleTouchStart = function _handleTouchStart(e) {
        $ba89aaa85160c319$var$dragEventFor = $ba89aaa85160c319$var$eventsFor.touch;
        this._handleDragStart(e);
    };
    _proto._handleTouchEnd = function _handleTouchEnd(e) {
        $ba89aaa85160c319$var$dragEventFor = $ba89aaa85160c319$var$eventsFor.touch;
        this._handleDragStop(e);
    };
    _proto._handleDragStart = function _handleDragStart(e) {
        if (typeof e.button === 'number' && e.button !== 0) return;
        this.isDragging = true;
        this.lastX = $ba89aaa85160c319$var$INVALID_VALUE;
        this.width = this.props.column.width;
        this.props.onResizeStart(this.props.column);
        var ownerDocument = this.handleRef.ownerDocument;
        $ba89aaa85160c319$export$3e51ec887013437b(ownerDocument);
        ownerDocument.addEventListener($ba89aaa85160c319$var$dragEventFor.move, this._handleDrag);
        ownerDocument.addEventListener($ba89aaa85160c319$var$dragEventFor.stop, this._handleDragStop);
    };
    _proto._handleDragStop = function _handleDragStop(e) {
        if (!this.isDragging) return;
        this.isDragging = false;
        this.props.onResizeStop(this.props.column);
        var ownerDocument = this.handleRef.ownerDocument;
        $ba89aaa85160c319$export$6f58ea783c356452(ownerDocument);
        ownerDocument.removeEventListener($ba89aaa85160c319$var$dragEventFor.move, this._handleDrag);
        ownerDocument.removeEventListener($ba89aaa85160c319$var$dragEventFor.stop, this._handleDragStop);
    };
    _proto._handleDrag = function _handleDrag(e) {
        var clientX = e.clientX;
        if (e.type === $ba89aaa85160c319$var$eventsFor.touch.move) {
            e.preventDefault();
            if (e.targetTouches && e.targetTouches[0]) clientX = e.targetTouches[0].clientX;
        }
        var offsetParent = this.handleRef.offsetParent;
        var offsetParentRect = offsetParent.getBoundingClientRect();
        var x = clientX + offsetParent.scrollLeft - offsetParentRect.left;
        if (this.lastX === $ba89aaa85160c319$var$INVALID_VALUE) {
            this.lastX = x;
            return;
        }
        var _this$props2 = this.props, column = _this$props2.column, MIN_WIDTH = _this$props2.minWidth;
        var width = column.width, maxWidth = column.maxWidth, _column$minWidth = column.minWidth, minWidth = _column$minWidth === void 0 ? MIN_WIDTH : _column$minWidth;
        var movedX = x - this.lastX;
        if (!movedX) return;
        this.width = this.width + movedX;
        this.lastX = x;
        var newWidth = this.width;
        if (maxWidth && newWidth > maxWidth) newWidth = maxWidth;
        else if (newWidth < minWidth) newWidth = minWidth;
        if (newWidth === width) return;
        this.props.onResize(column, newWidth);
    };
    return ColumnResizer;
}((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent);
$ba89aaa85160c319$var$ColumnResizer.defaultProps = {
    onResizeStart: (0, $7h8T1.noop),
    onResize: (0, $7h8T1.noop),
    onResizeStop: (0, $7h8T1.noop),
    minWidth: 30
};
$ba89aaa85160c319$var$ColumnResizer.propTypes = {
    /**
   * Custom style for the drag handler
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
    /**
   * The column object to be dragged
   */ column: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
    /**
   * A callback function when resizing started
   * The callback is of the shape of `(column) => *`
   */ onResizeStart: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    /**
   * A callback function when resizing the column
   * The callback is of the shape of `(column, width) => *`
   */ onResize: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    /**
   * A callback function when resizing stopped
   * The callback is of the shape of `(column) => *`
   */ onResizeStop: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    /**
   * Minimum width of the column could be resized to if the column's `minWidth` is not set
   */ minWidth: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number
};
var $ba89aaa85160c319$export$2e2bcd8739ae039 = $ba89aaa85160c319$var$ColumnResizer;

});

parcelRegister("i1YES", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2075f7b10f29e9a$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $aymWH = parcelRequire("aymWH");
function $d2075f7b10f29e9a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d2075f7b10f29e9a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $d2075f7b10f29e9a$var$ownKeys(source, true).forEach(function(key) {
            (0, $5zQU9.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $d2075f7b10f29e9a$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $d2075f7b10f29e9a$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ColumnManager(columns, fixed) {
        this._origColumns = [];
        this.reset(columns, fixed);
    }
    var _proto = ColumnManager.prototype;
    _proto._cache = function _cache(key, fn) {
        if (key in this._cached) return this._cached[key];
        this._cached[key] = fn();
        return this._cached[key];
    };
    _proto.reset = function reset(columns, fixed) {
        var _this = this;
        this._columns = columns.map(function(column) {
            var width = column.width;
            if (column.resizable) {
                // don't reset column's `width` if `width` prop doesn't change
                var idx = _this._origColumns.findIndex(function(x) {
                    return x.key === column.key;
                });
                if (idx >= 0 && _this._origColumns[idx].width === column.width) width = _this._columns[idx].width;
            }
            return $d2075f7b10f29e9a$var$_objectSpread({}, column, {
                width: width
            });
        });
        this._origColumns = columns;
        this._fixed = fixed;
        this._cached = {};
        this._columnStyles = this.recomputeColumnStyles();
    };
    _proto.resetCache = function resetCache() {
        this._cached = {};
    };
    _proto.getOriginalColumns = function getOriginalColumns() {
        return this._origColumns;
    };
    _proto.getColumns = function getColumns() {
        return this._columns;
    };
    _proto.getVisibleColumns = function getVisibleColumns() {
        var _this2 = this;
        return this._cache('visibleColumns', function() {
            return _this2._columns.filter(function(column) {
                return !column.hidden;
            });
        });
    };
    _proto.hasFrozenColumns = function hasFrozenColumns() {
        var _this3 = this;
        return this._cache('hasFrozenColumns', function() {
            return _this3._fixed && _this3.getVisibleColumns().some(function(column) {
                return !!column.frozen;
            });
        });
    };
    _proto.hasLeftFrozenColumns = function hasLeftFrozenColumns() {
        var _this4 = this;
        return this._cache('hasLeftFrozenColumns', function() {
            return _this4._fixed && _this4.getVisibleColumns().some(function(column) {
                return column.frozen === (0, $aymWH.FrozenDirection).LEFT || column.frozen === true;
            });
        });
    };
    _proto.hasRightFrozenColumns = function hasRightFrozenColumns() {
        var _this5 = this;
        return this._cache('hasRightFrozenColumns', function() {
            return _this5._fixed && _this5.getVisibleColumns().some(function(column) {
                return column.frozen === (0, $aymWH.FrozenDirection).RIGHT;
            });
        });
    };
    _proto.getMainColumns = function getMainColumns() {
        var _this6 = this;
        return this._cache('mainColumns', function() {
            var columns = _this6.getVisibleColumns();
            if (!_this6.hasFrozenColumns()) return columns;
            var mainColumns = [];
            _this6.getLeftFrozenColumns().forEach(function(column) {
                var _objectSpread2;
                //columns placeholder for the fixed table above them
                mainColumns.push($d2075f7b10f29e9a$var$_objectSpread({}, column, (_objectSpread2 = {}, _objectSpread2[ColumnManager.PlaceholderKey] = true, _objectSpread2)));
            });
            _this6.getVisibleColumns().forEach(function(column) {
                if (!column.frozen) mainColumns.push(column);
            });
            _this6.getRightFrozenColumns().forEach(function(column) {
                var _objectSpread3;
                mainColumns.push($d2075f7b10f29e9a$var$_objectSpread({}, column, (_objectSpread3 = {}, _objectSpread3[ColumnManager.PlaceholderKey] = true, _objectSpread3)));
            });
            return mainColumns;
        });
    };
    _proto.getLeftFrozenColumns = function getLeftFrozenColumns() {
        var _this7 = this;
        return this._cache('leftFrozenColumns', function() {
            if (!_this7._fixed) return [];
            return _this7.getVisibleColumns().filter(function(column) {
                return column.frozen === (0, $aymWH.FrozenDirection).LEFT || column.frozen === true;
            });
        });
    };
    _proto.getRightFrozenColumns = function getRightFrozenColumns() {
        var _this8 = this;
        return this._cache('rightFrozenColumns', function() {
            if (!_this8._fixed) return [];
            return _this8.getVisibleColumns().filter(function(column) {
                return column.frozen === (0, $aymWH.FrozenDirection).RIGHT;
            });
        });
    };
    _proto.getColumn = function getColumn(key) {
        var idx = this._columns.findIndex(function(column) {
            return column.key === key;
        });
        return this._columns[idx];
    };
    _proto.getColumnsWidth = function getColumnsWidth() {
        var _this9 = this;
        return this._cache('columnsWidth', function() {
            return _this9.recomputeColumnsWidth(_this9.getVisibleColumns());
        });
    };
    _proto.getLeftFrozenColumnsWidth = function getLeftFrozenColumnsWidth() {
        var _this10 = this;
        return this._cache('leftFrozenColumnsWidth', function() {
            return _this10.recomputeColumnsWidth(_this10.getLeftFrozenColumns());
        });
    };
    _proto.getRightFrozenColumnsWidth = function getRightFrozenColumnsWidth() {
        var _this11 = this;
        return this._cache('rightFrozenColumnsWidth', function() {
            return _this11.recomputeColumnsWidth(_this11.getRightFrozenColumns());
        });
    };
    _proto.recomputeColumnsWidth = function recomputeColumnsWidth(columns) {
        return columns.reduce(function(width, column) {
            return width + column.width;
        }, 0);
    };
    _proto.setColumnWidth = function setColumnWidth(key, width) {
        var column = this.getColumn(key);
        column.width = width;
        this._cached = {};
        this._columnStyles[column.key] = this.recomputeColumnStyle(column);
    };
    _proto.getColumnStyle = function getColumnStyle(key) {
        return this._columnStyles[key];
    };
    _proto.getColumnStyles = function getColumnStyles() {
        return this._columnStyles;
    };
    _proto.recomputeColumnStyle = function recomputeColumnStyle(column) {
        var flexGrow = 0;
        var flexShrink = 0;
        if (!this._fixed) {
            flexGrow = typeof column.flexGrow === 'number' ? column.flexGrow : 0;
            flexShrink = typeof column.flexShrink === 'number' ? column.flexShrink : 1;
        } // workaround for Flex bug on IE: https://github.com/philipwalton/flexbugs#flexbug-7
        var flexValue = flexGrow + " " + flexShrink + " auto";
        var style = $d2075f7b10f29e9a$var$_objectSpread({}, column.style, {
            flex: flexValue,
            msFlex: flexValue,
            WebkitFlex: flexValue,
            width: column.width,
            overflow: 'hidden'
        });
        if (!this._fixed && column.maxWidth) style.maxWidth = column.maxWidth;
        if (!this._fixed && column.minWidth) style.minWidth = column.minWidth;
        return style;
    };
    _proto.recomputeColumnStyles = function recomputeColumnStyles() {
        var _this12 = this;
        return this._columns.reduce(function(styles, column) {
            styles[column.key] = _this12.recomputeColumnStyle(column);
            return styles;
        }, {});
    };
    return ColumnManager;
}();
$d2075f7b10f29e9a$export$2e2bcd8739ae039.PlaceholderKey = '__placeholder__';

});


parcelRegister("7NdQE", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ac7d9f9832fd743$export$2e2bcd8739ae039);

var $6XgOP = parcelRequire("6XgOP");

var $kU09D = parcelRequire("kU09D");

var $5zQU9 = parcelRequire("5zQU9");

var $aCdHv = parcelRequire("aCdHv");

var $6MEf7 = parcelRequire("6MEf7");

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $hjlb6 = parcelRequire("hjlb6");

var $dCUwp = parcelRequire("dCUwp");

var $6z2Iy = parcelRequire("6z2Iy");

var $eEtBg = parcelRequire("eEtBg");

var $gdyfF = parcelRequire("gdyfF");

var $O52GH = parcelRequire("O52GH");

var $ljkyQ = parcelRequire("ljkyQ");

var $aymWH = parcelRequire("aymWH");

var $bFxRm = parcelRequire("bFxRm");

var $3Rqfe = parcelRequire("3Rqfe");

var $aziI9 = parcelRequire("aziI9");

var $g0W2r = parcelRequire("g0W2r");

var $i1YES = parcelRequire("i1YES");

var $7h8T1 = parcelRequire("7h8T1");
function $5ac7d9f9832fd743$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5ac7d9f9832fd743$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $5ac7d9f9832fd743$var$ownKeys(source, true).forEach(function(key) {
            (0, $5zQU9.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $5ac7d9f9832fd743$var$ownKeys(source).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $5ac7d9f9832fd743$var$getColumns = (0, $dCUwp.default)(function(columns, children) {
    return columns || (0, $7h8T1.normalizeColumns)(children);
});
var $5ac7d9f9832fd743$var$getStickyColumnLeftPosition = (0, $dCUwp.default)(function(columns, columnIndex) {
    return columns.slice(0, columnIndex).reduce(function(acc, col) {
        return acc + col.width;
    }, 0);
});
var $5ac7d9f9832fd743$var$getContainerStyle = function getContainerStyle(width, maxWidth, height) {
    return {
        width: width,
        maxWidth: maxWidth,
        height: height,
        overflow: 'hidden'
    };
};
var $5ac7d9f9832fd743$var$DEFAULT_COMPONENTS = {
    TableCell: (0, $ljkyQ.default),
    TableHeaderCell: (0, $O52GH.default),
    ExpandIcon: (0, $3Rqfe.default),
    SortIndicator: (0, $aziI9.default)
};
var $5ac7d9f9832fd743$var$RESIZE_THROTTLE_WAIT = 50; // used for memoization
var $5ac7d9f9832fd743$var$EMPTY_ARRAY = [];
/**
 * React table component
 */ var $5ac7d9f9832fd743$var$BaseTableV2 = /*#__PURE__*/ function(_React$PureComponent) {
    (0, $6MEf7.default)(BaseTableV2, _React$PureComponent);
    function BaseTableV2(props) {
        var _this;
        _this = _React$PureComponent.call(this, props) || this;
        var columns = props.columns, children = props.children, defaultExpandedRowKeys = props.defaultExpandedRowKeys;
        _this.state = {
            scrollbarSize: 0,
            hoveredRowKey: null,
            resizingKey: null,
            resizingWidth: 0,
            expandedRowKeys: (0, $7h8T1.cloneArray)(defaultExpandedRowKeys)
        };
        _this.columnManager = new (0, $i1YES.default)($5ac7d9f9832fd743$var$getColumns(columns, children), props.fixed);
        _this._setContainerRef = _this._setContainerRef.bind((0, $aCdHv.default)(_this));
        _this._setMainTableRef = _this._setMainTableRef.bind((0, $aCdHv.default)(_this));
        _this._setLeftTableRef = _this._setLeftTableRef.bind((0, $aCdHv.default)(_this));
        _this._setRightTableRef = _this._setRightTableRef.bind((0, $aCdHv.default)(_this));
        _this.renderExpandIcon = _this.renderExpandIcon.bind((0, $aCdHv.default)(_this));
        _this.renderRow = _this.renderRow.bind((0, $aCdHv.default)(_this));
        _this.renderRowCell = _this.renderRowCell.bind((0, $aCdHv.default)(_this));
        _this.renderHeader = _this.renderHeader.bind((0, $aCdHv.default)(_this));
        _this.renderHeaderCell = _this.renderHeaderCell.bind((0, $aCdHv.default)(_this));
        _this._handleScroll = _this._handleScroll.bind((0, $aCdHv.default)(_this));
        _this._handleVerticalScroll = _this._handleVerticalScroll.bind((0, $aCdHv.default)(_this));
        _this._handleRowsRendered = _this._handleRowsRendered.bind((0, $aCdHv.default)(_this));
        _this._handleRowHover = _this._handleRowHover.bind((0, $aCdHv.default)(_this));
        _this._handleRowExpand = _this._handleRowExpand.bind((0, $aCdHv.default)(_this));
        _this._handleColumnResize = (0, $7h8T1.throttle)(_this._handleColumnResize.bind((0, $aCdHv.default)(_this)), $5ac7d9f9832fd743$var$RESIZE_THROTTLE_WAIT);
        _this._handleColumnResizeStart = _this._handleColumnResizeStart.bind((0, $aCdHv.default)(_this));
        _this._handleColumnResizeStop = _this._handleColumnResizeStop.bind((0, $aCdHv.default)(_this));
        _this._handleColumnSort = _this._handleColumnSort.bind((0, $aCdHv.default)(_this));
        _this._handleFrozenRowHeightChange = _this._handleFrozenRowHeightChange.bind((0, $aCdHv.default)(_this));
        _this._handleRowHeightChange = _this._handleRowHeightChange.bind((0, $aCdHv.default)(_this));
        _this._getLeftTableContainerStyle = (0, $dCUwp.default)($5ac7d9f9832fd743$var$getContainerStyle);
        _this._getRightTableContainerStyle = (0, $dCUwp.default)($5ac7d9f9832fd743$var$getContainerStyle);
        _this._flattenOnKeys = (0, $dCUwp.default)(function(tree, keys, dataKey) {
            _this._depthMap = {};
            return (0, $7h8T1.flattenOnKeys)(tree, keys, _this._depthMap, dataKey);
        });
        _this._resetColumnManager = (0, $dCUwp.default)(function(columns, fixed) {
            _this.columnManager.reset(columns, fixed);
            if (_this.props.estimatedRowHeight && fixed) {
                if (!_this.columnManager.hasLeftFrozenColumns()) _this._leftRowHeightMap = {};
                if (!_this.columnManager.hasRightFrozenColumns()) _this._rightRowHeightMap = {};
            }
        }, function(newArgs, lastArgs) {
            return (0, $7h8T1.isObjectEqual)(newArgs, lastArgs, _this.props.ignoreFunctionInColumnCompare);
        });
        _this._isResetting = false;
        _this._resetIndex = null;
        _this._rowHeightMap = {};
        _this._rowHeightMapBuffer = {};
        _this._mainRowHeightMap = {};
        _this._leftRowHeightMap = {};
        _this._rightRowHeightMap = {};
        _this._getEstimatedTotalRowsHeight = (0, $dCUwp.default)((0, $7h8T1.getEstimatedTotalRowsHeight));
        _this._getRowHeight = _this._getRowHeight.bind((0, $aCdHv.default)(_this));
        _this._updateRowHeights = (0, $7h8T1.debounce)(function() {
            _this._isResetting = true;
            _this._rowHeightMap = $5ac7d9f9832fd743$var$_objectSpread({}, _this._rowHeightMap, {}, _this._rowHeightMapBuffer);
            _this.resetAfterRowIndex(_this._resetIndex, false);
            _this._rowHeightMapBuffer = {};
            _this._resetIndex = null;
            _this.forceUpdateTable();
            _this.forceUpdate();
            _this._isResetting = false;
        }, 0);
        _this._scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        _this._scrollHeight = 0;
        _this._lastScannedRowIndex = -1;
        _this._hasDataChangedSinceEndReached = true;
        _this._data = props.data;
        _this._depthMap = {};
        _this._horizontalScrollbarSize = 0;
        _this._verticalScrollbarSize = 0;
        _this._scrollbarPresenceChanged = false;
        return _this;
    }
    /**
   * Get the DOM node of the table
   */ var _proto = BaseTableV2.prototype;
    _proto.getDOMNode = function getDOMNode() {
        return this.tableNode;
    } /**
   * Get the column manager
   */ ;
    _proto.getColumnManager = function getColumnManager() {
        return this.columnManager;
    } /**
   * Get internal `expandedRowKeys` state
   */ ;
    _proto.getExpandedRowKeys = function getExpandedRowKeys() {
        var expandedRowKeys = this.props.expandedRowKeys;
        return expandedRowKeys !== undefined ? expandedRowKeys || $5ac7d9f9832fd743$var$EMPTY_ARRAY : this.state.expandedRowKeys;
    } /**
   * Get the expanded state, fallback to normal state if not expandable.
   */ ;
    _proto.getExpandedState = function getExpandedState() {
        return {
            expandedData: this._data,
            expandedRowKeys: this.getExpandedRowKeys(),
            expandedDepthMap: this._depthMap
        };
    } /**
   * Get the total height of all rows, including expanded rows.
   */ ;
    _proto.getTotalRowsHeight = function getTotalRowsHeight() {
        var _this$props = this.props, rowHeight = _this$props.rowHeight, estimatedRowHeight = _this$props.estimatedRowHeight;
        if (estimatedRowHeight) return this.table ? this.table.getTotalRowsHeight() : this._getEstimatedTotalRowsHeight(this._data, estimatedRowHeight);
        return this._data.length * rowHeight;
    } /**
   * Get the total width of all columns.
   */ ;
    _proto.getTotalColumnsWidth = function getTotalColumnsWidth() {
        return this.columnManager.getColumnsWidth();
    } /**
   * Forcefully re-render the inner Grid component.
   *
   * Calling `forceUpdate` on `Table` may not re-render the inner Grid since it uses `shallowCompare` as a performance optimization.
   * Use this method if you want to manually trigger a re-render.
   * This may be appropriate if the underlying row data has changed but the row sizes themselves have not.
   */ ;
    _proto.forceUpdateTable = function forceUpdateTable() {
        this.table && this.table.forceUpdateTable();
        this.leftTable && this.leftTable.forceUpdateTable();
        this.rightTable && this.rightTable.forceUpdateTable();
    } /**
   * Reset cached offsets for positioning after a specific rowIndex, should be used only in dynamic mode(estimatedRowHeight is provided)
   *
   * @param {number} rowIndex
   * @param {boolean} shouldForceUpdate
   */ ;
    _proto.resetAfterRowIndex = function resetAfterRowIndex(rowIndex, shouldForceUpdate) {
        if (rowIndex === void 0) rowIndex = 0;
        if (shouldForceUpdate === void 0) shouldForceUpdate = true;
        if (!this.props.estimatedRowHeight) return;
        this.table && this.table.resetAfterRowIndex(rowIndex, shouldForceUpdate);
        this.leftTable && this.leftTable.resetAfterRowIndex(rowIndex, shouldForceUpdate);
        this.rightTable && this.rightTable.resetAfterRowIndex(rowIndex, shouldForceUpdate);
    } /**
   * Reset row height cache, useful if `data` changed entirely, should be used only in dynamic mode(estimatedRowHeight is provided)
   */ ;
    _proto.resetRowHeightCache = function resetRowHeightCache() {
        if (!this.props.estimatedRowHeight) return;
        this._resetIndex = null;
        this._rowHeightMapBuffer = {};
        this._rowHeightMap = {};
        this._mainRowHeightMap = {};
        this._leftRowHeightMap = {};
        this._rightRowHeightMap = {};
    } /**
   * Scroll to the specified offset.
   * Useful for animating position changes.
   *
   * @param {object} offset
   */ ;
    _proto.scrollToPosition = function scrollToPosition(offset) {
        this._scroll = offset;
        this.table && this.table.scrollToPosition(offset);
        this.leftTable && this.leftTable.scrollToTop(offset.scrollTop);
        this.rightTable && this.rightTable.scrollToTop(offset.scrollTop);
    } /**
   * Scroll to the specified offset vertically.
   *
   * @param {number} scrollTop
   */ ;
    _proto.scrollToTop = function scrollToTop(scrollTop) {
        this._scroll.scrollTop = scrollTop;
        this.table && this.table.scrollToPosition(this._scroll);
        this.leftTable && this.leftTable.scrollToTop(scrollTop);
        this.rightTable && this.rightTable.scrollToTop(scrollTop);
    } /**
   * Scroll to the specified offset horizontally.
   *
   * @param {number} scrollLeft
   */ ;
    _proto.scrollToLeft = function scrollToLeft(scrollLeft) {
        this._scroll.scrollLeft = scrollLeft;
        this.table && this.table.scrollToPosition(this._scroll);
    } /**
   * Scroll to the specified row.
   * By default, the table will scroll as little as possible to ensure the row is visible.
   * You can control the alignment of the row though by specifying an align property. Acceptable values are:
   *
   * - `auto` (default) - Scroll as little as possible to ensure the row is visible.
   * - `smart` - Same as `auto` if it is less than one viewport away, or it's the same as`center`.
   * - `center` - Center align the row within the table.
   * - `end` - Align the row to the bottom side of the table.
   * - `start` - Align the row to the top side of the table.
   *
   * @param {number} rowIndex
   * @param {string} align
   */ ;
    _proto.scrollToRow = function scrollToRow(rowIndex, align) {
        if (rowIndex === void 0) rowIndex = 0;
        if (align === void 0) align = 'auto';
        this.table && this.table.scrollToRow(rowIndex, align);
        this.leftTable && this.leftTable.scrollToRow(rowIndex, align);
        this.rightTable && this.rightTable.scrollToRow(rowIndex, align);
    } /**
   * Set `expandedRowKeys` manually.
   * This method is available only if `expandedRowKeys` is uncontrolled.
   *
   * @param {array} expandedRowKeys
   */ ;
    _proto.setExpandedRowKeys = function setExpandedRowKeys(expandedRowKeys) {
        // if `expandedRowKeys` is controlled
        if (this.props.expandedRowKeys !== undefined) return;
        this.setState({
            expandedRowKeys: (0, $7h8T1.cloneArray)(expandedRowKeys)
        });
    };
    _proto.renderExpandIcon = function renderExpandIcon(_ref) {
        var rowData = _ref.rowData, rowIndex = _ref.rowIndex, depth = _ref.depth, onExpand = _ref.onExpand;
        var _this$props2 = this.props, rowKey = _this$props2.rowKey, expandColumnKey = _this$props2.expandColumnKey, expandIconProps = _this$props2.expandIconProps;
        if (!expandColumnKey) return null;
        var expandable = rowIndex >= 0 && (0, $7h8T1.hasChildren)(rowData);
        var expanded = rowIndex >= 0 && this.getExpandedRowKeys().indexOf(rowData[rowKey]) >= 0;
        var extraProps = (0, $7h8T1.callOrReturn)(expandIconProps, {
            rowData: rowData,
            rowIndex: rowIndex,
            depth: depth,
            expandable: expandable,
            expanded: expanded
        });
        var ExpandIcon = this._getComponent('ExpandIcon');
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ExpandIcon, (0, $kU09D.default)({
            depth: depth,
            expandable: expandable,
            expanded: expanded
        }, extraProps, {
            onExpand: onExpand
        }));
    };
    _proto.renderRow = function renderRow(_ref2) {
        var _cn;
        var isScrolling = _ref2.isScrolling, columns = _ref2.columns, rowData = _ref2.rowData, rowIndex = _ref2.rowIndex, style = _ref2.style;
        var _this$props3 = this.props, rowClassName = _this$props3.rowClassName, rowRenderer = _this$props3.rowRenderer, rowEventHandlers = _this$props3.rowEventHandlers, expandColumnKey = _this$props3.expandColumnKey, estimatedRowHeight = _this$props3.estimatedRowHeight;
        var rowClass = (0, $7h8T1.callOrReturn)(rowClassName, {
            columns: columns,
            rowData: rowData,
            rowIndex: rowIndex
        });
        var extraProps = (0, $7h8T1.callOrReturn)(this.props.rowProps, {
            columns: columns,
            rowData: rowData,
            rowIndex: rowIndex
        });
        var rowKey = rowData[this.props.rowKey];
        var depth = this._depthMap[rowKey] || 0;
        var className = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))(this._prefixClass('row'), rowClass, (_cn = {}, _cn[this._prefixClass("row--depth-" + depth)] = !!expandColumnKey && rowIndex >= 0, _cn[this._prefixClass('row--expanded')] = !!expandColumnKey && this.getExpandedRowKeys().indexOf(rowKey) >= 0, _cn[this._prefixClass('row--hovered')] = !isScrolling && rowKey === this.state.hoveredRowKey, _cn[this._prefixClass('row--frozen')] = depth === 0 && rowIndex < 0, _cn[this._prefixClass('row--customized')] = rowRenderer, _cn));
        var hasFrozenColumns = this.columnManager.hasFrozenColumns();
        var rowProps = $5ac7d9f9832fd743$var$_objectSpread({}, extraProps, {
            role: 'row',
            key: "row-" + rowKey,
            isScrolling: isScrolling,
            className: className,
            style: style,
            columns: columns,
            rowIndex: rowIndex,
            rowData: rowData,
            rowKey: rowKey,
            expandColumnKey: expandColumnKey,
            depth: depth,
            rowEventHandlers: rowEventHandlers,
            rowRenderer: rowRenderer,
            // for frozen rows we use fixed rowHeight
            estimatedRowHeight: rowIndex >= 0 ? estimatedRowHeight : undefined,
            getIsResetting: this._getIsResetting,
            cellRenderer: this.renderRowCell,
            expandIconRenderer: this.renderExpandIcon,
            onRowExpand: this._handleRowExpand,
            // for fixed table, we need to sync the hover state across the inner tables
            // onRowHover: hasFrozenColumns ? this._handleRowHover : null,
            onRowHeightChange: hasFrozenColumns ? this._handleFrozenRowHeightChange : this._handleRowHeightChange
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gdyfF.default), rowProps);
    };
    _proto.renderRowCell = function renderRowCell(_ref3) {
        var _cn2;
        var isScrolling = _ref3.isScrolling, columns = _ref3.columns, column = _ref3.column, columnIndex = _ref3.columnIndex, rowData = _ref3.rowData, rowIndex = _ref3.rowIndex, expandIcon = _ref3.expandIcon;
        var isFrozenColumnCell = column[(0, $i1YES.default).PlaceholderKey];
        var left = null; // Calculate the left offset of the cell
        if (isFrozenColumnCell) left = $5ac7d9f9832fd743$var$getStickyColumnLeftPosition(columns, columnIndex);
        var className = column.className, dataKey = column.dataKey, dataGetter = column.dataGetter, cellRenderer = column.cellRenderer;
        var TableCell = this._getComponent('TableCell');
        var cellData = dataGetter ? dataGetter({
            columns: columns,
            column: column,
            columnIndex: columnIndex,
            rowData: rowData,
            rowIndex: rowIndex
        }) : (0, $7h8T1.getValue)(rowData, dataKey);
        var cellProps = {
            isScrolling: isScrolling,
            cellData: cellData,
            columns: columns,
            column: column,
            columnIndex: columnIndex,
            rowData: rowData,
            rowIndex: rowIndex,
            container: this
        };
        var cell = (0, $7h8T1.renderElement)(cellRenderer || (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TableCell, {
            className: this._prefixClass('row-cell-text')
        }), cellProps);
        var cellCls = (0, $7h8T1.callOrReturn)(className, {
            cellData: cellData,
            columns: columns,
            column: column,
            columnIndex: columnIndex,
            rowData: rowData,
            rowIndex: rowIndex
        });
        var cls = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))(this._prefixClass('row-cell'), cellCls, (_cn2 = {}, _cn2[this._prefixClass('row-cell--align-center')] = column.align === (0, $aymWH.Alignment).CENTER, _cn2[this._prefixClass('row-cell--align-right')] = column.align === (0, $aymWH.Alignment).RIGHT, _cn2[this._prefixClass('row-cell--sticky')] = isFrozenColumnCell, _cn2));
        var extraProps = (0, $7h8T1.callOrReturn)(this.props.cellProps, {
            columns: columns,
            column: column,
            columnIndex: columnIndex,
            rowData: rowData,
            rowIndex: rowIndex
        });
        var _ref4 = extraProps || {}, tagName = _ref4.tagName, rest = (0, $6XgOP.default)(_ref4, [
            "tagName"
        ]);
        var Tag = tagName || 'div';
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Tag, (0, $kU09D.default)({
            role: "gridcell",
            key: "row-" + rowData[this.props.rowKey] + "-cell-" + column.key
        }, rest, {
            className: cls,
            style: $5ac7d9f9832fd743$var$_objectSpread({}, this.columnManager.getColumnStyle(column.key), {}, left !== null && {
                left: left
            })
        }), expandIcon, cell);
    };
    _proto.renderHeader = function renderHeader(_ref5) {
        var _cn3;
        var columns = _ref5.columns, headerIndex = _ref5.headerIndex, style = _ref5.style;
        var _this$props4 = this.props, headerClassName = _this$props4.headerClassName, headerRenderer = _this$props4.headerRenderer;
        var headerClass = (0, $7h8T1.callOrReturn)(headerClassName, {
            columns: columns,
            headerIndex: headerIndex
        });
        var extraProps = (0, $7h8T1.callOrReturn)(this.props.headerProps, {
            columns: columns,
            headerIndex: headerIndex
        });
        var className = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))(this._prefixClass('header-row'), headerClass, (_cn3 = {}, _cn3[this._prefixClass('header-row--resizing')] = !!this.state.resizingKey, _cn3[this._prefixClass('header-row--customized')] = headerRenderer, _cn3));
        var headerProps = $5ac7d9f9832fd743$var$_objectSpread({}, extraProps, {
            role: 'row',
            key: "header-" + headerIndex,
            className: className,
            style: style,
            columns: columns,
            headerIndex: headerIndex,
            headerRenderer: headerRenderer,
            cellRenderer: this.renderHeaderCell,
            expandColumnKey: this.props.expandColumnKey,
            expandIcon: this._getComponent('ExpandIcon')
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eEtBg.default), headerProps);
    };
    _proto.renderHeaderCell = function renderHeaderCell(_ref6) {
        var _cn4, _cn5;
        var columns = _ref6.columns, column = _ref6.column, columnIndex = _ref6.columnIndex, headerIndex = _ref6.headerIndex, expandIcon = _ref6.expandIcon;
        var isFrozenColumnCell = column[(0, $i1YES.default).PlaceholderKey];
        var left = null; // Calculate the left offset of the cell
        if (isFrozenColumnCell) left = $5ac7d9f9832fd743$var$getStickyColumnLeftPosition(columns, columnIndex);
        var headerClassName = column.headerClassName, headerRenderer = column.headerRenderer;
        var _this$props5 = this.props, sortBy = _this$props5.sortBy, sortState = _this$props5.sortState, headerCellProps = _this$props5.headerCellProps;
        var TableHeaderCell = this._getComponent('TableHeaderCell');
        var SortIndicator = this._getComponent('SortIndicator');
        var cellProps = {
            columns: columns,
            column: column,
            columnIndex: columnIndex,
            headerIndex: headerIndex,
            container: this
        };
        var cell = (0, $7h8T1.renderElement)(headerRenderer || (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(TableHeaderCell, {
            className: this._prefixClass('header-cell-text')
        }), cellProps);
        var sorting, sortOrder;
        if (sortState) {
            var order = sortState[column.key];
            sorting = order === (0, $bFxRm.default).ASC || order === (0, $bFxRm.default).DESC;
            sortOrder = sorting ? order : (0, $bFxRm.default).ASC;
        } else {
            sorting = column.key === sortBy.key;
            sortOrder = sorting ? sortBy.order : (0, $bFxRm.default).ASC;
        }
        var cellCls = (0, $7h8T1.callOrReturn)(headerClassName, {
            columns: columns,
            column: column,
            columnIndex: columnIndex,
            headerIndex: headerIndex
        });
        var cls = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))(this._prefixClass('header-cell'), cellCls, (_cn4 = {}, _cn4[this._prefixClass('header-cell--align-center')] = column.align === (0, $aymWH.Alignment).CENTER, _cn4[this._prefixClass('header-cell--align-right')] = column.align === (0, $aymWH.Alignment).RIGHT, _cn4[this._prefixClass('header-cell--sortable')] = column.sortable, _cn4[this._prefixClass('header-cell--sorting')] = sorting, _cn4[this._prefixClass('header-cell--resizing')] = column.key === this.state.resizingKey, _cn4[this._prefixClass('header-cell--sticky')] = isFrozenColumnCell, _cn4));
        var extraProps = (0, $7h8T1.callOrReturn)(headerCellProps, {
            columns: columns,
            column: column,
            columnIndex: columnIndex,
            headerIndex: headerIndex
        });
        var _ref7 = extraProps || {}, tagName = _ref7.tagName, rest = (0, $6XgOP.default)(_ref7, [
            "tagName"
        ]);
        var Tag = tagName || 'div';
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Tag, (0, $kU09D.default)({
            role: "gridcell",
            key: "header-" + headerIndex + "-cell-" + column.key,
            onClick: column.sortable ? this._handleColumnSort : null
        }, rest, {
            className: cls,
            style: $5ac7d9f9832fd743$var$_objectSpread({}, this.columnManager.getColumnStyle(column.key), {}, left !== null && {
                left: left
            }),
            "data-key": column.key
        }), expandIcon, cell, column.sortable && (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SortIndicator, {
            sortOrder: sortOrder,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))(this._prefixClass('sort-indicator'), (_cn5 = {}, _cn5[this._prefixClass('sort-indicator--descending')] = sortOrder === (0, $bFxRm.default).DESC, _cn5))
        }), column.resizable && (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g0W2r.default), {
            className: this._prefixClass('column-resizer'),
            column: column,
            onResizeStart: this._handleColumnResizeStart,
            onResizeStop: this._handleColumnResizeStop,
            onResize: this._handleColumnResize
        }));
    };
    _proto.renderMainTable = function renderMainTable() {
        var _this$props6 = this.props, width = _this$props6.width, headerHeight = _this$props6.headerHeight, rowHeight = _this$props6.rowHeight, fixed = _this$props6.fixed, estimatedRowHeight = _this$props6.estimatedRowHeight, rest = (0, $6XgOP.default)(_this$props6, [
            "width",
            "headerHeight",
            "rowHeight",
            "fixed",
            "estimatedRowHeight"
        ]);
        var height = this._getTableHeight();
        var tableWidth = width - this._verticalScrollbarSize;
        if (fixed) {
            var columnsWidth = this.columnManager.getColumnsWidth(); // make sure `scrollLeft` is always integer to fix a sync bug when scrolling to end horizontally
            tableWidth = Math.max(Math.round(columnsWidth), tableWidth);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6z2Iy.default), (0, $kU09D.default)({}, rest, this.state, {
            className: this._prefixClass('table-main'),
            ref: this._setMainTableRef,
            data: this._data,
            columns: this.columnManager.getMainColumns(),
            width: width,
            height: height,
            headerHeight: headerHeight,
            rowHeight: rowHeight,
            estimatedRowHeight: estimatedRowHeight,
            getRowHeight: estimatedRowHeight ? this._getRowHeight : undefined,
            headerWidth: tableWidth + (fixed ? this._verticalScrollbarSize : 0),
            bodyWidth: tableWidth,
            headerRenderer: this.renderHeader,
            rowRenderer: this.renderRow,
            onScroll: this._handleScroll,
            onRowsRendered: this._handleRowsRendered
        }));
    };
    _proto.renderLeftTable = function renderLeftTable() {
        if (!this.columnManager.hasLeftFrozenColumns()) return null;
        var _this$props7 = this.props, width = _this$props7.width, headerHeight = _this$props7.headerHeight, rowHeight = _this$props7.rowHeight, estimatedRowHeight = _this$props7.estimatedRowHeight, rest = (0, $6XgOP.default)(_this$props7, [
            "width",
            "headerHeight",
            "rowHeight",
            "estimatedRowHeight"
        ]);
        var containerHeight = this._getFrozenContainerHeight();
        var offset = this._verticalScrollbarSize || 20;
        var columnsWidth = this.columnManager.getLeftFrozenColumnsWidth();
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6z2Iy.default), (0, $kU09D.default)({}, rest, this.state, {
            containerStyle: this._getLeftTableContainerStyle(columnsWidth, width, containerHeight),
            className: this._prefixClass('table-frozen-left'),
            ref: this._setLeftTableRef,
            data: this._data,
            columns: this.columnManager.getLeftFrozenColumns(),
            initialScrollTop: this._scroll.scrollTop,
            width: columnsWidth + offset,
            height: containerHeight,
            headerHeight: headerHeight,
            rowHeight: rowHeight,
            estimatedRowHeight: estimatedRowHeight,
            getRowHeight: estimatedRowHeight ? this._getRowHeight : undefined,
            headerWidth: columnsWidth + offset,
            bodyWidth: columnsWidth + offset,
            headerRenderer: this.renderHeader,
            rowRenderer: this.renderRow,
            onScroll: this._handleVerticalScroll,
            onRowsRendered: (0, $7h8T1.noop)
        }));
    };
    _proto.renderRightTable = function renderRightTable() {
        if (!this.columnManager.hasRightFrozenColumns()) return null;
        var _this$props8 = this.props, width = _this$props8.width, headerHeight = _this$props8.headerHeight, rowHeight = _this$props8.rowHeight, estimatedRowHeight = _this$props8.estimatedRowHeight, rest = (0, $6XgOP.default)(_this$props8, [
            "width",
            "headerHeight",
            "rowHeight",
            "estimatedRowHeight"
        ]);
        var containerHeight = this._getFrozenContainerHeight();
        var columnsWidth = this.columnManager.getRightFrozenColumnsWidth();
        var scrollbarWidth = this._verticalScrollbarSize;
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6z2Iy.default), (0, $kU09D.default)({}, rest, this.state, {
            containerStyle: this._getLeftTableContainerStyle(columnsWidth + scrollbarWidth, width, containerHeight),
            className: this._prefixClass('table-frozen-right'),
            ref: this._setRightTableRef,
            data: this._data,
            columns: this.columnManager.getRightFrozenColumns(),
            initialScrollTop: this._scroll.scrollTop,
            width: columnsWidth + scrollbarWidth,
            height: containerHeight,
            headerHeight: headerHeight,
            rowHeight: rowHeight,
            estimatedRowHeight: estimatedRowHeight,
            getRowHeight: estimatedRowHeight ? this._getRowHeight : undefined,
            headerWidth: columnsWidth + scrollbarWidth,
            bodyWidth: columnsWidth,
            headerRenderer: this.renderHeader,
            rowRenderer: this.renderRow,
            onScroll: this._handleVerticalScroll,
            onRowsRendered: (0, $7h8T1.noop)
        }));
    };
    _proto.renderResizingLine = function renderResizingLine() {
        var _this$props9 = this.props, width = _this$props9.width, fixed = _this$props9.fixed;
        var resizingKey = this.state.resizingKey;
        if (!fixed || !resizingKey) return null;
        var columns = this.columnManager.getMainColumns();
        var idx = columns.findIndex(function(column) {
            return column.key === resizingKey;
        });
        var column = columns[idx];
        var columnWidth = column.width, frozen = column.frozen;
        var leftWidth = this.columnManager.recomputeColumnsWidth(columns.slice(0, idx));
        var left = leftWidth + columnWidth;
        if (!frozen) left -= this._scroll.scrollLeft;
        else if (frozen === (0, $aymWH.FrozenDirection).RIGHT) {
            var rightWidth = this.columnManager.recomputeColumnsWidth(columns.slice(idx + 1));
            if (rightWidth + columnWidth > width - this._verticalScrollbarSize) left = columnWidth;
            else left = width - this._verticalScrollbarSize - rightWidth;
        }
        var style = {
            left: left,
            height: this._getTableHeight() - this._horizontalScrollbarSize
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: this._prefixClass('resizing-line'),
            style: style
        });
    };
    _proto.renderFooter = function renderFooter() {
        var _this$props10 = this.props, footerHeight = _this$props10.footerHeight, footerRenderer = _this$props10.footerRenderer;
        if (footerHeight === 0) return null;
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: this._prefixClass('footer'),
            style: {
                height: footerHeight
            }
        }, (0, $7h8T1.renderElement)(footerRenderer));
    };
    _proto.renderEmptyLayer = function renderEmptyLayer() {
        var _this$props11 = this.props, data = _this$props11.data, frozenData = _this$props11.frozenData, footerHeight = _this$props11.footerHeight, emptyRenderer = _this$props11.emptyRenderer;
        if (data && data.length || frozenData && frozenData.length) return null;
        var headerHeight = this._getHeaderHeight();
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: this._prefixClass('empty-layer'),
            style: {
                top: headerHeight,
                bottom: footerHeight
            }
        }, (0, $7h8T1.renderElement)(emptyRenderer));
    };
    _proto.renderOverlay = function renderOverlay() {
        var overlayRenderer = this.props.overlayRenderer;
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: this._prefixClass('overlay')
        }, !!overlayRenderer && (0, $7h8T1.renderElement)(overlayRenderer));
    };
    _proto.render = function render() {
        var _cn6;
        var _this$props12 = this.props, columns = _this$props12.columns, children = _this$props12.children, width = _this$props12.width, fixed = _this$props12.fixed, data = _this$props12.data, frozenData = _this$props12.frozenData, expandColumnKey = _this$props12.expandColumnKey, disabled = _this$props12.disabled, className = _this$props12.className, style = _this$props12.style, footerHeight = _this$props12.footerHeight, classPrefix = _this$props12.classPrefix, estimatedRowHeight = _this$props12.estimatedRowHeight;
        this._resetColumnManager($5ac7d9f9832fd743$var$getColumns(columns, children), fixed);
        var _data = expandColumnKey ? this._flattenOnKeys(data, this.getExpandedRowKeys(), this.props.rowKey) : data;
        if (this._data !== _data) {
            this.resetAfterRowIndex(0, false);
            this._data = _data;
        } // should be after `this._data` assigned
        this._calcScrollbarSizes();
        this._totalRowsHeight = this.getTotalRowsHeight();
        var containerStyle = $5ac7d9f9832fd743$var$_objectSpread({}, style, {
            width: width,
            height: this._getTableHeight() + footerHeight,
            position: 'relative'
        });
        var cls = (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))(classPrefix, className, (_cn6 = {}, _cn6[classPrefix + "--fixed"] = fixed, _cn6[classPrefix + "--expandable"] = !!expandColumnKey, _cn6[classPrefix + "--empty"] = data.length === 0, _cn6[classPrefix + "--has-frozen-rows"] = frozenData.length > 0, _cn6[classPrefix + "--has-frozen-columns"] = this.columnManager.hasFrozenColumns(), _cn6[classPrefix + "--disabled"] = disabled, _cn6[classPrefix + "--dynamic"] = !!estimatedRowHeight, _cn6));
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ref: this._setContainerRef,
            className: cls,
            style: containerStyle
        }, this.renderFooter(), this.renderMainTable(), this.renderResizingLine(), this.renderEmptyLayer(), this.renderOverlay());
    };
    _proto.componentDidMount = function componentDidMount() {
        var scrollbarSize = this.props.getScrollbarSize();
        if (scrollbarSize > 0) this.setState({
            scrollbarSize: scrollbarSize
        });
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        var _this$props13 = this.props, data = _this$props13.data, height = _this$props13.height, maxHeight = _this$props13.maxHeight, estimatedRowHeight = _this$props13.estimatedRowHeight;
        if (data !== prevProps.data) {
            this._lastScannedRowIndex = -1;
            this._hasDataChangedSinceEndReached = true;
        }
        if (maxHeight !== prevProps.maxHeight || height !== prevProps.height) this._maybeCallOnEndReached();
        this._maybeScrollbarPresenceChange();
        if (estimatedRowHeight) {
            if (this.getTotalRowsHeight() !== this._totalRowsHeight) this.forceUpdate();
        }
    };
    _proto._prefixClass = function _prefixClass(className) {
        return this.props.classPrefix + "__" + className;
    };
    _proto._setContainerRef = function _setContainerRef(ref) {
        this.tableNode = ref;
    };
    _proto._setMainTableRef = function _setMainTableRef(ref) {
        this.table = ref;
    };
    _proto._setLeftTableRef = function _setLeftTableRef(ref) {
        this.leftTable = ref;
    };
    _proto._setRightTableRef = function _setRightTableRef(ref) {
        this.rightTable = ref;
    };
    _proto._getComponent = function _getComponent(name) {
        if (this.props.components && this.props.components[name]) return this.props.components[name];
        return $5ac7d9f9832fd743$var$DEFAULT_COMPONENTS[name];
    } // for dynamic row height
    ;
    _proto._getRowHeight = function _getRowHeight(rowIndex) {
        var _this$props14 = this.props, estimatedRowHeight = _this$props14.estimatedRowHeight, rowKey = _this$props14.rowKey;
        return this._rowHeightMap[this._data[rowIndex][rowKey]] || (0, $7h8T1.callOrReturn)(estimatedRowHeight, {
            rowData: this._data[rowIndex],
            rowIndex: rowIndex
        });
    };
    _proto._getIsResetting = function _getIsResetting() {
        return this._isResetting;
    };
    _proto._getHeaderHeight = function _getHeaderHeight() {
        var headerHeight = this.props.headerHeight;
        if (Array.isArray(headerHeight)) return headerHeight.reduce(function(sum, height) {
            return sum + height;
        }, 0);
        return headerHeight;
    };
    _proto._getFrozenRowsHeight = function _getFrozenRowsHeight() {
        var _this$props15 = this.props, frozenData = _this$props15.frozenData, rowHeight = _this$props15.rowHeight;
        return frozenData.length * rowHeight;
    };
    _proto._getTableHeight = function _getTableHeight() {
        var _this$props16 = this.props, height = _this$props16.height, maxHeight = _this$props16.maxHeight, footerHeight = _this$props16.footerHeight;
        var tableHeight = height - footerHeight;
        if (maxHeight > 0) {
            var frozenRowsHeight = this._getFrozenRowsHeight();
            var totalRowsHeight = this.getTotalRowsHeight();
            var headerHeight = this._getHeaderHeight();
            var totalHeight = headerHeight + frozenRowsHeight + totalRowsHeight + this._horizontalScrollbarSize;
            tableHeight = Math.min(totalHeight, maxHeight - footerHeight);
        }
        return tableHeight;
    };
    _proto._getBodyHeight = function _getBodyHeight() {
        return this._getTableHeight() - this._getHeaderHeight() - this._getFrozenRowsHeight();
    };
    _proto._getFrozenContainerHeight = function _getFrozenContainerHeight() {
        var maxHeight = this.props.maxHeight;
        var tableHeight = this._getTableHeight() - (this._data.length > 0 ? this._horizontalScrollbarSize : 0); // in auto height mode tableHeight = totalHeight
        if (maxHeight > 0) return tableHeight;
        var totalHeight = this.getTotalRowsHeight() + this._getHeaderHeight() + this._getFrozenRowsHeight();
        return Math.min(tableHeight, totalHeight);
    };
    _proto._calcScrollbarSizes = function _calcScrollbarSizes() {
        var _this$props17 = this.props, fixed = _this$props17.fixed, width = _this$props17.width;
        var scrollbarSize = this.state.scrollbarSize;
        var totalRowsHeight = this.getTotalRowsHeight();
        var totalColumnsWidth = this.getTotalColumnsWidth();
        var prevHorizontalScrollbarSize = this._horizontalScrollbarSize;
        var prevVerticalScrollbarSize = this._verticalScrollbarSize;
        if (scrollbarSize === 0) {
            this._horizontalScrollbarSize = 0;
            this._verticalScrollbarSize = 0;
        } else {
            // we have to set `this._horizontalScrollbarSize` before calling `this._getBodyHeight`
            if (!fixed || totalColumnsWidth <= width - scrollbarSize) {
                this._horizontalScrollbarSize = 0;
                this._verticalScrollbarSize = totalRowsHeight > this._getBodyHeight() ? scrollbarSize : 0;
            } else if (totalColumnsWidth > width) {
                this._horizontalScrollbarSize = scrollbarSize;
                this._verticalScrollbarSize = totalRowsHeight > this._getBodyHeight() - this._horizontalScrollbarSize ? scrollbarSize : 0;
            } else {
                this._horizontalScrollbarSize = 0;
                this._verticalScrollbarSize = 0;
                if (totalRowsHeight > this._getBodyHeight()) {
                    this._horizontalScrollbarSize = scrollbarSize;
                    this._verticalScrollbarSize = scrollbarSize;
                }
            }
        }
        if (prevHorizontalScrollbarSize !== this._horizontalScrollbarSize || prevVerticalScrollbarSize !== this._verticalScrollbarSize) this._scrollbarPresenceChanged = true;
    };
    _proto._maybeScrollbarPresenceChange = function _maybeScrollbarPresenceChange() {
        if (this._scrollbarPresenceChanged) {
            var onScrollbarPresenceChange = this.props.onScrollbarPresenceChange;
            this._scrollbarPresenceChanged = false;
            onScrollbarPresenceChange({
                size: this.state.scrollbarSize,
                horizontal: this._horizontalScrollbarSize > 0,
                vertical: this._verticalScrollbarSize > 0
            });
        }
    };
    _proto._maybeCallOnEndReached = function _maybeCallOnEndReached() {
        var _this$props18 = this.props, onEndReached = _this$props18.onEndReached, onEndReachedThreshold = _this$props18.onEndReachedThreshold;
        var scrollTop = this._scroll.scrollTop;
        var scrollHeight = this.getTotalRowsHeight();
        var clientHeight = this._getBodyHeight();
        if (!onEndReached || !clientHeight || !scrollHeight) return;
        var distanceFromEnd = scrollHeight - scrollTop - clientHeight + this._horizontalScrollbarSize;
        if (this._lastScannedRowIndex >= 0 && distanceFromEnd <= onEndReachedThreshold && (this._hasDataChangedSinceEndReached || scrollHeight !== this._scrollHeight)) {
            this._hasDataChangedSinceEndReached = false;
            this._scrollHeight = scrollHeight;
            onEndReached({
                distanceFromEnd: distanceFromEnd
            });
        }
    };
    _proto._handleScroll = function _handleScroll(args) {
        var lastScrollTop = this._scroll.scrollTop;
        this.scrollToPosition(args);
        this.props.onScroll(args);
        if (args.scrollTop > lastScrollTop) this._maybeCallOnEndReached();
    };
    _proto._handleVerticalScroll = function _handleVerticalScroll(_ref8) {
        var scrollTop = _ref8.scrollTop;
        var lastScrollTop = this._scroll.scrollTop;
        if (scrollTop !== lastScrollTop) this.scrollToTop(scrollTop);
        if (scrollTop > lastScrollTop) this._maybeCallOnEndReached();
    };
    _proto._handleRowsRendered = function _handleRowsRendered(args) {
        this.props.onRowsRendered(args);
        if (args.overscanStopIndex > this._lastScannedRowIndex) {
            this._lastScannedRowIndex = args.overscanStopIndex;
            this._maybeCallOnEndReached();
        }
    };
    _proto._handleRowHover = function _handleRowHover(_ref9) {
        var hovered = _ref9.hovered, rowKey = _ref9.rowKey;
        this.setState({
            hoveredRowKey: hovered ? rowKey : null
        });
    };
    _proto._handleRowExpand = function _handleRowExpand(_ref10) {
        var expanded = _ref10.expanded, rowData = _ref10.rowData, rowIndex = _ref10.rowIndex, rowKey = _ref10.rowKey;
        var expandedRowKeys = (0, $7h8T1.cloneArray)(this.getExpandedRowKeys());
        if (expanded) {
            if (!expandedRowKeys.indexOf(rowKey) >= 0) expandedRowKeys.push(rowKey);
        } else {
            var index = expandedRowKeys.indexOf(rowKey);
            if (index > -1) expandedRowKeys.splice(index, 1);
        } // if `expandedRowKeys` is uncontrolled, update internal state
        if (this.props.expandedRowKeys === undefined) this.setState({
            expandedRowKeys: expandedRowKeys
        });
        this.props.onRowExpand({
            expanded: expanded,
            rowData: rowData,
            rowIndex: rowIndex,
            rowKey: rowKey
        });
        this.props.onExpandedRowsChange(expandedRowKeys);
    };
    _proto._handleColumnResize = function _handleColumnResize(_ref11, width) {
        var key = _ref11.key;
        this.columnManager.setColumnWidth(key, width);
        this.setState({
            resizingWidth: width
        });
        var column = this.columnManager.getColumn(key);
        this.props.onColumnResize({
            column: column,
            width: width
        });
    };
    _proto._handleColumnResizeStart = function _handleColumnResizeStart(_ref12) {
        var key = _ref12.key;
        this.setState({
            resizingKey: key
        });
    };
    _proto._handleColumnResizeStop = function _handleColumnResizeStop() {
        var _this$state = this.state, resizingKey = _this$state.resizingKey, resizingWidth = _this$state.resizingWidth;
        this.setState({
            resizingKey: null,
            resizingWidth: 0
        });
        if (!resizingKey || !resizingWidth) return;
        var column = this.columnManager.getColumn(resizingKey);
        this.props.onColumnResizeEnd({
            column: column,
            width: resizingWidth
        });
    };
    _proto._handleColumnSort = function _handleColumnSort(event) {
        var key = event.currentTarget.dataset.key;
        var _this$props19 = this.props, sortBy = _this$props19.sortBy, sortState = _this$props19.sortState, onColumnSort = _this$props19.onColumnSort;
        var order = (0, $bFxRm.default).ASC;
        if (sortState) order = sortState[key] === (0, $bFxRm.default).ASC ? (0, $bFxRm.default).DESC : (0, $bFxRm.default).ASC;
        else if (key === sortBy.key) order = sortBy.order === (0, $bFxRm.default).ASC ? (0, $bFxRm.default).DESC : (0, $bFxRm.default).ASC;
        var column = this.columnManager.getColumn(key);
        onColumnSort({
            column: column,
            key: key,
            order: order
        });
    };
    _proto._handleFrozenRowHeightChange = function _handleFrozenRowHeightChange(rowKey, size, rowIndex, frozen) {
        if (!frozen) this._mainRowHeightMap[rowKey] = size;
        else if (frozen === (0, $aymWH.FrozenDirection).RIGHT) this._rightRowHeightMap[rowKey] = size;
        else this._leftRowHeightMap[rowKey] = size;
        var height = Math.max(this._mainRowHeightMap[rowKey] || 0, this._leftRowHeightMap[rowKey] || 0, this._rightRowHeightMap[rowKey] || 0);
        if (this._rowHeightMap[rowKey] !== height) this._handleRowHeightChange(rowKey, height, rowIndex);
    };
    _proto._handleRowHeightChange = function _handleRowHeightChange(rowKey, size, rowIndex) {
        if (this._resetIndex === null) this._resetIndex = rowIndex;
        else if (this._resetIndex > rowIndex) this._resetIndex = rowIndex;
        this._rowHeightMapBuffer[rowKey] = size;
        this._updateRowHeights();
    };
    return BaseTableV2;
}((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent);
$5ac7d9f9832fd743$var$BaseTableV2.Column = (0, $aymWH.default);
$5ac7d9f9832fd743$var$BaseTableV2.PlaceholderKey = (0, $i1YES.default).PlaceholderKey;
$5ac7d9f9832fd743$var$BaseTableV2.defaultProps = {
    classPrefix: 'BaseTableV2',
    rowKey: 'id',
    data: [],
    frozenData: [],
    fixed: false,
    headerHeight: 50,
    rowHeight: 50,
    footerHeight: 0,
    defaultExpandedRowKeys: [],
    sortBy: {},
    useIsScrolling: false,
    overscanRowCount: 1,
    onEndReachedThreshold: 500,
    getScrollbarSize: (0, $7h8T1.getScrollbarSize),
    ignoreFunctionInColumnCompare: true,
    onScroll: (0, $7h8T1.noop),
    onRowsRendered: (0, $7h8T1.noop),
    onScrollbarPresenceChange: (0, $7h8T1.noop),
    onRowExpand: (0, $7h8T1.noop),
    onExpandedRowsChange: (0, $7h8T1.noop),
    onColumnSort: (0, $7h8T1.noop),
    onColumnResize: (0, $7h8T1.noop),
    onColumnResizeEnd: (0, $7h8T1.noop)
};
$5ac7d9f9832fd743$var$BaseTableV2.propTypes = {
    /**
   * Prefix for table's inner className
   */ classPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    /**
   * Class name for the table
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    /**
   * Custom style for the table
   */ style: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
    /**
   * A collection of Column
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node,
    /**
   * Columns for the table
   */ columns: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).shape((0, $aymWH.default).propTypes)),
    /**
   * The data for the table
   */ data: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).array.isRequired,
    /**
   * The data be frozen to top, `rowIndex` is negative and started from `-1`
   */ frozenData: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).array,
    /**
   * The key field of each data item
   */ rowKey: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number
    ]).isRequired,
    /**
   * The width of the table
   */ width: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number.isRequired,
    /**
   * The height of the table, will be ignored if `maxHeight` is set
   */ height: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    /**
   * The max height of the table, the table's height will auto change when data changes,
   * will turns to vertical scroll if reaches the max height
   */ maxHeight: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    /**
   * The height of each table row, will be only used by frozen rows if `estimatedRowHeight` is set
   */ rowHeight: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    /**
   * Estimated row height, the real height will be measure dynamically according to the content
   * The callback is of the shape of `({ rowData, rowIndex }) => number`
   */ estimatedRowHeight: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
    ]),
    /**
   * The height of the table header, set to 0 to hide the header, could be an array to render multi headers.
   */ headerHeight: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number)
    ]).isRequired,
    /**
   * The height of the table footer
   */ footerHeight: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    /**
   * Whether the width of the columns are fixed or flexible
   */ fixed: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    /**
   * Whether the table is disabled
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    /**
   * Custom renderer on top of the table component
   */ overlayRenderer: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).element
    ]),
    /**
   * Custom renderer when the length of data is 0
   */ emptyRenderer: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).element
    ]),
    /**
   * Custom footer renderer, available only if `footerHeight` is larger then 0
   */ footerRenderer: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).element
    ]),
    /**
   * Custom header renderer
   * The renderer receives props `{ cells, columns, headerIndex }`
   */ headerRenderer: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).element
    ]),
    /**
   * Custom row renderer
   * The renderer receives props `{ isScrolling, cells, columns, rowData, rowIndex, depth }`
   */ rowRenderer: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).element
    ]),
    /**
   * Class name for the table header, could be a callback to return the class name
   * The callback is of the shape of `({ columns, headerIndex }) => string`
   */ headerClassName: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
    ]),
    /**
   * Class name for the table row, could be a callback to return the class name
   * The callback is of the shape of `({ columns, rowData, rowIndex }) => string`
   */ rowClassName: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
    ]),
    /**
   * Extra props applied to header element
   * The handler is of the shape of `({ columns, headerIndex }) object`
   */ headerProps: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
    ]),
    /**
   * Extra props applied to header cell element
   * The handler is of the shape of `({ columns, column, columnIndex, headerIndex }) => object`
   */ headerCellProps: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
    ]),
    /**
   * Extra props applied to row element
   * The handler is of the shape of `({ columns, rowData, rowIndex }) => object`
   */ rowProps: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
    ]),
    /**
   * Extra props applied to row cell element
   * The handler is of the shape of `({ columns, column, columnIndex, rowData, rowIndex }) => object`
   */ cellProps: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
    ]),
    /**
   * Extra props applied to ExpandIcon component
   * The handler is of the shape of `({ rowData, rowIndex, depth, expandable, expanded }) => object`
   */ expandIconProps: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
    ]),
    /**
   * The key for the expand column which render the expand icon if the data is a tree
   */ expandColumnKey: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    /**
   * Default expanded row keys when initialize the table
   */ defaultExpandedRowKeys: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number
    ])),
    /**
   * Controlled expanded row keys
   */ expandedRowKeys: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number
    ])),
    /**
   * A callback function when expand or collapse a tree node
   * The handler is of the shape of `({ expanded, rowData, rowIndex, rowKey }) => *`
   */ onRowExpand: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    /**
   * A callback function when the expanded row keys changed
   * The handler is of the shape of `(expandedRowKeys) => *`
   */ onExpandedRowsChange: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    /**
   * The sort state for the table, will be ignored if `sortState` is set
   */ sortBy: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).shape({
        /**
     * Sort key
     */ key: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
        /**
     * Sort order
     */ order: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOf([
            (0, $bFxRm.default).ASC,
            (0, $bFxRm.default).DESC
        ])
    }),
    /**
   * Multiple columns sort state for the table
   *
   * example:
   * ```js
   * {
   *   'column-0': SortOrder.ASC,
   *   'column-1': SortOrder.DESC,
   * }
   * ```
   */ sortState: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
    /**
   * A callback function for the header cell click event
   * The handler is of the shape of `({ column, key, order }) => *`
   */ onColumnSort: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    /**
   * A callback function when resizing the column width
   * The handler is of the shape of `({ column, width }) => *`
   */ onColumnResize: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    /**
   * A callback function when resizing the column width ends
   * The handler is of the shape of `({ column, width }) => *`
   */ onColumnResizeEnd: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    /**
   * Adds an additional isScrolling parameter to the row renderer.
   * This parameter can be used to show a placeholder row while scrolling.
   */ useIsScrolling: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    /**
   * Number of rows to render above/below the visible bounds of the list
   */ overscanRowCount: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    /**
   * Custom scrollbar size measurement
   */ getScrollbarSize: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    /**
   * A callback function when scrolling the table
   * The handler is of the shape of `({ scrollLeft, scrollTop, horizontalScrollDirection, verticalScrollDirection, scrollUpdateWasRequested }) => *`
   *
   * `scrollLeft` and `scrollTop` are numbers.
   *
   * `horizontalDirection` and `verticalDirection` are either `forward` or `backward`.
   *
   * `scrollUpdateWasRequested` is a boolean. This value is true if the scroll was caused by `scrollTo*`,
   * and false if it was the result of a user interaction in the browser.
   */ onScroll: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    /**
   * A callback function when scrolling the table within `onEndReachedThreshold` of the bottom
   * The handler is of the shape of `({ distanceFromEnd }) => *`
   */ onEndReached: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    /**
   * Threshold in pixels for calling `onEndReached`.
   */ onEndReachedThreshold: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    /**
   * A callback function with information about the slice of rows that were just rendered
   * The handler is of the shape of `({ overscanStartIndex, overscanStopIndex, startIndex， stopIndex }) => *`
   */ onRowsRendered: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    /**
   * A callback function when the scrollbar presence state changed
   * The handler is of the shape of `({ size, vertical, horizontal }) => *`
   */ onScrollbarPresenceChange: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    /**
   * A object for the row event handlers
   * Each of the keys is row event name, like `onClick`, `onDoubleClick` and etc.
   * Each of the handlers is of the shape of `({ rowData, rowIndex, rowKey, event }) => *`
   */ rowEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
    /**
   * whether to ignore function properties while comparing column definition
   */ ignoreFunctionInColumnCompare: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    /**
   * A object for the custom components, like `ExpandIcon` and `SortIndicator`
   */ components: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).shape({
        TableCell: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).elementType,
        TableHeaderCell: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).elementType,
        ExpandIcon: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).elementType,
        SortIndicator: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).elementType
    })
};
var $5ac7d9f9832fd743$export$2e2bcd8739ae039 = $5ac7d9f9832fd743$var$BaseTableV2;

});

parcelRegister("1AUfu", function(module, exports) {

$parcel$export(module.exports, "default", () => $1294c915d4f18790$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $hjdSp = parcelRequire("hjdSp");
/**
 * Decorator component that automatically adjusts the width and height of a single child
 */ var $1294c915d4f18790$var$AutoResizer = function AutoResizer(_ref) {
    var className = _ref.className, width = _ref.width, height = _ref.height, children = _ref.children, onResize = _ref.onResize;
    var disableWidth = typeof width === 'number';
    var disableHeight = typeof height === 'number';
    if (disableWidth && disableHeight) return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: className,
        style: {
            width: width,
            height: height,
            position: 'relative'
        }
    }, children({
        width: width,
        height: height
    }));
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hjdSp.default), {
        className: className,
        disableWidth: disableWidth,
        disableHeight: disableHeight,
        onResize: onResize
    }, function(size) {
        return children({
            width: disableWidth ? width : size.width,
            height: disableHeight ? height : size.height
        });
    });
};
$1294c915d4f18790$var$AutoResizer.propTypes = {
    /**
   * Class name for the component
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    /**
   * the width of the component, will be the container's width if not set
   */ width: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    /**
   * the height of the component, will be the container's width if not set
   */ height: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    /**
   * A callback function to render the children component
   * The handler is of the shape of `({ width, height }) => node`
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    /**
   * A callback function when the size of the table container changed if the width and height are not set
   * The handler is of the shape of `({ width, height }) => *`
   */ onResize: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
};
var $1294c915d4f18790$export$2e2bcd8739ae039 = $1294c915d4f18790$var$AutoResizer;

});
parcelRegister("hjdSp", function(module, exports) {

$parcel$export(module.exports, "default", () => $c99ef99767abfb0f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
/**
 * Detect Element Resize.
 * https://github.com/sdecima/javascript-detect-element-resize
 * Sebastian Decima
 *
 * Forked from version 0.5.3; includes the following modifications:
 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
 * 4) Add nonce for style element.
 **/ function $c99ef99767abfb0f$var$createDetectElementResize(nonce) {
    // Check `document` and `window` in case of server-side rendering
    var _window;
    if (typeof window !== 'undefined') _window = window;
    else if (typeof self !== 'undefined') _window = self;
    else _window = $parcel$global;
    var attachEvent = typeof document !== 'undefined' && document.attachEvent;
    if (!attachEvent) {
        var requestFrame = function() {
            var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function(fn) {
                return _window.setTimeout(fn, 20);
            };
            return function(fn) {
                return raf(fn);
            };
        }();
        var cancelFrame = function() {
            var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
            return function(id) {
                return cancel(id);
            };
        }();
        var resetTriggers = function resetTriggers(element) {
            var triggers = element.__resizeTriggers__, expand = triggers.firstElementChild, contract = triggers.lastElementChild, expandChild = expand.firstElementChild;
            contract.scrollLeft = contract.scrollWidth;
            contract.scrollTop = contract.scrollHeight;
            expandChild.style.width = expand.offsetWidth + 1 + 'px';
            expandChild.style.height = expand.offsetHeight + 1 + 'px';
            expand.scrollLeft = expand.scrollWidth;
            expand.scrollTop = expand.scrollHeight;
        };
        var checkTriggers = function checkTriggers(element) {
            return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
        };
        var scrollListener = function scrollListener(e) {
            // Don't measure (which forces) reflow for scrolls that happen inside of children!
            if (e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) return;
            var element = this;
            resetTriggers(this);
            if (this.__resizeRAF__) cancelFrame(this.__resizeRAF__);
            this.__resizeRAF__ = requestFrame(function() {
                if (checkTriggers(element)) {
                    element.__resizeLast__.width = element.offsetWidth;
                    element.__resizeLast__.height = element.offsetHeight;
                    element.__resizeListeners__.forEach(function(fn) {
                        fn.call(element, e);
                    });
                }
            });
        };
        /* Detect CSS Animations support to detect element display/re-attach */ var animation = false, keyframeprefix = '', animationstartevent = 'animationstart', domPrefixes = 'Webkit Moz O ms'.split(' '), startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '), pfx = '';
        var elm = document.createElement('fakeelement');
        if (elm.style.animationName !== undefined) animation = true;
        if (animation === false) {
            for(var i = 0; i < domPrefixes.length; i++)if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
                pfx = domPrefixes[i];
                keyframeprefix = '-' + pfx.toLowerCase() + '-';
                animationstartevent = startEvents[i];
                animation = true;
                break;
            }
        }
        var animationName = 'resizeanim';
        var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
        var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
    }
    var createStyles = function createStyles(doc) {
        if (!doc.getElementById('detectElementResize')) {
            //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
            var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }', head = doc.head || doc.getElementsByTagName('head')[0], style = doc.createElement('style');
            style.id = 'detectElementResize';
            style.type = 'text/css';
            if (nonce != null) style.setAttribute('nonce', nonce);
            if (style.styleSheet) style.styleSheet.cssText = css;
            else style.appendChild(doc.createTextNode(css));
            head.appendChild(style);
        }
    };
    var addResizeListener = function addResizeListener(element, fn) {
        if (attachEvent) element.attachEvent('onresize', fn);
        else {
            if (!element.__resizeTriggers__) {
                var doc = element.ownerDocument;
                var elementStyle = _window.getComputedStyle(element);
                if (elementStyle && elementStyle.position == 'static') element.style.position = 'relative';
                createStyles(doc);
                element.__resizeLast__ = {};
                element.__resizeListeners__ = [];
                (element.__resizeTriggers__ = doc.createElement('div')).className = 'resize-triggers';
                element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div><div class="contract-trigger"></div>';
                element.appendChild(element.__resizeTriggers__);
                resetTriggers(element);
                element.addEventListener('scroll', scrollListener, true);
                /* Listen for a css animation to detect element display/re-attach */ if (animationstartevent) {
                    element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
                        if (e.animationName == animationName) resetTriggers(element);
                    };
                    element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
                }
            }
            element.__resizeListeners__.push(fn);
        }
    };
    var removeResizeListener = function removeResizeListener(element, fn) {
        if (attachEvent) element.detachEvent('onresize', fn);
        else {
            element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
            if (!element.__resizeListeners__.length) {
                element.removeEventListener('scroll', scrollListener, true);
                if (element.__resizeTriggers__.__animationListener__) {
                    element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
                    element.__resizeTriggers__.__animationListener__ = null;
                }
                try {
                    element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
                } catch (e) {
                // Preact compat; see developit/preact-compat/issues/228
                }
            }
        }
    };
    return {
        addResizeListener: addResizeListener,
        removeResizeListener: removeResizeListener
    };
}
var $c99ef99767abfb0f$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $c99ef99767abfb0f$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $c99ef99767abfb0f$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $c99ef99767abfb0f$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $c99ef99767abfb0f$var$possibleConstructorReturn = function(self1, call) {
    if (!self1) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self1;
};
var $c99ef99767abfb0f$var$AutoSizer = function(_React$PureComponent) {
    $c99ef99767abfb0f$var$inherits(AutoSizer, _React$PureComponent);
    function AutoSizer() {
        var _ref;
        var _temp, _this, _ret;
        $c99ef99767abfb0f$var$classCallCheck(this, AutoSizer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $c99ef99767abfb0f$var$possibleConstructorReturn(this, (_ref = AutoSizer.__proto__ || Object.getPrototypeOf(AutoSizer)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            height: _this.props.defaultHeight || 0,
            width: _this.props.defaultWidth || 0
        }, _this._onResize = function() {
            var _this$props = _this.props, disableHeight = _this$props.disableHeight, disableWidth = _this$props.disableWidth, onResize = _this$props.onResize;
            if (_this._parentNode) {
                // Guard against AutoSizer component being removed from the DOM immediately after being added.
                // This can result in invalid style values which can result in NaN values if we don't handle them.
                // See issue #150 for more context.
                var _height = _this._parentNode.offsetHeight || 0;
                var _width = _this._parentNode.offsetWidth || 0;
                var _style = window.getComputedStyle(_this._parentNode) || {};
                var paddingLeft = parseInt(_style.paddingLeft, 10) || 0;
                var paddingRight = parseInt(_style.paddingRight, 10) || 0;
                var paddingTop = parseInt(_style.paddingTop, 10) || 0;
                var paddingBottom = parseInt(_style.paddingBottom, 10) || 0;
                var newHeight = _height - paddingTop - paddingBottom;
                var newWidth = _width - paddingLeft - paddingRight;
                if (!disableHeight && _this.state.height !== newHeight || !disableWidth && _this.state.width !== newWidth) {
                    _this.setState({
                        height: _height - paddingTop - paddingBottom,
                        width: _width - paddingLeft - paddingRight
                    });
                    onResize({
                        height: _height,
                        width: _width
                    });
                }
            }
        }, _this._setRef = function(autoSizer) {
            _this._autoSizer = autoSizer;
        }, _temp), $c99ef99767abfb0f$var$possibleConstructorReturn(_this, _ret);
    }
    $c99ef99767abfb0f$var$createClass(AutoSizer, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                var nonce = this.props.nonce;
                if (this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement) {
                    // Delay access of parentNode until mount.
                    // This handles edge-cases where the component has already been unmounted before its ref has been set,
                    // As well as libraries like react-lite which have a slightly different lifecycle.
                    this._parentNode = this._autoSizer.parentNode;
                    // Defer requiring resize handler in order to support server-side rendering.
                    // See issue #41
                    this._detectElementResize = $c99ef99767abfb0f$var$createDetectElementResize(nonce);
                    this._detectElementResize.addResizeListener(this._parentNode, this._onResize);
                    this._onResize();
                }
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                if (this._detectElementResize && this._parentNode) this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _props = this.props, children = _props.children, className = _props.className, disableHeight = _props.disableHeight, disableWidth = _props.disableWidth, style = _props.style;
                var _state = this.state, height = _state.height, width = _state.width;
                // Outer div should not force width/height since that may prevent containers from shrinking.
                // Inner component should overflow and use calculated width/height.
                // See issue #68 for more information.
                var outerStyle = {
                    overflow: 'visible'
                };
                var childParams = {};
                // Avoid rendering children before the initial measurements have been collected.
                // At best this would just be wasting cycles.
                var bailoutOnChildren = false;
                if (!disableHeight) {
                    if (height === 0) bailoutOnChildren = true;
                    outerStyle.height = 0;
                    childParams.height = height;
                }
                if (!disableWidth) {
                    if (width === 0) bailoutOnChildren = true;
                    outerStyle.width = 0;
                    childParams.width = width;
                }
                return (0, $eUqFw.createElement)('div', {
                    className: className,
                    ref: this._setRef,
                    style: $c99ef99767abfb0f$var$_extends({}, outerStyle, style)
                }, !bailoutOnChildren && children(childParams));
            }
        }
    ]);
    return AutoSizer;
}((0, $eUqFw.PureComponent));
$c99ef99767abfb0f$var$AutoSizer.defaultProps = {
    onResize: function onResize() {},
    disableHeight: false,
    disableWidth: false,
    style: {}
};
var $c99ef99767abfb0f$export$2e2bcd8739ae039 = $c99ef99767abfb0f$var$AutoSizer;

});



parcelRegister("7eqzD", function(module, exports) {

$parcel$export(module.exports, "ConditionalWrapper", () => $b3ad0a6f810bebd6$export$39aecc95f0365819);

var $eUqFw = parcelRequire("eUqFw");
const $b3ad0a6f810bebd6$export$39aecc95f0365819 = ({ condition: condition, renderWrapper: renderWrapper, children: children })=>condition ? renderWrapper(children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);

});

parcelRegister("8UvJe", function(module, exports) {

$parcel$export(module.exports, "useX2CNudgeStep", () => $96e8294f24734b15$export$add97e78ec6bfb0a);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

const $96e8294f24734b15$var$setNudgeStep = (nudgeStep)=>({ setState: setState })=>{
        setState({
            nudgeStep: nudgeStep
        });
    };
const $96e8294f24734b15$var$actions = {
    setNudgeStep: $96e8294f24734b15$var$setNudgeStep
};
const $96e8294f24734b15$var$Store = (0, $a61MH.createStore)({
    initialState: {
        nudgeStep: (0, $b8facdd16b032a29$export$26bb1007e6167496)
    },
    actions: $96e8294f24734b15$var$actions,
    name: 'X2COnboardingNudgeStepStore'
});
const $96e8294f24734b15$export$add97e78ec6bfb0a = (0, $ggKAj.createHook)($96e8294f24734b15$var$Store);

});

parcelRegister("43pn3", function(module, exports) {
module.exports = new URL("CannotReadFileError.cc72fcf2.svg", import.meta.url).toString();

});

parcelRegister("cTFYy", function(module, exports) {

$parcel$export(module.exports, "useGetPriorities", () => $b813f5d43c867f35$export$c92b17a678bb5430);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $gyZoj = parcelRequire("gyZoj");

var $kzTj7 = parcelRequire("kzTj7");

var $dvOIs = parcelRequire("dvOIs");
const $b813f5d43c867f35$export$55b80c1db6297f98 = {
    priorities: undefined
};
const $b813f5d43c867f35$export$489e9c0d7da0a5e2 = async ()=>{
    const { values: priorities } = await (0, $lRmyA.performGetRequest)(`${window.location.origin}/rest/api/3/priority/search`);
    return priorities;
};
const $b813f5d43c867f35$export$c92b17a678bb5430 = ()=>{
    const isCached = $b813f5d43c867f35$export$55b80c1db6297f98.priorities !== undefined;
    const initialState = {
        data: $b813f5d43c867f35$export$55b80c1db6297f98.priorities,
        isLoading: !isCached,
        error: null
    };
    const [{ data: data, isLoading: isLoading, error: error }, setState] = (0, $eUqFw.useState)(initialState);
    (0, $eUqFw.useEffect)(()=>{
        const fetchData = async ()=>{
            try {
                const priorities = await $b813f5d43c867f35$export$489e9c0d7da0a5e2();
                if (Array.isArray(priorities) && priorities.length > 0) {
                    const priorityMap = (0, $dvOIs.transformValue)(priorities);
                    $b813f5d43c867f35$export$55b80c1db6297f98.priorities = priorityMap;
                    setState({
                        data: priorityMap,
                        isLoading: false,
                        error: null
                    });
                } else setState({
                    data: undefined,
                    isLoading: false,
                    error: null
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                (0, $guiFP.default)({
                    meta: {
                        id: 'useGetPriorities',
                        packageName: (0, $kzTj7.APP_IDENTIFIER),
                        teamName: (0, $gyZoj.APP_TEAM_NAME)
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    data: undefined,
                    isLoading: false,
                    error: err
                });
            }
        };
        if (!isCached) fetchData();
    }, [
        isCached
    ]);
    return {
        data: data,
        isLoading: isLoading,
        error: error
    };
};

});
parcelRegister("dvOIs", function(module, exports) {

$parcel$export(module.exports, "transformValue", () => $72458a87109ba2c7$export$98c150630afe5417);
const $72458a87109ba2c7$export$98c150630afe5417 = (priorities)=>{
    const priorityMap = new Map();
    priorities.forEach((priority)=>priorityMap.set(priority.name, priority));
    return priorityMap;
};

});


parcelRegister("ji4el", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7b7601eaf24f82c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a7b7601eaf24f82c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    loading: {
        "id": "project-create-importer-upload-flow.mapping-screen.mapping-table.loading",
        "defaultMessage": "One moment while we get this ready..."
    },
    error: {
        "id": "project-create-importer-upload-flow.mapping-screen.mapping-table.error",
        "defaultMessage": "We're having some trouble with this file"
    },
    retry: {
        "id": "project-create-importer-upload-flow.mapping-screen.mapping-table.retry",
        "defaultMessage": "Try again"
    },
    preview: {
        "id": "project-create-importer-upload-flow.mapping-screen.mapping-table.preview",
        "defaultMessage": "Previewing first 30 tasks"
    }
});

});

parcelRegister("jrj5D", function(module, exports) {

$parcel$export(module.exports, "getTableColumns", () => $2cc616188d047190$export$a25a1ed7475cbf6d);
$parcel$export(module.exports, "getNewScrollLeftPosition", () => $2cc616188d047190$export$e447cd9e436493f8);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $agB2z = parcelRequire("agB2z");

var $5RnDx = parcelRequire("5RnDx");

var $33HKA = parcelRequire("33HKA");

var $dVF9y = parcelRequire("dVF9y");

var $i8FbN = parcelRequire("i8FbN");

var $hJ9U6 = parcelRequire("hJ9U6");

var $hzeeV = parcelRequire("hzeeV");

var $gDhJG = parcelRequire("gDhJG");
const $2cc616188d047190$export$7c3f559e2ca95fa = 200;
const $2cc616188d047190$var$getCellForRow = (key, priorities, value, fieldType)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(value)) return null;
    switch(fieldType){
        case 0, $agB2z.STATUS_FIELDTYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hzeeV.StatusCell), {
                key: key,
                value: value
            });
        case 0, $agB2z.NUMBER_FIELDTYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i8FbN.NumberCell), {
                key: key,
                value: value
            });
        case 0, $agB2z.PRIORITY_FIELDTYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJ9U6.default), {
                key: key,
                value: value,
                priorities: priorities
            });
        case 0, $agB2z.ASSIGNEE_FIELDTYPE:
        case 0, $agB2z.WATCHERS_FIELDTYPE:
        case 0, $agB2z.REPORTER_FIELDTYPE:
        case 0, $agB2z.CREATOR_FIELDTYPE:
        case 0, $agB2z.USERPICKER_FIELDTYPE:
        case 0, $agB2z.MULTI_USERPICKER_FIELDTYPE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5RnDx.AssigneeCell), {
                key: key,
                value: value
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gDhJG.TextCell), {
                key: key,
                value: value
            });
    }
};
const $2cc616188d047190$export$a25a1ed7475cbf6d = (mappingState, columnWidths, priorities)=>{
    if (mappingState === null) return [];
    return mappingState.columnOrder.map((name)=>mappingState.columns[name]).filter((col)=>col.isVisible).map((col, idx)=>({
            key: col.columnName,
            width: columnWidths[col.columnName] || $2cc616188d047190$export$7c3f559e2ca95fa,
            headerRenderer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $33HKA.ColumnHeader), {
                isFirstColumn: idx === 0,
                key: col.columnName,
                name: col.columnName,
                field: col.field
            }),
            cellRenderer: ({ rowData: rowData, rowIndex: rowIndex })=>{
                const key = `col-${col.columnName}-row-${rowIndex}`;
                if (rowIndex < 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dVF9y.ColumnNameCell), {
                    key: key,
                    value: col.columnName
                });
                return $2cc616188d047190$var$getCellForRow(key, priorities, rowData[col.columnName], col.field?.fieldType);
            },
            frozen: false,
            maxWidth: 640,
            minWidth: 120,
            resizable: true
        }));
};
const $2cc616188d047190$export$f4dc01b66fbd3bde = (mappingState, columnWidths, selectedColumn)=>{
    let targetLeftEdgePosition = 0;
    let targetRightEdgePosition = 0;
    for (const columnName of mappingState.columnOrder){
        if (columnName === selectedColumn) {
            targetRightEdgePosition = targetLeftEdgePosition + (columnWidths[columnName] || $2cc616188d047190$export$7c3f559e2ca95fa);
            break;
        }
        if (mappingState.columns[columnName].isVisible) targetLeftEdgePosition += columnWidths[columnName] || $2cc616188d047190$export$7c3f559e2ca95fa;
    }
    return {
        targetLeftEdgePosition: targetLeftEdgePosition,
        targetRightEdgePosition: targetRightEdgePosition
    };
};
const $2cc616188d047190$export$e447cd9e436493f8 = (mappingState, columnWidths, selectedColumn, tableRef)=>{
    const tableWidth = tableRef?.table?.props?.width || 0;
    const scrollLeftPosition = tableRef?.table?.bodyRef?.state?.scrollLeft || 0;
    const { targetLeftEdgePosition: targetLeftEdgePosition, targetRightEdgePosition: targetRightEdgePosition } = $2cc616188d047190$export$f4dc01b66fbd3bde(mappingState, columnWidths, selectedColumn);
    if (targetLeftEdgePosition < scrollLeftPosition) return targetLeftEdgePosition - tableWidth / 4;
    if (targetRightEdgePosition > scrollLeftPosition + tableWidth) return targetRightEdgePosition - tableWidth * 3 / 4;
    return undefined;
};

});
parcelRegister("5RnDx", function(module, exports) {

$parcel$export(module.exports, "AssigneeCell", () => $b98bb27610db7442$export$51e94d9eafa0b1f8);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iJlfe = parcelRequire("iJlfe");

var $8cU5f = parcelRequire("8cU5f");
const $b98bb27610db7442$export$51e94d9eafa0b1f8 = ({ value: value })=>{
    if (value === '') return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b98bb27610db7442$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: value,
        position: "bottom-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        size: "small",
        testId: "project-create-importer-upload-flow.ui.mapping-screen.mapping-table.assignee-cell.avatar"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b98bb27610db7442$var$ContentWrapper, null, value)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b98bb27610db7442$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _c7wx1q9c _hc7q15vq _njtz15vq _1xnh1l2s _p7r11txw _dzc21h6o",
            __cmplp.className
        ])
    });
});
const $b98bb27610db7442$var$ContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc",
            __cmplp.className
        ])
    });
});

});

parcelRegister("33HKA", function(module, exports) {

$parcel$export(module.exports, "ColumnHeader", () => $a1289e2cf718371b$export$5667c09b71ee0f05);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $hI5oG = parcelRequire("hI5oG");

var $gO9Xw = parcelRequire("gO9Xw");

var $gpZWO = parcelRequire("gpZWO");

var $86Ndv = parcelRequire("86Ndv");

var $dtaN9 = parcelRequire("dtaN9");

var $96IgR = parcelRequire("96IgR");

var $ffiyv = parcelRequire("ffiyv");

var $ltfxy = parcelRequire("ltfxy");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $8cU5f = parcelRequire("8cU5f");

var $7eqzD = parcelRequire("7eqzD");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8UvJe = parcelRequire("8UvJe");

var $6LyR2 = parcelRequire("6LyR2");

var $kzTj7 = parcelRequire("kzTj7");

var $agB2z = parcelRequire("agB2z");

var $eft4l = parcelRequire("eft4l");

var $aWLVm = parcelRequire("aWLVm");

var $hlez9 = parcelRequire("hlez9");

var $lUC5l = parcelRequire("lUC5l");

var $dxfzf = parcelRequire("dxfzf");

var $dDj95 = parcelRequire("dDj95");

var $gotW2 = parcelRequire("gotW2");

var $aPB1I = parcelRequire("aPB1I");
const $a1289e2cf718371b$var$CUSTOM_FIELD_INFO_LINK = 'https://confluence.atlassian.com/adminjiraserver/adding-custom-fields-1047552713.html';
const $a1289e2cf718371b$export$5667c09b71ee0f05 = ({ name: name, field: field, isFirstColumn: isFirstColumn })=>{
    const [mappingState, { setIsVisibleForColumn: setIsVisibleForColumn, setFieldForColumn: setFieldForColumn }] = (0, $lUC5l.useMappingState)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [searchTerm, setSearchTerm] = (0, $eUqFw.useState)('');
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const [isCustomFieldsMenuOpen, setIsCustomFieldsMenuOpen] = (0, $eUqFw.useState)(false);
    const columnHeaderButtonRef = (0, $eUqFw.useRef)();
    const { getValidationErrorMessage: getValidationErrorMessage } = (0, $aWLVm.useGetValidationErrorMessage)();
    const [{ nudgeStep: nudgeStep }] = (0, $8UvJe.useX2CNudgeStep)();
    const shouldShowDropdownSpotlight = isFirstColumn && nudgeStep === (0, $b8facdd16b032a29$export$af95284079b18767);
    (0, $eUqFw.useEffect)(()=>{
        if (mappingState?.selectedColumn === name) columnHeaderButtonRef.current?.focus();
    }, [
        mappingState?.selectedColumn,
        name
    ]);
    const updateColumnHeaderButtonRefAndForwardTriggerRef = (0, $eUqFw.useCallback)((triggerRef)=>(element)=>{
            columnHeaderButtonRef.current = element;
            typeof triggerRef === 'function' && triggerRef(element);
        }, []);
    const validationError = (0, $aPB1I.getValidationError)(mappingState, name);
    const getSetSystemFieldCallback = (0, $eUqFw.useCallback)((newField)=>()=>{
            setFieldForColumn(name, newField);
        }, [
        name,
        setFieldForColumn
    ]);
    const toggleMenuOpenState = (0, $eUqFw.useCallback)((attrs)=>{
        setIsOpen(attrs.isOpen);
        if (!attrs.isOpen) {
            // Reset search if menu closed
            setSearchTerm('');
            setIsCustomFieldsMenuOpen(false);
        }
    }, []);
    const getSetCustomFieldCallback = (0, $eUqFw.useCallback)((customFieldType)=>()=>{
            setFieldForColumn(name, {
                fieldName: name,
                // Default field name is the column name for new fields,
                fieldType: customFieldType
            });
        }, [
        name,
        setFieldForColumn
    ]);
    const removeFieldHandler = (0, $eUqFw.useCallback)(()=>{
        setIsVisibleForColumn(name, false);
    }, [
        name,
        setIsVisibleForColumn
    ]);
    const onSearchTermChange = (0, $eUqFw.useCallback)((e)=>setSearchTerm(e.target.value), []);
    const matchesSearchTerm = (0, $eUqFw.useCallback)((fieldToCheck)=>searchTerm === '' || fieldToCheck.fieldName.toLowerCase().includes(searchTerm.toLowerCase()), [
        searchTerm
    ]);
    const onLearnMoreClicked = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
        event.stopPropagation();
        window.open($a1289e2cf718371b$var$CUSTOM_FIELD_INFO_LINK, '_blank');
    }, []);
    const onLearnMoreKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Enter') onLearnMoreClicked(event);
    }, [
        onLearnMoreClicked
    ]);
    const onClickSelectCustomField = (0, $eUqFw.useCallback)((event)=>{
        event.stopPropagation();
        setIsCustomFieldsMenuOpen(true);
    }, []);
    const onClickGoBack = (0, $eUqFw.useCallback)((event)=>{
        event.stopPropagation();
        setIsCustomFieldsMenuOpen(false);
    }, []);
    const getSelectedCustomField = (0, $eUqFw.useCallback)(()=>{
        if (!field || field.fieldId) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gotW2.SelectedField), {
            icon: (0, $hlez9.getIcon)({
                fieldType: field.fieldType
            }),
            name: formatMessage((0, $hlez9.getDescriptorForNewFieldType)(field.fieldType))
        });
    }, [
        field,
        formatMessage
    ]);
    const createDropDownItems = (0, $eUqFw.useCallback)((availableFieldItems, filterCondition)=>mappingState ? availableFieldItems.filter(matchesSearchTerm).filter(filterCondition).map((fieldItem)=>{
            const isDisabled = !!fieldItem.fieldId && mappingState.mappedJiraFieldIds.has(fieldItem.fieldId);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
                key: `${fieldItem.fieldName}-${fieldItem.fieldType}`,
                onClick: getSetSystemFieldCallback(fieldItem),
                elemBefore: (0, $hlez9.getIcon)({
                    fieldType: fieldItem.fieldType,
                    isDisabled: isDisabled
                }),
                isDisabled: isDisabled,
                testId: `${(0, $kzTj7.COLUMN_HEADER_TEST_ID_PREFIX)}.dropdown-item.${fieldItem.fieldName}-${fieldItem.fieldType}`
            }, fieldItem.fieldName);
        }) : [], [
        matchesSearchTerm,
        mappingState,
        getSetSystemFieldCallback
    ]);
    const getExistingFieldsSection = (0, $eUqFw.useCallback)(()=>{
        const isIssueLinkFieldsAvailable = (0, $1ybV0.ff)('x2c-issuelinking-frontend_tuyzk');
        if (mappingState === null) return null;
        const availableJiraFieldItems = isIssueLinkFieldsAvailable ? createDropDownItems(mappingState.availableJiraFields, (fieldToCheck)=>!(!!field?.fieldId && fieldToCheck.fieldId === field.fieldId)) : mappingState.availableJiraFields.filter(matchesSearchTerm).sort((jiraField)=>!!field?.fieldId && jiraField.fieldId === field.fieldId ? -1 : 0).map((jiraField)=>{
            const isSelected = !!field?.fieldId && jiraField.fieldId === field.fieldId;
            const isDisabled = !!jiraField.fieldId && mappingState.mappedJiraFieldIds.has(jiraField.fieldId);
            return isSelected ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gotW2.SelectedField), {
                key: jiraField.fieldType,
                icon: (0, $hlez9.getIcon)({
                    fieldType: jiraField.fieldType
                }),
                name: jiraField.fieldName
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
                key: `${jiraField.fieldName}-${jiraField.fieldType}`,
                onClick: getSetSystemFieldCallback(jiraField),
                elemBefore: (0, $hlez9.getIcon)({
                    fieldType: jiraField.fieldType,
                    isDisabled: isDisabled
                }),
                isDisabled: isDisabled,
                testId: `${(0, $kzTj7.COLUMN_HEADER_TEST_ID_PREFIX)}.dropdown-item.${jiraField.fieldName}-${jiraField.fieldType}`
            }, jiraField.fieldName);
        });
        const availableIssueLinkFieldItems = isIssueLinkFieldsAvailable ? createDropDownItems(mappingState.availableIssueLinkFields, (fieldToCheck)=>!(!!field?.fieldName && fieldToCheck.fieldName === field.fieldName)) : [];
        const DropDownItems = isIssueLinkFieldsAvailable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a1289e2cf718371b$var$SearchBarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eft4l.SearchBar), {
            onSearchTermChange: onSearchTermChange
        })), field && field.fieldId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gotW2.SelectedField), {
            key: field.fieldType,
            icon: (0, $hlez9.getIcon)({
                fieldType: field.fieldType
            }),
            name: field.fieldName
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a1289e2cf718371b$var$SectionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a1289e2cf718371b$var$SectionHeader, {
            level: "h300",
            as: "h3"
        }, formatMessage((0, $dxfzf.default).existingFieldSectionHeading))), availableJiraFieldItems.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dDj95.NoFieldsAvailable), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, availableJiraFieldItems), mappingState.availableIssueLinkFields.length !== 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a1289e2cf718371b$var$SectionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a1289e2cf718371b$var$SectionHeader, {
            level: "h300",
            as: "h3"
        }, formatMessage((0, $dxfzf.default).issueLinksFieldSectionHeading))), mappingState.availableIssueLinkFields.length !== 0 && (availableIssueLinkFieldItems.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dDj95.NoFieldsAvailable), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, availableIssueLinkFieldItems))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a1289e2cf718371b$var$SectionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a1289e2cf718371b$var$SectionHeader, {
            level: "h300",
            as: "h3"
        }, formatMessage((0, $dxfzf.default).existingFieldSectionHeading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a1289e2cf718371b$var$SearchBarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eft4l.SearchBar), {
            onSearchTermChange: onSearchTermChange
        })), availableJiraFieldItems.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dDj95.NoFieldsAvailable), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, availableJiraFieldItems));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $a1289e2cf718371b$var$removeFieldWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
            onClick: removeFieldHandler,
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6LyR2.BlockerIcon), null),
            testId: `${(0, $kzTj7.COLUMN_HEADER_TEST_ID_PREFIX)}.remove-field`
        }, formatMessage((0, $dxfzf.default).removeField))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a1289e2cf718371b$var$SectionDivider, null), mappingState.availableNewFieldTypes.length !== 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
            testId: `${(0, $kzTj7.COLUMN_HEADER_TEST_ID_PREFIX)}.custom-field`,
            onClick: onClickSelectCustomField,
            elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))), {
                label: ""
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a1289e2cf718371b$var$SectionHeader, {
            level: "h300",
            as: "h3"
        }, formatMessage((0, $dxfzf.default).setNewFieldTypeHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a1289e2cf718371b$var$SectionDescription, null, formatMessage((0, $dxfzf.default).setNewFieldTypeDescription), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a1289e2cf718371b$var$LearnMoreLink, {
            "data-testId": `${(0, $kzTj7.COLUMN_HEADER_TEST_ID_PREFIX)}.learn-more-link`,
            onClick: onLearnMoreClicked,
            onKeyDown: onLearnMoreKeyDown,
            tabIndex: 0
        }, formatMessage((0, $dxfzf.default).learnMoreLink)))), getSelectedCustomField(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a1289e2cf718371b$var$SectionDivider, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), {
            testId: `${(0, $kzTj7.COLUMN_HEADER_TEST_ID_PREFIX)}.dropdown-item-group-existing-field`
        }, DropDownItems));
    }, [
        field,
        formatMessage,
        getSelectedCustomField,
        getSetSystemFieldCallback,
        mappingState,
        matchesSearchTerm,
        onClickSelectCustomField,
        onLearnMoreClicked,
        onLearnMoreKeyDown,
        onSearchTermChange,
        removeFieldHandler,
        createDropDownItems
    ]);
    const getCustomFieldsSection = (0, $eUqFw.useCallback)(()=>{
        if (mappingState === null) return null;
        const availableNewFieldItems = mappingState.availableNewFieldTypes.filter((fieldItem)=>(0, $agB2z.supportedCustomFieldTypes).has(fieldItem)).map((newFieldType)=>({
                fieldType: newFieldType,
                fieldName: formatMessage((0, $hlez9.getDescriptorForNewFieldType)(newFieldType))
            })).map((newField)=>{
            const isSelected = !!field && !field.fieldId && newField.fieldType === field.fieldType;
            return isSelected ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gotW2.SelectedField), {
                key: newField.fieldType,
                icon: (0, $hlez9.getIcon)({
                    fieldType: newField.fieldType
                }),
                name: formatMessage((0, $hlez9.getDescriptorForNewFieldType)(newField.fieldType))
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
                key: newField.fieldType,
                onClick: getSetCustomFieldCallback(newField.fieldType),
                elemBefore: (0, $hlez9.getIcon)({
                    fieldType: newField.fieldType
                }),
                testId: `${(0, $kzTj7.COLUMN_HEADER_TEST_ID_PREFIX)}.dropdown-item.${newField.fieldName}`
            }, newField.fieldName);
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), {
            testId: `${(0, $kzTj7.COLUMN_HEADER_TEST_ID_PREFIX)}.dropdown-item-group-custom-field`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a1289e2cf718371b$var$GoBackWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gpZWO))), {
                label: ""
            }),
            onClick: onClickGoBack,
            testId: `${(0, $kzTj7.COLUMN_HEADER_TEST_ID_PREFIX)}.go-back-wrapper`
        }, formatMessage((0, $dxfzf.default).goBack))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a1289e2cf718371b$var$SectionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a1289e2cf718371b$var$SectionHeader, {
            level: "h300",
            as: "h3"
        }, formatMessage((0, $dxfzf.default).selectCustomFieldHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a1289e2cf718371b$var$SectionDescription, null, formatMessage((0, $dxfzf.default).selectCustomFieldDescription))), availableNewFieldItems.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dDj95.NoFieldsAvailable), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, availableNewFieldItems));
    }, [
        field,
        formatMessage,
        getSetCustomFieldCallback,
        mappingState,
        onClickGoBack
    ]);
    const getEmptyFieldTrigger = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a1289e2cf718371b$var$EmptyFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))), {
            label: "",
            testId: `${(0, $kzTj7.COLUMN_HEADER_TEST_ID_PREFIX)}.add-icon`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, formatMessage((0, $dxfzf.default).mapToAField))), [
        formatMessage
    ]);
    const getFieldSelectedTrigger = (0, $eUqFw.useCallback)(({ fieldType: fieldType, fieldName: fieldName, fieldId: fieldId })=>{
        const hasValidationError = Boolean(validationError);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a1289e2cf718371b$var$ContentLeftWrapper, null, (0, $hlez9.getIcon)({
            fieldType: fieldType,
            hasValidationError: hasValidationError
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a1289e2cf718371b$var$Header, {
            as: "h3",
            level: "h500",
            hasValidationError: hasValidationError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: fieldName,
            position: "bottom-start",
            testId: `${(0, $kzTj7.COLUMN_HEADER_TEST_ID_PREFIX)}.trigger-tooltip`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, fieldName)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a1289e2cf718371b$var$ContentRightWrapper, null, !fieldId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
            appearance: "new",
            testId: `${(0, $kzTj7.COLUMN_HEADER_TEST_ID_PREFIX)}.lozenge-new`
        }, formatMessage((0, $dxfzf.default).newField)), validationError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: getValidationErrorMessage(validationError),
            testId: `${(0, $kzTj7.COLUMN_HEADER_TEST_ID_PREFIX)}.error-tooltip`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
            label: "",
            size: "medium",
            primaryColor: (0, $hlez9.ICON_COLOR_INVALID),
            testId: `${(0, $kzTj7.COLUMN_HEADER_TEST_ID_PREFIX)}.error-icon`
        }))));
    }, [
        formatMessage,
        getValidationErrorMessage,
        validationError
    ]);
    const dropdownTrigger = (0, $eUqFw.useCallback)(({ triggerRef: triggerRef, isSelected: isSelected, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a1289e2cf718371b$var$StyledButton, {
            ...props,
            iconAfter: field ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                label: "dropdown icon",
                size: "large"
            }) : undefined,
            ref: updateColumnHeaderButtonRefAndForwardTriggerRef(triggerRef),
            appearance: "subtle"
        }, field ? getFieldSelectedTrigger(field) : getEmptyFieldTrigger()), [
        field,
        getEmptyFieldTrigger,
        getFieldSelectedTrigger,
        updateColumnHeaderButtonRefAndForwardTriggerRef
    ]);
    const onKeyDownHandler = (0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Tab') event.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a1289e2cf718371b$var$Wrapper, {
        "data-testid": `${(0, $kzTj7.COLUMN_HEADER_TEST_ID_PREFIX)}.dropdown-menu`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        testId: `${(0, $kzTj7.COLUMN_HEADER_TEST_ID_PREFIX)}.dropdown-menu-${name}`,
        isOpen: isOpen || shouldShowDropdownSpotlight,
        onOpenChange: toggleMenuOpenState,
        shouldFlip: true,
        trigger: dropdownTrigger
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eqzD.ConditionalWrapper), {
        condition: shouldShowDropdownSpotlight,
        renderWrapper: (children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), {
                name: (0, $b8facdd16b032a29$export$af95284079b18767)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a1289e2cf718371b$var$SpotlightWrapper, null, children))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a1289e2cf718371b$var$DropdownItemWrapper, {
        onKeyDown: onKeyDownHandler
    }, isCustomFieldsMenuOpen ? getCustomFieldsSection() : getExistingFieldsSection()))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a1289e2cf718371b$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o _vchhusvi _o5721q9c _1bsb1osq _1ul9idpf _4t3i1osq _18iz1h6o _i1wwidpf _8ax3idpf _ake1idpf _1gqwidpf _11381osq _nb7jidpf _t74o1osq _1py6idpf _bt2c1txw",
            __cmplp.className
        ])
    });
});
const $a1289e2cf718371b$var$Header = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $hI5oG.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wybdlk8 _k48pni7l _vwz47vkz _18s8otz2 _1reo15vq _18m915vq _c7wx1q9c _hc7q15vq _njtz15vq _1xnh1l2s",
            __cmplp.hasValidationError ? "_syaze6sf" : "_syazj3m3",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a1289e2cf718371b$var$ContentLeftWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _2lx2vrvc _4cvr1h6o _1bah1y6m _18u0u2gc _1ul9idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a1289e2cf718371b$var$ContentRightWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlidpf _1o9zkb7n _i0dl1wug _2lx2vrvc _4cvr1h6o _k8em1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a1289e2cf718371b$var$SectionWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s81s3g",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a1289e2cf718371b$var$SectionHeader = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $hI5oG.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1p1dangw _1wyb1crf _vwz47vkz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a1289e2cf718371b$var$SectionDescription = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48p1nn1 _1wyb1skh _vwz4dlk8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a1289e2cf718371b$var$SectionDivider = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1b66 _bfhk1cs6 _2rkot94y _otyru2gc _19pku2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a1289e2cf718371b$var$DropdownItemWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_c71ldtre _1bsb1gwv",
            __cmplp.className
        ])
    });
});
const $a1289e2cf718371b$var$removeFieldWrapperStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.100',
    marginBottom: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a1289e2cf718371b$var$GoBackWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syazjwct",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a1289e2cf718371b$var$LearnMoreLink = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz11ce _9oik18uv _1bnx8stv _jf4cnqa1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a1289e2cf718371b$var$EmptyFieldWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _syaz11ce _k48pni7l _1wybw1gv _24rcu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a1289e2cf718371b$var$SpotlightWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
}); // this focus styling does not do anything but reconcile missing focus styles in AKButton possibly related to #hot-103234
const $a1289e2cf718371b$var$StyledButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bg4grf3",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a1289e2cf718371b$var$SearchBarWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4119w _4t3i1jfw _otyru2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gO9Xw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c3c90a7e02e55e7e$var$_react = $c3c90a7e02e55e7e$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $c3c90a7e02e55e7e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c3c90a7e02e55e7e$var$AddIcon = (props)=>/*#__PURE__*/ $c3c90a7e02e55e7e$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M13 11V3.993A.997.997 0 0012 3c-.556 0-1 .445-1 .993V11H3.993A.997.997 0 003 12c0 .557.445 1 .993 1H11v7.007c0 .548.448.993 1 .993.556 0 1-.445 1-.993V13h7.007A.997.997 0 0021 12c0-.556-.445-1-.993-1H13z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$c3c90a7e02e55e7e$var$AddIcon.displayName = 'AddIcon';
var $c3c90a7e02e55e7e$var$_default = $c3c90a7e02e55e7e$var$AddIcon;
module.exports.default = $c3c90a7e02e55e7e$var$_default;

});

parcelRegister("6LyR2", function(module, exports) {

$parcel$export(module.exports, "BlockerIcon", () => $346c54aacac31436$export$8e4c23f81e0a3c33);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");

var $PdmhA = parcelRequire("PdmhA");
// Custom icon since not supported by AK
const $346c54aacac31436$var$BlockerIconGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label']
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3ZM7 11L6.88338 11.0067C6.38604 11.0645 6 11.4872 6 12C6 12.5523 6.44772 13 7 13H17L17.1166 12.9933C17.614 12.9355 18 12.5128 18 12C18 11.4477 17.5523 11 17 11H7Z",
        fill: `var(--ds-icon-subtle, ${(0, $PdmhA).N700})`
    }));
const $346c54aacac31436$export$8e4c23f81e0a3c33 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $346c54aacac31436$var$BlockerIconGlyph,
        label: ""
    });

});

parcelRegister("dxfzf", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e39ecadec4a7602$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0e39ecadec4a7602$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    setNewFieldTypeHeading: {
        "id": "project-create-importer-upload-flow.mapping-screen.mapping-table.column-header.set-new-field-type-heading",
        "defaultMessage": "Create a new custom field"
    },
    setNewFieldTypeDescription: {
        "id": "project-create-importer-upload-flow.mapping-screen.mapping-table.column-header.set-new-field-type-description",
        "defaultMessage": "Add a field with information specific to your team's needs."
    },
    learnMoreLink: {
        "id": "project-create-importer-upload-flow.mapping-screen.mapping-table.column-header.learn-more-link",
        "defaultMessage": "Learn more about creating custom fields"
    },
    existingFieldSectionHeading: {
        "id": "project-create-importer-upload-flow.mapping-screen.mapping-table.column-header.existing-field-section-heading",
        "defaultMessage": "Map to an existing field"
    },
    issueLinksFieldSectionHeading: {
        "id": "project-create-importer-upload-flow.mapping-screen.mapping-table.column-header.issue-links-field-section-heading",
        "defaultMessage": "Link Issues"
    },
    goBack: {
        "id": "project-create-importer-upload-flow.mapping-screen.mapping-table.column-header.go-back",
        "defaultMessage": "Go back"
    },
    selectCustomFieldHeading: {
        "id": "project-create-importer-upload-flow.mapping-screen.mapping-table.column-header.select-custom-field-heading",
        "defaultMessage": "Select custom field"
    },
    selectCustomFieldDescription: {
        "id": "project-create-importer-upload-flow.mapping-screen.mapping-table.column-header.select-custom-field-description",
        "defaultMessage": "The type indicates how your custom field will display and function, as well as what values it can accept."
    },
    newField: {
        "id": "project-create-importer-upload-flow.mapping-screen.mapping-table.column-header.new-field",
        "defaultMessage": "New Field"
    },
    removeField: {
        "id": "project-create-importer-upload-flow.mapping-screen.mapping-table.column-header.remove-field",
        "defaultMessage": "Exclude column data from your import"
    },
    mapToAField: {
        "id": "project-create-importer-upload-flow.mapping-screen.mapping-table.column-header.map-to-a-field",
        "defaultMessage": "Map to a field"
    }
});

});

parcelRegister("dDj95", function(module, exports) {

$parcel$export(module.exports, "NoFieldsAvailable", () => $c872e4dae8f801f9$export$ef82f353cd97afa9);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kYOLp = parcelRequire("kYOLp");
const $c872e4dae8f801f9$export$ef82f353cd97afa9 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c872e4dae8f801f9$var$NoFieldsAvailableWrapper, null, formatMessage((0, $kYOLp.default).noFieldsAvailable));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c872e4dae8f801f9$var$NoFieldsAvailableWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1be1 _18u0v47k _2hwxpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kYOLp", function(module, exports) {

$parcel$export(module.exports, "default", () => $918db1ddceafae43$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $918db1ddceafae43$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noFieldsAvailable: {
        "id": "project-create-importer-upload-flow.mapping-screen.mapping-table.column-header.no-fields-available.no-fields-available",
        "defaultMessage": "No fields available..."
    }
});

});


parcelRegister("gotW2", function(module, exports) {

$parcel$export(module.exports, "SelectedField", () => $7a669b2940cf4ab0$export$ae74a03dc8785e75);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $9nt1B = parcelRequire("9nt1B");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kzTj7 = parcelRequire("kzTj7");

var $cQGgy = parcelRequire("cQGgy");
const $7a669b2940cf4ab0$export$ae74a03dc8785e75 = ({ icon: icon, name: name })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7a669b2940cf4ab0$var$Wrapper, {
        "data-testId": `${(0, $kzTj7.COLUMN_HEADER_TEST_ID_PREFIX)}.selected-field.wrapper`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7a669b2940cf4ab0$var$SelectedCustomFieldContent, null, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7a669b2940cf4ab0$var$SelectedIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nt1B))), {
        label: "",
        testId: `${(0, $kzTj7.COLUMN_HEADER_TEST_ID_PREFIX)}.selected-field.check-icon`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, formatMessage((0, $cQGgy.default).selected))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7a669b2940cf4ab0$var$SelectedIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _syaz11ce",
            __cmplp.className
        ])
    });
});
const $7a669b2940cf4ab0$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o _1bah1yb4 _1yt417l2 _bfhk1s4m",
            __cmplp.className
        ])
    });
});
const $7a669b2940cf4ab0$var$SelectedCustomFieldContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _80om73ad _24rcu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cQGgy", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cc948fa2d07b9ae$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2cc948fa2d07b9ae$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    selected: {
        "id": "project-create-importer-upload-flow.mapping-screen.mapping-table.column-header.selected-field.selected",
        "defaultMessage": "Selected"
    }
});

});


parcelRegister("aPB1I", function(module, exports) {

$parcel$export(module.exports, "getValidationError", () => $a636f757c12f477a$export$519bb523eb7aafa2);
const $a636f757c12f477a$export$519bb523eb7aafa2 = (mappingState, columnName)=>mappingState?.validationError?.columnErrors?.[columnName] || null;

});


parcelRegister("dVF9y", function(module, exports) {

$parcel$export(module.exports, "ColumnNameCell", () => $74811e3cbb181848$export$a599451efbf7cf);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8cU5f = parcelRequire("8cU5f");
const $74811e3cbb181848$export$a599451efbf7cf = ({ value: value })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($74811e3cbb181848$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: value,
        position: "bottom-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, value)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $74811e3cbb181848$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _c7wx1q9c _hc7q15vq _njtz15vq _1xnh1l2s _9p8eni7l",
            __cmplp.className
        ])
    });
});

});

parcelRegister("i8FbN", function(module, exports) {

$parcel$export(module.exports, "NumberCell", () => $05c3fa940c018333$export$da27302eef6199ea);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8cU5f = parcelRequire("8cU5f");
const $05c3fa940c018333$export$da27302eef6199ea = ({ value: value })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($05c3fa940c018333$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: value,
        position: "bottom-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-testId": "project-create-importer-upload-flow.ui.mapping-screen.mapping-table.number-cell.span"
    }, value)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $05c3fa940c018333$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1be1 _1reo15vq _18m915vq _c7wx1q9c _hc7q15vq _njtz15vq _1xnh1l2s",
            __cmplp.className
        ])
    });
});

});

parcelRegister("hJ9U6", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f176dfc929aa4f2$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8cU5f = parcelRequire("8cU5f");
const $8f176dfc929aa4f2$var$defaultIconUrl = `${window.location.origin}/images/icons/priorities/medium.svg`;
const $8f176dfc929aa4f2$export$b526cf238a0a0ab3 = ({ value: value, priorities: priorities })=>{
    if (value === '') return null;
    const priorityIconUrl = priorities?.get(value)?.iconUrl ?? $8f176dfc929aa4f2$var$defaultIconUrl;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8f176dfc929aa4f2$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: value,
        position: "bottom-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8f176dfc929aa4f2$var$ImageIcon, {
        src: priorityIconUrl,
        "data-testid": "project-create-importer-upload-flow.ui.mapping-screen.mapping-table.priority-cell.image-icon"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, value)));
};
$8f176dfc929aa4f2$export$b526cf238a0a0ab3.displayName = 'PriorityCell';
var $8f176dfc929aa4f2$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($8f176dfc929aa4f2$export$b526cf238a0a0ab3);
const $8f176dfc929aa4f2$var$iconSize = 22;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8f176dfc929aa4f2$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _dzc21h6o _p7r11txw _hiqrvrvc _10ca1q9c _17kn15vq _1hrp15vq _x3fa1l2s",
            __cmplp.className
        ])
    });
});
const $8f176dfc929aa4f2$var$ImageIcon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3iqslr _2hwxu2gc _1bsbqslr",
            __cmplp.className
        ])
    });
});

});

parcelRegister("hzeeV", function(module, exports) {

$parcel$export(module.exports, "StatusCell", () => $c3d5aac2c16b5e04$export$f71dcd7f3896fe01);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $ffiyv = parcelRequire("ffiyv");

var $8cU5f = parcelRequire("8cU5f");

var $lh8cM = parcelRequire("lh8cM");
const $c3d5aac2c16b5e04$export$f71dcd7f3896fe01 = ({ value: value })=>{
    if (value === '') return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c3d5aac2c16b5e04$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: value,
        position: "bottom-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: (0, $lh8cM.getCategory)(value),
        testId: "project-create-importer-upload-flow.ui.mapping-screen.mapping-table.status-cell.lozenge"
    }, value)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c3d5aac2c16b5e04$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _c7wx1q9c _hc7q15vq _njtz15vq _1xnh1l2s",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lh8cM", function(module, exports) {

$parcel$export(module.exports, "getCategory", () => $8092bc0f988fac15$export$410364bbb673ddbc);
const $8092bc0f988fac15$var$StatusNameToCategoryMap = {
    'to do': 'default',
    done: 'success'
};
const $8092bc0f988fac15$export$410364bbb673ddbc = (statusName)=>{
    const cleanStatusName = statusName.toLowerCase().trim();
    if (cleanStatusName in $8092bc0f988fac15$var$StatusNameToCategoryMap) return $8092bc0f988fac15$var$StatusNameToCategoryMap[cleanStatusName];
    return 'inprogress';
};

});


parcelRegister("gDhJG", function(module, exports) {

$parcel$export(module.exports, "TextCell", () => $bc4d89eb6442d3c1$export$765aced31cc89655);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8cU5f = parcelRequire("8cU5f");
const $bc4d89eb6442d3c1$export$765aced31cc89655 = ({ value: value })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bc4d89eb6442d3c1$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: value,
        position: "bottom-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-testid": "project-create-importer-upload-flow.ui.mapping-screen.mapping-table.text-cell.span"
    }, value)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bc4d89eb6442d3c1$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _c7wx1q9c _hc7q15vq _njtz15vq _1xnh1l2s",
            __cmplp.className
        ])
    });
});

});



parcelRegister("3Ucrz", function(module, exports) {

$parcel$export(module.exports, "UnmappedColumnsBanner", () => $91aac5ecda1c48ed$export$fa0a0481abaefe71);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $9nkwJ = parcelRequire("9nkwJ");

var $7u4fN = parcelRequire("7u4fN");

var $aWvIp = parcelRequire("aWvIp");

var $PdmhA = parcelRequire("PdmhA");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lUC5l = parcelRequire("lUC5l");

var $big9k = parcelRequire("big9k");
const $91aac5ecda1c48ed$var$SUCCESS_COLOR = `var(--ds-icon-accent-green, ${(0, $PdmhA).G400})`;
const $91aac5ecda1c48ed$export$fa0a0481abaefe71 = ({ hasValidationErrors: hasValidationErrors })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [numVisibleUnmappedColumns, { setNextSelectedUnmappedColumn: setNextSelectedUnmappedColumn }] = (0, $lUC5l.useNumVisibleUnmappedColumns)();
    const [mappingState] = (0, $lUC5l.useMappingState)();
    const onClick = (0, $eUqFw.useCallback)(()=>{
        setNextSelectedUnmappedColumn();
    }, [
        setNextSelectedUnmappedColumn
    ]);
    if (!mappingState || hasValidationErrors && numVisibleUnmappedColumns === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null);
    if (numVisibleUnmappedColumns === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($91aac5ecda1c48ed$var$CompletedWrapper, {
        "data-testid": "project-create-importer-upload-flow.ui.mapping-screen.unmapped-columns-banner.completed-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))), {
        primaryColor: $91aac5ecda1c48ed$var$SUCCESS_COLOR,
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, formatMessage((0, $big9k.default).allFieldsMapped)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($91aac5ecda1c48ed$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9nkwJ.default), {
        appearance: "primary"
    }, numVisibleUnmappedColumns), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, formatMessage((0, $big9k.default).unmappedColumns)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: onClick,
        appearance: "link"
    }, formatMessage((0, $big9k.default).goToNext)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $91aac5ecda1c48ed$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1n261g80 _1yt41r6r _2hwxu2gc _16qs1a05 _2rko1y44 _19it1l7n _24rcu2gc",
            __cmplp.className
        ])
    });
});
const $91aac5ecda1c48ed$var$CompletedWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1yt41q2z _2hwxu2gc _bfhkwqbp _1tkeor1b _vchhusvi _2rko1y44 _24rcu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9nkwJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $00d99ab26ca06411$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $aG4Mw = parcelRequire("aG4Mw");
function $00d99ab26ca06411$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $00d99ab26ca06411$var$boxStyles = (0, $1ZAYh.xcss)({
    borderRadius: 'border.radius.200',
    display: 'inline-flex',
    blockSize: 'min-content',
    flexShrink: 0 // Text component can wrap text, this ensures it doesn't wrap in flex containers.
});
/**
 * Visual refresh colors.
 * Hardcoded hex colors are used as the they should not change based on theme, and there are no appropriate color tokens.
 *
 * Using separate variables as opposed to an object, to comply with UI styling standard
 * https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-unsafe-values/usage#object-access
 */ const $00d99ab26ca06411$var$neutral300 = '#DDDEE1';
const $00d99ab26ca06411$var$red300 = '#FD9891';
const $00d99ab26ca06411$var$blue300 = '#8FB8F6';
const $00d99ab26ca06411$var$neutral1000 = '#292A2E';
const $00d99ab26ca06411$var$styles = {
    root: {
        name: "85bcg3",
        styles: "display:inline-flex;box-sizing:border-box;min-width:var(--ds-space-300, 24px);justify-content:center;flex-shrink:0;block-size:min-content;border-radius:var(--ds-border-radius-050, 2px);padding-inline:var(--ds-space-050, 4px)"
    },
    added: {
        name: "4x7cmh",
        styles: "background-color:var(--ds-background-success, #DCFFF1);color:var(--ds-text, #172B4D)"
    },
    default: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $00d99ab26ca06411$var$neutral300,
        color: $00d99ab26ca06411$var$neutral1000
    }),
    important: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $00d99ab26ca06411$var$red300,
        color: $00d99ab26ca06411$var$neutral1000
    }),
    primary: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $00d99ab26ca06411$var$blue300,
        color: $00d99ab26ca06411$var$neutral1000
    }),
    primaryInverted: {
        name: "1425qmy",
        styles: "background-color:var(--ds-surface, #FFFFFF);color:var(--ds-text-brand, #0C66E4)"
    },
    removed: {
        name: "10hiq01",
        styles: "background-color:var(--ds-background-danger, #FFECEB);color:var(--ds-text, #172B4D)"
    }
};
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ const $00d99ab26ca06411$var$Badge = /*#__PURE__*/ (0, $eUqFw.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
    if ((0, $XHGTv.getBooleanFF)('platform.design-system-team.component-visual-refresh_t8zbo')) return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        "data-testid": testId,
        css: [
            $00d99ab26ca06411$var$styles.root,
            $00d99ab26ca06411$var$styles[appearance]
        ],
        style: {
            background: style?.backgroundColor,
            color: style?.color
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        size: "small",
        align: "center",
        color: "inherit"
    }, typeof children === 'number' && max ? (0, $aG4Mw.formatValue)(children, max) : children));
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        testId: testId,
        as: "span",
        backgroundColor: $00d99ab26ca06411$var$backgroundColors[appearance],
        xcss: $00d99ab26ca06411$var$boxStyles,
        style: {
            background: style?.backgroundColor,
            color: style?.color
        },
        paddingInline: "space.075"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        size: "UNSAFE_small",
        align: "center",
        color: style?.color ? 'inherit' : $00d99ab26ca06411$var$textColors[appearance]
    }, typeof children === 'number' && max ? (0, $aG4Mw.formatValue)(children, max) : children));
});
$00d99ab26ca06411$var$Badge.displayName = 'Badge';
var $00d99ab26ca06411$export$2e2bcd8739ae039 = $00d99ab26ca06411$var$Badge;
const $00d99ab26ca06411$var$backgroundColors = {
    added: 'color.background.success',
    default: 'color.background.neutral',
    important: 'color.background.danger.bold',
    primary: 'color.background.brand.bold',
    primaryInverted: 'elevation.surface',
    removed: 'color.background.danger'
};
const $00d99ab26ca06411$var$textColors = {
    added: 'color.text.success',
    default: 'color.text',
    important: 'color.text.inverse',
    primary: 'color.text.inverse',
    primaryInverted: 'color.text.brand',
    removed: 'color.text.danger'
};

});
parcelRegister("aG4Mw", function(module, exports) {

$parcel$export(module.exports, "formatValue", () => $a8e5bba3d913fce3$export$7c4d25c0c3217d8c);
function $a8e5bba3d913fce3$var$getSafeValue(value = 0) {
    const numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $a8e5bba3d913fce3$export$7c4d25c0c3217d8c(value, max) {
    const safeValue = $a8e5bba3d913fce3$var$getSafeValue(value);
    const safeMax = $a8e5bba3d913fce3$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("big9k", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fe64b29aa3102a8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7fe64b29aa3102a8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    unmappedColumns: {
        "id": "project-create-importer-upload-flow.mapping-screen.unmapped-columns-banner.unmapped-columns",
        "defaultMessage": "Columns waiting to be mapped."
    },
    goToNext: {
        "id": "project-create-importer-upload-flow.mapping-screen.unmapped-columns-banner.go-to-next",
        "defaultMessage": "Highlight unmapped column"
    },
    allFieldsMapped: {
        "id": "project-create-importer-upload-flow.mapping-screen.unmapped-columns-banner.all-fields-mapped",
        "defaultMessage": "All fields are mapped, nice work!"
    }
});

});



parcelRegister("6ErCG", function(module, exports) {

$parcel$export(module.exports, "ProjectCreateScreen", () => $57f7d92dcdb539ea$export$8b82fd992c2da10e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $ldoFd = parcelRequire("ldoFd");

var $f222W = parcelRequire("f222W");

var $lzLxZ = parcelRequire("lzLxZ");
var $7jPhn = parcelRequire("7jPhn");
var $4LhB6 = parcelRequire("4LhB6");
var $jeetE = parcelRequire("jeetE");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $cf2Y4 = parcelRequire("cf2Y4");

var $1b2am = parcelRequire("1b2am");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2jdHI = parcelRequire("2jdHI");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $eIp1n = parcelRequire("eIp1n");
var $6WXNs = parcelRequire("6WXNs");

var $gd0Sp = parcelRequire("gd0Sp");

var $kzTj7 = parcelRequire("kzTj7");

var $3yuWi = parcelRequire("3yuWi");

var $9R4E5 = parcelRequire("9R4E5");

var $1VyqP = parcelRequire("1VyqP");

var $3EVB9 = parcelRequire("3EVB9");

var $elKPF = parcelRequire("elKPF");

var $1T7vu = parcelRequire("1T7vu");

var $cDLTA = parcelRequire("cDLTA");

var $bz2yd = parcelRequire("bz2yd");

var $d0wrd = parcelRequire("d0wrd");
var $irKna = parcelRequire("irKna");

var $2sRUp = parcelRequire("2sRUp");

var $1dxi7 = parcelRequire("1dxi7");

var $fiH3o = parcelRequire("fiH3o");

var $eSyeF = parcelRequire("eSyeF");

var $2ke01 = parcelRequire("2ke01");

var $4o2UL = parcelRequire("4o2UL");

var $b4upC = parcelRequire("b4upC");

var $kI9I9 = parcelRequire("kI9I9");

var $7JnAW = parcelRequire("7JnAW");

var $h0OrD = parcelRequire("h0OrD");

var $iR23m = parcelRequire("iR23m");

var $6llFq = parcelRequire("6llFq");
const $57f7d92dcdb539ea$export$33b17e5ac4c9437a = ({ onReturn: onReturn, onNext: onNext, hasProgressBar: hasProgressBar = false, shouldPrefillThirdPartyProjectName: shouldPrefillThirdPartyProjectName = false, shouldShowThirdPartyStats: shouldShowThirdPartyStats = false, thirdParty: thirdParty, shouldStartImportOnNext: shouldStartImportOnNext, isTMPSupported: isTMPSupported, onCloseAndReturnToUploadStep: onCloseAndReturnToUploadStep, templates: templates })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { isLoading: isLoadingProjectNameValidation, validateProjectName: validateProjectName } = (0, $4o2UL.useValidateProjectName)();
    const { isLoading: isLoadingProjectKeyValidation, validateProjectKey: validateProjectKey } = (0, $2ke01.useValidateProjectKey)();
    const { isLoading: isLoadingProjectKey, generateProjectKey: generateProjectKey } = (0, $eSyeF.useGenerateProjectKey)();
    const [projectData, { setProjectData: setProjectData }] = (0, $d0wrd.useProjectData)();
    const [{ selectedSpaceName: selectedSpaceName, selectedEntityName: selectedEntityName, selectedEntityStyle: selectedEntityStyle }] = (0, $irKna.useThirdPartyState)();
    let DEFAULT_PROJECT_NAME = '';
    if (shouldPrefillThirdPartyProjectName && selectedEntityName) {
        if (selectedSpaceName) DEFAULT_PROJECT_NAME = `${selectedSpaceName} - ${selectedEntityName}`;
        else DEFAULT_PROJECT_NAME = selectedEntityName;
    }
    const [projectName, setProjectName] = (0, $eUqFw.useState)(projectData.name || DEFAULT_PROJECT_NAME);
    const [projectKey, setProjectKey] = (0, $eUqFw.useState)(projectData.key || '');
    const [projectNameValidationError, setProjectNameValidationError] = (0, $eUqFw.useState)('');
    const [projectKeyValidationError, setProjectKeyValidationError] = (0, $eUqFw.useState)('');
    const [isSubmitting, setIsSubmitting] = (0, $eUqFw.useState)(false);
    const { productSteps: productSteps, currentStepIndex: currentStepIndex } = (0, $fiH3o.useProductSteps)();
    const { startImport: startImport, isImportLoading: isImportLoading, hasImportErrorOccurred: hasImportErrorOccurred, isStartImportDisabled: isStartImportDisabled } = (0, $1dxi7.useStartImportController)({
        thirdParty: thirdParty
    });
    const [source] = (0, $2sRUp.useSource)();
    const { projectCreateHeading: projectCreateHeading, projectCreateDescription: projectCreateDescription } = (0, $bz2yd.useProjectSpecificContent)(projectData.type, source);
    const { projectCreateHeading: thirdPartyProjectCreateHeading } = (0, $cDLTA.useContentForThirdParty)(thirdParty);
    const shouldDisableNext = !isSubmitting && (projectNameValidationError !== '' || projectKeyValidationError !== '' || isLoadingProjectNameValidation || isLoadingProjectKeyValidation || isLoadingProjectKey);
    const shouldDisableImport = isStartImportDisabled || shouldDisableNext;
    const { appEditions: appEditions } = (0, $gd0Sp.useTenantContext)();
    const isPermissionGated = (0, $eUqFw.useMemo)(()=>{
        if (isTMPSupported && projectData.type) {
            const application = (0, $eIp1n.getApplicationForProject)(projectData.type);
            const edition = (0, $6WXNs.getEdition)(application, appEditions);
            return (0, $1b2am.shouldApplyPermissionsGate)(application, edition);
        }
        return false;
    }, [
        appEditions,
        isTMPSupported,
        projectData.type
    ]);
    const DEFAULT_PROJECT_ACCESS = isPermissionGated ? (0, $99b47c2485002a11$export$1ec4bbf2f176ca6) : (0, $99b47c2485002a11$export$d9b46e2d865ef95c);
    (0, $eUqFw.useEffect)(()=>{
        if (!shouldPrefillThirdPartyProjectName || !projectName) return;
        validateProjectName(projectName).then((errorMessage)=>{
            if (errorMessage) {
                setProjectNameValidationError(errorMessage);
                return;
            }
            setProjectNameValidationError('');
            generateProjectKey(projectName).then((generatedProjectKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($f222W)))(generatedProjectKey)) {
                    setProjectKey(generatedProjectKey);
                    setProjectKeyValidationError('');
                    setProjectData({
                        name: projectName,
                        key: generatedProjectKey
                    });
                }
            });
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        generateProjectKey
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // once project access is set, no changes should be made
        if (typeof projectData.accessLevel !== 'undefined') return;
        if (isTMPSupported && selectedEntityStyle !== (0, $9R4E5.ProjectStyles).COMPANY_MANAGED_PROJECT) {
            setProjectData({
                style: (0, $9R4E5.ProjectStyles).TEAM_MANAGED_PROJECT,
                accessLevel: DEFAULT_PROJECT_ACCESS
            });
            return;
        }
        setProjectData({
            style: (0, $9R4E5.ProjectStyles).COMPANY_MANAGED_PROJECT,
            accessLevel: undefined
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const [handleProjectNameChange] = (0, $2jdHI.default)((newProjectName)=>{
        const valueLength = newProjectName.trim().length;
        if (valueLength === 0) {
            setProjectNameValidationError(formatMessage((0, $7JnAW.default).projectNameEmpty));
            return;
        }
        if (valueLength < (0, $9R4E5.PROJECT_NAME_START_LIMIT)) {
            setProjectNameValidationError(formatMessage((0, $7JnAW.default).projectNameTooShort));
            return;
        }
        if (valueLength > (0, $9R4E5.PROJECT_NAME_END_LIMIT)) {
            setProjectNameValidationError(formatMessage((0, $7JnAW.default).projectNameTooLong));
            return;
        }
        validateProjectName(newProjectName).then((errorMessage)=>{
            if (errorMessage) {
                setProjectNameValidationError(errorMessage);
                return;
            }
            setProjectNameValidationError('');
            generateProjectKey(newProjectName).then((generatedProjectKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($f222W)))(generatedProjectKey)) {
                    setProjectKey(generatedProjectKey);
                    setProjectKeyValidationError('');
                    setProjectData({
                        name: newProjectName,
                        key: generatedProjectKey
                    });
                }
            });
        });
    }, (0, $kzTj7.DEBOUNCE_DELAY));
    const onProjectNameChange = (0, $eUqFw.useCallback)((e)=>{
        setProjectName(e.target.value);
        setProjectNameValidationError('');
        handleProjectNameChange(e.target.value);
    }, [
        setProjectName,
        handleProjectNameChange,
        setProjectNameValidationError
    ]);
    const [handleProjectKeyChange] = (0, $2jdHI.default)((newProjectKey)=>{
        validateProjectKey(newProjectKey).then((errorMessage)=>{
            if (errorMessage) {
                setProjectKeyValidationError(errorMessage);
                return;
            }
            setProjectKeyValidationError('');
            setProjectData({
                key: newProjectKey
            });
        });
    }, (0, $kzTj7.DEBOUNCE_DELAY));
    const onProjectKeyChange = (0, $eUqFw.useCallback)((e)=>{
        const newKeyValue = e.target.value ? e.target.value.toUpperCase() : e.target.value;
        setProjectKey(newKeyValue);
        setProjectKeyValidationError('');
        handleProjectKeyChange(newKeyValue);
    }, [
        handleProjectKeyChange,
        setProjectKey,
        setProjectKeyValidationError
    ]);
    const onSubmit = (0, $eUqFw.useCallback)(async ()=>{
        // Not possible since users would have to have loaded mapping csv in the previous screen
        // and submit button is disabled in this case
        if (shouldStartImportOnNext && shouldDisableImport) return;
        setIsSubmitting(true);
        const projectNameError = await validateProjectName(projectName);
        if (projectNameError) {
            setIsSubmitting(false);
            setProjectNameValidationError(projectNameError);
            return;
        }
        const projectKeyError = await validateProjectKey(projectKey);
        if (projectKeyError) {
            setIsSubmitting(false);
            setProjectKeyValidationError(projectKeyError);
            return;
        }
        if (!shouldStartImportOnNext) {
            onNext();
            return;
        }
        startImport({
            projectData: projectData,
            onNext: onNext
        });
        setIsSubmitting(false);
    }, [
        shouldStartImportOnNext,
        shouldDisableImport,
        validateProjectName,
        projectName,
        validateProjectKey,
        projectKey,
        startImport,
        projectData,
        onNext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: (0, $3yuWi.X2C_SCREENS).SETUP_PROJECT,
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        attributes: {
            thirdParty: thirdParty
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($57f7d92dcdb539ea$var$Wrapper, {
        "data-testid": "project-create-importer-upload-flow.ui.project-create-screen.wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3EVB9.CloseAndReturnButton), {
        onCloseAndReturnToUploadStep: onCloseAndReturnToUploadStep
    }), hasProgressBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1T7vu.StepProgressBar), {
        productSteps: productSteps,
        currentStepIndex: currentStepIndex
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($57f7d92dcdb539ea$var$ContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($57f7d92dcdb539ea$var$CreateFormWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1VyqP.PageHeading), null, thirdPartyProjectCreateHeading || formatMessage(projectCreateHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1VyqP.PageDescription), null, formatMessage(projectCreateDescription, {
        br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null)
    }), (0, $1ybV0.ff)('jira-business-to-software-project-imports') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeetE.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lzLxZ.default), {
        onSubmit: onSubmit
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
            label: formatMessage((0, $7JnAW.default).projectName),
            name: "name",
            isRequired: true
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
                testId: "project-create-importer-upload-flow.ui.project-create-screen.project-name-field",
                ...fieldProps,
                value: projectName,
                onChange: onProjectNameChange,
                placeholder: formatMessage((0, $7JnAW.default).projectNamePlaceholder)
            }), projectNameValidationError !== '' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), {
                testId: "project-create-importer-upload-flow.ui.project-create-screen.project-name-error-message"
            }, projectNameValidationError))), templates.length !== 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6llFq.Templates), {
            templates: templates
        }), shouldShowThirdPartyStats && thirdParty && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iR23m.ProjectCreateStats), {
            thirdParty: thirdParty
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h0OrD.ProjectCreateMoreOptions), {
            projectKey: projectKey,
            onProjectKeyChange: onProjectKeyChange,
            projectKeyValidationError: projectKeyValidationError,
            isTMPSupported: isTMPSupported,
            isPermissionGated: isPermissionGated,
            defaultProjectAccess: DEFAULT_PROJECT_ACCESS,
            disableProjectStyle: !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(selectedEntityStyle)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($57f7d92dcdb539ea$var$FooterWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $elKPF.StepFooter), {
            onReturn: onReturn,
            shouldStartImportOnNext: shouldStartImportOnNext,
            isLoading: isImportLoading || isSubmitting,
            shouldDisableReturn: isImportLoading || isSubmitting,
            shouldDisableNext: shouldStartImportOnNext ? shouldDisableImport : shouldDisableNext,
            nextButtonType: "submit",
            hasImportErrorOccurred: hasImportErrorOccurred
        }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $57f7d92dcdb539ea$var$illustrationStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b4upC.Illustration), {
        projectType: projectData.type,
        projectName: projectName,
        projectKey: projectKey,
        isTmp: projectData.style === (0, $9R4E5.ProjectStyles).TEAM_MANAGED_PROJECT
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null)));
};
const $57f7d92dcdb539ea$export$8b82fd992c2da10e = (props)=>{
    if ((0, $eI5EY.fg)('enable-x2c-standardised-flow')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kI9I9.ProjectCreateScreenNew), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($57f7d92dcdb539ea$export$33b17e5ac4c9437a, props);
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $57f7d92dcdb539ea$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1n261q9c _4t3i1osq _1bsb1osq _vchhusvi _1yt41avh _bfhk1j9a _11381ns9",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $57f7d92dcdb539ea$var$ContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1n261q9c _1n261g80 _19pk1epz _1bah1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $57f7d92dcdb539ea$var$CreateFormWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1n261q9c _p12f1usy _2hwxoahv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $57f7d92dcdb539ea$var$FooterWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1n261q9c _4cvrh9n0",
            __cmplp.className
        ])
    });
});
const $57f7d92dcdb539ea$var$illustrationStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.600'
});

});
parcelRegister("f222W", function(module, exports) {
/**
 * Checks if `value` is `null`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
 * @example
 *
 * _.isNull(null);
 * // => true
 *
 * _.isNull(void 0);
 * // => false
 */ function $af18a14b43d56cd0$var$isNull(value) {
    return value === null;
}
module.exports = $af18a14b43d56cd0$var$isNull;

});

parcelRegister("1b2am", function(module, exports) {

$parcel$export(module.exports, "shouldApplyPermissionsGate", () => $2fa7d6fd2f61845f$export$6b07663b97ef9b4);

var $kkXdj = parcelRequire("kkXdj");

var $6rW04 = parcelRequire("6rW04");

var $6WXNs = parcelRequire("6WXNs");
var $eIp1n = parcelRequire("eIp1n");
const $2fa7d6fd2f61845f$export$6b07663b97ef9b4 = (application, edition)=>{
    const productPermissionGates = (0, $kkXdj.default)((0, $6rW04.default));
    let permissionGated;
    switch(application){
        case 0, $eIp1n.JIRA_SOFTWARE:
            permissionGated = productPermissionGates.software;
            break;
        case 0, $eIp1n.JIRA_PRODUCT_DISCOVERY:
            permissionGated = productPermissionGates.productDiscovery;
            break;
        case 0, $eIp1n.JIRA_SERVICE_DESK:
            permissionGated = productPermissionGates.serviceDesk;
            break;
        case 0, $eIp1n.JIRA_CORE:
            permissionGated = productPermissionGates.core;
            break;
        default:
            permissionGated = true;
            break;
    }
    return application === undefined || edition === undefined ? false : permissionGated && edition === (0, $6WXNs.FREE_EDITION);
};

});

const $99b47c2485002a11$export$d9b46e2d865ef95c = 'OPEN';
const $99b47c2485002a11$export$db9276cbaa3419e6 = 'LIMITED';
const $99b47c2485002a11$export$333699604c348681 = 'PRIVATE';
const $99b47c2485002a11$export$1ec4bbf2f176ca6 = 'FREE';

parcelRegister("eSyeF", function(module, exports) {

$parcel$export(module.exports, "useGenerateProjectKey", () => $a8034000c69496cf$export$4ce80135b61edab1);

var $eUqFw = parcelRequire("eUqFw");

var $gNbgN = parcelRequire("gNbgN");

var $guiFP = parcelRequire("guiFP");

var $gyZoj = parcelRequire("gyZoj");

var $kzTj7 = parcelRequire("kzTj7");
const $a8034000c69496cf$export$4ce80135b61edab1 = ()=>{
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [hasErrorOccurred, setHasErrorOccurred] = (0, $eUqFw.useState)(false);
    const generateProjectKey = (0, $eUqFw.useCallback)(async (projectName)=>{
        setIsLoading(true);
        setHasErrorOccurred(false);
        try {
            const { projectKey: projectKey } = await (0, $gNbgN.post)('', {
                name: projectName
            });
            setIsLoading(false);
            return projectKey;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'project-key-generation-error',
                    packageName: (0, $kzTj7.APP_IDENTIFIER),
                    teamName: (0, $gyZoj.APP_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true,
                error: error
            });
            setHasErrorOccurred(true);
            setIsLoading(false);
            return null;
        }
    }, []);
    return {
        isLoading: isLoading,
        hasErrorOccurred: hasErrorOccurred,
        generateProjectKey: generateProjectKey
    };
};

});
parcelRegister("gNbgN", function(module, exports) {

$parcel$export(module.exports, "post", () => $0cf446166dd94c15$export$299ba2dee77727e9);

var $lRmyA = parcelRequire("lRmyA");
const $0cf446166dd94c15$export$a5b7a8c3b1c6e775 = ()=>'/rest/simplified/latest/project/generateKey';
const $0cf446166dd94c15$export$299ba2dee77727e9 = (baseUrl, payload)=>{
    const url = $0cf446166dd94c15$export$a5b7a8c3b1c6e775();
    const options = {
        body: JSON.stringify(payload)
    };
    return (0, $lRmyA.performPostRequest)(url, options);
};

});


parcelRegister("2ke01", function(module, exports) {

$parcel$export(module.exports, "useValidateProjectKey", () => $857630441af56fd6$export$295a904270f596ea);

var $eUqFw = parcelRequire("eUqFw");

var $eahI0 = parcelRequire("eahI0");

var $guiFP = parcelRequire("guiFP");

var $gyZoj = parcelRequire("gyZoj");

var $kzTj7 = parcelRequire("kzTj7");
const $857630441af56fd6$export$295a904270f596ea = ()=>{
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [hasErrorOccurred, setHasErrorOccurred] = (0, $eUqFw.useState)(false);
    const validateProjectKey = (0, $eUqFw.useCallback)(async (projectKey)=>{
        setIsLoading(true);
        setHasErrorOccurred(false);
        try {
            const { errors: errors } = await (0, $eahI0.get)('', projectKey);
            setIsLoading(false);
            return errors?.projectKey;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'project-key-validation-error',
                    packageName: (0, $kzTj7.APP_IDENTIFIER),
                    teamName: (0, $gyZoj.APP_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true,
                error: error
            });
            setHasErrorOccurred(true);
            setIsLoading(false);
            return null;
        }
    }, []);
    return {
        isLoading: isLoading,
        hasErrorOccurred: hasErrorOccurred,
        validateProjectKey: validateProjectKey
    };
};

});
parcelRegister("eahI0", function(module, exports) {

$parcel$export(module.exports, "get", () => $e45f9e963fb56ffc$export$3988ae62b71be9a3);

var $lRmyA = parcelRequire("lRmyA");
const $e45f9e963fb56ffc$export$a5b7a8c3b1c6e775 = (baseUrl, projectKey)=>`/rest/simplified/latest/project/validate?projectKey=${encodeURIComponent(projectKey)}`;
const $e45f9e963fb56ffc$export$3988ae62b71be9a3 = (baseUrl, projectKey)=>{
    const url = $e45f9e963fb56ffc$export$a5b7a8c3b1c6e775(baseUrl, projectKey);
    return (0, $lRmyA.performGetRequest)(url);
};

});


parcelRegister("4o2UL", function(module, exports) {

$parcel$export(module.exports, "useValidateProjectName", () => $e2ecd12668c83b1c$export$435ac2290483e2e5);

var $eUqFw = parcelRequire("eUqFw");

var $46gQg = parcelRequire("46gQg");

var $guiFP = parcelRequire("guiFP");

var $gyZoj = parcelRequire("gyZoj");

var $kzTj7 = parcelRequire("kzTj7");
const $e2ecd12668c83b1c$export$435ac2290483e2e5 = ()=>{
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [hasErrorOccurred, setHasErrorOccurred] = (0, $eUqFw.useState)(false);
    const validateProjectName = (0, $eUqFw.useCallback)(async (projectName)=>{
        setIsLoading(true);
        setHasErrorOccurred(false);
        try {
            const { errors: errors } = await (0, $46gQg.get)('', projectName);
            setIsLoading(false);
            return errors?.projectName;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'project-name-validation-error',
                    packageName: (0, $kzTj7.APP_IDENTIFIER),
                    teamName: (0, $gyZoj.APP_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true,
                error: error
            });
            setHasErrorOccurred(true);
            setIsLoading(false);
            return null;
        }
    }, []);
    return {
        isLoading: isLoading,
        hasErrorOccurred: hasErrorOccurred,
        validateProjectName: validateProjectName
    };
};

});
parcelRegister("46gQg", function(module, exports) {

$parcel$export(module.exports, "constructEndpoint", () => $3960834d39b19d11$export$a5b7a8c3b1c6e775);
$parcel$export(module.exports, "get", () => $3960834d39b19d11$export$3988ae62b71be9a3);

var $lRmyA = parcelRequire("lRmyA");
const $3960834d39b19d11$export$a5b7a8c3b1c6e775 = (baseUrl, projectName)=>`/rest/simplified/latest/project/validate?projectName=${encodeURIComponent(projectName)}`;
const $3960834d39b19d11$export$3988ae62b71be9a3 = (baseUrl, projectKey)=>{
    const url = $3960834d39b19d11$export$a5b7a8c3b1c6e775(baseUrl, projectKey);
    return (0, $lRmyA.performGetRequest)(url);
};

});


parcelRegister("b4upC", function(module, exports) {

$parcel$export(module.exports, "Illustration", () => $12647c66bf104fb5$export$d43c2e2ca9b2c105);

var $eUqFw = parcelRequire("eUqFw");

var $9R4E5 = parcelRequire("9R4E5");

var $kalSW = parcelRequire("kalSW");

var $9klw6 = parcelRequire("9klw6");

var $fas7W = parcelRequire("fas7W");
const $12647c66bf104fb5$export$d43c2e2ca9b2c105 = ({ projectType: projectType, ...props })=>{
    switch(projectType){
        case (0, $9R4E5.ProjectTypes).BUSINESS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9klw6.Illustration), {
                ...props,
                teamManagedIllustrationFooter: (0, $fas7W.default).teamManagedIllustrationFooter,
                companyManagedIllustrationFooter: (0, $fas7W.default).companyManagedIllustrationFooter
            });
        case (0, $9R4E5.ProjectTypes).SOFTWARE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kalSW.IllustrationBoardView), {
                ...props,
                teamManagedIllustrationFooter: (0, $fas7W.default).teamManagedIllustrationFooter,
                companyManagedIllustrationFooter: (0, $fas7W.default).companyManagedIllustrationFooter
            });
        default:
            return null;
    }
};

});
parcelRegister("kalSW", function(module, exports) {

$parcel$export(module.exports, "IllustrationBoardView", () => $3ad66232376b3e6d$export$4c6f8b486bb13aa6);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5pW0k = parcelRequire("5pW0k");

var $dgvZS = parcelRequire("dgvZS");

var $8SMdk = parcelRequire("8SMdk");

var $8VwWb = parcelRequire("8VwWb");

var $wvKf6 = parcelRequire("wvKf6");


var $gKlyr = parcelRequire("gKlyr");
const $3ad66232376b3e6d$export$4c6f8b486bb13aa6 = ({ projectName: projectName, projectKey: projectKey, isTmp: isTmp, teamManagedIllustrationFooter: teamManagedIllustrationFooter, companyManagedIllustrationFooter: companyManagedIllustrationFooter })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dgvZS.IllustrationWrapper), {
        "data-testId": "project-create-importer-upload-flow.project-create-screen.illustration.jsw.wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5pW0k.IllustrationBlobBackground), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "664",
        height: "429",
        viewBox: "0 0 664 429",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "img",
        x: "12",
        y: "50",
        "aria-label": formatMessage((0, $gKlyr.default).illustrationLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        filter: "url(#filter0_dd_3207_1683)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "12",
        y: "4.12842",
        width: "640",
        height: "404",
        rx: "8",
        fill: "var(--ds-surface, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "212.448",
        y: "48",
        width: "36.3748",
        height: "12",
        rx: "6",
        fill: "var(--ds-background-accent-gray-subtler, #DFE1E6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "258.743",
        y: "48",
        width: "36.3748",
        height: "12",
        rx: "6",
        fill: "var(--ds-background-accent-gray-subtler, #DFE1E6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "312.479",
        y: "48",
        width: "47.9487",
        height: "12",
        rx: "6",
        fill: "var(--ds-background-accent-gray-subtler, #DFE1E6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "370.348",
        y: "48",
        width: "38.0282",
        height: "12",
        rx: "6",
        fill: "var(--ds-background-accent-gray-subtler, #DFE1E6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "212",
        y: "20",
        width: "119.872",
        height: "12",
        rx: "6",
        fill: "var(--ds-background-accent-gray-subtler, #DFE1E6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "133.333",
        height: "316",
        transform: "translate(212 77.0537)",
        fill: "var(--ds-surface-sunken, #F4F5F7)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "224",
        y: "87.0537",
        width: "60.3492",
        height: "12",
        rx: "6",
        fill: "var(--ds-background-accent-gray-subtler, #DFE1E6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        filter: "url(#filter1_dd_3207_1683)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "224",
        y: "107.054",
        width: "105",
        height: "50.2676",
        rx: "2.63378",
        fill: "var(--ds-surface-raised, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "232",
        y: "115.054",
        width: "87",
        height: "5",
        rx: "2.5",
        fill: "var(--ds-background-accent-gray-subtler, #EBECF0)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "232",
        y: "124.054",
        width: "61.8938",
        height: "5.26756",
        rx: "2.63378",
        fill: "var(--ds-background-accent-gray-subtler, #EBECF0)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8SMdk.IssueKeyText), {
        x: (0, $75a8388ef73e6ee9$export$81531bbc2788bcda),
        y: (0, $75a8388ef73e6ee9$export$4d7540aa85b4c3a0),
        projectKey: projectKey,
        issueNumber: 1,
        width: (0, $75a8388ef73e6ee9$export$4bc327aadbda777c)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        filter: "url(#filter2_dd_3207_1683)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "224",
        y: "165.321",
        width: "105",
        height: "50.2676",
        rx: "2.63378",
        fill: "var(--ds-surface-raised, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "232",
        y: "173.321",
        width: "87",
        height: "5",
        rx: "2.5",
        fill: "var(--ds-background-accent-gray-subtler, #EBECF0)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "232",
        y: "182.321",
        width: "61.8938",
        height: "5.26756",
        rx: "2.63378",
        fill: "var(--ds-background-accent-gray-subtler, #EBECF0)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8SMdk.IssueKeyText), {
        x: (0, $75a8388ef73e6ee9$export$81531bbc2788bcda),
        y: (0, $75a8388ef73e6ee9$export$303c9461df09b742),
        projectKey: projectKey,
        issueNumber: 2,
        width: (0, $75a8388ef73e6ee9$export$4bc327aadbda777c)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        filter: "url(#filter3_dd_3207_1683)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "224",
        y: "223.589",
        width: "105",
        height: "50.2676",
        rx: "2.63378",
        fill: "var(--ds-surface-raised, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "232",
        y: "231.589",
        width: "87",
        height: "5",
        rx: "2.5",
        fill: "var(--ds-background-accent-gray-subtler, #EBECF0)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "232",
        y: "240.589",
        width: "61.8938",
        height: "5.26756",
        rx: "2.63378",
        fill: "var(--ds-background-accent-gray-subtler, #EBECF0)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8SMdk.IssueKeyText), {
        x: (0, $75a8388ef73e6ee9$export$81531bbc2788bcda),
        y: (0, $75a8388ef73e6ee9$export$37ccd5eba46f39f0),
        projectKey: projectKey,
        issueNumber: 3,
        width: (0, $75a8388ef73e6ee9$export$4bc327aadbda777c)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        filter: "url(#filter4_dd_3207_1683)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "224",
        y: "281.856",
        width: "105",
        height: "50.2676",
        rx: "2.63378",
        fill: "var(--ds-surface-raised, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "232",
        y: "289.856",
        width: "87",
        height: "5",
        rx: "2.5",
        fill: "var(--ds-background-accent-gray-subtler, #EBECF0)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "232",
        y: "298.856",
        width: "61.8938",
        height: "5.26756",
        rx: "2.63378",
        fill: "var(--ds-background-accent-gray-subtler, #EBECF0)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8SMdk.IssueKeyText), {
        x: (0, $75a8388ef73e6ee9$export$81531bbc2788bcda),
        y: (0, $75a8388ef73e6ee9$export$657c04c2ef8cad98),
        projectKey: projectKey,
        issueNumber: 4,
        width: (0, $75a8388ef73e6ee9$export$4bc327aadbda777c)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "133.333",
        height: "316",
        transform: "translate(357.333 77.0537)",
        fill: "var(--ds-surface-sunken, #F4F5F7)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "369.333",
        y: "87.0537",
        width: "60.3492",
        height: "12",
        rx: "6",
        fill: "var(--ds-background-accent-gray-subtler, #DFE1E6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        filter: "url(#filter5_dd_3207_1683)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "369.333",
        y: "107.054",
        width: "105",
        height: "50.2676",
        rx: "2.63378",
        fill: "var(--ds-surface-raised, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "377.333",
        y: "115.054",
        width: "87",
        height: "5",
        rx: "2.5",
        fill: "var(--ds-background-accent-gray-subtler, #EBECF0)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "377.333",
        y: "124.054",
        width: "61.8938",
        height: "5.26756",
        rx: "2.63378",
        fill: "var(--ds-background-accent-gray-subtler, #EBECF0)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8SMdk.IssueKeyText), {
        x: (0, $75a8388ef73e6ee9$export$93ac4c38b1fe94bf),
        y: (0, $75a8388ef73e6ee9$export$4d7540aa85b4c3a0),
        projectKey: projectKey,
        issueNumber: 5,
        width: (0, $75a8388ef73e6ee9$export$4bc327aadbda777c)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        filter: "url(#filter6_dd_3207_1683)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "369.333",
        y: "165.321",
        width: "105",
        height: "50.2676",
        rx: "2.63378",
        fill: "var(--ds-surface-raised, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "377.333",
        y: "173.321",
        width: "87",
        height: "5",
        rx: "2.5",
        fill: "var(--ds-background-accent-gray-subtler, #EBECF0)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "377.333",
        y: "182.321",
        width: "61.8938",
        height: "5.26756",
        rx: "2.63378",
        fill: "var(--ds-background-accent-gray-subtler, #EBECF0)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8SMdk.IssueKeyText), {
        x: (0, $75a8388ef73e6ee9$export$93ac4c38b1fe94bf),
        y: (0, $75a8388ef73e6ee9$export$303c9461df09b742),
        projectKey: projectKey,
        issueNumber: 6,
        width: (0, $75a8388ef73e6ee9$export$4bc327aadbda777c)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "133.333",
        height: "316",
        transform: "translate(502.667 77.0537)",
        fill: "var(--ds-surface-sunken, #F4F5F7)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "514.667",
        y: "87.0537",
        width: "60.3492",
        height: "12",
        rx: "6",
        fill: "var(--ds-background-accent-gray-subtler, #DFE1E6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        filter: "url(#filter7_dd_3207_1683)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "514.667",
        y: "107.054",
        width: "105",
        height: "50.2676",
        rx: "2.63378",
        fill: "var(--ds-surface-raised, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "522.667",
        y: "115.054",
        width: "87",
        height: "5",
        rx: "2.5",
        fill: "var(--ds-background-accent-gray-subtler, #EBECF0)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "522.667",
        y: "124.054",
        width: "61.8938",
        height: "5.26756",
        rx: "2.63378",
        fill: "var(--ds-background-accent-gray-subtler, #EBECF0)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8SMdk.IssueKeyText), {
        x: (0, $75a8388ef73e6ee9$export$e6b84348472e1d3b),
        y: (0, $75a8388ef73e6ee9$export$4d7540aa85b4c3a0),
        projectKey: projectKey,
        issueNumber: 7,
        width: (0, $75a8388ef73e6ee9$export$4bc327aadbda777c)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        filter: "url(#filter8_dd_3207_1683)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "514.667",
        y: "165.321",
        width: "105",
        height: "50.2676",
        rx: "2.63378",
        fill: "var(--ds-surface-raised, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "522.667",
        y: "173.321",
        width: "87",
        height: "5",
        rx: "2.5",
        fill: "var(--ds-background-accent-gray-subtler, #EBECF0)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "522.667",
        y: "182.321",
        width: "61.8938",
        height: "5.26756",
        rx: "2.63378",
        fill: "var(--ds-background-accent-gray-subtler, #EBECF0)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8SMdk.IssueKeyText), {
        x: (0, $75a8388ef73e6ee9$export$e6b84348472e1d3b),
        y: (0, $75a8388ef73e6ee9$export$303c9461df09b742),
        projectKey: projectKey,
        issueNumber: 8,
        width: (0, $75a8388ef73e6ee9$export$4bc327aadbda777c)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        filter: "url(#filter9_dd_3207_1683)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "514.667",
        y: "223.589",
        width: "105",
        height: "50.2676",
        rx: "2.63378",
        fill: "var(--ds-surface-raised, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "522.667",
        y: "231.589",
        width: "87",
        height: "5",
        rx: "2.5",
        fill: "var(--ds-background-accent-gray-subtler, #EBECF0)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "522.667",
        y: "240.589",
        width: "61.8938",
        height: "5.26756",
        rx: "2.63378",
        fill: "var(--ds-background-accent-gray-subtler, #EBECF0)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8SMdk.IssueKeyText), {
        x: (0, $75a8388ef73e6ee9$export$e6b84348472e1d3b),
        y: (0, $75a8388ef73e6ee9$export$37ccd5eba46f39f0),
        projectKey: projectKey,
        issueNumber: 9,
        width: (0, $75a8388ef73e6ee9$export$4bc327aadbda777c)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12 11.4403C12 7.33113 15.3311 4 19.4403 4H196V408H19.4403C15.3311 408 12 404.669 12 400.56V11.4403Z",
        fill: "var(--ds-surface-sunken, #F4F5F7)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "28",
        y: "20",
        width: "19.8408",
        height: "19.8408",
        rx: "4.96021",
        fill: "var(--ds-icon-accent-blue, #2684FF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8VwWb.ProjectNameText), {
        x: 57,
        y: 19
    }, projectName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "28",
        y: "55.8408",
        width: "152",
        height: "12",
        rx: "6",
        fill: "var(--ds-background-accent-gray-subtler, #DFE1E6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "28",
        y: "83.8408",
        width: "152",
        height: "12",
        rx: "6",
        fill: "var(--ds-background-accent-gray-subtler, #DFE1E6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "28",
        y: "111.841",
        width: "152",
        height: "12",
        rx: "6",
        fill: "var(--ds-background-accent-gray-subtler, #DFE1E6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $wvKf6.ProjectStyleText), {
        x: 103,
        y: 388
    }, isTmp ? formatMessage(teamManagedIllustrationFooter) : formatMessage(companyManagedIllustrationFooter)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "12.5",
        y: "4.62842",
        width: "639",
        height: "403",
        rx: "7.5",
        stroke: "var(--ds-border, #F4F5F7)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
        id: "filter0_dd_3207_1683",
        x: "0",
        y: "0",
        width: "664",
        height: "428.128",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_3207_1683"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", {
        dy: "8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.15 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_3207_1683",
        result: "effect2_dropShadow_3207_1683"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_3207_1683",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
        id: "filter1_dd_3207_1683",
        x: "217.416",
        y: "104.42",
        width: "118.169",
        height: "63.4365",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.658444"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_3207_1683"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", {
        dy: "3.95067"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "3.29222"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.2 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_3207_1683",
        result: "effect2_dropShadow_3207_1683"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_3207_1683",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
        id: "filter2_dd_3207_1683",
        x: "217.416",
        y: "162.688",
        width: "118.169",
        height: "63.4365",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.658444"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_3207_1683"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", {
        dy: "3.95067"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "3.29222"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.2 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_3207_1683",
        result: "effect2_dropShadow_3207_1683"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_3207_1683",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
        id: "filter3_dd_3207_1683",
        x: "217.416",
        y: "220.955",
        width: "118.169",
        height: "63.4365",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.658444"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_3207_1683"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", {
        dy: "3.95067"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "3.29222"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.2 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_3207_1683",
        result: "effect2_dropShadow_3207_1683"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_3207_1683",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
        id: "filter4_dd_3207_1683",
        x: "217.416",
        y: "279.223",
        width: "118.169",
        height: "63.4365",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.658444"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_3207_1683"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", {
        dy: "3.95067"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "3.29222"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.2 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_3207_1683",
        result: "effect2_dropShadow_3207_1683"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_3207_1683",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
        id: "filter5_dd_3207_1683",
        x: "362.749",
        y: "104.42",
        width: "118.169",
        height: "63.4365",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.658444"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_3207_1683"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", {
        dy: "3.95067"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "3.29222"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.2 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_3207_1683",
        result: "effect2_dropShadow_3207_1683"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_3207_1683",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
        id: "filter6_dd_3207_1683",
        x: "362.749",
        y: "162.688",
        width: "118.169",
        height: "63.4365",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.658444"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_3207_1683"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", {
        dy: "3.95067"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "3.29222"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.2 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_3207_1683",
        result: "effect2_dropShadow_3207_1683"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_3207_1683",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
        id: "filter7_dd_3207_1683",
        x: "508.082",
        y: "104.42",
        width: "118.169",
        height: "63.4365",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.658444"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_3207_1683"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", {
        dy: "3.95067"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "3.29222"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.2 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_3207_1683",
        result: "effect2_dropShadow_3207_1683"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_3207_1683",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
        id: "filter8_dd_3207_1683",
        x: "508.082",
        y: "162.688",
        width: "118.169",
        height: "63.4365",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.658444"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_3207_1683"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", {
        dy: "3.95067"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "3.29222"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.2 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_3207_1683",
        result: "effect2_dropShadow_3207_1683"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_3207_1683",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
        id: "filter9_dd_3207_1683",
        x: "508.082",
        y: "220.955",
        width: "118.169",
        height: "63.4365",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.658444"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_3207_1683"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", {
        dy: "3.95067"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "3.29222"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.2 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_3207_1683",
        result: "effect2_dropShadow_3207_1683"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_3207_1683",
        result: "shape"
    }))))));
};

});
parcelRegister("5pW0k", function(module, exports) {

$parcel$export(module.exports, "IllustrationBlobBackground", () => $e29f23b1203a0c81$export$f779b7ceb8a1f1b1);

var $eUqFw = parcelRequire("eUqFw");
const $e29f23b1203a0c81$export$f779b7ceb8a1f1b1 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "720",
        height: "586",
        viewBox: "0 0 720 586",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "img"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M370.025 17.9079C434.256 22.6735 503.767 7.79394 556.943 40.6745C610.66 73.8893 624.33 136.807 649.809 190.907C678.228 251.252 739.504 312.537 713.872 373.89C688.153 435.452 591.852 436.828 531.607 473.835C474.196 509.102 439.255 580.301 370.025 585.109C300.167 589.961 241.321 540.007 189.315 497.609C141.938 458.986 117.437 406.978 88.5028 355.603C53.1707 292.869 -12.2428 234.212 1.99552 165.015C16.473 94.6556 86.9077 40.1425 159.374 11.1767C225.234 -15.1486 298.243 12.582 370.025 17.9079Z",
        fill: "var(--ds-icon-accent-blue, #2684FF)"
    }), children);

});

parcelRegister("dgvZS", function(module, exports) {

$parcel$export(module.exports, "IllustrationWrapper", () => $f0ddf7c6e605c794$export$315110e622e1743a);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $f0ddf7c6e605c794$export$315110e622e1743a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1kdj",
            __cmplp.className
        ])
    });
});

});

parcelRegister("8SMdk", function(module, exports) {

$parcel$export(module.exports, "IssueKeyText", () => $6115e1fd51b9b746$export$a7cc76c096dd3bac);
$parcel$export(module.exports, "createProjectKeyText", () => (parcelRequire("isBpJ")).createProjectKeyText);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $1ZhgW = parcelRequire("1ZhgW");


var $isBpJ = parcelRequire("isBpJ");
const $6115e1fd51b9b746$export$a7cc76c096dd3bac = ({ x: x, y: y, projectKey: projectKey, issueNumber: issueNumber, width: width })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ZhgW.TruncatedContentWrapper), {
        width: width,
        height: (0, $480553399c58770a$export$35234be61fe89835),
        x: `${x}`,
        y: `${y}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6115e1fd51b9b746$var$TruncatedIssueKeyInner, {
        width: width,
        height: (0, $480553399c58770a$export$35234be61fe89835)
    }, (0, $isBpJ.createProjectKeyText)(projectKey, issueNumber)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6115e1fd51b9b746$var$TruncatedIssueKeyInner = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $1ZhgW.TruncatedContentInner), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wybdlk8 _syaz1o15",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1ZhgW", function(module, exports) {

$parcel$export(module.exports, "TruncatedContentWrapper", () => $f55b77ba63504258$export$3e10296aeaa401db);
$parcel$export(module.exports, "TruncatedContentInner", () => $f55b77ba63504258$export$9399514b59832da7);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $f55b77ba63504258$export$3e10296aeaa401db = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "foreignObject", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_6f8077": (0, $9t7rW.default)(`${__cmplp.width}px`),
            "--_1neqek2": (0, $9t7rW.default)(`${__cmplp.height}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1hdq _4t3i2nrh",
            __cmplp.className
        ])
    });
});
const $f55b77ba63504258$export$9399514b59832da7 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_6f8077": (0, $9t7rW.default)(`${__cmplp.width}px`),
            "--_1neqek2": (0, $9t7rW.default)(`${__cmplp.height}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1hdq _4t3i2nrh _o5721q9c _1reo15vq _18m915vq _1bto1l2s",
            __cmplp.className
        ])
    });
});

});

const $480553399c58770a$export$35234be61fe89835 = 16.5;

parcelRegister("isBpJ", function(module, exports) {

$parcel$export(module.exports, "createProjectKeyText", () => $543bedf7a519cc4d$export$8eec09088030f721);
$parcel$export(module.exports, "truncateText", () => $543bedf7a519cc4d$export$59a943b34a82e690);
$parcel$export(module.exports, "transformProjectKeyText", () => $543bedf7a519cc4d$export$a4d8043c2fa7fd3e);
const $543bedf7a519cc4d$export$8eec09088030f721 = (projectKey, issueNumber)=>`${projectKey || 'KEY'}-${issueNumber}`;
const $543bedf7a519cc4d$export$59a943b34a82e690 = (text, length)=>text.length > length ? `${text.substring(0, length - 1)}...` : text;
const $543bedf7a519cc4d$export$a4d8043c2fa7fd3e = (projectKey, issueNumber)=>$543bedf7a519cc4d$export$59a943b34a82e690($543bedf7a519cc4d$export$8eec09088030f721(projectKey, issueNumber), 6);

});


parcelRegister("8VwWb", function(module, exports) {

$parcel$export(module.exports, "ProjectNameText", () => $6aac003b03ac3881$export$5a6718f5073ae56c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $1ZhgW = parcelRequire("1ZhgW");

const $6aac003b03ac3881$export$5a6718f5073ae56c = ({ x: x, y: y, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ZhgW.TruncatedContentWrapper), {
        width: (0, $0b74d46e7404e5a3$export$cf962e7ea0a87fae),
        height: (0, $0b74d46e7404e5a3$export$35234be61fe89835),
        x: `${x}`,
        y: `${y}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6aac003b03ac3881$var$TruncatedProjectNameInner, {
        width: (0, $0b74d46e7404e5a3$export$cf962e7ea0a87fae),
        height: (0, $0b74d46e7404e5a3$export$35234be61fe89835)
    }, children));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6aac003b03ac3881$var$TruncatedProjectNameInner = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $1ZhgW.TruncatedContentInner), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wybdlk8 _k48p1fw0",
            __cmplp.className
        ])
    });
});

});
const $0b74d46e7404e5a3$export$cf962e7ea0a87fae = 122;
const $0b74d46e7404e5a3$export$35234be61fe89835 = 18;


parcelRegister("wvKf6", function(module, exports) {

$parcel$export(module.exports, "ProjectStyleText", () => $c04e980230294c8f$export$19b2ffe7842cbd79);

var $eUqFw = parcelRequire("eUqFw");
const $c04e980230294c8f$export$19b2ffe7842cbd79 = ({ x: x, y: y, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fontSize: "12",
        x: `${x}`,
        y: `${y}`,
        textAnchor: "middle",
        fill: "var(--ds-text-subtlest, #6B778C)"
    }, children);

});

const $75a8388ef73e6ee9$export$81531bbc2788bcda = 232;
const $75a8388ef73e6ee9$export$93ac4c38b1fe94bf = 378;
const $75a8388ef73e6ee9$export$e6b84348472e1d3b = 524;
const $75a8388ef73e6ee9$export$4d7540aa85b4c3a0 = 134;
const $75a8388ef73e6ee9$export$303c9461df09b742 = 192;
const $75a8388ef73e6ee9$export$37ccd5eba46f39f0 = 250;
const $75a8388ef73e6ee9$export$657c04c2ef8cad98 = 309;
const $75a8388ef73e6ee9$export$4bc327aadbda777c = 90;

parcelRegister("gKlyr", function(module, exports) {

$parcel$export(module.exports, "default", () => $43263db54393bbb5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $43263db54393bbb5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    illustrationLabel: {
        "id": "project-create-importer-upload-flow.project-create-screen.illustration.jsw.illustration-label",
        "defaultMessage": "Illustration showing preview of Jira project interface after the project creation is done"
    }
});

});


parcelRegister("9klw6", function(module, exports) {

$parcel$export(module.exports, "Illustration", () => $f0ceed2546a5bb5b$export$d43c2e2ca9b2c105);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dgvZS = parcelRequire("dgvZS");

var $8VwWb = parcelRequire("8VwWb");

var $lGPBR = parcelRequire("lGPBR");

var $6J4HP = parcelRequire("6J4HP");
const $f0ceed2546a5bb5b$export$d43c2e2ca9b2c105 = ({ projectName: projectName, projectKey: projectKey, isTmp: isTmp, teamManagedIllustrationFooter: teamManagedIllustrationFooter, companyManagedIllustrationFooter: companyManagedIllustrationFooter })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dgvZS.IllustrationWrapper), {
        "data-testId": "project-create-importer-upload-flow.project-create-screen.illustration.jwm.wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "720",
        height: "586",
        viewBox: "0 0 720 586",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "img",
        "aria-label": formatMessage((0, $lGPBR.default).illustrationLabelSpork)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("title", null, formatMessage((0, $lGPBR.default).illustrationLabelSpork)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M370.025 17.9079C434.256 22.6735 503.767 7.79394 556.943 40.6745C610.66 73.8893 624.33 136.807 649.809 190.907C678.228 251.252 739.504 312.537 713.872 373.89C688.153 435.452 591.852 436.828 531.607 473.835C474.196 509.102 439.255 580.301 370.025 585.109C300.167 589.961 241.321 540.007 189.315 497.609C141.938 458.986 117.437 406.978 88.5028 355.603C53.1707 292.869 -12.2428 234.212 1.99552 165.015C16.473 94.6556 86.9077 40.1425 159.374 11.1767C225.234 -15.1486 298.243 12.582 370.025 17.9079Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        filter: "url(#create-project-shadow)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "20",
        y: "80",
        width: "640",
        height: "400",
        rx: "8",
        fill: "var(--ds-surface, white)",
        stroke: "var(--ds-background-accent-gray-subtler, #EBECF0)",
        strokeWidth: "1",
        filter: "create-project-shadow"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "42",
        y: "142",
        width: "20",
        height: "20",
        rx: "10",
        fill: "var(--ds-background-accent-gray-subtler, #DFE1E6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "78",
        y: "148",
        width: "100",
        height: "8",
        rx: "4",
        fill: "var(--ds-background-accent-gray-subtler, #DFE1E6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "42",
        y: "178",
        width: "20",
        height: "20",
        rx: "10",
        fill: "var(--ds-background-accent-gray-subtler, #DFE1E6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "78",
        y: "184",
        width: "100",
        height: "8",
        rx: "4",
        fill: "var(--ds-background-accent-gray-subtler, #DFE1E6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "42",
        y: "214",
        width: "20",
        height: "20",
        rx: "10",
        fill: "var(--ds-background-accent-gray-subtler, #DFE1E6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "78",
        y: "220",
        width: "100",
        height: "8",
        rx: "4",
        fill: "var(--ds-background-accent-gray-subtler, #DFE1E6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "42",
        y: "250",
        width: "20",
        height: "20",
        rx: "10",
        fill: "var(--ds-background-accent-gray-subtler, #DFE1E6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "78",
        y: "256",
        width: "100",
        height: "8",
        rx: "4",
        fill: "var(--ds-background-accent-gray-subtler, #DFE1E6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "42",
        y: "286",
        width: "20",
        height: "20",
        rx: "10",
        fill: "var(--ds-background-accent-gray-subtler, #DFE1E6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "78",
        y: "292",
        width: "100",
        height: "8",
        rx: "4",
        fill: "var(--ds-background-accent-gray-subtler, #DFE1E6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "42",
        y: "322",
        width: "20",
        height: "20",
        rx: "10",
        fill: "var(--ds-background-accent-gray-subtler, #DFE1E6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "78",
        y: "328",
        width: "100",
        height: "8",
        rx: "4",
        fill: "var(--ds-background-accent-gray-subtler, #DFE1E6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "42",
        y: "358",
        width: "20",
        height: "20",
        rx: "10",
        fill: "var(--ds-background-accent-gray-subtler, #DFE1E6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "78",
        y: "364",
        width: "100",
        height: "8",
        rx: "4",
        fill: "var(--ds-background-accent-gray-subtler, #DFE1E6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "40",
        y: "100",
        width: "24",
        height: "24",
        rx: "6",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "204",
        y: "80",
        width: "2",
        height: "400",
        fill: "var(--ds-border-disabled, #EBECF0)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "239",
        y: "148",
        width: "16",
        height: "8",
        rx: "4",
        fill: "var(--ds-background-accent-gray-subtler, #DFE1E6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "271",
        y: "132",
        width: "2",
        height: "334",
        fill: "var(--ds-border-disabled, #EBECF0)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "285",
        y: "148",
        width: "64",
        height: "8",
        rx: "4",
        fill: "var(--ds-background-accent-gray-subtler, #DFE1E6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "361",
        y: "132",
        width: "2",
        height: "334",
        fill: "var(--ds-border-disabled, #EBECF0)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "377",
        y: "147",
        width: "120",
        height: "8",
        rx: "4",
        fill: "var(--ds-background-accent-gray-subtler, #DFE1E6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "513",
        y: "132",
        width: "2",
        height: "334",
        fill: "var(--ds-border-disabled, #EBECF0)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "527",
        y: "148",
        width: "64",
        height: "8",
        rx: "4",
        fill: "var(--ds-background-accent-gray-subtler, #DFE1E6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "603",
        y: "132",
        width: "2",
        height: "334",
        fill: "var(--ds-border-disabled, #EBECF0)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "613",
        y: "148",
        width: "24",
        height: "8",
        rx: "4",
        fill: "var(--ds-background-accent-gray-subtler, #DFE1E6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "239",
        y: "186",
        width: "16",
        height: "16",
        rx: "4",
        fill: "var(--ds-background-accent-blue-subtle, #4C9AFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "377",
        y: "189",
        width: "120",
        height: "8",
        rx: "4",
        fill: "var(--ds-background-accent-gray-subtler, #DFE1E6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "527",
        y: "186",
        width: "64",
        height: "16",
        rx: "3",
        fill: "var(--ds-background-accent-gray-subtler, #C1C7D0)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "616",
        y: "184",
        width: "20",
        height: "20",
        rx: "10",
        fill: "var(--ds-background-accent-red-subtler, #FF8F73)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "239",
        y: "228",
        width: "16",
        height: "16",
        rx: "4",
        fill: "var(--ds-background-accent-blue-subtle, #4C9AFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "377",
        y: "231",
        width: "70",
        height: "8",
        rx: "4",
        fill: "var(--ds-background-accent-gray-subtler, #DFE1E6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "527",
        y: "228",
        width: "64",
        height: "16",
        rx: "3",
        fill: "var(--ds-background-accent-gray-subtler, #C1C7D0)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "616",
        y: "226",
        width: "20",
        height: "20",
        rx: "10",
        fill: "var(--ds-background-accent-blue-subtler, #4C9AFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "239",
        y: "270",
        width: "16",
        height: "16",
        rx: "4",
        fill: "var(--ds-background-accent-blue-subtle, #4C9AFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "377",
        y: "273",
        width: "120",
        height: "8",
        rx: "4",
        fill: "var(--ds-background-accent-gray-subtler, #DFE1E6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "527",
        y: "270",
        width: "64",
        height: "16",
        rx: "3",
        fill: "var(--ds-background-accent-blue-subtler, #B3D4FF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "616",
        y: "268",
        width: "20",
        height: "20",
        rx: "10",
        fill: "var(--ds-background-accent-blue-subtler, #4C9AFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "239",
        y: "312",
        width: "16",
        height: "16",
        rx: "4",
        fill: "var(--ds-background-accent-blue-subtle, #4C9AFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "377",
        y: "315",
        width: "120",
        height: "8",
        rx: "4",
        fill: "var(--ds-background-accent-gray-subtler, #DFE1E6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "527",
        y: "312",
        width: "64",
        height: "16",
        rx: "3",
        fill: "var(--ds-background-accent-blue-subtler, #B3D4FF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "616",
        y: "310",
        width: "20",
        height: "20",
        rx: "10",
        fill: "var(--ds-background-accent-orange-subtler, #FFC400)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "239",
        y: "354",
        width: "16",
        height: "16",
        rx: "4",
        fill: "var(--ds-background-accent-blue-subtle, #4C9AFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "377",
        y: "357",
        width: "120",
        height: "8",
        rx: "4",
        fill: "var(--ds-background-accent-gray-subtler, #DFE1E6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "527",
        y: "354",
        width: "64",
        height: "16",
        rx: "3",
        fill: "var(--ds-background-accent-blue-subtler, #B3D4FF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "616",
        y: "352",
        width: "20",
        height: "20",
        rx: "10",
        fill: "var(--ds-background-accent-red-subtler, #FF8F73)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "239",
        y: "396",
        width: "16",
        height: "16",
        rx: "4",
        fill: "var(--ds-background-accent-blue-subtle, #4C9AFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "377",
        y: "399",
        width: "120",
        height: "8",
        rx: "4",
        fill: "var(--ds-background-accent-gray-subtler, #DFE1E6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "527",
        y: "396",
        width: "64",
        height: "16",
        rx: "3",
        fill: "var(--ds-background-accent-green-subtler, #ABF5D1)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "616",
        y: "394",
        width: "20",
        height: "20",
        rx: "10",
        fill: "var(--ds-background-accent-blue-subtler, #4C9AFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "239",
        y: "438",
        width: "16",
        height: "16",
        rx: "4",
        fill: "var(--ds-background-accent-blue-subtle, #4C9AFF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "377",
        y: "441",
        width: "120",
        height: "8",
        rx: "4",
        fill: "var(--ds-background-accent-gray-subtler, #DFE1E6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "527",
        y: "438",
        width: "64",
        height: "16",
        rx: "3",
        fill: "var(--ds-background-accent-green-subtler, #ABF5D1)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "616",
        y: "436",
        width: "20",
        height: "20",
        rx: "10",
        fill: "var(--ds-background-accent-orange-subtler, #FFC400)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "224",
        y: "102",
        width: "180",
        height: "16",
        rx: "8",
        fill: "var(--ds-background-accent-gray-subtler, #DFE1E6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "624",
        y: "102",
        width: "16",
        height: "16",
        rx: "8",
        fill: "var(--ds-background-accent-gray-subtler, #DFE1E6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "600",
        y: "102",
        width: "16",
        height: "16",
        rx: "8",
        fill: "var(--ds-background-accent-gray-subtler, #DFE1E6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "576",
        y: "102",
        width: "16",
        height: "16",
        rx: "8",
        fill: "var(--ds-background-accent-gray-subtler, #DFE1E6)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "226",
        y: "172",
        width: "420",
        height: "2",
        fill: "var(--ds-border-disabled, #EBECF0)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "226",
        y: "214",
        width: "420",
        height: "2",
        fill: "var(--ds-border-disabled, #EBECF0)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "226",
        y: "256",
        width: "420",
        height: "2",
        fill: "var(--ds-border-disabled, #EBECF0)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "226",
        y: "298",
        width: "420",
        height: "2",
        fill: "var(--ds-border-disabled, #EBECF0)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "226",
        y: "340",
        width: "420",
        height: "2",
        fill: "var(--ds-border-disabled, #EBECF0)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "226",
        y: "382",
        width: "420",
        height: "2",
        fill: "var(--ds-border-disabled, #EBECF0)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "226",
        y: "424",
        width: "420",
        height: "2",
        fill: "var(--ds-border-disabled, #EBECF0)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8VwWb.ProjectNameText), {
        x: 72,
        y: 103
    }, projectName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fontSize: "14",
        x: "280",
        y: "198",
        fill: "var(--ds-text-subtle, #7A869A)"
    }, (0, $6J4HP.transformProjectKeyText)(projectKey, 1)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fontSize: "14",
        x: "280",
        y: "240",
        fill: "var(--ds-text-subtle, #7A869A)"
    }, (0, $6J4HP.transformProjectKeyText)(projectKey, 2)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fontSize: "14",
        x: "280",
        y: "282",
        fill: "var(--ds-text-subtle, #7A869A)"
    }, (0, $6J4HP.transformProjectKeyText)(projectKey, 3)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fontSize: "14",
        x: "280",
        y: "324",
        fill: "var(--ds-text-subtle, #7A869A)"
    }, (0, $6J4HP.transformProjectKeyText)(projectKey, 4)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fontSize: "14",
        x: "280",
        y: "366",
        fill: "var(--ds-text-subtle, #7A869A)"
    }, (0, $6J4HP.transformProjectKeyText)(projectKey, 5)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fontSize: "14",
        x: "280",
        y: "408",
        fill: "var(--ds-text-subtle, #7A869A)"
    }, (0, $6J4HP.transformProjectKeyText)(projectKey, 6)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fontSize: "14",
        x: "280",
        y: "450",
        fill: "var(--ds-text-subtle, #7A869A)"
    }, (0, $6J4HP.transformProjectKeyText)(projectKey, 7)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fontSize: "12",
        x: "110",
        y: "460",
        textAnchor: "middle",
        fill: "var(--ds-text-subtlest, #6B778C)"
    }, isTmp ? formatMessage(teamManagedIllustrationFooter) : formatMessage(companyManagedIllustrationFooter)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
        id: "create-project-shadow"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feDropShadow", {
        dx: "2",
        dy: "2",
        stdDeviation: "10",
        floodColor: "#000",
        floodOpacity: "0.2"
    })))));
};

});
parcelRegister("lGPBR", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd00b46d94f54418$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $cd00b46d94f54418$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    illustrationLabelSpork: {
        "id": "project-create-importer-upload-flow.project-create-screen.illustration.jwm.illustration-label-spork",
        "defaultMessage": "A Jira project in list view. It displays the name of the project that is typed in."
    }
});

});

parcelRegister("6J4HP", function(module, exports) {

$parcel$export(module.exports, "transformProjectKeyText", () => $697460bbc2d54ff3$export$a4d8043c2fa7fd3e);
parcelRequire("8SMdk");
var $isBpJ = parcelRequire("isBpJ");
const $697460bbc2d54ff3$export$59a943b34a82e690 = (text, length)=>text.length > length ? `${text.substring(0, length - 1)}...` : text;
const $697460bbc2d54ff3$export$a4d8043c2fa7fd3e = (projectKey, issueNumber)=>$697460bbc2d54ff3$export$59a943b34a82e690((0, $isBpJ.createProjectKeyText)(projectKey, issueNumber), 6);

});


parcelRegister("fas7W", function(module, exports) {

$parcel$export(module.exports, "default", () => $265794dac50724ec$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $265794dac50724ec$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    teamManagedIllustrationFooter: {
        "id": "project-create-importer-upload-flow.project-create-screen.illustration.team-managed-illustration-footer",
        "defaultMessage": "Team-managed project"
    },
    companyManagedIllustrationFooter: {
        "id": "project-create-importer-upload-flow.project-create-screen.illustration.company-managed-illustration-footer",
        "defaultMessage": "Company-managed project"
    }
});

});


parcelRegister("kI9I9", function(module, exports) {

$parcel$export(module.exports, "ProjectCreateScreenNew", () => $be236b76ea0061df$export$85ec2e012b3fb856);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $f222W = parcelRequire("f222W");

var $7jPhn = parcelRequire("7jPhn");
var $4LhB6 = parcelRequire("4LhB6");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $cf2Y4 = parcelRequire("cf2Y4");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2jdHI = parcelRequire("2jdHI");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kzTj7 = parcelRequire("kzTj7");

var $3ak5x = parcelRequire("3ak5x");

var $3yuWi = parcelRequire("3yuWi");

var $9R4E5 = parcelRequire("9R4E5");


var $1VyqP = parcelRequire("1VyqP");

var $elKPF = parcelRequire("elKPF");

var $1T7vu = parcelRequire("1T7vu");

var $7cdKR = parcelRequire("7cdKR");

var $bgSxq = parcelRequire("bgSxq");

var $d0wrd = parcelRequire("d0wrd");
var $irKna = parcelRequire("irKna");

var $jFv2N = parcelRequire("jFv2N");

var $1dxi7 = parcelRequire("1dxi7");

var $fiH3o = parcelRequire("fiH3o");

var $eSyeF = parcelRequire("eSyeF");

var $2ke01 = parcelRequire("2ke01");

var $4o2UL = parcelRequire("4o2UL");

var $fzDx6 = parcelRequire("fzDx6");

var $7JnAW = parcelRequire("7JnAW");

var $4oKpo = parcelRequire("4oKpo");

var $iR23m = parcelRequire("iR23m");

var $qDXwM = parcelRequire("qDXwM");

var $iKNKJ = parcelRequire("iKNKJ");

var $4aIBV = parcelRequire("4aIBV");
const $be236b76ea0061df$export$85ec2e012b3fb856 = ({ onReturn: onReturn, onNext: onNext, shouldPrefillThirdPartyProjectName: shouldPrefillThirdPartyProjectName = false, shouldShowThirdPartyStats: shouldShowThirdPartyStats = false, thirdParty: thirdParty, shouldStartImportOnNext: shouldStartImportOnNext, onCloseAndReturnToUploadStep: onCloseAndReturnToUploadStep, templates: templates, importType: importType = (0, $3ak5x.CSV) })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { isLoading: isLoadingProjectNameValidation, validateProjectName: validateProjectName } = (0, $4o2UL.useValidateProjectName)();
    const { isLoading: isLoadingProjectKeyValidation, validateProjectKey: validateProjectKey } = (0, $2ke01.useValidateProjectKey)();
    const { isLoading: isLoadingProjectKey, generateProjectKey: generateProjectKey } = (0, $eSyeF.useGenerateProjectKey)();
    const [projectData, { setProjectData: setProjectData }] = (0, $d0wrd.useProjectData)();
    const [{ selectedSpaceName: selectedSpaceName, selectedEntityName: selectedEntityName, selectedEntityStyle: selectedEntityStyle }] = (0, $irKna.useThirdPartyState)();
    const [selectedSourceItem] = (0, $jFv2N.useSelectedSourceItem)();
    const projectSettings = selectedSourceItem?.[selectedSourceItem?.supportedFlow];
    const { setupProjectScreenDescription: setupProjectScreenDescription } = (0, $bgSxq.useContentForCSV)(thirdParty || importType);
    let DEFAULT_PROJECT_NAME = '';
    if (shouldPrefillThirdPartyProjectName && selectedEntityName) {
        if (selectedSpaceName) DEFAULT_PROJECT_NAME = `${selectedSpaceName} - ${selectedEntityName}`;
        else DEFAULT_PROJECT_NAME = selectedEntityName;
    }
    const [projectName, setProjectName] = (0, $eUqFw.useState)(projectData.name || DEFAULT_PROJECT_NAME);
    const [projectKey, setProjectKey] = (0, $eUqFw.useState)(projectData.key || '');
    const [projectNameValidationError, setProjectNameValidationError] = (0, $eUqFw.useState)('');
    const [projectKeyValidationError, setProjectKeyValidationError] = (0, $eUqFw.useState)('');
    const [isSubmitting, setIsSubmitting] = (0, $eUqFw.useState)(false);
    const { productSteps: productSteps, currentStepIndex: currentStepIndex } = (0, $fiH3o.useProductSteps)();
    const { startImport: startImport, isImportLoading: isImportLoading, hasImportErrorOccurred: hasImportErrorOccurred, isStartImportDisabled: isStartImportDisabled } = (0, $1dxi7.useStartImportController)({
        thirdParty: thirdParty
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const shouldDisableNext = projectName === '' || projectKey === '' || !isSubmitting && (projectNameValidationError !== '' || projectKeyValidationError !== '' || isLoadingProjectNameValidation || isLoadingProjectKeyValidation || isLoadingProjectKey);
    const shouldDisableImport = isStartImportDisabled || shouldDisableNext;
    (0, $eUqFw.useEffect)(()=>{
        if (!shouldPrefillThirdPartyProjectName || !projectName) return;
        validateProjectName(projectName).then((errorMessage)=>{
            if (errorMessage) {
                setProjectNameValidationError(errorMessage);
                return;
            }
            setProjectNameValidationError('');
            generateProjectKey(projectName).then((generatedProjectKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($f222W)))(generatedProjectKey)) {
                    setProjectKey(generatedProjectKey);
                    setProjectKeyValidationError('');
                    setProjectData({
                        name: projectName,
                        key: generatedProjectKey
                    });
                }
            });
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        generateProjectKey
    ]);
    const [handleProjectNameChange] = (0, $2jdHI.default)((newProjectName)=>{
        const valueLength = newProjectName.trim().length;
        if (valueLength === 0) {
            setProjectNameValidationError(formatMessage((0, $7JnAW.default).projectNameEmpty));
            return;
        }
        if (valueLength < (0, $9R4E5.PROJECT_NAME_START_LIMIT)) {
            setProjectNameValidationError(formatMessage((0, $7JnAW.default).projectNameTooShort));
            return;
        }
        if (valueLength > (0, $9R4E5.PROJECT_NAME_END_LIMIT)) {
            setProjectNameValidationError(formatMessage((0, $7JnAW.default).projectNameTooLong));
            return;
        }
        validateProjectName(newProjectName).then((errorMessage)=>{
            if (errorMessage) {
                setProjectNameValidationError(errorMessage);
                return;
            }
            setProjectNameValidationError('');
            generateProjectKey(newProjectName).then((generatedProjectKey)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($f222W)))(generatedProjectKey)) {
                    setProjectKey(generatedProjectKey);
                    setProjectKeyValidationError('');
                    setProjectData({
                        name: newProjectName,
                        key: generatedProjectKey
                    });
                }
            });
        });
    }, (0, $kzTj7.DEBOUNCE_DELAY));
    const onProjectNameChange = (0, $eUqFw.useCallback)((e)=>{
        setProjectName(e.target.value);
        setProjectNameValidationError('');
        handleProjectNameChange(e.target.value);
    }, [
        setProjectName,
        handleProjectNameChange,
        setProjectNameValidationError
    ]);
    const [handleProjectKeyChange] = (0, $2jdHI.default)((newProjectKey)=>{
        validateProjectKey(newProjectKey).then((errorMessage)=>{
            if (errorMessage) {
                setProjectKeyValidationError(errorMessage);
                return;
            }
            setProjectKeyValidationError('');
            setProjectData({
                key: newProjectKey
            });
        });
    }, (0, $kzTj7.DEBOUNCE_DELAY));
    const onProjectKeyChange = (0, $eUqFw.useCallback)((value)=>{
        setProjectKey(value);
        setProjectKeyValidationError('');
        handleProjectKeyChange(value);
    }, [
        handleProjectKeyChange,
        setProjectKey,
        setProjectKeyValidationError
    ]);
    const onSubmit = (0, $eUqFw.useCallback)(async ()=>{
        // Not possible since users would have to have loaded mapping csv in the previous screen
        // and submit button is disabled in this case
        if (shouldStartImportOnNext && shouldDisableImport) return;
        setIsSubmitting(true);
        const projectNameError = await validateProjectName(projectName);
        if (projectNameError) {
            setIsSubmitting(false);
            setProjectNameValidationError(projectNameError);
            return;
        }
        const projectKeyError = await validateProjectKey(projectKey);
        if (projectKeyError) {
            setIsSubmitting(false);
            setProjectKeyValidationError(projectKeyError);
            return;
        }
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'projectSetupNextButton'
        }), {
            template: projectData.template,
            accessLevel: projectData.accessLevel
        });
        if (!shouldStartImportOnNext) {
            onNext();
            return;
        }
        startImport({
            projectData: projectData,
            onNext: onNext
        });
        setIsSubmitting(false);
    }, [
        shouldStartImportOnNext,
        shouldDisableImport,
        validateProjectName,
        projectName,
        validateProjectKey,
        projectKey,
        startImport,
        projectData,
        onNext,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: (0, $3yuWi.X2C_SCREENS).SETUP_PROJECT,
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        attributes: {
            thirdParty: thirdParty
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7cdKR.StepScreen), {
        testId: "project-create-importer-upload-flow.ui.project-create-screen.wrapper",
        renderProgressBar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1T7vu.ProgressBarStandard), {
            productSteps: productSteps,
            currentStepIndex: currentStepIndex,
            onClose: onCloseAndReturnToUploadStep
        }),
        renderFooter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $elKPF.StepFooterStandard), {
            alignRight: true,
            onReturn: onReturn,
            shouldStartImportOnNext: shouldStartImportOnNext,
            isLoading: isImportLoading || isSubmitting,
            shouldDisableReturn: isImportLoading || isSubmitting,
            shouldDisableNext: shouldStartImportOnNext ? shouldDisableImport : shouldDisableNext,
            nextButtonType: "submit",
            hasImportErrorOccurred: hasImportErrorOccurred,
            onClickNext: ()=>onSubmit()
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $be236b76ea0061df$var$contentWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $be236b76ea0061df$var$formWrapperStyles
    }, selectedSourceItem?.supportedFlow === (0, $d46558193b478af8$export$5a613e161b9e89e5) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1VyqP.PageHeading), null, formatMessage((0, $7JnAW.default).header)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1VyqP.PageDescription), null, setupProjectScreenDescription), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1VyqP.PageDescription), null, formatMessage((0, $7JnAW.default).allFieldsRequired))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $be236b76ea0061df$var$headerStyles
    }, formatMessage((0, $7JnAW.default).header)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $be236b76ea0061df$var$descriptionStyles
    }, setupProjectScreenDescription), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $be236b76ea0061df$var$descriptionStyles
    }, formatMessage((0, $7JnAW.default).allFieldsRequired))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $be236b76ea0061df$var$createFormWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $be236b76ea0061df$var$fieldsWrapperStyles
    }, projectSettings && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iKNKJ.ProjectTypeSelector), {
        projectSetting: projectSettings
    }), projectData.type === (0, $9R4E5.ProjectTypes).SOFTWARE && templates.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4aIBV.TemplateSelector), {
        templates: templates
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        label: formatMessage((0, $7JnAW.default).projectName),
        name: "name"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
            testId: "project-create-importer-upload-flow.ui.project-create-screen.project-name-field",
            ...fieldProps,
            value: projectName,
            onChange: onProjectNameChange,
            placeholder: formatMessage((0, $7JnAW.default).projectNamePlaceholder)
        }), projectNameValidationError !== '' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), {
            testId: "project-create-importer-upload-flow.ui.project-create-screen.project-name-error-message"
        }, projectNameValidationError)))), shouldShowThirdPartyStats && thirdParty && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iR23m.ProjectCreateStats), {
        thirdParty: thirdParty
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4oKpo.NewProjectCreateMoreOptions), {
        projectSettings: projectSettings,
        selectedEntityStyle: selectedEntityStyle,
        disableProjectStyle: !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(selectedEntityStyle)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $qDXwM.ProjectKeyField), {
        projectKey: projectKey,
        onProjectKeyChange: onProjectKeyChange,
        projectKeyValidationError: projectKeyValidationError
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fzDx6.IllustrationNew), {
        projectType: projectData.type,
        projectName: projectName,
        projectKey: projectKey,
        isTmp: projectData.style === (0, $9R4E5.ProjectStyles).TEAM_MANAGED_PROJECT,
        projectTemplate: projectData.template
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null)));
};
const $be236b76ea0061df$var$contentWrapperStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    flexFlow: 'row',
    flexWrap: 'wrap',
    columnGap: 'space.400',
    justifyContent: 'space-between'
});
const $be236b76ea0061df$var$formWrapperStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    flexFlow: 'column',
    width: '500px'
});
const $be236b76ea0061df$var$createFormWrapperStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    flexFlow: 'column',
    width: '400px'
});
const $be236b76ea0061df$var$fieldsWrapperStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    flexFlow: 'inherit',
    rowGap: 'space.100'
});
const $be236b76ea0061df$var$headerStyles = (0, $1ZAYh.xcss)({
    color: 'color.text',
    font: "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    paddingBottom: 'space.100'
});
const $be236b76ea0061df$var$descriptionStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.subtle',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    paddingBottom: 'space.200'
});

});
parcelRegister("fzDx6", function(module, exports) {

$parcel$export(module.exports, "IllustrationNew", () => $e68ab4d435e080a6$export$91ff4f22e3eed42b);

var $eUqFw = parcelRequire("eUqFw");

var $9R4E5 = parcelRequire("9R4E5");

var $27s3C = parcelRequire("27s3C");

var $aEXPY = parcelRequire("aEXPY");

var $fas7W = parcelRequire("fas7W");
const $e68ab4d435e080a6$export$91ff4f22e3eed42b = ({ projectType: projectType, projectTemplate: projectTemplate, ...props })=>{
    switch(projectType){
        case (0, $9R4E5.ProjectTypes).BUSINESS:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aEXPY.IllustrationJWM), {
                ...props,
                teamManagedIllustrationFooter: (0, $fas7W.default).teamManagedIllustrationFooter,
                companyManagedIllustrationFooter: (0, $fas7W.default).companyManagedIllustrationFooter
            });
        case (0, $9R4E5.ProjectTypes).SOFTWARE:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27s3C.IllustrationJSW), {
                ...props,
                projectTemplate: projectTemplate,
                teamManagedIllustrationFooter: (0, $fas7W.default).teamManagedIllustrationFooter,
                companyManagedIllustrationFooter: (0, $fas7W.default).companyManagedIllustrationFooter
            });
        default:
            return null;
    }
};

});
parcelRegister("27s3C", function(module, exports) {

$parcel$export(module.exports, "IllustrationJSW", () => $e017048ab883003b$export$8f32440ee1c7f301);

var $eUqFw = parcelRequire("eUqFw");

var $9R4E5 = parcelRequire("9R4E5");

var $8vOzr = parcelRequire("8vOzr");

var $kdBmF = parcelRequire("kdBmF");
const $e017048ab883003b$export$8f32440ee1c7f301 = ({ projectTemplate: projectTemplate, teamManagedIllustrationFooter: teamManagedIllustrationFooter, companyManagedIllustrationFooter: companyManagedIllustrationFooter, ...props })=>{
    switch(projectTemplate){
        case (0, $9R4E5.TemplateTypes).SCRUM:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kdBmF.JSWScrumIllustration), {
                ...props,
                teamManagedIllustrationFooter: teamManagedIllustrationFooter,
                companyManagedIllustrationFooter: companyManagedIllustrationFooter
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8vOzr.JSWKanbanIllustration), {
                ...props,
                teamManagedIllustrationFooter: teamManagedIllustrationFooter,
                companyManagedIllustrationFooter: companyManagedIllustrationFooter
            });
    }
};

});
parcelRegister("8vOzr", function(module, exports) {

$parcel$export(module.exports, "JSWKanbanIllustration", () => $d0e22b9917751065$export$5c4a91b1a9cbb5c1);

var $eUqFw = parcelRequire("eUqFw");

var $juktg = parcelRequire("juktg");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dgvZS = parcelRequire("dgvZS");

var $isBpJ = parcelRequire("isBpJ");

var $dwYJS = parcelRequire("dwYJS");
const $d0e22b9917751065$export$5c4a91b1a9cbb5c1 = ({ projectName: projectName, projectKey: projectKey, isTmp: isTmp, teamManagedIllustrationFooter: teamManagedIllustrationFooter, companyManagedIllustrationFooter: companyManagedIllustrationFooter })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { colorMode: colorMode } = (0, $juktg.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dgvZS.IllustrationWrapper), {
        "data-testId": "project-create-importer-upload-flow.project-create-screen.illustration.jsw-new.kanban.wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "469",
        height: "327",
        viewBox: "0 0 469 327",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": formatMessage((0, $dwYJS.default).illustrationLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M231.768 9.98332C275.273 12.6401 330.466 15.1635 366.484 33.4939C402.868 52.0105 406.389 50.8482 423.647 81.0084C442.896 114.649 482.028 174.233 464.666 208.437C447.246 242.756 382.018 243.524 341.213 264.155C302.326 283.815 278.659 323.507 231.768 326.188C184.451 328.893 144.593 301.044 109.367 277.408C77.2776 255.876 58.5204 253.739 38.922 225.099C14.9905 190.126 -7.34554 147.23 2.29851 108.654C12.1046 69.4304 40.0039 22.3787 89.0874 6.23079C133.696 -8.44509 183.148 7.01424 231.768 9.98332Z",
        fill: "url(#paint0_linear_4253_17959)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        filter: "url(#filter0_dd_4253_17959)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "22",
        y: "14",
        width: "410.164",
        height: "268.961",
        rx: "5.48394",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "22.3427",
        y: "14.3427",
        width: "409.479",
        height: "268.275",
        rx: "5.14119",
        fill: "var(--ds-shadow-overflow, ##F7F7F9)",
        strokeWidth: "0.685492"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "146",
        y: "71",
        width: "90",
        height: "198",
        rx: "1.97111",
        fill: "var(--ds-surface-sunken, #F7F8F9)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "153.885",
        y: "78.8838",
        width: "39.6517",
        height: "5",
        rx: "2.5",
        fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        filter: "url(#filter1_dd_4253_17959)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "154",
        y: "92",
        width: "74",
        height: "35",
        rx: "1.97111",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "159",
        y: "97",
        width: "64",
        height: "4",
        rx: "2",
        fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "159",
        y: "105",
        width: "44",
        height: "4",
        rx: "2",
        fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "var(--ds-text-subtlest, #626F86)",
        fontSize: "6.57038",
        letterSpacing: "0px",
        x: "159.256",
        y: "120.592"
    }, (0, $isBpJ.transformProjectKeyText)(projectKey, 1))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        filter: "url(#filter2_dd_4253_17959)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "154",
        y: "132",
        width: "74",
        height: "35",
        rx: "1.97111",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "159",
        y: "138",
        width: "64",
        height: "4",
        rx: "2",
        fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "159",
        y: "145",
        width: "44",
        height: "4",
        rx: "2",
        fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "var(--ds-text-subtlest, #626F86)",
        fontSize: "6.57038",
        letterSpacing: "0px",
        x: "159.256",
        y: "160.592"
    }, (0, $isBpJ.transformProjectKeyText)(projectKey, 2))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        filter: "url(#filter3_dd_4253_17959)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "154",
        y: "172",
        width: "74",
        height: "35",
        rx: "1.97111",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "159",
        y: "178",
        width: "64",
        height: "4",
        rx: "2",
        fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "159",
        y: "185",
        width: "44",
        height: "4",
        rx: "2",
        fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "var(--ds-text-subtlest, #626F86)",
        fontSize: "6.57038",
        letterSpacing: "0px",
        x: "159.256",
        y: "200.592"
    }, (0, $isBpJ.transformProjectKeyText)(projectKey, 3))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        filter: "url(#filter4_dd_4253_17959)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "154",
        y: "212",
        width: "74",
        height: "35",
        rx: "1.97111",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "159",
        y: "218",
        width: "64",
        height: "4",
        rx: "2",
        fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "159",
        y: "225",
        width: "44",
        height: "4",
        rx: "2",
        fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "var(--ds-text-subtlest, #626F86)",
        fontSize: "6.57038",
        letterSpacing: "0px",
        x: "159.256",
        y: "240.592"
    }, (0, $isBpJ.transformProjectKeyText)(projectKey, 4))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "242",
        y: "71",
        width: "90",
        height: "198",
        rx: "1.97111",
        fill: "var(--ds-surface-sunken, #F7F8F9)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "249.885",
        y: "78.8838",
        width: "39.6517",
        height: "5",
        rx: "2.5",
        fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        filter: "url(#filter5_dd_4253_17959)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "250",
        y: "92",
        width: "74",
        height: "35",
        rx: "1.97111",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "255",
        y: "98",
        width: "64",
        height: "4",
        rx: "2",
        fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "255",
        y: "105",
        width: "44",
        height: "4",
        rx: "2",
        fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "var(--ds-text-subtlest, #626F86)",
        fontSize: "6.57038",
        letterSpacing: "0px",
        x: "255.256",
        y: "120.592"
    }, (0, $isBpJ.transformProjectKeyText)(projectKey, 5))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        filter: "url(#filter6_dd_4253_17959)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "250",
        y: "132",
        width: "74",
        height: "35",
        rx: "1.97111",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "255",
        y: "138",
        width: "64",
        height: "4",
        rx: "2",
        fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "255",
        y: "145",
        width: "44",
        height: "4",
        rx: "2",
        fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "var(--ds-text-subtlest, #626F86)",
        fontSize: "6.57038",
        letterSpacing: "0px",
        x: "255.256",
        y: "160.592"
    }, (0, $isBpJ.transformProjectKeyText)(projectKey, 6))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "338",
        y: "71",
        width: "90",
        height: "198",
        rx: "1.97111",
        fill: "var(--ds-surface-sunken, #F7F8F9)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "345.885",
        y: "78.8838",
        width: "39.6517",
        height: "5",
        rx: "2.5",
        fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        filter: "url(#filter7_dd_4253_17959)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "346",
        y: "92",
        width: "74",
        height: "35",
        rx: "1.97111",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "351",
        y: "98",
        width: "64",
        height: "4",
        rx: "2",
        fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "351",
        y: "105",
        width: "44",
        height: "4",
        rx: "2",
        fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "var(--ds-text-subtlest, #626F86)",
        fontSize: "6.57038",
        letterSpacing: "0px",
        x: "351.256",
        y: "120.592"
    }, (0, $isBpJ.transformProjectKeyText)(projectKey, 7))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        filter: "url(#filter8_dd_4253_17959)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "346",
        y: "132",
        width: "74",
        height: "35",
        rx: "1.97111",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "351",
        y: "138",
        width: "64",
        height: "4",
        rx: "2",
        fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "351",
        y: "145",
        width: "44",
        height: "4",
        rx: "2",
        fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "var(--ds-text-subtlest, #626F86)",
        fontSize: "6.57038",
        letterSpacing: "0px",
        x: "351.256",
        y: "160.592"
    }, (0, $isBpJ.transformProjectKeyText)(projectKey, 8))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        filter: "url(#filter9_dd_4253_17959)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "346",
        y: "172",
        width: "74",
        height: "35",
        rx: "1.97111",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "351",
        y: "178",
        width: "64",
        height: "4",
        rx: "2",
        fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "351",
        y: "185",
        width: "44",
        height: "4",
        rx: "2",
        fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "var(--ds-text-subtlest, #626F86)",
        fontSize: "6.57038",
        letterSpacing: "0px",
        x: "351.256",
        y: "200.592"
    }, (0, $isBpJ.transformProjectKeyText)(projectKey, 9))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "146.183",
        y: "50.8418",
        width: "24.9347",
        height: "8.2259",
        rx: "4.11295",
        fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "177.856",
        y: "50.8418",
        width: "24.9347",
        height: "8.2259",
        rx: "4.11295",
        fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "209.53",
        y: "50.8418",
        width: "32.8684",
        height: "8.2259",
        rx: "4.11295",
        fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "249.136",
        y: "50.8418",
        width: "26.068",
        height: "8.2259",
        rx: "4.11295",
        fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "145.876",
        y: "32.5088",
        width: "82.171",
        height: "8.2259",
        rx: "4.11295",
        fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M22.147 18.8112C22.147 15.9944 24.4304 13.7109 27.2472 13.7109H133.147V282.711H27.2472C24.4304 282.711 22.147 280.427 22.147 277.611V18.8112Z",
        fill: "var(--ds-surface-sunken, #F7F8F9)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M22.147 13.7109H133.147H22.147ZM133.147 282.711H22.147H133.147ZM22.147 282.711V13.7109V282.711ZM133.832 13.7109V282.711H132.461V13.7109H133.832Z",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "35.6235",
        y: "30.1631",
        width: "13.6007",
        height: "13.6007",
        rx: "3.40018",
        fill: "var(--ds-icon-accent-blue, #1D7AFC)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "var(--ds-text-subtle, #44546F)",
        fontSize: "11",
        letterSpacing: "0px",
        x: "54.7085",
        y: "39.8719"
    }, (0, $isBpJ.truncateText)(projectName, 10)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "36.1914",
        y: "68.9893",
        width: "82.171",
        height: "8.2259",
        rx: "4.11295",
        fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "35.624",
        y: "51.9893",
        width: "82.171",
        height: "8.2259",
        rx: "4.11295",
        fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "36.1914",
        y: "85.9912",
        width: "82.171",
        height: "8.2259",
        rx: "4.11295",
        fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "var(--ds-text-subtlest, #626F86)",
        fontSize: "6.74874",
        letterSpacing: "0px",
        x: "35.6238",
        y: "269.126"
    }, isTmp ? formatMessage(teamManagedIllustrationFooter) : formatMessage(companyManagedIllustrationFooter))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
        id: "filter0_dd_4253_17959",
        x: "10",
        y: "2",
        width: "434.164",
        height: "292.96",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: colorMode === 'dark' ? '0 0 0 0 0.0117647 0 0 0 0 0.0156863 0 0 0 0 0.0156863 0 0 0 0.56 0' : '0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.16 0'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_4253_17959"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: colorMode === 'dark' ? '0 0 0 0 0.0117647 0 0 0 0 0.0156863 0 0 0 0 0.0156863 0 0 0 0.5 0' : '0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.12 0'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_4253_17959",
        result: "effect2_dropShadow_4253_17959"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_4253_17959",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
        id: "filter1_dd_4253_17959",
        x: "153",
        y: "91",
        width: "76",
        height: "38",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", {
        dy: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_4253_17959"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_4253_17959",
        result: "effect2_dropShadow_4253_17959"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_4253_17959",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
        id: "filter2_dd_4253_17959",
        x: "153",
        y: "131",
        width: "76",
        height: "38",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", {
        dy: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_4253_17959"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_4253_17959",
        result: "effect2_dropShadow_4253_17959"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_4253_17959",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
        id: "filter3_dd_4253_17959",
        x: "153",
        y: "171",
        width: "76",
        height: "38",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", {
        dy: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_4253_17959"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_4253_17959",
        result: "effect2_dropShadow_4253_17959"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_4253_17959",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
        id: "filter4_dd_4253_17959",
        x: "153",
        y: "211",
        width: "76",
        height: "38",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", {
        dy: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_4253_17959"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_4253_17959",
        result: "effect2_dropShadow_4253_17959"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_4253_17959",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
        id: "filter5_dd_4253_17959",
        x: "249",
        y: "91",
        width: "76",
        height: "38",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", {
        dy: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_4253_17959"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_4253_17959",
        result: "effect2_dropShadow_4253_17959"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_4253_17959",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
        id: "filter6_dd_4253_17959",
        x: "249",
        y: "131",
        width: "76",
        height: "38",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", {
        dy: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_4253_17959"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_4253_17959",
        result: "effect2_dropShadow_4253_17959"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_4253_17959",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
        id: "filter7_dd_4253_17959",
        x: "345",
        y: "91",
        width: "76",
        height: "38",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", {
        dy: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_4253_17959"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_4253_17959",
        result: "effect2_dropShadow_4253_17959"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_4253_17959",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
        id: "filter8_dd_4253_17959",
        x: "345",
        y: "131",
        width: "76",
        height: "38",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", {
        dy: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_4253_17959"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_4253_17959",
        result: "effect2_dropShadow_4253_17959"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_4253_17959",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
        id: "filter9_dd_4253_17959",
        x: "345",
        y: "171",
        width: "76",
        height: "38",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", {
        dy: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_4253_17959"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_4253_17959",
        result: "effect2_dropShadow_4253_17959"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_4253_17959",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint0_linear_4253_17959",
        x1: "74.9975",
        y1: "-1.89206e-05",
        x2: "228.889",
        y2: "324.521",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.150366",
        stopColor: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "#D8F2F6"
    })))));
};

});
parcelRegister("dwYJS", function(module, exports) {

$parcel$export(module.exports, "default", () => $afca3dedeb4bfb37$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $afca3dedeb4bfb37$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    illustrationLabel: {
        "id": "project-create-importer-upload-flow.project-create-screen.illustration.jsw-new.kanban.illustration-label",
        "defaultMessage": "Illustration showing the preview of Jira Project having a kanban board"
    }
});

});


parcelRegister("kdBmF", function(module, exports) {

$parcel$export(module.exports, "JSWScrumIllustration", () => $b74db5447813d17d$export$11b32c8fa3ba2ac5);

var $eUqFw = parcelRequire("eUqFw");

var $juktg = parcelRequire("juktg");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dgvZS = parcelRequire("dgvZS");

var $isBpJ = parcelRequire("isBpJ");

var $4cK3C = parcelRequire("4cK3C");
const $b74db5447813d17d$export$11b32c8fa3ba2ac5 = ({ projectName: projectName, projectKey: projectKey, isTmp: isTmp, teamManagedIllustrationFooter: teamManagedIllustrationFooter, companyManagedIllustrationFooter: companyManagedIllustrationFooter })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { colorMode: colorMode } = (0, $juktg.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dgvZS.IllustrationWrapper), {
        "data-testId": "project-create-importer-upload-flow.project-create-screen.illustration.jsw-new.scrum.wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "469",
        height: "327",
        viewBox: "0 0 469 327",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": formatMessage((0, $4cK3C.default).illustrationLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M231.768 9.98332C275.273 12.6401 330.466 15.1635 366.484 33.4939C402.868 52.0105 406.389 50.8482 423.647 81.0084C442.896 114.649 482.028 174.233 464.666 208.437C447.246 242.756 382.018 243.524 341.213 264.155C302.326 283.815 278.659 323.507 231.768 326.188C184.451 328.893 144.593 301.044 109.367 277.408C77.2776 255.876 58.5204 253.739 38.922 225.099C14.9905 190.126 -7.34554 147.23 2.29851 108.654C12.1046 69.4304 40.0039 22.3787 89.0874 6.23079C133.696 -8.44509 183.148 7.01424 231.768 9.98332Z",
        fill: "url(#paint0_linear_4253_17317)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        filter: "url(#filter0_dd_4253_17317)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        clipPath: "url(#clip0_4253_17317)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "22",
        y: "14",
        width: "410.164",
        height: "268.961",
        rx: "5.48394",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "145.816",
        y: "71.4442",
        width: "277.27",
        height: "105.126",
        rx: "1.97111",
        fill: "var(--ds-surface-sunken, #F7F8F9)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "153.701",
        y: "79.3284",
        width: "39.6517",
        height: "7.88446",
        rx: "3.94223",
        fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "153.701",
        y: "158.173",
        width: "39.6517",
        height: "7.88446",
        rx: "3.94223",
        fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        filter: "url(#filter1_dd_4253_17317)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "153.701",
        y: "92.4694",
        width: "261.501",
        height: "15.7689",
        rx: "1.97111",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "183.268",
        y: "98.3817",
        width: "57.1623",
        height: "3.94223",
        rx: "1.97111",
        fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "367.896",
        y: "98.3817",
        width: "26.2815",
        height: "3.94223",
        rx: "1.97111",
        fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "var(--ds-text-subtlest, #626F86)",
        fontSize: "6.57038",
        letterSpacing: "0px",
        x: "158.957",
        y: "102.69"
    }, (0, $isBpJ.transformProjectKeyText)(projectKey, 1)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        cx: "404.689",
        cy: "100.353",
        r: "5.2563",
        fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        filter: "url(#filter2_dd_4253_17317)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "153.701",
        y: "113.494",
        width: "261.501",
        height: "15.7689",
        rx: "1.97111",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "183.268",
        y: "119.407",
        width: "57.1623",
        height: "3.94223",
        rx: "1.97111",
        fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "367.896",
        y: "119.407",
        width: "26.2815",
        height: "3.94223",
        rx: "1.97111",
        fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "var(--ds-text-subtlest, #626F86)",
        fontSize: "6.57038",
        letterSpacing: "0px",
        x: "158.957",
        y: "123.715"
    }, (0, $isBpJ.transformProjectKeyText)(projectKey, 2)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        cx: "404.689",
        cy: "121.379",
        r: "5.2563",
        fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        filter: "url(#filter3_dd_4253_17317)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "153.701",
        y: "134.519",
        width: "261.501",
        height: "15.7689",
        rx: "1.97111",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "183.268",
        y: "140.433",
        width: "57.1623",
        height: "3.94223",
        rx: "1.97111",
        fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "367.896",
        y: "140.433",
        width: "26.2815",
        height: "3.94223",
        rx: "1.97111",
        fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "var(--ds-text-subtlest, #626F86)",
        fontSize: "6.57038",
        letterSpacing: "0px",
        x: "158.957",
        y: "144.739"
    }, (0, $isBpJ.transformProjectKeyText)(projectKey, 3)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        cx: "404.689",
        cy: "142.403",
        r: "5.2563",
        fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "153.701",
        y: "187.083",
        width: "39.6517",
        height: "7.88446",
        rx: "3.94223",
        fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        filter: "url(#filter4_dd_4253_17317)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "153.701",
        y: "200.224",
        width: "261.501",
        height: "15.7689",
        rx: "1.97111",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "183.268",
        y: "206.137",
        width: "57.1623",
        height: "3.94223",
        rx: "1.97111",
        fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "367.896",
        y: "206.137",
        width: "26.2815",
        height: "3.94223",
        rx: "1.97111",
        fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "var(--ds-text-subtlest, #626F86)",
        fontSize: "6.57038",
        letterSpacing: "0px",
        x: "158.957",
        y: "210.444"
    }, (0, $isBpJ.transformProjectKeyText)(projectKey, 4)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        cx: "404.689",
        cy: "208.109",
        r: "5.2563",
        fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        filter: "url(#filter5_dd_4253_17317)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "153.701",
        y: "221.249",
        width: "261.501",
        height: "15.7689",
        rx: "1.97111",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "183.268",
        y: "227.163",
        width: "57.1623",
        height: "3.94223",
        rx: "1.97111",
        fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "367.896",
        y: "227.163",
        width: "26.2815",
        height: "3.94223",
        rx: "1.97111",
        fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "var(--ds-text-subtlest, #626F86)",
        fontSize: "6.57038",
        letterSpacing: "0px",
        x: "158.957",
        y: "231.469"
    }, (0, $isBpJ.transformProjectKeyText)(projectKey, 5)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        cx: "404.689",
        cy: "229.134",
        r: "5.2563",
        fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        filter: "url(#filter6_dd_4253_17317)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "153.701",
        y: "242.274",
        width: "261.501",
        height: "15.7689",
        rx: "1.97111",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "183.268",
        y: "248.188",
        width: "57.1623",
        height: "3.94223",
        rx: "1.97111",
        fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "367.896",
        y: "248.188",
        width: "26.2815",
        height: "3.94223",
        rx: "1.97111",
        fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "var(--ds-text-subtlest, #626F86)",
        fontSize: "6.57038",
        letterSpacing: "0px",
        x: "158.957",
        y: "252.494"
    }, (0, $isBpJ.transformProjectKeyText)(projectKey, 6)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        cx: "404.689",
        cy: "250.159",
        r: "5.2563",
        fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "146.183",
        y: "50.8418",
        width: "24.9347",
        height: "8.2259",
        rx: "4.11295",
        fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "177.856",
        y: "50.8418",
        width: "24.9347",
        height: "8.2259",
        rx: "4.11295",
        fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "209.53",
        y: "50.8418",
        width: "32.8684",
        height: "8.2259",
        rx: "4.11295",
        fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "249.136",
        y: "50.8418",
        width: "26.068",
        height: "8.2259",
        rx: "4.11295",
        fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "145.876",
        y: "32.5088",
        width: "82.171",
        height: "8.2259",
        rx: "4.11295",
        fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M22 19.1394C22 16.3225 24.2835 14.0391 27.1003 14.0391H133V283.039H27.1003C24.2835 283.039 22 280.756 22 277.939V19.1394Z",
        fill: "var(--ds-surface-sunken, #F7F8F9)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M22 14.0391H133H22ZM133 283.039H22H133ZM22 283.039V14.0391V283.039ZM133.685 14.0391V283.039H132.315V14.0391H133.685Z",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "35.4766",
        y: "30.4908",
        width: "13.6007",
        height: "13.6007",
        rx: "3.40018",
        fill: "var(--ds-icon-accent-blue, #1D7AFC)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "var(--ds-text-subtle, #44546F)",
        fontSize: "11",
        letterSpacing: "0px",
        x: "54.7085",
        y: "39.8719"
    }, (0, $isBpJ.truncateText)(projectName, 10)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "36.0444",
        y: "69.3176",
        width: "82.171",
        height: "8.2259",
        rx: "4.11295",
        fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "35.4771",
        y: "52.3171",
        width: "82.171",
        height: "8.2259",
        rx: "4.11295",
        fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "36.0444",
        y: "86.319",
        width: "82.171",
        height: "8.2259",
        rx: "4.11295",
        fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "var(--ds-text-subtlest, #626F86)",
        fontSize: "6.57038",
        letterSpacing: "0px",
        x: "35.6238",
        y: "269.126"
    }, isTmp ? formatMessage(teamManagedIllustrationFooter) : formatMessage(companyManagedIllustrationFooter)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
        id: "filter0_dd_4253_17317",
        x: "10",
        y: "2",
        width: "434.164",
        height: "292.961",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: colorMode === 'dark' ? '0 0 0 0 0.0117647 0 0 0 0 0.0156863 0 0 0 0 0.0156863 0 0 0 0.56 0' : '0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.16 0'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_4253_17317"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: colorMode === 'dark' ? '0 0 0 0 0.0117647 0 0 0 0 0.0156863 0 0 0 0 0.0156863 0 0 0 0.5 0' : '0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.12 0'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_4253_17317",
        result: "effect2_dropShadow_4253_17317"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_4253_17317",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
        id: "filter1_dd_4253_17317",
        x: "152.701",
        y: "91.4694",
        width: "263.501",
        height: "18.7689",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", {
        dy: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0117647 0 0 0 0 0.0156863 0 0 0 0 0.0156863 0 0 0 0.5 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_4253_17317"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0117647 0 0 0 0 0.0156863 0 0 0 0 0.0156863 0 0 0 0.5 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_4253_17317",
        result: "effect2_dropShadow_4253_17317"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_4253_17317",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
        id: "filter2_dd_4253_17317",
        x: "152.701",
        y: "112.494",
        width: "263.501",
        height: "18.7689",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", {
        dy: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0117647 0 0 0 0 0.0156863 0 0 0 0 0.0156863 0 0 0 0.5 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_4253_17317"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0117647 0 0 0 0 0.0156863 0 0 0 0 0.0156863 0 0 0 0.5 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_4253_17317",
        result: "effect2_dropShadow_4253_17317"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_4253_17317",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
        id: "filter3_dd_4253_17317",
        x: "152.701",
        y: "133.519",
        width: "263.501",
        height: "18.7689",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", {
        dy: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0117647 0 0 0 0 0.0156863 0 0 0 0 0.0156863 0 0 0 0.5 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_4253_17317"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0117647 0 0 0 0 0.0156863 0 0 0 0 0.0156863 0 0 0 0.5 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_4253_17317",
        result: "effect2_dropShadow_4253_17317"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_4253_17317",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
        id: "filter4_dd_4253_17317",
        x: "152.701",
        y: "199.224",
        width: "263.501",
        height: "18.7689",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", {
        dy: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0117647 0 0 0 0 0.0156863 0 0 0 0 0.0156863 0 0 0 0.5 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_4253_17317"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0117647 0 0 0 0 0.0156863 0 0 0 0 0.0156863 0 0 0 0.5 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_4253_17317",
        result: "effect2_dropShadow_4253_17317"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_4253_17317",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
        id: "filter5_dd_4253_17317",
        x: "152.701",
        y: "220.249",
        width: "263.501",
        height: "18.7689",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", {
        dy: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0117647 0 0 0 0 0.0156863 0 0 0 0 0.0156863 0 0 0 0.5 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_4253_17317"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0117647 0 0 0 0 0.0156863 0 0 0 0 0.0156863 0 0 0 0.5 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_4253_17317",
        result: "effect2_dropShadow_4253_17317"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_4253_17317",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
        id: "filter6_dd_4253_17317",
        x: "152.701",
        y: "241.274",
        width: "263.501",
        height: "18.7689",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", {
        dy: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0117647 0 0 0 0 0.0156863 0 0 0 0 0.0156863 0 0 0 0.5 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_4253_17317"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0117647 0 0 0 0 0.0156863 0 0 0 0 0.0156863 0 0 0 0.5 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_4253_17317",
        result: "effect2_dropShadow_4253_17317"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_4253_17317",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint0_linear_4253_17317",
        x1: "74.9975",
        y1: "-1.89206e-05",
        x2: "228.889",
        y2: "324.521",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.150366",
        stopColor: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "#D8F2F6"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip0_4253_17317"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "22",
        y: "14",
        width: "410.164",
        height: "268.961",
        rx: "5.48394",
        fill: "white"
    })))));
};

});
parcelRegister("4cK3C", function(module, exports) {

$parcel$export(module.exports, "default", () => $2561a603a6acd3e1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2561a603a6acd3e1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    illustrationLabel: {
        "id": "project-create-importer-upload-flow.project-create-screen.illustration.jsw-new.scrum.illustration-label",
        "defaultMessage": "Illustration showing the preview of Jira Project having a scrum board"
    }
});

});



parcelRegister("aEXPY", function(module, exports) {

$parcel$export(module.exports, "IllustrationJWM", () => $1d2efde755b7db65$export$501992a230cf9d64);

var $eUqFw = parcelRequire("eUqFw");

var $juktg = parcelRequire("juktg");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dgvZS = parcelRequire("dgvZS");

var $isBpJ = parcelRequire("isBpJ");

var $l41HA = parcelRequire("l41HA");
const $1d2efde755b7db65$export$501992a230cf9d64 = ({ projectName: projectName, projectKey: projectKey, isTmp: isTmp, teamManagedIllustrationFooter: teamManagedIllustrationFooter, companyManagedIllustrationFooter: companyManagedIllustrationFooter })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { colorMode: colorMode } = (0, $juktg.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dgvZS.IllustrationWrapper), {
        "data-testId": "project-create-importer-upload-flow.project-create-screen.illustration.jwm-new.wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "469",
        height: "327",
        viewBox: "0 0 469 327",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "img",
        "aria-label": formatMessage((0, $l41HA.default).illustrationLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("title", null, formatMessage((0, $l41HA.default).illustrationLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M231.768 9.98332C275.273 12.6401 330.466 15.1635 366.484 33.4939C402.868 52.0105 406.389 50.8482 423.647 81.0084C442.896 114.649 482.028 174.233 464.666 208.437C447.246 242.756 382.018 243.524 341.213 264.155C302.326 283.815 278.659 323.507 231.768 326.188C184.451 328.893 144.593 301.044 109.367 277.408C77.2776 255.876 58.5204 253.739 38.922 225.099C14.9905 190.126 -7.34554 147.23 2.29851 108.654C12.1046 69.4304 40.0039 22.3787 89.0874 6.23079C133.696 -8.44509 183.148 7.01424 231.768 9.98332Z",
        fill: "url(#paint0_linear_4253_17324)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        filter: "url(#filter0_d_4253_17324)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "22",
        y: "14",
        width: "410.164",
        height: "268.961",
        rx: "5.47227",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "145.613",
        y: "32.4707",
        width: "81.9962",
        height: "8.2084",
        rx: "4.1042",
        fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M21.9991 19.0894C21.9991 16.2786 24.2778 14 27.0886 14H132.945V282.961H27.0886C24.2778 282.961 21.9991 280.682 21.9991 277.871V19.0894Z",
        fill: "var(--ds-surface-sunken, #F7F8F9)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M21.9991 14H132.945H21.9991ZM132.945 282.961H21.9991H132.945ZM21.9991 282.961V14V282.961ZM133.631 14V282.961H132.26V14H133.631Z",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "35.4757",
        y: "30.4521",
        width: "13.5718",
        height: "13.5718",
        rx: "3.39295",
        fill: "var(--ds-icon-accent-blue, #1D7AFC)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "var(--ds-text-subtle, #44546F)",
        fontSize: "11",
        letterSpacing: "0px",
        x: "54.5199",
        y: "40.1284"
    }, (0, $isBpJ.truncateText)(projectName, 10)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "36.0421",
        y: "69.2129",
        width: "81.9962",
        height: "8.2084",
        rx: "4.1042",
        fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "35.4761",
        y: "52.249",
        width: "81.9962",
        height: "8.2084",
        rx: "4.1042",
        fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "36.0421",
        y: "86.1787",
        width: "81.9962",
        height: "8.2084",
        rx: "4.1042",
        fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "var(--ds-text-subtlest, #626F86)",
        fontSize: "6.84033",
        letterSpacing: "0px",
        x: "35.4758",
        y: "268.924"
    }, isTmp ? formatMessage(teamManagedIllustrationFooter) : formatMessage(companyManagedIllustrationFooter)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M423.76 76.0552H146.394V78.0552H423.76V76.0552Z",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "146.394",
        y: "50.7646",
        width: "31.5487",
        height: "26.2906",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "156.911",
        y: "61",
        width: "10.5162",
        height: "5.25812",
        rx: "2.62906",
        fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "177.943",
        y: "50.7646",
        width: "1.31453",
        height: "26.2906",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "179.258",
        y: "50.7646",
        width: "57.8393",
        height: "26.2906",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "187.145",
        y: "61",
        width: "42.0649",
        height: "5.25812",
        rx: "2.62906",
        fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "237.097",
        y: "50.7646",
        width: "1.31453",
        height: "26.2906",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "238.411",
        y: "50.7646",
        width: "98.5897",
        height: "26.2906",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "247.613",
        y: "61",
        width: "78.8717",
        height: "5.25812",
        rx: "2.62906",
        fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "337.001",
        y: "50.7646",
        width: "1.31453",
        height: "26.2906",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "338.316",
        y: "50.7646",
        width: "57.8393",
        height: "26.2906",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "346.203",
        y: "61",
        width: "42.0649",
        height: "5.25812",
        rx: "2.62906",
        fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "396.155",
        y: "50.7646",
        width: "1.31453",
        height: "26.2906",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "397.469",
        y: "50.7646",
        width: "26.2906",
        height: "26.2906",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "402.728",
        y: "61",
        width: "15.7743",
        height: "5.25812",
        rx: "2.62906",
        fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M423.76 103.661H146.394V105.661H423.76V103.661Z",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "146.394",
        y: "78.3701",
        width: "31.5487",
        height: "26.2906",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "156.911",
        y: "86.2578",
        width: "10.5162",
        height: "10.5162",
        rx: "2.62906",
        fill: "var(--ds-icon-accent-blue, #1D7AFC)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "177.943",
        y: "78.3701",
        width: "1.31453",
        height: "26.2906",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "179.258",
        y: "78.3701",
        width: "57.8393",
        height: "26.2906",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "237.097",
        y: "78.3701",
        width: "1.31453",
        height: "26.2906",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "238.411",
        y: "78.3701",
        width: "98.5897",
        height: "26.2906",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "337.001",
        y: "78.3701",
        width: "1.31453",
        height: "26.2906",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "338.316",
        y: "78.3701",
        width: "57.8393",
        height: "26.2906",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "346.203",
        y: "86.2578",
        width: "42.0649",
        height: "10.5162",
        rx: "1.97179",
        fill: "var(--ds-background-accent-gray-subtle, #8590A2)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "396.155",
        y: "78.3701",
        width: "1.31453",
        height: "26.2906",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "397.469",
        y: "78.3701",
        width: "26.2906",
        height: "26.2906",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "404.699",
        y: "84.9434",
        width: "13.1453",
        height: "13.1453",
        rx: "6.57264",
        fill: "var(--ds-background-accent-red-subtle, #F87168)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M423.76 131.266H146.394V133.266H423.76V131.266Z",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "146.394",
        y: "105.976",
        width: "31.5487",
        height: "26.2906",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "156.911",
        y: "113.862",
        width: "10.5162",
        height: "10.5162",
        rx: "2.62906",
        fill: "var(--ds-icon-accent-blue, #1D7AFC)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "177.943",
        y: "105.976",
        width: "1.31453",
        height: "26.2906",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "179.258",
        y: "105.976",
        width: "57.8393",
        height: "26.2906",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "237.097",
        y: "105.976",
        width: "1.31453",
        height: "26.2906",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "238.411",
        y: "105.976",
        width: "98.5897",
        height: "26.2906",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "337.001",
        y: "105.976",
        width: "1.31453",
        height: "26.2906",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "338.316",
        y: "105.976",
        width: "57.8393",
        height: "26.2906",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "346.203",
        y: "113.862",
        width: "42.0649",
        height: "10.5162",
        rx: "1.97179",
        fill: "var(--ds-background-accent-gray-subtle, #8590A2)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "396.155",
        y: "105.976",
        width: "1.31453",
        height: "26.2906",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "397.469",
        y: "105.976",
        width: "26.2906",
        height: "26.2906",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "404.699",
        y: "112.549",
        width: "13.1453",
        height: "13.1453",
        rx: "6.57264",
        fill: "var(--ds-icon-accent-blue, #1D7AFC)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M423.76 158.871H146.394V160.871H423.76V158.871Z",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "146.394",
        y: "133.58",
        width: "31.5487",
        height: "26.2906",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "156.911",
        y: "141.467",
        width: "10.5162",
        height: "10.5162",
        rx: "2.62906",
        fill: "var(--ds-icon-accent-blue, #1D7AFC)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "177.943",
        y: "133.58",
        width: "1.31453",
        height: "26.2906",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "179.258",
        y: "133.58",
        width: "57.8393",
        height: "26.2906",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "237.097",
        y: "133.58",
        width: "1.31453",
        height: "26.2906",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "238.411",
        y: "133.58",
        width: "98.5897",
        height: "26.2906",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "337.001",
        y: "133.58",
        width: "1.31453",
        height: "26.2906",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "338.316",
        y: "133.58",
        width: "57.8393",
        height: "26.2906",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "346.203",
        y: "141.467",
        width: "42.0649",
        height: "10.5162",
        rx: "1.97179",
        fill: "var(--ds-background-accent-blue-subtler, CCE0FF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "396.155",
        y: "133.58",
        width: "1.31453",
        height: "26.2906",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "397.469",
        y: "133.58",
        width: "26.2906",
        height: "26.2906",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "404.699",
        y: "140.152",
        width: "13.1453",
        height: "13.1453",
        rx: "6.57264",
        fill: "var(--ds-icon-accent-blue, #1D7AFC)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M423.76 186.476H146.394V188.476H423.76V186.476Z",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "146.394",
        y: "161.186",
        width: "31.5487",
        height: "26.2906",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "156.911",
        y: "169.072",
        width: "10.5162",
        height: "10.5162",
        rx: "2.62906",
        fill: "var(--ds-icon-accent-blue, #1D7AFC)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "177.943",
        y: "161.186",
        width: "1.31453",
        height: "26.2906",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "179.258",
        y: "161.186",
        width: "57.8393",
        height: "26.2906",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "237.097",
        y: "161.186",
        width: "1.31453",
        height: "26.2906",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "238.411",
        y: "161.186",
        width: "98.5897",
        height: "26.2906",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "337.001",
        y: "161.186",
        width: "1.31453",
        height: "26.2906",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "338.316",
        y: "161.186",
        width: "57.8393",
        height: "26.2906",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "346.203",
        y: "169.072",
        width: "42.0649",
        height: "10.5162",
        rx: "1.97179",
        fill: "var(--ds-background-accent-blue-subtler, CCE0FF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "396.155",
        y: "161.186",
        width: "1.31453",
        height: "26.2906",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "397.469",
        y: "161.186",
        width: "26.2906",
        height: "26.2906",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "404.699",
        y: "167.758",
        width: "13.1453",
        height: "13.1453",
        rx: "6.57264",
        fill: "var(--ds-background-accent-yellow-subtler-hovered, #F5CD47)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M423.76 214.082H146.394V216.082H423.76V214.082Z",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "146.394",
        y: "188.791",
        width: "31.5487",
        height: "26.2906",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "156.911",
        y: "196.678",
        width: "10.5162",
        height: "10.5162",
        rx: "2.62906",
        fill: "var(--ds-icon-accent-blue, #1D7AFC)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "177.943",
        y: "188.791",
        width: "1.31453",
        height: "26.2906",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "179.258",
        y: "188.791",
        width: "57.8393",
        height: "26.2906",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "237.097",
        y: "188.791",
        width: "1.31453",
        height: "26.2906",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "238.411",
        y: "188.791",
        width: "98.5897",
        height: "26.2906",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "337.001",
        y: "188.791",
        width: "1.31453",
        height: "26.2906",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "338.316",
        y: "188.791",
        width: "57.8393",
        height: "26.2906",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "346.203",
        y: "196.678",
        width: "42.0649",
        height: "10.5162",
        rx: "1.97179",
        fill: "var(--ds-background-accent-blue-subtler, CCE0FF)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "396.155",
        y: "188.791",
        width: "1.31453",
        height: "26.2906",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "397.469",
        y: "188.791",
        width: "26.2906",
        height: "26.2906",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "404.7",
        y: "195.364",
        width: "13.1453",
        height: "13.1453",
        rx: "6.57264",
        fill: "var(--ds-background-accent-red-subtle, #F87168)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M423.76 241.687H146.394V243.687H423.76V241.687Z",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "146.394",
        y: "216.396",
        width: "31.5487",
        height: "26.2906",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "156.911",
        y: "224.283",
        width: "10.5162",
        height: "10.5162",
        rx: "2.62906",
        fill: "var(--ds-icon-accent-blue, #1D7AFC)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "177.943",
        y: "216.396",
        width: "1.31453",
        height: "26.2906",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "179.258",
        y: "216.396",
        width: "57.8393",
        height: "26.2906",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "237.097",
        y: "216.396",
        width: "1.31453",
        height: "26.2906",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "238.411",
        y: "216.396",
        width: "98.5897",
        height: "26.2906",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "337.001",
        y: "216.396",
        width: "1.31453",
        height: "26.2906",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "338.316",
        y: "216.396",
        width: "57.8393",
        height: "26.2906",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "346.203",
        y: "224.283",
        width: "42.0649",
        height: "10.5162",
        rx: "1.97179",
        fill: "var(--ds-background-accent-green-subtler, #BAF3DB)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "396.155",
        y: "216.396",
        width: "1.31453",
        height: "26.2906",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "397.469",
        y: "216.396",
        width: "26.2906",
        height: "26.2906",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "404.699",
        y: "222.97",
        width: "13.1453",
        height: "13.1453",
        rx: "6.57264",
        fill: "var(--ds-icon-accent-blue, #1D7AFC)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M423.76 269.292H146.394V271.292H423.76V269.292Z",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "146.394",
        y: "243.999",
        width: "31.5487",
        height: "26.2906",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "156.911",
        y: "251.886",
        width: "10.5162",
        height: "10.5162",
        rx: "2.62906",
        fill: "var(--ds-icon-accent-blue, #1D7AFC)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "177.943",
        y: "244.001",
        width: "1.31453",
        height: "26.2906",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "179.258",
        y: "243.999",
        width: "57.8393",
        height: "26.2906",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "237.097",
        y: "244.001",
        width: "1.31453",
        height: "26.2906",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "238.412",
        y: "243.999",
        width: "98.5897",
        height: "26.2906",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "337.001",
        y: "244.001",
        width: "1.31453",
        height: "26.2906",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "338.315",
        y: "243.999",
        width: "57.8393",
        height: "26.2906",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "346.202",
        y: "251.886",
        width: "42.0649",
        height: "10.5162",
        rx: "1.97179",
        fill: "var(--ds-background-accent-green-subtler, #BAF3DB)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "396.155",
        y: "244.001",
        width: "1.31453",
        height: "26.2906",
        fill: "var(--ds-border-disabled, #091E42)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "397.469",
        y: "243.999",
        width: "26.2906",
        height: "26.2906",
        fill: "var(--ds-background-input, white)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "404.699",
        y: "250.572",
        width: "13.1453",
        height: "13.1453",
        rx: "6.57264",
        fill: "var(--ds-background-accent-yellow-subtler-hovered, #F5CD47)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "var(--ds-text-subtlest, #626F86)",
        fontSize: "6.84033",
        letterSpacing: "0px",
        x: "195.984",
        y: "93.9126"
    }, (0, $isBpJ.transformProjectKeyText)(projectKey, 1)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "var(--ds-text-subtlest, #626F86)",
        fontSize: "6.84033",
        letterSpacing: "0px",
        x: "195.984",
        y: "121.085"
    }, (0, $isBpJ.transformProjectKeyText)(projectKey, 2)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "var(--ds-text-subtlest, #626F86)",
        fontSize: "6.84033",
        letterSpacing: "0px",
        x: "195.984",
        y: "149.662"
    }, (0, $isBpJ.transformProjectKeyText)(projectKey, 3)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "var(--ds-text-subtlest, #626F86)",
        fontSize: "6.84033",
        letterSpacing: "0px",
        x: "195.984",
        y: "176.558"
    }, (0, $isBpJ.transformProjectKeyText)(projectKey, 4)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "var(--ds-text-subtlest, #626F86)",
        fontSize: "6.84033",
        letterSpacing: "0px",
        x: "195.984",
        y: "205.135"
    }, (0, $isBpJ.transformProjectKeyText)(projectKey, 5)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "var(--ds-text-subtlest, #626F86)",
        fontSize: "6.84033",
        letterSpacing: "0px",
        x: "195.984",
        y: "232.032"
    }, (0, $isBpJ.transformProjectKeyText)(projectKey, 6)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "var(--ds-text-subtlest, #626F86)",
        fontSize: "6.84033",
        letterSpacing: "0px",
        x: "195.984",
        y: "259.768"
    }, (0, $isBpJ.transformProjectKeyText)(projectKey, 7))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
        id: "filter0_d_4253_17324",
        x: "13.7907",
        y: "11.2639",
        width: "426.582",
        height: "285.378",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", {
        dy: "5.47227"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "4.1042"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: colorMode === 'dark' ? '0 0 0 0 0.0117647 0 0 0 0 0.0156863 0 0 0 0 0.0156863 0 0 0 0.56 0' : '0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.16 0'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_4253_17324"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect1_dropShadow_4253_17324",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "paint0_linear_4253_17324",
        x1: "74.9975",
        y1: "-1.89206e-05",
        x2: "228.889",
        y2: "324.521",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.150366",
        stopColor: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: "#D8F2F6"
    })))));
};

});
parcelRegister("l41HA", function(module, exports) {

$parcel$export(module.exports, "default", () => $2eda02bbfeae05f9$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2eda02bbfeae05f9$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    illustrationLabel: {
        "id": "project-create-importer-upload-flow.project-create-screen.illustration.jwm-new.illustration-label",
        "defaultMessage": "A Jira project in list view. It displays the name of the project that is typed in."
    }
});

});



parcelRegister("7JnAW", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbab2e696e98366b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $fbab2e696e98366b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    header: {
        "id": "project-create-importer-upload-flow.project-create-screen.header",
        "defaultMessage": "Set up a project in Jira"
    },
    back: {
        "id": "project-create-importer-upload-flow.project-create-screen.back",
        "defaultMessage": "Back"
    },
    import: {
        "id": "project-create-importer-upload-flow.project-create-screen.import",
        "defaultMessage": "Import"
    },
    projectName: {
        "id": "project-create-importer-upload-flow.project-create-screen.project-name",
        "defaultMessage": "Project name"
    },
    projectNamePlaceholder: {
        "id": "project-create-importer-upload-flow.project-create-screen.project-name-placeholder",
        "defaultMessage": "Project name"
    },
    projectNameTooLong: {
        "id": "project-create-importer-upload-flow.project-create-screen.project-name-too-long",
        "defaultMessage": "The project name is too long"
    },
    projectNameTooShort: {
        "id": "project-create-importer-upload-flow.project-create-screen.project-name-too-short",
        "defaultMessage": "The project name is too short"
    },
    projectNameEmpty: {
        "id": "project-create-importer-upload-flow.project-create-screen.project-name-empty",
        "defaultMessage": "Your new project needs a name"
    },
    projectKey: {
        "id": "project-create-importer-upload-flow.project-create-screen.project-key",
        "defaultMessage": "Key"
    },
    allFieldsRequired: {
        "id": "project-create-importer-upload-flow.project-create-screen.all-fields-required",
        "defaultMessage": "All fields are required"
    }
});

});

parcelRegister("4oKpo", function(module, exports) {

$parcel$export(module.exports, "NewProjectCreateMoreOptions", () => $b0b794d8886d2b98$export$23860427ef6fed16);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4LhB6 = parcelRequire("4LhB6");

var $9nt1B = parcelRequire("9nt1B");

var $ffiyv = parcelRequire("ffiyv");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $jQxSL = parcelRequire("jQxSL");
var $5wCDk = parcelRequire("5wCDk");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $7eqzD = parcelRequire("7eqzD");

var $1b2am = parcelRequire("1b2am");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6ouuo = parcelRequire("6ouuo");

var $eIp1n = parcelRequire("eIp1n");
var $6WXNs = parcelRequire("6WXNs");

var $gd0Sp = parcelRequire("gd0Sp");

var $4saTO = parcelRequire("4saTO");

var $2flcE = parcelRequire("2flcE");

var $kzTj7 = parcelRequire("kzTj7");

var $9R4E5 = parcelRequire("9R4E5");

var $1WR91 = parcelRequire("1WR91");

var $lUC5l = parcelRequire("lUC5l");
var $d0wrd = parcelRequire("d0wrd");
var $irKna = parcelRequire("irKna");

var $7xgPi = parcelRequire("7xgPi");
const $b0b794d8886d2b98$var$dropdownWidthStyles = {
    minWidth: '400px',
    maxWidth: '528px'
};
const $b0b794d8886d2b98$var$CustomOption = (props)=>{
    const { isDisabled: isDisabled, label: label, lozengeContent: lozengeContent, description: description, disabledTooltipContent: disabledTooltipContent, disabledContent: disabledContent } = props.data;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eqzD.ConditionalWrapper), {
        condition: isDisabled,
        renderWrapper: (children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
                content: disabledTooltipContent || ''
            }, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $b0b794d8886d2b98$var$optionWrapperStyles,
            ...isDisabled ? [
                $b0b794d8886d2b98$var$disabledOptionWrapperStyles
            ] : []
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $b0b794d8886d2b98$var$contentWrapperStyles
    }, label, lozengeContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        paddingInlineStart: "space.100"
    }, lozengeContent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "p",
        xcss: $b0b794d8886d2b98$var$descriptionWrapperStyles
    }, description)), props.isSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nt1B))), {
        primaryColor: `var(--ds-icon-information, ${(0, $PdmhA).B200})`,
        label: ""
    })), isDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $b0b794d8886d2b98$var$disabledContentWrapperStyles
    }, disabledContent)));
};
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $b0b794d8886d2b98$var$noop = ()=>{};
const $b0b794d8886d2b98$export$23860427ef6fed16 = ({ shouldForceOpen: shouldForceOpen, projectSettings: projectSettings, disableProjectStyle: disableProjectStyle, children: children, selectedEntityStyle: selectedEntityStyle })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [mappingState, { setMappingState: setMappingState }] = (0, $lUC5l.useMappingState)();
    const [{ thirdPartyFieldConfigState: thirdPartyFieldConfigState, thirdPartyStatusMapping: thirdPartyStatusMapping }, { setThirdPartyState: setThirdPartyState }] = (0, $irKna.useThirdPartyState)();
    const [{ type: type, accessLevel: accessLevel, style: style }, { setProjectData: setProjectData }] = (0, $d0wrd.useProjectData)();
    const { appEditions: appEditions } = (0, $gd0Sp.useTenantContext)();
    const availableProjectStyles = (0, $eUqFw.useMemo)(()=>projectSettings?.find((setting)=>setting.productType === type)?.projectStyles, [
        projectSettings,
        type
    ]);
    const isTMPSupported = (0, $eUqFw.useMemo)(()=>availableProjectStyles?.includes((0, $9R4E5.ProjectStyles).TEAM_MANAGED_PROJECT) || false, [
        availableProjectStyles
    ]);
    const isCMPSupported = (0, $eUqFw.useMemo)(()=>availableProjectStyles?.includes((0, $9R4E5.ProjectStyles).COMPANY_MANAGED_PROJECT) || false, [
        availableProjectStyles
    ]);
    const isPermissionGated = (0, $eUqFw.useMemo)(()=>{
        if (type && (isTMPSupported || selectedEntityStyle === (0, $9R4E5.ProjectStyles).TEAM_MANAGED_PROJECT)) {
            const application = (0, $eIp1n.getApplicationForProject)(type);
            const edition = (0, $6WXNs.getEdition)(application, appEditions);
            return (0, $1b2am.shouldApplyPermissionsGate)(application, edition);
        }
        return false;
    }, [
        appEditions,
        isTMPSupported,
        selectedEntityStyle,
        type
    ]);
    const defaultProjectAccess = isPermissionGated ? (0, $99b47c2485002a11$export$1ec4bbf2f176ca6) : (0, $99b47c2485002a11$export$d9b46e2d865ef95c);
    const companyManagedOption = (0, $eUqFw.useMemo)(()=>({
            value: (0, $9R4E5.ProjectStyles).COMPANY_MANAGED_PROJECT,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: $b0b794d8886d2b98$var$titleWrapperStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b0b794d8886d2b98$var$Image, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($4saTO))),
                "aria-label": "company managed",
                role: "img",
                alt: ""
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                paddingInlineStart: "space.100"
            }, formatMessage((0, $7xgPi.default).companyManagedLabel))),
            lozengeContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
                appearance: "inprogress"
            }, formatMessage((0, $7xgPi.default).adminOnlyLozenge)),
            description: formatMessage((0, $7xgPi.default).companyManagedDescription),
            disabledContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                target: "_blank",
                href: (0, $kzTj7.CONTACT_ADMIN_LINK)
            }, formatMessage((0, $7xgPi.default).contactAdminCta)),
            disabledTooltipContent: formatMessage((0, $7xgPi.default).cannotCreateCompanyManagedProjectTooltipMessage),
            isDisabled: !isCMPSupported
        }), [
        formatMessage,
        isCMPSupported
    ]);
    const teamManagedOption = (0, $eUqFw.useMemo)(()=>({
            value: (0, $9R4E5.ProjectStyles).TEAM_MANAGED_PROJECT,
            label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: $b0b794d8886d2b98$var$titleWrapperStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b0b794d8886d2b98$var$Image, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($2flcE))),
                "aria-label": "team managed",
                role: "img",
                alt: ""
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                paddingInlineStart: "space.100"
            }, formatMessage((0, $7xgPi.default).teamManagedLabel))),
            description: formatMessage((0, $7xgPi.default).teamManagedDescription),
            disabledTooltipContent: formatMessage((0, $7xgPi.default).cannotCreateTeamManagedProjectTooltipMessage),
            isDisabled: !isTMPSupported
        }), [
        formatMessage,
        isTMPSupported
    ]);
    const options = (0, $eUqFw.useMemo)(()=>availableProjectStyles ? [
            teamManagedOption,
            companyManagedOption
        ].sort((a, b)=>availableProjectStyles.indexOf(a.value) - availableProjectStyles.indexOf(b.value)) : [
            teamManagedOption,
            companyManagedOption
        ], [
        availableProjectStyles,
        companyManagedOption,
        teamManagedOption
    ]);
    const defaultProjectStyle = (0, $eUqFw.useMemo)(()=>options.find(({ isDisabled: isDisabled })=>!isDisabled), [
        options
    ]);
    const onSetProjectStyle = (0, $eUqFw.useCallback)((projectStyle)=>{
        setProjectData({
            style: projectStyle,
            accessLevel: projectStyle === (0, $9R4E5.ProjectStyles).TEAM_MANAGED_PROJECT ? defaultProjectAccess : null
        });
    }, [
        defaultProjectAccess,
        setProjectData
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (selectedEntityStyle && selectedEntityStyle !== style) {
            onSetProjectStyle(selectedEntityStyle);
            return;
        }
        if (!style && defaultProjectStyle) onSetProjectStyle(defaultProjectStyle.value);
    }, [
        defaultProjectStyle,
        onSetProjectStyle,
        selectedEntityStyle,
        style
    ]);
    const selectedProjectStyle = (0, $eUqFw.useMemo)(()=>options.find(({ value: value })=>value === style), [
        options,
        style
    ]);
    const showProjectAccessField = selectedProjectStyle?.value === (0, $9R4E5.ProjectStyles).TEAM_MANAGED_PROJECT;
    const onChangeProjectStyle = (0, $eUqFw.useCallback)((option)=>{
        if (!option?.value) return;
         // Reset mapping state if data has previously been loaded
        if (mappingState !== null) setMappingState(null);
        if (thirdPartyFieldConfigState !== null) setThirdPartyState({
            thirdPartyFieldConfigState: null
        });
        if (thirdPartyStatusMapping !== null) setThirdPartyState({
            thirdPartyStatusMapping: null
        });
        onSetProjectStyle(option.value);
    }, [
        mappingState,
        onSetProjectStyle,
        setMappingState,
        setThirdPartyState,
        thirdPartyFieldConfigState,
        thirdPartyStatusMapping
    ]);
    const onProjectAccessChange = (0, $eUqFw.useCallback)((value)=>setProjectData({
            accessLevel: value
        }), [
        setProjectData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingBlockStart: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1WR91.Accordion), {
        shouldForceOpen: shouldForceOpen,
        heading: (0, $7xgPi.default).moreOptions,
        expandedHeading: (0, $7xgPi.default).hideMoreOptions,
        testId: "project-create-importer-upload-flow.ui.project-create-screen.new-project-create-more-options.accordion"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b0b794d8886d2b98$var$MoreOptionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        label: formatMessage((0, $7xgPi.default).projectType),
        name: "projectType",
        isDisabled: disableProjectStyle
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
            ...fieldProps,
            inputId: (0, $kzTj7.PROJECT_MANAGEMENT_TYPE_DROPDOWN_ID),
            name: (0, $kzTj7.PROJECT_MANAGEMENT_TYPE_DROPDOWN_ID),
            options: options,
            value: selectedProjectStyle,
            onChange: onChangeProjectStyle,
            components: {
                Option: $b0b794d8886d2b98$var$CustomOption
            }
        })), showProjectAccessField && type && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b0b794d8886d2b98$var$ProjectAccessWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ouuo.default), {
        projectType: type,
        value: accessLevel || undefined,
        onChange: onProjectAccessChange,
        onFirstChange: $b0b794d8886d2b98$var$noop,
        onAccessTypesLoaded: $b0b794d8886d2b98$var$noop,
        onError: $b0b794d8886d2b98$var$noop,
        validateRequired: false,
        requiredAccess: false,
        isDisabled: isPermissionGated,
        dropdownWidthStyles: $b0b794d8886d2b98$var$dropdownWidthStyles,
        baseUrl: ""
    })), children)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0b794d8886d2b98$var$ProjectAccessWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1dp61osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0b794d8886d2b98$var$MoreOptionWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1bsb1osq _1p57pxbi _15pj1txw",
            __cmplp.className
        ])
    });
});
const $b0b794d8886d2b98$var$optionWrapperStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    padding: 'space.100',
    paddingBottom: 'space.200'
});
const $b0b794d8886d2b98$var$disabledOptionWrapperStyles = (0, $1ZAYh.xcss)({
    cursor: 'not-allowed',
    opacity: '0.5',
    paddingBottom: 'space.0'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b0b794d8886d2b98$var$Image = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1ejb _4t3i1ejb",
            __cmplp.className
        ])
    });
});
const $b0b794d8886d2b98$var$contentWrapperStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap'
});
const $b0b794d8886d2b98$var$titleWrapperStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $b0b794d8886d2b98$var$descriptionWrapperStyles = (0, $1ZAYh.xcss)({
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    marginTop: 'space.100',
    marginLeft: 'space.400',
    color: 'color.text.subtlest'
});
const $b0b794d8886d2b98$var$disabledContentWrapperStyles = (0, $1ZAYh.xcss)({
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    paddingLeft: 'space.100'
});

});
parcelRegister("6ouuo", function(module, exports) {

$parcel$export(module.exports, "default", () => $1249615a39dfc4e2$export$2e2bcd8739ae039);

var $kPl4T = parcelRequire("kPl4T");
var $1249615a39dfc4e2$export$2e2bcd8739ae039 = (0, $kPl4T.default);

});
parcelRegister("kPl4T", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e22c2042ad6fa5c$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eUqFw = parcelRequire("eUqFw");

var $5BRby = parcelRequire("5BRby");

var $6vrw7 = parcelRequire("6vrw7");

var $gd0Sp = parcelRequire("gd0Sp");

var $6wnqS = parcelRequire("6wnqS");
var $l36Bx = parcelRequire("l36Bx");

var $gEpce = parcelRequire("gEpce");

var $dqrQW = parcelRequire("dqrQW");

var $bwOiz = parcelRequire("bwOiz");
const $6e22c2042ad6fa5c$var$getValueOnlyAccessType = (value)=>({
        value: value,
        // there are non-critical information that are used only for displaying dropdown options
        description: '',
        iconName: '',
        displayName: ''
    });
// eslint-disable-next-line jira/react/no-class-components
class $6e22c2042ad6fa5c$var$ProjectAccessApp extends (0, $eUqFw.PureComponent) {
    static{
        // Kinda hacky: In order to get a feature flag check around the TenantContextSubscriber,
        // we need to pass 'dummy' prop values for these.
        this.defaultProps = {
            isSiteAdmin: false,
            cloudName: (0, $6vrw7.toCloudName)('DISABLED'),
            validateRequired: false,
            requiredAccess: false
        };
    }
    constructor(props){
        super(props);
        this.render = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5BRby.default), {
                store: this.store,
                teamName: "helix",
                packageName: "projectAccess"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gEpce.default), {
                onFirstChange: this.props.onFirstChange,
                onAccessTypesLoaded: this.props.onAccessTypesLoaded,
                onChange: this.props.onChange,
                onError: this.props.onError,
                isDisabled: this.props.isDisabled,
                validateRequired: this.props.validateRequired,
                requiredAccess: this.props.requiredAccess,
                dropdownWidthStyles: this.props.dropdownWidthStyles
            }));
        const { baseUrl: baseUrl = '', cloudName: cloudName, isSiteAdmin: isSiteAdmin, value: value, projectId: projectId, projectType: projectType, isDisabled: isDisabled } = this.props;
        this.store = (0, $bwOiz.default)((0, $dqrQW.initialState));
        this.store.dispatch((0, $6wnqS.setContext)({
            baseUrl: baseUrl,
            cloudName: cloudName,
            isSiteAdmin: isSiteAdmin,
            projectId: projectId,
            projectType: projectType,
            isDisabled: isDisabled
        }));
        if (value) this.store.dispatch((0, $l36Bx.setProjectAccessType)($6e22c2042ad6fa5c$var$getValueOnlyAccessType(value)));
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.value && nextProps.value !== this.props.value) this.store.dispatch((0, $l36Bx.setProjectAccessType)($6e22c2042ad6fa5c$var$getValueOnlyAccessType(nextProps.value)));
    }
}
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6e22c2042ad6fa5c$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gd0Sp.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e22c2042ad6fa5c$var$ProjectAccessApp, {
            cloudName: tenantContext.cloudName,
            isSiteAdmin: tenantContext.isSiteAdmin,
            ...props
        }));

});
parcelRegister("6wnqS", function(module, exports) {

$parcel$export(module.exports, "setContext", () => $e7c08f27ccd38dbe$export$2f04de43fe27971a);

const $e7c08f27ccd38dbe$export$2f04de43fe27971a = (payload)=>({
        type: (0, $19154c8d94bf29b4$export$4bc4e62e7d72b94b),
        payload: payload
    });

});
const $19154c8d94bf29b4$export$4bc4e62e7d72b94b = 'SET_CONTEXT';


parcelRegister("l36Bx", function(module, exports) {

$parcel$export(module.exports, "fetchProjectAccessTypes", () => $32227a7ed0ce8fdd$export$f2f891b5fd2cd9f2);
$parcel$export(module.exports, "fetchProjectAccessTypesSuccess", () => $32227a7ed0ce8fdd$export$a6500906e454d44a);
$parcel$export(module.exports, "fetchProjectAccessTypesFail", () => $32227a7ed0ce8fdd$export$9b8200978e1aa316);
$parcel$export(module.exports, "setProjectAccessType", () => $32227a7ed0ce8fdd$export$b6d3b306f7d0ad98);

const $32227a7ed0ce8fdd$export$f2f891b5fd2cd9f2 = ()=>({
        type: (0, $af1385d33e486b90$export$95adf3d79d20c12a)
    });
const $32227a7ed0ce8fdd$export$a6500906e454d44a = (ProjectAccessTypes)=>({
        type: (0, $af1385d33e486b90$export$76564810767dbfb8),
        payload: ProjectAccessTypes
    });
const $32227a7ed0ce8fdd$export$9b8200978e1aa316 = (message)=>({
        type: (0, $af1385d33e486b90$export$1f51ae949b6d67a7),
        payload: {
            message: message
        }
    });
const $32227a7ed0ce8fdd$export$b6d3b306f7d0ad98 = (accessType)=>({
        type: (0, $af1385d33e486b90$export$8ae8742e36d90493),
        payload: {
            accessType: accessType
        }
    });

});
const $af1385d33e486b90$export$95adf3d79d20c12a = 'FETCH_PROJECT_ACCESS_TYPES';
const $af1385d33e486b90$export$76564810767dbfb8 = 'FETCH_PROJECT_ACCESS_TYPES_SUCCESS';
const $af1385d33e486b90$export$1f51ae949b6d67a7 = 'FETCH_PROJECT_ACCESS_TYPES_FAIL';
const $af1385d33e486b90$export$8ae8742e36d90493 = 'SET_PROJECT_ACCESS_TYPE';


parcelRegister("gEpce", function(module, exports) {

$parcel$export(module.exports, "default", () => $acbd1a3b3c2f25d6$export$2e2bcd8739ae039);
/* project-access-field-view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $7u4fN = parcelRequire("7u4fN");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $4LhB6 = parcelRequire("4LhB6");

var $86Ndv = parcelRequire("86Ndv");

var $f4A0J = parcelRequire("f4A0J");

var $4nce6 = parcelRequire("4nce6");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $bAQOb = parcelRequire("bAQOb");

var $giAhk = parcelRequire("giAhk");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");

var $lNNXV = parcelRequire("lNNXV");


var $l36Bx = parcelRequire("l36Bx");
var $dWvpP = parcelRequire("dWvpP");

var $9G8Y4 = parcelRequire("9G8Y4");

var $5igKv = parcelRequire("5igKv");

var $1HyPS = parcelRequire("1HyPS");

var $3pIyL = parcelRequire("3pIyL");

var $ipkrC = parcelRequire("ipkrC");

var $foiPb = parcelRequire("foiPb");
const $acbd1a3b3c2f25d6$export$ee4884666be8e7c1 = (availableOptions, currentAccessType)=>{
    if (availableOptions && availableOptions.length && currentAccessType) {
        const curAccessType = currentAccessType;
        const selectedValues = availableOptions.find((type)=>curAccessType.value === type.value);
        if (selectedValues) return selectedValues;
        return currentAccessType;
    }
    return undefined;
};
const $acbd1a3b3c2f25d6$export$6a5e4b07bae0ce70 = (currentSelect)=>(currentSelect && currentSelect.value) !== (0, $99b47c2485002a11$export$1ec4bbf2f176ca6); // eslint-disable-next-line jira/react/no-class-components
class $acbd1a3b3c2f25d6$export$ad2a406fae0d83f8 extends (0, $eUqFw.Component) {
    static{
        // go/jfe-eslint
        // eslint-disable-next-line react/sort-comp
        this.defaultProps = {
            validateRequired: false,
            requiredAccess: false
        };
    }
    static getIcon(icon, _label = '', noColour = false) {
        const props = {
            label: '',
            size: (0, $foiPb.ICON_SIZE),
            primaryColor: noColour ? undefined : `var(--ds-icon-subtle, ${(0, $PdmhA).N100})`
        };
        switch(icon){
            case 'open':
                // @ts-expect-error - TS2322 - Type '{ size: string; label: string; primaryColor: string | undefined; }' is not assignable to type 'IntrinsicAttributes'.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5igKv.default), {
                    ...props,
                    size: "medium"
                });
            case 'limited':
                // @ts-expect-error - TS2769 - No overload matches this call.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4nce6))), props);
            case 'private':
                // @ts-expect-error - TS2769 - No overload matches this call.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f4A0J))), props);
            default:
                // @ts-expect-error - TS2769 - No overload matches this call.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4nce6))), props);
        }
    }
    UNSAFE_componentWillMount() {
        this.props.onWillMount();
    }
    componentDidUpdate(prevProps) {
        if (this.props.onError && this.props.hasFetchDataError) this.props.onError();
        if (this.props.onAccessTypesLoaded && prevProps.accessTypes.length === 0 && this.props.accessTypes.length > 0) this.props.onAccessTypesLoaded();
        if (this.props.currentAccessType && !prevProps.currentAccessType) this.props.onFirstChange(this.props.currentAccessType.value);
    }
    getDropdownMenu(currentSelect) {
        const { accessTypes: accessTypes, isLoading: isLoading, isDisabled: isDisabled, intl: { formatMessage: formatMessage }, dropdownWidthStyles: dropdownWidthStyles, currentAccessType: currentAccessType, validateRequired: validateRequired } = this.props;
        const { isOpen: isOpen } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
            testId: "project-access.field.dropdown-menu",
            trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($acbd1a3b3c2f25d6$var$TriggerButton, {
                    ...props,
                    shouldFitContainer: true,
                    iconBefore: currentSelect && currentSelect.displayName ? $acbd1a3b3c2f25d6$export$ad2a406fae0d83f8.getIcon(currentSelect.iconName, currentSelect.displayName, isOpen) : undefined,
                    iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                        label: "",
                        size: "medium"
                    }),
                    isDisabled: isDisabled,
                    isInvalid: !currentAccessType && validateRequired,
                    testId: "project-access.field.button-trigger",
                    "aria-expanded": isOpen ? 'true' : 'false',
                    ref: triggerRef
                }, currentSelect && currentSelect.displayName ? currentSelect.displayName : formatMessage((0, $3pIyL.default).projectAccessPlaceholder)),
            shouldFlip: true,
            onOpenChange: this.handleOpenChange,
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($acbd1a3b3c2f25d6$var$DropdownWrapper, {
            widthStyles: dropdownWidthStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, accessTypes.map((type)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
                onClick: ()=>this.props.onChange(type),
                key: type.value,
                shouldTitleWrap: true,
                shouldDescriptionWrap: true,
                elemBefore: $acbd1a3b3c2f25d6$export$ad2a406fae0d83f8.getIcon(type.iconName, type.displayName)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                "data-testid": "project-access.field.option"
            }, type.displayName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $foiPb.DescriptionField), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
                dangerouslySetInnerHTML: {
                    __html: type.description
                }
            })))))));
    }
    render() {
        const { intl: { formatMessage: formatMessage }, requiredAccess: requiredAccess, isLoading: isLoading, accessTypes: accessTypes } = this.props;
        const currentSelect = this.getSelected();
        if (currentSelect) this.setAccessForFreeEdition(currentSelect);
        return isLoading || accessTypes.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $foiPb.AccessWrapper), {
            "data-pollinator-access-level-picker": true,
            "data-testid": "project-access.field.wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
            name: "project-access-field",
            isRequired: $acbd1a3b3c2f25d6$export$6a5e4b07bae0ce70(currentSelect) ? requiredAccess : false,
            label: formatMessage((0, $3pIyL.default).projectAccessTitle)
        }, ()=>this.renderAccess(currentSelect))) : null;
    }
    constructor(...args){
        super(...args);
        this.state = {
            // This isOpen state doesn't control whether the dropdown is actually open.
            // The dropdown manages its own state.
            // This is only used to change styles depending on the dropdown's reported state.
            isOpen: false
        };
        this.getButtonTheme = (currentTheme, props)=>{
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            const { buttonStyles: buttonStyles, ...rest } = currentTheme(props);
            const { currentAccessType: currentAccessType, validateRequired: validateRequired } = this.props;
            return {
                ...rest,
                buttonStyles: {
                    ...buttonStyles,
                    border: !currentAccessType && validateRequired ? `2px solid ${`var(--ds-border-danger, ${(0, $PdmhA).R400})`}` : 'none',
                    textAlign: 'left',
                    lineHeight: '3em'
                }
            };
        };
        this.getButtonThemeOld = (currentTheme, props)=>{
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            const { buttonStyles: buttonStyles, ...rest } = currentTheme(props);
            const { currentAccessType: currentAccessType, validateRequired: validateRequired } = this.props;
            return {
                ...rest,
                buttonStyles: {
                    ...buttonStyles,
                    border: !currentAccessType && validateRequired ? `2px solid ${`var(--ds-border-danger, ${(0, $PdmhA).R400})`}` : 'none',
                    textAlign: 'left'
                }
            };
        };
        this.getSelected = ()=>{
            const { accessTypes: accessTypes, currentAccessType: currentAccessType } = this.props;
            return $acbd1a3b3c2f25d6$export$ee4884666be8e7c1(accessTypes, currentAccessType);
        };
        this.handleOpenChange = (data)=>{
            this.props.onOpenChange?.(data.isOpen);
            this.setState({
                isOpen: data.isOpen
            });
        } // changing currentSelect  to optional because in new design by default currentSelect is null
        ;
        this.renderAccess = (currentSelect)=>{
            const { DisabledAccessLevel: DisabledAccessLevel, isDisabled: isDisabled, intl: { formatMessage: formatMessage } } = this.props;
            let isDowngraded = false;
            if (!isDisabled) return this.getDropdownMenu(currentSelect);
             // Downgraded projects keep their original access level, but cannot be modified
            isDowngraded = $acbd1a3b3c2f25d6$export$6a5e4b07bae0ce70(currentSelect);
            if (isDowngraded) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
                sourceName: "projectDetails",
                sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
                content: formatMessage((0, $3pIyL.default).downgradedProjectAccessMessage),
                onShow: (event)=>{
                    (0, $jMP2a.fireUIAnalytics)(event, 'accessLevelFreeTier');
                }
            }, this.getDropdownMenu(currentSelect)));
             // Non-downgraded projects will display a special message.
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
                sourceName: "projectDetailsDisabledAccessLevel",
                sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DisabledAccessLevel, null));
        };
        this.setAccessForFreeEdition = (currentSelect)=>{
            if (!$acbd1a3b3c2f25d6$export$6a5e4b07bae0ce70(currentSelect)) this.props.onChange(currentSelect);
        };
    }
}
const $acbd1a3b3c2f25d6$var$mapStateToProps = (state)=>({
        accessTypes: (0, $9G8Y4.accessTypesSelector)(state),
        currentAccessType: (0, $9G8Y4.selectedAccessTypeSelector)(state),
        isLoading: (0, $9G8Y4.isLoadingSelector)(state),
        hasFetchDataError: (0, $9G8Y4.hasFetchDataErrorSelector)(state),
        DisabledAccessLevel: (0, $1HyPS.default)
    });
const $acbd1a3b3c2f25d6$var$mapDispatchToProps = (dispatch, ownProps)=>({
        onChange: (accessType)=>{
            dispatch((0, $l36Bx.setProjectAccessType)(accessType));
            ownProps.onChange?.(accessType.value);
        },
        onWillMount: ()=>{
            dispatch((0, $l36Bx.fetchProjectAccessTypes)());
            dispatch((0, $dWvpP.fetchProjectAccessValue)());
        }
    });
const $acbd1a3b3c2f25d6$export$7f0f405abc96160c = (0, $bAQOb.componentWithFF)('jwm-project-create-a11y-fixes_4bdwx', (0, $ipkrC.ProjectAccessSelect), $acbd1a3b3c2f25d6$export$ad2a406fae0d83f8);
var $acbd1a3b3c2f25d6$export$2e2bcd8739ae039 = (0, $bAQOb.componentWithFF)('jwm-project-create-a11y-fixes_4bdwx', // @ts-expect-error - Types of property 'onChange' are incompatible.
(0, $lNNXV.connect)($acbd1a3b3c2f25d6$var$mapStateToProps, $acbd1a3b3c2f25d6$var$mapDispatchToProps)((0, $ipkrC.ProjectAccessSelect)), // @ts-expect-error - Argument of type 'ComponentType<WithIntlProps<Pick<OwnProps & StateProps & DispatchProps & { readonly intl: IntlShapeV2; }, "onError" | "isLoading" | "onWillMount" | ... 10 more ... | "onOpenChange"> & InexactPartial<...> & InexactPartial<...>>>' is not assignable to parameter of type 'ComponentType<Matching<StateProps & DispatchProps, WithIntlProps<Pick<OwnProps & StateProps & DispatchProps & { readonly intl: IntlShapeV2; }, "onError" | ... 12 more ... | "onOpenChange"> & InexactPartial<...> & InexactPartial<...>>>>'. | Argument of type 'ComponentType<WithIntlProps<Pick<OwnProps & StateProps & DispatchProps & { readonly intl: IntlShapeV2; }, "isLoading" | "onChange" | "onError" | ... 10 more ... | "DisabledAccessLevel"> & InexactPartial<...> & InexactPartial<...>>>' is not assignable to parameter of type 'ComponentType<Matching<StateProps & DispatchProps, WithIntlProps<Pick<OwnProps & StateProps & DispatchProps & { readonly intl: IntlShapeV2; }, "isLoading" | ... 12 more ... | "DisabledAccessLevel"> & InexactPartial<...> & InexactPartial<...>>>>'.
(0, $lNNXV.connect)($acbd1a3b3c2f25d6$var$mapStateToProps, $acbd1a3b3c2f25d6$var$mapDispatchToProps)((0, $giAhk.injectIntlV2)($acbd1a3b3c2f25d6$export$ad2a406fae0d83f8)));
const $acbd1a3b3c2f25d6$var$TriggerButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_14741e5h _btpd1wou _ffi41wou",
            __cmplp.isInvalid ? "_1wgm14wz" : "_1wgmglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $acbd1a3b3c2f25d6$var$DropdownWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { widthStyles: widthStyles, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1lej1wc": (0, $9t7rW.default)(__cmplp.widthStyles?.width),
            "--_ejdses": (0, $9t7rW.default)(__cmplp.widthStyles?.minWidth),
            "--_8ssotj": (0, $9t7rW.default)(__cmplp.widthStyles?.maxWidth)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb4cf6 _1ul91eim _p12fcxt6",
            __cmplp.className
        ])
    });
});

});
parcelRegister("f4A0J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02d4f449435745cf$var$_react = $02d4f449435745cf$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $02d4f449435745cf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $02d4f449435745cf$var$LockFilledIcon = (props)=>/*#__PURE__*/ $02d4f449435745cf$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M8 10V8.002A4.004 4.004 0 0112 4a4 4 0 014 4.002V10a2 2 0 012 2v6c0 1.105-.902 2-2.009 2H8.01A2 2 0 016 18v-6c0-1.102.897-1.995 2-2zm2 0h4V8.002A2.001 2.001 0 0012 6c-1.102 0-2 .898-2 2.002V10zm2 7a2 2 0 100-4 2 2 0 000 4z"/></svg>`
    }, props));
$02d4f449435745cf$var$LockFilledIcon.displayName = 'LockFilledIcon';
var $02d4f449435745cf$var$_default = $02d4f449435745cf$var$LockFilledIcon;
module.exports.default = $02d4f449435745cf$var$_default;

});

parcelRegister("4nce6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $32f2cb577afb3a41$var$_react = $32f2cb577afb3a41$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $32f2cb577afb3a41$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $32f2cb577afb3a41$var$PeopleIcon = (props)=>/*#__PURE__*/ $32f2cb577afb3a41$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><circle cx="16" cy="9" r="3"/><circle cx="8" cy="6" r="3"/><path d="M11 15c0-1.105.887-2 2-2h6c1.105 0 2 .885 2 2v3.73c0 3.027-10 3.027-10 0V15z"/><path d="M13 12a1.997 1.997 0 00-2-2H5c-1.113 0-2 .897-2 2.003v3.826c0 1.921 4.054 2.518 7 1.984v-2.807A3.001 3.001 0 0112.997 12H13z"/></g></svg>`
    }, props));
$32f2cb577afb3a41$var$PeopleIcon.displayName = 'PeopleIcon';
var $32f2cb577afb3a41$var$_default = $32f2cb577afb3a41$var$PeopleIcon;
module.exports.default = $32f2cb577afb3a41$var$_default;

});

parcelRegister("dWvpP", function(module, exports) {

$parcel$export(module.exports, "FETCH_PROJECT_ACCESS_VALUE", () => $13e86f5854137efc$export$61afd572a049875b);
$parcel$export(module.exports, "fetchProjectAccessValue", () => $13e86f5854137efc$export$2b09592e03651134);
const $13e86f5854137efc$export$61afd572a049875b = 'FETCH_PROJECT_ACCESS_VALUE';
const $13e86f5854137efc$export$2b09592e03651134 = ()=>({
        type: $13e86f5854137efc$export$61afd572a049875b,
        payload: {}
    });

});

parcelRegister("9G8Y4", function(module, exports) {

$parcel$export(module.exports, "accessTypesSelector", () => $39477492afb1e77a$export$3483ba732c414c01);
$parcel$export(module.exports, "selectedAccessTypeSelector", () => $39477492afb1e77a$export$e033433627f6c68e);
$parcel$export(module.exports, "isLoadingSelector", () => $39477492afb1e77a$export$c077f23183070903);
$parcel$export(module.exports, "hasFetchDataErrorSelector", () => $39477492afb1e77a$export$6dcdf8b417c2e903);
$parcel$export(module.exports, "baseUrlSelector", () => $39477492afb1e77a$export$1ca9a92a5f28e233);
$parcel$export(module.exports, "cloudNameSelector", () => $39477492afb1e77a$export$1f478fa2146237b9);
$parcel$export(module.exports, "isSiteAdminSelector", () => $39477492afb1e77a$export$69b767f18b3bb094);
$parcel$export(module.exports, "projectIdSelector", () => $39477492afb1e77a$export$4c9d6034f65d22f4);
$parcel$export(module.exports, "projectTypeSelector", () => $39477492afb1e77a$export$69316f88206ca90b);
const $39477492afb1e77a$export$3483ba732c414c01 = (state)=>state.entities.accessTypes;
const $39477492afb1e77a$export$e033433627f6c68e = (state)=>state.ui.selectedAccessType;
const $39477492afb1e77a$export$c077f23183070903 = (state)=>state.ui.isLoading;
const $39477492afb1e77a$export$6dcdf8b417c2e903 = (state)=>state.ui.fetchDataError;
const $39477492afb1e77a$export$1ca9a92a5f28e233 = (state)=>state.context.baseUrl;
const $39477492afb1e77a$export$1f478fa2146237b9 = (state)=>state.context.cloudName;
const $39477492afb1e77a$export$69b767f18b3bb094 = (state)=>state.context.isSiteAdmin;
const $39477492afb1e77a$export$4c9d6034f65d22f4 = (state)=>state.context.projectId;
const $39477492afb1e77a$export$69316f88206ca90b = (state)=>state.context.projectType;

});

parcelRegister("5igKv", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b362a932fb26de8$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $8b362a932fb26de8$var$UnlockIconGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        viewBox: "0 0 24 24",
        focusable: "false",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12,4 C14.209139,4 16,5.79182182 16,8.00236948 C15.9507283,8.55323146 15.6232086,8.82866245 15.017441,8.82866245 C14.4116734,8.82866245 14.0725264,8.55323146 14,8.00236948 C14,6.89616855 13.1043465,6 12,6 C10.8982909,6 10,6.89812584 10,8.00236948 L10,10 L15.9914698,10 C17.1007504,10 18,10.8874333 18,11.999615 L18,18.000385 C18,19.1047419 17.0980496,20 15.9914698,20 L8.0085302,20 C6.8992496,20 6,19.1125667 6,18.000385 L6,11.999615 C6,10.8979354 6.89758257,10.0043419 8.00048596,10.0000158 L8,8.00236948 C8,5.79192185 9.79535615,4 12,4 Z M12,13 C10.8954305,13 10,13.8954305 10,15 C10,16.1045695 10.8954305,17 12,17 C13.1045695,17 14,16.1045695 14,15 C14,13.8954305 13.1045695,13 12,13 Z",
        id: "path-1"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "mask-2",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("use", {
        id: "Mask",
        fill: "#42526E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "Neutral-/-N500-AAA",
        mask: "url(#mask-2)",
        fill: "#7A869A"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("polygon", {
        id: "N500",
        points: "0 24 24 24 24 0 0 0"
    }))));
const $8b362a932fb26de8$var$UnlockIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        primaryColor: "var(--ds-icon-subtle, #7A869A)",
        glyph: $8b362a932fb26de8$var$UnlockIconGlyph,
        label: "",
        size: "medium"
    });
var $8b362a932fb26de8$export$2e2bcd8739ae039 = $8b362a932fb26de8$var$UnlockIcon;

});

parcelRegister("1HyPS", function(module, exports) {

$parcel$export(module.exports, "default", () => $038a868ec46d8ab0$export$2e2bcd8739ae039);

var $c8Guq = parcelRequire("c8Guq");

var $eGI9v = parcelRequire("eGI9v");
var $8un0w = parcelRequire("8un0w");

var $giAhk = parcelRequire("giAhk");

var $lNNXV = parcelRequire("lNNXV");

var $9G8Y4 = parcelRequire("9G8Y4");

var $7cnIa = parcelRequire("7cnIa");
var $038a868ec46d8ab0$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))((0, $giAhk.injectIntlV2), (0, $eGI9v.default)('link', {
    onUpgrade: 'clicked'
}), (0, $8un0w.default)({
    onUpgrade: 'projectAccessUpgrade'
}), (0, $lNNXV.connect)((state)=>({
        baseUrl: (0, $9G8Y4.baseUrlSelector)(state),
        cloudName: (0, $9G8Y4.cloudNameSelector)(state),
        isSiteAdmin: (0, $9G8Y4.isSiteAdminSelector)(state)
    }), {}))((0, $7cnIa.default));

});
parcelRegister("7cnIa", function(module, exports) {

$parcel$export(module.exports, "default", () => $385a39da2aee8c29$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8uD7Y = parcelRequire("8uD7Y");

var $34Adg = parcelRequire("34Adg");
const $385a39da2aee8c29$var$UPGRADE_URL = '/admin/billing/applications';
function $385a39da2aee8c29$export$2e2bcd8739ae039(props) {
    const { baseUrl: baseUrl, cloudName: cloudName, isSiteAdmin: isSiteAdmin, onUpgrade: onUpgrade, intl: { formatMessage: formatMessage } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($385a39da2aee8c29$var$DisabledMessage, null, isSiteAdmin ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $34Adg.default).disabledProjectAccessMessageSiteAdmin,
        values: {
            cloudName: cloudName,
            callToAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                href: baseUrl + $385a39da2aee8c29$var$UPGRADE_URL,
                target: "_blank",
                onClick: onUpgrade
            }, formatMessage((0, $34Adg.default).disabledProjectAccessMessageSiteAdminLink))
        }
    }) : formatMessage((0, $34Adg.default).disabledProjectAccessMessage, {
        cloudName: cloudName
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $385a39da2aee8c29$var$DisabledMessage = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1o15 _1wybw1gv _18u01b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("34Adg", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4db5229bae7c3b5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d4db5229bae7c3b5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    disabledProjectAccessMessage: {
        "id": "project-details.project-access.disabled-access-level.message",
        "defaultMessage": "Anyone with access to {cloudName} can access and administer this project. Upgrade your plan to customize project permissions."
    },
    disabledProjectAccessMessageSiteAdmin: {
        "id": "project-details.project-access.disabled-access-level.message.siteadmin",
        "defaultMessage": "Anyone with access to {cloudName} can access and administer this project. {callToAction} to customize project permissions."
    },
    disabledProjectAccessMessageSiteAdminLink: {
        "id": "project-details.project-access.disabled-access-level.message.siteadmin.link",
        "defaultMessage": "Upgrade your plan"
    }
});

});



parcelRegister("3pIyL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee65a60056e10978$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ee65a60056e10978$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    projectAccessTitle: {
        "id": "project-details.project-access-title",
        "defaultMessage": "Access"
    },
    downgradedProjectAccessMessage: {
        "id": "project-details.project-access.disabled.message",
        "defaultMessage": "Permissions aren't editable on the Free plan. Upgrade to customize project permissions."
    },
    projectAccessPlaceholder: {
        "id": "project-details.project-access-placeholder",
        "defaultMessage": "Choose an access level"
    }
});

});

parcelRegister("ipkrC", function(module, exports) {

$parcel$export(module.exports, "ProjectAccessSelect", () => $676c07284d3a3cf5$export$74f0ca6274d9e514);

var $eUqFw = parcelRequire("eUqFw");

var $4LhB6 = parcelRequire("4LhB6");

var $f4A0J = parcelRequire("f4A0J");

var $4nce6 = parcelRequire("4nce6");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $jQxSL = parcelRequire("jQxSL");
var $5wCDk = parcelRequire("5wCDk");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");


var $5igKv = parcelRequire("5igKv");

var $3pIyL = parcelRequire("3pIyL");

var $foiPb = parcelRequire("foiPb");
const $676c07284d3a3cf5$var$getIcon = (icon)=>{
    const props = {
        size: (0, $foiPb.ICON_SIZE),
        primaryColor: `var(--ds-icon-subtle, ${(0, $PdmhA).N100})`,
        label: ''
    };
    switch(icon){
        case 'open':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5igKv.default), null);
        case 'limited':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4nce6))), props);
        case 'private':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f4A0J))), props);
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4nce6))), props);
    }
};
const $676c07284d3a3cf5$export$b0c082086b5fac02 = ({ children: children, ...props })=>{
    const selectedOption = props.getValue();
    const selectedIcon = selectedOption && selectedOption[0] != null ? $676c07284d3a3cf5$var$getIcon(selectedOption[0].iconName) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Control, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignBlock: "center",
        testId: "project-access.field.option"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingInlineStart: "space.100"
    }, selectedIcon)), children);
};
const $676c07284d3a3cf5$export$bf9b4e708cea1760 = (props)=>{
    const { isDisabled: isDisabled, data: data } = props;
    const { description: description, iconName: iconName, displayName: displayName } = data;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        alignItems: "center",
        xcss: [
            isDisabled ? $676c07284d3a3cf5$var$optionWrapperDisabledStyles : $676c07284d3a3cf5$var$optionWrapperEnabledStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignInline: "start",
        testId: "project-access.field.option"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        gap: "space.050",
        alignItems: "center",
        xcss: $676c07284d3a3cf5$var$iconContainerStyles
    }, $676c07284d3a3cf5$var$getIcon(iconName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        xcss: $676c07284d3a3cf5$var$contentContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, displayName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $676c07284d3a3cf5$var$descriptionStyles
    }, description)))));
};
const $676c07284d3a3cf5$export$74f0ca6274d9e514 = ({ onChange: onChange, isDisabled: isDisabled, currentAccessType: currentAccessType, validateRequired: validateRequired, accessTypes: accessTypes, hasFetchDataError: hasFetchDataError, onError: onError, onAccessTypesLoaded: onAccessTypesLoaded, onFirstChange: onFirstChange, requiredAccess: requiredAccess, isLoading: isLoading, DisabledAccessLevel: DisabledAccessLevel, onWillMount: onWillMount, isOpen: isOpen })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const prevAccessTypes = (0, $eUqFw.useRef)(accessTypes);
    const prevAccessType = (0, $eUqFw.useRef)(undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $eUqFw.useEffect)(()=>onWillMount(), []);
    const accessTypeOptions = (0, $eUqFw.useMemo)(()=>accessTypes.map((accessType)=>({
                label: accessType.displayName,
                ...accessType
            })), [
        accessTypes
    ]);
    const selected = (0, $eUqFw.useMemo)(()=>{
        const value = accessTypes?.find((type)=>type.value === currentAccessType?.value);
        return value ? {
            label: value.displayName,
            ...value
        } : undefined;
    }, [
        accessTypes,
        currentAccessType
    ]);
    // Downgraded projects keep their original access level, but cannot be modified
    const initiallySelectedNotFree = (0, $eUqFw.useMemo)(()=>(selected && selected.value !== (0, $99b47c2485002a11$export$1ec4bbf2f176ca6)) ?? true, [
        selected
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (onError && hasFetchDataError) onError?.();
    }, [
        hasFetchDataError,
        onError
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (onAccessTypesLoaded && prevAccessTypes.current.length === 0 && accessTypes.length > 0) onAccessTypesLoaded();
        prevAccessTypes.current = accessTypes;
    }, [
        accessTypes,
        onAccessTypesLoaded,
        onError
    ]);
    // If the access type is set for the first time, call onFirstChange
    (0, $eUqFw.useEffect)(()=>{
        if (currentAccessType && !prevAccessType.current) onFirstChange(currentAccessType.value);
        prevAccessType.current = currentAccessType?.value;
    }, [
        currentAccessType,
        onFirstChange
    ]);
    // If a value is set, check if it's not free and call onChange
    (0, $eUqFw.useEffect)(()=>{
        if (!initiallySelectedNotFree && selected) onChange(selected);
    }, [
        initiallySelectedNotFree,
        onChange,
        selected
    ]);
    const renderField = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
            isDisabled: isDisabled,
            isLoading: isLoading,
            required: requiredAccess,
            isInvalid: !currentAccessType && validateRequired,
            options: accessTypeOptions,
            "aria-label": formatMessage((0, $3pIyL.default).projectAccessTitle),
            onChange: (option)=>{
                if (option?.value) onChange(option);
            },
            classNamePrefix: "project-access",
            value: selected,
            isSearchable: false,
            placeholder: formatMessage((0, $3pIyL.default).projectAccessPlaceholder),
            components: {
                Control: $676c07284d3a3cf5$export$b0c082086b5fac02,
                Option: $676c07284d3a3cf5$export$bf9b4e708cea1760
            },
            menuIsOpen: isOpen,
            testId: "project-access.field.select"
        });
    const renderDisabledFields = ()=>{
        // If the field is disabled and free selected, show a tooltip informing the user why this value is set.
        if (isDisabled && initiallySelectedNotFree) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            sourceName: "projectDetails",
            sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: formatMessage((0, $3pIyL.default).downgradedProjectAccessMessage),
            onShow: (event)=>{
                (0, $jMP2a.fireUIAnalytics)(event, 'accessLevelFreeTier');
            }
        }, renderField()));
        // If field is disabled and the selected access level is not free, show informational message.
        // if the access level is set and project is downgraded we want to preserve the existing
        // access level and inform the user why it can't be changed.
        if (isDisabled && !initiallySelectedNotFree) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            sourceName: "projectDetailsDisabledAccessLevel",
            sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DisabledAccessLevel, null));
        return renderField();
    };
    return isLoading || accessTypes.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $foiPb.AccessWrapper), {
        "data-pollinator-access-level-picker": true,
        "data-testid": "project-access.field.wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        name: "project-access-field",
        isRequired: initiallySelectedNotFree ? requiredAccess : false,
        label: formatMessage((0, $3pIyL.default).projectAccessTitle)
    }, ()=>renderDisabledFields())) : null;
};
const $676c07284d3a3cf5$var$optionWrapperEnabledStyles = (0, $1ZAYh.xcss)({
    opacity: 1,
    cursor: 'pointer'
});
const $676c07284d3a3cf5$var$optionWrapperDisabledStyles = (0, $1ZAYh.xcss)({
    opacity: 0.5,
    cursor: 'not-allowed'
});
const $676c07284d3a3cf5$var$iconContainerStyles = (0, $1ZAYh.xcss)({
    flexGrow: '0'
});
const $676c07284d3a3cf5$var$contentContainerStyles = (0, $1ZAYh.xcss)({
    flexGrow: '1',
    marginLeft: 'space.100',
    marginRight: 'space.200'
});
const $676c07284d3a3cf5$var$descriptionStyles = (0, $1ZAYh.xcss)({
    fontSize: '11px',
    lineHeight: "var(--ds-space-200, 16px)",
    marginTop: 'space.100',
    color: 'color.text.subtle'
});

});
parcelRegister("foiPb", function(module, exports) {

$parcel$export(module.exports, "AccessWrapper", () => $b1ef12484860828f$export$884ccef09eb49ca0);
$parcel$export(module.exports, "DescriptionField", () => $b1ef12484860828f$export$336230c809f2ec53);
$parcel$export(module.exports, "ICON_SIZE", () => $b1ef12484860828f$export$91a15f1424900d33);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $b1ef12484860828f$export$884ccef09eb49ca0 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1j89",
            __cmplp.className
        ])
    });
});
const $b1ef12484860828f$export$336230c809f2ec53 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1e9r _ca0qu2gc _1wybgm0b",
            __cmplp.className
        ])
    });
});
const $b1ef12484860828f$export$91a15f1424900d33 = 'medium';

});



parcelRegister("dqrQW", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $f4999b29821a6dbe$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "default", () => $f4999b29821a6dbe$export$2e2bcd8739ae039);
// @ts-expect-error - TS2724 - '"redux"' has no exported member named 'CombinedReducer'. Did you mean 'combineReducers'?

var $huRi7 = parcelRequire("huRi7");

var $jTavp = parcelRequire("jTavp");

var $7n2ze = parcelRequire("7n2ze");

var $hxAVG = parcelRequire("hxAVG");
const $f4999b29821a6dbe$export$d4c72bab9d6cc13a = {
    ui: (0, $hxAVG.defaultUiState),
    entities: (0, $jTavp.defaultState),
    context: (0, $7n2ze.defaultState)
};
const $f4999b29821a6dbe$var$reducerFunction = (0, $huRi7.combineReducers)({
    ui: (0, $hxAVG.default),
    entities: (0, $jTavp.default),
    context: (0, $7n2ze.default)
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f4999b29821a6dbe$export$2e2bcd8739ae039 = (state = $f4999b29821a6dbe$export$d4c72bab9d6cc13a, action)=>$f4999b29821a6dbe$var$reducerFunction(state, action);

});
parcelRegister("jTavp", function(module, exports) {

$parcel$export(module.exports, "defaultState", () => $b86dafd67d9977f2$export$49d5fc8cba920a0);
$parcel$export(module.exports, "default", () => $b86dafd67d9977f2$export$2e2bcd8739ae039);

const $b86dafd67d9977f2$export$49d5fc8cba920a0 = {
    accessTypes: []
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b86dafd67d9977f2$export$2e2bcd8739ae039 = (state = $b86dafd67d9977f2$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 0, $af1385d33e486b90$export$76564810767dbfb8:
            // @ts-expect-error - TS2339 - Property 'payload' does not exist on type 'Action'.
            return action.payload;
        default:
            return state;
    }
};

});

parcelRegister("7n2ze", function(module, exports) {

$parcel$export(module.exports, "defaultState", () => $af5aec1943ad98f7$export$49d5fc8cba920a0);
$parcel$export(module.exports, "default", () => $af5aec1943ad98f7$export$2e2bcd8739ae039);

var $6vrw7 = parcelRequire("6vrw7");

const $af5aec1943ad98f7$export$49d5fc8cba920a0 = {
    baseUrl: '',
    cloudName: (0, $6vrw7.toCloudName)(''),
    isDisabled: false,
    isSiteAdmin: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$af5aec1943ad98f7$export$2e2bcd8739ae039 = (state = $af5aec1943ad98f7$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case 0, $19154c8d94bf29b4$export$4bc4e62e7d72b94b:
            {
                const { baseUrl: baseUrl, cloudName: cloudName, isDisabled: isDisabled, isSiteAdmin: isSiteAdmin, projectId: projectId, projectType: projectType } = action.payload;
                const context = {
                    baseUrl: baseUrl,
                    cloudName: cloudName,
                    isDisabled: isDisabled,
                    isSiteAdmin: isSiteAdmin
                };
                if (projectId) context.projectId = projectId;
                if (projectType) context.projectType = projectType;
                return context;
            }
        default:
            return state;
    }
};

});

parcelRegister("hxAVG", function(module, exports) {

$parcel$export(module.exports, "defaultUiState", () => $60ce93d525e29e78$export$53eaea1501389f54);
$parcel$export(module.exports, "default", () => $60ce93d525e29e78$export$2e2bcd8739ae039);


const $60ce93d525e29e78$export$53eaea1501389f54 = {
    isLoading: false,
    fetchDataError: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$60ce93d525e29e78$export$2e2bcd8739ae039 = (state = $60ce93d525e29e78$export$53eaea1501389f54, action)=>{
    switch(action.type){
        case 0, $af1385d33e486b90$export$95adf3d79d20c12a:
            return {
                ...state,
                isLoading: true
            };
        case 0, $af1385d33e486b90$export$76564810767dbfb8:
            return {
                ...state,
                isLoading: false
            };
        case 0, $af1385d33e486b90$export$8ae8742e36d90493:
            if (// @ts-expect-error - TS2339 - Property 'payload' does not exist on type 'Action'.
            action.payload.accessType && (!state.selectedAccessType || // @ts-expect-error - TS2339 - Property 'payload' does not exist on type 'Action'.
            state.selectedAccessType.value !== action.payload.accessType.value)) // @ts-expect-error - TS2339 - Property 'payload' does not exist on type 'Action'.
            return {
                ...state,
                selectedAccessType: action.payload.accessType
            };
            return state;
        case 0, $af1385d33e486b90$export$1f51ae949b6d67a7:
            return {
                ...state,
                isLoading: false,
                fetchDataError: true
            };
        default:
            return state;
    }
};

});


parcelRegister("bwOiz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6494ca29a8c38ba6$export$2e2bcd8739ae039);

var $huRi7 = parcelRequire("huRi7");

var $bd1K7 = parcelRequire("bd1K7");

var $czGdf = parcelRequire("czGdf");

var $9RvH3 = parcelRequire("9RvH3");

var $dqrQW = parcelRequire("dqrQW");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6494ca29a8c38ba6$export$2e2bcd8739ae039 = (initialState)=>(0, $huRi7.createStore)((0, $dqrQW.default), initialState, (0, $czGdf.default)({
        name: 'Project Access'
    })((0, $huRi7.applyMiddleware)((0, $bd1K7.createEpicMiddleware)((0, $9RvH3.default)))));

});
parcelRegister("9RvH3", function(module, exports) {

$parcel$export(module.exports, "default", () => $2410ac4efcfa9938$export$2e2bcd8739ae039);

var $bd1K7 = parcelRequire("bd1K7");

var $hYhIl = parcelRequire("hYhIl");

var $d0hCW = parcelRequire("d0hCW");
var $2410ac4efcfa9938$export$2e2bcd8739ae039 = (0, $bd1K7.combineEpics)((0, $hYhIl.default), (0, $d0hCW.default));

});
parcelRegister("hYhIl", function(module, exports) {

$parcel$export(module.exports, "default", () => $20c4a6f581cb95f5$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("cpH8E");
parcelRequire("iects");
parcelRequire("1Lcr1");
parcelRequire("3wBUP");

var $3JafE = parcelRequire("3JafE");


var $9G8Y4 = parcelRequire("9G8Y4");

var $keemz = parcelRequire("keemz");

var $l36Bx = parcelRequire("l36Bx");

const $20c4a6f581cb95f5$var$epic = (action$, store)=>action$.ofType((0, $af1385d33e486b90$export$95adf3d79d20c12a)).switchMap(()=>{
        const state = store.getState();
        const baseUrl = (0, $9G8Y4.baseUrlSelector)(state);
        const projectId = (0, $9G8Y4.projectIdSelector)(state);
        const projectType = (0, $9G8Y4.projectTypeSelector)(state);
        const currentAccessType = (0, $9G8Y4.selectedAccessTypeSelector)(state);
        return (0, $3JafE.Observable).fromPromise((0, $keemz.default).getProjectAccessTypes({
            baseUrl: baseUrl,
            projectType: projectType
        })).flatMap((response)=>{
            if (projectId || currentAccessType) return (0, $3JafE.Observable).of((0, $l36Bx.fetchProjectAccessTypesSuccess)(response));
            const defaultAccessType = null;
            const setProjectAccessTypeAction = defaultAccessType ? (0, $l36Bx.setProjectAccessType)(defaultAccessType) : (0, $l36Bx.setProjectAccessType)(response.accessTypes.find((x)=>x.value === (0, $99b47c2485002a11$export$1ec4bbf2f176ca6)) || defaultAccessType);
            return (0, $3JafE.Observable).of((0, $l36Bx.fetchProjectAccessTypesSuccess)(response), // @ts-expect-error - TS2769 - No overload matches this call.
            setProjectAccessTypeAction);
        }).catch((e)=>(0, $3JafE.Observable).of((0, $l36Bx.fetchProjectAccessTypesFail)(e.message)));
    });
var $20c4a6f581cb95f5$export$2e2bcd8739ae039 = $20c4a6f581cb95f5$var$epic;

});
parcelRegister("keemz", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f8dfb17b6b3401b$export$2e2bcd8739ae039);

var $53ciZ = parcelRequire("53ciZ");

var $lRmyA = parcelRequire("lRmyA");

var $ft7kU = parcelRequire("ft7kU");
const $2f8dfb17b6b3401b$export$77d9d8ce6f7585ab = ({ baseUrl: baseUrl, projectType: projectType })=>`${baseUrl}/rest/internal/simplified/1.0/accesslevel?${(0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify({
        projectType: projectType
    })}`;
const $2f8dfb17b6b3401b$export$a762a9796d0c5d6d = (context)=>`${$2f8dfb17b6b3401b$export$77d9d8ce6f7585ab(context)}/project/${context.projectId || ''}`;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2f8dfb17b6b3401b$var$toProjectAccessTypesResponse = (json)=>({
        accessTypes: json
    });
const $2f8dfb17b6b3401b$var$projectAccessTypesService = {
    getProjectAccessTypes: (context)=>(0, $ft7kU.default)((0, $lRmyA.performGetRequest)($2f8dfb17b6b3401b$export$77d9d8ce6f7585ab(context)), 'Failed to fetch access types for a project').then($2f8dfb17b6b3401b$var$toProjectAccessTypesResponse),
    updateProjectAccessType: (context, accessLevel)=>(0, $ft7kU.default)((0, $lRmyA.performPutRequest)($2f8dfb17b6b3401b$export$a762a9796d0c5d6d(context), {
            body: JSON.stringify({
                accessLevel: accessLevel
            })
        }), 'Failed to update access types for a project')
};
var $2f8dfb17b6b3401b$export$2e2bcd8739ae039 = $2f8dfb17b6b3401b$var$projectAccessTypesService;

});
parcelRegister("ft7kU", function(module, exports) {

$parcel$export(module.exports, "famaCatchAndLogFetchError", () => $9e0e185518348035$export$c3948fffb56ff7bb);
$parcel$export(module.exports, "default", () => $9e0e185518348035$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $7byHA = parcelRequire("7byHA");

var $avawr = parcelRequire("avawr");
const $9e0e185518348035$var$HTTP_LOCATION = 'project-settings-apps.http.catch-and-log-fetch-error';
const $9e0e185518348035$var$getStatusCodeGroup = (error)=>{
    if (error instanceof (0, $7byHA.default)) {
        const { statusCode: statusCode } = error;
        if (statusCode >= 100 && statusCode <= 199) return '1xx';
        if (statusCode >= 300 && statusCode <= 399) return '3xx';
        if (statusCode >= 400 && statusCode <= 499) return '4xx';
        if (statusCode >= 500 && statusCode <= 599) return '5xx';
    }
    if (error instanceof (0, $7byHA.ValidationError)) return '4xx';
    return 'unknown';
};
/**
 * All fetch calls made in project-settings should be wrapped by this method to ensure HTTP related errors can be
 * separated from JS errors in Splunk. The promise provided to this method MUST NOT perform any logic beside making
 * the fetch call (i.e. transforming responses). The caught error will be rethrown so any downstream methods can perform
 * their own error handling.
 *
 * @param promise Promise to wrap so any errors are caught and logged.
 * @param message Message to include in the log. This should provide context as to what action the user was taking.
 */ const $9e0e185518348035$var$catchAndLogFetchError = (promise, message)=>promise.catch((error)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData($9e0e185518348035$var$HTTP_LOCATION, message, error);
        throw error;
    });
const $9e0e185518348035$export$c3948fffb56ff7bb = (promise, packageName, errorId, message)=>promise.catch((error)=>{
        const statusCodeGroup = $9e0e185518348035$var$getStatusCodeGroup(error);
        (0, $avawr.logError)(packageName, errorId, message, error, {
            http: true,
            statusCodeGroup: statusCodeGroup
        });
        throw error;
    });
var $9e0e185518348035$export$2e2bcd8739ae039 = $9e0e185518348035$var$catchAndLogFetchError;

});



parcelRegister("d0hCW", function(module, exports) {

$parcel$export(module.exports, "default", () => $a500de986bf3bb50$export$2e2bcd8739ae039);
parcelRequire("jyKN9");
parcelRequire("cpH8E");
parcelRequire("8jBvP");
parcelRequire("flmol");
parcelRequire("1Lcr1");
parcelRequire("3wBUP");

var $3JafE = parcelRequire("3JafE");

var $9G8Y4 = parcelRequire("9G8Y4");

var $bFsiV = parcelRequire("bFsiV");

var $l36Bx = parcelRequire("l36Bx");

var $dWvpP = parcelRequire("dWvpP");
const $a500de986bf3bb50$var$epic = (action$, store)=>action$.ofType((0, $dWvpP.FETCH_PROJECT_ACCESS_VALUE)).switchMap(()=>{
        const state = store.getState();
        const baseUrl = (0, $9G8Y4.baseUrlSelector)(state);
        const projectId = (0, $9G8Y4.projectIdSelector)(state);
        const currentAccessType = (0, $9G8Y4.selectedAccessTypeSelector)(state);
        if (!projectId || currentAccessType) return (0, $3JafE.Observable).empty();
        return (0, $3JafE.Observable).fromPromise((0, $bFsiV.default).getProjectAccessValue(baseUrl, projectId)).map((response)=>(0, $l36Bx.setProjectAccessType)({
                value: response.value,
                description: response.description,
                displayName: response.displayName,
                iconName: response.iconName
            })).catch((e)=>(0, $3JafE.Observable).of((0, $l36Bx.fetchProjectAccessTypesFail)(e.message)));
    });
var $a500de986bf3bb50$export$2e2bcd8739ae039 = $a500de986bf3bb50$var$epic;

});
parcelRegister("bFsiV", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdc2eafc6cd0e88c$export$2e2bcd8739ae039);

var $lRmyA = parcelRequire("lRmyA");

var $ft7kU = parcelRequire("ft7kU");
const $fdc2eafc6cd0e88c$export$5cc4b52384516701 = (baseUrl, projectId)=>`${baseUrl}/rest/internal/simplified/1.0/accesslevel/project/${String(projectId)}`;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $fdc2eafc6cd0e88c$var$toProjectAccessValue = (json)=>json;
const $fdc2eafc6cd0e88c$var$projectAccessValueService = {
    getProjectAccessValue: (baseUrl, projectId)=>(0, $ft7kU.default)((0, $lRmyA.performGetRequest)($fdc2eafc6cd0e88c$export$5cc4b52384516701(baseUrl, projectId)), 'Failed to fetch project access level').then($fdc2eafc6cd0e88c$var$toProjectAccessValue)
};
var $fdc2eafc6cd0e88c$export$2e2bcd8739ae039 = $fdc2eafc6cd0e88c$var$projectAccessValueService;

});






parcelRegister("4saTO", function(module, exports) {
module.exports = new URL("CompanyManaged.a932409f.svg", import.meta.url).toString();

});

parcelRegister("2flcE", function(module, exports) {
module.exports = new URL("TeamManaged.e1ae20b8.svg", import.meta.url).toString();

});

parcelRegister("7xgPi", function(module, exports) {

$parcel$export(module.exports, "default", () => $4445aa9b29ec4abc$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4445aa9b29ec4abc$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    moreOptions: {
        "id": "project-create-importer-upload-flow.project-create-screen.new-project-create-more-options.more-options",
        "defaultMessage": "Show more"
    },
    hideMoreOptions: {
        "id": "project-create-importer-upload-flow.project-create-screen.new-project-create-more-options.hide-more-options",
        "defaultMessage": "Hide more"
    },
    projectType: {
        "id": "project-create-importer-upload-flow.project-create-screen.new-project-create-more-options.project-type",
        "defaultMessage": "Project type"
    },
    companyManagedLabel: {
        "id": "project-create-importer-upload-flow.project-create-screen.new-project-create-more-options.company-managed-label",
        "defaultMessage": "Company-managed"
    },
    teamManagedLabel: {
        "id": "project-create-importer-upload-flow.project-create-screen.new-project-create-more-options.team-managed-label",
        "defaultMessage": "Team-managed"
    },
    adminOnlyLozenge: {
        "id": "project-create-importer-upload-flow.project-create-screen.new-project-create-more-options.admin-only-lozenge",
        "defaultMessage": "Administrators only"
    },
    companyManagedDescription: {
        "id": "project-create-importer-upload-flow.project-create-screen.new-project-create-more-options.company-managed-description",
        "defaultMessage": "For teams who work with others across many projects in a standard way that\u2019s set by your Jira admins. Encourage and promote organizational best practices through shared configuration."
    },
    teamManagedDescription: {
        "id": "project-create-importer-upload-flow.project-create-screen.new-project-create-more-options.team-managed-description",
        "defaultMessage": "For teams who want to control their own working processes and practices in a self-contained space. The configuration is simpler and gives project admins more control over set up without involving a Jira admin. Settings do not impact other projects."
    },
    cannotCreateCompanyManagedProjectTooltipMessage: {
        "id": "project-create-importer-upload-flow.project-create-screen.new-project-create-more-options.cannot-create-company-managed-project-tooltip-message",
        "defaultMessage": "Only your Jira admin can create company-managed projects. Contact them for assistance."
    },
    cannotCreateTeamManagedProjectTooltipMessage: {
        "id": "project-create-importer-upload-flow.project-create-screen.new-project-create-more-options.cannot-create-team-managed-project-tooltip-message",
        "defaultMessage": "We currently don't support Team Managed Projects"
    },
    contactAdminCta: {
        "id": "project-create-importer-upload-flow.project-create-screen.new-project-create-more-options.contact-admin-cta",
        "defaultMessage": "Contact admin"
    }
});

});


parcelRegister("iR23m", function(module, exports) {

$parcel$export(module.exports, "ProjectCreateStats", () => $88de56a17c10df5f$export$4970832a1711e2d5);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $eI5EY = parcelRequire("eI5EY");

var $3ak5x = parcelRequire("3ak5x");

var $cDLTA = parcelRequire("cDLTA");

var $irKna = parcelRequire("irKna");

var $bwCxW = parcelRequire("bwCxW");
const $88de56a17c10df5f$export$4970832a1711e2d5 = ({ thirdParty: thirdParty })=>{
    const [{ entityStats: entityStats, userEmails: userEmails }] = (0, $irKna.useThirdPartyState)();
    const { cardStatsShort: cardStatsShort, usersStatsShort: usersStatsShort } = (0, $cDLTA.useContentForThirdParty)(thirdParty);
    if (thirdParty !== (0, $3ak5x.TRELLO) && thirdParty !== (0, $3ak5x.MONDAY)) return null;
    const tasks = (0, $eI5EY.fg)('jwm_clickup_importer') ? entityStats?.tasksCount : entityStats?.tasks;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($88de56a17c10df5f$var$Wrapper, {
        "data-testid": "project-create-importer-upload-flow.ui.project-create-screen.project-create-stats.wrapper"
    }, entityStats?.members != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bwCxW.Card), {
        cardContent: usersStatsShort,
        statistic: thirdParty === (0, $3ak5x.TRELLO) ? Object.keys(userEmails).length : entityStats.members
    }), tasks != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bwCxW.Card), {
        cardContent: cardStatsShort,
        statistic: tasks
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $88de56a17c10df5f$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _18s8yb19",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bwCxW", function(module, exports) {

$parcel$export(module.exports, "Card", () => $f668902460344716$export$60332b2344f7fe41);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5JgJ2 = parcelRequire("5JgJ2");
const $f668902460344716$export$60332b2344f7fe41 = ({ cardContent: cardContent, statistic: statistic })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f668902460344716$var$ContentWrapper, null, formatMessage(cardContent, {
        statistic: statistic,
        description: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f668902460344716$var$Description, null, chunks),
        header: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f668902460344716$var$Header, null, chunks),
        stats: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f668902460344716$var$Statistic, null, chunks)
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f668902460344716$var$ContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1y6m _2rkoftgi _1bsb1osq _19it1l7n _bfhkvuon _19pkze3t _1yt4pxbi _1reo15vq _1bto1l2s _o5721q9c _5s3b1b66",
            __cmplp.className
        ])
    });
});
const $f668902460344716$var$Statistic = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48pbfng _1wyb1tcg _vwz41f4h _1bsb1osq _1reo15vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f668902460344716$var$Header = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _k48pni7l _1wyb1crf _vwz47vkz _syaz1a45 _19pk1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f668902460344716$var$Description = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _19pk1b66 _k48p1nn1 _1wyb1skh _vwz4dlk8 _syaz1a45",
            __cmplp.className
        ])
    });
});

});


parcelRegister("qDXwM", function(module, exports) {

$parcel$export(module.exports, "ProjectKeyField", () => $3e555cd4a2aad952$export$ac2c85b29f218922);

var $eUqFw = parcelRequire("eUqFw");

var $7jPhn = parcelRequire("7jPhn");
var $4LhB6 = parcelRequire("4LhB6");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $cf2Y4 = parcelRequire("cf2Y4");

var $5JgJ2 = parcelRequire("5JgJ2");

var $9R4E5 = parcelRequire("9R4E5");

var $2nryu = parcelRequire("2nryu");

var $27MZP = parcelRequire("27MZP");
const $3e555cd4a2aad952$export$ac2c85b29f218922 = ({ projectKey: projectKey, onProjectKeyChange: onProjectKeyChange, projectKeyValidationError: projectKeyValidationError })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const projectKeyFieldLabel = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $3e555cd4a2aad952$var$labelWrapperStyle,
            testId: "project-create-importer-upload-flow.ui.project-create-screen.project-key-field.label-wrapper"
        }, formatMessage((0, $27MZP.default).projectKey), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2nryu.InfoButton), {
            description: formatMessage((0, $27MZP.default).projectKeyDescription, {
                link: (content)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                        href: (0, $9R4E5.PROJECT_KEY_LEARN_MORE_LINK),
                        target: "_blank"
                    }, content)
            })
        })), [
        formatMessage
    ]);
    const onChange = (0, $eUqFw.useCallback)((e)=>{
        const newKeyValue = e.target.value ? e.target.value.toUpperCase() : e.target.value;
        onProjectKeyChange(newKeyValue);
    }, [
        onProjectKeyChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $3e555cd4a2aad952$var$projectKeyWrapperStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        label: projectKeyFieldLabel,
        name: "key"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
            testId: "project-create-importer-upload-flow.ui.project-create-screen.project-key-field.project-key-field",
            ...fieldProps,
            value: projectKey,
            onChange: onChange
        }), projectKeyValidationError !== '' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, projectKeyValidationError))));
};
const $3e555cd4a2aad952$var$projectKeyWrapperStyle = (0, $1ZAYh.xcss)({
    width: '168px'
});
const $3e555cd4a2aad952$var$labelWrapperStyle = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    columnGap: 'space.050'
});

});
parcelRegister("27MZP", function(module, exports) {

$parcel$export(module.exports, "default", () => $7602582986d1e474$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7602582986d1e474$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    projectKey: {
        "id": "project-create-importer-upload-flow.project-create-screen.project-key-field.project-key",
        "defaultMessage": "Key"
    },
    projectKeyDescription: {
        "id": "project-create-importer-upload-flow.project-create-screen.project-key-field.project-key-description",
        "defaultMessage": "Choose a descriptive prefix for your project\u2019s issue keys to recognize work from this project. <link>Learn more</link>"
    }
});

});


parcelRegister("iKNKJ", function(module, exports) {

$parcel$export(module.exports, "ProjectTypeSelector", () => $cd04b24742a3efac$export$2186258e1d5d74cb);

var $eUqFw = parcelRequire("eUqFw");

var $4LhB6 = parcelRequire("4LhB6");

var $ffiyv = parcelRequire("ffiyv");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $jQxSL = parcelRequire("jQxSL");
var $5wCDk = parcelRequire("5wCDk");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kzTj7 = parcelRequire("kzTj7");

var $eYjP0 = parcelRequire("eYjP0");

var $lUC5l = parcelRequire("lUC5l");
var $d0wrd = parcelRequire("d0wrd");
var $irKna = parcelRequire("irKna");

var $jlvJi = parcelRequire("jlvJi");
const $cd04b24742a3efac$var$CustomOption = (props)=>{
    const { label: label, description: description } = props.data;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, label, description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "p",
        xcss: $cd04b24742a3efac$var$descriptionWrapperStyles
    }, description)));
};
const $cd04b24742a3efac$export$2186258e1d5d74cb = ({ projectSetting: projectSetting })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [mappingState, { setMappingState: setMappingState }] = (0, $lUC5l.useMappingState)();
    const [{ thirdPartyFieldConfigState: thirdPartyFieldConfigState }, { setThirdPartyState: setThirdPartyState }] = (0, $irKna.useThirdPartyState)();
    const [{ type: type }, { setProjectData: setProjectData }] = (0, $d0wrd.useProjectData)();
    const options = (0, $eUqFw.useMemo)(()=>{
        const jiraProjects = (0, $eYjP0.getJiraProjects)();
        return projectSetting.map((item)=>{
            const jiraProject = jiraProjects[item.productType];
            if (jiraProject) return {
                value: item.productType,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                    xcss: $cd04b24742a3efac$var$contentWrapperStyles
                }, jiraProject.icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                    paddingInlineStart: "space.100",
                    xcss: $cd04b24742a3efac$var$titleWrapperStyles
                }, formatMessage(jiraProject.name), item.isRecommended && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                    as: "span",
                    paddingInlineStart: "space.100"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
                    appearance: "new"
                }, formatMessage((0, $jlvJi.default).recommend))))),
                description: jiraProject.description ? formatMessage(jiraProject.description) : undefined,
                isRecommended: item.isRecommended
            };
            return {
                value: item.productType,
                label: item.productType,
                isRecommended: item.isRecommended
            };
        });
    }, [
        formatMessage,
        projectSetting
    ]);
    const onSetProjectType = (0, $eUqFw.useCallback)((projectType)=>{
        setProjectData({
            type: projectType,
            template: null,
            style: null,
            accessLevel: null
        });
    }, [
        setProjectData
    ]);
    const defaultProjectType = (0, $eUqFw.useMemo)(()=>options.find(({ isRecommended: isRecommended })=>isRecommended) || options[0], [
        options
    ]);
    const selectedProjectType = (0, $eUqFw.useMemo)(()=>options.find(({ value: value })=>value === type), [
        options,
        type
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!selectedProjectType && defaultProjectType) onSetProjectType(defaultProjectType.value);
    }, [
        defaultProjectType,
        onSetProjectType,
        selectedProjectType,
        type
    ]);
    const onChange = (0, $eUqFw.useCallback)((option)=>{
        if (!option?.value) return;
        // Reset field mapping state if change the project type
        if (mappingState !== null) setMappingState(null);
        if (thirdPartyFieldConfigState !== null) setThirdPartyState({
            thirdPartyFieldConfigState: null
        });
        onSetProjectType(option.value);
    }, [
        mappingState,
        onSetProjectType,
        setMappingState,
        setThirdPartyState,
        thirdPartyFieldConfigState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        label: formatMessage((0, $jlvJi.default).label),
        name: formatMessage((0, $jlvJi.default).label),
        testId: "project-create-importer-upload-flow.ui.project-create-screen.project-type-selector.field"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
            ...fieldProps,
            inputId: (0, $kzTj7.PROJECT_TYPE_DROPDOWN_ID),
            name: (0, $kzTj7.PROJECT_TYPE_DROPDOWN_ID),
            options: options,
            value: selectedProjectType,
            onChange: onChange,
            "aria-label": formatMessage((0, $jlvJi.default).label),
            components: {
                Option: $cd04b24742a3efac$var$CustomOption
            }
        }));
};
const $cd04b24742a3efac$var$contentWrapperStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center'
});
const $cd04b24742a3efac$var$titleWrapperStyles = (0, $1ZAYh.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $cd04b24742a3efac$var$descriptionWrapperStyles = (0, $1ZAYh.xcss)({
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    marginTop: 'space.100',
    paddingLeft: 'space.400',
    marginBottom: 'space.100',
    color: 'color.text.subtlest'
});

});
parcelRegister("jlvJi", function(module, exports) {

$parcel$export(module.exports, "default", () => $c34a48d84a463ce2$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c34a48d84a463ce2$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "project-create-importer-upload-flow.project-create-screen.project-type-selector.label",
        "defaultMessage": "Jira project"
    },
    recommend: {
        "id": "project-create-importer-upload-flow.project-create-screen.project-type-selector.recommend",
        "defaultMessage": "RECOMMENDED"
    }
});

});


parcelRegister("4aIBV", function(module, exports) {

$parcel$export(module.exports, "TemplateSelector", () => $8838b04868969989$export$8493763e5072e8ef);

var $eUqFw = parcelRequire("eUqFw");

var $4LhB6 = parcelRequire("4LhB6");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5wCDk = parcelRequire("5wCDk");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kzTj7 = parcelRequire("kzTj7");

var $d0wrd = parcelRequire("d0wrd");

var $mtwgG = parcelRequire("mtwgG");
const $8838b04868969989$export$8493763e5072e8ef = ({ templates: templates })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ template: template }, { setProjectData: setProjectData }] = (0, $d0wrd.useProjectData)();
    const options = (0, $eUqFw.useMemo)(()=>templates.map((item)=>({
                value: item.key,
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                    xcss: $8838b04868969989$var$contentWrapperStyles
                }, item.icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                    paddingInlineStart: "space.100",
                    xcss: $8838b04868969989$var$titleWrapperStyles
                }, formatMessage(item.title))),
                isDefault: item.isDefault
            })), [
        formatMessage,
        templates
    ]);
    const defaultTemplate = (0, $eUqFw.useMemo)(()=>options.find(({ isDefault: isDefault })=>isDefault) || options[0], [
        options
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!template && defaultTemplate) setProjectData({
            template: defaultTemplate.value
        });
    }, [
        defaultTemplate,
        setProjectData,
        template
    ]);
    const selectedTemplate = (0, $eUqFw.useMemo)(()=>options.find(({ value: value })=>value === template), [
        options,
        template
    ]);
    const onChangeTemplateClick = (0, $eUqFw.useCallback)((selectedItem)=>{
        if (!selectedItem?.value) return;
        setProjectData({
            template: selectedItem.value
        });
    }, [
        setProjectData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        label: formatMessage((0, $mtwgG.default).label),
        name: formatMessage((0, $mtwgG.default).label),
        testId: "project-create-importer-upload-flow.ui.project-create-screen.template-selector.field"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
            ...fieldProps,
            inputId: (0, $kzTj7.PROJECT_TEMPLATE_DROPDOWN_ID),
            name: (0, $kzTj7.PROJECT_TEMPLATE_DROPDOWN_ID),
            options: options,
            value: selectedTemplate,
            onChange: onChangeTemplateClick,
            "aria-label": formatMessage((0, $mtwgG.default).label)
        }));
};
const $8838b04868969989$var$contentWrapperStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center'
});
const $8838b04868969989$var$titleWrapperStyles = (0, $1ZAYh.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});

});
parcelRegister("mtwgG", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9fc161aa7c834b9$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b9fc161aa7c834b9$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "project-create-importer-upload-flow.project-create-screen.template-selector.label",
        "defaultMessage": "Template"
    }
});

});



parcelRegister("h0OrD", function(module, exports) {

$parcel$export(module.exports, "ProjectCreateMoreOptions", () => $3af3ffba43119197$export$2b36b12d2f0a6d30);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7jPhn = parcelRequire("7jPhn");
var $4LhB6 = parcelRequire("4LhB6");

var $9nt1B = parcelRequire("9nt1B");

var $ffiyv = parcelRequire("ffiyv");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $jQxSL = parcelRequire("jQxSL");
var $5wCDk = parcelRequire("5wCDk");

var $cf2Y4 = parcelRequire("cf2Y4");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $7eqzD = parcelRequire("7eqzD");

var $1ybV0 = parcelRequire("1ybV0");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $6ouuo = parcelRequire("6ouuo");

var $gd0Sp = parcelRequire("gd0Sp");

var $4saTO = parcelRequire("4saTO");

var $2flcE = parcelRequire("2flcE");

var $kzTj7 = parcelRequire("kzTj7");

var $9R4E5 = parcelRequire("9R4E5");

var $1WR91 = parcelRequire("1WR91");

var $2nryu = parcelRequire("2nryu");

var $bz2yd = parcelRequire("bz2yd");

var $lUC5l = parcelRequire("lUC5l");
var $d0wrd = parcelRequire("d0wrd");
var $irKna = parcelRequire("irKna");

var $2sRUp = parcelRequire("2sRUp");

var $cIv88 = parcelRequire("cIv88");
const $3af3ffba43119197$var$dropdownWidthStyles = {
    minWidth: '400px',
    maxWidth: '528px'
};
const $3af3ffba43119197$var$CustomOption = (props)=>{
    const { isDisabled: isDisabled, label: label, lozengeContent: lozengeContent, description: description, icon: icon, disabledTooltipContent: disabledTooltipContent, disabledContent: disabledContent } = props.data;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eqzD.ConditionalWrapper), {
        condition: isDisabled,
        renderWrapper: (children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
                content: disabledTooltipContent || ''
            }, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3af3ffba43119197$var$OptionWrapper, {
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $3af3ffba43119197$var$iconWrapperStyles
    }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $3af3ffba43119197$var$contentWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3af3ffba43119197$var$TitleWrapper, null, label, lozengeContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3af3ffba43119197$var$LozengeWrapper, null, lozengeContent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3af3ffba43119197$var$DescriptionWrapper, null, description)), props.isSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9nt1B))), {
        primaryColor: `var(--ds-icon-information, ${(0, $PdmhA).B200})`,
        label: ""
    }))), isDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3af3ffba43119197$var$DisabledContentWrapper, null, disabledContent));
};
const $3af3ffba43119197$var$CustomControl = ({ children: children, ...props })=>{
    const selectedOption = props.getValue();
    const selectedIcon = selectedOption && selectedOption[0] != null ? selectedOption[0].icon : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Control, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3af3ffba43119197$var$IconControlWrapper, null, selectedIcon), children);
}; // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $3af3ffba43119197$var$noop = ()=>{};
const $3af3ffba43119197$export$2b36b12d2f0a6d30 = ({ projectKey: projectKey, onProjectKeyChange: onProjectKeyChange, projectKeyValidationError: projectKeyValidationError, isTMPSupported: isTMPSupported, isPermissionGated: isPermissionGated, defaultProjectAccess: defaultProjectAccess, disableProjectStyle: disableProjectStyle })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [mappingState, { setMappingState: setMappingState }] = (0, $lUC5l.useMappingState)();
    const [{ thirdPartyFieldConfigState: thirdPartyFieldConfigState }, { setThirdPartyState: setThirdPartyState }] = (0, $irKna.useThirdPartyState)();
    const [{ type: type, accessLevel: accessLevel, style: style }, { setProjectData: setProjectData }] = (0, $d0wrd.useProjectData)();
    const { isSiteAdmin: isSiteAdmin } = (0, $gd0Sp.useTenantContext)();
    const [source] = (0, $2sRUp.useSource)();
    const { projectCreateMoreOptions: projectCreateMoreOptions, projectCreateHideMoreOptions: projectCreateHideMoreOptions } = (0, $bz2yd.useProjectSpecificContent)(type, source);
    const companyManagedOption = (0, $eUqFw.useMemo)(()=>({
            label: formatMessage((0, $cIv88.default).companyManagedLabel),
            value: (0, $9R4E5.ProjectStyles).COMPANY_MANAGED_PROJECT,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3af3ffba43119197$var$Image, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($4saTO))),
                "aria-label": "company managed",
                role: "img",
                alt: ""
            }),
            lozengeContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
                appearance: "inprogress"
            }, formatMessage((0, $cIv88.default).adminOnlyLozenge)),
            description: formatMessage((0, $cIv88.default).companyManagedDescription),
            disabledContent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                target: "_blank",
                href: (0, $kzTj7.CONTACT_ADMIN_LINK)
            }, formatMessage((0, $cIv88.default).contactAdminCta)),
            disabledTooltipContent: formatMessage((0, $cIv88.default).cannotCreateCompanyManagedProjectTooltipMessage),
            isDisabled: (0, $1ybV0.ff)('gun-2207-non-admin-support-in-tmp-migration_k7z9p') ? !isSiteAdmin : false
        }), [
        formatMessage,
        isSiteAdmin
    ]);
    const teamManagedOption = (0, $eUqFw.useMemo)(()=>({
            label: formatMessage((0, $cIv88.default).teamManagedLabel),
            value: (0, $9R4E5.ProjectStyles).TEAM_MANAGED_PROJECT,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3af3ffba43119197$var$Image, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($2flcE))),
                "aria-label": "team managed",
                role: "img",
                alt: ""
            }),
            lozengeContent: null,
            description: formatMessage((0, $cIv88.default).teamManagedDescription),
            disabledContent: null,
            disabledTooltipContent: formatMessage((0, $cIv88.default).cannotCreateTeamManagedProjectTooltipMessage),
            isDisabled: !isTMPSupported
        }), [
        formatMessage,
        isTMPSupported
    ]);
    const OPTIONS = (0, $eUqFw.useMemo)(()=>[
            teamManagedOption,
            companyManagedOption
        ], [
        companyManagedOption,
        teamManagedOption
    ]);
    const valueForProjectStyle = (0, $eUqFw.useMemo)(()=>OPTIONS.find((item)=>item.value === style), [
        OPTIONS,
        style
    ]);
    const showProjectAccessField = isTMPSupported && valueForProjectStyle?.value === (0, $9R4E5.ProjectStyles).TEAM_MANAGED_PROJECT;
    const projectKeyFieldLabel = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3af3ffba43119197$var$LabelWrapper, {
            "data-testid": "project-create-importer-upload-flow.ui.project-create-screen.project-create-more-options.label-wrapper"
        }, formatMessage((0, $cIv88.default).projectKey), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2nryu.InfoButton), {
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                values: {
                    learnMoreLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                        href: (0, $9R4E5.PROJECT_KEY_LEARN_MORE_LINK),
                        target: "_blank"
                    }, formatMessage((0, $cIv88.default).learnMoreProjectKey))
                },
                ...(0, $cIv88.default).projectKeyDescription
            })
        })), [
        formatMessage
    ]);
    const onChangeProjectStyle = (0, $eUqFw.useCallback)((selectedProjectStyle)=>{
        if (!selectedProjectStyle?.value) return;
         // Reset mapping state if data has previously been loaded
        if (mappingState !== null) setMappingState(null);
        if (thirdPartyFieldConfigState !== null) setThirdPartyState({
            thirdPartyFieldConfigState: null,
            thirdPartyStatusMapping: null
        });
        if (isTMPSupported) {
            const projectAccessLevel = selectedProjectStyle.value === (0, $9R4E5.ProjectStyles).COMPANY_MANAGED_PROJECT ? null : defaultProjectAccess;
            setProjectData({
                style: selectedProjectStyle.value,
                accessLevel: projectAccessLevel
            });
            return;
        }
        setProjectData({
            style: selectedProjectStyle.value
        });
    }, [
        defaultProjectAccess,
        isTMPSupported,
        mappingState,
        setMappingState,
        setProjectData,
        setThirdPartyState,
        thirdPartyFieldConfigState
    ]);
    const onProjectAccessChange = (0, $eUqFw.useCallback)((value)=>{
        setProjectData({
            accessLevel: value
        });
    }, [
        setProjectData
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3af3ffba43119197$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1WR91.Accordion), {
        shouldForceOpen: projectKeyValidationError !== '',
        heading: projectCreateMoreOptions,
        expandedHeading: projectCreateHideMoreOptions,
        testId: "project-create-importer-upload-flow.ui.project-create-screen.project-create-more-options.accordion"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3af3ffba43119197$var$MoreOptionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        label: formatMessage((0, $cIv88.default).projectType),
        name: "projectType",
        isRequired: true,
        isDisabled: disableProjectStyle
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
            ...fieldProps,
            inputId: (0, $kzTj7.PROJECT_MANAGEMENT_TYPE_DROPDOWN_ID),
            name: (0, $kzTj7.PROJECT_MANAGEMENT_TYPE_DROPDOWN_ID),
            options: OPTIONS,
            value: valueForProjectStyle,
            onChange: onChangeProjectStyle,
            components: {
                Option: $3af3ffba43119197$var$CustomOption,
                Control: $3af3ffba43119197$var$CustomControl
            }
        })), showProjectAccessField && type && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3af3ffba43119197$var$ProjectAccessWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ouuo.default), {
        projectType: type,
        value: accessLevel || undefined,
        onChange: onProjectAccessChange,
        onFirstChange: $3af3ffba43119197$var$noop,
        onAccessTypesLoaded: $3af3ffba43119197$var$noop,
        onError: $3af3ffba43119197$var$noop,
        validateRequired: false,
        requiredAccess: false,
        isDisabled: isPermissionGated,
        dropdownWidthStyles: $3af3ffba43119197$var$dropdownWidthStyles,
        baseUrl: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3af3ffba43119197$var$ProjectKeyWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        label: projectKeyFieldLabel,
        name: "key",
        isRequired: true
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
            testId: "project-create-importer-upload-flow.ui.project-create-screen.project-create-more-options.project-key-field",
            ...fieldProps,
            value: projectKey,
            onChange: onProjectKeyChange
        }), projectKeyValidationError !== '' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, projectKeyValidationError)))))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3af3ffba43119197$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _19pkpxbi _2lx21bp4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3af3ffba43119197$var$OptionWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1yt4u2gc _n3tdpxbi",
            __cmplp.isDisabled ? "_80om13gf" : "_80omtlke",
            __cmplp.isDisabled && "_tzy4105o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3af3ffba43119197$var$MoreOptionWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2lx2vrvc _1bsb1osq _15pj1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3af3ffba43119197$var$ProjectKeyWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _19pkpxbi _1bsb93m8",
            __cmplp.className
        ])
    });
});
const $3af3ffba43119197$var$iconWrapperStyles = (0, $1ZAYh.xcss)({
    width: 'space.300',
    height: 'space.300',
    marginRight: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3af3ffba43119197$var$Image = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1ejb _4t3i1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3af3ffba43119197$var$DisabledContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81vlj _18u01jfw _19pkx0bf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3af3ffba43119197$var$IconControlWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1tcg _4t3i1tcg _18u0u2gc",
            __cmplp.className
        ])
    });
});
const $3af3ffba43119197$var$contentWrapperStyles = (0, $1ZAYh.xcss)({
    marginRight: 'space.300'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3af3ffba43119197$var$TitleWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81oud _otyru2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3af3ffba43119197$var$LozengeWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3af3ffba43119197$var$DescriptionWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11c81vlj _19pku2gc _syaz1rc1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3af3ffba43119197$var$LabelWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _15h61b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3af3ffba43119197$var$ProjectAccessWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkpxbi _1dp61osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cIv88", function(module, exports) {

$parcel$export(module.exports, "default", () => $734ad52f1b02a206$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $734ad52f1b02a206$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    projectKey: {
        "id": "project-create-importer-upload-flow.project-create-screen.project-create-more-options.project-key",
        "defaultMessage": "Key"
    },
    projectType: {
        "id": "project-create-importer-upload-flow.project-create-screen.project-create-more-options.project-type",
        "defaultMessage": "Project type"
    },
    companyManagedLabel: {
        "id": "project-create-importer-upload-flow.project-create-screen.project-create-more-options.company-managed-label",
        "defaultMessage": "Company-managed"
    },
    teamManagedLabel: {
        "id": "project-create-importer-upload-flow.project-create-screen.project-create-more-options.team-managed-label",
        "defaultMessage": "Team-managed"
    },
    adminOnlyLozenge: {
        "id": "project-create-importer-upload-flow.project-create-screen.project-create-more-options.admin-only-lozenge",
        "defaultMessage": "Administrators only"
    },
    companyManagedDescription: {
        "id": "project-create-importer-upload-flow.project-create-screen.project-create-more-options.company-managed-description",
        "defaultMessage": "For teams who work with others across many projects in a standard way that\u2019s set by your Jira admins. Encourage and promote organizational best practices through shared configuration."
    },
    teamManagedDescription: {
        "id": "project-create-importer-upload-flow.project-create-screen.project-create-more-options.team-managed-description",
        "defaultMessage": "For teams who want to control their own working processes and practices in a self-contained space. The configuration is simpler and gives project admins more control over set up without involving a Jira admin. Settings do not impact other projects."
    },
    learnMoreTeamManagedProjects: {
        "id": "project-create-importer-upload-flow.project-create-screen.project-create-more-options.learn-more-team-managed-projects",
        "defaultMessage": "Learn more about team-managed projects"
    },
    cannotCreateCompanyManagedProjectTooltipMessage: {
        "id": "project-create-importer-upload-flow.project-create-screen.project-create-more-options.cannot-create-company-managed-project-tooltip-message",
        "defaultMessage": "Only your Jira admin can create company-managed projects. Contact them for assistance."
    },
    cannotCreateTeamManagedProjectTooltipMessage: {
        "id": "project-create-importer-upload-flow.project-create-screen.project-create-more-options.cannot-create-team-managed-project-tooltip-message",
        "defaultMessage": "We currently don't support Team Managed Projects"
    },
    contactAdminCta: {
        "id": "project-create-importer-upload-flow.project-create-screen.project-create-more-options.contact-admin-cta",
        "defaultMessage": "Contact admin"
    },
    learnMoreCompanyManagedProjects: {
        "id": "project-create-importer-upload-flow.project-create-screen.project-create-more-options.learn-more-company-managed-projects",
        "defaultMessage": "Learn more about company-managed projects"
    },
    learnMoreProjectKey: {
        "id": "project-create-importer-upload-flow.project-create-screen.project-create-more-options.learn-more-project-key",
        "defaultMessage": "Learn more"
    },
    projectKeyDescription: {
        "id": "project-create-importer-upload-flow.project-create-screen.project-create-more-options.project-key-description",
        "defaultMessage": "Choose a descriptive prefix for your project\u2019s issue keys to recognize work from this project. {learnMoreLink}"
    }
});

});


parcelRegister("6llFq", function(module, exports) {

$parcel$export(module.exports, "Templates", () => $6e1d48c67efef2df$export$b78c417a59fec2a7);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $d0wrd = parcelRequire("d0wrd");

var $cuOvE = parcelRequire("cuOvE");
parcelRequire("5uivJ");
var $B6OAm = parcelRequire("B6OAm");
var $5uivJ = parcelRequire("5uivJ");
const $6e1d48c67efef2df$export$b78c417a59fec2a7 = ({ templates: templates })=>{
    const [isOpen, setOpen] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ template: template }, { setProjectData: setProjectData }] = (0, $d0wrd.useProjectData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onClose = (0, $eUqFw.useCallback)(()=>{
        setOpen(false);
    }, []);
    const onConfirm = (0, $eUqFw.useCallback)((value)=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'x2cChangeTemplateConfirm', {
            templateType: value
        });
        setProjectData({
            template: value
        });
        onClose();
    }, [
        createAnalyticsEvent,
        setProjectData,
        onClose
    ]);
    const onChangeTemplateClick = (0, $eUqFw.useCallback)(()=>{
        setOpen(true);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'x2cChangeTemplateLink');
    }, [
        createAnalyticsEvent
    ]);
    const defaultTemplate = (0, $eUqFw.useMemo)(()=>templates.find(({ isDefault: isDefault })=>isDefault) || templates[0], [
        templates
    ]);
    const selectedTemplate = (0, $eUqFw.useMemo)(()=>{
        const setTemplate = templates.find(({ key: key })=>template === key);
        if (setTemplate) return setTemplate;
        setProjectData({
            template: defaultTemplate.key
        });
        return defaultTemplate;
    }, [
        template,
        defaultTemplate,
        templates,
        setProjectData
    ]);
    const { title: title, description: description, iconUrl: iconUrl } = selectedTemplate;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e1d48c67efef2df$var$Wrapper, {
        "data-testid": "project-create-importer-upload-flow.ui.project-create-screen.templates.wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e1d48c67efef2df$var$Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e1d48c67efef2df$var$Heading, null, formatMessage((0, $cuOvE.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        onClick: onChangeTemplateClick
    }, formatMessage((0, $cuOvE.default).button))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $B6OAm.TemplateCard), {
        iconUrl: iconUrl,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e1d48c67efef2df$var$Title, null, formatMessage(title)),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e1d48c67efef2df$var$Description, null, formatMessage(description))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5uivJ.TemplateModal), {
        templates: templates,
        defaultTemplate: selectedTemplate.key,
        isOpen: isOpen,
        onClose: onClose,
        onConfirm: onConfirm
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6e1d48c67efef2df$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb1osq _2lx21bp4 _19pk1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6e1d48c67efef2df$var$Header = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4",
            __cmplp.className
        ])
    });
});
const $6e1d48c67efef2df$var$Heading = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wybdlk8 _k48pni7l _vwz47vkz _y3gn1e5h _1wpz1h6o _syazjjyb",
            __cmplp.className
        ])
    });
});
const $6e1d48c67efef2df$var$Title = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyb7vkz _k48pni7l _vwz4gktf _y3gn1e5h _syaz1fxt",
            __cmplp.className
        ])
    });
});
const $6e1d48c67efef2df$var$Description = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyb1skh _k48p1nn1 _vwz4dlk8 _y3gn1e5h _syazjjyb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cuOvE", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e70c7898e50d5c0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7e70c7898e50d5c0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "project-create-importer-upload-flow.project-create-screen.templates.title",
        "defaultMessage": "Template"
    },
    button: {
        "id": "project-create-importer-upload-flow.project-create-screen.templates.button",
        "defaultMessage": "Change template"
    }
});

});

parcelRegister("5uivJ", function(module, exports) {

$parcel$export(module.exports, "TemplateModal", () => $d5dc29077d229e94$export$285e41bef8b1c77f);
$parcel$export(module.exports, "TemplateCard", () => (parcelRequire("B6OAm")).TemplateCard);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $dxopF = parcelRequire("dxopF");

var $hnuwz = parcelRequire("hnuwz");

var $kGQen = parcelRequire("kGQen");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $kzTj7 = parcelRequire("kzTj7");

var $htzhy = parcelRequire("htzhy");

var $B6OAm = parcelRequire("B6OAm");
const $d5dc29077d229e94$export$285e41bef8b1c77f = ({ templates: templates, defaultTemplate: defaultTemplate, isOpen: isOpen, onClose: onClose, onConfirm: onConfirm })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [value, setValue] = (0, $eUqFw.useState)(defaultTemplate);
    const getTemplates = (0, $eUqFw.useCallback)(()=>templates.map(({ key: key, iconUrl: iconUrl, title: title, description: description })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d5dc29077d229e94$var$RadioContainer, {
                key: key,
                onClick: ()=>setValue(key)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnuwz.default), {
                label: "",
                isChecked: key === value
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d5dc29077d229e94$var$TemplateCardWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $B6OAm.TemplateCard), {
                iconUrl: iconUrl,
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d5dc29077d229e94$var$Title, null, formatMessage(title)),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d5dc29077d229e94$var$Description, null, formatMessage(description)),
                showOutline: key === value,
                enableHover: true
            })))), [
        formatMessage,
        templates,
        value
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: (0, $kzTj7.CHANGE_TEMPLATE_MODAL),
        sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onClose: onClose,
        width: "large",
        testId: "project-create-importer-upload-flow.ui.project-create-screen.templates.template-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d5dc29077d229e94$var$ModalContent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d5dc29077d229e94$var$Heading, null, formatMessage((0, $htzhy.default).heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, getTemplates()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        onClick: onClose
    }, formatMessage((0, $htzhy.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "project-create-importer-upload-flow.ui.project-create-screen.templates.template-modal.button",
        appearance: "primary",
        onClick: ()=>onConfirm(value)
    }, formatMessage((0, $htzhy.default).confirm))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null))));
};
const $d5dc29077d229e94$var$RadioContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _19itglyw _bfhk18uv _1bsb1osq _80omtlke _4cvr1h6o _12ji1snc _1qu2agmp _12y310yn",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d5dc29077d229e94$var$Heading = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41ejb _syaz1fxt _1wybgktf _zg8l4jg8 _k48pbfng _vwz41tcg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d5dc29077d229e94$var$TemplateCardWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb1osq _18s8s8vo",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d5dc29077d229e94$var$ModalContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _bfhkvuon _2rko1l7b _1bsb9wyc _p12f1c3h _16qszotn _kqswstnw _154i1epz _19pk1jfw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d5dc29077d229e94$var$Title = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wybdlk8 _k48pni7l _vwz47vkz _y3gn1e5h _syaz1fxt",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d5dc29077d229e94$var$Description = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wybdlk8 _k48p1nn1 _vwz4gktf _y3gn1e5h _syaz1rc1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hnuwz", function(module, exports) {

$parcel$export(module.exports, "default", () => $306a59ce4e6b6146$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

var $PdmhA = parcelRequire("PdmhA");
const $306a59ce4e6b6146$var$packageName = undefined;
const $306a59ce4e6b6146$var$packageVersion = undefined;
const $306a59ce4e6b6146$var$noop = (0, $5Q9wj.default);
const $306a59ce4e6b6146$var$labelPaddingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    padding: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"}`
});
const $306a59ce4e6b6146$var$labelStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    boxSizing: 'border-box',
    position: 'relative',
    alignItems: 'flex-start',
    color: `var(--ds-text, ${(0, $PdmhA.N900)})`,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-disabled]': {
        color: `var(--ds-text-disabled, ${(0, $PdmhA.N80)})`,
        cursor: 'not-allowed'
    }
});
const $306a59ce4e6b6146$var$radioStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    // TODO https://product-fabric.atlassian.net/browse/DSP-10507 revisit and remove the scale of 14/24
    /*
     The circle should be 14px * 14px centred in a 24px * 24px box.
     This is inclusive of a 2px border and inner circle with 2px radius.
     There is a Chrome bug that makes the circle become an oval and the
     inner circle not be centred at various zoom levels. This bug is fixed
     in all browsers if a scale of 14/24 is applied.
   */ width: '24px',
    height: '24px',
    margin: "var(--ds-space-0, 0px)",
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    backgroundColor: 'var(--radio-background-color)',
    /* Border should multiply by 24/14 to offset scale, a scale of 12 / 7 is to fix a Chrome bug that makes the circle become an oval and the
     inner circle not be centred at various zoom levels */ border: `${"var(--ds-border-width, 1px)"} solid var(--radio-border-color)`,
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    MozAppearance: 'none',
    outline: 'none',
    /*
     Change the variables --radio-background-color, --radio-border-color,
     -radio-dot-color and -radio-dot-opacity according to user interactions.
     All other variables are constant
   */ '--radio-background-color': `var(--ds-background-input, ${(0, $PdmhA.N10)})`,
    '--radio-border-color': `var(--ds-border-input, ${(0, $PdmhA.N100)})`,
    '--radio-dot-color': `var(--ds-icon-inverse, ${(0, $PdmhA.N10)})`,
    '--radio-dot-opacity': 0,
    /* 24px * 7 / 12 === 14px height and width */ transform: 'scale(calc(7 / 12))',
    transition: 'border-color 0.2s ease-in-out, background-color 0.2s ease-in-out',
    verticalAlign: 'top',
    WebkitAppearance: 'none',
    '&::after': {
        /* Height and width should by 4px, multiply by 24/14 to offset scale */ width: 'calc(4px * 12 / 7)',
        height: 'calc(4px * 12 / 7)',
        position: 'absolute',
        background: 'var(--radio-dot-color)',
        // TODO Delete this comment after verifying spacing token -> previous value `'50%'`
        borderRadius: "var(--ds-border-radius-circle, 50%)",
        content: "''",
        opacity: 'var(--radio-dot-opacity)',
        transition: 'background-color 0.2s ease-in-out, opacity 0.2s ease-in-out'
    },
    '&:hover': {
        '--radio-background-color': `var(--ds-background-input-hovered, ${(0, $PdmhA.N30)})`,
        '--radio-border-color': `var(--ds-border-input, ${(0, $PdmhA.N100)})`
    },
    '&:active': {
        '--radio-background-color': `var(--ds-background-input-pressed, ${(0, $PdmhA.N30)})`
    },
    '&:focus': {
        outline: `${"var(--ds-border-width-outline, 3px)"} solid ${`var(--ds-border-focused, ${(0, $PdmhA.B200)})`}`,
        outlineOffset: "var(--ds-border-width-indicator, 3px)"
    },
    '&:checked': {
        '--radio-background-color': `var(--ds-background-selected-bold, ${(0, $PdmhA.B400)})`,
        '--radio-border-color': `var(--ds-background-selected-bold, ${(0, $PdmhA.B400)})`,
        '--radio-dot-opacity': 1
    },
    '&:checked:hover': {
        '--radio-background-color': `var(--ds-background-selected-bold-hovered, ${(0, $PdmhA.B300)})`,
        '--radio-border-color': `var(--ds-background-selected-bold-hovered, ${(0, $PdmhA.B300)})`
    },
    '&:checked:active': {
        '--radio-background-color': `var(--ds-background-selected-bold-pressed, ${(0, $PdmhA.B50)})`,
        '--radio-border-color': `var(--ds-border-input, ${(0, $PdmhA.N100)})`,
        '--radio-dot-color': `var(--ds-icon-inverse, ${(0, $PdmhA.B400)})`
    },
    '&:checked:focus': {
        outline: `${"var(--ds-border-width-outline, 3px)"} solid ${`var(--ds-border-focused, ${(0, $PdmhA.B200)})`}`,
        outlineOffset: "var(--ds-border-width-indicator, 3px)"
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-invalid], &:checked[data-invalid]': {
        '--radio-border-color': `var(--ds-icon-danger, ${(0, $PdmhA.R300)})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled, &:disabled:hover, &:disabled:focus, &:disabled:active, &:disabled[data-invalid]': {
        cursor: 'not-allowed',
        '--radio-background-color': `var(--ds-background-disabled, ${(0, $PdmhA.N20)})`,
        '--radio-border-color': `var(--ds-border-disabled, ${(0, $PdmhA.N20)})`,
        '--radio-dot-color': `var(--ds-icon-disabled, ${(0, $PdmhA.N70)})`
    }
});
const $306a59ce4e6b6146$var$InnerRadio = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function Radio(props, ref) {
    const { ariaLabel: ariaLabel, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, name: name, onChange: onChange = $306a59ce4e6b6146$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, // events and all other input props
    ...rest } = props;
    const onChangeAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'radio',
        packageName: $306a59ce4e6b6146$var$packageName,
        packageVersion: $306a59ce4e6b6146$var$packageVersion
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)("label", {
        "data-testid": testId && `${testId}--radio-label`,
        "data-disabled": isDisabled ? 'true' : undefined,
        css: $306a59ce4e6b6146$var$labelStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ...rest,
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0,
        "aria-label": ariaLabel,
        checked: isChecked,
        disabled: isDisabled,
        name: name,
        onChange: onChangeAnalytics,
        required: isRequired,
        type: "radio",
        value: value,
        "data-testid": testId && `${testId}--radio-input`,
        // isInvalid is used in a nonstandard way so cannot
        // use :invalid selector
        "data-invalid": isInvalid ? 'true' : undefined,
        css: $306a59ce4e6b6146$var$radioStyles,
        ref: ref
    }), label ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $306a59ce4e6b6146$var$labelPaddingStyles
    }, label) : null);
});
/**
 * __Radio__
 *
 * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
 *
 * - [Examples](https://atlassian.design/components/radio/examples)
 * - [Code](https://atlassian.design/components/radio/code)
 * - [Usage](https://atlassian.design/components/radio/usage)
 */ const $306a59ce4e6b6146$var$Radio = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Radio(props, ref) {
    return /*#__PURE__*/ (0, $byn9U.jsx)($306a59ce4e6b6146$var$InnerRadio, {
        ...props,
        ref: ref
    });
}));
var $306a59ce4e6b6146$export$2e2bcd8739ae039 = $306a59ce4e6b6146$var$Radio;

});

parcelRegister("htzhy", function(module, exports) {

$parcel$export(module.exports, "default", () => $cee8eb8a450d9cb5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $cee8eb8a450d9cb5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    heading: {
        "id": "project-create-importer-upload-flow.project-create-screen.templates.template-modal.heading",
        "defaultMessage": "Select project template"
    },
    cancel: {
        "id": "project-create-importer-upload-flow.project-create-screen.templates.template-modal.cancel",
        "defaultMessage": "Cancel"
    },
    confirm: {
        "id": "project-create-importer-upload-flow.project-create-screen.templates.template-modal.confirm",
        "defaultMessage": "Confirm"
    }
});

});

parcelRegister("B6OAm", function(module, exports) {

$parcel$export(module.exports, "TemplateCard", () => $f6829afec57c20d1$export$ba340e850b866867);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $f6829afec57c20d1$export$ba340e850b866867 = ({ title: title, description: description, iconUrl: iconUrl, showOutline: showOutline, enableHover: enableHover })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f6829afec57c20d1$var$TileContainer, {
        showOutline: Boolean(showOutline),
        enableHover: Boolean(enableHover)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f6829afec57c20d1$var$IconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f6829afec57c20d1$var$Icon, {
        src: iconUrl
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f6829afec57c20d1$var$Content, null, title, description));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f6829afec57c20d1$var$TileContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { showOutline: showOutline, enableHover: enableHover, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4t3i1dqv _1bsb1osq _2rkoftgi _16qs1j00 _18s81bpf",
            __cmplp.showOutline ? "_1a37je1v" : "_12ji1r31 _1qu2glyw _12y31o36",
            __cmplp.enableHover ? "_1dbzcljr" : "_1dbz1j00",
            __cmplp.className
        ])
    });
});
const $f6829afec57c20d1$var$IconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsbi9or _p12fplmo _4t3i1osq _4cvr1h6o _1bah1h6o _11q76r4t _2rko1mnk",
            __cmplp.className
        ])
    });
});
const $f6829afec57c20d1$var$Icon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsba4db _p12f1epz",
            __cmplp.className
        ])
    });
});
const $f6829afec57c20d1$var$Content = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8pxbi _1wpz1h6o",
            __cmplp.className
        ])
    });
});

});




parcelRegister("2RwaJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $409ee49ebef0a412$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $PVrB2 = parcelRequire("PVrB2");

var $cDLTA = parcelRequire("cDLTA");
var $aWLVm = parcelRequire("aWLVm");

var $asXeB = parcelRequire("asXeB");

var $4PkXR = parcelRequire("4PkXR");

var $hrqyW = parcelRequire("hrqyW");

var $a70WY = parcelRequire("a70WY");
const $409ee49ebef0a412$var$AddNewAccessTokenModal = ({ isOpen: isOpen, onClose: onClose, onClickCancelButton: onClickCancelButton, onClickSubmitButton: onClickSubmitButton, isLoading: isLoading, hasErrorOccurred: hasErrorOccurred, thirdParty: thirdParty })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { addAccessTokenModalDescription: addAccessTokenModalDescription } = (0, $cDLTA.useContentForThirdParty)(thirdParty);
    const { generateAPIToken: generateAPIToken } = (0, $aWLVm.useUrlForThirdParty)(thirdParty);
    const onCancel = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'cancelAddNewAccessToken');
        onClickCancelButton();
    }, [
        createAnalyticsEvent,
        onClickCancelButton
    ]);
    const onSubmit = (0, $eUqFw.useCallback)((accessToken)=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'submitAddNewAccessToken');
        onClickSubmitButton(accessToken);
    }, [
        createAnalyticsEvent,
        onClickSubmitButton
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hrqyW.default), {
        isOpen: isOpen,
        onClose: onClose,
        title: formatMessage((0, $a70WY.default).addAccessTokenModalTitle),
        description: addAccessTokenModalDescription && formatMessage(addAccessTokenModalDescription, {
            br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null),
            link: (children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                    href: generateAPIToken,
                    target: "_blank"
                }, children)
        }),
        cancelButton: {
            text: formatMessage((0, $a70WY.default).cancelButton),
            onClick: onCancel
        },
        submitButton: {
            text: formatMessage((0, $a70WY.default).submitButton),
            onClick: onSubmit
        },
        isLoading: isLoading,
        hasErrorOccurred: hasErrorOccurred,
        thirdParty: thirdParty
    });
};
const $409ee49ebef0a412$var$EditAccessTokenModal = ({ isOpen: isOpen, onClose: onClose, onClickCancelButton: onClickCancelButton, onClickSubmitButton: onClickSubmitButton, isLoading: isLoading, hasErrorOccurred: hasErrorOccurred, thirdParty: thirdParty, showCurrentAccount: showCurrentAccount })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { editAccessTokenModalDescription: editAccessTokenModalDescription } = (0, $cDLTA.useContentForThirdParty)(thirdParty);
    const onCancel = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'cancelEditAccessToken');
        onClickCancelButton();
    }, [
        createAnalyticsEvent,
        onClickCancelButton
    ]);
    const onSubmit = (0, $eUqFw.useCallback)((accessToken)=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'submitEditAccessToken');
        onClickSubmitButton(accessToken);
    }, [
        createAnalyticsEvent,
        onClickSubmitButton
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hrqyW.default), {
        isOpen: isOpen,
        onClose: onClose,
        title: formatMessage((0, $a70WY.default).editTokenModalTitle),
        description: editAccessTokenModalDescription && formatMessage(editAccessTokenModalDescription, {
            br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null)
        }),
        showCurrentAccount: showCurrentAccount,
        cancelButton: {
            text: formatMessage((0, $a70WY.default).cancelButton),
            onClick: onCancel
        },
        submitButton: {
            text: formatMessage((0, $a70WY.default).continueButton),
            onClick: onSubmit
        },
        isLoading: isLoading,
        hasErrorOccurred: hasErrorOccurred,
        thirdParty: thirdParty
    });
};
const $409ee49ebef0a412$var$ExpiredAccessTokenModal = ({ isOpen: isOpen, onClose: onClose, onClickCancelButton: onClickCancelButton, onClickSubmitButton: onClickSubmitButton, isLoading: isLoading, hasErrorOccurred: hasErrorOccurred, thirdParty: thirdParty })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { invalidAccessTokenModalDescription: invalidAccessTokenModalDescription } = (0, $cDLTA.useContentForThirdParty)(thirdParty);
    const onCancel = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'cancelExpiredAccessToken');
        onClickCancelButton();
    }, [
        createAnalyticsEvent,
        onClickCancelButton
    ]);
    const onContinue = (0, $eUqFw.useCallback)((accessToken)=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'continueExpiredAccessToken');
        onClickSubmitButton(accessToken);
    }, [
        createAnalyticsEvent,
        onClickSubmitButton
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hrqyW.default), {
        isOpen: isOpen,
        onClose: onClose,
        title: formatMessage((0, $a70WY.default).invalidAccessTokenModalTitle),
        description: invalidAccessTokenModalDescription && formatMessage(invalidAccessTokenModalDescription, {
            br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null)
        }),
        cancelButton: {
            text: formatMessage((0, $a70WY.default).cancelImportButton),
            onClick: onCancel
        },
        submitButton: {
            text: formatMessage((0, $a70WY.default).continueButton),
            onClick: onContinue
        },
        isLoading: isLoading,
        hasErrorOccurred: hasErrorOccurred,
        thirdParty: thirdParty
    });
};
const $409ee49ebef0a412$var$AccessTokenModalContent = ({ thirdParty: thirdParty, onCloseAndReturnToUploadStep: onCloseAndReturnToUploadStep, showCurrentAccount: showCurrentAccount })=>{
    const [{ isModalOpen: isModalOpen, modalType: modalType, shouldCloseAndReturnToUploadStep: shouldCloseAndReturnToUploadStep, onFinishAccessTokenValidation: onFinishAccessTokenValidation }, { resetAccessTokenModalState: resetAccessTokenModalState, setAccessTokenModalState: setAccessTokenModalState, setRequestAuthenticationToken: setRequestAuthenticationToken }] = (0, $asXeB.useAccessTokenModalState)();
    const { postAccessToken: postAccessToken, hasErrorOccurred: hasErrorOccurred, isLoading: isLoading } = (0, $4PkXR.useThirdPartyAccessToken)({
        thirdParty: thirdParty,
        requestAuthenticationToken: setRequestAuthenticationToken
    });
    const onClose = (0, $eUqFw.useCallback)(()=>{
        setAccessTokenModalState({
            isModalOpen: false
        });
        onFinishAccessTokenValidation && onFinishAccessTokenValidation(false);
    }, [
        setAccessTokenModalState,
        onFinishAccessTokenValidation
    ]);
    const handleCancelClick = (0, $eUqFw.useCallback)(()=>{
        shouldCloseAndReturnToUploadStep && onCloseAndReturnToUploadStep();
        resetAccessTokenModalState();
        onFinishAccessTokenValidation && onFinishAccessTokenValidation(false);
    }, [
        shouldCloseAndReturnToUploadStep,
        onCloseAndReturnToUploadStep,
        resetAccessTokenModalState,
        onFinishAccessTokenValidation
    ]);
    const handleSubmitClick = (0, $eUqFw.useCallback)((accessToken)=>{
        postAccessToken(accessToken, thirdParty).then((isValid)=>{
            if (isValid) {
                onFinishAccessTokenValidation && onFinishAccessTokenValidation(isValid);
                setAccessTokenModalState({
                    isModalOpen: false
                });
            }
        });
    }, [
        onFinishAccessTokenValidation,
        postAccessToken,
        setAccessTokenModalState,
        thirdParty
    ]);
    if (modalType === (0, $PVrB2.AccessTokenModalType).ADD_NEW_TOKEN) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($409ee49ebef0a412$var$AddNewAccessTokenModal, {
        isOpen: isModalOpen,
        onClickCancelButton: handleCancelClick,
        onClickSubmitButton: handleSubmitClick,
        onClose: onClose,
        isLoading: isLoading,
        hasErrorOccurred: hasErrorOccurred,
        thirdParty: thirdParty
    });
    if (modalType === (0, $PVrB2.AccessTokenModalType).EDIT_TOKEN) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($409ee49ebef0a412$var$EditAccessTokenModal, {
        isOpen: isModalOpen,
        onClickCancelButton: handleCancelClick,
        onClickSubmitButton: handleSubmitClick,
        onClose: onClose,
        isLoading: isLoading,
        hasErrorOccurred: hasErrorOccurred,
        thirdParty: thirdParty,
        showCurrentAccount: showCurrentAccount
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($409ee49ebef0a412$var$ExpiredAccessTokenModal, {
        isOpen: isModalOpen,
        onClose: onClose,
        onClickCancelButton: handleCancelClick,
        onClickSubmitButton: handleSubmitClick,
        isLoading: isLoading,
        hasErrorOccurred: hasErrorOccurred,
        thirdParty: thirdParty
    });
};
const $409ee49ebef0a412$var$RequestAccessTokenModal = ({ onCloseAndReturnToUploadStep: onCloseAndReturnToUploadStep, showCurrentAccount: showCurrentAccount })=>{
    const [{ thirdParty: thirdParty, isModalOpen: isModalOpen }] = (0, $asXeB.useAccessTokenModalState)();
    if (!thirdParty || !isModalOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($409ee49ebef0a412$var$AccessTokenModalContent, {
        thirdParty: thirdParty,
        onCloseAndReturnToUploadStep: onCloseAndReturnToUploadStep,
        showCurrentAccount: showCurrentAccount
    });
};
var $409ee49ebef0a412$export$2e2bcd8739ae039 = $409ee49ebef0a412$var$RequestAccessTokenModal;

});
parcelRegister("4PkXR", function(module, exports) {

$parcel$export(module.exports, "useThirdPartyAccessToken", () => $b56a36e567159be1$export$e81d56dcae748a34);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $gyZoj = parcelRequire("gyZoj");
var $5GSA7 = parcelRequire("5GSA7");

var $kzTj7 = parcelRequire("kzTj7");

var $3yuWi = parcelRequire("3yuWi");

var $8OWUq = parcelRequire("8OWUq");
const $b56a36e567159be1$export$e81d56dcae748a34 = ({ thirdParty: thirdPartyFromProps, requestAuthenticationToken: requestAuthenticationToken } = {})=>{
    const thirdPartyClient = (0, $8OWUq.useThirdPartyClient)({
        thirdParty: thirdPartyFromProps,
        requestAuthenticationToken: requestAuthenticationToken
    });
    const [onExperienceStart, onExperienceSuccess, onExperienceFail] = (0, $5GSA7.useExperienceTracker)((0, $3yuWi.EXPERIENCES).THIRD_PARTY_POST_ACCESS_TOKEN);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [hasErrorOccurred, setHasErrorOccurred] = (0, $eUqFw.useState)(false);
    const postAccessToken = (0, $eUqFw.useCallback)(async (accessToken, thirdParty)=>{
        if (!thirdParty) return false;
        setIsLoading(true);
        setHasErrorOccurred(false);
        (0, $3yuWi.thirdPartyPostAccessTokenMetric).start();
        onExperienceStart();
        try {
            await thirdPartyClient.postAccessToken({
                accessToken: accessToken
            });
            (0, $3yuWi.thirdPartyPostAccessTokenMetric).stop();
            onExperienceSuccess();
            setIsLoading(false);
            return true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $3yuWi.thirdPartyPostAccessTokenMetric).stop();
            onExperienceFail((0, $kzTj7.APP_IDENTIFIER), error, {
                thirdParty: thirdParty
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'post-third-party-access-token',
                    packageName: (0, $kzTj7.APP_IDENTIFIER),
                    teamName: (0, $gyZoj.APP_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true,
                error: error
            });
            setHasErrorOccurred(true);
            setIsLoading(false);
            return false;
        }
    }, [
        onExperienceFail,
        onExperienceStart,
        onExperienceSuccess,
        thirdPartyClient
    ]);
    return {
        isLoading: isLoading,
        hasErrorOccurred: hasErrorOccurred,
        postAccessToken: postAccessToken
    };
};

});

parcelRegister("hrqyW", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f6370432bce34e9$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $ldoFd = parcelRequire("ldoFd");

var $7opLA = parcelRequire("7opLA");

var $7u4fN = parcelRequire("7u4fN");

var $7jPhn = parcelRequire("7jPhn");
var $4LhB6 = parcelRequire("4LhB6");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
var $dxopF = parcelRequire("dxopF");

var $cf2Y4 = parcelRequire("cf2Y4");

var $5JgJ2 = parcelRequire("5JgJ2");

var $buKPq = parcelRequire("buKPq");

var $irKna = parcelRequire("irKna");

var $a70WY = parcelRequire("a70WY");
const $3f6370432bce34e9$var$AccessTokenModal = ({ isOpen: isOpen, onClose: onClose, title: title, description: description, cancelButton: cancelButton, submitButton: submitButton, isLoading: isLoading, hasErrorOccurred: hasErrorOccurred, thirdParty: thirdParty, showCurrentAccount: showCurrentAccount })=>{
    const [accessToken, setAccessToken] = (0, $eUqFw.useState)('');
    const [showError, setShowError] = (0, $eUqFw.useState)(false);
    const [{ siteName: siteName }] = (0, $irKna.useThirdPartyState)();
    (0, $eUqFw.useEffect)(()=>{
        setShowError(hasErrorOccurred === true);
    }, [
        hasErrorOccurred
    ]);
    const onChange = (0, $eUqFw.useCallback)((e)=>{
        setAccessToken(e.target.value);
        setShowError(false);
    }, []);
    const onSubmit = (0, $eUqFw.useCallback)(()=>{
        submitButton.onClick(accessToken);
    }, [
        accessToken,
        submitButton
    ]);
    const disabledButton = showError || (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(accessToken) || accessToken === '';
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        shouldScrollInViewport: false,
        testId: "project-create-importer-upload-flow.ui.request-access-token-modal.modal",
        shouldCloseOnEscapePress: true,
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, description, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3f6370432bce34e9$var$ContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        label: formatMessage((0, $a70WY.default).accessTokenTextfieldLabel),
        name: formatMessage((0, $a70WY.default).accessTokenTextfieldLabel),
        isRequired: true
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
            testId: "project-create-importer-upload-flow.ui.request-access-token-modal.access-token-textfield",
            ...fieldProps,
            value: accessToken,
            onChange: onChange,
            isReadOnly: isLoading,
            isInvalid: showError,
            autoFocus: true,
            placeholder: formatMessage((0, $a70WY.default).accessTokenTextfieldPlaceholder, {
                thirdParty: thirdParty
            })
        }), showError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, formatMessage((0, $a70WY.default).accessTokenTextfieldErrorMessage))))), showCurrentAccount && siteName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $buKPq.SiteName), {
        siteName: siteName
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        isDisabled: isLoading,
        onClick: cancelButton.onClick
    }, cancelButton.text), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        appearance: "primary",
        isDisabled: disabledButton,
        isLoading: isLoading,
        onClick: onSubmit
    }, submitButton.text))));
};
var $3f6370432bce34e9$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $3f6370432bce34e9$var$AccessTokenModal;
const $3f6370432bce34e9$var$ContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8zu5n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("buKPq", function(module, exports) {

$parcel$export(module.exports, "SiteName", () => $1c13523a0c16ea9c$export$99340bda81c58e19);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $6ROLN = parcelRequire("6ROLN");

var $4Bees = parcelRequire("4Bees");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gStYt = parcelRequire("gStYt");
const $1c13523a0c16ea9c$var$SiteNameContent = ({ siteName: siteName, isLoading: isLoading, hasErrorOccurred: hasErrorOccurred, onFetchSiteName: onFetchSiteName })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1c13523a0c16ea9c$var$SpinnerWrapper, {
        "data-testId": "project-create-importer-upload-flow.common.ui.site-name.spinner-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "small"
    }));
    if (hasErrorOccurred) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1c13523a0c16ea9c$var$RetryWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        spacing: "none",
        onClick: onFetchSiteName
    }, formatMessage((0, $gStYt.default).retry)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1c13523a0c16ea9c$var$StyledSiteName, null, siteName);
};
const $1c13523a0c16ea9c$export$99340bda81c58e19 = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ROLN.Label), {
        htmlFor: "current-account"
    }, formatMessage((0, $gStYt.default).currentAccount)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1c13523a0c16ea9c$var$Wrapper, {
        hasErrorOccurred: props.hasErrorOccurred
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1c13523a0c16ea9c$var$SiteNameContent, props)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1c13523a0c16ea9c$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasErrorOccurred: hasErrorOccurred, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wybdlk8 _vwz4gktf _k48p1nn1 _bfhk1y1w _4t3i1ylp _2rko1y44 _otyr1b66 _19bvu2gc _u5f3pxbi _syaz1n3s",
            __cmplp.hasErrorOccurred ? "_19it14wz" : "_19itglyw",
            __cmplp.className
        ])
    });
});
const $1c13523a0c16ea9c$var$StyledSiteName = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _4t3i1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1c13523a0c16ea9c$var$SpinnerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _1e0c1txw _4cvr1h6o _1bahesu3",
            __cmplp.className
        ])
    });
});
const $1c13523a0c16ea9c$var$RetryWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _1e0c1txw _4cvr1h6o _1bahesu3",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gStYt", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9d2040334efc2b4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d9d2040334efc2b4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    currentAccount: {
        "id": "project-create-importer-upload-flow.common.site-name.current-account",
        "defaultMessage": "Current account"
    },
    retry: {
        "id": "project-create-importer-upload-flow.common.site-name.retry",
        "defaultMessage": "Retry"
    }
});

});


parcelRegister("a70WY", function(module, exports) {

$parcel$export(module.exports, "default", () => $aecf2c925a42d30f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $aecf2c925a42d30f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    addAccessTokenModalTitle: {
        "id": "project-create-importer-upload-flow.request-access-token-modal.add-access-token-modal-title",
        "defaultMessage": "Enter your personal access token"
    },
    cancelButton: {
        "id": "project-create-importer-upload-flow.request-access-token-modal.cancel-button",
        "defaultMessage": "Cancel"
    },
    submitButton: {
        "id": "project-create-importer-upload-flow.request-access-token-modal.submit-button",
        "defaultMessage": "Submit"
    },
    invalidAccessTokenModalTitle: {
        "id": "project-create-importer-upload-flow.request-access-token-modal.invalid-access-token-modal-title",
        "defaultMessage": "Invalid personal access token"
    },
    cancelImportButton: {
        "id": "project-create-importer-upload-flow.request-access-token-modal.cancel-import-button",
        "defaultMessage": "Cancel import"
    },
    continueButton: {
        "id": "project-create-importer-upload-flow.request-access-token-modal.continue-button",
        "defaultMessage": "Continue"
    },
    accessTokenTextfieldLabel: {
        "id": "project-create-importer-upload-flow.request-access-token-modal.access-token-textfield-label",
        "defaultMessage": "Personal access token"
    },
    accessTokenTextfieldPlaceholder: {
        "id": "project-create-importer-upload-flow.request-access-token-modal.access-token-textfield-placeholder",
        "defaultMessage": "Paste your {thirdParty} token"
    },
    accessTokenTextfieldErrorMessage: {
        "id": "project-create-importer-upload-flow.request-access-token-modal.access-token-textfield-error-message",
        "defaultMessage": "Invalid token. Create a new personal access token and try again."
    },
    editTokenModalTitle: {
        "id": "project-create-importer-upload-flow.request-access-token-modal.edit-token-modal-title",
        "defaultMessage": "Edit personal access token"
    }
});

});



parcelRegister("6xfPA", function(module, exports) {

$parcel$export(module.exports, "ReviewScreenStandard", () => $e8fc7b0372ef2f2a$export$2076e2511ead2c7);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $3yuWi = parcelRequire("3yuWi");

var $elKPF = parcelRequire("elKPF");

var $1T7vu = parcelRequire("1T7vu");

var $7cdKR = parcelRequire("7cdKR");

var $d0wrd = parcelRequire("d0wrd");

var $1dxi7 = parcelRequire("1dxi7");

var $fiH3o = parcelRequire("fiH3o");

var $kCuhj = parcelRequire("kCuhj");

var $kxXOc = parcelRequire("kxXOc");
const $e8fc7b0372ef2f2a$export$2076e2511ead2c7 = ({ onReturn: onReturn, onNext: onNext, onCloseAndReturnToUploadStep: onCloseAndReturnToUploadStep, isCompact: isCompact, tiles: tiles, shouldStartImportOnNext: shouldStartImportOnNext })=>{
    const { productSteps: productSteps, currentStepIndex: currentStepIndex } = (0, $fiH3o.useProductSteps)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { startImport: startImport, isImportLoading: isImportLoading, isStartImportDisabled: isStartImportDisabled, hasImportErrorOccurred: hasImportErrorOccurred } = (0, $1dxi7.useStartImportController)();
    const [projectData] = (0, $d0wrd.useProjectData)();
    const handleSubmit = (0, $eUqFw.useCallback)(()=>{
        startImport({
            projectData: projectData,
            onNext: onNext
        });
    }, [
        onNext,
        projectData,
        startImport
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: (0, $3yuWi.X2C_SCREENS).REVIEW_SCREEN_STANDARD,
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7cdKR.StepScreen), {
        testId: "project-create-importer-upload-flow.ui.review-screen-standard.step-screen",
        renderProgressBar: !isCompact && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1T7vu.ProgressBarStandard), {
            productSteps: productSteps,
            currentStepIndex: currentStepIndex,
            onClose: onCloseAndReturnToUploadStep
        }),
        header: formatMessage((0, $kCuhj.default).heading),
        description: formatMessage((0, $kCuhj.default).description),
        maxWidth: "720px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kxXOc.ReviewTiles), {
        tiles: tiles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $elKPF.StepFooterStandard), {
        alignRight: true,
        isFixedPosition: !isCompact,
        onReturn: onReturn,
        nextButtonType: "submit",
        onClickNext: handleSubmit,
        shouldStartImportOnNext: shouldStartImportOnNext,
        isLoading: isImportLoading,
        shouldDisableReturn: isImportLoading,
        shouldDisableNext: isStartImportDisabled,
        hasImportErrorOccurred: hasImportErrorOccurred
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null)));
};

});
parcelRegister("kCuhj", function(module, exports) {

$parcel$export(module.exports, "default", () => $69aa8e3ffe3c31b3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $69aa8e3ffe3c31b3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    heading: {
        "id": "project-create-importer-upload-flow.review-screen-standard.heading",
        "defaultMessage": "Review project details"
    },
    description: {
        "id": "project-create-importer-upload-flow.review-screen-standard.description",
        "defaultMessage": "We\u2019re ready to import your team\u2019s data. Here\u2019s a summary of what\u2019s being imported into Jira. Confirm the details before starting the import."
    }
});

});

parcelRegister("kxXOc", function(module, exports) {

$parcel$export(module.exports, "ReviewTiles", () => $b7394eaa9fe86b3f$export$3457648272ab6769);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $5YsMl = parcelRequire("5YsMl");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gd0Sp = parcelRequire("gd0Sp");

var $fPb9U = parcelRequire("fPb9U");

var $OnUJW = parcelRequire("OnUJW");

var $4g60v = parcelRequire("4g60v");

var $ch13p = parcelRequire("ch13p");

var $kzTj7 = parcelRequire("kzTj7");

var $1pm5p = parcelRequire("1pm5p");

var $3taFW = parcelRequire("3taFW");

var $d0wrd = parcelRequire("d0wrd");

var $6x0nK = parcelRequire("6x0nK");

var $49IyY = parcelRequire("49IyY");

var $6GEcx = parcelRequire("6GEcx");
const $b7394eaa9fe86b3f$export$3457648272ab6769 = ({ tiles: tiles })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [projectData] = (0, $d0wrd.useProjectData)();
    const { projectType: projectType, projectStyle: projectStyle, projectTemplate: projectTemplate } = (0, $6GEcx.useContent)(projectData);
    const [{ numOfImportedFields: numOfImportedFields, numOfTotalFields: numOfTotalFields, numOfExistingFields: numOfExistingFields, numOfCustomFields: numOfCustomFields, numOfImportedUsers: numOfImportedUsers, numOfUniqueImportedUsers: numOfUniqueImportedUsers, numOfTotalUsers: numOfTotalUsers, numOfIssue: numOfIssue }] = (0, $6x0nK.useCSVReviewData)();
    const { isAdmin: isAdmin, isSiteAdmin: isSiteAdmin } = (0, $gd0Sp.useTenantContext)();
    const projectDetailsTile = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $b7394eaa9fe86b3f$var$cardStyles,
            key: (0, $1pm5p.CSVReviewTilesType).PROJECT_DETAILS
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3taFW.Card), {
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7394eaa9fe86b3f$var$Icon, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($4g60v))),
                "aria-label": formatMessage((0, $49IyY.default).projectDetailsTileLabel)
            }),
            heading: formatMessage((0, $49IyY.default).projectDetailsTileHeading, {
                projectName: projectData.name
            }),
            description: formatMessage((0, $49IyY.default).projectDetailsTileDescription, {
                projectStyle: projectStyle,
                projectType: projectType,
                projectTemplate: projectTemplate
            }),
            testId: "project-create-importer-upload-flow.ui.review-screen-standard.review-tiles.project-details",
            hasBoxShadow: false
        })), [
        formatMessage,
        projectData.name,
        projectStyle,
        projectTemplate,
        projectType
    ]);
    const fieldsTile = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $b7394eaa9fe86b3f$var$cardStyles,
            key: (0, $1pm5p.CSVReviewTilesType).FIELDS
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3taFW.Card), {
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7394eaa9fe86b3f$var$Icon, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($OnUJW))),
                "aria-label": formatMessage((0, $49IyY.default).fieldTileLabel)
            }),
            heading: formatMessage((0, $49IyY.default).fieldTileHeading, {
                numOfImported: numOfImportedFields,
                numOfTotal: numOfTotalFields
            }),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, formatMessage((0, $49IyY.default).fieldTileDescription, {
                numOfExistingFields: numOfExistingFields
            }), numOfCustomFields > 0 && formatMessage((0, $49IyY.default).fieldTileDescriptionForCustomField, {
                numOfCustomFields: numOfCustomFields
            })),
            testId: "project-create-importer-upload-flow.ui.review-screen-standard.review-tiles.fields",
            hasBoxShadow: false
        })), [
        formatMessage,
        numOfCustomFields,
        numOfExistingFields,
        numOfImportedFields,
        numOfTotalFields
    ]);
    const descriptionForUsersTile = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, numOfImportedUsers > 0 ? `${formatMessage((0, $49IyY.default).usersTileDescription, {
            numOfImported: numOfImportedUsers,
            numOfTotal: numOfTotalUsers
        })} ${formatMessage((0, $49IyY.default).usersTileMoreDescription, {
            numOfUniqueImported: numOfUniqueImportedUsers
        })}` : formatMessage((0, $49IyY.default).noUsersTileDescription))), (0, $1ybV0.ff)('enable-product-admin-for-x2c-migration_zmlsv') && !isSiteAdmin && isAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
            label: "",
            size: "medium",
            primaryColor: `var(--ds-icon-warning, ${(0, $PdmhA).Y400})`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, formatMessage((0, $49IyY.default).usersTileWarningDescription)))), [
        formatMessage,
        isAdmin,
        isSiteAdmin,
        numOfImportedUsers,
        numOfTotalUsers,
        numOfUniqueImportedUsers
    ]);
    const usersTile = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $b7394eaa9fe86b3f$var$cardStyles,
            key: (0, $1pm5p.CSVReviewTilesType).USERS
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3taFW.Card), {
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7394eaa9fe86b3f$var$Icon, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($ch13p))),
                "aria-label": formatMessage((0, $49IyY.default).usersTileLabel)
            }),
            heading: numOfImportedUsers > 0 ? formatMessage((0, $49IyY.default).usersTileHeading, {
                numOfUniqueImported: numOfUniqueImportedUsers
            }) : formatMessage((0, $49IyY.default).noUsersTileTitle),
            description: descriptionForUsersTile,
            testId: "project-create-importer-upload-flow.ui.review-screen-standard.review-tiles.users",
            hasBoxShadow: false
        })), [
        descriptionForUsersTile,
        formatMessage,
        numOfImportedUsers,
        numOfUniqueImportedUsers
    ]);
    const issuesTile = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $b7394eaa9fe86b3f$var$cardStyles,
            key: (0, $1pm5p.CSVReviewTilesType).ISSUES
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3taFW.Card), {
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b7394eaa9fe86b3f$var$Icon, {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($fPb9U))),
                "aria-label": formatMessage((0, $49IyY.default).issuesTileLabel)
            }),
            heading: formatMessage((0, $49IyY.default).issuesTileHeading, {
                numOfIssue: numOfIssue
            }),
            description: formatMessage(numOfIssue === '0' ? (0, $49IyY.default).noIssuesTileDescription : (0, $49IyY.default).issuesTileDescription, {
                link: (content)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                        appearance: "link",
                        spacing: "none",
                        target: "_blank",
                        href: (0, $kzTj7.WHAT_IS_AN_ISSUE_LINK)
                    }, content)
            }),
            testId: "project-create-importer-upload-flow.ui.review-screen-standard.review-tiles.issues",
            hasBoxShadow: false
        })), [
        formatMessage,
        numOfIssue
    ]);
    const tilesMap = (0, $eUqFw.useMemo)(()=>({
            [(0, $1pm5p.CSVReviewTilesType).PROJECT_DETAILS]: projectDetailsTile,
            [(0, $1pm5p.CSVReviewTilesType).FIELDS]: fieldsTile,
            [(0, $1pm5p.CSVReviewTilesType).USERS]: usersTile,
            [(0, $1pm5p.CSVReviewTilesType).ISSUES]: issuesTile
        }), [
        fieldsTile,
        issuesTile,
        projectDetailsTile,
        usersTile
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $b7394eaa9fe86b3f$var$wrapperStyles
    }, tiles.map((type)=>tilesMap[type]));
};
const $b7394eaa9fe86b3f$var$wrapperStyles = (0, $1ZAYh.xcss)({
    width: '100%',
    paddingTop: 'space.300',
    paddingBottom: 'space.300'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b7394eaa9fe86b3f$var$Icon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1nrf",
            __cmplp.className
        ])
    });
});
const $b7394eaa9fe86b3f$var$cardStyles = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.100'
});

});
parcelRegister("fPb9U", function(module, exports) {
module.exports = new URL("Cards.c45ee53b.svg", import.meta.url).toString();

});

parcelRegister("OnUJW", function(module, exports) {
module.exports = new URL("FieldIllustration.a260a224.svg", import.meta.url).toString();

});

parcelRegister("4g60v", function(module, exports) {
module.exports = new URL("ProjectIllustration.ed7746df.svg", import.meta.url).toString();

});

parcelRegister("ch13p", function(module, exports) {
module.exports = new URL("ReviewImportUsers.eb38cff6.svg", import.meta.url).toString();

});

parcelRegister("3taFW", function(module, exports) {

$parcel$export(module.exports, "Card", () => $08af5b08e4f84043$export$60332b2344f7fe41);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $PdmhA = parcelRequire("PdmhA");
const $08af5b08e4f84043$export$60332b2344f7fe41 = ({ icon: icon, rightActions: rightActions, onClick: onClick, heading: heading, description: description, testId: testId, hasBoxShadow: hasBoxShadow = true, isDisabled: isDisabled = false })=>{
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($08af5b08e4f84043$var$IconWrapper, null, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($08af5b08e4f84043$var$ContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($08af5b08e4f84043$var$Header, null, heading), description && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($08af5b08e4f84043$var$Description, null, description)), rightActions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($08af5b08e4f84043$var$ActionWrapper, null, rightActions));
    return onClick && !isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($08af5b08e4f84043$var$ButtonWrapper, {
        onClick: onClick,
        "data-testid": testId
    }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($08af5b08e4f84043$var$Wrapper, {
        "data-testid": testId,
        hasBoxShadow: hasBoxShadow
    }, content);
};
const $08af5b08e4f84043$var$commonWrapperStyling = {
    display: 'flex',
    flexFlow: 'row',
    alignItems: 'center',
    borderRadius: '8px',
    marginTop: "var(--ds-space-100, 8px)",
    position: 'relative',
    width: '100%',
    minHeight: "var(--ds-space-1000, 80px)",
    boxShadow: "var(--ds-shadow-raised, 0px 1px 1px rgba(9, 30, 66, 0.25),0px 0px 1px rgba(9, 30, 66, 0.31))",
    backgroundColor: `${`var(--ds-surface, ${(0, $PdmhA).N0})`}`
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $08af5b08e4f84043$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasBoxShadow: hasBoxShadow, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1n261q9c _4cvr1h6o _2rkoftgi _19pku2gc _kqswh2mm _1bsb1osq _1tke1epz _16qs13qd _bfhkvuon",
            __cmplp.hasBoxShadow ? "_16qs13qd" : "_16qsjen4",
            __cmplp.className
        ])
    });
});
const $08af5b08e4f84043$var$ButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1n261q9c _4cvr1h6o _2rkoftgi _19pku2gc _kqswh2mm _1bsb1osq _1tke1epz _16qs13qd _bfhkvuon _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _80omtlke _y3gn1e5h _1dbzf3fk",
            __cmplp.className
        ])
    });
});
const $08af5b08e4f84043$var$IconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _kqswstnw _1bsb1epz _4t3i1osq _bfhk10p6 _13liu2gc _mrkbu2gc",
            __cmplp.className
        ])
    });
});
const $08af5b08e4f84043$var$ContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1yt414j4 _1bto1l2s _1bahv2br _18u01epz",
            __cmplp.className
        ])
    });
});
const $08af5b08e4f84043$var$Header = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _11c81bk4 _syaz1a45 _n3td1b66",
            __cmplp.className
        ])
    });
});
const $08af5b08e4f84043$var$Description = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1y6m _11c8qk37 _1tke1tcg _syaz1a45 _o5721jtm",
            __cmplp.className
        ])
    });
});
const $08af5b08e4f84043$var$ActionWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbka7h _1e0c1txw _4cvr1h6o _1bah1h6o _1ul9oahv",
            __cmplp.className
        ])
    });
});

});

parcelRegister("6x0nK", function(module, exports) {

$parcel$export(module.exports, "useCSVReviewData", () => $67e26821b10a87b1$export$ce11a3416778e189);

var $lyOYo = parcelRequire("lyOYo");

var $ggKAj = parcelRequire("ggKAj");
var $bj4JM = parcelRequire("bj4JM");

var $8JicK = parcelRequire("8JicK");
const $67e26821b10a87b1$export$51ccef250b6feaa9 = (0, $bj4JM.createSelector)((state)=>state.mappingState, (newState)=>{
    if (newState === null) return {
        numOfImportedFields: 0,
        numOfTotalFields: 0,
        numOfExistingFields: 0,
        numOfCustomFields: 0,
        numOfImportedUsers: 0,
        numOfUniqueImportedUsers: 0,
        numOfTotalUsers: 0,
        numOfIssue: null
    };
    const numOfTotalFields = newState.columnOrder.length;
    const numOfExistingFields = newState.columnOrder.filter((colName)=>newState.columns[colName].field?.fieldId).length;
    const numOfCustomFields = newState.columnOrder.filter((colName)=>newState.columns[colName].field && !newState.columns[colName].field?.fieldId).length;
    const numOfTotalUsers = newState.shouldImportUsers && newState.userMapping ? Object.keys(newState.userMapping).length : 0;
    const numOfImportedUsers = newState.shouldImportUsers && newState.userMapping ? Object.values(newState.userMapping).filter((user)=>user.userValue).length : 0;
    const numOfUniqueImportedUsers = newState.shouldImportUsers && newState.userMapping ? (0, (/*@__PURE__*/$parcel$interopDefault($lyOYo)))(Object.values(newState.userMapping), 'userValue').filter((user)=>user.userValue).length : 0;
    return {
        numOfImportedFields: numOfExistingFields + numOfCustomFields,
        numOfTotalFields: numOfTotalFields,
        numOfExistingFields: numOfExistingFields,
        numOfCustomFields: numOfCustomFields,
        numOfImportedUsers: numOfImportedUsers,
        numOfUniqueImportedUsers: numOfUniqueImportedUsers,
        numOfTotalUsers: numOfTotalUsers,
        numOfIssue: newState.issueCount
    };
});
const $67e26821b10a87b1$export$ce11a3416778e189 = (0, $ggKAj.createHook)((0, $8JicK.Store), {
    selector: $67e26821b10a87b1$export$51ccef250b6feaa9
});

});

parcelRegister("49IyY", function(module, exports) {

$parcel$export(module.exports, "default", () => $5488f18ffe823122$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5488f18ffe823122$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    projectDetailsTileLabel: {
        "id": "project-create-importer-upload-flow.review-screen-standard.review-tiles.project-details-tile-label",
        "defaultMessage": "Project"
    },
    projectDetailsTileHeading: {
        "id": "project-create-importer-upload-flow.review-screen-standard.review-tiles.project-details-tile-heading",
        "defaultMessage": "1 Jira project: {projectName}"
    },
    projectDetailsTileDescription: {
        "id": "project-create-importer-upload-flow.review-screen-standard.review-tiles.project-details-tile-description",
        "defaultMessage": "A {projectStyle} {projectType} project{projectTemplate} will be created"
    },
    fieldTileLabel: {
        "id": "project-create-importer-upload-flow.review-screen-standard.review-tiles.field-tile-label",
        "defaultMessage": "Fields"
    },
    fieldTileHeading: {
        "id": "project-create-importer-upload-flow.review-screen-standard.review-tiles.field-tile-heading",
        "defaultMessage": "{numOfImported}/{numOfTotal} {numOfTotal, plural, one {field} other {fields}}"
    },
    fieldTileDescription: {
        "id": "project-create-importer-upload-flow.review-screen-standard.review-tiles.field-tile-description",
        "defaultMessage": "{numOfExistingFields} {numOfExistingFields, plural, one {column} other {columns}} will be mapped to existing Jira fields"
    },
    fieldTileDescriptionForCustomField: {
        "id": "project-create-importer-upload-flow.review-screen-standard.review-tiles.field-tile-description-for-custom-field",
        "defaultMessage": " and {numOfCustomFields} {numOfCustomFields, plural, one {custom field} other {custom fields}} will be created"
    },
    usersTileLabel: {
        "id": "project-create-importer-upload-flow.review-screen-standard.review-tiles.users-tile-label",
        "defaultMessage": "Users"
    },
    usersTileHeading: {
        "id": "project-create-importer-upload-flow.review-screen-standard.review-tiles.users-tile-heading",
        "defaultMessage": "{numOfUniqueImported} {numOfUniqueImported, plural, one {user} other {users}}"
    },
    usersTileDescription: {
        "id": "project-create-importer-upload-flow.review-screen-standard.review-tiles.users-tile-description",
        "defaultMessage": "{numOfImported}/{numOfTotal} {numOfTotal, plural, one {user row} other {user rows}} have been mapped."
    },
    usersTileMoreDescription: {
        "id": "project-create-importer-upload-flow.review-screen-standard.review-tiles.users-tile-more-description",
        "defaultMessage": "{numOfUniqueImported} {numOfUniqueImported, plural, one {unique user} other {unique users}} will be moved to Jira."
    },
    noUsersTileTitle: {
        "id": "project-create-importer-upload-flow.review-screen-standard.review-tiles.no-users-tile-title",
        "defaultMessage": "No users"
    },
    noUsersTileDescription: {
        "id": "project-create-importer-upload-flow.review-screen-standard.review-tiles.no-users-tile-description",
        "defaultMessage": "You haven\u2019t added users to the project. Assignee and reporter fields will be unassigned and user @mentions in comments will be converted to plain text."
    },
    issuesTileLabel: {
        "id": "project-create-importer-upload-flow.review-screen-standard.review-tiles.issues-tile-label",
        "defaultMessage": "Issues"
    },
    issuesTileHeading: {
        "id": "project-create-importer-upload-flow.review-screen-standard.review-tiles.issues-tile-heading",
        "defaultMessage": "{numOfIssue} {numOfIssue, plural, one {issue} other {issues}}"
    },
    issuesTileDescription: {
        "id": "project-create-importer-upload-flow.review-screen-standard.review-tiles.issues-tile-description",
        "defaultMessage": "Each row of the CSV data will be imported as an issue. <link>What is an issue?</link>"
    },
    noIssuesTileDescription: {
        "id": "project-create-importer-upload-flow.review-screen-standard.review-tiles.no-issues-tile-description",
        "defaultMessage": "The CSV file doesn\u2019t contain any data. Upload a CSV file with your team\u2019s data to import them as an issue. <link>What is an issue?</link>"
    },
    business: {
        "id": "project-create-importer-upload-flow.review-screen-standard.review-tiles.business",
        "defaultMessage": "business"
    },
    software: {
        "id": "project-create-importer-upload-flow.review-screen-standard.review-tiles.software",
        "defaultMessage": "software"
    },
    cmp: {
        "id": "project-create-importer-upload-flow.review-screen-standard.review-tiles.cmp",
        "defaultMessage": "company-managed"
    },
    tmp: {
        "id": "project-create-importer-upload-flow.review-screen-standard.review-tiles.tmp",
        "defaultMessage": "team-managed"
    },
    usersTileWarningDescription: {
        "id": "project-create-importer-upload-flow.review-screen-standard.review-tiles.users-tile-warning-description",
        "defaultMessage": "You don\u2019t have permission to invite new users. Any information provided about new users will not be imported."
    }
});

});

parcelRegister("6GEcx", function(module, exports) {

$parcel$export(module.exports, "useContent", () => $aadc2b97289e11c4$export$ee83783e2ce4cc63);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $7ZZxN = parcelRequire("7ZZxN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1pm5p = parcelRequire("1pm5p");

var $49IyY = parcelRequire("49IyY");
const $aadc2b97289e11c4$export$ee83783e2ce4cc63 = (projectData)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const projectTypeDisplayNames = (0, $eUqFw.useMemo)(()=>({
            [(0, $7ZZxN.CORE_PROJECT)]: formatMessage((0, $49IyY.default).business),
            [(0, $7ZZxN.SOFTWARE_PROJECT)]: formatMessage((0, $49IyY.default).software),
            [(0, $7ZZxN.CUSTOMER_SERVICE_PROJECT)]: '',
            [(0, $7ZZxN.SERVICE_DESK_PROJECT)]: '',
            [(0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT)]: ''
        }), [
        formatMessage
    ]);
    const projectStyleDisplayNames = (0, $eUqFw.useMemo)(()=>({
            [(0, $7ZZxN.COMPANY_MANAGED_PROJECT)]: formatMessage((0, $49IyY.default).cmp),
            [(0, $7ZZxN.TEAM_MANAGED_PROJECT)]: formatMessage((0, $49IyY.default).tmp)
        }), [
        formatMessage
    ]);
    const projectTypeDisplayName = projectData.type && projectTypeDisplayNames[projectData.type] ? projectTypeDisplayNames[projectData.type] : '';
    const projectStyleDisplayName = projectData.style ? projectStyleDisplayNames[projectData.style] : '';
    const selectedTemplate = projectData.template ? (0, $1pm5p.templatesJSW).find((template)=>template.key === projectData.template) : null;
    return {
        projectType: projectTypeDisplayName,
        projectStyle: projectStyleDisplayName,
        projectTemplate: selectedTemplate ? ` (${formatMessage(selectedTemplate.title)})` : ''
    };
};

});



parcelRegister("lGXk2", function(module, exports) {

$parcel$export(module.exports, "SelectProductScreen", () => $7cd067b4dd361d78$export$dd5f19fa5f8674ce);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $2Q5Ee = parcelRequire("2Q5Ee");

var $1kt3H = parcelRequire("1kt3H");

var $77CtJ = parcelRequire("77CtJ");
var $ecIoc = parcelRequire("ecIoc");

var $7ZZxN = parcelRequire("7ZZxN");

var $3x4sL = parcelRequire("3x4sL");

var $bSvLR = parcelRequire("bSvLR");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kzTj7 = parcelRequire("kzTj7");

var $3yuWi = parcelRequire("3yuWi");

var $9R4E5 = parcelRequire("9R4E5");

var $1VyqP = parcelRequire("1VyqP");

var $cFy8W = parcelRequire("cFy8W");

var $aWLVm = parcelRequire("aWLVm");

var $deAmo = parcelRequire("deAmo");

var $d0wrd = parcelRequire("d0wrd");

var $fLTcC = parcelRequire("fLTcC");

var $8NuTr = parcelRequire("8NuTr");
const $7cd067b4dd361d78$export$dd5f19fa5f8674ce = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [, { setProjectType: setProjectType }] = (0, $d0wrd.useProjectData)();
    const onJWMSelected = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'x2cBusinessProjectTile'
        }));
        setProjectType((0, $9R4E5.ProjectTypes).BUSINESS);
    }, [
        createAnalyticsEvent,
        setProjectType
    ]);
    const onJSWSelected = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'x2cSoftwareProjectTile'
        }));
        setProjectType((0, $9R4E5.ProjectTypes).SOFTWARE);
    }, [
        createAnalyticsEvent,
        setProjectType
    ]);
    const onJSMSelected = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'x2cServiceDeskProjectTile'
        }));
        window.open((0, $kzTj7.IMPORT_URL_SUFFIX), '_blank');
    }, [
        createAnalyticsEvent
    ]);
    const { availableProducts: availableProducts } = (0, $deAmo.default)();
    const handleLinkClick = (0, $eUqFw.useCallback)((event)=>{
        event.stopPropagation();
    }, []);
    const products = (0, $eUqFw.useMemo)(()=>[
            {
                key: (0, $7ZZxN.CORE_PROJECT),
                heading: (0, $fLTcC.default).jwmProductHeading,
                description: (0, $fLTcC.default).jwmProductDescription,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1kt3H))), {
                    label: "Jira",
                    primaryColor: "var(--ds-text-accent-blue, #0052CC)",
                    size: "xlarge"
                }),
                teams: [
                    (0, $fLTcC.default).marketing,
                    (0, $fLTcC.default).design,
                    (0, $fLTcC.default).hr,
                    (0, $fLTcC.default).legal
                ],
                footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7cd067b4dd361d78$var$PoweredByLinkWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3x4sL.FormattedI18nMessage), {
                    message: formatMessage((0, $fLTcC.default).poweredByJwmSpork, {
                        linkStart: '{linkStart}',
                        linkEnd: '{linkEnd}'
                    }),
                    componentsMapping: {
                        link: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77CtJ.JiraIcon), {
                                size: "xsmall",
                                appearance: "brand"
                            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                                href: (0, $kzTj7.JIRA_WAC_LINK),
                                target: "_blank",
                                onClick: handleLinkClick
                            }, children))
                    }
                })),
                onClick: onJWMSelected
            },
            {
                key: (0, $7ZZxN.SOFTWARE_PROJECT),
                heading: (0, $fLTcC.default).jswProductHeadingNew,
                description: (0, $fLTcC.default).jswProductDescription,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2Q5Ee))), {
                    label: "Jira",
                    primaryColor: "var(--ds-text-accent-blue, #0052CC)",
                    size: "xlarge"
                }),
                teams: [
                    (0, $fLTcC.default).software,
                    (0, $fLTcC.default).agile,
                    (0, $fLTcC.default).devops
                ],
                footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7cd067b4dd361d78$var$PoweredByLinkWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3x4sL.FormattedI18nMessage), {
                    message: formatMessage((0, $fLTcC.default).poweredByJswSpork, {
                        linkStart: '{linkStart}',
                        linkEnd: '{linkEnd}'
                    }),
                    componentsMapping: {
                        link: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77CtJ.JiraIcon), {
                                size: "xsmall",
                                appearance: "brand"
                            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                                href: (0, $kzTj7.JIRA_WAC_LINK),
                                target: "_blank",
                                onClick: handleLinkClick
                            }, children))
                    }
                })),
                onClick: onJSWSelected
            },
            {
                key: (0, $7ZZxN.SERVICE_DESK_PROJECT),
                heading: (0, $fLTcC.default).jsmProductHeading,
                description: (0, $fLTcC.default).jsmProductDescription,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bSvLR.default), {
                    label: "Jira",
                    primaryColor: "var(--ds-text-accent-blue, #0052CC)",
                    size: "xlarge"
                }),
                teams: [
                    (0, $fLTcC.default).it,
                    (0, $fLTcC.default).hr,
                    (0, $fLTcC.default).marketing,
                    (0, $fLTcC.default).facilities
                ],
                footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7cd067b4dd361d78$var$PoweredByLinkWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3x4sL.FormattedI18nMessage), {
                    message: formatMessage((0, $fLTcC.default).poweredByJsm, {
                        linkStart: '{linkStart}',
                        linkEnd: '{linkEnd}'
                    }),
                    componentsMapping: {
                        link: ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ecIoc.JiraServiceManagementIcon), {
                                size: "xsmall",
                                appearance: "brand"
                            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                                href: (0, $kzTj7.JSM_WAC_LINK),
                                target: "_blank",
                                onClick: handleLinkClick
                            }, children))
                    }
                })),
                onClick: onJSMSelected
            }
        ].filter((product)=>availableProducts.has(product.key)), [
        formatMessage,
        onJWMSelected,
        onJSWSelected,
        onJSMSelected,
        handleLinkClick,
        availableProducts
    ]);
    // TODO: If user is not SITE_ADMIN, redirect to JWM upload screen immediately as they can't use the legacy importer
    if ((0, $aWLVm.hasOnlyJWMLicense)(availableProducts)) {
        // If instance only has JWM license, skip Project select step
        onJWMSelected();
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: (0, $3yuWi.X2C_SCREENS).SELECT_PRODUCT,
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7cd067b4dd361d78$var$Wrapper, {
        "data-testid": "project-create-importer-upload-flow.ui.select-product-screen.wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1VyqP.PageHeading), null, formatMessage((0, $fLTcC.default).heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1VyqP.PageDescription), null, formatMessage((0, $fLTcC.default).description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7cd067b4dd361d78$var$ProductTileWrapper, null, products.map(({ key: key, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8NuTr.ProductTile), {
            key: key,
            product: key,
            ...props
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7cd067b4dd361d78$var$FooterWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cFy8W.SwitchBackToOldExperienceLink), {
        content: formatMessage((0, $fLTcC.default).importIntoExistingJiraProject)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7cd067b4dd361d78$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41lqb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7cd067b4dd361d78$var$ProductTileWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1fhb _1n261g80 _19pkxy5q",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7cd067b4dd361d78$var$FooterWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _19pk1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7cd067b4dd361d78$var$PoweredByLinkWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _19pkutpp _syaz1thw _1wyb1skh _1mil1nxw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bSvLR", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4177b0b7cffa982$export$2e2bcd8739ae039);
/**
 * Based on custom icon example:
 * https://atlassian.design/components/icon/custom-icon/examples
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $a4177b0b7cffa982$var$JSMLifeSaverGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 40 40",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line jira/react/no-classname-attribute, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        "clip-path": "url(#clip0_5852_7911)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M11.9885 17.3889V17.5556C12.3936 16.1725 13.1356 14.9116 14.1478 13.8857C15.1601 12.8599 16.411 12.1013 17.7885 11.6778H17.7219V2.13333C13.8757 2.69528 10.3135 4.48345 7.56497 7.232C4.81643 9.98054 3.02826 13.5427 2.46631 17.3889H11.9885Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M22.9443 11.7C24.2796 12.1219 25.4937 12.8592 26.4839 13.8494C27.4741 14.8396 28.2113 16.0536 28.6332 17.3889H38.1999C37.6379 13.5427 35.8498 9.98054 33.1012 7.232C30.3527 4.48345 26.7905 2.69528 22.9443 2.13333V11.7Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M28.6332 22.6111C28.2121 23.9468 27.4752 25.1613 26.4849 26.1516C25.4946 27.142 24.2801 27.8789 22.9443 28.3V37.8667C26.7905 37.3047 30.3527 35.5165 33.1012 32.768C35.8498 30.0195 37.6379 26.4573 38.1999 22.6111H28.6332Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M17.7219 28.3C16.3746 27.8756 15.1508 27.1299 14.1558 26.1272C13.1609 25.1245 12.4247 23.895 12.0108 22.5444V22.6222H2.46631C3.03046 26.4664 4.8196 30.0261 7.56796 32.7724C10.3163 35.5188 13.8773 37.3053 17.7219 37.8667V28.3Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        opacity: "0.5"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.5",
        d: "M11.6441 20C11.6467 19.1761 11.7664 18.3568 11.9997 17.5667V17.4H2.55523C1.96586 17.4 1.40063 17.6341 0.983882 18.0509C0.567134 18.4676 0.333008 19.0329 0.333008 19.6222L0.333008 20.4C0.333008 20.9894 0.567134 21.5546 0.983882 21.9714C1.40063 22.3881 1.96586 22.6222 2.55523 22.6222H12.0219V22.5445C11.7704 21.7197 11.6431 20.8622 11.6441 20Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.5",
        d: "M20.3328 11.3C21.2185 11.2995 22.099 11.4344 22.9439 11.7V2.22222C22.9439 1.63285 22.7098 1.06762 22.293 0.650874C21.8763 0.234126 21.3111 0 20.7217 0L19.9439 0C19.3545 0 18.7893 0.234126 18.3726 0.650874C17.9558 1.06762 17.7217 1.63285 17.7217 2.22222V11.6889H17.7883C18.6125 11.4337 19.47 11.3026 20.3328 11.3Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.5",
        d: "M28.6328 17.3889C29.1662 19.0888 29.1662 20.9112 28.6328 22.6111H38.1106C38.7 22.6111 39.2652 22.377 39.6819 21.9602C40.0987 21.5435 40.3328 20.9783 40.3328 20.3889V19.6111C40.3328 19.0217 40.0987 18.4565 39.6819 18.0398C39.2652 17.623 38.7 17.3889 38.1106 17.3889H28.6328Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        opacity: "0.5",
        d: "M20.3328 28.7C19.4471 28.7005 18.5666 28.5656 17.7217 28.3V37.7778C17.7217 38.3671 17.9558 38.9324 18.3726 39.3491C18.7893 39.7659 19.3545 40 19.9439 40H20.7217C21.3111 40 21.8763 39.7659 22.293 39.3491C22.7098 38.9324 22.9439 38.3671 22.9439 37.7778V28.3C22.099 28.5656 21.2185 28.7005 20.3328 28.7Z",
        fill: "currentColor"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip0_5852_7911"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "48",
        height: "48",
        fill: "white",
        transform: "translate(0.333008)"
    }))));
const $a4177b0b7cffa982$var$JSMLifeSaverIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        ...props,
        glyph: $a4177b0b7cffa982$var$JSMLifeSaverGlyph
    });
var $a4177b0b7cffa982$export$2e2bcd8739ae039 = $a4177b0b7cffa982$var$JSMLifeSaverIcon;

});

parcelRegister("cFy8W", function(module, exports) {

$parcel$export(module.exports, "SwitchBackToOldExperienceLink", () => $9b96b5ddb42c9640$export$f144ec7c50bc281f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $1ybV0 = parcelRequire("1ybV0");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kJlBc = parcelRequire("kJlBc");

var $kzTj7 = parcelRequire("kzTj7");
const $9b96b5ddb42c9640$export$f144ec7c50bc281f = ({ content: content })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [{ location: location }] = (0, $kJlBc.useRouter)();
    const onClick = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'switchToOldExperienceLink'
        }));
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9b96b5ddb42c9640$var$Link, {
        href: (0, $kzTj7.IMPORT_URL_SUFFIX),
        "data-testid": "project-create-importer-upload-flow.common.ui.old-experience-link.link",
        onClick: onClick,
        ...(location.pathname !== (0, $kzTj7.NEW_EXTERNAL_IMPORT_URL) || !(0, $1ybV0.ff)('x2c-jim-home-screen-replacement_eikwe')) && {
            target: '_blank'
        }
    }, content);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9b96b5ddb42c9640$var$Link = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz14q2",
            __cmplp.className
        ])
    });
});

});

parcelRegister("deAmo", function(module, exports) {

$parcel$export(module.exports, "default", () => $f363fb20d7a7d1ad$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gd0Sp = parcelRequire("gd0Sp");

var $aWLVm = parcelRequire("aWLVm");
const $f363fb20d7a7d1ad$var$useAvailableProducts = ()=>{
    const { licensedProducts: licensedProducts } = (0, $gd0Sp.useTenantContext)();
    const availableProducts = (0, $eUqFw.useMemo)(()=>(0, $aWLVm.getSetOfProductsAvailable)(licensedProducts), [
        licensedProducts
    ]);
    return {
        availableProducts: availableProducts
    };
};
var $f363fb20d7a7d1ad$export$2e2bcd8739ae039 = $f363fb20d7a7d1ad$var$useAvailableProducts;

});

parcelRegister("fLTcC", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfff445a9ac65c61$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $bfff445a9ac65c61$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    jwmProductHeading: {
        "id": "project-create-importer-upload-flow.select-product-screen.jwm-product-heading",
        "defaultMessage": "Import into a new business project"
    },
    jwmProductDescription: {
        "id": "project-create-importer-upload-flow.select-product-screen.jwm-product-description",
        "defaultMessage": "Manage your work using list, board, calendar, or timeline view."
    },
    jswProductHeadingNew: {
        "id": "project-create-importer-upload-flow.select-product-screen.jsw-product-heading-new",
        "defaultMessage": "Import into a new software project"
    },
    jswProductDescription: {
        "id": "project-create-importer-upload-flow.select-product-screen.jsw-product-description",
        "defaultMessage": "Manage development processes with agile and DevOps practices."
    },
    jsmProductHeading: {
        "id": "project-create-importer-upload-flow.select-product-screen.jsm-product-heading",
        "defaultMessage": "Import to new or existing service projects"
    },
    jsmProductDescription: {
        "id": "project-create-importer-upload-flow.select-product-screen.jsm-product-description",
        "defaultMessage": "Manage incoming requests from multiple channels and respond at scale."
    },
    heading: {
        "id": "project-create-importer-upload-flow.select-product-screen.heading",
        "defaultMessage": "Import data"
    },
    description: {
        "id": "project-create-importer-upload-flow.select-product-screen.description",
        "defaultMessage": "Select how and where you\u2019d like to import your data."
    },
    importIntoExistingJiraProject: {
        "id": "project-create-importer-upload-flow.select-product-screen.import-into-existing-jira-project",
        "defaultMessage": "Import into an existing Jira project"
    },
    marketing: {
        "id": "project-create-importer-upload-flow.select-product-screen.marketing",
        "defaultMessage": "Marketing"
    },
    design: {
        "id": "project-create-importer-upload-flow.select-product-screen.design",
        "defaultMessage": "Design"
    },
    hr: {
        "id": "project-create-importer-upload-flow.select-product-screen.hr",
        "defaultMessage": "HR"
    },
    legal: {
        "id": "project-create-importer-upload-flow.select-product-screen.legal",
        "defaultMessage": "Legal"
    },
    software: {
        "id": "project-create-importer-upload-flow.select-product-screen.software",
        "defaultMessage": "Software"
    },
    agile: {
        "id": "project-create-importer-upload-flow.select-product-screen.agile",
        "defaultMessage": "Agile"
    },
    devops: {
        "id": "project-create-importer-upload-flow.select-product-screen.devops",
        "defaultMessage": "Devops"
    },
    it: {
        "id": "project-create-importer-upload-flow.select-product-screen.it",
        "defaultMessage": "IT"
    },
    facilities: {
        "id": "project-create-importer-upload-flow.select-product-screen.facilities",
        "defaultMessage": "Facilities"
    },
    poweredByJwmSpork: {
        "id": "project-create-importer-upload-flow.select-product-screen.powered-by-jwm-spork",
        "defaultMessage": "Powered by {linkStart}Jira{linkEnd}"
    },
    poweredByJswSpork: {
        "id": "project-create-importer-upload-flow.select-product-screen.powered-by-jsw-spork",
        "defaultMessage": "Powered by {linkStart}Jira{linkEnd}"
    },
    poweredByJsm: {
        "id": "project-create-importer-upload-flow.select-product-screen.powered-by-jsm",
        "defaultMessage": "Powered by {linkStart}Jira Service Management{linkEnd}"
    }
});

});

parcelRegister("8NuTr", function(module, exports) {

$parcel$export(module.exports, "ProductTile", () => $1d175ff74cfb7de5$export$300c95c2b37c13cb);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $ffiyv = parcelRequire("ffiyv");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hkVNf = parcelRequire("hkVNf");
const $1d175ff74cfb7de5$export$300c95c2b37c13cb = ({ heading: heading, description: description, icon: icon, footer: footer, teams: teams, onClick: onClick, product: product })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1d175ff74cfb7de5$var$Wrapper, {
        "data-testid": "project-create-importer-upload-flow.ui.select-product-screen.product-tile.wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        onClick: onClick,
        testId: `project-create-importer-upload-flow.ui.select-product-screen.product-tile.button-${product}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1d175ff74cfb7de5$var$ContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $1d175ff74cfb7de5$var$iconWrapperStyles
    }, icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1d175ff74cfb7de5$var$Heading, null, formatMessage(heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1d175ff74cfb7de5$var$Description, null, formatMessage(description))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1d175ff74cfb7de5$var$FooterWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1d175ff74cfb7de5$var$Line, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, formatMessage((0, $hkVNf.default).idealFor)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1d175ff74cfb7de5$var$TeamLozengeWrapper, null, teams.map((team)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
            key: formatMessage(team),
            appearance: "default"
        }, formatMessage(team)))), footer)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1d175ff74cfb7de5$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8u2gc _bfhkvuon _2rkoftgi _16qs13qd _1138nklw _t74o1osq _hyh1pxbi _1py6ftgi _18iz1fhb _bt2c1txw _1u9n1bp4 _1x5v1yb4 _3t83vuon _1dbzf3fk",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1d175ff74cfb7de5$var$ContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _18s8jxsc _1tke5jys",
            __cmplp.className
        ])
    });
});
const $1d175ff74cfb7de5$var$iconWrapperStyles = (0, $1ZAYh.xcss)({
    marginBottom: 'space.300'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1d175ff74cfb7de5$var$Heading = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48pni7l _1wyb7vkz _19pkidpf _2hwxidpf _otyridpf _18u0idpf _y3gn1h6o _1bsb1osq _1i4q1hna _o5724jg8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1d175ff74cfb7de5$var$Description = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1osq _19pkpxbi _y3gn1h6o _o5724jg8 _vwz4gktf _k48p1nn1 _syaznoz8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1d175ff74cfb7de5$var$Line = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1b66 _bfhk1cs6 _2rkot94y _otyr1ejb _19pkxy5q",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1d175ff74cfb7de5$var$TeamLozengeWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1n261g80 _4cvr1h6o _1bah1h6o _1mil1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1d175ff74cfb7de5$var$FooterWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _syaz46h0 _k48p1nn1 _1wybdlk8",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hkVNf", function(module, exports) {

$parcel$export(module.exports, "default", () => $09983dee3f11deb8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $09983dee3f11deb8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    importToHeading: {
        "id": "project-create-importer-upload-flow.select-product-screen.product-tile.import-to-heading",
        "defaultMessage": "Import to {productName}"
    },
    idealFor: {
        "id": "project-create-importer-upload-flow.select-product-screen.product-tile.ideal-for",
        "defaultMessage": "Ideal for:"
    }
});

});



parcelRegister("9Qxbv", function(module, exports) {

$parcel$export(module.exports, "SelectSourceScreen", () => $0245829da4caee60$export$981c31887ee92b8e);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $4Ywu9 = parcelRequire("4Ywu9");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $3yuWi = parcelRequire("3yuWi");


var $2sRUp = parcelRequire("2sRUp");

var $fRSBs = parcelRequire("fRSBs");

var $c3Eti = parcelRequire("c3Eti");
const $0245829da4caee60$export$981c31887ee92b8e = ({ onNext: onNext })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [source] = (0, $2sRUp.useSource)();
    const skipSourceSelection = source === (0, $85ba070c29b4a3bd$export$44f7961a4c8dc451);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: (0, $3yuWi.X2C_SCREENS).SELECT_SOURCE_SCREEN,
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $0245829da4caee60$var$wrapperStyles,
        testId: "project-create-importer-upload-flow.ui.select-source-screen.wrapper"
    }, !skipSourceSelection && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $0245829da4caee60$var$headingWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $0245829da4caee60$var$pageHeadingStyles
    }, formatMessage((0, $fRSBs.default).heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "p"
    }, formatMessage((0, $fRSBs.default).pageDescription))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c3Eti.SourceSection), {
        onNext: onNext,
        skipSourceSelection: skipSourceSelection
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null)));
};
const $0245829da4caee60$var$wrapperStyles = (0, $1ZAYh.xcss)({
    padding: 'space.600',
    backgroundColor: 'elevation.surface',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    borderLeft: `solid 1px ${`var(--ds-border, ${(0, $PdmhA).N30})`}`,
    width: '100%',
    overflowY: 'auto',
    [(0, $4Ywu9.media).above.lg]: {
        paddingInline: 'space.1000'
    }
});
const $0245829da4caee60$var$headingWrapperStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.300',
    marginBottom: 'space.100'
});
const $0245829da4caee60$var$pageHeadingStyles = (0, $1ZAYh.xcss)({
    font: "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    marginBottom: 'space.300'
});

});
parcelRegister("fRSBs", function(module, exports) {

$parcel$export(module.exports, "default", () => $e48cd0fc54074787$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e48cd0fc54074787$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    heading: {
        "id": "project-create-importer-upload-flow.select-source-screen.heading",
        "defaultMessage": "Import data into Jira"
    },
    pageDescription: {
        "id": "project-create-importer-upload-flow.select-source-screen.page-description",
        "defaultMessage": "Import from any app into a new business or software project. Your imports will not affect current issues and users in Jira."
    }
});

});

parcelRegister("c3Eti", function(module, exports) {

$parcel$export(module.exports, "SourceSection", () => $e2c39ed97fd88274$export$52f53834c7b519ac);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $4lTFP = parcelRequire("4lTFP");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $cHKP9 = parcelRequire("cHKP9");

var $kzTj7 = parcelRequire("kzTj7");

var $PVrB2 = parcelRequire("PVrB2");

var $3ak5x = parcelRequire("3ak5x");


var $4nt6G = parcelRequire("4nt6G");

var $cFy8W = parcelRequire("cFy8W");

var $eft4l = parcelRequire("eft4l");

var $kJWbb = parcelRequire("kJWbb");

var $cDLTA = parcelRequire("cDLTA");

var $9QyvU = parcelRequire("9QyvU");

var $aEdcH = parcelRequire("aEdcH");
var $jFv2N = parcelRequire("jFv2N");

var $asXeB = parcelRequire("asXeB");

var $4OuDF = parcelRequire("4OuDF");

var $2XUTe = parcelRequire("2XUTe");

var $1Uk5t = parcelRequire("1Uk5t");

var $6smTt = parcelRequire("6smTt");

var $fAPM9 = parcelRequire("fAPM9");

var $i3sFc = parcelRequire("i3sFc");
const $e2c39ed97fd88274$export$52f53834c7b519ac = ({ onNext: onNext, skipSourceSelection: skipSourceSelection })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [importType] = (0, $aEdcH.useImportType)();
    const [showFlag, setShowFlag] = (0, $eUqFw.useState)(false);
    const [selectedThirdParty, setSelectedThirdParty] = (0, $eUqFw.useState)(undefined);
    const [searchTerm, setSearchTerm] = (0, $eUqFw.useState)('');
    const [isAuthLoading, setIsAuthLoading] = (0, $eUqFw.useState)(false);
    const { isLoading: isLoading, fetchImporterSource: fetchImporterSource, hasErrorOccurred: hasErrorOccurred } = (0, $4OuDF.useImporterSource)();
    const [sourceItems, { setSourceItems: setSourceItems }] = (0, $jFv2N.useSourceItems)();
    const { oAuthUnsuccessFlagTitle: oAuthUnsuccessFlagTitle, oAuthUnsuccessFlagDescription: oAuthUnsuccessFlagDescription } = (0, $cDLTA.useContentForThirdParty)(selectedThirdParty);
    const { onShowFlag: onShowFlag, onDismissFlag: onDismissFlag } = (0, $9QyvU.useX2CFlag)();
    const startThirdPartyOAuth = (0, $2XUTe.useThirdPartyOAuth)();
    const [, { setRequestAuthenticationToken: setRequestAuthenticationToken }] = (0, $asXeB.useAccessTokenModalState)();
    const { validateAccessToken: validateAccessToken } = (0, $1Uk5t.useThirdPartyAccessTokenStatus)({
        requestAuthenticationToken: setRequestAuthenticationToken
    });
    const isSearchEventSent = (0, $eUqFw.useRef)(false);
    const onFetchImporterSource = (0, $eUqFw.useCallback)(()=>{
        fetchImporterSource().then((data)=>{
            setSourceItems(data || []);
            // If skipSourceSelection and importType is already selected, then directly go to next step
            if (skipSourceSelection && importType) {
                const selectedItem = data?.find((item)=>item.key === importType);
                selectedItem && onNext(selectedItem.key, selectedItem.supportedFlow);
            }
        });
    }, [
        fetchImporterSource,
        importType,
        onNext,
        setSourceItems,
        skipSourceSelection
    ]);
    (0, $eUqFw.useEffect)(()=>{
        !sourceItems && onFetchImporterSource();
    }, [
        onFetchImporterSource,
        sourceItems
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (showFlag) {
            setShowFlag(false);
            oAuthUnsuccessFlagTitle && onShowFlag((0, $kzTj7.OAUTH_UNSUCCESS_FLAG_ID), {
                title: oAuthUnsuccessFlagTitle,
                description: [
                    oAuthUnsuccessFlagDescription,
                    {
                        link: (children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                                href: (0, $kzTj7.CONTACT_ADMIN_LINK),
                                target: "_blank"
                            }, children)
                    }
                ]
            });
        }
    }, [
        formatMessage,
        oAuthUnsuccessFlagDescription,
        oAuthUnsuccessFlagTitle,
        onShowFlag,
        showFlag
    ]);
    const onAuthSuccess = (0, $eUqFw.useCallback)((selectedSource, supportedFlow)=>{
        isAuthLoading && setIsAuthLoading(false);
        onNext(selectedSource, supportedFlow);
    }, [
        isAuthLoading,
        onNext
    ]);
    const handleItemClick = (0, $eUqFw.useCallback)((item)=>async ()=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'X2CSourceButton'
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
                importType: item.name
            });
            onDismissFlag((0, $kzTj7.OAUTH_UNSUCCESS_FLAG_ID));
            if (item.supportedFlow === (0, $d46558193b478af8$export$5a613e161b9e89e5) && (0, $3ak5x.SupportedThirdParties).has(item.key)) {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const selectedItem = item.key;
                selectedThirdParty !== selectedItem && setSelectedThirdParty(selectedItem);
                setIsAuthLoading(true);
                if (item.requiresOAuth) {
                    startThirdPartyOAuth({
                        thirdParty: selectedItem,
                        onSuccess: (source)=>onAuthSuccess(source, item.supportedFlow),
                        onFail: ()=>{
                            setShowFlag(true);
                            setIsAuthLoading(false);
                        }
                    });
                    return;
                }
                if (item.requiresPersonalAccessToken) {
                    validateAccessToken(selectedItem).then((status)=>{
                        if (status === 'VALID') onAuthSuccess(selectedItem, item.supportedFlow);
                        else setRequestAuthenticationToken({
                            thirdParty: selectedItem,
                            modalType: (0, $PVrB2.AccessTokenModalType).ADD_NEW_TOKEN
                        }).then((isSaved)=>{
                            if (isSaved) onAuthSuccess(selectedItem, item.supportedFlow);
                            else setIsAuthLoading(false);
                        });
                    });
                    return;
                }
            }
            onAuthSuccess(item.key, item.supportedFlow);
        }, [
        createAnalyticsEvent,
        onAuthSuccess,
        onDismissFlag,
        selectedThirdParty,
        setRequestAuthenticationToken,
        startThirdPartyOAuth,
        validateAccessToken
    ]);
    const onSearchTermChange = (0, $eUqFw.useCallback)((e)=>{
        setSearchTerm(e.target.value);
        if (!isSearchEventSent.current) {
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'importerSourceSearch searched');
            isSearchEventSent.current = true;
        }
    }, [
        createAnalyticsEvent
    ]);
    const filteredSourceItems = (0, $eUqFw.useMemo)(()=>searchTerm === '' ? sourceItems : sourceItems?.filter((item)=>item.name?.toLocaleLowerCase().includes(searchTerm.toLocaleLowerCase())), [
        searchTerm,
        sourceItems
    ]);
    const sourceItemsForGroup = (0, $eUqFw.useMemo)(()=>{
        if (filteredSourceItems && filteredSourceItems.length > 0) return filteredSourceItems;
        return sourceItems?.filter((item)=>item.name === (0, $3ak5x.CSV));
    }, [
        filteredSourceItems,
        sourceItems
    ]);
    if (isLoading || skipSourceSelection) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingBlockStart: "space.400",
        xcss: $e2c39ed97fd88274$var$contentWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "large",
        testId: "project-create-importer-upload-flow.ui.select-source-screen.source-section.spinner"
    }));
    if (hasErrorOccurred) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $e2c39ed97fd88274$var$errorScreenStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4nt6G.ErrorScreen), {
        testId: "project-create-importer-upload-flow.ui.select-source-screen.source-section.error-screen",
        header: formatMessage((0, $fAPM9.default).errorHeading),
        description: formatMessage((0, $fAPM9.default).errorDescription),
        illustration: (0, (/*@__PURE__*/$parcel$interopDefault($cHKP9))),
        onClick: onFetchImporterSource
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingBlockStart: "space.400",
        testId: "project-create-importer-upload-flow.ui.select-source-screen.source-section.wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $e2c39ed97fd88274$var$searchBarWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eft4l.SearchBar), {
        onSearchTermChange: onSearchTermChange,
        placeholder: (0, $fAPM9.default).searchPlaceholder
    })), filteredSourceItems?.length === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6smTt.EmptyView), null), sourceItemsForGroup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i3sFc.SourceGroup), {
        sourceItems: sourceItemsForGroup,
        renderItem: (item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJWbb.SourceCardItem), {
                key: item.key,
                onClick: handleItemClick(item),
                item: item,
                loading: selectedThirdParty === item.key && isAuthLoading
            })
    }), searchTerm === '' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $e2c39ed97fd88274$var$switchBackToOldExperienceStyles
    }, formatMessage((0, $fAPM9.default).switchBackToOldExperience, {
        link: (content)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cFy8W.SwitchBackToOldExperienceLink), {
                content: content
            })
    })));
};
const $e2c39ed97fd88274$var$errorScreenStyles = (0, $1ZAYh.xcss)({
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    minHeight: '600px'
});
const $e2c39ed97fd88274$var$contentWrapperStyles = (0, $1ZAYh.xcss)({
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    minHeight: '200px'
});
const $e2c39ed97fd88274$var$searchBarWrapperStyles = (0, $1ZAYh.xcss)({
    height: 'space.400',
    width: '240px',
    marginBottom: 'space.400'
});
const $e2c39ed97fd88274$var$switchBackToOldExperienceStyles = (0, $1ZAYh.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    font: `var(--ds-font-body, ${(0, $4lTFP.fontFallback).body.medium})`,
    color: 'color.text',
    paddingTop: 'space.100'
});

});
parcelRegister("kJWbb", function(module, exports) {

$parcel$export(module.exports, "SourceCardItem", () => $b1406cef26b31f4c$export$b55bccee5b44cd61);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $7J5LG = parcelRequire("7J5LG");
const $b1406cef26b31f4c$export$b55bccee5b44cd61 = ({ onClick: onClick, item: item, loading: loading })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b1406cef26b31f4c$var$ButtonWrapper, {
        onClick: ()=>onClick(item),
        "aria-label": item.name,
        loading: loading,
        disabled: loading
    }, loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "small",
        testId: "project-create-importer-upload-flow.common.ui.source-card-item.spinner"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (0, $7J5LG.renderIcon)(item.icon, true), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingInlineStart: "space.100",
        as: "span",
        xcss: $b1406cef26b31f4c$var$serviceNameStyles
    }, item.name)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b1406cef26b31f4c$var$ButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _2lx2vrvc _bfhk15cr _19iti1qc _2rko1y44 _1yt4pxbi _1bsbuuw1 _4t3i8vuz _irr3166n _q4zt1yqz _1di6fg4m _1q5t1r31 _1ohyglyw _1r9x1o36",
            __cmplp.loading ? "_1bah1h6o" : "_1bah1y6m",
            __cmplp.className
        ])
    });
});
const $b1406cef26b31f4c$var$serviceNameStyles = (0, $1ZAYh.xcss)({
    font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    color: 'color.text.subtle'
});

});

parcelRegister("9QyvU", function(module, exports) {

$parcel$export(module.exports, "useX2CFlag", () => $1cdad4af3fe21427$export$8721c742cda88266);

var $eUqFw = parcelRequire("eUqFw");

var $k8Qyf = parcelRequire("k8Qyf");

var $kzTj7 = parcelRequire("kzTj7");

var $71Evi = parcelRequire("71Evi");
const $1cdad4af3fe21427$var$getSuccessFlag = (props)=>({
        id: (0, $kzTj7.MAPPING_FIELD_UPDATE_SUCCESS_FLAG_ID),
        type: 'success',
        isAutoDismiss: true,
        title: '',
        ...props
    });
const $1cdad4af3fe21427$var$getOAuthUnsuccessFlag = (props)=>({
        id: (0, $kzTj7.OAUTH_UNSUCCESS_FLAG_ID),
        type: 'info',
        isAutoDismiss: true,
        title: '',
        ...props
    });
const $1cdad4af3fe21427$var$getFlagById = (flagId, props)=>{
    switch(flagId){
        case 0, $kzTj7.MAPPING_FIELD_UPDATE_SUCCESS_FLAG_ID:
            return $1cdad4af3fe21427$var$getSuccessFlag({
                title: (0, $71Evi.default).mappingFieldUpdateFlagTitle
            });
        case 0, $kzTj7.MAPPING_HIERARCHY_UPDATE_SUCCESS_FLAG_ID:
            return $1cdad4af3fe21427$var$getSuccessFlag({
                title: (0, $71Evi.default).mappingHierarchyUpdateFlagTitle
            });
        case 0, $kzTj7.MAPPING_STATUS_UPDATE_SUCCESS_FLAG_ID:
            return $1cdad4af3fe21427$var$getSuccessFlag({
                id: (0, $kzTj7.MAPPING_STATUS_UPDATE_SUCCESS_FLAG_ID),
                title: (0, $71Evi.default).mappingStatusUpdateFlagTitle
            });
        case 0, $kzTj7.OAUTH_UNSUCCESS_FLAG_ID:
            return $1cdad4af3fe21427$var$getOAuthUnsuccessFlag(props);
        default:
            return null;
    }
};
const $1cdad4af3fe21427$export$8721c742cda88266 = ()=>{
    const { showFlag: showFlag, hasFlag: hasFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const onShowFlag = (0, $eUqFw.useCallback)((selectedFlagId, props)=>{
        if (hasFlag?.(selectedFlagId)) return;
        const flag = $1cdad4af3fe21427$var$getFlagById(selectedFlagId, props);
        if (flag) showFlag(flag);
    }, [
        hasFlag,
        showFlag
    ]);
    const onDismissFlag = (0, $eUqFw.useCallback)((selectedFlagId)=>{
        if (!hasFlag?.(selectedFlagId)) return;
        dismissFlag(selectedFlagId);
    }, [
        dismissFlag,
        hasFlag
    ]);
    return {
        onShowFlag: onShowFlag,
        onDismissFlag: onDismissFlag
    };
};

});
parcelRegister("71Evi", function(module, exports) {

$parcel$export(module.exports, "default", () => $9eedcdade868aee5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9eedcdade868aee5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    mappingFieldUpdateFlagTitle: {
        "id": "project-create-importer-upload-flow.common.utils.use-flag.mapping-field-update-flag-title",
        "defaultMessage": "Changes to field mapping have been updated"
    },
    mappingHierarchyUpdateFlagTitle: {
        "id": "project-create-importer-upload-flow.common.utils.use-flag.mapping-hierarchy-update-flag-title",
        "defaultMessage": "Changes to project hierarchy have been updated"
    },
    mappingStatusUpdateFlagTitle: {
        "id": "project-create-importer-upload-flow.common.utils.use-flag.mapping-status-update-flag-title",
        "defaultMessage": "Changes to status mapping have been updated"
    }
});

});


parcelRegister("4OuDF", function(module, exports) {

$parcel$export(module.exports, "useImporterSource", () => $5cafeae80101b0a8$export$10833246a1936480);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gyZoj = parcelRequire("gyZoj");
var $5GSA7 = parcelRequire("5GSA7");

var $dWLk9 = parcelRequire("dWLk9");
var $gd0Sp = parcelRequire("gd0Sp");

var $kzTj7 = parcelRequire("kzTj7");

var $3yuWi = parcelRequire("3yuWi");

var $aWLVm = parcelRequire("aWLVm");

var $3IjXl = parcelRequire("3IjXl");
const $5cafeae80101b0a8$var$getX2CImporterSourceUrl = (cloudId)=>`${0, $gyZoj.X2C_SERVICE_URL_PREFIX}/customisedcsv/${cloudId}/products/live`;
const $5cafeae80101b0a8$export$10833246a1936480 = ()=>{
    const [onExperienceStart, onExperienceSuccess, onExperienceFail] = (0, $5GSA7.useExperienceTracker)((0, $3yuWi.EXPERIENCES).IMPORTER_SOURCE);
    const cloudId = (0, $dWLk9.useCloudId)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [hasErrorOccurred, setHasErrorOccurred] = (0, $eUqFw.useState)(false);
    const { isSiteAdmin: isSiteAdmin, isAdmin: isAdmin } = (0, $gd0Sp.useTenantContext)();
    const hasJSWLicense = (0, $aWLVm.useHasJSWLicense)();
    const fetchImporterSource = (0, $eUqFw.useCallback)(async ()=>{
        setIsLoading(true);
        setHasErrorOccurred(false);
        (0, $3yuWi.importerSourceInteractionMetric).start();
        onExperienceStart();
        try {
            const data = await (0, $lRmyA.performGetRequest)($5cafeae80101b0a8$var$getX2CImporterSourceUrl(cloudId));
            (0, $3yuWi.importerSourceInteractionMetric).stop();
            onExperienceSuccess();
            setIsLoading(false);
            return (0, $3IjXl.transformData)(data, formatMessage, isSiteAdmin, isAdmin, hasJSWLicense);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $3yuWi.importerSourceInteractionMetric).stop();
            onExperienceFail((0, $kzTj7.APP_IDENTIFIER), error);
            (0, $guiFP.default)({
                meta: {
                    id: 'fetch-importer-source',
                    packageName: (0, $kzTj7.APP_IDENTIFIER),
                    teamName: (0, $gyZoj.APP_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true,
                error: error
            });
            setHasErrorOccurred(true);
            setIsLoading(false);
            return null;
        }
    }, [
        cloudId,
        formatMessage,
        hasJSWLicense,
        isSiteAdmin,
        isAdmin,
        onExperienceFail,
        onExperienceStart,
        onExperienceSuccess
    ]);
    return {
        isLoading: isLoading,
        hasErrorOccurred: hasErrorOccurred,
        fetchImporterSource: fetchImporterSource
    };
};

});
parcelRegister("3IjXl", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $411c790e9b1953d2$export$3ceb62baab058c6b);

var $1ybV0 = parcelRequire("1ybV0");

var $3ak5x = parcelRequire("3ak5x");

var $eYjP0 = parcelRequire("eYjP0");

const $411c790e9b1953d2$export$3ceb62baab058c6b = (data, formatMessage, isSiteAdmin, isAdmin, hasJSWLicense)=>{
    const sourceItemMap = (0, $eYjP0.getSourceItemMap)(formatMessage);
    const result = data.map((item)=>(0, $3ak5x.SourceItemKeys).has(item.serviceName) ? {
            ...sourceItemMap[item.serviceName],
            supportedFlow: item.apiProducts.length > 0 ? (0, $d46558193b478af8$export$5a613e161b9e89e5) : (0, $d46558193b478af8$export$e87ab702cc1b919b),
            [(0, $d46558193b478af8$export$e87ab702cc1b919b)]: item.csvProducts,
            [(0, $d46558193b478af8$export$5a613e161b9e89e5)]: item.apiProducts
        } : {
            ...sourceItemMap[0, $3ak5x.CSV],
            key: item.serviceName,
            name: item.serviceName,
            supportedFlow: (0, $d46558193b478af8$export$e87ab702cc1b919b),
            [(0, $d46558193b478af8$export$e87ab702cc1b919b)]: item.csvProducts,
            [(0, $d46558193b478af8$export$5a613e161b9e89e5)]: item.apiProducts,
            sourceType: (0, $eYjP0.SourceType).THIRD_PARTY
        });
    // add csv item
    if (isSiteAdmin || isAdmin && (0, $1ybV0.ff)('enable-product-admin-for-x2c-migration_zmlsv')) {
        // add jira products if has jsw license
        if (hasJSWLicense) {
            result.push({
                ...sourceItemMap[0, $3ak5x.JIRA_SOFTWARE],
                supportedFlow: (0, $d46558193b478af8$export$5a613e161b9e89e5),
                [(0, $d46558193b478af8$export$e87ab702cc1b919b)]: [],
                [(0, $d46558193b478af8$export$5a613e161b9e89e5)]: [
                    {
                        productType: 'business',
                        isRecommended: false,
                        projectStyles: []
                    }
                ]
            });
            if ((0, $1ybV0.ff)('jira-business-to-software-project-imports')) result.push({
                ...sourceItemMap[0, $3ak5x.JIRA_BUSINESS],
                supportedFlow: (0, $d46558193b478af8$export$5a613e161b9e89e5),
                [(0, $d46558193b478af8$export$e87ab702cc1b919b)]: [],
                [(0, $d46558193b478af8$export$5a613e161b9e89e5)]: [
                    {
                        productType: 'software',
                        isRecommended: false,
                        projectStyles: []
                    }
                ]
            });
        }
        result.push({
            ...sourceItemMap[0, $3ak5x.CSV],
            supportedFlow: (0, $d46558193b478af8$export$e87ab702cc1b919b),
            [(0, $d46558193b478af8$export$e87ab702cc1b919b)]: [
                {
                    productType: 'business',
                    isRecommended: false,
                    projectStyles: [
                        'TEAM_MANAGED_PROJECT',
                        'COMPANY_MANAGED_PROJECT'
                    ]
                },
                {
                    productType: 'software',
                    isRecommended: false,
                    projectStyles: [
                        'TEAM_MANAGED_PROJECT',
                        'COMPANY_MANAGED_PROJECT'
                    ]
                }
            ],
            [(0, $d46558193b478af8$export$5a613e161b9e89e5)]: []
        });
    } else result.push({
        ...sourceItemMap[0, $3ak5x.CSV],
        supportedFlow: (0, $d46558193b478af8$export$e87ab702cc1b919b),
        [(0, $d46558193b478af8$export$e87ab702cc1b919b)]: [
            {
                productType: 'business',
                isRecommended: false,
                projectStyles: [
                    'TEAM_MANAGED_PROJECT'
                ]
            }
        ],
        [(0, $d46558193b478af8$export$5a613e161b9e89e5)]: []
    });
    return result;
};

});


parcelRegister("2XUTe", function(module, exports) {

$parcel$export(module.exports, "useThirdPartyOAuth", () => $2a7f5230db93c299$export$26dbf62b5b1dc82c);

var $eUqFw = parcelRequire("eUqFw");

var $6Y4Ff = parcelRequire("6Y4Ff");

var $bW292 = parcelRequire("bW292");

var $guiFP = parcelRequire("guiFP");

var $gyZoj = parcelRequire("gyZoj");
var $5GSA7 = parcelRequire("5GSA7");

var $3e9vj = parcelRequire("3e9vj");

var $kzTj7 = parcelRequire("kzTj7");

var $3ak5x = parcelRequire("3ak5x");

var $3yuWi = parcelRequire("3yuWi");
const $2a7f5230db93c299$export$b36e942b9a3b7cb5 = 'ebc3b6f8-f71e-498b-9fc3-61b997b8c14d';
const $2a7f5230db93c299$export$ffb1e62779436d52 = 'ac2bd12b-a2b9-44d4-bd45-9f3ec59e5a0e';
const $2a7f5230db93c299$export$3c856e2951b4893f = 'X2C_MONDAY';
const $2a7f5230db93c299$export$e884e0c1d5f953e1 = 'X2C_ASANA';
const $2a7f5230db93c299$export$ea3d44315bf39317 = 'X2C_CLICKUP';
const $2a7f5230db93c299$var$OUTBOUND_ENDPOINTS = {
    [(0, $3ak5x.MONDAY)]: {
        prod: `outboundAuth/start?containerId=${$2a7f5230db93c299$export$ffb1e62779436d52}&serviceKey=${$2a7f5230db93c299$export$3c856e2951b4893f}`,
        staging: `outboundAuth/start?containerId=${$2a7f5230db93c299$export$b36e942b9a3b7cb5}&serviceKey=${$2a7f5230db93c299$export$3c856e2951b4893f}`
    },
    [(0, $3ak5x.ASANA)]: {
        prod: `outboundAuth/start?containerId=${$2a7f5230db93c299$export$ffb1e62779436d52}&serviceKey=${$2a7f5230db93c299$export$e884e0c1d5f953e1}`,
        staging: `outboundAuth/start?containerId=${$2a7f5230db93c299$export$b36e942b9a3b7cb5}&serviceKey=${$2a7f5230db93c299$export$e884e0c1d5f953e1}`
    },
    [(0, $3ak5x.CLICK_UP)]: {
        prod: `outboundAuth/start?containerId=${$2a7f5230db93c299$export$ffb1e62779436d52}&serviceKey=${$2a7f5230db93c299$export$ea3d44315bf39317}`,
        staging: `outboundAuth/start?containerId=${$2a7f5230db93c299$export$b36e942b9a3b7cb5}&serviceKey=${$2a7f5230db93c299$export$ea3d44315bf39317}`
    }
};
const $2a7f5230db93c299$export$26dbf62b5b1dc82c = ()=>{
    const env = (0, $3e9vj.useEnvironment)();
    const [onExperienceStart, onExperienceSuccess, onExperienceFail] = (0, $5GSA7.useExperienceTracker)((0, $3yuWi.EXPERIENCES).THIRD_PARTY_OAUTH);
    const getUrl = (0, $eUqFw.useCallback)(({ thirdParty: thirdParty, isProd: isProd })=>{
        const endpoint = $2a7f5230db93c299$var$OUTBOUND_ENDPOINTS[thirdParty] !== undefined && $2a7f5230db93c299$var$OUTBOUND_ENDPOINTS[thirdParty]?.[isProd ? 'prod' : 'staging'];
        return endpoint && `${(0, $bW292.getATLContextUrl)('id')}/${endpoint}`;
    }, []);
    return (0, $eUqFw.useCallback)(async ({ thirdParty: thirdParty, onSuccess: onSuccess, onFail: onFail })=>{
        const isProd = env === 'prod';
        const url = getUrl({
            thirdParty: thirdParty,
            isProd: isProd
        });
        if (!url) return Promise.reject(new Error(`Not supported third party: ${thirdParty} or environment: ${env}`));
        onExperienceStart();
        return (0, $6Y4Ff.auth)(url).then(()=>{
            onSuccess(thirdParty);
            onExperienceSuccess();
        }).catch((error)=>{
            onFail && onFail();
            onExperienceFail((0, $kzTj7.APP_IDENTIFIER), error, {
                thirdParty: thirdParty
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'third-party-oAuth',
                    packageName: (0, $kzTj7.APP_IDENTIFIER),
                    teamName: (0, $gyZoj.APP_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true,
                error: error,
                attributes: {
                    thirdParty: thirdParty,
                    error: error
                }
            });
        });
    }, [
        env,
        getUrl,
        onExperienceFail,
        onExperienceStart,
        onExperienceSuccess
    ]);
};

});
parcelRegister("6Y4Ff", function(module, exports) {

$parcel$export(module.exports, "auth", () => $f8e4a233562063a8$export$73693bad9f5880b0);
$parcel$export(module.exports, "AuthError", () => (parcelRequire("dCD3m")).AuthError);

var $dCD3m = parcelRequire("dCD3m");

var $aMNE6 = parcelRequire("aMNE6");
function $f8e4a233562063a8$export$73693bad9f5880b0(startUrl, windowFeatures) {
    return new Promise((resolve, reject)=>{
        let authWindow = null;
        let authWindowInterval;
        const handleAuthWindowMessage = (event)=>{
            if (event.source !== authWindow) return;
            const { data: data } = event;
            if (typeof data !== 'object') return;
            switch(data.type){
                case 'outbound-auth:success':
                    finish();
                    resolve();
                    break;
                case 'outbound-auth:failure':
                    finish();
                    const errorType = data.errorType.toLowerCase();
                    if ((0, $aMNE6.isOfTypeAuthError)(errorType)) reject(new (0, $dCD3m.AuthError)(data.message, errorType));
                    else reject(new (0, $dCD3m.AuthError)(data.message));
                    break;
            }
        };
        const handleAuthWindowInterval = ()=>{
            if (authWindow && authWindow.closed) {
                finish();
                reject(new (0, $dCD3m.AuthError)('The auth window was closed', 'auth_window_closed'));
            }
        };
        const start = ()=>{
            window.addEventListener('message', handleAuthWindowMessage);
            authWindow = window.open(startUrl, startUrl, windowFeatures);
            authWindowInterval = window.setInterval(handleAuthWindowInterval, 500);
        };
        const finish = ()=>{
            clearInterval(authWindowInterval);
            window.removeEventListener('message', handleAuthWindowMessage);
            if (authWindow) {
                authWindow.close();
                authWindow = null;
            }
        };
        start();
    });
}

});
parcelRegister("dCD3m", function(module, exports) {

$parcel$export(module.exports, "AuthError", () => $0d7f9acb0a73d09c$export$145273558d58e0ac);
class $0d7f9acb0a73d09c$export$145273558d58e0ac extends Error {
    constructor(message, type){
        super(message);
        this.message = message;
        this.type = type;
        this.name = 'AuthError';
        this.type = type;
        this.message = message;
    }
}

});

parcelRegister("aMNE6", function(module, exports) {

$parcel$export(module.exports, "isOfTypeAuthError", () => $7b1b7575975439b3$export$400e64c8451aa84f);
// See https://tools.ietf.org/html/rfc6749#section-4.1.2.1
// 'auth_window_closed' is returned in addition to types from this RFC,
// representing when the authentication window is closed by the user
// 'authclientoauth2.autherror' is added to represent errors from
// outbound-auth
const $7b1b7575975439b3$export$400e64c8451aa84f = (inputString)=>{
    return [
        'auth_window_closed',
        'invalid_request',
        'unauthorized_client',
        'access_denied',
        'unsupported_response_type',
        'invalid_scope',
        'server_error',
        'temporarily_unavailable',
        'authclientoauth2.autherror'
    ].includes(inputString);
};

});


parcelRegister("3e9vj", function(module, exports) {

$parcel$export(module.exports, "useEnvironment", () => $f75608ebab912e29$export$ea7ed2425832167d);
$parcel$export(module.exports, "useIsStagingOrDevOrLocal", () => $f75608ebab912e29$export$b0d8f74f433a09c9);

var $gd0Sp = parcelRequire("gd0Sp");
const $f75608ebab912e29$var$ENVIRONMENT = {
    STAGING: 'staging',
    DEV: 'dev',
    LOCAL: 'local',
    PROD: 'prod'
};
const $f75608ebab912e29$export$ea7ed2425832167d = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext?.environment || $f75608ebab912e29$var$ENVIRONMENT.PROD;
};
const $f75608ebab912e29$export$b0d8f74f433a09c9 = ()=>{
    const env = $f75608ebab912e29$export$ea7ed2425832167d();
    return env === $f75608ebab912e29$var$ENVIRONMENT.STAGING || env === $f75608ebab912e29$var$ENVIRONMENT.DEV || env === $f75608ebab912e29$var$ENVIRONMENT.LOCAL;
};

});


parcelRegister("1Uk5t", function(module, exports) {

$parcel$export(module.exports, "useThirdPartyAccessTokenStatus", () => $7ed76b5240f85328$export$4a72ec9d8b5d4ee9);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $gyZoj = parcelRequire("gyZoj");
var $5GSA7 = parcelRequire("5GSA7");

var $kzTj7 = parcelRequire("kzTj7");

var $3yuWi = parcelRequire("3yuWi");

var $8OWUq = parcelRequire("8OWUq");
const $7ed76b5240f85328$export$4a72ec9d8b5d4ee9 = ({ requestAuthenticationToken: requestAuthenticationToken } = {})=>{
    const thirdPartyClient = (0, $8OWUq.useGetThirdPartyClient)({
        requestAuthenticationToken: requestAuthenticationToken
    });
    const [onExperienceStart, onExperienceSuccess, onExperienceFail] = (0, $5GSA7.useExperienceTracker)((0, $3yuWi.EXPERIENCES).THIRD_PARTY_POST_ACCESS_TOKEN_STATUS);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [hasErrorOccurred, setHasErrorOccurred] = (0, $eUqFw.useState)(false);
    const validateAccessToken = (0, $eUqFw.useCallback)(async (thirdParty)=>{
        setIsLoading(true);
        setHasErrorOccurred(false);
        (0, $3yuWi.thirdPartyAccessTokenStatusMetric).start();
        onExperienceStart();
        try {
            const newThirdPartyClient = thirdPartyClient(thirdParty);
            const data = await newThirdPartyClient.validateAccessToken();
            (0, $3yuWi.thirdPartyAccessTokenStatusMetric).stop();
            onExperienceSuccess();
            setIsLoading(false);
            return data.status;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $3yuWi.thirdPartyAccessTokenStatusMetric).stop();
            onExperienceFail((0, $kzTj7.APP_IDENTIFIER), error, {
                thirdParty: thirdParty
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'post-third-party-access-token-status',
                    packageName: (0, $kzTj7.APP_IDENTIFIER),
                    teamName: (0, $gyZoj.APP_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true,
                error: error
            });
            setHasErrorOccurred(true);
            setIsLoading(false);
            return null;
        }
    }, [
        onExperienceFail,
        onExperienceStart,
        onExperienceSuccess,
        thirdPartyClient
    ]);
    return {
        isLoading: isLoading,
        hasErrorOccurred: hasErrorOccurred,
        validateAccessToken: validateAccessToken
    };
};

});

parcelRegister("6smTt", function(module, exports) {

$parcel$export(module.exports, "EmptyView", () => $aeb690d6426c8cf3$export$f716ac8971c5316e);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $fx0B9 = parcelRequire("fx0B9");

var $9JLcx = parcelRequire("9JLcx");
const $aeb690d6426c8cf3$export$14b33d63628336c2 = 'x2c-other-app-request-form';
const $aeb690d6426c8cf3$export$f716ac8971c5316e = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const openFeedbackModal = (0, $fx0B9.useFeedbackCollector)();
    const onSubmitFeedbackClick = (0, $eUqFw.useCallback)(()=>{
        const onSubmit = ()=>{
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'X2CAppRequestSubmitButton'
            }));
        };
        openFeedbackModal({
            feedbackGroupId: $aeb690d6426c8cf3$export$14b33d63628336c2,
            onSubmit: onSubmit,
            feedbackTitle: formatMessage((0, $9JLcx.default).feedbackTitle),
            customTextAreaLabel: formatMessage((0, $9JLcx.default).customTextAreaLabel)
        });
    }, [
        createAnalyticsEvent,
        formatMessage,
        openFeedbackModal
    ]);
    const handleClick = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'X2CAppRequestButton'
        }));
        onSubmitFeedbackClick();
    }, [
        createAnalyticsEvent,
        onSubmitFeedbackClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $aeb690d6426c8cf3$var$emptyMessageStyles
    }, formatMessage((0, $9JLcx.default).requestOtherApp, {
        link: (content)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                appearance: "link",
                spacing: "none",
                onClick: handleClick,
                testId: "project-create-importer-upload-flow.ui.select-source-screen.source-section.empty-view.request-other-app-button"
            }, content)
    }));
};
const $aeb690d6426c8cf3$var$emptyMessageStyles = (0, $1ZAYh.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    color: 'color.text',
    padding: 'space.250',
    backgroundColor: 'elevation.surface.sunken',
    borderRadius: 'border.radius.200',
    marginBottom: 'space.200'
});

});
parcelRegister("fx0B9", function(module, exports) {

$parcel$export(module.exports, "useFeedbackCollector", () => $2047c48dfc8a9461$export$4be696be8a3bff13);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $1c02D = parcelRequire("1c02D");
var $irg9D = parcelRequire("irg9D");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kJlBc = parcelRequire("kJlBc");

var $gd0Sp = parcelRequire("gd0Sp");

var $aXCGK = parcelRequire("aXCGK");
const $2047c48dfc8a9461$export$698ff856156a88fe = /*#__PURE__*/ (0, $eUqFw.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $aXCGK.default).canContactPrompt, {
        link: (content)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                appearance: "link",
                spacing: "none",
                target: "_blank",
                href: "https://www.atlassian.com/legal/privacy-policy"
            }, content)
    }));
});
const $2047c48dfc8a9461$export$4be696be8a3bff13 = ()=>{
    const { openFeedbackCollector: openFeedbackCollector } = (0, $irg9D.useFeedbackCollectorActions)();
    const { isAdmin: isAdmin, isSiteAdmin: isSiteAdmin } = (0, $gd0Sp.useTenantContext)();
    const [{ route: { name: name, path: path } }] = (0, $kJlBc.useRouter)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return (0, $eUqFw.useCallback)(({ feedbackGroupId: feedbackGroupId, onSubmit: onSubmit, feedbackTitle: feedbackTitle, customTextAreaLabel: customTextAreaLabel })=>{
        openFeedbackCollector({
            entrypointId: (0, $1c02D.ENTRYPOINT_ID_JIRA_PLATFORM),
            feedbackGroupId: feedbackGroupId,
            feedbackTitle: feedbackTitle,
            showTypeField: false,
            showDefaultTextFields: true,
            canBeContactedLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2047c48dfc8a9461$export$698ff856156a88fe, null),
            submitButtonLabel: formatMessage((0, $aXCGK.default).submitButtonLabel),
            customTextAreaLabel: // @ts-expect-error: Object literal may only specify known properties, and 'customTextAreaLabel' does not exist in type 'FeedbackCollectorProps'.ts(2345)
            customTextAreaLabel,
            onSubmit: onSubmit,
            feedbackContext: [
                {
                    id: (0, $1c02D.EntryKeys).INLINE_FEEDBACK_ID,
                    value: feedbackGroupId
                },
                {
                    id: (0, $1c02D.EntryKeys).ROUTE_NAME,
                    value: name
                },
                {
                    id: (0, $1c02D.EntryKeys).IS_ADMIN,
                    value: isAdmin
                },
                {
                    id: (0, $1c02D.EntryKeys).IS_SITE_ADMIN,
                    value: isSiteAdmin
                },
                {
                    id: (0, $1c02D.EntryKeys).LOCATION,
                    value: path
                }
            ]
        });
    }, [
        formatMessage,
        isAdmin,
        isSiteAdmin,
        name,
        openFeedbackCollector,
        path
    ]);
};

});
parcelRegister("aXCGK", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c7f2fa07f58e853$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1c7f2fa07f58e853$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    canContactPrompt: {
        "id": "project-create-importer-upload-flow.common.utils.feedback-collector.can-contact-prompt",
        "defaultMessage": "Yes, Atlassian teams can contact me to learn more about this feedback and I acknowledge the <link>Atlassian Privacy Policy</link>."
    },
    submitButtonLabel: {
        "id": "project-create-importer-upload-flow.common.utils.feedback-collector.submit-button-label",
        "defaultMessage": "Submit"
    }
});

});


parcelRegister("9JLcx", function(module, exports) {

$parcel$export(module.exports, "default", () => $24328ce1768c5e5a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $24328ce1768c5e5a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    feedbackTitle: {
        "id": "project-create-importer-upload-flow.select-source-screen.source-section.empty-view.feedback-title",
        "defaultMessage": "Where would you like to import data from?"
    },
    customTextAreaLabel: {
        "id": "project-create-importer-upload-flow.select-source-screen.source-section.empty-view.custom-text-area-label",
        "defaultMessage": "Let us know what apps you\u2019d like us to extend support to"
    },
    requestOtherApp: {
        "id": "project-create-importer-upload-flow.select-source-screen.source-section.empty-view.request-other-app",
        "defaultMessage": "We couldn\u2019t find what you are looking for. <link>Let us know</link> if there are other apps you are looking to import data from."
    }
});

});


parcelRegister("fAPM9", function(module, exports) {

$parcel$export(module.exports, "default", () => $db2930592e7c4c87$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $db2930592e7c4c87$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    searchPlaceholder: {
        "id": "project-create-importer-upload-flow.select-source-screen.source-section.search-placeholder",
        "defaultMessage": "Search"
    },
    switchBackToOldExperience: {
        "id": "project-create-importer-upload-flow.select-source-screen.source-section.switch-back-to-old-experience",
        "defaultMessage": "This experience is only available for Jira business and software project imports. If you\u2019d like to import your data into Jira Service Management or Jira Product Discovery, <link>switch to the old experience</link>. "
    },
    errorHeading: {
        "id": "project-create-importer-upload-flow.select-source-screen.source-section.error-heading",
        "defaultMessage": "We\u2019re having trouble loading this page"
    },
    errorDescription: {
        "id": "project-create-importer-upload-flow.select-source-screen.source-section.error-description",
        "defaultMessage": "Try refreshing the page or check back again in a few minutes."
    }
});

});

parcelRegister("i3sFc", function(module, exports) {

$parcel$export(module.exports, "SourceGroup", () => $59daf31968a08c2e$export$83abd0443443da9f);

var $eUqFw = parcelRequire("eUqFw");

var $fcWBJ = parcelRequire("fcWBJ");

var $7u4fN = parcelRequire("7u4fN");

var $86Ndv = parcelRequire("86Ndv");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $eYjP0 = parcelRequire("eYjP0");

var $a4mrp = parcelRequire("a4mrp");
const $59daf31968a08c2e$export$c425c7607728b88d = 20;
const $59daf31968a08c2e$export$83abd0443443da9f = ({ sourceItems: sourceItems, renderItem: renderItem })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [showMore, setShowMore] = (0, $eUqFw.useState)(false);
    const groups = (0, $eUqFw.useMemo)(()=>{
        const groupedSourceItems = (0, (/*@__PURE__*/$parcel$interopDefault($fcWBJ)))(sourceItems, 'sourceType');
        return [
            {
                key: (0, $eYjP0.SourceType).THIRD_PARTY,
                header: (0, $a4mrp.default).thirdPartySourceHeader,
                description: (0, $a4mrp.default).thirdPartySourceDescription,
                data: groupedSourceItems[(0, $eYjP0.SourceType).THIRD_PARTY]
            },
            {
                key: (0, $eYjP0.SourceType).CSV,
                header: (0, $a4mrp.default).csvSectionHeader,
                description: (0, $a4mrp.default).csvSectionDescription,
                data: groupedSourceItems[(0, $eYjP0.SourceType).CSV]
            }
        ];
    }, [
        sourceItems
    ]);
    return groups.map((group)=>group.data && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            key: group.key,
            xcss: $59daf31968a08c2e$var$sourceGroupStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $59daf31968a08c2e$var$headerStyles,
            as: "h4"
        }, formatMessage(group.header)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $59daf31968a08c2e$var$descriptionStyles
        }, formatMessage(group.description, {
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, chunks)
        })), group.data.length <= $59daf31968a08c2e$export$c425c7607728b88d || showMore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $59daf31968a08c2e$var$buttonGroupStyles,
            role: "group"
        }, group.data.map((item)=>renderItem(item))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $59daf31968a08c2e$var$buttonGroupStyles,
            role: "group"
        }, group.data.slice(0, $59daf31968a08c2e$export$c425c7607728b88d).map((item)=>renderItem(item))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            paddingBlockStart: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                label: "chevronDownIcon"
            }),
            appearance: "link",
            onClick: ()=>setShowMore(true)
        }, formatMessage((0, $a4mrp.default).showMore))))));
};
const $59daf31968a08c2e$var$sourceGroupStyles = (0, $1ZAYh.xcss)({
    padding: 'space.250',
    backgroundColor: 'elevation.surface.sunken',
    borderRadius: 'border.radius.200',
    marginBottom: 'space.200'
});
const $59daf31968a08c2e$var$headerStyles = (0, $1ZAYh.xcss)({
    font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $59daf31968a08c2e$var$descriptionStyles = (0, $1ZAYh.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtlest'
});
const $59daf31968a08c2e$var$buttonGroupStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    flexFlow: 'row wrap',
    gap: 'space.200',
    marginTop: 'space.200'
});

});
parcelRegister("a4mrp", function(module, exports) {

$parcel$export(module.exports, "default", () => $9617f9368e3137c6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9617f9368e3137c6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    thirdPartySourceHeader: {
        "id": "project-create-importer-upload-flow.select-source-screen.source-section.source-group.third-party-source-header",
        "defaultMessage": "Where would you like to import from?"
    },
    thirdPartySourceDescription: {
        "id": "project-create-importer-upload-flow.select-source-screen.source-section.source-group.third-party-source-description",
        "defaultMessage": "Select the app where you\u2019d like to import your data from."
    },
    csvSectionHeader: {
        "id": "project-create-importer-upload-flow.select-source-screen.source-section.source-group.csv-section-header",
        "defaultMessage": "Can\u2019t find your app?"
    },
    csvSectionDescription: {
        "id": "project-create-importer-upload-flow.select-source-screen.source-section.source-group.csv-section-description",
        "defaultMessage": "If you don\u2019t see your app here, select <strong>CSV</strong> to use any CSV file to import your data."
    },
    showMore: {
        "id": "project-create-importer-upload-flow.select-source-screen.source-section.source-group.show-more",
        "defaultMessage": "Show more apps"
    }
});

});




parcelRegister("hrOrS", function(module, exports) {

$parcel$export(module.exports, "SelectThirdPartyEntityScreen", () => $aa97d7354ae1c386$export$1011d548f271458f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $66xY8 = parcelRequire("66xY8");

var $3yuWi = parcelRequire("3yuWi");

var $1VyqP = parcelRequire("1VyqP");

var $3EVB9 = parcelRequire("3EVB9");

var $elKPF = parcelRequire("elKPF");

var $1T7vu = parcelRequire("1T7vu");

var $cDLTA = parcelRequire("cDLTA");

var $d0wrd = parcelRequire("d0wrd");
var $irKna = parcelRequire("irKna");

var $asXeB = parcelRequire("asXeB");

var $fiH3o = parcelRequire("fiH3o");

var $7je32 = parcelRequire("7je32");

var $jwr02 = parcelRequire("jwr02");

var $6nUK1 = parcelRequire("6nUK1");

var $9RqsR = parcelRequire("9RqsR");

var $iD0US = parcelRequire("iD0US");
const $aa97d7354ae1c386$export$1011d548f271458f = ({ onReturn: onReturn, onNext: onNext, thirdParty: thirdParty, stats: stats, onCloseAndReturnToUploadStep: onCloseAndReturnToUploadStep, hasSearchableEntities: hasSearchableEntities, shouldShowPlaceholderIcons: shouldShowPlaceholderIcons, shouldShowFolderSelector: shouldShowFolderSelector, hideWorkspaceSelector: hideWorkspaceSelector, shouldShowSpaceSelector: shouldShowSpaceSelector, shouldShowAccountInfoIfUsingPAT: shouldShowAccountInfoIfUsingPAT, isMultipleEntitiesSupported: isMultipleEntitiesSupported = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { heading: heading, noAccountErrorHeader: noAccountErrorHeader } = (0, $cDLTA.useContentForThirdParty)(thirdParty);
    const { productSteps: productSteps, currentStepIndex: currentStepIndex } = (0, $fiH3o.useProductSteps)();
    const [{ type: type }] = (0, $d0wrd.useProjectData)();
    const [{ selectedEntityId: selectedEntityId, selectedWorkspaceId: selectedWorkspaceId, selectedEntities: selectedEntities }, { setThirdPartyState: setThirdPartyState }] = (0, $irKna.useThirdPartyState)();
    const [, { setRequestAuthenticationToken: requestAuthenticationToken }] = (0, $asXeB.useAccessTokenModalState)();
    const { hasAccountErrorOccurred: hasAccountErrorOccurred } = (0, $7je32.useThirdPartyWorkspaces)({
        thirdParty: thirdParty,
        requestAuthenticationToken: requestAuthenticationToken
    });
    (0, $eUqFw.useEffect)(()=>{
        if (hasAccountErrorOccurred) (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'noThirdPartyAccount found', {
            thirdParty: thirdParty
        });
    }, [
        hasAccountErrorOccurred,
        thirdParty,
        createAnalyticsEvent
    ]);
    const handleOnReturn = (0, $eUqFw.useCallback)(()=>{
        setThirdPartyState({
            selectedWorkspaceId: null,
            selectedSpaceId: null,
            selectedSpaceName: null,
            selectedEntities: null,
            selectedEntityId: null,
            selectedEntityName: null,
            selectedEntityStyle: null,
            entities: null,
            workspaces: null,
            entityStats: null,
            members: null,
            spaces: null
        });
        onReturn();
    }, [
        onReturn,
        setThirdPartyState
    ]);
    const progressBarComponent = (0, $eUqFw.useMemo)(()=>{
        if ((0, $eI5EY.fg)('enable-x2c-standardised-flow')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1T7vu.ProgressBarStandard), {
            productSteps: productSteps,
            currentStepIndex: currentStepIndex,
            onClose: onCloseAndReturnToUploadStep,
            shouldShowCancelModal: !hasAccountErrorOccurred && (selectedWorkspaceId != null || selectedEntityId != null)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $aa97d7354ae1c386$var$paddingForProgressBar
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3EVB9.CloseAndReturnButton), {
            onCloseAndReturnToUploadStep: onCloseAndReturnToUploadStep,
            shouldShowCancelModal: !hasAccountErrorOccurred && (selectedWorkspaceId != null || selectedEntityId != null)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1T7vu.StepProgressBar), {
            productSteps: productSteps,
            currentStepIndex: currentStepIndex
        }));
    }, [
        hasAccountErrorOccurred,
        onCloseAndReturnToUploadStep,
        selectedWorkspaceId,
        selectedEntityId,
        productSteps,
        currentStepIndex
    ]);
    const renderStepFooterComponent = (0, $eUqFw.useMemo)(()=>{
        if ((0, $eI5EY.fg)('enable-x2c-standardised-flow')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $elKPF.StepFooterStandard), {
            alignRight: true,
            onReturn: handleOnReturn,
            shouldDisableNext: true
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            onClick: handleOnReturn,
            testId: "project-create-importer-upload-flow.ui.select-third-party-entity-screen.back-button"
        }, formatMessage((0, $9RqsR.default).back)));
    }, [
        handleOnReturn,
        formatMessage
    ]);
    if (hasAccountErrorOccurred) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aa97d7354ae1c386$var$Wrapper, null, progressBarComponent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aa97d7354ae1c386$var$AccountErrorWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aa97d7354ae1c386$var$Illustration, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($66xY8))),
        "aria-describedby": "import-error",
        role: "img",
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1VyqP.ErrorHeading), null, noAccountErrorHeader), renderStepFooterComponent));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: (0, $3yuWi.X2C_SCREENS).SELECT_THIRD_PARTY_ENTITY_SCREEN,
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        attributes: {
            thirdParty: thirdParty
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aa97d7354ae1c386$var$Wrapper, {
        "data-testid": "project-create-importer-upload-flow.ui.select-third-party-entity-screen.wrapper"
    }, progressBarComponent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aa97d7354ae1c386$var$SectionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aa97d7354ae1c386$var$ContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1VyqP.PageHeading), null, heading), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jwr02.EntityContent), {
        thirdParty: thirdParty,
        shouldShowPlaceholderIcons: !!shouldShowPlaceholderIcons,
        shouldShowFolderSelector: !!shouldShowFolderSelector,
        hideWorkspaceSelector: !!hideWorkspaceSelector,
        shouldShowAccountInfoIfUsingPAT: !!shouldShowAccountInfoIfUsingPAT,
        shouldShowSpaceSelector: !!shouldShowSpaceSelector,
        isMultipleEntitiesSupported: isMultipleEntitiesSupported,
        onReturn: onReturn,
        onNext: onNext,
        hasSearchableEntities: !!hasSearchableEntities
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aa97d7354ae1c386$var$ContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iD0US.ThirdPartyIllustration), {
        thirdParty: thirdParty,
        projectType: type
    }), (selectedEntityId || isMultipleEntitiesSupported && selectedEntities) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6nUK1.EntityStats), {
        thirdParty: thirdParty,
        stats: stats,
        removeBackground: true,
        requestAuthenticationToken: requestAuthenticationToken,
        isMultipleEntitiesSupported: isMultipleEntitiesSupported
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $aa97d7354ae1c386$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1n261q9c _1bsb1osq _vchhusvi _1yt41avh _bfhk1j9a _11381ns9",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $aa97d7354ae1c386$var$ContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1n261q9c _1bsblti4 _18s87wht _vchhusvi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $aa97d7354ae1c386$var$SectionWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1n261q9c _1bah1h6o _1n261g80",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $aa97d7354ae1c386$var$AccountErrorWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1n261q9c _4cvr1h6o _1bah1h6o _4t3i1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $aa97d7354ae1c386$var$Illustration = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1to9 _c71lo812 _1bsb1ssb _4t3i1ssb",
            __cmplp.className
        ])
    });
});
const $aa97d7354ae1c386$var$paddingForProgressBar = (0, $1ZAYh.xcss)({
    paddingTop: 'space.800'
});

});
parcelRegister("7je32", function(module, exports) {

$parcel$export(module.exports, "useThirdPartyWorkspaces", () => $f46b3b261c1d8348$export$fc27b5312ee1f2a2);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $gyZoj = parcelRequire("gyZoj");
var $5GSA7 = parcelRequire("5GSA7");

var $kzTj7 = parcelRequire("kzTj7");

var $3yuWi = parcelRequire("3yuWi");

var $8OWUq = parcelRequire("8OWUq");
const $f46b3b261c1d8348$var$MISSING_TRELLO_ACCOUNT = 'MISSING_TRELLO_ACCOUNT';
const $f46b3b261c1d8348$var$getHasAccountErrorOccurred = async (error)=>{
    if (!error || error.statusCode !== 400 || !error.originalResponse) return Promise.resolve(false);
    return error.originalResponse.json().then((body)=>body.errorCode === $f46b3b261c1d8348$var$MISSING_TRELLO_ACCOUNT);
};
const $f46b3b261c1d8348$export$fc27b5312ee1f2a2 = ({ thirdParty: thirdParty, requestAuthenticationToken: requestAuthenticationToken })=>{
    const thirdPartyClient = (0, $8OWUq.useThirdPartyClient)({
        thirdParty: thirdParty,
        requestAuthenticationToken: requestAuthenticationToken
    });
    const [onExperienceStart, onExperienceSuccess, onExperienceFail] = (0, $5GSA7.useExperienceTracker)((0, $3yuWi.EXPERIENCES).THIRD_PARTY_WORKSPACES);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [hasErrorOccurred, setHasErrorOccurred] = (0, $eUqFw.useState)(false);
    const [hasAccountErrorOccurred, setAccountHasErrorOccurred] = (0, $eUqFw.useState)(false);
    const fetchThirdPartyWorkspaces = (0, $eUqFw.useCallback)(async ()=>{
        setIsLoading(true);
        setHasErrorOccurred(false);
        setAccountHasErrorOccurred(false);
        (0, $3yuWi.thirdPartyWorkspacesInteractionMetric).start();
        onExperienceStart();
        try {
            const data = await thirdPartyClient.getWorkspaces();
            (0, $3yuWi.thirdPartyWorkspacesInteractionMetric).stop();
            onExperienceSuccess();
            setIsLoading(false);
            return data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $3yuWi.thirdPartyWorkspacesInteractionMetric).stop();
            onExperienceFail((0, $kzTj7.APP_IDENTIFIER), error, {
                thirdParty: thirdParty
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'fetch-third-party-workspaces',
                    packageName: (0, $kzTj7.APP_IDENTIFIER),
                    teamName: (0, $gyZoj.APP_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true,
                error: error
            });
            setAccountHasErrorOccurred(await $f46b3b261c1d8348$var$getHasAccountErrorOccurred(error));
            setHasErrorOccurred(true);
            setIsLoading(false);
            return null;
        }
    }, [
        onExperienceFail,
        onExperienceStart,
        onExperienceSuccess,
        thirdPartyClient,
        thirdParty
    ]);
    return {
        isLoading: isLoading,
        hasErrorOccurred: hasErrorOccurred,
        hasAccountErrorOccurred: hasAccountErrorOccurred,
        fetchThirdPartyWorkspaces: fetchThirdPartyWorkspaces
    };
};

});

parcelRegister("jwr02", function(module, exports) {

$parcel$export(module.exports, "EntityContent", () => $7d44c1d6e5b4ac74$export$d6ed9b7c86907efb);

var $eUqFw = parcelRequire("eUqFw");

var $fI650 = parcelRequire("fI650");

var $7CD1S = parcelRequire("7CD1S");
var $jeetE = parcelRequire("jeetE");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $lRvnl = parcelRequire("lRvnl");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kzTj7 = parcelRequire("kzTj7");


var $1VyqP = parcelRequire("1VyqP");

var $elKPF = parcelRequire("elKPF");

var $aWLVm = parcelRequire("aWLVm");
var $cDLTA = parcelRequire("cDLTA");

var $irKna = parcelRequire("irKna");

var $2sRUp = parcelRequire("2sRUp");

var $asXeB = parcelRequire("asXeB");
var $fua3W = parcelRequire("fua3W");

var $4R50N = parcelRequire("4R50N");

var $lkIj4 = parcelRequire("lkIj4");

var $1IFC6 = parcelRequire("1IFC6");

var $9orTz = parcelRequire("9orTz");

var $ck9sR = parcelRequire("ck9sR");

var $gRMjU = parcelRequire("gRMjU");

var $fzhBF = parcelRequire("fzhBF");

var $4Fz7S = parcelRequire("4Fz7S");

var $hKh1G = parcelRequire("hKh1G");

var $fdRld = parcelRequire("fdRld");

var $fltaN = parcelRequire("fltaN");
const $7d44c1d6e5b4ac74$export$d6ed9b7c86907efb = ({ thirdParty: thirdParty, shouldShowPlaceholderIcons: shouldShowPlaceholderIcons, shouldShowFolderSelector: shouldShowFolderSelector, hideWorkspaceSelector: hideWorkspaceSelector, shouldShowAccountInfoIfUsingPAT: shouldShowAccountInfoIfUsingPAT, shouldShowSpaceSelector: shouldShowSpaceSelector, onReturn: onReturn, onNext: onNext, hasSearchableEntities: hasSearchableEntities, isMultipleEntitiesSupported: isMultipleEntitiesSupported })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [, { setCancelImportModalState: setCancelImportModalState }] = (0, $fua3W.useCancelImportModalState)();
    const [source] = (0, $2sRUp.useSource)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [, { setRequestAuthenticationToken: requestAuthenticationToken }] = (0, $asXeB.useAccessTokenModalState)();
    const [{ workspaces: workspaces, entities: entities, selectedEntityId: selectedEntityId, selectedWorkspaceId: selectedWorkspaceId, selectedEntities: selectedEntities }, { setThirdPartyState: setThirdPartyState }] = (0, $irKna.useThirdPartyState)();
    const { description: description, entityScreenDescription: entityScreenDescription, multiEntityInfo: multiEntityInfo } = (0, $cDLTA.useContentForThirdParty)(thirdParty);
    const tool = (0, $4R50N.useImportTool)(thirdParty);
    const { thirdPartyEntityDescriptionURL: thirdPartyEntityDescriptionURL } = (0, $aWLVm.useUrlForThirdParty)(thirdParty);
    const handleOnReturn = (0, $eUqFw.useCallback)(()=>{
        // Remove this when the new project create integration is implemented
        if (source === (0, $85ba070c29b4a3bd$export$44f7961a4c8dc451)) {
            (0, $aWLVm.redirectToProjectTemplatesScreen)();
            return;
        }
        setThirdPartyState({
            selectedWorkspaceId: null,
            selectedSpaceId: null,
            selectedSpaceName: null,
            selectedFolderId: null,
            selectedSubfolderId: null,
            selectedEntities: null,
            selectedEntityId: null,
            selectedEntityName: null,
            selectedEntityStyle: null,
            entities: null,
            folders: null,
            workspaces: null,
            spaces: null,
            entityStats: null,
            members: null,
            siteName: null
        });
        onReturn();
    }, [
        onReturn,
        setThirdPartyState,
        source
    ]);
    const handleOnNext = (0, $eUqFw.useCallback)(()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'thirdPartyEntity selected', {
            thirdParty: thirdParty,
            isStarredEntity: entities?.find((entity)=>entity.id === selectedEntityId)?.isStarred || false
        });
        onNext();
    }, [
        createAnalyticsEvent,
        entities,
        onNext,
        selectedEntityId,
        thirdParty
    ]);
    const handleOpenCancelImport = (0, $eUqFw.useCallback)(()=>{
        setCancelImportModalState({
            isCancelImportModalOpen: true,
            shouldCloseDrawerOnCancel: false,
            onCloseModalCallback: handleOnReturn
        });
    }, [
        handleOnReturn,
        setCancelImportModalState
    ]);
    const workspaceProps = (0, $fltaN.useWorkspaces)({
        thirdParty: thirdParty,
        shouldShowPlaceholderIcons: shouldShowPlaceholderIcons,
        requestAuthenticationToken: requestAuthenticationToken,
        hideWorkspaceSelector: hideWorkspaceSelector
    });
    const spacesProps = (0, $hKh1G.useSpaces)({
        thirdParty: thirdParty,
        shouldShowPlaceholderIcons: shouldShowPlaceholderIcons,
        requestAuthenticationToken: requestAuthenticationToken,
        shouldShowSpaceSelector: shouldShowSpaceSelector
    });
    const folderProps = (0, $4Fz7S.useFolders)({
        thirdParty: thirdParty,
        shouldShowPlaceholderIcons: shouldShowPlaceholderIcons,
        requestAuthenticationToken: requestAuthenticationToken,
        shouldShowFolderSelector: shouldShowFolderSelector,
        parentEntityId: shouldShowSpaceSelector ? spacesProps.selectedEntityId : selectedWorkspaceId
    });
    const subfolderProps = (0, $fdRld.useSubfolders)({
        thirdParty: thirdParty,
        shouldShowPlaceholderIcons: shouldShowPlaceholderIcons
    });
    const entityProps = (0, $fzhBF.useEntities)({
        thirdParty: thirdParty,
        shouldShowPlaceholderIcons: shouldShowPlaceholderIcons,
        hasSearchableEntities: hasSearchableEntities,
        requestAuthenticationToken: requestAuthenticationToken,
        hideWorkspaceSelector: hideWorkspaceSelector,
        parentEntityId: shouldShowSpaceSelector ? spacesProps.selectedEntityId : selectedWorkspaceId
    });
    const isWorkspacesLoading = workspaceProps.isLoading;
    const isEntitiesLoading = entityProps.isLoading;
    const hasNoWorkspaces = !isWorkspacesLoading && workspaces && workspaces.length === 0;
    if (hasNoWorkspaces) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1IFC6.EntitySelector), workspaceProps), (0, $eI5EY.fg)('enable-x2c-standardised-flow') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $elKPF.StepFooterStandard), {
        alignRight: true,
        onReturn: handleOnReturn,
        shouldDisableNext: true,
        backButtonMessage: // Remove this when the new project create integration is implemented
        source === (0, $85ba070c29b4a3bd$export$44f7961a4c8dc451) ? (0, $gRMjU.default).cancel : undefined
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7CD1S.default), {
        align: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $elKPF.StepFooter), {
        onReturn: handleOnReturn,
        shouldRenderNextButton: false,
        backButtonMessage: // Remove this when the new project create integration is implemented
        source === (0, $85ba070c29b4a3bd$export$44f7961a4c8dc451) ? (0, $gRMjU.default).cancel : undefined
    })));
    const BoardEntitySelectorComponent = hasSearchableEntities ? (0, $ck9sR.EntitySelectorWithPagination) : (0, $1IFC6.EntitySelector);
    const isWorkspaceIdSelected = hideWorkspaceSelector || selectedWorkspaceId !== null;
    const shouldShowBoardEntitySelector = !shouldShowSpaceSelector || spacesProps.selectedEntityId !== null;
    const showFolders = shouldShowFolderSelector && !folderProps.isEmptyEntities && (folderProps.selectedEntityId !== null || !entityProps.isEmptyEntities);
    const showSubfolders = showFolders && !subfolderProps.isEmptyEntities;
    const showSpaces = shouldShowSpaceSelector && isWorkspaceIdSelected;
    const isMultiEntitiesInvalid = !selectedEntities?.length || selectedEntities?.length > (0, $kzTj7.CLICKUP_MAX_LISTS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (0, $1ybV0.ff)('jira-business-to-software-project-imports') && entityScreenDescription ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1VyqP.PageDescription), null, formatMessage(entityScreenDescription, {
        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fI650.default), {
                appearance: "link",
                spacing: "none",
                href: thirdPartyEntityDescriptionURL,
                target: "_blank"
            }, chunks)
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1VyqP.PageDescription), null, description), (0, $1ybV0.ff)('jira-business-to-software-project-imports') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1VyqP.PageDescription), null, formatMessage((0, $gRMjU.default).requiredField), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeetE.default), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1VyqP.PageDescription), null, formatMessage((0, $gRMjU.default).requiredField)), tool?.requiresPersonalAccessToken === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lkIj4.AccountInfo), {
        thirdParty: thirdParty,
        shouldShowAccountInfoIfUsingPAT: shouldShowAccountInfoIfUsingPAT,
        requestAuthenticationToken: requestAuthenticationToken
    }), !hideWorkspaceSelector && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1IFC6.EntitySelector), {
        ...workspaceProps,
        isDisabled: isEntitiesLoading,
        isRequired: true
    }), isWorkspaceIdSelected && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, showSpaces && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1IFC6.EntitySelector), {
        ...spacesProps,
        isRequired: true
    }), showFolders && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1IFC6.EntitySelector), folderProps), showSubfolders && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1IFC6.EntitySelector), subfolderProps), shouldShowBoardEntitySelector && (isMultipleEntitiesSupported ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9orTz.EntitySelectorCheckbox), {
        ...entityProps,
        onChange: entityProps.onChangeMultipleEntities,
        selectedEntities: entityProps.selectedEntities,
        isRequired: true
    }), isMultipleEntitiesSupported && multiEntityInfo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $7d44c1d6e5b4ac74$var$infoSectionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), null, formatMessage(multiEntityInfo, {
        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                href: (0, $kzTj7.CLICKUP_MULTI_LIST_INFO),
                target: "_blank"
            }, chunks)
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(BoardEntitySelectorComponent, {
        ...entityProps,
        isRequired: true
    })), (0, $eI5EY.fg)('enable-x2c-standardised-flow') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $elKPF.StepFooterStandard), {
        alignRight: true,
        onReturn: selectedWorkspaceId || selectedEntityId ? handleOpenCancelImport : handleOnReturn,
        onClickNext: handleOnNext,
        shouldDisableNext: isMultipleEntitiesSupported ? isMultiEntitiesInvalid : selectedEntityId === null,
        isLoading: isWorkspacesLoading || isEntitiesLoading,
        backButtonMessage: // Remove this when the new project create integration is implemented
        source === (0, $85ba070c29b4a3bd$export$44f7961a4c8dc451) ? (0, $gRMjU.default).cancel : undefined
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7CD1S.default), {
        align: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $elKPF.StepFooter), {
        onReturn: selectedWorkspaceId || selectedEntityId ? handleOpenCancelImport : handleOnReturn,
        onClickNext: handleOnNext,
        shouldDisableNext: isMultipleEntitiesSupported ? isMultiEntitiesInvalid : selectedEntityId === null,
        isLoading: isWorkspacesLoading || isEntitiesLoading,
        backButtonMessage: // Remove this when the new project create integration is implemented
        source === (0, $85ba070c29b4a3bd$export$44f7961a4c8dc451) ? (0, $gRMjU.default).cancel : undefined
    }))));
};
const $7d44c1d6e5b4ac74$var$infoSectionStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.300'
});

});
parcelRegister("7CD1S", function(module, exports) {

$parcel$export(module.exports, "default", () => $564306fc9833a41c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");
function $564306fc9833a41c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $564306fc9833a41c$var$formFooterWrapperStyles = {
    name: "1rruhyk",
    styles: "display:flex;justify-content:flex-end;margin-block-start:var(--ds-space-300, 24px)"
};
const $564306fc9833a41c$var$justifyContentStyles = {
    name: "11g6mpt",
    styles: "justify-content:flex-start"
};
function $564306fc9833a41c$export$2e2bcd8739ae039({ align: align = 'end', children: children }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("footer", {
        css: [
            $564306fc9833a41c$var$formFooterWrapperStyles,
            align === 'start' && $564306fc9833a41c$var$justifyContentStyles
        ]
    }, children);
}

});

parcelRegister("lkIj4", function(module, exports) {

$parcel$export(module.exports, "AccountInfo", () => $c9f88dd09f45ac07$export$409ec18e0392f49a);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $96IgR = parcelRequire("96IgR");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $buKPq = parcelRequire("buKPq");

var $cDLTA = parcelRequire("cDLTA");

var $irKna = parcelRequire("irKna");

var $g1tXk = parcelRequire("g1tXk");

var $5TlJW = parcelRequire("5TlJW");
const $c9f88dd09f45ac07$export$409ec18e0392f49a = ({ thirdParty: thirdParty, shouldShowAccountInfoIfUsingPAT: shouldShowAccountInfoIfUsingPAT, requestAuthenticationToken: requestAuthenticationToken })=>{
    const { getSiteName: getSiteName, isLoading: isLoading, hasErrorOccurred: hasErrorOccurred } = (0, $g1tXk.useThirdPartySiteName)({
        thirdParty: thirdParty,
        requestAuthenticationToken: requestAuthenticationToken
    });
    const { loadingSiteNameErrorOccurredDescription: loadingSiteNameErrorOccurredDescription } = (0, $cDLTA.useContentForThirdParty)(thirdParty);
    const [{ siteName: siteName }, { setThirdPartyState: setThirdPartyState }] = (0, $irKna.useThirdPartyState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onFetchSiteName = (0, $eUqFw.useCallback)(()=>{
        getSiteName().then((data)=>{
            setThirdPartyState({
                siteName: data
            });
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'thirdPartySiteName retrieved', {
                thirdParty: thirdParty,
                siteName: siteName
            });
        });
    }, [
        createAnalyticsEvent,
        getSiteName,
        setThirdPartyState,
        siteName,
        thirdParty
    ]);
    (0, $eUqFw.useEffect)(()=>{
        shouldShowAccountInfoIfUsingPAT && !siteName && onFetchSiteName();
    }, [
        siteName,
        onFetchSiteName,
        shouldShowAccountInfoIfUsingPAT
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, shouldShowAccountInfoIfUsingPAT && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $buKPq.SiteName), {
        siteName: siteName,
        onFetchSiteName: onFetchSiteName,
        isLoading: isLoading,
        hasErrorOccurred: hasErrorOccurred
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5TlJW.EditPersonalAccessToken), {
        thirdParty: thirdParty
    }), hasErrorOccurred && loadingSiteNameErrorOccurredDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c9f88dd09f45ac07$var$ErrorWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        label: "",
        size: "medium",
        primaryColor: "var(--ds-icon-danger, #EF5C48)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c9f88dd09f45ac07$var$ErrorMessageWrapper, null, formatMessage(loadingSiteNameErrorOccurredDescription))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c9f88dd09f45ac07$var$ErrorWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $c9f88dd09f45ac07$var$ErrorMessageWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1ick _1wyb1crf _19pk1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("g1tXk", function(module, exports) {

$parcel$export(module.exports, "useThirdPartySiteName", () => $054b468b19e798a4$export$93f76226dc1a8867);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $gyZoj = parcelRequire("gyZoj");
var $5GSA7 = parcelRequire("5GSA7");

var $kzTj7 = parcelRequire("kzTj7");

var $3yuWi = parcelRequire("3yuWi");

var $8OWUq = parcelRequire("8OWUq");
const $054b468b19e798a4$export$93f76226dc1a8867 = ({ thirdParty: thirdParty, requestAuthenticationToken: requestAuthenticationToken })=>{
    const thirdPartyClient = (0, $8OWUq.useThirdPartyClient)({
        thirdParty: thirdParty,
        requestAuthenticationToken: requestAuthenticationToken
    });
    const [onExperienceStart, onExperienceSuccess, onExperienceFail] = (0, $5GSA7.useExperienceTracker)((0, $3yuWi.EXPERIENCES).THIRD_PARTY_GET_SITE_NAME);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [hasErrorOccurred, setHasErrorOccurred] = (0, $eUqFw.useState)(false);
    const getSiteName = (0, $eUqFw.useCallback)(async ()=>{
        setIsLoading(true);
        setHasErrorOccurred(false);
        (0, $3yuWi.thirdPartySiteNameMetric).start();
        onExperienceStart();
        try {
            const data = await thirdPartyClient.getSiteName();
            (0, $3yuWi.thirdPartySiteNameMetric).stop();
            onExperienceSuccess();
            setIsLoading(false);
            return data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $3yuWi.thirdPartySiteNameMetric).stop();
            onExperienceFail((0, $kzTj7.APP_IDENTIFIER), error, {
                thirdParty: thirdParty
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'get-third-party-site-name',
                    packageName: (0, $kzTj7.APP_IDENTIFIER),
                    teamName: (0, $gyZoj.APP_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true,
                error: error
            });
            setHasErrorOccurred(true);
            setIsLoading(false);
            return null;
        }
    }, [
        onExperienceFail,
        onExperienceStart,
        onExperienceSuccess,
        thirdParty,
        thirdPartyClient
    ]);
    return {
        isLoading: isLoading,
        hasErrorOccurred: hasErrorOccurred,
        getSiteName: getSiteName
    };
};

});

parcelRegister("5TlJW", function(module, exports) {

$parcel$export(module.exports, "EditPersonalAccessToken", () => $c366f26b325d5599$export$3e6ca7bb1392e155);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $PVrB2 = parcelRequire("PVrB2");

var $cDLTA = parcelRequire("cDLTA");

var $irKna = parcelRequire("irKna");

var $asXeB = parcelRequire("asXeB");
const $c366f26b325d5599$export$3e6ca7bb1392e155 = ({ thirdParty: thirdParty })=>{
    const { changeCurrentAccount: changeCurrentAccount } = (0, $cDLTA.useContentForThirdParty)(thirdParty);
    const [, { setThirdPartyState: setThirdPartyState }] = (0, $irKna.useThirdPartyState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [, { setRequestAuthenticationToken: setRequestAuthenticationToken }] = (0, $asXeB.useAccessTokenModalState)();
    const handleChangeAccount = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: `${thirdParty}ChangeAccountButton`
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
        setRequestAuthenticationToken({
            thirdParty: thirdParty,
            modalType: (0, $PVrB2.AccessTokenModalType).EDIT_TOKEN
        }).then((isSaved)=>{
            if (isSaved) setThirdPartyState({
                selectedWorkspaceId: null,
                selectedFolderId: null,
                selectedSubfolderId: null,
                selectedEntities: null,
                selectedEntityId: null,
                selectedEntityName: null,
                selectedEntityStyle: null,
                workspaces: null,
                folders: null,
                entities: null,
                entityStats: null,
                members: null,
                thirdPartyFieldConfigState: null,
                siteName: null
            });
        });
    }, [
        createAnalyticsEvent,
        thirdParty,
        setRequestAuthenticationToken,
        setThirdPartyState
    ]);
    if (!changeCurrentAccount) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c366f26b325d5599$var$ChangeAccountWrapper, null, formatMessage(changeCurrentAccount, {
        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                appearance: "link",
                spacing: "none",
                onClick: handleChangeAccount
            }, chunks)
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c366f26b325d5599$var$ChangeAccountWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyb1skh _vwz4dlk8 _k48p1nn1",
            __cmplp.className
        ])
    });
});

});


parcelRegister("1IFC6", function(module, exports) {

$parcel$export(module.exports, "EntitySelector", () => $6035b43b19d9eed0$export$6124fcdf0d64bf9d);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4vTMF = parcelRequire("4vTMF");

var $7u4fN = parcelRequire("7u4fN");

var $4LhB6 = parcelRequire("4LhB6");

var $b5IAe = parcelRequire("b5IAe");

var $lRvnl = parcelRequire("lRvnl");

var $5wCDk = parcelRequire("5wCDk");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hNbFQ = parcelRequire("hNbFQ");

var $k28Nj = parcelRequire("k28Nj");

var $e13rv = parcelRequire("e13rv");
const $6035b43b19d9eed0$export$6124fcdf0d64bf9d = ({ label: label, placeholder: placeholder, entities: entities, selectedEntityId: selectedEntityId, isLoading: isLoading, isDisabled: isDisabled = false, autoFocus: autoFocus = false, openMenuOnFocus: openMenuOnFocus = false, isClearable: isClearable = false, onChange: onChange, onChangeOld: onChangeOld, onClear: onClear, hasErrorOccurred: hasErrorOccurred, starredOptionsLabel: starredOptionsLabel, otherOptionsLabel: otherOptionsLabel, noEntitiesFoundHeader: noEntitiesFoundHeader, noEntitiesFoundDescription: noEntitiesFoundDescription, errorOccurredHeader: errorOccurredHeader, onRetry: onRetry, placeholderColor: placeholderColor, isRequired: isRequired, preselectOnlyOption: preselectOnlyOption })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const selectRef = (0, $eUqFw.useRef)(null);
    const onChangeHandler = (0, $eUqFw.useCallback)((option)=>{
        if (option === null && onClear) {
            onClear();
            return;
        }
        if ((0, $eI5EY.fg)('jira_importer_third_party_state_refactor')) option && onChange((0, $k28Nj.convertOptionToEntity)(option));
        else option && onChangeOld(option.value, option.label, option.style);
    }, [
        onChange,
        onChangeOld,
        onClear
    ]);
    const { selectedOption: selectedOption, options: options } = (0, $eUqFw.useMemo)(()=>(0, $k28Nj.getSelectedAndAllOptions)(entities, selectedEntityId, starredOptionsLabel, otherOptionsLabel, placeholderColor), [
        entities,
        otherOptionsLabel,
        placeholderColor,
        selectedEntityId,
        starredOptionsLabel
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // preselect the only option if there is only one option available
        if (preselectOnlyOption && selectRef.current && !isLoading && !selectedOption && options?.length === 1 && 'value' in options[0]) {
            onChangeHandler(options[0]);
            selectRef.current.blur();
        }
    }, [
        isLoading,
        onChangeHandler,
        options,
        preselectOnlyOption,
        selectedOption
    ]);
    if (!isLoading && entities && entities.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingBlockStart: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        title: noEntitiesFoundHeader,
        appearance: "warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, noEntitiesFoundDescription)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6035b43b19d9eed0$var$Wrapper, {
        "data-testid": "project-create-importer-upload-flow.ui.select-third-party-entity-screen.entity-content.entity-selector.wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        label: label,
        name: `selector-${(0, (/*@__PURE__*/$parcel$interopDefault($4vTMF)))(label)}`,
        isRequired: isRequired
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
            ...fieldProps,
            inputId: `entityDropdown-${(0, (/*@__PURE__*/$parcel$interopDefault($4vTMF)))(label)}`,
            name: "entityDropdown",
            options: options,
            value: selectedOption,
            onChange: onChangeHandler,
            placeholder: placeholder,
            isClearable: isClearable,
            isLoading: isLoading,
            isDisabled: isDisabled || hasErrorOccurred,
            autoFocus: autoFocus,
            openMenuOnFocus: openMenuOnFocus,
            components: (0, $hNbFQ.customComponents),
            ref: selectRef
        }), hasErrorOccurred && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            paddingBlockStart: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
            title: errorOccurredHeader,
            appearance: "warning"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            onClick: onRetry,
            appearance: "link",
            spacing: "none"
        }, formatMessage((0, $e13rv.default).tryAgain)))))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6035b43b19d9eed0$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1ejb _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hNbFQ", function(module, exports) {

$parcel$export(module.exports, "customComponents", () => $b66315d93515b27d$export$add9807c3da035df);
$parcel$export(module.exports, "customComponentsWithMenuList", () => $b66315d93515b27d$export$616959a62f49ed15);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $7u4fN = parcelRequire("7u4fN");

var $96IgR = parcelRequire("96IgR");

var $jQxSL = parcelRequire("jQxSL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $cHKP9 = parcelRequire("cHKP9");

var $6pssL = parcelRequire("6pssL");

var $k28Nj = parcelRequire("k28Nj");
const $b66315d93515b27d$var$CustomOption = (props)=>{
    const { label: label, iconUrl: iconUrl, placeholderColor: placeholderColor } = props.data;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b66315d93515b27d$var$OptionWrapper, null, iconUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b66315d93515b27d$var$Icon, {
        src: iconUrl,
        alt: ""
    }) : placeholderColor && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b66315d93515b27d$var$PlaceholderIcon, {
        placeholderColor: placeholderColor,
        "data-testId": "project-create-importer-upload-flow.common.ui.custom-select-components.placeholder-icon"
    }, label?.charAt(0)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b66315d93515b27d$var$TextWrapper, null, label)));
};
const $b66315d93515b27d$var$CustomControl = ({ children: children, ...props })=>{
    const selectedOption = props.getValue();
    const iconUrl = selectedOption && selectedOption[0] != null ? selectedOption[0].iconUrl : null;
    const placeholderColor = selectedOption && selectedOption[0] != null ? selectedOption[0].placeholderColor : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Control, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b66315d93515b27d$var$ControlWrapper, null, iconUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b66315d93515b27d$var$Icon, {
        src: iconUrl,
        alt: ""
    }), !iconUrl && !!placeholderColor && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b66315d93515b27d$var$PlaceholderIconControl, {
        placeholderColor: placeholderColor,
        "data-testId": "project-create-importer-upload-flow.common.ui.custom-select-components.placeholder-icon-control"
    }, selectedOption?.[0]?.label?.charAt(0)), children));
};
const $b66315d93515b27d$var$CustomMenuList = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { selectProps: { menuListProps: { hasSearchErrorOccurred: hasSearchErrorOccurred, searchErrorOccurredDescription: searchErrorOccurredDescription, isLoadingMore: isLoadingMore, hasLoadingMoreErrorOccurred: hasLoadingMoreErrorOccurred, loadingMoreErrorOccurredDescription: loadingMoreErrorOccurredDescription, onRetryLoadingMore: onRetryLoadingMore } } } = props;
    const content = (0, $eUqFw.useMemo)(()=>{
        if (hasSearchErrorOccurred) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b66315d93515b27d$var$ErrorWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b66315d93515b27d$var$SearchErrorIcon, {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($cHKP9)))
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b66315d93515b27d$var$ErrorContent, null, searchErrorOccurredDescription));
        if (hasLoadingMoreErrorOccurred) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b66315d93515b27d$var$ErrorWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
            label: "",
            size: "xlarge"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b66315d93515b27d$var$ErrorContent, null, loadingMoreErrorOccurredDescription), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            onClick: onRetryLoadingMore,
            appearance: "link",
            spacing: "none"
        }, formatMessage((0, $6pssL.default).tryAgain)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.children, isLoadingMore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b66315d93515b27d$var$LoadingWrapper, null, formatMessage((0, $6pssL.default).loadMore)));
    }, [
        formatMessage,
        hasLoadingMoreErrorOccurred,
        hasSearchErrorOccurred,
        isLoadingMore,
        loadingMoreErrorOccurredDescription,
        onRetryLoadingMore,
        props.children,
        searchErrorOccurredDescription
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).MenuList, props, content);
};
const $b66315d93515b27d$export$add9807c3da035df = {
    Option: $b66315d93515b27d$var$CustomOption,
    Control: $b66315d93515b27d$var$CustomControl
};
const $b66315d93515b27d$export$616959a62f49ed15 = {
    ...$b66315d93515b27d$export$add9807c3da035df,
    // using ComponentType<any> to allow custom props to be passed to menu list
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    MenuList: $b66315d93515b27d$var$CustomMenuList
};
const $b66315d93515b27d$var$OptionWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1yt41b66 _4cvr1h6o _1r5sh8dc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b66315d93515b27d$var$ControlWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bsb1osq _wpv8u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b66315d93515b27d$var$TextWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5721q9c _1reo15vq _18m915vq _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b66315d93515b27d$var$Icon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1ejb _4t3i1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b66315d93515b27d$var$SearchErrorIcon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1jfw _4t3i1jfw _otyrpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b66315d93515b27d$var$PlaceholderIcon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { placeholderColor: placeholderColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_ehyr2h": (0, $9t7rW.default)((0, $k28Nj.getDesignTokenBackgroundColor)(__cmplp.placeholderColor))
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1tcg _4t3i1tcg _bfhk1rbt _18s8h8dc _vwz41tcg _y3gn1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b66315d93515b27d$var$PlaceholderIconControl = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $b66315d93515b27d$var$PlaceholderIcon, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b66315d93515b27d$var$ErrorWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _1yt41ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b66315d93515b27d$var$ErrorContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1h6o _vwz4gktf _1wybdlk8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b66315d93515b27d$var$LoadingWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1ejb _syaznoz8 _vwz41tcg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6pssL", function(module, exports) {

$parcel$export(module.exports, "default", () => $40469d6d302f9e43$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $40469d6d302f9e43$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    loadMore: {
        "id": "project-create-importer-upload-flow.common.custom-select-components.load-more",
        "defaultMessage": "Loading..."
    },
    tryAgain: {
        "id": "project-create-importer-upload-flow.common.custom-select-components.try-again",
        "defaultMessage": "Try again"
    }
});

});

parcelRegister("k28Nj", function(module, exports) {

$parcel$export(module.exports, "getDesignTokenBackgroundColor", () => $801dd8f09f3c4e00$export$497244f2c7058105);
$parcel$export(module.exports, "convertEntityToOption", () => $801dd8f09f3c4e00$export$5eb73ad1b1df57fb);
$parcel$export(module.exports, "convertOptionToEntity", () => $801dd8f09f3c4e00$export$bc03e622cd3f7809);
$parcel$export(module.exports, "getSelectedAndAllOptions", () => $801dd8f09f3c4e00$export$a3a6a32fc2916386);
$parcel$export(module.exports, "getMultipleSelectedAndAllOptions", () => $801dd8f09f3c4e00$export$dc24dd72a36743bd);

var $PdmhA = parcelRequire("PdmhA");
const $801dd8f09f3c4e00$export$497244f2c7058105 = (colorCode)=>{
    switch(colorCode){
        case 0, $PdmhA.Y200:
            return `var(--ds-background-accent-yellow-subtle, ${0, $PdmhA.Y200})`;
        case 0, $PdmhA.T200:
        default:
            return `var(--ds-background-accent-teal-subtle, ${0, $PdmhA.T200})`;
    }
};
const $801dd8f09f3c4e00$export$5eb73ad1b1df57fb = ({ name: name, id: id, iconUrl: iconUrl, isStarred: isStarred, placeholderColor: placeholderColor, style: style })=>({
        label: name,
        value: id,
        iconUrl: iconUrl,
        isStarred: isStarred,
        placeholderColor: placeholderColor,
        style: style
    });
const $801dd8f09f3c4e00$export$bc03e622cd3f7809 = (option)=>({
        name: option.label,
        id: option.value,
        iconUrl: option.iconUrl,
        isStarred: option.isStarred,
        style: option.style
    });
const $801dd8f09f3c4e00$export$a3a6a32fc2916386 = (entities, selectedEntityId, starredOptionsLabel, otherOptionsLabel, placeholderColor)=>{
    if (!entities) return {
        options: [],
        selectedOption: null
    };
    let selectedOption = null;
    const starredOptions = [];
    const otherOptions = [];
    entities.forEach((entity)=>{
        const option = $801dd8f09f3c4e00$export$5eb73ad1b1df57fb({
            ...entity,
            placeholderColor: placeholderColor
        });
        if (entity.id === selectedEntityId) selectedOption = option;
        if (entity.isStarred) starredOptions.push(option);
        else otherOptions.push(option);
    });
    if (starredOptions.length > 0) return {
        selectedOption: selectedOption,
        options: [
            {
                label: starredOptionsLabel,
                options: starredOptions
            },
            {
                label: otherOptionsLabel,
                options: otherOptions
            }
        ]
    };
    return {
        selectedOption: selectedOption,
        options: otherOptions
    };
};
const $801dd8f09f3c4e00$export$dc24dd72a36743bd = (entities, selectedEntities)=>{
    if (!entities) return {
        options: [],
        selectedOptions: null
    };
    const selectedOptions = [];
    const otherOptions = [];
    entities.forEach((entity)=>{
        const option = $801dd8f09f3c4e00$export$5eb73ad1b1df57fb(entity);
        if (selectedEntities?.find((selectedEntity)=>selectedEntity.id === entity.id)) selectedOptions.push(option);
        otherOptions.push(option);
    });
    return {
        selectedOptions: selectedOptions,
        options: otherOptions
    };
};

});


parcelRegister("e13rv", function(module, exports) {

$parcel$export(module.exports, "default", () => $d41033e3d23fa767$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d41033e3d23fa767$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    tryAgain: {
        "id": "project-create-importer-upload-flow.select-third-party-entity-screen.entity-content.entity-selector.try-again",
        "defaultMessage": "Try again"
    }
});

});


parcelRegister("9orTz", function(module, exports) {

$parcel$export(module.exports, "EntitySelectorCheckbox", () => $b3c254ba9057fb8a$export$c2251e727a5c92f2);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4vTMF = parcelRequire("4vTMF");

var $7u4fN = parcelRequire("7u4fN");

var $7jPhn = parcelRequire("7jPhn");
var $4LhB6 = parcelRequire("4LhB6");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");

var $lRvnl = parcelRequire("lRvnl");

var $jvznW = parcelRequire("jvznW");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kzTj7 = parcelRequire("kzTj7");

var $k28Nj = parcelRequire("k28Nj");

var $hKJRy = parcelRequire("hKJRy");

var $h7Nx5 = parcelRequire("h7Nx5");
const $b3c254ba9057fb8a$var$MINIMUM_MENU_HEIGHT = 400;
const $b3c254ba9057fb8a$export$c2251e727a5c92f2 = ({ label: label, placeholder: placeholder, entities: entities, selectedEntities: selectedEntities, isLoading: isLoading, isDisabled: isDisabled = false, autoFocus: autoFocus = false, openMenuOnFocus: openMenuOnFocus = false, onChange: onChange, onClear: onClear, hasErrorOccurred: hasErrorOccurred, noEntitiesFoundHeader: noEntitiesFoundHeader, noEntitiesFoundDescription: noEntitiesFoundDescription, errorOccurredHeader: errorOccurredHeader, onRetry: onRetry, isRequired: isRequired })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [error, setError] = (0, $eUqFw.useState)(null);
    const validateField = (0, $eUqFw.useCallback)((optionValues)=>{
        if (optionValues && optionValues.length > (0, $kzTj7.CLICKUP_MAX_LISTS)) setError(formatMessage((0, $h7Nx5.default).maxListError, {
            maxListCount: (0, $kzTj7.CLICKUP_MAX_LISTS)
        }));
        else setError(null);
    }, [
        formatMessage
    ]);
    const onSelectAll = (0, $eUqFw.useCallback)(()=>{
        if (entities && entities.length > 0) onChange(entities);
    }, [
        entities,
        onChange
    ]);
    const onChangeHandler = (0, $eUqFw.useCallback)((optionValues)=>{
        if (optionValues === null && onClear) {
            onClear();
            return;
        }
        const selectedOptions = optionValues?.map((option)=>(0, $k28Nj.convertOptionToEntity)(option));
        selectedOptions && onChange(selectedOptions);
        validateField(optionValues);
    }, [
        onChange,
        onClear,
        validateField
    ]);
    const { selectedOptions: selectedOptions, options: options } = (0, $eUqFw.useMemo)(()=>(0, $k28Nj.getMultipleSelectedAndAllOptions)(entities, selectedEntities), [
        entities,
        selectedEntities
    ]);
    if (!isLoading && entities && entities.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingBlockStart: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        title: noEntitiesFoundHeader,
        appearance: "warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), null, noEntitiesFoundDescription)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b3c254ba9057fb8a$var$Wrapper, {
        "data-testid": "project-create-importer-upload-flow.ui.select-third-party-entity-screen.entity-content.entity-selector-checkbox.wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        label: label,
        name: `selector-${(0, (/*@__PURE__*/$parcel$interopDefault($4vTMF)))(label)}`,
        isRequired: isRequired
    }, ({ fieldProps: { id: id, ...otherFieldProps } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jvznW.default), {
            id: `entityMultiDropdown-${(0, (/*@__PURE__*/$parcel$interopDefault($4vTMF)))(label)}`,
            ...otherFieldProps,
            inputId: `entityMultiDropdown-input-${(0, (/*@__PURE__*/$parcel$interopDefault($4vTMF)))(label)}`,
            name: "entityMultiDropdown",
            options: options,
            value: selectedOptions,
            onChange: onChangeHandler,
            placeholder: placeholder,
            isClearable: true,
            isLoading: isLoading,
            isDisabled: isDisabled || hasErrorOccurred,
            autoFocus: autoFocus,
            openMenuOnFocus: openMenuOnFocus,
            minMenuHeight: $b3c254ba9057fb8a$var$MINIMUM_MENU_HEIGHT,
            isMulti: true,
            isInvalid: !!error,
            menuPlacement: "auto",
            components: {
                MenuList: (menuListProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hKJRy.MenuWithFooter), {
                        ...menuListProps,
                        showSelectAll: options.length <= (0, $kzTj7.CLICKUP_MAX_LISTS) && !isLoading,
                        onSelectAllClick: onSelectAll
                    })
            }
        }), !error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.HelperMessage), null, formatMessage((0, $h7Nx5.default).maxListHelperText, {
            maxListCount: (0, $kzTj7.CLICKUP_MAX_LISTS)
        })), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, error), hasErrorOccurred && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            paddingBlockStart: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
            title: errorOccurredHeader,
            appearance: "warning"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            onClick: onRetry,
            appearance: "link",
            spacing: "none"
        }, formatMessage((0, $h7Nx5.default).tryAgain)))))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b3c254ba9057fb8a$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1ejb _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jvznW", function(module, exports) {

$parcel$export(module.exports, "default", () => $a632e850af918cb2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5wCDk = parcelRequire("5wCDk");

var $bVKeg = parcelRequire("bVKeg");
const $a632e850af918cb2$var$CheckboxSelectInternal = ({ components: components, ...props })=>{
    const mergedComponents = (0, $eUqFw.useMemo)(()=>({
            ...components,
            Option: (0, $bVKeg.CheckboxOption)
        }), [
        components
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
        closeMenuOnSelect: false,
        hideSelectedOptions: false,
        isMulti: true,
        ...props,
        components: mergedComponents
    });
};
const $a632e850af918cb2$var$CheckboxSelect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo($a632e850af918cb2$var$CheckboxSelectInternal);
var $a632e850af918cb2$export$2e2bcd8739ae039 = $a632e850af918cb2$var$CheckboxSelect;

});
parcelRegister("bVKeg", function(module, exports) {

$parcel$export(module.exports, "CheckboxOption", () => $abfb51c6af49e9a3$export$d40cc97ecda916f9);
$parcel$export(module.exports, "RadioOption", () => $abfb51c6af49e9a3$export$82ab7168879267a7);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $c6Z6Z = parcelRequire("c6Z6Z");

var $hSJ9G = parcelRequire("hSJ9G");

var $PdmhA = parcelRequire("PdmhA");
function $abfb51c6af49e9a3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $abfb51c6af49e9a3$var$getPrimitiveStyles = (props)=>{
    const { cx: cx, className: className, getStyles: getStyles, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected } = props;
    const baseStyles = {
        alignItems: 'center',
        backgroundColor: isFocused ? `var(--ds-background-neutral-subtle-hovered, ${0, $PdmhA.N20})` : 'transparent',
        color: isDisabled ? "var(--ds-text-disabled, inherit)" : 'inherit',
        display: 'flex ',
        paddingBottom: "var(--ds-space-050, 4px)",
        paddingLeft: "var(--ds-space-200, 16px)",
        paddingTop: "var(--ds-space-050, 4px)",
        // This 'none' needs to be present to ensure that style is not applied when
        // the option is selected but not focused.
        boxShadow: isFocused ? `inset 2px 0px 0px ${`var(--ds-border-focused, ${0, $PdmhA.B400})`}` : 'none',
        ':active': {
            backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $PdmhA.N30)})`
        },
        '@media screen and (-ms-high-contrast: active)': {
            borderLeft: isFocused ? '2px solid transparent' : ''
        }
    };
    const augmentedStyles = /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...getStyles('option', props),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...baseStyles
    });
    const bemClasses = {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    };
    // maintain react-select API
    return [
        augmentedStyles,
        cx(bemClasses, className)
    ];
};
// the primary color represents the outer or background element
const $abfb51c6af49e9a3$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return `var(--ds-background-disabled, ${0, $PdmhA.B75})`;
    else if (isDisabled) return `var(--ds-background-disabled, ${0, $PdmhA.N20A})`;
    else if (isSelected && isActive) return `var(--ds-background-selected-bold-pressed, ${0, $PdmhA.B75})`;
    else if (isActive) return `var(--ds-background-selected-pressed, ${0, $PdmhA.B75})`;
    else if (isFocused && isSelected) return `var(--ds-background-selected-bold-hovered, ${0, $PdmhA.B300})`;
    else if (isFocused) return `var(--ds-surface, ${0, $PdmhA.N0})`;
    else if (isSelected) return `var(--ds-background-selected-bold, ${0, $PdmhA.B400})`;
    return `var(--ds-background-neutral, ${0, $PdmhA.N0})`;
};
// the secondary color represents the radio dot or checkmark
const $abfb51c6af49e9a3$var$getSecondaryColor = ({ isActive: isActive, isDisabled: isDisabled, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return `var(--ds-text-disabled, ${0, $PdmhA.N70})`;
    else if (isActive && isSelected && !isDisabled) return `var(--ds-surface, ${0, $PdmhA.B400})`;
    else if (!isSelected) return 'transparent';
    return `var(--ds-surface, ${0, $PdmhA.N0})`;
};
// the border color surrounds the checkbox/radio
const $abfb51c6af49e9a3$var$getBorderColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return `var(--ds-background-disabled, ${0, $PdmhA.B400})`;
    else if (isDisabled) return `var(--ds-background-disabled, ${0, $PdmhA.N100})`;
    else if (isSelected && isActive) return `var(--ds-background-selected-bold-pressed, ${0, $PdmhA.B400})`;
    else if (isActive) return `var(--ds-background-selected-bold, ${0, $PdmhA.B400})`;
    else if (isFocused && isSelected) return `var(--ds-background-selected-bold-hovered, ${0, $PdmhA.B400})`;
    else if (isFocused) return `var(--ds-border-input, ${0, $PdmhA.N100})`;
    else if (isSelected) return `var(--ds-background-selected-bold, ${0, $PdmhA.B400})`;
    return `var(--ds-border-input, ${0, $PdmhA.N100})`;
};
const $abfb51c6af49e9a3$var$baseIconStyles = {
    name: "zlggru",
    styles: "align-items:center;display:flex ;flex-shrink:0;padding-inline-end:var(--ds-space-050, 4px);& svg rect, & svg circle:first-of-type{stroke-width:var(--ds-border-width, 1px);stroke-linejoin:round;}"
};
const $abfb51c6af49e9a3$var$baseOptionStyles = {
    name: "6gb5tk",
    styles: "text-overflow:ellipsis;overflow-x:hidden;flex-grow:1;white-space:nowrap"
};
class $abfb51c6af49e9a3$var$ControlOption extends (0, $eUqFw.Component) {
    render() {
        const { getStyles: getStyles, Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, ...rest } = this.props;
        // prop assignment
        const props = {
            ...innerProps,
            onMouseDown: this.onMouseDown,
            onMouseUp: this.onMouseUp,
            onMouseLeave: this.onMouseLeave
        };
        const [styles, classes] = $abfb51c6af49e9a3$var$getPrimitiveStyles({
            getStyles: getStyles,
            ...rest
        });
        return(// These need to remain this way because `react-select` passes props with
        // styles inside, and that must be done dynamically.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: styles,
            className: classes,
            ref: innerRef,
            ...props
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: [
                $abfb51c6af49e9a3$var$baseIconStyles,
                // Here we are adding a border to the Checkbox and Radio SVG icons
                // This is an a11y fix for Select only for now but it may be rolled
                // into the `@atlaskit/icon` package's Checkbox and Radio SVGs later
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
                {
                    // This can eventually be changed to static styles that are
                    // applied conditionally (e.g. `isActive && activeBorderStyles`),
                    // but considering there are multiple instances of `react-select`
                    // requiring styles to be generated dynamically, it seemed like a
                    // low priority.
                    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
                    '& svg rect, & svg circle:first-of-type': {
                        stroke: $abfb51c6af49e9a3$var$getBorderColor({
                            ...this.props,
                            ...this.state
                        })
                    }
                }
            ]
        }, !!Icon ? /*#__PURE__*/ (0, $byn9U.jsx)(Icon, {
            label: "",
            primaryColor: $abfb51c6af49e9a3$var$getPrimaryColor({
                ...this.props,
                ...this.state
            }),
            secondaryColor: $abfb51c6af49e9a3$var$getSecondaryColor({
                ...this.props,
                ...this.state
            })
        }) : null), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $abfb51c6af49e9a3$var$baseOptionStyles
        }, children)));
    }
    constructor(...args){
        super(...args);
        this.state = {
            isActive: false
        };
        this.onMouseDown = ()=>this.setState({
                isActive: true
            });
        this.onMouseUp = ()=>this.setState({
                isActive: false
            });
        this.onMouseLeave = ()=>this.setState({
                isActive: false
            });
    }
}
const $abfb51c6af49e9a3$export$d40cc97ecda916f9 = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)($abfb51c6af49e9a3$var$ControlOption, {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($hSJ9G))),
        ...props
    });
const $abfb51c6af49e9a3$export$82ab7168879267a7 = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)($abfb51c6af49e9a3$var$ControlOption, {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($c6Z6Z))),
        ...props
    });

});


parcelRegister("hKJRy", function(module, exports) {

$parcel$export(module.exports, "MenuWithFooter", () => $3c9f2139142764f5$export$9192c1e9feba6bf2);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $jQxSL = parcelRequire("jQxSL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $9RSnD = parcelRequire("9RSnD");
const $3c9f2139142764f5$export$9192c1e9feba6bf2 = (props)=>{
    const { showSelectAll: showSelectAll, onSelectAllClick: onSelectAllClick, children: children, ...restProps } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).MenuList, restProps, children), showSelectAll && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        padding: "space.100",
        xcss: $3c9f2139142764f5$var$footerStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingInline: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        spacing: "compact",
        onClick: onSelectAllClick
    }, formatMessage((0, $9RSnD.default).selectAllOption)))));
};
const $3c9f2139142764f5$var$footerStyle = (0, $1ZAYh.xcss)({
    borderTop: `1px solid ${"var(--ds-border, #dfe1e6)"}`
});

});
parcelRegister("9RSnD", function(module, exports) {

$parcel$export(module.exports, "default", () => $cae86a12da559953$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $cae86a12da559953$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    selectAllOption: {
        "id": "project-create-importer-upload-flow.select-third-party-entity-screen.entity-content.entity-selector-checkbox.menu-with-footer.select-all-option",
        "defaultMessage": "Select all"
    }
});

});


parcelRegister("h7Nx5", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff78bf7650385f60$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ff78bf7650385f60$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    tryAgain: {
        "id": "project-create-importer-upload-flow.select-third-party-entity-screen.entity-content.entity-selector-checkbox.try-again",
        "defaultMessage": "Try again"
    },
    maxListHelperText: {
        "id": "project-create-importer-upload-flow.select-third-party-entity-screen.entity-content.entity-selector-checkbox.max-list-helper-text",
        "defaultMessage": "Select up to {maxListCount, plural, one {# list} other {# lists}}"
    },
    maxListError: {
        "id": "project-create-importer-upload-flow.select-third-party-entity-screen.entity-content.entity-selector-checkbox.max-list-error",
        "defaultMessage": "Please select a maximum of {maxListCount, plural, one {# list} other {# lists}}."
    }
});

});


parcelRegister("ck9sR", function(module, exports) {

$parcel$export(module.exports, "EntitySelectorWithPagination", () => $5f8313d0e2ee2dc7$export$8c5225abffc5d071);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8blac = parcelRequire("8blac");

var $4vTMF = parcelRequire("4vTMF");

var $7u4fN = parcelRequire("7u4fN");

var $4LhB6 = parcelRequire("4LhB6");

var $b5IAe = parcelRequire("b5IAe");

var $lRvnl = parcelRequire("lRvnl");

var $fm9CZ = parcelRequire("fm9CZ");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fO0l8 = parcelRequire("fO0l8");

var $kzTj7 = parcelRequire("kzTj7");

var $hNbFQ = parcelRequire("hNbFQ");

var $k28Nj = parcelRequire("k28Nj");

var $1GS0F = parcelRequire("1GS0F");
const $5f8313d0e2ee2dc7$export$8c5225abffc5d071 = ({ label: label, placeholder: placeholder, entities: entities, selectedEntityId: selectedEntityId, isLoading: isLoading, isDisabled: isDisabled = false, isRequired: isRequired, autoFocus: autoFocus = false, openMenuOnFocus: openMenuOnFocus = false, onChangeOld: onChangeOld, onChange: onChange, onSearchEntities: onSearchEntities, onResetSearchError: onResetSearchError, hasErrorOccurred: hasErrorOccurred, hasSearchErrorOccurred: hasSearchErrorOccurred, starredOptionsLabel: starredOptionsLabel, otherOptionsLabel: otherOptionsLabel, noEntitiesFoundHeader: noEntitiesFoundHeader, noEntitiesFoundDescription: noEntitiesFoundDescription, errorOccurredHeader: errorOccurredHeader, searchErrorOccurredDescription: searchErrorOccurredDescription, loadingMoreErrorOccurredDescription: loadingMoreErrorOccurredDescription, onRetry: onRetry, placeholderColor: placeholderColor, selectedEntityName: selectedEntityName, onMenuScrollToBottom: onMenuScrollToBottom })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isSearching = (0, $eUqFw.useRef)(false);
    const onChangeHandler = (0, $eUqFw.useCallback)((option)=>{
        if ((0, $eI5EY.fg)('jira_importer_third_party_state_refactor')) option && onChange((0, $k28Nj.convertOptionToEntity)(option));
        else option && onChangeOld(option.value, option.label, option.style);
        isSearching.current = false;
    }, [
        onChange,
        onChangeOld
    ]);
    const { selectedOption: selectedOption, options: options } = (0, $eUqFw.useMemo)(()=>{
        const entitiesWithSelected = [
            ...entities || []
        ];
        if (selectedEntityId !== null) {
            const entitiesSet = new Set(entities?.map((entity)=>entity.id) || []);
            entitiesSet.add(selectedEntityId);
            if (entitiesSet.size !== entitiesWithSelected.length) entitiesWithSelected.push({
                id: selectedEntityId,
                name: selectedEntityName || ''
            });
        }
        return (0, $k28Nj.getSelectedAndAllOptions)(entitiesWithSelected, selectedEntityId, starredOptionsLabel, otherOptionsLabel, placeholderColor);
    }, [
        entities,
        otherOptionsLabel,
        placeholderColor,
        selectedEntityId,
        selectedEntityName,
        starredOptionsLabel
    ]);
    const debouncedLoadOptions = (0, $eUqFw.useMemo)(()=>(0, $fO0l8.default)((inputValue)=>{
            if (inputValue === '') return Promise.resolve(options);
            return onSearchEntities(inputValue).then((searchResultEntities)=>searchResultEntities?.map((entity)=>(0, $k28Nj.convertEntityToOption)({
                        ...entity,
                        placeholderColor: placeholderColor
                    })) || []);
        }, (0, $kzTj7.DEBOUNCE_DELAY)), [
        onSearchEntities,
        options,
        placeholderColor
    ]);
    const onInputChangeHandler = (0, $eUqFw.useCallback)((inputValue)=>{
        isSearching.current = !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(inputValue);
        if (!isSearching.current && hasSearchErrorOccurred) onResetSearchError();
    }, [
        hasSearchErrorOccurred,
        onResetSearchError
    ]);
    const onMenuScrollToBottomHandler = (0, $eUqFw.useCallback)(()=>{
        if (isSearching.current) return;
        onMenuScrollToBottom();
    }, [
        onMenuScrollToBottom
    ]);
    if (!isLoading && entities && entities.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingBlockStart: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        title: noEntitiesFoundHeader,
        appearance: "warning"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, noEntitiesFoundDescription)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5f8313d0e2ee2dc7$var$Wrapper, {
        "data-testid": "project-create-importer-upload-flow.ui.select-third-party-entity-screen.entity-content.entity-selector-with-pagination.wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        label: label,
        name: `selector-${(0, (/*@__PURE__*/$parcel$interopDefault($4vTMF)))(label)}`,
        isRequired: isRequired
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fm9CZ.default), {
            ...fieldProps,
            inputId: `entityDropdown-${(0, (/*@__PURE__*/$parcel$interopDefault($4vTMF)))(label)}`,
            name: "entityDropdown",
            defaultOptions: options,
            loadOptions: debouncedLoadOptions,
            value: selectedOption,
            onChange: onChangeHandler,
            placeholder: placeholder,
            isClearable: false,
            isLoading: isLoading,
            isDisabled: isDisabled || hasErrorOccurred && !entities,
            autoFocus: autoFocus,
            openMenuOnFocus: openMenuOnFocus,
            components: (0, $hNbFQ.customComponentsWithMenuList),
            menuListProps: {
                hasSearchErrorOccurred: hasSearchErrorOccurred,
                searchErrorOccurredDescription: searchErrorOccurredDescription,
                isLoadingMore: isLoading && !!entities,
                hasLoadingMoreErrorOccurred: hasErrorOccurred && !!entities,
                loadingMoreErrorOccurredDescription: loadingMoreErrorOccurredDescription,
                onRetryLoadingMore: onMenuScrollToBottomHandler
            },
            onInputChange: onInputChangeHandler,
            onMenuScrollToBottom: onMenuScrollToBottomHandler
        }), hasErrorOccurred && !entities && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            paddingBlockStart: "space.200"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
            title: errorOccurredHeader,
            appearance: "warning"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            onClick: onRetry,
            appearance: "link",
            spacing: "none"
        }, formatMessage((0, $1GS0F.default).tryAgain)))))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5f8313d0e2ee2dc7$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1ejb _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fm9CZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a14ede2f273d8bdb$export$2e2bcd8739ae039);

var $hgTYM = parcelRequire("hgTYM");

var $5FjBr = parcelRequire("5FjBr");
var $a14ede2f273d8bdb$export$2e2bcd8739ae039 = (0, $5FjBr.default)((0, $hgTYM.default));

});
parcelRegister("hgTYM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c92f5a99b4ea3691$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useAsync", () => (parcelRequire("3IL7Z")).u);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $7IqRg = parcelRequire("7IqRg");

var $3IL7Z = parcelRequire("3IL7Z");
parcelRequire("1Xn5q");
parcelRequire("lDSrn");
parcelRequire("lIEGP");
parcelRequire("eT4IF");
parcelRequire("7Dzgl");
parcelRequire("fVK4C");


parcelRequire("aKcqM");
parcelRequire("bwPfh");
parcelRequire("5sKOb");
parcelRequire("jqNEH");
parcelRequire("5zQU9");
parcelRequire("lEfVV");

parcelRequire("k286k");

var $c92f5a99b4ea3691$var$AsyncSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function(props, ref) {
    var stateManagedProps = (0, $3IL7Z.u)(props);
    var selectProps = (0, $7IqRg.u)(stateManagedProps);
    return /*#__PURE__*/ $eUqFw.createElement((0, $cEc3i.S), (0, $kU09D.default)({
        ref: ref
    }, selectProps));
});
var $c92f5a99b4ea3691$export$2e2bcd8739ae039 = $c92f5a99b4ea3691$var$AsyncSelect;

});
parcelRegister("3IL7Z", function(module, exports) {

$parcel$export(module.exports, "u", () => $2b5a09c16d37496a$export$3b14a55fb2447963);

var $5zQU9 = parcelRequire("5zQU9");

var $1Xn5q = parcelRequire("1Xn5q");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
var $2b5a09c16d37496a$var$_excluded = [
    "defaultOptions",
    "cacheOptions",
    "loadOptions",
    "options",
    "isLoading",
    "onInputChange",
    "filterOption"
];
function $2b5a09c16d37496a$export$3b14a55fb2447963(_ref) {
    var _ref$defaultOptions = _ref.defaultOptions, propsDefaultOptions = _ref$defaultOptions === void 0 ? false : _ref$defaultOptions, _ref$cacheOptions = _ref.cacheOptions, cacheOptions = _ref$cacheOptions === void 0 ? false : _ref$cacheOptions, propsLoadOptions = _ref.loadOptions;
    _ref.options;
    var _ref$isLoading = _ref.isLoading, propsIsLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, propsOnInputChange = _ref.onInputChange, _ref$filterOption = _ref.filterOption, filterOption = _ref$filterOption === void 0 ? null : _ref$filterOption, restSelectProps = (0, $bwPfh.default)(_ref, $2b5a09c16d37496a$var$_excluded);
    var propsInputValue = restSelectProps.inputValue;
    var lastRequest = (0, $eUqFw.useRef)(undefined);
    var mounted = (0, $eUqFw.useRef)(false);
    var _useState = (0, $eUqFw.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined), _useState2 = (0, $aKcqM.default)(_useState, 2), defaultOptions = _useState2[0], setDefaultOptions = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : ''), _useState4 = (0, $aKcqM.default)(_useState3, 2), stateInputValue = _useState4[0], setStateInputValue = _useState4[1];
    var _useState5 = (0, $eUqFw.useState)(propsDefaultOptions === true), _useState6 = (0, $aKcqM.default)(_useState5, 2), isLoading = _useState6[0], setIsLoading = _useState6[1];
    var _useState7 = (0, $eUqFw.useState)(undefined), _useState8 = (0, $aKcqM.default)(_useState7, 2), loadedInputValue = _useState8[0], setLoadedInputValue = _useState8[1];
    var _useState9 = (0, $eUqFw.useState)([]), _useState10 = (0, $aKcqM.default)(_useState9, 2), loadedOptions = _useState10[0], setLoadedOptions = _useState10[1];
    var _useState11 = (0, $eUqFw.useState)(false), _useState12 = (0, $aKcqM.default)(_useState11, 2), passEmptyOptions = _useState12[0], setPassEmptyOptions = _useState12[1];
    var _useState13 = (0, $eUqFw.useState)({}), _useState14 = (0, $aKcqM.default)(_useState13, 2), optionsCache = _useState14[0], setOptionsCache = _useState14[1];
    var _useState15 = (0, $eUqFw.useState)(undefined), _useState16 = (0, $aKcqM.default)(_useState15, 2), prevDefaultOptions = _useState16[0], setPrevDefaultOptions = _useState16[1];
    var _useState17 = (0, $eUqFw.useState)(undefined), _useState18 = (0, $aKcqM.default)(_useState17, 2), prevCacheOptions = _useState18[0], setPrevCacheOptions = _useState18[1];
    if (cacheOptions !== prevCacheOptions) {
        setOptionsCache({});
        setPrevCacheOptions(cacheOptions);
    }
    if (propsDefaultOptions !== prevDefaultOptions) {
        setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        setPrevDefaultOptions(propsDefaultOptions);
    }
    (0, $eUqFw.useEffect)(function() {
        mounted.current = true;
        return function() {
            mounted.current = false;
        };
    }, []);
    var loadOptions = (0, $eUqFw.useCallback)(function(inputValue, callback) {
        if (!propsLoadOptions) return callback();
        var loader = propsLoadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') loader.then(callback, function() {
            return callback();
        });
    }, [
        propsLoadOptions
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (propsDefaultOptions === true) loadOptions(stateInputValue, function(options) {
            if (!mounted.current) return;
            setDefaultOptions(options || []);
            setIsLoading(!!lastRequest.current);
        });
    // NOTE: this effect is designed to only run when the component mounts,
    // so we don't want to include any hook dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var onInputChange = (0, $eUqFw.useCallback)(function(newValue, actionMeta) {
        var inputValue = (0, $jQxSL.L)(newValue, actionMeta, propsOnInputChange);
        if (!inputValue) {
            lastRequest.current = undefined;
            setStateInputValue('');
            setLoadedInputValue('');
            setLoadedOptions([]);
            setIsLoading(false);
            setPassEmptyOptions(false);
            return;
        }
        if (cacheOptions && optionsCache[inputValue]) {
            setStateInputValue(inputValue);
            setLoadedInputValue(inputValue);
            setLoadedOptions(optionsCache[inputValue]);
            setIsLoading(false);
            setPassEmptyOptions(false);
        } else {
            var request = lastRequest.current = {};
            setStateInputValue(inputValue);
            setIsLoading(true);
            setPassEmptyOptions(!loadedInputValue);
            loadOptions(inputValue, function(options) {
                if (!mounted) return;
                if (request !== lastRequest.current) return;
                lastRequest.current = undefined;
                setIsLoading(false);
                setLoadedInputValue(inputValue);
                setLoadedOptions(options || []);
                setPassEmptyOptions(false);
                setOptionsCache(options ? (0, $1Xn5q.default)((0, $1Xn5q.default)({}, optionsCache), {}, (0, $5zQU9.default)({}, inputValue, options)) : optionsCache);
            });
        }
    }, [
        cacheOptions,
        loadOptions,
        loadedInputValue,
        optionsCache,
        propsOnInputChange
    ]);
    var options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, restSelectProps), {}, {
        options: options,
        isLoading: isLoading || propsIsLoading,
        onInputChange: onInputChange,
        filterOption: filterOption
    });
}

});



parcelRegister("fO0l8", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5761c68e5511d47$export$2e2bcd8739ae039);
const $a5761c68e5511d47$var$defer = ()=>{
    const deferred = {};
    deferred.promise = new Promise((resolve, reject)=>{
        deferred.resolve = resolve;
        deferred.reject = reject;
    });
    return deferred;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a5761c68e5511d47$var$debounce(fn, wait = 0) {
    let deferred;
    let timer;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let lastArgs;
    function flush() {
        const thisDeferred = deferred;
        clearTimeout(timer);
        if (thisDeferred) // @ts-expect-error - TS2683 - 'this' implicitly has type 'any' because it does not have a type annotation. | TS7005 - Variable 'lastArgs' implicitly has an 'any' type.
        // eslint-disable-next-line @typescript-eslint/no-invalid-this
        Promise.resolve(fn.apply(this, lastArgs)).then(thisDeferred.resolve, thisDeferred.reject);
        lastArgs = [];
        deferred = null;
    }
    // @ts-expect-error - TS2322 - Type '(...args: readonly any[]) => any' is not assignable to type 'F'.
    return function debounced(...args) {
        if (deferred) clearTimeout(timer);
        else deferred = $a5761c68e5511d47$var$defer();
        lastArgs = args;
        // @ts-expect-error - TS2683 - 'this' implicitly has type 'any' because it does not have a type annotation.
        // eslint-disable-next-line @typescript-eslint/no-invalid-this
        timer = setTimeout(flush.bind(this), wait);
        return deferred.promise;
    };
}
var $a5761c68e5511d47$export$2e2bcd8739ae039 = $a5761c68e5511d47$var$debounce;

});

parcelRegister("1GS0F", function(module, exports) {

$parcel$export(module.exports, "default", () => $fff0640cd064f58f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $fff0640cd064f58f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    tryAgain: {
        "id": "project-create-importer-upload-flow.select-third-party-entity-screen.entity-content.entity-selector-with-pagination.try-again",
        "defaultMessage": "Try again"
    }
});

});


parcelRegister("gRMjU", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc0d161154457fa6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $bc0d161154457fa6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    requiredField: {
        "id": "project-create-importer-upload-flow.select-third-party-entity-screen.entity-content.required-field",
        "defaultMessage": "Required fields are marked with an asterisk."
    },
    cancel: {
        "id": "project-create-importer-upload-flow.select-third-party-entity-screen.entity-content.cancel",
        "defaultMessage": "Cancel"
    }
});

});

parcelRegister("fzhBF", function(module, exports) {

$parcel$export(module.exports, "useEntities", () => $c3ee1a366bb1d27b$export$c884af28013ba602);

var $eUqFw = parcelRequire("eUqFw");

var $PdmhA = parcelRequire("PdmhA");

var $eI5EY = parcelRequire("eI5EY");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $cDLTA = parcelRequire("cDLTA");

var $d0wrd = parcelRequire("d0wrd");
var $irKna = parcelRequire("irKna");

var $bjfvq = parcelRequire("bjfvq");

var $6xa9a = parcelRequire("6xa9a");

var $fyQq5 = parcelRequire("fyQq5");

var $2WjEt = parcelRequire("2WjEt");
const $c3ee1a366bb1d27b$export$c884af28013ba602 = ({ thirdParty: thirdParty, shouldShowPlaceholderIcons: shouldShowPlaceholderIcons, hasSearchableEntities: hasSearchableEntities, requestAuthenticationToken: requestAuthenticationToken, hideWorkspaceSelector: hideWorkspaceSelector, parentEntityId: parentEntityId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { entitySelectorLabel: label, entitySelectorPlaceholder: placeholder, starredEntitiesLabel: starredOptionsLabel, otherEntitiesLabel: otherOptionsLabel, noEntitiesFoundHeader: noEntitiesFoundHeader, noEntitiesFoundDescription: noEntitiesFoundDescription, noEntitiesFoundWithFolderDescription: noEntitiesFoundWithFolderDescription, noEntitiesFoundWithSubfolderDescription: noEntitiesFoundWithSubfolderDescription, errorOccurredFetchingEntitiesHeader: errorOccurredHeader, searchEntitiesErrorOccurredDescription: searchErrorOccurredDescription, loadingMoreEntitiesErrorOccurredDescription: loadingMoreErrorOccurredDescription } = (0, $cDLTA.useContentForThirdParty)(thirdParty);
    const { fetchThirdPartyEntities: fetchThirdPartyEntities, hasErrorOccurred: hasErrorOccurred, isLoading: isLoading } = (0, $fyQq5.useThirdPartyEntities)({
        thirdParty: thirdParty,
        requestAuthenticationToken: requestAuthenticationToken
    });
    const [{ entities: entities, selectedEntities: selectedEntities, selectedEntityId: selectedEntityId, selectedEntityName: selectedEntityName, selectedWorkspaceId: selectedWorkspaceId, selectedSpaceId: selectedSpaceId, workspaces: workspaces, selectedFolderId: selectedFolderId, selectedSubfolderId: selectedSubfolderId }, { setThirdPartyState: setThirdPartyState, setThirdPartyStateWithPreselectedEntityId: setThirdPartyStateWithPreselectedEntityId }] = (0, $irKna.useThirdPartyState)();
    const [{ selectedFolderIds: selectedFolderIds }] = (0, $bjfvq.useThirdPartySubfolders)();
    const [, { setProjectData: setProjectData }] = (0, $d0wrd.useProjectData)();
    const { searchThirdPartyEntities: searchThirdPartyEntities, hasErrorOccurred: hasSearchEntitiesErrorOccurred, resetSearchError: resetSearchError } = (0, $6xa9a.useSearchThirdPartyEntities)({
        thirdParty: thirdParty,
        requestAuthenticationToken: requestAuthenticationToken
    });
    const { fetchThirdPartyEntitiesPage: fetchThirdPartyEntitiesPage, hasErrorOccurred: hasEntityPageErrorOccurred, isLoading: isEntitiesPageLoading, fetchNextPage: fetchNextPage } = (0, $2WjEt.useThirdPartyEntitiesPage)({
        thirdParty: thirdParty,
        requestAuthenticationToken: requestAuthenticationToken
    });
    const canFetchEntities = hideWorkspaceSelector || workspaces !== null && ((0, $eI5EY.fg)('jwm_clickup_importer') ? parentEntityId !== null : selectedWorkspaceId !== null);
    const onSearchEntities = (0, $eUqFw.useCallback)((query)=>{
        if (!canFetchEntities) return Promise.resolve([]);
        return searchThirdPartyEntities({
            workspaceId: selectedWorkspaceId || undefined,
            query: query
        });
    }, [
        canFetchEntities,
        searchThirdPartyEntities,
        selectedWorkspaceId
    ]);
    const fetchEntities = (0, $eUqFw.useCallback)(()=>{
        if (!canFetchEntities || entities !== null) return;
        if (hasSearchableEntities) fetchThirdPartyEntitiesPage({
            workspaceId: selectedWorkspaceId || undefined
        }).then((thirdPartyEntities)=>{
            setThirdPartyStateWithPreselectedEntityId({
                entities: thirdPartyEntities,
                preSelectedEntityId: selectedEntityId
            });
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'thirdPartyEntitiesPage retrieved', {
                thirdParty: thirdParty,
                numEntities: thirdPartyEntities?.length || 0
            });
        });
        else fetchThirdPartyEntities({
            workspaceId: selectedWorkspaceId || undefined,
            folderIds: selectedFolderIds || undefined,
            ...(0, $eI5EY.fg)('jwm_clickup_importer') ? {
                spaceId: selectedSpaceId || undefined
            } : {}
        }).then((thirdPartyEntities)=>{
            if (thirdPartyEntities !== null) {
                setThirdPartyStateWithPreselectedEntityId({
                    entities: thirdPartyEntities,
                    preSelectedEntityId: selectedEntityId
                });
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'thirdPartyEntities retrieved', {
                    thirdParty: thirdParty,
                    numEntities: thirdPartyEntities?.length || 0
                });
            }
        });
    }, [
        canFetchEntities,
        entities,
        hasSearchableEntities,
        fetchThirdPartyEntitiesPage,
        selectedWorkspaceId,
        setThirdPartyStateWithPreselectedEntityId,
        selectedEntityId,
        createAnalyticsEvent,
        thirdParty,
        selectedFolderIds,
        selectedSpaceId,
        fetchThirdPartyEntities
    ]);
    (0, $eUqFw.useEffect)(()=>{
        fetchEntities();
    }, [
        fetchEntities
    ]);
    // TODO: Remove this on cleanup of 'jira_importer_third_party_state_refactor' feature gate
    const onChangeOld = (0, $eUqFw.useCallback)((entityId, entityName, style)=>{
        setThirdPartyState({
            selectedEntityId: entityId,
            entityStats: null,
            selectedEntityName: entityName,
            selectedEntityStyle: style,
            members: null,
            thirdPartyFieldConfigState: null,
            thirdPartyStatusMapping: null
        });
        setProjectData({
            name: undefined,
            accessLevel: undefined
        });
    }, [
        setThirdPartyState,
        setProjectData
    ]);
    const onChange = (0, $eUqFw.useCallback)((selectedEntity)=>{
        setThirdPartyState({
            selectedEntityId: selectedEntity.id,
            entityStats: null,
            selectedEntityName: selectedEntity.name,
            selectedEntityStyle: selectedEntity.style,
            members: null,
            thirdPartyFieldConfigState: null,
            thirdPartyStatusMapping: null,
            selectedEntities: [
                selectedEntity
            ]
        });
        setProjectData({
            name: undefined,
            accessLevel: undefined
        });
    }, [
        setThirdPartyState,
        setProjectData
    ]);
    const onChangeMultipleEntities = (0, $eUqFw.useCallback)((updateEntities)=>{
        setThirdPartyState({
            selectedEntities: updateEntities,
            thirdPartyFieldConfigState: null,
            thirdPartyStatusMapping: null,
            entityStats: null
        });
        setProjectData({
            name: undefined,
            accessLevel: undefined
        });
    }, [
        setThirdPartyState,
        setProjectData
    ]);
    const onMenuScrollToBottom = (0, $eUqFw.useCallback)(()=>{
        if (!canFetchEntities || (hasSearchableEntities ? isEntitiesPageLoading : isLoading)) return;
        fetchNextPage(selectedWorkspaceId || undefined).then((thirdPartyEntities)=>{
            thirdPartyEntities && setThirdPartyState({
                entities: entities?.concat(thirdPartyEntities)
            });
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'thirdPartyEntitiesPage retrieved', {
                thirdParty: thirdParty,
                numEntities: thirdPartyEntities?.length || 0,
                loadNextPage: true
            });
        });
    }, [
        canFetchEntities,
        createAnalyticsEvent,
        entities,
        fetchNextPage,
        hasSearchableEntities,
        isEntitiesPageLoading,
        isLoading,
        selectedWorkspaceId,
        setThirdPartyState,
        thirdParty
    ]);
    const isLoadingEntities = hasSearchableEntities ? isEntitiesPageLoading : isLoading;
    let noEntitiesFound = noEntitiesFoundDescription;
    if (selectedSubfolderId !== null && noEntitiesFoundWithSubfolderDescription) noEntitiesFound = noEntitiesFoundWithSubfolderDescription;
    else if (selectedFolderId !== null && noEntitiesFoundWithFolderDescription) noEntitiesFound = noEntitiesFoundWithFolderDescription;
    return {
        label: label,
        placeholder: placeholder,
        starredOptionsLabel: starredOptionsLabel,
        otherOptionsLabel: otherOptionsLabel,
        noEntitiesFoundHeader: noEntitiesFoundHeader,
        noEntitiesFoundDescription: noEntitiesFound,
        errorOccurredHeader: errorOccurredHeader,
        entities: entities,
        selectedEntities: selectedEntities,
        selectedEntityId: selectedEntityId,
        selectedEntityName: selectedEntityName,
        isLoading: isLoadingEntities,
        hasErrorOccurred: hasSearchableEntities ? hasEntityPageErrorOccurred : hasErrorOccurred,
        onChangeOld: onChangeOld,
        onChange: onChange,
        onRetry: fetchEntities,
        isDisabled: !canFetchEntities,
        placeholderColor: shouldShowPlaceholderIcons ? (0, $PdmhA.Y200) : undefined,
        onSearchEntities: onSearchEntities,
        hasSearchErrorOccurred: hasSearchEntitiesErrorOccurred,
        searchErrorOccurredDescription: searchErrorOccurredDescription,
        loadingMoreErrorOccurredDescription: loadingMoreErrorOccurredDescription,
        onMenuScrollToBottom: onMenuScrollToBottom,
        onResetSearchError: resetSearchError,
        isEmptyEntities: !isLoadingEntities && entities?.length === 0,
        onChangeMultipleEntities: onChangeMultipleEntities
    };
};

});
parcelRegister("bjfvq", function(module, exports) {

$parcel$export(module.exports, "useThirdPartySubfolders", () => $62920a7552941b5d$export$f09f16f61713fc85);

var $ggKAj = parcelRequire("ggKAj");
var $bj4JM = parcelRequire("bj4JM");

var $8JicK = parcelRequire("8JicK");
const $62920a7552941b5d$export$ebdda0835047eae6 = (0, $bj4JM.createSelector)((state)=>state.thirdPartyState, (newState)=>{
    const { folders: folders, subfolders: subfolders, selectedFolderId: selectedFolderId, selectedSubfolderId: selectedSubfolderId } = newState;
    if (selectedFolderId === null || folders === null) return {
        selectedSubfolders: null,
        selectedFolderIds: null
    };
    const selectedSubfolders = subfolders?.[selectedFolderId] || [];
    if (selectedSubfolderId !== null) return {
        selectedSubfolders: selectedSubfolders,
        selectedFolderIds: [
            selectedSubfolderId
        ]
    };
    return {
        selectedSubfolders: selectedSubfolders,
        selectedFolderIds: [
            selectedFolderId
        ]
    };
});
const $62920a7552941b5d$export$f09f16f61713fc85 = (0, $ggKAj.createHook)((0, $8JicK.Store), {
    selector: $62920a7552941b5d$export$ebdda0835047eae6
});

});

parcelRegister("6xa9a", function(module, exports) {

$parcel$export(module.exports, "useSearchThirdPartyEntities", () => $b6ae98a662791d9c$export$579cdfa8f055f3ab);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $gyZoj = parcelRequire("gyZoj");
var $5GSA7 = parcelRequire("5GSA7");

var $kzTj7 = parcelRequire("kzTj7");

var $3yuWi = parcelRequire("3yuWi");

var $8OWUq = parcelRequire("8OWUq");
const $b6ae98a662791d9c$export$579cdfa8f055f3ab = ({ thirdParty: thirdParty, requestAuthenticationToken: requestAuthenticationToken })=>{
    const thirdPartyClient = (0, $8OWUq.useThirdPartyClient)({
        thirdParty: thirdParty,
        requestAuthenticationToken: requestAuthenticationToken
    });
    const [onExperienceStart, onExperienceSuccess, onExperienceFail] = (0, $5GSA7.useExperienceTracker)((0, $3yuWi.EXPERIENCES).SEARCH_THIRD_PARTY_ENTITIES);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [hasErrorOccurred, setHasErrorOccurred] = (0, $eUqFw.useState)(false);
    const searchThirdPartyEntities = (0, $eUqFw.useCallback)(async ({ workspaceId: workspaceId, query: query })=>{
        setIsLoading(true);
        setHasErrorOccurred(false);
        (0, $3yuWi.searchThirdPartyEntitiesInteractionMetric).start();
        onExperienceStart();
        try {
            const data = await thirdPartyClient.searchEntities({
                workspaceId: workspaceId,
                query: query
            });
            (0, $3yuWi.searchThirdPartyEntitiesInteractionMetric).stop();
            onExperienceSuccess();
            setIsLoading(false);
            return data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $3yuWi.searchThirdPartyEntitiesInteractionMetric).stop();
            onExperienceFail((0, $kzTj7.APP_IDENTIFIER), error, {
                thirdParty: thirdParty
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'search-third-party-entities',
                    packageName: (0, $kzTj7.APP_IDENTIFIER),
                    teamName: (0, $gyZoj.APP_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true,
                error: error
            });
            setHasErrorOccurred(true);
            setIsLoading(false);
            return null;
        }
    }, [
        onExperienceFail,
        onExperienceStart,
        onExperienceSuccess,
        thirdParty,
        thirdPartyClient
    ]);
    const resetSearchError = (0, $eUqFw.useCallback)(()=>setHasErrorOccurred(false), []);
    return {
        isLoading: isLoading,
        hasErrorOccurred: hasErrorOccurred,
        searchThirdPartyEntities: searchThirdPartyEntities,
        resetSearchError: resetSearchError
    };
};

});

parcelRegister("fyQq5", function(module, exports) {

$parcel$export(module.exports, "useThirdPartyEntities", () => $1c99a25be2884350$export$7c54b5434f00385c);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $gyZoj = parcelRequire("gyZoj");
var $5GSA7 = parcelRequire("5GSA7");

var $kzTj7 = parcelRequire("kzTj7");

var $3yuWi = parcelRequire("3yuWi");

var $8OWUq = parcelRequire("8OWUq");
const $1c99a25be2884350$export$7c54b5434f00385c = ({ thirdParty: thirdParty, requestAuthenticationToken: requestAuthenticationToken })=>{
    const thirdPartyClient = (0, $8OWUq.useThirdPartyClient)({
        thirdParty: thirdParty,
        requestAuthenticationToken: requestAuthenticationToken
    });
    const [onExperienceStart, onExperienceSuccess, onExperienceFail] = (0, $5GSA7.useExperienceTracker)((0, $3yuWi.EXPERIENCES).THIRD_PARTY_ENTITIES);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [hasErrorOccurred, setHasErrorOccurred] = (0, $eUqFw.useState)(false);
    const fetchThirdPartyEntities = (0, $eUqFw.useCallback)(async ({ workspaceId: workspaceId, folderIds: folderIds, spaceId: spaceId })=>{
        setIsLoading(true);
        setHasErrorOccurred(false);
        (0, $3yuWi.thirdPartyEntitiesInteractionMetric).start();
        onExperienceStart();
        try {
            const data = await thirdPartyClient.getEntities({
                workspaceId: workspaceId,
                folderIds: folderIds,
                spaceId: spaceId
            });
            (0, $3yuWi.thirdPartyEntitiesInteractionMetric).stop();
            onExperienceSuccess();
            setIsLoading(false);
            return data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $3yuWi.thirdPartyEntitiesInteractionMetric).stop();
            onExperienceFail((0, $kzTj7.APP_IDENTIFIER), error, {
                thirdParty: thirdParty
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'fetch-third-party-entities',
                    packageName: (0, $kzTj7.APP_IDENTIFIER),
                    teamName: (0, $gyZoj.APP_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true,
                error: error
            });
            setHasErrorOccurred(true);
            setIsLoading(false);
            return null;
        }
    }, [
        onExperienceFail,
        onExperienceStart,
        onExperienceSuccess,
        thirdPartyClient,
        thirdParty
    ]);
    return {
        isLoading: isLoading,
        hasErrorOccurred: hasErrorOccurred,
        fetchThirdPartyEntities: fetchThirdPartyEntities
    };
};

});

parcelRegister("2WjEt", function(module, exports) {

$parcel$export(module.exports, "useThirdPartyEntitiesPage", () => $35397eba1b9947fc$export$f744c9e52401ac21);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $gyZoj = parcelRequire("gyZoj");
var $5GSA7 = parcelRequire("5GSA7");

var $kzTj7 = parcelRequire("kzTj7");

var $3yuWi = parcelRequire("3yuWi");

var $8OWUq = parcelRequire("8OWUq");
const $35397eba1b9947fc$export$f744c9e52401ac21 = ({ thirdParty: thirdParty, requestAuthenticationToken: requestAuthenticationToken })=>{
    const thirdPartyClient = (0, $8OWUq.useThirdPartyClient)({
        thirdParty: thirdParty,
        requestAuthenticationToken: requestAuthenticationToken
    });
    const [onExperienceStart, onExperienceSuccess, onExperienceFail] = (0, $5GSA7.useExperienceTracker)((0, $3yuWi.EXPERIENCES).THIRD_PARTY_ENTITIES_PAGE);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [hasErrorOccurred, setHasErrorOccurred] = (0, $eUqFw.useState)(false);
    const currentOffset = (0, $eUqFw.useRef)(null);
    const fetchThirdPartyEntitiesPage = (0, $eUqFw.useCallback)(async ({ workspaceId: workspaceId, offset: offset = null })=>{
        setIsLoading(true);
        setHasErrorOccurred(false);
        (0, $3yuWi.thirdPartyEntitiesPageInteractionMetric).start();
        onExperienceStart();
        try {
            const page = await thirdPartyClient.getEntitiesPage({
                workspaceId: workspaceId,
                offset: offset
            });
            (0, $3yuWi.thirdPartyEntitiesPageInteractionMetric).stop();
            onExperienceSuccess();
            setIsLoading(false);
            currentOffset.current = page.offset;
            return page.entities;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $3yuWi.thirdPartyEntitiesPageInteractionMetric).stop();
            onExperienceFail((0, $kzTj7.APP_IDENTIFIER), error, {
                thirdParty: thirdParty
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'fetch-third-party-entities-page',
                    packageName: (0, $kzTj7.APP_IDENTIFIER),
                    teamName: (0, $gyZoj.APP_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true,
                error: error
            });
            setHasErrorOccurred(true);
            setIsLoading(false);
            return null;
        }
    }, [
        onExperienceFail,
        onExperienceStart,
        onExperienceSuccess,
        thirdParty,
        thirdPartyClient
    ]);
    const fetchNextPage = (0, $eUqFw.useCallback)((workspaceId)=>{
        if (!currentOffset.current) return Promise.resolve(null);
        return fetchThirdPartyEntitiesPage({
            workspaceId: workspaceId,
            offset: currentOffset.current
        });
    }, [
        fetchThirdPartyEntitiesPage
    ]);
    return {
        isLoading: isLoading,
        hasErrorOccurred: hasErrorOccurred,
        fetchThirdPartyEntitiesPage: fetchThirdPartyEntitiesPage,
        fetchNextPage: fetchNextPage
    };
};

});


parcelRegister("4Fz7S", function(module, exports) {

$parcel$export(module.exports, "useFolders", () => $d67160e0652febf4$export$f37978ebacf89223);

var $eUqFw = parcelRequire("eUqFw");

var $PdmhA = parcelRequire("PdmhA");

var $eI5EY = parcelRequire("eI5EY");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $cDLTA = parcelRequire("cDLTA");

var $irKna = parcelRequire("irKna");

var $5Bkyq = parcelRequire("5Bkyq");
const $d67160e0652febf4$export$f37978ebacf89223 = ({ thirdParty: thirdParty, shouldShowPlaceholderIcons: shouldShowPlaceholderIcons, requestAuthenticationToken: requestAuthenticationToken, shouldShowFolderSelector: shouldShowFolderSelector, parentEntityId: parentEntityId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { foldersSelectorLabel: label, foldersSelectorPlaceholder: placeholder, errorOccurredFetchingFoldersHeader: errorOccurredHeader } = (0, $cDLTA.useContentForThirdParty)(thirdParty);
    const { fetchThirdPartyFolders: fetchThirdPartyFolders, hasErrorOccurred: hasErrorOccurred, isLoading: isLoading } = (0, $5Bkyq.useThirdPartyFolders)({
        thirdParty: thirdParty,
        requestAuthenticationToken: requestAuthenticationToken
    });
    const [{ folders: folders, selectedWorkspaceId: selectedWorkspaceId, selectedFolderId: selectedFolderId }, { setThirdPartyState: setThirdPartyState }] = (0, $irKna.useThirdPartyState)();
    const onFetchFolders = (0, $eUqFw.useCallback)(()=>{
        if (selectedWorkspaceId === null || folders != null || parentEntityId === null && (0, $eI5EY.fg)('jwm_clickup_importer')) return;
        const entityId = parentEntityId !== null && (0, $eI5EY.fg)('jwm_clickup_importer') ? parentEntityId : selectedWorkspaceId;
        fetchThirdPartyFolders(entityId).then((data)=>{
            setThirdPartyState({
                folders: data?.folders,
                subfolders: data?.subfolders
            });
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'thirdPartyFolders retrieved', {
                thirdParty: thirdParty,
                numFolders: data?.folders?.length || 0
            });
        });
    }, [
        createAnalyticsEvent,
        fetchThirdPartyFolders,
        folders,
        parentEntityId,
        selectedWorkspaceId,
        setThirdPartyState,
        thirdParty
    ]);
    (0, $eUqFw.useEffect)(()=>{
        shouldShowFolderSelector && onFetchFolders();
    }, [
        onFetchFolders,
        shouldShowFolderSelector
    ]);
    // TODO: Remove this on cleanup of 'jira_importer_third_party_state_refactor' feature gate
    const onChangeOld = (0, $eUqFw.useCallback)((folderId)=>{
        setThirdPartyState({
            selectedFolderId: folderId,
            selectedSubfolderId: null,
            selectedEntities: null,
            selectedEntityId: null,
            selectedEntityName: null,
            selectedEntityStyle: null,
            entities: null,
            entityStats: null,
            members: null,
            thirdPartyFieldConfigState: null,
            thirdPartyStatusMapping: null
        });
    }, [
        setThirdPartyState
    ]);
    const onChange = (0, $eUqFw.useCallback)((selectedFolder)=>{
        setThirdPartyState({
            selectedFolderId: selectedFolder ? selectedFolder.id : null,
            selectedSubfolderId: null,
            selectedEntities: null,
            selectedEntityId: null,
            selectedEntityName: null,
            selectedEntityStyle: null,
            entities: null,
            entityStats: null,
            members: null,
            thirdPartyFieldConfigState: null,
            thirdPartyStatusMapping: null
        });
    }, [
        setThirdPartyState
    ]);
    const onClear = (0, $eUqFw.useCallback)(()=>(0, $eI5EY.fg)('jira_importer_third_party_state_refactor') ? onChange(null) : onChangeOld(null), [
        onChange,
        onChangeOld
    ]);
    return {
        label: label,
        placeholder: placeholder,
        starredOptionsLabel: '',
        otherOptionsLabel: '',
        noEntitiesFoundHeader: '',
        noEntitiesFoundDescription: '',
        errorOccurredHeader: errorOccurredHeader,
        entities: folders,
        selectedEntityId: selectedFolderId,
        isLoading: isLoading,
        isDisabled: selectedWorkspaceId === null,
        isClearable: true,
        hasErrorOccurred: hasErrorOccurred,
        onChangeOld: onChangeOld,
        onChange: onChange,
        onClear: onClear,
        onRetry: onFetchFolders,
        placeholderColor: shouldShowPlaceholderIcons ? (0, $PdmhA.Y200) : undefined,
        isEmptyEntities: !folders || !isLoading && folders.length === 0
    };
};

});
parcelRegister("5Bkyq", function(module, exports) {

$parcel$export(module.exports, "useThirdPartyFolders", () => $9abeb0e9fc525ec7$export$5c364c4cd22e2c69);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $gyZoj = parcelRequire("gyZoj");
var $5GSA7 = parcelRequire("5GSA7");

var $kzTj7 = parcelRequire("kzTj7");

var $3yuWi = parcelRequire("3yuWi");

var $8OWUq = parcelRequire("8OWUq");
const $9abeb0e9fc525ec7$export$5c364c4cd22e2c69 = ({ thirdParty: thirdParty, requestAuthenticationToken: requestAuthenticationToken })=>{
    const thirdPartyClient = (0, $8OWUq.useThirdPartyClient)({
        thirdParty: thirdParty,
        requestAuthenticationToken: requestAuthenticationToken
    });
    const [onExperienceStart, onExperienceSuccess, onExperienceFail] = (0, $5GSA7.useExperienceTracker)((0, $3yuWi.EXPERIENCES).THIRD_PARTY_FOLDERS);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [hasErrorOccurred, setHasErrorOccurred] = (0, $eUqFw.useState)(false);
    const fetchThirdPartyFolders = (0, $eUqFw.useCallback)(async (workspaceId)=>{
        setIsLoading(true);
        setHasErrorOccurred(false);
        (0, $3yuWi.thirdPartyFoldersInteractionMetric).start();
        onExperienceStart();
        try {
            const data = await thirdPartyClient.getFolders({
                entityId: workspaceId
            });
            (0, $3yuWi.thirdPartyFoldersInteractionMetric).stop();
            onExperienceSuccess();
            setIsLoading(false);
            return data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $3yuWi.thirdPartyFoldersInteractionMetric).stop();
            onExperienceFail((0, $kzTj7.APP_IDENTIFIER), error, {
                thirdParty: thirdParty
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'fetch-third-party-folders',
                    packageName: (0, $kzTj7.APP_IDENTIFIER),
                    teamName: (0, $gyZoj.APP_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true,
                error: error
            });
            setHasErrorOccurred(true);
            setIsLoading(false);
            return null;
        }
    }, [
        onExperienceFail,
        onExperienceStart,
        onExperienceSuccess,
        thirdPartyClient,
        thirdParty
    ]);
    return {
        isLoading: isLoading,
        hasErrorOccurred: hasErrorOccurred,
        fetchThirdPartyFolders: fetchThirdPartyFolders
    };
};

});


parcelRegister("hKh1G", function(module, exports) {

$parcel$export(module.exports, "useSpaces", () => $fade7405b64949b4$export$4a0158bb8391bcb);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $PdmhA = parcelRequire("PdmhA");

var $jMP2a = parcelRequire("jMP2a");

var $cDLTA = parcelRequire("cDLTA");

var $irKna = parcelRequire("irKna");

var $3XuQQ = parcelRequire("3XuQQ");
const $fade7405b64949b4$export$4a0158bb8391bcb = ({ thirdParty: thirdParty, shouldShowPlaceholderIcons: shouldShowPlaceholderIcons, requestAuthenticationToken: requestAuthenticationToken, shouldShowSpaceSelector: shouldShowSpaceSelector })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { spaceSelectorLabel: label, spaceSelectorPlaceholder: placeholder, errorOccurredFetchingSpacesHeader: errorOccurredHeader, noSpacesFoundHeader: noSpacesFoundHeader, noSpacesFoundDescription: noSpacesFoundDescription } = (0, $cDLTA.useContentForThirdParty)(thirdParty);
    const { fetchThirdPartySpaces: fetchThirdPartySpaces, hasErrorOccurred: hasErrorOccurred, isLoading: isLoading } = (0, $3XuQQ.useThirdPartySpaces)({
        thirdParty: thirdParty,
        requestAuthenticationToken: requestAuthenticationToken
    });
    const [{ spaces: spaces, selectedWorkspaceId: selectedWorkspaceId, selectedSpaceId: selectedSpaceId }, { setThirdPartyState: setThirdPartyState }] = (0, $irKna.useThirdPartyState)();
    const onFetchSpaces = (0, $eUqFw.useCallback)(()=>{
        if (selectedWorkspaceId === null || spaces != null) return;
        fetchThirdPartySpaces(selectedWorkspaceId).then((spaceEntities)=>{
            setThirdPartyState({
                spaces: spaceEntities
            });
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'thirdPartySpaces retrieved', {
                thirdParty: thirdParty,
                numSpaces: spaceEntities?.length || 0
            });
        });
    }, [
        createAnalyticsEvent,
        fetchThirdPartySpaces,
        spaces,
        selectedWorkspaceId,
        setThirdPartyState,
        thirdParty
    ]);
    (0, $eUqFw.useEffect)(()=>{
        shouldShowSpaceSelector && onFetchSpaces();
    }, [
        onFetchSpaces,
        shouldShowSpaceSelector
    ]);
    // TODO: Remove this on cleanup of 'jira_importer_third_party_state_refactor' feature gate
    const onChangeOld = (0, $eUqFw.useCallback)((spaceId, spaceName)=>{
        setThirdPartyState({
            selectedSpaceId: spaceId,
            selectedSpaceName: spaceName,
            selectedFolderId: null,
            selectedSubfolderId: null,
            selectedEntities: null,
            selectedEntityId: null,
            selectedEntityName: null,
            selectedEntityStyle: null,
            folders: null,
            subfolders: null,
            entities: null,
            entityStats: null,
            members: null,
            thirdPartyFieldConfigState: null,
            thirdPartyStatusMapping: null
        });
    }, [
        setThirdPartyState
    ]);
    const onChange = (0, $eUqFw.useCallback)((selectedSpace)=>{
        setThirdPartyState({
            selectedSpaceId: selectedSpace ? selectedSpace.id : null,
            selectedSpaceName: selectedSpace ? selectedSpace.name : null,
            selectedFolderId: null,
            selectedSubfolderId: null,
            selectedEntities: null,
            selectedEntityId: null,
            selectedEntityName: null,
            selectedEntityStyle: null,
            folders: null,
            subfolders: null,
            entities: null,
            entityStats: null,
            members: null,
            thirdPartyFieldConfigState: null,
            thirdPartyStatusMapping: null
        });
    }, [
        setThirdPartyState
    ]);
    return {
        label: label,
        placeholder: placeholder,
        starredOptionsLabel: '',
        otherOptionsLabel: '',
        noEntitiesFoundHeader: noSpacesFoundHeader,
        noEntitiesFoundDescription: noSpacesFoundDescription,
        errorOccurredHeader: errorOccurredHeader,
        entities: spaces,
        selectedEntityId: selectedSpaceId,
        isLoading: isLoading,
        isDisabled: selectedWorkspaceId === null,
        isClearable: false,
        hasErrorOccurred: hasErrorOccurred,
        onChangeOld: onChangeOld,
        onChange: onChange,
        onRetry: onFetchSpaces,
        placeholderColor: shouldShowPlaceholderIcons ? (0, $PdmhA.Y200) : undefined,
        isEmptyEntities: !spaces || spaces.length === 0,
        preselectOnlyOption: true
    };
};

});
parcelRegister("3XuQQ", function(module, exports) {

$parcel$export(module.exports, "useThirdPartySpaces", () => $f67e0a73ee8c2f82$export$b1c2475591dc8182);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $gyZoj = parcelRequire("gyZoj");
var $5GSA7 = parcelRequire("5GSA7");

var $kzTj7 = parcelRequire("kzTj7");

var $3yuWi = parcelRequire("3yuWi");

var $8OWUq = parcelRequire("8OWUq");
const $f67e0a73ee8c2f82$export$b1c2475591dc8182 = ({ thirdParty: thirdParty, requestAuthenticationToken: requestAuthenticationToken })=>{
    const thirdPartyClient = (0, $8OWUq.useThirdPartyClient)({
        thirdParty: thirdParty,
        requestAuthenticationToken: requestAuthenticationToken
    });
    const [onExperienceStart, onExperienceSuccess, onExperienceFail] = (0, $5GSA7.useExperienceTracker)((0, $3yuWi.EXPERIENCES).THIRD_PARTY_SPACES);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [hasErrorOccurred, setHasErrorOccurred] = (0, $eUqFw.useState)(false);
    const fetchThirdPartySpaces = (0, $eUqFw.useCallback)(async (workspaceId)=>{
        setIsLoading(true);
        setHasErrorOccurred(false);
        (0, $3yuWi.thirdPartySpacesInteractionMetric).start();
        onExperienceStart();
        try {
            const data = await thirdPartyClient.getSpaces({
                workspaceId: workspaceId
            });
            (0, $3yuWi.thirdPartySpacesInteractionMetric).stop();
            onExperienceSuccess();
            setIsLoading(false);
            return data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $3yuWi.thirdPartySpacesInteractionMetric).stop();
            onExperienceFail((0, $kzTj7.APP_IDENTIFIER), error, {
                thirdParty: thirdParty
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'fetch-third-party-spaces',
                    packageName: (0, $kzTj7.APP_IDENTIFIER),
                    teamName: (0, $gyZoj.APP_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true,
                error: error
            });
            setHasErrorOccurred(true);
            setIsLoading(false);
            return null;
        }
    }, [
        onExperienceFail,
        onExperienceStart,
        onExperienceSuccess,
        thirdPartyClient,
        thirdParty
    ]);
    return {
        isLoading: isLoading,
        hasErrorOccurred: hasErrorOccurred,
        fetchThirdPartySpaces: fetchThirdPartySpaces
    };
};

});


parcelRegister("fdRld", function(module, exports) {

$parcel$export(module.exports, "useSubfolders", () => $6e328aebf9782403$export$36d754df6b34b28c);

var $eUqFw = parcelRequire("eUqFw");

var $PdmhA = parcelRequire("PdmhA");

var $eI5EY = parcelRequire("eI5EY");

var $cDLTA = parcelRequire("cDLTA");

var $irKna = parcelRequire("irKna");
var $bjfvq = parcelRequire("bjfvq");
const $6e328aebf9782403$export$36d754df6b34b28c = ({ thirdParty: thirdParty, shouldShowPlaceholderIcons: shouldShowPlaceholderIcons })=>{
    const { subfoldersSelectorLabel: label, subfoldersSelectorPlaceholder: placeholder } = (0, $cDLTA.useContentForThirdParty)(thirdParty);
    const [{ selectedFolderId: selectedFolderId, selectedSubfolderId: selectedSubfolderId }] = (0, $irKna.useThirdPartyState)();
    const [{ selectedSubfolders: selectedSubfolders }, { setThirdPartyState: setThirdPartyState }] = (0, $bjfvq.useThirdPartySubfolders)();
    // TODO: Remove this on cleanup of 'jira_importer_third_party_state_refactor' feature gate
    const onChangeOld = (0, $eUqFw.useCallback)((subfolderId)=>{
        setThirdPartyState({
            selectedSubfolderId: subfolderId,
            selectedEntityId: null,
            selectedEntityName: null,
            selectedEntityStyle: null,
            selectedEntities: null,
            entities: null,
            entityStats: null,
            members: null,
            thirdPartyFieldConfigState: null,
            thirdPartyStatusMapping: null
        });
    }, [
        setThirdPartyState
    ]);
    const onChange = (0, $eUqFw.useCallback)((selectedSubfolder)=>{
        setThirdPartyState({
            selectedSubfolderId: selectedSubfolder ? selectedSubfolder.id : null,
            selectedEntityId: null,
            selectedEntityName: null,
            selectedEntityStyle: null,
            selectedEntities: null,
            entities: null,
            entityStats: null,
            members: null,
            thirdPartyFieldConfigState: null,
            thirdPartyStatusMapping: null
        });
    }, [
        setThirdPartyState
    ]);
    const onClear = (0, $eUqFw.useCallback)(()=>(0, $eI5EY.fg)('jira_importer_third_party_state_refactor') ? onChange(null) : onChangeOld(null), [
        onChange,
        onChangeOld
    ]);
    return {
        label: label,
        placeholder: placeholder,
        starredOptionsLabel: '',
        otherOptionsLabel: '',
        noEntitiesFoundHeader: '',
        noEntitiesFoundDescription: '',
        errorOccurredHeader: '',
        entities: selectedSubfolders,
        selectedEntityId: selectedSubfolderId,
        isLoading: false,
        isDisabled: selectedFolderId === null,
        isClearable: true,
        hasErrorOccurred: false,
        onChangeOld: onChangeOld,
        onChange: onChange,
        onClear: onClear,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onRetry: ()=>{},
        placeholderColor: shouldShowPlaceholderIcons ? (0, $PdmhA.Y200) : undefined,
        isEmptyEntities: !selectedSubfolders || selectedSubfolders.length === 0
    };
};

});

parcelRegister("fltaN", function(module, exports) {

$parcel$export(module.exports, "useWorkspaces", () => $a16ef6990ffb9c1a$export$6362e1bb6b14e070);

var $eUqFw = parcelRequire("eUqFw");

var $PdmhA = parcelRequire("PdmhA");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $cDLTA = parcelRequire("cDLTA");

var $irKna = parcelRequire("irKna");

var $7je32 = parcelRequire("7je32");
const $a16ef6990ffb9c1a$export$6362e1bb6b14e070 = ({ thirdParty: thirdParty, shouldShowPlaceholderIcons: shouldShowPlaceholderIcons, requestAuthenticationToken: requestAuthenticationToken, hideWorkspaceSelector: hideWorkspaceSelector })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { workspacesSelectorLabel: label, workspacesSelectorPlaceholder: placeholder, starredWorkspacesLabel: starredOptionsLabel, otherWorkspacesLabel: otherOptionsLabel, noWorkspacesFoundHeader: noEntitiesFoundHeader, noWorkspacesFoundDescription: noEntitiesFoundDescription, errorOccurredFetchingWorkspacesHeader: errorOccurredHeader } = (0, $cDLTA.useContentForThirdParty)(thirdParty);
    const { fetchThirdPartyWorkspaces: fetchThirdPartyWorkspaces, hasErrorOccurred: hasErrorOccurred, isLoading: isLoading } = (0, $7je32.useThirdPartyWorkspaces)({
        thirdParty: thirdParty,
        requestAuthenticationToken: requestAuthenticationToken
    });
    const [{ workspaces: entities, selectedWorkspaceId: selectedWorkspaceId }, { setThirdPartyState: setThirdPartyState, setThirdPartyStateWithPreselectedWorkspaceId: setThirdPartyStateWithPreselectedWorkspaceId }] = (0, $irKna.useThirdPartyState)();
    const onFetchWorkspaces = (0, $eUqFw.useCallback)(()=>{
        fetchThirdPartyWorkspaces().then((workspaceEntities)=>{
            setThirdPartyStateWithPreselectedWorkspaceId({
                workspaces: workspaceEntities,
                preSelectedWorkspaceId: selectedWorkspaceId
            });
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'thirdPartyWorkspaces retrieved', {
                thirdParty: thirdParty,
                numWorkspaces: workspaceEntities?.length || 0
            });
        });
    }, [
        createAnalyticsEvent,
        fetchThirdPartyWorkspaces,
        selectedWorkspaceId,
        setThirdPartyStateWithPreselectedWorkspaceId,
        thirdParty
    ]);
    (0, $eUqFw.useEffect)(()=>{
        !hideWorkspaceSelector && !entities && onFetchWorkspaces();
    }, [
        entities,
        onFetchWorkspaces,
        hideWorkspaceSelector
    ]);
    // TODO: Remove this on cleanup of 'jira_importer_third_party_state_refactor' feature gate
    const onChangeOld = (0, $eUqFw.useCallback)((workspaceId)=>{
        setThirdPartyState({
            selectedWorkspaceId: workspaceId,
            selectedSpaceId: null,
            selectedSpaceName: null,
            selectedFolderId: null,
            selectedSubfolderId: null,
            selectedEntities: null,
            selectedEntityId: null,
            selectedEntityName: null,
            selectedEntityStyle: null,
            spaces: null,
            folders: null,
            entities: null,
            entityStats: null,
            members: null,
            thirdPartyFieldConfigState: null,
            thirdPartyStatusMapping: null
        });
    }, [
        setThirdPartyState
    ]);
    const onChange = (0, $eUqFw.useCallback)((selectedWorkspace)=>{
        setThirdPartyState({
            selectedWorkspaceId: selectedWorkspace.id,
            selectedSpaceId: null,
            selectedSpaceName: null,
            selectedFolderId: null,
            selectedSubfolderId: null,
            selectedEntities: null,
            selectedEntityId: null,
            selectedEntityName: null,
            selectedEntityStyle: null,
            spaces: null,
            folders: null,
            entities: null,
            entityStats: null,
            members: null,
            thirdPartyFieldConfigState: null,
            thirdPartyStatusMapping: null
        });
    }, [
        setThirdPartyState
    ]);
    return {
        label: label,
        placeholder: placeholder,
        starredOptionsLabel: starredOptionsLabel,
        otherOptionsLabel: otherOptionsLabel,
        noEntitiesFoundHeader: noEntitiesFoundHeader,
        noEntitiesFoundDescription: noEntitiesFoundDescription,
        errorOccurredHeader: errorOccurredHeader,
        entities: entities,
        selectedEntityId: selectedWorkspaceId,
        isLoading: isLoading,
        hasErrorOccurred: hasErrorOccurred,
        onChangeOld: onChangeOld,
        onChange: onChange,
        onRetry: onFetchWorkspaces,
        autoFocus: !selectedWorkspaceId,
        openMenuOnFocus: true,
        placeholderColor: shouldShowPlaceholderIcons ? (0, $PdmhA.T200) : undefined,
        preselectOnlyOption: true
    };
};

});


parcelRegister("6nUK1", function(module, exports) {

$parcel$export(module.exports, "EntityStats", () => $06184743ac837c58$export$43a3b779da6bc63d);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $hTLlD = parcelRequire("hTLlD");

var $7u4fN = parcelRequire("7u4fN");

var $96IgR = parcelRequire("96IgR");

var $2bv8J = parcelRequire("2bv8J");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hzcvF = parcelRequire("hzcvF");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $fPb9U = parcelRequire("fPb9U");

var $3m6q0 = parcelRequire("3m6q0");

var $1pm5p = parcelRequire("1pm5p");

var $cDLTA = parcelRequire("cDLTA");

var $bz2yd = parcelRequire("bz2yd");

var $d0wrd = parcelRequire("d0wrd");
var $irKna = parcelRequire("irKna");

var $gfi0T = parcelRequire("gfi0T");

var $fGJIt = parcelRequire("fGJIt");

var $4Jz5J = parcelRequire("4Jz5J");

var $g3Tds = parcelRequire("g3Tds");
const $06184743ac837c58$export$43a3b779da6bc63d = ({ thirdParty: thirdParty, stats: stats, removeBackground: removeBackground, requestAuthenticationToken: requestAuthenticationToken, isMultipleEntitiesSupported: isMultipleEntitiesSupported })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { statsHeading: statsHeading, cardStats: cardStats, memberStats: memberStats, cardStatsInfo: cardStatsInfo } = (0, $cDLTA.useContentForThirdParty)(thirdParty);
    const [{ type: type }] = (0, $d0wrd.useProjectData)();
    const { entityStatsUserMessage: entityStatsUserMessage } = (0, $bz2yd.useProjectSpecificContent)(type);
    const { fetchThirdPartyEntityStats: fetchThirdPartyEntityStats, hasErrorOccurred: hasEntityStatsErrorOccurred, isLoading: isEntityStatsLoading } = (0, $gfi0T.useThirdPartyEntityStats)({
        thirdParty: thirdParty,
        requestAuthenticationToken: requestAuthenticationToken
    });
    const { fetchThirdPartyMultiEntityStats: fetchThirdPartyMultiEntityStats, hasErrorOccurred: hasMultiEntityStatsErrorOccurred, isLoading: isMultiEntityStatsLoading } = (0, $fGJIt.useThirdPartyMultiEntityStats)({
        thirdParty: thirdParty,
        requestAuthenticationToken: requestAuthenticationToken
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [{ selectedEntityId: selectedEntityId, selectedEntityName: selectedEntityName, entityStats: entityStats, selectedEntities: selectedEntities }, { setThirdPartyState: setThirdPartyState }] = (0, $irKna.useThirdPartyState)();
    const prevSelectedEntities = (0, $hzcvF.usePrevious)(selectedEntities);
    const fetchMultiEntityStats = (0, $eUqFw.useCallback)(()=>{
        const entityIds = selectedEntities?.map((entity)=>entity.id) ?? [];
        if (entityIds.length === 0 || (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(selectedEntities, prevSelectedEntities)) return;
        fetchThirdPartyMultiEntityStats(entityIds).then((statistics)=>{
            setThirdPartyState({
                entityStats: statistics
            });
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'thirdPartyMultiEntityStats retrieved', {
                thirdParty: thirdParty,
                members: statistics?.members || 0,
                tasks: ((0, $eI5EY.fg)('jwm_clickup_importer') ? statistics?.tasksCount : statistics?.tasks) || 0
            });
        });
    }, [
        createAnalyticsEvent,
        fetchThirdPartyMultiEntityStats,
        prevSelectedEntities,
        selectedEntities,
        setThirdPartyState,
        thirdParty
    ]);
    const fetchStats = (0, $eUqFw.useCallback)(()=>{
        if (isMultipleEntitiesSupported) fetchMultiEntityStats();
        else {
            if (selectedEntityId === null || selectedEntityName === null || entityStats !== null) return;
            fetchThirdPartyEntityStats(selectedEntityId).then((statistics)=>{
                setThirdPartyState({
                    entityStats: statistics
                });
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'thirdPartyEntityStats retrieved', {
                    thirdParty: thirdParty,
                    members: statistics?.members || 0,
                    tasks: ((0, $eI5EY.fg)('jwm_clickup_importer') ? statistics?.tasksCount : statistics?.tasks) || 0
                });
            });
        }
    // ommit isMultipleEntitiesSupported which cause multiple fetches
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        createAnalyticsEvent,
        entityStats,
        fetchThirdPartyEntityStats,
        selectedEntityId,
        selectedEntityName,
        selectedEntities,
        setThirdPartyState,
        thirdParty
    ]);
    const onRetryFetchEntityStats = (0, $eUqFw.useCallback)(()=>{
        fetchStats();
    }, [
        fetchStats
    ]);
    (0, $eUqFw.useEffect)(()=>{
        fetchStats();
    }, [
        fetchStats
    ]);
    const { members: members, tasks: tasks, tasksCount: tasksCount } = entityStats || {};
    const numOfTasks = (0, $eI5EY.fg)('jwm_clickup_importer') ? tasksCount : tasks;
    const statsMap = (0, $eUqFw.useMemo)(()=>({
            [(0, $1pm5p.StatisticsType).TASKS]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Jz5J.Card), {
                key: (0, $1pm5p.StatisticsType).TASKS,
                cardContent: cardStats,
                statistic: numOfTasks,
                showLoadingState: isEntityStatsLoading || isMultipleEntitiesSupported && isMultiEntityStatsLoading,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($06184743ac837c58$var$IconWrapper, {
                    backgroundColor: `var(--ds-background-accent-blue-subtler, ${(0, $PdmhA).B50})`
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($06184743ac837c58$var$Icon, {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($fPb9U))),
                    "aria-label": "cards",
                    role: "img",
                    alt: "",
                    "data-testid": "project-create-importer-upload-flow.ui.select-third-party-entity-screen.entity-stats.cards-icon"
                }))
            }),
            [(0, $1pm5p.StatisticsType).MEMBERS]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Jz5J.Card), {
                key: (0, $1pm5p.StatisticsType).MEMBERS,
                cardContent: memberStats,
                statistic: members,
                showLoadingState: isEntityStatsLoading || isMultipleEntitiesSupported && isMultiEntityStatsLoading,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($06184743ac837c58$var$IconWrapper, {
                    backgroundColor: `var(--ds-background-accent-gray-subtlest, ${(0, $PdmhA).N20})`
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($06184743ac837c58$var$Icon, {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($3m6q0))),
                    "aria-label": "members",
                    role: "img",
                    alt: "",
                    "data-testid": "project-create-importer-upload-flow.ui.select-third-party-entity-screen.entity-stats.members-icon"
                }))
            })
        }), [
        cardStats,
        numOfTasks,
        isEntityStatsLoading,
        isMultipleEntitiesSupported,
        isMultiEntityStatsLoading,
        memberStats,
        members
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($06184743ac837c58$var$Wrapper, {
        "data-testid": "project-create-importer-upload-flow.ui.select-third-party-entity-screen.entity-stats.wrapper",
        removeBackground: removeBackground
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($06184743ac837c58$var$Header, null, statsHeading), (hasEntityStatsErrorOccurred || isMultipleEntitiesSupported && hasMultiEntityStatsErrorOccurred) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($06184743ac837c58$var$ErrorMessageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        label: "",
        primaryColor: `var(--ds-icon-danger, ${(0, $PdmhA).R400})`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($06184743ac837c58$var$ErrorMessage, null, formatMessage((0, $g3Tds.default).errorOccurredWithLink, {
        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                onClick: onRetryFetchEntityStats,
                appearance: "link",
                spacing: "none"
            }, chunks)
    }))), stats.map((stat)=>statsMap[stat])), stats.includes((0, $1pm5p.StatisticsType).MEMBERS) && members && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($06184743ac837c58$var$UserMessageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2bv8J))), {
        label: "",
        primaryColor: `var(--ds-icon-subtle, ${(0, $PdmhA).N300})`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($06184743ac837c58$var$UserMessageDescription, null, formatMessage(entityStatsUserMessage))), cardStatsInfo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2bv8J))), {
        label: "",
        primaryColor: `var(--ds-icon-subtle, ${(0, $PdmhA).N300})`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $06184743ac837c58$var$messageStyles
    }, formatMessage(cardStatsInfo))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $06184743ac837c58$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { removeBackground: removeBackground, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _2rko7vkz _vchhusvi",
            __cmplp.removeBackground ? "_bfhk18uv" : "_bfhkzxtc",
            __cmplp.removeBackground ? "_1yt4gx6n" : "_1yt41ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $06184743ac837c58$var$Header = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48pni7l _1wybdlk8 _vwz47vkz _syaz1wmz",
            __cmplp.className
        ])
    });
});
const $06184743ac837c58$var$IconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1hphqkz": (0, $9t7rW.default)(__cmplp.backgroundColor)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1obz _1ul91obz _4t3i1obz _bfhk3qkl",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $06184743ac837c58$var$Icon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1w8u _4t3i8vuz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $06184743ac837c58$var$ErrorMessageWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _p12f1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $06184743ac837c58$var$ErrorMessage = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1i4q1hna _1bsb1vuk",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $06184743ac837c58$var$UserMessageWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1yt4utpp _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $06184743ac837c58$var$UserMessageDescription = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc _syaz1n3s _1wyb1crf",
            __cmplp.className
        ])
    });
});
const $06184743ac837c58$var$messageStyles = (0, $1ZAYh.xcss)({
    fontSize: '12px'
});

});
parcelRegister("hzcvF", function(module, exports) {

$parcel$export(module.exports, "usePrevious", () => $42dfce76254176f5$export$5cae361ad82dce8b);
$parcel$export(module.exports, "usePreviousWithInitial", () => $42dfce76254176f5$export$23fbbb2e62c4a911);

var $eUqFw = parcelRequire("eUqFw");
const $42dfce76254176f5$export$5cae361ad82dce8b = (value)=>{
    const ref = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $42dfce76254176f5$export$23fbbb2e62c4a911 = (value)=>{
    const ref = (0, $eUqFw.useRef)(value);
    (0, $eUqFw.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};

});

parcelRegister("3m6q0", function(module, exports) {
module.exports = new URL("Members.e2794962.svg", import.meta.url).toString();

});

parcelRegister("gfi0T", function(module, exports) {

$parcel$export(module.exports, "useThirdPartyEntityStats", () => $202542032df6de88$export$abe4b68def07dcfd);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $gyZoj = parcelRequire("gyZoj");
var $5GSA7 = parcelRequire("5GSA7");

var $kzTj7 = parcelRequire("kzTj7");

var $3yuWi = parcelRequire("3yuWi");

var $8OWUq = parcelRequire("8OWUq");
const $202542032df6de88$export$abe4b68def07dcfd = ({ thirdParty: thirdParty, requestAuthenticationToken: requestAuthenticationToken })=>{
    const thirdPartyClient = (0, $8OWUq.useThirdPartyClient)({
        thirdParty: thirdParty,
        requestAuthenticationToken: requestAuthenticationToken
    });
    const [onExperienceStart, onExperienceSuccess, onExperienceFail] = (0, $5GSA7.useExperienceTracker)((0, $3yuWi.EXPERIENCES).THIRD_PARTY_ENTITY_STATS);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [hasErrorOccurred, setHasErrorOccurred] = (0, $eUqFw.useState)(false);
    const fetchThirdPartyEntityStats = (0, $eUqFw.useCallback)(async (entityId)=>{
        setIsLoading(true);
        setHasErrorOccurred(false);
        (0, $3yuWi.thirdPartyEntityStatsInteractionMetric).start();
        onExperienceStart();
        try {
            const data = await thirdPartyClient.getEntityStats({
                entityId: entityId
            });
            (0, $3yuWi.thirdPartyEntityStatsInteractionMetric).stop();
            onExperienceSuccess();
            setIsLoading(false);
            return data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $3yuWi.thirdPartyEntityStatsInteractionMetric).stop();
            onExperienceFail((0, $kzTj7.APP_IDENTIFIER), error, {
                thirdParty: thirdParty
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'fetch-third-party-entities',
                    packageName: (0, $kzTj7.APP_IDENTIFIER),
                    teamName: (0, $gyZoj.APP_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true,
                error: error
            });
            setHasErrorOccurred(true);
            setIsLoading(false);
            return null;
        }
    }, [
        onExperienceFail,
        onExperienceStart,
        onExperienceSuccess,
        thirdPartyClient,
        thirdParty
    ]);
    return {
        isLoading: isLoading,
        hasErrorOccurred: hasErrorOccurred,
        fetchThirdPartyEntityStats: fetchThirdPartyEntityStats
    };
};

});

parcelRegister("fGJIt", function(module, exports) {

$parcel$export(module.exports, "useThirdPartyMultiEntityStats", () => $78bc71e2b371e9f3$export$3b8005dba0de27e4);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $gyZoj = parcelRequire("gyZoj");
var $5GSA7 = parcelRequire("5GSA7");

var $kzTj7 = parcelRequire("kzTj7");

var $3yuWi = parcelRequire("3yuWi");

var $8OWUq = parcelRequire("8OWUq");
const $78bc71e2b371e9f3$export$3b8005dba0de27e4 = ({ thirdParty: thirdParty, requestAuthenticationToken: requestAuthenticationToken })=>{
    const thirdPartyClient = (0, $8OWUq.useThirdPartyClient)({
        thirdParty: thirdParty,
        requestAuthenticationToken: requestAuthenticationToken
    });
    const [onExperienceStart, onExperienceSuccess, onExperienceFail] = (0, $5GSA7.useExperienceTracker)((0, $3yuWi.EXPERIENCES).THIRD_PARTY_MULTI_ENTITY_STATS);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [hasErrorOccurred, setHasErrorOccurred] = (0, $eUqFw.useState)(false);
    const fetchThirdPartyMultiEntityStats = (0, $eUqFw.useCallback)(async (entityIds)=>{
        setIsLoading(true);
        setHasErrorOccurred(false);
        (0, $3yuWi.thirdPartyMultiEntityStatsInteractionMetric).start();
        onExperienceStart();
        try {
            const data = await thirdPartyClient.getMultiEntityStats({
                entityIds: entityIds
            });
            (0, $3yuWi.thirdPartyMultiEntityStatsInteractionMetric).stop();
            onExperienceSuccess();
            setIsLoading(false);
            return data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $3yuWi.thirdPartyMultiEntityStatsInteractionMetric).stop();
            onExperienceFail((0, $kzTj7.APP_IDENTIFIER), error, {
                thirdParty: thirdParty
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'fetch-third-party-multi-entity-stats',
                    packageName: (0, $kzTj7.APP_IDENTIFIER),
                    teamName: (0, $gyZoj.APP_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true,
                error: error
            });
            setHasErrorOccurred(true);
            setIsLoading(false);
            return null;
        }
    }, [
        onExperienceFail,
        onExperienceStart,
        onExperienceSuccess,
        thirdPartyClient,
        thirdParty
    ]);
    return {
        isLoading: isLoading,
        hasErrorOccurred: hasErrorOccurred,
        fetchThirdPartyMultiEntityStats: fetchThirdPartyMultiEntityStats
    };
};

});

parcelRegister("4Jz5J", function(module, exports) {

$parcel$export(module.exports, "Card", () => $d70f438db067094a$export$60332b2344f7fe41);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $ldoFd = parcelRequire("ldoFd");

var $5JgJ2 = parcelRequire("5JgJ2");
const $d70f438db067094a$export$60332b2344f7fe41 = ({ icon: icon, statistic: statistic, cardContent: cardContent, showLoadingState: showLoadingState })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d70f438db067094a$var$Wrapper, null, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d70f438db067094a$var$ContentWrapper, null, formatMessage(cardContent, {
        statistic: (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(statistic) ? '-' : statistic,
        description: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d70f438db067094a$var$Description, null, chunks),
        header: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d70f438db067094a$var$Header, null, chunks),
        stats: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d70f438db067094a$var$StatisticWrapper, null, showLoadingState ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d70f438db067094a$var$StatisticPlaceholder, {
                "data-testId": "project-create-importer-upload-flow.ui.select-third-party-entity-screen.entity-stats.card.statistic-placeholder"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, chunks))
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d70f438db067094a$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rkoftgi _1bsb1kdj _4t3i1obz _1reo15vq _18m915vq _1e0c1txw _2lx2vrvc _1n261q9c _4cvr1h6o _16qs13qd _bfhkvuon _vchhusvi _19pkutpp",
            __cmplp.className
        ])
    });
});
const $d70f438db067094a$var$Header = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _k48pni7l _1wyb1crf _vwz47vkz _syaz1a45 _19pk1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d70f438db067094a$var$Description = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _k48p1nn1 _1wyb1skh _vwz4dlk8 _syaz1a45 _o5721g80 _19pk1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d70f438db067094a$var$ContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _1yt4pxbi _vchhusvi _p12fo812 _1reo15vq _1bto1l2s _1bsb1osq _o5721q9c _4t3i1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d70f438db067094a$var$StatisticWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48pbfng _1wyb1tcg _vwz41f4h",
            __cmplp.className
        ])
    });
});
const $d70f438db067094a$var$shimmer = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d70f438db067094a$var$StatisticPlaceholder = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _4t3iu2gc _18s85uws _1bsboahv _2rkoftgi _5sagymdr _1o51q7pw _tip812c5 _j7hq2051 _1pglp3kn _bfhkqrzy _1itk17lr",
            __cmplp.className
        ])
    });
});

});

parcelRegister("g3Tds", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff52884c4cabb854$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ff52884c4cabb854$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorOccurredWithLink: {
        "id": "project-create-importer-upload-flow.select-third-party-entity-screen.entity-stats.error-occurred-with-link",
        "defaultMessage": "We couldn't load the data. <link>Try again</link>"
    }
});

});


parcelRegister("9RqsR", function(module, exports) {

$parcel$export(module.exports, "default", () => $e808c26763b42473$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e808c26763b42473$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    back: {
        "id": "project-create-importer-upload-flow.select-third-party-entity-screen.back",
        "defaultMessage": "Back"
    }
});

});

parcelRegister("iD0US", function(module, exports) {

$parcel$export(module.exports, "ThirdPartyIllustration", () => $35b39e2292130de1$export$e701fd1c28cc4001);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $eI5EY = parcelRequire("eI5EY");

var $gVkYZ = parcelRequire("gVkYZ");

var $1RFg2 = parcelRequire("1RFg2");

var $hEabk = parcelRequire("hEabk");

var $eKe4H = parcelRequire("eKe4H");

var $fI41g = parcelRequire("fI41g");

var $iQqxY = parcelRequire("iQqxY");

var $i9I6H = parcelRequire("i9I6H");

var $7Wxby = parcelRequire("7Wxby");

var $3N7Wf = parcelRequire("3N7Wf");

var $jkjEO = parcelRequire("jkjEO");

var $cnVVE = parcelRequire("cnVVE");

var $3ak5x = parcelRequire("3ak5x");

var $9R4E5 = parcelRequire("9R4E5");
const $35b39e2292130de1$export$e701fd1c28cc4001 = ({ thirdParty: thirdParty, projectType: projectType })=>{
    const illustration = (0, $eUqFw.useMemo)(()=>{
        if (projectType === (0, $9R4E5.ProjectTypes).BUSINESS) switch(thirdParty){
            case 0, $3ak5x.MONDAY:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35b39e2292130de1$var$Illustration, {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($i9I6H))),
                    alt: "",
                    "data-testid": "project-create-importer-upload-flow.ui.select-third-party-entity-screen.third-party-illustration.monday"
                });
            case 0, $3ak5x.ASANA:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35b39e2292130de1$var$Illustration, {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($gVkYZ))),
                    alt: "",
                    "data-testid": "project-create-importer-upload-flow.ui.select-third-party-entity-screen.third-party-illustration.asana"
                });
            case 0, $3ak5x.TRELLO:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35b39e2292130de1$var$Illustration, {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($3N7Wf))),
                    alt: "",
                    "data-testid": "project-create-importer-upload-flow.ui.select-third-party-entity-screen.third-party-illustration.trello"
                });
            case 0, $3ak5x.JIRA_SOFTWARE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35b39e2292130de1$var$Illustration, {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($iQqxY))),
                    alt: "",
                    "data-testid": "project-create-importer-upload-flow.ui.select-third-party-entity-screen.third-party-illustration.jira"
                });
            case 0, $3ak5x.CLICK_UP:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35b39e2292130de1$var$Illustration, {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($hEabk))),
                    alt: "",
                    "data-testid": "project-create-importer-upload-flow.ui.select-third-party-entity-screen.third-party-illustration.clickup"
                });
            default:
                return null;
        }
        else if (projectType === (0, $9R4E5.ProjectTypes).SOFTWARE) switch(thirdParty){
            case 0, $3ak5x.TRELLO:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35b39e2292130de1$var$Illustration, {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($cnVVE))),
                    alt: "",
                    "data-testid": "project-create-importer-upload-flow.ui.select-third-party-entity-screen.third-party-illustration.trello-jsw"
                });
            case 0, $3ak5x.ASANA:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35b39e2292130de1$var$Illustration, {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($1RFg2))),
                    alt: "",
                    "data-testid": "project-create-importer-upload-flow.ui.select-third-party-entity-screen.third-party-illustration.asana-jsw"
                });
            case 0, $3ak5x.JIRA_BUSINESS:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35b39e2292130de1$var$Illustration, {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($fI41g))),
                    alt: "",
                    "data-testid": "project-create-importer-upload-flow.ui.select-third-party-entity-screen.third-party-illustration.jira-business"
                });
            default:
                return null;
        }
        else return null;
    }, [
        projectType,
        thirdParty
    ]);
    const illustrationNew = (0, $eUqFw.useMemo)(()=>{
        switch(thirdParty){
            case 0, $3ak5x.MONDAY:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35b39e2292130de1$var$Illustration, {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($7Wxby))),
                    alt: "",
                    "data-testid": "project-create-importer-upload-flow.ui.select-third-party-entity-screen.third-party-illustration.monday"
                });
            case 0, $3ak5x.ASANA:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35b39e2292130de1$var$Illustration, {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($1RFg2))),
                    alt: "",
                    "data-testid": "project-create-importer-upload-flow.ui.select-third-party-entity-screen.third-party-illustration.asana"
                });
            case 0, $3ak5x.TRELLO:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35b39e2292130de1$var$Illustration, {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($jkjEO))),
                    alt: "",
                    "data-testid": "project-create-importer-upload-flow.ui.select-third-party-entity-screen.third-party-illustration.trello"
                });
            case 0, $3ak5x.JIRA_SOFTWARE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35b39e2292130de1$var$Illustration, {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($iQqxY))),
                    alt: "",
                    "data-testid": "project-create-importer-upload-flow.ui.select-third-party-entity-screen.third-party-illustration.jira"
                });
            case 0, $3ak5x.CLICK_UP:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35b39e2292130de1$var$Illustration, {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($eKe4H))),
                    alt: "",
                    "data-testid": "project-create-importer-upload-flow.ui.select-third-party-entity-screen.third-party-illustration.clickup"
                });
            case 0, $3ak5x.JIRA_BUSINESS:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35b39e2292130de1$var$Illustration, {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($fI41g))),
                    alt: "",
                    "data-testid": "project-create-importer-upload-flow.ui.select-third-party-entity-screen.third-party-illustration.jira-business"
                });
            default:
                return null;
        }
    }, [
        thirdParty
    ]);
    if ((0, $eI5EY.fg)('enable-x2c-standardised-flow')) return illustrationNew;
    return illustration;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $35b39e2292130de1$var$Illustration = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1kdj _19pk1epz",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gVkYZ", function(module, exports) {
module.exports = new URL("AsanaSelectBoardIllustrationSpork.2bbab650.svg", import.meta.url).toString();

});

parcelRegister("1RFg2", function(module, exports) {
module.exports = new URL("AsanaSelectBoardJiraIllustration.c6617f90.svg", import.meta.url).toString();

});

parcelRegister("hEabk", function(module, exports) {
module.exports = new URL("ClickupSelectListIllustrationSpork.4e69219d.svg", import.meta.url).toString();

});

parcelRegister("eKe4H", function(module, exports) {
module.exports = new URL("ClickupSelectListIllustrationStandard.8fc05847.svg", import.meta.url).toString();

});

parcelRegister("fI41g", function(module, exports) {
module.exports = new URL("JiraBusinessSelectProjectIllustration.26774f85.svg", import.meta.url).toString();

});

parcelRegister("iQqxY", function(module, exports) {
module.exports = new URL("JiraSelectBoardIllustrationSpork.e3235199.svg", import.meta.url).toString();

});

parcelRegister("i9I6H", function(module, exports) {
module.exports = new URL("MondaySelectBoardIllustrationSpork.1ee5dca4.svg", import.meta.url).toString();

});

parcelRegister("7Wxby", function(module, exports) {
module.exports = new URL("MondaySelectBoardIllustrationStandard.26885b16.svg", import.meta.url).toString();

});

parcelRegister("3N7Wf", function(module, exports) {
module.exports = new URL("TrelloSelectBoardIllustrationSpork.07ab7f27.svg", import.meta.url).toString();

});

parcelRegister("jkjEO", function(module, exports) {
module.exports = new URL("TrelloSelectBoardIllustrationStandard.963953c7.svg", import.meta.url).toString();

});

parcelRegister("cnVVE", function(module, exports) {
module.exports = new URL("TrelloSelectBoardJswIllustartion.3e37bc88.svg", import.meta.url).toString();

});



parcelRegister("1jsZA", function(module, exports) {

$parcel$export(module.exports, "ThirdPartyReviewScreen", () => $ddd4c6bfc8442593$export$24fe2d136fd50d9c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $gpZWO = parcelRequire("gpZWO");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4kMup = parcelRequire("4kMup");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $kzTj7 = parcelRequire("kzTj7");

var $3yuWi = parcelRequire("3yuWi");

var $1pm5p = parcelRequire("1pm5p");

var $1VyqP = parcelRequire("1VyqP");

var $3EVB9 = parcelRequire("3EVB9");

var $elKPF = parcelRequire("elKPF");

var $1T7vu = parcelRequire("1T7vu");

var $cDLTA = parcelRequire("cDLTA");
var $aWLVm = parcelRequire("aWLVm");

var $9QyvU = parcelRequire("9QyvU");

var $d0wrd = parcelRequire("d0wrd");
var $irKna = parcelRequire("irKna");

var $1dxi7 = parcelRequire("1dxi7");

var $asXeB = parcelRequire("asXeB");
var $irjtd = parcelRequire("irjtd");

var $fiH3o = parcelRequire("fiH3o");

var $kkYIq = parcelRequire("kkYIq");

var $bdRTp = parcelRequire("bdRTp");

var $8ScnX = parcelRequire("8ScnX");

var $7MbnE = parcelRequire("7MbnE");

var $iUOit = parcelRequire("iUOit");

var $fDl1F = parcelRequire("fDl1F");

var $dHmCU = parcelRequire("dHmCU");
const $ddd4c6bfc8442593$export$24fe2d136fd50d9c = ({ thirdParty: thirdParty, onNext: onNext, onReturn: onReturn, onCloseAndReturnToUploadStep: onCloseAndReturnToUploadStep, tiles: tiles, isMultipleEntitiesSupported: isMultipleEntitiesSupported = false })=>{
    const { productSteps: productSteps, currentStepIndex: currentStepIndex } = (0, $fiH3o.useProductSteps)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { startImport: startImport, isImportLoading: isImportLoading, isStartImportDisabled: isStartImportDisabled, hasImportErrorOccurred: hasImportErrorOccurred } = (0, $1dxi7.useStartImportController)({
        thirdParty: thirdParty,
        isMultipleEntitiesSupported: isMultipleEntitiesSupported
    });
    const [projectData] = (0, $d0wrd.useProjectData)();
    const [selectedTile, setSelectedTile] = (0, $eUqFw.useState)(undefined);
    const [{ selectedEntityId: selectedEntityId, selectedEntityName: selectedEntityName, selectedEntities: selectedEntities, thirdPartyImportSettings: thirdPartyImportSettings, thirdPartyFieldConfigState: thirdPartyFieldConfigState, thirdPartyStatusMapping: thirdPartyStatusMapping }, { setThirdPartyState: setThirdPartyState, setThirdPartyImportSettings: setThirdPartyImportSettings }] = (0, $irKna.useThirdPartyState)();
    const [, { setRequestAuthenticationToken: setRequestAuthenticationToken }] = (0, $asXeB.useAccessTokenModalState)();
    const { fetchThirdPartyFieldConfig: fetchThirdPartyFieldConfig, isLoading: isLoading, hasErrorOccurred: hasErrorOccurred } = (0, $kkYIq.useThirdPartyFieldConfig)({
        thirdParty: thirdParty,
        requestAuthenticationToken: setRequestAuthenticationToken
    });
    const { fetchThirdPartyMultiEntityStatuses: fetchThirdPartyMultiEntityStatuses, isLoading: isStatusMappingLoading, hasErrorOccurred: statusMappingError } = (0, $bdRTp.useThirdPartyMultiEntityStatuses)({
        thirdParty: thirdParty,
        requestAuthenticationToken: setRequestAuthenticationToken
    });
    const { onShowFlag: onShowFlag, onDismissFlag: onDismissFlag } = (0, $9QyvU.useX2CFlag)();
    const [{ hasUnsavedFieldMappingChanges: hasUnsavedFieldMappingChanges, hasUnsavedHierarchyMappingChanges: hasUnsavedHierarchyMappingChanges, hasUnsavedStatusMappingChanges: hasUnsavedStatusMappingChanges }, { setUIState: setUIState }] = (0, $irjtd.useUIState)();
    const { reviewScreenDescription: reviewScreenDescription } = (0, $cDLTA.useContentForThirdParty)(thirdParty);
    const { reviewScreenDescriptionURL: reviewScreenDescriptionURL } = (0, $aWLVm.useUrlForThirdParty)(thirdParty, projectData.type);
    const onFetchThirdPartyStatusMapping = (0, $eUqFw.useCallback)(()=>{
        selectedEntities && selectedEntities.length > 0 && tiles.includes((0, $1pm5p.ReviewTilesType).STATUS) && fetchThirdPartyMultiEntityStatuses(selectedEntities.map((entity)=>entity.id), projectData).then((data)=>{
            setThirdPartyState({
                thirdPartyStatusMapping: data
            });
        });
    }, [
        fetchThirdPartyMultiEntityStatuses,
        projectData,
        selectedEntities,
        setThirdPartyState,
        tiles
    ]);
    const onFetchThirdPartyFieldConfig = (0, $eUqFw.useCallback)(()=>{
        if (!(0, $1ybV0.ff)('x2c-clickup-importer-multi-list')) selectedEntityId && fetchThirdPartyFieldConfig(selectedEntityId, projectData).then((data)=>{
            setThirdPartyState({
                thirdPartyFieldConfigState: data
            });
        });
        else {
            const entityId = selectedEntityId || selectedEntities && selectedEntities[0]?.id;
            const entities = selectedEntities || entityId && [
                {
                    id: entityId,
                    name: selectedEntityName ?? ''
                }
            ] || [];
            entityId && entities.length > 0 && fetchThirdPartyFieldConfig(entityId, projectData, entities).then((data)=>{
                setThirdPartyState({
                    thirdPartyFieldConfigState: data
                });
            });
        }
    }, [
        fetchThirdPartyFieldConfig,
        projectData,
        selectedEntities,
        selectedEntityId,
        selectedEntityName,
        setThirdPartyState
    ]);
    (0, $eUqFw.useEffect)(()=>{
        !thirdPartyFieldConfigState && onFetchThirdPartyFieldConfig();
    }, [
        onFetchThirdPartyFieldConfig,
        thirdPartyFieldConfigState
    ]);
    (0, $eUqFw.useEffect)(()=>{
        !thirdPartyStatusMapping && onFetchThirdPartyStatusMapping();
    }, [
        onFetchThirdPartyStatusMapping,
        thirdPartyStatusMapping
    ]);
    const onStartImport = (0, $eUqFw.useCallback)(()=>{
        startImport({
            projectData: projectData,
            onNext: onNext
        });
    }, [
        startImport,
        projectData,
        onNext
    ]);
    const onSelectedTile = (0, $eUqFw.useCallback)((tile)=>{
        setSelectedTile(tile);
        onDismissFlag((0, $kzTj7.MAPPING_FIELD_UPDATE_SUCCESS_FLAG_ID));
        onDismissFlag((0, $kzTj7.MAPPING_HIERARCHY_UPDATE_SUCCESS_FLAG_ID));
        onDismissFlag((0, $kzTj7.MAPPING_STATUS_UPDATE_SUCCESS_FLAG_ID));
    }, [
        onDismissFlag
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            onDismissFlag((0, $kzTj7.MAPPING_FIELD_UPDATE_SUCCESS_FLAG_ID));
            onDismissFlag((0, $kzTj7.MAPPING_HIERARCHY_UPDATE_SUCCESS_FLAG_ID));
            onDismissFlag((0, $kzTj7.MAPPING_STATUS_UPDATE_SUCCESS_FLAG_ID));
            setUIState({
                hasUnsavedFieldMappingChanges: false,
                hasUnsavedHierarchyMappingChanges: false,
                hasUnsavedStatusMappingChanges: false
            });
        }, [
        onDismissFlag,
        setUIState
    ]);
    const onResetSelectedTile = (0, $eUqFw.useCallback)(()=>{
        setSelectedTile(undefined);
        if (hasUnsavedFieldMappingChanges) {
            onShowFlag((0, $kzTj7.MAPPING_FIELD_UPDATE_SUCCESS_FLAG_ID));
            setUIState({
                hasUnsavedFieldMappingChanges: false
            });
        }
        if (hasUnsavedHierarchyMappingChanges) {
            onShowFlag((0, $kzTj7.MAPPING_HIERARCHY_UPDATE_SUCCESS_FLAG_ID));
            setUIState({
                hasUnsavedHierarchyMappingChanges: false
            });
        }
        if (hasUnsavedStatusMappingChanges) {
            onShowFlag((0, $kzTj7.MAPPING_STATUS_UPDATE_SUCCESS_FLAG_ID));
            setUIState({
                hasUnsavedStatusMappingChanges: false
            });
        }
    }, [
        hasUnsavedFieldMappingChanges,
        hasUnsavedHierarchyMappingChanges,
        hasUnsavedStatusMappingChanges,
        onShowFlag,
        setUIState
    ]);
    const renderStepFooterComponent = (0, $eUqFw.useMemo)(()=>{
        if ((0, $eI5EY.fg)('enable-x2c-standardised-flow')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $elKPF.StepFooterStandard), {
            alignRight: true,
            onReturn: onReturn,
            shouldStartImportOnNext: true,
            onClickNext: onStartImport,
            isLoading: isImportLoading,
            shouldDisableReturn: isImportLoading,
            shouldDisableNext: isStartImportDisabled || isLoading || hasErrorOccurred || tiles.includes((0, $1pm5p.ReviewTilesType).STATUS) && isStatusMappingLoading || statusMappingError,
            hasImportErrorOccurred: hasImportErrorOccurred
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ddd4c6bfc8442593$var$FooterWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $elKPF.StepFooter), {
            onReturn: onReturn,
            shouldStartImportOnNext: true,
            onClickNext: onStartImport,
            isLoading: isImportLoading,
            shouldDisableReturn: isImportLoading,
            shouldDisableNext: isStartImportDisabled || isLoading || hasErrorOccurred || tiles.includes((0, $1pm5p.ReviewTilesType).STATUS) && isStatusMappingLoading || statusMappingError,
            hasImportErrorOccurred: hasImportErrorOccurred
        }));
    }, [
        hasErrorOccurred,
        hasImportErrorOccurred,
        isImportLoading,
        isLoading,
        isStartImportDisabled,
        isStatusMappingLoading,
        onReturn,
        onStartImport,
        statusMappingError,
        tiles
    ]);
    const renderContent = ()=>{
        const returnButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            onClick: onResetSelectedTile,
            appearance: "subtle",
            testId: "project-create-importer-upload-flow.ui.third-party-review-screen.back-button",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gpZWO))), {
                label: "",
                size: "small"
            })
        }, formatMessage((0, $7MbnE.default).backToReview));
        if (selectedTile === (0, $1pm5p.ReviewTilesType).HIERARCHY) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, returnButton, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iUOit.ProjectHierarchy), {
            thirdParty: thirdParty
        }));
        if (selectedTile === (0, $1pm5p.ReviewTilesType).FIELDS && thirdPartyFieldConfigState) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, returnButton, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ScnX.FieldsMapping), {
            thirdParty: thirdParty
        }));
        if (selectedTile === (0, $1pm5p.ReviewTilesType).STATUS && thirdPartyStatusMapping) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, returnButton, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dHmCU.StatusMapping), {
            thirdParty: thirdParty
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1VyqP.PageHeading), null, formatMessage((0, $7MbnE.default).heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1VyqP.PageDescription), null, reviewScreenDescription ? formatMessage(reviewScreenDescription, {
            link: (chunks)=>(0, $1ybV0.ff)('jira-business-to-software-project-imports') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4kMup.default), {
                    href: reviewScreenDescriptionURL,
                    target: "_blank"
                }, chunks) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                    href: reviewScreenDescriptionURL,
                    target: "_blank",
                    appearance: "link",
                    spacing: "none"
                }, chunks)
        }) : ''), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ddd4c6bfc8442593$var$TileWrapper, {
            "data-testid": "project-create-importer-upload-flow.ui.third-party-review-screen.tile-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fDl1F.ReviewTiles), {
            onSetSelectedTile: onSelectedTile,
            onRefetchFieldMapping: onFetchThirdPartyFieldConfig,
            thirdPartyImportSettings: thirdPartyImportSettings,
            onSetThirdPartyImportSettings: setThirdPartyImportSettings,
            thirdParty: thirdParty,
            isLoading: isLoading,
            isStatusMappingLoading: isStatusMappingLoading,
            tiles: tiles,
            hasErrorOccurred: hasErrorOccurred || !isLoading && !thirdPartyFieldConfigState,
            hasStatusMappingErrorOccurred: statusMappingError || !thirdPartyStatusMapping
        }), renderStepFooterComponent));
    };
    const progressBarComponent = (0, $eUqFw.useMemo)(()=>{
        if ((0, $eI5EY.fg)('enable-x2c-standardised-flow')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1T7vu.ProgressBarStandard), {
            productSteps: productSteps,
            currentStepIndex: currentStepIndex,
            onClose: onCloseAndReturnToUploadStep
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $ddd4c6bfc8442593$var$paddingForProgressBar
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3EVB9.CloseAndReturnButton), {
            onCloseAndReturnToUploadStep: onCloseAndReturnToUploadStep
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1T7vu.StepProgressBar), {
            productSteps: productSteps,
            currentStepIndex: currentStepIndex
        }));
    }, [
        productSteps,
        currentStepIndex,
        onCloseAndReturnToUploadStep
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: (0, $3yuWi.X2C_SCREENS).THIRD_PARTY_REVIEW_SCREEN,
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        attributes: {
            thirdParty: thirdParty
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ddd4c6bfc8442593$var$Wrapper, {
        "data-testid": "project-create-importer-upload-flow.ui.third-party-review-screen.wrapper"
    }, progressBarComponent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ddd4c6bfc8442593$var$ContentWrapper, null, renderContent()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ddd4c6bfc8442593$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1n261q9c _1bsb1osq _1tke5o3v _vchhusvi _1yt41avh _bfhk1j9a _11381ns9",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ddd4c6bfc8442593$var$ContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s82gi7 _1bsb1w8u _p12f1ncl",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ddd4c6bfc8442593$var$TileWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _1ul9kbql",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ddd4c6bfc8442593$var$FooterWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1n261q9c _4cvrh9n0 _1ik51osq",
            __cmplp.className
        ])
    });
});
const $ddd4c6bfc8442593$var$paddingForProgressBar = (0, $1ZAYh.xcss)({
    paddingTop: 'space.800'
});

});
parcelRegister("kkYIq", function(module, exports) {

$parcel$export(module.exports, "useThirdPartyFieldConfig", () => $1e170029e6c4d92b$export$c4d8f03980a54164);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $gyZoj = parcelRequire("gyZoj");
var $5GSA7 = parcelRequire("5GSA7");

var $kzTj7 = parcelRequire("kzTj7");

var $3yuWi = parcelRequire("3yuWi");

var $8OWUq = parcelRequire("8OWUq");

var $7a6EU = parcelRequire("7a6EU");
const $1e170029e6c4d92b$export$c4d8f03980a54164 = ({ thirdParty: thirdParty, requestAuthenticationToken: requestAuthenticationToken })=>{
    const thirdPartyClient = (0, $8OWUq.useThirdPartyClient)({
        thirdParty: thirdParty,
        requestAuthenticationToken: requestAuthenticationToken
    });
    const [onExperienceStart, onExperienceSuccess, onExperienceFail] = (0, $5GSA7.useExperienceTracker)((0, $3yuWi.EXPERIENCES).THIRD_PARTY_FIELD_CONFIG);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [hasErrorOccurred, setHasErrorOccurred] = (0, $eUqFw.useState)(false);
    const fetchThirdPartyFieldConfig = (0, $eUqFw.useCallback)(// IMP-498: Remove entityId and use entities
    async (entityId, projectData, entities)=>{
        setIsLoading(true);
        setHasErrorOccurred(false);
        (0, $3yuWi.thirdPartyFieldConfigInteractionMetric).start();
        onExperienceStart();
        try {
            const data = await thirdPartyClient.getFieldConfig({
                entityId: entityId,
                // Default name to empty string since we only use the id
                // IMP-498: Remove the fallback  default value
                entities: entities ?? [
                    {
                        id: entityId,
                        name: ''
                    }
                ],
                projectData: projectData
            });
            const fieldConfigState = (0, $7a6EU.transformToThirdPartyFieldConfigState)(data);
            (0, $3yuWi.thirdPartyFieldConfigInteractionMetric).stop();
            onExperienceSuccess();
            setIsLoading(false);
            return fieldConfigState;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $3yuWi.thirdPartyFieldConfigInteractionMetric).stop();
            onExperienceFail((0, $kzTj7.APP_IDENTIFIER), error, {
                thirdParty: thirdParty
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'fetch-third-party-field-config',
                    packageName: (0, $kzTj7.APP_IDENTIFIER),
                    teamName: (0, $gyZoj.APP_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true,
                error: error
            });
            setHasErrorOccurred(true);
            setIsLoading(false);
            return null;
        }
    }, [
        onExperienceFail,
        onExperienceStart,
        onExperienceSuccess,
        thirdPartyClient,
        thirdParty
    ]);
    return {
        isLoading: isLoading,
        hasErrorOccurred: hasErrorOccurred,
        fetchThirdPartyFieldConfig: fetchThirdPartyFieldConfig
    };
};

});
parcelRegister("7a6EU", function(module, exports) {

$parcel$export(module.exports, "transformToThirdPartyFieldConfigState", () => $348aea9eae352377$export$72d07333c54f10f3);

var $1ybV0 = parcelRequire("1ybV0");

var $kzTj7 = parcelRequire("kzTj7");
const $348aea9eae352377$export$e81952af12c27ea1 = (thirdPartyFieldMappings)=>{
    const fieldMappingsState = {};
    thirdPartyFieldMappings.forEach((fieldMapping)=>{
        fieldMappingsState[fieldMapping.thirdPartyField.fieldId] = {
            ...fieldMapping,
            defaultMappedJiraField: fieldMapping.mappedJiraField
        };
    });
    return fieldMappingsState;
};
const $348aea9eae352377$export$b79336099507b230 = (thirdPartyFieldMappings, filteredFieldId)=>thirdPartyFieldMappings// filter out hierarchy mapping field
    .filter((fieldMapping)=>!(0, $1ybV0.ff)('jwm-x2c-hierarchy-mapping_kkjnd') || fieldMapping.thirdPartyField.fieldId !== filteredFieldId).map((fieldMapping)=>fieldMapping.thirdPartyField.fieldId);
const $348aea9eae352377$export$c625f717fc4d0464 = (thirdPartyFieldMappings)=>{
    const mappedJiraFields = {};
    thirdPartyFieldMappings.filter((fieldMapping)=>!!fieldMapping.mappedJiraField.fieldId).forEach((fieldMapping)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        mappedJiraFields[fieldMapping.mappedJiraField.fieldId] = fieldMapping.thirdPartyField.fieldId;
    });
    return mappedJiraFields;
};
const $348aea9eae352377$export$f9566fe0385604b3 = (thirdPartyFieldMappings)=>{
    const includedJiraFieldIds = new Set();
    thirdPartyFieldMappings.filter((fieldMapping)=>!!fieldMapping.mappedJiraField.fieldId).forEach((fieldMapping)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        includedJiraFieldIds.add(fieldMapping.mappedJiraField.fieldId);
    });
    return includedJiraFieldIds;
};
const $348aea9eae352377$var$transformToThirdPartyItemTypeFieldMapping = (thirdPartyFieldMappings, filteredFieldId)=>({
        mappedJiraFields: $348aea9eae352377$export$c625f717fc4d0464(thirdPartyFieldMappings),
        thirdPartyFieldMappings: $348aea9eae352377$export$e81952af12c27ea1(thirdPartyFieldMappings),
        thirdPartyFieldOrder: $348aea9eae352377$export$b79336099507b230(thirdPartyFieldMappings, filteredFieldId),
        includedJiraFieldIds: $348aea9eae352377$export$f9566fe0385604b3(thirdPartyFieldMappings)
    });
const $348aea9eae352377$export$72d07333c54f10f3 = ({ thirdPartyFieldMappings: thirdPartyFieldMappings, availableJiraFields: availableJiraFields, itemTypes: itemTypes, hierarchyMapping: hierarchyMapping, hasUnsupportedFieldFiltered: hasUnsupportedFieldFiltered })=>{
    if (!itemTypes || itemTypes.length === 0) return {
        availableJiraFields: availableJiraFields,
        fieldMappingState: {
            [(0, $kzTj7.DEFAULT_ITEM_TYPE)]: $348aea9eae352377$var$transformToThirdPartyItemTypeFieldMapping(thirdPartyFieldMappings, hierarchyMapping?.mappingFieldId)
        },
        hierarchyMapping: hierarchyMapping,
        hasUnsupportedFieldFiltered: hasUnsupportedFieldFiltered
    };
    let fieldMappingState = {};
    itemTypes.forEach(({ itemTypeKey: itemTypeKey, itemTypeFieldMappings: itemTypeFieldMappings, itemTypeId: itemTypeId })=>{
        fieldMappingState = {
            ...fieldMappingState,
            [itemTypeKey]: {
                ...$348aea9eae352377$var$transformToThirdPartyItemTypeFieldMapping(itemTypeFieldMappings, hierarchyMapping?.itemType === itemTypeKey ? hierarchyMapping?.mappingFieldId : undefined),
                itemTypeId: itemTypeId
            }
        };
    });
    return {
        availableJiraFields: availableJiraFields,
        fieldMappingState: fieldMappingState,
        hierarchyMapping: hierarchyMapping,
        hasUnsupportedFieldFiltered: hasUnsupportedFieldFiltered
    };
};

});


parcelRegister("bdRTp", function(module, exports) {

$parcel$export(module.exports, "useThirdPartyMultiEntityStatuses", () => $66e4b3e0a69ae4fa$export$17f98139eca585e5);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $gyZoj = parcelRequire("gyZoj");
var $5GSA7 = parcelRequire("5GSA7");

var $kzTj7 = parcelRequire("kzTj7");

var $3yuWi = parcelRequire("3yuWi");

var $8OWUq = parcelRequire("8OWUq");

var $l6JHn = parcelRequire("l6JHn");
const $66e4b3e0a69ae4fa$export$17f98139eca585e5 = ({ thirdParty: thirdParty, requestAuthenticationToken: requestAuthenticationToken })=>{
    const thirdPartyClient = (0, $8OWUq.useThirdPartyClient)({
        thirdParty: thirdParty,
        requestAuthenticationToken: requestAuthenticationToken
    });
    const [onExperienceStart, onExperienceSuccess, onExperienceFail] = (0, $5GSA7.useExperienceTracker)((0, $3yuWi.EXPERIENCES).THIRD_PARTY_MULTI_ENTITY_STATUSES);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [hasErrorOccurred, setHasErrorOccurred] = (0, $eUqFw.useState)(false);
    const fetchThirdPartyMultiEntityStatuses = (0, $eUqFw.useCallback)(async (entityIds, projectData)=>{
        setIsLoading(true);
        setHasErrorOccurred(false);
        (0, $3yuWi.thirdPartyMultiEntityStatusesInteractionMetric).start();
        onExperienceStart();
        try {
            const data = await thirdPartyClient.getMultiEntityStatuses({
                entityIds: entityIds,
                projectData: projectData
            });
            (0, $3yuWi.thirdPartyMultiEntityStatusesInteractionMetric).stop();
            onExperienceSuccess();
            setIsLoading(false);
            return (0, $l6JHn.transformToStatusMappingState)(data);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $3yuWi.thirdPartyMultiEntityStatusesInteractionMetric).stop();
            onExperienceFail((0, $kzTj7.APP_IDENTIFIER), error, {
                thirdParty: thirdParty
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'fetch-third-party-multi-entity-statuses',
                    packageName: (0, $kzTj7.APP_IDENTIFIER),
                    teamName: (0, $gyZoj.APP_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true,
                error: error
            });
            setHasErrorOccurred(true);
            setIsLoading(false);
            return null;
        }
    }, [
        onExperienceFail,
        onExperienceStart,
        onExperienceSuccess,
        thirdPartyClient,
        thirdParty
    ]);
    return {
        isLoading: isLoading,
        hasErrorOccurred: hasErrorOccurred,
        fetchThirdPartyMultiEntityStatuses: fetchThirdPartyMultiEntityStatuses
    };
};

});
parcelRegister("l6JHn", function(module, exports) {

$parcel$export(module.exports, "transformToStatusMappingState", () => $c820a9215da7758b$export$834ac8f76931b058);
const $c820a9215da7758b$export$834ac8f76931b058 = (statusResponse)=>{
    const mapping = {};
    statusResponse.entityStatusMappings.forEach((entityStatusMapping)=>{
        const statusMappings = entityStatusMapping.statusMappings.reduce((acc, status)=>{
            acc[status.sourceStatusName] = {
                mappedStatusName: status.mappedStatusName,
                statusCategory: status.statusCategory
            };
            return acc;
        }, {});
        mapping[entityStatusMapping.entityName] = {
            entityId: entityStatusMapping.entityId,
            statusMappings: statusMappings
        };
    });
    return {
        availableJiraStatuses: statusResponse.availableJiraStatuses.sort((a, b)=>a.name.localeCompare(b.name)),
        statusOptions: statusResponse.statusOptions,
        entityStatusMappings: mapping
    };
};

});


parcelRegister("8ScnX", function(module, exports) {

$parcel$export(module.exports, "FieldsMapping", () => $193d40273e69e83a$export$d031d013c2a32ee9);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $c6uRV = parcelRequire("c6uRV");

var $es1tu = parcelRequire("es1tu");

var $hUuGf = parcelRequire("hUuGf");

var $klv54 = parcelRequire("klv54");
const $193d40273e69e83a$export$d031d013c2a32ee9 = (props)=>{
    const { thirdParty: thirdParty } = props;
    const [itemTypes] = (0, $es1tu.useThirdPartyFieldsItemTypes)();
    const [itemType, setItemType] = (0, $eUqFw.useState)(itemTypes[0] || null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c6uRV.FieldMappingItemTypeContext).Provider, {
        value: itemType
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($193d40273e69e83a$var$Wrapper, {
        "data-testid": "project-create-importer-upload-flow.ui.third-party-review-screen.fields-mapping.wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $klv54.FieldsMappingHeader), {
        thirdParty: thirdParty
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hUuGf.FieldsMappingContentWithTabs), {
        ...props,
        itemTypes: itemTypes,
        onItemTypeChanged: (type)=>{
            setItemType(type);
        },
        selectedItemType: itemType
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $193d40273e69e83a$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1n261q9c _1bsb1osq _vchhusvi _1yt41oq0",
            __cmplp.className
        ])
    });
});

});
parcelRegister("c6uRV", function(module, exports) {

$parcel$export(module.exports, "FieldMappingItemTypeContext", () => $c65a2b2ae37e3fca$export$ba8f7c76a8542a4a);
$parcel$export(module.exports, "useFieldMappingItemTypeContext", () => $c65a2b2ae37e3fca$export$d7f339a1eb7d3fa8);

var $eUqFw = parcelRequire("eUqFw");
const $c65a2b2ae37e3fca$export$ba8f7c76a8542a4a = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $c65a2b2ae37e3fca$export$d7f339a1eb7d3fa8 = ()=>(0, $eUqFw.useContext)($c65a2b2ae37e3fca$export$ba8f7c76a8542a4a);

});

parcelRegister("es1tu", function(module, exports) {

$parcel$export(module.exports, "useThirdPartyFieldConfigState", () => $444cc225c8cab0d5$export$9cffd0e96b43b9bd);
$parcel$export(module.exports, "useThirdPartyFieldsIncludedState", () => $444cc225c8cab0d5$export$3abd78b8a8412776);
$parcel$export(module.exports, "useThirdPartyFieldsItemTypes", () => $444cc225c8cab0d5$export$9057e70d355b5076);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");
var $bj4JM = parcelRequire("bj4JM");

var $1ybV0 = parcelRequire("1ybV0");

var $c6uRV = parcelRequire("c6uRV");

var $8JicK = parcelRequire("8JicK");
const $444cc225c8cab0d5$var$thirdPartyFieldConfigSelector = (state)=>state.thirdPartyState.thirdPartyFieldConfigState;
const $444cc225c8cab0d5$export$3c8dd3213fdbf94 = (0, $bj4JM.createSelector)($444cc225c8cab0d5$var$thirdPartyFieldConfigSelector, (_, props)=>props && props.itemType, (newState, itemType)=>{
    if (newState == null || itemType == null) return null;
    return {
        ...newState.fieldMappingState[itemType],
        availableJiraFields: newState.availableJiraFields
    };
});
const $444cc225c8cab0d5$export$4ebbd364fa265524 = (0, $ggKAj.createHook)((0, $8JicK.Store), {
    selector: $444cc225c8cab0d5$export$3c8dd3213fdbf94
});
const $444cc225c8cab0d5$export$9cffd0e96b43b9bd = ()=>{
    const itemType = (0, $c6uRV.useFieldMappingItemTypeContext)();
    const [state, { setIsThirdPartyFieldIncluded: setIsThirdPartyFieldIncluded, setThirdPartyFieldMapping: setThirdPartyFieldMapping }] = $444cc225c8cab0d5$export$4ebbd364fa265524({
        itemType: itemType
    });
    const actions = (0, $eUqFw.useMemo)(()=>({
            setIsThirdPartyFieldIncluded: setIsThirdPartyFieldIncluded.bind(null, itemType),
            setThirdPartyFieldMapping: setThirdPartyFieldMapping.bind(null, itemType)
        }), [
        itemType,
        setIsThirdPartyFieldIncluded,
        setThirdPartyFieldMapping
    ]);
    return [
        state,
        actions
    ];
};
const $444cc225c8cab0d5$export$e95ec0308327626d = (0, $bj4JM.createSelector)($444cc225c8cab0d5$var$thirdPartyFieldConfigSelector, (newState)=>{
    if (newState === null) return {
        numFieldsIncluded: 0,
        numThirdPartyFields: 0
    };
    const { fieldMappingState: fieldMappingState, hasUnsupportedFieldFiltered: hasUnsupportedFieldFiltered } = newState;
    let numThirdPartyFields = 0;
    let numFieldsIncluded = 0;
    Object.keys(fieldMappingState).forEach((key)=>{
        const fieldMapping = fieldMappingState[key];
        numThirdPartyFields += fieldMapping.thirdPartyFieldOrder.length;
        numFieldsIncluded += Object.values(fieldMapping?.thirdPartyFieldMappings || {}).filter((field)=>(0, $1ybV0.ff)('jwm-x2c-hierarchy-mapping_kkjnd') ? fieldMapping.thirdPartyFieldOrder.includes(field.thirdPartyField.fieldId) && field.mappingContext.isIncluded : field.mappingContext.isIncluded).length;
    });
    return {
        numThirdPartyFields: numThirdPartyFields,
        numFieldsIncluded: numFieldsIncluded,
        hasUnsupportedFieldFiltered: hasUnsupportedFieldFiltered
    };
});
const $444cc225c8cab0d5$export$3abd78b8a8412776 = (0, $ggKAj.createHook)((0, $8JicK.Store), {
    selector: $444cc225c8cab0d5$export$e95ec0308327626d
});
const $444cc225c8cab0d5$export$480a3fce86c0cd5d = (0, $bj4JM.createSelector)($444cc225c8cab0d5$var$thirdPartyFieldConfigSelector, (newState)=>newState ? Object.keys(newState.fieldMappingState) : []);
const $444cc225c8cab0d5$export$9057e70d355b5076 = (0, $ggKAj.createHook)((0, $8JicK.Store), {
    selector: $444cc225c8cab0d5$export$480a3fce86c0cd5d
});

});

parcelRegister("hUuGf", function(module, exports) {

$parcel$export(module.exports, "FieldsMappingContentWithTabs", () => $136795ba1ea731e7$export$4c9cb5c6dc18e789);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $9Amv1 = parcelRequire("9Amv1");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2jdHI = parcelRequire("2jdHI");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kzTj7 = parcelRequire("kzTj7");

var $fQU5k = parcelRequire("fQU5k");

var $eft4l = parcelRequire("eft4l");

var $cDLTA = parcelRequire("cDLTA");

var $es1tu = parcelRequire("es1tu");

var $abk6t = parcelRequire("abk6t");

var $bewSS = parcelRequire("bewSS");
const $136795ba1ea731e7$export$a04e7fe9c4df1d57 = ({ thirdParty: thirdParty, thirdPartyFieldConfigState: thirdPartyFieldConfigState, rowsPerPage: rowsPerPage = 7, itemTypes: itemTypes, selectedItemType: selectedItemType, onChange: onChange })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [searchTerm, setSearchTerm] = (0, $eUqFw.useState)('');
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [handleSearchTermChange] = (0, $2jdHI.default)((newValue)=>{
        if (newValue !== '') (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'fieldSearch used');
    }, (0, $kzTj7.DEBOUNCE_DELAY));
    const onSearchTermChange = (0, $eUqFw.useCallback)((e)=>{
        setSearchTerm(e.target.value);
        handleSearchTermChange(e.target.value);
    }, [
        handleSearchTermChange
    ]);
    const { thirdPartyFieldMappings: thirdPartyFieldMappings, thirdPartyFieldOrder: thirdPartyFieldOrder } = thirdPartyFieldConfigState;
    const { fieldsMappingPageIssueTypesMessage: fieldsMappingPageIssueTypesMessage } = (0, $cDLTA.useContentForThirdParty)(thirdParty);
    const filteredFields = (0, $eUqFw.useMemo)(()=>thirdPartyFieldOrder.filter((fieldId)=>searchTerm === '' || thirdPartyFieldMappings[fieldId].thirdPartyField.fieldName?.toLowerCase().includes(searchTerm.toLowerCase())), [
        searchTerm,
        thirdPartyFieldMappings,
        thirdPartyFieldOrder
    ]);
    const tableHead = (0, $bewSS.useTableHead)(thirdParty);
    const tableRows = (0, $bewSS.useTableRows)(thirdParty, {
        ...thirdPartyFieldConfigState,
        thirdPartyFieldOrder: filteredFields
    });
    const onSetPage = (0, $eUqFw.useCallback)((pageNumber, uiAnalytics)=>{
        if (uiAnalytics) (0, $jMP2a.fireUIAnalytics)(uiAnalytics, 'fieldMappingTable', {
            pageNumber: pageNumber,
            totalPages: tableRows?.length ? Math.ceil(tableRows.length / rowsPerPage) : 0
        });
    }, [
        rowsPerPage,
        tableRows?.length
    ]);
    const headerContent = ()=>{
        if (!itemTypes || itemTypes.length < 2) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($136795ba1ea731e7$var$SearchWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eft4l.SearchBar), {
            onSearchTermChange: onSearchTermChange,
            placeholder: (0, $abk6t.default).searchFieldPlaceholder
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            space: "space.100",
            xcss: $136795ba1ea731e7$var$tabHeaderStyles,
            grow: "fill",
            spread: "space-between",
            shouldWrap: true,
            rowSpace: "space.150"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
            alignItems: "center",
            gap: "space.100",
            xcss: $136795ba1ea731e7$var$tabContentStyles
        }, fieldsMappingPageIssueTypesMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $136795ba1ea731e7$var$textStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
            align: "center"
        }, fieldsMappingPageIssueTypesMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
            gap: "space.100",
            xcss: $136795ba1ea731e7$var$tabsStyles
        }, itemTypes.map((itemType)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($136795ba1ea731e7$var$StyledButton, {
                key: itemType,
                appearance: "default",
                onClick: ()=>onChange(itemType),
                isSelected: selectedItemType === itemType
            }, (0, $bewSS.getItemTypeContent)(itemType, formatMessage))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $136795ba1ea731e7$var$searchBarStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eft4l.SearchBar), {
            onSearchTermChange: onSearchTermChange,
            placeholder: (0, $abk6t.default).searchFieldPlaceholder,
            isCompact: true
        })));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, headerContent(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingBlockStart: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fQU5k.AsyncMappingTable), {
        head: tableHead,
        rows: tableRows,
        rowsPerPage: rowsPerPage,
        emptyMessage: (0, $abk6t.default).noFields,
        onSetPage: onSetPage
    })));
};
const $136795ba1ea731e7$export$4c9cb5c6dc18e789 = ({ thirdParty: thirdParty, rowsPerPage: rowsPerPage = 7, onItemTypeChanged: onItemTypeChanged, itemTypes: itemTypes, selectedItemType: selectedItemType })=>{
    const [thirdPartyFieldConfigState] = (0, $es1tu.useThirdPartyFieldConfigState)();
    if (thirdPartyFieldConfigState == null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($136795ba1ea731e7$export$a04e7fe9c4df1d57, {
        itemTypes: itemTypes,
        thirdParty: thirdParty,
        thirdPartyFieldConfigState: thirdPartyFieldConfigState,
        rowsPerPage: rowsPerPage,
        selectedItemType: selectedItemType,
        onChange: onItemTypeChanged
    });
};
const $136795ba1ea731e7$var$tabHeaderStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.150',
    marginBottom: 'space.100'
});
const $136795ba1ea731e7$var$textStyles = (0, $1ZAYh.xcss)({
    minWidth: '70px',
    fontSize: '12px',
    fontWeight: 500,
    paddingTop: 'space.050',
    paddingBottom: 'space.075'
});
const $136795ba1ea731e7$var$tabContentStyles = (0, $1ZAYh.xcss)({
    maxWidth: '100%',
    minWidth: '75%',
    flexGrow: 1
});
const $136795ba1ea731e7$var$searchBarStyles = (0, $1ZAYh.xcss)({
    width: '140px',
    flex: 1,
    maxWidth: '240px',
    minWidth: '140px',
    paddingTop: 'space.050'
});
const $136795ba1ea731e7$var$tabsStyles = (0, $1ZAYh.xcss)({
    overflow: 'auto',
    padding: 'space.050',
    paddingBottom: 'space.075'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $136795ba1ea731e7$var$StyledButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1tnqgktf _nmk41dk0",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $136795ba1ea731e7$var$SearchWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8zu5n _1bsb1ssb _p12f1qe4 _1ul9p3fh",
            __cmplp.className
        ])
    });
});

});
parcelRegister("abk6t", function(module, exports) {

$parcel$export(module.exports, "default", () => $fad376802964b273$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $fad376802964b273$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    searchFieldPlaceholder: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.search-field-placeholder",
        "defaultMessage": "Search fields"
    },
    thirdPartyFields: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.third-party-fields",
        "defaultMessage": "{thirdParty} field"
    },
    jwmFieldsSpork: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.jwm-fields-spork",
        "defaultMessage": "Jira field"
    },
    jiraBusinessProjectFieldsSpork: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.jira-business-project-fields-spork",
        "defaultMessage": "Business project field"
    },
    jiraSoftwareProjectFieldsSpork: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.jira-software-project-fields-spork",
        "defaultMessage": "Software project field"
    },
    jiraCurrentProjectFields: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.jira-current-project-fields",
        "defaultMessage": "Current project"
    },
    jiraNewProjectFields: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.jira-new-project-fields",
        "defaultMessage": "New project"
    },
    importToJira: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.import-to-jira",
        "defaultMessage": "Include in import"
    },
    exampleLabel: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.example-label",
        "defaultMessage": "{fieldName} (e.g. {exampleValue})"
    },
    noFields: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.no-fields",
        "defaultMessage": "There are no fields in your selected board."
    },
    itemTypes: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.item-types",
        "defaultMessage": "{itemType} field mapping"
    },
    itemTypeTab: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.item-type-tab",
        "defaultMessage": "Item field mapping"
    },
    subitemTab: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.subitem-tab",
        "defaultMessage": "Subitem field mapping"
    },
    itemType: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.item-type",
        "defaultMessage": "Item"
    },
    subitem: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.subitem",
        "defaultMessage": "Subitem"
    }
});

});

parcelRegister("bewSS", function(module, exports) {

$parcel$export(module.exports, "useTableHead", () => $ee8aee4a32bc4f0b$export$c1593f9fc5eec62b);
$parcel$export(module.exports, "useTableRows", () => $ee8aee4a32bc4f0b$export$a190e1af00082b41);
$parcel$export(module.exports, "getItemTypeContent", () => $ee8aee4a32bc4f0b$export$5d29a379ab125673);
/* utils.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $2Q5Ee = parcelRequire("2Q5Ee");

var $1kt3H = parcelRequire("1kt3H");

var $77CtJ = parcelRequire("77CtJ");

var $9Amv1 = parcelRequire("9Amv1");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kzTj7 = parcelRequire("kzTj7");

var $3ak5x = parcelRequire("3ak5x");

var $7J5LG = parcelRequire("7J5LG");

var $4R50N = parcelRequire("4R50N");

var $gfc9M = parcelRequire("gfc9M");

var $yF36J = parcelRequire("yF36J");

var $abk6t = parcelRequire("abk6t");
const $ee8aee4a32bc4f0b$var$getFieldText = (thirdParty)=>{
    switch(thirdParty){
        case 0, $3ak5x.JIRA_SOFTWARE:
        case 0, $3ak5x.JIRA_BUSINESS:
            return {
                thirdPartyFieldText: (0, $abk6t.default).jiraCurrentProjectFields,
                importProjectFieldText: (0, $abk6t.default).jiraNewProjectFields
            };
        default:
            return {
                thirdPartyFieldText: (0, $abk6t.default).thirdPartyFields,
                importProjectFieldText: (0, $abk6t.default).jwmFieldsSpork
            };
    }
};
const $ee8aee4a32bc4f0b$var$getFieldIcons = (tool)=>{
    switch(tool?.key){
        case 0, $3ak5x.JIRA_SOFTWARE:
        case 0, $3ak5x.JIRA_BUSINESS:
            return {
                thirdPartyIcon: null,
                importProjectIcon: null
            };
        default:
            return {
                thirdPartyIcon: tool && (0, $7J5LG.renderIcon)(tool?.icon, true),
                importProjectIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77CtJ.JiraIcon), {
                    size: "small",
                    appearance: "brand"
                })
            };
    }
};
const $ee8aee4a32bc4f0b$export$c1593f9fc5eec62b = (thirdParty)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const tool = (0, $4R50N.useImportTool)(thirdParty);
    const tableHead = (0, $eUqFw.useMemo)(()=>{
        if ((0, $1ybV0.ff)('jira-business-to-software-project-imports')) {
            const { thirdPartyFieldText: thirdPartyFieldText, importProjectFieldText: importProjectFieldText } = $ee8aee4a32bc4f0b$var$getFieldText(tool?.key);
            const thirdPartyFieldTextFormatted = formatMessage(thirdPartyFieldText, {
                thirdParty: tool?.name
            });
            const importProjectFieldTextFormatted = formatMessage(importProjectFieldText);
            const { thirdPartyIcon: thirdPartyIcon, importProjectIcon: importProjectIcon } = $ee8aee4a32bc4f0b$var$getFieldIcons(tool);
            return {
                cells: [
                    {
                        key: 'thirdPartyField',
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ee8aee4a32bc4f0b$var$FieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
                            space: "space.050",
                            alignBlock: "center"
                        }, thirdPartyIcon, thirdPartyFieldTextFormatted))
                    },
                    {
                        key: 'arrow',
                        width: 5
                    },
                    {
                        key: 'importProjectField',
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
                            space: "space.050",
                            alignBlock: "center"
                        }, importProjectIcon, importProjectFieldTextFormatted),
                        width: 40
                    },
                    {
                        key: 'importToJira',
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ee8aee4a32bc4f0b$var$ColumnHeader, null, formatMessage((0, $abk6t.default).importToJira)),
                        width: 25
                    }
                ]
            };
        }
        const isInternalImport = thirdParty === (0, $3ak5x.JIRA_SOFTWARE) && tool?.key === (0, $3ak5x.JIRA_SOFTWARE);
        const thirdPartyFieldText = isInternalImport ? formatMessage((0, $abk6t.default).jiraSoftwareProjectFieldsSpork) : formatMessage((0, $abk6t.default).thirdPartyFields, {
            thirdParty: tool?.name
        });
        const businessImportIcon = isInternalImport ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1kt3H))), {
            label: thirdPartyFieldText,
            size: "medium"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77CtJ.JiraIcon), {
            size: "small",
            appearance: "brand"
        });
        return {
            cells: [
                {
                    key: 'thirdPartyField',
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ee8aee4a32bc4f0b$var$FieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
                        space: "space.050",
                        alignBlock: "center"
                    }, isInternalImport ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2Q5Ee))), {
                        label: thirdPartyFieldText,
                        size: "medium"
                    }) : tool && (0, $7J5LG.renderIcon)(tool?.icon, true), thirdPartyFieldText))
                },
                {
                    key: 'arrow',
                    width: 5
                },
                {
                    key: 'jwmField',
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
                        space: "space.050",
                        alignBlock: "center"
                    }, businessImportIcon, formatMessage(isInternalImport ? (0, $abk6t.default).jiraBusinessProjectFieldsSpork : (0, $abk6t.default).jwmFieldsSpork)),
                    width: 40
                },
                {
                    key: 'importToJira',
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ee8aee4a32bc4f0b$var$ColumnHeader, null, formatMessage((0, $abk6t.default).importToJira)),
                    width: 25
                }
            ]
        };
    }, [
        formatMessage,
        tool,
        thirdParty
    ]);
    return tableHead;
};
const $ee8aee4a32bc4f0b$export$a190e1af00082b41 = (thirdParty, thirdPartyFieldConfigState)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { thirdPartyFieldMappings: fields, thirdPartyFieldOrder: thirdPartyFieldOrder } = thirdPartyFieldConfigState;
    const tableRows = (0, $eUqFw.useMemo)(()=>thirdPartyFieldOrder.map((fieldId)=>{
            const field = fields[fieldId];
            return {
                key: `row-${fieldId}`,
                cells: [
                    {
                        key: `${fieldId}-name`,
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ee8aee4a32bc4f0b$var$FieldWrapper, null, field.exampleValue ? formatMessage((0, $abk6t.default).exampleLabel, {
                            fieldName: field.thirdPartyField.fieldName,
                            exampleValue: field.exampleValue
                        }) : field.thirdPartyField.fieldName)
                    },
                    {
                        key: `${fieldId}-arrow`,
                        content: "\u2192"
                    },
                    {
                        key: (0, $1ybV0.ff)('jira-business-to-software-project-imports') ? `${fieldId}-import-project-field` : `${fieldId}-jwm-field`,
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gfc9M.FieldSelector), {
                            thirdPartyFieldMapping: field,
                            thirdParty: thirdParty
                        })
                    },
                    {
                        key: `${fieldId}-import`,
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $yF36J.default), {
                            thirdPartyFieldMapping: field
                        })
                    }
                ]
            };
        }), [
        fields,
        formatMessage,
        thirdParty,
        thirdPartyFieldOrder
    ]);
    return tableRows;
};
const $ee8aee4a32bc4f0b$export$5d29a379ab125673 = (itemType, formatMessage)=>{
    switch(itemType){
        case 0, $kzTj7.DEFAULT_ITEM_TYPE:
            return formatMessage((0, $abk6t.default).itemType);
        case 0, $kzTj7.DEFAULT_SUBITEM_TYPE:
            return formatMessage((0, $abk6t.default).subitem);
        default:
            return itemType.toLowerCase();
    }
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ee8aee4a32bc4f0b$var$FieldWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0utpp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ee8aee4a32bc4f0b$var$ColumnHeader = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _4t3i1ejb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gfc9M", function(module, exports) {

$parcel$export(module.exports, "FieldSelector", () => $bd543bb5efbb11c3$export$1e75f01162ffc4f1);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $6OfWd = parcelRequire("6OfWd");

var $86Ndv = parcelRequire("86Ndv");

var $ffiyv = parcelRequire("ffiyv");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kzTj7 = parcelRequire("kzTj7");

var $hlez9 = parcelRequire("hlez9");

var $es1tu = parcelRequire("es1tu");

var $chO6i = parcelRequire("chO6i");

var $abzXt = parcelRequire("abzXt");

var $avlET = parcelRequire("avlET");
const $bd543bb5efbb11c3$export$1e75f01162ffc4f1 = ({ thirdParty: thirdParty, thirdPartyFieldMapping: thirdPartyFieldMapping })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const [isCustomFieldsMenuOpen, setIsCustomFieldsMenuOpen] = (0, $eUqFw.useState)(false);
    const { mappedJiraField: mappedJiraField, mappingContext: mappingContext, thirdPartyField: thirdPartyField, compatibleExistingFieldTypes: compatibleExistingFieldTypes } = thirdPartyFieldMapping;
    const [thirdPartyFieldConfigState] = (0, $es1tu.useThirdPartyFieldConfigState)();
    const toggleMenuOpenState = (0, $eUqFw.useCallback)((attrs)=>{
        setIsOpen(attrs.isOpen);
        if (!attrs.isOpen) setIsCustomFieldsMenuOpen(false);
    }, []);
    const onClickSelectCustomField = (0, $eUqFw.useCallback)((event)=>{
        event.stopPropagation();
        setIsCustomFieldsMenuOpen(true);
    }, []);
    const onClickGoBack = (0, $eUqFw.useCallback)((event)=>{
        event.stopPropagation();
        setIsCustomFieldsMenuOpen(false);
    }, []);
    const onKeyDownHandler = (0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Tab') event.stopPropagation();
    }, []);
    const getFieldLozenge = (0, $eUqFw.useCallback)((isDisabled = false)=>{
        if (mappingContext.isRequired) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
            appearance: "default"
        }, formatMessage((0, $abzXt.default).required));
        if (!mappedJiraField.fieldId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
            appearance: isDisabled ? 'default' : 'new'
        }, formatMessage((0, $abzXt.default).newField));
        return null;
    }, [
        formatMessage,
        mappedJiraField.fieldId,
        mappingContext.isRequired
    ]);
    // disable the field if only one field option is available
    const shouldDisableField = (0, $eUqFw.useMemo)(()=>{
        if (thirdPartyFieldConfigState === null) return false;
        const { availableJiraFields: availableJiraFields } = thirdPartyFieldConfigState;
        const availableJiraFieldItems = compatibleExistingFieldTypes.flatMap((fieldType)=>availableJiraFields[fieldType] ?? []);
        return (availableJiraFieldItems?.length || 0) + thirdPartyFieldMapping.compatibleNewFieldTypes.length <= 1;
    }, [
        compatibleExistingFieldTypes,
        thirdPartyFieldConfigState,
        thirdPartyFieldMapping.compatibleNewFieldTypes.length
    ]);
    const dropdownTrigger = (0, $eUqFw.useCallback)(({ triggerRef: triggerRef, isSelected: isSelected, ...props })=>{
        const isDisabled = !mappingContext.isIncluded;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bd543bb5efbb11c3$var$StyledButton, {
            ...props,
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                label: "",
                size: "large"
            }),
            ref: triggerRef,
            isOpen: isSelected,
            isDisabled: isDisabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bd543bb5efbb11c3$var$ContentLeftWrapper, null, (0, $hlez9.getIcon)({
            fieldType: mappedJiraField.fieldType,
            isDisabled: isDisabled
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bd543bb5efbb11c3$var$Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: mappedJiraField.fieldName,
            position: "bottom-start"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, mappedJiraField.fieldName)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bd543bb5efbb11c3$var$ContentRightWrapper, null, getFieldLozenge(isDisabled)));
    }, [
        getFieldLozenge,
        mappedJiraField.fieldName,
        mappedJiraField.fieldType,
        mappingContext.isIncluded
    ]);
    const fixedFieldContent = (0, $eUqFw.useMemo)(()=>{
        const isDisabled = !mappingContext.isIncluded;
        const showDropdownIcon = !mappingContext.isRequired;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bd543bb5efbb11c3$var$FixedFieldWrapper, {
            isDisabled: isDisabled,
            showDropdownIcon: showDropdownIcon
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bd543bb5efbb11c3$var$ContentLeftWrapper, null, (0, $hlez9.getIcon)({
            fieldType: mappedJiraField.fieldType,
            isDisabled: isDisabled,
            isSubtle: !isDisabled
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bd543bb5efbb11c3$var$Header, null, mappedJiraField.fieldName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bd543bb5efbb11c3$var$ContentRightWrapper, null, getFieldLozenge(isDisabled)), showDropdownIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bd543bb5efbb11c3$var$ContentIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
            label: "",
            size: "large",
            testId: "project-create-importer-upload-flow.ui.third-party-review-screen.fields-mapping.fields-mapping-content.field-selector.chevron-down-icon"
        })));
    }, [
        getFieldLozenge,
        mappedJiraField.fieldName,
        mappedJiraField.fieldType,
        mappingContext.isIncluded,
        mappingContext.isRequired
    ]);
    if (mappingContext.isRequired) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: formatMessage((0, $abzXt.default).requiredFieldToolTip)
    }, fixedFieldContent);
    if (mappingContext.isFieldDisabled || shouldDisableField) return fixedFieldContent;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bd543bb5efbb11c3$var$Wrapper, {
        "data-testid": `${(0, $kzTj7.THIRD_PARTY_FIELD_SELECTOR_TEST_ID_PREFIX)}.dropdown-menu`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        testId: `${(0, $kzTj7.THIRD_PARTY_FIELD_SELECTOR_TEST_ID_PREFIX)}.dropdown-menu-${thirdPartyField.fieldName}`,
        isOpen: isOpen,
        onOpenChange: toggleMenuOpenState,
        shouldFlip: true,
        trigger: dropdownTrigger
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bd543bb5efbb11c3$var$DropdownItemWrapper, {
        onKeyDown: onKeyDownHandler
    }, isCustomFieldsMenuOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $avlET.NewCustomFieldsSection), {
        thirdPartyFieldMapping: thirdPartyFieldMapping,
        onClickGoBack: onClickGoBack
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $chO6i.ExistingFieldsSection), {
        thirdParty: thirdParty,
        thirdPartyFieldMapping: thirdPartyFieldMapping,
        onClickSelectCustomField: onClickSelectCustomField
    }))));
};
const $bd543bb5efbb11c3$export$8abc08b3556d99fc = 275; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bd543bb5efbb11c3$var$FixedFieldWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { showDropdownIcon: showDropdownIcon, isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o _vchhusvi _o5721q9c _1bsb7rrr _1ul9idpf _4t3ixy5q _19bv1b66 _2rko1y44 _80om13gf _bfhk6rqw _19it1599",
            __cmplp.showDropdownIcon ? "_u5f3idpf" : "_u5f3utpp",
            __cmplp.isDisabled ? "_syazznk9" : "_syaz1be1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bd543bb5efbb11c3$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o _vchhusvi _o5721q9c _1bsb7rrr _1ul9idpf _4t3ixy5q _18iz1h6o _i1wwidpf _8ax3idpf _ake1idpf _1gqwidpf _11381osq _nb7jidpf _t74o1osq _bt2c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bd543bb5efbb11c3$var$Header = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8otz2 _1reo15vq _18m915vq _c7wx1q9c _hc7q15vq _njtz15vq _1xnh1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bd543bb5efbb11c3$var$ContentLeftWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _2lx2vrvc _4cvr1h6o _1bah1y6m _18u0u2gc _1ul9idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bd543bb5efbb11c3$var$ContentIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwx1i6y _18u057x3 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bd543bb5efbb11c3$var$ContentRightWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlidpf _1o9zkb7n _i0dl1wug _2lx2vrvc _4cvr1h6o _k8em1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bd543bb5efbb11c3$var$DropdownItemWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_c71ldtre _1bsb7rrr _n3td1b66",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bd543bb5efbb11c3$var$StyledButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16hg1j9a _1l5aj3m3 _1nisidpf",
            __cmplp.isOpen ? "_1wgm1ekn" : "_1wgmpe8f",
            __cmplp.className
        ])
    });
});

});
parcelRegister("chO6i", function(module, exports) {

$parcel$export(module.exports, "ExistingFieldsSection", () => $7b5b288a1de0a71d$export$3f7d04e3265cb2f9);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $dtaN9 = parcelRequire("dtaN9");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kzTj7 = parcelRequire("kzTj7");

var $1VyqP = parcelRequire("1VyqP");

var $1XXvr = parcelRequire("1XXvr");

var $cDLTA = parcelRequire("cDLTA");

var $hlez9 = parcelRequire("hlez9");

var $antP2 = parcelRequire("antP2");

var $es1tu = parcelRequire("es1tu");

var $9HbMH = parcelRequire("9HbMH");

var $irjtd = parcelRequire("irjtd");

var $jaLNs = parcelRequire("jaLNs");
const $7b5b288a1de0a71d$export$3f7d04e3265cb2f9 = ({ thirdParty: thirdParty, thirdPartyFieldMapping: { compatibleExistingFieldTypes: compatibleExistingFieldTypes, mappedJiraField: mappedJiraField, thirdPartyField: thirdPartyField, compatibleNewFieldTypes: compatibleNewFieldTypes }, onClickSelectCustomField: onClickSelectCustomField })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [thirdPartyFieldConfigState, { setThirdPartyFieldMapping: setThirdPartyFieldMapping }] = (0, $es1tu.useThirdPartyFieldConfigState)();
    const { disabledFieldTooltip: disabledFieldTooltip } = (0, $cDLTA.useContentForThirdParty)(thirdParty);
    const [thirdPartyHierarchyState] = (0, $9HbMH.useThirdPartyHierarchyState)({
        types: (0, $antP2.getHierarchyMappingItems)(thirdParty),
        formatMessage: formatMessage
    });
    const [, { setUIState: setUIState }] = (0, $irjtd.useUIState)();
    const getSelectedCustomField = (0, $eUqFw.useCallback)(()=>{
        if (mappedJiraField.fieldId) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1XXvr.FieldSelectorItem), {
            icon: (0, $hlez9.getIcon)({
                fieldType: mappedJiraField.fieldType,
                isSelected: true
            }),
            name: mappedJiraField.fieldName,
            isSelected: true
        });
    }, [
        mappedJiraField
    ]);
    const handleDropdownItemClickFactory = (0, $eUqFw.useCallback)((jiraField)=>()=>{
            setThirdPartyFieldMapping(thirdPartyField.fieldId, jiraField);
            setUIState({
                hasUnsavedFieldMappingChanges: true
            });
        }, [
        setThirdPartyFieldMapping,
        setUIState,
        thirdPartyField.fieldId
    ]);
    const availableJiraFieldItems = (0, $eUqFw.useMemo)(()=>{
        if (thirdPartyFieldConfigState === null) return null;
        const { availableJiraFields: availableJiraFields, includedJiraFieldIds: includedJiraFieldIds } = thirdPartyFieldConfigState;
        return compatibleExistingFieldTypes.flatMap((fieldType)=>availableJiraFields[fieldType] ?? []).sort((jiraField)=>!!mappedJiraField.fieldId && jiraField.fieldId === mappedJiraField.fieldId ? -1 : 0).map((jiraField)=>{
            const isSelected = !!mappedJiraField?.fieldId && jiraField.fieldId === mappedJiraField.fieldId;
            const isDisabled = !!jiraField.fieldId && !!includedJiraFieldIds.has(jiraField.fieldId);
            const shouldExcludeField = (0, $1ybV0.ff)('jwm-x2c-hierarchy-mapping_kkjnd') && thirdPartyHierarchyState?.selectedHierarchyMappedItem?.fieldId === jiraField.fieldId;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1XXvr.FieldSelectorItem), {
                key: `${jiraField.fieldName}-${jiraField.fieldType}`,
                name: jiraField.fieldName,
                icon: (0, $hlez9.getIcon)({
                    fieldType: jiraField.fieldType,
                    isSelected: isSelected,
                    isDisabled: isDisabled
                }),
                onClick: handleDropdownItemClickFactory(jiraField),
                isDisabled: isDisabled || shouldExcludeField,
                isSelected: isSelected,
                tooltipContent: disabledFieldTooltip
            });
        });
    }, [
        compatibleExistingFieldTypes,
        disabledFieldTooltip,
        handleDropdownItemClickFactory,
        mappedJiraField.fieldId,
        thirdPartyFieldConfigState,
        thirdPartyHierarchyState?.selectedHierarchyMappedItem?.fieldId
    ]);
    const showNewFieldTypes = compatibleNewFieldTypes.length > 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7b5b288a1de0a71d$var$Wrapper, null, !!availableJiraFieldItems && availableJiraFieldItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1VyqP.DropdownSectionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1VyqP.DropdownSectionHeader), null, formatMessage((0, $jaLNs.default).existingFieldSectionHeading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7b5b288a1de0a71d$var$DropdownItemSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), {
        testId: `${(0, $kzTj7.THIRD_PARTY_FIELD_SELECTOR_TEST_ID_PREFIX)}.existing-fields-section.dropdown-item-group`
    }, availableJiraFieldItems)), showNewFieldTypes && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1VyqP.DropdownSectionDivider), null)), showNewFieldTypes && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7b5b288a1de0a71d$var$FooterWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        testId: `${(0, $kzTj7.THIRD_PARTY_FIELD_SELECTOR_TEST_ID_PREFIX)}.existing-fields-section.new-custom-field-button`,
        onClick: onClickSelectCustomField,
        elemAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))), {
            label: ""
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1VyqP.DropdownSectionHeader), null, formatMessage((0, $jaLNs.default).setNewFieldTypeHeading))), getSelectedCustomField()));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7b5b288a1de0a71d$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _c71ldtre",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7b5b288a1de0a71d$var$DropdownItemSection = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _18m91wug _16jlkb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7b5b288a1de0a71d$var$FooterWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlidpf _1o9zkb7n _i0dl1wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("antP2", function(module, exports) {

$parcel$export(module.exports, "getHierarchyMappingItems", () => $c9d54ca8ad84d3f6$export$88101f25dcbbff01);
$parcel$export(module.exports, "getFieldNameForHierarchyItem", () => $c9d54ca8ad84d3f6$export$e717cab97e41024e);

var $agB2z = parcelRequire("agB2z");

var $aYMEC = parcelRequire("aYMEC");

var $3ak5x = parcelRequire("3ak5x");

var $ghtO9 = parcelRequire("ghtO9");
const $c9d54ca8ad84d3f6$export$88101f25dcbbff01 = (thirdParty)=>{
    switch(thirdParty){
        case 0, $3ak5x.ASANA:
            return 0, $aYMEC.AsanaHierarchyTypes;
        case 0, $3ak5x.MONDAY:
            return 0, $aYMEC.MondayHierarchyTypes;
        case 0, $3ak5x.CLICK_UP:
            return 0, $aYMEC.ClickupHierarchyTypes;
        default:
            return [];
    }
};
const $c9d54ca8ad84d3f6$export$e717cab97e41024e = (fieldName, formatMessage)=>{
    switch(fieldName.toLowerCase()){
        case 0, $aYMEC.SECTION:
            return formatMessage((0, $ghtO9.default).sectionField);
        case 0, $aYMEC.GROUP:
            return formatMessage((0, $ghtO9.default).groupField);
        case 0, $aYMEC.TASK:
            return formatMessage((0, $ghtO9.default).taskField);
        case 0, $aYMEC.SUBTASK:
            return formatMessage((0, $ghtO9.default).subtaskField);
        case 0, $aYMEC.NESTED_SUBTASK:
            return formatMessage((0, $ghtO9.default).nestedSubtaskField);
        case 0, $agB2z.EPIC_FIELDTYPE:
            return formatMessage((0, $ghtO9.default).epicField);
        case 0, $aYMEC.ITEM:
            return formatMessage((0, $ghtO9.default).mondayItemField);
        case 0, $aYMEC.SUBITEM:
            return formatMessage((0, $ghtO9.default).mondaySubItemField);
        case 0, $aYMEC.LIST:
            return formatMessage((0, $ghtO9.default).listField);
        default:
            return fieldName;
    }
};

});
parcelRegister("ghtO9", function(module, exports) {

$parcel$export(module.exports, "default", () => $71202f881316e92f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $71202f881316e92f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    groupField: {
        "id": "project-create-importer-upload-flow.common.utils.third-party-mapping.group-field",
        "defaultMessage": "Group"
    },
    mondayItemField: {
        "id": "project-create-importer-upload-flow.common.utils.third-party-mapping.monday-item-field",
        "defaultMessage": "Item"
    },
    mondaySubItemField: {
        "id": "project-create-importer-upload-flow.common.utils.third-party-mapping.monday-sub-item-field",
        "defaultMessage": "Subitem"
    },
    sectionField: {
        "id": "project-create-importer-upload-flow.common.utils.third-party-mapping.section-field",
        "defaultMessage": "Section"
    },
    taskField: {
        "id": "project-create-importer-upload-flow.common.utils.third-party-mapping.task-field",
        "defaultMessage": "Task"
    },
    subtaskField: {
        "id": "project-create-importer-upload-flow.common.utils.third-party-mapping.subtask-field",
        "defaultMessage": "Subtask"
    },
    nestedSubtaskField: {
        "id": "project-create-importer-upload-flow.common.utils.third-party-mapping.nested-subtask-field",
        "defaultMessage": "Nested subtask"
    },
    epicField: {
        "id": "project-create-importer-upload-flow.common.utils.third-party-mapping.epic-field",
        "defaultMessage": "Epic"
    },
    listField: {
        "id": "project-create-importer-upload-flow.common.utils.third-party-mapping.list-field",
        "defaultMessage": "List"
    }
});

});


parcelRegister("9HbMH", function(module, exports) {

$parcel$export(module.exports, "useThirdPartyHierarchyState", () => $d27882654f390cbd$export$65f04703e860d26b);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");
var $bj4JM = parcelRequire("bj4JM");

var $kzTj7 = parcelRequire("kzTj7");

var $agB2z = parcelRequire("agB2z");

var $aYMEC = parcelRequire("aYMEC");

var $antP2 = parcelRequire("antP2");

var $8JicK = parcelRequire("8JicK");
const $d27882654f390cbd$export$2c9c6d310ae3ccf0 = (type, itemTypeMapping, availableJiraFields, mappingFieldId, formatMessage)=>{
    const defaultData = {
        item: {
            fieldId: type,
            fieldName: (0, $antP2.getFieldNameForHierarchyItem)(type, formatMessage),
            fieldType: type
        },
        mappedItem: {
            fieldId: type,
            fieldName: (0, $antP2.getFieldNameForHierarchyItem)(type, formatMessage),
            fieldType: type
        },
        availableItems: [],
        isDisabled: true,
        showTooltip: false
    };
    if (type === (0, $aYMEC.NESTED_SUBTASK) || type === (0, $aYMEC.SUBITEM)) return {
        ...defaultData,
        mappedItem: {
            fieldId: (0, $aYMEC.SUBTASK),
            fieldName: (0, $antP2.getFieldNameForHierarchyItem)((0, $aYMEC.SUBTASK), formatMessage),
            fieldType: (0, $aYMEC.SUBTASK)
        },
        showTooltip: type === (0, $aYMEC.NESTED_SUBTASK)
    };
    if (type === (0, $aYMEC.ITEM)) return {
        ...defaultData,
        mappedItem: {
            fieldId: (0, $aYMEC.TASK),
            fieldName: (0, $antP2.getFieldNameForHierarchyItem)((0, $aYMEC.TASK), formatMessage),
            fieldType: (0, $aYMEC.TASK)
        }
    };
    if (type === (0, $aYMEC.LIST)) return {
        ...defaultData,
        mappedItem: {
            fieldId: (0, $agB2z.EPIC_FIELDTYPE),
            fieldName: (0, $antP2.getFieldNameForHierarchyItem)((0, $agB2z.EPIC_FIELDTYPE), formatMessage),
            fieldType: (0, $agB2z.EPIC_FIELDTYPE)
        },
        showTooltip: true
    };
    if (!itemTypeMapping) return defaultData;
    const { thirdPartyFieldMappings: thirdPartyFieldMappings, includedJiraFieldIds: includedJiraFieldIds } = itemTypeMapping;
    if (type === mappingFieldId) {
        const thirdPartyFieldMapping = thirdPartyFieldMappings[mappingFieldId];
        if (!thirdPartyFieldMapping) return defaultData;
        const { mappedJiraField: mappedJiraField, mappingContext: mappingContext, compatibleExistingFieldTypes: compatibleExistingFieldTypes, thirdPartyField: thirdPartyField } = thirdPartyFieldMapping;
        const availableItems = compatibleExistingFieldTypes.flatMap((fieldType)=>availableJiraFields[fieldType] ?? []).sort((jiraField)=>!!mappedJiraField.fieldId && jiraField.fieldId === mappedJiraField.fieldId ? -1 : 0).map((jiraField)=>{
            const isDisabled = !!jiraField.fieldId && !!includedJiraFieldIds.has(jiraField.fieldId);
            return {
                ...jiraField,
                isDisabled: isDisabled,
                fieldName: (0, $antP2.getFieldNameForHierarchyItem)(jiraField.fieldName, formatMessage)
            };
        });
        return {
            item: thirdPartyField,
            mappedItem: {
                ...mappedJiraField,
                fieldName: (0, $antP2.getFieldNameForHierarchyItem)(mappedJiraField.fieldName, formatMessage)
            },
            availableItems: availableItems,
            isDisabled: mappingContext.isFieldDisabled,
            showTooltip: true
        };
    }
    return defaultData;
};
const $d27882654f390cbd$export$bcc4f1eec948d8c1 = (0, $bj4JM.createSelector)((state)=>state.thirdPartyState.thirdPartyFieldConfigState, (_, props)=>props, (newState, { types: types, formatMessage: formatMessage })=>{
    if (newState == null) return null;
    const { fieldMappingState: fieldMappingState, availableJiraFields: availableJiraFields, hierarchyMapping: hierarchyMapping } = newState;
    if (!hierarchyMapping) return null;
    let selectedHierarchyItem = null;
    let selectedHierarchyMappedItem = null;
    let thirdPartyItemTypeFieldMapping = null;
    const itemType = hierarchyMapping.itemType || (0, $kzTj7.DEFAULT_ITEM_TYPE);
    // For multi-entity, the keys on the fieldMappingState is the entity name
    // If the itemType is not in the fieldMappingState default
    // the thirdPartyItemTypeFieldMapping to null
    if (Object.keys(fieldMappingState).includes(itemType)) {
        const currentItemTypeMapping = fieldMappingState[hierarchyMapping.itemType || (0, $kzTj7.DEFAULT_ITEM_TYPE)];
        const subItemTypeMapping = fieldMappingState[0, $kzTj7.DEFAULT_SUBITEM_TYPE];
        thirdPartyItemTypeFieldMapping = {
            ...currentItemTypeMapping,
            // Add the included fields from the subitem type
            includedJiraFieldIds: new Set([
                ...currentItemTypeMapping.includedJiraFieldIds,
                ...subItemTypeMapping?.includedJiraFieldIds || []
            ])
        };
    }
    const data = types.map((type)=>{
        const item = $d27882654f390cbd$export$2c9c6d310ae3ccf0(type, thirdPartyItemTypeFieldMapping, availableJiraFields, hierarchyMapping.mappingFieldId, formatMessage);
        if (type === hierarchyMapping.mappingFieldId) {
            selectedHierarchyItem = item.mappedItem.fieldName;
            selectedHierarchyMappedItem = item.mappedItem;
        }
        return item;
    });
    return {
        data: data,
        selectedHierarchyItem: selectedHierarchyItem,
        selectedHierarchyMappedItem: selectedHierarchyMappedItem
    };
});
const $d27882654f390cbd$export$cc93fa4af4c15606 = (0, $ggKAj.createHook)((0, $8JicK.Store), {
    selector: $d27882654f390cbd$export$bcc4f1eec948d8c1
});
const $d27882654f390cbd$export$65f04703e860d26b = (props)=>{
    const [state, { setThirdPartyFieldMapping: setThirdPartyFieldMapping }] = $d27882654f390cbd$export$cc93fa4af4c15606(props);
    const actions = (0, $eUqFw.useMemo)(()=>({
            setThirdPartyFieldMapping: setThirdPartyFieldMapping.bind(null, (0, $kzTj7.DEFAULT_ITEM_TYPE))
        }), [
        setThirdPartyFieldMapping
    ]);
    return [
        state,
        actions
    ];
};

});

parcelRegister("jaLNs", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c173763c8f377ff$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3c173763c8f377ff$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    setNewFieldTypeHeading: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.field-selector.existing-fields-section.set-new-field-type-heading",
        "defaultMessage": "Create a new custom field"
    },
    existingFieldSectionHeading: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.field-selector.existing-fields-section.existing-field-section-heading",
        "defaultMessage": "Map to an existing field"
    }
});

});


parcelRegister("abzXt", function(module, exports) {

$parcel$export(module.exports, "default", () => $93c7e3dcf1ecb296$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $93c7e3dcf1ecb296$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    newField: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.field-selector.new-field",
        "defaultMessage": "New Field"
    },
    required: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.field-selector.required",
        "defaultMessage": "Required"
    },
    requiredFieldToolTip: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.field-selector.required-field-tool-tip",
        "defaultMessage": "This field can't be modified or excluded from the import."
    }
});

});

parcelRegister("avlET", function(module, exports) {

$parcel$export(module.exports, "NewCustomFieldsSection", () => $cb3f567d58fa1fd5$export$1bca492cc6dcd55b);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $6Pq2D = parcelRequire("6Pq2D");

var $7u4fN = parcelRequire("7u4fN");

var $fEubG = parcelRequire("fEubG");

var $4GOUU = parcelRequire("4GOUU");

var $PdmhA = parcelRequire("PdmhA");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kzTj7 = parcelRequire("kzTj7");

var $1VyqP = parcelRequire("1VyqP");

var $1XXvr = parcelRequire("1XXvr");

var $hlez9 = parcelRequire("hlez9");

var $es1tu = parcelRequire("es1tu");

var $irjtd = parcelRequire("irjtd");

var $dnTYt = parcelRequire("dnTYt");
const $cb3f567d58fa1fd5$export$1bca492cc6dcd55b = ({ thirdPartyFieldMapping: { mappedJiraField: mappedJiraField, compatibleNewFieldTypes: compatibleNewFieldTypes, thirdPartyField: thirdPartyField }, onClickGoBack: onClickGoBack })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [, { setThirdPartyFieldMapping: setThirdPartyFieldMapping }] = (0, $es1tu.useThirdPartyFieldConfigState)();
    const [, { setUIState: setUIState }] = (0, $irjtd.useUIState)();
    const handleDropdownItemClickFactory = (0, $eUqFw.useCallback)((newField)=>()=>{
            setThirdPartyFieldMapping(thirdPartyField.fieldId, {
                ...newField,
                fieldName: thirdPartyField.fieldName
            });
            setUIState({
                hasUnsavedFieldMappingChanges: true
            });
        }, [
        setThirdPartyFieldMapping,
        thirdPartyField.fieldId,
        thirdPartyField.fieldName,
        setUIState
    ]);
    const availableNewFieldItems = (0, $eUqFw.useMemo)(()=>compatibleNewFieldTypes.map((newFieldType)=>({
                fieldType: newFieldType,
                fieldName: formatMessage((0, $hlez9.getDescriptorForNewFieldType)(newFieldType)),
                fieldId: null
            })).map((newField)=>{
            const isSelected = !mappedJiraField.fieldId && newField.fieldType === mappedJiraField.fieldType;
            const descriptionMessage = (0, $hlez9.getDescriptionForNewFieldType)(newField.fieldType);
            const description = descriptionMessage ? formatMessage(descriptionMessage) : undefined;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1XXvr.FieldSelectorItem), {
                key: newField.fieldType,
                name: formatMessage((0, $hlez9.getDescriptorForNewFieldType)(newField.fieldType)),
                description: description,
                icon: (0, $hlez9.getIcon)({
                    fieldType: newField.fieldType,
                    isSelected: isSelected
                }),
                isSelected: isSelected,
                onClick: handleDropdownItemClickFactory(newField)
            });
        }), [
        compatibleNewFieldTypes,
        formatMessage,
        handleDropdownItemClickFactory,
        mappedJiraField.fieldId,
        mappedJiraField.fieldType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Pq2D.default), {
        autoFocus: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), {
        testId: `${(0, $kzTj7.THIRD_PARTY_FIELD_SELECTOR_TEST_ID_PREFIX)}.new-custom-fields-section.dropdown-item-group`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cb3f567d58fa1fd5$var$GoBackWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4GOUU))), {
            label: "",
            primaryColor: `var(--ds-icon-subtle, ${(0, $PdmhA).N300})`
        }),
        appearance: "subtle",
        spacing: "none",
        onClick: onClickGoBack,
        testId: `${(0, $kzTj7.THIRD_PARTY_FIELD_SELECTOR_TEST_ID_PREFIX)}.new-custom-fields-section.button`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cb3f567d58fa1fd5$var$GoBackContent, null, formatMessage((0, $dnTYt.default).goBack))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1VyqP.DropdownSectionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1VyqP.DropdownSectionHeader), null, formatMessage((0, $dnTYt.default).selectCustomFieldHeading))), availableNewFieldItems));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cb3f567d58fa1fd5$var$GoBackWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1yt4h8dc _1py61ssb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cb3f567d58fa1fd5$var$GoBackContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1n3s _1p1dangw _1dmzcv93 _1wyb1skh _vwz4dlk8 _18u0u2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dnTYt", function(module, exports) {

$parcel$export(module.exports, "default", () => $468f47774cc2fd4f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $468f47774cc2fd4f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    goBack: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.field-selector.new-custom-fields-section.go-back",
        "defaultMessage": "Create a new custom field"
    },
    selectCustomFieldHeading: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.field-selector.new-custom-fields-section.select-custom-field-heading",
        "defaultMessage": "Select a custom field type"
    }
});

});



parcelRegister("yF36J", function(module, exports) {

$parcel$export(module.exports, "default", () => $b98242a0515fae8c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $e270j = parcelRequire("e270j");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kzTj7 = parcelRequire("kzTj7");

var $klvFM = parcelRequire("klvFM");

var $a6DaD = parcelRequire("a6DaD");

var $cuqXL = parcelRequire("cuqXL");

var $es1tu = parcelRequire("es1tu");

var $irjtd = parcelRequire("irjtd");

var $bEtNM = parcelRequire("bEtNM");
const $b98242a0515fae8c$var$useWarningMessage = (fieldId, isToggleDisabled, isIncluded)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    switch(fieldId){
        case 0, $a6DaD.ASANA_ASSIGNEE_FIELD_ID:
            return !isIncluded && formatMessage((0, $bEtNM.default).excludeAssignee);
        case 0, $a6DaD.ASANA_DUE_ON_FIELD_ID:
            return !isIncluded && formatMessage((0, $bEtNM.default).excludeDueDate, {
                link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                        href: (0, $kzTj7.LEARN_MORE_ABOUT_TIMELINE),
                        target: "_blank"
                    }, chunks)
            });
        case 0, $a6DaD.ASANA_START_DATE_FIELD_ID:
            return !isIncluded && formatMessage((0, $bEtNM.default).excludeStartDate, {
                link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                        href: (0, $kzTj7.LEARN_MORE_ABOUT_TIMELINE),
                        target: "_blank"
                    }, chunks)
            });
        case 0, $a6DaD.ASANA_LIKES_FIELD_ID:
            return !isIncluded && isToggleDisabled && formatMessage((0, $bEtNM.default).votesDisableMessage);
        case 0, $cuqXL.CLICKUP_DESCRIPTION:
            return isIncluded && formatMessage((0, $bEtNM.default).clickupDescriptionRichText);
        case 0, $cuqXL.CLICKUP_START_DATE:
            return isIncluded && formatMessage((0, $bEtNM.default).clickupStartDateRecurring);
        default:
            return undefined;
    }
};
const $b98242a0515fae8c$var$IncludeInImport = ({ thirdPartyFieldMapping: thirdPartyFieldMapping })=>{
    const warningMessage = $b98242a0515fae8c$var$useWarningMessage(thirdPartyFieldMapping.thirdPartyField.fieldId, thirdPartyFieldMapping.mappingContext.isToggleDisabled, thirdPartyFieldMapping.mappingContext.isIncluded);
    const [, { setIsThirdPartyFieldIncluded: setIsThirdPartyFieldIncluded }] = (0, $es1tu.useThirdPartyFieldConfigState)();
    const [, { setUIState: setUIState }] = (0, $irjtd.useUIState)();
    const handleToggleChange = (0, $eUqFw.useCallback)((value)=>{
        setIsThirdPartyFieldIncluded(thirdPartyFieldMapping.thirdPartyField.fieldId, value.target.checked);
        setUIState({
            hasUnsavedFieldMappingChanges: true
        });
    }, [
        setIsThirdPartyFieldIncluded,
        thirdPartyFieldMapping.thirdPartyField.fieldId,
        setUIState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b98242a0515fae8c$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e270j.default), {
        testId: "project-create-importer-upload-flow.ui.third-party-review-screen.fields-mapping.fields-mapping-content.include-in-import.toggle",
        isChecked: thirdPartyFieldMapping.mappingContext.isIncluded,
        isDisabled: thirdPartyFieldMapping.mappingContext.isRequired || thirdPartyFieldMapping.mappingContext.isToggleDisabled,
        onChange: handleToggleChange,
        label: "include-in-import-toggle"
    }), warningMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $klvFM.InfoTooltip), {
        tooltipContent: warningMessage
    }));
};
var $b98242a0515fae8c$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $b98242a0515fae8c$var$IncludeInImport;
const $b98242a0515fae8c$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0xy5q _1e0c1txw _4cvr1h6o _29hzu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("klvFM", function(module, exports) {

$parcel$export(module.exports, "InfoTooltip", () => $239327a31bee96ff$export$dbdcde5ca046596e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $aUqTb = parcelRequire("aUqTb");

var $8cU5f = parcelRequire("8cU5f");
var $g3tFP = parcelRequire("g3tFP");

var $5JgJ2 = parcelRequire("5JgJ2");

var $biCbu = parcelRequire("biCbu");
const $239327a31bee96ff$export$dbdcde5ca046596e = ({ tooltipContent: tooltipContent, position: position })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ), {
        component: $239327a31bee96ff$var$InlineDialog,
        content: tooltipContent,
        position: position
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($239327a31bee96ff$var$StyledButton, {
        "aria-label": formatMessage((0, $biCbu.default).infoLabel),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aUqTb))), {
            label: ""
        }),
        testId: "project-create-importer-upload-flow.common.ui.info-tooltip.info",
        appearance: "subtle"
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $239327a31bee96ff$var$StyledButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_u1mbqkzo _il4vvuon",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $239327a31bee96ff$var$InlineDialog = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $g3tFP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11q7vuon _2rko1y44 _16qs1mxi _c71l1mjv _p12f1mjv _vchh18uv _1yt4pxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aUqTb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f13fdf9f823d771$var$_react = $7f13fdf9f823d771$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $7f13fdf9f823d771$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $7f13fdf9f823d771$var$EditorPanelIcon = (props)=>/*#__PURE__*/ $7f13fdf9f823d771$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12 19a7 7 0 110-14 7 7 0 010 14zm0-1.5a5.5 5.5 0 100-11 5.5 5.5 0 000 11zm0-6a1 1 0 011 1v2a1 1 0 01-2 0v-2a1 1 0 011-1zm0-3a1 1 0 110 2 1 1 0 010-2z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$7f13fdf9f823d771$var$EditorPanelIcon.displayName = 'EditorPanelIcon';
var $7f13fdf9f823d771$var$_default = $7f13fdf9f823d771$var$EditorPanelIcon;
module.exports.default = $7f13fdf9f823d771$var$_default;

});

parcelRegister("biCbu", function(module, exports) {

$parcel$export(module.exports, "default", () => $14435cb2354ff542$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $14435cb2354ff542$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    infoLabel: {
        "id": "project-create-importer-upload-flow.common.info-tooltip.info-label",
        "defaultMessage": "Info"
    }
});

});


parcelRegister("bEtNM", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ce5ecdd65bf5c4f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2ce5ecdd65bf5c4f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    excludeAssignee: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.include-in-import.exclude-assignee",
        "defaultMessage": "Import this field to make sure assignees are displayed in issues, comments, and tags."
    },
    excludeDueDate: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.include-in-import.exclude-due-date",
        "defaultMessage": "Import this field to see your issues in timeline view. <link>Learn more about timeline view</link>"
    },
    excludeStartDate: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.include-in-import.exclude-start-date",
        "defaultMessage": "Import this field to make sure timeline view is accurate for your project. <link>Learn more about timeline view</link>"
    },
    votesDisableMessage: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.include-in-import.votes-disable-message",
        "defaultMessage": "To import Likes enable Votes in Settings > System > General Configuration > Options"
    },
    clickupDescriptionRichText: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.include-in-import.clickup-description-rich-text",
        "defaultMessage": "Rich text formatting will not be imported"
    },
    clickupStartDateRecurring: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-content.include-in-import.clickup-start-date-recurring",
        "defaultMessage": "Recurring dates and time will not be imported"
    }
});

});




parcelRegister("klv54", function(module, exports) {

$parcel$export(module.exports, "FieldsMappingHeader", () => $69260239d6b16a43$export$bb849e8e6033fad3);

var $eUqFw = parcelRequire("eUqFw");

var $h6FFs = parcelRequire("h6FFs");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $4kMup = parcelRequire("4kMup");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1VyqP = parcelRequire("1VyqP");

var $cDLTA = parcelRequire("cDLTA");
var $aWLVm = parcelRequire("aWLVm");

var $d0wrd = parcelRequire("d0wrd");
var $es1tu = parcelRequire("es1tu");

var $1rYiW = parcelRequire("1rYiW");
const $69260239d6b16a43$export$bb849e8e6033fad3 = ({ thirdParty: thirdParty })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { fieldsMappingPageDescription: fieldsMappingPageDescription, fieldsMappingPageDisclaimer: fieldsMappingPageDisclaimer } = (0, $cDLTA.useContentForThirdParty)(thirdParty);
    const [{ type: type }] = (0, $d0wrd.useProjectData)();
    const { fieldURL: fieldURL, customFieldURL: customFieldURL, fieldMappingURL: fieldMappingURL } = (0, $aWLVm.useUrlForThirdParty)(thirdParty, type);
    const [{ hasUnsupportedFieldFiltered: hasUnsupportedFieldFiltered }] = (0, $es1tu.useThirdPartyFieldsIncludedState)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1VyqP.SectionHeading), null, formatMessage((0, $1rYiW.default).heading)), fieldsMappingPageDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $69260239d6b16a43$var$descriptionStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        color: "color.text.subtle"
    }, formatMessage(fieldsMappingPageDescription, {
        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4kMup.default), {
                href: fieldURL,
                target: "_blank"
            }, chunks),
        customFieldLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4kMup.default), {
                href: customFieldURL,
                target: "_blank"
            }, chunks)
    }))), hasUnsupportedFieldFiltered !== false && fieldsMappingPageDisclaimer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $69260239d6b16a43$var$disclaimerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.075",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: $69260239d6b16a43$var$infoIconWrapper,
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h6FFs))), {
        label: "",
        color: "var(--ds-icon-information, #1D7AFC)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        size: "UNSAFE_small",
        color: "color.text.subtle"
    }, formatMessage(fieldsMappingPageDisclaimer, {
        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4kMup.default), {
                href: fieldMappingURL,
                target: "_blank"
            }, chunks)
    })))));
};
const $69260239d6b16a43$var$descriptionStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.100'
});
const $69260239d6b16a43$var$disclaimerStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.150'
});
const $69260239d6b16a43$var$infoIconWrapper = (0, $1ZAYh.xcss)({
    alignSelf: 'start'
});

});
parcelRegister("h6FFs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c743518dce4b322a$var$_react = $c743518dce4b322a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c743518dce4b322a$var$_UNSAFE_baseNew = $c743518dce4b322a$var$_interopRequireDefault((parcelRequire("gCIXy")));
function $c743518dce4b322a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are a work in progress and subject to change or removal in future minor or patch releases.
 * Please reach out in #help-design-system before using these in production.
 *
 * Icon: "Information".
 * Category: Single-purpose
 * Location: ADS
 * Usage guidance: Known uses: helper message under textfield, information state insection messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c743518dce4b322a$var$InformationIcon = (props)=>/*#__PURE__*/ $c743518dce4b322a$var$_react.default.createElement($c743518dce4b322a$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentColor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$c743518dce4b322a$var$InformationIcon.displayName = 'InformationIcon';
var $c743518dce4b322a$var$_default = module.exports.default = $c743518dce4b322a$var$InformationIcon;

});

parcelRegister("1rYiW", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a4d17f160ee3123$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2a4d17f160ee3123$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    heading: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.fields-mapping.fields-mapping-header.heading",
        "defaultMessage": "Field mapping"
    }
});

});



parcelRegister("7MbnE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e622df40328ed88e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e622df40328ed88e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    heading: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.heading",
        "defaultMessage": "Review details"
    },
    backToReview: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.back-to-review",
        "defaultMessage": "Back to review details"
    }
});

});

parcelRegister("iUOit", function(module, exports) {

$parcel$export(module.exports, "ProjectHierarchy", () => $25e5a0e751ffd0bc$export$60df9eb90d448b7f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $2bv8J = parcelRequire("2bv8J");

var $b5IAe = parcelRequire("b5IAe");
var $27KYr = parcelRequire("27KYr");
var $1ZAYh = parcelRequire("1ZAYh");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3ak5x = parcelRequire("3ak5x");

var $1VyqP = parcelRequire("1VyqP");

var $cDLTA = parcelRequire("cDLTA");
var $aWLVm = parcelRequire("aWLVm");

var $antP2 = parcelRequire("antP2");

var $d0wrd = parcelRequire("d0wrd");
var $9HbMH = parcelRequire("9HbMH");

var $gAND3 = parcelRequire("gAND3");
var $9PmM8 = parcelRequire("9PmM8");

var $hwp26 = parcelRequire("hwp26");

var $9OEBu = parcelRequire("9OEBu");
const $25e5a0e751ffd0bc$var$getProjectHierarchyIllustration = (thirdParty)=>{
    switch(thirdParty){
        case 0, $3ak5x.MONDAY:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9PmM8.MondayHierarchy), null);
        case 0, $3ak5x.ASANA:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gAND3.AsanaHierarchy), null);
        default:
            return null;
    }
};
const $25e5a0e751ffd0bc$export$60df9eb90d448b7f = ({ thirdParty: thirdParty })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [data] = (0, $9HbMH.useThirdPartyHierarchyState)({
        types: (0, $antP2.getHierarchyMappingItems)(thirdParty),
        formatMessage: formatMessage
    });
    // return ProjectHierarchyMapping for clickup importer
    // remove fg('jwm_clickup_importer') when clean up ff('jwm-x2c-hierarchy-mapping_kkjnd')
    if ((0, $1ybV0.ff)('jwm-x2c-hierarchy-mapping_kkjnd') || (0, $eI5EY.fg)('jwm_clickup_importer')) {
        if (data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($25e5a0e751ffd0bc$export$922a3a1eae9d3db0, {
            thirdParty: thirdParty
        });
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($25e5a0e751ffd0bc$var$ProjectHierarchyIllustration, {
        thirdParty: thirdParty
    });
};
const $25e5a0e751ffd0bc$var$ProjectHierarchyIllustration = ({ thirdParty: thirdParty })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const illustration = $25e5a0e751ffd0bc$var$getProjectHierarchyIllustration(thirdParty);
    const { hierarchyPageDescription: hierarchyPageDescription } = (0, $cDLTA.useContentForThirdParty)(thirdParty);
    const { hierarchyPageDescriptionURL: hierarchyPageDescriptionURL } = (0, $aWLVm.useUrlForThirdParty)(thirdParty);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($25e5a0e751ffd0bc$var$Wrapper, {
        "data-testid": "project-create-importer-upload-flow.ui.third-party-review-screen.project-hierarchy.wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1VyqP.SectionHeading), null, formatMessage((0, $hwp26.default).heading)), illustration && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($25e5a0e751ffd0bc$var$ImageWrapper, null, illustration), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($25e5a0e751ffd0bc$var$ContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2bv8J))), {
        label: "",
        primaryColor: "var(--ds-background-accent-gray-subtle, #8590A2)"
    }), hierarchyPageDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($25e5a0e751ffd0bc$var$Description, null, formatMessage(hierarchyPageDescription, {
        ul: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($25e5a0e751ffd0bc$var$StyledUl, null, chunks),
        li: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", null, chunks),
        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                href: hierarchyPageDescriptionURL,
                target: "_blank"
            }, chunks)
    }))));
};
const $25e5a0e751ffd0bc$export$922a3a1eae9d3db0 = ({ thirdParty: thirdParty })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ type: type }] = (0, $d0wrd.useProjectData)();
    const { hierarchyMappingDescription: hierarchyMappingDescription } = (0, $cDLTA.useContentForThirdParty)(thirdParty);
    const { hierarchyPageDescriptionURL: hierarchyPageDescriptionURL } = (0, $aWLVm.useUrlForThirdParty)(thirdParty, type);
    const tableHead = (0, $9OEBu.useTableHead)(thirdParty);
    const tableRows = (0, $9OEBu.useTableRows)(thirdParty);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $25e5a0e751ffd0bc$var$contentWrapperStyles,
        testId: "project-create-importer-upload-flow.ui.third-party-review-screen.project-hierarchy.wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1VyqP.SectionHeading), null, formatMessage((0, $hwp26.default).heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingBlockStart: "space.200",
        paddingBlockEnd: "space.300"
    }, hierarchyMappingDescription && formatMessage(hierarchyMappingDescription, {
        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                href: hierarchyPageDescriptionURL,
                target: "_blank"
            }, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27KYr.default), {
        rowGap: "space.100",
        role: "table",
        testId: "project-create-importer-upload-flow.ui.third-party-review-screen.project-hierarchy.table"
    }, tableHead, tableRows));
};
const $25e5a0e751ffd0bc$var$contentWrapperStyles = (0, $1ZAYh.xcss)({
    width: '480px',
    paddingTop: 'space.300'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $25e5a0e751ffd0bc$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1n261q9c _vchhusvi _1yt41oq0 _1bsb1fdn",
            __cmplp.className
        ])
    });
});
const $25e5a0e751ffd0bc$var$ImageWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _18s8zu5n _bfhk10p6 _2rko1y44 _1yt4v47k",
            __cmplp.className
        ])
    });
});
const $25e5a0e751ffd0bc$var$ContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _18u01ejb",
            __cmplp.className
        ])
    });
});
const $25e5a0e751ffd0bc$var$Description = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _11c81oud _syaz1a45 _18u0u2gc _16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});
const $25e5a0e751ffd0bc$var$StyledUl = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bozg1ejb _otyr1ejb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gAND3", function(module, exports) {

$parcel$export(module.exports, "AsanaHierarchy", () => $b77713c5e76e14ef$export$e81ad0bc8d0785);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $77CtJ = parcelRequire("77CtJ");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $70vb9 = parcelRequire("70vb9");

var $cToOX = parcelRequire("cToOX");
const $b77713c5e76e14ef$export$e81ad0bc8d0785 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b77713c5e76e14ef$var$HeaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b77713c5e76e14ef$var$Image, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($70vb9))),
        "aria-label": "Asana",
        role: "img",
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b77713c5e76e14ef$var$AsanaHeader, null, formatMessage((0, $cToOX.default).asanaHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77CtJ.JiraIcon), {
        size: "small",
        appearance: "brand"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $b77713c5e76e14ef$var$jiraHeaderStyles
    }, formatMessage((0, $cToOX.default).jiraHeadingSpork))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "574",
        height: "141",
        viewBox: "0 0 574 141",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "img",
        "aria-label": formatMessage((0, $cToOX.default).illustrationLabelSpork)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "AsanaHierarchy"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "Asana"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        id: "Background",
        width: "270",
        height: "141",
        rx: "6",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "Subsubtask"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "check-circle-outline"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "24.1791",
        height: "24",
        transform: "translate(117 110)",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M129.09 113C134.097 113 138.157 117.029 138.157 122C138.157 126.971 134.097 131 129.09 131C124.082 131 120.022 126.971 120.022 122C120.022 117.029 124.082 113 129.09 113ZM129.09 115C125.195 115 122.037 118.134 122.037 122C122.037 125.866 125.195 129 129.09 129C132.984 129 136.142 125.866 136.142 122C136.142 118.134 132.984 115 129.09 115ZM132.736 119.215L132.824 119.293C133.19 119.656 133.216 120.227 132.903 120.62L132.824 120.707L128.794 124.707C128.429 125.07 127.853 125.096 127.458 124.785L127.37 124.707L125.355 122.707C124.961 122.317 124.961 121.683 125.355 121.293C125.72 120.93 126.296 120.904 126.692 121.215L126.78 121.293L128.082 122.585L131.4 119.293C131.765 118.93 132.341 118.904 132.736 119.215Z",
        fill: "#626F86"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "#172B4D",
        xmlSpace: "preserve",
        fontSize: "14",
        fontWeight: "500",
        letterSpacing: "0px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
        x: "146.216",
        y: "127.477"
    }, formatMessage((0, $cToOX.default).asanaSubtask))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M217.298 117V123C217.298 124.933 218.865 126.5 220.798 126.5H225.858V126.028C225.873 127.12 226.769 128 227.873 128C228.986 128 229.888 127.105 229.888 126C229.888 124.895 228.986 124 227.873 124C226.769 124 225.873 124.88 225.858 125.972V125.5H220.798C219.418 125.5 218.298 124.381 218.298 123V121.5H225.921C226.145 122.363 226.934 123 227.873 123C228.986 123 229.888 122.105 229.888 121C229.888 119.895 228.986 119 227.873 119C226.934 119 226.145 119.637 225.921 120.5H218.298V117H217.298ZM227.873 122C228.44 122 228.888 121.545 228.888 121C228.888 120.455 228.44 120 227.873 120C227.305 120 226.858 120.455 226.858 121C226.858 121.545 227.305 122 227.873 122ZM228.888 126C228.888 126.545 228.44 127 227.873 127C227.305 127 226.858 126.545 226.858 126C226.858 125.455 227.305 125 227.873 125C228.44 125 228.888 125.455 228.888 126Z",
        fill: "#44546F"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("line", {
        x1: "20",
        y1: "104.5",
        x2: "247.687",
        y2: "104.5",
        stroke: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "Subtask"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "check-circle-outline"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "24.1791",
        height: "24",
        transform: "translate(86.4927 76)",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M98.5822 79C103.59 79 107.649 83.0294 107.649 88C107.649 92.9706 103.59 97 98.5822 97C93.5746 97 89.5151 92.9706 89.5151 88C89.5151 83.0294 93.5746 79 98.5822 79ZM98.5822 81C94.6874 81 91.53 84.134 91.53 88C91.53 91.866 94.6874 95 98.5822 95C102.477 95 105.634 91.866 105.634 88C105.634 84.134 102.477 81 98.5822 81ZM102.229 85.2152L102.317 85.2929C102.682 85.6555 102.708 86.2274 102.395 86.6199L102.317 86.7071L98.2871 90.7071C97.9218 91.0697 97.3457 91.0956 96.9503 90.7848L96.8624 90.7071L94.8475 88.7071C94.454 88.3166 94.454 87.6834 94.8475 87.2929C95.2128 86.9303 95.7889 86.9044 96.1843 87.2152L96.2722 87.2929L97.5749 88.5853L100.892 85.2929C101.258 84.9303 101.834 84.9044 102.229 85.2152Z",
        fill: "#626F86"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "#172B4D",
        xmlSpace: "preserve",
        fontSize: "14",
        fontWeight: "500",
        letterSpacing: "0px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
        x: "115.709",
        y: "93.4766"
    }, formatMessage((0, $cToOX.default).asanaSubtask))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M186.791 83V89C186.791 90.933 188.358 92.5 190.291 92.5H195.351V92.0282C195.366 93.1198 196.262 94 197.365 94C198.478 94 199.38 93.1046 199.38 92C199.38 90.8954 198.478 90 197.365 90C196.262 90 195.366 90.8802 195.351 91.9718V91.5H190.291C188.91 91.5 187.791 90.3807 187.791 89V87.5H195.414C195.638 88.3626 196.427 89 197.365 89C198.478 89 199.38 88.1046 199.38 87C199.38 85.8954 198.478 85 197.365 85C196.427 85 195.638 85.6374 195.414 86.5H187.791V83H186.791ZM197.365 88C197.933 88 198.38 87.5453 198.38 87C198.38 86.4547 197.933 86 197.365 86C196.798 86 196.351 86.4547 196.351 87C196.351 87.5453 196.798 88 197.365 88ZM198.38 92C198.38 92.5453 197.933 93 197.365 93C196.798 93 196.351 92.5453 196.351 92C196.351 91.4547 196.798 91 197.365 91C197.933 91 198.38 91.4547 198.38 92Z",
        fill: "#44546F"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("line", {
        x1: "20",
        y1: "70.5",
        x2: "247.687",
        y2: "70.5",
        stroke: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "Task"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M42.9711 57.8007L37.8421 52.7097C37.2085 52.0808 37.6539 51 38.5466 51H48.8046C49.6973 51 50.1427 52.0809 49.5091 52.7097L44.3801 57.8007C43.9902 58.1878 43.361 58.1878 42.9711 57.8007Z",
        fill: "#626F86"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "24.1791",
        height: "24",
        transform: "translate(59.291 42)",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M71.3806 45C76.3882 45 80.4477 49.0294 80.4477 54C80.4477 58.9706 76.3882 63 71.3806 63C66.3729 63 62.3134 58.9706 62.3134 54C62.3134 49.0294 66.3729 45 71.3806 45ZM71.3806 47C67.4857 47 64.3283 50.134 64.3283 54C64.3283 57.866 67.4857 61 71.3806 61C75.2754 61 78.4328 57.866 78.4328 54C78.4328 50.134 75.2754 47 71.3806 47ZM75.0275 51.2152L75.1153 51.2929C75.4807 51.6555 75.5068 52.2274 75.1936 52.6199L75.1153 52.7071L71.0855 56.7071C70.7201 57.0697 70.144 57.0956 69.7486 56.7848L69.6607 56.7071L67.6458 54.7071C67.2524 54.3166 67.2524 53.6834 67.6458 53.2929C68.0111 52.9303 68.5872 52.9044 68.9827 53.2152L69.0705 53.2929L70.3733 54.5853L73.6906 51.2929C74.0559 50.9303 74.632 50.9044 75.0275 51.2152Z",
        fill: "#626F86"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "#172B4D",
        xmlSpace: "preserve",
        fontSize: "14",
        fontWeight: "500",
        letterSpacing: "0px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
        x: "88.5073",
        y: "60.4766"
    }, formatMessage((0, $cToOX.default).asanaTask))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M135.403 50V56C135.403 57.933 136.97 59.5 138.903 59.5H143.963V59.0282C143.978 60.1198 144.874 61 145.977 61C147.09 61 147.992 60.1046 147.992 59C147.992 57.8954 147.09 57 145.977 57C144.874 57 143.978 57.8802 143.963 58.9718V58.5H138.903C137.522 58.5 136.403 57.3807 136.403 56V54.5H144.026C144.249 55.3626 145.038 56 145.977 56C147.09 56 147.992 55.1046 147.992 54C147.992 52.8954 147.09 52 145.977 52C145.038 52 144.249 52.6374 144.026 53.5H136.403V50H135.403ZM145.977 55C146.545 55 146.992 54.5453 146.992 54C146.992 53.4547 146.545 53 145.977 53C145.41 53 144.962 53.4547 144.962 54C144.962 54.5453 145.41 55 145.977 55ZM146.992 59C146.992 59.5453 146.545 60 145.977 60C145.41 60 144.962 59.5453 144.962 59C144.962 58.4547 145.41 58 145.977 58C146.545 58 146.992 58.4547 146.992 59Z",
        fill: "#44546F"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("line", {
        x1: "20",
        y1: "36.5",
        x2: "247.687",
        y2: "36.5",
        stroke: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "Section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "#172B4D",
        xmlSpace: "preserve",
        fontSize: "14",
        fontWeight: "600",
        letterSpacing: "0px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
        x: "61.3062",
        y: "23.9766"
    }, formatMessage((0, $cToOX.default).asanaSection))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M42.9711 22.8007L37.8421 17.7097C37.2085 17.0808 37.6539 16 38.5466 16H48.8046C49.6973 16 50.1427 17.0809 49.5091 17.7097L44.3801 22.8007C43.9902 23.1878 43.361 23.1878 42.9711 22.8007Z",
        fill: "#626F86"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "arrow-right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "32",
        height: "32",
        transform: "translate(271 42)",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M287.391 65.6094C286.91 65.1288 286.873 64.3725 287.28 63.8494L287.391 63.7239L291.78 59.3346L279 59.3333C278.264 59.3333 277.667 58.7364 277.667 58C277.667 57.3162 278.181 56.7526 278.845 56.6756L279 56.6666L291.783 56.668L287.391 52.2761C286.91 51.7955 286.873 51.0392 287.28 50.5161L287.391 50.3905C287.871 49.9099 288.627 49.8729 289.151 50.2796L289.276 50.3905L295.943 57.0572L296.04 57.1661C296.044 57.1699 296.047 57.1738 296.05 57.1776L295.943 57.0572C295.99 57.1044 296.033 57.1542 296.072 57.2062C296.095 57.2384 296.118 57.2717 296.139 57.3058C296.149 57.3219 296.158 57.3381 296.167 57.3546C296.182 57.3809 296.196 57.4081 296.208 57.4359C296.219 57.4585 296.229 57.4816 296.238 57.5049C296.249 57.5312 296.259 57.5576 296.267 57.5844C296.274 57.6042 296.28 57.6247 296.286 57.6453C296.294 57.6741 296.3 57.703 296.306 57.7322C296.311 57.7555 296.315 57.7788 296.319 57.8021C296.323 57.8274 296.326 57.8535 296.328 57.8799C296.331 57.912 296.332 57.9431 296.333 57.9742C296.333 57.982 296.333 57.991 296.333 58L296.333 58.0258C296.332 58.0569 296.331 58.088 296.328 58.119L296.333 58C296.333 58.0675 296.328 58.1338 296.319 58.1986C296.315 58.2213 296.311 58.2445 296.306 58.2676C296.3 58.297 296.294 58.3259 296.286 58.3545C296.28 58.3753 296.274 58.3958 296.267 58.4162C296.259 58.4424 296.249 58.4687 296.239 58.4947C296.229 58.5183 296.219 58.5414 296.208 58.5643C296.196 58.5918 296.182 58.619 296.167 58.6457C296.158 58.6618 296.149 58.6781 296.139 58.6942C296.118 58.7283 296.095 58.7615 296.072 58.7935C296.066 58.8016 296.06 58.8094 296.054 58.8172C296.016 58.8646 295.981 58.9048 295.943 58.9428L289.276 65.6094C288.755 66.1301 287.911 66.1301 287.391 65.6094Z",
        fill: "var(--ds-text-subtle, #44546F)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "JWM hierarchy"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        clipPath: "url(#clip0_1_123)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "304",
        width: "270",
        height: "141",
        fill: "#CCE0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M531 84H538H542C543.657 84 545 85.3431 545 87V116C545 117.657 543.657 119 542 119H531",
        stroke: "#0052CC",
        strokeLinejoin: "round",
        strokeDasharray: "3 3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "Link"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "24",
        height: "24",
        transform: "translate(534 89)",
        fill: "#CCE0FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M546.654 97.764C546.492 97.9181 546.276 98.0028 546.052 98C545.828 97.9971 545.615 97.9069 545.456 97.7487C545.298 97.5905 545.208 97.3767 545.205 97.153C545.202 96.9292 545.287 96.7132 545.441 96.551L546.655 95.337C547 94.9918 547.41 94.718 547.861 94.5311C548.312 94.3443 548.795 94.2481 549.284 94.2481C549.772 94.2481 550.255 94.3443 550.706 94.5311C551.157 94.718 551.567 94.9918 551.912 95.337C552.258 95.6819 552.532 96.0916 552.719 96.5427C552.907 96.9938 553.003 97.4774 553.003 97.9658C553.003 98.4542 552.907 98.9378 552.72 99.389C552.533 99.8401 552.259 100.25 551.913 100.595L550.699 101.809L549.895 102.613C549.55 102.959 549.14 103.234 548.689 103.421C548.237 103.609 547.753 103.706 547.265 103.706C546.776 103.707 546.292 103.611 545.84 103.424C545.388 103.237 544.978 102.963 544.632 102.618C544.471 102.457 544.381 102.239 544.381 102.011C544.381 101.783 544.471 101.565 544.632 101.404C544.793 101.243 545.011 101.153 545.239 101.153C545.467 101.153 545.685 101.243 545.846 101.404C546.627 102.186 547.896 102.184 548.682 101.399L549.486 100.596L550.7 99.382C550.886 99.1963 551.034 98.9757 551.135 98.7327C551.236 98.4898 551.288 98.2293 551.287 97.9663C551.287 97.7033 551.235 97.4429 551.134 97.2C551.033 96.9571 550.885 96.7366 550.699 96.551C550.513 96.3651 550.293 96.2175 550.05 96.1169C549.807 96.0162 549.547 95.9644 549.284 95.9644C549.021 95.9644 548.761 96.0162 548.518 96.1169C548.275 96.2175 548.055 96.3651 547.869 96.551L546.654 97.764V97.764ZM545.846 104.236C546.008 104.082 546.224 103.997 546.448 104C546.672 104.003 546.885 104.093 547.044 104.251C547.202 104.41 547.292 104.623 547.295 104.847C547.298 105.071 547.213 105.287 547.059 105.449L545.845 106.663C545.5 107.008 545.09 107.282 544.639 107.469C544.188 107.656 543.705 107.752 543.217 107.752C542.728 107.752 542.245 107.656 541.794 107.469C541.343 107.282 540.933 107.008 540.588 106.663C540.242 106.318 539.968 105.908 539.781 105.457C539.593 105.006 539.497 104.523 539.497 104.034C539.497 103.546 539.593 103.062 539.78 102.611C539.967 102.16 540.241 101.75 540.587 101.405L541.801 100.191L542.605 99.387C542.95 99.0409 543.36 98.7663 543.811 98.5787C544.263 98.3911 544.747 98.2943 545.235 98.2939C545.724 98.2934 546.208 98.3893 546.66 98.576C547.112 98.7627 547.522 99.0366 547.868 99.382C548.029 99.543 548.119 99.7613 548.119 99.989C548.119 100.217 548.029 100.435 547.868 100.596C547.707 100.757 547.489 100.847 547.261 100.847C547.033 100.847 546.815 100.757 546.654 100.596C546.467 100.41 546.246 100.263 546.003 100.162C545.759 100.062 545.498 100.011 545.235 100.011C544.972 100.011 544.711 100.064 544.468 100.165C544.225 100.266 544.004 100.414 543.818 100.601L543.014 101.404L541.8 102.618C541.614 102.804 541.466 103.024 541.365 103.267C541.264 103.51 541.213 103.771 541.213 104.034C541.213 104.297 541.265 104.557 541.366 104.8C541.467 105.043 541.615 105.263 541.801 105.449C541.987 105.635 542.207 105.782 542.45 105.883C542.693 105.984 542.953 106.036 543.216 106.036C543.479 106.036 543.739 105.984 543.982 105.883C544.225 105.782 544.445 105.635 544.631 105.449L545.846 104.236Z",
        fill: "#0C66E4"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "Subtask2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        id: "Rectangle 1395",
        d: "M325 109C325 105.686 327.686 103 331 103H526C529.314 103 532 105.686 532 109V127C532 130.314 529.314 133 526 133H331C327.686 133 325 130.314 325 127V109Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "#626F86",
        xmlSpace: "preserve",
        fontSize: "14",
        fontWeight: "500",
        letterSpacing: "0px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
        x: "405",
        y: "123.084"
    }, formatMessage((0, $cToOX.default).jiraSubtask))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        clipPath: "url(#clip1_1_123)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M390 116.5V113.286C390 113.002 389.895 112.729 389.707 112.528C389.52 112.327 389.265 112.214 389 112.214H385C384.735 112.214 384.48 112.327 384.293 112.528C384.105 112.729 384 113.002 384 113.286V117.571C384 117.856 384.105 118.128 384.293 118.329C384.48 118.53 384.735 118.643 385 118.643H388V121.857C388 122.141 388.105 122.414 388.293 122.615C388.48 122.816 388.735 122.929 389 122.929H393C393.265 122.929 393.52 122.816 393.707 122.615C393.895 122.414 394 122.141 394 121.857V117.571C394 117.287 393.895 117.015 393.707 116.814C393.52 116.613 393.265 116.5 393 116.5H390ZM381 111.136C381 109.957 381.895 109 382.994 109H395.006C396.107 109 397 109.959 397 111.136V124.006C397 124.573 396.79 125.116 396.416 125.517C396.042 125.917 395.535 126.143 395.006 126.143H382.994C382.465 126.143 381.958 125.917 381.584 125.517C381.21 125.116 381 124.573 381 124.006V111.136ZM390 118.643H392V120.786H390V118.643ZM386 114.357H388V116.5H386V114.357Z",
        fill: "#2684FF"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "Subtask1"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        id: "Rectangle 1395_2",
        d: "M324 75C324 71.6863 326.686 69 330 69H525C528.314 69 531 71.6863 531 75V93C531 96.3137 528.314 99 525 99H330C326.686 99 324 96.3137 324 93V75Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "#626F86",
        xmlSpace: "preserve",
        fontSize: "14",
        fontWeight: "500",
        letterSpacing: "0px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
        x: "404",
        y: "88.9766"
    }, formatMessage((0, $cToOX.default).jiraSubtask))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        clipPath: "url(#clip2_1_123)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M389 83V80C389 79.7348 388.895 79.4804 388.707 79.2929C388.52 79.1054 388.265 79 388 79H384C383.735 79 383.48 79.1054 383.293 79.2929C383.105 79.4804 383 79.7348 383 80V84C383 84.2652 383.105 84.5196 383.293 84.7071C383.48 84.8946 383.735 85 384 85H387V88C387 88.2652 387.105 88.5196 387.293 88.7071C387.48 88.8946 387.735 89 388 89H392C392.265 89 392.52 88.8946 392.707 88.7071C392.895 88.5196 393 88.2652 393 88V84C393 83.7348 392.895 83.4804 392.707 83.2929C392.52 83.1054 392.265 83 392 83H389ZM380 77.994C380 76.893 380.895 76 381.994 76H394.006C395.107 76 396 76.895 396 77.994V90.006C396 90.5348 395.79 91.0418 395.416 91.4157C395.042 91.7896 394.535 91.9997 394.006 92H381.994C381.465 91.9997 380.958 91.7896 380.584 91.4157C380.21 91.0418 380 90.5348 380 90.006V77.994ZM389 85H391V87H389V85ZM385 81H387V83H385V81Z",
        fill: "#2684FF"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "Issue"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M324 41C324 37.6863 326.686 35 330 35H525C528.314 35 531 37.6863 531 41V59C531 62.3137 528.314 65 525 65H330C326.686 65 324 62.3137 324 59V41Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "#626F86",
        xmlSpace: "preserve",
        fontSize: "14",
        fontWeight: "500",
        letterSpacing: "0px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
        x: "380",
        y: "53.9766"
    }, formatMessage((0, $cToOX.default).jiraIssue))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        clipPath: "url(#clip3_1_123)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M356 43.6667C356 42.1939 357.194 41 358.667 41H369.333C370.806 41 372 42.1939 372 43.6667V54.3333C372 55.8061 370.806 57 369.333 57H358.667C357.194 57 356 55.8061 356 54.3333V43.6667Z",
        fill: "#4C9AFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M368.69 45.61C369.09 45.9913 369.105 46.6243 368.723 47.0238L363.874 52.1045C363.348 52.6548 362.47 52.6548 361.945 52.1045L359.277 49.3095C358.895 48.91 358.91 48.277 359.31 47.8957C359.709 47.5143 360.342 47.5291 360.723 47.9286L362.909 50.2184L367.277 45.6429C367.658 45.2434 368.291 45.2286 368.69 45.61Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "chevron-down"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "16",
        height: "16",
        transform: "translate(332 41)",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M337.528 47.862C337.403 47.9879 337.334 48.1579 337.334 48.335C337.334 48.5121 337.403 48.6821 337.528 48.808L339.487 50.7847C339.633 50.928 339.821 50.9993 340.007 50.9993C340.193 50.9993 340.377 50.928 340.519 50.7847L342.473 48.8147C342.597 48.6887 342.667 48.5187 342.667 48.3417C342.667 48.1646 342.597 47.9947 342.473 47.8687C342.411 47.8065 342.338 47.7572 342.258 47.7235C342.178 47.6899 342.091 47.6725 342.004 47.6725C341.917 47.6725 341.83 47.6899 341.75 47.7235C341.67 47.7572 341.597 47.8065 341.535 47.8687L340.003 49.4133L338.465 47.862C338.404 47.8001 338.331 47.751 338.251 47.7175C338.17 47.684 338.084 47.6667 337.997 47.6667C337.91 47.6667 337.823 47.684 337.743 47.7175C337.662 47.751 337.589 47.8001 337.528 47.862V47.862Z",
        fill: "#42526E"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "IssueStatus"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "325",
        y: "12",
        width: "88",
        height: "16",
        rx: "3",
        fill: "#DEEBFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "#0747A6",
        xmlSpace: "preserve",
        fontSize: "11",
        fontWeight: "bold",
        letterSpacing: "-0.084px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
        x: "329.184",
        y: "23.9102"
    }, formatMessage((0, $cToOX.default).jiraIssueStatus))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip0_1_123"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "304",
        width: "270",
        height: "141",
        rx: "6",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip1_1_123"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "16",
        height: "17.1429",
        fill: "white",
        transform: "translate(381 109)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip2_1_123"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "16",
        height: "16",
        fill: "white",
        transform: "translate(380 76)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip3_1_123"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "16",
        height: "16",
        fill: "white",
        transform: "translate(356 41)"
    })))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b77713c5e76e14ef$var$HeaderWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o _k48pni7l _1wyb1crf _vwz47vkz _syaz1dv3 _otyru2gc _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b77713c5e76e14ef$var$AsanaHeader = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01b66 _1bsb7rrr",
            __cmplp.className
        ])
    });
});
const $b77713c5e76e14ef$var$jiraHeaderStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.050'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b77713c5e76e14ef$var$Image = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1ejb _4t3i1ejb _u5f31b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cToOX", function(module, exports) {

$parcel$export(module.exports, "default", () => $74946d25efcf4f7c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $74946d25efcf4f7c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    asanaHeading: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.project-hierarchy.illustration.asana-hierarchy.asana-heading",
        "defaultMessage": "Asana"
    },
    jiraHeadingSpork: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.project-hierarchy.illustration.asana-hierarchy.jira-heading-spork",
        "defaultMessage": "Jira"
    },
    illustrationLabelSpork: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.project-hierarchy.illustration.asana-hierarchy.illustration-label-spork",
        "defaultMessage": "Visualization of how Asana fields are mapped to Jira."
    },
    asanaSection: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.project-hierarchy.illustration.asana-hierarchy.asana-section",
        "defaultMessage": "Section"
    },
    asanaTask: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.project-hierarchy.illustration.asana-hierarchy.asana-task",
        "defaultMessage": "Task 1 "
    },
    asanaSubtask: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.project-hierarchy.illustration.asana-hierarchy.asana-subtask",
        "defaultMessage": "Subtask 1"
    },
    jiraIssueStatus: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.project-hierarchy.illustration.asana-hierarchy.jira-issue-status",
        "defaultMessage": "ISSUE STATUS"
    },
    jiraIssue: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.project-hierarchy.illustration.asana-hierarchy.jira-issue",
        "defaultMessage": "Issue"
    },
    jiraSubtask: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.project-hierarchy.illustration.asana-hierarchy.jira-subtask",
        "defaultMessage": "Subtask"
    }
});

});


parcelRegister("9PmM8", function(module, exports) {

$parcel$export(module.exports, "MondayHierarchy", () => $ca2469eb881b6c7c$export$ee8614b3adad6d16);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $77CtJ = parcelRequire("77CtJ");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4HdID = parcelRequire("4HdID");

var $12QAT = parcelRequire("12QAT");
const $ca2469eb881b6c7c$export$ee8614b3adad6d16 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ca2469eb881b6c7c$var$HeaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ca2469eb881b6c7c$var$Image, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($4HdID))),
        "aria-label": "monday",
        role: "img",
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ca2469eb881b6c7c$var$MondayHeader, null, formatMessage((0, $12QAT.default).mondayHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77CtJ.JiraIcon), {
        size: "small",
        appearance: "brand"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $ca2469eb881b6c7c$var$jiraHeaderStyles
    }, formatMessage((0, $12QAT.default).jiraHeadingSpork))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "576",
        height: "116",
        viewBox: "0 0 576 116",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "img",
        "aria-label": formatMessage((0, $12QAT.default).illustrationLabel)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "MondayHierarchy"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "monday",
        clipPath: "url(#clip6_15_137)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "mondayBackground"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "270",
        height: "116",
        rx: "6",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "Image section view_2",
        clipPath: "url(#clip7_15_137)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "Group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "1",
        y: "4.21819",
        width: "209",
        height: "31.6364",
        rx: "6",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "#216E4E",
        xmlSpace: "preserve",
        fontSize: "14",
        fontWeight: "500",
        letterSpacing: "0px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
        x: "53",
        y: "25.1947"
    }, formatMessage((0, $12QAT.default).mondayGroup))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "Icon_4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "24",
        height: "24",
        transform: "translate(24 8.21819)",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M41.7071 17.5111C42.0697 17.8737 42.0956 18.4456 41.7848 18.8381L41.7071 18.9253L36.7071 23.9253C36.3444 24.2879 35.7726 24.3138 35.3801 24.003L35.2929 23.9253L30.2929 18.9253C29.9024 18.5348 29.9024 17.9016 30.2929 17.5111C30.6555 17.1485 31.2274 17.1226 31.6199 17.4334L31.7071 17.5111L36 21.8033L40.2928 17.5111C40.6555 17.1485 41.2273 17.1226 41.6199 17.4334L41.7071 17.5111Z",
        fill: "#216E4E"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "Item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M27 36.5H235C238.038 36.5 240.5 38.9624 240.5 42V61.6364C240.5 64.6739 238.038 67.1364 235 67.1364H27C23.9624 67.1364 21.5 64.6739 21.5 61.6364V42C21.5 38.9624 23.9624 36.5 27 36.5Z",
        stroke: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M21 41C21 38.7909 22.7909 37 25 37V37V67V67C22.7909 67 21 65.2091 21 63V41Z",
        fill: "#216E4E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "Nav Item_5"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "29",
        y: "36",
        width: "209",
        height: "31.6364",
        rx: "6",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "#626F86",
        xmlSpace: "preserve",
        fontSize: "14",
        fontWeight: "500",
        letterSpacing: "0px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
        x: "71",
        y: "56.9766"
    }, formatMessage((0, $12QAT.default).mondayItem))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "Icon_3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "24",
        height: "24",
        transform: "translate(40 40)",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M57.7071 49.2929C58.0697 49.6555 58.0956 50.2274 57.7848 50.6199L57.7071 50.7071L52.7071 55.7071C52.3444 56.0697 51.7726 56.0956 51.3801 55.7848L51.2929 55.7071L46.2929 50.7071C45.9024 50.3166 45.9024 49.6835 46.2929 49.2929C46.6555 48.9303 47.2274 48.9044 47.6199 49.2152L47.7071 49.2929L52 53.5851L56.2928 49.2929C56.6555 48.9303 57.2273 48.9044 57.6199 49.2152L57.7071 49.2929Z",
        fill: "#626F86"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "Subitem"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "Nav Item_4"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "57",
        y: "74",
        width: "184",
        height: "31.6364",
        rx: "6",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "#626F86",
        xmlSpace: "preserve",
        fontSize: "14",
        fontWeight: "500",
        letterSpacing: "0px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
        x: "71",
        y: "95.9766"
    }, formatMessage((0, $12QAT.default).mondaySubitem)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M47 74.5H235C238.038 74.5 240.5 76.9624 240.5 80V99.6364C240.5 102.674 238.038 105.136 235 105.136H47C43.9624 105.136 41.5 102.674 41.5 99.6364V80C41.5 76.9624 43.9624 74.5 47 74.5Z",
        stroke: "#DCDFE4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M41 79C41 76.7909 42.7909 75 45 75V75V105V105C42.7909 105 41 103.209 41 101V79Z",
        fill: "#216E4E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M23 66.4364V89.4364H41",
        stroke: "#216E4E",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "arrow-right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "32",
        height: "32",
        transform: "translate(272 42)",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M288.391 65.6094C287.91 65.1288 287.873 64.3725 288.28 63.8494L288.391 63.7239L292.78 59.3346L280 59.3333C279.264 59.3333 278.667 58.7364 278.667 58C278.667 57.3162 279.181 56.7526 279.844 56.6756L280 56.6666L292.783 56.668L288.391 52.2761C287.91 51.7955 287.873 51.0392 288.28 50.5161L288.391 50.3905C288.871 49.9099 289.627 49.8729 290.151 50.2796L290.276 50.3905L296.943 57.0572L297.04 57.1661C297.043 57.1699 297.047 57.1738 297.05 57.1776L296.943 57.0572C296.99 57.1044 297.033 57.1542 297.072 57.2062C297.095 57.2384 297.118 57.2717 297.139 57.3058C297.149 57.3219 297.158 57.3381 297.167 57.3546C297.182 57.3809 297.195 57.4081 297.208 57.4359C297.219 57.4585 297.229 57.4816 297.238 57.5049C297.249 57.5312 297.258 57.5576 297.267 57.5844C297.274 57.6042 297.28 57.6247 297.286 57.6453C297.294 57.6741 297.3 57.703 297.306 57.7322C297.311 57.7555 297.315 57.7788 297.319 57.8021C297.323 57.8274 297.326 57.8535 297.328 57.8799C297.331 57.912 297.332 57.9431 297.333 57.9742C297.333 57.982 297.333 57.991 297.333 58L297.333 58.0258C297.332 58.0569 297.331 58.088 297.328 58.119L297.333 58C297.333 58.0675 297.328 58.1338 297.319 58.1986C297.315 58.2213 297.311 58.2445 297.306 58.2676C297.3 58.297 297.294 58.3259 297.286 58.3545C297.28 58.3753 297.274 58.3958 297.267 58.4162C297.258 58.4424 297.249 58.4687 297.239 58.4947C297.229 58.5183 297.219 58.5414 297.208 58.5643C297.195 58.5918 297.182 58.619 297.167 58.6457C297.158 58.6618 297.149 58.6781 297.139 58.6942C297.118 58.7283 297.095 58.7615 297.072 58.7935C297.066 58.8016 297.06 58.8094 297.054 58.8172C297.016 58.8646 296.981 58.9048 296.943 58.9428L290.276 65.6094C289.755 66.1301 288.911 66.1301 288.391 65.6094Z",
        fill: "var(--ds-text-subtle, #44546F)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "JWM hierarchy"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        clipPath: "url(#clip0_15_137)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "306",
        y: "-3.05176e-05",
        width: "270",
        height: "116",
        rx: "6",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "Frame 1052",
        clipPath: "url(#clip1_15_137)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        id: "jwmBackground",
        x: "306",
        y: "-3.05176e-05",
        width: "270",
        height: "116",
        fill: "#579DFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "Image section view",
        clipPath: "url(#clip2_15_137)",
        filter: "url(#filter0_dd_15_137)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "Epic"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M320 19C320 15.6863 322.686 13 326 13H554C557.314 13 560 15.6863 560 19V37C560 40.3137 557.314 43 554 43H326C322.686 43 320 40.3137 320 37V19Z",
        fill: "#6E5DC6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        id: "Rectangle 1394",
        x: "320",
        y: "13",
        width: "240",
        height: "30",
        rx: "6",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "Nav Item_3"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "320",
        y: "13",
        width: "209",
        height: "30",
        rx: "6",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "#626F86",
        xmlSpace: "preserve",
        fontSize: "14",
        fontWeight: "500",
        letterSpacing: "0px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
        x: "392",
        y: "32.9765"
    }, formatMessage((0, $12QAT.default).jiraEpic))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "Icon_2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "24",
        height: "24",
        transform: "translate(336 16)",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M353.707 25.2929C354.07 25.6555 354.096 26.2274 353.785 26.6199L353.707 26.7071L348.707 31.7071C348.344 32.0697 347.773 32.0956 347.38 31.7848L347.293 31.7071L342.293 26.7071C341.902 26.3166 341.902 25.6834 342.293 25.2929C342.656 24.9303 343.227 24.9043 343.62 25.2152L343.707 25.2929L348 29.585L352.293 25.2929C352.655 24.9302 353.227 24.9043 353.62 25.2152L353.707 25.2929Z",
        fill: "#626F86"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "epic",
        clipPath: "url(#clip5_15_137)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "16",
        height: "16",
        transform: "translate(368 20)",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M382 20C383.105 20 384 20.8954 384 22V34C384 35.1045 383.105 36 382 36H370C368.895 36 368 35.1045 368 34V22C368 20.8954 368.895 20 370 20H382ZM376.5 23C376.35 23 376.22 23.069 376.128 23.173L372.149 28.145C372.146 28.148 372.113 28.19 372.113 28.19C372.047 28.279 372 28.382 372 28.5C372 28.776 372.224 29 372.5 29C372.528 29 372.551 29.005 372.577 29H375V32.5C375 32.776 375.224 33 375.5 33C375.624 33 375.734 32.95 375.821 32.876C375.821 32.876 375.883 32.809 375.906 32.776L379.84 27.863C379.859 27.845 379.871 27.824 379.887 27.803L379.914 27.77C379.963 27.689 380 27.6 380 27.5C380 27.224 379.776 27 379.5 27H377V23.5C377 23.224 376.776 23 376.5 23Z",
        fill: "#6554C0"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "Task"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M340 50C340 46.6863 342.686 44 346 44H554C557.314 44 560 46.6863 560 50V68C560 71.3137 557.314 74 554 74H346C342.686 74 340 71.3137 340 68V50Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "Nav Item_2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "348",
        y: "44",
        width: "209",
        height: "30",
        rx: "6",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "#626F86",
        xmlSpace: "preserve",
        fontSize: "14",
        fontWeight: "500",
        letterSpacing: "0px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
        x: "420",
        y: "63.9765"
    }, formatMessage((0, $12QAT.default).jiraTask))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "Icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "24",
        height: "24",
        transform: "translate(364 47)",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M381.707 56.2929C382.07 56.6555 382.096 57.2274 381.785 57.6199L381.707 57.7071L376.707 62.7071C376.344 63.0697 375.773 63.0956 375.38 62.7848L375.293 62.7071L370.293 57.7071C369.902 57.3166 369.902 56.6834 370.293 56.2929C370.656 55.9303 371.227 55.9043 371.62 56.2152L371.707 56.2929L376 60.585L380.293 56.2929C380.655 55.9302 381.227 55.9043 381.62 56.2152L381.707 56.2929Z",
        fill: "#626F86"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "jwm-item-type_task",
        clipPath: "url(#clip4_15_137)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M396 53.6666C396 52.1939 397.194 51 398.667 51H409.333C410.806 51 412 52.1939 412 53.6666V64.3333C412 65.8061 410.806 67 409.333 67H398.667C397.194 67 396 65.8061 396 64.3333V53.6666Z",
        fill: "#4C9AFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M408.69 55.6099C409.09 55.9913 409.105 56.6243 408.723 57.0238L403.874 62.1045C403.348 62.6548 402.47 62.6548 401.945 62.1045L399.277 59.3095C398.895 58.91 398.91 58.277 399.31 57.8957C399.709 57.5143 400.342 57.529 400.723 57.9285L402.909 60.2184L407.277 55.6428C407.658 55.2433 408.291 55.2286 408.69 55.6099Z",
        fill: "white"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "Subtask"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M360 81C360 77.6863 362.686 75 366 75H554C557.314 75 560 77.6863 560 81V99C560 102.314 557.314 105 554 105H366C362.686 105 360 102.314 360 99V81Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "Nav Item"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "376",
        y: "75",
        width: "184",
        height: "30",
        rx: "6",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("text", {
        fill: "#626F86",
        xmlSpace: "preserve",
        fontSize: "14",
        fontWeight: "500",
        letterSpacing: "0px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tspan", {
        x: "421",
        y: "95.9765"
    }, formatMessage((0, $12QAT.default).jiraSubtask))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        id: "subtask",
        clipPath: "url(#clip3_15_137)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "16",
        height: "16",
        transform: "translate(397 82)",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M406 89V86C406 85.7348 405.895 85.4804 405.707 85.2929C405.52 85.1053 405.265 85 405 85H401C400.735 85 400.48 85.1053 400.293 85.2929C400.105 85.4804 400 85.7348 400 86V90C400 90.2652 400.105 90.5195 400.293 90.7071C400.48 90.8946 400.735 91 401 91H404V94C404 94.2652 404.105 94.5195 404.293 94.7071C404.48 94.8946 404.735 95 405 95H409C409.265 95 409.52 94.8946 409.707 94.7071C409.895 94.5195 410 94.2652 410 94V90C410 89.7348 409.895 89.4804 409.707 89.2929C409.52 89.1053 409.265 89 409 89H406ZM397 83.994C397 82.893 397.895 82 398.994 82H411.006C412.107 82 413 82.895 413 83.994V96.006C413 96.5347 412.79 97.0418 412.416 97.4156C412.042 97.7895 411.535 97.9997 411.006 98H398.994C398.465 97.9997 397.958 97.7895 397.584 97.4156C397.21 97.0418 397 96.5347 397 96.006V83.994ZM406 91H408V93H406V91ZM402 87H404V89H402V87Z",
        fill: "#2684FF"
    }))))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("filter", {
        id: "filter0_dd_15_137",
        x: "312",
        y: "4.99997",
        width: "256",
        height: "108",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.16 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_15_137"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.12 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_15_137",
        result: "effect2_dropShadow_15_137"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_15_137",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip0_15_137"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        x: "306",
        y: "-3.05176e-05",
        width: "270",
        height: "116",
        rx: "6",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip1_15_137"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "270",
        height: "116",
        fill: "white",
        transform: "translate(306 -3.05176e-05)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip2_15_137"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "240",
        height: "92",
        fill: "white",
        transform: "translate(320 13)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip3_15_137"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "16",
        height: "16",
        fill: "white",
        transform: "translate(397 82)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip4_15_137"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "16",
        height: "16",
        fill: "white",
        transform: "translate(396 51)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip5_15_137"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "16",
        height: "16",
        fill: "white",
        transform: "translate(368 20)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip6_15_137"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "270",
        height: "116",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip7_15_137"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "240",
        height: "97.0182",
        fill: "white",
        transform: "translate(1 8.43637)"
    })))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ca2469eb881b6c7c$var$HeaderWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o _k48pni7l _1wyb1crf _vwz47vkz _syaz1dv3 _otyru2gc _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ca2469eb881b6c7c$var$MondayHeader = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01b66 _1bsb7rrr",
            __cmplp.className
        ])
    });
});
const $ca2469eb881b6c7c$var$jiraHeaderStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.050'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ca2469eb881b6c7c$var$Image = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1ejb _4t3i1ejb _u5f31b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("12QAT", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c966381244a8df0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1c966381244a8df0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    mondayHeading: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.project-hierarchy.illustration.monday-hierarchy.monday-heading",
        "defaultMessage": "monday hierarchy"
    },
    jiraHeadingSpork: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.project-hierarchy.illustration.monday-hierarchy.jira-heading-spork",
        "defaultMessage": "Jira hierarchy"
    },
    illustrationLabel: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.project-hierarchy.illustration.monday-hierarchy.illustration-label",
        "defaultMessage": "Map monday project to Jira project"
    },
    mondayGroup: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.project-hierarchy.illustration.monday-hierarchy.monday-group",
        "defaultMessage": "Group"
    },
    mondayItem: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.project-hierarchy.illustration.monday-hierarchy.monday-item",
        "defaultMessage": "Item"
    },
    mondaySubitem: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.project-hierarchy.illustration.monday-hierarchy.monday-subitem",
        "defaultMessage": "Subitem"
    },
    jiraEpic: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.project-hierarchy.illustration.monday-hierarchy.jira-epic",
        "defaultMessage": "Epic"
    },
    jiraTask: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.project-hierarchy.illustration.monday-hierarchy.jira-task",
        "defaultMessage": "Task"
    },
    jiraSubtask: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.project-hierarchy.illustration.monday-hierarchy.jira-subtask",
        "defaultMessage": "Subtask"
    }
});

});


parcelRegister("hwp26", function(module, exports) {

$parcel$export(module.exports, "default", () => $abb6f4461c15519c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $abb6f4461c15519c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    heading: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.project-hierarchy.heading",
        "defaultMessage": "Project hierarchy"
    },
    jwmSpork: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.project-hierarchy.jwm-spork",
        "defaultMessage": "Jira"
    }
});

});

parcelRegister("9OEBu", function(module, exports) {

$parcel$export(module.exports, "useTableHead", () => $8a004e6c7537d7e4$export$c1593f9fc5eec62b);
$parcel$export(module.exports, "useTableRows", () => $8a004e6c7537d7e4$export$a190e1af00082b41);

var $eUqFw = parcelRequire("eUqFw");

var $cSu9v = parcelRequire("cSu9v");

var $77CtJ = parcelRequire("77CtJ");

var $b5IAe = parcelRequire("b5IAe");
var $27KYr = parcelRequire("27KYr");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $agB2z = parcelRequire("agB2z");

var $aYMEC = parcelRequire("aYMEC");

var $7J5LG = parcelRequire("7J5LG");

var $klvFM = parcelRequire("klvFM");

var $cDLTA = parcelRequire("cDLTA");

var $antP2 = parcelRequire("antP2");

var $9HbMH = parcelRequire("9HbMH");

var $irjtd = parcelRequire("irjtd");

var $4R50N = parcelRequire("4R50N");

var $g9jDc = parcelRequire("g9jDc");

var $hwp26 = parcelRequire("hwp26");
const $8a004e6c7537d7e4$export$c1593f9fc5eec62b = (thirdParty)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const tool = (0, $4R50N.useImportTool)(thirdParty);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27KYr.default), {
        templateColumns: $8a004e6c7537d7e4$var$templateColumns,
        alignItems: "center",
        xcss: $8a004e6c7537d7e4$var$tableHeaderStyles,
        testId: "project-create-importer-upload-flow.ui.third-party-review-screen.project-hierarchy.table-header",
        role: "row"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $8a004e6c7537d7e4$var$columnStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.050",
        alignBlock: "center"
    }, tool && (0, $7J5LG.renderIcon)(tool?.icon, true), tool?.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77CtJ.JiraIcon), {
        size: "small",
        appearance: "brand"
    }), formatMessage((0, $hwp26.default).jwmSpork)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        padding: "space.050"
    }));
};
const $8a004e6c7537d7e4$export$a190e1af00082b41 = (thirdParty)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [thirdPartyHierarchyState, { setThirdPartyFieldMapping: setThirdPartyFieldMapping }] = (0, $9HbMH.useThirdPartyHierarchyState)({
        types: (0, $antP2.getHierarchyMappingItems)(thirdParty),
        formatMessage: formatMessage
    });
    const [, { setUIState: setUIState }] = (0, $irjtd.useUIState)();
    const { hierarchyStatusToolTip: hierarchyStatusToolTip, hierarchyCategoryToolTip: hierarchyCategoryToolTip, hierarchyEpicToolTip: hierarchyEpicToolTip, hierarchySubtaskToolTip: hierarchySubtaskToolTip, disabledFieldTooltip: disabledFieldTooltip } = (0, $cDLTA.useContentForThirdParty)(thirdParty);
    const handleOnClick = (0, $eUqFw.useCallback)((id)=>(selected)=>{
            if (id) {
                setThirdPartyFieldMapping(id, selected);
                setUIState({
                    hasUnsavedHierarchyMappingChanges: true
                });
                const analyticsEvent = createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'projectHierarchySelector'
                });
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'projectHierarchyItem changed', {
                    selectedHierarchyItem: selected.fieldName
                });
            }
        }, [
        createAnalyticsEvent,
        setThirdPartyFieldMapping,
        setUIState
    ]);
    const tableRows = (0, $eUqFw.useMemo)(()=>thirdPartyHierarchyState?.data.map((field)=>{
            const indentType = $8a004e6c7537d7e4$var$getIndentType(field.mappedItem.fieldType);
            const tooltipContent = $8a004e6c7537d7e4$var$getToolTipForHierarchyItem(field.mappedItem.fieldType, {
                hierarchyStatusToolTip: hierarchyStatusToolTip,
                hierarchyCategoryToolTip: hierarchyCategoryToolTip,
                hierarchyEpicToolTip: hierarchyEpicToolTip,
                hierarchySubtaskToolTip: hierarchySubtaskToolTip
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $27KYr.default), {
                role: "row",
                key: field.item.fieldId,
                templateColumns: $8a004e6c7537d7e4$var$templateColumns,
                alignItems: "center"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: $8a004e6c7537d7e4$var$columnStyles
            }, field.item.fieldName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                as: "span"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
                size: "small",
                label: "Arrow Right"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g9jDc.ItemSelector), {
                ...field,
                onClick: handleOnClick(field.item.fieldId),
                disabledFieldTooltip: disabledFieldTooltip,
                indentType: indentType
            }), field.showTooltip && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                as: "span",
                xcss: $8a004e6c7537d7e4$var$toolTipColumnStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $klvFM.InfoTooltip), {
                tooltipContent: tooltipContent || '',
                position: "bottom-start"
            })));
        }), [
        disabledFieldTooltip,
        handleOnClick,
        hierarchyCategoryToolTip,
        hierarchyEpicToolTip,
        hierarchyStatusToolTip,
        hierarchySubtaskToolTip,
        thirdPartyHierarchyState?.data
    ]);
    return tableRows;
};
const $8a004e6c7537d7e4$var$templateColumns = '1fr 5% 280px 40px';
const $8a004e6c7537d7e4$var$columnStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.100',
    textTransform: 'capitalize'
});
const $8a004e6c7537d7e4$var$tableHeaderStyles = (0, $1ZAYh.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    borderBottom: `2px solid ${`var(--ds-border, ${(0, $PdmhA).N30})`}`,
    paddingBottom: 'space.100'
});
const $8a004e6c7537d7e4$var$toolTipColumnStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.100'
});
const $8a004e6c7537d7e4$var$getIndentType = (fieldType)=>{
    switch(fieldType){
        case 0, $aYMEC.TASK:
            return 'small';
        case 0, $aYMEC.SUBTASK:
            return 'large';
        default:
            return 'default';
    }
};
const $8a004e6c7537d7e4$var$getToolTipForHierarchyItem = (fieldType, data)=>{
    switch(fieldType){
        case 0, $agB2z.STATUS_FIELDTYPE:
            return data.hierarchyStatusToolTip;
        case 0, $agB2z.CATEGORY_FIELDTYPE:
            return data.hierarchyCategoryToolTip;
        case 0, $agB2z.EPIC_FIELDTYPE:
            return data.hierarchyEpicToolTip;
        case 0, $aYMEC.SUBTASK:
            return data.hierarchySubtaskToolTip;
        default:
            return '';
    }
};

});
parcelRegister("g9jDc", function(module, exports) {

$parcel$export(module.exports, "ItemSelector", () => $e932ddfc9db73a63$export$cd303fea6ed83a4);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $6OfWd = parcelRequire("6OfWd");
var $fEubG = parcelRequire("fEubG");

var $86Ndv = parcelRequire("86Ndv");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1ZAYh = parcelRequire("1ZAYh");

var $kzTj7 = parcelRequire("kzTj7");

var $1XXvr = parcelRequire("1XXvr");

var $hlez9 = parcelRequire("hlez9");
const $e932ddfc9db73a63$export$cd303fea6ed83a4 = ({ mappedItem: mappedItem, availableItems: availableItems, isDisabled: isDisabled, onClick: onClick, indentType: indentType, disabledFieldTooltip: disabledFieldTooltip })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const toggleMenuOpenState = (0, $eUqFw.useCallback)((attrs)=>{
        setIsOpen(attrs.isOpen);
    }, []);
    const onKeyDownHandler = (0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Tab') event.stopPropagation();
    }, []);
    const handleDropdownItemClickFactory = (0, $eUqFw.useCallback)((item)=>()=>onClick && onClick({
                fieldType: item.fieldType,
                fieldName: item.fieldName,
                fieldId: item.fieldId
            }), [
        onClick
    ]);
    const availableOptions = (0, $eUqFw.useMemo)(()=>availableItems.map((item)=>{
            const isSelected = !!mappedItem?.fieldId && item.fieldId === mappedItem.fieldId;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1XXvr.FieldSelectorItem), {
                key: `${item.fieldName}-${item.fieldType}`,
                name: item.fieldName,
                icon: (0, $hlez9.getIcon)({
                    fieldType: item.fieldType,
                    isSelected: isSelected,
                    isDisabled: item.isDisabled
                }),
                onClick: handleDropdownItemClickFactory(item),
                isDisabled: item.isDisabled,
                isSelected: isSelected,
                tooltipContent: disabledFieldTooltip
            });
        }), [
        availableItems,
        disabledFieldTooltip,
        handleDropdownItemClickFactory,
        mappedItem.fieldId
    ]);
    const dropdownTrigger = (0, $eUqFw.useCallback)(({ triggerRef: triggerRef, isSelected: isSelected, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e932ddfc9db73a63$var$StyledButton, {
            ...props,
            iconAfter: isDisabled ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
                label: "",
                size: "large"
            }),
            ref: triggerRef,
            isOpen: isSelected,
            isDisabled: isDisabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
            alignItems: "center",
            gap: "space.150"
        }, (0, $hlez9.getIcon)({
            fieldType: mappedItem.fieldType,
            isDisabled: isDisabled,
            isSubtle: !isDisabled
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, mappedItem.fieldName))), [
        isDisabled,
        mappedItem.fieldName,
        mappedItem.fieldType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $e932ddfc9db73a63$var$styleMap[indentType],
        testId: (0, $kzTj7.THIRD_PARTY_HIERARCHY_SELECTOR_TEST_ID_PREFIX)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        isOpen: isOpen,
        onOpenChange: toggleMenuOpenState,
        shouldFlip: true,
        trigger: dropdownTrigger
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        onKeyDown: onKeyDownHandler,
        xcss: $e932ddfc9db73a63$var$DropdownItemStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), {
        testId: `${(0, $kzTj7.THIRD_PARTY_HIERARCHY_SELECTOR_TEST_ID_PREFIX)}.dropdown-item-group`
    }, availableOptions))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e932ddfc9db73a63$var$StyledButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_w1ap1osq _17em1ekn _nmk41dk0",
            __cmplp.isOpen ? "_1w90j3m3" : "_1w901kw7",
            __cmplp.isOpen ? "_1uvd1ekn" : "_17bz1r31 _e0gcglyw _15451o36",
            __cmplp.className
        ])
    });
});
const $e932ddfc9db73a63$var$styleMap = {
    small: (0, $1ZAYh.xcss)({
        marginLeft: 'space.150'
    }),
    large: (0, $1ZAYh.xcss)({
        marginLeft: 'space.300'
    }),
    default: (0, $1ZAYh.xcss)({
        marginLeft: 'space.0'
    })
};
const $e932ddfc9db73a63$var$DropdownItemStyles = (0, $1ZAYh.xcss)({
    width: '280px'
});

});



parcelRegister("fDl1F", function(module, exports) {

$parcel$export(module.exports, "ReviewTiles", () => $c97b3d4d0c69a37e$export$3457648272ab6769);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $dtaN9 = parcelRequire("dtaN9");

var $96IgR = parcelRequire("96IgR");

var $2bv8J = parcelRequire("2bv8J");

var $5YsMl = parcelRequire("5YsMl");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $PdmhA = parcelRequire("PdmhA");

var $e270j = parcelRequire("e270j");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $gd0Sp = parcelRequire("gd0Sp");

var $c8iUV = parcelRequire("c8iUV");

var $4wA8a = parcelRequire("4wA8a");

var $OnUJW = parcelRequire("OnUJW");

var $cg5ah = parcelRequire("cg5ah");

var $ch13p = parcelRequire("ch13p");

var $kzTj7 = parcelRequire("kzTj7");

var $1pm5p = parcelRequire("1pm5p");

var $3taFW = parcelRequire("3taFW");

var $cDLTA = parcelRequire("cDLTA");

var $antP2 = parcelRequire("antP2");

var $es1tu = parcelRequire("es1tu");

var $9HbMH = parcelRequire("9HbMH");

var $7qxDu = parcelRequire("7qxDu");

var $inuD3 = parcelRequire("inuD3");
const $c97b3d4d0c69a37e$var$LoadingStatus = ({ loadingMessage: loadingMessage })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c97b3d4d0c69a37e$var$SpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, loadingMessage));
const $c97b3d4d0c69a37e$var$ErrorStatus = ({ errorMessage: errorMessage })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        label: "",
        size: "medium",
        primaryColor: "var(--ds-icon-danger, #EF5C48)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c97b3d4d0c69a37e$var$ErrorMessageWrapper, null, errorMessage));
const $c97b3d4d0c69a37e$export$3457648272ab6769 = ({ onSetSelectedTile: onSetSelectedTile, thirdParty: thirdParty, thirdPartyImportSettings: thirdPartyImportSettings, onSetThirdPartyImportSettings: onSetThirdPartyImportSettings, isLoading: isLoading, hasErrorOccurred: hasErrorOccurred, isStatusMappingLoading: isStatusMappingLoading = false, hasStatusMappingErrorOccurred: hasStatusMappingErrorOccurred = false, onRefetchFieldMapping: onRefetchFieldMapping, onRefetchStatusMapping: onRefetchStatusMapping, tiles: tiles })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { fieldsTileLoadingDescription: fieldsTileLoadingDescription, hierarchyTileDescription: hierarchyTileDescription, usersTileHeading: usersTileHeading, usersTileDescriptionUnchecked: usersTileDescriptionUnchecked, usersTileWarningDescription: usersTileWarningDescription, usersTileDescription: usersTileDescription, fieldsTileInfoDescription: fieldsTileInfoDescription, hierarchyMappingTileDescription: hierarchyMappingTileDescription, hierarchyTileLoadingDescription: hierarchyTileLoadingDescription, attachmentTileEnabledDescription: attachmentTileEnabledDescription } = (0, $cDLTA.useContentForThirdParty)(thirdParty);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [{ numThirdPartyFields: numFields, numFieldsIncluded: numFieldsIncluded, hasUnsupportedFieldFiltered: hasUnsupportedFieldFiltered }] = (0, $es1tu.useThirdPartyFieldsIncludedState)();
    const shouldDisableFieldsOrHierarchyTile = isLoading || hasErrorOccurred;
    const shouldDisableStatusTile = isStatusMappingLoading || hasStatusMappingErrorOccurred;
    const [{ numMappedStatuses: numMappedStatuses, numTotalStatuses: numTotalStatuses }] = (0, $7qxDu.useThirdPartyMappedStatus)();
    const { isSiteAdmin: isSiteAdmin, isAdmin: isAdmin } = (0, $gd0Sp.useTenantContext)();
    const [thirdPartyHierarchyState] = (0, $9HbMH.useThirdPartyHierarchyState)({
        types: (0, $antP2.getHierarchyMappingItems)(thirdParty),
        formatMessage: formatMessage
    });
    // remove fg('jwm_clickup_importer') when clean up ff('jwm-x2c-hierarchy-mapping_kkjnd')
    const enableHierarchyMapping = (0, $1ybV0.ff)('jwm-x2c-hierarchy-mapping_kkjnd') || (0, $eI5EY.fg)('jwm_clickup_importer');
    const handleHierarchyTileClick = (0, $eUqFw.useCallback)(()=>{
        if (enableHierarchyMapping && shouldDisableFieldsOrHierarchyTile) return;
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'projectHierarchyButton'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
        onSetSelectedTile((0, $1pm5p.ReviewTilesType).HIERARCHY);
    }, [
        createAnalyticsEvent,
        enableHierarchyMapping,
        onSetSelectedTile,
        shouldDisableFieldsOrHierarchyTile
    ]);
    const handleFieldMappingTileClick = (0, $eUqFw.useCallback)(()=>{
        if (shouldDisableFieldsOrHierarchyTile) return;
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'fieldMappingButton'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
        onSetSelectedTile((0, $1pm5p.ReviewTilesType).FIELDS);
    }, [
        createAnalyticsEvent,
        onSetSelectedTile,
        shouldDisableFieldsOrHierarchyTile
    ]);
    const handleStatusMappingTileClick = (0, $eUqFw.useCallback)(()=>{
        if (shouldDisableStatusTile) return;
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'statusMappingButton'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
        onSetSelectedTile((0, $1pm5p.ReviewTilesType).STATUS);
    }, [
        createAnalyticsEvent,
        onSetSelectedTile,
        shouldDisableStatusTile
    ]);
    const descriptionForHierarchyTile = (0, $eUqFw.useMemo)(()=>{
        if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c97b3d4d0c69a37e$var$LoadingStatus, {
            loadingMessage: hierarchyTileLoadingDescription
        });
        if (hasErrorOccurred) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c97b3d4d0c69a37e$var$ErrorStatus, {
            errorMessage: formatMessage((0, $inuD3.default).hierarchyTileErrorDescription, {
                link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                        appearance: "link",
                        spacing: "none",
                        onClick: onRefetchFieldMapping
                    }, chunks)
            })
        });
        return hierarchyMappingTileDescription ? formatMessage(hierarchyMappingTileDescription, {
            jiraHierarchyItem: thirdPartyHierarchyState?.selectedHierarchyItem
        }) : null;
    }, [
        formatMessage,
        hasErrorOccurred,
        hierarchyMappingTileDescription,
        hierarchyTileLoadingDescription,
        isLoading,
        onRefetchFieldMapping,
        thirdPartyHierarchyState
    ]);
    const descriptionForFieldsTile = (0, $eUqFw.useMemo)(()=>{
        if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c97b3d4d0c69a37e$var$LoadingStatus, {
            loadingMessage: fieldsTileLoadingDescription
        });
        if (hasErrorOccurred) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c97b3d4d0c69a37e$var$ErrorStatus, {
            errorMessage: formatMessage((0, $inuD3.default).fieldTileErrorDescription, {
                link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                        appearance: "link",
                        spacing: "none",
                        onClick: onRefetchFieldMapping
                    }, chunks)
            })
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, formatMessage((0, $inuD3.default).fieldTileDescription, {
            numFields: numFields,
            numFieldsIncluded: numFieldsIncluded
        })), hasUnsupportedFieldFiltered !== false && fieldsTileInfoDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            space: "space.025",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            xcss: $c97b3d4d0c69a37e$var$infoIconWrapper,
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2bv8J))), {
            label: "",
            size: "medium",
            primaryColor: `var(--ds-icon-information, ${(0, $PdmhA).B200})`
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, formatMessage(fieldsTileInfoDescription))));
    }, [
        fieldsTileInfoDescription,
        fieldsTileLoadingDescription,
        formatMessage,
        hasErrorOccurred,
        hasUnsupportedFieldFiltered,
        isLoading,
        numFields,
        numFieldsIncluded,
        onRefetchFieldMapping
    ]);
    const descriptionForStatusTile = (0, $eUqFw.useMemo)(()=>{
        if (isStatusMappingLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c97b3d4d0c69a37e$var$LoadingStatus, {
            loadingMessage: formatMessage((0, $inuD3.default).statusTileLoadingDescription)
        });
        if (hasStatusMappingErrorOccurred) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c97b3d4d0c69a37e$var$ErrorStatus, {
            errorMessage: formatMessage((0, $inuD3.default).statusTileErrorDescription, {
                link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                        appearance: "link",
                        spacing: "none",
                        onClick: onRefetchStatusMapping
                    }, chunks)
            })
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, formatMessage((0, $inuD3.default).statusTileDescription, {
            numStatusesIncluded: numMappedStatuses,
            numStatuses: numTotalStatuses
        })));
    }, [
        formatMessage,
        hasStatusMappingErrorOccurred,
        isStatusMappingLoading,
        numMappedStatuses,
        numTotalStatuses,
        onRefetchStatusMapping
    ]);
    const showWarningMessage = (0, $1ybV0.ff)('enable-product-admin-for-x2c-migration_zmlsv') && !isSiteAdmin && isAdmin && thirdPartyImportSettings.shouldImportUsers && usersTileWarningDescription;
    const descriptionForUsersTile = (0, $eUqFw.useMemo)(()=>{
        if (!thirdPartyImportSettings.shouldImportUsers && usersTileDescriptionUnchecked) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
            label: "",
            size: "medium",
            primaryColor: `var(--ds-icon-warning, ${(0, $PdmhA).Y400})`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, usersTileDescriptionUnchecked)));
        if (usersTileDescription && usersTileDescription !== '' || showWarningMessage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
            space: "space.050"
        }, usersTileDescription && usersTileDescription !== '' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, usersTileDescription)), showWarningMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
            label: "",
            size: "medium",
            primaryColor: `var(--ds-icon-warning, ${(0, $PdmhA).Y400})`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, usersTileWarningDescription)));
        return null;
    }, [
        showWarningMessage,
        thirdPartyImportSettings.shouldImportUsers,
        usersTileDescription,
        usersTileDescriptionUnchecked,
        usersTileWarningDescription
    ]);
    const descriptionForAttachmentTile = (0, $eUqFw.useMemo)(()=>{
        if (thirdPartyImportSettings.shouldImportAttachments && attachmentTileEnabledDescription) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
            label: "",
            size: "medium",
            primaryColor: `var(--ds-icon-warning, ${(0, $PdmhA).Y400})`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, attachmentTileEnabledDescription)));
        return null;
    }, [
        thirdPartyImportSettings.shouldImportAttachments,
        attachmentTileEnabledDescription
    ]);
    const descriptionForCommentsTile = (0, $eUqFw.useMemo)(()=>{
        if (thirdPartyImportSettings.shouldImportComments) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
            label: "",
            size: "medium",
            primaryColor: `var(--ds-icon-warning, ${(0, $PdmhA).Y400})`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, formatMessage((0, $inuD3.default).commentsTileEnabledDescription))));
        return null;
    }, [
        formatMessage,
        thirdPartyImportSettings.shouldImportComments
    ]);
    const tilesMap = (0, $eUqFw.useMemo)(()=>({
            [(0, $1pm5p.ReviewTilesType).HIERARCHY]: {
                key: (0, $1pm5p.ReviewTilesType).HIERARCHY,
                heading: formatMessage((0, $inuD3.default).hierarchyTileHeading),
                description: enableHierarchyMapping ? descriptionForHierarchyTile : hierarchyTileDescription,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c97b3d4d0c69a37e$var$Icon, {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($cg5ah))),
                    "aria-label": formatMessage((0, $inuD3.default).hierarchyTileLabel),
                    role: "img",
                    alt: formatMessage((0, $inuD3.default).hierarchyTileLabel)
                }),
                rightActions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))), {
                    label: "",
                    size: "large",
                    primaryColor: shouldDisableFieldsOrHierarchyTile && enableHierarchyMapping ? `var(--ds-icon-disabled, ${(0, $PdmhA).N200})` : `var(--ds-icon-information, ${(0, $PdmhA).B200})`
                }),
                isDisabled: shouldDisableFieldsOrHierarchyTile,
                onClick: handleHierarchyTileClick
            },
            [(0, $1pm5p.ReviewTilesType).STATUS]: {
                key: (0, $1pm5p.ReviewTilesType).STATUS,
                heading: formatMessage((0, $inuD3.default).statusTileLabel),
                description: descriptionForStatusTile,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c97b3d4d0c69a37e$var$Icon, {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($OnUJW))),
                    "aria-label": formatMessage((0, $inuD3.default).statusTileLabel),
                    role: "img",
                    alt: formatMessage((0, $inuD3.default).statusTileLabel)
                }),
                rightActions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))), {
                    label: "",
                    size: "large",
                    primaryColor: shouldDisableStatusTile ? `var(--ds-icon-disabled, ${(0, $PdmhA).N200})` : `var(--ds-icon-information, ${(0, $PdmhA).B200})`
                }),
                isDisabled: shouldDisableStatusTile,
                onClick: handleStatusMappingTileClick
            },
            [(0, $1pm5p.ReviewTilesType).FIELDS]: {
                key: (0, $1pm5p.ReviewTilesType).FIELDS,
                heading: formatMessage((0, $inuD3.default).fieldTileHeading),
                description: descriptionForFieldsTile,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c97b3d4d0c69a37e$var$Icon, {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($OnUJW))),
                    "aria-label": formatMessage((0, $inuD3.default).fieldTileLabel),
                    role: "img",
                    alt: formatMessage((0, $inuD3.default).fieldTileLabel)
                }),
                rightActions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))), {
                    label: "",
                    size: "large",
                    primaryColor: shouldDisableFieldsOrHierarchyTile ? `var(--ds-icon-disabled, ${(0, $PdmhA).N200})` : `var(--ds-icon-information, ${(0, $PdmhA).B200})`
                }),
                isDisabled: shouldDisableFieldsOrHierarchyTile,
                onClick: handleFieldMappingTileClick
            },
            [(0, $1pm5p.ReviewTilesType).ATTACHMENTS]: {
                key: (0, $1pm5p.ReviewTilesType).ATTACHMENTS,
                heading: formatMessage((0, $inuD3.default).attachmentTileHeading),
                description: descriptionForAttachmentTile,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c97b3d4d0c69a37e$var$Icon, {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($c8iUV))),
                    "aria-label": formatMessage((0, $inuD3.default).attachmentTileLabel),
                    role: "img",
                    alt: formatMessage((0, $inuD3.default).attachmentTileLabel)
                }),
                rightActions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e270j.default), {
                    onChange: (value)=>onSetThirdPartyImportSettings({
                            shouldImportAttachments: value.target.checked
                        }),
                    isChecked: thirdPartyImportSettings.shouldImportAttachments,
                    label: formatMessage((0, $inuD3.default).attachmentTileHeading)
                })
            },
            [(0, $1pm5p.ReviewTilesType).USERS]: {
                key: (0, $1pm5p.ReviewTilesType).USERS,
                heading: usersTileHeading || '',
                description: descriptionForUsersTile,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c97b3d4d0c69a37e$var$Icon, {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($ch13p))),
                    "aria-label": formatMessage((0, $inuD3.default).usersTileLabel),
                    role: "img",
                    alt: formatMessage((0, $inuD3.default).usersTileLabel)
                }),
                rightActions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e270j.default), {
                    onChange: (value)=>onSetThirdPartyImportSettings({
                            shouldImportUsers: value.target.checked
                        }),
                    isChecked: thirdPartyImportSettings.shouldImportUsers,
                    label: usersTileHeading
                })
            },
            [(0, $1pm5p.ReviewTilesType).COMMENTS]: {
                key: (0, $1pm5p.ReviewTilesType).COMMENTS,
                heading: formatMessage((0, $inuD3.default).commentsTileHeading),
                description: descriptionForCommentsTile,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c97b3d4d0c69a37e$var$Icon, {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($4wA8a))),
                    "aria-label": formatMessage((0, $inuD3.default).commentsTileLabel),
                    role: "img",
                    alt: formatMessage((0, $inuD3.default).commentsTileLabel)
                }),
                rightActions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e270j.default), {
                    onChange: (value)=>onSetThirdPartyImportSettings({
                            shouldImportComments: value.target.checked
                        }),
                    isChecked: thirdPartyImportSettings.shouldImportComments,
                    label: formatMessage((0, $inuD3.default).commentsTileHeading)
                })
            }
        }), [
        descriptionForAttachmentTile,
        descriptionForCommentsTile,
        descriptionForFieldsTile,
        descriptionForHierarchyTile,
        descriptionForStatusTile,
        descriptionForUsersTile,
        enableHierarchyMapping,
        formatMessage,
        handleFieldMappingTileClick,
        handleHierarchyTileClick,
        handleStatusMappingTileClick,
        hierarchyTileDescription,
        onSetThirdPartyImportSettings,
        shouldDisableFieldsOrHierarchyTile,
        shouldDisableStatusTile,
        thirdPartyImportSettings.shouldImportAttachments,
        thirdPartyImportSettings.shouldImportComments,
        thirdPartyImportSettings.shouldImportUsers,
        usersTileHeading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c97b3d4d0c69a37e$var$Wrapper, null, tiles.map((type)=>tilesMap[type]).map(({ key: key, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3taFW.Card), {
            key: key,
            ...props,
            testId: (0, $kzTj7.REVIEW_SCREEN_CARD_TEST_ID)
        })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c97b3d4d0c69a37e$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _1yt4gx6n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c97b3d4d0c69a37e$var$Icon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1nrf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c97b3d4d0c69a37e$var$SpinnerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxu2gc _4t3i1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c97b3d4d0c69a37e$var$ErrorMessageWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wpz1h6o",
            __cmplp.className
        ])
    });
});
const $c97b3d4d0c69a37e$var$infoIconWrapper = (0, $1ZAYh.xcss)({
    alignSelf: 'start'
});

});
parcelRegister("c8iUV", function(module, exports) {
module.exports = new URL("AttachmentIllustration.0cb53b6e.svg", import.meta.url).toString();

});

parcelRegister("4wA8a", function(module, exports) {
module.exports = new URL("CommentsIllustration.037c2b17.svg", import.meta.url).toString();

});

parcelRegister("cg5ah", function(module, exports) {
module.exports = new URL("HierarchyIllustration.5acb9c37.svg", import.meta.url).toString();

});

parcelRegister("7qxDu", function(module, exports) {

$parcel$export(module.exports, "useThirdPartyStatusMappingState", () => $b1b1d774be1cf3ee$export$5a1b2b5cd3ab1f2f);
$parcel$export(module.exports, "useThirdPartyMappedStatus", () => $b1b1d774be1cf3ee$export$1dbc5bb6965bcf72);
$parcel$export(module.exports, "useThirdPartyStatusCategories", () => $b1b1d774be1cf3ee$export$223451133976c116);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");
var $bj4JM = parcelRequire("bj4JM");

var $T1aHH = parcelRequire("T1aHH");

var $8JicK = parcelRequire("8JicK");

var $irKna = parcelRequire("irKna");
const $b1b1d774be1cf3ee$var$thirdPartyStatusMappingSelector = (state)=>state.thirdPartyState.thirdPartyStatusMapping;
const $b1b1d774be1cf3ee$export$5a1b2b5cd3ab1f2f = ()=>{
    const [state, { setThirdPartyStatusMapping: setThirdPartyStatusMapping }] = (0, $irKna.useThirdPartyState)();
    const currentEntity = (0, $T1aHH.useStatusMappingEntityContext)();
    const actions = (0, $eUqFw.useMemo)(()=>({
            setThirdPartyStatusMapping: setThirdPartyStatusMapping.bind(null, currentEntity)
        }), [
        currentEntity,
        setThirdPartyStatusMapping
    ]);
    return [
        state.thirdPartyStatusMapping,
        actions
    ];
};
const $b1b1d774be1cf3ee$export$d7d6336774b5026d = (0, $bj4JM.createSelector)($b1b1d774be1cf3ee$var$thirdPartyStatusMappingSelector, (newState)=>{
    let numTotalStatuses = 0;
    let numMappedStatuses = 0;
    if (newState == null) return {
        numTotalStatuses: numTotalStatuses,
        numMappedStatuses: numMappedStatuses
    };
    const { entityStatusMappings: entityStatusMappings } = newState;
    Object.values(entityStatusMappings).forEach((entity)=>{
        numTotalStatuses += Object.values(entity.statusMappings).length;
        numMappedStatuses += Object.values(entity.statusMappings).filter((status)=>status.mappedStatusName !== null).length;
    });
    return {
        numTotalStatuses: numTotalStatuses,
        numMappedStatuses: numMappedStatuses
    };
});
const $b1b1d774be1cf3ee$export$1dbc5bb6965bcf72 = (0, $ggKAj.createHook)((0, $8JicK.Store), {
    selector: $b1b1d774be1cf3ee$export$d7d6336774b5026d
});
const $b1b1d774be1cf3ee$export$de4846bf419c53f5 = (0, $bj4JM.createSelector)($b1b1d774be1cf3ee$var$thirdPartyStatusMappingSelector, (newState)=>{
    if (newState == null) return {
        statusCategories: []
    };
    const { statusOptions: statusOptions } = newState;
    return {
        statusCategories: [
            ...new Set(statusOptions.map((status)=>status.statusCategory))
        ]
    };
});
const $b1b1d774be1cf3ee$export$223451133976c116 = (0, $ggKAj.createHook)((0, $8JicK.Store), {
    selector: $b1b1d774be1cf3ee$export$de4846bf419c53f5
});

});
parcelRegister("T1aHH", function(module, exports) {

$parcel$export(module.exports, "StatusMappingEntityContext", () => $259c963b24ca963b$export$eccc2abde98d50a8);
$parcel$export(module.exports, "useStatusMappingEntityContext", () => $259c963b24ca963b$export$2fb6191dfebaa6db);

var $eUqFw = parcelRequire("eUqFw");
const $259c963b24ca963b$export$eccc2abde98d50a8 = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $259c963b24ca963b$export$2fb6191dfebaa6db = ()=>(0, $eUqFw.useContext)($259c963b24ca963b$export$eccc2abde98d50a8);

});


parcelRegister("inuD3", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed55158141fdb9b7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ed55158141fdb9b7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    fieldTileLabel: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.review-tiles.field-tile-label",
        "defaultMessage": "Fields"
    },
    attachmentTileLabel: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.review-tiles.attachment-tile-label",
        "defaultMessage": "Attachments"
    },
    commentsTileLabel: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.review-tiles.comments-tile-label",
        "defaultMessage": "Comments"
    },
    usersTileLabel: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.review-tiles.users-tile-label",
        "defaultMessage": "Users"
    },
    hierarchyTileLabel: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.review-tiles.hierarchy-tile-label",
        "defaultMessage": "Hierarchy"
    },
    statusTileLabel: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.review-tiles.status-tile-label",
        "defaultMessage": "Status mapping"
    },
    fieldTileHeading: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.review-tiles.field-tile-heading",
        "defaultMessage": "Field mapping"
    },
    attachmentTileHeading: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.review-tiles.attachment-tile-heading",
        "defaultMessage": "Import all attachments"
    },
    hierarchyTileHeading: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.review-tiles.hierarchy-tile-heading",
        "defaultMessage": "Project hierarchy"
    },
    commentsTileHeading: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.review-tiles.comments-tile-heading",
        "defaultMessage": "Import comments"
    },
    hierarchyTileErrorDescription: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.review-tiles.hierarchy-tile-error-description",
        "defaultMessage": "We couldn't map your data. <link>Try again</link>"
    },
    commentsTileEnabledDescription: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.review-tiles.comments-tile-enabled-description",
        "defaultMessage": "Importing comments may take extra time. Some comment types will not be imported"
    },
    fieldTileErrorDescription: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.review-tiles.field-tile-error-description",
        "defaultMessage": "We couldn't map your data. <link>Try again</link>"
    },
    fieldTileDescription: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.review-tiles.field-tile-description",
        "defaultMessage": "{numFieldsIncluded}/{numFields} imported {numFields, plural, one {field is} other {fields are}} automatically mapped"
    },
    statusTileDescription: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.review-tiles.status-tile-description",
        "defaultMessage": "{numStatusesIncluded}/{numStatuses} imported {numStatuses, plural, one {status is} other {statuses are}} automatically mapped"
    },
    statusTileLoadingDescription: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.review-tiles.status-tile-loading-description",
        "defaultMessage": "Mapping your statuses to Jira"
    },
    statusTileErrorDescription: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.review-tiles.status-tile-error-description",
        "defaultMessage": "We couldn't map your statuses. <link>Try again</link>"
    }
});

});


parcelRegister("dHmCU", function(module, exports) {

$parcel$export(module.exports, "StatusMapping", () => $64f741f5091bada0$export$b8ff69f9ebbd4592);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1VyqP = parcelRequire("1VyqP");

var $cDLTA = parcelRequire("cDLTA");
var $aWLVm = parcelRequire("aWLVm");

var $T1aHH = parcelRequire("T1aHH");

var $irKna = parcelRequire("irKna");

var $6A3Cx = parcelRequire("6A3Cx");

var $jCanu = parcelRequire("jCanu");
const $64f741f5091bada0$export$b8ff69f9ebbd4592 = ({ thirdParty: thirdParty })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ thirdPartyStatusMapping: thirdPartyStatusMapping }] = (0, $irKna.useThirdPartyState)();
    const entities = (0, $eUqFw.useMemo)(()=>Object.keys(thirdPartyStatusMapping?.entityStatusMappings ?? {}), [
        thirdPartyStatusMapping?.entityStatusMappings
    ]);
    const defaultEntity = entities && entities.length > 0 && entities[0] || null;
    const [selectedEntityTab, setselectedEntityTab] = (0, $eUqFw.useState)(defaultEntity);
    const { statusMappingDescription: statusMappingDescription } = (0, $cDLTA.useContentForThirdParty)(thirdParty);
    const { statusMappingURL: statusMappingURL } = (0, $aWLVm.useUrlForThirdParty)(thirdParty);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $T1aHH.StatusMappingEntityContext).Provider, {
        value: selectedEntityTab
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $64f741f5091bada0$var$contentWrapperStyles,
        testId: "project-create-importer-upload-flow.ui.third-party-review-screen.status-mapping.wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1VyqP.SectionHeading), null, formatMessage((0, $6A3Cx.default).heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingBlockStart: "space.200",
        paddingBlockEnd: "space.300"
    }, statusMappingDescription && formatMessage(statusMappingDescription, {
        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                href: statusMappingURL,
                target: "_blank",
                appearance: "link",
                spacing: "none"
            }, chunks)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jCanu.StatusMappingContent), {
        thirdParty: thirdParty,
        onEntityChanged: (entity)=>{
            setselectedEntityTab(entity);
        },
        entities: entities ?? [],
        selectedEntityTab: selectedEntityTab
    })));
};
const $64f741f5091bada0$var$contentWrapperStyles = (0, $1ZAYh.xcss)({
    width: '560px',
    paddingTop: 'space.300'
});

});
parcelRegister("6A3Cx", function(module, exports) {

$parcel$export(module.exports, "default", () => $05887ac4fc838097$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $05887ac4fc838097$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    heading: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.status-mapping.heading",
        "defaultMessage": "Status mapping"
    }
});

});

parcelRegister("jCanu", function(module, exports) {

$parcel$export(module.exports, "StatusMappingContent", () => $028842fde0893c13$export$cf08f94579ec3c5a);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $9Amv1 = parcelRequire("9Amv1");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $cDLTA = parcelRequire("cDLTA");

var $f6ZAK = parcelRequire("f6ZAK");
const $028842fde0893c13$export$cf08f94579ec3c5a = ({ thirdParty: thirdParty, onEntityChanged: onEntityChanged, entities: entities, selectedEntityTab: selectedEntityTab })=>{
    const { statusMappingEntityName: statusMappingEntityName } = (0, $cDLTA.useContentForThirdParty)(thirdParty);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, entities.length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        space: "space.100",
        xcss: $028842fde0893c13$var$tabHeaderStyles,
        grow: "fill",
        spread: "space-between",
        shouldWrap: true,
        rowSpace: "space.150",
        testId: "project-create-importer-upload-flow.ui.third-party-review-screen.status-mapping.status-mapping-content.status-mapping-content-tab-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        alignItems: "center",
        gap: "space.100",
        xcss: $028842fde0893c13$var$tabContentStyles
    }, statusMappingEntityName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $028842fde0893c13$var$textStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        align: "center"
    }, statusMappingEntityName)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        gap: "space.100",
        xcss: $028842fde0893c13$var$tabsStyles
    }, entities.map((entity)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($028842fde0893c13$var$StyledButton, {
            key: entity,
            appearance: "default",
            onClick: ()=>onEntityChanged(entity),
            isSelected: selectedEntityTab === entity
        }, entity))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f6ZAK.StatusTable), {
        thirdParty: thirdParty
    }));
};
const $028842fde0893c13$var$tabHeaderStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.150',
    marginBottom: 'space.100'
});
const $028842fde0893c13$var$textStyles = (0, $1ZAYh.xcss)({
    minWidth: '70px',
    fontSize: '12px',
    fontWeight: 500,
    paddingTop: 'space.050',
    paddingBottom: 'space.075'
});
const $028842fde0893c13$var$tabContentStyles = (0, $1ZAYh.xcss)({
    maxWidth: '100%',
    minWidth: '75%',
    flexGrow: 1
});
const $028842fde0893c13$var$tabsStyles = (0, $1ZAYh.xcss)({
    overflow: 'auto',
    padding: 'space.050',
    paddingBottom: 'space.075'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $028842fde0893c13$var$StyledButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1tnqgktf _nmk41dk0",
            __cmplp.className
        ])
    });
});

});
parcelRegister("f6ZAK", function(module, exports) {

$parcel$export(module.exports, "StatusTable", () => $e343961db44d4fbf$export$c849b5d47a9c2fe0);

var $eUqFw = parcelRequire("eUqFw");

var $cSu9v = parcelRequire("cSu9v");

var $77CtJ = parcelRequire("77CtJ");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7J5LG = parcelRequire("7J5LG");

var $fQU5k = parcelRequire("fQU5k");

var $T1aHH = parcelRequire("T1aHH");

var $irKna = parcelRequire("irKna");

var $4R50N = parcelRequire("4R50N");

var $96OPN = parcelRequire("96OPN");

var $9ptQI = parcelRequire("9ptQI");
const $e343961db44d4fbf$export$c849b5d47a9c2fe0 = ({ thirdParty: thirdParty })=>{
    const tableHead = $e343961db44d4fbf$export$ba0aa44e07bbfb57(thirdParty);
    const tableRows = $e343961db44d4fbf$var$useStatusTableRows();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingBlockStart: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fQU5k.AsyncMappingTable), {
        head: tableHead,
        rows: tableRows,
        rowsPerPage: 6,
        emptyMessage: (0, $96OPN.default).noStatus
    }));
};
const $e343961db44d4fbf$export$ba0aa44e07bbfb57 = (thirdParty)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const tool = (0, $4R50N.useImportTool)(thirdParty);
    return (0, $eUqFw.useMemo)(()=>({
            cells: [
                {
                    key: 'thirdPartyStatus',
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
                        space: "space.050",
                        alignBlock: "center"
                    }, tool && (0, $7J5LG.renderIcon)(tool?.icon, true), `${tool?.name} ${formatMessage((0, $96OPN.default).statusHeader)}`)
                },
                {
                    key: 'arrow',
                    width: 5
                },
                {
                    key: 'jiraStatus',
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
                        space: "space.050",
                        alignBlock: "center"
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77CtJ.JiraIcon), {
                        size: "small",
                        appearance: "brand"
                    }), formatMessage((0, $96OPN.default).jira)),
                    width: 40
                }
            ]
        }), [
        formatMessage,
        tool
    ]);
};
const $e343961db44d4fbf$var$useStatusTableRows = ()=>{
    const [{ thirdPartyStatusMapping: thirdPartyStatusMapping }] = (0, $irKna.useThirdPartyState)();
    const selectedEntity = (0, $T1aHH.useStatusMappingEntityContext)();
    if (!thirdPartyStatusMapping || !selectedEntity) return undefined;
    const statusMappings = thirdPartyStatusMapping?.entityStatusMappings[selectedEntity].statusMappings;
    return Object.entries(statusMappings).map(([statusName, mappedStatus])=>({
            key: statusName,
            cells: [
                {
                    key: `${statusName}-thirdParty`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                        xcss: $e343961db44d4fbf$var$thirdPartyStatusColumnStyle
                    }, statusName)
                },
                {
                    key: `${statusName}-arrow`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
                        size: "medium",
                        label: "Arrow Right"
                    })
                },
                {
                    key: `${statusName}-jira`,
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9ptQI.StatusSelector), {
                        selectedStatus: {
                            sourceStatusName: statusName,
                            ...mappedStatus
                        }
                    })
                }
            ]
        }));
};
const $e343961db44d4fbf$var$thirdPartyStatusColumnStyle = (0, $1ZAYh.xcss)({
    textTransform: 'capitalize'
});

});
parcelRegister("96OPN", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4357bd957c7336a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c4357bd957c7336a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    jira: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.status-mapping.status-mapping-content.status-table.jira",
        "defaultMessage": "Jira status"
    },
    noStatus: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.status-mapping.status-mapping-content.status-table.no-status",
        "defaultMessage": "There are no status in your selected list."
    },
    statusHeader: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.status-mapping.status-mapping-content.status-table.status-header",
        "defaultMessage": "status"
    }
});

});

parcelRegister("9ptQI", function(module, exports) {

$parcel$export(module.exports, "StatusSelector", () => $a5155dc0e2c6bd4b$export$73bf5bb44ab352ee);

var $eUqFw = parcelRequire("eUqFw");

var $ffiyv = parcelRequire("ffiyv");

var $dxopF = parcelRequire("dxopF");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $28t3A = parcelRequire("28t3A");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $irKna = parcelRequire("irKna");

var $7qxDu = parcelRequire("7qxDu");

var $irjtd = parcelRequire("irjtd");

var $hORHV = parcelRequire("hORHV");

var $axv8x = parcelRequire("axv8x");

var $eWhGk = parcelRequire("eWhGk");
const $a5155dc0e2c6bd4b$export$73bf5bb44ab352ee = ({ selectedStatus: selectedStatus })=>{
    const [, { setThirdPartyStatusMapping: setThirdPartyStatusMapping }] = (0, $7qxDu.useThirdPartyStatusMappingState)();
    const [{ thirdPartyStatusMapping: thirdPartyStatusMapping }] = (0, $irKna.useThirdPartyState)();
    const [isModalOpen, setIsModalOpen] = (0, $eUqFw.useState)(false);
    const [newStatusName, setNewStatusName] = (0, $eUqFw.useState)('');
    const focusRef = (0, $eUqFw.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [, { setUIState: setUIState }] = (0, $irjtd.useUIState)();
    const formattedOptions = (0, $eWhGk.useStatusOptions)((thirdPartyStatusMapping?.statusOptions ?? []).concat(thirdPartyStatusMapping?.availableJiraStatuses ?? []));
    const statusValue = (0, $eUqFw.useMemo)(()=>{
        const matchedStatus = formattedOptions.filter((statusOptions)=>statusOptions.value.toLocaleLowerCase() === selectedStatus?.mappedStatusName.toLocaleLowerCase());
        return matchedStatus.length > 0 ? matchedStatus[0] : null;
    }, [
        formattedOptions,
        selectedStatus?.mappedStatusName
    ]);
    const updateOptionsOrder = (0, $eUqFw.useCallback)((options, currentStatus)=>{
        const isCurrentInStatusOptions = thirdPartyStatusMapping?.statusOptions.find((status)=>status.name.toLocaleLowerCase() === currentStatus.value.toLocaleLowerCase());
        if (!isCurrentInStatusOptions) {
            const updatedOptions = options.filter((option)=>option.value.toLocaleLowerCase() !== currentStatus.value.toLocaleLowerCase());
            updatedOptions.unshift(currentStatus);
            return updatedOptions;
        }
        return options;
    }, [
        thirdPartyStatusMapping?.statusOptions
    ]);
    const getLozenge = (0, $eUqFw.useCallback)((option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
            appearance: option.appearance
        }, option.label), []);
    const handleCreateLabel = (inputValue)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, inputValue, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
            size: "small"
        }, "(", formatMessage((0, $axv8x.default).addStatus), ")"));
    const handleModalClose = (0, $eUqFw.useCallback)(()=>setIsModalOpen(false), []);
    const handleOnChange = (0, $eUqFw.useCallback)((option)=>{
        if (option && selectedStatus) {
            setThirdPartyStatusMapping({
                sourceStatusName: selectedStatus.sourceStatusName,
                mappedStatusName: option.value,
                statusCategory: option.statusCategory
            });
            setUIState({
                hasUnsavedStatusMappingChanges: true
            });
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'projectStatusSelector'
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'statusItem changed', {
                selectedStatus: option.value,
                sourceStatus: selectedStatus.sourceStatusName
            });
        }
    }, [
        createAnalyticsEvent,
        selectedStatus,
        setThirdPartyStatusMapping,
        setUIState
    ]);
    const onStatusCreate = (inputValue)=>{
        setNewStatusName(inputValue);
        setIsModalOpen(true);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $a5155dc0e2c6bd4b$var$selectWrapperStyle,
        testId: "project-create-importer-upload-flow.ui.third-party-review-screen.status-mapping.status-mapping-content.status-table.status-selector.menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $28t3A.default), {
        ref: focusRef,
        inputId: `status-select-${selectedStatus?.sourceStatusName}`,
        placeholder: formatMessage((0, $axv8x.default).statusMappingPlaceholder),
        options: statusValue ? updateOptionsOrder(formattedOptions, statusValue) : formattedOptions,
        value: statusValue,
        formatOptionLabel: getLozenge,
        onCreateOption: onStatusCreate,
        formatCreateLabel: handleCreateLabel,
        onChange: handleOnChange,
        "aria-label": `${formatMessage((0, $axv8x.default).statusMapping)}: ${formatMessage((0, $axv8x.default).statusMappingHelper)}`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hORHV.AddStatusModal), {
        onClose: handleModalClose,
        statusCategory: (selectedStatus && selectedStatus.statusCategory) ?? undefined,
        sourceStatusName: (selectedStatus && selectedStatus.sourceStatusName) ?? undefined,
        focusRef: focusRef,
        newStatusName: newStatusName
    })));
};
const $a5155dc0e2c6bd4b$var$selectWrapperStyle = (0, $1ZAYh.xcss)({
    width: '275px'
});

});
parcelRegister("28t3A", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ab404645f53318b$export$2e2bcd8739ae039);

var $lOwgQ = parcelRequire("lOwgQ");

var $5FjBr = parcelRequire("5FjBr");
var $2ab404645f53318b$export$2e2bcd8739ae039 = (0, $5FjBr.default)((0, $lOwgQ.default));

});
parcelRegister("lOwgQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe174cca2c039728$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useCreatable", () => (parcelRequire("6xNN4")).u);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $cEc3i = parcelRequire("cEc3i");

var $7IqRg = parcelRequire("7IqRg");

var $6xNN4 = parcelRequire("6xNN4");
parcelRequire("1Xn5q");
parcelRequire("lDSrn");
parcelRequire("lIEGP");
parcelRequire("eT4IF");
parcelRequire("7Dzgl");
parcelRequire("fVK4C");


parcelRequire("aKcqM");
parcelRequire("bwPfh");
parcelRequire("5sKOb");
parcelRequire("jqNEH");
parcelRequire("5zQU9");
parcelRequire("lEfVV");

parcelRequire("k286k");

var $fe174cca2c039728$var$CreatableSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function(props, ref) {
    var creatableProps = (0, $7IqRg.u)(props);
    var selectProps = (0, $6xNN4.u)(creatableProps);
    return /*#__PURE__*/ $eUqFw.createElement((0, $cEc3i.S), (0, $kU09D.default)({
        ref: ref
    }, selectProps));
});
var $fe174cca2c039728$export$2e2bcd8739ae039 = $fe174cca2c039728$var$CreatableSelect;

});
parcelRegister("6xNN4", function(module, exports) {

$parcel$export(module.exports, "u", () => $4c3c7280e822f6fb$export$3b14a55fb2447963);

var $1Xn5q = parcelRequire("1Xn5q");

var $fVK4C = parcelRequire("fVK4C");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $cEc3i = parcelRequire("cEc3i");
var $4c3c7280e822f6fb$var$_excluded = [
    "allowCreateWhileLoading",
    "createOptionPosition",
    "formatCreateLabel",
    "isValidNewOption",
    "getNewOptionData",
    "onCreateOption",
    "options",
    "onChange"
];
var $4c3c7280e822f6fb$var$compareOption = function compareOption() {
    var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var option = arguments.length > 1 ? arguments[1] : undefined;
    var accessors = arguments.length > 2 ? arguments[2] : undefined;
    var candidate = String(inputValue).toLowerCase();
    var optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    var optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
var $4c3c7280e822f6fb$var$builtins = {
    formatCreateLabel: function formatCreateLabel(inputValue) {
        return "Create \"".concat(inputValue, "\"");
    },
    isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions, accessors) {
        return !(!inputValue || selectValue.some(function(option) {
            return $4c3c7280e822f6fb$var$compareOption(inputValue, option, accessors);
        }) || selectOptions.some(function(option) {
            return $4c3c7280e822f6fb$var$compareOption(inputValue, option, accessors);
        }));
    },
    getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
        return {
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        };
    }
};
function $4c3c7280e822f6fb$export$3b14a55fb2447963(_ref) {
    var _ref$allowCreateWhile = _ref.allowCreateWhileLoading, allowCreateWhileLoading = _ref$allowCreateWhile === void 0 ? false : _ref$allowCreateWhile, _ref$createOptionPosi = _ref.createOptionPosition, createOptionPosition = _ref$createOptionPosi === void 0 ? 'last' : _ref$createOptionPosi, _ref$formatCreateLabe = _ref.formatCreateLabel, formatCreateLabel = _ref$formatCreateLabe === void 0 ? $4c3c7280e822f6fb$var$builtins.formatCreateLabel : _ref$formatCreateLabe, _ref$isValidNewOption = _ref.isValidNewOption, isValidNewOption = _ref$isValidNewOption === void 0 ? $4c3c7280e822f6fb$var$builtins.isValidNewOption : _ref$isValidNewOption, _ref$getNewOptionData = _ref.getNewOptionData, getNewOptionData = _ref$getNewOptionData === void 0 ? $4c3c7280e822f6fb$var$builtins.getNewOptionData : _ref$getNewOptionData, onCreateOption = _ref.onCreateOption, _ref$options = _ref.options, propsOptions = _ref$options === void 0 ? [] : _ref$options, propsOnChange = _ref.onChange, restSelectProps = (0, $bwPfh.default)(_ref, $4c3c7280e822f6fb$var$_excluded);
    var _restSelectProps$getO = restSelectProps.getOptionValue, getOptionValue$1 = _restSelectProps$getO === void 0 ? (0, $cEc3i.g) : _restSelectProps$getO, _restSelectProps$getO2 = restSelectProps.getOptionLabel, getOptionLabel$1 = _restSelectProps$getO2 === void 0 ? (0, $cEc3i.b) : _restSelectProps$getO2, inputValue = restSelectProps.inputValue, isLoading = restSelectProps.isLoading, isMulti = restSelectProps.isMulti, value = restSelectProps.value, name = restSelectProps.name;
    var newOption = (0, $eUqFw.useMemo)(function() {
        return isValidNewOption(inputValue, (0, $jQxSL.I)(value), propsOptions, {
            getOptionValue: getOptionValue$1,
            getOptionLabel: getOptionLabel$1
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined;
    }, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel$1,
        getOptionValue$1,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    var options = (0, $eUqFw.useMemo)(function() {
        return (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
            newOption
        ].concat((0, $fVK4C.default)(propsOptions)) : [].concat((0, $fVK4C.default)(propsOptions), [
            newOption
        ]) : propsOptions;
    }, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    var onChange = (0, $eUqFw.useCallback)(function(newValue, actionMeta) {
        if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
        var valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                var newOptionData = getNewOptionData(inputValue, inputValue);
                var newActionMeta = {
                    action: 'create-option',
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, $jQxSL.D)(isMulti, [].concat((0, $fVK4C.default)((0, $jQxSL.I)(value)), [
                    newOptionData
                ]), newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, restSelectProps), {}, {
        options: options,
        onChange: onChange
    });
}

});



parcelRegister("hORHV", function(module, exports) {

$parcel$export(module.exports, "AddStatusModal", () => $1b364541b225897c$export$c3146321ad4e42e0);

var $eUqFw = parcelRequire("eUqFw");

var $6zOB7 = parcelRequire("6zOB7");

var $lzLxZ = parcelRequire("lzLxZ");
var $7jPhn = parcelRequire("7jPhn");
var $4LhB6 = parcelRequire("4LhB6");
var $7CD1S = parcelRequire("7CD1S");
var $aYQ0Q = parcelRequire("aYQ0Q");
var $bKkhQ = parcelRequire("bKkhQ");

var $jgrQL = parcelRequire("jgrQL");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $5wCDk = parcelRequire("5wCDk");

var $cf2Y4 = parcelRequire("cf2Y4");

var $PdmhA = parcelRequire("PdmhA");

var $kGQen = parcelRequire("kGQen");

var $8Qd0L = parcelRequire("8Qd0L");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $irKna = parcelRequire("irKna");

var $7qxDu = parcelRequire("7qxDu");

var $irjtd = parcelRequire("irjtd");

var $f5VLo = parcelRequire("f5VLo");
const $1b364541b225897c$export$c3146321ad4e42e0 = ({ onClose: onClose, statusCategory: statusCategory, sourceStatusName: sourceStatusName, newStatusName: newStatusName, focusRef: focusRef })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const categoryStatusOptions = $1b364541b225897c$var$useCategoryStatusOptions();
    const [{ thirdPartyStatusMapping: thirdPartyStatusMapping }, { setThirdPartyStatusOption: setThirdPartyStatusOption }] = (0, $irKna.useThirdPartyState)();
    const preSelectedCategory = (0, $eUqFw.useMemo)(()=>categoryStatusOptions.find((option)=>option.value === statusCategory), [
        categoryStatusOptions,
        statusCategory
    ]);
    const [statusName, setStatusName] = (0, $eUqFw.useState)(newStatusName ?? '');
    const [statusNameError, setStatusNameError] = (0, $eUqFw.useState)(null);
    const [selectedStatusCategory, setSelectedStatusCategory] = (0, $eUqFw.useState)(preSelectedCategory ?? null);
    const [, { setThirdPartyStatusMapping: setThirdPartyStatusMapping }] = (0, $7qxDu.useThirdPartyStatusMappingState)();
    const [, { setUIState: setUIState }] = (0, $irjtd.useUIState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const existingStatuses = (0, $eUqFw.useMemo)(()=>(thirdPartyStatusMapping && thirdPartyStatusMapping.availableJiraStatuses.concat(thirdPartyStatusMapping.statusOptions).map((status)=>status.name.toLocaleLowerCase())) ?? [], [
        thirdPartyStatusMapping
    ]);
    const onStatusCategoryChange = (selectedOption)=>{
        if (selectedOption) setSelectedStatusCategory(selectedOption);
    };
    const getStatusCategoryStyle = (0, $eUqFw.useCallback)((category)=>{
        switch(category){
            case 0, $8Qd0L.IN_PROGRESS:
                return $1b364541b225897c$var$inProgressStatus;
            case 0, $8Qd0L.DONE:
                return $1b364541b225897c$var$doneStatus;
            default:
                return $1b364541b225897c$var$defaultStatus;
        }
    }, []);
    const formatOption = (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            space: "space.075",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: [
                $1b364541b225897c$var$statusCategoryColorBase,
                getStatusCategoryStyle(option.value)
            ]
        }), option.label);
    const handleBlur = (0, $eUqFw.useCallback)(()=>{
        const matchedStatus = existingStatuses.filter((existingStatus)=>existingStatus === statusName.toLocaleLowerCase());
        if (matchedStatus.length > 0) return setStatusNameError(formatMessage((0, $f5VLo.default).statusNameAlreadyExistsError));
        if (statusName.trim().length === 0) return setStatusNameError(formatMessage((0, $f5VLo.default).statusNameBlankError));
        return setStatusNameError(null);
    }, [
        existingStatuses,
        formatMessage,
        statusName
    ]);
    const handleChange = (0, $eUqFw.useCallback)((e)=>{
        setStatusName(e.target.value);
    }, []);
    const handleClose = (0, $eUqFw.useCallback)(()=>{
        setStatusName('');
        setStatusNameError(null);
        onClose();
    }, [
        onClose
    ]);
    const handleSubmit = (0, $eUqFw.useCallback)(()=>{
        if (statusName && statusNameError === null && sourceStatusName && selectedStatusCategory && selectedStatusCategory.value !== null) {
            setThirdPartyStatusOption({
                name: statusName,
                statusCategory: selectedStatusCategory.value
            });
            setThirdPartyStatusMapping({
                sourceStatusName: sourceStatusName,
                mappedStatusName: statusName,
                statusCategory: selectedStatusCategory.value
            });
            setUIState({
                hasUnsavedStatusMappingChanges: true
            });
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'statusItem added', {
                selectedStatus: statusName,
                sourceStatus: sourceStatusName
            });
            handleClose();
        }
    }, [
        createAnalyticsEvent,
        handleClose,
        selectedStatusCategory,
        setThirdPartyStatusMapping,
        setThirdPartyStatusOption,
        setUIState,
        sourceStatusName,
        statusName,
        statusNameError
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onClose: handleClose,
        onCloseComplete: ()=>focusRef?.current?.focus(),
        width: "small",
        label: formatMessage((0, $f5VLo.default).modalHeader),
        shouldReturnFocus: false,
        testId: "project-create-importer-upload-flow.ui.third-party-review-screen.status-mapping.status-mapping-content.status-table.status-selector.add-status-modal.modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $1b364541b225897c$var$formWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lzLxZ.default), {
        onSubmit: handleSubmit
    }, ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aYQ0Q.default), {
            title: formatMessage((0, $f5VLo.default).modalHeader)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bKkhQ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $1b364541b225897c$var$fieldWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
            "aria-required": true,
            label: formatMessage((0, $f5VLo.default).statusNameLabel),
            name: "statusName",
            isRequired: true
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
                ...fieldProps,
                id: "project-create-importer-upload-flow.ui.third-party-review-screen.status-mapping.status-mapping-content.status-table.status-selector.add-status-modal.statusName-input",
                autoComplete: "off",
                "aria-label": formatMessage((0, $f5VLo.default).statusNameLabel),
                placeholder: formatMessage((0, $f5VLo.default).statusNamePlaceholder),
                maxLength: 60,
                onBlur: handleBlur,
                onChange: handleChange,
                value: statusName
            }), statusNameError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, statusNameError)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $1b364541b225897c$var$fieldWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
            "aria-required": true,
            label: formatMessage((0, $f5VLo.default).statusCategoryLabel),
            name: "statusCategory",
            isRequired: true
        }, ({ fieldProps: { id: id, ...rest } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
                inputId: "project-create-importer-upload-flow.ui.third-party-review-screen.status-mapping.status-mapping-content.status-table.status-selector.add-status-modal.statusCategory",
                ...rest,
                options: categoryStatusOptions,
                onChange: onStatusCategoryChange,
                value: selectedStatusCategory,
                formatOptionLabel: formatOption
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.HelperMessage), null, formatMessage((0, $f5VLo.default).statusCategoryHelper))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $1b364541b225897c$var$sectionWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
            space: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jgrQL))), {
            label: ""
        }), formatMessage((0, $f5VLo.default).newStatusInfoMessage)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7CD1S.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
            appearance: "subtle",
            onClick: handleClose
        }, formatMessage((0, $f5VLo.default).cancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
            appearance: "primary",
            type: "submit",
            isLoading: submitting
        }, formatMessage((0, $f5VLo.default).addButton)))))))));
};
const $1b364541b225897c$var$useCategoryStatusOptions = ()=>{
    const [{ statusCategories: statusCategories }] = (0, $7qxDu.useThirdPartyStatusCategories)();
    return statusCategories.map((category)=>({
            label: $1b364541b225897c$var$capitalizeFirstLetter(category.replace('_', ' ').toLocaleLowerCase()),
            value: category
        }));
};
const $1b364541b225897c$var$capitalizeFirstLetter = (str)=>str != null && str.charAt(0).toUpperCase() + str.slice(1) || '';
const $1b364541b225897c$var$formWrapperStyles = (0, $1ZAYh.xcss)({
    marginBlock: 'space.300'
});
const $1b364541b225897c$var$fieldWrapperStyles = (0, $1ZAYh.xcss)({
    paddingBottom: 'space.150'
});
const $1b364541b225897c$var$sectionWrapper = (0, $1ZAYh.xcss)({
    paddingTop: 'space.150',
    color: 'color.text.subtlest'
});
const $1b364541b225897c$var$statusCategoryColorBase = (0, $1ZAYh.xcss)({
    width: '16px',
    height: '16px',
    borderRadius: 'border.radius.050'
});
const $1b364541b225897c$var$doneStatus = (0, $1ZAYh.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    border: `1px solid ${`var(--ds-icon-accent-green, ${(0, $PdmhA).G300})`}`,
    backgroundColor: 'color.background.success'
});
const $1b364541b225897c$var$inProgressStatus = (0, $1ZAYh.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    border: `1px solid ${`var(--ds-icon-accent-blue, ${(0, $PdmhA).B100})`}`,
    backgroundColor: 'color.background.information'
});
const $1b364541b225897c$var$defaultStatus = (0, $1ZAYh.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    border: `1px solid ${`var(--ds-border-bold, ${(0, $PdmhA).N70})`}`,
    backgroundColor: 'color.background.neutral'
});

});
parcelRegister("aYQ0Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $97ae6dd46b7e11ec$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $hI5oG = parcelRequire("hI5oG");

var $XHGTv = parcelRequire("XHGTv");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $4lTFP = parcelRequire("4lTFP");
function $97ae6dd46b7e11ec$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $97ae6dd46b7e11ec$var$formHeaderContentStyles = (0, $1ZAYh.xcss)({
    minWidth: '100%',
    marginBlockStart: 'space.100'
});
const $97ae6dd46b7e11ec$var$formHeaderDescriptionStyles = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.100'
});
const $97ae6dd46b7e11ec$var$formHeaderTitleStyles = {
    name: "1eccq1n",
    styles: "line-height:var(--ds-font-lineHeight-500, 32px);margin-block-start:0;margin-inline-end:var(--ds-space-400, 32px);overflow:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $97ae6dd46b7e11ec$var$formHeaderWrapperStyles = {
    name: "xzr008",
    styles: "font-family:var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $97ae6dd46b7e11ec$var$lightH700Styles = /*#__PURE__*/ (0, $byn9U.css)((0, $4lTFP.h700)({
    theme: {
        mode: 'light'
    }
}));
const $97ae6dd46b7e11ec$export$2328f6c3afc53a3c = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $97ae6dd46b7e11ec$var$formHeaderContentStyles
    }, children);
};
const $97ae6dd46b7e11ec$export$fc2f92b09a865fbb = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $97ae6dd46b7e11ec$var$formHeaderDescriptionStyles
    }, children);
};
const $97ae6dd46b7e11ec$export$979afebc6a69047 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("h2", {
        css: [
            $97ae6dd46b7e11ec$var$lightH700Styles,
            $97ae6dd46b7e11ec$var$formHeaderTitleStyles
        ]
    }, children);
};
const $97ae6dd46b7e11ec$var$FormHeaderWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $97ae6dd46b7e11ec$var$formHeaderWrapperStyles
    }, children);
};
/**
 * __Form header__.
 *
 * A form header contains the form component's heading and subheadings. This provides the correct padding
 * and styling for it.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout).
 */ const $97ae6dd46b7e11ec$var$FormHeader = ({ children: children, description: description, title: title })=>{
    return (0, $XHGTv.getBooleanFF)('platform.design-system-team.form-header-typography-updates_4f1g6') ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), null, title && /*#__PURE__*/ (0, $byn9U.jsx)((0, $hI5oG.default), {
        size: "large"
    }, title), description && /*#__PURE__*/ (0, $byn9U.jsx)($97ae6dd46b7e11ec$export$fc2f92b09a865fbb, null, description), children && /*#__PURE__*/ (0, $byn9U.jsx)($97ae6dd46b7e11ec$export$2328f6c3afc53a3c, null, children)) : /*#__PURE__*/ (0, $byn9U.jsx)($97ae6dd46b7e11ec$var$FormHeaderWrapper, null, title && /*#__PURE__*/ (0, $byn9U.jsx)($97ae6dd46b7e11ec$export$979afebc6a69047, null, title), description && /*#__PURE__*/ (0, $byn9U.jsx)($97ae6dd46b7e11ec$export$fc2f92b09a865fbb, null, description), children && /*#__PURE__*/ (0, $byn9U.jsx)($97ae6dd46b7e11ec$export$2328f6c3afc53a3c, null, children));
};
var $97ae6dd46b7e11ec$export$2e2bcd8739ae039 = $97ae6dd46b7e11ec$var$FormHeader;

});

parcelRegister("bKkhQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c95da9811468ff1e$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $hI5oG = parcelRequire("hI5oG");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $c95da9811468ff1e$var$formSectionDescriptionStyles = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.100'
});
const $c95da9811468ff1e$var$formSectionWrapperStyles = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.300'
});
const $c95da9811468ff1e$var$FormSectionWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $c95da9811468ff1e$var$formSectionWrapperStyles
    }, children);
};
const $c95da9811468ff1e$var$FormSectionDescription = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $c95da9811468ff1e$var$formSectionDescriptionStyles
    }, children);
};
/**
 * __Form section__.
 *
 * A form section is used to define a section of a form layout. This contains a section title, content
 * and a description of the section.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout).
 */ const $c95da9811468ff1e$var$FormSection = ({ children: children, description: description, title: title })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)($c95da9811468ff1e$var$FormSectionWrapper, null, title && /*#__PURE__*/ (0, $byn9U.jsx)((0, $hI5oG.default), {
        size: "medium"
    }, title), description && /*#__PURE__*/ (0, $byn9U.jsx)($c95da9811468ff1e$var$FormSectionDescription, null, description), children);
};
var $c95da9811468ff1e$export$2e2bcd8739ae039 = $c95da9811468ff1e$var$FormSection;

});

parcelRegister("jgrQL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e0651d627acb5549$var$_react = $e0651d627acb5549$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $e0651d627acb5549$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $e0651d627acb5549$var$EditorInfoIcon = (props)=>/*#__PURE__*/ $e0651d627acb5549$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12 20a8 8 0 110-16 8 8 0 010 16zm0-8.5a1 1 0 00-1 1V15a1 1 0 002 0v-2.5a1 1 0 00-1-1zm0-1.125a1.375 1.375 0 100-2.75 1.375 1.375 0 000 2.75z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$e0651d627acb5549$var$EditorInfoIcon.displayName = 'EditorInfoIcon';
var $e0651d627acb5549$var$_default = $e0651d627acb5549$var$EditorInfoIcon;
module.exports.default = $e0651d627acb5549$var$_default;

});

parcelRegister("8Qd0L", function(module, exports) {

$parcel$export(module.exports, "UNDEFINED", () => $e7c4cf297fb3917f$export$6db089fe7b26f5b6);
$parcel$export(module.exports, "TODO", () => $e7c4cf297fb3917f$export$aa456a5030160740);
$parcel$export(module.exports, "IN_PROGRESS", () => $e7c4cf297fb3917f$export$5a9ac66c2785cc13);
$parcel$export(module.exports, "DONE", () => $e7c4cf297fb3917f$export$71efb3495f6084f2);
$parcel$export(module.exports, "STATUS_CATEGORIES", () => $e7c4cf297fb3917f$export$d9119300f9d9a815);
$parcel$export(module.exports, "StatusCategoryTypes", () => $e7c4cf297fb3917f$export$5d42a08d46cffe7);
$parcel$export(module.exports, "StatusCategoryIds", () => $e7c4cf297fb3917f$export$3f42f49c284d5b58);
$parcel$export(module.exports, "statusCategoryKeys", () => $e7c4cf297fb3917f$export$f3f919dc0f56d9eb);
$parcel$export(module.exports, "statusCategoryForId", () => $e7c4cf297fb3917f$export$3e9e3002956ff4fb);
$parcel$export(module.exports, "categoryIdForStatusCategory", () => $e7c4cf297fb3917f$export$7b16b0022aac2d46);
$parcel$export(module.exports, "isValidStatusCategoryKey", () => $e7c4cf297fb3917f$export$d928f247c903643a);
const $e7c4cf297fb3917f$export$6db089fe7b26f5b6 = 'UNDEFINED';
const $e7c4cf297fb3917f$export$aa456a5030160740 = 'TODO';
const $e7c4cf297fb3917f$export$5a9ac66c2785cc13 = 'IN_PROGRESS';
const $e7c4cf297fb3917f$export$71efb3495f6084f2 = 'DONE';
const $e7c4cf297fb3917f$export$d9119300f9d9a815 = [
    $e7c4cf297fb3917f$export$6db089fe7b26f5b6,
    $e7c4cf297fb3917f$export$aa456a5030160740,
    $e7c4cf297fb3917f$export$5a9ac66c2785cc13,
    $e7c4cf297fb3917f$export$71efb3495f6084f2
];
const $e7c4cf297fb3917f$var$statusCategories = [
    {
        id: '1',
        statusCategory: $e7c4cf297fb3917f$export$6db089fe7b26f5b6
    },
    {
        id: '2',
        statusCategory: $e7c4cf297fb3917f$export$aa456a5030160740
    },
    {
        id: '4',
        statusCategory: $e7c4cf297fb3917f$export$5a9ac66c2785cc13
    },
    {
        id: '3',
        statusCategory: $e7c4cf297fb3917f$export$71efb3495f6084f2
    }
];
const $e7c4cf297fb3917f$export$5d42a08d46cffe7 = Object.freeze({
    NEW: 'new',
    INDETERMINATE: 'indeterminate',
    DONE: 'done',
    UNDEFINED: 'undefined'
});
const $e7c4cf297fb3917f$export$3f42f49c284d5b58 = Object.freeze({
    [$e7c4cf297fb3917f$export$5d42a08d46cffe7.UNDEFINED]: 1,
    [$e7c4cf297fb3917f$export$5d42a08d46cffe7.NEW]: 2,
    [$e7c4cf297fb3917f$export$5d42a08d46cffe7.DONE]: 3,
    [$e7c4cf297fb3917f$export$5d42a08d46cffe7.INDETERMINATE]: 4
});
const $e7c4cf297fb3917f$export$f3f919dc0f56d9eb = Object.values($e7c4cf297fb3917f$export$5d42a08d46cffe7);
const $e7c4cf297fb3917f$export$3e9e3002956ff4fb = (statusCategoryId)=>{
    const value = $e7c4cf297fb3917f$var$statusCategories.find((sc)=>sc.id === String(statusCategoryId));
    return value ? value.statusCategory : $e7c4cf297fb3917f$export$6db089fe7b26f5b6;
};
const $e7c4cf297fb3917f$export$7b16b0022aac2d46 = (statusCategory)=>{
    const value = $e7c4cf297fb3917f$var$statusCategories.find((sc)=>sc.statusCategory === statusCategory);
    return Number(value ? value.id : '1');
};
const $e7c4cf297fb3917f$export$d928f247c903643a = (key)=>$e7c4cf297fb3917f$export$f3f919dc0f56d9eb.some((statusCategoryKey)=>statusCategoryKey === key);

});

parcelRegister("f5VLo", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d9d8868dce38bab$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3d9d8868dce38bab$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    modalHeader: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.status-mapping.status-mapping-content.status-table.status-selector.add-status-modal.modal-header",
        "defaultMessage": "Add a new status"
    },
    statusNameLabel: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.status-mapping.status-mapping-content.status-table.status-selector.add-status-modal.status-name-label",
        "defaultMessage": "Status name"
    },
    statusNamePlaceholder: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.status-mapping.status-mapping-content.status-table.status-selector.add-status-modal.status-name-placeholder",
        "defaultMessage": "Enter status name"
    },
    statusNameAlreadyExistsError: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.status-mapping.status-mapping-content.status-table.status-selector.add-status-modal.status-name-already-exists-error",
        "defaultMessage": "A status with that name already exists, please enter a different name."
    },
    statusNameBlankError: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.status-mapping.status-mapping-content.status-table.status-selector.add-status-modal.status-name-blank-error",
        "defaultMessage": "Status name cannot blank, please enter a different name."
    },
    statusCategoryLabel: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.status-mapping.status-mapping-content.status-table.status-selector.add-status-modal.status-category-label",
        "defaultMessage": "Status category"
    },
    statusCategoryHelper: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.status-mapping.status-mapping-content.status-table.status-selector.add-status-modal.status-category-helper",
        "defaultMessage": "Categories group multiple statuses of the same kind."
    },
    cancelButton: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.status-mapping.status-mapping-content.status-table.status-selector.add-status-modal.cancel-button",
        "defaultMessage": "Cancel"
    },
    addButton: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.status-mapping.status-mapping-content.status-table.status-selector.add-status-modal.add-button",
        "defaultMessage": "Add"
    },
    newStatusInfoMessage: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.status-mapping.status-mapping-content.status-table.status-selector.add-status-modal.new-status-info-message",
        "defaultMessage": "This status will be added to all the Lists in this project."
    }
});

});


parcelRegister("axv8x", function(module, exports) {

$parcel$export(module.exports, "default", () => $751bc5f3d73e23b3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $751bc5f3d73e23b3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    statusMapping: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.status-mapping.status-mapping-content.status-table.status-selector.status-mapping",
        "defaultMessage": "Status mapping"
    },
    statusMappingPlaceholder: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.status-mapping.status-mapping-content.status-table.status-selector.status-mapping-placeholder",
        "defaultMessage": "Select or add a status"
    },
    statusMappingHelper: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.status-mapping.status-mapping-content.status-table.status-selector.status-mapping-helper",
        "defaultMessage": "Start typing to search or add a custom status"
    },
    todo: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.status-mapping.status-mapping-content.status-table.status-selector.todo",
        "defaultMessage": "To do"
    },
    inprogress: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.status-mapping.status-mapping-content.status-table.status-selector.inprogress",
        "defaultMessage": "In progress"
    },
    done: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.status-mapping.status-mapping-content.status-table.status-selector.done",
        "defaultMessage": "Done"
    },
    addStatus: {
        "id": "project-create-importer-upload-flow.third-party-review-screen.status-mapping.status-mapping-content.status-table.status-selector.add-status",
        "defaultMessage": "new status"
    }
});

});

parcelRegister("eWhGk", function(module, exports) {

$parcel$export(module.exports, "useStatusOptions", () => $54260b8246921f97$export$c38601914b3ccefd);

var $8Qd0L = parcelRequire("8Qd0L");
const $54260b8246921f97$export$4d9e331cafeacb9d = (statusCategory)=>{
    switch(statusCategory){
        case 0, $8Qd0L.IN_PROGRESS:
            return 'inprogress';
        case 0, $8Qd0L.DONE:
            return 'success';
        default:
            return 'default';
    }
};
const $54260b8246921f97$export$c38601914b3ccefd = (thirdPartyOptions)=>thirdPartyOptions.filter((obj1, i, arr)=>arr.findIndex((obj2)=>obj2.name === obj1.name) === i).map((status)=>({
            label: status.name,
            value: status.name,
            statusCategory: status.statusCategory,
            appearance: $54260b8246921f97$export$4d9e331cafeacb9d(status.statusCategory)
        }));

});






parcelRegister("1SsJn", function(module, exports) {

$parcel$export(module.exports, "UploadScreen", () => $84c0022c3963701d$export$413ba8a319ab0e3e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $gpZWO = parcelRequire("gpZWO");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $8vncz = parcelRequire("8vncz");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $gd0Sp = parcelRequire("gd0Sp");

var $kzTj7 = parcelRequire("kzTj7");

var $3yuWi = parcelRequire("3yuWi");

var $1VyqP = parcelRequire("1VyqP");

var $cFy8W = parcelRequire("cFy8W");

var $aWLVm = parcelRequire("aWLVm");

var $deAmo = parcelRequire("deAmo");

var $bz2yd = parcelRequire("bz2yd");

var $d0wrd = parcelRequire("d0wrd");

var $2sRUp = parcelRequire("2sRUp");

var $1Vlpn = parcelRequire("1Vlpn");

var $5Zpfb = parcelRequire("5Zpfb");

var $ipvc6 = parcelRequire("ipvc6");
const $84c0022c3963701d$export$413ba8a319ab0e3e = ({ onReturn: onReturn, onNext: onNext })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { isSiteAdmin: isSiteAdmin } = (0, $gd0Sp.useTenantContext)();
    const { availableProducts: availableProducts } = (0, $deAmo.default)();
    const showReturnButton = isSiteAdmin && !(0, $aWLVm.hasOnlyJWMLicense)(availableProducts);
    const [{ type: type }] = (0, $d0wrd.useProjectData)();
    const [source] = (0, $2sRUp.useSource)();
    const { uploadHeading: uploadHeading, uploadDescription: uploadDescription } = (0, $bz2yd.useProjectSpecificContent)(type, source);
    // TODO: Don't show general importer link when user is JIRA_ADMIN but not SITE_ADMIN
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: (0, $3yuWi.X2C_SCREENS).UPLOAD_CSV,
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($84c0022c3963701d$var$Wrapper, {
        "data-testid": "project-create-importer-upload-flow.ui.upload-screen.wrapper"
    }, showReturnButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "project-create-importer-upload-flow.ui.upload-screen.return-button",
        onClick: onReturn,
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gpZWO))), {
            label: "Arrow Left"
        }),
        "aria-label": formatMessage((0, $5Zpfb.default).return)
    }, formatMessage((0, $5Zpfb.default).return)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $84c0022c3963701d$var$headingWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1VyqP.PageHeading), null, formatMessage(uploadHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1VyqP.PageDescription), null, formatMessage(uploadDescription, {
        link: (content)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cFy8W.SwitchBackToOldExperienceLink), {
                content: content
            })
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ipvc6.UploadCSVDropZone), {
        onNext: onNext
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Vlpn.ImportFromOtherTools), {
        onNext: onNext
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8vncz.SeenIt), {
        flag: (0, $kzTj7.PROJECT_CREATE_IMPORTER_SEEN_IT_FLAG)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $84c0022c3963701d$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1fra _1yt41avh",
            __cmplp.className
        ])
    });
});
const $84c0022c3963701d$var$headingWrapperStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.600',
    marginBottom: 'space.100'
});

});
parcelRegister("8vncz", function(module, exports) {

$parcel$export(module.exports, "SeenIt", () => $e60cd27fbb1c899a$export$dbdcc139f79b9b57);

var $eUqFw = parcelRequire("eUqFw");

var $jBAQz = parcelRequire("jBAQz");
const $e60cd27fbb1c899a$export$6be99c53fabc250b = 630720000000; // ~20 years
const $e60cd27fbb1c899a$export$dbdcc139f79b9b57 = /*#__PURE__*/ (0, $eUqFw.memo)(({ flag: flag })=>{
    (0, $eUqFw.useEffect)(()=>{
        (0, $jBAQz.setFlag)(flag, $e60cd27fbb1c899a$export$6be99c53fabc250b);
    }, [
        flag
    ]);
    return null;
});

});
parcelRegister("jBAQz", function(module, exports) {

$parcel$export(module.exports, "getFlags", () => $1749c1c9732fa517$export$d5815430bcc75df0);
$parcel$export(module.exports, "setFlag", () => $1749c1c9732fa517$export$5e165df1e30a1331);

var $czx3b = parcelRequire("czx3b");

var $hwbh0 = parcelRequire("hwbh0");

var $e91YZ = parcelRequire("e91YZ");

var $1Cw1V = parcelRequire("1Cw1V");

var $gYp0l = parcelRequire("gYp0l");
const $1749c1c9732fa517$export$442e3330dfabd1f5 = 3600000; // 1 hour
const $1749c1c9732fa517$export$4d45fa66d41a8ca9 = 2592000000; // ~1 month
const $1749c1c9732fa517$export$d5815430bcc75df0 = async (request)=>{
    const { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const flagKeys = Object.keys(request);
    const retrieveFlagKeysLookup = (0, (/*@__PURE__*/$parcel$interopDefault($hwbh0)))(flagKeys);
    if (!atlassianAccountId || isAnonymous) return (0, (/*@__PURE__*/$parcel$interopDefault($czx3b)))(retrieveFlagKeysLookup, ()=>({
            status: true,
            lastSeenDate: null
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const flags = {};
    if (0, $gYp0l.default) flagKeys.forEach((flagKey)=>{
        // @ts-expect-error - Object is possibly 'null'.
        const value = (0, $gYp0l.default).get(flagKey);
        if (value) {
            delete retrieveFlagKeysLookup[flagKey];
            flags[flagKey] = value;
        }
    });
    const retrieveFlagKeys = Object.keys(retrieveFlagKeysLookup);
    if (retrieveFlagKeys.length > 0) Object.assign(flags, await (0, $1Cw1V.getFlags)(atlassianAccountId, retrieveFlagKeys));
    if (0, $gYp0l.default) {
        const now = Date.now();
        retrieveFlagKeys.forEach((flagKey)=>{
            // Not sure whats going wrong here - but i assume `apiGetFlags` may not always return all `retrieveFalgKeys`
            // and so `flags[flagKey]` can be undefined - so we have to guard against it
            if (!flags[flagKey]) return;
            const { status: status } = flags[flagKey];
            const ttlNotSeen = request[flagKey].ttlNotSeen || $1749c1c9732fa517$export$442e3330dfabd1f5;
            const ttlSeen = request[flagKey].ttlSeen || $1749c1c9732fa517$export$4d45fa66d41a8ca9;
            // @ts-expect-error - TS2531: Object is possibly 'null'.
            (0, $gYp0l.default).set(flagKey, flags[flagKey], now + (status ? ttlSeen : ttlNotSeen));
        });
    }
    return flags;
};
const $1749c1c9732fa517$export$5e165df1e30a1331 = async (flagKey, ttl = $1749c1c9732fa517$export$4d45fa66d41a8ca9)=>{
    const { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    if (!atlassianAccountId || isAnonymous) return;
    if (0, $gYp0l.default) {
        const value = (0, $gYp0l.default).get(flagKey);
        if (value && value.status) return;
        const now = new Date();
        (0, $gYp0l.default).set(flagKey, {
            status: true,
            lastSeenDate: now.toISOString()
        }, now.getTime() + ttl);
    }
    await (0, $1Cw1V.setFlag)(atlassianAccountId, flagKey);
};

});
parcelRegister("czx3b", function(module, exports) {

var $3pSMu = parcelRequire("3pSMu");

var $piimr = parcelRequire("piimr");

var $7qARj = parcelRequire("7qARj");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $9272640aa667e27d$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $7qARj(iteratee, 3);
    $piimr(object, function(value, key, object) {
        $3pSMu(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $9272640aa667e27d$var$mapValues;

});

parcelRegister("hwbh0", function(module, exports) {

var $jDLwO = parcelRequire("jDLwO");

var $7hlYT = parcelRequire("7hlYT");
/**
 * This method is like `_.fromPairs` except that it accepts two arrays,
 * one of property identifiers and one of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 0.4.0
 * @category Array
 * @param {Array} [props=[]] The property identifiers.
 * @param {Array} [values=[]] The property values.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.zipObject(['a', 'b'], [1, 2]);
 * // => { 'a': 1, 'b': 2 }
 */ function $cc0e2b7b9a1e48d7$var$zipObject(props, values) {
    return $7hlYT(props || [], values || [], $jDLwO);
}
module.exports = $cc0e2b7b9a1e48d7$var$zipObject;

});
parcelRegister("7hlYT", function(module, exports) {
/**
 * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
 *
 * @private
 * @param {Array} props The property identifiers.
 * @param {Array} values The property values.
 * @param {Function} assignFunc The function to assign values.
 * @returns {Object} Returns the new object.
 */ function $54cb2be8ad88e749$var$baseZipObject(props, values, assignFunc) {
    var index = -1, length = props.length, valsLength = values.length, result = {};
    while(++index < length){
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
    }
    return result;
}
module.exports = $54cb2be8ad88e749$var$baseZipObject;

});


parcelRegister("1Cw1V", function(module, exports) {

$parcel$export(module.exports, "setFlag", () => $27a69f89da9f41d0$export$5e165df1e30a1331);
$parcel$export(module.exports, "getFlags", () => $27a69f89da9f41d0$export$d5815430bcc75df0);

var $czx3b = parcelRequire("czx3b");

var $7EhAs = parcelRequire("7EhAs");
const $27a69f89da9f41d0$export$c1f083639d344e75 = 'https://have-i-seen-it.us-east-1.prod.public.atl-paas.net';
const $27a69f89da9f41d0$export$5e165df1e30a1331 = (userKey, flagKey)=>{
    const data = {
        userKey: userKey,
        flagKey: flagKey
    };
    return fetch(`${$27a69f89da9f41d0$export$c1f083639d344e75}/flag`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }).then((response)=>{
        if (!response.ok) throw new (0, $7EhAs.default)(response.status, response.statusText);
        return undefined;
    });
};
const $27a69f89da9f41d0$var$convertToDates = (response)=>(0, (/*@__PURE__*/$parcel$interopDefault($czx3b)))(response, ({ status: status, lastSeenDate: lastSeenDate })=>({
            status: status,
            lastSeenDate: lastSeenDate ? new Date(lastSeenDate) : null
        }));
const $27a69f89da9f41d0$export$d5815430bcc75df0 = (userKey, flagKeys)=>{
    const params = new URLSearchParams();
    flagKeys.forEach((flagKey)=>params.append('flagKey', flagKey));
    params.append('userKey', userKey);
    return fetch(`${$27a69f89da9f41d0$export$c1f083639d344e75}/flags?${params.toString()}`).then((response)=>{
        if (!response.ok) throw new (0, $7EhAs.default)(response.status, response.statusText);
        return response.json();
    }).then((response)=>$27a69f89da9f41d0$var$convertToDates(response));
};

});

parcelRegister("gYp0l", function(module, exports) {

$parcel$export(module.exports, "default", () => $16304c7221461599$export$2e2bcd8739ae039);

var $89bO2 = parcelRequire("89bO2");

var $e91YZ = parcelRequire("e91YZ");

var $gUUjF = parcelRequire("gUUjF");
/**
 * Return an ExpirableStorage to be used with the "have i seen it" service.
 *
 * If the user is anonymous, return null.
 */ const $16304c7221461599$var$createStorage = ()=>{
    let storage = null;
    try {
        let context;
        try {
            context = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            return storage;
        }
        const { atlassianAccountId: atlassianAccountId } = context;
        if (atlassianAccountId) storage = (0, $89bO2.createSessionExpirableStorageProvider)(`have-i-seen-it-${atlassianAccountId.replace(/:/g, '_')}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('have-i-seen-it.storage', 'Failed to initialize storage.');
    }
    return storage;
};
var $16304c7221461599$export$2e2bcd8739ae039 = $16304c7221461599$var$createStorage();

});



parcelRegister("1Vlpn", function(module, exports) {

$parcel$export(module.exports, "ImportFromOtherTools", () => $3ab3b60868c24522$export$bd57497102c48f12);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $ffiyv = parcelRequire("ffiyv");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $cpweK = parcelRequire("cpweK");

var $kzTj7 = parcelRequire("kzTj7");

var $PVrB2 = parcelRequire("PVrB2");

var $7J5LG = parcelRequire("7J5LG");

var $cDLTA = parcelRequire("cDLTA");

var $bz2yd = parcelRequire("bz2yd");

var $9QyvU = parcelRequire("9QyvU");

var $d0wrd = parcelRequire("d0wrd");

var $2sRUp = parcelRequire("2sRUp");

var $asXeB = parcelRequire("asXeB");

var $4R50N = parcelRequire("4R50N");

var $2XUTe = parcelRequire("2XUTe");

var $1Uk5t = parcelRequire("1Uk5t");

var $5GQnb = parcelRequire("5GQnb");

var $aWaiu = parcelRequire("aWaiu");

var $FqMee = parcelRequire("FqMee");
const $3ab3b60868c24522$export$bd57497102c48f12 = ({ onNext: onNext })=>{
    const [isRequestOtherToolModalOpen, setRequestOtherToolModalOpen] = (0, $eUqFw.useState)(false);
    const [preOAuthModalStatus, setPreOAuthModalStatus] = (0, $eUqFw.useState)({
        isModalOpen: false
    });
    const [showFlag, setShowFlag] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { supportedTools: supportedTools, unavailableTools: unavailableTools } = (0, $4R50N.useTools)();
    const startThirdPartyOAuth = (0, $2XUTe.useThirdPartyOAuth)();
    const [, { setRequestAuthenticationToken: setRequestAuthenticationToken }] = (0, $asXeB.useAccessTokenModalState)();
    const { isLoading: isLoading, validateAccessToken: validateAccessToken } = (0, $1Uk5t.useThirdPartyAccessTokenStatus)({
        requestAuthenticationToken: setRequestAuthenticationToken
    });
    const [selectedThirdParty, setSelectedThirdParty] = (0, $eUqFw.useState)(undefined);
    const { onShowFlag: onShowFlag, onDismissFlag: onDismissFlag } = (0, $9QyvU.useX2CFlag)();
    const { oAuthUnsuccessFlagTitle: oAuthUnsuccessFlagTitle, oAuthUnsuccessFlagDescription: oAuthUnsuccessFlagDescription } = (0, $cDLTA.useContentForThirdParty)(selectedThirdParty);
    const [{ type: type }] = (0, $d0wrd.useProjectData)();
    const [source] = (0, $2sRUp.useSource)();
    const { importFromOtherAppsHeading: importFromOtherAppsHeading, importFromOtherAppsHelperMessage: importFromOtherAppsHelperMessage, importFromOtherAppsLearnMoreOtherApps: importFromOtherAppsLearnMoreOtherApps } = (0, $bz2yd.useProjectSpecificContent)(type, source);
    const onClickForOtherTools = (0, $eUqFw.useCallback)(()=>{
        setRequestOtherToolModalOpen(true);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'otherToolsButton'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
    }, [
        createAnalyticsEvent
    ]);
    const showPreOAuthModal = (0, $eUqFw.useCallback)(()=>{
        let resolve = (value)=>value;
        const promise = new Promise((resolveProp)=>{
            resolve = (value)=>{
                resolveProp(value);
                return value;
            };
        });
        setPreOAuthModalStatus({
            isModalOpen: true,
            onResolve: resolve
        });
        return promise;
    }, []);
    const onCloseForPreOAuthModal = (0, $eUqFw.useCallback)(()=>{
        preOAuthModalStatus.onResolve && preOAuthModalStatus.onResolve(false);
        setPreOAuthModalStatus({
            isModalOpen: false
        });
    }, [
        preOAuthModalStatus
    ]);
    const onNextForPreOAuthModal = (0, $eUqFw.useCallback)(()=>{
        preOAuthModalStatus.onResolve && preOAuthModalStatus.onResolve(true);
    }, [
        preOAuthModalStatus
    ]);
    const onOAuthFail = (0, $eUqFw.useCallback)(()=>{
        setPreOAuthModalStatus({
            isModalOpen: false
        });
        setShowFlag(true);
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        if (showFlag) {
            setShowFlag(false);
            oAuthUnsuccessFlagTitle && onShowFlag((0, $kzTj7.OAUTH_UNSUCCESS_FLAG_ID), {
                title: oAuthUnsuccessFlagTitle,
                description: [
                    oAuthUnsuccessFlagDescription,
                    {
                        link: (children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                                href: "/secure/ContactAdministrators!default.jspa",
                                target: "_blank"
                            }, children)
                    }
                ]
            });
        }
    }, [
        formatMessage,
        oAuthUnsuccessFlagDescription,
        oAuthUnsuccessFlagTitle,
        onShowFlag,
        selectedThirdParty,
        showFlag
    ]);
    const handleSupportedToolClick = (0, $eUqFw.useCallback)((tool)=>async ()=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: `${tool.key}Button`
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent);
            onDismissFlag((0, $kzTj7.OAUTH_UNSUCCESS_FLAG_ID));
            if (tool.isSupported) {
                selectedThirdParty !== tool.key && setSelectedThirdParty(tool.key);
                if ((0, $1ybV0.ff)('suppress-oauth-for-3p-apps-on-pollinator-tenants_5vbjr') && (0, $cpweK.isSynthetic)()) {
                    onNext(tool.key);
                    return;
                }
                if (tool.requiresOAuth) {
                    if (tool.showPreOAuthModal) {
                        const continueOAuth = await showPreOAuthModal();
                        if (continueOAuth === false) return;
                    }
                    startThirdPartyOAuth({
                        thirdParty: tool.key,
                        onSuccess: onNext,
                        onFail: onOAuthFail
                    });
                    return;
                }
                if (tool.requiresPersonalAccessToken) {
                    validateAccessToken(tool.key).then((status)=>{
                        if (status === 'VALID') onNext(tool.key);
                        else setRequestAuthenticationToken({
                            thirdParty: tool.key,
                            modalType: (0, $PVrB2.AccessTokenModalType).ADD_NEW_TOKEN
                        }).then((isSaved)=>{
                            if (isSaved) onNext(tool.key);
                        });
                    });
                    return;
                }
                onNext(tool.key);
            }
        }, [
        createAnalyticsEvent,
        onDismissFlag,
        onNext,
        onOAuthFail,
        setRequestAuthenticationToken,
        selectedThirdParty,
        showPreOAuthModal,
        startThirdPartyOAuth,
        validateAccessToken
    ]);
    const renderDescription = (0, $eUqFw.useMemo)(()=>{
        if (importFromOtherAppsLearnMoreOtherApps) return formatMessage(importFromOtherAppsHelperMessage, {
            link: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                href: (0, $kzTj7.LEARN_MORE_ABOUT_OTHER_TOOLS_LINK),
                target: "_blank"
            }, formatMessage(importFromOtherAppsLearnMoreOtherApps))
        });
        return formatMessage(importFromOtherAppsHelperMessage);
    }, [
        formatMessage,
        importFromOtherAppsHelperMessage,
        importFromOtherAppsLearnMoreOtherApps
    ]);
    const renderUnavailableTools = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3ab3b60868c24522$var$UnavailableToolsWrapper, null, unavailableTools.map((tool)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3ab3b60868c24522$var$OtherToolWrapper, {
                key: tool.key
            }, (0, $7J5LG.renderIcon)(tool.icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3ab3b60868c24522$var$ToolNameWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, tool.name)), tool.label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
                size: "small",
                color: "color.text.subtle"
            }, tool.label)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3ab3b60868c24522$var$OtherAppsDescription, {
            "data-testid": "project-create-importer-upload-flow.ui.upload-screen.import-from-other-tools.other-apps-description"
        }, formatMessage((0, $5GQnb.default).otherApps, {
            link: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3ab3b60868c24522$var$StyledLinkButton, {
                appearance: "link",
                onClick: onClickForOtherTools,
                testId: "project-create-importer-upload-flow.ui.upload-screen.import-from-other-tools.button"
            }, formatMessage((0, $5GQnb.default).tellUsWhere))
        }))), [
        formatMessage,
        onClickForOtherTools,
        unavailableTools
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3ab3b60868c24522$var$Wrapper, {
        "data-testid": "project-create-importer-upload-flow.ui.upload-screen.import-from-other-tools.wrapper"
    }, supportedTools.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3ab3b60868c24522$var$HeadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "medium",
        as: "h2"
    }, formatMessage((0, $5GQnb.default).supportedAppsHeading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3ab3b60868c24522$var$ButtonGroup, null, supportedTools.map((tool)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3ab3b60868c24522$var$OtherToolsButton, {
            key: tool.key,
            onClick: handleSupportedToolClick(tool),
            "aria-label": tool.name
        }, selectedThirdParty === tool.key && (isLoading || preOAuthModalStatus.isModalOpen) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: "small"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3ab3b60868c24522$var$ButtonContentWrapper, null, (0, $7J5LG.renderIcon)(tool.icon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3ab3b60868c24522$var$ButtonHeader, {
            level: "h500",
            as: "h4"
        }, tool.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
            size: "medium",
            color: "color.text.subtle"
        }, tool.label))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3ab3b60868c24522$var$HorizontalSeperator, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3ab3b60868c24522$var$HeadingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "medium",
        as: "h2"
    }, formatMessage(importFromOtherAppsHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $3ab3b60868c24522$var$lozengeWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: "new"
    }, formatMessage((0, $5GQnb.default).comingSoon)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3ab3b60868c24522$var$Description, {
        "data-testid": "project-create-importer-upload-flow.ui.upload-screen.import-from-other-tools.description"
    }, renderDescription)), renderUnavailableTools(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aWaiu.AsyncRequestOtherToolsModal), {
        isModalOpen: isRequestOtherToolModalOpen,
        setIsModalOpen: setRequestOtherToolModalOpen
    }), selectedThirdParty && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $FqMee.default), {
        isOpen: preOAuthModalStatus.isModalOpen,
        onClose: onCloseForPreOAuthModal,
        onNext: onNextForPreOAuthModal,
        thirdParty: selectedThirdParty
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3ab3b60868c24522$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4xy5q _bfhkvuon _19pkxy5q _otyrxy5q",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3ab3b60868c24522$var$ButtonGroup = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1n261g80 _zulp1693 _19pkpxbi",
            __cmplp.className
        ])
    });
});
const $3ab3b60868c24522$var$OtherToolsButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _2lx21bp4 _bfhkvuon _19iti1qc _16qs13qd _2rkoftgi _1wybdlk8 _1bsbuuw1 _1yt4v77o _4t3i1llu _1dbzf3fk",
            __cmplp.disabled ? "_80om13gf" : "_80omtlke",
            __cmplp.disabled && "_tzy4105o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3ab3b60868c24522$var$ButtonContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3ab3b60868c24522$var$ButtonHeader = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $hI5oG.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkxbgl _otyr1b66",
            __cmplp.className
        ])
    });
});
const $3ab3b60868c24522$var$lozengeWrapperStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.200'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3ab3b60868c24522$var$HeadingWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3ab3b60868c24522$var$HorizontalSeperator = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "hr", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19itglyw _4t3it94y _bfhkb5v6 _18s8gx6n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3ab3b60868c24522$var$Description = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaznoz8 _19pkpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3ab3b60868c24522$var$UnavailableToolsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1q9y _19pkxy5q",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3ab3b60868c24522$var$OtherToolWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "figure", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _18s8vg3z",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3ab3b60868c24522$var$ToolNameWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "figcaption", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pku2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3ab3b60868c24522$var$OtherAppsDescription = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $3ab3b60868c24522$var$Description, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1jfw _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3ab3b60868c24522$var$StyledLinkButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5GQnb", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3c694c86a206ec6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c3c694c86a206ec6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    learnMoreOtherApps: {
        "id": "project-create-importer-upload-flow.upload-screen.import-from-other-tools.learn-more-other-apps",
        "defaultMessage": "Learn more about importing from other apps"
    },
    comingSoon: {
        "id": "project-create-importer-upload-flow.upload-screen.import-from-other-tools.coming-soon",
        "defaultMessage": "Coming Soon"
    },
    supportedAppsHeading: {
        "id": "project-create-importer-upload-flow.upload-screen.import-from-other-tools.supported-apps-heading",
        "defaultMessage": "Import from apps"
    },
    otherApps: {
        "id": "project-create-importer-upload-flow.upload-screen.import-from-other-tools.other-apps",
        "defaultMessage": "Are there any other apps you\u2019d like to import data from? {link}"
    },
    tellUsWhere: {
        "id": "project-create-importer-upload-flow.upload-screen.import-from-other-tools.tell-us-where",
        "defaultMessage": "Let us know"
    }
});

});

parcelRegister("aWaiu", function(module, exports) {

$parcel$export(module.exports, "AsyncRequestOtherToolsModal", () => $b878754b4f02e289$export$8b8dd2a6f6d685fd);
/**
 * You are encouraged to use entry point export in src
 * However, at the time of development, this was mounted in JWM onboarding which had no relay environment
 * Hence we have this rll export as an alternative way to chunk the modal
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $b878754b4f02e289$var$RequestOthersToolModal = (0, $7rh0R.lazy)(()=>(parcelRequire("82gin")), {
    moduleId: "./src/packages/project-create-importer/project-create-importer-upload-flow/src/ui/upload-screen/import-from-other-tools/other-tools-request-modal/index.tsx"
});
const $b878754b4f02e289$export$8b8dd2a6f6d685fd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "request-other-tools-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b878754b4f02e289$var$RequestOthersToolModal, props));

});
parcelRegister("82gin", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('58QEq');
        const value = parcelRequire('1ojCm');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("58QEq").then(()=>parcelRequire('1ojCm'));
}

});


parcelRegister("FqMee", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0a28a0bd031f097$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
var $dxopF = parcelRequire("dxopF");

var $kGQen = parcelRequire("kGQen");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kzTj7 = parcelRequire("kzTj7");

var $cDLTA = parcelRequire("cDLTA");
var $aWLVm = parcelRequire("aWLVm");

var $7CK3x = parcelRequire("7CK3x");
const $c0a28a0bd031f097$var$PreOAuthModal = ({ isOpen: isOpen, thirdParty: thirdParty, onClose: onClose, onNext: onNext })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { preOAuthModalTitle: preOAuthModalTitle, preOAuthModalDescription: preOAuthModalDescription } = (0, $cDLTA.useContentForThirdParty)(thirdParty);
    const { appDownloadUrl: appDownloadUrl } = (0, $aWLVm.useUrlForThirdParty)(thirdParty);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onClose: onClose,
        testId: (0, $kzTj7.PRE_OAUTH_MODAL_TEST_ID)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, preOAuthModalTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, preOAuthModalDescription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage(preOAuthModalDescription, {
        br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null),
        link: (children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                href: appDownloadUrl,
                target: "_blank"
            }, children)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle",
        onClick: onClose
    }, formatMessage((0, $7CK3x.default).cancelButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "primary",
        onClick: onNext
    }, formatMessage((0, $7CK3x.default).nextButton))))));
};
var $c0a28a0bd031f097$export$2e2bcd8739ae039 = $c0a28a0bd031f097$var$PreOAuthModal;

});
parcelRegister("7CK3x", function(module, exports) {

$parcel$export(module.exports, "default", () => $14e0a245c0dd3436$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $14e0a245c0dd3436$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    cancelButton: {
        "id": "project-create-importer-upload-flow.upload-screen.import-from-other-tools.pre-oauth-modal.cancel-button",
        "defaultMessage": "Cancel"
    },
    nextButton: {
        "id": "project-create-importer-upload-flow.upload-screen.import-from-other-tools.pre-oauth-modal.next-button",
        "defaultMessage": "Next"
    }
});

});



parcelRegister("5Zpfb", function(module, exports) {

$parcel$export(module.exports, "default", () => $018b7d8eb66350ba$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $018b7d8eb66350ba$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    return: {
        "id": "project-create-importer-upload-flow.upload-screen.return",
        "defaultMessage": "Return to import your data"
    }
});

});

parcelRegister("ipvc6", function(module, exports) {

$parcel$export(module.exports, "UploadCSVDropZone", () => $beaa4b9983b514cc$export$c949aefb7a48049a);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $ldoFd = parcelRequire("ldoFd");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3ak5x = parcelRequire("3ak5x");

var $1VyqP = parcelRequire("1VyqP");

var $fiPvm = parcelRequire("fiPvm");
var $hPpMk = parcelRequire("hPpMk");

var $8lGnr = parcelRequire("8lGnr");

var $bz2yd = parcelRequire("bz2yd");

var $d0wrd = parcelRequire("d0wrd");

var $2sRUp = parcelRequire("2sRUp");

var $fZlPL = parcelRequire("fZlPL");

var $iIYuD = parcelRequire("iIYuD");
const $beaa4b9983b514cc$export$c949aefb7a48049a = ({ onNext: onNext })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onContinue = (0, $eUqFw.useCallback)(()=>{
        onNext((0, $3ak5x.CSV));
    }, [
        onNext
    ]);
    const [source] = (0, $2sRUp.useSource)();
    const [{ type: type }] = (0, $d0wrd.useProjectData)();
    const { uploadCsvDropzoneHeading: uploadCsvDropzoneHeading, uploadCsvDropzoneLearnMore: uploadCsvDropzoneLearnMore, uploadFooterContinue: uploadFooterContinue, uploadLearnMoreLink: uploadLearnMoreLink } = (0, $bz2yd.useProjectSpecificContent)(type, source);
    const { isFileBrowserOpen: isFileBrowserOpen, isFileNotCSV: isFileNotCSV, isFileTooLarge: isFileTooLarge, isFileUploading: isFileUploading, hasErrorOccurred: hasErrorOccurred, uploadedFileName: uploadedFileName, onReceiveFile: onReceiveFile, onRemoveFile: onRemoveFile, onCloseFileBrowser: onCloseFileBrowser, onOpenFileBrowser: onOpenFileBrowser, onFileDraggedAndDropped: onFileDraggedAndDropped } = (0, $fZlPL.useCSVDropzone)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($beaa4b9983b514cc$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($beaa4b9983b514cc$var$Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "medium",
        as: "h2"
    }, formatMessage(uploadCsvDropzoneHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1VyqP.LearnMore), {
        href: uploadLearnMoreLink,
        target: "_blank"
    }, formatMessage(uploadCsvDropzoneLearnMore))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hPpMk.FileDropTarget), {
        onReceiveFile: onFileDraggedAndDropped,
        onClick: onOpenFileBrowser,
        isDisabled: isFileUploading
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8lGnr.DropzoneContent), {
        isFileUploading: isFileUploading,
        isFileNotCSV: isFileNotCSV,
        hasErrorOccurred: hasErrorOccurred,
        isFileTooLarge: isFileTooLarge,
        uploadedFileName: uploadedFileName,
        onRemoveFile: onRemoveFile
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fiPvm.FileBrowser), {
        isOpen: isFileBrowserOpen,
        onReceiveFile: onReceiveFile,
        onClose: onCloseFileBrowser
    }), (0, $eI5EY.fg)('jwm-x2c-entry-point-improvement') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iIYuD.UploadAdvancedOptionsNew), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iIYuD.UploadAdvancedOptions), null), !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(uploadedFileName) && !isFileUploading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($beaa4b9983b514cc$var$NextButton, {
        appearance: "primary",
        onClick: onContinue,
        testId: "project-create-importer-upload-flow.ui.upload-screen.upload-csv-dropzone.next-button"
    }, formatMessage(uploadFooterContinue)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $beaa4b9983b514cc$var$NextButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1ejb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $beaa4b9983b514cc$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4xy5q _bfhkvuon _19pkxy5q _otyrxy5q",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $beaa4b9983b514cc$var$Header = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4 _1n261g80 _4cvr1q9y",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fiPvm", function(module, exports) {

$parcel$export(module.exports, "FileBrowser", () => $a7f5b4863229eccc$export$4ea4bb501c053712);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $ldoFd = parcelRequire("ldoFd");

var $kzTj7 = parcelRequire("kzTj7");
const $a7f5b4863229eccc$export$4ea4bb501c053712 = ({ isOpen: isOpen, onClose: onClose, onReceiveFile: onReceiveFile })=>{
    const inputRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (isOpen) {
            if (inputRef.current) // Click the input to open the file browser
            inputRef.current.click();
            // No browser API to know when file upload is closed, so we call
            // onClose immediately after opening
            onClose();
        }
    }, [
        isOpen,
        onClose
    ]);
    const onChangeHandler = (0, $eUqFw.useCallback)((event)=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(event.target.files)) onReceiveFile(event.target.files[0]);
        // Reset file input after sending file to parent
        const inputEl = event.target;
        inputEl.value = '';
    }, [
        onReceiveFile
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a7f5b4863229eccc$var$HiddenInput, {
        "data-testid": "project-create-importer-upload-flow.common.ui.file-dropzone.file-browser.hidden-input",
        type: "file",
        ref: inputRef,
        multiple: false,
        accept: (0, $kzTj7.CSV_FILE_UPLOAD_TYPE),
        onChange: onChangeHandler
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a7f5b4863229eccc$var$HiddenInput = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "input", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_3um015vq _kqswstnw _1pby1mrw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("hPpMk", function(module, exports) {

$parcel$export(module.exports, "FileDropTarget", () => $b3999aba02d61e98$export$795ab3de4d1b7f5c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $dxIU5 = parcelRequire("dxIU5");

var $PdmhA = parcelRequire("PdmhA");
const $b3999aba02d61e98$var$cancelEvent = (event)=>{
    event.preventDefault();
    event.stopPropagation();
};
const $b3999aba02d61e98$export$795ab3de4d1b7f5c = ({ children: children, onReceiveFile: onReceiveFile, onClick: onClick, isDisabled: isDisabled, isCompact: isCompact, className: className })=>{
    const [isDraggedOver, setIsDraggedOver] = (0, $eUqFw.useState)(false);
    const debouncedSetIsDraggedOver = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((newValue)=>setIsDraggedOver(newValue), 10), [
        setIsDraggedOver
    ]);
    const activateDropZone = (0, $eUqFw.useCallback)(()=>{
        debouncedSetIsDraggedOver.cancel();
        setIsDraggedOver(true);
    }, [
        debouncedSetIsDraggedOver
    ]);
    const deactivateDropzone = (0, $eUqFw.useCallback)(()=>{
        debouncedSetIsDraggedOver(false);
    }, [
        debouncedSetIsDraggedOver
    ]);
    const onDragOverHandler = (0, $eUqFw.useCallback)((event)=>{
        $b3999aba02d61e98$var$cancelEvent(event);
        if (!isDisabled) activateDropZone();
    }, [
        activateDropZone,
        isDisabled
    ]);
    const onDragLeaveHandler = (0, $eUqFw.useCallback)((event)=>{
        $b3999aba02d61e98$var$cancelEvent(event);
        deactivateDropzone();
    }, [
        deactivateDropzone
    ]);
    const onDropHandler = (0, $eUqFw.useCallback)((event)=>{
        $b3999aba02d61e98$var$cancelEvent(event);
        deactivateDropzone();
        if (!isDisabled && event.dataTransfer) onReceiveFile(event.dataTransfer.files[0]);
    }, [
        deactivateDropzone,
        isDisabled,
        onReceiveFile
    ]);
    const onClickHandler = (0, $eUqFw.useCallback)(()=>{
        if (!isDisabled) onClick();
    }, [
        isDisabled,
        onClick
    ]);
    const onKeyDownHandler = (0, $eUqFw.useCallback)((event)=>{
        if (!isDisabled && event.key === 'Enter') onClick();
    }, [
        isDisabled,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b3999aba02d61e98$var$DropzoneTarget, {
        "data-testid": "project-create-importer-upload-flow.common.ui.file-dropzone.file-drop-target.dropzone-target",
        isDraggedOver: isDraggedOver,
        onDragOver: onDragOverHandler,
        onDragLeave: onDragLeaveHandler,
        onDrop: onDropHandler,
        onClick: onClickHandler,
        onKeyDown: onKeyDownHandler,
        tabIndex: 0,
        isCompact: isCompact,
        // eslint-disable-next-line jira/react/no-classname-attribute, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, children);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b3999aba02d61e98$var$DropzoneTarget = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCompact: isCompact, isDraggedOver: isDraggedOver, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_7j3bli": (0, $9t7rW.default)(`${__cmplp.isCompact ? '1px' : '2px'} dashed ${__cmplp.isDraggedOver ? `var(--ds-border-selected, ${(0, $PdmhA).B200})` : `var(--ds-border, ${(0, $PdmhA).N40})`}`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _kqswh2mm _vchhusvi _bfhkvuon _1yt4u2gc _19itpgna _d0altlke",
            __cmplp.isCompact ? "_1tke1mcy" : "_1tkentd2",
            __cmplp.isCompact ? "_19pkidpf" : "_19pkxy5q",
            __cmplp.isCompact ? "_otyridpf" : "_otyr1ejb",
            __cmplp.className
        ])
    });
});

});

parcelRegister("8lGnr", function(module, exports) {

$parcel$export(module.exports, "DropzoneContent", () => $89195211038bab57$export$fba39bcc8f7f7281);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $7jPhn = parcelRequire("7jPhn");

var $bUiDR = parcelRequire("bUiDR");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $4Bees = parcelRequire("4Bees");

var $PdmhA = parcelRequire("PdmhA");

var $4lTFP = parcelRequire("4lTFP");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $c9m0Y = parcelRequire("c9m0Y");

var $6PprZ = parcelRequire("6PprZ");

var $6X9Nk = parcelRequire("6X9Nk");
const $89195211038bab57$export$fba39bcc8f7f7281 = ({ isFileUploading: isFileUploading, isFileNotCSV: isFileNotCSV, hasErrorOccurred: hasErrorOccurred, isFileTooLarge: isFileTooLarge, uploadedFileName: uploadedFileName, onRemoveFile: onRemoveFile, isLeaner: isLeaner })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    if (isFileUploading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        alignInline: "center",
        alignBlock: "center",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        size: "medium"
    }));
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(uploadedFileName)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        alignInline: "center",
        alignBlock: "center",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6PprZ.FileCard), {
        fileName: uploadedFileName,
        onRemoveFile: onRemoveFile
    }));
    const renderErrorMessage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, isFileNotCSV && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), {
            testId: "project-create-importer-upload-flow.common.ui.file-dropzone.dropzone-content.error-message"
        }, formatMessage((0, $6X9Nk.default).unsupportedFileErrorMessage)), hasErrorOccurred && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, formatMessage((0, $6X9Nk.default).uploadingErrorMessage)), isFileTooLarge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, formatMessage((0, $6X9Nk.default).fileSizeTooLargeErrorMessage)));
    if ((0, $eI5EY.fg)('enable-x2c-standardised-flow')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        alignInline: "center",
        alignBlock: "center",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        xcss: $89195211038bab57$var$imageStyles,
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "img",
        src: (0, (/*@__PURE__*/$parcel$interopDefault($c9m0Y))),
        alt: "",
        width: isLeaner ? '60px' : '100px'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            $89195211038bab57$var$textWrapperStyles,
            ...isLeaner ? [
                $89195211038bab57$var$textWrapperLeanerStyles
            ] : []
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: $89195211038bab57$var$headingLeanerStyles
    }, formatMessage((0, $6X9Nk.default).selectFileToUploadDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "span",
        xcss: $89195211038bab57$var$descriptionStyles
    }, formatMessage((0, $6X9Nk.default).dragAndDropDescription))), renderErrorMessage())));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        alignInline: "center",
        alignBlock: "center",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        xcss: $89195211038bab57$var$iconStyles,
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "div",
        xcss: $89195211038bab57$var$fileIconStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bUiDR))), {
        label: "file icon",
        size: "xlarge",
        primaryColor: `var(--ds-icon-subtle, ${(0, $PdmhA).N40})`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $89195211038bab57$var$textWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "h4",
        xcss: $89195211038bab57$var$headingStyles
    }, formatMessage((0, $6X9Nk.default).selectFileToUploadDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "p",
        xcss: $89195211038bab57$var$descriptionStyles
    }, formatMessage((0, $6X9Nk.default).dragAndDropDescription)))), renderErrorMessage());
};
const $89195211038bab57$var$headingStyles = (0, $1ZAYh.xcss)({
    margin: 'space.0'
});
const $89195211038bab57$var$headingLeanerStyles = (0, $1ZAYh.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    font: `var(--ds-font-heading-xsmall, ${(0, $4lTFP.fontFallback).heading.xsmall})`
});
const $89195211038bab57$var$iconStyles = (0, $1ZAYh.xcss)({
    gap: 'space.0',
    flexDirection: 'column'
});
const $89195211038bab57$var$imageStyles = (0, $1ZAYh.xcss)({
    gap: 'space.200',
    flexDirection: 'row'
});
const $89195211038bab57$var$fileIconStyles = (0, $1ZAYh.xcss)({
    alignSelf: 'center'
});
const $89195211038bab57$var$descriptionStyles = (0, $1ZAYh.xcss)({
    margin: 'space.0',
    color: 'color.text.subtle'
});
const $89195211038bab57$var$textWrapperStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column'
});
const $89195211038bab57$var$textWrapperLeanerStyles = (0, $1ZAYh.xcss)({
    flexDirection: 'row',
    gap: 'space.050'
});

});
parcelRegister("bUiDR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8ab3628d1a6a9af2$var$_react = $8ab3628d1a6a9af2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $8ab3628d1a6a9af2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $8ab3628d1a6a9af2$var$EditorFileIcon = (props)=>/*#__PURE__*/ $8ab3628d1a6a9af2$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M7 6.5c0-.276.228-.5.491-.5H13l4 4v7.5c0 .276-.228.5-.51.5H7.51a.508.508 0 01-.51-.5v-11zm5 1v2.999c0 .271.225.501.501.501H15.5L12 7.5z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$8ab3628d1a6a9af2$var$EditorFileIcon.displayName = 'EditorFileIcon';
var $8ab3628d1a6a9af2$var$_default = $8ab3628d1a6a9af2$var$EditorFileIcon;
module.exports.default = $8ab3628d1a6a9af2$var$_default;

});

parcelRegister("c9m0Y", function(module, exports) {
module.exports = new URL("MagicFile.118156f0.svg", import.meta.url).toString();

});

parcelRegister("6PprZ", function(module, exports) {

$parcel$export(module.exports, "FileCard", () => $796a1b2b67d81449$export$593fd10f7e6c6505);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $jWuk1 = parcelRequire("jWuk1");

var $bUiDR = parcelRequire("bUiDR");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $29cgq = parcelRequire("29cgq");
const $796a1b2b67d81449$export$593fd10f7e6c6505 = ({ fileName: fileName, onRemoveFile: onRemoveFile })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const removeFileHandler = (0, $eUqFw.useCallback)((e)=>{
        e.preventDefault();
        onRemoveFile();
    }, [
        onRemoveFile
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($796a1b2b67d81449$var$Wrapper, {
        "data-testid": "project-create-importer-upload-flow.common.ui.file-dropzone.file-card.wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $796a1b2b67d81449$var$fileIconWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bUiDR))), {
        label: "",
        size: "large"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, fileName), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($796a1b2b67d81449$var$CrossButtonWrapper, {
        "data-testid": "project-create-importer-upload-flow.common.ui.file-dropzone.file-card.cross-button-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        label: "",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
            label: formatMessage((0, $29cgq.default).removeFileLabel),
            size: "small"
        }),
        onClick: removeFileHandler,
        appearance: "subtle"
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $796a1b2b67d81449$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $796a1b2b67d81449$var$CrossButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01wug",
            __cmplp.className
        ])
    });
});
const $796a1b2b67d81449$var$fileIconWrapperStyles = (0, $1ZAYh.xcss)({
    marginRight: 'space.100'
});

});
parcelRegister("29cgq", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8f8bc0b58bea860$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b8f8bc0b58bea860$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    removeFileLabel: {
        "id": "project-create-importer-upload-flow.common.file-dropzone.file-card.remove-file-label",
        "defaultMessage": "Remove file"
    }
});

});


parcelRegister("6X9Nk", function(module, exports) {

$parcel$export(module.exports, "default", () => $27a7f9c3000f2ba3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $27a7f9c3000f2ba3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    selectFileToUploadDescription: {
        "id": "project-create-importer-upload-flow.common.file-dropzone.dropzone-content.select-file-to-upload-description",
        "defaultMessage": "Select a file to upload"
    },
    dragAndDropDescription: {
        "id": "project-create-importer-upload-flow.common.file-dropzone.dropzone-content.drag-and-drop-description",
        "defaultMessage": "or drag and drop here"
    },
    uploadingErrorMessage: {
        "id": "project-create-importer-upload-flow.common.file-dropzone.dropzone-content.uploading-error-message",
        "defaultMessage": "We couldn\u2019t upload your file. Try again."
    },
    fileSizeTooLargeErrorMessage: {
        "id": "project-create-importer-upload-flow.common.file-dropzone.dropzone-content.file-size-too-large-error-message",
        "defaultMessage": "This file exceeds the maximum file size of 500Mb. Upload a smaller file to proceed."
    },
    unsupportedFileErrorMessage: {
        "id": "project-create-importer-upload-flow.common.file-dropzone.dropzone-content.unsupported-file-error-message",
        "defaultMessage": "This file is not supported. Try uploading a CSV file."
    }
});

});


parcelRegister("fZlPL", function(module, exports) {

$parcel$export(module.exports, "useCSVDropzone", () => $aaf504fa45ceae8c$export$ab062ea81366c8e0);

var $eUqFw = parcelRequire("eUqFw");

var $eI5EY = parcelRequire("eI5EY");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kzTj7 = parcelRequire("kzTj7");

var $cEsNG = parcelRequire("cEsNG");

var $lUC5l = parcelRequire("lUC5l");
var $4uta0 = parcelRequire("4uta0");
var $d0wrd = parcelRequire("d0wrd");
var $9IeJ5 = parcelRequire("9IeJ5");

var $2sRUp = parcelRequire("2sRUp");
const $aaf504fa45ceae8c$var$isCSVFile = (selectedFileType)=>selectedFileType === (0, $kzTj7.CSV_FILE_UPLOAD_TYPE);
const $aaf504fa45ceae8c$export$ab062ea81366c8e0 = ()=>{
    const [isFileBrowserOpen, setIsFileBrowserOpen] = (0, $eUqFw.useState)(false);
    const [isFileNotCSV, setIsFileNotCSV] = (0, $eUqFw.useState)(false);
    const [isFileTooLarge, setIsFileTooLarge] = (0, $eUqFw.useState)(false);
    const [source] = (0, $2sRUp.useSource)();
    const { isFileUploading: isFileUploading, hasErrorOccurred: hasErrorOccurred, uploadCsv: uploadCsv } = (0, $cEsNG.useUploadCsv)(source);
    const [, { setMigrationId: setMigrationId }] = (0, $4uta0.useMigrationId)();
    const [, { setMappingState: setMappingState, resetProjectData: resetProjectData }] = (0, $lUC5l.useMappingState)();
    const [uploadedFileName, { setUploadedFileName: setUploadedFileName }] = (0, $9IeJ5.useUploadedFileName)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [{ key: key }] = (0, $d0wrd.useProjectData)();
    const onReceiveFile = (0, $eUqFw.useCallback)((file)=>{
        if ((0, $eI5EY.fg)('enable-x2c-standardised-flow')) {
            if (file.size > (0, $kzTj7.CSV_MAX_SIZE_BYTES)) {
                setIsFileTooLarge(true);
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'csvFile exceedsLimit', {
                    fileSize: file.size
                });
                return Promise.resolve();
            }
            setIsFileTooLarge(false);
        }
        setMappingState(null);
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'csvFile uploading', {
            fileSize: file.size
        });
        return uploadCsv(file, key).then((migrationId)=>{
            setMigrationId(migrationId);
            resetProjectData();
            if (migrationId) {
                setUploadedFileName(file?.name ?? null);
                (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'csvFile uploaded', {
                    fileSize: file.size
                });
            }
        });
    }, [
        createAnalyticsEvent,
        key,
        resetProjectData,
        setMappingState,
        setMigrationId,
        setUploadedFileName,
        uploadCsv,
        setIsFileTooLarge
    ]);
    const onRemoveFile = (0, $eUqFw.useCallback)(()=>{
        setUploadedFileName(null);
    }, [
        setUploadedFileName
    ]);
    const onCloseFileBrowser = (0, $eUqFw.useCallback)(()=>setIsFileBrowserOpen(false), [
        setIsFileBrowserOpen
    ]);
    const onOpenFileBrowser = (0, $eUqFw.useCallback)(()=>setIsFileBrowserOpen(true), [
        setIsFileBrowserOpen
    ]);
    const onFileDraggedAndDropped = (0, $eUqFw.useCallback)((selectedFile)=>{
        if (!$aaf504fa45ceae8c$var$isCSVFile(selectedFile.type)) {
            setIsFileNotCSV(true);
            return Promise.resolve();
        }
        setIsFileNotCSV(false);
        return onReceiveFile(selectedFile);
    }, [
        onReceiveFile
    ]);
    return {
        isFileBrowserOpen: isFileBrowserOpen,
        isFileNotCSV: isFileNotCSV,
        isFileTooLarge: isFileTooLarge,
        isFileUploading: isFileUploading,
        hasErrorOccurred: hasErrorOccurred,
        uploadedFileName: uploadedFileName,
        onReceiveFile: onReceiveFile,
        onRemoveFile: onRemoveFile,
        onCloseFileBrowser: onCloseFileBrowser,
        onOpenFileBrowser: onOpenFileBrowser,
        onFileDraggedAndDropped: onFileDraggedAndDropped
    };
};

});
parcelRegister("cEsNG", function(module, exports) {

$parcel$export(module.exports, "useUploadCsv", () => $ccf55baa3ca46e9f$export$7809c265c9aad91b);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $gyZoj = parcelRequire("gyZoj");
var $5GSA7 = parcelRequire("5GSA7");

var $dWLk9 = parcelRequire("dWLk9");

var $kzTj7 = parcelRequire("kzTj7");

var $3yuWi = parcelRequire("3yuWi");

var $jNdPf = parcelRequire("jNdPf");

var $il2VC = parcelRequire("il2VC");

var $1NLki = parcelRequire("1NLki");
const $ccf55baa3ca46e9f$export$7809c265c9aad91b = (source)=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const [onExperienceStart, onExperienceSuccess, onExperienceFail] = (0, $5GSA7.useExperienceTracker)((0, $3yuWi.EXPERIENCES).UPLOAD_CSV);
    const analyticsAttributes = (0, $jNdPf.useAnalyticsAttributesContext)();
    const [isFileUploading, setIsFileUploading] = (0, $eUqFw.useState)(false);
    const [hasErrorOccurred, setHasErrorOccurred] = (0, $eUqFw.useState)(false);
    const abortControllerRef = (0, $eUqFw.useRef)(null);
    const client = (0, $il2VC.useGetCSVImportClient)(source);
    (0, $eUqFw.useEffect)(()=>()=>{
            abortControllerRef?.current?.abort();
        }, [
        abortControllerRef
    ]);
    const uploadCsv = (0, $eUqFw.useCallback)(async (file, projectKey)=>{
        setIsFileUploading(true);
        setHasErrorOccurred(false);
        (0, $3yuWi.uploadInteractionMetric).start();
        onExperienceStart();
        abortControllerRef?.current?.abort();
        abortControllerRef.current = new AbortController();
        try {
            let response;
            if ((0, $1ybV0.ff)('enable-importing-data-to-existing-project_k8uub')) response = await client.getUploadUrlAndMigrationId({
                signal: abortControllerRef?.current?.signal,
                projectKey: projectKey
            });
            else response = await (0, $1NLki.fetchUploadUrlAndMigrationId)(cloudId, abortControllerRef?.current?.signal);
            const { uploadUrl: uploadUrl, migrationId: migrationId } = response;
            await (0, $1NLki.uploadFileToS3)(uploadUrl, file, abortControllerRef?.current?.signal);
            (0, $3yuWi.uploadInteractionMetric).stop();
            onExperienceSuccess(analyticsAttributes);
            setIsFileUploading(false);
            return migrationId;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $3yuWi.uploadInteractionMetric).stop();
            if (!abortControllerRef?.current?.signal?.aborted) {
                onExperienceFail((0, $kzTj7.APP_IDENTIFIER), error, analyticsAttributes);
                (0, $guiFP.default)({
                    meta: {
                        id: 'upload-error',
                        packageName: (0, $kzTj7.APP_IDENTIFIER),
                        teamName: (0, $gyZoj.APP_TEAM_NAME)
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    error: error
                });
                setHasErrorOccurred(true);
            }
            setIsFileUploading(false);
            return null;
        }
    }, [
        onExperienceStart,
        onExperienceSuccess,
        analyticsAttributes,
        client,
        cloudId,
        onExperienceFail
    ]);
    return {
        isFileUploading: isFileUploading,
        hasErrorOccurred: hasErrorOccurred,
        uploadCsv: uploadCsv
    };
};

});
parcelRegister("1NLki", function(module, exports) {

$parcel$export(module.exports, "fetchUploadUrlAndMigrationId", () => $a7b8eafc4bdda464$export$7d35a1ad95472c65);
$parcel$export(module.exports, "uploadFileToS3", () => $a7b8eafc4bdda464$export$9c774f4c11be1742);

var $2OdyW = parcelRequire("2OdyW");
var $lRmyA = parcelRequire("lRmyA");

var $cpweK = parcelRequire("cpweK");
var $gyZoj = parcelRequire("gyZoj");

var $kzTj7 = parcelRequire("kzTj7");
const $a7b8eafc4bdda464$var$getX2CFetchUploadUrl = (cloudId)=>`${0, $gyZoj.X2C_SERVICE_URL_PREFIX}/${cloudId}/import/csv/uploadUrl`;
const $a7b8eafc4bdda464$var$getSiteUrl = ()=>`https://${window.location.hostname}`;
const $a7b8eafc4bdda464$export$7d35a1ad95472c65 = (cloudId, signal)=>(0, $2OdyW.default)($a7b8eafc4bdda464$var$getX2CFetchUploadUrl(cloudId), {
        body: JSON.stringify({
            url: $a7b8eafc4bdda464$var$getSiteUrl()
        }),
        method: 'POST',
        signal: signal,
        headers: {
            'x-issynthetic-traffic': String((0, $cpweK.isSynthetic)())
        }
    });
const $a7b8eafc4bdda464$export$9c774f4c11be1742 = (uploadUrl, file, signal)=>(0, $lRmyA.performPutRequest)(uploadUrl, {
        headers: {
            'Content-Type': (0, $kzTj7.CSV_FILE_UPLOAD_TYPE),
            'x-issynthetic-traffic': String((0, $cpweK.isSynthetic)())
        },
        body: file,
        signal: signal
    });

});


parcelRegister("9IeJ5", function(module, exports) {

$parcel$export(module.exports, "useUploadedFileName", () => $e4108a1b12f52d51$export$13faed9191fcf5a0);

var $ggKAj = parcelRequire("ggKAj");
var $bj4JM = parcelRequire("bj4JM");

var $8JicK = parcelRequire("8JicK");
const $e4108a1b12f52d51$export$a9c3c0737f508734 = (0, $bj4JM.createSelector)((state)=>state.uploadedFileName, (newState)=>newState);
const $e4108a1b12f52d51$export$13faed9191fcf5a0 = (0, $ggKAj.createHook)((0, $8JicK.Store), {
    selector: $e4108a1b12f52d51$export$a9c3c0737f508734
});

});


parcelRegister("iIYuD", function(module, exports) {

$parcel$export(module.exports, "UploadAdvancedOptions", () => $552d077fd9de44c8$export$74c96370e7735ca6);
$parcel$export(module.exports, "UploadAdvancedOptionsNew", () => $552d077fd9de44c8$export$f79331a1bd48e7f4);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $4LhB6 = parcelRequire("4LhB6");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $cf2Y4 = parcelRequire("cf2Y4");

var $5JgJ2 = parcelRequire("5JgJ2");

var $cWiVr = parcelRequire("cWiVr");

var $kzTj7 = parcelRequire("kzTj7");

var $8tfrZ = parcelRequire("8tfrZ");

var $1WR91 = parcelRequire("1WR91");

var $dsYFU = parcelRequire("dsYFU");

var $2nryu = parcelRequire("2nryu");

var $aWLVm = parcelRequire("aWLVm");

var $bLalW = parcelRequire("bLalW");
var $lUC5l = parcelRequire("lUC5l");

var $3F7Ru = parcelRequire("3F7Ru");
const $552d077fd9de44c8$export$74c96370e7735ca6 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [advancedOptions, { updateAdvancedOptions: updateAdvancedOptions }] = (0, $bLalW.useAdvancedOptions)();
    const [mappingState, { setMappingState: setMappingState }] = (0, $lUC5l.useMappingState)();
    const { data: { user: user } } = (0, $cWiVr.useCurrentUser)();
    (0, $eUqFw.useEffect)(()=>{
        const localeOption = (0, $aWLVm.getLocaleOptionForUserLocale)(user?.locale);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const timeZoneOption = (0, $aWLVm.getTimeZoneOptionForUserTimeZone)(user?.timeZone);
        updateAdvancedOptions({
            localeOption: localeOption,
            timeZoneOption: timeZoneOption
        });
    // Only run if user changes
    }, [
        updateAdvancedOptions,
        user
    ]);
    const getOnChangeFileEncoding = (0, $eUqFw.useCallback)((fileEncoding)=>()=>{
            updateAdvancedOptions({
                fileEncoding: fileEncoding
            });
            // Reset mapping state if data has previously been loaded
            if (mappingState !== null) setMappingState(null);
        }, [
        mappingState,
        updateAdvancedOptions,
        setMappingState
    ]);
    const onChangeDelimiter = (0, $eUqFw.useCallback)((e)=>{
        updateAdvancedOptions({
            delimiter: e.target.value
        });
        // Reset mapping state if data has previously been loaded
        if (mappingState !== null) setMappingState(null);
    }, [
        mappingState,
        updateAdvancedOptions,
        setMappingState
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($552d077fd9de44c8$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1WR91.Accordion), {
        heading: (0, $3F7Ru.default).advancedOptions,
        testId: "project-create-importer-upload-flow.ui.upload-screen.upload-csv-dropzone.upload-advanced-options.accordion",
        ariaRoleDescription: (0, $3F7Ru.default).advancedOptionsDescription
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($552d077fd9de44c8$var$LabelWrapper, null, formatMessage((0, $3F7Ru.default).fileEncoding), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2nryu.InfoButton), {
            heading: formatMessage((0, $3F7Ru.default).fileEncodingPopupHeading),
            description: formatMessage((0, $3F7Ru.default).fileEncodingPopupDescription)
        })),
        name: "fileEncoding"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($552d077fd9de44c8$var$DropdownWrapper, {
            "data-testid": "project-create-importer-upload-flow.ui.upload-screen.upload-csv-dropzone.upload-advanced-options.dropdown-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
            ...fieldProps,
            trigger: advancedOptions.fileEncoding
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, (0, $8tfrZ.SUPPORTED_ENCODING).map((encoding)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
                key: encoding,
                onClick: getOnChangeFileEncoding(encoding),
                testId: `${(0, $kzTj7.FILE_ENCODING_DROPDOWN_TESTID_PREFIX)}.${encoding}`
            }, encoding)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $552d077fd9de44c8$var$spacerStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($552d077fd9de44c8$var$LabelWrapper, null, formatMessage((0, $3F7Ru.default).delimiter), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2nryu.InfoButton), {
            heading: formatMessage((0, $3F7Ru.default).delimiterPopupHeading),
            description: formatMessage((0, $3F7Ru.default).delimiterPopupDescription)
        })),
        name: "delimiter"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
            testId: "project-create-importer-upload-flow.ui.upload-screen.upload-csv-dropzone.upload-advanced-options.text-field",
            ...fieldProps,
            defaultValue: advancedOptions.delimiter,
            onChange: onChangeDelimiter
        })))));
};
const $552d077fd9de44c8$export$f79331a1bd48e7f4 = ()=>{
    const [advancedOptions, { updateAdvancedOptions: updateAdvancedOptions }] = (0, $bLalW.useAdvancedOptions)();
    const [mappingState, { setMappingState: setMappingState }] = (0, $lUC5l.useMappingState)();
    const onChange = (0, $eUqFw.useCallback)((data)=>{
        updateAdvancedOptions(data); // Reset mapping state if data has previously been loaded
        if (mappingState !== null) setMappingState(null);
    }, [
        mappingState,
        setMappingState,
        updateAdvancedOptions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dsYFU.AdvancedOptionsSetting), {
        advancedOptions: advancedOptions,
        onChange: onChange
    });
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $552d077fd9de44c8$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _p12f1nrf",
            __cmplp.className
        ])
    });
});
const $552d077fd9de44c8$var$spacerStyles = (0, $1ZAYh.xcss)({
    width: 'space.300'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $552d077fd9de44c8$var$LabelWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _15h61b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $552d077fd9de44c8$var$DropdownWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_t74o1jfw _1138bv7e _18iz1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cWiVr", function(module, exports) {

$parcel$export(module.exports, "useCurrentUser", () => $59f9598ada60a2a8$export$3901076af3749fa9);

var $eUqFw = parcelRequire("eUqFw");

var $ao0hp = parcelRequire("ao0hp");

var $gd0Sp = parcelRequire("gd0Sp");

var $lGLse = parcelRequire("lGLse");
const $59f9598ada60a2a8$var$useCurrentUserBasic = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return (0, $eUqFw.useMemo)(()=>({
            data: {
                user: {
                    accountId: tenantContext.atlassianAccountId,
                    isAdmin: tenantContext.isAdmin,
                    isAnonymous: tenantContext.isAnonymous,
                    isSiteAdmin: tenantContext.isSiteAdmin,
                    locale: tenantContext.locale || (0, $ao0hp.defaultLocale),
                    siteAdminStatus: tenantContext.siteAdminStatus,
                    userFullname: tenantContext.userFullname || ''
                }
            },
            loading: false,
            error: null
        }), [
        tenantContext.atlassianAccountId,
        tenantContext.isAdmin,
        tenantContext.isAnonymous,
        tenantContext.isSiteAdmin,
        tenantContext.locale,
        tenantContext.siteAdminStatus,
        tenantContext.userFullname
    ]);
};
const $59f9598ada60a2a8$var$useCurrentUserFull = ()=>{
    const { data: dataBasic } = $59f9598ada60a2a8$var$useCurrentUserBasic();
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const [{ data: data, loading: loading, error: error }, { fetch: fetch }] = (0, $lGLse.useUserSubscriber)();
    (0, $eUqFw.useEffect)(()=>{
        tenantContext.atlassianAccountId && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        fetch({
            params: {
                accountId: tenantContext.atlassianAccountId
            }
        }, false);
    }, [
        fetch,
        tenantContext.atlassianAccountId
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            data: {
                ...dataBasic,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                user: {
                    ...dataBasic.user,
                    ...data
                }
            },
            loading: loading,
            error: error
        }), [
        data,
        dataBasic,
        error,
        loading
    ]);
};
const $59f9598ada60a2a8$export$3901076af3749fa9 = ()=>(0, $gd0Sp.useTenantContext)().isAnonymous ? $59f9598ada60a2a8$var$useCurrentUserBasic() : $59f9598ada60a2a8$var$useCurrentUserFull(); // eslint-disable-line react-hooks/rules-of-hooks
const $59f9598ada60a2a8$export$6414ebbbfff99d4c = ({ children: children })=>{
    const result = $59f9598ada60a2a8$export$3901076af3749fa9();
    return children(result);
};

});
parcelRegister("lGLse", function(module, exports) {

$parcel$export(module.exports, "UserContainer", () => $033cdb69b2583281$export$7ff085589970ee0a);
$parcel$export(module.exports, "useUserSubscriber", () => $033cdb69b2583281$export$4e61bbf568682a96);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $kdNL5 = parcelRequire("kdNL5");
const $033cdb69b2583281$var$initialState = {
    data: null,
    loading: false,
    error: null
};
const $033cdb69b2583281$var$Store = (0, $a61MH.createStore)({
    name: 'user',
    initialState: $033cdb69b2583281$var$initialState,
    actions: $kdNL5
});
const $033cdb69b2583281$export$7ff085589970ee0a = (0, $heB5U.createContainer)($033cdb69b2583281$var$Store);
const $033cdb69b2583281$export$4e61bbf568682a96 = (0, $ggKAj.createHook)($033cdb69b2583281$var$Store);

});
parcelRegister("kdNL5", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $dd4efebc20057365$export$e7aa7bc5c1b3cfb3);

var $1TLNE = parcelRequire("1TLNE");
const $dd4efebc20057365$export$e7aa7bc5c1b3cfb3 = ({ params: params, header: header }, forceRefetch = false)=>async ({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (!params || currentState.loading || currentState.data && !forceRefetch) return;
        setState({
            loading: true
        });
        try {
            const data = await (0, $1TLNE.fetchData)({
                params: params,
                header: header
            });
            setState({
                data: data,
                loading: false,
                error: null
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setState({
                error: err,
                loading: false
            });
        }
    };

});
parcelRegister("1TLNE", function(module, exports) {

$parcel$export(module.exports, "fetchData", () => $7f578fc13a1a3e40$export$8134c072fddab6a5);

var $53ciZ = parcelRequire("53ciZ");

var $lRmyA = parcelRequire("lRmyA");
const $7f578fc13a1a3e40$export$8134c072fddab6a5 = ({ params: params, header: header })=>{
    const queryParams = {
        ...params,
        expand: Object.keys(params.expand || {}).filter((key)=>params.expand && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            params.expand[key])
    };
    const query = (0, $53ciZ.stringify)(queryParams, {
        arrayFormat: 'none'
    });
    const queryString = query ? `?${query}` : '';
    const requestUrl = `/rest/api/2/user${queryString}`;
    // @ts-expect-error - TS2345 - Argument of type '{ headers: HeaderParamForceAccountId; } | {}' is not assignable to parameter of type 'RequestInit | undefined'.
    return (0, $lRmyA.performGetRequest)(requestUrl, header ? {
        headers: header
    } : {});
};

});




parcelRegister("8tfrZ", function(module, exports) {

$parcel$export(module.exports, "SUPPORTED_ENCODING", () => $35835ff9f4f43b50$export$390381fbac8fcce6);
const $35835ff9f4f43b50$export$390381fbac8fcce6 = [
    'US-ASCII',
    'ISO-8859-1',
    'UTF-8',
    'UTF-16BE',
    'UTF-16LE',
    'UTF-16'
];

});

parcelRegister("dsYFU", function(module, exports) {

$parcel$export(module.exports, "AdvancedOptionsSetting", () => $9404050fd8e2537b$export$8d189d532daf7955);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $4LhB6 = parcelRequire("4LhB6");

var $c0jFd = parcelRequire("c0jFd");

var $cf2Y4 = parcelRequire("cf2Y4");

var $5JgJ2 = parcelRequire("5JgJ2");

var $cWiVr = parcelRequire("cWiVr");

var $kzTj7 = parcelRequire("kzTj7");

var $8tfrZ = parcelRequire("8tfrZ");

var $aWLVm = parcelRequire("aWLVm");

var $1WR91 = parcelRequire("1WR91");

var $2nryu = parcelRequire("2nryu");

var $gGXyh = parcelRequire("gGXyh");
const $9404050fd8e2537b$export$8d189d532daf7955 = ({ advancedOptions: advancedOptions, onChange: onChange })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { data: { user: user } } = (0, $cWiVr.useCurrentUser)();
    (0, $eUqFw.useEffect)(()=>{
        const localeOption = (0, $aWLVm.getLocaleOptionForUserLocale)(user?.locale);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const timeZoneOption = (0, $aWLVm.getTimeZoneOptionForUserTimeZone)(user?.timeZone);
        onChange({
            localeOption: localeOption,
            timeZoneOption: timeZoneOption
        });
    // Only run if user changes
    }, [
        onChange,
        user
    ]);
    const getOnChangeFileEncoding = (0, $eUqFw.useCallback)((fileEncoding)=>()=>{
            onChange({
                fileEncoding: fileEncoding
            });
        }, [
        onChange
    ]);
    const onChangeDelimiter = (0, $eUqFw.useCallback)((e)=>{
        onChange({
            delimiter: e.target.value
        });
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1WR91.Accordion), {
        heading: (0, $gGXyh.default).advancedOptions,
        testId: "project-create-importer-upload-flow.common.ui.file-dropzone.advanced-options-setting.accordion",
        ariaRoleDescription: (0, $gGXyh.default).advancedOptionsDescription
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        gap: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
            gap: "space.050"
        }, formatMessage((0, $gGXyh.default).fileEncoding), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2nryu.InfoButton), {
            heading: formatMessage((0, $gGXyh.default).fileEncoding),
            description: formatMessage((0, $gGXyh.default).fileEncodingPopupDescription)
        })),
        name: "fileEncoding"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9404050fd8e2537b$var$DropdownWrapper, {
            "data-testid": "project-create-importer-upload-flow.common.ui.file-dropzone.advanced-options-setting.dropdown-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
            ...fieldProps,
            trigger: advancedOptions.fileEncoding
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, (0, $8tfrZ.SUPPORTED_ENCODING).map((encoding)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
                key: encoding,
                onClick: getOnChangeFileEncoding(encoding),
                testId: `${(0, $kzTj7.FILE_ENCODING_DROPDOWN_TESTID_PREFIX)}.${encoding}`
            }, encoding)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
            gap: "space.050"
        }, formatMessage((0, $gGXyh.default).delimiter), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2nryu.InfoButton), {
            heading: formatMessage((0, $gGXyh.default).delimiterPopupHeading),
            description: formatMessage((0, $gGXyh.default).delimiterPopupDescription)
        })),
        name: "delimiter"
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
            testId: "project-create-importer-upload-flow.common.ui.file-dropzone.advanced-options-setting.text-field",
            ...fieldProps,
            defaultValue: advancedOptions.delimiter,
            onChange: onChangeDelimiter
        })))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9404050fd8e2537b$var$DropdownWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_t74o1jfw _1138bv7e _18iz1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gGXyh", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbe72e1394cdf3d1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $fbe72e1394cdf3d1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    fileEncoding: {
        "id": "project-create-importer-upload-flow.common.file-dropzone.advanced-options-setting.file-encoding",
        "defaultMessage": "File encoding"
    },
    delimiter: {
        "id": "project-create-importer-upload-flow.common.file-dropzone.advanced-options-setting.delimiter",
        "defaultMessage": "Delimiter"
    },
    advancedOptions: {
        "id": "project-create-importer-upload-flow.common.file-dropzone.advanced-options-setting.advanced-options",
        "defaultMessage": "Advanced file configuration options"
    },
    fileEncodingPopupDescription: {
        "id": "project-create-importer-upload-flow.common.file-dropzone.advanced-options-setting.file-encoding-popup-description",
        "defaultMessage": "When you open or save a file, you can choose an encoding standard. File encoding is how text is stored and helps programs determine how to represent text so that it\u2019s readable in different languages. It can also include numerical characters, alphabetical characters, and other symbols. UTF-8 is the most common file encoding language."
    },
    delimiterPopupHeading: {
        "id": "project-create-importer-upload-flow.common.file-dropzone.advanced-options-setting.delimiter-popup-heading",
        "defaultMessage": "Values separated by delimiters"
    },
    delimiterPopupDescription: {
        "id": "project-create-importer-upload-flow.common.file-dropzone.advanced-options-setting.delimiter-popup-description",
        "defaultMessage": "Your columns can have multiple values and separated by commas (,) or pipes (|)."
    },
    advancedOptionsDescription: {
        "id": "project-create-importer-upload-flow.common.file-dropzone.advanced-options-setting.advanced-options-description",
        "defaultMessage": "Advanced options for Import from CSV"
    }
});

});


parcelRegister("3F7Ru", function(module, exports) {

$parcel$export(module.exports, "default", () => $47a9766317c3b551$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $47a9766317c3b551$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    dateFormat: {
        "id": "project-create-importer-upload-flow.upload-screen.upload-csv-dropzone.upload-advanced-options.date-format",
        "defaultMessage": "Date format"
    },
    fileEncoding: {
        "id": "project-create-importer-upload-flow.upload-screen.upload-csv-dropzone.upload-advanced-options.file-encoding",
        "defaultMessage": "File encoding"
    },
    delimiter: {
        "id": "project-create-importer-upload-flow.upload-screen.upload-csv-dropzone.upload-advanced-options.delimiter",
        "defaultMessage": "Delimiter"
    },
    advancedOptions: {
        "id": "project-create-importer-upload-flow.upload-screen.upload-csv-dropzone.upload-advanced-options.advanced-options",
        "defaultMessage": "Advanced Options"
    },
    fileEncodingPopupHeading: {
        "id": "project-create-importer-upload-flow.upload-screen.upload-csv-dropzone.upload-advanced-options.file-encoding-popup-heading",
        "defaultMessage": "File encoding"
    },
    fileEncodingPopupDescription: {
        "id": "project-create-importer-upload-flow.upload-screen.upload-csv-dropzone.upload-advanced-options.file-encoding-popup-description",
        "defaultMessage": "When you open or save a file, you can choose an encoding standard. File encoding is how text is stored and helps programs determine how to represent text so that it\u2019s readable in different languages. It can also include numerical characters, alphabetical characters, and other symbols. UTF-8 is the most common file encoding language."
    },
    delimiterPopupHeading: {
        "id": "project-create-importer-upload-flow.upload-screen.upload-csv-dropzone.upload-advanced-options.delimiter-popup-heading",
        "defaultMessage": "Values separated by delimiters"
    },
    delimiterPopupDescription: {
        "id": "project-create-importer-upload-flow.upload-screen.upload-csv-dropzone.upload-advanced-options.delimiter-popup-description",
        "defaultMessage": "Your columns can have multiple values and separated by commas (,) or pipes (|)."
    },
    advancedOptionsDescription: {
        "id": "project-create-importer-upload-flow.upload-screen.upload-csv-dropzone.upload-advanced-options.advanced-options-description",
        "defaultMessage": "Advanced options for Import from CSV"
    }
});

});




parcelRegister("jXfNZ", function(module, exports) {

$parcel$export(module.exports, "UploadScreenStandard", () => $c9a3c0a7abab89c3$export$34d27733c9c42bd2);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $3yuWi = parcelRequire("3yuWi");

var $elKPF = parcelRequire("elKPF");

var $1T7vu = parcelRequire("1T7vu");

var $7cdKR = parcelRequire("7cdKR");

var $9IeJ5 = parcelRequire("9IeJ5");

var $fiH3o = parcelRequire("fiH3o");

var $cihY5 = parcelRequire("cihY5");

var $9exdj = parcelRequire("9exdj");

var $36TfL = parcelRequire("36TfL");
const $c9a3c0a7abab89c3$export$34d27733c9c42bd2 = ({ onClose: onClose, onNext: onNext, onReturn: onReturn, onCloseAndReturnToUploadStep: onCloseAndReturnToUploadStep, isCompact: isCompact = true, importType: importType })=>{
    const { heading: heading, description: description } = (0, $36TfL.useContent)(importType);
    const { productSteps: productSteps, currentStepIndex: currentStepIndex } = (0, $fiH3o.useProductSteps)();
    const [uploadedFileName] = (0, $9IeJ5.useUploadedFileName)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: (0, $3yuWi.X2C_SCREENS).UPLOAD_CSV,
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7cdKR.StepScreen), {
        renderProgressBar: !isCompact && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1T7vu.ProgressBarStandard), {
            productSteps: productSteps,
            currentStepIndex: currentStepIndex,
            onClose: onCloseAndReturnToUploadStep
        }),
        header: heading,
        description: description,
        renderFooter: !isCompact && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $elKPF.StepFooterStandard), {
            alignRight: true,
            onReturn: onReturn,
            shouldDisableNext: (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(uploadedFileName),
            onClickNext: ()=>onNext(),
            isFixedPosition: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9exdj.UploadCSVDropZone), {
        onNext: onNext,
        onClose: onClose,
        isCompact: isCompact
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cihY5.Guide), {
        importType: importType
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null)));
};

});
parcelRegister("cihY5", function(module, exports) {

$parcel$export(module.exports, "Guide", () => $bfcdb86e487271ae$export$dd9cef36367ff841);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $dEnUN = parcelRequire("dEnUN");
const $bfcdb86e487271ae$export$dd9cef36367ff841 = ({ importType: importType })=>{
    const guide = (0, $dEnUN.useGuide)(importType);
    if (guide === null) return null;
    const { heading: heading, steps: steps } = guide;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        xcss: $bfcdb86e487271ae$var$wrapperStyles,
        testId: "project-create-importer-upload-flow.ui.upload-screen-standard.guide.stack"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "h4",
        xcss: $bfcdb86e487271ae$var$headingStyles
    }, heading), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "ul",
        xcss: $bfcdb86e487271ae$var$listStyles
    }, steps.map((step, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            as: "li",
            key: index,
            xcss: $bfcdb86e487271ae$var$listItemStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $bfcdb86e487271ae$var$circleStyles
        }, index + 1), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            as: "p",
            xcss: $bfcdb86e487271ae$var$stepStyles
        }, step)))));
};
const $bfcdb86e487271ae$var$wrapperStyles = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.400'
});
const $bfcdb86e487271ae$var$headingStyles = (0, $1ZAYh.xcss)({
    color: 'color.text',
    font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $bfcdb86e487271ae$var$listStyles = (0, $1ZAYh.xcss)({
    listStyle: 'none',
    padding: 'space.0',
    marginBlockStart: 'space.200'
});
const $bfcdb86e487271ae$var$listItemStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    gap: 'space.200',
    paddingBlockEnd: 'space.100',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtle'
});
const $bfcdb86e487271ae$var$circleStyles = (0, $1ZAYh.xcss)({
    backgroundColor: 'color.background.accent.blue.subtlest',
    borderRadius: 'border.radius.circle',
    height: '24px',
    width: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around'
});
const $bfcdb86e487271ae$var$stepStyles = (0, $1ZAYh.xcss)({
    marginBlockStart: 'space.025'
});

});
parcelRegister("dEnUN", function(module, exports) {

$parcel$export(module.exports, "useGuide", () => $b89a78cf176e62d0$export$e2a645cd9d6a0957);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3ak5x = parcelRequire("3ak5x");

var $g3hu7 = parcelRequire("g3hu7");
const $b89a78cf176e62d0$var$boldElement = (content)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, content);
const $b89a78cf176e62d0$export$e2a645cd9d6a0957 = (importType)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const heading = formatMessage((0, $g3hu7.default).heading, {
        importType: importType
    });
    switch(importType){
        case 0, $3ak5x.GITHUB:
            return {
                heading: heading,
                steps: [
                    formatMessage((0, $g3hu7.default).githubStep1),
                    formatMessage((0, $g3hu7.default).githubStep2, {
                        b: $b89a78cf176e62d0$var$boldElement
                    })
                ]
            };
        case 0, $3ak5x.SMART_SHEET:
            return {
                heading: heading,
                steps: [
                    formatMessage((0, $g3hu7.default).smartsheetStep1, {
                        b: $b89a78cf176e62d0$var$boldElement
                    }),
                    formatMessage((0, $g3hu7.default).smartsheetStep2, {
                        b: $b89a78cf176e62d0$var$boldElement
                    }),
                    formatMessage((0, $g3hu7.default).smartsheetStep3)
                ]
            };
        case 0, $3ak5x.LINEAR:
            return {
                heading: heading,
                steps: [
                    formatMessage((0, $g3hu7.default).linearStep1),
                    formatMessage((0, $g3hu7.default).linearStep2, {
                        b: $b89a78cf176e62d0$var$boldElement
                    })
                ]
            };
        case 0, $3ak5x.GITLAB:
            return {
                heading: heading,
                steps: [
                    formatMessage((0, $g3hu7.default).gitLabStep1),
                    formatMessage((0, $g3hu7.default).gitLabStep2, {
                        b: $b89a78cf176e62d0$var$boldElement
                    }),
                    formatMessage((0, $g3hu7.default).gitLabStep3, {
                        b: $b89a78cf176e62d0$var$boldElement
                    })
                ]
            };
        case 0, $3ak5x.AZURE_DEVOPS:
            return {
                heading: heading,
                steps: [
                    formatMessage((0, $g3hu7.default).azureDevopsStep1, {
                        b: $b89a78cf176e62d0$var$boldElement
                    }),
                    formatMessage((0, $g3hu7.default).azureDevopsStep2),
                    formatMessage((0, $g3hu7.default).azureDevopsStep3, {
                        b: $b89a78cf176e62d0$var$boldElement
                    })
                ]
            };
        case 0, $3ak5x.WRIKE:
            return {
                heading: heading,
                steps: [
                    formatMessage((0, $g3hu7.default).wrikeStep1, {
                        b: $b89a78cf176e62d0$var$boldElement
                    }),
                    formatMessage((0, $g3hu7.default).wrikeStep2, {
                        b: $b89a78cf176e62d0$var$boldElement
                    }),
                    formatMessage((0, $g3hu7.default).wrikeStep3, {
                        b: $b89a78cf176e62d0$var$boldElement
                    }),
                    formatMessage((0, $g3hu7.default).wrikeStep4)
                ]
            };
        case 0, $3ak5x.JETBRAINS_YOUTRACK:
            return {
                heading: heading,
                steps: [
                    formatMessage((0, $g3hu7.default).jetbrainsStep1, {
                        b: $b89a78cf176e62d0$var$boldElement
                    }),
                    formatMessage((0, $g3hu7.default).jetbrainsStep2, {
                        b: $b89a78cf176e62d0$var$boldElement
                    })
                ]
            };
        case 0, $3ak5x.AIRTABLE:
            return {
                heading: heading,
                steps: [
                    formatMessage((0, $g3hu7.default).airtableStep1),
                    formatMessage((0, $g3hu7.default).airtableStep2, {
                        b: $b89a78cf176e62d0$var$boldElement
                    })
                ]
            };
        case 0, $3ak5x.NOTION:
            return {
                heading: heading,
                steps: [
                    formatMessage((0, $g3hu7.default).notionStep1, {
                        b: $b89a78cf176e62d0$var$boldElement
                    }),
                    formatMessage((0, $g3hu7.default).notionStep2, {
                        b: $b89a78cf176e62d0$var$boldElement
                    }),
                    formatMessage((0, $g3hu7.default).notionStep3)
                ]
            };
        default:
            return null;
    }
};

});
parcelRegister("g3hu7", function(module, exports) {

$parcel$export(module.exports, "default", () => $92b5b12f25bb84c5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $92b5b12f25bb84c5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    heading: {
        "id": "project-create-importer-upload-flow.upload-screen-standard.guide.heading",
        "defaultMessage": "To export your data from {importType}:"
    },
    githubStep1: {
        "id": "project-create-importer-upload-flow.upload-screen-standard.guide.github-step-1",
        "defaultMessage": "Go to a board you want to export and open project view."
    },
    githubStep2: {
        "id": "project-create-importer-upload-flow.upload-screen-standard.guide.github-step-2",
        "defaultMessage": "Select the arrow next to the view name and select <b>Download CSV</b>."
    },
    smartsheetStep1: {
        "id": "project-create-importer-upload-flow.upload-screen-standard.guide.smartsheet-step-1",
        "defaultMessage": "Select <b>File</b> > <b>Export</b> > <b>Export to Microsoft Excel</b>"
    },
    smartsheetStep2: {
        "id": "project-create-importer-upload-flow.upload-screen-standard.guide.smartsheet-step-2",
        "defaultMessage": "Once the file is downloaded, open the file in Excel. Select <b>File</b> > <b>Save As</b>."
    },
    smartsheetStep3: {
        "id": "project-create-importer-upload-flow.upload-screen-standard.guide.smartsheet-step-3",
        "defaultMessage": "In the dialog box, select CSV as the file format."
    },
    linearStep1: {
        "id": "project-create-importer-upload-flow.upload-screen-standard.guide.linear-step-1",
        "defaultMessage": "In projects or custom view, select a project."
    },
    linearStep2: {
        "id": "project-create-importer-upload-flow.upload-screen-standard.guide.linear-step-2",
        "defaultMessage": "Select \u22EF option > <b>Export issues as CSV\u2026</b>."
    },
    azureDevopsStep1: {
        "id": "project-create-importer-upload-flow.upload-screen-standard.guide.azure-devops-step-1",
        "defaultMessage": "Create a <b>query</b> to filter the work items you would like to export."
    },
    azureDevopsStep2: {
        "id": "project-create-importer-upload-flow.upload-screen-standard.guide.azure-devops-step-2",
        "defaultMessage": "Open the query."
    },
    azureDevopsStep3: {
        "id": "project-create-importer-upload-flow.upload-screen-standard.guide.azure-devops-step-3",
        "defaultMessage": "Select \u22EF option > <b>Export to CSV.</b>"
    },
    gitLabStep1: {
        "id": "project-create-importer-upload-flow.upload-screen-standard.guide.git-lab-step-1",
        "defaultMessage": "Go to the project you want to export."
    },
    gitLabStep2: {
        "id": "project-create-importer-upload-flow.upload-screen-standard.guide.git-lab-step-2",
        "defaultMessage": "Select <b>Plan</b> > <b>Issues</b> > <b>Actions</b> (\u22EE) > <b>Export as CSV</b>."
    },
    gitLabStep3: {
        "id": "project-create-importer-upload-flow.upload-screen-standard.guide.git-lab-step-3",
        "defaultMessage": "Verify if the email address is correct and select <b>Export issues</b>."
    },
    wrikeStep1: {
        "id": "project-create-importer-upload-flow.upload-screen-standard.guide.wrike-step-1",
        "defaultMessage": "Go to a project, select \u22EF > <b>Export</b> > <b>Excel</b>."
    },
    wrikeStep2: {
        "id": "project-create-importer-upload-flow.upload-screen-standard.guide.wrike-step-2",
        "defaultMessage": "In the pop-up window, choose if you want to export only filtered tasks or all tasks, then select <b>Export</b>."
    },
    wrikeStep3: {
        "id": "project-create-importer-upload-flow.upload-screen-standard.guide.wrike-step-3",
        "defaultMessage": "Once the file is downloaded, open the file in Excel. Select <b>File</b> > <b>Save As</b>."
    },
    wrikeStep4: {
        "id": "project-create-importer-upload-flow.upload-screen-standard.guide.wrike-step-4",
        "defaultMessage": "In the dialog box, select CSV as the file format."
    },
    jetbrainsStep1: {
        "id": "project-create-importer-upload-flow.upload-screen-standard.guide.jetbrains-step-1",
        "defaultMessage": "Go to the <b>Issues List</b> and select the issues you want to import."
    },
    jetbrainsStep2: {
        "id": "project-create-importer-upload-flow.upload-screen-standard.guide.jetbrains-step-2",
        "defaultMessage": "Select \u22EF > <b>Export in CSV</b>."
    },
    airtableStep1: {
        "id": "project-create-importer-upload-flow.upload-screen-standard.guide.airtable-step-1",
        "defaultMessage": "Go to Grid view."
    },
    airtableStep2: {
        "id": "project-create-importer-upload-flow.upload-screen-standard.guide.airtable-step-2",
        "defaultMessage": "Select <b>Download CSV</b> in the Grid view dropdown."
    },
    notionStep1: {
        "id": "project-create-importer-upload-flow.upload-screen-standard.guide.notion-step-1",
        "defaultMessage": "Select \u22EF in a Notion page and select <b>Export</b>."
    },
    notionStep2: {
        "id": "project-create-importer-upload-flow.upload-screen-standard.guide.notion-step-2",
        "defaultMessage": "In the pop-up window, select the export format (<b>Markdowns & CSV</b>), choose what data to include in your export, and select <b>Export</b>."
    },
    notionStep3: {
        "id": "project-create-importer-upload-flow.upload-screen-standard.guide.notion-step-3",
        "defaultMessage": "From the downloaded zip file, use the CSV file for importing into Jira."
    }
});

});



parcelRegister("9exdj", function(module, exports) {

$parcel$export(module.exports, "UploadCSVDropZone", () => $07f40c00a488ecab$export$c949aefb7a48049a);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $7u4fN = parcelRequire("7u4fN");

var $b5IAe = parcelRequire("b5IAe");
var $c0jFd = parcelRequire("c0jFd");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3ak5x = parcelRequire("3ak5x");

var $bz2yd = parcelRequire("bz2yd");

var $d0wrd = parcelRequire("d0wrd");
var $9IeJ5 = parcelRequire("9IeJ5");

var $2sRUp = parcelRequire("2sRUp");

var $bHhAe = parcelRequire("bHhAe");
const $07f40c00a488ecab$export$c949aefb7a48049a = ({ onNext: onNext, onClose: onClose, isCompact: isCompact })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [uploadedFileName] = (0, $9IeJ5.useUploadedFileName)();
    const onContinue = (0, $eUqFw.useCallback)(()=>{
        onNext((0, $3ak5x.CSV));
    }, [
        onNext
    ]);
    const [{ type: type }] = (0, $d0wrd.useProjectData)();
    const [source] = (0, $2sRUp.useSource)();
    const { uploadCsvDropzoneHeading: uploadCsvDropzoneHeading, uploadFooterContinue: uploadFooterContinue, uploadFooterCancel: uploadFooterCancel } = (0, $bz2yd.useProjectSpecificContent)(type, source);
    if (!isCompact) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bHhAe.Dropzone), {
        isLeaner: !isCompact
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        as: "h4",
        color: "color.text",
        paddingBlockStart: "space.300"
    }, formatMessage(uploadCsvDropzoneHeading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bHhAe.Dropzone), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        justifyContent: "end",
        gap: "space.100",
        xcss: $07f40c00a488ecab$var$buttonGroupStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "project-create-importer-upload-flow.ui.upload-screen-standard.upload-csv-dropzone.cancel-button",
        appearance: "subtle",
        onClick: onClose
    }, formatMessage(uploadFooterCancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "primary",
        onClick: onContinue,
        isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(uploadedFileName),
        testId: "project-create-importer-upload-flow.ui.upload-screen-standard.upload-csv-dropzone.next-button"
    }, formatMessage(uploadFooterContinue))));
};
const $07f40c00a488ecab$var$buttonGroupStyles = (0, $1ZAYh.xcss)({
    paddingBlockStart: 'space.200',
    paddingBlockEnd: 'space.300',
    marginBlockStart: 'space.250'
});

});
parcelRegister("bHhAe", function(module, exports) {

$parcel$export(module.exports, "Dropzone", () => $11d3731c0c8ebf6e$export$47d4850b9fdf5af1);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $1zbEq = parcelRequire("1zbEq");

var $dsYFU = parcelRequire("dsYFU");
var $fiPvm = parcelRequire("fiPvm");
var $hPpMk = parcelRequire("hPpMk");

var $8lGnr = parcelRequire("8lGnr");

var $bLalW = parcelRequire("bLalW");
var $lUC5l = parcelRequire("lUC5l");

var $fZlPL = parcelRequire("fZlPL");
const $11d3731c0c8ebf6e$export$47d4850b9fdf5af1 = ({ isLeaner: isLeaner = false })=>{
    const [advancedOptions, { updateAdvancedOptions: updateAdvancedOptions }] = (0, $bLalW.useAdvancedOptions)();
    const [mappingState, { setMappingState: setMappingState }] = (0, $lUC5l.useMappingState)();
    const { isFileBrowserOpen: isFileBrowserOpen, isFileNotCSV: isFileNotCSV, isFileTooLarge: isFileTooLarge, isFileUploading: isFileUploading, hasErrorOccurred: hasErrorOccurred, uploadedFileName: uploadedFileName, onReceiveFile: onReceiveFile, onRemoveFile: onRemoveFile, onCloseFileBrowser: onCloseFileBrowser, onOpenFileBrowser: onOpenFileBrowser, onFileDraggedAndDropped: onFileDraggedAndDropped } = (0, $fZlPL.useCSVDropzone)();
    const onChange = (0, $eUqFw.useCallback)((data)=>{
        updateAdvancedOptions(data);
        // Reset mapping state if data has previously been loaded
        if (mappingState !== null) setMappingState(null);
    }, [
        mappingState,
        setMappingState,
        updateAdvancedOptions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($11d3731c0c8ebf6e$export$c2688265d2f836e2, {
        onReceiveFile: onFileDraggedAndDropped,
        onClick: onOpenFileBrowser,
        isDisabled: isFileUploading,
        isLeaner: isLeaner
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8lGnr.DropzoneContent), {
        isFileUploading: isFileUploading,
        isFileNotCSV: isFileNotCSV,
        hasErrorOccurred: hasErrorOccurred,
        isFileTooLarge: isFileTooLarge,
        uploadedFileName: uploadedFileName,
        onRemoveFile: onRemoveFile,
        isLeaner: isLeaner
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fiPvm.FileBrowser), {
        isOpen: isFileBrowserOpen,
        onReceiveFile: onReceiveFile,
        onClose: onCloseFileBrowser
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dsYFU.AdvancedOptionsSetting), {
        advancedOptions: advancedOptions,
        onChange: onChange
    }));
};
const $11d3731c0c8ebf6e$export$c2688265d2f836e2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $hPpMk.FileDropTarget), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8zu5n _1yt4pxbi",
            __cmplp.isLeaner ? "_1tke1w81" : "_1tkeuuw1",
            __cmplp.className
        ])
    });
});

});


parcelRegister("36TfL", function(module, exports) {

$parcel$export(module.exports, "useContent", () => $d58342dc2d188aec$export$ee83783e2ce4cc63);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kzTj7 = parcelRequire("kzTj7");

var $9R4E5 = parcelRequire("9R4E5");


var $bgSxq = parcelRequire("bgSxq");

var $d0wrd = parcelRequire("d0wrd");
var $2sRUp = parcelRequire("2sRUp");

var $3lDgd = parcelRequire("3lDgd");
const $d58342dc2d188aec$export$ee83783e2ce4cc63 = (importType)=>{
    const [source] = (0, $2sRUp.useSource)();
    const [{ name: name, type: type }] = (0, $d0wrd.useProjectData)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { uploadScreenDescription: uploadScreenDescription } = (0, $bgSxq.useContentForCSV)(importType);
    return (0, $eUqFw.useMemo)(()=>{
        if (source === (0, $85ba070c29b4a3bd$export$ec4d35718915f521)) return {
            heading: formatMessage((0, $3lDgd.default).headingExistingProject, {
                projectName: name
            }),
            description: formatMessage((0, $3lDgd.default).descriptionExistingProject, {
                link: (content)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                        href: type === (0, $9R4E5.ProjectTypes).SOFTWARE ? (0, $kzTj7.LEARN_MORE_LINK_JSW) : (0, $kzTj7.LEARN_MORE_LINK),
                        target: "_blank",
                        appearance: "link",
                        spacing: "none"
                    }, content)
            })
        };
        return {
            heading: formatMessage((0, $3lDgd.default).heading),
            description: uploadScreenDescription
        };
    }, [
        formatMessage,
        name,
        source,
        type,
        uploadScreenDescription
    ]);
};

});
parcelRegister("3lDgd", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dab419a24a970a8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3dab419a24a970a8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    heading: {
        "id": "project-create-importer-upload-flow.upload-screen-standard.heading",
        "defaultMessage": "Upload a CSV file"
    },
    headingExistingProject: {
        "id": "project-create-importer-upload-flow.upload-screen-standard.heading-existing-project",
        "defaultMessage": "Import data into {projectName}"
    },
    descriptionExistingProject: {
        "id": "project-create-importer-upload-flow.upload-screen-standard.description-existing-project",
        "defaultMessage": "Let's bring your data into Jira. Before you begin, format your CSV to match the fields in your selected project using our <link>import documentation</link>."
    }
});

});



parcelRegister("2PJOp", function(module, exports) {

$parcel$export(module.exports, "UserMappingScreen", () => $88fd64c06d9f04bb$export$5725891a07ed4d6e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bLFgh = parcelRequire("bLFgh");
var $7u4fN = parcelRequire("7u4fN");

var $lzLxZ = parcelRequire("lzLxZ");
var $7CD1S = parcelRequire("7CD1S");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $lRvnl = parcelRequire("lRvnl");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $gd0Sp = parcelRequire("gd0Sp");

var $gGm3k = parcelRequire("gGm3k");

var $3yuWi = parcelRequire("3yuWi");

var $1VyqP = parcelRequire("1VyqP");

var $3EVB9 = parcelRequire("3EVB9");

var $fQU5k = parcelRequire("fQU5k");

var $elKPF = parcelRequire("elKPF");

var $1T7vu = parcelRequire("1T7vu");

var $bz2yd = parcelRequire("bz2yd");

var $d0wrd = parcelRequire("d0wrd");
var $irKna = parcelRequire("irKna");

var $asXeB = parcelRequire("asXeB");

var $fiH3o = parcelRequire("fiH3o");

var $2Iz1k = parcelRequire("2Iz1k");

var $df2ei = parcelRequire("df2ei");

var $c1PhN = parcelRequire("c1PhN");
const $88fd64c06d9f04bb$export$5725891a07ed4d6e = ({ thirdParty: thirdParty, hasProgressBar: hasProgressBar, onReturn: onReturn, onNext: onNext, onCloseAndReturnToUploadStep: onCloseAndReturnToUploadStep })=>{
    const [, { setRequestAuthenticationToken: setRequestAuthenticationToken }] = (0, $asXeB.useAccessTokenModalState)();
    const { fetchThirdPartyMembers: fetchThirdPartyMembers, isLoading: isLoading, hasErrorOccurred: hasErrorOccurred } = (0, $2Iz1k.useThirdPartyMembers)({
        thirdParty: thirdParty,
        requestAuthenticationToken: setRequestAuthenticationToken
    });
    const [thirdPartyState] = (0, $irKna.useThirdPartyState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [{ members: members, userEmails: userEmails }, { setThirdPartyState: setThirdPartyState }] = (0, $irKna.useThirdPartyState)();
    const { productSteps: productSteps, currentStepIndex: currentStepIndex } = (0, $fiH3o.useProductSteps)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ type: type }] = (0, $d0wrd.useProjectData)();
    const { userMappingScreenDescription: userMappingScreenDescription } = (0, $bz2yd.useProjectSpecificContent)(type);
    const { isSiteAdmin: isSiteAdmin, isAdmin: isAdmin } = (0, $gd0Sp.useTenantContext)();
    const onFetchThirdPartyMembers = (0, $eUqFw.useCallback)(()=>{
        thirdPartyState.selectedEntityId && fetchThirdPartyMembers(thirdPartyState.selectedEntityId).then((data)=>setThirdPartyState({
                members: data.members,
                userEmails: data.userEmails
            }));
    }, [
        fetchThirdPartyMembers,
        setThirdPartyState,
        thirdPartyState.selectedEntityId
    ]);
    (0, $eUqFw.useEffect)(()=>{
        !members && onFetchThirdPartyMembers();
    }, [
        fetchThirdPartyMembers,
        members,
        onFetchThirdPartyMembers,
        setThirdPartyState,
        thirdParty,
        thirdPartyState.selectedEntityId
    ]);
    const tableHead = (0, $c1PhN.useTableHead)();
    const tableRows = (0, $c1PhN.useTableRows)(members, userEmails);
    const handleSubmit = (0, $eUqFw.useCallback)((formData)=>{
        const userEmailsFromForm = (0, $c1PhN.convertFormDataToUserEmails)(formData);
        setThirdPartyState({
            userEmails: userEmailsFromForm
        });
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'thirdPartyMembersEmails entered', {
            thirdParty: thirdParty,
            numTotalMembers: members?.length || 0,
            numMembersWithEmail: Object.keys(userEmailsFromForm).length
        });
        onNext();
    }, [
        createAnalyticsEvent,
        members?.length,
        onNext,
        setThirdPartyState,
        thirdParty
    ]);
    const renderStepFooterComponent = (0, $eUqFw.useMemo)(()=>{
        if ((0, $eI5EY.fg)('enable-x2c-standardised-flow')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $elKPF.StepFooterStandard), {
            alignRight: true,
            onReturn: onReturn,
            isLoading: isLoading,
            nextButtonType: "submit"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7CD1S.default), {
            align: "end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $elKPF.StepFooter), {
            onReturn: onReturn,
            isLoading: isLoading,
            nextButtonType: "submit"
        }));
    }, [
        isLoading,
        onReturn
    ]);
    const getContent = (0, $eUqFw.useCallback)(()=>{
        if (hasErrorOccurred) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($88fd64c06d9f04bb$var$ErrorWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($88fd64c06d9f04bb$var$Illustration, {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($gGm3k))),
            "aria-describedby": "user-error-icon",
            role: "img",
            alt: ""
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1VyqP.ErrorHeading), {
            id: "user-error-icon"
        }, formatMessage((0, $df2ei.default).error)), (0, $eI5EY.fg)('enable-x2c-standardised-flow') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "primary",
            onClick: onFetchThirdPartyMembers
        }, formatMessage((0, $df2ei.default).tryAgain))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $elKPF.StepFooterStandard), {
            alignRight: true,
            onReturn: onReturn,
            shouldDisableNext: true
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bLFgh.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            onClick: onReturn
        }, formatMessage((0, $df2ei.default).back)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "primary",
            onClick: onFetchThirdPartyMembers
        }, formatMessage((0, $df2ei.default).tryAgain))));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1VyqP.PageDescription), null, formatMessage(userMappingScreenDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($88fd64c06d9f04bb$var$FormWrapper, null, (0, $1ybV0.ff)('enable-product-admin-for-x2c-migration_zmlsv') && !isSiteAdmin && isAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            paddingBlockEnd: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
            title: formatMessage((0, $df2ei.default).newUserNotAllowedToImportBannerHeading)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            as: "p"
        }, formatMessage((0, $df2ei.default).newUserNotAllowedToImportBannerDescription)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lzLxZ.default), {
            onSubmit: handleSubmit
        }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($88fd64c06d9f04bb$var$StyledForm, {
                ...formProps,
                isLoading: isLoading
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fQU5k.AsyncMappingTable), {
                head: tableHead,
                rows: tableRows,
                isLoading: isLoading,
                emptyMessage: (0, $df2ei.default).noUsers
            }), renderStepFooterComponent))));
    }, [
        formatMessage,
        handleSubmit,
        hasErrorOccurred,
        isAdmin,
        isLoading,
        isSiteAdmin,
        onFetchThirdPartyMembers,
        onReturn,
        renderStepFooterComponent,
        tableHead,
        tableRows,
        userMappingScreenDescription
    ]);
    const progressBarComponent = (0, $eUqFw.useMemo)(()=>{
        if ((0, $eI5EY.fg)('enable-x2c-standardised-flow')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, hasProgressBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1T7vu.ProgressBarStandard), {
            productSteps: productSteps,
            currentStepIndex: currentStepIndex,
            onClose: onCloseAndReturnToUploadStep
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $88fd64c06d9f04bb$var$paddingForProgressBar
        })));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3EVB9.CloseAndReturnButton), {
            onCloseAndReturnToUploadStep: onCloseAndReturnToUploadStep
        }), hasProgressBar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1T7vu.StepProgressBar), {
            productSteps: productSteps,
            currentStepIndex: currentStepIndex
        }));
    }, [
        productSteps,
        currentStepIndex,
        hasProgressBar,
        onCloseAndReturnToUploadStep
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: (0, $3yuWi.X2C_SCREENS).USER_MAPPING,
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        attributes: {
            thirdParty: thirdParty
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($88fd64c06d9f04bb$var$Wrapper, {
        "data-testid": "project-create-importer-upload-flow.ui.user-mapping-screen.wrapper"
    }, progressBarComponent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($88fd64c06d9f04bb$var$ContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1VyqP.PageHeading), null, formatMessage((0, $df2ei.default).heading)), getContent()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $88fd64c06d9f04bb$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1n261q9c _1bsb1osq _vchhusvi _1yt41avh _bfhk1j9a _11381ns9",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $88fd64c06d9f04bb$var$ContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s82gi7 _1bsb1w8u _p12f1qe4 _1tke1nrf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $88fd64c06d9f04bb$var$FormWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkxy5q _p12fmn5p _3xx17mnp _1ckz1wmp _17mut94y _1p1ft94y _89vy1n1a _5rvh1n1a _32nk1n1a _wws01n1a _12vq15vq _1vyi15vq _d7ffidpf _1j86idpf _1qrcidpf _4yngidpf _qz3tstnw",
            __cmplp.className
        ])
    });
});
const $88fd64c06d9f04bb$var$StyledForm = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "form", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLoading: isLoading, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_j3jiq82g _nzdf1wug _v5rg15vq",
            __cmplp.isLoading ? "_1k92idpf" : "_1k92uuw1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $88fd64c06d9f04bb$var$Illustration = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1lit _c71l1lit _1bsb1ssb _4t3i1ssb",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $88fd64c06d9f04bb$var$ErrorWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bsb1osq _4t3i1osq _2lx21bp4 _1bah1h6o",
            __cmplp.className
        ])
    });
});
const $88fd64c06d9f04bb$var$paddingForProgressBar = (0, $1ZAYh.xcss)({
    paddingTop: 'space.800'
});

});
parcelRegister("2Iz1k", function(module, exports) {

$parcel$export(module.exports, "useThirdPartyMembers", () => $b83e6330ff8b5617$export$84e08dcf99e4e98);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $gyZoj = parcelRequire("gyZoj");
var $5GSA7 = parcelRequire("5GSA7");

var $kzTj7 = parcelRequire("kzTj7");

var $3yuWi = parcelRequire("3yuWi");

var $8OWUq = parcelRequire("8OWUq");

var $kHqXN = parcelRequire("kHqXN");
const $b83e6330ff8b5617$export$84e08dcf99e4e98 = ({ thirdParty: thirdParty, requestAuthenticationToken: requestAuthenticationToken })=>{
    const thirdPartyClient = (0, $8OWUq.useThirdPartyClient)({
        thirdParty: thirdParty,
        requestAuthenticationToken: requestAuthenticationToken
    });
    const [onExperienceStart, onExperienceSuccess, onExperienceFail] = (0, $5GSA7.useExperienceTracker)((0, $3yuWi.EXPERIENCES).THIRD_PARTY_MEMBERS);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [hasErrorOccurred, setHasErrorOccurred] = (0, $eUqFw.useState)(false);
    const fetchThirdPartyMembers = (0, $eUqFw.useCallback)(async (entityId)=>{
        setIsLoading(true);
        setHasErrorOccurred(false);
        (0, $3yuWi.thirdPartyMembersInteractionMetric).start();
        onExperienceStart();
        try {
            const members = await thirdPartyClient.getEntityMembers({
                entityId: entityId
            });
            (0, $3yuWi.thirdPartyMembersInteractionMetric).stop();
            onExperienceSuccess();
            setIsLoading(false);
            return {
                members: members,
                userEmails: (0, $kHqXN.getUserEmails)(members)
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $3yuWi.thirdPartyMembersInteractionMetric).stop();
            onExperienceFail((0, $kzTj7.APP_IDENTIFIER), error, {
                thirdParty: thirdParty
            });
            (0, $guiFP.default)({
                meta: {
                    id: 'fetch-third-party-member-entities',
                    packageName: (0, $kzTj7.APP_IDENTIFIER),
                    teamName: (0, $gyZoj.APP_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true,
                error: error
            });
            setHasErrorOccurred(true);
            setIsLoading(false);
            return {
                members: null,
                userEmails: {}
            };
        }
    }, [
        onExperienceFail,
        onExperienceStart,
        onExperienceSuccess,
        thirdPartyClient,
        thirdParty
    ]);
    return {
        isLoading: isLoading,
        hasErrorOccurred: hasErrorOccurred,
        fetchThirdPartyMembers: fetchThirdPartyMembers
    };
};

});
parcelRegister("kHqXN", function(module, exports) {

$parcel$export(module.exports, "getUserEmails", () => $30100ad593a30e89$export$54d7ec7e554a8cd4);
const $30100ad593a30e89$export$54d7ec7e554a8cd4 = (members)=>{
    if (!members || members.length === 0) return {};
    const userEmailMappings = {};
    members.forEach((member)=>{
        if (member.email) userEmailMappings[member.id] = {
            emailId: member.email
        };
    });
    return userEmailMappings;
};

});


parcelRegister("df2ei", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f6bf9b0c159beac$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0f6bf9b0c159beac$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    heading: {
        "id": "project-create-importer-upload-flow.user-mapping-screen.heading",
        "defaultMessage": "Invite users to your project"
    },
    user: {
        "id": "project-create-importer-upload-flow.user-mapping-screen.user",
        "defaultMessage": "User"
    },
    email: {
        "id": "project-create-importer-upload-flow.user-mapping-screen.email",
        "defaultMessage": "Email"
    },
    back: {
        "id": "project-create-importer-upload-flow.user-mapping-screen.back",
        "defaultMessage": "Back"
    },
    tryAgain: {
        "id": "project-create-importer-upload-flow.user-mapping-screen.try-again",
        "defaultMessage": "Try again"
    },
    textFieldPlaceholder: {
        "id": "project-create-importer-upload-flow.user-mapping-screen.text-field-placeholder",
        "defaultMessage": "e.g., name@company.com"
    },
    error: {
        "id": "project-create-importer-upload-flow.user-mapping-screen.error",
        "defaultMessage": "We couldn't find the user details"
    },
    noUsers: {
        "id": "project-create-importer-upload-flow.user-mapping-screen.no-users",
        "defaultMessage": "There are no users in your selected board."
    },
    newUserNotAllowedToImportBannerHeading: {
        "id": "project-create-importer-upload-flow.user-mapping-screen.new-user-not-allowed-to-import-banner-heading",
        "defaultMessage": "You do not have permission to invite new users"
    },
    newUserNotAllowedToImportBannerDescription: {
        "id": "project-create-importer-upload-flow.user-mapping-screen.new-user-not-allowed-to-import-banner-description",
        "defaultMessage": "You can either ask an organization admin to invite new users before moving ahead with your import or continue without them. Any information of new users added here will not be imported."
    }
});

});

parcelRegister("c1PhN", function(module, exports) {

$parcel$export(module.exports, "convertFormDataToUserEmails", () => $6eb776fec56192b0$export$cf2757943730ee46);
$parcel$export(module.exports, "useTableHead", () => $6eb776fec56192b0$export$c1593f9fc5eec62b);
$parcel$export(module.exports, "useTableRows", () => $6eb776fec56192b0$export$a190e1af00082b41);

var $eUqFw = parcelRequire("eUqFw");

var $4LhB6 = parcelRequire("4LhB6");

var $cf2Y4 = parcelRequire("cf2Y4");

var $5JgJ2 = parcelRequire("5JgJ2");

var $df2ei = parcelRequire("df2ei");
const $6eb776fec56192b0$export$cf2757943730ee46 = (formData)=>{
    const userEmails = {};
    Object.keys(formData).forEach((key)=>{
        const emailId = formData[key];
        if (emailId && emailId.length > 0) userEmails[key] = {
            emailId: emailId
        };
    });
    return userEmails;
};
const $6eb776fec56192b0$export$c1593f9fc5eec62b = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const tableHead = (0, $eUqFw.useMemo)(()=>({
            cells: [
                {
                    key: 'user',
                    content: formatMessage((0, $df2ei.default).user),
                    isSortable: true,
                    shouldTruncate: true
                },
                {
                    key: 'arrow',
                    width: 5
                },
                {
                    key: 'email',
                    content: formatMessage((0, $df2ei.default).email)
                }
            ]
        }), [
        formatMessage
    ]);
    return tableHead;
};
const $6eb776fec56192b0$export$a190e1af00082b41 = (members, userEmails)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const tableRows = (0, $eUqFw.useMemo)(()=>members?.map((member)=>({
                key: `row-${member.id}`,
                cells: [
                    {
                        key: member.fullName,
                        content: member.fullName
                    },
                    {
                        key: `${member.id}-arrow`,
                        content: "\u2192"
                    },
                    {
                        key: `${member.id}-email`,
                        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
                            name: member.id,
                            defaultValue: userEmails[member.id]?.emailId || '',
                            label: `${member.fullName} email`
                        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
                                type: "email",
                                ...fieldProps,
                                placeholder: formatMessage((0, $df2ei.default).textFieldPlaceholder)
                            }))
                    }
                ]
            })), [
        formatMessage,
        members,
        userEmails
    ]);
    return tableRows;
};

});



parcelRegister("gyzna", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae1b843711defd8b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2RSru = parcelRequire("2RSru");

var $kzTj7 = parcelRequire("kzTj7");
const $ae1b843711defd8b$var$NewImporterLozenge = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2RSru.NewLozenge), {
        flag: (0, $kzTj7.PROJECT_CREATE_IMPORTER_SEEN_IT_FLAG)
    });
var $ae1b843711defd8b$export$2e2bcd8739ae039 = $ae1b843711defd8b$var$NewImporterLozenge;

});
parcelRegister("2RSru", function(module, exports) {

$parcel$export(module.exports, "NewLozenge", () => $c92ff552bae2be42$export$aaf471b17355e1c6);

var $eUqFw = parcelRequire("eUqFw");

var $ffiyv = parcelRequire("ffiyv");

var $jBAQz = parcelRequire("jBAQz");

var $gUUjF = parcelRequire("gUUjF");

var $5JgJ2 = parcelRequire("5JgJ2");


var $5tkXM = parcelRequire("5tkXM");
const $c92ff552bae2be42$export$aaf471b17355e1c6 = /*#__PURE__*/ (0, $eUqFw.memo)(({ flag: flag, testId: testId })=>{
    const [isLozengeVisible, setIsLozengeVisible] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    (0, $eUqFw.useEffect)(()=>{
        if (false) return;
        (0, $jBAQz.getFlags)({
            [flag]: {}
        }).then((response)=>{
            if (!response[flag]?.status) setIsLozengeVisible(true);
        }).catch(()=>{
            (0, $gUUjF.default).safeErrorWithoutCustomerData((0, $65fc8361bcd11294$export$7ec1427613e4cea), 'Failed to fetch have-i-seen-it flags.');
        });
    }, [
        flag
    ]);
    return isLozengeVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: "new",
        testId: testId
    }, formatMessage((0, $5tkXM.messages).new))) : null;
});

});
const $65fc8361bcd11294$export$7ec1427613e4cea = 'jira-business.common.ui.new-lozenge';

parcelRegister("5tkXM", function(module, exports) {

$parcel$export(module.exports, "messages", () => $254b8a1db1073b89$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $254b8a1db1073b89$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    new: {
        "id": "business-onboarding-common.new-lozenge.new",
        "defaultMessage": "New"
    }
});

});






parcelRegister("7QQh7", function(module, exports) {

$parcel$export(module.exports, "default", () => $b151fed675f1d2a4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b151fed675f1d2a4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noSummary: {
        "id": "issue-create.common.no-summary",
        "defaultMessage": "(No summary)"
    },
    noSummaryWithIssueType: {
        "id": "issue-create.common.no-summary-with-issue-type",
        "defaultMessage": "{issueType, select,\n            Task {New task}\n            Subtask {New subtask}\n            Story {New story}\n            Bug {New bug}\n            Epic {New epic}\n            Idea {New idea}\n            Request {New request}\n            other {{issueType}}\n        }"
    },
    resizeSpotlightMessage: {
        "id": "issue-create.common.resize-spotlight-message",
        "defaultMessage": "Resize or minimize your issue to pause editing and navigate around Jira."
    },
    miniModalSpotlightMessage: {
        "id": "issue-create.common.mini-modal-spotlight-message",
        "defaultMessage": "Create work in context and navigate your project without losing progress using the new create experience.{br}Expand to see the full view, or minimize to revisit it later. "
    },
    miniModalSpotlightActionMessage: {
        "id": "issue-create.common.mini-modal-spotlight-action-message",
        "defaultMessage": "Got it"
    },
    miniModalSpotlightHeading: {
        "id": "issue-create.common.mini-modal-spotlight-heading",
        "defaultMessage": "Multitasking made easy"
    }
});

});

parcelRegister("04KnN", function(module, exports) {

$parcel$export(module.exports, "NavigationDiscardChangesContainer", () => $92eba8e0abda82d0$export$6b9c176805b3c455);
$parcel$export(module.exports, "useNavigationDiscardChanges", () => $92eba8e0abda82d0$export$bf0dbeb75772072);
$parcel$export(module.exports, "useNavigationDiscardChangesActions", () => $92eba8e0abda82d0$export$9f61952484b5dffe);

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");

var $bMcrx = parcelRequire("bMcrx");
const $92eba8e0abda82d0$export$d4c72bab9d6cc13a = {
    deferredNavigationLink: ''
};
const $92eba8e0abda82d0$var$store = (0, $a61MH.createStore)({
    name: 'NavigationDiscardChanges',
    initialState: $92eba8e0abda82d0$export$d4c72bab9d6cc13a,
    actions: $bMcrx.actions
});
const $92eba8e0abda82d0$export$6b9c176805b3c455 = (0, $heB5U.createContainer)($92eba8e0abda82d0$var$store);
const $92eba8e0abda82d0$export$bf0dbeb75772072 = (0, $ggKAj.createHook)($92eba8e0abda82d0$var$store);
const $92eba8e0abda82d0$export$9f61952484b5dffe = (0, $ggKAj.createActionsHook)($92eba8e0abda82d0$var$store);

});
parcelRegister("bMcrx", function(module, exports) {

$parcel$export(module.exports, "actions", () => $db63f489639ad9bd$export$e324594224ef24da);
const $db63f489639ad9bd$export$a750007c2edb3b26 = (deferredNavigationLink)=>({ setState: setState })=>setState({
            deferredNavigationLink: deferredNavigationLink
        });
const $db63f489639ad9bd$export$e324594224ef24da = {
    setDeferredNavigationLink: $db63f489639ad9bd$export$a750007c2edb3b26
};

});


parcelRegister("lq8gO", function(module, exports) {

$parcel$export(module.exports, "useIssueCreateFromAnywhereContext", () => $e5c72f2d2626cbc6$export$f99899ced542f49a);

var $eUqFw = parcelRequire("eUqFw");

var $7T0RP = parcelRequire("7T0RP");

var $fFvAc = parcelRequire("fFvAc");

var $kNatw = parcelRequire("kNatw");
const $e5c72f2d2626cbc6$export$4cea60a165c59df0 = ()=>(0, $7T0RP.default);
const $e5c72f2d2626cbc6$export$f99899ced542f49a = ()=>{
    const cloudIdRef = (0, $eUqFw.useRef)('');
    const [{ selectedCloudId: selectedCloudId }] = (0, $kNatw.useSitePickerContext)();
    (0, $eUqFw.useEffect)(()=>{
        if (selectedCloudId && cloudIdRef.current !== selectedCloudId) cloudIdRef.current = selectedCloudId;
    }, [
        selectedCloudId
    ]);
    const originUrl = (0, $eUqFw.useMemo)(()=>(0, $fFvAc.transformOriginUrl)(selectedCloudId), [
        selectedCloudId
    ]);
    return {
        giraClient: {
            ...$e5c72f2d2626cbc6$export$4cea60a165c59df0(),
            ...originUrl && {
                clientCreator: ()=>$e5c72f2d2626cbc6$export$4cea60a165c59df0()?.clientCreator(originUrl)
            }
        },
        resetAndReloadCreateForm: cloudIdRef.current !== selectedCloudId
    };
};

});
parcelRegister("7T0RP", function(module, exports) {

$parcel$export(module.exports, "default", () => $e42cc5e4608d3fe0$export$2e2bcd8739ae039);

var $illlw = parcelRequire("illlw");

var $2vRh6 = parcelRequire("2vRh6");

var $jlBDe = parcelRequire("jlBDe");

var $bvQX6 = parcelRequire("bvQX6");
var $5ECju = parcelRequire("5ECju");

var $aqG9W = parcelRequire("aqG9W");

var $35Kb7 = parcelRequire("35Kb7");

var $kcwGc = parcelRequire("kcwGc");

var $10n8H = parcelRequire("10n8H");

var $gUUjF = parcelRequire("gUUjF");

var $aXA7t = parcelRequire("aXA7t");

var $iV2Ac = parcelRequire("iV2Ac");

var $1ZkL6 = parcelRequire("1ZkL6");

var $9ypom = parcelRequire("9ypom");
const $e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID = 'gira';
const $e42cc5e4608d3fe0$var$CACHE_NAME = `apollo-cache/${$e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID}`;
const $e42cc5e4608d3fe0$var$LOG_NAMESPACE = `apollo.${$e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID}.error.graphql`;
const $e42cc5e4608d3fe0$var$isSsrSuccessful = ()=>false ? true : !window || !window.SPA_STATE;
const $e42cc5e4608d3fe0$var$NETWORK_ERRORS_COUNTER_KEY = 'networkErrorsCounter';
const $e42cc5e4608d3fe0$export$851a7159daf49c89 = new (0, $2vRh6.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: (/*@__PURE__*/$parcel$interopDefault($iV2Ac))
});
const $e42cc5e4608d3fe0$var$errorLink = (0, $aqG9W.onError)(({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    // Ignore network errors as they will be logged in the retry link
    (0, $1ZkL6.reportErrors)({
        graphQLErrors: graphQLErrors,
        operation: operation
    });
    // Skip default error logging if analytics context data is defined for the query.
    const errorAnalytics = (0, $1ZkL6.getErrorAnalyticsContext)(operation.getContext());
    if (errorAnalytics !== undefined) return;
    if (graphQLErrors) {
        if (Array.isArray(graphQLErrors)) graphQLErrors.map(({ message: message, locations: locations, path: path })=>(0, $gUUjF.default).safeErrorWithoutCustomerData($e42cc5e4608d3fe0$var$LOG_NAMESPACE, `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`, {
                message: JSON.stringify(message),
                path: JSON.stringify(path),
                locations: JSON.stringify(locations)
            }));
        else (0, $gUUjF.default).safeErrorWithoutCustomerData($e42cc5e4608d3fe0$var$LOG_NAMESPACE, '[GraphQL error]: Unexpected error message format', {
            message: JSON.stringify(graphQLErrors)
        });
    }
    if (networkError) {
        const occuredNetworkErrorsBefore = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(operation.getContext(), [
            $e42cc5e4608d3fe0$var$NETWORK_ERRORS_COUNTER_KEY
        ], 0);
        (0, $gUUjF.default).safeErrorWithoutCustomerData($e42cc5e4608d3fe0$var$LOG_NAMESPACE, `[Network error]: ${networkError}, attempt ${occuredNetworkErrorsBefore + 1}`);
        operation.setContext({
            [$e42cc5e4608d3fe0$var$NETWORK_ERRORS_COUNTER_KEY]: occuredNetworkErrorsBefore + 1
        });
    }
});
const $e42cc5e4608d3fe0$var$retryLinkWithFama = new (0, $kcwGc.RetryLink)({
    delay: {
        initial: 300,
        max: 120000,
        jitter: true
    },
    attempts: (count, operation, networkError)=>{
        const retry = count < 5 && networkError && !networkError.statusCode;
        // Don't report any error if we're going to attempt a retry
        if (!retry) (0, $1ZkL6.reportErrors)({
            networkError: networkError,
            operation: operation
        });
        return retry;
    }
});
class $e42cc5e4608d3fe0$var$CancelableRequestLink extends (0, $bvQX6.ApolloLink) {
    constructor(){
        super();
        this.inFlightRequestControllers = {};
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    request(operation, forward) {
        const context = operation.getContext();
        if (!context.cancelable) return forward(operation);
        const key = JSON.stringify([
            operation.operationName,
            operation.query
        ]); // Equivalent to `operation.toKey` less the _actual_ variables
        this.inFlightRequestControllers[key]?.abort(); // Always abort the previous request
        const abortController = new AbortController();
        operation.setContext({
            ...context,
            fetchOptions: {
                signal: abortController.signal
            } // HttpLink passes this directly to fetch implementation
        });
        this.inFlightRequestControllers[key] = abortController;
        const cleanup = ()=>{
            // This callback may be called long after the request is replaced
            if (this.inFlightRequestControllers[key] === abortController) delete this.inFlightRequestControllers[key];
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new (0, $5ECju.default)((observer)=>{
            const subscription = forward(operation).subscribe({
                next: observer.next.bind(observer),
                // @ts-expect-error - TS7006 - Parameter 'error' implicitly has an 'any' type.
                error: (error)=>{
                    observer.error(error);
                    cleanup();
                },
                complete: observer.complete.bind(observer)
            });
            return ()=>{
                subscription?.unsubscribe();
                cleanup();
            };
        });
    }
}
const $e42cc5e4608d3fe0$var$cache = new (0, $2vRh6.InMemoryCache)({
    cacheRedirects: {
        Query: {
            ...(0, $10n8H.fragmentCacheRedirect)()
        }
    },
    fragmentMatcher: $e42cc5e4608d3fe0$export$851a7159daf49c89,
    dataIdFromObject: (object)=>object.id && `${object.id}${object.__typename}`
}).restore(!$e42cc5e4608d3fe0$var$isSsrSuccessful() && window.SPA_STATE[$e42cc5e4608d3fe0$var$CACHE_NAME] || {});
const $e42cc5e4608d3fe0$export$de66868aab9e79ea = (baseUrl)=>new (0, $jlBDe.ApolloClient)({
        name: $e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID,
        ssrMode: $e42cc5e4608d3fe0$var$isSsrSuccessful(),
        // @ts-expect-error - TS2345 - Argument of type '{ name: string; ssrMode: boolean; addTypename: boolean; link: ApolloLink; cache: InMemoryCache; connectToDevTools: boolean; }' is not assignable to parameter of type 'ApolloClientOptions<NormalizedCacheObject>'.
        addTypename: true,
        link: (0, $bvQX6.ApolloLink).from([
            $e42cc5e4608d3fe0$var$retryLinkWithFama,
            $e42cc5e4608d3fe0$var$errorLink,
            (0, $aXA7t.UFOLoggerLink),
            (0, $10n8H.fragmentLinkState)($e42cc5e4608d3fe0$var$cache),
            ...!$e42cc5e4608d3fe0$var$isSsrSuccessful() ? [
                new $e42cc5e4608d3fe0$var$CancelableRequestLink()
            ] : [],
            new (0, $35Kb7.HttpLink)({
                uri: ({ operationName: operationName })=>`${baseUrl}/rest/${$e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID}/1/?operation=${encodeURIComponent(operationName)}`,
                credentials: 'same-origin',
                // @ts-expect-error - TS2345 - Argument of type '{ uri: ({ operationName }: Operation) => string; credentials: string; abortErrorDoesNotCauseError: boolean; }' is not assignable to parameter of type 'Options'.
                abortErrorDoesNotCauseError: !$e42cc5e4608d3fe0$var$isSsrSuccessful()
            })
        ].filter(Boolean)),
        cache: $e42cc5e4608d3fe0$var$cache,
        connectToDevTools: false
    });
var $e42cc5e4608d3fe0$export$2e2bcd8739ae039 = {
    clientId: $e42cc5e4608d3fe0$var$GIRA_APOLLO_CLIENT_ID,
    clientCreator: $e42cc5e4608d3fe0$export$de66868aab9e79ea
};

});
parcelRegister("2vRh6", function(module, exports) {

$parcel$export(module.exports, "IntrospectionFragmentMatcher", () => $1d47cd4d9b8db33d$export$3b71c6b829c99d21);
$parcel$export(module.exports, "defaultDataIdFromObject", () => $1d47cd4d9b8db33d$export$bd03c5a9c99d6bce);
$parcel$export(module.exports, "InMemoryCache", () => $1d47cd4d9b8db33d$export$467265324939f47f);

var $fKE23 = parcelRequire("fKE23");

var $bO1Qv = parcelRequire("bO1Qv");

var $42BH7 = parcelRequire("42BH7");
var $66hGB = parcelRequire("66hGB");

var $7xYai = parcelRequire("7xYai");

var $8j2fP = parcelRequire("8j2fP");
var $1d47cd4d9b8db33d$var$haveWarned = false;
function $1d47cd4d9b8db33d$var$shouldWarn() {
    var answer = !$1d47cd4d9b8db33d$var$haveWarned;
    if (!(0, $42BH7.isTest)()) $1d47cd4d9b8db33d$var$haveWarned = true;
    return answer;
}
var $1d47cd4d9b8db33d$export$5d3fcf53267091de = function() {
    function HeuristicFragmentMatcher() {}
    HeuristicFragmentMatcher.prototype.ensureReady = function() {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function() {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        if (!__typename) {
            $1d47cd4d9b8db33d$var$shouldWarn();
            return 'heuristic';
        }
        if (__typename === typeCondition) return true;
        $1d47cd4d9b8db33d$var$shouldWarn();
        return 'heuristic';
    };
    return HeuristicFragmentMatcher;
}();
var $1d47cd4d9b8db33d$export$3b71c6b829c99d21 = function() {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        } else this.isReady = false;
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        (0, $8j2fP.invariant)(this.isReady, 1);
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        (0, $8j2fP.invariant)(__typename, 2);
        if (__typename === typeCondition) return true;
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function(type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                return implementingType.name;
            });
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}();
var $1d47cd4d9b8db33d$var$hasOwn = Object.prototype.hasOwnProperty;
var $1d47cd4d9b8db33d$var$DepTrackingCache = function() {
    function DepTrackingCache(data) {
        var _this = this;
        if (data === void 0) data = Object.create(null);
        this.data = data;
        this.depend = (0, $7xYai.wrap)(function(dataId) {
            return _this.data[dataId];
        }, {
            disposable: true,
            makeCacheKey: function(dataId) {
                return dataId;
            }
        });
    }
    DepTrackingCache.prototype.toObject = function() {
        return this.data;
    };
    DepTrackingCache.prototype.get = function(dataId) {
        this.depend(dataId);
        return this.data[dataId];
    };
    DepTrackingCache.prototype.set = function(dataId, value) {
        var oldValue = this.data[dataId];
        if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.delete = function(dataId) {
        if ($1d47cd4d9b8db33d$var$hasOwn.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.clear = function() {
        this.replace(null);
    };
    DepTrackingCache.prototype.replace = function(newData) {
        var _this = this;
        if (newData) {
            Object.keys(newData).forEach(function(dataId) {
                _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function(dataId) {
                if (!$1d47cd4d9b8db33d$var$hasOwn.call(newData, dataId)) _this.delete(dataId);
            });
        } else Object.keys(this.data).forEach(function(dataId) {
            _this.delete(dataId);
        });
    };
    return DepTrackingCache;
}();
function $1d47cd4d9b8db33d$var$defaultNormalizedCacheFactory(seed) {
    return new $1d47cd4d9b8db33d$var$DepTrackingCache(seed);
}
var $1d47cd4d9b8db33d$export$628ef07ba8965f12 = function() {
    function StoreReader(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, $7xYai.KeyTrie)((0, $42BH7.canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
        var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
        this.freezeResults = freezeResults;
        this.executeStoreQuery = (0, $7xYai.wrap)(function(options) {
            return executeStoreQuery.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                if (contextValue.store instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
            }
        });
        this.executeSelectionSet = (0, $7xYai.wrap)(function(options) {
            return executeSelectionSet.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
            }
        });
        this.executeSubSelectedArray = (0, $7xYai.wrap)(function(options) {
            return executeSubSelectedArray.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
            }
        });
    }
    StoreReader.prototype.readQueryFromStore = function(options) {
        return this.diffQueryAgainstStore((0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            returnPartialData: false
        })).result;
    };
    StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
        var queryDefinition = (0, $42BH7.getQueryDefinition)(query);
        variables = (0, $42BH7.assign)({}, (0, $42BH7.getDefaultValues)(queryDefinition), variables);
        var context = {
            store: store,
            dataIdFromObject: config && config.dataIdFromObject,
            cacheRedirects: config && config.cacheRedirects || {}
        };
        var execResult = this.executeStoreQuery({
            query: query,
            rootValue: {
                type: 'id',
                id: rootId,
                generated: true,
                typename: 'Query'
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
            if (info.tolerable) return;
            throw new (0, $8j2fP.InvariantError)(8);
        });
        if (previousResult) {
            if ((0, $66hGB.equal)(previousResult, execResult.result)) execResult.result = previousResult;
        }
        return {
            result: execResult.result,
            complete: !hasMissingFields
        };
    };
    StoreReader.prototype.executeStoreQuery = function(_a) {
        var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? $1d47cd4d9b8db33d$var$defaultFragmentMatcher : _b;
        var mainDefinition = (0, $42BH7.getMainDefinition)(query);
        var fragments = (0, $42BH7.getFragmentDefinitions)(query);
        var fragmentMap = (0, $42BH7.createFragmentMap)(fragments);
        var execContext = {
            query: query,
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            fragmentMatcher: fragmentMatcher
        };
        return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue: rootValue,
            execContext: execContext
        });
    };
    StoreReader.prototype.executeSelectionSet = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var finalResult = {
            result: null
        };
        var objectsToMerge = [];
        var object = contextValue.store.get(rootValue.id);
        var typename = object && object.__typename || rootValue.id === 'ROOT_QUERY' && 'Query' || void 0;
        function handleMissing(result) {
            var _a;
            if (result.missing) {
                finalResult.missing = finalResult.missing || [];
                (_a = finalResult.missing).push.apply(_a, result.missing);
            }
            return result.result;
        }
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $42BH7.shouldInclude)(selection, variables)) return;
            if ((0, $42BH7.isField)(selection)) {
                var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                if (typeof fieldResult !== 'undefined') objectsToMerge.push((_a = {}, _a[(0, $42BH7.resultKeyNameFromField)(selection)] = fieldResult, _a));
            } else {
                var fragment = void 0;
                if ((0, $42BH7.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) throw new (0, $8j2fP.InvariantError)(9);
                }
                var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                if (match) {
                    var fragmentExecResult = _this.executeSelectionSet({
                        selectionSet: fragment.selectionSet,
                        rootValue: rootValue,
                        execContext: execContext
                    });
                    if (match === 'heuristic' && fragmentExecResult.missing) fragmentExecResult = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, fragmentExecResult), {
                        missing: fragmentExecResult.missing.map(function(info) {
                            return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, info), {
                                tolerable: true
                            });
                        })
                    });
                    objectsToMerge.push(handleMissing(fragmentExecResult));
                }
            }
        });
        finalResult.result = (0, $42BH7.mergeDeepArray)(objectsToMerge);
        this.freezeResults;
        return finalResult;
    };
    StoreReader.prototype.executeField = function(object, typename, field, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue;
        var fieldName = field.name.value;
        var args = (0, $42BH7.argumentsObjectFromField)(field, variables);
        var info = {
            resultKey: (0, $42BH7.resultKeyNameFromField)(field),
            directives: (0, $42BH7.getDirectiveInfoFromField)(field, variables)
        };
        var readStoreResult = $1d47cd4d9b8db33d$var$readStoreResolver(object, typename, fieldName, args, contextValue, info);
        if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
            field: field,
            array: readStoreResult.result,
            execContext: execContext
        }));
        if (!field.selectionSet) {
            $1d47cd4d9b8db33d$var$assertSelectionSetForIdValue(field, readStoreResult.result);
            this.freezeResults;
            return readStoreResult;
        }
        if (readStoreResult.result == null) return readStoreResult;
        return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext: execContext
        }));
    };
    StoreReader.prototype.combineExecResults = function() {
        var execResults = [];
        for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
        var missing;
        execResults.forEach(function(execResult) {
            if (execResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, execResult.missing);
            }
        });
        return {
            result: execResults.pop().result,
            missing: missing
        };
    };
    StoreReader.prototype.executeSubSelectedArray = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, execContext = _a.execContext;
        var missing;
        function handleMissing(childResult) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
        }
        array = array.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                execContext: execContext
            }));
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: item,
                execContext: execContext
            }));
            $1d47cd4d9b8db33d$var$assertSelectionSetForIdValue(field, item);
            return item;
        });
        this.freezeResults;
        return {
            result: array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $1d47cd4d9b8db33d$var$assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && (0, $42BH7.isIdValue)(value)) throw new (0, $8j2fP.InvariantError)(10);
}
function $1d47cd4d9b8db33d$var$defaultFragmentMatcher() {
    return true;
}
function $1d47cd4d9b8db33d$export$7a4899fe13f33235(idValue) {
    (0, $8j2fP.invariant)((0, $42BH7.isIdValue)(idValue), 11);
}
function $1d47cd4d9b8db33d$var$readStoreResolver(object, typename, fieldName, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    var storeKeyName = fieldName;
    if (args || directives) storeKeyName = (0, $42BH7.getStoreKeyName)(storeKeyName, args, directives);
    var fieldValue = void 0;
    if (object) {
        fieldValue = object[storeKeyName];
        if (typeof fieldValue === 'undefined' && context.cacheRedirects && typeof typename === 'string') {
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) fieldValue = resolver(object, args, {
                    getCacheKey: function(storeObj) {
                        var id = context.dataIdFromObject(storeObj);
                        return id && (0, $42BH7.toIdValue)({
                            id: id,
                            typename: storeObj.__typename
                        });
                    }
                });
            }
        }
    }
    if (typeof fieldValue === 'undefined') return {
        result: fieldValue,
        missing: [
            {
                object: object,
                fieldName: storeKeyName,
                tolerable: false
            }
        ]
    };
    if ((0, $42BH7.isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
    return {
        result: fieldValue
    };
}
var $1d47cd4d9b8db33d$export$ee7258b8691956a3 = function() {
    function ObjectCache(data) {
        if (data === void 0) data = Object.create(null);
        this.data = data;
    }
    ObjectCache.prototype.toObject = function() {
        return this.data;
    };
    ObjectCache.prototype.get = function(dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function(dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function(dataId) {
        this.data[dataId] = void 0;
    };
    ObjectCache.prototype.clear = function() {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function(newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}();
function $1d47cd4d9b8db33d$export$7e2b40d1002de152(seed) {
    return new $1d47cd4d9b8db33d$export$ee7258b8691956a3(seed);
}
var $1d47cd4d9b8db33d$export$de4e6870dc6ac801 = function(_super) {
    (0, $fKE23.__extends)(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error);
function $1d47cd4d9b8db33d$export$fb86e3236e77e3(error, document) {
    var enhancedError = new $1d47cd4d9b8db33d$export$de4e6870dc6ac801("Error writing result to store for query:\n " + JSON.stringify(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
var $1d47cd4d9b8db33d$export$eb8361c5d132fb8f = function() {
    function StoreWriter() {}
    StoreWriter.prototype.writeQueryToStore = function(_a) {
        var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? $1d47cd4d9b8db33d$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        return this.writeResultToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            document: query,
            store: store,
            variables: variables,
            dataIdFromObject: dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
    };
    StoreWriter.prototype.writeResultToStore = function(_a) {
        var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? $1d47cd4d9b8db33d$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = (0, $42BH7.getOperationDefinition)(document);
        try {
            return this.writeSelectionSetToStore({
                result: result,
                dataId: dataId,
                selectionSet: operationDefinition.selectionSet,
                context: {
                    store: store,
                    processedData: {},
                    variables: (0, $42BH7.assign)({}, (0, $42BH7.getDefaultValues)(operationDefinition), variables),
                    dataIdFromObject: dataIdFromObject,
                    fragmentMap: (0, $42BH7.createFragmentMap)((0, $42BH7.getFragmentDefinitions)(document)),
                    fragmentMatcherFunction: fragmentMatcherFunction
                }
            });
        } catch (e) {
            throw $1d47cd4d9b8db33d$export$fb86e3236e77e3(e, document);
        }
    };
    StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
        var _this = this;
        var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
        var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $42BH7.shouldInclude)(selection, variables)) return;
            if ((0, $42BH7.isField)(selection)) {
                var resultFieldKey = (0, $42BH7.resultKeyNameFromField)(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') _this.writeFieldToStore({
                    dataId: dataId,
                    value: value,
                    field: selection,
                    context: context
                });
                else {
                    var isDefered = false;
                    var isClient = false;
                    if (selection.directives && selection.directives.length) {
                        isDefered = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'defer';
                        });
                        isClient = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'client';
                        });
                    }
                    !isDefered && !isClient && context.fragmentMatcherFunction;
                }
            } else {
                var fragment = void 0;
                if ((0, $42BH7.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = (fragmentMap || {})[selection.name.value];
                    (0, $8j2fP.invariant)(fragment, 3);
                }
                var matches = true;
                if (context.fragmentMatcherFunction && fragment.typeCondition) {
                    var id = dataId || 'self';
                    var idValue = (0, $42BH7.toIdValue)({
                        id: id,
                        typename: undefined
                    });
                    var fakeContext = {
                        store: new $1d47cd4d9b8db33d$export$ee7258b8691956a3((_a = {}, _a[id] = result, _a)),
                        cacheRedirects: {}
                    };
                    var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                    !(0, $42BH7.isProduction)() && match;
                    matches = !!match;
                }
                if (matches) _this.writeSelectionSetToStore({
                    result: result,
                    selectionSet: fragment.selectionSet,
                    dataId: dataId,
                    context: context
                });
            }
        });
        return store;
    };
    StoreWriter.prototype.writeFieldToStore = function(_a) {
        var _b;
        var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
        var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
        var storeValue;
        var storeObject;
        var storeFieldName = (0, $42BH7.storeKeyNameFromField)(field, variables);
        if (!field.selectionSet || value === null) storeValue = value != null && typeof value === 'object' ? {
            type: 'json',
            json: value
        } : value;
        else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
        } else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!$1d47cd4d9b8db33d$var$isGeneratedId(valueDataId)) valueDataId = '$' + valueDataId;
            if (dataIdFromObject) {
                var semanticId = dataIdFromObject(value);
                (0, $8j2fP.invariant)(!semanticId || !$1d47cd4d9b8db33d$var$isGeneratedId(semanticId), 4);
                if (semanticId || typeof semanticId === 'number' && semanticId === 0) {
                    valueDataId = semanticId;
                    generated = false;
                }
            }
            if (!$1d47cd4d9b8db33d$var$isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                dataId: valueDataId,
                result: value,
                selectionSet: field.selectionSet,
                context: context
            });
            var typename = value.__typename;
            storeValue = (0, $42BH7.toIdValue)({
                id: valueDataId,
                typename: typename
            }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && (0, $42BH7.isIdValue)(escapedId)) {
                var hadTypename = escapedId.typename !== undefined;
                var hasTypename = typename !== undefined;
                var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                (0, $8j2fP.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                (0, $8j2fP.invariant)(!hadTypename || hasTypename, 6);
                if (escapedId.generated) {
                    if (typenameChanged) {
                        if (!generated) store.delete(escapedId.id);
                    } else $1d47cd4d9b8db33d$var$mergeWithGenerated(escapedId.id, storeValue.id, store);
                }
            }
        }
        storeObject = store.get(dataId);
        if (!storeObject || !(0, $66hGB.equal)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, $fKE23.__assign)((0, $fKE23.__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
    };
    StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
        var _this = this;
        return value.map(function(item, index) {
            if (item === null) return null;
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
            var generated = true;
            if (context.dataIdFromObject) {
                var semanticId = context.dataIdFromObject(item);
                if (semanticId) {
                    itemDataId = semanticId;
                    generated = false;
                }
            }
            if (!$1d47cd4d9b8db33d$var$isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                dataId: itemDataId,
                result: item,
                selectionSet: selectionSet,
                context: context
            });
            return (0, $42BH7.toIdValue)({
                id: itemDataId,
                typename: item.__typename
            }, generated);
        });
    };
    return StoreWriter;
}();
function $1d47cd4d9b8db33d$var$isGeneratedId(id) {
    return id[0] === '$';
}
function $1d47cd4d9b8db33d$var$mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) return false;
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function(key) {
        var value = generated[key];
        var realValue = real[key];
        if ((0, $42BH7.isIdValue)(value) && $1d47cd4d9b8db33d$var$isGeneratedId(value.id) && (0, $42BH7.isIdValue)(realValue) && !(0, $66hGB.equal)(value, realValue) && $1d47cd4d9b8db33d$var$mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
    });
    cache.delete(generatedKey);
    var newRealValue = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, generated), real);
    if ((0, $66hGB.equal)(newRealValue, real)) return madeChanges;
    cache.set(realKey, newRealValue);
    return true;
}
function $1d47cd4d9b8db33d$var$isDataProcessed(dataId, field, processedData) {
    if (!processedData) return false;
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) return true;
        else processedData[dataId].push(field);
    } else processedData[dataId] = [
        field
    ];
    return false;
}
var $1d47cd4d9b8db33d$var$defaultConfig = {
    fragmentMatcher: new $1d47cd4d9b8db33d$export$5d3fcf53267091de(),
    dataIdFromObject: $1d47cd4d9b8db33d$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    freezeResults: false
};
function $1d47cd4d9b8db33d$export$bd03c5a9c99d6bce(result) {
    if (result.__typename) {
        if (result.id !== undefined) return result.__typename + ":" + result.id;
        if (result._id !== undefined) return result.__typename + ":" + result._id;
    }
    return null;
}
var $1d47cd4d9b8db33d$var$hasOwn$1 = Object.prototype.hasOwnProperty;
var $1d47cd4d9b8db33d$var$OptimisticCacheLayer = function(_super) {
    (0, $fKE23.__extends)(OptimisticCacheLayer, _super);
    function OptimisticCacheLayer(optimisticId, parent, transaction) {
        var _this = _super.call(this, Object.create(null)) || this;
        _this.optimisticId = optimisticId;
        _this.parent = parent;
        _this.transaction = transaction;
        return _this;
    }
    OptimisticCacheLayer.prototype.toObject = function() {
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.parent.toObject()), this.data);
    };
    OptimisticCacheLayer.prototype.get = function(dataId) {
        return $1d47cd4d9b8db33d$var$hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
    };
    return OptimisticCacheLayer;
}($1d47cd4d9b8db33d$export$ee7258b8691956a3);
var $1d47cd4d9b8db33d$export$467265324939f47f = function(_super) {
    (0, $fKE23.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.cacheKeyRoot = new (0, $7xYai.KeyTrie)((0, $42BH7.canUseWeakMap));
        _this.silenceBroadcast = false;
        _this.config = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, $1d47cd4d9b8db33d$var$defaultConfig), config);
        if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
        if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
        _this.addTypename = !!_this.config.addTypename;
        _this.data = _this.config.resultCaching ? new $1d47cd4d9b8db33d$var$DepTrackingCache() : new $1d47cd4d9b8db33d$export$ee7258b8691956a3();
        _this.optimisticData = _this.data;
        _this.storeWriter = new $1d47cd4d9b8db33d$export$eb8361c5d132fb8f();
        _this.storeReader = new $1d47cd4d9b8db33d$export$628ef07ba8965f12({
            cacheKeyRoot: _this.cacheKeyRoot,
            freezeResults: config.freezeResults
        });
        var cache = _this;
        var maybeBroadcastWatch = cache.maybeBroadcastWatch;
        _this.maybeBroadcastWatch = (0, $7xYai.wrap)(function(c) {
            return maybeBroadcastWatch.call(_this, c);
        }, {
            makeCacheKey: function(c) {
                if (c.optimistic) return;
                if (c.previousResult) return;
                if (cache.data instanceof $1d47cd4d9b8db33d$var$DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
            }
        });
        return _this;
    }
    InMemoryCache.prototype.restore = function(data) {
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).toObject();
    };
    InMemoryCache.prototype.read = function(options) {
        if (typeof options.rootId === 'string' && typeof this.data.get(options.rootId) === 'undefined') return null;
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.readQueryFromStore({
            store: options.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
            rootId: options.rootId,
            fragmentMatcherFunction: fragmentMatcherFunction,
            previousResult: options.previousResult,
            config: this.config
        }) || null;
    };
    InMemoryCache.prototype.write = function(write) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function(query) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.diffQueryAgainstStore({
            store: query.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: fragmentMatcherFunction,
            config: this.config
        });
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        this.watches.add(watch);
        return function() {
            _this.watches.delete(watch);
        };
    };
    InMemoryCache.prototype.evict = function(query) {
        throw new (0, $8j2fP.InvariantError)(7);
    };
    InMemoryCache.prototype.reset = function() {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var toReapply = [];
        var removedCount = 0;
        var layer = this.optimisticData;
        while(layer instanceof $1d47cd4d9b8db33d$var$OptimisticCacheLayer){
            if (layer.optimisticId === idToRemove) ++removedCount;
            else toReapply.push(layer);
            layer = layer.parent;
        }
        if (removedCount > 0) {
            this.optimisticData = layer;
            while(toReapply.length > 0){
                var layer_1 = toReapply.pop();
                this.performTransaction(layer_1.transaction, layer_1.optimisticId);
            }
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
        var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
        this.silenceBroadcast = true;
        if (typeof optimisticId === 'string') this.data = this.optimisticData = new $1d47cd4d9b8db33d$var$OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
        try {
            transaction(this);
        } finally{
            this.silenceBroadcast = silenceBroadcast;
            this.data = data;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
        return this.performTransaction(transaction, id);
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0, $42BH7.addTypenameToDocument)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function() {
        var _this = this;
        if (!this.silenceBroadcast) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c);
        });
    };
    InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
        c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic
        }));
    };
    return InMemoryCache;
}((0, $bO1Qv.ApolloCache));

});
parcelRegister("bO1Qv", function(module, exports) {

$parcel$export(module.exports, "ApolloCache", () => $8985cbc47a37b971$export$5fc74f25506aa9c);

var $42BH7 = parcelRequire("42BH7");
function $8985cbc47a37b971$var$queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $8985cbc47a37b971$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            op
        ]
    };
    return out;
}
function $8985cbc47a37b971$var$fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType'
            }
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $8985cbc47a37b971$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            frag
        ]
    };
    return out;
}
function $8985cbc47a37b971$var$selectionSetFromObj(obj) {
    if (typeof obj === 'number' || typeof obj === 'boolean' || typeof obj === 'string' || typeof obj === 'undefined' || obj === null) return null;
    if (Array.isArray(obj)) return $8985cbc47a37b971$var$selectionSetFromObj(obj[0]);
    var selections = [];
    Object.keys(obj).forEach(function(key) {
        var nestedSelSet = $8985cbc47a37b971$var$selectionSetFromObj(obj[key]);
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key
            },
            selectionSet: nestedSelSet || undefined
        };
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections
    };
    return selectionSet;
}
var $8985cbc47a37b971$var$justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename'
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null
                    }
                ]
            }
        }
    ]
};
var $8985cbc47a37b971$export$5fc74f25506aa9c = function() {
    function ApolloCache() {}
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: (0, $42BH7.getFragmentQueryDocument)(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.writeQuery = function(options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables
        });
    };
    ApolloCache.prototype.writeFragment = function(options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: (0, $42BH7.getFragmentQueryDocument)(options.fragment, options.fragmentName)
        });
    };
    ApolloCache.prototype.writeData = function(_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== 'undefined') {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: $8985cbc47a37b971$var$justTypenameQuery
                });
            } catch (e) {}
            var __typename = typenameResult && typenameResult.__typename || '__ClientData';
            var dataToWrite = Object.assign({
                __typename: __typename
            }, data);
            this.writeFragment({
                id: id,
                fragment: $8985cbc47a37b971$var$fragmentFromPojo(dataToWrite, __typename),
                data: dataToWrite
            });
        } else this.writeQuery({
            query: $8985cbc47a37b971$var$queryFromPojo(data),
            data: data
        });
    };
    return ApolloCache;
}();
var $8985cbc47a37b971$export$94affb487e701bf2;
$8985cbc47a37b971$export$94affb487e701bf2 || ($8985cbc47a37b971$export$94affb487e701bf2 = {});

});
parcelRegister("42BH7", function(module, exports) {

$parcel$export(module.exports, "storeKeyNameFromField", () => $2f1496a7de754c2a$export$54be8689c65f3b56);
$parcel$export(module.exports, "getStoreKeyName", () => $2f1496a7de754c2a$export$3cdb6c178b88cabe);
$parcel$export(module.exports, "argumentsObjectFromField", () => $2f1496a7de754c2a$export$3f5a60fb6a781b4f);
$parcel$export(module.exports, "resultKeyNameFromField", () => $2f1496a7de754c2a$export$7d1ad22471852218);
$parcel$export(module.exports, "isField", () => $2f1496a7de754c2a$export$fb56ad75dd311c12);
$parcel$export(module.exports, "isInlineFragment", () => $2f1496a7de754c2a$export$22a1cdafaf27bcff);
$parcel$export(module.exports, "isIdValue", () => $2f1496a7de754c2a$export$e33b89a9aa87695);
$parcel$export(module.exports, "toIdValue", () => $2f1496a7de754c2a$export$b124f125e34d720a);
$parcel$export(module.exports, "isJsonValue", () => $2f1496a7de754c2a$export$226c1c6d1a5b660a);
$parcel$export(module.exports, "getDirectiveInfoFromField", () => $2f1496a7de754c2a$export$2a7f471142984a91);
$parcel$export(module.exports, "shouldInclude", () => $2f1496a7de754c2a$export$3dc388a5f013b4a5);
$parcel$export(module.exports, "hasDirectives", () => $2f1496a7de754c2a$export$2dafb573e282fe8d);
$parcel$export(module.exports, "hasClientExports", () => $2f1496a7de754c2a$export$8d1e9e5bbfa5d09a);
$parcel$export(module.exports, "getFragmentQueryDocument", () => $2f1496a7de754c2a$export$abbf37c7cf644e41);
$parcel$export(module.exports, "assign", () => $2f1496a7de754c2a$export$e6e34fd1f2686227);
$parcel$export(module.exports, "checkDocument", () => $2f1496a7de754c2a$export$a7d0d8111d2386df);
$parcel$export(module.exports, "getOperationDefinition", () => $2f1496a7de754c2a$export$7a5b1fa979d2c158);
$parcel$export(module.exports, "getOperationName", () => $2f1496a7de754c2a$export$41bca9dc6871dd4e);
$parcel$export(module.exports, "getFragmentDefinitions", () => $2f1496a7de754c2a$export$5320a7ba9466a3df);
$parcel$export(module.exports, "getQueryDefinition", () => $2f1496a7de754c2a$export$d96b2213c1b9d3a9);
$parcel$export(module.exports, "getMainDefinition", () => $2f1496a7de754c2a$export$f431198736b7f96d);
$parcel$export(module.exports, "createFragmentMap", () => $2f1496a7de754c2a$export$193789b4c8246dd4);
$parcel$export(module.exports, "getDefaultValues", () => $2f1496a7de754c2a$export$84c19026e616569e);
$parcel$export(module.exports, "removeDirectivesFromDocument", () => $2f1496a7de754c2a$export$e5ae0530da5fe96c);
$parcel$export(module.exports, "addTypenameToDocument", () => $2f1496a7de754c2a$export$43b332f87950a467);
$parcel$export(module.exports, "removeConnectionDirectiveFromDocument", () => $2f1496a7de754c2a$export$74985f3324559867);
$parcel$export(module.exports, "buildQueryFromSelectionSet", () => $2f1496a7de754c2a$export$57c368c23873f32b);
$parcel$export(module.exports, "removeClientSetsFromDocument", () => $2f1496a7de754c2a$export$8eae69e876ee321e);
$parcel$export(module.exports, "canUseWeakMap", () => $2f1496a7de754c2a$export$772fbc04a0ad4ce9);
$parcel$export(module.exports, "cloneDeep", () => $2f1496a7de754c2a$export$629a2bd3f5a49ecc);
$parcel$export(module.exports, "isProduction", () => $2f1496a7de754c2a$export$f15d00aa73aafac4);
$parcel$export(module.exports, "isTest", () => $2f1496a7de754c2a$export$410cbc2864fa25b5);
$parcel$export(module.exports, "tryFunctionOrLogError", () => $2f1496a7de754c2a$export$50a91acae4904909);
$parcel$export(module.exports, "graphQLResultHasError", () => $2f1496a7de754c2a$export$b4df399e879e53ab);
$parcel$export(module.exports, "mergeDeep", () => $2f1496a7de754c2a$export$dd702b3c8240390c);
$parcel$export(module.exports, "mergeDeepArray", () => $2f1496a7de754c2a$export$160070228be94b08);

var $961BR = parcelRequire("961BR");

var $8j2fP = parcelRequire("8j2fP");

var $fKE23 = parcelRequire("fKE23");

var $cGs0N = parcelRequire("cGs0N");

var $66hGB = parcelRequire("66hGB");

var $2fFJv = parcelRequire("2fFJv");
function $2f1496a7de754c2a$export$dc071f102752d0eb(value) {
    return [
        'StringValue',
        'BooleanValue',
        'EnumValue'
    ].indexOf(value.kind) > -1;
}
function $2f1496a7de754c2a$export$3ff5e9927c3257c6(value) {
    return [
        'IntValue',
        'FloatValue'
    ].indexOf(value.kind) > -1;
}
function $2f1496a7de754c2a$var$isStringValue(value) {
    return value.kind === 'StringValue';
}
function $2f1496a7de754c2a$var$isBooleanValue(value) {
    return value.kind === 'BooleanValue';
}
function $2f1496a7de754c2a$var$isIntValue(value) {
    return value.kind === 'IntValue';
}
function $2f1496a7de754c2a$var$isFloatValue(value) {
    return value.kind === 'FloatValue';
}
function $2f1496a7de754c2a$var$isVariable(value) {
    return value.kind === 'Variable';
}
function $2f1496a7de754c2a$var$isObjectValue(value) {
    return value.kind === 'ObjectValue';
}
function $2f1496a7de754c2a$var$isListValue(value) {
    return value.kind === 'ListValue';
}
function $2f1496a7de754c2a$var$isEnumValue(value) {
    return value.kind === 'EnumValue';
}
function $2f1496a7de754c2a$var$isNullValue(value) {
    return value.kind === 'NullValue';
}
function $2f1496a7de754c2a$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($2f1496a7de754c2a$var$isIntValue(value) || $2f1496a7de754c2a$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($2f1496a7de754c2a$var$isBooleanValue(value) || $2f1496a7de754c2a$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($2f1496a7de754c2a$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $2f1496a7de754c2a$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($2f1496a7de754c2a$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($2f1496a7de754c2a$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $2f1496a7de754c2a$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($2f1496a7de754c2a$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($2f1496a7de754c2a$var$isNullValue(value)) argObj[name.value] = null;
    else throw new (0, $8j2fP.InvariantError)(17);
}
function $2f1496a7de754c2a$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $2f1496a7de754c2a$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $2f1496a7de754c2a$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $2f1496a7de754c2a$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $2f1496a7de754c2a$var$KNOWN_DIRECTIVES = [
    'connection',
    'include',
    'skip',
    'client',
    'rest',
    'export'
];
function $2f1496a7de754c2a$export$3cdb6c178b88cabe(fieldName, args, directives) {
    if (directives && directives['connection'] && directives['connection']['key']) {
        if (directives['connection']['filter'] && directives['connection']['filter'].length > 0) {
            var filterKeys = directives['connection']['filter'] ? directives['connection']['filter'] : [];
            filterKeys.sort();
            var queryArgs_1 = args;
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = queryArgs_1[key];
            });
            return directives['connection']['key'] + "(" + JSON.stringify(filteredArgs_1) + ")";
        } else return directives['connection']['key'];
    }
    var completeFieldName = fieldName;
    if (args) {
        var stringifiedArgs = (0, (/*@__PURE__*/$parcel$interopDefault($cGs0N)))(args);
        completeFieldName += "(" + stringifiedArgs + ")";
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($2f1496a7de754c2a$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@" + key + "(" + JSON.stringify(directives[key]) + ")";
        else completeFieldName += "@" + key;
    });
    return completeFieldName;
}
function $2f1496a7de754c2a$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $2f1496a7de754c2a$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $2f1496a7de754c2a$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $2f1496a7de754c2a$export$fb56ad75dd311c12(selection) {
    return selection.kind === 'Field';
}
function $2f1496a7de754c2a$export$22a1cdafaf27bcff(selection) {
    return selection.kind === 'InlineFragment';
}
function $2f1496a7de754c2a$export$e33b89a9aa87695(idObject) {
    return idObject && idObject.type === 'id' && typeof idObject.generated === 'boolean';
}
function $2f1496a7de754c2a$export$b124f125e34d720a(idConfig, generated) {
    if (generated === void 0) generated = false;
    return (0, $fKE23.__assign)({
        type: 'id',
        generated: generated
    }, typeof idConfig === 'string' ? {
        id: idConfig,
        typename: undefined
    } : idConfig);
}
function $2f1496a7de754c2a$export$226c1c6d1a5b660a(jsonObject) {
    return jsonObject != null && typeof jsonObject === 'object' && jsonObject.type === 'json';
}
function $2f1496a7de754c2a$var$defaultValueFromVariable(node) {
    throw new (0, $8j2fP.InvariantError)(18);
}
function $2f1496a7de754c2a$export$b3db129ed867b445(node, onVariable) {
    if (onVariable === void 0) onVariable = $2f1496a7de754c2a$var$defaultValueFromVariable;
    switch(node.kind){
        case 'Variable':
            return onVariable(node);
        case 'NullValue':
            return null;
        case 'IntValue':
            return parseInt(node.value, 10);
        case 'FloatValue':
            return parseFloat(node.value);
        case 'ListValue':
            return node.values.map(function(v) {
                return $2f1496a7de754c2a$export$b3db129ed867b445(v, onVariable);
            });
        case 'ObjectValue':
            var value = {};
            for(var _i = 0, _a = node.fields; _i < _a.length; _i++){
                var field = _a[_i];
                value[field.name.value] = $2f1496a7de754c2a$export$b3db129ed867b445(field.value, onVariable);
            }
            return value;
        default:
            return node.value;
    }
}
function $2f1496a7de754c2a$export$2a7f471142984a91(field, variables) {
    if (field.directives && field.directives.length) {
        var directiveObj_1 = {};
        field.directives.forEach(function(directive) {
            directiveObj_1[directive.name.value] = $2f1496a7de754c2a$export$3f5a60fb6a781b4f(directive, variables);
        });
        return directiveObj_1;
    }
    return null;
}
function $2f1496a7de754c2a$export$3dc388a5f013b4a5(selection, variables) {
    if (variables === void 0) variables = {};
    return $2f1496a7de754c2a$export$b7bdffb7e6f1ef53(selection.directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === 'Variable') {
            evaledValue = variables[ifArgument.value.name.value];
            (0, $8j2fP.invariant)(evaledValue !== void 0, 13);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === 'skip' ? !evaledValue : evaledValue;
    });
}
function $2f1496a7de754c2a$export$1b217de6ce18b9a(doc) {
    var names = [];
    (0, $961BR.visit)(doc, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
function $2f1496a7de754c2a$export$2dafb573e282fe8d(names, doc) {
    return $2f1496a7de754c2a$export$1b217de6ce18b9a(doc).some(function(name) {
        return names.indexOf(name) > -1;
    });
}
function $2f1496a7de754c2a$export$8d1e9e5bbfa5d09a(document) {
    return document && $2f1496a7de754c2a$export$2dafb573e282fe8d([
        'client'
    ], document) && $2f1496a7de754c2a$export$2dafb573e282fe8d([
        'export'
    ], document);
}
function $2f1496a7de754c2a$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === 'skip' || value === 'include';
}
function $2f1496a7de754c2a$export$b7bdffb7e6f1ef53(directives) {
    return directives ? directives.filter($2f1496a7de754c2a$var$isInclusionDirective).map(function(directive) {
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $8j2fP.invariant)(directiveArguments && directiveArguments.length === 1, 14);
        var ifArgument = directiveArguments[0];
        (0, $8j2fP.invariant)(ifArgument.name && ifArgument.name.value === 'if', 15);
        var ifValue = ifArgument.value;
        (0, $8j2fP.invariant)(ifValue && (ifValue.kind === 'Variable' || ifValue.kind === 'BooleanValue'), 16);
        return {
            directive: directive,
            ifArgument: ifArgument
        };
    }) : [];
}
function $2f1496a7de754c2a$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    var fragments = [];
    document.definitions.forEach(function(definition) {
        if (definition.kind === 'OperationDefinition') throw new (0, $8j2fP.InvariantError)(11);
        if (definition.kind === 'FragmentDefinition') fragments.push(definition);
    });
    if (typeof actualFragmentName === 'undefined') {
        (0, $8j2fP.invariant)(fragments.length === 1, 12);
        actualFragmentName = fragments[0].name.value;
    }
    var query = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, document), {
        definitions: (0, $fKE23.__spreadArrays)([
            {
                kind: 'OperationDefinition',
                operation: 'query',
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'FragmentSpread',
                            name: {
                                kind: 'Name',
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions)
    });
    return query;
}
function $2f1496a7de754c2a$export$e6e34fd1f2686227(target) {
    var sources = [];
    for(var _i = 1; _i < arguments.length; _i++)sources[_i - 1] = arguments[_i];
    sources.forEach(function(source) {
        if (typeof source === 'undefined' || source === null) return;
        Object.keys(source).forEach(function(key) {
            target[key] = source[key];
        });
    });
    return target;
}
function $2f1496a7de754c2a$export$a92e7a440b22bdf0(doc) {
    $2f1496a7de754c2a$export$a7d0d8111d2386df(doc);
    var mutationDef = doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.operation === 'mutation';
    })[0];
    (0, $8j2fP.invariant)(mutationDef, 1);
    return mutationDef;
}
function $2f1496a7de754c2a$export$a7d0d8111d2386df(doc) {
    (0, $8j2fP.invariant)(doc && doc.kind === 'Document', 2);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== 'FragmentDefinition';
    }).map(function(definition) {
        if (definition.kind !== 'OperationDefinition') throw new (0, $8j2fP.InvariantError)(3);
        return definition;
    });
    (0, $8j2fP.invariant)(operations.length <= 1, 4);
    return doc;
}
function $2f1496a7de754c2a$export$7a5b1fa979d2c158(doc) {
    $2f1496a7de754c2a$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition';
    })[0];
}
function $2f1496a7de754c2a$export$78a8e95d8d43ad7f(document) {
    var def = $2f1496a7de754c2a$export$7a5b1fa979d2c158(document);
    (0, $8j2fP.invariant)(def, 5);
    return def;
}
function $2f1496a7de754c2a$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'OperationDefinition' && definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $2f1496a7de754c2a$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === 'FragmentDefinition';
    });
}
function $2f1496a7de754c2a$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $2f1496a7de754c2a$export$7a5b1fa979d2c158(doc);
    (0, $8j2fP.invariant)(queryDef && queryDef.operation === 'query', 6);
    return queryDef;
}
function $2f1496a7de754c2a$export$772111caef41b3f5(doc) {
    (0, $8j2fP.invariant)(doc.kind === 'Document', 7);
    (0, $8j2fP.invariant)(doc.definitions.length <= 1, 8);
    var fragmentDef = doc.definitions[0];
    (0, $8j2fP.invariant)(fragmentDef.kind === 'FragmentDefinition', 9);
    return fragmentDef;
}
function $2f1496a7de754c2a$export$f431198736b7f96d(queryDoc) {
    $2f1496a7de754c2a$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === 'OperationDefinition') {
            var operation = definition.operation;
            if (operation === 'query' || operation === 'mutation' || operation === 'subscription') return definition;
        }
        if (definition.kind === 'FragmentDefinition' && !fragmentDefinition) fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw new (0, $8j2fP.InvariantError)(10);
}
function $2f1496a7de754c2a$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $2f1496a7de754c2a$export$84c19026e616569e(definition) {
    if (definition && definition.variableDefinitions && definition.variableDefinitions.length) {
        var defaultValues = definition.variableDefinitions.filter(function(_a) {
            var defaultValue = _a.defaultValue;
            return defaultValue;
        }).map(function(_a) {
            var variable = _a.variable, defaultValue = _a.defaultValue;
            var defaultValueObj = {};
            $2f1496a7de754c2a$export$a1dab82d368d6525(defaultValueObj, variable.name, defaultValue);
            return defaultValueObj;
        });
        return $2f1496a7de754c2a$export$e6e34fd1f2686227.apply(void 0, (0, $fKE23.__spreadArrays)([
            {}
        ], defaultValues));
    }
    return {};
}
function $2f1496a7de754c2a$export$55ead6c9e4eac970(operation) {
    var names = new Set();
    if (operation.variableDefinitions) for(var _i = 0, _a = operation.variableDefinitions; _i < _a.length; _i++){
        var definition = _a[_i];
        names.add(definition.variable.name.value);
    }
    return names;
}
function $2f1496a7de754c2a$var$filterInPlace(array, test, context) {
    var target = 0;
    array.forEach(function(elem, i) {
        if (test.call(this, elem, i, array)) array[target++] = elem;
    }, context);
    array.length = target;
    return array;
}
var $2f1496a7de754c2a$var$TYPENAME_FIELD = {
    kind: 'Field',
    name: {
        kind: 'Name',
        value: '__typename'
    }
};
function $2f1496a7de754c2a$var$isEmpty(op, fragments) {
    return op.selectionSet.selections.every(function(selection) {
        return selection.kind === 'FragmentSpread' && $2f1496a7de754c2a$var$isEmpty(fragments[selection.name.value], fragments);
    });
}
function $2f1496a7de754c2a$var$nullIfDocIsEmpty(doc) {
    return $2f1496a7de754c2a$var$isEmpty($2f1496a7de754c2a$export$7a5b1fa979d2c158(doc) || $2f1496a7de754c2a$export$772111caef41b3f5(doc), $2f1496a7de754c2a$export$193789b4c8246dd4($2f1496a7de754c2a$export$5320a7ba9466a3df(doc))) ? null : doc;
}
function $2f1496a7de754c2a$var$getDirectiveMatcher(directives) {
    return function directiveMatcher(directive) {
        return directives.some(function(dir) {
            return dir.name && dir.name === directive.name.value || dir.test && dir.test(directive);
        });
    };
}
function $2f1496a7de754c2a$export$e5ae0530da5fe96c(directives, doc) {
    var variablesInUse = Object.create(null);
    var variablesToRemove = [];
    var fragmentSpreadsInUse = Object.create(null);
    var fragmentSpreadsToRemove = [];
    var modifiedDoc = $2f1496a7de754c2a$var$nullIfDocIsEmpty((0, $961BR.visit)(doc, {
        Variable: {
            enter: function(node, _key, parent) {
                if (parent.kind !== 'VariableDefinition') variablesInUse[node.name.value] = true;
            }
        },
        Field: {
            enter: function(node) {
                if (directives && node.directives) {
                    var shouldRemoveField = directives.some(function(directive) {
                        return directive.remove;
                    });
                    if (shouldRemoveField && node.directives && node.directives.some($2f1496a7de754c2a$var$getDirectiveMatcher(directives))) {
                        if (node.arguments) node.arguments.forEach(function(arg) {
                            if (arg.value.kind === 'Variable') variablesToRemove.push({
                                name: arg.value.name.value
                            });
                        });
                        if (node.selectionSet) $2f1496a7de754c2a$var$getAllFragmentSpreadsFromSelectionSet(node.selectionSet).forEach(function(frag) {
                            fragmentSpreadsToRemove.push({
                                name: frag.name.value
                            });
                        });
                        return null;
                    }
                }
            }
        },
        FragmentSpread: {
            enter: function(node) {
                fragmentSpreadsInUse[node.name.value] = true;
            }
        },
        Directive: {
            enter: function(node) {
                if ($2f1496a7de754c2a$var$getDirectiveMatcher(directives)(node)) return null;
            }
        }
    }));
    if (modifiedDoc && $2f1496a7de754c2a$var$filterInPlace(variablesToRemove, function(v) {
        return !variablesInUse[v.name];
    }).length) modifiedDoc = $2f1496a7de754c2a$export$ecd5bb739c4a8b38(variablesToRemove, modifiedDoc);
    if (modifiedDoc && $2f1496a7de754c2a$var$filterInPlace(fragmentSpreadsToRemove, function(fs) {
        return !fragmentSpreadsInUse[fs.name];
    }).length) modifiedDoc = $2f1496a7de754c2a$export$7c9d17c333033c13(fragmentSpreadsToRemove, modifiedDoc);
    return modifiedDoc;
}
function $2f1496a7de754c2a$export$43b332f87950a467(doc) {
    return (0, $961BR.visit)($2f1496a7de754c2a$export$a7d0d8111d2386df(doc), {
        SelectionSet: {
            enter: function(node, _key, parent) {
                if (parent && parent.kind === 'OperationDefinition') return;
                var selections = node.selections;
                if (!selections) return;
                var skip = selections.some(function(selection) {
                    return $2f1496a7de754c2a$export$fb56ad75dd311c12(selection) && (selection.name.value === '__typename' || selection.name.value.lastIndexOf('__', 0) === 0);
                });
                if (skip) return;
                var field = parent;
                if ($2f1496a7de754c2a$export$fb56ad75dd311c12(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === 'export';
                })) return;
                return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, node), {
                    selections: (0, $fKE23.__spreadArrays)(selections, [
                        $2f1496a7de754c2a$var$TYPENAME_FIELD
                    ])
                });
            }
        }
    });
}
var $2f1496a7de754c2a$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === 'connection';
        if (willRemove) !directive.arguments || directive.arguments.some(function(arg) {
            return arg.name.value === 'key';
        });
        return willRemove;
    }
};
function $2f1496a7de754c2a$export$74985f3324559867(doc) {
    return $2f1496a7de754c2a$export$e5ae0530da5fe96c([
        $2f1496a7de754c2a$var$connectionRemoveConfig
    ], $2f1496a7de754c2a$export$a7d0d8111d2386df(doc));
}
function $2f1496a7de754c2a$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $2f1496a7de754c2a$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $2f1496a7de754c2a$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!$2f1496a7de754c2a$export$fb56ad75dd311c12(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($2f1496a7de754c2a$var$getDirectiveMatcher(directives)) || nestedCheck && $2f1496a7de754c2a$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $2f1496a7de754c2a$export$deed3420cb5d2e1d(directives, doc) {
    $2f1496a7de754c2a$export$a7d0d8111d2386df(doc);
    var parentPath;
    return $2f1496a7de754c2a$var$nullIfDocIsEmpty((0, $961BR.visit)(doc, {
        SelectionSet: {
            enter: function(node, _key, _parent, path) {
                var currentPath = path.join('-');
                if (!parentPath || currentPath === parentPath || !currentPath.startsWith(parentPath)) {
                    if (node.selections) {
                        var selectionsWithDirectives = node.selections.filter(function(selection) {
                            return $2f1496a7de754c2a$var$hasDirectivesInSelection(directives, selection);
                        });
                        if ($2f1496a7de754c2a$var$hasDirectivesInSelectionSet(directives, node, false)) parentPath = currentPath;
                        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, node), {
                            selections: selectionsWithDirectives
                        });
                    } else return null;
                }
            }
        }
    }));
}
function $2f1496a7de754c2a$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === 'Variable' && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $2f1496a7de754c2a$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $2f1496a7de754c2a$var$getArgumentMatcher(config);
    return $2f1496a7de754c2a$var$nullIfDocIsEmpty((0, $961BR.visit)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, node), {
                    variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    })
                });
            }
        },
        Field: {
            enter: function(node) {
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $2f1496a7de754c2a$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $2f1496a7de754c2a$var$nullIfDocIsEmpty((0, $961BR.visit)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $2f1496a7de754c2a$var$getAllFragmentSpreadsFromSelectionSet(selectionSet) {
    var allFragments = [];
    selectionSet.selections.forEach(function(selection) {
        if (($2f1496a7de754c2a$export$fb56ad75dd311c12(selection) || $2f1496a7de754c2a$export$22a1cdafaf27bcff(selection)) && selection.selectionSet) $2f1496a7de754c2a$var$getAllFragmentSpreadsFromSelectionSet(selection.selectionSet).forEach(function(frag) {
            return allFragments.push(frag);
        });
        else if (selection.kind === 'FragmentSpread') allFragments.push(selection);
    });
    return allFragments;
}
function $2f1496a7de754c2a$export$57c368c23873f32b(document) {
    var definition = $2f1496a7de754c2a$export$f431198736b7f96d(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === 'query') return document;
    var modifiedDoc = (0, $961BR.visit)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, node), {
                    operation: 'query'
                });
            }
        }
    });
    return modifiedDoc;
}
function $2f1496a7de754c2a$export$8eae69e876ee321e(document) {
    $2f1496a7de754c2a$export$a7d0d8111d2386df(document);
    var modifiedDoc = $2f1496a7de754c2a$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === 'client';
            },
            remove: true
        }
    ], document);
    if (modifiedDoc) modifiedDoc = (0, $961BR.visit)(modifiedDoc, {
        FragmentDefinition: {
            enter: function(node) {
                if (node.selectionSet) {
                    var isTypenameOnly = node.selectionSet.selections.every(function(selection) {
                        return $2f1496a7de754c2a$export$fb56ad75dd311c12(selection) && selection.name.value === '__typename';
                    });
                    if (isTypenameOnly) return null;
                }
            }
        }
    });
    return modifiedDoc;
}
var $2f1496a7de754c2a$export$772fbc04a0ad4ce9 = typeof WeakMap === 'function' && !(typeof navigator === 'object' && navigator.product === 'ReactNative');
var $2f1496a7de754c2a$var$toString = Object.prototype.toString;
function $2f1496a7de754c2a$export$629a2bd3f5a49ecc(value) {
    return $2f1496a7de754c2a$var$cloneDeepHelper(value, new Map());
}
function $2f1496a7de754c2a$var$cloneDeepHelper(val, seen) {
    switch($2f1496a7de754c2a$var$toString.call(val)){
        case "[object Array]":
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $2f1496a7de754c2a$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            if (seen.has(val)) return seen.get(val);
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $2f1496a7de754c2a$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}
function $2f1496a7de754c2a$export$4bd44a2aa29d3d6e() {
    if (typeof $2fFJv !== 'undefined' && "production") return "production";
    return 'development';
}
function $2f1496a7de754c2a$export$f0cb0fda19c18b37(env) {
    return $2f1496a7de754c2a$export$4bd44a2aa29d3d6e() === env;
}
function $2f1496a7de754c2a$export$f15d00aa73aafac4() {
    return $2f1496a7de754c2a$export$f0cb0fda19c18b37('production') === true;
}
function $2f1496a7de754c2a$export$df77466336fe5355() {
    return $2f1496a7de754c2a$export$f0cb0fda19c18b37('development') === true;
}
function $2f1496a7de754c2a$export$410cbc2864fa25b5() {
    return $2f1496a7de754c2a$export$f0cb0fda19c18b37('test') === true;
}
function $2f1496a7de754c2a$export$50a91acae4904909(f) {
    try {
        return f();
    } catch (e) {
        if (console.error) console.error(e);
    }
}
function $2f1496a7de754c2a$export$b4df399e879e53ab(result) {
    return result.errors && result.errors.length;
}
function $2f1496a7de754c2a$var$deepFreeze(o) {
    Object.freeze(o);
    Object.getOwnPropertyNames(o).forEach(function(prop) {
        if (o[prop] !== null && (typeof o[prop] === 'object' || typeof o[prop] === 'function') && !Object.isFrozen(o[prop])) $2f1496a7de754c2a$var$deepFreeze(o[prop]);
    });
    return o;
}
function $2f1496a7de754c2a$export$7f9c177735b71f18(obj) {
    if ($2f1496a7de754c2a$export$df77466336fe5355() || $2f1496a7de754c2a$export$410cbc2864fa25b5()) {
        var symbolIsPolyfilled = typeof Symbol === 'function' && typeof Symbol('') === 'string';
        if (!symbolIsPolyfilled) return $2f1496a7de754c2a$var$deepFreeze(obj);
    }
    return obj;
}
var $2f1496a7de754c2a$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $2f1496a7de754c2a$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $2f1496a7de754c2a$export$160070228be94b08(sources);
}
function $2f1496a7de754c2a$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var pastCopies = [];
        target = $2f1496a7de754c2a$var$shallowCopyForMerge(target, pastCopies);
        for(var i = 1; i < count; ++i)target = $2f1496a7de754c2a$var$mergeHelper(target, sources[i], pastCopies);
    }
    return target;
}
function $2f1496a7de754c2a$var$isObject(obj) {
    return obj !== null && typeof obj === 'object';
}
function $2f1496a7de754c2a$var$mergeHelper(target, source, pastCopies) {
    if ($2f1496a7de754c2a$var$isObject(source) && $2f1496a7de754c2a$var$isObject(target)) {
        if (Object.isExtensible && !Object.isExtensible(target)) target = $2f1496a7de754c2a$var$shallowCopyForMerge(target, pastCopies);
        Object.keys(source).forEach(function(sourceKey) {
            var sourceValue = source[sourceKey];
            if ($2f1496a7de754c2a$var$hasOwnProperty.call(target, sourceKey)) {
                var targetValue = target[sourceKey];
                if (sourceValue !== targetValue) target[sourceKey] = $2f1496a7de754c2a$var$mergeHelper($2f1496a7de754c2a$var$shallowCopyForMerge(targetValue, pastCopies), sourceValue, pastCopies);
            } else target[sourceKey] = sourceValue;
        });
        return target;
    }
    return source;
}
function $2f1496a7de754c2a$var$shallowCopyForMerge(value, pastCopies) {
    if (value !== null && typeof value === 'object' && pastCopies.indexOf(value) < 0) {
        if (Array.isArray(value)) value = value.slice(0);
        else value = (0, $fKE23.__assign)({
            __proto__: Object.getPrototypeOf(value)
        }, value);
        pastCopies.push(value);
    }
    return value;
}
var $2f1496a7de754c2a$var$haveWarned = Object.create({});
function $2f1496a7de754c2a$export$49d47c8e549bfaf9(msg, type) {
    if (type === void 0) type = 'warn';
    if (!$2f1496a7de754c2a$export$f15d00aa73aafac4() && !$2f1496a7de754c2a$var$haveWarned[msg]) {
        if (!$2f1496a7de754c2a$export$410cbc2864fa25b5()) $2f1496a7de754c2a$var$haveWarned[msg] = true;
        if (type === 'error') console.error(msg);
        else console.warn(msg);
    }
}
function $2f1496a7de754c2a$export$c54efeba029d4fe8(data) {
    return JSON.parse(JSON.stringify(data));
}

});
parcelRegister("961BR", function(module, exports) {

$parcel$export(module.exports, "BREAK", () => $916291e3e456a050$export$a89c95c098ac2a58);
$parcel$export(module.exports, "visit", () => $916291e3e456a050$export$bf638b60ea8b89b7);
$parcel$export(module.exports, "getVisitFn", () => $916291e3e456a050$export$c9c25cca74db6e70);
$parcel$export(module.exports, "visitInParallel", () => $916291e3e456a050$export$728beebeea393478);

var $biK02 = parcelRequire("biK02");

var $c8MIO = parcelRequire("c8MIO");
var $916291e3e456a050$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        // or removed in the future.
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
var $916291e3e456a050$export$a89c95c098ac2a58 = Object.freeze({});
function $916291e3e456a050$export$bf638b60ea8b89b7(root, visitor) {
    var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $916291e3e456a050$export$4fcd777a40ccf407;
    /* eslint-disable no-undef-init */ var stack = undefined;
    var inArray = Array.isArray(root);
    var keys = [
        root
    ];
    var index = -1;
    var edits = [];
    var node = undefined;
    var key = undefined;
    var parent = undefined;
    var path = [];
    var ancestors = [];
    var newRoot = root;
    /* eslint-enable no-undef-init */ do {
        index++;
        var isLeaving = index === keys.length;
        var isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) node = node.slice();
                else {
                    var clone = {};
                    for(var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++){
                        var k = _Object$keys2[_i2];
                        clone[k] = node[k];
                    }
                    node = clone;
                }
                var editOffset = 0;
                for(var ii = 0; ii < edits.length; ii++){
                    var editKey = edits[ii][0];
                    var editValue = edits[ii][1];
                    if (inArray) editKey -= editOffset;
                    if (inArray && editValue === null) {
                        node.splice(editKey, 1);
                        editOffset++;
                    } else node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else {
            key = parent ? inArray ? index : keys[index] : undefined;
            node = parent ? parent[key] : newRoot;
            if (node === null || node === undefined) continue;
            if (parent) path.push(key);
        }
        var result = void 0;
        if (!Array.isArray(node)) {
            if (!(0, $c8MIO.isNode)(node)) throw new Error("Invalid AST Node: ".concat((0, $biK02.default)(node), "."));
            var visitFn = $916291e3e456a050$export$c9c25cca74db6e70(visitor, node.kind, isLeaving);
            if (visitFn) {
                result = visitFn.call(visitor, node, key, parent, path, ancestors);
                if (result === $916291e3e456a050$export$a89c95c098ac2a58) break;
                if (result === false) {
                    if (!isLeaving) {
                        path.pop();
                        continue;
                    }
                } else if (result !== undefined) {
                    edits.push([
                        key,
                        result
                    ]);
                    if (!isLeaving) {
                        if ((0, $c8MIO.isNode)(result)) node = result;
                        else {
                            path.pop();
                            continue;
                        }
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _visitorKeys$node$kin;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) newRoot = edits[edits.length - 1][1];
    return newRoot;
}
function $916291e3e456a050$export$728beebeea393478(visitors) {
    var skipping = new Array(visitors.length);
    return {
        enter: function enter(node) {
            for(var i = 0; i < visitors.length; i++)if (skipping[i] == null) {
                var fn = $916291e3e456a050$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ false);
                if (fn) {
                    var result = fn.apply(visitors[i], arguments);
                    if (result === false) skipping[i] = node;
                    else if (result === $916291e3e456a050$export$a89c95c098ac2a58) skipping[i] = $916291e3e456a050$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            }
        },
        leave: function leave(node) {
            for(var i = 0; i < visitors.length; i++){
                if (skipping[i] == null) {
                    var fn = $916291e3e456a050$export$c9c25cca74db6e70(visitors[i], node.kind, /* isLeaving */ true);
                    if (fn) {
                        var result = fn.apply(visitors[i], arguments);
                        if (result === $916291e3e456a050$export$a89c95c098ac2a58) skipping[i] = $916291e3e456a050$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    }
                } else if (skipping[i] === node) skipping[i] = null;
            }
        }
    };
}
function $916291e3e456a050$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    var kindVisitor = visitor[kind];
    if (kindVisitor) {
        if (!isLeaving && typeof kindVisitor === 'function') // { Kind() {} }
        return kindVisitor;
        var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;
        if (typeof kindSpecificVisitor === 'function') // { Kind: { enter() {}, leave() {} } }
        return kindSpecificVisitor;
    } else {
        var specificVisitor = isLeaving ? visitor.leave : visitor.enter;
        if (specificVisitor) {
            if (typeof specificVisitor === 'function') // { enter() {}, leave() {} }
            return specificVisitor;
            var specificKindVisitor = specificVisitor[kind];
            if (typeof specificKindVisitor === 'function') // { enter: { Kind() {} }, leave: { Kind() {} } }
            return specificKindVisitor;
        }
    }
}

});
parcelRegister("biK02", function(module, exports) {

$parcel$export(module.exports, "default", () => $971870e72b5f63d8$export$2e2bcd8739ae039);

var $8Ygpi = parcelRequire("8Ygpi");
function $971870e72b5f63d8$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $971870e72b5f63d8$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $971870e72b5f63d8$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $971870e72b5f63d8$var$_typeof(obj);
}
var $971870e72b5f63d8$var$MAX_ARRAY_LENGTH = 10;
var $971870e72b5f63d8$var$MAX_RECURSIVE_DEPTH = 2;
function $971870e72b5f63d8$export$2e2bcd8739ae039(value) {
    return $971870e72b5f63d8$var$formatValue(value, []);
}
function $971870e72b5f63d8$var$formatValue(value, seenValues) {
    switch($971870e72b5f63d8$var$_typeof(value)){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? "[function ".concat(value.name, "]") : '[function]';
        case 'object':
            if (value === null) return 'null';
            return $971870e72b5f63d8$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $971870e72b5f63d8$var$formatObjectValue(value, previouslySeenValues) {
    if (previouslySeenValues.indexOf(value) !== -1) return '[Circular]';
    var seenValues = [].concat(previouslySeenValues, [
        value
    ]);
    var customInspectFn = $971870e72b5f63d8$var$getCustomFn(value);
    if (customInspectFn !== undefined) {
        var customValue = customInspectFn.call(value); // check for infinite recursion
        if (customValue !== value) return typeof customValue === 'string' ? customValue : $971870e72b5f63d8$var$formatValue(customValue, seenValues);
    } else if (Array.isArray(value)) return $971870e72b5f63d8$var$formatArray(value, seenValues);
    return $971870e72b5f63d8$var$formatObject(value, seenValues);
}
function $971870e72b5f63d8$var$formatObject(object, seenValues) {
    var keys = Object.keys(object);
    if (keys.length === 0) return '{}';
    if (seenValues.length > $971870e72b5f63d8$var$MAX_RECURSIVE_DEPTH) return '[' + $971870e72b5f63d8$var$getObjectTag(object) + ']';
    var properties = keys.map(function(key) {
        var value = $971870e72b5f63d8$var$formatValue(object[key], seenValues);
        return key + ': ' + value;
    });
    return '{ ' + properties.join(', ') + ' }';
}
function $971870e72b5f63d8$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $971870e72b5f63d8$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    var len = Math.min($971870e72b5f63d8$var$MAX_ARRAY_LENGTH, array.length);
    var remaining = array.length - len;
    var items = [];
    for(var i = 0; i < len; ++i)items.push($971870e72b5f63d8$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push("... ".concat(remaining, " more items"));
    return '[' + items.join(', ') + ']';
}
function $971870e72b5f63d8$var$getCustomFn(object) {
    var customInspectFn = object[String((0, $8Ygpi.default))];
    if (typeof customInspectFn === 'function') return customInspectFn;
    if (typeof object.inspect === 'function') return object.inspect;
}
function $971870e72b5f63d8$var$getObjectTag(object) {
    var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        var name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}

});
parcelRegister("8Ygpi", function(module, exports) {

$parcel$export(module.exports, "default", () => $02e19fa1ae734114$export$2e2bcd8739ae039);
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $02e19fa1ae734114$var$nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
var $02e19fa1ae734114$export$2e2bcd8739ae039 = $02e19fa1ae734114$var$nodejsCustomInspectSymbol;

});


parcelRegister("c8MIO", function(module, exports) {

$parcel$export(module.exports, "Location", () => $e2c0ca6f27c1fab3$export$18a2be9195644f38);
$parcel$export(module.exports, "Token", () => $e2c0ca6f27c1fab3$export$50792b0e93539fde);
$parcel$export(module.exports, "isNode", () => $e2c0ca6f27c1fab3$export$8ee0fc9ee280b4ee);

var $51GHS = parcelRequire("51GHS");
var $e2c0ca6f27c1fab3$export$18a2be9195644f38 = /*#__PURE__*/ function() {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ function Location(startToken, endToken, source) {
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    var _proto = Location.prototype;
    _proto.toJSON = function toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    };
    return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $51GHS.default)($e2c0ca6f27c1fab3$export$18a2be9195644f38);
var $e2c0ca6f27c1fab3$export$50792b0e93539fde = /*#__PURE__*/ function() {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ function Token(kind, start, end, line, column, prev, value) {
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column;
        this.value = value;
        this.prev = prev;
        this.next = null;
    }
    var _proto2 = Token.prototype;
    _proto2.toJSON = function toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    };
    return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.
(0, $51GHS.default)($e2c0ca6f27c1fab3$export$50792b0e93539fde);
function $e2c0ca6f27c1fab3$export$8ee0fc9ee280b4ee(maybeNode) {
    return maybeNode != null && typeof maybeNode.kind === 'string';
} /**
 * The list of all possible AST node types.
 */ 

});
parcelRegister("51GHS", function(module, exports) {

$parcel$export(module.exports, "default", () => $01e114d2d62ce6bf$export$2e2bcd8739ae039);

var $43MJl = parcelRequire("43MJl");

var $8Ygpi = parcelRequire("8Ygpi");
function $01e114d2d62ce6bf$export$2e2bcd8739ae039(classObject) {
    var fn = classObject.prototype.toJSON;
    typeof fn === 'function' || (0, $43MJl.default)(0);
    classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')
    if (0, $8Ygpi.default) classObject.prototype[0, $8Ygpi.default] = fn;
}

});
parcelRegister("43MJl", function(module, exports) {

$parcel$export(module.exports, "default", () => $56486ec4c154c5f8$export$2e2bcd8739ae039);
function $56486ec4c154c5f8$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message != null ? message : 'Unexpected invariant triggered.');
}

});




parcelRegister("cGs0N", function(module, exports) {
'use strict';
module.exports = function(data, opts) {
    if (!opts) opts = {};
    if (typeof opts === 'function') opts = {
        cmp: opts
    };
    var cycles = typeof opts.cycles === 'boolean' ? opts.cycles : false;
    var cmp = opts.cmp && function(f) {
        return function(node) {
            return function(a, b) {
                var aobj = {
                    key: a,
                    value: node[a]
                };
                var bobj = {
                    key: b,
                    value: node[b]
                };
                return f(aobj, bobj);
            };
        };
    }(opts.cmp);
    var seen = [];
    return function stringify(node) {
        if (node && node.toJSON && typeof node.toJSON === 'function') node = node.toJSON();
        if (node === undefined) return;
        if (typeof node == 'number') return isFinite(node) ? '' + node : 'null';
        if (typeof node !== 'object') return JSON.stringify(node);
        var i, out;
        if (Array.isArray(node)) {
            out = '[';
            for(i = 0; i < node.length; i++){
                if (i) out += ',';
                out += stringify(node[i]) || 'null';
            }
            return out + ']';
        }
        if (node === null) return 'null';
        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify('__cycle__');
            throw new TypeError('Converting circular structure to JSON');
        }
        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = '';
        for(i = 0; i < keys.length; i++){
            var key = keys[i];
            var value = stringify(node[key]);
            if (!value) continue;
            if (out) out += ',';
            out += JSON.stringify(key) + ':' + value;
        }
        seen.splice(seenIndex, 1);
        return '{' + out + '}';
    }(data);
};

});

parcelRegister("66hGB", function(module, exports) {

$parcel$export(module.exports, "equal", () => $471105b2f2fd38f1$export$411ce8e5a71e3069);
var $471105b2f2fd38f1$var$_a = Object.prototype, $471105b2f2fd38f1$var$toString = $471105b2f2fd38f1$var$_a.toString, $471105b2f2fd38f1$var$hasOwnProperty = $471105b2f2fd38f1$var$_a.hasOwnProperty;
var $471105b2f2fd38f1$var$previousComparisons = new Map();
/**
 * Performs a deep equality check on two JavaScript values, tolerating cycles.
 */ function $471105b2f2fd38f1$export$411ce8e5a71e3069(a, b) {
    try {
        return $471105b2f2fd38f1$var$check(a, b);
    } finally{
        $471105b2f2fd38f1$var$previousComparisons.clear();
    }
}
function $471105b2f2fd38f1$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    var aTag = $471105b2f2fd38f1$var$toString.call(a);
    var bTag = $471105b2f2fd38f1$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case '[object Object]':
            if ($471105b2f2fd38f1$var$previouslyCompared(a, b)) return true;
            var aKeys = Object.keys(a);
            var bKeys = Object.keys(b);
            // If `a` and `b` have a different number of enumerable keys, they
            // must be different.
            var keyCount = aKeys.length;
            if (keyCount !== bKeys.length) return false;
            // Now make sure they have the same keys.
            for(var k = 0; k < keyCount; ++k){
                if (!$471105b2f2fd38f1$var$hasOwnProperty.call(b, aKeys[k])) return false;
            }
            // Finally, check deep equality of all child properties.
            for(var k = 0; k < keyCount; ++k){
                var key = aKeys[k];
                if (!$471105b2f2fd38f1$var$check(a[key], b[key])) return false;
            }
            return true;
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == "" + b;
        case '[object Map]':
        case '[object Set]':
            if (a.size !== b.size) return false;
            if ($471105b2f2fd38f1$var$previouslyCompared(a, b)) return true;
            var aIterator = a.entries();
            var isMap = aTag === '[object Map]';
            while(true){
                var info = aIterator.next();
                if (info.done) break;
                // If a instanceof Set, aValue === aKey.
                var _a = info.value, aKey = _a[0], aValue = _a[1];
                // So this works the same way for both Set and Map.
                if (!b.has(aKey)) return false;
                // However, we care about deep equality of values only when dealing
                // with Map structures.
                if (isMap && !$471105b2f2fd38f1$var$check(aValue, b.get(aKey))) return false;
            }
            return true;
    }
    // Otherwise the values are not equal.
    return false;
}
function $471105b2f2fd38f1$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    var bSet = $471105b2f2fd38f1$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $471105b2f2fd38f1$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}
var $471105b2f2fd38f1$export$2e2bcd8739ae039 = $471105b2f2fd38f1$export$411ce8e5a71e3069;

});



parcelRegister("7xYai", function(module, exports) {

$parcel$export(module.exports, "KeyTrie", () => $57ea48f9f955816f$export$6bd8d8299be3ac82);
$parcel$export(module.exports, "wrap", () => $57ea48f9f955816f$export$4997ffc0176396a6);

var $182fv = parcelRequire("182fv");
function $57ea48f9f955816f$var$defaultDispose() {}
var $57ea48f9f955816f$var$Cache = /** @class */ function() {
    function Cache(max, dispose) {
        if (max === void 0) max = Infinity;
        if (dispose === void 0) dispose = $57ea48f9f955816f$var$defaultDispose;
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function(key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function(key) {
        var entry = this.getEntry(key);
        return entry && entry.value;
    };
    Cache.prototype.getEntry = function(key) {
        var entry = this.map.get(key);
        if (entry && entry !== this.newest) {
            var older = entry.older, newer = entry.newer;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            entry.older = this.newest;
            entry.older.newer = entry;
            entry.newer = null;
            this.newest = entry;
            if (entry === this.oldest) this.oldest = newer;
        }
        return entry;
    };
    Cache.prototype.set = function(key, value) {
        var entry = this.getEntry(key);
        if (entry) return entry.value = value;
        entry = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = entry;
        this.newest = entry;
        this.oldest = this.oldest || entry;
        this.map.set(key, entry);
        return entry.value;
    };
    Cache.prototype.clean = function() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    };
    Cache.prototype.delete = function(key) {
        var entry = this.map.get(key);
        if (entry) {
            if (entry === this.newest) this.newest = entry.older;
            if (entry === this.oldest) this.oldest = entry.newer;
            if (entry.newer) entry.newer.older = entry.older;
            if (entry.older) entry.older.newer = entry.newer;
            this.map.delete(key);
            this.dispose(entry.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}();
var $57ea48f9f955816f$var$parentEntrySlot = new (0, $182fv.Slot)();
var $57ea48f9f955816f$var$reusableEmptyArray = [];
var $57ea48f9f955816f$var$emptySetPool = [];
var $57ea48f9f955816f$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $57ea48f9f955816f$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $57ea48f9f955816f$var$valueIs(a, b) {
    var len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $57ea48f9f955816f$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $57ea48f9f955816f$var$valueCopy(value) {
    return value.slice(0);
}
var $57ea48f9f955816f$var$Entry = /** @class */ function() {
    function Entry(fn, args) {
        this.fn = fn;
        this.args = args;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        ++Entry.count;
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function() {
        $57ea48f9f955816f$var$assert(!this.recomputing, "already recomputing");
        if (!$57ea48f9f955816f$var$rememberParent(this) && $57ea48f9f955816f$var$maybeReportOrphan(this)) // The recipient of the entry.reportOrphan callback decided to dispose
        // of this orphan entry by calling entry.dispose(), so we don't need to
        // (and should not) proceed with the recomputation.
        return void 0;
        return $57ea48f9f955816f$var$mightBeDirty(this) ? $57ea48f9f955816f$var$reallyRecompute(this) : $57ea48f9f955816f$var$valueGet(this.value);
    };
    Entry.prototype.setDirty = function() {
        if (this.dirty) return;
        this.dirty = true;
        this.value.length = 0;
        $57ea48f9f955816f$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        $57ea48f9f955816f$var$maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function() {
        var _this = this;
        $57ea48f9f955816f$var$forgetChildren(this).forEach($57ea48f9f955816f$var$maybeReportOrphan);
        $57ea48f9f955816f$var$maybeUnsubscribe(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        this.parents.forEach(function(parent) {
            parent.setDirty();
            $57ea48f9f955816f$var$forgetChild(parent, _this);
        });
    };
    Entry.count = 0;
    return Entry;
}();
function $57ea48f9f955816f$var$rememberParent(child) {
    var parent = $57ea48f9f955816f$var$parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($57ea48f9f955816f$var$mightBeDirty(child)) $57ea48f9f955816f$var$reportDirtyChild(parent, child);
        else $57ea48f9f955816f$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $57ea48f9f955816f$var$reallyRecompute(entry) {
    // Since this recomputation is likely to re-remember some of this
    // entry's children, we forget our children here but do not call
    // maybeReportOrphan until after the recomputation finishes.
    var originalChildren = $57ea48f9f955816f$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    $57ea48f9f955816f$var$parentEntrySlot.withValue(entry, $57ea48f9f955816f$var$recomputeNewValue, [
        entry
    ]);
    if ($57ea48f9f955816f$var$maybeSubscribe(entry)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $57ea48f9f955816f$var$setClean(entry);
    // Now that we've had a chance to re-remember any children that were
    // involved in the recomputation, we can safely report any orphan
    // children that remain.
    originalChildren.forEach($57ea48f9f955816f$var$maybeReportOrphan);
    return $57ea48f9f955816f$var$valueGet(entry.value);
}
function $57ea48f9f955816f$var$recomputeNewValue(entry) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, entry.args);
    } catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $57ea48f9f955816f$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $57ea48f9f955816f$var$setClean(entry) {
    entry.dirty = false;
    if ($57ea48f9f955816f$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $57ea48f9f955816f$var$reportClean(entry);
}
function $57ea48f9f955816f$var$reportDirty(child) {
    child.parents.forEach(function(parent) {
        return $57ea48f9f955816f$var$reportDirtyChild(parent, child);
    });
}
function $57ea48f9f955816f$var$reportClean(child) {
    child.parents.forEach(function(parent) {
        return $57ea48f9f955816f$var$reportCleanChild(parent, child);
    });
}
// Let a parent Entry know that one of its children may be dirty.
function $57ea48f9f955816f$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $57ea48f9f955816f$var$assert(parent.childValues.has(child));
    $57ea48f9f955816f$var$assert($57ea48f9f955816f$var$mightBeDirty(child));
    if (!parent.dirtyChildren) parent.dirtyChildren = $57ea48f9f955816f$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    $57ea48f9f955816f$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $57ea48f9f955816f$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $57ea48f9f955816f$var$assert(parent.childValues.has(child));
    $57ea48f9f955816f$var$assert(!$57ea48f9f955816f$var$mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $57ea48f9f955816f$var$valueCopy(child.value));
    else if (!$57ea48f9f955816f$var$valueIs(childValue, child.value)) parent.setDirty();
    $57ea48f9f955816f$var$removeDirtyChild(parent, child);
    if ($57ea48f9f955816f$var$mightBeDirty(parent)) return;
    $57ea48f9f955816f$var$reportClean(parent);
}
function $57ea48f9f955816f$var$removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($57ea48f9f955816f$var$emptySetPool.length < $57ea48f9f955816f$var$POOL_TARGET_SIZE) $57ea48f9f955816f$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// If the given entry has a reportOrphan method, and no remaining parents,
// call entry.reportOrphan and return true iff it returns true. The
// reportOrphan function should return true to indicate entry.dispose()
// has been called, and the entry has been removed from any other caches
// (see index.js for the only current example).
function $57ea48f9f955816f$var$maybeReportOrphan(entry) {
    return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
}
// Removes all children from this entry and returns an array of the
// removed children.
function $57ea48f9f955816f$var$forgetChildren(parent) {
    var children = $57ea48f9f955816f$var$reusableEmptyArray;
    if (parent.childValues.size > 0) {
        children = [];
        parent.childValues.forEach(function(_value, child) {
            $57ea48f9f955816f$var$forgetChild(parent, child);
            children.push(child);
        });
    }
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $57ea48f9f955816f$var$assert(parent.dirtyChildren === null);
    return children;
}
function $57ea48f9f955816f$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $57ea48f9f955816f$var$removeDirtyChild(parent, child);
}
function $57ea48f9f955816f$var$maybeSubscribe(entry) {
    if (typeof entry.subscribe === "function") try {
        $57ea48f9f955816f$var$maybeUnsubscribe(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, entry.args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
function $57ea48f9f955816f$var$maybeUnsubscribe(entry) {
    var unsubscribe = entry.unsubscribe;
    if (typeof unsubscribe === "function") {
        entry.unsubscribe = void 0;
        unsubscribe();
    }
}
// A trie data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var $57ea48f9f955816f$export$6bd8d8299be3ac82 = /** @class */ function() {
    function KeyTrie(weakness) {
        this.weakness = weakness;
    }
    KeyTrie.prototype.lookup = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
        return this.lookupArray(array);
    };
    KeyTrie.prototype.lookupArray = function(array) {
        var node = this;
        array.forEach(function(key) {
            return node = node.getChildTrie(key);
        });
        return node.data || (node.data = Object.create(null));
    };
    KeyTrie.prototype.getChildTrie = function(key) {
        var map = this.weakness && $57ea48f9f955816f$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child) map.set(key, child = new KeyTrie(this.weakness));
        return child;
    };
    return KeyTrie;
}();
function $57ea48f9f955816f$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var $57ea48f9f955816f$var$keyTrie = new $57ea48f9f955816f$export$6bd8d8299be3ac82(typeof WeakMap === "function");
function $57ea48f9f955816f$export$cd3144f8dd136006() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $57ea48f9f955816f$var$keyTrie.lookupArray(args);
}
var $57ea48f9f955816f$var$caches = new Set();
function $57ea48f9f955816f$export$4997ffc0176396a6(originalFunction, options) {
    if (options === void 0) options = Object.create(null);
    var cache = new $57ea48f9f955816f$var$Cache(options.max || Math.pow(2, 16), function(entry) {
        return entry.dispose();
    });
    var disposable = !!options.disposable;
    var makeCacheKey = options.makeCacheKey || $57ea48f9f955816f$export$cd3144f8dd136006;
    function optimistic() {
        if (disposable && !$57ea48f9f955816f$var$parentEntrySlot.hasValue()) // If there's no current parent computation, and this wrapped
        // function is disposable (meaning we don't care about entry.value,
        // just dependency tracking), then we can short-cut everything else
        // in this function, because entry.recompute() is going to recycle
        // the entry object without recomputing anything, anyway.
        return void 0;
        var key = makeCacheKey.apply(null, arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        var args = Array.prototype.slice.call(arguments);
        var entry = cache.get(key);
        if (entry) entry.args = args;
        else {
            entry = new $57ea48f9f955816f$var$Entry(originalFunction, args);
            cache.set(key, entry);
            entry.subscribe = options.subscribe;
            if (disposable) entry.reportOrphan = function() {
                return cache.delete(key);
            };
        }
        var value = entry.recompute();
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $57ea48f9f955816f$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!$57ea48f9f955816f$var$parentEntrySlot.hasValue()) {
            $57ea48f9f955816f$var$caches.forEach(function(cache) {
                return cache.clean();
            });
            $57ea48f9f955816f$var$caches.clear();
        }
        // If options.disposable is truthy, the caller of wrap is telling us
        // they don't care about the result of entry.recompute(), so we should
        // avoid returning the value, so it won't be accidentally used.
        return disposable ? void 0 : value;
    }
    optimistic.dirty = function() {
        var key = makeCacheKey.apply(null, arguments);
        var child = key !== void 0 && cache.get(key);
        if (child) child.setDirty();
    };
    return optimistic;
}

});
parcelRegister("182fv", function(module, exports) {

$parcel$export(module.exports, "Slot", () => $0d28486785009faf$export$8c6ed5c666ac1360);
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var $0d28486785009faf$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var $0d28486785009faf$var$MISSING_VALUE = {};
var $0d28486785009faf$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var $0d28486785009faf$var$makeSlotClass = function() {
    return /** @class */ function() {
        function Slot() {
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $0d28486785009faf$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        Slot.prototype.hasValue = function() {
            for(var context_1 = $0d28486785009faf$var$currentContext; context_1; context_1 = context_1.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === $0d28486785009faf$var$MISSING_VALUE) break;
                if (context_1 !== $0d28486785009faf$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $0d28486785009faf$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($0d28486785009faf$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $0d28486785009faf$var$currentContext.slots[this.id] = $0d28486785009faf$var$MISSING_VALUE;
            return false;
        };
        Slot.prototype.getValue = function() {
            if (this.hasValue()) return $0d28486785009faf$var$currentContext.slots[this.id];
        };
        Slot.prototype.withValue = function(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            var _a;
            var slots = (_a = {
                __proto__: null
            }, _a[this.id] = value, _a);
            var parent = $0d28486785009faf$var$currentContext;
            $0d28486785009faf$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $0d28486785009faf$var$currentContext = parent;
            }
        };
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        Slot.bind = function(callback) {
            var context = $0d28486785009faf$var$currentContext;
            return function() {
                var saved = $0d28486785009faf$var$currentContext;
                try {
                    $0d28486785009faf$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $0d28486785009faf$var$currentContext = saved;
                }
            };
        };
        // Immediately run a callback function without any captured context.
        Slot.noContext = function(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($0d28486785009faf$var$currentContext) {
                var saved = $0d28486785009faf$var$currentContext;
                try {
                    $0d28486785009faf$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $0d28486785009faf$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        };
        return Slot;
    }();
};
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var $0d28486785009faf$var$globalKey = "@wry/context:Slot";
var $0d28486785009faf$var$host = Array;
var $0d28486785009faf$export$8c6ed5c666ac1360 = $0d28486785009faf$var$host[$0d28486785009faf$var$globalKey] || function() {
    var Slot = $0d28486785009faf$var$makeSlotClass();
    try {
        Object.defineProperty($0d28486785009faf$var$host, $0d28486785009faf$var$globalKey, {
            value: $0d28486785009faf$var$host[$0d28486785009faf$var$globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false
        });
    } finally{
        return Slot;
    }
}();
var $0d28486785009faf$export$2385a24977818dd0 = $0d28486785009faf$export$8c6ed5c666ac1360.bind, $0d28486785009faf$export$9fa6f2e300a97f8 = $0d28486785009faf$export$8c6ed5c666ac1360.noContext;
function $0d28486785009faf$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($0d28486785009faf$export$2385a24977818dd0(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function $0d28486785009faf$export$d5d7536e965c82da(genFn) {
    return function() {
        var gen = genFn.apply(this, arguments);
        var boundNext = $0d28486785009faf$export$2385a24977818dd0(gen.next);
        var boundThrow = $0d28486785009faf$export$2385a24977818dd0(gen.throw);
        return new Promise(function(resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if ($0d28486785009faf$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            var invokeNext = function(value) {
                return invoke(boundNext, value);
            };
            var invokeThrow = function(error) {
                return invoke(boundThrow, error);
            };
            invokeNext();
        });
    };
}
function $0d28486785009faf$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var $0d28486785009faf$var$wrappedFibers = [];
function $0d28486785009faf$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($0d28486785009faf$var$wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function(obj, method) {
            var fn = obj[method];
            obj[method] = function() {
                return $0d28486785009faf$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $0d28486785009faf$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}

});



parcelRegister("jlBDe", function(module, exports) {

$parcel$export(module.exports, "NetworkStatus", () => $03a288f5350d9e9d$export$bd096ddbd246c79c);
$parcel$export(module.exports, "ApolloError", () => $03a288f5350d9e9d$export$26a337512320b8c6);
$parcel$export(module.exports, "ApolloClient", () => $03a288f5350d9e9d$export$13f5a5f0f1dbab88);
$parcel$export(module.exports, "default", () => $03a288f5350d9e9d$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $42BH7 = parcelRequire("42BH7");
var $66hGB = parcelRequire("66hGB");

var $bvQX6 = parcelRequire("bvQX6");
var $5ECju = parcelRequire("5ECju");

var $6XJYy = parcelRequire("6XJYy");

var $8j2fP = parcelRequire("8j2fP");

var $961BR = parcelRequire("961BR");
var $03a288f5350d9e9d$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($03a288f5350d9e9d$export$bd096ddbd246c79c || ($03a288f5350d9e9d$export$bd096ddbd246c79c = {}));
function $03a288f5350d9e9d$var$isNetworkRequestInFlight(networkStatus) {
    return networkStatus < 7;
}
var $03a288f5350d9e9d$var$Observable = function(_super) {
    (0, $fKE23.__extends)(Observable, _super);
    function Observable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Observable.prototype[0, $6XJYy.default] = function() {
        return this;
    };
    Observable.prototype['@@observable'] = function() {
        return this;
    };
    return Observable;
}((0, $5ECju.default));
function $03a288f5350d9e9d$var$isNonEmptyArray(value) {
    return Array.isArray(value) && value.length > 0;
}
function $03a288f5350d9e9d$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty('graphQLErrors');
}
var $03a288f5350d9e9d$var$generateErrorMessage = function(err) {
    var message = '';
    if ($03a288f5350d9e9d$var$isNonEmptyArray(err.graphQLErrors)) err.graphQLErrors.forEach(function(graphQLError) {
        var errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += "GraphQL error: " + errorMessage + "\n";
    });
    if (err.networkError) message += 'Network error: ' + err.networkError.message + '\n';
    message = message.replace(/\n$/, '');
    return message;
};
var $03a288f5350d9e9d$export$26a337512320b8c6 = function(_super) {
    (0, $fKE23.__extends)(ApolloError, _super);
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.graphQLErrors = graphQLErrors || [];
        _this.networkError = networkError || null;
        if (!errorMessage) _this.message = $03a288f5350d9e9d$var$generateErrorMessage(_this);
        else _this.message = errorMessage;
        _this.extraInfo = extraInfo;
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);
var $03a288f5350d9e9d$export$160bafb6ac1e0641;
(function(FetchType) {
    FetchType[FetchType["normal"] = 1] = "normal";
    FetchType[FetchType["refetch"] = 2] = "refetch";
    FetchType[FetchType["poll"] = 3] = "poll";
})($03a288f5350d9e9d$export$160bafb6ac1e0641 || ($03a288f5350d9e9d$export$160bafb6ac1e0641 = {}));
var $03a288f5350d9e9d$var$hasError = function(storeValue, policy) {
    if (policy === void 0) policy = 'none';
    return storeValue && (storeValue.networkError || policy === 'none' && $03a288f5350d9e9d$var$isNonEmptyArray(storeValue.graphQLErrors));
};
var $03a288f5350d9e9d$export$6c1b56eac59c9584 = function(_super) {
    (0, $fKE23.__extends)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, options = _a.options, _b = _a.shouldSubscribe, shouldSubscribe = _b === void 0 ? true : _b;
        var _this = _super.call(this, function(observer) {
            return _this.onSubscribe(observer);
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        _this.isTornDown = false;
        _this.options = options;
        _this.variables = options.variables || {};
        _this.queryId = queryManager.generateQueryId();
        _this.shouldSubscribe = shouldSubscribe;
        var opDef = (0, $42BH7.getOperationDefinition)(options.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        _this.queryManager = queryManager;
        return _this;
    }
    ObservableQuery.prototype.result = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var observer = {
                next: function(result) {
                    resolve(result);
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    ObservableQuery.prototype.currentResult = function() {
        var result = this.getCurrentResult();
        if (result.data === undefined) result.data = {};
        return result;
    };
    ObservableQuery.prototype.getCurrentResult = function() {
        if (this.isTornDown) {
            var lastResult = this.lastResult;
            return {
                data: !this.lastError && lastResult && lastResult.data || void 0,
                error: this.lastError,
                loading: false,
                networkStatus: $03a288f5350d9e9d$export$bd096ddbd246c79c.error
            };
        }
        var _a = this.queryManager.getCurrentQueryResult(this), data = _a.data, partial = _a.partial;
        var queryStoreValue = this.queryManager.queryStore.get(this.queryId);
        var result;
        var fetchPolicy = this.options.fetchPolicy;
        var isNetworkFetchPolicy = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
        if (queryStoreValue) {
            var networkStatus = queryStoreValue.networkStatus;
            if ($03a288f5350d9e9d$var$hasError(queryStoreValue, this.options.errorPolicy)) return {
                data: void 0,
                loading: false,
                networkStatus: networkStatus,
                error: new $03a288f5350d9e9d$export$26a337512320b8c6({
                    graphQLErrors: queryStoreValue.graphQLErrors,
                    networkError: queryStoreValue.networkError
                })
            };
            if (queryStoreValue.variables) {
                this.options.variables = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options.variables), queryStoreValue.variables);
                this.variables = this.options.variables;
            }
            result = {
                data: data,
                loading: $03a288f5350d9e9d$var$isNetworkRequestInFlight(networkStatus),
                networkStatus: networkStatus
            };
            if (queryStoreValue.graphQLErrors && this.options.errorPolicy === 'all') result.errors = queryStoreValue.graphQLErrors;
        } else {
            var loading = isNetworkFetchPolicy || partial && fetchPolicy !== 'cache-only';
            result = {
                data: data,
                loading: loading,
                networkStatus: loading ? $03a288f5350d9e9d$export$bd096ddbd246c79c.loading : $03a288f5350d9e9d$export$bd096ddbd246c79c.ready
            };
        }
        if (!partial) this.updateLastResult((0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
            stale: false
        }));
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
            partial: partial
        });
    };
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult) {
        var snapshot = this.lastResultSnapshot;
        return !(snapshot && newResult && snapshot.networkStatus === newResult.networkStatus && snapshot.stale === newResult.stale && (0, $66hGB.equal)(snapshot.data, newResult.data));
    };
    ObservableQuery.prototype.getLastResult = function() {
        return this.lastResult;
    };
    ObservableQuery.prototype.getLastError = function() {
        return this.lastError;
    };
    ObservableQuery.prototype.resetLastResults = function() {
        delete this.lastResult;
        delete this.lastResultSnapshot;
        delete this.lastError;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function() {
        var queryStore = this.queryManager.queryStore.get(this.queryId);
        if (queryStore) {
            queryStore.networkError = null;
            queryStore.graphQLErrors = [];
        }
    };
    ObservableQuery.prototype.refetch = function(variables) {
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === 'cache-only') return Promise.reject(new (0, $8j2fP.InvariantError)(1));
        if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'cache-and-network') fetchPolicy = 'network-only';
        if (!(0, $66hGB.equal)(this.variables, variables)) this.variables = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.variables), variables);
        if (!(0, $66hGB.equal)(this.options.variables, this.variables)) this.options.variables = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options.variables), this.variables);
        return this.queryManager.fetchQuery(this.queryId, (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options), {
            fetchPolicy: fetchPolicy
        }), $03a288f5350d9e9d$export$160bafb6ac1e0641.refetch);
    };
    ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        (0, $8j2fP.invariant)(fetchMoreOptions.updateQuery, 2);
        var combinedOptions = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, $fKE23.__assign)((0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options), fetchMoreOptions), {
            variables: (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.variables), fetchMoreOptions.variables)
        })), {
            fetchPolicy: 'network-only'
        });
        var qid = this.queryManager.generateQueryId();
        return this.queryManager.fetchQuery(qid, combinedOptions, $03a288f5350d9e9d$export$160bafb6ac1e0641.normal, this.queryId).then(function(fetchMoreResult) {
            _this.updateQuery(function(previousResult) {
                return fetchMoreOptions.updateQuery(previousResult, {
                    fetchMoreResult: fetchMoreResult.data,
                    variables: combinedOptions.variables
                });
            });
            _this.queryManager.stopQuery(qid);
            return fetchMoreResult;
        }, function(error) {
            _this.queryManager.stopQuery(qid);
            throw error;
        });
    };
    ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, _a) {
                    var variables = _a.variables;
                    return updateQuery(previous, {
                        subscriptionData: subscriptionData,
                        variables: variables
                    });
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    ObservableQuery.prototype.setOptions = function(opts) {
        var oldFetchPolicy = this.options.fetchPolicy;
        this.options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options), opts);
        if (opts.pollInterval) this.startPolling(opts.pollInterval);
        else if (opts.pollInterval === 0) this.stopPolling();
        var fetchPolicy = opts.fetchPolicy;
        return this.setVariables(this.options.variables, oldFetchPolicy !== fetchPolicy && (oldFetchPolicy === 'cache-only' || oldFetchPolicy === 'standby' || fetchPolicy === 'network-only'), opts.fetchResults);
    };
    ObservableQuery.prototype.setVariables = function(variables, tryFetch, fetchResults) {
        if (tryFetch === void 0) tryFetch = false;
        if (fetchResults === void 0) fetchResults = true;
        this.isTornDown = false;
        variables = variables || this.variables;
        if (!tryFetch && (0, $66hGB.equal)(variables, this.variables)) return this.observers.size && fetchResults ? this.result() : Promise.resolve();
        this.variables = this.options.variables = variables;
        if (!this.observers.size) return Promise.resolve();
        return this.queryManager.fetchQuery(this.queryId, this.options);
    };
    ObservableQuery.prototype.updateQuery = function(mapFn) {
        var queryManager = this.queryManager;
        var _a = queryManager.getQueryWithPreviousResult(this.queryId), previousResult = _a.previousResult, variables = _a.variables, document = _a.document;
        var newResult = (0, $42BH7.tryFunctionOrLogError)(function() {
            return mapFn(previousResult, {
                variables: variables
            });
        });
        if (newResult) {
            queryManager.dataStore.markUpdateQueryResult(document, variables, newResult);
            queryManager.broadcastQueries();
        }
    };
    ObservableQuery.prototype.stopPolling = function() {
        this.queryManager.stopPollingQuery(this.queryId);
        this.options.pollInterval = undefined;
    };
    ObservableQuery.prototype.startPolling = function(pollInterval) {
        $03a288f5350d9e9d$var$assertNotCacheFirstOrOnly(this);
        this.options.pollInterval = pollInterval;
        this.queryManager.startPollingQuery(this.options, this.queryId);
    };
    ObservableQuery.prototype.updateLastResult = function(newResult) {
        var previousResult = this.lastResult;
        this.lastResult = newResult;
        this.lastResultSnapshot = this.queryManager.assumeImmutableResults ? newResult : (0, $42BH7.cloneDeep)(newResult);
        return previousResult;
    };
    ObservableQuery.prototype.onSubscribe = function(observer) {
        var _this = this;
        try {
            var subObserver = observer._subscription._observer;
            if (subObserver && !subObserver.error) subObserver.error = $03a288f5350d9e9d$var$defaultSubscriptionObserverErrorCallback;
        } catch (_a) {}
        var first = !this.observers.size;
        this.observers.add(observer);
        if (observer.next && this.lastResult) observer.next(this.lastResult);
        if (observer.error && this.lastError) observer.error(this.lastError);
        if (first) this.setUpQuery();
        return function() {
            if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
        };
    };
    ObservableQuery.prototype.setUpQuery = function() {
        var _this = this;
        var _a = this, queryManager = _a.queryManager, queryId = _a.queryId;
        if (this.shouldSubscribe) queryManager.addObservableQuery(queryId, this);
        if (this.options.pollInterval) {
            $03a288f5350d9e9d$var$assertNotCacheFirstOrOnly(this);
            queryManager.startPollingQuery(this.options, queryId);
        }
        var onError = function(error) {
            _this.updateLastResult((0, $fKE23.__assign)((0, $fKE23.__assign)({}, _this.lastResult), {
                errors: error.graphQLErrors,
                networkStatus: $03a288f5350d9e9d$export$bd096ddbd246c79c.error,
                loading: false
            }));
            $03a288f5350d9e9d$var$iterateObserversSafely(_this.observers, 'error', _this.lastError = error);
        };
        queryManager.observeQuery(queryId, this.options, {
            next: function(result) {
                if (_this.lastError || _this.isDifferentFromLastResult(result)) {
                    var previousResult_1 = _this.updateLastResult(result);
                    var _a = _this.options, query_1 = _a.query, variables = _a.variables, fetchPolicy_1 = _a.fetchPolicy;
                    if (queryManager.transform(query_1).hasClientExports) queryManager.getLocalState().addExportedVariables(query_1, variables).then(function(variables) {
                        var previousVariables = _this.variables;
                        _this.variables = _this.options.variables = variables;
                        if (!result.loading && previousResult_1 && fetchPolicy_1 !== 'cache-only' && queryManager.transform(query_1).serverQuery && !(0, $66hGB.equal)(previousVariables, variables)) _this.refetch();
                        else $03a288f5350d9e9d$var$iterateObserversSafely(_this.observers, 'next', result);
                    });
                    else $03a288f5350d9e9d$var$iterateObserversSafely(_this.observers, 'next', result);
                }
            },
            error: onError
        }).catch(onError);
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        var queryManager = this.queryManager;
        this.isTornDown = true;
        queryManager.stopPollingQuery(this.queryId);
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        queryManager.removeObservableQuery(this.queryId);
        queryManager.stopQuery(this.queryId);
        this.observers.clear();
    };
    return ObservableQuery;
}($03a288f5350d9e9d$var$Observable);
function $03a288f5350d9e9d$var$defaultSubscriptionObserverErrorCallback(error) {}
function $03a288f5350d9e9d$var$iterateObserversSafely(observers, method, argument) {
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}
function $03a288f5350d9e9d$var$assertNotCacheFirstOrOnly(obsQuery) {
    var fetchPolicy = obsQuery.options.fetchPolicy;
    (0, $8j2fP.invariant)(fetchPolicy !== 'cache-first' && fetchPolicy !== 'cache-only', 3);
}
var $03a288f5350d9e9d$var$MutationStore = function() {
    function MutationStore() {
        this.store = {};
    }
    MutationStore.prototype.getStore = function() {
        return this.store;
    };
    MutationStore.prototype.get = function(mutationId) {
        return this.store[mutationId];
    };
    MutationStore.prototype.initMutation = function(mutationId, mutation, variables) {
        this.store[mutationId] = {
            mutation: mutation,
            variables: variables || {},
            loading: true,
            error: null
        };
    };
    MutationStore.prototype.markMutationError = function(mutationId, error) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = error;
        }
    };
    MutationStore.prototype.markMutationResult = function(mutationId) {
        var mutation = this.store[mutationId];
        if (mutation) {
            mutation.loading = false;
            mutation.error = null;
        }
    };
    MutationStore.prototype.reset = function() {
        this.store = {};
    };
    return MutationStore;
}();
var $03a288f5350d9e9d$var$QueryStore = function() {
    function QueryStore() {
        this.store = {};
    }
    QueryStore.prototype.getStore = function() {
        return this.store;
    };
    QueryStore.prototype.get = function(queryId) {
        return this.store[queryId];
    };
    QueryStore.prototype.initQuery = function(query) {
        var previousQuery = this.store[query.queryId];
        (0, $8j2fP.invariant)(!previousQuery || previousQuery.document === query.document || (0, $66hGB.equal)(previousQuery.document, query.document), 19);
        var isSetVariables = false;
        var previousVariables = null;
        if (query.storePreviousVariables && previousQuery && previousQuery.networkStatus !== $03a288f5350d9e9d$export$bd096ddbd246c79c.loading) {
            if (!(0, $66hGB.equal)(previousQuery.variables, query.variables)) {
                isSetVariables = true;
                previousVariables = previousQuery.variables;
            }
        }
        var networkStatus;
        if (isSetVariables) networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.setVariables;
        else if (query.isPoll) networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.poll;
        else if (query.isRefetch) networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.refetch;
        else networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.loading;
        var graphQLErrors = [];
        if (previousQuery && previousQuery.graphQLErrors) graphQLErrors = previousQuery.graphQLErrors;
        this.store[query.queryId] = {
            document: query.document,
            variables: query.variables,
            previousVariables: previousVariables,
            networkError: null,
            graphQLErrors: graphQLErrors,
            networkStatus: networkStatus,
            metadata: query.metadata
        };
        if (typeof query.fetchMoreForQueryId === 'string' && this.store[query.fetchMoreForQueryId]) this.store[query.fetchMoreForQueryId].networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.fetchMore;
    };
    QueryStore.prototype.markQueryResult = function(queryId, result, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = null;
        this.store[queryId].graphQLErrors = $03a288f5350d9e9d$var$isNonEmptyArray(result.errors) ? result.errors : [];
        this.store[queryId].previousVariables = null;
        this.store[queryId].networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.ready;
        if (typeof fetchMoreForQueryId === 'string' && this.store[fetchMoreForQueryId]) this.store[fetchMoreForQueryId].networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.ready;
    };
    QueryStore.prototype.markQueryError = function(queryId, error, fetchMoreForQueryId) {
        if (!this.store || !this.store[queryId]) return;
        this.store[queryId].networkError = error;
        this.store[queryId].networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.error;
        if (typeof fetchMoreForQueryId === 'string') this.markQueryResultClient(fetchMoreForQueryId, true);
    };
    QueryStore.prototype.markQueryResultClient = function(queryId, complete) {
        var storeValue = this.store && this.store[queryId];
        if (storeValue) {
            storeValue.networkError = null;
            storeValue.previousVariables = null;
            if (complete) storeValue.networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.ready;
        }
    };
    QueryStore.prototype.stopQuery = function(queryId) {
        delete this.store[queryId];
    };
    QueryStore.prototype.reset = function(observableQueryIds) {
        var _this = this;
        Object.keys(this.store).forEach(function(queryId) {
            if (observableQueryIds.indexOf(queryId) < 0) _this.stopQuery(queryId);
            else _this.store[queryId].networkStatus = $03a288f5350d9e9d$export$bd096ddbd246c79c.loading;
        });
    };
    return QueryStore;
}();
function $03a288f5350d9e9d$var$capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}
var $03a288f5350d9e9d$var$LocalState = function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, $42BH7.mergeDeep)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, $42BH7.mergeDeep)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    LocalState.prototype.runResolvers = function(_a) {
        var document = _a.document, remoteResult = _a.remoteResult, context = _a.context, variables = _a.variables, _b = _a.onlyRunForcedResolvers, onlyRunForcedResolvers = _b === void 0 ? false : _b;
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            return (0, $fKE23.__generator)(this, function(_c) {
                if (document) return [
                    2,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    LocalState.prototype.clientQuery = function(document) {
        if ((0, $42BH7.hasDirectives)([
            'client'
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    LocalState.prototype.serverQuery = function(document) {
        return this.resolvers ? (0, $42BH7.removeClientSetsFromDocument)(document) : document;
    };
    LocalState.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var cache = this.cache;
        var newContext = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, context), {
            cache: cache,
            getCacheKey: function(obj) {
                if (cache.config) return cache.config.dataIdFromObject(obj);
                else (0, $8j2fP.invariant)(false, 6);
            }
        });
        return newContext;
    };
    LocalState.prototype.addExportedVariables = function(document, variables, context) {
        if (variables === void 0) variables = {};
        if (context === void 0) context = {};
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            return (0, $fKE23.__generator)(this, function(_a) {
                if (document) return [
                    2,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2,
                    (0, $fKE23.__assign)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, $961BR.visit)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === 'client' && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === 'always' && arg.value.kind === 'BooleanValue' && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, $961BR.BREAK;
                    }
                }
            }
        });
        return forceResolvers;
    };
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, $42BH7.buildQueryFromSelectionSet)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
        if (context === void 0) context = {};
        if (variables === void 0) variables = {};
        if (fragmentMatcher === void 0) fragmentMatcher = function() {
            return true;
        };
        if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            var mainDefinition, fragments, fragmentMap, definitionOperation, defaultOperationType, _a, cache, client, execContext;
            return (0, $fKE23.__generator)(this, function(_b) {
                mainDefinition = (0, $42BH7.getMainDefinition)(document);
                fragments = (0, $42BH7.getFragmentDefinitions)(document);
                fragmentMap = (0, $42BH7.createFragmentMap)(fragments);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? $03a288f5350d9e9d$var$capitalizeFirstLetter(definitionOperation) : 'Query';
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, $fKE23.__assign)((0, $fKE23.__assign)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                return [
                    2,
                    this.resolveSelectionSet(mainDefinition.selectionSet, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, rootValue, execContext) {
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, $fKE23.__generator)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, $fKE23.__awaiter)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, $fKE23.__generator)(this, function(_a) {
                            if (!(0, $42BH7.shouldInclude)(selection, variables)) return [
                                2
                            ];
                            if ((0, $42BH7.isField)(selection)) return [
                                2,
                                this.resolveField(selection, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== 'undefined') resultsToMerge.push((_a = {}, _a[(0, $42BH7.resultKeyNameFromField)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, $42BH7.isInlineFragment)(selection)) fragment = selection;
                            else {
                                fragment = fragmentMap[selection.name.value];
                                (0, $8j2fP.invariant)(fragment, 7);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2,
                                    this.resolveSelectionSet(fragment.selectionSet, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2
                            ];
                        });
                    });
                };
                return [
                    2,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, $42BH7.mergeDeepArray)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, rootValue, execContext) {
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, $fKE23.__generator)(this, function(_a) {
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, $42BH7.resultKeyNameFromField)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve(resolve(rootValue, (0, $42BH7.argumentsObjectFromField)(field, variables), execContext.context, {
                            field: field,
                            fragmentMap: execContext.fragmentMap
                        }));
                    }
                }
                return [
                    2,
                    resultPromise.then(function(result) {
                        if (result === void 0) result = defaultResult;
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === 'export' && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === 'as' && arg.value.kind === 'StringValue') execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        if (!field.selectionSet) return result;
                        if (result == null) return result;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, result, execContext);
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, item, execContext);
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, item, execContext);
        }));
    };
    return LocalState;
}();
function $03a288f5350d9e9d$var$multiplex(inner) {
    var observers = new Set();
    var sub = null;
    return new $03a288f5350d9e9d$var$Observable(function(observer) {
        observers.add(observer);
        sub = sub || inner.subscribe({
            next: function(value) {
                observers.forEach(function(obs) {
                    return obs.next && obs.next(value);
                });
            },
            error: function(error) {
                observers.forEach(function(obs) {
                    return obs.error && obs.error(error);
                });
            },
            complete: function() {
                observers.forEach(function(obs) {
                    return obs.complete && obs.complete();
                });
            }
        });
        return function() {
            if (observers.delete(observer) && !observers.size && sub) {
                sub.unsubscribe();
                sub = null;
            }
        };
    });
}
function $03a288f5350d9e9d$var$asyncMap(observable, mapFn) {
    return new $03a288f5350d9e9d$var$Observable(function(observer) {
        var next = observer.next, error = observer.error, complete = observer.complete;
        var activeNextCount = 0;
        var completed = false;
        var handler = {
            next: function(value) {
                ++activeNextCount;
                new Promise(function(resolve) {
                    resolve(mapFn(value));
                }).then(function(result) {
                    --activeNextCount;
                    next && next.call(observer, result);
                    completed && handler.complete();
                }, function(e) {
                    --activeNextCount;
                    error && error.call(observer, e);
                });
            },
            error: function(e) {
                error && error.call(observer, e);
            },
            complete: function() {
                completed = true;
                if (!activeNextCount) complete && complete.call(observer);
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}
var $03a288f5350d9e9d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $03a288f5350d9e9d$var$QueryManager = function() {
    function QueryManager(_a) {
        var link = _a.link, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, store = _a.store, _c = _a.onBroadcast, onBroadcast = _c === void 0 ? function() {
            return undefined;
        } : _c, _d = _a.ssrMode, ssrMode = _d === void 0 ? false : _d, _e = _a.clientAwareness, clientAwareness = _e === void 0 ? {} : _e, localState = _a.localState, assumeImmutableResults = _a.assumeImmutableResults;
        this.mutationStore = new $03a288f5350d9e9d$var$MutationStore();
        this.queryStore = new $03a288f5350d9e9d$var$QueryStore();
        this.clientAwareness = {};
        this.idCounter = 1;
        this.queries = new Map();
        this.fetchQueryRejectFns = new Map();
        this.transformCache = new ((0, $42BH7.canUseWeakMap) ? WeakMap : Map)();
        this.inFlightLinkObservables = new Map();
        this.pollingInfoByQueryId = new Map();
        this.link = link;
        this.queryDeduplication = queryDeduplication;
        this.dataStore = store;
        this.onBroadcast = onBroadcast;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new $03a288f5350d9e9d$var$LocalState({
            cache: store.getCache()
        });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = !!assumeImmutableResults;
    }
    QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $8j2fP.InvariantError)(8));
        });
    };
    QueryManager.prototype.mutate = function(_a) {
        var mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, updateQueriesByName = _a.updateQueries, _b = _a.refetchQueries, refetchQueries = _b === void 0 ? [] : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, updateWithProxyFn = _a.update, _d = _a.errorPolicy, errorPolicy = _d === void 0 ? 'none' : _d, fetchPolicy = _a.fetchPolicy, _e = _a.context, context = _e === void 0 ? {} : _e;
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            var mutationId, generateUpdateQueriesInfo, self;
            var _this = this;
            return (0, $fKE23.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        (0, $8j2fP.invariant)(mutation, 9);
                        (0, $8j2fP.invariant)(!fetchPolicy || fetchPolicy === 'no-cache', 10);
                        mutationId = this.generateQueryId();
                        mutation = this.transform(mutation).document;
                        this.setQuery(mutationId, function() {
                            return {
                                document: mutation
                            };
                        });
                        variables = this.getVariables(mutation, variables);
                        if (!this.transform(mutation).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _f.sent();
                        _f.label = 2;
                    case 2:
                        generateUpdateQueriesInfo = function() {
                            var ret = {};
                            if (updateQueriesByName) _this.queries.forEach(function(_a, queryId) {
                                var observableQuery = _a.observableQuery;
                                if (observableQuery) {
                                    var queryName = observableQuery.queryName;
                                    if (queryName && $03a288f5350d9e9d$var$hasOwnProperty.call(updateQueriesByName, queryName)) ret[queryId] = {
                                        updater: updateQueriesByName[queryName],
                                        query: _this.queryStore.get(queryId)
                                    };
                                }
                            });
                            return ret;
                        };
                        this.mutationStore.initMutation(mutationId, mutation, variables);
                        this.dataStore.markMutationInit({
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            updateQueries: generateUpdateQueriesInfo(),
                            update: updateWithProxyFn,
                            optimisticResponse: optimisticResponse
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2,
                            new Promise(function(resolve, reject) {
                                var storeResult;
                                var error;
                                self.getObservableFromLink(mutation, (0, $fKE23.__assign)((0, $fKE23.__assign)({}, context), {
                                    optimisticResponse: optimisticResponse
                                }), variables, false).subscribe({
                                    next: function(result) {
                                        if ((0, $42BH7.graphQLResultHasError)(result) && errorPolicy === 'none') {
                                            error = new $03a288f5350d9e9d$export$26a337512320b8c6({
                                                graphQLErrors: result.errors
                                            });
                                            return;
                                        }
                                        self.mutationStore.markMutationResult(mutationId);
                                        if (fetchPolicy !== 'no-cache') self.dataStore.markMutationResult({
                                            mutationId: mutationId,
                                            result: result,
                                            document: mutation,
                                            variables: variables,
                                            updateQueries: generateUpdateQueriesInfo(),
                                            update: updateWithProxyFn
                                        });
                                        storeResult = result;
                                    },
                                    error: function(err) {
                                        self.mutationStore.markMutationError(mutationId, err);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        self.setQuery(mutationId, function() {
                                            return {
                                                document: null
                                            };
                                        });
                                        reject(new $03a288f5350d9e9d$export$26a337512320b8c6({
                                            networkError: err
                                        }));
                                    },
                                    complete: function() {
                                        if (error) self.mutationStore.markMutationError(mutationId, error);
                                        self.dataStore.markMutationComplete({
                                            mutationId: mutationId,
                                            optimisticResponse: optimisticResponse
                                        });
                                        self.broadcastQueries();
                                        if (error) {
                                            reject(error);
                                            return;
                                        }
                                        if (typeof refetchQueries === 'function') refetchQueries = refetchQueries(storeResult);
                                        var refetchQueryPromises = [];
                                        if ($03a288f5350d9e9d$var$isNonEmptyArray(refetchQueries)) refetchQueries.forEach(function(refetchQuery) {
                                            if (typeof refetchQuery === 'string') self.queries.forEach(function(_a) {
                                                var observableQuery = _a.observableQuery;
                                                if (observableQuery && observableQuery.queryName === refetchQuery) refetchQueryPromises.push(observableQuery.refetch());
                                            });
                                            else {
                                                var queryOptions = {
                                                    query: refetchQuery.query,
                                                    variables: refetchQuery.variables,
                                                    fetchPolicy: 'network-only'
                                                };
                                                if (refetchQuery.context) queryOptions.context = refetchQuery.context;
                                                refetchQueryPromises.push(self.query(queryOptions));
                                            }
                                        });
                                        Promise.all(awaitRefetchQueries ? refetchQueryPromises : []).then(function() {
                                            self.setQuery(mutationId, function() {
                                                return {
                                                    document: null
                                                };
                                            });
                                            if (errorPolicy === 'ignore' && storeResult && (0, $42BH7.graphQLResultHasError)(storeResult)) delete storeResult.errors;
                                            resolve(storeResult);
                                        });
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, fetchType, fetchMoreForQueryId) {
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            var _a, metadata, _b, fetchPolicy, _c, context, query, variables, storeResult, isNetworkOnly, needToFetch, _d, complete, result, shouldFetch, requestId, cancel, networkResult;
            var _this = this;
            return (0, $fKE23.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _a = options.metadata, metadata = _a === void 0 ? null : _a, _b = options.fetchPolicy, fetchPolicy = _b === void 0 ? 'cache-first' : _b, _c = options.context, context = _c === void 0 ? {} : _c;
                        query = this.transform(options.query).document;
                        variables = this.getVariables(query, options.variables);
                        if (!this.transform(query).hasClientExports) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            this.localState.addExportedVariables(query, variables, context)
                        ];
                    case 1:
                        variables = _e.sent();
                        _e.label = 2;
                    case 2:
                        options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
                            variables: variables
                        });
                        isNetworkOnly = fetchPolicy === 'network-only' || fetchPolicy === 'no-cache';
                        needToFetch = isNetworkOnly;
                        if (!isNetworkOnly) {
                            _d = this.dataStore.getCache().diff({
                                query: query,
                                variables: variables,
                                returnPartialData: true,
                                optimistic: false
                            }), complete = _d.complete, result = _d.result;
                            needToFetch = !complete || fetchPolicy === 'cache-and-network';
                            storeResult = result;
                        }
                        shouldFetch = needToFetch && fetchPolicy !== 'cache-only' && fetchPolicy !== 'standby';
                        if ((0, $42BH7.hasDirectives)([
                            'live'
                        ], query)) shouldFetch = true;
                        requestId = this.idCounter++;
                        cancel = fetchPolicy !== 'no-cache' ? this.updateQueryWatch(queryId, query, options) : undefined;
                        this.setQuery(queryId, function() {
                            return {
                                document: query,
                                lastRequestId: requestId,
                                invalidated: true,
                                cancel: cancel
                            };
                        });
                        this.invalidate(fetchMoreForQueryId);
                        this.queryStore.initQuery({
                            queryId: queryId,
                            document: query,
                            storePreviousVariables: shouldFetch,
                            variables: variables,
                            isPoll: fetchType === $03a288f5350d9e9d$export$160bafb6ac1e0641.poll,
                            isRefetch: fetchType === $03a288f5350d9e9d$export$160bafb6ac1e0641.refetch,
                            metadata: metadata,
                            fetchMoreForQueryId: fetchMoreForQueryId
                        });
                        this.broadcastQueries();
                        if (shouldFetch) {
                            networkResult = this.fetchRequest({
                                requestId: requestId,
                                queryId: queryId,
                                document: query,
                                options: options,
                                fetchMoreForQueryId: fetchMoreForQueryId
                            }).catch(function(error) {
                                if ($03a288f5350d9e9d$export$17f5e6bd290bb15d(error)) throw error;
                                else {
                                    if (requestId >= _this.getQuery(queryId).lastRequestId) {
                                        _this.queryStore.markQueryError(queryId, error, fetchMoreForQueryId);
                                        _this.invalidate(queryId);
                                        _this.invalidate(fetchMoreForQueryId);
                                        _this.broadcastQueries();
                                    }
                                    throw new $03a288f5350d9e9d$export$26a337512320b8c6({
                                        networkError: error
                                    });
                                }
                            });
                            if (fetchPolicy !== 'cache-and-network') return [
                                2,
                                networkResult
                            ];
                            networkResult.catch(function() {});
                        }
                        this.queryStore.markQueryResultClient(queryId, !shouldFetch);
                        this.invalidate(queryId);
                        this.invalidate(fetchMoreForQueryId);
                        if (this.transform(query).hasForcedResolvers) return [
                            2,
                            this.localState.runResolvers({
                                document: query,
                                remoteResult: {
                                    data: storeResult
                                },
                                context: context,
                                variables: variables,
                                onlyRunForcedResolvers: true
                            }).then(function(result) {
                                _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                                _this.broadcastQueries();
                                return result;
                            })
                        ];
                        this.broadcastQueries();
                        return [
                            2,
                            {
                                data: storeResult
                            }
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markQueryResult = function(queryId, result, _a, fetchMoreForQueryId) {
        var fetchPolicy = _a.fetchPolicy, variables = _a.variables, errorPolicy = _a.errorPolicy;
        if (fetchPolicy === 'no-cache') this.setQuery(queryId, function() {
            return {
                newData: {
                    result: result.data,
                    complete: true
                }
            };
        });
        else this.dataStore.markQueryResult(result, this.getQuery(queryId).document, variables, fetchMoreForQueryId, errorPolicy === 'ignore' || errorPolicy === 'all');
    };
    QueryManager.prototype.queryListenerForObserver = function(queryId, options, observer) {
        var _this = this;
        function invoke(method, argument) {
            if (observer[method]) try {
                observer[method](argument);
            } catch (e) {}
            else method;
        }
        return function(queryStoreValue, newData) {
            _this.invalidate(queryId, false);
            if (!queryStoreValue) return;
            var _a = _this.getQuery(queryId), observableQuery = _a.observableQuery, document = _a.document;
            var fetchPolicy = observableQuery ? observableQuery.options.fetchPolicy : options.fetchPolicy;
            if (fetchPolicy === 'standby') return;
            var loading = $03a288f5350d9e9d$var$isNetworkRequestInFlight(queryStoreValue.networkStatus);
            var lastResult = observableQuery && observableQuery.getLastResult();
            var networkStatusChanged = !!(lastResult && lastResult.networkStatus !== queryStoreValue.networkStatus);
            var shouldNotifyIfLoading = options.returnPartialData || !newData && queryStoreValue.previousVariables || networkStatusChanged && options.notifyOnNetworkStatusChange || fetchPolicy === 'cache-only' || fetchPolicy === 'cache-and-network';
            if (loading && !shouldNotifyIfLoading) return;
            var hasGraphQLErrors = $03a288f5350d9e9d$var$isNonEmptyArray(queryStoreValue.graphQLErrors);
            var errorPolicy = observableQuery && observableQuery.options.errorPolicy || options.errorPolicy || 'none';
            if (errorPolicy === 'none' && hasGraphQLErrors || queryStoreValue.networkError) return invoke('error', new $03a288f5350d9e9d$export$26a337512320b8c6({
                graphQLErrors: queryStoreValue.graphQLErrors,
                networkError: queryStoreValue.networkError
            }));
            try {
                var data = void 0;
                var isMissing = void 0;
                if (newData) {
                    if (fetchPolicy !== 'no-cache' && fetchPolicy !== 'network-only') _this.setQuery(queryId, function() {
                        return {
                            newData: null
                        };
                    });
                    data = newData.result;
                    isMissing = !newData.complete;
                } else {
                    var lastError = observableQuery && observableQuery.getLastError();
                    var errorStatusChanged = errorPolicy !== 'none' && (lastError && lastError.graphQLErrors) !== queryStoreValue.graphQLErrors;
                    if (lastResult && lastResult.data && !errorStatusChanged) {
                        data = lastResult.data;
                        isMissing = false;
                    } else {
                        var diffResult = _this.dataStore.getCache().diff({
                            query: document,
                            variables: queryStoreValue.previousVariables || queryStoreValue.variables,
                            returnPartialData: true,
                            optimistic: true
                        });
                        data = diffResult.result;
                        isMissing = !diffResult.complete;
                    }
                }
                var stale = isMissing && !(options.returnPartialData || fetchPolicy === 'cache-only');
                var resultFromStore = {
                    data: stale ? lastResult && lastResult.data : data,
                    loading: loading,
                    networkStatus: queryStoreValue.networkStatus,
                    stale: stale
                };
                if (errorPolicy === 'all' && hasGraphQLErrors) resultFromStore.errors = queryStoreValue.graphQLErrors;
                invoke('next', resultFromStore);
            } catch (networkError) {
                invoke('error', new $03a288f5350d9e9d$export$26a337512320b8c6({
                    networkError: networkError
                }));
            }
        };
    };
    QueryManager.prototype.transform = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cache = this.dataStore.getCache();
            var transformed = cache.transformDocument(document);
            var forLink = (0, $42BH7.removeConnectionDirectiveFromDocument)(cache.transformForLink(transformed));
            var clientQuery = this.localState.clientQuery(transformed);
            var serverQuery = this.localState.serverQuery(forLink);
            var cacheEntry_1 = {
                document: transformed,
                hasClientExports: (0, $42BH7.hasClientExports)(transformed),
                hasForcedResolvers: this.localState.shouldForceResolvers(transformed),
                clientQuery: clientQuery,
                serverQuery: serverQuery,
                defaultVars: (0, $42BH7.getDefaultValues)((0, $42BH7.getOperationDefinition)(transformed))
            };
            var add = function(doc) {
                if (doc && !transformCache.has(doc)) transformCache.set(doc, cacheEntry_1);
            };
            add(document);
            add(transformed);
            add(clientQuery);
            add(serverQuery);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.transform(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options, shouldSubscribe) {
        if (shouldSubscribe === void 0) shouldSubscribe = true;
        (0, $8j2fP.invariant)(options.fetchPolicy !== 'standby', 11);
        options.variables = this.getVariables(options.query, options.variables);
        if (typeof options.notifyOnNetworkStatusChange === 'undefined') options.notifyOnNetworkStatusChange = false;
        var transformedOptions = (0, $fKE23.__assign)({}, options);
        return new $03a288f5350d9e9d$export$6c1b56eac59c9584({
            queryManager: this,
            options: transformedOptions,
            shouldSubscribe: shouldSubscribe
        });
    };
    QueryManager.prototype.query = function(options) {
        var _this = this;
        (0, $8j2fP.invariant)(options.query, 12);
        (0, $8j2fP.invariant)(options.query.kind === 'Document', 13);
        (0, $8j2fP.invariant)(!options.returnPartialData, 14);
        (0, $8j2fP.invariant)(!options.pollInterval, 15);
        return new Promise(function(resolve, reject) {
            var watchedQuery = _this.watchQuery(options, false);
            _this.fetchQueryRejectFns.set("query:" + watchedQuery.queryId, reject);
            watchedQuery.result().then(resolve, reject).then(function() {
                return _this.fetchQueryRejectFns.delete("query:" + watchedQuery.queryId);
            });
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.idCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        this.stopPollingQuery(queryId);
        this.queryStore.stopQuery(queryId);
        this.invalidate(queryId);
    };
    QueryManager.prototype.addQueryListener = function(queryId, listener) {
        this.setQuery(queryId, function(_a) {
            var listeners = _a.listeners;
            listeners.add(listener);
            return {
                invalidated: false
            };
        });
    };
    QueryManager.prototype.updateQueryWatch = function(queryId, document, options) {
        var _this = this;
        var cancel = this.getQuery(queryId).cancel;
        if (cancel) cancel();
        var previousResult = function() {
            var previousResult = null;
            var observableQuery = _this.getQuery(queryId).observableQuery;
            if (observableQuery) {
                var lastResult = observableQuery.getLastResult();
                if (lastResult) previousResult = lastResult.data;
            }
            return previousResult;
        };
        return this.dataStore.getCache().watch({
            query: document,
            variables: options.variables,
            optimistic: true,
            previousResult: previousResult,
            callback: function(newData) {
                _this.setQuery(queryId, function() {
                    return {
                        invalidated: true,
                        newData: newData
                    };
                });
            }
        });
    };
    QueryManager.prototype.addObservableQuery = function(queryId, observableQuery) {
        this.setQuery(queryId, function() {
            return {
                observableQuery: observableQuery
            };
        });
    };
    QueryManager.prototype.removeObservableQuery = function(queryId) {
        var cancel = this.getQuery(queryId).cancel;
        this.setQuery(queryId, function() {
            return {
                observableQuery: null
            };
        });
        if (cancel) cancel();
    };
    QueryManager.prototype.clearStore = function() {
        this.fetchQueryRejectFns.forEach(function(reject) {
            reject(new (0, $8j2fP.InvariantError)(16));
        });
        var resetIds = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) resetIds.push(queryId);
        });
        this.queryStore.reset(resetIds);
        this.mutationStore.reset();
        return this.dataStore.reset();
    };
    QueryManager.prototype.resetStore = function() {
        var _this = this;
        return this.clearStore().then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.queries.forEach(function(_a, queryId) {
            var observableQuery = _a.observableQuery;
            if (observableQuery) {
                var fetchPolicy = observableQuery.options.fetchPolicy;
                observableQuery.resetLastResults();
                if (fetchPolicy !== 'cache-only' && (includeStandby || fetchPolicy !== 'standby')) observableQueryPromises.push(observableQuery.refetch());
                _this.setQuery(queryId, function() {
                    return {
                        newData: null
                    };
                });
                _this.invalidate(queryId);
            }
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.observeQuery = function(queryId, options, observer) {
        this.addQueryListener(queryId, this.queryListenerForObserver(queryId, options, observer));
        return this.fetchQuery(queryId, options);
    };
    QueryManager.prototype.startQuery = function(queryId, options, listener) {
        this.addQueryListener(queryId, listener);
        this.fetchQuery(queryId, options).catch(function() {
            return undefined;
        });
        return queryId;
    };
    QueryManager.prototype.startGraphQLSubscription = function(_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, variables = _a.variables;
        query = this.transform(query).document;
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, {}, variables, false).map(function(result) {
                if (!fetchPolicy || fetchPolicy !== 'no-cache') {
                    _this.dataStore.markSubscriptionResult(result, query, variables);
                    _this.broadcastQueries();
                }
                if ((0, $42BH7.graphQLResultHasError)(result)) throw new $03a288f5350d9e9d$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                });
                return result;
            });
        };
        if (this.transform(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables).then(makeObservable);
            return new $03a288f5350d9e9d$var$Observable(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        this.fetchQueryRejectFns.delete("query:" + queryId);
        this.fetchQueryRejectFns.delete("fetchRequest:" + queryId);
        this.getQuery(queryId).subscriptions.forEach(function(x) {
            return x.unsubscribe();
        });
        this.queries.delete(queryId);
    };
    QueryManager.prototype.getCurrentQueryResult = function(observableQuery, optimistic) {
        if (optimistic === void 0) optimistic = true;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query, fetchPolicy = _a.fetchPolicy, returnPartialData = _a.returnPartialData;
        var lastResult = observableQuery.getLastResult();
        var newData = this.getQuery(observableQuery.queryId).newData;
        if (newData && newData.complete) return {
            data: newData.result,
            partial: false
        };
        if (fetchPolicy === 'no-cache' || fetchPolicy === 'network-only') return {
            data: undefined,
            partial: false
        };
        var _b = this.dataStore.getCache().diff({
            query: query,
            variables: variables,
            previousResult: lastResult ? lastResult.data : undefined,
            returnPartialData: true,
            optimistic: optimistic
        }), result = _b.result, complete = _b.complete;
        return {
            data: complete || returnPartialData ? result : void 0,
            partial: !complete
        };
    };
    QueryManager.prototype.getQueryWithPreviousResult = function(queryIdOrObservable) {
        var observableQuery;
        if (typeof queryIdOrObservable === 'string') {
            var foundObserveableQuery = this.getQuery(queryIdOrObservable).observableQuery;
            (0, $8j2fP.invariant)(foundObserveableQuery, 17);
            observableQuery = foundObserveableQuery;
        } else observableQuery = queryIdOrObservable;
        var _a = observableQuery.options, variables = _a.variables, query = _a.query;
        return {
            previousResult: this.getCurrentQueryResult(observableQuery, false).data,
            variables: variables,
            document: query
        };
    };
    QueryManager.prototype.broadcastQueries = function() {
        var _this = this;
        this.onBroadcast();
        this.queries.forEach(function(info, id) {
            if (info.invalidated) info.listeners.forEach(function(listener) {
                if (listener) listener(_this.queryStore.get(id), info.newData);
            });
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, deduplication) {
        var _this = this;
        if (deduplication === void 0) deduplication = this.queryDeduplication;
        var observable;
        var serverQuery = this.transform(query).serverQuery;
        if (serverQuery) {
            var _a = this, inFlightLinkObservables_1 = _a.inFlightLinkObservables, link = _a.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, $42BH7.getOperationName)(serverQuery) || void 0,
                context: this.prepareContext((0, $fKE23.__assign)((0, $fKE23.__assign)({}, context), {
                    forceFetch: !deduplication
                }))
            };
            context = operation.context;
            if (deduplication) {
                var byVariables_1 = inFlightLinkObservables_1.get(serverQuery) || new Map();
                inFlightLinkObservables_1.set(serverQuery, byVariables_1);
                var varJson_1 = JSON.stringify(variables);
                observable = byVariables_1.get(varJson_1);
                if (!observable) {
                    byVariables_1.set(varJson_1, observable = $03a288f5350d9e9d$var$multiplex((0, $bvQX6.execute)(link, operation)));
                    var cleanup = function() {
                        byVariables_1.delete(varJson_1);
                        if (!byVariables_1.size) inFlightLinkObservables_1.delete(serverQuery);
                        cleanupSub_1.unsubscribe();
                    };
                    var cleanupSub_1 = observable.subscribe({
                        next: cleanup,
                        error: cleanup,
                        complete: cleanup
                    });
                }
            } else observable = $03a288f5350d9e9d$var$multiplex((0, $bvQX6.execute)(link, operation));
        } else {
            observable = $03a288f5350d9e9d$var$Observable.of({
                data: {}
            });
            context = this.prepareContext(context);
        }
        var clientQuery = this.transform(query).clientQuery;
        if (clientQuery) observable = $03a288f5350d9e9d$var$asyncMap(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.fetchRequest = function(_a) {
        var _this = this;
        var requestId = _a.requestId, queryId = _a.queryId, document = _a.document, options = _a.options, fetchMoreForQueryId = _a.fetchMoreForQueryId;
        var variables = options.variables, _b = options.errorPolicy, errorPolicy = _b === void 0 ? 'none' : _b, fetchPolicy = options.fetchPolicy;
        var resultFromStore;
        var errorsFromStore;
        return new Promise(function(resolve, reject) {
            var observable = _this.getObservableFromLink(document, options.context, variables);
            var fqrfId = "fetchRequest:" + queryId;
            _this.fetchQueryRejectFns.set(fqrfId, reject);
            var cleanup = function() {
                _this.fetchQueryRejectFns.delete(fqrfId);
                _this.setQuery(queryId, function(_a) {
                    var subscriptions = _a.subscriptions;
                    subscriptions.delete(subscription);
                });
            };
            var subscription = observable.map(function(result) {
                if (requestId >= _this.getQuery(queryId).lastRequestId) {
                    _this.markQueryResult(queryId, result, options, fetchMoreForQueryId);
                    _this.queryStore.markQueryResult(queryId, result, fetchMoreForQueryId);
                    _this.invalidate(queryId);
                    _this.invalidate(fetchMoreForQueryId);
                    _this.broadcastQueries();
                }
                if (errorPolicy === 'none' && $03a288f5350d9e9d$var$isNonEmptyArray(result.errors)) return reject(new $03a288f5350d9e9d$export$26a337512320b8c6({
                    graphQLErrors: result.errors
                }));
                if (errorPolicy === 'all') errorsFromStore = result.errors;
                if (fetchMoreForQueryId || fetchPolicy === 'no-cache') resultFromStore = result.data;
                else {
                    var _a = _this.dataStore.getCache().diff({
                        variables: variables,
                        query: document,
                        optimistic: false,
                        returnPartialData: true
                    }), result_1 = _a.result, complete = _a.complete;
                    if (complete || options.returnPartialData) resultFromStore = result_1;
                }
            }).subscribe({
                error: function(error) {
                    cleanup();
                    reject(error);
                },
                complete: function() {
                    cleanup();
                    resolve({
                        data: resultFromStore,
                        errors: errorsFromStore,
                        loading: false,
                        networkStatus: $03a288f5350d9e9d$export$bd096ddbd246c79c.ready,
                        stale: false
                    });
                }
            });
            _this.setQuery(queryId, function(_a) {
                var subscriptions = _a.subscriptions;
                subscriptions.add(subscription);
            });
        });
    };
    QueryManager.prototype.getQuery = function(queryId) {
        return this.queries.get(queryId) || {
            listeners: new Set(),
            invalidated: false,
            document: null,
            newData: null,
            lastRequestId: 1,
            observableQuery: null,
            subscriptions: new Set()
        };
    };
    QueryManager.prototype.setQuery = function(queryId, updater) {
        var prev = this.getQuery(queryId);
        var newInfo = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, prev), updater(prev));
        this.queries.set(queryId, newInfo);
    };
    QueryManager.prototype.invalidate = function(queryId, invalidated) {
        if (invalidated === void 0) invalidated = true;
        if (queryId) this.setQuery(queryId, function() {
            return {
                invalidated: invalidated
            };
        });
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    QueryManager.prototype.checkInFlight = function(queryId) {
        var query = this.queryStore.get(queryId);
        return query && query.networkStatus !== $03a288f5350d9e9d$export$bd096ddbd246c79c.ready && query.networkStatus !== $03a288f5350d9e9d$export$bd096ddbd246c79c.error;
    };
    QueryManager.prototype.startPollingQuery = function(options, queryId, listener) {
        var _this = this;
        var pollInterval = options.pollInterval;
        (0, $8j2fP.invariant)(pollInterval, 18);
        if (!this.ssrMode) {
            var info = this.pollingInfoByQueryId.get(queryId);
            if (!info) this.pollingInfoByQueryId.set(queryId, info = {});
            info.interval = pollInterval;
            info.options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
                fetchPolicy: 'network-only'
            });
            var maybeFetch_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    if (_this.checkInFlight(queryId)) poll_1();
                    else _this.fetchQuery(queryId, info.options, $03a288f5350d9e9d$export$160bafb6ac1e0641.poll).then(poll_1, poll_1);
                }
            };
            var poll_1 = function() {
                var info = _this.pollingInfoByQueryId.get(queryId);
                if (info) {
                    clearTimeout(info.timeout);
                    info.timeout = setTimeout(maybeFetch_1, info.interval);
                }
            };
            if (listener) this.addQueryListener(queryId, listener);
            poll_1();
        }
        return queryId;
    };
    QueryManager.prototype.stopPollingQuery = function(queryId) {
        this.pollingInfoByQueryId.delete(queryId);
    };
    return QueryManager;
}();
var $03a288f5350d9e9d$var$DataStore = function() {
    function DataStore(initialCache) {
        this.cache = initialCache;
    }
    DataStore.prototype.getCache = function() {
        return this.cache;
    };
    DataStore.prototype.markQueryResult = function(result, document, variables, fetchMoreForQueryId, ignoreErrors) {
        if (ignoreErrors === void 0) ignoreErrors = false;
        var writeWithErrors = !(0, $42BH7.graphQLResultHasError)(result);
        if (ignoreErrors && (0, $42BH7.graphQLResultHasError)(result) && result.data) writeWithErrors = true;
        if (!fetchMoreForQueryId && writeWithErrors) this.cache.write({
            result: result.data,
            dataId: 'ROOT_QUERY',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markSubscriptionResult = function(result, document, variables) {
        if (!(0, $42BH7.graphQLResultHasError)(result)) this.cache.write({
            result: result.data,
            dataId: 'ROOT_SUBSCRIPTION',
            query: document,
            variables: variables
        });
    };
    DataStore.prototype.markMutationInit = function(mutation) {
        var _this = this;
        if (mutation.optimisticResponse) {
            var optimistic_1;
            if (typeof mutation.optimisticResponse === 'function') optimistic_1 = mutation.optimisticResponse(mutation.variables);
            else optimistic_1 = mutation.optimisticResponse;
            this.cache.recordOptimisticTransaction(function(c) {
                var orig = _this.cache;
                _this.cache = c;
                try {
                    _this.markMutationResult({
                        mutationId: mutation.mutationId,
                        result: {
                            data: optimistic_1
                        },
                        document: mutation.document,
                        variables: mutation.variables,
                        updateQueries: mutation.updateQueries,
                        update: mutation.update
                    });
                } finally{
                    _this.cache = orig;
                }
            }, mutation.mutationId);
        }
    };
    DataStore.prototype.markMutationResult = function(mutation) {
        var _this = this;
        if (!(0, $42BH7.graphQLResultHasError)(mutation.result)) {
            var cacheWrites_1 = [
                {
                    result: mutation.result.data,
                    dataId: 'ROOT_MUTATION',
                    query: mutation.document,
                    variables: mutation.variables
                }
            ];
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) Object.keys(updateQueries_1).forEach(function(id) {
                var _a = updateQueries_1[id], query = _a.query, updater = _a.updater;
                var _b = _this.cache.diff({
                    query: query.document,
                    variables: query.variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _b.result, complete = _b.complete;
                if (complete) {
                    var nextQueryResult = (0, $42BH7.tryFunctionOrLogError)(function() {
                        return updater(currentQueryResult, {
                            mutationResult: mutation.result,
                            queryName: (0, $42BH7.getOperationName)(query.document) || undefined,
                            queryVariables: query.variables
                        });
                    });
                    if (nextQueryResult) cacheWrites_1.push({
                        result: nextQueryResult,
                        dataId: 'ROOT_QUERY',
                        query: query.document,
                        variables: query.variables
                    });
                }
            });
            this.cache.performTransaction(function(c) {
                cacheWrites_1.forEach(function(write) {
                    return c.write(write);
                });
                var update = mutation.update;
                if (update) (0, $42BH7.tryFunctionOrLogError)(function() {
                    return update(c, mutation.result);
                });
            });
        }
    };
    DataStore.prototype.markMutationComplete = function(_a) {
        var mutationId = _a.mutationId, optimisticResponse = _a.optimisticResponse;
        if (optimisticResponse) this.cache.removeOptimistic(mutationId);
    };
    DataStore.prototype.markUpdateQueryResult = function(document, variables, newResult) {
        this.cache.write({
            result: newResult,
            dataId: 'ROOT_QUERY',
            variables: variables,
            query: document
        });
    };
    DataStore.prototype.reset = function() {
        return this.cache.reset();
    };
    return DataStore;
}();
var $03a288f5350d9e9d$var$version = "2.6.10";
var $03a288f5350d9e9d$var$hasSuggestedDevtools = false;
var $03a288f5350d9e9d$export$13f5a5f0f1dbab88 = function() {
    function ApolloClient(options) {
        var _this = this;
        this.defaultOptions = {};
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        var cache = options.cache, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, connectToDevTools = options.connectToDevTools, _c = options.queryDeduplication, queryDeduplication = _c === void 0 ? true : _c, defaultOptions = options.defaultOptions, _d = options.assumeImmutableResults, assumeImmutableResults = _d === void 0 ? false : _d, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link && resolvers) link = (0, $bvQX6.ApolloLink).empty();
        if (!link || !cache) throw new (0, $8j2fP.InvariantError)(4);
        this.link = link;
        this.cache = cache;
        this.store = new $03a288f5350d9e9d$var$DataStore(cache);
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || {};
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        var defaultConnectToDevTools = false;
        if (typeof connectToDevTools === 'undefined' ? defaultConnectToDevTools : connectToDevTools && typeof window !== 'undefined') window.__APOLLO_CLIENT__ = this;
        this.version = $03a288f5350d9e9d$var$version;
        this.localState = new $03a288f5350d9e9d$var$LocalState({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new $03a288f5350d9e9d$var$QueryManager({
            link: this.link,
            store: this.store,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.queryStore.getStore(),
                        mutations: _this.queryManager.mutationStore.getStore()
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            }
        });
    }
    ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.defaultOptions.watchQuery), options);
        if (this.disableNetworkFetches && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.watchQuery(options);
    };
    ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.defaultOptions.query), options);
        (0, $8j2fP.invariant)(options.fetchPolicy !== 'cache-and-network', 5);
        if (this.disableNetworkFetches && options.fetchPolicy === 'network-only') options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            fetchPolicy: 'cache-first'
        });
        return this.queryManager.query(options);
    };
    ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.defaultOptions.mutate), options);
        return this.queryManager.mutate(options);
    };
    ApolloClient.prototype.subscribe = function(options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    ApolloClient.prototype.writeQuery = function(options) {
        var result = this.cache.writeQuery(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeFragment = function(options) {
        var result = this.cache.writeFragment(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.writeData = function(options) {
        var result = this.cache.writeData(options);
        this.queryManager.broadcastQueries();
        return result;
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, $bvQX6.execute)(this.link, payload);
    };
    ApolloClient.prototype.initQueryManager = function() {
        return this.queryManager;
    };
    ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore();
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    return ApolloClient;
}();
var $03a288f5350d9e9d$export$2e2bcd8739ae039 = $03a288f5350d9e9d$export$13f5a5f0f1dbab88;

});
parcelRegister("bvQX6", function(module, exports) {

$parcel$export(module.exports, "makePromise", () => makePromise);
$parcel$export(module.exports, "fromError", () => fromError);
$parcel$export(module.exports, "ApolloLink", () => ApolloLink);
$parcel$export(module.exports, "from", () => from);
$parcel$export(module.exports, "split", () => split);
$parcel$export(module.exports, "execute", () => execute);
$parcel$export(module.exports, "Observable", () => (parcelRequire("5ECju")).default);

var $5ECju = parcelRequire("5ECju");

var $8j2fP = parcelRequire("8j2fP");

var $fKE23 = parcelRequire("fKE23");

var $42BH7 = parcelRequire("42BH7");
function validateOperation(operation) {
    var OPERATION_FIELDS = [
        'query',
        'operationName',
        'variables',
        'extensions',
        'context'
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw new (0, $8j2fP.InvariantError)(2);
    }
    return operation;
}
var LinkError = function(_super) {
    (0, $fKE23.__extends)(LinkError, _super);
    function LinkError(message, link) {
        var _this = _super.call(this, message) || this;
        _this.link = link;
        return _this;
    }
    return LinkError;
}(Error);
function isTerminating(link) {
    return link.request.length <= 1;
}
function toPromise(observable) {
    var completed = false;
    return new Promise(function(resolve, reject) {
        observable.subscribe({
            next: function(data) {
                if (completed) ;
                else {
                    completed = true;
                    resolve(data);
                }
            },
            error: reject
        });
    });
}
var makePromise = toPromise;
function fromPromise(promise) {
    return new (0, $5ECju.default)(function(observer) {
        promise.then(function(value) {
            observer.next(value);
            observer.complete();
        }).catch(observer.error.bind(observer));
    });
}
function fromError(errorValue) {
    return new (0, $5ECju.default)(function(observer) {
        observer.error(errorValue);
    });
}
function transformOperation(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== 'string' ? (0, $42BH7.getOperationName)(transformedOperation.query) : '';
    return transformedOperation;
}
function createOperation(starting, operation) {
    var context = (0, $fKE23.__assign)({}, starting);
    var setContext = function(next) {
        if (typeof next === 'function') context = (0, $fKE23.__assign)({}, context, next(context));
        else context = (0, $fKE23.__assign)({}, context, next);
    };
    var getContext = function() {
        return (0, $fKE23.__assign)({}, context);
    };
    Object.defineProperty(operation, 'setContext', {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, 'getContext', {
        enumerable: false,
        value: getContext
    });
    Object.defineProperty(operation, 'toKey', {
        enumerable: false,
        value: function() {
            return getKey(operation);
        }
    });
    return operation;
}
function getKey(operation) {
    var query = operation.query, variables = operation.variables, operationName = operation.operationName;
    return JSON.stringify([
        operationName,
        query,
        variables
    ]);
}
function passthrough(op, forward) {
    return forward ? forward(op) : (0, $5ECju.default).of();
}
function toLink(handler) {
    return typeof handler === 'function' ? new ApolloLink(handler) : handler;
}
function empty() {
    return new ApolloLink(function() {
        return (0, $5ECju.default).of();
    });
}
function from(links) {
    if (links.length === 0) return empty();
    return links.map(toLink).reduce(function(x, y) {
        return x.concat(y);
    });
}
function split(test, left, right) {
    var leftLink = toLink(left);
    var rightLink = toLink(right || new ApolloLink(passthrough));
    if (isTerminating(leftLink) && isTerminating(rightLink)) return new ApolloLink(function(operation) {
        return test(operation) ? leftLink.request(operation) || (0, $5ECju.default).of() : rightLink.request(operation) || (0, $5ECju.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return test(operation) ? leftLink.request(operation, forward) || (0, $5ECju.default).of() : rightLink.request(operation, forward) || (0, $5ECju.default).of();
    });
}
var concat = function(first, second) {
    var firstLink = toLink(first);
    if (isTerminating(firstLink)) return firstLink;
    var nextLink = toLink(second);
    if (isTerminating(nextLink)) return new ApolloLink(function(operation) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op) || (0, $5ECju.default).of();
        }) || (0, $5ECju.default).of();
    });
    else return new ApolloLink(function(operation, forward) {
        return firstLink.request(operation, function(op) {
            return nextLink.request(op, forward) || (0, $5ECju.default).of();
        }) || (0, $5ECju.default).of();
    });
};
var ApolloLink = function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(split(test, left, right || new ApolloLink(passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw new (0, $8j2fP.InvariantError)(1);
    };
    ApolloLink.empty = empty;
    ApolloLink.from = from;
    ApolloLink.split = split;
    ApolloLink.execute = execute;
    return ApolloLink;
}();
function execute(link, operation) {
    return link.request(createOperation(operation.context, transformOperation(validateOperation(operation)))) || (0, $5ECju.default).of();
}

});
parcelRegister("5ECju", function(module, exports) {

$parcel$export(module.exports, "default", () => $41de6865c2ff0290$export$2e2bcd8739ae039);

var $1eC02 = parcelRequire("1eC02");
var $41de6865c2ff0290$export$77cea355fa80b5f4 = (0, (/*@__PURE__*/$parcel$interopDefault($1eC02)));
var $41de6865c2ff0290$export$2e2bcd8739ae039 = $41de6865c2ff0290$export$77cea355fa80b5f4;

});
parcelRegister("1eC02", function(module, exports) {

module.exports = (parcelRequire("bhbKH")).Observable;

});
parcelRegister("bhbKH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Observable = void 0;
function $835a65fddbd60374$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $835a65fddbd60374$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $835a65fddbd60374$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $835a65fddbd60374$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $835a65fddbd60374$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
// === Symbol Support ===
var $835a65fddbd60374$var$hasSymbols = function() {
    return typeof Symbol === 'function';
};
var $835a65fddbd60374$var$hasSymbol = function(name) {
    return $835a65fddbd60374$var$hasSymbols() && Boolean(Symbol[name]);
};
var $835a65fddbd60374$var$getSymbol = function(name) {
    return $835a65fddbd60374$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
};
if ($835a65fddbd60374$var$hasSymbols() && !$835a65fddbd60374$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
var $835a65fddbd60374$var$SymbolIterator = $835a65fddbd60374$var$getSymbol('iterator');
var $835a65fddbd60374$var$SymbolObservable = $835a65fddbd60374$var$getSymbol('observable');
var $835a65fddbd60374$var$SymbolSpecies = $835a65fddbd60374$var$getSymbol('species'); // === Abstract Operations ===
function $835a65fddbd60374$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function $835a65fddbd60374$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$835a65fddbd60374$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $835a65fddbd60374$var$Observable;
}
function $835a65fddbd60374$var$isObservable(x) {
    return x instanceof $835a65fddbd60374$var$Observable; // SPEC: Brand check
}
function $835a65fddbd60374$var$hostReportError(e) {
    if ($835a65fddbd60374$var$hostReportError.log) $835a65fddbd60374$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $835a65fddbd60374$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $835a65fddbd60374$var$hostReportError(e);
        }
    });
}
function $835a65fddbd60374$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            var unsubscribe = $835a65fddbd60374$var$getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $835a65fddbd60374$var$hostReportError(e);
    }
}
function $835a65fddbd60374$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function $835a65fddbd60374$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(var i = 0; i < queue.length; ++i){
        $835a65fddbd60374$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function $835a65fddbd60374$var$notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    var observer = subscription._observer;
    try {
        var m = $835a65fddbd60374$var$getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                $835a65fddbd60374$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                $835a65fddbd60374$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $835a65fddbd60374$var$hostReportError(e);
    }
    if (subscription._state === 'closed') $835a65fddbd60374$var$cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function $835a65fddbd60374$var$onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $835a65fddbd60374$var$enqueue(function() {
            return $835a65fddbd60374$var$flushSubscription(subscription);
        });
        return;
    }
    $835a65fddbd60374$var$notifySubscription(subscription, type, value);
}
var $835a65fddbd60374$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        $835a65fddbd60374$var$_classCallCheck(this, Subscription);
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        var subscriptionObserver = new $835a65fddbd60374$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    $835a65fddbd60374$var$_createClass(Subscription, [
        {
            key: "unsubscribe",
            value: function unsubscribe() {
                if (this._state !== 'closed') {
                    $835a65fddbd60374$var$closeSubscription(this);
                    $835a65fddbd60374$var$cleanupSubscription(this);
                }
            }
        },
        {
            key: "closed",
            get: function() {
                return this._state === 'closed';
            }
        }
    ]);
    return Subscription;
}();
var $835a65fddbd60374$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        $835a65fddbd60374$var$_classCallCheck(this, SubscriptionObserver);
        this._subscription = subscription;
    }
    $835a65fddbd60374$var$_createClass(SubscriptionObserver, [
        {
            key: "next",
            value: function next(value) {
                $835a65fddbd60374$var$onNotify(this._subscription, 'next', value);
            }
        },
        {
            key: "error",
            value: function error(value) {
                $835a65fddbd60374$var$onNotify(this._subscription, 'error', value);
            }
        },
        {
            key: "complete",
            value: function complete() {
                $835a65fddbd60374$var$onNotify(this._subscription, 'complete');
            }
        },
        {
            key: "closed",
            get: function() {
                return this._subscription._state === 'closed';
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $835a65fddbd60374$var$Observable = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        $835a65fddbd60374$var$_classCallCheck(this, Observable);
        if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    $835a65fddbd60374$var$_createClass(Observable, [
        {
            key: "subscribe",
            value: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) observer = {
                    next: observer,
                    error: arguments[1],
                    complete: arguments[2]
                };
                return new $835a65fddbd60374$var$Subscription(observer, this._subscriber);
            }
        },
        {
            key: "forEach",
            value: function forEach(fn) {
                var _this = this;
                return new Promise(function(resolve, reject) {
                    if (typeof fn !== 'function') {
                        reject(new TypeError(fn + ' is not a function'));
                        return;
                    }
                    function done() {
                        subscription.unsubscribe();
                        resolve();
                    }
                    var subscription = _this.subscribe({
                        next: function(value) {
                            try {
                                fn(value, done);
                            } catch (e) {
                                reject(e);
                                subscription.unsubscribe();
                            }
                        },
                        error: reject,
                        complete: resolve
                    });
                });
            }
        },
        {
            key: "map",
            value: function map(fn) {
                var _this2 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $835a65fddbd60374$var$getSpecies(this);
                return new C(function(observer) {
                    return _this2.subscribe({
                        next: function(value) {
                            try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "filter",
            value: function filter(fn) {
                var _this3 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $835a65fddbd60374$var$getSpecies(this);
                return new C(function(observer) {
                    return _this3.subscribe({
                        next: function(value) {
                            try {
                                if (!fn(value)) return;
                            } catch (e) {
                                return observer.error(e);
                            }
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "reduce",
            value: function reduce(fn) {
                var _this4 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $835a65fddbd60374$var$getSpecies(this);
                var hasSeed = arguments.length > 1;
                var hasValue = false;
                var seed = arguments[1];
                var acc = seed;
                return new C(function(observer) {
                    return _this4.subscribe({
                        next: function(value) {
                            var first = !hasValue;
                            hasValue = true;
                            if (!first || hasSeed) try {
                                acc = fn(acc, value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            else acc = value;
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                            observer.next(acc);
                            observer.complete();
                        }
                    });
                });
            }
        },
        {
            key: "concat",
            value: function concat() {
                var _this5 = this;
                for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
                var C = $835a65fddbd60374$var$getSpecies(this);
                return new C(function(observer) {
                    var subscription;
                    var index = 0;
                    function startNext(next) {
                        subscription = next.subscribe({
                            next: function(v) {
                                observer.next(v);
                            },
                            error: function(e) {
                                observer.error(e);
                            },
                            complete: function() {
                                if (index === sources.length) {
                                    subscription = undefined;
                                    observer.complete();
                                } else startNext(C.from(sources[index++]));
                            }
                        });
                    }
                    startNext(_this5);
                    return function() {
                        if (subscription) {
                            subscription.unsubscribe();
                            subscription = undefined;
                        }
                    };
                });
            }
        },
        {
            key: "flatMap",
            value: function flatMap(fn) {
                var _this6 = this;
                if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
                var C = $835a65fddbd60374$var$getSpecies(this);
                return new C(function(observer) {
                    var subscriptions = [];
                    var outer = _this6.subscribe({
                        next: function(value) {
                            if (fn) try {
                                value = fn(value);
                            } catch (e) {
                                return observer.error(e);
                            }
                            var inner = C.from(value).subscribe({
                                next: function(value) {
                                    observer.next(value);
                                },
                                error: function(e) {
                                    observer.error(e);
                                },
                                complete: function() {
                                    var i = subscriptions.indexOf(inner);
                                    if (i >= 0) subscriptions.splice(i, 1);
                                    completeIfDone();
                                }
                            });
                            subscriptions.push(inner);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            completeIfDone();
                        }
                    });
                    function completeIfDone() {
                        if (outer.closed && subscriptions.length === 0) observer.complete();
                    }
                    return function() {
                        subscriptions.forEach(function(s) {
                            return s.unsubscribe();
                        });
                        outer.unsubscribe();
                    };
                });
            }
        },
        {
            key: $835a65fddbd60374$var$SymbolObservable,
            value: function() {
                return this;
            }
        }
    ], [
        {
            key: "from",
            value: function from(x) {
                var C = typeof this === 'function' ? this : Observable;
                if (x == null) throw new TypeError(x + ' is not an object');
                var method = $835a65fddbd60374$var$getMethod(x, $835a65fddbd60374$var$SymbolObservable);
                if (method) {
                    var observable = method.call(x);
                    if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
                    if ($835a65fddbd60374$var$isObservable(observable) && observable.constructor === C) return observable;
                    return new C(function(observer) {
                        return observable.subscribe(observer);
                    });
                }
                if ($835a65fddbd60374$var$hasSymbol('iterator')) {
                    method = $835a65fddbd60374$var$getMethod(x, $835a65fddbd60374$var$SymbolIterator);
                    if (method) return new C(function(observer) {
                        $835a65fddbd60374$var$enqueue(function() {
                            if (observer.closed) return;
                            var _iteratorNormalCompletion = true;
                            var _didIteratorError = false;
                            var _iteratorError = undefined;
                            try {
                                for(var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _item = _step.value;
                                    observer.next(_item);
                                    if (observer.closed) return;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
                                } finally{
                                    if (_didIteratorError) throw _iteratorError;
                                }
                            }
                            observer.complete();
                        });
                    });
                }
                if (Array.isArray(x)) return new C(function(observer) {
                    $835a65fddbd60374$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < x.length; ++i){
                            observer.next(x[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
                throw new TypeError(x + ' is not observable');
            }
        },
        {
            key: "of",
            value: function of() {
                for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
                var C = typeof this === 'function' ? this : Observable;
                return new C(function(observer) {
                    $835a65fddbd60374$var$enqueue(function() {
                        if (observer.closed) return;
                        for(var i = 0; i < items.length; ++i){
                            observer.next(items[i]);
                            if (observer.closed) return;
                        }
                        observer.complete();
                    });
                });
            }
        },
        {
            key: $835a65fddbd60374$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
module.exports.Observable = $835a65fddbd60374$var$Observable;
if ($835a65fddbd60374$var$hasSymbols()) Object.defineProperty($835a65fddbd60374$var$Observable, Symbol('extensions'), {
    value: {
        symbol: $835a65fddbd60374$var$SymbolObservable,
        hostReportError: $835a65fddbd60374$var$hostReportError
    },
    configurable: true
});

});





parcelRegister("aqG9W", function(module, exports) {

$parcel$export(module.exports, "onError", () => $797d090cd04ee84b$export$2288787135a8f66e);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");
var $5ECju = parcelRequire("5ECju");
function $797d090cd04ee84b$export$2288787135a8f66e(errorHandler) {
    return new (0, $bvQX6.ApolloLink)(function(operation, forward) {
        return new (0, $5ECju.default)(function(observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function(result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function(networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError && networkError.result && networkError.result.errors,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function() {
                        if (!retriedResult) observer.complete.bind(observer)();
                    }
                });
            } catch (e) {
                errorHandler({
                    networkError: e,
                    operation: operation,
                    forward: forward
                });
                observer.error(e);
            }
            return function() {
                if (sub) sub.unsubscribe();
                if (retriedSub) sub.unsubscribe();
            };
        });
    });
}
var $797d090cd04ee84b$export$d2c8415987899609 = function(_super) {
    (0, $fKE23.__extends)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = $797d090cd04ee84b$export$2288787135a8f66e(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}((0, $bvQX6.ApolloLink));

});

parcelRegister("35Kb7", function(module, exports) {

$parcel$export(module.exports, "HttpLink", () => $2405a8c9bbd1579c$export$f4bbf1aec241cc1);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");
var $5ECju = parcelRequire("5ECju");

var $cp9eN = parcelRequire("cp9eN");
var $2405a8c9bbd1579c$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, abortErrorDoesNotCauseError = linkOptions.abortErrorDoesNotCauseError, requestOptions = (0, $fKE23.__rest)(linkOptions, [
        "uri",
        "fetch",
        "includeExtensions",
        "useGETForQueries",
        "abortErrorDoesNotCauseError"
    ]);
    (0, $cp9eN.checkFetcher)(fetcher);
    if (!fetcher) fetcher = fetch;
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $bvQX6.ApolloLink)(function(operation) {
        var chosenURI = (0, $cp9eN.selectURI)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
            if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
        }
        var contextHeaders = (0, $fKE23.__assign)({}, clientAwarenessHeaders, context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        var _b = (0, $cp9eN.selectHttpOptionsAndBody)(operation, (0, $cp9eN.fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
        var controller;
        if (!options.signal) {
            var _c = (0, $cp9eN.createSignalIfSupported)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller) options.signal = signal;
        }
        var definitionIsMutation = function(d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
        if (options.method === 'GET') {
            var _d = $2405a8c9bbd1579c$var$rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) return (0, $bvQX6.fromError)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $cp9eN.serializeFetchParameter)(body, 'Payload');
        } catch (parseError) {
            return (0, $bvQX6.fromError)(parseError);
        }
        return new (0, $5ECju.default)(function(observer) {
            fetcher(chosenURI, options).then(function(response) {
                operation.setContext({
                    response: response
                });
                return response;
            }).then((0, $cp9eN.parseAndCheckHttpResponse)(operation)).then(function(result) {
                observer.next(result);
                observer.complete();
                return result;
            }).catch(function(err) {
                if (err.name === 'AbortError' && !abortErrorDoesNotCauseError) return;
                if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                observer.error(err);
            });
            return function() {
                if (controller) controller.abort();
            };
        });
    });
};
function $2405a8c9bbd1579c$var$rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) addQueryParam('query', body.query);
    if (body.operationName) addQueryParam('operationName', body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $cp9eN.serializeFetchParameter)(body.variables, 'Variables map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $cp9eN.serializeFetchParameter)(body.extensions, 'Extensions map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return {
        newURI: newURI
    };
}
var $2405a8c9bbd1579c$export$f4bbf1aec241cc1 = function(_super) {
    (0, $fKE23.__extends)(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, $2405a8c9bbd1579c$export$95180a16573d6675(opts).request) || this;
    }
    return HttpLink;
}((0, $bvQX6.ApolloLink));

});
parcelRegister("cp9eN", function(module, exports) {

$parcel$export(module.exports, "fallbackHttpConfig", () => $907efc3a22e8ac51$export$dd86f00dc866e75d);
$parcel$export(module.exports, "parseAndCheckHttpResponse", () => $907efc3a22e8ac51$export$d4051215bea0639f);
$parcel$export(module.exports, "checkFetcher", () => $907efc3a22e8ac51$export$8423f0cd3773115e);
$parcel$export(module.exports, "createSignalIfSupported", () => $907efc3a22e8ac51$export$f5853cd1fc39aea6);
$parcel$export(module.exports, "selectHttpOptionsAndBody", () => $907efc3a22e8ac51$export$a00ebfd5f1eebfb1);
$parcel$export(module.exports, "serializeFetchParameter", () => $907efc3a22e8ac51$export$5f8e80ac52052e28);
$parcel$export(module.exports, "selectURI", () => $907efc3a22e8ac51$export$63ccc2571850f81a);

var $fKE23 = parcelRequire("fKE23");

var $aKlnM = parcelRequire("aKlnM");

var $8j2fP = parcelRequire("8j2fP");
var $907efc3a22e8ac51$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false
};
var $907efc3a22e8ac51$var$defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json'
};
var $907efc3a22e8ac51$var$defaultOptions = {
    method: 'POST'
};
var $907efc3a22e8ac51$export$dd86f00dc866e75d = {
    http: $907efc3a22e8ac51$var$defaultHttpOptions,
    headers: $907efc3a22e8ac51$var$defaultHeaders,
    options: $907efc3a22e8ac51$var$defaultOptions
};
var $907efc3a22e8ac51$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var $907efc3a22e8ac51$export$d4051215bea0639f = function(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                var parseError = err;
                parseError.name = 'ServerParseError';
                parseError.response = response;
                parseError.statusCode = response.status;
                parseError.bodyText = bodyText;
                return Promise.reject(parseError);
            }
        }).then(function(result) {
            if (response.status >= 300) $907efc3a22e8ac51$export$c33ef9219f27efd7(response, result, "Response not successful: Received status code " + response.status);
            if (!Array.isArray(result) && !result.hasOwnProperty('data') && !result.hasOwnProperty('errors')) $907efc3a22e8ac51$export$c33ef9219f27efd7(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName) + "'.");
            return result;
        });
    };
};
var $907efc3a22e8ac51$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (typeof window === 'undefined') library = 'node-fetch';
        throw new (0, $8j2fP.InvariantError)(1);
    }
};
var $907efc3a22e8ac51$export$f5853cd1fc39aea6 = function() {
    if (typeof AbortController === 'undefined') return {
        controller: false,
        signal: false
    };
    var controller = new AbortController();
    var signal = controller.signal;
    return {
        controller: controller,
        signal: signal
    };
};
var $907efc3a22e8ac51$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = (0, $fKE23.__assign)({}, fallbackConfig.options, {
        headers: fallbackConfig.headers,
        credentials: fallbackConfig.credentials
    });
    var http = fallbackConfig.http;
    configs.forEach(function(config) {
        options = (0, $fKE23.__assign)({}, options, config.options, {
            headers: (0, $fKE23.__assign)({}, options.headers, config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $fKE23.__assign)({}, http, config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    if (http.includeQuery) body.query = (0, $aKlnM.print)(query);
    return {
        options: options,
        body: body
    };
};
var $907efc3a22e8ac51$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = new (0, $8j2fP.InvariantError)(2);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
var $907efc3a22e8ac51$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === 'function') return fallbackURI(operation);
    else return fallbackURI || '/graphql';
};

});
parcelRegister("aKlnM", function(module, exports) {

$parcel$export(module.exports, "print", () => $1f94f8496a1ffd7f$export$c2d084dc44961371);

var $961BR = parcelRequire("961BR");

var $flA0a = parcelRequire("flA0a");
function $1f94f8496a1ffd7f$export$c2d084dc44961371(ast) {
    return (0, $961BR.visit)(ast, {
        leave: $1f94f8496a1ffd7f$var$printDocASTReducer
    });
}
var $1f94f8496a1ffd7f$var$MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future
var $1f94f8496a1ffd7f$var$printDocASTReducer = {
    Name: function Name(node) {
        return node.value;
    },
    Variable: function Variable(node) {
        return '$' + node.name;
    },
    // Document
    Document: function Document(node) {
        return $1f94f8496a1ffd7f$var$join(node.definitions, '\n\n') + '\n';
    },
    OperationDefinition: function OperationDefinition(node) {
        var op = node.operation;
        var name = node.name;
        var varDefs = $1f94f8496a1ffd7f$var$wrap('(', $1f94f8496a1ffd7f$var$join(node.variableDefinitions, ', '), ')');
        var directives = $1f94f8496a1ffd7f$var$join(node.directives, ' ');
        var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
        // the query short form.
        return !name && !directives && !varDefs && op === 'query' ? selectionSet : $1f94f8496a1ffd7f$var$join([
            op,
            $1f94f8496a1ffd7f$var$join([
                name,
                varDefs
            ]),
            directives,
            selectionSet
        ], ' ');
    },
    VariableDefinition: function VariableDefinition(_ref) {
        var variable = _ref.variable, type = _ref.type, defaultValue = _ref.defaultValue, directives = _ref.directives;
        return variable + ': ' + type + $1f94f8496a1ffd7f$var$wrap(' = ', defaultValue) + $1f94f8496a1ffd7f$var$wrap(' ', $1f94f8496a1ffd7f$var$join(directives, ' '));
    },
    SelectionSet: function SelectionSet(_ref2) {
        var selections = _ref2.selections;
        return $1f94f8496a1ffd7f$var$block(selections);
    },
    Field: function Field(_ref3) {
        var alias = _ref3.alias, name = _ref3.name, args = _ref3.arguments, directives = _ref3.directives, selectionSet = _ref3.selectionSet;
        var prefix = $1f94f8496a1ffd7f$var$wrap('', alias, ': ') + name;
        var argsLine = prefix + $1f94f8496a1ffd7f$var$wrap('(', $1f94f8496a1ffd7f$var$join(args, ', '), ')');
        if (argsLine.length > $1f94f8496a1ffd7f$var$MAX_LINE_LENGTH) argsLine = prefix + $1f94f8496a1ffd7f$var$wrap('(\n', $1f94f8496a1ffd7f$var$indent($1f94f8496a1ffd7f$var$join(args, '\n')), '\n)');
        return $1f94f8496a1ffd7f$var$join([
            argsLine,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    Argument: function Argument(_ref4) {
        var name = _ref4.name, value = _ref4.value;
        return name + ': ' + value;
    },
    // Fragments
    FragmentSpread: function FragmentSpread(_ref5) {
        var name = _ref5.name, directives = _ref5.directives;
        return '...' + name + $1f94f8496a1ffd7f$var$wrap(' ', $1f94f8496a1ffd7f$var$join(directives, ' '));
    },
    InlineFragment: function InlineFragment(_ref6) {
        var typeCondition = _ref6.typeCondition, directives = _ref6.directives, selectionSet = _ref6.selectionSet;
        return $1f94f8496a1ffd7f$var$join([
            '...',
            $1f94f8496a1ffd7f$var$wrap('on ', typeCondition),
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            selectionSet
        ], ' ');
    },
    FragmentDefinition: function FragmentDefinition(_ref7) {
        var name = _ref7.name, typeCondition = _ref7.typeCondition, variableDefinitions = _ref7.variableDefinitions, directives = _ref7.directives, selectionSet = _ref7.selectionSet;
        return(// or removed in the future.
        "fragment ".concat(name).concat($1f94f8496a1ffd7f$var$wrap('(', $1f94f8496a1ffd7f$var$join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat($1f94f8496a1ffd7f$var$wrap('', $1f94f8496a1ffd7f$var$join(directives, ' '), ' ')) + selectionSet);
    },
    // Value
    IntValue: function IntValue(_ref8) {
        var value = _ref8.value;
        return value;
    },
    FloatValue: function FloatValue(_ref9) {
        var value = _ref9.value;
        return value;
    },
    StringValue: function StringValue(_ref10, key) {
        var value = _ref10.value, isBlockString = _ref10.block;
        return isBlockString ? (0, $flA0a.printBlockString)(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
    },
    BooleanValue: function BooleanValue(_ref11) {
        var value = _ref11.value;
        return value ? 'true' : 'false';
    },
    NullValue: function NullValue() {
        return 'null';
    },
    EnumValue: function EnumValue(_ref12) {
        var value = _ref12.value;
        return value;
    },
    ListValue: function ListValue(_ref13) {
        var values = _ref13.values;
        return '[' + $1f94f8496a1ffd7f$var$join(values, ', ') + ']';
    },
    ObjectValue: function ObjectValue(_ref14) {
        var fields = _ref14.fields;
        return '{' + $1f94f8496a1ffd7f$var$join(fields, ', ') + '}';
    },
    ObjectField: function ObjectField(_ref15) {
        var name = _ref15.name, value = _ref15.value;
        return name + ': ' + value;
    },
    // Directive
    Directive: function Directive(_ref16) {
        var name = _ref16.name, args = _ref16.arguments;
        return '@' + name + $1f94f8496a1ffd7f$var$wrap('(', $1f94f8496a1ffd7f$var$join(args, ', '), ')');
    },
    // Type
    NamedType: function NamedType(_ref17) {
        var name = _ref17.name;
        return name;
    },
    ListType: function ListType(_ref18) {
        var type = _ref18.type;
        return '[' + type + ']';
    },
    NonNullType: function NonNullType(_ref19) {
        var type = _ref19.type;
        return type + '!';
    },
    // Type System Definitions
    SchemaDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref20) {
        var directives = _ref20.directives, operationTypes = _ref20.operationTypes;
        return $1f94f8496a1ffd7f$var$join([
            'schema',
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(operationTypes)
        ], ' ');
    }),
    OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
        var operation = _ref21.operation, type = _ref21.type;
        return operation + ': ' + type;
    },
    ScalarTypeDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref22) {
        var name = _ref22.name, directives = _ref22.directives;
        return $1f94f8496a1ffd7f$var$join([
            'scalar',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' ')
        ], ' ');
    }),
    ObjectTypeDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref23) {
        var name = _ref23.name, interfaces = _ref23.interfaces, directives = _ref23.directives, fields = _ref23.fields;
        return $1f94f8496a1ffd7f$var$join([
            'type',
            name,
            $1f94f8496a1ffd7f$var$wrap('implements ', $1f94f8496a1ffd7f$var$join(interfaces, ' & ')),
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(fields)
        ], ' ');
    }),
    FieldDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref24) {
        var name = _ref24.name, args = _ref24.arguments, type = _ref24.type, directives = _ref24.directives;
        return name + ($1f94f8496a1ffd7f$var$hasMultilineItems(args) ? $1f94f8496a1ffd7f$var$wrap('(\n', $1f94f8496a1ffd7f$var$indent($1f94f8496a1ffd7f$var$join(args, '\n')), '\n)') : $1f94f8496a1ffd7f$var$wrap('(', $1f94f8496a1ffd7f$var$join(args, ', '), ')')) + ': ' + type + $1f94f8496a1ffd7f$var$wrap(' ', $1f94f8496a1ffd7f$var$join(directives, ' '));
    }),
    InputValueDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref25) {
        var name = _ref25.name, type = _ref25.type, defaultValue = _ref25.defaultValue, directives = _ref25.directives;
        return $1f94f8496a1ffd7f$var$join([
            name + ': ' + type,
            $1f94f8496a1ffd7f$var$wrap('= ', defaultValue),
            $1f94f8496a1ffd7f$var$join(directives, ' ')
        ], ' ');
    }),
    InterfaceTypeDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref26) {
        var name = _ref26.name, interfaces = _ref26.interfaces, directives = _ref26.directives, fields = _ref26.fields;
        return $1f94f8496a1ffd7f$var$join([
            'interface',
            name,
            $1f94f8496a1ffd7f$var$wrap('implements ', $1f94f8496a1ffd7f$var$join(interfaces, ' & ')),
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(fields)
        ], ' ');
    }),
    UnionTypeDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref27) {
        var name = _ref27.name, directives = _ref27.directives, types = _ref27.types;
        return $1f94f8496a1ffd7f$var$join([
            'union',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $1f94f8496a1ffd7f$var$join(types, ' | ') : ''
        ], ' ');
    }),
    EnumTypeDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref28) {
        var name = _ref28.name, directives = _ref28.directives, values = _ref28.values;
        return $1f94f8496a1ffd7f$var$join([
            'enum',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(values)
        ], ' ');
    }),
    EnumValueDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref29) {
        var name = _ref29.name, directives = _ref29.directives;
        return $1f94f8496a1ffd7f$var$join([
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' ')
        ], ' ');
    }),
    InputObjectTypeDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref30) {
        var name = _ref30.name, directives = _ref30.directives, fields = _ref30.fields;
        return $1f94f8496a1ffd7f$var$join([
            'input',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(fields)
        ], ' ');
    }),
    DirectiveDefinition: $1f94f8496a1ffd7f$var$addDescription(function(_ref31) {
        var name = _ref31.name, args = _ref31.arguments, repeatable = _ref31.repeatable, locations = _ref31.locations;
        return 'directive @' + name + ($1f94f8496a1ffd7f$var$hasMultilineItems(args) ? $1f94f8496a1ffd7f$var$wrap('(\n', $1f94f8496a1ffd7f$var$indent($1f94f8496a1ffd7f$var$join(args, '\n')), '\n)') : $1f94f8496a1ffd7f$var$wrap('(', $1f94f8496a1ffd7f$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $1f94f8496a1ffd7f$var$join(locations, ' | ');
    }),
    SchemaExtension: function SchemaExtension(_ref32) {
        var directives = _ref32.directives, operationTypes = _ref32.operationTypes;
        return $1f94f8496a1ffd7f$var$join([
            'extend schema',
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(operationTypes)
        ], ' ');
    },
    ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
        var name = _ref33.name, directives = _ref33.directives;
        return $1f94f8496a1ffd7f$var$join([
            'extend scalar',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' ')
        ], ' ');
    },
    ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
        var name = _ref34.name, interfaces = _ref34.interfaces, directives = _ref34.directives, fields = _ref34.fields;
        return $1f94f8496a1ffd7f$var$join([
            'extend type',
            name,
            $1f94f8496a1ffd7f$var$wrap('implements ', $1f94f8496a1ffd7f$var$join(interfaces, ' & ')),
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(fields)
        ], ' ');
    },
    InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
        var name = _ref35.name, interfaces = _ref35.interfaces, directives = _ref35.directives, fields = _ref35.fields;
        return $1f94f8496a1ffd7f$var$join([
            'extend interface',
            name,
            $1f94f8496a1ffd7f$var$wrap('implements ', $1f94f8496a1ffd7f$var$join(interfaces, ' & ')),
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(fields)
        ], ' ');
    },
    UnionTypeExtension: function UnionTypeExtension(_ref36) {
        var name = _ref36.name, directives = _ref36.directives, types = _ref36.types;
        return $1f94f8496a1ffd7f$var$join([
            'extend union',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            types && types.length !== 0 ? '= ' + $1f94f8496a1ffd7f$var$join(types, ' | ') : ''
        ], ' ');
    },
    EnumTypeExtension: function EnumTypeExtension(_ref37) {
        var name = _ref37.name, directives = _ref37.directives, values = _ref37.values;
        return $1f94f8496a1ffd7f$var$join([
            'extend enum',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(values)
        ], ' ');
    },
    InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
        var name = _ref38.name, directives = _ref38.directives, fields = _ref38.fields;
        return $1f94f8496a1ffd7f$var$join([
            'extend input',
            name,
            $1f94f8496a1ffd7f$var$join(directives, ' '),
            $1f94f8496a1ffd7f$var$block(fields)
        ], ' ');
    }
};
function $1f94f8496a1ffd7f$var$addDescription(cb) {
    return function(node) {
        return $1f94f8496a1ffd7f$var$join([
            node.description,
            cb(node)
        ], '\n');
    };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $1f94f8496a1ffd7f$var$join(maybeArray) {
    var _maybeArray$filter$jo;
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function(x) {
        return x;
    }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */ function $1f94f8496a1ffd7f$var$block(array) {
    return $1f94f8496a1ffd7f$var$wrap('{\n', $1f94f8496a1ffd7f$var$indent($1f94f8496a1ffd7f$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $1f94f8496a1ffd7f$var$wrap(start, maybeString) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $1f94f8496a1ffd7f$var$indent(str) {
    return $1f94f8496a1ffd7f$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $1f94f8496a1ffd7f$var$isMultiline(str) {
    return str.indexOf('\n') !== -1;
}
function $1f94f8496a1ffd7f$var$hasMultilineItems(maybeArray) {
    return maybeArray != null && maybeArray.some($1f94f8496a1ffd7f$var$isMultiline);
}

});
parcelRegister("flA0a", function(module, exports) {

$parcel$export(module.exports, "dedentBlockStringValue", () => $06a65b237068075a$export$fd88c0b652c46ccc);
$parcel$export(module.exports, "printBlockString", () => $06a65b237068075a$export$adb6ca997eeb1f45);
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */ function $06a65b237068075a$export$fd88c0b652c46ccc(rawString) {
    // Expand a block string's raw value into independent lines.
    var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.
    var commonIndent = $06a65b237068075a$export$3c95bfdc680af0c(rawString);
    if (commonIndent !== 0) for(var i = 1; i < lines.length; i++)lines[i] = lines[i].slice(commonIndent);
     // Remove leading and trailing blank lines.
    var startLine = 0;
    while(startLine < lines.length && $06a65b237068075a$var$isBlank(lines[startLine]))++startLine;
    var endLine = lines.length;
    while(endLine > startLine && $06a65b237068075a$var$isBlank(lines[endLine - 1]))--endLine;
     // Return a string of the lines joined with U+000A.
    return lines.slice(startLine, endLine).join('\n');
}
function $06a65b237068075a$var$isBlank(str) {
    for(var i = 0; i < str.length; ++i){
        if (str[i] !== ' ' && str[i] !== '\t') return false;
    }
    return true;
}
function $06a65b237068075a$export$3c95bfdc680af0c(value) {
    var _commonIndent;
    var isFirstLine = true;
    var isEmptyLine = true;
    var indent = 0;
    var commonIndent = null;
    for(var i = 0; i < value.length; ++i)switch(value.charCodeAt(i)){
        case 13:
            //  \r
            if (value.charCodeAt(i + 1) === 10) ++i; // skip \r\n as one symbol
        // falls through
        case 10:
            //  \n
            isFirstLine = false;
            isEmptyLine = true;
            indent = 0;
            break;
        case 9:
        case 32:
            //  <space>
            ++indent;
            break;
        default:
            if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) commonIndent = indent;
            isEmptyLine = false;
    }
    return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
function $06a65b237068075a$export$adb6ca997eeb1f45(value) {
    var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isSingleLine = value.indexOf('\n') === -1;
    var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
    var hasTrailingQuote = value[value.length - 1] === '"';
    var hasTrailingSlash = value[value.length - 1] === '\\';
    var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
    var result = ''; // Format a multi-line block quote to account for leading space.
    if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) result += '\n' + indentation;
    result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;
    if (printAsMultipleLines) result += '\n';
    return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}

});




parcelRegister("kcwGc", function(module, exports) {

$parcel$export(module.exports, "RetryLink", () => $eb4e47225b0a9c93$export$943d544ad120494a);

var $fKE23 = parcelRequire("fKE23");

var $bvQX6 = parcelRequire("bvQX6");
var $5ECju = parcelRequire("5ECju");
function $eb4e47225b0a9c93$var$buildDelayFunction(delayOptions) {
    var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
    var baseDelay = jitter ? initial : initial / 2;
    return function delayFunction(count) {
        var delay = Math.min(max, baseDelay * Math.pow(2, count));
        if (jitter) delay = Math.random() * delay;
        return delay;
    };
}
function $eb4e47225b0a9c93$var$buildRetryFunction(retryOptions) {
    var _a = retryOptions || {}, retryIf = _a.retryIf, _b = _a.max, max = _b === void 0 ? 5 : _b;
    return function retryFunction(count, operation, error) {
        if (count >= max) return false;
        return retryIf ? retryIf(error, operation) : !!error;
    };
}
var $eb4e47225b0a9c93$var$RetryableOperation = function() {
    function RetryableOperation(operation, nextLink, delayFor, retryIf) {
        var _this = this;
        this.operation = operation;
        this.nextLink = nextLink;
        this.delayFor = delayFor;
        this.retryIf = retryIf;
        this.retryCount = 0;
        this.values = [];
        this.complete = false;
        this.canceled = false;
        this.observers = [];
        this.currentSubscription = null;
        this.onNext = function(value) {
            _this.values.push(value);
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.next(value);
            }
        };
        this.onComplete = function() {
            _this.complete = true;
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.complete();
            }
        };
        this.onError = function(error) {
            return (0, $fKE23.__awaiter)(_this, void 0, void 0, function() {
                var shouldRetry, _i, _a, observer;
                return (0, $fKE23.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            this.retryCount += 1;
                            return [
                                4,
                                this.retryIf(this.retryCount, this.operation, error)
                            ];
                        case 1:
                            shouldRetry = _b.sent();
                            if (shouldRetry) {
                                this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                                return [
                                    2
                                ];
                            }
                            this.error = error;
                            for(_i = 0, _a = this.observers; _i < _a.length; _i++){
                                observer = _a[_i];
                                if (!observer) continue;
                                observer.error(error);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
        };
    }
    RetryableOperation.prototype.subscribe = function(observer) {
        if (this.canceled) throw new Error("Subscribing to a retryable link that was canceled is not supported");
        this.observers.push(observer);
        for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var value = _a[_i];
            observer.next(value);
        }
        if (this.complete) observer.complete();
        else if (this.error) observer.error(this.error);
    };
    RetryableOperation.prototype.unsubscribe = function(observer) {
        var index = this.observers.indexOf(observer);
        if (index < 0) throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
        this.observers[index] = null;
        if (this.observers.every(function(o) {
            return o === null;
        })) this.cancel();
    };
    RetryableOperation.prototype.start = function() {
        if (this.currentSubscription) return;
        this.try();
    };
    RetryableOperation.prototype.cancel = function() {
        if (this.currentSubscription) this.currentSubscription.unsubscribe();
        clearTimeout(this.timerId);
        this.timerId = null;
        this.currentSubscription = null;
        this.canceled = true;
    };
    RetryableOperation.prototype.try = function() {
        this.currentSubscription = this.nextLink(this.operation).subscribe({
            next: this.onNext,
            error: this.onError,
            complete: this.onComplete
        });
    };
    RetryableOperation.prototype.scheduleRetry = function(delay) {
        var _this = this;
        if (this.timerId) throw new Error("RetryLink BUG! Encountered overlapping retries");
        this.timerId = setTimeout(function() {
            _this.timerId = null;
            _this.try();
        }, delay);
    };
    return RetryableOperation;
}();
var $eb4e47225b0a9c93$export$943d544ad120494a = function(_super) {
    (0, $fKE23.__extends)(RetryLink, _super);
    function RetryLink(options) {
        var _this = _super.call(this) || this;
        var _a = options || {}, attempts = _a.attempts, delay = _a.delay;
        _this.delayFor = typeof delay === 'function' ? delay : $eb4e47225b0a9c93$var$buildDelayFunction(delay);
        _this.retryIf = typeof attempts === 'function' ? attempts : $eb4e47225b0a9c93$var$buildRetryFunction(attempts);
        return _this;
    }
    RetryLink.prototype.request = function(operation, nextLink) {
        var retryable = new $eb4e47225b0a9c93$var$RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
        retryable.start();
        return new (0, $5ECju.default)(function(observer) {
            retryable.subscribe(observer);
            return function() {
                retryable.unsubscribe(observer);
            };
        });
    };
    return RetryLink;
}((0, $bvQX6.ApolloLink));

});

parcelRegister("10n8H", function(module, exports) {

$parcel$export(module.exports, "fragmentCacheRedirect", () => $0bb7bd86ef08f58c$export$5133c88128301697);
$parcel$export(module.exports, "fragmentLinkState", () => $0bb7bd86ef08f58c$export$3f9ecfb4d42ab23d);

var $42BH7 = parcelRequire("42BH7");

var $hiwGV = parcelRequire("hiwGV");

var $2vRh6 = parcelRequire("2vRh6");
function $0bb7bd86ef08f58c$export$5133c88128301697(dataIdFromObject) {
    if (dataIdFromObject === void 0) dataIdFromObject = (0, $2vRh6.defaultDataIdFromObject);
    return {
        getFragment: function(_, _a) {
            var id = _a.id, __typename = _a.__typename;
            return (0, $42BH7.toIdValue)(dataIdFromObject({
                __typename: __typename,
                id: id
            }));
        }
    };
}
function $0bb7bd86ef08f58c$export$3f9ecfb4d42ab23d(apolloCache) {
    return (0, $hiwGV.withClientState)({
        cache: apolloCache,
        resolvers: {
            Query: {
                getFragment: function(_, _a, _b) {
                    var __typename = _a.__typename, id = _a.id;
                    var cache = _b.cache;
                    var fragmentId = cache.config.dataIdFromObject({
                        __typename: __typename,
                        id: id
                    });
                    return cache.data.data[fragmentId];
                }
            }
        }
    });
}

});
parcelRegister("hiwGV", function(module, exports) {

$parcel$export(module.exports, "withClientState", () => $c97d79f1a0a9adb8$export$a13f755900e15d9e);

var $bvQX6 = parcelRequire("bvQX6");
var $5ECju = parcelRequire("5ECju");

var $42BH7 = parcelRequire("42BH7");

var $77JSu = parcelRequire("77JSu");

var $fl4NX = parcelRequire("fl4NX");
var $c97d79f1a0a9adb8$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $c97d79f1a0a9adb8$var$graphql = $77JSu.graphql;
var $c97d79f1a0a9adb8$var$capitalizeFirstLetter = function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
var $c97d79f1a0a9adb8$export$a13f755900e15d9e = function(clientStateConfig) {
    if (clientStateConfig === void 0) clientStateConfig = {
        resolvers: {},
        defaults: {}
    };
    var defaults = clientStateConfig.defaults, cache = clientStateConfig.cache, typeDefs = clientStateConfig.typeDefs, fragmentMatcher = clientStateConfig.fragmentMatcher;
    if (cache && defaults) cache.writeData({
        data: defaults
    });
    return new (function(_super) {
        $c97d79f1a0a9adb8$var$__extends(StateLink, _super);
        function StateLink() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        StateLink.prototype.writeDefaults = function() {
            if (cache && defaults) cache.writeData({
                data: defaults
            });
        };
        StateLink.prototype.request = function(operation, forward) {
            if (forward === void 0) forward = function() {
                return (0, $5ECju.default).of({
                    data: {}
                });
            };
            if (typeDefs) {
                var directives_1 = 'directive @client on FIELD';
                var definition_1 = (0, $fl4NX.normalizeTypeDefs)(typeDefs);
                operation.setContext(function(_a) {
                    var _b = _a.schemas, schemas = _b === void 0 ? [] : _b;
                    return {
                        schemas: schemas.concat([
                            {
                                definition: definition_1,
                                directives: directives_1
                            }
                        ])
                    };
                });
            }
            var isClient = (0, $42BH7.hasDirectives)([
                'client'
            ], operation.query);
            if (!isClient) return forward(operation);
            var resolvers = typeof clientStateConfig.resolvers === 'function' ? clientStateConfig.resolvers() : clientStateConfig.resolvers;
            var server = (0, $fl4NX.removeClientSetsFromDocument)(operation.query);
            var query = operation.query;
            var type = $c97d79f1a0a9adb8$var$capitalizeFirstLetter(((0, $42BH7.getMainDefinition)(query) || {}).operation) || 'Query';
            var resolver = function(fieldName, rootValue, args, context, info) {
                if (rootValue === void 0) rootValue = {};
                var resultKey = info.resultKey;
                var aliasedNode = rootValue[resultKey];
                var preAliasingNode = rootValue[fieldName];
                var aliasNeeded = resultKey !== fieldName;
                if (aliasedNode !== undefined || preAliasingNode !== undefined) return aliasedNode || preAliasingNode;
                var resolverMap = resolvers[rootValue.__typename || type];
                if (resolverMap) {
                    var resolve = resolverMap[fieldName];
                    if (resolve) return resolve(rootValue, args, context, info);
                }
                return (aliasNeeded ? aliasedNode : preAliasingNode) || (defaults || {})[fieldName];
            };
            if (server) operation.query = server;
            var obs = server && forward ? forward(operation) : (0, $5ECju.default).of({
                data: {}
            });
            return new (0, $5ECju.default)(function(observer) {
                var complete = false;
                var handlingNext = false;
                obs.subscribe({
                    next: function(_a) {
                        var data = _a.data, errors = _a.errors;
                        var observerErrorHandler = observer.error.bind(observer);
                        var context = operation.getContext();
                        handlingNext = true;
                        $c97d79f1a0a9adb8$var$graphql(resolver, query, data, context, operation.variables, {
                            fragmentMatcher: fragmentMatcher
                        }).then(function(nextData) {
                            observer.next({
                                data: nextData,
                                errors: errors
                            });
                            if (complete) observer.complete();
                            handlingNext = false;
                        }).catch(observerErrorHandler);
                    },
                    error: observer.error.bind(observer),
                    complete: function() {
                        if (!handlingNext) observer.complete();
                        complete = true;
                    }
                });
            });
        };
        return StateLink;
    }((0, $bvQX6.ApolloLink)))();
};

});
parcelRegister("77JSu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fKE23 = parcelRequire("fKE23");

var $42BH7 = parcelRequire("42BH7");

var $1BuKE = parcelRequire("1BuKE");
function $52fcc63cc3cd9b23$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $42BH7.getMainDefinition(document);
    var fragments = $42BH7.getFragmentDefinitions(document);
    var fragmentMap = $42BH7.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $52fcc63cc3cd9b23$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $52fcc63cc3cd9b23$var$graphql;
function $52fcc63cc3cd9b23$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    return $fKE23.__awaiter(this, void 0, void 0, function() {
        var fragmentMap, contextValue, variables, result, execute;
        var _this = this;
        return $fKE23.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
                    result = {};
                    execute = function(selection) {
                        return $fKE23.__awaiter(_this, void 0, void 0, function() {
                            var fieldResult, resultFieldKey, fragment, typeCondition, fragmentResult;
                            return $fKE23.__generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!$42BH7.shouldInclude(selection, variables)) return [
                                            2
                                        ];
                                        if (!$42BH7.isField(selection)) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            $52fcc63cc3cd9b23$var$executeField(selection, rootValue, execContext)
                                        ];
                                    case 1:
                                        fieldResult = _a.sent();
                                        resultFieldKey = $42BH7.resultKeyNameFromField(selection);
                                        if (fieldResult !== undefined) {
                                            if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                                            else $1BuKE.merge(result[resultFieldKey], fieldResult);
                                        }
                                        return [
                                            2
                                        ];
                                    case 2:
                                        if ($42BH7.isInlineFragment(selection)) fragment = selection;
                                        else {
                                            fragment = fragmentMap[selection.name.value];
                                            if (!fragment) throw new Error("No fragment named " + selection.name.value);
                                        }
                                        typeCondition = fragment.typeCondition.name.value;
                                        if (!execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) return [
                                            3,
                                            4
                                        ];
                                        return [
                                            4,
                                            $52fcc63cc3cd9b23$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext)
                                        ];
                                    case 3:
                                        fragmentResult = _a.sent();
                                        $1BuKE.merge(result, fragmentResult);
                                        _a.label = 4;
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    };
                    return [
                        4,
                        Promise.all(selectionSet.selections.map(execute))
                    ];
                case 1:
                    _a.sent();
                    if (execContext.resultMapper) return [
                        2,
                        execContext.resultMapper(result, rootValue)
                    ];
                    return [
                        2,
                        result
                    ];
            }
        });
    });
}
function $52fcc63cc3cd9b23$var$executeField(field, rootValue, execContext) {
    return $fKE23.__awaiter(this, void 0, void 0, function() {
        var variables, contextValue, resolver, fieldName, args, info, result;
        return $fKE23.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
                    fieldName = field.name.value;
                    args = $42BH7.argumentsObjectFromField(field, variables);
                    info = {
                        isLeaf: !field.selectionSet,
                        resultKey: $42BH7.resultKeyNameFromField(field),
                        directives: $42BH7.getDirectiveInfoFromField(field, variables),
                        field: field
                    };
                    return [
                        4,
                        resolver(fieldName, rootValue, args, contextValue, info)
                    ];
                case 1:
                    result = _a.sent();
                    if (!field.selectionSet) return [
                        2,
                        result
                    ];
                    if (result == null) return [
                        2,
                        result
                    ];
                    if (Array.isArray(result)) return [
                        2,
                        $52fcc63cc3cd9b23$var$executeSubSelectedArray(field, result, execContext)
                    ];
                    return [
                        2,
                        $52fcc63cc3cd9b23$var$executeSelectionSet(field.selectionSet, result, execContext)
                    ];
            }
        });
    });
}
function $52fcc63cc3cd9b23$var$executeSubSelectedArray(field, result, execContext) {
    return Promise.all(result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $52fcc63cc3cd9b23$var$executeSubSelectedArray(field, item, execContext);
        return $52fcc63cc3cd9b23$var$executeSelectionSet(field.selectionSet, item, execContext);
    }));
}

});
parcelRegister("1BuKE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $42BH7 = parcelRequire("42BH7");
function $12b119b85c2553d1$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (variableValues === void 0) variableValues = {};
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $42BH7.getMainDefinition(document);
    var fragments = $42BH7.getFragmentDefinitions(document);
    var fragmentMap = $42BH7.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $12b119b85c2553d1$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $12b119b85c2553d1$var$graphql;
function $12b119b85c2553d1$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
    var result = {};
    selectionSet.selections.forEach(function(selection) {
        if (variables && !$42BH7.shouldInclude(selection, variables)) return;
        if ($42BH7.isField(selection)) {
            var fieldResult = $12b119b85c2553d1$var$executeField(selection, rootValue, execContext);
            var resultFieldKey = $42BH7.resultKeyNameFromField(selection);
            if (fieldResult !== undefined) {
                if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                else $12b119b85c2553d1$var$merge(result[resultFieldKey], fieldResult);
            }
        } else {
            var fragment = void 0;
            if ($42BH7.isInlineFragment(selection)) fragment = selection;
            else {
                fragment = fragmentMap[selection.name.value];
                if (!fragment) throw new Error("No fragment named " + selection.name.value);
            }
            var typeCondition = fragment.typeCondition.name.value;
            if (execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) {
                var fragmentResult = $12b119b85c2553d1$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext);
                $12b119b85c2553d1$var$merge(result, fragmentResult);
            }
        }
    });
    if (execContext.resultMapper) return execContext.resultMapper(result, rootValue);
    return result;
}
function $12b119b85c2553d1$var$executeField(field, rootValue, execContext) {
    var variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
    var fieldName = field.name.value;
    var args = $42BH7.argumentsObjectFromField(field, variables);
    var info = {
        isLeaf: !field.selectionSet,
        resultKey: $42BH7.resultKeyNameFromField(field),
        directives: $42BH7.getDirectiveInfoFromField(field, variables),
        field: field
    };
    var result = resolver(fieldName, rootValue, args, contextValue, info);
    if (!field.selectionSet) return result;
    if (result == null) return result;
    if (Array.isArray(result)) return $12b119b85c2553d1$var$executeSubSelectedArray(field, result, execContext);
    return $12b119b85c2553d1$var$executeSelectionSet(field.selectionSet, result, execContext);
}
function $12b119b85c2553d1$var$executeSubSelectedArray(field, result, execContext) {
    return result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $12b119b85c2553d1$var$executeSubSelectedArray(field, item, execContext);
        return $12b119b85c2553d1$var$executeSelectionSet(field.selectionSet, item, execContext);
    });
}
var $12b119b85c2553d1$var$hasOwn = Object.prototype.hasOwnProperty;
function $12b119b85c2553d1$var$merge(dest, src) {
    if (src !== null && typeof src === 'object') Object.keys(src).forEach(function(key) {
        var srcVal = src[key];
        if (!$12b119b85c2553d1$var$hasOwn.call(dest, key)) dest[key] = srcVal;
        else $12b119b85c2553d1$var$merge(dest[key], srcVal);
    });
}
module.exports.merge = $12b119b85c2553d1$var$merge;

});


parcelRegister("fl4NX", function(module, exports) {

$parcel$export(module.exports, "removeClientSetsFromDocument", () => $b2ac8b51e1cafdcd$export$8eae69e876ee321e);
$parcel$export(module.exports, "normalizeTypeDefs", () => $b2ac8b51e1cafdcd$export$467f9c465e4ace4e);

var $aKlnM = parcelRequire("aKlnM");

var $42BH7 = parcelRequire("42BH7");
var $b2ac8b51e1cafdcd$var$connectionRemoveConfig = {
    test: function(directive) {
        return directive.name.value === 'client';
    },
    remove: true
};
var $b2ac8b51e1cafdcd$var$removed = new Map();
function $b2ac8b51e1cafdcd$export$8eae69e876ee321e(query) {
    var cached = $b2ac8b51e1cafdcd$var$removed.get(query);
    if (cached) return cached;
    (0, $42BH7.checkDocument)(query);
    var docClone = (0, $42BH7.removeDirectivesFromDocument)([
        $b2ac8b51e1cafdcd$var$connectionRemoveConfig
    ], query);
    $b2ac8b51e1cafdcd$var$removed.set(query, docClone);
    return docClone;
}
function $b2ac8b51e1cafdcd$export$467f9c465e4ace4e(typeDefs) {
    var defs = Array.isArray(typeDefs) ? typeDefs : [
        typeDefs
    ];
    return defs.map(function(typeDef) {
        return typeof typeDef === 'string' ? typeDef : (0, $aKlnM.print)(typeDef);
    }).map(function(str) {
        return str.trim();
    }).join('\n');
}

});



parcelRegister("aXA7t", function(module, exports) {

$parcel$export(module.exports, "UFOLoggerLink", () => $2f1700194c3d8ae8$export$fb326ed954631f3f);

var $bvQX6 = parcelRequire("bvQX6");

var $fVaJL = parcelRequire("fVaJL");
const $2f1700194c3d8ae8$export$fb326ed954631f3f = new (0, $bvQX6.ApolloLink)((operation, forward)=>{
    const networkStart = performance.now();
    return forward(operation).map((response)=>{
        const networkComplete = performance.now();
        const operationName = operation.operationName ?? 'unnamed';
        (0, $fVaJL.addSpanToAll)('graphql', operationName, [
            {
                name: 'network'
            }
        ], networkStart, networkComplete);
        return response;
    });
});

});

parcelRegister("iV2Ac", function(module, exports) {
module.exports = JSON.parse("{\"__schema\":{\"types\":[{\"kind\":\"UNION\",\"name\":\"AllActivityFeedItemUnion\",\"possibleTypes\":[{\"name\":\"HistoryItem\"},{\"name\":\"CommentItem\"},{\"name\":\"WorklogItem\"},{\"name\":\"IncidentItem\"},{\"name\":\"ApprovalItem\"},{\"name\":\"HiddenCommentItem\"}]},{\"kind\":\"UNION\",\"name\":\"ApprovalActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ApprovalCreated\"},{\"name\":\"ApproverDecision\"},{\"name\":\"ApprovalCompleted\"}]},{\"kind\":\"UNION\",\"name\":\"ConfluencePageUnion\",\"possibleTypes\":[{\"name\":\"ConfluencePage\"},{\"name\":\"FailedRemoteLink\"}]},{\"kind\":\"UNION\",\"name\":\"GQLCategorizedField\",\"possibleTypes\":[{\"name\":\"GQLSortableField\"},{\"name\":\"GQLSearchableField\"}]},{\"kind\":\"UNION\",\"name\":\"GadgetParameters\",\"possibleTypes\":[{\"name\":\"VotedGadgetParameters\"},{\"name\":\"AssignedToMeGadgetParameters\"},{\"name\":\"WatchedGadgetParameters\"},{\"name\":\"InProgressGadgetParameters\"},{\"name\":\"FilterResultsGadgetParameters\"},{\"name\":\"TwoDimensionalStatisticsParameters\"},{\"name\":\"PieChartParameters\"},{\"name\":\"IssueStatisticsParameters\"},{\"name\":\"WorkloadPieChartParameters\"},{\"name\":\"ActivityStreamGadgetParameters\"},{\"name\":\"CreatedVsResolvedGadgetParameters\"},{\"name\":\"SprintGadgetParameters\"},{\"name\":\"ProjectsGadgetParameters\"},{\"name\":\"ConnectGadgetParameters\"},{\"name\":\"NotConfiguredGadgetParameters\"},{\"name\":\"UnsupportedGadgetParameters\"}]},{\"kind\":\"UNION\",\"name\":\"GroupByFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"UserField\"},{\"name\":\"LabelsField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"FloatCustomField\"}]},{\"kind\":\"UNION\",\"name\":\"GroupSectionItem\",\"possibleTypes\":[{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"HistoryValue\",\"possibleTypes\":[{\"name\":\"AssigneeFieldValue\"},{\"name\":\"PriorityFieldValue\"},{\"name\":\"StatusFieldValue\"},{\"name\":\"WorkLogFieldValue\"},{\"name\":\"RespondersFieldValue\"},{\"name\":\"GenericFieldValue\"}]},{\"kind\":\"UNION\",\"name\":\"IncidentActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ResponderAlertAssignedValue\"},{\"name\":\"AlertValue\"},{\"name\":\"ResponderAlertPriorityChangedValue\"},{\"name\":\"IccSessionValue\"},{\"name\":\"IccSessionInvitationValue\"},{\"name\":\"StakeholderUpdatedValue\"},{\"name\":\"IncidentStakeholderActionValue\"}]},{\"kind\":\"UNION\",\"name\":\"IssueFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"ProjectComponentsField\"},{\"name\":\"LabelsField\"},{\"name\":\"WatchersField\"},{\"name\":\"UserField\"},{\"name\":\"TextField\"},{\"name\":\"VersionsField\"},{\"name\":\"DateField\"},{\"name\":\"DateTimeField\"},{\"name\":\"IssueKeyField\"},{\"name\":\"ProjectField\"},{\"name\":\"ResolutionField\"},{\"name\":\"TimeTrackingField\"},{\"name\":\"TimeOriginalEstimateField\"},{\"name\":\"TimeEstimateField\"},{\"name\":\"TimeSpentField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"EpicLinkField\"},{\"name\":\"EpicNameField\"},{\"name\":\"ColorField\"},{\"name\":\"EpicColorField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"FlaggedCustomField\"},{\"name\":\"UserPickerCustomField\"},{\"name\":\"TextAreaCustomField\"},{\"name\":\"FloatCustomField\"},{\"name\":\"DatePickerCustomField\"},{\"name\":\"TextFieldCustomField\"},{\"name\":\"MultiSelectCustomField\"},{\"name\":\"LabelsCustomField\"},{\"name\":\"MultiUserPickerCustomField\"},{\"name\":\"PeopleCustomField\"},{\"name\":\"UrlCustomField\"},{\"name\":\"VersionCustomField\"},{\"name\":\"GroupPickerCustomField\"},{\"name\":\"MultiVersionCustomField\"},{\"name\":\"MultiGroupPickerCustomField\"},{\"name\":\"CheckBoxesCustomField\"},{\"name\":\"RadioButtonsCustomField\"},{\"name\":\"DateTimeCustomField\"},{\"name\":\"SeverityField\"},{\"name\":\"AffectedServicesField\"},{\"name\":\"TechLeadField\"},{\"name\":\"AttachmentsField\"},{\"name\":\"GlancesField\"},{\"name\":\"SecurityLevelField\"},{\"name\":\"IssueLinksField\"},{\"name\":\"IssuesInEpicField\"},{\"name\":\"SubtasksField\"},{\"name\":\"ChildIssuesField\"},{\"name\":\"CascadingSelectCustomField\"},{\"name\":\"CmdbField\"},{\"name\":\"SLACustomField\"},{\"name\":\"ProjectCustomField\"},{\"name\":\"EpicStatusField\"},{\"name\":\"ParentField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"CommentSummaryField\"}]},{\"kind\":\"UNION\",\"name\":\"IssueSections\",\"possibleTypes\":[{\"name\":\"PrimarySecondaryContextSections\"},{\"name\":\"JsdSections\"}]},{\"kind\":\"UNION\",\"name\":\"JiraActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraColorBackground\"},{\"name\":\"JiraGradientBackground\"},{\"name\":\"JiraMediaBackground\"},{\"name\":\"JiraAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraAtlassianIntelligenceAction\",\"possibleTypes\":[{\"name\":\"JiraAccessAtlassianIntelligenceFeature\"},{\"name\":\"JiraEnableAtlassianIntelligenceDeepLink\"},{\"name\":\"JiraContactOrgAdminToEnableAtlassianIntelligence\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraChildIssues\",\"possibleTypes\":[{\"name\":\"JiraChildIssuesWithinLimit\"},{\"name\":\"JiraChildIssuesExceedingLimit\"}]},{\"kind\":\"UNION\",\"name\":\"JiraCommentVisibility\",\"possibleTypes\":[{\"name\":\"JiraRoleVisibility\"},{\"name\":\"JiraGroupVisibility\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFavourite\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraPlan\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraServiceManagementQueue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGlobalPermissionGrantsResult\",\"possibleTypes\":[{\"name\":\"JiraGlobalPermissionGrantsList\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGrantTypeValue\",\"possibleTypes\":[{\"name\":\"JiraDefaultGrantTypeValue\"},{\"name\":\"JiraUserGrantTypeValue\"},{\"name\":\"JiraProjectRoleGrantTypeValue\"},{\"name\":\"JiraGroupGrantTypeValue\"},{\"name\":\"JiraIssueFieldGrantTypeValue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGroupLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateAdditionalServicesResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateAdditionalServices\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateFieldsResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateFields\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateLayoutResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"},{\"name\":\"JiraIssueItemGroupContainer\"},{\"name\":\"JiraIssueItemTabContainer\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainersResult\",\"possibleTypes\":[{\"name\":\"JiraIssueItemContainers\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemGroupContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemTabContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayout\",\"possibleTypes\":[{\"name\":\"JiraDefaultIssueLayout\"},{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"JiraLegacyIssueLayout\"},{\"name\":\"JsdDefaultIssueLayout\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldConfigurationHiddenIn\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInGlobal\"},{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInLayoutOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldPanelItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutContainerConfiguration\"},{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutGroupContainerConfiguration\"},{\"name\":\"JiraIssueLayoutTabContainerConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwner\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutIssueTypeOwner\"},{\"name\":\"JiraIssueLayoutRequestTypeOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwners\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutOwnersResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueResult\",\"possibleTypes\":[{\"name\":\"JiraIssue\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByFilterResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByFilter\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByJqlResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByJql\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraCustomIssueSearchError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchViewResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJQLGenerationError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraUIExposedError\"},{\"name\":\"JiraUsageLimitExceededError\"},{\"name\":\"JiraUnsupportedLanguageError\"},{\"name\":\"JiraGeneratedJqlInvalidError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraJqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JiraJqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedField\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedValue\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraMediaUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraMediaUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraNavigationItemResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"JiraSoftwareBuiltInNavigationItem\"},{\"name\":\"JiraAppNavigationItem\"},{\"name\":\"JiraShortcutNavigationItem\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOnSuggestedChildIssueResult\",\"possibleTypes\":[{\"name\":\"JiraSuggestedIssue\"},{\"name\":\"JiraSuggestedChildIssueStatus\"},{\"name\":\"JiraSuggestedChildIssueError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOverviewPlanMigrationStateResult\",\"possibleTypes\":[{\"name\":\"JiraOverviewPlanMigrationState\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraPermissionSchemeViewResult\",\"possibleTypes\":[{\"name\":\"JiraPermissionSchemeView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectConfiguration\",\"possibleTypes\":[{\"name\":\"JiraProjectConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectNavigationMetadata\",\"possibleTypes\":[{\"name\":\"JiraSoftwareProjectNavigationMetadata\"},{\"name\":\"JiraServiceManagementProjectNavigationMetadata\"},{\"name\":\"JiraWorkManagementProjectNavigationMetadata\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectsUsingField\",\"possibleTypes\":[{\"name\":\"JiraProjectsUsingFieldResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraRemoteIssueLink\",\"possibleTypes\":[{\"name\":\"JiraIssueRemoteIssueLink\"},{\"name\":\"JiraConfluenceRemoteIssueLink\"},{\"name\":\"JiraWebRemoteIssueLink\"},{\"name\":\"JiraCustomRemoteIssueLink\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSearchableEntity\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraIssue\"},{\"name\":\"JiraServiceManagementQueue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSectionLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraGroupLayout\"},{\"name\":\"JiraTabLayout\"},{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementApproverPrincipal\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserApproverPrincipal\"},{\"name\":\"JiraServiceManagementGroupApproverPrincipal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementEntitledEntity\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementEntitlementCustomer\"},{\"name\":\"JiraServiceManagementEntitlementOrganization\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementRequestTypePreviewField\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementTextPreviewField\"},{\"name\":\"JiraServiceManagementTextAreaPreviewField\"},{\"name\":\"JiraServiceManagementDueDatePreviewField\"},{\"name\":\"JiraServiceManagementDatePreviewField\"},{\"name\":\"JiraServiceManagementDateTimePreviewField\"},{\"name\":\"JiraServiceManagementAttachmentPreviewField\"},{\"name\":\"JiraServiceManagementSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiUserPickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiServicePickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiCheckboxesPreviewField\"},{\"name\":\"JiraServiceManagementPeoplePreviewField\"},{\"name\":\"JiraServiceManagementUnknownPreviewField\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementResponder\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserResponder\"},{\"name\":\"JiraServiceManagementTeamResponder\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityEditGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityShareGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityAnonymousAccessGrant\"},{\"name\":\"JiraShareableEntityAnyLoggedInUserGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraVersionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionResult\",\"possibleTypes\":[{\"name\":\"JiraVersion\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementColorBackground\"},{\"name\":\"JiraWorkManagementGradientBackground\"},{\"name\":\"JiraWorkManagementMediaBackground\"},{\"name\":\"JiraWorkManagementAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementCategoryOptionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementCategoryOptionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFieldConfigurationConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFieldConfigurationConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFilterConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFilterConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementGiraOverviewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementGiraOverview\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementSavedViewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementViewItemConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementViewItemConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedField\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedValue\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"LayoutDefiner\",\"possibleTypes\":[{\"name\":\"FieldLayoutScreen\"},{\"name\":\"JiraRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"MediaUploadTokenUnion\",\"possibleTypes\":[{\"name\":\"MediaUploadToken\"},{\"name\":\"FailedMediaUploadToken\"}]},{\"kind\":\"UNION\",\"name\":\"MergedFieldUnion\",\"possibleTypes\":[{\"name\":\"IssueTypeField\"},{\"name\":\"StatusField\"}]},{\"kind\":\"UNION\",\"name\":\"ProjectCategoryGadgetUnion\",\"possibleTypes\":[{\"name\":\"ProjectsGadgetItem\"},{\"name\":\"CategoriesGadgetItem\"}]},{\"kind\":\"UNION\",\"name\":\"RemoteIssueDetailsUnion\",\"possibleTypes\":[{\"name\":\"AssociatedIssueWrapper\"},{\"name\":\"FailedRemoteIssue\"}]},{\"kind\":\"UNION\",\"name\":\"SectionItem\",\"possibleTypes\":[{\"name\":\"GroupLayout\"},{\"name\":\"TabLayout\"},{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"TimeSeriesChartAdditionalPropertiesUnion\",\"possibleTypes\":[{\"name\":\"CreatedVsResolvedProperties\"}]}]}}");

});

parcelRegister("1ZkL6", function(module, exports) {

$parcel$export(module.exports, "getErrorAnalyticsContext", () => $a205b903a47dbc85$export$bd030713895ed5e2);
$parcel$export(module.exports, "reportErrors", () => $a205b903a47dbc85$export$a78ebe1911f50d41);

var $illlw = parcelRequire("illlw");

var $jlBDe = parcelRequire("jlBDe");

var $guiFP = parcelRequire("guiFP");
const $a205b903a47dbc85$export$15d632fe38832073 = 'giraErrorAnalytics';
const $a205b903a47dbc85$export$fc6a71db0f9a33f9 = (errorAnalytics, context = {})=>({
        ...context,
        [$a205b903a47dbc85$export$15d632fe38832073]: errorAnalytics
    });
const $a205b903a47dbc85$export$bd030713895ed5e2 = (context)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const errorAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(context, [
        $a205b903a47dbc85$export$15d632fe38832073
    ], undefined);
    if (typeof errorAnalytics === 'object' && typeof errorAnalytics.id === 'string' && (errorAnalytics.packageName === undefined || typeof errorAnalytics.packageName === 'string') && (errorAnalytics.teamName === undefined || typeof errorAnalytics.teamName === 'string') && (errorAnalytics.attributes === undefined || typeof errorAnalytics.attributes === 'object') && (errorAnalytics.sendToPrivacyUnsafeSplunk === undefined || typeof errorAnalytics.sendToPrivacyUnsafeSplunk === 'boolean')) return {
        id: errorAnalytics.id,
        packageName: errorAnalytics.packageName,
        teamName: errorAnalytics.teamName,
        attributes: errorAnalytics.attributes,
        sendToPrivacyUnsafeSplunk: errorAnalytics.sendToPrivacyUnsafeSplunk
    };
    return undefined;
};
const $a205b903a47dbc85$export$a78ebe1911f50d41 = ({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    const errorAnalytics = $a205b903a47dbc85$export$bd030713895ed5e2(operation.getContext());
    // Refine mixed type to Array | void
    if (graphQLErrors !== undefined && !Array.isArray(graphQLErrors)) return;
    const hasGraphQLError = graphQLErrors !== undefined && graphQLErrors.length > 0;
    const hasNetworkError = networkError !== undefined;
    // Only report errors using the JFE analytics pipeline if analytics context data is defined for the query.
    if (errorAnalytics === undefined || !hasGraphQLError && !hasNetworkError) return;
    const { id: id, packageName: packageName, teamName: teamName, attributes: attributes, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk } = errorAnalytics;
    const error = new (0, $jlBDe.ApolloError)({
        // Above Array.isArray check will refine the type to a read-only array. We need this spread to keep flow happy.
        graphQLErrors: graphQLErrors ? [
            ...graphQLErrors
        ] : undefined,
        networkError: networkError
    });
    const attributesWithOperationName = {
        ...attributes,
        operationName: operation.operationName,
        hasGraphQLError: hasGraphQLError,
        hasNetworkError: hasNetworkError
    };
    (0, $guiFP.default)({
        error: error,
        meta: {
            id: id,
            packageName: packageName,
            teamName: teamName
        },
        attributes: attributesWithOperationName,
        sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk
    });
};

});

parcelRegister("9ypom", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f4afc5439e22f0a$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $6ds0g = parcelRequire("6ds0g");
var $6f4afc5439e22f0a$var$docCache = new Map();
var $6f4afc5439e22f0a$var$fragmentSourceMap = new Map();
var $6f4afc5439e22f0a$var$printFragmentWarnings = true;
var $6f4afc5439e22f0a$var$experimentalFragmentVariables = false;
function $6f4afc5439e22f0a$var$normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function $6f4afc5439e22f0a$var$cacheKeyFromLoc(loc) {
    return $6f4afc5439e22f0a$var$normalize(loc.source.body.substring(loc.start, loc.end));
}
function $6f4afc5439e22f0a$var$processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function(fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = $6f4afc5439e22f0a$var$cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = $6f4afc5439e22f0a$var$fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if ($6f4afc5439e22f0a$var$printFragmentWarnings) console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
            } else if (!sourceKeySet) $6f4afc5439e22f0a$var$fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        } else definitions.push(fragmentDefinition);
    });
    return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, ast), {
        definitions: definitions
    });
}
function $6f4afc5439e22f0a$var$stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function(node) {
        if (node.loc) delete node.loc;
        Object.keys(node).forEach(function(key) {
            var value = node[key];
            if (value && typeof value === 'object') workSet.add(value);
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function $6f4afc5439e22f0a$var$parseDocument(source) {
    var cacheKey = $6f4afc5439e22f0a$var$normalize(source);
    if (!$6f4afc5439e22f0a$var$docCache.has(cacheKey)) {
        var parsed = (0, $6ds0g.parse)(source, {
            experimentalFragmentVariables: $6f4afc5439e22f0a$var$experimentalFragmentVariables,
            allowLegacyFragmentVariables: $6f4afc5439e22f0a$var$experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') throw new Error('Not a valid GraphQL document.');
        $6f4afc5439e22f0a$var$docCache.set(cacheKey, $6f4afc5439e22f0a$var$stripLoc($6f4afc5439e22f0a$var$processFragments(parsed)));
    }
    return $6f4afc5439e22f0a$var$docCache.get(cacheKey);
}
function $6f4afc5439e22f0a$export$72e4926bf8358653(literals) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (typeof literals === 'string') literals = [
        literals
    ];
    var result = literals[0];
    args.forEach(function(arg, i) {
        if (arg && arg.kind === 'Document') result += arg.loc.source.body;
        else result += arg;
        result += literals[i + 1];
    });
    return $6f4afc5439e22f0a$var$parseDocument(result);
}
function $6f4afc5439e22f0a$export$657554ef4dc7ac2d() {
    $6f4afc5439e22f0a$var$docCache.clear();
    $6f4afc5439e22f0a$var$fragmentSourceMap.clear();
}
function $6f4afc5439e22f0a$export$e4294e638636c6ab() {
    $6f4afc5439e22f0a$var$printFragmentWarnings = false;
}
function $6f4afc5439e22f0a$export$78cf889af350c840() {
    $6f4afc5439e22f0a$var$experimentalFragmentVariables = true;
}
function $6f4afc5439e22f0a$export$5290df9bbbd3cfa() {
    $6f4afc5439e22f0a$var$experimentalFragmentVariables = false;
}
var $6f4afc5439e22f0a$var$extras = {
    gql: $6f4afc5439e22f0a$export$72e4926bf8358653,
    resetCaches: $6f4afc5439e22f0a$export$657554ef4dc7ac2d,
    disableFragmentWarnings: $6f4afc5439e22f0a$export$e4294e638636c6ab,
    enableExperimentalFragmentVariables: $6f4afc5439e22f0a$export$78cf889af350c840,
    disableExperimentalFragmentVariables: $6f4afc5439e22f0a$export$5290df9bbbd3cfa
};
(function(gql_1) {
    gql_1.gql = $6f4afc5439e22f0a$var$extras.gql, gql_1.resetCaches = $6f4afc5439e22f0a$var$extras.resetCaches, gql_1.disableFragmentWarnings = $6f4afc5439e22f0a$var$extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = $6f4afc5439e22f0a$var$extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = $6f4afc5439e22f0a$var$extras.disableExperimentalFragmentVariables;
})($6f4afc5439e22f0a$export$72e4926bf8358653 || ($6f4afc5439e22f0a$export$72e4926bf8358653 = {}));
$6f4afc5439e22f0a$export$72e4926bf8358653["default"] = $6f4afc5439e22f0a$export$72e4926bf8358653;
var $6f4afc5439e22f0a$export$2e2bcd8739ae039 = $6f4afc5439e22f0a$export$72e4926bf8358653;

});
parcelRegister("6ds0g", function(module, exports) {

$parcel$export(module.exports, "parse", () => $d396d90054ce02d1$export$98e6a39c04603d36);
$parcel$export(module.exports, "parseValue", () => $d396d90054ce02d1$export$5303528d1070ff6f);

var $l48s6 = parcelRequire("l48s6");

var $1c4hI = parcelRequire("1c4hI");

var $c8MIO = parcelRequire("c8MIO");

var $hFu5F = parcelRequire("hFu5F");

var $7vqrl = parcelRequire("7vqrl");

var $5hGV7 = parcelRequire("5hGV7");

var $b5rqB = parcelRequire("b5rqB");
function $d396d90054ce02d1$export$98e6a39c04603d36(source, options) {
    var parser = new $d396d90054ce02d1$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $d396d90054ce02d1$export$5303528d1070ff6f(source, options) {
    var parser = new $d396d90054ce02d1$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $hFu5F.TokenKind).SOF);
    var value = parser.parseValueLiteral(false);
    parser.expectToken((0, $hFu5F.TokenKind).EOF);
    return value;
}
function $d396d90054ce02d1$export$28b8f402ccc88182(source, options) {
    var parser = new $d396d90054ce02d1$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $hFu5F.TokenKind).SOF);
    var type = parser.parseTypeReference();
    parser.expectToken((0, $hFu5F.TokenKind).EOF);
    return type;
}
var $d396d90054ce02d1$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser(source, options) {
        var sourceObj = (0, $7vqrl.isSource)(source) ? source : new (0, $7vqrl.Source)(source);
        this._lexer = new (0, $b5rqB.Lexer)(sourceObj);
        this._options = options;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ var _proto = Parser.prototype;
    _proto.parseName = function parseName() {
        var token = this.expectToken((0, $hFu5F.TokenKind).NAME);
        return {
            kind: (0, $1c4hI.Kind).NAME,
            value: token.value,
            loc: this.loc(token)
        };
    } // Implements the parsing rules in the Document section.
     /**
   * Document : Definition+
   */ ;
    _proto.parseDocument = function parseDocument() {
        var start = this._lexer.token;
        return {
            kind: (0, $1c4hI.Kind).DOCUMENT,
            definitions: this.many((0, $hFu5F.TokenKind).SOF, this.parseDefinition, (0, $hFu5F.TokenKind).EOF),
            loc: this.loc(start)
        };
    } /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */ ;
    _proto.parseDefinition = function parseDefinition() {
        if (this.peek((0, $hFu5F.TokenKind).NAME)) switch(this._lexer.token.value){
            case 'query':
            case 'mutation':
            case 'subscription':
                return this.parseOperationDefinition();
            case 'fragment':
                return this.parseFragmentDefinition();
            case 'schema':
            case 'scalar':
            case 'type':
            case 'interface':
            case 'union':
            case 'enum':
            case 'input':
            case 'directive':
                return this.parseTypeSystemDefinition();
            case 'extend':
                return this.parseTypeSystemExtension();
        }
        else if (this.peek((0, $hFu5F.TokenKind).BRACE_L)) return this.parseOperationDefinition();
        else if (this.peekDescription()) return this.parseTypeSystemDefinition();
        throw this.unexpected();
    } // Implements the parsing rules in the Operations section.
     /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ ;
    _proto.parseOperationDefinition = function parseOperationDefinition() {
        var start = this._lexer.token;
        if (this.peek((0, $hFu5F.TokenKind).BRACE_L)) return {
            kind: (0, $1c4hI.Kind).OPERATION_DEFINITION,
            operation: 'query',
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        var operation = this.parseOperationType();
        var name;
        if (this.peek((0, $hFu5F.TokenKind).NAME)) name = this.parseName();
        return {
            kind: (0, $1c4hI.Kind).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * OperationType : one of query mutation subscription
   */ ;
    _proto.parseOperationType = function parseOperationType() {
        var operationToken = this.expectToken((0, $hFu5F.TokenKind).NAME);
        switch(operationToken.value){
            case 'query':
                return 'query';
            case 'mutation':
                return 'mutation';
            case 'subscription':
                return 'subscription';
        }
        throw this.unexpected(operationToken);
    } /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ ;
    _proto.parseVariableDefinitions = function parseVariableDefinitions() {
        return this.optionalMany((0, $hFu5F.TokenKind).PAREN_L, this.parseVariableDefinition, (0, $hFu5F.TokenKind).PAREN_R);
    } /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseVariableDefinition = function parseVariableDefinition() {
        var start = this._lexer.token;
        return {
            kind: (0, $1c4hI.Kind).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $hFu5F.TokenKind).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $hFu5F.TokenKind).EQUALS) ? this.parseValueLiteral(true) : undefined,
            directives: this.parseDirectives(true),
            loc: this.loc(start)
        };
    } /**
   * Variable : $ Name
   */ ;
    _proto.parseVariable = function parseVariable() {
        var start = this._lexer.token;
        this.expectToken((0, $hFu5F.TokenKind).DOLLAR);
        return {
            kind: (0, $1c4hI.Kind).VARIABLE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } /**
   * SelectionSet : { Selection+ }
   */ ;
    _proto.parseSelectionSet = function parseSelectionSet() {
        var start = this._lexer.token;
        return {
            kind: (0, $1c4hI.Kind).SELECTION_SET,
            selections: this.many((0, $hFu5F.TokenKind).BRACE_L, this.parseSelection, (0, $hFu5F.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ ;
    _proto.parseSelection = function parseSelection() {
        return this.peek((0, $hFu5F.TokenKind).SPREAD) ? this.parseFragment() : this.parseField();
    } /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ ;
    _proto.parseField = function parseField() {
        var start = this._lexer.token;
        var nameOrAlias = this.parseName();
        var alias;
        var name;
        if (this.expectOptionalToken((0, $hFu5F.TokenKind).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return {
            kind: (0, $1c4hI.Kind).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $hFu5F.TokenKind).BRACE_L) ? this.parseSelectionSet() : undefined,
            loc: this.loc(start)
        };
    } /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ ;
    _proto.parseArguments = function parseArguments(isConst) {
        var item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $hFu5F.TokenKind).PAREN_L, item, (0, $hFu5F.TokenKind).PAREN_R);
    } /**
   * Argument[Const] : Name : Value[?Const]
   */ ;
    _proto.parseArgument = function parseArgument() {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $hFu5F.TokenKind).COLON);
        return {
            kind: (0, $1c4hI.Kind).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(false),
            loc: this.loc(start)
        };
    };
    _proto.parseConstArgument = function parseConstArgument() {
        var start = this._lexer.token;
        return {
            kind: (0, $1c4hI.Kind).ARGUMENT,
            name: this.parseName(),
            value: (this.expectToken((0, $hFu5F.TokenKind).COLON), this.parseValueLiteral(true)),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Fragments section.
     /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ ;
    _proto.parseFragment = function parseFragment() {
        var start = this._lexer.token;
        this.expectToken((0, $hFu5F.TokenKind).SPREAD);
        var hasTypeCondition = this.expectOptionalKeyword('on');
        if (!hasTypeCondition && this.peek((0, $hFu5F.TokenKind).NAME)) return {
            kind: (0, $1c4hI.Kind).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false),
            loc: this.loc(start)
        };
        return {
            kind: (0, $1c4hI.Kind).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ ;
    _proto.parseFragmentDefinition = function parseFragmentDefinition() {
        var _this$_options;
        var start = this._lexer.token;
        this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) return {
            kind: (0, $1c4hI.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
        return {
            kind: (0, $1c4hI.Kind).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet(),
            loc: this.loc(start)
        };
    } /**
   * FragmentName : Name but not `on`
   */ ;
    _proto.parseFragmentName = function parseFragmentName() {
        if (this._lexer.token.value === 'on') throw this.unexpected();
        return this.parseName();
    } // Implements the parsing rules in the Values section.
     /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ ;
    _proto.parseValueLiteral = function parseValueLiteral(isConst) {
        var token = this._lexer.token;
        switch(token.kind){
            case (0, $hFu5F.TokenKind).BRACKET_L:
                return this.parseList(isConst);
            case (0, $hFu5F.TokenKind).BRACE_L:
                return this.parseObject(isConst);
            case (0, $hFu5F.TokenKind).INT:
                this._lexer.advance();
                return {
                    kind: (0, $1c4hI.Kind).INT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $hFu5F.TokenKind).FLOAT:
                this._lexer.advance();
                return {
                    kind: (0, $1c4hI.Kind).FLOAT,
                    value: token.value,
                    loc: this.loc(token)
                };
            case (0, $hFu5F.TokenKind).STRING:
            case (0, $hFu5F.TokenKind).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $hFu5F.TokenKind).NAME:
                this._lexer.advance();
                switch(token.value){
                    case 'true':
                        return {
                            kind: (0, $1c4hI.Kind).BOOLEAN,
                            value: true,
                            loc: this.loc(token)
                        };
                    case 'false':
                        return {
                            kind: (0, $1c4hI.Kind).BOOLEAN,
                            value: false,
                            loc: this.loc(token)
                        };
                    case 'null':
                        return {
                            kind: (0, $1c4hI.Kind).NULL,
                            loc: this.loc(token)
                        };
                    default:
                        return {
                            kind: (0, $1c4hI.Kind).ENUM,
                            value: token.value,
                            loc: this.loc(token)
                        };
                }
            case (0, $hFu5F.TokenKind).DOLLAR:
                if (!isConst) return this.parseVariable();
                break;
        }
        throw this.unexpected();
    };
    _proto.parseStringLiteral = function parseStringLiteral() {
        var token = this._lexer.token;
        this._lexer.advance();
        return {
            kind: (0, $1c4hI.Kind).STRING,
            value: token.value,
            block: token.kind === (0, $hFu5F.TokenKind).BLOCK_STRING,
            loc: this.loc(token)
        };
    } /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ ;
    _proto.parseList = function parseList(isConst) {
        var _this = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this.parseValueLiteral(isConst);
        };
        return {
            kind: (0, $1c4hI.Kind).LIST,
            values: this.any((0, $hFu5F.TokenKind).BRACKET_L, item, (0, $hFu5F.TokenKind).BRACKET_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */ ;
    _proto.parseObject = function parseObject(isConst) {
        var _this2 = this;
        var start = this._lexer.token;
        var item = function item() {
            return _this2.parseObjectField(isConst);
        };
        return {
            kind: (0, $1c4hI.Kind).OBJECT,
            fields: this.any((0, $hFu5F.TokenKind).BRACE_L, item, (0, $hFu5F.TokenKind).BRACE_R),
            loc: this.loc(start)
        };
    } /**
   * ObjectField[Const] : Name : Value[?Const]
   */ ;
    _proto.parseObjectField = function parseObjectField(isConst) {
        var start = this._lexer.token;
        var name = this.parseName();
        this.expectToken((0, $hFu5F.TokenKind).COLON);
        return {
            kind: (0, $1c4hI.Kind).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Directives section.
     /**
   * Directives[Const] : Directive[?Const]+
   */ ;
    _proto.parseDirectives = function parseDirectives(isConst) {
        var directives = [];
        while(this.peek((0, $hFu5F.TokenKind).AT))directives.push(this.parseDirective(isConst));
        return directives;
    } /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */ ;
    _proto.parseDirective = function parseDirective(isConst) {
        var start = this._lexer.token;
        this.expectToken((0, $hFu5F.TokenKind).AT);
        return {
            kind: (0, $1c4hI.Kind).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Types section.
     /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ ;
    _proto.parseTypeReference = function parseTypeReference() {
        var start = this._lexer.token;
        var type;
        if (this.expectOptionalToken((0, $hFu5F.TokenKind).BRACKET_L)) {
            type = this.parseTypeReference();
            this.expectToken((0, $hFu5F.TokenKind).BRACKET_R);
            type = {
                kind: (0, $1c4hI.Kind).LIST_TYPE,
                type: type,
                loc: this.loc(start)
            };
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $hFu5F.TokenKind).BANG)) return {
            kind: (0, $1c4hI.Kind).NON_NULL_TYPE,
            type: type,
            loc: this.loc(start)
        };
        return type;
    } /**
   * NamedType : Name
   */ ;
    _proto.parseNamedType = function parseNamedType() {
        var start = this._lexer.token;
        return {
            kind: (0, $1c4hI.Kind).NAMED_TYPE,
            name: this.parseName(),
            loc: this.loc(start)
        };
    } // Implements the parsing rules in the Type Definition section.
     /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
        // Many definitions begin with a description and require a lookahead.
        var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $hFu5F.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaDefinition();
            case 'scalar':
                return this.parseScalarTypeDefinition();
            case 'type':
                return this.parseObjectTypeDefinition();
            case 'interface':
                return this.parseInterfaceTypeDefinition();
            case 'union':
                return this.parseUnionTypeDefinition();
            case 'enum':
                return this.parseEnumTypeDefinition();
            case 'input':
                return this.parseInputObjectTypeDefinition();
            case 'directive':
                return this.parseDirectiveDefinition();
        }
        throw this.unexpected(keywordToken);
    };
    _proto.peekDescription = function peekDescription() {
        return this.peek((0, $hFu5F.TokenKind).STRING) || this.peek((0, $hFu5F.TokenKind).BLOCK_STRING);
    } /**
   * Description : StringValue
   */ ;
    _proto.parseDescription = function parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    } /**
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   */ ;
    _proto.parseSchemaDefinition = function parseSchemaDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.many((0, $hFu5F.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $hFu5F.TokenKind).BRACE_R);
        return {
            kind: (0, $1c4hI.Kind).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * OperationTypeDefinition : OperationType : NamedType
   */ ;
    _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
        var start = this._lexer.token;
        var operation = this.parseOperationType();
        this.expectToken((0, $hFu5F.TokenKind).COLON);
        var type = this.parseNamedType();
        return {
            kind: (0, $1c4hI.Kind).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ ;
    _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $1c4hI.Kind).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $1c4hI.Kind).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ ;
    _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
        var _this$_options2;
        if (!this.expectOptionalKeyword('implements')) return [];
        if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
            var types = []; // Optional leading ampersand
            this.expectOptionalToken((0, $hFu5F.TokenKind).AMP);
            do types.push(this.parseNamedType());
            while (this.expectOptionalToken((0, $hFu5F.TokenKind).AMP) || this.peek((0, $hFu5F.TokenKind).NAME));
            return types;
        }
        return this.delimitedMany((0, $hFu5F.TokenKind).AMP, this.parseNamedType);
    } /**
   * FieldsDefinition : { FieldDefinition+ }
   */ ;
    _proto.parseFieldsDefinition = function parseFieldsDefinition() {
        var _this$_options3;
        // Legacy support for the SDL?
        if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek((0, $hFu5F.TokenKind).BRACE_L) && this._lexer.lookahead().kind === (0, $hFu5F.TokenKind).BRACE_R) {
            this._lexer.advance();
            this._lexer.advance();
            return [];
        }
        return this.optionalMany((0, $hFu5F.TokenKind).BRACE_L, this.parseFieldDefinition, (0, $hFu5F.TokenKind).BRACE_R);
    } /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ ;
    _proto.parseFieldDefinition = function parseFieldDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        this.expectToken((0, $hFu5F.TokenKind).COLON);
        var type = this.parseTypeReference();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $1c4hI.Kind).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ ;
    _proto.parseArgumentDefs = function parseArgumentDefs() {
        return this.optionalMany((0, $hFu5F.TokenKind).PAREN_L, this.parseInputValueDef, (0, $hFu5F.TokenKind).PAREN_R);
    } /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ ;
    _proto.parseInputValueDef = function parseInputValueDef() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        this.expectToken((0, $hFu5F.TokenKind).COLON);
        var type = this.parseTypeReference();
        var defaultValue;
        if (this.expectOptionalToken((0, $hFu5F.TokenKind).EQUALS)) defaultValue = this.parseValueLiteral(true);
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $1c4hI.Kind).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ ;
    _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        return {
            kind: (0, $1c4hI.Kind).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ ;
    _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        return {
            kind: (0, $1c4hI.Kind).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ ;
    _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $hFu5F.TokenKind).EQUALS) ? this.delimitedMany((0, $hFu5F.TokenKind).PIPE, this.parseNamedType) : [];
    } /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ ;
    _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        return {
            kind: (0, $1c4hI.Kind).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */ ;
    _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
        return this.optionalMany((0, $hFu5F.TokenKind).BRACE_L, this.parseEnumValueDefinition, (0, $hFu5F.TokenKind).BRACE_R);
    } /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */ ;
    _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        return {
            kind: (0, $1c4hI.Kind).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ ;
    _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        return {
            kind: (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */ ;
    _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
        return this.optionalMany((0, $hFu5F.TokenKind).BRACE_L, this.parseInputValueDef, (0, $hFu5F.TokenKind).BRACE_R);
    } /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ ;
    _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
        var keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $hFu5F.TokenKind).NAME) switch(keywordToken.value){
            case 'schema':
                return this.parseSchemaExtension();
            case 'scalar':
                return this.parseScalarTypeExtension();
            case 'type':
                return this.parseObjectTypeExtension();
            case 'interface':
                return this.parseInterfaceTypeExtension();
            case 'union':
                return this.parseUnionTypeExtension();
            case 'enum':
                return this.parseEnumTypeExtension();
            case 'input':
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    } /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */ ;
    _proto.parseSchemaExtension = function parseSchemaExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('schema');
        var directives = this.parseDirectives(true);
        var operationTypes = this.optionalMany((0, $hFu5F.TokenKind).BRACE_L, this.parseOperationTypeDefinition, (0, $hFu5F.TokenKind).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes,
            loc: this.loc(start)
        };
    } /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ ;
    _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('scalar');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        if (directives.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives,
            loc: this.loc(start)
        };
    } /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ ;
    _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('type');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ ;
    _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('interface');
        var name = this.parseName();
        var interfaces = this.parseImplementsInterfaces();
        var directives = this.parseDirectives(true);
        var fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ ;
    _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('union');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types,
            loc: this.loc(start)
        };
    } /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ ;
    _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('enum');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values,
            loc: this.loc(start)
        };
    } /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ ;
    _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
        var start = this._lexer.token;
        this.expectKeyword('extend');
        this.expectKeyword('input');
        var name = this.parseName();
        var directives = this.parseDirectives(true);
        var fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return {
            kind: (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields,
            loc: this.loc(start)
        };
    } /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */ ;
    _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
        var start = this._lexer.token;
        var description = this.parseDescription();
        this.expectKeyword('directive');
        this.expectToken((0, $hFu5F.TokenKind).AT);
        var name = this.parseName();
        var args = this.parseArgumentDefs();
        var repeatable = this.expectOptionalKeyword('repeatable');
        this.expectKeyword('on');
        var locations = this.parseDirectiveLocations();
        return {
            kind: (0, $1c4hI.Kind).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations,
            loc: this.loc(start)
        };
    } /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ ;
    _proto.parseDirectiveLocations = function parseDirectiveLocations() {
        return this.delimitedMany((0, $hFu5F.TokenKind).PIPE, this.parseDirectiveLocation);
    } /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ ;
    _proto.parseDirectiveLocation = function parseDirectiveLocation() {
        var start = this._lexer.token;
        var name = this.parseName();
        if ((0, $5hGV7.DirectiveLocation)[name.value] !== undefined) return name;
        throw this.unexpected(start);
    } // Core parsing utility functions
     /**
   * Returns a location object, used to identify the place in the source that created a given parsed object.
   */ ;
    _proto.loc = function loc(startToken) {
        var _this$_options4;
        if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) return new (0, $c8MIO.Location)(startToken, this._lexer.lastToken, this._lexer.source);
    } /**
   * Determines if the next token is of a given kind
   */ ;
    _proto.peek = function peek(kind) {
        return this._lexer.token.kind === kind;
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectToken = function expectToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        throw (0, $l48s6.syntaxError)(this._lexer.source, token.start, "Expected ".concat($d396d90054ce02d1$var$getTokenKindDesc(kind), ", found ").concat($d396d90054ce02d1$var$getTokenDesc(token), "."));
    } /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and return undefined.
   */ ;
    _proto.expectOptionalToken = function expectOptionalToken(kind) {
        var token = this._lexer.token;
        if (token.kind === kind) {
            this._lexer.advance();
            return token;
        }
        return undefined;
    } /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ ;
    _proto.expectKeyword = function expectKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $hFu5F.TokenKind).NAME && token.value === value) this._lexer.advance();
        else throw (0, $l48s6.syntaxError)(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat($d396d90054ce02d1$var$getTokenDesc(token), "."));
    } /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ ;
    _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
        var token = this._lexer.token;
        if (token.kind === (0, $hFu5F.TokenKind).NAME && token.value === value) {
            this._lexer.advance();
            return true;
        }
        return false;
    } /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ ;
    _proto.unexpected = function unexpected(atToken) {
        var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $l48s6.syntaxError)(this._lexer.source, token.start, "Unexpected ".concat($d396d90054ce02d1$var$getTokenDesc(token), "."));
    } /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.any = function any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    } /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            var nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ ;
    _proto.many = function many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    } /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ ;
    _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        var nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    };
    return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */ function $d396d90054ce02d1$var$getTokenDesc(token) {
    var value = token.value;
    return $d396d90054ce02d1$var$getTokenKindDesc(token.kind) + (value != null ? " \"".concat(value, "\"") : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $d396d90054ce02d1$var$getTokenKindDesc(kind) {
    return (0, $b5rqB.isPunctuatorTokenKind)(kind) ? "\"".concat(kind, "\"") : kind;
}

});
parcelRegister("l48s6", function(module, exports) {

$parcel$export(module.exports, "syntaxError", () => $6cdd0c9c097dfc31$export$bbee0c6176c019d4);

var $9fgMZ = parcelRequire("9fgMZ");
function $6cdd0c9c097dfc31$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $9fgMZ.GraphQLError)("Syntax Error: ".concat(description), undefined, source, [
        position
    ]);
}

});
parcelRegister("9fgMZ", function(module, exports) {

$parcel$export(module.exports, "GraphQLError", () => $20ec348cfe64bfcc$export$92d6ed0888e7cb7f);

var $fbtyx = parcelRequire("fbtyx");

var $gwa3m = parcelRequire("gwa3m");

var $cBRMW = parcelRequire("cBRMW");

var $5LGuP = parcelRequire("5LGuP");
function $20ec348cfe64bfcc$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $20ec348cfe64bfcc$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $20ec348cfe64bfcc$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $20ec348cfe64bfcc$var$_typeof(obj);
}
function $20ec348cfe64bfcc$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $20ec348cfe64bfcc$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $20ec348cfe64bfcc$var$ownKeys(Object(source), true).forEach(function(key) {
            $20ec348cfe64bfcc$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $20ec348cfe64bfcc$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $20ec348cfe64bfcc$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $20ec348cfe64bfcc$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $20ec348cfe64bfcc$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $20ec348cfe64bfcc$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $20ec348cfe64bfcc$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $20ec348cfe64bfcc$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $20ec348cfe64bfcc$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $20ec348cfe64bfcc$var$_setPrototypeOf(subClass, superClass);
}
function $20ec348cfe64bfcc$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $20ec348cfe64bfcc$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $20ec348cfe64bfcc$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $20ec348cfe64bfcc$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $20ec348cfe64bfcc$var$_possibleConstructorReturn(this, result);
    };
}
function $20ec348cfe64bfcc$var$_possibleConstructorReturn(self, call) {
    if (call && ($20ec348cfe64bfcc$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $20ec348cfe64bfcc$var$_assertThisInitialized(self);
}
function $20ec348cfe64bfcc$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $20ec348cfe64bfcc$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $20ec348cfe64bfcc$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$20ec348cfe64bfcc$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $20ec348cfe64bfcc$var$_construct(Class, arguments, $20ec348cfe64bfcc$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $20ec348cfe64bfcc$var$_setPrototypeOf(Wrapper, Class);
    };
    return $20ec348cfe64bfcc$var$_wrapNativeSuper(Class);
}
function $20ec348cfe64bfcc$var$_construct(Parent, args, Class) {
    if ($20ec348cfe64bfcc$var$_isNativeReflectConstruct()) $20ec348cfe64bfcc$var$_construct = Reflect.construct;
    else $20ec348cfe64bfcc$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $20ec348cfe64bfcc$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $20ec348cfe64bfcc$var$_construct.apply(null, arguments);
}
function $20ec348cfe64bfcc$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $20ec348cfe64bfcc$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $20ec348cfe64bfcc$var$_setPrototypeOf(o, p) {
    $20ec348cfe64bfcc$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $20ec348cfe64bfcc$var$_setPrototypeOf(o, p);
}
function $20ec348cfe64bfcc$var$_getPrototypeOf(o) {
    $20ec348cfe64bfcc$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $20ec348cfe64bfcc$var$_getPrototypeOf(o);
}
var $20ec348cfe64bfcc$export$92d6ed0888e7cb7f = /*#__PURE__*/ function(_Error) {
    $20ec348cfe64bfcc$var$_inherits(GraphQLError, _Error);
    var _super = $20ec348cfe64bfcc$var$_createSuper(GraphQLError);
    /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
        var _nodeLocations, _nodeLocations2, _nodeLocations3;
        var _this;
        $20ec348cfe64bfcc$var$_classCallCheck(this, GraphQLError);
        _this = _super.call(this, message);
        _this.name = 'GraphQLError';
        _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        _this.nodes = $20ec348cfe64bfcc$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        var nodeLocations = [];
        for(var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++){
            var _this$nodes;
            var _ref4 = _ref3[_i2];
            var loc = _ref4.loc;
            if (loc != null) nodeLocations.push(loc);
        }
        nodeLocations = $20ec348cfe64bfcc$var$undefinedIfEmpty(nodeLocations); // Compute locations in the source for the given nodes/positions.
        _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
        _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function(loc) {
            return loc.start;
        });
        _this.locations = positions && source ? positions.map(function(pos) {
            return (0, $cBRMW.getLocation)(source, pos);
        }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function(loc) {
            return (0, $cBRMW.getLocation)(loc.source, loc.start);
        });
        _this.path = path !== null && path !== void 0 ? path : undefined;
        var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;
        if (extensions == null && (0, $fbtyx.default)(originalExtensions)) _this.extensions = $20ec348cfe64bfcc$var$_objectSpread({}, originalExtensions);
        else _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
         // By being enumerable, JSON.stringify will include bellow properties in the resulting output.
        // This ensures that the simplest possible GraphQL service adheres to the spec.
        Object.defineProperties($20ec348cfe64bfcc$var$_assertThisInitialized(_this), {
            message: {
                enumerable: true
            },
            locations: {
                enumerable: _this.locations != null
            },
            path: {
                enumerable: _this.path != null
            },
            extensions: {
                enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        if (originalError !== null && originalError !== void 0 && originalError.stack) {
            Object.defineProperty($20ec348cfe64bfcc$var$_assertThisInitialized(_this), 'stack', {
                value: originalError.stack,
                writable: true,
                configurable: true
            });
            return $20ec348cfe64bfcc$var$_possibleConstructorReturn(_this);
        } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
        if (Error.captureStackTrace) Error.captureStackTrace($20ec348cfe64bfcc$var$_assertThisInitialized(_this), GraphQLError);
        else Object.defineProperty($20ec348cfe64bfcc$var$_assertThisInitialized(_this), 'stack', {
            value: Error().stack,
            writable: true,
            configurable: true
        });
        return _this;
    }
    $20ec348cfe64bfcc$var$_createClass(GraphQLError, [
        {
            key: "toString",
            value: function toString() {
                return $20ec348cfe64bfcc$export$55ee1551a3f962e6(this);
            } // FIXME: workaround to not break chai comparisons, should be remove in v16
        },
        {
            key: (0, $gwa3m.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'Object';
            }
        }
    ]);
    return GraphQLError;
}(/*#__PURE__*/ $20ec348cfe64bfcc$var$_wrapNativeSuper(Error));
function $20ec348cfe64bfcc$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $20ec348cfe64bfcc$export$55ee1551a3f962e6(error) {
    var output = error.message;
    if (error.nodes) for(var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++){
        var node = _error$nodes2[_i4];
        if (node.loc) output += '\n\n' + (0, $5LGuP.printLocation)(node.loc);
    }
    else if (error.source && error.locations) for(var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++){
        var location = _error$locations2[_i6];
        output += '\n\n' + (0, $5LGuP.printSourceLocation)(error.source, location);
    }
    return output;
}

});
parcelRegister("fbtyx", function(module, exports) {

$parcel$export(module.exports, "default", () => $700b00a777571467$export$2e2bcd8739ae039);
function $700b00a777571467$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $700b00a777571467$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $700b00a777571467$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $700b00a777571467$var$_typeof(obj);
}
function $700b00a777571467$export$2e2bcd8739ae039(value) {
    return $700b00a777571467$var$_typeof(value) == 'object' && value !== null;
}

});

parcelRegister("gwa3m", function(module, exports) {

$parcel$export(module.exports, "SYMBOL_ITERATOR", () => $84dde8096e41b064$export$f6cdee3c26d6da57);
$parcel$export(module.exports, "SYMBOL_ASYNC_ITERATOR", () => $84dde8096e41b064$export$8d0083df0471478e);
$parcel$export(module.exports, "SYMBOL_TO_STRING_TAG", () => $84dde8096e41b064$export$5deadc579ccc7c9c);
// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $84dde8096e41b064$export$f6cdee3c26d6da57 = typeof Symbol === 'function' && Symbol.iterator != null ? Symbol.iterator : '@@iterator'; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var $84dde8096e41b064$export$8d0083df0471478e = typeof Symbol === 'function' && Symbol.asyncIterator != null ? Symbol.asyncIterator : '@@asyncIterator'; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var $84dde8096e41b064$export$5deadc579ccc7c9c = typeof Symbol === 'function' && Symbol.toStringTag != null ? Symbol.toStringTag : '@@toStringTag';

});

parcelRegister("cBRMW", function(module, exports) {

$parcel$export(module.exports, "getLocation", () => $d7d707e8e9ee9fd6$export$e7fd20fad3cf4b5f);
/**
 * Represents a location in a Source.
 */ /**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */ function $d7d707e8e9ee9fd6$export$e7fd20fad3cf4b5f(source, position) {
    var lineRegexp = /\r\n|[\n\r]/g;
    var line = 1;
    var column = position + 1;
    var match;
    while((match = lineRegexp.exec(source.body)) && match.index < position){
        line += 1;
        column = position + 1 - (match.index + match[0].length);
    }
    return {
        line: line,
        column: column
    };
}

});

parcelRegister("5LGuP", function(module, exports) {

$parcel$export(module.exports, "printLocation", () => $66f0d94dee1ae1b2$export$96a9681e539deed);
$parcel$export(module.exports, "printSourceLocation", () => $66f0d94dee1ae1b2$export$867940333fd9f869);

var $cBRMW = parcelRequire("cBRMW");
function $66f0d94dee1ae1b2$export$96a9681e539deed(location) {
    return $66f0d94dee1ae1b2$export$867940333fd9f869(location.source, (0, $cBRMW.getLocation)(location.source, location.start));
}
function $66f0d94dee1ae1b2$export$867940333fd9f869(source, sourceLocation) {
    var firstLineColumnOffset = source.locationOffset.column - 1;
    var body = $66f0d94dee1ae1b2$var$whitespace(firstLineColumnOffset) + source.body;
    var lineIndex = sourceLocation.line - 1;
    var lineOffset = source.locationOffset.line - 1;
    var lineNum = sourceLocation.line + lineOffset;
    var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    var columnNum = sourceLocation.column + columnOffset;
    var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
    var lines = body.split(/\r\n|[\n\r]/g);
    var locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        var subLineIndex = Math.floor(columnNum / 80);
        var subLineColumnNum = columnNum % 80;
        var subLines = [];
        for(var i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $66f0d94dee1ae1b2$var$printPrefixedLines([
            [
                "".concat(lineNum),
                subLines[0]
            ]
        ].concat(subLines.slice(1, subLineIndex + 1).map(function(subLine) {
            return [
                '',
                subLine
            ];
        }), [
            [
                ' ',
                $66f0d94dee1ae1b2$var$whitespace(subLineColumnNum - 1) + '^'
            ],
            [
                '',
                subLines[subLineIndex + 1]
            ]
        ]));
    }
    return locationStr + $66f0d94dee1ae1b2$var$printPrefixedLines([
        [
            "".concat(lineNum - 1),
            lines[lineIndex - 1]
        ],
        [
            "".concat(lineNum),
            locationLine
        ],
        [
            '',
            $66f0d94dee1ae1b2$var$whitespace(columnNum - 1) + '^'
        ],
        [
            "".concat(lineNum + 1),
            lines[lineIndex + 1]
        ]
    ]);
}
function $66f0d94dee1ae1b2$var$printPrefixedLines(lines) {
    var existingLines = lines.filter(function(_ref) {
        var _ = _ref[0], line = _ref[1];
        return line !== undefined;
    });
    var padLen = Math.max.apply(Math, existingLines.map(function(_ref2) {
        var prefix = _ref2[0];
        return prefix.length;
    }));
    return existingLines.map(function(_ref3) {
        var prefix = _ref3[0], line = _ref3[1];
        return $66f0d94dee1ae1b2$var$leftPad(padLen, prefix) + (line ? ' | ' + line : ' |');
    }).join('\n');
}
function $66f0d94dee1ae1b2$var$whitespace(len) {
    return Array(len + 1).join(' ');
}
function $66f0d94dee1ae1b2$var$leftPad(len, str) {
    return $66f0d94dee1ae1b2$var$whitespace(len - str.length) + str;
}

});



parcelRegister("1c4hI", function(module, exports) {

$parcel$export(module.exports, "Kind", () => $1bf9b417a1cf9d08$export$a84bdc57c5122798);
/**
 * The set of allowed kind values for AST nodes.
 */ var $1bf9b417a1cf9d08$export$a84bdc57c5122798 = Object.freeze({
    // Name
    NAME: 'Name',
    // Document
    DOCUMENT: 'Document',
    OPERATION_DEFINITION: 'OperationDefinition',
    VARIABLE_DEFINITION: 'VariableDefinition',
    SELECTION_SET: 'SelectionSet',
    FIELD: 'Field',
    ARGUMENT: 'Argument',
    // Fragments
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_FRAGMENT: 'InlineFragment',
    FRAGMENT_DEFINITION: 'FragmentDefinition',
    // Values
    VARIABLE: 'Variable',
    INT: 'IntValue',
    FLOAT: 'FloatValue',
    STRING: 'StringValue',
    BOOLEAN: 'BooleanValue',
    NULL: 'NullValue',
    ENUM: 'EnumValue',
    LIST: 'ListValue',
    OBJECT: 'ObjectValue',
    OBJECT_FIELD: 'ObjectField',
    // Directives
    DIRECTIVE: 'Directive',
    // Types
    NAMED_TYPE: 'NamedType',
    LIST_TYPE: 'ListType',
    NON_NULL_TYPE: 'NonNullType',
    // Type System Definitions
    SCHEMA_DEFINITION: 'SchemaDefinition',
    OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
    // Type Definitions
    SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
    OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
    FIELD_DEFINITION: 'FieldDefinition',
    INPUT_VALUE_DEFINITION: 'InputValueDefinition',
    INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
    UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
    ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
    ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
    INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
    // Directive Definitions
    DIRECTIVE_DEFINITION: 'DirectiveDefinition',
    // Type System Extensions
    SCHEMA_EXTENSION: 'SchemaExtension',
    // Type Extensions
    SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
    OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
    INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
    UNION_TYPE_EXTENSION: 'UnionTypeExtension',
    ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
    INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
}); /**
 * The enum type representing the possible kind values of AST nodes.
 */ 

});

parcelRegister("hFu5F", function(module, exports) {

$parcel$export(module.exports, "TokenKind", () => $7350b511ab98151f$export$8b9d26ab11394711);
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $7350b511ab98151f$export$8b9d26ab11394711 = Object.freeze({
    SOF: '<SOF>',
    EOF: '<EOF>',
    BANG: '!',
    DOLLAR: '$',
    AMP: '&',
    PAREN_L: '(',
    PAREN_R: ')',
    SPREAD: '...',
    COLON: ':',
    EQUALS: '=',
    AT: '@',
    BRACKET_L: '[',
    BRACKET_R: ']',
    BRACE_L: '{',
    PIPE: '|',
    BRACE_R: '}',
    NAME: 'Name',
    INT: 'Int',
    FLOAT: 'Float',
    STRING: 'String',
    BLOCK_STRING: 'BlockString',
    COMMENT: 'Comment'
}); /**
 * The enum type representing the token kinds values.
 */ 

});

parcelRegister("7vqrl", function(module, exports) {

$parcel$export(module.exports, "Source", () => $0269dc101dba4337$export$1d2df86270c81ecb);
$parcel$export(module.exports, "isSource", () => $0269dc101dba4337$export$75135ee9ed6e435b);

var $gwa3m = parcelRequire("gwa3m");

var $biK02 = parcelRequire("biK02");

var $fZdRY = parcelRequire("fZdRY");

var $aVhwC = parcelRequire("aVhwC");
function $0269dc101dba4337$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $0269dc101dba4337$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $0269dc101dba4337$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $0269dc101dba4337$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $0269dc101dba4337$export$1d2df86270c81ecb = /*#__PURE__*/ function() {
    function Source(body) {
        var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GraphQL request';
        var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
            line: 1,
            column: 1
        };
        typeof body === 'string' || (0, $fZdRY.default)(0, "Body must be a string. Received: ".concat((0, $biK02.default)(body), "."));
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $fZdRY.default)(0, 'line in locationOffset is 1-indexed and must be positive.');
        this.locationOffset.column > 0 || (0, $fZdRY.default)(0, 'column in locationOffset is 1-indexed and must be positive.');
    } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
    $0269dc101dba4337$var$_createClass(Source, [
        {
            key: (0, $gwa3m.SYMBOL_TO_STRING_TAG),
            get: function get() {
                return 'Source';
            }
        }
    ]);
    return Source;
}();
function $0269dc101dba4337$export$75135ee9ed6e435b(source) {
    return (0, $aVhwC.default)(source, $0269dc101dba4337$export$1d2df86270c81ecb);
}

});
parcelRegister("fZdRY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b04eb23f905f9ab5$export$2e2bcd8739ae039);
function $b04eb23f905f9ab5$export$2e2bcd8739ae039(condition, message) {
    var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')
    if (!booleanCondition) throw new Error(message);
}

});

parcelRegister("aVhwC", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef14998e21195a05$export$2e2bcd8739ae039);

function $ef14998e21195a05$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $ef14998e21195a05$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $ef14998e21195a05$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $ef14998e21195a05$var$_typeof(obj);
}
var /**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */ // See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
$ef14998e21195a05$export$2e2bcd8739ae039 = // eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
    return value instanceof constructor;
};

});


parcelRegister("5hGV7", function(module, exports) {

$parcel$export(module.exports, "DirectiveLocation", () => $d7161a38006ba9b3$export$b45ffd2948484c41);
/**
 * The set of allowed directive location values.
 */ var $d7161a38006ba9b3$export$b45ffd2948484c41 = Object.freeze({
    // Request Definitions
    QUERY: 'QUERY',
    MUTATION: 'MUTATION',
    SUBSCRIPTION: 'SUBSCRIPTION',
    FIELD: 'FIELD',
    FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
    FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
    INLINE_FRAGMENT: 'INLINE_FRAGMENT',
    VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
    // Type System Definitions
    SCHEMA: 'SCHEMA',
    SCALAR: 'SCALAR',
    OBJECT: 'OBJECT',
    FIELD_DEFINITION: 'FIELD_DEFINITION',
    ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
    INTERFACE: 'INTERFACE',
    UNION: 'UNION',
    ENUM: 'ENUM',
    ENUM_VALUE: 'ENUM_VALUE',
    INPUT_OBJECT: 'INPUT_OBJECT',
    INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
}); /**
 * The enum type representing the directive location values.
 */ 

});

parcelRegister("b5rqB", function(module, exports) {

$parcel$export(module.exports, "Lexer", () => $a5d33b5906ae43cc$export$6168dc8908a6c652);
$parcel$export(module.exports, "isPunctuatorTokenKind", () => $a5d33b5906ae43cc$export$59ac0f4da287406a);

var $l48s6 = parcelRequire("l48s6");

var $c8MIO = parcelRequire("c8MIO");

var $hFu5F = parcelRequire("hFu5F");

var $flA0a = parcelRequire("flA0a");
var $a5d33b5906ae43cc$export$6168dc8908a6c652 = /*#__PURE__*/ function() {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ function Lexer(source) {
        var startOfFileToken = new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).SOF, 0, 0, 0, 0, null);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ var _proto = Lexer.prototype;
    _proto.advance = function advance() {
        this.lastToken = this.token;
        var token = this.token = this.lookahead();
        return token;
    } /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ ;
    _proto.lookahead = function lookahead() {
        var token = this.token;
        if (token.kind !== (0, $hFu5F.TokenKind).EOF) do {
            var _token$next;
            // Note: next is only mutable during parsing, so we cast to allow this.
            token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = $a5d33b5906ae43cc$var$readToken(this, token);
        }while (token.kind === (0, $hFu5F.TokenKind).COMMENT);
        return token;
    };
    return Lexer;
}();
function $a5d33b5906ae43cc$export$59ac0f4da287406a(kind) {
    return kind === (0, $hFu5F.TokenKind).BANG || kind === (0, $hFu5F.TokenKind).DOLLAR || kind === (0, $hFu5F.TokenKind).AMP || kind === (0, $hFu5F.TokenKind).PAREN_L || kind === (0, $hFu5F.TokenKind).PAREN_R || kind === (0, $hFu5F.TokenKind).SPREAD || kind === (0, $hFu5F.TokenKind).COLON || kind === (0, $hFu5F.TokenKind).EQUALS || kind === (0, $hFu5F.TokenKind).AT || kind === (0, $hFu5F.TokenKind).BRACKET_L || kind === (0, $hFu5F.TokenKind).BRACKET_R || kind === (0, $hFu5F.TokenKind).BRACE_L || kind === (0, $hFu5F.TokenKind).PIPE || kind === (0, $hFu5F.TokenKind).BRACE_R;
}
function $a5d33b5906ae43cc$var$printCharCode(code) {
    return isNaN(code) ? (0, $hFu5F.TokenKind).EOF : code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"");
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $a5d33b5906ae43cc$var$readToken(lexer, prev) {
    var source = lexer.source;
    var body = source.body;
    var bodyLength = body.length;
    var pos = prev.end;
    while(pos < bodyLength){
        var code = body.charCodeAt(pos);
        var _line = lexer.line;
        var _col = 1 + pos - lexer.lineStart; // SourceCharacter
        switch(code){
            case 0xfeff:
            case 9:
            case 32:
            case 44:
                //  ,
                ++pos;
                continue;
            case 10:
                //  \n
                ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 13:
                //  \r
                if (body.charCodeAt(pos + 1) === 10) pos += 2;
                else ++pos;
                ++lexer.line;
                lexer.lineStart = pos;
                continue;
            case 33:
                //  !
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).BANG, pos, pos + 1, _line, _col, prev);
            case 35:
                //  #
                return $a5d33b5906ae43cc$var$readComment(source, pos, _line, _col, prev);
            case 36:
                //  $
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).DOLLAR, pos, pos + 1, _line, _col, prev);
            case 38:
                //  &
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).AMP, pos, pos + 1, _line, _col, prev);
            case 40:
                //  (
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).PAREN_L, pos, pos + 1, _line, _col, prev);
            case 41:
                //  )
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).PAREN_R, pos, pos + 1, _line, _col, prev);
            case 46:
                //  .
                if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).SPREAD, pos, pos + 3, _line, _col, prev);
                break;
            case 58:
                //  :
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).COLON, pos, pos + 1, _line, _col, prev);
            case 61:
                //  =
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).EQUALS, pos, pos + 1, _line, _col, prev);
            case 64:
                //  @
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).AT, pos, pos + 1, _line, _col, prev);
            case 91:
                //  [
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).BRACKET_L, pos, pos + 1, _line, _col, prev);
            case 93:
                //  ]
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).BRACKET_R, pos, pos + 1, _line, _col, prev);
            case 123:
                // {
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).BRACE_L, pos, pos + 1, _line, _col, prev);
            case 124:
                // |
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).PIPE, pos, pos + 1, _line, _col, prev);
            case 125:
                // }
                return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).BRACE_R, pos, pos + 1, _line, _col, prev);
            case 34:
                //  "
                if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) return $a5d33b5906ae43cc$var$readBlockString(source, pos, _line, _col, prev, lexer);
                return $a5d33b5906ae43cc$var$readString(source, pos, _line, _col, prev);
            case 45:
            case 48:
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
                //  9
                return $a5d33b5906ae43cc$var$readNumber(source, pos, code, _line, _col, prev);
            case 65:
            case 66:
            case 67:
            case 68:
            case 69:
            case 70:
            case 71:
            case 72:
            case 73:
            case 74:
            case 75:
            case 76:
            case 77:
            case 78:
            case 79:
            case 80:
            case 81:
            case 82:
            case 83:
            case 84:
            case 85:
            case 86:
            case 87:
            case 88:
            case 89:
            case 90:
            case 95:
            case 97:
            case 98:
            case 99:
            case 100:
            case 101:
            case 102:
            case 103:
            case 104:
            case 105:
            case 106:
            case 107:
            case 108:
            case 109:
            case 110:
            case 111:
            case 112:
            case 113:
            case 114:
            case 115:
            case 116:
            case 117:
            case 118:
            case 119:
            case 120:
            case 121:
            case 122:
                // z
                return $a5d33b5906ae43cc$var$readName(source, pos, _line, _col, prev);
        }
        throw (0, $l48s6.syntaxError)(source, pos, $a5d33b5906ae43cc$var$unexpectedCharacterMessage(code));
    }
    var line = lexer.line;
    var col = 1 + pos - lexer.lineStart;
    return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */ function $a5d33b5906ae43cc$var$unexpectedCharacterMessage(code) {
    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) return "Cannot contain the invalid character ".concat($a5d33b5906ae43cc$var$printCharCode(code), ".");
    if (code === 39) // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
    return "Cannot parse the unexpected character ".concat($a5d33b5906ae43cc$var$printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */ function $a5d33b5906ae43cc$var$readComment(source, start, line, col, prev) {
    var body = source.body;
    var code;
    var position = start;
    do code = body.charCodeAt(++position);
    while (!isNaN(code) && (code > 0x001f || code === 0x0009));
    return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */ function $a5d33b5906ae43cc$var$readNumber(source, start, firstCode, line, col, prev) {
    var body = source.body;
    var code = firstCode;
    var position = start;
    var isFloat = false;
    if (code === 45) // -
    code = body.charCodeAt(++position);
    if (code === 48) {
        // 0
        code = body.charCodeAt(++position);
        if (code >= 48 && code <= 57) throw (0, $l48s6.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat($a5d33b5906ae43cc$var$printCharCode(code), "."));
    } else {
        position = $a5d33b5906ae43cc$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 46) {
        // .
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $a5d33b5906ae43cc$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    }
    if (code === 69 || code === 101) {
        // E e
        isFloat = true;
        code = body.charCodeAt(++position);
        if (code === 43 || code === 45) // + -
        code = body.charCodeAt(++position);
        position = $a5d33b5906ae43cc$var$readDigits(source, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 46 || $a5d33b5906ae43cc$var$isNameStart(code)) throw (0, $l48s6.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($a5d33b5906ae43cc$var$printCharCode(code), "."));
    return new (0, $c8MIO.Token)(isFloat ? (0, $hFu5F.TokenKind).FLOAT : (0, $hFu5F.TokenKind).INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */ function $a5d33b5906ae43cc$var$readDigits(source, start, firstCode) {
    var body = source.body;
    var position = start;
    var code = firstCode;
    if (code >= 48 && code <= 57) {
        // 0 - 9
        do code = body.charCodeAt(++position);
        while (code >= 48 && code <= 57); // 0 - 9
        return position;
    }
    throw (0, $l48s6.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat($a5d33b5906ae43cc$var$printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */ function $a5d33b5906ae43cc$var$readString(source, start, line, col, prev) {
    var body = source.body;
    var position = start + 1;
    var chunkStart = position;
    var code = 0;
    var value = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
    code !== 0x000a && code !== 0x000d){
        // Closing Quote (")
        if (code === 34) {
            value += body.slice(chunkStart, position);
            return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).STRING, start, position + 1, line, col, prev, value);
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009) throw (0, $l48s6.syntaxError)(source, position, "Invalid character within String: ".concat($a5d33b5906ae43cc$var$printCharCode(code), "."));
        ++position;
        if (code === 92) {
            // \
            value += body.slice(chunkStart, position - 1);
            code = body.charCodeAt(position);
            switch(code){
                case 34:
                    value += '"';
                    break;
                case 47:
                    value += '/';
                    break;
                case 92:
                    value += '\\';
                    break;
                case 98:
                    value += '\b';
                    break;
                case 102:
                    value += '\f';
                    break;
                case 110:
                    value += '\n';
                    break;
                case 114:
                    value += '\r';
                    break;
                case 116:
                    value += '\t';
                    break;
                case 117:
                    // uXXXX
                    var charCode = $a5d33b5906ae43cc$var$uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));
                    if (charCode < 0) {
                        var invalidSequence = body.slice(position + 1, position + 5);
                        throw (0, $l48s6.syntaxError)(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
                    }
                    value += String.fromCharCode(charCode);
                    position += 4;
                    break;
                default:
                    throw (0, $l48s6.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
            }
            ++position;
            chunkStart = position;
        }
    }
    throw (0, $l48s6.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */ function $a5d33b5906ae43cc$var$readBlockString(source, start, line, col, prev, lexer) {
    var body = source.body;
    var position = start + 3;
    var chunkStart = position;
    var code = 0;
    var rawValue = '';
    while(position < body.length && !isNaN(code = body.charCodeAt(position))){
        // Closing Triple-Quote (""")
        if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
            rawValue += body.slice(chunkStart, position);
            return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).BLOCK_STRING, start, position + 3, line, col, prev, (0, $flA0a.dedentBlockStringValue)(rawValue));
        } // SourceCharacter
        if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) throw (0, $l48s6.syntaxError)(source, position, "Invalid character within String: ".concat($a5d33b5906ae43cc$var$printCharCode(code), "."));
        if (code === 10) {
            // new line
            ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 13) {
            // carriage return
            if (body.charCodeAt(position + 1) === 10) position += 2;
            else ++position;
            ++lexer.line;
            lexer.lineStart = position;
        } else if (code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
            rawValue += body.slice(chunkStart, position) + '"""';
            position += 4;
            chunkStart = position;
        } else ++position;
    }
    throw (0, $l48s6.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */ function $a5d33b5906ae43cc$var$uniCharCode(a, b, c, d) {
    return $a5d33b5906ae43cc$var$char2hex(a) << 12 | $a5d33b5906ae43cc$var$char2hex(b) << 8 | $a5d33b5906ae43cc$var$char2hex(c) << 4 | $a5d33b5906ae43cc$var$char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */ function $a5d33b5906ae43cc$var$char2hex(a) {
    return a >= 48 && a <= 57 ? a - 48 // 0-9
     : a >= 65 && a <= 70 ? a - 55 // A-F
     : a >= 97 && a <= 102 ? a - 87 // a-f
     : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */ function $a5d33b5906ae43cc$var$readName(source, start, line, col, prev) {
    var body = source.body;
    var bodyLength = body.length;
    var position = start + 1;
    var code = 0;
    while(position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
    code >= 48 && code <= 57 || // 0-9
    code >= 65 && code <= 90 || // A-Z
    code >= 97 && code <= 122 // a-z
    ))++position;
    return new (0, $c8MIO.Token)((0, $hFu5F.TokenKind).NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z
function $a5d33b5906ae43cc$var$isNameStart(code) {
    return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}

});




parcelRegister("fFvAc", function(module, exports) {

$parcel$export(module.exports, "transformStargateUrl", () => $7f55592624807813$export$96f8b7181eacc12a);
$parcel$export(module.exports, "transformCreateIssueUrl", () => $7f55592624807813$export$3092c86dfb3d9d95);
$parcel$export(module.exports, "transformOriginUrl", () => $7f55592624807813$export$e32687a94f0c0d0c);
const $7f55592624807813$export$96f8b7181eacc12a = (url)=>{
    try {
        if (url && url.includes('ex/jira') && !url.includes('gateway/api')) {
            const urlObject = new URL(url);
            let urlPathArray = urlObject.pathname.split('/');
            urlPathArray = [
                'gateway',
                'api',
                ...urlPathArray.slice(1)
            ];
            return `${urlObject.origin}/${urlPathArray.join('/')}${urlObject.search}`;
        }
    } catch (e) {
        return url;
    }
    return url;
};
const $7f55592624807813$export$3092c86dfb3d9d95 = ({ issueUrl: issueUrl, selectedCloudId: selectedCloudId })=>{
    if (!selectedCloudId) return issueUrl;
    return `/gateway/api/ex/jira/${selectedCloudId}${issueUrl}`;
};
const $7f55592624807813$export$e32687a94f0c0d0c = (selectedCloudId)=>selectedCloudId ? `${window.origin}/gateway/api/ex/jira/${selectedCloudId}` : null;

});

parcelRegister("kNatw", function(module, exports) {

$parcel$export(module.exports, "useSitePickerContext", () => $fe884eb025cdb01f$export$f8b5aae013e4cf77);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $fe884eb025cdb01f$export$d4c72bab9d6cc13a = {
    selectedCloudId: '',
    siteDomain: ''
};
const $fe884eb025cdb01f$export$e324594224ef24da = {
    setSitePickerState: ({ selectedCloudId: selectedCloudId, siteDomain: siteDomain })=>({ setState: setState, getState: getState })=>{
            const currentState = getState();
            setState({
                ...currentState,
                selectedCloudId: selectedCloudId || '',
                siteDomain: siteDomain || ''
            });
        }
};
const $fe884eb025cdb01f$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'issue.fields.site-picker',
    initialState: $fe884eb025cdb01f$export$d4c72bab9d6cc13a,
    actions: $fe884eb025cdb01f$export$e324594224ef24da
});
const $fe884eb025cdb01f$export$f8b5aae013e4cf77 = (0, $ggKAj.createHook)($fe884eb025cdb01f$export$6f57813fe9f31bf9);

});


parcelRegister("8naas", function(module, exports) {

$parcel$export(module.exports, "usePublishUseTriggerIssueCreateModalChange", () => $8bbf3644c1ee01d1$export$def8d994aa8d00f4);

var $eUqFw = parcelRequire("eUqFw");

var $dNWQB = parcelRequire("dNWQB");
var $2gOs4 = parcelRequire("2gOs4");

var $ctR9z = parcelRequire("ctR9z");
const $8bbf3644c1ee01d1$export$def8d994aa8d00f4 = ()=>{
    const [state] = (0, $ctR9z.useTriggerIssueCreateModal)();
    const { publish: publish } = (0, $2gOs4.useGICLifeCycleEvents)();
    (0, $eUqFw.useEffect)(()=>publish((0, $dNWQB.GIC_LIFECYCLE_EVENTS).USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE, state), [
        publish,
        state
    ]);
};

});

parcelRegister("f9Boa", function(module, exports) {

$parcel$export(module.exports, "transformSelectedProject", () => $3796f36cffa5e004$export$cb22028aea60deb4);
$parcel$export(module.exports, "useX2CModal", () => $3796f36cffa5e004$export$9a2334e31c381817);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $1ybV0 = parcelRequire("1ybV0");

var $gd0Sp = parcelRequire("gd0Sp");

var $aNCXJ = parcelRequire("aNCXJ");
const $3796f36cffa5e004$export$cb22028aea60deb4 = (selectedProject)=>{
    if (selectedProject == null) return null;
    return {
        key: selectedProject.projectKey,
        name: selectedProject.label,
        type: selectedProject.projectType,
        isSimplified: selectedProject.isSimplified,
        style: selectedProject.isSimplified ? (0, $7ZZxN.ProjectStyle).NEXT_GEN : (0, $7ZZxN.ProjectStyle).CLASSIC,
        id: Number(selectedProject.value),
        avatarUrl: selectedProject.iconUrl
    };
};
const $3796f36cffa5e004$export$9a2334e31c381817 = ()=>{
    const [{ isModalOpen: isModalOpen, project: project }, { closeModal: closeModal, openModal: openModal, setProject: setProject }] = (0, $aNCXJ.useX2CModalContext)();
    const { isSiteAdmin: isSiteAdmin } = (0, $gd0Sp.useTenantContext)();
    const shouldShowX2CModal = (0, $eUqFw.useMemo)(()=>(0, $1ybV0.ff)('enable-x2c-modal-on-gic-import-issues-button_h8c6z') && isSiteAdmin && project && (project.type === (0, $7ZZxN.SOFTWARE_PROJECT) || project.type === (0, $7ZZxN.CORE_PROJECT)), [
        isSiteAdmin,
        project
    ]);
    return {
        isModalOpen: isModalOpen,
        shouldShowX2CModal: shouldShowX2CModal,
        project: project,
        closeModal: closeModal,
        openModal: openModal,
        setProject: setProject
    };
};

});
parcelRegister("aNCXJ", function(module, exports) {

$parcel$export(module.exports, "useX2CModalContext", () => $d494b87298363740$export$dcdcc4138d7a492b);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $d494b87298363740$export$d4c72bab9d6cc13a = {
    isModalOpen: false,
    project: null
};
const $d494b87298363740$export$e324594224ef24da = {
    openModal: ()=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                isModalOpen: true
            });
        },
    closeModal: ()=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                isModalOpen: false
            });
        },
    setProject: (project)=>({ getState: getState, setState: setState })=>{
            setState({
                ...getState(),
                project: project
            });
        }
};
const $d494b87298363740$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'gic.import.issues.x2c.modal',
    initialState: $d494b87298363740$export$d4c72bab9d6cc13a,
    actions: $d494b87298363740$export$e324594224ef24da
});
const $d494b87298363740$export$dcdcc4138d7a492b = (0, $ggKAj.createHook)($d494b87298363740$export$6f57813fe9f31bf9);

});


parcelRegister("kk6kW", function(module, exports) {

$parcel$export(module.exports, "default", () => $423c7dd329959b67$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8blac = parcelRequire("8blac");

var $hompL = parcelRequire("hompL");

var $aml13 = parcelRequire("aml13");

var $2BvS3 = parcelRequire("2BvS3");

var $exb0h = parcelRequire("exb0h");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $18to0 = parcelRequire("18to0");

var $3G9wl = parcelRequire("3G9wl");


var $hMjV9 = parcelRequire("hMjV9");

var $fqKjL = parcelRequire("fqKjL");

var $dEMIg = parcelRequire("dEMIg");

var $4r5oC = parcelRequire("4r5oC");

var $gys0Y = parcelRequire("gys0Y");

var $cYE68 = parcelRequire("cYE68");

var $dNWQB = parcelRequire("dNWQB");
var $2gOs4 = parcelRequire("2gOs4");

var $fswni = parcelRequire("fswni");

var $ctR9z = parcelRequire("ctR9z");

var $dgsxZ = parcelRequire("dgsxZ");

var $10fdS = parcelRequire("10fdS");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $2qZHF = parcelRequire("2qZHF");
var $bFzGY = parcelRequire("bFzGY");

var $bNe1g = parcelRequire("bNe1g");

var $aONhl = parcelRequire("aONhl");

var $7LoO9 = parcelRequire("7LoO9");

var $gd0Sp = parcelRequire("gd0Sp");

var $jb6Pg = parcelRequire("jb6Pg");

var $bbsDx = parcelRequire("bbsDx");

var $aqi5n = parcelRequire("aqi5n");

var $aFWau = parcelRequire("aFWau");

var $deodO = parcelRequire("deodO");

var $5kL7H = parcelRequire("5kL7H");

var $hFagV = parcelRequire("hFagV");

var $4NPAT = parcelRequire("4NPAT");

var $lq8gO = parcelRequire("lq8gO");

var $kNatw = parcelRequire("kNatw");

var $l1xaV = parcelRequire("l1xaV");

var $jI4T5 = parcelRequire("jI4T5");

var $1n3pz = parcelRequire("1n3pz");

var $7CMF8 = parcelRequire("7CMF8");
var $6NP0P = parcelRequire("6NP0P");

var $jc4Bb = parcelRequire("jc4Bb");

var $8cxU3 = parcelRequire("8cxU3");
var $1rYBS = parcelRequire("1rYBS");

var $1rYBS = parcelRequire("1rYBS");

var $eaonO = parcelRequire("eaonO");

var $fYlUn = parcelRequire("fYlUn");

var $eF2ez = parcelRequire("eF2ez");

var $9stBj = parcelRequire("9stBj");

var $b1gcq = parcelRequire("b1gcq");

var $4qoRl = parcelRequire("4qoRl");

var $cZzZr = parcelRequire("cZzZr");

var $ajNlY = parcelRequire("ajNlY");
const $423c7dd329959b67$var$CreateModal = ({ onTransformCreateFormProps: onTransformCreateFormProps, setShouldRestore: setShouldRestore, onResetApolloCache: onResetApolloCache })=>{
    const sessionIdRef = (0, $eUqFw.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4());
    const [{ payload: triggerIssueCreatePayload, displayOnlyRequiredFields: displayOnlyRequiredFields, disableCreationSuccessFlag: disableCreationSuccessFlag, isSubTaskCreationOpen: isSubTaskCreationOpen, isCreateLinkedIssue: isCreateLinkedIssue = false, isModalLoadInContext: isModalLoadInContext, triggerPointKey: triggerPointKey, interactedWithModalChangerButtons: interactedWithModalChangerButtons, inProgressIssueID: inProgressIssueID, sessionId: sessionId, wasStateRestored: wasStateRestored, isCustomBoardWithIcc: isCustomBoardWithIcc, jqlSwimlaneId: jqlSwimlaneId, swimlaneMode: swimlaneMode }, { setSessionId: setSessionId, openIssueCreateModal: openIssueCreateModal, resetWasModalRetriggered: resetWasModalRetriggered }] = (0, $ctR9z.useTriggerIssueCreateModal)();
    (0, $eUqFw.useEffect)(()=>{
        if (!sessionId) setSessionId(sessionIdRef.current);
    }, [
        sessionId,
        setSessionId
    ]);
    const { showEnforcementIfPendingToShow: showEnforcementIfPendingToShow } = (0, $7LoO9.useStorageEnforcement)();
    const [{ isLoading: isModalLoading, fieldConfig: modalFieldConfig, fieldTabs: modalFieldTabs, contextFields: modalContextFields, meta: modalFieldsDataMeta, error: modalFieldsDataError, apiLatency: modalApiLatency, additionalServices: modalAdditionalServices }, fetchModalConfig] = (0, $1n3pz.default)({
        displayOnlyRequiredFields: displayOnlyRequiredFields,
        triggerPointKey: triggerPointKey,
        isSubTaskCreationOpen: isSubTaskCreationOpen,
        triggerIssueCreatePayload: triggerIssueCreatePayload,
        isModalLoadInContext: isModalLoadInContext
    });
    const classificationFieldId = Object.keys(modalFieldConfig).find((key)=>modalFieldConfig[key].gqlType === 'JiraDataClassificationField');
    const classificationFieldConfig = classificationFieldId ? modalFieldConfig[classificationFieldId] : undefined;
    const proformaConfiguration = modalAdditionalServices?.proformaConfiguration;
    const { publish: publish } = (0, $2gOs4.useGICLifeCycleEvents)();
    const dirtyFieldsCurrentSession = (0, $eUqFw.useRef)({});
    const getFormState = (0, $eUqFw.useRef)(()=>null);
    const { data: projectContext } = (0, $bNe1g.useProjectContext)();
    const [{ isSubmitting: isSubmitting, isOperationInProgress: isOperationInProgress, shouldShowConfigureFieldModal: shouldShowConfigureFieldModal, shouldShowFindFieldModal: shouldShowFindFieldModal, selectedProject: selectedProject, selectedIssueType: selectedIssueType, meta: meta, shouldShowTempSwitchModal: shouldShowTempSwitchModal, dataFetchError: dataFetchError, isFormDirty: isCreateFormDirty, canCreateAnotherIssue: canCreateAnotherIssue, createdIssues: createdIssues }, { resetFormContext: resetFormContext, toggleConfigureFieldsModalVisibility: toggleConfigureFieldsModalVisibility, toggleFindFieldsModalVisibility: toggleFindFieldsModalVisibility, closeTempSwitchModal: closeTempSwitchModal, setAreConfiguredFieldsModified: setAreConfiguredFieldsModified, setForgeModules: setForgeModules, setCurrentActiveTabIndex: setCurrentActiveTabIndex, setCanCreateAnotherIssue: setCanCreateAnotherIssue, addCreatedIssue: addCreatedIssue }] = (0, $fswni.useFormContext)();
    const [, { resetState: resetState }] = (0, $18to0.useInlineFieldsActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const isGICPositioningEnabled = (0, $hFagV.useIsGICPositioningEnabled)();
    const { withMachineLearning: withMachineLearning } = (0, $1ybV0.ff)('gic-smart-fields-jira-labs_8uwvr') ? (0, $deodO.useSmartFieldsMachineLearning)() : {
        withMachineLearning: false
    };
    const shouldDisableActions = dataFetchError !== null;
    (0, $eUqFw.useEffect)(()=>{
        if (shouldDisableActions && setShouldRestore) {
            if (selectedProject === null) {
                const analyticsEvent = createAnalyticsEvent({
                    actionSubject: 'noselectedproject',
                    action: 'error'
                });
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'createIssueViewError');
            }
            setShouldRestore(false);
        }
    }, [
        shouldDisableActions,
        setShouldRestore,
        selectedProject,
        createAnalyticsEvent
    ]);
    const initFetchConfig = (0, $eUqFw.useCallback)(()=>{
        // ideally the change should be for all queries, but limitting the scope of change for now. The variable is defaulted to "STANDARD" in the BE.
        const issueCreateType = (0, $1ybV0.ff)('create-linked-issues-trigger-point-issue-view') && isCreateLinkedIssue && isModalLoadInContext ? {
            issueCreateType: isCreateLinkedIssue ? (0, $dEMIg.ISSUE_CREATE_TYPE).linkedIssue : (0, $dEMIg.ISSUE_CREATE_TYPE).standard
        } : {};
        if (!triggerIssueCreatePayload) fetchModalConfig({
            variables: (0, $1rYBS.getQueryVariables)((0, $1rYBS.getIssueCreateProjectForMount)(projectContext), null)
        });
        else {
            const { customFieldsToPreserveOnFormRecreation: customFieldsToPreserveOnFormRecreation = [], ...mainPayload } = triggerIssueCreatePayload;
            const parentId = mainPayload.parentId || null;
            const additionalContext = mainPayload.additionalContext || null;
            const projectPayload = (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(mainPayload.project) ? null : mainPayload.project;
            fetchModalConfig({
                variables: {
                    project: projectPayload,
                    issueType: mainPayload.issueType || null,
                    requestType: mainPayload.requestType || null,
                    defaultValues: mainPayload.defaultValues || null,
                    issueTypes: mainPayload.issueTypes || null,
                    requestTypes: mainPayload.requestTypes || null,
                    parentId: parentId,
                    additionalContext: additionalContext,
                    ...issueCreateType
                }
            });
            dirtyFieldsCurrentSession.current = {
                ...dirtyFieldsCurrentSession.current,
                ...Object.fromEntries(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                customFieldsToPreserveOnFormRecreation.map((k)=>[
                        k,
                        true
                    ]))
            };
        }
    }, [
        isCreateLinkedIssue,
        isModalLoadInContext,
        triggerIssueCreatePayload,
        fetchModalConfig,
        projectContext
    ]);
    const [{ siteDomain: siteDomain, selectedCloudId: selectedCloudId }] = (0, $kNatw.useSitePickerContext)();
    const [{ isLoading: isTransitionsLoading, error: transitionsError, transitions: transitions }, fetchTransitions] = (0, $jI4T5.default)();
    const shouldShowStatus = (0, $eUqFw.useMemo)(()=>(0, $1rYBS.shouldShowStatusField)(selectedProject?.projectType, modalFieldConfig), [
        selectedProject,
        modalFieldConfig
    ]);
    const { resetAndReloadCreateForm: resetAndReloadCreateForm } = (0, $lq8gO.useIssueCreateFromAnywhereContext)();
    (0, $eUqFw.useEffect)(()=>{
        if (shouldShowStatus && selectedProject && selectedIssueType && !resetAndReloadCreateForm) fetchTransitions({
            projectId: selectedProject.value,
            issueTypeId: selectedIssueType.type === (0, $8b8bfa076f313cc4$export$92ab80c1dc9baf44) ? selectedIssueType.issueTypeId : selectedIssueType.value,
            selectedCloudId: selectedCloudId
        });
    }, [
        fetchTransitions,
        selectedProject,
        selectedIssueType,
        shouldShowStatus,
        selectedCloudId,
        resetAndReloadCreateForm
    ]);
    const extraContext = (0, $eUqFw.useMemo)(()=>({
            issueType: selectedIssueType?.label,
            projectKey: selectedProject?.projectKey,
            classificationTags: selectedProject?.classificationTags
        }), [
        selectedProject,
        selectedIssueType
    ]);
    const { customFields: customFields, issueAdjustmentModules: issueAdjustmentModules, filteredOutModules: filteredOutModules, loadingStatus: loadingStatus } = (0, $l1xaV.useFetchForgeModules)(extraContext);
    const hasForgeFinishedLoading = loadingStatus === 'success' || loadingStatus === 'error';
    (0, $eUqFw.useEffect)(()=>{
        if (selectedProject && selectedIssueType) setForgeModules(customFields, issueAdjustmentModules, filteredOutModules, hasForgeFinishedLoading);
    }, [
        issueAdjustmentModules,
        setForgeModules,
        customFields,
        hasForgeFinishedLoading,
        filteredOutModules,
        selectedProject,
        selectedIssueType,
        shouldShowStatus
    ]);
    const [showIssuesCreated, setShowIssuesCreated] = (0, $eUqFw.useState)(false);
    const isApiCallTriggered = (0, $eUqFw.useRef)(false);
    if (!isApiCallTriggered.current) {
        initFetchConfig();
        inProgressIssueID && publish((0, $dNWQB.GIC_LIFECYCLE_EVENTS).MODAL_OPENED, {
            inProgressIssueID: inProgressIssueID
        });
        const restoredCreatedIssuesExists = (0, $1ybV0.ff)('fix-sentry-error-cannot-read-length_daci9') ? createdIssues?.length > 0 : createdIssues.length > 0;
        restoredCreatedIssuesExists && setShowIssuesCreated(restoredCreatedIssuesExists);
        isApiCallTriggered.current = true;
    }
    const [{ globalEventNamespaces: globalEventNamespaces, fieldsToAddInPublishedData: fieldsToAddInPublishedData, alertsToBeLinked: alertsToBeLinked, onIssueCreate: onIssueCreate, onClose: onClose, displayCreateAnotherIssueToggle: displayCreateAnotherIssueToggle, callbackPayload: callbackPayload }, { closeIssueCreateModal: closeIssueCreateModal, setCallbackPayload: setCallbackPayload }] = (0, $ctR9z.useTriggerIssueCreateModal)();
    const closeIssueCreateModalNew = (0, $eUqFw.useCallback)((issuesCreated)=>{
        closeIssueCreateModal(Boolean(issuesCreated?.length));
        inProgressIssueID && publish((0, $dNWQB.GIC_LIFECYCLE_EVENTS).MODAL_CLOSED, {
            callbackPayload: callbackPayload,
            inProgressIssueID: inProgressIssueID,
            createdIssues: issuesCreated
        });
    }, [
        callbackPayload,
        closeIssueCreateModal,
        inProgressIssueID,
        publish
    ]);
    if (isGICPositioningEnabled()) {
        // combine hook with above when cleaning up gic-refetch-on-discard_cxard
        const [{ shouldInitFetchConfig: shouldInitFetchConfig }, { resetShouldInitFetchConfig: resetShouldInitFetchConfig }] = // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $ctR9z.useTriggerIssueCreateModal)();
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $eUqFw.useEffect)(()=>{
            if (shouldInitFetchConfig || resetAndReloadCreateForm) {
                resetShouldInitFetchConfig();
                initFetchConfig();
            }
        }, [
            initFetchConfig,
            resetShouldInitFetchConfig,
            shouldInitFetchConfig,
            resetAndReloadCreateForm
        ]);
    }
    (0, $eUqFw.useEffect)(()=>{
        if (resetAndReloadCreateForm) resetFormContext();
    }, [
        resetAndReloadCreateForm,
        resetFormContext
    ]);
    const [shouldShowConfirmDismissModal, setShouldShowConfirmDismissModal] = (0, $eUqFw.useState)(false);
    const sourceThatFiredModalDismiss = (0, $eUqFw.useRef)(null);
    const [objectId, setObjectId] = (0, $eUqFw.useState)(undefined);
    const route = (0, $10fdS.useCurrentRoute)();
    const isCompanyManagedBoard = route?.name === (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_BOARD || route?.name === (0, $exb0h.ROUTE_NAMES).RAPIDBOARD_USER_BOARD || (0, $1ybV0.ff)('jsm-fix-multiple-success-flag-when-gic-on-boards') && route?.name === (0, $exb0h.ROUTE_NAMES).SERVICEDESK_BOARDS;
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const showSuccessFlag = (0, $eUqFw.useCallback)((issueList, successFlagParams)=>{
        if (((0, $1ybV0.ff)('fix-sentry-error-cannot-read-length_daci9') ? issueList?.length : issueList.length) && !disableCreationSuccessFlag) {
            const flagId = (0, $eo17r.toFlagId)((0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4());
            const issueDiscoveryUrl = (0, $aFWau.getIssueDiscoveryUrl)(issueList);
            showFlag({
                id: flagId,
                render: (flagProps)=>{
                    const successFlagProps = {
                        key: flagProps.key,
                        flagKey: flagProps.key,
                        id: flagId,
                        issueList: issueList,
                        issueDiscoveryUrl: issueDiscoveryUrl
                    };
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4qoRl.default), {
                        ...successFlagProps,
                        successFlagParams: successFlagParams
                    });
                }
            });
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'flag',
                action: 'viewed'
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'createIssueSuccessNotification');
        }
    }, [
        createAnalyticsEvent,
        disableCreationSuccessFlag,
        showFlag
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const api = {
            // @ts-expect-error - TS7006 - Parameter 'params' implicitly has an 'any' type.
            renderSuccessFlag: (params)=>{
                // @ts-expect-error - TS7006 - Parameter 'issue' implicitly has an 'any' type.
                const issueList = params.issues.map((issue)=>({
                        issueId: issue.issueId,
                        issueKey: issue.issueKey
                    }));
                (0, $fqKjL.successFlagDisplay).stop();
                showSuccessFlag(issueList, params);
            }
        };
        if (isCompanyManagedBoard) // eslint-disable-next-line jira/wrm/no-load-bridge
        (0, $2BvS3.loadBridge)({
            name: 'jira-agile/rapid/ui/gic-success-flag/bridge'
        }).then((bridge)=>// @ts-expect-error - TS2571 - Object is of type 'unknown'.
            bridge(api));
    }, [
        showSuccessFlag,
        isCompanyManagedBoard
    ]);
    // combine this with above when cleaning up gic.positioning
    const [{ minimizableModalView: minimizableModalView }] = isGICPositioningEnabled() ? (0, $ctR9z.useTriggerIssueCreateModal)() : [
        {
            minimizableModalView: undefined
        }
    ];
    const [{ shouldPushMiniModalDiscoverability: shouldPushMiniModalDiscoverability }] = (0, $ctR9z.useTriggerIssueCreateModal)();
    const { updateView: updateView } = (0, $aONhl.usePersistentIssueCreateModalViewResource)();
    const performCleanUp = (0, $eUqFw.useCallback)((shouldPublishCreatedIssues = false, issuesCreated)=>{
        const issueList = issuesCreated ?? createdIssues ?? [];
        if (!isCompanyManagedBoard) showSuccessFlag(issueList);
        else (0, $fqKjL.successFlagDisplay).start();
        closeIssueCreateModalNew(issueList);
        if (issuesCreated) updateView(minimizableModalView === 'mini' ? 'mini' : 'modal');
        if (shouldPublishCreatedIssues) (0, $ajNlY.publishCreatedIssues)({
            createdIssues: issueList,
            globalEventNamespaces: globalEventNamespaces,
            fieldsToAddInPublishedData: fieldsToAddInPublishedData,
            alertsToBeLinked: alertsToBeLinked,
            isSessionComplete: true,
            onIssueCreate: null,
            onClose: onClose,
            triggerPointKey: triggerPointKey,
            publishGICLifecycle: publish,
            inProgressIssueID: inProgressIssueID,
            callbackPayload: callbackPayload,
            selectedCloudId: selectedCloudId,
            jqlSwimlaneId: jqlSwimlaneId
        });
    }, [
        createdIssues,
        isCompanyManagedBoard,
        showSuccessFlag,
        closeIssueCreateModalNew,
        globalEventNamespaces,
        fieldsToAddInPublishedData,
        alertsToBeLinked,
        onClose,
        triggerPointKey,
        publish,
        inProgressIssueID,
        callbackPayload,
        selectedCloudId,
        minimizableModalView,
        updateView,
        jqlSwimlaneId
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if ((0, $1ybV0.ff)('jira-intelligent-issue-breakdown_18syl') && minimizableModalView === 'ai-enabled') setCallbackPayload({
            wasFormDirty: isCreateFormDirty
        });
    }, [
        isCreateFormDirty,
        setCallbackPayload,
        minimizableModalView
    ]);
    const onCreateAnotherChange = (_, analyticsEvent)=>{
        setCanCreateAnotherIssue(!canCreateAnotherIssue);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'createAnotherIssue', {
            projectType: selectedProject ? (0, $4r5oC.transformProjectType)(selectedProject.projectType) : 'none'
        });
    };
    const handleTabIndexEmptyContainingRequiredField = ()=>{
        try {
            const fieldValues = getFormState.current()?.values || null;
            const tabIndex = (0, $ajNlY.getTabIndexWithError)(modalFieldTabs, fieldValues, modalFieldConfig);
            setCurrentActiveTabIndex(tabIndex);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    packageName: 'jiraIssueCreate',
                    id: 'gicModalTabChangeOnSubmit',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    };
    const handleEmptyAndRequiredFields = ()=>{
        try {
            const fieldValues = getFormState.current()?.values || null;
            let emptyRequiredFields = [];
            if (modalFieldConfig) emptyRequiredFields = Object.keys(modalFieldConfig)?.filter((fieldId)=>Boolean(modalFieldConfig[fieldId].isRequired) && fieldValues && (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(fieldValues[fieldId]));
            const firstFieldIdWithError = (0, $ajNlY.getFirstFieldIdWithError)({
                fields: Object.keys(fieldValues || {}),
                emptyRequiredFields: emptyRequiredFields
            });
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $aqi5n.scrollToField)(firstFieldIdWithError);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    packageName: 'jiraIssueCreate',
                    id: 'gicModalNextRequiredFieldFocusOnSubmit',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    };
    const { atlassianAccountId: atlassianAccountId } = (0, $gd0Sp.useTenantContext)();
    const onSubmit = (_, analyticsEvent)=>{
        handleTabIndexEmptyContainingRequiredField();
        handleEmptyAndRequiredFields();
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'createIssue', {
            projectType: selectedProject ? (0, $4r5oC.transformProjectType)(selectedProject.projectType) : 'none',
            gicSessionId: sessionIdRef.current
        });
    };
    const showWatchersWarningOrErrorFlag = (0, $eUqFw.useCallback)((response)=>{
        const config = (0, $ajNlY.getWatchersFlagConfigFromResponse)(response);
        if (config) /**
				 * Showing the watchers warning/error flag slightly after the issue-create-success-flag
				 * so they visually appear one after another in order and the user would be able to
				 * actually see the success flag sliding in first and then being pushed down.
				 */ setTimeout(()=>{
            showFlag(config);
        }, 600);
    }, [
        showFlag
    ]);
    const onIssueCreateSuccess = (0, $eUqFw.useCallback)((createdIssue, watchersResponse)=>{
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const issuesCreated = addCreatedIssue(createdIssue);
        setObjectId(String(createdIssue?.issueId));
        setShowIssuesCreated(showIssuesCreated || canCreateAnotherIssue);
        (0, $ajNlY.publishCreatedIssues)({
            createdIssues: [
                createdIssue
            ],
            globalEventNamespaces: globalEventNamespaces,
            fieldsToAddInPublishedData: fieldsToAddInPublishedData,
            alertsToBeLinked: alertsToBeLinked,
            onIssueCreate: onIssueCreate,
            siteDomain: siteDomain,
            selectedCloudId: selectedCloudId,
            onClose: onClose,
            inProgressIssueID: inProgressIssueID,
            publishGICLifecycle: publish,
            isIssueCreateSuccess: true,
            callbackPayload: callbackPayload,
            jqlSwimlaneId: jqlSwimlaneId
        });
        if (!canCreateAnotherIssue) performCleanUp(true, issuesCreated);
        showWatchersWarningOrErrorFlag(watchersResponse);
    }, [
        showIssuesCreated,
        canCreateAnotherIssue,
        globalEventNamespaces,
        fieldsToAddInPublishedData,
        alertsToBeLinked,
        onIssueCreate,
        siteDomain,
        selectedCloudId,
        onClose,
        inProgressIssueID,
        publish,
        callbackPayload,
        addCreatedIssue,
        performCleanUp,
        showWatchersWarningOrErrorFlag,
        jqlSwimlaneId
    ]);
    const [dismissModalType, setDismissModalType] = (0, $7CMF8.useConfirmDismissAiSuggestedModal)();
    const [{ shouldShowConfirmDismissFromGlobalCreate: shouldShowConfirmDismissFromGlobalCreate, shouldShowConfirmDismissFromCurrentlyEditedIssue: shouldShowConfirmDismissFromCurrentlyEditedIssue }, { handleNextModalState: handleNextModalState }] = (0, $6NP0P.useShouldShowConfirmDismissAiSuggestedModal)();
    const showConfirmDismissModal = (source)=>{
        sourceThatFiredModalDismiss.current = source;
        setShouldShowConfirmDismissModal(true);
    };
    /**
	 * If a user opens the Global Issue Create from top navigation,
	 * while the minimizable AI modal is open, or they
	 * navigate away while current issue has been modified,
	 * we trigger a warning modal.
	 */ (0, $eUqFw.useEffect)(()=>{
        if (!(0, $1ybV0.ff)('jira-intelligent-issue-breakdown_18syl')) return;
        if (shouldShowConfirmDismissFromGlobalCreate || shouldShowConfirmDismissFromCurrentlyEditedIssue && shouldShowConfirmDismissFromGlobalCreate) {
            handleNextModalState();
            setDismissModalType((0, $7CMF8.DISCARD_MODAL_TYPE).DISCARD_ALL_FROM_GLOBAL_CREATE);
            return;
        }
        if (shouldShowConfirmDismissFromCurrentlyEditedIssue) {
            handleNextModalState();
            setDismissModalType((0, $7CMF8.DISCARD_MODAL_TYPE).DISCARD_CURRENT_EDITED);
        }
    }, [
        shouldShowConfirmDismissFromGlobalCreate,
        shouldShowConfirmDismissFromCurrentlyEditedIssue,
        handleNextModalState,
        setDismissModalType
    ]);
    const onAiSuggestedModalDiscard = (_, analyticsEvent, type)=>{
        switch(type){
            case (0, $7CMF8.DISCARD_MODAL_TYPE).DISCARD_ALL_FROM_GLOBAL_CREATE:
                publish((0, $dNWQB.GIC_LIFECYCLE_EVENTS).MODAL_DISCARD_ALL_SUGGESTED_ISSUES, {});
                resetWasModalRetriggered(true);
                // Recreate global-create-button trigger
                openIssueCreateModal({
                    disableCreationSuccessFlag: false,
                    triggerPointKey: 'global-create-button'
                });
                break;
            case (0, $7CMF8.DISCARD_MODAL_TYPE).DISCARD_CURRENT_SUGGESTED:
                closeIssueCreateModal(false);
                onConfirmDismissModalConfirm(_, analyticsEvent);
                break;
            case (0, $7CMF8.DISCARD_MODAL_TYPE).DISCARD_CURRENT_EDITED:
                closeIssueCreateModal(false);
                publish((0, $dNWQB.GIC_LIFECYCLE_EVENTS).MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES, {});
                break;
            default:
        }
        setDismissModalType(undefined);
    };
    const onAiSuggestedModalClose = ()=>{
        setDismissModalType(undefined);
    };
    const hideConfirmDismissModal = ()=>{
        setShouldShowConfirmDismissModal(false);
        sourceThatFiredModalDismiss.current = null;
    };
    const onModalClose = (_, analyticsEvent, source)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, source, {
            projectType: selectedProject ? (0, $4r5oC.transformProjectType)(selectedProject.projectType) : 'none'
        });
        showEnforcementIfPendingToShow();
        performCleanUp(true);
        resetState();
    };
    const onModalCloseWithConfirm = (source)=>(_, analyticsEvent)=>{
            if ((0, $1ybV0.ff)('jira-intelligent-issue-breakdown_18syl') && minimizableModalView === 'ai-enabled') {
                setDismissModalType((0, $7CMF8.DISCARD_MODAL_TYPE).DISCARD_CURRENT_SUGGESTED);
                return;
            }
            if (!isCreateFormDirty) {
                onModalClose(_, analyticsEvent, source);
                return;
            }
            showConfirmDismissModal(source);
        };
    const onConfirmDismissModalCancel = ()=>{
        hideConfirmDismissModal();
    };
    const onConfirmDismissModalConfirm = (_, analyticsEvent)=>{
        const source = sourceThatFiredModalDismiss && sourceThatFiredModalDismiss.current || '';
        // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'string'.
        onModalClose(_, analyticsEvent, source);
        hideConfirmDismissModal();
        if ((0, $1ybV0.ff)('jira-intelligent-issue-breakdown_18syl') && minimizableModalView === 'ai-enabled') setTimeout(()=>{
            publish((0, $dNWQB.GIC_LIFECYCLE_EVENTS).MODAL_DISCARD_SUGGESTED_ISSUE, {});
        });
    };
    const [resetFormFieldsCounter, setResetFormFieldsCounter] = (0, $eUqFw.useState)(0);
    const incrementResetCounter = (0, $eUqFw.useCallback)(()=>{
        setResetFormFieldsCounter((n)=>n + 1);
    }, []);
    const hideConfigureFieldsModal = ()=>{
        toggleConfigureFieldsModalVisibility(false);
    };
    const hideFindFieldModal = ()=>{
        toggleFindFieldsModalVisibility(false);
    };
    const hideTempSwitchModal = (shouldCloseParentIssueCreateModal)=>{
        closeTempSwitchModal();
        if (shouldCloseParentIssueCreateModal) performCleanUp();
    };
    // @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value. | TS7031 - Binding element 'shouldShowChangerSpotlight' implicitly has an 'any' type. | TS2525 - Initializer provides no value for this binding element and the binding element has no default value. | TS7031 - Binding element 'onOpenSpotlight' implicitly has an 'any' type. | TS2525 - Initializer provides no value for this binding element and the binding element has no default value. | TS7031 - Binding element 'onCloseSpotlight' implicitly has an 'any' type.
    const { shouldShowChangerSpotlight: shouldShowChangerSpotlight, onOpenSpotlight: onOpenSpotlight, onCloseSpotlight: onCloseSpotlight } = isGICPositioningEnabled() ? (0, $5kL7H.useChangerSpotlight)(minimizableModalView) : {};
    // resetting form context should happen after the component is unmounted (if done before, certain components/fields were throwing error)
    // @ts-expect-error - TS2322 - Type '() => void | Promise<void>' is not assignable to type 'void | Destructor'.
    (0, $eUqFw.useEffect)(()=>resetFormContext, [
        resetFormContext
    ]);
    // add sprint field to published data to enable dynamic success flags for scrum projects
    (0, $eUqFw.useEffect)(()=>{
        const sprintFieldId = Object.keys(modalFieldConfig).find((key)=>modalFieldConfig[key].gqlType === 'JiraSprintField');
        if (sprintFieldId !== undefined) fieldsToAddInPublishedData.push(sprintFieldId);
    }, [
        fieldsToAddInPublishedData,
        modalFieldConfig
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const fieldPropsExtensions = isGICPositioningEnabled() ? {
        description: {
            onFocus: onOpenSpotlight,
            onBlur: onCloseSpotlight
        }
    } : undefined;
    const preselectedStatus = triggerIssueCreatePayload?.status?.statusId;
    const classificationFieldProps = (0, $gys0Y.useClassificationFieldProps)(classificationFieldConfig);
    const buildCreateFormProps = (0, $eUqFw.useCallback)(()=>({
            isLoading: isModalLoading,
            fieldConfig: modalFieldConfig,
            fieldTabs: modalFieldTabs,
            contextFields: modalContextFields,
            meta: modalFieldsDataMeta,
            error: modalFieldsDataError,
            apiLatency: modalApiLatency,
            onFetchConfig: fetchModalConfig,
            onIssueCreateSuccess: onIssueCreateSuccess,
            canCreateAnotherIssue: canCreateAnotherIssue,
            dirtyFieldsCurrentSession: dirtyFieldsCurrentSession,
            getFormState: getFormState,
            onFormFieldsReset: incrementResetCounter,
            fieldPropsExtensions: fieldPropsExtensions,
            onResetApolloCache: onResetApolloCache,
            filteredOutModules: filteredOutModules,
            ...(0, $1ybV0.ff)('support-data-classification-field-in-gic_x6lda') && classificationFieldConfig && Array.isArray(classificationFieldConfig?.allowedValues) && classificationFieldConfig.allowedValues.length > 0 ? {
                classificationFieldProps: classificationFieldProps
            } : {},
            ...shouldShowStatus ? {
                statusFieldProps: {
                    preselectedTransition: transitions?.find((transition)=>transition.to.id === preselectedStatus),
                    initialTransition: transitions?.find((it)=>it.isInitial),
                    availableTransitions: transitions,
                    isTransitionsLoading: isTransitionsLoading,
                    transitionsError: transitionsError
                }
            } : Object.freeze({}),
            proformaConfiguration: proformaConfiguration,
            watchersConfigurations: modalAdditionalServices.watchersConfigurations
        }), [
        isModalLoading,
        modalFieldConfig,
        modalFieldTabs,
        modalContextFields,
        modalFieldsDataMeta,
        modalFieldsDataError,
        modalApiLatency,
        fetchModalConfig,
        onIssueCreateSuccess,
        canCreateAnotherIssue,
        incrementResetCounter,
        fieldPropsExtensions,
        classificationFieldConfig,
        classificationFieldProps,
        shouldShowStatus,
        transitions,
        isTransitionsLoading,
        transitionsError,
        preselectedStatus,
        proformaConfiguration,
        onResetApolloCache,
        modalAdditionalServices.watchersConfigurations,
        filteredOutModules
    ]);
    const createFormProps = (0, $eUqFw.useMemo)(()=>{
        let formProps = buildCreateFormProps();
        if (onTransformCreateFormProps) formProps = onTransformCreateFormProps(formProps);
        return formProps;
    }, [
        buildCreateFormProps,
        onTransformCreateFormProps
    ]);
    const renderFormOrError = ()=>{
        if (shouldDisableActions) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eaonO.default), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cxU3.default), createFormProps);
    };
    const currentUIModificationsConsentState = (0, $3G9wl.useUIModificationsConsentStatus)();
    const getShouldDisableSubmit = ()=>currentUIModificationsConsentState === (0, $e4bc45ef063f6e5f$export$d67d63332ce3ce38) || !meta.areRequiredFieldsSupported || shouldDisableActions || !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(meta.queryErrorMessage);
    // initialise the request type fields layout preference on modal load
    // internally, this will not re-fetch if previously done
    const [{ data: isRequestTypeFieldsLayoutEnabled }, { initialise: initialise }] = (0, $4NPAT.useRequestTypeFieldsLayoutPreference)();
    (0, $eUqFw.useEffect)(()=>{
        if (atlassianAccountId) initialise(atlassianAccountId, createAnalyticsEvent);
    }, [
        atlassianAccountId,
        createAnalyticsEvent,
        initialise
    ]);
    const isRequestTypeSelected = selectedIssueType?.type === (0, $8b8bfa076f313cc4$export$92ab80c1dc9baf44);
    const renderConfigureFieldsModal = ()=>shouldShowConfigureFieldModal && selectedProject && selectedIssueType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cYE68.default), {
            onCancel: hideConfigureFieldsModal,
            project: {
                projectId: selectedProject.value,
                projectType: selectedProject.projectType
            },
            issueTypeId: isRequestTypeSelected ? selectedIssueType.issueTypeId : selectedIssueType.value,
            requestTypeKey: isRequestTypeSelected ? selectedIssueType.requestTypeKey : undefined,
            parentId: triggerIssueCreatePayload?.parentId?.parentId,
            setAreConfiguredFieldsModified: setAreConfiguredFieldsModified,
            onlyDisplayAllFieldsOption: isRequestTypeFieldsLayoutEnabled && isRequestTypeSelected,
            messageContent: isRequestTypeSelected ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eF2ez.JsmRequestTypeFieldsChangeboarding), null) : undefined
        }) : null;
    const renderFindFieldModal = ()=>shouldShowFindFieldModal && selectedProject && selectedIssueType ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hMjV9.default), {
            project: {
                projectId: selectedProject.value,
                nextGenProject: selectedProject.isSimplified,
                projectType: selectedProject.projectType
            },
            issueTypeId: selectedIssueType.type === (0, $8b8bfa076f313cc4$export$92ab80c1dc9baf44) ? selectedIssueType.issueTypeId : selectedIssueType.value,
            operation: "CREATE",
            onCancel: hideFindFieldModal
        }) : null;
    const renderTempSwitchExperienceModal = ()=>shouldShowTempSwitchModal && selectedProject ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cZzZr.AsyncTempSwitchExperinceModal), {
            onClose: hideTempSwitchModal,
            projectType: selectedProject.projectType
        }) : null;
    const renderConfirmDismissModalAiSuggested = ()=>(0, $1ybV0.ff)('jira-intelligent-issue-breakdown_18syl') && selectedProject && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7CMF8.DiscardSuggestionsModal), {
            onDiscard: onAiSuggestedModalDiscard,
            onClose: onAiSuggestedModalClose,
            modalType: dismissModalType
        });
    const renderConfirmDismissModal = ()=>shouldShowConfirmDismissModal && selectedProject ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jc4Bb.default), {
            project: {
                projectId: selectedProject.value,
                projectType: selectedProject.projectType
            },
            sessionId: sessionIdRef.current,
            onCancel: onConfirmDismissModalCancel,
            onConfirm: onConfirmDismissModalConfirm
        }) : null;
    const renderExistingGicWarningModal = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fYlUn.ExistingGICWarning), null);
    const renderDisabledRestoreNavigationPrompt = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b1gcq.NavigateWithoutRestorePrompt), {
            setShouldRestore: setShouldRestore
        });
    const smartCardProviderFF = (0, $eUqFw.useMemo)(()=>({
            enableFlexibleBlockCard: (0, $1ybV0.ff)('issue.details.editor.enable-flexible-block-card')
        }), []);
    const modalWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9stBj.ModalWrapper), {
        onModalCloseWithConfirm: onModalCloseWithConfirm,
        shouldDisableActions: shouldDisableActions,
        onSubmit: onSubmit,
        isSubmitting: isSubmitting,
        isOperationInProgress: isOperationInProgress,
        canCreateAnotherIssue: canCreateAnotherIssue,
        onCreateAnotherChange: onCreateAnotherChange,
        getShouldDisableSubmit: getShouldDisableSubmit,
        createdIssues: createdIssues,
        displayCreateAnotherIssueToggle: displayCreateAnotherIssueToggle,
        shouldShowChangerSpotlight: isGICPositioningEnabled() ? !interactedWithModalChangerButtons && shouldShowChangerSpotlight : undefined,
        showIssuesCreated: showIssuesCreated,
        initialSummaryValue: (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(createFormProps.fieldConfig) ? null : createFormProps.fieldConfig?.summary?.defaultValue || '',
        projectType: selectedProject?.projectType,
        selectedIssueType: selectedIssueType,
        setShouldRestore: setShouldRestore,
        watchersConfigurations: modalAdditionalServices.watchersConfigurations
    }, !isGICPositioningEnabled() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
        onMount: (0, $jMP2a.fireScreenAnalyticsDeferred)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aml13.SmartCardProvider), {
        featureFlags: smartCardProviderFF
    }, renderFormOrError()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbsDx.UiModificationsEntryPoint), {
        issueTypeFieldType: modalContextFields.issuetype?.type || '',
        modalFieldConfig: modalFieldConfig,
        modules: issueAdjustmentModules,
        resetFormFieldsCounter: resetFormFieldsCounter,
        selectedIssueType: selectedIssueType,
        selectedProject: selectedProject,
        triggerPointKey: triggerPointKey
    }), renderConfigureFieldsModal(), renderFindFieldModal(), renderTempSwitchExperienceModal(), renderConfirmDismissModal(), isGICPositioningEnabled() && renderExistingGicWarningModal(), renderDisabledRestoreNavigationPrompt(), renderConfirmDismissModalAiSuggested());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa),
        sourceName: "createIssue",
        containerType: "project",
        objectType: "issue",
        objectId: objectId,
        containerId: selectedProject ? selectedProject.value : '',
        attributes: {
            isNewGIC: true,
            isCreatingAnotherIssue: canCreateAnotherIssue,
            isSubtask: isSubTaskCreationOpen,
            triggerPointKey: triggerPointKey,
            ...selectedProject ? {
                nextGenProject: selectedProject.isSimplified
            } : {},
            ...isGICPositioningEnabled() ? {
                gicViewState: minimizableModalView
            } : {},
            ...(0, $1ybV0.ff)('create-linked-issues-trigger-point-issue-view') ? {
                isCreateLinkedIssue: isCreateLinkedIssue
            } : {},
            hasProformaForm: !!proformaConfiguration?.hasProformaForm,
            wasStateRestored: wasStateRestored,
            isDiscoverabilityPush: !!shouldPushMiniModalDiscoverability && (0, $dgsxZ.isPartOfDiscoverabilityTriggers)(triggerPointKey),
            smartFieldsEnabled: withMachineLearning,
            sessionId: !sessionId ? sessionIdRef.current : sessionId,
            ...(0, $1ybV0.ff)('icc-for-custom-boards') ? {
                isCustomBoardWithIcc: isCustomBoardWithIcc
            } : {},
            ...(0, $1ybV0.ff)('icc-for-query-swimlanes') ? {
                swimlaneMode: swimlaneMode
            } : {}
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jb6Pg.UiModificationsContainer), null, modalWrapper));
};
var $423c7dd329959b67$export$2e2bcd8739ae039 = $423c7dd329959b67$var$CreateModal;

});
parcelRegister("aml13", function(module, exports) {

$parcel$export(module.exports, "SmartCardProvider", () => $ddfb038c93ff29bc$export$497ecb0280204df4);

var $eUqFw = parcelRequire("eUqFw");

var $huRi7 = parcelRequire("huRi7");

var $cGAGh = parcelRequire("cGAGh");

var $fQDHB = parcelRequire("fQDHB");

var $aatVr = parcelRequire("aatVr");

var $gqldc = parcelRequire("gqldc");

var $1Hojg = parcelRequire("1Hojg");
function $ddfb038c93ff29bc$export$497ecb0280204df4({ storeOptions: storeOptions, client: customClient, authFlow: customAuthFlow, children: children, renderers: renderers, featureFlags: featureFlags, isAdminHubAIEnabled: isAdminHubAIEnabled, product: product }) {
    const parentContext = (0, $eUqFw.useContext)((0, $gqldc.SmartCardContext));
    const defaultInitialState = (0, $eUqFw.useMemo)(()=>{
        return {};
    }, []);
    const { initialState: initialState } = storeOptions || {
        initialState: defaultInitialState
    };
    const store = (0, $eUqFw.useMemo)(()=>{
        return (0, $huRi7.createStore)((0, $aatVr.cardReducer), initialState);
    }, [
        initialState
    ]);
    const providerValue = (0, $eUqFw.useMemo)(()=>{
        const client = customClient || new (0, $1Hojg.default)();
        // If product is passed into provider, set it on the client if setProduct is supported
        if (product && client.setProduct) client.setProduct(product);
        const authFlow = customAuthFlow || 'oauth2';
        const getPreview = (url, platform)=>{
            const cardState = (0, $cGAGh.getUrl)(store, url);
            return cardState.details ? (0, $fQDHB.extractPreview)(cardState.details.data, platform) : undefined;
        };
        return {
            renderers: renderers,
            store: store,
            prefetchStore: {},
            connections: {
                client: client
            },
            config: {
                authFlow: authFlow
            },
            extractors: {
                getPreview: getPreview
            },
            featureFlags: featureFlags,
            isAdminHubAIEnabled: isAdminHubAIEnabled,
            product: product
        };
    }, [
        customClient,
        customAuthFlow,
        isAdminHubAIEnabled,
        product,
        renderers,
        featureFlags,
        store
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gqldc.SmartCardContext).Provider, {
        value: parentContext || providerValue
    }, children);
}
var $ddfb038c93ff29bc$export$2e2bcd8739ae039 = $ddfb038c93ff29bc$export$497ecb0280204df4;

});
parcelRegister("cGAGh", function(module, exports) {

$parcel$export(module.exports, "getUrl", () => $6b31d06902eb0186$export$94df0e59ebebf4a7);
const $6b31d06902eb0186$export$94df0e59ebebf4a7 = (store, url)=>{
    return store.getState()[url] || {
        status: 'pending'
    };
};

});

parcelRegister("fQDHB", function(module, exports) {

$parcel$export(module.exports, "extractPreview", () => $060df7d9b738514e$export$4b0d98b1b7f6d115);

var $5amkT = parcelRequire("5amkT");

var $9W7HP = parcelRequire("9W7HP");
const $060df7d9b738514e$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
    const preview = jsonLd?.preview;
    const isSupported = (0, $5amkT.extractPlatformIsSupported)(preview, platform);
    if (preview && isSupported) {
        if (typeof preview === 'string') return {
            src: preview
        };
        else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
            src: preview.interactiveHref,
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else if (preview['@type'] === 'Link') return {
            src: (0, $9W7HP.extractUrlFromLinkJsonLd)(preview),
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else {
            // TODO, EDM-565: Remove this once the typings for Dropbox and Jira have been patched up.
            if (preview.url || preview.href) {
                if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                    src: preview.interactiveHref,
                    aspectRatio: preview['atlassian:aspectRatio']
                };
                return {
                    src: (0, $9W7HP.extractUrlFromLinkJsonLd)(preview.url || preview.href),
                    aspectRatio: preview['atlassian:aspectRatio']
                };
            } else if (preview.content) return {
                content: preview.content
            };
        }
    }
};

});
parcelRegister("5amkT", function(module, exports) {

$parcel$export(module.exports, "extractPlatformIsSupported", () => $8b80b7bf7b97ac24$export$3e8ad908070b68b2);
const $8b80b7bf7b97ac24$export$3e8ad908070b68b2 = (preview, platform)=>{
    if (preview) {
        // By default, we support previews everywhere.
        if (typeof preview === 'string') return true;
        else {
            const supportedPlatforms = preview['atlassian:supportedPlatforms'];
            if (supportedPlatforms) {
                const isWeb = platform === 'web';
                return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
            }
            // No supported platforms - assume they are all supported.
            return true;
        }
    }
    // No preview, don't try and render it on any platforms.
    return false;
};

});

parcelRegister("9W7HP", function(module, exports) {

$parcel$export(module.exports, "extractUrlFromLinkJsonLd", () => $4a4ad889fa2ee8d2$export$396ba4ef2e37dc65);
const $4a4ad889fa2ee8d2$export$396ba4ef2e37dc65 = (link)=>{
    if (typeof link === 'string') return link;
    else if (Array.isArray(link)) {
        if (link.length > 0) return $4a4ad889fa2ee8d2$export$396ba4ef2e37dc65(link[0]);
    } else return link.href;
};

});


parcelRegister("aatVr", function(module, exports) {

$parcel$export(module.exports, "cardReducer", () => $f4cdd08462296438$export$3c7c3113a97b6492);

var $6EHO5 = parcelRequire("6EHO5");
var $4hPjC = parcelRequire("4hPjC");
const $f4cdd08462296438$var$isCardAction = (action)=>{
    return [
        (0, $6EHO5.ACTION_PENDING),
        (0, $6EHO5.ACTION_RESOLVING),
        (0, $6EHO5.ACTION_RESOLVED),
        (0, $6EHO5.ACTION_RELOADING),
        (0, $6EHO5.ACTION_ERROR),
        (0, $6EHO5.ACTION_ERROR_FALLBACK),
        (0, $6EHO5.ACTION_UPDATE_METADATA_STATUS)
    ].includes(action.type);
};
function $f4cdd08462296438$var$persistPayloadToState(payload, state, type) {
    const nextDetails = payload;
    const nextState = {
        ...state
    };
    if (nextDetails) {
        nextState.status = (0, $4hPjC.getStatus)(nextDetails);
        nextState.details = nextDetails;
    } else // Keep the pre-existing data in the store. If there
    // is no data, the UI should handle this gracefully.
    nextState.status = type;
    return nextState;
}
function $f4cdd08462296438$var$reduceToNextState(state, action) {
    switch(action.type){
        case 0, $6EHO5.ACTION_PENDING:
            return {
                status: action.type
            };
        case 0, $6EHO5.ACTION_RESOLVING:
            return {
                ...state,
                status: action.type
            };
        case 0, $6EHO5.ACTION_RESOLVED:
            return $f4cdd08462296438$var$persistPayloadToState(action.payload, state, action.type);
        case 0, $6EHO5.ACTION_RELOADING:
            return $f4cdd08462296438$var$persistPayloadToState(action.payload, state, 'resolved');
        case 0, $6EHO5.ACTION_ERROR:
            return {
                ...state,
                status: action.type,
                error: action.error
            };
        case 0, $6EHO5.ACTION_ERROR_FALLBACK:
            return {
                ...state,
                status: action.type,
                error: action.error,
                details: action.payload
            };
        case 0, $6EHO5.ACTION_UPDATE_METADATA_STATUS:
            return {
                ...state,
                metadataStatus: action.metadataStatus
            };
    }
}
const $f4cdd08462296438$export$3c7c3113a97b6492 = (state, action)=>{
    if (!$f4cdd08462296438$var$isCardAction(action)) return state;
    const cardState = state[action.url];
    // Card may have reached the same state on account of multiple of the same
    // URL being present in an editor session. E.g. page with N links to one resource.
    const hasSameStatus = !action.ignoreStatusCheck && cardState && cardState.status === action.type;
    if (hasSameStatus) return state;
    else {
        const nextState = $f4cdd08462296438$var$reduceToNextState(cardState, action);
        return {
            ...state,
            [action.url]: nextState
        };
    }
};

});
parcelRegister("6EHO5", function(module, exports) {

$parcel$export(module.exports, "ACTION_PENDING", () => $48f17d480117024d$export$6e470aad5ba8952e);
$parcel$export(module.exports, "ACTION_RESOLVING", () => $48f17d480117024d$export$9a6a932a0a39498e);
$parcel$export(module.exports, "ACTION_RESOLVED", () => $48f17d480117024d$export$63ec8bc7a8a75482);
$parcel$export(module.exports, "ACTION_RELOADING", () => $48f17d480117024d$export$b8cfaa842c9ab487);
$parcel$export(module.exports, "ACTION_ERROR", () => $48f17d480117024d$export$6d8ed3f9433dd372);
$parcel$export(module.exports, "ACTION_ERROR_FALLBACK", () => $48f17d480117024d$export$cfbbb7126bc8a0c6);
$parcel$export(module.exports, "ACTION_UPDATE_METADATA_STATUS", () => $48f17d480117024d$export$2c5edb971b673330);
$parcel$export(module.exports, "cardAction", () => $48f17d480117024d$export$a884a52152489cc3);
// TODO: eventually move this file to @atlaskit/link-actions
const $48f17d480117024d$export$6e470aad5ba8952e = 'pending';
const $48f17d480117024d$export$9a6a932a0a39498e = 'resolving';
const $48f17d480117024d$export$63ec8bc7a8a75482 = 'resolved';
const $48f17d480117024d$export$b8cfaa842c9ab487 = 'reloading';
const $48f17d480117024d$export$6d8ed3f9433dd372 = 'errored';
const $48f17d480117024d$export$cfbbb7126bc8a0c6 = 'fallback';
const $48f17d480117024d$export$76b5c1aca20759c6 = 'preload';
const $48f17d480117024d$export$2c5edb971b673330 = 'metadata';
const $48f17d480117024d$export$a884a52152489cc3 = (type, { url: url }, payload, error, metadataStatus, ignoreStatusCheck)=>({
        type: type,
        url: url,
        payload: payload,
        error: error,
        metadataStatus: metadataStatus,
        ignoreStatusCheck: ignoreStatusCheck
    });

});

parcelRegister("4hPjC", function(module, exports) {

$parcel$export(module.exports, "getStatus", () => $6a6a7fcdba3f3a7c$export$b70265791d2079d4);
const $6a6a7fcdba3f3a7c$var$getStatusForNotFoundVisibility = (meta)=>{
    const accessType = meta.requestAccess?.accessType;
    if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return 'forbidden';
};
const $6a6a7fcdba3f3a7c$export$b70265791d2079d4 = ({ meta: meta })=>{
    const { access: access, visibility: visibility } = meta;
    switch(access){
        case 'forbidden':
            if (visibility === 'not_found') return $6a6a7fcdba3f3a7c$var$getStatusForNotFoundVisibility(meta);
            else return 'forbidden';
        case 'unauthorized':
            return 'unauthorized';
        default:
            return 'resolved';
    }
};

});


parcelRegister("gqldc", function(module, exports) {

$parcel$export(module.exports, "SmartCardContext", () => $ee9cd29169baa49b$export$156b523e63b4f63a);
$parcel$export(module.exports, "useSmartLinkContext", () => $ee9cd29169baa49b$export$e1d190b530cf0ee9);

var $eUqFw = parcelRequire("eUqFw");

const $ee9cd29169baa49b$export$156b523e63b4f63a = (0, $eUqFw.createContext)(undefined);
function $ee9cd29169baa49b$export$e1d190b530cf0ee9() {
    const context = (0, $eUqFw.useContext)($ee9cd29169baa49b$export$156b523e63b4f63a);
    if (!context) throw Error('useSmartCard() must be wrapped in <SmartCardProvider>');
    return context;
}
var $ee9cd29169baa49b$export$2e2bcd8739ae039 = $ee9cd29169baa49b$export$156b523e63b4f63a;

});

parcelRegister("1Hojg", function(module, exports) {

$parcel$export(module.exports, "default", () => $22d12fbaea01fc74$export$2e2bcd8739ae039);
// import setimmediate to temporary fix dataloader 2.0.0 bug
// @see https://github.com/graphql/dataloader/issues/249
parcelRequire("inzmU");

var $5pr8w = parcelRequire("5pr8w");

var $aTD8J = parcelRequire("aTD8J");

var $bsIpz = parcelRequire("bsIpz");

var $f9yXU = parcelRequire("f9yXU");
var $dUrSu = parcelRequire("dUrSu");
var $4hPjC = parcelRequire("4hPjC");
var $5LW2w = parcelRequire("5LW2w");

var $gbc85 = parcelRequire("gbc85");

var $6roQF = parcelRequire("6roQF");

var $XHGTv = parcelRequire("XHGTv");
const $22d12fbaea01fc74$var$MAX_BATCH_SIZE = 50;
const $22d12fbaea01fc74$var$MIN_TIME_BETWEEN_BATCHES = 250;
const $22d12fbaea01fc74$var$URL_RESPONSE_CACHE_SIZE = 100;
const $22d12fbaea01fc74$export$d6a66073b5d79eb3 = new (0, $6roQF.LRUMap)($22d12fbaea01fc74$var$URL_RESPONSE_CACHE_SIZE);
class $22d12fbaea01fc74$export$2e2bcd8739ae039 {
    constructor(envKey, baseUrlOverride){
        this.postBatchResolve = async (resources, resourceType = 'URL')=>{
            // De-duplicate requested URLs (see `this.createLoader` for more detail).
            // Also de-duplicate requested ARIs as backend does not de-duplicate any requests.
            const deDuplicatedResources = [
                ...new Set(resources)
            ];
            let resolvedResources = [];
            const headers = {
                /**
			 * This header exist to enable the backend to process relative time, eg: "today", with respect to the user timezone.
			 * eg: used in "confluence-object-provider" to resolve confluence SLLV links that may involve relative time calculation.
			 */ ...(0, $XHGTv.getBooleanFF)('platform.linking-platform.datasource.add-timezone-header') ? {
                    'origin-timezone': Intl?.DateTimeFormat().resolvedOptions().timeZone
                } : {},
                // send product source as header X-Product if defined
                ...this.product ? {
                    'X-Product': this.product
                } : {}
            };
            try {
                // Ask the backend to resolve the URLs for us.
                if (resourceType === 'URL') resolvedResources = await (0, $5LW2w.request)('post', `${this.resolverUrl}/resolve/batch`, deDuplicatedResources.map((resourceUrl)=>({
                        resourceUrl: resourceUrl
                    })), headers);
                // Ask the backend to resolve the ARIs for us.
                if (resourceType === 'ARI') resolvedResources = await (0, $5LW2w.request)('post', `${this.resolverUrl}/resolve/ari/batch`, deDuplicatedResources.map((ari)=>({
                        ari: ari
                    })), headers);
            } catch (error) {
                // we make sure we return a valid dataloader response by creating an error
                // response for each url/ari
                resolvedResources = resources.map(()=>{
                    // @ts-ignore
                    const status = (0, $gbc85.isErrorResponse)(error) ? error.status : 500;
                    const errorResponse = {
                        status: status,
                        error: // @ts-ignore
                        error
                    };
                    return errorResponse;
                });
            }
            // Reduce into a map to make accessing faster and easier.
            const map = {};
            // NOTE: the batch endpoint returns the URLs/ARIs in the same order they were given.
            for(let i = 0; i < deDuplicatedResources.length; ++i){
                const resource = deDuplicatedResources[i];
                const data = resolvedResources[i];
                map[resource] = data;
            }
            // Reconvert list back into the original order in which it was given to us.
            return resources.map((originalResource)=>map[originalResource]);
        };
        // Endpoint for batch resolve url
        this.batchResolve = async (urls)=>{
            return this.postBatchResolve(urls, 'URL');
        };
        // Endpoint for batch resolve ari
        this.batchResolveAris = async (aris)=>{
            return this.postBatchResolve(aris, 'ARI');
        };
        this.resolverUrl = (0, $dUrSu.getResolverUrl)(envKey, baseUrlOverride);
        this.loadersByDomain = {};
        this.retryConfig = {
            retries: 2
        };
        this.resolvedCache = {};
        this.envKey = envKey;
        this.baseUrlOverride = baseUrlOverride;
    }
    setProduct(product) {
        this.product = product;
    }
    createLoader() {
        const batchResolveThrottler = (0, (/*@__PURE__*/$parcel$interopDefault($bsIpz)))({
            limit: 1,
            interval: $22d12fbaea01fc74$var$MIN_TIME_BETWEEN_BATCHES
        });
        const throttledBatchResolve = batchResolveThrottler(this.batchResolve);
        return new (0, (/*@__PURE__*/$parcel$interopDefault($5pr8w)))(// We place all calls to `batchResolve` in a limiter so we don't send off several simultaneous batch requests.
        // This is for two reasons:
        //  1: we want to avoid getting rate limited upstream (eg: forge and other APIs)
        //  2: we want to avoid sending out heaps of requests from the client at once
        (urls)=>throttledBatchResolve(urls), {
            maxBatchSize: $22d12fbaea01fc74$var$MAX_BATCH_SIZE,
            // NOTE: we turn off DataLoader's cache because it doesn't work for our use-case. Consider the following:
            // - a smartlink to a restricted item is resolved to "forbidden" with a "request access button"
            // - the user clicks "request access", and then following the auth prompts and gets access
            // - the frontend now re-renders the smartlink, but due to DataLoader's caching, the previous "forbidden" state is
            //   because the smartlink's URL (which is the cache key) is exactly the same
            //
            // For this reason, we disable DataLoader's cache.
            // This means that URLs will not be de-duplicated by DataLoader, so we perform the de-duplication logic
            // ourselves in `this.batchResolve`.
            cache: false
        });
    }
    getLoader(hostname) {
        if (!this.loadersByDomain[hostname]) this.loadersByDomain[hostname] = this.createLoader();
        return this.loadersByDomain[hostname];
    }
    async resolveUrl(url, force = false) {
        const hostname = new URL(url).hostname;
        const loader = this.getLoader(hostname);
        let responsePromise;
        responsePromise = $22d12fbaea01fc74$export$d6a66073b5d79eb3.get(url);
        if (!responsePromise || force) {
            responsePromise = loader.load(url);
            $22d12fbaea01fc74$export$d6a66073b5d79eb3.set(url, responsePromise);
        }
        let response;
        try {
            response = await responsePromise;
        } catch (e) {
            // Technically this never happens, since batchResolve handles errors and doesn't throw,
            // But just in case.
            $22d12fbaea01fc74$export$d6a66073b5d79eb3.delete(url);
            throw e;
        }
        const isUnresolvedLink = !(0, $gbc85.isSuccessfulResponse)(response) || (0, $4hPjC.getStatus)(response.body) !== 'resolved';
        if (isUnresolvedLink) // We want consequent calls for fetchData() to cause actual http call
        $22d12fbaea01fc74$export$d6a66073b5d79eb3.delete(url);
        return response;
    }
    async prefetchData(url) {
        // 1. Queue the URL as part of a dataloader batch.
        const response = await this.resolveUrl(url, false);
        if ((0, $gbc85.isSuccessfulResponse)(response)) // 2. If the URL resolves, send it back.
        return response.body;
        else try {
            // 3. If the URL does not resolve, retry it with exponential backoff.
            // This is done so that we avoid the scenario where users are unable to
            // see a resolved Smart Link, when their expectation is to be able to.
            const retriedResponse = await (0, (/*@__PURE__*/$parcel$interopDefault($aTD8J)))(async ()=>{
                // We check if the link has resolved in the cache and stop trying if so.
                // We do this by triggering an error that the link has already been resolved.
                // This cascades <retryCount> times after which it is handled like a normal
                // 'error', returning `undefined`.
                if (!this.resolvedCache[url]) {
                    const response = await this.resolveUrl(url, false);
                    if ((0, $gbc85.isSuccessfulResponse)(response)) return response;
                    else throw new Error('Retry for URL failed');
                } else // Short-circuit each of the retries, as described above.
                throw new Error('Retry unneeded - link has been resolved.');
            }, this.retryConfig);
            // Trigger callback after successful backoff.
            return retriedResponse.body;
        } catch (err) {
            // Do nothing in the case of an error - prefetching
            // failures should be silent. Once a link is visible,
            // it will be re-fetched anyhow, in which case a
            // user-facing error is required.
            return undefined;
        }
    }
    isRateLimitError(response) {
        return (0, $gbc85.isErrorResponse)(response) && response.error.status === 429;
    }
    // Fetch data from URL
    async fetchData(url, force) {
        let response = await this.resolveUrl(url, force);
        if (this.isRateLimitError(response)) response = await (0, (/*@__PURE__*/$parcel$interopDefault($aTD8J)))(async ()=>{
            const retryResponse = await this.resolveUrl(url, false);
            if (this.isRateLimitError(retryResponse)) throw this.mapErrorResponse(retryResponse, new URL(url).hostname);
            return retryResponse;
        }, this.retryConfig);
        if (!(0, $gbc85.isSuccessfulResponse)(response)) throw this.mapErrorResponse(response, new URL(url).hostname);
        // Set a flag in the `resolvedCache` for this URL. The intent of this is
        // to ensure that the exponential backoff method in `prefetchData` does
        // not continue to retry fetching for this URL, especially if it was previously
        // in a failed state. Note: this scenario only occurs on initial page load, if the
        // user scrolls through the page very fast. Once the URL is visible, prefetching
        // no longer takes place.
        this.resolvedCache[url] = true;
        // Return the JSON-LD response back up!
        return response.body;
    }
    /**
	 * Fetch data for multiple ARIs (batch) in one operation
	 * @param aris Array of ARIs to fetch data for
	 */ async fetchDataAris(aris) {
        return await this.batchResolveAris(aris);
    }
    async postData(data) {
        const requestData = {
            key: data.key,
            action: data.action,
            context: data.context
        };
        return await (0, $5LW2w.request)('post', `${this.resolverUrl}/invoke`, requestData);
    }
    /**
	 * Make request to the Search endpoint See `InvocationRequest` in ORS openapi.yaml for backend
	 * spec.
	 * @param data Payload including the search provider key and query. An empty search query string
	 * results in recent results being returned (pre-query).
	 * @returns JsonLd collection of search results.
	 */ async search(data) {
        const { key: key, action: action } = data;
        // Note: context in action is different to context in data, see types.
        const { query: query, context: context } = action;
        const requestData = {
            key: key,
            search: {
                query: query,
                context: context
            }
        };
        const response = await (0, $5LW2w.request)('post', `${this.resolverUrl}/invoke/search`, requestData);
        if ((0, $gbc85.isErrorResponse)(response)) // There is no hostname/it is not known. Hostname is not logged anyway as it's considered PII.
        throw this.mapErrorResponse(response);
        return response;
    }
    async fetchAvailableSearchProviders() {
        const response = await (0, $5LW2w.request)('post', `${this.resolverUrl}/providers`, {
            type: 'search'
        });
        return response.providers;
    }
    mapErrorResponse(response, hostname = '') {
        // Catch non-200 server responses to fallback or return useful information.
        if (response?.error) {
            const errorType = response.error.type;
            const errorMessage = response.error.message;
            const extensionKey = response.error.extensionKey;
            // this means there was a network error and we fallback to blue link
            // without impacting SLO's
            if (response.error instanceof (0, $5LW2w.NetworkError)) return new (0, $f9yXU.APIError)('fallback', hostname, errorMessage, errorType);
            switch(errorType){
                // BadRequestError - indicative of an API error, render
                // a blue link to mitigate customer impact.
                case 'ResolveBadRequestError':
                case 'SearchBadRequestError':
                    return new (0, $f9yXU.APIError)('fallback', hostname, errorMessage, errorType, extensionKey);
                // AuthError - if the user logs in, we may be able
                // to recover. Render an unauthorized card.
                case 'ResolveAuthError':
                case 'SearchAuthError':
                    return new (0, $f9yXU.APIError)('auth', hostname, errorMessage, errorType, extensionKey);
                // UnsupportedError - we do not know how to render this URL.
                // Bail out and ask the Editor to render as a blue link.
                case 'ResolveUnsupportedError':
                case 'SearchUnsupportedError':
                    return new (0, $f9yXU.APIError)('fatal', hostname, errorMessage, errorType, extensionKey);
                case 'ResolveFailedError':
                case 'SearchFailedError':
                case 'ResolveTimeoutError':
                case 'SearchTimeoutError':
                case 'SearchRateLimitError':
                case 'ResolveRateLimitError':
                case 'InternalServerError':
                    return new (0, $f9yXU.APIError)('error', hostname, errorMessage, errorType, extensionKey);
            }
        }
        // Catch all: we don't know this error, bail out.
        const { error: error, ...rest } = response || {};
        return new (0, $f9yXU.APIError)('fatal', hostname, // reason we stringify the error differently is because
        // JSON.stringify will return "{}" if it is an instance of Error
        // e.g. JSON.stringify(new Error('something went wrong')) will return '{}'
        // reason is JSON.stringify method only serializes enumerable properties but properties like "message" and "stack" are non enumerable
        // e.g. https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/message
        // more info here https://stackoverflow.com/questions/18391212/is-it-not-possible-to-stringify-an-error-using-json-stringify
        // we assume 'rest'  to "serializable" meaning all its properties are enumerable
        response ? `${this.stringifyError(error)} ${JSON.stringify(rest)}` : 'Response undefined', 'UnexpectedError');
    }
    /**
	 * This method will strigify both enumerable and  non enumerable properties of an object
	 * @param err
	 * @returns object serialized to JSON with both enumerable and non enumerable objects
	 */ stringifyError(err) {
        /**
		 * By default JSON.stringify only serializes enumerable properties of an object. In order for us to
		 * serialize non enumerable properties out of an error we need to expclitily provide the non enumerable property names.
		 * the second parameter to JSON.stringify gets the properties that will be serialized from the object passed in the first argument
		 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/getOwnPropertyNames
		 */ return JSON.stringify(err, //In ES5, if the argument to getOwnPropertyNames method is not an object (a primitive), then it will cause a TypeError
        typeof err === 'object' ? Object.getOwnPropertyNames(err) : undefined);
    }
}

});
parcelRegister("inzmU", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
(function(global1, undefined) {
    "use strict";
    if (global1.setImmediate) return;
    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global1.document;
    var registerImmediate;
    function setImmediate(callback) {
        // Callback can either be a function or a string
        if (typeof callback !== "function") callback = new Function("" + callback);
        // Copy function arguments
        var args = new Array(arguments.length - 1);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i + 1];
        // Store and register the task
        var task = {
            callback: callback,
            args: args
        };
        tasksByHandle[nextHandle] = task;
        registerImmediate(nextHandle);
        return nextHandle++;
    }
    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }
    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch(args.length){
            case 0:
                callback();
                break;
            case 1:
                callback(args[0]);
                break;
            case 2:
                callback(args[0], args[1]);
                break;
            case 3:
                callback(args[0], args[1], args[2]);
                break;
            default:
                callback.apply(undefined, args);
                break;
        }
    }
    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
        // "too much recursion" error.
        setTimeout(runIfPresent, 0, handle);
        else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally{
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }
    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            $2fFJv.nextTick(function() {
                runIfPresent(handle);
            });
        };
    }
    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global1.postMessage && !global1.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global1.onmessage;
            global1.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global1.postMessage("", "*");
            global1.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }
    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global1 && typeof event.data === "string" && event.data.indexOf(messagePrefix) === 0) runIfPresent(+event.data.slice(messagePrefix.length));
        };
        if (global1.addEventListener) global1.addEventListener("message", onGlobalMessage, false);
        else global1.attachEvent("onmessage", onGlobalMessage);
        registerImmediate = function(handle) {
            global1.postMessage(messagePrefix + handle, "*");
        };
    }
    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };
        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }
    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function() {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }
    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }
    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global1);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global1;
    // Don't get fooled by e.g. browserify environments.
    if (({}).toString.call(global1.process) === "[object process]") // For Node.js before 0.9
    installNextTickImplementation();
    else if (canUsePostMessage()) // For non-IE10 modern browsers
    installPostMessageImplementation();
    else if (global1.MessageChannel) // For web workers, where supported
    installMessageChannelImplementation();
    else if (doc && "onreadystatechange" in doc.createElement("script")) // For IE 6–8
    installReadyStateChangeImplementation();
    else // For older browsers
    installSetTimeoutImplementation();
    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
})(typeof self === "undefined" ? typeof $parcel$global === "undefined" ? module.exports : $parcel$global : self);

});

parcelRegister("5pr8w", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $3f0456472e399d24$var$DataLoader = /*#__PURE__*/ function() {
    function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $3f0456472e399d24$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $3f0456472e399d24$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $3f0456472e399d24$var$getValidCacheKeyFn(options);
        this._cacheMap = $3f0456472e399d24$var$getValidCacheMap(options);
        this._batch = null;
    } // Private
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value,' + ("but got: " + String(key) + "."));
        var batch = $3f0456472e399d24$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey = this._cacheKeyFn(key); // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        return resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    } /**
   * Loads multiple keys, promising an array of values:
   *
   *     var [ a, b ] = await myLoader.loadMany([ 'a', 'b' ]);
   *
   * This is similar to the more verbose:
   *
   *     var [ a, b ] = await Promise.all([
   *       myLoader.load('a'),
   *       myLoader.load('b')
   *     ]);
   *
   * However it is different in the case where any load fails. Where
   * Promise.all() would reject, loadMany() always resolves, however each result
   * is either a value or an Error instance.
   *
   *     var [ a, b, c ] = await myLoader.loadMany([ 'a', 'b', 'badkey' ]);
   *     // c instanceof Error
   *
   */ ;
    _proto.loadMany = function loadMany(keys) {
        if (!$3f0456472e399d24$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    } /**
   * Clears the value at `key` from the cache, if it exists. Returns itself for
   * method chaining.
   */ ;
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    } /**
   * Clears the entire cache. To be used when some event results in unknown
   * invalidations across this particular `DataLoader`. Returns itself for
   * method chaining.
   */ ;
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    } /**
   * Adds the provided key and value to the cache. If the key already
   * exists, no change is made. Returns itself for method chaining.
   *
   * To prime the cache with an error at a key, provide an Error instance.
   */ ;
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    };
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $3f0456472e399d24$var$enqueuePostPromiseJob = typeof $2fFJv === 'object' && typeof $2fFJv.nextTick === 'function' ? function(fn) {
    if (!$3f0456472e399d24$var$resolvedPromise) $3f0456472e399d24$var$resolvedPromise = Promise.resolve();
    $3f0456472e399d24$var$resolvedPromise.then(function() {
        return $2fFJv.nextTick(fn);
    });
} : setImmediate || setTimeout; // Private: cached resolved Promise instance
var $3f0456472e399d24$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $3f0456472e399d24$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize && (!existingBatch.cacheHits || existingBatch.cacheHits.length < loader._maxBatchSize)) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        return $3f0456472e399d24$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $3f0456472e399d24$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $3f0456472e399d24$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise = loader._batchLoadFn(batch.keys); // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== 'function') return $3f0456472e399d24$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$3f0456472e399d24$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $3f0456472e399d24$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var value = values[i];
            if (value instanceof Error) batch.callbacks[i].reject(value);
            else batch.callbacks[i].resolve(value);
        }
    })["catch"](function(error) {
        return $3f0456472e399d24$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $3f0456472e399d24$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $3f0456472e399d24$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $3f0456472e399d24$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $3f0456472e399d24$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $3f0456472e399d24$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $3f0456472e399d24$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $3f0456472e399d24$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $3f0456472e399d24$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            'get',
            'set',
            'delete',
            'clear'
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== 'function';
        });
        if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
    }
    return cacheMap;
} // Private
function $3f0456472e399d24$var$isArrayLike(x) {
    return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $3f0456472e399d24$var$DataLoader;

});

parcelRegister("aTD8J", function(module, exports) {
// Packages

var $kiPA0 = parcelRequire("kiPA0");
function $7eed66c63d4af541$var$retry(fn, opts) {
    function run(resolve, reject) {
        var options = opts || {};
        // Default `randomize` to true
        if (!('randomize' in options)) options.randomize = true;
        var op = $kiPA0.operation(options);
        // We allow the user to abort retrying
        // this makes sense in the cases where
        // knowledge is obtained that retrying
        // would be futile (e.g.: auth errors)
        function bail(err) {
            reject(err || new Error('Aborted'));
        }
        function onError(err, num) {
            if (err.bail) {
                bail(err);
                return;
            }
            if (!op.retry(err)) reject(op.mainError());
            else if (options.onRetry) options.onRetry(err, num);
        }
        function runAttempt(num) {
            var val;
            try {
                val = fn(bail, num);
            } catch (err) {
                onError(err, num);
                return;
            }
            Promise.resolve(val).then(resolve).catch(function catchIt(err) {
                onError(err, num);
            });
        }
        op.attempt(runAttempt);
    }
    return new Promise(run);
}
module.exports = $7eed66c63d4af541$var$retry;

});
parcelRegister("kiPA0", function(module, exports) {

module.exports = (parcelRequire("2aMUW"));

});
parcelRegister("2aMUW", function(module, exports) {

var $6ZiEJ = parcelRequire("6ZiEJ");
exports.operation = function(options) {
    var timeouts = exports.timeouts(options);
    return new $6ZiEJ(timeouts, {
        forever: options && options.forever,
        unref: options && options.unref,
        maxRetryTime: options && options.maxRetryTime
    });
};
exports.timeouts = function(options) {
    if (options instanceof Array) return [].concat(options);
    var opts = {
        retries: 10,
        factor: 2,
        minTimeout: 1000,
        maxTimeout: Infinity,
        randomize: false
    };
    for(var key in options)opts[key] = options[key];
    if (opts.minTimeout > opts.maxTimeout) throw new Error('minTimeout is greater than maxTimeout');
    var timeouts = [];
    for(var i = 0; i < opts.retries; i++)timeouts.push(this.createTimeout(i, opts));
    if (options && options.forever && !timeouts.length) timeouts.push(this.createTimeout(i, opts));
    // sort the array numerically ascending
    timeouts.sort(function(a, b) {
        return a - b;
    });
    return timeouts;
};
exports.createTimeout = function(attempt, opts) {
    var random = opts.randomize ? Math.random() + 1 : 1;
    var timeout = Math.round(random * opts.minTimeout * Math.pow(opts.factor, attempt));
    timeout = Math.min(timeout, opts.maxTimeout);
    return timeout;
};
exports.wrap = function(obj, options, methods) {
    if (options instanceof Array) {
        methods = options;
        options = null;
    }
    if (!methods) {
        methods = [];
        for(var key in obj)if (typeof obj[key] === 'function') methods.push(key);
    }
    for(var i = 0; i < methods.length; i++){
        var method = methods[i];
        var original = obj[method];
        obj[method] = (function retryWrapper(original) {
            var op = exports.operation(options);
            var args = Array.prototype.slice.call(arguments, 1);
            var callback = args.pop();
            args.push(function(err) {
                if (op.retry(err)) return;
                if (err) arguments[0] = op.mainError();
                callback.apply(this, arguments);
            });
            op.attempt(function() {
                original.apply(obj, args);
            });
        }).bind(obj, original);
        obj[method].options = options;
    }
};

});
parcelRegister("6ZiEJ", function(module, exports) {
function $5166e949108ea881$var$RetryOperation(timeouts, options) {
    // Compatibility for the old (timeouts, retryForever) signature
    if (typeof options === 'boolean') options = {
        forever: options
    };
    this._originalTimeouts = JSON.parse(JSON.stringify(timeouts));
    this._timeouts = timeouts;
    this._options = options || {};
    this._maxRetryTime = options && options.maxRetryTime || Infinity;
    this._fn = null;
    this._errors = [];
    this._attempts = 1;
    this._operationTimeout = null;
    this._operationTimeoutCb = null;
    this._timeout = null;
    this._operationStart = null;
    if (this._options.forever) this._cachedTimeouts = this._timeouts.slice(0);
}
module.exports = $5166e949108ea881$var$RetryOperation;
$5166e949108ea881$var$RetryOperation.prototype.reset = function() {
    this._attempts = 1;
    this._timeouts = this._originalTimeouts;
};
$5166e949108ea881$var$RetryOperation.prototype.stop = function() {
    if (this._timeout) clearTimeout(this._timeout);
    this._timeouts = [];
    this._cachedTimeouts = null;
};
$5166e949108ea881$var$RetryOperation.prototype.retry = function(err) {
    if (this._timeout) clearTimeout(this._timeout);
    if (!err) return false;
    var currentTime = new Date().getTime();
    if (err && currentTime - this._operationStart >= this._maxRetryTime) {
        this._errors.unshift(new Error('RetryOperation timeout occurred'));
        return false;
    }
    this._errors.push(err);
    var timeout = this._timeouts.shift();
    if (timeout === undefined) {
        if (this._cachedTimeouts) {
            // retry forever, only keep last error
            this._errors.splice(this._errors.length - 1, this._errors.length);
            this._timeouts = this._cachedTimeouts.slice(0);
            timeout = this._timeouts.shift();
        } else return false;
    }
    var self = this;
    var timer = setTimeout(function() {
        self._attempts++;
        if (self._operationTimeoutCb) {
            self._timeout = setTimeout(function() {
                self._operationTimeoutCb(self._attempts);
            }, self._operationTimeout);
            if (self._options.unref) self._timeout.unref();
        }
        self._fn(self._attempts);
    }, timeout);
    if (this._options.unref) timer.unref();
    return true;
};
$5166e949108ea881$var$RetryOperation.prototype.attempt = function(fn, timeoutOps) {
    this._fn = fn;
    if (timeoutOps) {
        if (timeoutOps.timeout) this._operationTimeout = timeoutOps.timeout;
        if (timeoutOps.cb) this._operationTimeoutCb = timeoutOps.cb;
    }
    var self = this;
    if (this._operationTimeoutCb) this._timeout = setTimeout(function() {
        self._operationTimeoutCb();
    }, self._operationTimeout);
    this._operationStart = new Date().getTime();
    this._fn(this._attempts);
};
$5166e949108ea881$var$RetryOperation.prototype.try = function(fn) {
    console.log('Using RetryOperation.try() is deprecated');
    this.attempt(fn);
};
$5166e949108ea881$var$RetryOperation.prototype.start = function(fn) {
    console.log('Using RetryOperation.start() is deprecated');
    this.attempt(fn);
};
$5166e949108ea881$var$RetryOperation.prototype.start = $5166e949108ea881$var$RetryOperation.prototype.try;
$5166e949108ea881$var$RetryOperation.prototype.errors = function() {
    return this._errors;
};
$5166e949108ea881$var$RetryOperation.prototype.attempts = function() {
    return this._attempts;
};
$5166e949108ea881$var$RetryOperation.prototype.mainError = function() {
    if (this._errors.length === 0) return null;
    var counts = {};
    var mainError = null;
    var mainErrorCount = 0;
    for(var i = 0; i < this._errors.length; i++){
        var error = this._errors[i];
        var message = error.message;
        var count = (counts[message] || 0) + 1;
        counts[message] = count;
        if (count >= mainErrorCount) {
            mainError = error;
            mainErrorCount = count;
        }
    }
    return mainError;
};

});




parcelRegister("bsIpz", function(module, exports) {
'use strict';
class $8584c26edaaf8f93$var$AbortError extends Error {
    constructor(){
        super('Throttled function aborted');
        this.name = 'AbortError';
    }
}
const $8584c26edaaf8f93$var$pThrottle = ({ limit: limit, interval: interval, strict: strict })=>{
    if (!Number.isFinite(limit)) throw new TypeError('Expected `limit` to be a finite number');
    if (!Number.isFinite(interval)) throw new TypeError('Expected `interval` to be a finite number');
    const queue = new Map();
    let currentTick = 0;
    let activeCount = 0;
    function windowedDelay() {
        const now = Date.now();
        if (now - currentTick > interval) {
            activeCount = 1;
            currentTick = now;
            return 0;
        }
        if (activeCount < limit) activeCount++;
        else {
            currentTick += interval;
            activeCount = 1;
        }
        return currentTick - now;
    }
    const strictTicks = [];
    function strictDelay() {
        const now = Date.now();
        if (strictTicks.length < limit) {
            strictTicks.push(now);
            return 0;
        }
        const earliestTime = strictTicks.shift() + interval;
        if (now >= earliestTime) {
            strictTicks.push(now);
            return 0;
        }
        strictTicks.push(earliestTime);
        return earliestTime - now;
    }
    const getDelay = strict ? strictDelay : windowedDelay;
    return (function_)=>{
        const throttled = function(...args) {
            if (!throttled.isEnabled) return (async ()=>function_.apply(this, args))();
            let timeout;
            return new Promise((resolve, reject)=>{
                const execute = ()=>{
                    resolve(function_.apply(this, args));
                    queue.delete(timeout);
                };
                timeout = setTimeout(execute, getDelay());
                queue.set(timeout, reject);
            });
        };
        throttled.abort = ()=>{
            for (const timeout of queue.keys()){
                clearTimeout(timeout);
                queue.get(timeout)(new $8584c26edaaf8f93$var$AbortError());
            }
            queue.clear();
            strictTicks.splice(0, strictTicks.length);
        };
        throttled.isEnabled = true;
        return throttled;
    };
};
module.exports = $8584c26edaaf8f93$var$pThrottle;
module.exports.AbortError = $8584c26edaaf8f93$var$AbortError;

});

parcelRegister("f9yXU", function(module, exports) {

$parcel$export(module.exports, "APIError", () => $eab65a9e311d10e1$export$3e5b797e39668f84);
class $eab65a9e311d10e1$export$3e5b797e39668f84 extends Error {
    constructor(kind, hostname, message, type, extensionKey){
        super(`${kind}: ${message}`);
        this.kind = kind;
        this.hostname = hostname;
        this.message = message;
        this.type = type;
        this.extensionKey = extensionKey;
        this.name = 'APIError';
        // The error type received from the server.
        this.type = type;
        // The kind mapped to on the client.
        this.kind = kind;
        // The message received from the server.
        this.message = message;
        // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
        this.hostname = hostname;
        // The extensionKey passed from the error response from ORS
        this.extensionKey = extensionKey;
    }
}

});

parcelRegister("dUrSu", function(module, exports) {

$parcel$export(module.exports, "getBaseUrl", () => $67d3f38f231759a2$export$f654b28f82155665);
$parcel$export(module.exports, "getResolverUrl", () => $67d3f38f231759a2$export$dc37652c1696f231);
const $67d3f38f231759a2$var$devBaseUrl = 'https://api-private.dev.atlassian.com';
const $67d3f38f231759a2$var$stgBaseUrl = 'https://pug.jira-dev.com/gateway/api';
const $67d3f38f231759a2$var$prodBaseUrl = 'https://api-private.atlassian.com';
const $67d3f38f231759a2$export$e2b040f052407032 = {
    dev: $67d3f38f231759a2$var$devBaseUrl,
    development: $67d3f38f231759a2$var$devBaseUrl,
    stg: $67d3f38f231759a2$var$stgBaseUrl,
    staging: $67d3f38f231759a2$var$stgBaseUrl,
    prd: $67d3f38f231759a2$var$prodBaseUrl,
    prod: $67d3f38f231759a2$var$prodBaseUrl,
    production: $67d3f38f231759a2$var$prodBaseUrl
};
const $67d3f38f231759a2$export$f654b28f82155665 = (envKey)=>{
    // If an environment is provided, then use Stargate.
    if (envKey) return envKey in $67d3f38f231759a2$export$e2b040f052407032 ? $67d3f38f231759a2$export$e2b040f052407032[envKey] : $67d3f38f231759a2$var$prodBaseUrl;
    // Otherwise, use the current origin of the page.
    return typeof window.location !== 'undefined' ? window.location.origin : '';
};
const $67d3f38f231759a2$export$dc37652c1696f231 = (envKey, baseUrlOverride)=>{
    // If an environment is provided, then use Stargate directly for requests.
    if (envKey || baseUrlOverride) {
        const baseUrl = baseUrlOverride || $67d3f38f231759a2$export$f654b28f82155665(envKey);
        return `${baseUrl}/object-resolver`;
    } else // Otherwise, we fallback to using the Edge Proxy to access Stargate,
    // which fixes some cookie issues with strict Browser policies.
    return '/gateway/api/object-resolver';
};
var $67d3f38f231759a2$export$2e2bcd8739ae039 = $67d3f38f231759a2$export$e2b040f052407032;

});

parcelRegister("5LW2w", function(module, exports) {

$parcel$export(module.exports, "NetworkError", () => $182a4c691eac998e$export$bae979e68e4dc802);
$parcel$export(module.exports, "request", () => $182a4c691eac998e$export$b5fe3f66a567bec0);
const $182a4c691eac998e$var$ALLOWED_RESPONSE_STATUS_CODES = [
    200,
    401,
    404
];
class $182a4c691eac998e$export$bae979e68e4dc802 extends Error {
    constructor(error){
        super(error);
    }
}
async function $182a4c691eac998e$export$b5fe3f66a567bec0(method, url, data, headers, statuses = $182a4c691eac998e$var$ALLOWED_RESPONSE_STATUS_CODES) {
    const requestConfig = {
        method: method,
        credentials: 'include',
        headers: {
            Accept: 'application/json',
            'Cache-Control': 'no-cache',
            'Content-Type': 'application/json',
            ...headers
        },
        ...data ? {
            body: JSON.stringify(data)
        } : {}
    };
    try {
        const response = await fetch(url, requestConfig);
        if (response.ok || statuses?.includes(response.status)) {
            if (statuses.includes(204)) {
                const text = await response.text();
                return text ? JSON.parse(text) : undefined;
            } else return await response.json();
        }
        throw response;
    } catch (error) {
        if (typeof error === 'string' || error instanceof TypeError) throw new $182a4c691eac998e$export$bae979e68e4dc802(error);
        throw error;
    }
}

});

parcelRegister("gbc85", function(module, exports) {

$parcel$export(module.exports, "isSuccessfulResponse", () => $fe0c9814ae7f11c7$export$1b59fe731a28a49d);
$parcel$export(module.exports, "isErrorResponse", () => $fe0c9814ae7f11c7$export$bea7bee8a87e7c52);
const $fe0c9814ae7f11c7$export$1b59fe731a28a49d = (response)=>{
    if (!response) return false;
    const hasSuccessfulStatus = response.status === 200;
    const hasSuccessBody = 'body' in response;
    return hasSuccessfulStatus && hasSuccessBody;
};
const $fe0c9814ae7f11c7$export$bea7bee8a87e7c52 = (response)=>{
    if (!response) return false;
    const hasStatus = 'status' in response && response.status >= 200;
    const hasErrorBody = 'error' in response;
    return hasStatus && hasErrorBody;
};

});

parcelRegister("6roQF", function(module, exports) {
!function(g, c) {
    c(module.exports);
}(module.exports, function(g) {
    const c = Symbol("newer"), e = Symbol("older");
    class n {
        constructor(a, b){
            typeof a !== "number" && (b = a, a = 0), this.size = 0, this.limit = a, this.oldest = this.newest = void 0, this._keymap = new Map(), b && (this.assign(b), a < 1 && (this.limit = this.size));
        }
        _markEntryAsUsed(a) {
            if (a === this.newest) return;
            a[c] && (a === this.oldest && (this.oldest = a[c]), a[c][e] = a[e]), a[e] && (a[e][c] = a[c]), a[c] = void 0, a[e] = this.newest, this.newest && (this.newest[c] = a), this.newest = a;
        }
        assign(a) {
            let b, d = this.limit || Number.MAX_VALUE;
            this._keymap.clear();
            let m = a[Symbol.iterator]();
            for(let h = m.next(); !h.done; h = m.next()){
                let f = new l(h.value[0], h.value[1]);
                this._keymap.set(f.key, f), b ? (b[c] = f, f[e] = b) : this.oldest = f, b = f;
                if (d-- == 0) throw new Error("overflow");
            }
            this.newest = b, this.size = this._keymap.size;
        }
        get(a) {
            var b = this._keymap.get(a);
            return b ? (this._markEntryAsUsed(b), b.value) : void 0;
        }
        set(a, b) {
            var d = this._keymap.get(a);
            return d ? (d.value = b, this._markEntryAsUsed(d), this) : (this._keymap.set(a, d = new l(a, b)), this.newest ? (this.newest[c] = d, d[e] = this.newest) : this.oldest = d, this.newest = d, ++this.size, this.size > this.limit && this.shift(), this);
        }
        shift() {
            var a = this.oldest;
            if (a) return this.oldest[c] ? (this.oldest = this.oldest[c], this.oldest[e] = void 0) : (this.oldest = void 0, this.newest = void 0), a[c] = a[e] = void 0, this._keymap.delete(a.key), --this.size, [
                a.key,
                a.value
            ];
        }
        find(a) {
            let b = this._keymap.get(a);
            return b ? b.value : void 0;
        }
        has(a) {
            return this._keymap.has(a);
        }
        delete(a) {
            var b = this._keymap.get(a);
            return b ? (this._keymap.delete(b.key), b[c] && b[e] ? (b[e][c] = b[c], b[c][e] = b[e]) : b[c] ? (b[c][e] = void 0, this.oldest = b[c]) : b[e] ? (b[e][c] = void 0, this.newest = b[e]) : this.oldest = this.newest = void 0, this.size--, b.value) : void 0;
        }
        clear() {
            this.oldest = this.newest = void 0, this.size = 0, this._keymap.clear();
        }
        keys() {
            return new j(this.oldest);
        }
        values() {
            return new k(this.oldest);
        }
        entries() {
            return this;
        }
        [Symbol.iterator]() {
            return new i(this.oldest);
        }
        forEach(a, b) {
            typeof b !== "object" && (b = this);
            let d = this.oldest;
            for(; d;)a.call(b, d.value, d.key, this), d = d[c];
        }
        toJSON() {
            for(var a = new Array(this.size), b = 0, d = this.oldest; d;)a[b++] = {
                key: d.key,
                value: d.value
            }, d = d[c];
            return a;
        }
        toString() {
            for(var a = "", b = this.oldest; b;)a += String(b.key) + ":" + b.value, b = b[c], b && (a += " < ");
            return a;
        }
    }
    g.LRUMap = n;
    function l(a, b) {
        this.key = a, this.value = b, this[c] = void 0, this[e] = void 0;
    }
    function i(a) {
        this.entry = a;
    }
    i.prototype[Symbol.iterator] = function() {
        return this;
    }, i.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: [
                a.key,
                a.value
            ]
        }) : {
            done: !0,
            value: void 0
        };
    };
    function j(a) {
        this.entry = a;
    }
    j.prototype[Symbol.iterator] = function() {
        return this;
    }, j.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.key
        }) : {
            done: !0,
            value: void 0
        };
    };
    function k(a) {
        this.entry = a;
    }
    k.prototype[Symbol.iterator] = function() {
        return this;
    }, k.prototype.next = function() {
        let a = this.entry;
        return a ? (this.entry = a[c], {
            done: !1,
            value: a.value
        }) : {
            done: !0,
            value: void 0
        };
    };
});

});



parcelRegister("18to0", function(module, exports) {

$parcel$export(module.exports, "useInlineFields", () => $dac7e85413a0f58a$export$71d5b5acb7d7f5ce);
$parcel$export(module.exports, "useInlineField", () => $dac7e85413a0f58a$export$14c9655e9d9e873c);
$parcel$export(module.exports, "useInlineFieldsActions", () => $dac7e85413a0f58a$export$cdb4b503c6154b35);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $7FqBr = parcelRequire("7FqBr");


var $iEhdM = parcelRequire("iEhdM");
// Inline fields state tracks field states in create issue view as the user interacts with them
// this is particularly needed as we want to save the field's value when the user
// unfocuses the field
const $dac7e85413a0f58a$var$store = (0, $a61MH.createStore)({
    name: 'forge.inline-fields-state',
    initialState: {},
    actions: $7FqBr.default
});
const $dac7e85413a0f58a$export$71d5b5acb7d7f5ce = (0, $ggKAj.createHook)($dac7e85413a0f58a$var$store);
const $dac7e85413a0f58a$export$14c9655e9d9e873c = (0, $ggKAj.createHook)($dac7e85413a0f58a$var$store, {
    selector: (state, fieldId)=>state[fieldId]
});
const $dac7e85413a0f58a$export$cdb4b503c6154b35 = (0, $ggKAj.createHook)($dac7e85413a0f58a$var$store, {
    selector: null
});

});
parcelRegister("7FqBr", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ebb8a0129954b6a$export$2e2bcd8739ae039);

var $2h3yq = parcelRequire("2h3yq");
const $2ebb8a0129954b6a$var$actions = {
    setFieldState: $2h3yq.setFieldState,
    resetState: $2h3yq.resetState,
    dispatchRetryFunction: $2h3yq.dispatchRetryFunction,
    dispatchFormSubmits: $2h3yq.dispatchFormSubmits
};
var $2ebb8a0129954b6a$export$2e2bcd8739ae039 = $2ebb8a0129954b6a$var$actions;

});
parcelRegister("2h3yq", function(module, exports) {

$parcel$export(module.exports, "setFieldState", () => $99f6e2cbf5817dbf$export$80fd62d9217dd703);
$parcel$export(module.exports, "resetState", () => $99f6e2cbf5817dbf$export$8e84bad0b35de9e8);
$parcel$export(module.exports, "dispatchRetryFunction", () => $99f6e2cbf5817dbf$export$27c59f06a7c1fe26);
$parcel$export(module.exports, "dispatchFormSubmits", () => $99f6e2cbf5817dbf$export$42fd5e650971333b);


var $iEhdM = parcelRequire("iEhdM");
const $99f6e2cbf5817dbf$export$80fd62d9217dd703 = (data)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const stateObject = {
            status: data.status !== undefined ? data.status : currentState[data.fieldId]?.status,
            formRef: data.formRef !== undefined ? data.formRef : currentState[data.fieldId]?.formRef,
            retryFunction: data.retryFunction !== undefined ? data.retryFunction : currentState[data.fieldId]?.retryFunction
        };
        setState({
            ...getState(),
            [data.fieldId]: stateObject
        });
    };
const $99f6e2cbf5817dbf$export$8e84bad0b35de9e8 = ()=>({ getState: getState, setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const stateToOverride = {};
        Object.getOwnPropertyNames(getState()).forEach((fieldId)=>{
            stateToOverride[fieldId] = {
                status: (0, $e456ec6df0e2a730$export$bbf78c43fa5268c8)
            };
        });
        setState(stateToOverride);
    };
const $99f6e2cbf5817dbf$export$27c59f06a7c1fe26 = (fieldId)=>async ({ getState: getState })=>{
        const currentState = getState();
        const fieldData = currentState[fieldId];
        const retryFunction = fieldData?.retryFunction;
        retryFunction && retryFunction();
    };
const $99f6e2cbf5817dbf$export$42fd5e650971333b = ()=>async ({ getState: getState })=>{
        const currentState = getState();
        Object.keys(currentState).forEach((fieldId)=>{
            if (currentState[fieldId]?.status === (0, $e456ec6df0e2a730$export$32bbcfb76243a487)) {
                const formRef = currentState[fieldId]?.formRef;
                (0, $iEhdM.dispatchFormSubmitAndBlurElements)(formRef);
            }
        });
    };

});
const $e456ec6df0e2a730$export$32bbcfb76243a487 = 'FOCUSED';
const $e456ec6df0e2a730$export$f81c1d6b9217380c = 'PENDING';
const $e456ec6df0e2a730$export$2ace7d3737836262 = 'RESOLVED';
const $e456ec6df0e2a730$export$9956c6a700e724c4 = 'STORED';
const $e456ec6df0e2a730$export$742c877aeb0f3dbd = 'FAILED';
const $e456ec6df0e2a730$export$bbf78c43fa5268c8 = 'IDLE';
const $e456ec6df0e2a730$export$ae7c16bdba5e2e15 = 10000;
const $e456ec6df0e2a730$export$30daef8830f2505d = 'WAIT';
const $e456ec6df0e2a730$export$f86e250f1a7b07c8 = 'PROCEED';
const $e456ec6df0e2a730$export$e784a07a62e2e0e5 = 'TIMEOUT';

parcelRegister("iEhdM", function(module, exports) {

$parcel$export(module.exports, "submitForgeFormField", () => $2e80a23b0db03f29$export$7e50fee868362aa2);
$parcel$export(module.exports, "dispatchFormSubmitAndBlurElements", () => $2e80a23b0db03f29$export$4d639a8e0790daf2);
$parcel$export(module.exports, "isBlurEventTriggeredOutsideTheFieldOld", () => $2e80a23b0db03f29$export$ca014e65e824dc57);
$parcel$export(module.exports, "isBlurEventTriggeredOutsideTheFieldNew", () => $2e80a23b0db03f29$export$9f61fe5b553b8202);

const $2e80a23b0db03f29$export$7e50fee868362aa2 = (formRef)=>{
    formRef?.current?.requestSubmit();
};
const $2e80a23b0db03f29$export$4d639a8e0790daf2 = (formRef)=>{
    $2e80a23b0db03f29$export$7e50fee868362aa2(formRef);
    if (formRef?.current?.elements) Array.from(formRef.current.elements).forEach((element)=>{
        if ('blur' in element && typeof element.blur === 'function') element?.blur();
    });
};
const $2e80a23b0db03f29$export$ca014e65e824dc57 = (fieldState, event)=>fieldState?.status === (0, $e456ec6df0e2a730$export$32bbcfb76243a487) && event.relatedTarget != null && !(event.relatedTarget instanceof Window) && !event.currentTarget.contains(event.relatedTarget);
const $2e80a23b0db03f29$export$9f61fe5b553b8202 = (fieldState, event, divRef)=>fieldState?.status === (0, $e456ec6df0e2a730$export$32bbcfb76243a487) && !divRef.current?.contains(event.relatedTarget);

});




parcelRegister("3G9wl", function(module, exports) {

$parcel$export(module.exports, "useUIModificationsConsentStatus", () => $381349a6fe3e5ee3$export$e2c526d2c1843a0e);
$parcel$export(module.exports, "useUIModificationsConsentStatusForApp", () => $381349a6fe3e5ee3$export$7700bb22109a011e);
$parcel$export(module.exports, "useUIModificationsConsentStatusForApps", () => $381349a6fe3e5ee3$export$2a5a8f1570c161c6);

var $bj4JM = parcelRequire("bj4JM");
var $ggKAj = parcelRequire("ggKAj");

var $1ybV0 = parcelRequire("1ybV0");

var $8LJqN = parcelRequire("8LJqN");

var $ig7wC = parcelRequire("ig7wC");

const $381349a6fe3e5ee3$var$selectOverallConsentStatus = (0, $bj4JM.createSelector)((state)=>state.uiModificationsConsentStatus, (consentMap)=>Object.values(consentMap).includes((0, $e4bc45ef063f6e5f$export$d67d63332ce3ce38)) ? (0, $e4bc45ef063f6e5f$export$d67d63332ce3ce38) : (0, $e4bc45ef063f6e5f$export$45ca911896c5084f));
const $381349a6fe3e5ee3$var$selectConsentStatusDeprecated = (state)=>state.uiModificationsConsentStatusDeprecated;
const $381349a6fe3e5ee3$var$selectUIMConsentStatus = (0, $8LJqN.functionWithCondition)(()=>(0, $1ybV0.ff)('ui-modifications-multi-app-experience_ud4yw'), $381349a6fe3e5ee3$var$selectOverallConsentStatus, $381349a6fe3e5ee3$var$selectConsentStatusDeprecated);
const $381349a6fe3e5ee3$export$e2c526d2c1843a0e = (0, $ggKAj.createStateHook)((0, $ig7wC.store), {
    selector: $381349a6fe3e5ee3$var$selectUIMConsentStatus
});
const $381349a6fe3e5ee3$export$7700bb22109a011e = (0, $ggKAj.createStateHook)((0, $ig7wC.store), {
    selector: (state, { appId: appId })=>state.uiModificationsConsentStatus[appId] || (0, $e4bc45ef063f6e5f$export$39d15f3568f5a72c)
});
const $381349a6fe3e5ee3$export$2a5a8f1570c161c6 = (0, $ggKAj.createStateHook)((0, $ig7wC.store), {
    selector: (state)=>state.uiModificationsConsentStatus
});

});
parcelRegister("ig7wC", function(module, exports) {

$parcel$export(module.exports, "store", () => $1aa7dabd47e15b99$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustmentsEnabled", () => $1aa7dabd47e15b99$export$358ad850b2f6d6fe);
$parcel$export(module.exports, "useAdjustmentsContextActions", () => $1aa7dabd47e15b99$export$4f2729981f4b81d2);
$parcel$export(module.exports, "UiModificationContextContainer", () => $1aa7dabd47e15b99$export$5eb9c167b683d125);

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");

const $1aa7dabd47e15b99$var$initialState = {
    shouldUiModificationsLoad: 'unknown',
    hasFinishedLoading: false,
    adjustmentsAreEnabled: false,
    uiModificationsConsentStatusDeprecated: (0, $e4bc45ef063f6e5f$export$39d15f3568f5a72c),
    uiModificationsConsentStatus: {}
};
const $1aa7dabd47e15b99$export$e324594224ef24da = {
    resetAdjustmentContext: ()=>({ setState: setState })=>{
            setState($1aa7dabd47e15b99$var$initialState);
        },
    setShouldUiModificationsLoad: (status)=>({ setState: setState })=>{
            setState({
                shouldUiModificationsLoad: status
            });
        },
    setHasFinishedLoading: (hasFinishedLoading)=>({ setState: setState })=>{
            setState({
                hasFinishedLoading: hasFinishedLoading
            });
        },
    setAdjustmentsAreEnabled: (enabled)=>({ setState: setState })=>{
            setState({
                adjustmentsAreEnabled: enabled
            });
        },
    setUIModificationsConsentStatusDeprecated: (enabled)=>({ setState: setState })=>{
            setState({
                uiModificationsConsentStatusDeprecated: enabled
            });
        },
    setUIModificationsConsentStatus: ({ appId: appId, status: status })=>({ setState: setState, getState: getState })=>{
            const currentConsentState = getState().uiModificationsConsentStatus;
            setState({
                uiModificationsConsentStatus: {
                    ...currentConsentState,
                    [appId]: status
                }
            });
        }
};
const $1aa7dabd47e15b99$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'issue-adjustments-context',
    initialState: $1aa7dabd47e15b99$var$initialState,
    actions: $1aa7dabd47e15b99$export$e324594224ef24da
});
const $1aa7dabd47e15b99$export$a12f82a132dee079 = (0, $ggKAj.createHook)($1aa7dabd47e15b99$export$6f57813fe9f31bf9);
const $1aa7dabd47e15b99$export$358ad850b2f6d6fe = (0, $ggKAj.createStateHook)($1aa7dabd47e15b99$export$6f57813fe9f31bf9, {
    selector: (state)=>state.adjustmentsAreEnabled
});
const $1aa7dabd47e15b99$export$4f2729981f4b81d2 = (0, $ggKAj.createActionsHook)($1aa7dabd47e15b99$export$6f57813fe9f31bf9);
const $1aa7dabd47e15b99$export$5eb9c167b683d125 = (0, $heB5U.createContainer)($1aa7dabd47e15b99$export$6f57813fe9f31bf9, {
    displayName: 'UiModificationContextContainer'
});

});
const $e4bc45ef063f6e5f$export$39d15f3568f5a72c = 'unknown';
const $e4bc45ef063f6e5f$export$d67d63332ce3ce38 = 'required';
const $e4bc45ef063f6e5f$export$45ca911896c5084f = 'consented';



parcelRegister("hMjV9", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a23c818b8860360$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $8a23c818b8860360$var$FindFieldModal = (0, $7rh0R.lazy)(()=>(parcelRequire("1ToDD")), {
    ssr: false,
    moduleId: "./src/packages/issue-create/find-field/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8a23c818b8860360$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "AsyncFindFieldModal",
        packageName: "jiraIssueConfigFindField",
        fallback: "flag",
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "config-find-field-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8a23c818b8860360$var$FindFieldModal, props)));

});
parcelRegister("1ToDD", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('h2MrD'),
            load('bYT2S'),
            load('7rPBH')
        ]);
        const value = parcelRequire('c36go');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("h2MrD"),
        load("bYT2S"),
        load("7rPBH")
    ]).then(()=>parcelRequire('c36go'));
}

});


// error types
const $8b8bfa076f313cc4$export$6c8cb487d6ffc522 = 'QueryError';
const $8b8bfa076f313cc4$export$b171488d52070cb3 = 'JiraIssueFieldUnsupportedErrorExtension';
const $8b8bfa076f313cc4$export$14b50ab9fbf2d370 = 'JiraIssueFieldValueValidationErrorExtension';
const $8b8bfa076f313cc4$export$3d1cda9bd50505e8 = 'SERVICE_REQUEST';
const $8b8bfa076f313cc4$export$48c144830383423 = 'INCIDENT_MANAGEMENT';
const $8b8bfa076f313cc4$export$1ea6ead7bcee4494 = 'PROBLEM_MANAGEMENT';
const $8b8bfa076f313cc4$export$b92ccb6dc3cdb548 = 'CHANGE_MANAGEMENT';
const $8b8bfa076f313cc4$export$a4a741b969f6509c = 'POST_INCIDENT_REVIEW';
const $8b8bfa076f313cc4$export$81e62964cc725098 = 'DEVELOPER_ESCALATION';
const $8b8bfa076f313cc4$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $8b8bfa076f313cc4$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $8b8bfa076f313cc4$export$c835df30ebbd529d = 'UNASSIGNED_REQUEST_TYPE';

parcelRegister("4r5oC", function(module, exports) {

$parcel$export(module.exports, "transformProjectType", () => $260e90a2e541fdbe$export$bd65219b3dd7789d);

var $7ZZxN = parcelRequire("7ZZxN");
const $260e90a2e541fdbe$export$bd65219b3dd7789d = (projectType)=>{
    if (!projectType) return 'none';
    if (projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT)) return 'serviceManagement';
    if (projectType === (0, $7ZZxN.CORE_PROJECT)) return 'workManagement';
    return projectType;
};

});

parcelRegister("gys0Y", function(module, exports) {

$parcel$export(module.exports, "useClassificationState", () => $fa176a2e4dc35c75$export$4404b0743b8ee564);
$parcel$export(module.exports, "useClassificationFieldProps", () => $fa176a2e4dc35c75$export$e2bccade312f8);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jzSBT = parcelRequire("jzSBT");

var $dNWQB = parcelRequire("dNWQB");
var $2gOs4 = parcelRequire("2gOs4");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $2KWIB = parcelRequire("2KWIB");
const $fa176a2e4dc35c75$export$4404b0743b8ee564 = (classificationOption)=>{
    const [selectedClassification, setSelectedClassification] = (0, $eUqFw.useState)(classificationOption);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { publish: publish } = (0, $2gOs4.useGICLifeCycleEvents)();
    const onClassificationOptionChange = (0, $eUqFw.useCallback)((option)=>{
        setSelectedClassification(option);
        const analyticsEvent = createAnalyticsEvent({});
        (0, $jMP2a.fireTrackAnalyticsDeferred)(analyticsEvent, 'ClassificationInGIC changed');
        publish((0, $dNWQB.GIC_LIFECYCLE_EVENTS).CLASSIFICATION_LEVEL_FIELD_CHANGE, {
            selectedClassification: option
        });
    }, [
        createAnalyticsEvent,
        publish
    ]);
    return [
        selectedClassification,
        setSelectedClassification,
        onClassificationOptionChange
    ];
};
const $fa176a2e4dc35c75$export$e2a389820b14b290 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return (0, $eUqFw.useCallback)((value)=>{
        if (!value) {
            const noClassificationOption = {
                id: undefined,
                definition: formatMessage((0, $2KWIB.default).noClassificationOption),
                color: 'NONE',
                includeIcon: false
            };
            return noClassificationOption;
        }
        return (0, $jzSBT.getProjectDefaultClassificationOption)(formatMessage((0, $2KWIB.default).projectDefaultClassificationOption), value);
    }, [
        formatMessage
    ]);
};
const $fa176a2e4dc35c75$export$cdada88ebf1ccd9 = (classificationFieldConfig)=>{
    const allowedClassifications = classificationFieldConfig?.allowedValues?.map((value)=>$fa176a2e4dc35c75$export$a30f3e09b4b8e281(value.node));
    return allowedClassifications;
};
const $fa176a2e4dc35c75$export$a30f3e09b4b8e281 = (defaultValue)=>{
    const defaultClassification = defaultValue ? {
        id: defaultValue?.id,
        name: defaultValue?.name,
        definition: (0, $1ybV0.ff)('dlp-field-selected-value-and-definition-changes_4jiut') ? defaultValue?.definition : defaultValue?.guidelines,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        color: defaultValue?.color?.colorKey
    } : undefined;
    return defaultClassification;
};
const $fa176a2e4dc35c75$export$e2bccade312f8 = (classificationFieldConfig)=>{
    const getCreateClassificationLevel = $fa176a2e4dc35c75$export$e2a389820b14b290();
    return (0, $eUqFw.useMemo)(()=>{
        let classificationFieldProps = {
            availableClassifications: undefined,
            initialClassification: undefined,
            isDisabled: false,
            nonEditableMessage: undefined
        };
        if ((0, $1ybV0.ff)('support-data-classification-field-in-gic_x6lda')) {
            const allowedClassifications = $fa176a2e4dc35c75$export$cdada88ebf1ccd9(classificationFieldConfig);
            const initialDefaultClassification = $fa176a2e4dc35c75$export$a30f3e09b4b8e281(classificationFieldConfig?.defaultValue?.[0]);
            const projectDefaultClassification = $fa176a2e4dc35c75$export$a30f3e09b4b8e281(classificationFieldConfig?.defaultValue?.[1]);
            const projectLevelClassification = getCreateClassificationLevel(projectDefaultClassification);
            const isFieldEditable = classificationFieldConfig?.isEditable;
            if (allowedClassifications) classificationFieldProps = {
                availableClassifications: allowedClassifications.concat(projectLevelClassification),
                initialClassification: initialDefaultClassification || projectLevelClassification,
                isDisabled: isFieldEditable === false,
                nonEditableMessage: classificationFieldConfig?.nonEditableReason
            };
        }
        return classificationFieldProps;
    }, [
        classificationFieldConfig,
        getCreateClassificationLevel
    ]);
};

});
parcelRegister("jzSBT", function(module, exports) {

$parcel$export(module.exports, "getProjectDefaultClassificationOption", () => $9e09f90100171cc0$export$1f0ddb93897fde19);
/* utils.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $2hZCh = parcelRequire("2hZCh");
const $9e09f90100171cc0$export$d890d332bbf5844a = (classifications)=>classifications ? {
        edges: classifications.map((classification)=>({
                node: {
                    id: classification.id,
                    name: classification.name,
                    definition: classification.definition,
                    guidelines: classification.guideline,
                    color: {
                        colorKey: classification.color
                    }
                }
            }))
    } : classifications;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9e09f90100171cc0$var$OverflowWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});
const $9e09f90100171cc0$var$ProjectDefaultTextWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _154i1i6y",
            __cmplp.className
        ])
    });
});
const $9e09f90100171cc0$export$1f0ddb93897fde19 = (message, defaultClassificationLevel)=>{
    const color = typeof defaultClassificationLevel?.color === 'string' ? defaultClassificationLevel?.color : defaultClassificationLevel?.color?.colorKey;
    return {
        id: undefined,
        nameFormatter: (classification)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9e09f90100171cc0$var$OverflowWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9e09f90100171cc0$var$ProjectDefaultTextWrapper, null, message, " - "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2hZCh.ClassificationLozenge), {
                ...classification,
                name: defaultClassificationLevel?.name || ''
            })),
        // The below lint error is because Color type expects string, whereas the graphQL type expects { colorKey: string }. This has been handled in variable definition for color.
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        color: color || 'NONE',
        definition: ''
    };
};

});
parcelRegister("2hZCh", function(module, exports) {

$parcel$export(module.exports, "ClassificationLozenge", () => $1aacf709cd0cb4e3$export$f31d135f91971ac4);
$parcel$export(module.exports, "DataClassificationDropdown", () => $1aacf709cd0cb4e3$export$37a6278f2f470b5e);

var $eUqFw = parcelRequire("eUqFw");

var $kd0cS = parcelRequire("kd0cS");

var $hTLlD = parcelRequire("hTLlD");

var $96IgR = parcelRequire("96IgR");

var $3yyVA = parcelRequire("3yyVA");
var $b13WO = parcelRequire("b13WO");
var $claMu = parcelRequire("claMu");
var $8ceJs = parcelRequire("8ceJs");

var $jQxSL = parcelRequire("jQxSL");
var $5wCDk = parcelRequire("5wCDk");

var $4q38b = parcelRequire("4q38b");

var $8cU5f = parcelRequire("8cU5f");

var $aeMpE = parcelRequire("aeMpE");

var $gi16t = parcelRequire("gi16t");

var $26qwu = parcelRequire("26qwu");
/**
 * The options in the select dropdown are quite customizable, and achieves different use-cases.
 * Options are identified (i.e. how an option in the dropdown is selected) by the "name", "label", and "definition" properties.
 * Typeof "option" prop is "ClassificationOption", which has requires at least one of the properties to exist, therefore it is safe to assume that an option will always be identifiable.
 * Obviously there can be duplicates, but that is a user error.
 *
 * Since only one of these identifying properties is required, there are 7 different combinations of these properties that will render a different option.
 *
 * (1) name
 *    - renders: name with icon (if includeIcon is true) in the icon container
 * (2) name, label
 *    - renders: name with icon (if includeIcon is true) in the icon container, and an inline label outside of the icon container
 * (3) name, definition
 *    - renders: name with icon (if includeIcon is true) in the icon container, and a definition below the icon container
 * (4) name, label, definition
 *    - renders: name with icon (if includeIcon is true) in the icon container, an inline label outside of the icon container, and a definition below the icon container
 * (5) label
 *    - renders: icon container with only an icon, and an inline label outside of the icon container
 *    - note: if includeIcon is false, then the icon container will not render (i.e. only an inline label will render)
 * (6) label, definition
 *    - renders: similar to (5) but with a definition below the icon container
 * (7) definition
 *    - renders: icon container with only an icon (conditionally rendered based on includeIcon), and a definition below the icon container
 *
 * Use cases:
 *    For space/project defaults we don't want to render a name.
 *    Instead we want to render a label: "Use space/project default".
 *    We also want to render a definition defining what the space/project default is.
 *    In this case, we'll use (6).
 *
 *    For resetting a classification (i.e. selecting the "No classification" option), we don't want to render a name or label.
 *    Instead we want to render only a definition and without an icon.
 *    In this case, we'll use (7) and pass in includeIcon={false}.
 */ const $1aacf709cd0cb4e3$var$dangerTextStyles = (0, $8ceJs.xcss)({
    color: 'color.text.danger'
});
const $1aacf709cd0cb4e3$var$CustomSingleValue = ({ children: children, ...props })=>{
    var _ref, _ref2, _classificationOverri;
    const { colorMode: colorMode = 'light' } = (0, $4q38b.default)();
    const { data: data } = props;
    const { name: name, nameLabel: nameLabel, definition: definition, color: color = 'NONE', includeIcon: includeIcon = true, classificationOverride: classificationOverride, nameFormatter: nameFormatter } = data || {};
    const inputName = (_ref = (_ref2 = (_classificationOverri = classificationOverride === null || classificationOverride === void 0 ? void 0 : classificationOverride.name) !== null && _classificationOverri !== void 0 ? _classificationOverri : name) !== null && _ref2 !== void 0 ? _ref2 : nameLabel) !== null && _ref !== void 0 ? _ref : definition;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).SingleValue, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $26qwu.ContainerLabel), null, nameFormatter ? nameFormatter(data) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $26qwu.ContainerIcon), {
        colorsConfig: (0, $aeMpE.colorsConfig)[colorMode][color],
        isIconOnly: includeIcon && !inputName
    }, includeIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gi16t.ClassificationIcon), {
        width: 14,
        height: 14,
        isDisabled: false,
        color: (0, $aeMpE.colorsConfig)[colorMode][color].fontColor,
        disabledColorConfig: (0, $aeMpE.disabledColorConfig)[colorMode]
    }), inputName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $26qwu.Name), null, inputName))));
};
/**
 * CustomOption component is used to render each option in the dropdown.
 **/ const $1aacf709cd0cb4e3$var$CustomOption = (props)=>{
    const { data: data } = props;
    const { name: name, definition: definition, nameLabel: nameLabel, includeIcon: includeIcon = true, nameFormatter: nameFormatter } = data || {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b13WO.default), {
        space: "space.050"
    }, (name || nameLabel || includeIcon) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $26qwu.ContainerLabel), {
        definitionExists: Boolean(definition)
    }, nameFormatter ? nameFormatter(data) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1aacf709cd0cb4e3$export$f31d135f91971ac4, data), nameLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $26qwu.NameLabel), null, nameLabel)), definition && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $26qwu.Definition), null, definition)));
};
const $1aacf709cd0cb4e3$export$f31d135f91971ac4 = (data)=>{
    const { colorMode: colorMode = 'light' } = (0, $4q38b.default)();
    const { name: name, nameLabel: nameLabel, includeIcon: includeIcon = true, color: color = 'NONE' } = data || {};
    // if name and label are both present, trim name to fit nameLabel in the same row
    const shouldTrimBothNameAndLabel = Boolean(name && nameLabel);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $26qwu.ContainerIcon), {
        colorsConfig: (0, $aeMpE.colorsConfig)[colorMode][color],
        isIconOnly: includeIcon && !name
    }, includeIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gi16t.ClassificationIcon), {
        width: 14,
        height: 14,
        isDisabled: false,
        color: (0, $aeMpE.colorsConfig)[colorMode][color].fontColor,
        disabledColorConfig: (0, $aeMpE.disabledColorConfig)[colorMode]
    }), name && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $26qwu.Name), null, name.substring(0, (0, $aeMpE.nameMaxLength) / (shouldTrimBothNameAndLabel ? 2 : 1))));
};
const $1aacf709cd0cb4e3$export$37a6278f2f470b5e = ({ label: label, options: options, value: value, errorMessage: errorMessage, disabledTooltipMessage: disabledTooltipMessage, isDisabled: isDisabled, onChange: onChange, onInputChange: onInputChange })=>{
    // find selected classification in options
    const onSelectChange = (option)=>{
        // we want to identify the selected option by these properties
        const selectedOption = {
            name: option === null || option === void 0 ? void 0 : option.name,
            definition: option === null || option === void 0 ? void 0 : option.definition,
            label: option === null || option === void 0 ? void 0 : option.nameLabel
        };
        // find corresponding classification in options based on identifying properties
        const selectedClassification = options.find((opt)=>(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))({
                name: opt.name,
                definition: opt.definition,
                label: opt.label
            }, selectedOption));
        if (!selectedOption || !selectedClassification) return;
        if (onChange) onChange(selectedClassification);
    };
    /*
    Since select component requires label & value props in list of options, we'll transform "options" prop to include these values.
  */ const transformToOptionType = (0, $eUqFw.useCallback)((classification)=>{
        var _ref3, _classification$name, _ref4, _ref5;
        return {
            ...(0, (/*@__PURE__*/$parcel$interopDefault($kd0cS)))(classification),
            // either name, label, or definition must exist, so we can safely use ! here
            label: (_ref3 = (_classification$name = classification.name) !== null && _classification$name !== void 0 ? _classification$name : classification.label) !== null && _ref3 !== void 0 ? _ref3 : classification.definition,
            // Asserting this as a string to keep lint happy. This wont be an issue, since CustomOption component will handle scenarios where name is a ReactNode.
            value: (_ref4 = (_ref5 = classification.name) !== null && _ref5 !== void 0 ? _ref5 : classification.label) !== null && _ref4 !== void 0 ? _ref4 : classification.definition,
            nameLabel: classification.label // since label is reserved for an option, we'll use nameLabel
        };
    }, []);
    const transformedOptions = (0, $eUqFw.useMemo)(()=>options.map(transformToOptionType), [
        options,
        transformToOptionType
    ]);
    const renderDropdown = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
            "aria-label": "data-classification-select",
            inputId: "data-classification-dropdown-input",
            options: transformedOptions,
            value: !value || errorMessage ? null : transformToOptionType(value),
            onChange: onSelectChange,
            onInputChange: onInputChange,
            isInvalid: Boolean(errorMessage),
            isDisabled: isDisabled,
            components: {
                Option: $1aacf709cd0cb4e3$var$CustomOption,
                SingleValue: $1aacf709cd0cb4e3$var$CustomSingleValue
            },
            styles: {
                option: (baseStyles)=>({
                        ...baseStyles,
                        padding: "var(--ds-space-200, 16px)"
                    }),
                menuPortal: (base)=>({
                        ...base,
                        zIndex: 9999
                    })
            },
            menuPortalTarget: document.body
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b13WO.default), {
        space: "space.100"
    }, label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $26qwu.DropdownLabel), {
        htmlFor: "data-classification-dropdown-input"
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b13WO.default), {
        space: "space.050"
    }, isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: disabledTooltipMessage
    }, renderDropdown()) : renderDropdown(), errorMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3yyVA.default), {
        alignItems: "center",
        gap: "space.025",
        xcss: $1aacf709cd0cb4e3$var$dangerTextStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        size: "small",
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $claMu.default), {
        as: "p",
        size: "small",
        color: "inherit"
    }, errorMessage))));
};

});
parcelRegister("3yyVA", function(module, exports) {

$parcel$export(module.exports, "default", () => $296fa405a14bfba6$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $snE9y = parcelRequire("snE9y");

var $8ceJs = parcelRequire("8ceJs");
const $296fa405a14bfba6$var$justifyContentMap = {
    start: (0, $byn9U.css)({
        justifyContent: 'start'
    }),
    center: (0, $byn9U.css)({
        justifyContent: 'center'
    }),
    end: (0, $byn9U.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $byn9U.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $byn9U.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $byn9U.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $byn9U.css)({
        justifyContent: 'stretch'
    })
};
const $296fa405a14bfba6$var$flexDirectionMap = {
    column: (0, $byn9U.css)({
        flexDirection: 'column'
    }),
    row: (0, $byn9U.css)({
        flexDirection: 'row'
    })
};
const $296fa405a14bfba6$var$flexWrapMap = {
    wrap: (0, $byn9U.css)({
        flexWrap: 'wrap'
    }),
    nowrap: (0, $byn9U.css)({
        flexWrap: 'nowrap'
    })
};
const $296fa405a14bfba6$var$alignItemsMap = {
    start: (0, $byn9U.css)({
        alignItems: 'start'
    }),
    center: (0, $byn9U.css)({
        alignItems: 'center'
    }),
    baseline: (0, $byn9U.css)({
        alignItems: 'baseline'
    }),
    end: (0, $byn9U.css)({
        alignItems: 'end'
    }),
    stretch: (0, $byn9U.css)({
        alignItems: 'stretch'
    })
};
const $296fa405a14bfba6$var$baseStyles = (0, $byn9U.css)({
    display: 'flex',
    boxSizing: 'border-box'
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ const $296fa405a14bfba6$var$Flex = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss }, ref)=>{
    const resolvedStyles = (0, $8ceJs.parseXcss)(xcss);
    return (0, $byn9U.jsx)(Component, {
        role: role,
        className: resolvedStyles.static,
        css: [
            $296fa405a14bfba6$var$baseStyles,
            gap && (0, $snE9y.spaceStylesMap).gap[gap],
            columnGap && (0, $snE9y.spaceStylesMap).columnGap[columnGap],
            rowGap && (0, $snE9y.spaceStylesMap).rowGap[rowGap],
            alignItems && $296fa405a14bfba6$var$alignItemsMap[alignItems],
            direction && $296fa405a14bfba6$var$flexDirectionMap[direction],
            justifyContent && $296fa405a14bfba6$var$justifyContentMap[justifyContent],
            wrap && $296fa405a14bfba6$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$296fa405a14bfba6$var$Flex.displayName = 'Flex';
var $296fa405a14bfba6$export$2e2bcd8739ae039 = $296fa405a14bfba6$var$Flex;

});
parcelRegister("snE9y", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", () => $0554f55e17625548$export$6ccdbebca2ee545f);
$parcel$export(module.exports, "positiveSpaceMap", () => $0554f55e17625548$export$958d0ae7f2977ae4);
$parcel$export(module.exports, "allSpaceMap", () => $0554f55e17625548$export$632685d741f3dbbf);
$parcel$export(module.exports, "inverseColorMap", () => $0554f55e17625548$export$2185ce37f9bdd963);
$parcel$export(module.exports, "opacityMap", () => $0554f55e17625548$export$daf94a976c798b4f);
$parcel$export(module.exports, "shadowMap", () => $0554f55e17625548$export$7aff6e7ba39bb774);
$parcel$export(module.exports, "borderColorMap", () => $0554f55e17625548$export$1531ad5bb3fbedac);
$parcel$export(module.exports, "backgroundColorMap", () => $0554f55e17625548$export$d1d79bf68ac056bd);
$parcel$export(module.exports, "textColorMap", () => $0554f55e17625548$export$8473307aa00d6ea1);
$parcel$export(module.exports, "layerMap", () => $0554f55e17625548$export$b5f31a7e431d2eab);
$parcel$export(module.exports, "borderWidthMap", () => $0554f55e17625548$export$e1b83c5210c471b8);
$parcel$export(module.exports, "borderRadiusMap", () => $0554f55e17625548$export$3c0a6c3e64bb180d);
$parcel$export(module.exports, "paddingStylesMap", () => $0554f55e17625548$export$e615f061ca585a6c);
$parcel$export(module.exports, "spaceStylesMap", () => $0554f55e17625548$export$bf46c3f9eeafc71f);
$parcel$export(module.exports, "backgroundColorStylesMap", () => $0554f55e17625548$export$e7af83bafe7f9e63);
$parcel$export(module.exports, "textColorStylesMap", () => $0554f55e17625548$export$3a1bcba60b23d7f0);
$parcel$export(module.exports, "fontWeightStylesMap", () => $0554f55e17625548$export$45f3f4fe16f9f7d5);
$parcel$export(module.exports, "fontStylesMap", () => $0554f55e17625548$export$128f10c238242f83);
$parcel$export(module.exports, "surfaceColorStylesMap", () => $0554f55e17625548$export$ff257d957d48c421);
$parcel$export(module.exports, "isSurfaceColorToken", () => $0554f55e17625548$export$5e65a44e5b6ecadb);

var $byn9U = parcelRequire("byn9U");

var $kyri3 = parcelRequire("kyri3");
const $0554f55e17625548$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
const $0554f55e17625548$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
const $0554f55e17625548$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
const $0554f55e17625548$export$632685d741f3dbbf = {
    ...$0554f55e17625548$export$958d0ae7f2977ae4,
    ...$0554f55e17625548$export$d2dc61f58390201c
};
const $0554f55e17625548$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
const $0554f55e17625548$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
const $0554f55e17625548$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
const $0554f55e17625548$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
const $0554f55e17625548$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
const $0554f55e17625548$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
const $0554f55e17625548$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
const $0554f55e17625548$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
const $0554f55e17625548$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
const $0554f55e17625548$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.0': "var(--ds-border-width-0, 0px)",
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
const $0554f55e17625548$export$3c0a6c3e64bb180d = {
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    'border.radius': "var(--ds-border-radius, 3px)",
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};
const $0554f55e17625548$export$6cc560b4dedf3816 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
const $0554f55e17625548$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
const $0554f55e17625548$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
const $0554f55e17625548$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
const $0554f55e17625548$var$getSerializedStylesMap = (cssProperty, tokenMap)=>{
    return Object.keys(tokenMap).reduce((emotionSpacingMap, token)=>{
        emotionSpacingMap[token] = (0, $byn9U.css)({
            [cssProperty]: tokenMap[token]
        });
        return emotionSpacingMap;
    }, {});
};
const $0554f55e17625548$export$e615f061ca585a6c = $0554f55e17625548$var$spacingProperties.reduce((styleMap, spacingProperty)=>{
    styleMap[spacingProperty] = $0554f55e17625548$var$getSerializedStylesMap(spacingProperty, $0554f55e17625548$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
const $0554f55e17625548$export$bf46c3f9eeafc71f = $0554f55e17625548$var$spacingProperties.reduce((styleMap, spacingProperty)=>{
    styleMap[spacingProperty] = $0554f55e17625548$var$getSerializedStylesMap(spacingProperty, $0554f55e17625548$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
const $0554f55e17625548$export$e7af83bafe7f9e63 = $0554f55e17625548$var$getSerializedStylesMap('backgroundColor', $0554f55e17625548$export$d1d79bf68ac056bd);
const $0554f55e17625548$export$3a1bcba60b23d7f0 = $0554f55e17625548$var$getSerializedStylesMap('color', $0554f55e17625548$export$8473307aa00d6ea1);
const $0554f55e17625548$export$45f3f4fe16f9f7d5 = $0554f55e17625548$var$getSerializedStylesMap('fontWeight', $0554f55e17625548$export$303e322c6b1ed114);
const $0554f55e17625548$export$68cc305da27dbaa4 = $0554f55e17625548$var$getSerializedStylesMap('fontFamily', $0554f55e17625548$export$3c7e9587132614b4);
const $0554f55e17625548$export$128f10c238242f83 = $0554f55e17625548$var$getSerializedStylesMap('font', $0554f55e17625548$export$6cc560b4dedf3816);
const $0554f55e17625548$export$ff257d957d48c421 = $0554f55e17625548$var$getSerializedStylesMap((0, $kyri3.CURRENT_SURFACE_CSS_VAR), $0554f55e17625548$export$41a358c9c2356760);
const $0554f55e17625548$export$5e65a44e5b6ecadb = (color)=>$0554f55e17625548$export$41a358c9c2356760[color] !== undefined;

});

parcelRegister("8ceJs", function(module, exports) {

$parcel$export(module.exports, "parseXcss", () => $5f7adf3e4e3521d6$export$a9c84988c8f81f2d);
$parcel$export(module.exports, "xcss", () => $5f7adf3e4e3521d6$export$f6c783d06584602c);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $byn9U = parcelRequire("byn9U");

var $snE9y = parcelRequire("snE9y");

var $2fFJv = parcelRequire("2fFJv");
const $5f7adf3e4e3521d6$export$9a199fbafee0014e = {
    backgroundColor: (0, $snE9y.backgroundColorMap),
    blockSize: (0, $snE9y.dimensionMap),
    borderBlockColor: (0, $snE9y.borderColorMap),
    borderBlockEndColor: (0, $snE9y.borderColorMap),
    borderBlockEndWidth: (0, $snE9y.borderWidthMap),
    borderBlockStartColor: (0, $snE9y.borderColorMap),
    borderBlockStartWidth: (0, $snE9y.borderWidthMap),
    borderBlockWidth: (0, $snE9y.borderWidthMap),
    borderBottomColor: (0, $snE9y.borderColorMap),
    borderBottomLeftRadius: (0, $snE9y.borderRadiusMap),
    borderBottomRightRadius: (0, $snE9y.borderRadiusMap),
    borderBottomWidth: (0, $snE9y.borderWidthMap),
    borderColor: (0, $snE9y.borderColorMap),
    borderEndEndRadius: (0, $snE9y.borderRadiusMap),
    borderEndStartRadius: (0, $snE9y.borderRadiusMap),
    borderInlineColor: (0, $snE9y.borderColorMap),
    borderInlineEndColor: (0, $snE9y.borderColorMap),
    borderInlineEndWidth: (0, $snE9y.borderWidthMap),
    borderInlineStartColor: (0, $snE9y.borderColorMap),
    borderInlineStartWidth: (0, $snE9y.borderWidthMap),
    borderInlineWidth: (0, $snE9y.borderWidthMap),
    borderLeftColor: (0, $snE9y.borderColorMap),
    borderLeftWidth: (0, $snE9y.borderWidthMap),
    borderRadius: (0, $snE9y.borderRadiusMap),
    borderRightColor: (0, $snE9y.borderColorMap),
    borderRightWidth: (0, $snE9y.borderWidthMap),
    borderStartEndRadius: (0, $snE9y.borderRadiusMap),
    borderStartStartRadius: (0, $snE9y.borderRadiusMap),
    borderTopColor: (0, $snE9y.borderColorMap),
    borderTopLeftRadius: (0, $snE9y.borderRadiusMap),
    borderTopRightRadius: (0, $snE9y.borderRadiusMap),
    borderTopWidth: (0, $snE9y.borderWidthMap),
    borderWidth: (0, $snE9y.borderWidthMap),
    bottom: (0, $snE9y.allSpaceMap),
    boxShadow: (0, $snE9y.shadowMap),
    color: (0, $snE9y.textColorMap),
    columnGap: (0, $snE9y.positiveSpaceMap),
    gap: (0, $snE9y.positiveSpaceMap),
    height: (0, $snE9y.dimensionMap),
    inlineSize: (0, $snE9y.dimensionMap),
    inset: (0, $snE9y.allSpaceMap),
    insetBlock: (0, $snE9y.allSpaceMap),
    insetBlockEnd: (0, $snE9y.allSpaceMap),
    insetBlockStart: (0, $snE9y.allSpaceMap),
    insetInline: (0, $snE9y.allSpaceMap),
    insetInlineEnd: (0, $snE9y.allSpaceMap),
    insetInlineStart: (0, $snE9y.allSpaceMap),
    left: (0, $snE9y.allSpaceMap),
    margin: (0, $snE9y.allSpaceMap),
    marginBlock: (0, $snE9y.allSpaceMap),
    marginBlockEnd: (0, $snE9y.allSpaceMap),
    marginBlockStart: (0, $snE9y.allSpaceMap),
    marginBottom: (0, $snE9y.allSpaceMap),
    marginInline: (0, $snE9y.allSpaceMap),
    marginInlineEnd: (0, $snE9y.allSpaceMap),
    marginInlineStart: (0, $snE9y.allSpaceMap),
    marginLeft: (0, $snE9y.allSpaceMap),
    marginRight: (0, $snE9y.allSpaceMap),
    marginTop: (0, $snE9y.allSpaceMap),
    maxBlockSize: (0, $snE9y.dimensionMap),
    maxHeight: (0, $snE9y.dimensionMap),
    maxInlineSize: (0, $snE9y.dimensionMap),
    maxWidth: (0, $snE9y.dimensionMap),
    minBlockSize: (0, $snE9y.dimensionMap),
    minHeight: (0, $snE9y.dimensionMap),
    minInlineSize: (0, $snE9y.dimensionMap),
    minWidth: (0, $snE9y.dimensionMap),
    opacity: (0, $snE9y.opacityMap),
    outlineColor: (0, $snE9y.borderColorMap),
    outlineOffset: (0, $snE9y.positiveSpaceMap),
    outlineWidth: (0, $snE9y.borderWidthMap),
    padding: (0, $snE9y.positiveSpaceMap),
    paddingBlock: (0, $snE9y.positiveSpaceMap),
    paddingBlockEnd: (0, $snE9y.positiveSpaceMap),
    paddingBlockStart: (0, $snE9y.positiveSpaceMap),
    paddingBottom: (0, $snE9y.positiveSpaceMap),
    paddingInline: (0, $snE9y.positiveSpaceMap),
    paddingInlineEnd: (0, $snE9y.positiveSpaceMap),
    paddingInlineStart: (0, $snE9y.positiveSpaceMap),
    paddingLeft: (0, $snE9y.positiveSpaceMap),
    paddingRight: (0, $snE9y.positiveSpaceMap),
    paddingTop: (0, $snE9y.positiveSpaceMap),
    right: (0, $snE9y.allSpaceMap),
    rowGap: (0, $snE9y.positiveSpaceMap),
    top: (0, $snE9y.allSpaceMap),
    width: (0, $snE9y.dimensionMap),
    zIndex: (0, $snE9y.layerMap)
};
const $5f7adf3e4e3521d6$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
const $5f7adf3e4e3521d6$var$isSafeEnvToThrow = ()=>typeof $2fFJv === 'object' && typeof $2fFJv.env === 'object' && false;
const $5f7adf3e4e3521d6$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
const $5f7adf3e4e3521d6$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
const $5f7adf3e4e3521d6$var$transformStyles = (styleObj)=>{
    if (!styleObj || typeof styleObj !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($5f7adf3e4e3521d6$var$transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(([key, value])=>{
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if (typeof value === 'object' && $5f7adf3e4e3521d6$var$safeSelectors.test(key)) {
            styleObj[key] = $5f7adf3e4e3521d6$var$transformStyles(value);
            return;
        }
        if ($5f7adf3e4e3521d6$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($5f7adf3e4e3521d6$var$reNestedSelectors.test(key)) throw new Error(`Styles not supported for key '${key}'.`);
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $5f7adf3e4e3521d6$export$9a199fbafee0014e)) return;
        const tokenValue = $5f7adf3e4e3521d6$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
const $5f7adf3e4e3521d6$var$baseXcss = (style)=>{
    const transformedStyles = $5f7adf3e4e3521d6$var$transformStyles(style);
    return {
        [$5f7adf3e4e3521d6$var$uniqueSymbol]: (0, $byn9U.css)(transformedStyles)
    };
};
const $5f7adf3e4e3521d6$export$a9c84988c8f81f2d = (args)=>{
    if (Array.isArray(args)) {
        const emotion = [];
        const staticArr = [];
        for (const arg of args){
            const result = $5f7adf3e4e3521d6$export$a9c84988c8f81f2d(arg);
            if (result.emotion) emotion.push(...result.emotion);
            if (result.static) staticArr.push(result.static);
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    const objArgs = args;
    const { [$5f7adf3e4e3521d6$var$uniqueSymbol]: styles } = objArgs || {};
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        const stringifiedArgs = `${args}`;
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $5f7adf3e4e3521d6$export$f6c783d06584602c(style) {
    return $5f7adf3e4e3521d6$var$baseXcss(style);
}

});


parcelRegister("b13WO", function(module, exports) {

$parcel$export(module.exports, "default", () => $8052d998c8f744ff$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/styles/no-exported-styles */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8ceJs = parcelRequire("8ceJs");

var $3yyVA = parcelRequire("3yyVA");
const $8052d998c8f744ff$var$flexGrowMap = {
    hug: (0, $8ceJs.xcss)({
        flexGrow: 0
    }),
    fill: (0, $8ceJs.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ const $8052d998c8f744ff$var$Stack = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: as, alignInline: alignItems, alignBlock: alignBlock = 'stretch', spread: spread, grow: grow, space: space, children: children, testId: testId, xcss: xcss, role: role }, ref)=>{
    const justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    const styles = grow ? [
        $8052d998c8f744ff$var$flexGrowMap[grow],
        ...Array.isArray(xcss) ? xcss : [
            xcss
        ]
    ] : xcss;
    return (0, $byn9U.jsx)((0, $3yyVA.default), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$8052d998c8f744ff$var$Stack.displayName = 'Stack';
var $8052d998c8f744ff$export$2e2bcd8739ae039 = $8052d998c8f744ff$var$Stack;

});

parcelRegister("claMu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fbfcf1e7b03568a$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8ynlC = parcelRequire("8ynlC");

var $snE9y = parcelRequire("snE9y");

var $8nikQ = parcelRequire("8nikQ");
const $8fbfcf1e7b03568a$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
// We're doing this because our CSS reset can add top margins to elements such as `p` which is totally insane.
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
const $8fbfcf1e7b03568a$var$resetStyles = (0, $byn9U.css)({
    margin: 0
});
const $8fbfcf1e7b03568a$var$strongStyles = (0, $byn9U.css)({
    fontWeight: 'bold'
});
const $8fbfcf1e7b03568a$var$emStyles = (0, $byn9U.css)({
    fontStyle: 'italic'
});
const $8fbfcf1e7b03568a$var$textAlignMap = {
    center: (0, $byn9U.css)({
        textAlign: 'center'
    }),
    end: (0, $byn9U.css)({
        textAlign: 'end'
    }),
    start: (0, $byn9U.css)({
        textAlign: 'start'
    })
};
const $8fbfcf1e7b03568a$var$truncationStyles = (0, $byn9U.css)({
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical'
});
const $8fbfcf1e7b03568a$var$wordBreakMap = {
    breakAll: (0, $byn9U.css)({
        wordBreak: 'break-all'
    })
};
const $8fbfcf1e7b03568a$var$HasTextAncestorContext = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
const $8fbfcf1e7b03568a$var$useHasTextAncestor = ()=>(0, $eUqFw.useContext)($8fbfcf1e7b03568a$var$HasTextAncestorContext);
/**
 * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
 */ const $8fbfcf1e7b03568a$var$useColor = (colorProp, hasTextAncestor)=>{
    const surface = (0, $8nikQ.useSurface)();
    /**
   * Where the color of the surface is inverted we always override the color
   * as there is no valid choice that is not covered by the override.
   */ if ((0, $snE9y.inverseColorMap).hasOwnProperty(surface)) return (0, $snE9y.inverseColorMap)[surface];
    if (colorProp === 'inherit') return undefined;
    if (!colorProp && hasTextAncestor) return undefined;
    return colorProp || 'color.text';
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ const $8fbfcf1e7b03568a$var$Text = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: Component = 'span', color: colorProp, align: align, testId: testId, id: id, size: size = 'medium', weight: weight, maxLines: maxLines, children: children }, ref)=>{
    (0, $8ynlC.default)($8fbfcf1e7b03568a$var$asAllowlist.includes(Component), `@atlaskit/primitives: Text received an invalid "as" value of "${Component}"`);
    const hasTextAncestor = $8fbfcf1e7b03568a$var$useHasTextAncestor();
    const color = $8fbfcf1e7b03568a$var$useColor(colorProp, hasTextAncestor);
    const component = (0, $byn9U.jsx)(Component, {
        ref: ref,
        css: [
            $8fbfcf1e7b03568a$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $snE9y.fontStylesMap)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $snE9y.textColorStylesMap)[color],
            maxLines && $8fbfcf1e7b03568a$var$truncationStyles,
            maxLines === 1 && $8fbfcf1e7b03568a$var$wordBreakMap.breakAll,
            align && $8fbfcf1e7b03568a$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $snE9y.fontWeightStylesMap)[weight],
            Component === 'em' && $8fbfcf1e7b03568a$var$emStyles,
            Component === 'strong' && $8fbfcf1e7b03568a$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : (0, $byn9U.jsx)($8fbfcf1e7b03568a$var$HasTextAncestorContext.Provider, {
        value: true
    }, component);
});
var $8fbfcf1e7b03568a$export$2e2bcd8739ae039 = $8fbfcf1e7b03568a$var$Text;

});
parcelRegister("8nikQ", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", () => $618eb1aec61f2325$export$1ca2a26fecb070ae);
$parcel$export(module.exports, "useSurface", () => $618eb1aec61f2325$export$1aeb4f6b93c4540d);

var $eUqFw = parcelRequire("eUqFw");
const $618eb1aec61f2325$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $eUqFw.createContext)('elevation.surface');
const $618eb1aec61f2325$export$1aeb4f6b93c4540d = ()=>{
    return (0, $eUqFw.useContext)($618eb1aec61f2325$export$1ca2a26fecb070ae);
};
$618eb1aec61f2325$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});


parcelRegister("aeMpE", function(module, exports) {

$parcel$export(module.exports, "nameMaxLength", () => $7740c3f4ff5782ea$export$253bdad208569777);
$parcel$export(module.exports, "guidelineMaxLength", () => $7740c3f4ff5782ea$export$e1444e5b0a63d793);
$parcel$export(module.exports, "colorsConfig", () => $7740c3f4ff5782ea$export$fb2992e82b83582a);
$parcel$export(module.exports, "disabledColorConfig", () => $7740c3f4ff5782ea$export$9cdea53b8993b139);

var $3dpxL = parcelRequire("3dpxL");

var $01Bcy = parcelRequire("01Bcy");
const { formatMessage: $7740c3f4ff5782ea$var$formatMessage } = (0, $3dpxL.createIntl)({
    locale: 'en'
});
const $7740c3f4ff5782ea$export$89b67151eed9295a = {
    definition: $7740c3f4ff5782ea$var$formatMessage((0, $01Bcy.messages).noClassification),
    includeIcon: false
};
const $7740c3f4ff5782ea$export$253bdad208569777 = 50;
const $7740c3f4ff5782ea$export$cbc3cef853d1014b = 1000;
const $7740c3f4ff5782ea$export$e1444e5b0a63d793 = 1000;
const $7740c3f4ff5782ea$export$fb2992e82b83582a = {
    light: {
        YELLOW: {
            fontColor: '#693200',
            bgColor: '#FFF5D4',
            bgColorHovered: '#FFE48F',
            bgColorPressed: '#FFC716',
            bgColorFocused: '#FFF5D4'
        },
        ORANGE: {
            fontColor: '#3A2C1F',
            bgColor: '#FFC716',
            bgColorHovered: '#FCA700',
            bgColorPressed: '#FA8700',
            bgColorFocused: '#FCA700'
        },
        RED: {
            fontColor: '#AE2E24',
            bgColor: '#FFECEB',
            bgColorHovered: '#FFD5D2',
            bgColorPressed: '#FD9891',
            bgColorFocused: '#FFECEB'
        },
        RED_BOLD: {
            fontColor: '#FFFFFF',
            bgColor: '#C9372C',
            bgColorHovered: '#AE2E24',
            bgColorPressed: '#5D1F1A',
            bgColorFocused: '#C9372C'
        },
        PURPLE: {
            fontColor: '#352C63',
            bgColor: '#DFD8FD',
            bgColorHovered: '#B8ACF6',
            bgColorPressed: '#9F8FEF',
            bgColorFocused: '#DFD8FD'
        },
        BLUE: {
            fontColor: '#09326C',
            bgColor: '#CCE0FF',
            bgColorHovered: '#85B8FF',
            bgColorPressed: '#579DFF',
            bgColorFocused: '#CCE0FF'
        },
        TEAL: {
            fontColor: '#206A83',
            bgColor: '#E7F9FF',
            bgColorHovered: '#C6EDFB',
            bgColorPressed: '#9DD9EE',
            bgColorFocused: '#E7F9FF'
        },
        GREEN: {
            fontColor: '#164B35',
            bgColor: '#BAF3DB',
            bgColorHovered: '#7EE2B8',
            bgColorPressed: '#4BCE97',
            bgColorFocused: '#BAF3DB'
        },
        GREY: {
            fontColor: '#172B4D',
            bgColor: '#F1F2F4',
            bgColorHovered: '#DCDFE4',
            bgColorPressed: '#B3B9C4',
            bgColorFocused: '#F1F2F4'
        },
        LIME: {
            fontColor: '#4C6B1F',
            bgColor: '#EFFFD6',
            bgColorHovered: '#D3F1A7',
            bgColorPressed: '#B3DF72',
            bgColorFocused: '#EFFFD6'
        },
        // Colors below to be removed soon so they do not have bgColorFocused
        NONE: {
            fontColor: '#172B4D',
            bgColor: 'inherit',
            bgColorHovered: 'rgba(9, 30, 66, 0.06)',
            bgColorPressed: 'rgba(9, 30, 66, 0.14)'
        },
        BLUE_BOLD: {
            fontColor: '#FFFFFF',
            bgColor: '#005C99',
            bgColorHovered: '#007ACC',
            bgColorPressed: '#003D66'
        }
    },
    dark: {
        YELLOW: {
            fontColor: '#FFE48F',
            bgColor: '#3A2C1F',
            bgColorHovered: '#693200',
            bgColorPressed: '#9E4C00',
            bgColorFocused: '#3A2C1F'
        },
        ORANGE: {
            fontColor: '#3A2C1F',
            bgColor: '#FFC716',
            bgColorHovered: '#FCA700',
            bgColorPressed: '#FA8700',
            bgColorFocused: '#FCA700'
        },
        RED: {
            fontColor: '#FD9891',
            bgColor: '#42221F',
            bgColorHovered: '#5D1F1A',
            bgColorPressed: '#AE2E24',
            bgColorFocused: '#42221F'
        },
        RED_BOLD: {
            fontColor: '#1D2125',
            bgColor: '#F87168',
            bgColorHovered: '#FD9891',
            bgColorPressed: '#FFD5D2',
            bgColorFocused: '#F87168'
        },
        PURPLE: {
            fontColor: '#DFD8FD',
            bgColor: '#352C63',
            bgColorHovered: '#5E4DB2',
            bgColorPressed: '#6E5DC6',
            bgColorFocused: '#352C63'
        },
        BLUE: {
            fontColor: '#CCE0FF',
            bgColor: '#09326C',
            bgColorHovered: '#0055CC',
            bgColorPressed: '#0C66E4',
            bgColorFocused: '#09326C'
        },
        TEAL: {
            fontColor: '#9DD9EE',
            bgColor: '#1E3137',
            bgColorHovered: '#164555',
            bgColorPressed: '#206A83',
            bgColorFocused: '#1E3137'
        },
        GREEN: {
            fontColor: '#BAF3DB',
            bgColor: '#164B35',
            bgColorHovered: '#216E4E',
            bgColorPressed: '#1F845A',
            bgColorFocused: '#164B35'
        },
        GREY: {
            fontColor: '#B6C2CF',
            bgColor: '#2C333A',
            bgColorHovered: '#38414A',
            bgColorPressed: '#454F59',
            bgColorFocused: '#2C333A'
        },
        LIME: {
            fontColor: '#B3DF72',
            bgColor: '#28311B',
            bgColorHovered: '#37471F',
            bgColorPressed: '#4C6B1F',
            bgColorFocused: '#28311B'
        },
        // Colors below to be removed soon so they do not have bgColorFocused
        NONE: {
            fontColor: '#B6C2CF',
            bgColor: 'inherit',
            bgColorHovered: 'rgba(161, 189, 217, 0.08)',
            bgColorPressed: 'rgba(166, 197, 226, 0.16)'
        },
        BLUE_BOLD: {
            fontColor: '#161A1D',
            bgColor: '#39A0FF',
            bgColorHovered: '#66B5FF',
            bgColorPressed: '#80C1FF'
        }
    }
};
const $7740c3f4ff5782ea$export$9cdea53b8993b139 = {
    light: {
        fontColor: '#091E42',
        bgColor: 'rgba(9, 30, 66, 0.03)'
    },
    dark: {
        fontColor: '#BFDBF847',
        bgColor: 'rgba(3, 4, 4, 0.26)'
    }
};

});
parcelRegister("01Bcy", function(module, exports) {

$parcel$export(module.exports, "messages", () => $004cf38da7543b2c$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $004cf38da7543b2c$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    noClassification: {
        id: 'data-classification-level.no-classification',
        defaultMessage: 'No classification',
        description: 'Text for the no classification option'
    },
    classifyContent: {
        id: 'data-classification-level.edit-popup.classify-content',
        defaultMessage: 'Classify content',
        description: 'Text for the header of the edit popup'
    },
    selectClassification: {
        id: 'data-classification-level.edit-popup.select-classification',
        defaultMessage: 'Select classification',
        description: 'Text for the label of the select dropdown to select a classification'
    },
    updateButton: {
        id: 'data-classification-level.edit-popup.update-button',
        defaultMessage: 'Update',
        description: 'Text for the update button'
    },
    cancelButton: {
        id: 'data-classification-level.edit-popup.cancel-button',
        defaultMessage: 'Cancel',
        description: 'Text for the cancel button'
    },
    changeLevel: {
        id: 'data-classification-level.read-popup.change-level',
        defaultMessage: 'Change level',
        description: 'Text for the button that changes the level of the selected classification'
    }
});

});


parcelRegister("gi16t", function(module, exports) {

$parcel$export(module.exports, "ClassificationIcon", () => $bdbf2ee812da5afc$export$d2e14829910b9b7d);

var $eUqFw = parcelRequire("eUqFw");

var $46xZN = parcelRequire("46xZN");
const $bdbf2ee812da5afc$export$d2e14829910b9b7d = ({ color: color, width: width, height: height, isDisabled: isDisabled, disabledColorConfig: disabledColorConfig })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $46xZN.SvgIcon), {
        width: width,
        height: height,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.4507 3.24947C11.7778 3.0101 12.2222 3.0101 12.5493 3.24947L12.6384 3.3145C12.6966 3.35693 12.7816 3.41879 12.8885 3.49621C13.1022 3.6511 13.4029 3.8681 13.7503 4.1163C14.4471 4.61402 15.325 5.23208 16.066 5.72614C16.731 6.16948 17.5184 6.51497 18.1606 6.75285C18.4775 6.87022 18.75 6.95808 18.9416 7.01617C19.0373 7.04516 19.1124 7.06659 19.1622 7.08044C19.1871 7.08736 19.2057 7.09238 19.2174 7.09549L19.2296 7.09873L19.231 7.09909C19.6299 7.20149 19.9142 7.55408 19.9294 7.96562L19 7.99995C19.9294 7.96562 19.9294 7.96545 19.9294 7.96562L19.9294 7.96637L19.9296 7.97092L19.9299 7.9823L19.9311 8.02272C19.9321 8.05733 19.9332 8.10704 19.9342 8.17035C19.9362 8.29692 19.9376 8.47816 19.9354 8.70198C19.931 9.14881 19.912 9.76955 19.8537 10.4665C19.7402 11.8241 19.4681 13.609 18.7732 14.9323C18.0039 16.3974 16.3463 17.7569 15.0203 18.6963C14.3347 19.182 13.6935 19.5855 13.2239 19.8675C12.9887 20.0088 12.7955 20.1202 12.66 20.1969C12.5923 20.2353 12.5389 20.265 12.5018 20.2855L12.4586 20.3092L12.4467 20.3157L12.442 20.3182C12.4419 20.3183 12.4413 20.3186 12 19.4999C11.566 20.3224 11.5658 20.3224 11.5657 20.3223L11.5606 20.3196L11.5484 20.3131L11.5044 20.2895C11.4666 20.269 11.4121 20.2393 11.3429 20.201C11.2047 20.1243 11.0075 20.013 10.7676 19.8718C10.2886 19.5899 9.63465 19.1866 8.93632 18.701C7.58714 17.763 5.89843 16.4025 5.12645 14.9323C4.4427 13.6301 4.19878 11.8354 4.10698 10.4745C4.0597 9.77357 4.05069 9.14709 4.05342 8.69567C4.05479 8.46954 4.05911 8.28624 4.06316 8.15821C4.06518 8.09417 4.06714 8.04388 4.06863 8.00888L4.07046 7.96804L4.07102 7.95657L4.07125 7.95199C4.07126 7.95182 4.07129 7.95125 5.00001 7.99995L4.07129 7.95125C4.09257 7.54532 4.37502 7.20025 4.76872 7.09917C4.7687 7.09917 4.76873 7.09916 4.76872 7.09917L4.7704 7.09873L4.78263 7.09549C4.79429 7.09238 4.81288 7.08736 4.83779 7.08044C4.88765 7.06659 4.96271 7.04516 5.05838 7.01617C5.25004 6.95808 5.52252 6.87022 5.8394 6.75285C6.48161 6.51498 7.26895 6.16948 7.93395 5.72614C8.67504 5.23208 9.55289 4.61402 10.2497 4.1163C10.5971 3.8681 10.8978 3.6511 11.1115 3.49621C11.2184 3.41879 11.3034 3.35693 11.3616 3.3145L11.4507 3.24947ZM5.91345 8.69663C5.91343 8.70005 5.91341 8.70348 5.91339 8.70693C5.91086 9.12508 5.91927 9.70457 5.96277 10.3493C6.05251 11.6797 6.28352 13.135 6.77323 14.0676C7.31396 15.0974 8.65034 16.2369 9.99807 17.1739C10.6482 17.6258 11.2607 18.0038 11.7109 18.2687C11.8151 18.33 11.9104 18.3852 11.9951 18.4336C12.0763 18.3862 12.1671 18.3325 12.2662 18.273C12.7071 18.0082 13.3072 17.6304 13.9451 17.1786C15.2657 16.243 16.5831 15.1025 17.1264 14.0676C17.6371 13.0952 17.89 11.63 18.0002 10.3116C18.0534 9.67538 18.0711 9.10545 18.0754 8.69297C17.9096 8.63851 17.7202 8.57322 17.5146 8.49705C16.8069 8.23492 15.8693 7.83042 15.0343 7.27375C14.2679 6.7628 13.3706 6.13086 12.6692 5.62983C12.4167 5.44946 12.1886 5.2854 12 5.14916C11.8114 5.2854 11.5833 5.44946 11.3308 5.62983C10.6294 6.13086 9.73213 6.7628 8.9657 7.27375C8.1307 7.83042 7.19314 8.23492 6.48544 8.49705C6.27515 8.57494 6.08188 8.64144 5.91345 8.69663ZM12 19.4999L11.5657 20.3223C11.8399 20.467 12.1684 20.4657 12.4413 20.3186L12 19.4999Z",
        fill: isDisabled ? disabledColorConfig.fontColor : color
    }));
};

});
parcelRegister("46xZN", function(module, exports) {

$parcel$export(module.exports, "SvgIcon", () => $2fd217d0c9b93693$export$dbcb8210e8a983ed);

var $exJuA = parcelRequire("exJuA");
const $2fd217d0c9b93693$export$dbcb8210e8a983ed = (0, $exJuA.default).svg((props)=>({
        minWidth: `${props.width}px`,
        minHeight: `${props.height}px`
    }));

});


parcelRegister("26qwu", function(module, exports) {

$parcel$export(module.exports, "DropdownLabel", () => $1880b73576d79ff1$export$bef68440ec6a6159);
$parcel$export(module.exports, "NameLabel", () => $1880b73576d79ff1$export$63077572f44eb437);
$parcel$export(module.exports, "ContainerLabel", () => $1880b73576d79ff1$export$3944a9dffaf20407);
$parcel$export(module.exports, "ContainerIcon", () => $1880b73576d79ff1$export$6d6da6edaddd5876);
$parcel$export(module.exports, "Name", () => $1880b73576d79ff1$export$c7bd411105e2dec3);
$parcel$export(module.exports, "Definition", () => $1880b73576d79ff1$export$cf0290ef4b5a4f61);

var $exJuA = parcelRequire("exJuA");

var $4lTFP = parcelRequire("4lTFP");
const $1880b73576d79ff1$export$bef68440ec6a6159 = (0, $exJuA.default).label({
    font: `var(--ds-font-body, ${(0, $4lTFP.fontFallback).body.medium})`,
    fontWeight: "var(--ds-font-weight-semibold, 600)"
});
const $1880b73576d79ff1$export$63077572f44eb437 = (0, $exJuA.default).span({
    marginLeft: "var(--ds-space-100, 8px)",
    color: "var(--ds-text-subtle, inherit)",
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
const $1880b73576d79ff1$export$3944a9dffaf20407 = (0, $exJuA.default).div((props)=>({
        display: 'flex',
        alignItems: 'center',
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        marginBottom: props.definitionExists ? "var(--ds-space-100, 8px)" : "var(--ds-space-0, 0px)"
    }));
const $1880b73576d79ff1$export$6d6da6edaddd5876 = (0, $exJuA.default).span((props)=>({
        display: 'inline-flex',
        maxWidth: '100%',
        whiteSpace: 'nowrap',
        width: 'auto',
        alignItems: 'center',
        padding: "var(--ds-space-025, 2px)",
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        paddingRight: props.isIconOnly ? "var(--ds-space-025, 2px)" : "var(--ds-space-050, 4px)",
        borderRadius: "var(--ds-border-radius, 3px)",
        color: props.colorsConfig.fontColor,
        background: props.colorsConfig.bgColor,
        userSelect: 'none'
    }));
const $1880b73576d79ff1$export$c7bd411105e2dec3 = (0, $exJuA.default).span({
    display: 'flex',
    alignItems: 'center',
    font: `${`var(--ds-font-body-small, ${(0, $4lTFP.fontFallback).body.small})`}, font-weight: ${"var(--ds-font-weight-medium, 500)"}`,
    lineHeight: '14px',
    marginLeft: "var(--ds-space-025, 2px)",
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $1880b73576d79ff1$export$cf0290ef4b5a4f61 = (0, $exJuA.default).div({
    color: "var(--ds-text-subtle, inherit)",
    whiteSpace: 'pre-wrap',
    overflowWrap: 'break-word',
    wordWrap: 'break-word'
});

});



parcelRegister("2KWIB", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ed3ac02aba149db$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4ed3ac02aba149db$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    classificationFieldLabel: {
        "id": "issue-create-commons.data-classification-field.classification-field-label",
        "defaultMessage": "Classification level"
    },
    projectDefaultClassificationOption: {
        "id": "issue-create-commons.data-classification-field.project-default-classification-option",
        "defaultMessage": "Project default"
    },
    noClassificationOption: {
        "id": "issue-create-commons.data-classification-field.no-classification-option",
        "defaultMessage": "Project default - No classification"
    }
});

});


parcelRegister("cYE68", function(module, exports) {

$parcel$export(module.exports, "default", () => $89fa887c3da1fa5e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $89fa887c3da1fa5e$var$ConfigureFieldsModal = (0, $7rh0R.lazy)(()=>(parcelRequire("gWcW8")), {
    ssr: false,
    moduleId: "./src/packages/issue-create/configure-fields/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$89fa887c3da1fa5e$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async.jira.issue-create.configure-fields",
        packageName: "jiraIssueCreateConfigureFields"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "create-configure-fields-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($89fa887c3da1fa5e$var$ConfigureFieldsModal, props)));

});
parcelRegister("gWcW8", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('861R8');
        const value = parcelRequire('cJqms');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("861R8").then(()=>parcelRequire('cJqms'));
}

});


parcelRegister("2qZHF", function(module, exports) {

$parcel$export(module.exports, "MountEvent", () => $017cfdc2fc017c3b$export$2c6963927dbc68f1);
/**
 * This library is the only place where you'd use raw analytics from atlaskit
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $2jDha = parcelRequire("2jDha");
// eslint-disable-next-line jira/react/no-class-components
class $017cfdc2fc017c3b$var$MountEventComponent extends (0, $eUqFw.Component) {
    componentDidMount() {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'mounted'
        });
        if (this.props.onMount) this.props.onMount(analyticsEvent);
    }
    render() {
        return null;
    }
}
const $017cfdc2fc017c3b$export$2c6963927dbc68f1 = (0, $2jDha.default)()($017cfdc2fc017c3b$var$MountEventComponent);

});

parcelRegister("7LoO9", function(module, exports) {

$parcel$export(module.exports, "useStorageEnforcement", () => $f0de573d65b66ce1$export$fa2c25e1ed13a1a8);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $hJ992 = parcelRequire("hJ992");

var $bNe1g = parcelRequire("bNe1g");


var $7YYuY = parcelRequire("7YYuY");

var $lXjME = parcelRequire("lXjME");
const $f0de573d65b66ce1$var$MODAL_COOLDOWN_MS = 86400000; // 1 day in ms
const $f0de573d65b66ce1$export$fa2c25e1ed13a1a8 = ()=>{
    const [currentState, { setIsOpen: setEnforceStorageModalIsOpen }] = (0, $lXjME.useEnforceStorageModal)();
    const issueViewMode = (0, $hJ992.useViewMode)();
    const { data: projectContextData } = (0, $bNe1g.useProjectContext)();
    const isInJSWProject = projectContextData?.projectType === (0, $7ZZxN.SOFTWARE_PROJECT);
    const openModalIfNotOnCooldown = (0, $eUqFw.useCallback)((touchpoint)=>{
        const isOnCooldown = Date.now() - ((0, $7YYuY.localStorage).get((0, $815b5650076b1618$export$ed785d2382d0101d)) || 0) < $f0de573d65b66ce1$var$MODAL_COOLDOWN_MS;
        if (isOnCooldown) {
            if (currentState.isOpen === 'pending') // Reset pending state if modal is on cooldown when it should be shown
            setEnforceStorageModalIsOpen({
                isOpen: 'closed',
                touchpoint: undefined
            });
        } else setEnforceStorageModalIsOpen({
            isOpen: 'open',
            touchpoint: touchpoint
        });
    }, [
        setEnforceStorageModalIsOpen,
        currentState.isOpen
    ]);
    const showEnforcementIfStorageIsFull = (0, $eUqFw.useCallback)(({ delayShow: delayShow = false, shouldOnlyShowInJSWContext: shouldOnlyShowInJSWContext = true, touchpoint: touchpoint })=>{
        if (shouldOnlyShowInJSWContext && !isInJSWProject) return;
        // Issue view use case is checked internally here rather than passed in, to avoid polluting consumer code
        if (delayShow || issueViewMode === (0, $935e771f19f8ea28$export$98c0ebc22792f04)) setEnforceStorageModalIsOpen({
            isOpen: 'pending',
            touchpoint: touchpoint
        });
        else openModalIfNotOnCooldown(touchpoint);
    }, [
        isInJSWProject,
        issueViewMode,
        setEnforceStorageModalIsOpen,
        openModalIfNotOnCooldown
    ]);
    // Used to show enforcement modal after modals are dismissed, to avoid modal on modal UX
    const showEnforcementIfPendingToShow = (0, $eUqFw.useCallback)(()=>{
        if (currentState.isOpen === 'pending') // Use the trigger from created the JSW issue
        openModalIfNotOnCooldown(currentState.touchpoint);
    }, [
        currentState.isOpen,
        openModalIfNotOnCooldown,
        currentState.touchpoint
    ]);
    return {
        showEnforcementIfStorageIsFull: showEnforcementIfStorageIsFull,
        showEnforcementIfPendingToShow: showEnforcementIfPendingToShow
    };
};

});
parcelRegister("hJ992", function(module, exports) {

$parcel$export(module.exports, "useChildIssuesLimit", () => $7e3614f655e5103c$export$8d75f312eaa63aec);
$parcel$export(module.exports, "useChildIssuesIssueLimitUrl", () => $7e3614f655e5103c$export$65a59acd1ffc5bba);
$parcel$export(module.exports, "useIsModal", () => $7e3614f655e5103c$export$9ce8428ff198804a);
$parcel$export(module.exports, "useIssueKey", () => $7e3614f655e5103c$export$22108eca27445997);
$parcel$export(module.exports, "useIssueId", () => $7e3614f655e5103c$export$9df8176b5ffce5ab);
$parcel$export(module.exports, "useIsArchived", () => $7e3614f655e5103c$export$7cd1821433aafaee);
$parcel$export(module.exports, "useIsClassifyEditEnabled", () => $7e3614f655e5103c$export$b23b36ed5c42e920);
$parcel$export(module.exports, "useProjectKey", () => $7e3614f655e5103c$export$f87be37f8e8be65);
$parcel$export(module.exports, "useAnalyticsSource", () => $7e3614f655e5103c$export$aad3917152559b87);
$parcel$export(module.exports, "useIssueContextActions", () => $7e3614f655e5103c$export$d6ec1293313f49ac);
$parcel$export(module.exports, "useRapidViewMap", () => $7e3614f655e5103c$export$4d204e800e4e0be7);
$parcel$export(module.exports, "useEstimationStatistic", () => $7e3614f655e5103c$export$5b20e30ee6db56e9);
$parcel$export(module.exports, "useViewMode", () => $7e3614f655e5103c$export$3a7c3e259b6adb93);
$parcel$export(module.exports, "useBackButtonUrl", () => $7e3614f655e5103c$export$cfe64a334903927c);
$parcel$export(module.exports, "useIssueNavigatorData", () => $7e3614f655e5103c$export$aa008a00bae7e7ab);
$parcel$export(module.exports, "useOnIssueKeyChange", () => $7e3614f655e5103c$export$52c975cf0b623556);
$parcel$export(module.exports, "useRapidViewId", () => $7e3614f655e5103c$export$b34d0ea0bf41fee);
$parcel$export(module.exports, "useViewScreenId", () => $7e3614f655e5103c$export$7c142b5701b4c3f9);
$parcel$export(module.exports, "useHasSoftwareAccess", () => $7e3614f655e5103c$export$dcc0d1c3cd4bd9fb);
$parcel$export(module.exports, "useIsFullPageIssueView", () => $7e3614f655e5103c$export$2e131fc4108f9106);
$parcel$export(module.exports, "useIsEmbedPageIssueView", () => $7e3614f655e5103c$export$4596c26005fbb859);
$parcel$export(module.exports, "useIsAiOptInEnabled", () => $7e3614f655e5103c$export$b131d9f6da853161);

var $eUqFw = parcelRequire("eUqFw");


var $e91YZ = parcelRequire("e91YZ");

var $7HKaW = parcelRequire("7HKaW");
var $6vrw7 = parcelRequire("6vrw7");

var $j3FUN = parcelRequire("j3FUN");
var $jBTMs = parcelRequire("jBTMs");

var $hWdjG = parcelRequire("hWdjG");
const $7e3614f655e5103c$export$8d75f312eaa63aec = ()=>{
    const [childIssuesLimit] = (0, $hWdjG.useIssueContextStoreChildIssuesLimit)();
    return childIssuesLimit;
};
const $7e3614f655e5103c$export$cc6e0a43a2a9b17a = ()=>{
    const [childIssuesIssueLimitUrls] = (0, $hWdjG.useIssueContextStoreChildIssuesIssueLimitUrls)();
    return childIssuesIssueLimitUrls;
};
const $7e3614f655e5103c$export$65a59acd1ffc5bba = (fieldId)=>{
    const childIssuesIssueLimitUrls = $7e3614f655e5103c$export$cc6e0a43a2a9b17a();
    return childIssuesIssueLimitUrls?.[fieldId];
};
const $7e3614f655e5103c$export$9ce8428ff198804a = ()=>{
    const [isModal] = (0, $hWdjG.useIssueContextStoreIsModal)();
    return isModal;
};
const $7e3614f655e5103c$export$22108eca27445997 = ()=>{
    const [issueKey] = (0, $hWdjG.useIssueContextStoreIssueKey)();
    return issueKey;
};
const $7e3614f655e5103c$export$9df8176b5ffce5ab = ()=>{
    const [issueId] = (0, $hWdjG.useIssueContextStoreIssueId)();
    return issueId;
};
const $7e3614f655e5103c$export$7cd1821433aafaee = ()=>{
    const [isArchived] = (0, $hWdjG.useIssueContextStoreIsArchived)();
    return isArchived;
};
const $7e3614f655e5103c$export$b23b36ed5c42e920 = ()=>{
    const [isClassifyEditEnabled] = (0, $hWdjG.useIssueContextStoreIsClassifyEditEnabled)();
    return isClassifyEditEnabled;
};
const $7e3614f655e5103c$export$f87be37f8e8be65 = ()=>{
    const [issueKey] = (0, $hWdjG.useIssueContextStoreIssueKey)();
    return (0, $6vrw7.toProjectKey)(issueKey.split('-')[0]);
};
const $7e3614f655e5103c$export$aad3917152559b87 = ()=>{
    const [analyticsSource] = (0, $hWdjG.useIssueContextStoreAnalyticsSource)();
    return analyticsSource;
};
const $7e3614f655e5103c$export$d6ec1293313f49ac = ()=>{
    const [, { setIssueContext: setIssueContext, mergeIssueContext: mergeIssueContext, getChildIssuesLimit: getChildIssuesLimit, getMaxTokenLength: getMaxTokenLength, getIsLoadedWithPage: getIsLoadedWithPage, getBackButtonUrl: getBackButtonUrl, getIsSpaEnabled: getIsSpaEnabled, getIssueKey: getIssueKey, setDetailViewAsModal: setDetailViewAsModal, setDetailViewAsSidebar: setDetailViewAsSidebar, resetDetailView: resetDetailView }] = (0, $hWdjG.useIssueContextStoreActions)();
    const actions = (0, $eUqFw.useMemo)(()=>({
            setIssueContext: setIssueContext,
            mergeIssueContext: mergeIssueContext,
            getChildIssuesLimit: getChildIssuesLimit,
            getMaxTokenLength: getMaxTokenLength,
            getIsLoadedWithPage: getIsLoadedWithPage,
            getBackButtonUrl: getBackButtonUrl,
            getIsSpaEnabled: getIsSpaEnabled,
            getIssueKey: getIssueKey,
            setDetailViewAsModal: setDetailViewAsModal,
            setDetailViewAsSidebar: setDetailViewAsSidebar,
            resetDetailView: resetDetailView
        }), [
        setIssueContext,
        mergeIssueContext,
        getChildIssuesLimit,
        getMaxTokenLength,
        getIsLoadedWithPage,
        getBackButtonUrl,
        getIsSpaEnabled,
        getIssueKey,
        setDetailViewAsModal,
        setDetailViewAsSidebar,
        resetDetailView
    ]);
    return [
        undefined,
        actions
    ];
};
const $7e3614f655e5103c$export$4d204e800e4e0be7 = ()=>{
    const [rapidViewMap] = (0, $hWdjG.useIssueContextRapidViewMap)();
    return rapidViewMap;
};
const $7e3614f655e5103c$export$e0d7666ae716c88a = ()=>{
    const [maxTokenLength] = (0, $hWdjG.useIssueContextStoreMaxTokenLength)();
    return maxTokenLength;
};
const $7e3614f655e5103c$export$b4199f923267161e = ()=>{
    const [isLoadedWithPage] = (0, $hWdjG.useIssueContextStoreIsLoadedWithPage)();
    return isLoadedWithPage;
};
const $7e3614f655e5103c$export$5b20e30ee6db56e9 = ()=>{
    const [estimationStatistic] = (0, $hWdjG.useIssueContextStoreEstimationStatistic)();
    return estimationStatistic;
};
const $7e3614f655e5103c$export$4dface15d86304a4 = ()=>{
    const [isLoading] = (0, $hWdjG.useIssueContextStoreIsLoading)();
    return isLoading;
};
const $7e3614f655e5103c$export$3a7c3e259b6adb93 = ()=>{
    const [viewMode] = (0, $hWdjG.useIssueContextStoreViewMode)();
    return viewMode;
};
const $7e3614f655e5103c$export$cfe64a334903927c = ()=>{
    const [backButtonUrl] = (0, $hWdjG.useIssueContextStoreBackButtonUrl)();
    return backButtonUrl;
};
const $7e3614f655e5103c$export$aa008a00bae7e7ab = ()=>{
    const [issueNavigatorData] = (0, $hWdjG.useIssueContextStoreIssueNavigatorData)();
    return issueNavigatorData;
};
const $7e3614f655e5103c$export$b49754504c41149f = ()=>{
    const [boardId] = (0, $hWdjG.useIssueContextStoreBoardId)();
    return boardId;
};
const $7e3614f655e5103c$export$91aab984882a2a2c = ()=>{
    const [boardType] = (0, $hWdjG.useIssueContextStoreBoardType)();
    return boardType;
};
const $7e3614f655e5103c$export$dbad9dbd4871f2e9 = ()=>{
    const [isSpaEnabled] = (0, $hWdjG.useIssueContextStoreIsSpaEnabled)();
    return isSpaEnabled;
};
const $7e3614f655e5103c$export$7be495880d433ab9 = ()=>{
    const [loginRedirectUrl] = (0, $hWdjG.useIssueContextStoreLoginRedirctUrl)();
    return loginRedirectUrl;
};
const $7e3614f655e5103c$export$52c975cf0b623556 = ()=>{
    const [onIssueKeyChange] = (0, $hWdjG.useIssueContextStoreOnIssueKeyChange)();
    return onIssueKeyChange;
};
const $7e3614f655e5103c$export$b34d0ea0bf41fee = ()=>{
    const [rapidViewId] = (0, $hWdjG.useIssueContextStoreRapidViewId)();
    return rapidViewId;
};
const $7e3614f655e5103c$export$7c142b5701b4c3f9 = ()=>{
    const [viewScreenId] = (0, $hWdjG.useIssueContextStoreViewScreenId)();
    return viewScreenId;
};
const $7e3614f655e5103c$export$dcc0d1c3cd4bd9fb = ()=>{
    const licensedProducts = (0, $j3FUN.useLicensedProducts)();
    const licenseStates = (0, $jBTMs.useLicenseStates)();
    const isJiraSoftwareLicenseActive = licenseStates && licenseStates.software === (0, $7HKaW.LICENSE_STATE_ACTIVE);
    return licensedProducts[(0, $e91YZ.LICENSED_PRODUCTS).JIRA_SOFTWARE] && isJiraSoftwareLicenseActive;
};
const $7e3614f655e5103c$export$2e131fc4108f9106 = ()=>{
    const analyticsSource = $7e3614f655e5103c$export$aad3917152559b87();
    return analyticsSource === (0, $0100842672acae20$export$b19f949fb9713614);
};
const $7e3614f655e5103c$export$4596c26005fbb859 = ()=>{
    const analyticsSource = $7e3614f655e5103c$export$aad3917152559b87();
    return analyticsSource === (0, $0100842672acae20$export$a5132300c5214280);
};
const $7e3614f655e5103c$export$b131d9f6da853161 = ()=>{
    const [isAiOptInEnabled] = (0, $hWdjG.useIssueContextIsAiOptInEnabled)();
    return isAiOptInEnabled;
};

});
const $0100842672acae20$export$53d41ff2666118e1 = 'agility-backlog';
const $0100842672acae20$export$7552fe2669628499 = 'bitbucket-issue';
const $0100842672acae20$export$41a718da0a8636f4 = 'connect-issue';
const $0100842672acae20$export$cebf0bc8b2ccaf57 = 'core-issue';
const $0100842672acae20$export$82540942fb014b0a = 'business-calendar';
const $0100842672acae20$export$7ca28938a07e0c33 = 'business-list';
const $0100842672acae20$export$f6cf06aaaeb58a54 = 'business-timeline';
const $0100842672acae20$export$b2c0462ff17aa26e = 'business-board';
const $0100842672acae20$export$a607850ebccd28ac = 'business-approvals';
const $0100842672acae20$export$1da6cede3561048f = 'business-files';
const $0100842672acae20$export$b19f949fb9713614 = 'full-issue';
const $0100842672acae20$export$a5132300c5214280 = 'embed-issue';
const $0100842672acae20$export$710114090a811b37 = 'global-issue-navigator-issue';
const $0100842672acae20$export$ce88447986394f2d = 'mobile-issue';
const $0100842672acae20$export$6a90d9196d330040 = 'project-issue-navigator';
const $0100842672acae20$export$2247c9059c171db1 = 'roadmap-issue';
const $0100842672acae20$export$cd16d39c55c569d0 = 'simple-software-board';
const $0100842672acae20$export$f72626bf0d75dfad = 'software-backlog-issue';
const $0100842672acae20$export$778b4609e784cb27 = 'software-deployments-issue';
const $0100842672acae20$export$5b73d694a6048002 = 'version-detail-issue';
const $0100842672acae20$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $0100842672acae20$export$21b5b7189add7861 = 'software-incidents-issue';
const $0100842672acae20$export$9c5d81b901471b27 = 'software-issue';
const $0100842672acae20$export$1735f6ad917dc411 = 'change-calendar';
const $0100842672acae20$export$7063ee6d0035a982 = 'queues-issue-view';
const $0100842672acae20$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $0100842672acae20$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $0100842672acae20$export$14a8072f422804fd = 'issue-navigator-next';

parcelRegister("jBTMs", function(module, exports) {

$parcel$export(module.exports, "useLicenseStates", () => $0a5df676eadd90b5$export$268651a63abe408a);

var $gd0Sp = parcelRequire("gd0Sp");
const $0a5df676eadd90b5$export$268651a63abe408a = ()=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    return tenantContext && tenantContext.licenseStates;
};

});

parcelRegister("hWdjG", function(module, exports) {

$parcel$export(module.exports, "useIssueContextStoreChildIssuesLimit", () => $c495211a89197754$export$abdbea56d86b4aac);
$parcel$export(module.exports, "useIssueContextStoreChildIssuesIssueLimitUrls", () => $c495211a89197754$export$326ff2b963d51c5c);
$parcel$export(module.exports, "useIssueContextStoreIssueKey", () => $c495211a89197754$export$44bcaaabb74e402b);
$parcel$export(module.exports, "useIssueContextStoreIssueId", () => $c495211a89197754$export$332dcee0cf9f4e45);
$parcel$export(module.exports, "useIssueContextStoreIsArchived", () => $c495211a89197754$export$c940355b1fc6e1c4);
$parcel$export(module.exports, "useIssueContextStoreIsClassifyEditEnabled", () => $c495211a89197754$export$b9eebaa1da421997);
$parcel$export(module.exports, "useIssueContextStoreIsModal", () => $c495211a89197754$export$daa47fd600e43a32);
$parcel$export(module.exports, "useIssueContextStoreViewScreenId", () => $c495211a89197754$export$ba2e9546ab5ba6f);
$parcel$export(module.exports, "useIssueContextStoreAnalyticsSource", () => $c495211a89197754$export$74d38d6c437efc1b);
$parcel$export(module.exports, "useIssueContextRapidViewMap", () => $c495211a89197754$export$2092528ee170d9e7);
$parcel$export(module.exports, "useIssueContextStoreMaxTokenLength", () => $c495211a89197754$export$57898374e6239a5a);
$parcel$export(module.exports, "useIssueContextStoreIsLoadedWithPage", () => $c495211a89197754$export$ff0264ec4c015dc1);
$parcel$export(module.exports, "useIssueContextStoreEstimationStatistic", () => $c495211a89197754$export$6c8b81f6dca8c23d);
$parcel$export(module.exports, "useIssueContextStoreIsLoading", () => $c495211a89197754$export$fe7085456138f0fc);
$parcel$export(module.exports, "useIssueContextStoreViewMode", () => $c495211a89197754$export$c339e36468c12443);
$parcel$export(module.exports, "useIssueContextStoreBackButtonUrl", () => $c495211a89197754$export$ef3bfa2642bb98cd);
$parcel$export(module.exports, "useIssueContextStoreIssueNavigatorData", () => $c495211a89197754$export$8accd063c74cd455);
$parcel$export(module.exports, "useIssueContextStoreBoardId", () => $c495211a89197754$export$e7edffc2a20027e7);
$parcel$export(module.exports, "useIssueContextStoreBoardType", () => $c495211a89197754$export$48aaa3a6bc2085d7);
$parcel$export(module.exports, "useIssueContextStoreIsSpaEnabled", () => $c495211a89197754$export$4a4b96bcf5166327);
$parcel$export(module.exports, "useIssueContextStoreLoginRedirctUrl", () => $c495211a89197754$export$bbd8ba0180545556);
$parcel$export(module.exports, "useIssueContextStoreOnIssueKeyChange", () => $c495211a89197754$export$aaa89627762c7d00);
$parcel$export(module.exports, "useIssueContextStoreRapidViewId", () => $c495211a89197754$export$796589b0ec52848a);
$parcel$export(module.exports, "useIssueContextIsAiOptInEnabled", () => $c495211a89197754$export$7e70ee570119a0a7);
$parcel$export(module.exports, "IssueContextContainer", () => $c495211a89197754$export$93db6a8f3342dddf);
$parcel$export(module.exports, "useIssueContextStoreActions", () => $c495211a89197754$export$965360ae27fcae98);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $6vrw7 = parcelRequire("6vrw7");

var $8d785 = parcelRequire("8d785");

var $hHM8F = parcelRequire("hHM8F");

var $fhgeS = parcelRequire("fhgeS");
const $c495211a89197754$export$d4c72bab9d6cc13a = {
    childIssuesLimit: undefined,
    childIssuesIssueLimitUrls: undefined,
    issueKey: (0, $6vrw7.toIssueKey)(''),
    isArchived: false,
    isClassifyEditEnabled: false,
    isModal: false,
    maxTokenLength: 0,
    isLoadedWithPage: false,
    rapidViewMap: undefined,
    estimationStatistic: undefined,
    isLoading: false,
    // initialise viewMode with the value stored in local storage
    viewMode: (0, $fhgeS.getViewModeFromLocalStorage)(),
    analyticsSource: undefined,
    backButtonUrl: undefined,
    issueNavigatorData: undefined,
    boardId: undefined,
    boardType: undefined,
    isSpaEnabled: false,
    loginRedirectUrl: undefined,
    onIssueKeyChange: undefined,
    rapidViewId: undefined,
    viewScreenId: undefined,
    isAiOptInEnabled: false
};
const $c495211a89197754$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'issue-context',
    initialState: $c495211a89197754$export$d4c72bab9d6cc13a,
    actions: $8d785.actions
});
const $c495211a89197754$var$getIssueContext = (state)=>state;
const $c495211a89197754$var$getIsModal = (state)=>state.isModal;
const $c495211a89197754$var$getIssueKey = (state)=>state.issueKey;
const $c495211a89197754$var$getIsArchived = (state)=>state.isArchived;
const $c495211a89197754$var$getIsClassifyEditEnabled = (state)=>state.isClassifyEditEnabled;
const $c495211a89197754$var$getIssueId = (state)=>state.issueId;
// @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
const $c495211a89197754$var$getAnalyticsSource = (state)=>state.analyticsSource !== undefined ? state.analyticsSource : undefined;
const $c495211a89197754$var$getRapidViewMap = (state)=>state.rapidViewMap;
const $c495211a89197754$var$getMaxTokenLength = (state)=>state.maxTokenLength;
const $c495211a89197754$var$getIsLoadedWithPage = (state)=>state.isLoadedWithPage;
const $c495211a89197754$var$getEstimationStatistic = (state)=>state.estimationStatistic;
const $c495211a89197754$var$getIsLoading = (state)=>state.isLoading;
const $c495211a89197754$var$getViewMode = (state)=>state.viewMode;
const $c495211a89197754$var$getBackButtonUrl = (state)=>state.backButtonUrl;
const $c495211a89197754$var$getIssueNavigatorData = (state)=>state.issueNavigatorData;
const $c495211a89197754$var$getBoardId = (state)=>state.boardId;
const $c495211a89197754$var$getBoardType = (state)=>state.boardType;
const $c495211a89197754$var$getIsSpaEnabled = (state)=>state.isSpaEnabled;
const $c495211a89197754$var$getLoginRedirectUrl = (state)=>state.loginRedirectUrl;
const $c495211a89197754$var$getOnIssueKeyChange = (state)=>state.onIssueKeyChange;
const $c495211a89197754$var$getRapidViewId = (state)=>state.rapidViewId;
const $c495211a89197754$var$getViewScreenId = (state)=>state.viewScreenId;
const $c495211a89197754$var$getIsAiOptInEnabled = (state)=>Boolean(state.isAiOptInEnabled);
const $c495211a89197754$export$f6e0a3ee03299fbc = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIssueContext
});
const $c495211a89197754$export$abdbea56d86b4aac = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: (0, $hHM8F.getChildIssuesLimit)
});
const $c495211a89197754$export$326ff2b963d51c5c = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: (0, $hHM8F.getChildIssuesIssueLimitUrls)
});
const $c495211a89197754$export$44bcaaabb74e402b = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIssueKey
});
const $c495211a89197754$export$332dcee0cf9f4e45 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIssueId
});
const $c495211a89197754$export$c940355b1fc6e1c4 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsArchived
});
const $c495211a89197754$export$b9eebaa1da421997 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsClassifyEditEnabled
});
const $c495211a89197754$export$daa47fd600e43a32 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsModal
});
const $c495211a89197754$export$ba2e9546ab5ba6f = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getViewScreenId
});
const $c495211a89197754$export$74d38d6c437efc1b = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getAnalyticsSource
});
const $c495211a89197754$export$2092528ee170d9e7 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getRapidViewMap
});
const $c495211a89197754$export$57898374e6239a5a = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getMaxTokenLength
});
const $c495211a89197754$export$ff0264ec4c015dc1 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsLoadedWithPage
});
const $c495211a89197754$export$6c8b81f6dca8c23d = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getEstimationStatistic
});
const $c495211a89197754$export$fe7085456138f0fc = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsLoading
});
const $c495211a89197754$export$c339e36468c12443 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getViewMode
});
const $c495211a89197754$export$ef3bfa2642bb98cd = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getBackButtonUrl
});
const $c495211a89197754$export$8accd063c74cd455 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIssueNavigatorData
});
const $c495211a89197754$export$e7edffc2a20027e7 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getBoardId
});
const $c495211a89197754$export$48aaa3a6bc2085d7 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getBoardType
});
const $c495211a89197754$export$4a4b96bcf5166327 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsSpaEnabled
});
const $c495211a89197754$export$bbd8ba0180545556 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getLoginRedirectUrl
});
const $c495211a89197754$export$aaa89627762c7d00 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getOnIssueKeyChange
});
const $c495211a89197754$export$796589b0ec52848a = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getRapidViewId
});
const $c495211a89197754$export$7e70ee570119a0a7 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: $c495211a89197754$var$getIsAiOptInEnabled
});
const $c495211a89197754$export$93db6a8f3342dddf = (0, $heB5U.createContainer)($c495211a89197754$export$6f57813fe9f31bf9);
const $c495211a89197754$export$965360ae27fcae98 = (0, $ggKAj.createHook)($c495211a89197754$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("8d785", function(module, exports) {

$parcel$export(module.exports, "actions", () => $0a3f8ba487c482e8$export$e324594224ef24da);

var $7LyiF = parcelRequire("7LyiF");

var $hHM8F = parcelRequire("hHM8F");


var $fhgeS = parcelRequire("fhgeS");
const $0a3f8ba487c482e8$export$784a03c4b74da53e = (issueContext)=>({ setState: setState, getState: getState })=>{
        const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
        // ARKEN-792: reset issueId on issueKey change if issueId isn't provided
        if (currentIssueId && currentIssueKey && !issueContext.issueId && issueContext.issueKey !== currentIssueKey) setState({
            ...issueContext,
            issueId: undefined,
            viewMode: issueContext.viewMode || getState().viewMode
        });
        else setState({
            ...issueContext,
            viewMode: issueContext.viewMode || getState().viewMode
        });
    };
const $0a3f8ba487c482e8$export$666ee48e0eaf4f13 = (partialIssueContext)=>({ getState: getState, setState: setState })=>{
        const { issueKey: currentIssueKey, issueId: currentIssueId } = getState();
        // ARKEN-792: reset issueId on issueKey change if issueId isn't provided
        if (currentIssueId && currentIssueKey && !partialIssueContext.issueId && partialIssueContext.issueKey && partialIssueContext.issueKey !== currentIssueKey) setState({
            ...getState(),
            ...partialIssueContext,
            issueId: undefined
        });
        else setState({
            ...getState(),
            ...partialIssueContext
        });
    };
const $0a3f8ba487c482e8$export$89b6937a83edcaa6 = ()=>({ getState: getState })=>(0, $hHM8F.getChildIssuesLimit)(getState());
const $0a3f8ba487c482e8$export$e40f2acaf1a50b00 = ()=>({ getState: getState })=>getState().maxTokenLength;
const $0a3f8ba487c482e8$export$2fe981b90be13483 = ()=>({ getState: getState })=>getState().isLoadedWithPage;
const $0a3f8ba487c482e8$export$afce556782490aae = ()=>({ getState: getState })=>getState().backButtonUrl;
const $0a3f8ba487c482e8$export$711dfa096bf81f2d = ()=>({ getState: getState })=>getState().isSpaEnabled;
const $0a3f8ba487c482e8$export$4a030f6192bebe03 = ()=>({ getState: getState })=>getState().issueKey;
const $0a3f8ba487c482e8$export$b41341ac6c74ca6 = ()=>({ getState: getState })=>getState().isArchived;
const $0a3f8ba487c482e8$export$77ec0de2f63f10c4 = (willSave = true)=>({ setState: setState })=>{
        if (willSave) (0, $7LyiF.localStorage).set((0, $7LyiF.VIEW_MODE_STORAGE_KEY), (0, $935e771f19f8ea28$export$98c0ebc22792f04));
        setState({
            viewMode: (0, $935e771f19f8ea28$export$98c0ebc22792f04)
        });
    };
const $0a3f8ba487c482e8$export$b303af51de56a0e = (willSave = true)=>({ setState: setState })=>{
        if (willSave) (0, $7LyiF.localStorage).set((0, $7LyiF.VIEW_MODE_STORAGE_KEY), (0, $935e771f19f8ea28$export$705305d6da432040));
        setState({
            viewMode: (0, $935e771f19f8ea28$export$705305d6da432040)
        });
    };
const $0a3f8ba487c482e8$export$75007d125f198b78 = ()=>({ setState: setState })=>{
        setState({
            viewMode: (0, $fhgeS.getViewModeFromLocalStorage)()
        });
    };
const $0a3f8ba487c482e8$export$e324594224ef24da = {
    setIssueContext: $0a3f8ba487c482e8$export$784a03c4b74da53e,
    mergeIssueContext: $0a3f8ba487c482e8$export$666ee48e0eaf4f13,
    getChildIssuesLimit: $0a3f8ba487c482e8$export$89b6937a83edcaa6,
    getMaxTokenLength: $0a3f8ba487c482e8$export$e40f2acaf1a50b00,
    getIsLoadedWithPage: $0a3f8ba487c482e8$export$2fe981b90be13483,
    getBackButtonUrl: $0a3f8ba487c482e8$export$afce556782490aae,
    getIsSpaEnabled: $0a3f8ba487c482e8$export$711dfa096bf81f2d,
    getIssueKey: $0a3f8ba487c482e8$export$4a030f6192bebe03,
    getIsArchived: $0a3f8ba487c482e8$export$b41341ac6c74ca6,
    setDetailViewAsModal: $0a3f8ba487c482e8$export$77ec0de2f63f10c4,
    setDetailViewAsSidebar: $0a3f8ba487c482e8$export$b303af51de56a0e,
    resetDetailView: $0a3f8ba487c482e8$export$75007d125f198b78
};

});
parcelRegister("7LyiF", function(module, exports) {

$parcel$export(module.exports, "LOG_LOCATION", () => $7643f341d271ccc9$export$25a759e49d5049db);
$parcel$export(module.exports, "localStorage", () => $7643f341d271ccc9$export$c2ed3351cac403d1);
$parcel$export(module.exports, "VIEW_MODE_STORAGE_KEY", () => $7643f341d271ccc9$export$a13f7f627010bccd);

var $aZaPn = parcelRequire("aZaPn");
const $7643f341d271ccc9$export$25a759e49d5049db = 'issue.issue-context-service';
const $7643f341d271ccc9$export$c2ed3351cac403d1 = (0, $aZaPn.createLocalStorageProvider)('jira_issue_view');
const $7643f341d271ccc9$export$a13f7f627010bccd = 'view-mode';

});

parcelRegister("hHM8F", function(module, exports) {

$parcel$export(module.exports, "getChildIssuesLimit", () => $a9a8c93b5bcca8ab$export$89b6937a83edcaa6);
$parcel$export(module.exports, "getChildIssuesIssueLimitUrls", () => $a9a8c93b5bcca8ab$export$8f43520910e8128c);

var $gUUjF = parcelRequire("gUUjF");

var $7LyiF = parcelRequire("7LyiF");
// This is here solely as a last resort option if the backend for some reason
// is unable to propagate the limit. Or if somehow the code that populates
// this store is broken.
// 500 is the current limit reflected in the backend at the time of writing.
const $a9a8c93b5bcca8ab$var$FALLBACK_CHILD_ISSUES_LIMIT = 500;
const $a9a8c93b5bcca8ab$var$getFallbackChildIssuesLimitAndLogAsUnexpected = ()=>{
    (0, $gUUjF.default).safeErrorWithoutCustomerData(`${(0, $7LyiF.LOG_LOCATION)}.selectors.getChildIssuesLimit`, 'The child issues limit is undefined using the fallback child issues limit');
    return $a9a8c93b5bcca8ab$var$FALLBACK_CHILD_ISSUES_LIMIT;
};
const $a9a8c93b5bcca8ab$export$89b6937a83edcaa6 = (state)=>state.childIssuesLimit ?? $a9a8c93b5bcca8ab$var$getFallbackChildIssuesLimitAndLogAsUnexpected();
const $a9a8c93b5bcca8ab$export$8f43520910e8128c = (state)=>state.childIssuesIssueLimitUrls;

});

const $935e771f19f8ea28$export$98c0ebc22792f04 = 'MODAL';
const $935e771f19f8ea28$export$705305d6da432040 = 'SIDEBAR';
const $935e771f19f8ea28$export$2d037fdba4f67558 = 'DEFAULT';
const $935e771f19f8ea28$export$8bcece6b344db0b9 = 'FIELD';
const $935e771f19f8ea28$export$f65dd83d96b675ee = 'DEV_SUMMARY';
const $935e771f19f8ea28$export$971ccedc18d35178 = 'RELEASES_PANEL';
const $935e771f19f8ea28$export$18e4c648db363204 = 'PANEL';
const $935e771f19f8ea28$export$7f66491e43ca5015 = 'TAB';

parcelRegister("fhgeS", function(module, exports) {

$parcel$export(module.exports, "getViewModeFromLocalStorage", () => $49ad189ccd6ad8c9$export$cae7c4c591dcc261);

var $7LyiF = parcelRequire("7LyiF");

const $49ad189ccd6ad8c9$export$cae7c4c591dcc261 = ()=>(0, $7LyiF.localStorage).get((0, $7LyiF.VIEW_MODE_STORAGE_KEY)) || (0, $935e771f19f8ea28$export$2d037fdba4f67558);

});




const $815b5650076b1618$export$b8b9d90f9e5bd72b = 'jira-enforce-storage-limits';
const $815b5650076b1618$export$8f56a4ad6e1486ea = 10;
const $815b5650076b1618$export$ed785d2382d0101d = 'lastStorageEnforcement';

parcelRegister("7YYuY", function(module, exports) {

$parcel$export(module.exports, "localStorage", () => $79189cfebd980a86$export$c2ed3351cac403d1);

var $aZaPn = parcelRequire("aZaPn");
const $79189cfebd980a86$export$c2ed3351cac403d1 = (0, $aZaPn.createLocalStorageProvider)('enforce-storage-limits');

});


parcelRegister("jb6Pg", function(module, exports) {

$parcel$export(module.exports, "UiModificationsContainer", () => $4882128396b2131f$export$1834060b93715de7);

var $eUqFw = parcelRequire("eUqFw");

var $5JgCW = parcelRequire("5JgCW");

var $bKI0B = parcelRequire("bKI0B");
const $4882128396b2131f$export$1834060b93715de7 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5JgCW.BaseUiModificationsContainer), {
        scope: (0, $bKI0B.GIC_VIEW_TYPE),
        viewType: (0, $bKI0B.GIC_VIEW_TYPE)
    }, children);

});
parcelRegister("5JgCW", function(module, exports) {

$parcel$export(module.exports, "BaseUiModificationsContainer", () => $63c993e842f182d8$export$8b7a045f60eb9797);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $ig7wC = parcelRequire("ig7wC");

var $aCsSk = parcelRequire("aCsSk");
const $63c993e842f182d8$export$8b7a045f60eb9797 = ({ children: children, scope: scope, viewType: viewType })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aCsSk.LoadedUiModificationsContainer), {
        scope: scope,
        viewType: viewType,
        createAnalyticsEvent: createAnalyticsEvent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ig7wC.UiModificationContextContainer), {
        scope: scope
    }, children));
};

});
parcelRegister("aCsSk", function(module, exports) {

$parcel$export(module.exports, "LoadedUiModificationsContainer", () => $dc8f196226ca6983$export$b087a12fbb84e8ac);

var $heB5U = parcelRequire("heB5U");

var $fcNlw = parcelRequire("fcNlw");
const $dc8f196226ca6983$export$b087a12fbb84e8ac = (0, $heB5U.createContainer)((0, $fcNlw.store), {
    displayName: 'LoadedUiModificationsContainer',
    onInit: ()=>({ setState: setState }, { viewType: viewType })=>{
            setState({
                viewType: viewType
            });
        }
});

});
parcelRegister("fcNlw", function(module, exports) {

$parcel$export(module.exports, "store", () => $712150835f54079d$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustedField", () => $712150835f54079d$export$df4b0714e8177e0e);
$parcel$export(module.exports, "useAnalyticsData", () => $712150835f54079d$export$45885672916a1436);
$parcel$export(module.exports, "useIssueAdjustmentsActions", () => $712150835f54079d$export$cb9a014ec14556d8);
$parcel$export(module.exports, "useAdjustedScreenTabs", () => $712150835f54079d$export$677b3e34bd14c681);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $1ybV0 = parcelRequire("1ybV0");
parcelRequire("B0Z3S");
var $lpNv8 = parcelRequire("lpNv8");
var $B0Z3S = parcelRequire("B0Z3S");
var $fxgW1 = parcelRequire("fxgW1");
var $9V8vn = parcelRequire("9V8vn");
var $5hhPg = parcelRequire("5hhPg");
var $4BYh6 = parcelRequire("4BYh6");
var $5v1Sk = parcelRequire("5v1Sk");
var $doolD = parcelRequire("doolD");
var $4QLO7 = parcelRequire("4QLO7");
var $3P2qm = parcelRequire("3P2qm");
var $lpNv8 = parcelRequire("lpNv8");
var $7mVyC = parcelRequire("7mVyC");
var $b2p8u = parcelRequire("b2p8u");
var $gwHjs = parcelRequire("gwHjs");
var $juRVB = parcelRequire("juRVB");
var $cQ3jb = parcelRequire("cQ3jb");
var $2ugNi = parcelRequire("2ugNi");
var $51sNT = parcelRequire("51sNT");
const $712150835f54079d$var$name = 'issue-adjustments';
const $712150835f54079d$export$d4c72bab9d6cc13a = {
    formData: null,
    screenTabs: null,
    appliedChanges: null,
    error: null,
    analyticsData: {},
    registeredFieldsDeprecated: {},
    registeredFields: {},
    triggerFieldInitializationKey: 0,
    // Selector checks if this is not equal 0 in the useFieldReady
    numberOfSupportedFields: 0,
    internalFormMetadata: {},
    viewType: null,
    experienceDataIsLoading: false,
    buffer: {},
    bufferTimeouts: {},
    bufferErrors: null,
    lastProcessedChange: null,
    fieldsInitialization: {
        startTime: null,
        timeoutId: undefined,
        status: 'notStarted'
    },
    appsErrors: {}
};
// triggerFieldInitializationKey, viewType and numberOfSupportedFields should not be reset on project or issue type change
const { triggerFieldInitializationKey: $712150835f54079d$var$triggerFieldInitializationKey, viewType: $712150835f54079d$var$scopedViewType, numberOfSupportedFields: $712150835f54079d$var$numberOfSupportedFields, ...$712150835f54079d$var$stateForResetAllFields } = $712150835f54079d$export$d4c72bab9d6cc13a;
const $712150835f54079d$var$multiAppsBufferingActions = {
    bufferChanges: $B0Z3S.bufferChanges,
    bufferTimeout: $B0Z3S.bufferTimeout,
    handleBufferAllAppsError: $fxgW1.handleBufferAllAppsError,
    sendBufferFinalMetrics: $b2p8u.sendBufferFinalMetrics,
    sendBufferConflictMetrics: $b2p8u.sendBufferConflictMetrics,
    initializeOnInitBuffer: $B0Z3S.initializeOnInitBuffer,
    clearAllBufferTimeouts: $9V8vn.clearAllBufferTimeouts,
    clearBufferForChangeId: $9V8vn.clearBufferForChangeId,
    addBufferError: $lpNv8.addBufferError,
    resetBufferErrors: $lpNv8.resetBufferErrors
};
const $712150835f54079d$export$e324594224ef24da = {
    triggerFieldInitialization: ()=>({ getState: getState, setState: setState })=>{
            setState({
                triggerFieldInitializationKey: getState().triggerFieldInitializationKey + 1
            });
        },
    processChange: $5v1Sk.processChange,
    setFieldValue: $gwHjs.setFieldValue,
    initializeField: $5hhPg.initializeField,
    startFieldsInitialisationTimeout: $juRVB.startFieldsInitialisationTimeout,
    successFieldsInitalisation: $juRVB.successFieldsInitalisation,
    ...$712150835f54079d$var$multiAppsBufferingActions,
    registerFields: $4QLO7.registerFields,
    unregisterFields: $4QLO7.unregisterFields,
    unregisterAllFieldsOfChangeId: $4QLO7.unregisterAllFieldsOfChangeId,
    processIframeChanges: $doolD.processIframeChanges,
    updateFields: $2ugNi.updateFields,
    clearAppliedValue: (fieldId)=>({ setState: setState, getState: getState })=>{
            const previousState = getState().appliedChanges || {};
            if (previousState[fieldId]) {
                const { value: value, ...otherFieldChanges } = previousState[fieldId];
                setState({
                    appliedChanges: {
                        ...previousState,
                        [fieldId]: otherFieldChanges
                    }
                });
            }
        },
    resetAllFields: ()=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
            // Clear the fieldsInitialization timeout to avoid potetianl side effects.
            clearTimeout(getState().fieldsInitialization.timeoutId);
            if ((0, $1ybV0.ff)('ui-modifications-multi-app-experience_ud4yw')) dispatch((0, $9V8vn.clearAllBufferTimeouts)());
            setState($712150835f54079d$var$stateForResetAllFields);
        },
    setError: $7mVyC.setError,
    resetError: $7mVyC.resetError,
    setAnalyticsData: (analyticsData)=>({ setState: setState, getState: getState })=>{
            const previousState = getState().analyticsData ?? {};
            setState({
                analyticsData: {
                    ...previousState,
                    ...analyticsData
                }
            });
        },
    setNumberOfSupportedFields: (numberOfAllSupportedFields)=>({ setState: setState })=>{
            setState({
                numberOfSupportedFields: numberOfAllSupportedFields
            });
        },
    /**
	 * This is used to block onInit for specific case like Issue View background refresh loading.
	 */ setExperienceDataIsLoading: (experienceDataIsLoading)=>({ setState: setState })=>{
            setState({
                experienceDataIsLoading: experienceDataIsLoading
            });
        },
    setAppErrors: $3P2qm.setAppErrors,
    resetAppErrors: $3P2qm.resetAppErrors,
    initializeScreenTabs: $4BYh6.initializeScreenTabs,
    updateScreenTabs: $51sNT.updateScreenTabs,
    updateActiveScreenTab: $cQ3jb.updateActiveScreenTab
};
const $712150835f54079d$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: $712150835f54079d$var$name,
    initialState: $712150835f54079d$export$d4c72bab9d6cc13a,
    actions: $712150835f54079d$export$e324594224ef24da
});
const $712150835f54079d$export$37792a602e748c08 = (0, $ggKAj.createHook)($712150835f54079d$export$6f57813fe9f31bf9);
const $712150835f54079d$var$stableEmptyFieldFromIframe = {};
const $712150835f54079d$export$df4b0714e8177e0e = (0, $ggKAj.createHook)($712150835f54079d$export$6f57813fe9f31bf9, {
    selector: (state, fieldId)=>state.appliedChanges?.[fieldId] || $712150835f54079d$var$stableEmptyFieldFromIframe
});
const $712150835f54079d$export$45885672916a1436 = (0, $ggKAj.createHook)($712150835f54079d$export$6f57813fe9f31bf9, {
    selector: (state)=>state.analyticsData
});
const $712150835f54079d$export$cb9a014ec14556d8 = (0, $ggKAj.createActionsHook)($712150835f54079d$export$6f57813fe9f31bf9);
const $712150835f54079d$export$677b3e34bd14c681 = (0, $ggKAj.createHook)($712150835f54079d$export$6f57813fe9f31bf9, {
    selector: (state)=>state.screenTabs
});

});
parcelRegister("B0Z3S", function(module, exports) {

$parcel$export(module.exports, "bufferChanges", () => $eb7ae82fbbeb5c60$export$15f16f4bde8a8eea);
$parcel$export(module.exports, "bufferTimeout", () => $eb7ae82fbbeb5c60$export$ada544fa4df33ac7);
$parcel$export(module.exports, "initializeOnInitBuffer", () => $eb7ae82fbbeb5c60$export$496162694df22caf);
$parcel$export(module.exports, "addBufferError", () => (parcelRequire("lpNv8")).addBufferError);
$parcel$export(module.exports, "handleBufferAllAppsError", () => (parcelRequire("fxgW1")).handleBufferAllAppsError);

var $1ybV0 = parcelRequire("1ybV0");

var $2bv99 = parcelRequire("2bv99");

var $gA4iv = parcelRequire("gA4iv");

var $7mVyC = parcelRequire("7mVyC");

var $kjZtG = parcelRequire("kjZtG");

var $ke5CN = parcelRequire("ke5CN");

var $9V8vn = parcelRequire("9V8vn");

var $fxgW1 = parcelRequire("fxgW1");

var $lpNv8 = parcelRequire("lpNv8");

var $b2p8u = parcelRequire("b2p8u");

var $3Oj61 = parcelRequire("3Oj61");
const $eb7ae82fbbeb5c60$export$b181ece3dc0959e0 = 10000;
const $eb7ae82fbbeb5c60$var$getMultiAppBufferingTimeoutMs = ()=>(0, $1ybV0.getFeatureFlagValue)('forge-ui-modifications-multi-app-buffer-timeout', $eb7ae82fbbeb5c60$export$b181ece3dc0959e0);
const $eb7ae82fbbeb5c60$export$15f16f4bde8a8eea = ({ changeId: changeId, appId: appId, fieldsChanges: fieldsChanges, context: context })=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { buffer: buffer, bufferTimeouts: bufferTimeouts } = getState();
        const previousBuffer = buffer[changeId] || {};
        const previousAppBuffer = previousBuffer[appId] || {};
        const bufferForChangeId = {
            ...previousBuffer,
            [appId]: {
                ...previousAppBuffer,
                ...fieldsChanges
            }
        };
        if ((0, $ke5CN.changesReadyToApply)(bufferForChangeId)) {
            clearTimeout(bufferTimeouts[changeId]);
            try {
                await dispatch((0, $kjZtG.validateNoConflictAndApply)(bufferForChangeId, changeId, context));
            } catch (err) {
                dispatch((0, $fxgW1.handleBufferAllAppsError)({
                    err: err,
                    changeId: changeId,
                    bufferForChangeId: bufferForChangeId
                }));
            }
        } else setState({
            buffer: {
                ...buffer,
                [changeId]: bufferForChangeId
            }
        });
        if (bufferTimeouts[changeId] === undefined) {
            const timeout = setTimeout(async ()=>{
                try {
                    await dispatch($eb7ae82fbbeb5c60$export$ada544fa4df33ac7(changeId, context));
                } catch (err) {
                    dispatch((0, $fxgW1.handleBufferAllAppsError)({
                        err: err,
                        changeId: changeId,
                        bufferForChangeId: bufferForChangeId
                    }));
                }
            }, $eb7ae82fbbeb5c60$var$getMultiAppBufferingTimeoutMs());
            setState({
                bufferTimeouts: {
                    ...bufferTimeouts,
                    [changeId]: timeout
                }
            });
        }
    };
const $eb7ae82fbbeb5c60$export$ada544fa4df33ac7 = (changeId, context)=>async ({ getState: getState, dispatch: dispatch }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
        const { buffer: buffer, bufferErrors: bufferErrors } = getState();
        const bufferForChangeId = buffer[changeId] || {};
        const appsWithTimeout = (0, $3Oj61.findAppsWhichDidNotSendChangesBeforeTimeout)(bufferForChangeId);
        if (appsWithTimeout.length) {
            // display timeout flag only if other buffering errors did not appear previously to the user
            if (bufferErrors === null) dispatch((0, $7mVyC.setError)({
                errorCode: 'BUFFERING_TIMEOUT'
            }));
            dispatch((0, $lpNv8.addBufferError)('BUFFERING_TIMEOUT'));
            (0, $2bv99.fireOperationalAnalyticsWithContext)(createAnalyticsEvent({}), 'buffer timeout', viewType, {
                changeId: changeId,
                allAppIds: Object.keys(bufferForChangeId).join(),
                timedOutAppIds: appsWithTimeout.join()
            });
        }
        await dispatch((0, $kjZtG.validateNoConflictAndApply)(bufferForChangeId, changeId, context));
    };
const $eb7ae82fbbeb5c60$export$496162694df22caf = (appsIds)=>({ setState: setState, getState: getState })=>{
        const { buffer: buffer } = getState();
        const bufferForOnInit = {};
        appsIds.forEach((appId)=>{
            bufferForOnInit[appId] = null;
        });
        setState({
            buffer: {
                ...buffer,
                [(0, $gA4iv.ON_INIT_CHANGE_ID)]: bufferForOnInit
            }
        });
    };

});
parcelRegister("2bv99", function(module, exports) {

$parcel$export(module.exports, "fireOperationalAnalyticsWithoutContext", () => $9bb7bb1bc373c32d$export$92f0a000de1dacb3);
$parcel$export(module.exports, "fireOperationalAnalyticsWithContext", () => $9bb7bb1bc373c32d$export$5ac7b3728975936c);
// jira-frontend/browse/src/packages/platform/observability/product-analytics-bridge/README.md#Tracking outside of UI

var $jMP2a = parcelRequire("jMP2a");

var $3DOEL = parcelRequire("3DOEL");
const $9bb7bb1bc373c32d$export$92f0a000de1dacb3 = (actionSubject, action, viewType, attributes = {})=>(0, $3DOEL.getAnalyticsWebClient)().getInstance().sendOperationalEvent({
        action: action,
        actionSubject: `jiraUiModifications.${actionSubject}`,
        source: viewType,
        attributes: {
            ...attributes,
            viewType: viewType
        }
    });
const $9bb7bb1bc373c32d$export$5ac7b3728975936c = (event, id, viewType, attributes = {})=>{
    (0, $jMP2a.fireOperationalAnalytics)(event, `jiraUiModifications.${id}`, {
        ...attributes,
        viewType: viewType
    });
};

});

parcelRegister("gA4iv", function(module, exports) {

$parcel$export(module.exports, "ON_INIT_CHANGE_ID", () => $7e6df3ec5ab54baa$export$415cc1afa6445f90);
/**
 * @atlassian/jira-issue-create is still using the constants from the current issue-adjustments
 * package, this dependency should be removed in further cyclic deps fix
 */ // eslint-disable-next-line jira/export/no-external-exports

const $7e6df3ec5ab54baa$export$415cc1afa6445f90 = 'onInitChangeId';

});

parcelRegister("7mVyC", function(module, exports) {

$parcel$export(module.exports, "setError", () => $dfad354765909d34$export$b8d0bb2aa0adefe5);
$parcel$export(module.exports, "resetError", () => $dfad354765909d34$export$7e5930c6217b1d4e);
const $dfad354765909d34$export$b8d0bb2aa0adefe5 = (errorProperties)=>({ setState: setState })=>{
        setState({
            error: {
                errorCode: errorProperties.errorCode,
                fieldName: errorProperties.fieldName
            }
        });
    };
const $dfad354765909d34$export$7e5930c6217b1d4e = ()=>({ setState: setState })=>{
        setState({
            error: null
        });
    };

});

parcelRegister("kjZtG", function(module, exports) {

$parcel$export(module.exports, "validateNoConflictAndApply", () => $dc51ceae4b610127$export$7c7bcb610d80b592);

var $2bv99 = parcelRequire("2bv99");

var $fsCiP = parcelRequire("fsCiP");

var $3P2qm = parcelRequire("3P2qm");

var $7mVyC = parcelRequire("7mVyC");

var $4QLO7 = parcelRequire("4QLO7");

var $2ugNi = parcelRequire("2ugNi");

var $9V8vn = parcelRequire("9V8vn");

var $lpNv8 = parcelRequire("lpNv8");

var $b2p8u = parcelRequire("b2p8u");

var $3Oj61 = parcelRequire("3Oj61");
const $dc51ceae4b610127$export$7c7bcb610d80b592 = (bufferForChangeId, changeId, context)=>async ({ dispatch: dispatch }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
        const conflicts = (0, $3Oj61.getConflicts)({
            bufferForChangeId: bufferForChangeId
        });
        const applyBufferedChangesSequentially = async ()=>{
            for (const [appId, fieldsChanges] of Object.entries(bufferForChangeId))if (fieldsChanges !== null) // In general await should not be used inside loops, because it changes parallel processing
            // of promises to sequential. In our case sequential processing is desired.
            // Without it, 2nd buffered app changes override 1st buffered app changes.
            // With sequential processing, appliedChanges are saved in UIM store before next changes are processed.
            // eslint-disable-next-line no-await-in-loop
            await applyAppChanges(fieldsChanges, appId);
        };
        const applyAppChanges = async (fieldsChanges, appId)=>{
            const { cloudId: cloudId, activationId: activationId, issueId: issueId, environment: environment, getAsyncLookupData: getAsyncLookupData, transitionId: transitionId } = context;
            const lookupDataFromApi = await getAsyncLookupData(fieldsChanges);
            try {
                await dispatch((0, $2ugNi.updateFields)({
                    changeId: changeId,
                    fieldsChanges: fieldsChanges,
                    lookupDataFromApi: lookupDataFromApi,
                    tenantContext: {
                        cloudId: cloudId,
                        activationId: activationId
                    },
                    viewContext: {
                        issueId: issueId,
                        transitionId: transitionId
                    },
                    environment: environment,
                    appId: appId
                }));
            } catch (err) {
                if (err instanceof (0, $fsCiP.UiModificationsFieldsValidationError)) {
                    (0, $2bv99.fireOperationalAnalyticsWithContext)(createAnalyticsEvent({}), 'fieldsChangesValidation failed', viewType, {
                        ...err.attributes
                    });
                    dispatch((0, $7mVyC.setError)({
                        errorCode: 'APPLY_BUFFER_CHANGES_ERROR'
                    }));
                    dispatch((0, $lpNv8.addBufferError)('APPLY_BUFFER_CHANGES_ERROR'));
                    // Setting app errors from transformers to pass them to the onErrorCallback
                    dispatch((0, $3P2qm.setAppErrors)({
                        errors: err.attributes.errors,
                        appId: appId
                    }));
                    return;
                }
                throw err;
            } finally{
                dispatch((0, $4QLO7.unregisterFields)({
                    changeId: changeId,
                    appId: appId
                }));
            }
        };
        if (Object.keys(conflicts).length > 0) {
            dispatch((0, $7mVyC.setError)({
                errorCode: 'MULTI_APP_CONFLICT'
            }));
            dispatch((0, $lpNv8.addBufferError)('MULTI_APP_CONFLICT'));
            dispatch((0, $b2p8u.sendBufferConflictMetrics)(changeId, bufferForChangeId, conflicts));
            dispatch((0, $lpNv8.setAppConflictErrors)(changeId, bufferForChangeId, conflicts));
        } else {
            await applyBufferedChangesSequentially();
            dispatch((0, $b2p8u.sendBufferFinalMetrics)(changeId, bufferForChangeId));
        }
        dispatch((0, $4QLO7.unregisterAllFieldsOfChangeId)(changeId));
        dispatch((0, $9V8vn.clearBufferForChangeId)({
            changeId: changeId
        }));
        dispatch((0, $lpNv8.resetBufferErrors)());
    };

});
parcelRegister("fsCiP", function(module, exports) {

$parcel$export(module.exports, "FIELD_VALIDATION_ERROR", () => $b179e025ecadff0b$export$d1996cb46a690190);
$parcel$export(module.exports, "UiModificationsFieldsValidationError", () => $b179e025ecadff0b$export$9e8b5e552e255163);
const $b179e025ecadff0b$export$d1996cb46a690190 = 'FIELD_VALIDATION_FAILED';
class $b179e025ecadff0b$export$9e8b5e552e255163 extends Error {
    constructor(message, attributes, cause){
        super(message, cause);
        this.attributes = attributes;
    }
}

});

parcelRegister("3P2qm", function(module, exports) {

$parcel$export(module.exports, "setAppErrors", () => $a351a7797518b436$export$7054e2f8e68cf0dd);
$parcel$export(module.exports, "resetAppErrors", () => $a351a7797518b436$export$24c821207687a907);
const $a351a7797518b436$export$7054e2f8e68cf0dd = ({ errors: errors, appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: errors
            }
        });
    };
const $a351a7797518b436$export$24c821207687a907 = ({ appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: null
            }
        });
    };

});

parcelRegister("4QLO7", function(module, exports) {

$parcel$export(module.exports, "registerFields", () => $745940e83e6bea58$export$d4eb181b231cf88d);
$parcel$export(module.exports, "unregisterFields", () => $745940e83e6bea58$export$1ca69a85bb7273de);
$parcel$export(module.exports, "unregisterAllFieldsOfChangeId", () => $745940e83e6bea58$export$973336095fd0befc);

var $kFGm5 = parcelRequire("kFGm5");

var $1ybV0 = parcelRequire("1ybV0");

var $59LUk = parcelRequire("59LUk");
const $745940e83e6bea58$export$c327a17109f9f677 = ({ nextRegisteredFields: nextRegisteredFields, changeId: changeId, buffer: buffer })=>{
    const currentBufferForChangeId = buffer[changeId] || {};
    const appsToBuffer = (0, $59LUk.findAppsToBufferForChangeId)({
        registeredFieldsMap: nextRegisteredFields,
        changeId: changeId
    });
    const bufferForChangeId = {};
    appsToBuffer.forEach((appIdToBuffer)=>{
        bufferForChangeId[appIdToBuffer] = null;
    });
    return {
        ...bufferForChangeId,
        ...currentBufferForChangeId
    };
};
const $745940e83e6bea58$var$registerFieldsFFOn = ({ getState: getState, setState: setState, changeId: changeId, appId: appId, fieldsToBeRegistered: fieldsToBeRegistered })=>{
    const { registeredFields: registeredFields, buffer: buffer } = getState();
    const appFields = registeredFields[appId] || {};
    const appChangeIdFields = appFields[changeId] || [];
    const nextRegisteredFields = {
        ...registeredFields,
        [appId]: {
            ...appFields,
            [changeId]: [
                ...appChangeIdFields,
                ...fieldsToBeRegistered
            ]
        }
    };
    const bufferForChangeId = $745940e83e6bea58$export$c327a17109f9f677({
        nextRegisteredFields: nextRegisteredFields,
        changeId: changeId,
        buffer: buffer
    });
    setState({
        registeredFields: {
            ...nextRegisteredFields
        },
        buffer: {
            ...buffer,
            ...Object.keys(bufferForChangeId).length && {
                [changeId]: bufferForChangeId
            }
        }
    });
};
const $745940e83e6bea58$export$d4eb181b231cf88d = ({ changeId: changeId, fieldsToBeRegistered: fieldsToBeRegistered, appId: appId })=>({ setState: setState, getState: getState })=>{
        if (!Array.isArray(fieldsToBeRegistered)) return;
        if ((0, $1ybV0.ff)('ui-modifications-multi-app-experience_ud4yw')) $745940e83e6bea58$var$registerFieldsFFOn({
            getState: getState,
            setState: setState,
            changeId: changeId,
            appId: appId,
            fieldsToBeRegistered: fieldsToBeRegistered
        });
        else {
            const alreadyRegisteredFields = getState().registeredFieldsDeprecated;
            setState({
                registeredFieldsDeprecated: {
                    ...alreadyRegisteredFields,
                    [changeId]: fieldsToBeRegistered
                }
            });
        }
    };
const $745940e83e6bea58$export$1ca69a85bb7273de = ({ changeId: changeId, appId: appId })=>({ setState: setState, getState: getState })=>{
        if ((0, $1ybV0.ff)('ui-modifications-multi-app-experience_ud4yw')) {
            const { registeredFields: registeredFields } = getState();
            const registeredAppFields = registeredFields[appId] || {};
            const nextRegisteredAppFields = (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(registeredAppFields, changeId);
            setState({
                registeredFields: {
                    ...registeredFields,
                    [appId]: nextRegisteredAppFields
                }
            });
        } else setState({
            registeredFieldsDeprecated: (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(getState().registeredFieldsDeprecated, changeId)
        });
    };
const $745940e83e6bea58$export$973336095fd0befc = (changeId)=>({ setState: setState, getState: getState })=>{
        const { registeredFields: registeredFields } = getState();
        const nextRegisteredFields = {};
        Object.entries(registeredFields).forEach(([appId, registeredAppFields])=>{
            if (registeredAppFields) nextRegisteredFields[appId] = (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(registeredAppFields, changeId);
        });
        setState({
            registeredFields: {
                ...nextRegisteredFields
            }
        });
    };

});
parcelRegister("59LUk", function(module, exports) {

$parcel$export(module.exports, "findAppsToBufferForChangeId", () => $8f338195a0adcdd4$export$69bf78514084d05f);
const $8f338195a0adcdd4$export$69bf78514084d05f = ({ registeredFieldsMap: registeredFieldsMap, changeId: changeId })=>{
    const fieldsRegisteredByApps = {};
    const appsToBuffer = new Set();
    Object.entries(registeredFieldsMap).forEach(([appId, appRegisteredFields])=>{
        const fields = appRegisteredFields?.[changeId];
        if (!fields) return;
        fields.forEach((fieldId)=>{
            if (fieldsRegisteredByApps[fieldId]) {
                fieldsRegisteredByApps[fieldId].add(appId);
                fieldsRegisteredByApps[fieldId].forEach((applicationId)=>appsToBuffer.add(applicationId));
            } else {
                fieldsRegisteredByApps[fieldId] = new Set();
                fieldsRegisteredByApps[fieldId].add(appId);
            }
        });
    });
    return appsToBuffer;
};

});


parcelRegister("2ugNi", function(module, exports) {

$parcel$export(module.exports, "updateFields", () => $0896ca7411360473$export$cceae62fd4d1ef0a);

var $8blac = parcelRequire("8blac");

var $1ybV0 = parcelRequire("1ybV0");

var $2bv99 = parcelRequire("2bv99");


var $7h8I4 = parcelRequire("7h8I4");
var $hGbVp = parcelRequire("hGbVp");
var $lB1pd = parcelRequire("lB1pd");

var $fsCiP = parcelRequire("fsCiP");

var $fUNS1 = parcelRequire("fUNS1");

var $7CbIv = parcelRequire("7CbIv");
const $0896ca7411360473$export$cceae62fd4d1ef0a = ({ changeId: changeId, fieldsChanges: fieldsChanges, lookupDataFromApi: lookupDataFromApi, tenantContext: tenantContext, viewContext: viewContext, environment: environment, appId: appId })=>async ({ setState: setState, getState: getState }, { viewType: viewType })=>{
        const appliedChanges = getState().appliedChanges || {};
        const formData = getState().formData || {};
        const { internalFormMetadata: internalFormMetadata, registeredFields: registeredFields, registeredFieldsDeprecated: registeredFieldsDeprecated } = getState();
        const { changesToApply: changesToApply, incomingFormData: incomingFormData, errorsByField: errorsByField } = await Object.keys(fieldsChanges).reduce(async (acc, fieldId)=>{
            // Do not update fields that are not inside initialized data.
            // Validates if the field that comes from Iframe is supported
            // - because we add to formData only the supported ones.
            const fieldData = formData[fieldId];
            const internalMetadata = internalFormMetadata[fieldId];
            const fieldIsRegistered = (0, $1ybV0.ff)('ui-modifications-multi-app-experience_ud4yw') ? (0, $7h8I4.fieldWasRegistered)(registeredFields, changeId, fieldId, appId) : (0, $7h8I4.fieldWasRegisteredDeprecated)(registeredFieldsDeprecated, changeId, fieldId);
            // Only registered field Ids can be updated.
            if (!fieldIsRegistered || !fieldData) {
                // eslint-disable-next-line no-console
                console.warn(`UIM tried to apply changes to the unregistered field ${fieldId}`);
                (0, $2bv99.fireOperationalAnalyticsWithoutContext)('applyChanges', 'unregisteredField', viewType, {
                    message: 'Attempt to apply changes to a field that was not registered',
                    fieldId: fieldId
                });
                return acc;
            }
            const lookupData = {
                [(0, $6b8c146c2dd688bb$export$a1cacdcf198da901)]: internalMetadata.allowedValues,
                [(0, $6b8c146c2dd688bb$export$3a106242c8f57ac2)]: lookupDataFromApi[0, $6b8c146c2dd688bb$export$3a106242c8f57ac2]
            };
            // It updates properties in each field to avoid removing unchanged props for
            // selected field by another app or another onChange update.
            // Only supported properties are allowed.
            const supportedFieldChanges = await (0, $7CbIv.transformFieldChangesToInternalShape)({
                fieldType: fieldData.fieldType,
                fieldId: fieldId,
                fieldFromIframe: fieldsChanges?.[fieldId],
                lookupData: lookupData,
                viewType: viewType,
                tenantContext: tenantContext,
                viewContext: viewContext,
                environment: environment
            });
            if (supportedFieldChanges.isValid === false) {
                (await acc).errorsByField[fieldId] = supportedFieldChanges.errors;
                return acc;
            }
            // It converts changes to 'public' format to update the formData
            const publicShapeChanges = (0, $lB1pd.transformFieldToIframe)(supportedFieldChanges.data, viewType, fieldData.fieldType, lookupData, fieldsChanges?.[fieldId], internalMetadata);
            const transformedFieldChanges = (0, $hGbVp.mapFieldPropsFromPublicToInternalShape)(supportedFieldChanges.data, viewType, fieldData.fieldType);
            const combinedChangesToApply = {
                ...appliedChanges[fieldId],
                ...transformedFieldChanges
            };
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(combinedChangesToApply)) {
                (await acc).changesToApply[fieldId] = combinedChangesToApply;
                (await acc).incomingFormData[fieldId] = {
                    ...formData[fieldId],
                    ...publicShapeChanges
                };
            }
            return acc;
        }, Promise.resolve({
            changesToApply: {
                ...appliedChanges
            },
            incomingFormData: {
                ...formData
            },
            errorsByField: {}
        }));
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(errorsByField)) throw new (0, $fsCiP.UiModificationsFieldsValidationError)('Transformation failed', {
            errors: (0, $fUNS1.prepareErrorsArray)(errorsByField)
        });
        setState({
            appliedChanges: changesToApply,
            formData: incomingFormData
        });
    };

});
const $6b8c146c2dd688bb$export$a1cacdcf198da901 = 'LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY';
const $6b8c146c2dd688bb$export$3a106242c8f57ac2 = 'LOOKUP_SOURCE_USERS_ASYNC_DATA';
const $6b8c146c2dd688bb$export$f5d5f6bb902f1027 = '-1';
const $6b8c146c2dd688bb$export$106087dcfd4fb129 = 100;

parcelRegister("7h8I4", function(module, exports) {

$parcel$export(module.exports, "fieldWasRegisteredDeprecated", () => $86ebc8f98d26cbd3$export$fce3a63433d10493);
$parcel$export(module.exports, "fieldWasRegistered", () => $86ebc8f98d26cbd3$export$fbe9157c12cb4e7b);
const $86ebc8f98d26cbd3$export$fce3a63433d10493 = (registeredFields, changeId, fieldId)=>registeredFields[changeId]?.includes(fieldId);
const $86ebc8f98d26cbd3$export$fbe9157c12cb4e7b = (registeredFields, changeId, fieldId, appId)=>!!registeredFields[appId]?.[changeId]?.includes(fieldId);

});

parcelRegister("hGbVp", function(module, exports) {

$parcel$export(module.exports, "mapFieldPropsFromPublicToInternalShape", () => $29afb4d5faeca466$export$120a0679b3388948);

var $8ibkc = parcelRequire("8ibkc");
const $29afb4d5faeca466$export$120a0679b3388948 = (properties, viewType, fieldType)=>{
    const fieldConfiguration = (0, $8ibkc.getSupportedFieldConfiguration)(viewType, fieldType);
    const propertyMapping = fieldConfiguration?.propertyMapping;
    if (!propertyMapping) return properties;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(properties).reduce((acc, propertyName)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const propertyMappingValue = propertyMapping[propertyName];
        acc[propertyMappingValue ?? propertyName] = properties[propertyName];
        return acc;
    }, {});
};

});
parcelRegister("8ibkc", function(module, exports) {

$parcel$export(module.exports, "getSupportedFieldConfiguration", () => $9883d6a43ab701de$export$8fc8d6775f1842b8);
$parcel$export(module.exports, "isFieldTypeSupported", () => $9883d6a43ab701de$export$b47920a5dd99844f);
$parcel$export(module.exports, "getConsentMessage", () => $9883d6a43ab701de$export$20eabd2b3ada6bf3);
$parcel$export(module.exports, "isProjectTypeSupported", () => $9883d6a43ab701de$export$cd7c26587dda4120);
$parcel$export(module.exports, "getAnalytics", () => $9883d6a43ab701de$export$b0297573c90085aa);
$parcel$export(module.exports, "isTriggerPointSupported", () => $9883d6a43ab701de$export$ef45e4471aa21b27);
$parcel$export(module.exports, "isScreenTabsSupportEnabled", () => $9883d6a43ab701de$export$71e5898a2b967ce3);

var $h1jSL = parcelRequire("h1jSL");

var $7vcoF = parcelRequire("7vcoF");
const $9883d6a43ab701de$var$isKeyOf = (key, object)=>object[key] !== undefined;
const $9883d6a43ab701de$var$getConfigurationByViewType = ({ viewType: viewType })=>{
    const viewConfiguration = (0, $7vcoF.supportedViews)[viewType];
    if (!viewConfiguration) throw new Error(`Unsupported view type ${viewType} in getConfigurationByViewType.`);
    return viewConfiguration;
};
function $9883d6a43ab701de$export$8fc8d6775f1842b8(viewType, fieldType) {
    const fieldsConfiguration = $9883d6a43ab701de$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldsConfiguration();
    if (!$9883d6a43ab701de$var$isKeyOf(fieldType, fieldsConfiguration)) {
        (0, $h1jSL.fireIAErrorAnalytics)({
            error: new Error('Unsupported field type.'),
            id: 'getSupportedFieldConfiguration',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
        return undefined;
    }
    return fieldsConfiguration[fieldType];
}
const $9883d6a43ab701de$export$e4330d77fd93d1de = (viewType)=>$9883d6a43ab701de$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldTypes();
const $9883d6a43ab701de$export$72171ea4e785fc66 = (viewType)=>$9883d6a43ab701de$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedProjectTypes();
function $9883d6a43ab701de$export$b47920a5dd99844f(viewType, fieldType) {
    return fieldType !== undefined && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $9883d6a43ab701de$export$e4330d77fd93d1de(viewType).includes(fieldType);
}
function $9883d6a43ab701de$export$20eabd2b3ada6bf3(viewType) {
    return $9883d6a43ab701de$var$getConfigurationByViewType({
        viewType: viewType
    }).getConsentMessage();
}
function $9883d6a43ab701de$export$cd7c26587dda4120(project, viewType) {
    return $9883d6a43ab701de$export$72171ea4e785fc66(viewType).includes(project.type);
}
function $9883d6a43ab701de$export$b0297573c90085aa(viewType) {
    return $9883d6a43ab701de$var$getConfigurationByViewType({
        viewType: viewType
    }).getAnalytics();
}
function $9883d6a43ab701de$export$c0728caa743a409e(viewType) {
    return $9883d6a43ab701de$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedTriggerPointsConfiguration();
}
const $9883d6a43ab701de$export$ef45e4471aa21b27 = (viewType, triggerPoint)=>triggerPoint !== undefined && $9883d6a43ab701de$export$c0728caa743a409e(viewType).has(triggerPoint);
const $9883d6a43ab701de$export$71e5898a2b967ce3 = (viewType)=>$9883d6a43ab701de$var$getConfigurationByViewType({
        viewType: viewType
    }).isScreenTabsSupportEnabled();

});
parcelRegister("h1jSL", function(module, exports) {

$parcel$export(module.exports, "fireIAErrorAnalytics", () => $31b678c9ad2da8b8$export$319cadf5a1a1b6a7);
$parcel$export(module.exports, "fireUIMErrorAnalytics", () => $31b678c9ad2da8b8$export$7ca48916618a8ab2);

var $guiFP = parcelRequire("guiFP");

var $eTZsp = parcelRequire("eTZsp");

var $bKI0B = parcelRequire("bKI0B");
const $31b678c9ad2da8b8$export$319cadf5a1a1b6a7 = ({ error: error, id: id, viewType: viewType, attributes: attributes = {}, event: event })=>{
    const supportedViews = (0, $bKI0B.getSupportedViewTypes)();
    const errorType = (0, $eTZsp.getErrorType)(error);
    const packageName = supportedViews.indexOf(viewType) >= 0 ? `${viewType}jiraUiModifications` : 'jiraUiModifications';
    (0, $guiFP.default)({
        event: event,
        meta: {
            id: id,
            packageName: packageName,
            teamName: 'unbox'
        },
        error: error,
        sendToPrivacyUnsafeSplunk: true,
        attributes: {
            errorType: errorType,
            ...attributes
        }
    });
};
const $31b678c9ad2da8b8$export$7ca48916618a8ab2 = ({ error: error, id: id, viewType: viewType, attributes: attributes = {}, event: event })=>{
    const errorType = (0, $eTZsp.getErrorType)(error);
    const packageName = 'jiraUiModifications';
    (0, $guiFP.default)({
        event: event,
        meta: {
            id: id,
            teamName: 'unbox',
            packageName: packageName
        },
        error: error,
        sendToPrivacyUnsafeSplunk: true,
        attributes: {
            errorType: errorType,
            ...attributes,
            viewType: viewType
        }
    });
};

});
parcelRegister("bKI0B", function(module, exports) {

$parcel$export(module.exports, "GIC_VIEW_TYPE", () => $f2036ab73f830785$export$e615b7e9b8fb4715);
$parcel$export(module.exports, "ISSUE_VIEW_VIEW_TYPE", () => $f2036ab73f830785$export$7de257fbae219dde);
$parcel$export(module.exports, "ISSUE_TRANSITION_VIEW_TYPE", () => $f2036ab73f830785$export$a415896b28cb78d7);
$parcel$export(module.exports, "getSupportedViewTypes", () => $f2036ab73f830785$export$d85868cf60d9efa6);

var $1ybV0 = parcelRequire("1ybV0");
const $f2036ab73f830785$export$e615b7e9b8fb4715 = 'GIC';
const $f2036ab73f830785$export$7de257fbae219dde = 'IssueView';
const $f2036ab73f830785$export$a415896b28cb78d7 = 'IssueTransition';
const $f2036ab73f830785$export$d85868cf60d9efa6 = ()=>[
        $f2036ab73f830785$export$e615b7e9b8fb4715,
        $f2036ab73f830785$export$7de257fbae219dde,
        ...(0, $1ybV0.ff)('ui-modifications-on-issue-transition-view_7z1g0') ? [
            $f2036ab73f830785$export$a415896b28cb78d7
        ] : []
    ];

});


parcelRegister("7vcoF", function(module, exports) {

$parcel$export(module.exports, "supportedViews", () => $729488f5ba158c79$export$a13e14fcae9906a8);

var $bKI0B = parcelRequire("bKI0B");

var $a2GLQ = parcelRequire("a2GLQ");

var $ke9hW = parcelRequire("ke9hW");

var $5ZW9L = parcelRequire("5ZW9L");
const $729488f5ba158c79$export$a13e14fcae9906a8 = {
    [(0, $bKI0B.GIC_VIEW_TYPE)]: new (0, $a2GLQ.GICViewConfiguration)(),
    [(0, $bKI0B.ISSUE_VIEW_VIEW_TYPE)]: new (0, $5ZW9L.IssueViewViewConfiguration)(),
    [(0, $bKI0B.ISSUE_TRANSITION_VIEW_TYPE)]: new (0, $ke9hW.IssueTransitionViewConfiguration)()
};

});
parcelRegister("a2GLQ", function(module, exports) {

$parcel$export(module.exports, "GICViewConfiguration", () => $f4be71a1bc47c7c5$export$99b59685fcab4ee);

var $7ZZxN = parcelRequire("7ZZxN");

var $1ybV0 = parcelRequire("1ybV0");


var $lO4Or = parcelRequire("lO4Or");

var $hBkQt = parcelRequire("hBkQt");


var $8QLPP = parcelRequire("8QLPP");

var $axvW5 = parcelRequire("axvW5");

var $hBOxC = parcelRequire("hBOxC");

var $9aEJT = parcelRequire("9aEJT");

var $e8h5r = parcelRequire("e8h5r");

var $e793N = parcelRequire("e793N");

var $incV3 = parcelRequire("incV3");

var $htzHC = parcelRequire("htzHC");

var $7AbVk = parcelRequire("7AbVk");

var $gLagZ = parcelRequire("gLagZ");

var $hFkmH = parcelRequire("hFkmH");

var $feRPz = parcelRequire("feRPz");

var $9Ek5r = parcelRequire("9Ek5r");

var $1h6vN = parcelRequire("1h6vN");

var $1NIGg = parcelRequire("1NIGg");

var $2xymT = parcelRequire("2xymT");

var $8TLBS = parcelRequire("8TLBS");

var $f8ZvF = parcelRequire("f8ZvF");

var $9lHpT = parcelRequire("9lHpT");

var $4WWvu = parcelRequire("4WWvu");

var $48mC7 = parcelRequire("48mC7");

var $l29kV = parcelRequire("l29kV");

var $jJReM = parcelRequire("jJReM");

var $iLshM = parcelRequire("iLshM");

var $k1kz4 = parcelRequire("k1kz4");

var $3sHes = parcelRequire("3sHes");

var $1Wx7H = parcelRequire("1Wx7H");

var $9dJRK = parcelRequire("9dJRK");

var $dxSfw = parcelRequire("dxSfw");

var $bxDqf = parcelRequire("bxDqf");

var $6fCXk = parcelRequire("6fCXk");

var $eRMH7 = parcelRequire("eRMH7");

var $EfOiv = parcelRequire("EfOiv");

var $459V5 = parcelRequire("459V5");
class $f4be71a1bc47c7c5$export$99b59685fcab4ee {
    getSupportedFieldsConfiguration() {
        const commonFieldValidators = (0, $2xymT.getCommonFieldValidators)();
        return {
            [(0, $lO4Or.SUMMARY_TYPE)]: {
                // It contains also supported field properties.
                // Validator MUST be added here to make given property supported.
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $6fCXk.singleLineTextFieldSetValueValidator)
                },
                // Transformers are optional per property, if missing the value will be used as is
                publicToInternalTransformers: {},
                internalToPublicTransformers: {
                    value: (0, $6fCXk.singleLineTextFieldGetValueTransformer)
                },
                emitChangeOn: 'blur'
            },
            [(0, $lO4Or.PRIORITY_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $gLagZ.validatePrioritySetValue),
                    optionsVisibility: (0, $2xymT.validateSetOptionsVisibilityRule)
                },
                publicToInternalTransformers: {
                    value: (0, $1Wx7H.prioritySetValueTransformer),
                    optionsVisibility: (0, $1Wx7H.transformPrioritySetOptionsVisibility)
                },
                internalToPublicTransformers: {
                    value: (0, $1Wx7H.transformPriorityGetValue),
                    optionsVisibility: (0, $1Wx7H.transformPriorityGetOptionsVisibility)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$a1cacdcf198da901),
                propertyMapping: {
                    optionsVisibility: 'allowedValues'
                }
            },
            [(0, $lO4Or.ASSIGNEE_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $8QLPP.assigneeSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $8QLPP.assigneeSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $8QLPP.assigneeGetValueTransformer)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$3a106242c8f57ac2)
            },
            [(0, $lO4Or.USER_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $1h6vN.userPickerSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $eRMH7.userPickerSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $eRMH7.userPickerGetValueTransformer)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$3a106242c8f57ac2)
            },
            [(0, $lO4Or.LABELS_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $incV3.labelsSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $incV3.labelsSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $incV3.labelsGetValueTransformer)
                },
                emitChangeOn: 'change'
            },
            [(0, $lO4Or.DESCRIPTION_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $9lHpT.validateDescriptionAndParagraphSetValue)
                },
                publicToInternalTransformers: {
                    value: (0, $9lHpT.descriptionAndParagraphSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $9lHpT.descriptionAndParagraphGetValueTransformer)
                },
                emitChangeOn: 'blur'
            },
            [(0, $lO4Or.SELECT_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $9Ek5r.selectSetValueValidator),
                    optionsVisibility: (0, $2xymT.validateSetOptionsVisibilityRule)
                },
                publicToInternalTransformers: {
                    value: (0, $bxDqf.selectSetValueTransformer),
                    optionsVisibility: (0, $bxDqf.transformSelectSetOptionsVisibility)
                },
                internalToPublicTransformers: {
                    value: (0, $bxDqf.selectGetValueTransformer),
                    optionsVisibility: (0, $bxDqf.transformSelectGetOptionsVisibility)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$a1cacdcf198da901),
                propertyMapping: {
                    optionsVisibility: 'allowedValues'
                }
            },
            [(0, $lO4Or.TEXT_AREA_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $9lHpT.validateDescriptionAndParagraphSetValue)
                },
                publicToInternalTransformers: {
                    value: (0, $9lHpT.descriptionAndParagraphSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $9lHpT.descriptionAndParagraphGetValueTransformer)
                },
                emitChangeOn: 'blur'
            },
            [(0, $lO4Or.MULTI_SELECT_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $l29kV.validateMultiSelectSetValue),
                    optionsVisibility: (0, $2xymT.validateSetOptionsVisibilityRule)
                },
                publicToInternalTransformers: {
                    value: (0, $l29kV.multiSelectSetValueTransformer),
                    optionsVisibility: (0, $l29kV.transformMultiSelectSetOptionsVisibility)
                },
                internalToPublicTransformers: {
                    value: (0, $l29kV.multiSelectGetValueTransformer),
                    optionsVisibility: (0, $l29kV.transformMultiSelectGetOptionsVisibility)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$a1cacdcf198da901),
                propertyMapping: {
                    optionsVisibility: 'allowedValues'
                }
            },
            [(0, $lO4Or.PEOPLE_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $3sHes.peopleSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $3sHes.peopleSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $3sHes.peopleGetValueTransformer)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$3a106242c8f57ac2)
            },
            [(0, $lO4Or.MULTI_USER_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $jJReM.multiUserPickerSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $jJReM.multiUserPickerSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $jJReM.multiUserPickerGetValueTransformer)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$3a106242c8f57ac2)
            },
            [(0, $lO4Or.TEXT_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $6fCXk.singleLineTextFieldSetValueValidator)
                },
                publicToInternalTransformers: {},
                internalToPublicTransformers: {
                    value: (0, $6fCXk.singleLineTextFieldGetValueTransformer)
                },
                emitChangeOn: 'blur'
            },
            [(0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $48mC7.validateMultiCheckboxSetValue),
                    optionsVisibility: (0, $2xymT.validateSetOptionsVisibilityRule)
                },
                publicToInternalTransformers: {
                    value: (0, $48mC7.multiCheckboxSetValueTransformer),
                    optionsVisibility: (0, $48mC7.transformMultiCheckboxSetOptionsVisibility)
                },
                internalToPublicTransformers: {
                    value: (0, $48mC7.multiCheckboxGetValueTransformer),
                    optionsVisibility: (0, $48mC7.transformMultiCheckboxGetOptionsVisibility)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$a1cacdcf198da901),
                propertyMapping: {
                    optionsVisibility: 'allowedValues'
                }
            },
            [(0, $lO4Or.COMPONENTS_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $f8ZvF.validateComponentsSetValue)
                },
                publicToInternalTransformers: {
                    value: (0, $f8ZvF.componentsSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $f8ZvF.componentsGetValueTransformer)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$a1cacdcf198da901),
                requiredScopes: (0, $hBOxC.componentsRequiredScopes)
            },
            [(0, $lO4Or.REPORTER_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $feRPz.reporterSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $dxSfw.reporterSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $dxSfw.reporterGetValueTransformer)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$3a106242c8f57ac2)
            },
            [(0, $lO4Or.FIX_VERSIONS_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $EfOiv.fixVersionsSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $EfOiv.transformVersionsSetValue)
                },
                internalToPublicTransformers: {
                    value: (0, $EfOiv.transformVersionsGetValue)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$a1cacdcf198da901),
                requiredScopes: (0, $EfOiv.versionsRequiredScopes)
            },
            [(0, $lO4Or.ISSUE_TYPE)]: {
                publicShapeValidators: {
                    value: (0, $e793N.issueTypeSetValueValidator),
                    optionsVisibility: (0, $2xymT.validateSetOptionsVisibilityRule)
                },
                publicToInternalTransformers: {
                    value: (0, $4WWvu.issueTypeSetValueTransformer),
                    optionsVisibility: (0, $4WWvu.transformIssueTypeSetOptionsVisibility)
                },
                internalToPublicTransformers: {
                    value: (0, $4WWvu.issueTypeGetValueTransformer),
                    optionsVisibility: (0, $4WWvu.transformIssueTypeGetOptionsVisibility)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$a1cacdcf198da901),
                propertyMapping: {
                    optionsVisibility: 'allowedValues'
                }
            },
            [(0, $lO4Or.URL_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $6fCXk.singleLineTextFieldSetValueValidator)
                },
                publicToInternalTransformers: {},
                internalToPublicTransformers: {
                    value: (0, $6fCXk.singleLineTextFieldGetValueTransformer)
                },
                emitChangeOn: 'blur'
            },
            [(0, $lO4Or.DATE_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $9aEJT.datePickerSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $9aEJT.datePickerSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $9aEJT.datePickerGetValueTransformer)
                },
                emitChangeOn: 'change'
            },
            [(0, $lO4Or.DATETIME_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $e8h5r.validateDateTimePickerSetValue)
                },
                publicToInternalTransformers: {
                    value: (0, $e8h5r.transformDateTimePickerSetValue)
                },
                internalToPublicTransformers: {
                    value: (0, $e8h5r.transformDateTimePickerGetValue)
                },
                emitChangeOn: 'change'
            },
            [(0, $lO4Or.RADIO_BUTTONS_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $hFkmH.radioButtonsSetValueValidator),
                    optionsVisibility: (0, $2xymT.validateSetOptionsVisibilityRule)
                },
                publicToInternalTransformers: {
                    value: (0, $9dJRK.radioButtonsSetValueTransformer),
                    optionsVisibility: (0, $9dJRK.transformRadioButtonsSetOptionsVisibility)
                },
                internalToPublicTransformers: {
                    value: (0, $9dJRK.radioButtonsGetValueTransformer),
                    optionsVisibility: (0, $9dJRK.transformRadioButtonsGetOptionsVisibility)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$a1cacdcf198da901),
                propertyMapping: {
                    optionsVisibility: 'allowedValues'
                }
            },
            [(0, $lO4Or.NUMBER_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $htzHC.validateNumberValue)
                },
                publicToInternalTransformers: {
                    value: (0, $iLshM.transformNumberToInternalValue)
                },
                internalToPublicTransformers: {
                    value: (0, $iLshM.transformNumberToPublicValue)
                },
                emitChangeOn: 'blur',
                requiredScopes: (0, $iLshM.numberIssueGicScopes)
            },
            [(0, $lO4Or.PARENT_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $7AbVk.parentSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $k1kz4.parentSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $k1kz4.parentGetValueTransformer)
                },
                emitChangeOn: 'change'
            },
            [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $axvW5.validateCascadingSelectSetValue)
                },
                publicToInternalTransformers: {
                    value: (0, $8TLBS.transformSetValueCascadingSelect)
                },
                internalToPublicTransformers: {
                    value: (0, $8TLBS.transformGetValueCascadingSelect)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$a1cacdcf198da901)
            },
            [(0, $lO4Or.AFFECTS_VERSIONS_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $1NIGg.validateVersionValue)
                },
                publicToInternalTransformers: {
                    value: (0, $EfOiv.transformVersionsSetValue)
                },
                internalToPublicTransformers: {
                    value: (0, $EfOiv.transformVersionsGetValue)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$a1cacdcf198da901),
                requiredScopes: (0, $EfOiv.versionsRequiredScopes)
            }
        };
    }
    getSupportedFieldTypes() {
        const supportedFieldTypes = [
            (0, $lO4Or.SUMMARY_TYPE),
            (0, $lO4Or.PRIORITY_TYPE),
            (0, $lO4Or.ASSIGNEE_TYPE),
            (0, $lO4Or.LABELS_TYPE),
            (0, $lO4Or.DESCRIPTION_TYPE),
            (0, $lO4Or.SELECT_CF_TYPE),
            (0, $lO4Or.TEXT_AREA_CF_TYPE),
            (0, $lO4Or.MULTI_SELECT_CF_TYPE),
            (0, $lO4Or.USER_CF_TYPE),
            (0, $lO4Or.TEXT_CF_TYPE),
            (0, $lO4Or.MULTI_USER_CF_TYPE),
            (0, $lO4Or.PEOPLE_CF_TYPE),
            (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE),
            (0, $lO4Or.REPORTER_TYPE),
            (0, $lO4Or.COMPONENTS_TYPE),
            (0, $lO4Or.FIX_VERSIONS_TYPE),
            (0, $lO4Or.ISSUE_TYPE),
            (0, $lO4Or.DATE_CF_TYPE),
            (0, $lO4Or.DATETIME_CF_TYPE),
            (0, $lO4Or.URL_CF_TYPE),
            (0, $lO4Or.RADIO_BUTTONS_CF_TYPE),
            (0, $lO4Or.NUMBER_CF_TYPE),
            (0, $lO4Or.PARENT_TYPE)
        ];
        if ((0, $1ybV0.ff)('uim-cascading-select-field-support-gic_h1cda')) supportedFieldTypes.push((0, $lO4Or.CASCADING_SELECT_CF_TYPE));
        if ((0, $1ybV0.ff)('ui-modifications-gic-affects-version-support_6gdcz')) supportedFieldTypes.push((0, $lO4Or.AFFECTS_VERSIONS_TYPE));
        return supportedFieldTypes;
    }
    getSupportedProjectTypes() {
        return [
            (0, $7ZZxN.SOFTWARE_PROJECT),
            (0, $7ZZxN.CORE_PROJECT)
        ];
    }
    getConsentMessage() {
        return (0, $459V5.default).obligatoryUimGicConsentMessage;
    }
    getAnalytics() {
        return this.analytics;
    }
    getSupportedTriggerPointsConfiguration() {
        return new Set([
            (0, $33ffe55cb7bcdadc$export$a05673a22505d5ee),
            (0, $33ffe55cb7bcdadc$export$c78d329777576aa0),
            (0, $33ffe55cb7bcdadc$export$affdc3af7a9a4677),
            (0, $33ffe55cb7bcdadc$export$7e9cfd1f59e60910),
            (0, $33ffe55cb7bcdadc$export$946ec0b21cb84fd0),
            (0, $33ffe55cb7bcdadc$export$708499dcd016e5e9)
        ]);
    }
    constructor(){
        this.analytics = {
            stopTTI: $hBkQt.stopTTI,
            cancelTTI: $hBkQt.cancelTTI,
            markIframeLoad: $hBkQt.markIframeLoad,
            markFieldsRegistered: $hBkQt.markFieldsRegistered,
            markOnInitResolved: $hBkQt.markOnInitResolved
        };
        this.isScreenTabsSupportEnabled = ()=>true;
    }
}

});
const $33ffe55cb7bcdadc$export$a05673a22505d5ee = 'forge-open-issue-create';
const $33ffe55cb7bcdadc$export$c78d329777576aa0 = 'global-create-button';
const $33ffe55cb7bcdadc$export$affdc3af7a9a4677 = 'keyboard-shortcut';
const $33ffe55cb7bcdadc$export$7e9cfd1f59e60910 = 'jsw-issue-view-create-issue-in-epic';
const $33ffe55cb7bcdadc$export$708499dcd016e5e9 = 'jsw-issue-view-create-subtask';
const $33ffe55cb7bcdadc$export$e1c8789144c4c810 = 'jsw-issue-view-ai-breakdown-child-issue';
const $33ffe55cb7bcdadc$export$c5afabb7a17e802 = 'jsw-issue-view-ai-breakdown-subtask';
const $33ffe55cb7bcdadc$export$2086a63173b79b56 = 'jsw-releases-create-issue';
const $33ffe55cb7bcdadc$export$fe1e5e4597147709 = 'jsw-roadmap-create-issue';
const $33ffe55cb7bcdadc$export$9bc326812a93707 = 'jsw-security-create-issue';
const $33ffe55cb7bcdadc$export$f352934e06f44599 = 'jsm-calendar-create-change-request';
const $33ffe55cb7bcdadc$export$6ae07c77acc64360 = 'jsm-create-incident-from-alert-detail';
const $33ffe55cb7bcdadc$export$b41d0684e4b6ab1 = 'jsm-create-incident-from-alert-list';
const $33ffe55cb7bcdadc$export$be9b2b1329ff7ec9 = 'jsm-empty-queue-create-request';
const $33ffe55cb7bcdadc$export$235b856f54db8916 = 'jwm-board-create-issue';
const $33ffe55cb7bcdadc$export$ebbb81a0a3406bcb = 'jwm-calendar-create-issue';
const $33ffe55cb7bcdadc$export$8e135b62470e5f9a = 'jwm-list-create-issue';
const $33ffe55cb7bcdadc$export$21ea58e7361c33ba = 'jwm-list-create-subtask';
const $33ffe55cb7bcdadc$export$d2cf44b8c67cca33 = 'jwm-timeline-create-issue';
const $33ffe55cb7bcdadc$export$894285d6d13375fd = 'jwm-timeline-create-subtask';
const $33ffe55cb7bcdadc$export$aa348159181703a0 = 'software-create-issue-dialog';
const $33ffe55cb7bcdadc$export$f90eec3841adf619 = 'create-linked-issue-issue-view';
const $33ffe55cb7bcdadc$export$718822a309bffada = 'create-linked-issue-command-palette';
const $33ffe55cb7bcdadc$export$2753dafac81e805c = 'service-desk-linked-issue-trigger';
const $33ffe55cb7bcdadc$export$7c4d5cc5711d9294 = 'jsw-incidents-create-jsm-pir-trigger';
const $33ffe55cb7bcdadc$export$6eb7318fea2f8ce0 = 'jsw-incidents-create-issue-trigger';
const $33ffe55cb7bcdadc$export$998dfc72404b9e14 = 'jpo-dialogs-jira-create-issue';
const $33ffe55cb7bcdadc$export$fc180a4b5785d2f4 = 'jsw-adapted-global-issue-create-trigger';
const $33ffe55cb7bcdadc$export$946ec0b21cb84fd0 = 'jsw-create-epic-issue';
const $33ffe55cb7bcdadc$export$dba86c91ec4fdbf0 = 'create-issue-backlog-trigger';
const $33ffe55cb7bcdadc$export$b5cdfd7f3bb79a7 = 'create-epic-issue-backlog-trigger';
const $33ffe55cb7bcdadc$export$a8199da3cfab0e8 = 'create-issue-in-epic-backlog-trigger';
const $33ffe55cb7bcdadc$export$5b97e2844e620e54 = 'create-issue-active-sprint-empty-view-trigger';
const $33ffe55cb7bcdadc$export$569f5ff8afa08896 = 'create-linked-issue-issue-navigator-trigger';
const $33ffe55cb7bcdadc$export$bafd52474e9ff4e = 'jwm-summary-create-first-issue-trigger';
const $33ffe55cb7bcdadc$export$87f86192eaf0fdf = 'create-subtask-issue-navigator-trigger';
const $33ffe55cb7bcdadc$export$b99842c2cf46f6be = 'create-subtask-new-issue-navigator-trigger';
const $33ffe55cb7bcdadc$export$1e467d0a3f53a410 = 'jwm-board-embed-issue-create';
const $33ffe55cb7bcdadc$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
const $33ffe55cb7bcdadc$export$867e9a641a3c1457 = 'jwm-list-embed-issue-create';
const $33ffe55cb7bcdadc$export$8de9fa43731c4b5b = 'issue-parent-switcher-field-create-issue';
const $33ffe55cb7bcdadc$export$87249ccbfd10fb78 = 'polaris-create-delivery-issue';
const $33ffe55cb7bcdadc$export$c0eeeb31d264de76 = 'home-page-default-open-gic';
const $33ffe55cb7bcdadc$export$f546e18e46478c84 = 'issue-create-embed-trigger';
const $33ffe55cb7bcdadc$export$1784e634ba79f1f9 = 'developer-escalations-issue-create-trigger';
const $33ffe55cb7bcdadc$export$145eb8935a34e85e = 'jwm-inline-create';
const $33ffe55cb7bcdadc$export$32648b574a536c8b = 'polaris-global-submit-idea-switch-project-trigger';

parcelRegister("8QLPP", function(module, exports) {

$parcel$export(module.exports, "assigneeSetValueValidator", () => $0661eaaab34eb369$export$a1b37d5eeb401ad6);
$parcel$export(module.exports, "assigneeSetValueTransformer", () => $0661eaaab34eb369$export$d1aadee23fc64b9d);
$parcel$export(module.exports, "assigneeGetValueTransformer", () => $0661eaaab34eb369$export$166948efaac892d3);
$parcel$export(module.exports, "assigneeScopes", () => $0661eaaab34eb369$export$3c9d4db6ddd2a8e6);

var $2Vsz9 = parcelRequire("2Vsz9");

var $4XB9o = parcelRequire("4XB9o");

var $8xPow = parcelRequire("8xPow");

var $9DCyM = parcelRequire("9DCyM");
const $0661eaaab34eb369$export$a1b37d5eeb401ad6 = (value)=>value === null || (0, $8xPow.isNotEmptyString)(value);
const $0661eaaab34eb369$export$d1aadee23fc64b9d = (value, lookupValues)=>{
    if (value === null) return null;
    const foundValue = (0, $9DCyM.singleValueLookup)(value, lookupValues, 'accountId');
    if (!foundValue) throw new (0, $2Vsz9.FieldValueLookupError)();
    const { accountId: accountId, name: displayName, picture: picture } = foundValue;
    return {
        accountId: accountId,
        displayName: displayName,
        avatarUrls: {
            '48x48': picture
        }
    };
};
const $0661eaaab34eb369$export$166948efaac892d3 = (value)=>{
    if (value === null) return null;
    const { accountId: accountId } = value;
    return {
        accountId: accountId
    };
};
const $0661eaaab34eb369$export$3c9d4db6ddd2a8e6 = {
    ...(0, $4XB9o.baseScopesRequiredPerField),
    granular: [
        ...(0, $4XB9o.baseScopesRequiredPerField).granular,
        'read:user:jira'
    ],
    coarse: [
        ...(0, $4XB9o.baseScopesRequiredPerField).coarse,
        'read:jira-user'
    ]
};

});
parcelRegister("2Vsz9", function(module, exports) {

$parcel$export(module.exports, "FieldValueLookupError", () => $583216437d6b2342$export$73c2f0689b6c4a5a);
class $583216437d6b2342$export$73c2f0689b6c4a5a extends Error {
}

});

parcelRegister("4XB9o", function(module, exports) {

$parcel$export(module.exports, "baseScopesRequiredPerField", () => $321feced323efbab$export$ec1ba7c44413935f);
const $321feced323efbab$export$ec1ba7c44413935f = {
    granular: [
        'read:field:jira',
        'write:field:jira',
        'read:field-configuration:jira',
        'write:field-configuration:jira'
    ],
    coarse: [
        'read:jira-work',
        'write:jira-work',
        'manage:jira-configuration'
    ]
};

});

parcelRegister("8xPow", function(module, exports) {

$parcel$export(module.exports, "isNotEmptyString", () => $5bbf28343919e2e5$export$582443c7ead02173);
const $5bbf28343919e2e5$export$582443c7ead02173 = (value)=>typeof value === 'string' && value !== '';

});

parcelRegister("9DCyM", function(module, exports) {

$parcel$export(module.exports, "singleValueLookup", () => $cb00830fef4b3a2b$export$93a99fc9939aad85);
/**
 * Finds a single entity from a provided list of entities
 *
 * @param value - the value search being made by
 * @param lookupValues - list of entities where search is being made
 * @param lookupKey - property name of the entity from the lookupValues list with which value will be compared
 */ const $cb00830fef4b3a2b$export$93a99fc9939aad85 = (value, // eslint-disable-next-line @typescript-eslint/no-explicit-any
lookupValues = [], lookupKey)=>lookupValues.find((option)=>option[lookupKey] === value);

});


parcelRegister("axvW5", function(module, exports) {

$parcel$export(module.exports, "validateCascadingSelectSetValue", () => $783211acf76ed798$export$2d586ab6ce4d7126);

var $8xPow = parcelRequire("8xPow");
const $783211acf76ed798$export$2d586ab6ce4d7126 = (value)=>value === null || typeof value === 'object' && 'parentId' in value && 'childId' in value && (0, $8xPow.isNotEmptyString)(value.parentId) && ((0, $8xPow.isNotEmptyString)(value.childId) || value.childId === null);

});

parcelRegister("hBOxC", function(module, exports) {

$parcel$export(module.exports, "validateComponentsSetValue", () => $2df75154b7318e72$export$c65e64c3a855d5d2);
$parcel$export(module.exports, "componentsRequiredScopes", () => $2df75154b7318e72$export$a818a96eabdabcb);


var $4XB9o = parcelRequire("4XB9o");

var $8xPow = parcelRequire("8xPow");
const $2df75154b7318e72$export$c65e64c3a855d5d2 = (value)=>Array.isArray(value) && value.length <= (0, $6b8c146c2dd688bb$export$106087dcfd4fb129) && value.every((0, $8xPow.isNotEmptyString));
const $2df75154b7318e72$export$a818a96eabdabcb = {
    ...(0, $4XB9o.baseScopesRequiredPerField),
    granular: [
        'read:project.component:jira',
        ...(0, $4XB9o.baseScopesRequiredPerField).granular,
        'write:field.default-value:jira'
    ]
};

});

parcelRegister("9aEJT", function(module, exports) {

$parcel$export(module.exports, "datePickerSetValueValidator", () => $7e4f3bba2e0dcf4b$export$c003579a97a2459e);
$parcel$export(module.exports, "datePickerSetValueTransformer", () => $7e4f3bba2e0dcf4b$export$cfb5350c1b8d2150);
$parcel$export(module.exports, "datePickerGetValueTransformer", () => $7e4f3bba2e0dcf4b$export$e844c6ac3a5cbef7);

var $EN9B6 = parcelRequire("EN9B6");
var $7ueqz = parcelRequire("7ueqz");
var $5YjhU = parcelRequire("5YjhU");
var $3xcI8 = parcelRequire("3xcI8");
// Date picker accepts only date string in format yyyy-MM-dd, so we need to validate it
// The date format is consistent with API contract
const $7e4f3bba2e0dcf4b$var$dateHasExpectedFormat = (date)=>{
    const dateFormat = 'yyyy-MM-dd';
    // `parse` doesn't respect strict format, see known issue https://github.com/date-fns/date-fns/issues/942
    // where format yyyy-MM-dd date 2022-10-2 is parsed successfully but shouldn't
    if (typeof date !== 'string' || dateFormat.length !== date.length) return false;
    const parsedDate = (0, $5YjhU.default)(date, dateFormat, new Date());
    return (0, $7ueqz.default)(parsedDate);
};
const $7e4f3bba2e0dcf4b$export$c003579a97a2459e = (value)=>value === null || $7e4f3bba2e0dcf4b$var$dateHasExpectedFormat(value);
const $7e4f3bba2e0dcf4b$export$cfb5350c1b8d2150 = (publicValue)=>publicValue === null ? '' : publicValue;
const $7e4f3bba2e0dcf4b$export$e844c6ac3a5cbef7 = (internalValue)=>{
    if (!internalValue) return null;
    const parsedDate = (0, $3xcI8.default)(internalValue);
    if ((0, $7ueqz.default)(parsedDate)) return (0, $EN9B6.default)(parsedDate, 'yyyy-MM-dd');
    throw new Error(`Invalid date was provided: ${internalValue}`);
};

});

parcelRegister("e8h5r", function(module, exports) {

$parcel$export(module.exports, "validateDateTimePickerSetValue", () => $3a1f121e49e0e6cd$export$7930ddff407505cc);
$parcel$export(module.exports, "transformDateTimePickerSetValue", () => $3a1f121e49e0e6cd$export$e81204f19744e19f);
$parcel$export(module.exports, "transformDateTimePickerGetValue", () => $3a1f121e49e0e6cd$export$4cb6c79fda4a9c74);

var $EN9B6 = parcelRequire("EN9B6");
var $kCEEd = parcelRequire("kCEEd");
var $7ueqz = parcelRequire("7ueqz");
var $3xcI8 = parcelRequire("3xcI8");
// Date time picker accepts only date string in format YYYY-MM-DDThh:mm:ssTZD
const $3a1f121e49e0e6cd$var$formatString = "yyyy-MM-dd'T'HH:mmxxx";
const $3a1f121e49e0e6cd$export$a886f5166a4d311e = (fullDate)=>{
    if (typeof fullDate !== 'string') return false;
    return (0, $kCEEd.default)(fullDate, $3a1f121e49e0e6cd$var$formatString) && (0, $7ueqz.default)((0, $3xcI8.default)(fullDate));
};
const $3a1f121e49e0e6cd$export$7930ddff407505cc = (value)=>value === null || $3a1f121e49e0e6cd$export$a886f5166a4d311e(value);
const $3a1f121e49e0e6cd$export$e81204f19744e19f = (publicValue)=>publicValue === null ? '' : publicValue;
const $3a1f121e49e0e6cd$export$4cb6c79fda4a9c74 = (internalValue)=>{
    if (!internalValue) return null;
    const parsedDate = (0, $3xcI8.default)(internalValue);
    if ((0, $7ueqz.default)(parsedDate)) return (0, $EN9B6.default)(parsedDate, $3a1f121e49e0e6cd$var$formatString);
    throw new Error(`Invalid date was provided: ${internalValue}`);
};

});

parcelRegister("e793N", function(module, exports) {

$parcel$export(module.exports, "issueTypeSetValueValidator", () => $b7ee4c8a0d7e5e1e$export$19e9b52e41260d79);

var $8xPow = parcelRequire("8xPow");
const $b7ee4c8a0d7e5e1e$export$19e9b52e41260d79 = (value)=>(0, $8xPow.isNotEmptyString)(value);

});

parcelRegister("incV3", function(module, exports) {

$parcel$export(module.exports, "labelsRequiredScopes", () => $23eda58696bf9a04$export$5397fc4189b6d690);
$parcel$export(module.exports, "labelsSetValueValidator", () => $23eda58696bf9a04$export$e67b5652c846b5f);
$parcel$export(module.exports, "labelsSetValueTransformer", () => $23eda58696bf9a04$export$861e9d180b68fea1);
$parcel$export(module.exports, "labelsGetValueTransformer", () => $23eda58696bf9a04$export$b0b12fd0b1cd9d3a);

var $4XB9o = parcelRequire("4XB9o");
const $23eda58696bf9a04$export$5397fc4189b6d690 = {
    granular: [
        ...(0, $4XB9o.baseScopesRequiredPerField).granular,
        'read:label:jira'
    ],
    coarse: [
        ...(0, $4XB9o.baseScopesRequiredPerField).coarse
    ]
};
const $23eda58696bf9a04$export$e67b5652c846b5f = (value)=>typeof value === 'object' && value !== null && Array.isArray(value) && value.every((label)=>typeof label === 'string' && label !== '');
const $23eda58696bf9a04$export$861e9d180b68fea1 = (publicValue)=>publicValue.map((label)=>({
            value: label,
            label: label
        }));
const $23eda58696bf9a04$export$b0b12fd0b1cd9d3a = (internalValue)=>internalValue.map(({ value: value })=>value);

});

parcelRegister("htzHC", function(module, exports) {

$parcel$export(module.exports, "validateNumberValue", () => $fa6f50589319585e$export$aeb074bfcd7963bd);
$parcel$export(module.exports, "numberScopes", () => $fa6f50589319585e$export$2ddc76933cd1391c);

var $4XB9o = parcelRequire("4XB9o");
const $fa6f50589319585e$export$aeb074bfcd7963bd = (value)=>value === null || typeof value === 'number';
const $fa6f50589319585e$export$2ddc76933cd1391c = (0, $4XB9o.baseScopesRequiredPerField);

});

parcelRegister("7AbVk", function(module, exports) {

$parcel$export(module.exports, "parentSetValueValidator", () => $6122b026ea76dee9$export$ada98fdbc0faa607);
$parcel$export(module.exports, "parentScopes", () => $6122b026ea76dee9$export$bdc8bd505789b6e8);

var $4XB9o = parcelRequire("4XB9o");

var $8xPow = parcelRequire("8xPow");
const $6122b026ea76dee9$export$ada98fdbc0faa607 = (value)=>value === null || (0, $8xPow.isNotEmptyString)(value);
const $6122b026ea76dee9$export$bdc8bd505789b6e8 = (0, $4XB9o.baseScopesRequiredPerField);

});

parcelRegister("gLagZ", function(module, exports) {

$parcel$export(module.exports, "validatePrioritySetValue", () => $e35fe104200f1bd7$export$feb916d6d9ca4953);
$parcel$export(module.exports, "priorityScopes", () => $e35fe104200f1bd7$export$de5c165bee5efef2);

var $4XB9o = parcelRequire("4XB9o");

var $8xPow = parcelRequire("8xPow");
const $e35fe104200f1bd7$export$feb916d6d9ca4953 = (value)=>(0, $8xPow.isNotEmptyString)(value);
const $e35fe104200f1bd7$export$de5c165bee5efef2 = {
    ...(0, $4XB9o.baseScopesRequiredPerField),
    granular: [
        ...(0, $4XB9o.baseScopesRequiredPerField).granular,
        'read:priority:jira'
    ]
};

});

parcelRegister("hFkmH", function(module, exports) {

$parcel$export(module.exports, "radioButtonsSetValueValidator", () => $35c8b6ff54e234a0$export$fd2e39ca7399c512);
$parcel$export(module.exports, "radioButtonsScopes", () => $35c8b6ff54e234a0$export$baef9137cbf80a51);

var $4XB9o = parcelRequire("4XB9o");

var $8xPow = parcelRequire("8xPow");
const $35c8b6ff54e234a0$export$fd2e39ca7399c512 = (value)=>value === null || (0, $8xPow.isNotEmptyString)(value);
const $35c8b6ff54e234a0$export$baef9137cbf80a51 = (0, $4XB9o.baseScopesRequiredPerField);

});

parcelRegister("feRPz", function(module, exports) {

$parcel$export(module.exports, "reporterSetValueValidator", () => $ac17a534dc1fcb45$export$b8b018eb25bdb4d8);

var $fBuJM = parcelRequire("fBuJM");

var $8xPow = parcelRequire("8xPow");
const $ac17a534dc1fcb45$export$b8b018eb25bdb4d8 = (value)=>// We should omit automatic id special value so it won't be picked up by this field
    // It is only applicable to the assignee field
    value === null || (0, $8xPow.isNotEmptyString)(value) && (0, $fBuJM.isNotAutomaticId)(value);

});
parcelRegister("fBuJM", function(module, exports) {

$parcel$export(module.exports, "isNotAutomaticId", () => $0c75b2f3b403ad8c$export$ab4c3a3c49d7add);

const $0c75b2f3b403ad8c$export$ab4c3a3c49d7add = (value)=>value !== (0, $6b8c146c2dd688bb$export$f5d5f6bb902f1027);

});


parcelRegister("9Ek5r", function(module, exports) {

$parcel$export(module.exports, "selectSetValueValidator", () => $0e072097323757a8$export$c02b1c2a574ca4c7);
$parcel$export(module.exports, "selectWithAriSetValueValidator", () => $0e072097323757a8$export$f22935386c756879);
$parcel$export(module.exports, "selectScopes", () => $0e072097323757a8$export$cb76f902c880ecb4);

var $4XB9o = parcelRequire("4XB9o");

var $6lwHh = parcelRequire("6lwHh");

var $8xPow = parcelRequire("8xPow");
const $0e072097323757a8$export$c02b1c2a574ca4c7 = (value)=>value === null || (0, $8xPow.isNotEmptyString)(value);
const $0e072097323757a8$export$f22935386c756879 = (value)=>value === null || (0, $8xPow.isNotEmptyString)(value) && (0, $6lwHh.isAriResourceIdValid)(value);
const $0e072097323757a8$export$cb76f902c880ecb4 = (0, $4XB9o.baseScopesRequiredPerField);

});
parcelRegister("6lwHh", function(module, exports) {

$parcel$export(module.exports, "isAriResourceIdValid", () => $0007d4320dc46b59$export$4d1e9901084f3bf6);

var $2rn3r = parcelRequire("2rn3r");
const $0007d4320dc46b59$var$CLOUD_ID_MOCK = 'cloud-id';
const $0007d4320dc46b59$var$ACTIOVATION_ID_MOCK = 'activation-id';
const $0007d4320dc46b59$var$FIELD_ID_MOCK = 'field-1';
const $0007d4320dc46b59$export$4d1e9901084f3bf6 = (optionId)=>{
    try {
        (0, $2rn3r.JiraIssueFieldOptionAri).create({
            siteId: $0007d4320dc46b59$var$CLOUD_ID_MOCK,
            activationId: $0007d4320dc46b59$var$ACTIOVATION_ID_MOCK,
            fieldId: $0007d4320dc46b59$var$FIELD_ID_MOCK,
            optionId: optionId
        });
        return true;
    } catch (e) {
        return false;
    }
};

});
parcelRegister("2rn3r", function(module, exports) {

$parcel$export(module.exports, "JiraIssueFieldOptionAri", () => $396674cae5287926$export$e3bc1ec22f941fbe);

var $7HlAi = parcelRequire("7HlAi");

var $v8cEo = parcelRequire("v8cEo");

var $hkoEN = parcelRequire("hkoEN");
// src/jira/issue-field-option/manifest.ts
var $396674cae5287926$var$jiraIssueFieldOptionAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9-]+$"),
    resourceOwner: (0, $7HlAi.JiraIssueFieldOptionAriResourceOwner),
    resourceType: (0, $7HlAi.JiraIssueFieldOptionAriResourceType),
    resourceIdSlug: "activation/{activationId}/{fieldId}/{optionId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        fieldId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/,
        // eslint-disable-line no-useless-escape
        optionId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
    }
};
// src/jira/issue-field-option/index.ts
var $396674cae5287926$export$e3bc1ec22f941fbe = class _JiraIssueFieldOptionAri extends (0, $v8cEo.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._fieldId = opts.resourceIdSegmentValues.fieldId, this._optionId = opts.resourceIdSegmentValues.optionId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get fieldId() {
        return this._fieldId;
    }
    get optionId() {
        return this._optionId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $396674cae5287926$var$jiraIssueFieldOptionAriStaticOpts.qualifier,
            platformQualifier: $396674cae5287926$var$jiraIssueFieldOptionAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $396674cae5287926$var$jiraIssueFieldOptionAriStaticOpts.resourceOwner,
            resourceType: $396674cae5287926$var$jiraIssueFieldOptionAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.fieldId}/${opts.optionId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                fieldId: opts.fieldId,
                optionId: opts.optionId
            }
        }, ariOpts = (0, $hkoEN.AriParser).fromOpts(derivedOpts, $396674cae5287926$var$jiraIssueFieldOptionAriStaticOpts);
        return new _JiraIssueFieldOptionAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $hkoEN.AriParser).fromString(maybeAri, $396674cae5287926$var$jiraIssueFieldOptionAriStaticOpts);
        return new _JiraIssueFieldOptionAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            fieldId: this.fieldId,
            optionId: this.optionId
        };
    }
};

});
parcelRegister("7HlAi", function(module, exports) {

$parcel$export(module.exports, "JiraIssueFieldOptionAriResourceOwner", () => $5632bebec8ddd527$export$eb4f4cf0880fe5a8);
$parcel$export(module.exports, "JiraIssueFieldOptionAriResourceType", () => $5632bebec8ddd527$export$4bec333360908e78);
// src/jira/issue-field-option/types.ts
var $5632bebec8ddd527$export$eb4f4cf0880fe5a8 = "jira", $5632bebec8ddd527$export$4bec333360908e78 = "issue-field-option";

});




parcelRegister("1h6vN", function(module, exports) {

$parcel$export(module.exports, "userPickerSetValueValidator", () => $0eb8d1cc295999fc$export$e01dbe42b757ec);

var $fBuJM = parcelRequire("fBuJM");

var $8xPow = parcelRequire("8xPow");
const $0eb8d1cc295999fc$export$e01dbe42b757ec = (value)=>// We should omit automatic id special value, so it won't be picked up by this field
    // It is only applicable to the assignee field
    value === null || (0, $8xPow.isNotEmptyString)(value) && (0, $fBuJM.isNotAutomaticId)(value);

});

parcelRegister("1NIGg", function(module, exports) {

$parcel$export(module.exports, "validateVersionValue", () => $2e28f5c68ce7d201$export$f3e581e8b1e2479a);
$parcel$export(module.exports, "versionsRequiredScopes", () => $2e28f5c68ce7d201$export$60db61c485973ad9);


var $4XB9o = parcelRequire("4XB9o");

var $8xPow = parcelRequire("8xPow");
const $2e28f5c68ce7d201$export$f3e581e8b1e2479a = (value)=>Array.isArray(value) && value.every((0, $8xPow.isNotEmptyString)) && value.length <= (0, $6b8c146c2dd688bb$export$106087dcfd4fb129);
const $2e28f5c68ce7d201$export$60db61c485973ad9 = {
    granular: [
        ...(0, $4XB9o.baseScopesRequiredPerField).granular,
        'read:project-version:jira'
    ],
    coarse: [
        ...(0, $4XB9o.baseScopesRequiredPerField).coarse
    ]
};

});

parcelRegister("2xymT", function(module, exports) {

$parcel$export(module.exports, "getCommonFieldValidators", () => $b3ce4d907a850501$export$68248012b0fecf7d);
$parcel$export(module.exports, "validateSetOptionsVisibilityRule", () => $b3ce4d907a850501$export$cb8a43658ea03ec7);

var $hYZXM = parcelRequire("hYZXM");

var $iNF54 = parcelRequire("iNF54");

var $h1jSL = parcelRequire("h1jSL");

var $fN5n7 = parcelRequire("fN5n7");

var $8xPow = parcelRequire("8xPow");

var $bM27I = parcelRequire("bM27I");
const $b3ce4d907a850501$export$68248012b0fecf7d = ()=>({
        fieldName: (value)=>typeof value === 'string',
        isVisible: (value)=>typeof value === 'boolean',
        description: $b3ce4d907a850501$export$b5ccb7b3af83de7e,
        isReadOnly: (value, { isReadOnlyBySystem: isReadOnlyBySystem })=>typeof value === 'boolean' && (value || !value && !isReadOnlyBySystem),
        isRequired: (value, { isRequiredBySystem: isRequiredBySystem })=>typeof value === 'boolean' && (value || !value && !isRequiredBySystem)
    });
const $b3ce4d907a850501$export$b5ccb7b3af83de7e = async (value)=>{
    if (typeof value !== 'string') return false;
    if (value === '') return true;
    // turn into ADF
    try {
        const adfValue = await (0, $iNF54.convertWikiToAdfAsync)(value);
        if (!adfValue) return false;
        // find image nodes that contain external URLs.
        (0, $hYZXM.traverse)(adfValue, {
            media: (node)=>{
                if (node.attrs?.type === 'external' && node.attrs.url !== undefined) // ADF cannot contain external urls due to the possibility of data egress.
                throw new (0, $fN5n7.ExternalImageValidationError)('Cannot contain external images');
            }
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        // ExternalImageValidationError will be thrown if there is an external image
        if (!(err instanceof (0, $fN5n7.ExternalImageValidationError))) // TODO: use valid value of issueType instead of undefined in fireIAErrorAnalytics call. There is a task for it - https://ecosystem-platform.atlassian.net/browse/UIM-1651;
        (0, $h1jSL.fireIAErrorAnalytics)({
            error: err,
            id: 'descriptionWikiValidationException',
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
            viewType: undefined,
            attributes: {
                errorCause: err?.cause,
                message: err.message
            }
        });
        return false;
    }
    return true;
};
const $b3ce4d907a850501$export$cb8a43658ea03ec7 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
optionsVisibility)=>(0, $bM27I.isObject)(optionsVisibility) && typeof optionsVisibility.isVisible === 'boolean' && Array.isArray(optionsVisibility.options) && optionsVisibility.options.every((0, $8xPow.isNotEmptyString));

});
parcelRegister("hYZXM", function(module, exports) {

$parcel$export(module.exports, "traverse", () => $ed8bc6cb8f4f14d7$export$df3f009e3d155b20);
function $ed8bc6cb8f4f14d7$export$735cfea22ce30f58(_visitors) {
    return true;
}
function $ed8bc6cb8f4f14d7$export$df3f009e3d155b20(adf, visitors) {
    if (!$ed8bc6cb8f4f14d7$export$735cfea22ce30f58(visitors)) throw new Error(`Visitors are not valid: "${Object.keys(visitors).join(', ')}"`);
    return $ed8bc6cb8f4f14d7$var$traverseNode(adf, {
        node: undefined
    }, visitors, 0, 0);
}
function $ed8bc6cb8f4f14d7$var$traverseNode(adfNode, parent, visitors, index, depth) {
    const visitor = visitors[adfNode.type] || visitors['any'];
    let newNode = {
        ...adfNode
    };
    if (visitor) {
        const processedNode = visitor({
            ...newNode
        }, parent, index, depth);
        if (processedNode === false) return false;
        newNode = processedNode || adfNode;
    }
    if (newNode.content) newNode.content = newNode.content.reduce((acc, node, idx)=>{
        if (!node) return acc;
        const processedNode = $ed8bc6cb8f4f14d7$var$traverseNode(node, {
            node: newNode,
            parent: parent
        }, visitors, idx, depth + 1);
        if (processedNode !== false) acc.push(processedNode);
        return acc;
    }, []);
    return newNode;
}

});

parcelRegister("iNF54", function(module, exports) {

$parcel$export(module.exports, "convertWikiToAdfAsync", () => $75db0e1c09df6ee1$export$8e1b3b0130ee3556);



const $75db0e1c09df6ee1$export$8e1b3b0130ee3556 = async (wiki)=>{
    if (wiki === null || wiki === undefined || wiki === '') return Promise.resolve(null);
    const wikiPromise = await Promise.resolve((parcelRequire("fjUC0")));
    const schemaPromise = await Promise.resolve((parcelRequire("9wcjJ")));
    const jsonPromise = await Promise.resolve((parcelRequire("3M3qX")));
    const [{ defaultSchema: defaultSchema }, { WikiMarkupTransformer: WikiMarkupTransformer }, { JSONTransformer: JSONTransformer }] = await Promise.all([
        schemaPromise,
        wikiPromise,
        jsonPromise
    ]);
    const wikiTransformer = new WikiMarkupTransformer(defaultSchema);
    const adfTransformer = new JSONTransformer();
    const pmNode = wikiTransformer.parse(wiki);
    return adfTransformer.encode(pmNode);
};

});

parcelRegister("fN5n7", function(module, exports) {

$parcel$export(module.exports, "ExternalImageValidationError", () => $2acabb1059cc5ecc$export$af6b052883945124);
class $2acabb1059cc5ecc$export$af6b052883945124 extends Error {
}

});

parcelRegister("bM27I", function(module, exports) {

$parcel$export(module.exports, "isObject", () => $26654f2e3eecc1da$export$a6cdc56e425d0d0a);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $26654f2e3eecc1da$export$a6cdc56e425d0d0a = (value)=>typeof value === 'object' && value !== null;

});


parcelRegister("8TLBS", function(module, exports) {

$parcel$export(module.exports, "transformSetValueCascadingSelect", () => $403aed697acc707b$export$905a8d55c641a71e);
$parcel$export(module.exports, "transformGetValueCascadingSelect", () => $403aed697acc707b$export$47e9770ed0d1c344);

var $2Vsz9 = parcelRequire("2Vsz9");

var $8xPow = parcelRequire("8xPow");

var $9DCyM = parcelRequire("9DCyM");
const $403aed697acc707b$var$findCascadingSelectLookupValues = (lookupData, parentId, childId)=>{
    const foundOption = lookupData.find((currentOption)=>currentOption.parentOptionValue.id === parentId);
    if (!foundOption) throw new (0, $2Vsz9.FieldValueLookupError)();
    const value = {
        parent: foundOption.parentOptionValue,
        child: childId !== null ? (0, $9DCyM.singleValueLookup)(childId, foundOption.childOptionValues, 'id') : childId
    };
    return value;
};
const $403aed697acc707b$export$905a8d55c641a71e = (value, allowedValues)=>{
    if (value === null) return null;
    const cascadingSelectValue = $403aed697acc707b$var$findCascadingSelectLookupValues(allowedValues, value.parentId, value.childId);
    if (!(0, $8xPow.isNotEmptyString)(cascadingSelectValue.parent.value)) throw new (0, $2Vsz9.FieldValueLookupError)();
    return {
        label: cascadingSelectValue.parent.value,
        value: cascadingSelectValue.parent.id,
        child: cascadingSelectValue.child ? {
            label: cascadingSelectValue.child.value,
            value: cascadingSelectValue.child.id
        } : null
    };
};
const $403aed697acc707b$export$47e9770ed0d1c344 = (cascadingValue)=>{
    if (!cascadingValue) return null;
    const { label: label, value: value, child: child } = cascadingValue;
    return child?.label && child?.value ? {
        parent: {
            id: value,
            value: label
        },
        child: {
            id: child.value,
            value: child.label
        }
    } : {
        parent: {
            id: value,
            value: label
        },
        child: null
    };
};

});

parcelRegister("f8ZvF", function(module, exports) {

$parcel$export(module.exports, "validateComponentsSetValue", () => $ada74a8f069458d4$export$c65e64c3a855d5d2);
$parcel$export(module.exports, "componentsGetValueTransformer", () => $ada74a8f069458d4$export$b6f14754491cc7aa);
$parcel$export(module.exports, "componentsSetValueTransformer", () => $ada74a8f069458d4$export$777b614991f65d18);

var $2Vsz9 = parcelRequire("2Vsz9");

var $jgrDo = parcelRequire("jgrDo");

var $8xPow = parcelRequire("8xPow");

var $eF9ai = parcelRequire("eF9ai");
const $ada74a8f069458d4$export$c65e64c3a855d5d2 = (value)=>Array.isArray(value) && value.every((0, $8xPow.isNotEmptyString));
const $ada74a8f069458d4$export$b6f14754491cc7aa = (internalValue)=>{
    if (!internalValue) return [];
    return internalValue.map(({ value: id, label: name })=>({
            id: id,
            name: name
        }));
};
const $ada74a8f069458d4$export$777b614991f65d18 = (publicValue, lookupValues)=>{
    if (!publicValue.length) return [];
    const filteredLookupValues = (0, $eF9ai.multiValueLookup)(publicValue, lookupValues, 'id');
    if (publicValue.length !== filteredLookupValues.length) {
        const notFoundValues = (0, $jgrDo.getValueLookupValuesDiff)(publicValue, lookupValues, 'id');
        throw new (0, $2Vsz9.FieldValueLookupError)(notFoundValues.join());
    }
    return filteredLookupValues.map(({ id: value, name: label })=>({
            value: value,
            label: label
        }));
};

});
parcelRegister("jgrDo", function(module, exports) {

$parcel$export(module.exports, "getValueLookupValuesDiff", () => $6997272717cb1667$export$6ebcd48e99f6b85);
/**
 * Finds the difference between provided ids and the list of available entities, by returning a list of
 * ids that weren't found in that entities list
 *
 * @param value - the list of values search being made by
 * @param lookupValues - list of entities with full information about all valid ids
 * @param lookupKey - property name of the entity from the lookupValues list with which value will be compared
 */ const $6997272717cb1667$export$6ebcd48e99f6b85 = (value, // eslint-disable-next-line @typescript-eslint/no-explicit-any
lookupValues = [], lookupKey)=>value.filter((id)=>!lookupValues.some((option)=>option[lookupKey] === id));

});

parcelRegister("eF9ai", function(module, exports) {

$parcel$export(module.exports, "multiValueLookup", () => $46ed71582596a5f2$export$12a8af52bc9e513e);
/**
 * Finds multiple entities from a provided list of entities
 *
 * @param value - the list of values search being made by
 * @param lookupValues - list of entities where search is being made
 * @param lookupKey - property name of the entity from the lookupValues list with which value will be compared
 */ const $46ed71582596a5f2$export$12a8af52bc9e513e = (value, // eslint-disable-next-line @typescript-eslint/no-explicit-any
lookupValues = [], lookupKey)=>lookupValues.filter((option)=>value.includes(option[lookupKey]));

});


parcelRegister("9lHpT", function(module, exports) {

$parcel$export(module.exports, "validateDescriptionAndParagraphSetValue", () => $b801949b1978c966$export$55c0a47975b0f67);
$parcel$export(module.exports, "descriptionAndParagraphSetValueTransformer", () => $b801949b1978c966$export$8596d284a0b8650f);
$parcel$export(module.exports, "descriptionAndParagraphGetValueTransformer", () => $b801949b1978c966$export$736f124bc0a7d673);

var $kFGm5 = parcelRequire("kFGm5");

var $9tBd5 = parcelRequire("9tBd5");


var $cw2gk = parcelRequire("cw2gk");
const $b801949b1978c966$export$55c0a47975b0f67 = (value, { fieldRenderer: fieldRenderer }, _createAnalyticsEvent, extra)=>{
    switch(fieldRenderer){
        case 0, $c059ef17c7f90619$export$31a6c27df1f927b2:
            return (0, $cw2gk.isValidADF)({
                newValue: value,
                currentValue: extra.currentField?.value,
                viewType: extra.viewType
            });
        case 0, $c059ef17c7f90619$export$95433ac963f4aebe:
            return Promise.resolve(typeof value === 'string');
        default:
            return Promise.resolve(false);
    }
};
const $b801949b1978c966$export$8596d284a0b8650f = (value)=>{
    if (typeof value === 'string') return value;
    return {
        ...value,
        overrideRequired: true
    };
};
const $b801949b1978c966$export$736f124bc0a7d673 = (value, fieldRenderer)=>{
    if (value === undefined) // The `convertTextToAdf` call will give us an "empty ADF object":
    // {
    //   "type": "doc",
    //   "version": 1,
    //   "content": [
    //     {
    //       "type": "paragraph",
    //       "content": []
    //     }
    //   ]
    // }
    return fieldRenderer === (0, $c059ef17c7f90619$export$31a6c27df1f927b2) ? (0, $9tBd5.convertTextToAdf)('') : '';
    if (typeof value === 'string') return value;
    return (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(value, 'overrideRequired');
};

});
parcelRegister("9tBd5", function(module, exports) {

$parcel$export(module.exports, "convertTextToAdf", () => $61e37c91a1a26fa0$export$c10cf32c4acc1d57);

var $7MIXN = parcelRequire("7MIXN");
var $cSalc = parcelRequire("cSalc");

var $esUXI = parcelRequire("esUXI");
const $61e37c91a1a26fa0$export$c10cf32c4acc1d57 = (text)=>{
    if (text === '') return (0, $esUXI.getEmptyADF)();
    return (0, $7MIXN.doc)((0, $cSalc.paragraph)(text));
};

});
parcelRegister("7MIXN", function(module, exports) {

$parcel$export(module.exports, "doc", () => $4f7b6cd47961b649$export$2a111da947c407d2);
const $4f7b6cd47961b649$export$2a111da947c407d2 = (...content)=>({
        type: 'doc',
        version: 1,
        content: content
    });

});

parcelRegister("cSalc", function(module, exports) {

$parcel$export(module.exports, "paragraph", () => $57b33af9e28257e2$export$9c206ddddb32a9b);

var $c9ddq = parcelRequire("c9ddq");
const $57b33af9e28257e2$export$9c206ddddb32a9b = (...content)=>({
        type: 'paragraph',
        content: (0, $c9ddq.createTextNodes)(content)
    });

});
parcelRegister("c9ddq", function(module, exports) {

$parcel$export(module.exports, "createTextNodes", () => $4ae8175d6e70d2ef$export$3a269a5941b62f04);

var $abyJE = parcelRequire("abyJE");
function $4ae8175d6e70d2ef$export$3a269a5941b62f04(nodes) {
    return nodes.map($4ae8175d6e70d2ef$export$72b9432ea0656b50);
}
function $4ae8175d6e70d2ef$export$72b9432ea0656b50(str) {
    return typeof str === 'string' ? (0, $abyJE.text)(str) : str;
}

});
parcelRegister("abyJE", function(module, exports) {

$parcel$export(module.exports, "text", () => $22c1ededacc2b8bf$export$6f093cfa640b7166);
const $22c1ededacc2b8bf$export$6f093cfa640b7166 = (text)=>({
        type: 'text',
        text: text
    });

});




/**
 * `graphql-field-type` are a duplicate of `graphql-field-types` from `@atlassian/jira-issue-create`
 * located in src/packages/issue-create/issue-create-modal/src/common/constants/graphql-field-types.tsx
 * This was done to prevent cyclic dependencies between packages.
 * Only field types the UIM currently support or plan to support were taken from the referenced file.
 */ // graphql __typename
const $c059ef17c7f90619$export$2d5a62a3515ad4c6 = 'JiraIssueTypeField';
const $c059ef17c7f90619$export$23ca38ad884e35f1 = 'JiraSingleLineTextField';
const $c059ef17c7f90619$export$31a6c27df1f927b2 = 'JiraRichTextField';
const $c059ef17c7f90619$export$30b2c2de5e3007a4 = 'JiraComponentsField';
const $c059ef17c7f90619$export$3849bb04b4eee607 = 'JiraSingleSelectUserPickerField';
const $c059ef17c7f90619$export$eca94ae30cb92d8 = 'JiraMultipleSelectUserPickerField';
const $c059ef17c7f90619$export$2bb9d057bad89bfa = 'JiraPeopleField';
const $c059ef17c7f90619$export$64c7789e86344de5 = 'JiraLabelsField';
const $c059ef17c7f90619$export$de14210faa5f2099 = 'JiraPriorityField';
const $c059ef17c7f90619$export$e0b268941120d761 = 'JiraDatePickerField';
const $c059ef17c7f90619$export$f2b56433dc0af401 = 'JiraUrlField';
const $c059ef17c7f90619$export$d10237d945259f96 = 'JiraCheckboxesField';
const $c059ef17c7f90619$export$27854f490d658fc4 = 'JiraRadioSelectField';
const $c059ef17c7f90619$export$fb8861017089d392 = 'JiraSingleSelectField';
const $c059ef17c7f90619$export$2055419ff013de79 = 'JiraMultipleSelectField';
const $c059ef17c7f90619$export$f7a08bf17a7ac661 = 'JiraAssigneeField';
const $c059ef17c7f90619$export$d64150fd9c66969c = 'JiraReporterField';
const $c059ef17c7f90619$export$95433ac963f4aebe = 'JiraTextAreaField';

parcelRegister("cw2gk", function(module, exports) {

$parcel$export(module.exports, "isValidADF", () => $1fdb475b2c590568$export$94ea512f7afe62e4);

var $2UdGp = parcelRequire("2UdGp");

var $hTLlD = parcelRequire("hTLlD");

var $7MIXN = parcelRequire("7MIXN");

var $hYZXM = parcelRequire("hYZXM");

var $2bv99 = parcelRequire("2bv99");

const $1fdb475b2c590568$var$getADFValidator = async ()=>{
    const { validator: validator } = await (parcelRequire("hRMDl"));
    return validator;
};
const $1fdb475b2c590568$var$validateAdfExternalUrls = (adf)=>{
    try {
        (0, $hYZXM.traverse)(adf, {
            media: (node)=>{
                if (node.attrs?.type === 'external' && node.attrs?.url !== undefined) throw new Error('Cannot contain external images');
            },
            blockCard: ()=>{
                throw new Error('Cannot contain blockCard');
            },
            embedCard: ()=>{
                throw new Error('Cannot contain embedCard');
            }
        });
        return true;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        return false;
    }
};
const $1fdb475b2c590568$export$6f13dd7501a16a00 = (newValue, currentValue)=>{
    // If there is no user input or defaultValue set, we just validate the `externalValue` directly
    if (!currentValue || !currentValue.content.length) return $1fdb475b2c590568$var$validateAdfExternalUrls(newValue);
    // Find the diff nodes between the new value and the current value
    const foundDiffNodes = (0, (/*@__PURE__*/$parcel$interopDefault($2UdGp)))(newValue.content, currentValue.content, (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD))));
    // Format `foundDiffNodes` into a valid ADF doc
    const formattedDiffAdf = (0, $7MIXN.doc)(...foundDiffNodes);
    return $1fdb475b2c590568$var$validateAdfExternalUrls(formattedDiffAdf);
};
const $1fdb475b2c590568$export$94ea512f7afe62e4 = async ({ newValue: newValue, currentValue: currentValue, viewType: viewType })=>{
    const validator = await $1fdb475b2c590568$var$getADFValidator();
    const validate = validator();
    const validationStartTime = performance.now();
    try {
        const isValidAdfNewValue = // Additionaly to ADF validator it chekcs version property since ADF validator checks only existance of it.
        Object.hasOwnProperty.call(newValue, 'version') && typeof newValue.version === 'number' && !Number.isNaN(newValue.version) && validate(newValue).valid;
        const isValidAdf = isValidAdfNewValue && $1fdb475b2c590568$export$6f13dd7501a16a00(newValue, currentValue);
        (0, $2bv99.fireOperationalAnalyticsWithoutContext)('adfValidation', 'completed', viewType, {
            validatedInMs: Math.floor(performance.now() - validationStartTime)
        });
        return isValidAdf;
    } catch (e) {
        return false;
    }
};

});
parcelRegister("2UdGp", function(module, exports) {

var $fa0Ox = parcelRequire("fa0Ox");

var $hKE3p = parcelRequire("hKE3p");

var $9eFtX = parcelRequire("9eFtX");

var $cRpul = parcelRequire("cRpul");

var $iTvqy = parcelRequire("iTvqy");
/**
 * This method is like `_.difference` except that it accepts `comparator`
 * which is invoked to compare elements of `array` to `values`. The order and
 * references of result values are determined by the first array. The comparator
 * is invoked with two arguments: (arrVal, othVal).
 *
 * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 *
 * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
 * // => [{ 'x': 2, 'y': 1 }]
 */ var $21db6ce926da14e3$var$differenceWith = $9eFtX(function(array, values) {
    var comparator = $iTvqy(values);
    if ($cRpul(comparator)) comparator = undefined;
    return $cRpul(array) ? $fa0Ox(array, $hKE3p(values, 1, $cRpul, true), undefined, comparator) : [];
});
module.exports = $21db6ce926da14e3$var$differenceWith;

});

parcelRegister("hRMDl", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('b0ymx');
        const value = parcelRequire('kItdj');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("b0ymx").then(()=>parcelRequire('kItdj'));
}

});



parcelRegister("4WWvu", function(module, exports) {

$parcel$export(module.exports, "issueTypeSetValueTransformer", () => $eaa6af66d18c4d64$export$93e4fd33c48f4977);
$parcel$export(module.exports, "issueTypeGetValueTransformer", () => $eaa6af66d18c4d64$export$391657d4e7f81237);
$parcel$export(module.exports, "transformIssueTypeSetOptionsVisibility", () => $eaa6af66d18c4d64$export$db493bcecec5fb56);
$parcel$export(module.exports, "transformIssueTypeGetOptionsVisibility", () => $eaa6af66d18c4d64$export$3a886340b0f20858);

var $2Vsz9 = parcelRequire("2Vsz9");

var $240Nk = parcelRequire("240Nk");

var $j55UJ = parcelRequire("j55UJ");

var $9DCyM = parcelRequire("9DCyM");
const $eaa6af66d18c4d64$export$93e4fd33c48f4977 = (value, lookupValues)=>{
    const lookupValue = (0, $9DCyM.singleValueLookup)(value, lookupValues, 'value');
    if (!lookupValue) throw new (0, $2Vsz9.FieldValueLookupError)();
    return {
        iconUrl: lookupValue.iconUrl,
        label: lookupValue.label,
        value: lookupValue.value
    };
};
const $eaa6af66d18c4d64$export$391657d4e7f81237 = (value)=>{
    /**
	 * Switching between projects with UIM context doesn't reset the IA context in a timely
	 * manner, that's why we still have `adjustmentsAreEnabled` resulting in `true` even
	 * though the context should have been reset and the undecorated component should have rendered first.
	 * As a result, issue type field sends `null` as a value to the value decorator just
	 * before the context reset is being triggered.
	 * `null` won't be sent to jira-bridge because after the context is reset, the actual issue type option is being set.
	 */ if (!value) return null;
    return {
        id: value.value,
        name: value.label
    };
};
const $eaa6af66d18c4d64$export$db493bcecec5fb56 = (optionsVisibility, lookupValues)=>(0, $240Nk.applyOptionsVisibilityRule)(optionsVisibility, lookupValues, 'value');
const $eaa6af66d18c4d64$export$3a886340b0f20858 = (optionsVisibility, lookupValues)=>(0, $j55UJ.getAvailableOptionsVisibilityRule)(optionsVisibility, lookupValues, 'value');

});
parcelRegister("240Nk", function(module, exports) {

$parcel$export(module.exports, "applyOptionsVisibilityRule", () => $2a0f351d50eb18bb$export$642f3f0b0177721e);
const $2a0f351d50eb18bb$export$642f3f0b0177721e = ({ options: options, isVisible: isVisible }, lookupValues = [], optionKey)=>isVisible ? lookupValues.filter((value)=>options.includes(value[optionKey])) : lookupValues.filter((value)=>!options.includes(value[optionKey]));

});

parcelRegister("j55UJ", function(module, exports) {

$parcel$export(module.exports, "getAvailableOptionsVisibilityRule", () => $faf933437c2b998e$export$d614c43ae91f42cd);
const $faf933437c2b998e$export$d614c43ae91f42cd = ({ options: options, isVisible: isVisible }, lookupValues = [], optionKey)=>({
        isVisible: isVisible,
        options: options.filter((option)=>lookupValues.some((value)=>value[optionKey] === option))
    });

});


parcelRegister("48mC7", function(module, exports) {

$parcel$export(module.exports, "transformMultiCheckboxSetOptionsVisibility", () => $6ba40f250c6b77ad$export$115a0b8c81087c2c);
$parcel$export(module.exports, "transformMultiCheckboxGetOptionsVisibility", () => $6ba40f250c6b77ad$export$4471ab017a7abd7);
$parcel$export(module.exports, "validateMultiCheckboxSetValue", () => $6ba40f250c6b77ad$export$56639f1c650d9ba5);
$parcel$export(module.exports, "multiCheckboxSetValueTransformer", () => $6ba40f250c6b77ad$export$9ba1ee83cc9456ba);
$parcel$export(module.exports, "multiCheckboxGetValueTransformer", () => $6ba40f250c6b77ad$export$6d15ce1cc0bdffe7);

var $2Vsz9 = parcelRequire("2Vsz9");

var $240Nk = parcelRequire("240Nk");

var $j55UJ = parcelRequire("j55UJ");

var $jgrDo = parcelRequire("jgrDo");

var $8xPow = parcelRequire("8xPow");

var $eF9ai = parcelRequire("eF9ai");
const $6ba40f250c6b77ad$export$115a0b8c81087c2c = (optionsVisibility, lookupValues)=>(0, $240Nk.applyOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
const $6ba40f250c6b77ad$export$4471ab017a7abd7 = (optionsVisibility, lookupValues)=>(0, $j55UJ.getAvailableOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
const $6ba40f250c6b77ad$export$56639f1c650d9ba5 = (value)=>Array.isArray(value) && value.every((0, $8xPow.isNotEmptyString));
const $6ba40f250c6b77ad$export$9ba1ee83cc9456ba = (publicValue, allowedValues)=>{
    if (!publicValue.length) return [];
    const foundValue = (0, $eF9ai.multiValueLookup)(publicValue, allowedValues, 'id');
    if (foundValue.length !== publicValue.length) {
        const notFoundValues = (0, $jgrDo.getValueLookupValuesDiff)(publicValue, foundValue, 'id');
        throw new (0, $2Vsz9.FieldValueLookupError)(notFoundValues.join());
    }
    return foundValue.map(({ value: value, id: id })=>({
            label: value,
            value: id
        }));
};
const $6ba40f250c6b77ad$export$6d15ce1cc0bdffe7 = (internalValue)=>{
    if (!internalValue) return [];
    return internalValue.map(({ value: value, label: label })=>({
            id: value,
            value: label
        }));
};

});

parcelRegister("l29kV", function(module, exports) {

$parcel$export(module.exports, "transformMultiSelectSetOptionsVisibility", () => $61d58bb7e967fbc8$export$464f5c048bb44fae);
$parcel$export(module.exports, "transformMultiSelectGetOptionsVisibility", () => $61d58bb7e967fbc8$export$16ec76c8ef15bfca);
$parcel$export(module.exports, "validateMultiSelectSetValue", () => $61d58bb7e967fbc8$export$7002ea8d8a6dd444);
$parcel$export(module.exports, "multiSelectSetValueTransformer", () => $61d58bb7e967fbc8$export$87ccfa5280a3288f);
$parcel$export(module.exports, "multiSelectGetValueTransformer", () => $61d58bb7e967fbc8$export$9992ce1903b64c5);

var $2Vsz9 = parcelRequire("2Vsz9");

var $240Nk = parcelRequire("240Nk");

var $j55UJ = parcelRequire("j55UJ");

var $jgrDo = parcelRequire("jgrDo");

var $8xPow = parcelRequire("8xPow");

var $eF9ai = parcelRequire("eF9ai");
const $61d58bb7e967fbc8$export$464f5c048bb44fae = (optionsVisibility, lookupValues)=>(0, $240Nk.applyOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
const $61d58bb7e967fbc8$export$16ec76c8ef15bfca = (optionsVisibility, lookupValues)=>(0, $j55UJ.getAvailableOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
const $61d58bb7e967fbc8$export$7002ea8d8a6dd444 = (value)=>Array.isArray(value) && value.every((0, $8xPow.isNotEmptyString));
const $61d58bb7e967fbc8$export$87ccfa5280a3288f = (values, lookupValues)=>{
    if (!values.length) return [];
    const filteredValues = (0, $eF9ai.multiValueLookup)(values, lookupValues, 'id');
    if (filteredValues.length !== values.length) {
        const notFoundValues = (0, $jgrDo.getValueLookupValuesDiff)(values, filteredValues, 'id');
        throw new (0, $2Vsz9.FieldValueLookupError)(notFoundValues.join());
    }
    return filteredValues.map((val)=>({
            label: val.value,
            value: val.id
        }));
};
const $61d58bb7e967fbc8$export$9992ce1903b64c5 = (internalValue)=>{
    if (!internalValue) return [];
    return internalValue.map(({ value: value, label: label })=>({
            id: value,
            value: label
        }));
};

});

parcelRegister("jJReM", function(module, exports) {

$parcel$export(module.exports, "multiUserPickerSetValueValidator", () => $634c9a1b5c875da9$export$161337c705ff4d65);
$parcel$export(module.exports, "multiUserPickerSetValueTransformer", () => $634c9a1b5c875da9$export$206658c0c308733e);
$parcel$export(module.exports, "multiUserPickerGetValueTransformer", () => $634c9a1b5c875da9$export$68e3fe5737fc7137);

var $2Vsz9 = parcelRequire("2Vsz9");

var $jgrDo = parcelRequire("jgrDo");

var $fBuJM = parcelRequire("fBuJM");

var $8xPow = parcelRequire("8xPow");

var $eF9ai = parcelRequire("eF9ai");
const $634c9a1b5c875da9$export$161337c705ff4d65 = (value)=>Array.isArray(value) && // We should omit automatic id special value so it won't be picked up by this field
    // It is only applicable to the assignee field
    value.every((option)=>(0, $8xPow.isNotEmptyString)(option) && (0, $fBuJM.isNotAutomaticId)(option));
const $634c9a1b5c875da9$export$206658c0c308733e = (values, lookupValues)=>{
    if (!values.length) return [];
    const filteredLookupValues = (0, $eF9ai.multiValueLookup)(values, lookupValues, 'accountId');
    if (values.length !== filteredLookupValues.length) {
        const notFoundValues = (0, $jgrDo.getValueLookupValuesDiff)(values, filteredLookupValues, 'accountId');
        throw new (0, $2Vsz9.FieldValueLookupError)(notFoundValues.join());
    }
    return filteredLookupValues.map(({ accountId: id, name: name, picture: avatarUrl })=>({
            id: id,
            name: name,
            avatarUrl: avatarUrl
        }));
};
const $634c9a1b5c875da9$export$68e3fe5737fc7137 = (value)=>{
    if (!value) return [];
    return value.map(({ id: id })=>({
            accountId: id
        }));
};

});

parcelRegister("iLshM", function(module, exports) {

$parcel$export(module.exports, "transformNumberToInternalValue", () => $a1a418ce68cea4d2$export$bdbd8c4d6c9c2efe);
$parcel$export(module.exports, "transformNumberToPublicValue", () => $a1a418ce68cea4d2$export$8bdc28b51a4acc44);
$parcel$export(module.exports, "numberIssueGicScopes", () => $a1a418ce68cea4d2$export$b7e1c026b8f78970);

var $htzHC = parcelRequire("htzHC");
const $a1a418ce68cea4d2$export$bdbd8c4d6c9c2efe = (publicValue)=>publicValue === null ? '' : String(publicValue);
const $a1a418ce68cea4d2$export$8bdc28b51a4acc44 = (internalValue)=>[
        undefined,
        ''
    ].includes(internalValue) ? null : Number(internalValue);
const $a1a418ce68cea4d2$export$b7e1c026b8f78970 = {
    ...(0, $htzHC.numberScopes),
    granular: [
        ...(0, $htzHC.numberScopes).granular,
        'write:field.default-value:jira'
    ]
};

});

parcelRegister("k1kz4", function(module, exports) {

$parcel$export(module.exports, "parentSetValueTransformer", () => $90bf3720d66e7be7$export$a65d296b5d388a59);
$parcel$export(module.exports, "parentGetValueTransformer", () => $90bf3720d66e7be7$export$ea591224dc3a0141);

var $lPQPn = parcelRequire("lPQPn");

var $2Vsz9 = parcelRequire("2Vsz9");


var $5Xfbd = parcelRequire("5Xfbd");
async function $90bf3720d66e7be7$export$a65d296b5d388a59(value, _lookupValues, { tenantContext: tenantContext }) {
    if (value === null) return null;
    try {
        const parentIssueDetails = await (0, $5Xfbd.fetchParentIssueDetails)(tenantContext.cloudId, value);
        if (!parentIssueDetails) throw new (0, $2Vsz9.FieldValueLookupError)(`Parent issue with issueId "${value}" not found`, {
            cause: (0, $23d97971f71f1cd0$export$4a4db137834138dd)
        });
        const issue = parentIssueDetails.jira?.issueById;
        const fields = issue?.fieldsById?.edges;
        if (!issue || !issue.issueId || !issue.key || !fields) throw new (0, $2Vsz9.FieldValueLookupError)(`Error fetching data for parent issue with issueId "${value}"`, {
            cause: (0, $23d97971f71f1cd0$export$aa7d91b2fd1ba261)
        });
        let issueTypeField = null;
        let summaryField = null;
        let statusField = null;
        for (const field of fields){
            if ((0, $5Xfbd.isJiraIssueTypeFieldNode)(field?.node)) issueTypeField = field?.node ?? null;
            else if ((0, $5Xfbd.isJiraSingleLineTextFieldNode)(field?.node)) summaryField = field?.node ?? null;
            else if ((0, $5Xfbd.isJiraStatusFieldNode)(field?.node)) statusField = field?.node ?? null;
        }
        if (!issueTypeField || !summaryField || !statusField) throw new (0, $2Vsz9.FieldValueLookupError)(`Error fetching data for parent issue with issueId "${value}"`, {
            cause: (0, $23d97971f71f1cd0$export$aa7d91b2fd1ba261)
        });
        return {
            color: (0, $lPQPn.asColor)(parentIssueDetails.jira?.issueById?.issueColorField?.color?.colorKey) ?? undefined,
            value: parentIssueDetails.jira.issueById.issueId,
            isDone: (0, $5Xfbd.checkParentIssueIsDone)(statusField),
            key: parentIssueDetails.jira.issueById.key,
            label: summaryField.text,
            fields: {
                summary: summaryField.text ?? '',
                issuetype: {
                    id: issueTypeField.issueType?.issueTypeId ?? undefined,
                    name: issueTypeField.issueType?.name ?? undefined,
                    iconUrl: issueTypeField.issueType?.avatar?.xsmall ?? ''
                }
            }
        };
    } catch (error) {
        if (error instanceof Error && !('cause' in error)) error.cause = (0, $23d97971f71f1cd0$export$494a54d93664524d);
        if (error instanceof Error) throw new (0, $2Vsz9.FieldValueLookupError)(error.message, {
            cause: error.cause
        });
        throw error;
    }
}
function $90bf3720d66e7be7$export$ea591224dc3a0141(intervalValue) {
    if (!intervalValue) return null;
    return {
        id: intervalValue.value.toString(),
        key: intervalValue.key
    };
}

});
parcelRegister("lPQPn", function(module, exports) {

$parcel$export(module.exports, "asColor", () => $66f7283bb625ccc7$export$b74af6529f09947);
$parcel$export(module.exports, "asServerColor", () => $66f7283bb625ccc7$export$442690a499ee9598);
$parcel$export(module.exports, "asClassicEpicColor", () => $66f7283bb625ccc7$export$eb754032c0b9698c);
$parcel$export(module.exports, "transformColorToTheme", () => $66f7283bb625ccc7$export$37c9bd72afe7f286);
$parcel$export(module.exports, "getValueFromColor", () => $66f7283bb625ccc7$export$a00423580059ae28);
$parcel$export(module.exports, "getColorFromValue", () => $66f7283bb625ccc7$export$6d14528e40cbe34b);
$parcel$export(module.exports, "toFrontendColor", () => $66f7283bb625ccc7$export$574e4dbf3c01f0ad);
$parcel$export(module.exports, "toBackendColor", () => $66f7283bb625ccc7$export$47af25386a01de1);
$parcel$export(module.exports, "classicToFrontendColor", () => $66f7283bb625ccc7$export$8f81207f7ac5fb9a);
$parcel$export(module.exports, "classicToBackendColor", () => $66f7283bb625ccc7$export$28fb68bb1de025d5);
$parcel$export(module.exports, "getDefaultColorPalette", () => $66f7283bb625ccc7$export$f6e067d5c418081a);
$parcel$export(module.exports, "getLozengeThemeByColor", () => $66f7283bb625ccc7$export$949dc67535a8ff2);
$parcel$export(module.exports, "getRandomColor", () => $66f7283bb625ccc7$export$e4369cabd7e84cd9);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $aXGkF = parcelRequire("aXGkF");

var $tgbCK = parcelRequire("tgbCK");

var $hNY9X = parcelRequire("hNY9X");

var $opsFH = parcelRequire("opsFH");
const $66f7283bb625ccc7$export$b74af6529f09947 = (color)=>{
    if (color == null) return (0, $opsFH.Colors).PURPLE;
    if (color in (0, $opsFH.Colors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $tgbCK.MAP_FROM_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_SERVER_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_AGILE_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color];
    return (0, $opsFH.Colors).PURPLE;
};
const $66f7283bb625ccc7$export$442690a499ee9598 = (color)=>{
    if (color == null) return (0, $opsFH.ServerColors).SERVER_PURPLE;
    if (color in (0, $opsFH.ServerColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_AGILE_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)[(0, $tgbCK.MAP_FROM_AGILE_COLOR)[color]];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)) return (0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    return (0, $opsFH.ServerColors).SERVER_PURPLE;
};
const $66f7283bb625ccc7$export$eb754032c0b9698c = (color)=>{
    if (color === null) return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $opsFH.Colors).PURPLE];
    if (color in (0, $opsFH.ClassicEpicColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $tgbCK.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $tgbCK.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_AGILE_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $tgbCK.MAP_FROM_AGILE_COLOR)[color]];
    // i.e: ghx-label-7
    return (0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $opsFH.Colors).PURPLE];
};
const $66f7283bb625ccc7$export$1a0a4af71e00cea4 = (color)=>{
    if (color === null) return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $opsFH.Colors).PURPLE];
    if (color in (0, $opsFH.AgileColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[color];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $tgbCK.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)) return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    // i.e: color_7
    return (0, $tgbCK.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $opsFH.Colors).PURPLE];
};
const $66f7283bb625ccc7$export$37c9bd72afe7f286 = (transformation, colorSchemaExtension)=>{
    const newColorSchema = {
        ...(0, $tgbCK.BASE_COLOR_SCHEMA),
        ...colorSchemaExtension
    };
    const extendedColors = (colorSchemaExtension ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys(colorSchemaExtension) : []).concat(Object.keys((0, $opsFH.Colors)));
    return extendedColors.reduce((obj, color)=>({
            ...obj,
            [color]: transformation(newColorSchema[color])
        }), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {});
};
const $66f7283bb625ccc7$export$a00423580059ae28 = (color)=>(0, $tgbCK.MAP_COLORS_TO_VALUE)[color] || (0, $tgbCK.MAP_COLORS_TO_VALUE)[0, $opsFH.PURPLE];
const $66f7283bb625ccc7$export$6d14528e40cbe34b = (value)=>// NOTE: lodash invert coerce the output to Dictionary<string> instead of using a polymorphic type
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Color'.
    (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))((0, $tgbCK.MAP_COLORS_TO_VALUE))[value] || (0, $opsFH.PURPLE);
const $66f7283bb625ccc7$export$574e4dbf3c01f0ad = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $tgbCK.MAP_FROM_SERVER_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_COLOR)[colorStr] : (0, $opsFH.PURPLE);
const $66f7283bb625ccc7$export$47af25386a01de1 = (color)=>(0, $tgbCK.MAP_FROM_CLIENT_SERVER_COLOR)[color];
const $66f7283bb625ccc7$export$8f81207f7ac5fb9a = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $tgbCK.MAP_FROM_SERVER_CLASSIC_COLOR)[colorStr] : (0, $opsFH.PURPLE);
const $66f7283bb625ccc7$export$28fb68bb1de025d5 = (color)=>(0, $tgbCK.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
/**
 * Return default color palette
 */ const $66f7283bb625ccc7$var$paletteColorValues = $66f7283bb625ccc7$export$37c9bd72afe7f286((colorSchema)=>colorSchema.primary);
const $66f7283bb625ccc7$export$f6e067d5c418081a = (formatMessage)=>[
        {
            label: formatMessage((0, $hNY9X.default).purpleLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).PURPLE]
        },
        {
            label: formatMessage((0, $hNY9X.default).blueLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).BLUE]
        },
        {
            label: formatMessage((0, $hNY9X.default).greenLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).GREEN]
        },
        {
            label: formatMessage((0, $hNY9X.default).tealLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).TEAL]
        },
        {
            label: formatMessage((0, $hNY9X.default).yellowLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).YELLOW]
        },
        {
            label: formatMessage((0, $hNY9X.default).orangeLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).ORANGE]
        },
        {
            label: formatMessage((0, $hNY9X.default).greyLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).GREY]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkPurpleLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_PURPLE]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkBlueLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_BLUE]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkGreenLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_GREEN]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkTealLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_TEAL]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkYellowLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_YELLOW]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkOrangeLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_ORANGE]
        },
        {
            label: formatMessage((0, $hNY9X.default).darkGreyLabel),
            value: $66f7283bb625ccc7$var$paletteColorValues[(0, $opsFH.Colors).DARK_GREY]
        }
    ];
const $66f7283bb625ccc7$export$9b822862d986dfdf = $66f7283bb625ccc7$export$37c9bd72afe7f286((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $66f7283bb625ccc7$export$949dc67535a8ff2 = (color = (0, $tgbCK.DEFAULT_EPIC_COLOR))=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $66f7283bb625ccc7$export$9b822862d986dfdf[color] ?? $66f7283bb625ccc7$export$9b822862d986dfdf[0, $tgbCK.DEFAULT_EPIC_COLOR];
const $66f7283bb625ccc7$export$e4369cabd7e84cd9 = ()=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const colorKeys = Object.keys((0, $opsFH.Colors));
    return colorKeys[Math.floor(Math.random() * colorKeys.length)];
};

});
parcelRegister("aXGkF", function(module, exports) {

var $CAsD5 = parcelRequire("CAsD5");

var $eQ67w = parcelRequire("eQ67w");

var $3QMTK = parcelRequire("3QMTK");
/** Used for built-in method references. */ var $7fb0405f6a745d75$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $7fb0405f6a745d75$var$nativeObjectToString = $7fb0405f6a745d75$var$objectProto.toString;
/**
 * Creates an object composed of the inverted keys and values of `object`.
 * If `object` contains duplicate values, subsequent values overwrite
 * property assignments of previous values.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Object
 * @param {Object} object The object to invert.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invert(object);
 * // => { '1': 'c', '2': 'b' }
 */ var $7fb0405f6a745d75$var$invert = $eQ67w(function(result, value, key) {
    if (value != null && typeof value.toString != 'function') value = $7fb0405f6a745d75$var$nativeObjectToString.call(value);
    result[value] = key;
}, $CAsD5($3QMTK));
module.exports = $7fb0405f6a745d75$var$invert;

});
parcelRegister("eQ67w", function(module, exports) {

var $im19c = parcelRequire("im19c");
/**
 * Creates a function like `_.invertBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} toIteratee The function to resolve iteratees.
 * @returns {Function} Returns the new inverter function.
 */ function $acdaab61bed7cb96$var$createInverter(setter, toIteratee) {
    return function(object, iteratee) {
        return $im19c(object, setter, toIteratee(iteratee), {});
    };
}
module.exports = $acdaab61bed7cb96$var$createInverter;

});
parcelRegister("im19c", function(module, exports) {

var $piimr = parcelRequire("piimr");
/**
 * The base implementation of `_.invert` and `_.invertBy` which inverts
 * `object` with values transformed by `iteratee` and set by `setter`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform values.
 * @param {Object} accumulator The initial inverted object.
 * @returns {Function} Returns `accumulator`.
 */ function $d5cb2bea9036f464$var$baseInverter(object, setter, iteratee, accumulator) {
    $piimr(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
    });
    return accumulator;
}
module.exports = $d5cb2bea9036f464$var$baseInverter;

});



parcelRegister("tgbCK", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_EPIC_COLOR", () => $3e0c3a8718e9d782$export$c2357bec51c5cf5b);
$parcel$export(module.exports, "MAP_COLORS_TO_VALUE", () => $3e0c3a8718e9d782$export$db33d74b098e3da9);
$parcel$export(module.exports, "MAP_COLORS_TO_TOKEN", () => $3e0c3a8718e9d782$export$fc5fe4213a5703f1);
$parcel$export(module.exports, "MAP_VALUE_TO_COLOR", () => $3e0c3a8718e9d782$export$a6cb26e106674600);
$parcel$export(module.exports, "MAP_FROM_SERVER_COLOR", () => $3e0c3a8718e9d782$export$43264b0781f10167);
$parcel$export(module.exports, "MAP_FROM_CLIENT_SERVER_COLOR", () => $3e0c3a8718e9d782$export$aedca9f3a1ee43d7);
$parcel$export(module.exports, "MAP_FROM_SERVER_CLASSIC_COLOR", () => $3e0c3a8718e9d782$export$fb5d051fe1b2bccc);
$parcel$export(module.exports, "MAP_FROM_CLIENT_CLASSIC_COLOR", () => $3e0c3a8718e9d782$export$c13af2d9629c53d8);
$parcel$export(module.exports, "MAP_FROM_AGILE_COLOR", () => $3e0c3a8718e9d782$export$994d3ffa39be04fd);
$parcel$export(module.exports, "MAP_FROM_CLIENT_AGILE_COLOR", () => $3e0c3a8718e9d782$export$db17671bf37971e7);
$parcel$export(module.exports, "MAP_CLASSIC_COLOR_TO_AGILE_COLOR", () => $3e0c3a8718e9d782$export$1fdd5a248b5f697c);
$parcel$export(module.exports, "MAP_COLOR_TO_AK_COLOR", () => $3e0c3a8718e9d782$export$82fc3b0b98905453);
$parcel$export(module.exports, "MAP_AGILE_COLOR_TO_AK_COLOR", () => $3e0c3a8718e9d782$export$703aca53c431bb88);
$parcel$export(module.exports, "BASE_COLOR_SCHEMA", () => $3e0c3a8718e9d782$export$92b6aebfb522f0d9);

var $aXGkF = parcelRequire("aXGkF");

var $PdmhA = parcelRequire("PdmhA");

var $opsFH = parcelRequire("opsFH");
const $3e0c3a8718e9d782$export$c2357bec51c5cf5b = 'PURPLE';
const $3e0c3a8718e9d782$export$db33d74b098e3da9 = {
    [(0, $opsFH.PURPLE)]: `var(--ds-background-accent-purple-subtle, ${(0, $PdmhA).P200})`,
    [(0, $opsFH.BLUE)]: `var(--ds-background-accent-blue-subtle, ${(0, $PdmhA).B200})`,
    [(0, $opsFH.GREEN)]: `var(--ds-background-accent-green-subtle, ${(0, $PdmhA).G200})`,
    [(0, $opsFH.TEAL)]: `var(--ds-background-accent-teal-subtle, ${(0, $PdmhA).T200})`,
    [(0, $opsFH.YELLOW)]: `var(--ds-background-accent-yellow-subtle, ${(0, $PdmhA).Y200})`,
    [(0, $opsFH.ORANGE)]: `var(--ds-background-accent-red-subtle, ${(0, $PdmhA).R200})`,
    [(0, $opsFH.GREY)]: `var(--ds-background-accent-gray-subtle, ${(0, $PdmhA).N200})`,
    [(0, $opsFH.DARK_PURPLE)]: `var(--ds-background-accent-purple-bolder, ${(0, $PdmhA).P400})`,
    [(0, $opsFH.DARK_BLUE)]: `var(--ds-background-accent-blue-bolder, ${(0, $PdmhA).B400})`,
    [(0, $opsFH.DARK_GREEN)]: `var(--ds-background-accent-green-bolder, ${(0, $PdmhA).G400})`,
    [(0, $opsFH.DARK_TEAL)]: `var(--ds-background-accent-teal-bolder, ${(0, $PdmhA).T400})`,
    [(0, $opsFH.DARK_YELLOW)]: `var(--ds-background-accent-orange-bolder, ${(0, $PdmhA).Y400})`,
    [(0, $opsFH.DARK_ORANGE)]: `var(--ds-background-accent-red-bolder, ${(0, $PdmhA).R400})`,
    [(0, $opsFH.DARK_GREY)]: `var(--ds-background-accent-gray-bolder, ${(0, $PdmhA).N700})`
};
const $3e0c3a8718e9d782$export$fc5fe4213a5703f1 = {
    [(0, $PdmhA).P200]: `var(--ds-background-accent-purple-subtle, ${(0, $PdmhA).P200})`,
    [(0, $PdmhA).B200]: `var(--ds-background-accent-blue-subtle, ${(0, $PdmhA).B200})`,
    [(0, $PdmhA).G200]: `var(--ds-background-accent-green-subtle, ${(0, $PdmhA).G200})`,
    [(0, $PdmhA).T200]: `var(--ds-background-accent-teal-subtle, ${(0, $PdmhA).T200})`,
    [(0, $PdmhA).Y200]: `var(--ds-background-accent-yellow-subtle, ${(0, $PdmhA).Y200})`,
    [(0, $PdmhA).R200]: `var(--ds-background-accent-red-subtle, ${(0, $PdmhA).R200})`,
    [(0, $PdmhA).N200]: `var(--ds-background-accent-gray-subtle, ${(0, $PdmhA).N200})`,
    [(0, $PdmhA).P400]: `var(--ds-background-accent-purple-bolder, ${(0, $PdmhA).P400})`,
    [(0, $PdmhA).B400]: `var(--ds-background-accent-blue-bolder, ${(0, $PdmhA).B400})`,
    [(0, $PdmhA).G400]: `var(--ds-background-accent-green-bolder, ${(0, $PdmhA).G400})`,
    [(0, $PdmhA).T400]: `var(--ds-background-accent-teal-bolder, ${(0, $PdmhA).T400})`,
    [(0, $PdmhA).Y400]: `var(--ds-background-accent-orange-bolder, ${(0, $PdmhA).Y400})`,
    [(0, $PdmhA).R400]: `var(--ds-background-accent-red-bolder, ${(0, $PdmhA).R400})`,
    [(0, $PdmhA).N700]: `var(--ds-background-accent-gray-bolder, ${(0, $PdmhA).N700})`
};
const $3e0c3a8718e9d782$export$a6cb26e106674600 = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))($3e0c3a8718e9d782$export$db33d74b098e3da9);
const $3e0c3a8718e9d782$export$43264b0781f10167 = {
    [(0, $opsFH.SERVER_PURPLE)]: (0, $opsFH.PURPLE),
    [(0, $opsFH.SERVER_DARK_PURPLE)]: (0, $opsFH.DARK_PURPLE),
    [(0, $opsFH.SERVER_BLUE)]: (0, $opsFH.BLUE),
    [(0, $opsFH.SERVER_DARK_BLUE)]: (0, $opsFH.DARK_BLUE),
    [(0, $opsFH.SERVER_GREEN)]: (0, $opsFH.GREEN),
    [(0, $opsFH.SERVER_DARK_GREEN)]: (0, $opsFH.DARK_GREEN),
    [(0, $opsFH.SERVER_TEAL)]: (0, $opsFH.TEAL),
    [(0, $opsFH.SERVER_DARK_TEAL)]: (0, $opsFH.DARK_TEAL),
    [(0, $opsFH.SERVER_YELLOW)]: (0, $opsFH.YELLOW),
    [(0, $opsFH.SERVER_DARK_YELLOW)]: (0, $opsFH.DARK_YELLOW),
    [(0, $opsFH.SERVER_ORANGE)]: (0, $opsFH.ORANGE),
    [(0, $opsFH.SERVER_DARK_ORANGE)]: (0, $opsFH.DARK_ORANGE),
    [(0, $opsFH.SERVER_GREY)]: (0, $opsFH.GREY),
    [(0, $opsFH.SERVER_DARK_GREY)]: (0, $opsFH.DARK_GREY)
};
const $3e0c3a8718e9d782$export$aedca9f3a1ee43d7 = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))($3e0c3a8718e9d782$export$43264b0781f10167);
const $3e0c3a8718e9d782$export$fb5d051fe1b2bccc = {
    [(0, $opsFH.GHX_LABEL_1)]: (0, $opsFH.DARK_GREY),
    [(0, $opsFH.GHX_LABEL_2)]: (0, $opsFH.DARK_YELLOW),
    [(0, $opsFH.GHX_LABEL_3)]: (0, $opsFH.YELLOW),
    [(0, $opsFH.GHX_LABEL_4)]: (0, $opsFH.DARK_BLUE),
    [(0, $opsFH.GHX_LABEL_5)]: (0, $opsFH.DARK_TEAL),
    [(0, $opsFH.GHX_LABEL_6)]: (0, $opsFH.GREEN),
    [(0, $opsFH.GHX_LABEL_7)]: (0, $opsFH.PURPLE),
    [(0, $opsFH.GHX_LABEL_8)]: (0, $opsFH.DARK_PURPLE),
    [(0, $opsFH.GHX_LABEL_9)]: (0, $opsFH.ORANGE),
    [(0, $opsFH.GHX_LABEL_10)]: (0, $opsFH.BLUE),
    [(0, $opsFH.GHX_LABEL_11)]: (0, $opsFH.TEAL),
    [(0, $opsFH.GHX_LABEL_12)]: (0, $opsFH.GREY),
    [(0, $opsFH.GHX_LABEL_13)]: (0, $opsFH.DARK_GREEN),
    [(0, $opsFH.GHX_LABEL_14)]: (0, $opsFH.DARK_ORANGE)
};
const $3e0c3a8718e9d782$export$c13af2d9629c53d8 = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))($3e0c3a8718e9d782$export$fb5d051fe1b2bccc);
const $3e0c3a8718e9d782$export$994d3ffa39be04fd = {
    [(0, $opsFH.AGILE_COLOR_1)]: (0, $opsFH.DARK_GREY),
    [(0, $opsFH.AGILE_COLOR_2)]: (0, $opsFH.DARK_YELLOW),
    [(0, $opsFH.AGILE_COLOR_3)]: (0, $opsFH.YELLOW),
    [(0, $opsFH.AGILE_COLOR_4)]: (0, $opsFH.DARK_BLUE),
    [(0, $opsFH.AGILE_COLOR_5)]: (0, $opsFH.DARK_TEAL),
    [(0, $opsFH.AGILE_COLOR_6)]: (0, $opsFH.GREEN),
    [(0, $opsFH.AGILE_COLOR_7)]: (0, $opsFH.PURPLE),
    [(0, $opsFH.AGILE_COLOR_8)]: (0, $opsFH.DARK_PURPLE),
    [(0, $opsFH.AGILE_COLOR_9)]: (0, $opsFH.ORANGE),
    [(0, $opsFH.AGILE_COLOR_10)]: (0, $opsFH.BLUE),
    [(0, $opsFH.AGILE_COLOR_11)]: (0, $opsFH.TEAL),
    [(0, $opsFH.AGILE_COLOR_12)]: (0, $opsFH.GREY),
    [(0, $opsFH.AGILE_COLOR_13)]: (0, $opsFH.DARK_GREEN),
    [(0, $opsFH.AGILE_COLOR_14)]: (0, $opsFH.DARK_ORANGE)
};
const $3e0c3a8718e9d782$export$db17671bf37971e7 = (0, (/*@__PURE__*/$parcel$interopDefault($aXGkF)))($3e0c3a8718e9d782$export$994d3ffa39be04fd);
const $3e0c3a8718e9d782$export$1fdd5a248b5f697c = {
    [(0, $opsFH.GHX_LABEL_1)]: (0, $opsFH.AGILE_COLOR_1),
    [(0, $opsFH.GHX_LABEL_2)]: (0, $opsFH.AGILE_COLOR_2),
    [(0, $opsFH.GHX_LABEL_3)]: (0, $opsFH.AGILE_COLOR_3),
    [(0, $opsFH.GHX_LABEL_4)]: (0, $opsFH.AGILE_COLOR_4),
    [(0, $opsFH.GHX_LABEL_5)]: (0, $opsFH.AGILE_COLOR_5),
    [(0, $opsFH.GHX_LABEL_6)]: (0, $opsFH.AGILE_COLOR_6),
    [(0, $opsFH.GHX_LABEL_7)]: (0, $opsFH.AGILE_COLOR_7),
    [(0, $opsFH.GHX_LABEL_8)]: (0, $opsFH.AGILE_COLOR_8),
    [(0, $opsFH.GHX_LABEL_9)]: (0, $opsFH.AGILE_COLOR_9),
    [(0, $opsFH.GHX_LABEL_10)]: (0, $opsFH.AGILE_COLOR_10),
    [(0, $opsFH.GHX_LABEL_11)]: (0, $opsFH.AGILE_COLOR_11),
    [(0, $opsFH.GHX_LABEL_12)]: (0, $opsFH.AGILE_COLOR_12),
    [(0, $opsFH.GHX_LABEL_13)]: (0, $opsFH.AGILE_COLOR_13),
    [(0, $opsFH.GHX_LABEL_14)]: (0, $opsFH.AGILE_COLOR_14)
};
const $3e0c3a8718e9d782$export$82fc3b0b98905453 = {
    [(0, $opsFH.DARK_GREY)]: 'grey',
    [(0, $opsFH.DARK_YELLOW)]: 'yellow',
    [(0, $opsFH.YELLOW)]: 'yellowLight',
    [(0, $opsFH.DARK_BLUE)]: 'blue',
    [(0, $opsFH.DARK_TEAL)]: 'teal',
    [(0, $opsFH.GREEN)]: 'greenLight',
    [(0, $opsFH.PURPLE)]: 'purpleLight',
    [(0, $opsFH.DARK_PURPLE)]: 'purple',
    [(0, $opsFH.ORANGE)]: 'redLight',
    [(0, $opsFH.BLUE)]: 'blueLight',
    [(0, $opsFH.TEAL)]: 'tealLight',
    [(0, $opsFH.GREY)]: 'greyLight',
    [(0, $opsFH.DARK_GREEN)]: 'green',
    [(0, $opsFH.DARK_ORANGE)]: 'red'
};
const $3e0c3a8718e9d782$export$703aca53c431bb88 = {
    [(0, $opsFH.AGILE_COLOR_1)]: 'grey',
    [(0, $opsFH.AGILE_COLOR_2)]: 'yellow',
    [(0, $opsFH.AGILE_COLOR_3)]: 'yellowLight',
    [(0, $opsFH.AGILE_COLOR_4)]: 'blue',
    [(0, $opsFH.AGILE_COLOR_5)]: 'teal',
    [(0, $opsFH.AGILE_COLOR_6)]: 'greenLight',
    [(0, $opsFH.AGILE_COLOR_7)]: 'purpleLight',
    [(0, $opsFH.AGILE_COLOR_8)]: 'purple',
    [(0, $opsFH.AGILE_COLOR_9)]: 'redLight',
    [(0, $opsFH.AGILE_COLOR_10)]: 'blueLight',
    [(0, $opsFH.AGILE_COLOR_11)]: 'tealLight',
    [(0, $opsFH.AGILE_COLOR_12)]: 'greyLight',
    [(0, $opsFH.AGILE_COLOR_13)]: 'green',
    [(0, $opsFH.AGILE_COLOR_14)]: 'red'
};
const $3e0c3a8718e9d782$export$92b6aebfb522f0d9 = {
    [(0, $opsFH.PURPLE)]: {
        primary: `var(--ds-background-accent-purple-subtle, ${(0, $PdmhA).P200})`,
        secondary: `var(--ds-background-accent-purple-bolder, ${(0, $PdmhA).P500})`,
        text: `var(--ds-text-accent-purple, ${(0, $PdmhA).P500})`,
        textBackground: `var(--ds-background-accent-purple-subtler, ${(0, $PdmhA).P50})`,
        border: `var(--ds-border-accent-purple, ${(0, $PdmhA).P400})`,
        line: `var(--ds-border-accent-purple, ${(0, $PdmhA).P300})`,
        primaryGradient: `var(--ds-background-accent-purple-subtler, ${(0, $PdmhA).P75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.BLUE)]: {
        primary: `var(--ds-background-accent-blue-subtle, ${(0, $PdmhA).B200})`,
        secondary: `var(--ds-background-accent-blue-bolder, ${(0, $PdmhA).B500})`,
        text: `var(--ds-text-accent-blue, ${(0, $PdmhA).B500})`,
        textBackground: `var(--ds-background-accent-blue-subtler, ${(0, $PdmhA).B50})`,
        border: `var(--ds-border-accent-blue, ${(0, $PdmhA).B400})`,
        line: `var(--ds-border-accent-blue, ${(0, $PdmhA).B300})`,
        primaryGradient: `var(--ds-background-accent-blue-subtler, ${(0, $PdmhA).B75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.GREEN)]: {
        primary: `var(--ds-background-accent-green-subtle, ${(0, $PdmhA).G200})`,
        secondary: `var(--ds-background-accent-green-bolder, ${(0, $PdmhA).G500})`,
        text: `var(--ds-text-accent-green, ${(0, $PdmhA).G500})`,
        textBackground: `var(--ds-background-accent-green-subtler, ${(0, $PdmhA).G50})`,
        border: `var(--ds-border-accent-green, ${(0, $PdmhA).G400})`,
        line: `var(--ds-border-accent-green, ${(0, $PdmhA).G300})`,
        primaryGradient: `var(--ds-background-accent-green-subtler, ${(0, $PdmhA).G75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.TEAL)]: {
        primary: `var(--ds-background-accent-teal-subtle, ${(0, $PdmhA).T200})`,
        secondary: `var(--ds-background-accent-teal-bolder, ${(0, $PdmhA).T500})`,
        text: `var(--ds-text-accent-teal, ${(0, $PdmhA).T500})`,
        textBackground: `var(--ds-background-accent-teal-subtler, ${(0, $PdmhA).T50})`,
        border: `var(--ds-border-accent-teal, ${(0, $PdmhA).T400})`,
        line: `var(--ds-border-accent-teal, ${(0, $PdmhA).T300})`,
        primaryGradient: `var(--ds-background-accent-teal-subtler, ${(0, $PdmhA).T75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.YELLOW)]: {
        primary: `var(--ds-background-accent-yellow-subtle, ${(0, $PdmhA).Y200})`,
        secondary: `var(--ds-background-accent-yellow-bolder, ${(0, $PdmhA).Y500})`,
        text: `var(--ds-text-accent-yellow, ${(0, $PdmhA).Y500})`,
        textBackground: `var(--ds-background-accent-yellow-subtler, ${(0, $PdmhA).Y50})`,
        border: `var(--ds-border-accent-yellow, ${(0, $PdmhA).Y400})`,
        line: `var(--ds-border-accent-yellow, ${(0, $PdmhA).Y300})`,
        primaryGradient: `var(--ds-background-accent-yellow-subtler, ${(0, $PdmhA).Y75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.ORANGE)]: {
        primary: `var(--ds-background-accent-red-subtle, ${(0, $PdmhA).R200})`,
        secondary: `var(--ds-background-accent-red-bolder, ${(0, $PdmhA).R500})`,
        text: `var(--ds-text-accent-red, ${(0, $PdmhA).R500})`,
        textBackground: `var(--ds-background-accent-red-subtler, ${(0, $PdmhA).R50})`,
        border: `var(--ds-border-accent-red, ${(0, $PdmhA).R400})`,
        line: `var(--ds-border-accent-red, ${(0, $PdmhA).R300})`,
        primaryGradient: `var(--ds-background-accent-red-subtler, ${(0, $PdmhA).R75})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.GREY)]: {
        primary: `var(--ds-background-accent-gray-subtle, ${(0, $PdmhA).N200})`,
        secondary: `var(--ds-background-accent-gray-bolder, ${(0, $PdmhA).N500})`,
        text: `var(--ds-text-accent-gray, ${(0, $PdmhA).N500})`,
        textBackground: `var(--ds-background-accent-gray-subtler, ${(0, $PdmhA).N30})`,
        border: `var(--ds-border-accent-gray, ${(0, $PdmhA).N700})`,
        line: `var(--ds-border-accent-gray, ${(0, $PdmhA).N500})`,
        primaryGradient: `var(--ds-background-accent-gray-subtler, ${(0, $PdmhA).N50})`,
        hasContrastSecondaryGradient: true
    },
    [(0, $opsFH.DARK_PURPLE)]: {
        primary: `var(--ds-background-accent-purple-bolder, ${(0, $PdmhA).P400})`,
        secondary: `var(--ds-background-accent-purple-subtle, ${(0, $PdmhA).P200})`,
        text: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        textBackground: `var(--ds-background-accent-purple-bolder, ${(0, $PdmhA).P400})`,
        border: `var(--ds-border-accent-purple, ${(0, $PdmhA).P100})`,
        line: `var(--ds-border-accent-purple, ${(0, $PdmhA).P300})`,
        primaryGradient: `var(--ds-background-accent-purple-subtle, ${(0, $PdmhA).P100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_BLUE)]: {
        primary: `var(--ds-background-accent-blue-bolder, ${(0, $PdmhA).B400})`,
        secondary: `var(--ds-background-accent-blue-subtle, ${(0, $PdmhA).B200})`,
        text: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        textBackground: `var(--ds-background-accent-blue-bolder, ${(0, $PdmhA).B400})`,
        border: `var(--ds-border-accent-blue, ${(0, $PdmhA).B200})`,
        line: `var(--ds-border-accent-blue, ${(0, $PdmhA).B100})`,
        primaryGradient: `var(--ds-background-accent-blue-subtle, ${(0, $PdmhA).B100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_GREEN)]: {
        primary: `var(--ds-background-accent-green-bolder, ${(0, $PdmhA).G400})`,
        secondary: `var(--ds-background-accent-green-subtle, ${(0, $PdmhA).G200})`,
        text: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        textBackground: `var(--ds-background-accent-green-bolder, ${(0, $PdmhA).G400})`,
        border: `var(--ds-border-accent-green, ${(0, $PdmhA).G200})`,
        line: `var(--ds-border-accent-green, ${(0, $PdmhA).G300})`,
        primaryGradient: `var(--ds-background-accent-green-subtle, ${(0, $PdmhA).G200})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_TEAL)]: {
        primary: `var(--ds-background-accent-teal-bolder, ${(0, $PdmhA).T400})`,
        secondary: `var(--ds-background-accent-teal-subtle, ${(0, $PdmhA).T200})`,
        text: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        textBackground: `var(--ds-background-accent-teal-bolder, ${(0, $PdmhA).T400})`,
        border: `var(--ds-border-accent-teal, ${(0, $PdmhA).T200})`,
        line: `var(--ds-border-accent-teal, ${(0, $PdmhA).T300})`,
        primaryGradient: `var(--ds-background-accent-teal-subtle, ${(0, $PdmhA).T100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_YELLOW)]: {
        primary: `var(--ds-background-accent-orange-bolder, ${(0, $PdmhA).Y400})`,
        secondary: `var(--ds-background-accent-orange-subtle, ${(0, $PdmhA).Y200})`,
        text: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        textBackground: `var(--ds-background-accent-orange-bolder, ${(0, $PdmhA).Y400})`,
        border: `var(--ds-background-accent-orange-subtle, ${(0, $PdmhA).Y200})`,
        line: `var(--ds-border-accent-orange, ${(0, $PdmhA).Y300})`,
        primaryGradient: `var(--ds-background-accent-orange-subtle, ${(0, $PdmhA).Y100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_ORANGE)]: {
        primary: `var(--ds-background-accent-red-bolder, ${(0, $PdmhA).R400})`,
        secondary: `var(--ds-background-accent-red-subtle, ${(0, $PdmhA).R200})`,
        text: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        textBackground: `var(--ds-background-accent-red-bolder, ${(0, $PdmhA).R400})`,
        border: `var(--ds-background-accent-red-subtle, ${(0, $PdmhA).R100})`,
        line: `var(--ds-border-accent-red, ${(0, $PdmhA).R300})`,
        primaryGradient: `var(--ds-background-accent-red-subtle, ${(0, $PdmhA).R100})`,
        hasContrastSecondaryGradient: false
    },
    [(0, $opsFH.DARK_GREY)]: {
        primary: `var(--ds-background-accent-gray-bolder, ${(0, $PdmhA).N700})`,
        secondary: `var(--ds-background-accent-gray-subtle, ${(0, $PdmhA).N300})`,
        text: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
        textBackground: `var(--ds-background-accent-gray-bolder, ${(0, $PdmhA).N500})`,
        border: `var(--ds-background-accent-gray-subtle, ${(0, $PdmhA).N100})`,
        line: `var(--ds-border-accent-gray, ${(0, $PdmhA).N500})`,
        primaryGradient: `var(--ds-background-accent-gray-subtle, ${(0, $PdmhA).N100})`,
        hasContrastSecondaryGradient: false
    }
};

});
parcelRegister("opsFH", function(module, exports) {

$parcel$export(module.exports, "PURPLE", () => $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2);
$parcel$export(module.exports, "DARK_PURPLE", () => $e6c2c5f41d0c328b$export$c815fe495e8174a0);
$parcel$export(module.exports, "BLUE", () => $e6c2c5f41d0c328b$export$738c3b9a44c87ecc);
$parcel$export(module.exports, "DARK_BLUE", () => $e6c2c5f41d0c328b$export$1225f83626261b80);
$parcel$export(module.exports, "GREEN", () => $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b);
$parcel$export(module.exports, "DARK_GREEN", () => $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78);
$parcel$export(module.exports, "TEAL", () => $e6c2c5f41d0c328b$export$d0446fe88325854e);
$parcel$export(module.exports, "DARK_TEAL", () => $e6c2c5f41d0c328b$export$bb848c92687e69dc);
$parcel$export(module.exports, "YELLOW", () => $e6c2c5f41d0c328b$export$aab610c505c06a8f);
$parcel$export(module.exports, "DARK_YELLOW", () => $e6c2c5f41d0c328b$export$466af87757d343a2);
$parcel$export(module.exports, "ORANGE", () => $e6c2c5f41d0c328b$export$3de5e29ed1757f9b);
$parcel$export(module.exports, "DARK_ORANGE", () => $e6c2c5f41d0c328b$export$da02e4820b6ab753);
$parcel$export(module.exports, "GREY", () => $e6c2c5f41d0c328b$export$7d278ca694634874);
$parcel$export(module.exports, "DARK_GREY", () => $e6c2c5f41d0c328b$export$26453300bfc61cb8);
$parcel$export(module.exports, "COLORS", () => $e6c2c5f41d0c328b$export$56d196d2844d1ca1);
$parcel$export(module.exports, "SERVER_PURPLE", () => $e6c2c5f41d0c328b$export$792af22a0198af8d);
$parcel$export(module.exports, "SERVER_DARK_PURPLE", () => $e6c2c5f41d0c328b$export$588af712afdcb006);
$parcel$export(module.exports, "SERVER_BLUE", () => $e6c2c5f41d0c328b$export$84c4918645391802);
$parcel$export(module.exports, "SERVER_DARK_BLUE", () => $e6c2c5f41d0c328b$export$b8f1f5838352a33a);
$parcel$export(module.exports, "SERVER_GREEN", () => $e6c2c5f41d0c328b$export$9384b7e350ee6542);
$parcel$export(module.exports, "SERVER_DARK_GREEN", () => $e6c2c5f41d0c328b$export$87d3fb8d8656d38b);
$parcel$export(module.exports, "SERVER_TEAL", () => $e6c2c5f41d0c328b$export$b0b4ce3e99e66aae);
$parcel$export(module.exports, "SERVER_DARK_TEAL", () => $e6c2c5f41d0c328b$export$a89b77a449bd223e);
$parcel$export(module.exports, "SERVER_YELLOW", () => $e6c2c5f41d0c328b$export$9a33b5e3cde94885);
$parcel$export(module.exports, "SERVER_DARK_YELLOW", () => $e6c2c5f41d0c328b$export$33253d7862bceb8a);
$parcel$export(module.exports, "SERVER_ORANGE", () => $e6c2c5f41d0c328b$export$6609c2b23fc42f39);
$parcel$export(module.exports, "SERVER_DARK_ORANGE", () => $e6c2c5f41d0c328b$export$cd994662b5911917);
$parcel$export(module.exports, "SERVER_GREY", () => $e6c2c5f41d0c328b$export$1793d43e13e078c5);
$parcel$export(module.exports, "SERVER_DARK_GREY", () => $e6c2c5f41d0c328b$export$487a6e9145526564);
$parcel$export(module.exports, "GHX_LABEL_1", () => $e6c2c5f41d0c328b$export$e4bdf2d4c4bbb15e);
$parcel$export(module.exports, "GHX_LABEL_2", () => $e6c2c5f41d0c328b$export$8f5c1c5512278dc6);
$parcel$export(module.exports, "GHX_LABEL_3", () => $e6c2c5f41d0c328b$export$94ac87c81ed074a7);
$parcel$export(module.exports, "GHX_LABEL_4", () => $e6c2c5f41d0c328b$export$6bc9ab1f489f76f7);
$parcel$export(module.exports, "GHX_LABEL_5", () => $e6c2c5f41d0c328b$export$610a2c132b6fcf96);
$parcel$export(module.exports, "GHX_LABEL_6", () => $e6c2c5f41d0c328b$export$8e4997dba71f1c40);
$parcel$export(module.exports, "GHX_LABEL_7", () => $e6c2c5f41d0c328b$export$18a545b4e69b27b4);
$parcel$export(module.exports, "GHX_LABEL_8", () => $e6c2c5f41d0c328b$export$27fff1a0d295292a);
$parcel$export(module.exports, "GHX_LABEL_9", () => $e6c2c5f41d0c328b$export$e57aa662a56724e1);
$parcel$export(module.exports, "GHX_LABEL_10", () => $e6c2c5f41d0c328b$export$4b0d63e2c3be2072);
$parcel$export(module.exports, "GHX_LABEL_11", () => $e6c2c5f41d0c328b$export$457ecb9560f2bf83);
$parcel$export(module.exports, "GHX_LABEL_12", () => $e6c2c5f41d0c328b$export$a866db37165a696c);
$parcel$export(module.exports, "GHX_LABEL_13", () => $e6c2c5f41d0c328b$export$9b18447c1168a1b6);
$parcel$export(module.exports, "GHX_LABEL_14", () => $e6c2c5f41d0c328b$export$93b9ad4020e271b7);
$parcel$export(module.exports, "AGILE_COLOR_1", () => $e6c2c5f41d0c328b$export$5cd2af17b34de3e3);
$parcel$export(module.exports, "AGILE_COLOR_2", () => $e6c2c5f41d0c328b$export$987671fa69482a7b);
$parcel$export(module.exports, "AGILE_COLOR_3", () => $e6c2c5f41d0c328b$export$70ba8a5b1f4c7446);
$parcel$export(module.exports, "AGILE_COLOR_4", () => $e6c2c5f41d0c328b$export$fcd1c42d8d3ebd36);
$parcel$export(module.exports, "AGILE_COLOR_5", () => $e6c2c5f41d0c328b$export$f80a5bd2fa0ba256);
$parcel$export(module.exports, "AGILE_COLOR_6", () => $e6c2c5f41d0c328b$export$37ad5ce8d2aeaf78);
$parcel$export(module.exports, "AGILE_COLOR_7", () => $e6c2c5f41d0c328b$export$9dc62d5d151cb355);
$parcel$export(module.exports, "AGILE_COLOR_8", () => $e6c2c5f41d0c328b$export$1ed15b30f5663f92);
$parcel$export(module.exports, "AGILE_COLOR_9", () => $e6c2c5f41d0c328b$export$5d23a84d55ac1644);
$parcel$export(module.exports, "AGILE_COLOR_10", () => $e6c2c5f41d0c328b$export$bf08c9a6ed42e349);
$parcel$export(module.exports, "AGILE_COLOR_11", () => $e6c2c5f41d0c328b$export$66c5d8f0b5ff279c);
$parcel$export(module.exports, "AGILE_COLOR_12", () => $e6c2c5f41d0c328b$export$da30755a37c3a597);
$parcel$export(module.exports, "AGILE_COLOR_13", () => $e6c2c5f41d0c328b$export$721cf84faff6bf19);
$parcel$export(module.exports, "AGILE_COLOR_14", () => $e6c2c5f41d0c328b$export$4b8f8666bd7b61dd);
$parcel$export(module.exports, "Colors", () => $e6c2c5f41d0c328b$export$c537fa0d021d010b);
$parcel$export(module.exports, "ServerColors", () => $e6c2c5f41d0c328b$export$d33d39828a18210a);
$parcel$export(module.exports, "ClassicEpicColors", () => $e6c2c5f41d0c328b$export$f476e6e43e0101e7);
$parcel$export(module.exports, "AgileColors", () => $e6c2c5f41d0c328b$export$4b7407b8700035bd);
/**
 * Color constants
 */ const $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2 = 'PURPLE';
const $e6c2c5f41d0c328b$export$c815fe495e8174a0 = 'DARK_PURPLE';
const $e6c2c5f41d0c328b$export$738c3b9a44c87ecc = 'BLUE';
const $e6c2c5f41d0c328b$export$1225f83626261b80 = 'DARK_BLUE';
const $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b = 'GREEN';
const $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78 = 'DARK_GREEN';
const $e6c2c5f41d0c328b$export$d0446fe88325854e = 'TEAL';
const $e6c2c5f41d0c328b$export$bb848c92687e69dc = 'DARK_TEAL';
const $e6c2c5f41d0c328b$export$aab610c505c06a8f = 'YELLOW';
const $e6c2c5f41d0c328b$export$466af87757d343a2 = 'DARK_YELLOW';
const $e6c2c5f41d0c328b$export$3de5e29ed1757f9b = 'ORANGE';
const $e6c2c5f41d0c328b$export$da02e4820b6ab753 = 'DARK_ORANGE';
const $e6c2c5f41d0c328b$export$7d278ca694634874 = 'GREY';
const $e6c2c5f41d0c328b$export$26453300bfc61cb8 = 'DARK_GREY';
const $e6c2c5f41d0c328b$export$56d196d2844d1ca1 = [
    $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2,
    $e6c2c5f41d0c328b$export$c815fe495e8174a0,
    $e6c2c5f41d0c328b$export$738c3b9a44c87ecc,
    $e6c2c5f41d0c328b$export$1225f83626261b80,
    $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b,
    $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78,
    $e6c2c5f41d0c328b$export$d0446fe88325854e,
    $e6c2c5f41d0c328b$export$bb848c92687e69dc,
    $e6c2c5f41d0c328b$export$aab610c505c06a8f,
    $e6c2c5f41d0c328b$export$466af87757d343a2,
    $e6c2c5f41d0c328b$export$3de5e29ed1757f9b,
    $e6c2c5f41d0c328b$export$da02e4820b6ab753,
    $e6c2c5f41d0c328b$export$7d278ca694634874,
    $e6c2c5f41d0c328b$export$26453300bfc61cb8
];
const $e6c2c5f41d0c328b$export$792af22a0198af8d = 'purple';
const $e6c2c5f41d0c328b$export$588af712afdcb006 = 'dark_purple';
const $e6c2c5f41d0c328b$export$84c4918645391802 = 'blue';
const $e6c2c5f41d0c328b$export$b8f1f5838352a33a = 'dark_blue';
const $e6c2c5f41d0c328b$export$9384b7e350ee6542 = 'green';
const $e6c2c5f41d0c328b$export$87d3fb8d8656d38b = 'dark_green';
const $e6c2c5f41d0c328b$export$b0b4ce3e99e66aae = 'teal';
const $e6c2c5f41d0c328b$export$a89b77a449bd223e = 'dark_teal';
const $e6c2c5f41d0c328b$export$9a33b5e3cde94885 = 'yellow';
const $e6c2c5f41d0c328b$export$33253d7862bceb8a = 'dark_yellow';
const $e6c2c5f41d0c328b$export$6609c2b23fc42f39 = 'orange';
const $e6c2c5f41d0c328b$export$cd994662b5911917 = 'dark_orange';
const $e6c2c5f41d0c328b$export$1793d43e13e078c5 = 'grey';
const $e6c2c5f41d0c328b$export$487a6e9145526564 = 'dark_grey';
const $e6c2c5f41d0c328b$export$e4bdf2d4c4bbb15e = 'ghx-label-1';
const $e6c2c5f41d0c328b$export$8f5c1c5512278dc6 = 'ghx-label-2';
const $e6c2c5f41d0c328b$export$94ac87c81ed074a7 = 'ghx-label-3';
const $e6c2c5f41d0c328b$export$6bc9ab1f489f76f7 = 'ghx-label-4';
const $e6c2c5f41d0c328b$export$610a2c132b6fcf96 = 'ghx-label-5';
const $e6c2c5f41d0c328b$export$8e4997dba71f1c40 = 'ghx-label-6';
const $e6c2c5f41d0c328b$export$18a545b4e69b27b4 = 'ghx-label-7';
const $e6c2c5f41d0c328b$export$27fff1a0d295292a = 'ghx-label-8';
const $e6c2c5f41d0c328b$export$e57aa662a56724e1 = 'ghx-label-9';
const $e6c2c5f41d0c328b$export$4b0d63e2c3be2072 = 'ghx-label-10';
const $e6c2c5f41d0c328b$export$457ecb9560f2bf83 = 'ghx-label-11';
const $e6c2c5f41d0c328b$export$a866db37165a696c = 'ghx-label-12';
const $e6c2c5f41d0c328b$export$9b18447c1168a1b6 = 'ghx-label-13';
const $e6c2c5f41d0c328b$export$93b9ad4020e271b7 = 'ghx-label-14';
const $e6c2c5f41d0c328b$export$5cd2af17b34de3e3 = 'color_1';
const $e6c2c5f41d0c328b$export$987671fa69482a7b = 'color_2';
const $e6c2c5f41d0c328b$export$70ba8a5b1f4c7446 = 'color_3';
const $e6c2c5f41d0c328b$export$fcd1c42d8d3ebd36 = 'color_4';
const $e6c2c5f41d0c328b$export$f80a5bd2fa0ba256 = 'color_5';
const $e6c2c5f41d0c328b$export$37ad5ce8d2aeaf78 = 'color_6';
const $e6c2c5f41d0c328b$export$9dc62d5d151cb355 = 'color_7';
const $e6c2c5f41d0c328b$export$1ed15b30f5663f92 = 'color_8';
const $e6c2c5f41d0c328b$export$5d23a84d55ac1644 = 'color_9';
const $e6c2c5f41d0c328b$export$bf08c9a6ed42e349 = 'color_10';
const $e6c2c5f41d0c328b$export$66c5d8f0b5ff279c = 'color_11';
const $e6c2c5f41d0c328b$export$da30755a37c3a597 = 'color_12';
const $e6c2c5f41d0c328b$export$721cf84faff6bf19 = 'color_13';
const $e6c2c5f41d0c328b$export$4b8f8666bd7b61dd = 'color_14';
const $e6c2c5f41d0c328b$export$c537fa0d021d010b = {
    PURPLE: $e6c2c5f41d0c328b$export$7ffdeca4b2f927a2,
    DARK_PURPLE: $e6c2c5f41d0c328b$export$c815fe495e8174a0,
    BLUE: $e6c2c5f41d0c328b$export$738c3b9a44c87ecc,
    DARK_BLUE: $e6c2c5f41d0c328b$export$1225f83626261b80,
    GREEN: $e6c2c5f41d0c328b$export$48d4b2cd5bc0e88b,
    DARK_GREEN: $e6c2c5f41d0c328b$export$c6f4cf2e5768eb78,
    TEAL: $e6c2c5f41d0c328b$export$d0446fe88325854e,
    DARK_TEAL: $e6c2c5f41d0c328b$export$bb848c92687e69dc,
    YELLOW: $e6c2c5f41d0c328b$export$aab610c505c06a8f,
    DARK_YELLOW: $e6c2c5f41d0c328b$export$466af87757d343a2,
    ORANGE: $e6c2c5f41d0c328b$export$3de5e29ed1757f9b,
    DARK_ORANGE: $e6c2c5f41d0c328b$export$da02e4820b6ab753,
    GREY: $e6c2c5f41d0c328b$export$7d278ca694634874,
    DARK_GREY: $e6c2c5f41d0c328b$export$26453300bfc61cb8
};
const $e6c2c5f41d0c328b$export$d33d39828a18210a = {
    SERVER_PURPLE: $e6c2c5f41d0c328b$export$792af22a0198af8d,
    SERVER_DARK_PURPLE: $e6c2c5f41d0c328b$export$588af712afdcb006,
    SERVER_BLUE: $e6c2c5f41d0c328b$export$84c4918645391802,
    SERVER_DARK_BLUE: $e6c2c5f41d0c328b$export$b8f1f5838352a33a,
    SERVER_GREEN: $e6c2c5f41d0c328b$export$9384b7e350ee6542,
    SERVER_DARK_GREEN: $e6c2c5f41d0c328b$export$87d3fb8d8656d38b,
    SERVER_TEAL: $e6c2c5f41d0c328b$export$b0b4ce3e99e66aae,
    SERVER_DARK_TEAL: $e6c2c5f41d0c328b$export$a89b77a449bd223e,
    SERVER_YELLOW: $e6c2c5f41d0c328b$export$9a33b5e3cde94885,
    SERVER_DARK_YELLOW: $e6c2c5f41d0c328b$export$33253d7862bceb8a,
    SERVER_ORANGE: $e6c2c5f41d0c328b$export$6609c2b23fc42f39,
    SERVER_DARK_ORANGE: $e6c2c5f41d0c328b$export$cd994662b5911917,
    SERVER_GREY: $e6c2c5f41d0c328b$export$1793d43e13e078c5,
    SERVER_DARK_GREY: $e6c2c5f41d0c328b$export$487a6e9145526564
};
const $e6c2c5f41d0c328b$export$f476e6e43e0101e7 = {
    GHX_LABEL_1: $e6c2c5f41d0c328b$export$e4bdf2d4c4bbb15e,
    GHX_LABEL_2: $e6c2c5f41d0c328b$export$8f5c1c5512278dc6,
    GHX_LABEL_3: $e6c2c5f41d0c328b$export$94ac87c81ed074a7,
    GHX_LABEL_4: $e6c2c5f41d0c328b$export$6bc9ab1f489f76f7,
    GHX_LABEL_5: $e6c2c5f41d0c328b$export$610a2c132b6fcf96,
    GHX_LABEL_6: $e6c2c5f41d0c328b$export$8e4997dba71f1c40,
    GHX_LABEL_7: $e6c2c5f41d0c328b$export$18a545b4e69b27b4,
    GHX_LABEL_8: $e6c2c5f41d0c328b$export$27fff1a0d295292a,
    GHX_LABEL_9: $e6c2c5f41d0c328b$export$e57aa662a56724e1,
    GHX_LABEL_10: $e6c2c5f41d0c328b$export$4b0d63e2c3be2072,
    GHX_LABEL_11: $e6c2c5f41d0c328b$export$457ecb9560f2bf83,
    GHX_LABEL_12: $e6c2c5f41d0c328b$export$a866db37165a696c,
    GHX_LABEL_13: $e6c2c5f41d0c328b$export$9b18447c1168a1b6,
    GHX_LABEL_14: $e6c2c5f41d0c328b$export$93b9ad4020e271b7
};
const $e6c2c5f41d0c328b$export$4b7407b8700035bd = {
    AGILE_COLOR_1: $e6c2c5f41d0c328b$export$5cd2af17b34de3e3,
    AGILE_COLOR_2: $e6c2c5f41d0c328b$export$987671fa69482a7b,
    AGILE_COLOR_3: $e6c2c5f41d0c328b$export$70ba8a5b1f4c7446,
    AGILE_COLOR_4: $e6c2c5f41d0c328b$export$fcd1c42d8d3ebd36,
    AGILE_COLOR_5: $e6c2c5f41d0c328b$export$f80a5bd2fa0ba256,
    AGILE_COLOR_6: $e6c2c5f41d0c328b$export$37ad5ce8d2aeaf78,
    AGILE_COLOR_7: $e6c2c5f41d0c328b$export$9dc62d5d151cb355,
    AGILE_COLOR_8: $e6c2c5f41d0c328b$export$1ed15b30f5663f92,
    AGILE_COLOR_9: $e6c2c5f41d0c328b$export$5d23a84d55ac1644,
    AGILE_COLOR_10: $e6c2c5f41d0c328b$export$bf08c9a6ed42e349,
    AGILE_COLOR_11: $e6c2c5f41d0c328b$export$66c5d8f0b5ff279c,
    AGILE_COLOR_12: $e6c2c5f41d0c328b$export$da30755a37c3a597,
    AGILE_COLOR_13: $e6c2c5f41d0c328b$export$721cf84faff6bf19,
    AGILE_COLOR_14: $e6c2c5f41d0c328b$export$4b8f8666bd7b61dd
};

});


parcelRegister("hNY9X", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7d8f225d60e32dd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a7d8f225d60e32dd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    purpleLabel: {
        "id": "issue-epic-color.common.purple-label",
        "defaultMessage": "purple"
    },
    blueLabel: {
        "id": "issue-epic-color.common.blue-label",
        "defaultMessage": "blue"
    },
    greenLabel: {
        "id": "issue-epic-color.common.green-label",
        "defaultMessage": "green"
    },
    tealLabel: {
        "id": "issue-epic-color.common.teal-label",
        "defaultMessage": "teal"
    },
    yellowLabel: {
        "id": "issue-epic-color.common.yellow-label",
        "defaultMessage": "yellow"
    },
    orangeLabel: {
        "id": "issue-epic-color.common.orange-label",
        "defaultMessage": "orange"
    },
    greyLabel: {
        "id": "issue-epic-color.common.grey-label",
        "defaultMessage": "grey"
    },
    darkPurpleLabel: {
        "id": "issue-epic-color.common.dark-purple-label",
        "defaultMessage": "dark purple"
    },
    darkBlueLabel: {
        "id": "issue-epic-color.common.dark-blue-label",
        "defaultMessage": "dark blue"
    },
    darkGreenLabel: {
        "id": "issue-epic-color.common.dark-green-label",
        "defaultMessage": "dark green"
    },
    darkTealLabel: {
        "id": "issue-epic-color.common.dark-teal-label",
        "defaultMessage": "dark teal"
    },
    darkYellowLabel: {
        "id": "issue-epic-color.common.dark-yellow-label",
        "defaultMessage": "dark yellow"
    },
    darkOrangeLabel: {
        "id": "issue-epic-color.common.dark-orange-label",
        "defaultMessage": "dark orange"
    },
    darkGreyLabel: {
        "id": "issue-epic-color.common.dark-grey-label",
        "defaultMessage": "dark grey"
    }
});

});


const $23d97971f71f1cd0$export$4a4db137834138dd = 'FETCH_PARENT_FIELD_NOT_FOUND';
const $23d97971f71f1cd0$export$aa7d91b2fd1ba261 = 'FETCH_PARENT_FIELD_DETAILS_MISSING_DATA';
const $23d97971f71f1cd0$export$494a54d93664524d = 'FETCH_PARENT_FIELD_UNKNOWN_ERROR';
const $23d97971f71f1cd0$export$db8af5ee2c36776e = 'FETCH_PARENT_FIELD_DETAILS_REQUEST_FAILED';

parcelRegister("5Xfbd", function(module, exports) {

$parcel$export(module.exports, "isJiraIssueTypeFieldNode", () => $6f64b4b9dfeef6b5$export$57eda1f5ad7133c3);
$parcel$export(module.exports, "isJiraSingleLineTextFieldNode", () => $6f64b4b9dfeef6b5$export$ea2b75e2537cbccf);
$parcel$export(module.exports, "isJiraStatusFieldNode", () => $6f64b4b9dfeef6b5$export$1a148ec51054fc5a);
$parcel$export(module.exports, "fetchParentIssueDetails", () => $6f64b4b9dfeef6b5$export$ef5c4d73a6136d96);
$parcel$export(module.exports, "checkParentIssueIsDone", () => $6f64b4b9dfeef6b5$export$2b30e3fdda29f6);

var $2Shq0 = parcelRequire("2Shq0");

var $8Qd0L = parcelRequire("8Qd0L");

var $kXzsJ = parcelRequire("kXzsJ");

var $cEBFL = parcelRequire("cEBFL");

const $6f64b4b9dfeef6b5$export$57eda1f5ad7133c3 = (node)=>node?.__typename === 'JiraIssueTypeField';
const $6f64b4b9dfeef6b5$export$ea2b75e2537cbccf = (node)=>node?.__typename === 'JiraSingleLineTextField';
const $6f64b4b9dfeef6b5$export$1a148ec51054fc5a = (node)=>node?.__typename === 'JiraStatusField';
const $6f64b4b9dfeef6b5$export$6ba84cffc20b9772 = (0, $cEBFL.gqlTagGira)`
  query ParentIssueDetailsQuery($ari: ID!) {
    jira {
      issueById(id: $ari) {
        issueId
        key
        issueColorField {
          color {
            colorKey
          }
        }
        fieldsById(ids: ["summary", "issuetype", "status"]) {
          edges {
            node {
              __typename
              ... on JiraIssueTypeField {
                fieldId
                issueType {
                  issueTypeId
                  name
                  avatar {
                    xsmall
                  }
                }
              }
              ... on JiraSingleLineTextField {
                fieldId
                text
              }
              ... on JiraStatusField {
                fieldId
                status {
                  statusCategory {
                    statusCategoryId
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
async function $6f64b4b9dfeef6b5$export$ef5c4d73a6136d96(siteId, issueId) {
    try {
        const variables = {
            ari: (0, $2Shq0.JiraIssueAri).create({
                siteId: siteId,
                issueId: issueId
            }).toString()
        };
        const { data: data } = await (0, $kXzsJ.getClient)('').query({
            query: $6f64b4b9dfeef6b5$export$6ba84cffc20b9772,
            variables: variables,
            operationName: 'ParentIssueDetailsQuery'
        });
        return data;
    } catch (error) {
        throw new Error(`Error fetching data for parent issue with issueId "${issueId}"`, {
            cause: (0, $23d97971f71f1cd0$export$db8af5ee2c36776e)
        });
    }
}
const $6f64b4b9dfeef6b5$export$2b30e3fdda29f6 = (node)=>{
    const doneStatusCategoryId = (0, $8Qd0L).StatusCategoryIds[(0, $8Qd0L).StatusCategoryTypes.DONE];
    return doneStatusCategoryId && String(doneStatusCategoryId) === node.status?.statusCategory?.statusCategoryId;
};

});
parcelRegister("2Shq0", function(module, exports) {

$parcel$export(module.exports, "JiraIssueAri", () => $f33aa2105af1c8a3$export$1da6808e89ee03e);

var $dD8N7 = parcelRequire("dD8N7");

var $v8cEo = parcelRequire("v8cEo");

var $hkoEN = parcelRequire("hkoEN");
// src/jira/issue/manifest.ts
var $f33aa2105af1c8a3$var$jiraIssueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9-]+$"),
    resourceOwner: (0, $dD8N7.JiraIssueAriResourceOwner),
    resourceType: (0, $dD8N7.JiraIssueAriResourceType),
    resourceIdSlug: "{issueId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/
    }
};
// src/jira/issue/index.ts
var $f33aa2105af1c8a3$export$1da6808e89ee03e = class _JiraIssueAri extends (0, $v8cEo.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId;
    }
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $f33aa2105af1c8a3$var$jiraIssueAriStaticOpts.qualifier,
            platformQualifier: $f33aa2105af1c8a3$var$jiraIssueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $f33aa2105af1c8a3$var$jiraIssueAriStaticOpts.resourceOwner,
            resourceType: $f33aa2105af1c8a3$var$jiraIssueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId
            }
        }, ariOpts = (0, $hkoEN.AriParser).fromOpts(derivedOpts, $f33aa2105af1c8a3$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $hkoEN.AriParser).fromString(maybeAri, $f33aa2105af1c8a3$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId
        };
    }
};

});
parcelRegister("dD8N7", function(module, exports) {

$parcel$export(module.exports, "JiraIssueAriResourceOwner", () => $5b32aaefd8525674$export$665a39f1b4e29e0a);
$parcel$export(module.exports, "JiraIssueAriResourceType", () => $5b32aaefd8525674$export$76beb4d0da177ad4);
// src/jira/issue/types.ts
var $5b32aaefd8525674$export$665a39f1b4e29e0a = "jira", $5b32aaefd8525674$export$76beb4d0da177ad4 = "issue";

});


parcelRegister("kXzsJ", function(module, exports) {

$parcel$export(module.exports, "getClient", () => $04aa819d4030995f$export$6bb76d6eba7e258c);

var $2OdyW = parcelRequire("2OdyW");

var $gIOVj = parcelRequire("gIOVj");
const $04aa819d4030995f$var$makeFetchClient = (baseUrl)=>({
        query: ({ query: query, variables: variables, signal: signal, operationName: operationName })=>(0, $2OdyW.default)((0, $gIOVj.getGiraUrl)(baseUrl, operationName), {
                method: 'POST',
                body: JSON.stringify({
                    query: query,
                    variables: variables,
                    operationName: operationName
                }),
                signal: signal
            })
    });
let $04aa819d4030995f$var$client;
const $04aa819d4030995f$export$6bb76d6eba7e258c = (baseUrl)=>{
    if (!$04aa819d4030995f$var$client) $04aa819d4030995f$var$client = $04aa819d4030995f$var$makeFetchClient(baseUrl);
    return $04aa819d4030995f$var$client;
};

});
parcelRegister("gIOVj", function(module, exports) {

$parcel$export(module.exports, "ISSUE_VIEW_INTERACTIVE_QUERY", () => $8fd02e0075f962e8$export$1780a132c0453fee);
$parcel$export(module.exports, "getGiraUrl", () => $8fd02e0075f962e8$export$aefb19023b2eda55);
$parcel$export(module.exports, "getJiraQueryEcosystemFirstSeenOnIssueView", () => $8fd02e0075f962e8$export$79eba9bf6dc9960d);
$parcel$export(module.exports, "buildIssueQuery", () => $8fd02e0075f962e8$export$222ae9aca08830f0);
$parcel$export(module.exports, "getGiraRequestOptions", () => $8fd02e0075f962e8$export$e1542dc7ff749de8);
$parcel$export(module.exports, "getContentPanelsQuery", () => (parcelRequire("7IE2L")).getContentPanelsQuery);
$parcel$export(module.exports, "getEcosystemQuery", () => (parcelRequire("gIud4")).getEcosystemQuery);

var $bKxX9 = parcelRequire("bKxX9");

var $k0k8C = parcelRequire("k0k8C");

var $cs6Z7 = parcelRequire("cs6Z7");

var $6wu6G = parcelRequire("6wu6G");

var $h9ZPQ = parcelRequire("h9ZPQ");
var $8b8FO = parcelRequire("8b8FO");
var $iKlzi = parcelRequire("iKlzi");
var $7IE2L = parcelRequire("7IE2L");
var $gIud4 = parcelRequire("gIud4");
var $78jDL = parcelRequire("78jDL");
var $bjRBT = parcelRequire("bjRBT");
var $aEsk2 = parcelRequire("aEsk2");
var $k94eC = parcelRequire("k94eC");
var $9U1Mc = parcelRequire("9U1Mc");
var $1zKic = parcelRequire("1zKic");
var $4825Q = parcelRequire("4825Q");
var $cEBFL = parcelRequire("cEBFL");
const $8fd02e0075f962e8$var$CREATED_ORDER_DESCENDING = '-created';
const $8fd02e0075f962e8$export$1780a132c0453fee = 'issueViewInteractiveQuery';
const $8fd02e0075f962e8$export$aefb19023b2eda55 = (baseUrl, operation)=>`${baseUrl}/rest/gira/1/${(0, $k0k8C.appendOperationQuery)(operation)}`;
const $8fd02e0075f962e8$var$viewIssueQuery = ()=>`
    viewIssue(issueKey: $issueKey) {
        ${(0, $cs6Z7.getIsOldValueRequested)((0, $6wu6G.GIRA_AGG_MIGRATION_ISARCHIVED_FLAG)) ? (0, $78jDL.getIsArchivedQuery)() : ''}
        canCreateSubTask
        ${(0, $6wu6G.isIssueExportControlEnabled)() ? 'canExportIssue' : ''}
        ${/**
					 * Note: When activity sorting feature is enabled, we do not
					 * want to fetch with sort order passed through; we should defer
					 * to the saved sort order in the backend to return the correct
					 * sort order
					 */ (0, $8b8FO.default)({
        maxResults: (0, $cEBFL.NUM_INITIAL_COMMENTS_TO_LOAD),
        startAt: 0,
        orderBy: $8fd02e0075f962e8$var$CREATED_ORDER_DESCENDING,
        commentAmount: Math.floor((0, $cEBFL.NUM_INITIAL_COMMENTS_TO_LOAD))
    })}
        ${/**
					 * Note: When activity sorting feature is enabled, we do not
					 * want to fetch with sort order passed through; we should defer
					 * to the saved sort order in the backend to return the correct
					 * sort order
					 */ (0, $4825Q.default)({
        startAt: 0,
        worklogAmount: Math.floor((0, $cEBFL.NUM_INITIAL_WORKLOGS_TO_LOAD))
    })}
        ${(0, $gIud4.getEcosystemQuery)()}
        ${(0, $7IE2L.getContentPanelsQuery)()}
        ${(0, $bKxX9.ff)('issue-view-remove-glancesfield-from-query_fyj0g') ? (0, $gIud4.getLegacyRightWebPanelsQuery)() : (0, $gIud4.getGlancesQuery)()}
		${// only fetch dead glancesField if it's already removed (using legacyRightWebPanels)
    (0, $bKxX9.ff)('issue-view-remove-glancesfield-from-query_fyj0g') && (0, $bKxX9.ff)('implement-dead-glancesfield-query_f71sc') ? (0, $gIud4.getGlancesQuery)() : ''}
        ${(0, $bKxX9.ff)('issue.details.gira-agg-migration-attachments_ecebe') ? 'totalAttachmentsCount' : (0, $h9ZPQ.default)()}
        ${(0, $iKlzi.getContainersByTypeQuery)()}
        ${(0, $1zKic.getRemoteLinksQuery)()}
    }
`;
const $8fd02e0075f962e8$export$79eba9bf6dc9960d = ()=>`
    jira {
        ecosystemFirstSeenOnIssueView
    }
`;
const $8fd02e0075f962e8$export$58eaa2ae4a5a410a = ()=>`
    jira {
        ecosystemFirstSeenOnIssueView
        hasAdministerPermission: hasGlobalPermission(key: ADMINISTER)
        hasUserPickerPermission: hasGlobalPermission(key: USER_PICKER)
    }
`;
const $8fd02e0075f962e8$export$222ae9aca08830f0 = ()=>`
query ${$8fd02e0075f962e8$export$1780a132c0453fee}($issueKey: String!, $projectKey: String)  {
        ${$8fd02e0075f962e8$export$58eaa2ae4a5a410a()}
        ${(0, $aEsk2.default)()}
        ${$8fd02e0075f962e8$var$viewIssueQuery()}
        ${(0, $bjRBT.getJiraSettingsQuery)()}
        ${(0, $k94eC.default)()}
        ${(0, $9U1Mc.default)()}
    }

`;
const $8fd02e0075f962e8$export$e1542dc7ff749de8 = (issueKey, projectKey)=>{
    const payload = {
        operationName: $8fd02e0075f962e8$export$1780a132c0453fee,
        query: $8fd02e0075f962e8$export$222ae9aca08830f0(),
        variables: {
            issueKey: issueKey,
            projectKey: projectKey
        }
    };
    return {
        method: 'POST',
        body: JSON.stringify(payload)
    };
};

});
parcelRegister("k0k8C", function(module, exports) {

$parcel$export(module.exports, "appendOperationQuery", () => $c7bfdca12e254eb8$export$69694c3add0f6058);
const $c7bfdca12e254eb8$export$69694c3add0f6058 = (operation)=>operation ? `?operation=${operation}` : '';

});

parcelRegister("cs6Z7", function(module, exports) {

$parcel$export(module.exports, "getIsOldValueRequested", () => $712ffcbbea6809c2$export$117d07493a3c1dce);
$parcel$export(module.exports, "getIsNewValueRequested", () => $712ffcbbea6809c2$export$7cdf481ce732d27f);

var $bKxX9 = parcelRequire("bKxX9");
const $712ffcbbea6809c2$var$getConsistencyCheckFeatureFlag = (featureFlagName, defaultValue = 'OLD')=>{
    const possibleValues = [
        'NEW',
        'CHECK_RETURN_NEW',
        'CHECK',
        'OLD'
    ];
    return (0, $bKxX9.getMultivariateFeatureFlag)(featureFlagName, defaultValue, possibleValues);
};
const $712ffcbbea6809c2$export$117d07493a3c1dce = (featureFlagName)=>{
    const featureFlagValue = $712ffcbbea6809c2$var$getConsistencyCheckFeatureFlag(featureFlagName);
    return featureFlagValue === 'OLD' || featureFlagValue === 'CHECK_RETURN_NEW' || featureFlagValue === 'CHECK';
};
const $712ffcbbea6809c2$export$7cdf481ce732d27f = (featureFlagName)=>{
    const featureFlagValue = $712ffcbbea6809c2$var$getConsistencyCheckFeatureFlag(featureFlagName);
    return featureFlagValue === 'NEW' || featureFlagValue === 'CHECK_RETURN_NEW' || featureFlagValue === 'CHECK';
};

});

parcelRegister("6wu6G", function(module, exports) {

$parcel$export(module.exports, "isParentInIssueViewEnabled", () => $54a10774de0b57ab$export$9c7fa56ed1fa2e15);
$parcel$export(module.exports, "isJsmTimelineEnabled", () => $54a10774de0b57ab$export$575e1bf822db15b5);
$parcel$export(module.exports, "GIRA_AGG_MIGRATION_ISARCHIVED_FLAG", () => $54a10774de0b57ab$export$f53cbe8a5052e3e0);
$parcel$export(module.exports, "isIssueExportControlEnabled", () => $54a10774de0b57ab$export$e92cc7310d059d3e);

var $bKxX9 = parcelRequire("bKxX9");
const $54a10774de0b57ab$export$9c7fa56ed1fa2e15 = ()=>(0, $bKxX9.ff)('parent-field-in-issue-view_x4zn4', false);
const $54a10774de0b57ab$export$575e1bf822db15b5 = ()=>(0, $bKxX9.ff)('jsm-timelines-phase-2_70gja', false);
const $54a10774de0b57ab$export$f53cbe8a5052e3e0 = 'issue.details.gira-agg-migration-isarchived';
const $54a10774de0b57ab$export$e92cc7310d059d3e = ()=>(0, $bKxX9.ff)('dlp-gordian-enabled', false); // </gordian>

});

parcelRegister("h9ZPQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c28c20ef01249d5c$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $c28c20ef01249d5c$export$2e2bcd8739ae039 = ()=>`attachments(orderDirection: DESC, orderField: CREATED, maxResults: 12) {
        nodes {
          id
          filename
          mimetype
          mediaApiFileId
          createdDate
          filesize
          parentName
          author {
              accountId
          }
          parentId
          hasRestrictedParent
        }
        totalCount
        deletableCount
      }
`;

});

parcelRegister("8b8FO", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b9fb32e2d7fc8e2$export$2e2bcd8739ae039);

var $8c9rb = parcelRequire("8c9rb");

var $6wu6G = parcelRequire("6wu6G");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7b9fb32e2d7fc8e2$export$2e2bcd8739ae039 = ({ maxResults: maxResults, startAt: startAt, orderBy: orderBy, commentAmount: commentAmount })=>{
    const commentPermalinkId = (0, $8c9rb.getPermalinkId)((0, $8c9rb.COMMENTS));
    const orderByParameter = orderBy !== null && orderBy !== undefined ? `, orderBy: "${orderBy}"` : '';
    const commentParameter = commentPermalinkId !== null && commentPermalinkId !== undefined ? `, commentId: ${commentPermalinkId}` : '';
    const commentAmountParameter = commentParameter !== '' && commentAmount !== null && commentAmount !== undefined ? `, commentAmount: ${commentAmount}` : '';
    const maxResultsParameter = commentParameter === '' && maxResults !== null && maxResults !== undefined ? `, maxResults: ${maxResults}` : '';
    const jiraCommentVisibility = ` jiraCommentVisibility {
    __typename
    ...on JiraRoleVisibility {
      name
    }
    ...on JiraGroupVisibility {
      group {
        groupId
        name
      }
    }
  }`;
    return `
        comments (first: ${startAt}${maxResultsParameter}${orderByParameter}${commentParameter}${commentAmountParameter}) {
            nodes {
                id
                author {
                    accountId
                    displayName
                    avatarUrl
                }
                updateAuthor {
                    accountId
                    displayName
                    avatarUrl
                }
                ${jiraCommentVisibility}
                created
                updated
                jsdPublic
                bodyAdf
                jsdAuthorCanSeeRequest
                ${(0, $6wu6G.isJsmTimelineEnabled)() ? 'eventOccurredAt' : ''}
                ${(0, $6wu6G.isJsmTimelineEnabled)() ? 'jsdIncidentActivityViewHidden' : ''}
            }
            totalCount
            startIndex
        }
    `;
};

});
parcelRegister("8c9rb", function(module, exports) {

$parcel$export(module.exports, "COMMENTS", () => $227761ce6e538457$export$4cab9dfa8fc858f4);
$parcel$export(module.exports, "WORKLOG", () => $227761ce6e538457$export$df36fc05622c402);
$parcel$export(module.exports, "getPermalinkId", () => $227761ce6e538457$export$bf42dbba4c31080e);

var $gUUjF = parcelRequire("gUUjF");
const $227761ce6e538457$export$b18d061fc042df1a = {
    COMMENTS: 'focusedCommentId',
    WORKLOG: 'focusedWorklogId'
};
const $227761ce6e538457$export$4cab9dfa8fc858f4 = 'COMMENTS';
const $227761ce6e538457$export$df36fc05622c402 = 'WORKLOG';
const $227761ce6e538457$var$getAllUrlParams = ()=>{
    // get query string from  window
    let queryString = window.location.search.slice(1);
    // we'll store the parameters here
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const obj = {};
    // if query string exists
    if (queryString) {
        // stuff after # is not part of query string, so get rid of it
        queryString = queryString.split('#')[0];
        // split our query string into its component parts
        const arr = queryString.split('&');
        for(let i = 0; i < arr.length; i += 1){
            // separate the keys and the values
            const a = arr[i].split('=');
            // set parameter name and value (use 'true' if empty)
            const paramName = a[0];
            try {
                const paramValue = typeof a[1] === 'undefined' ? true : decodeURIComponent(a[1]);
                obj[paramName] = paramValue;
            } catch (error) {
                (0, $gUUjF.default).safeErrorWithoutCustomerData('getAllUrlParams', `Malformed value was obtained from the query string for ${paramName}`);
            }
        }
    }
    return obj;
};
const $227761ce6e538457$export$bf42dbba4c31080e = (targetPermalinkType)=>{
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly COMMENTS: "focusedCommentId"; readonly WORKLOG: "focusedWorklogId"; }'.
    if (!$227761ce6e538457$export$b18d061fc042df1a[targetPermalinkType]) return null;
    const urlParams = $227761ce6e538457$var$getAllUrlParams();
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly COMMENTS: "focusedCommentId"; readonly WORKLOG: "focusedWorklogId"; }'.
    return urlParams[$227761ce6e538457$export$b18d061fc042df1a[targetPermalinkType]];
};

});


parcelRegister("iKlzi", function(module, exports) {

$parcel$export(module.exports, "getContainersByTypeQuery", () => $f3b1ff3f54778e3d$export$63131b2831854cc);
const $f3b1ff3f54778e3d$export$63131b2831854cc = ()=>`
containersByType(input:{systemContainerTypes: [CONTENT, PRIMARY, SECONDARY, REQUEST_PORTAL], supportDefaultTab: true}) {
__typename
... on JiraIssueItemContainers {
containers {
  containerType
  items {
    nodes {
      type: __typename
      ... on JiraIssueItemFieldItem {
        fieldItemId        
      }
      ... on JiraIssueItemPanelItem {
        panelItemId
      }
      ... on JiraIssueItemTabContainer {
        name
        tabContainerId              
        items {
          nodes {
            type: __typename
            ... on JiraIssueItemFieldItem {
              fieldItemId
            }
          }
        }
      }
    }
  }
}
}
}
`;

});

parcelRegister("7IE2L", function(module, exports) {

$parcel$export(module.exports, "getContentPanelsQuery", () => $431a6f81d3096fcd$export$e6f14eac549b679d);
const $431a6f81d3096fcd$var$getContentPanelNode = ()=>`
    name
    addonKey
    moduleKey
    options
    iconUrl
    tooltip
    type
    isShownByDefault
    wasManuallyAddedToIssue
`;
const $431a6f81d3096fcd$var$getContentPanelsConnectionQuery = ()=>`
    contentPanels {
        edges {
            node {
                ${$431a6f81d3096fcd$var$getContentPanelNode()}
            }
        }
    }
`;
const $431a6f81d3096fcd$var$getLegacyContentPanelsConnectionQuery = ()=>`
    legacyContentPanels {
        edges {
            node {
                ${$431a6f81d3096fcd$var$getContentPanelNode()}
            }
        }
    }
`;
const $431a6f81d3096fcd$export$e6f14eac549b679d = ()=>`
    ${$431a6f81d3096fcd$var$getContentPanelsConnectionQuery()}
    ${$431a6f81d3096fcd$var$getLegacyContentPanelsConnectionQuery()}
    hasCustomisedContentPanels
`;

});

parcelRegister("gIud4", function(module, exports) {

$parcel$export(module.exports, "getEcosystemQuery", () => $7b5055fce2a30c91$export$edefef8c65e08bd2);
$parcel$export(module.exports, "getGlancesQuery", () => $7b5055fce2a30c91$export$ca7e7bf9f1b931a2);
$parcel$export(module.exports, "getLegacyRightWebPanelsQuery", () => $7b5055fce2a30c91$export$92c9a3dc7076af51);

var $bKxX9 = parcelRequire("bKxX9");
const $7b5055fce2a30c91$var$getForgeQuery = ()=>`forge {
        panels {
          id
          instances {
            id
            collapsed
            added
          }
        }
      }`;
const $7b5055fce2a30c91$export$edefef8c65e08bd2 = ()=>`
    ecosystem {
      ${!(0, $bKxX9.ff)('issue-view-remove-connect-operations-from-critical-fetch_vtk4w') ? `
      operations {
        name
        url: href
        icon {
          url
        }
        tooltip
        styleClass
      }` : ''}
      ${!(0, $bKxX9.ff)('issue-view-remove-activitypanels-from-critical-fetch_43ozj') ? `
      activityPanels {
        name
        iframe {
          addonKey
          moduleKey
          options
        }
      }    
    ` : ''}
      ${!(0, $bKxX9.ff)('issue-view-remove-backgroundscripts-from-critical-fetch_6f6on') ? `
      backgroundScripts {
        iframe {
          addonKey
          moduleKey
          options
        }
        shouldReloadOnRefresh
      }` : ''}
      contextPanels {
        name
        iframe {
          addonKey
          moduleKey
          options
        }
        icon {
          url
        }
        content
        status
        type
      }
      ${$7b5055fce2a30c91$var$getForgeQuery()}
    }
`;
const $7b5055fce2a30c91$export$ca7e7bf9f1b931a2 = ()=>`
        glancesField {
          fieldKey
          value {
            name
            status
            iframe {
              addonKey
              moduleKey
              options
            }
            icon {
              url
            }
            content
            type
          }
        }
      `;
const $7b5055fce2a30c91$export$92c9a3dc7076af51 = ()=>`
        legacyRightWebPanels {
          edges {
            node {
              name
              status
              addonKey
              moduleKey
              options
              content
            }
          }
        }
      `;

});

parcelRegister("78jDL", function(module, exports) {

$parcel$export(module.exports, "getIsArchivedQuery", () => $70934e0e589cd253$export$2b9ee7163e124831);
const $70934e0e589cd253$export$2b9ee7163e124831 = ()=>'isArchived';

});

parcelRegister("bjRBT", function(module, exports) {

$parcel$export(module.exports, "getJiraSettingsQuery", () => $fc5601890f738e54$export$191f50c0f86b85ec);
const $fc5601890f738e54$export$e302502f14e3f203 = ()=>`
          timeTracking {
            isTimeTrackingEnabled
            hoursPerDay
            daysPerWeek
            defaultUnit
            format
          }
    `;
const $fc5601890f738e54$export$65e7d3d1915962da = ()=>`
          subtasks {
            enabled
          }
    `;
const $fc5601890f738e54$export$191f50c0f86b85ec = ()=>`
    jiraSettings {
      newIssueViewTransitionSettings {
        shouldDelayChangeboarding
        newIssueViewTransitionLockingStatus
     }
    }
`;

});

parcelRegister("aEsk2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad384184792593f0$export$2e2bcd8739ae039);

var $hCNRu = parcelRequire("hCNRu");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ad384184792593f0$export$2e2bcd8739ae039 = ()=>`mediaContext(issueKey: $issueKey) {
    userToken {
      token
      id
      issueId
      tokenDurationInMins
    }
    uploadToken {
      __typename
      ... on MediaUploadToken {
        endpointUrl
        token
        targetCollection
        tokenDurationInMins
        clientId
      }
      ... on FailedMediaUploadToken {
        error
      }
    }
    readToken(maxTokenLength: ${(0, $hCNRu.getMaxTokenLength)()}) {
      clientId
      endpointUrl
      tokensWithFiles {
        files {
          issueId
          attachmentId
          attachmentMediaApiId
        }
        token
      }
      tokenLifespanInSeconds
    }
  }`;

});
parcelRegister("hCNRu", function(module, exports) {

$parcel$export(module.exports, "getMaxTokenLength", () => $64be2f4b2ff25f7a$export$e40f2acaf1a50b00);
// Low enough such that it shouldn't cause problems for non-IE11 browsers, and high
// enough such that it shouldn't be encountered in practice very often.
const $64be2f4b2ff25f7a$var$nonIE11MaxTokenLength = 2 ** 16;
const $64be2f4b2ff25f7a$export$e40f2acaf1a50b00 = ()=>$64be2f4b2ff25f7a$var$nonIE11MaxTokenLength;

});


parcelRegister("k94eC", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2892695ccbce2fe$export$2e2bcd8739ae039);
// A list of all keys of permissions that this transformer supports.
const $c2892695ccbce2fe$export$9fc40cb6f3529ef = ()=>[
        'ADMINISTER_PROJECTS',
        'ASSIGN_ISSUES',
        'EDIT_ISSUES',
        'SCHEDULE_ISSUES',
        'ADD_COMMENTS',
        'DELETE_ALL_COMMENTS',
        'DELETE_OWN_COMMENTS',
        'EDIT_ALL_COMMENTS',
        'EDIT_OWN_COMMENTS',
        'CREATE_ISSUES',
        'DELETE_ISSUES',
        'MOVE_ISSUES',
        'MODIFY_REPORTER',
        'CREATE_ATTACHMENTS',
        'DELETE_ALL_ATTACHMENTS',
        'DELETE_OWN_ATTACHMENTS',
        'WORK_ON_ISSUES',
        'ASSIGNABLE_USER',
        'LINK_ISSUES',
        'VIEW_VOTERS_AND_WATCHERS',
        'MANAGE_WATCHERS',
        'EDIT_ALL_WORKLOGS',
        'EDIT_OWN_WORKLOGS',
        'DELETE_ALL_WORKLOGS',
        'DELETE_OWN_WORKLOGS',
        'VIEW_DEV_TOOLS',
        'SERVICEDESK_AGENT',
        'RESOLVE_ISSUES',
        'CLONE_ISSUE'
    ];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c2892695ccbce2fe$export$2e2bcd8739ae039 = ()=>`
    permissions(issueKey:$issueKey, keys:["${$c2892695ccbce2fe$export$9fc40cb6f3529ef().join('","')}"]) {
        key
        havePermission
    }
`;

});

parcelRegister("9U1Mc", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4c00732e1b938da$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $a4c00732e1b938da$export$2e2bcd8739ae039 = ()=>`
    project(projectKey: $projectKey) {
        id
        newIssueViewLockedIn
        issueTypes {
            id
            name
            iconUrl
            subtask
        }
    }
`;

});

parcelRegister("1zKic", function(module, exports) {

$parcel$export(module.exports, "getRemoteLinksQuery", () => $785a81b5a18b3dbb$export$6bbc6b72b0b57f25);
const $785a81b5a18b3dbb$export$6bbc6b72b0b57f25 = ()=>`
    remoteLinks {
        isLinkingEnabled
        remoteLinkedIssues {
            preview {
                id
                issueId
                globalId
                href
                applicationType
                applicationName
                relationship
                title
            }
        }
    }            
`;

});

parcelRegister("4825Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a565ae6a7a72917$export$2e2bcd8739ae039);

var $8c9rb = parcelRequire("8c9rb");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7a565ae6a7a72917$export$2e2bcd8739ae039 = ({ startAt: startAt, orderBy: orderBy, worklogAmount: worklogAmount })=>{
    const orderByParameter = orderBy !== null && orderBy !== undefined ? `, orderBy: "${orderBy}"` : '';
    const worklogPermalinkId = (0, $8c9rb.getPermalinkId)((0, $8c9rb.WORKLOG));
    if (worklogPermalinkId === null || worklogPermalinkId === undefined) return '';
    const worklogParameter = `, worklogId: ${worklogPermalinkId}`;
    const worklogAmountParameter = worklogAmount !== null && worklogAmount !== undefined ? `, worklogAmount: ${worklogAmount}` : '';
    return `
        worklogs (startAt: ${startAt}${orderByParameter}${worklogParameter}${worklogAmountParameter}) {
            nodes {
                id
                author {
                    accountId
                    displayName
                    avatarUrl
                }
                updateAuthor {
                    accountId
                    displayName
                    avatarUrl
                }
                created
                started
                updated
                comment
                timeSpent
                timeSpentSeconds
            }
            totalCount
            startIndex
        }
    `;
};

});

parcelRegister("cEBFL", function(module, exports) {

$parcel$export(module.exports, "NUM_INITIAL_COMMENTS_TO_LOAD", () => $918a33e666c5e78d$export$c46d621c29194aa4);
$parcel$export(module.exports, "NUM_INITIAL_WORKLOGS_TO_LOAD", () => $918a33e666c5e78d$export$b2e398ce246f55b3);
$parcel$export(module.exports, "gqlTagGira", () => $918a33e666c5e78d$export$aeae6fc40846cf9f);

var $7IE2L = parcelRequire("7IE2L");

var $gIud4 = parcelRequire("gIud4");

var $78jDL = parcelRequire("78jDL");


var $h9ZPQ = parcelRequire("h9ZPQ");

var $8b8FO = parcelRequire("8b8FO");

var $4825Q = parcelRequire("4825Q");

var $bjRBT = parcelRequire("bjRBT");

var $aEsk2 = parcelRequire("aEsk2");

var $k94eC = parcelRequire("k94eC");

var $9U1Mc = parcelRequire("9U1Mc");

var $iKlzi = parcelRequire("iKlzi");

var $1zKic = parcelRequire("1zKic");

const $918a33e666c5e78d$export$c46d621c29194aa4 = 5;
const $918a33e666c5e78d$export$304a6c004edb30d8 = '-created';
const $918a33e666c5e78d$export$b2e398ce246f55b3 = 5;
const $918a33e666c5e78d$export$1c36ecc9afd61c73 = '-started';
const $918a33e666c5e78d$export$aeae6fc40846cf9f = (literals, ...substitutions)=>{
    let result = '';
    // run the loop only for the substitution count
    substitutions.forEach((key, i)=>{
        result += literals[i];
        result += key.toString();
    });
    // add the last literal
    result += literals[literals.length - 1];
    return result;
};

});





parcelRegister("3sHes", function(module, exports) {

$parcel$export(module.exports, "peopleSetValueValidator", () => $a62d6b8303db47a8$export$b553dcd60e54b2da);
$parcel$export(module.exports, "peopleSetValueTransformer", () => $a62d6b8303db47a8$export$6262031046230bac);
$parcel$export(module.exports, "peopleGetValueTransformer", () => $a62d6b8303db47a8$export$34e69b3ea0fd6308);

var $2Vsz9 = parcelRequire("2Vsz9");

var $jgrDo = parcelRequire("jgrDo");

var $fBuJM = parcelRequire("fBuJM");

var $8xPow = parcelRequire("8xPow");

var $eF9ai = parcelRequire("eF9ai");
const $a62d6b8303db47a8$export$b553dcd60e54b2da = (value)=>Array.isArray(value) && // We should omit automatic id special value so it won't be picked up by this field
    // It is only applicable to the assignee field
    value.every((userId)=>(0, $8xPow.isNotEmptyString)(userId) && (0, $fBuJM.isNotAutomaticId)(userId));
const $a62d6b8303db47a8$export$6262031046230bac = (value, lookupValues)=>{
    if (!value.length) return [];
    const filteredLookupValues = (0, $eF9ai.multiValueLookup)(value, lookupValues, 'accountId');
    if (value.length !== filteredLookupValues.length) {
        const notFoundValues = (0, $jgrDo.getValueLookupValuesDiff)(value, filteredLookupValues, 'accountId');
        throw new (0, $2Vsz9.FieldValueLookupError)(notFoundValues.join());
    }
    return filteredLookupValues.map(({ accountId: id, name: name, picture: avatarUrl })=>({
            id: id,
            name: name,
            avatarUrl: avatarUrl
        }));
};
const $a62d6b8303db47a8$export$34e69b3ea0fd6308 = (value)=>{
    if (!value) return [];
    // can be an object in case of people field with isMulti: false
    const valueArray = Array.isArray(value) ? value : [
        value
    ];
    return valueArray.map(({ id: accountId })=>({
            accountId: accountId
        }));
};

});

parcelRegister("1Wx7H", function(module, exports) {

$parcel$export(module.exports, "transformPrioritySetOptionsVisibility", () => $7f0fc53b7ffe5d8e$export$722da4484009d687);
$parcel$export(module.exports, "transformPriorityGetOptionsVisibility", () => $7f0fc53b7ffe5d8e$export$3cc1c0d9b27ad517);
$parcel$export(module.exports, "prioritySetValueTransformer", () => $7f0fc53b7ffe5d8e$export$c6ef424ead917b72);
$parcel$export(module.exports, "transformPriorityGetValue", () => $7f0fc53b7ffe5d8e$export$95a791a89befdf91);

var $2Vsz9 = parcelRequire("2Vsz9");

var $240Nk = parcelRequire("240Nk");

var $j55UJ = parcelRequire("j55UJ");

var $9DCyM = parcelRequire("9DCyM");
const $7f0fc53b7ffe5d8e$export$722da4484009d687 = (optionsVisibility, lookupValues)=>(0, $240Nk.applyOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
const $7f0fc53b7ffe5d8e$export$3cc1c0d9b27ad517 = (optionsVisibility, lookupValues)=>(0, $j55UJ.getAvailableOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
const $7f0fc53b7ffe5d8e$export$c6ef424ead917b72 = (value, lookupValues)=>{
    const lookupValue = (0, $9DCyM.singleValueLookup)(value, lookupValues, 'id');
    if (!lookupValue) throw new (0, $2Vsz9.FieldValueLookupError)();
    return {
        label: lookupValue.name,
        value: lookupValue.id,
        iconUrl: lookupValue.iconUrl
    };
};
const $7f0fc53b7ffe5d8e$export$95a791a89befdf91 = (priority)=>{
    if (!priority) return null;
    const { label: label, value: value, iconUrl: iconUrl } = priority;
    return {
        name: label,
        id: value,
        iconUrl: iconUrl
    };
};

});

parcelRegister("9dJRK", function(module, exports) {

$parcel$export(module.exports, "transformRadioButtonsSetOptionsVisibility", () => $70872c7d75e7f159$export$825e2dc660c855a0);
$parcel$export(module.exports, "transformRadioButtonsGetOptionsVisibility", () => $70872c7d75e7f159$export$149e6a6e5e31219);
$parcel$export(module.exports, "radioButtonsSetValueTransformer", () => $70872c7d75e7f159$export$d23713245ea192a9);
$parcel$export(module.exports, "radioButtonsGetValueTransformer", () => $70872c7d75e7f159$export$624bfe758f4ad3c6);

var $2Vsz9 = parcelRequire("2Vsz9");

var $240Nk = parcelRequire("240Nk");

var $j55UJ = parcelRequire("j55UJ");

var $9DCyM = parcelRequire("9DCyM");
const $70872c7d75e7f159$export$825e2dc660c855a0 = (optionsVisibility, lookupValues)=>(0, $240Nk.applyOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
const $70872c7d75e7f159$export$149e6a6e5e31219 = (optionsVisibility, lookupValues)=>(0, $j55UJ.getAvailableOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
const $70872c7d75e7f159$export$d23713245ea192a9 = (value, allowedValues)=>{
    if (value === null) return null;
    const foundValue = (0, $9DCyM.singleValueLookup)(value, allowedValues, 'id');
    if (!foundValue) throw new (0, $2Vsz9.FieldValueLookupError)();
    return {
        value: foundValue.id,
        label: foundValue.value
    };
};
const $70872c7d75e7f159$export$624bfe758f4ad3c6 = (value)=>{
    if (!value) return null;
    const { label: label, value: id } = value;
    return {
        id: id,
        value: label
    };
};

});

parcelRegister("dxSfw", function(module, exports) {

$parcel$export(module.exports, "reporterSetValueTransformer", () => $ada9cb53cbf81785$export$610accc7edd3f281);
$parcel$export(module.exports, "reporterGetValueTransformer", () => $ada9cb53cbf81785$export$2c1706dd36f54bb3);

var $2Vsz9 = parcelRequire("2Vsz9");

var $9DCyM = parcelRequire("9DCyM");
const $ada9cb53cbf81785$export$610accc7edd3f281 = (value, lookupValues)=>{
    if (value === null) return null;
    const foundValue = (0, $9DCyM.singleValueLookup)(value, lookupValues, 'accountId');
    if (!foundValue) throw new (0, $2Vsz9.FieldValueLookupError)();
    return {
        id: foundValue.accountId,
        name: foundValue.name,
        avatarUrl: foundValue.picture
    };
};
const $ada9cb53cbf81785$export$2c1706dd36f54bb3 = (value)=>{
    if (!value) return null;
    const { id: accountId } = value;
    return {
        accountId: accountId
    };
};

});

parcelRegister("bxDqf", function(module, exports) {

$parcel$export(module.exports, "transformSelectSetOptionsVisibility", () => $51efb35da251dc6a$export$81990085f8ab114b);
$parcel$export(module.exports, "transformSelectGetOptionsVisibility", () => $51efb35da251dc6a$export$7c7ca81813eb0f65);
$parcel$export(module.exports, "selectSetValueTransformer", () => $51efb35da251dc6a$export$136c42b919fdec83);
$parcel$export(module.exports, "selectGetValueTransformer", () => $51efb35da251dc6a$export$fd4db924c90bd0e2);

var $2Vsz9 = parcelRequire("2Vsz9");

var $240Nk = parcelRequire("240Nk");

var $j55UJ = parcelRequire("j55UJ");

var $9DCyM = parcelRequire("9DCyM");
const $51efb35da251dc6a$export$81990085f8ab114b = (optionsVisibility, lookupValues)=>(0, $240Nk.applyOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
const $51efb35da251dc6a$export$7c7ca81813eb0f65 = (optionsVisibility, lookupValues)=>(0, $j55UJ.getAvailableOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
const $51efb35da251dc6a$export$136c42b919fdec83 = (value, allowedValues)=>{
    if (value === null) return null;
    const foundValue = (0, $9DCyM.singleValueLookup)(value, allowedValues, 'id');
    if (!foundValue) throw new (0, $2Vsz9.FieldValueLookupError)();
    return {
        value: foundValue.id,
        label: foundValue.value
    };
};
const $51efb35da251dc6a$export$fd4db924c90bd0e2 = (value)=>{
    if (!value) return null;
    const { label: label, value: id } = value;
    return {
        id: id,
        value: label
    };
};

});

parcelRegister("6fCXk", function(module, exports) {

$parcel$export(module.exports, "singleLineTextFieldSetValueValidator", () => $ea1d2f3392f4e0a9$export$e0269944af4481cc);
$parcel$export(module.exports, "singleLineTextFieldGetValueTransformer", () => $ea1d2f3392f4e0a9$export$161c77b6b09fc494);
const $ea1d2f3392f4e0a9$export$e0269944af4481cc = (value)=>typeof value === 'string';
const $ea1d2f3392f4e0a9$export$161c77b6b09fc494 = (internalValue)=>internalValue !== undefined ? internalValue : '';

});

parcelRegister("eRMH7", function(module, exports) {

$parcel$export(module.exports, "userPickerSetValueTransformer", () => $479a996075356cdb$export$890d33cc39835486);
$parcel$export(module.exports, "userPickerGetValueTransformer", () => $479a996075356cdb$export$e87b0f36be178543);

var $2Vsz9 = parcelRequire("2Vsz9");

var $9DCyM = parcelRequire("9DCyM");
const $479a996075356cdb$export$890d33cc39835486 = (value, lookupValues)=>{
    if (value === null) return null;
    const foundValue = (0, $9DCyM.singleValueLookup)(value, lookupValues, 'accountId');
    if (!foundValue) throw new (0, $2Vsz9.FieldValueLookupError)();
    return {
        id: foundValue.accountId,
        name: foundValue.name,
        avatarUrl: foundValue.picture
    };
};
const $479a996075356cdb$export$e87b0f36be178543 = (value)=>{
    if (!value) return null;
    const { id: accountId } = value;
    return {
        accountId: accountId
    };
};

});

parcelRegister("EfOiv", function(module, exports) {

$parcel$export(module.exports, "fixVersionsSetValueValidator", () => $4cb36f7c55e72631$export$423303d5750f732c);
$parcel$export(module.exports, "transformVersionsSetValue", () => $4cb36f7c55e72631$export$5706ac863a06e5ed);
$parcel$export(module.exports, "transformVersionsGetValue", () => $4cb36f7c55e72631$export$360c4edb055d9cb4);
$parcel$export(module.exports, "versionsRequiredScopes", () => $4cb36f7c55e72631$export$60db61c485973ad9);

var $2Vsz9 = parcelRequire("2Vsz9");

var $1NIGg = parcelRequire("1NIGg");

var $jgrDo = parcelRequire("jgrDo");

var $8xPow = parcelRequire("8xPow");

var $eF9ai = parcelRequire("eF9ai");
const $4cb36f7c55e72631$export$423303d5750f732c = (value)=>Array.isArray(value) && value.every((0, $8xPow.isNotEmptyString));
const $4cb36f7c55e72631$export$5706ac863a06e5ed = (values, lookupValues)=>{
    if (!values.length) return [];
    const filteredLookupValues = (0, $eF9ai.multiValueLookup)(values, lookupValues, 'id');
    if (values.length !== filteredLookupValues.length) {
        const notFoundValues = (0, $jgrDo.getValueLookupValuesDiff)(values, filteredLookupValues, 'id');
        throw new (0, $2Vsz9.FieldValueLookupError)(notFoundValues.join());
    }
    return filteredLookupValues.map(({ name: name, id: id })=>({
            label: name,
            value: id
        }));
};
const $4cb36f7c55e72631$export$360c4edb055d9cb4 = (internalValue)=>{
    if (!internalValue) return [];
    return internalValue.map(({ value: value, label: label })=>({
            id: value,
            name: label
        }));
};
const $4cb36f7c55e72631$export$60db61c485973ad9 = {
    ...(0, $1NIGg.versionsRequiredScopes),
    granular: [
        ...(0, $1NIGg.versionsRequiredScopes).granular,
        'write:field.default-value:jira'
    ]
};

});

parcelRegister("459V5", function(module, exports) {

$parcel$export(module.exports, "default", () => $959b01ec75bb8054$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $959b01ec75bb8054$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    obligatoryUimGicConsentMessage: {
        "id": "ui-modifications-fields-configuration.common.utils.views.gic.obligatory-uim-gic-consent-message",
        "defaultMessage": "You must allow \"{appTitle}\" to access your Atlassian products to create this issue."
    }
});

});


parcelRegister("ke9hW", function(module, exports) {

$parcel$export(module.exports, "IssueTransitionViewConfiguration", () => $b34720468cbf828a$export$970307e8f6cfcea1);

var $3QMTK = parcelRequire("3QMTK");

var $7ZZxN = parcelRequire("7ZZxN");

var $1ybV0 = parcelRequire("1ybV0");


var $lO4Or = parcelRequire("lO4Or");

var $fy5vB = parcelRequire("fy5vB");


var $8QLPP = parcelRequire("8QLPP");

var $axvW5 = parcelRequire("axvW5");

var $9aEJT = parcelRequire("9aEJT");

var $e8h5r = parcelRequire("e8h5r");

var $e793N = parcelRequire("e793N");

var $incV3 = parcelRequire("incV3");

var $eMv4r = parcelRequire("eMv4r");

var $ifv0j = parcelRequire("ifv0j");

var $1zzzr = parcelRequire("1zzzr");

var $htzHC = parcelRequire("htzHC");

var $7AbVk = parcelRequire("7AbVk");

var $gLagZ = parcelRequire("gLagZ");

var $hFkmH = parcelRequire("hFkmH");

var $9Zo5b = parcelRequire("9Zo5b");

var $1h6vN = parcelRequire("1h6vN");

var $2xymT = parcelRequire("2xymT");

var $b50wi = parcelRequire("b50wi");

var $dBUTs = parcelRequire("dBUTs");

var $lKEcA = parcelRequire("lKEcA");

var $cHN5s = parcelRequire("cHN5s");

var $3g1BX = parcelRequire("3g1BX");

var $2oXjw = parcelRequire("2oXjw");

var $1TPgc = parcelRequire("1TPgc");

var $48Oaa = parcelRequire("48Oaa");

var $kt4Dk = parcelRequire("kt4Dk");

var $k8Z2Y = parcelRequire("k8Z2Y");

var $8IcPP = parcelRequire("8IcPP");

var $ioiX9 = parcelRequire("ioiX9");

var $3nLyZ = parcelRequire("3nLyZ");

var $js9Si = parcelRequire("js9Si");

var $ivCUc = parcelRequire("ivCUc");

var $6Hfnl = parcelRequire("6Hfnl");

var $fD0E1 = parcelRequire("fD0E1");
class $b34720468cbf828a$export$970307e8f6cfcea1 {
    getSupportedFieldsConfiguration() {
        const commonFieldValidators = (0, $2xymT.getCommonFieldValidators)();
        return {
            [(0, $lO4Or.TEXT_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $9Zo5b.validateSingleLineTextValue)
                },
                publicToInternalTransformers: {},
                internalToPublicTransformers: {
                    value: (0, $9Zo5b.transformSingleLineTextToPublicValue)
                },
                emitChangeOn: 'blur'
            },
            [(0, $lO4Or.SELECT_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $ivCUc.selectSetValueValidator),
                    optionsVisibility: (0, $1ybV0.ff)('modern-issue-transition-fields-rollout-batch-2_bremb') ? (0, $b50wi.validateSetOptionsVisibility) : (0, $2xymT.validateSetOptionsVisibilityRule)
                },
                publicToInternalTransformers: {
                    value: (0, $1ybV0.ff)('modern-issue-transition-fields-rollout-batch-2_bremb') ? (0, $ivCUc.selectSetValueTransformer) : (0, $ivCUc.selectSetValueTransformerOld),
                    optionsVisibility: (0, $1ybV0.ff)('modern-issue-transition-fields-rollout-batch-2_bremb') ? (0, $b50wi.transformSetOptionsVisibilityAri) : (0, $ivCUc.transformSelectSetOptionsVisibility)
                },
                internalToPublicTransformers: {
                    value: (0, $1ybV0.ff)('modern-issue-transition-fields-rollout-batch-2_bremb') ? (0, $ivCUc.selectGetValueTransformer) : (0, $ivCUc.selectGetValueTransformerOld),
                    optionsVisibility: (0, $1ybV0.ff)('modern-issue-transition-fields-rollout-batch-2_bremb') ? (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK))) : (0, $ivCUc.transformSelectGetOptionsVisibility)
                },
                emitChangeOn: 'change',
                ...(0, $1ybV0.ff)('modern-issue-transition-fields-rollout-batch-2_bremb') ? {} : {
                    lookupSource: (0, $6b8c146c2dd688bb$export$a1cacdcf198da901)
                },
                propertyMapping: {
                    optionsVisibility: (0, $1ybV0.ff)('modern-issue-transition-fields-rollout-batch-2_bremb') ? 'fieldOptionsFilter' : 'allowedValues'
                }
            },
            [(0, $lO4Or.URL_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $9Zo5b.validateSingleLineTextValue)
                },
                publicToInternalTransformers: {},
                internalToPublicTransformers: {
                    value: (0, $9Zo5b.transformSingleLineTextToPublicValue)
                },
                emitChangeOn: 'blur'
            },
            [(0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $eMv4r.validateMultiCheckboxSetValue),
                    optionsVisibility: (0, $2xymT.validateSetOptionsVisibilityRule)
                },
                publicToInternalTransformers: {
                    value: (0, $1ybV0.ff)('modern-issue-transition-fields-rollout-batch-2_bremb') ? (0, $2oXjw.multiCheckboxSetValueTransformer) : (0, $2oXjw.oldMultiCheckboxSetValueTransformer),
                    optionsVisibility: (0, $1ybV0.ff)('modern-issue-transition-fields-rollout-batch-2_bremb') ? (0, $2oXjw.transformMultiCheckboxSetOptionsVisibility) : (0, $2oXjw.oldTransformMultiCheckboxSetOptionsVisibility)
                },
                internalToPublicTransformers: {
                    value: (0, $1ybV0.ff)('modern-issue-transition-fields-rollout-batch-2_bremb') ? (0, $2oXjw.multiCheckboxGetValueTransformer) : (0, $2oXjw.oldMultiCheckboxGetValueTransformer),
                    optionsVisibility: (0, $1ybV0.ff)('modern-issue-transition-fields-rollout-batch-2_bremb') ? (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK))) : (0, $2oXjw.transformMultiCheckboxGetOptionsVisibility)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$a1cacdcf198da901),
                propertyMapping: {
                    optionsVisibility: 'allowedValues'
                }
            },
            [(0, $lO4Or.RADIO_BUTTONS_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $hFkmH.radioButtonsSetValueValidator),
                    optionsVisibility: (0, $2xymT.validateSetOptionsVisibilityRule)
                },
                publicToInternalTransformers: {
                    value: (0, $1ybV0.ff)('modern-issue-transition-fields-rollout-batch-2_bremb') ? (0, $ioiX9.transformRadioButtonsSetValue) : (0, $ioiX9.radioButtonsSetValueTransformerOld),
                    optionsVisibility: (0, $1ybV0.ff)('modern-issue-transition-fields-rollout-batch-2_bremb') ? (0, $ioiX9.transformRadioButtonsSetOptionsVisibility) : (0, $ioiX9.transformRadioButtonsSetOptionsVisibilityOld)
                },
                internalToPublicTransformers: {
                    value: (0, $1ybV0.ff)('modern-issue-transition-fields-rollout-batch-2_bremb') ? (0, $ioiX9.transformRadioButtonsGetValue) : (0, $ioiX9.radioButtonsGetValueTransformerOld),
                    optionsVisibility: (0, $1ybV0.ff)('modern-issue-transition-fields-rollout-batch-2_bremb') ? (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK))) : (0, $ioiX9.transformRadioButtonsGetOptionsVisibility)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$a1cacdcf198da901),
                propertyMapping: {
                    optionsVisibility: 'allowedValues'
                }
            },
            [(0, $lO4Or.TEXT_AREA_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $kt4Dk.paragraphSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $kt4Dk.paragraphSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $kt4Dk.paragraphGetValueTransformer)
                },
                emitChangeOn: 'blur'
            },
            [(0, $lO4Or.DESCRIPTION_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $kt4Dk.paragraphSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $kt4Dk.paragraphSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $kt4Dk.paragraphGetValueTransformer)
                },
                emitChangeOn: 'blur'
            },
            [(0, $lO4Or.MULTI_SELECT_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $ifv0j.validateMultiSelectSetValue),
                    optionsVisibility: (0, $b50wi.validateSetOptionsVisibility)
                },
                publicToInternalTransformers: {
                    value: (0, $1TPgc.multiSelectSetValueTransformer),
                    optionsVisibility: (0, $b50wi.transformSetOptionsVisibilityAri)
                },
                internalToPublicTransformers: {
                    value: (0, $1TPgc.multiSelectGetValueTransformer),
                    /**
					 * Note: `transformFieldToIframe()` uses `FieldMapFromIframe` as input of optionsVisibility transformer,
					 * we're using `identity()` to return that same value and override `formData` (containing the private shape), before we sent it back to the iframe.
					 *
					 * Check "src/packages/issue-adjustments/issue-adjustments/src/controllers/issue-adjustments/main.tsx" for details.
					 */ optionsVisibility: (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK)))
                },
                propertyMapping: {
                    optionsVisibility: 'fieldOptionsFilter'
                },
                emitChangeOn: 'change'
            },
            [(0, $lO4Or.ASSIGNEE_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $8QLPP.assigneeSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $1ybV0.ff)('modern-issue-transition-fields-rollout-batch-5_gg7wo') ? (0, $dBUTs.transformAssigneeSetValue) : (0, $8QLPP.assigneeSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $8QLPP.assigneeGetValueTransformer)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$3a106242c8f57ac2)
            },
            [(0, $lO4Or.USER_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $1h6vN.userPickerSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $6Hfnl.transformUserPickerSetValue)
                },
                internalToPublicTransformers: {
                    value: (0, $6Hfnl.transformUserPickerGetValue)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$3a106242c8f57ac2)
            },
            [(0, $lO4Or.REPORTER_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $1h6vN.userPickerSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $6Hfnl.transformUserPickerSetValue)
                },
                internalToPublicTransformers: {
                    value: (0, $6Hfnl.transformUserPickerGetValue)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$3a106242c8f57ac2)
            },
            [(0, $lO4Or.RESOLUTION_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $js9Si.resolutionSetValueValidator),
                    optionsVisibility: (0, $b50wi.validateSetOptionsVisibility)
                },
                publicToInternalTransformers: {
                    value: (0, $js9Si.resolutionSetValueTransformer),
                    optionsVisibility: (0, $js9Si.transformSetOptionsVisibilityAriResolution)
                },
                internalToPublicTransformers: {
                    value: (0, $js9Si.resolutionGetValueTransformer),
                    optionsVisibility: (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK)))
                },
                emitChangeOn: 'change',
                propertyMapping: {
                    optionsVisibility: 'fieldOptionsFilter'
                }
            },
            [(0, $lO4Or.LABELS_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $3g1BX.validateLabelsSetValue)
                },
                publicToInternalTransformers: {
                    value: (0, $incV3.labelsSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $incV3.labelsGetValueTransformer)
                },
                emitChangeOn: 'change'
            },
            [(0, $lO4Or.DATE_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $9aEJT.datePickerSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $9aEJT.datePickerSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $9aEJT.datePickerGetValueTransformer)
                },
                emitChangeOn: 'change'
            },
            [(0, $lO4Or.DATETIME_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $e8h5r.validateDateTimePickerSetValue)
                },
                publicToInternalTransformers: {
                    value: (0, $e8h5r.transformDateTimePickerSetValue)
                },
                internalToPublicTransformers: {
                    value: (0, $e8h5r.transformDateTimePickerGetValue)
                },
                emitChangeOn: 'change'
            },
            [(0, $lO4Or.PRIORITY_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $gLagZ.validatePrioritySetValue),
                    optionsVisibility: (0, $b50wi.validateSetOptionsVisibility)
                },
                publicToInternalTransformers: {
                    value: (0, $8IcPP.prioritySetValueTransformer),
                    optionsVisibility: (0, $8IcPP.transformSetOptionsVisibilityAriPriority)
                },
                internalToPublicTransformers: {
                    value: (0, $8IcPP.priorityGetValueTransformer),
                    optionsVisibility: (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK)))
                },
                propertyMapping: {
                    optionsVisibility: 'fieldOptionsFilter'
                },
                emitChangeOn: 'change'
            },
            [(0, $lO4Or.ISSUE_TYPE)]: {
                publicShapeValidators: {
                    value: (0, $e793N.issueTypeSetValueValidator),
                    optionsVisibility: (0, $cHN5s.validateSetOptionsVisibilityIssueType)
                },
                publicToInternalTransformers: {
                    value: (0, $cHN5s.issueTypeSetValueTransformer),
                    optionsVisibility: (0, $cHN5s.transformIssueTypeSetOptionsVisibility)
                },
                internalToPublicTransformers: {
                    value: (0, $cHN5s.issueTypeGetValueTransformer),
                    optionsVisibility: (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK)))
                },
                emitChangeOn: 'change',
                propertyMapping: {
                    optionsVisibility: 'fieldOptionsFilter'
                }
            },
            [(0, $lO4Or.NUMBER_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $htzHC.validateNumberValue)
                },
                publicToInternalTransformers: {},
                internalToPublicTransformers: {},
                emitChangeOn: 'blur'
            },
            [(0, $lO4Or.PARENT_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $7AbVk.parentSetValueValidator),
                    optionsVisibility: (0, $b50wi.validateSetOptionsVisibility)
                },
                publicToInternalTransformers: {
                    value: (0, $k8Z2Y.transformParentSetValue),
                    optionsVisibility: (0, $k8Z2Y.transformParentSetOptionsVisibility)
                },
                internalToPublicTransformers: {
                    value: (0, $k8Z2Y.transformParentGetValue),
                    optionsVisibility: (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK)))
                },
                emitChangeOn: 'change',
                propertyMapping: {
                    optionsVisibility: 'fieldOptionsFilter'
                }
            },
            [(0, $lO4Or.FIX_VERSIONS_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $3nLyZ.validateReleaseVersionValue),
                    optionsVisibility: (0, $b50wi.validateSetOptionsVisibility)
                },
                publicToInternalTransformers: {
                    value: (0, $3nLyZ.transformReleaseVersionsSetValue),
                    optionsVisibility: (0, $3nLyZ.transformReleaseVersionsSetOptionsVisibility)
                },
                internalToPublicTransformers: {
                    value: (0, $3nLyZ.transformReleaseVersionsGetValue),
                    optionsVisibility: (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK)))
                },
                emitChangeOn: 'change',
                requiredScopes: (0, $3nLyZ.releaseVersionsRequiredScopes),
                propertyMapping: {
                    optionsVisibility: 'fieldOptionsFilter'
                }
            },
            [(0, $lO4Or.AFFECTS_VERSIONS_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $3nLyZ.validateReleaseVersionValue),
                    optionsVisibility: (0, $b50wi.validateSetOptionsVisibility)
                },
                publicToInternalTransformers: {
                    value: (0, $3nLyZ.transformReleaseVersionsSetValue),
                    optionsVisibility: (0, $3nLyZ.transformReleaseVersionsSetOptionsVisibility)
                },
                internalToPublicTransformers: {
                    value: (0, $3nLyZ.transformReleaseVersionsGetValue),
                    optionsVisibility: (0, (/*@__PURE__*/$parcel$interopDefault($3QMTK)))
                },
                emitChangeOn: 'change',
                requiredScopes: (0, $3nLyZ.releaseVersionsRequiredScopes),
                propertyMapping: {
                    optionsVisibility: 'fieldOptionsFilter'
                }
            },
            [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $axvW5.validateCascadingSelectSetValue)
                },
                publicToInternalTransformers: {
                    value: (0, $lKEcA.transformSetValueCascadingSelect)
                },
                internalToPublicTransformers: {
                    value: (0, $lKEcA.transformGetValueCascadingSelect)
                },
                emitChangeOn: 'change'
            },
            [(0, $lO4Or.MULTI_USER_CF_TYPE)]: {
                publicShapeValidators: {
                    ...commonFieldValidators,
                    value: (0, $1zzzr.validateMultiUserPickerSetValue)
                },
                publicToInternalTransformers: {
                    value: (0, $48Oaa.transformMultiUserPickerSetValue)
                },
                internalToPublicTransformers: {
                    value: (0, $48Oaa.transformMultiUserPickerGetValue)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$3a106242c8f57ac2)
            }
        };
    }
    getSupportedFieldTypes() {
        const supportedFieldTypes = [
            (0, $lO4Or.TEXT_CF_TYPE),
            (0, $lO4Or.SELECT_CF_TYPE),
            (0, $lO4Or.URL_CF_TYPE),
            (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE),
            (0, $lO4Or.RADIO_BUTTONS_CF_TYPE),
            (0, $lO4Or.TEXT_AREA_CF_TYPE),
            (0, $lO4Or.MULTI_SELECT_CF_TYPE),
            (0, $lO4Or.ASSIGNEE_TYPE),
            (0, $lO4Or.RESOLUTION_TYPE),
            (0, $lO4Or.DATE_CF_TYPE),
            (0, $lO4Or.DATETIME_CF_TYPE),
            (0, $lO4Or.LABELS_TYPE),
            (0, $lO4Or.PRIORITY_TYPE),
            (0, $lO4Or.ISSUE_TYPE),
            (0, $lO4Or.NUMBER_CF_TYPE),
            (0, $lO4Or.USER_CF_TYPE),
            (0, $lO4Or.FIX_VERSIONS_TYPE),
            (0, $lO4Or.AFFECTS_VERSIONS_TYPE),
            (0, $lO4Or.REPORTER_TYPE),
            (0, $lO4Or.CASCADING_SELECT_CF_TYPE),
            (0, $lO4Or.PARENT_TYPE),
            (0, $lO4Or.DESCRIPTION_TYPE),
            (0, $lO4Or.MULTI_USER_CF_TYPE)
        ];
        return supportedFieldTypes;
    }
    getSupportedProjectTypes() {
        return [
            (0, $7ZZxN.SOFTWARE_PROJECT)
        ];
    }
    getConsentMessage() {
        return (0, $fD0E1.default).uimTransitionViewConsentMessage;
    }
    getAnalytics() {
        return this.analytics;
    }
    getSupportedTriggerPointsConfiguration() {
        if ((0, $1ybV0.ff)('ui-modifications-on-issue-transition-view_7z1g0')) return new Set([
            (0, $fa834bef164496cf$export$ef94a84e2990361c),
            (0, $fa834bef164496cf$export$de11f84a7d32933b),
            (0, $fa834bef164496cf$export$6c46e4003e7b7e9c),
            (0, $fa834bef164496cf$export$4edf4c3eee5081f6),
            (0, $fa834bef164496cf$export$27b74e685c26e665),
            (0, $fa834bef164496cf$export$290710ac08f770c0),
            (0, $fa834bef164496cf$export$ddade13ad1b89bf0)
        ]);
        return new Set([]);
    }
    constructor(){
        this.analytics = {
            stopTTI: $fy5vB.stopTTI,
            cancelTTI: $fy5vB.cancelTTI,
            markIframeLoad: $fy5vB.markIframeLoad,
            markFieldsRegistered: $fy5vB.markFieldsRegistered,
            markOnInitResolved: $fy5vB.markOnInitResolved
        };
        this.isScreenTabsSupportEnabled = ()=>false;
    }
}

});
const $fa834bef164496cf$export$ef94a84e2990361c = 'issue-transition-issue-view';
const $fa834bef164496cf$export$de11f84a7d32933b = 'issue-transition-board-card-transition';
const $fa834bef164496cf$export$6c46e4003e7b7e9c = 'issue-transition-advanced-roadmaps-jira-transition';
const $fa834bef164496cf$export$e77cd508fbc3b5ba = 'issue-transition-backlog-inline-transition';
const $fa834bef164496cf$export$4edf4c3eee5081f6 = 'issue-transition-issue-view-shortcut-dialog';
const $fa834bef164496cf$export$27b74e685c26e665 = 'issue-transition-command-palette-status-field-transition';
const $fa834bef164496cf$export$290710ac08f770c0 = 'issue-transition-issue-results-shortcut-transition';
const $fa834bef164496cf$export$ddade13ad1b89bf0 = 'issue-transition-status-field-trigger';
const $fa834bef164496cf$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
const $fa834bef164496cf$export$2bf0e335b815a90b = 'comment';
const $fa834bef164496cf$export$1b8cc53b37a62399 = 'worklog';
const $fa834bef164496cf$export$d624b8367eb730df = 'issuelinks';

parcelRegister("eMv4r", function(module, exports) {

$parcel$export(module.exports, "validateMultiCheckboxSetValue", () => $1b4aa32c8b85acdf$export$56639f1c650d9ba5);


var $8xPow = parcelRequire("8xPow");
const $1b4aa32c8b85acdf$export$56639f1c650d9ba5 = (value)=>Array.isArray(value) && value.length <= (0, $6b8c146c2dd688bb$export$106087dcfd4fb129) && value.every((0, $8xPow.isNotEmptyString));

});

parcelRegister("ifv0j", function(module, exports) {

$parcel$export(module.exports, "validateMultiSelectSetValue", () => $0a46a3adc5b74859$export$7002ea8d8a6dd444);
$parcel$export(module.exports, "multiSelectScopes", () => $0a46a3adc5b74859$export$314882a3f1f403d6);


var $4XB9o = parcelRequire("4XB9o");

var $8xPow = parcelRequire("8xPow");
const $0a46a3adc5b74859$export$7002ea8d8a6dd444 = (value)=>Array.isArray(value) && value.length <= (0, $6b8c146c2dd688bb$export$106087dcfd4fb129) && value.every((0, $8xPow.isNotEmptyString));
const $0a46a3adc5b74859$export$314882a3f1f403d6 = (0, $4XB9o.baseScopesRequiredPerField);

});

parcelRegister("1zzzr", function(module, exports) {

$parcel$export(module.exports, "validateMultiUserPickerSetValue", () => $1202a9c5b84d7884$export$57a9bf0fd9eba591);


var $fBuJM = parcelRequire("fBuJM");

var $8xPow = parcelRequire("8xPow");
const $1202a9c5b84d7884$export$57a9bf0fd9eba591 = (value)=>Array.isArray(value) && value.length <= (0, $6b8c146c2dd688bb$export$106087dcfd4fb129) && // We should omit automatic id special value so it won't be picked up by this field
    // It is only applicable to the assignee field
    value.every((option)=>(0, $8xPow.isNotEmptyString)(option) && (0, $fBuJM.isNotAutomaticId)(option));

});

parcelRegister("9Zo5b", function(module, exports) {

$parcel$export(module.exports, "validateSingleLineTextValue", () => $266811df11a6043f$export$88db43fe998a9953);
$parcel$export(module.exports, "transformSingleLineTextToPublicValue", () => $266811df11a6043f$export$7c3fcefca458407b);
$parcel$export(module.exports, "singleLineTextScopes", () => $266811df11a6043f$export$60f08a79db8505dc);

var $4XB9o = parcelRequire("4XB9o");
const $266811df11a6043f$export$88db43fe998a9953 = (value)=>typeof value === 'string';
const $266811df11a6043f$export$7c3fcefca458407b = (internalValue)=>internalValue || '';
const $266811df11a6043f$export$60f08a79db8505dc = (0, $4XB9o.baseScopesRequiredPerField);

});

parcelRegister("b50wi", function(module, exports) {

$parcel$export(module.exports, "transformSelectSetOptionsVisibility", () => $ced00c0766dbb63f$export$81990085f8ab114b);
$parcel$export(module.exports, "transformOptionIdsToARI", () => $ced00c0766dbb63f$export$aaa1909c16b4bd2c);
$parcel$export(module.exports, "transformSetOptionsVisibilityAri", () => $ced00c0766dbb63f$export$a68e1c2d1192287c);
$parcel$export(module.exports, "transformSelectGetOptionsVisibility", () => $ced00c0766dbb63f$export$7c7ca81813eb0f65);
$parcel$export(module.exports, "optionsVisibilityContainNoMoreThan100Items", () => $ced00c0766dbb63f$export$914c7f5212c4c649);
$parcel$export(module.exports, "validateSetOptionsVisibility", () => $ced00c0766dbb63f$export$973aead813665e25);

var $huI7r = parcelRequire("huI7r");

var $2xymT = parcelRequire("2xymT");
const $ced00c0766dbb63f$export$81990085f8ab114b = ({ isVisible: isVisible, options: options })=>({
        operation: isVisible ? 'ALLOW' : 'EXCLUDE',
        ids: options
    });
const $ced00c0766dbb63f$export$aaa1909c16b4bd2c = (optionIds, { tenantContext: tenantContext, fieldContext: fieldContext })=>optionIds.map((optionId)=>{
        const resourceId = `${fieldContext.fieldId}/${optionId}`;
        return (0, $huI7r.createAri)({
            resourceOwner: 'jira',
            cloudId: tenantContext.cloudId,
            resourceType: 'issue-field-option',
            activationId: tenantContext.activationId,
            resourceId: resourceId
        });
    });
const $ced00c0766dbb63f$export$a68e1c2d1192287c = ({ isVisible: isVisible, options: options }, _lookupValues, context)=>({
        operation: isVisible ? 'ALLOW' : 'EXCLUDE',
        optionIds: $ced00c0766dbb63f$export$aaa1909c16b4bd2c(options, context)
    });
const $ced00c0766dbb63f$export$7c7ca81813eb0f65 = ({ isVisible: isVisible, options: options })=>({
        isVisible: isVisible,
        options: options
    });
const $ced00c0766dbb63f$export$914c7f5212c4c649 = (optionsVisibility)=>optionsVisibility.options.length <= 100;
const $ced00c0766dbb63f$export$973aead813665e25 = (optionsVisibility)=>(0, $2xymT.validateSetOptionsVisibilityRule)(optionsVisibility) && $ced00c0766dbb63f$export$914c7f5212c4c649(optionsVisibility);

});

parcelRegister("dBUTs", function(module, exports) {

$parcel$export(module.exports, "transformAssigneeSetValue", () => $e2b90bba5e8591a9$export$8de5b8bd1490307a);


var $2Vsz9 = parcelRequire("2Vsz9");

var $9DCyM = parcelRequire("9DCyM");
const $e2b90bba5e8591a9$export$8de5b8bd1490307a = (value, lookupValues)=>{
    if (value === null) return null;
    const foundValue = (0, $9DCyM.singleValueLookup)(value, lookupValues, 'accountId');
    if (!foundValue) throw new (0, $2Vsz9.FieldValueLookupError)();
    if (foundValue.accountId === (0, $19ac13c3509f8eeb$export$203481fb42374407)) return {
        ...foundValue,
        id: (0, $19ac13c3509f8eeb$export$f5d5f6bb902f1027),
        accountStatus: 'active'
    };
    return foundValue;
};

});
const $19ac13c3509f8eeb$export$3619ebc524504344 = 'assignee';
const $19ac13c3509f8eeb$export$d875316cb0cd94f7 = '__INVITE_PEOPLE_ID__';
const $19ac13c3509f8eeb$export$f5d5f6bb902f1027 = 'ari:cloud:identity::user/-1';
const $19ac13c3509f8eeb$export$203481fb42374407 = '-1';


parcelRegister("lKEcA", function(module, exports) {

$parcel$export(module.exports, "transformSetValueCascadingSelect", () => $ba8b57f84711c945$export$905a8d55c641a71e);
$parcel$export(module.exports, "transformGetValueCascadingSelect", () => $ba8b57f84711c945$export$47e9770ed0d1c344);

var $3l1bi = parcelRequire("3l1bi");

var $2rn3r = parcelRequire("2rn3r");

var $2Vsz9 = parcelRequire("2Vsz9");

var $cc5IR = parcelRequire("cc5IR");

var $39bQi = parcelRequire("39bQi");
const $ba8b57f84711c945$export$2cb19dacff9881ed = (0, $3l1bi.default);
const $ba8b57f84711c945$export$905a8d55c641a71e = async (inputValue, _lookupValues, { tenantContext: tenantContext, viewContext: viewContext, environment: environment, fieldContext: fieldContext })=>{
    if (inputValue === null) return null;
    let childAri = null;
    const parentAri = (0, $2rn3r.JiraIssueFieldOptionAri).create({
        siteId: tenantContext.cloudId,
        activationId: tenantContext.activationId,
        fieldId: fieldContext.fieldId,
        optionId: inputValue.parentId
    }).toString();
    if (inputValue?.childId) childAri = (0, $2rn3r.JiraIssueFieldOptionAri).create({
        siteId: tenantContext.cloudId,
        activationId: tenantContext.activationId,
        fieldId: fieldContext.fieldId,
        optionId: inputValue.childId
    }).toString();
    const response = await (0, $cc5IR.fetchFieldOptions)({
        tenantContext: tenantContext,
        viewContext: viewContext,
        environment: environment,
        fieldContext: fieldContext,
        optionARIs: [
            parentAri
        ],
        nodePropertyName: 'parentOptions',
        queryName: 'FETCH_CASCADING_SELECT',
        query: $ba8b57f84711c945$export$2cb19dacff9881ed,
        extraQueryVariables: {
            filterByIdChild: {
                optionIds: childAri ? [
                    childAri
                ] : [],
                operation: 'ALLOW'
            }
        }
    });
    const parentOption = response?.edges?.[0]?.node;
    const childOption = response?.edges?.[0]?.node?.childOptions?.edges?.[0]?.node;
    if (parentOption?.id !== parentAri || inputValue?.childId && childOption?.id !== childAri) throw new (0, $2Vsz9.FieldValueLookupError)(JSON.stringify(inputValue));
    return {
        parentOptionValue: {
            id: parentOption.id,
            value: parentOption?.value ?? ''
        },
        childOptionValue: inputValue?.childId && childOption ? {
            id: childOption.id,
            value: childOption?.value ?? ''
        } : null
    };
};
const $ba8b57f84711c945$export$47e9770ed0d1c344 = (inputValue)=>{
    if (!inputValue || !inputValue.parentOptionValue) return null;
    const parent = {
        id: (0, $39bQi.getResourceIdfromAri)(inputValue.parentOptionValue.id),
        value: inputValue.parentOptionValue.value
    };
    const child = inputValue.childOptionValue ? {
        id: (0, $39bQi.getResourceIdfromAri)(inputValue.childOptionValue.id),
        value: inputValue.childOptionValue.value
    } : null;
    return {
        parent: parent,
        child: child
    };
};

});
parcelRegister("3l1bi", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ba182a4c1395dba$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fd73fd915e48c4a426112bc260bf0f05>>
 * @relayHash 897e785dd82d688a8b92757085b3206d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 59653e087b319c6c1799a443fab7349acbf7cc3fb9daf3db605b9a9f1d3ae86a
const $1ba182a4c1395dba$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ari"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterById"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterByIdChild"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "ari"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "value"
    }, v4 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "filterById",
                        "variableName": "filterById"
                    }
                ],
                "concreteType": "JiraParentOptionConnection",
                "kind": "LinkedField",
                "name": "parentOptions",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraParentOptionEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraParentOption",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v2 /*: any*/ ,
                                    v3 /*: any*/ ,
                                    {
                                        "args": [
                                            {
                                                "kind": "Variable",
                                                "name": "filterById",
                                                "variableName": "filterByIdChild"
                                            }
                                        ],
                                        "concreteType": "JiraOptionConnection",
                                        "kind": "LinkedField",
                                        "name": "childOptions",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "concreteType": "JiraOptionEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "concreteType": "JiraOption",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                            v2 /*: any*/ ,
                                                            v3 /*: any*/ 
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "JiraCascadingSelectField"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "cascadingSelectIssueTransitionIssueAdjustmentsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "cascadingSelectIssueTransitionIssueAdjustmentsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v4 /*: any*/ ,
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "59653e087b319c6c1799a443fab7349acbf7cc3fb9daf3db605b9a9f1d3ae86a",
            "metadata": {},
            "name": "cascadingSelectIssueTransitionIssueAdjustmentsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1ba182a4c1395dba$var$node.hash = "05c858c87aebae163faf43d2a0d580f3";
var $1ba182a4c1395dba$export$2e2bcd8739ae039 = $1ba182a4c1395dba$var$node;

});

parcelRegister("cc5IR", function(module, exports) {

$parcel$export(module.exports, "fetchFieldOptions", () => $1d228c83c3afa0b0$export$89b4c8a7d912358b);

var $iWLL0 = parcelRequire("iWLL0");

var $huI7r = parcelRequire("huI7r");
const $1d228c83c3afa0b0$export$89b4c8a7d912358b = async ({ tenantContext: tenantContext, viewContext: viewContext, environment: environment, fieldContext: fieldContext, optionARIs: optionARIs, nodePropertyName: nodePropertyName, queryName: queryName, query: query, extraQueryVariables: extraQueryVariables = {} })=>{
    let response;
    try {
        response = await (0, $iWLL0.fetchQuery)(environment, query, {
            ari: (0, $huI7r.createAri)({
                resourceOwner: 'jira',
                cloudId: tenantContext.cloudId,
                resourceType: 'issuefieldvalue',
                resourceId: `${viewContext.issueId}/${fieldContext.fieldId}`
            }),
            filterById: {
                optionIds: optionARIs,
                operation: 'ALLOW'
            },
            ...extraQueryVariables
        }, {
            networkCacheConfig: {
                force: false
            },
            fetchPolicy: 'store-or-network'
        }).toPromise();
        if (!response || !response.node || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        !response.node[nodePropertyName]) throw new Error(`[${queryName}]: Property ${nodePropertyName} does not exist.`, {
            cause: `${queryName}_MISSING_FIELD_OPTIONS_PROPERTY`
        });
    } catch (err) {
        const error = err instanceof Error ? err : new Error();
        if (!error.cause) error.cause = `${queryName}_FIELD_OPTION_REQUEST_FAILED`;
        throw error;
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return response.node[nodePropertyName];
};

});

parcelRegister("39bQi", function(module, exports) {

$parcel$export(module.exports, "getResourceIdfromAri", () => $f901710551638b10$export$8977d55db9d1c1bb);

var $huI7r = parcelRequire("huI7r");
const $f901710551638b10$export$8977d55db9d1c1bb = (value)=>(0, $huI7r.parseAri)(value)?.resourceId ?? '';

});


parcelRegister("cHN5s", function(module, exports) {

$parcel$export(module.exports, "issueTypeGetValueTransformer", () => $415c5119f8f8eb21$export$391657d4e7f81237);
$parcel$export(module.exports, "issueTypeSetValueTransformer", () => $415c5119f8f8eb21$export$93e4fd33c48f4977);
$parcel$export(module.exports, "validateSetOptionsVisibilityIssueType", () => $415c5119f8f8eb21$export$aa313386b5aded3f);
$parcel$export(module.exports, "transformIssueTypeSetOptionsVisibility", () => $415c5119f8f8eb21$export$db493bcecec5fb56);

var $a5LdW = parcelRequire("a5LdW");

var $lSeXP = parcelRequire("lSeXP");

var $2Vsz9 = parcelRequire("2Vsz9");

var $cc5IR = parcelRequire("cc5IR");

var $2xymT = parcelRequire("2xymT");

var $39bQi = parcelRequire("39bQi");

var $b50wi = parcelRequire("b50wi");
const $415c5119f8f8eb21$export$391657d4e7f81237 = (value)=>{
    if (!value) return null;
    return {
        id: (0, $39bQi.getResourceIdfromAri)(value.value),
        name: value.label
    };
};
const $415c5119f8f8eb21$export$5c18f9ce93e4df2d = (0, $a5LdW.default);
const $415c5119f8f8eb21$export$93e4fd33c48f4977 = async (inputValue, _lookupValues, { tenantContext: tenantContext, viewContext: viewContext, environment: environment, fieldContext: fieldContext })=>{
    const issueTypeARI = (0, $lSeXP.JiraIssueTypeAri).create({
        siteId: tenantContext.cloudId,
        issueTypeId: inputValue
    }).toString();
    // it depends on jira-issue-type-field-options-filtering FF (add as dependency)
    const response = await (0, $cc5IR.fetchFieldOptions)({
        tenantContext: tenantContext,
        viewContext: viewContext,
        environment: environment,
        fieldContext: fieldContext,
        optionARIs: [
            issueTypeARI
        ],
        nodePropertyName: 'issueTypesForTransition',
        queryName: 'FETCH_ISSUE_TYPE',
        query: $415c5119f8f8eb21$export$5c18f9ce93e4df2d
    });
    const issueType = response?.edges?.[0]?.node;
    if (issueType?.value !== issueTypeARI) throw new (0, $2Vsz9.FieldValueLookupError)(inputValue);
    return {
        value: issueType.value,
        label: issueType.label ?? '',
        avatar: {
            small: issueType?.avatar?.small ?? ''
        }
    };
};
const $415c5119f8f8eb21$export$aa313386b5aded3f = (optionsVisibility)=>(0, $2xymT.validateSetOptionsVisibilityRule)(optionsVisibility) && (0, $b50wi.optionsVisibilityContainNoMoreThan100Items)(optionsVisibility);
const $415c5119f8f8eb21$export$db493bcecec5fb56 = (optionsVisibility, _lookupValues, { tenantContext: tenantContext })=>({
        optionIds: optionsVisibility.options.map((optionId)=>(0, $lSeXP.JiraIssueTypeAri).create({
                siteId: tenantContext.cloudId,
                issueTypeId: optionId
            }).toString()),
        operation: optionsVisibility.isVisible ? 'ALLOW' : 'EXCLUDE'
    });

});
parcelRegister("a5LdW", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0af8b7513c73091$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<929230ceb9941390a54f78d0fcd40f06>>
 * @relayHash 62034951ad478b9310149b860e0e5d76
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID dc489ea573805d3058b4220a278b462df520be5380ad0c5861fb89ed6d98d79d
const $b0af8b7513c73091$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ari"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterById"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "ari"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "filterById",
            "variableName": "filterById"
        }
    ], v3 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v5 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "small"
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "issueTypeQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "issueTypesForTransition",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraIssueTypeField"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "issueTypeQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraIssueTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "issueTypesForTransition",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssueType",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraIssueTypeField"
                        },
                        v6 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "dc489ea573805d3058b4220a278b462df520be5380ad0c5861fb89ed6d98d79d",
            "metadata": {},
            "name": "issueTypeQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b0af8b7513c73091$var$node.hash = "fffc08bf530de123da55bbae6d5a77bb";
var $b0af8b7513c73091$export$2e2bcd8739ae039 = $b0af8b7513c73091$var$node;

});

parcelRegister("lSeXP", function(module, exports) {

$parcel$export(module.exports, "JiraIssueTypeAri", () => $5565f3a77cc61dd8$export$931e4419330c3862);

var $ivR3E = parcelRequire("ivR3E");

var $v8cEo = parcelRequire("v8cEo");

var $hkoEN = parcelRequire("hkoEN");
// src/jira/issue-type/manifest.ts
var $5565f3a77cc61dd8$var$jiraIssueTypeAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9-]+$"),
    resourceOwner: (0, $ivR3E.JiraIssueTypeAriResourceOwner),
    resourceType: (0, $ivR3E.JiraIssueTypeAriResourceType),
    resourceIdSlug: "{issueTypeId}",
    resourceIdSegmentFormats: {
        issueTypeId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
    }
};
// src/jira/issue-type/index.ts
var $5565f3a77cc61dd8$export$931e4419330c3862 = class _JiraIssueTypeAri extends (0, $v8cEo.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._issueTypeId = opts.resourceIdSegmentValues.issueTypeId;
    }
    get siteId() {
        return this._siteId;
    }
    get issueTypeId() {
        return this._issueTypeId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $5565f3a77cc61dd8$var$jiraIssueTypeAriStaticOpts.qualifier,
            platformQualifier: $5565f3a77cc61dd8$var$jiraIssueTypeAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $5565f3a77cc61dd8$var$jiraIssueTypeAriStaticOpts.resourceOwner,
            resourceType: $5565f3a77cc61dd8$var$jiraIssueTypeAriStaticOpts.resourceType,
            resourceId: `${opts.issueTypeId}`,
            resourceIdSegmentValues: {
                issueTypeId: opts.issueTypeId
            }
        }, ariOpts = (0, $hkoEN.AriParser).fromOpts(derivedOpts, $5565f3a77cc61dd8$var$jiraIssueTypeAriStaticOpts);
        return new _JiraIssueTypeAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $hkoEN.AriParser).fromString(maybeAri, $5565f3a77cc61dd8$var$jiraIssueTypeAriStaticOpts);
        return new _JiraIssueTypeAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueTypeId: this.issueTypeId
        };
    }
};

});
parcelRegister("ivR3E", function(module, exports) {

$parcel$export(module.exports, "JiraIssueTypeAriResourceOwner", () => $1571d0ff007c6aa8$export$a40271de8e7c8a70);
$parcel$export(module.exports, "JiraIssueTypeAriResourceType", () => $1571d0ff007c6aa8$export$70e5e6fc47f1a2cc);
// src/jira/issue-type/types.ts
var $1571d0ff007c6aa8$export$a40271de8e7c8a70 = "jira", $1571d0ff007c6aa8$export$70e5e6fc47f1a2cc = "issue-type";

});



parcelRegister("3g1BX", function(module, exports) {

$parcel$export(module.exports, "validateLabelsSetValue", () => $24cd4c9564078af1$export$6130bc1755ce872a);


var $8xPow = parcelRequire("8xPow");
const $24cd4c9564078af1$export$6130bc1755ce872a = (value)=>Array.isArray(value) && value.length <= (0, $6b8c146c2dd688bb$export$106087dcfd4fb129) && value.every((0, $8xPow.isNotEmptyString));

});

parcelRegister("2oXjw", function(module, exports) {

$parcel$export(module.exports, "oldTransformMultiCheckboxSetOptionsVisibility", () => $eac593fbe3f09bca$export$d54e26a70b9eded2);
$parcel$export(module.exports, "transformMultiCheckboxSetOptionsVisibility", () => $eac593fbe3f09bca$export$115a0b8c81087c2c);
$parcel$export(module.exports, "transformMultiCheckboxGetOptionsVisibility", () => $eac593fbe3f09bca$export$4471ab017a7abd7);
$parcel$export(module.exports, "oldMultiCheckboxSetValueTransformer", () => $eac593fbe3f09bca$export$60d0ede531dc3889);
$parcel$export(module.exports, "multiCheckboxSetValueTransformer", () => $eac593fbe3f09bca$export$9ba1ee83cc9456ba);
$parcel$export(module.exports, "oldMultiCheckboxGetValueTransformer", () => $eac593fbe3f09bca$export$c4727c29a2e818d6);
$parcel$export(module.exports, "multiCheckboxGetValueTransformer", () => $eac593fbe3f09bca$export$6d15ce1cc0bdffe7);

var $2Vsz9 = parcelRequire("2Vsz9");

var $240Nk = parcelRequire("240Nk");

var $j55UJ = parcelRequire("j55UJ");

var $39bQi = parcelRequire("39bQi");

var $jgrDo = parcelRequire("jgrDo");

var $eF9ai = parcelRequire("eF9ai");

var $b50wi = parcelRequire("b50wi");
const $eac593fbe3f09bca$export$d54e26a70b9eded2 = (optionsVisibility, lookupValues)=>(0, $240Nk.applyOptionsVisibilityRule)(optionsVisibility, lookupValues, 'value');
const $eac593fbe3f09bca$export$115a0b8c81087c2c = ({ options: options, isVisible: isVisible }, lookupValues, context)=>{
    const aris = (0, $b50wi.transformOptionIdsToARI)(options, context);
    return (0, $240Nk.applyOptionsVisibilityRule)({
        options: aris,
        isVisible: isVisible
    }, lookupValues, 'value');
};
const $eac593fbe3f09bca$export$4471ab017a7abd7 = (optionsVisibility, lookupValues)=>(0, $j55UJ.getAvailableOptionsVisibilityRule)(optionsVisibility, lookupValues, 'value');
const $eac593fbe3f09bca$export$60d0ede531dc3889 = (publicValue, allowedValues)=>{
    if (!publicValue.length) return [];
    const foundValue = (0, $eF9ai.multiValueLookup)(publicValue, allowedValues, 'value');
    if (foundValue.length !== publicValue.length) {
        const notFoundValues = (0, $jgrDo.getValueLookupValuesDiff)(publicValue, foundValue, 'value');
        throw new (0, $2Vsz9.FieldValueLookupError)(notFoundValues.join());
    }
    return foundValue;
};
const $eac593fbe3f09bca$export$9ba1ee83cc9456ba = (publicValue, allowedValues, context)=>{
    if (!publicValue.length) return [];
    const foundValue = (0, $eF9ai.multiValueLookup)((0, $b50wi.transformOptionIdsToARI)(publicValue, context), allowedValues, 'value');
    if (foundValue.length !== publicValue.length) {
        const notFoundValues = (0, $jgrDo.getValueLookupValuesDiff)(publicValue, foundValue, 'value');
        throw new (0, $2Vsz9.FieldValueLookupError)(notFoundValues.join());
    }
    return foundValue;
};
const $eac593fbe3f09bca$export$c4727c29a2e818d6 = (internalValue)=>{
    if (!internalValue) return [];
    return internalValue.map(({ value: value, label: label })=>({
            id: value,
            value: label
        }));
};
const $eac593fbe3f09bca$export$6d15ce1cc0bdffe7 = (internalValue)=>{
    if (!internalValue) return [];
    return internalValue.map(({ value: value, label: label })=>({
            id: (0, $39bQi.getResourceIdfromAri)(value),
            value: label
        }));
};

});

parcelRegister("1TPgc", function(module, exports) {

$parcel$export(module.exports, "multiSelectSetValueTransformer", () => $3741151681c21924$export$87ccfa5280a3288f);
$parcel$export(module.exports, "multiSelectGetValueTransformer", () => $3741151681c21924$export$9992ce1903b64c5);

var $4i5CZ = parcelRequire("4i5CZ");

var $huI7r = parcelRequire("huI7r");

var $2Vsz9 = parcelRequire("2Vsz9");

var $cc5IR = parcelRequire("cc5IR");

var $39bQi = parcelRequire("39bQi");

var $jgrDo = parcelRequire("jgrDo");
const $3741151681c21924$export$5cc625f595670ece = (0, $4i5CZ.default);
const $3741151681c21924$export$87ccfa5280a3288f = async (values, _lookupValues, { tenantContext: tenantContext, viewContext: viewContext, environment: environment, fieldContext: fieldContext })=>{
    if (!values.length) return [];
    const optionARIs = values.map((optionId)=>{
        const resourceId = `${fieldContext.fieldId}/${optionId}`;
        return (0, $huI7r.createAri)({
            resourceOwner: 'jira',
            cloudId: tenantContext.cloudId,
            resourceType: 'issue-field-option',
            activationId: tenantContext.activationId,
            resourceId: resourceId
        });
    });
    const response = await (0, $cc5IR.fetchFieldOptions)({
        tenantContext: tenantContext,
        viewContext: viewContext,
        environment: environment,
        fieldContext: fieldContext,
        optionARIs: optionARIs,
        nodePropertyName: 'fieldOptions',
        queryName: 'FETCH_MULTI_SELECT',
        query: $3741151681c21924$export$5cc625f595670ece
    });
    const fieldOptions = response?.edges?.map((edge)=>edge?.node).filter(Boolean).filter(({ value: value })=>optionARIs.includes(value)).map(({ label: label, value: optionValue })=>({
            label: label ?? '',
            value: optionValue
        })) ?? [];
    if (fieldOptions.length !== values.length) {
        const notFoundValues = (0, $jgrDo.getValueLookupValuesDiff)(optionARIs, fieldOptions, 'value');
        throw new (0, $2Vsz9.FieldValueLookupError)(notFoundValues.map((value)=>(0, $39bQi.getResourceIdfromAri)(value)).join());
    }
    return fieldOptions;
};
const $3741151681c21924$export$9992ce1903b64c5 = (internalValue)=>{
    if (!internalValue) return [];
    return internalValue.map(({ value: value, label: label })=>({
            id: (0, $39bQi.getResourceIdfromAri)(value),
            value: label
        }));
};

});
parcelRegister("4i5CZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f72891612662e94$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8973fc32f41005ada60f03db2f35714c>>
 * @relayHash f16f2688fb82395dbff9cc53b5991a29
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 40f8ccf331ee2738de878621a8d5a7851e1740ff1ae9bd7f56cecb8ae82c0c08
const $9f72891612662e94$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ari"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterById"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "ari"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "filterById",
            "variableName": "filterById"
        },
        {
            "kind": "Literal",
            "name": "searchBy",
            "value": ""
        }
    ], v3 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "value"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "multiSelectQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraOptionConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldOptions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraOptionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraMultipleSelectField"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "multiSelectQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "concreteType": "JiraOptionConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldOptions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraOptionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraMultipleSelectField"
                        },
                        v5 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "40f8ccf331ee2738de878621a8d5a7851e1740ff1ae9bd7f56cecb8ae82c0c08",
            "metadata": {},
            "name": "multiSelectQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$9f72891612662e94$var$node.hash = "85f2a0ca2abb954e2213378539f66106";
var $9f72891612662e94$export$2e2bcd8739ae039 = $9f72891612662e94$var$node;

});


parcelRegister("48Oaa", function(module, exports) {

$parcel$export(module.exports, "transformMultiUserPickerSetValue", () => $cadc20aae57cd42c$export$5b3066e9c91b4b70);
$parcel$export(module.exports, "transformMultiUserPickerGetValue", () => $cadc20aae57cd42c$export$14f50c5c8c51bfdc);

var $2Vsz9 = parcelRequire("2Vsz9");

var $jgrDo = parcelRequire("jgrDo");

var $eF9ai = parcelRequire("eF9ai");
const $cadc20aae57cd42c$export$5b3066e9c91b4b70 = (values, lookupValues)=>{
    if (!values.length) return [];
    const filteredLookupValues = (0, $eF9ai.multiValueLookup)(values, lookupValues, 'accountId');
    if (values.length !== filteredLookupValues.length) {
        const notFoundValues = (0, $jgrDo.getValueLookupValuesDiff)(values, filteredLookupValues, 'accountId');
        throw new (0, $2Vsz9.FieldValueLookupError)(notFoundValues.join());
    }
    return filteredLookupValues.map(({ id: id, accountId: accountId, accountStatus: accountStatus, name: name, picture: picture })=>({
            id: id,
            accountId: accountId,
            accountStatus: accountStatus,
            name: name,
            picture: picture
        }));
};
const $cadc20aae57cd42c$export$14f50c5c8c51bfdc = (value)=>{
    if (!value) return [];
    return value.map(({ accountId: accountId })=>({
            accountId: accountId
        }));
};

});

parcelRegister("kt4Dk", function(module, exports) {

$parcel$export(module.exports, "paragraphSetValueValidator", () => $94b0b3a34e7f86b6$export$374879bc6474221d);
$parcel$export(module.exports, "paragraphSetValueTransformer", () => $94b0b3a34e7f86b6$export$4f3e7aa88a08b7db);
$parcel$export(module.exports, "paragraphGetValueTransformer", () => $94b0b3a34e7f86b6$export$88b493c87579f4ea);

var $kFGm5 = parcelRequire("kFGm5");

var $9tBd5 = parcelRequire("9tBd5");


var $cw2gk = parcelRequire("cw2gk");
const $94b0b3a34e7f86b6$var$rendererValidators = {
    [(0, $c7e7b1d3600a0c0f$export$89b8c5d86c10a68c)]: (value, { currentField: currentField, viewType: viewType })=>(0, $cw2gk.isValidADF)({
            newValue: value,
            currentValue: currentField?.value,
            viewType: viewType
        }),
    [(0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f)]: (value)=>Promise.resolve(typeof value === 'string')
};
const $94b0b3a34e7f86b6$var$getRenderer = (renderer)=>{
    if (renderer === (0, $c7e7b1d3600a0c0f$export$89b8c5d86c10a68c) || renderer === (0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f)) return renderer;
    throw new Error(`Invalid renderer: ${renderer}`);
};
const $94b0b3a34e7f86b6$export$374879bc6474221d = (value, { fieldRenderer: fieldRenderer }, _createAnalyticsEvent, extra)=>{
    try {
        const renderer = $94b0b3a34e7f86b6$var$getRenderer(fieldRenderer);
        return $94b0b3a34e7f86b6$var$rendererValidators[renderer](value, extra);
    } catch (e) {
        return Promise.resolve(false);
    }
};
const $94b0b3a34e7f86b6$export$4f3e7aa88a08b7db = (value)=>typeof value === 'string' ? value : {
        ...value,
        overrideRequired: true
    };
const $94b0b3a34e7f86b6$export$88b493c87579f4ea = (value, fieldRenderer)=>{
    if (value === undefined) // The `convertTextToAdf` call will give us an "empty ADF object":
    // {
    //   "type": "doc",
    //   "version": 1,
    //   "content": [
    //     {
    //       "type": "paragraph",
    //       "content": []
    //     }
    //   ]
    // }
    return fieldRenderer === (0, $c7e7b1d3600a0c0f$export$89b8c5d86c10a68c) ? (0, $9tBd5.convertTextToAdf)('') : '';
    if (typeof value === 'string') return value;
    return (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(value, 'overrideRequired');
};

});
const $c7e7b1d3600a0c0f$export$89b8c5d86c10a68c = 'atlassian-wiki-renderer';
const $c7e7b1d3600a0c0f$export$a4a240cb4053b29f = 'jira-text-renderer';
const $c7e7b1d3600a0c0f$export$840ed33fa94f7693 = 'frother-control-renderer';


parcelRegister("k8Z2Y", function(module, exports) {

$parcel$export(module.exports, "transformParentSetValue", () => $82a3aa21642067b8$export$2c2fa789efcce745);
$parcel$export(module.exports, "transformParentGetValue", () => $82a3aa21642067b8$export$98caacb992dbef18);
$parcel$export(module.exports, "transformParentSetOptionsVisibility", () => $82a3aa21642067b8$export$63fbd35228742042);

var $3lDIQ = parcelRequire("3lDIQ");

var $2Shq0 = parcelRequire("2Shq0");

var $4UIXh = parcelRequire("4UIXh");

var $2Vsz9 = parcelRequire("2Vsz9");

var $cc5IR = parcelRequire("cc5IR");

var $39bQi = parcelRequire("39bQi");
const $82a3aa21642067b8$export$9687b4a4fc9632b9 = (0, $3lDIQ.default);
const $82a3aa21642067b8$export$2c2fa789efcce745 = async (inputValue, _lookupValues, { tenantContext: tenantContext, viewContext: viewContext, environment: environment, fieldContext: fieldContext })=>{
    if (!inputValue) return null;
    const optionAri = (0, $2Shq0.JiraIssueAri).create({
        siteId: tenantContext.cloudId,
        issueId: inputValue
    }).toString();
    const response = await (0, $cc5IR.fetchFieldOptions)({
        tenantContext: tenantContext,
        viewContext: viewContext,
        environment: environment,
        fieldContext: fieldContext,
        optionARIs: [
            optionAri
        ],
        nodePropertyName: 'parentCandidatesForExistingIssue',
        queryName: 'FETCH_PARENT',
        query: $82a3aa21642067b8$export$9687b4a4fc9632b9
    });
    const parentValue = (0, $4UIXh.transformParentNode)(response?.edges?.[0]?.node);
    if (parentValue?.value !== optionAri) throw new (0, $2Vsz9.FieldValueLookupError)(inputValue);
    return parentValue;
};
const $82a3aa21642067b8$export$98caacb992dbef18 = (intervalValue)=>{
    if (!intervalValue) return null;
    return {
        id: (0, $39bQi.getResourceIdfromAri)(intervalValue?.id?.toString() || ''),
        key: intervalValue.key
    };
};
const $82a3aa21642067b8$export$63fbd35228742042 = (optionsVisibility, _lookupValues, { tenantContext: tenantContext })=>({
        optionIds: optionsVisibility.options.map((optionId)=>(0, $2Shq0.JiraIssueAri).create({
                siteId: tenantContext.cloudId,
                issueId: optionId
            }).toString()),
        operation: optionsVisibility.isVisible ? 'ALLOW' : 'EXCLUDE'
    });

});
parcelRegister("3lDIQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $91fc2eaceef21d96$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<690118cf7a65320e213a3256c2e353e5>>
 * @relayHash 9254794c81eab73d38a4fcd183545b44
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e7eaadf0b4bc99fcf00cfa29d947f83ace3effa8dc03c1cd6d9d8e435d7881a6
const $91fc2eaceef21d96$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ari"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterById"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "ari"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "kind": "Literal",
            "name": "excludeDone",
            "value": false
        },
        {
            "kind": "Variable",
            "name": "filterById",
            "variableName": "filterById"
        },
        {
            "kind": "Literal",
            "name": "searchBy",
            "value": ""
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "key"
    }, v5 = {
        "kind": "ScalarField",
        "name": "colorKey"
    }, v6 = [
        {
            "kind": "Literal",
            "name": "ids",
            "value": [
                "summary",
                "issuetype",
                "status"
            ]
        }
    ], v7 = {
        "kind": "ScalarField",
        "name": "fieldId"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            v7 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "text"
            }
        ],
        "type": "JiraSingleLineTextField"
    }, v9 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v10 = {
        "kind": "ScalarField",
        "name": "name"
    }, v11 = {
        "concreteType": "JiraAvatar",
        "kind": "LinkedField",
        "name": "avatar",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "xsmall"
            }
        ]
    }, v12 = {
        "concreteType": "JiraIssueTypeHierarchyLevel",
        "kind": "LinkedField",
        "name": "hierarchy",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "level"
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "statusCategoryId"
    }, v14 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "parentIssueTransitionIssueAdjustmentsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "parentCandidatesForExistingIssue",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraColorField",
                                                            "kind": "LinkedField",
                                                            "name": "issueColorField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraColor",
                                                                    "kind": "LinkedField",
                                                                    "name": "color",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "args": v6 /*: any*/ ,
                                                            "concreteType": "JiraIssueFieldConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldsById",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v8 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v7 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraIssueType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issueType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v9 /*: any*/ ,
                                                                                                v10 /*: any*/ ,
                                                                                                v11 /*: any*/ ,
                                                                                                v12 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraIssueTypeField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v7 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraStatus",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "status",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "statusCategory",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v13 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraStatusField"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraParentIssueField"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "parentIssueTransitionIssueAdjustmentsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v14 /*: any*/ ,
                        v2 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraIssueConnection",
                                    "kind": "LinkedField",
                                    "name": "parentCandidatesForExistingIssue",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraIssue",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraColorField",
                                                            "kind": "LinkedField",
                                                            "name": "issueColorField",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraColor",
                                                                    "kind": "LinkedField",
                                                                    "name": "color",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        v2 /*: any*/ 
                                                                    ]
                                                                },
                                                                v2 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "args": v6 /*: any*/ ,
                                                            "concreteType": "JiraIssueFieldConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldsById",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                    "kind": "LinkedField",
                                                                    "name": "edges",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "node",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v14 /*: any*/ ,
                                                                                v8 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v7 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraIssueType",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "issueType",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v9 /*: any*/ ,
                                                                                                v10 /*: any*/ ,
                                                                                                v11 /*: any*/ ,
                                                                                                v12 /*: any*/ ,
                                                                                                v2 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraIssueTypeField"
                                                                                },
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v7 /*: any*/ ,
                                                                                        {
                                                                                            "concreteType": "JiraStatus",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "status",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraStatusCategory",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "statusCategory",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v13 /*: any*/ ,
                                                                                                        v2 /*: any*/ 
                                                                                                    ]
                                                                                                },
                                                                                                v2 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ],
                                                                                    "type": "JiraStatusField"
                                                                                },
                                                                                v2 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraParentIssueField"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e7eaadf0b4bc99fcf00cfa29d947f83ace3effa8dc03c1cd6d9d8e435d7881a6",
            "metadata": {},
            "name": "parentIssueTransitionIssueAdjustmentsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$91fc2eaceef21d96$var$node.hash = "80f30b7afe9a71b36db44f64eef395cf";
var $91fc2eaceef21d96$export$2e2bcd8739ae039 = $91fc2eaceef21d96$var$node;

});

parcelRegister("4UIXh", function(module, exports) {

$parcel$export(module.exports, "transformParentNode", () => $1a121e8634edf34d$export$1b622b80a5cf731f);
$parcel$export(module.exports, "transformToSuggestions", () => $1a121e8634edf34d$export$6cffaaeb4c7c0c18);

var $8Qd0L = parcelRequire("8Qd0L");

var $tgbCK = parcelRequire("tgbCK");
const $1a121e8634edf34d$export$1b622b80a5cf731f = (edgeNode)=>{
    const fieldsEdges = edgeNode?.fieldsById?.edges || [];
    const summaryField = fieldsEdges.find((field)=>field?.node?.fieldId === 'summary');
    const issueTypeField = fieldsEdges.find((field)=>field?.node?.fieldId === 'issuetype');
    const statusField = fieldsEdges.find((field)=>field?.node?.fieldId === 'status');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const colorKey = edgeNode?.issueColorField?.color?.colorKey;
    const checkParentIssueIsDone = (statusCategoryId)=>{
        const doneStatusCategoryId = (0, $8Qd0L).StatusCategoryIds[(0, $8Qd0L).StatusCategoryTypes.DONE];
        return doneStatusCategoryId && String(doneStatusCategoryId) === statusCategoryId;
    };
    const isDone = checkParentIssueIsDone(statusField?.node?.status?.statusCategory?.statusCategoryId || '');
    return {
        id: edgeNode?.id || '',
        key: edgeNode?.key || '',
        fields: {
            issuetype: {
                id: issueTypeField?.node?.issueType?.issueTypeId || '',
                name: issueTypeField?.node?.issueType?.name || '',
                iconUrl: issueTypeField?.node?.issueType?.avatar?.xsmall || ''
            },
            summary: summaryField?.node?.text || ''
        },
        color: colorKey in (0, $tgbCK.MAP_FROM_SERVER_COLOR) ? (0, $tgbCK.MAP_FROM_SERVER_COLOR)[colorKey] : undefined,
        value: edgeNode?.id || '',
        label: `${edgeNode?.key || ''} ${summaryField?.node?.text || ''}`,
        isDone: isDone
    };
};
const $1a121e8634edf34d$export$6cffaaeb4c7c0c18 = (fieldOptionsData)=>(fieldOptionsData?.edges || [])?.filter((edge)=>edge?.node).map((edge)=>$1a121e8634edf34d$export$1b622b80a5cf731f(edge?.node));

});


parcelRegister("8IcPP", function(module, exports) {

$parcel$export(module.exports, "priorityGetValueTransformer", () => $5cbf08b8a0823fbb$export$a3dcdeebcccb44cd);
$parcel$export(module.exports, "prioritySetValueTransformer", () => $5cbf08b8a0823fbb$export$c6ef424ead917b72);
$parcel$export(module.exports, "transformSetOptionsVisibilityAriPriority", () => $5cbf08b8a0823fbb$export$113005d17f05d2e1);

var $t6UBb = parcelRequire("t6UBb");

var $XGPnQ = parcelRequire("XGPnQ");

var $2Vsz9 = parcelRequire("2Vsz9");

var $cc5IR = parcelRequire("cc5IR");
const $5cbf08b8a0823fbb$export$a3dcdeebcccb44cd = ({ label: label, priorityId: priorityId, iconUrl: iconUrl })=>({
        name: label,
        id: priorityId,
        iconUrl: iconUrl
    });
const $5cbf08b8a0823fbb$export$8efeac1ccffb6a1d = (0, $t6UBb.default);
const $5cbf08b8a0823fbb$export$c6ef424ead917b72 = async (inputValue, _lookupValues, { tenantContext: tenantContext, viewContext: viewContext, environment: environment, fieldContext: fieldContext })=>{
    if (!inputValue) return null;
    const optionAri = (0, $XGPnQ.JiraPriorityAri).create({
        priorityId: inputValue,
        siteId: tenantContext.cloudId,
        activationId: tenantContext.activationId
    }).toString();
    const response = await (0, $cc5IR.fetchFieldOptions)({
        tenantContext: tenantContext,
        viewContext: viewContext,
        environment: environment,
        fieldContext: fieldContext,
        optionARIs: [
            optionAri
        ],
        nodePropertyName: 'priorities',
        queryName: 'FETCH_PRIORITY',
        query: $5cbf08b8a0823fbb$export$8efeac1ccffb6a1d
    });
    const priority = response?.edges?.[0]?.node;
    if (priority?.value !== optionAri) throw new (0, $2Vsz9.FieldValueLookupError)(inputValue);
    return {
        value: priority.value,
        label: priority.label ?? '',
        iconUrl: priority.iconUrl ?? '',
        priorityId: priority.priorityId
    };
};
const $5cbf08b8a0823fbb$export$113005d17f05d2e1 = ({ isVisible: isVisible, options: options }, _lookupValues, { tenantContext: tenantContext })=>({
        operation: isVisible ? 'ALLOW' : 'EXCLUDE',
        optionIds: options.map((optionId)=>(0, $XGPnQ.JiraPriorityAri).create({
                priorityId: optionId,
                siteId: tenantContext.cloudId,
                activationId: tenantContext.activationId
            }).toString())
    });

});
parcelRegister("t6UBb", function(module, exports) {

$parcel$export(module.exports, "default", () => $96a63da77ff1882a$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<66436dd0ab537848d4cbb2a0bdbf6985>>
 * @relayHash f6a30ee6ee1e3e60e7ac3366d295bd46
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5da9c5aa8b3c6f6d93f01d05e399d0b1abce793bce7cc920b4ad912ceecc37af
const $96a63da77ff1882a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ari"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterById"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "ari"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "filterById",
            "variableName": "filterById"
        },
        {
            "kind": "Literal",
            "name": "searchBy",
            "value": ""
        }
    ], v4 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v6 = {
        "kind": "ScalarField",
        "name": "priorityId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "priorityIssueTransitionIssueAdjustmentsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraPriorityConnection",
                                    "kind": "LinkedField",
                                    "name": "priorities",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraPriorityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraPriority",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraPriorityField"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "priorityIssueTransitionIssueAdjustmentsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraPriorityConnection",
                                    "kind": "LinkedField",
                                    "name": "priorities",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraPriorityEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraPriority",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v2 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraPriorityField"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "5da9c5aa8b3c6f6d93f01d05e399d0b1abce793bce7cc920b4ad912ceecc37af",
            "metadata": {},
            "name": "priorityIssueTransitionIssueAdjustmentsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$96a63da77ff1882a$var$node.hash = "5e7c742934e2b174f578c445449fb8d9";
var $96a63da77ff1882a$export$2e2bcd8739ae039 = $96a63da77ff1882a$var$node;

});

parcelRegister("XGPnQ", function(module, exports) {

$parcel$export(module.exports, "JiraPriorityAri", () => $2eb998dfbb67cb97$export$5f41709ebd395cb1);

var $kVIiT = parcelRequire("kVIiT");

var $v8cEo = parcelRequire("v8cEo");

var $hkoEN = parcelRequire("hkoEN");
// src/jira/priority/manifest.ts
var $2eb998dfbb67cb97$var$jiraPriorityAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9-]+$"),
    resourceOwner: (0, $kVIiT.JiraPriorityAriResourceOwner),
    resourceType: (0, $kVIiT.JiraPriorityAriResourceType),
    resourceIdSlug: "activation/{activationId}/{priorityId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        priorityId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
    }
};
// src/jira/priority/index.ts
var $2eb998dfbb67cb97$export$5f41709ebd395cb1 = class _JiraPriorityAri extends (0, $v8cEo.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._priorityId = opts.resourceIdSegmentValues.priorityId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get priorityId() {
        return this._priorityId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $2eb998dfbb67cb97$var$jiraPriorityAriStaticOpts.qualifier,
            platformQualifier: $2eb998dfbb67cb97$var$jiraPriorityAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $2eb998dfbb67cb97$var$jiraPriorityAriStaticOpts.resourceOwner,
            resourceType: $2eb998dfbb67cb97$var$jiraPriorityAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.priorityId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                priorityId: opts.priorityId
            }
        }, ariOpts = (0, $hkoEN.AriParser).fromOpts(derivedOpts, $2eb998dfbb67cb97$var$jiraPriorityAriStaticOpts);
        return new _JiraPriorityAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $hkoEN.AriParser).fromString(maybeAri, $2eb998dfbb67cb97$var$jiraPriorityAriStaticOpts);
        return new _JiraPriorityAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            priorityId: this.priorityId
        };
    }
};

});
parcelRegister("kVIiT", function(module, exports) {

$parcel$export(module.exports, "JiraPriorityAriResourceOwner", () => $87edd756771a8842$export$a154bdc743e3d7f4);
$parcel$export(module.exports, "JiraPriorityAriResourceType", () => $87edd756771a8842$export$f5f5f4d1fc71ee3e);
// src/jira/priority/types.ts
var $87edd756771a8842$export$a154bdc743e3d7f4 = "jira", $87edd756771a8842$export$f5f5f4d1fc71ee3e = "priority";

});



parcelRegister("ioiX9", function(module, exports) {

$parcel$export(module.exports, "radioButtonsSetValueTransformerOld", () => $0695ded3a78e2796$export$afac3b5895a63445);
$parcel$export(module.exports, "transformRadioButtonsSetValue", () => $0695ded3a78e2796$export$59a14d3ac9af6334);
$parcel$export(module.exports, "radioButtonsGetValueTransformerOld", () => $0695ded3a78e2796$export$f0b186fd5b1146a5);
$parcel$export(module.exports, "transformRadioButtonsGetValue", () => $0695ded3a78e2796$export$878c780f038a370d);
$parcel$export(module.exports, "transformRadioButtonsSetOptionsVisibility", () => $0695ded3a78e2796$export$825e2dc660c855a0);
$parcel$export(module.exports, "transformRadioButtonsSetOptionsVisibilityOld", () => $0695ded3a78e2796$export$130c22d60f3ea0b1);
$parcel$export(module.exports, "transformRadioButtonsGetOptionsVisibility", () => $0695ded3a78e2796$export$149e6a6e5e31219);

var $2rn3r = parcelRequire("2rn3r");

var $2Vsz9 = parcelRequire("2Vsz9");

var $240Nk = parcelRequire("240Nk");

var $j55UJ = parcelRequire("j55UJ");

var $39bQi = parcelRequire("39bQi");

var $b50wi = parcelRequire("b50wi");

var $9DCyM = parcelRequire("9DCyM");
const $0695ded3a78e2796$export$afac3b5895a63445 = (value, allowedValues)=>{
    if (value === null) return null;
    const foundValue = (0, $9DCyM.singleValueLookup)(value, allowedValues, 'id');
    if (!foundValue) throw new (0, $2Vsz9.FieldValueLookupError)();
    return {
        value: foundValue.id,
        label: foundValue.value
    };
};
const $0695ded3a78e2796$export$59a14d3ac9af6334 = (value, allowedValues, context)=>{
    if (value === null) return null;
    const optionAri = (0, $2rn3r.JiraIssueFieldOptionAri).create({
        optionId: value,
        siteId: context.tenantContext.cloudId,
        activationId: context.tenantContext.activationId,
        fieldId: context.fieldContext.fieldId
    }).toString();
    const foundValue = (0, $9DCyM.singleValueLookup)(optionAri, allowedValues, 'value');
    if (!foundValue) throw new (0, $2Vsz9.FieldValueLookupError)();
    return foundValue;
};
const $0695ded3a78e2796$export$f0b186fd5b1146a5 = (value)=>{
    if (!value) return null;
    const { label: label, value: id } = value;
    return {
        id: id,
        value: label
    };
};
const $0695ded3a78e2796$export$878c780f038a370d = (internalValue)=>{
    if (!internalValue) return null;
    return {
        id: (0, $39bQi.getResourceIdfromAri)(internalValue.value),
        value: internalValue.label
    };
};
const $0695ded3a78e2796$export$825e2dc660c855a0 = ({ options: options, isVisible: isVisible }, lookupValues, context)=>{
    const aris = (0, $b50wi.transformOptionIdsToARI)(options, context);
    return (0, $240Nk.applyOptionsVisibilityRule)({
        options: aris,
        isVisible: isVisible
    }, lookupValues, 'value');
};
const $0695ded3a78e2796$export$130c22d60f3ea0b1 = (optionsVisibility, lookupValues)=>(0, $240Nk.applyOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');
const $0695ded3a78e2796$export$149e6a6e5e31219 = (optionsVisibility, lookupValues)=>(0, $j55UJ.getAvailableOptionsVisibilityRule)(optionsVisibility, lookupValues, 'id');

});

parcelRegister("3nLyZ", function(module, exports) {

$parcel$export(module.exports, "validateReleaseVersionValue", () => $e751e6e20c22efe4$export$31de952981b2edff);
$parcel$export(module.exports, "transformReleaseVersionsSetValue", () => $e751e6e20c22efe4$export$203f864eb08f43ec);
$parcel$export(module.exports, "transformReleaseVersionsGetValue", () => $e751e6e20c22efe4$export$8a2e9c6f89b699e4);
$parcel$export(module.exports, "transformReleaseVersionsSetOptionsVisibility", () => $e751e6e20c22efe4$export$390339514db83786);
$parcel$export(module.exports, "releaseVersionsRequiredScopes", () => $e751e6e20c22efe4$export$25e903bcd4f7a783);

var $hDPRM = parcelRequire("hDPRM");

var $glDap = parcelRequire("glDap");


var $2Vsz9 = parcelRequire("2Vsz9");

var $1NIGg = parcelRequire("1NIGg");

var $cc5IR = parcelRequire("cc5IR");

var $39bQi = parcelRequire("39bQi");

var $jgrDo = parcelRequire("jgrDo");

var $8xPow = parcelRequire("8xPow");
const $e751e6e20c22efe4$export$31de952981b2edff = (value)=>Array.isArray(value) && value.every((0, $8xPow.isNotEmptyString)) && value.length <= (0, $6b8c146c2dd688bb$export$106087dcfd4fb129);
const $e751e6e20c22efe4$export$1b26e14167ad7414 = (0, $hDPRM.default);
const $e751e6e20c22efe4$export$203f864eb08f43ec = async (inputValues, _lookupValues, { tenantContext: tenantContext, viewContext: viewContext, environment: environment, fieldContext: fieldContext })=>{
    if (!inputValues.length) return [];
    const optionARIs = inputValues.map((optionId)=>(0, $glDap.JiraVersionAri).create({
            siteId: tenantContext.cloudId,
            activationId: tenantContext.activationId,
            versionId: optionId
        }).toString());
    const response = await (0, $cc5IR.fetchFieldOptions)({
        tenantContext: tenantContext,
        viewContext: viewContext,
        environment: environment,
        fieldContext: fieldContext,
        optionARIs: optionARIs,
        nodePropertyName: 'selectableValueOptions',
        queryName: 'FETCH_RELEASE_VERSIONS',
        query: $e751e6e20c22efe4$export$1b26e14167ad7414
    });
    const fieldOptions = response?.edges?.map((edge)=>edge?.node).filter(Boolean).filter(({ id: id })=>optionARIs.includes(id)).map(({ selectableLabel: selectableLabel, id: id, selectableGroupKey: selectableGroupKey, selectableIconUrl: selectableIconUrl })=>({
            id: id,
            selectableLabel: selectableLabel ?? '',
            selectableGroupKey: selectableGroupKey ?? null,
            selectableIconUrl: selectableIconUrl ?? null
        })) ?? [];
    if (fieldOptions.length !== inputValues.length) {
        const notFoundValues = (0, $jgrDo.getValueLookupValuesDiff)(optionARIs, fieldOptions, 'id');
        throw new (0, $2Vsz9.FieldValueLookupError)(notFoundValues.map((value)=>(0, $39bQi.getResourceIdfromAri)(value)).join());
    }
    return fieldOptions;
};
const $e751e6e20c22efe4$export$8a2e9c6f89b699e4 = (internalValues)=>{
    if (!internalValues) return [];
    return internalValues.map((value)=>({
            id: (0, $39bQi.getResourceIdfromAri)(value.id),
            name: value.selectableLabel
        }));
};
const $e751e6e20c22efe4$export$390339514db83786 = (optionsVisibility, _lookupValues, { tenantContext: tenantContext })=>({
        optionIds: optionsVisibility.options.map((optionId)=>(0, $glDap.JiraVersionAri).create({
                siteId: tenantContext.cloudId,
                activationId: tenantContext.activationId,
                versionId: optionId
            }).toString()),
        operation: optionsVisibility.isVisible ? 'ALLOW' : 'EXCLUDE'
    });
const $e751e6e20c22efe4$export$25e903bcd4f7a783 = {
    ...(0, $1NIGg.versionsRequiredScopes),
    granular: [
        ...(0, $1NIGg.versionsRequiredScopes).granular,
        'write:field.default-value:jira'
    ]
};

});
parcelRegister("hDPRM", function(module, exports) {

$parcel$export(module.exports, "default", () => $deaccdd0bc70a249$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3f670764c69c84a0d91e4768de892708>>
 * @relayHash ee1bd6cb49e1854165e09b99130a59b4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 377af4db65b49ba114cb6c2e54913086afe4021507f42ca6cc6702fc2b30f465
const $deaccdd0bc70a249$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ari"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterById"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "ari"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "filterById",
            "variableName": "filterById"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "selectableLabel"
    }, v5 = {
        "kind": "ScalarField",
        "name": "selectableGroupKey"
    }, v6 = {
        "kind": "ScalarField",
        "name": "selectableIconUrl"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "releaseVersionsIssueTransitionIssueAdjustmentsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraSelectableValueConnection",
                                    "kind": "LinkedField",
                                    "name": "selectableValueOptions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSelectableValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v2 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraMultipleVersionPickerField"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "releaseVersionsIssueTransitionIssueAdjustmentsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        v2 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraSelectableValueConnection",
                                    "kind": "LinkedField",
                                    "name": "selectableValueOptions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraSelectableValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v2 /*: any*/ ,
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v6 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraMultipleVersionPickerField"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "377af4db65b49ba114cb6c2e54913086afe4021507f42ca6cc6702fc2b30f465",
            "metadata": {},
            "name": "releaseVersionsIssueTransitionIssueAdjustmentsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$deaccdd0bc70a249$var$node.hash = "4f26dbdc495633bc3ca79baddd923221";
var $deaccdd0bc70a249$export$2e2bcd8739ae039 = $deaccdd0bc70a249$var$node;

});

parcelRegister("glDap", function(module, exports) {

$parcel$export(module.exports, "JiraVersionAri", () => $45797df1d60c11a2$export$eff0d18d9de27263);

var $lbxdl = parcelRequire("lbxdl");

var $v8cEo = parcelRequire("v8cEo");

var $hkoEN = parcelRequire("hkoEN");
// src/jira/version/manifest.ts
var $45797df1d60c11a2$var$jiraVersionAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9-]+$"),
    resourceOwner: (0, $lbxdl.JiraVersionAriResourceOwner),
    resourceType: (0, $lbxdl.JiraVersionAriResourceType),
    resourceIdSlug: "activation/{activationId}/{versionId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        versionId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
    }
};
// src/jira/version/index.ts
var $45797df1d60c11a2$export$eff0d18d9de27263 = class _JiraVersionAri extends (0, $v8cEo.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._versionId = opts.resourceIdSegmentValues.versionId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get versionId() {
        return this._versionId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $45797df1d60c11a2$var$jiraVersionAriStaticOpts.qualifier,
            platformQualifier: $45797df1d60c11a2$var$jiraVersionAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $45797df1d60c11a2$var$jiraVersionAriStaticOpts.resourceOwner,
            resourceType: $45797df1d60c11a2$var$jiraVersionAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.versionId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                versionId: opts.versionId
            }
        }, ariOpts = (0, $hkoEN.AriParser).fromOpts(derivedOpts, $45797df1d60c11a2$var$jiraVersionAriStaticOpts);
        return new _JiraVersionAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $hkoEN.AriParser).fromString(maybeAri, $45797df1d60c11a2$var$jiraVersionAriStaticOpts);
        return new _JiraVersionAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            versionId: this.versionId
        };
    }
};

});
parcelRegister("lbxdl", function(module, exports) {

$parcel$export(module.exports, "JiraVersionAriResourceOwner", () => $b2b1f653fdb26674$export$1b35360c29caced0);
$parcel$export(module.exports, "JiraVersionAriResourceType", () => $b2b1f653fdb26674$export$680940c40f68f72d);
// src/jira/version/types.ts
var $b2b1f653fdb26674$export$1b35360c29caced0 = "jira", $b2b1f653fdb26674$export$680940c40f68f72d = "version";

});



parcelRegister("js9Si", function(module, exports) {

$parcel$export(module.exports, "resolutionSetValueValidator", () => $a3f5461c0ceecf14$export$f8430b44b42c3ba0);
$parcel$export(module.exports, "resolutionGetValueTransformer", () => $a3f5461c0ceecf14$export$5bc2a5ee6e251e7b);
$parcel$export(module.exports, "resolutionSetValueTransformer", () => $a3f5461c0ceecf14$export$297cfd5e8642246b);
$parcel$export(module.exports, "transformSetOptionsVisibilityAriResolution", () => $a3f5461c0ceecf14$export$dfbd625a885d635c);

var $8UC0T = parcelRequire("8UC0T");

var $hsYcB = parcelRequire("hsYcB");

var $2Vsz9 = parcelRequire("2Vsz9");

var $cc5IR = parcelRequire("cc5IR");

var $39bQi = parcelRequire("39bQi");

var $8xPow = parcelRequire("8xPow");
const $a3f5461c0ceecf14$export$f8430b44b42c3ba0 = (value)=>value === null || (0, $8xPow.isNotEmptyString)(value);
const $a3f5461c0ceecf14$export$5bc2a5ee6e251e7b = (internalValue)=>{
    if (!internalValue) return null;
    const { label: label, value: value } = internalValue;
    return {
        id: (0, $39bQi.getResourceIdfromAri)(value),
        value: label
    };
};
const $a3f5461c0ceecf14$export$99a1b7b417122c1 = (0, $8UC0T.default);
const $a3f5461c0ceecf14$export$297cfd5e8642246b = async (inputValue, _lookupValues, { tenantContext: tenantContext, viewContext: viewContext, environment: environment, fieldContext: fieldContext })=>{
    if (!inputValue) return null;
    const resolutionARI = (0, $hsYcB.JiraResolutionAri).create({
        resolutionId: inputValue,
        siteId: tenantContext.cloudId,
        activationId: tenantContext.activationId
    }).toString();
    const isResolutionForTransition = !!viewContext.transitionId;
    const response = await (0, $cc5IR.fetchFieldOptions)({
        tenantContext: tenantContext,
        viewContext: viewContext,
        environment: environment,
        fieldContext: fieldContext,
        optionARIs: [
            resolutionARI
        ],
        nodePropertyName: isResolutionForTransition ? 'resolutionsForTransition' : 'resolutions',
        queryName: 'FETCH_RESOLUTION',
        query: $a3f5461c0ceecf14$export$99a1b7b417122c1,
        extraQueryVariables: {
            transitionId: viewContext.transitionId ?? '',
            isResolutionForTransition: isResolutionForTransition
        }
    });
    const resolution = response?.edges?.[0]?.node;
    if (resolution?.value !== resolutionARI) throw new (0, $2Vsz9.FieldValueLookupError)(inputValue);
    return {
        value: resolution.value,
        label: resolution.label ?? ''
    };
};
const $a3f5461c0ceecf14$export$dfbd625a885d635c = ({ isVisible: isVisible, options: options }, _lookupValues, { tenantContext: tenantContext })=>({
        operation: isVisible ? 'ALLOW' : 'EXCLUDE',
        optionIds: options.map((optionId)=>(0, $hsYcB.JiraResolutionAri).create({
                resolutionId: optionId,
                siteId: tenantContext.cloudId,
                activationId: tenantContext.activationId
            }).toString())
    });

});
parcelRegister("8UC0T", function(module, exports) {

$parcel$export(module.exports, "default", () => $243f6f27bfc1ccbc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f31ab28cee35491a9307270ef32616eb>>
 * @relayHash 653e4292ed116dfebafab4695c5e8d48
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6b88a0aac50f0af09e01d6b78e1088bcf047a8a828512b078466d7fc9ac20432
const $243f6f27bfc1ccbc$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ari"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterById"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isResolutionForTransition"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "transitionId"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "ari"
        }
    ], v5 = {
        "kind": "Variable",
        "name": "filterById",
        "variableName": "filterById"
    }, v6 = [
        v5 /*: any*/ 
    ], v7 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v8 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "name"
    }, v9 = [
        {
            "concreteType": "JiraResolutionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraResolution",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        v8 /*: any*/ 
                    ]
                }
            ]
        }
    ], v10 = [
        v5 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "transitionId",
            "variableName": "transitionId"
        }
    ], v11 = {
        "kind": "ScalarField",
        "name": "id"
    }, v12 = [
        {
            "concreteType": "JiraResolutionEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraResolution",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        v11 /*: any*/ 
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "resolutionQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "condition": "isResolutionForTransition",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "args": v6 /*: any*/ ,
                                            "concreteType": "JiraResolutionConnection",
                                            "kind": "LinkedField",
                                            "name": "resolutions",
                                            "plural": false,
                                            "selections": v9 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "condition": "isResolutionForTransition",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": v10 /*: any*/ ,
                                            "concreteType": "JiraResolutionConnection",
                                            "kind": "LinkedField",
                                            "name": "resolutionsForTransition",
                                            "plural": false,
                                            "selections": v9 /*: any*/ 
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraResolutionField"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v3 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "resolutionQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "condition": "isResolutionForTransition",
                                    "kind": "Condition",
                                    "passingValue": false,
                                    "selections": [
                                        {
                                            "args": v6 /*: any*/ ,
                                            "concreteType": "JiraResolutionConnection",
                                            "kind": "LinkedField",
                                            "name": "resolutions",
                                            "plural": false,
                                            "selections": v12 /*: any*/ 
                                        }
                                    ]
                                },
                                {
                                    "condition": "isResolutionForTransition",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "args": v10 /*: any*/ ,
                                            "concreteType": "JiraResolutionConnection",
                                            "kind": "LinkedField",
                                            "name": "resolutionsForTransition",
                                            "plural": false,
                                            "selections": v12 /*: any*/ 
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraResolutionField"
                        },
                        v11 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "6b88a0aac50f0af09e01d6b78e1088bcf047a8a828512b078466d7fc9ac20432",
            "metadata": {},
            "name": "resolutionQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$243f6f27bfc1ccbc$var$node.hash = "e886abcbca64bda05f694b3d6df280e9";
var $243f6f27bfc1ccbc$export$2e2bcd8739ae039 = $243f6f27bfc1ccbc$var$node;

});

parcelRegister("hsYcB", function(module, exports) {

$parcel$export(module.exports, "JiraResolutionAri", () => $5b21878b125eb7eb$export$4b3cf07790b96474);

var $81qiQ = parcelRequire("81qiQ");

var $v8cEo = parcelRequire("v8cEo");

var $hkoEN = parcelRequire("hkoEN");
// src/jira/resolution/manifest.ts
var $5b21878b125eb7eb$var$jiraResolutionAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9-]+$"),
    resourceOwner: (0, $81qiQ.JiraResolutionAriResourceOwner),
    resourceType: (0, $81qiQ.JiraResolutionAriResourceType),
    resourceIdSlug: "activation/{activationId}/{resolutionId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        resolutionId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
    }
};
// src/jira/resolution/index.ts
var $5b21878b125eb7eb$export$4b3cf07790b96474 = class _JiraResolutionAri extends (0, $v8cEo.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._resolutionId = opts.resourceIdSegmentValues.resolutionId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get resolutionId() {
        return this._resolutionId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $5b21878b125eb7eb$var$jiraResolutionAriStaticOpts.qualifier,
            platformQualifier: $5b21878b125eb7eb$var$jiraResolutionAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $5b21878b125eb7eb$var$jiraResolutionAriStaticOpts.resourceOwner,
            resourceType: $5b21878b125eb7eb$var$jiraResolutionAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.resolutionId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                resolutionId: opts.resolutionId
            }
        }, ariOpts = (0, $hkoEN.AriParser).fromOpts(derivedOpts, $5b21878b125eb7eb$var$jiraResolutionAriStaticOpts);
        return new _JiraResolutionAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $hkoEN.AriParser).fromString(maybeAri, $5b21878b125eb7eb$var$jiraResolutionAriStaticOpts);
        return new _JiraResolutionAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            resolutionId: this.resolutionId
        };
    }
};

});
parcelRegister("81qiQ", function(module, exports) {

$parcel$export(module.exports, "JiraResolutionAriResourceOwner", () => $e7e1107f782ddc08$export$e5856db7949e58fd);
$parcel$export(module.exports, "JiraResolutionAriResourceType", () => $e7e1107f782ddc08$export$6625f083a1369cde);
// src/jira/resolution/types.ts
var $e7e1107f782ddc08$export$e5856db7949e58fd = "jira", $e7e1107f782ddc08$export$6625f083a1369cde = "resolution";

});



parcelRegister("ivCUc", function(module, exports) {

$parcel$export(module.exports, "transformSelectSetOptionsVisibility", () => $025f732ecd584dd6$export$81990085f8ab114b);
$parcel$export(module.exports, "transformSelectGetOptionsVisibility", () => $025f732ecd584dd6$export$7c7ca81813eb0f65);
$parcel$export(module.exports, "selectSetValueValidator", () => $025f732ecd584dd6$export$c02b1c2a574ca4c7);
$parcel$export(module.exports, "selectSetValueTransformerOld", () => $025f732ecd584dd6$export$27d13b94ef7f7717);
$parcel$export(module.exports, "selectSetValueTransformer", () => $025f732ecd584dd6$export$136c42b919fdec83);
$parcel$export(module.exports, "selectGetValueTransformerOld", () => $025f732ecd584dd6$export$f971e17a9dc0cf5a);
$parcel$export(module.exports, "selectGetValueTransformer", () => $025f732ecd584dd6$export$fd4db924c90bd0e2);

var $30vmZ = parcelRequire("30vmZ");

var $2rn3r = parcelRequire("2rn3r");

var $2Vsz9 = parcelRequire("2Vsz9");

var $240Nk = parcelRequire("240Nk");

var $cc5IR = parcelRequire("cc5IR");

var $j55UJ = parcelRequire("j55UJ");

var $39bQi = parcelRequire("39bQi");

var $8xPow = parcelRequire("8xPow");

var $9DCyM = parcelRequire("9DCyM");
const $025f732ecd584dd6$export$81990085f8ab114b = (optionsVisibility, lookupValues)=>(0, $240Nk.applyOptionsVisibilityRule)(optionsVisibility, lookupValues, 'value');
const $025f732ecd584dd6$export$7c7ca81813eb0f65 = (optionsVisibility, lookupValues)=>(0, $j55UJ.getAvailableOptionsVisibilityRule)(optionsVisibility, lookupValues, 'value');
const $025f732ecd584dd6$export$c02b1c2a574ca4c7 = (value)=>value === null || (0, $8xPow.isNotEmptyString)(value);
const $025f732ecd584dd6$export$27d13b94ef7f7717 = (value, allowedValues)=>{
    if (value === null) return null;
    const foundValue = (0, $9DCyM.singleValueLookup)(value, allowedValues, 'value');
    if (!foundValue) throw new (0, $2Vsz9.FieldValueLookupError)();
    return {
        value: foundValue.value,
        label: foundValue.label
    };
};
const $025f732ecd584dd6$export$8a2c723186a4de94 = (0, $30vmZ.default);
const $025f732ecd584dd6$export$136c42b919fdec83 = async (inputValue, _lookupValues, { tenantContext: tenantContext, viewContext: viewContext, environment: environment, fieldContext: fieldContext })=>{
    if (inputValue === null) return null;
    const optionAri = (0, $2rn3r.JiraIssueFieldOptionAri).create({
        siteId: tenantContext.cloudId,
        activationId: tenantContext.activationId,
        fieldId: fieldContext.fieldId,
        optionId: inputValue
    }).toString();
    const response = await (0, $cc5IR.fetchFieldOptions)({
        tenantContext: tenantContext,
        viewContext: viewContext,
        environment: environment,
        fieldContext: fieldContext,
        optionARIs: [
            optionAri
        ],
        nodePropertyName: 'fieldOptions',
        queryName: 'FETCH_SELECT',
        query: $025f732ecd584dd6$export$8a2c723186a4de94
    });
    const option = response?.edges?.[0]?.node;
    if (option?.value !== optionAri) throw new (0, $2Vsz9.FieldValueLookupError)(inputValue);
    return {
        value: option.value,
        label: option.label ?? ''
    };
};
const $025f732ecd584dd6$export$f971e17a9dc0cf5a = (value)=>{
    if (!value || value.value === undefined) return null;
    const { label: label, value: id } = value;
    return {
        id: id,
        value: label
    };
};
const $025f732ecd584dd6$export$fd4db924c90bd0e2 = (internalValue)=>{
    if (!internalValue || internalValue.value === undefined) return null;
    return {
        id: (0, $39bQi.getResourceIdfromAri)(internalValue.value),
        value: internalValue.label
    };
};

});
parcelRegister("30vmZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $97d9b830c9f010ea$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<61ed5af44d6ff650f3ceb55ec9530e67>>
 * @relayHash dc0ee3a00570c8a4476b76e947391702
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e1d1eb200ab0fee3f493fb7fc558a2c0a806551d56073089018f3e539686bf5e
const $97d9b830c9f010ea$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "ari"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "filterById"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "ari"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "filterById",
            "variableName": "filterById"
        },
        {
            "kind": "Literal",
            "name": "searchBy",
            "value": ""
        }
    ], v4 = {
        "alias": "value",
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "alias": "label",
        "kind": "ScalarField",
        "name": "value"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "selectIssueTransitionIssueAdjustmentsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraOptionConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldOptions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraOptionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraSingleSelectField"
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "selectIssueTransitionIssueAdjustmentsQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "__typename"
                        },
                        v2 /*: any*/ ,
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "args": v3 /*: any*/ ,
                                    "concreteType": "JiraOptionConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldOptions",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraOptionEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        v5 /*: any*/ ,
                                                        v2 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "type": "JiraSingleSelectField"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "e1d1eb200ab0fee3f493fb7fc558a2c0a806551d56073089018f3e539686bf5e",
            "metadata": {},
            "name": "selectIssueTransitionIssueAdjustmentsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$97d9b830c9f010ea$var$node.hash = "d491ce6e025f96ae1790f91d97c73cf5";
var $97d9b830c9f010ea$export$2e2bcd8739ae039 = $97d9b830c9f010ea$var$node;

});


parcelRegister("6Hfnl", function(module, exports) {

$parcel$export(module.exports, "transformUserPickerSetValue", () => $09a8997d337a729d$export$ea418154f9f68685);
$parcel$export(module.exports, "transformUserPickerGetValue", () => $09a8997d337a729d$export$79b25b13f5798aa6);

var $2Vsz9 = parcelRequire("2Vsz9");

var $9DCyM = parcelRequire("9DCyM");
const $09a8997d337a729d$export$ea418154f9f68685 = (value, lookupValues)=>{
    if (value === null) return null;
    const foundValue = (0, $9DCyM.singleValueLookup)(value, lookupValues, 'accountId');
    if (!foundValue) throw new (0, $2Vsz9.FieldValueLookupError)();
    return foundValue;
};
const $09a8997d337a729d$export$79b25b13f5798aa6 = (value)=>value ? {
        accountId: value.accountId
    } : null;

});

parcelRegister("fD0E1", function(module, exports) {

$parcel$export(module.exports, "default", () => $c71a4af93ef685ad$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c71a4af93ef685ad$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    uimTransitionViewConsentMessage: {
        "id": "ui-modifications-fields-configuration.common.utils.views.issue-transition.uim-transition-view-consent-message",
        "defaultMessage": "Allow \u201C{appTitle}\u201D to access your Atlassian products to get the full issue experience."
    }
});

});


parcelRegister("5ZW9L", function(module, exports) {

$parcel$export(module.exports, "IssueViewViewConfiguration", () => $9954d8ff285c460a$export$c80c11394a2e44ab);

var $7ZZxN = parcelRequire("7ZZxN");


var $1ybV0 = parcelRequire("1ybV0");

var $lO4Or = parcelRequire("lO4Or");

var $iTvzN = parcelRequire("iTvzN");


var $8QLPP = parcelRequire("8QLPP");

var $axvW5 = parcelRequire("axvW5");

var $hBOxC = parcelRequire("hBOxC");

var $9aEJT = parcelRequire("9aEJT");

var $e8h5r = parcelRequire("e8h5r");

var $eMv4r = parcelRequire("eMv4r");

var $ifv0j = parcelRequire("ifv0j");

var $1zzzr = parcelRequire("1zzzr");

var $htzHC = parcelRequire("htzHC");

var $7AbVk = parcelRequire("7AbVk");

var $gLagZ = parcelRequire("gLagZ");

var $hFkmH = parcelRequire("hFkmH");

var $feRPz = parcelRequire("feRPz");

var $9Ek5r = parcelRequire("9Ek5r");

var $9Zo5b = parcelRequire("9Zo5b");

var $1h6vN = parcelRequire("1h6vN");

var $1NIGg = parcelRequire("1NIGg");

var $2xymT = parcelRequire("2xymT");

var $b50wi = parcelRequire("b50wi");

var $elWuT = parcelRequire("elWuT");

var $bvi64 = parcelRequire("bvi64");

var $3qPEc = parcelRequire("3qPEc");

var $aCDyF = parcelRequire("aCDyF");

var $fguRM = parcelRequire("fguRM");

var $8lh20 = parcelRequire("8lh20");

var $2hY4o = parcelRequire("2hY4o");

var $1mUM4 = parcelRequire("1mUM4");

var $aXs6e = parcelRequire("aXs6e");

var $90qH7 = parcelRequire("90qH7");

var $7Vf73 = parcelRequire("7Vf73");

var $44460 = parcelRequire("44460");

var $4yViI = parcelRequire("4yViI");

var $1f831 = parcelRequire("1f831");

var $4tIE7 = parcelRequire("4tIE7");

var $c6jWy = parcelRequire("c6jWy");

var $aXpSX = parcelRequire("aXpSX");

var $hF72b = parcelRequire("hF72b");

var $hBvZU = parcelRequire("hBvZU");

var $dHKLL = parcelRequire("dHKLL");

var $hMqzl = parcelRequire("hMqzl");
class $9954d8ff285c460a$export$c80c11394a2e44ab {
    getSupportedFieldsConfiguration() {
        const commonFieldValidators = (0, $2xymT.getCommonFieldValidators)();
        return {
            [(0, $lO4Or.SUMMARY_TYPE)]: {
                publicShapeValidators: {
                    isReadOnly: commonFieldValidators.isReadOnly,
                    value: (0, $9Zo5b.validateSingleLineTextValue)
                },
                publicToInternalTransformers: {},
                internalToPublicTransformers: {
                    value: (0, $9Zo5b.transformSingleLineTextToPublicValue)
                },
                /**
				 * On the Issue View cannot differentiate between change and blur since only change is being observed.
				 * 'change' on the Issue View means e.g. that user "blurs" from a text field or change the selection in a select field.
				 */ emitChangeOn: 'change',
                requiredScopes: (0, $hF72b.summaryIssueViewScopes)
            },
            [(0, $lO4Or.DESCRIPTION_TYPE)]: {
                publicShapeValidators: {
                    fieldName: commonFieldValidators.fieldName,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    value: (0, $8lh20.validateRichText)
                },
                publicToInternalTransformers: {},
                internalToPublicTransformers: {
                    value: (0, $8lh20.transformRichTextToPublicValue)
                },
                emitChangeOn: 'change',
                requiredScopes: (0, $8lh20.descriptionIssueViewScopes)
            },
            [(0, $lO4Or.ASSIGNEE_TYPE)]: {
                publicShapeValidators: {
                    description: commonFieldValidators.description,
                    fieldName: commonFieldValidators.fieldName,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    value: (0, $8QLPP.assigneeSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $8QLPP.assigneeSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $8QLPP.assigneeGetValueTransformer)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$3a106242c8f57ac2),
                requiredScopes: (0, $elWuT.assigneeIssueViewScopes)
            },
            [(0, $lO4Or.PRIORITY_TYPE)]: {
                publicShapeValidators: {
                    fieldName: commonFieldValidators.fieldName,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    value: (0, $gLagZ.validatePrioritySetValue),
                    optionsVisibility: (0, $b50wi.validateSetOptionsVisibility)
                },
                publicToInternalTransformers: {
                    value: (0, $1f831.transformPrioritySetValue),
                    optionsVisibility: (0, $b50wi.transformSelectSetOptionsVisibility)
                },
                internalToPublicTransformers: {
                    value: (0, $1f831.transformPriorityGetValue),
                    optionsVisibility: (0, $b50wi.transformSelectGetOptionsVisibility)
                },
                emitChangeOn: 'change',
                requiredScopes: (0, $1f831.priorityIssueViewScopes),
                propertyMapping: {
                    optionsVisibility: 'allowedValuesOverrides'
                }
            },
            [(0, $lO4Or.TEXT_CF_TYPE)]: {
                publicShapeValidators: {
                    fieldName: commonFieldValidators.fieldName,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    value: (0, $9Zo5b.validateSingleLineTextValue),
                    description: commonFieldValidators.description
                },
                publicToInternalTransformers: {},
                internalToPublicTransformers: {
                    value: (0, $9Zo5b.transformSingleLineTextToPublicValue)
                },
                emitChangeOn: 'change',
                requiredScopes: (0, $aXpSX.singleLineTextIssueViewScopes)
            },
            [(0, $lO4Or.URL_CF_TYPE)]: {
                publicShapeValidators: {
                    description: commonFieldValidators.description,
                    fieldName: commonFieldValidators.fieldName,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    value: (0, $9Zo5b.validateSingleLineTextValue)
                },
                publicToInternalTransformers: {},
                internalToPublicTransformers: {
                    value: (0, $9Zo5b.transformSingleLineTextToPublicValue)
                },
                emitChangeOn: 'change',
                requiredScopes: (0, $hBvZU.urlIssueViewScopes)
            },
            [(0, $lO4Or.TEXT_AREA_CF_TYPE)]: {
                publicShapeValidators: {
                    fieldName: commonFieldValidators.fieldName,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    value: (0, $44460.validateParagraphSetValue),
                    description: commonFieldValidators.description
                },
                publicToInternalTransformers: {
                    value: (0, $44460.paragraphSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $44460.paragraphGetValueTransformer)
                },
                emitChangeOn: 'change',
                requiredScopes: (0, $8lh20.descriptionIssueViewScopes)
            },
            [(0, $lO4Or.MULTI_SELECT_CF_TYPE)]: {
                publicShapeValidators: {
                    description: commonFieldValidators.description,
                    fieldName: commonFieldValidators.fieldName,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    value: (0, $ifv0j.validateMultiSelectSetValue),
                    optionsVisibility: (0, $b50wi.validateSetOptionsVisibility)
                },
                publicToInternalTransformers: {
                    value: (0, $aXs6e.transformMultiSelectSetValue),
                    optionsVisibility: (0, $b50wi.transformSetOptionsVisibilityAri)
                },
                internalToPublicTransformers: {
                    value: (0, $aXs6e.transformMultiSelectGetValue),
                    optionsVisibility: (0, $b50wi.transformSelectGetOptionsVisibility)
                },
                emitChangeOn: 'change',
                requiredScopes: (0, $aXs6e.multiSelectScopes),
                propertyMapping: {
                    optionsVisibility: 'fieldOptionsFilter'
                }
            },
            [(0, $lO4Or.SELECT_CF_TYPE)]: {
                publicShapeValidators: {
                    fieldName: commonFieldValidators.fieldName,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    value: (0, $9Ek5r.selectWithAriSetValueValidator),
                    description: commonFieldValidators.description,
                    optionsVisibility: (0, $b50wi.validateSetOptionsVisibility)
                },
                publicToInternalTransformers: {
                    value: (0, $c6jWy.selectSetValueTransformer),
                    optionsVisibility: (0, $b50wi.transformSetOptionsVisibilityAri)
                },
                internalToPublicTransformers: {
                    value: (0, $c6jWy.selectGetValueTransformer),
                    optionsVisibility: (0, $b50wi.transformSelectGetOptionsVisibility)
                },
                emitChangeOn: 'change',
                requiredScopes: (0, $c6jWy.selectIssueViewScopes),
                propertyMapping: {
                    optionsVisibility: 'fieldOptionsFilter'
                }
            },
            [(0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE)]: {
                publicShapeValidators: {
                    description: commonFieldValidators.description,
                    fieldName: commonFieldValidators.fieldName,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    value: (0, $eMv4r.validateMultiCheckboxSetValue),
                    optionsVisibility: (0, $b50wi.validateSetOptionsVisibility)
                },
                publicToInternalTransformers: {
                    value: (0, $1mUM4.multiCheckboxSetValueTransformer),
                    optionsVisibility: (0, $b50wi.transformSelectSetOptionsVisibility)
                },
                internalToPublicTransformers: {
                    value: (0, $1mUM4.multiCheckboxGetValueTransformer),
                    optionsVisibility: (0, $b50wi.transformSelectGetOptionsVisibility)
                },
                emitChangeOn: 'change',
                requiredScopes: (0, $1mUM4.multiCheckboxScopes),
                propertyMapping: {
                    optionsVisibility: 'allowedValuesOverrides'
                }
            },
            [(0, $lO4Or.RADIO_BUTTONS_CF_TYPE)]: {
                publicShapeValidators: {
                    fieldName: commonFieldValidators.fieldName,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    description: commonFieldValidators.description,
                    value: (0, $hFkmH.radioButtonsSetValueValidator),
                    optionsVisibility: (0, $b50wi.validateSetOptionsVisibility)
                },
                publicToInternalTransformers: {
                    value: (0, $4tIE7.radioButtonsSetValueTransformer),
                    optionsVisibility: (0, $b50wi.transformSelectSetOptionsVisibility)
                },
                internalToPublicTransformers: {
                    value: (0, $4tIE7.radioButtonsGetValueTransformer),
                    optionsVisibility: (0, $b50wi.transformSelectGetOptionsVisibility)
                },
                emitChangeOn: 'change',
                requiredScopes: (0, $4tIE7.radioButtonsIssueViewScopes),
                propertyMapping: {
                    optionsVisibility: 'allowedValuesOverrides'
                }
            },
            [(0, $lO4Or.FIX_VERSIONS_TYPE)]: {
                publicShapeValidators: {
                    fieldName: commonFieldValidators.fieldName,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    description: commonFieldValidators.description,
                    value: (0, $1NIGg.validateVersionValue)
                },
                publicToInternalTransformers: {
                    value: (0, $dHKLL.transformVersionToInternalValue)
                },
                internalToPublicTransformers: {
                    value: (0, $dHKLL.transformVersionToPublicValue)
                },
                emitChangeOn: 'change',
                requiredScopes: (0, $dHKLL.versionsRequiredScopes)
            },
            [(0, $lO4Or.AFFECTS_VERSIONS_TYPE)]: {
                publicShapeValidators: {
                    fieldName: commonFieldValidators.fieldName,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    description: commonFieldValidators.description,
                    value: (0, $1NIGg.validateVersionValue)
                },
                publicToInternalTransformers: {
                    value: (0, $dHKLL.transformVersionToInternalValue)
                },
                internalToPublicTransformers: {
                    value: (0, $dHKLL.transformVersionToPublicValue)
                },
                emitChangeOn: 'change',
                requiredScopes: (0, $dHKLL.versionsRequiredScopes)
            },
            [(0, $lO4Or.NUMBER_CF_TYPE)]: {
                publicShapeValidators: {
                    description: commonFieldValidators.description,
                    fieldName: commonFieldValidators.fieldName,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    value: (0, $htzHC.validateNumberValue)
                },
                publicToInternalTransformers: {},
                internalToPublicTransformers: {},
                emitChangeOn: 'change',
                requiredScopes: (0, $7Vf73.numberIssueViewScopes)
            },
            [(0, $lO4Or.LABELS_TYPE)]: {
                publicShapeValidators: {
                    description: commonFieldValidators.description,
                    fieldName: commonFieldValidators.fieldName,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    value: (0, $2hY4o.validateLabelsSetValue)
                },
                publicToInternalTransformers: {},
                internalToPublicTransformers: {},
                emitChangeOn: 'change',
                requiredScopes: (0, $2hY4o.labelsRequiredScopes)
            },
            [(0, $lO4Or.DATE_CF_TYPE)]: {
                publicShapeValidators: {
                    description: commonFieldValidators.description,
                    fieldName: commonFieldValidators.fieldName,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    value: (0, $9aEJT.datePickerSetValueValidator)
                },
                publicToInternalTransformers: {},
                internalToPublicTransformers: {
                    value: (0, $9aEJT.datePickerGetValueTransformer)
                },
                emitChangeOn: 'change',
                requiredScopes: (0, $aCDyF.datePickerIssueViewScopes)
            },
            [(0, $lO4Or.DATETIME_CF_TYPE)]: {
                publicShapeValidators: {
                    description: commonFieldValidators.description,
                    fieldName: commonFieldValidators.fieldName,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    value: (0, $e8h5r.validateDateTimePickerSetValue)
                },
                publicToInternalTransformers: {},
                internalToPublicTransformers: {
                    value: (0, $e8h5r.transformDateTimePickerGetValue)
                },
                emitChangeOn: 'change',
                requiredScopes: (0, $fguRM.dateTimePickerIssueViewScopes)
            },
            [(0, $lO4Or.USER_CF_TYPE)]: {
                publicShapeValidators: {
                    description: commonFieldValidators.description,
                    fieldName: commonFieldValidators.fieldName,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    value: (0, $1h6vN.userPickerSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $8QLPP.assigneeSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $8QLPP.assigneeGetValueTransformer)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$3a106242c8f57ac2),
                requiredScopes: (0, $elWuT.assigneeIssueViewScopes)
            },
            [(0, $lO4Or.REPORTER_TYPE)]: {
                publicShapeValidators: {
                    description: commonFieldValidators.description,
                    fieldName: commonFieldValidators.fieldName,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    value: (0, $feRPz.reporterSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $8QLPP.assigneeSetValueTransformer)
                },
                internalToPublicTransformers: {
                    value: (0, $8QLPP.assigneeGetValueTransformer)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$3a106242c8f57ac2),
                requiredScopes: (0, $elWuT.assigneeIssueViewScopes)
            },
            [(0, $lO4Or.MULTI_USER_CF_TYPE)]: {
                publicShapeValidators: {
                    description: commonFieldValidators.description,
                    fieldName: commonFieldValidators.fieldName,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    value: (0, $1zzzr.validateMultiUserPickerSetValue)
                },
                publicToInternalTransformers: {
                    value: (0, $90qH7.transformMultiUserPickerSetValue)
                },
                internalToPublicTransformers: {
                    value: (0, $90qH7.transformMultiUserPickerGetValue)
                },
                emitChangeOn: 'change',
                lookupSource: (0, $6b8c146c2dd688bb$export$3a106242c8f57ac2),
                requiredScopes: (0, $elWuT.assigneeIssueViewScopes)
            },
            [(0, $lO4Or.COMPONENTS_TYPE)]: {
                publicShapeValidators: {
                    description: commonFieldValidators.description,
                    fieldName: commonFieldValidators.fieldName,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    value: (0, $hBOxC.validateComponentsSetValue)
                },
                publicToInternalTransformers: {
                    value: (0, $3qPEc.transformComponentsSetValue)
                },
                internalToPublicTransformers: {
                    value: (0, $3qPEc.transformComponentsGetValue)
                },
                emitChangeOn: 'change',
                requiredScopes: (0, $3qPEc.componentsIssueViewScopes)
            },
            [(0, $lO4Or.PARENT_TYPE)]: {
                publicShapeValidators: {
                    fieldName: commonFieldValidators.fieldName,
                    description: commonFieldValidators.description,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    value: (0, $7AbVk.parentSetValueValidator)
                },
                publicToInternalTransformers: {
                    value: (0, $4yViI.transformParentSetValue)
                },
                internalToPublicTransformers: {
                    value: (0, $4yViI.transformParentGetValue)
                },
                emitChangeOn: 'change',
                requiredScopes: (0, $4yViI.parentIssueViewScopes)
            },
            [(0, $lO4Or.CASCADING_SELECT_CF_TYPE)]: {
                publicShapeValidators: {
                    fieldName: commonFieldValidators.fieldName,
                    isReadOnly: commonFieldValidators.isReadOnly,
                    isVisible: commonFieldValidators.isVisible,
                    value: (0, $axvW5.validateCascadingSelectSetValue),
                    description: commonFieldValidators.description
                },
                publicToInternalTransformers: {
                    value: (0, $bvi64.transformSetValueCascadingSelect)
                },
                internalToPublicTransformers: {
                    value: (0, $bvi64.transformGetValueCascadingSelect)
                },
                emitChangeOn: 'change',
                requiredScopes: (0, $bvi64.cascadingSelectIssueViewScopes)
            }
        };
    }
    getSupportedFieldTypes() {
        const supportedFieldTypes = [
            (0, $lO4Or.SUMMARY_TYPE),
            (0, $lO4Or.DESCRIPTION_TYPE),
            (0, $lO4Or.ASSIGNEE_TYPE),
            (0, $lO4Or.PRIORITY_TYPE),
            (0, $lO4Or.URL_CF_TYPE),
            (0, $lO4Or.TEXT_CF_TYPE),
            (0, $lO4Or.MULTI_CHECKBOXES_CF_TYPE),
            (0, $lO4Or.TEXT_AREA_CF_TYPE),
            (0, $lO4Or.SELECT_CF_TYPE),
            (0, $lO4Or.MULTI_SELECT_CF_TYPE),
            (0, $lO4Or.RADIO_BUTTONS_CF_TYPE),
            (0, $lO4Or.FIX_VERSIONS_TYPE),
            (0, $lO4Or.NUMBER_CF_TYPE),
            (0, $lO4Or.DATE_CF_TYPE),
            (0, $lO4Or.DATETIME_CF_TYPE),
            (0, $lO4Or.LABELS_TYPE),
            (0, $lO4Or.USER_CF_TYPE),
            (0, $lO4Or.REPORTER_TYPE),
            (0, $lO4Or.COMPONENTS_TYPE),
            (0, $lO4Or.MULTI_USER_CF_TYPE),
            (0, $lO4Or.PARENT_TYPE)
        ];
        if ((0, $1ybV0.ff)('ui-modifications-cascading-select-field-support-_bjjiv')) supportedFieldTypes.push((0, $lO4Or.CASCADING_SELECT_CF_TYPE));
        if ((0, $1ybV0.ff)('forge-ui-modifications-affects-versions-field-support-iv_ff6mj')) supportedFieldTypes.push((0, $lO4Or.AFFECTS_VERSIONS_TYPE));
        return supportedFieldTypes;
    }
    getSupportedProjectTypes() {
        return [
            (0, $7ZZxN.SOFTWARE_PROJECT)
        ];
    }
    getConsentMessage() {
        return (0, $hMqzl.default).uimIssueViewConsentMessage;
    }
    getAnalytics() {
        return this.analytics;
    }
    getSupportedTriggerPointsConfiguration() {
        return new Set([
            (0, $0100842672acae20$export$b19f949fb9713614),
            (0, $0100842672acae20$export$9c5d81b901471b27),
            (0, $0100842672acae20$export$f72626bf0d75dfad),
            (0, $0100842672acae20$export$cd16d39c55c569d0),
            (0, $0100842672acae20$export$53d41ff2666118e1),
            (0, $0100842672acae20$export$710114090a811b37),
            (0, $0100842672acae20$export$14a8072f422804fd),
            (0, $0100842672acae20$export$7ca28938a07e0c33)
        ]);
    }
    constructor(){
        this.analytics = {
            stopTTI: $iTvzN.stopTTI,
            cancelTTI: $iTvzN.cancelTTI,
            markIframeLoad: $iTvzN.markIframeLoad,
            markFieldsRegistered: $iTvzN.markFieldsRegistered,
            markOnInitResolved: $iTvzN.markOnInitResolved
        };
        this.isScreenTabsSupportEnabled = ()=>false;
    }
}

});
parcelRegister("iTvzN", function(module, exports) {

$parcel$export(module.exports, "startUimTti", () => $f4d69f5c84cf80c8$export$1422384676f6de7a);
$parcel$export(module.exports, "markUimTtiIssueViewLoaded", () => $f4d69f5c84cf80c8$export$5a9389b70d93def2);
$parcel$export(module.exports, "stopTTI", () => $f4d69f5c84cf80c8$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $f4d69f5c84cf80c8$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $f4d69f5c84cf80c8$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $f4d69f5c84cf80c8$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $f4d69f5c84cf80c8$export$d86f4868694f2aa7);

var $lNfG4 = parcelRequire("lNfG4");

var $gGRYc = parcelRequire("gGRYc");
const $f4d69f5c84cf80c8$var$uimInIssueViewTTI = (0, $lNfG4.metrics).interaction({
    key: 'ui-modifications-in-issue-view',
    timings: [
        {
            key: 'issue-view-tti-delta',
            startMark: 'issue-view-tti'
        },
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        }
    ],
    featureFlags: (0, $gGRYc.TTIFFs)
});
const $f4d69f5c84cf80c8$export$1422384676f6de7a = ()=>{
    $f4d69f5c84cf80c8$var$uimInIssueViewTTI.start();
};
const $f4d69f5c84cf80c8$export$5a9389b70d93def2 = ()=>{
    $f4d69f5c84cf80c8$var$uimInIssueViewTTI.mark('issue-view-tti');
};
const $f4d69f5c84cf80c8$export$30ca4c461fab486c = (customData)=>{
    $f4d69f5c84cf80c8$var$uimInIssueViewTTI.stop({
        customData: customData
    });
};
const $f4d69f5c84cf80c8$export$27f2445288b528c = ()=>{
    $f4d69f5c84cf80c8$var$uimInIssueViewTTI.cancel();
};
const $f4d69f5c84cf80c8$export$7a2709fc1e33401a = ()=>{
    $f4d69f5c84cf80c8$var$uimInIssueViewTTI.mark('iframe-load');
};
const $f4d69f5c84cf80c8$export$cf3893335c93e33b = ()=>{
    $f4d69f5c84cf80c8$var$uimInIssueViewTTI.mark('fields-registered');
};
const $f4d69f5c84cf80c8$export$d86f4868694f2aa7 = ()=>{
    $f4d69f5c84cf80c8$var$uimInIssueViewTTI.mark('oninit-resolved');
};

});

parcelRegister("elWuT", function(module, exports) {

$parcel$export(module.exports, "assigneeIssueViewScopes", () => $ed8290f82948f280$export$37dd073552da1a40);

var $8QLPP = parcelRequire("8QLPP");

var $2re4M = parcelRequire("2re4M");
const $ed8290f82948f280$export$37dd073552da1a40 = {
    ...(0, $8QLPP.assigneeScopes),
    granular: [
        ...(0, $8QLPP.assigneeScopes).granular,
        ...(0, $2re4M.commonIssueViewGranularScopes)
    ]
};

});
parcelRegister("2re4M", function(module, exports) {

$parcel$export(module.exports, "commonIssueViewGranularScopes", () => $7aa07c0f3ab1502e$export$c6286247dcbeb3df);
const $7aa07c0f3ab1502e$export$c6286247dcbeb3df = [
    'write:issue:jira',
    'read:issue-field-values:jira'
];

});


parcelRegister("bvi64", function(module, exports) {

$parcel$export(module.exports, "transformSetValueCascadingSelect", () => $6fcfcb43819b052a$export$905a8d55c641a71e);
$parcel$export(module.exports, "transformGetValueCascadingSelect", () => $6fcfcb43819b052a$export$47e9770ed0d1c344);
$parcel$export(module.exports, "cascadingSelectIssueViewScopes", () => $6fcfcb43819b052a$export$a0edee15316177cb);

var $2rn3r = parcelRequire("2rn3r");

var $9Ek5r = parcelRequire("9Ek5r");

var $2re4M = parcelRequire("2re4M");
const $6fcfcb43819b052a$export$905a8d55c641a71e = (value, _lookupValues, { tenantContext: tenantContext, fieldContext: fieldContext })=>{
    if (value === null) return null;
    let childAri = null;
    const parentAri = (0, $2rn3r.JiraIssueFieldOptionAri).create({
        siteId: tenantContext.cloudId,
        activationId: tenantContext.activationId,
        fieldId: fieldContext.fieldId,
        optionId: value.parentId
    }).toString();
    if (value?.childId) childAri = (0, $2rn3r.JiraIssueFieldOptionAri).create({
        siteId: tenantContext.cloudId,
        activationId: tenantContext.activationId,
        fieldId: fieldContext.fieldId,
        optionId: value.childId
    }).toString();
    return {
        parentId: parentAri,
        childId: childAri
    };
};
const $6fcfcb43819b052a$export$47e9770ed0d1c344 = (value)=>{
    if (!value) return null;
    const parent = {
        id: value.id,
        value: value.value
    };
    const child = value.child ? {
        id: value.child.id,
        value: value.child.value
    } : null;
    return {
        parent: parent,
        child: child
    };
};
const $6fcfcb43819b052a$export$a0edee15316177cb = {
    ...(0, $9Ek5r.selectScopes),
    granular: [
        ...(0, $9Ek5r.selectScopes).granular,
        ...(0, $2re4M.commonIssueViewGranularScopes)
    ]
};

});

parcelRegister("3qPEc", function(module, exports) {

$parcel$export(module.exports, "componentsIssueViewScopes", () => $84a07567d70530ac$export$2d77b34c4c3f5fd0);
$parcel$export(module.exports, "transformComponentsGetValue", () => $84a07567d70530ac$export$5bb582851410c3c3);
$parcel$export(module.exports, "transformComponentsSetValue", () => $84a07567d70530ac$export$11da965a72270337);

var $hBOxC = parcelRequire("hBOxC");

var $2re4M = parcelRequire("2re4M");
const $84a07567d70530ac$export$2d77b34c4c3f5fd0 = {
    ...(0, $hBOxC.componentsRequiredScopes),
    granular: [
        ...(0, $hBOxC.componentsRequiredScopes).granular,
        ...(0, $2re4M.commonIssueViewGranularScopes)
    ]
};
const $84a07567d70530ac$export$5bb582851410c3c3 = (internalValue)=>{
    if (!internalValue) return [];
    return internalValue.map(({ id: id, name: name })=>({
            id: id,
            name: name
        }));
};
const $84a07567d70530ac$export$11da965a72270337 = (publicValues)=>{
    if (!publicValues) return [];
    return publicValues.map((id)=>({
            id: id
        }));
};

});

parcelRegister("aCDyF", function(module, exports) {

$parcel$export(module.exports, "datePickerIssueViewScopes", () => $ab81124e008d3519$export$7936cbcb39b1d176);

var $4XB9o = parcelRequire("4XB9o");

var $2re4M = parcelRequire("2re4M");
const $ab81124e008d3519$export$7936cbcb39b1d176 = {
    ...(0, $4XB9o.baseScopesRequiredPerField),
    granular: [
        ...(0, $4XB9o.baseScopesRequiredPerField).granular,
        ...(0, $2re4M.commonIssueViewGranularScopes)
    ]
};

});

parcelRegister("fguRM", function(module, exports) {

$parcel$export(module.exports, "dateTimePickerIssueViewScopes", () => $e48d6f07d007070c$export$a7d3367976f70795);

var $4XB9o = parcelRequire("4XB9o");

var $2re4M = parcelRequire("2re4M");
const $e48d6f07d007070c$export$a7d3367976f70795 = {
    ...(0, $4XB9o.baseScopesRequiredPerField),
    granular: [
        ...(0, $4XB9o.baseScopesRequiredPerField).granular,
        ...(0, $2re4M.commonIssueViewGranularScopes)
    ]
};

});

parcelRegister("8lh20", function(module, exports) {

$parcel$export(module.exports, "validateRichText", () => $ed8b97216cbe9959$export$98157eaee5d4eeca);
$parcel$export(module.exports, "transformRichTextToPublicValue", () => $ed8b97216cbe9959$export$41b11897967c0fca);
$parcel$export(module.exports, "descriptionIssueViewScopes", () => $ed8b97216cbe9959$export$9f764201bd3a6b52);

var $9tBd5 = parcelRequire("9tBd5");

var $4XB9o = parcelRequire("4XB9o");

var $cw2gk = parcelRequire("cw2gk");

var $2re4M = parcelRequire("2re4M");
const $ed8b97216cbe9959$export$98157eaee5d4eeca = (value, _metadata, _createAnalyticsEvent, extra)=>(0, $cw2gk.isValidADF)({
        newValue: value,
        currentValue: extra.currentField?.value,
        viewType: extra.viewType
    });
const $ed8b97216cbe9959$export$41b11897967c0fca = (value)=>{
    if (value === undefined) // The `convertTextToAdf` call will give us an "empty ADF object":
    // {
    //   "type": "doc",
    //   "version": 1,
    //   "content": [
    //     {
    //       "type": "paragraph",
    //       "content": []
    //     }
    //   ]
    // }
    return (0, $9tBd5.convertTextToAdf)('');
    return value;
};
const $ed8b97216cbe9959$export$9f764201bd3a6b52 = {
    ...(0, $4XB9o.baseScopesRequiredPerField),
    granular: [
        ...(0, $4XB9o.baseScopesRequiredPerField).granular,
        ...(0, $2re4M.commonIssueViewGranularScopes)
    ]
};

});

parcelRegister("2hY4o", function(module, exports) {

$parcel$export(module.exports, "validateLabelsSetValue", () => $b0ed2f79ced2bbe2$export$6130bc1755ce872a);
$parcel$export(module.exports, "labelsRequiredScopes", () => $b0ed2f79ced2bbe2$export$5397fc4189b6d690);


var $incV3 = parcelRequire("incV3");

var $8xPow = parcelRequire("8xPow");

var $2re4M = parcelRequire("2re4M");
const $b0ed2f79ced2bbe2$export$6130bc1755ce872a = (value)=>Array.isArray(value) && value.length <= (0, $6b8c146c2dd688bb$export$106087dcfd4fb129) && value.every((0, $8xPow.isNotEmptyString));
const $b0ed2f79ced2bbe2$export$5397fc4189b6d690 = {
    ...(0, $incV3.labelsRequiredScopes),
    granular: [
        ...(0, $incV3.labelsRequiredScopes).granular,
        ...(0, $2re4M.commonIssueViewGranularScopes)
    ]
};

});

parcelRegister("1mUM4", function(module, exports) {

$parcel$export(module.exports, "multiCheckboxSetValueTransformer", () => $5dec8e4211293f94$export$9ba1ee83cc9456ba);
$parcel$export(module.exports, "multiCheckboxGetValueTransformer", () => $5dec8e4211293f94$export$6d15ce1cc0bdffe7);
$parcel$export(module.exports, "multiCheckboxScopes", () => $5dec8e4211293f94$export$488c2db81cb83823);

var $4XB9o = parcelRequire("4XB9o");

var $2re4M = parcelRequire("2re4M");
const $5dec8e4211293f94$export$9ba1ee83cc9456ba = (values)=>values.map((id)=>({
            id: id
        }));
const $5dec8e4211293f94$export$6d15ce1cc0bdffe7 = (internalValue)=>{
    if (!internalValue) return [];
    return internalValue.map(({ id: id, value: value })=>({
            id: id,
            value: value
        }));
};
const $5dec8e4211293f94$export$488c2db81cb83823 = {
    ...(0, $4XB9o.baseScopesRequiredPerField),
    granular: [
        ...(0, $4XB9o.baseScopesRequiredPerField).granular,
        ...(0, $2re4M.commonIssueViewGranularScopes)
    ]
};

});

parcelRegister("aXs6e", function(module, exports) {

$parcel$export(module.exports, "transformMultiSelectSetValue", () => $98e2ed2a05bc16c5$export$efdfe34b5fc174ce);
$parcel$export(module.exports, "transformMultiSelectGetValue", () => $98e2ed2a05bc16c5$export$7ad37bc37002060f);
$parcel$export(module.exports, "multiSelectScopes", () => $98e2ed2a05bc16c5$export$314882a3f1f403d6);

var $ifv0j = parcelRequire("ifv0j");

var $2re4M = parcelRequire("2re4M");
const $98e2ed2a05bc16c5$export$efdfe34b5fc174ce = (values)=>values.map((id)=>({
            id: id
        }));
const $98e2ed2a05bc16c5$export$7ad37bc37002060f = (internalValue)=>{
    if (!internalValue) return [];
    return internalValue.map(({ id: id, value: value })=>({
            id: id,
            value: value
        }));
};
const $98e2ed2a05bc16c5$export$314882a3f1f403d6 = {
    ...(0, $ifv0j.multiSelectScopes),
    granular: [
        ...(0, $ifv0j.multiSelectScopes).granular,
        ...(0, $2re4M.commonIssueViewGranularScopes)
    ]
};

});

parcelRegister("90qH7", function(module, exports) {

$parcel$export(module.exports, "transformMultiUserPickerSetValue", () => $42c048be67171248$export$5b3066e9c91b4b70);
$parcel$export(module.exports, "transformMultiUserPickerGetValue", () => $42c048be67171248$export$14f50c5c8c51bfdc);

var $2Vsz9 = parcelRequire("2Vsz9");

var $jgrDo = parcelRequire("jgrDo");

var $eF9ai = parcelRequire("eF9ai");
const $42c048be67171248$export$5b3066e9c91b4b70 = (values, lookupValues)=>{
    if (!values.length) return [];
    const filteredLookupValues = (0, $eF9ai.multiValueLookup)(values, lookupValues, 'accountId');
    if (values.length !== filteredLookupValues.length) {
        const notFoundValues = (0, $jgrDo.getValueLookupValuesDiff)(values, filteredLookupValues, 'accountId');
        throw new (0, $2Vsz9.FieldValueLookupError)(notFoundValues.join());
    }
    return filteredLookupValues.map(({ accountId: accountId, name: name, picture: picture })=>({
            accountId: accountId,
            displayName: name,
            avatarUrls: {
                '24x24': picture
            }
        }));
};
const $42c048be67171248$export$14f50c5c8c51bfdc = (value)=>{
    if (!value) return [];
    return value.map(({ accountId: accountId })=>({
            accountId: accountId
        }));
};

});

parcelRegister("7Vf73", function(module, exports) {

$parcel$export(module.exports, "numberIssueViewScopes", () => $8f6be24ae7bd02a4$export$d0704215d52fd2fd);

var $htzHC = parcelRequire("htzHC");

var $2re4M = parcelRequire("2re4M");
const $8f6be24ae7bd02a4$export$d0704215d52fd2fd = {
    ...(0, $htzHC.numberScopes),
    granular: [
        ...(0, $htzHC.numberScopes).granular,
        ...(0, $2re4M.commonIssueViewGranularScopes)
    ]
};

});

parcelRegister("44460", function(module, exports) {

$parcel$export(module.exports, "validateParagraphSetValue", () => $fadba7e7b05c2d33$export$7efb2358ba381826);
$parcel$export(module.exports, "paragraphSetValueTransformer", () => $fadba7e7b05c2d33$export$4f3e7aa88a08b7db);
$parcel$export(module.exports, "paragraphGetValueTransformer", () => $fadba7e7b05c2d33$export$88b493c87579f4ea);

var $9tBd5 = parcelRequire("9tBd5");


var $cw2gk = parcelRequire("cw2gk");
const $fadba7e7b05c2d33$export$7efb2358ba381826 = (value, { fieldRenderer: fieldRenderer }, _createAnalyticsEvent, extra)=>{
    switch(fieldRenderer){
        case 0, $c7e7b1d3600a0c0f$export$89b8c5d86c10a68c:
            return (0, $cw2gk.isValidADF)({
                newValue: value,
                currentValue: extra.currentField?.value,
                viewType: extra.viewType
            });
        case 0, $c7e7b1d3600a0c0f$export$a4a240cb4053b29f:
            return Promise.resolve(typeof value === 'string');
        default:
            return Promise.resolve(false);
    }
};
const $fadba7e7b05c2d33$export$4f3e7aa88a08b7db = (value)=>{
    if (typeof value === 'string') return value;
    return {
        ...value
    };
};
const $fadba7e7b05c2d33$export$88b493c87579f4ea = (value, fieldRenderer)=>{
    if (value === undefined || value === null) // The `convertTextToAdf` call will give us an "empty ADF object":
    // {
    //   "type": "doc",
    //   "version": 1,
    //   "content": [
    //     {
    //       "type": "paragraph",
    //       "content": []
    //     }
    //   ]
    // }
    return fieldRenderer === (0, $c7e7b1d3600a0c0f$export$89b8c5d86c10a68c) ? (0, $9tBd5.convertTextToAdf)('') : '';
    if (typeof value === 'string') return value;
    return value;
};

});

parcelRegister("4yViI", function(module, exports) {

$parcel$export(module.exports, "transformParentSetValue", () => $748ec28ce44dd6e2$export$2c2fa789efcce745);
$parcel$export(module.exports, "transformParentGetValue", () => $748ec28ce44dd6e2$export$98caacb992dbef18);
$parcel$export(module.exports, "parentIssueViewScopes", () => $748ec28ce44dd6e2$export$4512997696e69403);

var $7AbVk = parcelRequire("7AbVk");

var $2re4M = parcelRequire("2re4M");
function $748ec28ce44dd6e2$export$2c2fa789efcce745(value) {
    if (value === null) return null;
    return {
        id: value
    };
}
function $748ec28ce44dd6e2$export$98caacb992dbef18(internalValue) {
    if (!internalValue) return null;
    return {
        id: internalValue.id,
        key: internalValue.key
    };
}
const $748ec28ce44dd6e2$export$4512997696e69403 = {
    ...(0, $7AbVk.parentScopes),
    granular: [
        ...(0, $7AbVk.parentScopes).granular,
        ...(0, $2re4M.commonIssueViewGranularScopes)
    ]
};

});

parcelRegister("1f831", function(module, exports) {

$parcel$export(module.exports, "transformPrioritySetValue", () => $31d58dbbdb2d0809$export$fc571ad244cfa429);
$parcel$export(module.exports, "transformPriorityGetValue", () => $31d58dbbdb2d0809$export$95a791a89befdf91);
$parcel$export(module.exports, "priorityIssueViewScopes", () => $31d58dbbdb2d0809$export$73887a9e9ca89122);

var $gLagZ = parcelRequire("gLagZ");

var $2re4M = parcelRequire("2re4M");
const $31d58dbbdb2d0809$export$fc571ad244cfa429 = (value)=>({
        id: value
    });
const $31d58dbbdb2d0809$export$95a791a89befdf91 = (priority)=>{
    if (!priority) return null;
    const { id: id, name: name, iconUrl: iconUrl } = priority;
    return {
        id: id,
        name: name,
        iconUrl: iconUrl
    };
};
const $31d58dbbdb2d0809$export$73887a9e9ca89122 = {
    ...(0, $gLagZ.priorityScopes),
    granular: [
        ...(0, $gLagZ.priorityScopes).granular,
        ...(0, $2re4M.commonIssueViewGranularScopes)
    ]
};

});

parcelRegister("4tIE7", function(module, exports) {

$parcel$export(module.exports, "radioButtonsSetValueTransformer", () => $2219b0493254e016$export$d23713245ea192a9);
$parcel$export(module.exports, "radioButtonsGetValueTransformer", () => $2219b0493254e016$export$624bfe758f4ad3c6);
$parcel$export(module.exports, "radioButtonsIssueViewScopes", () => $2219b0493254e016$export$44f58b3fbc54e404);

var $hFkmH = parcelRequire("hFkmH");

var $2re4M = parcelRequire("2re4M");
const $2219b0493254e016$export$d23713245ea192a9 = (value)=>{
    if (value === null) return null;
    return {
        id: value
    };
};
const $2219b0493254e016$export$624bfe758f4ad3c6 = (value)=>{
    if (!value) return null;
    return {
        id: value.id,
        value: value.value
    };
};
const $2219b0493254e016$export$44f58b3fbc54e404 = {
    ...(0, $hFkmH.radioButtonsScopes),
    granular: [
        ...(0, $hFkmH.radioButtonsScopes).granular,
        ...(0, $2re4M.commonIssueViewGranularScopes)
    ]
};

});

parcelRegister("c6jWy", function(module, exports) {

$parcel$export(module.exports, "selectSetValueTransformer", () => $c937724d4654ecc5$export$136c42b919fdec83);
$parcel$export(module.exports, "selectGetValueTransformer", () => $c937724d4654ecc5$export$fd4db924c90bd0e2);
$parcel$export(module.exports, "selectIssueViewScopes", () => $c937724d4654ecc5$export$c606e83ffca8af68);

var $2rn3r = parcelRequire("2rn3r");

var $9Ek5r = parcelRequire("9Ek5r");

var $2re4M = parcelRequire("2re4M");
const $c937724d4654ecc5$export$136c42b919fdec83 = (value, _lookupValues, { tenantContext: tenantContext, fieldContext: fieldContext })=>{
    if (value === null) return null;
    const ari = (0, $2rn3r.JiraIssueFieldOptionAri).create({
        siteId: tenantContext.cloudId,
        activationId: tenantContext.activationId,
        fieldId: fieldContext.fieldId,
        optionId: value
    }).toString();
    return {
        ari: ari
    };
};
const $c937724d4654ecc5$export$fd4db924c90bd0e2 = (value)=>{
    if (!value) return null;
    return {
        id: value.id,
        value: value.value
    };
};
const $c937724d4654ecc5$export$c606e83ffca8af68 = {
    ...(0, $9Ek5r.selectScopes),
    granular: [
        ...(0, $9Ek5r.selectScopes).granular,
        ...(0, $2re4M.commonIssueViewGranularScopes)
    ]
};

});

parcelRegister("aXpSX", function(module, exports) {

$parcel$export(module.exports, "singleLineTextIssueViewScopes", () => $3bb3814a07671186$export$6ece4ba5721790a0);

var $9Zo5b = parcelRequire("9Zo5b");

var $2re4M = parcelRequire("2re4M");
const $3bb3814a07671186$export$6ece4ba5721790a0 = {
    ...(0, $9Zo5b.singleLineTextScopes),
    granular: [
        ...(0, $9Zo5b.singleLineTextScopes).granular,
        ...(0, $2re4M.commonIssueViewGranularScopes)
    ]
};

});

parcelRegister("hF72b", function(module, exports) {

$parcel$export(module.exports, "summaryIssueViewScopes", () => $f1d94cf8f7167e02$export$98513697beab9507);

var $9Zo5b = parcelRequire("9Zo5b");

var $2re4M = parcelRequire("2re4M");
const $f1d94cf8f7167e02$export$98513697beab9507 = {
    ...(0, $9Zo5b.singleLineTextScopes),
    granular: [
        ...(0, $9Zo5b.singleLineTextScopes).granular,
        ...(0, $2re4M.commonIssueViewGranularScopes)
    ]
};

});

parcelRegister("hBvZU", function(module, exports) {

$parcel$export(module.exports, "urlIssueViewScopes", () => $a11136df0fd75d48$export$c6b3963a694ffc47);

var $4XB9o = parcelRequire("4XB9o");

var $2re4M = parcelRequire("2re4M");
const $a11136df0fd75d48$export$c6b3963a694ffc47 = {
    ...(0, $4XB9o.baseScopesRequiredPerField),
    granular: [
        ...(0, $4XB9o.baseScopesRequiredPerField).granular,
        ...(0, $2re4M.commonIssueViewGranularScopes)
    ]
};

});

parcelRegister("dHKLL", function(module, exports) {

$parcel$export(module.exports, "transformVersionToInternalValue", () => $b5f230f1f80751f7$export$1fb4429d51b6df1d);
$parcel$export(module.exports, "transformVersionToPublicValue", () => $b5f230f1f80751f7$export$e019532c54e8b675);
$parcel$export(module.exports, "versionsRequiredScopes", () => $b5f230f1f80751f7$export$60db61c485973ad9);

var $1NIGg = parcelRequire("1NIGg");

var $2re4M = parcelRequire("2re4M");
const $b5f230f1f80751f7$export$1fb4429d51b6df1d = (internalValue)=>{
    if (!internalValue.length) return [];
    return internalValue.map((id)=>({
            id: id
        }));
};
const $b5f230f1f80751f7$export$e019532c54e8b675 = (internalValue)=>{
    if (!internalValue) return [];
    return internalValue.map(({ id: id, name: name })=>({
            id: id,
            name: name
        }));
};
const $b5f230f1f80751f7$export$60db61c485973ad9 = {
    ...(0, $1NIGg.versionsRequiredScopes),
    granular: [
        ...(0, $1NIGg.versionsRequiredScopes).granular,
        ...(0, $2re4M.commonIssueViewGranularScopes)
    ]
};

});

parcelRegister("hMqzl", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f459b4ccd463f1f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1f459b4ccd463f1f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    uimIssueViewConsentMessage: {
        "id": "ui-modifications-fields-configuration.common.utils.views.issue-view.uim-issue-view-consent-message",
        "defaultMessage": "Allow \u201C{appTitle}\u201D to access your Atlassian products to get the full issue experience."
    }
});

});





parcelRegister("lB1pd", function(module, exports) {

$parcel$export(module.exports, "transformFieldToIframe", () => $d133bdec274d1c3f$export$aa453854f74fab);

var $h1jSL = parcelRequire("h1jSL");

var $8ibkc = parcelRequire("8ibkc");
const $d133bdec274d1c3f$export$aa453854f74fab = (fieldChanges, viewType, fieldType, lookupData, fieldFromIframe, fieldMetadata)=>{
    const fieldConfiguration = (0, $8ibkc.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldInternalToPublicTransformers = fieldConfiguration?.internalToPublicTransformers;
    const publicShapeField = {
        ...fieldChanges
    };
    if (publicShapeField.value !== undefined && fieldInternalToPublicTransformers?.value) try {
        publicShapeField.value = fieldInternalToPublicTransformers?.value(fieldChanges.value, fieldMetadata.fieldRenderer);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $h1jSL.fireIAErrorAnalytics)({
            error: err,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    if (fieldFromIframe.optionsVisibility !== undefined && fieldInternalToPublicTransformers?.optionsVisibility) try {
        const lookupSource = fieldConfiguration?.lookupSource;
        const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
        publicShapeField.optionsVisibility = fieldInternalToPublicTransformers?.optionsVisibility(fieldFromIframe.optionsVisibility, lookupValues);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $h1jSL.fireIAErrorAnalytics)({
            error: err,
            id: 'internalToPublicOptionsVisibilityTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return publicShapeField;
};

});

parcelRegister("fUNS1", function(module, exports) {

$parcel$export(module.exports, "prepareErrorsArray", () => $ef7370b518a4155c$export$e1fce51bc5be90b7);
const $ef7370b518a4155c$export$e1fce51bc5be90b7 = (errorsById)=>Object.values(errorsById).flat();

});

parcelRegister("7CbIv", function(module, exports) {

$parcel$export(module.exports, "transformFieldChangesToInternalShape", () => $0921c7ca821fb6e8$export$d14f85c01e334a1);

var $8blac = parcelRequire("8blac");

var $2Vsz9 = parcelRequire("2Vsz9");
var $8ibkc = parcelRequire("8ibkc");

var $fsCiP = parcelRequire("fsCiP");

var $WO73Y = parcelRequire("WO73Y");

var $KAPjp = parcelRequire("KAPjp");

var $fW80u = parcelRequire("fW80u");
const $0921c7ca821fb6e8$export$d14f85c01e334a1 = async ({ fieldType: fieldType, fieldId: fieldId, fieldFromIframe: fieldFromIframe, lookupData: lookupData, viewType: viewType, tenantContext: tenantContext, viewContext: viewContext, environment: environment })=>{
    const fieldConfiguration = (0, $8ibkc.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldTransformers = fieldConfiguration?.publicToInternalTransformers;
    const fieldValidators = fieldConfiguration?.publicShapeValidators;
    if (!fieldFromIframe || !fieldTransformers || !fieldValidators) return {
        ...(0, $KAPjp.VALID_RESULT),
        data: {}
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const validatorsArray = Object.keys(fieldValidators);
    const lookupSource = fieldConfiguration?.lookupSource;
    const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
    const fieldTransformationResults = await Promise.all(validatorsArray.map(async (propertyName)=>{
        if (!Object.prototype.hasOwnProperty.call(fieldFromIframe, propertyName)) return 0, $KAPjp.VALID_RESULT;
        const propertyValue = fieldFromIframe[propertyName];
        const transformer = fieldTransformers[propertyName];
        const fieldContext = {
            fieldId: fieldId
        };
        // We need to catch lookup values discrepancies and react accordingly
        // to how we react to validation errors - throw an error
        // if the set value wasn't found in the array of lookupValues
        try {
            const data = transformer ? await transformer(propertyValue, lookupValues, {
                tenantContext: tenantContext,
                viewContext: viewContext,
                environment: environment,
                fieldContext: fieldContext
            }) : propertyValue;
            return {
                isValid: true,
                data: {
                    [propertyName]: data
                }
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            // FieldValueLookupError will be thrown from the transformer
            // when the lookup value wasn't found
            if (err instanceof (0, $2Vsz9.FieldValueLookupError)) {
                // For single value fields its straightforward to just pass
                // the faulty propertyValue into error message,
                // but for multi value fields we should find out the faulty values from the array
                // thats why we should propagate the faulty values as a comma separated string
                // by using the error's message
                const faultyValue = err.message || propertyValue;
                return {
                    isValid: false,
                    error: {
                        fieldId: fieldId,
                        fieldType: fieldType,
                        type: (0, $fsCiP.FIELD_VALIDATION_ERROR),
                        method: (0, $WO73Y.mapFieldPropertyToApiMethod)(propertyName),
                        message: `Invalid IDs provided: ${faultyValue}`
                    }
                };
            }
            throw err;
        }
    }));
    const invalidTransformationResults = (0, $fW80u.filterInvalidResults)(fieldTransformationResults);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(invalidTransformationResults)) return {
        isValid: false,
        errors: invalidTransformationResults.map((result)=>result.error)
    };
    return (0, $fW80u.mapValidResultsToFieldInternalShape)(fieldTransformationResults);
};

});
parcelRegister("WO73Y", function(module, exports) {

$parcel$export(module.exports, "propertyToMethodMap", () => $f0920af4bdd7ca41$export$8325709d137b2606);
$parcel$export(module.exports, "mapFieldPropertyToApiMethod", () => $f0920af4bdd7ca41$export$e1cc7da28a1c4bb7);
const $f0920af4bdd7ca41$var$SET_NAME_METHOD = 'setName';
const $f0920af4bdd7ca41$var$SET_DESCRIPTION_METHOD = 'setDescription';
const $f0920af4bdd7ca41$var$SET_VISIBLE_METHOD = 'setVisible';
const $f0920af4bdd7ca41$var$SET_READ_ONLY_METHOD = 'setReadOnly';
const $f0920af4bdd7ca41$var$SET_VALUE_METHOD = 'setValue';
const $f0920af4bdd7ca41$var$SET_REQUIRED_METHOD = 'setRequired';
const $f0920af4bdd7ca41$var$SET_OPTIONS_VISIBILITY_METHOD = 'setOptionsVisibility';
const $f0920af4bdd7ca41$export$8325709d137b2606 = {
    fieldName: $f0920af4bdd7ca41$var$SET_NAME_METHOD,
    description: $f0920af4bdd7ca41$var$SET_DESCRIPTION_METHOD,
    isVisible: $f0920af4bdd7ca41$var$SET_VISIBLE_METHOD,
    isReadOnly: $f0920af4bdd7ca41$var$SET_READ_ONLY_METHOD,
    value: $f0920af4bdd7ca41$var$SET_VALUE_METHOD,
    isRequired: $f0920af4bdd7ca41$var$SET_REQUIRED_METHOD,
    optionsVisibility: $f0920af4bdd7ca41$var$SET_OPTIONS_VISIBILITY_METHOD
};
const $f0920af4bdd7ca41$export$e1cc7da28a1c4bb7 = (fieldProperty)=>{
    const method = $f0920af4bdd7ca41$export$8325709d137b2606[fieldProperty];
    if (!method) throw new Error(`No method found for field property: ${fieldProperty}`);
    return method;
};

});

parcelRegister("KAPjp", function(module, exports) {

$parcel$export(module.exports, "VALID_RESULT", () => $31d75f6b66e8195c$export$ee79e3ab53b8db79);
const $31d75f6b66e8195c$export$ee79e3ab53b8db79 = {
    isValid: true
};

});

parcelRegister("fW80u", function(module, exports) {

$parcel$export(module.exports, "mapValidResultsToFieldInternalShape", () => $130c7c4675a36fa8$export$a60dd8f1b025f23d);
$parcel$export(module.exports, "filterInvalidResults", () => $130c7c4675a36fa8$export$ddd005554aecd409);
const $130c7c4675a36fa8$export$a60dd8f1b025f23d = (results)=>results.reduce((acc, result)=>{
        if (result.isValid === true && Object.prototype.hasOwnProperty.call(result, 'data')) acc.data = {
            ...acc.data,
            ...result.data
        };
        return acc;
    }, {
        isValid: true,
        data: {}
    });
const $130c7c4675a36fa8$export$ddd005554aecd409 = (validationResults)=>validationResults.reduce((acc, result)=>{
        if (result.isValid === false) acc.push(result);
        return acc;
    }, []);

});



parcelRegister("9V8vn", function(module, exports) {

$parcel$export(module.exports, "clearBufferForChangeId", () => $0a575b9006a54548$export$bb8a68817bbdbd56);
$parcel$export(module.exports, "clearAllBufferTimeouts", () => $0a575b9006a54548$export$35bf721435968774);

var $kFGm5 = parcelRequire("kFGm5");
const $0a575b9006a54548$export$bb8a68817bbdbd56 = ({ changeId: changeId })=>({ setState: setState, getState: getState })=>{
        const { buffer: buffer, bufferTimeouts: bufferTimeouts } = getState();
        setState({
            buffer: (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(buffer, changeId),
            bufferTimeouts: (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(bufferTimeouts, changeId)
        });
    };
const $0a575b9006a54548$export$35bf721435968774 = ()=>({ getState: getState })=>{
        const { bufferTimeouts: bufferTimeouts } = getState();
        Object.values(bufferTimeouts).forEach((timeoutId)=>{
            clearTimeout(timeoutId);
        });
    };

});

parcelRegister("lpNv8", function(module, exports) {

$parcel$export(module.exports, "addBufferError", () => $cda1f7d272061b98$export$a2e535b38f56de3f);
$parcel$export(module.exports, "resetBufferErrors", () => $cda1f7d272061b98$export$e86d86ae2de90434);
$parcel$export(module.exports, "setAppConflictErrors", () => $cda1f7d272061b98$export$436bafa7bd476b9d);

var $3P2qm = parcelRequire("3P2qm");

var $3Oj61 = parcelRequire("3Oj61");
const $cda1f7d272061b98$export$a2e535b38f56de3f = (errorCode)=>({ setState: setState, getState: getState })=>{
        const bufferErrors = getState().bufferErrors || [];
        setState({
            bufferErrors: [
                ...bufferErrors,
                errorCode
            ]
        });
    };
const $cda1f7d272061b98$export$e86d86ae2de90434 = ()=>({ setState: setState })=>{
        setState({
            bufferErrors: null
        });
    };
const $cda1f7d272061b98$export$436bafa7bd476b9d = (changeId, bufferForChangeId, conflicts)=>({ dispatch: dispatch, getState: getState })=>{
        const appIds = Object.keys(bufferForChangeId);
        const lifecycleHook = changeId.startsWith('onInit') ? 'onInit' : 'onChange';
        const errorGroupsMap = (0, $3Oj61.getConflictErrorGroups)({
            appIds: appIds,
            conflicts: conflicts,
            formData: getState().formData || {},
            lifecycleHook: lifecycleHook
        });
        Object.entries(errorGroupsMap).forEach(([appId, errorGroup])=>{
            dispatch((0, $3P2qm.setAppErrors)({
                errors: errorGroup,
                appId: appId
            }));
        });
    };

});
parcelRegister("3Oj61", function(module, exports) {

$parcel$export(module.exports, "getConflicts", () => $7d0aaeca5ed35059$export$733bb30b9159fd88);
$parcel$export(module.exports, "getConflictErrorGroups", () => $7d0aaeca5ed35059$export$a3007ce4632f4be1);
$parcel$export(module.exports, "findAppsWhichDidNotSendChangesBeforeTimeout", () => $7d0aaeca5ed35059$export$dce8d41dc6e2b824);


var $WO73Y = parcelRequire("WO73Y");
const $7d0aaeca5ed35059$export$733bb30b9159fd88 = ({ bufferForChangeId: bufferForChangeId })=>{
    const fieldsPropsByApps = {};
    Object.entries(bufferForChangeId).filter(([_, fieldsChanges])=>fieldsChanges !== null).forEach(([appId, fieldsChanges])=>{
        Object.entries(fieldsChanges ?? {}).forEach(([fieldId, properties])=>Object.keys(properties).forEach((property)=>{
                if (!$7d0aaeca5ed35059$export$48096063dda20fc9(property)) return;
                const fieldProperty = `${fieldId}_${property}`;
                if (!fieldsPropsByApps[fieldProperty]) fieldsPropsByApps[fieldProperty] = {
                    apps: [],
                    fieldId: fieldId,
                    property: property
                };
                fieldsPropsByApps[fieldProperty].apps.push(appId);
            }));
    });
    const conflicts = {};
    Object.values(fieldsPropsByApps).filter(({ apps: apps })=>apps.length > 1).forEach(({ apps: apps, fieldId: fieldId, property: property })=>{
        apps.forEach((appId)=>{
            const conflict = {
                fieldId: fieldId,
                property: property
            };
            conflicts[appId] = conflicts[appId] ? [
                ...conflicts[appId],
                conflict
            ] : [
                conflict
            ];
        });
    });
    return conflicts;
};
const $7d0aaeca5ed35059$export$a3007ce4632f4be1 = ({ appIds: appIds, conflicts: conflicts, formData: formData, lifecycleHook: lifecycleHook })=>{
    const errorsMap = {};
    if (Object.keys(conflicts).length === 0) return errorsMap;
    appIds.forEach((appId)=>{
        if (!conflicts[appId]) {
            const appError = {
                type: (0, $991dbd38b561a091$export$83ecd24e1e791a18),
                message: `Due to a conflict between other UIM apps, we couldn\u{2019}t apply any modifications from ${lifecycleHook}.`,
                lifecycleHook: lifecycleHook
            };
            errorsMap[appId] = [
                appError
            ];
        } else {
            const appErrors = [];
            conflicts[appId].forEach(({ fieldId: fieldId, property: property })=>{
                const method = (0, $WO73Y.mapFieldPropertyToApiMethod)(property);
                appErrors.push({
                    type: (0, $991dbd38b561a091$export$83ecd24e1e791a18),
                    lifecycleHook: lifecycleHook,
                    message: `Your app is conflicted with another UIM app in ${lifecycleHook} on field: ${fieldId}, method: ${method}. Changes have been dismissed.`,
                    fieldType: formData[fieldId]?.fieldType,
                    fieldId: fieldId,
                    method: method
                });
            });
            errorsMap[appId] = appErrors;
        }
    });
    return errorsMap;
};
const $7d0aaeca5ed35059$export$48096063dda20fc9 = (property)=>{
    if (typeof property !== 'string') return false;
    return Object.prototype.hasOwnProperty.call((0, $WO73Y.propertyToMethodMap), property);
};
const $7d0aaeca5ed35059$export$dce8d41dc6e2b824 = (bufferForChangeId)=>Object.entries(bufferForChangeId).filter(([_, fieldsChanges])=>fieldsChanges === null).map(([appId])=>appId);

});
const $991dbd38b561a091$export$83ecd24e1e791a18 = 'MULTI_APP_CONFLICT_ERROR';



parcelRegister("b2p8u", function(module, exports) {

$parcel$export(module.exports, "sendBufferFinalMetrics", () => $ac05157e5ea7642e$export$4c03c99761d30a8);
$parcel$export(module.exports, "sendBufferConflictMetrics", () => $ac05157e5ea7642e$export$c0be261e8ef555b0);

var $2bv99 = parcelRequire("2bv99");

var $8ibkc = parcelRequire("8ibkc");

var $3Oj61 = parcelRequire("3Oj61");
const $ac05157e5ea7642e$export$4c03c99761d30a8 = (changeId, bufferForChangeId)=>({ getState: getState }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
        const { bufferErrors: bufferErrors, analyticsData: { issueAdjustmentModulesCount: issueAdjustmentModulesCount, configuredAppsCount: configuredAppsCount, adjustmentsAPILatency: adjustmentsAPILatency } } = getState();
        const appIds = Object.keys(bufferForChangeId).join();
        if (bufferErrors === null) (0, $2bv99.fireOperationalAnalyticsWithContext)(createAnalyticsEvent({}), 'bufferApplication success', viewType, {
            changeId: changeId,
            appIds: appIds
        });
        (0, $8ibkc.getAnalytics)(viewType).stopTTI({
            issueAdjustmentModulesCount: issueAdjustmentModulesCount,
            adjustmentsAPILatency: adjustmentsAPILatency,
            configuredAppsCount: configuredAppsCount,
            completionStatus: (0, $3Oj61.findAppsWhichDidNotSendChangesBeforeTimeout)(bufferForChangeId).length > 0 ? 'buffering_timeout' : 'success',
            viewType: viewType,
            appIds: appIds
        });
    };
const $ac05157e5ea7642e$export$c0be261e8ef555b0 = (changeId, bufferForChangeId, conflicts)=>async ({ getState: getState }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
        const { analyticsData: { issueAdjustmentModulesCount: issueAdjustmentModulesCount, configuredAppsCount: configuredAppsCount, adjustmentsAPILatency: adjustmentsAPILatency } } = getState();
        const appIds = Object.keys(bufferForChangeId);
        const lifecycleHook = changeId.startsWith('onInit') ? 'onInit' : 'onChange';
        (0, $2bv99.fireOperationalAnalyticsWithContext)(createAnalyticsEvent({}), 'multipleApps conflict', viewType, {
            lifecycleHook: lifecycleHook,
            conflicts: conflicts,
            appIds: appIds.join()
        });
        (0, $8ibkc.getAnalytics)(viewType).stopTTI({
            issueAdjustmentModulesCount: issueAdjustmentModulesCount,
            adjustmentsAPILatency: adjustmentsAPILatency,
            configuredAppsCount: configuredAppsCount,
            completionStatus: 'buffering_conflict',
            viewType: viewType,
            appIds: appIds.join()
        });
    };

});


parcelRegister("ke5CN", function(module, exports) {

$parcel$export(module.exports, "changesReadyToApply", () => $714ec2685b8970cc$export$b1a7d72d393d2d4b);
const $714ec2685b8970cc$export$b1a7d72d393d2d4b = (bufferForChangeId)=>{
    const appsReady = Object.values(bufferForChangeId).filter((fieldsChanges)=>fieldsChanges !== null);
    return appsReady.length === Object.keys(bufferForChangeId).length;
};

});

parcelRegister("fxgW1", function(module, exports) {

$parcel$export(module.exports, "handleBufferAllAppsError", () => $d5c00fb5ba986881$export$8b3b1eb4f3cdfb5f);

var $h1jSL = parcelRequire("h1jSL");

var $8ibkc = parcelRequire("8ibkc");

var $7mVyC = parcelRequire("7mVyC");

var $4QLO7 = parcelRequire("4QLO7");

var $9V8vn = parcelRequire("9V8vn");

var $lpNv8 = parcelRequire("lpNv8");
const $d5c00fb5ba986881$export$8b3b1eb4f3cdfb5f = ({ err: err, changeId: changeId, bufferForChangeId: bufferForChangeId })=>({ getState: getState, dispatch: dispatch }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
        const { analyticsData: { issueAdjustmentModulesCount: issueAdjustmentModulesCount, configuredAppsCount: configuredAppsCount, adjustmentsAPILatency: adjustmentsAPILatency } } = getState();
        const appIds = Object.keys(bufferForChangeId);
        dispatch((0, $7mVyC.setError)({
            errorCode: 'APPLY_BUFFER_CHANGES_ERROR'
        }));
        dispatch((0, $4QLO7.unregisterAllFieldsOfChangeId)(changeId));
        dispatch((0, $9V8vn.clearBufferForChangeId)({
            changeId: changeId
        }));
        dispatch((0, $lpNv8.resetBufferErrors)());
        (0, $8ibkc.getAnalytics)(viewType).stopTTI({
            issueAdjustmentModulesCount: issueAdjustmentModulesCount,
            adjustmentsAPILatency: adjustmentsAPILatency,
            configuredAppsCount: configuredAppsCount,
            completionStatus: 'error',
            viewType: viewType,
            appIds: appIds.join()
        });
        (0, $h1jSL.fireUIMErrorAnalytics)({
            error: err,
            id: 'bufferChanges',
            viewType: viewType,
            attributes: {
                errorCause: err?.cause
            },
            event: createAnalyticsEvent({})
        });
    };

});


parcelRegister("5hhPg", function(module, exports) {

$parcel$export(module.exports, "initializeField", () => $4a4217001e2b8280$export$6b51e123e61a9615);

var $2brTl = parcelRequire("2brTl");
const $4a4217001e2b8280$export$6b51e123e61a9615 = ({ field: field, metadata: metadata })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData = {} } = getState();
        const fieldMetadata = {
            allowedValues: field.allowedValues,
            isReadOnlyBySystem: field.isReadOnly,
            isRequiredBySystem: field.isRequired,
            fieldRenderer: metadata?.fieldRenderer,
            fieldType: field.fieldType
        };
        const publicValue = (0, $2brTl.mapFieldValueFromInternalToPublic)({
            fieldMetadata: fieldMetadata,
            internalFieldValue: field.value,
            fieldType: field.fieldType,
            viewType: viewType
        });
        setState({
            formData: {
                ...formData,
                [field.fieldId]: {
                    fieldId: field.fieldId,
                    fieldName: field.fieldName,
                    description: field.description,
                    isVisible: field.isVisible,
                    fieldType: field.fieldType,
                    isReadOnly: field.isReadOnly,
                    isRequired: field.isRequired,
                    value: publicValue,
                    optionsVisibility: undefined
                }
            },
            internalFormMetadata: {
                ...internalFormMetadata,
                [field.fieldId]: fieldMetadata
            }
        });
    };

});
parcelRegister("2brTl", function(module, exports) {

$parcel$export(module.exports, "mapFieldValueFromInternalToPublic", () => $d67d5ad1d534dc24$export$50806045b617d116);

var $h1jSL = parcelRequire("h1jSL");

var $8ibkc = parcelRequire("8ibkc");
const $d67d5ad1d534dc24$export$50806045b617d116 = ({ fieldMetadata: fieldMetadata, internalFieldValue: internalFieldValue, fieldType: fieldType, viewType: viewType })=>{
    if (fieldMetadata === undefined) throw new Error('Attempt to set value for the uninitialized field');
    let value = internalFieldValue;
    try {
        const valueTransformer = (0, $8ibkc.getSupportedFieldConfiguration)(viewType, fieldType)?.internalToPublicTransformers.value;
        if (valueTransformer) /**
			 * We trust that the internal field data is in the correct shape.
			 * Data that is in the incorrect shape will result in error events
			 * being logged for further investigation. In this error case we will
			 * pass `null` as the value to unblock onInit for the apps
			 *
			 * The `fieldRenderer` passed to the `valueTransformer` is used only for
			 * rich text fields and will be `undefined` for most of the executions
			 */ value = valueTransformer(internalFieldValue, fieldMetadata?.fieldRenderer);
    } catch (error) {
        value = null;
        (0, $h1jSL.fireIAErrorAnalytics)({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return value;
};

});


parcelRegister("4BYh6", function(module, exports) {

$parcel$export(module.exports, "initializeScreenTabs", () => $ffd70689a2678058$export$7f7be235f64f029b);
const $ffd70689a2678058$export$7f7be235f64f029b = ({ tabs: tabs, selected: selected })=>({ setState: setState })=>{
        setState({
            screenTabs: tabs.map(({ id: id }, index)=>({
                    id: id,
                    isVisible: true,
                    isActive: index === selected
                }))
        });
    };

});

parcelRegister("5v1Sk", function(module, exports) {

$parcel$export(module.exports, "processChange", () => $c7e1595f1029ad04$export$352dfcce04d66748);

var $d2gyF = parcelRequire("d2gyF");

var $1ybV0 = parcelRequire("1ybV0");

var $8ibkc = parcelRequire("8ibkc");

var $4XxH1 = parcelRequire("4XxH1");
const $c7e1595f1029ad04$export$352dfcce04d66748 = ({ fieldId: fieldId, fieldValue: fieldValue, eventType: eventType, fieldType: fieldType })=>({ setState: setState, getState: getState }, { viewType: viewType })=>{
        const emitChangeOn = (0, $8ibkc.getSupportedFieldConfiguration)(viewType, fieldType)?.emitChangeOn;
        if (emitChangeOn !== eventType) return;
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        const nextFormData = (0, $4XxH1.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        /**
		 * setTimeout justification - we need to delay the state update to the next tick to avoid batched updates.
		 * Otherwise, UIM app may not be notified about every single change.
		 */ setTimeout(()=>{
            const changeId = (0, $1ybV0.ff)('ui-modifications-multi-app-experience_ud4yw') ? (0, (/*@__PURE__*/$parcel$interopDefault($d2gyF)))() : undefined;
            setState({
                lastProcessedChange: {
                    fieldId: fieldId,
                    changeId: changeId
                },
                formData: nextFormData
            });
        }, 0);
    };

});
parcelRegister("d2gyF", function(module, exports) {

var $1uqnh = parcelRequire("1uqnh");
/** Used to generate unique IDs. */ var $97d84e6072626d2c$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $97d84e6072626d2c$var$uniqueId(prefix) {
    var id = ++$97d84e6072626d2c$var$idCounter;
    return $1uqnh(prefix) + id;
}
module.exports = $97d84e6072626d2c$var$uniqueId;

});

parcelRegister("4XxH1", function(module, exports) {

$parcel$export(module.exports, "calculateNextFormValue", () => $895b39e97d23f926$export$25441a03bb8f1cb0);

var $hTLlD = parcelRequire("hTLlD");

var $2brTl = parcelRequire("2brTl");
const $895b39e97d23f926$export$25441a03bb8f1cb0 = ({ internalFormMetadata: internalFormMetadata, formData: formData, fieldId: fieldId, fieldValue: fieldValue, fieldType: fieldType, viewType: viewType })=>{
    if (formData === null) return null;
    const newPublicValue = (0, $2brTl.mapFieldValueFromInternalToPublic)({
        fieldMetadata: internalFormMetadata[fieldId],
        internalFieldValue: fieldValue,
        fieldType: fieldType,
        viewType: viewType
    });
    const currentPublicValue = formData[fieldId]?.value;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(newPublicValue, currentPublicValue)) return null;
    return {
        ...formData,
        [fieldId]: {
            ...formData[fieldId],
            value: newPublicValue
        }
    };
};

});


parcelRegister("doolD", function(module, exports) {

$parcel$export(module.exports, "processIframeChanges", () => $3cc3399376f38c1e$export$35909bac5672434b);

var $h1jSL = parcelRequire("h1jSL");
var $2bv99 = parcelRequire("2bv99");

var $8ibkc = parcelRequire("8ibkc");

var $gIAmp = parcelRequire("gIAmp");

var $fsCiP = parcelRequire("fsCiP");

var $3P2qm = parcelRequire("3P2qm");
parcelRequire("B0Z3S");
var $lpNv8 = parcelRequire("lpNv8");
var $B0Z3S = parcelRequire("B0Z3S");

var $7mVyC = parcelRequire("7mVyC");

var $4QLO7 = parcelRequire("4QLO7");

var $2ugNi = parcelRequire("2ugNi");
const $3cc3399376f38c1e$export$35909bac5672434b = ({ changeId: changeId, fieldsChangesUnnormalized: fieldsChangesUnnormalized, appId: appId, context: context })=>async ({ getState: getState, dispatch: dispatch }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
        const { buffer: buffer, analyticsData: analyticsData } = getState();
        const { cloudId: cloudId, activationId: activationId, issueId: issueId, transitionId: transitionId, environment: environment, getAsyncLookupData: getAsyncLookupData, getFilteredFieldChangesBasedOnScope: getFilteredFieldChangesBasedOnScope, getValidatedFieldsChanges: getValidatedFieldsChanges } = context;
        const { issueAdjustmentModulesCount: issueAdjustmentModulesCount, configuredAppsCount: configuredAppsCount, adjustmentsAPILatency: adjustmentsAPILatency } = analyticsData;
        const bufferForChangeId = buffer[changeId] || {};
        const shouldBufferChanges = Object.prototype.hasOwnProperty.call(bufferForChangeId, appId);
        try {
            const fieldsChanges = getFilteredFieldChangesBasedOnScope(fieldsChangesUnnormalized);
            const validatedFieldsChanges = await getValidatedFieldsChanges(fieldsChanges);
            if (shouldBufferChanges) {
                await dispatch((0, $B0Z3S.bufferChanges)({
                    changeId: changeId,
                    appId: appId,
                    fieldsChanges: fieldsChanges,
                    context: context
                }));
                return;
            }
            const lookupDataFromApi = await getAsyncLookupData(validatedFieldsChanges);
            await dispatch((0, $2ugNi.updateFields)({
                changeId: changeId,
                fieldsChanges: fieldsChanges,
                lookupDataFromApi: lookupDataFromApi,
                tenantContext: {
                    cloudId: cloudId,
                    activationId: activationId
                },
                viewContext: {
                    issueId: issueId,
                    transitionId: transitionId
                },
                environment: environment,
                appId: appId
            }));
            (0, $8ibkc.getAnalytics)(viewType).stopTTI({
                issueAdjustmentModulesCount: issueAdjustmentModulesCount,
                adjustmentsAPILatency: adjustmentsAPILatency,
                configuredAppsCount: configuredAppsCount,
                completionStatus: 'success',
                viewType: viewType,
                appIds: appId
            });
            (0, $gIAmp.fireIATrackAnalytics)(createAnalyticsEvent({}), 'jiraUiModificationsUseSubmit success', viewType, {
                issueAdjustmentModulesCount: issueAdjustmentModulesCount,
                configuredAppsCount: configuredAppsCount
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            dispatch((0, $7mVyC.setError)({
                errorCode: 'USE_SUBMIT_ERROR_CODE'
            }));
            if (shouldBufferChanges) {
                dispatch((0, $lpNv8.addBufferError)('USE_SUBMIT_ERROR_CODE'));
                dispatch((0, $4QLO7.unregisterFields)({
                    changeId: changeId,
                    appId: appId
                }));
            }
            (0, $8ibkc.getAnalytics)(viewType).stopTTI({
                issueAdjustmentModulesCount: issueAdjustmentModulesCount,
                adjustmentsAPILatency: adjustmentsAPILatency,
                configuredAppsCount: configuredAppsCount,
                completionStatus: 'error',
                viewType: viewType,
                appIds: appId
            });
            if (err instanceof (0, $fsCiP.UiModificationsFieldsValidationError)) {
                (0, $2bv99.fireOperationalAnalyticsWithContext)(createAnalyticsEvent({}), 'fieldsChangesValidation failed', viewType, {
                    ...err.attributes
                });
                // Setting app errors from validators to pass them to the onErrorCallback
                dispatch((0, $3P2qm.setAppErrors)({
                    errors: err.attributes.errors,
                    appId: appId
                }));
                return;
            }
            (0, $h1jSL.fireIAErrorAnalytics)({
                error: err,
                id: 'useSubmit',
                viewType: viewType,
                attributes: {
                    errorCause: err?.cause
                },
                event: createAnalyticsEvent({})
            });
        } finally{
            // in case of successful addition of changes to the buffer, we don't want to remove loading state on fields yet
            if (!shouldBufferChanges) dispatch((0, $4QLO7.unregisterFields)({
                changeId: changeId,
                appId: appId
            }));
        }
    };

});
parcelRegister("gIAmp", function(module, exports) {

$parcel$export(module.exports, "fireIATrackAnalytics", () => $af484da6b5020068$export$5014f9ce18c21b09);

var $jMP2a = parcelRequire("jMP2a");

var $7vcoF = parcelRequire("7vcoF");
const $af484da6b5020068$export$5014f9ce18c21b09 = (event, id, viewType, attributes = {})=>{
    const prefix = (0, $7vcoF.supportedViews)[viewType] ? viewType : '';
    (0, $jMP2a.fireTrackAnalytics)(event, `${prefix}${id}`, attributes);
};

});


parcelRegister("gwHjs", function(module, exports) {

$parcel$export(module.exports, "setFieldValue", () => $e9fd5dd289ce7424$export$6556d46d2662453c);

var $4XxH1 = parcelRequire("4XxH1");
const $e9fd5dd289ce7424$export$6556d46d2662453c = ({ fieldId: fieldId, fieldType: fieldType, fieldValue: fieldValue })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        /**
		 * We can set new field value only if the field was initialized.
		 * This checks the field metedata that indicates the successfull initialization.
		 */ if (!internalFormMetadata[fieldId]) return;
        const nextFormData = (0, $4XxH1.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        setState({
            formData: nextFormData
        });
    };

});

parcelRegister("juRVB", function(module, exports) {

$parcel$export(module.exports, "startFieldsInitialisationTimeout", () => $ef2c7adb6b78931a$export$2c0f020b89dfa30b);
$parcel$export(module.exports, "successFieldsInitalisation", () => $ef2c7adb6b78931a$export$cf768a695e83eefa);

var $1ybV0 = parcelRequire("1ybV0");

var $2bv99 = parcelRequire("2bv99");

var $3UFcS = parcelRequire("3UFcS");

var $7mVyC = parcelRequire("7mVyC");
const $ef2c7adb6b78931a$var$getTimeout = ()=>(0, $1ybV0.getFeatureFlagValue)('forge-ui-modifications-fields-initialization-timeout', 15000);
const $ef2c7adb6b78931a$var$getFieldsInitializationTime = (startTime)=>startTime !== null ? performance.now() - startTime : null;
const $ef2c7adb6b78931a$var$isFieldInitialisationComplete = (status)=>status === 'success' || status === 'timedOut';
const $ef2c7adb6b78931a$export$2c0f020b89dfa30b = ()=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { fieldsInitialization: fieldsInitialization } = getState();
        if (fieldsInitialization.timeoutId === undefined && fieldsInitialization.status === 'notStarted') {
            const timeoutId = setTimeout(()=>dispatch($ef2c7adb6b78931a$export$8ce83a9201590a5e()), $ef2c7adb6b78931a$var$getTimeout());
            setState({
                fieldsInitialization: {
                    startTime: performance.now(),
                    timeoutId: timeoutId,
                    status: 'inProgress'
                }
            });
        }
    };
const $ef2c7adb6b78931a$export$8ce83a9201590a5e = ()=>({ getState: getState, setState: setState, dispatch: dispatch }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
        const { formData: formData, experienceDataIsLoading: experienceDataIsLoading, numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { startTime: startTime, status: status } = fieldsInitialization;
        if ($ef2c7adb6b78931a$var$isFieldInitialisationComplete(status) || ((0, $1ybV0.ff)('forge-ui-modifications-screentabs_qoa33') ? (0, $3UFcS.selectReadyPublicDataForOnInit)(getState(), {
            viewType: viewType
        }) !== null : (0, $3UFcS.selectReadyFieldsOld)(getState(), undefined) !== null)) return;
        dispatch((0, $7mVyC.setError)({
            errorCode: 'ON_INIT_FIELDS_INITIALIZATION_TIMEOUT'
        }));
        (0, $2bv99.fireOperationalAnalyticsWithContext)(createAnalyticsEvent({}), 'fieldsInitialization timedOut', viewType, {
            previousStatus: status,
            configuredTimeout: $ef2c7adb6b78931a$var$getTimeout(),
            fieldsInitializationTime: $ef2c7adb6b78931a$var$getFieldsInitializationTime(startTime),
            initalizedFieldsCount: Object.keys(formData ?? {}).length,
            experienceDataIsLoading: experienceDataIsLoading,
            supportedFieldsCount: numberOfSupportedFields
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'timedOut'
            }
        });
    };
const $ef2c7adb6b78931a$export$cf768a695e83eefa = ()=>({ getState: getState, setState: setState }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
        const { status: status } = getState().fieldsInitialization;
        if ($ef2c7adb6b78931a$var$isFieldInitialisationComplete(status)) return;
        const { numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { timeoutId: timeoutId, startTime: startTime } = fieldsInitialization;
        clearTimeout(timeoutId);
        (0, $2bv99.fireOperationalAnalyticsWithContext)(createAnalyticsEvent({}), 'fieldsInitialization success', viewType, {
            previousStatus: status,
            fieldsInitializationTime: $ef2c7adb6b78931a$var$getFieldsInitializationTime(startTime),
            initalizedFieldsCount: numberOfSupportedFields
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'success'
            }
        });
    };

});
parcelRegister("3UFcS", function(module, exports) {

$parcel$export(module.exports, "selectReadyFieldsOld", () => $c53e858e46a423f2$export$8f4fb114be4d807);
$parcel$export(module.exports, "selectReadyPublicDataForOnInit", () => $c53e858e46a423f2$export$4cadeedb8c3f31f7);

var $bj4JM = parcelRequire("bj4JM");

var $8ibkc = parcelRequire("8ibkc");
const $c53e858e46a423f2$export$8f4fb114be4d807 = (0, $bj4JM.createSelector)((state)=>state.formData, (state)=>state.numberOfSupportedFields, (state)=>state.experienceDataIsLoading, (formData, numberOfSupportedFields, experienceDataIsLoading)=>{
    if (formData !== null && numberOfSupportedFields !== 0 && experienceDataIsLoading === false && Object.keys(formData).length === numberOfSupportedFields) return formData;
    return null;
});
const $c53e858e46a423f2$export$4cadeedb8c3f31f7 = (0, $bj4JM.createSelector)((_, props)=>props.viewType, (state)=>state.formData, (state)=>state.numberOfSupportedFields, (state)=>state.screenTabs, (state)=>state.experienceDataIsLoading, (viewType, formData, numberOfSupportedFields, screenTabsData, experienceDataIsLoading)=>{
    if (formData !== null && !(0, $8ibkc.isScreenTabsSupportEnabled)(viewType) && numberOfSupportedFields !== 0 && experienceDataIsLoading === false && Object.keys(formData).length === numberOfSupportedFields) return {
        formData: formData,
        screenTabsData: []
    };
    if (formData !== null && screenTabsData !== null && (0, $8ibkc.isScreenTabsSupportEnabled)(viewType) && numberOfSupportedFields !== 0 && experienceDataIsLoading === false && Object.keys(formData).length === numberOfSupportedFields) return {
        formData: formData,
        screenTabsData: screenTabsData
    };
    return null;
});

});


parcelRegister("cQ3jb", function(module, exports) {

$parcel$export(module.exports, "updateActiveScreenTab", () => $ca2372258451375d$export$21363496760d39cd);
const $ca2372258451375d$export$21363496760d39cd = ({ selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: screenTabs } = getState();
        if (screenTabs) setState({
            screenTabs: screenTabs.map((tab, index)=>({
                    ...tab,
                    isActive: index === selected
                }))
        });
    };

});

parcelRegister("51sNT", function(module, exports) {

$parcel$export(module.exports, "updateScreenTabs", () => $1b694249b98b7d22$export$131c67fd312b8a11);

var $2bv99 = parcelRequire("2bv99");

var $250Jk = parcelRequire("250Jk");

var $hHma7 = parcelRequire("hHma7");

var $3P2qm = parcelRequire("3P2qm");
const $1b694249b98b7d22$export$131c67fd312b8a11 = ({ screenTabsChanges: screenTabsFromIframe, appId: appId })=>({ getState: getState, setState: setState, dispatch: dispatch }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
        const { screenTabs: internalScreenTabs } = getState();
        try {
            if (screenTabsFromIframe && internalScreenTabs && (0, $250Jk.screenTabsPublicToInternalValidator)(screenTabsFromIframe, internalScreenTabs)) setState({
                screenTabs: (0, $250Jk.screenTabsPublicToInternalTransformer)(screenTabsFromIframe, internalScreenTabs)
            });
            else throw new (0, $hHma7.UiModificationsScreenTabsValidationError)('Transformation failed', {
                errors: [
                    {
                        type: (0, $hHma7.SCREENTAB_VALIDATION_ERROR),
                        message: 'Transformation failed'
                    }
                ]
            });
        } catch (err) {
            if (err instanceof (0, $hHma7.UiModificationsScreenTabsValidationError)) {
                (0, $2bv99.fireOperationalAnalyticsWithContext)(createAnalyticsEvent({}), 'screenTabsChangesValidation failed', viewType, {
                    ...err.attributes
                });
                // Setting app errors from validators to pass them to the onErrorCallback
                dispatch((0, $3P2qm.setAppErrors)({
                    errors: err.attributes.errors,
                    appId: appId
                }));
            }
        }
    };

});
parcelRegister("250Jk", function(module, exports) {

$parcel$export(module.exports, "screenTabsPublicToInternalTransformer", () => $84a538ddabf922c3$export$9ca9b35e7b6a8bbc);
$parcel$export(module.exports, "screenTabsPublicToInternalValidator", () => $84a538ddabf922c3$export$e7a91e7e430e691a);

var $8xPow = parcelRequire("8xPow");
const $84a538ddabf922c3$var$isValidScreenTabId = (id, internalScreenTabs)=>(0, $8xPow.isNotEmptyString)(id) && internalScreenTabs.find((tab)=>tab.id === id) !== undefined;
const $84a538ddabf922c3$var$isValidScreenTabIsVisible = (isVisible)=>typeof isVisible === 'boolean' || typeof isVisible === 'undefined';
const $84a538ddabf922c3$var$isValidScreenTabIsActive = (isActive)=>typeof isActive === 'boolean' || typeof isActive === 'undefined';
const $84a538ddabf922c3$export$9ca9b35e7b6a8bbc = (screenTabsFromApp, screenTabsInternal)=>{
    let numberOfActiveScreenTabs = 0;
    const internalActiveScreenTabIndex = screenTabsInternal.findIndex((tab)=>tab.isActive === true);
    const screenTabsInternalUpdated = screenTabsInternal.map((screenTabInternal)=>{
        const screenTabFromApp = screenTabsFromApp.find((tab)=>tab.id === screenTabInternal.id);
        if (!screenTabFromApp) return screenTabInternal;
        numberOfActiveScreenTabs += screenTabFromApp.isActive === true ? 1 : 0;
        return {
            id: screenTabInternal.id,
            isVisible: screenTabFromApp.isVisible ?? true,
            isActive: screenTabFromApp.isActive
        };
    });
    // if no active tab is specified. default to the first.
    if (numberOfActiveScreenTabs === 0 && internalActiveScreenTabIndex === -1 && typeof screenTabsInternalUpdated[0]?.isActive !== 'undefined') screenTabsInternalUpdated[0].isActive = true;
    return screenTabsInternalUpdated;
};
const $84a538ddabf922c3$export$e7a91e7e430e691a = (screenTabsFromApp, screenTabsInternal)=>{
    let numberOfActiveScreenTabs = 0;
    if (!Array.isArray(screenTabsFromApp)) return false;
    const screenTabsFromAppFiltered = screenTabsFromApp.filter(({ id: id, isVisible: isVisible, isActive: isActive })=>{
        const isValidScreenTab = $84a538ddabf922c3$var$isValidScreenTabId(id, screenTabsInternal) && $84a538ddabf922c3$var$isValidScreenTabIsVisible(isVisible) && $84a538ddabf922c3$var$isValidScreenTabIsActive(isActive);
        numberOfActiveScreenTabs += isActive ? 1 : 0;
        return isValidScreenTab;
    });
    return numberOfActiveScreenTabs <= 1 && screenTabsFromApp.length === screenTabsFromAppFiltered.length;
};

});

parcelRegister("hHma7", function(module, exports) {

$parcel$export(module.exports, "SCREENTAB_VALIDATION_ERROR", () => $3824179c819605a1$export$7905b8899a324e90);
$parcel$export(module.exports, "UiModificationsScreenTabsValidationError", () => $3824179c819605a1$export$faf1f1824ee0a136);
const $3824179c819605a1$export$7905b8899a324e90 = 'SCREENTAB_VALIDATION_FAILED';
class $3824179c819605a1$export$faf1f1824ee0a136 extends Error {
    constructor(message, attributes, cause){
        super(message, cause);
        this.attributes = attributes;
    }
}

});






parcelRegister("bbsDx", function(module, exports) {

$parcel$export(module.exports, "UiModificationsEntryPoint", () => $bd19f18f8fda167e$export$c89b83ae4e6840b3);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $eTZsp = parcelRequire("eTZsp");

var $fryuC = parcelRequire("fryuC");
parcelRequire("fryuC");
var $aBj0i = parcelRequire("aBj0i");

var $lO4Or = parcelRequire("lO4Or");

var $bKI0B = parcelRequire("bKI0B");

var $3t2Ya = parcelRequire("3t2Ya");
const $bd19f18f8fda167e$export$c89b83ae4e6840b3 = ({ issueTypeFieldType: issueTypeFieldType, modules: modules, modalFieldConfig: modalFieldConfig, resetFormFieldsCounter: resetFormFieldsCounter, selectedIssueType: selectedIssueType, selectedProject: selectedProject, triggerPointKey: triggerPointKey })=>{
    const issueAdjustmentsContext = (0, $eUqFw.useMemo)(()=>{
        if (selectedProject && selectedIssueType) return {
            project: {
                id: selectedProject.value,
                key: selectedProject.projectKey,
                type: selectedProject.projectType,
                isSimplified: selectedProject.isSimplified
            },
            issueType: {
                id: selectedIssueType.value,
                name: selectedIssueType.label
            }
        };
        return null;
    }, [
        selectedIssueType,
        selectedProject
    ]);
    const runtimeProps = (0, $eUqFw.useMemo)(()=>({
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            issueAdjustmentsContext: issueAdjustmentsContext,
            fieldsCount: (0, $3t2Ya.getSupportedFieldsCount)({
                ...modalFieldConfig,
                [(0, $lO4Or.ISSUE_TYPE)]: {
                    fieldType: issueTypeFieldType
                }
            }),
            viewType: (0, $bKI0B.GIC_VIEW_TYPE),
            resetFormFieldsCounter: resetFormFieldsCounter,
            modules: modules
        }), [
        issueAdjustmentsContext,
        issueTypeFieldType,
        modalFieldConfig,
        modules,
        resetFormFieldsCounter
    ]);
    if (!issueAdjustmentsContext) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "uiModifications",
        packageName: "jiraUiModificationsViewGic",
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aBj0i.IssueAdjustmentsErrorHandler), null),
        attributes: (error)=>({
                errorType: (0, $eTZsp.getErrorType)(error),
                viewType: (0, $bKI0B.GIC_VIEW_TYPE)
            }),
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fryuC.IssueAdjustmentsAsync), {
        containerId: "uiModifications",
        containerPackageName: "jiraUiModificationsViewGic",
        runtimeProps: runtimeProps,
        triggerPointKey: triggerPointKey
    }));
};

});
parcelRegister("fryuC", function(module, exports) {

$parcel$export(module.exports, "IssueAdjustmentsAsync", () => $f953aa38eb604f8e$export$e2efea28577ab138);
$parcel$export(module.exports, "IssueAdjustmentsErrorHandler", () => (parcelRequire("aBj0i")).IssueAdjustmentsErrorHandler);

var $eUqFw = parcelRequire("eUqFw");

var $aw5Sy = parcelRequire("aw5Sy");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $1ybV0 = parcelRequire("1ybV0");

var $eTZsp = parcelRequire("eTZsp");

var $8ibkc = parcelRequire("8ibkc");

var $ig7wC = parcelRequire("ig7wC");

var $aiUya = parcelRequire("aiUya");

var $aBj0i = parcelRequire("aBj0i");

const $f953aa38eb604f8e$export$84b9ffa7ecdfad72 = ()=>()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aBj0i.IssueAdjustmentsErrorHandler), null);
const $f953aa38eb604f8e$var$STABLE_EMPTY_OBJECT = {};
const $f953aa38eb604f8e$export$e2efea28577ab138 = ({ containerId: containerId, containerPackageName: containerPackageName, runtimeProps: runtimeProps, triggerPointKey: triggerPointKey, errorFallback: errorFallback })=>{
    const { issueAdjustmentsContext: issueAdjustmentsContext, modules: modules, viewType: viewType } = runtimeProps;
    const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions } = (0, $6j4bv.useEntryPoint)((0, $aiUya.issueAdjustmentsEntryPoint), $f953aa38eb604f8e$var$STABLE_EMPTY_OBJECT);
    const { setShouldUiModificationsLoad: setShouldUiModificationsLoad } = (0, $ig7wC.useAdjustmentsContextActions)();
    const defaultErrorFallback = $f953aa38eb604f8e$export$84b9ffa7ecdfad72();
    const hasUiModificationsLoaded = (0, $eUqFw.useRef)(false);
    // NOTE: This killswitch flag can be enabled in an incident to prevent UI modifications from loading
    const shouldUiModificationsLoad = // NOTE: this is configured as a permanent flag that defaults to "false" for all users. It will never be "rolled out".
    // In an incident the default rule in Launch Darkly can be set to "true" to skip mounting the IssueAdjustmentsAsync component.
    // This will stop calls to the internal UI modifications endpoint, reducing load on services like cs-extensions
    // https://app.launchdarkly.com/jira/production/features/killswitch-turn-off-forge-ui-modifications-in-jira/targeting
    !(0, $1ybV0.ff)('killswitch-turn-off-forge-ui-modifications-in-jira', false) && modules?.length > 0 && (0, $8ibkc.isTriggerPointSupported)(viewType, triggerPointKey) && (0, $8ibkc.isProjectTypeSupported)(issueAdjustmentsContext.project, viewType);
    (0, $eUqFw.useEffect)(()=>{
        const hasProjectAndIssueTypeFinishedLoading = issueAdjustmentsContext !== null;
        // issueAdjustmentContext starts out as null so we need to wait until it is populated
        // to know if UI modifications should load or not in this project type.
        // issueAdjustmentContext needs to be a dependency not hasProjectAndIssueTypeFinishedLoading
        // otherwise we don't set the supported status when changing issue types only
        if (hasProjectAndIssueTypeFinishedLoading) setShouldUiModificationsLoad(shouldUiModificationsLoad ? 'yes' : 'no');
        if (shouldUiModificationsLoad && !hasUiModificationsLoaded.current) {
            entryPointActions.load();
            hasUiModificationsLoaded.current = true;
        }
    }, [
        issueAdjustmentsContext,
        shouldUiModificationsLoad,
        setShouldUiModificationsLoad,
        entryPointActions
    ]);
    if (shouldUiModificationsLoad) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
        data: {
            attributes: {
                triggerPointKey: triggerPointKey
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: containerId,
        packageName: containerPackageName,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null),
        errorFallback: errorFallback || defaultErrorFallback,
        errorAttributes: (error)=>({
                errorType: (0, $eTZsp.getErrorType)(error),
                viewType: runtimeProps.viewType
            }),
        runtimeProps: runtimeProps
    }));
    return null;
};

});
parcelRegister("aiUya", function(module, exports) {

$parcel$export(module.exports, "issueAdjustmentsEntryPoint", () => $3e8be9ec96721d55$export$4e091e70f9620cd8);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $3e8be9ec96721d55$export$4e091e70f9620cd8 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("70rVI")), {
        moduleId: "45466920"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("70rVI", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('LKiko');
        const value = parcelRequire('kmAfp');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("LKiko").then(()=>parcelRequire('kmAfp'));
}

});


parcelRegister("aBj0i", function(module, exports) {

$parcel$export(module.exports, "IssueAdjustmentsErrorHandler", () => $3ed727681dfad4c2$export$68b86a282e98ff70);

var $eUqFw = parcelRequire("eUqFw");

var $fcNlw = parcelRequire("fcNlw");
const $3ed727681dfad4c2$export$68b86a282e98ff70 = ()=>{
    const { setError: setError, resetError: resetError } = (0, $fcNlw.useIssueAdjustmentsActions)();
    (0, $eUqFw.useEffect)(()=>{
        setError({
            errorCode: 'ERROR_BOUNDARY_HANDLER_ERROR_CODE'
        });
        return ()=>resetError();
    }, [
        setError,
        resetError
    ]);
    return null;
};

});


parcelRegister("3t2Ya", function(module, exports) {

$parcel$export(module.exports, "getSupportedFieldsCount", () => $9c08951a7d7a9737$export$11f15170229125b6);

var $bKI0B = parcelRequire("bKI0B");

var $8ibkc = parcelRequire("8ibkc");
const $9c08951a7d7a9737$export$11f15170229125b6 = (fields)=>{
    if (!fields) return 0;
    return Object.values(fields).filter(({ fieldType: fieldType })=>(0, $8ibkc.isFieldTypeSupported)((0, $bKI0B.GIC_VIEW_TYPE), fieldType)).length;
};

});


parcelRegister("aqi5n", function(module, exports) {

$parcel$export(module.exports, "scrollToElement", () => $ca31c6caf382650d$export$2353115f31f4d15);
$parcel$export(module.exports, "preventEscKeyPropagationKeyPressHandler", () => $ca31c6caf382650d$export$feb08457bf70a411);
$parcel$export(module.exports, "scrollToField", () => $ca31c6caf382650d$export$a3f522e44642cd81);

var $k7cZh = parcelRequire("k7cZh");

var $dEMIg = parcelRequire("dEMIg");

var $5Tzd9 = parcelRequire("5Tzd9");

var $jK8t4 = parcelRequire("jK8t4");


var $5vWUc = parcelRequire("5vWUc");

var $j2Myn = parcelRequire("j2Myn");
const $ca31c6caf382650d$export$2353115f31f4d15 = (elementId)=>{
    const fieldRef = document.getElementById(elementId);
    if (fieldRef) (0, $k7cZh.default)(fieldRef, (0, $dEMIg.DEFAULT_SCROLL_OPTIONS));
};
const $ca31c6caf382650d$export$feb08457bf70a411 = (event)=>{
    if (event?.keyCode === (0, $jK8t4.ESC_KEY_KEYCODE)) event?.nativeEvent?.stopImmediatePropagation();
};
const $ca31c6caf382650d$export$a3f522e44642cd81 = (fieldId)=>{
    const fieldWithErrorRef = document.getElementById((0, $5Tzd9.getFieldContainerId)(fieldId));
    if (fieldWithErrorRef) (0, $k7cZh.default)(fieldWithErrorRef, (0, $dEMIg.DEFAULT_SCROLL_OPTIONS));
};

});
parcelRegister("5Tzd9", function(module, exports) {

$parcel$export(module.exports, "getFieldContainerId", () => $997cb5a9e601e254$export$10904a5319f8077);


var $lIor1 = parcelRequire("lIor1");

var $7TaJX = parcelRequire("7TaJX");

var $dRkzf = parcelRequire("dRkzf");

var $5OZ28 = parcelRequire("5OZ28");

var $4r5oC = parcelRequire("4r5oC");

var $kOu8r = parcelRequire("kOu8r");

var $5VJL3 = parcelRequire("5VJL3");

var $fFvAc = parcelRequire("fFvAc");
const $997cb5a9e601e254$export$10904a5319f8077 = (fieldId)=>`${fieldId}-container`;

});
parcelRegister("lIor1", function(module, exports) {

$parcel$export(module.exports, "validateString", () => $e73e6bfff42de9c2$export$d7b0a588f685ba7e);
$parcel$export(module.exports, "validateSelectField", () => $e73e6bfff42de9c2$export$53ded7ceec493f10);
$parcel$export(module.exports, "validateCascadingSelectField", () => $e73e6bfff42de9c2$export$837294b8fc732f20);
$parcel$export(module.exports, "validateAssigneeField", () => $e73e6bfff42de9c2$export$dd17aabe3f77b2ba);
$parcel$export(module.exports, "validateUserPickerField", () => $e73e6bfff42de9c2$export$356346770aab95cb);
$parcel$export(module.exports, "validateCheckboxField", () => $e73e6bfff42de9c2$export$7aa5e0976d0c384b);
$parcel$export(module.exports, "validateComponentField", () => $e73e6bfff42de9c2$export$89943b0814df306d);
$parcel$export(module.exports, "validateCustomTeamsField", () => $e73e6bfff42de9c2$export$364ea91bee38a994);
$parcel$export(module.exports, "validateGroupPickerField", () => $e73e6bfff42de9c2$export$c6d4785f3f46f73a);
$parcel$export(module.exports, "validateMultiVersionsField", () => $e73e6bfff42de9c2$export$727e23f536334715);
$parcel$export(module.exports, "validateOrganizationsField", () => $e73e6bfff42de9c2$export$b97bb8e170430af8);
$parcel$export(module.exports, "validatePriorityField", () => $e73e6bfff42de9c2$export$17fd881b060187f7);
$parcel$export(module.exports, "validateRadioSelectField", () => $e73e6bfff42de9c2$export$f69029476f9179b);
$parcel$export(module.exports, "validateRadioGroupField", () => $e73e6bfff42de9c2$export$d60dcaa093bca71d);
$parcel$export(module.exports, "validateResolutionField", () => $e73e6bfff42de9c2$export$316feff8e636f81f);
$parcel$export(module.exports, "validateSingleVersionField", () => $e73e6bfff42de9c2$export$45f7908dc93110fb);
$parcel$export(module.exports, "validateLabelField", () => $e73e6bfff42de9c2$export$1a8caa895b9fda26);
$parcel$export(module.exports, "validateForgeLabelField", () => $e73e6bfff42de9c2$export$bf4287ae453e2aab);
// @ts-expect-error - TS2614 - Module '"@atlaskit/user-picker"' has no exported member 'LegacyValue'. Did you mean to use 'import LegacyValue from "@atlaskit/user-picker"' instead?

var $dEMIg = parcelRequire("dEMIg");

// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
const $e73e6bfff42de9c2$export$d7b0a588f685ba7e = (value, isRequired, type)=>{
    if (isRequired && !value?.trim?.()) return 0, $dEMIg.REQUIRED;
    if (typeof value === 'string' && type === 'text' && value?.length > (0, $a8a1251974a60726$export$fe1a70381f6491b5)) return 0, $a8a1251974a60726$export$618e922e89e8bcae;
    return undefined;
};
const $e73e6bfff42de9c2$export$53ded7ceec493f10 = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $dEMIg.REQUIRED;
        if (Array.isArray(value) && !value.length) return 0, $dEMIg.REQUIRED;
    }
    return undefined;
};
const $e73e6bfff42de9c2$export$837294b8fc732f20 = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $dEMIg.REQUIRED;
    }
    return undefined;
};
const $e73e6bfff42de9c2$export$dd17aabe3f77b2ba = (value, isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $dEMIg.REQUIRED;
        if (Array.isArray(value) && !value.length) return 0, $dEMIg.REQUIRED;
    }
    return undefined;
};
const $e73e6bfff42de9c2$export$356346770aab95cb = (value, isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $dEMIg.REQUIRED;
        if (Array.isArray(value) && !value.length) return 0, $dEMIg.REQUIRED;
    }
    return undefined;
};
// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
const $e73e6bfff42de9c2$export$7aa5e0976d0c384b = (value, isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $dEMIg.REQUIRED;
        if (Array.isArray(value) && !value.length) return 0, $dEMIg.REQUIRED;
    }
    return undefined;
};
// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
const $e73e6bfff42de9c2$export$89943b0814df306d = (value, isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $dEMIg.REQUIRED;
        if (Array.isArray(value) && !value.length) return 0, $dEMIg.REQUIRED;
    }
    return undefined;
};
const $e73e6bfff42de9c2$export$364ea91bee38a994 = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $dEMIg.REQUIRED;
    }
    return undefined;
};
const $e73e6bfff42de9c2$export$c6d4785f3f46f73a = (value, isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $dEMIg.REQUIRED;
        if (Array.isArray(value) && !value.length) return 0, $dEMIg.REQUIRED;
    }
    return undefined;
};
const $e73e6bfff42de9c2$export$727e23f536334715 = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $dEMIg.REQUIRED;
        if (!value.length) return 0, $dEMIg.REQUIRED;
    }
    return undefined;
};
const $e73e6bfff42de9c2$export$b97bb8e170430af8 = (data, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!data) return 0, $dEMIg.REQUIRED;
        if (Array.isArray(data) && !data.length) return 0, $dEMIg.REQUIRED;
    }
    return undefined;
};
// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
const $e73e6bfff42de9c2$export$17fd881b060187f7 = (data, isRequired)=>{
    if (isRequired && !data) return 0, $dEMIg.REQUIRED;
    return undefined;
};
// @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
const $e73e6bfff42de9c2$export$f69029476f9179b = (data, isRequired)=>{
    if (isRequired && !data) return 0, $dEMIg.REQUIRED;
    return undefined;
};
const $e73e6bfff42de9c2$export$d60dcaa093bca71d = (data, isRequired)=>{
    if (isRequired && !data) return 0, $dEMIg.REQUIRED;
    return undefined;
};
const $e73e6bfff42de9c2$export$316feff8e636f81f = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $dEMIg.REQUIRED;
    }
    return undefined;
};
const $e73e6bfff42de9c2$export$45f7908dc93110fb = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $dEMIg.REQUIRED;
    }
    return undefined;
};
const $e73e6bfff42de9c2$export$1a8caa895b9fda26 = (labels, isRequired)=>{
    if (isRequired) {
        if (!labels) return 0, $dEMIg.REQUIRED;
        if (Array.isArray(labels) && !labels.length) return 0, $dEMIg.REQUIRED;
    }
    if (labels && labels?.length > (0, $a8a1251974a60726$export$1fdf850c93de8bae)) return 0, $a8a1251974a60726$export$fd7dfa1695d325ca;
    if (labels && labels.map((label)=>label.value.trim()).some((value)=>value.includes(' ') || value.length > (0, $a8a1251974a60726$export$9151073f92820ff8))) return 0, $a8a1251974a60726$export$e77d629cc732976d;
    return undefined;
};
const $e73e6bfff42de9c2$export$bf4287ae453e2aab = (labels, isRequired)=>{
    if (isRequired) {
        if (!labels) return 0, $dEMIg.REQUIRED;
        if (Array.isArray(labels) && !labels.length) return 0, $dEMIg.REQUIRED;
    }
    if (labels && labels?.length > (0, $a8a1251974a60726$export$1fdf850c93de8bae)) return 0, $a8a1251974a60726$export$fd7dfa1695d325ca;
    if (labels && labels.map((label)=>label.value.trim()).some((value)=>value.length > (0, $a8a1251974a60726$export$9151073f92820ff8))) return 0, $a8a1251974a60726$export$8d30d41a8828e14f;
    return undefined;
};

});
const $a8a1251974a60726$export$9151073f92820ff8 = 255;
const $a8a1251974a60726$export$fe1a70381f6491b5 = 255;
const $a8a1251974a60726$export$1fdf850c93de8bae = 55;
const $a8a1251974a60726$export$fd7dfa1695d325ca = 'MAX ALLOWED LABELS';
const $a8a1251974a60726$export$e77d629cc732976d = 'LABELS INVALID';
const $a8a1251974a60726$export$8d30d41a8828e14f = 'FORGE LABELS INVALID';
const $a8a1251974a60726$export$618e922e89e8bcae = 'STRING_INVALID';


parcelRegister("7TaJX", function(module, exports) {

$parcel$export(module.exports, "ISSUE_CREATE_MODAL_BODY_SELECTOR", () => $908859f4f2da1f9d$export$7c7171667037b275);
$parcel$export(module.exports, "closeMenuOnScroll", () => $908859f4f2da1f9d$export$fe334d83c6aac80f);
// keeping it here instead of jira-issue-create to avoid cyclic dependencies.
const $908859f4f2da1f9d$export$7c7171667037b275 = 'issue-create.ui.modal.modal-body';
const $908859f4f2da1f9d$var$MENU_CLOSE_SELECTORS = [
    $908859f4f2da1f9d$export$7c7171667037b275
];
const $908859f4f2da1f9d$export$fe334d83c6aac80f = (e)=>{
    // @ts-expect-error - TS18047 -  'e.target' is possibly 'null'.
    if ($908859f4f2da1f9d$var$MENU_CLOSE_SELECTORS.includes(e.target.id)) return true;
    return false;
};

});

parcelRegister("dRkzf", function(module, exports) {

$parcel$export(module.exports, "handleApolloError", () => $294efd9e23b94cc4$export$31b755cdc25616f2);
const $294efd9e23b94cc4$export$31b755cdc25616f2 = (error)=>{
    let errorType = 'unknown';
    if (error.networkError != null) errorType = 'networkError';
    else if (error.graphQLErrors && error.graphQLErrors.length > 0) errorType = 'graphQLError';
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'ErrorType'.
    return errorType;
};

});

parcelRegister("5OZ28", function(module, exports) {

$parcel$export(module.exports, "preventFormSubmitOnEnterKeyPress", () => $2db6999e0646d640$export$9d2267fe165de4b6);
const $2db6999e0646d640$export$9d2267fe165de4b6 = (event)=>{
    event.key === 'Enter' && event.preventDefault();
};

});

parcelRegister("kOu8r", function(module, exports) {

$parcel$export(module.exports, "getValueFromEventOrValue", () => $d13b61db8ab93a6d$export$a59801673b41acfd);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $d13b61db8ab93a6d$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $d13b61db8ab93a6d$export$a59801673b41acfd(eventOrValue) {
    if ($d13b61db8ab93a6d$var$isEvent(eventOrValue)) {
        const { currentTarget: currentTarget } = eventOrValue;
        if (currentTarget.type === 'checkbox') {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            if (currentTarget.checked) return currentTarget.value || true;
            return currentTarget.value ? undefined : false;
        }
        if (currentTarget) return currentTarget.value;
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return eventOrValue;
}

});

parcelRegister("5VJL3", function(module, exports) {

$parcel$export(module.exports, "isForgeCustomField", () => $ea68d63ed44fcd5c$export$78cf1b56a8dede1f);
$parcel$export(module.exports, "isForgeLegacyFieldType", () => $ea68d63ed44fcd5c$export$3fb46a1fa454ffea);
$parcel$export(module.exports, "getExtensionIdFromLegacyFieldType", () => $ea68d63ed44fcd5c$export$2b6a9cc67d548886);
$parcel$export(module.exports, "focusFormButton", () => $ea68d63ed44fcd5c$export$f1a0ef98758e7a8a);

var $2Rqjr = parcelRequire("2Rqjr");
const $ea68d63ed44fcd5c$export$78cf1b56a8dede1f = (fieldType)=>typeof fieldType === 'string' && (fieldType.startsWith((0, $2Rqjr.LEGACY_FORGE_FIELD_TYPE_PREFIX)) || fieldType.startsWith((0, $2Rqjr.FORGE_FIELD_TYPE_PREFIX)));
const $ea68d63ed44fcd5c$export$3fb46a1fa454ffea = (fieldType)=>fieldType.startsWith((0, $2Rqjr.LEGACY_FORGE_FIELD_TYPE_PREFIX));
const $ea68d63ed44fcd5c$export$2b6a9cc67d548886 = (fieldType)=>fieldType.split((0, $2Rqjr.PARTIAL_LEGACY_FORGE_FIELD_TYPE_PREFIX))[1] || null;
const $ea68d63ed44fcd5c$export$319e805d3fc5ee35 = (fields)=>Object.values(fields).filter((field)=>$ea68d63ed44fcd5c$export$78cf1b56a8dede1f(field.fieldType));
const $ea68d63ed44fcd5c$export$f1a0ef98758e7a8a = (formSelector, target = document)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const button = target.querySelector(`button[form="${formSelector}"][type="submit"]`);
    if (button != null) button.focus();
};

});


parcelRegister("jK8t4", function(module, exports) {

$parcel$export(module.exports, "NEW_GIC_LEARN_MORE_LINK", () => $033dcf8d621cea4a$export$d807a38e79102eb0);
$parcel$export(module.exports, "FIELDS_LEARN_MORE_LINKS", () => $033dcf8d621cea4a$export$629cb7e52dfd594b);
$parcel$export(module.exports, "USER_GIC_POSITIONING_SPOTLIGHT", () => $033dcf8d621cea4a$export$1056c1e726f183f9);
$parcel$export(module.exports, "ESC_KEY_KEYCODE", () => $033dcf8d621cea4a$export$53016e09dd7d4dca);

const $033dcf8d621cea4a$export$483ce8a526ee009f = 'https://support.atlassian.com/jira-core-cloud/docs/create-and-work-with-issues/';
const $033dcf8d621cea4a$export$d807a38e79102eb0 = 'https://support.atlassian.com/jira-work-management/docs/what-is-the-new-jira-issue-create-experience/';
const $033dcf8d621cea4a$export$629cb7e52dfd594b = {
    [(0, $b1ba189bc6d9d9ad$export$252fb981af0e2e4e)]: '/secure/ShowConstantsHelp.jspa?decorator=popup#ResolutionTypes',
    [(0, $b1ba189bc6d9d9ad$export$909ba97f4a791588)]: '/secure/ShowConstantsHelp.jspa?decorator=popup#SecurityLevels',
    [(0, $b1ba189bc6d9d9ad$export$de14210faa5f2099)]: '/secure/ShowConstantsHelp.jspa?decorator=popup#PriorityLevels'
};
const $033dcf8d621cea4a$export$1056c1e726f183f9 = 'jira.user.gic.positioning.spotlight';
const $033dcf8d621cea4a$export$53016e09dd7d4dca = 27;

});
// graphql __typename
const $b1ba189bc6d9d9ad$export$aa5680ad8f8be9fc = 'JiraProjectField';
const $b1ba189bc6d9d9ad$export$2d5a62a3515ad4c6 = 'JiraIssueTypeField';
const $b1ba189bc6d9d9ad$export$a12a4b25ab12710c = 'JsmRequestTypeField';
const $b1ba189bc6d9d9ad$export$23ca38ad884e35f1 = 'JiraSingleLineTextField';
const $b1ba189bc6d9d9ad$export$31a6c27df1f927b2 = 'JiraRichTextField';
const $b1ba189bc6d9d9ad$export$30b2c2de5e3007a4 = 'JiraComponentsField';
const $b1ba189bc6d9d9ad$export$f10e53e8928b61bd = 'JiraDataClassificationField';
const $b1ba189bc6d9d9ad$export$3849bb04b4eee607 = 'JiraSingleSelectUserPickerField';
const $b1ba189bc6d9d9ad$export$eca94ae30cb92d8 = 'JiraMultipleSelectUserPickerField';
const $b1ba189bc6d9d9ad$export$2bb9d057bad89bfa = 'JiraPeopleField';
const $b1ba189bc6d9d9ad$export$b1ac879bb5cdf30a = 'JsmPeopleField';
const $b1ba189bc6d9d9ad$export$e4d5e04bc56680dc = 'JiraNumberField';
const $b1ba189bc6d9d9ad$export$d8312cdfa02c100d = 'JiraDateTimePickerField';
const $b1ba189bc6d9d9ad$export$8723b724f0b3ac65 = 'JiraEpicLinkField';
const $b1ba189bc6d9d9ad$export$64c7789e86344de5 = 'JiraLabelsField';
const $b1ba189bc6d9d9ad$export$f4f101295d5cc151 = 'JiraSingleVersionPickerField';
const $b1ba189bc6d9d9ad$export$5bb498d4f2f54799 = 'JiraMultipleVersionPickerField';
const $b1ba189bc6d9d9ad$export$de14210faa5f2099 = 'JiraPriorityField';
const $b1ba189bc6d9d9ad$export$47af4d6f62c134cf = 'JiraIssueLinkField';
const $b1ba189bc6d9d9ad$export$e0b268941120d761 = 'JiraDatePickerField';
const $b1ba189bc6d9d9ad$export$909ba97f4a791588 = 'JiraSecurityLevelField';
const $b1ba189bc6d9d9ad$export$f2b56433dc0af401 = 'JiraUrlField';
const $b1ba189bc6d9d9ad$export$d10237d945259f96 = 'JiraCheckboxesField';
const $b1ba189bc6d9d9ad$export$27854f490d658fc4 = 'JiraRadioSelectField';
const $b1ba189bc6d9d9ad$export$fb8861017089d392 = 'JiraSingleSelectField';
const $b1ba189bc6d9d9ad$export$2055419ff013de79 = 'JiraMultipleSelectField';
const $b1ba189bc6d9d9ad$export$16fe78a07e97f2ad = 'JiraSingleGroupPickerField';
const $b1ba189bc6d9d9ad$export$3a1ae3e0f2d9b1b9 = 'JiraMultipleGroupPickerField';
const $b1ba189bc6d9d9ad$export$64238d76a1dc0703 = 'JiraSprintField';
const $b1ba189bc6d9d9ad$export$1070aada56fcaec9 = 'JiraColorField';
const $b1ba189bc6d9d9ad$export$a9b3195cbef5c5ad = 'JiraAttachmentsField';
const $b1ba189bc6d9d9ad$export$76d811609080a7aa = 'JiraIssueRestrictionField';
const $b1ba189bc6d9d9ad$export$252fb981af0e2e4e = 'JiraResolutionField';
const $b1ba189bc6d9d9ad$export$a36509fae9e84682 = 'JiraCascadingSelectField';
const $b1ba189bc6d9d9ad$export$79443fedd031b437 = 'JiraTeamField';
const $b1ba189bc6d9d9ad$export$5e56d79dfe9be3d = 'JiraAffectedServicesField';
const $b1ba189bc6d9d9ad$export$d41ae99ff05f5cda = 'JsmMultipleSelectUserPickerField';
const $b1ba189bc6d9d9ad$export$597fa240de2bfd92 = 'JiraCMDBField';
const $b1ba189bc6d9d9ad$export$864384797e544339 = 'JsmOrganizationField';
const $b1ba189bc6d9d9ad$export$7e5590c7c7a403c0 = 'JiraConnectTextField';
const $b1ba189bc6d9d9ad$export$d854193d90dc547d = 'JiraConnectNumberField';
const $b1ba189bc6d9d9ad$export$985c14eb8f3f0309 = 'JiraConnectSingleSelectField';
const $b1ba189bc6d9d9ad$export$9f6f73ea02649f83 = 'JiraConnectMultipleSelectField';
const $b1ba189bc6d9d9ad$export$aecc734a7c3591d7 = 'JiraTimeTrackingField';
const $b1ba189bc6d9d9ad$export$d9861709f0b70c10 = 'JiraWorkLogField';
const $b1ba189bc6d9d9ad$export$7a583e2ae9052377 = 'JiraConnectRichTextField';
const $b1ba189bc6d9d9ad$export$8643f0b9cefed538 = 'JiraForgeStringField';
const $b1ba189bc6d9d9ad$export$e0ece81bd398c799 = 'JiraForgeNumberField';
const $b1ba189bc6d9d9ad$export$745c8245fea49a34 = 'JiraForgeUserField';
const $b1ba189bc6d9d9ad$export$bbc6b85844b0ade5 = 'JiraForgeUsersField';
const $b1ba189bc6d9d9ad$export$fd24d37af44fe736 = 'JiraForgeGroupField';
const $b1ba189bc6d9d9ad$export$3027db6317a2a8ea = 'JiraForgeGroupsField';
const $b1ba189bc6d9d9ad$export$f596336c24b128f5 = 'JiraForgeStringsField';
const $b1ba189bc6d9d9ad$export$70ff025076e5fb13 = 'JiraForgeDatetimeField';
const $b1ba189bc6d9d9ad$export$111f32c51678063a = 'JiraForgeDateField';
const $b1ba189bc6d9d9ad$export$67aca33725b6a717 = 'JiraForgeObjectField';
const $b1ba189bc6d9d9ad$export$1c7f7cfd2029442f = 'JiraAtlassianTeamField';
const $b1ba189bc6d9d9ad$export$670384150af5f49e = 'JiraParentIssueField';
const $b1ba189bc6d9d9ad$export$bf9df74e065af482 = 'JiraParentField';
const $b1ba189bc6d9d9ad$export$e40f819979b3881d = 'JiraStatusField';
const $b1ba189bc6d9d9ad$export$33f8a9cb608132ba = 'JiraServiceManagementRespondersField';
const $b1ba189bc6d9d9ad$export$fc69de49ba08ae77 = 'JiraServiceManagementEntitlementField';
const $b1ba189bc6d9d9ad$export$a138d5648dda03f0 = 'JiraMessageEditField';
const $b1ba189bc6d9d9ad$export$f7a08bf17a7ac661 = 'JiraAssigneeField';
const $b1ba189bc6d9d9ad$export$d64150fd9c66969c = 'JiraReporterField';
const $b1ba189bc6d9d9ad$export$95433ac963f4aebe = 'JiraTextAreaField';
const $b1ba189bc6d9d9ad$export$f57941b9c1949a82 = 'JiraEpicColorField';
const $b1ba189bc6d9d9ad$export$3e8dded8d83b5d95 = 'JiraAssetField';


parcelRegister("5vWUc", function(module, exports) {

$parcel$export(module.exports, "useWindowSize", () => $4ead39f0817019fc$export$42c02f33970a2afa);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");
const $4ead39f0817019fc$export$42c02f33970a2afa = ()=>{
    const isClient = !false;
    const getSize = ()=>({
            width: isClient ? window.innerWidth : undefined,
            height: isClient ? window.innerHeight : undefined
        });
    const [windowSize, setWindowSize] = (0, $eUqFw.useState)(getSize());
    const onResize = ()=>{
        setWindowSize(getSize());
    };
    const onResizeDebounced = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(onResize, 100, {
        leading: true,
        trailing: true
    });
    (0, $eUqFw.useEffect)(()=>{
        if (!isClient) return undefined;
        window.addEventListener('resize', onResizeDebounced);
        return ()=>{
            window.removeEventListener('resize', onResizeDebounced);
        };
    }, [
        onResizeDebounced,
        isClient
    ]);
    return [
        windowSize.width,
        windowSize.height
    ];
};

});

parcelRegister("j2Myn", function(module, exports) {

$parcel$export(module.exports, "openInNewTabLinkClickEventHandler", () => $60a440f1a2f12c15$export$90d78a8969dab02);
const $60a440f1a2f12c15$export$90d78a8969dab02 = (event)=>{
    const eventTarget = event.target;
    if (eventTarget instanceof HTMLAnchorElement) eventTarget.target = '_blank';
};

});


parcelRegister("aFWau", function(module, exports) {

$parcel$export(module.exports, "getIssueDiscoveryUrl", () => $f003e5336b3da316$export$852450339fdb3b37);
const $f003e5336b3da316$export$852450339fdb3b37 = (createdIssues)=>{
    if (createdIssues.length > 1) {
        const issueKeys = createdIssues.map((issue)=>issue.issueKey).join(',');
        const jqlSearch = encodeURIComponent(`issueKey in (${issueKeys})`);
        return `/issues/?jql=${jqlSearch}`;
    }
    return `/browse/${createdIssues[0].issueKey}`;
};

});

parcelRegister("deodO", function(module, exports) {

$parcel$export(module.exports, "useSmartFieldsMachineLearning", () => $76d1e6dffbdf7d5a$export$2d70bc5538735402);

var $148L2 = parcelRequire("148L2");
const $76d1e6dffbdf7d5a$export$2d70bc5538735402 = ()=>{
    const { loading: loadingJiraLabsSmartFields, data: jiraLabsSmartFieldsData } = (0, $148L2.useSmartFieldsPreferenceResource)();
    const hasUserOptedOut = jiraLabsSmartFieldsData?.hasUserOptedOut;
    const withMachineLearning = !loadingJiraLabsSmartFields && !hasUserOptedOut;
    return {
        withMachineLearning: withMachineLearning
    };
};

});
parcelRegister("148L2", function(module, exports) {

$parcel$export(module.exports, "useSmartFieldsPreferenceResource", () => $06fac1f409c430cd$export$f66e1f764818b2e);
$parcel$export(module.exports, "SmartFieldsPreference", () => $06fac1f409c430cd$export$bccde3fe1fc453a0);

var $eUqFw = parcelRequire("eUqFw");

var $e270j = parcelRequire("e270j");

var $5oIBC = parcelRequire("5oIBC");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");

var $3HCkE = parcelRequire("3HCkE");

var $jlBE2 = parcelRequire("jlBE2");

var $h6fAk = parcelRequire("h6fAk");

var $3xjvh = parcelRequire("3xjvh");

var $8ARYh = parcelRequire("8ARYh");
const $06fac1f409c430cd$export$f66e1f764818b2e = ()=>(0, $3HCkE.useResource)((0, $jlBE2.gicSmartFieldsFeatureResource));
const $06fac1f409c430cd$export$bccde3fe1fc453a0 = (0, $5oIBC.default)((props)=>{
    const { loading: loading, data: data, update: updateResource } = $06fac1f409c430cd$export$f66e1f764818b2e();
    const { updatePreferences: updatePreferences } = (0, $8ARYh.useSmartFieldsUpdateUserPreference)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { flagService: { showFlag: showFlag } } = props;
    const hasUserOptedOut = (0, $eUqFw.useMemo)(()=>typeof data?.hasUserOptedOut === 'boolean' ? data.hasUserOptedOut : false, [
        data
    ]);
    const hasUserDismissedReadMore = (0, $eUqFw.useMemo)(()=>typeof data?.hasUserDismissedReadMore === 'boolean' ? data.hasUserDismissedReadMore : false, [
        data
    ]);
    const { openSmartFieldsFeedbackCollector: openSmartFieldsFeedbackCollector } = (0, $3xjvh.useSmartFieldsFeedbackCollector)();
    const onChange = (0, $eUqFw.useCallback)(async (_, analyticsEventUI)=>{
        const value = !hasUserOptedOut;
        updateResource(()=>({
                hasUserOptedOut: value,
                hasUserDismissedReadMore: false
            }));
        (0, $jMP2a.fireUIAnalytics)(analyticsEventUI, 'toggleLabsGicSmartFields', {
            isSmartFieldsOptOut: value
        });
        try {
            await updatePreferences({
                hasUserOptedOut: value,
                hasUserDismissedReadMore: false
            });
            showFlag({
                type: 'success',
                title: value ? (0, $h6fAk.messages).successTitleOptingOut : (0, $h6fAk.messages).successTitleOptingIn
            });
            if (value) openSmartFieldsFeedbackCollector({
                feedbackTitle: formatMessage((0, $h6fAk.messages).feedbackOptOutTitle),
                feedbackContext: [
                    {
                        id: 'smart-fields-opt-out',
                        value: 'opted-out'
                    }
                ]
            });
        } catch (err) {
            updateResource(()=>({
                    hasUserOptedOut: hasUserOptedOut,
                    hasUserDismissedReadMore: hasUserDismissedReadMore
                }));
            const actions = [
                {
                    content: (0, $h6fAk.messages).refreshPageBtn,
                    onClick: ()=>{
                        window.location.reload();
                    }
                }
            ];
            showFlag({
                type: 'error',
                title: value ? (0, $h6fAk.messages).errTitleOptingOut : (0, $h6fAk.messages).errTitleOptingIn,
                description: (0, $h6fAk.messages).errDescriptionOptingIn,
                actions: actions
            });
        }
    }, [
        hasUserDismissedReadMore,
        hasUserOptedOut,
        updateResource,
        updatePreferences,
        showFlag,
        openSmartFieldsFeedbackCollector,
        formatMessage
    ]);
    if (loading) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e270j.default), {
        isChecked: !hasUserOptedOut,
        onChange: onChange
    });
});

});
parcelRegister("5oIBC", function(module, exports) {

$parcel$export(module.exports, "default", () => $43f0696c76a3faa9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $k8Qyf = parcelRequire("k8Qyf");
const $43f0696c76a3faa9$var$withFlagService = (WrappedComponent)=>{
    return (props)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ...props,
            flagService: (0, $k8Qyf.flagService)
        });
};
var $43f0696c76a3faa9$export$2e2bcd8739ae039 = $43f0696c76a3faa9$var$withFlagService;

});

parcelRegister("h6fAk", function(module, exports) {

$parcel$export(module.exports, "messages", () => $07eec5e43213e270$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $07eec5e43213e270$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    imgAltText: {
        "id": "personal-settings-gic-smart-fields.common.img-alt-text",
        "defaultMessage": "Hide unused fields when creating issues"
    },
    headerText: {
        "id": "personal-settings-gic-smart-fields.common.header-text",
        "defaultMessage": "Hide unused fields when creating issues"
    },
    descriptionText: {
        "id": "personal-settings-gic-smart-fields.common.description-text",
        "defaultMessage": "We\u2019ve implemented some smarts to make sure you have quick and easy access to the fields you actually use when you create issues. We\u2019re not removing the unused fields, you\u2019ll still be able to find them in a <strong>More fields</strong> section at the bottom of the issue create form. <link>Read more about the fields available when creating issues</link>"
    },
    loadingIndicatorAriaLabel: {
        "id": "personal-settings-gic-smart-fields.common.loading-indicator-aria-label",
        "defaultMessage": "Loading data for smart fields toggle button"
    },
    errTitleOptingOut: {
        "id": "personal-settings-gic-smart-fields.common.err-title-opting-out",
        "defaultMessage": "Failed to turn off"
    },
    errTitleOptingIn: {
        "id": "personal-settings-gic-smart-fields.common.err-title-opting-in",
        "defaultMessage": "Failed to turn on"
    },
    errDescriptionOptingIn: {
        "id": "personal-settings-gic-smart-fields.common.err-description-opting-in",
        "defaultMessage": "The issue should fix itself. You can try again in a few minutes, or refresh the page."
    },
    successTitleOptingIn: {
        "id": "personal-settings-gic-smart-fields.common.success-title-opting-in",
        "defaultMessage": "Now hiding unused fields when you create issues."
    },
    successTitleOptingOut: {
        "id": "personal-settings-gic-smart-fields.common.success-title-opting-out",
        "defaultMessage": "Unused fields now showing when you create issues."
    },
    refreshPageBtn: {
        "id": "personal-settings-gic-smart-fields.common.refresh-page-btn",
        "defaultMessage": "Refresh page"
    },
    feedbackTitle: {
        "id": "personal-settings-gic-smart-fields.common.feedback-title",
        "defaultMessage": "Share your feedback"
    },
    feedbackOptOutTitle: {
        "id": "personal-settings-gic-smart-fields.common.feedback-opt-out-title",
        "defaultMessage": "Before you go, help us improve the experience"
    }
});

});

parcelRegister("3xjvh", function(module, exports) {

$parcel$export(module.exports, "useSmartFieldsFeedbackCollector", () => $60327b9a42dfd7c6$export$ffd83fb8be3279b);

var $eUqFw = parcelRequire("eUqFw");

var $irg9D = parcelRequire("irg9D");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $60327b9a42dfd7c6$export$25dc0a1e75f58d8f = '980acd66-d10b-474a-9ff1-48928fc1c8ad';
const $60327b9a42dfd7c6$export$14b33d63628336c2 = 'gic.smart-fields';
const $60327b9a42dfd7c6$export$ffd83fb8be3279b = ()=>{
    const { openFeedbackCollector: openFeedbackCollector, resetFeedbackCollectorState: resetFeedbackCollectorState } = (0, $irg9D.useFeedbackCollectorActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const openSmartFieldsFeedbackCollector = (0, $eUqFw.useCallback)((feedbackCollectorProps)=>{
        openFeedbackCollector({
            entrypointId: $60327b9a42dfd7c6$export$25dc0a1e75f58d8f,
            feedbackGroupId: $60327b9a42dfd7c6$export$14b33d63628336c2,
            onClose: ()=>{
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'smartFieldsFeedbackCollector closed');
                resetFeedbackCollectorState();
            },
            onSubmit: ()=>{
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'smartFieldsFeedbackCollector submitted');
            },
            ...feedbackCollectorProps
        });
    }, [
        openFeedbackCollector,
        createAnalyticsEvent,
        resetFeedbackCollectorState
    ]);
    return {
        openSmartFieldsFeedbackCollector: openSmartFieldsFeedbackCollector
    };
};

});

parcelRegister("8ARYh", function(module, exports) {

$parcel$export(module.exports, "useSmartFieldsUpdateUserPreference", () => $27efb19ca3d492b5$export$d7a60913673e28ef);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $cm5m0 = parcelRequire("cm5m0");

const $27efb19ca3d492b5$export$d7a60913673e28ef = ()=>{
    const updatePreferences = (0, $eUqFw.useCallback)(async (payload)=>{
        try {
            await (0, $cm5m0.userPreferenceAPI).set((0, $3b73772f5336e068$export$b94951a11282ae6a), payload);
        } catch (err) {
            (0, $guiFP.default)({
                error: err instanceof Error ? err : new Error('Unknown error'),
                meta: {
                    id: 'updateCommandPaletteOptInStatus',
                    packageName: 'jiraPersonalSettingsGicSmartFields',
                    teamName: 'deliveroo'
                }
            });
            throw err;
        }
    }, []);
    return {
        updatePreferences: updatePreferences
    };
};

});
const $3b73772f5336e068$export$b94951a11282ae6a = 'gic-smart-fields-feature';




parcelRegister("5kL7H", function(module, exports) {

$parcel$export(module.exports, "useChangerSpotlight", () => $b8c37132db30dd7b$export$6e0f4554859c42e9);

var $eUqFw = parcelRequire("eUqFw");

var $jK8t4 = parcelRequire("jK8t4");

var $bBHrT = parcelRequire("bBHrT");
const $b8c37132db30dd7b$export$6e0f4554859c42e9 = (minimizableModalView)=>{
    const [allowShowingChangerSpotlight, setAllowShowingChangerSpotlight] = (0, $eUqFw.useState)(false);
    const [userPreferenceSpotlight, setUserPreferences] = (0, $bBHrT.useUserPreferences)((0, $jK8t4.USER_GIC_POSITIONING_SPOTLIGHT), false);
    const hasSeenGicPositioningSpotlight = userPreferenceSpotlight;
    const shouldShowChangerSpotlight = !hasSeenGicPositioningSpotlight && allowShowingChangerSpotlight;
    const onCloseChangerSpotlight = (0, $eUqFw.useCallback)(()=>{
        if (!hasSeenGicPositioningSpotlight) {
            setAllowShowingChangerSpotlight(false);
            setUserPreferences(true);
        }
    }, [
        setAllowShowingChangerSpotlight,
        hasSeenGicPositioningSpotlight,
        setUserPreferences
    ]);
    const isModalView = minimizableModalView === 'modal';
    (0, $eUqFw.useEffect)(()=>{
        if (!isModalView && shouldShowChangerSpotlight) onCloseChangerSpotlight();
    }, [
        onCloseChangerSpotlight,
        isModalView,
        shouldShowChangerSpotlight
    ]);
    const onOpenSpotlight = ()=>{
        if (isModalView) setAllowShowingChangerSpotlight(true);
    };
    const onCloseSpotlight = ()=>{
        if (isModalView) onCloseChangerSpotlight();
    };
    return {
        shouldShowChangerSpotlight: shouldShowChangerSpotlight,
        onOpenSpotlight: onOpenSpotlight,
        onCloseSpotlight: onCloseSpotlight
    };
};

});
parcelRegister("bBHrT", function(module, exports) {

$parcel$export(module.exports, "useUserPreferences", () => $5fdd72b3ea8401e3$export$b6472e0d8983f5f5);

var $eUqFw = parcelRequire("eUqFw");

var $6G5mG = parcelRequire("6G5mG");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $5fdd72b3ea8401e3$var$setGICUserPreferences = async (key, value)=>{
    try {
        await (0, $lRmyA.performPutRequest)(`/rest/api/3/mypreferences?key=${key}`, {
            body: JSON.stringify({
                value: value
            })
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'getAPI3MyPreferences',
                packageName: 'jiraIssueCreate',
                teamName: 'gryffindor'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    }
};
const $5fdd72b3ea8401e3$export$b6472e0d8983f5f5 = (key, fallbackState)=>{
    const [state, setState] = (0, $eUqFw.useState)(fallbackState);
    (0, $eUqFw.useEffect)(()=>{
        const run = async ()=>{
            try {
                const apiResult = await (0, $lRmyA.performGetRequest)(`/rest/api/3/mypreferences?key=${key}`);
                if (typeof apiResult !== 'object' || !(0, (/*@__PURE__*/$parcel$interopDefault($6G5mG)))(apiResult, 'value')) {
                    const error = new Error('Invalid preference value');
                    (0, $guiFP.default)({
                        meta: {
                            id: 'getAPI3MyPreferences',
                            packageName: 'jiraIssueCreate',
                            teamName: 'gryffindor'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                    return;
                }
                setState(apiResult.value);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                if (error.statusCode === 404) // Error 404 is acceptable as the first time the key does not exist in the user profile.
                return;
                (0, $guiFP.default)({
                    meta: {
                        id: 'getAPI3MyPreferences',
                        packageName: 'jiraIssueCreate',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        };
        run();
    }, [
        key
    ]);
    const setUserPreferences = (0, $eUqFw.useCallback)((value)=>{
        $5fdd72b3ea8401e3$var$setGICUserPreferences(key, value);
        setState(value);
    }, [
        key
    ]);
    return [
        state,
        setUserPreferences
    ];
};

});


parcelRegister("hFagV", function(module, exports) {

$parcel$export(module.exports, "useIsGICPositioningEnabled", () => $31821ff9abcb2b5d$export$a782e9359ada4cd3);

var $eUqFw = parcelRequire("eUqFw");

var $jUUuq = parcelRequire("jUUuq");
const $31821ff9abcb2b5d$export$a782e9359ada4cd3 = ()=>{
    const [{ disableGICPositioning: disableGICPositioning }] = (0, $jUUuq.useGICPositioningEnabledController)();
    const isGICPositioningEnabled = (0, $eUqFw.useCallback)(()=>!disableGICPositioning, [
        disableGICPositioning
    ]);
    return isGICPositioningEnabled;
};

});
parcelRegister("jUUuq", function(module, exports) {

$parcel$export(module.exports, "useGICPositioningEnabledController", () => $272a3f35c814a05d$export$9cc1c859181a0ff4);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $272a3f35c814a05d$var$initialState = {
    disableGICPositioning: false
};
const $272a3f35c814a05d$var$actions = {
    setDisableGICPositioning: (disableGICPositioning)=>({ setState: setState })=>{
            setState({
                disableGICPositioning: disableGICPositioning
            });
        }
};
const $272a3f35c814a05d$var$Store = (0, $a61MH.createStore)({
    initialState: $272a3f35c814a05d$var$initialState,
    actions: $272a3f35c814a05d$var$actions,
    name: 'GICPositioningEnabledController'
});
const $272a3f35c814a05d$export$4bfa4009172d242 = (0, $heB5U.createContainer)($272a3f35c814a05d$var$Store);
const $272a3f35c814a05d$export$9cc1c859181a0ff4 = (0, $ggKAj.createHook)($272a3f35c814a05d$var$Store);

});


parcelRegister("4NPAT", function(module, exports) {

$parcel$export(module.exports, "useRequestTypeFieldsLayoutPreference", () => $68821cacd4c1ebc0$export$7f6ea71dfb4ea52b);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $gSnp9 = parcelRequire("gSnp9");

var $hcmFF = parcelRequire("hcmFF");
const $68821cacd4c1ebc0$export$d4c72bab9d6cc13a = {
    isInitialised: false,
    data: (0, $hcmFF.fallbackValue),
    isLoading: false
};
const $68821cacd4c1ebc0$var$store = (0, $a61MH.createStore)({
    name: 'RequestTypeFieldsLayoutUserPreference',
    initialState: $68821cacd4c1ebc0$export$d4c72bab9d6cc13a,
    actions: $gSnp9.actions
});
const $68821cacd4c1ebc0$export$7f6ea71dfb4ea52b = (0, $ggKAj.createHook)($68821cacd4c1ebc0$var$store);

});
parcelRegister("gSnp9", function(module, exports) {

$parcel$export(module.exports, "actions", () => $0a02deb05d88c750$export$e324594224ef24da);


var $48bs8 = parcelRequire("48bs8");

var $guiFP = parcelRequire("guiFP");

var $7byHA = parcelRequire("7byHA");
var $JRB5w = parcelRequire("JRB5w");

var $jMP2a = parcelRequire("jMP2a");

var $hcmFF = parcelRequire("hcmFF");
const $0a02deb05d88c750$var$initialise = (accountId, createAnalyticsEvent)=>async ({ setState: setState, getState: getState })=>{
        const state = getState();
        if (!state.isInitialised && accountId !== null) {
            setState({
                isLoading: true
            });
            await (0, $48bs8.getUserProperty)('', accountId, (0, $hcmFF.propertyKey)).then((value)=>{
                setState({
                    isInitialised: true,
                    data: value === (0, $hcmFF.UserPreference).RequestFormFields,
                    isLoading: false
                });
                (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'getRequestTypesLayoutPreference succeeded', {});
            }).catch((error)=>{
                if (error.statusCode === (0, $1c3fbb431a173cc6$export$8bca792d963eb0ef)) {
                    // user preference has not been set
                    setState({
                        isLoading: false,
                        data: (0, $hcmFF.fallbackValue)
                    });
                    (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'getRequestTypesLayoutPreference succeeded', {});
                } else {
                    setState({
                        isLoading: false
                    });
                    (0, $guiFP.default)({
                        meta: {
                            id: 'getRequestTypesLayoutPreference',
                            packageName: 'jiraIssueCreate',
                            teamName: 'gryffindor'
                        },
                        error: error,
                        attributes: {
                            isClientFetchError: (0, $JRB5w.isClientFetchError)(error)
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            });
        }
    };
const $0a02deb05d88c750$var$setPreference = (accountId, isEnabled, createAnalyticsEvent, callback)=>async ({ setState: setState, getState: getState })=>{
        const { isLoading: isLoading, data: oldValue } = getState();
        if (accountId && !isLoading) {
            setState({
                data: isEnabled,
                isLoading: true
            });
            await (0, $48bs8.setUserProperties)('', accountId, (0, $hcmFF.propertyKey), JSON.stringify(isEnabled ? (0, $hcmFF.UserPreference).RequestFormFields : (0, $hcmFF.UserPreference).ScreenFields)).then((res)=>{
                if (!res.ok) return res.text().then((errResp)=>{
                    throw new (0, $7byHA.default)(res.status, errResp);
                });
                setState({
                    data: isEnabled,
                    isLoading: false
                });
                (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'setRequestTypesLayoutPreference succeeded', {
                    isEnabled: isEnabled
                });
                return callback();
            }).catch((error)=>{
                setState({
                    data: oldValue,
                    isLoading: false
                });
                (0, $guiFP.default)({
                    meta: {
                        id: 'setRequestTypesLayoutPreference',
                        packageName: 'jiraIssueCreate',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    attributes: {
                        isClientFetchError: (0, $JRB5w.isClientFetchError)(error)
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
            });
        }
    };
const $0a02deb05d88c750$export$e324594224ef24da = {
    setPreference: $0a02deb05d88c750$var$setPreference,
    initialise: $0a02deb05d88c750$var$initialise
};

});
const $1c3fbb431a173cc6$export$ff39ebd4bb12b718 = 201;
const $1c3fbb431a173cc6$export$3288b14b6745c572 = 204;
const $1c3fbb431a173cc6$export$9de493bcd9b1d977 = 400;
const $1c3fbb431a173cc6$export$67d19e9a991baa07 = 401;
const $1c3fbb431a173cc6$export$a3269a3914b007e3 = 403;
const $1c3fbb431a173cc6$export$8bca792d963eb0ef = 404;
const $1c3fbb431a173cc6$export$4a3cb39801694eee = 407;
const $1c3fbb431a173cc6$export$fa405bbf47d510e2 = 408;
const $1c3fbb431a173cc6$export$c09e7ea0fc79f34f = 409;
const $1c3fbb431a173cc6$export$5244030134e99 = 412;
const $1c3fbb431a173cc6$export$f90ac1df0b60853d = 413;
const $1c3fbb431a173cc6$export$a447d0a965e16776 = 422;
const $1c3fbb431a173cc6$export$3b48aba8957000cd = 426;
const $1c3fbb431a173cc6$export$6763168a631449a2 = 429;
const $1c3fbb431a173cc6$export$e813cd7045fcc98d = 500;
const $1c3fbb431a173cc6$export$2ce38d41a306034e = 502;
const $1c3fbb431a173cc6$export$974c37534b0191b1 = 503;
const $1c3fbb431a173cc6$export$5400e8dddac3fcf3 = 504;

parcelRegister("hcmFF", function(module, exports) {

$parcel$export(module.exports, "fallbackValue", () => $cdd0760b182359cc$export$91cd7f5c38b6ba2);
$parcel$export(module.exports, "propertyKey", () => $cdd0760b182359cc$export$52266bfa96e3a752);
$parcel$export(module.exports, "UserPreference", () => $cdd0760b182359cc$export$9eb786c5fec4a558);
const $cdd0760b182359cc$export$91cd7f5c38b6ba2 = true;
const $cdd0760b182359cc$export$52266bfa96e3a752 = 'gic-jsm-fields-layout-preference';
const $cdd0760b182359cc$export$9eb786c5fec4a558 = {
    ScreenFields: 'SCREEN_FIELDS',
    RequestFormFields: 'REQUEST_FORM_FIELDS'
};

});



parcelRegister("l1xaV", function(module, exports) {

$parcel$export(module.exports, "useFetchForgeModules", () => $b65edf7895fc2881$export$36c81308105ff728);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $eEzyV = parcelRequire("eEzyV");

var $1ybV0 = parcelRequire("1ybV0");

var $2Rqjr = parcelRequire("2Rqjr");

var $fTsDx = parcelRequire("fTsDx");

var $arKaN = parcelRequire("arKaN");

var $gd0Sp = parcelRequire("gd0Sp");
const $b65edf7895fc2881$export$36c81308105ff728 = (extraContext = {})=>{
    const { cloudId: cloudId, activationId: activationId } = (0, $gd0Sp.useTenantContext)();
    const modulesToFetch = (0, $eUqFw.useMemo)(()=>[
            (0, $2Rqjr.CUSTOM_FIELD_MODULE),
            (0, $2Rqjr.CUSTOM_FIELD_TYPE_MODULE),
            (0, $2Rqjr.UI_MODIFICATIONS_MODULE)
        ], []);
    const classificationTags = extraContext?.classificationTags;
    const previousDataClassificationTags = (0, $eUqFw.useRef)([]);
    const dataClassificationTags = (0, $eUqFw.useMemo)(()=>{
        // When classification tags are not defined, it means the project in GIC is not loaded yet
        if (!classificationTags) return undefined;
        // The `classificationTags` is not referencially stable, so we need to deep compare it and
        // make sure we are only changing this `useMemo` reference when there are values changes
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(previousDataClassificationTags.current, classificationTags)) previousDataClassificationTags.current = classificationTags;
        return previousDataClassificationTags.current;
    }, [
        classificationTags
    ]);
    const hasDataClassificationTags = !!dataClassificationTags;
    const request = (0, $eUqFw.useCallback)(()=>{
        const contextIds = (0, $1ybV0.ff)('arken-1053-jira-forge-extension-changes-for-aegis_aws9x') ? [
            `ari:cloud:jira:${cloudId}:workspace/${activationId}`
        ] : undefined;
        return (0, $arKaN.default)(cloudId, modulesToFetch, {
            tags: dataClassificationTags || []
        }, {
            include: {
                scopes: true
            }
        }, (0, $2Rqjr.SOURCE_GLOBAL_ISSUE_CREATE), contextIds);
    }, [
        dataClassificationTags,
        cloudId,
        activationId,
        modulesToFetch
    ]);
    const { data: data, error: error, fetch: fetch, loadingStatus: loadingStatus } = (0, $eEzyV.useLoadingStatusService)(request, {
        loading: true
    });
    (0, $eUqFw.useEffect)(()=>{
        // Since access narrowing, we need to know if the selected project in GIC has or not data
        // classification tags in it, and make sure we call cs-extensions with those.
        //
        // So if data classification tags are not yet loaded, the request should not be invoked
        if (!hasDataClassificationTags) return;
        fetch();
    }, [
        fetch,
        hasDataClassificationTags
    ]);
    return (0, $eUqFw.useMemo)(()=>{
        const customFields = [];
        const issueAdjustmentModules = [];
        const filteredOutModules = [];
        const modules = data?.extensions;
        const accessNarrowedModules = data?.accessNarrowedExtensions;
        accessNarrowedModules?.jiraCustomField?.forEach((module)=>{
            filteredOutModules.push(module);
        });
        accessNarrowedModules?.jiraCustomFieldType?.forEach((module)=>{
            filteredOutModules.push(module);
        });
        modules?.jiraCustomField?.forEach((module)=>{
            if ((0, $fTsDx.doesExtensionMeetConditions)(module, extraContext)) customFields.push(module);
            else filteredOutModules.push(module);
        });
        modules?.jiraCustomFieldType?.forEach((module)=>{
            if ((0, $fTsDx.doesExtensionMeetConditions)(module, extraContext)) customFields.push(module);
            else filteredOutModules.push(module);
        });
        modules?.jiraUiModifications?.forEach((module)=>{
            if ((0, $fTsDx.doesExtensionMeetConditions)(module, extraContext)) issueAdjustmentModules.push(module);
        });
        return {
            customFields: customFields,
            issueAdjustmentModules: issueAdjustmentModules,
            filteredOutModules: filteredOutModules,
            error: error,
            loadingStatus: loadingStatus
        };
    }, [
        data,
        loadingStatus,
        error,
        extraContext
    ]);
};

});

parcelRegister("jI4T5", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2c60f26b8064d8d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eEzyV = parcelRequire("eEzyV");

var $gd0Sp = parcelRequire("gd0Sp");

var $jV9A8 = parcelRequire("jV9A8");
const $b2c60f26b8064d8d$var$useFetchTransitionsService = ()=>{
    const { cloudId: cloudId } = (0, $gd0Sp.useTenantContext)();
    const fetchTransitions = (0, $eUqFw.useCallback)(({ projectId: projectId, issueTypeId: issueTypeId, selectedCloudId: selectedCloudId })=>(0, $jV9A8.default)(selectedCloudId || cloudId, projectId, issueTypeId), [
        cloudId
    ]);
    const { loading: loading, error: error, data: data, fetch: fetch } = (0, $eEzyV.useService)(fetchTransitions);
    return [
        {
            isLoading: loading,
            error: error,
            transitions: data
        },
        fetch
    ];
};
var $b2c60f26b8064d8d$export$2e2bcd8739ae039 = $b2c60f26b8064d8d$var$useFetchTransitionsService;

});
parcelRegister("jV9A8", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d5b1483ff92b6b9$export$2e2bcd8739ae039);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $dfh7z = parcelRequire("dfh7z");

var $eGitB = parcelRequire("eGitB");
const $4d5b1483ff92b6b9$var$constructEndpoint = (cloudId)=>`/gateway/api/jira/project-configuration/query/${cloudId}/2/transition/initial`;
const $4d5b1483ff92b6b9$var$getTransitions = async (cloudId, projectId, issueTypeId)=>{
    const url = $4d5b1483ff92b6b9$var$constructEndpoint(cloudId);
    (0, $dfh7z.StatusFieldLoad).start();
    try {
        const resp = await (0, $lRmyA.performPostRequest)(url, {
            body: JSON.stringify({
                projectId: projectId,
                issueTypeId: issueTypeId
            })
        });
        (0, $dfh7z.StatusFieldLoad).success();
        return (0, $eGitB.transformData)(resp);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $dfh7z.StatusFieldLoad).failure();
        (0, $guiFP.default)({
            meta: {
                id: 'getTransitions',
                packageName: 'jiraIssueCreate',
                teamName: 'gryffindor'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};
var $4d5b1483ff92b6b9$export$2e2bcd8739ae039 = $4d5b1483ff92b6b9$var$getTransitions;

});
parcelRegister("eGitB", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $572c290420ba9660$export$3ceb62baab058c6b);
const $572c290420ba9660$var$shouldReplace = (existing, replacement)=>!existing.isInitial && replacement.isInitial || existing.isDisabled === true && !replacement.isDisabled;
const $572c290420ba9660$export$3ceb62baab058c6b = (data)=>{
    const transitionMap = data.reduce((acc, val)=>{
        if (acc.has(val.to.id) && !$572c290420ba9660$var$shouldReplace(acc.get(val.to.id), val)) return acc;
        return acc.set(val.to.id, val);
    }, new Map());
    return Array.from(transitionMap.values());
};

});



parcelRegister("1n3pz", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c739c6d4e4f3803$export$2e2bcd8739ae039);

var $cMQz6 = parcelRequire("cMQz6");

var $g9dzQ = parcelRequire("g9dzQ");

var $1vkQL = parcelRequire("1vkQL");
const $3c739c6d4e4f3803$var$useModalLoadQuery = (props)=>{
    const { displayOnlyRequiredFields: displayOnlyRequiredFields = false, triggerPointKey: triggerPointKey, isSubTaskCreationOpen: isSubTaskCreationOpen = false, triggerIssueCreatePayload: triggerIssueCreatePayload, isModalLoadInContext: isModalLoadInContext = false } = props;
    const [{ isLoading: isLoading, fieldConfig: fieldConfig, fieldTabs: fieldTabs, contextFields: contextFields, meta: meta, error: error, apiLatency: apiLatency, additionalServices: additionalServices }, fetchConfig] = (0, $cMQz6.default)({
        displayOnlyRequiredFields: displayOnlyRequiredFields,
        triggerPointKey: triggerPointKey
    });
    const [{ isLoading: isSubtaskLoading, fieldConfig: subtaskFieldConfig, fieldTabs: subtaskFieldTabs, contextFields: subtaskContextFields, meta: subtaskFieldsDataMeta, error: subtaskFieldsDataError, apiLatency: subtaskApiLatency, additionalServices: subtaskAdditionalServices }, fetchSubtaskConfig] = (0, $1vkQL.default)({
        displayOnlyRequiredFields: displayOnlyRequiredFields,
        triggerPointKey: triggerPointKey
    });
    const [{ isLoading: isLoadingInContext, fieldConfig: fieldConfigInContext, fieldTabs: fieldTabsInContext, contextFields: contextFieldsInContext, meta: fieldsDataMetaInContext, error: fieldsDataErrorInContext, apiLatency: apiLatencyInContext, additionalServices: additionalServicesInContext }, fetchConfigInContext] = (0, $g9dzQ.default)({
        displayOnlyRequiredFields: displayOnlyRequiredFields,
        triggerPointKey: triggerPointKey
    });
    const parentId = triggerIssueCreatePayload?.parentId || null;
    const additionalContext = triggerIssueCreatePayload?.additionalContext || null;
    if (isModalLoadInContext && additionalContext) return [
        {
            isLoading: isLoadingInContext,
            fieldConfig: fieldConfigInContext,
            fieldTabs: fieldTabsInContext,
            contextFields: contextFieldsInContext,
            meta: fieldsDataMetaInContext,
            error: fieldsDataErrorInContext,
            apiLatency: apiLatencyInContext,
            additionalServices: additionalServicesInContext
        },
        fetchConfigInContext
    ];
    if (isSubTaskCreationOpen && parentId) return [
        {
            isLoading: isSubtaskLoading,
            fieldConfig: subtaskFieldConfig,
            fieldTabs: subtaskFieldTabs,
            contextFields: subtaskContextFields,
            meta: subtaskFieldsDataMeta,
            error: subtaskFieldsDataError,
            apiLatency: subtaskApiLatency,
            additionalServices: subtaskAdditionalServices
        },
        fetchSubtaskConfig
    ];
    return [
        {
            isLoading: isLoading,
            fieldConfig: fieldConfig,
            fieldTabs: fieldTabs,
            contextFields: contextFields,
            meta: meta,
            error: error,
            apiLatency: apiLatency,
            additionalServices: additionalServices
        },
        fetchConfig
    ];
};
var $3c739c6d4e4f3803$export$2e2bcd8739ae039 = $3c739c6d4e4f3803$var$useModalLoadQuery;

});
parcelRegister("cMQz6", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fd8c6f5aef6b506$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $dRkzf = parcelRequire("dRkzf");

var $6JePA = parcelRequire("6JePA");

var $deodO = parcelRequire("deodO");

var $9Oxdn = parcelRequire("9Oxdn");

var $9QCcq = parcelRequire("9QCcq");
const $8fd8c6f5aef6b506$var$useFetchCreateConfigQuery = (props = {})=>{
    const { displayOnlyRequiredFields: displayOnlyRequiredFields = false, triggerPointKey: triggerPointKey } = props;
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const [fetchError, setFetchError] = (0, $eUqFw.useState)(null);
    const apiStartTime = (0, $eUqFw.useRef)(0);
    const [apiLatency, setApiLatency] = (0, $eUqFw.useState)(0);
    const [data, setData] = (0, $eUqFw.useState)({
        fieldTabs: [],
        fieldConfig: {},
        contextFields: {},
        meta: {
            areRequiredFieldsSupported: true,
            queryErrorMessage: ''
        },
        additionalServices: {}
    });
    const { withMachineLearning: withMachineLearning } = (0, $1ybV0.ff)('gic-smart-fields-jira-labs_8uwvr') ? (0, $deodO.useSmartFieldsMachineLearning)() : {
        withMachineLearning: false
    };
    const [fetchConfig] = (0, $iZuDo.useLazyQuery)((0, $1ybV0.ff)('gic-smart-fields-jira-labs_8uwvr') ? (0, $9Oxdn.getCreateConfigUserPreferredQuery)(withMachineLearning) : (0, $9QCcq.CREATE_CONFIG_USER_PREFERRED_QUERY), {
        fetchPolicy: 'no-cache',
        onCompleted: (queryData)=>{
            setApiLatency(Math.floor(performance.now() - apiStartTime.current));
            if ((0, $1ybV0.ff)('gic-smart-fields-jira-labs_8uwvr')) setData((0, $6JePA.transformQueryResults)((0, $6JePA.transformQueryData)(queryData), displayOnlyRequiredFields));
            else setData((0, $6JePA.transformQueryResults)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            queryData, displayOnlyRequiredFields));
            setLoading(false);
        },
        onError: (error)=>{
            setFetchError(error);
            (0, $guiFP.default)({
                meta: {
                    id: 'useFetchCreateConfigQuery',
                    packageName: 'jiraIssueCreate',
                    teamName: 'gryffindor'
                },
                error: error,
                attributes: {
                    errorType: (0, $dRkzf.handleApolloError)(error),
                    triggerPointKey: triggerPointKey
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    });
    const handleFetch = (0, $eUqFw.useRef)((queryVariables)=>{
        setLoading(true);
        apiStartTime.current = performance.now();
        fetchConfig(queryVariables);
    });
    return [
        {
            isLoading: loading,
            fieldTabs: data.fieldTabs,
            fieldConfig: data.fieldConfig,
            contextFields: data.contextFields,
            meta: data.meta,
            error: fetchError,
            apiLatency: apiLatency,
            additionalServices: data.additionalServices
        },
        handleFetch.current
    ];
};
var $8fd8c6f5aef6b506$export$2e2bcd8739ae039 = $8fd8c6f5aef6b506$var$useFetchCreateConfigQuery;

});
parcelRegister("iZuDo", function(module, exports) {

$parcel$export(module.exports, "useQuery", () => $dd35afdbf6e72e7e$export$dd0a697e1782aedd);
$parcel$export(module.exports, "useLazyQuery", () => $dd35afdbf6e72e7e$export$fd83eea6ecd2d8fa);
$parcel$export(module.exports, "useMutation", () => $dd35afdbf6e72e7e$export$609860bf8b0084c);
$parcel$export(module.exports, "useApolloClient", () => $dd35afdbf6e72e7e$export$eb9a56e7a29e494);

var $4ErPU = parcelRequire("4ErPU");

var $fKE23 = parcelRequire("fKE23");

var $eUqFw = parcelRequire("eUqFw");

var $jlBDe = parcelRequire("jlBDe");

var $66hGB = parcelRequire("66hGB");

var $8j2fP = parcelRequire("8j2fP");
var $dd35afdbf6e72e7e$var$OperationData = function() {
    function OperationData(options, context) {
        this.isMounted = false;
        this.previousOptions = {};
        this.context = {};
        this.options = {};
        this.options = options || {};
        this.context = context || {};
    }
    OperationData.prototype.getOptions = function() {
        return this.options;
    };
    OperationData.prototype.setOptions = function(newOptions, storePrevious) {
        if (storePrevious === void 0) storePrevious = false;
        if (storePrevious && !(0, $66hGB.equal)(this.options, newOptions)) this.previousOptions = this.options;
        this.options = newOptions;
    };
    OperationData.prototype.unmount = function() {
        this.isMounted = false;
    };
    OperationData.prototype.refreshClient = function() {
        var client = this.options && this.options.client || this.context && this.context.client;
        (0, $8j2fP.invariant)(!!client, 2);
        var isNew = false;
        if (client !== this.client) {
            isNew = true;
            this.client = client;
            this.cleanup();
        }
        return {
            client: this.client,
            isNew: isNew
        };
    };
    OperationData.prototype.verifyDocumentType = function(document, type) {
        var operation = (0, $4ErPU.parser)(document);
        var requiredOperationName = (0, $4ErPU.operationName)(type);
        var usedOperationName = (0, $4ErPU.operationName)(operation.type);
        (0, $8j2fP.invariant)(operation.type === type, 3);
    };
    return OperationData;
}();
var $dd35afdbf6e72e7e$var$QueryData = function(_super) {
    (0, $fKE23.__extends)(QueryData, _super);
    function QueryData(_a) {
        var options = _a.options, context = _a.context, forceUpdate = _a.forceUpdate;
        var _this = _super.call(this, options, context) || this;
        _this.previousData = {};
        _this.currentObservable = {};
        _this.runLazy = false;
        _this.runLazyQuery = function(options) {
            _this.cleanup();
            _this.runLazy = true;
            _this.lazyOptions = options;
            _this.forceUpdate();
        };
        _this.getExecuteResult = function() {
            var result = _this.getQueryResult();
            _this.startQuerySubscription();
            return result;
        };
        _this.obsRefetch = function(variables) {
            return _this.currentObservable.query.refetch(variables);
        };
        _this.obsFetchMore = function(fetchMoreOptions) {
            return _this.currentObservable.query.fetchMore(fetchMoreOptions);
        };
        _this.obsUpdateQuery = function(mapFn) {
            return _this.currentObservable.query.updateQuery(mapFn);
        };
        _this.obsStartPolling = function(pollInterval) {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
        };
        _this.obsStopPolling = function() {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
        };
        _this.obsSubscribeToMore = function(options) {
            return _this.currentObservable.query.subscribeToMore(options);
        };
        _this.forceUpdate = forceUpdate;
        return _this;
    }
    QueryData.prototype.execute = function() {
        this.refreshClient();
        var _a = this.getOptions(), skip = _a.skip, query = _a.query;
        if (skip || query !== this.previousData.query) {
            this.removeQuerySubscription();
            this.previousData.query = query;
        }
        this.updateObservableQuery();
        if (this.isMounted) this.startQuerySubscription();
        return this.getExecuteSsrResult() || this.getExecuteResult();
    };
    QueryData.prototype.executeLazy = function() {
        return !this.runLazy ? [
            this.runLazyQuery,
            {
                loading: false,
                networkStatus: (0, $jlBDe.NetworkStatus).ready,
                called: false,
                data: undefined
            }
        ] : [
            this.runLazyQuery,
            this.execute()
        ];
    };
    QueryData.prototype.fetchData = function() {
        var options = this.getOptions();
        if (options.skip || options.ssr === false) return false;
        var obs = this.currentObservable.query;
        var currentResult = obs.getCurrentResult();
        return currentResult.loading ? obs.result() : false;
    };
    QueryData.prototype.afterExecute = function(_a) {
        var _this = this;
        var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
        this.isMounted = true;
        if (!lazy || this.runLazy) {
            this.handleErrorOrCompleted();
            setTimeout(function() {
                _this.currentObservable.query && _this.currentObservable.query.resetQueryStoreErrors();
            });
        }
        this.previousOptions = this.getOptions();
        return this.unmount.bind(this);
    };
    QueryData.prototype.cleanup = function() {
        this.removeQuerySubscription();
        delete this.currentObservable.query;
        delete this.previousData.result;
    };
    QueryData.prototype.getOptions = function() {
        var options = _super.prototype.getOptions.call(this);
        if (this.lazyOptions) {
            options.variables = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options.variables), this.lazyOptions.variables);
            options.context = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options.context), this.lazyOptions.context);
        }
        if (this.runLazy) delete options.skip;
        return options;
    };
    QueryData.prototype.getExecuteSsrResult = function() {
        var treeRenderingInitiated = this.context && this.context.renderPromises;
        var ssrDisabled = this.getOptions().ssr === false;
        var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
        var ssrLoading = {
            loading: true,
            networkStatus: (0, $jlBDe.NetworkStatus).loading,
            called: true,
            data: undefined
        };
        if (ssrDisabled && (treeRenderingInitiated || fetchDisabled)) return ssrLoading;
        var result;
        if (treeRenderingInitiated) result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
        return result;
    };
    QueryData.prototype.prepareObservableQueryOptions = function() {
        var options = this.getOptions();
        this.verifyDocumentType(options.query, (0, $4ErPU.DocumentType).Query);
        var displayName = options.displayName || 'Query';
        if (this.context && this.context.renderPromises && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options.fetchPolicy = 'cache-first';
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            displayName: displayName,
            context: options.context,
            metadata: {
                reactComponent: {
                    displayName: displayName
                }
            }
        });
    };
    QueryData.prototype.initializeObservableQuery = function() {
        if (this.context && this.context.renderPromises) this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
        if (!this.currentObservable.query) {
            var observableQueryOptions = this.prepareObservableQueryOptions();
            this.previousData.observableQueryOptions = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, observableQueryOptions), {
                children: null
            });
            this.currentObservable.query = this.refreshClient().client.watchQuery((0, $fKE23.__assign)({}, observableQueryOptions));
            if (this.context && this.context.renderPromises) this.context.renderPromises.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
        }
    };
    QueryData.prototype.updateObservableQuery = function() {
        if (!this.currentObservable.query) {
            this.initializeObservableQuery();
            return;
        }
        var newObservableQueryOptions = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.prepareObservableQueryOptions()), {
            children: null
        });
        if (!(0, $66hGB.equal)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
            this.previousData.observableQueryOptions = newObservableQueryOptions;
            this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function() {});
        }
    };
    QueryData.prototype.startQuerySubscription = function() {
        var _this = this;
        if (this.currentObservable.subscription || this.getOptions().skip) return;
        var obsQuery = this.currentObservable.query;
        this.currentObservable.subscription = obsQuery.subscribe({
            next: function(_a) {
                var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $66hGB.equal)(previousResult.data, data)) return;
                _this.forceUpdate();
            },
            error: function(error) {
                _this.resubscribeToQuery();
                if (!error.hasOwnProperty('graphQLErrors')) throw error;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading || !(0, $66hGB.equal)(error, _this.previousData.error)) {
                    _this.previousData.error = error;
                    _this.forceUpdate();
                }
            }
        });
    };
    QueryData.prototype.resubscribeToQuery = function() {
        this.removeQuerySubscription();
        var lastError = this.currentObservable.query.getLastError();
        var lastResult = this.currentObservable.query.getLastResult();
        this.currentObservable.query.resetLastResults();
        this.startQuerySubscription();
        Object.assign(this.currentObservable.query, {
            lastError: lastError,
            lastResult: lastResult
        });
    };
    QueryData.prototype.getQueryResult = function() {
        var result = this.observableQueryFields();
        var options = this.getOptions();
        if (options.skip) result = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
            data: undefined,
            error: undefined,
            loading: false,
            called: true
        });
        else {
            var currentResult = this.currentObservable.query.getCurrentResult();
            var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
            var error = currentResult.error, data = currentResult.data;
            if (errors && errors.length > 0) error = new (0, $jlBDe.ApolloError)({
                graphQLErrors: errors
            });
            result = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
                loading: loading,
                networkStatus: networkStatus,
                error: error,
                called: true
            });
            if (loading) {
                var previousData = this.previousData.result && this.previousData.result.data;
                result.data = previousData && data ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, previousData), data) : previousData || data;
            } else if (error) Object.assign(result, {
                data: (this.currentObservable.query.getLastResult() || {}).data
            });
            else {
                var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
                var partialRefetch = options.partialRefetch;
                if (partialRefetch && !data && partial && fetchPolicy !== 'cache-only') {
                    Object.assign(result, {
                        loading: true,
                        networkStatus: (0, $jlBDe.NetworkStatus).loading
                    });
                    result.refetch();
                    return result;
                }
                result.data = data;
            }
        }
        result.client = this.client;
        this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
        this.previousData.result = result;
        return result;
    };
    QueryData.prototype.handleErrorOrCompleted = function() {
        var obsQuery = this.currentObservable.query;
        if (!obsQuery) return;
        var _a = obsQuery.getCurrentResult(), data = _a.data, loading = _a.loading, error = _a.error;
        if (!loading) {
            var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError;
            if (this.previousOptions && !this.previousData.loading && (0, $66hGB.equal)(this.previousOptions.query, query) && (0, $66hGB.equal)(this.previousOptions.variables, variables)) return;
            if (onCompleted && !error) onCompleted(data);
            else if (onError && error) onError(error);
        }
    };
    QueryData.prototype.removeQuerySubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    QueryData.prototype.observableQueryFields = function() {
        var observable = this.currentObservable.query;
        return {
            variables: observable.variables,
            refetch: this.obsRefetch,
            fetchMore: this.obsFetchMore,
            updateQuery: this.obsUpdateQuery,
            startPolling: this.obsStartPolling,
            stopPolling: this.obsStopPolling,
            subscribeToMore: this.obsSubscribeToMore
        };
    };
    return QueryData;
}($dd35afdbf6e72e7e$var$OperationData);
function $dd35afdbf6e72e7e$var$useDeepMemo(memoFn, key) {
    var ref = (0, $eUqFw.useRef)();
    if (!ref.current || !(0, $66hGB.equal)(key, ref.current.key)) ref.current = {
        key: key,
        value: memoFn()
    };
    return ref.current.value;
}
function $dd35afdbf6e72e7e$var$useBaseQuery(query, options, lazy) {
    if (lazy === void 0) lazy = false;
    var context = (0, $eUqFw.useContext)((0, $4ErPU.getApolloContext)());
    var _a = (0, $eUqFw.useReducer)(function(x) {
        return x + 1;
    }, 0), tick = _a[0], forceUpdate = _a[1];
    var updatedOptions = options ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
        query: query
    }) : {
        query: query
    };
    var queryDataRef = (0, $eUqFw.useRef)();
    if (!queryDataRef.current) queryDataRef.current = new $dd35afdbf6e72e7e$var$QueryData({
        options: updatedOptions,
        context: context,
        forceUpdate: forceUpdate
    });
    var queryData = queryDataRef.current;
    queryData.setOptions(updatedOptions);
    queryData.context = context;
    var memo = {
        options: (0, $fKE23.__assign)((0, $fKE23.__assign)({}, updatedOptions), {
            onError: undefined,
            onCompleted: undefined
        }),
        context: context,
        tick: tick
    };
    var result = $dd35afdbf6e72e7e$var$useDeepMemo(function() {
        return lazy ? queryData.executeLazy() : queryData.execute();
    }, memo);
    var queryResult = lazy ? result[1] : result;
    (0, $eUqFw.useEffect)(function() {
        return queryData.afterExecute({
            lazy: lazy
        });
    }, [
        queryResult.loading,
        queryResult.networkStatus,
        queryResult.error,
        queryResult.data
    ]);
    (0, $eUqFw.useEffect)(function() {
        return function() {
            return queryData.cleanup();
        };
    }, []);
    return result;
}
function $dd35afdbf6e72e7e$export$dd0a697e1782aedd(query, options) {
    return $dd35afdbf6e72e7e$var$useBaseQuery(query, options, false);
}
function $dd35afdbf6e72e7e$export$fd83eea6ecd2d8fa(query, options) {
    return $dd35afdbf6e72e7e$var$useBaseQuery(query, options, true);
}
var $dd35afdbf6e72e7e$var$MutationData = function(_super) {
    (0, $fKE23.__extends)(MutationData, _super);
    function MutationData(_a) {
        var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.runMutation = function(mutationFunctionOptions) {
            if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
            _this.onMutationStart();
            var mutationId = _this.generateNewMutationId();
            return _this.mutate(mutationFunctionOptions).then(function(response) {
                _this.onMutationCompleted(response, mutationId);
                return response;
            }).catch(function(error) {
                _this.onMutationError(error, mutationId);
                if (!_this.getOptions().onError) throw error;
            });
        };
        _this.verifyDocumentType(options.mutation, (0, $4ErPU.DocumentType).Mutation);
        _this.result = result;
        _this.setResult = setResult;
        _this.mostRecentMutationId = 0;
        return _this;
    }
    MutationData.prototype.execute = function(result) {
        this.isMounted = true;
        this.verifyDocumentType(this.getOptions().mutation, (0, $4ErPU.DocumentType).Mutation);
        result.client = this.refreshClient().client;
        return [
            this.runMutation,
            result
        ];
    };
    MutationData.prototype.afterExecute = function() {
        this.isMounted = true;
        return this.unmount.bind(this);
    };
    MutationData.prototype.cleanup = function() {};
    MutationData.prototype.mutate = function(mutationFunctionOptions) {
        var _a = this.getOptions(), mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, mutationContext = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
        var mutateOptions = (0, $fKE23.__assign)({}, mutationFunctionOptions);
        var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
        delete mutateOptions.variables;
        return this.refreshClient().client.mutate((0, $fKE23.__assign)({
            mutation: mutation,
            optimisticResponse: optimisticResponse,
            refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
            awaitRefetchQueries: awaitRefetchQueries,
            update: update,
            context: mutationContext,
            fetchPolicy: fetchPolicy,
            variables: mutateVariables
        }, mutateOptions));
    };
    MutationData.prototype.onMutationStart = function() {
        if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
            loading: true,
            error: undefined,
            data: undefined,
            called: true
        });
    };
    MutationData.prototype.onMutationCompleted = function(response, mutationId) {
        var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
        var data = response.data, errors = response.errors;
        var error = errors && errors.length > 0 ? new (0, $jlBDe.ApolloError)({
            graphQLErrors: errors
        }) : undefined;
        var callOncomplete = function() {
            return onCompleted ? onCompleted(data) : null;
        };
        if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
            called: true,
            loading: false,
            data: data,
            error: error
        });
        callOncomplete();
    };
    MutationData.prototype.onMutationError = function(error, mutationId) {
        var onError = this.getOptions().onError;
        if (this.isMostRecentMutation(mutationId)) this.updateResult({
            loading: false,
            error: error,
            data: undefined,
            called: true
        });
        if (onError) onError(error);
    };
    MutationData.prototype.generateNewMutationId = function() {
        return ++this.mostRecentMutationId;
    };
    MutationData.prototype.isMostRecentMutation = function(mutationId) {
        return this.mostRecentMutationId === mutationId;
    };
    MutationData.prototype.updateResult = function(result) {
        if (this.isMounted && (!this.previousResult || !(0, $66hGB.equal)(this.previousResult, result))) {
            this.setResult(result);
            this.previousResult = result;
        }
    };
    return MutationData;
}($dd35afdbf6e72e7e$var$OperationData);
function $dd35afdbf6e72e7e$export$609860bf8b0084c(mutation, options) {
    var context = (0, $eUqFw.useContext)((0, $4ErPU.getApolloContext)());
    var _a = (0, $eUqFw.useState)({
        called: false,
        loading: false
    }), result = _a[0], setResult = _a[1];
    var updatedOptions = options ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
        mutation: mutation
    }) : {
        mutation: mutation
    };
    var mutationDataRef = (0, $eUqFw.useRef)();
    function getMutationDataRef() {
        if (!mutationDataRef.current) mutationDataRef.current = new $dd35afdbf6e72e7e$var$MutationData({
            options: updatedOptions,
            context: context,
            result: result,
            setResult: setResult
        });
        return mutationDataRef.current;
    }
    var mutationData = getMutationDataRef();
    mutationData.setOptions(updatedOptions);
    mutationData.context = context;
    (0, $eUqFw.useEffect)(function() {
        return mutationData.afterExecute();
    });
    return mutationData.execute(result);
}
var $dd35afdbf6e72e7e$var$SubscriptionData = function(_super) {
    (0, $fKE23.__extends)(SubscriptionData, _super);
    function SubscriptionData(_a) {
        var options = _a.options, context = _a.context, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.currentObservable = {};
        _this.setResult = setResult;
        _this.initialize(options);
        return _this;
    }
    SubscriptionData.prototype.execute = function(result) {
        if (this.getOptions().skip === true) {
            this.cleanup();
            return {
                loading: false,
                error: undefined,
                data: undefined,
                variables: this.getOptions().variables
            };
        }
        var currentResult = result;
        if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
        var shouldResubscribe = this.getOptions().shouldResubscribe;
        if (typeof shouldResubscribe === 'function') shouldResubscribe = !!shouldResubscribe(this.getOptions());
        if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $66hGB.equal)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
            this.cleanup();
            currentResult = this.getLoadingResult();
        }
        this.initialize(this.getOptions());
        this.startSubscription();
        this.previousOptions = this.getOptions();
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, currentResult), {
            variables: this.getOptions().variables
        });
    };
    SubscriptionData.prototype.afterExecute = function() {
        this.isMounted = true;
    };
    SubscriptionData.prototype.cleanup = function() {
        this.endSubscription();
        delete this.currentObservable.query;
    };
    SubscriptionData.prototype.initialize = function(options) {
        if (this.currentObservable.query || this.getOptions().skip === true) return;
        this.currentObservable.query = this.refreshClient().client.subscribe({
            query: options.subscription,
            variables: options.variables,
            fetchPolicy: options.fetchPolicy
        });
    };
    SubscriptionData.prototype.startSubscription = function() {
        if (this.currentObservable.subscription) return;
        this.currentObservable.subscription = this.currentObservable.query.subscribe({
            next: this.updateCurrentData.bind(this),
            error: this.updateError.bind(this),
            complete: this.completeSubscription.bind(this)
        });
    };
    SubscriptionData.prototype.getLoadingResult = function() {
        return {
            loading: true,
            error: undefined,
            data: undefined
        };
    };
    SubscriptionData.prototype.updateResult = function(result) {
        if (this.isMounted) this.setResult(result);
    };
    SubscriptionData.prototype.updateCurrentData = function(result) {
        var onSubscriptionData = this.getOptions().onSubscriptionData;
        this.updateResult({
            data: result.data,
            loading: false,
            error: undefined
        });
        if (onSubscriptionData) onSubscriptionData({
            client: this.refreshClient().client,
            subscriptionData: result
        });
    };
    SubscriptionData.prototype.updateError = function(error) {
        this.updateResult({
            error: error,
            loading: false
        });
    };
    SubscriptionData.prototype.completeSubscription = function() {
        var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
        if (onSubscriptionComplete) onSubscriptionComplete();
        this.endSubscription();
    };
    SubscriptionData.prototype.endSubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    return SubscriptionData;
}($dd35afdbf6e72e7e$var$OperationData);
function $dd35afdbf6e72e7e$export$368b4214baeb914c(subscription, options) {
    var context = (0, $eUqFw.useContext)((0, $4ErPU.getApolloContext)());
    var updatedOptions = options ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
        subscription: subscription
    }) : {
        subscription: subscription
    };
    var _a = (0, $eUqFw.useState)({
        loading: !updatedOptions.skip,
        error: undefined,
        data: undefined
    }), result = _a[0], setResult = _a[1];
    var subscriptionDataRef = (0, $eUqFw.useRef)();
    function getSubscriptionDataRef() {
        if (!subscriptionDataRef.current) subscriptionDataRef.current = new $dd35afdbf6e72e7e$var$SubscriptionData({
            options: updatedOptions,
            context: context,
            setResult: setResult
        });
        return subscriptionDataRef.current;
    }
    var subscriptionData = getSubscriptionDataRef();
    subscriptionData.setOptions(updatedOptions, true);
    subscriptionData.context = context;
    (0, $eUqFw.useEffect)(function() {
        return subscriptionData.afterExecute();
    });
    (0, $eUqFw.useEffect)(function() {
        return subscriptionData.cleanup.bind(subscriptionData);
    }, []);
    return subscriptionData.execute(result);
}
function $dd35afdbf6e72e7e$export$eb9a56e7a29e494() {
    var client = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext((0, $4ErPU.getApolloContext)()).client;
    (0, $8j2fP.invariant)(client, 1);
    return client;
}
function $dd35afdbf6e72e7e$var$makeDefaultQueryInfo() {
    return {
        seen: false,
        observable: null
    };
}
var $dd35afdbf6e72e7e$export$260e90e395a79974 = function() {
    function RenderPromises() {
        this.queryPromises = new Map();
        this.queryInfoTrie = new Map();
    }
    RenderPromises.prototype.registerSSRObservable = function(observable, props) {
        this.lookupQueryInfo(props).observable = observable;
    };
    RenderPromises.prototype.getSSRObservable = function(props) {
        return this.lookupQueryInfo(props).observable;
    };
    RenderPromises.prototype.addQueryPromise = function(queryInstance, finish) {
        var info = this.lookupQueryInfo(queryInstance.getOptions());
        if (!info.seen) {
            this.queryPromises.set(queryInstance.getOptions(), new Promise(function(resolve) {
                resolve(queryInstance.fetchData());
            }));
            return null;
        }
        return finish();
    };
    RenderPromises.prototype.hasPromises = function() {
        return this.queryPromises.size > 0;
    };
    RenderPromises.prototype.consumeAndAwaitPromises = function() {
        var _this = this;
        var promises = [];
        this.queryPromises.forEach(function(promise, queryInstance) {
            _this.lookupQueryInfo(queryInstance).seen = true;
            promises.push(promise);
        });
        this.queryPromises.clear();
        return Promise.all(promises);
    };
    RenderPromises.prototype.lookupQueryInfo = function(props) {
        var queryInfoTrie = this.queryInfoTrie;
        var query = props.query, variables = props.variables;
        var varMap = queryInfoTrie.get(query) || new Map();
        if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
        var variablesString = JSON.stringify(variables);
        var info = varMap.get(variablesString) || $dd35afdbf6e72e7e$var$makeDefaultQueryInfo();
        if (!varMap.has(variablesString)) varMap.set(variablesString, info);
        return info;
    };
    return RenderPromises;
}();

});

parcelRegister("6JePA", function(module, exports) {

$parcel$export(module.exports, "transformQueryResults", () => $c67a3cc063568db1$export$142cac81f59c4a2b);
$parcel$export(module.exports, "transformQueryData", () => $c67a3cc063568db1$export$e87b478b11690bbe);
$parcel$export(module.exports, "tranformSubtaskData", () => $c67a3cc063568db1$export$2406de70fd65131a);
$parcel$export(module.exports, "tranformModalLoadDataInContext", () => $c67a3cc063568db1$export$6f0b5e0a42086cba);

var $illlw = parcelRequire("illlw");

var $ldoFd = parcelRequire("ldoFd");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $dEMIg = parcelRequire("dEMIg");

var $fFvAc = parcelRequire("fFvAc");

var $lO4Or = parcelRequire("lO4Or");

var $lG4nv = parcelRequire("lG4nv");


var $aJRvJ = parcelRequire("aJRvJ");

var $2yhuM = parcelRequire("2yhuM");

var $amtY1 = parcelRequire("amtY1");
const $c67a3cc063568db1$var$getTabLayoutInfoOld = ({ data: data, onlyRequiredField: onlyRequiredField = false, allFieldIds: allFieldIds = [] })=>{
    const fieldTabs = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(data, 'jiraIssueCreateLayout.contentSection.items', []).map(({ id: id, name: name, items: items })=>{
        if (onlyRequiredField) {
            // @ts-expect-error - TS7031 - Binding element 'fieldId' implicitly has an 'any' type.
            const filteredItems = items.filter(({ fieldId: fieldId })=>allFieldIds.includes(fieldId));
            return filteredItems.length === 0 ? null : {
                id: id,
                name: name,
                items: filteredItems.map(({ fieldId: fieldId })=>fieldId)
            };
        }
        return {
            id: id,
            name: name,
            items: items// @ts-expect-error - TS7031 - Binding element 'fieldId' implicitly has an 'any' type.
            .filter(({ fieldId: fieldId })=>allFieldIds.includes(fieldId))// @ts-expect-error - TS7031 - Binding element 'fieldId' implicitly has an 'any' type.
            .map(({ fieldId: fieldId })=>fieldId)
        };
    }).filter(Boolean);
    return fieldTabs;
};
const $c67a3cc063568db1$var$getTabLayoutInfoNew = ({ data: data, onlyRequiredField: onlyRequiredField = false, allFieldIds: allFieldIds = [] })=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const fieldTabs = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(data, 'jiraIssueCreateLayout.contentSection.items', []);
    return fieldTabs.map(({ id: id, name: name, items: items, collapsedItems: collapsedItems })=>{
        const filterItems = (itemsToFilter)=>itemsToFilter.filter(({ fieldId: fieldId })=>allFieldIds.includes(fieldId)).map(({ fieldId: fieldId })=>fieldId);
        const filteredItems = filterItems(items || []);
        const filteredCollapsedItems = filterItems(collapsedItems || []);
        const result = {
            id: id,
            name: name,
            items: filteredItems
        };
        result.collapsedItems = filteredCollapsedItems;
        if (onlyRequiredField && result.items.length === 0 && result.collapsedItems.length === 0) return null;
        return result;
    }).filter((tab)=>!!tab);
};
const $c67a3cc063568db1$export$1da66c24c878ae7 = ({ data: data, onlyRequiredField: onlyRequiredField = false, allFieldIds: allFieldIds = [] })=>{
    if ((0, $1ybV0.ff)('gic-smart-fields-jira-labs_8uwvr')) return $c67a3cc063568db1$var$getTabLayoutInfoNew({
        data: data,
        onlyRequiredField: onlyRequiredField,
        allFieldIds: allFieldIds
    });
    return $c67a3cc063568db1$var$getTabLayoutInfoOld({
        data: data,
        onlyRequiredField: onlyRequiredField,
        allFieldIds: allFieldIds
    });
};
const $c67a3cc063568db1$export$da99f019bcffa6fb = (timeTrackingSettings)=>{
    if (timeTrackingSettings) {
        const { defaultFormat: defaultFormat, workingDaysPerWeek: workingDaysPerWeek, workingHoursPerDay: workingHoursPerDay, defaultUnit: defaultUnit, isJiraConfiguredTimeTrackingEnabled: isJiraConfiguredTimeTrackingEnabled } = timeTrackingSettings;
        let format = '';
        if (defaultFormat === 'DAYS') format = 'days';
        else if (defaultFormat === 'HOURS') format = 'hours';
        else format = 'pretty';
        let unit = '';
        if (defaultUnit === 'DAY') unit = 'day';
        else if (defaultUnit === 'HOUR') unit = 'hour';
        else if (defaultUnit === 'MINUTE') unit = 'minute';
        else unit = 'week';
        return {
            daysPerWeek: workingDaysPerWeek,
            hoursPerDay: workingHoursPerDay,
            format: // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Format | undefined'.
            format,
            // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'DefaultUnit'.
            defaultUnit: unit,
            isTimeTrackingEnabled: isJiraConfiguredTimeTrackingEnabled
        };
    }
    return undefined;
};
const $c67a3cc063568db1$export$603097abf044854 = (data, onlyRequiredField = false)=>{
    const fields = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(data, 'jiraIssueCreateFields.fields.nodes', []);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const contextFields = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const fieldConfigData = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const requiredFieldConfigData = {};
    let isRequiredFieldComponentSupported = true;
    let gqlTypeBeingProcessed;
    fields.forEach((fieldData)=>{
        try {
            const { __typename: gqlType, fieldId: fieldId, name: name, type: type, description: description, fieldConfig: fieldConfig = {}, searchUrl: searchUrl, mediaContext: mediaContext, adminRichTextConfig: adminRichTextConfig, isMulti: isMulti, attributesIncludedInAutoCompleteSearch: attributesIncludedInAutoCompleteSearch, timeTrackingSettings: timeTrackingSettings, maxAllowedTotalAttachmentsSize: maxAllowedTotalAttachmentsSize } = fieldData;
            gqlTypeBeingProcessed = gqlType;
            if (fieldId && !(0, $dEMIg.UNSUPPORTED_FIELD_TYPES_IN_GIC).includes(type)) {
                if ((0, $lG4nv.CONTEXT_FIELD_TYPES).includes(gqlType) && type !== (0, $lO4Or.PROJECT_PICKER_CF_TYPE)) {
                    let transformedData;
                    if (gqlType === (0, $b1ba189bc6d9d9ad$export$aa5680ad8f8be9fc)) {
                        transformedData = (0, $aJRvJ.transformProjectField)(fieldData);
                        contextFields[fieldId] = transformedData;
                    }
                    if (gqlType === (0, $b1ba189bc6d9d9ad$export$2d5a62a3515ad4c6)) {
                        transformedData = (0, $aJRvJ.transformIssueTypeField)(fieldData);
                        contextFields[fieldId] = transformedData;
                    }
                    if (gqlType === (0, $b1ba189bc6d9d9ad$export$a12a4b25ab12710c)) {
                        const requestTypeFieldData = fieldData;
                        // @ts-expect-error - TS2339 Property 'requestType' does not exist on type 'never'.
                        if (requestTypeFieldData?.requestType?.issueType) // @ts-expect-error - TS2339 Property 'requestType' does not exist on type 'never'.
                        requestTypeFieldData.requestType.issueType.issueTypeName = contextFields?.issuetype?.selectedIssueType?.label;
                        transformedData = (0, $aJRvJ.transformRequestTypeField)(requestTypeFieldData);
                        contextFields.requestType = transformedData;
                    }
                } else {
                    const gqlTypeWithOverride = (0, $amtY1.overrideGqlTypes)(fieldData);
                    const gqlFieldConfig = // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly JiraAffectedServicesField: { readonly Component: AbstractComponent<ReturnComponentProps<AffectedServicesFieldConfig>, any>; readonly defaultValueKey: "selectedAffectedServices"; readonly submitTransform: (options: AffectedServiceOption[]) => ServiceEntity[]; readonly retainUserInputTransform: (selectedAff...'.
                    (0, $lG4nv.getGqlFieldMap)()[gqlTypeWithOverride] || {};
                    const { defaultValueKey: defaultValueKey, allowedValuesKey: allowedValuesKey } = gqlFieldConfig;
                    let defaultValue;
                    if (Array.isArray(defaultValueKey) && (0, $1ybV0.ff)('support-data-classification-field-in-gic_x6lda')) defaultValue = defaultValueKey.map((key)=>key && (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldData, key, undefined));
                    else defaultValue = defaultValueKey && (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldData, defaultValueKey, undefined);
                    const allowedValues = allowedValuesKey && (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldData, allowedValuesKey, undefined);
                    // @ts-expect-error - TS2339 Property 'isRequired' does not exist on type '{}'.
                    const isRequired = fieldConfig?.isRequired || false;
                    // @ts-expect-error - TS2339 Property 'isEditable' does not exist on type '{}'.
                    const isEditable = fieldConfig?.isEditable;
                    // @ts-expect-error - TS2339 Property 'nonEditableReason' does not exist on type '{}'.
                    const nonEditableReason = fieldConfig?.nonEditableReason || {};
                    const copyLinksAndAttachments = (0, $1ybV0.ff)('create-linked-issues-trigger-point-issue-view') && gqlTypeWithOverride === (0, $b1ba189bc6d9d9ad$export$47af4d6f62c134cf) ? fieldData?.copyLinksAndAttachments : undefined;
                    fieldConfigData[fieldId] = {
                        gqlType: gqlTypeWithOverride,
                        fieldId: fieldId,
                        fieldName: name,
                        fieldType: type,
                        description: description,
                        isRequired: isRequired,
                        isEditable: isEditable,
                        nonEditableReason: nonEditableReason,
                        autoCompleteUrl: (0, $fFvAc.transformStargateUrl)(searchUrl || ''),
                        defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(defaultValue) ? undefined : defaultValue,
                        allowedValues: allowedValues,
                        additionalData: {
                            mediaContext: mediaContext,
                            isMulti: isMulti,
                            attributesIncludedInAutoCompleteSearch: attributesIncludedInAutoCompleteSearch,
                            timeTrackingSettings: $c67a3cc063568db1$export$da99f019bcffa6fb(timeTrackingSettings),
                            maxAllowedTotalAttachmentsSize: maxAllowedTotalAttachmentsSize,
                            ...(0, $1ybV0.ff)('create-linked-issues-trigger-point-issue-view') ? {
                                copyLinksAndAttachments: copyLinksAndAttachments
                            } : {}
                        }
                    };
                    if (adminRichTextConfig) fieldConfigData[fieldId].additionalData.adminRichTextConfig = adminRichTextConfig;
                    if (onlyRequiredField && isRequired) requiredFieldConfigData[fieldId] = fieldConfigData[fieldId];
                    if (isRequired && !('Component' in gqlFieldConfig)) isRequiredFieldComponentSupported = false;
                }
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'processingApiFieldData',
                    packageName: 'jiraIssueCreate',
                    teamName: 'gryffindor'
                },
                error: error,
                attributes: {
                    error: `processing ${gqlTypeBeingProcessed} failed`
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    });
    // process fields which are not supported in graphql layer
    const errors = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(data, 'jiraIssueCreateFields.errors', []);
    const { unsupportedFields: unsupportedFields, isRequiredFieldTypeSupported: isRequiredFieldTypeSupported } = (0, $2yhuM.getGqlUnsupportedFields)(errors);
    return {
        fieldConfig: onlyRequiredField ? {
            ...requiredFieldConfigData
        } : {
            ...fieldConfigData,
            ...unsupportedFields
        },
        contextFields: contextFields,
        meta: {
            areRequiredFieldsSupported: isRequiredFieldTypeSupported && isRequiredFieldComponentSupported
        }
    };
};
const $c67a3cc063568db1$export$5fe007c334fc070a = (data)=>{
    const nodes = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(data, 'jiraIssueCreateAdditionalServices.services.edges', []);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const services = {};
    nodes.forEach(({ node: node })=>{
        services[node.serviceId] = node;
    });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return services;
};
const $c67a3cc063568db1$export$142cac81f59c4a2b = (data, onlyRequiredField = false)=>{
    const fieldKeyedById = $c67a3cc063568db1$export$603097abf044854(data, onlyRequiredField);
    const { watchers: watchers, proforma: proforma } = $c67a3cc063568db1$export$5fe007c334fc070a(data);
    const result = {
        fieldTabs: $c67a3cc063568db1$export$1da66c24c878ae7({
            data: data,
            onlyRequiredField: onlyRequiredField,
            allFieldIds: Object.keys(fieldKeyedById.fieldConfig)
        }),
        ...fieldKeyedById,
        meta: {
            ...fieldKeyedById.meta,
            queryErrorMessage: (0, $2yhuM.getQueryErrorMessage)(data)
        },
        additionalServices: {
            watchersConfigurations: watchers?.permissions,
            proformaConfiguration: proforma?.proforma
        }
    };
    return $c67a3cc063568db1$var$validateRequiredFieldsFromTransformQueryResults(result);
};
const $c67a3cc063568db1$var$validateRequiredFieldsFromTransformQueryResults = (result)=>{
    const { fieldTabs: fieldTabs, fieldConfig: fieldConfig } = result;
    const errorFields = [];
    const newFieldTabs = fieldTabs.map((tab)=>{
        if (!tab.collapsedItems) return tab;
        const collapsedItems = tab.collapsedItems.filter((fieldId)=>{
            const field = fieldConfig[fieldId];
            if (field?.isRequired || fieldId === 'summary') {
                !(0, $1ybV0.ff)('gic-smart-fields-remove-required-sentry-error_9jlqp') && errorFields.push(fieldId);
                return false;
            }
            return true;
        });
        return {
            ...tab,
            collapsedItems: collapsedItems
        };
    });
    if (!(0, $1ybV0.ff)('gic-smart-fields-remove-required-sentry-error_9jlqp')) {
        if (errorFields.length > 0) (0, $guiFP.default)({
            meta: {
                id: 'gicValidateTransformQueryResults',
                packageName: 'jiraIssueCreate',
                teamName: 'gryffindor'
            },
            error: new Error('Some required fields were collapsed'),
            attributes: {
                errorFields: errorFields.map((fieldId)=>({
                        fieldId: fieldId,
                        isRequired: fieldConfig[fieldId]?.isRequired
                    })),
                error: 'Some required fields were collapsed'
            },
            sendToPrivacyUnsafeSplunk: true
        });
    }
    return {
        ...result,
        fieldTabs: newFieldTabs
    };
};
const $c67a3cc063568db1$export$e87b478b11690bbe = (data)=>({
        jiraIssueCreateFields: {
            ...data.jiraIssueCreateFields
        },
        ...data.jiraIssueCreateAdditionalServices ? {
            jiraIssueCreateAdditionalServices: {
                ...data.jiraIssueCreateAdditionalServices
            }
        } : {},
        jiraIssueCreateLayout: Object.prototype.hasOwnProperty.call(data, 'jiraIssueCreateLayoutWithML') ? {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ...data.jiraIssueCreateLayoutWithML
        } : {
            ...data.jiraIssueCreateLayout
        }
    });
const $c67a3cc063568db1$var$tranformSubtaskDataOld = (data)=>({
        jiraIssueCreateFields: {
            ...data.jiraSubtaskCreationFields
        },
        jiraIssueCreateLayout: {
            ...data.jiraSubtaskCreationLayout
        },
        jiraIssueCreateAdditionalServices: {
            ...data.jiraSubtaskCreationAdditionalServices
        }
    });
const $c67a3cc063568db1$var$tranformSubtaskDataNew = (data)=>({
        jiraIssueCreateFields: {
            ...data.jiraSubtaskCreationFields
        },
        jiraIssueCreateAdditionalServices: {
            ...data.jiraSubtaskCreationAdditionalServices
        },
        jiraIssueCreateLayout: Object.prototype.hasOwnProperty.call(data, 'jiraSubtaskCreationLayoutWithML') ? {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ...data.jiraSubtaskCreationLayoutWithML
        } : {
            ...data.jiraSubtaskCreationLayout
        }
    });
const $c67a3cc063568db1$export$2406de70fd65131a = (data)=>{
    if ((0, $1ybV0.ff)('gic-smart-fields-jira-labs_8uwvr')) return $c67a3cc063568db1$var$tranformSubtaskDataNew(data);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return $c67a3cc063568db1$var$tranformSubtaskDataOld(data);
};
const $c67a3cc063568db1$export$3882cbedc41c0e0a = (data)=>({
        jiraIssueCreateFields: {
            ...data.jiraIssueCreateFieldsInContext
        },
        jiraIssueCreateLayout: {
            ...data.jiraIssueCreateLayoutInContext
        },
        jiraIssueCreateAdditionalServices: {
            ...data.jiraIssueCreateAdditionalServices
        }
    });
const $c67a3cc063568db1$export$9fb58334c8cb6162 = (data)=>({
        jiraIssueCreateFields: {
            ...data.jiraIssueCreateFieldsInContext
        },
        jiraIssueCreateAdditionalServices: {
            ...data.jiraIssueCreateAdditionalServices
        },
        jiraIssueCreateLayout: Object.prototype.hasOwnProperty.call(data, 'jiraIssueCreateLayoutInContextWithML') ? {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ...data.jiraIssueCreateLayoutInContextWithML
        } : {
            ...data.jiraIssueCreateLayoutInContext
        }
    });
const $c67a3cc063568db1$export$6f0b5e0a42086cba = (data)=>{
    if ((0, $1ybV0.ff)('gic-smart-fields-jira-labs_8uwvr')) return $c67a3cc063568db1$export$9fb58334c8cb6162(data);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return $c67a3cc063568db1$export$3882cbedc41c0e0a(data);
};

});
parcelRegister("lG4nv", function(module, exports) {

$parcel$export(module.exports, "getGqlFieldMap", () => $633c9eab6bea64b6$export$472717ed4aec82f1);
$parcel$export(module.exports, "UPDATE_FIELDS_CREATE_LINKED_ISSUE", () => $633c9eab6bea64b6$export$aed6a8ebeb442f9);
$parcel$export(module.exports, "UPDATE_FIELDS", () => $633c9eab6bea64b6$export$e7c3e130e221f1f1);
$parcel$export(module.exports, "CONTEXT_FIELD_TYPES", () => $633c9eab6bea64b6$export$ccf7c75b07963f11);

var $5iWql = parcelRequire("5iWql");

var $1ybV0 = parcelRequire("1ybV0");

var $eQWPb = parcelRequire("eQWPb");
var $j2ArP = parcelRequire("j2ArP");
var $6nTlM = parcelRequire("6nTlM");
var $cVsIh = parcelRequire("cVsIh");
var $8MMgG = parcelRequire("8MMgG");
var $l3c1m = parcelRequire("l3c1m");
var $6ynFi = parcelRequire("6ynFi");
var $aYzpN = parcelRequire("aYzpN");
var $5hGgp = parcelRequire("5hGgp");
var $5GK4N = parcelRequire("5GK4N");
var $kfu77 = parcelRequire("kfu77");
var $5hR1J = parcelRequire("5hR1J");
var $2sjGj = parcelRequire("2sjGj");
var $4KGIz = parcelRequire("4KGIz");
var $l7nwo = parcelRequire("l7nwo");
var $9PXwb = parcelRequire("9PXwb");
var $6BUcO = parcelRequire("6BUcO");
var $bcUzb = parcelRequire("bcUzb");
var $j6rDO = parcelRequire("j6rDO");
var $74tp8 = parcelRequire("74tp8");
var $dR4yn = parcelRequire("dR4yn");
var $i8BXG = parcelRequire("i8BXG");
var $lWQTA = parcelRequire("lWQTA");
var $8AMXG = parcelRequire("8AMXG");
var $hQhuO = parcelRequire("hQhuO");
var $7EBWy = parcelRequire("7EBWy");
var $h5iE1 = parcelRequire("h5iE1");
var $kMBLZ = parcelRequire("kMBLZ");
var $ddgk1 = parcelRequire("ddgk1");
var $iuMpO = parcelRequire("iuMpO");
var $8YKza = parcelRequire("8YKza");
var $8aayW = parcelRequire("8aayW");
var $k8ImN = parcelRequire("k8ImN");
var $fV68f = parcelRequire("fV68f");
var $aRKjl = parcelRequire("aRKjl");
var $aU3XJ = parcelRequire("aU3XJ");
var $j0x3u = parcelRequire("j0x3u");
var $dLN4D = parcelRequire("dLN4D");
var $dkhuh = parcelRequire("dkhuh");
var $5F4bs = parcelRequire("5F4bs");
var $6Wef2 = parcelRequire("6Wef2");
var $ksJvI = parcelRequire("ksJvI");
var $bRVha = parcelRequire("bRVha");
var $14d8O = parcelRequire("14d8O");
var $ia8XI = parcelRequire("ia8XI");
var $6gsqy = parcelRequire("6gsqy");
var $897qz = parcelRequire("897qz");
var $3O2c6 = parcelRequire("3O2c6");
var $6Pq4z = parcelRequire("6Pq4z");
var $gtaAU = parcelRequire("gtaAU");
var $3x0xT = parcelRequire("3x0xT");
var $ePdOt = parcelRequire("ePdOt");
var $3GT6n = parcelRequire("3GT6n");
var $5TtxV = parcelRequire("5TtxV");
var $ljNBY = parcelRequire("ljNBY");
var $5d2AR = parcelRequire("5d2AR");
var $5u49X = parcelRequire("5u49X");
var $eUIIn = parcelRequire("eUIIn");
var $b81gR = parcelRequire("b81gR");
var $frqgn = parcelRequire("frqgn");
var $ltG3Y = parcelRequire("ltG3Y");
var $0dKMy = parcelRequire("0dKMy");
var $3n4oY = parcelRequire("3n4oY");
var $f6c5h = parcelRequire("f6c5h");
var $dA8Yc = parcelRequire("dA8Yc");
var $4Dz8o = parcelRequire("4Dz8o");
var $ikozW = parcelRequire("ikozW");
var $k4Bm6 = parcelRequire("k4Bm6");
var $60BSb = parcelRequire("60BSb");
var $39m9P = parcelRequire("39m9P");
var $gO6fZ = parcelRequire("gO6fZ");
var $a3FRc = parcelRequire("a3FRc");
var $fKpo5 = parcelRequire("fKpo5");
var $9LZ9B = parcelRequire("9LZ9B");

var $bRVha = parcelRequire("bRVha");

var $3pjiv = parcelRequire("3pjiv");

var $ddgk1 = parcelRequire("ddgk1");

var $8JQyN = parcelRequire("8JQyN");

var $ed9FR = parcelRequire("ed9FR");

var $lPQPn = parcelRequire("lPQPn");

var $6t5cq = parcelRequire("6t5cq");

var $i5YRy = parcelRequire("i5YRy");

var $j8vGU = parcelRequire("j8vGU");

var $d7a37 = parcelRequire("d7a37");

var $7mH0H = parcelRequire("7mH0H");

var $6b6yO = parcelRequire("6b6yO");

var $e6t0U = parcelRequire("e6t0U");

var $gnxL7 = parcelRequire("gnxL7");

var $eamzO = parcelRequire("eamzO");

var $26Ej0 = parcelRequire("26Ej0");

var $cAsYI = parcelRequire("cAsYI");

var $3K8W2 = parcelRequire("3K8W2");

var $aFVOZ = parcelRequire("aFVOZ");

var $2XekW = parcelRequire("2XekW");

var $25vda = parcelRequire("25vda");

var $l6Z7J = parcelRequire("l6Z7J");

var $cWMyd = parcelRequire("cWMyd");

var $lKd2p = parcelRequire("lKd2p");

var $42gdJ = parcelRequire("42gdJ");

var $cbDYy = parcelRequire("cbDYy");

var $9tBd5 = parcelRequire("9tBd5");

var $bHNyo = parcelRequire("bHNyo");

var $lO4Or = parcelRequire("lO4Or");

var $hdX72 = parcelRequire("hdX72");
var $3rBGb = parcelRequire("3rBGb");

var $12Skn = parcelRequire("12Skn");

var $bJTcd = parcelRequire("bJTcd");
var $fokXx = parcelRequire("fokXx");

var $l8UTV = parcelRequire("l8UTV");

var $lnewE = parcelRequire("lnewE");

var $1BCWe = parcelRequire("1BCWe");

var $bXFdm = parcelRequire("bXFdm");

var $2RvjE = parcelRequire("2RvjE");
var $1S8gB = parcelRequire("1S8gB");

var $bjDIF = parcelRequire("bjDIF");
var $f34jc = parcelRequire("f34jc");

const $633c9eab6bea64b6$var$createFieldMapItems = ()=>({
        [(0, $b1ba189bc6d9d9ad$export$5e56d79dfe9be3d)]: {
            Component: (0, $eQWPb.default),
            defaultValueKey: 'selectedAffectedServices',
            submitTransform: (0, $6t5cq.mapOptionsToServiceEntities),
            retainUserInputTransform: (0, $kMBLZ.mutateAffectedServicesField)
        },
        [(0, $b1ba189bc6d9d9ad$export$23ca38ad884e35f1)]: {
            Component: (0, $fKpo5.default),
            defaultValueKey: 'text',
            retainUserInputTransform: (0, $ljNBY.mutateTextField)
        },
        [(0, $b1ba189bc6d9d9ad$export$7e5590c7c7a403c0)]: {
            Component: (0, $fKpo5.default),
            defaultValueKey: 'text',
            retainUserInputTransform: (0, $ljNBY.mutateTextField)
        },
        [(0, $b1ba189bc6d9d9ad$export$8643f0b9cefed538)]: {
            Component: (0, $fKpo5.default),
            defaultValueKey: 'text',
            retainUserInputTransform: (0, $ljNBY.mutateTextField)
        },
        [(0, $b1ba189bc6d9d9ad$export$31a6c27df1f927b2)]: {
            Component: (0, $bJTcd.default),
            defaultValueKey: 'richText.adfValue.json',
            retainUserInputTransform: (0, $fokXx.mutateADFField)
        },
        [(0, $b1ba189bc6d9d9ad$export$30b2c2de5e3007a4)]: {
            Component: (0, $5GK4N.default),
            defaultValueKey: 'selectedComponents',
            allowedValuesKey: 'components.nodes',
            submitTransform: (0, $7mH0H.mapOptionsToData),
            retainUserInputTransform: (0, $fV68f.mutateComponentsField)
        },
        ...(0, $1ybV0.ff)('support-data-classification-field-in-gic_x6lda') ? {
            [(0, $b1ba189bc6d9d9ad$export$f10e53e8928b61bd)]: {
                Component: (0, $5hR1J.default),
                defaultValueKey: [
                    'classificationLevel',
                    'defaultClassificationLevel'
                ],
                allowedValuesKey: 'classificationLevels.edges'
            }
        } : {},
        [(0, $b1ba189bc6d9d9ad$export$3849bb04b4eee607)]: {
            Component: (0, $60BSb.default),
            defaultValueKey: 'user',
            submitTransform: (0, $bRVha.mapUserOptionsToIds),
            retainUserInputTransform: (0, $bRVha.mutateSingleUserPicker)
        },
        [(0, $b1ba189bc6d9d9ad$export$745c8245fea49a34)]: {
            Component: (0, $60BSb.default),
            defaultValueKey: 'user',
            submitTransform: (0, $bRVha.mapUserOptionsToAccountIds),
            retainUserInputTransform: (0, $bRVha.mutateSingleUserPicker)
        },
        [(0, $b1ba189bc6d9d9ad$export$eca94ae30cb92d8)]: {
            Component: (0, $7EBWy.default),
            defaultValueKey: 'selectedUsers',
            submitTransform: (0, $bRVha.mapUserOptionsToIds),
            retainUserInputTransform: (0, $bRVha.mutateMultiUserPicker)
        },
        [(0, $b1ba189bc6d9d9ad$export$d41ae99ff05f5cda)]: {
            Component: (0, $7EBWy.default),
            defaultValueKey: 'selectedUsers',
            submitTransform: (0, $bRVha.mapUserOptionsToIds),
            retainUserInputTransform: (0, $bRVha.mutateMultiUserPicker)
        },
        [(0, $b1ba189bc6d9d9ad$export$bbc6b85844b0ade5)]: {
            Component: (0, $7EBWy.default),
            defaultValueKey: 'selectedUsers',
            submitTransform: (0, $bRVha.mapUserOptionsToAccountIds),
            retainUserInputTransform: (0, $bRVha.mutateMultiUserPicker)
        },
        [(0, $b1ba189bc6d9d9ad$export$2bb9d057bad89bfa)]: {
            Component: (0, $frqgn.default),
            defaultValueKey: 'selectedUsers',
            submitTransform: (0, $dR4yn.mapUserOptionOrOptionsToIds),
            retainUserInputTransform: (0, $dR4yn.mutatePeopleField)
        },
        [(0, $b1ba189bc6d9d9ad$export$b1ac879bb5cdf30a)]: {
            Component: (0, $frqgn.default),
            defaultValueKey: 'selectedUsers',
            submitTransform: (0, $dR4yn.mapUserOptionOrOptionsToIds),
            retainUserInputTransform: (0, $dR4yn.mutatePeopleField)
        },
        [(0, $b1ba189bc6d9d9ad$export$e4d5e04bc56680dc)]: {
            Component: (0, $5u49X.default),
            defaultValueKey: 'number',
            submitTransform: (0, $ia8XI.transformAsNumber),
            retainUserInputTransform: (0, $ia8XI.mutateNumberField)
        },
        [(0, $b1ba189bc6d9d9ad$export$d854193d90dc547d)]: {
            Component: (0, $5u49X.default),
            defaultValueKey: 'number',
            submitTransform: (0, $ia8XI.transformAsNumber),
            retainUserInputTransform: (0, $ia8XI.mutateNumberField)
        },
        [(0, $b1ba189bc6d9d9ad$export$e0ece81bd398c799)]: {
            Component: (0, $5u49X.default),
            defaultValueKey: 'number',
            submitTransform: (0, $ia8XI.transformAsNumber),
            retainUserInputTransform: (0, $ia8XI.mutateNumberField)
        },
        [(0, $b1ba189bc6d9d9ad$export$d8312cdfa02c100d)]: {
            Component: (0, $4KGIz.default),
            defaultValueKey: 'dateTime',
            submitTransform: (0, $aRKjl.transformDate),
            retainUserInputTransform: (0, $aU3XJ.mutateDateTimeField)
        },
        [(0, $b1ba189bc6d9d9ad$export$70ff025076e5fb13)]: {
            Component: (0, $4KGIz.default),
            defaultValueKey: 'dateTime',
            submitTransform: (0, $aRKjl.transformDate),
            retainUserInputTransform: (0, $aU3XJ.mutateDateTimeField)
        },
        ...(0, $1ybV0.ff)('parent-field-in-gic_d3b3n') && (0, $1ybV0.ff)('epic-link-and-parent-link-removed-from-gic_u1tku') ? {
            [(0, $b1ba189bc6d9d9ad$export$8723b724f0b3ac65)]: {}
        } : {
            [(0, $b1ba189bc6d9d9ad$export$8723b724f0b3ac65)]: {
                Component: (0, $l8UTV.EpicLinkField),
                defaultValueKey: 'epic',
                submitTransform: (0, $e6t0U.mapEpicLinkOptionToData),
                retainUserInputTransform: (0, $dLN4D.mutateEpicLinkField)
            }
        },
        [(0, $b1ba189bc6d9d9ad$export$64c7789e86344de5)]: {
            Component: (0, $l7nwo.default),
            defaultValueKey: 'selectedLabels',
            submitTransform: (0, $26Ej0.mapLabelOptionsToData),
            retainUserInputTransform: (0, $6Wef2.mutateLabelsFields)
        },
        [(0, $b1ba189bc6d9d9ad$export$f596336c24b128f5)]: {
            Component: (0, $l7nwo.ForgeLabelsField),
            defaultValueKey: 'selectedLabels',
            submitTransform: (0, $26Ej0.mapLabelOptionsToData),
            retainUserInputTransform: (0, $6Wef2.mutateLabelsFields)
        },
        [(0, $b1ba189bc6d9d9ad$export$3e8dded8d83b5d95)]: {
            Component: (0, $j2ArP.default),
            defaultValueKey: 'selectedAssets',
            submitTransform: (0, $ddgk1.mapAssetOptionsToAssetEntity),
            retainUserInputTransform: (0, $ddgk1.mutateAssetsFields)
        },
        [(0, $b1ba189bc6d9d9ad$export$f4f101295d5cc151)]: {
            Component: (0, $39m9P.default),
            defaultValueKey: 'version',
            allowedValuesKey: 'versions.nodes',
            submitTransform: (0, $bHNyo.getVersionId),
            retainUserInputTransform: (0, $ePdOt.mutateSingleVersionField)
        },
        [(0, $b1ba189bc6d9d9ad$export$5bb498d4f2f54799)]: {
            Component: (0, $h5iE1.default),
            defaultValueKey: 'selectedVersions',
            allowedValuesKey: 'versions.nodes',
            submitTransform: (0, $bHNyo.getVersionsIds),
            retainUserInputTransform: (0, $14d8O.mutateMultiVersionsField)
        },
        [(0, $b1ba189bc6d9d9ad$export$de14210faa5f2099)]: {
            Component: (0, $ltG3Y.default),
            defaultValueKey: 'priority',
            allowedValuesKey: 'priorities.nodes',
            submitTransform: (0, $2XekW.mapOptionToData),
            retainUserInputTransform: (0, $3O2c6.mutatePriorityField)
        },
        [(0, $b1ba189bc6d9d9ad$export$e0b268941120d761)]: {
            Component: (0, $2sjGj.default),
            defaultValueKey: 'date',
            submitTransform: (0, $aRKjl.transformDate),
            retainUserInputTransform: (0, $aRKjl.mutateDateField)
        },
        [(0, $b1ba189bc6d9d9ad$export$111f32c51678063a)]: {
            Component: (0, $2sjGj.default),
            defaultValueKey: 'date',
            submitTransform: (0, $aRKjl.transformDate),
            retainUserInputTransform: (0, $aRKjl.mutateDateField)
        },
        [(0, $b1ba189bc6d9d9ad$export$909ba97f4a791588)]: {
            Component: (0, $2RvjE.default),
            defaultValueKey: 'securityLevel',
            allowedValuesKey: 'securityLevels.nodes',
            submitTransform: (0, $1S8gB.transformOnSubmit),
            retainUserInputTransform: (0, $1S8gB.mutateSecurityLevelField)
        },
        [(0, $b1ba189bc6d9d9ad$export$76d811609080a7aa)]: {
            Component: (0, $lnewE.default),
            defaultValueKey: 'selectedRoles',
            submitTransform: (0, $lKd2p.mapRoleToRestrictionValue)
        },
        [(0, $b1ba189bc6d9d9ad$export$f2b56433dc0af401)]: {
            Component: (0, $9LZ9B.default),
            defaultValueKey: 'url',
            retainUserInputTransform: (0, $5d2AR.mutateUrlField)
        },
        [(0, $b1ba189bc6d9d9ad$export$fb8861017089d392)]: {
            Component: (0, $k4Bm6.default),
            defaultValueKey: 'fieldOption',
            allowedValuesKey: 'fieldOptions.nodes',
            submitTransform: (0, $42gdJ.mapSelectOptionsToData),
            retainUserInputTransform: (0, $74tp8.mutateSingleSelectField)
        },
        [(0, $b1ba189bc6d9d9ad$export$985c14eb8f3f0309)]: {
            Component: (0, $k4Bm6.default),
            defaultValueKey: 'fieldOption',
            allowedValuesKey: 'fieldOptions.nodes',
            submitTransform: (0, $74tp8.mapSelectOptionsToConnectData),
            retainUserInputTransform: (0, $74tp8.mutateSingleSelectField)
        },
        [(0, $b1ba189bc6d9d9ad$export$2055419ff013de79)]: {
            Component: (0, $hQhuO.default),
            defaultValueKey: 'selectedFieldOptions',
            allowedValuesKey: 'fieldOptions.nodes',
            submitTransform: (0, $42gdJ.mapMultiSelectOptionsToData),
            retainUserInputTransform: (0, $j6rDO.mutateMultiSelectField)
        },
        [(0, $b1ba189bc6d9d9ad$export$9f6f73ea02649f83)]: {
            Component: (0, $hQhuO.default),
            defaultValueKey: 'selectedFieldOptions',
            allowedValuesKey: 'fieldOptions.nodes',
            submitTransform: (0, $j6rDO.mapMultiSelectOptionsToConnectData),
            retainUserInputTransform: (0, $j6rDO.mutateMultiSelectField)
        },
        [(0, $b1ba189bc6d9d9ad$export$16fe78a07e97f2ad)]: {
            Component: (0, $ikozW.default),
            defaultValueKey: 'selectedGroup',
            submitTransform: (0, $gnxL7.transformGroupToName),
            retainUserInputTransform: (0, $3x0xT.mutateSingleGroupPickerField)
        },
        [(0, $b1ba189bc6d9d9ad$export$fd24d37af44fe736)]: {
            Component: (0, $ikozW.default),
            defaultValueKey: 'selectedGroup',
            submitTransform: (0, $gnxL7.transformGroupToName),
            retainUserInputTransform: (0, $3x0xT.mutateSingleGroupPickerField)
        },
        [(0, $b1ba189bc6d9d9ad$export$3a1ae3e0f2d9b1b9)]: {
            Component: (0, $8AMXG.default),
            defaultValueKey: 'selectedGroups',
            submitTransform: (0, $gnxL7.transformGroupsToNames),
            retainUserInputTransform: (0, $ksJvI.mutateMultipleGroupPickerField)
        },
        [(0, $b1ba189bc6d9d9ad$export$3027db6317a2a8ea)]: {
            Component: (0, $8AMXG.default),
            defaultValueKey: 'selectedGroups',
            submitTransform: (0, $gnxL7.transformGroupsToNames),
            retainUserInputTransform: (0, $ksJvI.mutateMultipleGroupPickerField)
        },
        [(0, $b1ba189bc6d9d9ad$export$64238d76a1dc0703)]: {
            Component: (0, $gO6fZ.default),
            defaultValueKey: 'selectedSprints',
            submitTransform: (0, $cbDYy.mapSprintOptionToData),
            retainUserInputTransform: (0, $5F4bs.mutateJiraSprintField)
        },
        [(0, $b1ba189bc6d9d9ad$export$47af4d6f62c134cf)]: {
            Component: (0, $bcUzb.default),
            submitTransform: (0, $eamzO.mapOptionsToData),
            defaultValueKey: 'issueLinks',
            allowedValuesKey: 'issueLinkTypeRelations.nodes',
            retainUserInputTransform: (0, $dkhuh.mutateIssueLinksField)
        },
        [(0, $b1ba189bc6d9d9ad$export$1070aada56fcaec9)]: {
            Component: (0, $5hGgp.default),
            defaultValueKey: 'color.colorKey',
            submitTransform: (0, $lPQPn.asServerColor),
            retainUserInputTransform: (0, $j0x3u.mutateIssueColorField)
        },
        [(0, $b1ba189bc6d9d9ad$export$f57941b9c1949a82)]: {
            Component: (0, $5hGgp.default),
            defaultValueKey: 'color.colorKey',
            submitTransform: (0, $lPQPn.asClassicEpicColor),
            retainUserInputTransform: (0, $j0x3u.mutateEpicColorField)
        },
        [(0, $b1ba189bc6d9d9ad$export$95433ac963f4aebe)]: {
            Component: (0, $a3FRc.default),
            defaultValueKey: 'richText.plainText',
            submitTransform: (0, $9tBd5.convertTextToAdf),
            retainUserInputTransform: (0, $5TtxV.mutateTextAreaField)
        },
        [(0, $b1ba189bc6d9d9ad$export$67aca33725b6a717)]: {
            Component: (0, $a3FRc.default),
            defaultValueKey: 'object',
            submitTransform: (0, $3pjiv.transformJSONStringToObject),
            retainUserInputTransform: (0, $5TtxV.mutateTextAreaField)
        },
        [(0, $b1ba189bc6d9d9ad$export$f7a08bf17a7ac661)]: {
            Component: (0, $6nTlM.default),
            defaultValueKey: 'user',
            submitTransform: (0, $i8BXG.mapUserToAssigneeValue),
            retainUserInputTransform: (0, $i8BXG.mutateAssigneeUserPicker)
        },
        [(0, $b1ba189bc6d9d9ad$export$d64150fd9c66969c)]: {
            Component: (0, $f6c5h.default),
            defaultValueKey: 'user',
            submitTransform: (0, $bRVha.mapUserOptionsToIds),
            retainUserInputTransform: (0, $bRVha.mutateSingleUserPicker)
        },
        [(0, $b1ba189bc6d9d9ad$export$252fb981af0e2e4e)]: {
            Component: (0, $dA8Yc.default),
            defaultValueKey: 'resolution',
            allowedValuesKey: 'resolutions.nodes',
            submitTransform: (0, $cWMyd.mapOptionToResolutionOption),
            retainUserInputTransform: (0, $gtaAU.mutateResolutionField)
        },
        [(0, $b1ba189bc6d9d9ad$export$a9b3195cbef5c5ad)]: {
            Component: (0, $12Skn.default),
            submitTransform: (0, $9PXwb.getFileIdsFromFiles)
        },
        [(0, $b1ba189bc6d9d9ad$export$a36509fae9e84682)]: {
            Component: (0, $8MMgG.default),
            defaultValueKey: 'cascadingOption',
            allowedValuesKey: 'cascadingOptions.nodes',
            submitTransform: (0, $i5YRy.transformToServerValue),
            retainUserInputTransform: (0, $8YKza.mutateCascadingSelectField)
        },
        [(0, $b1ba189bc6d9d9ad$export$79443fedd031b437)]: {
            Component: (0, $kfu77.default),
            defaultValueKey: 'selectedTeam',
            submitTransform: (0, $6b6yO.transformTeamFieldTypeString),
            retainUserInputTransform: (0, $3GT6n.mutateTeamField)
        },
        [(0, $b1ba189bc6d9d9ad$export$1c7f7cfd2029442f)]: {
            Component: (0, $cVsIh.default),
            defaultValueKey: 'JiraAtlassianTeamField',
            submitTransform: (0, $iuMpO.transformAtlassianTeamFieldTypeString),
            retainUserInputTransform: (0, $iuMpO.mutateAtlassianTeamField)
        },
        [(0, $b1ba189bc6d9d9ad$export$597fa240de2bfd92)]: {
            Component: (0, $aYzpN.default),
            defaultValueKey: 'selectedCmdbObjects',
            submitTransform: (0, $8JQyN.transformCmdbField),
            retainUserInputTransform: null
        },
        [(0, $b1ba189bc6d9d9ad$export$864384797e544339)]: {
            Component: (0, $eUIIn.default),
            defaultValueKey: 'selectedOrganizations',
            submitTransform: (0, $cAsYI.mapOrganizationOptionsToData),
            retainUserInputTransform: (0, $6gsqy.mutateOrganizationsField)
        },
        [(0, $b1ba189bc6d9d9ad$export$a138d5648dda03f0)]: {
            Component: (0, $lWQTA.default),
            defaultValueKey: 'richText.adfValue.json'
        },
        [(0, $b1ba189bc6d9d9ad$export$aa5680ad8f8be9fc)]: {
            Component: (0, $0dKMy.default),
            defaultValueKey: 'project',
            submitTransform: (0, $25vda.mapOptionToData),
            retainUserInputTransform: (0, $6Pq4z.mutateProjectField)
        },
        [(0, $b1ba189bc6d9d9ad$export$aecc734a7c3591d7)]: {
            Component: (0, $bjDIF.default),
            submitTransform: (0, $f34jc.transformTimeTrackingValueToSubmitFormat),
            retainUserInputTransform: (0, $f34jc.mutateTimeTrackingField),
            defaultValueKey: 'originalEstimate'
        },
        [(0, $b1ba189bc6d9d9ad$export$d9861709f0b70c10)]: {
            Component: (0, $1BCWe.default),
            submitTransform: (0, $6BUcO.getLogWorkSubmitValue)
        },
        ...(0, $1ybV0.ff)('custom-checkbox_jvcud') ? {
            [(0, $b1ba189bc6d9d9ad$export$d10237d945259f96)]: {
                Component: (0, $l3c1m.default),
                allowedValuesKey: 'fieldOptions.nodes',
                defaultValueKey: 'selectedFieldOptions',
                submitTransform: (0, $j8vGU.mapOptionsToData),
                retainUserInputTransform: (0, $8aayW.mutateCheckboxField)
            }
        } : {
            [(0, $b1ba189bc6d9d9ad$export$d10237d945259f96)]: {
                Component: (0, $6ynFi.default),
                defaultValueKey: 'selectedFieldOptions',
                allowedValuesKey: 'fieldOptions.nodes',
                submitTransform: (0, $d7a37.mapOptionsToData),
                retainUserInputTransform: (0, $k8ImN.mutateCheckboxSelectField)
            }
        },
        ...(0, $1ybV0.ff)('parent-field-in-gic_d3b3n') && (0, $1ybV0.ff)('epic-link-and-parent-link-removed-from-gic_u1tku') ? {
            [(0, $b1ba189bc6d9d9ad$export$670384150af5f49e)]: {}
        } : {
            [(0, $b1ba189bc6d9d9ad$export$670384150af5f49e)]: {
                Component: (0, $bXFdm.ParentLinkField),
                defaultValueKey: 'parentIssue',
                submitTransform: (0, $aFVOZ.mapOptionToData)
            }
        },
        ...(0, $1ybV0.ff)('parent-field-in-gic_d3b3n') ? {
            [(0, $b1ba189bc6d9d9ad$export$bf9df74e065af482)]: {
                Component: (0, $b81gR.default),
                defaultValueKey: 'parentIssue',
                submitTransform: (0, $3K8W2.mapOptionToData),
                retainUserInputTransform: (0, $897qz.mutateParentField)
            }
        } : {},
        ...(0, $1ybV0.ff)('jsm-responders-field-in-gicx-ui') ? {
            [(0, $b1ba189bc6d9d9ad$export$33f8a9cb608132ba)]: {
                Component: (0, $4Dz8o.default),
                defaultValueKey: 'selectedUsers',
                submitTransform: (0, $ed9FR.mapUserOptionsToAris)
            }
        } : {},
        [(0, $b1ba189bc6d9d9ad$export$27854f490d658fc4)]: {
            Component: (0, $3n4oY.default),
            defaultValueKey: 'selectedOption',
            allowedValuesKey: 'fieldOptions.nodes',
            submitTransform: (0, $l6Z7J.mapOptionToData),
            retainUserInputTransform: (0, $74tp8.mutateSingleSelectField)
        },
        [(0, $b1ba189bc6d9d9ad$export$fc69de49ba08ae77)]: {
            Component: (0, $hdX72.IssueCreateEntitlementField),
            defaultValueKey: 'selectedEntitlement',
            submitTransform: (0, $3rBGb.mapEntitlementOptionToData),
            retainUserInputTransform: undefined
        }
    });
const $633c9eab6bea64b6$export$472717ed4aec82f1 = (0, $5iWql.default)($633c9eab6bea64b6$var$createFieldMapItems);
const $633c9eab6bea64b6$export$aed6a8ebeb442f9 = [
    (0, $lO4Or.ISSUE_LINKS_TYPE),
    (0, $lO4Or.WORK_LOG_TYPE),
    (0, $lO4Or.ATTACHMENT_TYPE)
];
const $633c9eab6bea64b6$export$e7c3e130e221f1f1 = [
    (0, $lO4Or.ISSUE_LINKS_TYPE),
    (0, $lO4Or.WORK_LOG_TYPE)
];
const $633c9eab6bea64b6$export$ccf7c75b07963f11 = [
    (0, $b1ba189bc6d9d9ad$export$aa5680ad8f8be9fc),
    (0, $b1ba189bc6d9d9ad$export$2d5a62a3515ad4c6),
    (0, $b1ba189bc6d9d9ad$export$a12a4b25ab12710c)
];

});
parcelRegister("eQWPb", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cb4b1e8a5a02c9c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");

var $kXF1s = parcelRequire("kXF1s");

var $icPhQ = parcelRequire("icPhQ");
var $6HoNR = parcelRequire("6HoNR");

var $ajD9f = parcelRequire("ajD9f");

var $7TaJX = parcelRequire("7TaJX");

var $kMBLZ = parcelRequire("kMBLZ");
const $6cb4b1e8a5a02c9c$var$AffectedServicesField = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange, ...fieldProps }, fieldId: fieldId, error: error, autoCompleteUrl: autoCompleteUrl = '', isEditable: isEditable = true, nonEditableReason: nonEditableReason, onCloseMenuOnScroll: // @ts-expect-error - TS2339 - Property 'onCloseMenuOnScroll' does not exist on type 'Props'.
    onCloseMenuOnScroll = (0, $7TaJX.closeMenuOnScroll), isDropdownMenuFixedAndLayered: // @ts-expect-error - TS2339 - Property 'isDropdownMenuFixedAndLayered' does not exist on type 'Props'.
    isDropdownMenuFixedAndLayered = false, defaultValue: defaultValue } = props;
    const [shouldFetchServiceName, setShouldFetchServiceName] = (0, $eUqFw.useState)(true);
    const [selectedOptions, setSelectedOptions] = (0, $eUqFw.useState)([]);
    const [{ isLoading: isLoading }, fetchAffectedServicesName] = (0, $kMBLZ.useFetchAffectedServicesName)();
    (0, $eUqFw.useEffect)(()=>{
        if (shouldFetchServiceName && defaultValue && defaultValue.length > 0) {
            /*
            const ids = defaultValue.map((service) => service.serviceId);
            Simply extracting serviceId above causes Flow error as 'service'
            is of type (JiraAffectedService | AffectedServiceOption).
            See TURTLE-89 for more details.
             */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const ids = defaultValue.reduce((serviceIds, service)=>// @ts-expect-error - TS2339 - Property 'serviceId' does not exist on type 'AffectedServiceOption'. | TS2339 - Property 'serviceId' does not exist on type 'AffectedServiceOption'.
                service.serviceId != null ? serviceIds.concat(service.serviceId) : serviceIds, []);
            if (ids.length > 0) fetchAffectedServicesName(ids, setSelectedOptions);
            setShouldFetchServiceName(false);
        } else setSelectedOptions(value);
    }, [
        defaultValue,
        fetchAffectedServicesName,
        setSelectedOptions,
        shouldFetchServiceName,
        value
    ]);
    const getAffectedServicesEdit = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kXF1s.default), {
            ...fieldProps,
            autoCompleteUrl: autoCompleteUrl,
            onChange: onChange,
            value: selectedOptions,
            fieldId: fieldId,
            isInvalid: Boolean(error),
            isDisabled: !isEditable,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            fetchSuggestionsOnFocus: true
        });
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ajD9f.StyledFieldSkeleton), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, isEditable === false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: nonEditableReason?.message || ''
    }, getAffectedServicesEdit()) : getAffectedServicesEdit());
};
var $6cb4b1e8a5a02c9c$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    transformDefaultValue: (0, $kMBLZ.transformDefaultAffectedServices)
})($6cb4b1e8a5a02c9c$var$AffectedServicesField);

});
parcelRegister("kXF1s", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b706079b2b1d573$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fm9CZ = parcelRequire("fm9CZ");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4NcaX = parcelRequire("4NcaX");

var $fO0l8 = parcelRequire("fO0l8");

var $9U2XD = parcelRequire("9U2XD");

var $6Skzr = parcelRequire("6Skzr");

var $6t5cq = parcelRequire("6t5cq");
const $3b706079b2b1d573$var$LOAD_OPTIONS_DEBOUNCE_TIMER = 300;
const $3b706079b2b1d573$var$AffectedServicesPickerEdit = (props)=>{
    const { fieldId: fieldId, value: value, onChange: onChange, autoCompleteUrl: autoCompleteUrl, isInvalid: isInvalid, isDisabled: isDisabled, placeholder: placeholder = '', isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, onCloseMenuOnScroll: onCloseMenuOnScroll, fetchSuggestionsOnFocus: fetchSuggestionsOnFocus = false, ...fieldProps } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [lastFetchFailed, setLastFetchFailed] = (0, $eUqFw.useState)(false);
    const [defaultOptions, setDefaultOptions] = (0, $eUqFw.useState)([]);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const shouldFetchDefaultOptions = (0, $eUqFw.useRef)(true);
    const searchAffectedServices = async (query = '')=>{
        setLastFetchFailed(false);
        try {
            (0, $9U2XD.fetchAffectedServicesExperience).start();
            const affectedServices = await (0, $6t5cq.fetchAffectedServices)(query, autoCompleteUrl);
            (0, $9U2XD.fetchAffectedServicesExperience).success();
            return affectedServices;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setLastFetchFailed(true);
            (0, $9U2XD.fetchAffectedServicesExperience).failure();
            return [];
        }
    };
    const onFocus = async ()=>{
        if (shouldFetchDefaultOptions && defaultOptions && shouldFetchDefaultOptions.current && !defaultOptions.length) {
            shouldFetchDefaultOptions.current = false;
            setIsLoading && setIsLoading(true);
            const options = await searchAffectedServices();
            setDefaultOptions && setDefaultOptions(options);
            setIsLoading && setIsLoading(false);
        }
    };
    const loadOptionsDebounced = (0, $fO0l8.default)(searchAffectedServices, $3b706079b2b1d573$var$LOAD_OPTIONS_DEBOUNCE_TIMER);
    const noOptionsMessage = (0, $eUqFw.useCallback)(()=>formatMessage(lastFetchFailed ? (0, $6Skzr.default).failedFetch : (0, $6Skzr.default).noMatches), [
        formatMessage,
        lastFetchFailed
    ]);
    const defaultOptionsProps = ()=>{
        if (fetchSuggestionsOnFocus) return {
            onFocus: onFocus,
            isLoading: isLoading,
            defaultOptions: defaultOptions
        };
        return {};
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fm9CZ.default), {
        ...fieldProps,
        fieldId: fieldId,
        loadOptions: loadOptionsDebounced,
        // @ts-expect-error - TS2322 - Type '(value: AffectedServiceOption[]) => void' is not assignable to type '(value: OptionsType<AffectedServiceOption>, action: ActionMeta<AffectedServiceOption>) => void'.
        onChange: onChange,
        autoFocus: false,
        ...defaultOptionsProps(),
        isClearable: Boolean(value),
        isMulti: true,
        value: value,
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        noOptionsMessage: noOptionsMessage,
        placeholder: placeholder,
        isDisabled: isDisabled,
        // @ts-expect-error - TS2322 - Type '((e: ChangeEvent<HTMLElement>) => boolean) | undefined' is not assignable to type 'boolean | EventListener | undefined'.
        closeMenuOnScroll: onCloseMenuOnScroll,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        styles: (0, $4NcaX.defaultSelectStyles),
        "data-testid": "issue-field-affected-services.ui.edit.async-select"
    });
};
var $3b706079b2b1d573$export$2e2bcd8739ae039 = $3b706079b2b1d573$var$AffectedServicesPickerEdit;

});
parcelRegister("4NcaX", function(module, exports) {

$parcel$export(module.exports, "defaultSelectStyles", () => $114b87bdc51f126d$export$b12192ea1a215e5f);
$parcel$export(module.exports, "indicatorFixSelectStyles", () => $114b87bdc51f126d$export$eca30945eaf474dd);

var $PdmhA = parcelRequire("PdmhA");

var $c9TLT = parcelRequire("c9TLT");
const $114b87bdc51f126d$export$b12192ea1a215e5f = {
    menuPortal: (base)=>({
            ...base,
            zIndex: (0, $c9TLT.layers).modal
        }),
    menu: (base)=>({
            ...base,
            zIndex: (0, $c9TLT.layers).modal
        })
};
const $114b87bdc51f126d$var$inputIconPaddingLeft = "var(--ds-space-025, 2px)";
const $114b87bdc51f126d$var$inputIconPaddingRight = "var(--ds-space-050, 4px)";
const $114b87bdc51f126d$export$eca30945eaf474dd = {
    // need to apply same padding to both loadingIndicator and clearIndicator - not to have input query jumping between lines e.g. in multi-select
    loadingIndicator: (base)=>({
            ...base,
            paddingLeft: $114b87bdc51f126d$var$inputIconPaddingLeft,
            paddingRight: $114b87bdc51f126d$var$inputIconPaddingRight
        }),
    clearIndicator: (base)=>({
            ...base,
            paddingLeft: $114b87bdc51f126d$var$inputIconPaddingLeft,
            paddingRight: $114b87bdc51f126d$var$inputIconPaddingRight
        })
};
const $114b87bdc51f126d$export$a9f371909ef7b4d6 = {
    container: (base)=>({
            ...base,
            border: `${"var(--ds-space-025, 2px)"} solid ${`var(--ds-border-danger, ${(0, $PdmhA).R400})`}`,
            borderRadius: "var(--ds-space-050, 4px)"
        })
};

});

parcelRegister("9U2XD", function(module, exports) {

$parcel$export(module.exports, "graphModalExperience", () => $8c84c39cbd5b3ad6$export$1b179afadba799dc);
$parcel$export(module.exports, "rapidSearchExperience", () => $8c84c39cbd5b3ad6$export$1a90deecc86e78f8);
$parcel$export(module.exports, "autocompleteInsightFieldExperience", () => $8c84c39cbd5b3ad6$export$94337fa170a193d2);
$parcel$export(module.exports, "fetchAffectedServicesExperience", () => $8c84c39cbd5b3ad6$export$ce8d2a860f4e0316);
$parcel$export(module.exports, "objectDetailsViewExperience", () => $8c84c39cbd5b3ad6$export$8e0a16d0fc0feba3);
$parcel$export(module.exports, "objectViewInlineEditSwitchFromReadToEditModeExperience", () => $8c84c39cbd5b3ad6$export$5ae0e1bbe443c52b);
$parcel$export(module.exports, "objectViewInlineEditSwitchFromEditToReadModeExperience", () => $8c84c39cbd5b3ad6$export$b9c9c5e92fa6a3a4);
$parcel$export(module.exports, "createObjectTypeExperience", () => $8c84c39cbd5b3ad6$export$15a29f6e079c9b3d);
$parcel$export(module.exports, "createObjectExperience", () => $8c84c39cbd5b3ad6$export$aaf507c87c29ab22);
$parcel$export(module.exports, "loadSchemaObjectListExperience", () => $8c84c39cbd5b3ad6$export$6f02ba4c2b1e3f5f);
$parcel$export(module.exports, "loadAttributesConfigurationExperience", () => $8c84c39cbd5b3ad6$export$8f63f06b0486e498);
$parcel$export(module.exports, "updateObjectFilterExperience", () => $8c84c39cbd5b3ad6$export$967859e6be8e6f4b);
$parcel$export(module.exports, "getUpdateGlobalConfigInlineEditExperience", () => $8c84c39cbd5b3ad6$export$e4deb66475dfa46b);
$parcel$export(module.exports, "loadObjectDetailExperience", () => $8c84c39cbd5b3ad6$export$3f1da23c065671d2);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $8c84c39cbd5b3ad6$export$1b179afadba799dc = new (0, $kDfSL.UFOExperience)('service-management.insight-cmdb.display-graph-modal', {
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult,
    type: (0, $12kyE.ExperienceTypes).Experience
});
const $8c84c39cbd5b3ad6$export$1a90deecc86e78f8 = new (0, $kDfSL.UFOExperience)('service-management.insight-cmdb.display-rapid-search-results', {
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult,
    type: (0, $12kyE.ExperienceTypes).Experience
});
const $8c84c39cbd5b3ad6$export$94337fa170a193d2 = new (0, $kDfSL.UFOExperience)('service-management.insight-cmdb.autocomplete-search-insight-field', {
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult,
    type: (0, $12kyE.ExperienceTypes).Experience,
    featureFlags: [
        'jsm-insight-field-performance-improvements_fplgq'
    ]
});
const $8c84c39cbd5b3ad6$export$ce8d2a860f4e0316 = new (0, $kDfSL.UFOExperience)('service-management.insight-cmdb.fetch-affected-services', {
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult,
    type: (0, $12kyE.ExperienceTypes).Experience
});
const $8c84c39cbd5b3ad6$export$8e0a16d0fc0feba3 = new (0, $kDfSL.UFOExperience)('jsm-cmdb-object-details-view', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad
});
const $8c84c39cbd5b3ad6$export$5ae0e1bbe443c52b = new (0, $kDfSL.UFOExperience)('service-management.insight-cmdb.object-view-inline-edit.switch-from-read-to-edit-mode', {
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult,
    type: (0, $12kyE.ExperienceTypes).Experience
});
const $8c84c39cbd5b3ad6$export$b9c9c5e92fa6a3a4 = new (0, $kDfSL.UFOExperience)('service-management.insight-cmdb.object-view-inline-edit.switch-from-edit-to-read-mode', {
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult,
    type: (0, $12kyE.ExperienceTypes).Experience
});
const $8c84c39cbd5b3ad6$export$15a29f6e079c9b3d = new (0, $kDfSL.UFOExperience)('jsm-cmdb-create-object-type', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    timings: [
        {
            key: 'created-on-server',
            endMark: 'object-type-created-on-server'
        }
    ]
});
const $8c84c39cbd5b3ad6$export$aaf507c87c29ab22 = new (0, $kDfSL.UFOExperience)('service-management.insight-cmdb.create-object', {
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult,
    type: (0, $12kyE.ExperienceTypes).Experience
});
const $8c84c39cbd5b3ad6$export$6f02ba4c2b1e3f5f = new (0, $kDfSL.UFOExperience)('jsm-cmdb-load-object-list', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad
});
const $8c84c39cbd5b3ad6$export$8f63f06b0486e498 = new (0, $kDfSL.UFOExperience)('jsm-cmdb-load-attributes-tab', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad
});
const $8c84c39cbd5b3ad6$export$967859e6be8e6f4b = new (0, $kDfSL.UFOExperience)('jsm-cmdb-object-filter', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    timings: [
        {
            key: 'response-received',
            endMark: 'server-response-received'
        },
        {
            key: 'object-table-rendered',
            endMark: 'object-table-rendered'
        },
        {
            key: 'object-list-rendered',
            endMark: 'object-list-rendered'
        },
        {
            key: 'no-filter-results-rendered',
            endMark: 'no-filter-results-rendered'
        }
    ]
});
const $8c84c39cbd5b3ad6$export$e4deb66475dfa46b = ()=>new (0, $kDfSL.UFOExperience)('service-management.insight-cmdb.global-config-inline-edit.update', {
        performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult,
        type: (0, $12kyE.ExperienceTypes).Experience
    });
const $8c84c39cbd5b3ad6$export$3f1da23c065671d2 = new (0, $kDfSL.UFOExperience)('service-management.insight-cmdb.embedded-object-details-view', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad
});

});

parcelRegister("6Skzr", function(module, exports) {

$parcel$export(module.exports, "default", () => $22e595dc051fd27a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $22e595dc051fd27a$var$messages = (0, $90IgZ.defineMessages)({
    noMatches: {
        "id": "issue-field-affected-services.edit.no-matches",
        "defaultMessage": "No Matches"
    },
    failedFetch: {
        "id": "issue-field-affected-services.edit.failed-fetch",
        "defaultMessage": "Search failed. Please try again."
    }
});
var $22e595dc051fd27a$export$2e2bcd8739ae039 = $22e595dc051fd27a$var$messages;

});

parcelRegister("6t5cq", function(module, exports) {

$parcel$export(module.exports, "mapServiceEntitiesToOptions", () => $e3d69c789fa20f9e$export$23b96a30f377b741);
$parcel$export(module.exports, "mapOptionsToServiceEntities", () => $e3d69c789fa20f9e$export$7dcfc49587479fac);
$parcel$export(module.exports, "fetchAffectedServices", () => $e3d69c789fa20f9e$export$66d34216c85d32cb);

var $53ciZ = parcelRequire("53ciZ");

var $guiFP = parcelRequire("guiFP");

var $7byHA = parcelRequire("7byHA");
var $lRmyA = parcelRequire("lRmyA");
const $e3d69c789fa20f9e$export$23b96a30f377b741 = (services)=>services.map(({ id: id, name: name })=>({
            label: name,
            value: id
        }));
const $e3d69c789fa20f9e$export$7dcfc49587479fac = (options)=>options.map(({ label: label, value: value })=>({
            id: value,
            name: label
        }));
const $e3d69c789fa20f9e$export$66d34216c85d32cb = async (inputValue, autoCompleteUrl)=>{
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify({
        query: inputValue
    });
    return (0, $lRmyA.performGetRequest)(`${autoCompleteUrl}?${query}`).then((response)=>$e3d69c789fa20f9e$export$23b96a30f377b741(response.services)).catch((error)=>{
        (0, $guiFP.trackFetchErrors)({
            error: error,
            id: 'fetchAffectedServices',
            packageName: 'jiraIssueFieldAffectedServices',
            logToSentry: !(0, $7byHA.isValidationError)(error),
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                errorMessage: error.message
            }
        });
        throw error;
    });
};

});


parcelRegister("icPhQ", function(module, exports) {

$parcel$export(module.exports, "FieldContainer", () => $5358eebeffdccf27$export$b5c4b0e7cd7f148b);
$parcel$export(module.exports, "Description", () => $5358eebeffdccf27$export$393edc798c47379d);
$parcel$export(module.exports, "SelectContainer", () => $5358eebeffdccf27$export$446eebadefe1123b);
$parcel$export(module.exports, "Divider", () => $5358eebeffdccf27$export$2e0a83ec2e27ecbb);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $5358eebeffdccf27$export$b5c4b0e7cd7f148b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { marginTop: marginTop, paddingBottom: paddingBottom, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1r250ak": (0, $9t7rW.default)(typeof (__cmplp.width ?? 350) === 'number' ? `${__cmplp.width ?? 350}px` : __cmplp.width ?? 350),
            "--_1glwpqj": (0, $9t7rW.default)(`${__cmplp.marginTop ?? 0}px`),
            "--_1i3s0vn": (0, $9t7rW.default)(`${__cmplp.paddingBottom ?? 0}px`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbuo76 _19pknek2 _n3td11zn",
            __cmplp.className
        ])
    });
});
const $5358eebeffdccf27$export$393edc798c47379d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyru2gc",
            __cmplp.className
        ])
    });
});
const $5358eebeffdccf27$export$446eebadefe1123b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1mjv",
            __cmplp.className
        ])
    });
});
const $5358eebeffdccf27$export$2e0a83ec2e27ecbb = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3it94y _1bsb1osq _bfhkb5v6 _18s8gx6n",
            __cmplp.className
        ])
    });
});
const $5358eebeffdccf27$export$32dd8f1956fe77b1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01wug _2hwxu2gc",
            __cmplp.className
        ])
    });
});

});

parcelRegister("6HoNR", function(module, exports) {

$parcel$export(module.exports, "withFormField", () => $b5afd88747d4ca5d$export$17bf6386ac4a43ba);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4LhB6 = parcelRequire("4LhB6");

var $0cdA8 = parcelRequire("0cdA8");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $eTZsp = parcelRequire("eTZsp");

var $7eMp1 = parcelRequire("7eMp1");

var $1zCIN = parcelRequire("1zCIN");

var $dWh83 = parcelRequire("dWh83");
var $6LDal = parcelRequire("6LDal");parcelRequire("fryuC");
var $aBj0i = parcelRequire("aBj0i");

var $dNWQB = parcelRequire("dNWQB");
var $2gOs4 = parcelRequire("2gOs4");

var $bKI0B = parcelRequire("bKI0B");

var $lVewy = parcelRequire("lVewy");

var $kOu8r = parcelRequire("kOu8r");
var $5VJL3 = parcelRequire("5VJL3");

var $5i7Lk = parcelRequire("5i7Lk");

var $6duIW = parcelRequire("6duIW");

var $l1bxK = parcelRequire("l1bxK");

var $1ZhS1 = parcelRequire("1ZhS1");

var $ewDib = parcelRequire("ewDib");

var $6UjGk = parcelRequire("6UjGk");
const $b5afd88747d4ca5d$export$17bf6386ac4a43ba = (options)=>(Component)=>// @ts-expect-error - TS2322 - Type '(ownProps: ReturnComponentProps<Config>) => JSX.Element | null' is not assignable to type 'AbstractComponent<ReturnComponentProps<Config>, any>'.
        (ownProps)=>{
            const { fieldId: fieldId, fieldName: fieldName, fieldType: fieldType, description: descriptionRaw, isRequired: isRequired = false, defaultValue: // @ts-expect-error - TS2339 - Property 'defaultValue' does not exist on type '{ areUiModificationsBusy?: boolean | undefined; } & BaseField & { componentKey?: string | undefined; fieldType?: string | undefined; forge?: { selectedProject: SelectedProject; selectedIssueType: IssueOrRequestType; modules: ForgeModules; } | undefined; fieldHelpTextUrl?: string | undefined; onLayoutDone?: (() => vo...'.
            defaultValue, componentKey: componentKey, forge: forge, onLayoutDone: onLayoutDone, fieldHelpTextUrl: fieldHelpTextUrl, areUiModificationsBusy: areUiModificationsBusy, defaultValueDontTransform: defaultValueDontTransform, isRequiredFromUIM: isRequiredFromUIM, onLinkClickEvent: onLinkClickEvent, isMini: isMini, isCollapsed: isCollapsed, isFieldResponsive: isFieldResponsive, fieldWrapperElement: fieldWrapperElement, ...ownPropsRest } = ownProps;
            const { publish: publish } = (0, $2gOs4.useGICLifeCycleEvents)();
            const { transformDefaultValue: transformDefaultValue, validator: validator, shouldRenderFieldMessage: shouldRenderFieldMessage = true, shouldHideLabel: shouldHideLabel = false } = options;
            const description = (0, $5VJL3.isForgeCustomField)(fieldType) ? (0, $1zCIN.extractEnvFromFieldDescription)(descriptionRaw).description : descriptionRaw;
            const hasSentTransformDefaultValueError = (0, $eUqFw.useRef)(false);
            let transformedDefaultValue;
            try {
                /**
     * The transformDefaultValue function is generally used to transform a defaultValue
     * that is passed from the backend, which is in a different data format to the
     * frontend data format.
     *
     * In some situations, we want to set the defaultValue using data that is already
     * in the frontend data format instead of the backend data format. In these cases
     * we want to ignore the transformDefaultValue and just use the defaultValue from props.
     *
     * To do this, we are using the defaultValueDontTransform prop to know that we
     * can safely not run transformDefaultValue.
     */ if (defaultValueDontTransform) transformedDefaultValue = defaultValue; // this can be merged into the below on ff cleanup
                else transformedDefaultValue = defaultValue !== undefined && typeof transformDefaultValue === 'function' ? transformDefaultValue(defaultValue) : defaultValue;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                if (hasSentTransformDefaultValueError.current === false) {
                    hasSentTransformDefaultValueError.current = true;
                    (0, $guiFP.default)({
                        meta: {
                            id: 'defaultValueTransformation',
                            packageName: 'jiraIssueCreateCommons',
                            teamName: 'gryffindor'
                        },
                        error: error,
                        attributes: {
                            fieldType: fieldType
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            }
            (0, $eUqFw.useLayoutEffect)(()=>{
                onLayoutDone && onLayoutDone();
            }, [
                onLayoutDone
            ]);
            const shouldSetWidth = (0, $1ybV0.ff)('gic-smart-fields-jira-labs_8uwvr') ? isMini || isFieldResponsive : isMini;
            const renderComponent = (fieldProps, error)=>// @ts-expect-error Type 'Omit<ReturnComponentProps<Config>, "fieldId" | "fieldName" | "description" | "isRequired" | "defaultValue" | "areUiModificationsBusy" | "componentKey" | "fieldType" | "forge" | "fieldHelpTextUrl" | "onLayoutDone"> & { ...; }' is not assignable to type 'IntrinsicAttributes & PropsWithoutRef<ComponentProps<Config, FieldValue>> & RefAttributes<any> & { ...; }'.
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
                    ...ownPropsRest,
                    fieldId: fieldId,
                    fieldName: fieldName,
                    isRequired: isRequired,
                    fieldProps: fieldProps,
                    width: shouldSetWidth ? '100%' : undefined,
                    isMini: isMini,
                    description: description,
                    defaultValue: defaultValue,
                    error: error,
                    key: componentKey
                });
            const renderFieldMessage = (0, $eUqFw.useCallback)((error)=>{
                if (shouldRenderFieldMessage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5i7Lk.FieldMessage), {
                    fieldId: fieldId,
                    description: description,
                    error: error,
                    fieldName: fieldName,
                    fieldHelpTextUrl: fieldHelpTextUrl,
                    onLinkClickEvent: onLinkClickEvent,
                    isMini: isMini
                });
                return null;
            }, [
                description,
                fieldHelpTextUrl,
                fieldId,
                fieldName,
                isMini,
                onLinkClickEvent,
                shouldRenderFieldMessage
            ]);
            const extension = (0, $eUqFw.useMemo)(()=>{
                if (typeof fieldType === 'string' && (0, $5VJL3.isForgeCustomField)(fieldType) && forge?.modules && forge?.hasFinishedLoading) return (0, $1ZhS1.getExtension)(fieldType, forge?.modules);
                return null;
            }, [
                fieldType,
                forge?.modules,
                forge?.hasFinishedLoading
            ]);
            (0, $eUqFw.useEffect)(()=>{
                const shouldReportFailure = typeof fieldType === 'string' && (0, $5VJL3.isForgeCustomField)(fieldType) && forge?.hasFinishedLoading && !extension && forge?.modules && forge?.filteredOutModules;
                if (shouldReportFailure) (0, $l1bxK.reportForgeFailure)(fieldType, forge?.modules, forge?.filteredOutModules);
            }, [
                fieldType,
                extension,
                forge?.modules,
                forge?.filteredOutModules,
                forge?.hasFinishedLoading
            ]);
            const renderFieldContent = (fieldProps, error)=>{
                if ((0, $1ybV0.ff)('gic-smart-fields-jira-labs_8uwvr') && isCollapsed) return null;
                const fieldPropsWithPublish = {
                    ...fieldProps,
                    onChange: (value, ...rest)=>{
                        fieldProps.onChange(value, ...rest);
                        publish((0, $dNWQB.GIC_LIFECYCLE_EVENTS).CREATE_FORM_FIELD_VALUE_CHANGE, {
                            fieldId: fieldId,
                            fieldName: fieldName,
                            fieldType: fieldType,
                            value: (0, $kOu8r.getValueFromEventOrValue)(value)
                        });
                    }
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, fieldType !== undefined && (0, $5VJL3.isForgeCustomField)(fieldType) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6duIW.ForgeField), {
                    fieldId: fieldId,
                    fieldName: fieldName,
                    fieldType: fieldType,
                    fieldProps: fieldPropsWithPublish,
                    error: error,
                    selectedProject: forge?.selectedProject,
                    selectedIssueType: forge?.selectedIssueType,
                    extension: extension,
                    renderFieldMessage: renderFieldMessage,
                    renderDefaultComponent: renderComponent
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, fieldWrapperElement ? /*#__PURE__*/ (0, $eUqFw.cloneElement)(fieldWrapperElement, {}, [
                    renderComponent(fieldPropsWithPublish, error),
                    renderFieldMessage(error)
                ]) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, renderComponent(fieldPropsWithPublish, error), renderFieldMessage(error))));
            };
            const renderFieldLabel = (0, $eUqFw.useCallback)(()=>{
                if ((0, $1ybV0.ff)('gic-smart-fields-jira-labs_8uwvr') && isCollapsed) return ''; // TODO Merge this condition with the one below when cleaning gic-smart-fields-jira-labs_8uwvr https://hello.jira.atlassian.cloud/browse/DEE-3790
                if (shouldHideLabel) return ''; // one off case only expected in case of worklog where we want to show the label inside the component code
                if ((0, $5VJL3.isForgeCustomField)(fieldType)) {
                    const { environment: environment } = (0, $1zCIN.extractEnvFromFieldDescription)(descriptionRaw);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b5afd88747d4ca5d$var$ForgeLabel, null, fieldName, " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7eMp1.EnvironmentLozenge), {
                        environmentType: environment
                    }));
                }
                return fieldName;
            }, [
                fieldName,
                fieldType,
                shouldHideLabel,
                descriptionRaw,
                isCollapsed
            ]);
            if ((0, $5VJL3.isForgeCustomField)(fieldType) && !forge?.hasFinishedLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ewDib.FieldSkeleton), null);
            if ((0, $5VJL3.isForgeCustomField)(fieldType) && !extension) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
                id: "withFormField",
                // eslint-disable-next-line jira/js/package-name-enforcer-for-error-boundary
                packageName: "jiraIssueCreateModal",
                fallback: "unmount",
                sendToPrivacyUnsafeSplunk: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
                id: `${fieldId}-field`,
                label: renderFieldLabel(),
                elementAfterLabel: areUiModificationsBusy ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6LDal.FieldBusyIndicator), {
                    fieldId: fieldId
                }) : undefined,
                isRequired: isRequired,
                name: fieldId,
                defaultValue: transformedDefaultValue,
                key: (0, $6UjGk.generateKeyForRequiredFromUIM)({
                    fieldId: fieldId,
                    isRequiredFromUIM: isRequiredFromUIM === true
                }),
                validate: (value, _formState, { dirty: dirty })=>{
                    try {
                        const { type: type } = ownPropsRest;
                        if ((0, $5VJL3.isForgeCustomField)(fieldType) && isRequired) // Dirty check is required for the forge custom fields that haven't yet populated the value because it haven't lost a focus
                        return dirty && typeof validator === 'function' ? validator(value, isRequired, type) : undefined;
                        return typeof validator === 'function' ? validator(value, isRequired, type) : undefined;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } catch (error) {
                        (0, $guiFP.default)({
                            meta: {
                                id: 'fieldValidationIssue',
                                packageName: 'jiraIssueCreateCommons',
                                teamName: 'gryffindor'
                            },
                            error: error,
                            sendToPrivacyUnsafeSplunk: true
                        });
                        return undefined;
                    }
                }
            }, ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dWh83.ErrorBoundaryBypassProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dWh83.ErrorBoundaryBypassOutput), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
                    id: "issueAdjustmentsFieldValueDecorator",
                    // eslint-disable-next-line jira/js/package-name-enforcer-for-error-boundary
                    packageName: "jiraIssueCreateModal",
                    fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aBj0i.IssueAdjustmentsErrorHandler), null), renderFieldContent(fieldProps, error)),
                    sendToPrivacyUnsafeSplunk: true,
                    attributes: (err)=>({
                            errorType: (0, $eTZsp.getErrorType)(err),
                            viewType: (0, $bKI0B.GIC_VIEW_TYPE),
                            fieldId: fieldId,
                            fieldType: fieldType
                        })
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lVewy.FieldValueDecoratorAsync), {
                    fieldId: fieldId,
                    fieldType: fieldType,
                    fieldProps: fieldProps
                }, (interceptedFieldProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dWh83.ErrorBoundaryBypassInput), null, renderFieldContent(interceptedFieldProps, error)))))));
        };
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b5afd88747d4ca5d$var$ForgeLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wybdlk8 _1e0c116y _4cvr1h6o _zulpu2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7eMp1", function(module, exports) {

$parcel$export(module.exports, "EnvironmentLozenge", () => $cd44a5efa9c7c2f2$export$278f8e01799d0418);
$parcel$export(module.exports, "nameWithCustomEnvironment", () => $cd44a5efa9c7c2f2$export$f9338c21ba7c7334);

var $eUqFw = parcelRequire("eUqFw");

var $ffiyv = parcelRequire("ffiyv");

var $2Rqjr = parcelRequire("2Rqjr");

var $8uD7Y = parcelRequire("8uD7Y");

var $aghg0 = parcelRequire("aghg0");
const $cd44a5efa9c7c2f2$export$50589a87e4fb3dae = (environmentType)=>{
    switch(environmentType){
        case 0, $2Rqjr.DEVELOPMENT_ENVIRONMENT:
            return (0, $aghg0.messages).developmentEnvironmentLozenge;
        case 0, $2Rqjr.STAGING_ENVIRONMENT:
            return (0, $aghg0.messages).stagingEnvironmentLozenge;
        default:
            return null;
    }
};
const $cd44a5efa9c7c2f2$export$278f8e01799d0418 = (props)=>{
    const { environmentType: environmentType } = props;
    const labelKey = $cd44a5efa9c7c2f2$export$50589a87e4fb3dae(environmentType);
    return labelKey ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        testId: "forge-ui-extension-title.ui.environment-lozenge.lozenge",
        appearance: environmentType === (0, $2Rqjr.DEVELOPMENT_ENVIRONMENT) ? 'default' : 'moved'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), labelKey)) : null;
};
const $cd44a5efa9c7c2f2$export$f9338c21ba7c7334 = (name, environmentType, environmentKey)=>{
    if (environmentType === (0, $2Rqjr.DEVELOPMENT_ENVIRONMENT) && environmentKey && environmentKey !== (0, $2Rqjr.DEFAULT_ENVIRONMENT_KEY)) return `${name} - ${environmentKey}`;
    return name;
};

});
parcelRegister("aghg0", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ea116b14fefa1e63$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $ea116b14fefa1e63$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    developmentEnvironmentLozenge: {
        "id": "forge-ui-extension-title.environment-lozenge.development-environment-lozenge",
        "defaultMessage": "DEV"
    },
    stagingEnvironmentLozenge: {
        "id": "forge-ui-extension-title.environment-lozenge.staging-environment-lozenge",
        "defaultMessage": "STG"
    }
});

});


parcelRegister("1zCIN", function(module, exports) {

$parcel$export(module.exports, "extractEnvFromFieldDescription", () => $4a572015a6dc1e3e$export$dfa36573f3bd00af);
const $4a572015a6dc1e3e$var$DEV_PREFIX = '(DEVELOPMENT) ';
const $4a572015a6dc1e3e$var$STG_PREFIX = '(STAGING) ';
const $4a572015a6dc1e3e$export$dfa36573f3bd00af = (descriptionWithEnv = '')=>{
    if (descriptionWithEnv.startsWith($4a572015a6dc1e3e$var$DEV_PREFIX)) return {
        environment: 'DEVELOPMENT',
        description: descriptionWithEnv.replace($4a572015a6dc1e3e$var$DEV_PREFIX, '')
    };
    if (descriptionWithEnv.startsWith($4a572015a6dc1e3e$var$STG_PREFIX)) return {
        environment: 'STAGING',
        description: descriptionWithEnv.replace($4a572015a6dc1e3e$var$STG_PREFIX, '')
    };
    return {
        environment: 'PRODUCTION',
        description: descriptionWithEnv
    };
};

});

parcelRegister("dWh83", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundaryBypassProvider", () => $01b98097d656a3ff$export$a5feb4d632b53009);
$parcel$export(module.exports, "ErrorBoundaryBypassInput", () => $01b98097d656a3ff$export$36798a6d5688c318);
$parcel$export(module.exports, "ErrorBoundaryBypassOutput", () => $01b98097d656a3ff$export$775be62266860b86);

var $eUqFw = parcelRequire("eUqFw");
const $01b98097d656a3ff$var$ErrorBoundaryBypassApiContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $01b98097d656a3ff$var$ErrorBoundaryBypassErrorContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $01b98097d656a3ff$export$a5feb4d632b53009 = ({ children: children })=>{
    const [bypassedError, setBypassedError] = (0, $eUqFw.useState)(null);
    const api = (0, $eUqFw.useMemo)(()=>({
            // @ts-expect-error - TS7006 - Parameter 'error' implicitly has an 'any' type.
            swallowError: (error)=>{
                setBypassedError(error);
            }
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($01b98097d656a3ff$var$ErrorBoundaryBypassErrorContext.Provider, {
        value: bypassedError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($01b98097d656a3ff$var$ErrorBoundaryBypassApiContext.Provider, {
        value: api
    }, children));
};
class $01b98097d656a3ff$export$36798a6d5688c318 extends (0, $eUqFw.Component) {
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    componentDidCatch(error) {
        if (this.context !== null) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        this.context.swallowError(error);
    }
    static{
        this.contextType = $01b98097d656a3ff$var$ErrorBoundaryBypassApiContext;
    }
    render() {
        if (this.state.hasError) return null;
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            hasError: false
        };
    }
}
const $01b98097d656a3ff$export$775be62266860b86 = ()=>{
    const bypassedError = (0, $eUqFw.useContext)($01b98097d656a3ff$var$ErrorBoundaryBypassErrorContext);
    if (bypassedError !== null) throw bypassedError;
    return null;
};

});

parcelRegister("6LDal", function(module, exports) {

$parcel$export(module.exports, "FieldBusyIndicator", () => $e3d5ba0b8ddbe369$export$cf3e115209fc94cb);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4Bees = parcelRequire("4Bees");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gzBuH = parcelRequire("gzBuH");

var $5hFCF = parcelRequire("5hFCF");
const $e3d5ba0b8ddbe369$export$cf3e115209fc94cb = /*#__PURE__*/ (0, $eUqFw.memo)(({ fieldId: fieldId })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const loadingMessage = formatMessage((0, $5hFCF.default).fieldLevelIndicatorTooltipContent);
    const indicatorId = `issue-adjustments.ui.field-loading-indicator.${fieldId}`;
    const tooltipId = `issue-adjustments.ui.field-loading-indicator.tooltip.${fieldId}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        tag: "span",
        content: loadingMessage,
        testId: tooltipId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e3d5ba0b8ddbe369$export$4e31364808fb7483, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gzBuH.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        testId: indicatorId,
        size: "small"
    }))));
});
$e3d5ba0b8ddbe369$export$cf3e115209fc94cb.displayName = 'FieldBusyIndicator'; // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $e3d5ba0b8ddbe369$export$4e31364808fb7483 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u012x7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gzBuH", function(module, exports) {

$parcel$export(module.exports, "default", () => $6303a1693ea37869$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $aTx5K = parcelRequire("aTx5K");
function $6303a1693ea37869$export$2e2bcd8739ae039({ children: children, ignore: ignore = true }) {
    const parentProfilerContext = (0, $eUqFw.useContext)((0, $7rh0R.ProfilerContext));
    const ignoredRLLProfilerContext = (0, $eUqFw.useMemo)(()=>({
            ...parentProfilerContext,
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            placeholderFallBackMounted () {},
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            placeholderFallBackUnmounted () {}
        }), [
        parentProfilerContext
    ]);
    // react-18: Use children directly
    const kids = children != null ? children : null;
    if (!ignore) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, kids);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aTx5K.default), {
        ignore: ignore
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7rh0R.ProfilerContext).Provider, {
        value: ignoredRLLProfilerContext
    }, kids));
}

});
parcelRegister("aTx5K", function(module, exports) {

$parcel$export(module.exports, "default", () => $99ad7ab78a19ec4c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jsCXU = parcelRequire("jsCXU");
function $99ad7ab78a19ec4c$export$2e2bcd8739ae039({ children: children, ignore: ignore = true }) {
    const parentContext = (0, $eUqFw.useContext)((0, $jsCXU.default));
    const ignoredInteractionContext = (0, $eUqFw.useMemo)(()=>{
        if (!parentContext) return null;
        return {
            ...parentContext,
            hold (...args) {
                if (!ignore) return parentContext.hold(...args);
            }
        };
    }, [
        parentContext,
        ignore
    ]);
    // react-18: Use children directly
    const kids = children != null ? children : null;
    if (!ignoredInteractionContext) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, kids);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jsCXU.default).Provider, {
        value: ignoredInteractionContext
    }, kids);
}

});


parcelRegister("5hFCF", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e5ff97e78fc07e1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8e5ff97e78fc07e1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    fieldLevelIndicatorTooltipContent: {
        "id": "issue-adjustments.field-busy-indicator.field-level-indicator-tooltip-content",
        "defaultMessage": "Loading UI modifications..."
    }
});

});


parcelRegister("lVewy", function(module, exports) {

$parcel$export(module.exports, "FieldValueDecoratorAsync", () => $1957aa217428fa22$export$24545fc29fe55980);

var $eUqFw = parcelRequire("eUqFw");

var $ig7wC = parcelRequire("ig7wC");

var $bKI0B = parcelRequire("bKI0B");

var $8ibkc = parcelRequire("8ibkc");

var $kN8ZW = parcelRequire("kN8ZW");
const $1957aa217428fa22$var$FieldValueDecoratorAsyncNoMemo = ({ children: children, fieldType: fieldType, fieldProps: fieldProps, fieldId: fieldId })=>{
    const adjustmentsAreEnabled = (0, $ig7wC.useAdjustmentsEnabled)();
    const undecoratedResult = children(fieldProps);
    if ((0, $8ibkc.isFieldTypeSupported)((0, $bKI0B.GIC_VIEW_TYPE), fieldType) && adjustmentsAreEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kN8ZW.EnabledFieldValueDecorator), {
        fieldProps: fieldProps,
        fieldId: fieldId,
        fieldType: fieldType
    }, children);
    return undecoratedResult;
};
const $1957aa217428fa22$export$24545fc29fe55980 = /*#__PURE__*/ (0, $eUqFw.memo)($1957aa217428fa22$var$FieldValueDecoratorAsyncNoMemo);

});
parcelRegister("kN8ZW", function(module, exports) {

$parcel$export(module.exports, "EnabledFieldValueDecorator", () => $c84f9b3e503e326b$export$9d96bb1f53295b76);

var $fcNlw = parcelRequire("fcNlw");

var $gR74I = parcelRequire("gR74I");
const $c84f9b3e503e326b$export$9d96bb1f53295b76 = ({ children: children, fieldId: fieldId, fieldType: fieldType, fieldProps: fieldProps })=>{
    const { onBlur: onBlur, onChange: onChange } = fieldProps;
    const { getFieldValue: getFieldValue } = (0, $gR74I.useFormApi)();
    const { processChange: processChange } = (0, $fcNlw.useIssueAdjustmentsActions)();
    const processChangeByType = (eventType)=>{
        processChange({
            fieldId: fieldId,
            fieldValue: getFieldValue(fieldId),
            eventType: eventType,
            fieldType: fieldType
        });
    };
    const interceptedFieldProps = {
        ...fieldProps,
        onChange: (modifiedValue)=>{
            // Order is important to pass the current value to the UIM
            onChange(modifiedValue);
            processChangeByType('change');
        },
        onBlur: ()=>{
            // Order is important to pass the current value to the UIM
            onBlur();
            processChangeByType('blur');
        }
    };
    return children(interceptedFieldProps);
};

});
parcelRegister("gR74I", function(module, exports) {

$parcel$export(module.exports, "FormApiProvider", () => $722c7ef846088156$export$1e7be89a21d0c0ae);
$parcel$export(module.exports, "useFormApi", () => $722c7ef846088156$export$4607062597b2b4df);

var $eUqFw = parcelRequire("eUqFw");
const $722c7ef846088156$var$Context = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $722c7ef846088156$export$1e7be89a21d0c0ae = ({ children: children, setFieldValue: setFieldValue, getFormState: getFormState })=>{
    const setFieldValueRef = (0, $eUqFw.useRef)(setFieldValue);
    setFieldValueRef.current = setFieldValue;
    const getFormStateRef = (0, $eUqFw.useRef)(getFormState);
    getFormStateRef.current = getFormState;
    const value = (0, $eUqFw.useMemo)(()=>({
            setFieldValue: (...args)=>setFieldValueRef.current(...args),
            getFieldValue: (fieldId)=>getFormStateRef.current().values[fieldId]
        }), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($722c7ef846088156$var$Context.Provider, {
        value: value
    }, children);
};
const $722c7ef846088156$export$4607062597b2b4df = ()=>{
    const context = (0, $eUqFw.useContext)($722c7ef846088156$var$Context);
    if (context === null) throw new Error('Missing FormApiProvider');
    return context;
};

});



parcelRegister("5i7Lk", function(module, exports) {

$parcel$export(module.exports, "FieldMessage", () => $35539f264557e149$export$eb5013679a5d3f69);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $9wcjJ = parcelRequire("9wcjJ");

var $7jPhn = parcelRequire("7jPhn");

var $7Y6sw = parcelRequire("7Y6sw");

var $8cU5f = parcelRequire("8cU5f");

var $iUp5j = parcelRequire("iUp5j");

var $1ybV0 = parcelRequire("1ybV0");

var $4ksts = parcelRequire("4ksts");

var $dEMIg = parcelRequire("dEMIg");

var $9XfZZ = parcelRequire("9XfZZ");

var $huDma = parcelRequire("huDma");


var $Gmy9H = parcelRequire("Gmy9H");

var $a5JEv = parcelRequire("a5JEv");
const $35539f264557e149$var$FieldMessageBehaviour = (props)=>{
    const { description: description = '', error: error, fieldName: fieldName, fieldHelpTextUrl: fieldHelpTextUrl = '', isMini: isMini, onLinkClickEvent: onLinkClickEvent, fieldId: fieldId } = props;
    const { formatMessage: formatMessage, formatNumber: formatNumber } = (0, $4ksts.useIntlV2)();
    const maxHeight = 22;
    const emojiProvider = (0, $iUp5j.useEmojiProvider)();
    const getHelpText = (0, $eUqFw.useCallback)(()=>{
        // fieldHelpTextUrl is used as a unique key. Extracting a suffix just for making the key shorter
        const urlSuffix = fieldHelpTextUrl.substring(fieldHelpTextUrl.lastIndexOf('#'));
        const helperMessage = (0, $Gmy9H.LEARN_MORE_MESSAGES)[urlSuffix] || (0, $a5JEv.default).fieldHelpTextLabel;
        return `[${formatMessage(helperMessage)}|${fieldHelpTextUrl}]`;
    }, [
        formatMessage,
        fieldHelpTextUrl
    ]);
    const adfDocument = (0, $eUqFw.useMemo)(()=>{
        let fieldDescription = description;
        if (fieldHelpTextUrl) {
            if (fieldDescription) fieldDescription = `${fieldDescription} ${getHelpText()}`;
            else fieldDescription = getHelpText();
        }
        return (0, $huDma.convertWikiToAdf)(fieldDescription);
    }, [
        description,
        fieldHelpTextUrl,
        getHelpText
    ]);
    const getErrorMessage = (validationError)=>{
        switch(validationError){
            case 0, $dEMIg.REQUIRED:
                return formatMessage((0, $a5JEv.default).requiredErrorMessage, {
                    fieldName: fieldName
                });
            case 0, $a8a1251974a60726$export$fd7dfa1695d325ca:
                return formatMessage((0, $a5JEv.default).labelsMaxErrorMessage, {
                    MAX_ALLOWED_LABELS: formatNumber((0, $a8a1251974a60726$export$1fdf850c93de8bae))
                });
            case 0, $a8a1251974a60726$export$e77d629cc732976d:
                return formatMessage((0, $a5JEv.default).labelsInvalidErrorMessage, {
                    MAX_LABEL_SIZE: formatNumber((0, $a8a1251974a60726$export$9151073f92820ff8))
                });
            case 0, $a8a1251974a60726$export$618e922e89e8bcae:
                return formatMessage((0, $a5JEv.default).stringInvalidErrorMessage, {
                    fieldName: fieldName,
                    MAX_STRING_SIZE: formatNumber((0, $a8a1251974a60726$export$fe1a70381f6491b5))
                });
            case 0, $a8a1251974a60726$export$8d30d41a8828e14f:
                return formatMessage((0, $a5JEv.default).forgeLabelsInvalidErrorMessage, {
                    MAX_LABEL_SIZE: formatNumber((0, $a8a1251974a60726$export$9151073f92820ff8))
                });
            default:
                return validationError;
        }
    };
    if (error !== undefined && error !== false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, getErrorMessage(error));
    const getRenderer = (isTruncated = false)=>{
        const rendererFFProps = (0, $1ybV0.ff)('platform.linking-platform.jira-renderer-use-default-smartlinks-value') ? {
            smartLinks: (0, $9XfZZ.smartLinksDefault)
        } : {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Y6sw.default // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ), {
            document: adfDocument,
            schema: (0, $9wcjJ.defaultSchema),
            dataProviders: emojiProvider,
            disableHeadingIDs: true,
            featureFlags: {
                codeBidiWarnings: true,
                'code-bidi-warnings': true,
                // enables sending analytics event with renderer specific tti measurement
                // please do not clean up, this feature flag is meant to be rolled out permanently just for a fraction of users
                'renderer-tti-tracking': (0, $1ybV0.ff)('issue.details.renderer.tti-tracking'),
                'allow-windowed-code-block': true
            },
            maxHeight: isTruncated ? maxHeight : undefined,
            truncated: isTruncated,
            fadeOutHeight: isTruncated ? 0 : undefined,
            eventHandlers: {
                smartCard: {
                    onClick: (0, $9XfZZ.onLinkClick)
                },
                link: {
                    onClick: onLinkClickEvent || (0, $9XfZZ.onLinkClick)
                }
            },
            ...rendererFFProps
        });
    };
    const getRenderedDescription = (truncatedRenderer = false)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.HelperMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35539f264557e149$var$Description, {
            "data-testid": "issue-create-commons.common.ui.field-message.description",
            isMini: isMini,
            ...fieldId && {
                id: `${fieldId}-field-message`
            }
        }, getRenderer(truncatedRenderer)));
    if (adfDocument) {
        if (isMini) {
            if (adfDocument.content[0]?.type === 'paragraph') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35539f264557e149$var$TooltipContentContainer, null, getRenderer()),
                position: "bottom"
            }, getRenderedDescription(true));
            return null;
        }
        return getRenderedDescription();
    }
    return null;
};
const $35539f264557e149$export$eb5013679a5d3f69 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($35539f264557e149$var$FieldMessageBehaviour, {
        key: `field-message-${props.fieldId}`,
        ...props
    });
const $35539f264557e149$var$TooltipContentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_woio15cr _1f1h16g6 _13odidpf _9j7z1moj",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $35539f264557e149$var$Description = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isMini: isMini, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_162p546": (0, $9t7rW.default)(__cmplp.isMini && {
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            })
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_woio1wmz _1f1hqk37 _13od1b66 _1pz31ynx",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9wcjJ", function(module, exports) {

$parcel$export(module.exports, "defaultSchemaConfig", () => $6ee0a826b7e77e55$export$e4e3ac1fa64862db);
$parcel$export(module.exports, "getSchemaBasedOnStage", () => $6ee0a826b7e77e55$export$fd147e7d448dea03);
$parcel$export(module.exports, "defaultSchema", () => $6ee0a826b7e77e55$export$1db618b7b2275ea1);

var $5iWql = parcelRequire("5iWql");

var $lUaLf = parcelRequire("lUaLf");
var $jTnho = parcelRequire("jTnho");

var $khrXf = parcelRequire("khrXf");
const $6ee0a826b7e77e55$var$getDefaultSchemaConfig = ()=>{
    const defaultSchemaConfig = {
        nodes: [
            'doc',
            'paragraph',
            'text',
            'bulletList',
            'orderedList',
            'listItem',
            'heading',
            'blockquote',
            'codeBlock',
            'panel',
            'rule',
            'image',
            'caption',
            'mention',
            'media',
            'mediaGroup',
            'mediaSingle',
            'mediaInline',
            'confluenceUnsupportedBlock',
            'confluenceUnsupportedInline',
            'confluenceJiraIssue',
            'expand',
            'nestedExpand',
            'extension',
            'inlineExtension',
            'bodiedExtension',
            'hardBreak',
            'emoji',
            'table',
            'tableCell',
            'tableHeader',
            'tableRow',
            'decisionList',
            'decisionItem',
            'taskList',
            'taskItem',
            'unknownBlock',
            'date',
            'status',
            'placeholder',
            'layoutSection',
            'layoutColumn',
            'inlineCard',
            'blockCard',
            'embedCard',
            'unsupportedBlock',
            'unsupportedInline'
        ],
        marks: [
            'link',
            'em',
            'strong',
            'strike',
            'subsup',
            'underline',
            'code',
            'textColor',
            'backgroundColor',
            'confluenceInlineComment',
            'breakout',
            'alignment',
            'indentation',
            'annotation',
            'dataConsumer',
            'border',
            'unsupportedMark',
            'unsupportedNodeAttribute',
            'typeAheadQuery',
            // https://product-fabric.atlassian.net/browse/ED-10214,
            'fragment'
        ]
    };
    return defaultSchemaConfig;
};
const $6ee0a826b7e77e55$export$e4e3ac1fa64862db = $6ee0a826b7e77e55$var$getDefaultSchemaConfig();
const $6ee0a826b7e77e55$export$fd147e7d448dea03 = (0, $5iWql.default)((stage = 'final')=>{
    const defaultSchemaConfig = $6ee0a826b7e77e55$var$getDefaultSchemaConfig();
    if (stage === 'stage0') defaultSchemaConfig.customNodeSpecs = {
        layoutSection: (0, $jTnho.layoutSectionWithSingleColumn),
        multiBodiedExtension: (0, $lUaLf.multiBodiedExtension),
        extensionFrame: (0, $lUaLf.extensionFrame)
    };
    return (0, $khrXf.createSchema)(defaultSchemaConfig);
});
const $6ee0a826b7e77e55$export$1db618b7b2275ea1 = $6ee0a826b7e77e55$export$fd147e7d448dea03();

});
parcelRegister("lUaLf", function(module, exports) {

$parcel$export(module.exports, "extensionFrame", () => $ff272cde3452ccae$export$4fdcae991fd743e7);
$parcel$export(module.exports, "multiBodiedExtension", () => $ff272cde3452ccae$export$c3c04d555a8b9013);

var $eUEbq = parcelRequire("eUEbq");

var $7XZYM = parcelRequire("7XZYM");
const $ff272cde3452ccae$export$4fdcae991fd743e7 = (0, $7XZYM.extensionFrameStage0)({
    parseDOM: [
        {
            context: 'extensionFrame//',
            tag: 'div[data-extension-frame]',
            skip: true
        },
        {
            tag: 'div[data-extension-frame]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-extension-frame': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $ff272cde3452ccae$export$c3c04d555a8b9013 = (0, $7XZYM.multiBodiedExtensionStage0)({
    parseDOM: [
        {
            context: 'multiBodiedExtension//',
            tag: '[data-node-type="multi-bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="multi-bodied-extension"]',
            getAttrs: (domNode)=>(0, $eUEbq.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'multi-bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});
parcelRegister("eUEbq", function(module, exports) {

$parcel$export(module.exports, "getExtensionAttrs", () => $adb577300eb72d12$export$1765e2758fc47004);
const $adb577300eb72d12$export$d5f21755dc782a4a = (name)=>{
    return !!name && [
        'default',
        'wide',
        'full-width'
    ].includes(name);
};
const $adb577300eb72d12$export$1765e2758fc47004 = (dom, isInline = false)=>{
    const extensionType = dom.getAttribute('data-extension-type');
    const extensionKey = dom.getAttribute('data-extension-key');
    if (!extensionType || !extensionKey) return false;
    const attrs = {
        extensionType: extensionType,
        extensionKey: extensionKey,
        text: dom.getAttribute('data-text') || undefined,
        parameters: JSON.parse(dom.getAttribute('data-parameters') || '{}'),
        localId: dom.getAttribute('data-local-id') || undefined
    };
    if (!isInline) {
        const rawLayout = dom.getAttribute('data-layout');
        attrs.layout = $adb577300eb72d12$export$d5f21755dc782a4a(rawLayout) ? rawLayout : 'default';
    }
    return attrs;
};

});

parcelRegister("7XZYM", function(module, exports) {

$parcel$export(module.exports, "blockCard", () => $5cce1edef7204014$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockquote", () => $5cce1edef7204014$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockquoteLegacy", () => $5cce1edef7204014$export$199922e5af8e9a6);
$parcel$export(module.exports, "bodiedExtension", () => $5cce1edef7204014$export$27903d543b563e39);
$parcel$export(module.exports, "bulletList", () => $5cce1edef7204014$export$a140c94e5ea26bee);
$parcel$export(module.exports, "caption", () => $5cce1edef7204014$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "codeBlock", () => $5cce1edef7204014$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "confluenceJiraIssue", () => $5cce1edef7204014$export$daf889beb5092f95);
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $5cce1edef7204014$export$e6e4878f43c27cab);
$parcel$export(module.exports, "confluenceUnsupportedInline", () => $5cce1edef7204014$export$3e6d667072febc87);
$parcel$export(module.exports, "date", () => $5cce1edef7204014$export$324d90190a8b822a);
$parcel$export(module.exports, "decisionItem", () => $5cce1edef7204014$export$6959e16eeff859b4);
$parcel$export(module.exports, "decisionList", () => $5cce1edef7204014$export$62d45a65fb43d95e);
$parcel$export(module.exports, "doc", () => $5cce1edef7204014$export$2a111da947c407d2);
$parcel$export(module.exports, "embedCard", () => $5cce1edef7204014$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "emoji", () => $5cce1edef7204014$export$a19185d1233fc4b2);
$parcel$export(module.exports, "expand", () => $5cce1edef7204014$export$9f77e0932fb78f72);
$parcel$export(module.exports, "extension", () => $5cce1edef7204014$export$1b45514b112dd749);
$parcel$export(module.exports, "extensionFrameStage0", () => $5cce1edef7204014$export$b555be60c7703afb);
$parcel$export(module.exports, "hardBreak", () => $5cce1edef7204014$export$371da9dd35aba193);
$parcel$export(module.exports, "heading", () => $5cce1edef7204014$export$46e4a324ac90507f);
$parcel$export(module.exports, "image", () => $5cce1edef7204014$export$5c452ff88e35e47d);
$parcel$export(module.exports, "inlineCard", () => $5cce1edef7204014$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineExtensionWithMarks", () => $5cce1edef7204014$export$b3b1e36c2105006d);
$parcel$export(module.exports, "layoutColumn", () => $5cce1edef7204014$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutSection", () => $5cce1edef7204014$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionFull", () => $5cce1edef7204014$export$cdae19acb0a520fd);
$parcel$export(module.exports, "listItem", () => $5cce1edef7204014$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "listItemLegacy", () => $5cce1edef7204014$export$1b6a2528830f2ee1);
$parcel$export(module.exports, "media", () => $5cce1edef7204014$export$987d49ffe1b0900f);
$parcel$export(module.exports, "mediaGroup", () => $5cce1edef7204014$export$2855e964765eac9);
$parcel$export(module.exports, "mediaInline", () => $5cce1edef7204014$export$38bab695e3f720f1);
$parcel$export(module.exports, "mediaSingle", () => $5cce1edef7204014$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingleCaption", () => $5cce1edef7204014$export$8d067f22dc2d1254);
$parcel$export(module.exports, "mediaSingleFull", () => $5cce1edef7204014$export$7e767666f2ce108a);
$parcel$export(module.exports, "mediaSingleWidthType", () => $5cce1edef7204014$export$4bd9a38995f6bf50);
$parcel$export(module.exports, "mention", () => $5cce1edef7204014$export$db83999c14438df4);
$parcel$export(module.exports, "multiBodiedExtensionStage0", () => $5cce1edef7204014$export$750e45819f66d9d0);
$parcel$export(module.exports, "nestedExpand", () => $5cce1edef7204014$export$63cadbf5f4296627);
$parcel$export(module.exports, "orderedList", () => $5cce1edef7204014$export$a5dc81035676e7a);
$parcel$export(module.exports, "panel", () => $5cce1edef7204014$export$21f42ab9b6679f44);
$parcel$export(module.exports, "panelLegacy", () => $5cce1edef7204014$export$aa4e41075a4109d7);
$parcel$export(module.exports, "paragraph", () => $5cce1edef7204014$export$9c206ddddb32a9b);
$parcel$export(module.exports, "placeholder", () => $5cce1edef7204014$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "rule", () => $5cce1edef7204014$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "status", () => $5cce1edef7204014$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "table", () => $5cce1edef7204014$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableCell", () => $5cce1edef7204014$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "tableHeader", () => $5cce1edef7204014$export$48884d2a5190dc73);
$parcel$export(module.exports, "tableRow", () => $5cce1edef7204014$export$ce666bf02318c957);
$parcel$export(module.exports, "taskItem", () => $5cce1edef7204014$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "taskList", () => $5cce1edef7204014$export$375b6afcc5f4d291);
$parcel$export(module.exports, "text", () => $5cce1edef7204014$export$6f093cfa640b7166);
$parcel$export(module.exports, "unsupportedBlock", () => $5cce1edef7204014$export$44b79b0979d0f0f7);
$parcel$export(module.exports, "unsupportedInline", () => $5cce1edef7204014$export$310ebe0d80122e9b);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:pm:full" to regenerate this file.
 */ 
var $9mSQX = parcelRequire("9mSQX");
const $5cce1edef7204014$export$c4c2f833baaebdb8 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: null
        },
        datasource: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $5cce1edef7204014$export$67dc04e652a298ca = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock)+',
    group: 'block',
    selectable: false,
    defining: true
});
const $5cce1edef7204014$export$199922e5af8e9a6 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | unsupportedBlock)+',
    group: 'block',
    selectable: false,
    defining: true
});
const $5cce1edef7204014$export$27903d543b563e39 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'dataConsumer fragment',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $5cce1edef7204014$export$e7320d153c538837 = (0, $9mSQX.createPMNodeSpecFactory)({
    marks: 'dataConsumer fragment',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $5cce1edef7204014$export$a140c94e5ea26bee = (0, $9mSQX.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: false
});
const $5cce1edef7204014$export$8e3c2dfdc4f0453d = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(hardBreak | mention | emoji | date | placeholder | inlineCard | status | text | unsupportedInline)*',
    marks: '_',
    selectable: false,
    isolating: true
});
const $5cce1edef7204014$export$7bb0d5c671655cc4 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        }
    },
    code: true,
    defining: true
});
const $5cce1edef7204014$export$62a75647a293fbec = (0, $9mSQX.createPMNodeSpecFactory)({
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        }
    },
    code: true,
    defining: true
});
const $5cce1edef7204014$export$daf889beb5092f95 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        issueKey: {
            default: ''
        },
        macroId: {
            default: null
        },
        schemaVersion: {
            default: null
        },
        server: {
            default: null
        },
        serverId: {
            default: null
        }
    }
});
const $5cce1edef7204014$export$e6e4878f43c27cab = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
const $5cce1edef7204014$export$3e6d667072febc87 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
const $5cce1edef7204014$export$324d90190a8b822a = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$47988d68fe575725 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$6959e16eeff859b4 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'DECIDED'
        }
    },
    defining: true
});
const $5cce1edef7204014$export$62d45a65fb43d95e = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(decisionItem | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $5cce1edef7204014$export$2a111da947c407d2 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(block | layoutSection | blockRootOnly)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment breakout'
});
const $5cce1edef7204014$export$be4283d9a1cb1ff6 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: ''
        },
        layout: {
            default: 'center'
        },
        width: {
            default: 100
        },
        originalHeight: {
            default: null
        },
        originalWidth: {
            default: null
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$a19185d1233fc4b2 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$f5574b5d45fc2112 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$9f77e0932fb78f72 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $5cce1edef7204014$export$111717af0897b759 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $5cce1edef7204014$export$1b45514b112dd749 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$a8baf338431a691 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$b555be60c7703afb = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | extension | bodiedExtension | unsupportedBlock | blockCard | embedCard)+',
    marks: 'dataConsumer fragment',
    attrs: {},
    selectable: false,
    definingAsContext: false,
    definingForContent: true,
    isolating: true
});
const $5cce1edef7204014$export$371da9dd35aba193 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    selectable: false
});
const $5cce1edef7204014$export$46e4a324ac90507f = (0, $9mSQX.createPMNodeSpecFactory)({
    content: 'inline*',
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $5cce1edef7204014$export$1b0c1557b234fa00 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $5cce1edef7204014$export$85461f751c457cc2 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $5cce1edef7204014$export$2b380a0f7e250af1 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $5cce1edef7204014$export$5c452ff88e35e47d = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        src: {
            default: ''
        },
        alt: {
            default: ''
        },
        title: {
            default: null
        }
    },
    draggable: true
});
const $5cce1edef7204014$export$cbf8224b64e0d942 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $5cce1edef7204014$export$2f4e72b9459914ad = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $5cce1edef7204014$export$16b353b2649bd8d9 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$b3b1e36c2105006d = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$ab76e7c03cd6f650 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(block | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment',
    attrs: {
        width: {
            default: undefined
        }
    },
    selectable: false,
    isolating: true
});
const $5cce1edef7204014$export$b3b6a70a7fa4a5be = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,3} unsupportedBlock* | unsupportedBlock+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    isolating: true
});
const $5cce1edef7204014$export$cdae19acb0a520fd = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){2,3}',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    isolating: true
});
const $5cce1edef7204014$export$206007566ca0aca5 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,3}',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    isolating: true
});
const $5cce1edef7204014$export$76c7e83ecc9cdf05 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    defining: true
});
const $5cce1edef7204014$export$1b6a2528830f2ee1 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock) (paragraph | bulletList | orderedList | mediaSingle | codeBlock | unsupportedBlock)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    defining: true
});
const $5cce1edef7204014$export$987d49ffe1b0900f = (0, $9mSQX.createPMNodeSpecFactory)({
    attrs: {
        type: {
            default: 'file'
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        height: {
            default: null
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        __contextId: {
            default: null
        },
        __displayType: {
            default: null
        },
        __external: {
            default: false
        },
        __fileMimeType: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        url: {
            default: null
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$2855e964765eac9 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(media | unsupportedBlock)+',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {},
    selectable: false
});
const $5cce1edef7204014$export$38bab695e3f720f1 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        type: {
            default: 'file'
        },
        url: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        height: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __fileMimeType: {
            default: null
        },
        __displayType: {
            default: null
        },
        __contextId: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        __external: {
            default: false
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$969fe3781ca15058 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true,
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'annotation border link unsupportedMark unsupportedNodeAttribute'
});
const $5cce1edef7204014$export$8d067f22dc2d1254 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$7e767666f2ce108a = (0, $9mSQX.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$4bd9a38995f6bf50 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: true,
    attrs: {
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$db83999c14438df4 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$46f790bd65f760d0 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$750e45819f66d9d0 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: 'extensionFrame+',
    group: 'blockRootOnly',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    definingAsContext: true
});
const $5cce1edef7204014$export$63cadbf5f4296627 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | panel | blockquote | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $5cce1edef7204014$export$f03786aa6312d1e4 = (0, $9mSQX.createPMNodeSpecFactory)({
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
const $5cce1edef7204014$export$a5dc81035676e7a = (0, $9mSQX.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        order: {
            default: 1
        }
    },
    selectable: false
});
const $5cce1edef7204014$export$21f42ab9b6679f44 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$aa4e41075a4109d7 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$9c206ddddb32a9b = (0, $9mSQX.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $5cce1edef7204014$export$4f98472e6dc14293 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $5cce1edef7204014$export$ea332b61641b0588 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $5cce1edef7204014$export$a1f41dc4901771f8 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $5cce1edef7204014$export$c7187bbd1a7a9244 = (0, $9mSQX.createPMNodeSpecFactory)({
    marks: '',
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        }
    },
    selectable: false
});
const $5cce1edef7204014$export$fbeb3a3956e8a3c7 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block'
});
const $5cce1edef7204014$export$471f7ae5c4103ae1 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$b6ce52be8d7a261 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$9852986a3ec5f6a0 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
const $5cce1edef7204014$export$e1e720e5f4603e6a = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
const $5cce1edef7204014$export$48884d2a5190dc73 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
const $5cce1edef7204014$export$ce666bf02318c957 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    tableRole: 'row'
});
const $5cce1edef7204014$export$6d8b0ef52e2e6390 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
const $5cce1edef7204014$export$375b6afcc5f4d291 = (0, $9mSQX.createPMNodeSpecFactory)({
    content: '(taskItem | unsupportedBlock)+ (taskItem | taskList | unsupportedBlock)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $5cce1edef7204014$export$6f093cfa640b7166 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline'
});
const $5cce1edef7204014$export$5ea06bc686c59dc2 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline'
});
const $5cce1edef7204014$export$93256a4c17b33a82 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline'
});
const $5cce1edef7204014$export$44b79b0979d0f0f7 = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});
const $5cce1edef7204014$export$310ebe0d80122e9b = (0, $9mSQX.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});

});
parcelRegister("9mSQX", function(module, exports) {

$parcel$export(module.exports, "createPMNodeSpecFactory", () => $6d20b7d0ef1b427c$export$bf0a80f00e2b8ff6);
$parcel$export(module.exports, "createPMMarkSpecFactory", () => $6d20b7d0ef1b427c$export$cf5823ed4e9f4c6f);
/**
 * Factory method to attach custom parseDOM and/or toDOM for nodeSpec
 *
 * @example
 * createPMNodeSpecFactory<SomeNode>(node)({parseDOM: {}, toDOM: (node) => {} });
 *
 * @param nodeSpec - NodeSpec without toDom and parseDom
 * @returns A function for a node which allows the consumer to define toDom and parseDom
 */ const $6d20b7d0ef1b427c$export$bf0a80f00e2b8ff6 = (nodeSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
        return {
            ...nodeSpec,
            ...parseDOM && {
                parseDOM: parseDOM
            },
            ...toDOM && {
                toDOM: toDOM
            },
            ...toDebugString && {
                toDebugString: toDebugString
            }
        };
    };
const $6d20b7d0ef1b427c$export$cf5823ed4e9f4c6f = (markSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
        return {
            ...markSpec,
            ...parseDOM && {
                parseDOM: parseDOM
            },
            ...toDOM && {
                toDOM: toDOM
            },
            ...toDebugString && {
                toDebugString: toDebugString
            }
        };
    };

});



parcelRegister("jTnho", function(module, exports) {

$parcel$export(module.exports, "layoutSection", () => $e7b53637cb7eb2d7$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionWithSingleColumn", () => $e7b53637cb7eb2d7$export$4f9d8f623ff17117);

var $7XZYM = parcelRequire("7XZYM");
const $e7b53637cb7eb2d7$export$b3b6a70a7fa4a5be = (0, $7XZYM.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $e7b53637cb7eb2d7$export$cdae19acb0a520fd = (0, $7XZYM.layoutSectionFull)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $e7b53637cb7eb2d7$export$4f9d8f623ff17117 = (0, $7XZYM.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("khrXf", function(module, exports) {

$parcel$export(module.exports, "createSchema", () => $ec3b1467be5518b9$export$5f4ce795563f4211);
$parcel$export(module.exports, "sanitizeNodes", () => $ec3b1467be5518b9$export$daf54fed04c8fb77);

var $7dkLM = parcelRequire("7dkLM");


var $dkRpY = parcelRequire("dkRpY");
var $ht6w1 = parcelRequire("ht6w1");
var $wOKi6 = parcelRequire("wOKi6");
var $dx7fV = parcelRequire("dx7fV");
var $5He3U = parcelRequire("5He3U");
var $4ohT6 = parcelRequire("4ohT6");
var $de8p2 = parcelRequire("de8p2");
var $8nj7b = parcelRequire("8nj7b");
var $79k1z = parcelRequire("79k1z");
var $9iaXL = parcelRequire("9iaXL");
var $l9pLr = parcelRequire("l9pLr");
var $3SpHb = parcelRequire("3SpHb");
var $4w9F8 = parcelRequire("4w9F8");
var $hkdIQ = parcelRequire("hkdIQ");
var $gIVi2 = parcelRequire("gIVi2");
var $6USfM = parcelRequire("6USfM");
var $2ce3x = parcelRequire("2ce3x");
var $7LHzX = parcelRequire("7LHzX");
var $gLNTn = parcelRequire("gLNTn");
var $8osWo = parcelRequire("8osWo");

var $heoPx = parcelRequire("heoPx");
var $jDF31 = parcelRequire("jDF31");
var $eStcf = parcelRequire("eStcf");
var $568Ob = parcelRequire("568Ob");
var $d99SJ = parcelRequire("d99SJ");
var $hgVop = parcelRequire("hgVop");
var $eTtDn = parcelRequire("eTtDn");
var $1Ud4U = parcelRequire("1Ud4U");
var $56qNL = parcelRequire("56qNL");
var $8CDqw = parcelRequire("8CDqw");
var $47B7q = parcelRequire("47B7q");
var $dPUL6 = parcelRequire("dPUL6");
var $1HZv5 = parcelRequire("1HZv5");
var $7XTsD = parcelRequire("7XTsD");
var $5JhXr = parcelRequire("5JhXr");
var $lKuoe = parcelRequire("lKuoe");
var $izui5 = parcelRequire("izui5");
var $7y7sZ = parcelRequire("7y7sZ");
var $lUaLf = parcelRequire("lUaLf");
var $7SlQD = parcelRequire("7SlQD");
var $iWGOh = parcelRequire("iWGOh");
var $iOeir = parcelRequire("iOeir");
var $8mC62 = parcelRequire("8mC62");
var $7xvQK = parcelRequire("7xvQK");
var $1O3jv = parcelRequire("1O3jv");
var $jTnho = parcelRequire("jTnho");
var $3eVto = parcelRequire("3eVto");
var $gN3fl = parcelRequire("gN3fl");
var $1KDvn = parcelRequire("1KDvn");
var $hXvCf = parcelRequire("hXvCf");
var $cvCFq = parcelRequire("cvCFq");
var $fkqTY = parcelRequire("fkqTY");
var $dj4Ew = parcelRequire("dj4Ew");
var $8lnnz = parcelRequire("8lnnz");
var $5bGpU = parcelRequire("5bGpU");
var $dDs5p = parcelRequire("dDs5p");
var $7wZ4m = parcelRequire("7wZ4m");
var $cvo5z = parcelRequire("cvo5z");
var $byxO6 = parcelRequire("byxO6");
var $ie5d6 = parcelRequire("ie5d6");
var $7QozA = parcelRequire("7QozA");
var $ltJuR = parcelRequire("ltJuR");
var $4ne8H = parcelRequire("4ne8H");
var $7p32Z = parcelRequire("7p32Z");
var $8cuPa = parcelRequire("8cuPa");
function $ec3b1467be5518b9$var$addItems(builtInItems, config, customSpecs = {}) {
    if (!config) return {};
    /**
   * Add built-in Node / Mark specs
   */ const items = builtInItems.reduce((items, { name: name, spec: spec })=>{
        if (config.indexOf(name) !== -1) items[name] = customSpecs[name] || spec;
        return items;
    }, {});
    /**
   * Add Custom Node / Mark specs
   */ return Object.keys(customSpecs).reduce((items, name)=>{
        if (items[name]) return items;
        items[name] = customSpecs[name];
        return items;
    }, items);
}
// We use groups to allow schemas to be constructed in different shapes without changing node/mark
// specs, but this means nodes/marks are defined with groups that might never be used in the schema.
// In this scenario ProseMirror will complain and prevent the schema from being constructed.
//
// To avoid the problem, we include items that serve to "declare" the groups in the schema. This
// approach unfortunately leaves unused items in the schema, but has the benefit of avoiding the
// need to manipulate `exclude` or content expression values for potentially every schema item.
function $ec3b1467be5518b9$var$groupDeclaration(name) {
    return {
        name: `__${name}GroupDeclaration`,
        spec: {
            group: name
        }
    };
}
const $ec3b1467be5518b9$var$markGroupDeclarations = [
    $ec3b1467be5518b9$var$groupDeclaration((0, $a82948bb4071f608$export$9b982809044276a6)),
    $ec3b1467be5518b9$var$groupDeclaration((0, $a82948bb4071f608$export$4498a6080fed604c)),
    $ec3b1467be5518b9$var$groupDeclaration((0, $a82948bb4071f608$export$f8e8a5f34f6ea725)),
    $ec3b1467be5518b9$var$groupDeclaration((0, $a82948bb4071f608$export$b395009ca7f092c7))
];
const $ec3b1467be5518b9$var$markGroupDeclarationsNames = $ec3b1467be5518b9$var$markGroupDeclarations.map((groupMark)=>groupMark.name);
const $ec3b1467be5518b9$var$nodesInOrder = [
    {
        name: 'doc',
        spec: (0, $1HZv5.doc)
    },
    {
        name: 'paragraph',
        spec: (0, $5bGpU.paragraph)
    },
    {
        name: 'text',
        spec: (0, $ltJuR.text)
    },
    {
        name: 'bulletList',
        spec: (0, $568Ob.bulletList)
    },
    {
        name: 'orderedList',
        spec: (0, $8lnnz.orderedListWithOrder)
    },
    {
        name: 'listItem',
        spec: (0, $3eVto.listItemWithTask)
    },
    {
        name: 'heading',
        spec: (0, $iWGOh.heading)
    },
    {
        name: 'blockquote',
        spec: (0, $jDF31.blockquoteWithList)
    },
    {
        name: 'codeBlock',
        spec: (0, $hgVop.codeBlock)
    },
    {
        name: 'panel',
        spec: (0, $izui5.extendedPanel)(true)
    },
    {
        name: 'rule',
        spec: (0, $7wZ4m.rule)
    },
    {
        name: 'image',
        spec: (0, $iOeir.image)
    },
    {
        name: 'mention',
        spec: (0, $fkqTY.mention)
    },
    {
        name: 'caption',
        spec: (0, $d99SJ.caption)
    },
    {
        name: 'media',
        spec: (0, $gN3fl.media)
    },
    {
        name: 'mediaGroup',
        spec: (0, $1KDvn.mediaGroup)
    },
    {
        name: 'mediaSingle',
        spec: (0, $cvCFq.mediaSingleFull)
    },
    {
        name: 'mediaInline',
        spec: (0, $hXvCf.mediaInline)
    },
    {
        name: 'placeholder',
        spec: (0, $dDs5p.placeholder)
    },
    {
        name: 'layoutSection',
        spec: (0, $jTnho.layoutSection)
    },
    {
        name: 'layoutColumn',
        spec: (0, $1O3jv.layoutColumn)
    },
    {
        name: 'hardBreak',
        spec: (0, $7SlQD.hardBreak)
    },
    {
        name: 'emoji',
        spec: (0, $5JhXr.emoji)
    },
    {
        name: 'table',
        spec: (0, $byxO6.table)
    },
    {
        name: 'tableCell',
        spec: (0, $byxO6.tableCell)
    },
    {
        name: 'tableRow',
        spec: (0, $byxO6.tableRow)
    },
    {
        name: 'tableHeader',
        spec: (0, $byxO6.tableHeader)
    },
    {
        name: 'confluenceJiraIssue',
        spec: (0, $eTtDn.confluenceJiraIssue)
    },
    {
        name: 'confluenceUnsupportedInline',
        spec: (0, $56qNL.confluenceUnsupportedInline)
    },
    {
        name: 'confluenceUnsupportedBlock',
        spec: (0, $1Ud4U.confluenceUnsupportedBlock)
    },
    {
        name: 'decisionList',
        spec: (0, $dPUL6.decisionList)
    },
    {
        name: 'decisionItem',
        spec: (0, $47B7q.decisionItem)
    },
    {
        name: 'taskList',
        spec: (0, $7QozA.taskList)
    },
    {
        name: 'taskItem',
        spec: (0, $ie5d6.taskItem)
    },
    {
        name: 'date',
        spec: (0, $8CDqw.date)
    },
    {
        name: 'status',
        spec: (0, $cvo5z.status)
    },
    {
        name: 'expand',
        spec: (0, $lKuoe.expand)
    },
    {
        name: 'nestedExpand',
        spec: (0, $dj4Ew.nestedExpand)
    },
    {
        name: 'extension',
        spec: (0, $7y7sZ.extension)
    },
    {
        name: 'inlineExtension',
        spec: (0, $7xvQK.inlineExtension)
    },
    {
        name: 'bodiedExtension',
        spec: (0, $eStcf.bodiedExtension)
    },
    {
        name: 'multiBodiedExtension',
        spec: (0, $lUaLf.multiBodiedExtension)
    },
    {
        name: 'extensionFrame',
        spec: (0, $lUaLf.extensionFrame)
    },
    {
        name: 'inlineCard',
        spec: (0, $8mC62.inlineCard)
    },
    {
        name: 'blockCard',
        spec: (0, $heoPx.blockCard)
    },
    {
        name: 'embedCard',
        spec: (0, $7XTsD.embedCard)
    },
    {
        name: 'unknownBlock',
        spec: (0, $4ne8H.default)
    },
    {
        name: 'unsupportedBlock',
        spec: (0, $7p32Z.unsupportedBlock)
    },
    {
        name: 'unsupportedInline',
        spec: (0, $8cuPa.unsupportedInline)
    }
];
const $ec3b1467be5518b9$var$marksInOrder = [
    {
        name: 'link',
        spec: (0, $3SpHb.link)
    },
    {
        name: 'em',
        spec: (0, $79k1z.em)
    },
    {
        name: 'strong',
        spec: (0, $hkdIQ.strong)
    },
    {
        name: 'textColor',
        spec: (0, $6USfM.textColor)
    },
    {
        name: 'backgroundColor',
        spec: (0, $wOKi6.backgroundColor)
    },
    {
        name: 'strike',
        spec: (0, $4w9F8.strike)
    },
    {
        name: 'subsup',
        spec: (0, $gIVi2.subsup)
    },
    {
        name: 'underline',
        spec: (0, $7LHzX.underline)
    },
    {
        name: 'code',
        spec: (0, $4ohT6.code)
    },
    {
        name: 'typeAheadQuery',
        spec: (0, $2ce3x.typeAheadQuery)
    },
    {
        name: 'alignment',
        spec: (0, $dkRpY.alignment)
    },
    {
        name: 'annotation',
        spec: (0, $ht6w1.annotation)
    },
    {
        name: 'confluenceInlineComment',
        spec: (0, $de8p2.confluenceInlineComment)
    },
    ...$ec3b1467be5518b9$var$markGroupDeclarations,
    {
        name: 'breakout',
        spec: (0, $5He3U.breakout)
    },
    {
        name: 'dataConsumer',
        spec: (0, $8nj7b.dataConsumer)
    },
    {
        name: 'fragment',
        spec: (0, $9iaXL.fragment)
    },
    {
        name: 'indentation',
        spec: (0, $l9pLr.indentation)
    },
    {
        name: 'border',
        spec: (0, $dx7fV.border)
    },
    {
        name: 'unsupportedMark',
        spec: (0, $gLNTn.unsupportedMark)
    },
    {
        name: 'unsupportedNodeAttribute',
        spec: (0, $8osWo.unsupportedNodeAttribute)
    }
];
function $ec3b1467be5518b9$export$2d0c32a809131488() {
    const nodes = $ec3b1467be5518b9$var$nodesInOrder.reduce((acc, { name: name, spec: spec })=>{
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    const marks = $ec3b1467be5518b9$var$marksInOrder.reduce((acc, { name: name, spec: spec })=>{
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    return {
        nodes: nodes,
        marks: marks
    };
}
function $ec3b1467be5518b9$export$5f4ce795563f4211(config) {
    const { customNodeSpecs: customNodeSpecs, customMarkSpecs: customMarkSpecs } = config;
    const nodesConfig = Object.keys(customNodeSpecs || {}).concat(config.nodes);
    const marksConfig = Object.keys(customMarkSpecs || {}).concat(config.marks || []).concat($ec3b1467be5518b9$var$markGroupDeclarationsNames);
    let nodes = $ec3b1467be5518b9$var$addItems($ec3b1467be5518b9$var$nodesInOrder, nodesConfig, customNodeSpecs);
    const marks = $ec3b1467be5518b9$var$addItems($ec3b1467be5518b9$var$marksInOrder, marksConfig, customMarkSpecs);
    nodes = $ec3b1467be5518b9$export$daf54fed04c8fb77(nodes, marks);
    return new (0, $7dkLM.Schema)({
        nodes: nodes,
        marks: marks
    });
}
function $ec3b1467be5518b9$export$daf54fed04c8fb77(nodes, supportedMarks) {
    const nodeNames = Object.keys(nodes);
    nodeNames.forEach((nodeKey)=>{
        const nodeSpec = {
            ...nodes[nodeKey]
        };
        if (nodeSpec.marks && nodeSpec.marks !== '_') nodeSpec.marks = nodeSpec.marks.split(' ').filter((mark)=>!!supportedMarks[mark]).join(' ');
        if (nodeSpec.content) nodeSpec.content = $ec3b1467be5518b9$export$9cb535b0ed27c9c(nodes, nodeSpec.content);
        nodes[nodeKey] = nodeSpec;
    });
    return nodes;
}
function $ec3b1467be5518b9$export$9cb535b0ed27c9c(nodes, rawContent) {
    const content = rawContent.replace(/\W/g, ' ');
    const contentKeys = content.split(' ');
    const unsupportedContentKeys = contentKeys.filter((contentKey)=>!$ec3b1467be5518b9$var$isContentSupported(nodes, contentKey));
    return unsupportedContentKeys.reduce((newContent, nodeName)=>$ec3b1467be5518b9$var$sanitizedContent(newContent, nodeName), rawContent);
}
function $ec3b1467be5518b9$var$sanitizedContent(content, invalidContent) {
    if (!invalidContent.length) return content || '';
    if (!content || !content.match(/\w/)) return '';
    const pattern = `(${invalidContent}((\\s)*\\|)+)|((\\|(\\s)*)+${invalidContent})|(${invalidContent}$)|(${invalidContent}(\\+|\\*))`;
    return content.replace(new RegExp(pattern, 'g'), '').replace('  ', ' ').trim();
}
function $ec3b1467be5518b9$var$isContentSupported(nodes, contentKey) {
    const nodeKeys = Object.keys(nodes);
    // content is with valid node
    if (nodeKeys.indexOf(contentKey) > -1) return true;
    // content is with valid group
    for(const supportedKey in nodes){
        const nodeSpec = nodes[supportedKey];
        if (nodeSpec && nodeSpec.group === contentKey) return true;
    }
    return false;
}
const $ec3b1467be5518b9$export$c77b6d30da5276a1 = true;

});
parcelRegister("7dkLM", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $5409dbb98ebf29ba$export$ffb0004e005737fa);
$parcel$export(module.exports, "Mark", () => $5409dbb98ebf29ba$export$c9d15bcfc6d42044);
$parcel$export(module.exports, "ReplaceError", () => $5409dbb98ebf29ba$export$6de0e778727af3f2);
$parcel$export(module.exports, "Slice", () => $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e);
$parcel$export(module.exports, "ResolvedPos", () => $5409dbb98ebf29ba$export$b2a42f82e59e4b19);
$parcel$export(module.exports, "NodeRange", () => $5409dbb98ebf29ba$export$7bc461ceb770fb16);
$parcel$export(module.exports, "Node", () => $5409dbb98ebf29ba$export$85c928794f8d04d4);
$parcel$export(module.exports, "MarkType", () => $5409dbb98ebf29ba$export$b6a78689043c6521);
$parcel$export(module.exports, "Schema", () => $5409dbb98ebf29ba$export$19342e026b58ebb7);
$parcel$export(module.exports, "DOMParser", () => $5409dbb98ebf29ba$export$1059c6e7d2ce5669);
$parcel$export(module.exports, "DOMSerializer", () => $5409dbb98ebf29ba$export$3476b78f8f5a8b72);

var $cPnfS = parcelRequire("cPnfS");
function $5409dbb98ebf29ba$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $5409dbb98ebf29ba$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $5409dbb98ebf29ba$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $5409dbb98ebf29ba$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $5409dbb98ebf29ba$export$ffb0004e005737fa {
    /**
    @internal
    */ constructor(/**
    @internal
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $5409dbb98ebf29ba$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $5409dbb98ebf29ba$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $5409dbb98ebf29ba$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $5409dbb98ebf29ba$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $5409dbb98ebf29ba$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $5409dbb98ebf29ba$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $5409dbb98ebf29ba$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $5409dbb98ebf29ba$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $5409dbb98ebf29ba$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. (Not public.)
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $5409dbb98ebf29ba$var$retIndex(0, pos);
        if (pos == this.size) return $5409dbb98ebf29ba$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $5409dbb98ebf29ba$var$retIndex(i + 1, end);
                return $5409dbb98ebf29ba$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $5409dbb98ebf29ba$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $5409dbb98ebf29ba$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $5409dbb98ebf29ba$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $5409dbb98ebf29ba$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $5409dbb98ebf29ba$export$ffb0004e005737fa.empty;
        if (nodes instanceof $5409dbb98ebf29ba$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $5409dbb98ebf29ba$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $5409dbb98ebf29ba$export$ffb0004e005737fa.empty = new $5409dbb98ebf29ba$export$ffb0004e005737fa([], 0);
const $5409dbb98ebf29ba$var$found = {
    index: 0,
    offset: 0
};
function $5409dbb98ebf29ba$var$retIndex(index, offset) {
    $5409dbb98ebf29ba$var$found.index = index;
    $5409dbb98ebf29ba$var$found.offset = offset;
    return $5409dbb98ebf29ba$var$found;
}
function $5409dbb98ebf29ba$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$5409dbb98ebf29ba$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$5409dbb98ebf29ba$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $5409dbb98ebf29ba$export$c9d15bcfc6d42044 {
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $5409dbb98ebf29ba$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        return type.create(json.attrs);
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none;
        if (marks instanceof $5409dbb98ebf29ba$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
}
/**
The empty set of marks.
*/ $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $5409dbb98ebf29ba$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e {
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $5409dbb98ebf29ba$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e($5409dbb98ebf29ba$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e($5409dbb98ebf29ba$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
}
/**
The empty slice.
*/ $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e.empty = new $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e($5409dbb98ebf29ba$export$ffb0004e005737fa.empty, 0, 0);
function $5409dbb98ebf29ba$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($5409dbb98ebf29ba$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $5409dbb98ebf29ba$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $5409dbb98ebf29ba$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $5409dbb98ebf29ba$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $5409dbb98ebf29ba$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $5409dbb98ebf29ba$export$6de0e778727af3f2("Inconsistent open depths");
    return $5409dbb98ebf29ba$var$replaceOuter($from, $to, slice, 0);
}
function $5409dbb98ebf29ba$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $5409dbb98ebf29ba$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $5409dbb98ebf29ba$var$close(node, $5409dbb98ebf29ba$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $5409dbb98ebf29ba$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $5409dbb98ebf29ba$var$prepareSliceForReplace(slice, $from);
        return $5409dbb98ebf29ba$var$close(node, $5409dbb98ebf29ba$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $5409dbb98ebf29ba$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $5409dbb98ebf29ba$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $5409dbb98ebf29ba$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $5409dbb98ebf29ba$var$checkJoin(node, $after.node(depth));
    return node;
}
function $5409dbb98ebf29ba$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $5409dbb98ebf29ba$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $5409dbb98ebf29ba$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$5409dbb98ebf29ba$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $5409dbb98ebf29ba$var$addNode($end.nodeBefore, target);
}
function $5409dbb98ebf29ba$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $5409dbb98ebf29ba$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $5409dbb98ebf29ba$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $5409dbb98ebf29ba$var$joinable($end, $to, depth + 1);
    let content = [];
    $5409dbb98ebf29ba$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $5409dbb98ebf29ba$var$checkJoin(openStart, openEnd);
        $5409dbb98ebf29ba$var$addNode($5409dbb98ebf29ba$var$close(openStart, $5409dbb98ebf29ba$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $5409dbb98ebf29ba$var$addNode($5409dbb98ebf29ba$var$close(openStart, $5409dbb98ebf29ba$var$replaceTwoWay($from, $start, depth + 1)), content);
        $5409dbb98ebf29ba$var$addRange($start, $end, depth, content);
        if (openEnd) $5409dbb98ebf29ba$var$addNode($5409dbb98ebf29ba$var$close(openEnd, $5409dbb98ebf29ba$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $5409dbb98ebf29ba$var$addRange($to, null, depth, content);
    return new $5409dbb98ebf29ba$export$ffb0004e005737fa(content);
}
function $5409dbb98ebf29ba$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $5409dbb98ebf29ba$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $5409dbb98ebf29ba$var$joinable($from, $to, depth + 1);
        $5409dbb98ebf29ba$var$addNode($5409dbb98ebf29ba$var$close(type, $5409dbb98ebf29ba$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $5409dbb98ebf29ba$var$addRange($to, null, depth, content);
    return new $5409dbb98ebf29ba$export$ffb0004e005737fa(content);
}
function $5409dbb98ebf29ba$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($5409dbb98ebf29ba$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $5409dbb98ebf29ba$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $5409dbb98ebf29ba$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $5409dbb98ebf29ba$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        for(let i = 0; i < $5409dbb98ebf29ba$var$resolveCache.length; i++){
            let cached = $5409dbb98ebf29ba$var$resolveCache[i];
            if (cached.pos == pos && cached.doc == doc) return cached;
        }
        let result = $5409dbb98ebf29ba$var$resolveCache[$5409dbb98ebf29ba$var$resolveCachePos] = $5409dbb98ebf29ba$export$b2a42f82e59e4b19.resolve(doc, pos);
        $5409dbb98ebf29ba$var$resolveCachePos = ($5409dbb98ebf29ba$var$resolveCachePos + 1) % $5409dbb98ebf29ba$var$resolveCacheSize;
        return result;
    }
}
let $5409dbb98ebf29ba$var$resolveCache = [], $5409dbb98ebf29ba$var$resolveCachePos = 0, $5409dbb98ebf29ba$var$resolveCacheSize = 12;
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $5409dbb98ebf29ba$export$7bc461ceb770fb16 {
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
}
const $5409dbb98ebf29ba$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/ class $5409dbb98ebf29ba$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $5409dbb98ebf29ba$export$ffb0004e005737fa.empty;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $5409dbb98ebf29ba$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $5409dbb98ebf29ba$var$emptyAttrs) && $5409dbb98ebf29ba$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $5409dbb98ebf29ba$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $5409dbb98ebf29ba$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $5409dbb98ebf29ba$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $5409dbb98ebf29ba$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $5409dbb98ebf29ba$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $5409dbb98ebf29ba$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $5409dbb98ebf29ba$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise error when they do not.
    */ check() {
        this.type.checkContent(this.content);
        let copy = $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++)copy = this.marks[i].addToSet(copy);
        if (!$5409dbb98ebf29ba$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = null;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $5409dbb98ebf29ba$export$ffb0004e005737fa.fromJSON(schema, json.content);
        return schema.nodeType(json.type).create(json.attrs, content, marks);
    }
}
$5409dbb98ebf29ba$export$85c928794f8d04d4.prototype.text = undefined;
class $5409dbb98ebf29ba$var$TextNode extends $5409dbb98ebf29ba$export$85c928794f8d04d4 {
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $5409dbb98ebf29ba$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $5409dbb98ebf29ba$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $5409dbb98ebf29ba$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
}
function $5409dbb98ebf29ba$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $5409dbb98ebf29ba$export$364ed450558d7ec4 {
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $5409dbb98ebf29ba$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $5409dbb98ebf29ba$export$364ed450558d7ec4.empty;
        let expr = $5409dbb98ebf29ba$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $5409dbb98ebf29ba$var$dfa($5409dbb98ebf29ba$var$nfa(expr));
        $5409dbb98ebf29ba$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $5409dbb98ebf29ba$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
}
/**
@internal
*/ $5409dbb98ebf29ba$export$364ed450558d7ec4.empty = new $5409dbb98ebf29ba$export$364ed450558d7ec4(true);
class $5409dbb98ebf29ba$var$TokenStream {
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
}
function $5409dbb98ebf29ba$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($5409dbb98ebf29ba$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $5409dbb98ebf29ba$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($5409dbb98ebf29ba$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $5409dbb98ebf29ba$var$parseExprSubscript(stream) {
    let expr = $5409dbb98ebf29ba$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $5409dbb98ebf29ba$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $5409dbb98ebf29ba$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $5409dbb98ebf29ba$var$parseExprRange(stream, expr) {
    let min = $5409dbb98ebf29ba$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $5409dbb98ebf29ba$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $5409dbb98ebf29ba$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.groups.indexOf(name) > -1) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $5409dbb98ebf29ba$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $5409dbb98ebf29ba$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $5409dbb98ebf29ba$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
/**
Construct an NFA from an expression as returned by the parser. The
NFA is represented as an array of states, which are themselves
arrays of edges, which are `{term, to}` objects. The first state is
the entry state and the last node is the success state.

Note that unlike typical NFAs, the edge ordering in this one is
significant, in that it is used to contruct filler content when
necessary.
*/ function $5409dbb98ebf29ba$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $5409dbb98ebf29ba$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $5409dbb98ebf29ba$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($5409dbb98ebf29ba$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $5409dbb98ebf29ba$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($5409dbb98ebf29ba$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $5409dbb98ebf29ba$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $5409dbb98ebf29ba$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($5409dbb98ebf29ba$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $5409dbb98ebf29ba$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $5409dbb98ebf29ba$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $5409dbb98ebf29ba$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $5409dbb98ebf29ba$var$initAttrs(attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $5409dbb98ebf29ba$var$Attribute(attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $5409dbb98ebf29ba$export$f06e977173f1857c {
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $5409dbb98ebf29ba$var$initAttrs(spec.attrs);
        this.defaultAttrs = $5409dbb98ebf29ba$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $5409dbb98ebf29ba$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $5409dbb98ebf29ba$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $5409dbb98ebf29ba$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $5409dbb98ebf29ba$export$ffb0004e005737fa.from(content), $5409dbb98ebf29ba$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $5409dbb98ebf29ba$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $5409dbb98ebf29ba$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $5409dbb98ebf29ba$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $5409dbb98ebf29ba$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($5409dbb98ebf29ba$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $5409dbb98ebf29ba$export$85c928794f8d04d4(this, attrs, content.append(after), $5409dbb98ebf29ba$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type with the given attributes.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $5409dbb98ebf29ba$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
}
// Attribute descriptors
class $5409dbb98ebf29ba$var$Attribute {
    constructor(options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
    }
    get isRequired() {
        return !this.hasDefault;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $5409dbb98ebf29ba$export$b6a78689043c6521 {
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $5409dbb98ebf29ba$var$initAttrs(spec.attrs);
        this.excluded = null;
        let defaults = $5409dbb98ebf29ba$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $5409dbb98ebf29ba$export$c9d15bcfc6d42044(this, defaults) : null;
    }
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $5409dbb98ebf29ba$export$c9d15bcfc6d42044(this, $5409dbb98ebf29ba$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $5409dbb98ebf29ba$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $5409dbb98ebf29ba$export$19342e026b58ebb7 {
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $cPnfS.default).from(spec.nodes), instanceSpec.marks = (0, $cPnfS.default).from(spec.marks || {}), this.nodes = $5409dbb98ebf29ba$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $5409dbb98ebf29ba$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $5409dbb98ebf29ba$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            type.markSet = markExpr == "_" ? null : markExpr ? $5409dbb98ebf29ba$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $5409dbb98ebf29ba$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $5409dbb98ebf29ba$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $5409dbb98ebf29ba$var$TextNode(type, type.defaultAttrs, text, $5409dbb98ebf29ba$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $5409dbb98ebf29ba$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $5409dbb98ebf29ba$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
}
function $5409dbb98ebf29ba$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $5409dbb98ebf29ba$export$1059c6e7d2ce5669 {
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        rules.forEach((rule)=>{
            if (rule.tag) this.tags.push(rule);
            else if (rule.style) this.styles.push(rule);
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $5409dbb98ebf29ba$var$ParseContext(this, options, false);
        context.addAll(dom, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $5409dbb98ebf29ba$var$ParseContext(this, options, true);
        context.addAll(dom, options.from, options.to);
        return $5409dbb98ebf29ba$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($5409dbb98ebf29ba$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $5409dbb98ebf29ba$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $5409dbb98ebf29ba$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $5409dbb98ebf29ba$export$1059c6e7d2ce5669(schema, $5409dbb98ebf29ba$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
}
const $5409dbb98ebf29ba$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $5409dbb98ebf29ba$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $5409dbb98ebf29ba$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $5409dbb98ebf29ba$var$OPT_PRESERVE_WS = 1, $5409dbb98ebf29ba$var$OPT_PRESERVE_WS_FULL = 2, $5409dbb98ebf29ba$var$OPT_OPEN_LEFT = 4;
function $5409dbb98ebf29ba$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $5409dbb98ebf29ba$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $5409dbb98ebf29ba$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $5409dbb98ebf29ba$var$OPT_PRESERVE_WS | $5409dbb98ebf29ba$var$OPT_PRESERVE_WS_FULL : base & ~$5409dbb98ebf29ba$var$OPT_OPEN_LEFT;
}
class $5409dbb98ebf29ba$var$NodeContext {
    constructor(type, attrs, // Marks applied to this node itself
    marks, // Marks that can't apply here, but will be used in children if possible
    pendingMarks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.pendingMarks = pendingMarks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none;
        // Nested Marks with same type
        this.stashMarks = [];
        this.match = match || (options & $5409dbb98ebf29ba$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($5409dbb98ebf29ba$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $5409dbb98ebf29ba$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $5409dbb98ebf29ba$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($5409dbb98ebf29ba$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    popFromStashMark(mark) {
        for(let i = this.stashMarks.length - 1; i >= 0; i--)if (mark.eq(this.stashMarks[i])) return this.stashMarks.splice(i, 1)[0];
    }
    applyPending(nextType) {
        for(let i = 0, pending = this.pendingMarks; i < pending.length; i++){
            let mark = pending[i];
            if ((this.type ? this.type.allowsMarkType(mark.type) : $5409dbb98ebf29ba$var$markMayApply(mark.type, nextType)) && !mark.isInSet(this.activeMarks)) {
                this.activeMarks = mark.addToSet(this.activeMarks);
                this.pendingMarks = mark.removeFromSet(this.pendingMarks);
            }
        }
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$5409dbb98ebf29ba$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
}
class $5409dbb98ebf29ba$var$ParseContext {
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        let topNode = options.topNode, topContext;
        let topOptions = $5409dbb98ebf29ba$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $5409dbb98ebf29ba$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $5409dbb98ebf29ba$var$NodeContext(topNode.type, topNode.attrs, $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none, $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $5409dbb98ebf29ba$var$NodeContext(null, null, $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none, $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $5409dbb98ebf29ba$var$NodeContext(parser.schema.topNodeType, null, $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none, $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom) {
        if (dom.nodeType == 3) this.addTextNode(dom);
        else if (dom.nodeType == 1) this.addElement(dom);
    }
    withStyleRules(dom, f) {
        let style = dom.getAttribute("style");
        if (!style) return f();
        let marks = this.readStyles($5409dbb98ebf29ba$var$parseStyles(style));
        if (!marks) return; // A style with ignore: true
        let [addMarks, removeMarks] = marks, top = this.top;
        for(let i = 0; i < removeMarks.length; i++)this.removePendingMark(removeMarks[i], top);
        for(let i = 0; i < addMarks.length; i++)this.addPendingMark(addMarks[i]);
        f();
        for(let i = 0; i < addMarks.length; i++)this.removePendingMark(addMarks[i], top);
        for(let i = 0; i < removeMarks.length; i++)this.addPendingMark(removeMarks[i]);
    }
    addTextNode(dom) {
        let value = dom.nodeValue;
        let top = this.top;
        if (top.options & $5409dbb98ebf29ba$var$OPT_PRESERVE_WS_FULL || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!(top.options & $5409dbb98ebf29ba$var$OPT_PRESERVE_WS)) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (!(top.options & $5409dbb98ebf29ba$var$OPT_PRESERVE_WS_FULL)) value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value));
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, matchAfter) {
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($5409dbb98ebf29ba$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $5409dbb98ebf29ba$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        if (rule ? rule.ignore : $5409dbb98ebf29ba$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, top = this.top, oldNeedsBlock = this.needsBlock;
            if ($5409dbb98ebf29ba$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom);
                return;
            }
            if (rule && rule.skip) this.addAll(dom);
            else this.withStyleRules(dom, ()=>this.addAll(dom));
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else this.withStyleRules(dom, ()=>{
            this.addElementByRule(dom, rule, rule.consuming === false ? ruleID : undefined);
        });
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"));
    }
    // Called for ignored nodes
    ignoreFallback(dom) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"));
    }
    // Run any style parser associated with the node's styles. Either
    // return an array of marks, or null to indicate some of the styles
    // had a rule with `ignore` set.
    readStyles(styles) {
        let add = $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none, remove = $5409dbb98ebf29ba$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < styles.length; i += 2)for(let after = undefined;;){
            let rule = this.parser.matchStyle(styles[i], styles[i + 1], this, after);
            if (!rule) break;
            if (rule.ignore) return null;
            if (rule.clearMark) this.top.pendingMarks.concat(this.top.activeMarks).forEach((m)=>{
                if (rule.clearMark(m)) remove = m.addToSet(remove);
            });
            else add = this.parser.schema.marks[rule.mark].create(rule.attrs).addToSet(add);
            if (rule.consuming === false) after = rule;
            else break;
        }
        return [
            add,
            remove
        ];
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, continueAfter) {
        let sync, nodeType, mark;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) sync = this.enter(nodeType, rule.attrs || null, rule.preserveWhitespace);
            else if (!this.insertNode(nodeType.create(rule.attrs))) this.leafFallback(dom);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            mark = markType.create(rule.attrs);
            this.addPendingMark(mark);
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM);
        }
        if (sync && this.sync(startIn)) this.open--;
        if (mark) this.removePendingMark(mark, startIn);
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return false;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)this.enterInner(route[i], null, false);
        return true;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) this.enterInner(block);
        }
        if (this.findPlace(node)) {
            this.closeExtra();
            let top = this.top;
            top.applyPending(node.type);
            if (top.match) top.match = top.match.matchType(node.type);
            let marks = top.activeMarks;
            for(let i = 0; i < node.marks.length; i++)if (!top.type || top.type.allowsMarkType(node.marks[i].type)) marks = node.marks[i].addToSet(marks);
            top.content.push(node.mark(marks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, preserveWS) {
        let ok = this.findPlace(type.create(attrs));
        if (ok) this.enterInner(type, attrs, true, preserveWS);
        return ok;
    }
    // Open a node of the given type
    enterInner(type, attrs = null, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.applyPending(type);
        top.match = top.match && top.match.matchType(type);
        let options = $5409dbb98ebf29ba$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $5409dbb98ebf29ba$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $5409dbb98ebf29ba$var$OPT_OPEN_LEFT;
        this.nodes.push(new $5409dbb98ebf29ba$var$NodeContext(type, attrs, top.activeMarks, top.pendingMarks, solid, null, options));
        this.open++;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(this.isOpen || this.options.topOpen);
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--)if (this.nodes[i] == to) {
            this.open = i;
            return true;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && next.groups.indexOf(part) == -1) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
    addPendingMark(mark) {
        let found = $5409dbb98ebf29ba$var$findSameMarkInSet(mark, this.top.pendingMarks);
        if (found) this.top.stashMarks.push(found);
        this.top.pendingMarks = mark.addToSet(this.top.pendingMarks);
    }
    removePendingMark(mark, upto) {
        for(let depth = this.open; depth >= 0; depth--){
            let level = this.nodes[depth];
            let found = level.pendingMarks.lastIndexOf(mark);
            if (found > -1) level.pendingMarks = mark.removeFromSet(level.pendingMarks);
            else {
                level.activeMarks = mark.removeFromSet(level.activeMarks);
                let stashMark = level.popFromStashMark(mark);
                if (stashMark && level.type && level.type.allowsMarkType(stashMark.type)) level.activeMarks = stashMark.addToSet(level.activeMarks);
            }
            if (level == upto) break;
        }
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $5409dbb98ebf29ba$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $5409dbb98ebf29ba$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $5409dbb98ebf29ba$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
// Tokenize a style attribute into property/value pairs.
function $5409dbb98ebf29ba$var$parseStyles(style) {
    let re = /\s*([\w-]+)\s*:\s*([^;]+)/g, m, result = [];
    while(m = re.exec(style))result.push(m[1], m[2].trim());
    return result;
}
function $5409dbb98ebf29ba$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $5409dbb98ebf29ba$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
function $5409dbb98ebf29ba$var$findSameMarkInSet(mark, set) {
    for(let i = 0; i < set.length; i++){
        if (mark.eq(set[i])) return set[i];
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $5409dbb98ebf29ba$export$3476b78f8f5a8b72 {
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $5409dbb98ebf29ba$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $5409dbb98ebf29ba$export$3476b78f8f5a8b72.renderSpec($5409dbb98ebf29ba$var$doc(options), this.nodes[node.type.name](node));
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $5409dbb98ebf29ba$export$3476b78f8f5a8b72.renderSpec($5409dbb98ebf29ba$var$doc(options), toDOM(mark, inline));
    }
    /**
    Render an [output spec](https://prosemirror.net/docs/ref/#model.DOMOutputSpec) to a DOM node. If
    the spec has a hole (zero) in it, `contentDOM` will point at the
    node with the hole.
    */ static renderSpec(doc, structure, xmlNS = null) {
        if (typeof structure == "string") return {
            dom: doc.createTextNode(structure)
        };
        if (structure.nodeType != null) return {
            dom: structure
        };
        if (structure.dom && structure.dom.nodeType != null) return structure;
        let tagName = structure[0], space = tagName.indexOf(" ");
        if (space > 0) {
            xmlNS = tagName.slice(0, space);
            tagName = tagName.slice(space + 1);
        }
        let contentDOM;
        let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
        let attrs = structure[1], start = 1;
        if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
            start = 2;
            for(let name in attrs)if (attrs[name] != null) {
                let space = name.indexOf(" ");
                if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
                else dom.setAttribute(name, attrs[name]);
            }
        }
        for(let i = start; i < structure.length; i++){
            let child = structure[i];
            if (child === 0) {
                if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
                return {
                    dom: dom,
                    contentDOM: dom
                };
            } else {
                let { dom: inner, contentDOM: innerContent } = $5409dbb98ebf29ba$export$3476b78f8f5a8b72.renderSpec(doc, child, xmlNS);
                dom.appendChild(inner);
                if (innerContent) {
                    if (contentDOM) throw new RangeError("Multiple content holes");
                    contentDOM = innerContent;
                }
            }
        }
        return {
            dom: dom,
            contentDOM: contentDOM
        };
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $5409dbb98ebf29ba$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $5409dbb98ebf29ba$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $5409dbb98ebf29ba$var$gatherToDOM(schema.marks);
    }
}
function $5409dbb98ebf29ba$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $5409dbb98ebf29ba$var$doc(options) {
    return options.document || window.document;
}

});
parcelRegister("cPnfS", function(module, exports) {

$parcel$export(module.exports, "default", () => $956c496b6231a8e7$export$2e2bcd8739ae039);
// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function $956c496b6231a8e7$var$OrderedMap(content) {
    this.content = content;
}
$956c496b6231a8e7$var$OrderedMap.prototype = {
    constructor: $956c496b6231a8e7$var$OrderedMap,
    find: function(key) {
        for(var i = 0; i < this.content.length; i += 2)if (this.content[i] === key) return i;
        return -1;
    },
    // :: (string) → ?any
    // Retrieve the value stored under `key`, or return undefined when
    // no such key exists.
    get: function(key) {
        var found = this.find(key);
        return found == -1 ? undefined : this.content[found + 1];
    },
    // :: (string, any, ?string) → OrderedMap
    // Create a new map by replacing the value of `key` with a new
    // value, or adding a binding to the end of the map. If `newKey` is
    // given, the key of the binding will be replaced with that key.
    update: function(key, value, newKey) {
        var self = newKey && newKey != key ? this.remove(newKey) : this;
        var found = self.find(key), content = self.content.slice();
        if (found == -1) content.push(newKey || key, value);
        else {
            content[found + 1] = value;
            if (newKey) content[found] = newKey;
        }
        return new $956c496b6231a8e7$var$OrderedMap(content);
    },
    // :: (string) → OrderedMap
    // Return a map with the given key removed, if it existed.
    remove: function(key) {
        var found = this.find(key);
        if (found == -1) return this;
        var content = this.content.slice();
        content.splice(found, 2);
        return new $956c496b6231a8e7$var$OrderedMap(content);
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the start of the map.
    addToStart: function(key, value) {
        return new $956c496b6231a8e7$var$OrderedMap([
            key,
            value
        ].concat(this.remove(key).content));
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the end of the map.
    addToEnd: function(key, value) {
        var content = this.remove(key).content.slice();
        content.push(key, value);
        return new $956c496b6231a8e7$var$OrderedMap(content);
    },
    // :: (string, string, any) → OrderedMap
    // Add a key after the given key. If `place` is not found, the new
    // key is added to the end.
    addBefore: function(place, key, value) {
        var without = this.remove(key), content = without.content.slice();
        var found = without.find(place);
        content.splice(found == -1 ? content.length : found, 0, key, value);
        return new $956c496b6231a8e7$var$OrderedMap(content);
    },
    // :: ((key: string, value: any))
    // Call the given function for each key/value pair in the map, in
    // order.
    forEach: function(f) {
        for(var i = 0; i < this.content.length; i += 2)f(this.content[i], this.content[i + 1]);
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by prepending the keys in this map that don't
    // appear in `map` before the keys in `map`.
    prepend: function(map) {
        map = $956c496b6231a8e7$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $956c496b6231a8e7$var$OrderedMap(map.content.concat(this.subtract(map).content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by appending the keys in this map that don't
    // appear in `map` after the keys in `map`.
    append: function(map) {
        map = $956c496b6231a8e7$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $956c496b6231a8e7$var$OrderedMap(this.subtract(map).content.concat(map.content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a map containing all the keys in this map that don't
    // appear in `map`.
    subtract: function(map) {
        var result = this;
        map = $956c496b6231a8e7$var$OrderedMap.from(map);
        for(var i = 0; i < map.content.length; i += 2)result = result.remove(map.content[i]);
        return result;
    },
    // :: () → Object
    // Turn ordered map into a plain object.
    toObject: function() {
        var result = {};
        this.forEach(function(key, value) {
            result[key] = value;
        });
        return result;
    },
    // :: number
    // The amount of keys in this map.
    get size () {
        return this.content.length >> 1;
    }
};
// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
$956c496b6231a8e7$var$OrderedMap.from = function(value) {
    if (value instanceof $956c496b6231a8e7$var$OrderedMap) return value;
    var content = [];
    if (value) for(var prop in value)content.push(prop, value[prop]);
    return new $956c496b6231a8e7$var$OrderedMap(content);
};
var $956c496b6231a8e7$export$2e2bcd8739ae039 = $956c496b6231a8e7$var$OrderedMap;

});


// # What do marks exist?
//
// Marks are categorised into different groups. One motivation for this was to allow the `code` mark
// to exclude other marks, without needing to explicitly name them. Explicit naming requires the
// named mark to exist in the schema. This is undesirable because we want to construct different
// schemas that have different sets of nodes/marks.
//
// Groups provide a level of indirection, and solve this problem. For the immediate use-case, one
// group called "not_code" would have sufficed, but this an ultra-specialised to code.
// Mark group for font styling (e.g. bold, italic, underline, superscript).
const $a82948bb4071f608$export$4498a6080fed604c = 'fontStyle';
const $a82948bb4071f608$export$f8e8a5f34f6ea725 = 'searchQuery';
const $a82948bb4071f608$export$b395009ca7f092c7 = 'link';
const $a82948bb4071f608$export$9b982809044276a6 = 'color';
const $a82948bb4071f608$export$470d0905851e47a1 = 'alignment';
const $a82948bb4071f608$export$bacb7f4b06a06b22 = 'indentation';

parcelRegister("dkRpY", function(module, exports) {

$parcel$export(module.exports, "alignmentPositionMap", () => $9b569454df3a2499$export$be9cf49015769bbd);
$parcel$export(module.exports, "alignment", () => $9b569454df3a2499$export$8e53000a4ec837);

var $iGMmR = parcelRequire("iGMmR");
const $9b569454df3a2499$export$be9cf49015769bbd = {
    end: 'right',
    right: 'end',
    center: 'center'
};
const $9b569454df3a2499$export$8e53000a4ec837 = (0, $iGMmR.alignment)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-block-mark',
            getAttrs: (dom)=>{
                const align = dom.getAttribute('data-align');
                return align ? {
                    align: align
                } : false;
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: `fabric-editor-block-mark fabric-editor-alignment fabric-editor-align-${mark.attrs.align}`,
                'data-align': mark.attrs.align
            },
            0
        ];
    }
});

});
parcelRegister("iGMmR", function(module, exports) {

$parcel$export(module.exports, "alignment", () => $d9b1ab0e2c5c423a$export$8e53000a4ec837);
$parcel$export(module.exports, "annotation", () => $d9b1ab0e2c5c423a$export$8512c9afa7b24c3b);
$parcel$export(module.exports, "backgroundColor", () => $d9b1ab0e2c5c423a$export$8c5a050822fd698c);
$parcel$export(module.exports, "border", () => $d9b1ab0e2c5c423a$export$1edee58a52776cd9);
$parcel$export(module.exports, "breakout", () => $d9b1ab0e2c5c423a$export$89015c65f1c75e3f);
$parcel$export(module.exports, "code", () => $d9b1ab0e2c5c423a$export$6565f9f03506010b);
$parcel$export(module.exports, "confluenceInlineComment", () => $d9b1ab0e2c5c423a$export$f3b72f8fc4684ecd);
$parcel$export(module.exports, "dataConsumer", () => $d9b1ab0e2c5c423a$export$3024f02c495408d6);
$parcel$export(module.exports, "em", () => $d9b1ab0e2c5c423a$export$c63c6f932822f543);
$parcel$export(module.exports, "fragment", () => $d9b1ab0e2c5c423a$export$f00aeb236b6f05af);
$parcel$export(module.exports, "indentation", () => $d9b1ab0e2c5c423a$export$480c699bd4ec0d86);
$parcel$export(module.exports, "link", () => $d9b1ab0e2c5c423a$export$9c30223ca0a664fb);
$parcel$export(module.exports, "strike", () => $d9b1ab0e2c5c423a$export$4899a95d70ec5056);
$parcel$export(module.exports, "strong", () => $d9b1ab0e2c5c423a$export$59ae2c325a998f89);
$parcel$export(module.exports, "subsup", () => $d9b1ab0e2c5c423a$export$b3401ee80eb31041);
$parcel$export(module.exports, "textColor", () => $d9b1ab0e2c5c423a$export$32f78bffcd82ff28);
$parcel$export(module.exports, "typeAheadQuery", () => $d9b1ab0e2c5c423a$export$20af3dabbb5538df);
$parcel$export(module.exports, "underline", () => $d9b1ab0e2c5c423a$export$425327af25286e5e);
$parcel$export(module.exports, "unsupportedMark", () => $d9b1ab0e2c5c423a$export$30d78d5eb6719bb8);
$parcel$export(module.exports, "unsupportedNodeAttribute", () => $d9b1ab0e2c5c423a$export$a316dc07ff5182a2);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:pm:full" to regenerate this file.
 */ 
var $9mSQX = parcelRequire("9mSQX");
const $d9b1ab0e2c5c423a$export$8e53000a4ec837 = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        align: {}
    },
    excludes: 'alignment indentation',
    group: 'alignment'
});
const $d9b1ab0e2c5c423a$export$8512c9afa7b24c3b = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        id: {
            default: ''
        },
        annotationType: {
            default: 'inlineComment'
        }
    },
    inclusive: true,
    excludes: '',
    group: 'annotation'
});
const $d9b1ab0e2c5c423a$export$8c5a050822fd698c = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    excludes: 'color',
    group: 'color'
});
const $d9b1ab0e2c5c423a$export$1edee58a52776cd9 = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        size: {},
        color: {}
    },
    inclusive: false
});
const $d9b1ab0e2c5c423a$export$89015c65f1c75e3f = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        mode: {
            default: 'wide'
        }
    },
    inclusive: false,
    spanning: false
});
const $d9b1ab0e2c5c423a$export$6565f9f03506010b = (0, $9mSQX.createPMMarkSpecFactory)({
    inclusive: true,
    excludes: 'fontStyle link searchQuery color'
});
const $d9b1ab0e2c5c423a$export$f3b72f8fc4684ecd = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        reference: {
            default: ''
        }
    },
    inclusive: false,
    excludes: ''
});
const $d9b1ab0e2c5c423a$export$3024f02c495408d6 = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        sources: {
            default: []
        }
    }
});
const $d9b1ab0e2c5c423a$export$c63c6f932822f543 = (0, $9mSQX.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $d9b1ab0e2c5c423a$export$f00aeb236b6f05af = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        localId: {
            default: ''
        },
        name: {
            default: null
        }
    },
    inclusive: false,
    excludes: ''
});
const $d9b1ab0e2c5c423a$export$480c699bd4ec0d86 = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        level: {}
    },
    excludes: 'indentation alignment',
    group: 'indentation'
});
const $d9b1ab0e2c5c423a$export$9c30223ca0a664fb = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        href: {},
        __confluenceMetadata: {
            default: null
        }
    },
    inclusive: false,
    excludes: 'link',
    group: 'link'
});
const $d9b1ab0e2c5c423a$export$4899a95d70ec5056 = (0, $9mSQX.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $d9b1ab0e2c5c423a$export$59ae2c325a998f89 = (0, $9mSQX.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $d9b1ab0e2c5c423a$export$b3401ee80eb31041 = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        type: {
            default: 'sub'
        }
    },
    inclusive: true,
    group: 'fontStyle'
});
const $d9b1ab0e2c5c423a$export$32f78bffcd82ff28 = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    group: 'color'
});
const $d9b1ab0e2c5c423a$export$20af3dabbb5538df = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        trigger: {
            default: ''
        }
    },
    inclusive: true,
    group: 'searchQuery'
});
const $d9b1ab0e2c5c423a$export$425327af25286e5e = (0, $9mSQX.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $d9b1ab0e2c5c423a$export$30d78d5eb6719bb8 = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        originalValue: {}
    },
    excludes: ''
});
const $d9b1ab0e2c5c423a$export$a316dc07ff5182a2 = (0, $9mSQX.createPMMarkSpecFactory)({
    attrs: {
        unsupported: {},
        type: {}
    }
});

});


parcelRegister("ht6w1", function(module, exports) {

$parcel$export(module.exports, "AnnotationTypes", () => $cb7a32ece9a7eb7b$export$94aa2fc69ad33d19);
$parcel$export(module.exports, "AnnotationMarkStates", () => $cb7a32ece9a7eb7b$export$4bab14797673da9f);
$parcel$export(module.exports, "buildDataAttributes", () => $cb7a32ece9a7eb7b$export$93a98caa8bc6cb07);
$parcel$export(module.exports, "annotation", () => $cb7a32ece9a7eb7b$export$8512c9afa7b24c3b);

var $iGMmR = parcelRequire("iGMmR");
let $cb7a32ece9a7eb7b$export$94aa2fc69ad33d19 = /*#__PURE__*/ function(AnnotationTypes) {
    AnnotationTypes["INLINE_COMMENT"] = "inlineComment";
    return AnnotationTypes;
}({});
let $cb7a32ece9a7eb7b$export$4bab14797673da9f = /*#__PURE__*/ function(AnnotationMarkStates) {
    AnnotationMarkStates["RESOLVED"] = "resolved";
    AnnotationMarkStates["ACTIVE"] = "active";
    return AnnotationMarkStates;
}({});
function $cb7a32ece9a7eb7b$export$93a98caa8bc6cb07({ id: id, annotationType: annotationType, state: state }) {
    const data = {
        'data-mark-type': 'annotation',
        'data-mark-annotation-type': annotationType,
        'data-id': id
    };
    if (state) return {
        ...data,
        'data-mark-annotation-state': state
    };
    return data;
}
const $cb7a32ece9a7eb7b$export$8512c9afa7b24c3b = (0, $iGMmR.annotation)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="annotation"]',
            mark: 'annotation',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const attrs = {
                    id: dom.getAttribute('data-id'),
                    annotationType: dom.getAttribute('data-mark-annotation-type')
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        /*
      Data attributes on the DOM node are a temporary means of
      incrementally switching over to the Annotation mark. Once renderer
      provides native support for inline comments the data attributes on the
      DOM nodes will be removed.
    */ return [
            'span',
            {
                // Prettier will remove the quotes around class. This would cause some browsers
                // to not add this attribute properly, as its a reserved word.
                // prettier-ignore
                'class': 'fabric-editor-annotation',
                ...$cb7a32ece9a7eb7b$export$93a98caa8bc6cb07({
                    id: node.attrs.id,
                    annotationType: node.attrs.annotationType
                })
            },
            0
        ];
    }
});

});

parcelRegister("wOKi6", function(module, exports) {

$parcel$export(module.exports, "backgroundColor", () => $062a5a4c71a35221$export$8c5a050822fd698c);

var $iGMmR = parcelRequire("iGMmR");

var $a3bbC = parcelRequire("a3bbC");

var $jR93G = parcelRequire("jR93G");

var $6USfM = parcelRequire("6USfM");

var $as9OS = parcelRequire("as9OS");
/**
 * @name backgroundColor_mark
 */ const $062a5a4c71a35221$var$colorArrayPalette = [
    [
        (0, $jR93G.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $jR93G.T200),
        'Teal'
    ],
    // token: color.background.accent.teal.subtler
    [
        (0, $jR93G.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $jR93G.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $jR93G.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $jR93G.P200),
        'Purple'
    ] // token: color.background.accent.purple.subtler
];
const $062a5a4c71a35221$export$14ec3f21a268e497 = new Map();
$062a5a4c71a35221$var$colorArrayPalette.forEach(([color, label])=>$062a5a4c71a35221$export$14ec3f21a268e497.set(color.toLowerCase(), label));
const $062a5a4c71a35221$export$8c5a050822fd698c = (0, $iGMmR.backgroundColor)({
    parseDOM: [
        {
            style: 'background-color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $jR93G.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $062a5a4c71a35221$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This is used to support the work-around that converts the hex color to
        // a design system token to enable light / dark mode (through a CSS variable --custom-palette-color)
        {
            tag: '.fabric-background-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.backgroundCustomColor;
                return hexColor && $062a5a4c71a35221$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        /**
     * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * separate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $a3bbC.hexToEditorTextBackgroundPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ((0, $6USfM.getGlobalTheme)().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $as9OS.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-background-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-background-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-background-custom-color']: mark.attrs.color
            }
        ];
    }
});

});
parcelRegister("a3bbC", function(module, exports) {

$parcel$export(module.exports, "hexToEditorBorderPaletteColor", () => $7512dc9a41818c00$export$bad3c41dd33cb4bc);
$parcel$export(module.exports, "hexToEditorTextPaletteColor", () => $7512dc9a41818c00$export$9c2f408d391feb93);
$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", () => $7512dc9a41818c00$export$8b58ff1b36bb75e0);
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", () => $7512dc9a41818c00$export$a270511a0e7fd61a);
/**
 * This takes an adf hex color and returns a matching border palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToEditorBorderPaletteColor('#091E4224');
 * //     ^? const cssValue: string
 * <div style={{borderColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $7512dc9a41818c00$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return $7512dc9a41818c00$export$aa000893c5e2b9c2[hexColor.toUpperCase()];
}
const $7512dc9a41818c00$export$aa000893c5e2b9c2 = {
    /** gray - subtle */ '#091E4224': 'var(--ds-border, #091E4224)',
    /** gray */ '#758195': 'var(--ds-border-bold, #758195)',
    /** gray - bold */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $7512dc9a41818c00$export$9c2f408d391feb93(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return $7512dc9a41818c00$export$57fa5089caad992[hexColor.toUpperCase()];
}
const $7512dc9a41818c00$export$57fa5089caad992 = {
    /** blue - light */ '#B3D4FF': 'var(--ds-background-accent-blue-subtler, #B3D4FF)',
    /** blue - medium */ '#4C9AFF': 'var(--ds-icon-accent-blue, #4C9AFF)',
    /** blue - strong */ '#0747A6': 'var(--ds-text-accent-blue, #0747A6)',
    /** teal - light */ '#B3F5FF': 'var(--ds-background-accent-teal-subtler, #B3F5FF)',
    /** teal - medium */ '#00B8D9': 'var(--ds-icon-accent-teal, #00B8D9)',
    /** teal - strong */ '#008DA6': 'var(--ds-text-accent-teal, #008DA6)',
    /** green - light */ '#ABF5D1': 'var(--ds-background-accent-green-subtler, #ABF5D1)',
    /** green - medium */ '#36B37E': 'var(--ds-icon-accent-green, #36B37E)',
    /** green - strong */ '#006644': 'var(--ds-text-accent-green, #006644)',
    /** yellowOrange - light */ '#FFF0B3': 'var(--ds-background-accent-yellow-subtler, #FFF0B3)',
    /** yellowOrange - medium */ '#FFC400': 'var(--ds-background-accent-orange-subtle, #FFC400)',
    /** yellowOrange - strong */ '#FF991F': 'var(--ds-icon-accent-orange, #FF991F)',
    /** red - light */ '#FFBDAD': 'var(--ds-background-accent-red-subtler, #FFBDAD)',
    /** red - medium */ '#FF5630': 'var(--ds-icon-accent-red, #FF5630)',
    /** red - strong */ '#BF2600': 'var(--ds-text-accent-red, #BF2600)',
    /** purple - light */ '#EAE6FF': 'var(--ds-background-accent-purple-subtler, #EAE6FF)',
    /** purple - medium */ '#6554C0': 'var(--ds-icon-accent-purple, #6554C0)',
    /** purple - strong */ '#403294': 'var(--ds-text-accent-purple, #403294)',
    /** whiteGray - light */ '#FFFFFF': 'var(--ds-text-inverse, #FFFFFF)',
    /** whiteGray - medium */ '#97A0AF': 'var(--ds-icon-accent-gray, #97A0AF)',
    /** whiteGray - strong */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $7512dc9a41818c00$export$8b58ff1b36bb75e0(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    return $7512dc9a41818c00$export$12a518ff137dd389[hexColor.toUpperCase()];
}
const $7512dc9a41818c00$export$12a518ff137dd389 = {
    /** Gray - light */ '#DCDFE4': 'var(--ds-background-accent-gray-subtler, #DCDFE4)',
    /** Teal - light */ '#C6EDFB': 'var(--ds-background-accent-teal-subtler, #C6EDFB)',
    /** Lime - light */ '#D3F1A7': 'var(--ds-background-accent-lime-subtler, #D3F1A7)',
    /** Orange - light */ '#FEDEC8': 'var(--ds-background-accent-orange-subtler, #FEDEC8)',
    /** Magenta - light */ '#FDD0EC': 'var(--ds-background-accent-magenta-subtler, #FDD0EC)',
    /** Purple - light */ '#DFD8FD': 'var(--ds-background-accent-purple-subtler, #DFD8FD)'
};
function $7512dc9a41818c00$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    const tokenData = $7512dc9a41818c00$export$2462741d70e6a62f[hexColor.toUpperCase()];
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
const $7512dc9a41818c00$export$2462741d70e6a62f = {
    /** blue - light */ '#DEEBFF': {
        getValue: ()=>'#DEEBFF',
        token: 'var(--ds-background-accent-blue-subtlest, #DEEBFF)'
    },
    /** blue - medium */ '#B3D4FF': {
        getValue: ()=>'#B3D4FF',
        token: 'var(--ds-background-accent-blue-subtler, #B3D4FF)'
    },
    /** blue - strong */ '#4C9AFF': {
        getValue: ()=>'#4C9AFF',
        token: 'var(--ds-background-accent-blue-subtle, #4C9AFF)'
    },
    /** teal - light */ '#E6FCFF': {
        getValue: ()=>'#E6FCFF',
        token: 'var(--ds-background-accent-teal-subtlest, #E6FCFF)'
    },
    /** teal - medium */ '#B3F5FF': {
        getValue: ()=>'#B3F5FF',
        token: 'var(--ds-background-accent-teal-subtler, #B3F5FF)'
    },
    /** teal - strong */ '#79E2F2': {
        getValue: ()=>'#79E2F2',
        token: 'var(--ds-background-accent-teal-subtle, #79E2F2)'
    },
    /** green - light */ '#E3FCEF': {
        getValue: ()=>'#E3FCEF',
        token: 'var(--ds-background-accent-green-subtlest, #E3FCEF)'
    },
    /** green - medium */ '#ABF5D1': {
        getValue: ()=>'#ABF5D1',
        token: 'var(--ds-background-accent-green-subtler, #ABF5D1)'
    },
    /** green - strong */ '#57D9A3': {
        getValue: ()=>'#57D9A3',
        token: 'var(--ds-background-accent-green-subtle, #57D9A3)'
    },
    /** yellowOrange - light */ '#FFFAE6': {
        getValue: ()=>'#FFFAE6',
        token: 'var(--ds-background-accent-yellow-subtlest, #FFFAE6)'
    },
    /** yellowOrange - medium */ '#FFF0B3': {
        getValue: ()=>'#FFF0B3',
        token: 'var(--ds-background-accent-yellow-subtler, #FFF0B3)'
    },
    /** yellowOrange - strong */ '#FFC400': {
        getValue: ()=>'#FFC400',
        token: 'var(--ds-background-accent-orange-subtle, #FFC400)'
    },
    /** red - light */ '#FFEBE6': {
        getValue: ()=>'#FFEBE6',
        token: 'var(--ds-background-accent-red-subtlest, #FFEBE6)'
    },
    /** red - medium */ '#FFBDAD': {
        getValue: ()=>'#FFBDAD',
        token: 'var(--ds-background-accent-red-subtler, #FFBDAD)'
    },
    /** red - strong */ '#FF8F73': {
        getValue: ()=>'#FF8F73',
        token: 'var(--ds-background-accent-red-subtle, #FF8F73)'
    },
    /** purple - light */ '#EAE6FF': {
        getValue: ()=>'#EAE6FF',
        token: 'var(--ds-background-accent-purple-subtlest, #EAE6FF)'
    },
    /** purple - medium */ '#C0B6F2': {
        getValue: ()=>'#C0B6F2',
        token: 'var(--ds-background-accent-purple-subtler, #C0B6F2)'
    },
    /** purple - strong */ '#998DD9': {
        getValue: ()=>'#998DD9',
        token: 'var(--ds-background-accent-purple-subtle, #998DD9)'
    },
    /** whiteGray - light */ '#FFFFFF': {
        getValue: ()=>'#FFFFFF',
        token: 'var(--ds-surface, #FFFFFF)'
    },
    /** whiteGray - medium */ '#F4F5F7': {
        getValue: ()=>'#F4F5F7',
        token: 'var(--ds-background-accent-gray-subtlest, #F4F5F7)'
    },
    /** whiteGray - strong */ '#B3BAC5': {
        getValue: ()=>'#B3BAC5',
        token: 'var(--ds-background-accent-gray-subtle, #B3BAC5)'
    }
};

});

parcelRegister("jR93G", function(module, exports) {

$parcel$export(module.exports, "R50", () => $e749fe592a330097$export$4b84fd0e2c617bd);
$parcel$export(module.exports, "R75", () => $e749fe592a330097$export$b34b069eff244586);
$parcel$export(module.exports, "R100", () => $e749fe592a330097$export$be802dd0d8b57f35);
$parcel$export(module.exports, "R300", () => $e749fe592a330097$export$4a7404f376229999);
$parcel$export(module.exports, "R400", () => $e749fe592a330097$export$2010d0fb4295b346);
$parcel$export(module.exports, "R500", () => $e749fe592a330097$export$2837b5a1a71d5c02);
$parcel$export(module.exports, "Y50", () => $e749fe592a330097$export$8d9596b529bbb9cf);
$parcel$export(module.exports, "Y75", () => $e749fe592a330097$export$41060a744ab0b7ae);
$parcel$export(module.exports, "Y200", () => $e749fe592a330097$export$5aae31392d72caaa);
$parcel$export(module.exports, "Y400", () => $e749fe592a330097$export$59619663aa6500fb);
$parcel$export(module.exports, "G50", () => $e749fe592a330097$export$8a6341c32b6a3ee6);
$parcel$export(module.exports, "G75", () => $e749fe592a330097$export$69a3bf21b9686c2b);
$parcel$export(module.exports, "G200", () => $e749fe592a330097$export$747d86715d4175de);
$parcel$export(module.exports, "G300", () => $e749fe592a330097$export$940e1f69e873f202);
$parcel$export(module.exports, "G400", () => $e749fe592a330097$export$a49394138f7b8e85);
$parcel$export(module.exports, "G500", () => $e749fe592a330097$export$6fa04827ac68a4fb);
$parcel$export(module.exports, "B50", () => $e749fe592a330097$export$226de0355ed012f8);
$parcel$export(module.exports, "B75", () => $e749fe592a330097$export$8c13c2ee36917869);
$parcel$export(module.exports, "B100", () => $e749fe592a330097$export$ecfc1dff386a3e7a);
$parcel$export(module.exports, "B400", () => $e749fe592a330097$export$b3de0ae08da2ce64);
$parcel$export(module.exports, "B500", () => $e749fe592a330097$export$a6ee3d71bc067634);
$parcel$export(module.exports, "L200", () => $e749fe592a330097$export$f72948ef771f6f15);
$parcel$export(module.exports, "N0", () => $e749fe592a330097$export$29a4f05edc054374);
$parcel$export(module.exports, "N20", () => $e749fe592a330097$export$9fdfb749e33cdf97);
$parcel$export(module.exports, "N30", () => $e749fe592a330097$export$3e51e8f1440314ba);
$parcel$export(module.exports, "N40", () => $e749fe592a330097$export$1ce2d1575d444ceb);
$parcel$export(module.exports, "N50", () => $e749fe592a330097$export$8754fc7e6d8b3000);
$parcel$export(module.exports, "N60", () => $e749fe592a330097$export$c2e91cbeada39b8b);
$parcel$export(module.exports, "N80", () => $e749fe592a330097$export$eaa8c8a70ac22806);
$parcel$export(module.exports, "N200", () => $e749fe592a330097$export$f563ee71e9ee74cd);
$parcel$export(module.exports, "N300", () => $e749fe592a330097$export$e2ef2124cf4024b1);
$parcel$export(module.exports, "Neutral300", () => $e749fe592a330097$export$1ae1cebe22dcedb4);
$parcel$export(module.exports, "N300A", () => $e749fe592a330097$export$13609db0e6812ab8);
$parcel$export(module.exports, "N500", () => $e749fe592a330097$export$c39c0fe0f26207ae);
$parcel$export(module.exports, "N600", () => $e749fe592a330097$export$7090862dc3038a9f);
$parcel$export(module.exports, "N800", () => $e749fe592a330097$export$7d61b15e0da132af);
$parcel$export(module.exports, "N1000", () => $e749fe592a330097$export$f78789c8b01753cd);
$parcel$export(module.exports, "M200", () => $e749fe592a330097$export$a19f0c33186f7767);
$parcel$export(module.exports, "O200", () => $e749fe592a330097$export$51716a84e62e022c);
$parcel$export(module.exports, "P50", () => $e749fe592a330097$export$363e4475840015bb);
$parcel$export(module.exports, "P75", () => $e749fe592a330097$export$4b0a4417ed59760f);
$parcel$export(module.exports, "P100", () => $e749fe592a330097$export$6011520a64d9a187);
$parcel$export(module.exports, "P200", () => $e749fe592a330097$export$a7175d4e9206bc80);
$parcel$export(module.exports, "P300", () => $e749fe592a330097$export$b48405b95304b5a1);
$parcel$export(module.exports, "P500", () => $e749fe592a330097$export$147899de772240ec);
$parcel$export(module.exports, "T50", () => $e749fe592a330097$export$2cf711fe14c66f06);
$parcel$export(module.exports, "T75", () => $e749fe592a330097$export$7a8f4d33f6f9772c);
$parcel$export(module.exports, "T100", () => $e749fe592a330097$export$776c9c497ef08533);
$parcel$export(module.exports, "T200", () => $e749fe592a330097$export$69cb3ca10c1e330e);
$parcel$export(module.exports, "T300", () => $e749fe592a330097$export$9dc1ef0f3f48059b);
$parcel$export(module.exports, "T500", () => $e749fe592a330097$export$6036577f95c3877e);
$parcel$export(module.exports, "normalizeHexColor", () => $e749fe592a330097$export$b61655071712e690);
$parcel$export(module.exports, "isHex", () => $e749fe592a330097$export$8a9b6341a7c96bc);
$parcel$export(module.exports, "isRgb", () => $e749fe592a330097$export$e698776ec826343);
$parcel$export(module.exports, "rgbToHex", () => $e749fe592a330097$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgb", () => $e749fe592a330097$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToRgba", () => $e749fe592a330097$export$9665a07d9187b414);

var $dDX7B = parcelRequire("dDX7B");
const $e749fe592a330097$export$4b84fd0e2c617bd = '#FFEBE6';
const $e749fe592a330097$export$b34b069eff244586 = '#FFBDAD';
const $e749fe592a330097$export$be802dd0d8b57f35 = '#FF8F73';
const $e749fe592a330097$export$4a7404f376229999 = '#FF5630';
const $e749fe592a330097$export$2010d0fb4295b346 = '#DE350B';
const $e749fe592a330097$export$2837b5a1a71d5c02 = '#BF2600';
const $e749fe592a330097$export$8d9596b529bbb9cf = '#FFFAE6';
const $e749fe592a330097$export$41060a744ab0b7ae = '#FFF0B3';
const $e749fe592a330097$export$5aae31392d72caaa = '#FFC400';
const $e749fe592a330097$export$59619663aa6500fb = '#FF991F';
const $e749fe592a330097$export$874739ea9e379ab6 = '#FF8B00';
const $e749fe592a330097$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $e749fe592a330097$export$69a3bf21b9686c2b = '#ABF5D1';
const $e749fe592a330097$export$747d86715d4175de = '#57D9A3';
const $e749fe592a330097$export$940e1f69e873f202 = '#36B37E';
const $e749fe592a330097$export$a49394138f7b8e85 = '#00875A';
const $e749fe592a330097$export$6fa04827ac68a4fb = '#006644';
const $e749fe592a330097$export$226de0355ed012f8 = '#DEEBFF';
const $e749fe592a330097$export$8c13c2ee36917869 = '#B3D4FF';
const $e749fe592a330097$export$ecfc1dff386a3e7a = '#4C9AFF';
const $e749fe592a330097$export$b3de0ae08da2ce64 = '#0052CC';
const $e749fe592a330097$export$a6ee3d71bc067634 = '#0747A6';
const $e749fe592a330097$export$f72948ef771f6f15 = '#D3F1A7';
const $e749fe592a330097$export$29a4f05edc054374 = '#FFFFFF';
const $e749fe592a330097$export$9fdfb749e33cdf97 = '#F4F5F7';
const $e749fe592a330097$export$3e51e8f1440314ba = '#EBECF0';
const $e749fe592a330097$export$1ce2d1575d444ceb = '#DFE1E6';
const $e749fe592a330097$export$8754fc7e6d8b3000 = '#C1C7D0';
const $e749fe592a330097$export$c2e91cbeada39b8b = '#B3BAC5';
const $e749fe592a330097$export$eaa8c8a70ac22806 = '#97A0AF';
const $e749fe592a330097$export$7c87d337fb91a97d = '#8993A4';
const $e749fe592a330097$export$f563ee71e9ee74cd = '#6B778C';
const $e749fe592a330097$export$e2ef2124cf4024b1 = '#5E6C84';
const $e749fe592a330097$export$1ae1cebe22dcedb4 = '#DCDFE4';
const $e749fe592a330097$export$13609db0e6812ab8 = '#091E4224';
const $e749fe592a330097$export$c39c0fe0f26207ae = '#42526E';
const $e749fe592a330097$export$7090862dc3038a9f = '#758195';
const $e749fe592a330097$export$7d61b15e0da132af = '#172B4D';
const $e749fe592a330097$export$f78789c8b01753cd = '#172B4D';
const $e749fe592a330097$export$a19f0c33186f7767 = '#FDD0EC';
const $e749fe592a330097$export$51716a84e62e022c = '#FEDEC8';
const $e749fe592a330097$export$363e4475840015bb = '#EAE6FF';
const $e749fe592a330097$export$4b0a4417ed59760f = '#C0B6F2';
const $e749fe592a330097$export$6011520a64d9a187 = '#998DD9';
const $e749fe592a330097$export$a7175d4e9206bc80 = '#DFD8FD';
const $e749fe592a330097$export$b48405b95304b5a1 = '#6554C0';
const $e749fe592a330097$export$c71e4279dd54a18d = '#5243AA';
const $e749fe592a330097$export$147899de772240ec = '#403294';
const $e749fe592a330097$export$2cf711fe14c66f06 = '#E6FCFF';
const $e749fe592a330097$export$7a8f4d33f6f9772c = '#B3F5FF';
const $e749fe592a330097$export$776c9c497ef08533 = '#79E2F2';
const $e749fe592a330097$export$69cb3ca10c1e330e = '#C6EDFB';
const $e749fe592a330097$export$9dc1ef0f3f48059b = '#00B8D9';
const $e749fe592a330097$export$6036577f95c3877e = '#008DA6';
function $e749fe592a330097$export$b61655071712e690(color, defaultColor) {
    if (!color) return null;
    // Normalize to hex
    color = color.trim().toLowerCase();
    if ($e749fe592a330097$export$8a9b6341a7c96bc(color)) // Normalize 3-hex to 6-hex colours
    {
        if (color.length === 4) color = color.split('').map((c)=>c === '#' ? '#' : `${c}${c}`).join('');
    } else if ($e749fe592a330097$export$e698776ec826343(color)) return $e749fe592a330097$export$34d09c4a771c46ef(color);
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (color === 'default') return null;
        else if ($dDX7B.default && $dDX7B.default[color]) color = $dDX7B.default[color];
        else if ($dDX7B && $dDX7B[color]) color = $dDX7B[color];
        else return null;
    }
    if (color === defaultColor) return null;
    return color;
}
function $e749fe592a330097$export$5a544e13ad4e1fa5(color) {
    if (!$e749fe592a330097$export$8a9b6341a7c96bc(color)) return null;
    let colorBits = color.substring(1).split('');
    if (colorBits.length === 3) colorBits = [
        colorBits[0],
        colorBits[0],
        colorBits[1],
        colorBits[1],
        colorBits[2],
        colorBits[2]
    ];
    const rgb = Number(`0x${colorBits.join('')}`);
    // eslint-disable-next-line no-bitwise
    return `rgb(${rgb >> 16 & 255},${rgb >> 8 & 255},${rgb & 255})`;
}
function $e749fe592a330097$export$9665a07d9187b414(rawColor, alpha) {
    const color = $e749fe592a330097$export$b61655071712e690(rawColor);
    if (!color) return null;
    const hex2rgb = (color)=>color.match(/[a-z0-9]{2}/gi).map((hex)=>parseInt(hex, 16));
    return `rgba(${hex2rgb(color).concat(alpha).join(',')})`;
}
function $e749fe592a330097$export$34d09c4a771c46ef(value) {
    const matches = value.match(/(0?\.?\d{1,3})%?\b/g);
    if (matches && matches.length >= 3) {
        const [red, green, blue] = matches.map(Number);
        return '#' + (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1) // eslint-disable-line no-bitwise
        ;
    }
    return null;
}
function $e749fe592a330097$export$e698776ec826343(color) {
    return /rgba?\(/.test(color);
}
function $e749fe592a330097$export$8a9b6341a7c96bc(color) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(color);
}

});
parcelRegister("dDX7B", function(module, exports) {
module.exports = JSON.parse("{\"aliceblue\":\"#f0f8ff\",\"antiquewhite\":\"#faebd7\",\"aqua\":\"#00ffff\",\"aquamarine\":\"#7fffd4\",\"azure\":\"#f0ffff\",\"beige\":\"#f5f5dc\",\"bisque\":\"#ffe4c4\",\"black\":\"#000000\",\"blanchedalmond\":\"#ffebcd\",\"blue\":\"#0000ff\",\"blueviolet\":\"#8a2be2\",\"brown\":\"#a52a2a\",\"burlywood\":\"#deb887\",\"cadetblue\":\"#5f9ea0\",\"chartreuse\":\"#7fff00\",\"chocolate\":\"#d2691e\",\"coral\":\"#ff7f50\",\"cornflowerblue\":\"#6495ed\",\"cornsilk\":\"#fff8dc\",\"crimson\":\"#dc143c\",\"cyan\":\"#00ffff\",\"darkblue\":\"#00008b\",\"darkcyan\":\"#008b8b\",\"darkgoldenrod\":\"#b8860b\",\"darkgray\":\"#a9a9a9\",\"darkgreen\":\"#006400\",\"darkgrey\":\"#a9a9a9\",\"darkkhaki\":\"#bdb76b\",\"darkmagenta\":\"#8b008b\",\"darkolivegreen\":\"#556b2f\",\"darkorange\":\"#ff8c00\",\"darkorchid\":\"#9932cc\",\"darkred\":\"#8b0000\",\"darksalmon\":\"#e9967a\",\"darkseagreen\":\"#8fbc8f\",\"darkslateblue\":\"#483d8b\",\"darkslategray\":\"#2f4f4f\",\"darkslategrey\":\"#2f4f4f\",\"darkturquoise\":\"#00ced1\",\"darkviolet\":\"#9400d3\",\"deeppink\":\"#ff1493\",\"deepskyblue\":\"#00bfff\",\"dimgray\":\"#696969\",\"dimgrey\":\"#696969\",\"dodgerblue\":\"#1e90ff\",\"firebrick\":\"#b22222\",\"floralwhite\":\"#fffaf0\",\"forestgreen\":\"#228b22\",\"fuchsia\":\"#ff00ff\",\"gainsboro\":\"#dcdcdc\",\"ghostwhite\":\"#f8f8ff\",\"gold\":\"#ffd700\",\"goldenrod\":\"#daa520\",\"gray\":\"#808080\",\"green\":\"#008000\",\"greenyellow\":\"#adff2f\",\"grey\":\"#808080\",\"honeydew\":\"#f0fff0\",\"hotpink\":\"#ff69b4\",\"indianred\":\"#cd5c5c\",\"indigo\":\"#4b0082\",\"ivory\":\"#fffff0\",\"khaki\":\"#f0e68c\",\"lavender\":\"#e6e6fa\",\"lavenderblush\":\"#fff0f5\",\"lawngreen\":\"#7cfc00\",\"lemonchiffon\":\"#fffacd\",\"lightblue\":\"#add8e6\",\"lightcoral\":\"#f08080\",\"lightcyan\":\"#e0ffff\",\"lightgoldenrodyellow\":\"#fafad2\",\"lightgray\":\"#d3d3d3\",\"lightgreen\":\"#90ee90\",\"lightgrey\":\"#d3d3d3\",\"lightpink\":\"#ffb6c1\",\"lightsalmon\":\"#ffa07a\",\"lightseagreen\":\"#20b2aa\",\"lightskyblue\":\"#87cefa\",\"lightslategray\":\"#778899\",\"lightslategrey\":\"#778899\",\"lightsteelblue\":\"#b0c4de\",\"lightyellow\":\"#ffffe0\",\"lime\":\"#00ff00\",\"limegreen\":\"#32cd32\",\"linen\":\"#faf0e6\",\"magenta\":\"#ff00ff\",\"maroon\":\"#800000\",\"mediumaquamarine\":\"#66cdaa\",\"mediumblue\":\"#0000cd\",\"mediumorchid\":\"#ba55d3\",\"mediumpurple\":\"#9370db\",\"mediumseagreen\":\"#3cb371\",\"mediumslateblue\":\"#7b68ee\",\"mediumspringgreen\":\"#00fa9a\",\"mediumturquoise\":\"#48d1cc\",\"mediumvioletred\":\"#c71585\",\"midnightblue\":\"#191970\",\"mintcream\":\"#f5fffa\",\"mistyrose\":\"#ffe4e1\",\"moccasin\":\"#ffe4b5\",\"navajowhite\":\"#ffdead\",\"navy\":\"#000080\",\"oldlace\":\"#fdf5e6\",\"olive\":\"#808000\",\"olivedrab\":\"#6b8e23\",\"orange\":\"#ffa500\",\"orangered\":\"#ff4500\",\"orchid\":\"#da70d6\",\"palegoldenrod\":\"#eee8aa\",\"palegreen\":\"#98fb98\",\"paleturquoise\":\"#afeeee\",\"palevioletred\":\"#db7093\",\"papayawhip\":\"#ffefd5\",\"peachpuff\":\"#ffdab9\",\"peru\":\"#cd853f\",\"pink\":\"#ffc0cb\",\"plum\":\"#dda0dd\",\"powderblue\":\"#b0e0e6\",\"purple\":\"#800080\",\"rebeccapurple\":\"#663399\",\"red\":\"#ff0000\",\"rosybrown\":\"#bc8f8f\",\"royalblue\":\"#4169e1\",\"saddlebrown\":\"#8b4513\",\"salmon\":\"#fa8072\",\"sandybrown\":\"#f4a460\",\"seagreen\":\"#2e8b57\",\"seashell\":\"#fff5ee\",\"sienna\":\"#a0522d\",\"silver\":\"#c0c0c0\",\"skyblue\":\"#87ceeb\",\"slateblue\":\"#6a5acd\",\"slategray\":\"#708090\",\"slategrey\":\"#708090\",\"snow\":\"#fffafa\",\"springgreen\":\"#00ff7f\",\"steelblue\":\"#4682b4\",\"tan\":\"#d2b48c\",\"teal\":\"#008080\",\"thistle\":\"#d8bfd8\",\"tomato\":\"#ff6347\",\"turquoise\":\"#40e0d0\",\"violet\":\"#ee82ee\",\"wheat\":\"#f5deb3\",\"white\":\"#ffffff\",\"whitesmoke\":\"#f5f5f5\",\"yellow\":\"#ffff00\",\"yellowgreen\":\"#9acd32\"}");

});


parcelRegister("6USfM", function(module, exports) {

$parcel$export(module.exports, "colorPalette", () => $50920eab1d33a737$export$569885e57444f84a);
$parcel$export(module.exports, "getGlobalTheme", () => $50920eab1d33a737$export$813ecdf77207a053);
$parcel$export(module.exports, "textColor", () => $50920eab1d33a737$export$32f78bffcd82ff28);

var $iGMmR = parcelRequire("iGMmR");

var $a3bbC = parcelRequire("a3bbC");

var $jR93G = parcelRequire("jR93G");

var $as9OS = parcelRequire("as9OS");
/**
 * @name textColor_mark
 */ // used for extended palette in text color picker
const $50920eab1d33a737$var$colorArrayPalette = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $jR93G.B500),
        'Dark blue'
    ],
    // Chore coat
    [
        (0, $jR93G.T500),
        'Dark teal'
    ],
    // Shabby chic
    [
        (0, $jR93G.G500),
        'Dark green'
    ],
    // Keen green
    [
        (0, $jR93G.Y400),
        'Orange'
    ],
    // Cheezy blasters
    [
        (0, $jR93G.R500),
        'Dark red'
    ],
    // Dragon's blood
    [
        (0, $jR93G.P500),
        'Dark purple'
    ],
    // Prince
    // row 2
    [
        (0, $jR93G.N80),
        'Light gray'
    ],
    // Spooky ghost
    [
        (0, $jR93G.B100),
        'Blue'
    ],
    // Arvo breeze
    [
        (0, $jR93G.T300),
        'Teal'
    ],
    // Tamarama
    [
        (0, $jR93G.G300),
        'Green'
    ],
    // Fine pine
    [
        (0, $jR93G.Y200),
        'Yellow'
    ],
    // Pub mix
    [
        (0, $jR93G.R300),
        'Red'
    ],
    // Poppy surprise
    [
        (0, $jR93G.P300),
        'Purple'
    ],
    // Da' juice
    // row 3
    [
        (0, $jR93G.N0),
        'White'
    ],
    [
        (0, $jR93G.B75),
        'Light blue'
    ],
    // Schwag
    [
        (0, $jR93G.T75),
        'Light teal'
    ],
    // Arctic chill
    [
        (0, $jR93G.G75),
        'Light green'
    ],
    // Mintie
    [
        (0, $jR93G.Y75),
        'Light yellow'
    ],
    // Dandelion whisper
    [
        (0, $jR93G.R75),
        'Light red'
    ],
    // Bondi sunburn
    [
        (0, $jR93G.P50),
        'Light purple'
    ] // Lavender secret
];
const $50920eab1d33a737$export$569885e57444f84a = new Map();
const $50920eab1d33a737$export$81e5ed9e84fe2e28 = $50920eab1d33a737$export$569885e57444f84a;
$50920eab1d33a737$var$colorArrayPalette.forEach(([color, label])=>$50920eab1d33a737$export$569885e57444f84a.set(color.toLowerCase(), label));
// these are for test only
let $50920eab1d33a737$var$testGlobalTheme;
const $50920eab1d33a737$export$fd7e0dd2b74807f7 = (theme)=>{
    $50920eab1d33a737$var$testGlobalTheme = theme;
};
const $50920eab1d33a737$export$813ecdf77207a053 = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($50920eab1d33a737$var$testGlobalTheme) return {
        colorMode: $50920eab1d33a737$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
const $50920eab1d33a737$export$32f78bffcd82ff28 = (0, $iGMmR.textColor)({
    parseDOM: [
        {
            style: 'color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $jR93G.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $50920eab1d33a737$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This was initially introduced to ensure text-color marks were not lost
        // when text-color was used inside a link, and is now also used to support
        // where the hex color stored in ADF is used as an ID for a design system
        // token (and based on theme mode -- the presented color will change).
        {
            tag: '.fabric-text-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.textCustomColor;
                return hexColor && $50920eab1d33a737$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        /**
     * The Editor persists custom text colors when content has been migrated from the old editor, or created via
     * apis.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $a3bbC.hexToEditorTextPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ($50920eab1d33a737$export$813ecdf77207a053().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $as9OS.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-text-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-text-custom-color']: mark.attrs.color
            }
        ];
    }
});

});
parcelRegister("as9OS", function(module, exports) {

$parcel$export(module.exports, "getDarkModeLCHColor", () => $79c422e1aade6ff8$export$a5065c3b8aacaf99);
// https://en.wikipedia.org/wiki/HCL_color_space
// https://en.wikipedia.org/wiki/CIE_1931_color_space#CIE_xy_chromaticity_diagram_and_the_CIE_xyY_color_space
// https://en.wikipedia.org/wiki/CIELAB_color_space
const $79c422e1aade6ff8$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
const $79c422e1aade6ff8$var$expandShorthandHex = (input)=>input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b)=>r + r + g + g + b + b);
const $79c422e1aade6ff8$var$rgbFromHex = (input)=>{
    const fullHex = $79c422e1aade6ff8$var$expandShorthandHex(input);
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
const $79c422e1aade6ff8$var$rgbToHex = ({ r: r, g: g, b: b })=>{
    const convertComponent = (c)=>{
        const cBase16 = c.toString(16);
        return cBase16.length === 1 ? `0${cBase16}` : cBase16;
    };
    return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
};
const $79c422e1aade6ff8$var$rgbToXyz = (rgb)=>{
    const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    const r = convertRgbComponent(rgb.r / 255);
    const g = convertRgbComponent(rgb.g / 255);
    const b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
const $79c422e1aade6ff8$var$xyzToLab = ({ x: x, y: y, z: z })=>({
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    });
const $79c422e1aade6ff8$var$labToLch = ({ l: l, a: a, b: b })=>{
    let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
const $79c422e1aade6ff8$var$lchToLab = ({ l: l, c: c, h: h })=>{
    const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
const $79c422e1aade6ff8$var$labToXyz = ({ l: l, a: a, b: b })=>{
    const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    const y = (l + 16) / 116;
    const x = a / 500 + y;
    const z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
const $79c422e1aade6ff8$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
    const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    return {
        r: $79c422e1aade6ff8$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $79c422e1aade6ff8$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $79c422e1aade6ff8$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
const $79c422e1aade6ff8$var$rgbToLch = (rgb)=>$79c422e1aade6ff8$var$labToLch($79c422e1aade6ff8$var$xyzToLab($79c422e1aade6ff8$var$rgbToXyz(rgb)));
const $79c422e1aade6ff8$var$lchToRgb = (lch)=>$79c422e1aade6ff8$var$xyzToRgb($79c422e1aade6ff8$var$labToXyz($79c422e1aade6ff8$var$lchToLab(lch)));
const $79c422e1aade6ff8$export$313b8a8fcb34c3b8 = (color, newPercent)=>{
    const rgb = $79c422e1aade6ff8$var$rgbFromHex(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    const lch = $79c422e1aade6ff8$var$rgbToLch(rgb);
    lch.l = $79c422e1aade6ff8$var$clamp(newPercent, 0, 100);
    return $79c422e1aade6ff8$var$rgbToHex($79c422e1aade6ff8$var$lchToRgb(lch));
};
const $79c422e1aade6ff8$var$getLightness = (color)=>{
    const rgb = $79c422e1aade6ff8$var$rgbFromHex(color);
    if (rgb === null) return 0;
    const lch = $79c422e1aade6ff8$var$rgbToLch(rgb);
    return lch.l;
};
const $79c422e1aade6ff8$export$a5065c3b8aacaf99 = (currentBackgroundColor)=>{
    const lightness = $79c422e1aade6ff8$var$getLightness(currentBackgroundColor);
    const newLightness = Math.abs(100 - lightness);
    return $79c422e1aade6ff8$export$313b8a8fcb34c3b8(currentBackgroundColor, newLightness).toUpperCase();
};

});



parcelRegister("dx7fV", function(module, exports) {

$parcel$export(module.exports, "borderColorPalette", () => $9da3fc4a55f49543$export$e4e044c989c86ca7);
$parcel$export(module.exports, "border", () => $9da3fc4a55f49543$export$1edee58a52776cd9);

var $iGMmR = parcelRequire("iGMmR");

var $a3bbC = parcelRequire("a3bbC");

var $jR93G = parcelRequire("jR93G");
/**
 * @name border_mark
 * @description This mark adds decoration to an element, and any element decorated with it will also have a border style.
 */ const $9da3fc4a55f49543$var$borderColorArrayPalette = [
    [
        (0, $jR93G.N300A),
        'Subtle gray'
    ],
    [
        (0, $jR93G.N600),
        'Gray'
    ],
    [
        (0, $jR93G.N1000),
        'Bold gray'
    ]
];
const $9da3fc4a55f49543$export$e4e044c989c86ca7 = new Map();
$9da3fc4a55f49543$var$borderColorArrayPalette.forEach(([color, label])=>$9da3fc4a55f49543$export$e4e044c989c86ca7.set(color.toLowerCase(), label));
const $9da3fc4a55f49543$export$1edee58a52776cd9 = (0, $iGMmR.border)({
    parseDOM: [
        {
            tag: '[data-mark-type="border"]',
            getAttrs: (domNode)=>{
                var _dom$getAttribute, _dom$getAttribute2;
                const dom = domNode;
                const color = ((_dom$getAttribute = dom.getAttribute('data-color')) !== null && _dom$getAttribute !== void 0 ? _dom$getAttribute : '').toLowerCase();
                const size = +((_dom$getAttribute2 = dom.getAttribute('data-size')) !== null && _dom$getAttribute2 !== void 0 ? _dom$getAttribute2 : '0');
                return {
                    size: size > 3 ? 3 : size < 1 ? false : size,
                    color: $9da3fc4a55f49543$export$e4e044c989c86ca7.has(color) ? color : false
                };
            }
        }
    ],
    toDOM (mark, isInline) {
        const wrapperStyle = isInline ? 'span' : 'div';
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        const paletteColorValue = (0, $a3bbC.hexToEditorBorderPaletteColor)(mark.attrs.color) || mark.attrs.color;
        return [
            wrapperStyle,
            {
                'data-mark-type': 'border',
                'data-color': mark.attrs.color,
                'data-size': mark.attrs.size,
                style: `--custom-palette-color: ${paletteColorValue}`
            }
        ];
    }
});

});

parcelRegister("5He3U", function(module, exports) {

$parcel$export(module.exports, "breakout", () => $425be04f82df9f96$export$89015c65f1c75e3f);

var $iGMmR = parcelRequire("iGMmR");
const $425be04f82df9f96$var$allowedTypes = [
    'wide',
    'full-width'
];
const $425be04f82df9f96$export$89015c65f1c75e3f = (0, $iGMmR.breakout)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-breakout-mark',
            getAttrs (dom) {
                const mode = dom.getAttribute('data-mode');
                return {
                    mode: $425be04f82df9f96$var$allowedTypes.indexOf(mode || '') === -1 ? 'wide' : mode
                };
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: 'fabric-editor-breakout-mark',
                'data-mode': mark.attrs.mode
            },
            0
        ];
    }
});

});

parcelRegister("4ohT6", function(module, exports) {

$parcel$export(module.exports, "code", () => $33274773c4b5166a$export$6565f9f03506010b);

var $iGMmR = parcelRequire("iGMmR");
const $33274773c4b5166a$export$6565f9f03506010b = (0, $iGMmR.code)({
    parseDOM: [
        {
            tag: 'span.code',
            preserveWhitespace: true
        },
        {
            tag: 'code',
            preserveWhitespace: true
        },
        {
            tag: 'tt',
            preserveWhitespace: true
        },
        {
            tag: 'span',
            preserveWhitespace: true,
            getAttrs: (domNode)=>{
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre') return {};
                if (dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') >= 0) return {};
                return false;
            }
        }
    ],
    toDOM () {
        return [
            'span',
            {
                class: 'code',
                spellcheck: 'false'
            }
        ];
    }
});

});

parcelRegister("de8p2", function(module, exports) {

$parcel$export(module.exports, "confluenceInlineComment", () => $9a1319ce36df48fa$export$f3b72f8fc4684ecd);

var $iGMmR = parcelRequire("iGMmR");
const $9a1319ce36df48fa$export$f3b72f8fc4684ecd = (0, $iGMmR.confluenceInlineComment)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="confluenceInlineComment"]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-mark-type': 'confluenceInlineComment',
                'data-reference': node.attrs.reference
            }
        ];
    }
});

});

parcelRegister("8nj7b", function(module, exports) {

$parcel$export(module.exports, "dataConsumer", () => $618f4c86e0c34ede$export$3024f02c495408d6);
$parcel$export(module.exports, "toJSON", () => $618f4c86e0c34ede$export$54fd2c36b5cc6731);

var $iGMmR = parcelRequire("iGMmR");

var $1pjCh = parcelRequire("1pjCh");
/**
 * This annotation is purely for reference, & does _nothing_ given annotating
 * `minLength` on an array of strings is not supported with our schema+spec
 * generator.
 *
 * We're keeping it to signal that data consumer `sources` shouldn't be empty
 * strings
 *
 * // @minLength 1
 */ /**
 * @name dataConsumer_mark
 * @description This mark is used for metadata surrounding a node consuming data
 * from a given source node
 */ const $618f4c86e0c34ede$var$parseDataConsumer = (maybeValue)=>{
    const sources = (0, $1pjCh.isDOMElement)(maybeValue) && maybeValue.getAttribute('data-sources');
    try {
        return sources ? {
            sources: JSON.parse(sources)
        } : false;
    } catch  {
        return false;
    }
};
const $618f4c86e0c34ede$export$3024f02c495408d6 = (0, $iGMmR.dataConsumer)({
    parseDOM: [
        {
            tag: '[data-mark-type="dataConsumer"]',
            getAttrs: (maybeValue)=>$618f4c86e0c34ede$var$parseDataConsumer(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'dataConsumer',
                'data-sources': JSON.stringify(mark.attrs.sources)
            }
        ];
    }
});
const $618f4c86e0c34ede$export$54fd2c36b5cc6731 = (mark)=>{
    // // Remove intemediary state if we don't have any sources on data consumer
    // if (mark.attrs?.sources?.length < 1) {
    //   return null;
    // }
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).filter((key)=>key === 'sources' && mark.attrs[key].length > 0 && mark.attrs[key] !== null).reduce((acc, key)=>{
            return {
                ...acc,
                [key]: mark.attrs[key]
            };
        }, {})
    };
};

});
parcelRegister("1pjCh", function(module, exports) {

$parcel$export(module.exports, "isDOMElement", () => $106757a7f274372d$export$c296e2d4365c37a5);
const $106757a7f274372d$export$c296e2d4365c37a5 = (maybeNode)=>maybeNode instanceof Node && maybeNode.nodeType === Node.ELEMENT_NODE;

});


parcelRegister("79k1z", function(module, exports) {

$parcel$export(module.exports, "em", () => $5348e8113a21cfa8$export$c63c6f932822f543);

var $iGMmR = parcelRequire("iGMmR");
/**
 * @name em_mark
 */ const $5348e8113a21cfa8$var$emDOM = [
    'em'
];
const $5348e8113a21cfa8$export$c63c6f932822f543 = (0, $iGMmR.em)({
    parseDOM: [
        {
            tag: 'i'
        },
        {
            tag: 'em'
        },
        {
            style: 'font-style=italic'
        }
    ],
    toDOM () {
        return $5348e8113a21cfa8$var$emDOM;
    }
});

});

parcelRegister("9iaXL", function(module, exports) {

$parcel$export(module.exports, "fragment", () => $6c3e4c85b88bb30a$export$f00aeb236b6f05af);
$parcel$export(module.exports, "toJSON", () => $6c3e4c85b88bb30a$export$54fd2c36b5cc6731);

var $iGMmR = parcelRequire("iGMmR");

var $1pjCh = parcelRequire("1pjCh");
/**
 * @name fragment_mark
 * @description Indicates that the elements decorated with this mark belong to a "fragment" entity, which represents a collection of ADF nodes.
 * This entity can be referred to later by its `localId` attribute.
 */ const $6c3e4c85b88bb30a$var$parseFragment = (maybeValue)=>{
    var _maybeValue$getAttrib;
    if (!(0, $1pjCh.isDOMElement)(maybeValue)) return false;
    const name = (_maybeValue$getAttrib = maybeValue.getAttribute('data-name')) !== null && _maybeValue$getAttrib !== void 0 ? _maybeValue$getAttrib : undefined;
    const localId = maybeValue.getAttribute('data-localId');
    if (!localId) return false;
    return {
        localId: localId,
        name: name
    };
};
const $6c3e4c85b88bb30a$export$f00aeb236b6f05af = (0, $iGMmR.fragment)({
    parseDOM: [
        {
            tag: '[data-mark-type="fragment"]',
            getAttrs: (maybeValue)=>$6c3e4c85b88bb30a$var$parseFragment(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'fragment',
                'data-name': mark.attrs.name,
                'data-localId': mark.attrs.localId
            }
        ];
    }
});
const $6c3e4c85b88bb30a$export$54fd2c36b5cc6731 = (mark)=>{
    return {
        type: mark.type.name,
        attrs: {
            localId: mark.attrs.localId,
            ...mark.attrs.name ? {
                name: mark.attrs.name
            } : {}
        }
    };
};

});

parcelRegister("l9pLr", function(module, exports) {

$parcel$export(module.exports, "indentation", () => $f65e6c756517ff64$export$480c699bd4ec0d86);

var $iGMmR = parcelRequire("iGMmR");
const $f65e6c756517ff64$export$480c699bd4ec0d86 = (0, $iGMmR.indentation)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-indentation-mark',
            getAttrs (dom) {
                const level = +(dom.getAttribute('data-level') || '0');
                return {
                    level: level > 6 ? 6 : level < 1 ? false : level
                };
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-indentation-mark',
                'data-level': mark.attrs.level
            },
            0
        ];
    }
});

});

parcelRegister("3SpHb", function(module, exports) {

$parcel$export(module.exports, "link", () => $2d2a58d971c4790c$export$9c30223ca0a664fb);
$parcel$export(module.exports, "toJSON", () => $2d2a58d971c4790c$export$54fd2c36b5cc6731);

var $iGMmR = parcelRequire("iGMmR");

var $4N6cH = parcelRequire("4N6cH");
/**
 * @name link_mark
 */ const $2d2a58d971c4790c$var$getLinkAttrs = (attribute)=>(domNode)=>{
        const dom = domNode;
        const href = dom.getAttribute(attribute) || '';
        const attrs = {
            __confluenceMetadata: dom.hasAttribute('__confluenceMetadata') ? JSON.parse(dom.getAttribute('__confluenceMetadata') || '') : undefined
        };
        if (!(0, $4N6cH.isSafeUrl)(href)) return false;
        if ((0, $4N6cH.isRootRelative)(href)) {
            attrs.href = href;
            return attrs;
        }
        attrs.href = (0, $4N6cH.normalizeUrl)(href);
        return attrs;
    };
const $2d2a58d971c4790c$export$9c30223ca0a664fb = (0, $iGMmR.link)({
    parseDOM: [
        {
            tag: '[data-block-link]',
            getAttrs: $2d2a58d971c4790c$var$getLinkAttrs('data-block-link'),
            contentElement: (node)=>{
                const clone = node.cloneNode(true);
                clone.removeAttribute('data-block-link');
                clone.setAttribute('data-skip-paste', 'true');
                const wrapper = document.createElement('div');
                wrapper.appendChild(clone);
                return wrapper;
            }
        },
        {
            tag: 'a[href]',
            getAttrs: $2d2a58d971c4790c$var$getLinkAttrs('href')
        }
    ],
    toDOM (node, isInline) {
        const attrs = Object.keys(node.attrs).reduce((attrs, key)=>{
            if (key === '__confluenceMetadata') {
                if (node.attrs[key] !== null) attrs[key] = JSON.stringify(node.attrs[key]);
            } else if (key === 'href') attrs[key] = (0, $4N6cH.isSafeUrl)(node.attrs[key]) ? node.attrs[key] : undefined;
            else attrs[key] = node.attrs[key];
            return attrs;
        }, {});
        if (isInline) return [
            'a',
            attrs
        ];
        return [
            'a',
            {
                ...attrs,
                ['data-block-link']: 'true',
                class: 'blockLink'
            },
            0
        ];
    }
});
const $2d2a58d971c4790c$var$OPTIONAL_ATTRS = [
    'title',
    'id',
    'collection',
    'occurrenceKey',
    '__confluenceMetadata'
];
const $2d2a58d971c4790c$export$54fd2c36b5cc6731 = (mark)=>({
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).reduce((attrs, key)=>{
            if ($2d2a58d971c4790c$var$OPTIONAL_ATTRS.indexOf(key) === -1 || mark.attrs[key] !== null) attrs[key] = mark.attrs[key];
            return attrs;
        }, {})
    });

});
parcelRegister("4N6cH", function(module, exports) {

$parcel$export(module.exports, "isSafeUrl", () => $37d08cfa1c7b561a$export$c9f92f5469372e0f);
$parcel$export(module.exports, "linkify", () => $37d08cfa1c7b561a$export$8ccbde94d5c7f8e7);
$parcel$export(module.exports, "linkifyMatch", () => $37d08cfa1c7b561a$export$6f7d7761b97f967);
$parcel$export(module.exports, "getLinkMatch", () => $37d08cfa1c7b561a$export$ce9ae45aed3e4ec);
$parcel$export(module.exports, "normalizeUrl", () => $37d08cfa1c7b561a$export$6535eb414fa2c8b6);
$parcel$export(module.exports, "isRootRelative", () => $37d08cfa1c7b561a$export$23579274a7a24f7b);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $izjsg = parcelRequire("izjsg");
const $37d08cfa1c7b561a$var$whitelistedURLPatterns = [
    /^https?:\/\//im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\//im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:/im,
    /^facetime:/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^sourcetree:/im,
    /^sourcetree:\/\//im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^#/im
];
const $37d08cfa1c7b561a$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url.trim();
    if (urlTrimmed.length === 0) return true;
    return $37d08cfa1c7b561a$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
const $37d08cfa1c7b561a$export$8ccbde94d5c7f8e7 = (0, (/*@__PURE__*/$parcel$interopDefault($izjsg)))();
$37d08cfa1c7b561a$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
$37d08cfa1c7b561a$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
const $37d08cfa1c7b561a$var$urlWithoutSpacesValidator = {
    validate: /[^\s]+/
};
// `tel:` URI spec is https://datatracker.ietf.org/doc/html/rfc3966
// We're not validating the phone number or separators - but if there's a space it definitely isn't a valid `tel:` URI
$37d08cfa1c7b561a$export$8ccbde94d5c7f8e7.add('tel:', $37d08cfa1c7b561a$var$urlWithoutSpacesValidator);
// https://datatracker.ietf.org/doc/html/rfc8089
$37d08cfa1c7b561a$export$8ccbde94d5c7f8e7.add('file:', $37d08cfa1c7b561a$var$urlWithoutSpacesValidator);
$37d08cfa1c7b561a$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
const $37d08cfa1c7b561a$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $37d08cfa1c7b561a$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$37d08cfa1c7b561a$var$tlds.push($37d08cfa1c7b561a$var$tlds2Char);
$37d08cfa1c7b561a$export$8ccbde94d5c7f8e7.tlds($37d08cfa1c7b561a$var$tlds, false);
const $37d08cfa1c7b561a$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $37d08cfa1c7b561a$export$6f7d7761b97f967 = (text)=>{
    if (!$37d08cfa1c7b561a$export$746d02eae03c72e1.test(text)) return [];
    const matches = [];
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($37d08cfa1c7b561a$export$746d02eae03c72e1) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($37d08cfa1c7b561a$export$746d02eae03c72e1);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
function $37d08cfa1c7b561a$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    let match = $37d08cfa1c7b561a$export$6f7d7761b97f967(str);
    if (!match.length) match = $37d08cfa1c7b561a$export$8ccbde94d5c7f8e7.match(str);
    return match && match[0];
}
function $37d08cfa1c7b561a$export$6535eb414fa2c8b6(url) {
    const match = $37d08cfa1c7b561a$export$ce9ae45aed3e4ec(url);
    return match && match.url || '';
}
function $37d08cfa1c7b561a$export$23579274a7a24f7b(url) {
    return url.startsWith('/');
}

});
parcelRegister("izjsg", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $d84a96391edf6631$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $d84a96391edf6631$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $d84a96391edf6631$var$isString(obj) {
    return $d84a96391edf6631$var$_class(obj) === '[object String]';
}
function $d84a96391edf6631$var$isObject(obj) {
    return $d84a96391edf6631$var$_class(obj) === '[object Object]';
}
function $d84a96391edf6631$var$isRegExp(obj) {
    return $d84a96391edf6631$var$_class(obj) === '[object RegExp]';
}
function $d84a96391edf6631$var$isFunction(obj) {
    return $d84a96391edf6631$var$_class(obj) === '[object Function]';
}
function $d84a96391edf6631$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $d84a96391edf6631$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $d84a96391edf6631$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $d84a96391edf6631$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $d84a96391edf6631$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $d84a96391edf6631$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $d84a96391edf6631$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $d84a96391edf6631$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $d84a96391edf6631$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $d84a96391edf6631$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $d84a96391edf6631$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("bUlLc"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($d84a96391edf6631$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($d84a96391edf6631$var$isObject(val)) {
            if ($d84a96391edf6631$var$isRegExp(val.validate)) compiled.validate = $d84a96391edf6631$var$createValidator(val.validate);
            else if ($d84a96391edf6631$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($d84a96391edf6631$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $d84a96391edf6631$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($d84a96391edf6631$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $d84a96391edf6631$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($d84a96391edf6631$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|' + '(' + self.re.host_fuzzy_test.source + ')|' + '@', 'i');
    //
    // Cleanup
    //
    $d84a96391edf6631$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $d84a96391edf6631$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $d84a96391edf6631$var$createMatch(self, shift) {
    var match = new $d84a96391edf6631$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $d84a96391edf6631$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $d84a96391edf6631$var$LinkifyIt)) return new $d84a96391edf6631$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($d84a96391edf6631$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $d84a96391edf6631$var$assign({}, $d84a96391edf6631$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $d84a96391edf6631$var$assign({}, $d84a96391edf6631$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $d84a96391edf6631$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $d84a96391edf6631$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $d84a96391edf6631$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $d84a96391edf6631$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($d84a96391edf6631$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($d84a96391edf6631$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $d84a96391edf6631$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $d84a96391edf6631$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $d84a96391edf6631$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $d84a96391edf6631$var$LinkifyIt;

});
parcelRegister("bUlLc", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("4NOMA")).source;
    re.src_Cc = (parcelRequire("jvFHg")).source;
    re.src_Z = (parcelRequire("8UCq2")).source;
    re.src_P = (parcelRequire("aUAJj")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,3}[a-zA-Z0-9%/]|' + // github has ... in commit range links. Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + '\\,(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    '\\!(?!' + re.src_ZCc + '|[!]).|' + '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    re.src_email_name = '[\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]+';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + // don't allow `--` in domain names, because:
    // - that can conflict with markdown &mdash; / &ndash;
    // - nobody use those anyway
    '(?:' + re.src_pseudo_letter + '(?:-(?!-)|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|\\(|' + re.src_ZCc + ')(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});
parcelRegister("4NOMA", function(module, exports) {
module.exports = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("jvFHg", function(module, exports) {
module.exports = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("8UCq2", function(module, exports) {
module.exports = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;

});

parcelRegister("aUAJj", function(module, exports) {
module.exports = /[!-#%-\*,-/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E49\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});





parcelRegister("4w9F8", function(module, exports) {

$parcel$export(module.exports, "strike", () => $34a1a559eec97f76$export$4899a95d70ec5056);

var $iGMmR = parcelRequire("iGMmR");
const $34a1a559eec97f76$export$4899a95d70ec5056 = (0, $iGMmR.strike)({
    parseDOM: [
        {
            tag: 'strike'
        },
        {
            tag: 's'
        },
        {
            tag: 'del'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'line-through' && null
        }
    ],
    toDOM () {
        return [
            's'
        ];
    }
});

});

parcelRegister("hkdIQ", function(module, exports) {

$parcel$export(module.exports, "strong", () => $c9cef2e2919bbc38$export$59ae2c325a998f89);

var $iGMmR = parcelRequire("iGMmR");
/**
 * @name strong_mark
 */ const $c9cef2e2919bbc38$var$strongDOM = [
    'strong'
];
const $c9cef2e2919bbc38$export$59ae2c325a998f89 = (0, $iGMmR.strong)({
    parseDOM: [
        {
            tag: 'strong'
        },
        // This works around a Google Docs misbehavior where
        // pasted content will be inexplicably wrapped in `<b>`
        // tags with a font-weight normal.
        {
            tag: 'b',
            getAttrs (node) {
                const element = node;
                return element.style.fontWeight !== 'normal' && null;
            }
        },
        {
            tag: 'span',
            getAttrs (node) {
                const element = node;
                const { fontWeight: fontWeight } = element.style;
                return typeof fontWeight === 'string' && (fontWeight === 'bold' || fontWeight === 'bolder' || /^(bold(er)?|[5-9]\d{2,})$/.test(fontWeight)) && null;
            }
        }
    ],
    toDOM () {
        return $c9cef2e2919bbc38$var$strongDOM;
    }
});

});

parcelRegister("gIVi2", function(module, exports) {

$parcel$export(module.exports, "subsup", () => $c2cd32026e6eb3a5$export$b3401ee80eb31041);

var $iGMmR = parcelRequire("iGMmR");
/**
 * @name subsup_mark
 */ function $c2cd32026e6eb3a5$var$getAttrFromVerticalAlign(node) {
    if (node.style.verticalAlign) {
        const type = node.style.verticalAlign.slice(0, 3);
        if (type === 'sub' || type === 'sup') return {
            type: type
        };
    }
    return false;
}
const $c2cd32026e6eb3a5$export$b3401ee80eb31041 = (0, $iGMmR.subsup)({
    parseDOM: [
        {
            tag: 'sub',
            attrs: {
                type: 'sub'
            }
        },
        {
            tag: 'sup',
            attrs: {
                type: 'sup'
            }
        },
        {
            // Special case for pasting from Google Docs
            // Google Docs uses vertical align to denote subscript and super script
            tag: 'span',
            style: 'vertical-align=super',
            getAttrs: (node)=>$c2cd32026e6eb3a5$var$getAttrFromVerticalAlign(node)
        },
        {
            tag: 'span',
            style: 'vertical-align=sub',
            getAttrs: (node)=>$c2cd32026e6eb3a5$var$getAttrFromVerticalAlign(node)
        }
    ],
    toDOM (mark) {
        return [
            mark.attrs.type
        ];
    }
});

});

parcelRegister("2ce3x", function(module, exports) {

$parcel$export(module.exports, "typeAheadQuery", () => $19979afb697512ce$export$20af3dabbb5538df);

var $iGMmR = parcelRequire("iGMmR");

var $jR93G = parcelRequire("jR93G");
const $19979afb697512ce$export$20af3dabbb5538df = (0, $iGMmR.typeAheadQuery)({
    parseDOM: [
        {
            tag: 'span[data-type-ahead-query]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-type-ahead-query': 'true',
                'data-trigger': node.attrs.trigger,
                style: `color: ${(0, $jR93G.B400)}`
            }
        ];
    }
});

});

parcelRegister("7LHzX", function(module, exports) {

$parcel$export(module.exports, "underline", () => $5a7eba10acd79c46$export$425327af25286e5e);

var $iGMmR = parcelRequire("iGMmR");
const $5a7eba10acd79c46$export$425327af25286e5e = (0, $iGMmR.underline)({
    parseDOM: [
        {
            tag: 'u'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'underline' && null
        }
    ],
    toDOM () {
        return [
            'u'
        ];
    }
});

});

parcelRegister("gLNTn", function(module, exports) {

$parcel$export(module.exports, "unsupportedMark", () => $c357bcad799cb7a9$export$30d78d5eb6719bb8);

var $iGMmR = parcelRequire("iGMmR");
const $c357bcad799cb7a9$export$30d78d5eb6719bb8 = (0, $iGMmR.unsupportedMark)({
    toDOM () {
        return [
            'span'
        ];
    }
});

});

parcelRegister("8osWo", function(module, exports) {

$parcel$export(module.exports, "unsupportedNodeAttribute", () => $61c703adc490c2ac$export$a316dc07ff5182a2);

var $iGMmR = parcelRequire("iGMmR");
const $61c703adc490c2ac$export$a316dc07ff5182a2 = (0, $iGMmR.unsupportedNodeAttribute)({
    toDOM () {
        return [
            'span'
        ];
    }
});

});

parcelRegister("heoPx", function(module, exports) {

$parcel$export(module.exports, "blockCard", () => $c8b70143c7895a82$export$c4c2f833baaebdb8);

var $7XZYM = parcelRequire("7XZYM");
/**
 * @name blockCard_node
 */ const $c8b70143c7895a82$var$getCommonAttributesFromDom = (dom)=>{
    const anchor = dom;
    const data = anchor.getAttribute('data-card-data');
    const datasource = anchor.getAttribute('data-datasource');
    return {
        data: data ? JSON.parse(data) : undefined,
        layout: datasource ? dom.getAttribute('data-layout') || undefined : undefined,
        width: Number(dom.getAttribute('data-width')) || undefined,
        datasource: datasource ? JSON.parse(datasource) : undefined
    };
};
const $c8b70143c7895a82$export$c4c2f833baaebdb8 = (0, $7XZYM.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('href') || undefined,
                    ...$c8b70143c7895a82$var$getCommonAttributesFromDom(dom)
                };
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('data-card-url') || undefined,
                    ...$c8b70143c7895a82$var$getCommonAttributesFromDom(dom)
                };
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const { url: url } = node.attrs;
        const { data: data } = node.attrs;
        const { layout: layout, width: width, datasource: datasource } = node.attrs;
        const attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': `${width}`
        };
        return [
            'a',
            attrs,
            (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.url) || ' '
        ];
    }
});

});

parcelRegister("jDF31", function(module, exports) {

$parcel$export(module.exports, "blockquote", () => $e4c18015cb0b91e7$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockquoteWithList", () => $e4c18015cb0b91e7$export$9b4686c4b9672643);

var $7XZYM = parcelRequire("7XZYM");
const $e4c18015cb0b91e7$export$67dc04e652a298ca = (0, $7XZYM.blockquoteLegacy)({
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM () {
        return [
            'blockquote',
            0
        ];
    }
});
const $e4c18015cb0b91e7$export$9b4686c4b9672643 = (0, $7XZYM.blockquote)({
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM () {
        return [
            'blockquote',
            0
        ];
    }
});

});

parcelRegister("eStcf", function(module, exports) {

$parcel$export(module.exports, "bodiedExtension", () => $ad4cc1abe1dded2c$export$27903d543b563e39);

var $eUEbq = parcelRequire("eUEbq");

var $7XZYM = parcelRequire("7XZYM");
const $ad4cc1abe1dded2c$export$27903d543b563e39 = (0, $7XZYM.bodiedExtension)({
    parseDOM: [
        {
            context: 'bodiedExtension//',
            tag: '[data-node-type="bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="bodied-extension"]',
            getAttrs: (domNode)=>(0, $eUEbq.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("568Ob", function(module, exports) {

$parcel$export(module.exports, "bulletListSelector", () => $3b645877cad760fc$export$5f25a39efab3b58b);
$parcel$export(module.exports, "bulletList", () => $3b645877cad760fc$export$a140c94e5ea26bee);

var $7XZYM = parcelRequire("7XZYM");
const $3b645877cad760fc$export$5f25a39efab3b58b = '.ak-ul';
const $3b645877cad760fc$export$a140c94e5ea26bee = (0, $7XZYM.bulletList)({
    parseDOM: [
        {
            tag: 'ul'
        }
    ],
    toDOM () {
        const attrs = {
            class: $3b645877cad760fc$export$5f25a39efab3b58b.substr(1)
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});

});

parcelRegister("d99SJ", function(module, exports) {

$parcel$export(module.exports, "caption", () => $9923c7ec34bc61e9$export$8e3c2dfdc4f0453d);

var $7XZYM = parcelRequire("7XZYM");
const $9923c7ec34bc61e9$export$8e3c2dfdc4f0453d = (0, $7XZYM.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-caption': 'true'
        };
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});

});

parcelRegister("hgVop", function(module, exports) {

$parcel$export(module.exports, "codeBlock", () => $c930734c642b0af7$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "toJSON", () => $c930734c642b0af7$export$54fd2c36b5cc6731);

var $7dkLM = parcelRequire("7dkLM");

var $XHGTv = parcelRequire("XHGTv");

var $7XZYM = parcelRequire("7XZYM");
/**
 * @name codeBlock_node
 */ /**
 * @name codeBlock_with_no_marks_node
 */ /**
 * @name codeBlock_with_marks_node
 */ const $c930734c642b0af7$var$getLanguageFromEditorStyle = (dom)=>{
    return dom.getAttribute('data-language') || undefined;
};
// example of BB style:
// <div class="codehilite language-javascript"><pre><span>hello world</span><span>\n</span></pre></div>
const $c930734c642b0af7$var$getLanguageFromBitbucketStyle = (dom)=>{
    if (dom && dom.classList.contains('codehilite')) // code block html from Bitbucket always contains an extra new line
    return $c930734c642b0af7$var$extractLanguageFromClass(dom.className);
    return;
};
// If there is a child code element, check that for data-language
const $c930734c642b0af7$var$getLanguageFromCode = (dom)=>{
    const firstChild = dom.firstElementChild;
    if (firstChild && firstChild.nodeName === 'CODE') return firstChild.getAttribute('data-language') || undefined;
};
const $c930734c642b0af7$var$extractLanguageFromClass = (className)=>{
    const languageRegex = /(?:^|\s)language-([^\s]+)/;
    const result = languageRegex.exec(className);
    if (result && result[1]) return result[1];
    return;
};
const $c930734c642b0af7$var$removeLastNewLine = (dom)=>{
    const parent = dom && dom.parentElement;
    if (parent && parent.classList.contains('codehilite')) dom.textContent = dom.textContent.replace(/\n$/, '');
    return dom;
};
function $c930734c642b0af7$var$parseCodeFromHtml(node) {
    let code = '';
    node.childNodes.forEach((child)=>{
        if (child.nodeType === Node.TEXT_NODE) // append text
        code += child.nodeValue;
        else if (child.nodeType === Node.ELEMENT_NODE && child instanceof Element) {
            const tagName = child.tagName.toLowerCase();
            if (tagName === 'div' || tagName === 'p') // add a newline before its content, unless it's the first child to avoid leading newlines
            {
                if (child.previousElementSibling !== null) code += '\n';
            }
            if (tagName === 'br') code += '\n';
            else code += $c930734c642b0af7$var$parseCodeFromHtml(child);
        }
    });
    return code;
}
const $c930734c642b0af7$export$7bb0d5c671655cc4 = (0, $7XZYM.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                let dom = domNode;
                const language = $c930734c642b0af7$var$getLanguageFromBitbucketStyle(dom.parentElement) || $c930734c642b0af7$var$getLanguageFromEditorStyle(dom.parentElement) || $c930734c642b0af7$var$getLanguageFromCode(dom) || dom.getAttribute('data-language');
                dom = $c930734c642b0af7$var$removeLastNewLine(dom);
                return {
                    language: language
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                return false;
            },
            getContent: (domNode, schema)=>{
                if ((0, $XHGTv.getBooleanFF)('platform.editor.codeblock.parsedom-divstyle-improve_5ib4n')) {
                    const code = $c930734c642b0af7$var$parseCodeFromHtml(domNode);
                    return code ? (0, $7dkLM.Fragment).from(schema.text(code)) : (0, $7dkLM.Fragment).empty;
                }
                const dom = domNode;
                const code = Array.from(dom.children).map((child)=>child.textContent).filter((x)=>x !== undefined).join('\n');
                return code ? (0, $7dkLM.Fragment).from(schema.text(code)) : (0, $7dkLM.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: (dom)=>{
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                const dom = domNode;
                // TODO: ED-5604 Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                const lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach((line)=>line.remove());
                return {};
            }
        }
    ],
    toDOM (node) {
        return [
            'pre',
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});
const $c930734c642b0af7$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((memo, key)=>{
            if (key === 'uniqueId') return memo;
            if (key === 'language' && node.attrs.language === null) return memo;
            memo[key] = node.attrs[key];
            return memo;
        }, {})
    });

});

parcelRegister("eTtDn", function(module, exports) {

$parcel$export(module.exports, "confluenceJiraIssue", () => $ad7d306f65d843cf$export$daf889beb5092f95);

var $7XZYM = parcelRequire("7XZYM");
const $ad7d306f65d843cf$var$name = 'confluenceJiraIssue';
const $ad7d306f65d843cf$export$daf889beb5092f95 = (0, $7XZYM.confluenceJiraIssue)({
    parseDOM: [
        {
            tag: `span[data-node-type="${$ad7d306f65d843cf$var$name}"]`,
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    issueKey: dom.textContent,
                    macroId: dom.dataset && dom.dataset.macroId,
                    schemaVersion: dom.dataset && dom.dataset.schemaVersion,
                    server: dom.dataset && dom.dataset.server,
                    serverId: dom.dataset && dom.dataset.serverId
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': $ad7d306f65d843cf$var$name,
            'data-macro-id': node.attrs.macroId,
            'data-schema-version': node.attrs.schemaVersion,
            'data-server': node.attrs.server,
            'data-server-id': node.attrs.serverId,
            'data-jira-issue': node.attrs.issueKey
        };
        return [
            'span',
            attrs,
            node.attrs.issueKey
        ];
    }
});

});

parcelRegister("1Ud4U", function(module, exports) {

$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $16352a752ab9df2e$export$e6e4878f43c27cab);

var $7XZYM = parcelRequire("7XZYM");
const $16352a752ab9df2e$var$name = 'confluenceUnsupportedBlock';
const $16352a752ab9df2e$export$e6e4878f43c27cab = (0, $7XZYM.confluenceUnsupportedBlock)({
    toDOM (node) {
        // NOTE: This node cannot be "contenteditable: false". If it's the only node in a document, PM throws an error because there's nowhere to put the cursor.
        const attrs = {
            'data-node-type': $16352a752ab9df2e$var$name,
            'data-confluence-unsupported': 'block',
            'data-confluence-unsupported-block-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$16352a752ab9df2e$var$name}"]`,
            getAttrs (dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-block-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("56qNL", function(module, exports) {

$parcel$export(module.exports, "confluenceUnsupportedInline", () => $3b724d8f09621cf0$export$3e6d667072febc87);

var $7XZYM = parcelRequire("7XZYM");
const $3b724d8f09621cf0$var$name = 'confluenceUnsupportedInline';
const $3b724d8f09621cf0$export$3e6d667072febc87 = (0, $7XZYM.confluenceUnsupportedInline)({
    toDOM (node) {
        const attrs = {
            'data-node-type': $3b724d8f09621cf0$var$name,
            'data-confluence-unsupported': 'inline',
            'data-confluence-unsupported-inline-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$3b724d8f09621cf0$var$name}"]`,
            getAttrs (dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-inline-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("8CDqw", function(module, exports) {

$parcel$export(module.exports, "date", () => $647074b218f86851$export$324d90190a8b822a);

var $7XZYM = parcelRequire("7XZYM");
const $647074b218f86851$export$324d90190a8b822a = (0, $7XZYM.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: (dom)=>({
                    timestamp: dom.getAttribute('data-timestamp')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("47B7q", function(module, exports) {

$parcel$export(module.exports, "decisionItem", () => $30049be2ce3504a7$export$6959e16eeff859b4);

var $lUXsh = parcelRequire("lUXsh");

var $7XZYM = parcelRequire("7XZYM");
const $30049be2ce3504a7$export$6959e16eeff859b4 = (0, $7XZYM.decisionItem)({
    parseDOM: [
        {
            tag: 'li[data-decision-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $lUXsh.uuid).generate(),
                    state: dom.getAttribute('data-decision-state')
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-decision-local-id': localId || 'local-decision',
            'data-decision-state': state
        };
        return [
            'li',
            attrs,
            0
        ];
    }
});

});
parcelRegister("lUXsh", function(module, exports) {

$parcel$export(module.exports, "generateUuid", () => $ff4cf27d021d1199$export$1c3aefb711c3a4cc);
$parcel$export(module.exports, "uuid", () => $ff4cf27d021d1199$export$31b40729666a4ae0);
/* eslint-disable no-bitwise */ const $ff4cf27d021d1199$export$1c3aefb711c3a4cc = ()=>'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0;
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
/* eslint-enable no-bitwise */ let $ff4cf27d021d1199$var$staticValue = false;
const $ff4cf27d021d1199$export$31b40729666a4ae0 = {
    setStatic (value) {
        $ff4cf27d021d1199$var$staticValue = value;
    },
    generate () {
        return $ff4cf27d021d1199$var$staticValue || $ff4cf27d021d1199$export$1c3aefb711c3a4cc();
    }
};

});


parcelRegister("dPUL6", function(module, exports) {

$parcel$export(module.exports, "decisionListSelector", () => $a12c10e7c25a057a$export$a5393ce68c2ff601);
$parcel$export(module.exports, "decisionList", () => $a12c10e7c25a057a$export$62d45a65fb43d95e);

var $lUXsh = parcelRequire("lUXsh");

var $7XZYM = parcelRequire("7XZYM");
/**
 * @name decisionList_node
 */ const $a12c10e7c25a057a$var$name = 'decisionList';
const $a12c10e7c25a057a$export$a5393ce68c2ff601 = `[data-node-type="${$a12c10e7c25a057a$var$name}"]`;
const $a12c10e7c25a057a$export$62d45a65fb43d95e = (0, $7XZYM.decisionList)({
    parseDOM: [
        {
            tag: `ol${$a12c10e7c25a057a$export$a5393ce68c2ff601}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $lUXsh.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $a12c10e7c25a057a$var$name,
            'data-decision-list-local-id': localId || 'local-decision-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("1HZv5", function(module, exports) {

$parcel$export(module.exports, "doc", () => $13e9834b2c1b91e1$export$2a111da947c407d2);

var $7XZYM = parcelRequire("7XZYM");
const $13e9834b2c1b91e1$export$2a111da947c407d2 = (0, $7XZYM.doc)({});

});

parcelRegister("7XTsD", function(module, exports) {

$parcel$export(module.exports, "embedCard", () => $5cc9107583ccf967$export$be4283d9a1cb1ff6);

var $7XZYM = parcelRequire("7XZYM");
const $5cc9107583ccf967$export$be4283d9a1cb1ff6 = (0, $7XZYM.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: (dom)=>({
                    url: dom.getAttribute('data-card-url'),
                    layout: dom.getAttribute('data-layout') || 'center',
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(dom.getAttribute('data-card-original-height')) || null
                })
        }
    ],
    toDOM (node) {
        const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
        const attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("5JhXr", function(module, exports) {

$parcel$export(module.exports, "emoji", () => $42bf15c2cb81cca3$export$a19185d1233fc4b2);

var $7RIfh = parcelRequire("7RIfh");

var $7XZYM = parcelRequire("7XZYM");
const $42bf15c2cb81cca3$export$a19185d1233fc4b2 = (0, $7XZYM.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $42bf15c2cb81cca3$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $42bf15c2cb81cca3$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $42bf15c2cb81cca3$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            getAttrs: (dom)=>(0, $7RIfh.acNameToEmoji)(dom.getAttribute('data-emoticon-name'))
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            getAttrs: (dom)=>(0, $7RIfh.acShortcutToEmoji)(dom.getAttribute('data-hipchat-emoticon'))
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $42bf15c2cb81cca3$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $42bf15c2cb81cca3$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $42bf15c2cb81cca3$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        }
    ],
    toDOM (node) {
        const { shortName: shortName, id: id, text: text } = node.attrs;
        const attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});
parcelRegister("7RIfh", function(module, exports) {

$parcel$export(module.exports, "acNameToEmoji", () => $5b9fcdd9b42caf92$export$f61e93bda2a8b420);
$parcel$export(module.exports, "acShortcutToEmoji", () => $5b9fcdd9b42caf92$export$441f8b58f5790a68);
$parcel$export(module.exports, "getEmojiAcName", () => $5b9fcdd9b42caf92$export$880a2465992fbbe);
// Default emoji id for Confluence glyphs that has no match to Fabric Emoji
const $5b9fcdd9b42caf92$var$DEFAULT_EMOJI_ID = '2b50';
// Default ac:name for emoticons as a fallback is `blue-star`
const $5b9fcdd9b42caf92$var$DEFAULT_EMOJI_ACNAME = 'blue-star';
// ac:hipchat-emoticon prefix when converting to Emoji ID
const $5b9fcdd9b42caf92$var$HC_EMOTICON_PREFIX = 'atlassian-';
/**
 * Confluence glyphs ac:name of <ac:emoticon /> map to new emojis
 * {
 *   [ac:name] : ['emoji-id', 'emoji-shortName', 'emoji-fallback']
 *   ...
 * }
 * Glyphs that do not map to Fabric Emoji
 * will be mapped to Emoji Id '2b50' (:star:) with preserving ac:name as shortName attribute;
 */ const $5b9fcdd9b42caf92$var$acNameToEmojiMap = {
    smile: [
        '1f642',
        ':slight_smile:',
        '\uD83D\uDE42'
    ],
    sad: [
        '1f641',
        ':slight_frown:',
        '\uD83D\uDE41'
    ],
    cheeky: [
        '1f61b',
        ':stuck_out_tongue:',
        '\uD83D\uDE1B'
    ],
    laugh: [
        '1f600',
        ':grinning:',
        '\uD83D\uDE00'
    ],
    wink: [
        '1f609',
        ':wink:',
        '\uD83D\uDE09'
    ],
    information: [
        '2139',
        ':information_source:',
        '\u2139'
    ],
    tick: [
        '2705',
        ':white_check_mark:',
        '\u2705'
    ],
    cross: [
        '274c',
        ':x:',
        '\u274C'
    ],
    warning: [
        '26a0',
        ':warning:',
        '\u26A0'
    ],
    plus: [
        '2795',
        ':heavy_plus_sign:',
        '\u2795'
    ],
    minus: [
        '2796',
        ':heavy_minus_sign:',
        '\u2796'
    ],
    question: [
        '2753',
        ':question:',
        '\u003F'
    ],
    'thumbs-up': [
        '1f44d',
        ':thumbsup:',
        '\uD83D\uDC4D'
    ],
    'thumbs-down': [
        '1f44e',
        ':thumbsdown:',
        '\uD83D\uDC4E'
    ],
    'light-on': [
        '1f4a1',
        ':bulb:',
        '\uD83D\uDCA1'
    ],
    'yellow-star': [
        '2b50',
        ':star:',
        '\uD83D\uDC9B'
    ],
    'light-off': [
        '1f6ab',
        ':no_entry_sign:',
        '\uD83D\uDEAB'
    ],
    'red-star': [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'green-star': [
        '1f49a',
        ':green_heart:',
        '\uD83D\uDC9A'
    ],
    'blue-star': [
        '1f499',
        ':blue_heart:',
        '\uD83D\uDC99'
    ],
    heart: [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'broken-heart': [
        '1f494',
        ':broken_heart:',
        '\uD83D\uDC94'
    ]
};
function $5b9fcdd9b42caf92$export$f61e93bda2a8b420(acName) {
    const emojiData = $5b9fcdd9b42caf92$var$acNameToEmojiMap[acName];
    return emojiData ? {
        id: emojiData[0],
        shortName: emojiData[1],
        text: emojiData[2]
    } : {
        id: $5b9fcdd9b42caf92$var$DEFAULT_EMOJI_ID,
        shortName: `:${acName}:`,
        text: ''
    };
}
function $5b9fcdd9b42caf92$export$bc94e44ec0e7bd82(emojiId) {
    const filterEmojis = (acName)=>$5b9fcdd9b42caf92$var$acNameToEmojiMap[acName] ? $5b9fcdd9b42caf92$var$acNameToEmojiMap[acName][0] === emojiId : false;
    return Object.keys($5b9fcdd9b42caf92$var$acNameToEmojiMap).filter(filterEmojis)[0];
}
function $5b9fcdd9b42caf92$export$441f8b58f5790a68(hipchatEmoticonShortName) {
    return {
        id: `${$5b9fcdd9b42caf92$var$HC_EMOTICON_PREFIX}${hipchatEmoticonShortName}`,
        shortName: `:${hipchatEmoticonShortName}:`,
        text: ''
    };
}
function $5b9fcdd9b42caf92$var$getAcNameFromShortName(shortName) {
    return shortName.slice(shortName[0] === ':' ? 1 : 0, shortName[shortName.length - 1] === ':' ? -1 : shortName.length);
}
function $5b9fcdd9b42caf92$export$880a2465992fbbe({ id: id, shortName: shortName }) {
    if ($5b9fcdd9b42caf92$var$DEFAULT_EMOJI_ID === id) {
        const possibleName = $5b9fcdd9b42caf92$var$getAcNameFromShortName(shortName);
        if (possibleName in $5b9fcdd9b42caf92$var$acNameToEmojiMap) return possibleName;
    }
    return $5b9fcdd9b42caf92$export$bc94e44ec0e7bd82(id) || $5b9fcdd9b42caf92$var$DEFAULT_EMOJI_ACNAME;
}

});


parcelRegister("lKuoe", function(module, exports) {

$parcel$export(module.exports, "expand", () => $fd5577a23a87630d$export$9f77e0932fb78f72);
$parcel$export(module.exports, "toJSON", () => $fd5577a23a87630d$export$54fd2c36b5cc6731);

var $7XZYM = parcelRequire("7XZYM");
/**
 * @name expand_node
 */ /**
 * @name expand_with_no_mark_node
 */ /**
 * @name expand_with_breakout_mark_node
 */ function $fd5577a23a87630d$var$getExpandAttrs(domNode) {
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
const $fd5577a23a87630d$export$9f77e0932fb78f72 = (0, $7XZYM.expand)({
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: $fd5577a23a87630d$var$getExpandAttrs
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            skip: true
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            skip: true
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: $fd5577a23a87630d$var$getExpandAttrs
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $fd5577a23a87630d$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>!key.startsWith('__')).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });

});

parcelRegister("izui5", function(module, exports) {

$parcel$export(module.exports, "PanelType", () => $d852fdfb5507437d$export$969277cf61e5a7aa);
$parcel$export(module.exports, "panel", () => $d852fdfb5507437d$export$21f42ab9b6679f44);
$parcel$export(module.exports, "extendedPanel", () => $d852fdfb5507437d$export$ce20b13564211141);

var $7XZYM = parcelRequire("7XZYM");
let $d852fdfb5507437d$export$969277cf61e5a7aa = /*#__PURE__*/ function(PanelType) {
    PanelType["INFO"] = "info";
    PanelType["NOTE"] = "note";
    PanelType["TIP"] = "tip";
    PanelType["WARNING"] = "warning";
    PanelType["ERROR"] = "error";
    PanelType["SUCCESS"] = "success";
    PanelType["CUSTOM"] = "custom";
    return PanelType;
}({});
/**
 * @name panel_node
 */ const $d852fdfb5507437d$var$getDomAttrs = (nodeAttrs)=>{
    const attrs = {
        'data-panel-type': nodeAttrs.panelType,
        'data-panel-icon': nodeAttrs.panelIcon,
        'data-panel-icon-id': nodeAttrs.panelIconId,
        'data-panel-icon-text': nodeAttrs.panelIconText,
        'data-panel-color': nodeAttrs.panelColor
    };
    return attrs;
};
const $d852fdfb5507437d$var$getParseDOMAttrs = (allowCustomPanel, dom)=>{
    let parseDOMAttrs = {
        panelType: dom.getAttribute('data-panel-type')
    };
    if (allowCustomPanel) parseDOMAttrs = {
        ...parseDOMAttrs,
        panelIcon: dom.getAttribute('data-panel-icon'),
        panelIconId: dom.getAttribute('data-panel-icon-id'),
        panelIconText: dom.getAttribute('data-panel-icon-text'),
        panelColor: dom.getAttribute('data-panel-color')
    };
    else parseDOMAttrs.panelType = parseDOMAttrs.panelType === $d852fdfb5507437d$export$969277cf61e5a7aa.CUSTOM ? $d852fdfb5507437d$export$969277cf61e5a7aa.INFO : parseDOMAttrs.panelType;
    return parseDOMAttrs;
};
const $d852fdfb5507437d$export$21f42ab9b6679f44 = (allowCustomPanel)=>{
    const panelNodeSpec = (0, $7XZYM.panelLegacy)({
        parseDOM: [
            {
                tag: 'div[data-panel-type]',
                getAttrs: (dom)=>$d852fdfb5507437d$var$getParseDOMAttrs(allowCustomPanel, dom)
            }
        ],
        toDOM (node) {
            const attrs = $d852fdfb5507437d$var$getDomAttrs(node.attrs);
            const contentAttrs = {
                'data-panel-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    });
    return panelNodeSpec;
};
const $d852fdfb5507437d$export$ce20b13564211141 = (allowCustomPanel)=>{
    const panelNodeSpec = (0, $7XZYM.panel)({
        parseDOM: [
            {
                tag: 'div[data-panel-type]',
                getAttrs: (dom)=>$d852fdfb5507437d$var$getParseDOMAttrs(allowCustomPanel, dom)
            }
        ],
        toDOM (node) {
            const attrs = $d852fdfb5507437d$var$getDomAttrs(node.attrs);
            const contentAttrs = {
                'data-panel-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    });
    return panelNodeSpec;
};

});

parcelRegister("7y7sZ", function(module, exports) {

$parcel$export(module.exports, "extension", () => $57f1801b48030dd3$export$1b45514b112dd749);

var $eUEbq = parcelRequire("eUEbq");

var $7XZYM = parcelRequire("7XZYM");
const $57f1801b48030dd3$export$1b45514b112dd749 = (0, $7XZYM.extension)({
    parseDOM: [
        {
            tag: '[data-node-type="extension"]',
            getAttrs: (domNode)=>(0, $eUEbq.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("7SlQD", function(module, exports) {

$parcel$export(module.exports, "hardBreak", () => $5bbe86148e97ac9f$export$371da9dd35aba193);

var $7XZYM = parcelRequire("7XZYM");
const $5bbe86148e97ac9f$export$371da9dd35aba193 = (0, $7XZYM.hardBreak)({
    parseDOM: [
        {
            tag: 'br'
        }
    ],
    toDOM () {
        return [
            'br'
        ];
    }
});

});

parcelRegister("iWGOh", function(module, exports) {

$parcel$export(module.exports, "heading", () => $dcaed9f1743d53de$export$46e4a324ac90507f);

var $7XZYM = parcelRequire("7XZYM");
/**
 * @name heading_node
 */ /**
 * @name heading_with_no_marks_node
 */ // Check `paragraph` node for why we are doing things like this
/**
 * @name heading_with_alignment_node
 */ /**
 * @name heading_with_indentation_node
 */ const $dcaed9f1743d53de$var$getAttrs = (level)=>(domNode)=>{
        var _heading$attrs, _heading$attrs$localI;
        return {
            level: level,
            localId: domNode.getAttribute('data-local-id') || ((_heading$attrs = $dcaed9f1743d53de$export$46e4a324ac90507f.attrs) === null || _heading$attrs === void 0 ? void 0 : (_heading$attrs$localI = _heading$attrs.localId) === null || _heading$attrs$localI === void 0 ? void 0 : _heading$attrs$localI.default)
        };
    };
const $dcaed9f1743d53de$export$46e4a324ac90507f = (0, $7XZYM.heading)({
    parseDOM: [
        {
            tag: 'h1',
            getAttrs: $dcaed9f1743d53de$var$getAttrs(1)
        },
        {
            tag: 'h2',
            getAttrs: $dcaed9f1743d53de$var$getAttrs(2)
        },
        {
            tag: 'h3',
            getAttrs: $dcaed9f1743d53de$var$getAttrs(3)
        },
        {
            tag: 'h4',
            getAttrs: $dcaed9f1743d53de$var$getAttrs(4)
        },
        {
            tag: 'h5',
            getAttrs: $dcaed9f1743d53de$var$getAttrs(5)
        },
        {
            tag: 'h6',
            getAttrs: $dcaed9f1743d53de$var$getAttrs(6)
        }
    ],
    toDOM (node) {
        const { level: level, localId: localId } = node.attrs;
        const name = 'h' + level;
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
});

});

parcelRegister("iOeir", function(module, exports) {

$parcel$export(module.exports, "image", () => $db17fc75bafe5b63$export$5c452ff88e35e47d);

var $7XZYM = parcelRequire("7XZYM");
const $db17fc75bafe5b63$export$5c452ff88e35e47d = (0, $7XZYM.image)({
    parseDOM: [
        {
            tag: 'img[src^="data:image/"]',
            ignore: true
        },
        {
            tag: 'img[src]',
            getAttrs (domNode) {
                const dom = domNode;
                return {
                    src: dom.getAttribute('src'),
                    alt: dom.getAttribute('alt'),
                    title: dom.getAttribute('title')
                };
            }
        }
    ],
    toDOM (node) {
        return [
            'img',
            node.attrs
        ];
    }
});

});

parcelRegister("8mC62", function(module, exports) {

$parcel$export(module.exports, "inlineCard", () => $616dedf2d343125f$export$cbf8224b64e0d942);

var $7XZYM = parcelRequire("7XZYM");
const $616dedf2d343125f$export$cbf8224b64e0d942 = (0, $7XZYM.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : ''
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});

});

parcelRegister("7xvQK", function(module, exports) {

$parcel$export(module.exports, "inlineExtension", () => $57d4522b818e953c$export$16b353b2649bd8d9);

var $eUEbq = parcelRequire("eUEbq");

var $7XZYM = parcelRequire("7XZYM");
const $57d4522b818e953c$export$16b353b2649bd8d9 = (0, $7XZYM.inlineExtensionWithMarks)({
    parseDOM: [
        {
            tag: 'span[data-extension-type]',
            getAttrs: (domNode)=>(0, $eUEbq.getExtensionAttrs)(domNode, true)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-local-id:': node.attrs.localId,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("1O3jv", function(module, exports) {

$parcel$export(module.exports, "layoutColumn", () => $150d07f918689e82$export$ab76e7c03cd6f650);

var $7XZYM = parcelRequire("7XZYM");
const $150d07f918689e82$export$ab76e7c03cd6f650 = (0, $7XZYM.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    width: Number(dom.getAttribute('data-column-width')) || undefined
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-layout-column': 'true'
        };
        const { width: width } = node.attrs;
        if (width) {
            attrs['style'] = `flex-basis: ${width}%`;
            attrs['data-column-width'] = `${width}`;
        }
        // We need to apply a attribute to the inner most child to help
        // ProseMirror identify its boundaries better.
        const contentAttrs = {
            'data-layout-content': 'true'
        };
        return [
            'div',
            attrs,
            [
                'div',
                contentAttrs,
                0
            ]
        ];
    }
});

});

parcelRegister("3eVto", function(module, exports) {

$parcel$export(module.exports, "listItem", () => $25bf42da33411467$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "listItemWithTask", () => $25bf42da33411467$export$58dca2f0678302a4);

var $7XZYM = parcelRequire("7XZYM");
const $25bf42da33411467$export$76c7e83ecc9cdf05 = (0, $7XZYM.listItemLegacy)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
});
const $25bf42da33411467$export$58dca2f0678302a4 = (0, $7XZYM.listItem)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
});

});

parcelRegister("gN3fl", function(module, exports) {

$parcel$export(module.exports, "createMediaSpec", () => $c393bda0a4dc410d$export$35bdbf5bc8caa677);
$parcel$export(module.exports, "copyPrivateAttributes", () => $c393bda0a4dc410d$export$111130fa8968d741);
$parcel$export(module.exports, "media", () => $c393bda0a4dc410d$export$987d49ffe1b0900f);
$parcel$export(module.exports, "toJSON", () => $c393bda0a4dc410d$export$54fd2c36b5cc6731);

var $jR93G = parcelRequire("jR93G");

var $7XZYM = parcelRequire("7XZYM");
const $c393bda0a4dc410d$export$bb3fe706be61f640 = (0, $7XZYM.media)({}).attrs;
const $c393bda0a4dc410d$export$35bdbf5bc8caa677 = (attributes, inline = false)=>{
    const domNodeType = inline ? 'span' : 'div';
    const nodeName = inline ? 'mediaInline' : 'media';
    const parseDOM = [
        {
            tag: `${domNodeType}[data-node-type="${nodeName}"]`,
            getAttrs: (dom)=>{
                const attrs = {};
                if (attributes) Object.keys(attributes).forEach((k)=>{
                    const key = $c393bda0a4dc410d$export$f84fdfb973c05bd8(k).replace(/^__/, '');
                    const value = dom.getAttribute(`data-${key}`) || '';
                    if (value) attrs[k] = value;
                });
                // Need to do validation & type conversion manually
                if (attrs.__fileSize) attrs.__fileSize = +attrs.__fileSize;
                const width = Number(attrs.width);
                if (typeof width !== 'undefined' && !isNaN(width)) attrs.width = width;
                const height = Number(attrs.height);
                if (typeof height !== 'undefined' && !isNaN(height)) attrs.height = height;
                return attrs;
            }
        },
        // Don't match data URI
        {
            tag: 'img[src^="data:image"]',
            ignore: true
        }
    ];
    // media-inline.ts uses this same function to generate the nodespec
    // this ensures that we don't make a media inline out of a copied image
    // https://product-fabric.atlassian.net/browse/EDM-2996
    if (!inline) parseDOM.push({
        tag: 'img:not(.smart-link-icon)',
        getAttrs: (dom)=>{
            return {
                type: 'external',
                url: dom.getAttribute('src') || '',
                alt: dom.getAttribute('alt') || ''
            };
        }
    });
    const toDOM = (node)=>{
        const attrs = {
            'data-id': node.attrs.id,
            'data-node-type': `${nodeName}`,
            'data-type': node.attrs.type,
            'data-collection': node.attrs.collection,
            'data-occurrence-key': node.attrs.occurrenceKey,
            'data-width': node.attrs.width,
            'data-height': node.attrs.height,
            'data-url': node.attrs.url,
            'data-alt': node.attrs.alt,
            // toDOM is used for static rendering as well as editor rendering. This comes into play for
            // emails, copy/paste, etc, so the title and styling here *is* useful (despite a React-based
            // node view being used for editing).
            title: 'Attachment',
            // Manually kept in sync with the style of media cards. The goal is to render a plain gray
            // rectangle that provides an affordance for media.
            style: `display: inline-block; border-radius: 3px; background: ${(0, $jR93G.N30)}; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);`
        };
        $c393bda0a4dc410d$export$111130fa8968d741(node.attrs, attrs, (key)=>`data-${$c393bda0a4dc410d$export$f84fdfb973c05bd8(key.slice(2))}`);
        return [
            `${domNodeType}`,
            attrs
        ];
    };
    if (inline) return (0, $7XZYM.mediaInline)({
        parseDOM: parseDOM,
        toDOM: toDOM
    });
    return (0, $7XZYM.media)({
        parseDOM: parseDOM,
        toDOM: toDOM
    });
};
const $c393bda0a4dc410d$export$987d49ffe1b0900f = $c393bda0a4dc410d$export$35bdbf5bc8caa677($c393bda0a4dc410d$export$bb3fe706be61f640, false);
const $c393bda0a4dc410d$export$f84fdfb973c05bd8 = (str)=>str.replace(/([^A-Z]+)([A-Z])/g, (_, x, y)=>`${x}-${y.toLowerCase()}`);
const $c393bda0a4dc410d$export$111130fa8968d741 = (from, to, map)=>{
    if ($c393bda0a4dc410d$export$987d49ffe1b0900f.attrs) Object.keys($c393bda0a4dc410d$export$987d49ffe1b0900f.attrs).forEach((key)=>{
        if (key[0] === '_' && key[1] === '_' && from[key]) to[map ? map(key) : key] = from[key];
    });
};
/**
 * There's no concept of optional property in ProseMirror. It sets value as `null`
 * when there's no use of any property. We are filtering out all private & optional attrs here.
 */ const $c393bda0a4dc410d$var$optionalAttributes = [
    'occurrenceKey',
    'width',
    'height',
    'url',
    'alt'
];
const $c393bda0a4dc410d$var$externalOnlyAttributes = [
    'type',
    'url',
    'width',
    'height',
    'alt'
];
const $c393bda0a4dc410d$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs)// Strip private attributes e.g. __fileName, __fileSize, __fileMimeType, etc.
        .filter((key)=>!(key[0] === '_' && key[1] === '_')).reduce((obj, key)=>{
            if (node.attrs.type === 'external' && $c393bda0a4dc410d$var$externalOnlyAttributes.indexOf(key) === -1) return obj;
            if ($c393bda0a4dc410d$var$optionalAttributes.indexOf(key) > -1 && (node.attrs[key] === null || node.attrs[key] === '')) return obj;
            if ([
                'width',
                'height'
            ].indexOf(key) !== -1) {
                obj[key] = Number(node.attrs[key]);
                return obj;
            }
            obj[key] = node.attrs[key];
            return obj;
        }, {})
    });

});

parcelRegister("1KDvn", function(module, exports) {

$parcel$export(module.exports, "mediaGroup", () => $1468bb36b31049a8$export$2855e964765eac9);

var $7XZYM = parcelRequire("7XZYM");
const $1468bb36b31049a8$export$2855e964765eac9 = (0, $7XZYM.mediaGroup)({
    parseDOM: [
        {
            tag: 'div[data-node-type="mediaGroup"]'
        },
        {
            tag: 'div[class="MediaGroup"]'
        }
    ],
    toDOM () {
        return [
            'div',
            {
                'data-node-type': 'mediaGroup'
            },
            0
        ];
    }
});

});

parcelRegister("hXvCf", function(module, exports) {

$parcel$export(module.exports, "mediaInline", () => $d130789d4554ffe4$export$38bab695e3f720f1);

var $gN3fl = parcelRequire("gN3fl");

var $7XZYM = parcelRequire("7XZYM");
const $d130789d4554ffe4$export$38bab695e3f720f1 = (0, $gN3fl.createMediaSpec)((0, $7XZYM.mediaInline)({}).attrs, true);

});

parcelRegister("cvCFq", function(module, exports) {

$parcel$export(module.exports, "mediaSingleSpec", () => $91b65fc731134d1d$export$5a1e124099b60c6b);
$parcel$export(module.exports, "mediaSingle", () => $91b65fc731134d1d$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingleWithCaption", () => $91b65fc731134d1d$export$d35e6c006d4abdfb);
$parcel$export(module.exports, "mediaSingleWithWidthType", () => $91b65fc731134d1d$export$9c58e19811ce4cf5);
$parcel$export(module.exports, "mediaSingleFull", () => $91b65fc731134d1d$export$7e767666f2ce108a);
$parcel$export(module.exports, "toJSON", () => $91b65fc731134d1d$export$54fd2c36b5cc6731);

var $H6cl0 = parcelRequire("H6cl0");

var $1pjCh = parcelRequire("1pjCh");

var $7XZYM = parcelRequire("7XZYM");
const $91b65fc731134d1d$export$bb3fe706be61f640 = {
    width: {
        default: null
    },
    // null makes small images to have original size by default
    layout: {
        default: 'center'
    }
};
const $91b65fc731134d1d$export$5a1e124099b60c6b = ({ withCaption: withCaption = false, withExtendedWidthTypes: withExtendedWidthTypes = false })=>{
    const getAttrs = (dom)=>{
        if (!(0, $1pjCh.isDOMElement)(dom)) // this should never happen
        return {
            layout: 'center'
        };
        const layout = dom.getAttribute('data-layout') || 'center';
        const width = Number(dom.getAttribute('data-width')) || null;
        const widthType = dom.getAttribute('data-width-type');
        if (withExtendedWidthTypes) return {
            layout: layout,
            width: width,
            widthType: widthType
        };
        else if (widthType === (0, $H6cl0.WidthType).PIXEL) // if editor does not support widthType attribute.
        // We ignore width and widthType together.
        return {
            layout: layout
        };
        else return {
            layout: layout,
            width: width
        };
    };
    const getAttrsFromNode = (node)=>{
        const { layout: layout, width: width } = node.attrs;
        const attrs = {
            'data-node-type': 'mediaSingle',
            'data-layout': layout,
            'data-width': ''
        };
        if (width) attrs['data-width'] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
        if (withExtendedWidthTypes && node.attrs.widthType) {
            const { widthType: widthType } = node.attrs;
            return {
                ...attrs,
                'data-width-type': widthType || (0, $H6cl0.WidthType).PERCENTAGE
            };
        }
        return attrs;
    };
    if (withExtendedWidthTypes && withCaption) return (0, $7XZYM.mediaSingleFull)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (withExtendedWidthTypes && !withCaption) return (0, $7XZYM.mediaSingleWidthType)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (!withExtendedWidthTypes && withCaption) return (0, $7XZYM.mediaSingleCaption)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    return (0, $7XZYM.mediaSingle)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
};
const $91b65fc731134d1d$export$969fe3781ca15058 = $91b65fc731134d1d$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: false
});
const $91b65fc731134d1d$export$d35e6c006d4abdfb = $91b65fc731134d1d$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: false
});
const $91b65fc731134d1d$export$9c58e19811ce4cf5 = $91b65fc731134d1d$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: true
});
const $91b65fc731134d1d$export$7e767666f2ce108a = $91b65fc731134d1d$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true
});
const $91b65fc731134d1d$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if (node.attrs[key] !== null) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });

});
parcelRegister("H6cl0", function(module, exports) {

$parcel$export(module.exports, "WidthType", () => $0818d30f6134b029$export$4d41558722ac7eed);
/**
 * @description The widthType attribute is used to support fixed with media single
 */ let $0818d30f6134b029$export$4d41558722ac7eed = /*#__PURE__*/ function(WidthType) {
    WidthType["PIXEL"] = "pixel";
    WidthType["PERCENTAGE"] = "percentage";
    return WidthType;
}({});

});


parcelRegister("fkqTY", function(module, exports) {

$parcel$export(module.exports, "mention", () => $b28d976c62a93439$export$db83999c14438df4);
$parcel$export(module.exports, "toJSON", () => $b28d976c62a93439$export$54fd2c36b5cc6731);

var $lUXsh = parcelRequire("lUXsh");

var $7XZYM = parcelRequire("7XZYM");
let $b28d976c62a93439$export$abebb208988c258 = /*#__PURE__*/ function(USER_TYPES) {
    USER_TYPES["DEFAULT"] = "DEFAULT";
    USER_TYPES["SPECIAL"] = "SPECIAL";
    USER_TYPES["APP"] = "APP";
    return USER_TYPES;
}({});
const $b28d976c62a93439$export$db83999c14438df4 = (0, $7XZYM.mention)({
    parseDOM: [
        {
            tag: 'span[data-mention-id]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const attrs = {
                    id: dom.getAttribute('data-mention-id') || $b28d976c62a93439$export$db83999c14438df4.attrs.id.default,
                    text: dom.textContent || $b28d976c62a93439$export$db83999c14438df4.attrs.text.default,
                    accessLevel: dom.getAttribute('data-access-level') || $b28d976c62a93439$export$db83999c14438df4.attrs.accessLevel.default,
                    localId: (0, $lUXsh.uuid).generate()
                };
                const userType = dom.getAttribute('data-user-type');
                if ($b28d976c62a93439$export$abebb208988c258[userType]) attrs.userType = userType;
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { id: id, accessLevel: accessLevel, text: text, userType: userType, localId: localId } = node.attrs;
        const attrs = {
            'data-mention-id': id,
            'data-access-level': accessLevel,
            contenteditable: 'false'
        };
        if (localId) attrs['data-local-id'] = localId;
        if (userType) attrs['data-user-type'] = userType;
        return [
            'span',
            attrs,
            text
        ];
    }
});
const $b28d976c62a93439$var$isOptional = (key)=>{
    return [
        'userType',
        'localId'
    ].indexOf(key) > -1;
};
const $b28d976c62a93439$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if ($b28d976c62a93439$var$isOptional(key) && !node.attrs[key]) return obj;
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });

});

parcelRegister("dj4Ew", function(module, exports) {

$parcel$export(module.exports, "nestedExpand", () => $9b00a8a2bcf49bd5$export$63cadbf5f4296627);

var $7XZYM = parcelRequire("7XZYM");
const $9b00a8a2bcf49bd5$export$63cadbf5f4296627 = (0, $7XZYM.nestedExpand)({
    parseDOM: [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            skip: true
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="nestedExpand"]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    title: dom.getAttribute('data-title'),
                    __expanded: true
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'nestedExpand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("8lnnz", function(module, exports) {

$parcel$export(module.exports, "orderedListSelector", () => $61326b7f5996ad33$export$4e7125c7ff595be5);
$parcel$export(module.exports, "orderedList", () => $61326b7f5996ad33$export$a5dc81035676e7a);
$parcel$export(module.exports, "orderedListWithOrder", () => $61326b7f5996ad33$export$b9ab759e8298198f);

var $7XZYM = parcelRequire("7XZYM");
const $61326b7f5996ad33$export$4e7125c7ff595be5 = '.ak-ol';
const $61326b7f5996ad33$export$a5dc81035676e7a = (0, $7XZYM.orderedList)({
    parseDOM: [
        {
            tag: 'ol'
        }
    ],
    toDOM () {
        const attrs = {
            class: $61326b7f5996ad33$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
// resolve "start" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveOrder"
// in packages/editor/editor-common/src/utils/list.ts
const $61326b7f5996ad33$var$resolveStart = (start)=>{
    const num = Number(start);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $61326b7f5996ad33$export$b9ab759e8298198f = (0, $7XZYM.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: (domNode)=>{
                const dom = domNode;
                const startDOMAttr = dom.getAttribute('start');
                if (startDOMAttr) {
                    const start = $61326b7f5996ad33$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start
                    };
                }
                return null;
            }
        }
    ],
    toDOM (node) {
        var _node$attrs;
        const start = $61326b7f5996ad33$var$resolveStart(node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.order);
        const attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $61326b7f5996ad33$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("5bGpU", function(module, exports) {

$parcel$export(module.exports, "paragraph", () => $3c6ee1ed25404369$export$9c206ddddb32a9b);

var $7XZYM = parcelRequire("7XZYM");
const $3c6ee1ed25404369$export$9c206ddddb32a9b = (0, $7XZYM.paragraph)({
    parseDOM: [
        {
            tag: 'p',
            getAttrs: (domNode)=>{
                var _paragraph$attrs, _paragraph$attrs$loca;
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || ((_paragraph$attrs = $3c6ee1ed25404369$export$9c206ddddb32a9b.attrs) === null || _paragraph$attrs === void 0 ? void 0 : (_paragraph$attrs$loca = _paragraph$attrs.localId) === null || _paragraph$attrs$loca === void 0 ? void 0 : _paragraph$attrs$loca.default)
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const name = 'p';
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
});

});

parcelRegister("dDs5p", function(module, exports) {

$parcel$export(module.exports, "placeholder", () => $028fd15bd9efda92$export$c7187bbd1a7a9244);

var $7XZYM = parcelRequire("7XZYM");
const $028fd15bd9efda92$export$c7187bbd1a7a9244 = (0, $7XZYM.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: (dom)=>({
                    text: dom.getAttribute('data-placeholder') || $028fd15bd9efda92$export$c7187bbd1a7a9244.attrs.text.default
                })
        }
    ],
    toDOM (node) {
        const { text: text } = node.attrs;
        const attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("7wZ4m", function(module, exports) {

$parcel$export(module.exports, "rule", () => $57bae4a7ab6a77ec$export$fbeb3a3956e8a3c7);

var $7XZYM = parcelRequire("7XZYM");
/**
 * @name rule_node
 */ const $57bae4a7ab6a77ec$var$hrDOM = [
    'hr'
];
const $57bae4a7ab6a77ec$export$fbeb3a3956e8a3c7 = (0, $7XZYM.rule)({
    parseDOM: [
        {
            tag: 'hr'
        }
    ],
    toDOM () {
        return $57bae4a7ab6a77ec$var$hrDOM;
    }
});

});

parcelRegister("cvo5z", function(module, exports) {

$parcel$export(module.exports, "status", () => $91ab10d6717106ff$export$471f7ae5c4103ae1);

var $lUXsh = parcelRequire("lUXsh");

var $7XZYM = parcelRequire("7XZYM");
const $91ab10d6717106ff$export$471f7ae5c4103ae1 = (0, $7XZYM.status)({
    parseDOM: [
        {
            tag: 'span[data-node-type="status"]',
            getAttrs: (domNode)=>{
                const dom = domNode;
                return {
                    text: dom.textContent.replace(/\n/, '').trim(),
                    color: dom.getAttribute('data-color'),
                    localId: (0, $lUXsh.uuid).generate(),
                    style: dom.getAttribute('data-style')
                };
            }
        }
    ],
    toDOM (node) {
        const { text: text, color: color, localId: localId, style: style } = node.attrs;
        const attrs = {
            'data-node-type': 'status',
            'data-color': color,
            'data-local-id': localId,
            'data-style': style,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("byxO6", function(module, exports) {

$parcel$export(module.exports, "tablePrefixSelector", () => $869d1810285fb07e$export$9cfceb893b24742a);
$parcel$export(module.exports, "tableCellSelector", () => $869d1810285fb07e$export$69cb4c3f80383763);
$parcel$export(module.exports, "tableHeaderSelector", () => $869d1810285fb07e$export$7b07d37d879c957f);
$parcel$export(module.exports, "tableCellContentWrapperSelector", () => $869d1810285fb07e$export$8dd42a84cd52da07);
$parcel$export(module.exports, "tableCellContentDomSelector", () => $869d1810285fb07e$export$5e26a5c19f0865d8);
$parcel$export(module.exports, "getCellAttrs", () => $869d1810285fb07e$export$43977bde391e007);
$parcel$export(module.exports, "getCellDomAttrs", () => $869d1810285fb07e$export$363c8dda799bfe9c);
$parcel$export(module.exports, "tableBackgroundColorNames", () => $869d1810285fb07e$export$8cc2833b5b349a1e);
$parcel$export(module.exports, "tableBackgroundColorPalette", () => $869d1810285fb07e$export$219b7f492ad209f8);
$parcel$export(module.exports, "tableBackgroundBorderColor", () => $869d1810285fb07e$export$95e9c925fbf01d1c);
$parcel$export(module.exports, "table", () => $869d1810285fb07e$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableWithCustomWidth", () => $869d1810285fb07e$export$90e634fbace1f0c4);
$parcel$export(module.exports, "tableStage0", () => $869d1810285fb07e$export$3862de5c8c9098cf);
$parcel$export(module.exports, "tableToJSON", () => $869d1810285fb07e$export$1f92a2f429e06fa8);
$parcel$export(module.exports, "tableRow", () => $869d1810285fb07e$export$ce666bf02318c957);
$parcel$export(module.exports, "tableCell", () => $869d1810285fb07e$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "toJSONTableCell", () => $869d1810285fb07e$export$2ac34c099660f1a8);
$parcel$export(module.exports, "tableHeader", () => $869d1810285fb07e$export$48884d2a5190dc73);
$parcel$export(module.exports, "toJSONTableHeader", () => $869d1810285fb07e$export$2af48797a1010bb1);

var $a3bbC = parcelRequire("a3bbC");

var $jR93G = parcelRequire("jR93G");

var $lUXsh = parcelRequire("lUXsh");

var $as9OS = parcelRequire("as9OS");

var $7XZYM = parcelRequire("7XZYM");
const $869d1810285fb07e$export$9cfceb893b24742a = 'pm-table';
const $869d1810285fb07e$export$69cb4c3f80383763 = `${$869d1810285fb07e$export$9cfceb893b24742a}-cell-content-wrap`;
const $869d1810285fb07e$export$7b07d37d879c957f = `${$869d1810285fb07e$export$9cfceb893b24742a}-header-content-wrap`;
const $869d1810285fb07e$export$8dd42a84cd52da07 = `${$869d1810285fb07e$export$9cfceb893b24742a}-cell-nodeview-wrapper`;
const $869d1810285fb07e$export$5e26a5c19f0865d8 = `${$869d1810285fb07e$export$9cfceb893b24742a}-cell-nodeview-content-dom`;
const $869d1810285fb07e$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND = (0, $jR93G.N20).toLocaleLowerCase();
const $869d1810285fb07e$export$43977bde391e007 = (dom, defaultValues = {})=>{
    const widthAttr = dom.getAttribute('data-colwidth');
    const width = widthAttr && /^\d+(,\d+)*$/.test(widthAttr) ? widthAttr.split(',').map((str)=>Number(str)) : null;
    const colspan = Number(dom.getAttribute('colspan') || 1);
    let { backgroundColor: backgroundColor } = dom.style;
    /**
   * We have pivoted to store background color information in
   *  data-cell-background.
   * We will have original hex code (which we map to DST token)
   *  stored in data-cell-background, use that.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ const dataCellBackground = dom.getAttribute('data-cell-background');
    const dataCellBackgroundHexCode = dataCellBackground && (0, $jR93G.isHex)(dataCellBackground) ? dataCellBackground : undefined;
    // ignore setting background attr if ds neutral token is detected
    if (backgroundColor.includes('--ds-background-neutral')) backgroundColor = '';
    else if (backgroundColor && (0, $jR93G.isRgb)(backgroundColor)) {
        const result = (0, $jR93G.rgbToHex)(backgroundColor);
        if (result !== null) backgroundColor = result;
    }
    const backgroundHexCode = dataCellBackgroundHexCode || (backgroundColor && backgroundColor !== defaultValues['background'] ? backgroundColor : null);
    return {
        colspan: colspan,
        rowspan: Number(dom.getAttribute('rowspan') || 1),
        colwidth: width && width.length === colspan ? width : null,
        background: backgroundHexCode
    };
};
// these are for test only
let $869d1810285fb07e$var$testGlobalTheme;
const $869d1810285fb07e$export$fd7e0dd2b74807f7 = (theme)=>{
    $869d1810285fb07e$var$testGlobalTheme = theme;
};
// This is a minimal duplication of the method from @atlaskit/tokens
// to minimise the number of dependencies required as these changes are expected
// to be patched onto CR8.
const $869d1810285fb07e$var$getGlobalTheme = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($869d1810285fb07e$var$testGlobalTheme) return {
        colorMode: $869d1810285fb07e$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
const $869d1810285fb07e$export$363c8dda799bfe9c = (node)=>{
    const attrs = {};
    const nodeType = node.type.name;
    if (node.attrs.colspan !== 1) attrs.colspan = node.attrs.colspan;
    if (node.attrs.rowspan !== 1) attrs.rowspan = node.attrs.rowspan;
    if (node.attrs.colwidth) attrs['data-colwidth'] = node.attrs.colwidth.join(',');
    if (node.attrs.background) {
        const { background: background } = node.attrs;
        // to ensure that we don't overwrite product's style:
        // - it clears background color for <th> if its set to gray
        // - it clears background color for <td> if its set to white
        // - it clears background color for <th> if ds neutral token is detected
        const ignored = nodeType === 'tableHeader' && background === $869d1810285fb07e$export$8cc2833b5b349a1e.get('light gray') || nodeType === 'tableCell' && background === $869d1810285fb07e$export$8cc2833b5b349a1e.get('white') || nodeType === 'tableHeader' && background.includes('--ds-background-neutral');
        if (ignored) attrs.style = '';
        else {
            const color = (0, $jR93G.isRgb)(background) && (0, $jR93G.rgbToHex)(background) ? (0, $jR93G.rgbToHex)(background) : background;
            /**
       * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
       * backgrounds persisted.
       *
       * This feature predates the introduction of dark mode.
       *
       * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
       *
       * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
       *
       * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
       * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
       * seperate attribute (data-cell-background), instead of the inline style.
       *
       * See the following document for more details on this behaviour
       * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
       */ const tokenColor = (0, $a3bbC.hexToEditorBackgroundPaletteRawValue)(color);
            if (tokenColor) attrs.style = `background-color: ${tokenColor};`;
            else // if we have a custom color, we need to check if we are in dark mode
            if ($869d1810285fb07e$var$getGlobalTheme().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
            attrs.style = `background-color: ${(0, $as9OS.getDarkModeLCHColor)(color)};`;
            else // if we are in light mode, we can just set the color
            attrs.style = `background-color: ${background};`;
            /**
       * Storing hex code in data-cell-background because
       *  we want to have DST token (css variable) or
       *  DST token value (value (hex code) of css variable) in
       *  inline style to correct render table cell background
       *  based on selected theme.
       * Currently we rely on background color hex code stored in
       *  inline style.
       * Because of that when we copy and paste table, we end up
       *  having DST token or DST token value in ADF instead of
       *  original hex code which we map to DST token.
       * So, introducing data-cell-background.
       * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
       */ if (color) attrs['data-cell-background'] = color;
            attrs.colorname = $869d1810285fb07e$export$219b7f492ad209f8.get(color);
        }
    }
    if (nodeType === 'tableHeader') attrs.class = $869d1810285fb07e$export$7b07d37d879c957f;
    else attrs.class = $869d1810285fb07e$export$69cb4c3f80383763;
    return attrs;
};
const $869d1810285fb07e$export$219b7f492ad209f8 = new Map();
const $869d1810285fb07e$export$95e9c925fbf01d1c = (0, $jR93G.hexToRgba)((0, $jR93G.N800), 0.12) || (0, $jR93G.N0);
const $869d1810285fb07e$export$8cc2833b5b349a1e = new Map();
[
    [
        (0, $jR93G.N0),
        'White'
    ],
    [
        (0, $jR93G.B50),
        'Light blue'
    ],
    [
        (0, $jR93G.T50),
        'Light teal'
    ],
    [
        (0, $jR93G.G50),
        'Light green'
    ],
    [
        (0, $jR93G.Y50),
        'Light yellow'
    ],
    [
        (0, $jR93G.R50),
        'Light red'
    ],
    [
        (0, $jR93G.P50),
        'Light purple'
    ],
    [
        (0, $jR93G.N20),
        'Light gray'
    ],
    [
        (0, $jR93G.B75),
        'Blue'
    ],
    [
        (0, $jR93G.T75),
        'Teal'
    ],
    [
        (0, $jR93G.G75),
        'Green'
    ],
    [
        (0, $jR93G.Y75),
        'Yellow'
    ],
    [
        (0, $jR93G.R75),
        'Red'
    ],
    [
        (0, $jR93G.P75),
        'Purple'
    ],
    [
        (0, $jR93G.N60),
        'Gray'
    ],
    [
        (0, $jR93G.B100),
        'Dark blue'
    ],
    [
        (0, $jR93G.T100),
        'Dark teal'
    ],
    [
        (0, $jR93G.G200),
        'Dark green'
    ],
    [
        (0, $jR93G.Y200),
        'Dark yellow'
    ],
    [
        (0, $jR93G.R100),
        'Dark red'
    ],
    [
        (0, $jR93G.P100),
        'Dark purple'
    ]
].forEach(([colorValue, colorName])=>{
    $869d1810285fb07e$export$219b7f492ad209f8.set(colorValue.toLowerCase(), colorName);
    $869d1810285fb07e$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
});
/**
 * @name table_node
 */ /**
 * @name table_row_node
 */ /**
 * @name table_cell_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name table_cell_node
 */ /**
 * @name table_header_node
 */ // TODO: Fix any, potential issue. ED-5048
const $869d1810285fb07e$var$createTableSpec = ()=>(0, $7XZYM.table)({
        parseDOM: [
            {
                tag: 'table',
                getAttrs: (node)=>{
                    var _dom$parentElement;
                    const dom = node;
                    const breakoutWrapper = (_dom$parentElement = dom.parentElement) === null || _dom$parentElement === void 0 ? void 0 : _dom$parentElement.parentElement;
                    return {
                        isNumberColumnEnabled: dom.getAttribute('data-number-column') === 'true',
                        layout: // copying from editor
                        dom.getAttribute('data-layout') || (breakoutWrapper === null || breakoutWrapper === void 0 ? void 0 : breakoutWrapper.getAttribute('data-layout')) || 'default',
                        __autoSize: dom.getAttribute('data-autosize') === 'true',
                        localId: dom.getAttribute('data-table-local-id') || (0, $lUXsh.uuid).generate(),
                        width: Number(dom.getAttribute('data-table-width')) || null,
                        displayMode: dom.getAttribute('data-table-display-mode') || null
                    };
                }
            }
        ],
        toDOM (node) {
            const attrs = {
                'data-number-column': node.attrs.isNumberColumnEnabled,
                'data-layout': node.attrs.layout,
                'data-autosize': node.attrs.__autoSize,
                'data-table-local-id': node.attrs.localId,
                'data-table-width': node.attrs.width,
                'data-table-display-mode': node.attrs.displayMode
            };
            return [
                'table',
                attrs,
                [
                    'tbody',
                    0
                ]
            ];
        }
    });
const $869d1810285fb07e$export$9852986a3ec5f6a0 = $869d1810285fb07e$var$createTableSpec();
const $869d1810285fb07e$export$90e634fbace1f0c4 = $869d1810285fb07e$var$createTableSpec();
const $869d1810285fb07e$export$3862de5c8c9098cf = $869d1810285fb07e$var$createTableSpec();
const $869d1810285fb07e$var$shouldIncludeAttribute = (key, value)=>!key.startsWith('__') && (key !== 'localId' || !!value);
const $869d1810285fb07e$export$1f92a2f429e06fa8 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>$869d1810285fb07e$var$shouldIncludeAttribute(key, node.attrs[key])).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });
const $869d1810285fb07e$export$ce666bf02318c957 = (0, $7XZYM.tableRow)({
    parseDOM: [
        {
            tag: 'tr'
        }
    ],
    toDOM () {
        return [
            'tr',
            0
        ];
    }
});
const $869d1810285fb07e$var$cellAttrs = {
    colspan: {
        default: 1
    },
    rowspan: {
        default: 1
    },
    colwidth: {
        default: null
    },
    background: {
        default: null
    }
};
const $869d1810285fb07e$export$e1e720e5f4603e6a = (0, $7XZYM.tableCell)({
    parseDOM: [
        // Ignore number cell copied from renderer
        {
            tag: '.ak-renderer-table-number-column',
            ignore: true
        },
        {
            tag: 'td',
            getAttrs: (dom)=>$869d1810285fb07e$export$43977bde391e007(dom)
        }
    ],
    toDOM: (node)=>[
            'td',
            $869d1810285fb07e$export$363c8dda799bfe9c(node),
            0
        ]
});
const $869d1810285fb07e$export$2ac34c099660f1a8 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if ($869d1810285fb07e$var$cellAttrs[key].default !== node.attrs[key]) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });
const $869d1810285fb07e$export$48884d2a5190dc73 = (0, $7XZYM.tableHeader)({
    parseDOM: [
        {
            tag: 'th',
            getAttrs: (dom)=>$869d1810285fb07e$export$43977bde391e007(dom, {
                    background: $869d1810285fb07e$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND
                })
        }
    ],
    toDOM: (node)=>[
            'th',
            $869d1810285fb07e$export$363c8dda799bfe9c(node),
            0
        ]
});
const $869d1810285fb07e$export$2af48797a1010bb1 = $869d1810285fb07e$export$2ac34c099660f1a8;

});

parcelRegister("ie5d6", function(module, exports) {

$parcel$export(module.exports, "taskItem", () => $d44d9373b8f163aa$export$6d8b0ef52e2e6390);

var $lUXsh = parcelRequire("lUXsh");

var $7XZYM = parcelRequire("7XZYM");
const $d44d9373b8f163aa$export$6d8b0ef52e2e6390 = (0, $7XZYM.taskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $lUXsh.uuid).generate(),
                    state: dom.getAttribute('data-task-state') || 'TODO'
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("7QozA", function(module, exports) {

$parcel$export(module.exports, "taskListSelector", () => $5b607363bfbaed7e$export$c0ec71adb7a18fb2);
$parcel$export(module.exports, "taskList", () => $5b607363bfbaed7e$export$375b6afcc5f4d291);

var $lUXsh = parcelRequire("lUXsh");

var $7XZYM = parcelRequire("7XZYM");
/**
 * @name taskList_node
 */ const $5b607363bfbaed7e$var$name = 'actionList';
const $5b607363bfbaed7e$export$c0ec71adb7a18fb2 = `[data-node-type="${$5b607363bfbaed7e$var$name}"]`;
const $5b607363bfbaed7e$export$375b6afcc5f4d291 = (0, $7XZYM.taskList)({
    parseDOM: [
        {
            tag: `div${$5b607363bfbaed7e$export$c0ec71adb7a18fb2}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $lUXsh.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $5b607363bfbaed7e$var$name,
            'data-task-list-local-id': localId || 'local-task-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("ltJuR", function(module, exports) {

$parcel$export(module.exports, "text", () => $fa2f9921fdf8b722$export$6f093cfa640b7166);

var $7XZYM = parcelRequire("7XZYM");
const $fa2f9921fdf8b722$export$6f093cfa640b7166 = (0, $7XZYM.text)({
    toDebugString: ()=>'text_node'
});

});

parcelRegister("4ne8H", function(module, exports) {

$parcel$export(module.exports, "default", () => $32f4472c0028f4d7$export$2e2bcd8739ae039);
const $32f4472c0028f4d7$var$name = 'unknownBlock';
var $32f4472c0028f4d7$export$2e2bcd8739ae039 = {
    group: 'block',
    content: 'inline+',
    marks: '_',
    toDOM () {
        return [
            'div',
            {
                'data-node-type': $32f4472c0028f4d7$var$name
            },
            0
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$32f4472c0028f4d7$var$name}"]`
        }
    ]
};

});

parcelRegister("7p32Z", function(module, exports) {

$parcel$export(module.exports, "unsupportedBlock", () => $563d3b506527dd26$export$44b79b0979d0f0f7);

var $7XZYM = parcelRequire("7XZYM");
const $563d3b506527dd26$export$44b79b0979d0f0f7 = (0, $7XZYM.unsupportedBlock)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedBlock"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedBlock',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    }
});

});

parcelRegister("8cuPa", function(module, exports) {

$parcel$export(module.exports, "unsupportedInline", () => $5f875acca3371d13$export$310ebe0d80122e9b);

var $7XZYM = parcelRequire("7XZYM");
const $5f875acca3371d13$export$310ebe0d80122e9b = (0, $7XZYM.unsupportedInline)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedInline"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedInline',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'span',
            attrs,
            'Unsupported content'
        ];
    }
});

});



parcelRegister("7Y6sw", function(module, exports) {

$parcel$export(module.exports, "defaultNodeComponents", () => $e41301324310ff6f$export$ee31295d51950741);
$parcel$export(module.exports, "default", () => $e41301324310ff6f$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $9wcjJ = parcelRequire("9wcjJ");

var $cBoJh = parcelRequire("cBoJh");

var $fLfen = parcelRequire("fLfen");
var $eQbJA = parcelRequire("eQbJA");

var $8lJ1v = parcelRequire("8lJ1v");
var $6zWLF = parcelRequire("6zWLF");
var $ghZO5 = parcelRequire("ghZO5");
var $4iaaT = parcelRequire("4iaaT");
var $a3eWT = parcelRequire("a3eWT");

var $jMQbs = parcelRequire("jMQbs");
var $cC72g = parcelRequire("cC72g");
var $h3qKx = parcelRequire("h3qKx");
var $dHwtf = parcelRequire("dHwtf");
var $f8mRM = parcelRequire("f8mRM");
var $5Fak9 = parcelRequire("5Fak9");
var $jwP4O = parcelRequire("jwP4O");

var $XHGTv = parcelRequire("XHGTv");

var $gL7tA = parcelRequire("gL7tA");

var $25FYC = parcelRequire("25FYC");

var $6PJBT = parcelRequire("6PJBT");

var $dcbVh = parcelRequire("dcbVh");

var $dFBS3 = parcelRequire("dFBS3");

var $lS7UL = parcelRequire("lS7UL");
var $15lMG = parcelRequire("15lMG");

var $9pV0l = parcelRequire("9pV0l");

var $eNyed = parcelRequire("eNyed");

var $auyn4 = parcelRequire("auyn4");

var $3rMck = parcelRequire("3rMck");

var $86Pbu = parcelRequire("86Pbu");

var $2dNsW = parcelRequire("2dNsW");

var $czPRi = parcelRequire("czPRi");

var $3y8r4 = parcelRequire("3y8r4");

var $fGrAu = parcelRequire("fGrAu");

var $51CHm = parcelRequire("51CHm");

var $1UbnR = parcelRequire("1UbnR");

var $9oaPg = parcelRequire("9oaPg");

var $irna0 = parcelRequire("irna0");

var $0jEfW = parcelRequire("0jEfW");

var $5iWql = parcelRequire("5iWql");

var $ks9LI = parcelRequire("ks9LI");

var $jgiTL = parcelRequire("jgiTL");

var $528fV = parcelRequire("528fV");

var $jzB8h = parcelRequire("jzB8h");
const $e41301324310ff6f$export$47b2879ca9bbf67a = 2000;
const $e41301324310ff6f$export$1b622068be977101 = 3000;
const $e41301324310ff6f$var$packageName = undefined;
const $e41301324310ff6f$var$packageVersion = undefined;
const $e41301324310ff6f$export$ee31295d51950741 = (0, $jzB8h.nodeToReact);
class $e41301324310ff6f$export$88530751e3977073 extends (0, $eUqFw.PureComponent) {
    constructor(props){
        super(props);
        /**
   * This is used in measuring the Renderer Mount time and is then
   * deleted once that measurement occurs.
   */ this.renderedMeasurementDistortedDurationMonitor = (0, $h3qKx.getDistortedDurationMonitor)();
        this.featureFlags = (0, $5iWql.default)((featureFlags)=>{
            const normalizedFeatureFlags = (0, $gL7tA.normalizeFeatureFlags)(featureFlags, {
                objectFlagKeys: [
                    'rendererRenderTracking'
                ]
            });
            return {
                featureFlags: normalizedFeatureFlags
            };
        });
        this.fireAnalyticsEvent = (event)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) {
                const channel = (0, $6PJBT.FabricChannel).editor;
                createAnalyticsEvent(event).fire(channel);
            }
        };
        this.getSchema = (0, $5iWql.default)((schema, adfStage)=>{
            if (schema) return schema;
            return (0, $9wcjJ.getSchemaBasedOnStage)(adfStage);
        });
        this.onMouseDownEditView = ()=>{
            // When the user is deselecting text on the screen by clicking, if they are clicking outside
            // the current selection, by the time the onclick handler is called the window.getSelection()
            // value will already be cleared.
            // The mousedown callback is called before the selection is cleared.
            const windowSelection = window.getSelection();
            this.mouseDownSelection = windowSelection !== null ? windowSelection.toString() : undefined;
        };
        this.handleMouseTripleClickInTables = (event)=>{
            if ((0, $jMQbs.default).ios || (0, $jMQbs.default).android) return;
            const badBrowser = (0, $jMQbs.default).chrome || (0, $jMQbs.default).safari;
            const tripleClick = event.detail >= 3;
            if (!(badBrowser && tripleClick)) return;
            const selection = window.getSelection();
            if (!selection) return;
            const { type: type, anchorNode: anchorNode, focusNode: focusNode } = selection;
            const rangeSelection = Boolean(type === 'Range' && anchorNode && focusNode);
            if (!rangeSelection) return;
            const target = event.target;
            const tableCell = target.closest('td,th');
            const clickedInCell = Boolean(tableCell);
            if (!clickedInCell) return;
            const anchorInCell = tableCell.contains(anchorNode);
            const focusInCell = tableCell.contains(focusNode);
            const selectionStartsOrEndsOutsideClickedCell = !(anchorInCell && focusInCell);
            if (!selectionStartsOrEndsOutsideClickedCell) return;
            // If selection starts or ends in a different cell than the clicked cell,
            // we select the node inside the clicked cell (or if both are in a different
            // cell, we select the cell's contents instead). We want to select the nearest
            // parent block, so that a whole line of text/content is selected (rather than
            // selecting a span that would select one specific chunk of text).
            const elementToSelect = anchorInCell ? anchorNode.parentElement?.closest('div,p') : focusInCell ? focusNode.parentElement?.closest('div,p') : tableCell;
            if (elementToSelect) selection.selectAllChildren(elementToSelect);
        };
        this.providerFactory = props.dataProviders || new (0, $fLfen.default)();
        this.serializer = new (0, $lS7UL.default)(this.deriveSerializerProps(props));
        this.editorRef = props.innerRef || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.id = (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))();
        (0, $jwP4O.startMeasure)(`Renderer Render Time: ${this.id}`);
        const featureFlags = this.featureFlags(this.props.featureFlags).featureFlags;
        if (featureFlags?.rendererTtiTracking) (0, $f8mRM.measureTTI)((tti, ttiFromInvocation, canceled)=>{
            this.fireAnalyticsEvent({
                action: (0, $auyn4.ACTION).RENDERER_TTI,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).RENDERER,
                attributes: {
                    tti: tti,
                    ttiFromInvocation: ttiFromInvocation,
                    canceled: canceled
                },
                eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
            });
        });
    }
    anchorLinkAnalytics() {
        const hash = window.location.hash && decodeURIComponent(window.location.hash.slice(1));
        const { disableHeadingIDs: disableHeadingIDs } = this.props;
        if (!disableHeadingIDs && hash && this.editorRef && this.editorRef.current instanceof HTMLElement) {
            const anchorLinkElement = document.getElementById(hash);
            // We are not use this.editorRef.querySelector here, instead we have this.editorRef.contains
            // because querySelector might fail if there are special characters in hash, and CSS.escape is still experimental.
            if (anchorLinkElement && this.editorRef.current.contains(anchorLinkElement)) this.fireAnalyticsEvent({
                action: (0, $auyn4.ACTION).VIEWED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).ANCHOR_LINK,
                attributes: {
                    platform: (0, $3rMck.PLATFORM).WEB,
                    mode: (0, $3rMck.MODE).RENDERER
                },
                eventType: (0, $auyn4.EVENT_TYPE).UI
            });
        }
    }
    componentDidMount() {
        this.fireAnalyticsEvent({
            action: (0, $auyn4.ACTION).STARTED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $3rMck.PLATFORM).WEB
            },
            eventType: (0, $auyn4.EVENT_TYPE).UI
        });
        this.rafID = requestAnimationFrame(()=>{
            (0, $jwP4O.stopMeasure)(`Renderer Render Time: ${this.id}`, (duration)=>{
                const { analyticsEventSeverityTracking: analyticsEventSeverityTracking } = this.props;
                const forceSeverityTracking = typeof analyticsEventSeverityTracking === 'undefined' && (0, $5Fak9.shouldForceTracking)();
                const severity = !!forceSeverityTracking || analyticsEventSeverityTracking?.enabled ? (0, $cC72g.getAnalyticsEventSeverity)(duration, analyticsEventSeverityTracking?.severityNormalThreshold ?? $e41301324310ff6f$export$47b2879ca9bbf67a, analyticsEventSeverityTracking?.severityDegradedThreshold ?? $e41301324310ff6f$export$1b622068be977101) : undefined;
                // ED-16320: Check for explicit disable so that by default
                // it will still be enabled as it currently is. Then we can
                // progressively opt out synthetic tenants.
                const isTTRTrackingExplicitlyDisabled = this.props?.analyticsEventSeverityTracking?.enabled === false;
                if (!isTTRTrackingExplicitlyDisabled) this.fireAnalyticsEvent({
                    action: (0, $auyn4.ACTION).RENDERED,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).RENDERER,
                    attributes: {
                        platform: (0, $3rMck.PLATFORM).WEB,
                        duration: duration,
                        distortedDuration: this.renderedMeasurementDistortedDurationMonitor.distortedDuration,
                        ttfb: (0, $dHwtf.getResponseEndTime)(),
                        nodes: (0, $cBoJh.reduce)(this.props.document, (acc, node)=>{
                            acc[node.type] = (acc[node.type] || 0) + 1;
                            return acc;
                        }, {}),
                        severity: severity
                    },
                    eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
                });
                this.renderedMeasurementDistortedDurationMonitor.cleanup();
                delete this.renderedMeasurementDistortedDurationMonitor;
            });
            this.anchorLinkAnalytics();
        });
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const nextMedia = nextProps.media || {};
        const media = this.props.media || {};
        if (nextProps.portal !== this.props.portal || nextProps.appearance !== this.props.appearance || nextProps.stickyHeaders !== this.props.stickyHeaders || nextProps.disableActions !== this.props.disableActions || nextProps.allowCustomPanels !== this.props.allowCustomPanels || nextProps.extensionHandlers !== this.props.extensionHandlers || nextProps.allowHeadingAnchorLinks !== this.props.allowHeadingAnchorLinks || nextMedia.allowLinking !== media.allowLinking) this.serializer = new (0, $lS7UL.default)(this.deriveSerializerProps(nextProps));
    }
    deriveSerializerProps(props) {
        // if just passed a boolean, change shape into object to simplify type
        const stickyHeaders = props.stickyHeaders ? props.stickyHeaders === true ? {} : props.stickyHeaders : undefined;
        const { annotationProvider: annotationProvider } = props;
        const allowAnnotationsDraftMode = Boolean(annotationProvider && annotationProvider.inlineComment && annotationProvider.inlineComment.allowDraftMode);
        const { featureFlags: featureFlags } = this.featureFlags(props.featureFlags);
        return {
            providers: this.providerFactory,
            eventHandlers: props.eventHandlers,
            extensionHandlers: props.extensionHandlers,
            portal: props.portal,
            objectContext: {
                adDoc: props.document,
                schema: props.schema,
                ...props.rendererContext
            },
            appearance: props.appearance,
            disableHeadingIDs: props.disableHeadingIDs,
            disableActions: props.disableActions,
            allowHeadingAnchorLinks: props.allowHeadingAnchorLinks,
            allowColumnSorting: props.allowColumnSorting,
            fireAnalyticsEvent: this.fireAnalyticsEvent,
            shouldOpenMediaViewer: props.shouldOpenMediaViewer,
            allowAltTextOnImages: props.allowAltTextOnImages,
            stickyHeaders: stickyHeaders,
            allowMediaLinking: props.media && props.media.allowLinking,
            surroundTextNodesWithTextWrapper: allowAnnotationsDraftMode,
            media: props.media,
            emojiResourceConfig: props.emojiResourceConfig,
            smartLinks: props.smartLinks,
            allowCopyToClipboard: props.allowCopyToClipboard,
            allowWrapCodeBlock: props.allowWrapCodeBlock,
            allowCustomPanels: props.allowCustomPanels,
            allowAnnotations: props.allowAnnotations,
            allowSelectAllTrap: props.allowSelectAllTrap,
            allowPlaceholderText: props.allowPlaceholderText,
            nodeComponents: props.nodeComponents,
            // does not currently support SSR, should not be enabled in environments where Renderer is SSR-ed
            allowWindowedCodeBlock: featureFlags?.allowWindowedCodeBlock,
            isInsideOfInlineExtension: (0, $XHGTv.getBooleanFF)('platform.editor.inline_extension.extended_lcqdn') && props.isInsideOfInlineExtension,
            textHighlighter: props.UNSTABLE_textHighlighter,
            isCommentsOnMediaMediaInlineBugFixEnabled: featureFlags?.commentsOnMediaMediaInlineBugFix
        };
    }
    render() {
        const { document: adfDocument, onComplete: onComplete, onError: onError, appearance: appearance, allowAnnotations: allowAnnotations, adfStage: adfStage, truncated: truncated, maxHeight: maxHeight, fadeOutHeight: fadeOutHeight, enableSsrInlineScripts: enableSsrInlineScripts, allowHeadingAnchorLinks: allowHeadingAnchorLinks, allowPlaceholderText: allowPlaceholderText, allowColumnSorting: allowColumnSorting, allowCopyToClipboard: allowCopyToClipboard, allowWrapCodeBlock: allowWrapCodeBlock, allowCustomPanels: allowCustomPanels, media: media } = this.props;
        const featureFlags = this.featureFlags(this.props.featureFlags);
        const allowNestedHeaderLinks = (0, $1UbnR.isNestedHeaderLinksEnabled)(allowHeadingAnchorLinks);
        /**
     * Handle clicks inside renderer. If the click isn't on media, in the media picker, or on a
     * link, call the onUnhandledClick eventHandler (which in Jira for example, may switch the
     * renderer out for the editor).
     * @param event Click event anywhere inside renderer
     */ const handleWrapperOnClick = (event)=>{
            const targetElement = event.target;
            // ED-14862: When a user triple clicks to select a line of content inside a
            // a table cell, but the browser incorrectly moves the selection start or end into
            // a different table cell, we manually set the selection back to within the original
            // table cell the user intended to target
            this.handleMouseTripleClickInTables(event);
            if (!this.props.eventHandlers?.onUnhandledClick) return;
            if (!(targetElement instanceof window.Element)) return;
            const rendererWrapper = event.currentTarget;
            // Check if the click was on an interactive element
            const isInteractiveElementInTree = (0, $9oaPg.findInTree)(targetElement, rendererWrapper, (0, $irna0.isInteractiveElement));
            if (isInteractiveElementInTree) return;
            // Ensure that selecting text in the renderer doesn't trigger onUnhandledClick
            // This logic originated in jira-frontend:
            // src/packages/issue/issue-view/src/views/field/rich-text/rich-text-inline-edit-view.js
            // The selection is required to be checked in `onMouseDown` and here. If not here, a new
            // selection isn't reported; if not in `onMouseDown`, a click outside the selection will
            // return an empty selection, which will erroneously fire onUnhandledClick.
            const windowSelection = window.getSelection();
            const selection = windowSelection !== null ? windowSelection.toString() : undefined;
            const hasSelection = selection && selection.length !== 0;
            const hasSelectionMouseDown = this.mouseDownSelection && this.mouseDownSelection.length !== 0;
            const allowEditBasedOnSelection = !hasSelection && !hasSelectionMouseDown;
            if (allowEditBasedOnSelection) this.props.eventHandlers.onUnhandledClick(event);
        };
        try {
            const schema = this.getSchema(this.props.schema, this.props.adfStage);
            const { result: result, stat: stat, pmDoc: pmDoc } = (0, $15lMG.renderDocument)(adfDocument, this.serializer, schema, adfStage, this.props.useSpecBasedValidator, this.id, this.fireAnalyticsEvent, this.props.unsupportedContentLevelsTracking, this.props.appearance);
            if (onComplete) onComplete(stat);
            const rendererOutput = /*#__PURE__*/ (0, $byn9U.jsx)((0, $0jEfW.RendererContextProvider), {
                value: featureFlags
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $fGrAu.ActiveHeaderIdProvider), {
                value: (0, $1UbnR.getActiveHeadingId)(allowHeadingAnchorLinks)
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $86Pbu.default).Provider, {
                value: {
                    fireAnalyticsEvent: (event)=>this.fireAnalyticsEvent(event)
                }
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $2dNsW.Provider), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $eQbJA.ProviderFactoryProvider), {
                value: this.providerFactory
            }, /*#__PURE__*/ (0, $byn9U.jsx)($e41301324310ff6f$var$RendererWrapper, {
                allowAnnotations: allowAnnotations,
                appearance: appearance,
                allowNestedHeaderLinks: allowNestedHeaderLinks,
                allowColumnSorting: allowColumnSorting,
                allowCopyToClipboard: allowCopyToClipboard,
                allowWrapCodeBlock: allowWrapCodeBlock,
                allowCustomPanels: allowCustomPanels,
                allowPlaceholderText: allowPlaceholderText,
                useBlockRenderForCodeBlock: featureFlags.featureFlags.useBlockRenderForCodeBlock ?? true,
                addTelepointer: this.props.addTelepointer,
                innerRef: this.editorRef,
                onClick: handleWrapperOnClick,
                onMouseDown: this.onMouseDownEditView,
                ssr: media?.ssr,
                isInsideOfInlineExtension: this.props.isInsideOfInlineExtension
            }, enableSsrInlineScripts ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $czPRi.BreakoutSSRInlineScript), null) : null, /*#__PURE__*/ (0, $byn9U.jsx)($e41301324310ff6f$var$RendererActionsInternalUpdater, {
                doc: pmDoc,
                schema: schema,
                onAnalyticsEvent: this.fireAnalyticsEvent
            }, result)))))));
            let rendererResult = truncated ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $eNyed.TruncatedWrapper), {
                height: maxHeight,
                fadeHeight: fadeOutHeight
            }, rendererOutput) : rendererOutput;
            const rendererRenderTracking = featureFlags?.featureFlags?.rendererRenderTracking?.[(0, $auyn4.ACTION_SUBJECT).RENDERER];
            const reRenderTracking = rendererRenderTracking?.enabled && /*#__PURE__*/ (0, $byn9U.jsx)((0, $jgiTL.RenderTracking), {
                componentProps: this.props,
                action: (0, $auyn4.ACTION).RE_RENDERED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).RENDERER,
                handleAnalyticsEvent: this.fireAnalyticsEvent,
                useShallow: rendererRenderTracking.useShallow
            });
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, reRenderTracking, rendererResult);
        } catch (e) {
            if (onError) onError(e);
            return /*#__PURE__*/ (0, $byn9U.jsx)($e41301324310ff6f$var$RendererWrapper, {
                allowAnnotations: allowAnnotations,
                appearance: appearance,
                allowCopyToClipboard: allowCopyToClipboard,
                allowWrapCodeBlock: allowWrapCodeBlock,
                allowPlaceholderText: allowPlaceholderText,
                allowColumnSorting: allowColumnSorting,
                allowNestedHeaderLinks: allowNestedHeaderLinks,
                useBlockRenderForCodeBlock: featureFlags.featureFlags.useBlockRenderForCodeBlock ?? true,
                addTelepointer: this.props.addTelepointer,
                onClick: handleWrapperOnClick
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $ghZO5.default), null));
        }
    }
    componentWillUnmount() {
        const { dataProviders: dataProviders } = this.props;
        if (this.rafID) window.cancelAnimationFrame(this.rafID);
        // if this is the ProviderFactory which was created in constructor
        // it's safe to destroy it on Renderer unmount
        if (!dataProviders) this.providerFactory.destroy();
    }
}
const $e41301324310ff6f$export$af81ffb59b6ef0dd = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo((props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $dcbVh.FabricEditorAnalyticsContext), {
        data: {
            appearance: (0, $cC72g.getAnalyticsAppearance)(props.appearance),
            packageName: $e41301324310ff6f$var$packageName,
            packageVersion: $e41301324310ff6f$var$packageVersion,
            componentName: 'renderer',
            editorSessionId: (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))()
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $a3eWT.WithCreateAnalyticsEvent), {
        render: (createAnalyticsEvent)=>{
            // `IntlErrorBoundary` only captures Internationalisation errors, leaving others for `ErrorBoundary`.
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $ks9LI.ErrorBoundary), {
                component: (0, $auyn4.ACTION_SUBJECT).RENDERER,
                rethrowError: true,
                fallbackComponent: null,
                createAnalyticsEvent: createAnalyticsEvent
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $6zWLF.IntlErrorBoundary), null, /*#__PURE__*/ (0, $byn9U.jsx)($e41301324310ff6f$export$88530751e3977073, {
                ...props,
                createAnalyticsEvent: createAnalyticsEvent
            })));
        }
    })));
const $e41301324310ff6f$var$RendererWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo((props)=>{
    const { allowColumnSorting: allowColumnSorting, allowNestedHeaderLinks: allowNestedHeaderLinks, innerRef: innerRef, appearance: appearance, children: children, onClick: onClick, onMouseDown: onMouseDown, useBlockRenderForCodeBlock: useBlockRenderForCodeBlock, addTelepointer: addTelepointer, ssr: ssr, isInsideOfInlineExtension: isInsideOfInlineExtension } = props;
    const createTelepointer = ()=>{
        const telepointer = document.createElement('span');
        telepointer.textContent = '\u200b';
        telepointer.id = (0, $9pV0l.TELEPOINTER_ID);
        return telepointer;
    };
    const initialUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(true);
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        // We must check if window is defined, if it isn't we are in a SSR environment
        // and we don't want to add the telepointer
        if (typeof window !== 'undefined' && addTelepointer && innerRef?.current) {
            const renderer = innerRef.current.querySelector('.ak-renderer-document');
            if (initialUpdate.current) {
                const lastChild = renderer.lastChild;
                lastChild && lastChild.appendChild(createTelepointer());
            }
            const mutateTelepointer = (mutations)=>{
                mutations.forEach((mutation)=>{
                    if (initialUpdate.current) {
                        const oldTelepointer = renderer.querySelector(`#${(0, $9pV0l.TELEPOINTER_ID)}`);
                        if (oldTelepointer) oldTelepointer.remove();
                        const lastChild = renderer.lastChild;
                        lastChild && lastChild.appendChild(createTelepointer());
                        initialUpdate.current = false;
                    }
                    if (mutation.type === 'characterData') {
                        const parentNode = mutation.target.parentElement;
                        if (parentNode) {
                            const oldTelepointer = renderer.querySelector(`#${(0, $9pV0l.TELEPOINTER_ID)}`);
                            if (oldTelepointer) oldTelepointer.remove();
                            parentNode.appendChild(createTelepointer());
                        }
                    }
                });
            };
            const observer = new MutationObserver(mutateTelepointer);
            observer.observe(innerRef.current, {
                characterData: true,
                attributes: false,
                childList: true,
                subtree: true
            });
            return ()=>observer.disconnect();
        }
    }, [
        innerRef,
        addTelepointer
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $4iaaT.WidthProvider), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `ak-renderer-wrapper is-${appearance}`,
        "data-appearance": appearance,
        shouldCheckExistingValue: (0, $XHGTv.getBooleanFF)('platform.editor.inline_extension.extended_lcqdn') && isInsideOfInlineExtension
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8lJ1v.BaseTheme), {
        baseFontSize: appearance && appearance !== 'comment' ? (0, $25FYC.akEditorFullPageDefaultFontSize) : undefined
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $528fV.EditorMediaClientProvider), {
        ssr: ssr
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: innerRef,
        onClick: onClick,
        onMouseDown: onMouseDown,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $9pV0l.rendererStyles)({
            appearance: appearance,
            allowNestedHeaderLinks: allowNestedHeaderLinks,
            allowColumnSorting: !!allowColumnSorting,
            useBlockRenderForCodeBlock: useBlockRenderForCodeBlock,
            allowAnnotations: props.allowAnnotations
        })
    }, children))));
});
function $e41301324310ff6f$var$RendererActionsInternalUpdater({ children: children, doc: doc, schema: schema, onAnalyticsEvent: onAnalyticsEvent }) {
    const actions = (0, $eUqFw.useContext)((0, $3y8r4.RendererContext));
    const rendererRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (doc) actions._privateRegisterRenderer(rendererRef, doc, schema, onAnalyticsEvent);
        else actions._privateUnregisterRenderer();
        return ()=>actions._privateUnregisterRenderer();
    }, [
        actions,
        schema,
        doc,
        onAnalyticsEvent
    ]);
    return children;
}
const $e41301324310ff6f$var$RendererWithAnnotationSelection = (props)=>{
    const { allowAnnotations: allowAnnotations, document: adfDocument } = props;
    const localRef = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(null);
    const innerRef = props.innerRef || localRef;
    if (!allowAnnotations) return /*#__PURE__*/ (0, $byn9U.jsx)($e41301324310ff6f$export$af81ffb59b6ef0dd, {
        innerRef: innerRef,
        ...props
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $3y8r4.RendererActionsContext), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $51CHm.AnnotationsWrapper), {
        rendererRef: innerRef,
        adfDocument: adfDocument,
        annotationProvider: props.annotationProvider,
        isNestedRender: true
    }, /*#__PURE__*/ (0, $byn9U.jsx)($e41301324310ff6f$export$af81ffb59b6ef0dd, {
        innerRef: innerRef,
        ...props,
        featureFlags: props.featureFlags
    })));
};
var /* @deprecated using this version of the renderer causes the RendererActions to inaccessible from any consumers */ $e41301324310ff6f$export$2e2bcd8739ae039 = $e41301324310ff6f$var$RendererWithAnnotationSelection;

});
parcelRegister("cBoJh", function(module, exports) {

$parcel$export(module.exports, "reduce", () => $20fd485d301fa5b8$export$533b26079ad0b4b);

var $hYZXM = parcelRequire("hYZXM");
function $20fd485d301fa5b8$export$533b26079ad0b4b(adf, callback, initial) {
    let result = initial;
    (0, $hYZXM.traverse)(adf, {
        any: (node)=>{
            result = callback(result, node);
        }
    });
    return result;
}

});

parcelRegister("fLfen", function(module, exports) {

$parcel$export(module.exports, "default", () => $b31a16c45fbc6a54$export$2e2bcd8739ae039);
function $b31a16c45fbc6a54$var$isUndefined(x) {
    return x === undefined;
}
class $b31a16c45fbc6a54$export$2e2bcd8739ae039 {
    static create(providers) {
        const providerFactory = new $b31a16c45fbc6a54$export$2e2bcd8739ae039();
        const keys = Object.keys(providers);
        keys.forEach((name)=>{
            providerFactory.setProvider(name, providers[name]);
        });
        return providerFactory;
    }
    destroy() {
        this.providers.clear();
        this.subscribers.clear();
    }
    isEmpty() {
        return !this.providers.size && !this.subscribers.size;
    }
    setProvider(name, provider) {
        // Do not trigger notifyUpdate if provider is the same.
        if (this.providers.get(name) === provider) return;
        if (!$b31a16c45fbc6a54$var$isUndefined(provider)) this.providers.set(name, provider);
        else this.providers.delete(name);
        this.notifyUpdated(name, provider);
    }
    removeProvider(name) {
        this.providers.delete(name);
        this.notifyUpdated(name);
    }
    subscribe(name, handler) {
        const handlers = this.subscribers.get(name) || [];
        handlers.push(handler);
        this.subscribers.set(name, handlers);
        const provider = this.providers.get(name);
        if (provider) handler(name, provider);
    }
    unsubscribe(name, handler) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        const index = handlers.indexOf(handler);
        if (index !== -1) handlers.splice(index, 1);
        if (handlers.length === 0) this.subscribers.delete(name);
        else this.subscribers.set(name, handlers);
    }
    unsubscribeAll(name) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        this.subscribers.delete(name);
    }
    hasProvider(name) {
        return this.providers.has(name);
    }
    notifyUpdated(name, provider) {
        const handlers = this.subscribers.get(name);
        if (!handlers) return;
        handlers.forEach((handler)=>{
            handler(name, provider);
        });
    }
    constructor(){
        this.providers = new Map();
        this.subscribers = new Map();
    }
}

});

parcelRegister("eQbJA", function(module, exports) {

$parcel$export(module.exports, "ProviderFactoryProvider", () => $c43429769ae35a0a$export$617c134b25cc4265);
$parcel$export(module.exports, "useProvider", () => $c43429769ae35a0a$export$693cdb10cec23617);

var $eUqFw = parcelRequire("eUqFw");

var $fLfen = parcelRequire("fLfen");
const $c43429769ae35a0a$var$ProviderFactoryContext = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(new (0, $fLfen.default)());
const $c43429769ae35a0a$export$617c134b25cc4265 = $c43429769ae35a0a$var$ProviderFactoryContext.Provider;
const $c43429769ae35a0a$export$a3af4b6980aa23b5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext($c43429769ae35a0a$var$ProviderFactoryContext);
const $c43429769ae35a0a$export$693cdb10cec23617 = (name)=>{
    const [provider, setProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState();
    const providerFactory = $c43429769ae35a0a$export$a3af4b6980aa23b5();
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        const providerHandler = (_, provider)=>{
            setProvider(provider);
        };
        providerFactory.subscribe(name, providerHandler);
        return ()=>{
            providerFactory.unsubscribe(name, providerHandler);
        };
    }, [
        name,
        providerFactory
    ]);
    return provider;
};

});

parcelRegister("8lJ1v", function(module, exports) {

$parcel$export(module.exports, "mapBreakpointToLayoutMaxWidth", () => $18ee109913827a1b$export$b5ccf4d25d2c5af1);
$parcel$export(module.exports, "BaseTheme", () => $18ee109913827a1b$export$a1a213d350ca51ca);

var $eUqFw = parcelRequire("eUqFw");

var $4WmDP = parcelRequire("4WmDP");

var $25FYC = parcelRequire("25FYC");

var $lcnyw = parcelRequire("lcnyw");

var $4iaaT = parcelRequire("4iaaT");
function $18ee109913827a1b$export$b5ccf4d25d2c5af1(breakpoint) {
    switch(breakpoint){
        case 'M':
        case 'L':
            return 760;
        default:
            return 680;
    }
}
function $18ee109913827a1b$export$3de34996b814f0f0({ baseFontSize: baseFontSize, children: children }) {
    const memoizedTheme = (0, $eUqFw.useMemo)(()=>({
            baseFontSize: baseFontSize || (0, $lcnyw.fontSize)(),
            layoutMaxWidth: (0, $25FYC.akEditorDefaultLayoutWidth)
        }), [
        baseFontSize
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4WmDP.a), {
        theme: memoizedTheme
    }, children);
}
function $18ee109913827a1b$export$a1a213d350ca51ca({ children: children, baseFontSize: baseFontSize }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4iaaT.WidthConsumer), null, ({ breakpoint: breakpoint })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($18ee109913827a1b$export$3de34996b814f0f0, {
            breakpoint: breakpoint,
            baseFontSize: baseFontSize
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children)));
}

});
parcelRegister("25FYC", function(module, exports) {

$parcel$export(module.exports, "akEditorFullPageDefaultFontSize", () => $823f29f46e51fd3b$export$fe6b0b821a0e9067);
$parcel$export(module.exports, "akEditorCodeFontFamily", () => $823f29f46e51fd3b$export$9a7c520c39e1f0aa);
$parcel$export(module.exports, "akEditorSubtleAccent", () => $823f29f46e51fd3b$export$1d762aef048d30f9);
$parcel$export(module.exports, "akEditorBlockquoteBorderColor", () => $823f29f46e51fd3b$export$a7a75e50ae62d0a8);
$parcel$export(module.exports, "akEditorDeleteBackground", () => $823f29f46e51fd3b$export$ef95eb6ef0fd0a4a);
$parcel$export(module.exports, "akEditorDeleteBackgroundWithOpacity", () => $823f29f46e51fd3b$export$8f7d2d784079e274);
$parcel$export(module.exports, "akEditorDeleteBorder", () => $823f29f46e51fd3b$export$3c108a6bc41bb5f2);
$parcel$export(module.exports, "akEditorDeleteIconColor", () => $823f29f46e51fd3b$export$bf3aaa2106c119fd);
$parcel$export(module.exports, "akEditorCustomIconSize", () => $823f29f46e51fd3b$export$d2715266dd4a1fd1);
$parcel$export(module.exports, "akEditorSelectedBorderColor", () => $823f29f46e51fd3b$export$cf524c1b49838a49);
$parcel$export(module.exports, "akEditorSelectedBgColor", () => $823f29f46e51fd3b$export$ef597e2e80767649);
$parcel$export(module.exports, "akEditorSelectedBorderSize", () => $823f29f46e51fd3b$export$8dac549e32469ac4);
$parcel$export(module.exports, "akEditorSelectedBorder", () => $823f29f46e51fd3b$export$6e1e1996c4e8cc51);
$parcel$export(module.exports, "akEditorSelectedBoxShadow", () => $823f29f46e51fd3b$export$b6a59ac3a19b6343);
$parcel$export(module.exports, "akEditorSelectedBorderBoldSize", () => $823f29f46e51fd3b$export$befaaae517e3d864);
$parcel$export(module.exports, "akEditorUnitZIndex", () => $823f29f46e51fd3b$export$f35cc48f3398ab79);
$parcel$export(module.exports, "akEditorShadowZIndex", () => $823f29f46e51fd3b$export$b46cda584c619451);
$parcel$export(module.exports, "akEditorStickyHeaderZIndex", () => $823f29f46e51fd3b$export$6bed85de54b5de42);
$parcel$export(module.exports, "akEditorSmallZIndex", () => $823f29f46e51fd3b$export$321ddd2f049dd12);
$parcel$export(module.exports, "akEditorGridLineZIndex", () => $823f29f46e51fd3b$export$daeac9b8422ac3c2);
$parcel$export(module.exports, "akEditorMenuZIndex", () => $823f29f46e51fd3b$export$501d46e11ed5bf73);
$parcel$export(module.exports, "akEditorFloatingPanelZIndex", () => $823f29f46e51fd3b$export$6817b4b6a5ef78f1);
$parcel$export(module.exports, "akEditorFloatingDialogZIndex", () => $823f29f46e51fd3b$export$93768eb72dec48ce);
$parcel$export(module.exports, "akEditorTableCellOnStickyHeaderZIndex", () => $823f29f46e51fd3b$export$c0aec4e0896849a0);
$parcel$export(module.exports, "akEditorFloatingOverlapPanelZIndex", () => $823f29f46e51fd3b$export$5886f057e4f21fe4);
$parcel$export(module.exports, "akEditorTableToolbarSize", () => $823f29f46e51fd3b$export$6e85faa46d537a3f);
$parcel$export(module.exports, "akEditorTableBorder", () => $823f29f46e51fd3b$export$36ba77fba4a62d5f);
$parcel$export(module.exports, "akEditorTableToolbar", () => $823f29f46e51fd3b$export$640eef769748f78f);
$parcel$export(module.exports, "akEditorTableHeaderCellBackground", () => $823f29f46e51fd3b$export$4c6f61fb4b9ae93);
$parcel$export(module.exports, "akEditorTableBorderSelected", () => $823f29f46e51fd3b$export$f7bbcec54ff5bc47);
$parcel$export(module.exports, "akEditorFullPageMaxWidth", () => $823f29f46e51fd3b$export$fad19f16d3f953a3);
$parcel$export(module.exports, "akEditorDefaultLayoutWidth", () => $823f29f46e51fd3b$export$9db045950eedb49f);
$parcel$export(module.exports, "akEditorWideLayoutWidth", () => $823f29f46e51fd3b$export$74c442132af16a);
$parcel$export(module.exports, "akEditorFullWidthLayoutWidth", () => $823f29f46e51fd3b$export$f580e3d28d0986de);
$parcel$export(module.exports, "akEditorTableNumberColumnWidth", () => $823f29f46e51fd3b$export$37df10057d36a0e5);
$parcel$export(module.exports, "akEditorBreakoutPadding", () => $823f29f46e51fd3b$export$437293c5e9fc2703);
$parcel$export(module.exports, "akEditorGutterPaddingDynamic", () => $823f29f46e51fd3b$export$f222e0c7a2dc5324);
$parcel$export(module.exports, "akEditorMobileBreakoutPoint", () => $823f29f46e51fd3b$export$efe8561bbd3f74d2);
$parcel$export(module.exports, "akEditorTableCellMinWidth", () => $823f29f46e51fd3b$export$e4d39a9e8607c1d3);
$parcel$export(module.exports, "akEditorTableLegacyCellMinWidth", () => $823f29f46e51fd3b$export$43946f2400ab6f1f);
$parcel$export(module.exports, "akEditorMediaResizeHandlerPaddingWide", () => $823f29f46e51fd3b$export$558438ae7fd4b8ce);
$parcel$export(module.exports, "akEditorMediaResizeHandlerPadding", () => $823f29f46e51fd3b$export$6beb98d32d4ca149);
$parcel$export(module.exports, "akEditorSwoopCubicBezier", () => $823f29f46e51fd3b$export$3b24948cd5dbb087);
$parcel$export(module.exports, "gridMediumMaxWidth", () => $823f29f46e51fd3b$export$5edb4f38c3eacb1a);
$parcel$export(module.exports, "breakoutWideScaleRatio", () => $823f29f46e51fd3b$export$e60820063058ed59);
$parcel$export(module.exports, "akEditorCalculatedWideLayoutWidth", () => $823f29f46e51fd3b$export$c0e6648ae1bb2fac);
$parcel$export(module.exports, "akRichMediaResizeZIndex", () => $823f29f46e51fd3b$export$fb15fade89f67217);
$parcel$export(module.exports, "akLayoutGutterOffset", () => $823f29f46e51fd3b$export$847030921e9d5a40);
$parcel$export(module.exports, "akEditorLineHeight", () => $823f29f46e51fd3b$export$40eb41ab799f0329);
$parcel$export(module.exports, "akEditorToolbarKeylineHeight", () => $823f29f46e51fd3b$export$d29cb2c31fcbb7c5);
$parcel$export(module.exports, "akEditorContextPanelWidth", () => $823f29f46e51fd3b$export$688a6dc01e760755);
$parcel$export(module.exports, "akEditorTableCellBlanketSelected", () => $823f29f46e51fd3b$export$e736f2caf3b39eb3);
$parcel$export(module.exports, "akEditorTableCellBlanketDeleted", () => $823f29f46e51fd3b$export$de3cef07cda55645);
$parcel$export(module.exports, "blockNodesVerticalMargin", () => $823f29f46e51fd3b$export$1d0d506416d457f1);
$parcel$export(module.exports, "DEFAULT_EMBED_CARD_WIDTH", () => $823f29f46e51fd3b$export$e683ef42725d1713);
$parcel$export(module.exports, "DEFAULT_EMBED_CARD_HEIGHT", () => $823f29f46e51fd3b$export$226c784ba04bd04b);
$parcel$export(module.exports, "MAX_BROWSER_SCROLLBAR_HEIGHT", () => $823f29f46e51fd3b$export$214ff00e5618d86c);
$parcel$export(module.exports, "FULL_PAGE_EDITOR_TOOLBAR_HEIGHT", () => $823f29f46e51fd3b$export$d7726a000ae2d7c);
$parcel$export(module.exports, "akEditorSelectedNodeClassName", () => $823f29f46e51fd3b$export$a02a3f1515c2e21a);
$parcel$export(module.exports, "editorFontSize", () => $823f29f46e51fd3b$export$58a725ff69bda73a);
$parcel$export(module.exports, "relativeFontSizeToBase16", () => $823f29f46e51fd3b$export$59733a9f61449b25);
$parcel$export(module.exports, "akEditorMobileMaxWidth", () => $823f29f46e51fd3b$export$9369fd010fa0ddd6);
$parcel$export(module.exports, "avatarColors", () => $823f29f46e51fd3b$export$312e1e71424c4aa1);

var $XHGTv = parcelRequire("XHGTv");

var $PdmhA = parcelRequire("PdmhA");

var $lcnyw = parcelRequire("lcnyw");
const $823f29f46e51fd3b$export$fe6b0b821a0e9067 = 16;
const $823f29f46e51fd3b$export$9a7c520c39e1f0aa = (0, $lcnyw.codeFontFamily)();
const $823f29f46e51fd3b$export$e314d58809da911b = (0, $PdmhA.N500);
const $823f29f46e51fd3b$export$9a3076d23c153d92 = (0, $PdmhA.B100);
const $823f29f46e51fd3b$export$1d762aef048d30f9 = (0, $PdmhA.N40);
const $823f29f46e51fd3b$export$46f75d2f1d59b188 = (0, $PdmhA.N500);
const $823f29f46e51fd3b$export$c997cfdaffb4d6e6 = (0, $PdmhA.N0);
const $823f29f46e51fd3b$export$a7a75e50ae62d0a8 = (0, $PdmhA.N40);
const $823f29f46e51fd3b$export$e549ee8be3e2f59f = (0, $PdmhA.N900);
const $823f29f46e51fd3b$export$781884c8fda242b6 = (0, $PdmhA.N700);
const $823f29f46e51fd3b$export$a9a8b3b91667afe1 = (0, $PdmhA.B50);
const $823f29f46e51fd3b$export$5e112b63e4291515 = (0, $PdmhA.B400);
const $823f29f46e51fd3b$export$b9864494c2608629 = (0, $PdmhA.N20);
const $823f29f46e51fd3b$export$f0e953d95429ca1 = '12px';
const $823f29f46e51fd3b$export$a309dbdeca0adb1a = '2px 4px';
const $823f29f46e51fd3b$export$ef95eb6ef0fd0a4a = (0, $PdmhA.R50);
const $823f29f46e51fd3b$export$886b94e7e5d244bf = (0, $PdmhA.R50);
const $823f29f46e51fd3b$export$8f7d2d784079e274 = 'rgba(255, 189, 173, 0.5)'; // R75 with 50% opacity
const $823f29f46e51fd3b$export$3c108a6bc41bb5f2 = (0, $PdmhA.R300);
const $823f29f46e51fd3b$export$bf3aaa2106c119fd = (0, $PdmhA.R400);
const $823f29f46e51fd3b$export$d2715266dd4a1fd1 = 20;
const $823f29f46e51fd3b$export$cf524c1b49838a49 = (0, $PdmhA.B300);
const $823f29f46e51fd3b$export$ef597e2e80767649 = (0, $PdmhA.B50);
const $823f29f46e51fd3b$export$514e6c370fbea91d = (0, $PdmhA.B75);
const $823f29f46e51fd3b$export$8dac549e32469ac4 = 1;
const $823f29f46e51fd3b$export$6e1e1996c4e8cc51 = `${$823f29f46e51fd3b$export$8dac549e32469ac4}px solid ${`var(--ds-border-selected, ${$823f29f46e51fd3b$export$cf524c1b49838a49})`}`;
const $823f29f46e51fd3b$export$b6a59ac3a19b6343 = `0 0 0 ${$823f29f46e51fd3b$export$8dac549e32469ac4}px ${`var(--ds-border-selected, ${$823f29f46e51fd3b$export$cf524c1b49838a49})`}`;
const $823f29f46e51fd3b$export$ecb17e3df162de53 = (0, $PdmhA.B400);
const $823f29f46e51fd3b$export$befaaae517e3d864 = 2;
const $823f29f46e51fd3b$export$4a007c22e25e31f6 = 0.3;
const $823f29f46e51fd3b$export$f35cc48f3398ab79 = 1;
const $823f29f46e51fd3b$export$b46cda584c619451 = 2;
const $823f29f46e51fd3b$export$6bed85de54b5de42 = 11; // filmstrip uses 10 for its shadow
const $823f29f46e51fd3b$export$321ddd2f049dd12 = $823f29f46e51fd3b$export$6bed85de54b5de42 + 1;
const $823f29f46e51fd3b$export$daeac9b8422ac3c2 = 1;
const $823f29f46e51fd3b$export$501d46e11ed5bf73 = (0, $lcnyw.layers).blanket();
const $823f29f46e51fd3b$export$6817b4b6a5ef78f1 = (0, $lcnyw.layers).layer();
const $823f29f46e51fd3b$export$93768eb72dec48ce = $823f29f46e51fd3b$export$501d46e11ed5bf73 + 10;
const $823f29f46e51fd3b$export$c0aec4e0896849a0 = $823f29f46e51fd3b$export$93768eb72dec48ce - 5;
const $823f29f46e51fd3b$export$5886f057e4f21fe4 = $823f29f46e51fd3b$export$6817b4b6a5ef78f1 + 5;
const $823f29f46e51fd3b$export$11965a0dc12e6cd6 = (0, $PdmhA.N100);
const $823f29f46e51fd3b$export$6e85faa46d537a3f = 11;
const $823f29f46e51fd3b$export$36ba77fba4a62d5f = (0, $PdmhA.N50);
const $823f29f46e51fd3b$export$a21078fd4649993b = (0, $PdmhA.DN70);
const $823f29f46e51fd3b$export$640eef769748f78f = (0, $PdmhA.N20);
const $823f29f46e51fd3b$export$d72825c6f006826c = (0, $PdmhA.DN50);
const $823f29f46e51fd3b$export$154c32a542db7927 = (0, $PdmhA.N20);
const $823f29f46e51fd3b$export$58aee55ecb41eac9 = (0, $PdmhA.B75);
const $823f29f46e51fd3b$export$4c6f61fb4b9ae93 = '#F1F2F4';
const $823f29f46e51fd3b$export$95e9a0285b97474d = '#2C333A';
const $823f29f46e51fd3b$export$b098fbeedf0e901d = (0, $PdmhA.B100);
const $823f29f46e51fd3b$export$f7bbcec54ff5bc47 = (0, $PdmhA.B300);
const $823f29f46e51fd3b$export$7db8b54b38e7e92 = (0, $PdmhA.R50);
const $823f29f46e51fd3b$export$bee03689367106ff = (0, $PdmhA.R300);
const $823f29f46e51fd3b$export$f36ab9d2ae35c3cf = (0, $PdmhA.R75);
const $823f29f46e51fd3b$export$76b5e653883e5290 = '3px';
const $823f29f46e51fd3b$export$6d85fe8177a50c0c = 0.5;
const $823f29f46e51fd3b$export$fad19f16d3f953a3 = 680;
const $823f29f46e51fd3b$export$9db045950eedb49f = 760;
const $823f29f46e51fd3b$export$74c442132af16a = 960; // This value is used for tables with breakouts and is used to calculate `breakoutWidthPx`
const $823f29f46e51fd3b$export$f580e3d28d0986de = 1800;
const $823f29f46e51fd3b$export$9d5488b5afad62bf = 1792;
const $823f29f46e51fd3b$export$37df10057d36a0e5 = 42;
const $823f29f46e51fd3b$export$437293c5e9fc2703 = 96;
const $823f29f46e51fd3b$export$6e0f4d52efd3d2d = 32;
const $823f29f46e51fd3b$export$f222e0c7a2dc5324 = ()=>(0, $XHGTv.getBooleanFF)('platform.editor.core.increase-full-page-guttering') ? 52 : 32;
const $823f29f46e51fd3b$export$efe8561bbd3f74d2 = 720;
const $823f29f46e51fd3b$export$e4d39a9e8607c1d3 = 48;
const $823f29f46e51fd3b$export$43946f2400ab6f1f = 128;
const $823f29f46e51fd3b$export$558438ae7fd4b8ce = 12;
const $823f29f46e51fd3b$export$6beb98d32d4ca149 = 4;
const $823f29f46e51fd3b$export$3b24948cd5dbb087 = `cubic-bezier(0.15, 1, 0.3, 1)`;
const $823f29f46e51fd3b$export$5edb4f38c3eacb1a = 1024;
const $823f29f46e51fd3b$export$e60820063058ed59 = 1.33;
const $823f29f46e51fd3b$export$c0e6648ae1bb2fac = 1011; // = akEditorDefaultLayoutWidth * breakoutWideScaleRatio = 1010.8 ~ 1011 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is > 1329px.
const $823f29f46e51fd3b$export$fb15fade89f67217 = $823f29f46e51fd3b$export$f35cc48f3398ab79 * 99;
const $823f29f46e51fd3b$export$847030921e9d5a40 = (0, $lcnyw.gridSize)() * 1.5;
const $823f29f46e51fd3b$export$40eb41ab799f0329 = 1.714;
const $823f29f46e51fd3b$export$c36b615598bb9f62 = (0, $PdmhA.N30);
const $823f29f46e51fd3b$export$e271312fc7124aec = '1px';
const $823f29f46e51fd3b$export$d29cb2c31fcbb7c5 = 2;
const $823f29f46e51fd3b$export$688a6dc01e760755 = 320;
const $823f29f46e51fd3b$export$e736f2caf3b39eb3 = 'rgba(179, 212, 255, 0.3)';
const $823f29f46e51fd3b$export$de3cef07cda55645 = 'rgba(255, 235, 230, 0.3)';
const $823f29f46e51fd3b$export$1d0d506416d457f1 = '0.75rem';
const $823f29f46e51fd3b$export$e683ef42725d1713 = 680;
const $823f29f46e51fd3b$export$226c784ba04bd04b = 480;
const $823f29f46e51fd3b$export$214ff00e5618d86c = 20;
const $823f29f46e51fd3b$export$c82675fa56f2eefd = '56px';
const $823f29f46e51fd3b$export$d7726a000ae2d7c = ()=>(0, $XHGTv.getBooleanFF)('platform.confluence.frontend.narrow-full-page-editor-toolbar') ? "var(--ds-space-500, 40px)" : '56px';
const $823f29f46e51fd3b$export$a02a3f1515c2e21a = 'ak-editor-selected-node';
const $823f29f46e51fd3b$export$58a725ff69bda73a = ({ theme: theme })=>theme && theme.baseFontSize ? theme.baseFontSize : (0, $lcnyw.fontSize)();
const $823f29f46e51fd3b$export$945a9e125632354d = (multiplier)=>({ theme: theme })=>$823f29f46e51fd3b$export$58a725ff69bda73a({
            theme: theme
        }) * multiplier;
const $823f29f46e51fd3b$export$59733a9f61449b25 = (px)=>{
    if (typeof px === 'string') px = parseInt(px);
    if (isNaN(px)) throw new Error(`Invalid font size: '${px}'`);
    return `${px / 16}rem`;
};
const $823f29f46e51fd3b$export$96b72b7f243fa693 = {
    laptopHiDPI: {
        width: 1440,
        height: 900
    },
    laptopMDPI: {
        width: 1280,
        height: 800
    },
    tabletL: {
        width: 1024,
        height: 1366
    },
    tabletS: {
        width: 768,
        height: 1024
    },
    mobileM: {
        width: 414,
        height: 736
    },
    mobileS: {
        width: 375,
        height: 667
    },
    mobileXS: {
        width: 320,
        height: 568
    }
};
const $823f29f46e51fd3b$export$9369fd010fa0ddd6 = 0;
const $823f29f46e51fd3b$export$846a716e9e69a8df = [
    [
        'White',
        '#000000'
    ],
    [
        'Light blue',
        '#0C294F'
    ],
    [
        'Light teal',
        '#0C343B'
    ],
    [
        'Light green',
        '#052E21'
    ],
    [
        'Light yellow',
        '#484123'
    ],
    [
        'Light red',
        '#441C13'
    ],
    [
        'Light purple',
        '#282249'
    ],
    [
        'Light gray',
        '#202328'
    ],
    [
        'Blue',
        '#0B3165'
    ],
    [
        'Teal',
        '#044853'
    ],
    [
        'Green',
        '#053927'
    ],
    [
        'Yellow',
        '#6F5C25'
    ],
    [
        'Red',
        '#582013'
    ],
    [
        'Purple',
        '#3E327B'
    ],
    [
        'Gray',
        '#475262'
    ],
    [
        'Dark blue',
        '#003884'
    ],
    [
        'Dark teal',
        '#055866'
    ],
    [
        'Dark green',
        '#044932'
    ],
    [
        'Dark yellow',
        '#82641C'
    ],
    [
        'Dark red',
        '#6B2A19'
    ],
    [
        'Dark purple',
        '#4D38B2'
    ]
].map(([colorName, colorValue])=>$823f29f46e51fd3b$export$5f2dade43b841301(colorName, colorValue)).join('\n');
function $823f29f46e51fd3b$export$5f2dade43b841301(colorName, colorValue) {
    return `
  &[colorname="${colorName}"] {
    background-color: ${colorValue} !important; // !important to override default style color
  }
  `;
}
const $823f29f46e51fd3b$export$312e1e71424c4aa1 = [
    `var(--ds-icon-accent-red, ${(0, $PdmhA.R100)})`,
    `var(--ds-background-accent-red-bolder-hovered, ${(0, $PdmhA.R300)})`,
    `var(--ds-icon-accent-magenta, ${(0, $PdmhA.R500)})`,
    `var(--ds-background-accent-magenta-bolder-hovered, ${(0, $PdmhA.Y100)})`,
    `var(--ds-icon-accent-orange, ${(0, $PdmhA.Y300)})`,
    `var(--ds-background-accent-orange-bolder-hovered, ${(0, $PdmhA.Y500)})`,
    `var(--ds-icon-accent-green, ${(0, $PdmhA.G100)})`,
    `var(--ds-background-accent-green-bolder-hovered, ${(0, $PdmhA.G300)})`,
    `var(--ds-icon-accent-blue, ${(0, $PdmhA.G500)})`,
    `var(--ds-background-accent-blue-bolder-hovered, ${(0, $PdmhA.T100)})`,
    `var(--ds-icon-accent-teal, ${(0, $PdmhA.T300)})`,
    `var(--ds-background-accent-teal-bolder-hovered, ${(0, $PdmhA.T500)})`,
    `var(--ds-icon-accent-lime, ${(0, $PdmhA.B100)})`,
    `var(--ds-background-accent-lime-bolder-hovered, ${(0, $PdmhA.B300)})`,
    `var(--ds-icon-accent-purple, ${(0, $PdmhA.B500)})`,
    `var(--ds-background-accent-purple-bolder-hovered, ${(0, $PdmhA.N70)})`,
    `var(--ds-icon-accent-gray, ${(0, $PdmhA.N200)})`,
    `var(--ds-background-accent-gray-bolder-hovered, ${(0, $PdmhA.N800)})`,
    `var(--ds-icon-accent-yellow, ${(0, $PdmhA.P100)})`,
    `var(--ds-background-accent-yellow-bolder-hovered, ${(0, $PdmhA.P300)})`,
    `var(--ds-background-accent-yellow-bolder-pressed, ${(0, $PdmhA.P500)})`
];

});

parcelRegister("4iaaT", function(module, exports) {

$parcel$export(module.exports, "getBreakpoint", () => $1e71c497b84a179d$export$1eb095b00b926404);
$parcel$export(module.exports, "createWidthContext", () => $1e71c497b84a179d$export$31a4966bffb9ac98);
$parcel$export(module.exports, "WidthContext", () => $1e71c497b84a179d$export$27e39f636459b9f);
$parcel$export(module.exports, "WidthConsumer", () => $1e71c497b84a179d$export$5d8538aa831b6ebb);
$parcel$export(module.exports, "WidthProvider", () => $1e71c497b84a179d$export$7921e18173e8c666);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8yx6O = parcelRequire("8yx6O");

var $5qTKr = parcelRequire("5qTKr");
function $1e71c497b84a179d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1e71c497b84a179d$var$styles = {
    name: "pw7jst",
    styles: "position:relative;width:100%"
};
const $1e71c497b84a179d$var$SCROLLBAR_WIDTH = 30;
function $1e71c497b84a179d$export$1eb095b00b926404(width = 0) {
    const MAX_S = 1266;
    const MAX_M = 2146;
    if (width >= MAX_S && width < MAX_M) return 'M';
    else if (width >= MAX_M) return 'L';
    return 'S';
}
function $1e71c497b84a179d$export$31a4966bffb9ac98(width = 0) {
    return {
        width: width,
        breakpoint: $1e71c497b84a179d$export$1eb095b00b926404(width)
    };
}
const $1e71c497b84a179d$export$27e39f636459b9f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext($1e71c497b84a179d$export$31a4966bffb9ac98());
const { Provider: $1e71c497b84a179d$var$Provider, Consumer: $1e71c497b84a179d$export$5d8538aa831b6ebb } = $1e71c497b84a179d$export$27e39f636459b9f;
const $1e71c497b84a179d$export$7921e18173e8c666 = ({ className: className, shouldCheckExistingValue: shouldCheckExistingValue, children: children })=>{
    const existingContextValue = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext($1e71c497b84a179d$export$27e39f636459b9f);
    const [width, setWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState(typeof document !== 'undefined' ? document.body?.offsetWidth ?? 0 : 0);
    const widthRef = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(width);
    const isMountedRef = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(true);
    const providerValue = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useMemo(()=>$1e71c497b84a179d$export$31a4966bffb9ac98(width), [
        width
    ]);
    const updateWidth = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useMemo(()=>{
        return (0, $8yx6O.default)((nextWidth)=>{
            const currentWidth = widthRef.current || 0;
            // Ignore changes that are less than SCROLLBAR_WIDTH, otherwise it can cause infinite re-scaling
            if (Math.abs(currentWidth - nextWidth) < $1e71c497b84a179d$var$SCROLLBAR_WIDTH) return;
            // Avoid React memory leak by checking if the component is still mounted
            if (!isMountedRef.current) return;
            setWidth(nextWidth);
        });
    }, []);
    const skipWidthDetection = shouldCheckExistingValue && existingContextValue.width > 0;
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useLayoutEffect(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $1e71c497b84a179d$var$styles,
        className: className
    }, !skipWidthDetection && /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $5qTKr.WidthObserver), {
        setWidth: updateWidth,
        offscreen: true
    }), /*#__PURE__*/ (0, $byn9U.jsx)($1e71c497b84a179d$var$Provider, {
        value: providerValue
    }, children)), skipWidthDetection && children));
};

});


parcelRegister("6zWLF", function(module, exports) {

$parcel$export(module.exports, "IntlErrorBoundary", () => $8da2e051cc84279e$export$7df0749115d18d19);

var $eUqFw = parcelRequire("eUqFw");

var $3dpxL = parcelRequire("3dpxL");
const $8da2e051cc84279e$export$c7ef921528e1d279 = '<IntlProvider> needs to exist in the component ancestry';
const $8da2e051cc84279e$var$isMissingIntlProviderInAncestryError = (err)=>err?.toString()?.includes('<IntlProvider> needs to exist in the component ancestry');
class $8da2e051cc84279e$export$7df0749115d18d19 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    componentDidCatch(error, errorInfo) {
        // if missing IntlProvider in ancestry, we setup a fallback IntlProvider ourselves
        if ($8da2e051cc84279e$var$isMissingIntlProviderInAncestryError(error)) this.setState({
            missingIntlProviderInAncestry: true
        });
        else // else we re-propagate the non-react-intl-next error
        throw error;
    }
    render() {
        if (this.state.missingIntlProviderInAncestry) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
            locale: "en"
        }, this.props.children);
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            missingIntlProviderInAncestry: false
        };
    }
}

});

parcelRegister("ghZO5", function(module, exports) {

$parcel$export(module.exports, "default", () => $410321c0dde78cdc$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2qhQi = parcelRequire("2qhQi");

var $25FYC = parcelRequire("25FYC");

var $ioiQ7 = parcelRequire("ioiQ7");

var $PdmhA = parcelRequire("PdmhA");

var $lcnyw = parcelRequire("lcnyw");

var $8cU5f = parcelRequire("8cU5f");

var $auyn4 = parcelRequire("auyn4");

var $jlmhn = parcelRequire("jlmhn");

var $2pBoL = parcelRequire("2pBoL");

var $fwrz2 = parcelRequire("fwrz2");
const $410321c0dde78cdc$var$blockNodeStyle = /*#__PURE__*/ (0, $byn9U.css)({
    background: `var(--ds-background-disabled, ${(0, $PdmhA.N30)})`,
    border: `1px dashed ${`var(--ds-border-disabled, ${(0, $PdmhA.N50)})`}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `${(0, $lcnyw.borderRadius)()}px`,
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $25FYC.relativeFontSizeToBase16)((0, $lcnyw.fontSize)()),
    margin: `${"var(--ds-space-100, 8px)"} 0`,
    minHeight: '24px',
    padding: "var(--ds-space-150, 12px)",
    textAlign: 'center',
    verticalAlign: 'text-bottom',
    minWidth: '120px',
    alignItems: 'center',
    justifyContent: 'center'
});
const $410321c0dde78cdc$var$UnsupportedBlockNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const message = (0, $fwrz2.getUnsupportedContent)((0, $jlmhn.unsupportedContentMessages).unsupportedBlockContent, (0, $jlmhn.unsupportedContentMessages).unsupportedBlockContent.defaultMessage + ':', node, intl);
    const tooltipContent = intl.formatMessage((0, $jlmhn.unsupportedContentMessages).unsupportedContentTooltip);
    const { current: style } = (0, $eUqFw.useRef)({
        padding: '4px'
    });
    const originalNodeType = node?.attrs.originalValue.type;
    const tooltipOnShowHandler = (0, $eUqFw.useCallback)(()=>dispatchAnalyticsEvent && (0, $2pBoL.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $auyn4.ACTION_SUBJECT_ID).ON_UNSUPPORTED_BLOCK, originalNodeType), [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $410321c0dde78cdc$var$blockNodeStyle,
        className: "unsupported"
    }, message, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cU5f.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        style: style
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ioiQ7))), {
        label: "?",
        size: "small"
    })))));
};
var $410321c0dde78cdc$export$2e2bcd8739ae039 = (0, $2qhQi.default)($410321c0dde78cdc$var$UnsupportedBlockNode);

});
parcelRegister("auyn4", function(module, exports) {

$parcel$export(module.exports, "EVENT_TYPE", () => $4b9f3ea7e6ac7391$export$76a2e4c433c23bb9);
$parcel$export(module.exports, "ACTION", () => $4b9f3ea7e6ac7391$export$9523889e0a5da4ba);
$parcel$export(module.exports, "INPUT_METHOD", () => $4b9f3ea7e6ac7391$export$85f107b1fcc9d96f);
$parcel$export(module.exports, "TRIGGER_METHOD", () => $4b9f3ea7e6ac7391$export$81a8b7dba1aa8f75);
$parcel$export(module.exports, "ACTION_SUBJECT", () => $4b9f3ea7e6ac7391$export$7525482b5931e326);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $4b9f3ea7e6ac7391$export$9957974f8b4d8f74);
$parcel$export(module.exports, "CONTENT_COMPONENT", () => $4b9f3ea7e6ac7391$export$9f0b2adf3cfd71b7);
var $4b9f3ea7e6ac7391$export$76a2e4c433c23bb9;
(function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
})($4b9f3ea7e6ac7391$export$76a2e4c433c23bb9 || ($4b9f3ea7e6ac7391$export$76a2e4c433c23bb9 = {}));
var $4b9f3ea7e6ac7391$export$9523889e0a5da4ba;
(function(ACTION) {
    ACTION["ACTIVATED"] = "activated";
    ACTION["ADDED"] = "added";
    ACTION["BROWSER_FREEZE"] = "browserFreeze";
    ACTION["CANCELLED"] = "cancelled";
    ACTION["CAUGHT_DOM_ERROR"] = "caughtDomError";
    ACTION["CHANGED_BACKGROUND_COLOR"] = "changedBackgroundColor";
    ACTION["CHANGED_ICON"] = "changedIcon";
    ACTION["CHANGED_FULL_WIDTH_MODE"] = "changedFullWidthMode";
    ACTION["CHANGED_LAYOUT"] = "changedLayout";
    ACTION["CHANGED_REPLACEMENT_TEXT"] = "changedReplacementText";
    ACTION["CHANGED_TYPE"] = "changedType";
    ACTION["CHANGED_URL"] = "changedUrl";
    ACTION["CLEARED"] = "cleared";
    ACTION["CLICKED"] = "clicked";
    ACTION["CLOSED"] = "closed";
    ACTION["COMMITTED"] = "committed";
    /** used in @atlassian/editor-referentiality */ ACTION["CONNECTED_NODES"] = "connectedNodes";
    ACTION["CONVERTED"] = "converted";
    ACTION["COPIED"] = "copied";
    ACTION["CUT"] = "cut";
    ACTION["DEACTIVATED"] = "deactivated";
    ACTION["DECREMENTED"] = "decremented";
    ACTION["DELETED"] = "deleted";
    ACTION["DISCARDED_INVALID_STEPS_FROM_TRANSACTION"] = "discardedInvalidStepsFromTransaction";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_SOURCE"] = "disconnectedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_TARGET"] = "disconnectedTarget";
    ACTION["DISMISSED"] = "dismissed";
    ACTION["DISPATCHED_INVALID_TRANSACTION"] = "dispatchedInvalidTransaction";
    ACTION["DISPATCHED_VALID_TRANSACTION"] = "dispatchedValidTransaction";
    ACTION["DRAGGED"] = "dragged";
    ACTION["EDITED"] = "edited";
    ACTION["EDITOR_CRASHED"] = "unhandledErrorCaught";
    ACTION["EDITOR_CRASHED_ADDITIONAL_INFORMATION"] = "unhandledErrorCaughtAdditionalInfov2";
    ACTION["EDITOR_MOUNTED"] = "mounted";
    ACTION["EDITOR_TTI"] = "tti";
    ACTION["EDITOR_CONTENT_RETRIEVAL_PERFORMED"] = "contentRetrievalPerformed";
    ACTION["RE_RENDERED"] = "reRendered";
    ACTION["ENTERED"] = "entered";
    ACTION["ERRORED"] = "errored";
    ACTION["EXPOSED"] = "exposed";
    ACTION["FAILED_TO_UNMOUNT"] = "failedToUnmount";
    ACTION["FIND_NEXT_PERFORMED"] = "findNextPerformed";
    ACTION["FIND_PERFORMED"] = "findPerformed";
    ACTION["FIND_PREV_PERFORMED"] = "findPrevPerformed";
    ACTION["FORMATTED"] = "formatted";
    ACTION["HELP_OPENED"] = "helpOpened";
    ACTION["HIGHLIGHTED"] = "highlighted";
    ACTION["INCREMENTED"] = "incremented";
    ACTION["INDENTED"] = "indented";
    ACTION["INITIALISED"] = "initialised";
    /** used in @atlassian/editor-referentiality */ ACTION["INITIALISED_FRAGMENT_MARK"] = "initialisedFragmentMark";
    ACTION["INPUT_PERF_SAMPLING"] = "inputPerfSampling";
    ACTION["INPUT_PERF_SAMPLING_AVG"] = "inputPerfSamplingAvg";
    ACTION["INPUT_PERF_SAMPLING_SINGLE_KEYPRESS"] = "inputPerfSamplingSingleKeypress";
    ACTION["INPUT_PERF_SAMPLING_SINGLE_KEYPRESS_AVG"] = "inputPerfSamplingSingleKeypressAvg";
    ACTION["INPUT_PERF_SAMPLING_RENDERED"] = "inputPerfSamplingRendered";
    ACTION["INPUT_PERF_SAMPLING_RENDERED_AVG"] = "inputPerfSamplingRenderedAvg";
    ACTION["INSERTED"] = "inserted";
    ACTION["INVALID_DOCUMENT_ENCOUNTERED"] = "invalidDocumentEncountered";
    ACTION["INVOKED"] = "invoked";
    /** used in @atlassian/editor-referentiality */ ACTION["GOT_CONNECTIONS"] = "gotConnections";
    ACTION["LANGUAGE_SELECTED"] = "languageSelected";
    ACTION["LIST_ITEM_JOINED"] = "listItemJoined";
    ACTION["MATCHED"] = "matched";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    ACTION["NODE_CONTENT_SANITIZED"] = "nodeContentSanitized";
    ACTION["OPENED"] = "opened";
    ACTION["OUTDENTED"] = "outdented";
    ACTION["PASTED"] = "pasted";
    ACTION["PASTED_AS_PLAIN"] = "pastedAsPlain";
    ACTION["PASTED_TIMED"] = "pastedTimed";
    ACTION["PROSEMIRROR_RENDERED"] = "proseMirrorRendered";
    ACTION["REACT_NODEVIEW_RENDERED"] = "reactNodeViewRendered";
    ACTION["REPLACED_ALL"] = "replacedAll";
    ACTION["REPLACED_ONE"] = "replacedOne";
    ACTION["RESOLVED"] = "resolved";
    ACTION["SELECTED"] = "selected";
    ACTION["SHOWN"] = "shown";
    ACTION["SLOW_INPUT"] = "slowInput";
    ACTION["STARTED"] = "started";
    ACTION["STOPPED"] = "stopped";
    ACTION["SUBSTITUTED"] = "autoSubstituted";
    ACTION["SYNCHRONY_DISCONNECTED"] = "synchronyDisconnected";
    ACTION["SYNCHRONY_ENTITY_ERROR"] = "synchronyEntityError";
    ACTION["SYNCHRONY_ERROR"] = "synchronyError";
    ACTION["TEXT_LINK_MARK_TRANSFORMED"] = "textLinkMarkTransformed";
    ACTION["DEDUPE_MARKS_TRANSFORMED_V2"] = "dedupeMarksTransformedV2";
    ACTION["NODES_MISSING_CONTENT_TRANSFORMED"] = "nodesMissingContentTransformed";
    ACTION["INDENTATION_MARKS_TRANSFORMED"] = "indentationMarksTransformed";
    ACTION["INVALID_MEDIA_CONTENT_TRANSFORMED"] = "invalidMediaContentTransformed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["TRANSACTION_DISPATCHED"] = "transactionDispatched";
    ACTION["TRANSACTION_MUTATED_AFTER_DISPATCH"] = "transactionMutatedAfterDispatched";
    ACTION["TYPING_FINISHED"] = "typingFinished";
    ACTION["TYPING_STARTED"] = "typingStarted";
    ACTION["UNLINK"] = "unlinked";
    ACTION["UNSUPPORTED_CONTENT_ENCOUNTERED"] = "unsupportedContentEncounteredV2";
    ACTION["UPDATED"] = "updated";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_FRAGMENT_MARK_NAME"] = "updatedFragmentMarkName";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_SOURCE"] = "updatedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_TARGET"] = "updatedTarget";
    ACTION["UPLOAD_EXTERNAL_FAIL"] = "uploadExternalFailed";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["WITH_PLUGIN_STATE_CALLED"] = "withPluginStateCalled";
    ACTION["RENDERED"] = "rendered";
    ACTION["ON_EDITOR_READY_CALLBACK"] = "onEditorReadyCallback";
    ACTION["ON_CHANGE_CALLBACK"] = "onChangeCalled";
    ACTION["NEW_COLLAB_SYNC_UP_ERROR_NO_STEPS"] = "newCollabSyncUpErrorNoSteps";
    ACTION["REMOVE_ICON"] = "removedIcon";
    ACTION["UFO_SESSION_COMPLETE"] = "ufoSessionComplete";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["DOCUMENT_PROCESSING_ERROR"] = "documentProcessingErrorV2";
    ACTION["RENDERER_TTI"] = "tti";
    ACTION["CRASHED"] = "unhandledErrorCaughtV2";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["UNSUPPORTED_TOOLTIP_VIEWED"] = "viewed";
    ACTION["RECORD_VIDEO"] = "recordVideo";
    ACTION["INSERT_VIDEO"] = "insertVideo";
    ACTION["RECORD_VIDEO_FAILED"] = "recordVideoFailed";
    ACTION["ADD_CHILD"] = "addChild";
    ACTION["CHANGE_ACTIVE"] = "changeActive";
    ACTION["REMOVE_CHILD"] = "removeChild";
    ACTION["UPDATE_PARAMETERS"] = "updateParameters";
    ACTION["GET_CHILDERN"] = "getChildern";
    ACTION["MOVED"] = "moved";
})($4b9f3ea7e6ac7391$export$9523889e0a5da4ba || ($4b9f3ea7e6ac7391$export$9523889e0a5da4ba = {}));
var $4b9f3ea7e6ac7391$export$85f107b1fcc9d96f;
(function(INPUT_METHOD) {
    INPUT_METHOD["ASCII"] = "ascii";
    INPUT_METHOD["AUTO"] = "auto";
    INPUT_METHOD["AUTO_DETECT"] = "autoDetect";
    INPUT_METHOD["BUTTON"] = "button";
    INPUT_METHOD["BLUR"] = "blur";
    INPUT_METHOD["CARD"] = "card";
    INPUT_METHOD["CLIPBOARD"] = "clipboard";
    INPUT_METHOD["CONFIG_PANEL"] = "configPanel";
    INPUT_METHOD["CONTEXT_MENU"] = "contextMenu";
    INPUT_METHOD["DRAG_AND_DROP"] = "dragAndDrop";
    INPUT_METHOD["DRAG"] = "drag";
    INPUT_METHOD["EXTERNAL"] = "external";
    INPUT_METHOD["EXTENSION_API"] = "extensionApi";
    INPUT_METHOD["FLOATING_TB"] = "floatingToolbar";
    INPUT_METHOD["FORMATTING"] = "autoformatting";
    INPUT_METHOD["INSERT_MENU"] = "insertMenu";
    INPUT_METHOD["KEYBOARD"] = "keyboard";
    INPUT_METHOD["MACRO_BROWSER"] = "macroBrowser";
    INPUT_METHOD["MANUAL"] = "manual";
    INPUT_METHOD["PICKER"] = "picker";
    INPUT_METHOD["PICKER_CLOUD"] = "cloudPicker";
    INPUT_METHOD["PREFILL"] = "prefill";
    INPUT_METHOD["QUICK_INSERT"] = "quickInsert";
    INPUT_METHOD["SHORTCUT"] = "shortcut";
    INPUT_METHOD["TOOLBAR"] = "toolbar";
    INPUT_METHOD["TYPEAHEAD"] = "typeAhead";
    INPUT_METHOD["DATASOURCE"] = "datasource_config";
    INPUT_METHOD["TABLE_CONTEXT_MENU"] = "tableContextMenu";
    INPUT_METHOD["MOUSE"] = "mouse";
})($4b9f3ea7e6ac7391$export$85f107b1fcc9d96f || ($4b9f3ea7e6ac7391$export$85f107b1fcc9d96f = {}));
var $4b9f3ea7e6ac7391$export$81a8b7dba1aa8f75;
(function(TRIGGER_METHOD) {
    TRIGGER_METHOD["BUTTON"] = "button";
    TRIGGER_METHOD["KEYBOARD"] = "keyboard";
    TRIGGER_METHOD["SHORTCUT"] = "shortcut";
    TRIGGER_METHOD["TOOLBAR"] = "toolbar";
})($4b9f3ea7e6ac7391$export$81a8b7dba1aa8f75 || ($4b9f3ea7e6ac7391$export$81a8b7dba1aa8f75 = {}));
var $4b9f3ea7e6ac7391$export$7525482b5931e326;
(function(ACTION_SUBJECT) {
    ACTION_SUBJECT["TOOLBAR_BUTTON"] = "toolbarButton";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["CONFIG_PANEL"] = "configPanel";
    ACTION_SUBJECT["CONTENT_COMPONENT"] = "contentComponent";
    ACTION_SUBJECT["DATE"] = "date";
    ACTION_SUBJECT["DATE_SEGMENT"] = "dateSegment";
    ACTION_SUBJECT["DOCUMENT"] = "document";
    ACTION_SUBJECT["EDITOR"] = "editor";
    ACTION_SUBJECT["ELEMENT_BROWSER"] = "elementBrowser";
    ACTION_SUBJECT["EMBEDS"] = "embeds";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["EXTENSION"] = "extension";
    ACTION_SUBJECT["FEATURE"] = "feature";
    ACTION_SUBJECT["FEEDBACK_DIALOG"] = "feedbackDialog";
    ACTION_SUBJECT["FIND_REPLACE_DIALOG"] = "findReplaceDialog";
    ACTION_SUBJECT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    ACTION_SUBJECT["FLOATING_TOOLBAR_PLUGIN"] = "floatingToolbarPlugin";
    ACTION_SUBJECT["HELP"] = "help";
    ACTION_SUBJECT["LAYOUT"] = "layout";
    ACTION_SUBJECT["LIST"] = "list";
    ACTION_SUBJECT["MEDIA"] = "media";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["PANEL"] = "panel";
    ACTION_SUBJECT["PICKER"] = "picker";
    ACTION_SUBJECT["PLUS_MENU"] = "plusMenu";
    ACTION_SUBJECT["PLUGIN_SLOT"] = "pluginSlot";
    ACTION_SUBJECT["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT["SELECTION"] = "selection";
    ACTION_SUBJECT["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["TABLES_PLUGIN"] = "tablesPlugin";
    ACTION_SUBJECT["TEXT"] = "text";
    ACTION_SUBJECT["TOOLBAR"] = "toolbar";
    ACTION_SUBJECT["TYPEAHEAD"] = "typeAhead";
    ACTION_SUBJECT["TYPEAHEAD_ITEM"] = "typeAheadItem";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["SEARCH_RESULT"] = "searchResult";
    ACTION_SUBJECT["CREATE_LINK_INLINE_DIALOG"] = "createLinkInlineDialog";
    ACTION_SUBJECT["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT["REACT_EDITOR_VIEW"] = "reactEditorView";
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["TOOLTIP"] = "tooltip";
    ACTION_SUBJECT["LOOM"] = "loom";
    ACTION_SUBJECT["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT["BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT["DROP_TARGET"] = "dropTarget";
    ACTION_SUBJECT["DRAG"] = "drag";
    ACTION_SUBJECT["ELEMENT"] = "element";
})($4b9f3ea7e6ac7391$export$7525482b5931e326 || ($4b9f3ea7e6ac7391$export$7525482b5931e326 = {}));
var $4b9f3ea7e6ac7391$export$9957974f8b4d8f74;
(function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["ACTION"] = "action";
    ACTION_SUBJECT_ID["ALL"] = "all";
    ACTION_SUBJECT_ID["ALT_TEXT"] = "altText";
    ACTION_SUBJECT_ID["ANNOTATE_BUTTON"] = "annotateButton";
    ACTION_SUBJECT_ID["AVATAR_GROUP_PLUGIN"] = "AvatarGroupInPlugin";
    ACTION_SUBJECT_ID["BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["BORDER"] = "border";
    ACTION_SUBJECT_ID["BUTTON_CATEGORY"] = "categoryButton";
    ACTION_SUBJECT_ID["BUTTON_FEEDBACK"] = "feedbackButton";
    ACTION_SUBJECT_ID["BUTTON_HELP"] = "helpButton";
    ACTION_SUBJECT_ID["CANCEL"] = "cancel";
    ACTION_SUBJECT_ID["CAPTION"] = "caption";
    ACTION_SUBJECT_ID["CARD_BLOCK"] = "blockCard";
    ACTION_SUBJECT_ID["CARD_INLINE"] = "inlineCard";
    ACTION_SUBJECT_ID["CELL"] = "cell";
    ACTION_SUBJECT_ID["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    ACTION_SUBJECT_ID["CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU"] = "createInlineCommentFromHighlightActionsMenu";
    ACTION_SUBJECT_ID["DATE"] = "date";
    ACTION_SUBJECT_ID["DATE_DAY"] = "day";
    ACTION_SUBJECT_ID["DATE_MONTH"] = "month";
    ACTION_SUBJECT_ID["DATE_YEAR"] = "year";
    ACTION_SUBJECT_ID["DECISION"] = "decision";
    ACTION_SUBJECT_ID["DIVIDER"] = "divider";
    ACTION_SUBJECT_ID["EDIT_LINK"] = "editLink";
    ACTION_SUBJECT_ID["EDIT_DATASOURCE"] = "editDatasource";
    ACTION_SUBJECT_ID["ELEMENT_DRAG_HANDLE"] = "elementDragHandle";
    ACTION_SUBJECT_ID["ELEMENT_DROP_TARGET"] = "elementDropTarget";
    ACTION_SUBJECT_ID["EMBEDS"] = "embeds";
    ACTION_SUBJECT_ID["EMOJI"] = "emoji";
    ACTION_SUBJECT_ID["EXPAND"] = "expand";
    ACTION_SUBJECT_ID["EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_API"] = "extensionApi";
    ACTION_SUBJECT_ID["EXTENSION_BLOCK"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_BODIED"] = "bodiedExtension";
    ACTION_SUBJECT_ID["EXTENSION_INLINE"] = "inlineExtension";
    ACTION_SUBJECT_ID["FORMAT_BACKGROUND_COLOR"] = "backgroundColor";
    ACTION_SUBJECT_ID["FORMAT_BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["FORMAT_CLEAR"] = "clearFormatting";
    ACTION_SUBJECT_ID["FORMAT_CODE"] = "code";
    ACTION_SUBJECT_ID["FORMAT_COLOR"] = "color";
    ACTION_SUBJECT_ID["FORMAT_HEADING"] = "heading";
    ACTION_SUBJECT_ID["FORMAT_INDENT"] = "indentation";
    ACTION_SUBJECT_ID["FORMAT_ITALIC"] = "italic";
    ACTION_SUBJECT_ID["FORMAT_LIST_BULLET"] = "bulletedList";
    ACTION_SUBJECT_ID["FORMAT_LIST_NUMBER"] = "numberedList";
    ACTION_SUBJECT_ID["FORMAT_STRIKE"] = "strike";
    ACTION_SUBJECT_ID["FORMAT_STRONG"] = "strong";
    ACTION_SUBJECT_ID["FORMAT_SUB"] = "subscript";
    ACTION_SUBJECT_ID["FORMAT_SUPER"] = "superscript";
    ACTION_SUBJECT_ID["FORMAT_UNDERLINE"] = "underline";
    ACTION_SUBJECT_ID["FRAGMENT_MARK"] = "fragmentMark";
    ACTION_SUBJECT_ID["GOTO_SMART_LINK_SETTINGS"] = "goToSmartLinkSettings";
    ACTION_SUBJECT_ID["HELP_QUICK_INSERT"] = "helpQuickInsert";
    ACTION_SUBJECT_ID["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["LAYOUT"] = "layout";
    ACTION_SUBJECT_ID["LINE_BREAK"] = "lineBreak";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["LINK_PREVIEW"] = "linkPreview";
    ACTION_SUBJECT_ID["LINK_SEARCH_INPUT"] = "linkSearchInput";
    ACTION_SUBJECT_ID["MEDIA"] = "media";
    ACTION_SUBJECT_ID["MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["MEDIA_INLINE"] = "mediaInline";
    ACTION_SUBJECT_ID["MEDIA_INLINE_IMAGE"] = "mediaInlineImage";
    ACTION_SUBJECT_ID["MEDIA_LINK"] = "mediaLink";
    ACTION_SUBJECT_ID["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["MENTION"] = "mention";
    ACTION_SUBJECT_ID["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["NODE"] = "node";
    ACTION_SUBJECT_ID["OPEN_LINK"] = "openLink";
    ACTION_SUBJECT_ID["PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_BLOCK_CARD"] = "blockCard";
    ACTION_SUBJECT_ID["PASTE_BLOCKQUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["PASTE_BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT_ID["PASTE_BULLET_LIST"] = "bulletList";
    ACTION_SUBJECT_ID["PASTE_CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["PASTE_DECISION_LIST"] = "decisionList";
    ACTION_SUBJECT_ID["PASTE_EXPAND"] = "expand";
    ACTION_SUBJECT_ID["PASTE_EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["PASTE_HEADING"] = "heading";
    ACTION_SUBJECT_ID["PASTE_MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["PASTE_MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["PASTE_NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["PASTE_ORDERED_LIST"] = "orderedList";
    ACTION_SUBJECT_ID["PASTE_PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_PARAGRAPH"] = "paragraph";
    ACTION_SUBJECT_ID["PASTE_RULE"] = "rule";
    ACTION_SUBJECT_ID["PASTE_TABLE"] = "table";
    ACTION_SUBJECT_ID["PASTE_TABLE_CELL"] = "tableCell";
    ACTION_SUBJECT_ID["PASTE_TABLE_HEADER"] = "tableHeader";
    ACTION_SUBJECT_ID["PASTE_TABLE_ROW"] = "tableRow";
    ACTION_SUBJECT_ID["PASTE_TASK_LIST"] = "taskList";
    ACTION_SUBJECT_ID["PICKER_CLOUD"] = "cloudPicker";
    ACTION_SUBJECT_ID["PICKER_COLOR"] = "colorPicker";
    ACTION_SUBJECT_ID["PICKER_EMOJI"] = "emojiPicker";
    ACTION_SUBJECT_ID["PLACEHOLDER_TEXT"] = "placeholderText";
    ACTION_SUBJECT_ID["POST_QUERY_SEARCH_RESULTS"] = "postQuerySearchResults";
    ACTION_SUBJECT_ID["PRE_QUERY_SEARCH_RESULTS"] = "preQuerySearchResults";
    ACTION_SUBJECT_ID["PRODUCT_NAME"] = "productName";
    ACTION_SUBJECT_ID["PUNC"] = "punctuation";
    ACTION_SUBJECT_ID["QUICK_SEARCH"] = "quickSearch";
    ACTION_SUBJECT_ID["RANGE"] = "range";
    ACTION_SUBJECT_ID["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT_ID["RECENT_ACTIVITIES"] = "recentActivities";
    ACTION_SUBJECT_ID["RESIZED"] = "resized";
    ACTION_SUBJECT_ID["RICH_MEDIA_LAYOUT"] = "richMediaLayout";
    ACTION_SUBJECT_ID["SAVE"] = "save";
    ACTION_SUBJECT_ID["SECTION"] = "section";
    ACTION_SUBJECT_ID["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT_ID["STATUS"] = "status";
    ACTION_SUBJECT_ID["SYMBOL"] = "symbol";
    ACTION_SUBJECT_ID["TABLE"] = "table";
    ACTION_SUBJECT_ID["TEXT"] = "text";
    ACTION_SUBJECT_ID["TYPEAHEAD_EMOJI"] = "emojiTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_LINK"] = "linkTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_MENTION"] = "mentionTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_QUICK_INSERT"] = "quickInsertTypeAhead";
    ACTION_SUBJECT_ID["UNKNOWN_NODE"] = "unknownNode";
    ACTION_SUBJECT_ID["UNLINK"] = "unlink";
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["UNSUPPORTED_ERROR"] = "unsupportedUnhandled";
    ACTION_SUBJECT_ID["UNSUPPORTED_NODE_ATTRIBUTE"] = "unsupportedNodeAttribute";
    ACTION_SUBJECT_ID["UNSUPPORTED_BLOCK"] = "unsupportedBlock";
    ACTION_SUBJECT_ID["UNSUPPORTED_INLINE"] = "unsupportedInline";
    ACTION_SUBJECT_ID["UNSUPPORTED_MARK"] = "unsupportedMark";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_INLINE"] = "onUnsupportedInline";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_BLOCK"] = "onUnsupportedBlock";
    ACTION_SUBJECT_ID["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
})($4b9f3ea7e6ac7391$export$9957974f8b4d8f74 || ($4b9f3ea7e6ac7391$export$9957974f8b4d8f74 = {}));
var $4b9f3ea7e6ac7391$export$75ef928acd21e35b;
(function(FLOATING_CONTROLS_TITLE) {
    FLOATING_CONTROLS_TITLE["CODE_BLOCK"] = "codeBlockFloatingControls";
    FLOATING_CONTROLS_TITLE["EXTENSION"] = "extensionFloatingControls";
    FLOATING_CONTROLS_TITLE["HYPERLINK"] = "hyperlinkFloatingControls";
    FLOATING_CONTROLS_TITLE["MEDIA"] = "mediaFloatingControls";
    FLOATING_CONTROLS_TITLE["PANEL"] = "panelFloatingControls";
    FLOATING_CONTROLS_TITLE["TABLE"] = "tableFloatingControls";
    FLOATING_CONTROLS_TITLE["EXPAND"] = "expandToolbar";
})($4b9f3ea7e6ac7391$export$75ef928acd21e35b || ($4b9f3ea7e6ac7391$export$75ef928acd21e35b = {}));
var $4b9f3ea7e6ac7391$export$9f0b2adf3cfd71b7;
(function(CONTENT_COMPONENT) {
    CONTENT_COMPONENT["INLINE_COMMENT"] = "inlineComment";
    CONTENT_COMPONENT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    CONTENT_COMPONENT["FLOATING_INSERT_BUTTON"] = "floatingInsertButton";
    CONTENT_COMPONENT["FLOATING_TOOLBAR"] = "floatingToolbar";
})($4b9f3ea7e6ac7391$export$9f0b2adf3cfd71b7 || ($4b9f3ea7e6ac7391$export$9f0b2adf3cfd71b7 = {}));

});

parcelRegister("jlmhn", function(module, exports) {

$parcel$export(module.exports, "unsupportedContentMessages", () => $735f19feda697729$export$32ec96484dd3ba39);

var $90IgZ = parcelRequire("90IgZ");
const $735f19feda697729$export$32ec96484dd3ba39 = (0, $90IgZ.defineMessages)({
    unsupportedInlineContent: {
        id: 'fabric.editor.unsupportedInlineContent',
        defaultMessage: 'Unsupported content',
        description: 'Unsupported content'
    },
    unsupportedBlockContent: {
        id: 'fabric.editor.unsupportedBlockContent',
        defaultMessage: 'This editor does not support displaying this content',
        description: 'This editor does not support displaying this content'
    },
    unsupportedContentTooltip: {
        id: 'fabric.editor.unsupportedContentTooltip',
        defaultMessage: 'Content is not available in this editor, this will be preserved when you edit and save',
        description: 'Content is not available in this editor, this will be preserved when you edit and save'
    }
});

});

parcelRegister("2pBoL", function(module, exports) {

$parcel$export(module.exports, "findAndTrackUnsupportedContentNodes", () => $377308c09ead4e9c$export$d343369b8f25914);
$parcel$export(module.exports, "fireUnsupportedEvent", () => $377308c09ead4e9c$export$e1051b410945e4d4);
$parcel$export(module.exports, "trackUnsupportedContentTooltipDisplayedFor", () => $377308c09ead4e9c$export$3a34598135e7219b);

var $auyn4 = parcelRequire("auyn4");
const $377308c09ead4e9c$var$whitelistedAttributes = [
    'align',
    'annotationType',
    'extensionKey',
    'extensionType',
    'layout',
    'type',
    'localId',
    'mode',
    'language',
    'timestamp',
    'state',
    'originalWidth',
    'originalHeight',
    'height',
    'width',
    'shortName',
    'level',
    'userType',
    'order',
    'panelType',
    'color',
    'style',
    'isNumberColumnEnabled',
    'colspan',
    'rowspan',
    'colwidth',
    'background'
];
function $377308c09ead4e9c$var$concatAncestorHierarchy(node, ancestoryHierarchy) {
    const { name: name } = node.type;
    // Space concatenator used to reduce analytics payload size
    return ancestoryHierarchy ? `${ancestoryHierarchy} ${name}` : name;
}
const $377308c09ead4e9c$var$sanitizeMarks = (marks = [])=>{
    let sanitizedMarks = [];
    marks.forEach((mark)=>{
        if (mark.attrs) {
            const attrs = $377308c09ead4e9c$var$sanitizeAttributes(mark.attrs);
            sanitizedMarks.push({
                ...mark,
                attrs: attrs
            });
        } else sanitizedMarks.push({
            ...mark
        });
    });
    return sanitizedMarks;
};
const $377308c09ead4e9c$var$sanitizeAttributes = (attrs = {})=>{
    let sanitizedAttrs = Object.assign({}, attrs);
    Object.keys(attrs).filter((key)=>!$377308c09ead4e9c$var$whitelistedAttributes.includes(key)).forEach((key)=>{
        sanitizedAttrs[key] !== null ? sanitizedAttrs[key] = '' : sanitizedAttrs[key] = 'null';
    });
    return sanitizedAttrs;
};
const $377308c09ead4e9c$var$trackUnsupportedContentTooltipActionFor = (action, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    dispatchAnalyticsEvent({
        action: action,
        actionSubjectId: unsupportedContentType,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).TOOLTIP,
        eventType: (0, $auyn4.EVENT_TYPE).UI,
        attributes: {
            unsupportedNodeType: originalNodeType
        }
    });
};
const $377308c09ead4e9c$export$d343369b8f25914 = (node, schema, dispatchAnalyticsEvent, ancestorHierarchy = '')=>{
    const { type: nodeType, marks: nodeMarks } = node;
    const { unsupportedMark: unsupportedMark, unsupportedNodeAttribute: unsupportedNodeAttribute } = schema.marks;
    const { unsupportedInline: unsupportedInline, unsupportedBlock: unsupportedBlock } = schema.nodes;
    const parentType = ancestorHierarchy.split(' ').pop() || '';
    if (nodeMarks.length) nodeMarks.forEach((mark)=>{
        if (mark.type === unsupportedMark) {
            const { originalValue: originalValue } = mark.attrs || {};
            const { type: type } = originalValue || {};
            const unsupportedNode = {
                type: type || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: originalValue.attrs || {}
            };
            $377308c09ead4e9c$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $auyn4.ACTION_SUBJECT_ID).UNSUPPORTED_MARK, unsupportedNode);
        } else if (mark.type === unsupportedNodeAttribute) {
            const { unsupported: unsupported } = mark.attrs || {};
            const unsupportedNodeAttribute = {
                type: nodeType.name || '',
                ancestry: ancestorHierarchy,
                parentType: parentType,
                marks: [],
                attrs: unsupported || {}
            };
            $377308c09ead4e9c$export$e1051b410945e4d4(dispatchAnalyticsEvent, (0, $auyn4.ACTION_SUBJECT_ID).UNSUPPORTED_NODE_ATTRIBUTE, unsupportedNodeAttribute);
        }
    });
    if (nodeType === unsupportedInline || nodeType === unsupportedBlock) {
        const { originalValue: originalValue } = node.attrs || {};
        const { marks: marks } = originalValue || [];
        const { attrs: attrs } = originalValue || {};
        const { type: type } = originalValue || {};
        const unsupportedNode = {
            type: type || '',
            ancestry: ancestorHierarchy,
            parentType: parentType,
            marks: marks || [],
            attrs: attrs || {}
        };
        const actionSubjectId = nodeType === unsupportedInline ? (0, $auyn4.ACTION_SUBJECT_ID).UNSUPPORTED_INLINE : (0, $auyn4.ACTION_SUBJECT_ID).UNSUPPORTED_BLOCK;
        $377308c09ead4e9c$export$e1051b410945e4d4(dispatchAnalyticsEvent, actionSubjectId, unsupportedNode);
    } else // Recursive check for nested content
    node.content.forEach((childNode)=>$377308c09ead4e9c$export$d343369b8f25914(childNode, schema, dispatchAnalyticsEvent, $377308c09ead4e9c$var$concatAncestorHierarchy(node, ancestorHierarchy)));
};
const $377308c09ead4e9c$export$e1051b410945e4d4 = (dispatchAnalyticsEvent, actionSubjectId, unsupportedNode, errorCode)=>{
    const sanitizedAttrs = $377308c09ead4e9c$var$sanitizeAttributes(unsupportedNode.attrs);
    const sanitizedMarks = $377308c09ead4e9c$var$sanitizeMarks(unsupportedNode.marks);
    const sanitizedUnsupportedNode = {
        type: unsupportedNode.type,
        ancestry: unsupportedNode.ancestry,
        parentType: unsupportedNode.parentType,
        attrs: sanitizedAttrs,
        marks: sanitizedMarks
    };
    const payload = {
        action: (0, $auyn4.ACTION).UNSUPPORTED_CONTENT_ENCOUNTERED,
        actionSubject: (0, $auyn4.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        attributes: {
            unsupportedNode: sanitizedUnsupportedNode,
            ...!!errorCode && {
                errorCode: errorCode
            }
        },
        eventType: (0, $auyn4.EVENT_TYPE).TRACK
    };
    dispatchAnalyticsEvent(payload);
};
const $377308c09ead4e9c$export$3a34598135e7219b = (dispatchAnalyticsEvent, unsupportedContentType, originalNodeType)=>{
    $377308c09ead4e9c$var$trackUnsupportedContentTooltipActionFor((0, $auyn4.ACTION).UNSUPPORTED_TOOLTIP_VIEWED, dispatchAnalyticsEvent, unsupportedContentType, originalNodeType);
};

});

parcelRegister("fwrz2", function(module, exports) {

$parcel$export(module.exports, "getUnsupportedContent", () => $db8d6186d2017844$export$d4ded51d0f0bd2df);
function $db8d6186d2017844$export$d4ded51d0f0bd2df(message, prefix, node, intl) {
    let defaultLocale = 'en';
    let canTranslateToLocale = true;
    let locale = intl ? intl.locale : defaultLocale;
    let finalMessage = message.defaultMessage;
    if (node && locale.startsWith(defaultLocale)) {
        const { originalValue: originalValue } = node.attrs;
        if (originalValue.text || originalValue.attrs && originalValue.attrs.text) {
            finalMessage = originalValue.text ? originalValue.text : originalValue.attrs.text;
            canTranslateToLocale = false;
        } else if (originalValue.type) {
            finalMessage = `${prefix} ${originalValue.type}`;
            canTranslateToLocale = false;
        }
    }
    if (intl && canTranslateToLocale) return intl.formatMessage(message);
    return finalMessage;
}

});


parcelRegister("a3eWT", function(module, exports) {

$parcel$export(module.exports, "WithCreateAnalyticsEvent", () => $9c91a1aeaaf3a113$export$9ac3d19711324187);

var $eUqFw = parcelRequire("eUqFw");

var $2jDha = parcelRequire("2jDha");
const $9c91a1aeaaf3a113$export$9ac3d19711324187 = (0, $2jDha.default)()(class WithCreateAnalyticsEvent extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { render: render, createAnalyticsEvent: createAnalyticsEvent } = this.props;
        return render(createAnalyticsEvent);
    }
});

});

parcelRegister("jMQbs", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab843e1ceaf4562b$export$2e2bcd8739ae039);
const $ab843e1ceaf4562b$var$result = {
    mac: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    gecko_version: 0,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    safari_version: 0,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    $ab843e1ceaf4562b$var$result.mac = /Mac/.test(navigator.platform);
    let ie = $ab843e1ceaf4562b$var$result.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $ab843e1ceaf4562b$var$result.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    $ab843e1ceaf4562b$var$result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    $ab843e1ceaf4562b$var$result.gecko_version = parseInt((navigator.userAgent.match(/Firefox\/(\d+)/) || [])[1], 10);
    $ab843e1ceaf4562b$var$result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    $ab843e1ceaf4562b$var$result.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    $ab843e1ceaf4562b$var$result.android = /Android \d/.test(navigator.userAgent);
    $ab843e1ceaf4562b$var$result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $ab843e1ceaf4562b$var$result.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $ab843e1ceaf4562b$var$result.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $ab843e1ceaf4562b$var$result.safari_version = parseInt((navigator.userAgent.match(/Version\/([0-9\._]+).*Safari/) || [])[1], 10);
    $ab843e1ceaf4562b$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $ab843e1ceaf4562b$var$result.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}
var $ab843e1ceaf4562b$export$2e2bcd8739ae039 = $ab843e1ceaf4562b$var$result;

});

parcelRegister("cC72g", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsAppearance", () => $13dbb3ef40d71a8c$export$be87849653b93e6b);
$parcel$export(module.exports, "getAnalyticsEditorAppearance", () => $13dbb3ef40d71a8c$export$31ae53e002edded0);
$parcel$export(module.exports, "getAnalyticsEventSeverity", () => $13dbb3ef40d71a8c$export$f8edd689e8b20f3a);
$parcel$export(module.exports, "SEVERITY", () => $13dbb3ef40d71a8c$export$6a6bef12562cd865);
$parcel$export(module.exports, "analyticsEventKey", () => $13dbb3ef40d71a8c$export$288273ee3e3b6132);

var $dcbVh = parcelRequire("dcbVh");

var $gsJXf = parcelRequire("gsJXf");
const $13dbb3ef40d71a8c$export$be87849653b93e6b = (appearance)=>{
    switch(appearance){
        case 'full-page':
            return (0, $dcbVh.EDITOR_APPEARANCE_CONTEXT).FIXED_WIDTH;
        case 'full-width':
            return (0, $dcbVh.EDITOR_APPEARANCE_CONTEXT).FULL_WIDTH;
        case 'comment':
            return (0, $dcbVh.EDITOR_APPEARANCE_CONTEXT).COMMENT;
        case 'chromeless':
            return (0, $dcbVh.EDITOR_APPEARANCE_CONTEXT).CHROMELESS;
        case 'mobile':
            return (0, $dcbVh.EDITOR_APPEARANCE_CONTEXT).MOBILE;
    }
};
const $13dbb3ef40d71a8c$export$31ae53e002edded0 = (editorAppearance)=>editorAppearance ? `editor_${$13dbb3ef40d71a8c$export$be87849653b93e6b(editorAppearance)}` : '_unknown';
const $13dbb3ef40d71a8c$export$f8edd689e8b20f3a = (duration, normalThreshold, degradedThreshold)=>{
    if (duration > normalThreshold && duration <= degradedThreshold) return "degraded";
    if (duration > degradedThreshold) return "blocking";
    return "normal";
};
var $13dbb3ef40d71a8c$export$6a6bef12562cd865;
(function(SEVERITY) {
    SEVERITY["NORMAL"] = "normal";
    SEVERITY["DEGRADED"] = "degraded";
    SEVERITY["BLOCKING"] = "blocking";
})($13dbb3ef40d71a8c$export$6a6bef12562cd865 || ($13dbb3ef40d71a8c$export$6a6bef12562cd865 = {}));
const $13dbb3ef40d71a8c$export$288273ee3e3b6132 = 'EDITOR_ANALYTICS_EVENT';

});
parcelRegister("gsJXf", function(module, exports) {

$parcel$export(module.exports, "getUnsupportedContentLevelData", () => $bc6d1acb6b48a837$export$484b83e0462998d);

var $hYZXM = parcelRequire("hYZXM");
var $bc6d1acb6b48a837$export$6632e71a22d31bf1;
(function(UNSUPPORTED_CONTENT_LEVEL_SEVERITY) {
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["NORMAL"] = "normal";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["DEGRADED"] = "degraded";
    UNSUPPORTED_CONTENT_LEVEL_SEVERITY["BLOCKING"] = "blocking";
})($bc6d1acb6b48a837$export$6632e71a22d31bf1 || ($bc6d1acb6b48a837$export$6632e71a22d31bf1 = {}));
const $bc6d1acb6b48a837$export$f9f8a29778652c3e = {
    DEGRADED: 10,
    BLOCKING: 25
};
const $bc6d1acb6b48a837$var$buildUnsupportedContentLevelThresholds = (customThresholds)=>{
    return {
        degraded: customThresholds?.degraded || $bc6d1acb6b48a837$export$f9f8a29778652c3e.DEGRADED,
        blocking: customThresholds?.blocking || $bc6d1acb6b48a837$export$f9f8a29778652c3e.BLOCKING
    };
};
const $bc6d1acb6b48a837$var$countSupportedUnsupportedNodes = (validDocument)=>{
    let unsupportedNodes = 0;
    let supportedNodes = 0;
    const unsupportedNodeTypeCount = {};
    const unsupportedNodeTypes = [
        'unsupportedInline',
        'unsupportedBlock',
        'confluenceUnsupportedInline',
        'confluenceUnsupportedBlock'
    ];
    (0, $hYZXM.traverse)(validDocument, {
        any: (node)=>{
            if (unsupportedNodeTypes.includes(node.type)) {
                const originalNode = node.attrs?.originalValue;
                if (originalNode) // start an independent traversal for the purpose of counting
                // unsupported content nodes (with nested children contributing towards
                // that count)
                (0, $hYZXM.traverse)(originalNode, {
                    any: (unsupportedNode, parent)=>{
                        unsupportedNodes++;
                        // Count the types of unsupported nodes
                        const parentType = parent.parent?.node?.type ?? 'unknown';
                        const type = `${parentType}/${unsupportedNode?.type ?? 'unknown'}`;
                        unsupportedNodeTypeCount[type] = (unsupportedNodeTypeCount?.[type] ?? 0) + 1;
                    }
                });
                // force the parent traversal (which is counting supported content nodes)
                // to skip traversal/counting of nested children of the unsupported nodes
                return false;
            } else supportedNodes++;
        }
    });
    return {
        unsupportedNodes: unsupportedNodes,
        supportedNodes: supportedNodes,
        unsupportedNodeTypeCount: unsupportedNodeTypeCount
    };
};
const $bc6d1acb6b48a837$var$mapUnsupportedContentLevelToSeverity = (unsupportedContentLevelPercent, thresholds)=>{
    if (thresholds.degraded <= unsupportedContentLevelPercent && unsupportedContentLevelPercent < thresholds.blocking) return "degraded";
    if (thresholds.blocking <= unsupportedContentLevelPercent) return "blocking";
    return "normal";
};
const $bc6d1acb6b48a837$export$484b83e0462998d = (validDocument, customThresholds)=>{
    const { unsupportedNodes: unsupportedNodes, supportedNodes: supportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } = $bc6d1acb6b48a837$var$countSupportedUnsupportedNodes(validDocument);
    const thresholds = $bc6d1acb6b48a837$var$buildUnsupportedContentLevelThresholds(customThresholds);
    const percentage = Math.round(unsupportedNodes / (unsupportedNodes + supportedNodes) * 100);
    const severity = $bc6d1acb6b48a837$var$mapUnsupportedContentLevelToSeverity(percentage, thresholds);
    return {
        severity: severity,
        percentage: percentage,
        counts: {
            supportedNodes: supportedNodes,
            unsupportedNodes: unsupportedNodes,
            unsupportedNodeTypeCount: unsupportedNodeTypeCount
        }
    };
};

});


parcelRegister("h3qKx", function(module, exports) {

$parcel$export(module.exports, "getDistortedDurationMonitor", () => $42313729e4f27ef3$export$70f7d127254a90c);
$parcel$export(module.exports, "measureRender", () => $42313729e4f27ef3$export$267ed650a5d21ae6);

var $hSjuP = parcelRequire("hSjuP");
const $42313729e4f27ef3$export$70f7d127254a90c = ()=>{
    if (typeof document === 'undefined') return {
        distortedDuration: false,
        cleanup () {}
    };
    // If an editor is rendered when the document is not visible -- the callback passed to
    // requestAnimationFrame will not fire until the document becomes visible again.
    //
    // For the purposes of using performance measurement -- this behaviour means the events
    // which have been fired in the background are not useful -- and lead to other events
    // being hard to draw conclusions from.
    //
    // To mitigate this -- we detect this state -- and fire a separate callback when the
    // measurement has occurred when the render was in the background
    let distortedDuration = document.visibilityState !== 'visible';
    function handleVisibilityChange() {
        if (document.visibilityState !== 'visible') distortedDuration = true;
    }
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return {
        distortedDuration: distortedDuration,
        /**
		 * Cleans up the document visibility event listener
		 */ cleanup () {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        }
    };
};
function $42313729e4f27ef3$export$267ed650a5d21ae6(/**
	 * Unique name for the measurement
	 *
	 * Important: if multiple measureRender events are fired at the same time
	 * with the same measure name -- the result will not be correct.
	 */ measureName, /**
	 * Call back fired when the measurement completes.
	 *
	 * Note: when this function is called when the Document.visibilityState is not
	 * visible -- the duration is likely to be misleading/inaccurate. This is due
	 * to the measurements use of the `requestAnimationFrame` api which only fires
	 * when the Document.visibilityState is visible.
	 */ onMeasureComplete) {
    if (!(0, $hSjuP.isPerformanceAPIAvailable)()) return;
    const startMark = `[START]: ${measureName}`;
    const endMark = `[END]: ${measureName}`;
    const startTime = performance.now();
    performance.mark(startMark);
    let distortedDurationMonitor = $42313729e4f27ef3$export$70f7d127254a90c();
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            performance.mark(endMark);
            distortedDurationMonitor.cleanup();
            const duration = performance.now() - startTime;
            try {
                performance.measure(measureName, startMark, endMark);
                const entry = performance.getEntriesByName(measureName).pop();
                if (!entry) onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
                else onMeasureComplete({
                    duration: entry.duration,
                    startTime: entry.startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            } catch (e) {
                onMeasureComplete({
                    duration: duration,
                    startTime: startTime,
                    distortedDuration: distortedDurationMonitor.distortedDuration
                });
            }
            performance.clearMeasures(measureName);
            performance.clearMarks(startMark);
            performance.clearMarks(endMark);
        });
    });
}

});
parcelRegister("hSjuP", function(module, exports) {

$parcel$export(module.exports, "isPerformanceAPIAvailable", () => $37ae000f1ac45716$export$b5717a625dd4a3eb);
$parcel$export(module.exports, "isPerformanceObserverAvailable", () => $37ae000f1ac45716$export$48995af1e77d8643);
$parcel$export(module.exports, "isPerformanceObserverLongTaskAvailable", () => $37ae000f1ac45716$export$4370ec0f52022f66);
let $37ae000f1ac45716$var$hasRequiredPerformanceAPIs;
function $37ae000f1ac45716$export$b5717a625dd4a3eb() {
    if ($37ae000f1ac45716$var$hasRequiredPerformanceAPIs === undefined) $37ae000f1ac45716$var$hasRequiredPerformanceAPIs = typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType',
        'now'
    ].every((api)=>!!performance[api]);
    return $37ae000f1ac45716$var$hasRequiredPerformanceAPIs;
}
function $37ae000f1ac45716$export$48995af1e77d8643() {
    return !!(typeof window !== 'undefined' && 'PerformanceObserver' in window);
}
function $37ae000f1ac45716$export$4370ec0f52022f66() {
    return $37ae000f1ac45716$export$48995af1e77d8643() && PerformanceObserver.supportedEntryTypes && PerformanceObserver.supportedEntryTypes.includes('longtask');
}

});


parcelRegister("dHwtf", function(module, exports) {

$parcel$export(module.exports, "getResponseEndTime", () => $976419fd13134405$export$92d097a1155bbe27);

var $hSjuP = parcelRequire("hSjuP");
function $976419fd13134405$export$92d097a1155bbe27() {
    if (!(0, $hSjuP.isPerformanceAPIAvailable)()) return;
    const nav = performance.getEntriesByType('navigation')[0];
    if (nav) return nav.responseEnd;
    return;
}

});

parcelRegister("f8mRM", function(module, exports) {

$parcel$export(module.exports, "measureTTI", () => $3f2a31ea09fc8871$export$dd9846a8ce40fad7);
$parcel$export(module.exports, "getTTISeverity", () => $3f2a31ea09fc8871$export$8a681a045a8e7990);

var $cC72g = parcelRequire("cC72g");

var $hSjuP = parcelRequire("hSjuP");

var $h3qKx = parcelRequire("h3qKx");
function $3f2a31ea09fc8871$export$dd9846a8ce40fad7(onMeasureComplete, idleThreshold = 1000, cancelAfter = 60, // Dependency Injection for easier testing
PerfObserver) {
    if (!(0, $hSjuP.isPerformanceObserverLongTaskAvailable)()) return;
    const start = performance.now();
    // Keeping track of users moving away from the tab, which distorts the TTI measurement
    const distortedDurationMonitor = (0, $h3qKx.getDistortedDurationMonitor)();
    let prevLongTask;
    let lastLongTask = {
        startTime: start,
        duration: 0
    };
    const cancelAfterMs = cancelAfter * 1000;
    const observer = new (PerfObserver || PerformanceObserver)((list)=>{
        const entries = list.getEntries();
        if (entries.length) {
            prevLongTask = lastLongTask;
            lastLongTask = entries[entries.length - 1];
        }
    });
    observer.observe({
        entryTypes: [
            'longtask'
        ]
    });
    const checkIdle = ()=>{
        // 1. There hasn't been any long task in `idleThreshold` time: Interactive from the start.
        // 2. Only 1 long task: Interactive from the end of the only long task.
        // 3. Several long tasks:
        //    3.1 Interactive from the end of prevLongTask if `lastLongTask.start - prevLongTask.end >= idleThreshold`
        //    3.2 Interactive from the end of lastLongTask if `lastLongTask.start - prevLongTask.end < idleThreshold`
        const now = performance.now();
        const lastEnd = lastLongTask.startTime + lastLongTask.duration;
        const prevEnd = prevLongTask ? prevLongTask.startTime + prevLongTask.duration : lastEnd;
        const elapsedTimeMs = now - start;
        const canceled = elapsedTimeMs > cancelAfterMs;
        if (!prevLongTask) {
            observer.disconnect();
            distortedDurationMonitor.cleanup();
            return onMeasureComplete(prevEnd, 0, false, distortedDurationMonitor.distortedDuration);
        } else if (lastLongTask.startTime - prevEnd >= idleThreshold) {
            observer.disconnect();
            distortedDurationMonitor.cleanup();
            return onMeasureComplete(prevEnd, prevEnd - start, canceled, distortedDurationMonitor.distortedDuration);
        } else if (now - lastEnd >= idleThreshold || canceled) {
            observer.disconnect();
            distortedDurationMonitor.cleanup();
            return onMeasureComplete(lastEnd, lastEnd - start, canceled, distortedDurationMonitor.distortedDuration);
        }
        return setTimeout(checkIdle, idleThreshold);
    };
    setTimeout(checkIdle, idleThreshold);
}
const $3f2a31ea09fc8871$export$d0d10f04d3799d8b = {
    NORMAL: 40000,
    DEGRADED: 60000
};
const $3f2a31ea09fc8871$export$f801d5dbbaf41dff = {
    NORMAL: 5000,
    DEGRADED: 8000
};
function $3f2a31ea09fc8871$export$8a681a045a8e7990(tti, ttiFromInvocation, ttiSeverityNormalThreshold, ttiSeverityDegradedThreshold, ttiFromInvocationSeverityNormalThreshold, ttiFromInvocationSeverityDegradedThreshold) {
    const ttiNormalThreshold = ttiSeverityNormalThreshold || $3f2a31ea09fc8871$export$d0d10f04d3799d8b.NORMAL;
    const ttiDegradedThreshold = ttiSeverityDegradedThreshold || $3f2a31ea09fc8871$export$d0d10f04d3799d8b.DEGRADED;
    let ttiSeverity;
    if (tti >= ttiNormalThreshold && tti < ttiDegradedThreshold) ttiSeverity = (0, $cC72g.SEVERITY).DEGRADED;
    else if (tti >= ttiDegradedThreshold) ttiSeverity = (0, $cC72g.SEVERITY).BLOCKING;
    else ttiSeverity = (0, $cC72g.SEVERITY).NORMAL;
    const ttiFromInvocationNormalThreshold = ttiFromInvocationSeverityNormalThreshold || $3f2a31ea09fc8871$export$f801d5dbbaf41dff.NORMAL;
    const ttiFromInvocationDegradedThreshold = ttiFromInvocationSeverityDegradedThreshold || $3f2a31ea09fc8871$export$f801d5dbbaf41dff.DEGRADED;
    let ttiFromInvocationSeverity;
    if (ttiFromInvocation >= ttiFromInvocationNormalThreshold && ttiFromInvocation < ttiFromInvocationDegradedThreshold) ttiFromInvocationSeverity = (0, $cC72g.SEVERITY).DEGRADED;
    else if (ttiFromInvocation >= ttiFromInvocationDegradedThreshold) ttiFromInvocationSeverity = (0, $cC72g.SEVERITY).BLOCKING;
    else ttiFromInvocationSeverity = (0, $cC72g.SEVERITY).NORMAL;
    return {
        ttiSeverity: ttiSeverity,
        ttiFromInvocationSeverity: ttiFromInvocationSeverity
    };
}

});

parcelRegister("5Fak9", function(module, exports) {

$parcel$export(module.exports, "shouldForceTracking", () => $8107391f2d138b3f$export$5b59d3e9e22dbdc6);
// START: temporary code https://product-fabric.atlassian.net/browse/ED-10260
const $8107391f2d138b3f$export$5b59d3e9e22dbdc6 = ()=>{
    try {
        const { FRONTEND_VERSION: FRONTEND_VERSION = '' } = window.__buildInfo || {};
        return window.location.hostname === 'product-fabric.atlassian.net' && FRONTEND_VERSION.includes('branch-deploy');
    } catch (err) {
        // eslint-disable-next-line no-console
        console.warn(err);
        return false;
    }
}; // END:  temporary code  https://product-fabric.atlassian.net/browse/ED-10260

});

parcelRegister("jwP4O", function(module, exports) {

$parcel$export(module.exports, "startMeasure", () => $758da5b5dcbf0cb2$export$b62aa2130c86b59b);
$parcel$export(module.exports, "stopMeasure", () => $758da5b5dcbf0cb2$export$37c25be427bec097);
$parcel$export(module.exports, "clearMeasure", () => $758da5b5dcbf0cb2$export$6f766653554dac02);

var $hSjuP = parcelRequire("hSjuP");
const $758da5b5dcbf0cb2$var$measureMap = new Map();
function $758da5b5dcbf0cb2$export$b62aa2130c86b59b(measureName) {
    if (!(0, $hSjuP.isPerformanceAPIAvailable)()) return;
    performance.mark(`${measureName}::start`);
    $758da5b5dcbf0cb2$var$measureMap.set(measureName, performance.now());
}
function $758da5b5dcbf0cb2$export$37c25be427bec097(measureName, onMeasureComplete) {
    if (!(0, $hSjuP.isPerformanceAPIAvailable)()) return;
    performance.mark(`${measureName}::end`);
    const start = onMeasureComplete ? $758da5b5dcbf0cb2$var$measureMap.get(measureName) : undefined;
    try {
        performance.measure(measureName, `${measureName}::start`, `${measureName}::end`);
    } catch (error) {} finally{
        if (onMeasureComplete) {
            const entry = performance.getEntriesByName(measureName).pop();
            if (entry) onMeasureComplete(entry.duration, entry.startTime);
            else if (start) onMeasureComplete(performance.now() - start, start);
        }
        $758da5b5dcbf0cb2$export$6f766653554dac02(measureName);
    }
}
function $758da5b5dcbf0cb2$export$6f766653554dac02(measureName) {
    if (!(0, $hSjuP.isPerformanceAPIAvailable)()) return;
    $758da5b5dcbf0cb2$var$measureMap.delete(measureName);
    performance.clearMarks(`${measureName}::start`);
    performance.clearMarks(`${measureName}::end`);
    performance.clearMeasures(measureName);
}

});

parcelRegister("gL7tA", function(module, exports) {

$parcel$export(module.exports, "normalizeFeatureFlags", () => $dc7cda4295086a63$export$f1485fc4974593c0);
$parcel$export(module.exports, "getEnabledFeatureFlagKeys", () => $dc7cda4295086a63$export$6d018dd0f6cbebcb);

var $jh2R9 = parcelRequire("jh2R9");

var $4vTMF = parcelRequire("4vTMF");
const $dc7cda4295086a63$var$EMPTY = {};
function $dc7cda4295086a63$var$isObjectFlagKey(key, value, objectFlagKeys) {
    return Boolean(typeof value === 'string' && objectFlagKeys?.includes(key));
}
function $dc7cda4295086a63$var$isValidJSONObject(value) {
    try {
        let result = JSON.parse(value);
        if (typeof result === 'object' && result !== null) return true;
        return false;
    } catch (err) {
        return false;
    }
}
function $dc7cda4295086a63$export$f1485fc4974593c0(rawFeatureFlags, options) {
    if (!rawFeatureFlags) return $dc7cda4295086a63$var$EMPTY;
    return Object.entries(rawFeatureFlags).filter((e)=>{
        if (typeof e[1] === 'boolean') return true;
        if ($dc7cda4295086a63$var$isObjectFlagKey((0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))(e[0]), e[1], options?.objectFlagKeys) && $dc7cda4295086a63$var$isValidJSONObject(e[1])) return true;
        return false;
    }).filter(([key])=>(0, (/*@__PURE__*/$parcel$interopDefault($4vTMF)))(key) === key).map(([key, value])=>[
            (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))(key),
            value
        ]).reduce((flags, [key, value])=>{
        if ($dc7cda4295086a63$var$isObjectFlagKey(key, value, options?.objectFlagKeys)) flags[key] = JSON.parse(value);
        if (typeof value === 'boolean') flags[key] = value;
        return flags;
    }, {});
}
function $dc7cda4295086a63$export$6d018dd0f6cbebcb(featureFlags) {
    return Object.keys(featureFlags).filter((key)=>featureFlags[key] === true);
}

});

parcelRegister("lS7UL", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cfa93f53d0b6bdd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7dkLM = parcelRequire("7dkLM");

var $1UbnR = parcelRequire("1UbnR");
parcelRequire("jzB8h");
var $iK2Ni = parcelRequire("iK2Ni");
var $jzB8h = parcelRequire("jzB8h");

var $3OTv2 = parcelRequire("3OTv2");

var $jxP5v = parcelRequire("jxP5v");
var $3Rfkt = parcelRequire("3Rfkt");

var $3glLa = parcelRequire("3glLa");

var $9lEAD = parcelRequire("9lEAD");

var $9oaPg = parcelRequire("9oaPg");

var $2zbl1 = parcelRequire("2zbl1");

var $enpaH = parcelRequire("enpaH");

var $bl9MZ = parcelRequire("bl9MZ");

var $4QHKY = parcelRequire("4QHKY");

var $fvSxt = parcelRequire("fvSxt");
function $4cfa93f53d0b6bdd$var$mergeMarks(marksAndNodes) {
    return marksAndNodes.reduce((acc, markOrNode)=>{
        const prev = acc.length && acc[acc.length - 1] || null;
        if (markOrNode.type instanceof (0, $7dkLM.MarkType) && prev && prev.type instanceof (0, $7dkLM.MarkType) && Array.isArray(prev.content) && (0, $3glLa.isSameMark)(prev, markOrNode)) prev.content = $4cfa93f53d0b6bdd$var$mergeMarks(prev.content.concat(markOrNode.content));
        else acc.push(markOrNode);
        return acc;
    }, []);
}
class $4cfa93f53d0b6bdd$export$2e2bcd8739ae039 {
    constructor(init){
        this.headingIds = [];
        /**
	 * The reason we have this extra array here is because we need to generate the same unique
	 * heading id for 2 different nodes: headers and expands (check the implementation of
	 * `getUniqueHeadingId` for more info).
	 *
	 * We will eventually need to refactor the current approach to generate unique ids
	 * for headers under this ticket -> https://product-fabric.atlassian.net/browse/ED-9668
	 */ this.expandHeadingIds = [];
        this.allowCopyToClipboard = false;
        this.allowWrapCodeBlock = false;
        this.allowPlaceholderText = true;
        this.allowCustomPanels = false;
        this.startPos = 1;
        this.surroundTextNodesWithTextWrapper = false;
        this.allowAnnotations = false;
        this.serializeFragmentChild = (node, { index: index, parentInfo: parentInfo })=>{
            const pos = this.startPos;
            const currentPath = parentInfo && parentInfo.path || [];
            const parentIsIncompleteTask = node.type.name === 'taskItem' && node.attrs.state !== 'DONE';
            const nodeKey = `${node.type.name}__${this.startPos}`;
            const serializedContent = this.serializeFragment(node.content, this.getNodeProps(node, parentInfo), (0, $jzB8h.toReact)(node, {
                allowSelectAllTrap: this.allowSelectAllTrap,
                allowWindowedCodeBlock: this.allowWindowedCodeBlock
            }, this.nodeComponents), nodeKey, {
                parentIsIncompleteTask: parentIsIncompleteTask,
                path: [
                    ...currentPath,
                    node
                ],
                pos: this.startPos
            });
            this.startPos = pos + node.nodeSize;
            const marks = node.marks ? [
                ...node.marks
            ] : [];
            const isMedia = node.type.name === 'media';
            const shouldSkipBorderMark = (mark)=>currentPath.some((n)=>n.type?.name !== 'mediaSingle') && isMedia && mark.type.name === 'border';
            const shouldSkipLinkMark = (mark)=>this.allowMediaLinking !== true && isMedia && mark.type.name === 'link';
            return marks.reduceRight((content, mark)=>{
                if (shouldSkipLinkMark(mark) || shouldSkipBorderMark(mark)) return content;
                return this.renderMark((0, $3Rfkt.toReact)(mark), this.withMediaMarkProps(node, mark, this.getMarkProps(mark, [], node)), `${mark.type.name}-${index}`, content);
            }, serializedContent);
        };
        this.withMediaMarkProps = (node, mark, defaultProps)=>{
            if (mark.type.name === 'link' && node.type.name === 'media') return {
                ...defaultProps,
                isMediaLink: true
            };
            if (this.isCommentsOnMediaMediaInlineBugFixEnabled && node.type.name === 'mediaInline' && mark.type.name === 'annotation') return {
                ...defaultProps,
                isMediaInline: true
            };
            return defaultProps;
        };
        this.getUnsupportedContentProps = (node)=>{
            return {
                node: node,
                dispatchAnalyticsEvent: this.fireAnalyticsEvent
            };
        };
        this.getAnnotationMarkProps = (mark, marksParentPath)=>{
            const annotationParentIds = (marksParentPath || []).reduce((acc, parent)=>{
                if ((0, $jxP5v.isAnnotationMark)(parent)) return [
                    ...acc,
                    parent.attrs.id
                ];
                return acc;
            }, []);
            return {
                id: mark.attrs.id,
                annotationType: mark.attrs.annotationType,
                annotationParentIds: annotationParentIds,
                allowAnnotations: this.allowAnnotations,
                dataAttributes: {
                    'data-renderer-mark': true
                }
            };
        };
        this.getMarkProps = (mark, marksParentPath, node)=>{
            if ((0, $jxP5v.isAnnotationMark)(mark)) return this.getAnnotationMarkProps(mark, marksParentPath);
            const { key: key, ...otherAttrs } = mark.attrs;
            const extraProps = {
                isInline: node?.isInline
            };
            // currently the only mark which has custom props is the code mark
            const markSpecificProps = (0, $bl9MZ.isCodeMark)(mark) ? {
                // The appearance being mobile indicates we are in an renderer being
                // rendered by mobile bridge in a web view.
                // The tooltip is likely to have unexpected behaviour there, with being cut
                // off, so we disable it. This is also to keep the behaviour consistent with
                // the rendering in the mobile Native Renderer.
                codeBidiWarningTooltipEnabled: this.appearance !== 'mobile'
            } : {};
            const props = {
                eventHandlers: this.eventHandlers,
                fireAnalyticsEvent: this.fireAnalyticsEvent,
                markKey: key,
                ...otherAttrs,
                ...extraProps,
                ...markSpecificProps,
                dataAttributes: {
                    'data-renderer-mark': true
                }
            };
            return props;
        };
        this.providers = init.providers;
        this.eventHandlers = init.eventHandlers;
        this.extensionHandlers = init.extensionHandlers;
        this.portal = init.portal;
        this.rendererContext = init.objectContext;
        this.appearance = init.appearance;
        this.disableHeadingIDs = init.disableHeadingIDs;
        this.disableActions = init.disableActions;
        this.allowHeadingAnchorLinks = init.allowHeadingAnchorLinks;
        this.allowCopyToClipboard = init.allowCopyToClipboard;
        this.allowWrapCodeBlock = init.allowWrapCodeBlock;
        this.allowPlaceholderText = init.allowPlaceholderText;
        this.allowCustomPanels = init.allowCustomPanels;
        this.allowColumnSorting = init.allowColumnSorting;
        this.fireAnalyticsEvent = init.fireAnalyticsEvent;
        this.shouldOpenMediaViewer = init.shouldOpenMediaViewer;
        this.allowAltTextOnImages = init.allowAltTextOnImages;
        this.stickyHeaders = init.stickyHeaders;
        this.allowMediaLinking = init.allowMediaLinking;
        this.allowAnnotations = Boolean(init.allowAnnotations);
        this.surroundTextNodesWithTextWrapper = Boolean(init.surroundTextNodesWithTextWrapper);
        this.media = init.media;
        this.emojiResourceConfig = init.emojiResourceConfig;
        this.smartLinks = init.smartLinks;
        this.allowSelectAllTrap = init.allowSelectAllTrap;
        this.nodeComponents = init.nodeComponents;
        this.allowWindowedCodeBlock = init.allowWindowedCodeBlock;
        this.isInsideOfInlineExtension = init.isInsideOfInlineExtension;
        this.textHighlighter = init.textHighlighter;
        this.isCommentsOnMediaMediaInlineBugFixEnabled = init.isCommentsOnMediaMediaInlineBugFixEnabled;
    }
    resetState() {
        this.headingIds = [];
        this.expandHeadingIds = [];
        this.startPos = 1;
    }
    getNodeProps(node, parentInfo) {
        const path = parentInfo ? parentInfo.path : undefined;
        switch(node.type.name){
            case 'date':
                return this.getDateProps(node, parentInfo, path);
            case 'hardBreak':
                return this.getHardBreakProps(node, path);
            case 'heading':
                return this.getHeadingProps(node, path);
            case 'media':
                return this.getMediaProps(node, path);
            case 'emoji':
                return this.getEmojiProps(node);
            case 'mediaGroup':
                return this.getMediaGroupProps(node);
            case 'mediaInline':
                return this.getMediaInlineProps(node);
            case 'mediaSingle':
                return this.getMediaSingleProps(node, path);
            case 'table':
                return this.getTableProps(node, path);
            case 'tableHeader':
            case 'tableRow':
                return this.getTableChildrenProps(node);
            case 'taskItem':
                return this.getTaskItemProps(node, path);
            case 'embedCard':
                return this.getEmbedCardProps(node, path);
            case 'blockCard':
                return this.getBlockCardProps(node, path);
            case 'expand':
                return this.getExpandProps(node, path);
            case 'unsupportedBlock':
            case 'unsupportedInline':
                return this.getUnsupportedContentProps(node);
            case 'codeBlock':
                return this.getCodeBlockProps(node);
            case 'panel':
                return this.getPanelProps(node);
            default:
                return this.getProps(node, path);
        }
    }
    serializeFragment(fragment, props = {}, target = this.allowSelectAllTrap ? (0, $iK2Ni.DocWithSelectAllTrap) : (0, $iK2Ni.default), key = 'root-0', parentInfo) {
        // This makes sure that we reset internal state on re-render.
        if (key === 'root-0') this.resetState();
        return this.renderNode(target, props, key, $4cfa93f53d0b6bdd$export$2e2bcd8739ae039.getChildNodes(fragment).map((node, index)=>{
            if ((0, $jzB8h.isTextWrapper)(node)) return this.serializeTextWrapper(node.content, {
                index: index,
                parentInfo: parentInfo
            });
            return this.serializeFragmentChild(node, {
                index: index,
                parentInfo: parentInfo
            });
        }));
    }
    serializeTextWrapper(content, { index: index, parentInfo: parentInfo }) {
        const currentPath = parentInfo && parentInfo.path || [];
        const nodePosition = parentInfo && parentInfo.pos || 1;
        return $4cfa93f53d0b6bdd$export$2e2bcd8739ae039.buildMarkStructure(content).map((mark, index)=>{
            return this.serializeMark({
                mark: mark,
                parentNode: {
                    path: currentPath,
                    pos: nodePosition
                },
                parentMark: {
                    path: [
                        mark
                    ]
                }
            });
        });
    }
    serializeMark({ mark: mark, parentNode: parentNode, parentMark: parentMark }) {
        if (!(0, $jzB8h.isTextNode)(mark)) {
            const serializeContent = (childMark, index)=>this.serializeMark({
                    mark: childMark,
                    parentNode: parentNode,
                    parentMark: {
                        path: [
                            ...parentMark.path,
                            childMark
                        ]
                    }
                });
            const content = (mark.content || []).map(serializeContent);
            const markKey = `${mark.type.name}-component__${this.startPos}__${parentMark.path.length}`;
            return this.renderMark((0, $3Rfkt.toReact)(mark), this.getMarkProps(mark, parentMark.path), markKey, content);
        }
        const startPos = this.startPos;
        const endPos = startPos + mark.nodeSize;
        this.startPos = endPos;
        const textKey = `text-wrapper_${this.startPos}`;
        if (this.surroundTextNodesWithTextWrapper) {
            const parentDepth = Math.max(parentNode.path.length - 1, 0);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3OTv2.default), {
                key: textKey,
                startPos: startPos + parentDepth,
                endPos: endPos + parentDepth,
                textHighlighter: this.textHighlighter,
                marks: mark.marks
            }, mark.text);
        }
        const segments = (0, $4QHKY.segmentText)(mark.text, this.textHighlighter);
        return (0, $fvSxt.renderTextSegments)(segments, this.textHighlighter, mark.marks, startPos);
    }
    renderNode(NodeComponent, props, key, content) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(NodeComponent, {
            key: key,
            ...props
        }, content);
    }
    renderMark(MarkComponent, props, key, content) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MarkComponent, {
            key: key,
            ...props
        }, content);
    }
    getTableChildrenProps(node) {
        return {
            ...this.getProps(node),
            allowColumnSorting: this.allowColumnSorting
        };
    }
    getTableProps(node, path = []) {
        // TODO: https://product-fabric.atlassian.net/browse/CEMS-1048
        const stickyHeaders = !(0, $enpaH.insideBreakoutLayout)(path) ? this.stickyHeaders : undefined;
        const isInsideOfBlockNode = (0, $enpaH.insideBlockNode)(path, node.type.schema);
        const isInsideMultiBodiedExtension = (0, $enpaH.insideMultiBodiedExtension)(path, node.type.schema);
        return {
            ...this.getProps(node),
            allowColumnSorting: this.allowColumnSorting,
            columnWidths: (0, $9lEAD.calcTableColumnWidths)(node),
            tableNode: node,
            stickyHeaders: stickyHeaders,
            isInsideOfBlockNode: isInsideOfBlockNode,
            isInsideMultiBodiedExtension: isInsideMultiBodiedExtension
        };
    }
    getDateProps(node, parentInfo, path = []) {
        return {
            timestamp: node.attrs && node.attrs.timestamp,
            parentIsIncompleteTask: parentInfo && parentInfo.parentIsIncompleteTask,
            dataAttributes: {
                // We need to account for depth (path.length gives up depth) here
                // but depth doesnt increment the pos, only accounted for.
                'data-renderer-start-pos': this.startPos + path.length
            }
        };
    }
    getMediaSingleProps(node, path = []) {
        const { marks: { link: link } } = node.type.schema;
        const isInsideOfBlockNode = (0, $enpaH.insideBlockNode)(path, node.type.schema);
        const isLinkMark = (mark)=>mark.type === link;
        const childHasLink = node.firstChild && node.firstChild.marks.filter((m)=>isLinkMark(m) || this.allowMediaLinking === true).length;
        return {
            ...this.getProps(node, path),
            isInsideOfBlockNode: isInsideOfBlockNode,
            childHasLink: childHasLink,
            allowCaptions: this.media && this.media.allowCaptions,
            featureFlags: this.media && this.media.featureFlags
        };
    }
    getMediaProps(node, path = []) {
        const { marks: { annotation: annotation, link: link, border: border } } = node.type.schema;
        const isChildOfMediaSingle = path.some((n)=>n.type?.name === 'mediaSingle');
        const isAnnotationMark = (mark)=>mark.type === annotation;
        const isLinkMark = (mark)=>mark.type === link;
        const isBorderMark = (mark)=>isChildOfMediaSingle && mark.type === border;
        return {
            ...this.getProps(node, path),
            marks: node.marks.filter((m)=>!isLinkMark(m) || this.allowMediaLinking === true),
            isLinkMark: isLinkMark,
            isBorderMark: isBorderMark,
            isAnnotationMark: isAnnotationMark,
            allowAltTextOnImages: this.allowAltTextOnImages,
            featureFlags: this.media && this.media.featureFlags,
            shouldOpenMediaViewer: this.shouldOpenMediaViewer,
            ssr: this.media?.ssr,
            // surroundTextNodesWithTextWrapper checks inlineComment.allowDraftMode
            allowAnnotationsDraftMode: this.surroundTextNodesWithTextWrapper
        };
    }
    getEmojiProps(node) {
        return {
            ...this.getProps(node),
            resourceConfig: this.emojiResourceConfig
        };
    }
    getEmbedCardProps(node, path = []) {
        const isInsideOfBlockNode = (0, $enpaH.insideBlockNode)(path, node.type.schema);
        return {
            ...this.getProps(node),
            isInsideOfBlockNode: isInsideOfBlockNode
        };
    }
    getBlockCardProps(node, path = []) {
        return {
            ...this.getProps(node),
            isNodeNested: path.length > 0
        };
    }
    getMediaGroupProps(node) {
        return {
            ...this.getProps(node),
            shouldOpenMediaViewer: this.shouldOpenMediaViewer,
            allowAltTextOnImages: this.allowAltTextOnImages,
            featureFlags: this.media && this.media.featureFlags,
            enableDownloadButton: this.media?.enableDownloadButton,
            ssr: this.media?.ssr
        };
    }
    getMediaInlineProps(node) {
        return {
            ...this.getProps(node),
            ssr: this.media?.ssr
        };
    }
    getTaskItemProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            disabled: this.disableActions
        };
    }
    getHardBreakProps(node, path = []) {
        let forceNewLine = false;
        const parentNode = path.length > 0 ? path[path.length - 1] : null;
        if (parentNode && parentNode.lastChild === node) forceNewLine = true;
        return {
            ...this.getProps(node),
            forceNewLine: forceNewLine
        };
    }
    getCodeBlockProps(node) {
        // The appearance being mobile indicates we are in an renderer being
        // rendered by mobile bridge in a web view.
        // The tooltip is likely to have unexpected behaviour there, with being cut
        // off, so we disable it. This is also to keep the behaviour consistent with
        // the rendering in the mobile Native Renderer.
        const codeBidiWarningTooltipEnabled = this.appearance !== 'mobile';
        return {
            ...this.getProps(node),
            text: node.textContent,
            codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
        };
    }
    getPanelProps(node) {
        return {
            ...this.getProps(node),
            allowCustomPanels: this.allowCustomPanels
        };
    }
    getProps(node, path = []) {
        return {
            text: node.text,
            providers: this.providers,
            eventHandlers: this.eventHandlers,
            extensionHandlers: this.extensionHandlers,
            portal: this.portal,
            rendererContext: this.rendererContext,
            serializer: this,
            content: node.content ? node.content.toJSON() : undefined,
            allowHeadingAnchorLinks: this.allowHeadingAnchorLinks,
            allowCopyToClipboard: this.allowCopyToClipboard,
            allowWrapCodeBlock: this.allowWrapCodeBlock,
            allowPlaceholderText: this.allowPlaceholderText,
            rendererAppearance: this.appearance,
            fireAnalyticsEvent: this.fireAnalyticsEvent,
            nodeType: node.type.name,
            marks: node.marks,
            smartLinks: this.smartLinks,
            isInsideOfInlineExtension: this.isInsideOfInlineExtension,
            dataAttributes: {
                // We need to account for depth (path.length gives up depth) here
                // but depth doesnt increment the pos, only accounted for.
                'data-renderer-start-pos': this.startPos + path.length
            },
            path: path,
            ...node.attrs
        };
    }
    headingAnchorSupported(path = []) {
        const isImmediateParent = (path, nodeName)=>{
            return path.length > 0 && path[path.length - 1].type.name === nodeName;
        };
        return (0, $1UbnR.isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks) || path.length === 0 || isImmediateParent(path, 'layoutColumn');
    }
    getHeadingProps(node, path = []) {
        return {
            ...this.getProps(node, path),
            content: node.content ? node.content.toJSON() : undefined,
            headingId: this.getHeadingId(node, this.headingIds),
            showAnchorLink: this.appearance !== 'comment' && this.allowHeadingAnchorLinks && !this.disableHeadingIDs && this.headingAnchorSupported(path)
        };
    }
    getExpandProps(node, path = []) {
        if (!(0, $1UbnR.isNestedHeaderLinksEnabled)(this.allowHeadingAnchorLinks)) return this.getProps(node);
        const nestedHeaderIds = (0, $2zbl1.findChildrenByType)(node, node.type.schema.nodes.heading).map(({ node: node })=>this.getHeadingId(node, this.expandHeadingIds));
        return {
            ...this.getProps(node),
            nestedHeaderIds: nestedHeaderIds
        };
    }
    // The return value of this function is NOT url encoded,
    // In HTML5 standard, id can contain any characters, encoding is no necessary.
    // Plus we trying to avoid double encoding, therefore we leave the value as is.
    // Remember to use encodeURIComponent when generating url from the id value.
    getHeadingId(node, headingIds) {
        if (this.disableHeadingIDs || !node.content.size) return;
        // We are not use node.textContent here, because we would like to handle cases where
        // headings only contain inline blocks like emoji, status and date.
        const nodeContent = node.content.toJSON().reduce((acc, node)=>acc.concat((0, $9oaPg.getText)(node) || ''), '').trim().replace(/\s/g, '-');
        if (!nodeContent) return;
        return this.getUniqueHeadingId(nodeContent, headingIds);
    }
    getUniqueHeadingId(baseId, headingIds, counter = 0) {
        if (counter === 0 && headingIds.indexOf(baseId) === -1) {
            headingIds.push(baseId);
            return baseId;
        } else if (counter !== 0) {
            const headingId = `${baseId}.${counter}`;
            if (headingIds.indexOf(headingId) === -1) {
                headingIds.push(headingId);
                return headingId;
            }
        }
        return this.getUniqueHeadingId(baseId, headingIds, ++counter);
    }
    static getChildNodes(fragment) {
        const children = [];
        fragment.forEach((node)=>{
            children.push(node);
        });
        return (0, $jzB8h.mergeTextNodes)(children);
    }
    static getMarks(node) {
        if (!node.marks || node.marks.length === 0) return [];
        return (0, $3glLa.getMarksByOrder)(node.marks);
    }
    static buildMarkStructure(content) {
        return $4cfa93f53d0b6bdd$var$mergeMarks(content.map((node)=>{
            const nodeMarks = this.getMarks(node);
            if (nodeMarks.length === 0) return node;
            return nodeMarks.reverse().reduce((acc, mark)=>{
                const { eq: eq } = mark;
                return {
                    ...mark,
                    eq: eq,
                    content: [
                        acc
                    ]
                };
            }, node);
        }));
    }
    // TODO: ED-9004 Remove unused ReactSerializer.fromSchema in renderer
    // https://sourcegraph-frontend.internal.shared-prod.us-west-2.kitt-inf.net/search?q=ReactSerializer.fromSchema&patternType=literal
    static fromSchema(_, init) {
        return new $4cfa93f53d0b6bdd$export$2e2bcd8739ae039(init);
    }
}

});
parcelRegister("1UbnR", function(module, exports) {

$parcel$export(module.exports, "isNestedHeaderLinksEnabled", () => $1c58b049207353f4$export$7aa7587d1ce9583c);
$parcel$export(module.exports, "getActiveHeadingId", () => $1c58b049207353f4$export$acb253d79d72af92);
function $1c58b049207353f4$export$7aa7587d1ce9583c(allowHeadingAnchorLinks) {
    // If it's a boolean or undefined, then we don't support nesting.
    if (!allowHeadingAnchorLinks || typeof allowHeadingAnchorLinks === 'boolean') return false;
    const { allowNestedHeaderLinks: allowNestedHeaderLinks } = allowHeadingAnchorLinks;
    // Explicit cast to a boolean to cover scenario where it's undefined.
    return !!allowNestedHeaderLinks;
}
function $1c58b049207353f4$export$acb253d79d72af92(allowHeadingAnchorLinks) {
    if (!$1c58b049207353f4$export$7aa7587d1ce9583c(allowHeadingAnchorLinks)) return undefined;
    return allowHeadingAnchorLinks.activeHeadingId;
}

});

parcelRegister("jzB8h", function(module, exports) {

$parcel$export(module.exports, "InlineCard", () => $d8a5c9f67b66f0e2$export$aff6291803939b05);
$parcel$export(module.exports, "nodeToReact", () => $d8a5c9f67b66f0e2$export$3931063f6a5f290e);
$parcel$export(module.exports, "toReact", () => $d8a5c9f67b66f0e2$export$d4334b129116aad7);
$parcel$export(module.exports, "mergeTextNodes", () => $d8a5c9f67b66f0e2$export$8045509d14b5046f);
$parcel$export(module.exports, "isTextWrapper", () => $d8a5c9f67b66f0e2$export$d4ebd3557ee7fac1);
$parcel$export(module.exports, "isTextNode", () => $d8a5c9f67b66f0e2$export$ccbedd67ef6e9417);
$parcel$export(module.exports, "Doc", () => (parcelRequire("iK2Ni")).default);
$parcel$export(module.exports, "DocWithSelectAllTrap", () => (parcelRequire("iK2Ni")).DocWithSelectAllTrap);

var $bYKiA = parcelRequire("bYKiA");

var $fuq9M = parcelRequire("fuq9M");

var $1o3JA = parcelRequire("1o3JA");

var $jTkfS = parcelRequire("jTkfS");

var $cQobE = parcelRequire("cQobE");

var $bs79N = parcelRequire("bs79N");

var $iK2Ni = parcelRequire("iK2Ni");

var $h3PoL = parcelRequire("h3PoL");

var $9A6NO = parcelRequire("9A6NO");

var $fGuTt = parcelRequire("fGuTt");

var $6C80U = parcelRequire("6C80U");

var $95JQu = parcelRequire("95JQu");

var $7s3LA = parcelRequire("7s3LA");

var $joPiA = parcelRequire("joPiA");

var $61520 = parcelRequire("61520");

var $8geRS = parcelRequire("8geRS");

var $1PFrh = parcelRequire("1PFrh");

var $lOrB2 = parcelRequire("lOrB2");

var $1OmSI = parcelRequire("1OmSI");

var $5hibD = parcelRequire("5hibD");

var $bIQK1 = parcelRequire("bIQK1");

var $eFI96 = parcelRequire("eFI96");

var $7GWuD = parcelRequire("7GWuD");

var $ghZO5 = parcelRequire("ghZO5");
var $SceRA = parcelRequire("SceRA");

const $d8a5c9f67b66f0e2$export$a22ee8f907eecb5f = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("hdZzW")).then((mod)=>mod.default),
    loading: ()=>null
});

const $d8a5c9f67b66f0e2$export$6c415d1fdae3dfdb = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("hV2nj")).then((mod)=>mod.default),
    loading: ()=>null
});

const $d8a5c9f67b66f0e2$export$771a55a10b0a40ae = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("8X5AK")).then((mod)=>mod.default),
    loading: ()=>null
});

const $d8a5c9f67b66f0e2$export$27c4189b8be1bf93 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("4pDEH")).then((mod)=>mod.default),
    loading: ()=>null
});

const $d8a5c9f67b66f0e2$export$b458dfa720128865 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("cpwUf")).then((mod)=>mod.default),
    loading: ()=>null
});

const $d8a5c9f67b66f0e2$export$b6f73a2b0b0de599 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("iwWxo")).then((mod)=>mod.default),
    loading: ()=>null
});

const $d8a5c9f67b66f0e2$export$6341f9a885713487 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("dT3NP")).then((mod)=>mod.default),
    loading: ()=>null
});

const $d8a5c9f67b66f0e2$export$96e9906d6d93a972 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("bs2b1")).then((mod)=>mod.default),
    loading: ()=>null
});

const $d8a5c9f67b66f0e2$export$56cc48506ff790a = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("2oofV")).then((mod)=>mod.default),
    loading: ()=>null
});

const $d8a5c9f67b66f0e2$export$2ddb90ad54e5f587 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("eGdwO")).then((mod)=>mod.default),
    loading: ()=>null
});

const $d8a5c9f67b66f0e2$export$6789d7ecdc77631b = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("2wIVv")).then((mod)=>mod.default),
    loading: ()=>null
});

const $d8a5c9f67b66f0e2$export$aff6291803939b05 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("7wd1u")).then((mod)=>mod.default),
    loading: ()=>null
});

const $d8a5c9f67b66f0e2$export$d18ccd25c0d2c6b0 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("7DeSP")).then((mod)=>mod.default),
    loading: ()=>null
});

const $d8a5c9f67b66f0e2$export$7fc53215244aec38 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("jCPfL")).then((mod)=>mod.default),
    loading: ()=>null
});

const $d8a5c9f67b66f0e2$export$d7858be3df00d59 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("inOsC")).then((mod)=>mod.default),
    loading: ()=>null
});

const $d8a5c9f67b66f0e2$export$462ea7c2a1c4cb1f = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("auWO3")).then((mod)=>mod.default),
    loading: ()=>null
});

const $d8a5c9f67b66f0e2$export$888d74bc001c3a5d = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("gm2m3")).then((mod)=>mod.default),
    loading: ()=>null
});

const $d8a5c9f67b66f0e2$export$e891316fea657d90 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("idS5t")).then((mod)=>mod.default),
    loading: ()=>null
});

const $d8a5c9f67b66f0e2$export$49bd1dfb0ad29c40 = (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
    loader: ()=>(parcelRequire("45J2i")).then((mod)=>mod.default),
    loading: ()=>null
});
const $d8a5c9f67b66f0e2$export$3931063f6a5f290e = {
    blockquote: (0, $fuq9M.default),
    bulletList: (0, $bs79N.default),
    blockCard: $d8a5c9f67b66f0e2$export$d18ccd25c0d2c6b0,
    caption: (0, $61520.default),
    date: $d8a5c9f67b66f0e2$export$6341f9a885713487,
    decisionItem: $d8a5c9f67b66f0e2$export$b6f73a2b0b0de599,
    decisionList: $d8a5c9f67b66f0e2$export$b458dfa720128865,
    doc: (0, $iK2Ni.default),
    emoji: $d8a5c9f67b66f0e2$export$56cc48506ff790a,
    extension: (0, $h3PoL.default),
    bodiedExtension: (0, $1o3JA.default),
    multiBodiedExtension: (0, $jTkfS.default),
    extensionFrame: (0, $cQobE.default),
    hardBreak: (0, $9A6NO.default),
    heading: (0, $fGuTt.default),
    inlineCard: $d8a5c9f67b66f0e2$export$aff6291803939b05,
    inlineExtension: (0, $6C80U.default),
    layoutSection: (0, $95JQu.default),
    layoutColumn: (0, $7s3LA.default),
    listItem: (0, $joPiA.default),
    media: $d8a5c9f67b66f0e2$export$7fc53215244aec38,
    mediaGroup: $d8a5c9f67b66f0e2$export$d7858be3df00d59,
    mediaInline: $d8a5c9f67b66f0e2$export$462ea7c2a1c4cb1f,
    mediaSingle: $d8a5c9f67b66f0e2$export$888d74bc001c3a5d,
    mention: $d8a5c9f67b66f0e2$export$e891316fea657d90,
    orderedList: (0, $8geRS.default),
    panel: $d8a5c9f67b66f0e2$export$2ddb90ad54e5f587,
    paragraph: (0, $1PFrh.default),
    placeholder: (0, $lOrB2.default),
    rule: (0, $1OmSI.default),
    status: $d8a5c9f67b66f0e2$export$96e9906d6d93a972,
    taskItem: $d8a5c9f67b66f0e2$export$27c4189b8be1bf93,
    taskList: $d8a5c9f67b66f0e2$export$771a55a10b0a40ae,
    table: (0, $5hibD.default),
    tableCell: (0, $bIQK1.TableCell),
    tableHeader: (0, $bIQK1.TableHeader),
    tableRow: (0, $eFI96.default),
    unknownBlock: (0, $7GWuD.default),
    unsupportedBlock: (0, $ghZO5.default),
    unsupportedInline: (0, $SceRA.default),
    expand: $d8a5c9f67b66f0e2$export$49bd1dfb0ad29c40,
    nestedExpand: $d8a5c9f67b66f0e2$export$49bd1dfb0ad29c40,
    embedCard: $d8a5c9f67b66f0e2$export$6789d7ecdc77631b
};
const $d8a5c9f67b66f0e2$export$d4334b129116aad7 = (node, flags, nodeComponents)=>{
    if (node.type.name === 'doc' && flags?.allowSelectAllTrap === true) return 0, $iK2Ni.DocWithSelectAllTrap;
    if (node.type.name === 'codeBlock') {
        if (flags?.allowWindowedCodeBlock === true) return $d8a5c9f67b66f0e2$export$a22ee8f907eecb5f;
        return $d8a5c9f67b66f0e2$export$6c415d1fdae3dfdb;
    }
    // Allowing custom components to override those provided in nodeToReact
    const nodes = {
        ...$d8a5c9f67b66f0e2$export$3931063f6a5f290e,
        ...nodeComponents
    };
    return nodes[node.type.name];
};
const $d8a5c9f67b66f0e2$export$8045509d14b5046f = (nodes)=>{
    return nodes.reduce((acc, current)=>{
        if (!$d8a5c9f67b66f0e2$export$1879817ac5c922b7(current.type.name)) {
            acc.push(current);
            return acc;
        }
        // Append node to previous node, if it was a text wrapper
        if (acc.length > 0 && $d8a5c9f67b66f0e2$export$d4ebd3557ee7fac1(acc[acc.length - 1])) {
            const textWrapper = acc[acc.length - 1];
            textWrapper.content.push(current);
            textWrapper.nodeSize += current.nodeSize;
        } else acc.push({
            type: {
                name: 'textWrapper'
            },
            content: [
                current
            ],
            nodeSize: current.nodeSize
        });
        return acc;
    }, []);
};
const $d8a5c9f67b66f0e2$export$1879817ac5c922b7 = (type)=>{
    return type === 'text';
};
const $d8a5c9f67b66f0e2$export$d4ebd3557ee7fac1 = (node)=>{
    return node.type.name === 'textWrapper';
};
function $d8a5c9f67b66f0e2$export$ccbedd67ef6e9417(node) {
    return node.type.name === 'text';
}
const $d8a5c9f67b66f0e2$var$whitespaceRegex = /^\s*$/;
const $d8a5c9f67b66f0e2$export$dd0c7365db1f79a5 = (doc)=>{
    if (doc.childCount !== 1) return false;
    const parentNodes = [];
    doc.forEach((child)=>parentNodes.push(child));
    const node = parentNodes[0];
    return node.type.name === 'paragraph' && $d8a5c9f67b66f0e2$var$isEmojiBlock(node.content);
};
const $d8a5c9f67b66f0e2$var$isEmojiBlock = (pnode)=>{
    const content = [];
    // Optimisation for long documents - worst case block will be space-emoji-space
    if (pnode.childCount > 7) return false;
    pnode.forEach((child)=>content.push(child));
    let emojiCount = 0;
    for(let i = 0; i < content.length; ++i){
        const node = content[i];
        switch(node.type.name){
            case 'text':
                if (node.text && !node.text.match($d8a5c9f67b66f0e2$var$whitespaceRegex)) return false;
                continue;
            case 'emoji':
                if (++emojiCount > 3) return false;
                continue;
            default:
                // Only text and emoji nodes are allowed
                return false;
        }
    }
    return emojiCount > 0;
};

});
parcelRegister("fuq9M", function(module, exports) {

$parcel$export(module.exports, "default", () => $01d75114e7b1d263$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $01d75114e7b1d263$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("blockquote", null, props.children);
}

});

parcelRegister("1o3JA", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2910cc5d13eaf73$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $h3PoL = parcelRequire("h3PoL");

var $ks9LI = parcelRequire("ks9LI");

var $8zo8Y = parcelRequire("8zo8Y");

var $fvyhV = parcelRequire("fvyhV");

var $auyn4 = parcelRequire("auyn4");
const $d2910cc5d13eaf73$var$BodiedExtension = (props)=>{
    const { children: children, layout: layout = 'default', path: path = [], extensionKey: extensionKey, extensionType: extensionType } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const removeOverflow = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(children).map((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(child) ? child.props.nodeType === 'table' : false).every(Boolean);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ks9LI.ErrorBoundary), {
        component: (0, $fvyhV.ACTION_SUBJECT).RENDERER,
        componentId: (0, $auyn4.ACTION_SUBJECT_ID).EXTENSION_BODIED,
        createAnalyticsEvent: createAnalyticsEvent,
        additionalInfo: `${extensionType}: ${extensionKey} `
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8zo8Y.default), {
        ...props,
        type: "bodiedExtension"
    }, ({ result: result })=>{
        try {
            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(result)) // Return the content directly if it's a valid JSX.Element
            return (0, $h3PoL.renderExtension)(result, layout, {
                isTopLevel: path.length < 1
            }, removeOverflow);
        } catch (e) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        // Always return default content if anything goes wrong
        return (0, $h3PoL.renderExtension)(children, layout, {
            isTopLevel: path.length < 1
        }, removeOverflow);
    }));
};
var $d2910cc5d13eaf73$export$2e2bcd8739ae039 = $d2910cc5d13eaf73$var$BodiedExtension;

});
parcelRegister("h3PoL", function(module, exports) {

$parcel$export(module.exports, "renderExtension", () => $32bbfd07e0365c73$export$b7482bdc8aff85e4);
$parcel$export(module.exports, "default", () => $32bbfd07e0365c73$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8zo8Y = parcelRequire("8zo8Y");

var $8AkRK = parcelRequire("8AkRK");
var $4iaaT = parcelRequire("4iaaT");

var $b3jMP = parcelRequire("b3jMP");

var $ghgHw = parcelRequire("ghgHw");
const $32bbfd07e0365c73$export$b7482bdc8aff85e4 = (content, layout, options = {}, removeOverflow)=>{
    const overflowContainerClass = !removeOverflow ? (0, $ghgHw.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER : '';
    // by default, we assume the extension is at top level, (direct child of doc node)
    const { isTopLevel: isTopLevel = true } = options || {};
    const centerAlignClass = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) ? (0, $ghgHw.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4iaaT.WidthConsumer), null, ({ width: width })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ref: options.handleRef,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $ghgHw.RendererCssClassName).EXTENSION} ${options.shadowClassNames} ${centerAlignClass}`,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                width: isTopLevel ? (0, $b3jMP.calcBreakoutWidth)(layout, width) : '100%'
            },
            "data-layout": layout
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: overflowContainerClass
        }, content)));
};
const $32bbfd07e0365c73$var$Extension = (props)=>{
    const { text: text, layout: layout = 'default', handleRef: handleRef, shadowClassNames: shadowClassNames, path: path = [] } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8zo8Y.default), {
        ...props,
        type: "extension"
    }, ({ result: result })=>{
        try {
            // Return the result directly if it's a valid JSX.Element
            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(result)) return $32bbfd07e0365c73$export$b7482bdc8aff85e4(result, layout, {
                isTopLevel: path.length < 1,
                handleRef: handleRef,
                shadowClassNames: shadowClassNames
            });
        } catch (e) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        // Always return default content if anything goes wrong
        return $32bbfd07e0365c73$export$b7482bdc8aff85e4(text || 'extension', layout, {
            isTopLevel: path.length < 1,
            handleRef: handleRef,
            shadowClassNames: shadowClassNames
        });
    });
};
var $32bbfd07e0365c73$export$2e2bcd8739ae039 = (0, $8AkRK.default)($32bbfd07e0365c73$var$Extension, {
    overflowSelector: `.${(0, $ghgHw.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER}`
});

});
parcelRegister("8zo8Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $8811e89bd6bf57c4$export$2e2bcd8739ae039);
/** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $5iWql = parcelRequire("5iWql");

var $ktPAA = parcelRequire("ktPAA");

var $hhK9E = parcelRequire("hhK9E");

var $bBq1a = parcelRequire("bBq1a");

var $XHGTv = parcelRequire("XHGTv");
const $8811e89bd6bf57c4$var$inlineExtensionStyle = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-block',
    maxWidth: '100%',
    verticalAlign: 'middle',
    // es-lint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    margin: `1px 1px ${"var(--ds-space-050, 4px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& .rich-media-item': {
        maxWidth: '100%'
    }
});
class $8811e89bd6bf57c4$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    UNSAFE_componentWillMount() {
        this.mounted = true;
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    render() {
        const { providers: providers } = this.props;
        if (!providers) return this.setupAndRenderExtensionNode({});
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $hhK9E.WithProviders), {
            providers: [
                'extensionProvider'
            ],
            providerFactory: providers,
            renderNode: this.setupAndRenderExtensionNode
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            extensionProvider: null
        };
        this.mounted = false;
        this.handleProvider = (name, providerPromise)=>{
            providerPromise && providerPromise.then((provider)=>{
                if (this.mounted) this.setState({
                    [name]: provider
                });
            });
        };
        this.getNodeRenderer = (0, $5iWql.default)((0, $ktPAA.getNodeRenderer));
        this.renderExtensionNode = (extensionProvider)=>{
            const { extensionHandlers: extensionHandlers, rendererContext: rendererContext, extensionType: extensionType, extensionKey: extensionKey, parameters: parameters, content: content, text: text, type: type, localId: localId, marks: marks, actions: actions } = this.props;
            const fragmentLocalId = marks?.find((m)=>m.type.name === 'fragment')?.attrs?.localId;
            const node = {
                type: type,
                extensionKey: extensionKey,
                extensionType: extensionType,
                parameters: parameters,
                content: content || text,
                localId: localId,
                fragmentLocalId: fragmentLocalId
            };
            let result = null;
            try {
                if (extensionHandlers && extensionHandlers[extensionType]) {
                    const render = (0, $bBq1a.getExtensionRenderer)(extensionHandlers[extensionType]);
                    result = render(node, rendererContext.adDoc);
                }
                if (!result && extensionProvider) {
                    const NodeRenderer = this.getNodeRenderer(extensionProvider, extensionType, extensionKey);
                    if (node.type === 'multiBodiedExtension') result = /*#__PURE__*/ (0, $byn9U.jsx)(NodeRenderer, {
                        node: node,
                        actions: actions
                    });
                    else if (node.type === 'inlineExtension') result = /*#__PURE__*/ (0, $byn9U.jsx)($8811e89bd6bf57c4$var$InlineNodeRendererWrapper, null, /*#__PURE__*/ (0, $byn9U.jsx)(NodeRenderer, {
                        node: node
                    }));
                    else result = /*#__PURE__*/ (0, $byn9U.jsx)(NodeRenderer, {
                        node: node
                    });
                }
            } catch (e) {
            /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
            return this.props.children({
                result: result
            });
        };
        this.setupAndRenderExtensionNode = (providers)=>{
            const { extensionProvider: extensionProvider } = this.state;
            if (!extensionProvider && providers.extensionProvider) this.handleProvider('extensionProvider', providers.extensionProvider);
            return this.renderExtensionNode(extensionProvider);
        };
    }
}
const $8811e89bd6bf57c4$var$InlineNodeRendererWrapper = ({ children: children })=>{
    if ((0, $XHGTv.getBooleanFF)('platform.editor.inline_extension.extended_lcqdn')) return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        className: "inline-extension-renderer",
        css: $8811e89bd6bf57c4$var$inlineExtensionStyle
    }, children));
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, children);
};

});
parcelRegister("ktPAA", function(module, exports) {

$parcel$export(module.exports, "getExtensionModuleNode", () => $16c6d066806429c4$export$82dd45c2db936caf);
$parcel$export(module.exports, "getExtensionModuleNodePrivateProps", () => $16c6d066806429c4$export$426f8efd8690d8aa);
$parcel$export(module.exports, "getNodeRenderer", () => $16c6d066806429c4$export$67a7d49db68d30a0);

var $eUqFw = parcelRequire("eUqFw");

var $bYKiA = parcelRequire("bYKiA");

var $axIAz = parcelRequire("axIAz");
async function $16c6d066806429c4$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey) {
    const [extKey, nodeKey] = (0, $axIAz.getExtensionKeyAndNodeKey)(extensionKey, extensionType);
    const manifest = await extensionProvider.getExtension(extensionType, extKey);
    if (!manifest) throw new Error(`Extension with key "${extKey}" and type "${extensionType}" not found!`);
    if (!manifest.modules.nodes) throw new Error(`Couldn't find any node for extension type "${extensionType}" and key "${extensionKey}"!`);
    const node = manifest.modules.nodes[nodeKey];
    if (!node) throw new Error(`Node with key "${extensionKey}" not found on manifest for extension type "${extensionType}" and key "${extensionKey}"!`);
    return node;
}
async function $16c6d066806429c4$export$426f8efd8690d8aa(extensionProvider, extensionType, extensionKey) {
    const moduleNode = await $16c6d066806429c4$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey);
    return Object.keys(moduleNode).filter((key)=>key.startsWith('__')).reduce((acc, key)=>{
        acc[key] = moduleNode[key];
        return acc;
    }, {});
}
function $16c6d066806429c4$var$ExtensionLoading(props) {
    if (props.error || props.timedOut) {
        // eslint-disable-next-line no-console
        console.error('Error rendering extension', props.error);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, "Error loading the extension!");
    } else return null;
}
function $16c6d066806429c4$export$67a7d49db68d30a0(extensionProvider, extensionType, extensionKey) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($bYKiA)))({
        loader: ()=>{
            return $16c6d066806429c4$export$82dd45c2db936caf(extensionProvider, extensionType, extensionKey).then((node)=>(0, $axIAz.resolveImport)(node.render()));
        },
        loading: $16c6d066806429c4$var$ExtensionLoading
    });
}

});
parcelRegister("axIAz", function(module, exports) {

$parcel$export(module.exports, "getExtensionKeyAndNodeKey", () => $00855aad3e674979$export$8a49818572e1d105);
$parcel$export(module.exports, "buildAction", () => $00855aad3e674979$export$bb33bcdd9a10a608);
$parcel$export(module.exports, "resolveImport", () => $00855aad3e674979$export$d69c9b451c47653b);
const $00855aad3e674979$export$a7d04c836550045a = 'com.atlassian.ecosystem';
const $00855aad3e674979$export$8a49818572e1d105 = (extensionKey, extensionType)=>{
    // Forge macro extensionKey has a user generated string, so splitting on
    // a colon is unstable for their particular use case. They only have one
    // node in the relevant manifest so we can hardcode nodeKey to 'default'.
    if (extensionType === $00855aad3e674979$export$a7d04c836550045a) return [
        extensionKey,
        'default'
    ];
    const [extKey, nodeKey = 'default'] = extensionKey.split(':');
    return [
        extKey,
        nodeKey
    ];
};
const $00855aad3e674979$export$5f3eb042babacbbd = (extensionKey, nodeKey)=>{
    if (!nodeKey || nodeKey === 'default') return extensionKey;
    return `${extensionKey}:${nodeKey}`;
};
function $00855aad3e674979$export$bb33bcdd9a10a608(action, manifest) {
    if (typeof action === 'function') return action;
    if (action.type === 'node' && manifest.modules.nodes) return $00855aad3e674979$export$33863d887d6f4bfd(action, manifest);
}
const $00855aad3e674979$export$d69c9b451c47653b = async (importPromise)=>{
    const importedModule = await importPromise;
    return importedModule && importedModule.__esModule ? importedModule.default : importedModule;
};
function $00855aad3e674979$export$33863d887d6f4bfd(action, manifest) {
    if (!manifest.modules.nodes) return;
    const node = manifest.modules.nodes[action.key];
    const extensionKey = $00855aad3e674979$export$5f3eb042babacbbd(manifest.key, action.key);
    const extension = {
        type: node.type,
        attrs: {
            extensionType: manifest.type,
            extensionKey: extensionKey,
            parameters: action.parameters
        }
    };
    if (node.type === 'bodiedExtension') return {
        ...extension,
        content: [
            {
                type: 'paragraph',
                content: []
            }
        ]
    };
    else if (node.type === 'multiBodiedExtension') return {
        ...extension,
        content: [
            {
                type: 'extensionFrame',
                content: [
                    {
                        type: 'paragraph',
                        content: []
                    }
                ]
            }
        ]
    };
    return extension;
}

});


parcelRegister("hhK9E", function(module, exports) {

$parcel$export(module.exports, "WithProviders", () => $e051dcc9b530fea9$export$d498ee8be33e096f);

var $eUqFw = parcelRequire("eUqFw");
class $e051dcc9b530fea9$export$d498ee8be33e096f extends (0, $eUqFw.PureComponent) {
    static{
        this.displayName = 'WithProviders';
    }
    constructor(props){
        super(props);
        this.handleProvider = (name, provider)=>{
            this.setState(({ providers: providers })=>{
                return {
                    providers: {
                        ...providers,
                        [name]: provider
                    }
                };
            });
        };
        const providers = {};
        this.props.providers.forEach((name)=>{
            providers[name] = undefined;
        });
        this.state = {
            providers: providers
        };
    }
    UNSAFE_componentWillMount() {
        const { providers: providers, providerFactory: providerFactory } = this.props;
        providers.forEach((name)=>{
            providerFactory.subscribe(name, this.handleProvider);
        });
    }
    componentWillUnmount() {
        const { providers: providers, providerFactory: providerFactory } = this.props;
        providers.forEach((name)=>{
            providerFactory.unsubscribe(name, this.handleProvider);
        });
    }
    render() {
        const { state: state, props: props } = this;
        const { renderNode: renderNode } = props;
        return renderNode(state.providers);
    }
}

});

parcelRegister("bBq1a", function(module, exports) {

$parcel$export(module.exports, "getExtensionRenderer", () => $a67b7acccaabba61$export$9214452ef07eda7);
function $a67b7acccaabba61$export$9214452ef07eda7(extensionHandler) {
    if (typeof extensionHandler === 'object') return extensionHandler.render;
    else return extensionHandler;
}

});


parcelRegister("8AkRK", function(module, exports) {

$parcel$export(module.exports, "shadowClassNames", () => $4d8b4ecfb3103f1d$export$4735dd2b0fa88aa5);
$parcel$export(module.exports, "default", () => $4d8b4ecfb3103f1d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1JeZT = parcelRequire("1JeZT");
const $4d8b4ecfb3103f1d$export$4735dd2b0fa88aa5 = {
    RIGHT_SHADOW: 'right-shadow',
    LEFT_SHADOW: 'left-shadow'
};
function $4d8b4ecfb3103f1d$export$2e2bcd8739ae039(Component, options) {
    return class OverflowShadow extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
        componentWillUnmount() {
            if (options.useShadowObserver) return this.shadowObserver && this.shadowObserver.dispose();
            if (this.overflowContainer) this.overflowContainer.removeEventListener('scroll', this.handleScroll);
            this.updateShadows();
        }
        componentDidUpdate() {
            if (!options.useShadowObserver) this.updateShadows();
        }
        initShadowObserver() {
            if (this.shadowObserver || !this.overflowContainer) return;
            this.shadowObserver = new (0, $1JeZT.ShadowObserver)({
                scrollContainer: this.overflowContainer,
                onUpdateShadows: (shadowStates)=>{
                    this.setState((prevState)=>{
                        const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = shadowStates;
                        if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== prevState.showRightShadow) return {
                            showLeftShadow: showLeftShadow,
                            showRightShadow: showRightShadow
                        };
                        return null;
                    });
                }
            });
        }
        render() {
            const { showLeftShadow: showLeftShadow, showRightShadow: showRightShadow } = this.state;
            let classNames = [
                showRightShadow && $4d8b4ecfb3103f1d$export$4735dd2b0fa88aa5.RIGHT_SHADOW,
                showLeftShadow && $4d8b4ecfb3103f1d$export$4735dd2b0fa88aa5.LEFT_SHADOW,
                options.useShadowObserver && (0, $1JeZT.shadowObserverClassNames).SHADOW_CONTAINER
            ].filter(Boolean).join(' ');
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
                handleRef: this.handleContainer,
                shadowClassNames: classNames,
                ...this.props
            });
        }
        constructor(...args){
            super(...args);
            this.overflowContainerWidth = 0;
            this.state = {
                showLeftShadow: false,
                showRightShadow: false
            };
            this.handleScroll = (event)=>{
                if (!this.overflowContainer || event.target !== this.overflowContainer || options.useShadowObserver) return;
                this.updateShadows();
            };
            this.updateShadows = ()=>{
                if (options.useShadowObserver) return;
                this.setState((prevState)=>{
                    if (!this.overflowContainer) return;
                    const diff = this.calcOverflowDiff();
                    const showRightShadow = diff > 0 && diff > this.overflowContainer.scrollLeft;
                    const showLeftShadow = this.showLeftShadow(this.overflowContainer);
                    if (showLeftShadow !== prevState.showLeftShadow || showRightShadow !== this.state.showRightShadow) return {
                        showLeftShadow: showLeftShadow,
                        showRightShadow: showRightShadow
                    };
                    return null;
                });
            };
            this.showLeftShadow = (overflowContainer)=>{
                return !!overflowContainer && overflowContainer.scrollLeft > 0;
            };
            this.calcOverflowDiff = ()=>{
                if (!this.overflowContainer) return 0;
                this.diff = this.calcScrollableWidth();
                return this.diff - this.overflowContainer.offsetWidth;
            };
            this.calcScrollableWidth = ()=>{
                if (!this.scrollable && this.overflowContainer) return this.overflowContainer.scrollWidth;
                if (!this.scrollable) return 0;
                let width = 0;
                for(let i = 0; i < this.scrollable.length; i++){
                    const scrollableElement = this.scrollable[i];
                    width += scrollableElement.scrollWidth;
                }
                return width;
            };
            this.handleContainer = (container)=>{
                if (!container || this.container) return;
                this.container = container;
                this.overflowContainer = container.querySelector(options.overflowSelector);
                if (!this.overflowContainer) this.overflowContainer = container;
                if (options.useShadowObserver) {
                    this.initShadowObserver();
                    return;
                }
                this.updateShadows();
                this.overflowContainer.addEventListener('scroll', this.handleScroll);
            };
        }
    };
}

});
parcelRegister("1JeZT", function(module, exports) {

$parcel$export(module.exports, "shadowObserverClassNames", () => $6890a1642153a0c2$export$1cbe0bb16052178d);
$parcel$export(module.exports, "ShadowObserver", () => $6890a1642153a0c2$export$51a5b28e4fb2dba2);
var $6890a1642153a0c2$export$ebeea2fe2e93862e;
(function(ShadowKeys) {
    ShadowKeys["SHOW_LEFT_SHADOW"] = "showLeftShadow";
    ShadowKeys["SHOW_RIGHT_SHADOW"] = "showRightShadow";
})($6890a1642153a0c2$export$ebeea2fe2e93862e || ($6890a1642153a0c2$export$ebeea2fe2e93862e = {}));
const $6890a1642153a0c2$export$1cbe0bb16052178d = {
    SENTINEL_LEFT: 'sentinel-left',
    SENTINEL_RIGHT: 'sentinel-right',
    SHADOW_CONTAINER: 'with-shadow-observer'
};
const $6890a1642153a0c2$var$requestIdleCallback = (fn)=>{
    return window.requestIdleCallback ? window.requestIdleCallback(fn) : window.requestAnimationFrame(fn);
};
const $6890a1642153a0c2$var$cancelIdleCallback = (id)=>{
    return window.cancelIdleCallback ? window.cancelIdleCallback(id) : window.cancelAnimationFrame(id);
};
class $6890a1642153a0c2$export$51a5b28e4fb2dba2 {
    constructor({ scrollContainer: scrollContainer, onUpdateShadows: onUpdateShadows }){
        this.sentinels = {};
        this.shadowStates = {
            ["showLeftShadow"]: false,
            ["showRightShadow"]: false
        };
        this.init = ()=>{
            if (!this.scrollContainer || this.intersectionObserver) return;
            this.sentinels.right = document.createElement('div');
            this.sentinels.right.classList.add($6890a1642153a0c2$export$1cbe0bb16052178d.SENTINEL_RIGHT);
            this.scrollContainer.appendChild(this.sentinels.right);
            this.sentinels.left = document.createElement('div');
            this.sentinels.left.classList.add($6890a1642153a0c2$export$1cbe0bb16052178d.SENTINEL_LEFT);
            this.scrollContainer.prepend(this.sentinels.left);
            this.intersectionObserver = new IntersectionObserver((entries, _)=>{
                entries.forEach(this.onIntersect);
            }, {
                root: this.scrollContainer,
                rootMargin: '1px'
            });
            this.intersectionObserver.observe(this.sentinels.left);
            this.intersectionObserver.observe(this.sentinels.right);
        };
        this.onIntersect = (entry)=>{
            this.requestCallbackId = $6890a1642153a0c2$var$requestIdleCallback(()=>{
                if (entry.target.classList.contains($6890a1642153a0c2$export$1cbe0bb16052178d.SENTINEL_LEFT)) this.shadowStates["showLeftShadow"] = !entry.isIntersecting;
                if (entry.target.classList.contains($6890a1642153a0c2$export$1cbe0bb16052178d.SENTINEL_RIGHT)) this.shadowStates["showRightShadow"] = !entry.isIntersecting;
                this.onUpdateShadows(this.shadowStates);
            });
        };
        this.scrollContainer = scrollContainer;
        this.onUpdateShadows = onUpdateShadows;
        this.init();
    }
    dispose() {
        if (this.intersectionObserver) {
            this.intersectionObserver.disconnect();
            this.intersectionObserver = undefined;
            this.requestCallbackId && $6890a1642153a0c2$var$cancelIdleCallback(this.requestCallbackId);
        }
    }
}

});


parcelRegister("b3jMP", function(module, exports) {

$parcel$export(module.exports, "breakoutConsts", () => $c900a46a85c71891$export$ead1fecec2ecf57c);
$parcel$export(module.exports, "absoluteBreakoutWidth", () => $c900a46a85c71891$export$b34ea040d1533a3);
$parcel$export(module.exports, "calcWideWidth", () => $c900a46a85c71891$export$86325001fe8f3adc);
$parcel$export(module.exports, "calcBreakoutWidth", () => $c900a46a85c71891$export$5f4502874a28dfce);
$parcel$export(module.exports, "calculateBreakoutStyles", () => $c900a46a85c71891$export$c377853ecdd53e5b);
$parcel$export(module.exports, "calcBreakoutWidthPx", () => $c900a46a85c71891$export$586300c53bd298dd);
$parcel$export(module.exports, "getNextBreakoutMode", () => $c900a46a85c71891$export$7eb758567e6644fd);
$parcel$export(module.exports, "getTitle", () => $c900a46a85c71891$export$70d1bf7729efff40);

var $25FYC = parcelRequire("25FYC");

var $kUnNQ = parcelRequire("kUnNQ");

var $8lJ1v = parcelRequire("8lJ1v");

var $4iaaT = parcelRequire("4iaaT");

var $7Dnt4 = parcelRequire("7Dnt4");
/**
 * Variables required to construct a context for breakout ssr inline script.
 *
 * TODO: Clean this up after: https://product-fabric.atlassian.net/browse/ED-8942
 *
 */ const $c900a46a85c71891$export$ead1fecec2ecf57c = {
    padding: (0, $25FYC.akEditorBreakoutPadding),
    defaultLayoutWidth: (0, $25FYC.akEditorDefaultLayoutWidth),
    wideScaleRatio: (0, $25FYC.breakoutWideScaleRatio),
    fullWidthLayoutWidth: (0, $25FYC.akEditorFullWidthLayoutWidth),
    wideLayoutWidth: (0, $25FYC.akEditorWideLayoutWidth),
    mapBreakpointToLayoutMaxWidth: $8lJ1v.mapBreakpointToLayoutMaxWidth,
    getBreakpoint: $4iaaT.getBreakpoint,
    /**
	 * This function can return percentage value or px value depending upon the inputs
	 */ calcBreakoutWidth: (layout, containerWidth, padding)=>{
        const effectiveFullWidth = containerWidth - (padding ?? $c900a46a85c71891$export$ead1fecec2ecf57c.padding);
        switch(layout){
            case 'full-width':
                return `${Math.min(effectiveFullWidth, $c900a46a85c71891$export$ead1fecec2ecf57c.fullWidthLayoutWidth)}px`;
            case 'wide':
                if (effectiveFullWidth <= 0) return '100%';
                let wideWidth = $c900a46a85c71891$export$ead1fecec2ecf57c.calcWideWidth(containerWidth, undefined, undefined, padding);
                if (wideWidth.endsWith('%')) return `${Math.min(effectiveFullWidth, $c900a46a85c71891$export$ead1fecec2ecf57c.fullWidthLayoutWidth)}px`;
                return wideWidth;
            default:
                return '100%';
        }
    },
    calcLineLength: ()=>$c900a46a85c71891$export$ead1fecec2ecf57c.defaultLayoutWidth,
    calcWideWidth: (containerWidth = $c900a46a85c71891$export$ead1fecec2ecf57c.defaultLayoutWidth, maxWidth = Infinity, fallback = '100%', padding)=>{
        const effectiveFullWidth = containerWidth - (padding ?? $c900a46a85c71891$export$ead1fecec2ecf57c.padding);
        const layoutMaxWidth = $c900a46a85c71891$export$ead1fecec2ecf57c.mapBreakpointToLayoutMaxWidth($c900a46a85c71891$export$ead1fecec2ecf57c.getBreakpoint(containerWidth));
        const wideWidth = Math.min(Math.ceil(layoutMaxWidth * $c900a46a85c71891$export$ead1fecec2ecf57c.wideScaleRatio), effectiveFullWidth);
        return layoutMaxWidth > wideWidth ? fallback : `${Math.min(maxWidth, wideWidth)}px`;
    }
};
const $c900a46a85c71891$export$b34ea040d1533a3 = (layout, containerWidth)=>{
    const breakoutWidth = $c900a46a85c71891$export$ead1fecec2ecf57c.calcBreakoutWidth(layout, containerWidth);
    // If it's percent, map to max layout size
    if (breakoutWidth.endsWith('%')) switch(layout){
        case 'full-width':
            return 0, $25FYC.akEditorFullWidthLayoutWidth;
        case 'wide':
            return 0, $25FYC.akEditorWideLayoutWidth;
        default:
            return $c900a46a85c71891$export$ead1fecec2ecf57c.mapBreakpointToLayoutMaxWidth($c900a46a85c71891$export$ead1fecec2ecf57c.getBreakpoint(containerWidth));
    }
    return parseInt(breakoutWidth, 10);
};
const $c900a46a85c71891$export$86325001fe8f3adc = $c900a46a85c71891$export$ead1fecec2ecf57c.calcWideWidth;
const $c900a46a85c71891$export$5f4502874a28dfce = $c900a46a85c71891$export$ead1fecec2ecf57c.calcBreakoutWidth;
function $c900a46a85c71891$export$c377853ecdd53e5b({ mode: mode, widthStateLineLength: widthStateLineLength, widthStateWidth: widthStateWidth }) {
    const breakoutWidth = $c900a46a85c71891$export$5f4502874a28dfce(mode, widthStateWidth);
    const breakoutWidthPx = (0, $7Dnt4.parsePx)(breakoutWidth);
    if (!widthStateLineLength) // lineLength is not normally undefined when this is run for,
    // consumers but can be in SSR, initial render or test (jsdom)
    // environments.
    //
    // this approach doesn't work well with position: fixed, so
    // it breaks things like sticky headers.
    //
    // It can also cause bluriness for some child content (such as iframes)
    return {
        type: 'line-length-unknown',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        display: 'flex',
        justifyContent: 'center',
        transform: 'none',
        transition: `min-width 0.5s ${0, $25FYC.akEditorSwoopCubicBezier}`
    };
    // NOTE
    // At time of writing -- when toggling between full-width and
    // full-page appearance modes. There is a slight delay before
    // the widthState is updated.
    // During this period -- the marginLeftPx will be incorrect.
    // const marginLeftPx = -(breakoutWidthPx - widthStateLineLength) / 2;
    return {
        type: 'line-length-known',
        width: breakoutWidth,
        minWidth: breakoutWidthPx,
        transition: `min-width 0.5s ${0, $25FYC.akEditorSwoopCubicBezier}`,
        transform: `translateX(-50%)`,
        marginLeft: `50%`
    };
}
function $c900a46a85c71891$export$586300c53bd298dd(mode, widthStateWidth, padding) {
    return (0, $7Dnt4.parsePx)($c900a46a85c71891$export$5f4502874a28dfce(mode, widthStateWidth, padding));
}
const $c900a46a85c71891$export$7eb758567e6644fd = (currentMode)=>{
    if (currentMode === 'full-width') return 'center';
    else if (currentMode === 'wide') return 'full-width';
    return 'wide';
};
const $c900a46a85c71891$export$70d1bf7729efff40 = (layout)=>{
    switch(layout){
        case 'full-width':
            return (0, $kUnNQ.default).layoutFixedWidth;
        case 'wide':
            return (0, $kUnNQ.default).layoutFullWidth;
        default:
            return (0, $kUnNQ.default).layoutWide;
    }
};

});
parcelRegister("kUnNQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $25e994a2b8e47584$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");

var $crP7H = parcelRequire("crP7H");

var $i044r = parcelRequire("i044r");

var $iEvyL = parcelRequire("iEvyL");

var $hl0Ug = parcelRequire("hl0Ug");

var $5UbPZ = parcelRequire("5UbPZ");

var $caBpJ = parcelRequire("caBpJ");


var $3nLvm = parcelRequire("3nLvm");

var $cBbZY = parcelRequire("cBbZY");

var $f0Ytd = parcelRequire("f0Ytd");

var $dgXkb = parcelRequire("dgXkb");

var $gxhGk = parcelRequire("gxhGk");

var $3nLS5 = parcelRequire("3nLS5");

var $aWXsE = parcelRequire("aWXsE");

var $kRwaf = parcelRequire("kRwaf");

var $jlXTA = parcelRequire("jlXTA");

var $cV3Z1 = parcelRequire("cV3Z1");

var $gzJN4 = parcelRequire("gzJN4");

var $gRnnR = parcelRequire("gRnnR");

var $cHLhY = parcelRequire("cHLhY");

var $eQYNZ = parcelRequire("eQYNZ");

var $huXFb = parcelRequire("huXFb");

var $5Jyfy = parcelRequire("5Jyfy");

var $esoLD = parcelRequire("esoLD");

var $15J3I = parcelRequire("15J3I");

var $9dZ3f = parcelRequire("9dZ3f");

var $6qPs9 = parcelRequire("6qPs9");

var $41ppt = parcelRequire("41ppt");

var $lNoB6 = parcelRequire("lNoB6");

var $25e994a2b8e47584$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    layoutFixedWidth: {
        id: 'fabric.editor.layoutFixedWidth',
        defaultMessage: 'Back to center',
        description: 'Display your element (image, table, extension, etc) as standard width'
    },
    layoutWide: {
        id: 'fabric.editor.layoutWide',
        defaultMessage: 'Go wide',
        description: 'Display your element (image, table, extension, etc) wider than normal'
    },
    layoutFullWidth: {
        id: 'fabric.editor.layoutFullWidth',
        defaultMessage: 'Go full width',
        description: 'Display your element (image, table, extension, etc) as full width'
    },
    alignImageRight: {
        id: 'fabric.editor.alignImageRight',
        defaultMessage: 'Align right',
        description: 'Aligns image to the right'
    },
    alignImageCenter: {
        id: 'fabric.editor.alignImageCenter',
        defaultMessage: 'Align center',
        description: 'Aligns image to the center'
    },
    alignImageLeft: {
        id: 'fabric.editor.alignImageLeft',
        defaultMessage: 'Align left',
        description: 'Aligns image to the left'
    },
    remove: {
        id: 'fabric.editor.remove',
        defaultMessage: 'Remove',
        description: 'Delete the element (image, panel, table, etc.) from your document'
    },
    removeEmoji: {
        id: 'fabric.editor.removeEmoji',
        defaultMessage: 'Remove emoji',
        description: 'Remove the emoji panel icon from custom panel'
    },
    visit: {
        id: 'fabric.editor.visit',
        defaultMessage: 'Open link in a new window',
        description: 'Open the link in a new window'
    },
    inviteToEditButtonTitle: {
        id: 'fabric.editor.editMode.inviteToEditButton.title',
        defaultMessage: 'Invite to edit',
        description: 'Invite another user to edit the current document'
    },
    saveButton: {
        id: 'fabric.editor.saveButton',
        defaultMessage: 'Save',
        description: 'Submit and save a comment or document'
    },
    cancelButton: {
        id: 'fabric.editor.cancelButton',
        defaultMessage: 'Cancel',
        description: 'Discard the current comment or document'
    },
    taskList: {
        id: 'fabric.editor.tooltip.taskList',
        defaultMessage: 'an action item',
        description: 'an action item in the Editor'
    },
    bulletList: {
        id: 'fabric.editor.tooltip.bulletList',
        defaultMessage: 'a list',
        description: 'a list item in the Editor'
    },
    nestedExpand: {
        id: 'fabric.editor.tooltip.nestedExpand',
        defaultMessage: 'a nested expand',
        description: 'expand node which is nested'
    },
    decisionList: {
        id: 'fabric.editor.tooltip.decisionList',
        defaultMessage: 'a decision list',
        description: 'a list of decisions'
    },
    defaultBlockNode: {
        id: 'fabric.editor.tooltip.defaultBlockNode',
        defaultMessage: 'a block node',
        description: 'a block node element'
    },
    panel: {
        id: 'fabric.editor.tooltip.blockPanel',
        defaultMessage: 'a panel',
        description: 'Panel node in the Editor'
    },
    blockquote: {
        id: 'fabric.editor.blockquote',
        defaultMessage: 'a quote',
        description: 'a quote node'
    },
    timeUpdated: {
        id: 'fabric.editor.time.updated',
        defaultMessage: 'Updated',
        description: 'Time last updated'
    },
    timeViewed: {
        id: 'fabric.editor.time.viewed',
        defaultMessage: 'Viewed',
        description: 'Time last viewed'
    },
    timeAgo: {
        id: 'fabric.editor.time.ago',
        defaultMessage: 'ago',
        description: 'Some time ago'
    },
    copyToClipboard: {
        id: 'fabric.editor.copyToClipboard',
        defaultMessage: 'Copy',
        description: 'Copy the whole content of the element to your clipboard'
    },
    copiedToClipboard: {
        id: 'fabric.editor.copiedToClipboard',
        defaultMessage: 'Copied!',
        description: 'Copied the whole content of the element to clipboard'
    }
});

});
parcelRegister("crP7H", function(module, exports) {

$parcel$export(module.exports, "alignmentMessages", () => $f5e476b2ff5d3a17$export$5229ffea355cfdf6);

var $90IgZ = parcelRequire("90IgZ");
const $f5e476b2ff5d3a17$export$5229ffea355cfdf6 = (0, $90IgZ.defineMessages)({
    alignment: {
        id: 'fabric.editor.alignment',
        defaultMessage: 'Text alignment',
        description: 'Opens drop down menu of options to configure text alignment'
    },
    alignLeft: {
        id: 'fabric.editor.alignLeft',
        defaultMessage: 'Align left',
        description: 'label stating that text is aligned left'
    },
    alignCenter: {
        id: 'fabric.editor.alignCenter',
        defaultMessage: 'Align center',
        description: 'label stating that text is aligned center'
    },
    alignRight: {
        id: 'fabric.editor.alignRight',
        defaultMessage: 'Align right',
        description: 'label stating that text is aligned right'
    }
});

});

parcelRegister("i044r", function(module, exports) {

$parcel$export(module.exports, "annotationMessages", () => $be74b511631b010a$export$ff612ca71703201d);

var $90IgZ = parcelRequire("90IgZ");
const $be74b511631b010a$export$ff612ca71703201d = (0, $90IgZ.defineMessages)({
    createComment: {
        id: 'fabric.editor.createComment',
        defaultMessage: 'Comment',
        description: 'Create/add an inline comment based on the users selection'
    },
    // TODO: Remove this message when the platform.editor.allow-inline-comments-for-inline-nodes-round-2_ctuxz FF is removed
    createCommentInvalid: {
        id: 'fabric.editor.createCommentInvalid',
        defaultMessage: 'You can only comment on text and headings',
        description: 'Error message to communicate to the user they can only do the current action in certain contexts'
    },
    createCommentDisabled: {
        id: 'fabric.editor.createCommentDisabled',
        defaultMessage: 'You can only comment on text, headings, emojis, dates, mentions, links, and statuses.',
        description: 'Error message to communicate to the user they can only do the current action in certain contexts'
    },
    toolbar: {
        id: 'fabric.editor.annotationToolbar',
        defaultMessage: 'Annotation toolbar',
        description: 'A label for a toolbar (UI element) that creates annotations/comments in the document'
    }
});

});

parcelRegister("iEvyL", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2944a169bba41b5f$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $2944a169bba41b5f$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    normal: {
        id: 'fabric.editor.normal',
        defaultMessage: 'Normal text',
        description: 'This is the default text style'
    },
    heading1: {
        id: 'fabric.editor.heading1',
        defaultMessage: 'Heading 1',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading1Description: {
        id: 'fabric.editor.heading1Description',
        defaultMessage: 'Use this for a top level heading',
        description: 'Description of the main heading, heading 1'
    },
    heading2: {
        id: 'fabric.editor.heading2',
        defaultMessage: 'Heading 2',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading2Description: {
        id: 'fabric.editor.heading2Description',
        defaultMessage: 'Use this for key sections',
        description: 'Description of a subtitle heading or secondary heading'
    },
    heading3: {
        id: 'fabric.editor.heading3',
        defaultMessage: 'Heading 3',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading3Description: {
        id: 'fabric.editor.heading3Description',
        defaultMessage: 'Use this for sub sections and group headings',
        description: ''
    },
    heading4: {
        id: 'fabric.editor.heading4',
        defaultMessage: 'Heading 4',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading4Description: {
        id: 'fabric.editor.heading4Description',
        defaultMessage: 'Use this for deep headings',
        description: ''
    },
    heading5: {
        id: 'fabric.editor.heading5',
        defaultMessage: 'Heading 5',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading5Description: {
        id: 'fabric.editor.heading5Description',
        defaultMessage: 'Use this for grouping list items',
        description: ''
    },
    heading6: {
        id: 'fabric.editor.heading6',
        defaultMessage: 'Heading 6',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading6Description: {
        id: 'fabric.editor.heading6Description',
        defaultMessage: 'Use this for low level headings',
        description: ''
    },
    blockquote: {
        id: 'fabric.editor.blockquote2',
        defaultMessage: 'Quote',
        description: 'Quote some text'
    },
    blockquoteDescription: {
        id: 'fabric.editor.blockquote.description',
        defaultMessage: 'Insert a quote or citation',
        description: 'Quote some text'
    },
    codeblock: {
        id: 'fabric.editor.codeblock',
        defaultMessage: 'Code snippet',
        description: 'Insert a snippet/segment of code (code block)'
    },
    codeblockDescription: {
        id: 'fabric.editor.codeblock.description',
        defaultMessage: 'Display code with syntax highlighting',
        description: 'Insert a snippet/segment of code (code block)'
    },
    infoPanel: {
        id: 'fabric.editor.infoPanel',
        defaultMessage: 'Info panel',
        description: 'Visually distinguishes your text by adding a background colour (blue, purple, yellow, green, red)'
    },
    infoPanelDescription: {
        id: 'fabric.editor.infoPanel.description',
        defaultMessage: 'Highlight information in a colored panel',
        description: 'Visually distinguishes your text by adding a background colour (blue, purple, yellow, green, red)'
    },
    notePanel: {
        id: 'fabric.editor.notePanel',
        defaultMessage: 'Note panel',
        description: 'Visually distinguishes your text by adding a note panel'
    },
    notePanelDescription: {
        id: 'fabric.editor.notePanel.description',
        defaultMessage: 'Add a note in a colored panel',
        description: 'Visually distinguishes your text by adding a note panel'
    },
    successPanel: {
        id: 'fabric.editor.successPanel',
        defaultMessage: 'Success panel',
        description: 'Visually distinguishes your text by adding a success panel'
    },
    successPanelDescription: {
        id: 'fabric.editor.successPanel.description',
        defaultMessage: 'Add tips in a colored panel',
        description: 'Visually distinguishes your text by adding a success panel'
    },
    warningPanel: {
        id: 'fabric.editor.warningPanel',
        defaultMessage: 'Warning panel',
        description: 'Visually distinguishes your text by adding a warning panel'
    },
    warningPanelDescription: {
        id: 'fabric.editor.warningPanel.description',
        defaultMessage: 'Add a note of caution in a colored panel',
        description: 'Visually distinguishes your text by adding a warning panel'
    },
    errorPanel: {
        id: 'fabric.editor.errorPanel',
        defaultMessage: 'Error panel',
        description: 'Visually distinguishes your text by adding a error panel'
    },
    errorPanelDescription: {
        id: 'fabric.editor.errorPanel.description',
        defaultMessage: 'Call out errors in a colored panel',
        description: 'Visually distinguishes your text by adding a error panel'
    },
    customPanel: {
        id: 'fabric.editor.customPanel',
        defaultMessage: 'Custom panel',
        description: 'Visually distinguishes your panel by adding a emoji icon and background color'
    },
    customPanelDescription: {
        id: 'fabric.editor.customPanel.description',
        defaultMessage: 'Add a note with an emoji and colored background',
        description: 'Visually distinguishes your panel by adding a emoji icon and background color '
    },
    other: {
        id: 'fabric.editor.other',
        defaultMessage: 'Others...',
        description: 'Other text formatting'
    }
});

});

parcelRegister("hl0Ug", function(module, exports) {

$parcel$export(module.exports, "codeBidiWarningMessages", () => $2d2f04d0b297ab75$export$42bb270d1224182);

var $90IgZ = parcelRequire("90IgZ");
const $2d2f04d0b297ab75$export$42bb270d1224182 = (0, $90IgZ.defineMessages)({
    /**
	 * Message taken from
	 * https://hello.atlassian.net/wiki/spaces/~tswan/pages/1366555782/PSHELP-2943+Investigate+Trojan+Source+Attack+Vulnerability+design
	 */ label: {
        id: 'fabric.editor.codeBidiWarningLabel',
        defaultMessage: 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.',
        description: 'Tooltip message to present to users when a bidirectional character is encountered in code.'
    }
});

});

parcelRegister("5UbPZ", function(module, exports) {

$parcel$export(module.exports, "linkMessages", () => $53edd04fede58907$export$4ce3884394d6d9);

var $90IgZ = parcelRequire("90IgZ");
const $53edd04fede58907$export$4ce3884394d6d9 = (0, $90IgZ.defineMessages)({
    openLink: {
        id: 'fabric.editor.openLink',
        defaultMessage: 'Open link in a new tab',
        description: 'Opens the link in a new tab'
    }
});

});

parcelRegister("caBpJ", function(module, exports) {

$parcel$export(module.exports, "linkToolbarMessages", () => $3e150f112ec60beb$export$2d7676d841c8ae9);

var $90IgZ = parcelRequire("90IgZ");
const $3e150f112ec60beb$export$2d7676d841c8ae9 = (0, $90IgZ.defineMessages)({
    addLink: {
        id: 'fabric.editor.mediaAddLink',
        defaultMessage: 'Add link',
        description: 'Add link'
    },
    unableToOpenLink: {
        id: 'fabric.editor.unableToOpenLink',
        defaultMessage: 'Unable to open this link',
        description: 'Unable to open this link'
    },
    unlink: {
        id: 'fabric.editor.unlink',
        defaultMessage: 'Unlink',
        description: 'Removes the hyperlink but keeps your text.'
    },
    editDatasourceStandalone: {
        id: 'fabric.editor.editDatasourceStandalone',
        defaultMessage: 'Edit',
        description: 'A standalone edit button to edit the datasource via a config modal'
    },
    editDatasourceStandaloneTooltip: {
        id: 'fabric.editor.editDatasourceStandaloneTooltip',
        defaultMessage: 'Edit search query',
        description: 'A standalone edit button tooltip to hint at editing the datasource via a config modal'
    },
    editLink: {
        id: 'fabric.editor.editLink',
        defaultMessage: 'Edit link',
        description: 'Edit the link, update display text'
    },
    placeholder: {
        id: 'fabric.editor.hyperlinkToolbarPlaceholder',
        defaultMessage: 'Paste or search for link',
        description: 'Paste or search for link'
    },
    linkPlaceholder: {
        id: 'fabric.editor.linkPlaceholder',
        defaultMessage: 'Paste link',
        description: 'Create a new link by pasting a URL.'
    },
    linkAddress: {
        id: 'fabric.editor.linkAddress',
        defaultMessage: 'Link address',
        description: 'Insert the address of the link'
    },
    invalidLink: {
        id: 'fabric.editor.invalidLink',
        defaultMessage: 'Please enter a valid link.',
        description: 'Please enter a valid link.'
    },
    emptyLink: {
        id: 'fabric.editor.emptyLink',
        defaultMessage: 'Please enter a link.',
        description: 'Please enter a link.'
    },
    settingsLink: {
        id: 'fabric.editor.settingsLinks',
        defaultMessage: 'Go to Link Preferences',
        description: 'Go to Link Preferences'
    },
    editDatasource: {
        id: 'fabric.editor.edit.datasource',
        defaultMessage: 'Edit search query',
        description: 'Datasource toolbar edit button'
    },
    searchInput: {
        id: 'fabric.editor.edit.searchInput',
        defaultMessage: 'Add a link',
        description: 'Label for the search media input'
    }
});

});

parcelRegister("3nLvm", function(module, exports) {

$parcel$export(module.exports, "codeBlockButtonMessages", () => $746db467dddb4c16$export$74e304339778e94d);

var $90IgZ = parcelRequire("90IgZ");
const $746db467dddb4c16$export$74e304339778e94d = (0, $90IgZ.defineMessages)({
    copyCodeToClipboard: {
        id: 'fabric.editor.codeBlockCopyButton.copyToClipboard',
        defaultMessage: 'Copy as text',
        description: 'Copy the content of the code block as text to your clipboard'
    },
    copiedCodeToClipboard: {
        id: 'fabric.editor.codeBlockCopyButton.copiedToClipboard',
        defaultMessage: 'Copied!',
        description: 'Copied the content of the code block as text to clipboard'
    },
    wrapCode: {
        id: 'fabric.editor.codeBlockWrapButton.wrapCodeBlock',
        defaultMessage: 'Turn on wrap',
        description: 'Wrap the content of the code block'
    },
    unwrapCode: {
        id: 'fabric.editor.codeBlockWrapButton.unwrapCodeBlock',
        defaultMessage: 'Turn off wrap',
        description: 'Wrap the content of the code block'
    },
    selectLanguage: {
        id: 'fabric.editor.selectLanguage',
        defaultMessage: 'Select language',
        description: 'Code blocks display software code. A prompt to select the software language the code is written in.'
    }
});

});

parcelRegister("cBbZY", function(module, exports) {

$parcel$export(module.exports, "toolbarInsertBlockMessages", () => $9e3b17467a1722f8$export$70c8a7203d95247);

var $90IgZ = parcelRequire("90IgZ");
const $9e3b17467a1722f8$export$70c8a7203d95247 = (0, $90IgZ.defineMessages)({
    action: {
        id: 'fabric.editor.action',
        defaultMessage: 'Action item',
        description: "Also known as a \u201Ctask\u201D, \u201Cto do item\u201D, or a checklist"
    },
    actionDescription: {
        id: 'fabric.editor.action.description',
        defaultMessage: 'Create and assign action items',
        description: ''
    },
    link: {
        id: 'fabric.editor.link',
        defaultMessage: 'Link',
        description: 'Insert a hyperlink'
    },
    linkDescription: {
        id: 'fabric.editor.link.description',
        defaultMessage: 'Insert a link',
        description: 'Insert a hyperlink'
    },
    mediaFiles: {
        id: 'fabric.editor.mediaFiles',
        defaultMessage: 'Image, video, or file',
        description: 'Insert one or more files, videos or images'
    },
    addMediaFiles: {
        id: 'fabric.editor.addMediaFiles',
        defaultMessage: 'Add image, video, or file',
        description: 'Insert one or more files, videos or images'
    },
    mediaFilesDescription: {
        id: 'fabric.editor.mediaFiles.description',
        defaultMessage: 'Add images and other files to your page',
        description: 'Insert one or more files or images'
    },
    image: {
        id: 'fabric.editor.image',
        defaultMessage: 'Image',
        description: 'Insert an image.'
    },
    mention: {
        id: 'fabric.editor.mention',
        defaultMessage: 'Mention',
        description: 'Reference another person in your document'
    },
    mentionDescription: {
        id: 'fabric.editor.mention.description',
        defaultMessage: 'Mention someone to send them a notification',
        description: 'Reference another person in your document'
    },
    emoji: {
        id: 'fabric.editor.emoji',
        defaultMessage: 'Emoji',
        description: 'Insert an emoticon or smiley :-)'
    },
    emojiDescription: {
        id: 'fabric.editor.emoji.description',
        defaultMessage: "Use emojis to express ideas \uD83C\uDF89 and emotions \uD83D\uDE04",
        description: 'Insert an emoticon or smiley :-)'
    },
    table: {
        id: 'fabric.editor.table',
        defaultMessage: 'Table',
        description: 'Inserts a table in the document'
    },
    tableDescription: {
        id: 'fabric.editor.table.description',
        defaultMessage: 'Insert a table',
        description: 'Inserts a table in the document'
    },
    tableSelector: {
        id: 'fabric.editor.tableSelector',
        defaultMessage: 'Table size',
        description: 'Opens a table selector that lets you insert a table of custom size'
    },
    tableSelectorDescription: {
        id: 'fabric.editor.tableSelector.description',
        defaultMessage: 'Add a table using popup to select a custom size',
        description: 'Opens a table selector that lets you insert a table of a custom size'
    },
    tableSizeSelectorButton: {
        id: 'fabric.editor.tableSizeSelectorButton',
        defaultMessage: '{numberOfColumns} by {numberOfRows}',
        description: 'Creates a table of custom size'
    },
    tableSizeSelectorPopup: {
        id: 'fabric.editor.tableSizeSelectorPopup',
        defaultMessage: 'Table size selector',
        description: 'Table selector popup to create table of custom size'
    },
    expand: {
        id: 'fabric.editor.expand',
        defaultMessage: 'Expand',
        description: 'Inserts an expand in the document'
    },
    expandDescription: {
        id: 'fabric.editor.expand.description',
        defaultMessage: 'Insert an expand',
        description: 'Inserts an expand in the document'
    },
    decision: {
        id: 'fabric.editor.decision',
        defaultMessage: 'Decision',
        description: "Capture a decision you\u2019ve made"
    },
    decisionDescription: {
        id: 'fabric.editor.decision.description',
        defaultMessage: "Capture decisions so they\u2019re easy to track",
        description: "Capture a decision you\u2019ve made"
    },
    feedbackDialog: {
        id: 'fabric.editor.feedbackDialog',
        defaultMessage: 'Give feedback',
        description: 'Open the feedback dialog from editor'
    },
    feedbackDialogDescription: {
        id: 'fabric.editor.feedbackDialog.description',
        defaultMessage: 'Tell us about your experience using the new editor',
        description: 'Description for feedback option under quick insert dropdown'
    },
    horizontalRule: {
        id: 'fabric.editor.horizontalRule',
        defaultMessage: 'Divider',
        description: 'A horizontal rule or divider'
    },
    horizontalRuleDescription: {
        id: 'fabric.editor.horizontalRule.description',
        defaultMessage: 'Separate content with a horizontal line',
        description: 'A horizontal rule or divider'
    },
    date: {
        id: 'fabric.editor.date',
        defaultMessage: 'Date',
        description: 'Opens a date picker that lets you select a date'
    },
    dateDescription: {
        id: 'fabric.editor.date.description',
        defaultMessage: 'Add a date using a calendar',
        description: 'Opens a date picker that lets you select a date'
    },
    placeholderText: {
        id: 'fabric.editor.placeholderText',
        defaultMessage: 'Placeholder text',
        description: 'Inserts a text placeholder into the page'
    },
    placeholderTextDescription: {
        id: 'fabric.editor.placeholderText.description',
        defaultMessage: 'Insert a text placeholder into the page',
        description: 'Inserts a text placeholder into the page'
    },
    columns: {
        id: 'fabric.editor.columns',
        defaultMessage: 'Layouts',
        description: 'Create a multi column section or layout'
    },
    columnsDescription: {
        id: 'fabric.editor.columns.description',
        defaultMessage: 'Structure your page using sections',
        description: 'Create a multi column section or layout'
    },
    status: {
        id: 'fabric.editor.status',
        defaultMessage: 'Status',
        description: 'Inserts an item representing the status of an activity to task.'
    },
    statusDescription: {
        id: 'fabric.editor.status.description',
        defaultMessage: 'Add a custom status label',
        description: 'Inserts an item representing the status of an activity to task.'
    },
    viewMore: {
        id: 'fabric.editor.viewMore',
        defaultMessage: 'View more',
        description: ''
    },
    insertMenu: {
        id: 'fabric.editor.insertMenu',
        defaultMessage: 'Insert elements',
        description: 'Opens a menu of additional items that can be inserted into your document.'
    },
    help: {
        id: 'fabric.editor.help',
        defaultMessage: 'Help',
        description: 'Opens up the help dialog'
    },
    helpDescription: {
        id: 'fabric.editor.help.description',
        defaultMessage: 'Browse all the keyboard shortcuts and markdown options',
        description: 'Browse all the keyboard shortcuts and markdown options'
    },
    recordVideo: {
        id: 'fabric.editor.recordVideo',
        defaultMessage: 'Record a Loom video',
        description: 'Record a Loom video'
    },
    addLoomVideo: {
        id: 'fabric.editor.addLoomVideo',
        defaultMessage: 'Record a Loom video',
        description: 'Record a Loom video'
    },
    addLoomVideoComment: {
        id: 'fabric.editor.addLoomVideoComment',
        defaultMessage: 'Record a Loom video comment',
        description: 'Record a Loom video comment'
    },
    recordVideoDescription: {
        id: 'fabric.editor.recordVideo.description',
        defaultMessage: 'Record and share your screen and thoughts',
        description: 'Record and share your screen and thoughts'
    },
    recordLoomShortTitle: {
        id: 'fabric.editor.recordLoomShortTitle',
        defaultMessage: 'Record',
        description: 'Record'
    }
});

});

parcelRegister("f0Ytd", function(module, exports) {

$parcel$export(module.exports, "toolbarMessages", () => $90786a7d58942cd8$export$81b075fd34c2f0bb);

var $90IgZ = parcelRequire("90IgZ");
const $90786a7d58942cd8$export$81b075fd34c2f0bb = (0, $90IgZ.defineMessages)({
    wrapLeft: {
        id: 'fabric.editor.wrapLeft',
        defaultMessage: 'Wrap left',
        description: 'Aligns your image to the left and wraps text around it.'
    },
    wrapRight: {
        id: 'fabric.editor.wrapRight',
        defaultMessage: 'Wrap right',
        description: 'Aligns your image to the right and wraps text around it.'
    },
    changeToMediaSingle: {
        id: 'fabric.editor.media_change_mediasingle',
        defaultMessage: 'Original size',
        description: 'In the context of a media inline image, it allows the user to convert it to media single'
    },
    changeToMediaInlineImage: {
        id: 'fabric.editor.media_change_mediainline_default',
        defaultMessage: 'Inline',
        description: 'In the context of media single contains media node, it allows the user to convert media single to media inline image'
    },
    changeToMediaInlineImageCaptionWarning: {
        id: 'fabric.editor.media_change_mediainline_caption_warn',
        defaultMessage: 'Inline (caption will be removed)',
        description: 'In the context of media single contains media node, it allows the user to convert media single to media inline image and warn user about caption being removed'
    }
});

});

parcelRegister("dgXkb", function(module, exports) {

$parcel$export(module.exports, "messages", () => $487e431f21163a94$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $487e431f21163a94$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    url: {
        id: 'fabric.editor.url',
        defaultMessage: 'Display URL',
        description: 'Convert the card to become a regular text-based hyperlink.'
    },
    block: {
        id: 'fabric.editor.displayBlock',
        defaultMessage: 'Display card',
        description: 'Display link as a card with a rich preview similar to in a Facebook feed with page title, description, and potentially an image.'
    },
    inline: {
        id: 'fabric.editor.displayInline',
        defaultMessage: 'Display inline',
        description: 'Display link with the title only.'
    },
    embed: {
        id: 'fabric.editor.displayEmbed',
        defaultMessage: 'Display embed',
        description: 'Display link as an embedded object'
    },
    link: {
        id: 'fabric.editor.displayLink',
        defaultMessage: 'Display as text',
        description: 'Convert the card to become a regular text-based hyperlink.'
    },
    card: {
        id: 'fabric.editor.cardFloatingControls',
        defaultMessage: 'Card options',
        description: 'Options to change card type'
    },
    blockCardUnavailable: {
        id: 'fabric.editor.blockCardUnavailable',
        defaultMessage: 'The inline link is inside {node} and cannot have its view changed',
        description: 'Warning message to show the user that this node cannot change its view'
    },
    displayOptionUnavailableInParentNode: {
        id: 'fabric.editor.displayOptionUnavailableInParentNode',
        defaultMessage: "This display option isn't available inside {node}",
        description: 'Warning message to show the user that this node option is not available inside a parent node type'
    },
    urlTitle: {
        id: 'fabric.editor.urlTitle',
        defaultMessage: 'URL',
        description: 'Title for option to convert the card to become a regular text-based hyperlink.'
    },
    blockTitle: {
        id: 'fabric.editor.blockTitle',
        defaultMessage: 'Card',
        description: 'Title for option to display link in the card view.'
    },
    inlineTitle: {
        id: 'fabric.editor.inlineTitle',
        defaultMessage: 'Inline',
        description: 'Title for option to display link in the inline view.'
    },
    embedTitle: {
        id: 'fabric.editor.embedTitle',
        defaultMessage: 'Embed',
        description: 'Title for option to display link as an embedded object.'
    },
    urlDescription: {
        id: 'fabric.editor.urlDescription',
        defaultMessage: 'Display link as URL',
        description: 'Description for option to convert the card to become a regular text-based hyperlink.'
    },
    blockDescription: {
        id: 'fabric.editor.blockDescription',
        defaultMessage: 'Display more information about a link, including a summary and actions',
        description: 'Description for option to display link in the card view.'
    },
    inlineDescription: {
        id: 'fabric.editor.inlineDescription',
        defaultMessage: 'Display link as inline text',
        description: 'Description for option to display link in the inline view.'
    },
    embedDescription: {
        id: 'fabric.editor.ecombedDescription',
        defaultMessage: 'Display an interactive preview of a link',
        description: 'Description for option to display link as an embedded object.'
    },
    editDropdownExpandIconLabel: {
        id: 'fabric.editor.editDropdownExpandIconLabel',
        defaultMessage: 'Expand dropdown menu',
        description: 'Text of an icon to expand the dropdown'
    },
    editDropdownTriggerTitle: {
        id: 'fabric.editor.editDropdownTriggerTitle',
        defaultMessage: 'Edit',
        description: 'Text of a button to trigger opening an edit dropdown'
    },
    editDropdownEditLinkTitle: {
        id: 'fabric.editor.editDropdownEditLinkTitle',
        defaultMessage: 'Edit link',
        description: 'Edit dropdown edit link button text'
    },
    editDropdownEditDatasourceTitle: {
        id: 'fabric.editor.editDropdownEditDatasourceTitle',
        defaultMessage: 'Edit search query',
        description: 'Edit dropdown edit datasource button text'
    },
    datasourceTitle: {
        id: 'fabric.editor.datasourceTitle',
        defaultMessage: 'Edit search query',
        description: 'Tooltip of button to edit a card into a datasource'
    },
    datasourceAppearanceTitle: {
        id: 'fabric.editor.datasourceAppearanceTitle',
        defaultMessage: 'List',
        description: 'Tooltip of button to change to datasource appearance'
    },
    datasourceJiraIssue: {
        id: 'fabric.editor.datasource.jiraIssue',
        defaultMessage: 'Jira Issues',
        description: 'Insert a jira datasource table'
    },
    datasourceJiraIssueDescription: {
        id: 'fabric.editor.datasource.jiraIssue.description',
        defaultMessage: 'Insert Jira issues from Jira Cloud with enhanced search, filtering, and configuration.',
        description: 'Insert a jira datasource table'
    },
    datasourceAssetsObjectsGeneralAvailability: {
        id: 'fabric.editor.datasource.assetsObjectsGeneralAvailability',
        defaultMessage: 'Assets',
        description: 'Text displayed when selecting the type of data to include onto the page, in this case: JSM Assets objects.'
    },
    datasourceAssetsObjects: {
        id: 'fabric.editor.datasource.assetsObjects',
        defaultMessage: 'Assets (Beta)',
        description: 'Text displayed when selecting the type of data to include onto the page, in this case: JSM Assets objects. This feature is currently in Beta release, so we also include messaging for that.'
    },
    datasourceAssetsObjectsDescription: {
        id: 'fabric.editor.datasource.assetsObjects.description',
        defaultMessage: 'Insert objects from Assets in Jira Service Management with search and filtering',
        description: 'Description text displayed when selecting the type of data to include onto the page, in this case: JSM Assets objects'
    },
    inlineOverlay: {
        id: 'fabric.editor.inlineOverlay',
        defaultMessage: 'Configure',
        description: 'An overlay shown when hover over inline smart link to inform user that they can click the link to edit the links appearance.'
    },
    inlineConfigureLink: {
        id: 'fabric.editor.inlineConfigureLink',
        defaultMessage: 'Configure link',
        description: 'An icon shown when hovering over inline smart link to inform user they can click the icon to configure the links appearance.'
    },
    inlineGoToLink: {
        id: 'fabric.editor.inlineGoToLink',
        defaultMessage: 'Go to link',
        description: 'An option in the configure link dropdown that informs the user they can click the option to open the link'
    },
    datasourceConfluenceSearch: {
        id: 'fabric.editor.datasource.confluenceSearch',
        defaultMessage: 'Insert Confluence list',
        description: 'Title shown for Confluence Search datasource on QuickInsert options'
    },
    datasourceConfluenceSearchDescription: {
        id: 'fabric.editor.datasource.confluenceSearch.description',
        defaultMessage: 'Insert list of search results from Confluence with enhanced search, filtering, and configuration.',
        description: 'Description text displayed when selecting the type of data to include onto the page, in this case: Confluence Search objects'
    }
});

});

parcelRegister("gxhGk", function(module, exports) {

$parcel$export(module.exports, "messages", () => $34ce1140d22932eb$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $34ce1140d22932eb$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    toolbarLabel: {
        id: 'fabric.editor.toolbarLabel',
        defaultMessage: 'Editor',
        description: 'Label for the ARIA region landmark'
    },
    pageActionsLabel: {
        id: 'fabric.editor.pageActionsLabel',
        defaultMessage: 'Page actions',
        description: 'Label for the ARIA region landmark'
    },
    editableContentLabel: {
        id: 'fabric.editor.editableContentLabel',
        defaultMessage: 'Editable content',
        description: 'Label for the ARIA region landmark'
    }
});

});

parcelRegister("3nLS5", function(module, exports) {

$parcel$export(module.exports, "toolbarMessages", () => $4ddae2f112066626$export$81b075fd34c2f0bb);

var $90IgZ = parcelRequire("90IgZ");
const $4ddae2f112066626$export$81b075fd34c2f0bb = (0, $90IgZ.defineMessages)({
    underline: {
        id: 'fabric.editor.underline',
        defaultMessage: 'Underline',
        description: 'Whether the text selection has underlined text'
    },
    strike: {
        id: 'fabric.editor.strike',
        defaultMessage: 'Strikethrough',
        description: 'Whether the text selection has crossed out text'
    },
    code: {
        id: 'fabric.editor.code',
        defaultMessage: 'Code',
        description: 'Whether the text selection has monospaced/code font'
    },
    codeOn: {
        id: 'fabric.editor.code.on',
        defaultMessage: '{textFormattingOff}, Code On',
        description: 'Reports that code formatting has been turned on'
    },
    subscript: {
        id: 'fabric.editor.subscript',
        defaultMessage: 'Subscript',
        description: 'Whether the text selection is written below the line in a slightly smaller size'
    },
    subscriptOffSuperscriptOn: {
        id: 'fabric.editor.subscript.off.superscript.on',
        defaultMessage: 'Subscript Off, Superscript On',
        description: 'Reports text formatting in case when subscript off and superscript on'
    },
    superscript: {
        id: 'fabric.editor.superscript',
        defaultMessage: 'Superscript',
        description: 'Whether the text selection is written above the line in a slightly smaller size'
    },
    superscriptOffSubscriptOn: {
        id: 'fabric.editor.superscript.off.subscript.on',
        defaultMessage: 'Superscript Off, Subscript On',
        description: 'Describe text formatting in case when Superscript Off and Subscript on'
    },
    clearFormatting: {
        id: 'fabric.editor.clearFormatting',
        defaultMessage: 'Clear formatting',
        description: 'Remove all rich text formatting from the selected text'
    },
    moreFormatting: {
        id: 'fabric.editor.moreFormatting',
        defaultMessage: 'More formatting',
        description: 'Clicking this will show a menu with additional formatting options'
    },
    textFormatting: {
        id: 'fabric.editor.textFormatting',
        defaultMessage: 'Text formatting',
        description: 'Aria label for the wrapper of text format buttons'
    },
    bold: {
        id: 'fabric.editor.bold',
        defaultMessage: 'Bold',
        description: "This refers to bold or \u201Cstrong\u201D formatting, indicates that its contents have strong importance, seriousness, or urgency."
    },
    italic: {
        id: 'fabric.editor.italic',
        defaultMessage: 'Italic',
        description: 'This refers to italics or emphasized formatting.'
    },
    on: {
        id: 'fabric.editor.on',
        defaultMessage: '{formattingType} On',
        description: 'Reports that text formatting has been turned on'
    },
    off: {
        id: 'fabric.editor.off',
        defaultMessage: '{formattingType} Off',
        description: 'Reports that text formatting has been turned off'
    },
    textStyles: {
        id: 'fabric.editor.textStyles',
        defaultMessage: '{blockTypeName} Text styles',
        description: 'Menu label that provides access to various heading styles or normal text. For example: normal text styles, heading 1 text styles.'
    },
    textStylesTooltip: {
        id: 'fabric.editor.textStylesTooltip',
        defaultMessage: 'Text styles',
        description: 'Tooltip text for menu that provides access to various heading styles or normal text.'
    },
    textFormattingOff: {
        id: 'fabric.editor.text.formatting.off',
        defaultMessage: 'Text formatting Off',
        description: 'Reports that text formatting has been turned off'
    },
    navigateToEditorToolbar: {
        id: 'fabric.editor.navigate.toolbar.editor',
        defaultMessage: 'Navigate to editor toolbar',
        description: 'Navigate to the main editor toolbar.'
    },
    navigateToFloatingToolbar: {
        id: 'fabric.editor.navigate.toolbar.floating',
        defaultMessage: 'Navigate to floating toolbar',
        description: 'Navigate to a floating toolbar for relevant nodes (e.g. tables or panels).'
    }
});

});

parcelRegister("aWXsE", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8d88a2512df54a18$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $8d88a2512df54a18$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    tableOptions: {
        id: 'fabric.editor.tableOptions',
        defaultMessage: 'Table options',
        description: 'Opens a menu with additional table options'
    },
    tableSizeIncreaseScreenReaderInformation: {
        id: 'fabric.editor.tableResizeIncreaseScreenReaderInformation',
        defaultMessage: 'Table width increased to {newWidth, plural, one {# pixel} other {# pixels}}.',
        description: 'Information for screen reader users about increasing the table size by a certain number of pixels.'
    },
    tableSizeDecreaseScreenReaderInformation: {
        id: 'fabric.editor.tableResizeDecreaseScreenReaderInformation',
        defaultMessage: 'Table width decreased to {newWidth, plural, one {# pixel} other {# pixels}}.',
        description: 'Information for screen reader users about decreasing the table size by a certain number of pixels.'
    },
    headerRow: {
        id: 'fabric.editor.headerRow',
        defaultMessage: 'Header row',
        description: 'Marks the first table row as a header row'
    },
    headerColumn: {
        id: 'fabric.editor.headerColumn',
        defaultMessage: 'Header column',
        description: 'Marks the first table column as a header row'
    },
    numberedColumn: {
        id: 'fabric.editor.numberedColumn',
        defaultMessage: 'Numbered column',
        description: 'Adds an auto-numbering column to your table'
    },
    collapseTable: {
        id: 'fabric.editor.collapseTable',
        defaultMessage: 'Collapse table',
        description: 'Wraps table in an expand'
    },
    resizeTable: {
        id: 'fabric.editor.tables.resizeTable',
        defaultMessage: 'Resize table',
        description: 'Tooltip displayed on custom table width resize hande'
    },
    insertColumn: {
        id: 'fabric.editor.insertColumn',
        defaultMessage: 'Insert column right',
        description: 'Inserts a new column to the right of selected column.'
    },
    addColumnLeft: {
        id: 'fabric.editor.addColumnLeft',
        defaultMessage: 'Add column left',
        description: 'Adds a new column to the left of selected column.'
    },
    addColumnRight: {
        id: 'fabric.editor.addColumnRight',
        defaultMessage: 'Add column right',
        description: 'Adds a new column to the right of selected column.'
    },
    insertColumnDrag: {
        id: 'fabric.editor.insertColumnDrag',
        defaultMessage: 'Insert column',
        description: 'Inserts a new column to the right of selected column.'
    },
    removeColumns: {
        id: 'fabric.editor.removeColumns',
        defaultMessage: 'Delete {0, plural, one {column} other {columns}}',
        description: 'Deletes a table column.'
    },
    insertRow: {
        id: 'fabric.editor.insertRow',
        defaultMessage: 'Insert row below',
        description: 'Inserts a new row below the selected row.'
    },
    addRowAbove: {
        id: 'fabric.editor.addRowAbove',
        defaultMessage: 'Add row above',
        description: 'Adds a new row above the selected row.'
    },
    addRowBelow: {
        id: 'fabric.editor.addRowBelow',
        defaultMessage: 'Add row below',
        description: 'Adds a new row below the selected row.'
    },
    moveColumnLeft: {
        id: 'fabric.editor.moveColumnLeft',
        defaultMessage: 'Move {0, plural, one {column} other {columns}} left',
        description: 'Moves a column or columns to the left.'
    },
    moveColumnRight: {
        id: 'fabric.editor.moveColumnRight',
        defaultMessage: 'Move {0, plural, one {column} other {columns}} right',
        description: 'Moves a column or columns to the right.'
    },
    moveRowUp: {
        id: 'fabric.editor.moveRowUp',
        defaultMessage: 'Move {0, plural, one {row} other {rows}} up',
        description: 'Moves a row or selected rows up.'
    },
    moveRowDown: {
        id: 'fabric.editor.moveDownDown',
        defaultMessage: 'Move {0, plural, one {row} other {rows}} down',
        description: 'Moves a row or selected rows down.'
    },
    insertRowDrag: {
        id: 'fabric.editor.insertRowDrag',
        defaultMessage: 'Insert row',
        description: 'Inserts a new row below the selected row.'
    },
    removeRows: {
        id: 'fabric.editor.removeRows',
        defaultMessage: 'Delete {0, plural, one {row} other {rows}}',
        description: 'Deletes a table row.'
    },
    rowNumbers: {
        id: 'fabrid.editor.rowNumbers',
        defaultMessage: 'Row numbers',
        desciption: 'Adds a number to each row except header row'
    },
    rowsAreInserted: {
        id: 'fabric.editor.rowsAreInserted',
        defaultMessage: '{count, plural, one {A row has been} other {{count} rows have been}} inserted',
        description: 'Assistive message following the insertion of row(s)'
    },
    rowsAreRemoved: {
        id: 'fabric.editor.rowsAreRemoved',
        defaultMessage: '{count, plural, one {The row has been} other {{count} rows have been}} removed',
        description: 'Assistive message following the removal of row(s)'
    },
    columnsAreInserted: {
        id: 'fabric.editor.columnsAreInserted',
        defaultMessage: '{count, plural, one {A column has been} other {{count} columns have been}} inserted',
        description: 'Assistive message following the insertion of column(s)'
    },
    columnsAreRemoved: {
        id: 'fabric.editor.columnsAreRemoved',
        defaultMessage: '{count, plural, one {The column has been} other {{count} columns have been}} removed',
        description: 'Assistive message following the removal of column(s)'
    },
    cellOptions: {
        id: 'fabric.editor.cellOptions',
        defaultMessage: 'Cell options',
        description: 'Opens a menu with options for the current table cell.'
    },
    confirmDeleteLinkedModalOKButton: {
        id: 'fabric.editor.tables.confirmDeleteLinkedModalOKButton',
        defaultMessage: 'Delete',
        description: 'Action button label for confirm modal when deleting a table linked to an extension.'
    },
    confirmDeleteLinkedModalMessage: {
        id: 'fabric.editor.tables.confirmDeleteLinkedModalMessage',
        defaultMessage: 'Deleting {nodeName} will break anything connected to it.',
        description: 'Message for confirm modal when deleting a table linked to an extension.'
    },
    confirmDeleteLinkedModalMessagePrefix: {
        id: 'fabric.editor.extension.confirmDeleteLinkedModalMessagePrefix',
        defaultMessage: 'Deleting',
        description: 'prefix for confirmation dialog text'
    },
    confirmModalCheckboxLabel: {
        id: 'fabric.editor.floatingToolbar.confirmModalCheckboxLabel',
        defaultMessage: 'Also delete connected elements',
        description: 'checkbox label text'
    },
    deleteElementTitle: {
        id: 'fabric.editor.extension.deleteElementTitle',
        defaultMessage: 'Delete element',
        description: 'Title text for confirm modal when deleting an extension linked to a data consumer.'
    },
    unnamedSource: {
        id: 'fabric.editor.extension.sourceNoTitledName',
        defaultMessage: 'this element',
        description: 'The current element without preset name been selected'
    },
    adjustColumns: {
        id: 'fabric.editor.tables.adjustColumn',
        defaultMessage: 'Adjust column',
        description: 'Tooltip displayed on table column resize handle'
    },
    cornerControl: {
        id: 'fabric.editor.cornerControl',
        defaultMessage: 'Highlight table',
        description: 'A button on the upper left corner of the table that shows up when the table is in focus. Clicking on it will select the entire table.'
    },
    cellBackground: {
        id: 'fabric.editor.cellBackground',
        defaultMessage: 'Cell background',
        description: 'Change the background color of a table cell.'
    },
    backgroundColor: {
        id: 'fabric.editor.backgroundColor',
        defaultMessage: 'Background color',
        description: 'Change the background color of a table cell.'
    },
    mergeCells: {
        id: 'fabric.editor.mergeCells',
        defaultMessage: 'Merge cells',
        description: 'Merge tables cells together.'
    },
    splitCell: {
        id: 'fabric.editor.splitCell',
        defaultMessage: 'Split cell',
        description: 'Split a merged table cell.'
    },
    clearCells: {
        id: 'fabric.editor.clearCells',
        defaultMessage: 'Clear {0, plural, one {cell} other {cells}}',
        description: 'Clears the contents of the selected cells (this does not delete the cells themselves).'
    },
    sortColumnASC: {
        id: 'fabric.editor.sortColumnASC',
        defaultMessage: "Sort column A \u2192 Z",
        description: 'Sort column in ascending order'
    },
    sortColumnDESC: {
        id: 'fabric.editor.sortColumnDESC',
        defaultMessage: "Sort column Z \u2192 A",
        description: 'Sort column in descending order'
    },
    sortColumnIncreasing: {
        id: 'fabric.editor.sortColumnIncreasing',
        defaultMessage: 'Sort increasing',
        description: 'Sort column in ascending order'
    },
    sortColumnDecreasing: {
        id: 'fabric.editor.sortColumnDecreasing',
        defaultMessage: 'Sort decreasing',
        description: 'Sort column in descending order'
    },
    canNotSortTable: {
        id: 'fabric.editor.canNotSortTable',
        defaultMessage: `\u{26A0}\u{FE0F} You can't sort a table with merged cells`,
        description: `Split your cells to enable this feature`
    },
    distributeColumns: {
        id: 'fabric.editor.distributeColumns',
        defaultMessage: `Distribute columns`,
        description: `Distribute widths between selected columns`
    },
    lockColumnWidths: {
        id: 'fabric.editor.lockColumns',
        defaultMessage: 'Fixed column widths',
        description: 'Toggle button to enable fixed column widths'
    },
    rowControl: {
        id: 'fabric.editor.rowControl',
        defaultMessage: 'Highlight row',
        description: 'A button on the left of each row that shows up when the table is in focus. Clicking on it will select the entire row.'
    },
    rowDragHandle: {
        id: 'fabric.editor.rowDragHandle',
        defaultMessage: 'Row options',
        description: 'The row drag handle to move the row within the table. Click to open a menu for more row options.'
    },
    columnDragHandle: {
        id: 'fabric.editor.columnDragHandle',
        defaultMessage: 'Column options',
        description: 'The column drag handle to move the column within the table. Click to open a menu for more column options.'
    },
    fullWidthLabel: {
        id: 'fabric.editor.tableFullWidthLabel',
        defaultMessage: 'Full-width',
        description: 'Trigger table width to full-width mode'
    },
    startedColumnResize: {
        id: 'fabric.editor.tables.startedColumnResize',
        defaultMessage: 'Started column resize',
        description: 'Screen Reader announces when the user engages the column resizer'
    },
    focusedOtherResize: {
        id: 'fabric.editor.tables.otherResize',
        defaultMessage: '{direction, select, left {Switched to the left column resize} right {Switched to the right column resize} other {}}',
        description: 'Screen Reader announces when the user switches to the left or right column resizer'
    },
    changedColumnWidth: {
        id: 'fabric.editor.tables.columnWidth',
        defaultMessage: '{width, plural, one {Column width was changed to {width} pixel} other {Column width was changed to {width} pixels}}',
        description: 'Screen Reader announces when the user modifies the column width'
    },
    columnResizeStop: {
        id: 'fabric.editor.tables.resizeStop',
        defaultMessage: 'Stopped resize',
        description: 'Screen Reader announces when the user discontinues the resizing operation'
    },
    columnResizeOverflow: {
        id: 'fabric.editor.tables.columnResizeOverflow',
        defaultMessage: 'You can only resize this column while the table has a scroll bar.',
        description: 'Screen Reader announces when the user attempts to resize the last column without the table being in overflow state'
    },
    columnResizeLast: {
        id: 'fabric.editor.tables.columnResizeLast',
        defaultMessage: 'You can only resize this column to the left.',
        description: 'Screen Reader announces when the user attempts to resize the last column when only the previous one is available for resizing'
    },
    tableAlignmentOptions: {
        id: 'fabric.editor.tableAlignmentOptions',
        defaultMessage: 'Alignment options',
        description: 'Opens a menu with additional table alignment options'
    },
    alignTableCenter: {
        id: 'fabric.editor.alignTableCenter',
        defaultMessage: 'Align center',
        description: 'Aligns table to the center'
    },
    alignTableLeft: {
        id: 'fabric.editor.alignTableLeft',
        defaultMessage: 'Align left',
        description: 'Aligns table to the left'
    }
});

});

parcelRegister("kRwaf", function(module, exports) {

$parcel$export(module.exports, "messages", () => $3ecd38f7fae129df$export$defe85febe8b728c);
// Common Translations will live here

var $90IgZ = parcelRequire("90IgZ");
const $3ecd38f7fae129df$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    unorderedList: {
        id: 'fabric.editor.unorderedList',
        defaultMessage: 'Bullet list',
        description: "A list with bullets. Also known as an \u201Cunordered\u201D list"
    },
    unorderedListDescription: {
        id: 'fabric.editor.unorderedList.description',
        defaultMessage: 'Create an unordered list',
        description: ''
    },
    orderedList: {
        id: 'fabric.editor.orderedList',
        defaultMessage: 'Numbered list',
        description: "A list with ordered items 1\u2026 2\u2026 3\u2026"
    },
    orderedListDescription: {
        id: 'fabric.editor.orderedList.description',
        defaultMessage: 'Create an ordered list',
        description: ''
    },
    lists: {
        id: 'fabric.editor.lists',
        defaultMessage: 'Lists',
        description: 'Menu shows ordered/bullet list and unordered/numbered lists'
    },
    listsFormat: {
        id: 'fabric.editor.listsFormat',
        defaultMessage: 'List formatting',
        description: 'Aria label for the wrapper of list buttons'
    }
});

});

parcelRegister("jlXTA", function(module, exports) {

$parcel$export(module.exports, "messages", () => $b45c2149401d6a9b$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $b45c2149401d6a9b$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    undo: {
        id: 'fabric.editor.undo',
        defaultMessage: 'Undo',
        description: 'Undo the previously performed action.'
    },
    redo: {
        id: 'fabric.editor.redo',
        defaultMessage: 'Redo',
        description: 'Redo the previously undone action.'
    }
});

});

parcelRegister("cV3Z1", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c7d625ff9c848147$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $c7d625ff9c848147$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    placeholder: {
        id: 'fabric.editor.statusPlaceholder',
        defaultMessage: 'Set a status',
        description: 'Placeholder description for an empty (new) status item in the editor'
    },
    editText: {
        id: 'fabric.editor.editStatusText',
        defaultMessage: 'Edit Status',
        description: 'Title for the input that changes the status text'
    },
    editColor: {
        id: 'fabric.editor.editStatusColor',
        defaultMessage: 'Edit Status Color',
        description: 'Title for the color picker that changes the status color'
    }
});

});

parcelRegister("gzJN4", function(module, exports) {

$parcel$export(module.exports, "messages", () => $83ce02220bb0efb9$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $83ce02220bb0efb9$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    editText: {
        id: 'fabric.editor.editDateText',
        defaultMessage: 'Edit Date',
        description: 'Title for the input that changes the date'
    },
    invalidDateError: {
        id: 'fabric.editor.invalidDateError',
        defaultMessage: 'Enter a valid date',
        description: 'Error message when the date typed in is invalid, requesting they inputs a new date'
    },
    onKeyUpDownText: {
        id: 'fabric.editor.upDown',
        defaultMessage: 'On the use of up and down arrow keys into the following input field, the date will update below',
        description: 'The text for the date input informs the user that using the arrow keys (up and down) will update the date picker below'
    }
});

});

parcelRegister("gRnnR", function(module, exports) {

$parcel$export(module.exports, "toolbarMessages", () => $25542adb992d74a9$export$81b075fd34c2f0bb);

var $90IgZ = parcelRequire("90IgZ");
const $25542adb992d74a9$export$81b075fd34c2f0bb = (0, $90IgZ.defineMessages)({
    singleColumn: {
        id: 'fabric.editor.single',
        defaultMessage: 'Single column layout',
        description: 'Layout with one single column'
    },
    twoColumns: {
        id: 'fabric.editor.twoColumns',
        defaultMessage: 'Two columns layout',
        description: 'Layout with two columns of equal width'
    },
    threeColumns: {
        id: 'fabric.editor.threeColumns',
        defaultMessage: 'Three columns layout',
        description: 'Layout with three columns of equal width'
    },
    rightSidebar: {
        id: 'fabric.editor.rightSidebar',
        defaultMessage: 'Right sidebar layout',
        description: 'Layout with two columns, left column is 2/3 and right is 1/3 of page'
    },
    leftSidebar: {
        id: 'fabric.editor.leftSidebar',
        defaultMessage: 'Left sidebar layout',
        description: 'Layout with two columns, left column is 1/3 and right is 2/3 of page'
    },
    threeColumnsWithSidebars: {
        id: 'fabric.editor.threeColumnsWithSidebars',
        defaultMessage: 'Three columns with sidebars layout',
        description: 'Layout with 3 columns laid out as 25% - 50% - 25%'
    },
    floatingToolbarRadioGroupAriaLabel: {
        id: 'fabric.editor.floatingToolbar.floatingToolbarRadioGroupAriaLabel',
        defaultMessage: 'Layout options',
        description: "a floating toolbar radiogroup's aria label"
    }
});

});

parcelRegister("cHLhY", function(module, exports) {

$parcel$export(module.exports, "messages", () => $6e3da37fbdace53a$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $6e3da37fbdace53a$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    indent: {
        id: 'fabric.editor.indent',
        defaultMessage: 'Indent',
        description: 'Indent a list item, paragraph or heading'
    },
    outdent: {
        id: 'fabric.editor.outdent',
        defaultMessage: 'Outdent',
        description: 'Outdent a list item, paragraph or heading'
    }
});

});

parcelRegister("eQYNZ", function(module, exports) {

$parcel$export(module.exports, "avatarGroupMessages", () => $9043d79e240ee2bc$export$8a0e7c3f8f5b8868);

var $90IgZ = parcelRequire("90IgZ");
const $9043d79e240ee2bc$export$8a0e7c3f8f5b8868 = (0, $90IgZ.defineMessages)({
    editors: {
        id: 'fabric.editor.editors',
        defaultMessage: 'Editors',
        description: 'classifying the people that are currently editing the document'
    }
});

});

parcelRegister("huXFb", function(module, exports) {

$parcel$export(module.exports, "findReplaceMessages", () => $3c5fdd44b2d3ce90$export$b46a930e1a386b2e);

var $90IgZ = parcelRequire("90IgZ");
const $3c5fdd44b2d3ce90$export$b46a930e1a386b2e = (0, $90IgZ.defineMessages)({
    find: {
        id: 'fabric.editor.find',
        defaultMessage: 'Find',
        description: 'The word or phrase to search for on the document'
    },
    matchCase: {
        id: 'fabric.editor.matchCase',
        defaultMessage: 'Match case',
        description: 'Toggle whether should also match case when searching for text'
    },
    findNext: {
        id: 'fabric.editor.findNext',
        defaultMessage: 'Find next',
        description: 'Locate the next occurrence of the word or phrase that was searched for'
    },
    findPrevious: {
        id: 'fabric.editor.findPrevious',
        defaultMessage: 'Find previous',
        description: 'Locate the previous occurrence of the word or phrase that was searched for'
    },
    closeFindReplaceDialog: {
        id: 'fabric.editor.closeFindReplaceDialog',
        defaultMessage: 'Close',
        description: 'Cancel search and close the "Find and Replace" dialog'
    },
    noResultsFound: {
        id: 'fabric.editor.noResultsFound',
        defaultMessage: 'No results',
        description: 'No matches were found for the word or phrase that was searched for'
    },
    resultsCount: {
        id: 'fabric.editor.resultsCount',
        description: 'Text for selected search match position and total results count',
        defaultMessage: '{selectedMatchPosition} of {totalResultsCount}'
    },
    findReplaceToolbarButton: {
        id: 'fabric.editor.findReplaceToolbarButton',
        defaultMessage: 'Find and replace',
        description: '"Find" highlights all instances of a word or phrase on the document, and "Replace" changes one or all of those instances to something else'
    },
    replaceWith: {
        id: 'fabric.editor.replaceWith',
        defaultMessage: 'Replace with',
        description: 'The value that will replace the word or phrase that was searched for'
    },
    replace: {
        id: 'fabric.editor.replace',
        defaultMessage: 'Replace',
        description: 'Replace only the currently selected instance of the word or phrase'
    },
    replaceAll: {
        id: 'fabric.editor.replaceAll',
        defaultMessage: 'Replace all',
        description: 'Replace all instances of the word or phrase throughout the entire document'
    },
    replaceSuccess: {
        id: 'fabric.editor.replaceSuccess',
        defaultMessage: '{numberOfMatches, plural, one {# match replaced} other {# matches replaced}}',
        description: 'Text when replacement succesfully done'
    }
});

});

parcelRegister("5Jyfy", function(module, exports) {

$parcel$export(module.exports, "textColorMessages", () => $659712c134e63f96$export$effb4ee8b6f74abe);

var $90IgZ = parcelRequire("90IgZ");
const $659712c134e63f96$export$effb4ee8b6f74abe = (0, $90IgZ.defineMessages)({
    textColor: {
        id: 'fabric.editor.textColor',
        defaultMessage: '{selectedColorName} Text color',
        description: 'Label of menu that provides access to various colors of text. For example: green Text color, dark blue Text color'
    },
    textColorTooltip: {
        id: 'fabric.editor.textColorTooltip',
        defaultMessage: 'Text color',
        description: 'Toolip of menu that provides access to various colors of text.'
    }
});

});

parcelRegister("esoLD", function(module, exports) {

$parcel$export(module.exports, "tasksAndDecisionsMessages", () => $f7043a77b8e9aaee$export$273d864e9e6d0b1f);

var $90IgZ = parcelRequire("90IgZ");
const $f7043a77b8e9aaee$export$273d864e9e6d0b1f = (0, $90IgZ.defineMessages)({
    taskPlaceholder: {
        id: 'fabric.editor.taskPlaceholder',
        defaultMessage: "Type your action, use '@' to assign to someone.",
        description: 'Placeholder description for an empty action/task in the editor'
    },
    decisionPlaceholder: {
        id: 'fabric.editor.decisionPlaceholder',
        defaultMessage: "Add a decision\u2026",
        description: 'Placeholder description for an empty decision in the editor'
    }
});

});

parcelRegister("15J3I", function(module, exports) {

$parcel$export(module.exports, "placeholderTextMessages", () => $06a5c9e158322ba9$export$ee8ab8a034b5a8bd);

var $90IgZ = parcelRequire("90IgZ");
const $06a5c9e158322ba9$export$ee8ab8a034b5a8bd = (0, $90IgZ.defineMessages)({
    placeholderTextPlaceholder: {
        id: 'fabric.editor.placeholderTextPlaceholder',
        defaultMessage: 'Add placeholder text',
        description: ''
    }
});

});

parcelRegister("9dZ3f", function(module, exports) {

$parcel$export(module.exports, "pasteOptionsToolbarMessages", () => $29826be79024dd4b$export$703e803e9cb0cea4);

var $90IgZ = parcelRequire("90IgZ");
const $29826be79024dd4b$export$703e803e9cb0cea4 = (0, $90IgZ.defineMessages)({
    pasteOptions: {
        id: 'fabric.editor.pasteOptions',
        defaultMessage: 'Paste options',
        description: 'Opens a menu with additional paste options'
    },
    plainText: {
        id: 'fabric.editor.plainText',
        defaultMessage: 'Use plain text',
        description: 'Converts pasted text into plain text'
    },
    markdown: {
        id: 'fabric.editor.useMarkdown',
        defaultMessage: 'Use Markdown',
        description: 'Converts pasted text into Markdown'
    },
    richText: {
        id: 'fabric.editor.richText',
        defaultMessage: 'Use rich text',
        description: 'Converts pasted text into Rich text'
    }
});

});

parcelRegister("6qPs9", function(module, exports) {

$parcel$export(module.exports, "panelMessages", () => $a6f005da1ccf8afc$export$7bb18eb6f9170174);

var $90IgZ = parcelRequire("90IgZ");
const $a6f005da1ccf8afc$export$7bb18eb6f9170174 = (0, $90IgZ.defineMessages)({
    info: {
        id: 'fabric.editor.info',
        defaultMessage: 'Info',
        description: 'Panels provide a way to highlight text. The info panel has a blue background.'
    },
    note: {
        id: 'fabric.editor.note',
        defaultMessage: 'Note',
        description: 'Panels provide a way to highlight text. The note panel has a purple background.'
    },
    success: {
        id: 'fabric.editor.success',
        defaultMessage: 'Success',
        description: 'Panels provide a way to highlight text. The success panel has a green background.'
    },
    warning: {
        id: 'fabric.editor.warning',
        defaultMessage: 'Warning',
        description: 'Panels provide a way to highlight text. The warning panel has a yellow background.'
    },
    error: {
        id: 'fabric.editor.error',
        defaultMessage: 'Error',
        description: 'Panels provide a way to highlight text. The error panel has a red background.'
    },
    emoji: {
        id: 'fabric.editor.panel.emoji',
        defaultMessage: 'Add emoji',
        description: 'Select the panel icon'
    },
    backgroundColor: {
        id: 'fabric.editor.panel.backgroundColor',
        defaultMessage: 'Background color',
        description: 'Select the panel background color.'
    },
    panelsGroup: {
        id: 'fabric.editor.panel.panelsGroup',
        defaultMessage: 'Panel Types',
        description: 'aria-label for group of panels the floating toolbar'
    }
});

});

parcelRegister("41ppt", function(module, exports) {

$parcel$export(module.exports, "mentionMessages", () => $a6f080a3a1fae2ec$export$33aafd5ccbbbd00a);

var $90IgZ = parcelRequire("90IgZ");
const $a6f080a3a1fae2ec$export$33aafd5ccbbbd00a = (0, $90IgZ.defineMessages)({
    inviteItemTitle: {
        id: 'fabric.editor.inviteItem.title',
        defaultMessage: '{userRole, select, admin {Invite} trusted {Invite} other {Add}} teammate to {productName}',
        description: 'Title of the invite teammate item in typeahead plugin'
    },
    mentionsAddLabel: {
        id: 'fabric.editor.mentionsAddLabel',
        defaultMessage: 'add-icon',
        description: 'icon label to describe adding a new mention'
    },
    mentionsIconLabel: {
        id: 'fabric.editor.mentionsIconLabel',
        defaultMessage: 'Mention',
        description: 'icon label to describe the mention icon'
    },
    mentionsNodeLabel: {
        id: 'fabric.editor.mentionNode.label',
        defaultMessage: 'Tagged user',
        description: 'Label to indicate mention node to Screen reader users, that preceeds with user name ex: "Tagged user @XXX'
    }
});

});

parcelRegister("lNoB6", function(module, exports) {

$parcel$export(module.exports, "helpDialogMessages", () => $01ed8aa9766665d3$export$83c85447c71428ba);

var $90IgZ = parcelRequire("90IgZ");
const $01ed8aa9766665d3$export$83c85447c71428ba = (0, $90IgZ.defineMessages)({
    editorHelp: {
        id: 'fabric.editor.editorHelp',
        defaultMessage: 'Editor help',
        description: 'Title of editor help dialog.'
    },
    helpDialogTips: {
        id: 'fabric.editor.helpDialogTips',
        defaultMessage: 'Press {keyMap} to quickly open this dialog at any time',
        description: 'Hint about how to open a dialog quickly using a shortcut.'
    },
    keyboardShortcuts: {
        id: 'fabric.editor.keyboardShortcuts',
        defaultMessage: 'Keyboard shortcuts',
        description: ''
    },
    markdown: {
        id: 'fabric.editor.markdown',
        defaultMessage: 'Markdown',
        description: 'It is a name of popular markup language.'
    },
    pastePlainText: {
        id: 'fabric.editor.pastePlainText',
        defaultMessage: 'Paste plain text',
        description: ''
    },
    CheckUncheckActionItem: {
        id: 'fabric.editor.checkUncheckActionItem',
        defaultMessage: 'Toggle action item',
        description: 'For Check/Uncheck Action item use shortcut'
    },
    InsertTableColumn: {
        id: 'fabric.editor.insertTableColumn',
        defaultMessage: 'Insert table column',
        description: 'For insert table column'
    },
    InsertTableRow: {
        id: 'fabric.editor.insertTableRow',
        defaultMessage: 'Insert table row',
        description: 'For insert table row'
    },
    altText: {
        id: 'fabric.editor.altText',
        defaultMessage: 'Alt text',
        description: 'Alternative text for image.'
    },
    selectTableRow: {
        id: 'fabric.editor.selectTableRow',
        defaultMessage: 'Select table row',
        description: 'Hint for selecting a table row using a shortcut'
    },
    selectTableColumn: {
        id: 'fabric.editor.selectTableColumn',
        defaultMessage: 'Select table column',
        description: 'Hint for selecting a table column using a shortcut'
    },
    selectColumnResize: {
        id: 'fabric.editor.selectColumnResize',
        defaultMessage: 'Select column resize',
        description: 'Hint for selecting a column resize a shortcut'
    },
    increaseSize: {
        id: 'fabric.editor.increaseSize',
        defaultMessage: 'Increase table or media size',
        description: 'The text is shown as an shortcut description in help dialog modal, when the user uses the described shortcut, he is able to increase the width of the selected element. Optimal characters less than 21.'
    },
    decreaseSize: {
        id: 'fabric.editor.decreaseSize',
        defaultMessage: 'Decrease table or media size',
        description: 'The text is shown as an shortcut description in help dialog modal, when the user uses the described shortcut, he is able to decrease the width of the selected element. Optimal characters less than 21.'
    },
    focusTableResizeHandle: {
        id: 'fabric.editor.focusTableResizeHandle',
        defaultMessage: 'Focus table resize handle',
        description: 'Focus table resize handle'
    },
    closeHelpDialog: {
        id: 'fabric.editor.closeHelpDialog',
        defaultMessage: 'Close help dialog',
        description: ''
    },
    // TODO: Move it inside quick insert plugin
    quickInsert: {
        id: 'fabric.editor.quickInsert',
        defaultMessage: 'Quick insert',
        description: 'Name of a feature, which let you insert items quickly.'
    },
    highlightColor: {
        id: 'fabric.editor.highlightColor',
        defaultMessage: 'Toggle highlight color palette',
        description: 'Keyboard shortcut to toggle highlight color palette.'
    }
});

});


parcelRegister("7Dnt4", function(module, exports) {

$parcel$export(module.exports, "walkUpTreeUntil", () => $27814a391fc641fb$export$df14aaf7a527ab0c);
$parcel$export(module.exports, "unwrap", () => $27814a391fc641fb$export$debb760848ca95a);
$parcel$export(module.exports, "removeNestedEmptyEls", () => $27814a391fc641fb$export$5b66dc78851adb5e);
$parcel$export(module.exports, "containsClassName", () => $27814a391fc641fb$export$c8913a477cc44663);
$parcel$export(module.exports, "closest", () => $27814a391fc641fb$export$ff7f7c97cdce86e);
$parcel$export(module.exports, "closestElement", () => $27814a391fc641fb$export$d508bcfb7f019487);
$parcel$export(module.exports, "parsePx", () => $27814a391fc641fb$export$b0eef8cd00b29d5c);
$parcel$export(module.exports, "maphElem", () => $27814a391fc641fb$export$5b6ab01a6efa50e2);
/**
 * Walks a DOM tree up to the provided `stopElement`, or if falsy before.
 * @param element
 * @param stopElement
 */ function $27814a391fc641fb$export$df14aaf7a527ab0c(element, shouldStop) {
    let rootElement = element;
    while(rootElement && rootElement.parentElement && !shouldStop(rootElement))rootElement = rootElement.parentElement;
    return rootElement;
}
function $27814a391fc641fb$export$debb760848ca95a(parent, wrapped) {
    const docsFragment = document.createDocumentFragment();
    Array.from(wrapped.children).forEach((child)=>{
        docsFragment.appendChild(child);
    });
    parent.replaceChild(docsFragment, wrapped);
}
function $27814a391fc641fb$export$5b66dc78851adb5e(el) {
    while(el.parentElement && el.childElementCount === 0 && el.textContent === ''){
        const parentEl = el.parentElement;
        parentEl.removeChild(el);
        el = parentEl;
    }
}
const $27814a391fc641fb$export$c8913a477cc44663 = (node, className)=>{
    if (!node) return false;
    if (node.classList && node.classList.contains) return node.classList.contains(className);
    if (!node.className) return false;
    const classNames = typeof node.className.baseVal === 'string' ? node.className.baseVal : node.className;
    return classNames.split(' ').indexOf(className) !== -1;
};
function $27814a391fc641fb$export$ff7f7c97cdce86e(node, s) {
    if (!node) return null;
    let el = node;
    if (!document.documentElement || !document.documentElement.contains(el)) return null;
    if (el.closest) return el.closest(s);
    do {
        const matchfn = el.matches ? el.matches : el.msMatchesSelector;
        if (matchfn && matchfn.call(el, s)) return el;
        el = el.parentElement || el.parentNode;
    }while (el !== null && el.nodeType === 1);
    return null;
}
function $27814a391fc641fb$export$d508bcfb7f019487(node, s) {
    return $27814a391fc641fb$export$ff7f7c97cdce86e(node, s);
}
function $27814a391fc641fb$export$b0eef8cd00b29d5c(pxStr) {
    if (!pxStr.endsWith('px')) return undefined;
    const maybeNumber = parseInt(pxStr, 10);
    return !Number.isNaN(maybeNumber) ? maybeNumber : undefined;
}
function $27814a391fc641fb$export$b2d5d4f1aeebddf1(elem, callback) {
    const array = [];
    for(let i = 0; i < elem.childElementCount; i++)array.push(callback(elem.children[i], i, elem));
    return array;
}
function $27814a391fc641fb$export$5b6ab01a6efa50e2(elem, callback) {
    return $27814a391fc641fb$export$b2d5d4f1aeebddf1(elem, callback);
}

});


parcelRegister("ghgHw", function(module, exports) {

$parcel$export(module.exports, "RendererCssClassName", () => $b6700cb9221d79ab$export$91f3bbbf974496e2);
const $b6700cb9221d79ab$var$clPrefix = 'ak-renderer-';
const $b6700cb9221d79ab$export$91f3bbbf974496e2 = {
    DOCUMENT: `${$b6700cb9221d79ab$var$clPrefix}document`,
    EXTENSION: `${$b6700cb9221d79ab$var$clPrefix}extension`,
    EXTENSION_CENTER_ALIGN: `${$b6700cb9221d79ab$var$clPrefix}extension-center-align`,
    EXTENSION_OVERFLOW_CONTAINER: `${$b6700cb9221d79ab$var$clPrefix}extension-overflow-container`,
    NUMBER_COLUMN: `${$b6700cb9221d79ab$var$clPrefix}table-number-column`,
    SORTABLE_COLUMN_WRAPPER: `${$b6700cb9221d79ab$var$clPrefix}tableHeader-sortable-column__wrapper`,
    SORTABLE_COLUMN: `${$b6700cb9221d79ab$var$clPrefix}tableHeader-sortable-column`,
    SORTABLE_COLUMN_ICON_WRAPPER: `${$b6700cb9221d79ab$var$clPrefix}tableHeader-sorting-icon__wrapper`,
    SORTABLE_COLUMN_NO_ORDER: `${$b6700cb9221d79ab$var$clPrefix}tableHeader-sorting-icon__no-order`
};

});


parcelRegister("ks9LI", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $52e78d2fac659478$export$e926676385687eaf);

var $eUqFw = parcelRequire("eUqFw");

var $auyn4 = parcelRequire("auyn4");

var $XHGTv = parcelRequire("XHGTv");

var $6PJBT = parcelRequire("6PJBT");

var $2g9ms = parcelRequire("2g9ms");

var $3rMck = parcelRequire("3rMck");

var $hompL = parcelRequire("hompL");
class $52e78d2fac659478$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    fireAnalyticsEvent(event) {
        const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
        if (createAnalyticsEvent) {
            const channel = (0, $6PJBT.FabricChannel).editor;
            createAnalyticsEvent(event).fire(channel);
        }
    }
    hasFallback() {
        return typeof this.props.fallbackComponent !== 'undefined';
    }
    shouldRecover() {
        return this.hasFallback() && this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        const additionalInfo = this.props.additionalInfo ?? '';
        this.fireAnalyticsEvent({
            action: (0, $auyn4.ACTION).CRASHED,
            actionSubject: this.props.component,
            actionSubjectId: this.props.componentId,
            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL,
            attributes: {
                platform: (0, $3rMck.PLATFORM).WEB,
                errorMessage: `${additionalInfo}${error?.message}`,
                componentStack: errorInfo?.componentStack || undefined,
                errorRethrown: Boolean(this.props.rethrowError)
            }
        });
        (0, $2g9ms.logException)(error, {
            location: 'renderer'
        });
        if ((0, $XHGTv.getBooleanFF)('platform.editor.renderer-error-boundary-for-dom-errors')) {
            const pattern = /Failed to execute.*on 'Node'.*/;
            const matchesPattern = pattern.test(error.message);
            if (matchesPattern) {
                this.fireAnalyticsEvent({
                    action: (0, $auyn4.ACTION).CAUGHT_DOM_ERROR,
                    actionSubject: this.props.component,
                    actionSubjectId: this.props.componentId,
                    eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL,
                    attributes: {
                        platform: (0, $3rMck.PLATFORM).WEB,
                        errorMessage: `${additionalInfo}${error?.message}`
                    }
                });
                this.setState(()=>({
                        domError: true
                    }));
            }
        }
        if (this.hasFallback()) this.setState({
            errorCaptured: true
        }, ()=>{
            if (this.props.rethrowError) throw error;
        });
    }
    render() {
        if ((0, $XHGTv.getBooleanFF)('platform.editor.renderer-error-boundary-for-dom-errors')) {
            if (this.state.domError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, {
                key: (0, (/*@__PURE__*/$parcel$interopDefault($hompL)))()
            }, this.props.children);
        }
        if (this.shouldRecover()) return this.props.fallbackComponent;
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            errorCaptured: false,
            domError: false
        };
    }
}

});
parcelRegister("2g9ms", function(module, exports) {

$parcel$export(module.exports, "logException", () => $af535f581045d8fb$export$f86b2a1a2ce291b3);

var $kwAba = parcelRequire("kwAba");
const $af535f581045d8fb$var$SENTRY_DSN = 'https://0b10c8e02fb44d8796c047b102c9bee8@o55978.ingest.sentry.io/4505129224110080';
const $af535f581045d8fb$var$packageName = 'editor-common'; // Sentry doesn't accept '/' in its releases https://docs.sentry.io/platforms/javascript/configuration/releases/
const $af535f581045d8fb$var$packageVersion = undefined;
const $af535f581045d8fb$var$sanitiseSentryEvents = (data, _hint)=>{
    // Remove URL as it has UGC
    // TODO: Sanitise the URL instead of just removing it
    if (data.request) delete data.request.url;
    return data;
};


const $af535f581045d8fb$export$f86b2a1a2ce291b3 = async (error, tags)=>{
    try {
        const { BrowserClient: BrowserClient, defaultIntegrations: defaultIntegrations, getCurrentHub: getCurrentHub } = await (parcelRequire("hTdx3"));
        const { ExtraErrorData: ExtraErrorData } = await (parcelRequire("g11Z2"));
        const sentryOptions = {
            dsn: (0, $kwAba.isFedRamp)() ? undefined : $af535f581045d8fb$var$SENTRY_DSN,
            release: `${$af535f581045d8fb$var$packageName}@${$af535f581045d8fb$var$packageVersion}`,
            environment: undefined ?? 'unknown',
            ignoreErrors: [
                // Network issues
                /^network error/i,
                /^network failure/i,
                'TypeError: Failed to fetch',
                // A benign error, see https://stackoverflow.com/a/50387233/2645305
                'ResizeObserver loop limit exceeded',
                /ResizeObserver loop completed with undelivered notifications/
            ],
            autoSessionTracking: false,
            integrations: (_integrations)=>[
                    // Remove the Breadcrumbs integration from the default as it's too likely to log UGC/PII
                    // https://docs.sentry.io/platforms/javascript/configuration/integrations/default/
                    ...defaultIntegrations.filter(({ name: name })=>name !== 'Breadcrumbs'),
                    // Extracts all non-native attributes from the error object and attaches them to the event as the extra data
                    // https://docs.sentry.io/platforms/javascript/configuration/integrations/plugin/?original_referrer=https%3A%2F%2Fduckduckgo.com%2F#extraerrordata
                    new ExtraErrorData()
                ],
            beforeSend: $af535f581045d8fb$var$sanitiseSentryEvents
        };
        // Use a client to avoid picking up the errors from parent applications
        const client = new BrowserClient(sentryOptions);
        const hub = getCurrentHub();
        hub.bindClient(client);
        hub.withScope((scope)=>{
            scope.setTags({
                // Jira environment variables
                'jira-bundler': window.BUNDLER_VERSION,
                'jira-variant': window.BUILD_VARIANT,
                'jira-release': window.BUILD_KEY,
                // Confluence environment variables
                'confluence-frontend-version': window.__buildInfo?.FRONTEND_VERSION,
                ...tags
            });
            // Explicitly remove the breadcrumbs as it's too likely to log UGC/PII to side-step the hub integrations not being respected
            scope.clearBreadcrumbs();
            hub.captureException(error);
        });
        return client.close();
    } catch (_error) {
    // Error reporting failed, we don't want this to generate more errors
    }
};

});
parcelRegister("kwAba", function(module, exports) {

$parcel$export(module.exports, "isFedRamp", () => $572aee3f817486b3$export$64d6499adf9b2e51);
const $572aee3f817486b3$var$FEDRAMP_MODERATE = 'fedramp-moderate';
function $572aee3f817486b3$export$64d6499adf9b2e51() {
    const global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    const env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === $572aee3f817486b3$var$FEDRAMP_MODERATE;
    const matches = global.location?.hostname?.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});

parcelRegister("hTdx3", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('gEreB');
        const value = parcelRequire('kdu1i');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("gEreB").then(()=>parcelRequire('kdu1i'));
}

});

parcelRegister("g11Z2", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hsecs');
        const value = parcelRequire('iVxd1');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hsecs").then(()=>parcelRequire('iVxd1'));
}

});


parcelRegister("3rMck", function(module, exports) {

$parcel$export(module.exports, "PLATFORM", () => $4ad63cbfa87b30ac$export$88c4881e092abcaf);
$parcel$export(module.exports, "MODE", () => $4ad63cbfa87b30ac$export$e48589d9e4824227);
var $4ad63cbfa87b30ac$export$88c4881e092abcaf;
(function(PLATFORM) {
    PLATFORM["NATIVE"] = "mobileNative";
    PLATFORM["HYBRID"] = "mobileHybrid";
    PLATFORM["WEB"] = "web";
})($4ad63cbfa87b30ac$export$88c4881e092abcaf || ($4ad63cbfa87b30ac$export$88c4881e092abcaf = {}));
var $4ad63cbfa87b30ac$export$e48589d9e4824227;
(function(MODE) {
    MODE["RENDERER"] = "renderer";
    MODE["EDITOR"] = "editor";
})($4ad63cbfa87b30ac$export$e48589d9e4824227 || ($4ad63cbfa87b30ac$export$e48589d9e4824227 = {}));
var $4ad63cbfa87b30ac$export$ecd1fed429542b49;
(function(RESOLVE_METHOD) {
    RESOLVE_METHOD["COMPONENT"] = "component";
    RESOLVE_METHOD["CONSUMER"] = "consumer";
    RESOLVE_METHOD["ORPHANED"] = "orphaned";
})($4ad63cbfa87b30ac$export$ecd1fed429542b49 || ($4ad63cbfa87b30ac$export$ecd1fed429542b49 = {}));

});


parcelRegister("fvyhV", function(module, exports) {

$parcel$export(module.exports, "EVENT_TYPE", () => $832dd5cdd187eb37$export$76a2e4c433c23bb9);
$parcel$export(module.exports, "ACTION", () => $832dd5cdd187eb37$export$9523889e0a5da4ba);
$parcel$export(module.exports, "ACTION_SUBJECT", () => $832dd5cdd187eb37$export$7525482b5931e326);
$parcel$export(module.exports, "ACTION_SUBJECT_ID", () => $832dd5cdd187eb37$export$9957974f8b4d8f74);
var $832dd5cdd187eb37$export$76a2e4c433c23bb9;
(function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
})($832dd5cdd187eb37$export$76a2e4c433c23bb9 || ($832dd5cdd187eb37$export$76a2e4c433c23bb9 = {}));
var $832dd5cdd187eb37$export$9523889e0a5da4ba;
(function(ACTION) {
    ACTION["STARTED"] = "started";
    ACTION["RENDERED"] = "rendered";
    ACTION["RE_RENDERED"] = "reRendered";
    ACTION["RENDERER_TTI"] = "tti";
    ACTION["CRASHED"] = "unhandledErrorCaught";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["CLICKED"] = "clicked";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["INSERTED"] = "inserted";
    ACTION["OPENED"] = "opened";
    ACTION["CLOSED"] = "closed";
    ACTION["DELETED"] = "deleted";
    ACTION["EDITED"] = "edited";
    ACTION["RESOLVED"] = "resolved";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
})($832dd5cdd187eb37$export$9523889e0a5da4ba || ($832dd5cdd187eb37$export$9523889e0a5da4ba = {}));
var $832dd5cdd187eb37$export$7525482b5931e326;
(function(ACTION_SUBJECT) {
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["MEDIA"] = "media";
})($832dd5cdd187eb37$export$7525482b5931e326 || ($832dd5cdd187eb37$export$7525482b5931e326 = {}));
var $832dd5cdd187eb37$export$9957974f8b4d8f74;
(function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
})($832dd5cdd187eb37$export$9957974f8b4d8f74 || ($832dd5cdd187eb37$export$9957974f8b4d8f74 = {}));

});


parcelRegister("jTkfS", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd803a06446500b8$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/prefer-primitives */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $eUqFw = parcelRequire("eUqFw");

var $h3PoL = parcelRequire("h3PoL");

var $8zo8Y = parcelRequire("8zo8Y");

var $ihOvF = parcelRequire("ihOvF");
var $4iaaT = parcelRequire("4iaaT");

var $ghgHw = parcelRequire("ghgHw");

var $b3jMP = parcelRequire("b3jMP");
const $bd803a06446500b8$var$useMultiBodiedExtensionActions = ({ updateActiveChild: updateActiveChild, children: children })=>{
    const actions = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useMemo(()=>{
        return {
            changeActive (index) {
                return updateActiveChild(index);
            },
            addChild () {
                return false;
            },
            getChildrenCount () {
                return children ? children?.length : 0;
            },
            removeChild (index) {
                return false;
            },
            updateParameters (parameters) {
                return false;
            },
            getChildren () {
                return [];
            }
        };
    }, [
        updateActiveChild,
        children
    ]);
    return actions;
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $bd803a06446500b8$var$navigationCssExtended = /*#__PURE__*/ (0, $byn9U.css)((0, $ihOvF.sharedMultiBodiedExtensionStyles).mbeNavigation, ";margin-left:0!important;margin-right:0!important;.mbe-add-tab-button,.mbe-remove-tab{display:none;}");
const $bd803a06446500b8$var$MultiBodiedExtension = (props)=>{
    const { children: children, layout: layout = 'default', path: path = [] } = props;
    const [activeChildIndex, setActiveChildIndex] = (0, $eUqFw.useState)(0);
    const removeOverflow = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(children).map((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(child) ? child.props.nodeType === 'table' : false).every(Boolean);
    const overflowContainerClass = !removeOverflow ? (0, $ghgHw.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER : '';
    const updateActiveChild = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((index)=>{
        if (typeof index !== 'number') {
            // TODO: Make sure we log this somewhere if this happens
            setActiveChildIndex(0);
            return false;
        }
        setActiveChildIndex(index);
        return true;
    }, [
        setActiveChildIndex
    ]);
    const actions = $bd803a06446500b8$var$useMultiBodiedExtensionActions({
        updateActiveChild: updateActiveChild,
        children: children
    });
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    const containerCssExtended = /*#__PURE__*/ (0, $byn9U.css)((0, $ihOvF.sharedMultiBodiedExtensionStyles).mbeExtensionContainer, ";.ak-renderer-extension{margin-top:0!important;}[data-layout='full-width'],[data-layout='wide']{.multiBodiedExtension-navigation{border-right:3px solid ", `var(--ds-border, ${(0, $PdmhA.N40)})`, "!important;}}.multiBodiedExtension--frames>[data-extension-frame='true']:nth-of-type(", activeChildIndex + 1, "){", (0, $ihOvF.sharedMultiBodiedExtensionStyles).extensionFrameContent, " margin-left:0;margin-right:0;}");
    const isTopLevel = path.length < 1;
    const centerAlignClass = isTopLevel && [
        'wide',
        'full-width'
    ].includes(layout) ? (0, $ghgHw.RendererCssClassName).EXTENSION_CENTER_ALIGN : '';
    function renderMbeContent(width) {
        return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $ghgHw.RendererCssClassName).EXTENSION} ${centerAlignClass} ${overflowContainerClass}`,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                width: isTopLevel ? (0, $b3jMP.calcBreakoutWidth)(layout, width) : '100%'
            },
            "data-layout": layout
        }, /*#__PURE__*/ (0, $byn9U.jsx)("nav", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "multiBodiedExtension-navigation",
            css: $bd803a06446500b8$var$navigationCssExtended,
            "data-testid": "multiBodiedExtension-navigation"
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8zo8Y.default), {
            ...props,
            actions: actions,
            type: "multiBodiedExtension"
        }, ({ result: result })=>{
            try {
                if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(result)) // Return the content directly if it's a valid JSX.Element
                return (0, $h3PoL.renderExtension)(result, layout, {
                    isTopLevel: path.length < 1
                });
            } catch (e) {
            /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
            // Always return default content if anything goes wrong
            return (0, $h3PoL.renderExtension)(children, layout, {
                isTopLevel: path.length < 1
            });
        })), /*#__PURE__*/ (0, $byn9U.jsx)("article", {
            "data-testid": "multiBodiedExtension--frames",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `multiBodiedExtension--frames`
        }, children));
    }
    return /*#__PURE__*/ (0, $byn9U.jsx)("section", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "multiBodiedExtension--container",
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: containerCssExtended,
        "data-testid": "multiBodiedExtension--container",
        "data-active-child-index": activeChildIndex,
        "data-layout": layout
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4iaaT.WidthConsumer), null, ({ width: width })=>renderMbeContent(width)));
};
var $bd803a06446500b8$export$2e2bcd8739ae039 = $bd803a06446500b8$var$MultiBodiedExtension;

});
parcelRegister("ihOvF", function(module, exports) {

$parcel$export(module.exports, "removeMarginsAndBorder", () => $d53af947505f28f8$export$8df0393dc2d5d656);
$parcel$export(module.exports, "sharedMultiBodiedExtensionStyles", () => $d53af947505f28f8$export$9c7196ca47f67390);
/** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
function $d53af947505f28f8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Wraps the navigation bar and extensionFrames
const $d53af947505f28f8$var$mbeExtensionContainer = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    background: 'transparent !important',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'padding:': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        left: `${"var(--ds-space-100, 8px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        right: `${"var(--ds-space-100, 8px)"} !important`
    },
    paddingBottom: "var(--ds-space-100, 8px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.remove-padding': {
        paddingBottom: 0
    },
    position: 'relative',
    verticalAlign: 'middle',
    cursor: 'pointer',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.multiBodiedExtension-handler-result': {
        marginLeft: "var(--ds-space-100, 8px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".multiBodiedExtension-content-dom-wrapper > [data-extension-frame='true'], .multiBodiedExtension--frames > [data-extension-frame='true']": {
        display: 'none',
        background: "var(--ds-surface, white)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.multiBodiedExtension-content-dom-wrapper, .multiBodiedExtension--frames': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[data-extension-frame='true'] > :not(style):first-child, [data-extension-frame='true'] > style:first-child + *": {
            marginTop: 0
        }
    }
});
const $d53af947505f28f8$var$mbeNavigation = {
    name: "2ubief",
    styles: "border-top-left-radius:var(--ds-border-radius, 3px);border-top-right-radius:var(--ds-border-radius, 3px);user-select:none;-webkit-user-modify:read-only;border-bottom:none !important;background:var(--ds-surface, white);margin-left:var(--ds-space-100, 8px);margin-right:var(--ds-space-100, 8px);&.remove-margins{margin:var(--ds-space-negative-100, -8px);}&.remove-border{border:none;}"
};
const $d53af947505f28f8$var$extensionFrameContent = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    padding: `${"var(--ds-space-100, 8px)"} !important`,
    display: 'block',
    minHeight: '100px',
    background: "var(--ds-surface, white)",
    borderBottomLeftRadius: "var(--ds-border-radius, 3px)",
    borderBottomRightRadius: "var(--ds-border-radius, 3px)",
    marginLeft: "var(--ds-space-100, 8px)",
    marginRight: "var(--ds-space-100, 8px)",
    cursor: 'initial',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.pm-table-with-controls': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginLeft: `${"var(--ds-space-150, 12px)"} !important`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        paddingRight: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.bodiedExtensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-150, 12px)"} !important`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '.extensionView-content-wrap': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: `${"var(--ds-space-100, 8px)"} !important`
    }
});
const $d53af947505f28f8$export$8df0393dc2d5d656 = {
    name: "c620zi",
    styles: "margin-left:0;margin-right:0;border:none"
};
const $d53af947505f28f8$export$9c7196ca47f67390 = {
    mbeExtensionContainer: $d53af947505f28f8$var$mbeExtensionContainer,
    mbeNavigation: $d53af947505f28f8$var$mbeNavigation,
    extensionFrameContent: $d53af947505f28f8$var$extensionFrameContent
};

});


parcelRegister("cQobE", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdec7fc741b72949$export$2e2bcd8739ae039);
/** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
function $fdec7fc741b72949$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fdec7fc741b72949$var$containerCSS = {
    name: "ecvjkq",
    styles: "min-height:100px"
};
const $fdec7fc741b72949$var$ExtensionFrame = (props)=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $fdec7fc741b72949$var$containerCSS,
        "data-extension-frame": "true",
        style: {
            flexBasis: `100%`
        }
    }, props.children);
};
var $fdec7fc741b72949$export$2e2bcd8739ae039 = $fdec7fc741b72949$var$ExtensionFrame;

});

parcelRegister("bs79N", function(module, exports) {

$parcel$export(module.exports, "default", () => $887b035eeb07eb03$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $568Ob = parcelRequire("568Ob");

var $7iIIt = parcelRequire("7iIIt");
function $887b035eeb07eb03$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("ul", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $568Ob.bulletListSelector).substr(1),
        "data-indent-level": props.path ? (0, $7iIIt.getListIndentLevel)(props.path) : 1
    }, props.children);
}

});
parcelRegister("7iIIt", function(module, exports) {

$parcel$export(module.exports, "getListIndentLevel", () => $9a57d99548bd54c6$export$75aa84e85754623e);
function $9a57d99548bd54c6$export$75aa84e85754623e(path) {
    let count = 1;
    path.forEach((node)=>{
        if (node.type.name === 'bulletList' || node.type.name === 'orderedList') count++;
    });
    return count;
}

});


parcelRegister("iK2Ni", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f597e6cf1e24bd5$export$2e2bcd8739ae039);
$parcel$export(module.exports, "DocWithSelectAllTrap", () => $2f597e6cf1e24bd5$export$41121a410ca2f650);

var $eUqFw = parcelRequire("eUqFw");

var $ghgHw = parcelRequire("ghgHw");

var $6Afu1 = parcelRequire("6Afu1");
function $2f597e6cf1e24bd5$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $ghgHw.RendererCssClassName).DOCUMENT
    }, props.children);
}
function $2f597e6cf1e24bd5$export$41121a410ca2f650(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: (0, $6Afu1.useSelectAllTrap)(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $ghgHw.RendererCssClassName).DOCUMENT
    }, props.children);
}

});
parcelRegister("6Afu1", function(module, exports) {

$parcel$export(module.exports, "useSelectAllTrap", () => $3bc68038c3a101f2$export$98871b245ee25215);

var $auyn4 = parcelRequire("auyn4");

var $eUqFw = parcelRequire("eUqFw");

var $86Pbu = parcelRequire("86Pbu");

var $8ul1p = parcelRequire("8ul1p");
const $3bc68038c3a101f2$export$98871b245ee25215 = ()=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext((0, $86Pbu.default));
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(null);
    const clicked = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(false);
    const caught = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef();
    const mac = typeof navigator !== 'undefined' ? /Mac/.test(navigator.platform) : false;
    const onKeyDown = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((e)=>{
        const el = ref.current;
        if (!el) return;
        const modKey = mac ? e.metaKey : e.ctrlKey;
        if (!modKey || e.code !== 'KeyA' || e.shiftKey) return;
        const elementSelection = (0, $8ul1p.ElementSelection).fromWindow();
        if (elementSelection.eq(caught.current)) {
            fireAnalyticsEvent({
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                action: (0, $auyn4.ACTION).SELECT_ALL_ESCAPED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).RENDERER
            });
            return;
        }
        if (elementSelection.inside(el) || elementSelection.type === 'None' && clicked.current) {
            fireAnalyticsEvent({
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                action: (0, $auyn4.ACTION).SELECT_ALL_CAUGHT,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).RENDERER
            });
            e.preventDefault();
            caught.current = elementSelection.select(el);
        }
    }, [
        mac,
        ref,
        fireAnalyticsEvent,
        clicked,
        caught
    ]);
    const onClick = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((e)=>{
        clicked.current = ref.current?.contains(e.target) ?? false;
    }, [
        ref,
        clicked
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        window.addEventListener('keydown', onKeyDown);
        window.addEventListener('click', onClick);
        return ()=>{
            window.removeEventListener('keydown', onKeyDown);
            window.removeEventListener('click', onClick);
        };
    }, [
        onKeyDown,
        onClick
    ]);
    return ref;
};

});
parcelRegister("86Pbu", function(module, exports) {

$parcel$export(module.exports, "default", () => $7259abaa905a9ea2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $7259abaa905a9ea2$var$AnalyticsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({
    fireAnalyticsEvent: (_event)=>null
});
var $7259abaa905a9ea2$export$2e2bcd8739ae039 = $7259abaa905a9ea2$var$AnalyticsContext;

});

parcelRegister("8ul1p", function(module, exports) {

$parcel$export(module.exports, "ElementSelection", () => $2419f1fe60d6618f$export$6e6724d89f27411);
class $2419f1fe60d6618f$export$6e6724d89f27411 {
    constructor(selection){
        this.type = selection ? selection.type : 'None';
        if (selection && this.type !== 'None') this.range = selection.getRangeAt(0);
    }
    eq(selection) {
        if (!selection) return false;
        if (this.range && selection.range) {
            const startMatches = this.range?.compareBoundaryPoints(Range.START_TO_START, selection.range) === 0;
            const endMatches = this.range?.compareBoundaryPoints(Range.END_TO_END, selection.range) === 0;
            return startMatches && endMatches;
        }
        return this.type === 'None' && selection.type === 'None';
    }
    inside(el) {
        return el.contains(this.range?.commonAncestorContainer ?? null);
    }
    select(el) {
        const range = document.createRange();
        range.selectNodeContents(el);
        const selection = window.getSelection();
        if (selection) {
            selection.removeAllRanges();
            selection.addRange(range);
        }
        return $2419f1fe60d6618f$export$6e6724d89f27411.fromWindow();
    }
    static fromWindow(win = window) {
        return new $2419f1fe60d6618f$export$6e6724d89f27411(win.getSelection());
    }
}

});



parcelRegister("9A6NO", function(module, exports) {

$parcel$export(module.exports, "default", () => $385c81737007be05$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $385c81737007be05$var$HardBreak = ({ forceNewLine: forceNewLine = false })=>{
    // To display an empty line using Shift+Enter, ProseMirror inserts a
    // double <br>. The second <br> is not part of the document, it's just
    // there to make browsers behave properly. The forceNewLine prop in this
    // component replicates this behaviour. If the last child node is a
    // hardBreak, it will also insert a double <br>.
    if (forceNewLine) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null);
};
var $385c81737007be05$export$2e2bcd8739ae039 = $385c81737007be05$var$HardBreak;

});

parcelRegister("fGuTt", function(module, exports) {

$parcel$export(module.exports, "default", () => $083d6a919e4a5a31$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dMrTV = parcelRequire("dMrTV");

var $auyn4 = parcelRequire("auyn4");

var $86Pbu = parcelRequire("86Pbu");

var $fBE31 = parcelRequire("fBE31");
const $083d6a919e4a5a31$var$getCurrentUrlWithHash = (hash = '')=>{
    const url = new URL(window.location.href);
    url.search = ''; // clear any query params so that the page will correctly scroll to the anchor
    url.hash = encodeURIComponent(hash);
    return url.href;
};
function $083d6a919e4a5a31$var$hasRightAlignmentMark(marks) {
    if (!marks || !marks.length) return false;
    return marks.some((mark)=>mark.type.name === 'alignment' && mark.attrs.align === 'end');
}
function $083d6a919e4a5a31$var$WrappedHeadingAnchor({ enableNestedHeaderLinks: enableNestedHeaderLinks, level: level, headingId: headingId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $86Pbu.default).Consumer, null, ({ fireAnalyticsEvent: fireAnalyticsEvent })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dMrTV.default), {
            enableNestedHeaderLinks: enableNestedHeaderLinks,
            level: level,
            onCopyText: ()=>{
                fireAnalyticsEvent({
                    action: (0, $auyn4.ACTION).CLICKED,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).BUTTON,
                    actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).HEADING_ANCHOR_LINK,
                    eventType: (0, $auyn4.EVENT_TYPE).UI
                });
                return (0, $fBE31.copyTextToClipboard)($083d6a919e4a5a31$var$getCurrentUrlWithHash(headingId));
            }
        }));
}
function $083d6a919e4a5a31$var$Heading(props) {
    const { headingId: headingId, dataAttributes: dataAttributes, allowHeadingAnchorLinks: allowHeadingAnchorLinks, marks: marks, invisible: invisible } = props;
    const HX = `h${props.level}`;
    const showAnchorLink = !!props.showAnchorLink;
    const isRightAligned = $083d6a919e4a5a31$var$hasRightAlignmentMark(marks);
    const enableNestedHeaderLinks = allowHeadingAnchorLinks && allowHeadingAnchorLinks.allowNestedHeaderLinks;
    const headingIdToUse = invisible ? undefined : headingId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(HX, {
        id: headingIdToUse,
        ...dataAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, showAnchorLink && headingId && isRightAligned && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($083d6a919e4a5a31$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        headingId: headingId
    }), props.children, showAnchorLink && headingId && !isRightAligned && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($083d6a919e4a5a31$var$WrappedHeadingAnchor, {
        level: props.level,
        enableNestedHeaderLinks: enableNestedHeaderLinks,
        headingId: headingId
    })));
}
var $083d6a919e4a5a31$export$2e2bcd8739ae039 = $083d6a919e4a5a31$var$Heading;

});
parcelRegister("dMrTV", function(module, exports) {

$parcel$export(module.exports, "HeadingAnchorWrapperClassName", () => $2e231eb3e398a79e$export$3c9cedc52604835d);
$parcel$export(module.exports, "default", () => $2e231eb3e398a79e$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $hUwRB = parcelRequire("hUwRB");

var $8cU5f = parcelRequire("8cU5f");

var $2qhQi = parcelRequire("2qhQi");

var $drghF = parcelRequire("drghF");
const $2e231eb3e398a79e$export$3c9cedc52604835d = 'heading-anchor-wrapper';
const $2e231eb3e398a79e$var$CopyAnchorWrapperWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        ...rest,
        className: $2e231eb3e398a79e$export$3c9cedc52604835d,
        ref: ref
    }, children));
});
const $2e231eb3e398a79e$var$copyAnchorButtonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline',
    outline: 'none',
    backgroundColor: 'transparent',
    border: 'none',
    color: `var(--ds-icon, ${(0, $PdmhA.N500)})`,
    cursor: 'pointer',
    right: 0
});
class $2e231eb3e398a79e$var$HeadingAnchor extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    componentDidMount() {
        this.resetMessage();
    }
    render() {
        const { tooltipMessage: tooltipMessage } = this.state;
        if (tooltipMessage) // We set the key to the message to ensure it remounts when the message
        // changes, so that it correctly repositions.
        // @see https://ecosystem.atlassian.net/projects/AK/queues/issue/AK-6548
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cU5f.default), {
            tag: $2e231eb3e398a79e$var$CopyAnchorWrapperWithRef,
            content: tooltipMessage,
            position: "top",
            delay: 0,
            key: tooltipMessage
        }, this.renderAnchorButton());
        return this.renderAnchorButton();
    }
    constructor(...args){
        super(...args);
        this.state = {
            tooltipMessage: '',
            isClicked: false
        };
        this.setTooltipState = (message, isClicked = false)=>{
            this.setState({
                // TODO: ED-14403 investigate why this does not translate
                tooltipMessage: this.props.intl.formatMessage(message),
                isClicked: isClicked
            });
        };
        this.getCopyAriaLabel = ()=>{
            const { copyAriaLabel: copyAriaLabel } = (0, $drghF.headingAnchorLinkMessages);
            return this.props.intl.formatMessage(copyAriaLabel);
        };
        this.copyToClipboard = async (event)=>{
            const { copiedHeadingLinkToClipboard: copiedHeadingLinkToClipboard, failedToCopyHeadingLink: failedToCopyHeadingLink } = (0, $drghF.headingAnchorLinkMessages);
            event.stopPropagation();
            try {
                await this.props.onCopyText();
                this.setTooltipState(copiedHeadingLinkToClipboard, true);
            } catch (e) {
                this.setTooltipState(failedToCopyHeadingLink);
            }
        };
        this.resetMessage = ()=>{
            this.setTooltipState((0, $drghF.headingAnchorLinkMessages).copyHeadingLinkToClipboard);
        };
        this.renderAnchorButton = ()=>{
            return /*#__PURE__*/ (0, $byn9U.jsx)("button", {
                css: $2e231eb3e398a79e$var$copyAnchorButtonStyles,
                onMouseLeave: this.resetMessage,
                onClick: this.copyToClipboard,
                "aria-label": this.state.tooltipMessage,
                type: "button"
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hUwRB))), {
                label: this.getCopyAriaLabel(),
                size: this.props.level > 3 ? 'small' : 'medium',
                primaryColor: this.state.isClicked ? `var(--ds-icon-selected, ${0, $PdmhA.B400})` : `var(--ds-icon-subtle, ${0, $PdmhA.N200})`
            }));
        };
    }
}
var $2e231eb3e398a79e$export$2e2bcd8739ae039 = (0, $2qhQi.default)($2e231eb3e398a79e$var$HeadingAnchor);

});
parcelRegister("drghF", function(module, exports) {

$parcel$export(module.exports, "headingAnchorLinkMessages", () => $463d81896c1da8e9$export$74bada844422036d);
$parcel$export(module.exports, "tableCellMessages", () => $463d81896c1da8e9$export$c79ebc36348824d1);
$parcel$export(module.exports, "inlineCommentMessages", () => $463d81896c1da8e9$export$9f52c375a6ef34fc);

var $90IgZ = parcelRequire("90IgZ");
const $463d81896c1da8e9$export$74bada844422036d = (0, $90IgZ.defineMessages)({
    copyHeadingLinkToClipboard: {
        id: 'fabric.editor.headingLink.copyAnchorLink',
        defaultMessage: 'Copy link to heading',
        description: 'Copy heading link to clipboard'
    },
    copiedHeadingLinkToClipboard: {
        id: 'fabric.editor.headingLink.copied',
        defaultMessage: 'Copied!',
        description: 'Copied heading link to clipboard'
    },
    failedToCopyHeadingLink: {
        id: 'fabric.editor.headingLink.failedToCopy',
        defaultMessage: 'Copy failed',
        description: 'failed to copy heading link to clipboard'
    },
    copyAriaLabel: {
        id: 'fabric.editor.headingLink.copyAriaLabel',
        defaultMessage: 'Copy',
        description: 'copy aria label for link icon'
    }
});
const $463d81896c1da8e9$export$c79ebc36348824d1 = (0, $90IgZ.defineMessages)({
    noneSortingLabel: {
        id: 'fabric.editor.headingLink.noneSortingLabel',
        defaultMessage: 'none',
        description: 'this table column is not sorted'
    },
    ascSortingLabel: {
        id: 'fabric.editor.headingLink.ascSortingLabel',
        defaultMessage: 'ascending',
        description: 'this table column is sorted in ascending order'
    },
    descSortingLabel: {
        id: 'fabric.editor.headingLink.descSortingLabel',
        defaultMessage: 'descending',
        description: 'this table column is sorted in descending order'
    }
});
const $463d81896c1da8e9$export$9f52c375a6ef34fc = (0, $90IgZ.defineMessages)({
    contentRendererInlineCommentMarkerStart: {
        id: 'fabric.editor.inlineComment.marker.start',
        defaultMessage: 'inline comment start',
        description: 'Starting marker to indicate that text is highlighted with an inline comment by a screen reader.'
    },
    contentRendererInlineCommentMarkerEnd: {
        id: 'fabric.editor.inlineComment.marker.end',
        defaultMessage: 'inline comment end',
        description: 'Ending marker to indicate that text was highlighted with an inline comment by a screen reader.'
    }
});

});


parcelRegister("fBE31", function(module, exports) {

$parcel$export(module.exports, "copyTextToClipboard", () => $2b1d2dec2d1f6a3a$export$f980440e1ab4537d);
const $2b1d2dec2d1f6a3a$export$f980440e1ab4537d = (text)=>new Promise((resolve, reject)=>{
        const isApiSupported = !!navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
        if (isApiSupported) navigator.clipboard.writeText(text).then(()=>resolve(), (e)=>reject(e));
        else reject('Clipboard API is not supported');
    });

});


parcelRegister("6C80U", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8a58832896c0175$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8zo8Y = parcelRequire("8zo8Y");
const $e8a58832896c0175$var$InlineExtension = (props)=>{
    const { text: text } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8zo8Y.default), {
        ...props,
        type: "inlineExtension"
    }, ({ result: result })=>{
        try {
            // Return the result directly if it's a valid JSX.Element
            if (result && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(result)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, result);
        } catch (e) {
        /** We don't want this error to block renderer */ /** We keep rendering the default content */ }
        // Always return default content if anything goes wrong
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, text || 'inlineExtension');
    });
};
var $e8a58832896c0175$export$2e2bcd8739ae039 = $e8a58832896c0175$var$InlineExtension;

});

parcelRegister("95JQu", function(module, exports) {

$parcel$export(module.exports, "default", () => $644e1ab6adc9f0f3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $644e1ab6adc9f0f3$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-layout-section": true
    }, props.children);
}

});

parcelRegister("7s3LA", function(module, exports) {

$parcel$export(module.exports, "default", () => $43b3ec491f0f3458$export$2e2bcd8739ae039);
/** @jsx jsx */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $a2RTs = parcelRequire("a2RTs");
var $4iaaT = parcelRequire("4iaaT");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $43b3ec491f0f3458$var$layoutColumnClearMarginTopStyles = /*#__PURE__*/ (0, $byn9U.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $a2RTs.clearNextSiblingMarginTopStyle), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
(0, $a2RTs.clearNextSiblingBlockMarkMarginTopStyle));
function $43b3ec491f0f3458$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-layout-column": true,
        "data-column-width": props.width,
        style: {
            flexBasis: `${props.width}%`
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4iaaT.WidthProvider), null, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $43b3ec491f0f3458$var$layoutColumnClearMarginTopStyles
    }), props.children));
}

});
parcelRegister("a2RTs", function(module, exports) {

$parcel$export(module.exports, "clearNextSiblingMarginTopStyle", () => $af2a19a8f75d9d7b$export$b15ec88fc1f2e843);
$parcel$export(module.exports, "clearNextSiblingBlockMarkMarginTopStyle", () => $af2a19a8f75d9d7b$export$eb3aaa9338936d44);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
function $af2a19a8f75d9d7b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $af2a19a8f75d9d7b$export$b15ec88fc1f2e843 = {
    name: "1f3w791",
    styles: "& + *{margin-top:0 !important;}"
};
const $af2a19a8f75d9d7b$var$textElements = [
    'p',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6'
];
const $af2a19a8f75d9d7b$var$nextSiblingBlockMarkContentSelectors = $af2a19a8f75d9d7b$var$textElements.map((elem)=>`+ .fabric-editor-block-mark > ${elem}`).join(',');
const $af2a19a8f75d9d7b$export$eb3aaa9338936d44 = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`${$af2a19a8f75d9d7b$var$nextSiblingBlockMarkContentSelectors}`]: {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        marginTop: '0 !important'
    }
});

});


parcelRegister("joPiA", function(module, exports) {

$parcel$export(module.exports, "default", () => $37248d0763ca9dd6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $37248d0763ca9dd6$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", null, props.children);
}

});

parcelRegister("61520", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0089215b260366e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4hB9U = parcelRequire("4hB9U");
const $d0089215b260366e$var$RenderCaption = ({ children: children, dataAttributes: dataAttributes })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4hB9U.default), {
        hasContent: true,
        dataAttributes: dataAttributes
    }, children);
};
var $d0089215b260366e$export$2e2bcd8739ae039 = $d0089215b260366e$var$RenderCaption;

});
parcelRegister("4hB9U", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f558a09344abdcc$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2qhQi = parcelRequire("2qhQi");

var $PdmhA = parcelRequire("PdmhA");

var $iq4r1 = parcelRequire("iq4r1");
const $0f558a09344abdcc$var$captionWrapperStyle = /*#__PURE__*/ (0, $byn9U.css)({
    marginTop: "var(--ds-space-100, 8px)",
    textAlign: 'center',
    position: 'relative',
    color: `var(--ds-text-subtle, ${(0, $PdmhA.N400)})`
});
const $0f558a09344abdcc$var$placeholderStyle = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-subtlest, ${(0, $PdmhA.N200)})`,
    position: 'absolute',
    top: 0,
    width: '100%'
});
class $0f558a09344abdcc$export$f7feb87190a94c76 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { selected: selected, hasContent: hasContent, children: children, dataAttributes: dataAttributes, intl: { formatMessage: formatMessage } } = this.props;
        const showPlaceholder = !selected && !hasContent;
        return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            "data-media-caption": true,
            "data-testid": "media-caption",
            ...dataAttributes,
            css: $0f558a09344abdcc$var$captionWrapperStyle
        }, showPlaceholder ? /*#__PURE__*/ (0, $byn9U.jsx)("p", {
            css: $0f558a09344abdcc$var$placeholderStyle
        }, formatMessage((0, $iq4r1.messages).placeholder)) : null, children);
    }
}
var $0f558a09344abdcc$export$2e2bcd8739ae039 = (0, $2qhQi.default)($0f558a09344abdcc$export$f7feb87190a94c76);

});
parcelRegister("iq4r1", function(module, exports) {

$parcel$export(module.exports, "messages", () => $603bd4cc93c12c49$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $603bd4cc93c12c49$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    placeholder: {
        id: 'fabric.editor.captionPlaceholder',
        defaultMessage: 'Add a caption',
        description: 'Placeholder description for an empty (new) caption in the editor'
    }
});

});



parcelRegister("8geRS", function(module, exports) {

$parcel$export(module.exports, "default", () => $78523893e2031013$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8lnnz = parcelRequire("8lnnz");

var $juoPd = parcelRequire("juoPd");

var $fS4LS = parcelRequire("fS4LS");

var $7iIIt = parcelRequire("7iIIt");
function $78523893e2031013$export$2e2bcd8739ae039(props) {
    let extraProps = {};
    const itemCounterDigitsSize = (0, $fS4LS.getItemCounterDigitsSize)({
        order: props.order,
        itemsCount: props?.content?.length
    });
    if (itemCounterDigitsSize && itemCounterDigitsSize > 2) extraProps.style = (0, $juoPd.getOrderedListInlineStyles)(itemCounterDigitsSize, 'object');
    if (props.order !== undefined) extraProps.start = (0, $fS4LS.resolveOrder)(props.order);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("ol", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $8lnnz.orderedListSelector).substr(1),
        "data-indent-level": props.path ? (0, $7iIIt.getListIndentLevel)(props.path) : 1,
        start: props.start,
        ...extraProps
    }, props.children);
}

});
parcelRegister("juoPd", function(module, exports) {

$parcel$export(module.exports, "listItemCounterPadding", () => $d49e7b19d8143680$export$bafd6beec0797f87);
$parcel$export(module.exports, "getOrderedListInlineStyles", () => $d49e7b19d8143680$export$6d31fdb1d74cee3e);
$parcel$export(module.exports, "listsSharedStyles", () => $d49e7b19d8143680$export$ea95db02cc29c78f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $568Ob = parcelRequire("568Ob");
var $8lnnz = parcelRequire("8lnnz");

var $jMQbs = parcelRequire("jMQbs");
const $d49e7b19d8143680$export$bafd6beec0797f87 = 24;
var $d49e7b19d8143680$var$CSS_VAR_NAMES;
(function(CSS_VAR_NAMES) {
    CSS_VAR_NAMES["ITEM_COUNTER_PADDING"] = "--ed--list--item-counter--padding";
})($d49e7b19d8143680$var$CSS_VAR_NAMES || ($d49e7b19d8143680$var$CSS_VAR_NAMES = {}));
const $d49e7b19d8143680$var$getItemCounterLeftPadding = (itemCounterDigitsSize)=>{
    // Previous padding-left was approximately 24px. We approximate that
    // same value using "ch" units (which represent the width of a "0" digit
    // character). We use "ch" so that this computed padding can now grow if
    //  the font-size ever enlarges.
    let paddingLeft = `2.385ch`;
    if (itemCounterDigitsSize >= 3) {
        // When there are 3 or more digits, we use a combination of "ch" units and
        // pixel values so that while the computed padding grows if font-size ever
        // enlarges, it doesn't over-scale with each digit (because of the fixed pixel
        // portion of the computed value). This way, very large item counters will not
        // become overly left-padded.
        const fixedBasePx = 2;
        paddingLeft = `calc(${itemCounterDigitsSize + 1}ch - ${fixedBasePx}px)`;
    }
    return paddingLeft;
};
const $d49e7b19d8143680$var$stringifyStyle = (style)=>Object.entries(style).reduce((str, [key, value])=>`${str}${key}:${value};`, ``);
function $d49e7b19d8143680$export$6d31fdb1d74cee3e(itemCounterDigitsSize, styleFormat) {
    const style = {
        ["--ed--list--item-counter--padding"]: $d49e7b19d8143680$var$getItemCounterLeftPadding(itemCounterDigitsSize)
    };
    if (styleFormat === 'string') return $d49e7b19d8143680$var$stringifyStyle(style);
    return style;
}
const $d49e7b19d8143680$export$ea95db02cc29c78f = /*#__PURE__*/ (0, $byn9U.css)("ul,ol{box-sizing:border-box;padding-left:var(", "--ed--list--item-counter--padding", ", ", $d49e7b19d8143680$export$bafd6beec0797f87, "px);li p:empty,li p>span:empty{", (0, $jMQbs.default).gecko ? 'display: inline-block;' : '', ";}}", (0, $8lnnz.orderedListSelector), ",", (0, $568Ob.bulletListSelector), "{/*\n      Ensures list item content adheres to the list's margin instead\n      of filling the entire block row. This is important to allow\n      clicking interactive elements which are floated next to a list.\n\n      For some history and context on this block, see PRs related to tickets.:\n      @see ED-6551 - original issue.\n      @see ED-7015 - follow up issue.\n      @see ED-7447 - flow-root change.\n\n      We use 'display: table' (old clear fix / new block formatting context hack)\n      for older browsers and 'flow-root' for modern browsers.\n\n      @see https://css-tricks.com/display-flow-root/\n    */display:table;display:flow-root;}ul,ul ul ul ul{list-style-type:disc;}ul ul,ul ul ul ul ul{list-style-type:circle;}ul ul ul,ul ul ul ul ul ul{list-style-type:square;}ol,ol ol ol ol{list-style-type:decimal;}ol ol,ol ol ol ol ol{list-style-type:lower-alpha;}ol ol ol,ol ol ol ol ol ol{list-style-type:lower-roman;}ol[data-indent-level='1'],ol[data-indent-level='4']{list-style-type:decimal;}ol[data-indent-level='2'],ol[data-indent-level='5']{list-style-type:lower-alpha;}ol[data-indent-level='3'],ol[data-indent-level='6']{list-style-type:lower-roman;}ul[data-indent-level='1'],ul[data-indent-level='4']{list-style-type:disc;}ul[data-indent-level='2'],ul[data-indent-level='5']{list-style-type:circle;}ul[data-indent-level='3'],ul[data-indent-level='6']{list-style-type:square;}");

});

parcelRegister("fS4LS", function(module, exports) {

$parcel$export(module.exports, "resolveOrder", () => $8f03f23b1eeeea4e$export$d445360e2a3c026b);
$parcel$export(module.exports, "getOrderFromOrderedListNode", () => $8f03f23b1eeeea4e$export$cbefb5b89ef0719f);
$parcel$export(module.exports, "getItemCounterDigitsSize", () => $8f03f23b1eeeea4e$export$320582fc14ba1e0f);
$parcel$export(module.exports, "isListNode", () => $8f03f23b1eeeea4e$export$a7d7d2b9ba4d4dbb);
$parcel$export(module.exports, "isParagraphNode", () => $8f03f23b1eeeea4e$export$35f600abfe6f0127);
$parcel$export(module.exports, "isListItemNode", () => $8f03f23b1eeeea4e$export$2ddb0a75547407f6);
$parcel$export(module.exports, "isBulletList", () => $8f03f23b1eeeea4e$export$35b2f400604e700);
$parcel$export(module.exports, "isOrderedList", () => $8f03f23b1eeeea4e$export$6e4e1502c6d9e5b8);
$parcel$export(module.exports, "isOrderedListContinuous", () => $8f03f23b1eeeea4e$export$a265e5f4220d0409);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/prosemirror-transformer/utils/list.ts
// If changes are made to this file, please make the same update in the linked file.
const $8f03f23b1eeeea4e$export$8ef94ae42a3729bd = 1;
const $8f03f23b1eeeea4e$export$d445360e2a3c026b = (order)=>{
    const num = Number(order);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $8f03f23b1eeeea4e$export$cbefb5b89ef0719f = (orderedListNode)=>{
    const order = orderedListNode?.attrs?.order;
    return $8f03f23b1eeeea4e$export$d445360e2a3c026b(order) ?? $8f03f23b1eeeea4e$export$8ef94ae42a3729bd;
};
const $8f03f23b1eeeea4e$export$320582fc14ba1e0f = (options)=>{
    const order = $8f03f23b1eeeea4e$export$d445360e2a3c026b(options.order) ?? $8f03f23b1eeeea4e$export$8ef94ae42a3729bd;
    const itemsCount = typeof options.itemsCount === 'number' ? options.itemsCount : 0;
    const largestCounter = order + (itemsCount - 1);
    return String(largestCounter)?.split('.')?.[0]?.length;
};
function $8f03f23b1eeeea4e$export$a7d7d2b9ba4d4dbb(node) {
    return Boolean(node && node.type && [
        'orderedList',
        'bulletList'
    ].includes(node.type.name));
}
function $8f03f23b1eeeea4e$export$35f600abfe6f0127(node) {
    return Boolean(node && node.type && 'paragraph' === node.type.name);
}
function $8f03f23b1eeeea4e$export$2ddb0a75547407f6(node) {
    return Boolean(node && node.type && 'listItem' === node.type.name);
}
function $8f03f23b1eeeea4e$export$35b2f400604e700(node) {
    return Boolean(node && node.type && 'bulletList' === node.type.name);
}
function $8f03f23b1eeeea4e$export$6e4e1502c6d9e5b8(node) {
    return Boolean(node && node.type && 'orderedList' === node.type.name);
}
const $8f03f23b1eeeea4e$export$a265e5f4220d0409 = (firstOrderedList, secondOrderedList)=>{
    if (!($8f03f23b1eeeea4e$export$6e4e1502c6d9e5b8(firstOrderedList) && $8f03f23b1eeeea4e$export$6e4e1502c6d9e5b8(secondOrderedList))) return false;
    return $8f03f23b1eeeea4e$export$cbefb5b89ef0719f(firstOrderedList) + firstOrderedList.childCount === $8f03f23b1eeeea4e$export$cbefb5b89ef0719f(secondOrderedList);
};

});


parcelRegister("1PFrh", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9ba1ef480aabd69$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kCf67 = parcelRequire("kCf67");
function $c9ba1ef480aabd69$export$2e2bcd8739ae039({ children: children, dataAttributes: dataAttributes }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", dataAttributes, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kCf67.default), null, children));
}

});
parcelRegister("kCf67", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f2a3f638b2bb379$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $0f2a3f638b2bb379$export$2e2bcd8739ae039(props) {
    const { children: children } = props;
    const childCount = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(children).length;
    if (!childCount) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, "\xa0");
    return children;
}

});


parcelRegister("lOrB2", function(module, exports) {

$parcel$export(module.exports, "default", () => $8631e4f292d72a1d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $8631e4f292d72a1d$export$2e2bcd8739ae039(props) {
    if (props.allowPlaceholderText) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        "data-placeholder": `${props.text}`
    }, props.text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null);
}

});

parcelRegister("1OmSI", function(module, exports) {

$parcel$export(module.exports, "default", () => $703438935d5e4acf$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $703438935d5e4acf$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("hr", null);
}

});

parcelRegister("5hibD", function(module, exports) {

$parcel$export(module.exports, "isTableResizingEnabled", () => $2343f7ca7945d21e$export$eec82c0a93aa66d9);
$parcel$export(module.exports, "default", () => $2343f7ca7945d21e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $mJhHc = parcelRequire("mJhHc");

var $8AkRK = parcelRequire("8AkRK");
var $4iaaT = parcelRequire("4iaaT");

var $iYHWS = parcelRequire("iYHWS");
var $9lEAD = parcelRequire("9lEAD");
var $40AXa = parcelRequire("40AXa");

var $8DyOy = parcelRequire("8DyOy");

var $25FYC = parcelRequire("25FYC");

var $2JJ1l = parcelRequire("2JJ1l");

var $XHGTv = parcelRequire("XHGTv");

var $9pV0l = parcelRequire("9pV0l");

var $bIQK1 = parcelRequire("bIQK1");

var $2dNsW = parcelRequire("2dNsW");

var $8GvDy = parcelRequire("8GvDy");

var $5pCn0 = parcelRequire("5pCn0");

var $5IOJr = parcelRequire("5IOJr");
const $2343f7ca7945d21e$export$eec82c0a93aa66d9 = (appearance)=>(0, $5IOJr.isFullWidthOrFullPageAppearance)(appearance);
const $2343f7ca7945d21e$var$orderChildren = (children, tableNode, smartCardStorage, tableOrderStatus)=>{
    if (!tableOrderStatus || tableOrderStatus.order === (0, $8DyOy.SortOrder).NO_ORDER) return children;
    const { order: order, columnIndex: columnIndex } = tableOrderStatus;
    const compareNodesInOrder = (0, $40AXa.createCompareNodes)({
        getInlineCardTextFromStore (attrs) {
            const { url: url } = attrs;
            if (!url) return null;
            return smartCardStorage.get(url) || null;
        }
    }, order);
    const tableArray = (0, $9lEAD.convertProsemirrorTableNodeToArrayOfRows)(tableNode);
    const tableArrayWithChildren = tableArray.map((rowNodes, index)=>({
            rowNodes: rowNodes,
            rowReact: children[index]
        }));
    const headerRow = tableArrayWithChildren.shift();
    const sortedTable = tableArrayWithChildren.sort((rowA, rowB)=>compareNodesInOrder(rowA.rowNodes[columnIndex], rowB.rowNodes[columnIndex]));
    if (headerRow) sortedTable.unshift(headerRow);
    return sortedTable.map((elem)=>elem.rowReact);
};
const $2343f7ca7945d21e$var$hasRowspan = (row)=>{
    let hasRowspan = false;
    row.forEach((cell)=>hasRowspan = hasRowspan || cell.attrs.rowspan > 1);
    return hasRowspan;
};
const $2343f7ca7945d21e$var$getRefTop = (refElement)=>{
    return Math.round(refElement.getBoundingClientRect().top);
};
const $2343f7ca7945d21e$var$shouldHeaderStick = (scrollTop, tableTop, tableBottom, rowHeight)=>tableTop <= scrollTop && !(tableBottom - rowHeight <= scrollTop);
const $2343f7ca7945d21e$var$shouldHeaderPinBottom = (scrollTop, tableBottom, rowHeight)=>tableBottom - rowHeight <= scrollTop && !(tableBottom < scrollTop);
const $2343f7ca7945d21e$var$addSortableColumn = (rows, tableOrderStatus, onSorting)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.map(rows, (row, index)=>{
        if (index === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.only(row), {
            tableOrderStatus: tableOrderStatus,
            onSorting: onSorting
        });
        return row;
    });
};
const $2343f7ca7945d21e$var$isHeaderRowEnabled = (rows)=>{
    if (!rows.length) return false;
    const { children: children } = rows[0].props;
    if (!children.length) return false;
    if (children.length === 1) return children[0].type === (0, $bIQK1.TableHeader);
    return children.every((node)=>node.type === (0, $bIQK1.TableHeader));
};
const $2343f7ca7945d21e$var$tableCanBeSticky = (node, children)=>{
    return $2343f7ca7945d21e$var$isHeaderRowEnabled(children) && node && node.firstChild && !$2343f7ca7945d21e$var$hasRowspan(node.firstChild);
};
const $2343f7ca7945d21e$var$canUseLinelength = (appearance)=>appearance === 'full-page' || appearance === 'mobile';
class $2343f7ca7945d21e$export$f2c3aea42b2a048f extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    componentDidMount() {
        this.resizeObserver = new ResizeObserver(this.applyResizerChange);
        if (this.wrapperRef.current) this.resizeObserver.observe(this.wrapperRef.current);
        if (this.stickyHeaderRef.current) this.resizeObserver.observe(this.stickyHeaderRef.current);
        if (this.props.stickyHeaders) {
            this.overflowParent = (0, $8GvDy.OverflowParent).fromElement(this.tableRef.current);
            this.overflowParent.addEventListener('scroll', this.onScroll);
        }
    }
    componentDidUpdate(prevProps, prevState) {
        // toggling sticky headers visiblity
        if (this.props.stickyHeaders && !this.overflowParent) this.overflowParent = (0, $8GvDy.OverflowParent).fromElement(this.tableRef.current);
        else if (!this.props.stickyHeaders && this.overflowParent) {
            this.overflowParent.removeEventListener('scroll', this.onScroll);
            this.overflowParent = null;
        }
        // offsetTop might have changed, re-position sticky header
        if (this.props.stickyHeaders !== prevProps.stickyHeaders) this.updateSticky();
        // sync horizontal scroll in floating div when toggling modes
        if (prevState.stickyMode !== this.state.stickyMode) this.onWrapperScrolled();
    }
    get pinTop() {
        if (!this.tableRef.current || !this.stickyHeaderRef.current) return;
        return this.tableRef.current.offsetHeight - this.stickyHeaderRef.current.offsetHeight + (0, $mJhHc.tableMarginTop) - (0, $8GvDy.tableStickyPadding);
    }
    get stickyTop() {
        switch(this.state.stickyMode){
            case 'pin-bottom':
                return this.pinTop;
            case 'stick':
                return this.props.stickyHeaders && this.props.stickyHeaders.offsetTop;
            default:
                return undefined;
        }
    }
    render() {
        const { isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, renderWidth: renderWidth, columnWidths: columnWidths, stickyHeaders: stickyHeaders, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension } = this.props;
        const { stickyMode: stickyMode } = this.state;
        const lineLengthFixedWidth = (0, $25FYC.akEditorDefaultLayoutWidth);
        let left;
        let updatedLayout;
        // The tableWidth and left offset logic below must stay aligned with the `breakout-ssr.tsx` logic
        // Please consider changes below carefully to not negatively impact SSR
        // `renderWidth` cannot be depended on during SSR
        const isRenderWidthValid = !!renderWidth && renderWidth > 0;
        const calcDefaultLayoutWidthByAppearance = (rendererAppearance, tableNode)=>{
            if (rendererAppearance === 'full-width' && !tableNode?.attrs.width) return isRenderWidthValid ? Math.min((0, $25FYC.akEditorFullWidthLayoutWidth), renderWidth) : (0, $25FYC.akEditorFullWidthLayoutWidth);
            else {
                // custom width, or width mapped to breakpoint
                const tableContainerWidth = (0, $2JJ1l.getTableContainerWidth)(tableNode);
                return isRenderWidthValid ? Math.min(tableContainerWidth, renderWidth) : tableContainerWidth;
            }
        };
        const tableWidth = calcDefaultLayoutWidthByAppearance(rendererAppearance, tableNode);
        // Logic for table alignment in renderer
        const isTableAlignStart = (0, $XHGTv.getBooleanFF)('platform.editor.table.allow-table-alignment') && (0, $5IOJr.isFullWidthOrFullPageAppearance)(rendererAppearance) && tableNode && tableNode.attrs && tableNode.attrs.layout === 'align-start';
        const fullWidthLineLength = isRenderWidthValid ? Math.min((0, $25FYC.akEditorFullWidthLayoutWidth), renderWidth) : (0, $25FYC.akEditorFullWidthLayoutWidth);
        const lineLength = (0, $5IOJr.isFullWidthAppearance)(rendererAppearance) ? fullWidthLineLength : lineLengthFixedWidth;
        const shouldCalculateLeftForAlignment = isTableAlignStart && ((0, $5IOJr.isFullPageAppearance)(rendererAppearance) && tableWidth <= lineLengthFixedWidth || (0, $5IOJr.isFullWidthAppearance)(rendererAppearance));
        if (shouldCalculateLeftForAlignment) left = (tableWidth - lineLength) / 2;
        if (!shouldCalculateLeftForAlignment && $2343f7ca7945d21e$var$canUseLinelength(rendererAppearance) && tableWidth > lineLengthFixedWidth) left = lineLengthFixedWidth / 2 - tableWidth / 2;
        const children = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(this.props.children);
        // Historically, tables in the full-width renderer had their layout set to 'default' which is deceiving.
        // This check caters for those tables and helps with SSR logic
        const isFullWidth = !tableNode?.attrs.width && rendererAppearance === 'full-width' && layout !== 'full-width';
        if (isFullWidth) updatedLayout = 'full-width';
        else if (tableNode?.attrs.width) updatedLayout = 'custom';
        else updatedLayout = layout;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $mJhHc.TableSharedCssClassName).TABLE_CONTAINER} ${this.props.shadowClassNames || ''}`,
            "data-layout": updatedLayout,
            ref: this.props.handleRef,
            style: {
                width: $2343f7ca7945d21e$export$eec82c0a93aa66d9(rendererAppearance) ? tableWidth : 'inherit',
                left: left,
                marginLeft: shouldCalculateLeftForAlignment && left !== undefined ? -left : undefined
            }
        }, stickyHeaders && $2343f7ca7945d21e$var$tableCanBeSticky(tableNode, children) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8GvDy.StickyTable), {
            isNumberColumnEnabled: isNumberColumnEnabled,
            tableWidth: tableWidth,
            layout: layout,
            renderWidth: renderWidth,
            handleRef: this.props.handleRef,
            shadowClassNames: this.props.shadowClassNames,
            top: this.stickyTop,
            mode: stickyMode,
            innerRef: this.stickyWrapperRef,
            wrapperWidth: this.state.wrapperWidth,
            columnWidths: columnWidths,
            rowHeight: this.state.headerRowHeight,
            tableNode: tableNode,
            rendererAppearance: rendererAppearance
        }, [
            children && children[0]
        ]), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $mJhHc.TableSharedCssClassName).TABLE_NODE_WRAPPER,
            ref: this.wrapperRef,
            onScroll: this.props.stickyHeaders && this.onWrapperScrolled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5pCn0.Table), {
            innerRef: this.tableRef,
            columnWidths: columnWidths,
            layout: layout,
            isNumberColumnEnabled: isNumberColumnEnabled,
            renderWidth: renderWidth,
            tableNode: tableNode,
            rendererAppearance: rendererAppearance,
            isInsideOfBlockNode: isInsideOfBlockNode,
            isinsideMultiBodiedExtension: isinsideMultiBodiedExtension
        }, this.grabFirstRowRef(children)))));
    }
    constructor(...args){
        super(...args);
        this.state = {
            stickyMode: 'none',
            wrapperWidth: 0,
            headerRowHeight: 0
        };
        this.tableRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.stickyHeaderRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        // used for sync scroll + copying wrapper width to sticky header
        this.stickyWrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.wrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.overflowParent = null;
        this.resizeObserver = null;
        this.applyResizerChange = (entries)=>{
            let wrapperWidth = this.state.wrapperWidth;
            let headerRowHeight = this.state.headerRowHeight;
            for (const entry of entries){
                if (entry.target === this.wrapperRef.current) wrapperWidth = entry.contentRect.width;
                else if (entry.target === this.stickyHeaderRef.current) headerRowHeight = Math.round(entry.contentRect.height);
            }
            if (headerRowHeight !== this.state.headerRowHeight || wrapperWidth !== this.state.wrapperWidth) this.setState({
                wrapperWidth: wrapperWidth,
                headerRowHeight: headerRowHeight
            });
        };
        this.componentWillUnmount = ()=>{
            if (this.overflowParent) this.overflowParent.removeEventListener('scroll', this.onScroll);
            if (this.nextFrame) cancelAnimationFrame(this.nextFrame);
            if (this.resizeObserver) this.resizeObserver.disconnect();
        };
        this.getScrollTop = ()=>{
            const { stickyHeaders: stickyHeaders } = this.props;
            const offsetTop = stickyHeaders && stickyHeaders.offsetTop || 0;
            return (this.overflowParent ? this.overflowParent.top : 0) + offsetTop;
        };
        this.updateSticky = ()=>{
            const tableElem = this.tableRef.current;
            const refElem = this.stickyHeaderRef.current;
            if (!tableElem || !refElem) return;
            const scrollTop = this.getScrollTop() + (0, $8GvDy.tableStickyPadding);
            const tableTop = $2343f7ca7945d21e$var$getRefTop(tableElem);
            const tableBottom = tableTop + tableElem.clientHeight;
            const shouldSticky = $2343f7ca7945d21e$var$shouldHeaderStick(scrollTop, tableTop, tableBottom, refElem.clientHeight);
            const shouldPin = $2343f7ca7945d21e$var$shouldHeaderPinBottom(scrollTop, tableBottom, refElem.clientHeight);
            let stickyMode = 'none';
            if (shouldPin) stickyMode = 'pin-bottom';
            else if (shouldSticky) stickyMode = 'stick';
            if (this.state.stickyMode !== stickyMode) this.setState({
                stickyMode: stickyMode
            });
            this.nextFrame = undefined;
        };
        this.onScroll = ()=>{
            if (!this.nextFrame) this.nextFrame = requestAnimationFrame(this.updateSticky);
        };
        this.onWrapperScrolled = ()=>{
            if (!this.wrapperRef.current || !this.stickyWrapperRef.current) return;
            this.stickyWrapperRef.current.scrollLeft = this.wrapperRef.current.scrollLeft;
        };
        this.grabFirstRowRef = (children)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.map(children || false, (child, idx)=>{
                if (idx === 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(child, {
                    innerRef: this.stickyHeaderRef
                });
                return child;
            });
        };
    }
}
class $2343f7ca7945d21e$export$91e0997fd3f75d56 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { children: children } = this.props;
        if (!children) return null;
        let childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(children);
        const orderedChildren = (0, $iYHWS.compose)(this.addNumberColumnIndexes, this.addSortableColumn)(childrenArray);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2343f7ca7945d21e$export$f2c3aea42b2a048f, this.props, orderedChildren);
    }
    constructor(...args){
        super(...args);
        this.state = {
            tableOrderStatus: undefined
        };
        // adds sortable + re-orders children
        this.addSortableColumn = (childrenArray)=>{
            const { tableNode: tableNode, allowColumnSorting: allowColumnSorting, smartCardStorage: smartCardStorage } = this.props;
            const { tableOrderStatus: tableOrderStatus } = this.state;
            if (allowColumnSorting && $2343f7ca7945d21e$var$isHeaderRowEnabled(childrenArray) && tableNode && !(0, $9lEAD.hasMergedCell)(tableNode)) return $2343f7ca7945d21e$var$addSortableColumn($2343f7ca7945d21e$var$orderChildren(childrenArray, tableNode, smartCardStorage, tableOrderStatus), tableOrderStatus, this.changeSortOrder);
            return childrenArray;
        };
        this.changeSortOrder = (columnIndex, sortOrder)=>{
            this.setState({
                tableOrderStatus: {
                    columnIndex: columnIndex,
                    order: sortOrder
                }
            });
        };
        this.addNumberColumnIndexes = (rows)=>{
            const { isNumberColumnEnabled: isNumberColumnEnabled } = this.props;
            const headerRowEnabled = $2343f7ca7945d21e$var$isHeaderRowEnabled(rows);
            return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.map(rows, (row, index)=>{
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.only(row), {
                    isNumberColumnEnabled: isNumberColumnEnabled,
                    index: headerRowEnabled ? index === 0 ? '' : index : index + 1
                });
            });
        };
    }
}
const $2343f7ca7945d21e$var$TableWithShadows = (0, $8AkRK.default)($2343f7ca7945d21e$export$91e0997fd3f75d56, {
    overflowSelector: `.${(0, $mJhHc.TableSharedCssClassName).TABLE_NODE_WRAPPER}`,
    useShadowObserver: true
});
const $2343f7ca7945d21e$var$TableWithWidth = (props)=>{
    // Remember, `width` will be 0 during SSR
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4iaaT.WidthConsumer), null, ({ width: width })=>{
        // we are adding full page padding before but now it cause difference between editor and renderer so we need to remove it, and 1px also for matching exact width.
        const renderWidth = props.rendererAppearance === 'full-page' ? (0, $XHGTv.getBooleanFF)('platform.editor.table-width-diff-in-renderer_x5s3z') ? width + (0, $9pV0l.FullPagePadding) - 1 : width - (0, $9pV0l.FullPagePadding) * 2 : width;
        const colWidthsSum = props.columnWidths?.reduce((total, val)=>total + val, 0) || 0;
        if (colWidthsSum || $2343f7ca7945d21e$export$eec82c0a93aa66d9(props.rendererAppearance)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2343f7ca7945d21e$var$TableWithShadows, {
            renderWidth: renderWidth,
            ...props
        });
        // there should not be a case when colWidthsSum is 0 and table is in overflow state - so no need to render shadows in this case
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2343f7ca7945d21e$export$91e0997fd3f75d56, {
            renderWidth: renderWidth,
            ...props
        });
    });
};
var $2343f7ca7945d21e$export$2e2bcd8739ae039 = (0, $2dNsW.withSmartCardStorage)($2343f7ca7945d21e$var$TableWithWidth);

});
parcelRegister("mJhHc", function(module, exports) {

$parcel$export(module.exports, "tableMarginTop", () => $6271954a5ccf999f$export$808015ab1dd6897a);
$parcel$export(module.exports, "tableMarginTopWithControl", () => $6271954a5ccf999f$export$910bf0d22c3d10f2);
$parcel$export(module.exports, "tableMarginSides", () => $6271954a5ccf999f$export$a43e30915fab3ccf);
$parcel$export(module.exports, "tableCellMinWidth", () => $6271954a5ccf999f$export$531f77930bf508de);
$parcel$export(module.exports, "tableNewColumnMinWidth", () => $6271954a5ccf999f$export$c60fae4049791eae);
$parcel$export(module.exports, "tableCellBorderWidth", () => $6271954a5ccf999f$export$72aad729077aa0fb);
$parcel$export(module.exports, "tableCellPadding", () => $6271954a5ccf999f$export$e56b8ca552b280f6);
$parcel$export(module.exports, "TableSharedCssClassName", () => $6271954a5ccf999f$export$c096bca5477eb7ad);
$parcel$export(module.exports, "tableSharedStyle", () => $6271954a5ccf999f$export$c2bf8eea75aa9302);
$parcel$export(module.exports, "calcTableWidth", () => $6271954a5ccf999f$export$d7ece4d8beb06815);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $byxO6 = parcelRequire("byxO6");

var $25FYC = parcelRequire("25FYC");
var $bCCqk = parcelRequire("bCCqk");

var $XHGTv = parcelRequire("XHGTv");

var $jMQbs = parcelRequire("jMQbs");

var $9SSfJ = parcelRequire("9SSfJ");

var $17wmF = parcelRequire("17wmF");
const $6271954a5ccf999f$export$808015ab1dd6897a = 24;
const $6271954a5ccf999f$export$afe1899c3eea9823 = 16;
const $6271954a5ccf999f$export$910bf0d22c3d10f2 = 14;
const $6271954a5ccf999f$export$a43e30915fab3ccf = 8;
const $6271954a5ccf999f$export$531f77930bf508de = 48;
const $6271954a5ccf999f$export$c60fae4049791eae = 140;
const $6271954a5ccf999f$export$72aad729077aa0fb = 1;
const $6271954a5ccf999f$export$e56b8ca552b280f6 = 8;
const $6271954a5ccf999f$export$bba39e724bc39451 = 6;
const $6271954a5ccf999f$export$c096bca5477eb7ad = {
    TABLE_CONTAINER: `${(0, $byxO6.tablePrefixSelector)}-container`,
    TABLE_NODE_WRAPPER: `${(0, $byxO6.tablePrefixSelector)}-wrapper`,
    TABLE_LEFT_SHADOW: `${(0, $byxO6.tablePrefixSelector)}-with-left-shadow`,
    TABLE_RIGHT_SHADOW: `${(0, $byxO6.tablePrefixSelector)}-with-right-shadow`,
    TABLE_STICKY_SHADOW: `${(0, $byxO6.tablePrefixSelector)}-sticky-shadow`,
    TABLE_STICKY_WRAPPER: `${(0, $byxO6.tablePrefixSelector)}-sticky-wrapper`,
    TABLE_STICKY_SCROLLBAR_CONTAINER: `${(0, $byxO6.tablePrefixSelector)}-sticky-scrollbar-container`,
    TABLE_STICKY_SENTINEL_TOP: `${(0, $byxO6.tablePrefixSelector)}-sticky-sentinel-top`,
    TABLE_STICKY_SENTINEL_BOTTOM: `${(0, $byxO6.tablePrefixSelector)}-sticky-sentinel-bottom`,
    TABLE_STICKY_SCROLLBAR_SENTINEL_TOP: `${(0, $byxO6.tablePrefixSelector)}-sticky-scrollbar-sentinel-top`,
    TABLE_STICKY_SCROLLBAR_SENTINEL_BOTTOM: `${(0, $byxO6.tablePrefixSelector)}-sticky-scrollbar-sentinel-bottom`,
    TABLE_SHADOW_SENTINEL_LEFT: `${(0, $byxO6.tablePrefixSelector)}-shadow-sentinel-left`,
    TABLE_SHADOW_SENTINEL_RIGHT: `${(0, $byxO6.tablePrefixSelector)}-shadow-sentinel-right`,
    TABLE_CELL_NODEVIEW_CONTENT_DOM: (0, $byxO6.tableCellContentDomSelector),
    TABLE_CELL_WRAPPER: (0, $byxO6.tableCellSelector),
    TABLE_HEADER_CELL_WRAPPER: (0, $byxO6.tableHeaderSelector),
    TABLE_ROW_CONTROLS_WRAPPER: `${(0, $byxO6.tablePrefixSelector)}-row-controls-wrapper`,
    TABLE_COLUMN_CONTROLS_DECORATIONS: `${(0, $byxO6.tablePrefixSelector)}-column-controls-decoration`,
    TABLE_RESIZER_CONTAINER: `${(0, $byxO6.tablePrefixSelector)}-resizer-container`
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Appears safe to auto-fix, but leaving it up to the team to remediate as the readability only gets worse with autofixing
const $6271954a5ccf999f$export$c2bf8eea75aa9302 = ()=>/*#__PURE__*/ (0, $byn9U.css)((0, $17wmF.tableCellBackgroundStyleOverride)(), " .", $6271954a5ccf999f$export$c096bca5477eb7ad.TABLE_CONTAINER, "{position:relative;margin:0 auto var(--ds-space-200, 16px);box-sizing:border-box;.decisionItemView-content-wrap:first-of-type>div{margin-top:0;}}.", $6271954a5ccf999f$export$c096bca5477eb7ad.TABLE_CONTAINER, "[data-number-column='true']{padding-left:", (0, $25FYC.akEditorTableNumberColumnWidth) - 1, "px;clear:both;}.", $6271954a5ccf999f$export$c096bca5477eb7ad.TABLE_RESIZER_CONTAINER, "{will-change:width,margin-left;}.", $6271954a5ccf999f$export$c096bca5477eb7ad.TABLE_RESIZER_CONTAINER, " table{will-change:width;}.", $6271954a5ccf999f$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER, ">table{margin:var(--ds-space-300, 24px) 0 0 0;}.", $6271954a5ccf999f$export$c096bca5477eb7ad.TABLE_CONTAINER, ">table,.", $6271954a5ccf999f$export$c096bca5477eb7ad.TABLE_STICKY_WRAPPER, ">table{margin:var(--ds-space-300, 24px) var(--ds-space-100, 8px) 0 0;}.", $6271954a5ccf999f$export$c096bca5477eb7ad.TABLE_CONTAINER, ">table,.", $6271954a5ccf999f$export$c096bca5477eb7ad.TABLE_NODE_WRAPPER, ">table,.", $6271954a5ccf999f$export$c096bca5477eb7ad.TABLE_STICKY_WRAPPER, ">table{border-collapse:collapse;border:", $6271954a5ccf999f$export$72aad729077aa0fb, "px solid ", `var(--ds-background-accent-gray-subtler, ${(0, $25FYC.akEditorTableBorder)})`, ";table-layout:fixed;font-size:1em;width:100%;&[data-autosize='true']{table-layout:auto;}&{*{box-sizing:border-box;}hr{box-sizing:content-box;}tbody{border-bottom:none;}th td{background-color:var(--ds-background-neutral-subtle, white);}th,td{min-width:", $6271954a5ccf999f$export$531f77930bf508de, "px;font-weight:normal;vertical-align:top;border:1px solid ", `var(--ds-background-accent-gray-subtler, ${(0, $25FYC.akEditorTableBorder)})`, ";border-right-width:0;border-bottom-width:0;padding:", (0, $XHGTv.fg)('platform_editor_tables_padding_increase') ? `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-250, 20px)"}` : "var(--ds-space-100, 8px)", ";", (0, $jMQbs.default).gecko || (0, $jMQbs.default).ie || (0, $jMQbs.default).mac && (0, $jMQbs.default).chrome ? 'background-clip: padding-box;' : '', ">:first-child:not(style),>style:first-child+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+*,>style:first-child+.ProseMirror-gapcursor+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+span+*,>style:first-child+.ProseMirror-gapcursor+span+*{margin-top:0;}th p:not(:first-of-type),td p:not(:first-of-type){margin-top:var(--ds-space-150, 12px);}}th{background-color:", `var(--ds-background-accent-gray-subtlest, ${(0, $25FYC.akEditorTableToolbar)})`, ";text-align:left;&:not([style]):not(.danger){.", (0, $9SSfJ.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, ":not(.danger){background-color:var(--ds-surface-raised, rgb(235, 237, 240));:not(.", (0, $25FYC.akEditorSelectedNodeClassName), "){box-shadow:0px 0px 0px 1px var(--ds-border, transparent);}.", (0, $9SSfJ.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER, "{background-image:", (0, $bCCqk.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), ";background-color:var(--ds-background-neutral, rgb(235, 237, 240));}.", (0, $9SSfJ.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER, "{background-color:var(--ds-background-neutral, rgb(226, 229, 233));}>[data-ds--code--code-block]{background-image:", (0, $bCCqk.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), "!important;background-color:var(--ds-background-neutral, rgb(235, 237, 240))!important;--ds--code--line-number-bg-color:var(--ds-background-neutral, rgb(226, 229, 233));}}}}}}");
const $6271954a5ccf999f$export$d7ece4d8beb06815 = (layout, containerWidth, addControllerPadding = true)=>{
    switch(layout){
        case 'full-width':
            return containerWidth ? Math.min(containerWidth - (addControllerPadding ? (0, $25FYC.akEditorBreakoutPadding) : 0), (0, $25FYC.akEditorFullWidthLayoutWidth)) : (0, $25FYC.akEditorFullWidthLayoutWidth);
        case 'wide':
            if (containerWidth) return Math.min(containerWidth - (addControllerPadding ? (0, $25FYC.akEditorBreakoutPadding) : 0), (0, $25FYC.akEditorWideLayoutWidth));
            return 0, $25FYC.akEditorWideLayoutWidth;
        default:
            return 'inherit';
    }
};

});
parcelRegister("bCCqk", function(module, exports) {

$parcel$export(module.exports, "overflowShadow", () => $d830dab92300d0ea$export$c5c1e4f4640336fb);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
const $d830dab92300d0ea$export$c5c1e4f4640336fb = ({ leftCoverWidth: leftCoverWidth, rightCoverWidth: rightCoverWidth })=>{
    const width = "var(--ds-space-100, 8px)";
    const leftCoverWidthResolved = leftCoverWidth || width;
    const rightCoverWidthResolved = rightCoverWidth || width;
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $byn9U.css)();
};

});

parcelRegister("9SSfJ", function(module, exports) {

$parcel$export(module.exports, "CodeBlockSharedCssClassName", () => $eb33b06689f56208$export$42659c26f026f6ea);
$parcel$export(module.exports, "codeBlockSharedStyles", () => $eb33b06689f56208$export$a4fbe21dc6fae881);
$parcel$export(module.exports, "codeBlockInListSafariFix", () => $eb33b06689f56208$export$3aa5ee2f4c156533);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- Should be safe to autofix, but ignoring for now */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");
var $bCCqk = parcelRequire("bCCqk");

var $PdmhA = parcelRequire("PdmhA");

var $lcnyw = parcelRequire("lcnyw");
const $eb33b06689f56208$export$42659c26f026f6ea = {
    CODEBLOCK_CONTAINER: 'code-block',
    CODEBLOCK_START: 'code-block--start',
    CODEBLOCK_END: 'code-block--end',
    CODEBLOCK_CONTENT_WRAPPER: 'code-block-content-wrapper',
    CODEBLOCK_LINE_NUMBER_GUTTER: 'line-number-gutter',
    CODEBLOCK_CONTENT: 'code-content',
    DS_CODEBLOCK: '[data-ds--code--code-block]'
};
const $eb33b06689f56208$export$a4fbe21dc6fae881 = ()=>/*#__PURE__*/ (0, $byn9U.css)(".", $eb33b06689f56208$export$42659c26f026f6ea.CODEBLOCK_CONTAINER, "{position:relative;background-color:var(--ds-surface-raised, transparent);border-radius:var(--ds-border-radius, 3px);margin:", (0, $25FYC.blockNodesVerticalMargin), " 0 0 0;font-family:", (0, $25FYC.akEditorCodeFontFamily), ";min-width:", (0, $25FYC.akEditorTableCellMinWidth), "px;cursor:pointer;--ds--code--bg-color:transparent;white-space:normal;.", $eb33b06689f56208$export$42659c26f026f6ea.CODEBLOCK_START, "{position:absolute;visibility:hidden;height:1.5rem;top:0px;left:0px;}.", $eb33b06689f56208$export$42659c26f026f6ea.CODEBLOCK_END, "{position:absolute;visibility:hidden;height:1.5rem;bottom:0px;right:0px;}.", $eb33b06689f56208$export$42659c26f026f6ea.CODEBLOCK_CONTENT_WRAPPER, "{background-color:", `var(--ds-background-neutral, ${(0, $PdmhA.N20)})`, ";display:flex;border-radius:var(--ds-border-radius, 3px);width:100%;counter-reset:line;overflow-x:auto;background-image:", (0, $bCCqk.overflowShadow)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    }), ";background-repeat:no-repeat;background-attachment:local,local,local,local,scroll,scroll,scroll,scroll;background-size:var(--ds-space-300, 24px) 100%,var(--ds-space-300, 24px) 100%,var(--ds-space-100, 8px) 100%,var(--ds-space-100, 8px) 100%,var(--ds-space-100, 8px) 100%,1px 100%,var(--ds-space-100, 8px) 100%,1px 100%;background-position:0 0,0 0,100% 0,100% 0,100% 0,100% 0,0 0,0 0;overflow-y:hidden;}.", $eb33b06689f56208$export$42659c26f026f6ea.CODEBLOCK_LINE_NUMBER_GUTTER, "{flex-shrink:0;text-align:right;background-color:", `var(--ds-background-neutral, ${(0, $PdmhA.N30)})`, ";padding:var(--ds-space-100, 8px);position:relative;span{display:block;line-height:0;font-size:0;::before{display:inline-block;content:counter(line);counter-increment:line;color:", `var(--ds-text-subtlest, ${(0, $PdmhA.N400)})`, ";font-size:", (0, $25FYC.relativeFontSizeToBase16)((0, $lcnyw.fontSize)()), ";line-height:1.5rem;}}}.", $eb33b06689f56208$export$42659c26f026f6ea.CODEBLOCK_CONTENT, "{display:flex;flex:1;code{flex-grow:1;tab-size:4;cursor:text;color:", `var(--ds-text, ${(0, $PdmhA.N800)})`, ";border-radius:var(--ds-border-radius, 3px);margin:var(--ds-space-100, 8px);white-space:pre;font-size:", (0, $25FYC.relativeFontSizeToBase16)((0, $lcnyw.fontSize)()), ";line-height:1.5rem;}}}");
const $eb33b06689f56208$export$3aa5ee2f4c156533 = /*#__PURE__*/ (0, $byn9U.css)("::before{content:' ';line-height:", (0, $25FYC.akEditorLineHeight), ";}>p:first-child,>.code-block:first-child,>.ProseMirror-gapcursor:first-child+.code-block{margin-top:-", (0, $25FYC.akEditorLineHeight), "em!important;}");

});

parcelRegister("17wmF", function(module, exports) {

$parcel$export(module.exports, "tableCellBackgroundStyleOverride", () => $9f1b588651706b74$export$677e93f0f5f9623a);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $byxO6 = parcelRequire("byxO6");

var $bNZ6o = parcelRequire("bNZ6o");
// This is used in order to support usage of DS tokens. Table cell background-color
// is set inline in '@atlaskit/adf-schema' and the color value is stored in ADF so
// it is not possible to use tokens there without polluting ADF.
// As table cell backgrounds are set inline, this should not break mobile as
// hexToEditorBackgroundPaletteColor() outputs a css variable with fallback hex.
const $9f1b588651706b74$var$mapBackgroundColors = ()=>{
    let cssString = '';
    (0, $byxO6.tableBackgroundColorNames).forEach((value, key)=>{
        const paletteColorValue = (0, $bNZ6o.hexToEditorBackgroundPaletteColor)(value);
        if (paletteColorValue) cssString += `
        td[colorname='${key}' i],
        th[colorname='${key}' i] {
          background-color: ${paletteColorValue} !important;
        }
      `;
    });
    return cssString;
};
const $9f1b588651706b74$export$677e93f0f5f9623a = ()=>/*#__PURE__*/ (0, $byn9U.css)($9f1b588651706b74$var$mapBackgroundColors());

});
parcelRegister("bNZ6o", function(module, exports) {

$parcel$export(module.exports, "hexToEditorBackgroundPaletteColor", () => $1e659e5f8f9e9d8c$export$5f6a44a42a4b38c2);
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", () => $1e659e5f8f9e9d8c$export$a270511a0e7fd61a);
// This import will be stripped on build

var $iX87Q = parcelRequire("iX87Q");
function $1e659e5f8f9e9d8c$export$5f6a44a42a4b38c2(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = $1e659e5f8f9e9d8c$export$2462741d70e6a62f[hexColor.toUpperCase()];
    return tokenData ? tokenData.token : undefined;
}
function $1e659e5f8f9e9d8c$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = $1e659e5f8f9e9d8c$export$2462741d70e6a62f[hexColor.toUpperCase()];
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
const $1e659e5f8f9e9d8c$export$2462741d70e6a62f = {
    // blue
    /** blue - light */ ['#DEEBFF']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.blue.subtlest', fallback),
        token: "var(--ds-background-accent-blue-subtlest, #DEEBFF)"
    },
    // source for hex code was legacy token B50
    /** blue - medium */ ['#B3D4FF']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.blue.subtler', fallback),
        token: "var(--ds-background-accent-blue-subtler, #B3D4FF)"
    },
    // source for hex code was legacy token B75
    /** blue - strong */ ['#4C9AFF']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.blue.subtle', fallback),
        token: "var(--ds-background-accent-blue-subtle, #4C9AFF)"
    },
    // source for hex code was legacy token B100
    // teal
    /** teal - light */ ['#E6FCFF']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.teal.subtlest', fallback),
        token: "var(--ds-background-accent-teal-subtlest, #E6FCFF)" // source for hex code was legacy token T50,
    },
    /** teal - medium */ ['#B3F5FF']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.teal.subtler', fallback),
        token: "var(--ds-background-accent-teal-subtler, #B3F5FF)" // source for hex code was legacy token T75,
    },
    /** teal - strong */ ['#79E2F2']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.teal.subtle', fallback),
        token: "var(--ds-background-accent-teal-subtle, #79E2F2)" // source for hex code was legacy token T100,
    },
    // green
    /** green - light */ ['#E3FCEF']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.green.subtlest', fallback),
        token: "var(--ds-background-accent-green-subtlest, #E3FCEF)" // source for hex code was legacy token G50,
    },
    /** green - medium */ ['#ABF5D1']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.green.subtler', fallback),
        token: "var(--ds-background-accent-green-subtler, #ABF5D1)" // source for hex code was legacy token G75,
    },
    /** green - strong */ ['#57D9A3']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.green.subtle', fallback),
        token: "var(--ds-background-accent-green-subtle, #57D9A3)" // source for hex code was legacy token G200,
    },
    // yellowOrange
    /** yellowOrange - light */ ['#FFFAE6']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.yellow.subtlest', fallback),
        token: "var(--ds-background-accent-yellow-subtlest, #FFFAE6)" // source for hex code was legacy token Y50,
    },
    /** yellowOrange - medium */ ['#FFF0B3']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.yellow.subtler', fallback),
        token: "var(--ds-background-accent-yellow-subtler, #FFF0B3)" // source for hex code was legacy token Y75,
    },
    /** yellowOrange - strong */ ['#FFC400']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.orange.subtle', fallback),
        token: "var(--ds-background-accent-orange-subtle, #FFC400)" // source for hex code was legacy token Y200,
    },
    // red
    /** red - light */ ['#FFEBE6']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.red.subtlest', fallback),
        token: "var(--ds-background-accent-red-subtlest, #FFEBE6)" // source for hex code was legacy token R50,
    },
    /** red - medium */ ['#FFBDAD']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.red.subtler', fallback),
        token: "var(--ds-background-accent-red-subtler, #FFBDAD)" // source for hex code was legacy token R75,
    },
    /** red - strong */ ['#FF8F73']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.red.subtle', fallback),
        token: "var(--ds-background-accent-red-subtle, #FF8F73)" // source for hex code was legacy token R100,
    },
    // purple
    /** purple - light */ ['#EAE6FF']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.purple.subtlest', fallback),
        token: "var(--ds-background-accent-purple-subtlest, #EAE6FF)" // source for hex code was legacy token P50,
    },
    /** purple - medium */ ['#C0B6F2']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.purple.subtler', fallback),
        token: "var(--ds-background-accent-purple-subtler, #C0B6F2)" // source for hex code was legacy token P75,
    },
    /** purple - strong */ ['#998DD9']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.purple.subtle', fallback),
        token: "var(--ds-background-accent-purple-subtle, #998DD9)" // source for hex code was legacy token P100,
    },
    // whiteGray
    /** whiteGray - light */ ['#FFFFFF']: {
        getValue: (fallback)=>(0, $iX87Q.default)('elevation.surface', fallback),
        token: "var(--ds-surface, #FFFFFF)" // source for hex code was legacy token N0,
    },
    /** whiteGray - medium */ ['#F4F5F7']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.gray.subtlest', fallback),
        token: "var(--ds-background-accent-gray-subtlest, #F4F5F7)" // source for hex code was legacy token N20,
    },
    /** whiteGray - strong */ ['#B3BAC5']: {
        getValue: (fallback)=>(0, $iX87Q.default)('color.background.accent.gray.subtle', fallback),
        token: "var(--ds-background-accent-gray-subtle, #B3BAC5)" // source for hex code was legacy token N60,
    }
};

});



parcelRegister("iYHWS", function(module, exports) {

$parcel$export(module.exports, "compose", () => $68fcb7b2f1ecd6d1$export$f672e0b6f7222cd7);
/** Helper type for single arg function */ function $68fcb7b2f1ecd6d1$export$f672e0b6f7222cd7(func, ...funcs) {
    const allFuncs = [
        func,
        ...funcs
    ];
    return function composed(raw) {
        return allFuncs.reduceRight((memo, func)=>func(memo), raw);
    };
}

});

parcelRegister("9lEAD", function(module, exports) {

$parcel$export(module.exports, "calcTableColumnWidths", () => $6cb2424413478105$export$98951d3cdcfd364b);
$parcel$export(module.exports, "hasMergedCell", () => $6cb2424413478105$export$f9d610bfbb78949b);
$parcel$export(module.exports, "convertProsemirrorTableNodeToArrayOfRows", () => $6cb2424413478105$export$69fbfaf01f2fd534);
$parcel$export(module.exports, "isPositionNearTableRow", () => $6cb2424413478105$export$889a8e446452be16);
function $6cb2424413478105$export$98951d3cdcfd364b(node) {
    let tableColumnWidths = [];
    const firstRow = node.firstChild;
    if (firstRow) // Sanity validation, but it should always have a first row
    // Iterate for the cells in the first row
    firstRow.forEach((colNode)=>{
        let colwidth = colNode.attrs.colwidth || [
            0
        ];
        // If we have colwidth, we added it
        if (colwidth) tableColumnWidths = [
            ...tableColumnWidths,
            ...colwidth
        ];
    });
    return tableColumnWidths;
}
function $6cb2424413478105$export$f9d610bfbb78949b(tableNode) {
    let hasSpan = false;
    tableNode.descendants((node)=>{
        if (node.type.name === 'tableRow') return true;
        const { colspan: colspan, rowspan: rowspan } = node.attrs;
        if (colspan > 1 || rowspan > 1) hasSpan = true;
        return false;
    });
    return hasSpan;
}
function $6cb2424413478105$export$69fbfaf01f2fd534(tableNode) {
    const result = [];
    tableNode.forEach((rowNode)=>{
        if (rowNode.type.name === 'tableRow') {
            const row = [];
            rowNode.forEach((n)=>row.push(n));
            result.push(row);
        }
    });
    return result;
}
function $6cb2424413478105$export$889a8e446452be16(pos, schema, direction) {
    if (!schema.nodes.tableRow) return false;
    let doc = pos.doc;
    let resolved = pos;
    const sibling = direction === 'before' ? 'nodeBefore' : 'nodeAfter';
    while(resolved.depth > 0){
        const siblingType = resolved[sibling]?.type;
        if (siblingType === schema.nodes.tableRow) return true;
        resolved = doc.resolve(resolved[direction]());
    }
    return false;
}

});

parcelRegister("40AXa", function(module, exports) {

$parcel$export(module.exports, "createCompareNodes", () => $886e901aefc55741$export$49215374a8bec29c);

var $8DyOy = parcelRequire("8DyOy");
var $886e901aefc55741$export$e2e108cbe2e4f865;
(function(ContentType) {
    ContentType[ContentType["NUMBER"] = 0] = "NUMBER";
    ContentType[ContentType["TEXT"] = 5] = "TEXT";
    ContentType[ContentType["MENTION"] = 10] = "MENTION";
    ContentType[ContentType["DATE"] = 15] = "DATE";
    ContentType[ContentType["STATUS"] = 20] = "STATUS";
    ContentType[ContentType["LINK"] = 25] = "LINK";
})($886e901aefc55741$export$e2e108cbe2e4f865 || ($886e901aefc55741$export$e2e108cbe2e4f865 = {}));
function $886e901aefc55741$var$getLinkMark(node) {
    const [linkMark] = node.marks.filter((mark)=>mark.type.name === 'link');
    return linkMark || null;
}
function $886e901aefc55741$var$parseLocaleNumber(stringNumber, groupPattern, fractionPattern) {
    if (!stringNumber.trim().length) return null;
    const maybeANumber = Number.parseFloat(stringNumber.replace(groupPattern, '').replace(fractionPattern, '.'));
    if (Number.isNaN(maybeANumber)) return null;
    return maybeANumber;
}
function $886e901aefc55741$export$8ebf986086b1866f() {
    // Source: https://stackoverflow.com/questions/12004808/does-javascript-take-local-decimal-separators-into-account
    const locale = window.navigator.language;
    const thousandSeparator = Intl.NumberFormat(locale).format(11111).replace(/\p{Number}/gu, '');
    const decimalSeparator = Intl.NumberFormat(locale).format(1.1).replace(/\p{Number}/gu, '');
    const numericPattern = new RegExp(`(\\d+(?:[${thousandSeparator}${decimalSeparator}]?\\d+)*)`, 'g');
    const thousandSeparatorPattern = new RegExp('\\' + thousandSeparator, 'g');
    const decimalSeparatorPattern = new RegExp('\\' + decimalSeparator);
    return (text)=>{
        if (!text.trim().length) return null;
        // This will break the text apart at the locations of the formatted numbers
        const result = text.split(numericPattern);
        // We then put the text back together but with all the formatted numbers converted back to plain numerals,
        // for example a sentence like "What is 1,000.01% of 10,000.01" would be normalized and sorted as
        // if it's saying "What is 1000.01% of 10000.01". This way the Intl.Collator can use the numeric setting to sort
        // numeral values within string correctly.
        const tokens = result.reduce((acc, stringNumber)=>{
            if (!stringNumber?.length) return acc;
            const maybeANumber = $886e901aefc55741$var$parseLocaleNumber(stringNumber, thousandSeparatorPattern, decimalSeparatorPattern);
            // NOTE: We know there can only be a single decimal separator. So we can assume that if the first found separator
            // is not at the same position as the last found one, then we can assume the locale used to format the number
            // is different to our locale. This will result in the value being treated as a string.
            if (maybeANumber !== null && stringNumber.indexOf(decimalSeparator) === stringNumber.lastIndexOf(decimalSeparator)) acc.push(maybeANumber);
            else acc.push(stringNumber);
            return acc;
        }, []);
        if (tokens.length === 1) return tokens[0];
        return tokens.join('');
    };
}
function $886e901aefc55741$export$7cc053f549ed70b8(textNode, normalizeTextParser) {
    // treat as a link if contain a link
    const linkMark = $886e901aefc55741$var$getLinkMark(textNode);
    if (linkMark) {
        const value = textNode.text || '';
        return {
            type: 25,
            value: value
        };
    }
    const text = textNode.text || '';
    const normalizedText = normalizeTextParser(text);
    if (typeof normalizedText === 'number') return {
        type: 0,
        value: normalizedText
    };
    return {
        type: 5,
        value: normalizedText ?? text
    };
}
function $886e901aefc55741$var$getMetaFromNode(node, options, normalizeTextParser) {
    if (!node) return null;
    const firstChild = node.firstChild;
    if (!firstChild) return null;
    switch(firstChild.type.name){
        // Text case
        /*
      Get Meta value from the first child if the cell is of type
        * Heading (Any cell where the text is set to a heading type)
        * Paragraph (Normal text)
     */ case 'heading':
        case 'paragraph':
            return $886e901aefc55741$var$getMetaFromNode(firstChild, options, normalizeTextParser);
        case 'inlineCard':
            {
                const attrs = firstChild.attrs;
                const maybeTitle = options.getInlineCardTextFromStore(attrs);
                if (maybeTitle) return {
                    type: 25,
                    value: maybeTitle
                };
                const url = attrs.url;
                return {
                    type: 25,
                    value: url ? url : ''
                };
            }
        case 'text':
            return $886e901aefc55741$export$7cc053f549ed70b8(firstChild, normalizeTextParser);
        case 'status':
            {
                const text = firstChild.attrs.text;
                return {
                    type: 20,
                    value: text
                };
            }
        case 'date':
            {
                const timestamp = Number.parseInt(firstChild.attrs.timestamp, 20);
                return {
                    type: 15,
                    value: timestamp
                };
            }
        case 'mention':
            {
                // TODO: Check what should be the fallback when mention does not have a text
                const text = firstChild.attrs.text || '';
                return {
                    type: 10,
                    value: text.toLowerCase()
                };
            }
        default:
            return null;
    }
}
function $886e901aefc55741$var$compareValue(valueA, valueB) {
    if (valueA === valueB) return 0;
    if (typeof valueA === 'string' && typeof valueB === 'string') return valueA.localeCompare(valueB, window.navigator.language, {
        caseFirst: 'upper',
        numeric: true
    });
    return valueA > valueB ? 1 : -1;
}
const $886e901aefc55741$export$49215374a8bec29c = (options, order = (0, $8DyOy.SortOrder).ASC)=>{
    const normalizeTextParser = $886e901aefc55741$export$8ebf986086b1866f();
    return (nodeA, nodeB)=>{
        const metaNodeA = $886e901aefc55741$var$getMetaFromNode(nodeA, options, normalizeTextParser);
        const metaNodeB = $886e901aefc55741$var$getMetaFromNode(nodeB, options, normalizeTextParser);
        /*
      Donot switch the order (Asec or Desc) if either node is null.
      This will ensure that empty cells are always at the bottom during sorting.
    */ if (metaNodeA === null || metaNodeB === null) return $886e901aefc55741$var$compareMetaFromNode(metaNodeA, metaNodeB);
        return (order === (0, $8DyOy.SortOrder).DESC ? -1 : 1) * $886e901aefc55741$var$compareMetaFromNode(metaNodeA, metaNodeB);
    };
};
function $886e901aefc55741$var$compareMetaFromNode(metaNodeA, metaNodeB) {
    if (metaNodeA === metaNodeB) return 0;
    if (metaNodeA === null || metaNodeB === null) return metaNodeB === null ? -1 : 1;
    if (metaNodeA.type !== metaNodeB.type) return metaNodeA.type > metaNodeB.type ? 1 : -1;
    return $886e901aefc55741$var$compareValue(metaNodeA.value, metaNodeB.value);
}

});
parcelRegister("8DyOy", function(module, exports) {

$parcel$export(module.exports, "SortOrder", () => $060dd58131e98cee$export$7ae723045d45777a);

var $3DXMd = parcelRequire("3DXMd");

var $7PkbE = parcelRequire("7PkbE");
var $060dd58131e98cee$export$7ae723045d45777a;
(function(SortOrder) {
    SortOrder["ASC"] = "asc";
    SortOrder["DESC"] = "desc";
    SortOrder["NO_ORDER"] = "no_order";
})($060dd58131e98cee$export$7ae723045d45777a || ($060dd58131e98cee$export$7ae723045d45777a = {}));

});
parcelRegister("3DXMd", function(module, exports) {

$parcel$export(module.exports, "AnnotationUpdateEvent", () => $959eb61d6ba0a905$export$c1c4b33b4e7b1c70);

var $3sTLs = parcelRequire("3sTLs");
var $959eb61d6ba0a905$export$c1c4b33b4e7b1c70;
(function(AnnotationUpdateEvent) {
    AnnotationUpdateEvent["SET_ANNOTATION_FOCUS"] = "SET_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["SET_ANNOTATION_STATE"] = "SET_ANNOTATION_STATE";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_FOCUS"] = "REMOVE_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["ON_ANNOTATION_CLICK"] = "ON_ANNOTATION_CLICK";
    AnnotationUpdateEvent["DESELECT_ANNOTATIONS"] = "DESELECT_ANNOTATIONS";
})($959eb61d6ba0a905$export$c1c4b33b4e7b1c70 || ($959eb61d6ba0a905$export$c1c4b33b4e7b1c70 = {}));
class $959eb61d6ba0a905$export$7cc60aa9ef845515 {
    emit(event, params) {
        if (typeof params === 'undefined') return this.emitter.emit(event);
        return this.emitter.emit(event, params);
    }
    on(event, listener) {
        return this.emitter.on(event, listener);
    }
    off(event, listener) {
        return this.emitter.removeListener(event, listener);
    }
    listeners(event) {
        return this.emitter.listeners(event);
    }
    constructor(){
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($3sTLs)))();
    }
}

});
parcelRegister("3sTLs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $285f3e4babf0bfc8$var$R = typeof Reflect === 'object' ? Reflect : null;
var $285f3e4babf0bfc8$var$ReflectApply = $285f3e4babf0bfc8$var$R && typeof $285f3e4babf0bfc8$var$R.apply === 'function' ? $285f3e4babf0bfc8$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $285f3e4babf0bfc8$var$ReflectOwnKeys;
if ($285f3e4babf0bfc8$var$R && typeof $285f3e4babf0bfc8$var$R.ownKeys === 'function') $285f3e4babf0bfc8$var$ReflectOwnKeys = $285f3e4babf0bfc8$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $285f3e4babf0bfc8$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $285f3e4babf0bfc8$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $285f3e4babf0bfc8$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $285f3e4babf0bfc8$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $285f3e4babf0bfc8$var$EventEmitter() {
    $285f3e4babf0bfc8$var$EventEmitter.init.call(this);
}
module.exports = $285f3e4babf0bfc8$var$EventEmitter;
module.exports.once = $285f3e4babf0bfc8$var$once;
// Backwards-compat with node 0.10.x
$285f3e4babf0bfc8$var$EventEmitter.EventEmitter = $285f3e4babf0bfc8$var$EventEmitter;
$285f3e4babf0bfc8$var$EventEmitter.prototype._events = undefined;
$285f3e4babf0bfc8$var$EventEmitter.prototype._eventsCount = 0;
$285f3e4babf0bfc8$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $285f3e4babf0bfc8$var$defaultMaxListeners = 10;
function $285f3e4babf0bfc8$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($285f3e4babf0bfc8$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $285f3e4babf0bfc8$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $285f3e4babf0bfc8$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $285f3e4babf0bfc8$var$defaultMaxListeners = arg;
    }
});
$285f3e4babf0bfc8$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$285f3e4babf0bfc8$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $285f3e4babf0bfc8$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $285f3e4babf0bfc8$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $285f3e4babf0bfc8$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$285f3e4babf0bfc8$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $285f3e4babf0bfc8$var$_getMaxListeners(this);
};
$285f3e4babf0bfc8$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $285f3e4babf0bfc8$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $285f3e4babf0bfc8$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$285f3e4babf0bfc8$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $285f3e4babf0bfc8$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $285f3e4babf0bfc8$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $285f3e4babf0bfc8$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $285f3e4babf0bfc8$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$285f3e4babf0bfc8$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $285f3e4babf0bfc8$var$_addListener(this, type, listener, false);
};
$285f3e4babf0bfc8$var$EventEmitter.prototype.on = $285f3e4babf0bfc8$var$EventEmitter.prototype.addListener;
$285f3e4babf0bfc8$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $285f3e4babf0bfc8$var$_addListener(this, type, listener, true);
};
function $285f3e4babf0bfc8$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $285f3e4babf0bfc8$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $285f3e4babf0bfc8$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$285f3e4babf0bfc8$var$EventEmitter.prototype.once = function once(type, listener) {
    $285f3e4babf0bfc8$var$checkListener(listener);
    this.on(type, $285f3e4babf0bfc8$var$_onceWrap(this, type, listener));
    return this;
};
$285f3e4babf0bfc8$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $285f3e4babf0bfc8$var$checkListener(listener);
    this.prependListener(type, $285f3e4babf0bfc8$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$285f3e4babf0bfc8$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $285f3e4babf0bfc8$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $285f3e4babf0bfc8$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$285f3e4babf0bfc8$var$EventEmitter.prototype.off = $285f3e4babf0bfc8$var$EventEmitter.prototype.removeListener;
$285f3e4babf0bfc8$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $285f3e4babf0bfc8$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $285f3e4babf0bfc8$var$unwrapListeners(evlistener) : $285f3e4babf0bfc8$var$arrayClone(evlistener, evlistener.length);
}
$285f3e4babf0bfc8$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $285f3e4babf0bfc8$var$_listeners(this, type, true);
};
$285f3e4babf0bfc8$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $285f3e4babf0bfc8$var$_listeners(this, type, false);
};
$285f3e4babf0bfc8$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $285f3e4babf0bfc8$var$listenerCount.call(emitter, type);
};
$285f3e4babf0bfc8$var$EventEmitter.prototype.listenerCount = $285f3e4babf0bfc8$var$listenerCount;
function $285f3e4babf0bfc8$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$285f3e4babf0bfc8$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $285f3e4babf0bfc8$var$ReflectOwnKeys(this._events) : [];
};
function $285f3e4babf0bfc8$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $285f3e4babf0bfc8$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $285f3e4babf0bfc8$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $285f3e4babf0bfc8$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $285f3e4babf0bfc8$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $285f3e4babf0bfc8$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $285f3e4babf0bfc8$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $285f3e4babf0bfc8$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $285f3e4babf0bfc8$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});


parcelRegister("7PkbE", function(module, exports) {

$parcel$export(module.exports, "ToolbarSize", () => $7affccbd0c281873$export$ed55211407a9423);
$parcel$export(module.exports, "ToolbarWidths", () => $7affccbd0c281873$export$423b5e8c92d477b9);
$parcel$export(module.exports, "ToolbarWidthsFullPage", () => $7affccbd0c281873$export$63ca43752be70b90);
var $7affccbd0c281873$export$ed55211407a9423;
(function(ToolbarSize) {
    ToolbarSize[ToolbarSize["XXL"] = 6] = "XXL";
    ToolbarSize[ToolbarSize["XL"] = 5] = "XL";
    ToolbarSize[ToolbarSize["L"] = 4] = "L";
    ToolbarSize[ToolbarSize["M"] = 3] = "M";
    ToolbarSize[ToolbarSize["S"] = 2] = "S";
    ToolbarSize[ToolbarSize["XXXS"] = 1] = "XXXS";
})($7affccbd0c281873$export$ed55211407a9423 || ($7affccbd0c281873$export$ed55211407a9423 = {}));
var $7affccbd0c281873$export$423b5e8c92d477b9;
(function(ToolbarWidths) {
    ToolbarWidths[ToolbarWidths["XXL"] = 610] = "XXL";
    ToolbarWidths[ToolbarWidths["XL"] = 540] = "XL";
    ToolbarWidths[ToolbarWidths["L"] = 460] = "L";
    ToolbarWidths[ToolbarWidths["M"] = 450] = "M";
    ToolbarWidths[ToolbarWidths["S"] = 410] = "S";
})($7affccbd0c281873$export$423b5e8c92d477b9 || ($7affccbd0c281873$export$423b5e8c92d477b9 = {}));
var $7affccbd0c281873$export$63ca43752be70b90;
(function(ToolbarWidthsFullPage) {
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["XXL"] = 650] = "XXL";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["XL"] = 580] = "XL";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["L"] = 540] = "L";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["M"] = 490] = "M";
    ToolbarWidthsFullPage[ToolbarWidthsFullPage["S"] = 410] = "S";
})($7affccbd0c281873$export$63ca43752be70b90 || ($7affccbd0c281873$export$63ca43752be70b90 = {}));

});



parcelRegister("2JJ1l", function(module, exports) {

$parcel$export(module.exports, "layoutToWidth", () => $9db2d789f4714b6a$export$9b77d38feba5446);
$parcel$export(module.exports, "getParentNodeWidth", () => $9db2d789f4714b6a$export$d76cc081ce1449a8);
$parcel$export(module.exports, "getTableContainerWidth", () => $9db2d789f4714b6a$export$3930799be057b305);

var $2zbl1 = parcelRequire("2zbl1");

var $25FYC = parcelRequire("25FYC");

var $lcnyw = parcelRequire("lcnyw");

var $jLo5a = parcelRequire("jLo5a");

var $jySns = parcelRequire("jySns");

var $b3jMP = parcelRequire("b3jMP");
const $9db2d789f4714b6a$export$9b77d38feba5446 = {
    default: (0, $25FYC.akEditorDefaultLayoutWidth),
    wide: (0, $25FYC.akEditorWideLayoutWidth),
    'full-width': (0, $25FYC.akEditorFullWidthLayoutWidth)
};
const $9db2d789f4714b6a$export$d76cc081ce1449a8 = (pos, state, containerWidth, isFullWidthModeEnabled)=>{
    if (!pos) return;
    const node = $9db2d789f4714b6a$var$getNestedParentNode(pos, state);
    if (!node) return;
    let layout = node.attrs.layout || 'default';
    const { schema: schema } = state;
    const breakoutMark = schema.marks.breakout && schema.marks.breakout.isInSet(node.marks);
    if (breakoutMark && breakoutMark.attrs.mode) layout = breakoutMark.attrs.mode;
    let parentWidth = $9db2d789f4714b6a$var$calcBreakoutNodeWidth(layout, containerWidth, isFullWidthModeEnabled);
    // TODO: ED-15663
    // Please, do not copy or use this kind of code below
    // @ts-ignore
    const contextPanelPluginKey = {
        key: 'contextPanelPluginKey$',
        getState: (state)=>{
            return state['contextPanelPluginKey$'];
        }
    };
    if (node.type === schema.nodes.layoutSection) {
        parentWidth += (0, $25FYC.akLayoutGutterOffset) * 2; // extra width that gets added to layout
        // Calculate width of parent layout column when
        // Parallel layout with viewport greater than 1024px
        // OR side panel of an extension is open and change the node width to smaller than containerWidth
        if (containerWidth.width > (0, $25FYC.gridMediumMaxWidth) || contextPanelPluginKey.getState(state)?.contents.length > 0 && contextPanelPluginKey.getState(state)?.contents[0] !== undefined) {
            parentWidth -= ((0, $jySns.LAYOUT_SECTION_MARGIN) + 2) * (node.childCount - 1); // margin between sections
            const $pos = state.doc.resolve(pos);
            const column = (0, $2zbl1.findParentNodeOfTypeClosestToPos)($pos, [
                state.schema.nodes.layoutColumn
            ]);
            if (column && column.node && !isNaN(column.node.attrs.width)) // get exact width of parent layout column using node attrs
            parentWidth = Math.round(parentWidth * column.node.attrs.width * 0.01);
        }
    }
    // account for the padding of the parent node
    switch(node.type){
        case schema.nodes.layoutSection:
            parentWidth -= (0, $jySns.LAYOUT_COLUMN_PADDING) * 2;
            break;
        case schema.nodes.bodiedExtension:
            parentWidth -= (0, $jLo5a.BODIED_EXT_PADDING) * 2;
            break;
        case schema.nodes.extensionFrame:
            parentWidth -= (0, $jLo5a.BODIED_EXT_PADDING) * 2;
            break;
        // TODO: Migrate away from gridSize
        // Recommendation: Replace gridSize with 8
        case schema.nodes.expand:
            // padding
            parentWidth -= (0, $lcnyw.gridSize)() * 2;
            // gutter offset
            parentWidth += (0, $lcnyw.gridSize)() * 3;
            // padding right
            parentWidth -= (0, $lcnyw.gridSize)();
            // padding left
            parentWidth -= (0, $lcnyw.gridSize)() * 4 - (0, $lcnyw.gridSize)() / 2;
            break;
    }
    parentWidth -= 2; // border
    return parentWidth;
};
const $9db2d789f4714b6a$var$getNestedParentNode = (tablePos, state)=>{
    if (tablePos === undefined) return null;
    const $pos = state.doc.resolve(tablePos);
    const parent = (0, $2zbl1.findParentNodeOfTypeClosestToPos)($pos, [
        state.schema.nodes.bodiedExtension,
        state.schema.nodes.extensionFrame,
        state.schema.nodes.layoutSection,
        state.schema.nodes.expand
    ]);
    return parent ? parent.node : null;
};
const $9db2d789f4714b6a$var$calcBreakoutNodeWidth = (layout, containerWidth, isFullWidthModeEnabled)=>{
    return isFullWidthModeEnabled ? Math.min(containerWidth.lineLength, (0, $25FYC.akEditorFullWidthLayoutWidth)) : (0, $b3jMP.absoluteBreakoutWidth)(layout, containerWidth.width);
};
const $9db2d789f4714b6a$export$3930799be057b305 = (node)=>{
    if (node?.attrs.width) return node.attrs.width;
    return $9db2d789f4714b6a$export$9b77d38feba5446[node?.attrs.layout] || (0, $25FYC.akEditorDefaultLayoutWidth);
};
const $9db2d789f4714b6a$export$9724081a0d43786a = (node, offset)=>{
    const isNumberColumnEnabled = node.attrs.isNumberColumnEnabled;
    if (isNumberColumnEnabled && offset > 0) return $9db2d789f4714b6a$export$3930799be057b305(node) - offset;
    return $9db2d789f4714b6a$export$3930799be057b305(node);
};

});
parcelRegister("2zbl1", function(module, exports) {

$parcel$export(module.exports, "removeParentNodeOfType", () => $1de7a52bc852b126$export$5dd18664fe8bcbde);
$parcel$export(module.exports, "findParentNodeOfType", () => $1de7a52bc852b126$export$1a3a74094b9968e);
$parcel$export(module.exports, "replaceParentNodeOfType", () => $1de7a52bc852b126$export$b72cc612b642c071);
$parcel$export(module.exports, "removeSelectedNode", () => $1de7a52bc852b126$export$7d6e4e6663186878);
$parcel$export(module.exports, "isNodeSelection", () => $1de7a52bc852b126$export$a8c1d2c13abf8822);
$parcel$export(module.exports, "replaceSelectedNode", () => $1de7a52bc852b126$export$39874bca494f9ba3);
$parcel$export(module.exports, "setTextSelection", () => $1de7a52bc852b126$export$1df6d14df6b0b758);
$parcel$export(module.exports, "safeInsert", () => $1de7a52bc852b126$export$5fe92db78385e37c);
$parcel$export(module.exports, "canInsert", () => $1de7a52bc852b126$export$b4d1262a40ad21d4);
$parcel$export(module.exports, "removeNodeBefore", () => $1de7a52bc852b126$export$ffb1550ab6c3d03c);
$parcel$export(module.exports, "findPositionOfNodeBefore", () => $1de7a52bc852b126$export$f8088819b1e2c2dc);
$parcel$export(module.exports, "findParentNode", () => $1de7a52bc852b126$export$dc159056ffdb4c76);
$parcel$export(module.exports, "findParentNodeClosestToPos", () => $1de7a52bc852b126$export$fe09644e3bc6166b);
$parcel$export(module.exports, "findDomRefAtPos", () => $1de7a52bc852b126$export$666ce65defe9ad6e);
$parcel$export(module.exports, "hasParentNode", () => $1de7a52bc852b126$export$178ecaf80f45fdb6);
$parcel$export(module.exports, "findParentNodeOfTypeClosestToPos", () => $1de7a52bc852b126$export$8bf0d019bde85d18);
$parcel$export(module.exports, "hasParentNodeOfType", () => $1de7a52bc852b126$export$14f438bb7227ce63);
$parcel$export(module.exports, "findParentDomRefOfType", () => $1de7a52bc852b126$export$faeafc1151740116);
$parcel$export(module.exports, "findSelectedNodeOfType", () => $1de7a52bc852b126$export$924aa2dd4d9a67fa);
$parcel$export(module.exports, "flatten", () => $1de7a52bc852b126$export$bffa455ba8c619a6);
$parcel$export(module.exports, "findChildren", () => $1de7a52bc852b126$export$f94ca194e830789c);
$parcel$export(module.exports, "findChildrenByType", () => $1de7a52bc852b126$export$96bb9476c7c69f39);
$parcel$export(module.exports, "contains", () => $1de7a52bc852b126$export$2344b14b097df817);
// src/selection.ts

var $kpTIW = parcelRequire("kpTIW");

var $7dkLM = parcelRequire("7dkLM");
var $1de7a52bc852b126$export$5dd18664fe8bcbde = (nodeType)=>(tr)=>{
        const parent = $1de7a52bc852b126$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $1de7a52bc852b126$var$removeNodeAtPos(parent.pos)(tr);
        return tr;
    };
var $1de7a52bc852b126$export$b72cc612b642c071 = (nodeType, content)=>(tr)=>{
        if (!Array.isArray(nodeType)) nodeType = [
            nodeType
        ];
        for(let i = 0, count = nodeType.length; i < count; i++){
            const parent = $1de7a52bc852b126$export$1a3a74094b9968e(nodeType[i])(tr.selection);
            if (parent) {
                const newTr = $1de7a52bc852b126$var$replaceNodeAtPos(parent.pos, content)(tr);
                if (newTr !== tr) return newTr;
            }
        }
        return tr;
    };
var $1de7a52bc852b126$export$7d6e4e6663186878 = (tr)=>{
    if ($1de7a52bc852b126$export$a8c1d2c13abf8822(tr.selection)) {
        const from = tr.selection.$from.pos;
        const to = tr.selection.$to.pos;
        return $1de7a52bc852b126$var$cloneTr(tr.delete(from, to));
    }
    return tr;
};
var $1de7a52bc852b126$export$39874bca494f9ba3 = (content)=>(tr)=>{
        if ($1de7a52bc852b126$export$a8c1d2c13abf8822(tr.selection)) {
            const { $from: $from, $to: $to } = tr.selection;
            if (content instanceof (0, $7dkLM.Fragment) && $from.parent.canReplace($from.index(), $from.indexAfter(), content) || content instanceof (0, $7dkLM.Node) && $from.parent.canReplaceWith($from.index(), $from.indexAfter(), content.type)) return $1de7a52bc852b126$var$cloneTr(tr.replaceWith($from.pos, $to.pos, content).setSelection(new (0, $kpTIW.NodeSelection)(tr.doc.resolve($from.pos))));
        }
        return tr;
    };
var $1de7a52bc852b126$export$1df6d14df6b0b758 = (position, dir = 1)=>(tr)=>{
        const nextSelection = (0, $kpTIW.Selection).findFrom(tr.doc.resolve(position), dir, true);
        if (nextSelection) return tr.setSelection(nextSelection);
        return tr;
    };
var $1de7a52bc852b126$var$isSelectableNode = (node)=>Boolean(node instanceof (0, $7dkLM.Node) && node.type && node.type.spec.selectable);
var $1de7a52bc852b126$var$shouldSelectNode = (node)=>$1de7a52bc852b126$var$isSelectableNode(node) && node.type.isLeaf;
var $1de7a52bc852b126$var$setSelection = (node, pos, tr)=>{
    if ($1de7a52bc852b126$var$shouldSelectNode(node)) return tr.setSelection(new (0, $kpTIW.NodeSelection)(tr.doc.resolve(pos)));
    return $1de7a52bc852b126$export$1df6d14df6b0b758(pos)(tr);
};
var $1de7a52bc852b126$export$5fe92db78385e37c = (content, position, tryToReplace)=>(tr)=>{
        const hasPosition = typeof position === "number";
        const { $from: $from } = tr.selection;
        const $insertPos = hasPosition ? tr.doc.resolve(position) : $1de7a52bc852b126$export$a8c1d2c13abf8822(tr.selection) ? tr.doc.resolve($from.pos + 1) : $from;
        const { parent: parent } = $insertPos;
        if ($1de7a52bc852b126$export$a8c1d2c13abf8822(tr.selection) && tryToReplace) {
            const oldTr = tr;
            tr = $1de7a52bc852b126$export$39874bca494f9ba3(content)(tr);
            if (oldTr !== tr) return tr;
        }
        if ($1de7a52bc852b126$var$isEmptyParagraph(parent)) {
            const oldTr = tr;
            tr = $1de7a52bc852b126$export$b72cc612b642c071(parent.type, content)(tr);
            if (oldTr !== tr) {
                const pos = $1de7a52bc852b126$var$isSelectableNode(content) ? // for selectable node, selection position would be the position of the replaced parent
                $insertPos.before($insertPos.depth) : $insertPos.pos;
                return $1de7a52bc852b126$var$setSelection(content, pos, tr);
            }
        }
        if ($1de7a52bc852b126$export$b4d1262a40ad21d4($insertPos, content)) {
            tr.insert($insertPos.pos, content);
            const pos = hasPosition ? $insertPos.pos : $1de7a52bc852b126$var$isSelectableNode(content) ? // for atom nodes selection position after insertion is the previous pos
            tr.selection.$anchor.pos - 1 : tr.selection.$anchor.pos;
            return $1de7a52bc852b126$var$cloneTr($1de7a52bc852b126$var$setSelection(content, pos, tr));
        }
        for(let i = $insertPos.depth; i > 0; i--){
            const pos = $insertPos.after(i);
            const $pos = tr.doc.resolve(pos);
            if ($1de7a52bc852b126$export$b4d1262a40ad21d4($pos, content)) {
                tr.insert(pos, content);
                return $1de7a52bc852b126$var$cloneTr($1de7a52bc852b126$var$setSelection(content, pos, tr));
            }
        }
        return tr;
    };
var $1de7a52bc852b126$export$36491a9ea218d882 = (nodeType, type, attrs, marks)=>(tr)=>{
        const parent = $1de7a52bc852b126$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $1de7a52bc852b126$var$cloneTr(tr.setNodeMarkup(parent.pos, type, Object.assign({}, parent.node.attrs, attrs), marks));
        return tr;
    };
var $1de7a52bc852b126$export$7f11cc48adfe3aed = (nodeType)=>(tr)=>{
        if (!$1de7a52bc852b126$export$a8c1d2c13abf8822(tr.selection)) {
            const parent = $1de7a52bc852b126$export$1a3a74094b9968e(nodeType)(tr.selection);
            if (parent) return $1de7a52bc852b126$var$cloneTr(tr.setSelection((0, $kpTIW.NodeSelection).create(tr.doc, parent.pos)));
        }
        return tr;
    };
var $1de7a52bc852b126$export$ffb1550ab6c3d03c = (tr)=>{
    const position = $1de7a52bc852b126$export$f8088819b1e2c2dc(tr.selection);
    if (typeof position === "number") return $1de7a52bc852b126$var$removeNodeAtPos(position)(tr);
    return tr;
};
// src/helpers.ts
var $1de7a52bc852b126$export$a8c1d2c13abf8822 = (selection)=>{
    return selection instanceof (0, $kpTIW.NodeSelection);
};
var $1de7a52bc852b126$var$equalNodeType = (nodeType, node)=>{
    return Array.isArray(nodeType) && nodeType.indexOf(node.type) > -1 || node.type === nodeType;
};
var $1de7a52bc852b126$var$cloneTr = (tr)=>{
    return Object.assign(Object.create(tr), tr).setTime(Date.now());
};
var $1de7a52bc852b126$var$replaceNodeAtPos = (position, content)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        const $pos = tr.doc.resolve(position);
        if (!node) return tr;
        if ($1de7a52bc852b126$var$canReplace($pos, content)) {
            tr = tr.replaceWith(position, position + node.nodeSize, content);
            const start = tr.selection.$from.pos - 1;
            tr = $1de7a52bc852b126$export$1df6d14df6b0b758(Math.max(start, 0), -1)(tr);
            tr = $1de7a52bc852b126$export$1df6d14df6b0b758(tr.selection.$from.start())(tr);
            return $1de7a52bc852b126$var$cloneTr(tr);
        }
        return tr;
    };
var $1de7a52bc852b126$var$canReplace = ($pos, content)=>{
    const node = $pos.node($pos.depth);
    return node && node.type.validContent(content instanceof (0, $7dkLM.Fragment) ? content : (0, $7dkLM.Fragment).from(content));
};
var $1de7a52bc852b126$var$removeNodeAtPos = (position)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        if (!node) return tr;
        return $1de7a52bc852b126$var$cloneTr(tr.delete(position, position + node.nodeSize));
    };
var $1de7a52bc852b126$export$b4d1262a40ad21d4 = ($pos, content)=>{
    const index = $pos.index();
    if (content instanceof (0, $7dkLM.Fragment)) return $pos.parent.canReplace(index, index, content);
    else if (content instanceof (0, $7dkLM.Node)) return $pos.parent.canReplaceWith(index, index, content.type);
    return false;
};
var $1de7a52bc852b126$var$isEmptyParagraph = (node)=>{
    return !node || node.type.name === "paragraph" && node.nodeSize === 2;
};
// src/selection.ts
var $1de7a52bc852b126$export$dc159056ffdb4c76 = (predicate)=>({ $from: $from, $to: $to }, validateSameParent = false)=>{
        if (validateSameParent && !$from.sameParent($to)) {
            let depth = Math.min($from.depth, $to.depth);
            while(depth >= 0){
                const fromNode = $from.node(depth);
                const toNode = $to.node(depth);
                if (toNode === fromNode) {
                    if (predicate(fromNode)) return {
                        // Return the resolved pos
                        pos: depth > 0 ? $from.before(depth) : 0,
                        start: $from.start(depth),
                        depth: depth,
                        node: fromNode
                    };
                }
                depth = depth - 1;
            }
            return;
        }
        return $1de7a52bc852b126$export$fe09644e3bc6166b($from, predicate);
    };
var $1de7a52bc852b126$export$fe09644e3bc6166b = ($pos, predicate)=>{
    for(let i = $pos.depth; i > 0; i--){
        const node = $pos.node(i);
        if (predicate(node)) return {
            pos: i > 0 ? $pos.before(i) : 0,
            start: $pos.start(i),
            depth: i,
            node: node
        };
    }
};
var $1de7a52bc852b126$export$8556d79fa8189214 = (predicate, domAtPos)=>(selection)=>{
        const parent = $1de7a52bc852b126$export$dc159056ffdb4c76(predicate)(selection);
        if (parent) return $1de7a52bc852b126$export$666ce65defe9ad6e(parent.pos, domAtPos);
    };
var $1de7a52bc852b126$export$178ecaf80f45fdb6 = (predicate)=>(selection)=>{
        return !!$1de7a52bc852b126$export$dc159056ffdb4c76(predicate)(selection);
    };
var $1de7a52bc852b126$export$1a3a74094b9968e = (nodeType)=>(selection)=>{
        return $1de7a52bc852b126$export$dc159056ffdb4c76((node)=>$1de7a52bc852b126$var$equalNodeType(nodeType, node))(selection);
    };
var $1de7a52bc852b126$export$8bf0d019bde85d18 = ($pos, nodeType)=>{
    return $1de7a52bc852b126$export$fe09644e3bc6166b($pos, (node)=>$1de7a52bc852b126$var$equalNodeType(nodeType, node));
};
var $1de7a52bc852b126$export$14f438bb7227ce63 = (nodeType)=>(selection)=>{
        return $1de7a52bc852b126$export$178ecaf80f45fdb6((node)=>$1de7a52bc852b126$var$equalNodeType(nodeType, node))(selection);
    };
var $1de7a52bc852b126$export$faeafc1151740116 = (nodeType, domAtPos)=>(selection)=>{
        return $1de7a52bc852b126$export$8556d79fa8189214((node)=>$1de7a52bc852b126$var$equalNodeType(nodeType, node), domAtPos)(selection);
    };
var $1de7a52bc852b126$export$924aa2dd4d9a67fa = (nodeType)=>(selection)=>{
        if ($1de7a52bc852b126$export$a8c1d2c13abf8822(selection)) {
            const { node: node, $from: $from } = selection;
            if ($1de7a52bc852b126$var$equalNodeType(nodeType, node)) return {
                node: node,
                start: $from.start(),
                pos: $from.pos,
                depth: $from.depth
            };
        }
    };
var $1de7a52bc852b126$export$f8088819b1e2c2dc = (selection)=>{
    const { nodeBefore: nodeBefore } = selection.$from;
    const maybeSelection = (0, $kpTIW.Selection).findFrom(selection.$from, -1);
    if (maybeSelection && nodeBefore) {
        const parent = $1de7a52bc852b126$export$1a3a74094b9968e(nodeBefore.type)(maybeSelection);
        if (parent) return parent.pos;
        return maybeSelection.$from.pos;
    }
};
var $1de7a52bc852b126$export$666ce65defe9ad6e = (position, domAtPos)=>{
    const dom = domAtPos(position);
    const node = dom.node.childNodes[dom.offset];
    if (dom.node.nodeType === Node.TEXT_NODE && dom.node.parentNode) return dom.node.parentNode;
    if (!node || node.nodeType === Node.TEXT_NODE) return dom.node;
    return node;
};
// src/node.ts
var $1de7a52bc852b126$export$bffa455ba8c619a6 = (node, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    const result = [];
    node.descendants((child, pos)=>{
        result.push({
            node: child,
            pos: pos
        });
        if (!descend) return false;
    });
    return result;
};
var $1de7a52bc852b126$export$f94ca194e830789c = (node, predicate, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    else if (!predicate) throw new Error('Invalid "predicate" parameter');
    return $1de7a52bc852b126$export$bffa455ba8c619a6(node, descend).filter((child)=>predicate(child.node));
};
var $1de7a52bc852b126$export$53418710fbc2d8cc = (node, descend = true)=>{
    return $1de7a52bc852b126$export$f94ca194e830789c(node, (child)=>child.isText, descend);
};
var $1de7a52bc852b126$export$ddc1620722e25671 = (node, descend = true)=>{
    return $1de7a52bc852b126$export$f94ca194e830789c(node, (child)=>child.isInline, descend);
};
var $1de7a52bc852b126$export$cae8d7f259e5bbe9 = (node, descend = true)=>{
    return $1de7a52bc852b126$export$f94ca194e830789c(node, (child)=>child.isBlock, descend);
};
var $1de7a52bc852b126$export$a836476a7f9de5b4 = (node, predicate, descend = true)=>{
    return $1de7a52bc852b126$export$f94ca194e830789c(node, (child)=>!!predicate(child.attrs), descend);
};
var $1de7a52bc852b126$export$96bb9476c7c69f39 = (node, nodeType, descend = true)=>{
    return $1de7a52bc852b126$export$f94ca194e830789c(node, (child)=>child.type === nodeType, descend);
};
var $1de7a52bc852b126$export$c01a9e7ec615e821 = (node, markType, descend = true)=>{
    return $1de7a52bc852b126$export$f94ca194e830789c(node, (child)=>Boolean(markType.isInSet(child.marks)), descend);
};
var $1de7a52bc852b126$export$2344b14b097df817 = (node, nodeType)=>{
    return !!$1de7a52bc852b126$export$96bb9476c7c69f39(node, nodeType).length;
};

});
parcelRegister("kpTIW", function(module, exports) {

$parcel$export(module.exports, "Selection", () => $edd15e116d766874$export$52baac22726c72bf);
$parcel$export(module.exports, "SelectionRange", () => $edd15e116d766874$export$7bd1839c3c5d5bd4);
$parcel$export(module.exports, "TextSelection", () => $edd15e116d766874$export$c2b25f346d19bcbb);
$parcel$export(module.exports, "AllSelection", () => $edd15e116d766874$export$c15d9ba76bdbcd95);
$parcel$export(module.exports, "NodeSelection", () => $edd15e116d766874$export$e2940151ac854c0b);
$parcel$export(module.exports, "Transaction", () => $edd15e116d766874$export$febc5573c75cefb0);
$parcel$export(module.exports, "EditorState", () => $edd15e116d766874$export$afa855cbfaff27f2);
$parcel$export(module.exports, "Plugin", () => $edd15e116d766874$export$901cf72dabf2112a);
$parcel$export(module.exports, "PluginKey", () => $edd15e116d766874$export$1692d8b0e89cecc3);

var $7dkLM = parcelRequire("7dkLM");

var $d6JJW = parcelRequire("d6JJW");
const $edd15e116d766874$var$classesById = Object.create(null);
/**
Superclass for editor selections. Every selection type should
extend this. Should not be instantiated directly.
*/ class $edd15e116d766874$export$52baac22726c72bf {
    /**
    Initialize a selection with the head and anchor and ranges. If no
    ranges are given, constructs a single range across `$anchor` and
    `$head`.
    */ constructor(/**
    The resolved anchor of the selection (the side that stays in
    place when the selection is modified).
    */ $anchor, /**
    The resolved head of the selection (the side that moves when
    the selection is modified).
    */ $head, ranges){
        this.$anchor = $anchor;
        this.$head = $head;
        this.ranges = ranges || [
            new $edd15e116d766874$export$7bd1839c3c5d5bd4($anchor.min($head), $anchor.max($head))
        ];
    }
    /**
    The selection's anchor, as an unresolved position.
    */ get anchor() {
        return this.$anchor.pos;
    }
    /**
    The selection's head.
    */ get head() {
        return this.$head.pos;
    }
    /**
    The lower bound of the selection's main range.
    */ get from() {
        return this.$from.pos;
    }
    /**
    The upper bound of the selection's main range.
    */ get to() {
        return this.$to.pos;
    }
    /**
    The resolved lower  bound of the selection's main range.
    */ get $from() {
        return this.ranges[0].$from;
    }
    /**
    The resolved upper bound of the selection's main range.
    */ get $to() {
        return this.ranges[0].$to;
    }
    /**
    Indicates whether the selection contains any content.
    */ get empty() {
        let ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++)if (ranges[i].$from.pos != ranges[i].$to.pos) return false;
        return true;
    }
    /**
    Get the content of this selection as a slice.
    */ content() {
        return this.$from.doc.slice(this.from, this.to, true);
    }
    /**
    Replace the selection with a slice or, if no slice is given,
    delete the selection. Will append to the given transaction.
    */ replace(tr, content = (0, $7dkLM.Slice).empty) {
        // Put the new selection at the position after the inserted
        // content. When that ended in an inline node, search backwards,
        // to get the position after that node. If not, search forward.
        let lastNode = content.content.lastChild, lastParent = null;
        for(let i = 0; i < content.openEnd; i++){
            lastParent = lastNode;
            lastNode = lastNode.lastChild;
        }
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $7dkLM.Slice).empty : content);
            if (i == 0) $edd15e116d766874$var$selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1);
        }
    }
    /**
    Replace the selection with the given node, appending the changes
    to the given transaction.
    */ replaceWith(tr, node) {
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            let from = mapping.map($from.pos), to = mapping.map($to.pos);
            if (i) tr.deleteRange(from, to);
            else {
                tr.replaceRangeWith(from, to, node);
                $edd15e116d766874$var$selectionToInsertionEnd(tr, mapFrom, node.isInline ? -1 : 1);
            }
        }
    }
    /**
    Find a valid cursor or leaf node selection starting at the given
    position and searching back if `dir` is negative, and forward if
    positive. When `textOnly` is true, only consider cursor
    selections. Will return null when no valid selection position is
    found.
    */ static findFrom($pos, dir, textOnly = false) {
        let inner = $pos.parent.inlineContent ? new $edd15e116d766874$export$c2b25f346d19bcbb($pos) : $edd15e116d766874$var$findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
        if (inner) return inner;
        for(let depth = $pos.depth - 1; depth >= 0; depth--){
            let found = dir < 0 ? $edd15e116d766874$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly) : $edd15e116d766874$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
            if (found) return found;
        }
        return null;
    }
    /**
    Find a valid cursor or leaf node selection near the given
    position. Searches forward first by default, but if `bias` is
    negative, it will search backwards first.
    */ static near($pos, bias = 1) {
        return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new $edd15e116d766874$export$c15d9ba76bdbcd95($pos.node(0));
    }
    /**
    Find the cursor or leaf node selection closest to the start of
    the given document. Will return an
    [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
    exists.
    */ static atStart(doc) {
        return $edd15e116d766874$var$findSelectionIn(doc, doc, 0, 0, 1) || new $edd15e116d766874$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Find the cursor or leaf node selection closest to the end of the
    given document.
    */ static atEnd(doc) {
        return $edd15e116d766874$var$findSelectionIn(doc, doc, doc.content.size, doc.childCount, -1) || new $edd15e116d766874$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Deserialize the JSON representation of a selection. Must be
    implemented for custom classes (as a static class method).
    */ static fromJSON(doc, json) {
        if (!json || !json.type) throw new RangeError("Invalid input for Selection.fromJSON");
        let cls = $edd15e116d766874$var$classesById[json.type];
        if (!cls) throw new RangeError(`No selection type ${json.type} defined`);
        return cls.fromJSON(doc, json);
    }
    /**
    To be able to deserialize selections from JSON, custom selection
    classes must register themselves with an ID string, so that they
    can be disambiguated. Try to pick something that's unlikely to
    clash with classes from other modules.
    */ static jsonID(id, selectionClass) {
        if (id in $edd15e116d766874$var$classesById) throw new RangeError("Duplicate use of selection JSON ID " + id);
        $edd15e116d766874$var$classesById[id] = selectionClass;
        selectionClass.prototype.jsonID = id;
        return selectionClass;
    }
    /**
    Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
    which is a value that can be mapped without having access to a
    current document, and later resolved to a real selection for a
    given document again. (This is used mostly by the history to
    track and restore old selections.) The default implementation of
    this method just converts the selection to a text selection and
    returns the bookmark for that.
    */ getBookmark() {
        return $edd15e116d766874$export$c2b25f346d19bcbb.between(this.$anchor, this.$head).getBookmark();
    }
}
$edd15e116d766874$export$52baac22726c72bf.prototype.visible = true;
/**
Represents a selected range in a document.
*/ class $edd15e116d766874$export$7bd1839c3c5d5bd4 {
    /**
    Create a range.
    */ constructor(/**
    The lower bound of the range.
    */ $from, /**
    The upper bound of the range.
    */ $to){
        this.$from = $from;
        this.$to = $to;
    }
}
let $edd15e116d766874$var$warnedAboutTextSelection = false;
function $edd15e116d766874$var$checkTextSelection($pos) {
    if (!$edd15e116d766874$var$warnedAboutTextSelection && !$pos.parent.inlineContent) {
        $edd15e116d766874$var$warnedAboutTextSelection = true;
        console["warn"]("TextSelection endpoint not pointing into a node with inline content (" + $pos.parent.type.name + ")");
    }
}
/**
A text selection represents a classical editor selection, with a
head (the moving side) and anchor (immobile side), both of which
point into textblock nodes. It can be empty (a regular cursor
position).
*/ class $edd15e116d766874$export$c2b25f346d19bcbb extends $edd15e116d766874$export$52baac22726c72bf {
    /**
    Construct a text selection between the given points.
    */ constructor($anchor, $head = $anchor){
        $edd15e116d766874$var$checkTextSelection($anchor);
        $edd15e116d766874$var$checkTextSelection($head);
        super($anchor, $head);
    }
    /**
    Returns a resolved position if this is a cursor selection (an
    empty text selection), and null otherwise.
    */ get $cursor() {
        return this.$anchor.pos == this.$head.pos ? this.$head : null;
    }
    map(doc, mapping) {
        let $head = doc.resolve(mapping.map(this.head));
        if (!$head.parent.inlineContent) return $edd15e116d766874$export$52baac22726c72bf.near($head);
        let $anchor = doc.resolve(mapping.map(this.anchor));
        return new $edd15e116d766874$export$c2b25f346d19bcbb($anchor.parent.inlineContent ? $anchor : $head, $head);
    }
    replace(tr, content = (0, $7dkLM.Slice).empty) {
        super.replace(tr, content);
        if (content == (0, $7dkLM.Slice).empty) {
            let marks = this.$from.marksAcross(this.$to);
            if (marks) tr.ensureMarks(marks);
        }
    }
    eq(other) {
        return other instanceof $edd15e116d766874$export$c2b25f346d19bcbb && other.anchor == this.anchor && other.head == this.head;
    }
    getBookmark() {
        return new $edd15e116d766874$var$TextBookmark(this.anchor, this.head);
    }
    toJSON() {
        return {
            type: "text",
            anchor: this.anchor,
            head: this.head
        };
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid input for TextSelection.fromJSON");
        return new $edd15e116d766874$export$c2b25f346d19bcbb(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    /**
    Create a text selection from non-resolved positions.
    */ static create(doc, anchor, head = anchor) {
        let $anchor = doc.resolve(anchor);
        return new this($anchor, head == anchor ? $anchor : doc.resolve(head));
    }
    /**
    Return a text selection that spans the given positions or, if
    they aren't text positions, find a text selection near them.
    `bias` determines whether the method searches forward (default)
    or backwards (negative number) first. Will fall back to calling
    [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
    doesn't contain a valid text position.
    */ static between($anchor, $head, bias) {
        let dPos = $anchor.pos - $head.pos;
        if (!bias || dPos) bias = dPos >= 0 ? 1 : -1;
        if (!$head.parent.inlineContent) {
            let found = $edd15e116d766874$export$52baac22726c72bf.findFrom($head, bias, true) || $edd15e116d766874$export$52baac22726c72bf.findFrom($head, -bias, true);
            if (found) $head = found.$head;
            else return $edd15e116d766874$export$52baac22726c72bf.near($head, bias);
        }
        if (!$anchor.parent.inlineContent) {
            if (dPos == 0) $anchor = $head;
            else {
                $anchor = ($edd15e116d766874$export$52baac22726c72bf.findFrom($anchor, -bias, true) || $edd15e116d766874$export$52baac22726c72bf.findFrom($anchor, bias, true)).$anchor;
                if ($anchor.pos < $head.pos != dPos < 0) $anchor = $head;
            }
        }
        return new $edd15e116d766874$export$c2b25f346d19bcbb($anchor, $head);
    }
}
$edd15e116d766874$export$52baac22726c72bf.jsonID("text", $edd15e116d766874$export$c2b25f346d19bcbb);
class $edd15e116d766874$var$TextBookmark {
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new $edd15e116d766874$var$TextBookmark(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        return $edd15e116d766874$export$c2b25f346d19bcbb.between(doc.resolve(this.anchor), doc.resolve(this.head));
    }
}
/**
A node selection is a selection that points at a single node. All
nodes marked [selectable](https://prosemirror.net/docs/ref/#model.NodeSpec.selectable) can be the
target of a node selection. In such a selection, `from` and `to`
point directly before and after the selected node, `anchor` equals
`from`, and `head` equals `to`..
*/ class $edd15e116d766874$export$e2940151ac854c0b extends $edd15e116d766874$export$52baac22726c72bf {
    /**
    Create a node selection. Does not verify the validity of its
    argument.
    */ constructor($pos){
        let node = $pos.nodeAfter;
        let $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
        super($pos, $end);
        this.node = node;
    }
    map(doc, mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        let $pos = doc.resolve(pos);
        if (deleted) return $edd15e116d766874$export$52baac22726c72bf.near($pos);
        return new $edd15e116d766874$export$e2940151ac854c0b($pos);
    }
    content() {
        return new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(this.node), 0, 0);
    }
    eq(other) {
        return other instanceof $edd15e116d766874$export$e2940151ac854c0b && other.anchor == this.anchor;
    }
    toJSON() {
        return {
            type: "node",
            anchor: this.anchor
        };
    }
    getBookmark() {
        return new $edd15e116d766874$var$NodeBookmark(this.anchor);
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number") throw new RangeError("Invalid input for NodeSelection.fromJSON");
        return new $edd15e116d766874$export$e2940151ac854c0b(doc.resolve(json.anchor));
    }
    /**
    Create a node selection from non-resolved positions.
    */ static create(doc, from) {
        return new $edd15e116d766874$export$e2940151ac854c0b(doc.resolve(from));
    }
    /**
    Determines whether the given node may be selected as a node
    selection.
    */ static isSelectable(node) {
        return !node.isText && node.type.spec.selectable !== false;
    }
}
$edd15e116d766874$export$e2940151ac854c0b.prototype.visible = false;
$edd15e116d766874$export$52baac22726c72bf.jsonID("node", $edd15e116d766874$export$e2940151ac854c0b);
class $edd15e116d766874$var$NodeBookmark {
    constructor(anchor){
        this.anchor = anchor;
    }
    map(mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        return deleted ? new $edd15e116d766874$var$TextBookmark(pos, pos) : new $edd15e116d766874$var$NodeBookmark(pos);
    }
    resolve(doc) {
        let $pos = doc.resolve(this.anchor), node = $pos.nodeAfter;
        if (node && $edd15e116d766874$export$e2940151ac854c0b.isSelectable(node)) return new $edd15e116d766874$export$e2940151ac854c0b($pos);
        return $edd15e116d766874$export$52baac22726c72bf.near($pos);
    }
}
/**
A selection type that represents selecting the whole document
(which can not necessarily be expressed with a text selection, when
there are for example leaf block nodes at the start or end of the
document).
*/ class $edd15e116d766874$export$c15d9ba76bdbcd95 extends $edd15e116d766874$export$52baac22726c72bf {
    /**
    Create an all-selection over the given document.
    */ constructor(doc){
        super(doc.resolve(0), doc.resolve(doc.content.size));
    }
    replace(tr, content = (0, $7dkLM.Slice).empty) {
        if (content == (0, $7dkLM.Slice).empty) {
            tr.delete(0, tr.doc.content.size);
            let sel = $edd15e116d766874$export$52baac22726c72bf.atStart(tr.doc);
            if (!sel.eq(tr.selection)) tr.setSelection(sel);
        } else super.replace(tr, content);
    }
    toJSON() {
        return {
            type: "all"
        };
    }
    /**
    @internal
    */ static fromJSON(doc) {
        return new $edd15e116d766874$export$c15d9ba76bdbcd95(doc);
    }
    map(doc) {
        return new $edd15e116d766874$export$c15d9ba76bdbcd95(doc);
    }
    eq(other) {
        return other instanceof $edd15e116d766874$export$c15d9ba76bdbcd95;
    }
    getBookmark() {
        return $edd15e116d766874$var$AllBookmark;
    }
}
$edd15e116d766874$export$52baac22726c72bf.jsonID("all", $edd15e116d766874$export$c15d9ba76bdbcd95);
const $edd15e116d766874$var$AllBookmark = {
    map () {
        return this;
    },
    resolve (doc) {
        return new $edd15e116d766874$export$c15d9ba76bdbcd95(doc);
    }
};
// FIXME we'll need some awareness of text direction when scanning for selections
// Try to find a selection inside the given node. `pos` points at the
// position where the search starts. When `text` is true, only return
// text selections.
function $edd15e116d766874$var$findSelectionIn(doc, node, pos, index, dir, text = false) {
    if (node.inlineContent) return $edd15e116d766874$export$c2b25f346d19bcbb.create(doc, pos);
    for(let i = index - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir){
        let child = node.child(i);
        if (!child.isAtom) {
            let inner = $edd15e116d766874$var$findSelectionIn(doc, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
            if (inner) return inner;
        } else if (!text && $edd15e116d766874$export$e2940151ac854c0b.isSelectable(child)) return $edd15e116d766874$export$e2940151ac854c0b.create(doc, pos - (dir < 0 ? child.nodeSize : 0));
        pos += child.nodeSize * dir;
    }
    return null;
}
function $edd15e116d766874$var$selectionToInsertionEnd(tr, startLen, bias) {
    let last = tr.steps.length - 1;
    if (last < startLen) return;
    let step = tr.steps[last];
    if (!(step instanceof (0, $d6JJW.ReplaceStep) || step instanceof (0, $d6JJW.ReplaceAroundStep))) return;
    let map = tr.mapping.maps[last], end;
    map.forEach((_from, _to, _newFrom, newTo)=>{
        if (end == null) end = newTo;
    });
    tr.setSelection($edd15e116d766874$export$52baac22726c72bf.near(tr.doc.resolve(end), bias));
}
const $edd15e116d766874$var$UPDATED_SEL = 1, $edd15e116d766874$var$UPDATED_MARKS = 2, $edd15e116d766874$var$UPDATED_SCROLL = 4;
/**
An editor state transaction, which can be applied to a state to
create an updated state. Use
[`EditorState.tr`](https://prosemirror.net/docs/ref/#state.EditorState.tr) to create an instance.

Transactions track changes to the document (they are a subclass of
[`Transform`](https://prosemirror.net/docs/ref/#transform.Transform)), but also other state changes,
like selection updates and adjustments of the set of [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks). In addition, you can store
metadata properties in a transaction, which are extra pieces of
information that client code or plugins can use to describe what a
transaction represents, so that they can update their [own
state](https://prosemirror.net/docs/ref/#state.StateField) accordingly.

The [editor view](https://prosemirror.net/docs/ref/#view.EditorView) uses a few metadata
properties: it will attach a property `"pointer"` with the value
`true` to selection transactions directly caused by mouse or touch
input, a `"composition"` property holding an ID identifying the
composition that caused it to transactions caused by composed DOM
input, and a `"uiEvent"` property of that may be `"paste"`,
`"cut"`, or `"drop"`.
*/ class $edd15e116d766874$export$febc5573c75cefb0 extends (0, $d6JJW.Transform) {
    /**
    @internal
    */ constructor(state){
        super(state.doc);
        // The step count for which the current selection is valid.
        this.curSelectionFor = 0;
        // Bitfield to track which aspects of the state were updated by
        // this transaction.
        this.updated = 0;
        // Object used to store metadata properties for the transaction.
        this.meta = Object.create(null);
        this.time = Date.now();
        this.curSelection = state.selection;
        this.storedMarks = state.storedMarks;
    }
    /**
    The transaction's current selection. This defaults to the editor
    selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
    transaction, but can be overwritten with
    [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
    */ get selection() {
        if (this.curSelectionFor < this.steps.length) {
            this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
            this.curSelectionFor = this.steps.length;
        }
        return this.curSelection;
    }
    /**
    Update the transaction's current selection. Will determine the
    selection that the editor gets when the transaction is applied.
    */ setSelection(selection) {
        if (selection.$from.doc != this.doc) throw new RangeError("Selection passed to setSelection must point at the current document");
        this.curSelection = selection;
        this.curSelectionFor = this.steps.length;
        this.updated = (this.updated | $edd15e116d766874$var$UPDATED_SEL) & ~$edd15e116d766874$var$UPDATED_MARKS;
        this.storedMarks = null;
        return this;
    }
    /**
    Whether the selection was explicitly updated by this transaction.
    */ get selectionSet() {
        return (this.updated & $edd15e116d766874$var$UPDATED_SEL) > 0;
    }
    /**
    Set the current stored marks.
    */ setStoredMarks(marks) {
        this.storedMarks = marks;
        this.updated |= $edd15e116d766874$var$UPDATED_MARKS;
        return this;
    }
    /**
    Make sure the current stored marks or, if that is null, the marks
    at the selection, match the given set of marks. Does nothing if
    this is already the case.
    */ ensureMarks(marks) {
        if (!(0, $7dkLM.Mark).sameSet(this.storedMarks || this.selection.$from.marks(), marks)) this.setStoredMarks(marks);
        return this;
    }
    /**
    Add a mark to the set of stored marks.
    */ addStoredMark(mark) {
        return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Remove a mark or mark type from the set of stored marks.
    */ removeStoredMark(mark) {
        return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Whether the stored marks were explicitly set for this transaction.
    */ get storedMarksSet() {
        return (this.updated & $edd15e116d766874$var$UPDATED_MARKS) > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        super.addStep(step, doc);
        this.updated = this.updated & ~$edd15e116d766874$var$UPDATED_MARKS;
        this.storedMarks = null;
    }
    /**
    Update the timestamp for the transaction.
    */ setTime(time) {
        this.time = time;
        return this;
    }
    /**
    Replace the current selection with the given slice.
    */ replaceSelection(slice) {
        this.selection.replace(this, slice);
        return this;
    }
    /**
    Replace the selection with the given node. When `inheritMarks` is
    true and the content is inline, it inherits the marks from the
    place where it is inserted.
    */ replaceSelectionWith(node, inheritMarks = true) {
        let selection = this.selection;
        if (inheritMarks) node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : selection.$from.marksAcross(selection.$to) || (0, $7dkLM.Mark).none));
        selection.replaceWith(this, node);
        return this;
    }
    /**
    Delete the selection.
    */ deleteSelection() {
        this.selection.replace(this);
        return this;
    }
    /**
    Replace the given range, or the selection if no range is given,
    with a text node containing the given string.
    */ insertText(text, from, to) {
        let schema = this.doc.type.schema;
        if (from == null) {
            if (!text) return this.deleteSelection();
            return this.replaceSelectionWith(schema.text(text), true);
        } else {
            if (to == null) to = from;
            to = to == null ? from : to;
            if (!text) return this.deleteRange(from, to);
            let marks = this.storedMarks;
            if (!marks) {
                let $from = this.doc.resolve(from);
                marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
            }
            this.replaceRangeWith(from, to, schema.text(text, marks));
            if (!this.selection.empty) this.setSelection($edd15e116d766874$export$52baac22726c72bf.near(this.selection.$to));
            return this;
        }
    }
    /**
    Store a metadata property in this transaction, keyed either by
    name or by plugin.
    */ setMeta(key, value) {
        this.meta[typeof key == "string" ? key : key.key] = value;
        return this;
    }
    /**
    Retrieve a metadata property for a given name or plugin.
    */ getMeta(key) {
        return this.meta[typeof key == "string" ? key : key.key];
    }
    /**
    Returns true if this transaction doesn't contain any metadata,
    and can thus safely be extended.
    */ get isGeneric() {
        for(let _ in this.meta)return false;
        return true;
    }
    /**
    Indicate that the editor should scroll the selection into view
    when updated to the state produced by this transaction.
    */ scrollIntoView() {
        this.updated |= $edd15e116d766874$var$UPDATED_SCROLL;
        return this;
    }
    /**
    True when this transaction has had `scrollIntoView` called on it.
    */ get scrolledIntoView() {
        return (this.updated & $edd15e116d766874$var$UPDATED_SCROLL) > 0;
    }
}
function $edd15e116d766874$var$bind(f, self) {
    return !self || !f ? f : f.bind(self);
}
class $edd15e116d766874$var$FieldDesc {
    constructor(name, desc, self){
        this.name = name;
        this.init = $edd15e116d766874$var$bind(desc.init, self);
        this.apply = $edd15e116d766874$var$bind(desc.apply, self);
    }
}
const $edd15e116d766874$var$baseFields = [
    new $edd15e116d766874$var$FieldDesc("doc", {
        init (config) {
            return config.doc || config.schema.topNodeType.createAndFill();
        },
        apply (tr) {
            return tr.doc;
        }
    }),
    new $edd15e116d766874$var$FieldDesc("selection", {
        init (config, instance) {
            return config.selection || $edd15e116d766874$export$52baac22726c72bf.atStart(instance.doc);
        },
        apply (tr) {
            return tr.selection;
        }
    }),
    new $edd15e116d766874$var$FieldDesc("storedMarks", {
        init (config) {
            return config.storedMarks || null;
        },
        apply (tr, _marks, _old, state) {
            return state.selection.$cursor ? tr.storedMarks : null;
        }
    }),
    new $edd15e116d766874$var$FieldDesc("scrollToSelection", {
        init () {
            return 0;
        },
        apply (tr, prev) {
            return tr.scrolledIntoView ? prev + 1 : prev;
        }
    })
];
// Object wrapping the part of a state object that stays the same
// across transactions. Stored in the state's `config` property.
class $edd15e116d766874$var$Configuration {
    constructor(schema, plugins){
        this.schema = schema;
        this.plugins = [];
        this.pluginsByKey = Object.create(null);
        this.fields = $edd15e116d766874$var$baseFields.slice();
        if (plugins) plugins.forEach((plugin)=>{
            if (this.pluginsByKey[plugin.key]) throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")");
            this.plugins.push(plugin);
            this.pluginsByKey[plugin.key] = plugin;
            if (plugin.spec.state) this.fields.push(new $edd15e116d766874$var$FieldDesc(plugin.key, plugin.spec.state, plugin));
        });
    }
}
/**
The state of a ProseMirror editor is represented by an object of
this type. A state is a persistent data structure—it isn't
updated, but rather a new state value is computed from an old one
using the [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) method.

A state holds a number of built-in fields, and plugins can
[define](https://prosemirror.net/docs/ref/#state.PluginSpec.state) additional fields.
*/ class $edd15e116d766874$export$afa855cbfaff27f2 {
    /**
    @internal
    */ constructor(/**
    @internal
    */ config){
        this.config = config;
    }
    /**
    The schema of the state's document.
    */ get schema() {
        return this.config.schema;
    }
    /**
    The plugins that are active in this state.
    */ get plugins() {
        return this.config.plugins;
    }
    /**
    Apply the given transaction to produce a new state.
    */ apply(tr) {
        return this.applyTransaction(tr).state;
    }
    /**
    @internal
    */ filterTransaction(tr, ignore = -1) {
        for(let i = 0; i < this.config.plugins.length; i++)if (i != ignore) {
            let plugin = this.config.plugins[i];
            if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this)) return false;
        }
        return true;
    }
    /**
    Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
    returns the precise transactions that were applied (which might
    be influenced by the [transaction
    hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
    plugins) along with the new state.
    */ applyTransaction(rootTr) {
        if (!this.filterTransaction(rootTr)) return {
            state: this,
            transactions: []
        };
        let trs = [
            rootTr
        ], newState = this.applyInner(rootTr), seen = null;
        // This loop repeatedly gives plugins a chance to respond to
        // transactions as new transactions are added, making sure to only
        // pass the transactions the plugin did not see before.
        for(;;){
            let haveNew = false;
            for(let i = 0; i < this.config.plugins.length; i++){
                let plugin = this.config.plugins[i];
                if (plugin.spec.appendTransaction) {
                    let n = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this;
                    let tr = n < trs.length && plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
                    if (tr && newState.filterTransaction(tr, i)) {
                        tr.setMeta("appendedTransaction", rootTr);
                        if (!seen) {
                            seen = [];
                            for(let j = 0; j < this.config.plugins.length; j++)seen.push(j < i ? {
                                state: newState,
                                n: trs.length
                            } : {
                                state: this,
                                n: 0
                            });
                        }
                        trs.push(tr);
                        newState = newState.applyInner(tr);
                        haveNew = true;
                    }
                    if (seen) seen[i] = {
                        state: newState,
                        n: trs.length
                    };
                }
            }
            if (!haveNew) return {
                state: newState,
                transactions: trs
            };
        }
    }
    /**
    @internal
    */ applyInner(tr) {
        if (!tr.before.eq(this.doc)) throw new RangeError("Applying a mismatched transaction");
        let newInstance = new $edd15e116d766874$export$afa855cbfaff27f2(this.config), fields = this.config.fields;
        for(let i = 0; i < fields.length; i++){
            let field = fields[i];
            newInstance[field.name] = field.apply(tr, this[field.name], this, newInstance);
        }
        return newInstance;
    }
    /**
    Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
    */ get tr() {
        return new $edd15e116d766874$export$febc5573c75cefb0(this);
    }
    /**
    Create a new state.
    */ static create(config) {
        let $config = new $edd15e116d766874$var$Configuration(config.doc ? config.doc.type.schema : config.schema, config.plugins);
        let instance = new $edd15e116d766874$export$afa855cbfaff27f2($config);
        for(let i = 0; i < $config.fields.length; i++)instance[$config.fields[i].name] = $config.fields[i].init(config, instance);
        return instance;
    }
    /**
    Create a new state based on this one, but with an adjusted set
    of active plugins. State fields that exist in both sets of
    plugins are kept unchanged. Those that no longer exist are
    dropped, and those that are new are initialized using their
    [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
    configuration object..
    */ reconfigure(config) {
        let $config = new $edd15e116d766874$var$Configuration(this.schema, config.plugins);
        let fields = $config.fields, instance = new $edd15e116d766874$export$afa855cbfaff27f2($config);
        for(let i = 0; i < fields.length; i++){
            let name = fields[i].name;
            instance[name] = this.hasOwnProperty(name) ? this[name] : fields[i].init(config, instance);
        }
        return instance;
    }
    /**
    Serialize this state to JSON. If you want to serialize the state
    of plugins, pass an object mapping property names to use in the
    resulting JSON object to plugin objects. The argument may also be
    a string or number, in which case it is ignored, to support the
    way `JSON.stringify` calls `toString` methods.
    */ toJSON(pluginFields) {
        let result = {
            doc: this.doc.toJSON(),
            selection: this.selection.toJSON()
        };
        if (this.storedMarks) result.storedMarks = this.storedMarks.map((m)=>m.toJSON());
        if (pluginFields && typeof pluginFields == 'object') for(let prop in pluginFields){
            if (prop == "doc" || prop == "selection") throw new RangeError("The JSON fields `doc` and `selection` are reserved");
            let plugin = pluginFields[prop], state = plugin.spec.state;
            if (state && state.toJSON) result[prop] = state.toJSON.call(plugin, this[plugin.key]);
        }
        return result;
    }
    /**
    Deserialize a JSON representation of a state. `config` should
    have at least a `schema` field, and should contain array of
    plugins to initialize the state with. `pluginFields` can be used
    to deserialize the state of plugins, by associating plugin
    instances with the property names they use in the JSON object.
    */ static fromJSON(config, json, pluginFields) {
        if (!json) throw new RangeError("Invalid input for EditorState.fromJSON");
        if (!config.schema) throw new RangeError("Required config field 'schema' missing");
        let $config = new $edd15e116d766874$var$Configuration(config.schema, config.plugins);
        let instance = new $edd15e116d766874$export$afa855cbfaff27f2($config);
        $config.fields.forEach((field)=>{
            if (field.name == "doc") instance.doc = (0, $7dkLM.Node).fromJSON(config.schema, json.doc);
            else if (field.name == "selection") instance.selection = $edd15e116d766874$export$52baac22726c72bf.fromJSON(instance.doc, json.selection);
            else if (field.name == "storedMarks") {
                if (json.storedMarks) instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON);
            } else {
                if (pluginFields) for(let prop in pluginFields){
                    let plugin = pluginFields[prop], state = plugin.spec.state;
                    if (plugin.key == field.name && state && state.fromJSON && Object.prototype.hasOwnProperty.call(json, prop)) {
                        instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
                        return;
                    }
                }
                instance[field.name] = field.init(config, instance);
            }
        });
        return instance;
    }
}
function $edd15e116d766874$var$bindProps(obj, self, target) {
    for(let prop in obj){
        let val = obj[prop];
        if (val instanceof Function) val = val.bind(self);
        else if (prop == "handleDOMEvents") val = $edd15e116d766874$var$bindProps(val, self, {});
        target[prop] = val;
    }
    return target;
}
/**
Plugins bundle functionality that can be added to an editor.
They are part of the [editor state](https://prosemirror.net/docs/ref/#state.EditorState) and
may influence that state and the view that contains it.
*/ class $edd15e116d766874$export$901cf72dabf2112a {
    /**
    Create a plugin.
    */ constructor(/**
    The plugin's [spec object](https://prosemirror.net/docs/ref/#state.PluginSpec).
    */ spec){
        this.spec = spec;
        /**
        The [props](https://prosemirror.net/docs/ref/#view.EditorProps) exported by this plugin.
        */ this.props = {};
        if (spec.props) $edd15e116d766874$var$bindProps(spec.props, this, this.props);
        this.key = spec.key ? spec.key.key : $edd15e116d766874$var$createKey("plugin");
    }
    /**
    Extract the plugin's state field from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}
const $edd15e116d766874$var$keys = Object.create(null);
function $edd15e116d766874$var$createKey(name) {
    if (name in $edd15e116d766874$var$keys) return name + "$" + ++$edd15e116d766874$var$keys[name];
    $edd15e116d766874$var$keys[name] = 0;
    return name + "$";
}
/**
A key is used to [tag](https://prosemirror.net/docs/ref/#state.PluginSpec.key) plugins in a way
that makes it possible to find them, given an editor state.
Assigning a key does mean only one plugin of that type can be
active in a state.
*/ class $edd15e116d766874$export$1692d8b0e89cecc3 {
    /**
    Create a plugin key.
    */ constructor(name = "key"){
        this.key = $edd15e116d766874$var$createKey(name);
    }
    /**
    Get the active plugin with this key, if any, from an editor
    state.
    */ get(state) {
        return state.config.pluginsByKey[this.key];
    }
    /**
    Get the plugin's state from an editor state.
    */ getState(state) {
        return state[this.key];
    }
}

});
parcelRegister("d6JJW", function(module, exports) {

$parcel$export(module.exports, "StepMap", () => $98af50e5743169ae$export$c53d01c3ab9721b3);
$parcel$export(module.exports, "Mapping", () => $98af50e5743169ae$export$f5f785078011b62);
$parcel$export(module.exports, "Step", () => $98af50e5743169ae$export$fd55ce593607084a);
$parcel$export(module.exports, "StepResult", () => $98af50e5743169ae$export$8ebf1578a4199c09);
$parcel$export(module.exports, "AddMarkStep", () => $98af50e5743169ae$export$d24ba56b0e3464a9);
$parcel$export(module.exports, "RemoveMarkStep", () => $98af50e5743169ae$export$94150db1311f67a9);
$parcel$export(module.exports, "AddNodeMarkStep", () => $98af50e5743169ae$export$adefd16c402fee4e);
$parcel$export(module.exports, "RemoveNodeMarkStep", () => $98af50e5743169ae$export$fdf7d1dc10724da2);
$parcel$export(module.exports, "ReplaceStep", () => $98af50e5743169ae$export$5c860b2e74034756);
$parcel$export(module.exports, "ReplaceAroundStep", () => $98af50e5743169ae$export$444ba800d6024a98);
$parcel$export(module.exports, "liftTarget", () => $98af50e5743169ae$export$f1508b72cc76a09e);
$parcel$export(module.exports, "findWrapping", () => $98af50e5743169ae$export$118cb9a83e81ba37);
$parcel$export(module.exports, "canSplit", () => $98af50e5743169ae$export$5aaf008897aef029);
$parcel$export(module.exports, "canJoin", () => $98af50e5743169ae$export$f15f89fd9d8cc98a);
$parcel$export(module.exports, "joinPoint", () => $98af50e5743169ae$export$41b1d4cb5ceb3147);
$parcel$export(module.exports, "insertPoint", () => $98af50e5743169ae$export$64cb316d02de1dd1);
$parcel$export(module.exports, "dropPoint", () => $98af50e5743169ae$export$2819d598d048fc9c);
$parcel$export(module.exports, "replaceStep", () => $98af50e5743169ae$export$ed6ac67359824afd);
$parcel$export(module.exports, "AttrStep", () => $98af50e5743169ae$export$626399c38172f669);
$parcel$export(module.exports, "Transform", () => $98af50e5743169ae$export$563a914cafbdc389);

var $7dkLM = parcelRequire("7dkLM");
// Recovery values encode a range index and an offset. They are
// represented as numbers, because tons of them will be created when
// mapping, for example, a large number of decorations. The number's
// lower 16 bits provide the index, the remaining bits the offset.
//
// Note: We intentionally don't use bit shift operators to en- and
// decode these, since those clip to 32 bits, which we might in rare
// cases want to overflow. A 64-bit float can represent 48-bit
// integers precisely.
const $98af50e5743169ae$var$lower16 = 0xffff;
const $98af50e5743169ae$var$factor16 = Math.pow(2, 16);
function $98af50e5743169ae$var$makeRecover(index, offset) {
    return index + offset * $98af50e5743169ae$var$factor16;
}
function $98af50e5743169ae$var$recoverIndex(value) {
    return value & $98af50e5743169ae$var$lower16;
}
function $98af50e5743169ae$var$recoverOffset(value) {
    return (value - (value & $98af50e5743169ae$var$lower16)) / $98af50e5743169ae$var$factor16;
}
const $98af50e5743169ae$var$DEL_BEFORE = 1, $98af50e5743169ae$var$DEL_AFTER = 2, $98af50e5743169ae$var$DEL_ACROSS = 4, $98af50e5743169ae$var$DEL_SIDE = 8;
/**
An object representing a mapped position with extra
information.
*/ class $98af50e5743169ae$export$c77c9be41668e9b4 {
    /**
    @internal
    */ constructor(/**
    The mapped version of the position.
    */ pos, /**
    @internal
    */ delInfo, /**
    @internal
    */ recover){
        this.pos = pos;
        this.delInfo = delInfo;
        this.recover = recover;
    }
    /**
    Tells you whether the position was deleted, that is, whether the
    step removed the token on the side queried (via the `assoc`)
    argument from the document.
    */ get deleted() {
        return (this.delInfo & $98af50e5743169ae$var$DEL_SIDE) > 0;
    }
    /**
    Tells you whether the token before the mapped position was deleted.
    */ get deletedBefore() {
        return (this.delInfo & ($98af50e5743169ae$var$DEL_BEFORE | $98af50e5743169ae$var$DEL_ACROSS)) > 0;
    }
    /**
    True when the token after the mapped position was deleted.
    */ get deletedAfter() {
        return (this.delInfo & ($98af50e5743169ae$var$DEL_AFTER | $98af50e5743169ae$var$DEL_ACROSS)) > 0;
    }
    /**
    Tells whether any of the steps mapped through deletes across the
    position (including both the token before and after the
    position).
    */ get deletedAcross() {
        return (this.delInfo & $98af50e5743169ae$var$DEL_ACROSS) > 0;
    }
}
/**
A map describing the deletions and insertions made by a step, which
can be used to find the correspondence between positions in the
pre-step version of a document and the same position in the
post-step version.
*/ class $98af50e5743169ae$export$c53d01c3ab9721b3 {
    /**
    Create a position map. The modifications to the document are
    represented as an array of numbers, in which each group of three
    represents a modified chunk as `[start, oldSize, newSize]`.
    */ constructor(/**
    @internal
    */ ranges, /**
    @internal
    */ inverted = false){
        this.ranges = ranges;
        this.inverted = inverted;
        if (!ranges.length && $98af50e5743169ae$export$c53d01c3ab9721b3.empty) return $98af50e5743169ae$export$c53d01c3ab9721b3.empty;
    }
    /**
    @internal
    */ recover(value) {
        let diff = 0, index = $98af50e5743169ae$var$recoverIndex(value);
        if (!this.inverted) for(let i = 0; i < index; i++)diff += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
        return this.ranges[index * 3] + diff + $98af50e5743169ae$var$recoverOffset(value);
    }
    mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    map(pos, assoc = 1) {
        return this._map(pos, assoc, true);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex], end = start + oldSize;
            if (pos <= end) {
                let side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
                let result = start + diff + (side < 0 ? 0 : newSize);
                if (simple) return result;
                let recover = pos == (assoc < 0 ? start : end) ? null : $98af50e5743169ae$var$makeRecover(i / 3, pos - start);
                let del = pos == start ? $98af50e5743169ae$var$DEL_AFTER : pos == end ? $98af50e5743169ae$var$DEL_BEFORE : $98af50e5743169ae$var$DEL_ACROSS;
                if (assoc < 0 ? pos != start : pos != end) del |= $98af50e5743169ae$var$DEL_SIDE;
                return new $98af50e5743169ae$export$c77c9be41668e9b4(result, del, recover);
            }
            diff += newSize - oldSize;
        }
        return simple ? pos + diff : new $98af50e5743169ae$export$c77c9be41668e9b4(pos + diff, 0, null);
    }
    /**
    @internal
    */ touches(pos, recover) {
        let diff = 0, index = $98af50e5743169ae$var$recoverIndex(recover);
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], end = start + oldSize;
            if (pos <= end && i == index * 3) return true;
            diff += this.ranges[i + newIndex] - oldSize;
        }
        return false;
    }
    /**
    Calls the given function on each of the changed ranges included in
    this map.
    */ forEach(f) {
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0, diff = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i], oldStart = start - (this.inverted ? diff : 0), newStart = start + (this.inverted ? 0 : diff);
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex];
            f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
            diff += newSize - oldSize;
        }
    }
    /**
    Create an inverted version of this map. The result can be used to
    map positions in the post-step document to the pre-step document.
    */ invert() {
        return new $98af50e5743169ae$export$c53d01c3ab9721b3(this.ranges, !this.inverted);
    }
    /**
    @internal
    */ toString() {
        return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
    }
    /**
    Create a map that moves all positions by offset `n` (which may be
    negative). This can be useful when applying steps meant for a
    sub-document to a larger document, or vice-versa.
    */ static offset(n) {
        return n == 0 ? $98af50e5743169ae$export$c53d01c3ab9721b3.empty : new $98af50e5743169ae$export$c53d01c3ab9721b3(n < 0 ? [
            0,
            -n,
            0
        ] : [
            0,
            0,
            n
        ]);
    }
}
/**
A StepMap that contains no changed ranges.
*/ $98af50e5743169ae$export$c53d01c3ab9721b3.empty = new $98af50e5743169ae$export$c53d01c3ab9721b3([]);
/**
A mapping represents a pipeline of zero or more [step
maps](https://prosemirror.net/docs/ref/#transform.StepMap). It has special provisions for losslessly
handling mapping positions through a series of steps in which some
steps are inverted versions of earlier steps. (This comes up when
‘[rebasing](/docs/guide/#transform.rebasing)’ steps for
collaboration or history management.)
*/ class $98af50e5743169ae$export$f5f785078011b62 {
    /**
    Create a new mapping with the given position maps.
    */ constructor(/**
    The step maps in this mapping.
    */ maps = [], /**
    @internal
    */ mirror, /**
    The starting position in the `maps` array, used when `map` or
    `mapResult` is called.
    */ from = 0, /**
    The end position in the `maps` array.
    */ to = maps.length){
        this.maps = maps;
        this.mirror = mirror;
        this.from = from;
        this.to = to;
    }
    /**
    Create a mapping that maps only through a part of this one.
    */ slice(from = 0, to = this.maps.length) {
        return new $98af50e5743169ae$export$f5f785078011b62(this.maps, this.mirror, from, to);
    }
    /**
    @internal
    */ copy() {
        return new $98af50e5743169ae$export$f5f785078011b62(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
    }
    /**
    Add a step map to the end of this mapping. If `mirrors` is
    given, it should be the index of the step map that is the mirror
    image of this one.
    */ appendMap(map, mirrors) {
        this.to = this.maps.push(map);
        if (mirrors != null) this.setMirror(this.maps.length - 1, mirrors);
    }
    /**
    Add all the step maps in a given mapping to this one (preserving
    mirroring information).
    */ appendMapping(mapping) {
        for(let i = 0, startSize = this.maps.length; i < mapping.maps.length; i++){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i], mirr != null && mirr < i ? startSize + mirr : undefined);
        }
    }
    /**
    Finds the offset of the step map that mirrors the map at the
    given offset, in this mapping (as per the second argument to
    `appendMap`).
    */ getMirror(n) {
        if (this.mirror) {
            for(let i = 0; i < this.mirror.length; i++)if (this.mirror[i] == n) return this.mirror[i + (i % 2 ? -1 : 1)];
        }
    }
    /**
    @internal
    */ setMirror(n, m) {
        if (!this.mirror) this.mirror = [];
        this.mirror.push(n, m);
    }
    /**
    Append the inverse of the given mapping to this one.
    */ appendMappingInverted(mapping) {
        for(let i = mapping.maps.length - 1, totalSize = this.maps.length + mapping.maps.length; i >= 0; i--){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : undefined);
        }
    }
    /**
    Create an inverted version of this mapping.
    */ invert() {
        let inverse = new $98af50e5743169ae$export$f5f785078011b62;
        inverse.appendMappingInverted(this);
        return inverse;
    }
    /**
    Map a position through this mapping.
    */ map(pos, assoc = 1) {
        if (this.mirror) return this._map(pos, assoc, true);
        for(let i = this.from; i < this.to; i++)pos = this.maps[i].map(pos, assoc);
        return pos;
    }
    /**
    Map a position through this mapping, returning a mapping
    result.
    */ mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let delInfo = 0;
        for(let i = this.from; i < this.to; i++){
            let map = this.maps[i], result = map.mapResult(pos, assoc);
            if (result.recover != null) {
                let corr = this.getMirror(i);
                if (corr != null && corr > i && corr < this.to) {
                    i = corr;
                    pos = this.maps[corr].recover(result.recover);
                    continue;
                }
            }
            delInfo |= result.delInfo;
            pos = result.pos;
        }
        return simple ? pos : new $98af50e5743169ae$export$c77c9be41668e9b4(pos, delInfo, null);
    }
}
const $98af50e5743169ae$var$stepsByID = Object.create(null);
/**
A step object represents an atomic change. It generally applies
only to the document it was created for, since the positions
stored in it will only make sense for that document.

New steps are defined by creating classes that extend `Step`,
overriding the `apply`, `invert`, `map`, `getMap` and `fromJSON`
methods, and registering your class with a unique
JSON-serialization identifier using
[`Step.jsonID`](https://prosemirror.net/docs/ref/#transform.Step^jsonID).
*/ class $98af50e5743169ae$export$fd55ce593607084a {
    /**
    Get the step map that represents the changes made by this step,
    and which can be used to transform between positions in the old
    and the new document.
    */ getMap() {
        return $98af50e5743169ae$export$c53d01c3ab9721b3.empty;
    }
    /**
    Try to merge this step with another one, to be applied directly
    after it. Returns the merged step when possible, null if the
    steps can't be merged.
    */ merge(other) {
        return null;
    }
    /**
    Deserialize a step from its JSON representation. Will call
    through to the step class' own implementation of this method.
    */ static fromJSON(schema, json) {
        if (!json || !json.stepType) throw new RangeError("Invalid input for Step.fromJSON");
        let type = $98af50e5743169ae$var$stepsByID[json.stepType];
        if (!type) throw new RangeError(`No step type ${json.stepType} defined`);
        return type.fromJSON(schema, json);
    }
    /**
    To be able to serialize steps to JSON, each step needs a string
    ID to attach to its JSON representation. Use this method to
    register an ID for your step classes. Try to pick something
    that's unlikely to clash with steps from other modules.
    */ static jsonID(id, stepClass) {
        if (id in $98af50e5743169ae$var$stepsByID) throw new RangeError("Duplicate use of step JSON ID " + id);
        $98af50e5743169ae$var$stepsByID[id] = stepClass;
        stepClass.prototype.jsonID = id;
        return stepClass;
    }
}
/**
The result of [applying](https://prosemirror.net/docs/ref/#transform.Step.apply) a step. Contains either a
new document or a failure value.
*/ class $98af50e5743169ae$export$8ebf1578a4199c09 {
    /**
    @internal
    */ constructor(/**
    The transformed document, if successful.
    */ doc, /**
    The failure message, if unsuccessful.
    */ failed){
        this.doc = doc;
        this.failed = failed;
    }
    /**
    Create a successful step result.
    */ static ok(doc) {
        return new $98af50e5743169ae$export$8ebf1578a4199c09(doc, null);
    }
    /**
    Create a failed step result.
    */ static fail(message) {
        return new $98af50e5743169ae$export$8ebf1578a4199c09(null, message);
    }
    /**
    Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
    arguments. Create a successful result if it succeeds, and a
    failed one if it throws a `ReplaceError`.
    */ static fromReplace(doc, from, to, slice) {
        try {
            return $98af50e5743169ae$export$8ebf1578a4199c09.ok(doc.replace(from, to, slice));
        } catch (e) {
            if (e instanceof (0, $7dkLM.ReplaceError)) return $98af50e5743169ae$export$8ebf1578a4199c09.fail(e.message);
            throw e;
        }
    }
}
function $98af50e5743169ae$var$mapFragment(fragment, f, parent) {
    let mapped = [];
    for(let i = 0; i < fragment.childCount; i++){
        let child = fragment.child(i);
        if (child.content.size) child = child.copy($98af50e5743169ae$var$mapFragment(child.content, f, child));
        if (child.isInline) child = f(child, parent, i);
        mapped.push(child);
    }
    return (0, $7dkLM.Fragment).fromArray(mapped);
}
/**
Add a mark to all inline content between two positions.
*/ class $98af50e5743169ae$export$d24ba56b0e3464a9 extends $98af50e5743169ae$export$fd55ce593607084a {
    /**
    Create a mark step.
    */ constructor(/**
    The start of the marked range.
    */ from, /**
    The end of the marked range.
    */ to, /**
    The mark to add.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
        let parent = $from.node($from.sharedDepth(this.to));
        let slice = new (0, $7dkLM.Slice)($98af50e5743169ae$var$mapFragment(oldSlice.content, (node, parent)=>{
            if (!node.isAtom || !parent.type.allowsMarkType(this.mark.type)) return node;
            return node.mark(this.mark.addToSet(node.marks));
        }, parent), oldSlice.openStart, oldSlice.openEnd);
        return $98af50e5743169ae$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $98af50e5743169ae$export$94150db1311f67a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $98af50e5743169ae$export$d24ba56b0e3464a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $98af50e5743169ae$export$d24ba56b0e3464a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $98af50e5743169ae$export$d24ba56b0e3464a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "addMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for AddMarkStep.fromJSON");
        return new $98af50e5743169ae$export$d24ba56b0e3464a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$98af50e5743169ae$export$fd55ce593607084a.jsonID("addMark", $98af50e5743169ae$export$d24ba56b0e3464a9);
/**
Remove a mark from all inline content between two positions.
*/ class $98af50e5743169ae$export$94150db1311f67a9 extends $98af50e5743169ae$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The start of the unmarked range.
    */ from, /**
    The end of the unmarked range.
    */ to, /**
    The mark to remove.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to);
        let slice = new (0, $7dkLM.Slice)($98af50e5743169ae$var$mapFragment(oldSlice.content, (node)=>{
            return node.mark(this.mark.removeFromSet(node.marks));
        }, doc), oldSlice.openStart, oldSlice.openEnd);
        return $98af50e5743169ae$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $98af50e5743169ae$export$d24ba56b0e3464a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $98af50e5743169ae$export$94150db1311f67a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $98af50e5743169ae$export$94150db1311f67a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $98af50e5743169ae$export$94150db1311f67a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "removeMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
        return new $98af50e5743169ae$export$94150db1311f67a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
}
$98af50e5743169ae$export$fd55ce593607084a.jsonID("removeMark", $98af50e5743169ae$export$94150db1311f67a9);
/**
Add a mark to a specific node.
*/ class $98af50e5743169ae$export$adefd16c402fee4e extends $98af50e5743169ae$export$fd55ce593607084a {
    /**
    Create a node mark step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to add.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $98af50e5743169ae$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.addToSet(node.marks));
        return $98af50e5743169ae$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (node) {
            let newSet = this.mark.addToSet(node.marks);
            if (newSet.length == node.marks.length) {
                for(let i = 0; i < node.marks.length; i++)if (!node.marks[i].isInSet(newSet)) return new $98af50e5743169ae$export$adefd16c402fee4e(this.pos, node.marks[i]);
                return new $98af50e5743169ae$export$adefd16c402fee4e(this.pos, this.mark);
            }
        }
        return new $98af50e5743169ae$export$fdf7d1dc10724da2(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $98af50e5743169ae$export$adefd16c402fee4e(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "addNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
        return new $98af50e5743169ae$export$adefd16c402fee4e(json.pos, schema.markFromJSON(json.mark));
    }
}
$98af50e5743169ae$export$fd55ce593607084a.jsonID("addNodeMark", $98af50e5743169ae$export$adefd16c402fee4e);
/**
Remove a mark from a specific node.
*/ class $98af50e5743169ae$export$fdf7d1dc10724da2 extends $98af50e5743169ae$export$fd55ce593607084a {
    /**
    Create a mark-removing step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to remove.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $98af50e5743169ae$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.removeFromSet(node.marks));
        return $98af50e5743169ae$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node || !this.mark.isInSet(node.marks)) return this;
        return new $98af50e5743169ae$export$adefd16c402fee4e(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $98af50e5743169ae$export$fdf7d1dc10724da2(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "removeNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
        return new $98af50e5743169ae$export$fdf7d1dc10724da2(json.pos, schema.markFromJSON(json.mark));
    }
}
$98af50e5743169ae$export$fd55ce593607084a.jsonID("removeNodeMark", $98af50e5743169ae$export$fdf7d1dc10724da2);
/**
Replace a part of the document with a slice of new content.
*/ class $98af50e5743169ae$export$5c860b2e74034756 extends $98af50e5743169ae$export$fd55ce593607084a {
    /**
    The given `slice` should fit the 'gap' between `from` and
    `to`—the depths must line up, and the surrounding nodes must be
    able to be joined with the open sides of the slice. When
    `structure` is true, the step will fail if the content between
    from and to is not just a sequence of closing and then opening
    tokens (this is to guard against rebased replace steps
    overwriting something they weren't supposed to).
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The slice to insert.
    */ slice, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.slice = slice;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && $98af50e5743169ae$var$contentBetween(doc, this.from, this.to)) return $98af50e5743169ae$export$8ebf1578a4199c09.fail("Structure replace would overwrite content");
        return $98af50e5743169ae$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, this.slice);
    }
    getMap() {
        return new $98af50e5743169ae$export$c53d01c3ab9721b3([
            this.from,
            this.to - this.from,
            this.slice.size
        ]);
    }
    invert(doc) {
        return new $98af50e5743169ae$export$5c860b2e74034756(this.from, this.from + this.slice.size, doc.slice(this.from, this.to));
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deletedAcross && to.deletedAcross) return null;
        return new $98af50e5743169ae$export$5c860b2e74034756(from.pos, Math.max(from.pos, to.pos), this.slice);
    }
    merge(other) {
        if (!(other instanceof $98af50e5743169ae$export$5c860b2e74034756) || other.structure || this.structure) return null;
        if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $7dkLM.Slice).empty : new (0, $7dkLM.Slice)(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
            return new $98af50e5743169ae$export$5c860b2e74034756(this.from, this.to + (other.to - other.from), slice, this.structure);
        } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $7dkLM.Slice).empty : new (0, $7dkLM.Slice)(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
            return new $98af50e5743169ae$export$5c860b2e74034756(other.from, this.to, slice, this.structure);
        } else return null;
    }
    toJSON() {
        let json = {
            stepType: "replace",
            from: this.from,
            to: this.to
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for ReplaceStep.fromJSON");
        return new $98af50e5743169ae$export$5c860b2e74034756(json.from, json.to, (0, $7dkLM.Slice).fromJSON(schema, json.slice), !!json.structure);
    }
}
$98af50e5743169ae$export$fd55ce593607084a.jsonID("replace", $98af50e5743169ae$export$5c860b2e74034756);
/**
Replace a part of the document with a slice of content, but
preserve a range of the replaced content by moving it into the
slice.
*/ class $98af50e5743169ae$export$444ba800d6024a98 extends $98af50e5743169ae$export$fd55ce593607084a {
    /**
    Create a replace-around step with the given range and gap.
    `insert` should be the point in the slice into which the content
    of the gap should be moved. `structure` has the same meaning as
    it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The start of preserved range.
    */ gapFrom, /**
    The end of preserved range.
    */ gapTo, /**
    The slice to insert.
    */ slice, /**
    The position in the slice where the preserved range should be
    inserted.
    */ insert, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.gapFrom = gapFrom;
        this.gapTo = gapTo;
        this.slice = slice;
        this.insert = insert;
        this.structure = structure;
    }
    apply(doc) {
        if (this.structure && ($98af50e5743169ae$var$contentBetween(doc, this.from, this.gapFrom) || $98af50e5743169ae$var$contentBetween(doc, this.gapTo, this.to))) return $98af50e5743169ae$export$8ebf1578a4199c09.fail("Structure gap-replace would overwrite content");
        let gap = doc.slice(this.gapFrom, this.gapTo);
        if (gap.openStart || gap.openEnd) return $98af50e5743169ae$export$8ebf1578a4199c09.fail("Gap is not a flat range");
        let inserted = this.slice.insertAt(this.insert, gap.content);
        if (!inserted) return $98af50e5743169ae$export$8ebf1578a4199c09.fail("Content does not fit in gap");
        return $98af50e5743169ae$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, inserted);
    }
    getMap() {
        return new $98af50e5743169ae$export$c53d01c3ab9721b3([
            this.from,
            this.gapFrom - this.from,
            this.insert,
            this.gapTo,
            this.to - this.gapTo,
            this.slice.size - this.insert
        ]);
    }
    invert(doc) {
        let gap = this.gapTo - this.gapFrom;
        return new $98af50e5743169ae$export$444ba800d6024a98(this.from, this.from + this.slice.size + gap, this.from + this.insert, this.from + this.insert + gap, doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        let gapFrom = mapping.map(this.gapFrom, -1), gapTo = mapping.map(this.gapTo, 1);
        if (from.deletedAcross && to.deletedAcross || gapFrom < from.pos || gapTo > to.pos) return null;
        return new $98af50e5743169ae$export$444ba800d6024a98(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure);
    }
    toJSON() {
        let json = {
            stepType: "replaceAround",
            from: this.from,
            to: this.to,
            gapFrom: this.gapFrom,
            gapTo: this.gapTo,
            insert: this.insert
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number" || typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number") throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
        return new $98af50e5743169ae$export$444ba800d6024a98(json.from, json.to, json.gapFrom, json.gapTo, (0, $7dkLM.Slice).fromJSON(schema, json.slice), json.insert, !!json.structure);
    }
}
$98af50e5743169ae$export$fd55ce593607084a.jsonID("replaceAround", $98af50e5743169ae$export$444ba800d6024a98);
function $98af50e5743169ae$var$contentBetween(doc, from, to) {
    let $from = doc.resolve(from), dist = to - from, depth = $from.depth;
    while(dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount){
        depth--;
        dist--;
    }
    if (dist > 0) {
        let next = $from.node(depth).maybeChild($from.indexAfter(depth));
        while(dist > 0){
            if (!next || next.isLeaf) return true;
            next = next.firstChild;
            dist--;
        }
    }
    return false;
}
function $98af50e5743169ae$var$addMark(tr, from, to, mark) {
    let removed = [], added = [];
    let removing, adding;
    tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (!node.isInline) return;
        let marks = node.marks;
        if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
            let start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
            let newSet = mark.addToSet(marks);
            for(let i = 0; i < marks.length; i++)if (!marks[i].isInSet(newSet)) {
                if (removing && removing.to == start && removing.mark.eq(marks[i])) removing.to = end;
                else removed.push(removing = new $98af50e5743169ae$export$94150db1311f67a9(start, end, marks[i]));
            }
            if (adding && adding.to == start) adding.to = end;
            else added.push(adding = new $98af50e5743169ae$export$d24ba56b0e3464a9(start, end, mark));
        }
    });
    removed.forEach((s)=>tr.step(s));
    added.forEach((s)=>tr.step(s));
}
function $98af50e5743169ae$var$removeMark(tr, from, to, mark) {
    let matched = [], step = 0;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (!node.isInline) return;
        step++;
        let toRemove = null;
        if (mark instanceof (0, $7dkLM.MarkType)) {
            let set = node.marks, found;
            while(found = mark.isInSet(set)){
                (toRemove || (toRemove = [])).push(found);
                set = found.removeFromSet(set);
            }
        } else if (mark) {
            if (mark.isInSet(node.marks)) toRemove = [
                mark
            ];
        } else toRemove = node.marks;
        if (toRemove && toRemove.length) {
            let end = Math.min(pos + node.nodeSize, to);
            for(let i = 0; i < toRemove.length; i++){
                let style = toRemove[i], found;
                for(let j = 0; j < matched.length; j++){
                    let m = matched[j];
                    if (m.step == step - 1 && style.eq(matched[j].style)) found = m;
                }
                if (found) {
                    found.to = end;
                    found.step = step;
                } else matched.push({
                    style: style,
                    from: Math.max(pos, from),
                    to: end,
                    step: step
                });
            }
        }
    });
    matched.forEach((m)=>tr.step(new $98af50e5743169ae$export$94150db1311f67a9(m.from, m.to, m.style)));
}
function $98af50e5743169ae$var$clearIncompatible(tr, pos, parentType, match = parentType.contentMatch) {
    let node = tr.doc.nodeAt(pos);
    let replSteps = [], cur = pos + 1;
    for(let i = 0; i < node.childCount; i++){
        let child = node.child(i), end = cur + child.nodeSize;
        let allowed = match.matchType(child.type);
        if (!allowed) replSteps.push(new $98af50e5743169ae$export$5c860b2e74034756(cur, end, (0, $7dkLM.Slice).empty));
        else {
            match = allowed;
            for(let j = 0; j < child.marks.length; j++)if (!parentType.allowsMarkType(child.marks[j].type)) tr.step(new $98af50e5743169ae$export$94150db1311f67a9(cur, end, child.marks[j]));
            if (child.isText && !parentType.spec.code) {
                let m, newline = /\r?\n|\r/g, slice;
                while(m = newline.exec(child.text)){
                    if (!slice) slice = new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(parentType.schema.text(" ", parentType.allowedMarks(child.marks))), 0, 0);
                    replSteps.push(new $98af50e5743169ae$export$5c860b2e74034756(cur + m.index, cur + m.index + m[0].length, slice));
                }
            }
        }
        cur = end;
    }
    if (!match.validEnd) {
        let fill = match.fillBefore((0, $7dkLM.Fragment).empty, true);
        tr.replace(cur, cur, new (0, $7dkLM.Slice)(fill, 0, 0));
    }
    for(let i = replSteps.length - 1; i >= 0; i--)tr.step(replSteps[i]);
}
function $98af50e5743169ae$var$canCut(node, start, end) {
    return (start == 0 || node.canReplace(start, node.childCount)) && (end == node.childCount || node.canReplace(0, end));
}
/**
Try to find a target depth to which the content in the given range
can be lifted. Will not go across
[isolating](https://prosemirror.net/docs/ref/#model.NodeSpec.isolating) parent nodes.
*/ function $98af50e5743169ae$export$f1508b72cc76a09e(range) {
    let parent = range.parent;
    let content = parent.content.cutByIndex(range.startIndex, range.endIndex);
    for(let depth = range.depth;; --depth){
        let node = range.$from.node(depth);
        let index = range.$from.index(depth), endIndex = range.$to.indexAfter(depth);
        if (depth < range.depth && node.canReplace(index, endIndex, content)) return depth;
        if (depth == 0 || node.type.spec.isolating || !$98af50e5743169ae$var$canCut(node, index, endIndex)) break;
    }
    return null;
}
function $98af50e5743169ae$var$lift(tr, range, target) {
    let { $from: $from, $to: $to, depth: depth } = range;
    let gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
    let start = gapStart, end = gapEnd;
    let before = (0, $7dkLM.Fragment).empty, openStart = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $from.index(d) > 0) {
        splitting = true;
        before = (0, $7dkLM.Fragment).from($from.node(d).copy(before));
        openStart++;
    } else start--;
    let after = (0, $7dkLM.Fragment).empty, openEnd = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $to.after(d + 1) < $to.end(d)) {
        splitting = true;
        after = (0, $7dkLM.Fragment).from($to.node(d).copy(after));
        openEnd++;
    } else end++;
    tr.step(new $98af50e5743169ae$export$444ba800d6024a98(start, end, gapStart, gapEnd, new (0, $7dkLM.Slice)(before.append(after), openStart, openEnd), before.size - openStart, true));
}
/**
Try to find a valid way to wrap the content in the given range in a
node of the given type. May introduce extra nodes around and inside
the wrapper node, if necessary. Returns null if no valid wrapping
could be found. When `innerRange` is given, that range's content is
used as the content to fit into the wrapping, instead of the
content of `range`.
*/ function $98af50e5743169ae$export$118cb9a83e81ba37(range, nodeType, attrs = null, innerRange = range) {
    let around = $98af50e5743169ae$var$findWrappingOutside(range, nodeType);
    let inner = around && $98af50e5743169ae$var$findWrappingInside(innerRange, nodeType);
    if (!inner) return null;
    return around.map($98af50e5743169ae$var$withAttrs).concat({
        type: nodeType,
        attrs: attrs
    }).concat(inner.map($98af50e5743169ae$var$withAttrs));
}
function $98af50e5743169ae$var$withAttrs(type) {
    return {
        type: type,
        attrs: null
    };
}
function $98af50e5743169ae$var$findWrappingOutside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let around = parent.contentMatchAt(startIndex).findWrapping(type);
    if (!around) return null;
    let outer = around.length ? around[0] : type;
    return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null;
}
function $98af50e5743169ae$var$findWrappingInside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let inner = parent.child(startIndex);
    let inside = type.contentMatch.findWrapping(inner.type);
    if (!inside) return null;
    let lastType = inside.length ? inside[inside.length - 1] : type;
    let innerMatch = lastType.contentMatch;
    for(let i = startIndex; innerMatch && i < endIndex; i++)innerMatch = innerMatch.matchType(parent.child(i).type);
    if (!innerMatch || !innerMatch.validEnd) return null;
    return inside;
}
function $98af50e5743169ae$var$wrap(tr, range, wrappers) {
    let content = (0, $7dkLM.Fragment).empty;
    for(let i = wrappers.length - 1; i >= 0; i--){
        if (content.size) {
            let match = wrappers[i].type.contentMatch.matchFragment(content);
            if (!match || !match.validEnd) throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
        }
        content = (0, $7dkLM.Fragment).from(wrappers[i].type.create(wrappers[i].attrs, content));
    }
    let start = range.start, end = range.end;
    tr.step(new $98af50e5743169ae$export$444ba800d6024a98(start, end, start, end, new (0, $7dkLM.Slice)(content, 0, 0), wrappers.length, true));
}
function $98af50e5743169ae$var$setBlockType(tr, from, to, type, attrs) {
    if (!type.isTextblock) throw new RangeError("Type given to setBlockType should be a textblock");
    let mapFrom = tr.steps.length;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (node.isTextblock && !node.hasMarkup(type, attrs) && $98af50e5743169ae$var$canChangeType(tr.doc, tr.mapping.slice(mapFrom).map(pos), type)) {
            // Ensure all markup that isn't allowed in the new node type is cleared
            tr.clearIncompatible(tr.mapping.slice(mapFrom).map(pos, 1), type);
            let mapping = tr.mapping.slice(mapFrom);
            let startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
            tr.step(new $98af50e5743169ae$export$444ba800d6024a98(startM, endM, startM + 1, endM - 1, new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(type.create(attrs, null, node.marks)), 0, 0), 1, true));
            return false;
        }
    });
}
function $98af50e5743169ae$var$canChangeType(doc, pos, type) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $pos.parent.canReplaceWith(index, index + 1, type);
}
/**
Change the type, attributes, and/or marks of the node at `pos`.
When `type` isn't given, the existing node type is preserved,
*/ function $98af50e5743169ae$var$setNodeMarkup(tr, pos, type, attrs, marks) {
    let node = tr.doc.nodeAt(pos);
    if (!node) throw new RangeError("No node at given position");
    if (!type) type = node.type;
    let newNode = type.create(attrs, null, marks || node.marks);
    if (node.isLeaf) return tr.replaceWith(pos, pos + node.nodeSize, newNode);
    if (!type.validContent(node.content)) throw new RangeError("Invalid content for node type " + type.name);
    tr.step(new $98af50e5743169ae$export$444ba800d6024a98(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1, new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(newNode), 0, 0), 1, true));
}
/**
Check whether splitting at the given position is allowed.
*/ function $98af50e5743169ae$export$5aaf008897aef029(doc, pos, depth = 1, typesAfter) {
    let $pos = doc.resolve(pos), base = $pos.depth - depth;
    let innerType = typesAfter && typesAfter[typesAfter.length - 1] || $pos.parent;
    if (base < 0 || $pos.parent.type.spec.isolating || !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) || !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount))) return false;
    for(let d = $pos.depth - 1, i = depth - 2; d > base; d--, i--){
        let node = $pos.node(d), index = $pos.index(d);
        if (node.type.spec.isolating) return false;
        let rest = node.content.cutByIndex(index, node.childCount);
        let overrideChild = typesAfter && typesAfter[i + 1];
        if (overrideChild) rest = rest.replaceChild(0, overrideChild.type.create(overrideChild.attrs));
        let after = typesAfter && typesAfter[i] || node;
        if (!node.canReplace(index + 1, node.childCount) || !after.type.validContent(rest)) return false;
    }
    let index = $pos.indexAfter(base);
    let baseType = typesAfter && typesAfter[0];
    return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type);
}
function $98af50e5743169ae$var$split(tr, pos, depth = 1, typesAfter) {
    let $pos = tr.doc.resolve(pos), before = (0, $7dkLM.Fragment).empty, after = (0, $7dkLM.Fragment).empty;
    for(let d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--){
        before = (0, $7dkLM.Fragment).from($pos.node(d).copy(before));
        let typeAfter = typesAfter && typesAfter[i];
        after = (0, $7dkLM.Fragment).from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
    }
    tr.step(new $98af50e5743169ae$export$5c860b2e74034756(pos, pos, new (0, $7dkLM.Slice)(before.append(after), depth, depth), true));
}
/**
Test whether the blocks before and after a given position can be
joined.
*/ function $98af50e5743169ae$export$f15f89fd9d8cc98a(doc, pos) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $98af50e5743169ae$var$joinable($pos.nodeBefore, $pos.nodeAfter) && $pos.parent.canReplace(index, index + 1);
}
function $98af50e5743169ae$var$joinable(a, b) {
    return !!(a && b && !a.isLeaf && a.canAppend(b));
}
/**
Find an ancestor of the given position that can be joined to the
block before (or after if `dir` is positive). Returns the joinable
point, if any.
*/ function $98af50e5743169ae$export$41b1d4cb5ceb3147(doc, pos, dir = -1) {
    let $pos = doc.resolve(pos);
    for(let d = $pos.depth;; d--){
        let before, after, index = $pos.index(d);
        if (d == $pos.depth) {
            before = $pos.nodeBefore;
            after = $pos.nodeAfter;
        } else if (dir > 0) {
            before = $pos.node(d + 1);
            index++;
            after = $pos.node(d).maybeChild(index);
        } else {
            before = $pos.node(d).maybeChild(index - 1);
            after = $pos.node(d + 1);
        }
        if (before && !before.isTextblock && $98af50e5743169ae$var$joinable(before, after) && $pos.node(d).canReplace(index, index + 1)) return pos;
        if (d == 0) break;
        pos = dir < 0 ? $pos.before(d) : $pos.after(d);
    }
}
function $98af50e5743169ae$var$join(tr, pos, depth) {
    let step = new $98af50e5743169ae$export$5c860b2e74034756(pos - depth, pos + depth, (0, $7dkLM.Slice).empty, true);
    tr.step(step);
}
/**
Try to find a point where a node of the given type can be inserted
near `pos`, by searching up the node hierarchy when `pos` itself
isn't a valid place but is at the start or end of a node. Return
null if no position was found.
*/ function $98af50e5743169ae$export$64cb316d02de1dd1(doc, pos, nodeType) {
    let $pos = doc.resolve(pos);
    if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) return pos;
    if ($pos.parentOffset == 0) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.index(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.before(d + 1);
        if (index > 0) return null;
    }
    if ($pos.parentOffset == $pos.parent.content.size) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.indexAfter(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.after(d + 1);
        if (index < $pos.node(d).childCount) return null;
    }
    return null;
}
/**
Finds a position at or around the given position where the given
slice can be inserted. Will look at parent nodes' nearest boundary
and try there, even if the original position wasn't directly at the
start or end of that node. Returns null when no position was found.
*/ function $98af50e5743169ae$export$2819d598d048fc9c(doc, pos, slice) {
    let $pos = doc.resolve(pos);
    if (!slice.content.size) return pos;
    let content = slice.content;
    for(let i = 0; i < slice.openStart; i++)content = content.firstChild.content;
    for(let pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++)for(let d = $pos.depth; d >= 0; d--){
        let bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
        let insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
        let parent = $pos.node(d), fits = false;
        if (pass == 1) fits = parent.canReplace(insertPos, insertPos, content);
        else {
            let wrapping = parent.contentMatchAt(insertPos).findWrapping(content.firstChild.type);
            fits = wrapping && parent.canReplaceWith(insertPos, insertPos, wrapping[0]);
        }
        if (fits) return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
    }
    return null;
}
/**
‘Fit’ a slice into a given position in the document, producing a
[step](https://prosemirror.net/docs/ref/#transform.Step) that inserts it. Will return null if
there's no meaningful way to insert the slice here, or inserting it
would be a no-op (an empty slice over an empty range).
*/ function $98af50e5743169ae$export$ed6ac67359824afd(doc, from, to = from, slice = (0, $7dkLM.Slice).empty) {
    if (from == to && !slice.size) return null;
    let $from = doc.resolve(from), $to = doc.resolve(to);
    // Optimization -- avoid work if it's obvious that it's not needed.
    if ($98af50e5743169ae$var$fitsTrivially($from, $to, slice)) return new $98af50e5743169ae$export$5c860b2e74034756(from, to, slice);
    return new $98af50e5743169ae$var$Fitter($from, $to, slice).fit();
}
function $98af50e5743169ae$var$fitsTrivially($from, $to, slice) {
    return !slice.openStart && !slice.openEnd && $from.start() == $to.start() && $from.parent.canReplace($from.index(), $to.index(), slice.content);
}
// Algorithm for 'placing' the elements of a slice into a gap:
//
// We consider the content of each node that is open to the left to be
// independently placeable. I.e. in <p("foo"), p("bar")>, when the
// paragraph on the left is open, "foo" can be placed (somewhere on
// the left side of the replacement gap) independently from p("bar").
//
// This class tracks the state of the placement progress in the
// following properties:
//
//  - `frontier` holds a stack of `{type, match}` objects that
//    represent the open side of the replacement. It starts at
//    `$from`, then moves forward as content is placed, and is finally
//    reconciled with `$to`.
//
//  - `unplaced` is a slice that represents the content that hasn't
//    been placed yet.
//
//  - `placed` is a fragment of placed content. Its open-start value
//    is implicit in `$from`, and its open-end value in `frontier`.
class $98af50e5743169ae$var$Fitter {
    constructor($from, $to, unplaced){
        this.$from = $from;
        this.$to = $to;
        this.unplaced = unplaced;
        this.frontier = [];
        this.placed = (0, $7dkLM.Fragment).empty;
        for(let i = 0; i <= $from.depth; i++){
            let node = $from.node(i);
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt($from.indexAfter(i))
            });
        }
        for(let i = $from.depth; i > 0; i--)this.placed = (0, $7dkLM.Fragment).from($from.node(i).copy(this.placed));
    }
    get depth() {
        return this.frontier.length - 1;
    }
    fit() {
        // As long as there's unplaced content, try to place some of it.
        // If that fails, either increase the open score of the unplaced
        // slice, or drop nodes from it, and then try again.
        while(this.unplaced.size){
            let fit = this.findFittable();
            if (fit) this.placeNodes(fit);
            else this.openMore() || this.dropNode();
        }
        // When there's inline content directly after the frontier _and_
        // directly after `this.$to`, we must generate a `ReplaceAround`
        // step that pulls that content into the node after the frontier.
        // That means the fitting must be done to the end of the textblock
        // node after `this.$to`, not `this.$to` itself.
        let moveInline = this.mustMoveInline(), placedSize = this.placed.size - this.depth - this.$from.depth;
        let $from = this.$from, $to = this.close(moveInline < 0 ? this.$to : $from.doc.resolve(moveInline));
        if (!$to) return null;
        // If closing to `$to` succeeded, create a step
        let content = this.placed, openStart = $from.depth, openEnd = $to.depth;
        while(openStart && openEnd && content.childCount == 1){
            content = content.firstChild.content;
            openStart--;
            openEnd--;
        }
        let slice = new (0, $7dkLM.Slice)(content, openStart, openEnd);
        if (moveInline > -1) return new $98af50e5743169ae$export$444ba800d6024a98($from.pos, moveInline, this.$to.pos, this.$to.end(), slice, placedSize);
        if (slice.size || $from.pos != this.$to.pos) return new $98af50e5743169ae$export$5c860b2e74034756($from.pos, $to.pos, slice);
        return null;
    }
    // Find a position on the start spine of `this.unplaced` that has
    // content that can be moved somewhere on the frontier. Returns two
    // depths, one for the slice and one for the frontier.
    findFittable() {
        let startDepth = this.unplaced.openStart;
        for(let cur = this.unplaced.content, d = 0, openEnd = this.unplaced.openEnd; d < startDepth; d++){
            let node = cur.firstChild;
            if (cur.childCount > 1) openEnd = 0;
            if (node.type.spec.isolating && openEnd <= d) {
                startDepth = d;
                break;
            }
            cur = node.content;
        }
        // Only try wrapping nodes (pass 2) after finding a place without
        // wrapping failed.
        for(let pass = 1; pass <= 2; pass++)for(let sliceDepth = pass == 1 ? startDepth : this.unplaced.openStart; sliceDepth >= 0; sliceDepth--){
            let fragment, parent = null;
            if (sliceDepth) {
                parent = $98af50e5743169ae$var$contentAt(this.unplaced.content, sliceDepth - 1).firstChild;
                fragment = parent.content;
            } else fragment = this.unplaced.content;
            let first = fragment.firstChild;
            for(let frontierDepth = this.depth; frontierDepth >= 0; frontierDepth--){
                let { type: type, match: match } = this.frontier[frontierDepth], wrap, inject = null;
                // In pass 1, if the next node matches, or there is no next
                // node but the parents look compatible, we've found a
                // place.
                if (pass == 1 && (first ? match.matchType(first.type) || (inject = match.fillBefore((0, $7dkLM.Fragment).from(first), false)) : parent && type.compatibleContent(parent.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    inject: inject
                };
                else if (pass == 2 && first && (wrap = match.findWrapping(first.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    wrap: wrap
                };
                // Don't continue looking further up if the parent node
                // would fit here.
                if (parent && match.matchType(parent.type)) break;
            }
        }
    }
    openMore() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $98af50e5743169ae$var$contentAt(content, openStart);
        if (!inner.childCount || inner.firstChild.isLeaf) return false;
        this.unplaced = new (0, $7dkLM.Slice)(content, openStart + 1, Math.max(openEnd, inner.size + openStart >= content.size - openEnd ? openStart + 1 : 0));
        return true;
    }
    dropNode() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $98af50e5743169ae$var$contentAt(content, openStart);
        if (inner.childCount <= 1 && openStart > 0) {
            let openAtEnd = content.size - openStart <= openStart + inner.size;
            this.unplaced = new (0, $7dkLM.Slice)($98af50e5743169ae$var$dropFromFragment(content, openStart - 1, 1), openStart - 1, openAtEnd ? openStart - 1 : openEnd);
        } else this.unplaced = new (0, $7dkLM.Slice)($98af50e5743169ae$var$dropFromFragment(content, openStart, 1), openStart, openEnd);
    }
    // Move content from the unplaced slice at `sliceDepth` to the
    // frontier node at `frontierDepth`. Close that frontier node when
    // applicable.
    placeNodes({ sliceDepth: sliceDepth, frontierDepth: frontierDepth, parent: parent, inject: inject, wrap: wrap }) {
        while(this.depth > frontierDepth)this.closeFrontierNode();
        if (wrap) for(let i = 0; i < wrap.length; i++)this.openFrontierNode(wrap[i]);
        let slice = this.unplaced, fragment = parent ? parent.content : slice.content;
        let openStart = slice.openStart - sliceDepth;
        let taken = 0, add = [];
        let { match: match, type: type } = this.frontier[frontierDepth];
        if (inject) {
            for(let i = 0; i < inject.childCount; i++)add.push(inject.child(i));
            match = match.matchFragment(inject);
        }
        // Computes the amount of (end) open nodes at the end of the
        // fragment. When 0, the parent is open, but no more. When
        // negative, nothing is open.
        let openEndCount = fragment.size + sliceDepth - (slice.content.size - slice.openEnd);
        // Scan over the fragment, fitting as many child nodes as
        // possible.
        while(taken < fragment.childCount){
            let next = fragment.child(taken), matches = match.matchType(next.type);
            if (!matches) break;
            taken++;
            if (taken > 1 || openStart == 0 || next.content.size) {
                match = matches;
                add.push($98af50e5743169ae$var$closeNodeStart(next.mark(type.allowedMarks(next.marks)), taken == 1 ? openStart : 0, taken == fragment.childCount ? openEndCount : -1));
            }
        }
        let toEnd = taken == fragment.childCount;
        if (!toEnd) openEndCount = -1;
        this.placed = $98af50e5743169ae$var$addToFragment(this.placed, frontierDepth, (0, $7dkLM.Fragment).from(add));
        this.frontier[frontierDepth].match = match;
        // If the parent types match, and the entire node was moved, and
        // it's not open, close this frontier node right away.
        if (toEnd && openEndCount < 0 && parent && parent.type == this.frontier[this.depth].type && this.frontier.length > 1) this.closeFrontierNode();
        // Add new frontier nodes for any open nodes at the end.
        for(let i = 0, cur = fragment; i < openEndCount; i++){
            let node = cur.lastChild;
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt(node.childCount)
            });
            cur = node.content;
        }
        // Update `this.unplaced`. Drop the entire node from which we
        // placed it we got to its end, otherwise just drop the placed
        // nodes.
        this.unplaced = !toEnd ? new (0, $7dkLM.Slice)($98af50e5743169ae$var$dropFromFragment(slice.content, sliceDepth, taken), slice.openStart, slice.openEnd) : sliceDepth == 0 ? (0, $7dkLM.Slice).empty : new (0, $7dkLM.Slice)($98af50e5743169ae$var$dropFromFragment(slice.content, sliceDepth - 1, 1), sliceDepth - 1, openEndCount < 0 ? slice.openEnd : sliceDepth - 1);
    }
    mustMoveInline() {
        if (!this.$to.parent.isTextblock) return -1;
        let top = this.frontier[this.depth], level;
        if (!top.type.isTextblock || !$98af50e5743169ae$var$contentAfterFits(this.$to, this.$to.depth, top.type, top.match, false) || this.$to.depth == this.depth && (level = this.findCloseLevel(this.$to)) && level.depth == this.depth) return -1;
        let { depth: depth } = this.$to, after = this.$to.after(depth);
        while(depth > 1 && after == this.$to.end(--depth))++after;
        return after;
    }
    findCloseLevel($to) {
        scan: for(let i = Math.min(this.depth, $to.depth); i >= 0; i--){
            let { match: match, type: type } = this.frontier[i];
            let dropInner = i < $to.depth && $to.end(i + 1) == $to.pos + ($to.depth - (i + 1));
            let fit = $98af50e5743169ae$var$contentAfterFits($to, i, type, match, dropInner);
            if (!fit) continue;
            for(let d = i - 1; d >= 0; d--){
                let { match: match, type: type } = this.frontier[d];
                let matches = $98af50e5743169ae$var$contentAfterFits($to, d, type, match, true);
                if (!matches || matches.childCount) continue scan;
            }
            return {
                depth: i,
                fit: fit,
                move: dropInner ? $to.doc.resolve($to.after(i + 1)) : $to
            };
        }
    }
    close($to) {
        let close = this.findCloseLevel($to);
        if (!close) return null;
        while(this.depth > close.depth)this.closeFrontierNode();
        if (close.fit.childCount) this.placed = $98af50e5743169ae$var$addToFragment(this.placed, close.depth, close.fit);
        $to = close.move;
        for(let d = close.depth + 1; d <= $to.depth; d++){
            let node = $to.node(d), add = node.type.contentMatch.fillBefore(node.content, true, $to.index(d));
            this.openFrontierNode(node.type, node.attrs, add);
        }
        return $to;
    }
    openFrontierNode(type, attrs = null, content) {
        let top = this.frontier[this.depth];
        top.match = top.match.matchType(type);
        this.placed = $98af50e5743169ae$var$addToFragment(this.placed, this.depth, (0, $7dkLM.Fragment).from(type.create(attrs, content)));
        this.frontier.push({
            type: type,
            match: type.contentMatch
        });
    }
    closeFrontierNode() {
        let open = this.frontier.pop();
        let add = open.match.fillBefore((0, $7dkLM.Fragment).empty, true);
        if (add.childCount) this.placed = $98af50e5743169ae$var$addToFragment(this.placed, this.frontier.length, add);
    }
}
function $98af50e5743169ae$var$dropFromFragment(fragment, depth, count) {
    if (depth == 0) return fragment.cutByIndex(count, fragment.childCount);
    return fragment.replaceChild(0, fragment.firstChild.copy($98af50e5743169ae$var$dropFromFragment(fragment.firstChild.content, depth - 1, count)));
}
function $98af50e5743169ae$var$addToFragment(fragment, depth, content) {
    if (depth == 0) return fragment.append(content);
    return fragment.replaceChild(fragment.childCount - 1, fragment.lastChild.copy($98af50e5743169ae$var$addToFragment(fragment.lastChild.content, depth - 1, content)));
}
function $98af50e5743169ae$var$contentAt(fragment, depth) {
    for(let i = 0; i < depth; i++)fragment = fragment.firstChild.content;
    return fragment;
}
function $98af50e5743169ae$var$closeNodeStart(node, openStart, openEnd) {
    if (openStart <= 0) return node;
    let frag = node.content;
    if (openStart > 1) frag = frag.replaceChild(0, $98af50e5743169ae$var$closeNodeStart(frag.firstChild, openStart - 1, frag.childCount == 1 ? openEnd - 1 : 0));
    if (openStart > 0) {
        frag = node.type.contentMatch.fillBefore(frag).append(frag);
        if (openEnd <= 0) frag = frag.append(node.type.contentMatch.matchFragment(frag).fillBefore((0, $7dkLM.Fragment).empty, true));
    }
    return node.copy(frag);
}
function $98af50e5743169ae$var$contentAfterFits($to, depth, type, match, open) {
    let node = $to.node(depth), index = open ? $to.indexAfter(depth) : $to.index(depth);
    if (index == node.childCount && !type.compatibleContent(node.type)) return null;
    let fit = match.fillBefore(node.content, true, index);
    return fit && !$98af50e5743169ae$var$invalidMarks(type, node.content, index) ? fit : null;
}
function $98af50e5743169ae$var$invalidMarks(type, fragment, start) {
    for(let i = start; i < fragment.childCount; i++)if (!type.allowsMarks(fragment.child(i).marks)) return true;
    return false;
}
function $98af50e5743169ae$var$definesContent(type) {
    return type.spec.defining || type.spec.definingForContent;
}
function $98af50e5743169ae$var$replaceRange(tr, from, to, slice) {
    if (!slice.size) return tr.deleteRange(from, to);
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    if ($98af50e5743169ae$var$fitsTrivially($from, $to, slice)) return tr.step(new $98af50e5743169ae$export$5c860b2e74034756(from, to, slice));
    let targetDepths = $98af50e5743169ae$var$coveredDepths($from, tr.doc.resolve(to));
    // Can't replace the whole document, so remove 0 if it's present
    if (targetDepths[targetDepths.length - 1] == 0) targetDepths.pop();
    // Negative numbers represent not expansion over the whole node at
    // that depth, but replacing from $from.before(-D) to $to.pos.
    let preferredTarget = -($from.depth + 1);
    targetDepths.unshift(preferredTarget);
    // This loop picks a preferred target depth, if one of the covering
    // depths is not outside of a defining node, and adds negative
    // depths for any depth that has $from at its start and does not
    // cross a defining node.
    for(let d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--){
        let spec = $from.node(d).type.spec;
        if (spec.defining || spec.definingAsContext || spec.isolating) break;
        if (targetDepths.indexOf(d) > -1) preferredTarget = d;
        else if ($from.before(d) == pos) targetDepths.splice(1, 0, -d);
    }
    // Try to fit each possible depth of the slice into each possible
    // target depth, starting with the preferred depths.
    let preferredTargetIndex = targetDepths.indexOf(preferredTarget);
    let leftNodes = [], preferredDepth = slice.openStart;
    for(let content = slice.content, i = 0;; i++){
        let node = content.firstChild;
        leftNodes.push(node);
        if (i == slice.openStart) break;
        content = node.content;
    }
    // Back up preferredDepth to cover defining textblocks directly
    // above it, possibly skipping a non-defining textblock.
    for(let d = preferredDepth - 1; d >= 0; d--){
        let leftNode = leftNodes[d], def = $98af50e5743169ae$var$definesContent(leftNode.type);
        if (def && !leftNode.sameMarkup($from.node(Math.abs(preferredTarget) - 1))) preferredDepth = d;
        else if (def || !leftNode.type.isTextblock) break;
    }
    for(let j = slice.openStart; j >= 0; j--){
        let openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
        let insert = leftNodes[openDepth];
        if (!insert) continue;
        for(let i = 0; i < targetDepths.length; i++){
            // Loop over possible expansion levels, starting with the
            // preferred one
            let targetDepth = targetDepths[(i + preferredTargetIndex) % targetDepths.length], expand = true;
            if (targetDepth < 0) {
                expand = false;
                targetDepth = -targetDepth;
            }
            let parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
            if (parent.canReplaceWith(index, index, insert.type, insert.marks)) return tr.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to, new (0, $7dkLM.Slice)($98af50e5743169ae$var$closeFragment(slice.content, 0, slice.openStart, openDepth), openDepth, slice.openEnd));
        }
    }
    let startSteps = tr.steps.length;
    for(let i = targetDepths.length - 1; i >= 0; i--){
        tr.replace(from, to, slice);
        if (tr.steps.length > startSteps) break;
        let depth = targetDepths[i];
        if (depth < 0) continue;
        from = $from.before(depth);
        to = $to.after(depth);
    }
}
function $98af50e5743169ae$var$closeFragment(fragment, depth, oldOpen, newOpen, parent) {
    if (depth < oldOpen) {
        let first = fragment.firstChild;
        fragment = fragment.replaceChild(0, first.copy($98af50e5743169ae$var$closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
    }
    if (depth > newOpen) {
        let match = parent.contentMatchAt(0);
        let start = match.fillBefore(fragment).append(fragment);
        fragment = start.append(match.matchFragment(start).fillBefore((0, $7dkLM.Fragment).empty, true));
    }
    return fragment;
}
function $98af50e5743169ae$var$replaceRangeWith(tr, from, to, node) {
    if (!node.isInline && from == to && tr.doc.resolve(from).parent.content.size) {
        let point = $98af50e5743169ae$export$64cb316d02de1dd1(tr.doc, from, node.type);
        if (point != null) from = to = point;
    }
    tr.replaceRange(from, to, new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(node), 0, 0));
}
function $98af50e5743169ae$var$deleteRange(tr, from, to) {
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    let covered = $98af50e5743169ae$var$coveredDepths($from, $to);
    for(let i = 0; i < covered.length; i++){
        let depth = covered[i], last = i == covered.length - 1;
        if (last && depth == 0 || $from.node(depth).type.contentMatch.validEnd) return tr.delete($from.start(depth), $to.end(depth));
        if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1)))) return tr.delete($from.before(depth), $to.after(depth));
    }
    for(let d = 1; d <= $from.depth && d <= $to.depth; d++){
        if (from - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d) return tr.delete($from.before(d), to);
    }
    tr.delete(from, to);
}
// Returns an array of all depths for which $from - $to spans the
// whole content of the nodes at that depth.
function $98af50e5743169ae$var$coveredDepths($from, $to) {
    let result = [], minDepth = Math.min($from.depth, $to.depth);
    for(let d = minDepth; d >= 0; d--){
        let start = $from.start(d);
        if (start < $from.pos - ($from.depth - d) || $to.end(d) > $to.pos + ($to.depth - d) || $from.node(d).type.spec.isolating || $to.node(d).type.spec.isolating) break;
        if (start == $to.start(d) || d == $from.depth && d == $to.depth && $from.parent.inlineContent && $to.parent.inlineContent && d && $to.start(d - 1) == start - 1) result.push(d);
    }
    return result;
}
/**
Update an attribute in a specific node.
*/ class $98af50e5743169ae$export$626399c38172f669 extends $98af50e5743169ae$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.pos = pos;
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $98af50e5743169ae$export$8ebf1578a4199c09.fail("No node at attribute step's position");
        let attrs = Object.create(null);
        for(let name in node.attrs)attrs[name] = node.attrs[name];
        attrs[this.attr] = this.value;
        let updated = node.type.create(attrs, null, node.marks);
        return $98af50e5743169ae$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    getMap() {
        return $98af50e5743169ae$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $98af50e5743169ae$export$626399c38172f669(this.pos, this.attr, doc.nodeAt(this.pos).attrs[this.attr]);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $98af50e5743169ae$export$626399c38172f669(pos.pos, this.attr, this.value);
    }
    toJSON() {
        return {
            stepType: "attr",
            pos: this.pos,
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.pos != "number" || typeof json.attr != "string") throw new RangeError("Invalid input for AttrStep.fromJSON");
        return new $98af50e5743169ae$export$626399c38172f669(json.pos, json.attr, json.value);
    }
}
$98af50e5743169ae$export$fd55ce593607084a.jsonID("attr", $98af50e5743169ae$export$626399c38172f669);
/**
Update an attribute in the doc node.
*/ class $98af50e5743169ae$export$f50707b396300ac9 extends $98af50e5743169ae$export$fd55ce593607084a {
    /**
    Construct an attribute step.
    */ constructor(/**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.attr = attr;
        this.value = value;
    }
    apply(doc) {
        let attrs = Object.create(null);
        for(let name in doc.attrs)attrs[name] = doc.attrs[name];
        attrs[this.attr] = this.value;
        let updated = doc.type.create(attrs, doc.content, doc.marks);
        return $98af50e5743169ae$export$8ebf1578a4199c09.ok(updated);
    }
    getMap() {
        return $98af50e5743169ae$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $98af50e5743169ae$export$f50707b396300ac9(this.attr, doc.attrs[this.attr]);
    }
    map(mapping) {
        return this;
    }
    toJSON() {
        return {
            stepType: "docAttr",
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.attr != "string") throw new RangeError("Invalid input for DocAttrStep.fromJSON");
        return new $98af50e5743169ae$export$f50707b396300ac9(json.attr, json.value);
    }
}
$98af50e5743169ae$export$fd55ce593607084a.jsonID("docAttr", $98af50e5743169ae$export$f50707b396300ac9);
/**
@internal
*/ let $98af50e5743169ae$export$88cc3a1dfce48dd3 = class extends Error {
};
$98af50e5743169ae$export$88cc3a1dfce48dd3 = function TransformError(message) {
    let err = Error.call(this, message);
    err.__proto__ = TransformError.prototype;
    return err;
};
$98af50e5743169ae$export$88cc3a1dfce48dd3.prototype = Object.create(Error.prototype);
$98af50e5743169ae$export$88cc3a1dfce48dd3.prototype.constructor = $98af50e5743169ae$export$88cc3a1dfce48dd3;
$98af50e5743169ae$export$88cc3a1dfce48dd3.prototype.name = "TransformError";
/**
Abstraction to build up and track an array of
[steps](https://prosemirror.net/docs/ref/#transform.Step) representing a document transformation.

Most transforming methods return the `Transform` object itself, so
that they can be chained.
*/ class $98af50e5743169ae$export$563a914cafbdc389 {
    /**
    Create a transform that starts with the given document.
    */ constructor(/**
    The current document (the result of applying the steps in the
    transform).
    */ doc){
        this.doc = doc;
        /**
        The steps in this transform.
        */ this.steps = [];
        /**
        The documents before each of the steps.
        */ this.docs = [];
        /**
        A mapping with the maps for each of the steps in this transform.
        */ this.mapping = new $98af50e5743169ae$export$f5f785078011b62;
    }
    /**
    The starting document.
    */ get before() {
        return this.docs.length ? this.docs[0] : this.doc;
    }
    /**
    Apply a new step in this transform, saving the result. Throws an
    error when the step fails.
    */ step(step) {
        let result = this.maybeStep(step);
        if (result.failed) throw new $98af50e5743169ae$export$88cc3a1dfce48dd3(result.failed);
        return this;
    }
    /**
    Try to apply a step in this transformation, ignoring it if it
    fails. Returns the step result.
    */ maybeStep(step) {
        let result = step.apply(this.doc);
        if (!result.failed) this.addStep(step, result.doc);
        return result;
    }
    /**
    True when the document has been changed (when there are any
    steps).
    */ get docChanged() {
        return this.steps.length > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        this.docs.push(this.doc);
        this.steps.push(step);
        this.mapping.appendMap(step.getMap());
        this.doc = doc;
    }
    /**
    Replace the part of the document between `from` and `to` with the
    given `slice`.
    */ replace(from, to = from, slice = (0, $7dkLM.Slice).empty) {
        let step = $98af50e5743169ae$export$ed6ac67359824afd(this.doc, from, to, slice);
        if (step) this.step(step);
        return this;
    }
    /**
    Replace the given range with the given content, which may be a
    fragment, node, or array of nodes.
    */ replaceWith(from, to, content) {
        return this.replace(from, to, new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(content), 0, 0));
    }
    /**
    Delete the content between the given positions.
    */ delete(from, to) {
        return this.replace(from, to, (0, $7dkLM.Slice).empty);
    }
    /**
    Insert the given content at the given position.
    */ insert(pos, content) {
        return this.replaceWith(pos, pos, content);
    }
    /**
    Replace a range of the document with a given slice, using
    `from`, `to`, and the slice's
    [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
    than fixed start and end points. This method may grow the
    replaced area or close open nodes in the slice in order to get a
    fit that is more in line with WYSIWYG expectations, by dropping
    fully covered parent nodes of the replaced region when they are
    marked [non-defining as
    context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
    open parent node from the slice that _is_ marked as [defining
    its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
    
    This is the method, for example, to handle paste. The similar
    [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
    primitive tool which will _not_ move the start and end of its given
    range, and is useful in situations where you need more precise
    control over what happens.
    */ replaceRange(from, to, slice) {
        $98af50e5743169ae$var$replaceRange(this, from, to, slice);
        return this;
    }
    /**
    Replace the given range with a node, but use `from` and `to` as
    hints, rather than precise positions. When from and to are the same
    and are at the start or end of a parent node in which the given
    node doesn't fit, this method may _move_ them out towards a parent
    that does allow the given node to be placed. When the given range
    completely covers a parent node, this method may completely replace
    that parent node.
    */ replaceRangeWith(from, to, node) {
        $98af50e5743169ae$var$replaceRangeWith(this, from, to, node);
        return this;
    }
    /**
    Delete the given range, expanding it to cover fully covered
    parent nodes until a valid replace is found.
    */ deleteRange(from, to) {
        $98af50e5743169ae$var$deleteRange(this, from, to);
        return this;
    }
    /**
    Split the content in the given range off from its parent, if there
    is sibling content before or after it, and move it up the tree to
    the depth specified by `target`. You'll probably want to use
    [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
    sure the lift is valid.
    */ lift(range, target) {
        $98af50e5743169ae$var$lift(this, range, target);
        return this;
    }
    /**
    Join the blocks around the given position. If depth is 2, their
    last and first siblings are also joined, and so on.
    */ join(pos, depth = 1) {
        $98af50e5743169ae$var$join(this, pos, depth);
        return this;
    }
    /**
    Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
    The wrappers are assumed to be valid in this position, and should
    probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
    */ wrap(range, wrappers) {
        $98af50e5743169ae$var$wrap(this, range, wrappers);
        return this;
    }
    /**
    Set the type of all textblocks (partly) between `from` and `to` to
    the given node type with the given attributes.
    */ setBlockType(from, to = from, type, attrs = null) {
        $98af50e5743169ae$var$setBlockType(this, from, to, type, attrs);
        return this;
    }
    /**
    Change the type, attributes, and/or marks of the node at `pos`.
    When `type` isn't given, the existing node type is preserved,
    */ setNodeMarkup(pos, type, attrs = null, marks) {
        $98af50e5743169ae$var$setNodeMarkup(this, pos, type, attrs, marks);
        return this;
    }
    /**
    Set a single attribute on a given node to a new value.
    The `pos` addresses the document content. Use `setDocAttribute`
    to set attributes on the document itself.
    */ setNodeAttribute(pos, attr, value) {
        this.step(new $98af50e5743169ae$export$626399c38172f669(pos, attr, value));
        return this;
    }
    /**
    Set a single attribute on the document to a new value.
    */ setDocAttribute(attr, value) {
        this.step(new $98af50e5743169ae$export$f50707b396300ac9(attr, value));
        return this;
    }
    /**
    Add a mark to the node at position `pos`.
    */ addNodeMark(pos, mark) {
        this.step(new $98af50e5743169ae$export$adefd16c402fee4e(pos, mark));
        return this;
    }
    /**
    Remove a mark (or a mark of the given type) from the node at
    position `pos`.
    */ removeNodeMark(pos, mark) {
        if (!(mark instanceof (0, $7dkLM.Mark))) {
            let node = this.doc.nodeAt(pos);
            if (!node) throw new RangeError("No node at position " + pos);
            mark = mark.isInSet(node.marks);
            if (!mark) return this;
        }
        this.step(new $98af50e5743169ae$export$fdf7d1dc10724da2(pos, mark));
        return this;
    }
    /**
    Split the node at the given position, and optionally, if `depth` is
    greater than one, any number of nodes above that. By default, the
    parts split off will inherit the node type of the original node.
    This can be changed by passing an array of types and attributes to
    use after the split.
    */ split(pos, depth = 1, typesAfter) {
        $98af50e5743169ae$var$split(this, pos, depth, typesAfter);
        return this;
    }
    /**
    Add the given mark to the inline content between `from` and `to`.
    */ addMark(from, to, mark) {
        $98af50e5743169ae$var$addMark(this, from, to, mark);
        return this;
    }
    /**
    Remove marks from inline nodes between `from` and `to`. When
    `mark` is a single mark, remove precisely that mark. When it is
    a mark type, remove all marks of that type. When it is null,
    remove all marks of any type.
    */ removeMark(from, to, mark) {
        $98af50e5743169ae$var$removeMark(this, from, to, mark);
        return this;
    }
    /**
    Removes all marks and nodes from the content of the node at
    `pos` that don't match the given new parent node type. Accepts
    an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
    third argument.
    */ clearIncompatible(pos, parentType, match) {
        $98af50e5743169ae$var$clearIncompatible(this, pos, parentType, match);
        return this;
    }
}

});



parcelRegister("jLo5a", function(module, exports) {

$parcel$export(module.exports, "BODIED_EXT_PADDING", () => $7d6512c53e3e5450$export$5ac5087fe1217160);
$parcel$export(module.exports, "BODIED_EXT_MBE_MARGIN_TOP", () => $7d6512c53e3e5450$export$91624ec52c59c24c);
const $7d6512c53e3e5450$export$f5ecdce4c60ff98b = 8;
const $7d6512c53e3e5450$export$5ac5087fe1217160 = $7d6512c53e3e5450$export$f5ecdce4c60ff98b * 2;
const $7d6512c53e3e5450$export$91624ec52c59c24c = 12;

});

parcelRegister("jySns", function(module, exports) {

$parcel$export(module.exports, "LAYOUT_SECTION_MARGIN", () => $b3681f0378a2ce4f$export$cd04f19842abff0);
$parcel$export(module.exports, "LAYOUT_COLUMN_PADDING", () => $b3681f0378a2ce4f$export$a1bb91aa2d5fcce8);
const $b3681f0378a2ce4f$export$cd04f19842abff0 = 8;
const $b3681f0378a2ce4f$export$a1bb91aa2d5fcce8 = $b3681f0378a2ce4f$export$cd04f19842abff0 * 1.5;

});


parcelRegister("9pV0l", function(module, exports) {

$parcel$export(module.exports, "FullPagePadding", () => $224cbf506e249e6d$export$12fd658e5eef0d79);
$parcel$export(module.exports, "TELEPOINTER_ID", () => $224cbf506e249e6d$export$74b525449cc7cbd1);
$parcel$export(module.exports, "rendererStyles", () => $224cbf506e249e6d$export$1c4377249312209);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $lcnyw = parcelRequire("lcnyw");

var $PdmhA = parcelRequire("PdmhA");

var $4lTFP = parcelRequire("4lTFP");

var $juktg = parcelRequire("juktg");

var $33dUZ = parcelRequire("33dUZ");

var $1TZMa = parcelRequire("1TZMa");
var $i2OhI = parcelRequire("i2OhI");
var $9x5mm = parcelRequire("9x5mm");
var $9SSfJ = parcelRequire("9SSfJ");
var $6GESD = parcelRequire("6GESD");
var $3CrqS = parcelRequire("3CrqS");
var $izEcn = parcelRequire("izEcn");
var $hp7YN = parcelRequire("hp7YN");
var $8VeKB = parcelRequire("8VeKB");
var $juoPd = parcelRequire("juoPd");
var $dMNGz = parcelRequire("dMNGz");
var $bLfPF = parcelRequire("bLfPF");
var $fPB6q = parcelRequire("fPB6q");
var $c1Qps = parcelRequire("c1Qps");
var $cDyCO = parcelRequire("cDyCO");
var $mJhHc = parcelRequire("mJhHc");
var $6lAd7 = parcelRequire("6lAd7");
var $lGBd6 = parcelRequire("lGBd6");
var $eJ4TL = parcelRequire("eJ4TL");

var $8AkRK = parcelRequire("8AkRK");
var $1JeZT = parcelRequire("1JeZT");

var $jMQbs = parcelRequire("jMQbs");

var $25FYC = parcelRequire("25FYC");

var $ghgHw = parcelRequire("ghgHw");

var $dMrTV = parcelRequire("dMrTV");

var $igoil = parcelRequire("igoil");

var $5hibD = parcelRequire("5hibD");

const $224cbf506e249e6d$export$12fd658e5eef0d79 = 32;
const $224cbf506e249e6d$var$tableShadowWidth = 32;
const $224cbf506e249e6d$export$74b525449cc7cbd1 = 'ai-streaming-telepointer';
const $224cbf506e249e6d$var$telepointerStyles = (colorMode)=>{
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $byn9U.css)("#", $224cbf506e249e6d$export$74b525449cc7cbd1, "{display:inline-block;position:relative;width:1.5px;height:25px;background:linear-gradient(\n\t\t\t\t45deg,\n\t\t\t\t", colorMode === 'dark' ? '#f5cd47' : '#f8e6a0', " -12.02%,\n\t\t\t\t", colorMode === 'dark' ? '#60c6d2' : '#8bdbe5', " 19.18%,\n\t\t\t\t", colorMode === 'dark' ? '#388bff' : '#0c66e4', " 71.87%\n\t\t\t);margin-left:var(--ds-space-025, 2px);&::after{content:'AI';position:absolute;display:block;top:0;left:0;font-size:10px;font-weight:700;width:12.5px;height:13px;padding-top:1px;padding-left:1.5px;line-height:initial;border-radius:0px 2px 2px 0px;color:var(--ds-text-inverse, white);background:linear-gradient(\n\t\t\t\t\t45deg,\n\t\t\t\t\t", colorMode === 'dark' ? '#60c6d2' : '#8bdbe5', " -57%,\n\t\t\t\t\t", colorMode === 'dark' ? '#388bff' : '#0c66e4', " 71.87%\n\t\t\t\t);}}");
};
const $224cbf506e249e6d$var$getLineHeight = (fontCode)=>(0, $4lTFP.headingSizes)[fontCode].lineHeight / (0, $4lTFP.headingSizes)[fontCode].size;
const $224cbf506e249e6d$export$bc02e067df412c3b = {
    h1: {
        lineHeight: $224cbf506e249e6d$var$getLineHeight('h700')
    },
    h2: {
        lineHeight: $224cbf506e249e6d$var$getLineHeight('h600')
    },
    h3: {
        lineHeight: $224cbf506e249e6d$var$getLineHeight('h500')
    },
    h4: {
        lineHeight: $224cbf506e249e6d$var$getLineHeight('h400')
    },
    h5: {
        lineHeight: $224cbf506e249e6d$var$getLineHeight('h300')
    },
    h6: {
        lineHeight: $224cbf506e249e6d$var$getLineHeight('h100')
    }
};
const $224cbf506e249e6d$var$headingAnchorStyle = (headingTag)=>/*#__PURE__*/ // TODO Delete this comment after verifying space token -> previous value `margin-left: 6px`
    (0, $byn9U.css)(".", (0, $dMrTV.HeadingAnchorWrapperClassName), "{position:absolute;height:", $224cbf506e249e6d$export$bc02e067df412c3b[headingTag].lineHeight, "em;margin-left:var(--ds-space-075, 6px);button{padding-left:0;padding-right:0;}}/**\n     * Applies hover effects to the heading anchor link button\n     * to fade in when the user rolls over the heading.\n     *\n     * The link is persistent on mobile, so we use feature detection\n     * to enable hover effects for systems that support it (desktop).\n     *\n     * @see https://caniuse.com/mdn-css_at-rules_media_hover\n     */@media (hover: hover) and (pointer: fine){.", (0, $dMrTV.HeadingAnchorWrapperClassName), "{>button{opacity:0;transform:translate(-8px, 0px);transition:opacity 0.2s ease 0s,transform 0.2s ease 0s;}}&:hover{.", (0, $dMrTV.HeadingAnchorWrapperClassName), ">button{opacity:1;transform:none!important;}}}.", (0, $dMrTV.HeadingAnchorWrapperClassName), "{button:focus{opacity:1;transform:none!important;}}");
const $224cbf506e249e6d$var$alignedHeadingAnchorStyle = ({ allowNestedHeaderLinks: allowNestedHeaderLinks })=>{
    if (!allowNestedHeaderLinks) return '';
    // TODO Delete this comment after verifying space token -> previous value `margin: 6px`
    return /*#__PURE__*/ (0, $byn9U.css)(".fabric-editor-block-mark[data-align]>{h1,h2,h3,h4,h5,h6{position:relative;}}.fabric-editor-block-mark:not([data-align='center'])[data-align]{.", (0, $dMrTV.HeadingAnchorWrapperClassName), "{margin:0 var(--ds-space-075, 6px) 0 0;transform:translateX(calc(-100% - var(--ds-space-075, 6px)));}@media (hover: hover) and (pointer: fine){.", (0, $dMrTV.HeadingAnchorWrapperClassName), ">button{transform:translate(8px, 0px);}}}");
};
const $224cbf506e249e6d$var$tableSortableColumnStyle = ({ allowColumnSorting: allowColumnSorting, allowNestedHeaderLinks: allowNestedHeaderLinks })=>{
    if (!allowColumnSorting) return '';
    let headingsCss = '';
    if (allowNestedHeaderLinks) headingsCss = `
      /**
       * When the sort button is enabled we want the heading's copy link button
       * to reserve space so that it can prematurely wrap to avoid the button
       * being displayed underneath the sort button (hidden or obscured).
       *
       * The two buttons fight each other since the sort button is displayed
       * on hover of the <th /> and the copy link button is displayed on hover
       * of the heading.
       *
       * Note that this can break the WYSIWYG experience in the case where
       * a heading fills the width of the table cell and the only thing which
       * wraps is the copy link button. This is hopefully a rare fringe case.
       */
      .${0, $dMrTV.HeadingAnchorWrapperClassName} {
        position: unset;
      }
      > {
        h1, h2, h3, h4, h5, h6 {
          margin-right: 30px;
        }
      }
    `;
    return /*#__PURE__*/ (0, $byn9U.css)(".", (0, $ghgHw.RendererCssClassName).SORTABLE_COLUMN_WRAPPER, "{padding:0;.", (0, $ghgHw.RendererCssClassName).SORTABLE_COLUMN, "{width:100%;height:100%;padding:", (0, $XHGTv.fg)('platform_editor_tables_padding_increase') ? `${0, $mJhHc.tableCellPadding}px ${"var(--ds-space-250, 20px)"}` : `${0, $mJhHc.tableCellPadding}px`, ";border-width:1.5px;border-style:solid;border-color:transparent;", headingsCss, ";>*:first-child{margin-top:0;}>.ProseMirror-gapcursor:first-child+*,>style:first-child+.ProseMirror-gapcursor+*{margin-top:0;}>.ProseMirror-gapcursor:first-child+span+*,>style:first-child+.ProseMirror-gapcursor+span+*{margin-top:0;}@supports selector(:focus-visible){&:focus{outline:unset;}&:focus-visible{border-color:", `var(--ds-border-focused, ${$PdmhA.B300})`, ";}}}.", (0, $ghgHw.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER, "{margin:0;.", (0, $2965d2199c43f228$export$bd4f24d8b1e86b23), "{opacity:1;transition:opacity 0.2s ease-in-out;}}.", (0, $ghgHw.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER, "{.", (0, $2965d2199c43f228$export$bd4f24d8b1e86b23), "{opacity:0;&:focus{opacity:1;}}}&:hover{.", (0, $ghgHw.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER, "{.", (0, $2965d2199c43f228$export$bd4f24d8b1e86b23), "{opacity:1;}}}}");
};
const $224cbf506e249e6d$var$fullPageStyles = ({ appearance: appearance }, { theme: theme })=>{
    if (appearance !== 'full-page' && appearance !== 'mobile') return '';
    return /*#__PURE__*/ (0, $byn9U.css)("max-width:", theme && theme.layoutMaxWidth ? `${theme.layoutMaxWidth}px` : 'none', ";margin:0 auto;padding:0 ", appearance === 'full-page' ? $224cbf506e249e6d$export$12fd658e5eef0d79 : 0, "px;");
};
const $224cbf506e249e6d$var$fullWidthStyles = ({ appearance: appearance })=>{
    if (appearance !== 'full-width') return '';
    return /*#__PURE__*/ (0, $byn9U.css)("max-width:", (0, $25FYC.akEditorFullWidthLayoutWidth), "px;margin:0 auto;.fabric-editor-breakout-mark,.ak-renderer-extension{width:100%!important;}", (0, $5hibD.isTableResizingEnabled)(appearance) ? '' : `
      .pm-table-container {
        width: 100% !important;
      }
    `, ";");
};
const $224cbf506e249e6d$var$breakoutWidthStyle = ()=>{
    return /*#__PURE__*/ (0, $byn9U.css)("*:not([data-mark-type='fragment']) .", (0, $mJhHc.TableSharedCssClassName).TABLE_CONTAINER, "{width:100%!important;left:0!important;}[data-mark-type='fragment'] * .", (0, $mJhHc.TableSharedCssClassName).TABLE_CONTAINER, "{width:100%!important;left:0!important;}");
};
const $224cbf506e249e6d$var$getShadowOverrides = ()=>{
    return /*#__PURE__*/ (0, $byn9U.css)("&.", (0, $8AkRK.shadowClassNames).RIGHT_SHADOW, "::after,&.", (0, $8AkRK.shadowClassNames).LEFT_SHADOW, "::before{width:", $224cbf506e249e6d$var$tableShadowWidth, "px;background:linear-gradient(\n\t\t\t\t\tto left,\n\t\t\t\t\ttransparent 0,\n\t\t\t\t\t", `var(--ds-shadow-overflow-spread, ${(0, $PdmhA.N40A)})`, " 140%\n\t\t\t\t),linear-gradient(\n\t\t\t\t\tto right,\n\t\t\t\t\tvar(--ds-shadow-overflow-perimeter, transparent) 0px,\n\t\t\t\t\ttransparent 1px\n\t\t\t\t);}&.", (0, $8AkRK.shadowClassNames).RIGHT_SHADOW, "::after{background:linear-gradient(\n\t\t\t\t\tto right,\n\t\t\t\t\ttransparent 0,\n\t\t\t\t\t", `var(--ds-shadow-overflow-spread, ${(0, $PdmhA.N40A)})`, " 140%\n\t\t\t\t),linear-gradient(\n\t\t\t\t\tto left,\n\t\t\t\t\tvar(--ds-shadow-overflow-perimeter, transparent) 0px,\n\t\t\t\t\ttransparent 1px\n\t\t\t\t);right:0px;}");
};
function $224cbf506e249e6d$var$getAnnotationStyles({ allowAnnotations: allowAnnotations }) {
    if (!(0, $XHGTv.fg)('platform.editor.allow-inline-comments-for-inline-nodes')) return '';
    if ((0, $XHGTv.fg)('platform.editor.allow-inline-comments-for-inline-nodes-round-2_ctuxz')) return '';
    return /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        "& [data-mark-type='annotation'][data-mark-annotation-state='active'] [data-annotation-mark], & [data-annotation-draft-mark][data-annotation-inline-node]": {
            background: `var(--ds-background-accent-yellow-subtler, ${(0, $PdmhA.Y75)})`,
            borderBottom: `2px solid ${`var(--ds-border-accent-yellow, ${(0, $PdmhA.Y300)})`}`,
            boxShadow: `var(--ds-shadow-overlay, ${`1px 2px 3px ${(0, $PdmhA.N60A)}, -1px 2px 3px ${(0, $PdmhA.N60A)}`})`,
            cursor: 'pointer',
            padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-025, 2px)"}`
        }
    });
}
const $224cbf506e249e6d$export$1c4377249312209 = (wrapperProps)=>(theme)=>{
        const { colorMode: colorMode } = (0, $juktg.default)();
        // This is required to be compatible with styled-components prop structure.
        const themeProps = {
            theme: theme
        };
        const { useBlockRenderForCodeBlock: useBlockRenderForCodeBlock } = wrapperProps;
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/design-system/no-css-tagged-template-expression
        return /*#__PURE__*/ (0, $byn9U.css)("font-size:", (0, $25FYC.editorFontSize)(themeProps), "px;line-height:1.5rem;color:", `var(--ds-text, ${$PdmhA.N800})`, ";.", (0, $ghgHw.RendererCssClassName).DOCUMENT, "::after{content:'';visibility:hidden;display:block;height:0;clear:both;}", $224cbf506e249e6d$var$fullPageStyles(wrapperProps, themeProps), " ", $224cbf506e249e6d$var$fullWidthStyles(wrapperProps), " .", (0, $ghgHw.RendererCssClassName).DOCUMENT, "{", (0, $33dUZ.mediaInlineImageStyles), ";}& h1{", $224cbf506e249e6d$var$headingAnchorStyle('h1'), ";}& h2{", $224cbf506e249e6d$var$headingAnchorStyle('h2'), ";}& h3{", $224cbf506e249e6d$var$headingAnchorStyle('h3'), ";}& h4{", $224cbf506e249e6d$var$headingAnchorStyle('h4'), ";}& h5{", $224cbf506e249e6d$var$headingAnchorStyle('h5'), ";}& h6{", $224cbf506e249e6d$var$headingAnchorStyle('h6'), ";}& span.akActionMark{color:", `var(--ds-link, ${$PdmhA.B400})`, ";text-decoration:none;&:hover{color:", `var(--ds-link, ${$PdmhA.B300})`, ";text-decoration:underline;}&:active{color:", `var(--ds-link-pressed, ${$PdmhA.B500})`, ";}}& span.akActionMark{cursor:pointer;}& span[data-placeholder]{color:", `var(--ds-text-subtlest, ${$PdmhA.N200})`, ";}", $224cbf506e249e6d$var$telepointerStyles(colorMode), " ", (0, $eJ4TL.whitespaceSharedStyles), ";", (0, $9x5mm.blockquoteSharedStyles), ";", (0, $hp7YN.headingsSharedStyles)(), ";", (0, $fPB6q.ruleSharedStyles)(), ";", (0, $bLfPF.paragraphSharedStyles), ";", (0, $juoPd.listsSharedStyles), ";", (0, $8VeKB.indentationSharedStyles), ";", (0, $i2OhI.blockMarksSharedStyles), ";", (0, $6GESD.codeMarkSharedStyles)(), ";", (0, $c1Qps.shadowSharedStyle), ";", (0, $izEcn.dateSharedStyle), ";", (0, $lGBd6.textColorStyles), ";", (0, $1TZMa.backgroundColorStyles)(), ";", (0, $6lAd7.tasksAndDecisionsStyles), ";", (0, $cDyCO.smartCardSharedStyles), " ", $224cbf506e249e6d$var$getAnnotationStyles(wrapperProps), " & .UnknownBlock{font-family:", (0, $lcnyw.fontFamily)(), ";font-size:", (0, $25FYC.relativeFontSizeToBase16)((0, $lcnyw.fontSize)()), ";font-weight:400;white-space:pre-wrap;word-wrap:break-word;}& span.date-node{background:", `var(--ds-background-neutral, ${$PdmhA.N30A})`, ";border-radius:var(--ds-border-radius-100, 3px);color:", `var(--ds-text, ${$PdmhA.N800})`, ";padding:var(--ds-space-025, 2px) var(--ds-space-050, 4px);margin:0 1px;transition:background 0.3s;}& span.date-node-highlighted{background:", `var(--ds-background-danger, ${$PdmhA.R50})`, ";color:", `var(--ds-text-danger, ${$PdmhA.R500})`, ";}& .renderer-image{max-width:100%;display:block;margin:var(--ds-space-300, 24px) 0;}.", (0, $dMNGz.richMediaClassName), ".rich-media-wrapped+.", (0, $dMNGz.richMediaClassName), ":not(.rich-media-wrapped){clear:both;}& .code-block,& blockquote,& hr,&>div>div:not(.rich-media-wrapped),.", (0, $dMNGz.richMediaClassName), ".rich-media-wrapped+.rich-media-wrapped+*:not(.rich-media-wrapped),.", (0, $dMNGz.richMediaClassName), ".rich-media-wrapped+div:not(.rich-media-wrapped),.", (0, $dMNGz.richMediaClassName), ".image-align-start,.", (0, $dMNGz.richMediaClassName), ".image-center,.", (0, $dMNGz.richMediaClassName), ".image-align-end{clear:both;}& .rich-media-wrapped{&+h1,&+h2,&+h3,&+h4,&+h5,&+h6{margin-top:var(--ds-space-100, 8px);}}", $224cbf506e249e6d$var$alignedHeadingAnchorStyle(wrapperProps), (0, $dMNGz.mediaSingleSharedStyle), " & div[class^='image-wrap-']+div[class^='image-wrap-']{margin-left:0;margin-right:0;}.", (0, $ghgHw.RendererCssClassName).DOCUMENT, ">{", $224cbf506e249e6d$var$breakoutWidthStyle(), " * .", (0, $ghgHw.RendererCssClassName).EXTENSION_OVERFLOW_CONTAINER, "{overflow-x:auto;}& .", (0, $ghgHw.RendererCssClassName).EXTENSION, ":first-child{margin-top:0;}}.", (0, $ghgHw.RendererCssClassName).DOCUMENT, "{.", (0, $ghgHw.RendererCssClassName).EXTENSION, "{margin-top:", (0, $25FYC.blockNodesVerticalMargin), ";}.", (0, $ghgHw.RendererCssClassName).EXTENSION_CENTER_ALIGN, "{margin-left:50%;transform:translateX(-50%);}.", (0, $mJhHc.TableSharedCssClassName).TABLE_NODE_WRAPPER, "{overflow-x:auto;}.", (0, $1JeZT.shadowObserverClassNames).SHADOW_CONTAINER, " .", (0, $mJhHc.TableSharedCssClassName).TABLE_NODE_WRAPPER, "{display:flex;}}", (0, $mJhHc.tableSharedStyle)(), " .", (0, $ghgHw.RendererCssClassName).DOCUMENT, " .", (0, $mJhHc.TableSharedCssClassName).TABLE_CONTAINER, "{z-index:0;transition:all 0.1s linear;display:flex;&.", (0, $8AkRK.shadowClassNames).RIGHT_SHADOW, "::after,&.", (0, $8AkRK.shadowClassNames).LEFT_SHADOW, "::before{top:", (0, $mJhHc.tableMarginTop) - 1, "px;height:calc(100% - ", (0, $mJhHc.tableMarginTop), "px);z-index:", (0, $25FYC.akEditorStickyHeaderZIndex), ";}", $224cbf506e249e6d$var$getShadowOverrides(), " & .", (0, $1JeZT.shadowObserverClassNames).SENTINEL_LEFT, ",& .", (0, $1JeZT.shadowObserverClassNames).SENTINEL_RIGHT, "{height:calc(100% - ", (0, $mJhHc.tableMarginTop), "px);}table{height:1px;", $224cbf506e249e6d$var$tableSortableColumnStyle(wrapperProps), ";margin-left:0;margin-right:0;}table tr:first-of-type{height:100%;td,th{position:relative;}}table[data-number-column='true']{.", (0, $ghgHw.RendererCssClassName).NUMBER_COLUMN, "{background-color:", `var(--ds-background-neutral, ${(0, $25FYC.akEditorTableToolbar)})`, ";border-right:1px solid ", `var(--ds-background-accent-gray-subtler, ${(0, $25FYC.akEditorTableBorder)})`, ";width:", (0, $25FYC.akEditorTableNumberColumnWidth), "px;text-align:center;color:", `var(--ds-text-subtlest, ${$PdmhA.N200})`, ";font-size:", (0, $25FYC.relativeFontSizeToBase16)((0, $lcnyw.fontSize)()), ";}.fixed .", (0, $ghgHw.RendererCssClassName).NUMBER_COLUMN, "{border-right:0px none;}}}tr[data-header-row].fixed{position:fixed!important;display:flex;overflow:hidden;z-index:", (0, $25FYC.akEditorStickyHeaderZIndex), ";border-right:1px solid ", `var(--ds-background-accent-gray-subtler, ${(0, $25FYC.akEditorTableBorder)})`, ";border-bottom:1px solid ", `var(--ds-background-accent-gray-subtler, ${(0, $25FYC.akEditorTableBorder)})`, ";transform:translateX(-1px);}.sticky>th{z-index:", (0, $25FYC.akEditorStickyHeaderZIndex), ";position:sticky!important;top:0;}.sticky>td{position:sticky!important;top:0;}.sticky th,.sticky td{box-shadow:0px 1px ", `var(--ds-background-accent-gray-subtler, ${(0, $25FYC.akEditorTableBorder)})`, ",0px -0.5px ", `var(--ds-background-accent-gray-subtler, ${(0, $25FYC.akEditorTableBorder)})`, ",inset -1px 0px ", `var(--ds-background-accent-gray-subtler, ${(0, $25FYC.akEditorTableToolbar)})`, ",0px -1px ", `var(--ds-background-accent-gray-subtler, ${(0, $25FYC.akEditorTableToolbar)})`, ";}.fixed+tr{min-height:0px;}& .code-block{max-width:100%;display:block;position:relative;border-radius:var(--ds-border-radius-100, 3px);word-wrap:normal;}& .MediaGroup,& .code-block{margin-top:", (0, $25FYC.blockNodesVerticalMargin), ";&:first-child{margin-top:0;}}", $224cbf506e249e6d$var$useGridRenderForCodeBlock(useBlockRenderForCodeBlock), " ", (0, $igoil.getLightWeightCodeBlockStylesForRootRendererStyleSheet)(), " ", (0, $3CrqS.columnLayoutSharedStyle), ";& [data-layout-section]{margin-top:var(--ds-space-250, 20px);&>div+div{margin-left:var(--ds-space-400, 32px);}@media screen and (max-width: ", (0, $25FYC.gridMediumMaxWidth), "px){&>div+div{margin-left:0;}}& .MediaGroup,& .code-block{margin-top:", (0, $25FYC.blockNodesVerticalMargin), ";&:first-child{margin-top:0;}}}& li{>.code-block{margin:", (0, $25FYC.blockNodesVerticalMargin), " 0 0 0;}>.code-block:first-child{margin-top:0;}>div:last-of-type.code-block{margin-bottom:", (0, $25FYC.blockNodesVerticalMargin), ";}}&:not([data-node-type='decisionList'])>li,&:not(.", (0, $cDyCO.SmartCardSharedCssClassName).BLOCK_CARD_CONTAINER, ")>li{", (0, $jMQbs.default).safari ? (0, $9SSfJ.codeBlockInListSafariFix) : '', ";}");
    };
const $224cbf506e249e6d$var$useGridRenderForCodeBlock = (codeBlockRenderAsBlock)=>{
    if (codeBlockRenderAsBlock) return '';
    return `& .code-block {
       /* -ms- properties are necessary until MS supports the latest version of the grid spec */
       /* stylelint-disable value-no-vendor-prefix, declaration-block-no-duplicate-properties */
       display: -ms-grid;
       display: grid;
       -ms-grid-columns: auto 1fr;
       /* stylelint-enable */

       grid-template-columns: minmax(0, 1fr);

       & > span {
         /* stylelint-disable value-no-vendor-prefix */
         -ms-grid-row: 1;
         -ms-grid-column: 2;
         /* stylelint-enable */
         grid-column: 1;
       }
     }`;
};

});
parcelRegister("33dUZ", function(module, exports) {

$parcel$export(module.exports, "INLINE_IMAGE_WRAPPER_CLASS_NAME", () => $0e005f327ee86521$export$dd2e16f83ae6aa78);
$parcel$export(module.exports, "INLINE_IMAGE_ASPECT_RATIO_CSS_VAR_KEY", () => $0e005f327ee86521$export$7ab34e219ce6eef);
$parcel$export(module.exports, "INLINE_IMAGE_BORDER_SIZE_CSS_VAR_KEY", () => $0e005f327ee86521$export$263a8a844c370a89);
$parcel$export(module.exports, "INLINE_IMAGE_BORDER_COLOR_CSS_VAR_KEY", () => $0e005f327ee86521$export$b0d1f1e1fb3c4b46);
$parcel$export(module.exports, "mediaInlineImageStyles", () => $0e005f327ee86521$export$dee15762144889b7);
$parcel$export(module.exports, "wrapperStyle", () => $0e005f327ee86521$export$c4d4f06a25de97f);
$parcel$export(module.exports, "selectedStyle", () => $0e005f327ee86521$export$a7abb1b3dc25813f);
$parcel$export(module.exports, "interactiveStyle", () => $0e005f327ee86521$export$ac950970e139031e);
$parcel$export(module.exports, "borderStyle", () => $0e005f327ee86521$export$4d0a7f76ad443516);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $2OD79 = parcelRequire("2OD79");
function $0e005f327ee86521$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0e005f327ee86521$export$dd2e16f83ae6aa78 = 'media-inline-image-wrapper';
const $0e005f327ee86521$export$7ab34e219ce6eef = '--editor-media-inline-image-aspect-ratio';
const $0e005f327ee86521$export$263a8a844c370a89 = '--editor-media-inline-image-border-size';
const $0e005f327ee86521$export$b0d1f1e1fb3c4b46 = '--editor-media-inline-image-border-color';
// We implemented such selectors to ensure specificity:
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Nested and dynamic css calls are violations, needs manual remediation
const $0e005f327ee86521$var$inlineImageHeight = (height, margin = 0)=>/*#__PURE__*/ (0, $byn9U.css)(">.mediaInlineView-content-wrap>.", $0e005f327ee86521$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .mediaInlineView-content-wrap>.", $0e005f327ee86521$export$dd2e16f83ae6aa78, ",>.", $0e005f327ee86521$export$dd2e16f83ae6aa78, ",>:is(a, span[data-mark-type='border']) .", $0e005f327ee86521$export$dd2e16f83ae6aa78, "{height:", height, "px;transform:translateY(", margin, "px);}");
const $0e005f327ee86521$export$dee15762144889b7 = /*#__PURE__*/ (0, $byn9U.css)(".", $0e005f327ee86521$export$dd2e16f83ae6aa78, "{height:", (0, $2OD79.referenceHeights)['p'], "px;transform:translateY(-2px);}h1{", $0e005f327ee86521$var$inlineImageHeight((0, $2OD79.referenceHeights)['h1'], -3), ";}h2{", $0e005f327ee86521$var$inlineImageHeight((0, $2OD79.referenceHeights)['h2'], -3), ";}h3{", $0e005f327ee86521$var$inlineImageHeight((0, $2OD79.referenceHeights)['h3'], -2), ";}h4{", $0e005f327ee86521$var$inlineImageHeight((0, $2OD79.referenceHeights)['h4'], -2), ";}h5{", $0e005f327ee86521$var$inlineImageHeight((0, $2OD79.referenceHeights)['h5'], -2), ";}h6{", $0e005f327ee86521$var$inlineImageHeight((0, $2OD79.referenceHeights)['h6'], -2), ";}");
const $0e005f327ee86521$export$c4d4f06a25de97f = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    verticalAlign: 'middle',
    overflow: 'hidden',
    borderRadius: `${"var(--ds-border-radius, 3px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    aspectRatio: `var(${$0e005f327ee86521$export$7ab34e219ce6eef}, ${(0, $2OD79.DEFAULT_INLINE_IMAGE_ASPECT_RATIO)})`,
    maxWidth: '100%'
});
const $0e005f327ee86521$export$a7abb1b3dc25813f = /*#__PURE__*/ (0, $byn9U.css)({
    cursor: 'pointer',
    boxShadow: `0 0 0 1px ${`var(--ds-border-selected, ${(0, $PdmhA.B300)})`}`,
    outline: 'none'
});
const $0e005f327ee86521$export$ac950970e139031e = {
    name: "e0dnmk",
    styles: "cursor:pointer"
};
const $0e005f327ee86521$export$4d0a7f76ad443516 = /*#__PURE__*/ (0, $byn9U.css)({
    borderColor: `var(${$0e005f327ee86521$export$b0d1f1e1fb3c4b46})`,
    borderStyle: 'solid',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `calc(var(${$0e005f327ee86521$export$263a8a844c370a89}, ${(0, $2OD79.DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 2px)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderWidth: `calc(var(${$0e005f327ee86521$export$263a8a844c370a89}, ${(0, $2OD79.DEFAULT_INLINE_IMAGE_BORDER_SIZE)}) * 1px)`,
    boxSizing: `border-box`
});

});
parcelRegister("2OD79", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_IMAGE_WIDTH", () => $d7d59ee2afa625fe$export$d722b7527b1834a8);
$parcel$export(module.exports, "DEFAULT_IMAGE_HEIGHT", () => $d7d59ee2afa625fe$export$da894f7669b4e67c);
$parcel$export(module.exports, "DEFAULT_INLINE_IMAGE_ASPECT_RATIO", () => $d7d59ee2afa625fe$export$286cf28b87ad4b4f);
$parcel$export(module.exports, "DEFAULT_INLINE_IMAGE_BORDER_SIZE", () => $d7d59ee2afa625fe$export$64fe09732fb8680);
$parcel$export(module.exports, "referenceHeights", () => $d7d59ee2afa625fe$export$c1317a9224e4d798);

var $4lTFP = parcelRequire("4lTFP");
const $d7d59ee2afa625fe$export$d722b7527b1834a8 = 250;
const $d7d59ee2afa625fe$export$da894f7669b4e67c = 200;
const $d7d59ee2afa625fe$export$286cf28b87ad4b4f = $d7d59ee2afa625fe$export$d722b7527b1834a8 / $d7d59ee2afa625fe$export$da894f7669b4e67c;
const $d7d59ee2afa625fe$export$64fe09732fb8680 = 0;
const $d7d59ee2afa625fe$export$c1317a9224e4d798 = {
    p: (0, $4lTFP.headingSizes).h600.lineHeight - 2,
    h1: (0, $4lTFP.headingSizes).h800.lineHeight + 4,
    h2: (0, $4lTFP.headingSizes).h700.lineHeight + 3,
    h3: (0, $4lTFP.headingSizes).h600.lineHeight + 1,
    h4: (0, $4lTFP.headingSizes).h500.lineHeight + 3,
    h5: (0, $4lTFP.headingSizes).h400.lineHeight + 4,
    h6: (0, $4lTFP.headingSizes).h300.lineHeight + 2
};

});


parcelRegister("1TZMa", function(module, exports) {

$parcel$export(module.exports, "backgroundColorStyles", () => $315666ebd5cb3646$export$e4cca17cf56e99d);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $XHGTv = parcelRequire("XHGTv");
function $315666ebd5cb3646$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
var $315666ebd5cb3646$var$_ref = {
    name: "dk8lvo",
    styles: ".fabric-background-color-mark{background-color:var(--custom-palette-color, inherit);}a .fabric-background-color-mark{background-color:unset;}.fabric-background-color-mark .ak-editor-annotation{background-color:unset;}"
};
var $315666ebd5cb3646$var$_ref2 = {
    name: "7ixjog",
    styles: ".fabric-background-color-mark{background-color:var(--custom-palette-color, inherit);border-radius:2px;padding-top:1px;padding-bottom:2px;box-decoration-break:clone;}a .fabric-background-color-mark{background-color:unset;}.fabric-background-color-mark .ak-editor-annotation{background-color:unset;}"
};
const $315666ebd5cb3646$export$e4cca17cf56e99d = ()=>{
    return (0, $XHGTv.getBooleanFF)('platform.editor.review-text-highlighting-styling') ? $315666ebd5cb3646$var$_ref2 : $315666ebd5cb3646$var$_ref;
};

});

parcelRegister("i2OhI", function(module, exports) {

$parcel$export(module.exports, "blockMarksSharedStyles", () => $0f0fb00286f19d22$export$33edc553df878c50);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- Perfectly safe to auto-fix, but leaving it up to the team to remediate as the readability only gets worse with autofixing */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $0f0fb00286f19d22$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0f0fb00286f19d22$export$33edc553df878c50 = {
    name: "1p01ut3",
    styles: "*:not(.fabric-editor-block-mark)>,*:not(.fabric-editor-block-mark)>div.fabric-editor-block-mark:first-of-type:not(.fabric-editor-indentation-mark):not(.fabric-editor-alignment),.fabric-editor-alignment:first-of-type:first-child,.ProseMirror .fabric-editor-indentation-mark:first-of-type:first-child{p,h1,h2,h3,h4,h5,h6,.heading-wrapper{:first-child:not(style),style:first-child+*{margin-top:0;}}}"
};

});

parcelRegister("9x5mm", function(module, exports) {

$parcel$export(module.exports, "blockquoteSharedStyles", () => $6a19a22e227ae8f2$export$1b5f3b43e6c4a8ee);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");
const $6a19a22e227ae8f2$export$1b5f3b43e6c4a8ee = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& blockquote': {
        boxSizing: 'border-box',
        color: 'inherit',
        paddingLeft: "var(--ds-space-200, 16px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        borderLeft: `2px solid ${`var(--ds-border, ${(0, $25FYC.akEditorBlockquoteBorderColor)})`}`,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $25FYC.blockNodesVerticalMargin)} 0 0 0`,
        marginRight: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[dir='rtl'] &": {
            paddingLeft: 0,
            paddingRight: "var(--ds-space-200, 16px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-child': {
            marginTop: 0
        },
        '&::before': {
            content: "''"
        },
        '&::after': {
            content: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& p': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '& table, & table:last-child': {
            display: 'inline-table'
        }
    }
});

});

parcelRegister("6GESD", function(module, exports) {

$parcel$export(module.exports, "codeMarkSharedStyles", () => $494b32cd7dbfd86c$export$ea799c18f699972b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
parcelRequire("dl0RD");
var $gamSa = parcelRequire("gamSa");

var $PdmhA = parcelRequire("PdmhA");
const $494b32cd7dbfd86c$export$ea799c18f699972b = ()=>{
    return /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.code': {
            '--ds--code--bg-color': `var(--ds-background-neutral, ${(0, $PdmhA.N30A)})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            ...(0, $gamSa.getCodeStyles)()
        }
    });
};

});
parcelRegister("dl0RD", function(module, exports) {

$parcel$export(module.exports, "default", () => $a70258a1be0ad4f6$export$2e2bcd8739ae039);
$parcel$export(module.exports, "getCodeStyles", () => (parcelRequire("gamSa")).getCodeStyles);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $hve4P = parcelRequire("hve4P");

var $hyA5S = parcelRequire("hyA5S");

var $gamSa = parcelRequire("gamSa");
/**
 * __Code__
 *
 * Code highlights short strings of code snippets inline with body text.
 *
 * - [Examples](https://atlassian.design/components/code/examples)
 * - [Code](https://atlassian.design/components/code/code)
 * - [Usage](https://atlassian.design/components/code/usage)
 */ const $a70258a1be0ad4f6$var$Code = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Code({ testId: testId, ...props }, ref) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const styles = /*#__PURE__*/ (0, $byn9U.css)((0, $gamSa.getCodeStyles)());
    const { children: children, codeBidiWarnings: codeBidiWarnings = true, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, ...otherProps } = props;
    const decoratedChildren = codeBidiWarnings ? /*#__PURE__*/ (0, $byn9U.jsx)($a70258a1be0ad4f6$var$RenderCodeChildrenWithBidiWarnings, {
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
    }, children) : children;
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("code", {
        ref: ref,
        "data-testid": testId,
        css: styles,
        ...otherProps
    }, decoratedChildren));
}));
function $a70258a1be0ad4f6$var$RenderCodeChildrenWithBidiWarnings({ children: children, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled }) {
    const replacedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.map(children, (childNode)=>{
        if (typeof childNode === 'string') {
            const decorated = (0, $hyA5S.default)(childNode, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $hve4P.default), {
                    bidiCharacter: bidiCharacter,
                    key: index,
                    label: codeBidiWarningLabel,
                    tooltipEnabled: codeBidiWarningTooltipEnabled
                }));
            return decorated;
        }
        if ($a70258a1be0ad4f6$var$isReactElement(childNode) && childNode.props.children) {
            // eslint-disable-next-line @repo/internal/react/no-clone-element
            const newChildNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(childNode, {
                children: /*#__PURE__*/ (0, $byn9U.jsx)($a70258a1be0ad4f6$var$RenderCodeChildrenWithBidiWarnings, {
                    codeBidiWarningLabel: codeBidiWarningLabel,
                    codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
                }, childNode.props.children)
            });
            return newChildNode;
        }
        return childNode;
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, replacedChildren);
}
function $a70258a1be0ad4f6$var$isReactElement(child) {
    return !!child.type;
}
$a70258a1be0ad4f6$var$Code.displayName = 'Code';
var $a70258a1be0ad4f6$export$2e2bcd8739ae039 = $a70258a1be0ad4f6$var$Code;

});
parcelRegister("hve4P", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cee3a28ff2903e3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");

var $hqCgH = parcelRequire("hqCgH");
function $0cee3a28ff2903e3$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, tooltipEnabled: tooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
    if (tooltipEnabled) return(// Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: label,
        tag: $0cee3a28ff2903e3$var$CustomizedTagWithRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hqCgH.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter
    }, skipChildren ? null : bidiCharacter)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hqCgH.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter
    }, skipChildren ? null : bidiCharacter);
}
const $0cee3a28ff2903e3$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        ...rest,
        ref: ref
    }, children);
});

});
parcelRegister("hqCgH", function(module, exports) {

$parcel$export(module.exports, "Decorator", () => $bffbd99dc2ca2fb8$export$a592b67c93d52467);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $lkPEe = parcelRequire("lkPEe");
const $bffbd99dc2ca2fb8$var$decoration = /*#__PURE__*/ (0, $byn9U.css)({
    // Required as otherwise the following bidi characters cause the span
    // to not receive hover events.
    //
    // U+2066 LEFT-TO-RIGHT ISOLATE (when using pseudo element before)
    // U+202E RIGHT-TO-LEFT OVERRIDE' (when using pseudo element after)
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':before': {
        display: 'inline-flex',
        padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'row',
        background: `var(--ds-background-warning, ${(0, $PdmhA.Y75)})`,
        color: "var(--ds-text-warning, #7F5F01)",
        content: '"<"attr(data-bidi-character-code)">"',
        fontSize: '14px',
        fontStyle: 'normal',
        lineHeight: '18px',
        /**
     * Ensures the decoration receives pointer events when it occurs with
     * an ancestor that disables them.
     */ pointerEvents: 'auto'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover:before': {
        background: `var(--ds-background-warning-hovered, ${(0, $PdmhA.Y75)})`,
        color: "var(--ds-text-warning, #533F04)"
    }
});
function $bffbd99dc2ca2fb8$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
    const bidiCharacterCode = $bffbd99dc2ca2fb8$var$getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $bffbd99dc2ca2fb8$var$decoration,
        "data-testid": testId,
        "data-bidi-character-code": bidiCharacterCode,
        // This is set to true so that the content is not read out by
        // screen readers as the content includes angle brackets for
        // visual decoration purposes.
        // We use a visually hidden `mark` element below for screen readers
        "aria-hidden": "true"
    }, children), /*#__PURE__*/ (0, $byn9U.jsx)((0, $lkPEe.default), {
        testId: testId && `${testId}--visually-hidden`
    }, /*#__PURE__*/ (0, $byn9U.jsx)("mark", null, bidiCharacterCode)));
}
function $bffbd99dc2ca2fb8$var$getBidiCharacterCode(bidiCharacter) {
    const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
    return `U+${bidiCharacterCode}`;
}

});


parcelRegister("hyA5S", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4a6695c0dcb062d$export$2e2bcd8739ae039);
const $d4a6695c0dcb062d$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
function $d4a6695c0dcb062d$export$2e2bcd8739ae039(originalText, decorate) {
    const matches = [
        ...originalText.matchAll($d4a6695c0dcb062d$export$ecb256e6a1f5ee7e)
    ];
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    let children = [];
    let mappedTo = 0;
    for (const match of matches){
        if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
        // mapped to the children.
        // Add them as plain text.
        children.push(originalText.substring(mappedTo, match.index));
        children.push(decorate({
            bidiCharacter: match[0],
            index: match.index
        }));
        // While index is guaranteed to be present, it needs to be asserted due
        // to a limitation of typescripts regex handling
        //
        // https://github.com/microsoft/TypeScript/issues/36788
        // Decorate bidi character
        mappedTo = match.index + match[0].length;
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}

});

parcelRegister("gamSa", function(module, exports) {

$parcel$export(module.exports, "getCodeBlockStyles", () => $9564a2d27c68447a$export$b571c24d82780698);
$parcel$export(module.exports, "getCodeStyles", () => $9564a2d27c68447a$export$d5fcf1b7ff23707b);
$parcel$export(module.exports, "getCodeBlockTheme", () => $9564a2d27c68447a$export$57a2d4b573afd64a);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $iUo9q = parcelRequire("iUo9q");

var $bQ0Ef = parcelRequire("bQ0Ef");
const $9564a2d27c68447a$export$cb7aec0206b595d2 = (numLines)=>{
    if (!numLines) return '1ch';
    return `${numLines.toFixed(0).length}ch`;
};
const $9564a2d27c68447a$var$lineNumberStyle = (theme)=>({
        // width of the line number gutter
        minWidth: `calc(${theme.lineNumberWidth} + ${0, $iUo9q.LINE_NUMBER_GUTTER}px) !important`,
        // this needs to be important or it gets overwritten by inline styles
        fontStyle: 'normal !important',
        // this needs to be important or it gets overwritten by inline styles
        color: `${theme.lineNumberColor} !important`,
        flexShrink: 0,
        // needed to replicate existing design spec
        boxSizing: 'border-box',
        paddingRight: `${0, $iUo9q.SPACING}px !important`,
        paddingLeft: (0, $iUo9q.SPACING),
        marginRight: (0, $iUo9q.SPACING),
        textAlign: 'right',
        userSelect: 'none',
        // this is to fix SSR spacing issue
        display: 'block',
        // This is how we are preventing line numbers being copied to clipboard.
        // (`user-select: none;` was not sufficent).
        // https://product-fabric.atlassian.net/browse/DSP-2729
        '&::after': {
            content: `attr(data-ds--line-number)`
        }
    });
// order of these keys does matter as it will affect the css precedence
const $9564a2d27c68447a$var$syntaxKeywordColors = (theme)=>({
        '.token': {
            // this specifically stops prism css cascading.
            '&:not([class=token],[data-ds--code--row--highlight],[data-ds--code--row])': {
                all: 'unset'
            },
            // additional specificity required to match the all: unset
            '&.key,&.keyword': {
                color: theme.keywordColor,
                fontWeight: 'bolder'
            },
            '&.attr-name': {
                color: theme.attributeColor
            },
            '&.selector': {
                color: theme.selectorTagColor
            },
            '&.comment,&.block-comment': {
                color: theme.commentColor,
                fontFamily: theme.fontFamilyItalic,
                fontStyle: 'italic'
            },
            '&.function-name': {
                color: theme.sectionColor
            },
            '&.doctype': {
                color: theme.docTagColor
            },
            '&.substr': {
                color: theme.substringColor
            },
            '&.namespace': {
                color: theme.nameColor
            },
            '&.builtin': {
                color: theme.builtInColor
            },
            '&.entity': {
                color: theme.literalColor
            },
            '&.bullet': {
                color: theme.bulletColor
            },
            '&.code': {
                color: theme.codeColor
            },
            '&.regex': {
                color: theme.regexpColor
            },
            '&.symbol': {
                color: theme.symbolColor
            },
            '&.variable': {
                color: theme.variableColor
            },
            '&.url': {
                color: theme.linkColor
            },
            '&.selector-attr': {
                color: theme.selectorAttributeColor
            },
            '&.selector-pseudo': {
                color: theme.selectorPseudoColor
            },
            '&.type': {
                color: theme.typeColor
            },
            '&.quote': {
                color: theme.quoteColor
            },
            '&.tag': {
                color: theme.templateTagColor
            },
            '&.string': {
                color: theme.stringColor
            },
            '&.class-name': {
                color: theme.sectionColor
            },
            '&.title': {
                color: theme.titleColor
            },
            '&.section': {
                color: theme.sectionColor
            },
            '&.meta-keyword': {
                color: theme.metaKeywordColor
            },
            '&.meta': {
                color: theme.metaColor
            },
            '&.italic': {
                fontStyle: 'italic'
            },
            '&.bold': {
                fontWeight: 'bolder'
            },
            '&.function': {
                color: theme.functionColor
            },
            '&.number': {
                color: theme.numberColor
            },
            '&.attr-value': {
                color: theme.attributeColor
            },
            '&.prolog': {
                color: theme.prologColor
            },
            '&.cdata': {
                color: theme.cdataColor
            },
            '&.punctuation': {
                color: theme.punctuationColor
            },
            '&.property': {
                color: theme.propertyColor
            },
            '&.constant': {
                color: theme.constantColor
            },
            '&.deleted': {
                color: theme.deletedColor
            },
            '&.boolean': {
                color: theme.booleanColor
            },
            '&.char': {
                color: theme.charColor
            },
            '&.inserted': {
                color: theme.insertedColor
            },
            '&.operator': {
                color: theme.operatorColor
            },
            '&.atrule': {
                color: theme.atruleColor
            },
            '&.important': {
                color: theme.importantColor,
                fontWeight: 'bold'
            }
        }
    });
const $9564a2d27c68447a$export$ee58a26b5d612ac1 = (theme)=>({
        fontSize: (0, $iUo9q.CODE_FONT_SIZE),
        fontFamily: theme.fontFamily,
        fontWeight: 'normal',
        backgroundColor: `var(${0, $iUo9q.VAR_CODE_BG_COLOR},${theme.backgroundColor})`,
        color: theme.textColor,
        borderStyle: 'none',
        borderRadius: "var(--ds-border-radius, 3px)"
    });
const $9564a2d27c68447a$export$b571c24d82780698 = (theme)=>(highlightedStartText, highlightedEndText, showLineNumbers, shouldWrapLongLines)=>({
            // this is required to account for prismjs styles leaking into the codeblock
            'code[class*="language-"], pre[class*="language-"], code': {
                all: 'unset',
                padding: showLineNumbers ? `${0, $iUo9q.SPACING}px 0` : (0, $iUo9q.SPACING),
                tabSize: 4
            },
            display: 'flex',
            lineHeight: (0, $iUo9q.CODE_LINE_HEIGHT),
            overflowX: 'auto',
            whiteSpace: 'pre',
            direction: 'ltr',
            ...$9564a2d27c68447a$export$ee58a26b5d612ac1(theme),
            ...$9564a2d27c68447a$var$syntaxKeywordColors(theme),
            // this is to account for SSR spacing issue once loaded in browser
            '& .linenumber, .ds-sh-line-number': $9564a2d27c68447a$var$lineNumberStyle(theme),
            '& .linenumber': {
                display: 'inline-block !important',
                float: 'left'
            },
            // these styles are for line highlighting
            '& [data-ds--code--row]': {
                display: showLineNumbers ? 'flex' : 'block',
                paddingRight: `${0, $iUo9q.SPACING}px !important`,
                marginRight: `-${0, $iUo9q.SPACING}px`
            },
            '& [data-ds--code--row--highlight]': {
                background: `${theme.highlightedLineBgColor}`,
                // eslint-disable-next-line @atlaskit/design-system/use-visually-hidden
                '&::before, &::after': {
                    clipPath: 'inset(100%)',
                    clip: 'rect(1px, 1px, 1px, 1px)',
                    height: '1px',
                    overflow: 'hidden',
                    position: 'absolute',
                    whiteSpace: 'nowrap',
                    width: '1px'
                },
                // The formatting here is an accessibility convention
                '&::before': {
                    content: `" [${highlightedStartText}] "`
                },
                '&::after': {
                    content: `" [${highlightedEndText}] "`
                }
            },
            '& [data-ds--code--row--highlight] .linenumber': {
                borderLeft: `${0, $iUo9q.HIGHLIGHT_BORDER_WIDTH} solid ${theme.highlightedLineBorderColor}`,
                paddingLeft: `${(0, $iUo9q.SPACING) / 2}px !important`,
                position: 'relative'
            },
            // fill in space caused by parent border top
            '& [data-ds--code--row--highlight] .linenumber::before': {
                content: '""',
                position: 'absolute',
                width: (0, $iUo9q.HIGHLIGHT_BORDER_WIDTH),
                top: '-1px',
                left: `-${0, $iUo9q.HIGHLIGHT_BORDER_WIDTH}`,
                borderTop: `1px solid ${theme.highlightedLineBorderColor}`
            },
            '[data-ds--code--row--highlight] + [data-ds--code--row]:not([data-ds--code--row--highlight]), [data-ds--code--row]:not([data-ds--code--row--highlight]) + [data-ds--code--row--highlight]': {
                borderTop: '1px dashed transparent'
            },
            '[data-ds--code--row--highlight]:last-child': {
                borderBottom: '1px dashed transparent'
            },
            '& code:first-of-type': {
                paddingRight: `0px !important`,
                backgroundImage: showLineNumbers ? `linear-gradient(to right, var(${0, $iUo9q.VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor}), var(${0, $iUo9q.VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor})
    calc(${theme.lineNumberWidth} + ${0, $iUo9q.LINE_NUMBER_GUTTER}px), transparent calc(${theme.lineNumberWidth} + ${0, $iUo9q.LINE_NUMBER_GUTTER}px), transparent)` : undefined
            },
            // we need to use last-of-type because when Code is SSR'd
            // 2 <code> elements are created and we don't want this style
            // applied to the first one
            '& code:last-of-type': {
                paddingRight: `${0, $iUo9q.SPACING}px !important`,
                flexBasis: 'auto',
                flexGrow: 1,
                // Needed for the highlight line to extend full-width
                flexShrink: shouldWrapLongLines ? 1 : 0,
                wordBreak: 'break-word'
            },
            // Prevents empty code blocks from vertically collapsing
            'code > span:only-child:empty:before, code > span:only-child > span:only-child:empty:before': {
                content: '" "'
            }
        });
const $9564a2d27c68447a$export$d5fcf1b7ff23707b = ()=>{
    const theme = (0, $bQ0Ef.getBaseTheme)();
    const baseStyles = $9564a2d27c68447a$export$ee58a26b5d612ac1(theme);
    return {
        ...baseStyles,
        display: 'inline',
        padding: '2px 0.5ch',
        boxDecorationBreak: 'clone',
        fontSize: '0.875em',
        overflow: 'auto',
        overflowWrap: 'break-word',
        whiteSpace: 'pre-wrap'
    };
};
const $9564a2d27c68447a$export$57a2d4b573afd64a = (maxLines)=>{
    return {
        ...(0, $bQ0Ef.getBaseTheme)(),
        ...(0, $bQ0Ef.getColorPalette)(),
        lineNumberWidth: maxLines ? $9564a2d27c68447a$export$cb7aec0206b595d2(maxLines) : undefined
    };
};

});
parcelRegister("iUo9q", function(module, exports) {

$parcel$export(module.exports, "CODE_FONT_SIZE", () => $fb842dc45fcee8c3$export$431ac46d758d98c8);
$parcel$export(module.exports, "CODE_LINE_HEIGHT", () => $fb842dc45fcee8c3$export$8e3c04032121c606);
$parcel$export(module.exports, "HIGHLIGHT_BORDER_WIDTH", () => $fb842dc45fcee8c3$export$c8b5dc30e9f2b86e);
$parcel$export(module.exports, "SPACING", () => $fb842dc45fcee8c3$export$82ea42e772d49e5b);
$parcel$export(module.exports, "LINE_NUMBER_GUTTER", () => $fb842dc45fcee8c3$export$eeeea0ff98e06fff);
$parcel$export(module.exports, "VAR_CODE_LINE_NUMBER_BG_COLOR", () => $fb842dc45fcee8c3$export$254015fe817dcb9e);
$parcel$export(module.exports, "VAR_CODE_BG_COLOR", () => $fb842dc45fcee8c3$export$1758fda69688282e);
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $lcnyw = parcelRequire("lcnyw");
const $fb842dc45fcee8c3$export$431ac46d758d98c8 = 12;
const $fb842dc45fcee8c3$export$8e3c04032121c606 = '20px';
const $fb842dc45fcee8c3$export$c8b5dc30e9f2b86e = '4px';
const $fb842dc45fcee8c3$export$82ea42e772d49e5b = (0, $lcnyw.gridSize)();
const $fb842dc45fcee8c3$export$eeeea0ff98e06fff = $fb842dc45fcee8c3$export$82ea42e772d49e5b * 2;
const $fb842dc45fcee8c3$export$254015fe817dcb9e = '--ds--code--line-number-bg-color';
const $fb842dc45fcee8c3$export$1758fda69688282e = '--ds--code--bg-color';
const $fb842dc45fcee8c3$export$2cd00c745c539a1 = `data-ds--code--code-block`;

});

parcelRegister("bQ0Ef", function(module, exports) {

$parcel$export(module.exports, "getBaseTheme", () => $531c36e6ab7cba4e$export$4464aa303b3e4fda);
$parcel$export(module.exports, "getColorPalette", () => $531c36e6ab7cba4e$export$fe2a6478976e8b17);

var $5iWql = parcelRequire("5iWql");

var $PdmhA = parcelRequire("PdmhA");

var $lcnyw = parcelRequire("lcnyw");
// Hardcoded values have been used due to the current color palette not having any
// accessible color options for Teal and Yellow and +20A
const $531c36e6ab7cba4e$var$T800 = '#067384';
const $531c36e6ab7cba4e$var$Y1100 = '#7A5D1A';
const $531c36e6ab7cba4e$export$4464aa303b3e4fda = ()=>({
        fontFamily: (0, $lcnyw.codeFontFamily)(),
        fontFamilyItalic: `SFMono-MediumItalic, ${(0, $lcnyw.codeFontFamily)()}`,
        backgroundColor: `var(--ds-background-neutral, ${$PdmhA.N20})`,
        textColor: `var(--ds-text, ${$PdmhA.N800})`,
        lineNumberColor: `var(--ds-text-subtlest, ${$PdmhA.N400})`,
        lineNumberBgColor: `var(--ds-background-neutral, ${$PdmhA.N30})`
    });
const $531c36e6ab7cba4e$export$7136e5d021a38178 = $531c36e6ab7cba4e$export$4464aa303b3e4fda();
const $531c36e6ab7cba4e$export$fe2a6478976e8b17 = (0, $5iWql.default)(()=>{
    return {
        highlightedLineBgColor: `var(--ds-background-neutral, ${$PdmhA.N30})`,
        highlightedLineBorderColor: `var(--ds-border-focused, ${$PdmhA.B200})`,
        substringColor: `var(--ds-text-subtlest, ${$PdmhA.N400})`,
        keywordColor: `var(--ds-text-accent-blue, ${$PdmhA.B400})`,
        attributeColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        selectorTagColor: `var(--ds-text-accent-blue, ${$PdmhA.B400})`,
        docTagColor: `var(--ds-text-accent-yellow, ${$531c36e6ab7cba4e$var$Y1100})`,
        nameColor: `var(--ds-text-accent-blue, ${$PdmhA.B400})`,
        builtInColor: `var(--ds-text-accent-blue, ${$PdmhA.B400})`,
        literalColor: `var(--ds-text-accent-blue, ${$PdmhA.B400})`,
        bulletColor: `var(--ds-text-accent-blue, ${$PdmhA.B400})`,
        codeColor: `var(--ds-text-accent-blue, ${$PdmhA.B400})`,
        regexpColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        symbolColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        variableColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        templateVariableColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        linkColor: `var(--ds-text-accent-purple, ${$PdmhA.P300})`,
        selectorAttributeColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        selectorPseudoColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        typeColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        stringColor: `var(--ds-text-accent-green, ${$PdmhA.G500})`,
        selectorIdColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        selectorClassColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        quoteColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        templateTagColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        titleColor: `var(--ds-text-accent-purple, ${$PdmhA.P300})`,
        sectionColor: `var(--ds-text-accent-purple, ${$PdmhA.P300})`,
        commentColor: `var(--ds-text-subtlest, ${$PdmhA.N400})`,
        metaKeywordColor: `var(--ds-text-accent-green, ${$PdmhA.G500})`,
        metaColor: `var(--ds-text-subtlest, ${$PdmhA.N400})`,
        functionColor: `var(--ds-text, ${$PdmhA.N800})`,
        numberColor: `var(--ds-text-accent-blue, ${$PdmhA.B400})`,
        prologColor: `var(--ds-text-accent-blue, ${$PdmhA.B400})`,
        cdataColor: `var(--ds-text-subtlest, ${$PdmhA.N400})`,
        punctuationColor: `var(--ds-text, ${$PdmhA.N800})`,
        propertyColor: `var(--ds-text-accent-purple, ${$PdmhA.P300})`,
        constantColor: `var(--ds-text-accent-teal, ${$531c36e6ab7cba4e$var$T800})`,
        booleanColor: `var(--ds-text-accent-blue, ${$PdmhA.B400})`,
        charColor: `var(--ds-text, ${$PdmhA.N800})`,
        insertedColor: `var(--ds-text-accent-green, ${$PdmhA.G500})`,
        deletedColor: `var(--ds-text-accent-red, ${$PdmhA.R500})`,
        operatorColor: `var(--ds-text, ${$PdmhA.N800})`,
        atruleColor: `var(--ds-text-accent-green, ${$PdmhA.G500})`,
        importantColor: `var(--ds-text-accent-yellow, ${$531c36e6ab7cba4e$var$Y1100})`
    };
});
const $531c36e6ab7cba4e$var$getTheme = ()=>({
        ...$531c36e6ab7cba4e$export$4464aa303b3e4fda(),
        ...$531c36e6ab7cba4e$export$fe2a6478976e8b17()
    });
var $531c36e6ab7cba4e$export$2e2bcd8739ae039 = $531c36e6ab7cba4e$var$getTheme;

});




parcelRegister("3CrqS", function(module, exports) {

$parcel$export(module.exports, "columnLayoutSharedStyle", () => $934e9631ae78eb9d$export$6891a39948814a80);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");
const $934e9631ae78eb9d$export$6891a39948814a80 = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '[data-layout-section]': {
        position: 'relative',
        display: 'flex',
        flexDirection: 'row',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > *': {
            flex: 1,
            minWidth: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > .unsupportedBlockView-content-wrap': {
            minWidth: 'initial'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`@media screen and (max-width: ${0, $25FYC.gridMediumMaxWidth}px)`]: {
            flexDirection: 'column'
        }
    }
});

});

parcelRegister("izEcn", function(module, exports) {

$parcel$export(module.exports, "DateSharedCssClassName", () => $2966a11c67f1dc9b$export$99cdf122d0bb9f95);
$parcel$export(module.exports, "dateSharedStyle", () => $2966a11c67f1dc9b$export$86f86bd772084bf4);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
const $2966a11c67f1dc9b$export$99cdf122d0bb9f95 = {
    DATE_WRAPPER: `date-lozenger-container`,
    DATE_CONTAINER: 'dateView-content-wrap'
};
const $2966a11c67f1dc9b$export$86f86bd772084bf4 = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$2966a11c67f1dc9b$export$99cdf122d0bb9f95.DATE_WRAPPER} span`]: {
        whiteSpace: 'unset'
    }
});

});

parcelRegister("hp7YN", function(module, exports) {

$parcel$export(module.exports, "headingsSharedStyles", () => $b6534361ec439a17$export$9272613b68afed4b);
/* eslint-disable @atlaskit/design-system/use-tokens-space */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $4lTFP = parcelRequire("4lTFP");
const $b6534361ec439a17$export$9272613b68afed4b = ()=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& h1': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            ...(0, $4lTFP.h700)(),
            marginBottom: 0,
            marginTop: '1.667em'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& h2': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            ...(0, $4lTFP.h600)(),
            marginTop: '1.8em',
            marginBottom: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& h3': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            ...(0, $4lTFP.h500)(),
            marginTop: '2em',
            marginBottom: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& h4': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            ...(0, $4lTFP.h400)(),
            marginTop: '1.357em'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& h5': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            ...(0, $4lTFP.h300)(),
            marginTop: '1.667em',
            textTransform: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& h6': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            ...(0, $4lTFP.h100)(),
            marginTop: '1.455em',
            textTransform: 'none'
        }
    });

});

parcelRegister("8VeKB", function(module, exports) {

$parcel$export(module.exports, "indentationSharedStyles", () => $62390827e5c3730a$export$6856b92f564d3de8);
/* eslint-disable @atlaskit/design-system/use-tokens-space */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $62390827e5c3730a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $62390827e5c3730a$export$6856b92f564d3de8 = {
    name: "1bgz9nd",
    styles: ".fabric-editor-indentation-mark{&[data-level='1']{margin-left:30px;}&[data-level='2']{margin-left:60px;}&[data-level='3']{margin-left:90px;}&[data-level='4']{margin-left:120px;}&[data-level='5']{margin-left:150px;}&[data-level='6']{margin-left:180px;}}"
};

});

parcelRegister("dMNGz", function(module, exports) {

$parcel$export(module.exports, "richMediaClassName", () => $1119b3f943e4e41c$export$cfe6da7d522d87bb);
$parcel$export(module.exports, "mediaSingleSharedStyle", () => $1119b3f943e4e41c$export$d031611b96ba4cf0);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
const $1119b3f943e4e41c$export$cfe6da7d522d87bb = 'rich-media-item';
const $1119b3f943e4e41c$var$wrappedMediaBreakoutPoint = 410;
const $1119b3f943e4e41c$export$d031611b96ba4cf0 = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`li .${$1119b3f943e4e41c$export$cfe6da7d522d87bb}`]: {
        margin: 0
    },
    // Hack for chrome to fix media single position inside a list when media is the first child
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-chrome li > .mediaSingleView-content-wrap::before': {
        content: "''",
        display: 'block',
        height: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&.ua-firefox': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.mediaSingleView-content-wrap': {
            userSelect: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '.captionView-content-wrap': {
            userSelect: 'text'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    ".mediaSingleView-content-wrap[layout='center']": {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`table .${$1119b3f943e4e41c$export$cfe6da7d522d87bb}`]: {
        marginTop: "var(--ds-space-150, 12px)",
        marginBottom: "var(--ds-space-150, 12px)",
        clear: 'both',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&.image-wrap-left, &.image-wrap-right': {
            clear: 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:first-child': {
                marginTop: "var(--ds-space-150, 12px)"
            }
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$1119b3f943e4e41c$export$cfe6da7d522d87bb}.image-wrap-right + .${$1119b3f943e4e41c$export$cfe6da7d522d87bb}.image-wrap-left`]: {
        clear: 'both'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`.${$1119b3f943e4e41c$export$cfe6da7d522d87bb}.image-wrap-left + .${$1119b3f943e4e41c$export$cfe6da7d522d87bb}.image-wrap-right, .${$1119b3f943e4e41c$export$cfe6da7d522d87bb}.image-wrap-right + .${$1119b3f943e4e41c$export$cfe6da7d522d87bb}.image-wrap-left, .${$1119b3f943e4e41c$export$cfe6da7d522d87bb}.image-wrap-left + .${$1119b3f943e4e41c$export$cfe6da7d522d87bb}.image-wrap-left, .${$1119b3f943e4e41c$export$cfe6da7d522d87bb}.image-wrap-right + .${$1119b3f943e4e41c$export$cfe6da7d522d87bb}.image-wrap-right`]: {
        marginRight: 0,
        marginLeft: 0
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    [`@media all and (max-width: ${$1119b3f943e4e41c$var$wrappedMediaBreakoutPoint}px)`]: {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "div.mediaSingleView-content-wrap[layout='wrap-left'], div.mediaSingleView-content-wrap[data-layout='wrap-left'], div.mediaSingleView-content-wrap[layout='wrap-right'], div.mediaSingleView-content-wrap[data-layout='wrap-right']": {
            float: 'none',
            overflow: 'auto',
            margin: `${"var(--ds-space-150, 12px)"} 0`
        }
    }
});

});

parcelRegister("bLfPF", function(module, exports) {

$parcel$export(module.exports, "paragraphSharedStyles", () => $01f8be114e0c8342$export$2f49074d75b0e29f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");
const $01f8be114e0c8342$export$2f49074d75b0e29f = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& p': {
        fontSize: '1em',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        lineHeight: (0, $25FYC.akEditorLineHeight),
        fontWeight: 'normal',
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        marginTop: (0, $25FYC.blockNodesVerticalMargin),
        marginBottom: 0,
        letterSpacing: '-0.005em'
    }
});

});

parcelRegister("fPB6q", function(module, exports) {

$parcel$export(module.exports, "ruleSharedStyles", () => $03688c0b58412e8b$export$329434b3a2da905e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");

var $PdmhA = parcelRequire("PdmhA");
const $03688c0b58412e8b$export$329434b3a2da905e = ()=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& hr': {
            border: 'none',
            backgroundColor: `var(--ds-border, ${(0, $PdmhA.N30A)})`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            margin: `${(0, $25FYC.akEditorLineHeight)}em 0`,
            height: '2px',
            borderRadius: '1px'
        }
    });

});

parcelRegister("c1Qps", function(module, exports) {

$parcel$export(module.exports, "shadowSharedStyle", () => $79f1b57345ca8b5a$export$985ce3da3286f9ed);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");

var $PdmhA = parcelRequire("PdmhA");

var $8AkRK = parcelRequire("8AkRK");

var $1JeZT = parcelRequire("1JeZT");
const $79f1b57345ca8b5a$var$shadowWidth = 8;
/**
 * TODO: This is close to working and removes a tone of JS from OverflowShadow component
 *
 *  background: linear-gradient(to right, white 30%, rgba(255, 255, 255, 0)),
 *         linear-gradient(to right, rgba(255, 255, 255, 0), white 70%) 100% 0,
 *        linear-gradient(to right, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0)),
 *         linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.2)) 100% 0;
 *       background-repeat: no-repeat;
 *       background-color: white;
 *       background-size: 40px 100%, 40px 100%, 14px 100%, 14px 100%;
 *
 *      background-attachment: local, local, scroll, scroll;
 */ const $79f1b57345ca8b5a$export$985ce3da3286f9ed = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $8AkRK.shadowClassNames).RIGHT_SHADOW}::before, .${(0, $8AkRK.shadowClassNames).RIGHT_SHADOW}::after, .${(0, $8AkRK.shadowClassNames).LEFT_SHADOW}::before, .${(0, $8AkRK.shadowClassNames).LEFT_SHADOW}::after`]: {
        display: 'none',
        position: 'absolute',
        pointerEvents: 'none',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: (0, $25FYC.akEditorShadowZIndex),
        width: `${$79f1b57345ca8b5a$var$shadowWidth}px`,
        content: "''",
        height: 'calc(100%)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $8AkRK.shadowClassNames).RIGHT_SHADOW}, .${(0, $8AkRK.shadowClassNames).LEFT_SHADOW}`]: {
        position: 'relative'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $8AkRK.shadowClassNames).LEFT_SHADOW}::before`]: {
        background: `linear-gradient( to left, transparent 0, ${`var(--ds-shadow-overflow-spread, ${(0, $PdmhA.N40A)})`} 140% ), linear-gradient( to right, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px )`,
        top: '0px',
        left: 0,
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $8AkRK.shadowClassNames).RIGHT_SHADOW}::after`]: {
        background: `linear-gradient( to right, transparent 0, ${`var(--ds-shadow-overflow-spread, ${(0, $PdmhA.N40A)})`} 140% ), linear-gradient( to left, ${"var(--ds-shadow-overflow-perimeter, transparent)"} 0px, transparent 1px )`,
        right: '0px',
        top: '0px',
        display: 'block'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $1JeZT.shadowObserverClassNames).SENTINEL_LEFT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    [`& .${(0, $1JeZT.shadowObserverClassNames).SENTINEL_RIGHT}`]: {
        height: '100%',
        width: '0px',
        minWidth: '0px'
    }
});

});

parcelRegister("cDyCO", function(module, exports) {

$parcel$export(module.exports, "SmartCardSharedCssClassName", () => $4c6292b6b99d2100$export$4ccd31bf665a88f6);
$parcel$export(module.exports, "smartCardSharedStyles", () => $4c6292b6b99d2100$export$83e107f0a431e184);

var $25FYC = parcelRequire("25FYC");
const $4c6292b6b99d2100$export$4ccd31bf665a88f6 = {
    INLINE_CARD_CONTAINER: 'inlineCardView-content-wrap',
    BLOCK_CARD_CONTAINER: 'blockCardView-content-wrap',
    EMBED_CARD_CONTAINER: 'embedCardView-content-wrap',
    DATASOURCE_CONTAINER: 'datasourceView-content-wrap',
    LOADER_WRAPPER: 'loader-wrapper'
};
const $4c6292b6b99d2100$export$83e107f0a431e184 = `
  .${$4c6292b6b99d2100$export$4ccd31bf665a88f6.BLOCK_CARD_CONTAINER} {
    display: block;
    margin: ${(0, $25FYC.blockNodesVerticalMargin)} 0 0;
    max-width: ${760}px;
  }
`;

});

parcelRegister("6lAd7", function(module, exports) {

$parcel$export(module.exports, "TaskDecisionSharedCssClassName", () => $3b7c2ca31535e9f0$export$a7172b75d403a0e4);
$parcel$export(module.exports, "tasksAndDecisionsStyles", () => $3b7c2ca31535e9f0$export$df437277fbc8b4f5);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");
const $3b7c2ca31535e9f0$export$a7172b75d403a0e4 = {
    DECISION_CONTAINER: 'decisionItemView-content-wrap',
    TASK_CONTAINER: 'taskItemView-content-wrap',
    TASK_ITEM: 'task-item'
};
const $3b7c2ca31535e9f0$export$df437277fbc8b4f5 = /*#__PURE__*/ (0, $byn9U.css)(".ProseMirror{.taskItemView-content-wrap,.", $3b7c2ca31535e9f0$export$a7172b75d403a0e4.DECISION_CONTAINER, "{position:relative;min-width:", (0, $25FYC.akEditorTableCellMinWidth), "px;}.", $3b7c2ca31535e9f0$export$a7172b75d403a0e4.DECISION_CONTAINER, "{margin-top:0;}.", $3b7c2ca31535e9f0$export$a7172b75d403a0e4.TASK_CONTAINER, "{span[contenteditable='false']{height:", (0, $25FYC.akEditorLineHeight), "em;}}.", $3b7c2ca31535e9f0$export$a7172b75d403a0e4.TASK_ITEM, "{line-height:", (0, $25FYC.akEditorLineHeight), ";}}div[data-task-local-id]{span[contenteditable='false']{height:", (0, $25FYC.akEditorLineHeight), "em;}span[contenteditable='false']+div{line-height:", (0, $25FYC.akEditorLineHeight), "em;}}div[data-task-list-local-id]{margin:var(--ds-space-150, 12px) 0 0 0;}div[data-task-list-local-id]{div+div{margin-top:var(--ds-space-050, 4px);}}div[data-task-list-local-id] div[data-task-list-local-id]{margin-top:var(--ds-space-050, 4px);margin-left:var(--ds-space-300, 24px);}.ak-editor-panel__content{>div[data-task-list-local-id]:first-child{margin:0 0 0 0!important;}}");

});

parcelRegister("lGBd6", function(module, exports) {

$parcel$export(module.exports, "textColorStyles", () => $0837c408409e9387$export$a518ea5d00002b38);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $0837c408409e9387$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0837c408409e9387$export$a518ea5d00002b38 = {
    name: "1nlqh0j",
    styles: ".fabric-text-color-mark{color:var(--custom-palette-color, inherit);}a .fabric-text-color-mark{color:unset;}"
};

});

parcelRegister("eJ4TL", function(module, exports) {

$parcel$export(module.exports, "whitespaceSharedStyles", () => $a571a229b95a4cf5$export$c9ce3bfa46d7acba);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $a571a229b95a4cf5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a571a229b95a4cf5$export$c9ce3bfa46d7acba = {
    name: "1s8ykn2",
    styles: "word-wrap:break-word;white-space:pre-wrap"
};

});

parcelRegister("igoil", function(module, exports) {

$parcel$export(module.exports, "getLightWeightCodeBlockStylesForRootRendererStyleSheet", () => $1fb47e1f387902d6$export$3f1ff491ca7c4c4a);
$parcel$export(module.exports, "default", () => $1fb47e1f387902d6$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");

var $9SSfJ = parcelRequire("9SSfJ");

var $8Mzh3 = parcelRequire("8Mzh3");

var $ghgHw = parcelRequire("ghgHw");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $1fb47e1f387902d6$var$lightWeightCodeBlockStyles = /*#__PURE__*/ (0, $byn9U.css)(".", (0, $9SSfJ.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, "{cursor:text;}");
const $1fb47e1f387902d6$export$afbde0e7339bed51 = {
    CONTAINER: 'light-weight-code-block'
};
const $1fb47e1f387902d6$export$3f1ff491ca7c4c4a = ()=>{
    // We overwrite the rule that clears margin-top for first nested codeblocks, as
    // our lightweight codeblock dom structure will always nest the codeblock inside
    // an extra container div which would constantly be targeted. Now, top-level
    // lightweight codeblock containers will not be targeted.
    // NOTE: This must be added after other .code-block styles in the root
    // Renderer stylesheet.
    // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $byn9U.css)(".", (0, $ghgHw.RendererCssClassName).DOCUMENT, ">.", $1fb47e1f387902d6$export$afbde0e7339bed51.CONTAINER, " .", (0, $9SSfJ.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER, "{margin-top:", (0, $25FYC.blockNodesVerticalMargin), ";}");
};
const $1fb47e1f387902d6$var$LightWeightCodeBlock = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ text: text, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, className: className }, ref)=>{
    const textRows = (0, $eUqFw.useMemo)(()=>(text ?? '').split('\n'), [
        text
    ]);
    const { renderBidiWarnings: renderBidiWarnings } = (0, $8Mzh3.useBidiWarnings)({
        enableWarningTooltip: codeBidiWarningTooltipEnabled
    });
    const classNames = [
        $1fb47e1f387902d6$export$afbde0e7339bed51.CONTAINER,
        className
    ].join(' ');
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: classNames,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            (0, $9SSfJ.codeBlockSharedStyles)(),
            $1fb47e1f387902d6$var$lightWeightCodeBlockStyles
        ]
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        className: (0, $9SSfJ.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $9SSfJ.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $9SSfJ.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER
    }, textRows.map((_, index)=>/*#__PURE__*/ (0, $byn9U.jsx)("span", {
            key: index
        }))), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        className: (0, $9SSfJ.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT
    }, /*#__PURE__*/ (0, $byn9U.jsx)("code", null, renderBidiWarnings(text))))));
});
var $1fb47e1f387902d6$export$2e2bcd8739ae039 = $1fb47e1f387902d6$var$LightWeightCodeBlock;

});
parcelRegister("8Mzh3", function(module, exports) {

$parcel$export(module.exports, "useBidiWarnings", () => $2b26be7b9b8b2e65$export$9fb9fe546a188c7b);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hve4P = parcelRequire("hve4P");

var $hl0Ug = parcelRequire("hl0Ug");

var $hyA5S = parcelRequire("hyA5S");
const $2b26be7b9b8b2e65$export$9fb9fe546a188c7b = ({ enableWarningTooltip: enableWarningTooltip = true })=>{
    const intl = (0, $5JgJ2.default)();
    const warningLabel = intl.formatMessage((0, $hl0Ug.codeBidiWarningMessages).label);
    const renderBidiWarnings = (text)=>{
        return (0, $hyA5S.default)(text, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hve4P.default), {
                bidiCharacter: bidiCharacter,
                key: index,
                label: warningLabel,
                tooltipEnabled: enableWarningTooltip
            }));
    };
    return {
        renderBidiWarnings: renderBidiWarnings,
        warningLabel: warningLabel
    };
};

});


const $2965d2199c43f228$export$bd4f24d8b1e86b23 = `ak-renderer-tableHeader-sorting-icon`;


parcelRegister("bIQK1", function(module, exports) {

$parcel$export(module.exports, "TableHeader", () => $ae9592fb5e3881d8$export$f850895b287ef28e);
$parcel$export(module.exports, "TableCell", () => $ae9592fb5e3881d8$export$1e4baea7053fc0e3);

var $eUqFw = parcelRequire("eUqFw");

var $as9OS = parcelRequire("as9OS");
var $byxO6 = parcelRequire("byxO6");

var $4q38b = parcelRequire("4q38b");

var $8DyOy = parcelRequire("8DyOy");

var $bNZ6o = parcelRequire("bNZ6o");

var $izVyo = parcelRequire("izVyo");

var $3rMck = parcelRequire("3rMck");

var $auyn4 = parcelRequire("auyn4");

var $ghgHw = parcelRequire("ghgHw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $drghF = parcelRequire("drghF");
const $ae9592fb5e3881d8$var$IgnoreSorting = [
    'LABEL',
    'INPUT'
];
const $ae9592fb5e3881d8$var$nextStatusOrder = (currentSortOrder)=>{
    switch(currentSortOrder){
        case (0, $8DyOy.SortOrder).NO_ORDER:
            return (0, $8DyOy.SortOrder).ASC;
        case (0, $8DyOy.SortOrder).ASC:
            return (0, $8DyOy.SortOrder).DESC;
        case (0, $8DyOy.SortOrder).DESC:
            return (0, $8DyOy.SortOrder).NO_ORDER;
    }
    return (0, $8DyOy.SortOrder).NO_ORDER;
};
const $ae9592fb5e3881d8$var$getSortOrderLabel = (intl, currentSortOrder)=>{
    const { noneSortingLabel: noneSortingLabel, ascSortingLabel: ascSortingLabel, descSortingLabel: descSortingLabel } = (0, $drghF.tableCellMessages);
    switch(currentSortOrder){
        case (0, $8DyOy.SortOrder).NO_ORDER:
            return intl.formatMessage(noneSortingLabel);
        case (0, $8DyOy.SortOrder).ASC:
            return intl.formatMessage(ascSortingLabel);
        case (0, $8DyOy.SortOrder).DESC:
            return intl.formatMessage(descSortingLabel);
        default:
            return intl.formatMessage(noneSortingLabel);
    }
};
const $ae9592fb5e3881d8$var$getDataAttributes = (colwidth, background)=>{
    const attrs = {};
    if (colwidth) attrs['data-colwidth'] = colwidth.join(',');
    /**
   * Storing hex code in data-cell-background because
   *  we want to have DST token (css variable) or
   *  DST token value (value (hex code) of css variable) in
   *  inline style to correct render table cell background
   *  based on selected theme.
   * Currently we rely on background color hex code stored in
   *  inline style.
   * Because of that when we copy and paste table, we end up
   *  having DST token or DST token value in ADF instead of
   *  original hex code which we map to DST token.
   * So, introducing data-cell-background.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ if (background) attrs['data-cell-background'] = background;
    return attrs;
};
const $ae9592fb5e3881d8$var$getStyle = ({ background: background, colGroupWidth: colGroupWidth, offsetTop: offsetTop, colorMode: colorMode })=>{
    const style = {};
    if (background && // ignore setting inline styles if ds neutral token is detected
    !background.includes('--ds-background-neutral')) {
        /**
     * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
     * backgrounds persisted.
     *
     * This feature predates the introduction of dark mode.
     *
     * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-cell-background), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $bNZ6o.hexToEditorBackgroundPaletteRawValue)(background);
        if (tokenColor) style.backgroundColor = tokenColor;
        else // if we have a custom color, we need to check if we are in dark mode
        if (colorMode === 'dark') // if we are in dark mode, we need to invert the color
        style.backgroundColor = (0, $as9OS.getDarkModeLCHColor)(background);
        else // if we are in light mode, we can just set the color
        style.backgroundColor = background;
    }
    if (colGroupWidth) {
        style.width = colGroupWidth;
        style.minWidth = colGroupWidth;
    }
    if (offsetTop !== undefined) style.top = offsetTop;
    return style;
};
const $ae9592fb5e3881d8$var$getWithCellProps = (WrapperComponent)=>{
    return function WithCellProps(props) {
        const { colorMode: colorMode } = (0, $4q38b.default)();
        const { children: children, className: className, onClick: onClick, colwidth: colwidth, colGroupWidth: colGroupWidth, rowspan: rowspan, colspan: colspan, background: background, offsetTop: offsetTop, ariaSort: ariaSort } = props;
        // This is used to set the background color of the cell
        // to a dark mode color in mobile dark mode
        const colorName = background ? (0, $byxO6.tableBackgroundColorPalette).get(background) : '';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrapperComponent, {
            rowSpan: rowspan,
            colSpan: colspan,
            // Note: When content from a renderer is pasted into an editor
            // the background color is not taken from the inline style.
            // Instead it is taken from the data-cell-background attribute
            // (added via getDataAttributes below).
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: $ae9592fb5e3881d8$var$getStyle({
                background: background,
                colGroupWidth: colGroupWidth,
                offsetTop: offsetTop,
                colorMode: colorMode
            }),
            colorname: colorName,
            onClick: onClick,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            ...$ae9592fb5e3881d8$var$getDataAttributes(colwidth, background),
            "aria-sort": ariaSort
        }, children);
    };
};
const $ae9592fb5e3881d8$var$TH = $ae9592fb5e3881d8$var$getWithCellProps('th');
const $ae9592fb5e3881d8$export$cfca40ca5c56a38e = (WrapperComponent)=>{
    return function THWithSortableColumn(props) {
        const intl = (0, $5JgJ2.default)();
        const { allowColumnSorting: allowColumnSorting, onSorting: onSorting, children: children, sortOrdered: sortOrdered, isHeaderRow: isHeaderRow } = props;
        const sortOrderedClassName = sortOrdered === (0, $8DyOy.SortOrder).NO_ORDER ? (0, $ghgHw.RendererCssClassName).SORTABLE_COLUMN_NO_ORDER : '';
        if (!allowColumnSorting || !isHeaderRow) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrapperComponent, props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrapperComponent, {
            ...props,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $ghgHw.RendererCssClassName).SORTABLE_COLUMN_WRAPPER,
            ariaSort: $ae9592fb5e3881d8$var$getSortOrderLabel(intl, sortOrdered)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            className: (0, $ghgHw.RendererCssClassName).SORTABLE_COLUMN
        }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("figure", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `${(0, $ghgHw.RendererCssClassName).SORTABLE_COLUMN_ICON_WRAPPER} ${sortOrderedClassName}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $izVyo.default), {
            isSortingAllowed: !!onSorting,
            sortOrdered: sortOrdered,
            onClick: sort,
            onKeyDown: onKeyPress
        }))));
        function onKeyPress(event) {
            const keys = [
                ' ',
                'Enter',
                'Spacebar'
            ];
            const { tagName: tagName } = event.target;
            // trigger sorting if space or enter are clicked but not when in an input field (template variables)
            if (keys.includes(event.key) && !$ae9592fb5e3881d8$var$IgnoreSorting.includes(tagName)) {
                event.preventDefault();
                sort();
            }
        }
        function sort() {
            const { fireAnalyticsEvent: fireAnalyticsEvent, onSorting: onSorting, columnIndex: columnIndex, sortOrdered: sortOrdered } = props;
            if (onSorting && columnIndex != null) {
                const sortOrder = $ae9592fb5e3881d8$var$nextStatusOrder(sortOrdered);
                onSorting(columnIndex, sortOrder);
                fireAnalyticsEvent && fireAnalyticsEvent({
                    action: (0, $auyn4.ACTION).SORT_COLUMN,
                    actionSubject: (0, $auyn4.ACTION_SUBJECT).TABLE,
                    attributes: {
                        platform: (0, $3rMck.PLATFORM).WEB,
                        mode: (0, $3rMck.MODE).RENDERER,
                        columnIndex: columnIndex,
                        sortOrder: sortOrder
                    },
                    eventType: (0, $auyn4.EVENT_TYPE).TRACK
                });
            } else fireAnalyticsEvent && fireAnalyticsEvent({
                action: (0, $auyn4.ACTION).SORT_COLUMN_NOT_ALLOWED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).TABLE,
                attributes: {
                    platform: (0, $3rMck.PLATFORM).WEB,
                    mode: (0, $3rMck.MODE).RENDERER
                },
                eventType: (0, $auyn4.EVENT_TYPE).TRACK
            });
        }
    };
};
const $ae9592fb5e3881d8$export$f850895b287ef28e = $ae9592fb5e3881d8$export$cfca40ca5c56a38e($ae9592fb5e3881d8$var$TH);
const $ae9592fb5e3881d8$var$TD = $ae9592fb5e3881d8$var$getWithCellProps('td');
const $ae9592fb5e3881d8$export$1e4baea7053fc0e3 = $ae9592fb5e3881d8$var$TD;

});
parcelRegister("izVyo", function(module, exports) {

$parcel$export(module.exports, "default", () => $796bee0c360b8d27$export$2e2bcd8739ae039);
/** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $2qhQi = parcelRequire("2qhQi");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $8DyOy = parcelRequire("8DyOy");


var $9UY0g = parcelRequire("9UY0g");
function $796bee0c360b8d27$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $796bee0c360b8d27$export$c3618f310f725028;
(function(StatusClassNames) {
    StatusClassNames["ASC"] = "sorting-icon-svg__asc";
    StatusClassNames["DESC"] = "sorting-icon-svg__desc";
    StatusClassNames["NO_ORDER"] = "sorting-icon-svg__no_order";
    StatusClassNames["SORTING_NOT_ALLOWED"] = "sorting-icon-svg__not-allowed";
})($796bee0c360b8d27$export$c3618f310f725028 || ($796bee0c360b8d27$export$c3618f310f725028 = {}));
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $796bee0c360b8d27$var$buttonStyles = /*#__PURE__*/ (0, $byn9U.css)("position:absolute;display:flex;height:28px;width:28px;margin:var(--ds-space-075, 6px);right:0;top:0;border:2px solid var(--ds-border, #fff);border-radius:var(--ds-border-radius-100, 4px);background-color:", `var(--ds-surface-overlay, ${(0, $PdmhA.N20)})`, ";justify-content:center;align-items:center;cursor:pointer;&:hover{background-color:", `var(--ds-surface-overlay-hovered, ${(0, $PdmhA.N30)})`, ";}&:active{background-color:var(--ds-surface-overlay-pressed, rgba(179, 212, 255, 0.6));}&.", (0, $2965d2199c43f228$export$bd4f24d8b1e86b23), "__not-allowed{cursor:not-allowed;}");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $796bee0c360b8d27$var$iconWrapperStyles = /*#__PURE__*/ (0, $byn9U.css)("width:8px;height:12px;transition:transform 0.3s cubic-bezier(0.15, 1, 0.3, 1);transform-origin:50% 50%;display:flex;justify-content:center;&.", "sorting-icon-svg__desc", "{transform:rotate(-180deg);}&.", (0, $2965d2199c43f228$export$bd4f24d8b1e86b23), "-inactive{opacity:0.7;}");
// The icon is created with CSS due to the following Firefox issue: https://product-fabric.atlassian.net/browse/ED-8001
// The TL;DR is that svg's in tables mess up how HTML is copied in Firefox. Using a styled div instead solves the problem.
// For this reason, svg's should be avoided in tables until this issue is fixed: https://bugzilla.mozilla.org/show_bug.cgi?id=1664350
const $796bee0c360b8d27$var$iconStyles = {
    name: "1uj2pwb",
    styles: "height:100%;width:2px;border-radius:50px;background:var(--ds-icon, #42526E);&::before, &::after{background:var(--ds-icon, #42526E);content:'';height:2px;width:6px;position:absolute;border-radius:50px;}&::before{transform:rotate(45deg) translate(3.4px, 8.5px);}&::after{transform:rotate(-45deg) translate(-6.3px, 5.7px);}"
};
const $796bee0c360b8d27$var$getIconClassName = (isSortingAllowed, sortOrdered)=>{
    const activated = sortOrdered !== (0, $8DyOy.SortOrder).NO_ORDER;
    const activeStatusClass = `${(0, $2965d2199c43f228$export$bd4f24d8b1e86b23)}-${activated ? 'active' : 'inactive'}`;
    if (!isSortingAllowed) return `${"sorting-icon-svg__not-allowed"} ${activeStatusClass}`;
    switch(sortOrdered){
        case (0, $8DyOy.SortOrder).ASC:
            return `${"sorting-icon-svg__asc"} ${activeStatusClass}`;
        case (0, $8DyOy.SortOrder).DESC:
            return `${"sorting-icon-svg__desc"} ${activeStatusClass}`;
        default:
            return `${"sorting-icon-svg__no_order"} ${activeStatusClass}`;
    }
};
const $796bee0c360b8d27$var$getTooltipTitle = (intl, isSortingAllowed, sortOrdered)=>{
    const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel } = (0, $9UY0g.sortingIconMessages);
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $8DyOy.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $8DyOy.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $8DyOy.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return '';
};
const $796bee0c360b8d27$var$getAriaLabel = (intl, isSortingAllowed, sortOrdered)=>{
    const { noOrderLabel: noOrderLabel, ascOrderLabel: ascOrderLabel, descOrderLabel: descOrderLabel, invalidLabel: invalidLabel, defaultLabel: defaultLabel } = (0, $9UY0g.sortingAriaLabelMessages);
    if (!isSortingAllowed) return intl.formatMessage(invalidLabel);
    switch(sortOrdered){
        case (0, $8DyOy.SortOrder).NO_ORDER:
            return intl.formatMessage(noOrderLabel);
        case (0, $8DyOy.SortOrder).ASC:
            return intl.formatMessage(ascOrderLabel);
        case (0, $8DyOy.SortOrder).DESC:
            return intl.formatMessage(descOrderLabel);
    }
    return intl.formatMessage(defaultLabel);
};
const $796bee0c360b8d27$var$SortingIcon = ({ isSortingAllowed: isSortingAllowed, sortOrdered: sortOrdered, intl: intl, onClick: onClick, onKeyDown: onKeyDown })=>{
    const buttonClassName = `${(0, $2965d2199c43f228$export$bd4f24d8b1e86b23)} ${sortOrdered !== (0, $8DyOy.SortOrder).NO_ORDER ? 'is-active' : ''}${isSortingAllowed ? '' : ` ${0, $2965d2199c43f228$export$bd4f24d8b1e86b23}__not-allowed `}`;
    const content = $796bee0c360b8d27$var$getTooltipTitle(intl, isSortingAllowed, sortOrdered);
    const ariaLabel = $796bee0c360b8d27$var$getAriaLabel(intl, isSortingAllowed, sortOrdered);
    const handleClick = ()=>{
        if (isSortingAllowed) onClick();
    };
    const handleKeyDown = (event)=>{
        if (isSortingAllowed) onKeyDown(event);
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cU5f.default), {
        delay: 0,
        content: content,
        position: "top"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $796bee0c360b8d27$var$buttonStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: buttonClassName,
        role: "button",
        tabIndex: isSortingAllowed ? 0 : -1,
        "aria-label": ariaLabel,
        "aria-disabled": !isSortingAllowed,
        onClick: handleClick,
        onKeyDown: handleKeyDown
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $796bee0c360b8d27$var$iconWrapperStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $796bee0c360b8d27$var$getIconClassName(isSortingAllowed, sortOrdered)
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $796bee0c360b8d27$var$iconStyles
    }))));
};
var $796bee0c360b8d27$export$2e2bcd8739ae039 = (0, $2qhQi.default)($796bee0c360b8d27$var$SortingIcon);

});
parcelRegister("9UY0g", function(module, exports) {

$parcel$export(module.exports, "sortingIconMessages", () => $7a4513affbf7abf6$export$458c50917513cd1a);
$parcel$export(module.exports, "sortingAriaLabelMessages", () => $7a4513affbf7abf6$export$f142573f51a67577);

var $90IgZ = parcelRequire("90IgZ");
const $7a4513affbf7abf6$export$458c50917513cd1a = (0, $90IgZ.defineMessages)({
    noOrderLabel: {
        id: 'fabric.editor.headingLink.noOrderLabel',
        defaultMessage: 'Sort column A to Z',
        description: 'Sort the column in ascending order'
    },
    ascOrderLabel: {
        id: 'fabric.editor.headingLink.ascOrderLabel',
        defaultMessage: 'Sort column Z to A',
        description: 'Sort the column in descending order'
    },
    descOrderLabel: {
        id: 'fabric.editor.headingLink.descOrderLabel',
        defaultMessage: 'Clear sorting',
        description: 'clear the sorting from this column'
    },
    invalidLabel: {
        id: 'fabric.editor.headingLink.invalidLabel',
        defaultMessage: `\u{26A0}\u{FE0F}  You can't sort a table with merged cells`,
        description: 'this sort is invalid for merged cells'
    }
});
const $7a4513affbf7abf6$export$f142573f51a67577 = (0, $90IgZ.defineMessages)({
    noOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.no',
        defaultMessage: 'No sort applied to the column',
        description: 'Aria-label for Sort column button when sorting was not applied or the sorting has been cleared'
    },
    ascOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.asc',
        defaultMessage: 'Ascending sort applied',
        description: 'Aria-label for Sort column button when ascending sorting was applied'
    },
    descOrderLabel: {
        id: 'fabric.editor.tableHeader.sorting.desc',
        defaultMessage: 'Descending sort applied',
        description: 'Aria-label for Sort column button when descending sorting was applied'
    },
    invalidLabel: {
        id: 'fabric.editor.tableHeader.sorting.invalid',
        defaultMessage: `You can't sort a table with merged cells`,
        description: 'Aria-label for Sort column button when sorting is not possible'
    },
    defaultLabel: {
        id: 'fabric.editor.tableHeader.sorting.default',
        defaultMessage: 'Sort the column',
        description: 'Default aria-label for Sort column button'
    }
});

});



parcelRegister("2dNsW", function(module, exports) {

$parcel$export(module.exports, "Provider", () => $51ce6dfb65debd17$export$2881499e37b75b9a);
$parcel$export(module.exports, "withSmartCardStorage", () => $51ce6dfb65debd17$export$65e2d5a272a382b0);

var $eUqFw = parcelRequire("eUqFw");
const $51ce6dfb65debd17$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(new Map());
const $51ce6dfb65debd17$export$2881499e37b75b9a = function({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($51ce6dfb65debd17$export$841858b892ce1f4c.Provider, {
        value: new Map()
    }, children);
};
const $51ce6dfb65debd17$export$65e2d5a272a382b0 = (WrappedComponent)=>{
    return class extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
        render() {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($51ce6dfb65debd17$export$841858b892ce1f4c.Consumer, null, (storage)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                    ...this.props,
                    smartCardStorage: storage
                }));
        }
    };
};

});

parcelRegister("8GvDy", function(module, exports) {

$parcel$export(module.exports, "tableStickyPadding", () => $6c193b8ede21e024$export$3de6413b528017ca);
$parcel$export(module.exports, "StickyTable", () => $6c193b8ede21e024$export$fd9654fc359d55a3);
$parcel$export(module.exports, "OverflowParent", () => $6c193b8ede21e024$export$e97bc6692974bd0b);
/** @jsx jsx */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $mJhHc = parcelRequire("mJhHc");

var $25FYC = parcelRequire("25FYC");

var $PdmhA = parcelRequire("PdmhA");

var $5pCn0 = parcelRequire("5pCn0");

var $dAsgR = parcelRequire("dAsgR");

var $5hibD = parcelRequire("5hibD");
function $6c193b8ede21e024$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6c193b8ede21e024$export$3de6413b528017ca = 8;
const $6c193b8ede21e024$var$modeSpecficStyles = {
    none: {
        name: "eivff4",
        styles: "display:none"
    },
    stick: {
        name: "duudsh",
        styles: "position:fixed"
    },
    'pin-bottom': {
        name: "a4hmbt",
        styles: "position:absolute"
    }
};
// TODO: Quality ticket: https://product-fabric.atlassian.net/browse/DSP-4123
const $6c193b8ede21e024$var$fixedTableDivStaticStyles = (top, width, rendererAppearance)=>{
    let stickyHeaderZIndex;
    if ((0, $5hibD.isTableResizingEnabled)(rendererAppearance)) stickyHeaderZIndex = 13;
    else stickyHeaderZIndex = (0, $25FYC.akEditorStickyHeaderZIndex);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $byn9U.css)(typeof top === 'number' && `top: ${top}px;`, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${width}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex: stickyHeaderZIndex,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`& .${(0, $mJhHc.TableSharedCssClassName).TABLE_CONTAINER}, & .${(0, $mJhHc.TableSharedCssClassName).TABLE_STICKY_WRAPPER} > table`]: {
            marginTop: 0,
            marginBottom: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            tr: {
                background: "var(--ds-surface, white)"
            }
        },
        borderTop: `${$6c193b8ede21e024$export$3de6413b528017ca}px solid ${"var(--ds-surface, white)"}`,
        background: "var(--ds-surface-overlay, white)",
        boxShadow: `0 6px 4px -4px ${`var(--ds-shadow-overflow-perimeter, ${(0, $PdmhA.N40A)})`}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "div[data-expanded='false'] &": {
            display: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [`& .${(0, $mJhHc.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.right-shadow::after, & .${(0, $mJhHc.TableSharedCssClassName).TABLE_CONTAINER}.is-sticky.left-shadow::before`]: {
            top: '0px',
            height: '100%'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "&.fixed-table-div-custom-table-resizing[mode='stick']": {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            zIndex: stickyHeaderZIndex
        }
    });
};
const $6c193b8ede21e024$export$c32334a490c1bcab = (props)=>{
    const { top: top, wrapperWidth: wrapperWidth, mode: mode, rendererAppearance: rendererAppearance } = props;
    const fixedTableCss = [
        $6c193b8ede21e024$var$fixedTableDivStaticStyles(top, wrapperWidth, rendererAppearance),
        $6c193b8ede21e024$var$modeSpecficStyles?.[mode]
    ];
    const attrs = {
        mode: mode
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...attrs,
        "data-testid": "sticky-table-fixed",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $5hibD.isTableResizingEnabled)(rendererAppearance) ? 'fixed-table-div-custom-table-resizing' : '',
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: fixedTableCss
    }, props.children);
};
const $6c193b8ede21e024$export$fd9654fc359d55a3 = ({ top: top, left: left, mode: mode, shadowClassNames: shadowClassNames, innerRef: innerRef, wrapperWidth: wrapperWidth, tableWidth: tableWidth, isNumberColumnEnabled: isNumberColumnEnabled, layout: layout, children: children, columnWidths: columnWidths, renderWidth: renderWidth, rowHeight: rowHeight, tableNode: tableNode, rendererAppearance: rendererAppearance })=>{
    let styles;
    /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ if ((0, $5hibD.isTableResizingEnabled)(rendererAppearance)) styles = /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: mode === 'pin-bottom' ? top : undefined,
        position: 'absolute'
    });
    else styles = /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        left: left && left < 0 ? left : undefined,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        top: mode === 'pin-bottom' ? top : undefined,
        position: 'relative'
    });
    /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: styles
    }, /*#__PURE__*/ (0, $byn9U.jsx)($6c193b8ede21e024$export$c32334a490c1bcab, {
        top: mode === 'stick' ? top : undefined,
        mode: rowHeight > 300 ? 'none' : mode,
        wrapperWidth: wrapperWidth,
        rendererAppearance: rendererAppearance
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $mJhHc.TableSharedCssClassName).TABLE_CONTAINER} is-sticky ${shadowClassNames || ''}`,
        "data-layout": layout,
        style: {
            width: tableWidth
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${(0, $mJhHc.TableSharedCssClassName).TABLE_STICKY_WRAPPER}`,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $5pCn0.Table), {
        columnWidths: columnWidths,
        layout: layout,
        isNumberColumnEnabled: isNumberColumnEnabled,
        renderWidth: renderWidth,
        tableNode: tableNode,
        rendererAppearance: rendererAppearance
    }, /**
               * @see https://product-fabric.atlassian.net/browse/ED-10235
               * We pass prop 'invisible' to our table's children nodes meaning
               * they exist inside of the 'invisible' duplicated table component that
               * enables sticky headers.
               */ (0, $dAsgR.recursivelyInjectProps)(children, {
        invisible: true
    })))))));
};
/**
 * Traverse DOM Tree upwards looking for table parents with "overflow: scroll".
 */ function $6c193b8ede21e024$var$findHorizontalOverflowScrollParent(table) {
    let parent = table;
    if (!parent) return null;
    while(parent = parent.parentElement){
        // IE11 on Window 8 doesn't show styles from CSS when accessing through element.style property.
        const style = window.getComputedStyle(parent);
        if (style.overflow === 'scroll' || style.overflowY === 'scroll') return parent;
    }
    return null;
}
class $6c193b8ede21e024$export$e97bc6692974bd0b {
    constructor(ref){
        this.ref = ref;
        this.ref = ref;
    }
    static fromElement(el) {
        return new $6c193b8ede21e024$export$e97bc6692974bd0b($6c193b8ede21e024$var$findHorizontalOverflowScrollParent(el) || window);
    }
    get isElement() {
        return this.ref instanceof HTMLElement;
    }
    get top() {
        if (this.ref instanceof HTMLElement) return this.ref.getBoundingClientRect().top;
        return 0;
    }
    addEventListener(type, cb, ...args) {
        this.ref.addEventListener(type, cb, ...args);
    }
    removeEventListener(type, cb, ...args) {
        this.ref.removeEventListener(type, cb, ...args);
    }
}

});
parcelRegister("5pCn0", function(module, exports) {

$parcel$export(module.exports, "Table", () => $d1450a2ad961c3d0$export$54ec01a60f47d33d);

var $eUqFw = parcelRequire("eUqFw");

var $7LRgQ = parcelRequire("7LRgQ");

var $2JJ1l = parcelRequire("2JJ1l");

var $25FYC = parcelRequire("25FYC");
const $d1450a2ad961c3d0$export$54ec01a60f47d33d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(({ innerRef: innerRef, isNumberColumnEnabled: isNumberColumnEnabled, columnWidths: columnWidths, layout: layout, renderWidth: renderWidth, children: children, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension })=>{
    const tableWidth = tableNode ? (0, $2JJ1l.getTableContainerWidth)(tableNode) : (0, $25FYC.akEditorDefaultLayoutWidth);
    const tableLayout = tableNode?.attrs.layout;
    const tableDisplayMode = tableNode?.attrs.displayMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("table", {
        "data-testid": "renderer-table",
        "data-number-column": isNumberColumnEnabled,
        "data-table-width": tableWidth,
        "data-layout": tableLayout,
        "data-table-display-mode": tableDisplayMode,
        ref: innerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7LRgQ.Colgroup), {
        columnWidths: columnWidths,
        layout: layout,
        isNumberColumnEnabled: isNumberColumnEnabled,
        renderWidth: renderWidth,
        tableNode: tableNode,
        rendererAppearance: rendererAppearance,
        isInsideOfBlockNode: isInsideOfBlockNode,
        isinsideMultiBodiedExtension: isinsideMultiBodiedExtension
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tbody", null, children));
});

});
parcelRegister("7LRgQ", function(module, exports) {

$parcel$export(module.exports, "Colgroup", () => $f7bcc0c4e516d135$export$89efc2d0ceeaa030);

var $eUqFw = parcelRequire("eUqFw");

var $mJhHc = parcelRequire("mJhHc");

var $25FYC = parcelRequire("25FYC");

var $2JJ1l = parcelRequire("2JJ1l");

var $5hibD = parcelRequire("5hibD");

var $XHGTv = parcelRequire("XHGTv");

var $aSvLw = parcelRequire("aSvLw");
// we allow scaling down column widths by no more than 30%
// this intends to reduce unwanted scrolling in the Renderer in these scenarios:
// User A creates a table with column widths → User B views it on a smaller screen
// User A creates a table with column widths → User A views it with reduced viewport space (eg. Confluence sidebar is open)
const $f7bcc0c4e516d135$var$MAX_SCALING_PERCENT = 0.3;
const $f7bcc0c4e516d135$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION = 0.4;
const $f7bcc0c4e516d135$var$isTableResized = (columnWidths)=>{
    const filteredWidths = columnWidths.filter((width)=>width !== 0);
    return !!filteredWidths.length;
};
const $f7bcc0c4e516d135$var$fixColumnWidth = (columnWidth, _tableWidth, _layoutWidth, zeroWidthColumnsCount, scaleDownPercent)=>{
    if (columnWidth === 0) return columnWidth;
    // If the tables total width (including no zero widths col or cols without width) is less than the current layout
    // We scale up the columns to meet the minimum of the table layout.
    if (zeroWidthColumnsCount === 0 && scaleDownPercent) return Math.max(Math.floor((1 - scaleDownPercent) * columnWidth), (0, $mJhHc.tableCellMinWidth));
    return Math.max(// We need to take tableCellBorderWidth, to avoid unnecessary overflow.
    columnWidth - (0, $mJhHc.tableCellBorderWidth), zeroWidthColumnsCount ? (0, $25FYC.akEditorTableLegacyCellMinWidth) : (0, $mJhHc.tableCellMinWidth));
};
const $f7bcc0c4e516d135$export$825b9ec54e6e762c = ({ renderWidth: renderWidth, tableWidth: tableWidth, maxScale: maxScale })=>{
    const diffPercent = 1 - renderWidth / tableWidth;
    return diffPercent < maxScale ? diffPercent : maxScale;
};
const $f7bcc0c4e516d135$var$colWidthSum = (columnWidths)=>columnWidths.reduce((prev, curr)=>curr + prev, 0);
const $f7bcc0c4e516d135$var$renderScaleDownColgroup = (props)=>{
    let { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled, renderWidth: renderWidth, tableNode: tableNode, rendererAppearance: rendererAppearance, isInsideOfBlockNode: isInsideOfBlockNode, isinsideMultiBodiedExtension: isinsideMultiBodiedExtension, isTableScalingEnabled: isTableScalingEnabled, isTableFixedColumnWidthsOptionEnabled: isTableFixedColumnWidthsOptionEnabled } = props;
    if (!columnWidths) return [];
    const tableResized = $f7bcc0c4e516d135$var$isTableResized(columnWidths);
    const noOfColumns = columnWidths.length;
    let targetWidths;
    const tableContainerWidth = (0, $2JJ1l.getTableContainerWidth)(tableNode);
    if ((0, $5hibD.isTableResizingEnabled)(rendererAppearance) && !isInsideOfBlockNode && !isinsideMultiBodiedExtension && !tableResized) {
        // for tables with no column widths defined, assume that the real table width
        // is defined by node.attrs.width
        const tableWidth = (isNumberColumnEnabled ? tableContainerWidth - (0, $25FYC.akEditorTableNumberColumnWidth) : tableContainerWidth) - 1;
        const defaultColumnWidth = tableWidth / noOfColumns;
        targetWidths = new Array(noOfColumns).fill(defaultColumnWidth);
    } else if (!tableResized) return null;
    const sumOfColumns = $f7bcc0c4e516d135$var$colWidthSum(columnWidths);
    // tables in the wild may be smaller than table container width (col resizing bugs, created before custom widths etc.)
    // this causes issues with num column scaling as we add a new table column in renderer
    const isTableSmallerThanContainer = sumOfColumns < tableContainerWidth - 1;
    const forceScaleForNumColumn = (0, $XHGTv.getBooleanFF)('platform.editor.scale-table-when-number-column-in-table-resized_y4qh2') && isTableScalingEnabled && isNumberColumnEnabled && tableResized;
    // when table resized and number column is enabled, we need to scale down the table in render
    if (forceScaleForNumColumn) {
        const scalePercentage = +((tableContainerWidth - (0, $25FYC.akEditorTableNumberColumnWidth)) / tableContainerWidth);
        const targetMaxWidth = tableContainerWidth - (0, $25FYC.akEditorTableNumberColumnWidth);
        let totalWidthAfterScale = 0;
        const newScaledTargetWidths = columnWidths.map((width)=>{
            // we need to scale each column UP, to ensure total width of table matches table container
            const patchedWidth = isTableSmallerThanContainer ? width / sumOfColumns * (tableContainerWidth - 1) : width;
            const newWidth = Math.floor(patchedWidth * scalePercentage);
            totalWidthAfterScale += newWidth;
            return newWidth;
        });
        const diff = targetMaxWidth - totalWidthAfterScale;
        targetWidths = newScaledTargetWidths;
        if (diff > 0 || diff < 0 && Math.abs(diff) < (0, $mJhHc.tableCellMinWidth)) {
            let updated = false;
            targetWidths = targetWidths.map((width)=>{
                if (!updated && width + diff > (0, $mJhHc.tableCellMinWidth)) {
                    updated = true;
                    width += diff;
                }
                return width;
            });
        }
    }
    targetWidths = targetWidths || columnWidths;
    // @see ED-6056
    const maxTableWidth = renderWidth < tableContainerWidth ? renderWidth : tableContainerWidth;
    let tableWidth = isNumberColumnEnabled ? (0, $25FYC.akEditorTableNumberColumnWidth) : 0;
    let minTableWidth = tableWidth;
    let zeroWidthColumnsCount = 0;
    targetWidths.forEach((width)=>{
        if (width) tableWidth += Math.ceil(width);
        else zeroWidthColumnsCount += 1;
        minTableWidth += Math.ceil(width) || (0, $25FYC.akEditorTableLegacyCellMinWidth);
    });
    let cellMinWidth = 0;
    let scaleDownPercent = 0;
    const isTableScalingWithFixedColumnWidthsOptionEnabled = isTableScalingEnabled && isTableFixedColumnWidthsOptionEnabled;
    const isTableWidthFixed = isTableScalingWithFixedColumnWidthsOptionEnabled && props.tableNode?.attrs.displayMode === 'fixed';
    const maxScalingPercent = (0, $XHGTv.getBooleanFF)('platform.editor.table.use-increased-scaling-percent') && isTableScalingWithFixedColumnWidthsOptionEnabled ? $f7bcc0c4e516d135$var$MAX_SCALING_PERCENT_TABLES_WITH_FIXED_COLUMN_WIDTHS_OPTION : $f7bcc0c4e516d135$var$MAX_SCALING_PERCENT;
    // fixes migration tables with zero-width columns
    if (zeroWidthColumnsCount > 0) {
        if (minTableWidth > maxTableWidth) {
            const minWidth = Math.ceil((maxTableWidth - tableWidth) / zeroWidthColumnsCount);
            cellMinWidth = minWidth < (0, $25FYC.akEditorTableLegacyCellMinWidth) ? (0, $25FYC.akEditorTableLegacyCellMinWidth) : minWidth;
        }
    } else if (renderWidth < tableWidth && !isTableWidthFixed) scaleDownPercent = $f7bcc0c4e516d135$export$825b9ec54e6e762c({
        renderWidth: renderWidth,
        tableWidth: tableWidth,
        maxScale: maxScalingPercent
    });
    return targetWidths.map((colWidth)=>{
        const width = $f7bcc0c4e516d135$var$fixColumnWidth(colWidth, minTableWidth, maxTableWidth, zeroWidthColumnsCount, scaleDownPercent) || cellMinWidth;
        const style = width ? {
            width: `${width}px`
        } : {};
        return style;
    });
};
const $f7bcc0c4e516d135$export$89efc2d0ceeaa030 = (props)=>{
    let { columnWidths: columnWidths, isNumberColumnEnabled: isNumberColumnEnabled } = props;
    const flags = (0, $aSvLw.useFeatureFlags)();
    if (!columnWidths) return null;
    const colStyles = $f7bcc0c4e516d135$var$renderScaleDownColgroup({
        ...props,
        isTableScalingEnabled: !!(flags && 'tablePreserveWidth' in flags && flags.tablePreserveWidth),
        isTableFixedColumnWidthsOptionEnabled: !!(flags && 'tableWithFixedColumnWidthsOption' in flags && flags.tableWithFixedColumnWidthsOption)
    });
    if (!colStyles) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("colgroup", null, isNumberColumnEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("col", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            width: (0, $25FYC.akEditorTableNumberColumnWidth)
        },
        "data-test-id": 'num'
    }), colStyles.map((style, idx)=>// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("col", {
            key: idx,
            style: style
        })));
};

});
parcelRegister("aSvLw", function(module, exports) {

$parcel$export(module.exports, "useFeatureFlags", () => $28a890e9aac82cf9$export$90335b3ff08f335);

var $0jEfW = parcelRequire("0jEfW");
const $28a890e9aac82cf9$export$90335b3ff08f335 = ()=>(0, $0jEfW.useRendererContext)()?.featureFlags;

});
parcelRegister("0jEfW", function(module, exports) {

$parcel$export(module.exports, "useRendererContext", () => $d436489e1336a0a8$export$a906432540ed7ed8);
$parcel$export(module.exports, "RendererContextProvider", () => $d436489e1336a0a8$export$ca5df47902194781);

var $eUqFw = parcelRequire("eUqFw");
const $d436489e1336a0a8$var$RendererContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({});
const $d436489e1336a0a8$export$a906432540ed7ed8 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext($d436489e1336a0a8$var$RendererContext);
const $d436489e1336a0a8$export$ca5df47902194781 = $d436489e1336a0a8$var$RendererContext.Provider;

});




parcelRegister("dAsgR", function(module, exports) {

$parcel$export(module.exports, "recursivelyInjectProps", () => $914d0966c8d84305$export$40e12ce8e0a76b0c);

var $eUqFw = parcelRequire("eUqFw");
function $914d0966c8d84305$export$40e12ce8e0a76b0c(children, propsToInject) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(children).map((child)=>{
        // Cannot add a prop to an invalid element, so just return the child
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(child)) return child;
        // Recursive call if child has nested children
        if (child.props.children) child = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(child, {
            children: $914d0966c8d84305$export$40e12ce8e0a76b0c(child.props.children, propsToInject)
        });
        // Add props to react child node
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(child, propsToInject);
    });
}

});


parcelRegister("5IOJr", function(module, exports) {

$parcel$export(module.exports, "isFullWidthAppearance", () => $4ca9a9ced50544ff$export$c0112b8340d4924b);
$parcel$export(module.exports, "isFullPageAppearance", () => $4ca9a9ced50544ff$export$a64737a81cde10b4);
$parcel$export(module.exports, "isFullWidthOrFullPageAppearance", () => $4ca9a9ced50544ff$export$33331a99fac775a1);
const $4ca9a9ced50544ff$export$c0112b8340d4924b = (appearance)=>appearance === 'full-width';
const $4ca9a9ced50544ff$export$a64737a81cde10b4 = (appearance)=>appearance === 'full-page';
const $4ca9a9ced50544ff$export$33331a99fac775a1 = (appearance)=>$4ca9a9ced50544ff$export$a64737a81cde10b4(appearance) || $4ca9a9ced50544ff$export$c0112b8340d4924b(appearance);

});


parcelRegister("eFI96", function(module, exports) {

$parcel$export(module.exports, "default", () => $95840539bf259587$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iYHWS = parcelRequire("iYHWS");

var $8DyOy = parcelRequire("8DyOy");

var $ghgHw = parcelRequire("ghgHw");
class $95840539bf259587$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { children: children, innerRef: innerRef } = this.props;
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", {
            ref: innerRef
        }, this.props.isNumberColumnEnabled && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("td", {
            className: (0, $ghgHw.RendererCssClassName).NUMBER_COLUMN
        }, this.props.index), (0, $iYHWS.compose)(this.addSortableColumn, this.addColGroupWidth)(childrenArray));
    }
    constructor(...args){
        super(...args);
        this.state = {
            colGroupWidths: []
        };
        this.addSortableColumn = (childrenArray)=>{
            const { allowColumnSorting: allowColumnSorting, index: rowIndex } = this.props;
            if (allowColumnSorting) {
                const isHeaderRow = !rowIndex;
                childrenArray = childrenArray.map((child, index)=>{
                    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(child)) {
                        const { tableOrderStatus: tableOrderStatus } = this.props;
                        let sortOrdered = (0, $8DyOy.SortOrder).NO_ORDER;
                        if (tableOrderStatus) sortOrdered = index === tableOrderStatus.columnIndex ? tableOrderStatus.order : (0, $8DyOy.SortOrder).NO_ORDER;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(child, {
                            columnIndex: index,
                            onSorting: this.props.onSorting,
                            sortOrdered: sortOrdered,
                            isHeaderRow: isHeaderRow
                        });
                    }
                });
            }
            return childrenArray;
        };
        this.addColGroupWidth = (childrenArray)=>{
            if (this.state.colGroupWidths) childrenArray = childrenArray.map((child, index)=>{
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(child)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(child, {
                    colGroupWidth: this.state.colGroupWidths[index]
                });
            });
            return childrenArray;
        };
    }
}

});

parcelRegister("7GWuD", function(module, exports) {

$parcel$export(module.exports, "default", () => $7aa19c407521dacd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $7aa19c407521dacd$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: "UnknownBlock"
    }, props.children);
}

});

parcelRegister("SceRA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6545cc1fcc87ffd$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2qhQi = parcelRequire("2qhQi");

var $25FYC = parcelRequire("25FYC");

var $ioiQ7 = parcelRequire("ioiQ7");

var $PdmhA = parcelRequire("PdmhA");

var $lcnyw = parcelRequire("lcnyw");

var $8cU5f = parcelRequire("8cU5f");

var $auyn4 = parcelRequire("auyn4");

var $jlmhn = parcelRequire("jlmhn");

var $2pBoL = parcelRequire("2pBoL");

var $fwrz2 = parcelRequire("fwrz2");
const $c6545cc1fcc87ffd$var$inlineNodeStyle = /*#__PURE__*/ (0, $byn9U.css)({
    alignItems: 'center',
    background: `var(--ds-background-disabled, ${(0, $PdmhA.N30)})`,
    border: `1px dashed ${`var(--ds-border-disabled, ${(0, $PdmhA.N50)})`}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `${(0, $lcnyw.borderRadius)()}px`,
    boxSizing: 'border-box',
    cursor: 'default',
    display: 'inline-flex',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $25FYC.relativeFontSizeToBase16)((0, $lcnyw.fontSize)()),
    margin: `0 ${"var(--ds-space-025, 2px)"}`,
    minHeight: '24px',
    padding: `0 ${"var(--ds-space-100, 8px)"}`,
    verticalAlign: 'middle',
    whiteSpace: 'nowrap'
});
const $c6545cc1fcc87ffd$var$UnsupportedInlineNode = ({ node: node, intl: intl, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const message = (0, $fwrz2.getUnsupportedContent)((0, $jlmhn.unsupportedContentMessages).unsupportedInlineContent, 'Unsupported', node, intl);
    const tooltipContent = intl.formatMessage((0, $jlmhn.unsupportedContentMessages).unsupportedContentTooltip);
    const { current: style } = (0, $eUqFw.useRef)({
        padding: '4px'
    });
    const originalNodeType = node?.attrs.originalValue.type;
    const tooltipOnShowHandler = (0, $eUqFw.useCallback)(()=>dispatchAnalyticsEvent && (0, $2pBoL.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $auyn4.ACTION_SUBJECT_ID).ON_UNSUPPORTED_INLINE, originalNodeType), [
        dispatchAnalyticsEvent,
        originalNodeType
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $c6545cc1fcc87ffd$var$inlineNodeStyle
    }, message, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cU5f.default), {
        content: tooltipContent,
        hideTooltipOnClick: false,
        position: "bottom",
        onShow: tooltipOnShowHandler,
        strategy: "absolute"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        style: style
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ioiQ7))), {
        label: "?",
        size: "small"
    }))));
};
var $c6545cc1fcc87ffd$export$2e2bcd8739ae039 = (0, $2qhQi.default)($c6545cc1fcc87ffd$var$UnsupportedInlineNode);

});

parcelRegister("hdZzW", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('3xOzk');
        const value = parcelRequire('iG4VC');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("3xOzk").then(()=>parcelRequire('iG4VC'));
}

});

parcelRegister("hV2nj", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('6Fj3f');
        const value = parcelRequire('gfKzF');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("6Fj3f").then(()=>parcelRequire('gfKzF'));
}

});

parcelRegister("8X5AK", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('ezj2q');
        const value = parcelRequire('lqYEs');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("ezj2q").then(()=>parcelRequire('lqYEs'));
}

});

parcelRegister("4pDEH", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('7RqT5')
        ]);
        const value = parcelRequire('9WngA');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("7RqT5")
    ]).then(()=>parcelRequire('9WngA'));
}

});

parcelRegister("cpwUf", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('61wTT');
        const value = parcelRequire('aEQmM');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("61wTT").then(()=>parcelRequire('aEQmM'));
}

});

parcelRegister("iwWxo", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('iuBLh');
        const value = parcelRequire('92FiY');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("iuBLh").then(()=>parcelRequire('92FiY'));
}

});

parcelRegister("dT3NP", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('1lROW');
        const value = parcelRequire('koyU4');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("1lROW").then(()=>parcelRequire('koyU4'));
}

});

parcelRegister("bs2b1", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('3ZQaF')
        ]);
        const value = parcelRequire('b5oht');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("3ZQaF")
    ]).then(()=>parcelRequire('b5oht'));
}

});

parcelRegister("2oofV", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('iNpPm');
        const value = parcelRequire('lFdD2');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("iNpPm").then(()=>parcelRequire('lFdD2'));
}

});

parcelRegister("eGdwO", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('3Qpga');
        const value = parcelRequire('5Av7A');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("3Qpga").then(()=>parcelRequire('5Av7A'));
}

});

parcelRegister("2wIVv", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('okTix')
        ]);
        const value = parcelRequire('358j8');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("okTix")
    ]).then(()=>parcelRequire('358j8'));
}

});

parcelRegister("7wd1u", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('655BX')
        ]);
        const value = parcelRequire('7aetn');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("655BX")
    ]).then(()=>parcelRequire('7aetn'));
}

});

parcelRegister("7DeSP", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('1xrTu')
        ]);
        const value = parcelRequire('7DTTy');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("1xrTu")
    ]).then(()=>parcelRequire('7DTTy'));
}

});

parcelRegister("jCPfL", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('bbbuZ');
        const value = parcelRequire('amerF');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("bbbuZ").then(()=>parcelRequire('amerF'));
}

});

parcelRegister("inOsC", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('c8Dgp');
        const value = parcelRequire('24XFv');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("c8Dgp").then(()=>parcelRequire('24XFv'));
}

});

parcelRegister("auWO3", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('hPzOn'),
            load('f6tBu')
        ]);
        const value = parcelRequire('2nIQG');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("hPzOn"),
        load("f6tBu")
    ]).then(()=>parcelRequire('2nIQG'));
}

});

parcelRegister("gm2m3", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('eK2pl');
        const value = parcelRequire('2DI79');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("eK2pl").then(()=>parcelRequire('2DI79'));
}

});

parcelRegister("idS5t", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('zMxKU')
        ]);
        const value = parcelRequire('4UCtC');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("zMxKU")
    ]).then(()=>parcelRequire('4UCtC'));
}

});

parcelRegister("45J2i", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('fGRiM')
        ]);
        const value = parcelRequire('foh2b');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("fGRiM")
    ]).then(()=>parcelRequire('foh2b'));
}

});


parcelRegister("3OTv2", function(module, exports) {

$parcel$export(module.exports, "default", () => $07a602b0c59c0475$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $60fwk = parcelRequire("60fwk");
const $07a602b0c59c0475$var$TextWrapper = (props)=>{
    const { startPos: startPos, endPos: endPos } = props;
    const { children: children } = props;
    if (!children) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $60fwk.TextWithAnnotationDraft), {
        startPos: startPos,
        endPos: endPos,
        textHighlighter: props.textHighlighter,
        marks: props.marks
    }, children);
};
var $07a602b0c59c0475$export$2e2bcd8739ae039 = $07a602b0c59c0475$var$TextWrapper;

});
parcelRegister("60fwk", function(module, exports) {

$parcel$export(module.exports, "TextWithAnnotationDraft", () => $6059897edc992844$export$69a4e0ac39aaf9b7);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $9DvHC = parcelRequire("9DvHC");

var $hM6XC = parcelRequire("hM6XC");

var $e7OQ8 = parcelRequire("e7OQ8");

var $gGtOE = parcelRequire("gGtOE");

var $5uTcm = parcelRequire("5uTcm");

var $j6rwF = parcelRequire("j6rwF");

var $4QHKY = parcelRequire("4QHKY");

var $fvSxt = parcelRequire("fvSxt");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $6059897edc992844$var$markStyles = ()=>/*#__PURE__*/ (0, $byn9U.css)("color:inherit;background-color:unset;-webkit-tap-highlight-color:transparent;", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $j6rwF.AnnotationSharedCSSByState)().focus);
const $6059897edc992844$export$8062d68eccdfa39c = ({ draftPosition: draftPosition, children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("mark", {
        "data-renderer-mark": true,
        ...(0, $5uTcm.dataAttributes)(draftPosition),
        css: $6059897edc992844$var$markStyles
    }, children);
};
const $6059897edc992844$export$846ef6158669db08 = (annotationPosition, fragmentCount)=>{
    if (annotationPosition === (0, $9DvHC.InsertDraftPosition).START) return 0;
    if (annotationPosition === (0, $9DvHC.InsertDraftPosition).END) return fragmentCount - 1;
    if (annotationPosition === (0, $9DvHC.InsertDraftPosition).INSIDE && fragmentCount === 3) return 1;
    return -1;
};
const $6059897edc992844$export$b756d37afc321d72 = ({ texts: texts, shouldApplyAnnotationAt: shouldApplyAnnotationAt, draftPosition: draftPosition, textHighlighter: textHighlighter, marks: marks })=>{
    const annotateIndex = $6059897edc992844$export$846ef6158669db08(shouldApplyAnnotationAt, texts.length);
    return texts.map((value, index)=>{
        const segments = (0, $4QHKY.segmentText)(value, textHighlighter);
        if (annotateIndex === index) return /*#__PURE__*/ (0, $byn9U.jsx)($6059897edc992844$export$8062d68eccdfa39c, {
            key: index,
            draftPosition: draftPosition
        }, (0, $fvSxt.renderTextSegments)(segments, textHighlighter, marks || [], draftPosition.from));
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, {
            key: index
        }, (0, $fvSxt.renderTextSegments)(segments, textHighlighter, marks || [], draftPosition.from));
    });
};
const $6059897edc992844$export$69a4e0ac39aaf9b7 = ({ startPos: startPos, endPos: endPos, children: children, textHighlighter: textHighlighter, marks: marks })=>{
    const textPosition = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useMemo(()=>({
            start: startPos,
            end: endPos
        }), [
        endPos,
        startPos
    ]);
    const nextDraftPosition = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext((0, $hM6XC.AnnotationsDraftContext));
    const shouldApplyAnnotationAt = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useMemo(()=>{
        if (!nextDraftPosition) return false;
        return (0, $gGtOE.calcInsertDraftPositionOnText)(textPosition, nextDraftPosition);
    }, [
        nextDraftPosition,
        textPosition
    ]);
    const textString = (0, $e7OQ8.findTextString)(children);
    if (!textString) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, children);
    if (shouldApplyAnnotationAt === false || !nextDraftPosition) {
        const segments = (0, $4QHKY.segmentText)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $fvSxt.renderTextSegments)(segments, textHighlighter, marks || [], startPos));
    }
    if (shouldApplyAnnotationAt === (0, $9DvHC.InsertDraftPosition).AROUND_TEXT) {
        const segments = (0, $4QHKY.segmentText)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $byn9U.jsx)($6059897edc992844$export$8062d68eccdfa39c, {
            key: 0,
            draftPosition: nextDraftPosition
        }, (0, $fvSxt.renderTextSegments)(segments, textHighlighter, marks || [], startPos));
    }
    const offsets = (0, $e7OQ8.calcTextSplitOffset)(nextDraftPosition, textPosition, textString);
    const texts = (0, $e7OQ8.splitText)(textString, offsets);
    if (!texts) {
        const segments = (0, $4QHKY.segmentText)(textString, textHighlighter);
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $fvSxt.renderTextSegments)(segments, textHighlighter, marks || [], startPos));
    }
    const components = $6059897edc992844$export$b756d37afc321d72({
        texts: texts,
        shouldApplyAnnotationAt: shouldApplyAnnotationAt,
        draftPosition: nextDraftPosition,
        textHighlighter: textHighlighter,
        marks: marks
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, components);
};

});
parcelRegister("9DvHC", function(module, exports) {

$parcel$export(module.exports, "InsertDraftPosition", () => $ab5f93f7b05cb8d0$export$c1bd4813440b4505);
var $ab5f93f7b05cb8d0$export$c1bd4813440b4505;
(function(InsertDraftPosition) {
    InsertDraftPosition["AROUND_TEXT"] = "AROUND_TEXT";
    InsertDraftPosition["START"] = "START";
    InsertDraftPosition["END"] = "END";
    InsertDraftPosition["INSIDE"] = "INSIDE";
})($ab5f93f7b05cb8d0$export$c1bd4813440b4505 || ($ab5f93f7b05cb8d0$export$c1bd4813440b4505 = {}));

});

parcelRegister("hM6XC", function(module, exports) {

$parcel$export(module.exports, "AnnotationsDraftContext", () => $590117c6b16bec59$export$365d1799d81a236d);
$parcel$export(module.exports, "ProvidersContext", () => $590117c6b16bec59$export$6a26b015ac619737);
$parcel$export(module.exports, "InlineCommentsStateContext", () => $590117c6b16bec59$export$aafe46a36ef535ba);
$parcel$export(module.exports, "AnnotationsDraftContextWrapper", () => $590117c6b16bec59$export$153126608e00390);

var $eUqFw = parcelRequire("eUqFw");
const $590117c6b16bec59$export$365d1799d81a236d = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $590117c6b16bec59$export$6a26b015ac619737 = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $590117c6b16bec59$export$aafe46a36ef535ba = /*#__PURE__*/ (0, $eUqFw.createContext)({});
class $590117c6b16bec59$export$153126608e00390 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { children: children } = this.props;
        const { position: position } = this.state;
        const applyAnnotationDraftAt = this.applyAnnotationDraftAt;
        const clearAnnotationDraft = this.clearAnnotationDraft;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($590117c6b16bec59$export$365d1799d81a236d.Provider, {
            value: position
        }, children({
            applyAnnotationDraftAt: applyAnnotationDraftAt,
            clearAnnotationDraft: clearAnnotationDraft
        }));
    }
    constructor(...args){
        super(...args);
        this.state = {
            position: null
        };
        this.applyAnnotationDraftAt = (nextPosition)=>{
            const { setDraftRange: setDraftRange } = this.props;
            // Set the draft range to preserve it downstream
            setDraftRange();
            // We need to support a new draft being made while one exists and overwrite it
            // Set the document position for the newly created draft
            this.setState({
                position: nextPosition
            });
        };
        this.clearAnnotationDraft = ()=>{
            const { clearDraftRange: clearDraftRange } = this.props;
            // Clear the draft range
            clearDraftRange();
            // Clear the draft position in the document
            this.setState({
                position: null
            });
        };
    }
}

});

parcelRegister("e7OQ8", function(module, exports) {

$parcel$export(module.exports, "findTextString", () => $3b454e3a573d3685$export$a9795c84b22a1f06);
$parcel$export(module.exports, "splitText", () => $3b454e3a573d3685$export$2878cc467c8be8fe);
$parcel$export(module.exports, "calcTextSplitOffset", () => $3b454e3a573d3685$export$1059bfc467f4f55d);

var $eUqFw = parcelRequire("eUqFw");
const $3b454e3a573d3685$export$a9795c84b22a1f06 = (reactNode)=>{
    let result = null;
    const children = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(reactNode);
    for (const childNode of children){
        if (result) break;
        else if (typeof childNode === 'string') result = childNode;
        else if ($3b454e3a573d3685$var$isReactElement(childNode) && childNode.props.children) result = $3b454e3a573d3685$export$a9795c84b22a1f06(childNode.props.children);
    }
    return result;
};
function $3b454e3a573d3685$var$isReactElement(child) {
    return !!child.type;
}
const $3b454e3a573d3685$export$2878cc467c8be8fe = (text, { startOffset: startOffset, endOffset: endOffset })=>{
    if (endOffset > text.length || endOffset - startOffset <= 0) return null;
    return [
        text.slice(0, startOffset),
        text.slice(startOffset, endOffset),
        text.slice(endOffset)
    ].filter(Boolean);
};
const $3b454e3a573d3685$export$1059bfc467f4f55d = (position, textPosition, text)=>{
    const { start: start, end: end } = textPosition;
    const startOffset = Math.max(position.from - start, 0);
    const endOffset = Math.min(Math.abs(end - position.to - text.length), text.length);
    return {
        startOffset: startOffset,
        endOffset: endOffset
    };
};

});

parcelRegister("gGtOE", function(module, exports) {

$parcel$export(module.exports, "calcInsertDraftPositionOnText", () => $aae0540f8d212f73$export$b1baddbd5f289877);

var $9DvHC = parcelRequire("9DvHC");
const $aae0540f8d212f73$export$b1baddbd5f289877 = ({ start: startTextPosition, end: endTextPosition }, position)=>{
    const isRangePositionAroundText = position.from <= startTextPosition && position.to >= endTextPosition;
    if (isRangePositionAroundText) return (0, $9DvHC.InsertDraftPosition).AROUND_TEXT;
    const isRangePositionInsideText = position.from > startTextPosition && position.from < endTextPosition && position.to < endTextPosition && position.to > startTextPosition;
    if (isRangePositionInsideText) return (0, $9DvHC.InsertDraftPosition).INSIDE;
    const isRangePositionStartingAtText = position.from >= startTextPosition && position.from <= endTextPosition && position.to >= endTextPosition;
    if (isRangePositionStartingAtText) return (0, $9DvHC.InsertDraftPosition).END;
    const isRangePositionEndingAtText = position.from <= startTextPosition && position.to >= startTextPosition && position.to <= endTextPosition;
    if (isRangePositionEndingAtText) return (0, $9DvHC.InsertDraftPosition).START;
    return false;
};

});

parcelRegister("5uTcm", function(module, exports) {

$parcel$export(module.exports, "dataAttributes", () => $7a9e7bfcd1b1e667$export$15d6ddc168d35719);
$parcel$export(module.exports, "updateWindowSelectionAroundDraft", () => $7a9e7bfcd1b1e667$export$e14699d956e87e73);
const $7a9e7bfcd1b1e667$export$15d6ddc168d35719 = ({ from: from, to: to })=>{
    return {
        ['data-annotation-draft-mark']: true,
        ['data-draft-start-at']: from,
        ['data-draft-end-at']: to
    };
};
const $7a9e7bfcd1b1e667$var$buildDataAttributesQuery = (pos)=>{
    const a = $7a9e7bfcd1b1e667$export$15d6ddc168d35719(pos);
    return Object.entries(a).map(([k, v])=>`[${k}="${v}"]`).join('');
};
const $7a9e7bfcd1b1e667$export$e14699d956e87e73 = (pos)=>{
    const sel = window.getSelection();
    if (!sel) return false;
    const draftNodes = document.querySelectorAll($7a9e7bfcd1b1e667$var$buildDataAttributesQuery(pos));
    if (!draftNodes || draftNodes.length === 0) return false;
    sel.removeAllRanges();
    const range = document.createRange();
    range.setStart(draftNodes[0], 0);
    range.setEndAfter(draftNodes[draftNodes.length - 1]);
    sel.addRange(range);
    return true;
};

});

parcelRegister("j6rwF", function(module, exports) {

$parcel$export(module.exports, "AnnotationSharedClassNames", () => $fa3ae464b5020ffc$export$b0aeb22a160e5b4c);
$parcel$export(module.exports, "BlockAnnotationSharedClassNames", () => $fa3ae464b5020ffc$export$ac15f3ad21fefeac);
$parcel$export(module.exports, "AnnotationSharedCSSByState", () => $fa3ae464b5020ffc$export$261ebe180da42726);
$parcel$export(module.exports, "annotationSharedStyles", () => $fa3ae464b5020ffc$export$5f72fe1d39f8129b);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $PdmhA = parcelRequire("PdmhA");
const $fa3ae464b5020ffc$export$6d0ce11e3a04da25 = 'ak-editor-annotation';
const $fa3ae464b5020ffc$export$b0aeb22a160e5b4c = {
    focus: `${$fa3ae464b5020ffc$export$6d0ce11e3a04da25}-focus`,
    blur: `${$fa3ae464b5020ffc$export$6d0ce11e3a04da25}-blur`,
    draft: `${$fa3ae464b5020ffc$export$6d0ce11e3a04da25}-draft`
};
const $fa3ae464b5020ffc$export$3600479d19dfa7a9 = 'ak-editor-block-annotation';
const $fa3ae464b5020ffc$export$ac15f3ad21fefeac = {
    focus: `${$fa3ae464b5020ffc$export$3600479d19dfa7a9}-focus`,
    blur: `${$fa3ae464b5020ffc$export$3600479d19dfa7a9}-blur`,
    draft: `${$fa3ae464b5020ffc$export$3600479d19dfa7a9}-draft`
};
const $fa3ae464b5020ffc$var$Yellow100 = 'rgb(255, 247, 214)';
const $fa3ae464b5020ffc$var$Y200a = 'rgba(255, 196, 0, 0.82)';
const $fa3ae464b5020ffc$export$261ebe180da42726 = ()=>{
    if ((0, $XHGTv.getBooleanFF)('platform.editor.allow-inline-comments-for-inline-nodes-round-2_ctuxz')) // NOTE: These styles are shared between renderer and editor. Sometimes they
    // need different selectors and other times they apply the same attributes
    // in a different way. For example in renderer the focus styles are an
    // override, not a separate class. Be sure to check both usages of this
    // before modifying.
    return {
        common: {
            borderBottom: '2px solid transparent',
            cursor: 'pointer',
            padding: '1px 0 2px',
            '&:has(.card), &:has([data-inline-card])': {
                paddingTop: '4px',
                border: 'none',
                boxShadow: `0 2px 0 0 ${`var(--ds-border-accent-yellow, ${$fa3ae464b5020ffc$var$Y200a})`}`
            },
            '&:has(.date-lozenger-container)': {
                paddingTop: '2px'
            }
        },
        focus: /*#__PURE__*/ (0, $byn9U.css)({
            background: `var(--ds-background-accent-yellow-subtler, ${(0, $PdmhA.Y75)})`,
            borderBottomColor: `var(--ds-border-accent-yellow, ${(0, $PdmhA.Y300)})`,
            boxShadow: `var(--ds-shadow-overlay, ${`1px 2px 3px ${(0, $PdmhA.N60A)}, -1px 2px 3px ${(0, $PdmhA.N60A)}`})`
        }),
        blur: /*#__PURE__*/ (0, $byn9U.css)({
            background: `var(--ds-background-accent-yellow-subtlest, ${$fa3ae464b5020ffc$var$Yellow100})`,
            borderBottomColor: `var(--ds-border-accent-yellow, ${$fa3ae464b5020ffc$var$Y200a})`
        })
    };
    else if ((0, $XHGTv.getBooleanFF)('platform.editor.allow-inline-comments-for-inline-nodes')) return {
        focus: /*#__PURE__*/ (0, $byn9U.css)({
            background: `var(--ds-background-accent-yellow-subtler, ${(0, $PdmhA.Y75)})`,
            borderBottom: `2px solid ${`var(--ds-border-accent-yellow, ${(0, $PdmhA.Y300)})`}`,
            boxShadow: `var(--ds-shadow-overlay, ${`1px 2px 3px ${(0, $PdmhA.N60A)}, -1px 2px 3px ${(0, $PdmhA.N60A)}`})`,
            cursor: 'pointer',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:has(.card)': {
                fontSize: '1.5rem',
                lineHeight: '1.2rem',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
                '& > *': {
                    fontSize: '16px'
                }
            }
        }),
        blur: /*#__PURE__*/ (0, $byn9U.css)({
            background: `var(--ds-background-accent-yellow-subtlest, ${$fa3ae464b5020ffc$var$Yellow100})`,
            borderBottom: `2px solid ${`var(--ds-border-accent-yellow, ${$fa3ae464b5020ffc$var$Y200a})`}`,
            cursor: 'pointer',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:has(.card)': {
                fontSize: '1.5rem',
                lineHeight: '1.2rem',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
                '& > *': {
                    fontSize: '16px'
                }
            }
        })
    };
    else return {
        focus: /*#__PURE__*/ (0, $byn9U.css)({
            // Background is not coming through in confluence, suspecting to be caused by some specific combination of
            // emotion and token look up
            background: `var(--ds-background-accent-yellow-subtler, ${(0, $PdmhA.Y75)})`,
            borderBottom: `2px solid ${`var(--ds-border-accent-yellow, ${(0, $PdmhA.Y300)})`}`,
            // TODO: https://product-fabric.atlassian.net/browse/DSP-4147
            boxShadow: `var(--ds-shadow-overlay, ${`1px 2px 3px ${(0, $PdmhA.N60A)}, -1px 2px 3px ${(0, $PdmhA.N60A)}`})`,
            cursor: 'pointer'
        }),
        blur: /*#__PURE__*/ (0, $byn9U.css)({
            background: `var(--ds-background-accent-yellow-subtlest, ${$fa3ae464b5020ffc$var$Yellow100})`,
            borderBottom: `2px solid ${`var(--ds-border-accent-yellow, ${$fa3ae464b5020ffc$var$Y200a})`}`,
            cursor: 'pointer'
        })
    };
};
const $fa3ae464b5020ffc$export$5f72fe1d39f8129b = ()=>(0, $XHGTv.getBooleanFF)('platform.editor.allow-inline-comments-for-inline-nodes-round-2_ctuxz') ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- `AnnotationSharedCSSByState()` is not safe in object syntax
    (0, $byn9U.css)(".ProseMirror{.", $fa3ae464b5020ffc$export$b0aeb22a160e5b4c.blur, ",.", $fa3ae464b5020ffc$export$b0aeb22a160e5b4c.focus, ",.", $fa3ae464b5020ffc$export$b0aeb22a160e5b4c.draft, "{", $fa3ae464b5020ffc$export$261ebe180da42726().common, ";}.", $fa3ae464b5020ffc$export$b0aeb22a160e5b4c.focus, "{", $fa3ae464b5020ffc$export$261ebe180da42726().focus, ";}.", $fa3ae464b5020ffc$export$b0aeb22a160e5b4c.draft, "{", $fa3ae464b5020ffc$export$261ebe180da42726().focus, ";cursor:initial;}.", $fa3ae464b5020ffc$export$b0aeb22a160e5b4c.blur, "{", $fa3ae464b5020ffc$export$261ebe180da42726().blur, ";}}") : /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- `AnnotationSharedCSSByState()` is not safe in object syntax
    (0, $byn9U.css)(".ProseMirror{.", $fa3ae464b5020ffc$export$b0aeb22a160e5b4c.focus, "{", $fa3ae464b5020ffc$export$261ebe180da42726().focus, ";}.", $fa3ae464b5020ffc$export$b0aeb22a160e5b4c.draft, "{", $fa3ae464b5020ffc$export$261ebe180da42726().focus, ";cursor:initial;}.", $fa3ae464b5020ffc$export$b0aeb22a160e5b4c.blur, "{", $fa3ae464b5020ffc$export$261ebe180da42726().blur, ";}}");

});

parcelRegister("4QHKY", function(module, exports) {

$parcel$export(module.exports, "segmentText", () => $d5d1d56c1f3d5a17$export$93301b6f1ff0b0c3);
function $d5d1d56c1f3d5a17$export$93301b6f1ff0b0c3(text, highlighter) {
    if (!highlighter || !text) return [
        {
            type: 'plain',
            text: text ?? ''
        }
    ];
    const segments = [];
    let pos = 0;
    try {
        const markTextSegmentMatches = text.matchAll(highlighter.pattern);
        for (const markTextMatch of markTextSegmentMatches){
            if (markTextMatch.index !== 0) segments.push({
                type: 'plain',
                text: text.substring(pos, markTextMatch.index)
            });
            segments.push({
                type: 'match',
                text: markTextMatch[0],
                groups: markTextMatch.groups && Object.keys(markTextMatch.groups).filter((key)=>markTextMatch.groups[key])
            });
            pos = markTextMatch.index + markTextMatch[0].length;
        }
        if (pos < text.length) segments.push({
            type: 'plain',
            text: text.substring(pos)
        });
        return segments;
    } catch (_e) {}
    return [
        {
            type: 'plain',
            text: text
        }
    ];
}

});

parcelRegister("fvSxt", function(module, exports) {

$parcel$export(module.exports, "renderTextSegments", () => $af4a012340e55cd1$export$8a20fd0614851c5f);

var $eUqFw = parcelRequire("eUqFw");
function $af4a012340e55cd1$export$8a20fd0614851c5f(segments, textHighlighter, marksList, startPos) {
    const Component = textHighlighter?.component;
    const marks = new Set(marksList.map((m)=>m.type.name));
    function renderSegment(segment, idx = 0) {
        if (segment.type === 'plain' || !Component) return segment.text;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            "data-highlighted": true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
            match: segment.text,
            groups: segment.groups,
            marks: marks,
            key: `${segment.text}_${startPos}_${idx}`,
            startPos: startPos + idx
        }, segment.text));
    }
    if (segments.length === 1) return renderSegment(segments[0]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, {
        key: `text-wrapper_${startPos}`
    }, segments.map(renderSegment));
}

});



parcelRegister("jxP5v", function(module, exports) {

$parcel$export(module.exports, "isAnnotationMark", () => $e461add4b299b195$export$855795c145f03402);
$parcel$export(module.exports, "default", () => $e461add4b299b195$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ht6w1 = parcelRequire("ht6w1");

var $kgIht = parcelRequire("kgIht");
const $e461add4b299b195$export$855795c145f03402 = (mark)=>{
    return mark && mark.type && mark.type.name === 'annotation';
};
const $e461add4b299b195$var$AnnotationComponent = ({ id: id, annotationType: annotationType, children: children, dataAttributes: dataAttributes, annotationParentIds: annotationParentIds = [], allowAnnotations: allowAnnotations, useBlockLevel: useBlockLevel, isMediaInline: isMediaInline })=>{
    const data = {
        ...dataAttributes,
        ...(0, $ht6w1.buildDataAttributes)({
            id: id,
            annotationType: annotationType
        })
    };
    if (allowAnnotations) return isMediaInline ? // Inline comment on mediaInline is not supported as part of comments on media project,
    // hence skip any styling/event handling for annotations on mediaInline.
    // `id` is still needed so that comment view component can be correct positioned
    // when using comment navigation to access comments on mediaInline
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        id: id
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kgIht.MarkElement), {
        id: id,
        dataAttributes: data,
        annotationParentIds: annotationParentIds,
        annotationType: annotationType,
        useBlockLevel: useBlockLevel
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        id: id,
        ...data
    }, children);
};
var $e461add4b299b195$export$2e2bcd8739ae039 = $e461add4b299b195$var$AnnotationComponent;

});
parcelRegister("kgIht", function(module, exports) {

$parcel$export(module.exports, "MarkElement", () => $d21042c0f3a68a92$export$f3069f755c1eba0b);

var $eUqFw = parcelRequire("eUqFw");

var $ht6w1 = parcelRequire("ht6w1");

var $1DD45 = parcelRequire("1DD45");

var $7EYt1 = parcelRequire("7EYt1");
var $lzDkm = parcelRequire("lzDkm");
var $fX449 = parcelRequire("fX449");

var $hM6XC = parcelRequire("hM6XC");

var $3DXMd = parcelRequire("3DXMd");
const $d21042c0f3a68a92$export$f3069f755c1eba0b = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, useBlockLevel: useBlockLevel })=>{
    const updateSubscriber = (0, $fX449.useInlineCommentSubscriberContext)();
    const states = (0, $eUqFw.useContext)((0, $hM6XC.InlineCommentsStateContext));
    const hasFocus = (0, $7EYt1.useHasFocusEvent)({
        id: id,
        updateSubscriber: updateSubscriber
    });
    const dataAttributesMemorized = (0, $eUqFw.useMemo)(()=>dataAttributes, [
        dataAttributes
    ]);
    const onClick = (0, $eUqFw.useCallback)((props)=>{
        if (!updateSubscriber) return;
        if (useBlockLevel) return;
        const { eventTarget: eventTarget, annotationIds: annotationIds } = props;
        updateSubscriber.emit((0, $3DXMd.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, {
            annotationIds: annotationIds,
            eventTarget: eventTarget
        });
    }, [
        updateSubscriber,
        useBlockLevel
    ]);
    const activeParentIds = (0, $lzDkm.useInlineCommentsFilter)({
        annotationIds: annotationParentIds,
        filter: {
            state: (0, $ht6w1.AnnotationMarkStates).ACTIVE
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1DD45.MarkComponent), {
        id: id,
        dataAttributes: dataAttributesMemorized,
        annotationParentIds: activeParentIds,
        onClick: onClick,
        hasFocus: hasFocus,
        state: states[id],
        useBlockLevel: useBlockLevel
    }, children);
};

});
parcelRegister("1DD45", function(module, exports) {

$parcel$export(module.exports, "MarkComponent", () => $336011f89b3a559a$export$4f5a51511304fdd0);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8tM2T = parcelRequire("8tM2T");

var $j6rwF = parcelRequire("j6rwF");

var $ht6w1 = parcelRequire("ht6w1");

var $XHGTv = parcelRequire("XHGTv");

var $5JgJ2 = parcelRequire("5JgJ2");

var $drghF = parcelRequire("drghF");
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- `AnnotationSharedCSSByState` is not object-safe
const $336011f89b3a559a$var$markStyles = ()=>/*#__PURE__*/ (0, $byn9U.css)("color:inherit;background-color:unset;-webkit-tap-highlight-color:transparent;&[data-mark-annotation-state='", (0, $ht6w1.AnnotationMarkStates).ACTIVE, "']{", (0, $XHGTv.getBooleanFF)('platform.editor.allow-inline-comments-for-inline-nodes-round-2_ctuxz') ? (0, $j6rwF.AnnotationSharedCSSByState)().common : '', " ", (0, $j6rwF.AnnotationSharedCSSByState)().blur, " &:focus,&[data-has-focus='true']{", (0, $j6rwF.AnnotationSharedCSSByState)().focus, ";}}");
const $336011f89b3a559a$var$isMobile = ()=>{
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};
const $336011f89b3a559a$var$accessibilityStyles = (startMarker, endMarker)=>/*#__PURE__*/ (0, $byn9U.css)({
        '&::before, &::after': {
            clipPath: 'inset(100%)',
            clip: 'rect(1px, 1px, 1px, 1px)',
            height: '1px',
            overflow: 'hidden',
            position: 'absolute',
            whiteSpace: 'nowrap',
            width: '1px'
        },
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            content: `' [${startMarker}] '`
        },
        '&::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            content: `' [${endMarker}] '`
        }
    });
const $336011f89b3a559a$export$4f5a51511304fdd0 = ({ annotationParentIds: annotationParentIds, children: children, dataAttributes: dataAttributes, id: id, state: state, hasFocus: hasFocus, onClick: onClick, useBlockLevel: useBlockLevel })=>{
    const isInlineCommentsKbAccessible = (0, $8tM2T.default).checkGate('inline_comments_keyboard_accessible_renderer');
    const intl = (0, $5JgJ2.default)();
    const annotationIds = (0, $eUqFw.useMemo)(()=>[
            ...new Set([
                ...annotationParentIds,
                id
            ])
        ], [
        id,
        annotationParentIds
    ]);
    const onMarkClick = (0, $eUqFw.useCallback)((event)=>{
        // prevent inline mark logic for media block marks
        if (event.currentTarget instanceof HTMLElement && event.currentTarget.getAttribute('data-block-mark')) return;
        // prevents multiple callback on overlapping annotations
        if (event.defaultPrevented || state !== (0, $ht6w1.AnnotationMarkStates).ACTIVE) return;
        if ((0, $XHGTv.getBooleanFF)('platform.editor.allow-inline-comments-for-inline-nodes')) // We only want to interfere with click events if the click is on some ui inside the renderer document
        // This is to prevent the click events from portaled content (such as link previews and mention profiles)
        {
            if (event.target instanceof HTMLElement && event.target.closest('.ak-renderer-document')) {
                if (event.target.closest('[data-mention-id]')) ;
                else {
                    // prevents from opening link URL inside webView in Safari
                    event.preventDefault();
                    event.stopPropagation();
                }
            }
        } else // prevents from opening link URL inside webView in Safari
        event.preventDefault();
        onClick({
            eventTarget: event.target,
            annotationIds: annotationIds
        });
    }, [
        annotationIds,
        onClick,
        state
    ]);
    const onMarkEnter = (evt)=>{
        const focusedElementTag = document.activeElement?.tagName;
        if (focusedElementTag === 'MARK' && evt.key === 'Enter') onMarkClick(evt);
    };
    const overriddenData = !state ? dataAttributes : {
        ...dataAttributes,
        'data-mark-annotation-state': state,
        'data-has-focus': hasFocus
    };
    const desktopAccessibilityAttributes = isInlineCommentsKbAccessible ? $336011f89b3a559a$var$isMobile() ? {} : {
        role: 'button',
        tabIndex: 0,
        onKeyDown: onMarkEnter,
        'aria-expanded': hasFocus
    } : {};
    const accessibility = state !== (0, $ht6w1.AnnotationMarkStates).ACTIVE ? {
        'aria-disabled': true
    } : {
        'aria-details': annotationIds.join(', '),
        ...desktopAccessibilityAttributes
    };
    const getAccessibilityStyles = ()=>{
        if ($336011f89b3a559a$var$isMobile()) return {};
        if (isInlineCommentsKbAccessible) {
            const startMarker = intl.formatMessage((0, $drghF.inlineCommentMessages).contentRendererInlineCommentMarkerStart);
            const endMarker = intl.formatMessage((0, $drghF.inlineCommentMessages).contentRendererInlineCommentMarkerEnd);
            return $336011f89b3a559a$var$accessibilityStyles(startMarker, endMarker);
        } else return {};
    };
    return (0, $byn9U.jsx)(useBlockLevel ? 'div' : 'mark', {
        id: id,
        [(0, $XHGTv.getBooleanFF)('platform.editor.allow-inline-comments-for-inline-nodes') ? 'onClickCapture' : 'onClick']: onMarkClick,
        ...accessibility,
        ...overriddenData,
        ...!useBlockLevel && {
            css: [
                $336011f89b3a559a$var$markStyles,
                getAccessibilityStyles()
            ]
        }
    }, children);
};

});

parcelRegister("7EYt1", function(module, exports) {

$parcel$export(module.exports, "useAnnotationStateByTypeEvent", () => $f9406be79cf3cc6d$export$95f9f9045e92d283);
$parcel$export(module.exports, "useHasFocusEvent", () => $f9406be79cf3cc6d$export$48f5d7f6702be07c);
$parcel$export(module.exports, "useAnnotationClickEvent", () => $f9406be79cf3cc6d$export$26cf539704e444c1);

var $eUqFw = parcelRequire("eUqFw");

var $3DXMd = parcelRequire("3DXMd");

var $8tM2T = parcelRequire("8tM2T");

var $ht6w1 = parcelRequire("ht6w1");

var $auyn4 = parcelRequire("auyn4");

var $6PJBT = parcelRequire("6PJBT");
const $f9406be79cf3cc6d$export$95f9f9045e92d283 = ({ type: type, updateSubscriber: updateSubscriber })=>{
    const [states, setStates] = (0, $eUqFw.useState)({});
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!updateSubscriber) return;
        const cb = (payload)=>{
            if (!payload) return;
            const nextStates = Object.values(payload).reduce((acc, curr)=>{
                if (curr.id && curr.annotationType === type) {
                    // Check for empty state to prevent additional renders
                    const isEmpty = curr.state === null || curr.state === undefined;
                    return {
                        ...acc,
                        [curr.id]: !isEmpty ? curr.state : states[curr.id]
                    };
                }
                return acc;
            }, {});
            setStates({
                ...states,
                ...nextStates
            });
        };
        updateSubscriber.on((0, $3DXMd.AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
        return ()=>{
            updateSubscriber.off((0, $3DXMd.AnnotationUpdateEvent).SET_ANNOTATION_STATE, cb);
        };
    }, [
        states,
        type,
        updateSubscriber
    ]);
    return states;
};
const $f9406be79cf3cc6d$export$48f5d7f6702be07c = ({ id: id, updateSubscriber: updateSubscriber })=>{
    const [hasFocus, setHasFocus] = (0, $eUqFw.useState)(false);
    const isInlineCommentsKbAccessible = (0, $8tM2T.default).checkGate('inline_comments_keyboard_accessible_renderer');
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!updateSubscriber) return;
        const cb = (payload)=>{
            setHasFocus(payload && payload.annotationId === id);
        };
        const removeFocus = ()=>{
            setHasFocus(false);
            if (isInlineCommentsKbAccessible && document.activeElement instanceof HTMLElement) document.activeElement.blur();
        };
        updateSubscriber.on((0, $3DXMd.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
        updateSubscriber.on((0, $3DXMd.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
        return ()=>{
            updateSubscriber.off((0, $3DXMd.AnnotationUpdateEvent).SET_ANNOTATION_FOCUS, cb);
            updateSubscriber.off((0, $3DXMd.AnnotationUpdateEvent).REMOVE_ANNOTATION_FOCUS, removeFocus);
        };
    }, [
        id,
        updateSubscriber,
        isInlineCommentsKbAccessible
    ]);
    return hasFocus;
};
const $f9406be79cf3cc6d$export$26cf539704e444c1 = (props)=>{
    const [annotationClickEvent, setAnnotationClickEvent] = (0, $eUqFw.useState)(null);
    const { updateSubscriber: updateSubscriber, createAnalyticsEvent: createAnalyticsEvent, isCommentsOnMediaAnalyticsEnabled: isCommentsOnMediaAnalyticsEnabled } = props;
    const isInlineCommentsKbAccessible = (0, $8tM2T.default).checkGate('inline_comments_keyboard_accessible_renderer');
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!updateSubscriber) return;
        const clickCb = ({ annotationIds: annotationIds, eventTarget: eventTarget, eventTargetType: eventTargetType, viewMethod: viewMethod })=>{
            const annotationsByType = annotationIds.filter((id)=>!!id).map((id)=>({
                    id: id,
                    type: (0, $ht6w1.AnnotationTypes).INLINE_COMMENT
                }));
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $auyn4.ACTION).VIEWED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: annotationsByType.length || 0,
                    ...isCommentsOnMediaAnalyticsEnabled && {
                        targetNodeType: eventTargetType,
                        method: viewMethod
                    }
                }
            }).fire((0, $6PJBT.FabricChannel).editor);
            setAnnotationClickEvent({
                annotations: annotationsByType,
                clickElementTarget: eventTarget
            });
        };
        const deselectCb = ()=>{
            setAnnotationClickEvent({
                annotations: [],
                clickElementTarget: undefined
            });
            if (isInlineCommentsKbAccessible && document.activeElement instanceof HTMLElement) document.activeElement.blur();
        };
        updateSubscriber.on((0, $3DXMd.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
        updateSubscriber.on((0, $3DXMd.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
        return ()=>{
            updateSubscriber.off((0, $3DXMd.AnnotationUpdateEvent).ON_ANNOTATION_CLICK, clickCb);
            updateSubscriber.off((0, $3DXMd.AnnotationUpdateEvent).DESELECT_ANNOTATIONS, deselectCb);
        };
    }, [
        updateSubscriber,
        createAnalyticsEvent,
        isCommentsOnMediaAnalyticsEnabled,
        isInlineCommentsKbAccessible
    ]);
    return annotationClickEvent;
};

});

parcelRegister("lzDkm", function(module, exports) {

$parcel$export(module.exports, "useInlineCommentsFilter", () => $96e3e7352e62ec9e$export$8e7d47f9e38ad4f1);

var $eUqFw = parcelRequire("eUqFw");

var $hM6XC = parcelRequire("hM6XC");
const $96e3e7352e62ec9e$export$8e7d47f9e38ad4f1 = ({ annotationIds: annotationIds, filter: { state: stateFilter } })=>{
    const states = (0, $eUqFw.useContext)((0, $hM6XC.InlineCommentsStateContext));
    return (0, $eUqFw.useMemo)(()=>{
        return annotationIds.reduce((acc, id)=>{
            if (states && states[id] === stateFilter) return [
                ...acc,
                id
            ];
            return acc;
        }, []);
    }, [
        annotationIds,
        states,
        stateFilter
    ]);
};

});

parcelRegister("fX449", function(module, exports) {

$parcel$export(module.exports, "useInlineCommentSubscriberContext", () => $6e0e66bb5944c119$export$b46737175cffd396);

var $eUqFw = parcelRequire("eUqFw");

var $hM6XC = parcelRequire("hM6XC");
const $6e0e66bb5944c119$export$b46737175cffd396 = ()=>{
    const providers = (0, $eUqFw.useContext)((0, $hM6XC.ProvidersContext));
    if (!providers) return null;
    const { inlineComment: { updateSubscriber: updateSubscriber } } = providers;
    return updateSubscriber || null;
};

});



parcelRegister("3Rfkt", function(module, exports) {

$parcel$export(module.exports, "toReact", () => $4802fa6ceee7ed6b$export$d4334b129116aad7);

var $bl9MZ = parcelRequire("bl9MZ");

var $fKWge = parcelRequire("fKWge");

var $5NC3a = parcelRequire("5NC3a");

var $7FrhV = parcelRequire("7FrhV");

var $3czYv = parcelRequire("3czYv");

var $5EI2Z = parcelRequire("5EI2Z");

var $2LYW6 = parcelRequire("2LYW6");

var $jIWxL = parcelRequire("jIWxL");

var $fqJal = parcelRequire("fqJal");

var $3QkG0 = parcelRequire("3QkG0");

var $3ofDw = parcelRequire("3ofDw");

var $cTsEA = parcelRequire("cTsEA");

var $hySUC = parcelRequire("hySUC");

var $dt1Ro = parcelRequire("dt1Ro");

var $9HbLt = parcelRequire("9HbLt");

var $5hADG = parcelRequire("5hADG");

var $jxP5v = parcelRequire("jxP5v");

var $9Pmx7 = parcelRequire("9Pmx7");

var $jKBO7 = parcelRequire("jKBO7");
const $4802fa6ceee7ed6b$export$c00d967a0f56fdb7 = {
    code: (0, $bl9MZ.default),
    em: (0, $fKWge.default),
    link: (0, $5NC3a.default),
    strike: (0, $7FrhV.default),
    strong: (0, $3czYv.default),
    subsup: (0, $5EI2Z.default),
    textColor: (0, $2LYW6.default),
    backgroundColor: (0, $jIWxL.default),
    underline: (0, $fqJal.default),
    annotation: (0, $jxP5v.default),
    border: (0, $9Pmx7.default),
    // Stage0
    confluenceInlineComment: (0, $jKBO7.default),
    breakout: (0, $3QkG0.default),
    alignment: (0, $3ofDw.default),
    indentation: (0, $cTsEA.default),
    unsupportedMark: (0, $hySUC.default),
    unsupportedNodeAttribute: (0, $dt1Ro.default),
    dataConsumer: (0, $9HbLt.default),
    fragment: (0, $5hADG.default)
};
const $4802fa6ceee7ed6b$export$d4334b129116aad7 = (mark)=>{
    return $4802fa6ceee7ed6b$export$c00d967a0f56fdb7[mark.type.name];
};

});
parcelRegister("bl9MZ", function(module, exports) {

$parcel$export(module.exports, "isCodeMark", () => $ee87d0fee0f502c9$export$86390c02c110ec2f);
$parcel$export(module.exports, "default", () => $ee87d0fee0f502c9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $dl0RD = parcelRequire("dl0RD");

var $hl0Ug = parcelRequire("hl0Ug");
const $ee87d0fee0f502c9$export$86390c02c110ec2f = (mark)=>{
    return mark && mark.type && mark.type.name === 'code';
};
function $ee87d0fee0f502c9$export$7cea6ffa7022e85f(props) {
    const codeBidiWarningLabel = props.intl.formatMessage((0, $hl0Ug.codeBidiWarningMessages).label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dl0RD.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "code",
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: props.codeBidiWarningTooltipEnabled,
        ...props.dataAttributes
    }, props.children);
}
var $ee87d0fee0f502c9$export$2e2bcd8739ae039 = (0, $2qhQi.default)($ee87d0fee0f502c9$export$7cea6ffa7022e85f);

});

parcelRegister("fKWge", function(module, exports) {

$parcel$export(module.exports, "default", () => $80f002b5113a8782$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $80f002b5113a8782$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("em", props.dataAttributes, props.children);
}

});

parcelRegister("5NC3a", function(module, exports) {

$parcel$export(module.exports, "default", () => $f92b0d1e7af6585c$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $9oaPg = parcelRequire("9oaPg");

var $3rMck = parcelRequire("3rMck");

var $auyn4 = parcelRequire("auyn4");

var $gP1iJ = parcelRequire("gP1iJ");

var $aw5Sy = parcelRequire("aw5Sy");
const $f92b0d1e7af6585c$var$anchorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-link, ${(0, $PdmhA.B400)})`,
    '&:hover': {
        color: `var(--ds-link, ${(0, $PdmhA.B300)})`,
        textDecoration: 'underline'
    },
    '&:active': {
        color: `var(--ds-link-pressed, ${(0, $PdmhA.B500)})`
    }
});
function $f92b0d1e7af6585c$export$2e2bcd8739ae039(props) {
    const { href: href, target: target, eventHandlers: eventHandlers, fireAnalyticsEvent: fireAnalyticsEvent, isMediaLink: isMediaLink, dataAttributes: dataAttributes } = props;
    const anchorProps = {
        href: href,
        target: target,
        title: href
    };
    if (target === '_blank') anchorProps.rel = 'noreferrer noopener';
    const handler = (0, $9oaPg.getEventHandler)(eventHandlers, 'link');
    if (isMediaLink) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, props.children);
    const analyticsData = {
        attributes: {
            location: 'renderer'
        },
        // Below is added for the future implementation of Linking Platform namespaced analytic context
        location: 'renderer'
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $aw5Sy.default), {
        data: analyticsData
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $gP1iJ.default), {
        css: $f92b0d1e7af6585c$var$anchorStyles,
        onClick: (e)=>{
            if (fireAnalyticsEvent) fireAnalyticsEvent({
                action: (0, $auyn4.ACTION).VISITED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).LINK,
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                attributes: {
                    platform: (0, $3rMck.PLATFORM).WEB,
                    mode: (0, $3rMck.MODE).RENDERER
                }
            });
            if (handler) handler(e, href);
        },
        ...anchorProps,
        ...dataAttributes
    }, props.children));
}

});
parcelRegister("9oaPg", function(module, exports) {

$parcel$export(module.exports, "ADFEncoder", () => $b08f4d77e849a46a$export$bcf771b83128eae7);
$parcel$export(module.exports, "getText", () => $b08f4d77e849a46a$export$c72d34660a162238);
$parcel$export(module.exports, "getEventHandler", () => $b08f4d77e849a46a$export$eee20638634729b3);
$parcel$export(module.exports, "getPlatform", () => $b08f4d77e849a46a$export$867a782338812cb4);
$parcel$export(module.exports, "findInTree", () => $b08f4d77e849a46a$export$38b61ebf4950cd39);

var $9wcjJ = parcelRequire("9wcjJ");

var $3M3qX = parcelRequire("3M3qX");
function $b08f4d77e849a46a$var$createEncoder(parser, encoder) {
    return (value)=>encoder.encode(parser.parse(value));
}
class $b08f4d77e849a46a$export$bcf771b83128eae7 {
    constructor(createTransformerWithSchema){
        const transformer = createTransformerWithSchema((0, $9wcjJ.defaultSchema));
        this.encode = $b08f4d77e849a46a$var$createEncoder(transformer, new (0, $3M3qX.JSONTransformer)());
    }
}
const $b08f4d77e849a46a$export$c72d34660a162238 = (node)=>{
    return node.text || node.attrs && (node.attrs.text || node.attrs.shortName) || `[${typeof node.type === 'string' ? node.type : node.type.name}]`;
};
const $b08f4d77e849a46a$export$eee20638634729b3 = (eventHandlers, type, eventName = 'onClick')=>{
    return eventHandlers && type && eventHandlers[type] && eventHandlers[type][eventName];
};
const $b08f4d77e849a46a$export$867a782338812cb4 = (rendererAppearance)=>{
    if (rendererAppearance === 'mobile') return 'mobile';
    return 'web';
};
function $b08f4d77e849a46a$export$38b61ebf4950cd39(element, topElement, evaluate) {
    if (element === topElement) return false;
    if (evaluate(element)) return true;
    if (!element.parentElement) return false;
    return $b08f4d77e849a46a$export$38b61ebf4950cd39(element.parentElement, topElement, evaluate);
}

});
parcelRegister("3M3qX", function(module, exports) {

$parcel$export(module.exports, "SchemaStage", () => $3ad50ef6c4da68ad$export$933e6445c497ffd5);
$parcel$export(module.exports, "JSONTransformer", () => $3ad50ef6c4da68ad$export$98cb1d9308d0944d);

var $hTLlD = parcelRequire("hTLlD");

var $hgVop = parcelRequire("hgVop");
var $8nj7b = parcelRequire("8nj7b");
var $lKuoe = parcelRequire("lKuoe");
var $9iaXL = parcelRequire("9iaXL");
var $3SpHb = parcelRequire("3SpHb");
var $cvCFq = parcelRequire("cvCFq");
var $gN3fl = parcelRequire("gN3fl");
var $fkqTY = parcelRequire("fkqTY");
var $byxO6 = parcelRequire("byxO6");

var $9wcjJ = parcelRequire("9wcjJ");

var $dxv8o = parcelRequire("dxv8o");

var $gbvAY = parcelRequire("gbvAY");
var $3ad50ef6c4da68ad$export$933e6445c497ffd5;
(function(SchemaStage) {
    SchemaStage["FINAL"] = "final";
    SchemaStage["STAGE_0"] = "stage0";
})($3ad50ef6c4da68ad$export$933e6445c497ffd5 || ($3ad50ef6c4da68ad$export$933e6445c497ffd5 = {}));
const $3ad50ef6c4da68ad$var$isType = (type)=>(node)=>node.type.name === type;
const $3ad50ef6c4da68ad$var$isCodeBlock = $3ad50ef6c4da68ad$var$isType('codeBlock');
const $3ad50ef6c4da68ad$var$isMediaNode = $3ad50ef6c4da68ad$var$isType('media');
const $3ad50ef6c4da68ad$var$isMediaInline = $3ad50ef6c4da68ad$var$isType('mediaInline');
const $3ad50ef6c4da68ad$var$isMediaSingleNode = $3ad50ef6c4da68ad$var$isType('mediaSingle');
const $3ad50ef6c4da68ad$var$isMentionNode = $3ad50ef6c4da68ad$var$isType('mention');
const $3ad50ef6c4da68ad$var$isParagraph = $3ad50ef6c4da68ad$var$isType('paragraph');
const $3ad50ef6c4da68ad$var$isHeading = $3ad50ef6c4da68ad$var$isType('heading');
const $3ad50ef6c4da68ad$var$isTable = $3ad50ef6c4da68ad$var$isType('table');
const $3ad50ef6c4da68ad$var$isTableCell = $3ad50ef6c4da68ad$var$isType('tableCell');
const $3ad50ef6c4da68ad$var$isTableHeader = $3ad50ef6c4da68ad$var$isType('tableHeader');
const $3ad50ef6c4da68ad$var$isLinkMark = $3ad50ef6c4da68ad$var$isType('link');
const $3ad50ef6c4da68ad$var$isUnsupportedMark = $3ad50ef6c4da68ad$var$isType('unsupportedMark');
const $3ad50ef6c4da68ad$var$isUnsupportedNodeAttributeMark = $3ad50ef6c4da68ad$var$isType('unsupportedNodeAttribute');
const $3ad50ef6c4da68ad$var$isExpand = $3ad50ef6c4da68ad$var$isType('expand');
const $3ad50ef6c4da68ad$var$isNestedExpand = $3ad50ef6c4da68ad$var$isType('nestedExpand');
const $3ad50ef6c4da68ad$var$isUnsupportedNode = (node)=>$3ad50ef6c4da68ad$var$isType('unsupportedBlock')(node) || $3ad50ef6c4da68ad$var$isType('unsupportedInline')(node);
const $3ad50ef6c4da68ad$var$isDataConsumer = $3ad50ef6c4da68ad$var$isType('dataConsumer');
const $3ad50ef6c4da68ad$var$isFragmentMark = $3ad50ef6c4da68ad$var$isType('fragment');
const $3ad50ef6c4da68ad$var$filterNull = (subject)=>{
    let output = {
        ...subject
    };
    for(const key in output){
        const current = output[key];
        if (current === null) {
            const { [key]: unusedKey, ...filteredObj } = output;
            output = filteredObj;
        } else if (typeof current === 'object' && !Array.isArray(current)) output[key] = $3ad50ef6c4da68ad$var$filterNull(current);
    }
    return output;
};
const $3ad50ef6c4da68ad$var$createDocFromContent = (content)=>{
    return {
        version: 1,
        type: 'doc',
        content: content || []
    };
};
const $3ad50ef6c4da68ad$var$emptyDoc = $3ad50ef6c4da68ad$var$createDocFromContent([
    {
        type: 'paragraph',
        content: []
    }
]);
const $3ad50ef6c4da68ad$var$toJSON = (node)=>{
    const obj = {
        type: node.type.name
    };
    if ($3ad50ef6c4da68ad$var$isUnsupportedNode(node)) return node.attrs.originalValue;
    else if ($3ad50ef6c4da68ad$var$isMediaNode(node)) obj.attrs = (0, $gN3fl.toJSON)(node).attrs;
    else if ($3ad50ef6c4da68ad$var$isMediaSingleNode(node)) obj.attrs = (0, $cvCFq.toJSON)(node).attrs;
    else if ($3ad50ef6c4da68ad$var$isMediaInline(node)) obj.attrs = (0, $gN3fl.toJSON)(node).attrs;
    else if ($3ad50ef6c4da68ad$var$isMentionNode(node)) obj.attrs = (0, $fkqTY.toJSON)(node).attrs;
    else if ($3ad50ef6c4da68ad$var$isCodeBlock(node)) obj.attrs = (0, $hgVop.toJSON)(node).attrs;
    else if ($3ad50ef6c4da68ad$var$isTable(node)) obj.attrs = (0, $byxO6.tableToJSON)(node).attrs;
    else if ($3ad50ef6c4da68ad$var$isTableCell(node)) obj.attrs = (0, $byxO6.toJSONTableCell)(node).attrs;
    else if ($3ad50ef6c4da68ad$var$isTableHeader(node)) obj.attrs = (0, $byxO6.toJSONTableHeader)(node).attrs;
    else if ($3ad50ef6c4da68ad$var$isExpand(node) || $3ad50ef6c4da68ad$var$isNestedExpand(node)) obj.attrs = (0, $lKuoe.toJSON)(node).attrs;
    else if (node.attrs && Object.keys(node.attrs).length) obj.attrs = node.attrs;
    if (obj.attrs) obj.attrs = $3ad50ef6c4da68ad$var$filterNull(obj.attrs);
    // Remove the attrs property if it's empty, this is currently limited to paragraph nodes.
    if ($3ad50ef6c4da68ad$var$isParagraph(node) && obj.attrs && !Object.keys(obj.attrs).length) delete obj.attrs;
    if (node.isText) obj.text = node.textContent;
    else node.content.forEach((child)=>{
        obj.content = obj.content || [];
        obj.content.push($3ad50ef6c4da68ad$var$toJSON(child));
    });
    if ($3ad50ef6c4da68ad$var$isParagraph(node) || $3ad50ef6c4da68ad$var$isHeading(node)) obj.content = obj.content || [];
    if (node.marks.length) {
        // Run any custom mark serialisers
        const parsedMarks = node.marks.map((mark)=>{
            if ($3ad50ef6c4da68ad$var$isUnsupportedMark(mark)) return $3ad50ef6c4da68ad$var$canOverrideMark(mark, node.marks) ? null : mark.attrs.originalValue;
            else if ($3ad50ef6c4da68ad$var$isUnsupportedNodeAttributeMark(mark)) return null;
            else if ($3ad50ef6c4da68ad$var$isLinkMark(mark)) return (0, $3SpHb.toJSON)(mark);
            else if ($3ad50ef6c4da68ad$var$isDataConsumer(mark)) {
                const serialised = (0, $8nj7b.toJSON)(mark);
                return !serialised.attrs.sources || serialised.attrs.sources?.length === 0 ? null : serialised;
            } else if ($3ad50ef6c4da68ad$var$isFragmentMark(mark)) {
                const fragmentMark = (0, $9iaXL.toJSON)(mark);
                if (!fragmentMark.attrs.localId) return null;
                return fragmentMark;
            } else return mark.toJSON();
        }).filter((maybeMark)=>maybeMark !== null);
        // Only set if we have a non-empty array, otherwise explicitly undefine it (as we only run this path if `node.marks.length`)
        obj.marks = parsedMarks?.length > 0 ? parsedMarks : undefined;
        const nodeAttributeMark = node.marks.find($3ad50ef6c4da68ad$var$isUnsupportedNodeAttributeMark);
        if (nodeAttributeMark && nodeAttributeMark.attrs.type.nodeType === obj.type) obj.attrs = {
            ...$3ad50ef6c4da68ad$var$getUnwrappedNodeAttributes(node, nodeAttributeMark, obj)
        };
    }
    return obj;
};
const $3ad50ef6c4da68ad$var$canOverrideMark = (mark, existingMarks)=>{
    if (existingMarks.some((e)=>mark.attrs.originalValue.type === e.type.name)) return (0, $dxv8o.markOverrideRuleFor)(mark.attrs.originalValue.type).canOverrideUnsupportedMark();
    return false;
};
const $3ad50ef6c4da68ad$var$getUnwrappedNodeAttributes = (node, mark, obj)=>{
    const nodeAttributes = node.type.spec.attrs;
    const attributes = {
        ...mark.attrs.unsupported,
        ...obj.attrs
    };
    for(var key in obj.attrs)if (obj.attrs.hasOwnProperty(key)) {
        const attribute = nodeAttributes ? nodeAttributes[key] : null;
        if (attribute) {
            if (attribute.default === node.attrs[key] && mark.attrs.unsupported[key]) return {
                ...attributes,
                [key]: mark.attrs.unsupported[key]
            };
        }
    }
    return attributes;
};
class $3ad50ef6c4da68ad$export$98cb1d9308d0944d {
    encode(node) {
        const content = [];
        node.content.forEach((child)=>{
            content.push((0, $gbvAY.sanitizeNode)($3ad50ef6c4da68ad$var$toJSON(child)));
        });
        if (!content || (0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(content, $3ad50ef6c4da68ad$var$emptyDoc.content)) return $3ad50ef6c4da68ad$var$createDocFromContent([]);
        return $3ad50ef6c4da68ad$var$createDocFromContent(content);
    }
    internalParse(content, stage = "final") {
        const schema = (0, $9wcjJ.getSchemaBasedOnStage)(stage);
        const doc = schema.nodeFromJSON(content);
        doc.check();
        return doc;
    }
    parse(content, stage) {
        if (content.type !== 'doc') throw new Error('Expected content format to be ADF');
        if (!content.content || content.content.length === 0) return this.internalParse($3ad50ef6c4da68ad$var$emptyDoc, stage);
        return this.internalParse(content, stage);
    }
    /**
	 * This method is used to encode a single node
	 */ encodeNode(node) {
        return (0, $gbvAY.sanitizeNode)($3ad50ef6c4da68ad$var$toJSON(node));
    }
}

});
parcelRegister("dxv8o", function(module, exports) {

$parcel$export(module.exports, "markOverrideRuleFor", () => $c20debfacfaca33a$export$28e4e3c024cce988);
const $c20debfacfaca33a$var$defaultAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return true;
    }
};
const $c20debfacfaca33a$var$defaultDoNotAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return false;
    }
};
const $c20debfacfaca33a$export$28e4e3c024cce988 = (type)=>{
    switch(type){
        case 'link':
        case 'em':
        case 'strong':
        case 'strike':
        case 'subsup':
        case 'underline':
        case 'code':
        case 'textColor':
        case 'backgroundColor':
        case 'confluenceInlineComment':
        case 'breakout':
        case 'alignment':
        case 'indentation':
        case 'border':
            return $c20debfacfaca33a$var$defaultAllowOverrideBehaviour;
        default:
            return $c20debfacfaca33a$var$defaultDoNotAllowOverrideBehaviour;
    }
};

});

parcelRegister("gbvAY", function(module, exports) {

$parcel$export(module.exports, "sanitizeNode", () => $a78a3c5cfd4c361e$export$48b382180baf8e88);

var $hYZXM = parcelRequire("hYZXM");

var $i9nQI = parcelRequire("i9nQI");
function $a78a3c5cfd4c361e$export$48b382180baf8e88(json) {
    const sanitizedJSON = (0, $hYZXM.traverse)(json, {
        text: (node)=>{
            if (!node || !Array.isArray(node.marks)) return node;
            return {
                ...node,
                marks: node.marks.filter((mark)=>mark.type !== 'typeAheadQuery')
            };
        },
        status: (node)=>{
            if (node.attrs && !!node.attrs.text) return (0, $i9nQI.removeNonAnnotationMarks)(node);
            return false; // empty status
        },
        caption: (node)=>{
            if (node.content) return node;
            return false; // empty caption
        },
        emoji: (0, $i9nQI.removeNonAnnotationMarks),
        mention: (0, $i9nQI.removeNonAnnotationMarks),
        date: (0, $i9nQI.removeNonAnnotationMarks),
        hardBreak: (0, $i9nQI.removeMarks),
        inlineCard: (0, $i9nQI.removeNonAnnotationMarks)
    });
    return sanitizedJSON;
}

});
parcelRegister("i9nQI", function(module, exports) {

$parcel$export(module.exports, "removeMarks", () => $638c380cab2e60ba$export$9bf001d8ef76e497);
$parcel$export(module.exports, "removeNonAnnotationMarks", () => $638c380cab2e60ba$export$8cae9126fc577085);
function $638c380cab2e60ba$export$9bf001d8ef76e497(node) {
    let newNode = {
        ...node
    };
    delete newNode.marks;
    return newNode;
}
function $638c380cab2e60ba$export$8cae9126fc577085(node) {
    let newNode = {
        ...node
    };
    if (node.marks) newNode.marks = node.marks.filter((mark)=>mark.type === 'annotation');
    return newNode;
}

});




parcelRegister("gP1iJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $aab24c083dcc3a2b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1ngde = parcelRequire("1ngde");

var $lyAeo = parcelRequire("lyAeo");

var $6aS3b = parcelRequire("6aS3b");

var $jasdt = parcelRequire("jasdt");

var $4PrNA = parcelRequire("4PrNA");
const $aab24c083dcc3a2b$var$PACKAGE_DATA = {
    packageName: undefined,
    packageVersion: undefined,
    componentName: 'linkUrl'
};
const $aab24c083dcc3a2b$var$Link = (0, $lyAeo.withLinkClickedEvent)('a');
const $aab24c083dcc3a2b$var$LinkUrl = ({ href: href, children: children, checkSafety: checkSafety = true, onClick: onClick, testId: testId = 'link-with-safety', ...props })=>{
    const { isLinkSafe: isLinkSafe, showSafetyWarningModal: showSafetyWarningModal, ...linkWarningModalProps } = (0, $jasdt.useLinkWarningModal)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6aS3b.LinkAnalyticsContext), {
        url: href,
        display: "url"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aab24c083dcc3a2b$var$Link, {
        "data-testid": testId,
        href: href,
        onClick: (e)=>{
            if (!checkSafety) {
                onClick && onClick(e);
                return;
            }
            // Only call the onClick if the link is safe
            if (isLinkSafe(e, href)) onClick && onClick(e);
            else showSafetyWarningModal(e, href);
        },
        ...props
    }, children)), checkSafety && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4PrNA.default), linkWarningModalProps));
};
var $aab24c083dcc3a2b$export$2e2bcd8739ae039 = (0, $1ngde.default)($aab24c083dcc3a2b$var$PACKAGE_DATA)($aab24c083dcc3a2b$var$LinkUrl);

});
parcelRegister("lyAeo", function(module, exports) {

$parcel$export(module.exports, "fireLinkClickedEvent", () => $a830f7743a3fdab2$export$7987de3055fbdcb0);
$parcel$export(module.exports, "withLinkClickedEvent", () => $a830f7743a3fdab2$export$263352d59c0c5966);

var $eUqFw = parcelRequire("eUqFw");

var $4LwTb = parcelRequire("4LwTb");

var $bTNMs = parcelRequire("bTNMs");

var $8sbpW = parcelRequire("8sbpW");
const $a830f7743a3fdab2$export$cfb45d54e1604f6c = new Map([
    [
        undefined,
        'none'
    ],
    [
        0,
        'left'
    ],
    [
        1,
        'middle'
    ],
    [
        2,
        'right'
    ]
]);
const $a830f7743a3fdab2$export$74743eda5dda3ccf = (e)=>{
    return [
        'alt',
        'ctrl',
        'meta',
        'shift'
    ].filter((key)=>e[`${key}Key`] === true);
};
const $a830f7743a3fdab2$var$isContentEditable = (el)=>{
    return el instanceof HTMLElement && el.isContentEditable;
};
function $a830f7743a3fdab2$export$d2a83e3b34be812b(e, clickType) {
    const { mac: mac, safari: safari } = (0, $4LwTb.browser)();
    /**
	 * If the link/parent is content editable then left click won't have typical effect
	 */ if ($a830f7743a3fdab2$var$isContentEditable(e.currentTarget) && [
        'left',
        'middle'
    ].includes(clickType)) return 'contentEditable';
    switch(clickType){
        case 'left':
        case 'keyboard':
            {
                // Meta key = Cmd for macOS, Windows key sometimes for Windows (otherwise false)
                // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/metaKey
                if (e.metaKey) return mac ? 'clickThroughNewTabOrWindow' : 'clickThrough';
                if (e.shiftKey) {
                    // Alt/option click in safari typically adds the link to bookmarks
                    if (safari) return 'alt';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.ctrlKey) {
                    // Ctrl+Left on macOS defaults to triggering a right click instead (so won't trigger onClick)
                    // but if this behaviour is disabled, likely outcome is clickThrough
                    if (mac) return 'clickThrough';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.altKey) return 'alt';
                const target = e.currentTarget.getAttribute('target');
                if (target === '_blank') return 'clickThroughNewTabOrWindow';
                return 'clickThrough';
            }
        case 'middle':
            return 'clickThroughNewTabOrWindow';
        case 'right':
            return 'contextMenu';
    }
    return 'unknown';
}
const $a830f7743a3fdab2$var$linkClickedEvent = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented })=>({
        action: 'clicked',
        actionSubject: 'link',
        eventType: 'ui',
        attributes: {
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented
        }
    });
const $a830f7743a3fdab2$export$7fedc699766c16de = (event)=>{
    // Through the `detail` property, we're able to determine if the event is (most likely) triggered via keyboard
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    const isKeyboard = event.nativeEvent.detail === 0;
    const clickType = isKeyboard ? 'keyboard' : $a830f7743a3fdab2$export$cfb45d54e1604f6c.get(event.button);
    if (!clickType) return;
    const clickOutcome = $a830f7743a3fdab2$export$d2a83e3b34be812b(event, clickType);
    const keysHeld = $a830f7743a3fdab2$export$74743eda5dda3ccf(event);
    const defaultPrevented = event.defaultPrevented;
    return $a830f7743a3fdab2$var$linkClickedEvent({
        clickType: clickType,
        clickOutcome: clickOutcome,
        keysHeld: keysHeld,
        defaultPrevented: defaultPrevented
    });
};
const $a830f7743a3fdab2$export$7987de3055fbdcb0 = (createAnalyticsEvent)=>(event, overrides = {})=>{
        const payload = $a830f7743a3fdab2$export$7fedc699766c16de(event);
        if (payload) createAnalyticsEvent({
            ...payload,
            ...overrides,
            attributes: {
                ...payload.attributes,
                ...overrides?.attributes
            }
        }).fire((0, $bTNMs.ANALYTICS_CHANNEL));
    };
const $a830f7743a3fdab2$var$getDisplayName = (WrappedComponent)=>{
    if (typeof WrappedComponent === 'string') return WrappedComponent;
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
function $a830f7743a3fdab2$export$263352d59c0c5966(WrappedComponent) {
    const Component = (props)=>{
        const onClick = (0, $8sbpW.useLinkClicked)(props.onClick);
        const onMouseDown = (0, $8sbpW.useMouseDownEvent)(props.onMouseDown);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ...props,
            onClick: onClick,
            onMouseDown: onMouseDown
        });
    };
    Component.displayName = `withLinkClickedEvent(${$a830f7743a3fdab2$var$getDisplayName(WrappedComponent)})`;
    return Component;
}

});
parcelRegister("4LwTb", function(module, exports) {

$parcel$export(module.exports, "browser", () => $53e1c38db50269d3$export$3f2684e5d7cb1006);
const $53e1c38db50269d3$var$result = {
    mac: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    $53e1c38db50269d3$var$result.mac = /Mac/.test(navigator.platform);
    let ie = $53e1c38db50269d3$var$result.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $53e1c38db50269d3$var$result.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    $53e1c38db50269d3$var$result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    $53e1c38db50269d3$var$result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    $53e1c38db50269d3$var$result.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    $53e1c38db50269d3$var$result.android = /Android \d/.test(navigator.userAgent);
    $53e1c38db50269d3$var$result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $53e1c38db50269d3$var$result.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $53e1c38db50269d3$var$result.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $53e1c38db50269d3$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $53e1c38db50269d3$var$result.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}
function $53e1c38db50269d3$export$3f2684e5d7cb1006() {
    return $53e1c38db50269d3$var$result;
}

});

parcelRegister("bTNMs", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $0a26d6e0cc0b2d68$export$85183a312807388d);
$parcel$export(module.exports, "context", () => $0a26d6e0cc0b2d68$export$a078c61943f9dbbe);
$parcel$export(module.exports, "TrackQuickActionType", () => $0a26d6e0cc0b2d68$export$72af824fa910c33e);
$parcel$export(module.exports, "TrackQuickActionFailureReason", () => $0a26d6e0cc0b2d68$export$c89e475f7f7174c2);
$parcel$export(module.exports, "SmartLinkEvents", () => $0a26d6e0cc0b2d68$export$b91e0203b928470c);
$parcel$export(module.exports, "resolvedEvent", () => $0a26d6e0cc0b2d68$export$e2e1bab8375c3115);
$parcel$export(module.exports, "unresolvedEvent", () => $0a26d6e0cc0b2d68$export$331b399cdebbb8d4);
$parcel$export(module.exports, "invokeSucceededEvent", () => $0a26d6e0cc0b2d68$export$237caeb1002642ba);
$parcel$export(module.exports, "invokeFailedEvent", () => $0a26d6e0cc0b2d68$export$ac488bf3e4c7f93);
$parcel$export(module.exports, "connectSucceededEvent", () => $0a26d6e0cc0b2d68$export$5f549b8ba38f19b1);
$parcel$export(module.exports, "connectFailedEvent", () => $0a26d6e0cc0b2d68$export$fdfcba182edbb89a);
$parcel$export(module.exports, "trackAppAccountConnected", () => $0a26d6e0cc0b2d68$export$27d8deca51e9575c);
$parcel$export(module.exports, "trackAppAccountAuthStarted", () => $0a26d6e0cc0b2d68$export$48e92e116e00d94c);
$parcel$export(module.exports, "trackSmartLinkQuickActionStarted", () => $0a26d6e0cc0b2d68$export$1c2a74fe02a8031b);
$parcel$export(module.exports, "trackSmartLinkQuickActionSuccess", () => $0a26d6e0cc0b2d68$export$afbd6446c1c03a3e);
$parcel$export(module.exports, "trackSmartLinkQuickActionFailed", () => $0a26d6e0cc0b2d68$export$2706827739a8c50);
$parcel$export(module.exports, "trackHoverCardResolutionStarted", () => $0a26d6e0cc0b2d68$export$daa964b113be9527);
$parcel$export(module.exports, "uiAuthEvent", () => $0a26d6e0cc0b2d68$export$5318734335f1d8b8);
$parcel$export(module.exports, "uiAuthAlternateAccountEvent", () => $0a26d6e0cc0b2d68$export$14f2ce8523ccb652);
$parcel$export(module.exports, "uiCardClickedEvent", () => $0a26d6e0cc0b2d68$export$8b5d1f55370347a1);
$parcel$export(module.exports, "uiIframeDwelledEvent", () => $0a26d6e0cc0b2d68$export$6b045396616c2e9f);
$parcel$export(module.exports, "uiIframeFocusedEvent", () => $0a26d6e0cc0b2d68$export$93fa3246cf9e3b52);
$parcel$export(module.exports, "uiActionClickedEvent", () => $0a26d6e0cc0b2d68$export$e00b9d79d3367530);
$parcel$export(module.exports, "uiClosedAuthEvent", () => $0a26d6e0cc0b2d68$export$fe5b1f066ca3365d);
$parcel$export(module.exports, "screenAuthPopupEvent", () => $0a26d6e0cc0b2d68$export$69bb595db263d8ef);
$parcel$export(module.exports, "uiRenderSuccessEvent", () => $0a26d6e0cc0b2d68$export$bd308326cf1076aa);
$parcel$export(module.exports, "uiRenderFailedEvent", () => $0a26d6e0cc0b2d68$export$1543b6391f48a5e2);
$parcel$export(module.exports, "uiHoverCardViewedEvent", () => $0a26d6e0cc0b2d68$export$e80a2f97cccab3b1);
$parcel$export(module.exports, "uiHoverCardDismissedEvent", () => $0a26d6e0cc0b2d68$export$3d10c6f90bc461d3);
$parcel$export(module.exports, "uiHoverCardOpenLinkClickedEvent", () => $0a26d6e0cc0b2d68$export$ad3275d7dff50d21);
$parcel$export(module.exports, "uiLearnMoreLinkClickedEvent", () => $0a26d6e0cc0b2d68$export$925348ae8d2e0bf3);
$parcel$export(module.exports, "chunkloadFailedEvent", () => $0a26d6e0cc0b2d68$export$2b6bbed3753f06f9);
$parcel$export(module.exports, "uiSmartLinkStatusLozengeButtonClicked", () => $0a26d6e0cc0b2d68$export$94c3643533642ab);
$parcel$export(module.exports, "uiSmartLinkStatusListItemButtonClicked", () => $0a26d6e0cc0b2d68$export$18dfe458db0b743d);
$parcel$export(module.exports, "uiSmartLinkStatusOpenPreviewButtonClicked", () => $0a26d6e0cc0b2d68$export$9a352e2e15b3de89);
$parcel$export(module.exports, "uiServerActionClicked", () => $0a26d6e0cc0b2d68$export$a66dc699502b5d28);

var $hEsGF = parcelRequire("hEsGF");

var $cCvxR = parcelRequire("cCvxR");
const $0a26d6e0cc0b2d68$export$85183a312807388d = 'media';
const $0a26d6e0cc0b2d68$export$a078c61943f9dbbe = {
    componentName: 'smart-cards',
    packageName: undefined,
    packageVersion: undefined
};
var $0a26d6e0cc0b2d68$export$72af824fa910c33e;
(function(TrackQuickActionType) {
    TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
})($0a26d6e0cc0b2d68$export$72af824fa910c33e || ($0a26d6e0cc0b2d68$export$72af824fa910c33e = {}));
var $0a26d6e0cc0b2d68$export$c89e475f7f7174c2;
(function(TrackQuickActionFailureReason) {
    TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
    TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
    TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
})($0a26d6e0cc0b2d68$export$c89e475f7f7174c2 || ($0a26d6e0cc0b2d68$export$c89e475f7f7174c2 = {}));
const $0a26d6e0cc0b2d68$export$bbd674aacb40a160 = {
    [(0, $cCvxR.SmartLinkActionType).FollowEntityAction]: 'Follow',
    [(0, $cCvxR.SmartLinkActionType).StatusUpdateAction]: 'StatusUpdate',
    [(0, $cCvxR.SmartLinkActionType).UnfollowEntityAction]: 'Unfollow'
};
const $0a26d6e0cc0b2d68$export$baf70a532f8c6fa6 = {
    [(0, $cCvxR.SmartLinkActionType).FollowEntityAction]: 'smartLinkFollowButton',
    [(0, $cCvxR.SmartLinkActionType).UnfollowEntityAction]: 'smartLinkFollowButton'
};
const $0a26d6e0cc0b2d68$var$uiActionSubjectIds = {
    DownloadAction: 'downloadDocument',
    PreviewAction: 'invokePreviewScreen',
    ViewAction: 'shortcutGoToLink',
    StatusAction: 'issueStatusUpdate'
};
class $0a26d6e0cc0b2d68$export$b91e0203b928470c {
    insertSmartLink(url, type, createAnalyticsEvent) {
        $0a26d6e0cc0b2d68$export$2a123f7ee48a122c({
            action: 'inserted',
            actionSubject: 'smartLink',
            eventType: 'track',
            attributes: {
                type: type
            },
            nonPrivacySafeAttributes: {
                domainName: url
            }
        }, createAnalyticsEvent);
    }
}
const $0a26d6e0cc0b2d68$export$2a123f7ee48a122c = (payload, createAnalyticsEvent)=>{
    if (createAnalyticsEvent) createAnalyticsEvent(payload).fire($0a26d6e0cc0b2d68$export$85183a312807388d);
};
const $0a26d6e0cc0b2d68$export$e2e1bab8375c3115 = (props)=>({
        action: 'resolved',
        actionSubject: 'smartLink',
        eventType: 'operational',
        attributes: {
            ...props,
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe
        }
    });
const $0a26d6e0cc0b2d68$export$331b399cdebbb8d4 = ({ id: id, definitionId: definitionId, extensionKey: extensionKey, resourceType: resourceType, destinationSubproduct: destinationSubproduct, destinationProduct: destinationProduct, error: error, status: status, location: location })=>({
        action: 'unresolved',
        actionSubject: 'smartLink',
        eventType: 'operational',
        attributes: {
            id: id,
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            ...definitionId ? {
                definitionId: definitionId
            } : {},
            ...extensionKey ? {
                extensionKey: extensionKey
            } : {},
            ...resourceType ? {
                resourceType: resourceType
            } : {},
            ...destinationSubproduct ? {
                destinationSubproduct: destinationSubproduct
            } : {},
            ...destinationProduct ? {
                destinationProduct: destinationProduct
            } : {},
            ...location ? {
                location: location
            } : {},
            reason: status,
            error: error ? {
                message: error?.message,
                kind: error?.kind,
                type: error?.type
            } : undefined
        }
    });
const $0a26d6e0cc0b2d68$export$237caeb1002642ba = ({ id: id, actionType: actionType, display: display, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
    const measure = id ? (0, $hEsGF.getMeasure)(id, 'resolved') : undefined;
    return {
        action: 'resolved',
        actionSubject: 'smartLinkAction',
        eventType: 'operational',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            actionType: actionType,
            display: display,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            extensionKey: extensionKey,
            duration: measure?.duration
        }
    };
};
const $0a26d6e0cc0b2d68$export$ac488bf3e4c7f93 = ({ id: id, actionType: actionType, display: display, reason: reason, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>{
    const measure = id ? (0, $hEsGF.getMeasure)(id, 'errored') : undefined;
    return {
        action: 'unresolved',
        actionSubject: 'smartLinkAction',
        eventType: 'operational',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            actionType: actionType,
            display: display,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            duration: measure?.duration,
            reason: reason
        }
    };
};
const $0a26d6e0cc0b2d68$export$5f549b8ba38f19b1 = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        action: 'connectSucceeded',
        actionSubject: 'smartLink',
        eventType: 'operational',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            definitionId: definitionId,
            extensionKey: extensionKey,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$fdfcba182edbb89a = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, reason: reason })=>({
        action: 'connectFailed',
        actionSubject: 'smartLink',
        actionSubjectId: reason,
        eventType: 'operational',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            reason: reason,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$27d8deca51e9575c = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        action: 'connected',
        actionSubject: 'applicationAccount',
        eventType: 'track',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            definitionId: definitionId,
            extensionKey: extensionKey,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$48e92e116e00d94c = ({ extensionKey: extensionKey, location: location })=>({
        action: 'authStarted',
        actionSubject: 'applicationAccount',
        eventType: 'track',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            extensionKey: extensionKey,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$1c2a74fe02a8031b = ({ smartLinkActionType: smartLinkActionType, ...attributes })=>({
        action: 'started',
        actionSubject: 'smartLinkQuickAction',
        eventType: 'track',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            ...attributes,
            smartLinkActionType: $0a26d6e0cc0b2d68$export$bbd674aacb40a160[smartLinkActionType] ?? smartLinkActionType
        }
    });
const $0a26d6e0cc0b2d68$export$afbd6446c1c03a3e = ({ smartLinkActionType: smartLinkActionType, ...attributes })=>({
        action: 'success',
        actionSubject: 'smartLinkQuickAction',
        eventType: 'track',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            ...attributes,
            smartLinkActionType: $0a26d6e0cc0b2d68$export$bbd674aacb40a160[smartLinkActionType] ?? smartLinkActionType
        }
    });
const $0a26d6e0cc0b2d68$export$2706827739a8c50 = ({ smartLinkActionType: smartLinkActionType, ...attributes })=>({
        action: 'failed',
        actionSubject: 'smartLinkQuickAction',
        eventType: 'track',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            ...attributes,
            smartLinkActionType: $0a26d6e0cc0b2d68$export$bbd674aacb40a160[smartLinkActionType] ?? smartLinkActionType
        }
    });
const $0a26d6e0cc0b2d68$export$daa964b113be9527 = ({ display: display, ...attributes })=>({
        action: 'resolved',
        actionSubject: 'hoverCard',
        eventType: 'track',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            ...attributes,
            display: display
        }
    });
const $0a26d6e0cc0b2d68$export$5318734335f1d8b8 = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, display: display })=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'connectAccount',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            definitionId: definitionId,
            extensionKey: extensionKey,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            display: display
        }
    });
const $0a26d6e0cc0b2d68$export$14f2ce8523ccb652 = ({ definitionId: definitionId, extensionKey: extensionKey, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, display: display })=>({
        action: 'clicked',
        actionSubject: 'smartLink',
        actionSubjectId: 'tryAnotherAccount',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            definitionId: definitionId,
            extensionKey: extensionKey,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            display: display
        }
    });
const $0a26d6e0cc0b2d68$export$8b5d1f55370347a1 = ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, isModifierKeyPressed: isModifierKeyPressed, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, actionSubjectId: actionSubjectId })=>({
        action: 'clicked',
        actionSubject: 'smartLink',
        actionSubjectId: actionSubjectId,
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            status: status,
            definitionId: definitionId,
            extensionKey: extensionKey,
            display: display,
            isModifierKeyPressed: isModifierKeyPressed,
            location: location,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct
        }
    });
const $0a26d6e0cc0b2d68$export$6b045396616c2e9f = ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, dwellTime: dwellTime, dwellPercentVisible: dwellPercentVisible })=>({
        action: 'dwelled',
        actionSubject: 'smartLinkIframe',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            status: status,
            definitionId: definitionId,
            extensionKey: extensionKey,
            display: display,
            location: location,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            dwellTime: dwellTime,
            dwellPercentVisible: dwellPercentVisible
        }
    });
const $0a26d6e0cc0b2d68$export$93fa3246cf9e3b52 = ({ id: id, display: display, status: status, definitionId: definitionId, extensionKey: extensionKey, location: location, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct })=>({
        action: 'focused',
        actionSubject: 'smartLinkIframe',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            status: status,
            definitionId: definitionId,
            extensionKey: extensionKey,
            display: display,
            location: location,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct
        }
    });
const $0a26d6e0cc0b2d68$export$e00b9d79d3367530 = ({ id: id, actionType: actionType, extensionKey: extensionKey, display: display, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: $0a26d6e0cc0b2d68$var$uiActionSubjectIds[actionType],
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            display: display,
            actionType: actionType,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$fe5b1f066ca3365d = ({ display: display, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        action: 'closed',
        actionSubject: 'consentModal',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            display: display
        }
    });
const $0a26d6e0cc0b2d68$export$69bb595db263d8ef = ({ extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        actionSubject: 'consentModal',
        eventType: 'screen',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$bd308326cf1076aa = ({ display: display, status: status, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, canBeDatasource: canBeDatasource })=>({
        action: 'renderSuccess',
        actionSubject: 'smartLink',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            status: status,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            display: display,
            canBeDatasource: canBeDatasource
        }
    });
const $0a26d6e0cc0b2d68$export$1543b6391f48a5e2 = ({ display: display, error: error, errorInfo: errorInfo, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        actionSubject: 'smartLink',
        action: 'renderFailed',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            error: error,
            errorInfo: errorInfo,
            display: display,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$e80a2f97cccab3b1 = ({ id: id, previewDisplay: previewDisplay, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod, status: status })=>({
        action: 'viewed',
        actionSubject: 'hoverCard',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            previewDisplay: previewDisplay,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            previewInvokeMethod: previewInvokeMethod,
            status: status
        }
    });
const $0a26d6e0cc0b2d68$export$3d10c6f90bc461d3 = ({ id: id, previewDisplay: previewDisplay, hoverTime: hoverTime, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod, status: status })=>({
        action: 'dismissed',
        actionSubject: 'hoverCard',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            previewDisplay: previewDisplay,
            hoverTime: hoverTime,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            previewInvokeMethod: previewInvokeMethod,
            status: status
        }
    });
const $0a26d6e0cc0b2d68$export$ad3275d7dff50d21 = ({ id: id, previewDisplay: previewDisplay, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location, previewInvokeMethod: previewInvokeMethod })=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'shortcutGoToLink',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            id: id,
            previewDisplay: previewDisplay,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location,
            previewInvokeMethod: previewInvokeMethod
        }
    });
const $0a26d6e0cc0b2d68$export$925348ae8d2e0bf3 = ()=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'learnMore',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe
        }
    });
const $0a26d6e0cc0b2d68$export$2b6bbed3753f06f9 = ({ display: display, error: error, errorInfo: errorInfo, extensionKey: extensionKey, definitionId: definitionId, destinationProduct: destinationProduct, destinationSubproduct: destinationSubproduct, location: location })=>({
        action: 'chunkLoadFailed',
        actionSubject: 'smartLink',
        eventType: 'operational',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe,
            error: error,
            errorInfo: errorInfo,
            display: display,
            extensionKey: extensionKey,
            definitionId: definitionId,
            destinationProduct: destinationProduct,
            destinationSubproduct: destinationSubproduct,
            location: location
        }
    });
const $0a26d6e0cc0b2d68$export$94c3643533642ab = ()=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'smartLinkStatusLozenge',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe
        }
    });
const $0a26d6e0cc0b2d68$export$18dfe458db0b743d = ()=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'smartLinkStatusListItem',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe
        }
    });
const $0a26d6e0cc0b2d68$export$9a352e2e15b3de89 = ()=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: 'smartLinkStatusOpenPreview',
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe
        }
    });
const $0a26d6e0cc0b2d68$export$a66dc699502b5d28 = ({ smartLinkActionType: smartLinkActionType })=>({
        action: 'clicked',
        actionSubject: 'button',
        actionSubjectId: $0a26d6e0cc0b2d68$export$baf70a532f8c6fa6[smartLinkActionType] ?? smartLinkActionType,
        eventType: 'ui',
        attributes: {
            ...$0a26d6e0cc0b2d68$export$a078c61943f9dbbe
        }
    });

});
parcelRegister("hEsGF", function(module, exports) {

$parcel$export(module.exports, "clearMarks", () => $c9b3a002aa9f3cfd$export$1a717feb4df1a945);
$parcel$export(module.exports, "clearMeasures", () => $c9b3a002aa9f3cfd$export$de42547d395c8271);
$parcel$export(module.exports, "getMeasure", () => $c9b3a002aa9f3cfd$export$d6e97a903ae9a3aa);
$parcel$export(module.exports, "mark", () => $c9b3a002aa9f3cfd$export$bf7f2fce5c1cf636);
$parcel$export(module.exports, "create", () => $c9b3a002aa9f3cfd$export$185802fd694ee1f5);
const $c9b3a002aa9f3cfd$var$isPerformanceAPIAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every((api)=>!!performance[api]);
};
const $c9b3a002aa9f3cfd$var$hasPerformanceAPIAvailable = $c9b3a002aa9f3cfd$var$isPerformanceAPIAvailable();
const $c9b3a002aa9f3cfd$export$fcff3185c7ce7f2b = (id, status)=>`${status}:${id}`;
const $c9b3a002aa9f3cfd$export$984df7f61dd7928f = (id, status)=>`time-to-${status}:${id}`;
const $c9b3a002aa9f3cfd$export$1a717feb4df1a945 = (id)=>{
    if ($c9b3a002aa9f3cfd$var$hasPerformanceAPIAvailable) {
        const marks = performance.getEntriesByType('mark').filter((mark)=>mark.name.includes(id));
        marks.forEach((mark)=>performance.clearMarks(mark.name));
    }
};
const $c9b3a002aa9f3cfd$export$de42547d395c8271 = (id)=>{
    if ($c9b3a002aa9f3cfd$var$hasPerformanceAPIAvailable) {
        const measures = performance.getEntriesByType('measure').filter((measure)=>measure.name.includes(id));
        measures.forEach((measure)=>performance.clearMeasures(measure.name));
    }
};
const $c9b3a002aa9f3cfd$var$getMark = (id, status)=>{
    if ($c9b3a002aa9f3cfd$var$hasPerformanceAPIAvailable) {
        const name = $c9b3a002aa9f3cfd$export$fcff3185c7ce7f2b(id, status);
        const marks = performance.getEntriesByName(name);
        if (marks.length > 0) return marks[0];
        return undefined;
    }
};
const $c9b3a002aa9f3cfd$export$d6e97a903ae9a3aa = (id, status)=>{
    if ($c9b3a002aa9f3cfd$var$hasPerformanceAPIAvailable) {
        const name = $c9b3a002aa9f3cfd$export$984df7f61dd7928f(id, status);
        const measures = performance.getEntriesByName(name);
        if (measures.length > 0) return measures[0];
        return undefined;
    }
};
const $c9b3a002aa9f3cfd$export$bf7f2fce5c1cf636 = (id, status)=>{
    if ($c9b3a002aa9f3cfd$var$hasPerformanceAPIAvailable) {
        const name = $c9b3a002aa9f3cfd$export$fcff3185c7ce7f2b(id, status);
        performance.mark(name);
    }
};
const $c9b3a002aa9f3cfd$export$185802fd694ee1f5 = (id, status)=>{
    if ($c9b3a002aa9f3cfd$var$hasPerformanceAPIAvailable) {
        const name = $c9b3a002aa9f3cfd$export$984df7f61dd7928f(id, status);
        const measure = $c9b3a002aa9f3cfd$export$d6e97a903ae9a3aa(id, status);
        if (!measure) {
            const startMark = $c9b3a002aa9f3cfd$var$getMark(id, 'pending');
            const endMark = $c9b3a002aa9f3cfd$var$getMark(id, status);
            if (startMark && endMark) performance.measure(name, startMark.name, endMark.name);
        }
    }
};

});

parcelRegister("cCvxR", function(module, exports) {

$parcel$export(module.exports, "SmartLinkActionType", () => $8c69a400a46c2e51$export$6324b7946ad663e9);
$parcel$export(module.exports, "InvokeError", () => $8c69a400a46c2e51$export$d4d72202bff63658);
/**
 * The enum that describes Smart Link action types
 */ var $8c69a400a46c2e51$export$6324b7946ad663e9;
(function(SmartLinkActionType) {
    SmartLinkActionType["FollowEntityAction"] = "FollowEntityAction";
    SmartLinkActionType["GetStatusTransitionsAction"] = "GetStatusTransitionsAction";
    SmartLinkActionType["StatusUpdateAction"] = "StatusUpdateAction";
    SmartLinkActionType["UnfollowEntityAction"] = "UnfollowEntityAction";
})($8c69a400a46c2e51$export$6324b7946ad663e9 || ($8c69a400a46c2e51$export$6324b7946ad663e9 = {}));
class $8c69a400a46c2e51$export$d4d72202bff63658 extends Error {
    constructor(message, errorCode){
        super(message);
        this.errorCode = errorCode;
    }
}

});


parcelRegister("8sbpW", function(module, exports) {

$parcel$export(module.exports, "useLinkClicked", () => $ae3e58c828553a00$export$5993d3ca6c85f774);
$parcel$export(module.exports, "useMouseDownEvent", () => $ae3e58c828553a00$export$df67f318ded0283c);

var $eUqFw = parcelRequire("eUqFw");

var $bFzGY = parcelRequire("bFzGY");

var $lyAeo = parcelRequire("lyAeo");
var $ae3e58c828553a00$export$81a5b494baf0f17c;
(function(ClickButton) {
    ClickButton[ClickButton["Left"] = 0] = "Left";
    ClickButton[ClickButton["Middle"] = 1] = "Middle";
    ClickButton[ClickButton["Right"] = 2] = "Right";
})($ae3e58c828553a00$export$81a5b494baf0f17c || ($ae3e58c828553a00$export$81a5b494baf0f17c = {}));
const $ae3e58c828553a00$export$5993d3ca6c85f774 = (/**
	 * Handler to
	 */ handler, /**
	 * Filter which mouse events should trigger the link clicked event
	 */ predicate)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (0, $eUqFw.useCallback)((...args)=>{
        const [event] = args;
        handler?.apply(null, args);
        if (!predicate || predicate?.(event)) (0, $lyAeo.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        handler,
        predicate,
        createAnalyticsEvent
    ]);
};
const $ae3e58c828553a00$var$isNotLeftClick = (event)=>event.button !== 0;
const $ae3e58c828553a00$export$df67f318ded0283c = (onMouseDown)=>{
    return $ae3e58c828553a00$export$5993d3ca6c85f774(onMouseDown, $ae3e58c828553a00$var$isNotLeftClick);
};

});


parcelRegister("6aS3b", function(module, exports) {

$parcel$export(module.exports, "LinkAnalyticsContext", () => $225f130421a19d23$export$9458cdec663b9ff1);

var $eUqFw = parcelRequire("eUqFw");

var $aw5Sy = parcelRequire("aw5Sy");
const $225f130421a19d23$export$9458cdec663b9ff1 = ({ display: display, id: id, children: children, source: source })=>{
    const displayCategory = display === 'url' ? 'link' : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aw5Sy.default), {
        data: {
            source: source,
            attributes: {
                displayCategory: displayCategory,
                display: display,
                id: id
            }
        }
    }, children);
};

});

parcelRegister("jasdt", function(module, exports) {

$parcel$export(module.exports, "useLinkWarningModal", () => $22736ecc26df3888$export$32b76c003683c2ec);

var $eUqFw = parcelRequire("eUqFw");

var $jw09O = parcelRequire("jw09O");

var $bFzGY = parcelRequire("bFzGY");

var $bTNMs = parcelRequire("bTNMs");
const $22736ecc26df3888$var$toUrl = (url, base)=>{
    try {
        return new URL(url, base);
    } catch  {
        return undefined;
    }
};
const $22736ecc26df3888$export$32b76c003683c2ec = ()=>{
    const [unsafeLinkText, setUnsafeLinkText] = (0, $eUqFw.useState)(null);
    const [url, setUrl] = (0, $eUqFw.useState)(null);
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const sendWarningModalViewedEvent = ()=>{
        createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'linkSafetyWarningModal',
            eventType: 'screen',
            name: 'linkSafetyWarningModal'
        }).fire((0, $bTNMs.ANALYTICS_CHANNEL));
    };
    const sendContinueClickedEvent = ()=>{
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'linkSafetyWarningModalContinue',
            eventType: 'ui',
            screen: 'linkSafetyWarningModal'
        }).fire((0, $bTNMs.ANALYTICS_CHANNEL));
    };
    /**
	 * It checks and warns if a link text is a URL and different from an actual link destination
	 */ const isLinkSafe = (event, href)=>{
        if (!href) return true;
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        const normalisedUrlFromLinkText = (0, $jw09O.normalizeUrl)(linkText);
        if (!normalisedUrlFromLinkText) return true;
        const anchorLinkRegex = new RegExp(/^#/im);
        const isLinkTextAnchorLink = anchorLinkRegex.test(linkText);
        const isAnchorLink = anchorLinkRegex.test(href);
        if (isAnchorLink || isLinkTextAnchorLink) return true;
        const relativeLinkRegex = new RegExp(/^\//im);
        const isRelativeHrefLink = relativeLinkRegex.test(href);
        if (isRelativeHrefLink) return true;
        const hrefUrl = $22736ecc26df3888$var$toUrl(href, window.location.origin);
        const linkTextUrl = $22736ecc26df3888$var$toUrl(normalisedUrlFromLinkText, hrefUrl?.origin);
        if (!hrefUrl || !linkTextUrl) return true;
        const httpProtocols = [
            'http:',
            'https:'
        ];
        let areProtocolsEquivalent;
        if (httpProtocols.includes(linkTextUrl.protocol) && httpProtocols.includes(hrefUrl.protocol)) {
            const noUserNameAndPassword = !linkTextUrl.username && !linkTextUrl.password && !hrefUrl.username && !hrefUrl.password;
            areProtocolsEquivalent = noUserNameAndPassword;
        } else areProtocolsEquivalent = linkTextUrl.protocol === hrefUrl.protocol;
        const areEquivalentLinks = linkTextUrl.hostname === hrefUrl.hostname && linkTextUrl.pathname === hrefUrl.pathname && linkTextUrl.search === hrefUrl.search && linkTextUrl.username === hrefUrl.username && linkTextUrl.password === hrefUrl.password && areProtocolsEquivalent;
        if (!areEquivalentLinks) return false;
        return true;
    };
    const showSafetyWarningModal = (event, href)=>{
        event.preventDefault();
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        setUnsafeLinkText(linkText);
        href && setUrl(href);
        setIsOpen(true);
        sendWarningModalViewedEvent();
    };
    const onClose = ()=>{
        setIsOpen(false);
        setUnsafeLinkText(null);
        setUrl(null);
    };
    const onContinue = ()=>{
        onClose();
        sendContinueClickedEvent();
        url && window.open(url, '_blank', 'noopener noreferrer');
    };
    return {
        isLinkSafe: isLinkSafe,
        isOpen: isOpen,
        onClose: onClose,
        onContinue: onContinue,
        showSafetyWarningModal: showSafetyWarningModal,
        unsafeLinkText: unsafeLinkText,
        url: url
    };
};

});
parcelRegister("jw09O", function(module, exports) {

$parcel$export(module.exports, "isSafeUrl", () => $d3ea18b193bf4e7e$export$c9f92f5469372e0f);
$parcel$export(module.exports, "normalizeUrl", () => $d3ea18b193bf4e7e$export$6535eb414fa2c8b6);
/**
 * This file has been partially duplicated in packages/editor/adf-schema/src/utils/url.ts
 * Any changes made here should be mirrored there until the duplicate behaviour is resolved
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $dVFtG = parcelRequire("dVFtG");
const $d3ea18b193bf4e7e$var$linkify = (0, (/*@__PURE__*/$parcel$interopDefault($dVFtG)))();
$d3ea18b193bf4e7e$var$linkify.add('sourcetree:', 'http:');
$d3ea18b193bf4e7e$var$linkify.add('jamfselfservice:', 'http:');
$d3ea18b193bf4e7e$var$linkify.add('notes:', 'http:');
const $d3ea18b193bf4e7e$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $d3ea18b193bf4e7e$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$d3ea18b193bf4e7e$var$tlds.push($d3ea18b193bf4e7e$var$tlds2Char);
$d3ea18b193bf4e7e$var$linkify.tlds($d3ea18b193bf4e7e$var$tlds, false);
const $d3ea18b193bf4e7e$var$whitelistedURLPatterns = [
    /^https?:\/\/[^\s]*$/im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\/[^\s]*$/im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:[^\s]*$/im,
    /^facetime:[^\s]*$/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    /^sourcetree:/im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^foo:/im,
    /^#/im
];
const $d3ea18b193bf4e7e$var$normaliseLinkHref = (url)=>{
    const match = $d3ea18b193bf4e7e$var$getLinkMatch(url);
    return match && match.url || null;
};
const $d3ea18b193bf4e7e$var$getLinkMatch = (str)=>{
    if (!str) return null;
    let match = $d3ea18b193bf4e7e$var$linkifyMatch(str);
    if (!match.length) match = $d3ea18b193bf4e7e$var$linkify.match(str);
    return match && match.length > 0 && match[0].index === 0 && match[0].lastIndex === str.trim().length ? match[0] : null;
};
const $d3ea18b193bf4e7e$var$LINK_REGEXP = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $d3ea18b193bf4e7e$var$linkifyMatch = (text)=>{
    const matches = [];
    if (!$d3ea18b193bf4e7e$var$LINK_REGEXP.test(text)) return matches;
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($d3ea18b193bf4e7e$var$LINK_REGEXP) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($d3ea18b193bf4e7e$var$LINK_REGEXP);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
const $d3ea18b193bf4e7e$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url.trim();
    return $d3ea18b193bf4e7e$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
function $d3ea18b193bf4e7e$export$6535eb414fa2c8b6(url) {
    if (!url) return '';
    const urlWithoutNewlines = url.replace(/[\r\n]+/g, '');
    if ($d3ea18b193bf4e7e$export$c9f92f5469372e0f(urlWithoutNewlines)) return urlWithoutNewlines.trim();
    return $d3ea18b193bf4e7e$var$normaliseLinkHref(urlWithoutNewlines);
}

});
parcelRegister("dVFtG", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $a240c5dab5a16a6a$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $a240c5dab5a16a6a$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $a240c5dab5a16a6a$var$isString(obj) {
    return $a240c5dab5a16a6a$var$_class(obj) === '[object String]';
}
function $a240c5dab5a16a6a$var$isObject(obj) {
    return $a240c5dab5a16a6a$var$_class(obj) === '[object Object]';
}
function $a240c5dab5a16a6a$var$isRegExp(obj) {
    return $a240c5dab5a16a6a$var$_class(obj) === '[object RegExp]';
}
function $a240c5dab5a16a6a$var$isFunction(obj) {
    return $a240c5dab5a16a6a$var$_class(obj) === '[object Function]';
}
function $a240c5dab5a16a6a$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $a240c5dab5a16a6a$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $a240c5dab5a16a6a$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $a240c5dab5a16a6a$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $a240c5dab5a16a6a$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $a240c5dab5a16a6a$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $a240c5dab5a16a6a$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $a240c5dab5a16a6a$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $a240c5dab5a16a6a$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $a240c5dab5a16a6a$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $a240c5dab5a16a6a$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("ajKi5"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($a240c5dab5a16a6a$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($a240c5dab5a16a6a$var$isObject(val)) {
            if ($a240c5dab5a16a6a$var$isRegExp(val.validate)) compiled.validate = $a240c5dab5a16a6a$var$createValidator(val.validate);
            else if ($a240c5dab5a16a6a$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($a240c5dab5a16a6a$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $a240c5dab5a16a6a$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($a240c5dab5a16a6a$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $a240c5dab5a16a6a$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($a240c5dab5a16a6a$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $a240c5dab5a16a6a$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $a240c5dab5a16a6a$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $a240c5dab5a16a6a$var$createMatch(self, shift) {
    var match = new $a240c5dab5a16a6a$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $a240c5dab5a16a6a$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $a240c5dab5a16a6a$var$LinkifyIt)) return new $a240c5dab5a16a6a$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($a240c5dab5a16a6a$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $a240c5dab5a16a6a$var$assign({}, $a240c5dab5a16a6a$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $a240c5dab5a16a6a$var$assign({}, $a240c5dab5a16a6a$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $a240c5dab5a16a6a$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $a240c5dab5a16a6a$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $a240c5dab5a16a6a$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $a240c5dab5a16a6a$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $a240c5dab5a16a6a$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $a240c5dab5a16a6a$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $a240c5dab5a16a6a$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $a240c5dab5a16a6a$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $a240c5dab5a16a6a$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $a240c5dab5a16a6a$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($a240c5dab5a16a6a$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($a240c5dab5a16a6a$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $a240c5dab5a16a6a$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $a240c5dab5a16a6a$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $a240c5dab5a16a6a$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $a240c5dab5a16a6a$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $a240c5dab5a16a6a$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $a240c5dab5a16a6a$var$LinkifyIt;

});
parcelRegister("ajKi5", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("4NOMA")).source;
    re.src_Cc = (parcelRequire("jvFHg")).source;
    re.src_Z = (parcelRequire("8UCq2")).source;
    re.src_P = (parcelRequire("aUAJj")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,}[a-zA-Z0-9%/&]|' + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + ',(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    ';(?!' + re.src_ZCc + ').|' + // allow `;` if not followed by space-like char
    '\\!+(?!' + re.src_ZCc + '|[!]).|' + // allow `!!!` in paths, but not at the end
    '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});




parcelRegister("4PrNA", function(module, exports) {

$parcel$export(module.exports, "default", () => $63c30e2831e3a614$export$2e2bcd8739ae039);
/** @jsx jsx */ parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");
var $dxopF = parcelRequire("dxopF");

var $8uD7Y = parcelRequire("8uD7Y");
var $2qhQi = parcelRequire("2qhQi");
var $3dpxL = parcelRequire("3dpxL");

var $9Q9JX = parcelRequire("9Q9JX");

var $byn9U = parcelRequire("byn9U");

var $4abrz = parcelRequire("4abrz");
const $63c30e2831e3a614$var$WarningModal = (props)=>{
    const { isOpen: isOpen, unsafeLinkText: unsafeLinkText, url: url, onClose: onClose, onContinue: onContinue, intl: intl } = props;
    const content = /*#__PURE__*/ (0, $byn9U.jsx)((0, $dxopF.default), null, isOpen && /*#__PURE__*/ (0, $byn9U.jsx)((0, $aOw1G.default), {
        onClose: onClose,
        testId: "link-with-safety-warning"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $kigFe.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $boSVF.default), {
        appearance: "warning"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $4abrz.messages).check_this_link))), /*#__PURE__*/ (0, $byn9U.jsx)((0, $lfiOu.default), null, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: (0, $9Q9JX.breakWordsCss)
    }, url && unsafeLinkText && /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), {
        ...(0, $4abrz.messages).link_safety_warning_message,
        values: {
            unsafeLinkText: unsafeLinkText,
            a: ()=>/*#__PURE__*/ (0, $byn9U.jsx)("a", {
                    href: url,
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, url)
        }
    }))), /*#__PURE__*/ (0, $byn9U.jsx)((0, $2OJfS.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $7u4fN.default), {
        appearance: "subtle",
        onClick: onClose
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $4abrz.messages).go_back)), /*#__PURE__*/ (0, $byn9U.jsx)((0, $7u4fN.default), {
        appearance: "warning",
        onClick: onContinue,
        autoFocus: true
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $4abrz.messages).continue)))));
    return intl ? content : /*#__PURE__*/ (0, $byn9U.jsx)((0, $3dpxL.default), {
        locale: "en"
    }, content);
};
var $63c30e2831e3a614$export$2e2bcd8739ae039 = (0, $2qhQi.default)($63c30e2831e3a614$var$WarningModal, {
    enforceContext: false
});

});
parcelRegister("9Q9JX", function(module, exports) {

$parcel$export(module.exports, "breakWordsCss", () => $0cae29636d763a60$export$e4dda5b86d39ace5);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $0cae29636d763a60$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0cae29636d763a60$export$e4dda5b86d39ace5 = {
    name: "1ujvzzx",
    styles: "white-space:pre-line;word-break:break-all"
};

});

parcelRegister("4abrz", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ebfdcddf6874aaf0$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $ebfdcddf6874aaf0$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    actions: {
        id: 'fabric.linking.actions',
        defaultMessage: 'Actions',
        description: ''
    },
    add_account: {
        id: 'fabric.linking.add_account',
        defaultMessage: 'Add account',
        description: 'Allows to add a new account'
    },
    ai_summarize: {
        id: 'fabric.linking.ai_summarize',
        defaultMessage: 'Summarize',
        description: 'Action to summarize link resource content with AI'
    },
    ai_summarized: {
        id: 'fabric.linking.ai_summarized',
        defaultMessage: 'Summarized by Atlassian Intelligence',
        description: 'Shown with the content summarised by AI.'
    },
    ai_summarized_abbreviation: {
        id: 'fabric.linking.ai_summarized_abbreviation',
        defaultMessage: 'Summarized by AI',
        description: 'Shown with the content summarised by AI. AI is in abbreviation form to reduce space.'
    },
    ai_summarized_info: {
        id: 'fabric.linking.ai_summarized_info',
        defaultMessage: 'Information quality may vary. <a>Learn more</a>',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarized_info_short: {
        id: 'fabric.linking.ai_summarized_info_short',
        defaultMessage: 'Content quality may vary',
        description: 'Additional info about the content summarised by AI.'
    },
    ai_summarizing: {
        id: 'fabric.linking.ai_summarizing',
        defaultMessage: 'Atlassian Intelligence is working...',
        description: 'Shown when AI summary is summarising the link resource content.'
    },
    ai_summary_error_generic: {
        id: 'fabric.linking.ai_summary_error_generic',
        defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <a>check the status of AI</a>.",
        description: 'Shown when AI Summary encountered an unexpected error while summarizing the linked resource content.'
    },
    ai_summary_error_acceptable_use_violation: {
        id: 'fabric.linking.ai_summary_error_acceptable_use_violation',
        defaultMessage: "We cannot show the results of this summary as it goes against <a>Atlassian's Acceptable Use Policy</a>.",
        description: 'Shown when AI summary is summarising the link resource content and the content violates atlassians acceptable use policy.'
    },
    ai_summary_error_hipaa_content_detected: {
        id: 'fabric.linking.ai_summary_error_hipaa_content_detected',
        defaultMessage: 'Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content.',
        description: 'Shown when the AI summary is summarising the link resource content and the content contains HIPAA restricted content.'
    },
    ai_summary_error_exceeding_context_length_error: {
        id: 'fabric.linking.ai_summary_error_exceeding_context_length_error',
        defaultMessage: "Atlassian Intelligence can't generate a summary for you right now as there is too much content to summarize.",
        description: 'Shown when the AI summary is summarising the link resource content and the content is too large to summarize.'
    },
    assigned_to: {
        id: 'fabric.linking.assigned_to',
        defaultMessage: 'Assigned to {context}',
        description: 'Indicates the person or entity that the resource is assigned to.'
    },
    automation_action_title: {
        id: 'fabric.linking.automation-action.title',
        defaultMessage: 'View automation rules...',
        description: 'The title of the button in a hover card to open an automation menu for a given SmartLink.'
    },
    automation_action_icon_label: {
        id: 'fabric.linking.automation-action.icon.label',
        defaultMessage: 'Automation icon',
        description: 'The label for the automation icon inside of the button opening the automation menu.'
    },
    automation_action_tooltip: {
        id: 'fabric.linking.automation-action.tooltip',
        defaultMessage: 'Select an automation rule to run',
        description: 'The tooltip for the automation action indicating that a button will open an automation modal.'
    },
    automation_action_confluence_page_modal_title: {
        id: 'fabric.linking.automation-action.confluence.page.modal.title',
        defaultMessage: 'Page automations',
        description: 'The title of the automation modal when the SmartLink is a Confluence page'
    },
    automation_action_confluence_page_modal_description: {
        id: 'fabric.linking.automation-action.confluence.page.modal.description',
        defaultMessage: 'Apply an automation to <b>{name}</b>.{br}The available selections are controlled by Confluence and space administrators.',
        description: 'The description in the automation modal when the SmartLink is a Confluence page. Indicating which page the automation will apply to, and who controls the available automations.'
    },
    cancel: {
        id: 'fabric.linking.cancel',
        defaultMessage: 'Cancel',
        description: 'cancel'
    },
    beta: {
        id: 'fabric.linking.beta',
        defaultMessage: 'Beta',
        description: 'Indicates a beta phase of the feature.'
    },
    cannot_connect: {
        id: 'fabric.linking.cannot_connect',
        defaultMessage: "Can't connect, try again",
        description: 'Error for when a provided link is not found.'
    },
    cannot_find_link: {
        id: 'fabric.linking.cannot_find_link',
        defaultMessage: "Can't find link",
        description: 'Error for when a provided link is not found.'
    },
    click_to_join: {
        id: 'fabric.linking.click_to_join',
        defaultMessage: 'Join {context}',
        description: 'Allows the user join the product or service immediately'
    },
    click_to_join_description: {
        id: 'fabric.linking.click_to_join_description',
        defaultMessage: "You've been approved, so you can join {context} right away.",
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    close: {
        id: 'fabric.linking.close',
        defaultMessage: 'Close',
        description: ''
    },
    check_this_link: {
        id: 'fabric.linking.check_this_link',
        defaultMessage: 'Check this link',
        description: 'Link safety warning modal header'
    },
    connect_to: {
        id: 'fabric.linking.connect_to',
        defaultMessage: 'Connect to {name}',
        description: 'Allows the user to connect with different types of external services'
    },
    connect_account_description: {
        id: 'fabric.linking.connect_account_description',
        defaultMessage: "We'll open a new page to help you connect your {name} account",
        description: 'Explains what will happen when the users connects to a new account'
    },
    connect_link_account: {
        id: 'fabric.linking.connect_link_account',
        defaultMessage: 'Connect to preview',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link.'
    },
    connect_link_account_card: {
        id: 'fabric.linking.connect_link_account_card_view',
        defaultMessage: 'Connect',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_link_account_card_name: {
        id: 'fabric.linking.connect_link_account_card_view_name',
        defaultMessage: 'Connect your {context} account',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in title.'
    },
    connect_link_account_card_description: {
        id: 'fabric.linking.connect_link_account_card_view_description',
        defaultMessage: 'To show a preview of this link, connect your {context} account.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view. Displayed in byline.'
    },
    connect_unauthorised_account_action: {
        id: 'fabric.linking.connect_unauthorised_account_action',
        defaultMessage: 'Connect to {context}',
        description: 'Shown on a button to connect user external account to their Atlassian account.'
    },
    connect_unauthorised_account_description: {
        id: 'fabric.linking.connect_unauthorised_account_description',
        defaultMessage: 'Connect your {context} account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view.'
    },
    connect_unauthorised_account_description_no_provider: {
        id: 'fabric.linking.connect_unauthorised_account_description_no_provider',
        defaultMessage: 'Connect your account to collaborate on work across Atlassian products.',
        description: 'Shown when a user does not have access to a link, but can connect their external account to view the link on card view and we do not have the providers name.'
    },
    continue: {
        id: 'fabric.linking.continue',
        defaultMessage: 'Continue',
        description: 'continue'
    },
    copy_url_to_clipboard: {
        id: 'fabric.linking.copy_url_to_clipboard',
        defaultMessage: 'Copy link',
        description: ''
    },
    copied_url_to_clipboard: {
        id: 'fabric.linking.copied_url_to_clipboard',
        defaultMessage: 'Copied!',
        description: 'Url has been copied to the clipboard'
    },
    could_not_load_link: {
        id: 'fabric.linking.couldnt_load_link',
        defaultMessage: "We couldn't load this link for an unknown reason.",
        description: 'Error case for card view - link could not be loaded.'
    },
    created_by: {
        id: 'fabric.linking.created_by',
        defaultMessage: 'Created by {context}',
        description: 'Indicates the person or entity that created the resource.'
    },
    created_on_relative: {
        id: 'fabric.linking.create_on_relative',
        defaultMessage: 'Created {context}',
        description: 'Indicated when entity was created (relative form)'
    },
    created_on_absolute: {
        id: 'fabric.linking.create_on_absolute',
        defaultMessage: 'Created on {context}',
        description: 'Indicated when entity was created (absolute form)'
    },
    delete: {
        id: 'fabric.linking.delete',
        defaultMessage: 'Delete',
        description: 'Allow a user to delete a link'
    },
    download: {
        id: 'fabric.linking.download',
        defaultMessage: 'Download',
        description: ''
    },
    download_description: {
        id: 'fabric.linking.download_description',
        defaultMessage: 'Download this file into your local storage',
        description: 'Description on what Download does'
    },
    download_file: {
        id: 'fabric.linking.download_file',
        defaultMessage: 'Download file',
        description: 'Allow a user to download a file'
    },
    ai_summary_action: {
        id: 'fabric.linking.ai_summary_action',
        defaultMessage: 'Summarize with AI',
        description: 'Allow a user to summarize a link'
    },
    ai_summary_action_description: {
        id: 'fabric.linking.ai_summary_action_description',
        defaultMessage: 'Summarize the content of this link using Atlassian Intelligence.',
        description: 'Description of what the summarize link with AI action does'
    },
    copy_summary_action: {
        id: 'fabric.linking.copy_summary_action',
        defaultMessage: 'Copy summary',
        description: 'Allow a user to copy a generated summary'
    },
    copy_summary_action_description: {
        id: 'fabric.linking.copy_summary_action_description',
        defaultMessage: 'Copy summary',
        description: 'Description of what the copy summary AI action does'
    },
    copied_summary_action_description: {
        id: 'fabric.linking.copied_summary_action_description',
        defaultMessage: 'Copied summary to clipboard',
        description: 'Confirmation to the user that the summry has been copied'
    },
    edit: {
        id: 'fabric.linking.edit',
        defaultMessage: 'Edit',
        description: 'Allow a user to edit a link'
    },
    follow: {
        id: 'fabric.linking.follow',
        defaultMessage: 'Follow',
        description: 'Click to follow a project.'
    },
    follow_project_description: {
        id: 'fabric.linking.follow_project_description',
        defaultMessage: 'Follow to get notifications on this project',
        description: 'Description on what Follow does'
    },
    follow_project: {
        id: 'fabric.linking.follow_project',
        defaultMessage: 'Follow project',
        description: 'Click to follow a project.'
    },
    follow_project_error: {
        id: 'fabric.linking.follow_project_error',
        defaultMessage: 'We encountered an error while trying to follow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas project'
    },
    follow_goal_description: {
        id: 'fabric.linking.follow_goal_description',
        defaultMessage: 'Follow this goal to get notifications on updates',
        description: 'Description on what Follow does'
    },
    follow_goal: {
        id: 'fabric.linking.follow_goal',
        defaultMessage: 'Follow goal',
        description: 'Click to follow a project.'
    },
    follow_goal_error: {
        id: 'fabric.linking.follow_goal_error',
        defaultMessage: 'We encountered an error while trying to follow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when following an Atlas goal'
    },
    go_back: {
        id: 'fabric.linking.go_back',
        defaultMessage: 'Go back',
        description: 'go back'
    },
    invalid_permissions: {
        id: 'fabric.linking.invalid_permissions',
        defaultMessage: 'Restricted content',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    invalid_permissions_description: {
        id: 'fabric.linking.invalid_permissions_description',
        defaultMessage: "You'll need to request access or try a different account to view this preview.",
        description: 'Message shown when a user does not have permissions to view an item. Displayed as description.'
    },
    join_to_view: {
        id: 'fabric.linking.join_to_view',
        defaultMessage: 'Join {context} to view this issue',
        description: 'Allows the user join the product or service immediately'
    },
    learn_more_about_smart_links: {
        id: 'fabric.linking.learn_more_about_smart_links',
        defaultMessage: 'Learn more about Smart Links.',
        description: 'An anchor link to redirect user to a page about Smart Links.'
    },
    learn_more_about_connecting_account: {
        id: 'fabric.linking.learn_more_about_connecting_account',
        defaultMessage: 'Learn more about connecting your account to Atlassian products.',
        description: 'An anchor link to redirect user to a page about authorization with 3rd party accounts.'
    },
    loading: {
        id: 'fabric.linking.loading',
        defaultMessage: 'Loading...',
        description: 'Indicates an element on a page is loading.'
    },
    modified_by: {
        id: 'fabric.linking.updated_by',
        defaultMessage: 'Modified by {context}',
        description: 'Indicates the person or entity that modified the resource.'
    },
    modified_on_relative: {
        id: 'fabric.linking.modified_on_relative',
        defaultMessage: 'Updated {context}',
        description: 'Indicated when entity was modified (relative form)'
    },
    modified_on_absolute: {
        id: 'fabric.linking.modified_on_absolute',
        defaultMessage: 'Updated on {context}',
        description: 'Indicated when entity was modified (absolute form)'
    },
    more_actions: {
        id: 'fabric.linking.more_actions',
        defaultMessage: 'More actions',
        description: 'Allows the users to see more link actions'
    },
    open_issue_in_jira: {
        id: 'fabric.linking.open_issue_in_jira',
        defaultMessage: 'Open issue in Jira',
        description: 'Click to open link in Jira'
    },
    open_link_in_a_new_tab: {
        id: 'fabric.linking.open_link_in_a_new_tab',
        defaultMessage: 'Open link in a new tab',
        description: 'Click to open link in a new tab'
    },
    owned_by: {
        id: 'fabric.linking.owned_by',
        defaultMessage: 'Owned by {context}',
        description: 'Indicates the person or entity that owns or maintains the resource.'
    },
    preview_description: {
        id: 'fabric.linking.preview_description',
        defaultMessage: 'Open a full screen preview of this link',
        description: 'Description on what Preview does'
    },
    preview_improved: {
        id: 'fabric.linking.preview_improved',
        defaultMessage: 'Open preview',
        description: 'Click to view a richer view of your content, without needing to navigate to it.'
    },
    preview_close: {
        id: 'fabric.linking.preview_close',
        defaultMessage: 'Close preview',
        description: 'Click to close embed preview modal.'
    },
    preview_max_size: {
        id: 'fabric.linking.preview_max_size',
        defaultMessage: 'View full screen',
        description: 'Click to increase embed preview modal size to a maximum viewing size.'
    },
    preview_min_size: {
        id: 'fabric.linking.preview_min_size',
        defaultMessage: 'Close full screen',
        description: 'Click to decrease embed preview modal size to a minimum viewing size.'
    },
    priority_blocker: {
        id: 'fabric.linking.priority_blocker',
        defaultMessage: 'Blocker',
        description: 'Indicated priority as blocker'
    },
    priority_critical: {
        id: 'fabric.linking.priority_critical',
        defaultMessage: 'Critical',
        description: 'Indicated priority as critical'
    },
    priority_high: {
        id: 'fabric.linking.priority_high',
        defaultMessage: 'High',
        description: 'Indicated priority as high'
    },
    priority_highest: {
        id: 'fabric.linking.priority_highest',
        defaultMessage: 'Highest',
        description: 'Indicated priority as highest'
    },
    priority_low: {
        id: 'fabric.linking.priority_low',
        defaultMessage: 'Low',
        description: 'Indicated priority as low'
    },
    priority_lowest: {
        id: 'fabric.linking.priority_lowest',
        defaultMessage: 'Lowest',
        description: 'Indicated priority as lowest'
    },
    priority_major: {
        id: 'fabric.linking.priority_major',
        defaultMessage: 'Major',
        description: 'Indicated priority as major'
    },
    priority_medium: {
        id: 'fabric.linking.priority_medium',
        defaultMessage: 'Medium',
        description: 'Indicated priority as medium'
    },
    priority_minor: {
        id: 'fabric.linking.priority_minor',
        defaultMessage: 'Minor',
        description: 'Indicated priority as minor'
    },
    priority_trivial: {
        id: 'fabric.linking.priority_trivial',
        defaultMessage: 'Trivial',
        description: 'Indicated priority as trivial'
    },
    priority_undefined: {
        id: 'fabric.linking.priority_undefined',
        defaultMessage: 'Undefined',
        description: 'Indicated priority as unknown'
    },
    forbidden_access: {
        id: 'fabric.linking.forbidden_access',
        defaultMessage: 'Your access is forbidden',
        description: 'Shown when a user does not have access to a resource behind the link.'
    },
    pending_request: {
        id: 'fabric.linking.pending_request',
        defaultMessage: 'Your access request is pending',
        description: 'Shown when a user has requested an access but status is pending.'
    },
    read_time: {
        id: 'fabric.linking.read_time',
        defaultMessage: '{context} min read',
        description: 'Estimated time to read this resource'
    },
    restricted_link: {
        id: 'fabric.linking.restricted_link',
        defaultMessage: 'Restricted link, try another account',
        description: 'Message shown when a user does not have permissions to view an item'
    },
    request_access_to_view: {
        id: 'fabric.linking.request_access_to_view',
        defaultMessage: 'Request access to {context} to view this issue',
        description: 'Allows the user to request access to a product or service'
    },
    request_denied: {
        id: 'fabric.linking.request_denied',
        defaultMessage: 'Your access request was denied',
        description: 'The user had request access but the request was denied by a product or service'
    },
    retry: {
        id: 'fabric.linking.retry',
        defaultMessage: 'Retry',
        description: 'Allows user to perform an action again'
    },
    save: {
        id: 'fabric.linking.save',
        defaultMessage: 'Save',
        description: 'Just the "save" word'
    },
    sent_on_relative: {
        id: 'fabric.linking.sent_on_relative',
        defaultMessage: 'Sent {context}',
        description: 'Indicated when entity was sent (relative form)'
    },
    sent_on_absolute: {
        id: 'fabric.linking.sent_on_absolute',
        defaultMessage: 'Sent on {context}',
        description: 'Indicated when entity was sent (absolute form)'
    },
    status_change_load_error: {
        id: 'fabric.linking.status_change_load_error',
        defaultMessage: "We couldn\u2019t load the statuses and transitions",
        description: 'Informs the user that the loading of status transitions failed'
    },
    status_change_permission_error: {
        id: 'fabric.linking.status_change_permission_error',
        defaultMessage: "You don\u2019t have permission to transition this issue. ",
        description: 'Informs the user that they do not have enough permissions to update a status'
    },
    status_change_update_error: {
        id: 'fabric.linking.status_change_update_error',
        defaultMessage: "We couldn\u2019t update the status",
        description: "Occurs when a user tries to update an issue's status but fails to do so"
    },
    try_again: {
        id: 'fabric.linking.try_again',
        defaultMessage: 'Try again',
        description: 'Allow the user to try an action again'
    },
    try_another_account: {
        id: 'fabric.linking.try_another_account',
        defaultMessage: 'Try another account',
        description: 'Allows the user to try an action again with a different account'
    },
    link_safety_warning_message: {
        id: 'fabric.linking.link_safety_warning_message',
        defaultMessage: 'The link {unsafeLinkText} is taking you to a different site, <a>actual link here</a>',
        description: 'Link safety check warning message'
    },
    unauthorised_account_description: {
        id: 'fabric.linking.unauthorised_account_description',
        defaultMessage: "You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_description_no_provider: {
        id: 'fabric.linking.unauthorised_account_description_no_provider',
        defaultMessage: "You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.",
        description: 'Explains that user does not have access to a link.'
    },
    unauthorised_account_name: {
        id: 'fabric.linking.unauthorised_account_name',
        defaultMessage: "We can't display private pages from {context}",
        description: 'Shown when a user does not have access to a link.'
    },
    unauthorised_account_name_no_provider: {
        id: 'fabric.linking.unauthorised_account_name_no_provider',
        defaultMessage: "We can't display private pages",
        description: 'Shown when a user does not have access to a link.'
    },
    unassigned: {
        id: 'fabric.linking.unassigned',
        defaultMessage: 'Unassigned',
        description: 'Shown as a tooltip text for a default unassigned fallback avatar'
    },
    unfollow: {
        id: 'fabric.linking.unfollow',
        defaultMessage: 'Unfollow',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_description: {
        id: 'fabric.linking.unfollow_project_description',
        defaultMessage: 'Unfollow to stop receiving project notifications',
        description: 'Description on what Unfollow does'
    },
    unfollow_project: {
        id: 'fabric.linking.unfollow_project',
        defaultMessage: 'Unfollow project',
        description: 'Click to unfollow a project.'
    },
    unfollow_project_error: {
        id: 'fabric.linking.unfollow_project_error',
        defaultMessage: 'We encountered an error while trying to unfollow the project. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas project'
    },
    unfollow_goal_description: {
        id: 'fabric.linking.unfollow_goal_description',
        defaultMessage: 'Unfollow to stop receiving notifications for this goal',
        description: 'Description on what Unfollow does'
    },
    unfollow_goal: {
        id: 'fabric.linking.unfollow_goal',
        defaultMessage: 'Unfollow goal',
        description: 'Click to unfollow a project.'
    },
    unfollow_goal_error: {
        id: 'fabric.linking.unfollow_goal_error',
        defaultMessage: 'We encountered an error while trying to unfollow the goal. Check your connection or refresh the page and try again.',
        description: 'Shown when an unknown error occurs when unfollowing an Atlas goal'
    },
    unlink_account: {
        id: 'fabric.linking.unlink_account',
        defaultMessage: 'Unlink Account',
        description: 'Allows to remove a connected account from the user'
    },
    view: {
        id: 'fabric.linking.view',
        defaultMessage: 'View',
        description: 'Go through to a piece of content to view it in its original context.'
    },
    viewIn: {
        id: 'fabric.linking.srclink',
        defaultMessage: 'View in',
        description: 'We have a link in our preview modals to the original document. This text goes before the provider name'
    },
    viewOriginal: {
        id: 'fabric.linking.srclinkunknown',
        defaultMessage: 'View Original',
        description: "We have a link in our preview modals to the original document. This is for when we don't know the provider name"
    },
    default_no_access_title: {
        id: 'fabric.linking.no_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they dont have access to certain content'
    },
    direct_access_title: {
        id: 'fabric.linking.direct_access_title',
        defaultMessage: 'Join {product} to view this content',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access_description: {
        id: 'fabric.linking.direct_access_description',
        defaultMessage: 'Your team uses {product} to collaborate and you can start using it right away!',
        description: 'Informs the user that they have access to this product, and can sign up or join right away.'
    },
    direct_access: {
        id: 'fabric.linking.direct_access',
        defaultMessage: 'Join now',
        description: 'Allows the user join the product or service immediately'
    },
    request_access_description: {
        id: 'fabric.linking.request_access_description',
        defaultMessage: 'Your team uses {product} to collaborate. Send your admin a request for access.',
        description: 'Informs the user to request access to a product by talking to the website administrator'
    },
    request_access: {
        id: 'fabric.linking.request_access',
        defaultMessage: 'Request access',
        description: 'Allows the user to request access to a product or service'
    },
    request_access_pending_title: {
        id: 'fabric.linking.request_access_pending_title',
        defaultMessage: 'Access to {product} is pending',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_access_pending_description: {
        id: 'fabric.linking.request_access_pending_description',
        defaultMessage: 'Your request to access {hostname} is awaiting admin approval.',
        description: 'Informs the user that their request to view this content is pending website administrator approval'
    },
    request_access_pending: {
        id: 'fabric.linking.request_access_pending',
        defaultMessage: 'Pending approval',
        description: 'Informs the user that their request to view this content is pending'
    },
    request_denied_description: {
        id: 'fabric.linking.request_denied_description',
        defaultMessage: "Your admin didn't approve your request to view {product} pages from {hostname}.",
        description: 'Informs the user that their request to view this content was denied'
    },
    access_exists_description: {
        id: 'fabric.linking.access_exists_description',
        defaultMessage: 'Request access to view this content from {hostname}.',
        description: 'Informs the user to contact the website administrator to request access to a product'
    },
    not_found_description: {
        id: 'fabric.linking.not_found_description',
        defaultMessage: "The page doesn't exist or it may have changed after this link was added.",
        description: 'Error case for when a provided item is not found within the list of items'
    },
    not_found_title: {
        id: 'fabric.linking.not_found_title',
        defaultMessage: "We can't show you this {product} page",
        description: 'Error case for when a provided link is not found'
    },
    forbidden_title: {
        id: 'fabric.linking.forbidden_title',
        defaultMessage: "You don't have access to this content",
        description: 'Informs the user that they do not have access to the linked content.'
    },
    forbidden_description: {
        id: 'fabric.linking.forbidden_description',
        defaultMessage: 'Contact your admin to request access to {hostname}.',
        description: 'Informs the user that they must contact the site administrator for access.'
    },
    related_work_items_not_found: {
        id: 'fabric.linking.related_work_items_not_found',
        defaultMessage: 'This link is not mentioned anywhere else.',
        description: 'Informs the user that there are no related resources for a given url'
    },
    last_mentioned_in: {
        id: 'fabric.linking.last_mentioned_in',
        defaultMessage: 'Last mentioned in',
        description: 'Informs the user about where the resource was last mentioned in'
    },
    related: {
        id: 'fabric.linking.related',
        defaultMessage: 'Related',
        description: 'Informs the user about related resources'
    },
    generic_error_message: {
        id: 'fabric.linking.generic_error_message',
        defaultMessage: 'An error occurred',
        description: 'A generic error message to the user'
    },
    related_links_modal_title: {
        id: 'fabric.linking.related_links_modal_title',
        defaultMessage: 'Recent Links',
        description: 'Shown as the title for the related links modal'
    },
    related_links_view_related_urls: {
        id: 'fabric.linking.related_links_view_related_urls.nonfinal',
        defaultMessage: 'View recent links...',
        description: 'Action to view related links to the given resource'
    },
    related_links_found_in: {
        id: 'fabric.linking.related_links_found_in',
        defaultMessage: 'Found In',
        description: 'Informs the user of the resources are found in the given url'
    },
    related_links_not_found: {
        id: 'fabric.linking.related_links_not_found',
        defaultMessage: "We didn't find any links to show here.",
        description: 'Informs the user that there are no related resources for the given url'
    },
    related_links_includes_links_to: {
        id: 'fabric.linking.related_links_includes_links_to',
        defaultMessage: 'Includes Links To',
        description: 'Informs the user of the resources the url links to'
    },
    related_links_modal_error_header: {
        id: 'fabric.linking.related_links_modal_error_header',
        defaultMessage: 'Something went wrong',
        description: 'Title for related links error'
    },
    related_links_modal_error_message: {
        id: 'fabric.linking.related_links_modal_error_message',
        defaultMessage: 'We ran into an issue trying to load recent links. Check your connection or refresh to try again.',
        description: 'Informs the user that there was a problem loading related links'
    },
    related_links_modal_unavailable_header: {
        id: 'fabric.linking.related_links_modal_unavailable_header',
        defaultMessage: 'No recent links',
        description: 'Title for related links being unavailable'
    },
    related_links_modal_unavailable_message: {
        id: 'fabric.linking.related_links_modal_unavailable_message',
        defaultMessage: "We didn't find any links to show here. We continuously review and add recent links for updated pages or other content types.",
        description: 'Informs the user that related links were not found but may be available in the future'
    }
});

});




parcelRegister("7FrhV", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5732daa23d4c623$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $e5732daa23d4c623$export$2e2bcd8739ae039(props) {
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        ...props.dataAttributes,
        style: {
            textDecoration: 'line-through'
        }
    }, props.children));
}

});

parcelRegister("3czYv", function(module, exports) {

$parcel$export(module.exports, "default", () => $e223899bd1ad5435$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $e223899bd1ad5435$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", props.dataAttributes, props.children);
}

});

parcelRegister("5EI2Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $b555def9a496abb5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $b555def9a496abb5$var$isSub = (type)=>{
    return type === 'sub';
};
function $b555def9a496abb5$export$2e2bcd8739ae039(props) {
    if ($b555def9a496abb5$var$isSub(props.type)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("sub", props.dataAttributes, props.children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("sup", props.dataAttributes, props.children);
}

});

parcelRegister("2LYW6", function(module, exports) {

$parcel$export(module.exports, "default", () => $e29fd36a20822e31$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $as9OS = parcelRequire("as9OS");

var $iXTVf = parcelRequire("iXTVf");

var $4q38b = parcelRequire("4q38b");
function $e29fd36a20822e31$export$2e2bcd8739ae039(props) {
    const { colorMode: colorMode } = (0, $4q38b.default)();
    // Note -- while there is no way to create custom colors using default tooling
    // the editor does supported ad hoc color values -- and there may be content
    // which has been migrated or created via apis which use such values.
    let paletteColorValue;
    /**
   * The Editor persists custom text colors when content has been migrated from the old editor, or created via
   * apis.
   *
   * This behaviour predates the introduction of dark mode.
   *
   * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
   *
   * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
   *
   * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
   * how we detect text colors copied from external editor sources. Where we load the background color from a
   * seperate attribute (data-text-custom-color), instead of the inline style.
   *
   * See the following document for more details on this behaviour
   * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
   */ const tokenColor = (0, $iXTVf.hexToEditorTextPaletteColor)(props.color);
    if (tokenColor) paletteColorValue = (0, $iXTVf.hexToEditorTextPaletteColor)(props.color) || props.color;
    else if (colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
    paletteColorValue = (0, $as9OS.getDarkModeLCHColor)(props.color);
    else // if we are in light mode, we can just set the color
    paletteColorValue = props.color;
    const style = (0, $eUqFw.useMemo)(()=>({
            ['--custom-palette-color']: paletteColorValue
        }), [
        paletteColorValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        ...props.dataAttributes,
        "data-text-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-text-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style
    }, props.children);
}

});
parcelRegister("iXTVf", function(module, exports) {

$parcel$export(module.exports, "hexToEditorTextPaletteColor", () => $f1092a04097603f0$export$9c2f408d391feb93);
// This import will be stripped on build
/**
 * This takes an adf hex color and returns a matching text palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToTextPaletteColor('#0747A6');
 * //     ^? const cssValue: string
 * <span style={{textColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $f1092a04097603f0$export$9c2f408d391feb93(hexColor) {
    // Ts ignore used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    return $f1092a04097603f0$export$57fa5089caad992[hexColor.toUpperCase()];
}
const $f1092a04097603f0$export$57fa5089caad992 = {
    // blue
    /** blue - light */ ['#B3D4FF']: "var(--ds-background-accent-blue-subtler, #B3D4FF)",
    // source for hex code was legacy token B75
    /** blue - medium */ ['#4C9AFF']: "var(--ds-icon-accent-blue, #4C9AFF)",
    // source for hex code was legacy token B100
    /** blue - strong */ ['#0747A6']: "var(--ds-text-accent-blue, #0747A6)",
    // source for hex code was legacy token B500
    // teal
    /** teal - light */ ['#B3F5FF']: "var(--ds-background-accent-teal-subtler, #B3F5FF)",
    // source for hex code was legacy token T75
    /** teal - medium */ ['#00B8D9']: "var(--ds-icon-accent-teal, #00B8D9)",
    // source for hex code was legacy token T300
    /** teal - strong */ ['#008DA6']: "var(--ds-text-accent-teal, #008DA6)",
    // source for hex code was legacy token T500
    // green
    /** green - light */ ['#ABF5D1']: "var(--ds-background-accent-green-subtler, #ABF5D1)",
    // source for hex code was legacy token G75
    /** green - medium */ ['#36B37E']: "var(--ds-icon-accent-green, #36B37E)",
    // source for hex code was legacy token G300
    /** green - strong */ ['#006644']: "var(--ds-text-accent-green, #006644)",
    // source for hex code was legacy token G500
    // yellowOrange
    /** yellowOrange - light */ ['#FFF0B3']: "var(--ds-background-accent-yellow-subtler, #FFF0B3)",
    // source for hex code was legacy token Y75
    /** yellowOrange - medium */ ['#FFC400']: "var(--ds-background-accent-orange-subtle, #FFC400)",
    // source for hex code was legacy token Y200
    /** yellowOrange - strong */ ['#FF991F']: "var(--ds-icon-accent-orange, #FF991F)",
    // source for hex code was legacy token Y400
    // red
    /** red - light */ ['#FFBDAD']: "var(--ds-background-accent-red-subtler, #FFBDAD)",
    // source for hex code was legacy token R75
    /** red - medium */ ['#FF5630']: "var(--ds-icon-accent-red, #FF5630)",
    // source for hex code was legacy token R300
    /** red - strong */ ['#BF2600']: "var(--ds-text-accent-red, #BF2600)",
    // source for hex code was legacy token R500
    // purple
    /** purple - light */ ['#EAE6FF']: "var(--ds-background-accent-purple-subtler, #EAE6FF)",
    // source for hex code was legacy token P50
    /** purple - medium */ ['#6554C0']: "var(--ds-icon-accent-purple, #6554C0)",
    // source for hex code was legacy token P300
    /** purple - strong */ ['#403294']: "var(--ds-text-accent-purple, #403294)",
    // source for hex code was legacy token P500
    // whiteGray
    /** whiteGray - light */ ['#FFFFFF']: "var(--ds-text-inverse, #FFFFFF)",
    // source for hex code was legacy token N0
    /** whiteGray - medium */ ['#97A0AF']: "var(--ds-icon-accent-gray, #97A0AF)",
    // source for hex code was legacy token N80
    /** whiteGray - strong */ ['#172B4D']: "var(--ds-text, #172B4D)" // source for hex code was legacy token N800
};

});


parcelRegister("jIWxL", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd19009972ab5ceb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $as9OS = parcelRequire("as9OS");

var $77B5u = parcelRequire("77B5u");

var $4q38b = parcelRequire("4q38b");
function $dd19009972ab5ceb$export$2e2bcd8739ae039(props) {
    const { colorMode: colorMode } = (0, $4q38b.default)();
    let paletteColorValue;
    /**
   * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
   *
   * This behaviour predates the introduction of dark mode.
   *
   * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
   *
   * This introduces inversion of the presentation of the custom text background colors when the user is in dark mode.
   *
   * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
   * how we detect text background colors copied from external editor sources. Where we load the background color from a
   * separate attribute (data-background-custom-color), instead of the inline style.
   *
   * See the following document for more details on this behaviour
   * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
   */ const tokenColor = (0, $77B5u.hexToEditorTextBackgroundPaletteColor)(props.color);
    if (tokenColor) paletteColorValue = tokenColor;
    else if (colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
    paletteColorValue = (0, $as9OS.getDarkModeLCHColor)(props.color);
    else // if we are in light mode, we can just set the color
    paletteColorValue = props.color;
    const style = (0, $eUqFw.useMemo)(()=>({
            ['--custom-palette-color']: paletteColorValue
        }), [
        paletteColorValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        ...props.dataAttributes,
        "data-background-custom-color": props.color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-background-color-mark",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style
    }, props.children);
}

});
parcelRegister("77B5u", function(module, exports) {

$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", () => $e06862f35dcf01b5$export$8b58ff1b36bb75e0);
// This import will be stripped on build
// Color tokens defined on https://hello.atlassian.net/wiki/spaces/EOU/pages/3587733210/Text+highlighting+-+designs#Colour-palette
// values are asserted to improve generated type declarations
const $e06862f35dcf01b5$export$12a518ff137dd389 = {
    /** Gray - light */ ['#DCDFE4']: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
    /** Teal - light */ ['#C6EDFB']: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    /** Lime - light */ ['#D3F1A7']: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    /** Orange - light */ ['#FEDEC8']: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
    /** Magenta - light */ ['#FDD0EC']: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    /** Purple - light */ ['#DFD8FD']: "var(--ds-background-accent-purple-subtler, #DFD8FD)"
};
function $e06862f35dcf01b5$export$8b58ff1b36bb75e0(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    // @ts-ignore
    return $e06862f35dcf01b5$export$12a518ff137dd389[hexColor.toUpperCase()];
}

});


parcelRegister("fqJal", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cc82c573f7a0c67$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $0cc82c573f7a0c67$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("u", props.dataAttributes, props.children);
}

});

parcelRegister("3QkG0", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fa30294f41b5af3$export$2e2bcd8739ae039);
/** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $4iaaT = parcelRequire("4iaaT");

var $b3jMP = parcelRequire("b3jMP");

var $25FYC = parcelRequire("25FYC");
const $3fa30294f41b5af3$export$491e6397d7c1480b = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: `${(0, $25FYC.blockNodesVerticalMargin)} 0`,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginLeft: '50%',
    transform: 'translateX(-50%)'
});
function $3fa30294f41b5af3$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $4iaaT.WidthConsumer), null, ({ width: width })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $3fa30294f41b5af3$export$491e6397d7c1480b,
            "data-mode": props.mode,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            style: {
                width: (0, $b3jMP.calcBreakoutWidth)(props.mode, width)
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "fabric-editor-breakout-mark fabric-editor-block-mark"
        }, props.children));
}

});

parcelRegister("3ofDw", function(module, exports) {

$parcel$export(module.exports, "default", () => $83b09024e681d364$export$2e2bcd8739ae039);
/** @jsx jsx */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $dkRpY = parcelRequire("dkRpY");
const $83b09024e681d364$var$MarkWrapper = (props)=>{
    const styles = props['data-align'] ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $byn9U.css)("text-align:", (0, $dkRpY.alignmentPositionMap)[props['data-align']], ";") : '';
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: styles,
        ...props
    }, props.children));
};
function $83b09024e681d364$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $byn9U.jsx)($83b09024e681d364$var$MarkWrapper, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-alignment",
        "data-align": props.align
    }, props.children);
}

});

parcelRegister("cTsEA", function(module, exports) {

$parcel$export(module.exports, "default", () => $462a17ee6dc989f3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $462a17ee6dc989f3$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-block-mark fabric-editor-indentation-mark",
        "data-level": props.level
    }, props.children);
}

});

parcelRegister("hySUC", function(module, exports) {

$parcel$export(module.exports, "default", () => $069f0328a052510c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $069f0328a052510c$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", props.dataAttributes, props.children);
}

});

parcelRegister("dt1Ro", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dd2306713f4b142$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $0dd2306713f4b142$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", props.dataAttributes, props.children);
}

});

parcelRegister("9HbLt", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6b9a8159d214ff1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $e6b9a8159d214ff1$export$2e2bcd8739ae039(props) {
    const WrapperElement = props.isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrapperElement, {
        "data-source": props.sources ? JSON.stringify(props.sources) : undefined,
        "data-mark-type": "dataConsumer",
        ...props.dataAttributes
    }, props.children);
}

});

parcelRegister("5hADG", function(module, exports) {

$parcel$export(module.exports, "default", () => $81a4738291ec68b6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $81a4738291ec68b6$export$2e2bcd8739ae039(props) {
    const WrapperElement = props.isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrapperElement, {
        "data-localId": props.localId,
        "data-name": props.name,
        "data-mark-type": "fragment",
        ...props.dataAttributes
    }, props.children);
}

});

parcelRegister("9Pmx7", function(module, exports) {

$parcel$export(module.exports, "default", () => $a79e62228a84dfa5$export$2e2bcd8739ae039);
/** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
function $a79e62228a84dfa5$export$2e2bcd8739ae039(props) {
    const borderColor = props.color ?? '';
    const borderSize = props.size ?? 0;
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        "data-color": borderColor,
        "data-size": borderSize,
        "data-mark-type": "border"
    }, props.children);
}

});

parcelRegister("jKBO7", function(module, exports) {

$parcel$export(module.exports, "default", () => $40d0890446758faa$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
class $40d0890446758faa$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        const { reference: reference, children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
            "data-mark-type": "confluenceInlineComment",
            "data-reference": reference
        }, children);
    }
}

});


parcelRegister("3glLa", function(module, exports) {

$parcel$export(module.exports, "getMarksByOrder", () => $40f2a19ba0a22464$export$99a33ed044c278ae);
$parcel$export(module.exports, "isSameMark", () => $40f2a19ba0a22464$export$b1304404bdc42b7a);
$parcel$export(module.exports, "getValidDocument", () => $40f2a19ba0a22464$export$fb80336a7e408cb3);
$parcel$export(module.exports, "getValidNode", () => $40f2a19ba0a22464$export$81b20b6c83a56bd);

var $lUXsh = parcelRequire("lUXsh");
var $2yJJ8 = parcelRequire("2yJJ8");
var $4N6cH = parcelRequire("4N6cH");
var $izui5 = parcelRequire("izui5");

var $9wcjJ = parcelRequire("9wcjJ");

var $XHGTv = parcelRequire("XHGTv");
const $40f2a19ba0a22464$export$3b94ef2190b2d585 = {
    FINAL: 'final',
    STAGE_0: 'stage0'
};
const $40f2a19ba0a22464$export$62d5811a2955c1d8 = [
    'fragment',
    'link',
    'em',
    'strong',
    'textColor',
    'backgroundColor',
    'strike',
    'subsup',
    'underline',
    'code',
    'confluenceInlineComment',
    'annotation',
    'dataConsumer'
];
const $40f2a19ba0a22464$export$30f8aa4cc1f8c1cb = (type)=>{
    return type === 'sub' || type === 'sup';
};
const $40f2a19ba0a22464$export$99a33ed044c278ae = (marks)=>{
    return [
        ...marks
    ].sort((a, b)=>$40f2a19ba0a22464$export$62d5811a2955c1d8.indexOf(a.type.name) - $40f2a19ba0a22464$export$62d5811a2955c1d8.indexOf(b.type.name));
};
const $40f2a19ba0a22464$export$b1304404bdc42b7a = (mark, otherMark)=>{
    if (!mark || !otherMark) return false;
    return mark.eq(otherMark);
};
const $40f2a19ba0a22464$export$fb80336a7e408cb3 = (doc, schema = (0, $9wcjJ.defaultSchema), adfStage = 'final')=>{
    const node = $40f2a19ba0a22464$export$81b20b6c83a56bd(doc, schema, adfStage);
    if (node.type === 'doc') {
        node.content = $40f2a19ba0a22464$var$wrapInlineNodes(node.content);
        return node;
    }
    return null;
};
const $40f2a19ba0a22464$var$wrapInlineNodes = (nodes = [])=>{
    return nodes.map((node)=>(0, $2yJJ8.inlineNodes).has(node.type) ? {
            type: 'paragraph',
            content: [
                node
            ]
        } : node);
};
const $40f2a19ba0a22464$export$fafd4f799ee68da0 = (content, schema = (0, $9wcjJ.defaultSchema), adfStage = 'final')=>{
    return content.map((node)=>$40f2a19ba0a22464$export$81b20b6c83a56bd(node, schema, adfStage));
};
const $40f2a19ba0a22464$var$TEXT_COLOR_PATTERN = /^#[0-9a-fA-F]{6}$/;
const $40f2a19ba0a22464$var$RELATIVE_LINK = /^\//;
const $40f2a19ba0a22464$var$ANCHOR_LINK = /^#/;
const $40f2a19ba0a22464$var$flattenUnknownBlockTree = (node, schema = (0, $9wcjJ.defaultSchema), adfStage = 'final')=>{
    const output = [];
    let isPrevLeafNode = false;
    for(let i = 0; i < node.content.length; i++){
        const childNode = node.content[i];
        const isLeafNode = !(childNode.content && childNode.content.length);
        if (i > 0) {
            if (isPrevLeafNode) output.push({
                type: 'text',
                text: ' '
            });
            else output.push({
                type: 'hardBreak'
            });
        }
        if (isLeafNode) output.push($40f2a19ba0a22464$export$81b20b6c83a56bd(childNode, schema, adfStage));
        else output.push(...$40f2a19ba0a22464$var$flattenUnknownBlockTree(childNode, schema, adfStage));
        isPrevLeafNode = isLeafNode;
    }
    return output;
};
const $40f2a19ba0a22464$export$b9908ef75cad1e0e = (node)=>{
    const { attrs: attrs = {}, content: content, text: text, type: type } = node;
    if (!content || !content.length) {
        const unknownInlineNode = {
            type: 'text',
            text: text || attrs.text || `[${type}]`
        };
        const { textUrl: textUrl } = attrs;
        if (textUrl && (0, $4N6cH.isSafeUrl)(textUrl)) unknownInlineNode.marks = [
            {
                type: 'link',
                attrs: {
                    href: textUrl
                }
            }
        ];
        return unknownInlineNode;
    }
    /*
	 * Find leaf nodes and join them. If leaf nodes' parent node is the same node
	 * join with a blank space, otherwise they are children of different branches, i.e.
	 * we need to join them with a hardBreak node
	 */ return {
        type: 'unknownBlock',
        content: $40f2a19ba0a22464$var$flattenUnknownBlockTree(node)
    };
};
const $40f2a19ba0a22464$var$getValidMarks = (marks, adfStage = 'final')=>{
    if (marks && marks.length > 0) return marks.reduce((acc, mark)=>{
        const validMark = $40f2a19ba0a22464$export$87c6d4a6ebb7d9e9(mark, adfStage);
        if (validMark) acc.push(validMark);
        return acc;
    }, []);
    return marks;
};
const $40f2a19ba0a22464$export$81b20b6c83a56bd = (originalNode, schema = (0, $9wcjJ.defaultSchema), adfStage = 'final')=>{
    const { attrs: attrs, marks: marks, text: text, type: type } = originalNode;
    let { content: content } = originalNode;
    const node = {
        attrs: attrs,
        marks: marks,
        text: text,
        type: type
    };
    if (content) node.content = content = $40f2a19ba0a22464$export$fafd4f799ee68da0(content, schema, adfStage);
    // If node type doesn't exist in schema, make it an unknown node
    if (!schema.nodes[type]) return $40f2a19ba0a22464$export$b9908ef75cad1e0e(node);
    if (type) switch(type){
        case 'doc':
            {
                const { version: version } = originalNode;
                if (version && content && content.length) return {
                    type: type,
                    content: content
                };
                break;
            }
        case 'codeBlock':
            if (content) content = content.reduce((acc, val)=>{
                if (val.type === 'text') acc.push({
                    type: val.type,
                    text: val.text
                });
                return acc;
            }, []);
            if (attrs && attrs.language) return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
            return {
                type: type,
                content: content,
                marks: marks
            };
        case 'date':
            if (attrs && attrs.timestamp) return {
                type: type,
                attrs: attrs,
                ...(0, $XHGTv.getBooleanFF)('platform.editor.allow-inline-comments-for-inline-nodes-round-2_ctuxz') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'status':
            if (attrs && attrs.text && attrs.color) return {
                type: type,
                attrs: attrs,
                ...(0, $XHGTv.getBooleanFF)('platform.editor.allow-inline-comments-for-inline-nodes-round-2_ctuxz') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'emoji':
            if (attrs && attrs.shortName) return {
                type: type,
                attrs: attrs,
                ...(0, $XHGTv.getBooleanFF)('platform.editor.allow-inline-comments-for-inline-nodes-round-2_ctuxz') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'inlineExtension':
        case 'extension':
            if (attrs && attrs.extensionType && attrs.extensionKey) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'inlineCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $4N6cH.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $4N6cH.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs,
                ...(0, $XHGTv.getBooleanFF)('platform.editor.allow-inline-comments-for-inline-nodes') ? {
                    marks: marks
                } : {}
            };
            break;
        case 'blockCard':
            if (attrs && (attrs.datasource && !attrs.url || attrs.url && (0, $4N6cH.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $4N6cH.isSafeUrl)(attrs.data.url))) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'embedCard':
            if (attrs && (attrs.url && (0, $4N6cH.isSafeUrl)(attrs.url) || attrs.data && attrs.data.url && (0, $4N6cH.isSafeUrl)(attrs.data.url)) && attrs.layout) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'bodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'multiBodiedExtension':
            if (attrs && attrs.extensionType && attrs.extensionKey && content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'extensionFrame':
            if (content) return {
                type: type,
                attrs: attrs,
                content: content
            };
            break;
        case 'hardBreak':
            return {
                type: type
            };
        case 'caption':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'mediaInline':
            {
                let mediaId = '';
                let mediaCollection = [];
                if (attrs) {
                    const { id: id, collection: collection } = attrs;
                    mediaId = id;
                    mediaCollection = collection;
                }
                if (mediaId && mediaCollection) return {
                    type: type,
                    attrs: attrs,
                    marks: marks
                };
                break;
            }
        case 'media':
            {
                let mediaId = '';
                let mediaType = '';
                let mediaCollection = [];
                let mediaUrl = '';
                if (attrs) {
                    const { id: id, collection: collection, type: type, url: url } = attrs;
                    mediaId = id;
                    mediaType = type;
                    mediaCollection = collection;
                    mediaUrl = url;
                }
                if (mediaType === 'external' && !!mediaUrl) {
                    const mediaAttrs = {
                        type: mediaType,
                        url: mediaUrl,
                        width: attrs.width,
                        height: attrs.height
                    };
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $40f2a19ba0a22464$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                } else if (mediaId && mediaType) {
                    const mediaAttrs = {
                        type: mediaType,
                        id: mediaId,
                        collection: mediaCollection
                    };
                    if (attrs.width) mediaAttrs.width = attrs.width;
                    if (attrs.height) mediaAttrs.height = attrs.height;
                    if (attrs.alt) mediaAttrs.alt = attrs.alt;
                    const getMarks = $40f2a19ba0a22464$var$getValidMarks(marks, adfStage);
                    return getMarks ? {
                        type: type,
                        attrs: mediaAttrs,
                        marks: getMarks
                    } : {
                        type: type,
                        attrs: mediaAttrs
                    };
                }
                break;
            }
        case 'mediaGroup':
            if (Array.isArray(content) && !content.some((e)=>e.type !== 'media')) return {
                type: type,
                content: content
            };
            break;
        case 'mediaSingle':
            {
                const containsJustMedia = Array.isArray(content) && content.length === 1 && content[0].type === 'media';
                const containsMediaAndCaption = Array.isArray(content) && content.length === 2 && content[0].type === 'media' && content[1].type === 'caption';
                if (containsJustMedia || containsMediaAndCaption) return {
                    type: type,
                    attrs: attrs,
                    content: content,
                    marks: $40f2a19ba0a22464$var$getValidMarks(marks, adfStage)
                };
                break;
            }
        case 'mention':
            {
                let mentionText = '';
                let mentionId;
                let mentionAccess;
                if (attrs) {
                    const { text: text, displayName: displayName, id: id, accessLevel: accessLevel } = attrs;
                    mentionText = text || displayName;
                    mentionId = id;
                    mentionAccess = accessLevel;
                }
                if (!mentionText) mentionText = text || '@unknown';
                if (mentionText && mentionId) {
                    const mentionNode = {
                        type: type,
                        attrs: {
                            id: mentionId,
                            text: mentionText,
                            accessLevel: ''
                        },
                        ...(0, $XHGTv.getBooleanFF)('platform.editor.allow-inline-comments-for-inline-nodes-round-2_ctuxz') ? {
                            marks: marks
                        } : {}
                    };
                    if (mentionAccess) mentionNode.attrs.accessLevel = mentionAccess;
                    return mentionNode;
                }
                break;
            }
        case 'paragraph':
            if (adfStage === 'stage0') {
                let paragraphNode = {
                    type: type,
                    content: content || []
                };
                if (attrs && attrs.localId) paragraphNode.attrs = {
                    localId: attrs.localId
                };
                if (marks) paragraphNode.marks = [
                    ...marks
                ];
                return paragraphNode;
            }
            return marks ? {
                type: type,
                content: content || [],
                marks: marks
            } : {
                type: type,
                content: content || []
            };
        case 'rule':
            return {
                type: type
            };
        case 'text':
            {
                let { marks: marks } = node;
                if (text) return marks ? {
                    type: type,
                    text: text,
                    marks: $40f2a19ba0a22464$var$getValidMarks(marks, adfStage)
                } : {
                    type: type,
                    text: text
                };
                break;
            }
        case 'heading':
            if (attrs) {
                const { level: level } = attrs;
                const between = (x, a, b)=>x >= a && x <= b;
                if (level && between(level, 1, 6)) {
                    if (adfStage === 'stage0') {
                        let headingNode = {
                            type: type,
                            content: content,
                            attrs: {
                                level: level
                            }
                        };
                        if (attrs.localId) headingNode.attrs.localId = attrs.localId;
                        if (marks) headingNode.marks = [
                            ...marks
                        ];
                        return headingNode;
                    }
                    return marks ? {
                        type: type,
                        content: content,
                        marks: marks,
                        attrs: {
                            level: level
                        }
                    } : {
                        type: type,
                        content: content,
                        attrs: {
                            level: level
                        }
                    };
                }
            }
            break;
        case 'bulletList':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'orderedList':
            if (content) return {
                type: type,
                content: content,
                attrs: {
                    order: attrs && attrs.order
                }
            };
            break;
        case 'listItem':
            if (content) return {
                type: type,
                content: $40f2a19ba0a22464$var$wrapInlineNodes(content)
            };
            break;
        case 'blockquote':
            if (content) return {
                type: type,
                content: content
            };
            break;
        case 'panel':
            if (attrs && content) {
                const { panelType: panelType } = attrs;
                if (Object.values((0, $izui5.PanelType)).includes(panelType)) return {
                    type: type,
                    attrs: attrs,
                    content: content
                };
            }
            break;
        case 'layoutSection':
            if (content) return {
                type: type,
                marks: marks,
                content: content
            };
            break;
        case 'layoutColumn':
            if (attrs && content) {
                if (attrs.width > 0 && attrs.width <= 100) return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'decisionList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $lUXsh.generateUuid)()
                }
            };
        case 'decisionItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $lUXsh.generateUuid)(),
                    state: attrs && attrs.state || 'DECIDED'
                }
            };
        case 'taskList':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $lUXsh.generateUuid)()
                }
            };
        case 'taskItem':
            return {
                type: type,
                content: content,
                attrs: {
                    localId: attrs && attrs.localId || (0, $lUXsh.generateUuid)(),
                    state: attrs && attrs.state || 'TODO'
                }
            };
        case 'table':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableRow')) {
                if (adfStage === 'stage0') return {
                    type: type,
                    content: content,
                    attrs: {
                        ...attrs,
                        localId: attrs?.localId || (0, $lUXsh.generateUuid)(),
                        width: attrs?.width || null
                    }
                };
                return {
                    type: type,
                    content: content,
                    attrs: attrs
                };
            }
            break;
        case 'tableRow':
            if (Array.isArray(content) && content.length > 0 && !content.some((e)=>e.type !== 'tableCell' && e.type !== 'tableHeader')) return {
                type: type,
                content: content
            };
            break;
        case 'tableCell':
        case 'tableHeader':
            if (content) {
                const cellAttrs = {};
                if (attrs) {
                    if (attrs.colspan && attrs.colspan > 1) cellAttrs.colspan = attrs.colspan;
                    if (attrs.rowspan && attrs.rowspan > 1) cellAttrs.rowspan = attrs.rowspan;
                    if (attrs.background) cellAttrs.background = attrs.background;
                    if (attrs.colwidth && Array.isArray(attrs.colwidth)) cellAttrs.colwidth = attrs.colwidth;
                }
                return {
                    type: type,
                    content: $40f2a19ba0a22464$var$wrapInlineNodes(content),
                    attrs: attrs ? cellAttrs : undefined
                };
            }
            break;
        case 'image':
            if (attrs && attrs.src) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'placeholder':
            if (attrs && typeof attrs.text !== 'undefined') return {
                type: type,
                attrs: attrs
            };
            break;
        case 'expand':
        case 'nestedExpand':
            return {
                type: type,
                attrs: attrs,
                content: content,
                marks: marks
            };
    }
    return $40f2a19ba0a22464$export$b9908ef75cad1e0e(node);
};
const $40f2a19ba0a22464$export$87c6d4a6ebb7d9e9 = (mark, adfStage = 'final')=>{
    const { attrs: attrs, type: type } = mark;
    if (type) switch(type){
        case 'code':
            return {
                type: type
            };
        case 'em':
            return {
                type: type
            };
        case 'link':
            if (attrs) {
                const { href: href, url: url, __confluenceMetadata: __confluenceMetadata } = attrs;
                let linkHref = href || url;
                if (linkHref && linkHref.indexOf(':') === -1 && !$40f2a19ba0a22464$var$RELATIVE_LINK.test(linkHref) && !$40f2a19ba0a22464$var$ANCHOR_LINK.test(linkHref)) linkHref = `http://${linkHref}`;
                const linkAttrs = {
                    href: linkHref
                };
                if (__confluenceMetadata) linkAttrs.__confluenceMetadata = __confluenceMetadata;
                if (linkHref && (0, $4N6cH.isSafeUrl)(linkHref)) return {
                    type: type,
                    attrs: linkAttrs
                };
            }
            break;
        case 'strike':
            return {
                type: type
            };
        case 'strong':
            return {
                type: type
            };
        case 'subsup':
            if (attrs && attrs['type']) {
                const subSupType = attrs['type'];
                if ($40f2a19ba0a22464$export$30f8aa4cc1f8c1cb(subSupType)) return {
                    type: type,
                    attrs: {
                        type: subSupType
                    }
                };
            }
            break;
        case 'textColor':
            if (attrs && $40f2a19ba0a22464$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
        case 'underline':
            return {
                type: type
            };
        case 'annotation':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
        case 'backgroundColor':
            if (attrs && $40f2a19ba0a22464$var$TEXT_COLOR_PATTERN.test(attrs.color)) return {
                type: type,
                attrs: attrs
            };
            break;
    }
    if (adfStage === 'stage0') switch(type){
        case 'confluenceInlineComment':
            return {
                type: type,
                attrs: attrs
            };
        case 'dataConsumer':
            return {
                type: type,
                attrs: attrs
            };
        case 'fragment':
            return {
                type: type,
                attrs: attrs
            };
        case 'border':
            return {
                type: type,
                attrs: attrs
            };
    }
    return null;
};

});
parcelRegister("2yJJ8", function(module, exports) {

$parcel$export(module.exports, "inlineNodes", () => $1dd23a32bc80184c$export$b1f729c6af6f2a6e);

var $4K6In = parcelRequire("4K6In");
const $1dd23a32bc80184c$var$typedNodes = $4K6In;
const $1dd23a32bc80184c$export$b1f729c6af6f2a6e = new Set(Object.keys($1dd23a32bc80184c$var$typedNodes).filter((key)=>$1dd23a32bc80184c$var$typedNodes[key] && $1dd23a32bc80184c$var$typedNodes[key].group === 'inline'));

});
parcelRegister("4K6In", function(module, exports) {

$parcel$export(module.exports, "expand", () => (parcelRequire("lKuoe")).expand);
$parcel$export(module.exports, "expandToJSON", () => (parcelRequire("lKuoe")).toJSON);
$parcel$export(module.exports, "confluenceJiraIssue", () => (parcelRequire("eTtDn")).confluenceJiraIssue);
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => (parcelRequire("1Ud4U")).confluenceUnsupportedBlock);
$parcel$export(module.exports, "confluenceUnsupportedInline", () => (parcelRequire("56qNL")).confluenceUnsupportedInline);
$parcel$export(module.exports, "doc", () => (parcelRequire("1HZv5")).doc);
$parcel$export(module.exports, "blockquote", () => (parcelRequire("jDF31")).blockquote);
$parcel$export(module.exports, "blockquoteWithList", () => (parcelRequire("jDF31")).blockquoteWithList);
$parcel$export(module.exports, "bulletList", () => (parcelRequire("568Ob")).bulletList);
$parcel$export(module.exports, "bulletListSelector", () => (parcelRequire("568Ob")).bulletListSelector);
$parcel$export(module.exports, "codeBlock", () => (parcelRequire("hgVop")).codeBlock);
$parcel$export(module.exports, "codeBlockToJSON", () => (parcelRequire("hgVop")).toJSON);
$parcel$export(module.exports, "hardBreak", () => (parcelRequire("7SlQD")).hardBreak);
$parcel$export(module.exports, "heading", () => (parcelRequire("iWGOh")).heading);
$parcel$export(module.exports, "rule", () => (parcelRequire("7wZ4m")).rule);
$parcel$export(module.exports, "orderedList", () => (parcelRequire("8lnnz")).orderedList);
$parcel$export(module.exports, "orderedListSelector", () => (parcelRequire("8lnnz")).orderedListSelector);
$parcel$export(module.exports, "orderedListWithOrder", () => (parcelRequire("8lnnz")).orderedListWithOrder);
$parcel$export(module.exports, "paragraph", () => (parcelRequire("5bGpU")).paragraph);
$parcel$export(module.exports, "emoji", () => (parcelRequire("5JhXr")).emoji);
$parcel$export(module.exports, "image", () => (parcelRequire("iOeir")).image);
$parcel$export(module.exports, "mention", () => (parcelRequire("fkqTY")).mention);
$parcel$export(module.exports, "mentionToJSON", () => (parcelRequire("fkqTY")).toJSON);
$parcel$export(module.exports, "listItem", () => (parcelRequire("3eVto")).listItem);
$parcel$export(module.exports, "listItemWithTask", () => (parcelRequire("3eVto")).listItemWithTask);
$parcel$export(module.exports, "panel", () => (parcelRequire("izui5")).panel);
$parcel$export(module.exports, "extendedPanel", () => (parcelRequire("izui5")).extendedPanel);
$parcel$export(module.exports, "PanelType", () => (parcelRequire("izui5")).PanelType);
$parcel$export(module.exports, "text", () => (parcelRequire("ltJuR")).text);
$parcel$export(module.exports, "unknownBlock", () => (parcelRequire("4ne8H")).default);
$parcel$export(module.exports, "caption", () => (parcelRequire("d99SJ")).caption);
$parcel$export(module.exports, "media", () => (parcelRequire("gN3fl")).media);
$parcel$export(module.exports, "copyPrivateMediaAttributes", () => (parcelRequire("gN3fl")).copyPrivateAttributes);
$parcel$export(module.exports, "mediaToJSON", () => (parcelRequire("gN3fl")).toJSON);
$parcel$export(module.exports, "mediaGroup", () => (parcelRequire("1KDvn")).mediaGroup);
$parcel$export(module.exports, "mediaInline", () => (parcelRequire("hXvCf")).mediaInline);
$parcel$export(module.exports, "mediaSingle", () => (parcelRequire("cvCFq")).mediaSingle);
$parcel$export(module.exports, "mediaSingleSpec", () => (parcelRequire("cvCFq")).mediaSingleSpec);
$parcel$export(module.exports, "mediaSingleWithCaption", () => (parcelRequire("cvCFq")).mediaSingleWithCaption);
$parcel$export(module.exports, "mediaSingleWithWidthType", () => (parcelRequire("cvCFq")).mediaSingleWithWidthType);
$parcel$export(module.exports, "mediaSingleFull", () => (parcelRequire("cvCFq")).mediaSingleFull);
$parcel$export(module.exports, "mediaSingleToJSON", () => (parcelRequire("cvCFq")).toJSON);
$parcel$export(module.exports, "table", () => (parcelRequire("byxO6")).table);
$parcel$export(module.exports, "tableStage0", () => (parcelRequire("byxO6")).tableStage0);
$parcel$export(module.exports, "tableWithCustomWidth", () => (parcelRequire("byxO6")).tableWithCustomWidth);
$parcel$export(module.exports, "tableToJSON", () => (parcelRequire("byxO6")).tableToJSON);
$parcel$export(module.exports, "tableCell", () => (parcelRequire("byxO6")).tableCell);
$parcel$export(module.exports, "toJSONTableCell", () => (parcelRequire("byxO6")).toJSONTableCell);
$parcel$export(module.exports, "tableHeader", () => (parcelRequire("byxO6")).tableHeader);
$parcel$export(module.exports, "toJSONTableHeader", () => (parcelRequire("byxO6")).toJSONTableHeader);
$parcel$export(module.exports, "tableRow", () => (parcelRequire("byxO6")).tableRow);
$parcel$export(module.exports, "tableBackgroundColorPalette", () => (parcelRequire("byxO6")).tableBackgroundColorPalette);
$parcel$export(module.exports, "tableBackgroundBorderColor", () => (parcelRequire("byxO6")).tableBackgroundBorderColor);
$parcel$export(module.exports, "tableBackgroundColorNames", () => (parcelRequire("byxO6")).tableBackgroundColorNames);
$parcel$export(module.exports, "getCellAttrs", () => (parcelRequire("byxO6")).getCellAttrs);
$parcel$export(module.exports, "getCellDomAttrs", () => (parcelRequire("byxO6")).getCellDomAttrs);
$parcel$export(module.exports, "tablePrefixSelector", () => (parcelRequire("byxO6")).tablePrefixSelector);
$parcel$export(module.exports, "tableCellSelector", () => (parcelRequire("byxO6")).tableCellSelector);
$parcel$export(module.exports, "tableHeaderSelector", () => (parcelRequire("byxO6")).tableHeaderSelector);
$parcel$export(module.exports, "tableCellContentWrapperSelector", () => (parcelRequire("byxO6")).tableCellContentWrapperSelector);
$parcel$export(module.exports, "tableCellContentDomSelector", () => (parcelRequire("byxO6")).tableCellContentDomSelector);
$parcel$export(module.exports, "decisionList", () => (parcelRequire("dPUL6")).decisionList);
$parcel$export(module.exports, "decisionListSelector", () => (parcelRequire("dPUL6")).decisionListSelector);
$parcel$export(module.exports, "decisionItem", () => (parcelRequire("47B7q")).decisionItem);
$parcel$export(module.exports, "taskList", () => (parcelRequire("7QozA")).taskList);
$parcel$export(module.exports, "taskListSelector", () => (parcelRequire("7QozA")).taskListSelector);
$parcel$export(module.exports, "taskItem", () => (parcelRequire("ie5d6")).taskItem);
$parcel$export(module.exports, "date", () => (parcelRequire("8CDqw")).date);
$parcel$export(module.exports, "placeholder", () => (parcelRequire("dDs5p")).placeholder);
$parcel$export(module.exports, "layoutSection", () => (parcelRequire("jTnho")).layoutSection);
$parcel$export(module.exports, "layoutSectionWithSingleColumn", () => (parcelRequire("jTnho")).layoutSectionWithSingleColumn);
$parcel$export(module.exports, "layoutColumn", () => (parcelRequire("1O3jv")).layoutColumn);
$parcel$export(module.exports, "inlineCard", () => (parcelRequire("8mC62")).inlineCard);
$parcel$export(module.exports, "blockCard", () => (parcelRequire("heoPx")).blockCard);
$parcel$export(module.exports, "unsupportedBlock", () => (parcelRequire("7p32Z")).unsupportedBlock);
$parcel$export(module.exports, "unsupportedInline", () => (parcelRequire("8cuPa")).unsupportedInline);
$parcel$export(module.exports, "status", () => (parcelRequire("cvo5z")).status);
$parcel$export(module.exports, "nestedExpand", () => (parcelRequire("dj4Ew")).nestedExpand);
$parcel$export(module.exports, "embedCard", () => (parcelRequire("7XTsD")).embedCard);
$parcel$export(module.exports, "extension", () => (parcelRequire("7y7sZ")).extension);
$parcel$export(module.exports, "inlineExtension", () => (parcelRequire("7xvQK")).inlineExtension);
$parcel$export(module.exports, "bodiedExtension", () => (parcelRequire("eStcf")).bodiedExtension);
$parcel$export(module.exports, "extensionFrame", () => (parcelRequire("lUaLf")).extensionFrame);
$parcel$export(module.exports, "multiBodiedExtension", () => (parcelRequire("lUaLf")).multiBodiedExtension);

var $lKuoe = parcelRequire("lKuoe");

var $eTtDn = parcelRequire("eTtDn");

var $1Ud4U = parcelRequire("1Ud4U");

var $56qNL = parcelRequire("56qNL");

var $1HZv5 = parcelRequire("1HZv5");

var $jDF31 = parcelRequire("jDF31");

var $568Ob = parcelRequire("568Ob");

var $hgVop = parcelRequire("hgVop");

var $7SlQD = parcelRequire("7SlQD");

var $iWGOh = parcelRequire("iWGOh");

var $7wZ4m = parcelRequire("7wZ4m");

var $8lnnz = parcelRequire("8lnnz");

var $5bGpU = parcelRequire("5bGpU");

var $5JhXr = parcelRequire("5JhXr");

var $iOeir = parcelRequire("iOeir");

var $fkqTY = parcelRequire("fkqTY");

var $3eVto = parcelRequire("3eVto");

var $izui5 = parcelRequire("izui5");

var $ltJuR = parcelRequire("ltJuR");

var $4ne8H = parcelRequire("4ne8H");

var $d99SJ = parcelRequire("d99SJ");

var $gN3fl = parcelRequire("gN3fl");

var $1KDvn = parcelRequire("1KDvn");

var $hXvCf = parcelRequire("hXvCf");

var $cvCFq = parcelRequire("cvCFq");

var $byxO6 = parcelRequire("byxO6");

var $dPUL6 = parcelRequire("dPUL6");

var $47B7q = parcelRequire("47B7q");

var $7QozA = parcelRequire("7QozA");

var $ie5d6 = parcelRequire("ie5d6");

var $8CDqw = parcelRequire("8CDqw");

var $dDs5p = parcelRequire("dDs5p");

var $jTnho = parcelRequire("jTnho");

var $1O3jv = parcelRequire("1O3jv");

var $8mC62 = parcelRequire("8mC62");

var $heoPx = parcelRequire("heoPx");

var $7p32Z = parcelRequire("7p32Z");

var $8cuPa = parcelRequire("8cuPa");

var $cvo5z = parcelRequire("cvo5z");

var $dj4Ew = parcelRequire("dj4Ew");

var $7XTsD = parcelRequire("7XTsD");

var $7y7sZ = parcelRequire("7y7sZ");

var $7xvQK = parcelRequire("7xvQK");

var $eStcf = parcelRequire("eStcf");

var $lUaLf = parcelRequire("lUaLf");

});



parcelRegister("enpaH", function(module, exports) {

$parcel$export(module.exports, "insideBreakoutLayout", () => $b1eae69ef70cc146$export$d7bc71cca336a3b);
$parcel$export(module.exports, "insideBlockNode", () => $b1eae69ef70cc146$export$42ddc573eb5a7b43);
$parcel$export(module.exports, "insideMultiBodiedExtension", () => $b1eae69ef70cc146$export$9f1e9347b0411934);
const $b1eae69ef70cc146$export$a6a9bc90de7cbf3d = (node)=>node.type.name === 'layoutSection';
const $b1eae69ef70cc146$export$75a02f867f3d493c = (node)=>node.marks.some((m)=>m.type.name === 'breakout');
const $b1eae69ef70cc146$export$d7bc71cca336a3b = (path)=>path.some((item)=>$b1eae69ef70cc146$export$a6a9bc90de7cbf3d(item) && $b1eae69ef70cc146$export$75a02f867f3d493c(item));
const $b1eae69ef70cc146$export$42ddc573eb5a7b43 = (path, schema)=>{
    const { nodes: { expand: expand, nestedExpand: nestedExpand, layoutColumn: layoutColumn } } = schema;
    const blockNodeNames = [
        expand,
        nestedExpand,
        layoutColumn
    ].filter((node)=>Boolean(node)).map((node)=>node.name);
    return path && path.some((n)=>n.type && blockNodeNames.indexOf(n.type.name) > -1);
};
const $b1eae69ef70cc146$export$9f1e9347b0411934 = (path, schema)=>{
    const { nodes: { multiBodiedExtension: multiBodiedExtension } } = schema;
    return path.some((n)=>n.type === multiBodiedExtension);
};

});


parcelRegister("15lMG", function(module, exports) {

$parcel$export(module.exports, "renderDocument", () => $749e15ac1fb41126$export$59a54f98b9753d5c);

var $5iWql = parcelRequire("5iWql");

var $9wcjJ = parcelRequire("9wcjJ");

var $3glLa = parcelRequire("3glLa");

var $2pBoL = parcelRequire("2pBoL");
var $9EOM6 = parcelRequire("9EOM6");

var $auyn4 = parcelRequire("auyn4");

var $3rMck = parcelRequire("3rMck");

var $dgWxh = parcelRequire("dgWxh");

var $8RPsP = parcelRequire("8RPsP");
const $749e15ac1fb41126$var$SUPPORTS_HIRES_TIMER_API = !!(window.performance && performance.now);
const $749e15ac1fb41126$var$withStopwatch = (cb)=>{
    const startTime = $749e15ac1fb41126$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    const output = cb();
    const endTime = $749e15ac1fb41126$var$SUPPORTS_HIRES_TIMER_API ? performance.now() : Date.now();
    const time = endTime - startTime;
    return {
        output: output,
        time: time
    };
};
const $749e15ac1fb41126$var$_validation = (doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent)=>{
    let result;
    if (useSpecBasedValidator) {
        // link mark on mediaSingle is deprecated, need to move link mark to child media node
        // https://product-fabric.atlassian.net/browse/ED-14043
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $8RPsP.transformMediaLinkMarks)(doc);
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $auyn4.ACTION).MEDIA_LINK_TRANSFORMED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).RENDERER,
            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
        });
        result = (0, $9EOM6.validateADFEntity)(schema, transformedAdf || doc, dispatchAnalyticsEvent);
    } else result = (0, $3glLa.getValidDocument)(doc, schema, adfStage);
    if (!result) return result;
    // ProseMirror always require a child under doc
    if (result.type === 'doc' && useSpecBasedValidator) {
        if (Array.isArray(result.content) && result.content.length === 0) result.content.push({
            type: 'paragraph',
            content: []
        });
        // Just making sure doc is always valid
        if (!result.version) result.version = 1;
    }
    return result;
};
const $749e15ac1fb41126$var$memoValidation = (0, $5iWql.default)($749e15ac1fb41126$var$_validation, (newArgs, lastArgs)=>{
    const [newDoc, newSchema, newADFStage, newUseSpecValidator] = newArgs;
    const [oldDoc, oldSchema, oldADFStage, oldUseSpecValidator] = lastArgs;
    // we're ignoring changes to dispatchAnalyticsEvent in this check
    const result = $749e15ac1fb41126$var$areDocsEqual(newDoc, oldDoc) && newSchema === oldSchema && newADFStage === oldADFStage && newUseSpecValidator === oldUseSpecValidator;
    return result;
});
const $749e15ac1fb41126$var$areDocsEqual = (docA, docB)=>{
    if (docA === docB) return true;
    if (typeof docA === 'string' && typeof docB === 'string') return docA === docB;
    // PMNode
    if (docA.type && docA.toJSON && docB.type && docB.toJSON) return JSON.stringify(docA.toJSON()) === JSON.stringify(docB.toJSON());
    // Object
    return JSON.stringify(docA) === JSON.stringify(docB);
};
const $749e15ac1fb41126$var$_serializeFragment = (serializer, doc)=>{
    return serializer.serializeFragment(doc.content);
};
const $749e15ac1fb41126$var$memoSerializeFragment = (0, $5iWql.default)($749e15ac1fb41126$var$_serializeFragment, (newArgs, lastArgs)=>{
    const [newSerializer, newDoc] = newArgs;
    const [oldSerializer, oldDoc] = lastArgs;
    return newSerializer === oldSerializer && $749e15ac1fb41126$var$areDocsEqual(newDoc, oldDoc);
});
const $749e15ac1fb41126$var$_createNodeAndCheck = (schema, doc, dispatchAnalyticsEvent)=>{
    const pmNode = schema.nodeFromJSON(doc);
    try {
        pmNode.check();
    } catch (err) {
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $auyn4.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $3rMck.PLATFORM).WEB,
                errorStack: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
        });
    }
    return pmNode;
};
const $749e15ac1fb41126$var$memoCreateNodeAndCheck = (0, $5iWql.default)($749e15ac1fb41126$var$_createNodeAndCheck, (newArgs, lastArgs)=>{
    // ignore dispatchAnalyticsEvent
    const [newSchema, newDoc] = newArgs;
    const [oldSchema, oldDoc] = lastArgs;
    return newSchema === oldSchema && $749e15ac1fb41126$var$areDocsEqual(newDoc, oldDoc);
});
const $749e15ac1fb41126$export$59a54f98b9753d5c = (doc, serializer, schema = (0, $9wcjJ.defaultSchema), adfStage = 'final', useSpecBasedValidator = false, rendererId = 'noid', dispatchAnalyticsEvent, unsupportedContentLevelsTracking, appearance)=>{
    const stat = {
        sanitizeTime: 0
    };
    const { output: validDoc, time: sanitizeTime } = $749e15ac1fb41126$var$withStopwatch(()=>{
        return $749e15ac1fb41126$var$memoValidation(doc, schema, adfStage, useSpecBasedValidator, dispatchAnalyticsEvent);
    });
    // save sanitize time to stats
    stat.sanitizeTime = sanitizeTime;
    if (!validDoc) return {
        stat: stat,
        result: null
    };
    const { output: node, time: buildTreeTime } = $749e15ac1fb41126$var$withStopwatch(()=>{
        return $749e15ac1fb41126$var$memoCreateNodeAndCheck(schema, validDoc, dispatchAnalyticsEvent);
    });
    // save build tree time to stats
    stat.buildTreeTime = buildTreeTime;
    const { output: result, time: serializeTime } = $749e15ac1fb41126$var$withStopwatch(()=>{
        return $749e15ac1fb41126$var$memoSerializeFragment(serializer, node);
    });
    // save serialize tree time to stats
    stat.serializeTime = serializeTime;
    if (dispatchAnalyticsEvent && useSpecBasedValidator) {
        (0, $2pBoL.findAndTrackUnsupportedContentNodes)(node, schema, dispatchAnalyticsEvent);
        if (unsupportedContentLevelsTracking?.enabled) {
            const documentData = {
                doc: validDoc,
                appearance: appearance,
                rendererId: rendererId
            };
            (0, $dgWxh.trackUnsupportedContentLevels)(documentData, unsupportedContentLevelsTracking, dispatchAnalyticsEvent);
        }
    }
    return {
        result: result,
        stat: stat,
        pmDoc: node
    };
};

});
parcelRegister("9EOM6", function(module, exports) {

$parcel$export(module.exports, "validateADFEntity", () => $7176b3167fe60867$export$884cfad20dece33e);

var $e1vnp = parcelRequire("e1vnp");

var $auyn4 = parcelRequire("auyn4");

var $2pBoL = parcelRequire("2pBoL");
const $7176b3167fe60867$export$8e7fd962b4d3895d = 'unsupportedNodeAttribute';
const $7176b3167fe60867$var$errorCallbackFor = (marks, validate, dispatchAnalyticsEvent)=>{
    return (entity, error, options)=>{
        return $7176b3167fe60867$export$468b008419c9a974(entity, error, options, marks, validate, dispatchAnalyticsEvent);
    };
};
const $7176b3167fe60867$export$468b008419c9a974 = (entity, error, options, marks, validate, dispatchAnalyticsEvent)=>{
    if (entity && entity.type === $7176b3167fe60867$export$8e7fd962b4d3895d) return entity;
    if (options.isMark) return $7176b3167fe60867$export$87b732fa69cdf16e(error.meta, 'mark');
    if (options.isNodeAttribute) {
        const entityType = entity && entity.type ? entity.type : undefined;
        return {
            type: $7176b3167fe60867$export$8e7fd962b4d3895d,
            attrs: {
                type: {
                    nodeType: entityType
                },
                unsupported: error.meta
            }
        };
    }
    if (entity && marks.indexOf(entity.type) > -1) return;
    /**
	 * There's a inconsistency between ProseMirror and ADF.
	 * `content` is actually optional in ProseMirror.
	 * And, also empty `text` node is not valid.
	 */ if (error.code === 'MISSING_PROPERTIES' && entity.type === 'paragraph') return {
        type: 'paragraph',
        content: []
    };
    // TODO: We can repair missing content like `panel` without a `paragraph`.
    if (error.code === 'INVALID_CONTENT_LENGTH') {
        if (error.meta && options.allowUnsupportedBlock && entity.content) return $7176b3167fe60867$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent);
        else // Can't fix it by wrapping
        if (dispatchAnalyticsEvent) $7176b3167fe60867$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    }
    if (options.allowUnsupportedBlock) return $7176b3167fe60867$export$87b732fa69cdf16e(entity);
    if (options.allowUnsupportedInline) return $7176b3167fe60867$export$87b732fa69cdf16e(entity, 'inline');
    if (dispatchAnalyticsEvent) $7176b3167fe60867$var$trackValidationError(dispatchAnalyticsEvent, error, entity);
    return entity;
};
function $7176b3167fe60867$var$getEntityForInvalidContentLength(error, entity, validate, marks, dispatchAnalyticsEvent) {
    const meta = error.meta;
    if (meta.type === 'maximum') entity.content = entity.content.filter((x)=>!!x).map((child, index)=>{
        return index >= meta.requiredLength && child.type !== 'unsupportedBlock' ? $7176b3167fe60867$export$87b732fa69cdf16e(child) : validate(child, $7176b3167fe60867$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent)).entity;
    });
    if (meta.type === 'minimum') {
        if (entity.content.length === 0) return $7176b3167fe60867$export$87b732fa69cdf16e(entity);
        entity.content = entity.content.filter((x)=>!!x).map((child)=>{
            return child.type !== 'unsupportedBlock' ? $7176b3167fe60867$export$87b732fa69cdf16e(child) : child;
        });
    }
    return entity;
}
function $7176b3167fe60867$var$trackValidationError(dispatchAnalyticsEvent, error, entity) {
    if (!dispatchAnalyticsEvent) return;
    (0, $2pBoL.fireUnsupportedEvent)(dispatchAnalyticsEvent, (0, $auyn4.ACTION_SUBJECT_ID).UNSUPPORTED_ERROR, {
        type: entity.type || '',
        ancestry: entity.ancestorHierarchy || '',
        parentType: entity.parentType || '',
        marks: entity.marks || [],
        attrs: entity.attrs || {}
    }, error.code);
}
const $7176b3167fe60867$export$884cfad20dece33e = (schema, node, dispatchAnalyticsEvent)=>{
    const nodes = Object.keys(schema.nodes);
    const marks = Object.keys(schema.marks);
    const validate = (0, $e1vnp.validator)(nodes, marks, {
        allowPrivateAttributes: true
    });
    const emptyDoc = {
        type: 'doc',
        content: []
    };
    const { entity: entity = emptyDoc } = validate(node, $7176b3167fe60867$var$errorCallbackFor(marks, validate, dispatchAnalyticsEvent));
    return entity;
};
function $7176b3167fe60867$export$87b732fa69cdf16e(originalValue, type = 'block') {
    let unsupportedNodeType;
    switch(type){
        case 'inline':
            unsupportedNodeType = 'unsupportedInline';
            break;
        case 'mark':
            unsupportedNodeType = 'unsupportedMark';
            break;
        default:
            unsupportedNodeType = 'unsupportedBlock';
    }
    return {
        type: unsupportedNodeType,
        attrs: {
            originalValue: originalValue
        }
    };
}

});
parcelRegister("e1vnp", function(module, exports) {

$parcel$export(module.exports, "validator", () => $344e03ee90062787$export$956325f45c5d174a);

var $fygQo = parcelRequire("fygQo");

var $9Psqs = parcelRequire("9Psqs");

var $9OCXp = parcelRequire("9OCXp");
function $344e03ee90062787$var$mapMarksItems(spec, fn = (x)=>x) {
    if (spec.props && spec.props.marks) {
        const { items: items, ...rest } = spec.props.marks;
        return {
            ...spec,
            props: {
                ...spec.props,
                marks: {
                    ...rest,
                    /**
					 * `Text & MarksObject<Mark-1>` produces `items: ['mark-1']`
					 * `Text & MarksObject<Mark-1 | Mark-2>` produces `items: [['mark-1', 'mark-2']]`
					 */ items: items.length ? Array.isArray(items[0]) ? items.map(fn) : [
                        fn(items)
                    ] : [
                        []
                    ]
                }
            }
        };
    } else return spec;
}
const $344e03ee90062787$var$partitionObject = (obj, predicate)=>Object.keys(obj).reduce((acc, key)=>{
        const result = predicate(key, obj[key], obj);
        acc[result ? 0 : 1].push(key);
        return acc;
    }, [
        [],
        []
    ]);
/**
 * Normalizes the structure of files imported form './specs'.
 * We denormalised the spec to save bundle size.
 */ function $344e03ee90062787$var$createSpec(nodes, marks) {
    return Object.keys($fygQo).reduce((newSpecs, k)=>{
        const spec = {
            ...$fygQo[k]
        };
        if (spec.props) {
            spec.props = {
                ...spec.props
            };
            if (spec.props.content) {
                // 'tableCell_content' => { type: 'array', items: [ ... ] }
                if ((0, $9Psqs.isString)(spec.props.content)) spec.props.content = $fygQo[spec.props.content];
                // ['inline', 'emoji']
                if (Array.isArray(spec.props.content)) /**
					 * Flatten
					 *
					 * Input:
					 * [ { type: 'array', items: [ 'tableHeader' ] }, { type: 'array', items: [ 'tableCell' ] } ]
					 *
					 * Output:
					 * { type: 'array', items: [ [ 'tableHeader' ], [ 'tableCell' ] ] }
					 */ spec.props.content = {
                    type: 'array',
                    items: (spec.props.content || []).map((arr)=>arr.items)
                };
                else spec.props.content = {
                    ...spec.props.content
                };
                spec.props.content.items = spec.props.content.items// ['inline'] => [['emoji', 'hr', ...]]
                // ['media'] => [['media']]
                .map((item)=>(0, $9Psqs.isString)(item) ? Array.isArray($fygQo[item]) ? $fygQo[item] : [
                        item
                    ] : item)// [['emoji', 'hr', 'inline_code']] => [['emoji', 'hr', ['text', { marks: {} }]]]
                .map((item)=>item.map((subItem)=>Array.isArray($fygQo[subItem]) ? $fygQo[subItem] : (0, $9Psqs.isString)(subItem) ? subItem : [
                            'text',
                            subItem
                        ])// Remove unsupported nodes & marks
                    // Filter nodes
                    .filter((subItem)=>{
                        if (nodes) {
                            // Node with overrides
                            // ['mediaSingle', { props: { content: { items: [ 'media', 'caption' ] } }}]
                            if (Array.isArray(subItem)) {
                                const isMainNodeSupported = nodes.indexOf(subItem[0]) > -1;
                                if (isMainNodeSupported && subItem[1]?.props?.content?.items) return subItem[1].props.content.items.every((item)=>nodes.indexOf(item) > -1);
                                return isMainNodeSupported;
                            }
                            return nodes.indexOf(subItem) > -1;
                        }
                        return true;
                    })// Filter marks
                    .map((subItem)=>Array.isArray(subItem) && marks ? /**
										 * TODO: Probably try something like immer, but it's 3.3kb gzipped.
										 * Not worth it just for this.
										 */ [
                            subItem[0],
                            $344e03ee90062787$var$mapMarksItems(subItem[1])
                        ] : subItem));
            }
        }
        newSpecs[k] = spec;
        return newSpecs;
    }, {});
}
function $344e03ee90062787$var$getOptionsForType(type, list) {
    if (!list) return {};
    for(let i = 0, len = list.length; i < len; i++){
        const spec = list[i];
        let name = spec;
        let options = {};
        if (Array.isArray(spec)) [name, options] = spec;
        if (name === type) return options;
    }
    return false;
}
const $344e03ee90062787$var$isValidatorSpecAttrs = (spec)=>{
    return !!spec.props;
};
function $344e03ee90062787$export$66c739158ef99a42(spec, value) {
    if (!(0, $9Psqs.isDefined)(value)) return !!spec.optional;
    if ($344e03ee90062787$var$isValidatorSpecAttrs(spec)) {
        // If spec has ".props" it is ValidatorSpecAttrs and need to pipe back in recursively
        const [_, invalidKeys] = $344e03ee90062787$var$partitionObject(spec.props, (key, subSpec)=>$344e03ee90062787$export$66c739158ef99a42(subSpec, value[key]));
        return invalidKeys.length === 0;
    }
    // extension_node parameters has no type
    if (!(0, $9Psqs.isDefined)(spec.type)) // @ts-expect-error - property 'optional' does not exist on type 'never'
    // This error was introduced after upgrading to TypeScript 5
    return !!spec.optional;
    switch(spec.type){
        case 'boolean':
            return (0, $9Psqs.isBoolean)(value);
        case 'number':
            return (0, $9Psqs.isNumber)(value) && ((0, $9Psqs.isDefined)(spec.minimum) ? spec.minimum <= value : true) && ((0, $9Psqs.isDefined)(spec.maximum) ? spec.maximum >= value : true);
        case 'integer':
            return (0, $9Psqs.isInteger)(value) && ((0, $9Psqs.isDefined)(spec.minimum) ? spec.minimum <= value : true) && ((0, $9Psqs.isDefined)(spec.maximum) ? spec.maximum >= value : true);
        case 'string':
            const validatorFnPassed = (rule)=>typeof value === 'string' && (0, $9Psqs.isDefined)((0, $9OCXp.validatorFnMap)[rule]) && (0, $9OCXp.validatorFnMap)[rule](value);
            return (0, $9Psqs.isString)(value) && ((0, $9Psqs.isDefined)(spec.minLength) ? spec.minLength <= value.length : true) && ((0, $9Psqs.isDefined)(spec.validatorFn) ? validatorFnPassed(spec.validatorFn) : true) && (spec.pattern ? new RegExp(spec.pattern).test(value) : true);
        case 'object':
            return (0, $9Psqs.isPlainObject)(value);
        case 'array':
            if (Array.isArray(value)) {
                const isTuple = !!spec.isTupleLike;
                const { minItems: minItems, maxItems: maxItems } = spec;
                if (minItems !== undefined && value.length < minItems || maxItems !== undefined && value.length > maxItems) return false;
                if (isTuple) {
                    // If value has fewer items than tuple has specs - we are fine with that.
                    const numberOfItemsToCheck = Math.min(spec.items.length, value.length);
                    return Array(numberOfItemsToCheck).fill(null).every((_, i)=>$344e03ee90062787$export$66c739158ef99a42(spec.items[i], value[i]));
                } else return value.every((valueItem)=>// We check that at least one of the specs in the list (spec.items) matches each value from
                    spec.items.some((itemSpec)=>$344e03ee90062787$export$66c739158ef99a42(itemSpec, valueItem)));
            }
            return false;
        case 'enum':
            return (0, $9Psqs.isString)(value) && spec.values.indexOf(value) > -1;
    }
}
const $344e03ee90062787$var$errorMessageFor = (type, message)=>`${type}: ${message}.`;
const $344e03ee90062787$var$getUnsupportedOptions = (spec)=>{
    if (spec && spec.props && spec.props.content) {
        const { allowUnsupportedBlock: allowUnsupportedBlock, allowUnsupportedInline: allowUnsupportedInline } = spec.props.content;
        return {
            allowUnsupportedBlock: allowUnsupportedBlock,
            allowUnsupportedInline: allowUnsupportedInline
        };
    }
    return {};
};
const $344e03ee90062787$var$invalidChildContent = (child, errorCallback, parentSpec)=>{
    const message = $344e03ee90062787$var$errorMessageFor(child.type, 'invalid content');
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        ...child
    }, {
        code: 'INVALID_CONTENT',
        message: message
    }, $344e03ee90062787$var$getUnsupportedOptions(parentSpec));
};
const $344e03ee90062787$var$unsupportedMarkContent = (errorCode, mark, errorCallback, errorMessage)=>{
    const message = errorMessage || $344e03ee90062787$var$errorMessageFor(mark.type, 'unsupported mark');
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        ...mark
    }, {
        code: errorCode,
        message: message,
        meta: mark
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: true
    });
};
const $344e03ee90062787$var$unsupportedNodeAttributesContent = (entity, errorCode, invalidAttributes, message, errorCallback)=>{
    if (!errorCallback) throw new Error(message);
    else return errorCallback({
        type: entity.type
    }, {
        code: errorCode,
        message: message,
        meta: invalidAttributes
    }, {
        allowUnsupportedBlock: false,
        allowUnsupportedInline: false,
        isMark: false,
        isNodeAttribute: true
    });
};
function $344e03ee90062787$export$956325f45c5d174a(nodes, marks, options) {
    const validatorSpecs = $344e03ee90062787$var$createSpec(nodes, marks);
    const { mode: mode = 'strict', allowPrivateAttributes: allowPrivateAttributes = false } = options || {};
    const validate = (entity, errorCallback, allowed, parentSpec)=>{
        const validationResult = validateNode(entity, errorCallback, allowed, parentSpec);
        return {
            entity: validationResult.entity,
            valid: validationResult.valid
        };
    };
    const validateNode = (entity, errorCallback, allowed, parentSpec, isMark = false)=>{
        const { type: type } = entity;
        let newEntity = {
            ...entity
        };
        const err = (code, msg, meta)=>{
            const message = $344e03ee90062787$var$errorMessageFor(type, msg);
            if (errorCallback) return {
                valid: false,
                entity: errorCallback(newEntity, {
                    code: code,
                    message: message,
                    meta: meta
                }, $344e03ee90062787$var$getUnsupportedOptions(parentSpec))
            };
            else throw new Error(message);
        };
        if (type) {
            const typeOptions = $344e03ee90062787$var$getOptionsForType(type, allowed);
            if (typeOptions === false) return isMark ? {
                valid: false
            } : err('INVALID_TYPE', 'type not allowed here');
            const spec = validatorSpecs[type];
            if (!spec) return err('INVALID_TYPE', `${type}: No validation spec found for type!`);
            const specBasedValidationResult = specBasedValidationFor(spec, typeOptions, entity, err, newEntity, type, errorCallback, isMark);
            if (specBasedValidationResult.hasValidated && specBasedValidationResult.result) return specBasedValidationResult.result;
        } else return err('INVALID_TYPE', 'ProseMirror Node/Mark should contain a `type`');
        return {
            valid: true,
            entity: newEntity
        };
    };
    return validate;
    function marksValidationFor(validator, entity, errorCallback, newEntity, err) {
        let validationResult;
        if (validator.props && validator.props.marks) {
            const marksSet = allowedMarksFor(validator);
            const marksValidationResult = marksAfterValidation(entity, errorCallback, marksSet, validator);
            validationResult = {
                valid: true,
                entity: newEntity,
                marksValidationOutput: marksValidationResult
            };
        } else validationResult = marksForEntitySpecNotSupportingMarks(entity, newEntity, errorCallback, err);
        return validationResult;
    }
    function validatorFor(spec, typeOptions) {
        return {
            ...spec,
            ...typeOptions,
            // options with props can override props of spec
            ...spec.props ? {
                props: {
                    ...spec.props,
                    ...typeOptions['props'] || {}
                }
            } : {}
        };
    }
    function marksAfterValidation(entity, errorCallback, marksSet, validator) {
        return entity.marks ? entity.marks.map((mark)=>{
            const isAKnownMark = marks ? marks.indexOf(mark.type) > -1 : true;
            if (mode === 'strict' && isAKnownMark) {
                const finalResult = validateNode(mark, errorCallback, marksSet, validator, true);
                const finalMark = finalResult.entity;
                if (finalMark) return {
                    valid: true,
                    originalMark: mark,
                    newMark: finalMark
                };
                else if (finalResult.marksValidationOutput && finalResult.marksValidationOutput.length) return {
                    valid: false,
                    originalMark: mark,
                    errorCode: finalResult.marksValidationOutput[0].errorCode,
                    message: finalResult.marksValidationOutput[0].message
                };
                else return {
                    valid: false,
                    originalMark: mark,
                    errorCode: 'INVALID_TYPE'
                };
            } else return {
                valid: false,
                originalMark: mark,
                errorCode: 'INVALID_CONTENT'
            };
        }) : [];
    }
    function allowedMarksFor(validator) {
        const { items: items } = validator.props.marks;
        const marksSet = items.length ? Array.isArray(items[0]) ? items[0] : items : [];
        return marksSet;
    }
    function marksForEntitySpecNotSupportingMarks(prevEntity, newEntity, errorCallback, err) {
        const errorCode = 'REDUNDANT_MARKS';
        const currentMarks = prevEntity.marks || [];
        const newMarks = currentMarks.map((mark)=>{
            const isUnsupportedNodeAttributeMark = mark.type === 'unsupportedNodeAttribute';
            if (isUnsupportedNodeAttributeMark) return mark;
            return $344e03ee90062787$var$unsupportedMarkContent(errorCode, mark, errorCallback);
        });
        if (newMarks.length) {
            newEntity.marks = newMarks;
            return {
                valid: true,
                entity: newEntity
            };
        } else return err('REDUNDANT_MARKS', 'redundant marks', {
            marks: Object.keys(currentMarks)
        });
    }
    function requiredPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        if (validatorSpec.required) {
            if (!validatorSpec.required.every((prop)=>(0, $9Psqs.isDefined)(prevEntity[prop]))) result = err('MISSING_PROPERTIES', 'required prop missing');
        }
        return result;
    }
    function textPropertyValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        if (validatorSpec.props.text) {
            if ((0, $9Psqs.isDefined)(prevEntity.text) && !$344e03ee90062787$export$66c739158ef99a42(validatorSpec.props.text, prevEntity.text)) result = err('INVALID_TEXT', `'text' validation failed`);
        }
        return result;
    }
    function contentLengthValidationFor(validatorSpec, prevEntity, err) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        if (validatorSpec.props.content && prevEntity.content) {
            const { minItems: minItems, maxItems: maxItems } = validatorSpec.props.content;
            const length = prevEntity.content.length;
            if ((0, $9Psqs.isDefined)(minItems) && minItems > length) result = err('INVALID_CONTENT_LENGTH', `'content' should have more than ${minItems} child`, {
                length: length,
                requiredLength: minItems,
                type: 'minimum'
            });
            else if ((0, $9Psqs.isDefined)(maxItems) && maxItems < length) result = err('INVALID_CONTENT_LENGTH', `'content' should have less than ${maxItems} child`, {
                length: length,
                requiredLength: maxItems,
                type: 'maximum'
            });
        }
        return result;
    }
    function invalidAttributesFor(validatorSpec, prevEntity) {
        let invalidAttrs = [];
        let validatorAttrs = {};
        if (validatorSpec.props && validatorSpec.props.attrs) {
            const attrOptions = (0, $9Psqs.makeArray)(validatorSpec.props.attrs);
            /**
			 * Attrs can be union type so try each path
			 * attrs: [{ props: { url: { type: 'string' } } }, { props: { data: {} } }],
			 * Gotcha: It will always report the last failure.
			 */ for(let i = 0, length = attrOptions.length; i < length; ++i){
                const attrOption = attrOptions[i];
                if (attrOption && attrOption.props) [, invalidAttrs] = $344e03ee90062787$var$partitionObject(attrOption.props, (key, spec)=>{
                    const valueToValidate = prevEntity.attrs[key];
                    return $344e03ee90062787$export$66c739158ef99a42(spec, valueToValidate);
                });
                validatorAttrs = attrOption;
                if (!invalidAttrs.length) break;
            }
        }
        return {
            invalidAttrs: invalidAttrs,
            validatorAttrs: validatorAttrs
        };
    }
    function attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback) {
        const validatorSpecAllowsAttributes = validatorSpec.props && validatorSpec.props.attrs;
        if (prevEntity.attrs) {
            if (!validatorSpecAllowsAttributes) {
                if (isMark) return handleNoAttibutesAllowedInSpecForMark(prevEntity, prevEntity.attrs);
                const attrs = Object.keys(prevEntity.attrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, [], attrs, errorCallback);
            }
            const { hasUnsupportedAttrs: hasUnsupportedAttrs, redundantAttrs: redundantAttrs, invalidAttrs: invalidAttrs } = validateAttributes(validatorSpec, prevEntity, prevEntity.attrs);
            if (hasUnsupportedAttrs) {
                if (isMark) return handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs);
                return handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback);
            }
        }
        return {
            valid: true,
            entity: prevEntity
        };
    }
    function validateAttributes(validatorSpec, prevEntity, attributes) {
        const invalidAttributesResult = invalidAttributesFor(validatorSpec, prevEntity);
        const { invalidAttrs: invalidAttrs } = invalidAttributesResult;
        const validatorAttrs = invalidAttributesResult.validatorAttrs;
        const attrs = Object.keys(attributes).filter((k)=>!(allowPrivateAttributes && k.startsWith('__')));
        const redundantAttrs = attrs.filter((a)=>!validatorAttrs.props[a]);
        const hasRedundantAttrs = redundantAttrs.length > 0;
        const hasUnsupportedAttrs = invalidAttrs.length || hasRedundantAttrs;
        return {
            hasUnsupportedAttrs: hasUnsupportedAttrs,
            invalidAttrs: invalidAttrs,
            redundantAttrs: redundantAttrs
        };
    }
    function handleUnsupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, redundantAttrs, errorCallback) {
        const attr = invalidAttrs.concat(redundantAttrs);
        let result = {
            valid: true,
            entity: prevEntity
        };
        const message = $344e03ee90062787$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const errorCode = 'UNSUPPORTED_ATTRIBUTES';
        newEntity.marks = wrapUnSupportedNodeAttributes(prevEntity, newEntity, attr, errorCode, message, errorCallback);
        result = {
            valid: true,
            entity: newEntity
        };
        return result;
    }
    function handleUnsupportedMarkAttributes(prevEntity, invalidAttrs, redundantAttrs) {
        let errorCode = 'INVALID_ATTRIBUTES';
        let message = $344e03ee90062787$var$errorMessageFor(prevEntity.type, `'attrs' validation failed`);
        const hasRedundantAttrs = redundantAttrs.length;
        const hasBothInvalidAndRedundantAttrs = hasRedundantAttrs && invalidAttrs.length;
        if (!hasBothInvalidAndRedundantAttrs && hasRedundantAttrs) {
            errorCode = 'REDUNDANT_ATTRIBUTES';
            message = $344e03ee90062787$var$errorMessageFor('redundant attributes found', redundantAttrs.join(', '));
        }
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function handleNoAttibutesAllowedInSpecForMark(prevEntity, attributes) {
        const message = $344e03ee90062787$var$errorMessageFor('redundant attributes found', Object.keys(attributes).join(', '));
        const errorCode = 'REDUNDANT_ATTRIBUTES';
        const markValidationResult = {
            valid: true,
            originalMark: prevEntity,
            errorCode: errorCode,
            message: message
        };
        return {
            valid: false,
            marksValidationOutput: [
                markValidationResult
            ]
        };
    }
    function wrapUnSupportedNodeAttributes(prevEntity, newEntity, invalidAttrs, errorCode, message, errorCallback) {
        let invalidValues = {};
        for(let invalidAttr in invalidAttrs){
            invalidValues[invalidAttrs[invalidAttr]] = prevEntity.attrs && prevEntity.attrs[invalidAttrs[invalidAttr]];
            if (newEntity.attrs) delete newEntity.attrs[invalidAttrs[invalidAttr]];
        }
        const unsupportedNodeAttributeValues = $344e03ee90062787$var$unsupportedNodeAttributesContent(prevEntity, errorCode, invalidValues, message, errorCallback);
        const finalEntity = {
            ...newEntity
        };
        if (finalEntity.marks) {
            if (!unsupportedNodeAttributeValues) return finalEntity.marks;
            // If there is an existing unsupported node attribute mark, overwrite it to avoid duplicate marks
            const existingMark = finalEntity.marks.find((mark)=>mark.type === unsupportedNodeAttributeValues.type);
            if (existingMark) existingMark.attrs = unsupportedNodeAttributeValues.attrs;
            else finalEntity.marks.push(unsupportedNodeAttributeValues);
            return finalEntity.marks;
        } else return [
            unsupportedNodeAttributeValues
        ];
    }
    function extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type) {
        let result = {
            valid: true,
            entity: prevEntity
        };
        const [requiredProps, redundantProps] = $344e03ee90062787$var$partitionObject(prevEntity, (k)=>(0, $9Psqs.isDefined)(validatorSpec.props[k]));
        if (redundantProps.length) {
            if (mode === 'loose') {
                newEntity = {
                    type: type
                };
                requiredProps.reduce((acc, p)=>(0, $9Psqs.copy)(prevEntity, acc, p), newEntity);
            } else {
                if (!((redundantProps.indexOf('marks') > -1 || redundantProps.indexOf('attrs') > -1) && redundantProps.length === 1)) return err('REDUNDANT_PROPERTIES', `redundant props found: ${redundantProps.join(', ')}`, {
                    props: redundantProps
                });
            }
        }
        return result;
    }
    function specBasedValidationFor(spec, typeOptions, prevEntity, err, newEntity, type, errorCallback, isMark) {
        let specBasedValidationResult = {
            hasValidated: false
        };
        const validatorSpec = validatorFor(spec, typeOptions);
        if (!validatorSpec) return specBasedValidationResult;
        // Required Props
        // For array format where `required` is an array
        const requiredPropertyValidatonResult = requiredPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!requiredPropertyValidatonResult.valid) return {
            hasValidated: true,
            result: requiredPropertyValidatonResult
        };
        if (!validatorSpec.props) {
            const props = Object.keys(prevEntity);
            // If there's no validator.props then there shouldn't be any key except `type`
            if (props.length > 1) return {
                hasValidated: true,
                result: err('REDUNDANT_PROPERTIES', `redundant props found: ${Object.keys(prevEntity).join(', ')}`, {
                    props: props
                })
            };
            return specBasedValidationResult;
        }
        // Check text
        const textPropertyValidationResult = textPropertyValidationFor(validatorSpec, prevEntity, err);
        if (!textPropertyValidationResult.valid) return {
            hasValidated: true,
            result: textPropertyValidationResult
        };
        // Content Length
        const contentLengthValidationResult = contentLengthValidationFor(validatorSpec, prevEntity, err);
        if (!contentLengthValidationResult.valid) return {
            hasValidated: true,
            result: contentLengthValidationResult
        };
        // Required Props
        // For object format based on `optional` property
        const [, missingProps] = $344e03ee90062787$var$partitionObject(validatorSpec.props, (k, v)=>{
            // if the validator is an array, then check
            // if the `required` field contains the key.
            const isOptional = Array.isArray(v) ? !validatorSpec.required?.includes(k) : v.optional;
            return isOptional || (0, $9Psqs.isDefined)(prevEntity[k]);
        });
        if (missingProps.length) return {
            hasValidated: true,
            result: err('MISSING_PROPERTIES', 'required prop missing', {
                props: missingProps
            })
        };
        const attributesValidationResult = attributesValidationFor(validatorSpec, prevEntity, newEntity, isMark, errorCallback);
        if (!attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        if (isMark && attributesValidationResult.valid) return {
            hasValidated: true,
            result: attributesValidationResult
        };
        const extraPropsValidationResult = extraPropsValidationFor(validatorSpec, prevEntity, err, newEntity, type);
        if (!extraPropsValidationResult.valid) return {
            hasValidated: true,
            result: extraPropsValidationResult
        };
        // Children
        if (validatorSpec.props.content) {
            const contentValidatorSpec = validatorSpec.props.content;
            if (prevEntity.content) {
                const validateChildNode = (child, index)=>{
                    if (child === undefined) return child;
                    const validateChildMarks = (childEntity, marksValidationOutput, errorCallback, isLastValidationSpec, isParentTupleLike = false)=>{
                        let marksAreValid = true;
                        if (childEntity && childEntity.marks && marksValidationOutput) {
                            const validMarks = marksValidationOutput.filter((mark)=>mark.valid);
                            const finalMarks = marksValidationOutput.map((mr)=>{
                                if (mr.valid) return mr.newMark;
                                else {
                                    if (validMarks.length || isLastValidationSpec || isParentTupleLike || mr.errorCode === 'INVALID_TYPE' || mr.errorCode === 'INVALID_CONTENT' || mr.errorCode === 'REDUNDANT_ATTRIBUTES' || mr.errorCode === 'INVALID_ATTRIBUTES') return $344e03ee90062787$var$unsupportedMarkContent(mr.errorCode, mr.originalMark, errorCallback, mr.message);
                                    return;
                                }
                            }).filter(Boolean);
                            if (finalMarks.length) childEntity.marks = finalMarks;
                            else {
                                delete childEntity.marks;
                                marksAreValid = false;
                            }
                        }
                        return {
                            valid: marksAreValid,
                            entity: childEntity
                        };
                    };
                    const hasMultipleCombinationOfContentAllowed = !!contentValidatorSpec.isTupleLike;
                    if (hasMultipleCombinationOfContentAllowed) {
                        const { entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, (0, $9Psqs.makeArray)(contentValidatorSpec.items[index] || contentValidatorSpec.items[contentValidatorSpec.items.length - 1]), validatorSpec);
                        const { entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, false, true);
                        return entity;
                    }
                    // Only go inside valid branch
                    const allowedSpecsForEntity = contentValidatorSpec.items.filter((item)=>Array.isArray(item) ? item.some(// [p, hr, ...] or [p, [text, {}], ...]
                        (spec)=>(Array.isArray(spec) ? spec[0] : spec) === child.type) : true);
                    if (allowedSpecsForEntity.length) {
                        if (allowedSpecsForEntity.length > 1) throw new Error('Consider using Tuple instead!');
                        const maybeArray = (0, $9Psqs.makeArray)(allowedSpecsForEntity[0]);
                        const allowedSpecsForChild = maybeArray.filter((item)=>(Array.isArray(item) ? item[0] : item) === child.type);
                        if (allowedSpecsForChild.length === 0) return $344e03ee90062787$var$invalidChildContent(child, errorCallback, validatorSpec);
                        /**
						 * When there's multiple possible branches try all of them.
						 * If all of them fails, throw the first one.
						 * e.g.- [['text', { marks: ['a'] }], ['text', { marks: ['b'] }]]
						 */ let firstError;
                        let firstChild;
                        for(let i = 0, len = allowedSpecsForChild.length; i < len; i++)try {
                            const allowedValueForCurrentSpec = [
                                allowedSpecsForChild[i]
                            ];
                            const { valid: valid, entity: newChildEntity, marksValidationOutput: marksValidationOutput } = validateNode(child, errorCallback, allowedValueForCurrentSpec, validatorSpec);
                            if (valid) {
                                const isLastValidationSpec = i === allowedSpecsForChild.length - 1;
                                const { valid: marksAreValid, entity: entity } = validateChildMarks(newChildEntity, marksValidationOutput, errorCallback, isLastValidationSpec);
                                const unsupportedMarks = entity && entity.marks && entity.marks.filter((mark)=>mark.type === 'unsupportedMark') || [];
                                if (marksAreValid && !unsupportedMarks.length) return entity;
                                else firstChild = firstChild || newChildEntity;
                            } else firstChild = firstChild || newChildEntity;
                        } catch (error) {
                            firstError = firstError || error;
                        }
                        if (!errorCallback) throw firstError;
                        else return firstChild;
                    } else return $344e03ee90062787$var$invalidChildContent(child, errorCallback, validatorSpec);
                };
                newEntity.content = prevEntity.content.map(validateChildNode).filter(Boolean);
            } else if (!contentValidatorSpec.optional) return {
                hasValidated: true,
                result: err('MISSING_PROPERTIES', 'missing `content` prop')
            };
        }
        // Marks
        if (prevEntity.marks) return {
            hasValidated: true,
            result: marksValidationFor(validatorSpec, prevEntity, errorCallback, newEntity, err)
        };
        return specBasedValidationResult;
    }
}

});
parcelRegister("fygQo", function(module, exports) {

$parcel$export(module.exports, "alignment", () => (parcelRequire("a5jT7")).alignment);
$parcel$export(module.exports, "annotation", () => (parcelRequire("a5jT7")).annotation);
$parcel$export(module.exports, "atomic_inline", () => (parcelRequire("a5jT7")).atomic_inline);
$parcel$export(module.exports, "backgroundColor", () => (parcelRequire("a5jT7")).backgroundColor);
$parcel$export(module.exports, "blockCard", () => (parcelRequire("a5jT7")).blockCard);
$parcel$export(module.exports, "block_content", () => (parcelRequire("a5jT7")).block_content);
$parcel$export(module.exports, "blockquote", () => (parcelRequire("a5jT7")).blockquote);
$parcel$export(module.exports, "bodiedExtension", () => (parcelRequire("a5jT7")).bodiedExtension);
$parcel$export(module.exports, "bodiedExtension_with_marks", () => (parcelRequire("a5jT7")).bodiedExtension_with_marks);
$parcel$export(module.exports, "border", () => (parcelRequire("a5jT7")).border);
$parcel$export(module.exports, "breakout", () => (parcelRequire("a5jT7")).breakout);
$parcel$export(module.exports, "bulletList", () => (parcelRequire("a5jT7")).bulletList);
$parcel$export(module.exports, "caption", () => (parcelRequire("a5jT7")).caption);
$parcel$export(module.exports, "code", () => (parcelRequire("a5jT7")).code);
$parcel$export(module.exports, "codeBlock", () => (parcelRequire("a5jT7")).codeBlock);
$parcel$export(module.exports, "codeBlock_with_marks", () => (parcelRequire("a5jT7")).codeBlock_with_marks);
$parcel$export(module.exports, "codeBlock_with_no_marks", () => (parcelRequire("a5jT7")).codeBlock_with_no_marks);
$parcel$export(module.exports, "code_inline", () => (parcelRequire("a5jT7")).code_inline);
$parcel$export(module.exports, "dataConsumer", () => (parcelRequire("a5jT7")).dataConsumer);
$parcel$export(module.exports, "date", () => (parcelRequire("a5jT7")).date);
$parcel$export(module.exports, "decisionItem", () => (parcelRequire("a5jT7")).decisionItem);
$parcel$export(module.exports, "decisionList", () => (parcelRequire("a5jT7")).decisionList);
$parcel$export(module.exports, "doc", () => (parcelRequire("a5jT7")).doc);
$parcel$export(module.exports, "em", () => (parcelRequire("a5jT7")).em);
$parcel$export(module.exports, "embedCard", () => (parcelRequire("a5jT7")).embedCard);
$parcel$export(module.exports, "emoji", () => (parcelRequire("a5jT7")).emoji);
$parcel$export(module.exports, "expand", () => (parcelRequire("a5jT7")).expand);
$parcel$export(module.exports, "expand_with_breakout_mark", () => (parcelRequire("a5jT7")).expand_with_breakout_mark);
$parcel$export(module.exports, "expand_with_no_mark", () => (parcelRequire("a5jT7")).expand_with_no_mark);
$parcel$export(module.exports, "extension", () => (parcelRequire("a5jT7")).extension);
$parcel$export(module.exports, "extensionFrame", () => (parcelRequire("a5jT7")).extensionFrame);
$parcel$export(module.exports, "extension_with_marks", () => (parcelRequire("a5jT7")).extension_with_marks);
$parcel$export(module.exports, "formatted_text_inline", () => (parcelRequire("a5jT7")).formatted_text_inline);
$parcel$export(module.exports, "fragment", () => (parcelRequire("a5jT7")).fragment);
$parcel$export(module.exports, "hardBreak", () => (parcelRequire("a5jT7")).hardBreak);
$parcel$export(module.exports, "heading", () => (parcelRequire("a5jT7")).heading);
$parcel$export(module.exports, "heading_with_alignment", () => (parcelRequire("a5jT7")).heading_with_alignment);
$parcel$export(module.exports, "heading_with_indentation", () => (parcelRequire("a5jT7")).heading_with_indentation);
$parcel$export(module.exports, "heading_with_no_marks", () => (parcelRequire("a5jT7")).heading_with_no_marks);
$parcel$export(module.exports, "indentation", () => (parcelRequire("a5jT7")).indentation);
$parcel$export(module.exports, "inline", () => (parcelRequire("a5jT7")).inline);
$parcel$export(module.exports, "inlineCard", () => (parcelRequire("a5jT7")).inlineCard);
$parcel$export(module.exports, "inlineExtension", () => (parcelRequire("a5jT7")).inlineExtension);
$parcel$export(module.exports, "inlineExtension_with_marks", () => (parcelRequire("a5jT7")).inlineExtension_with_marks);
$parcel$export(module.exports, "inline_comment_marker", () => (parcelRequire("a5jT7")).inline_comment_marker);
$parcel$export(module.exports, "layoutColumn", () => (parcelRequire("a5jT7")).layoutColumn);
$parcel$export(module.exports, "layoutSection", () => (parcelRequire("a5jT7")).layoutSection);
$parcel$export(module.exports, "layoutSection_full", () => (parcelRequire("a5jT7")).layoutSection_full);
$parcel$export(module.exports, "layoutSection_with_single_column", () => (parcelRequire("a5jT7")).layoutSection_with_single_column);
$parcel$export(module.exports, "link", () => (parcelRequire("a5jT7")).link);
$parcel$export(module.exports, "link_text_inline", () => (parcelRequire("a5jT7")).link_text_inline);
$parcel$export(module.exports, "listItem", () => (parcelRequire("a5jT7")).listItem);
$parcel$export(module.exports, "media", () => (parcelRequire("a5jT7")).media);
$parcel$export(module.exports, "mediaGroup", () => (parcelRequire("a5jT7")).mediaGroup);
$parcel$export(module.exports, "mediaInline", () => (parcelRequire("a5jT7")).mediaInline);
$parcel$export(module.exports, "mediaSingle", () => (parcelRequire("a5jT7")).mediaSingle);
$parcel$export(module.exports, "mediaSingle_caption", () => (parcelRequire("a5jT7")).mediaSingle_caption);
$parcel$export(module.exports, "mediaSingle_full", () => (parcelRequire("a5jT7")).mediaSingle_full);
$parcel$export(module.exports, "mention", () => (parcelRequire("a5jT7")).mention);
$parcel$export(module.exports, "multiBodiedExtension", () => (parcelRequire("a5jT7")).multiBodiedExtension);
$parcel$export(module.exports, "nestedExpand", () => (parcelRequire("a5jT7")).nestedExpand);
$parcel$export(module.exports, "nestedExpand_content", () => (parcelRequire("a5jT7")).nestedExpand_content);
$parcel$export(module.exports, "nestedExpand_with_no_marks", () => (parcelRequire("a5jT7")).nestedExpand_with_no_marks);
$parcel$export(module.exports, "non_nestable_block_content", () => (parcelRequire("a5jT7")).non_nestable_block_content);
$parcel$export(module.exports, "orderedList", () => (parcelRequire("a5jT7")).orderedList);
$parcel$export(module.exports, "panel", () => (parcelRequire("a5jT7")).panel);
$parcel$export(module.exports, "paragraph", () => (parcelRequire("a5jT7")).paragraph);
$parcel$export(module.exports, "paragraph_with_alignment", () => (parcelRequire("a5jT7")).paragraph_with_alignment);
$parcel$export(module.exports, "paragraph_with_indentation", () => (parcelRequire("a5jT7")).paragraph_with_indentation);
$parcel$export(module.exports, "paragraph_with_no_marks", () => (parcelRequire("a5jT7")).paragraph_with_no_marks);
$parcel$export(module.exports, "placeholder", () => (parcelRequire("a5jT7")).placeholder);
$parcel$export(module.exports, "rule", () => (parcelRequire("a5jT7")).rule);
$parcel$export(module.exports, "status", () => (parcelRequire("a5jT7")).status);
$parcel$export(module.exports, "strike", () => (parcelRequire("a5jT7")).strike);
$parcel$export(module.exports, "strong", () => (parcelRequire("a5jT7")).strong);
$parcel$export(module.exports, "subsup", () => (parcelRequire("a5jT7")).subsup);
$parcel$export(module.exports, "table", () => (parcelRequire("a5jT7")).table);
$parcel$export(module.exports, "tableCell", () => (parcelRequire("a5jT7")).tableCell);
$parcel$export(module.exports, "tableCell_content", () => (parcelRequire("a5jT7")).tableCell_content);
$parcel$export(module.exports, "tableHeader", () => (parcelRequire("a5jT7")).tableHeader);
$parcel$export(module.exports, "tableRow", () => (parcelRequire("a5jT7")).tableRow);
$parcel$export(module.exports, "taskItem", () => (parcelRequire("a5jT7")).taskItem);
$parcel$export(module.exports, "taskList", () => (parcelRequire("a5jT7")).taskList);
$parcel$export(module.exports, "text", () => (parcelRequire("a5jT7")).text);
$parcel$export(module.exports, "textColor", () => (parcelRequire("a5jT7")).textColor);
$parcel$export(module.exports, "underline", () => (parcelRequire("a5jT7")).underline);

var $a5jT7 = parcelRequire("a5jT7");

});
parcelRegister("a5jT7", function(module, exports) {

$parcel$export(module.exports, "blockCard", () => $7579cc59edd0dc9b$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "text", () => $7579cc59edd0dc9b$export$6f093cfa640b7166);
$parcel$export(module.exports, "codeBlock", () => $7579cc59edd0dc9b$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "codeBlock_with_marks", () => $7579cc59edd0dc9b$export$e6744655acd74d98);
$parcel$export(module.exports, "codeBlock_with_no_marks", () => $7579cc59edd0dc9b$export$6e3671492ca8dabf);
$parcel$export(module.exports, "mediaSingle", () => $7579cc59edd0dc9b$export$969fe3781ca15058);
$parcel$export(module.exports, "media", () => $7579cc59edd0dc9b$export$987d49ffe1b0900f);
$parcel$export(module.exports, "link", () => $7579cc59edd0dc9b$export$9c30223ca0a664fb);
$parcel$export(module.exports, "annotation", () => $7579cc59edd0dc9b$export$8512c9afa7b24c3b);
$parcel$export(module.exports, "border", () => $7579cc59edd0dc9b$export$1edee58a52776cd9);
$parcel$export(module.exports, "hardBreak", () => $7579cc59edd0dc9b$export$371da9dd35aba193);
$parcel$export(module.exports, "mention", () => $7579cc59edd0dc9b$export$db83999c14438df4);
$parcel$export(module.exports, "emoji", () => $7579cc59edd0dc9b$export$a19185d1233fc4b2);
$parcel$export(module.exports, "date", () => $7579cc59edd0dc9b$export$324d90190a8b822a);
$parcel$export(module.exports, "placeholder", () => $7579cc59edd0dc9b$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "inlineCard", () => $7579cc59edd0dc9b$export$cbf8224b64e0d942);
$parcel$export(module.exports, "status", () => $7579cc59edd0dc9b$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "formatted_text_inline", () => $7579cc59edd0dc9b$export$cd4081e08b45f72e);
$parcel$export(module.exports, "code_inline", () => $7579cc59edd0dc9b$export$36e4c193ad57e432);
$parcel$export(module.exports, "em", () => $7579cc59edd0dc9b$export$c63c6f932822f543);
$parcel$export(module.exports, "strong", () => $7579cc59edd0dc9b$export$59ae2c325a998f89);
$parcel$export(module.exports, "strike", () => $7579cc59edd0dc9b$export$4899a95d70ec5056);
$parcel$export(module.exports, "subsup", () => $7579cc59edd0dc9b$export$b3401ee80eb31041);
$parcel$export(module.exports, "underline", () => $7579cc59edd0dc9b$export$425327af25286e5e);
$parcel$export(module.exports, "textColor", () => $7579cc59edd0dc9b$export$32f78bffcd82ff28);
$parcel$export(module.exports, "backgroundColor", () => $7579cc59edd0dc9b$export$8c5a050822fd698c);
$parcel$export(module.exports, "inline_comment_marker", () => $7579cc59edd0dc9b$export$e2bb6ccb232b5816);
$parcel$export(module.exports, "code", () => $7579cc59edd0dc9b$export$6565f9f03506010b);
$parcel$export(module.exports, "caption", () => $7579cc59edd0dc9b$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "mediaSingle_caption", () => $7579cc59edd0dc9b$export$68b0ead306f9670f);
$parcel$export(module.exports, "mediaSingle_full", () => $7579cc59edd0dc9b$export$f7fd577406abd5f8);
$parcel$export(module.exports, "link_text_inline", () => $7579cc59edd0dc9b$export$64324e102160646);
$parcel$export(module.exports, "inlineExtension", () => $7579cc59edd0dc9b$export$16b353b2649bd8d9);
$parcel$export(module.exports, "inlineExtension_with_marks", () => $7579cc59edd0dc9b$export$e37f10815f36843d);
$parcel$export(module.exports, "mediaInline", () => $7579cc59edd0dc9b$export$38bab695e3f720f1);
$parcel$export(module.exports, "atomic_inline", () => $7579cc59edd0dc9b$export$3fed98b72ebf1c06);
$parcel$export(module.exports, "inline", () => $7579cc59edd0dc9b$export$18c8ad048e32c7d5);
$parcel$export(module.exports, "paragraph", () => $7579cc59edd0dc9b$export$9c206ddddb32a9b);
$parcel$export(module.exports, "paragraph_with_alignment", () => $7579cc59edd0dc9b$export$9ca11c06877e5c64);
$parcel$export(module.exports, "paragraph_with_indentation", () => $7579cc59edd0dc9b$export$a3bd66932996fb7d);
$parcel$export(module.exports, "paragraph_with_no_marks", () => $7579cc59edd0dc9b$export$f06f75eb1e56b0c5);
$parcel$export(module.exports, "taskItem", () => $7579cc59edd0dc9b$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "taskList", () => $7579cc59edd0dc9b$export$375b6afcc5f4d291);
$parcel$export(module.exports, "bulletList", () => $7579cc59edd0dc9b$export$a140c94e5ea26bee);
$parcel$export(module.exports, "listItem", () => $7579cc59edd0dc9b$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "orderedList", () => $7579cc59edd0dc9b$export$a5dc81035676e7a);
$parcel$export(module.exports, "blockquote", () => $7579cc59edd0dc9b$export$67dc04e652a298ca);
$parcel$export(module.exports, "decisionItem", () => $7579cc59edd0dc9b$export$6959e16eeff859b4);
$parcel$export(module.exports, "decisionList", () => $7579cc59edd0dc9b$export$62d45a65fb43d95e);
$parcel$export(module.exports, "embedCard", () => $7579cc59edd0dc9b$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "extension", () => $7579cc59edd0dc9b$export$1b45514b112dd749);
$parcel$export(module.exports, "extension_with_marks", () => $7579cc59edd0dc9b$export$15be7c145cec614a);
$parcel$export(module.exports, "heading", () => $7579cc59edd0dc9b$export$46e4a324ac90507f);
$parcel$export(module.exports, "heading_with_indentation", () => $7579cc59edd0dc9b$export$1902f9737466a0dc);
$parcel$export(module.exports, "heading_with_no_marks", () => $7579cc59edd0dc9b$export$7b491e75f1be9278);
$parcel$export(module.exports, "heading_with_alignment", () => $7579cc59edd0dc9b$export$c17edf9af655deaf);
$parcel$export(module.exports, "mediaGroup", () => $7579cc59edd0dc9b$export$2855e964765eac9);
$parcel$export(module.exports, "rule", () => $7579cc59edd0dc9b$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "panel", () => $7579cc59edd0dc9b$export$21f42ab9b6679f44);
$parcel$export(module.exports, "nestedExpand_content", () => $7579cc59edd0dc9b$export$9584f52f3ebd5d7e);
$parcel$export(module.exports, "nestedExpand_with_no_marks", () => $7579cc59edd0dc9b$export$b756fc994eb0bc4f);
$parcel$export(module.exports, "alignment", () => $7579cc59edd0dc9b$export$8e53000a4ec837);
$parcel$export(module.exports, "indentation", () => $7579cc59edd0dc9b$export$480c699bd4ec0d86);
$parcel$export(module.exports, "dataConsumer", () => $7579cc59edd0dc9b$export$3024f02c495408d6);
$parcel$export(module.exports, "fragment", () => $7579cc59edd0dc9b$export$f00aeb236b6f05af);
$parcel$export(module.exports, "tableCell", () => $7579cc59edd0dc9b$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "nestedExpand", () => $7579cc59edd0dc9b$export$63cadbf5f4296627);
$parcel$export(module.exports, "tableHeader", () => $7579cc59edd0dc9b$export$48884d2a5190dc73);
$parcel$export(module.exports, "tableCell_content", () => $7579cc59edd0dc9b$export$9b2745ced483e9ab);
$parcel$export(module.exports, "tableRow", () => $7579cc59edd0dc9b$export$ce666bf02318c957);
$parcel$export(module.exports, "table", () => $7579cc59edd0dc9b$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "non_nestable_block_content", () => $7579cc59edd0dc9b$export$ed866000601e7fa5);
$parcel$export(module.exports, "bodiedExtension", () => $7579cc59edd0dc9b$export$27903d543b563e39);
$parcel$export(module.exports, "bodiedExtension_with_marks", () => $7579cc59edd0dc9b$export$ee052cc5b2356e83);
$parcel$export(module.exports, "expand", () => $7579cc59edd0dc9b$export$9f77e0932fb78f72);
$parcel$export(module.exports, "expand_with_no_mark", () => $7579cc59edd0dc9b$export$1358dbfffec33cd4);
$parcel$export(module.exports, "expand_with_breakout_mark", () => $7579cc59edd0dc9b$export$c30e395ad81940c1);
$parcel$export(module.exports, "block_content", () => $7579cc59edd0dc9b$export$a31afb40076fa18b);
$parcel$export(module.exports, "layoutColumn", () => $7579cc59edd0dc9b$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutSection", () => $7579cc59edd0dc9b$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSection_full", () => $7579cc59edd0dc9b$export$941b63fbd931e449);
$parcel$export(module.exports, "layoutSection_with_single_column", () => $7579cc59edd0dc9b$export$e0e9834198e8601d);
$parcel$export(module.exports, "extensionFrame", () => $7579cc59edd0dc9b$export$4fdcae991fd743e7);
$parcel$export(module.exports, "multiBodiedExtension", () => $7579cc59edd0dc9b$export$c3c04d555a8b9013);
$parcel$export(module.exports, "breakout", () => $7579cc59edd0dc9b$export$89015c65f1c75e3f);
$parcel$export(module.exports, "doc", () => $7579cc59edd0dc9b$export$2a111da947c407d2);
const $7579cc59edd0dc9b$export$c4c2f833baaebdb8 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockCard'
            ]
        },
        attrs: [
            {
                props: {
                    url: {
                        type: 'string',
                        optional: true,
                        validatorFn: 'safeUrl'
                    },
                    datasource: {
                        props: {
                            id: {
                                type: 'string'
                            },
                            parameters: {
                                type: 'object'
                            },
                            views: {
                                items: [
                                    {
                                        props: {
                                            properties: {
                                                optional: true,
                                                type: 'object'
                                            },
                                            type: {
                                                type: 'string'
                                            }
                                        }
                                    }
                                ],
                                minItems: 1,
                                type: 'array'
                            }
                        }
                    },
                    width: {
                        type: 'number',
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ],
                        optional: true
                    }
                }
            },
            {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    }
                }
            }
        ]
    },
    required: [
        'attrs'
    ]
};
const $7579cc59edd0dc9b$export$6f093cfa640b7166 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'text'
            ]
        },
        text: {
            type: 'string',
            minLength: 1
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $7579cc59edd0dc9b$export$310ebe0d80122e9b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'unsupportedInline'
            ]
        },
        attrs: {
            props: {
                originalValue: {
                    type: 'object'
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$7bb0d5c671655cc4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'codeBlock'
            ]
        },
        attrs: {
            props: {
                language: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'text',
                    {
                        props: {
                            marks: {
                                items: [],
                                maxItems: 0,
                                optional: true,
                                type: 'array'
                            }
                        }
                    }
                ]
            ],
            optional: true,
            allowUnsupportedInline: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $7579cc59edd0dc9b$export$e6744655acd74d98 = [
    'codeBlock',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $7579cc59edd0dc9b$export$6e3671492ca8dabf = [
    'codeBlock',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $7579cc59edd0dc9b$export$969fe3781ca15058 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaSingle'
            ]
        },
        attrs: [
            {
                props: {
                    width: {
                        type: 'number',
                        minimum: 0,
                        maximum: 100,
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'percentage'
                        ],
                        optional: true
                    }
                }
            },
            {
                props: {
                    width: {
                        type: 'number',
                        minimum: 0
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'pixel'
                        ]
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                'link'
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$987d49ffe1b0900f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'media'
            ]
        },
        attrs: [
            {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'link',
                            'file'
                        ]
                    },
                    id: {
                        minLength: 1,
                        type: 'string'
                    },
                    alt: {
                        type: 'string',
                        optional: true
                    },
                    collection: {
                        type: 'string'
                    },
                    height: {
                        type: 'number',
                        optional: true
                    },
                    occurrenceKey: {
                        minLength: 1,
                        type: 'string',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    }
                }
            },
            {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'external'
                        ]
                    },
                    alt: {
                        type: 'string',
                        optional: true
                    },
                    height: {
                        type: 'number',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    },
                    url: {
                        type: 'string'
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'link',
                    'annotation',
                    'border'
                ]
            ]
        }
    },
    required: [
        'attrs'
    ]
};
const $7579cc59edd0dc9b$export$44b79b0979d0f0f7 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'unsupportedBlock'
            ]
        },
        attrs: {
            props: {
                originalValue: {
                    type: 'object'
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$9c30223ca0a664fb = {
    props: {
        type: {
            type: 'enum',
            values: [
                'link'
            ]
        },
        attrs: {
            props: {
                href: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                title: {
                    type: 'string',
                    optional: true
                },
                id: {
                    type: 'string',
                    optional: true
                },
                collection: {
                    type: 'string',
                    optional: true
                },
                occurrenceKey: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$8512c9afa7b24c3b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'annotation'
            ]
        },
        attrs: {
            props: {
                id: {
                    type: 'string'
                },
                annotationType: {
                    type: 'enum',
                    values: [
                        'inlineComment'
                    ]
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$1edee58a52776cd9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'border'
            ]
        },
        attrs: {
            props: {
                size: {
                    type: 'number',
                    minimum: 1,
                    maximum: 3
                },
                color: {
                    pattern: '^#[0-9a-fA-F]{8}$|^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$371da9dd35aba193 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'hardBreak'
            ]
        },
        attrs: {
            props: {
                text: {
                    type: 'enum',
                    values: [
                        '\n'
                    ],
                    optional: true
                }
            },
            optional: true
        }
    }
};
const $7579cc59edd0dc9b$export$db83999c14438df4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mention'
            ]
        },
        attrs: {
            props: {
                id: {
                    type: 'string'
                },
                localId: {
                    type: 'string',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                accessLevel: {
                    type: 'string',
                    optional: true
                },
                userType: {
                    type: 'enum',
                    values: [
                        'DEFAULT',
                        'SPECIAL',
                        'APP'
                    ],
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$a19185d1233fc4b2 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'emoji'
            ]
        },
        attrs: {
            props: {
                shortName: {
                    type: 'string'
                },
                id: {
                    type: 'string',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$324d90190a8b822a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'date'
            ]
        },
        attrs: {
            props: {
                timestamp: {
                    minLength: 1,
                    type: 'string'
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$c7187bbd1a7a9244 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'placeholder'
            ]
        },
        attrs: {
            props: {
                text: {
                    type: 'string'
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$cbf8224b64e0d942 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'inlineCard'
            ]
        },
        attrs: [
            {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    }
                }
            }
        ],
        marks: {
            items: [
                'annotation'
            ],
            optional: true,
            type: 'array'
        }
    },
    required: [
        'attrs'
    ]
};
const $7579cc59edd0dc9b$export$471f7ae5c4103ae1 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'status'
            ]
        },
        attrs: {
            props: {
                text: {
                    minLength: 1,
                    type: 'string'
                },
                color: {
                    type: 'enum',
                    values: [
                        'neutral',
                        'purple',
                        'blue',
                        'red',
                        'yellow',
                        'green'
                    ]
                },
                localId: {
                    type: 'string',
                    optional: true
                },
                style: {
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$cd4081e08b45f72e = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'link',
                        'em',
                        'strong',
                        'strike',
                        'subsup',
                        'underline',
                        'textColor',
                        'annotation',
                        'backgroundColor',
                        null
                    ]
                ]
            }
        }
    }
];
const $7579cc59edd0dc9b$export$36e4c193ad57e432 = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'code',
                        'link',
                        'annotation'
                    ]
                ]
            }
        }
    }
];
const $7579cc59edd0dc9b$export$c63c6f932822f543 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'em'
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$59ae2c325a998f89 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strong'
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$4899a95d70ec5056 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strike'
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$b3401ee80eb31041 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'subsup'
            ]
        },
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'sub',
                        'sup'
                    ]
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$425327af25286e5e = {
    props: {
        type: {
            type: 'enum',
            values: [
                'underline'
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$32f78bffcd82ff28 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'textColor'
            ]
        },
        attrs: {
            props: {
                color: {
                    type: 'string',
                    pattern: '^#[0-9a-fA-F]{6}$'
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$8c5a050822fd698c = {
    props: {
        type: {
            type: 'enum',
            values: [
                'backgroundColor'
            ]
        },
        attrs: {
            props: {
                color: {
                    pattern: '^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$e2bb6ccb232b5816 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'confluenceInlineComment'
            ]
        },
        attrs: {
            props: {
                reference: {
                    type: 'string'
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$6565f9f03506010b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'code'
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$8e3c2dfdc4f0453d = {
    props: {
        type: {
            type: 'enum',
            values: [
                'caption'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'hardBreak',
                    'mention',
                    'emoji',
                    'date',
                    'placeholder',
                    'inlineCard',
                    'status',
                    'formatted_text_inline',
                    'code_inline'
                ]
            ],
            allowUnsupportedInline: true,
            minItems: 0
        }
    }
};
const $7579cc59edd0dc9b$export$68b0ead306f9670f = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                isTupleLike: true,
                items: [
                    'media',
                    'caption'
                ],
                minItems: 1,
                maxItems: 2,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $7579cc59edd0dc9b$export$f7fd577406abd5f8 = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'media'
                ],
                minItems: 1,
                maxItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $7579cc59edd0dc9b$export$af10954ff7b86f88 = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'media'
                ],
                minItems: 1,
                maxItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $7579cc59edd0dc9b$export$64324e102160646 = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'link'
                ]
            }
        }
    }
];
const $7579cc59edd0dc9b$export$16b353b2649bd8d9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'inlineExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $7579cc59edd0dc9b$export$e37f10815f36843d = [
    'inlineExtension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $7579cc59edd0dc9b$export$38bab695e3f720f1 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaInline'
            ]
        },
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'link',
                        'file',
                        'image'
                    ],
                    optional: true
                },
                id: {
                    minLength: 1,
                    type: 'string'
                },
                alt: {
                    type: 'string',
                    optional: true
                },
                collection: {
                    type: 'string'
                },
                occurrenceKey: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                },
                width: {
                    type: 'number',
                    optional: true
                },
                height: {
                    type: 'number',
                    optional: true
                },
                data: {
                    type: 'object',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'link',
                    'annotation',
                    'border'
                ]
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$5c452ff88e35e47d = {
    props: {
        type: {
            type: 'enum',
            values: [
                'image'
            ]
        },
        attrs: {
            props: {
                src: {
                    type: 'string'
                },
                alt: {
                    type: 'string',
                    optional: true
                },
                title: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$daf889beb5092f95 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'confluenceJiraIssue'
            ]
        },
        attrs: {
            props: {
                issueKey: {
                    type: 'string'
                },
                macroId: {
                    type: 'string',
                    optional: true
                },
                schemaVersion: {
                    type: 'string',
                    optional: true
                },
                server: {
                    type: 'string',
                    optional: true
                },
                serverId: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$3e6d667072febc87 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'confluenceUnsupportedInline'
            ]
        },
        attrs: {
            props: {
                cxhtml: {
                    type: 'string'
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$3fed98b72ebf1c06 = [
    'hardBreak',
    'mention',
    'emoji',
    'inlineExtension_with_marks',
    'date',
    'placeholder',
    'inlineCard',
    'status',
    'mediaInline'
];
const $7579cc59edd0dc9b$export$18c8ad048e32c7d5 = [
    'formatted_text_inline',
    'code_inline',
    'date',
    'emoji',
    'hardBreak',
    'inlineCard',
    'mention',
    'placeholder',
    'status',
    'inlineExtension_with_marks',
    'mediaInline'
];
const $7579cc59edd0dc9b$export$9c206ddddb32a9b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'paragraph'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'inline'
            ],
            optional: true,
            allowUnsupportedInline: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $7579cc59edd0dc9b$export$9ca11c06877e5c64 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'alignment'
                ]
            }
        }
    }
];
const $7579cc59edd0dc9b$export$a3bd66932996fb7d = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'indentation'
                ]
            }
        }
    }
];
const $7579cc59edd0dc9b$export$f06f75eb1e56b0c5 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $7579cc59edd0dc9b$export$6d8b0ef52e2e6390 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'taskItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'enum',
                    values: [
                        'TODO',
                        'DONE'
                    ]
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $7579cc59edd0dc9b$export$375b6afcc5f4d291 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'taskList'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            isTupleLike: true,
            items: [
                'taskItem',
                [
                    'taskItem',
                    'taskList'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $7579cc59edd0dc9b$export$7c2caff17995c996 = [
    'listItem',
    {
        props: {
            content: {
                type: 'array',
                isTupleLike: true,
                items: [
                    [
                        'paragraph_with_no_marks',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock_with_no_marks'
                    ],
                    [
                        'paragraph_with_no_marks',
                        'bulletList',
                        'orderedList',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock_with_no_marks'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $7579cc59edd0dc9b$export$a140c94e5ea26bee = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bulletList'
            ]
        },
        content: {
            type: 'array',
            items: [
                'listItem'
            ],
            minItems: 1
        }
    }
};
const $7579cc59edd0dc9b$export$76c7e83ecc9cdf05 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'listItem'
            ]
        },
        content: {
            type: 'array',
            isTupleLike: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock_with_no_marks'
                ],
                [
                    'paragraph_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'taskList',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock_with_no_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $7579cc59edd0dc9b$export$a5dc81035676e7a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'orderedList'
            ]
        },
        attrs: {
            props: {
                order: {
                    type: 'number',
                    minimum: 0,
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'listItem'
            ],
            minItems: 1
        }
    }
};
const $7579cc59edd0dc9b$export$67dc04e652a298ca = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockquote'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'orderedList',
                    'bulletList'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $7579cc59edd0dc9b$export$6e5adfaa13d64d06 = [
    'blockquote',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'paragraph'
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $7579cc59edd0dc9b$export$6959e16eeff859b4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'decisionItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
const $7579cc59edd0dc9b$export$62d45a65fb43d95e = {
    props: {
        type: {
            type: 'enum',
            values: [
                'decisionList'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'decisionItem'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $7579cc59edd0dc9b$export$be4283d9a1cb1ff6 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'embedCard'
            ]
        },
        attrs: {
            props: {
                url: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'wrap-right',
                        'wrap-left',
                        'align-end',
                        'align-start'
                    ]
                },
                width: {
                    type: 'number',
                    maximum: 100,
                    minimum: 0,
                    optional: true
                },
                originalHeight: {
                    type: 'number',
                    optional: true
                },
                originalWidth: {
                    type: 'number',
                    optional: true
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$1b45514b112dd749 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'extension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $7579cc59edd0dc9b$export$15be7c145cec614a = [
    'extension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $7579cc59edd0dc9b$export$46e4a324ac90507f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'heading'
            ]
        },
        attrs: {
            props: {
                level: {
                    type: 'number',
                    minimum: 1,
                    maximum: 6
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline'
            ],
            optional: true,
            allowUnsupportedInline: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $7579cc59edd0dc9b$export$1902f9737466a0dc = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'indentation'
                ]
            }
        }
    }
];
const $7579cc59edd0dc9b$export$7b491e75f1be9278 = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $7579cc59edd0dc9b$export$c17edf9af655deaf = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'alignment'
                ]
            }
        }
    }
];
const $7579cc59edd0dc9b$export$2855e964765eac9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaGroup'
            ]
        },
        content: {
            type: 'array',
            items: [
                'media'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $7579cc59edd0dc9b$export$fbeb3a3956e8a3c7 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'rule'
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$21f42ab9b6679f44 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'panel'
            ]
        },
        attrs: {
            props: {
                panelType: {
                    type: 'enum',
                    values: [
                        'info',
                        'note',
                        'tip',
                        'warning',
                        'error',
                        'success',
                        'custom'
                    ]
                },
                panelIcon: {
                    type: 'string',
                    optional: true
                },
                panelIconId: {
                    type: 'string',
                    optional: true
                },
                panelIconText: {
                    type: 'string',
                    optional: true
                },
                panelColor: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'heading_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'blockCard',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock_with_no_marks',
                    'taskList',
                    'rule',
                    'decisionList'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $7579cc59edd0dc9b$export$a2049a0e5c8e6fc7 = [
    'panel',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    [
                        'paragraph_with_no_marks',
                        'heading_with_no_marks',
                        'bulletList',
                        'orderedList',
                        'blockCard'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
const $7579cc59edd0dc9b$export$9584f52f3ebd5d7e = {
    type: 'array',
    items: [
        [
            'paragraph_with_no_marks',
            'heading_with_no_marks',
            'mediaSingle_caption',
            'mediaSingle_full',
            'mediaGroup',
            'codeBlock_with_no_marks',
            'bulletList',
            'orderedList',
            'taskList',
            'decisionList',
            'rule',
            'panel',
            'blockquote'
        ]
    ],
    minItems: 1,
    allowUnsupportedBlock: true
};
const $7579cc59edd0dc9b$export$b756fc994eb0bc4f = [
    'nestedExpand',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $7579cc59edd0dc9b$export$8e53000a4ec837 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'alignment'
            ]
        },
        attrs: {
            props: {
                align: {
                    type: 'enum',
                    values: [
                        'center',
                        'end'
                    ]
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$480c699bd4ec0d86 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'indentation'
            ]
        },
        attrs: {
            props: {
                level: {
                    type: 'number',
                    minimum: 1,
                    maximum: 6
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$3024f02c495408d6 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'dataConsumer'
            ]
        },
        attrs: {
            props: {
                sources: {
                    type: 'array',
                    items: [
                        {
                            type: 'string'
                        }
                    ],
                    minItems: 1
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$f00aeb236b6f05af = {
    props: {
        type: {
            type: 'enum',
            values: [
                'fragment'
            ]
        },
        attrs: {
            props: {
                localId: {
                    minLength: 1,
                    type: 'string'
                },
                name: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$e1e720e5f4603e6a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableCell'
            ]
        },
        attrs: {
            props: {
                colspan: {
                    type: 'number',
                    optional: true
                },
                rowspan: {
                    type: 'number',
                    optional: true
                },
                colwidth: {
                    type: 'array',
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true
                },
                background: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: 'tableCell_content'
    },
    required: [
        'content'
    ]
};
const $7579cc59edd0dc9b$export$63cadbf5f4296627 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'nestedExpand'
            ]
        },
        attrs: {
            props: {
                title: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: 'nestedExpand_content'
    },
    required: [
        'content'
    ]
};
const $7579cc59edd0dc9b$export$48884d2a5190dc73 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableHeader'
            ]
        },
        attrs: {
            props: {
                colspan: {
                    type: 'number',
                    optional: true
                },
                rowspan: {
                    type: 'number',
                    optional: true
                },
                colwidth: {
                    type: 'array',
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true
                },
                background: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: 'tableCell_content'
    },
    required: [
        'content'
    ]
};
const $7579cc59edd0dc9b$export$9b2745ced483e9ab = {
    type: 'array',
    items: [
        [
            'paragraph_with_no_marks',
            'paragraph_with_alignment',
            'panel',
            'blockquote',
            'orderedList',
            'bulletList',
            'rule',
            'heading_with_no_marks',
            'heading_with_alignment',
            'heading_with_indentation',
            'codeBlock_with_no_marks',
            'mediaSingle_caption',
            'mediaSingle_full',
            'mediaGroup',
            'decisionList',
            'taskList',
            'blockCard',
            'embedCard',
            'extension_with_marks',
            'nestedExpand_with_no_marks'
        ]
    ],
    minItems: 1,
    allowUnsupportedBlock: true
};
const $7579cc59edd0dc9b$export$ce666bf02318c957 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableRow'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'tableCell',
                    'tableHeader'
                ]
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$9852986a3ec5f6a0 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'table'
            ]
        },
        attrs: {
            props: {
                displayMode: {
                    type: 'enum',
                    values: [
                        'default',
                        'fixed'
                    ],
                    optional: true
                },
                isNumberColumnEnabled: {
                    type: 'boolean',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'align-end',
                        'align-start',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    minLength: 1,
                    optional: true
                },
                width: {
                    type: 'number',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'tableRow'
            ],
            minItems: 1
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'fragment'
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$ed866000601e7fa5 = [
    'paragraph_with_no_marks',
    'panel',
    'blockquote',
    'orderedList',
    'bulletList',
    'rule',
    'heading_with_no_marks',
    'codeBlock_with_no_marks',
    'mediaGroup',
    'mediaSingle_caption',
    'mediaSingle_full',
    'decisionList',
    'taskList',
    'table',
    'blockCard',
    'embedCard',
    'extension_with_marks'
];
const $7579cc59edd0dc9b$export$27903d543b563e39 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bodiedExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'non_nestable_block_content'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $7579cc59edd0dc9b$export$ee052cc5b2356e83 = [
    'bodiedExtension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
const $7579cc59edd0dc9b$export$9f77e0932fb78f72 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'expand'
            ]
        },
        attrs: {
            props: {
                title: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'non_nestable_block_content'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $7579cc59edd0dc9b$export$1358dbfffec33cd4 = [
    'expand',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
const $7579cc59edd0dc9b$export$c30e395ad81940c1 = [
    'expand',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
const $7579cc59edd0dc9b$export$e6e4878f43c27cab = {
    props: {
        type: {
            type: 'enum',
            values: [
                'confluenceUnsupportedBlock'
            ]
        },
        attrs: {
            props: {
                cxhtml: {
                    type: 'string'
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$a31afb40076fa18b = [
    'blockCard',
    'paragraph_with_no_marks',
    'paragraph_with_alignment',
    'paragraph_with_indentation',
    'mediaSingle_caption',
    'mediaSingle_full',
    'codeBlock_with_no_marks',
    'taskList',
    'bulletList',
    'orderedList',
    'heading_with_no_marks',
    'heading_with_alignment',
    'heading_with_indentation',
    'mediaGroup',
    'decisionList',
    'rule',
    'panel',
    'blockquote',
    'extension_with_marks',
    'embedCard',
    'table',
    'expand_with_no_mark',
    'bodiedExtension_with_marks'
];
const $7579cc59edd0dc9b$export$ab76e7c03cd6f650 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'layoutColumn'
            ]
        },
        attrs: {
            props: {
                width: {
                    type: 'number',
                    minimum: 0,
                    maximum: 100
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'block_content'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
const $7579cc59edd0dc9b$export$b3b6a70a7fa4a5be = {
    props: {
        type: {
            type: 'enum',
            values: [
                'layoutSection'
            ]
        },
        content: {
            type: 'array',
            items: [
                'layoutColumn'
            ]
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'breakout'
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$941b63fbd931e449 = [
    'layoutSection',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'layoutColumn'
                ],
                minItems: 2,
                maxItems: 3,
                allowUnsupportedBlock: true
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            },
            type: {
                type: 'enum',
                values: [
                    'layoutSection'
                ]
            }
        }
    }
];
const $7579cc59edd0dc9b$export$e0e9834198e8601d = [
    'layoutSection',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'layoutColumn'
                ],
                minItems: 1,
                maxItems: 3,
                allowUnsupportedBlock: true
            },
            type: {
                type: 'enum',
                values: [
                    'layoutSection'
                ]
            },
            marks: {
                items: [
                    'breakout'
                ],
                optional: true,
                type: 'array'
            }
        }
    }
];
const $7579cc59edd0dc9b$export$4fdcae991fd743e7 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'extensionFrame'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'codeBlock_with_no_marks',
                    'mediaGroup',
                    'mediaSingle_full',
                    'mediaSingle_caption',
                    'decisionList',
                    'taskList',
                    'table',
                    'extension_with_marks',
                    'bodiedExtension_with_marks',
                    'blockCard',
                    'embedCard'
                ]
            ],
            minItems: 1
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'dataConsumer',
                    'fragment'
                ]
            ]
        }
    }
};
const $7579cc59edd0dc9b$export$c3c04d555a8b9013 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'multiBodiedExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    type: 'string',
                    minLength: 1
                },
                extensionType: {
                    type: 'string',
                    minLength: 1
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'default',
                        'wide',
                        'full-width'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true,
                    minLength: 1
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'extensionFrame'
            ]
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
const $7579cc59edd0dc9b$export$ebb5393736e9ba23 = [
    'multiBodiedExtension'
];
const $7579cc59edd0dc9b$export$89015c65f1c75e3f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'breakout'
            ]
        },
        attrs: {
            props: {
                mode: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width'
                    ]
                }
            }
        }
    }
};
const $7579cc59edd0dc9b$export$2a111da947c407d2 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'doc'
            ]
        },
        version: {
            type: 'enum',
            values: [
                1
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'blockCard',
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'paragraph_with_indentation',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock_with_no_marks',
                    'taskList',
                    'bulletList',
                    'orderedList',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'mediaGroup',
                    'decisionList',
                    'rule',
                    'panel',
                    'blockquote',
                    'extension_with_marks',
                    'embedCard',
                    'table',
                    'expand_with_no_mark',
                    'bodiedExtension_with_marks',
                    'codeBlock_with_marks',
                    'layoutSection_full',
                    'layoutSection_with_single_column',
                    'multiBodiedExtension',
                    'expand_with_breakout_mark'
                ]
            ],
            allowUnsupportedBlock: true
        }
    }
};

});


parcelRegister("9Psqs", function(module, exports) {

$parcel$export(module.exports, "isDefined", () => $4db2155c913df292$export$4e62c701997796c1);
$parcel$export(module.exports, "isNumber", () => $4db2155c913df292$export$7e4aa119212bc614);
$parcel$export(module.exports, "isInteger", () => $4db2155c913df292$export$a287f47fed4544b8);
$parcel$export(module.exports, "isBoolean", () => $4db2155c913df292$export$f9ce7b637dfbe238);
$parcel$export(module.exports, "isString", () => $4db2155c913df292$export$844ec244b1367d54);
$parcel$export(module.exports, "isPlainObject", () => $4db2155c913df292$export$53b83ca8eaab0383);
$parcel$export(module.exports, "copy", () => $4db2155c913df292$export$784d13d8ee351f07);
$parcel$export(module.exports, "makeArray", () => $4db2155c913df292$export$7b85fd78dd236198);
const $4db2155c913df292$export$4e62c701997796c1 = (x)=>x != null;
const $4db2155c913df292$export$7e4aa119212bc614 = (x)=>typeof x === 'number' && !isNaN(x) && isFinite(x);
const $4db2155c913df292$export$a287f47fed4544b8 = (x)=>typeof x === 'number' && isFinite(x) && Math.floor(x) === x;
const $4db2155c913df292$export$f9ce7b637dfbe238 = (x)=>x === true || x === false || toString.call(x) === '[object Boolean]';
const $4db2155c913df292$export$844ec244b1367d54 = (s)=>typeof s === 'string' || s instanceof String;
const $4db2155c913df292$export$53b83ca8eaab0383 = (x)=>typeof x === 'object' && x !== null && !Array.isArray(x);
const $4db2155c913df292$export$784d13d8ee351f07 = (source, dest, key)=>{
    dest[key] = source[key];
    return dest;
};
const $4db2155c913df292$export$7b85fd78dd236198 = (maybeArray)=>Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];

});

parcelRegister("9OCXp", function(module, exports) {

$parcel$export(module.exports, "validatorFnMap", () => $a7ed38120a1f6a7d$export$d1b377ca77ac267d);

var $4N6cH = parcelRequire("4N6cH");
const $a7ed38120a1f6a7d$export$d1b377ca77ac267d = {
    safeUrl: (0, $4N6cH.isSafeUrl)
};

});



parcelRegister("dgWxh", function(module, exports) {

$parcel$export(module.exports, "trackUnsupportedContentLevels", () => $ef522d3e9c36ad8d$export$a43de96edd8d0a0);

var $cC72g = parcelRequire("cC72g");
var $gsJXf = parcelRequire("gsJXf");

var $auyn4 = parcelRequire("auyn4");

var $3rMck = parcelRequire("3rMck");
let $ef522d3e9c36ad8d$var$rendersMap = {};
const $ef522d3e9c36ad8d$var$processLevelsAndTrack = (item, thresholds, dispatchAnalyticsEvent)=>{
    try {
        const { severity: severity, percentage: percentage, counts: { supportedNodes: supportedNodes, unsupportedNodes: unsupportedNodes, unsupportedNodeTypeCount: unsupportedNodeTypeCount } } = (0, $gsJXf.getUnsupportedContentLevelData)(item.doc, thresholds);
        dispatchAnalyticsEvent({
            action: (0, $auyn4.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).RENDERER,
            attributes: {
                appearance: (0, $cC72g.getAnalyticsAppearance)(item.appearance),
                platform: (0, $3rMck.PLATFORM).WEB,
                unsupportedContentLevelSeverity: severity,
                unsupportedContentLevelPercentage: percentage,
                unsupportedNodesCount: unsupportedNodes,
                supportedNodesCount: supportedNodes,
                unsupportedNodeTypeCount: unsupportedNodeTypeCount
            },
            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
        });
    } catch (err) {
        dispatchAnalyticsEvent({
            action: (0, $auyn4.ACTION).UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).RENDERER,
            attributes: {
                platform: (0, $3rMck.PLATFORM).WEB,
                error: err instanceof Error ? err.message : String(err)
            },
            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
        });
    }
};
const $ef522d3e9c36ad8d$var$schedule = (fn)=>{
    if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(fn);
    else setTimeout(fn, 0);
};
const $ef522d3e9c36ad8d$var$DEFAULT_SAMPLING_RATE = 100;
const $ef522d3e9c36ad8d$export$a43de96edd8d0a0 = (item, trackingOptions, dispatchAnalyticsEvent)=>{
    const { thresholds: thresholds, samplingRates: samplingRates } = trackingOptions;
    const appearance = item.appearance ?? 'unknown';
    if (!$ef522d3e9c36ad8d$var$rendersMap[appearance]) $ef522d3e9c36ad8d$var$rendersMap[appearance] = new Set();
    // bail out if already processed a render from a given renderer instance
    const didProcessRenderer = $ef522d3e9c36ad8d$var$rendersMap[appearance].has(item.rendererId);
    if (didProcessRenderer) return;
    // otherwise track the render
    $ef522d3e9c36ad8d$var$rendersMap[appearance].add(item.rendererId);
    const sampleRate = samplingRates && samplingRates[appearance] || $ef522d3e9c36ad8d$var$DEFAULT_SAMPLING_RATE;
    // sample from the first available tracked render
    if ($ef522d3e9c36ad8d$var$rendersMap[appearance].size === 1) $ef522d3e9c36ad8d$var$schedule(()=>$ef522d3e9c36ad8d$var$processLevelsAndTrack(item, thresholds, dispatchAnalyticsEvent));
    // cleanup/refresh tracked renders at the sampling rate
    if ($ef522d3e9c36ad8d$var$rendersMap[appearance].size % sampleRate === 0) $ef522d3e9c36ad8d$var$rendersMap[appearance] = new Set();
};

});

parcelRegister("8RPsP", function(module, exports) {

$parcel$export(module.exports, "transformMediaLinkMarks", () => $7c51eda11523b776$export$6528700f3fa2fe2a);

var $hYZXM = parcelRequire("hYZXM");
const $7c51eda11523b776$export$6528700f3fa2fe2a = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $hYZXM.traverse)(adf, {
        mediaSingle: (node)=>{
            if (!node.marks || !node.content || node.content[0]?.type !== 'media') return node;
            let linkMark = null;
            node.marks.forEach((mark, i)=>{
                if (mark.type === 'link') {
                    linkMark = mark;
                    node.marks?.splice(i, 1);
                    isTransformed = true;
                }
            });
            if (node.marks.length === 0) delete node.marks;
            if (linkMark) {
                const mediaNode = node.content[0];
                // only add link mark if media node doesnt already have one
                if (mediaNode.marks?.every((mark)=>mark.type !== 'link')) mediaNode.marks.push(linkMark);
                else if (!mediaNode.marks) mediaNode.marks = [
                    linkMark
                ];
            }
            return node;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});


parcelRegister("eNyed", function(module, exports) {

$parcel$export(module.exports, "TruncatedWrapper", () => $9b4f242756c8e56d$export$79ad592494094f07);
/** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");
const $9b4f242756c8e56d$var$fadeOutStyles = (maxHeight, top, backgroundColor)=>/*#__PURE__*/ (0, $byn9U.css)({
        position: 'relative',
        overflowY: 'hidden',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxHeight: `${maxHeight}px`,
        '&::after': {
            content: "''",
            position: 'absolute',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            top: `${top}px`,
            bottom: 0,
            left: 0,
            right: 0,
            backgroundImage: `linear-gradient( ${"var(--ds-background-neutral-subtle, rgba(255, 255, 255, 0))"}, ${backgroundColor} )`
        }
    });
const $9b4f242756c8e56d$var$FadeOut = (props)=>{
    const { children: children, backgroundColor: backgroundColor, fadeHeight: fadeHeight, height: height } = props;
    const top = height - fadeHeight;
    const styles = $9b4f242756c8e56d$var$fadeOutStyles(height, top, backgroundColor);
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: styles
    }, children);
};
class $9b4f242756c8e56d$export$79ad592494094f07 extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
    }
    // TODO: Quality ticket as elevation.surface will be issue when sits top of modal. https://product-fabric.atlassian.net/browse/DSP-4123
    render() {
        const { height: height = 95, fadeHeight: fadeHeight = 24, backgroundColor: backgroundColor = "var(--ds-surface, white)", children: children } = this.props;
        return /*#__PURE__*/ (0, $byn9U.jsx)($9b4f242756c8e56d$var$FadeOut, {
            height: height,
            fadeHeight: fadeHeight,
            backgroundColor: backgroundColor
        }, children);
    }
}

});

parcelRegister("czPRi", function(module, exports) {

$parcel$export(module.exports, "BreakoutSSRInlineScript", () => $ddb8ae66842d9ef3$export$cfc1361be0de4203);

var $eUqFw = parcelRequire("eUqFw");

var $b3jMP = parcelRequire("b3jMP");
function $ddb8ae66842d9ef3$export$cfc1361be0de4203() {
    /**
	 * Should only inline this script while SSR,
	 * not needed on the client side.
	 */ if (typeof window !== 'undefined' && !window.navigator.userAgent.includes('jsdom')) return null;
    const id = Math.floor(Math.random() * 9999990001) + 9999;
    const context = $ddb8ae66842d9ef3$export$92859d13f30c883e(id);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("script", {
        "data-breakout-script-id": id,
        // To investigate if we can replace this.
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: context
        }
    });
}
function $ddb8ae66842d9ef3$export$92859d13f30c883e(id) {
    return `
  (function(window){
    ${$ddb8ae66842d9ef3$export$47813c4121c8b4b3};
    (${$ddb8ae66842d9ef3$var$applyBreakoutAfterSSR.toString()})("${id}", breakoutConsts);
  })(window);
`;
}
const $ddb8ae66842d9ef3$export$47813c4121c8b4b3 = `
  var breakoutConsts = ${JSON.stringify((0, $b3jMP.breakoutConsts))};
  breakoutConsts.mapBreakpointToLayoutMaxWidth = ${(0, $b3jMP.breakoutConsts).mapBreakpointToLayoutMaxWidth.toString()};
  breakoutConsts.getBreakpoint = ${(0, $b3jMP.breakoutConsts).getBreakpoint.toString()};
  breakoutConsts.calcBreakoutWidth = ${(0, $b3jMP.breakoutConsts).calcBreakoutWidth.toString()};
  breakoutConsts.calcLineLength = ${(0, $b3jMP.breakoutConsts).calcLineLength.toString()};
  breakoutConsts.calcWideWidth = ${(0, $b3jMP.breakoutConsts).calcWideWidth.toString()};
`;
function $ddb8ae66842d9ef3$var$applyBreakoutAfterSSR(id, breakoutConsts) {
    const MEDIA_NODE_TYPE = 'mediaSingle';
    const WIDE_LAYOUT_MODES = [
        'full-width',
        'wide',
        'custom'
    ];
    function findUp(element, condition) {
        if (!element) return;
        while(element.parentElement){
            if (condition(element)) return element.parentElement;
            element = element.parentElement;
        }
    }
    const renderer = findUp(document.querySelector('[data-breakout-script-id="' + id + '"]'), (elem)=>!!elem.parentElement?.classList.contains('ak-renderer-wrapper'));
    if (!renderer) return;
    const observer = new MutationObserver((mutationsList)=>{
        mutationsList.forEach((item)=>{
            if (item.target.nodeType !== Node.ELEMENT_NODE) return;
            if (item.target.classList.contains('ak-renderer-document')) item.addedNodes.forEach((maybeNode)=>{
                // maybeNode may contain comments which doesn't have a dataset property
                if (maybeNode.nodeType !== Node.ELEMENT_NODE) return;
                let width;
                const node = maybeNode;
                const mode = node.dataset.mode || node.dataset.layout || '';
                if (!mode || !WIDE_LAYOUT_MODES.includes(mode)) return;
                if (node.classList.contains('pm-table-container') && mode === 'custom') {
                    const effectiveWidth = renderer.offsetWidth - breakoutConsts.padding;
                    width = `${Math.min(parseInt(node.style.width), effectiveWidth)}px`;
                } else width = breakoutConsts.calcBreakoutWidth(mode, renderer.offsetWidth);
                if (node.style.width === width) return;
                node.style.width = width;
                // Tables require some special logic, as they are not using common css transform approach,
                // because it breaks with sticky headers. This logic is copied from a table node:
                // https://bitbucket.org/atlassian/atlassian-frontend/src/77938aee0c140d02ff99b98a03849be1236865b4/packages/editor/renderer/src/react/nodes/table.tsx#table.tsx-235:245
                if (node.classList.contains('pm-table-container') && !renderer.classList.contains('is-full-width')) {
                    const lineLength = breakoutConsts.calcLineLength();
                    const left = lineLength / 2 - parseInt(width) / 2;
                    if (left < 0 && parseInt(width) > lineLength) node.style.left = left + 'px';
                    else node.style.left = '';
                }
            });
            else if (/**
				 * The mutation observer is only called once per added node.
				 * The above condition only deals with direct children of <div class="ak-renderer-document" />
				 * When it is initially called on the direct children, not all the sub children have loaded.
				 * So nested media elements which are not immediately loaded as sub children are not available in the above conditional.
				 * Thus adding this conditional to deal with all media elements directly.
				 */ item.target.dataset.nodeType === MEDIA_NODE_TYPE) applyMediaBreakout(item.target);
        });
    });
    const applyMediaBreakout = (card)=>{
        // width was already set by another breakout script
        if (card.style.width) return;
        const tableParent = findUp(card, (elem)=>elem instanceof HTMLTableCellElement);
        // only apply the breakout to media elements not nested inside table
        // table sizing is not based on percentage width
        if (tableParent) return;
        const mode = card.dataset.mode || card.dataset.layout || '';
        const width = card.dataset.width;
        const isPixelBasedResizing = card.dataset.widthType === 'pixel';
        if (WIDE_LAYOUT_MODES.includes(mode)) card.style.width = '100%';
        else if (width && !isPixelBasedResizing) // Pixel based resizing has width set in pixels based on its width attribute
        // Thus, no need to override for non-wide layouts
        card.style.width = `${width}%`;
    };
    observer.observe(renderer, {
        childList: true,
        subtree: true
    });
    /**
	 * Using window load event to unsubscribe from mutation observer, as at this stage document is fully rendered.
	 * Experiment with DOMContentLoaded showed that some of the blocks were not processed at all.
	 * That's why window load is necessary.
	 *
	 * More info:
	 * – https://html.spec.whatwg.org/multipage/parsing.html#the-end
	 * – https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
	 * – https://developer.mozilla.org/en-US/docs/Web/API/Document/DOMContentLoaded_event
	 */ const disconnect = ()=>{
        observer.disconnect();
        window.removeEventListener('load', disconnect);
    };
    window.addEventListener('load', disconnect);
}
const $ddb8ae66842d9ef3$export$2a0b3eeee3f2ea40 = (0, $b3jMP.breakoutConsts).calcLineLength;

});

parcelRegister("3y8r4", function(module, exports) {

$parcel$export(module.exports, "RendererContext", () => $5d02794d72aca87b$export$1e9ea4edb6d1bfe6);
$parcel$export(module.exports, "RendererActionsContext", () => $5d02794d72aca87b$export$66feffbad722f9d4);

var $eUqFw = parcelRequire("eUqFw");

var $4LDRV = parcelRequire("4LDRV");
const $5d02794d72aca87b$export$1e9ea4edb6d1bfe6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(new (0, $4LDRV.default)());
function $5d02794d72aca87b$export$66feffbad722f9d4({ children: children, context: context }) {
    const actions = (0, $eUqFw.useMemo)(()=>new (0, $4LDRV.default)(true), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5d02794d72aca87b$export$1e9ea4edb6d1bfe6.Provider, {
        value: context || actions
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.only(children));
}
const $5d02794d72aca87b$export$d5fcf151601331bc = $5d02794d72aca87b$export$1e9ea4edb6d1bfe6.Consumer;

});
parcelRegister("4LDRV", function(module, exports) {

$parcel$export(module.exports, "default", () => $c69eb49c2c3d64ed$export$2e2bcd8739ae039);

var $3M3qX = parcelRequire("3M3qX");

var $C2nNl = parcelRequire("C2nNl");

var $ht6w1 = parcelRequire("ht6w1");

var $d6JJW = parcelRequire("d6JJW");

var $71A5J = parcelRequire("71A5J");

var $auyn4 = parcelRequire("auyn4");

var $2hpv2 = parcelRequire("2hpv2");

var $1sePJ = parcelRequire("1sePJ");

var $XHGTv = parcelRequire("XHGTv");
class $c69eb49c2c3d64ed$export$2e2bcd8739ae039 {
    constructor(initFromContext = false){
        // This is our psuedo feature flag for now
        // This module can only be used when wrapped with
        // the <RendererContext> component for now.
        this.initFromContext = false;
        this.initFromContext = initFromContext;
        this.transformer = new (0, $3M3qX.JSONTransformer)();
    }
    //#region private
    _privateRegisterRenderer(ref, doc, schema, onAnalyticsEvent) {
        if (!this.initFromContext) return;
        else if (!this.ref) this.ref = ref;
        else if (this.ref !== ref) throw new Error("Renderer has already been registered! It's not allowed to re-register with another new Renderer instance.");
        this.doc = doc;
        this.schema = schema;
        this.onAnalyticsEvent = onAnalyticsEvent;
    }
    _privateUnregisterRenderer() {
        this.doc = undefined;
        this.ref = undefined;
        this.schema = undefined;
    }
    /**
	 * Validate whether we can create an annotation between two positions
	 */ _privateValidatePositionsForAnnotation(from, to) {
        if (!this.doc || !this.schema) return false;
        return (0, $C2nNl.canApplyAnnotationOnRange)({
            from: from,
            to: to
        }, this.doc, this.schema);
    }
    //#endregion
    deleteAnnotation(annotationId, annotationType) {
        if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
        const mark = this.schema.marks.annotation.create({
            id: annotationId,
            annotationType: annotationType
        });
        let from;
        let to;
        let nodePos;
        let step;
        this.doc.descendants((node, pos)=>{
            const found = mark.isInSet(node.marks);
            if (found && node.type.name === 'media') nodePos = pos;
            if (found && !from) {
                // Set both here incase it only spans one node.
                from = pos;
                to = pos + node.nodeSize;
            } else if (found && from) // If the mark spans multiple nodes,
            // we'll keep setting the end until no longer found.
            to = pos + node.nodeSize;
            return true;
        });
        if (nodePos !== undefined) step = new (0, $d6JJW.RemoveNodeMarkStep)(nodePos, mark);
        else {
            if (from === undefined || to === undefined) return false;
            step = new (0, $d6JJW.RemoveMarkStep)(from, to, mark);
        }
        const { doc: doc, failed: failed } = step.apply(this.doc);
        if (this.onAnalyticsEvent) {
            const payload = {
                action: (0, $auyn4.ACTION).DELETED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                attributes: {
                    inlineNodeNames: step instanceof (0, $d6JJW.RemoveMarkStep) ? (0, $1sePJ.getRendererRangeInlineNodeNames)({
                        pos: {
                            from: from,
                            to: to
                        },
                        actions: this
                    }) : undefined
                }
            };
            this.onAnalyticsEvent(payload);
        }
        if (!failed && doc) return {
            step: step,
            doc: this.transformer.encode(doc)
        };
        return false;
    }
    annotate(range, annotationId, annotationType) {
        if (!this.doc || !this.schema || !this.schema.marks.annotation) return false;
        const pos = (0, $71A5J.getPosFromRange)(range);
        if (!pos) return false;
        const { from: from, to: to } = pos;
        const validPositions = this._privateValidatePositionsForAnnotation(from, to);
        if (!validPositions) return false;
        return this.applyAnnotation(pos, {
            annotationId: annotationId,
            annotationType: (0, $ht6w1.AnnotationTypes).INLINE_COMMENT
        });
    }
    isValidAnnotationRange(range) {
        if (!range) return false;
        if ((0, $XHGTv.getBooleanFF)('platform.editor.allow-inline-comments-for-inline-nodes-round-2_ctuxz')) {
            if (this.isRendererWithinRange(range)) return false;
        }
        const pos = (0, $71A5J.getPosFromRange)(range);
        if (!pos || !this.doc) return false;
        return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
    }
    isRendererWithinRange(range) {
        const { startContainer: startContainer, endContainer: endContainer } = range;
        if (startContainer.parentElement && startContainer.parentElement.closest('.ak-renderer-extension') || endContainer.parentElement && endContainer.parentElement.closest('.ak-renderer-extension')) return true;
        return false;
    }
    isValidAnnotationPosition(pos) {
        if (!pos || !this.doc) return false;
        return this._privateValidatePositionsForAnnotation(pos.from, pos.to);
    }
    /**
	 * Note: False indicates that the selection not able to be calculated.
	 */ getPositionFromRange(range, isCommentsOnMediaBugFixEnabled, isCommentsOnMediaBugVideoComment) {
        if (!this.doc || !this.schema || !range) return false;
        return (0, $71A5J.getPosFromRange)(range, isCommentsOnMediaBugFixEnabled, isCommentsOnMediaBugVideoComment);
    }
    getAnnotationMarks() {
        const { schema: schema, doc: doc } = this;
        if (!schema || !doc) return [];
        const { marks: { annotation: annotationMarkType } } = schema;
        if (!annotationMarkType) return [];
        const marks = [];
        doc.descendants((node)=>{
            const annotationsMark = node.marks.filter((m)=>m.type === annotationMarkType);
            if (!annotationsMark || !annotationsMark.length) return true;
            marks.push(...annotationsMark);
            return false;
        });
        const uniqueMarks = new Map();
        marks.forEach((m)=>{
            uniqueMarks.set(m.attrs.id, m);
        });
        return Array.from(uniqueMarks.values());
    }
    getAnnotationsByPosition(range) {
        if (!this.doc || !this.schema) return [];
        const pos = (0, $71A5J.getPosFromRange)(range);
        if (!pos || !this.doc) return [];
        return (0, $C2nNl.getAnnotationIdsFromRange)(pos, this.doc, this.schema);
    }
    applyAnnotation(pos, annotation, isCommentsOnMediaBugFixEnabled, isCommentsOnMediaBugVideoCommentEnabled) {
        if (!this.doc || !pos || !this.schema) return false;
        const { from: from, to: to } = pos;
        const { annotationId: annotationId, annotationType: annotationType } = annotation;
        let step;
        let targetNodeType;
        const beforeNodePos = isCommentsOnMediaBugFixEnabled ? // hence, -1 is not needed
        from : // we need to 1 position before it for nodeAt to return the node itself
        Math.max(from - 1, 0);
        const possibleNode = this.doc.nodeAt(beforeNodePos);
        if (possibleNode?.type.name === 'media') {
            targetNodeType = 'media';
            step = new (0, $d6JJW.AddNodeMarkStep)(beforeNodePos, this.schema.marks.annotation.create({
                id: annotationId,
                type: annotationType
            }));
        } else {
            const resolvedNode = this.doc.resolve(from).node();
            // annotation is technically on text, but the context is caption
            targetNodeType = resolvedNode.type.name === 'caption' ? 'caption' : 'text';
            step = (0, $71A5J.createAnnotationStep)(from, to, {
                annotationId: annotationId,
                annotationType: annotationType,
                schema: this.schema
            });
        }
        const { doc: doc, failed: failed } = step.apply(this.doc);
        if (failed || !doc) return false;
        const originalSelection = doc.textBetween(from, to);
        const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, $2hpv2.getIndexMatch)(this.doc, this.schema, originalSelection, from);
        return {
            step: step,
            doc: this.transformer.encode(doc),
            inlineNodeTypes: (0, $1sePJ.getRendererRangeInlineNodeNames)({
                actions: this,
                pos: {
                    from: from,
                    to: to
                }
            }),
            originalSelection: originalSelection,
            numMatches: numMatches,
            matchIndex: matchIndex,
            pos: blockNodePos,
            ...isCommentsOnMediaBugFixEnabled && {
                targetNodeType: targetNodeType
            }
        };
    }
    generateAnnotationIndexMatch(pos) {
        if (!this.doc || !pos || !this.schema) return false;
        const { from: from, to: to } = pos;
        const originalSelection = this.doc.textBetween(from, to);
        const { numMatches: numMatches, matchIndex: matchIndex, blockNodePos: blockNodePos } = (0, $2hpv2.getIndexMatch)(this.doc, this.schema, originalSelection, from);
        return {
            originalSelection: originalSelection,
            numMatches: numMatches,
            matchIndex: matchIndex,
            pos: blockNodePos
        };
    }
    // TODO: Do not forget to remove `undefined` when the
    //       `platform.editor.allow-inline-comments-for-inline-nodes-round-2_ctuxz` is removed.
    getInlineNodeTypes(annotationId) {
        if (!this.doc || !this.schema) return [];
        return (0, $C2nNl.getAnnotationInlineNodeTypes)({
            doc: this.doc,
            schema: this.schema
        }, annotationId);
    }
}

});
parcelRegister("C2nNl", function(module, exports) {

$parcel$export(module.exports, "canApplyAnnotationOnRange", () => $6e1952b32e9f668f$export$77ddf8216f9eb904);
$parcel$export(module.exports, "getAnnotationIdsFromRange", () => $6e1952b32e9f668f$export$badbcc229c848aec);
$parcel$export(module.exports, "hasAnnotationMark", () => $6e1952b32e9f668f$export$5fe1412b20386053);
$parcel$export(module.exports, "containsAnyAnnotations", () => $6e1952b32e9f668f$export$1976770b876b2728);
$parcel$export(module.exports, "getRangeInlineNodeNames", () => $6e1952b32e9f668f$export$35054451202ed5d9);
$parcel$export(module.exports, "getAnnotationInlineNodeTypes", () => $6e1952b32e9f668f$export$8261bc1f662f3f6e);

var $ht6w1 = parcelRequire("ht6w1");

var $XHGTv = parcelRequire("XHGTv");
const $6e1952b32e9f668f$export$77ddf8216f9eb904 = (rangeSelection, doc, schema)=>{
    const { from: from, to: to } = rangeSelection;
    if (isNaN(from + to) || to - from <= 0 || to < 0 || from < 0) return false;
    const { inlineCard: inlineCard } = schema.nodes;
    let foundInvalid = false;
    doc.nodesBetween(rangeSelection.from, rangeSelection.to, (node, _pos, parent)=>{
        // Special exception for hardBreak nodes
        if (schema.nodes.hardBreak === node.type) return false;
        // For block elements or text nodes, we want to check
        // if annotations are allowed inside this tree
        // or if we're leaf and not text
        if ((0, $XHGTv.getBooleanFF)('platform.editor.allow-inline-comments-for-inline-nodes')) {
            if ((0, $XHGTv.getBooleanFF)('platform.editor.allow-inline-comments-for-inline-nodes-round-2_ctuxz')) {
                const isAllowedInlineNode = [
                    'emoji',
                    'status',
                    'date',
                    'mention',
                    'inlineCard'
                ].includes(node.type.name);
                if (node.isInline && !node.isText && !isAllowedInlineNode || node.isLeaf && !node.isText && !isAllowedInlineNode || node.isText && !parent?.type.allowsMarkType(schema.marks.annotation)) {
                    foundInvalid = true;
                    return false;
                }
            } else if (node.isInline && !node.isText && node.type !== inlineCard || node.isLeaf && !node.isText && node.type !== inlineCard || node.isText && !parent?.type.allowsMarkType(schema.marks.annotation)) {
                foundInvalid = true;
                return false;
            }
        } else if (node.isInline && !node.isText || node.isLeaf && !node.isText || node.isText && !parent?.type.allowsMarkType(schema.marks.annotation)) {
            foundInvalid = true;
            return false;
        }
        return true;
    });
    return !foundInvalid;
};
const $6e1952b32e9f668f$export$badbcc229c848aec = (rangeSelection, doc, schema)=>{
    const { from: from, to: to } = rangeSelection;
    let annotations = new Set();
    doc.nodesBetween(from, to, (node)=>{
        if (!node.marks) return true;
        node.marks.forEach((mark)=>{
            if (mark.type === schema.marks.annotation && mark.attrs) annotations.add(mark.attrs.id);
        });
        return true;
    });
    return Array.from(annotations);
};
function $6e1952b32e9f668f$export$5fe1412b20386053(node, state) {
    const { schema: { marks: { annotation: annotationMark } } } = state;
    return !!(annotationMark && node && node.marks.length && annotationMark.isInSet(node.marks));
}
function $6e1952b32e9f668f$export$1976770b876b2728(slice, state) {
    if (!slice.content.size) return false;
    let hasAnnotation = false;
    slice.content.forEach((node)=>{
        hasAnnotation = hasAnnotation || $6e1952b32e9f668f$export$5fe1412b20386053(node, state);
        // return early if annotation found already
        if (hasAnnotation) return true;
        // check annotations in descendants
        node.descendants((node)=>{
            if ($6e1952b32e9f668f$export$5fe1412b20386053(node, state)) {
                hasAnnotation = true;
                return false;
            }
            return true;
        });
    });
    return hasAnnotation;
}
function $6e1952b32e9f668f$export$35054451202ed5d9({ doc: doc, pos: pos }) {
    if (!(0, $XHGTv.getBooleanFF)('platform.editor.allow-inline-comments-for-inline-nodes-round-2_ctuxz')) return undefined;
    let nodeNames = new Set();
    doc.nodesBetween(pos.from, pos.to, (node)=>{
        if (node.isInline) nodeNames.add(node.type.name);
    });
    // We sort the list alphabetically to make human consumption of the list easier (in tools like the analytics extension)
    const sortedNames = [
        ...nodeNames
    ].sort();
    return sortedNames;
}
function $6e1952b32e9f668f$export$8261bc1f662f3f6e(state, annotationId) {
    if (!(0, $XHGTv.getBooleanFF)('platform.editor.allow-inline-comments-for-inline-nodes-round-2_ctuxz')) return undefined;
    const mark = state.schema.marks.annotation.create({
        id: annotationId,
        annotationType: (0, $ht6w1.AnnotationTypes).INLINE_COMMENT
    });
    const inlineNodeNames = new Set();
    state.doc.descendants((node, pos)=>{
        if (mark.isInSet(node.marks)) inlineNodeNames.add(node.type.name);
        return true;
    });
    // This sorting is done to make human consumption easier (ie. in dev tools, test snapshots, analytics events, ...)
    return [
        ...inlineNodeNames
    ].sort();
}

});

parcelRegister("71A5J", function(module, exports) {

$parcel$export(module.exports, "getPosFromRange", () => $b3968e5549ee563f$export$243cdddc5b21d8c1);
$parcel$export(module.exports, "createAnnotationStep", () => $b3968e5549ee563f$export$74899f7e5acb5cd3);

var $XHGTv = parcelRequire("XHGTv");

var $d6JJW = parcelRequire("d6JJW");
function $b3968e5549ee563f$var$getStartPos(element) {
    return parseInt(element.dataset.rendererStartPos || '-1', 10);
}
const $b3968e5549ee563f$var$getNodeType = (element)=>element.dataset.nodeType;
function $b3968e5549ee563f$var$isPositionPointer(element) {
    return $b3968e5549ee563f$var$getStartPos(element) > -1;
}
function $b3968e5549ee563f$var$findParent(element) {
    const { parentElement: parentElement } = element;
    if (!parentElement || $b3968e5549ee563f$var$isRoot(parentElement)) return null;
    if ($b3968e5549ee563f$var$isPositionPointer(parentElement)) return parentElement;
    return $b3968e5549ee563f$var$findParent(parentElement);
}
function $b3968e5549ee563f$var$findMediaParent(element) {
    const { parentElement: parentElement } = element;
    if (!parentElement || $b3968e5549ee563f$var$isRoot(parentElement)) return null;
    if (parentElement.dataset.nodeType === 'mediaSingle') return parentElement;
    return $b3968e5549ee563f$var$findMediaParent(parentElement);
}
function $b3968e5549ee563f$var$findParentBeforePointer(element) {
    const { parentElement: parentElement } = element;
    if ($b3968e5549ee563f$var$isRoot(parentElement) || !parentElement) return null;
    if ($b3968e5549ee563f$var$isPositionPointer(parentElement)) return element;
    return $b3968e5549ee563f$var$findParentBeforePointer(parentElement);
}
function $b3968e5549ee563f$var$isElementNode(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
function $b3968e5549ee563f$var$isTextNode(node) {
    return node.nodeType === Node.TEXT_NODE;
}
function $b3968e5549ee563f$var$isHighlightTextNode(node) {
    return !!node?.dataset?.highlighted;
}
function $b3968e5549ee563f$var$isNodeInlineMark(node) {
    return $b3968e5549ee563f$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
}
function $b3968e5549ee563f$var$isElementInlineMark(element) {
    return !!element && Boolean(element.dataset.rendererMark);
}
function $b3968e5549ee563f$var$isNodeInlineTextMark(node) {
    if (node === null) return false;
    const isInlineMark = $b3968e5549ee563f$var$isElementNode(node) && Boolean(node.dataset.rendererMark);
    if (!isInlineMark) return false;
    /**
	 * This checks if the element has any descendents with the data-inline-card
	 * attribute set to 'true'. If it does, we should not consider it as an
	 * inline text mark.
	 **/ if ($b3968e5549ee563f$var$hasInlineNodeDescendant(node)) return false;
    return true;
}
/**
 * This checks all the descendents of a node and returns true if it reaches
 * a descendant with the data-inline-card attribute set to 'true'.
 */ function $b3968e5549ee563f$var$hasInlineNodeDescendant(node) {
    if ($b3968e5549ee563f$var$isElementNode(node)) {
        if ((0, $XHGTv.getBooleanFF)('platform.editor.allow-inline-comments-for-inline-nodes-round-2_ctuxz')) {
            if (node.dataset.annotationInlineNode === 'true') return true;
        } else {
            if (node.dataset.inlineCard === 'true') return true;
        }
        return Array.from(node.childNodes).some($b3968e5549ee563f$var$hasInlineNodeDescendant);
    }
    return false;
}
function $b3968e5549ee563f$var$resolveNodePos(node) {
    let resolvedPos = 0;
    let prev = node.previousSibling;
    while(prev){
        if (prev && ($b3968e5549ee563f$var$isTextNode(prev) || $b3968e5549ee563f$var$isHighlightTextNode(prev))) resolvedPos += (prev.textContent || '').length;
        else if (prev) {
            if ((0, $XHGTv.getBooleanFF)('platform.editor.allow-inline-comments-for-inline-nodes')) {
                if ($b3968e5549ee563f$var$isNodeInlineTextMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
                else resolvedPos += 1;
            } else if ($b3968e5549ee563f$var$isNodeInlineMark(prev) && prev.textContent) resolvedPos += prev.textContent.length;
            else resolvedPos += 1;
        }
        prev = prev.previousSibling;
    }
    return resolvedPos;
}
function $b3968e5549ee563f$var$isRoot(element) {
    return !!element && element.classList.contains('ak-renderer-document');
}
function $b3968e5549ee563f$export$5db587db55468da7(node, offset, findEnd = false) {
    // If the passed node doesn't exist, we should abort
    if (!node) return false;
    if ((0, $XHGTv.getBooleanFF)('platform.editor.allow-inline-comments-for-inline-nodes')) {
        const startPosAncestor = node.parentElement?.closest('[data-renderer-start-pos');
        const potentialParent = (0, $XHGTv.getBooleanFF)('platform.editor.allow-inline-comments-for-inline-nodes-round-2_ctuxz') ? 'data-annotation-mark' : 'data-inline-card';
        if (startPosAncestor?.hasAttribute(potentialParent)) {
            if (findEnd) return parseInt(startPosAncestor?.getAttribute('data-renderer-start-pos') || '-1', 10) + 1;
            else return parseInt(startPosAncestor?.getAttribute('data-renderer-start-pos') || '-1', 10);
        }
    }
    if (node instanceof HTMLElement && $b3968e5549ee563f$var$isPositionPointer(node)) return $b3968e5549ee563f$var$getStartPos(node) + offset;
    const parent = $b3968e5549ee563f$var$findParent(node);
    // Similar to above, if we cant find a parent position pointer
    // we should not proceed.
    if (!parent) return false;
    let resolvedPos = $b3968e5549ee563f$var$getStartPos(parent);
    let current = node;
    if (current.parentElement && current.parentElement !== parent) {
        // Find the parent element that is a direct child of the position pointer
        // the outer most element from our text position.
        const preParentPointer = $b3968e5549ee563f$var$findParentBeforePointer(current.parentElement);
        // If our range is inside an inline node
        // We need to move our pointers to parent element
        // since we don't want to count text inside inline nodes at all
        if ((0, $XHGTv.getBooleanFF)('platform.editor.allow-inline-comments-for-inline-nodes')) {
            if (!($b3968e5549ee563f$var$isNodeInlineTextMark(preParentPointer) || $b3968e5549ee563f$var$isHighlightTextNode(preParentPointer))) {
                current = current.parentElement;
                offset = 0;
            }
        } else if (!($b3968e5549ee563f$var$isElementInlineMark(preParentPointer) || $b3968e5549ee563f$var$isHighlightTextNode(preParentPointer))) {
            current = current.parentElement;
            offset = 0;
        }
        resolvedPos += $b3968e5549ee563f$var$resolveNodePos(current);
        while(current && current.parentElement !== parent){
            current = current.parentNode;
            if (current) {
                const nodePos = $b3968e5549ee563f$var$resolveNodePos(current);
                resolvedPos += nodePos;
            }
        }
    } else resolvedPos += $b3968e5549ee563f$var$resolveNodePos(current);
    return resolvedPos + offset;
}
function $b3968e5549ee563f$export$243cdddc5b21d8c1(range, isCommentsOnMediaBugFixEnabled, isCommentsOnMediaBugVideoCommentEnabled) {
    const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
    const possibleMediaOrMediaSingleElement = $b3968e5549ee563f$var$findParent(startContainer);
    if (isCommentsOnMediaBugVideoCommentEnabled) {
        // Video hover targets return media single, not media, thus, the extra check in condition.
        const isMediaOrMediaSingle = possibleMediaOrMediaSingleElement && /media|mediaSingle/.test($b3968e5549ee563f$var$getNodeType(possibleMediaOrMediaSingleElement) || '');
        if (isMediaOrMediaSingle) {
            let pos;
            const mediaSingleElement = $b3968e5549ee563f$var$getNodeType(possibleMediaOrMediaSingleElement) === 'mediaSingle' ? possibleMediaOrMediaSingleElement : $b3968e5549ee563f$var$findMediaParent(possibleMediaOrMediaSingleElement);
            if (mediaSingleElement) pos = $b3968e5549ee563f$var$getStartPos(mediaSingleElement);
            if (pos !== undefined) return {
                from: pos,
                to: pos
            };
        }
    } else if (possibleMediaOrMediaSingleElement && $b3968e5549ee563f$var$getNodeType(possibleMediaOrMediaSingleElement) === 'media') {
        let pos;
        if (isCommentsOnMediaBugFixEnabled) {
            const mediaSingleElement = $b3968e5549ee563f$var$findMediaParent(possibleMediaOrMediaSingleElement);
            if (mediaSingleElement) pos = $b3968e5549ee563f$var$getStartPos(mediaSingleElement);
        } else pos = $b3968e5549ee563f$var$getStartPos(possibleMediaOrMediaSingleElement);
        if (pos !== undefined) return {
            from: pos,
            to: pos
        };
    }
    const from = $b3968e5549ee563f$export$5db587db55468da7(startContainer, startOffset);
    const findEnd = true;
    const to = $b3968e5549ee563f$export$5db587db55468da7(endContainer, endOffset, findEnd);
    if (from === false || to === false) return false;
    return {
        from: from,
        to: to
    };
}
function $b3968e5549ee563f$export$74899f7e5acb5cd3(from, to, opts) {
    return new (0, $d6JJW.AddMarkStep)(Math.min(from, to), Math.max(from, to), opts.schema.marks.annotation.create({
        id: opts.annotationId,
        annotationType: opts.annotationType
    }));
}

});

parcelRegister("2hpv2", function(module, exports) {

$parcel$export(module.exports, "getIndexMatch", () => $b5feef743cb1e04c$export$fb7dab895a0d310e);
function $b5feef743cb1e04c$export$fb7dab895a0d310e(doc, schema, selectedText, startIndex) {
    let textContent = '';
    let matchIndex = 0;
    let numMatches = 0;
    let blockNodePos;
    doc.descendants((node, pos)=>{
        const nodeType = node.type;
        const { media: media } = schema.nodes;
        // Mirrors Confluence backend and doesn't construct textContent if it doesn't allow annotations
        // Don't skip media node so that block node can be defined its startIndex in within [nodeStart, nodeEnd]
        if ((node.isText || !nodeType.allowsMarkType(schema.marks.annotation)) && nodeType !== media) // Note: `return true` as a parent disallowing annotations does not mean a child disallows annotations.
        // Eg: panel (invalid) > p (valid)
        return true;
        const nodeStart = pos;
        const nodeEnd = nodeStart + node.nodeSize;
        if (startIndex >= nodeStart && startIndex <= nodeEnd) {
            // if it's a node block, set position to pos to indicate to the backend
            // that it's an annotation on a block node
            if (nodeType === media) blockNodePos = pos;
            // If the start of the annotation selection is within the current node, we scan the document for previous occurrences
            // Find the index by counting all previous instances of the selectedText in the partial textContent
            // Need to scan from start, up to `startIndex` (which includes partial of the current node)
            textContent += doc.textBetween(nodeStart, startIndex - 1);
            matchIndex = $b5feef743cb1e04c$export$3c2359e76fc742da(textContent, selectedText);
            // Complete appending of the node
            textContent += doc.textBetween(startIndex, nodeEnd);
        } else textContent += node.textContent;
        return true;
    });
    // Count total number of matches in final text
    numMatches = $b5feef743cb1e04c$export$3c2359e76fc742da(textContent, selectedText);
    return {
        numMatches: numMatches,
        matchIndex: matchIndex,
        textContent: textContent,
        blockNodePos: blockNodePos
    };
}
function $b5feef743cb1e04c$export$3c2359e76fc742da(searchString, query) {
    if (searchString === '' || query === '') return 0;
    // Escape characters that would trigger as syntax in a regex query before converting to the query
    const reg = new RegExp(query.replace(/(?=[.\\+*?[^\]$(){}\|])/g, '\\'), 'g');
    return (searchString.match(reg) || []).length;
}

});

parcelRegister("1sePJ", function(module, exports) {

$parcel$export(module.exports, "getRendererRangeInlineNodeNames", () => $a5556de51fea1f38$export$b0ea72d31617ccea);

var $C2nNl = parcelRequire("C2nNl");

var $XHGTv = parcelRequire("XHGTv");
function $a5556de51fea1f38$export$b0ea72d31617ccea({ actions: actions, pos: pos }) {
    if (!(0, $XHGTv.getBooleanFF)('platform.editor.allow-inline-comments-for-inline-nodes-round-2_ctuxz')) return undefined;
    const { doc: doc } = actions;
    if (!pos || !doc) return undefined;
    const inlineNodeNames = (0, $C2nNl.getRangeInlineNodeNames)({
        doc: doc,
        pos: pos
    });
    return inlineNodeNames;
}

});



parcelRegister("fGrAu", function(module, exports) {

$parcel$export(module.exports, "ActiveHeaderIdProvider", () => $1032568447f01655$export$20439b49fdd0d26c);
$parcel$export(module.exports, "ActiveHeaderIdConsumer", () => $1032568447f01655$export$cddc3c6ebe2d2cec);

var $eUqFw = parcelRequire("eUqFw");
const { Provider: $1032568447f01655$export$20439b49fdd0d26c, Consumer: $1032568447f01655$var$Consumer } = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(undefined);
/**
 * We need to expose this abstraction on top of the native Consumer in order to control when
 * The consumer will get notified when a match has happened. If we use the Consumer directly in
 * Expand components without this inner state, everytime a new prop comes in, and the `newActiveHeaderId`
 * is the same as before, we will set the expand to true forever, until the active header id changes.
 * Thus, the user won't be able to collapse the expand.
 *
 * By exposing `onNestedHeaderIdMatch` here we can control when will consumers be notified:
 * only when a `newActiveHeaderId` comes in from the Provider and the list of header ids includes it.
 */ const $1032568447f01655$export$cddc3c6ebe2d2cec = ({ nestedHeaderIds: nestedHeaderIds, onNestedHeaderIdMatch: onNestedHeaderIdMatch })=>{
    const [activeHeaderId, setActiveHeaderId] = (0, $eUqFw.useState)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1032568447f01655$var$Consumer, null, (newActiveHeaderId)=>{
        if (!newActiveHeaderId || !nestedHeaderIds.includes(newActiveHeaderId)) setActiveHeaderId(undefined);
        else if (newActiveHeaderId !== activeHeaderId && nestedHeaderIds.includes(newActiveHeaderId)) {
            setActiveHeaderId(newActiveHeaderId);
            onNestedHeaderIdMatch();
        }
        return null;
    });
};

});

parcelRegister("51CHm", function(module, exports) {

$parcel$export(module.exports, "AnnotationsWrapper", () => $6d4afb79505778c0$export$cef0157dd42cbb3f);

var $eUqFw = parcelRequire("eUqFw");

var $ht6w1 = parcelRequire("ht6w1");

var $8YTuc = parcelRequire("8YTuc");

var $5PgAq = parcelRequire("5PgAq");

var $hM6XC = parcelRequire("hM6XC");

var $hHQQe = parcelRequire("hHQQe");

var $7EYt1 = parcelRequire("7EYt1");

var $bFzGY = parcelRequire("bFzGY");

var $8BrGT = parcelRequire("8BrGT");

var $54EB5 = parcelRequire("54EB5");

var $60fwk = parcelRequire("60fwk");

var $kgIht = parcelRequire("kgIht");
const $6d4afb79505778c0$var$LoadAnnotations = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(({ adfDocument: adfDocument, isNestedRender: isNestedRender })=>{
    (0, $hHQQe.useLoadAnnotations)({
        adfDocument: adfDocument,
        isNestedRender: isNestedRender
    });
    return null;
});
const $6d4afb79505778c0$export$cef0157dd42cbb3f = (props)=>{
    const { children: children, annotationProvider: annotationProvider, rendererRef: rendererRef, adfDocument: adfDocument, isNestedRender: isNestedRender } = props;
    const updateSubscriber = annotationProvider && annotationProvider.inlineComment && annotationProvider.inlineComment.updateSubscriber;
    const inlineCommentAnnotationsState = (0, $7EYt1.useAnnotationStateByTypeEvent)({
        type: (0, $ht6w1.AnnotationTypes).INLINE_COMMENT,
        updateSubscriber: updateSubscriber || null
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hM6XC.ProvidersContext).Provider, {
        value: annotationProvider
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hM6XC.InlineCommentsStateContext).Provider, {
        value: inlineCommentAnnotationsState
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8BrGT.AnnotationRangeProvider), {
        allowCommentsOnMedia: annotationProvider?.inlineComment?.allowCommentsOnMedia ?? false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $54EB5.AnnotationHoverContext), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5PgAq.AnnotationsContextWrapper), {
        createAnalyticsEvent: createAnalyticsEvent,
        rendererRef: rendererRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6d4afb79505778c0$var$LoadAnnotations, {
        adfDocument: adfDocument,
        isNestedRender: isNestedRender
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8YTuc.AnnotationView), {
        createAnalyticsEvent: createAnalyticsEvent
    }), children)))));
};

});
parcelRegister("8YTuc", function(module, exports) {

$parcel$export(module.exports, "AnnotationView", () => $33f5226cf1895528$export$41cd4a02859c2806);

var $eUqFw = parcelRequire("eUqFw");

var $hM6XC = parcelRequire("hM6XC");

var $7EYt1 = parcelRequire("7EYt1");

var $3y8r4 = parcelRequire("3y8r4");
const $33f5226cf1895528$export$41cd4a02859c2806 = (props)=>{
    const providers = (0, $eUqFw.useContext)((0, $hM6XC.ProvidersContext));
    const actionContext = (0, $eUqFw.useContext)((0, $3y8r4.RendererContext));
    const inlineCommentProvider = providers && providers.inlineComment;
    const updateSubscriber = inlineCommentProvider && inlineCommentProvider.updateSubscriber || null;
    const isCommentsOnMediaAnalyticsEnabled = inlineCommentProvider?.isCommentsOnMediaAnalyticsEnabled;
    const viewComponentProps = (0, $7EYt1.useAnnotationClickEvent)({
        updateSubscriber: updateSubscriber,
        createAnalyticsEvent: props.createAnalyticsEvent,
        isCommentsOnMediaAnalyticsEnabled: isCommentsOnMediaAnalyticsEnabled
    });
    const ViewComponent = inlineCommentProvider && inlineCommentProvider.viewComponent;
    const deleteAnnotation = (0, $eUqFw.useMemo)(()=>(annotationInfo)=>actionContext.deleteAnnotation(annotationInfo.id, annotationInfo.type), [
        actionContext
    ]);
    // For view mode, the finding of inline node types is a bit more complex,
    // that's why we will not provide it as a `inlineNodeTypes` props to the view component,
    // to speed up the rendering process.
    const getInlineNodeTypes = (0, $eUqFw.useCallback)((annotationId)=>actionContext.getInlineNodeTypes(annotationId), [
        actionContext
    ]);
    if (ViewComponent && viewComponentProps) {
        const { annotations: annotations, clickElementTarget: clickElementTarget } = viewComponentProps;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ViewComponent, {
            annotations: annotations,
            clickElementTarget: clickElementTarget,
            deleteAnnotation: deleteAnnotation,
            getInlineNodeTypes: getInlineNodeTypes
        });
    }
    return null;
};

});

parcelRegister("5PgAq", function(module, exports) {

$parcel$export(module.exports, "AnnotationsContextWrapper", () => $cbee67f29564fbf7$export$787af8a111ff3c03);

var $eUqFw = parcelRequire("eUqFw");

var $hM6XC = parcelRequire("hM6XC");

var $kwO9B = parcelRequire("kwO9B");

var $hqR1N = parcelRequire("hqR1N");

var $8BrGT = parcelRequire("8BrGT");
const $cbee67f29564fbf7$export$787af8a111ff3c03 = (props)=>{
    const providers = (0, $eUqFw.useContext)((0, $hM6XC.ProvidersContext));
    const { range: range, type: type } = (0, $8BrGT.useAnnotationRangeState)();
    const { setDraftRange: setDraftRange, clearDraftRange: clearDraftRange } = (0, $8BrGT.useAnnotationRangeDispatch)();
    const { rendererRef: rendererRef, createAnalyticsEvent: createAnalyticsEvent, children: children } = props;
    const inlineCommentProvider = providers && providers.inlineComment;
    const selectionComponent = inlineCommentProvider && inlineCommentProvider.selectionComponent;
    const hoverComponent = inlineCommentProvider && inlineCommentProvider.hoverComponent;
    // We want to set the draft to the range the user highlighted
    const setRangeForDraft = (0, $eUqFw.useCallback)(()=>{
        setDraftRange(range, type);
    }, [
        range,
        setDraftRange,
        type
    ]);
    const clearRangeForDraft = (0, $eUqFw.useCallback)(()=>{
        clearDraftRange(type);
    }, [
        type,
        clearDraftRange
    ]);
    const render = (0, $eUqFw.useCallback)(({ applyAnnotationDraftAt: applyAnnotationDraftAt, clearAnnotationDraft: clearAnnotationDraft })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children, !!hoverComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kwO9B.RangeValidator), {
            createAnalyticsEvent: createAnalyticsEvent,
            rendererRef: rendererRef,
            component: hoverComponent,
            applyAnnotationDraftAt: applyAnnotationDraftAt,
            clearAnnotationDraft: clearAnnotationDraft
        }), !!selectionComponent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hqR1N.SelectionRangeValidator), {
            createAnalyticsEvent: createAnalyticsEvent,
            rendererRef: rendererRef,
            selectionComponent: selectionComponent,
            applyAnnotationDraftAt: applyAnnotationDraftAt,
            clearAnnotationDraft: clearAnnotationDraft
        }));
    }, [
        hoverComponent,
        selectionComponent,
        children,
        rendererRef,
        createAnalyticsEvent
    ]);
    if (!selectionComponent && !hoverComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hM6XC.AnnotationsDraftContextWrapper), {
        setDraftRange: setRangeForDraft,
        clearDraftRange: clearRangeForDraft
    }, render);
};

});
parcelRegister("kwO9B", function(module, exports) {

$parcel$export(module.exports, "RangeValidator", () => $ab20af5b23ed434b$export$6d8376a902cb8aa7);

var $eUqFw = parcelRequire("eUqFw");

var $hDLz7 = parcelRequire("hDLz7");

var $3y8r4 = parcelRequire("3y8r4");

var $8BrGT = parcelRequire("8BrGT");

var $54EB5 = parcelRequire("54EB5");

var $hM6XC = parcelRequire("hM6XC");
const $ab20af5b23ed434b$export$6d8376a902cb8aa7 = (props)=>{
    const { component: component, rendererRef: rendererRef, applyAnnotationDraftAt: applyAnnotationDraftAt, clearAnnotationDraft: clearAnnotationDraft, createAnalyticsEvent: createAnalyticsEvent } = props;
    const actions = (0, $eUqFw.useContext)((0, $3y8r4.RendererContext));
    const { clearHoverRange: clearHoverRange } = (0, $8BrGT.useAnnotationRangeDispatch)();
    const { range: range, type: type } = (0, $8BrGT.useAnnotationRangeState)();
    const { isWithinRange: isWithinRange } = (0, $54EB5.useAnnotationHoverContext)();
    const providers = (0, $eUqFw.useContext)((0, $hM6XC.ProvidersContext));
    const isCommentsOnMediaBugFixEnabled = providers?.inlineComment.isCommentsOnMediaBugFixEnabled ?? false;
    const isCommentsOnMediaBugVideoCommentEnabled = providers?.inlineComment.isCommentsOnMediaBugVideoCommentEnabled ?? false;
    if (!range || type !== 'hover') return null;
    const documentPosition = actions.getPositionFromRange(range, isCommentsOnMediaBugFixEnabled, isCommentsOnMediaBugVideoCommentEnabled);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hDLz7.Mounter), {
        isWithinRange: isWithinRange,
        range: range,
        wrapperDOM: rendererRef,
        component: component,
        onClose: clearHoverRange,
        documentPosition: documentPosition,
        isAnnotationAllowed: true,
        applyAnnotation: actions.applyAnnotation.bind(actions),
        applyAnnotationDraftAt: applyAnnotationDraftAt,
        generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
        clearAnnotationDraft: clearAnnotationDraft,
        createAnalyticsEvent: createAnalyticsEvent
    });
};

});
parcelRegister("hDLz7", function(module, exports) {

$parcel$export(module.exports, "Mounter", () => $708ff088a2bb7e9b$export$2109cd350bcf6eda);

var $eUqFw = parcelRequire("eUqFw");

var $ht6w1 = parcelRequire("ht6w1");

var $5uTcm = parcelRequire("5uTcm");

var $6PJBT = parcelRequire("6PJBT");

var $auyn4 = parcelRequire("auyn4");

var $3y8r4 = parcelRequire("3y8r4");

var $hM6XC = parcelRequire("hM6XC");
const $708ff088a2bb7e9b$export$2109cd350bcf6eda = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo((props)=>{
    const { component: Component, range: range, isWithinRange: isWithinRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, clearAnnotationDraft: clearAnnotationDraft, applyAnnotationDraftAt: applyAnnotationDraftAt, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
    const [draftDocumentPosition, setDraftDocumentPosition] = (0, $eUqFw.useState)();
    const actions = (0, $eUqFw.useContext)((0, $3y8r4.RendererContext));
    const providers = (0, $eUqFw.useContext)((0, $hM6XC.ProvidersContext));
    const isCommentsOnMediaBugFixEnabled = Boolean(providers?.inlineComment.isCommentsOnMediaBugFixEnabled);
    const onCreateCallback = (0, $eUqFw.useCallback)((annotationId)=>{
        if (!isAnnotationAllowed || !documentPosition || !applyAnnotation) return false;
        const annotation = {
            annotationId: annotationId,
            annotationType: (0, $ht6w1.AnnotationTypes).INLINE_COMMENT
        };
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $auyn4.ACTION).INSERTED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {},
            eventType: (0, $auyn4.EVENT_TYPE).TRACK
        }).fire((0, $6PJBT.FabricChannel).editor);
        return applyAnnotation(draftDocumentPosition || documentPosition, annotation, isCommentsOnMediaBugFixEnabled);
    }, [
        isAnnotationAllowed,
        documentPosition,
        applyAnnotation,
        draftDocumentPosition,
        createAnalyticsEvent,
        isCommentsOnMediaBugFixEnabled
    ]);
    const createIndexCallback = (0, $eUqFw.useCallback)(()=>{
        if (!documentPosition || !generateIndexMatch) return false;
        const result = generateIndexMatch(documentPosition);
        if (!result) return false;
        return result;
    }, [
        documentPosition,
        generateIndexMatch
    ]);
    const applyDraftModeCallback = (0, $eUqFw.useCallback)((options)=>{
        if (!documentPosition || !isAnnotationAllowed) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $auyn4.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {},
                eventType: (0, $auyn4.EVENT_TYPE).TRACK
            }).fire((0, $6PJBT.FabricChannel).editor);
            return false;
        }
        setDraftDocumentPosition(documentPosition);
        applyAnnotationDraftAt(documentPosition);
        if (createAnalyticsEvent) {
            const uniqueAnnotationsInRange = actions.getAnnotationsByPosition(range);
            createAnalyticsEvent({
                action: (0, $auyn4.ACTION).OPENED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: uniqueAnnotationsInRange.length
                }
            }).fire((0, $6PJBT.FabricChannel).editor);
        }
        window.requestAnimationFrame(()=>{
            if (options.keepNativeSelection) (0, $5uTcm.updateWindowSelectionAroundDraft)(documentPosition);
            else {
                const sel = window.getSelection();
                if (sel) sel.removeAllRanges();
            }
        });
        const positionToAnnotate = draftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation || !options.annotationId) return false;
        const annotation = {
            annotationId: options.annotationId,
            annotationType: (0, $ht6w1.AnnotationTypes).INLINE_COMMENT
        };
        return applyAnnotation(positionToAnnotate, annotation, isCommentsOnMediaBugFixEnabled);
    }, [
        documentPosition,
        isAnnotationAllowed,
        applyAnnotationDraftAt,
        createAnalyticsEvent,
        applyAnnotation,
        draftDocumentPosition,
        isCommentsOnMediaBugFixEnabled,
        actions,
        range
    ]);
    const removeDraftModeCallback = (0, $eUqFw.useCallback)(()=>{
        clearAnnotationDraft();
        setDraftDocumentPosition(null);
        const sel = window.getSelection();
        if (sel) sel.removeAllRanges();
    }, [
        clearAnnotationDraft
    ]);
    const onCloseCallback = (0, $eUqFw.useCallback)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $auyn4.ACTION).CLOSED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $auyn4.EVENT_TYPE).TRACK,
            attributes: {}
        }).fire((0, $6PJBT.FabricChannel).editor);
        removeDraftModeCallback();
        onCloseProps();
    }, [
        onCloseProps,
        removeDraftModeCallback,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
        range: range,
        isWithinRange: isWithinRange,
        wrapperDOM: wrapperDOM.current,
        isAnnotationAllowed: isAnnotationAllowed,
        onClose: onCloseCallback,
        onCreate: onCreateCallback,
        getAnnotationIndexMatch: createIndexCallback,
        applyDraftMode: applyDraftModeCallback,
        removeDraftMode: removeDraftModeCallback
    });
});

});

parcelRegister("8BrGT", function(module, exports) {

$parcel$export(module.exports, "AnnotationRangeProvider", () => $6a56f8f8abc5dcf9$export$30384a6aedd19fee);
$parcel$export(module.exports, "useAnnotationRangeState", () => $6a56f8f8abc5dcf9$export$e07ee6d6cc95d9a0);
$parcel$export(module.exports, "useAnnotationRangeDispatch", () => $6a56f8f8abc5dcf9$export$708fc397e2b6f08d);

var $eUqFw = parcelRequire("eUqFw");
function $6a56f8f8abc5dcf9$var$reducer(state, action) {
    switch(action.type){
        case 'clear':
            if (!!state.range || !!state.type) return {
                range: null,
                draftRange: null,
                type: null
            };
            return state;
        case 'clearSelection':
            if (state.type === 'selection') return {
                ...state,
                range: null,
                type: null
            };
            return state;
        case 'clearDraftSelection':
            if (state.type === 'selection') return {
                ...state,
                draftRange: null
            };
            return state;
        case 'clearDraftHover':
            if (state.type === 'hover') return {
                ...state,
                draftRange: null
            };
            return state;
        case 'clearHover':
            if (state.type === 'hover') return {
                range: null,
                draftRange: null,
                type: null
            };
            return state;
        case 'setSelection':
            if (state.range !== action.range || state.type !== 'selection') return {
                ...state,
                range: action.range,
                type: 'selection'
            };
            return state;
        case 'setHover':
            if (state.range !== action.range || state.type !== 'hover') return {
                ...state,
                range: action.range,
                type: 'hover'
            };
            return state;
        case 'setDraftSelection':
            if (state.draftRange !== action.draftRange || state.type !== 'selection') return {
                range: null,
                draftRange: action.draftRange,
                type: null
            };
            return state;
        case 'setDraftHover':
            if (state.draftRange !== action.draftRange || state.type !== 'hover') return {
                ...state,
                draftRange: action.draftRange
            };
            return state;
    }
}
const $6a56f8f8abc5dcf9$export$145b9bb655c3d220 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    range: null,
    draftRange: null,
    type: null
});
const $6a56f8f8abc5dcf9$export$efb0d1c8cbaac647 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    clearRange: ()=>{},
    clearSelectionRange: ()=>{},
    clearDraftRange: ()=>{},
    clearHoverRange: ()=>{},
    setRange: ()=>{},
    setDraftRange: ()=>{}
});
const $6a56f8f8abc5dcf9$export$30384a6aedd19fee = ({ children: children, allowCommentsOnMedia: allowCommentsOnMedia })=>{
    const [{ range: range, draftRange: draftRange, type: type }, dispatch] = (0, $eUqFw.useReducer)($6a56f8f8abc5dcf9$var$reducer, {
        range: null,
        draftRange: null,
        type: null
    });
    const clearRange = (0, $eUqFw.useCallback)(()=>dispatch({
            type: 'clear'
        }), []);
    const clearSelectionRange = (0, $eUqFw.useCallback)(()=>dispatch({
            type: 'clearSelection'
        }), []);
    const clearDraftRange = (0, $eUqFw.useCallback)((type)=>{
        if (type === 'hover') {
            dispatch({
                type: 'clearDraftHover'
            });
            return;
        }
        dispatch({
            type: 'clearDraftSelection'
        });
    }, []);
    const clearHoverRange = (0, $eUqFw.useCallback)(()=>dispatch({
            type: 'clearHover'
        }), []);
    const setRange = (0, $eUqFw.useCallback)((range)=>dispatch({
            type: 'setSelection',
            range: range
        }), []);
    const setDraftRange = (0, $eUqFw.useCallback)((range, type)=>{
        if (type === 'hover') {
            dispatch({
                type: 'setDraftHover',
                draftRange: range
            });
            return;
        }
        dispatch({
            type: 'setDraftSelection',
            draftRange: range
        });
    }, []);
    const setHoverTarget = (0, $eUqFw.useCallback)((target)=>{
        // the HoverComponent expects an element deeply nested inside media, these classes work with the current implementation
        const mediaNode = target.querySelector('.media-card-inline-player, .media-file-card-view');
        const range = document.createRange();
        range.setStartBefore(mediaNode);
        range.setEndAfter(mediaNode);
        dispatch({
            type: 'setHover',
            range: range
        });
    }, []);
    const stateData = (0, $eUqFw.useMemo)(()=>({
            range: range,
            draftRange: draftRange,
            type: type
        }), [
        range,
        draftRange,
        type
    ]);
    const dispatchData = (0, $eUqFw.useMemo)(()=>({
            clearRange: clearRange,
            clearSelectionRange: clearSelectionRange,
            clearDraftRange: clearDraftRange,
            clearHoverRange: clearHoverRange,
            setRange: setRange,
            setDraftRange: setDraftRange,
            setHoverTarget: !!allowCommentsOnMedia ? setHoverTarget : undefined
        }), [
        allowCommentsOnMedia,
        clearRange,
        clearSelectionRange,
        clearDraftRange,
        clearHoverRange,
        setRange,
        setDraftRange,
        setHoverTarget
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6a56f8f8abc5dcf9$export$145b9bb655c3d220.Provider, {
        value: stateData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6a56f8f8abc5dcf9$export$efb0d1c8cbaac647.Provider, {
        value: dispatchData
    }, children));
};
const $6a56f8f8abc5dcf9$export$e07ee6d6cc95d9a0 = ()=>{
    return (0, $eUqFw.useContext)($6a56f8f8abc5dcf9$export$145b9bb655c3d220);
};
const $6a56f8f8abc5dcf9$export$708fc397e2b6f08d = ()=>{
    return (0, $eUqFw.useContext)($6a56f8f8abc5dcf9$export$efb0d1c8cbaac647);
};

});

parcelRegister("54EB5", function(module, exports) {

$parcel$export(module.exports, "AnnotationHoverContext", () => $50ccccfcb51e23a5$export$b3db0feb20552fc3);
$parcel$export(module.exports, "useAnnotationHoverContext", () => $50ccccfcb51e23a5$export$a02bfcbbbf920306);
$parcel$export(module.exports, "useAnnotationHoverDispatch", () => $50ccccfcb51e23a5$export$c288883964405c82);

var $eUqFw = parcelRequire("eUqFw");
const $50ccccfcb51e23a5$var$AnnotationHoverStateContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isWithinRange: false
});
const $50ccccfcb51e23a5$var$AnnotationHoverDispatchContext = /*#__PURE__*/ (0, $eUqFw.createContext)({
    cancelTimeout: ()=>{},
    initiateTimeout: ()=>{},
    setIsWithinRange: ()=>{}
});
const $50ccccfcb51e23a5$export$b3db0feb20552fc3 = ({ children: children })=>{
    const [isWithinRange, setIsWithinRange] = (0, $eUqFw.useState)(false);
    const timeoutHandler = (0, $eUqFw.useRef)();
    const cancelTimeout = (0, $eUqFw.useCallback)(()=>{
        if (timeoutHandler) clearTimeout(timeoutHandler.current);
    }, [
        timeoutHandler
    ]);
    const initiateTimeout = (0, $eUqFw.useCallback)(()=>{
        if (isWithinRange) timeoutHandler.current = setTimeout(()=>{
            setIsWithinRange(false);
        }, 500);
    }, [
        isWithinRange
    ]);
    const stateData = (0, $eUqFw.useMemo)(()=>({
            isWithinRange: isWithinRange
        }), [
        isWithinRange
    ]);
    const dispatchData = (0, $eUqFw.useMemo)(()=>({
            cancelTimeout: cancelTimeout,
            initiateTimeout: initiateTimeout,
            setIsWithinRange: setIsWithinRange
        }), [
        cancelTimeout,
        initiateTimeout,
        setIsWithinRange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($50ccccfcb51e23a5$var$AnnotationHoverStateContext.Provider, {
        value: stateData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($50ccccfcb51e23a5$var$AnnotationHoverDispatchContext.Provider, {
        value: dispatchData
    }, children));
};
const $50ccccfcb51e23a5$export$a02bfcbbbf920306 = ()=>{
    return (0, $eUqFw.useContext)($50ccccfcb51e23a5$var$AnnotationHoverStateContext);
};
const $50ccccfcb51e23a5$export$c288883964405c82 = ()=>{
    return (0, $eUqFw.useContext)($50ccccfcb51e23a5$var$AnnotationHoverDispatchContext);
};

});


parcelRegister("hqR1N", function(module, exports) {

$parcel$export(module.exports, "SelectionRangeValidator", () => $d18a26519cb817d7$export$74435b85e23b84d9);

var $eUqFw = parcelRequire("eUqFw");

var $gaT2d = parcelRequire("gaT2d");

var $gYemZ = parcelRequire("gYemZ");

var $3y8r4 = parcelRequire("3y8r4");

var $hM6XC = parcelRequire("hM6XC");
const $d18a26519cb817d7$export$74435b85e23b84d9 = (props)=>{
    const { selectionComponent: selectionComponent, rendererRef: rendererRef, applyAnnotationDraftAt: applyAnnotationDraftAt, clearAnnotationDraft: clearAnnotationDraft, createAnalyticsEvent: createAnalyticsEvent } = props;
    const actions = (0, $eUqFw.useContext)((0, $3y8r4.RendererContext));
    const [range, draftRange, clearRange] = (0, $gaT2d.useUserSelectionRange)({
        rendererRef: rendererRef
    });
    const providers = (0, $eUqFw.useContext)((0, $hM6XC.ProvidersContext));
    const isCommentsOnMediaBugFixEnabled = Boolean(providers?.inlineComment.isCommentsOnMediaBugFixEnabled);
    if (!range && !draftRange) return null;
    const documentPosition = actions.getPositionFromRange(range, isCommentsOnMediaBugFixEnabled);
    // This property is drilled down to consumers when a new range is selected to test it's validity
    let isAnnotationAllowedOnRange = false;
    try {
        isAnnotationAllowedOnRange = documentPosition && actions.isValidAnnotationPosition(documentPosition);
    } catch  {
        isAnnotationAllowedOnRange = false;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gYemZ.SelectionInlineCommentMounter), {
        range: range,
        draftRange: draftRange,
        wrapperDOM: rendererRef,
        component: selectionComponent,
        onClose: clearRange,
        documentPosition: documentPosition,
        isAnnotationAllowed: isAnnotationAllowedOnRange,
        applyAnnotation: actions.applyAnnotation.bind(actions),
        applyAnnotationDraftAt: applyAnnotationDraftAt,
        generateIndexMatch: actions.generateAnnotationIndexMatch.bind(actions),
        clearAnnotationDraft: clearAnnotationDraft,
        createAnalyticsEvent: createAnalyticsEvent
    });
};

});
parcelRegister("gaT2d", function(module, exports) {

$parcel$export(module.exports, "useUserSelectionRange", () => $2b9e605d251de5e6$export$47201332e612f5a4);

var $eUqFw = parcelRequire("eUqFw");

var $8BrGT = parcelRequire("8BrGT");

var $kCwjj = parcelRequire("kCwjj");
const $2b9e605d251de5e6$export$47201332e612f5a4 = (props)=>{
    const { rendererRef: { current: rendererDOM } } = props;
    const selectionTimeoutRef = (0, $eUqFw.useRef)();
    const { clearRange: clearRange, setRange: setRange } = (0, $8BrGT.useAnnotationRangeDispatch)();
    const { range: range, draftRange: draftRange, type: type } = (0, $8BrGT.useAnnotationRangeState)();
    (0, $eUqFw.useEffect)(()=>{
        if (!document || !rendererDOM) return;
        const onSelectionChange = (event)=>{
            if (selectionTimeoutRef.current) clearTimeout(selectionTimeoutRef.current);
            selectionTimeoutRef.current = setTimeout(()=>{
                const sel = document.getSelection();
                if (!sel || sel.type !== 'Range' || sel.rangeCount !== 1) return;
                const _range = sel.getRangeAt(0);
                if (rendererDOM && (0, $kCwjj.isRangeInsideOfRendererContainer)(rendererDOM, _range)) setRange(_range.cloneRange());
            }, 250);
        };
        document.addEventListener('selectionchange', onSelectionChange);
        return ()=>{
            document.removeEventListener('selectionchange', onSelectionChange);
            clearRange();
        };
    }, [
        rendererDOM,
        setRange,
        clearRange
    ]);
    return [
        type === 'selection' ? range : null,
        draftRange,
        clearRange
    ];
};

});
parcelRegister("kCwjj", function(module, exports) {

$parcel$export(module.exports, "isRangeInsideOfRendererContainer", () => $2cbbad4c943c0aad$export$90ee8f2d9317f430);
/** Exists in its own module to allow mocking in unit tests */ const $2cbbad4c943c0aad$export$90ee8f2d9317f430 = (rendererDOM, range)=>{
    const sourceRange = document.createRange();
    sourceRange.selectNode(rendererDOM);
    const isSelectionStartsAfterRenderer = range.compareBoundaryPoints(Range.START_TO_START, sourceRange) === 1;
    const isSelectionStartsBeforeRenderer = range.compareBoundaryPoints(Range.START_TO_END, sourceRange) === 1;
    const isSelectionEndsAfterRenderer = range.compareBoundaryPoints(Range.END_TO_END, sourceRange) === 1;
    return isSelectionStartsAfterRenderer && isSelectionStartsBeforeRenderer && !isSelectionEndsAfterRenderer;
};

});


parcelRegister("gYemZ", function(module, exports) {

$parcel$export(module.exports, "SelectionInlineCommentMounter", () => $13ebad160f9e33ff$export$ca7741472ed8ba00);

var $eUqFw = parcelRequire("eUqFw");

var $ht6w1 = parcelRequire("ht6w1");

var $XHGTv = parcelRequire("XHGTv");

var $5uTcm = parcelRequire("5uTcm");

var $6PJBT = parcelRequire("6PJBT");

var $auyn4 = parcelRequire("auyn4");

var $1sePJ = parcelRequire("1sePJ");

var $3y8r4 = parcelRequire("3y8r4");

var $hM6XC = parcelRequire("hM6XC");
const $13ebad160f9e33ff$export$ca7741472ed8ba00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo((props)=>{
    const { component: Component, range: range, draftRange: draftRange, isAnnotationAllowed: isAnnotationAllowed, wrapperDOM: wrapperDOM, onClose: onCloseProps, clearAnnotationDraft: clearAnnotationDraft, applyAnnotationDraftAt: applyAnnotationDraftAt, documentPosition: documentPosition, applyAnnotation: applyAnnotation, createAnalyticsEvent: createAnalyticsEvent, generateIndexMatch: generateIndexMatch } = props;
    const [draftDocumentPosition, setDraftDocumentPosition] = (0, $eUqFw.useState)();
    const actions = (0, $eUqFw.useContext)((0, $3y8r4.RendererContext));
    const providers = (0, $eUqFw.useContext)((0, $hM6XC.ProvidersContext));
    const isCommentsOnMediaBugFixEnabled = !!providers?.inlineComment.isCommentsOnMediaBugFixEnabled;
    const inlineNodeTypes = (0, $eUqFw.useMemo)(()=>{
        if (!(0, $XHGTv.fg)('platform.editor.allow-inline-comments-for-inline-nodes-round-2_ctuxz')) return undefined;
        if (actions.isValidAnnotationRange(range)) return (0, $1sePJ.getRendererRangeInlineNodeNames)({
            pos: documentPosition,
            actions: actions
        });
        else return undefined;
    }, [
        documentPosition,
        actions,
        range
    ]);
    const onCreateCallback = (0, $eUqFw.useCallback)((annotationId)=>{
        // We want to support creation on a documentPosition if the user is only using ranges
        // but we want to prioritize draft positions if they are being used by consumers
        const positionToAnnotate = draftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation) return false;
        // Evaluate position validity when the user commits the position to be annotated
        const isCreateAllowedOnPosition = actions.isValidAnnotationPosition(positionToAnnotate);
        if (!isCreateAllowedOnPosition) return false;
        const annotation = {
            annotationId: annotationId,
            annotationType: (0, $ht6w1.AnnotationTypes).INLINE_COMMENT
        };
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $auyn4.ACTION).INSERTED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).INLINE_COMMENT,
            attributes: {
                inlineNodeNames: inlineNodeTypes
            },
            eventType: (0, $auyn4.EVENT_TYPE).TRACK
        }).fire((0, $6PJBT.FabricChannel).editor);
        return applyAnnotation(positionToAnnotate, annotation, isCommentsOnMediaBugFixEnabled);
    }, [
        actions,
        documentPosition,
        applyAnnotation,
        draftDocumentPosition,
        createAnalyticsEvent,
        isCommentsOnMediaBugFixEnabled,
        inlineNodeTypes
    ]);
    const createIndexCallback = (0, $eUqFw.useCallback)(()=>{
        if (!documentPosition || !generateIndexMatch) return false;
        const result = generateIndexMatch(documentPosition);
        if (!result) return false;
        return result;
    }, [
        documentPosition,
        generateIndexMatch
    ]);
    const applyDraftModeCallback = (0, $eUqFw.useCallback)((options)=>{
        if (!documentPosition || !isAnnotationAllowed) {
            if (createAnalyticsEvent) createAnalyticsEvent({
                action: (0, $auyn4.ACTION).CREATE_NOT_ALLOWED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).INLINE_COMMENT,
                attributes: {
                    inlineNodeNames: inlineNodeTypes
                },
                eventType: (0, $auyn4.EVENT_TYPE).TRACK
            }).fire((0, $6PJBT.FabricChannel).editor);
            return false;
        }
        setDraftDocumentPosition(documentPosition);
        applyAnnotationDraftAt(documentPosition);
        if (createAnalyticsEvent) {
            const uniqueAnnotationsInRange = range ? actions.getAnnotationsByPosition(range) : [];
            createAnalyticsEvent({
                action: (0, $auyn4.ACTION).OPENED,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).ANNOTATION,
                actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).INLINE_COMMENT,
                eventType: (0, $auyn4.EVENT_TYPE).TRACK,
                attributes: {
                    overlap: uniqueAnnotationsInRange.length,
                    inlineNodeNames: inlineNodeTypes
                }
            }).fire((0, $6PJBT.FabricChannel).editor);
        }
        window.requestAnimationFrame(()=>{
            if (options.keepNativeSelection) (0, $5uTcm.updateWindowSelectionAroundDraft)(documentPosition);
            else {
                const sel = window.getSelection();
                if (sel) sel.removeAllRanges();
            }
        });
        const positionToAnnotate = draftDocumentPosition || documentPosition;
        if (!positionToAnnotate || !applyAnnotation || !options.annotationId) return false;
        const annotation = {
            annotationId: options.annotationId,
            annotationType: (0, $ht6w1.AnnotationTypes).INLINE_COMMENT
        };
        return applyAnnotation(positionToAnnotate, annotation, isCommentsOnMediaBugFixEnabled);
    }, [
        documentPosition,
        isAnnotationAllowed,
        applyAnnotationDraftAt,
        createAnalyticsEvent,
        applyAnnotation,
        draftDocumentPosition,
        isCommentsOnMediaBugFixEnabled,
        actions,
        range,
        inlineNodeTypes
    ]);
    const removeDraftModeCallback = (0, $eUqFw.useCallback)(()=>{
        clearAnnotationDraft();
        setDraftDocumentPosition(null);
        const sel = window.getSelection();
        if (sel) sel.removeAllRanges();
    }, [
        clearAnnotationDraft
    ]);
    const onCloseCallback = (0, $eUqFw.useCallback)(()=>{
        if (createAnalyticsEvent) createAnalyticsEvent({
            action: (0, $auyn4.ACTION).CLOSED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).ANNOTATION,
            actionSubjectId: (0, $auyn4.ACTION_SUBJECT_ID).INLINE_COMMENT,
            eventType: (0, $auyn4.EVENT_TYPE).TRACK,
            attributes: {
                inlineNodeNames: inlineNodeTypes
            }
        }).fire((0, $6PJBT.FabricChannel).editor);
        removeDraftModeCallback();
        onCloseProps();
    }, [
        onCloseProps,
        removeDraftModeCallback,
        createAnalyticsEvent,
        inlineNodeTypes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
        range: range,
        draftRange: draftRange,
        wrapperDOM: wrapperDOM.current,
        isAnnotationAllowed: isAnnotationAllowed,
        onClose: onCloseCallback,
        onCreate: onCreateCallback,
        getAnnotationIndexMatch: createIndexCallback,
        applyDraftMode: applyDraftModeCallback,
        removeDraftMode: removeDraftModeCallback,
        inlineNodeTypes: inlineNodeTypes
    });
});

});



parcelRegister("hHQQe", function(module, exports) {

$parcel$export(module.exports, "useLoadAnnotations", () => $8bee4875a94416f4$export$39f7c1a861a0d41c);

var $eUqFw = parcelRequire("eUqFw");

var $3DXMd = parcelRequire("3DXMd");

var $hM6XC = parcelRequire("hM6XC");

var $3y8r4 = parcelRequire("3y8r4");
const $8bee4875a94416f4$export$39f7c1a861a0d41c = ({ adfDocument: adfDocument, isNestedRender: isNestedRender })=>{
    const actions = (0, $eUqFw.useContext)((0, $3y8r4.RendererContext));
    const providers = (0, $eUqFw.useContext)((0, $hM6XC.ProvidersContext));
    (0, $eUqFw.useEffect)(()=>{
        if (!providers) return;
        const { inlineComment: { getState: inlineCommentGetState, updateSubscriber: updateSubscriberInlineComment } } = providers;
        const annotations = actions.getAnnotationMarks();
        // we don't want to request integrators for state with an empty list of ids.
        if (!annotations.length) return;
        const ids = annotations.map((mark)=>mark.attrs.id);
        const cb = (data)=>{
            if (!updateSubscriberInlineComment) return;
            const payload = data.reduce((acc, value)=>({
                    ...acc,
                    [value.id]: value
                }), {});
            updateSubscriberInlineComment.emit((0, $3DXMd.AnnotationUpdateEvent).SET_ANNOTATION_STATE, payload);
        };
        inlineCommentGetState(ids, isNestedRender).then(cb);
    }, [
        actions,
        providers,
        adfDocument,
        isNestedRender
    ]);
};

});


parcelRegister("irna0", function(module, exports) {

$parcel$export(module.exports, "isInteractiveElement", () => $b7527acbcef6bdce$export$3dee5e4542c672d9);


function $b7527acbcef6bdce$export$3dee5e4542c672d9(element) {
    if ('href' in element && element.href != null) return true;
    if (element.classList.contains((0, $d493a7c9cb0c9147$export$42c8d07e41ed1e74))) return true;
    if (element.classList.contains((0, $bab13eb90e97354a$export$7a6526d4be3b7eb3))) return true;
    return false;
}

});
const $bab13eb90e97354a$export$7a6526d4be3b7eb3 = 'media-file-card-view';
const $bab13eb90e97354a$export$1b2a6cb6a124ba37 = 'media-file-card-view-selected';

/**
 * Classname for the media viewer popup that appears adjacent to the editor div. Use this to check
 * if the media viewer has appeared.
 */ const $d493a7c9cb0c9147$export$42c8d07e41ed1e74 = 'media-viewer-popup';


parcelRegister("jgiTL", function(module, exports) {

$parcel$export(module.exports, "RenderTracking", () => $98ba299cac70cc92$export$fe16de086fea1f5f);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $hvU79 = parcelRequire("hvU79");

var $auyn4 = parcelRequire("auyn4");
function $98ba299cac70cc92$export$fe16de086fea1f5f(props) {
    const debouncedHandleAnalyticsEvent = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(props.handleAnalyticsEvent, 500), [
        props.handleAnalyticsEvent
    ]);
    (0, $hvU79.useComponentRenderTracking)({
        onRender: ({ renderCount: renderCount, propsDifference: propsDifference, componentId: componentId })=>{
            if (!renderCount) return;
            debouncedHandleAnalyticsEvent({
                action: props.action,
                actionSubject: props.actionSubject,
                attributes: {
                    count: renderCount,
                    propsDifference: propsDifference,
                    componentId: componentId
                },
                eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
            });
        },
        propsDiffingOptions: {
            enabled: true,
            props: props.componentProps,
            propsToIgnore: props.propsToIgnore,
            useShallow: props.useShallow
        },
        zeroBasedCount: true
    });
    return null;
}

});
parcelRegister("hvU79", function(module, exports) {

$parcel$export(module.exports, "useComponentRenderTracking", () => $e22106f086fac2c0$export$ebce6d7d8ca67353);

var $eUqFw = parcelRequire("eUqFw");

var $lUXsh = parcelRequire("lUXsh");

var $5z3Na = parcelRequire("5z3Na");
function $e22106f086fac2c0$export$ebce6d7d8ca67353({ onRender: onRender, propsDiffingOptions: propsDiffingOptions, zeroBasedCount: zeroBasedCount = true }) {
    const propsRef = (0, $eUqFw.useRef)();
    const renderCountRef = (0, $eUqFw.useRef)(zeroBasedCount ? 0 : 1);
    const { current: componentId } = (0, $eUqFw.useRef)((0, $lUXsh.uuid).generate());
    (0, $eUqFw.useEffect)(()=>{
        const lastProps = propsRef.current;
        const renderCount = renderCountRef.current;
        let propsDifference;
        if (propsDiffingOptions?.enabled && lastProps) propsDifference = propsDiffingOptions?.useShallow ? (0, $5z3Na.getShallowPropsDifference)(lastProps, propsDiffingOptions.props) : (0, $5z3Na.getPropsDifference)(lastProps, propsDiffingOptions.props, 0, 2, propsDiffingOptions?.propsToIgnore);
        const result = {
            renderCount: renderCount,
            propsDifference: propsDifference,
            componentId: componentId
        };
        onRender(result);
        if (propsDiffingOptions?.enabled) propsRef.current = propsDiffingOptions.props;
        renderCountRef.current = renderCountRef.current + 1;
    }); // No dependencies run on each render
}

});
parcelRegister("5z3Na", function(module, exports) {

$parcel$export(module.exports, "getPropsDifference", () => $703624ece0dd9f93$export$d438af18e3a25d10);
$parcel$export(module.exports, "getShallowPropsDifference", () => $703624ece0dd9f93$export$418b0a935c0a0030);

var $eUqFw = parcelRequire("eUqFw");
const $703624ece0dd9f93$export$74743eda5dda3ccf = Object.keys;
const $703624ece0dd9f93$export$aedd1a2d18cbf42b = (object1, object2)=>{
    const oldKeys = object1 !== null ? $703624ece0dd9f93$export$74743eda5dda3ccf(object1) : [];
    const newKeys = object2 !== null ? $703624ece0dd9f93$export$74743eda5dda3ccf(object2) : [];
    const removed = oldKeys.filter((key)=>!newKeys.includes(key));
    const added = newKeys.filter((key)=>!oldKeys.includes(key));
    const common = oldKeys.filter((key)=>newKeys.includes(key));
    return {
        added: added,
        common: common,
        removed: removed
    };
};
const $703624ece0dd9f93$export$f4c1dafc9df1f03 = (value)=>{
    const valueType = typeof value;
    if (value === null) return 'null';
    else if (value === undefined) return 'undefined';
    else if (valueType === 'string' || valueType === 'number') return value;
    else if (valueType === 'symbol') return value.toString();
    else if (valueType === 'function') return `function:${value.name}`;
    else if (valueType === 'object') return {
        type: 'object',
        keys: Object.keys(value)
    };
};
const $703624ece0dd9f93$export$d438af18e3a25d10 = (object1, object2, curDepth = 0, maxDepth = 2, keysToIgnore = [])=>{
    const { added: added, common: common, removed: removed } = $703624ece0dd9f93$export$aedd1a2d18cbf42b(object1, object2);
    const changed = [];
    common.forEach((key)=>{
        const value1 = object1[key];
        const value2 = object2[key];
        const value1Type = typeof value1;
        const value2Type = typeof value2;
        // Do comparision only if values doesn't match (or reference to same object in memory).
        // Or if key does not exist in keys to ignore.
        if (value1 !== value2 && keysToIgnore.indexOf(key) === -1) {
            // if both key value are objects and not referencing same object in memory.
            //  then get recursive difference.
            if ((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(value1) || (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(value2)) changed.push({
                key: key,
                reactElementChanged: true
            });
            else if (value1Type === 'object' && value2Type === 'object') {
                if (curDepth <= maxDepth) {
                    const difference = $703624ece0dd9f93$export$d438af18e3a25d10(value1, value2, curDepth + 1, maxDepth);
                    changed.push({
                        key: key,
                        difference: difference
                    });
                } else changed.push({
                    key: key,
                    maxDepthReached: true
                });
            } else changed.push({
                key: key,
                oldValue: $703624ece0dd9f93$export$f4c1dafc9df1f03(value1),
                newValue: $703624ece0dd9f93$export$f4c1dafc9df1f03(value2)
            });
        }
    });
    return {
        added: added,
        changed: changed,
        removed: removed
    };
};
const $703624ece0dd9f93$export$418b0a935c0a0030 = (object1, object2)=>{
    const { added: added, common: common, removed: removed } = $703624ece0dd9f93$export$aedd1a2d18cbf42b(object1, object2);
    const changed = common.filter((key)=>object1[key] !== object2[key]);
    return {
        added: added,
        changed: changed,
        removed: removed
    };
};

});



parcelRegister("528fV", function(module, exports) {

$parcel$export(module.exports, "EditorMediaClientProvider", () => $6634d5910495a92e$export$77218b6ff680865f);

var $eUqFw = parcelRequire("eUqFw");

var $kJ7yF = parcelRequire("kJ7yF");

var $eQbJA = parcelRequire("eQbJA");
const $6634d5910495a92e$export$77218b6ff680865f = ({ children: children, ssr: ssr })=>{
    const [mediaClientConfig, setMediaClientConfig] = (0, $eUqFw.useState)();
    const mediaProvider = (0, $eQbJA.useProvider)('mediaProvider');
    /**
	 * If a mediaClientConfig is provided then we will force
	 * skip the mediaClient from context
	 */ const shouldSkipContext = Boolean(ssr?.config || mediaProvider);
    const contextMediaClient = (0, $eUqFw.useContext)((0, $kJ7yF.MediaClientContext));
    // MediaClientProvider currently requires a mediaClientConfig
    // And inserting the MediaClientProvider will cause a re-render
    // We should use MediaClientProvider once it no longer requires a config
    const mediaClient = (0, $eUqFw.useMemo)(()=>mediaClientConfig ? (0, $kJ7yF.getMediaClient)(mediaClientConfig) : undefined, [
        mediaClientConfig
    ]);
    // Consumers can override the mediaClient for renderer,
    // by not providing both SSR config and mediaProvider,
    // and provide a top level mediaClient context
    // This is useful for testing and creating examples.
    (0, $eUqFw.useEffect)(()=>{
        if (ssr?.config) setMediaClientConfig(ssr.config);
        else if (mediaProvider) mediaProvider.then((provider)=>{
            setMediaClientConfig(provider.viewMediaClientConfig);
        });
    }, [
        mediaProvider,
        ssr
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJ7yF.MediaClientContext).Provider, {
        value: shouldSkipContext ? mediaClient : contextMediaClient
    }, children);
};

});
parcelRegister("kJ7yF", function(module, exports) {

$parcel$export(module.exports, "MediaClientContext", () => $2a63c6834b952386$export$ba5d7212f2b4619f);
$parcel$export(module.exports, "getMediaClient", () => $2a63c6834b952386$export$c9ecbc1b719fd417);
$parcel$export(module.exports, "MediaClientProvider", () => $2a63c6834b952386$export$5bff351c86f56d97);
$parcel$export(module.exports, "useMediaClient", () => $2a63c6834b952386$export$8b3e87ea56c3a345);

var $eUqFw = parcelRequire("eUqFw");

var $go0co = parcelRequire("go0co");
const $2a63c6834b952386$export$ba5d7212f2b4619f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(undefined);
const $2a63c6834b952386$var$mediaClientsMap = new Map();
const $2a63c6834b952386$export$c9ecbc1b719fd417 = (mediaClientConfig)=>{
    // The Provider defines mediaClientConfig as required,
    // but integrators may skip it when using Media Card to display external images
    // i.e. a Media Client is not needed.
    // An empty mediaClientConfig object `{}` won't fall into this case,
    // but that case is handled internally by Media Client.
    if (!mediaClientConfig) return new (0, $go0co.MediaClient)({
        authProvider: ()=>Promise.resolve({
                clientId: '',
                token: '',
                baseUrl: ''
            })
    });
    let mediaClient = $2a63c6834b952386$var$mediaClientsMap.get(mediaClientConfig);
    if (!mediaClient) {
        mediaClient = new (0, $go0co.MediaClient)(mediaClientConfig);
        $2a63c6834b952386$var$mediaClientsMap.set(mediaClientConfig, mediaClient);
    }
    return mediaClient;
};
const $2a63c6834b952386$export$5bff351c86f56d97 = ({ children: children, clientConfig: clientConfig })=>{
    const mediaClient = (0, $eUqFw.useMemo)(()=>$2a63c6834b952386$export$c9ecbc1b719fd417(clientConfig), [
        clientConfig
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2a63c6834b952386$export$ba5d7212f2b4619f.Provider, {
        value: mediaClient
    }, children);
};
const $2a63c6834b952386$export$8b3e87ea56c3a345 = ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext($2a63c6834b952386$export$ba5d7212f2b4619f);
    if (!mediaClient) throw new Error('No MediaClient set, use MediaClientProvider to set one');
    return mediaClient;
};

});
parcelRegister("go0co", function(module, exports) {

$parcel$export(module.exports, "MediaClient", () => $53af8e7882f0f992$export$fba8b4ca6d386aec);

var $4FH8r = parcelRequire("4FH8r");
parcelRequire("2q7Xj");
var $fmEc3 = parcelRequire("fmEc3");

var $EEZOU = parcelRequire("EEZOU");

var $3ixzU = parcelRequire("3ixzU");

var $eJAUz = parcelRequire("eJAUz");
parcelRequire("gHZqD");
var $exlxT = parcelRequire("exlxT");

class $53af8e7882f0f992$export$fba8b4ca6d386aec {
    constructor(mediaClientConfig, store = (0, $exlxT.mediaStore), mediaApi){
        this.mediaClientConfig = mediaClientConfig;
        this.store = store;
        this.mediaStore = mediaApi ?? new (0, $EEZOU.MediaStore)({
            authProvider: mediaClientConfig.authProvider,
            initialAuth: mediaClientConfig.initialAuth,
            chunkHashAlgorithm: mediaClientConfig.useSha256ForUploads ? (0, $fmEc3.ChunkHashAlgorithm).Sha256 : (0, $fmEc3.ChunkHashAlgorithm).Sha1
        });
        this.config = mediaClientConfig;
        this.file = new (0, $3ixzU.FileFetcherImpl)(this.mediaStore, this.store);
        this.eventEmitter = new (0, $4FH8r.EventEmitter2)();
        this.stargate = new (0, $eJAUz.StargateClient)(mediaClientConfig.stargateBaseUrl);
    }
    /**
	 * @internal
	 */ __DO_NOT_USE__getMediaStore() {
        return this.store;
    }
    getImage(id, params, controller, fetchMaxRes, traceContext) {
        return this.mediaStore.getImage(id, params, controller, fetchMaxRes, traceContext);
    }
    getImageUrl(id, params) {
        return this.mediaStore.getFileImageURL(id, params);
    }
    getImageUrlSync(id, params) {
        return this.mediaStore.getFileImageURLSync(id, params);
    }
    async getImageMetadata(id, params) {
        return (await this.mediaStore.getImageMetadata(id, params)).metadata;
    }
    async mobileUploadPromise() {
        if (this.mobileUpload) return this.mobileUpload;
        const module = await (parcelRequire("jSRlT"));
        this.mobileUpload = new module.MobileUploadImpl(this.mediaStore, this.store);
        return this.mobileUpload;
    }
    async removeFileFromCollection(id, collectionName, occurrenceKey, traceContext) {
        await this.mediaStore.removeCollectionFile(id, collectionName, occurrenceKey, traceContext);
    }
    on(event, listener) {
        this.eventEmitter.on(event, listener);
    }
    off(event, listener) {
        this.eventEmitter.off(event, listener);
    }
    emit(event, payload) {
        return this.eventEmitter.emit(event, payload);
    }
}

});
parcelRegister("4FH8r", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
!function(undefined) {
    var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    var defaultMaxListeners = 10;
    function init() {
        this._events = {};
        if (this._conf) configure.call(this, this._conf);
    }
    function configure(conf) {
        if (conf) {
            this._conf = conf;
            conf.delimiter && (this.delimiter = conf.delimiter);
            this._maxListeners = conf.maxListeners !== undefined ? conf.maxListeners : defaultMaxListeners;
            conf.wildcard && (this.wildcard = conf.wildcard);
            conf.newListener && (this.newListener = conf.newListener);
            conf.verboseMemoryLeak && (this.verboseMemoryLeak = conf.verboseMemoryLeak);
            if (this.wildcard) this.listenerTree = {};
        } else this._maxListeners = defaultMaxListeners;
    }
    function logPossibleMemoryLeak(count, eventName) {
        var errorMsg = "(node) warning: possible EventEmitter memory leak detected. " + count + ' listeners added. ' + 'Use emitter.setMaxListeners() to increase limit.';
        if (this.verboseMemoryLeak) errorMsg += ' Event name: ' + eventName + '.';
        if (typeof $2fFJv !== 'undefined' && $2fFJv.emitWarning) {
            var e = new Error(errorMsg);
            e.name = 'MaxListenersExceededWarning';
            e.emitter = this;
            e.count = count;
            $2fFJv.emitWarning(e);
        } else {
            console.error(errorMsg);
            if (console.trace) console.trace();
        }
    }
    function EventEmitter(conf) {
        this._events = {};
        this.newListener = false;
        this.verboseMemoryLeak = false;
        configure.call(this, conf);
    }
    EventEmitter.EventEmitter2 = EventEmitter; // backwards compatibility for exporting EventEmitter property
    //
    // Attention, function return type now is array, always !
    // It has zero elements if no any matches found and one or more
    // elements (leafs) if there are matches
    //
    function searchListenerTree(handlers, type, tree, i) {
        if (!tree) return [];
        var listeners = [], leaf, len, branch, xTree, xxTree, isolatedBranch, endReached, typeLength = type.length, currentType = type[i], nextType = type[i + 1];
        if (i === typeLength && tree._listeners) {
            //
            // If at the end of the event(s) list and the tree has listeners
            // invoke those listeners.
            //
            if (typeof tree._listeners === 'function') {
                handlers && handlers.push(tree._listeners);
                return [
                    tree
                ];
            } else {
                for(leaf = 0, len = tree._listeners.length; leaf < len; leaf++)handlers && handlers.push(tree._listeners[leaf]);
                return [
                    tree
                ];
            }
        }
        if (currentType === '*' || currentType === '**' || tree[currentType]) {
            //
            // If the event emitted is '*' at this part
            // or there is a concrete match at this patch
            //
            if (currentType === '*') {
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 1));
                return listeners;
            } else if (currentType === '**') {
                endReached = i + 1 === typeLength || i + 2 === typeLength && nextType === '*';
                if (endReached && tree._listeners) // The next element has a _listeners, add it to the handlers.
                listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
                for(branch in tree)if (branch !== '_listeners' && tree.hasOwnProperty(branch)) {
                    if (branch === '*' || branch === '**') {
                        if (tree[branch]._listeners && !endReached) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
                        listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                    } else if (branch === nextType) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 2));
                    else // No match on this one, shift into the tree but not in the type array.
                    listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                }
                return listeners;
            }
            listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i + 1));
        }
        xTree = tree['*'];
        if (xTree) //
        // If the listener tree will allow any match for this part,
        // then recursively explore all branches of the tree
        //
        searchListenerTree(handlers, type, xTree, i + 1);
        xxTree = tree['**'];
        if (xxTree) {
            if (i < typeLength) {
                if (xxTree._listeners) // If we have a listener on a '**', it will catch all, so add its handler.
                searchListenerTree(handlers, type, xxTree, typeLength);
                // Build arrays of matching next branches and others.
                for(branch in xxTree)if (branch !== '_listeners' && xxTree.hasOwnProperty(branch)) {
                    if (branch === nextType) // We know the next element will match, so jump twice.
                    searchListenerTree(handlers, type, xxTree[branch], i + 2);
                    else if (branch === currentType) // Current node matches, move into the tree.
                    searchListenerTree(handlers, type, xxTree[branch], i + 1);
                    else {
                        isolatedBranch = {};
                        isolatedBranch[branch] = xxTree[branch];
                        searchListenerTree(handlers, type, {
                            '**': isolatedBranch
                        }, i + 1);
                    }
                }
            } else if (xxTree._listeners) // We have reached the end and still on a '**'
            searchListenerTree(handlers, type, xxTree, typeLength);
            else if (xxTree['*'] && xxTree['*']._listeners) searchListenerTree(handlers, type, xxTree['*'], typeLength);
        }
        return listeners;
    }
    function growListenerTree(type, listener) {
        type = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
        //
        // Looks for two consecutive '**', if so, don't add the event at all.
        //
        for(var i = 0, len = type.length; i + 1 < len; i++){
            if (type[i] === '**' && type[i + 1] === '**') return;
        }
        var tree = this.listenerTree;
        var name = type.shift();
        while(name !== undefined){
            if (!tree[name]) tree[name] = {};
            tree = tree[name];
            if (type.length === 0) {
                if (!tree._listeners) tree._listeners = listener;
                else {
                    if (typeof tree._listeners === 'function') tree._listeners = [
                        tree._listeners
                    ];
                    tree._listeners.push(listener);
                    if (!tree._listeners.warned && this._maxListeners > 0 && tree._listeners.length > this._maxListeners) {
                        tree._listeners.warned = true;
                        logPossibleMemoryLeak.call(this, tree._listeners.length, name);
                    }
                }
                return true;
            }
            name = type.shift();
        }
        return true;
    }
    // By default EventEmitters will print a warning if more than
    // 10 listeners are added to it. This is a useful default which
    // helps finding memory leaks.
    //
    // Obviously not all Emitters should be limited to 10. This function allows
    // that to be increased. Set to zero for unlimited.
    EventEmitter.prototype.delimiter = '.';
    EventEmitter.prototype.setMaxListeners = function(n) {
        if (n !== undefined) {
            this._maxListeners = n;
            if (!this._conf) this._conf = {};
            this._conf.maxListeners = n;
        }
    };
    EventEmitter.prototype.event = '';
    EventEmitter.prototype.once = function(event, fn) {
        return this._once(event, fn, false);
    };
    EventEmitter.prototype.prependOnceListener = function(event, fn) {
        return this._once(event, fn, true);
    };
    EventEmitter.prototype._once = function(event, fn, prepend) {
        this._many(event, 1, fn, prepend);
        return this;
    };
    EventEmitter.prototype.many = function(event, ttl, fn) {
        return this._many(event, ttl, fn, false);
    };
    EventEmitter.prototype.prependMany = function(event, ttl, fn) {
        return this._many(event, ttl, fn, true);
    };
    EventEmitter.prototype._many = function(event, ttl, fn, prepend) {
        var self = this;
        if (typeof fn !== 'function') throw new Error('many only accepts instances of Function');
        function listener() {
            if (--ttl === 0) self.off(event, listener);
            return fn.apply(this, arguments);
        }
        listener._origin = fn;
        this._on(event, listener, prepend);
        return self;
    };
    EventEmitter.prototype.emit = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return false;
        }
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all && this._all.length) {
            handler = this._all.slice();
            if (al > 3) {
                args = new Array(al);
                for(j = 0; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this, type);
                        break;
                    case 2:
                        handler[i].call(this, type, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, type, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else {
            handler = this._events[type];
            if (typeof handler === 'function') {
                this.event = type;
                switch(al){
                    case 1:
                        handler.call(this);
                        break;
                    case 2:
                        handler.call(this, arguments[1]);
                        break;
                    case 3:
                        handler.call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        args = new Array(al - 1);
                        for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                        handler.apply(this, args);
                }
                return true;
            } else if (handler) // need to make copy of handlers because list can change in the middle
            // of emit call
            handler = handler.slice();
        }
        if (handler && handler.length) {
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this);
                        break;
                    case 2:
                        handler[i].call(this, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
            return true;
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) throw arguments[1]; // Unhandled 'error' event
            else throw new Error("Uncaught, unspecified 'error' event.");
            return false;
        }
        return !!this._all;
    };
    EventEmitter.prototype.emitAsync = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === 'newListener' && !this.newListener) {
            if (!this._events.newListener) return Promise.resolve([
                false
            ]);
        }
        var promises = [];
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all) {
            if (al > 3) {
                args = new Array(al);
                for(j = 1; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = this._all.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(this._all[i].call(this, type));
                        break;
                    case 2:
                        promises.push(this._all[i].call(this, type, arguments[1]));
                        break;
                    case 3:
                        promises.push(this._all[i].call(this, type, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(this._all[i].apply(this, args));
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else handler = this._events[type];
        if (typeof handler === 'function') {
            this.event = type;
            switch(al){
                case 1:
                    promises.push(handler.call(this));
                    break;
                case 2:
                    promises.push(handler.call(this, arguments[1]));
                    break;
                case 3:
                    promises.push(handler.call(this, arguments[1], arguments[2]));
                    break;
                default:
                    args = new Array(al - 1);
                    for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                    promises.push(handler.apply(this, args));
            }
        } else if (handler && handler.length) {
            handler = handler.slice();
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(handler[i].call(this));
                        break;
                    case 2:
                        promises.push(handler[i].call(this, arguments[1]));
                        break;
                    case 3:
                        promises.push(handler[i].call(this, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(handler[i].apply(this, args));
                }
            }
        } else if (!this._all && type === 'error') {
            if (arguments[1] instanceof Error) return Promise.reject(arguments[1]); // Unhandled 'error' event
            else return Promise.reject("Uncaught, unspecified 'error' event.");
        }
        return Promise.all(promises);
    };
    EventEmitter.prototype.on = function(type, listener) {
        return this._on(type, listener, false);
    };
    EventEmitter.prototype.prependListener = function(type, listener) {
        return this._on(type, listener, true);
    };
    EventEmitter.prototype.onAny = function(fn) {
        return this._onAny(fn, false);
    };
    EventEmitter.prototype.prependAny = function(fn) {
        return this._onAny(fn, true);
    };
    EventEmitter.prototype.addListener = EventEmitter.prototype.on;
    EventEmitter.prototype._onAny = function(fn, prepend) {
        if (typeof fn !== 'function') throw new Error('onAny only accepts instances of Function');
        if (!this._all) this._all = [];
        // Add the function to the event listener collection.
        if (prepend) this._all.unshift(fn);
        else this._all.push(fn);
        return this;
    };
    EventEmitter.prototype._on = function(type, listener, prepend) {
        if (typeof type === 'function') {
            this._onAny(type, listener);
            return this;
        }
        if (typeof listener !== 'function') throw new Error('on only accepts instances of Function');
        this._events || init.call(this);
        // To avoid recursion in the case that type == "newListeners"! Before
        // adding it to the listeners, first emit "newListeners".
        this.emit('newListener', type, listener);
        if (this.wildcard) {
            growListenerTree.call(this, type, listener);
            return this;
        }
        if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
        this._events[type] = listener;
        else {
            if (typeof this._events[type] === 'function') // Change to array.
            this._events[type] = [
                this._events[type]
            ];
            // If we've already got an array, just add
            if (prepend) this._events[type].unshift(listener);
            else this._events[type].push(listener);
            // Check for listener leak
            if (!this._events[type].warned && this._maxListeners > 0 && this._events[type].length > this._maxListeners) {
                this._events[type].warned = true;
                logPossibleMemoryLeak.call(this, this._events[type].length, type);
            }
        }
        return this;
    };
    EventEmitter.prototype.off = function(type, listener) {
        if (typeof listener !== 'function') throw new Error('removeListener only takes instances of Function');
        var handlers, leafs = [];
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
        } else {
            // does not use listeners(), so no side effect of creating _events[type]
            if (!this._events[type]) return this;
            handlers = this._events[type];
            leafs.push({
                _listeners: handlers
            });
        }
        for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
            var leaf = leafs[iLeaf];
            handlers = leaf._listeners;
            if (isArray(handlers)) {
                var position = -1;
                for(var i = 0, length = handlers.length; i < length; i++)if (handlers[i] === listener || handlers[i].listener && handlers[i].listener === listener || handlers[i]._origin && handlers[i]._origin === listener) {
                    position = i;
                    break;
                }
                if (position < 0) continue;
                if (this.wildcard) leaf._listeners.splice(position, 1);
                else this._events[type].splice(position, 1);
                if (handlers.length === 0) {
                    if (this.wildcard) delete leaf._listeners;
                    else delete this._events[type];
                }
                this.emit("removeListener", type, listener);
                return this;
            } else if (handlers === listener || handlers.listener && handlers.listener === listener || handlers._origin && handlers._origin === listener) {
                if (this.wildcard) delete leaf._listeners;
                else delete this._events[type];
                this.emit("removeListener", type, listener);
            }
        }
        function recursivelyGarbageCollect(root) {
            if (root === undefined) return;
            var keys = Object.keys(root);
            for(var i in keys){
                var key = keys[i];
                var obj = root[key];
                if (obj instanceof Function || typeof obj !== "object" || obj === null) continue;
                if (Object.keys(obj).length > 0) recursivelyGarbageCollect(root[key]);
                if (Object.keys(obj).length === 0) delete root[key];
            }
        }
        recursivelyGarbageCollect(this.listenerTree);
        return this;
    };
    EventEmitter.prototype.offAny = function(fn) {
        var i = 0, l = 0, fns;
        if (fn && this._all && this._all.length > 0) {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)if (fn === fns[i]) {
                fns.splice(i, 1);
                this.emit("removeListenerAny", fn);
                return this;
            }
        } else {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)this.emit("removeListenerAny", fns[i]);
            this._all = [];
        }
        return this;
    };
    EventEmitter.prototype.removeListener = EventEmitter.prototype.off;
    EventEmitter.prototype.removeAllListeners = function(type) {
        if (arguments.length === 0) {
            !this._events || init.call(this);
            return this;
        }
        if (this.wildcard) {
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
            for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
                var leaf = leafs[iLeaf];
                leaf._listeners = null;
            }
        } else if (this._events) this._events[type] = null;
        return this;
    };
    EventEmitter.prototype.listeners = function(type) {
        if (this.wildcard) {
            var handlers = [];
            var ns = typeof type === 'string' ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
            return handlers;
        }
        this._events || init.call(this);
        if (!this._events[type]) this._events[type] = [];
        if (!isArray(this._events[type])) this._events[type] = [
            this._events[type]
        ];
        return this._events[type];
    };
    EventEmitter.prototype.eventNames = function() {
        return Object.keys(this._events);
    };
    EventEmitter.prototype.listenerCount = function(type) {
        return this.listeners(type).length;
    };
    EventEmitter.prototype.listenersAny = function() {
        if (this._all) return this._all;
        else return [];
    };
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define(function() {
        return EventEmitter;
    });
    else // CommonJS
    module.exports = EventEmitter;
}();

});

parcelRegister("2q7Xj", function(module, exports) {

$parcel$export(module.exports, "mediaState", () => (parcelRequire("iE8r2")).mediaState);
$parcel$export(module.exports, "isClientBasedAuth", () => (parcelRequire("jrFS0")).isClientBasedAuth);
$parcel$export(module.exports, "authToOwner", () => (parcelRequire("jrFS0")).authToOwner);
$parcel$export(module.exports, "ChunkHashAlgorithm", () => (parcelRequire("fmEc3")).ChunkHashAlgorithm);
// WARNING! DO NOTE MOVE THIS EXPORT!
// mediaState should be exported BEFORE StreamsCache import later because
// StreamsCache will try to import mediaState from here.

var $iE8r2 = parcelRequire("iE8r2");

var $jrFS0 = parcelRequire("jrFS0");

var $fmEc3 = parcelRequire("fmEc3");

});
parcelRegister("iE8r2", function(module, exports) {

$parcel$export(module.exports, "mediaState", () => $4cdeb32efb36e469$export$8cef61637918b288);

var $4FH8r = parcelRequire("4FH8r");

var $6roQF = parcelRequire("6roQF");
const $4cdeb32efb36e469$export$8cef61637918b288 = {
    streams: new (0, $6roQF.LRUMap)(1000),
    stateDeferreds: new Map(),
    eventEmitter: new (0, $4FH8r.EventEmitter2)()
};

});

parcelRegister("jrFS0", function(module, exports) {

$parcel$export(module.exports, "isClientBasedAuth", () => $a5c9edcfc78df537$export$6ba49fcac9c46e54);
$parcel$export(module.exports, "authToOwner", () => $a5c9edcfc78df537$export$17f6055767a8d96a);
function $a5c9edcfc78df537$export$6ba49fcac9c46e54(auth) {
    return !!auth.clientId;
}
function $a5c9edcfc78df537$export$af1ab14f2246ef72(auth) {
    return !!auth.asapIssuer;
}
const $a5c9edcfc78df537$export$17f6055767a8d96a = (auth)=>{
    if ($a5c9edcfc78df537$export$af1ab14f2246ef72(auth)) return auth;
    const clientAuth = {
        id: auth.clientId,
        baseUrl: auth.baseUrl,
        token: auth.token
    };
    return clientAuth;
};

});

parcelRegister("fmEc3", function(module, exports) {

$parcel$export(module.exports, "ChunkHashAlgorithm", () => $2714010903136296$export$d3e73a50cc549c2e);
var $2714010903136296$export$d3e73a50cc549c2e;
(function(ChunkHashAlgorithm) {
    ChunkHashAlgorithm["Sha1"] = "sha1";
    ChunkHashAlgorithm["Sha256"] = "sha256";
})($2714010903136296$export$d3e73a50cc549c2e || ($2714010903136296$export$d3e73a50cc549c2e = {}));

});


parcelRegister("EEZOU", function(module, exports) {

$parcel$export(module.exports, "MediaStore", () => $1e7feef2970a1c0d$export$572b8a2a9fd7cbba);
$parcel$export(module.exports, "getMediaEnvironment", () => $1e7feef2970a1c0d$export$c8b741e18397852a);
$parcel$export(module.exports, "getMediaRegion", () => $1e7feef2970a1c0d$export$20f9315304dd6726);

var $5Cq8b = parcelRequire("5Cq8b");

var $aFsdc = parcelRequire("aFsdc");

var $4M5UY = parcelRequire("4M5UY");

var $5AvHR = parcelRequire("5AvHR");

var $2WGjX = parcelRequire("2WGjX");

var $bvZYv = parcelRequire("bvZYv");
parcelRequire("2q7Xj");
var $fmEc3 = parcelRequire("fmEc3");

var $XHGTv = parcelRequire("XHGTv");
const $1e7feef2970a1c0d$var$MEDIA_API_REGION = 'media-api-region';
const $1e7feef2970a1c0d$var$MEDIA_API_ENVIRONMENT = 'media-api-environment';
const $1e7feef2970a1c0d$var$extendImageParams = (params, fetchMaxRes = false)=>{
    return {
        ...params,
        'max-age': params?.['max-age'] ?? (0, $aFsdc.FILE_CACHE_MAX_AGE),
        allowAnimated: params?.allowAnimated ?? true,
        mode: params?.mode ?? 'crop',
        ...fetchMaxRes ? {
            width: (0, $aFsdc.MAX_RESOLUTION),
            height: (0, $aFsdc.MAX_RESOLUTION)
        } : {}
    };
};
const $1e7feef2970a1c0d$var$jsonHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
};
class $1e7feef2970a1c0d$export$572b8a2a9fd7cbba {
    constructor(config){
        this.config = config;
        this.resolveAuth = (authContext)=>(0, $bvZYv.resolveAuth)(this.config.authProvider, authContext);
        this.resolveInitialAuth = ()=>(0, $bvZYv.resolveInitialAuth)(this.config.initialAuth);
        this._chunkHashAlgorithm = config.chunkHashAlgorithm || (0, $fmEc3.ChunkHashAlgorithm).Sha1;
    }
    async removeCollectionFile(id, collectionName, occurrenceKey, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/collection/{collectionName}'
        };
        const body = {
            actions: [
                {
                    action: 'remove',
                    item: {
                        type: 'file',
                        id: id,
                        occurrenceKey: occurrenceKey
                    }
                }
            ]
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/collection/${collectionName}`, options);
    }
    createUpload(createUpTo = 1, collectionName, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            params: {
                createUpTo: createUpTo,
                hashAlgorithm: this._chunkHashAlgorithm
            },
            headers: {
                Accept: 'application/json'
            },
            traceContext: traceContext
        };
        return this.request(`/upload`, options).then((0, $2WGjX.createMapResponseToJson)(metadata));
    }
    async uploadChunk(etag, blob, uploadId, partNumber, collectionName, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/chunk/{etag}'
        };
        const options = {
            ...metadata,
            params: {
                uploadId: uploadId,
                partNumber: partNumber
            },
            authContext: {
                collectionName: collectionName
            },
            body: blob,
            traceContext: traceContext
        };
        await this.request(`/chunk/${etag}`, options);
    }
    createFileFromUpload(body, params = {}, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/upload'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $1e7feef2970a1c0d$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        return this.request('/file/upload', options).then((0, $2WGjX.createMapResponseToJson)(metadata));
    }
    getRejectedResponseFromDescriptor(descriptor, limit) {
        return {
            fileId: descriptor.fileId,
            error: {
                code: 'ExceedMaxFileSizeLimit',
                title: 'The expected file size exceeded the maximum size limit.',
                href: 'https://dt-api-filestore--app.ap-southeast-2.dev.atl-paas.net/api.html#BadRequest',
                limit: limit,
                size: descriptor.size
            }
        };
    }
    async touchFiles(body, params = {}, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/upload/createWithFiles'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            headers: $1e7feef2970a1c0d$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext,
            params: {
                hashAlgorithm: this._chunkHashAlgorithm
            }
        };
        return this.request('/upload/createWithFiles', options).then((0, $2WGjX.createMapResponseToJson)(metadata));
    }
    getFile(fileId, params = {}, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${fileId}`, options).then((0, $2WGjX.createMapResponseToJson)(metadata));
    }
    async getFileImageURL(id, params) {
        const { collection: collectionName } = params || {};
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        return this.createFileImageURL(id, auth, params);
    }
    // TODO Create ticket in case Trace Id can be supported through query params
    getFileImageURLSync(id, params) {
        const auth = this.resolveInitialAuth();
        return this.createFileImageURL(id, auth, params);
    }
    createFileImageURL(id, auth, params) {
        const options = {
            params: $1e7feef2970a1c0d$var$extendImageParams(params),
            auth: auth
        };
        const imageEndpoint = (0, $XHGTv.getBooleanFF)('platform.media-cdn-delivery') ? 'image/cdn' : 'image';
        return (0, $2WGjX.createUrl)(`${auth.baseUrl}/file/${id}/${imageEndpoint}`, options);
    }
    async getFileBinary(id, collectionName, maxAge = (0, $aFsdc.FILE_CACHE_MAX_AGE)) {
        const headers = {};
        const binaryEndpoint = (0, $XHGTv.getBooleanFF)('platform.media-cdn-delivery') ? 'binary/cdn' : 'binary';
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/${binaryEndpoint}`
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: headers,
            params: {
                collection: collectionName,
                'max-age': `${maxAge}`
            }
        };
        return this.request(`/file/${id}/${binaryEndpoint}`, options).then((0, $2WGjX.createMapResponseToBlob)(metadata));
    }
    async getFileBinaryURL(id, collectionName, maxAge = (0, $aFsdc.FILE_CACHE_MAX_AGE)) {
        const auth = await this.resolveAuth({
            collectionName: collectionName
        });
        const options = {
            params: {
                dl: true,
                collection: collectionName,
                'max-age': maxAge
            },
            auth: auth
        };
        const binaryEndpoint = (0, $XHGTv.getBooleanFF)('platform.media-cdn-delivery') ? 'binary/cdn' : 'binary';
        return (0, $2WGjX.createUrl)(`${auth.baseUrl}/file/${id}/${binaryEndpoint}`, options);
    }
    async getArtifactURL(artifacts, artifactName, collectionName) {
        const artifactUrl = (0, $4M5UY.getArtifactUrl)(artifacts, artifactName);
        if (!artifactUrl) throw new Error(`artifact ${artifactName} not found`);
        const auth = !artifactUrl.includes('media-cdn') ? await this.resolveAuth({
            collectionName: collectionName
        }) : undefined;
        const options = {
            params: {
                collection: collectionName,
                'max-age': (0, $aFsdc.FILE_CACHE_MAX_AGE)
            },
            auth: auth
        };
        return (0, $2WGjX.createUrl)(artifactUrl, options);
    }
    async getImage(id, params, controller, fetchMaxRes, traceContext) {
        // TODO add checkWebpSupport() back https://product-fabric.atlassian.net/browse/MPT-584
        const isWebpSupported = false;
        const headers = {};
        if (isWebpSupported) headers.accept = 'image/webp,image/*,*/*;q=0.8';
        const imageEndpoint = (0, $XHGTv.getBooleanFF)('platform.media-cdn-delivery') ? 'image/cdn' : 'image';
        const metadata = {
            method: 'GET',
            endpoint: `/file/{fileId}/${imageEndpoint}`
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params && params.collection
            },
            params: $1e7feef2970a1c0d$var$extendImageParams(params, fetchMaxRes),
            headers: headers,
            traceContext: traceContext
        };
        return this.request(`/file/${id}/${imageEndpoint}`, options, controller).then((0, $2WGjX.createMapResponseToBlob)(metadata));
    }
    async getItems(ids, collectionName, traceContext) {
        const descriptors = ids.map((id)=>({
                type: 'file',
                id: id,
                collection: collectionName
            }));
        const metadata = {
            method: 'POST',
            endpoint: '/items'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: $1e7feef2970a1c0d$var$jsonHeaders,
            body: JSON.stringify({
                descriptors: descriptors
            }),
            traceContext: traceContext
        };
        return this.request('/items', options).then((0, $2WGjX.createMapResponseToJson)(metadata));
    }
    async getImageMetadata(id, params, traceContext) {
        const metadata = {
            method: 'GET',
            endpoint: '/file/{fileId}/image/metadata'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params && params.collection
            },
            params: params,
            traceContext: traceContext
        };
        return this.request(`/file/${id}/image/metadata`, options).then((0, $2WGjX.createMapResponseToJson)(metadata));
    }
    async appendChunksToUpload(uploadId, body, collectionName, traceContext) {
        const metadata = {
            method: 'PUT',
            endpoint: '/upload/{uploadId}/chunks'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: collectionName
            },
            headers: $1e7feef2970a1c0d$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        await this.request(`/upload/${uploadId}/chunks`, options);
    }
    copyFileWithToken(body, params, traceContext) {
        const metadata = {
            method: 'POST',
            endpoint: '/file/copy/withToken'
        };
        const options = {
            ...metadata,
            authContext: {
                collectionName: params.collection
            },
            params: params,
            headers: $1e7feef2970a1c0d$var$jsonHeaders,
            body: JSON.stringify(body),
            traceContext: traceContext
        };
        return this.request('/file/copy/withToken', options).then((0, $2WGjX.createMapResponseToJson)(metadata));
    }
    async request(path, options = {
        method: 'GET',
        endpoint: undefined,
        authContext: {}
    }, controller) {
        const { method: method, endpoint: endpoint, authContext: authContext, params: params, headers: headers, body: body, clientOptions: clientOptions, traceContext: traceContext } = options;
        const auth = await this.resolveAuth(authContext);
        const extendedTraceContext = traceContext ? {
            ...traceContext,
            spanId: traceContext?.spanId || (0, $5Cq8b.getRandomHex)(8)
        } : undefined;
        const response = await (0, $5AvHR.request)(`${auth.baseUrl}${path}`, {
            method: method,
            endpoint: endpoint,
            auth: auth,
            params: params,
            headers: headers,
            body: body,
            clientOptions: clientOptions,
            traceContext: extendedTraceContext
        }, controller);
        $1e7feef2970a1c0d$var$setKeyValueInSessionStorage($1e7feef2970a1c0d$var$MEDIA_API_REGION, response.headers.get('x-media-region'));
        $1e7feef2970a1c0d$var$setKeyValueInSessionStorage($1e7feef2970a1c0d$var$MEDIA_API_ENVIRONMENT, response.headers.get('x-media-env'));
        return response;
    }
    get chunkHashAlgorithm() {
        return this._chunkHashAlgorithm;
    }
}
const $1e7feef2970a1c0d$var$getValueFromSessionStorage = (key)=>{
    return window && window.sessionStorage && window.sessionStorage.getItem(key) || undefined;
};
const $1e7feef2970a1c0d$var$setKeyValueInSessionStorage = (key, value)=>{
    if (!value || !(window && window.sessionStorage)) return;
    const currentValue = window.sessionStorage.getItem(key);
    if (currentValue !== value) window.sessionStorage.setItem(key, value);
};
const $1e7feef2970a1c0d$export$c8b741e18397852a = ()=>{
    return $1e7feef2970a1c0d$var$getValueFromSessionStorage($1e7feef2970a1c0d$var$MEDIA_API_ENVIRONMENT);
};
const $1e7feef2970a1c0d$export$20f9315304dd6726 = ()=>{
    return $1e7feef2970a1c0d$var$getValueFromSessionStorage($1e7feef2970a1c0d$var$MEDIA_API_REGION);
};

});
parcelRegister("5Cq8b", function(module, exports) {

$parcel$export(module.exports, "isUndefined", () => $b1f5fb9992743b46$export$fce6876652108ab);
$parcel$export(module.exports, "omitBy", () => $b1f5fb9992743b46$export$d7a617dda645b4e3);
$parcel$export(module.exports, "getRandomHex", () => $b1f5fb9992743b46$export$456b25e3a9b4a843);
const $b1f5fb9992743b46$export$fce6876652108ab = (value)=>value === undefined;
const $b1f5fb9992743b46$export$357523c63a2253b9 = (obj, keys = [])=>{
    if (obj === undefined) return {};
    return Object.fromEntries(Object.entries(obj).filter(([k])=>keys.includes(k)));
};
const $b1f5fb9992743b46$export$d7a617dda645b4e3 = (obj, predicate)=>Object.fromEntries(Object.entries(obj).filter(([, v])=>!predicate(v)));
const $b1f5fb9992743b46$export$61fc7d43ac8f84b0 = (func, wait)=>{
    let timeout;
    return (...args)=>{
        clearTimeout(timeout);
        timeout = setTimeout(()=>func(...args), wait);
    };
};
const $b1f5fb9992743b46$export$de994efd351b291c = (srcObj)=>{
    return (obj)=>{
        let key;
        for(key in srcObj){
            if (obj[key] === undefined || obj[key] !== srcObj[key]) return false;
        }
        return true;
    };
};
function $b1f5fb9992743b46$var$getRandomHexValues(byte) {
    return [
        ...Array(byte * 2)
    ].map(()=>Math.floor(Math.random() * 16).toString(16)).join('');
}
function $b1f5fb9992743b46$export$456b25e3a9b4a843(byte) {
    let randomHex;
    if (window?.crypto) try {
        randomHex = Array.from(window.crypto.getRandomValues(new Uint8Array(byte))).map((b)=>b.toString(16).padStart(2, '0')).join('');
    } catch (e) {
        randomHex = $b1f5fb9992743b46$var$getRandomHexValues(byte);
    }
    else randomHex = $b1f5fb9992743b46$var$getRandomHexValues(byte);
    return randomHex;
}

});

parcelRegister("aFsdc", function(module, exports) {

$parcel$export(module.exports, "RECENTS_COLLECTION", () => $8452033603633a1a$export$860a16125e30000b);
$parcel$export(module.exports, "FILE_CACHE_MAX_AGE", () => $8452033603633a1a$export$bd6e8fe09a90927b);
$parcel$export(module.exports, "MAX_RESOLUTION", () => $8452033603633a1a$export$6e70f30e392bc53f);
$parcel$export(module.exports, "CHUNK_SIZE", () => $8452033603633a1a$export$c1abb8bab1e615cd);
$parcel$export(module.exports, "PROCESSING_BATCH_SIZE", () => $8452033603633a1a$export$3d5157f0def70e54);
$parcel$export(module.exports, "MAX_UPLOAD_FILE_SIZE", () => $8452033603633a1a$export$f14f521f3d306044);

var $bYwuj = parcelRequire("bYwuj");
const $8452033603633a1a$export$860a16125e30000b = 'recents';
const $8452033603633a1a$export$bd6e8fe09a90927b = 2592000; // Retain for 30 days
const $8452033603633a1a$export$6e70f30e392bc53f = 4096;
const $8452033603633a1a$export$c1abb8bab1e615cd = 5 * (0, $bYwuj.DATA_UNIT).MB;
const $8452033603633a1a$export$3d5157f0def70e54 = 1000;
const $8452033603633a1a$export$f14f521f3d306044 = 2 * (0, $bYwuj.DATA_UNIT).TB;

});
parcelRegister("bYwuj", function(module, exports) {

$parcel$export(module.exports, "isPreviewableType", () => $e9c15b08e9162a33$export$350ede7b7a6acf99);
$parcel$export(module.exports, "DATA_UNIT", () => $e9c15b08e9162a33$export$76cfea4c354af843);
const $e9c15b08e9162a33$export$350ede7b7a6acf99 = (type)=>{
    const defaultPreviewableTypes = [
        'audio',
        'video',
        'image',
        'doc'
    ];
    return defaultPreviewableTypes.indexOf(type) > -1;
};
var $e9c15b08e9162a33$export$76cfea4c354af843;
(function(DATA_UNIT) {
    DATA_UNIT[DATA_UNIT["MB"] = 1048576] = "MB";
    DATA_UNIT[DATA_UNIT["GB"] = 1073741824] = "GB";
    DATA_UNIT[DATA_UNIT["TB"] = 1099511627776] = "TB";
})($e9c15b08e9162a33$export$76cfea4c354af843 || ($e9c15b08e9162a33$export$76cfea4c354af843 = {}));

});


parcelRegister("4M5UY", function(module, exports) {

$parcel$export(module.exports, "getArtifactUrl", () => $d9f7ddb4d1f162b2$export$1cc24defa44e7f84);

var $XHGTv = parcelRequire("XHGTv");
const $d9f7ddb4d1f162b2$export$1cc24defa44e7f84 = (artifacts, prop)=>{
    if ((0, $XHGTv.getBooleanFF)('platform.media-cdn-delivery')) return artifacts[prop]?.cdnUrl || artifacts[prop]?.url;
    return artifacts[prop]?.url;
};

});

parcelRegister("5AvHR", function(module, exports) {

$parcel$export(module.exports, "request", () => $4a84a560f69f3535$export$b5fe3f66a567bec0);

var $7aQon = parcelRequire("7aQon");

var $2WGjX = parcelRequire("2WGjX");
async function $4a84a560f69f3535$export$b5fe3f66a567bec0(url, options = {}, controller) {
    const { method: method = 'GET', endpoint: endpoint, auth: auth, params: params, headers: headers, body: body, clientOptions: clientOptions = {}, traceContext: traceContext } = options;
    const { retryOptions: retryOptions } = clientOptions;
    const metadata = {
        method: method,
        endpoint: endpoint,
        traceContext: traceContext
    };
    // TODO BMPT-918: add client timeout feature behing a FF (using clientOptions.clientTimeout + Promise.race)
    const doFetch = ()=>fetch((0, $2WGjX.createUrl)(url, {
            params: params
        }), {
            method: method,
            body: body,
            headers: (0, $2WGjX.extendHeaders)(headers, auth, traceContext),
            signal: controller && controller.signal
        }).then((0, $2WGjX.createProcessFetchResponse)(metadata));
    return (0, $2WGjX.fetchRetry)(doFetch, metadata, retryOptions);
}

});
parcelRegister("7aQon", function(module, exports) {

$parcel$export(module.exports, "RequestError", () => $9c115d8974651e85$export$43ee7d0e4f429743);
$parcel$export(module.exports, "isRequestError", () => $9c115d8974651e85$export$3717b1ffef4428ea);

var $6bBrC = parcelRequire("6bBrC");
class $9c115d8974651e85$export$43ee7d0e4f429743 extends (0, $6bBrC.BaseMediaClientError) {
    constructor(reason, metadata, innerError){
        super(reason);
        this.reason = reason;
        this.metadata = metadata;
        this.innerError = innerError;
    }
    get attributes() {
        const { reason: reason, metadata: { method: method, endpoint: endpoint, mediaRegion: mediaRegion, mediaEnv: mediaEnv, attempts: attempts, clientExhaustedRetries: clientExhaustedRetries, statusCode: statusCode } = {}, innerError: innerError } = this;
        return {
            reason: reason,
            method: method,
            endpoint: endpoint,
            mediaRegion: mediaRegion,
            mediaEnv: mediaEnv,
            attempts: attempts,
            clientExhaustedRetries: clientExhaustedRetries,
            statusCode: statusCode,
            innerError: innerError
        };
    }
}
function $9c115d8974651e85$export$3717b1ffef4428ea(err) {
    return err instanceof $9c115d8974651e85$export$43ee7d0e4f429743;
}

});
parcelRegister("6bBrC", function(module, exports) {

$parcel$export(module.exports, "BaseMediaClientError", () => $acff2c6dc8396dfc$export$2b0aca14d61c3190);

var $eKK8L = parcelRequire("eKK8L");
class $acff2c6dc8396dfc$export$2b0aca14d61c3190 extends Error {
    constructor(message){
        super(message);
        this.message = message;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}

});
parcelRegister("eKK8L", function(module, exports) {

$parcel$export(module.exports, "isMediaClientError", () => $11f35e187e1f2fdf$export$2491e0bbdb59256e);
$parcel$export(module.exports, "getMediaClientErrorReason", () => $11f35e187e1f2fdf$export$c15d72765ee2baa4);
function $11f35e187e1f2fdf$export$2491e0bbdb59256e(error) {
    return error instanceof Object && 'attributes' in error && error.attributes instanceof Object && 'reason' in error.attributes && error instanceof Error;
}
function $11f35e187e1f2fdf$export$c15d72765ee2baa4(err) {
    return $11f35e187e1f2fdf$export$2491e0bbdb59256e(err) ? err.attributes.reason : 'unknown';
}

});



parcelRegister("2WGjX", function(module, exports) {

$parcel$export(module.exports, "isRateLimitedError", () => $6c6863351bba029c$export$bc96a6a479480590);
$parcel$export(module.exports, "createUrl", () => $6c6863351bba029c$export$7138c24907de3954);
$parcel$export(module.exports, "extendHeaders", () => $6c6863351bba029c$export$18cfbabc415d771c);
$parcel$export(module.exports, "createMapResponseToJson", () => $6c6863351bba029c$export$e0519b126b73efa6);
$parcel$export(module.exports, "createMapResponseToBlob", () => $6c6863351bba029c$export$5cc7b0795397da86);
$parcel$export(module.exports, "fetchRetry", () => $6c6863351bba029c$export$782df2acbe10b22c);
$parcel$export(module.exports, "createRequestErrorReason", () => $6c6863351bba029c$export$6397609af718d008);
$parcel$export(module.exports, "createProcessFetchResponse", () => $6c6863351bba029c$export$6e2e477edb7d6032);
parcelRequire("2q7Xj");
var $jrFS0 = parcelRequire("jrFS0");

var $hFyZ6 = parcelRequire("hFyZ6");

var $7aQon = parcelRequire("7aQon");
function $6c6863351bba029c$export$80c51ea1e89203dd(timeout) {
    return new Promise((resolve)=>setTimeout(resolve, timeout));
}
function $6c6863351bba029c$export$de0b576cf7ce4a53(err) {
    return err instanceof Error && err.message === 'request_cancelled' || !!err && err.name === 'AbortError';
}
function $6c6863351bba029c$export$ad8c5cf7dd4c3caf(err) {
    return err instanceof TypeError;
}
function $6c6863351bba029c$export$bc96a6a479480590(error) {
    return !!error && (0, $7aQon.isRequestError)(error) && error.attributes.statusCode === 429 || !!error && !!error.message && error.message.includes('429');
}
const $6c6863351bba029c$export$922566b90d0535ce = {
    traceId: 'x-b3-traceid',
    spanId: 'x-b3-spanid',
    parentSpanId: 'x-b3-parentspanid',
    sampled: 'x-b3-sampled',
    flags: 'x-b3-flags'
};
const $6c6863351bba029c$var$mapTraceIdToRequestHeaders = (traceContext)=>{
    return traceContext ? {
        [$6c6863351bba029c$export$922566b90d0535ce.traceId]: traceContext.traceId,
        [$6c6863351bba029c$export$922566b90d0535ce.spanId]: traceContext.spanId
    } : {};
};
function $6c6863351bba029c$export$eaf4479116d2f925(auth) {
    if (!auth) return {};
    if ((0, $jrFS0.isClientBasedAuth)(auth)) return {
        'X-Client-Id': auth.clientId,
        Authorization: `Bearer ${auth.token}`
    };
    return {
        'X-Issuer': auth.asapIssuer,
        Authorization: `Bearer ${auth.token}`
    };
}
function $6c6863351bba029c$export$7138c24907de3954(url, { params: params, auth: auth }) {
    const parsedUrl = new URL(url, auth?.baseUrl);
    const authParams = auth && (0, $hFyZ6.mapAuthToQueryParameters)(auth) || {};
    const paramsToAppend = {
        ...params,
        ...authParams
    };
    Object.entries(paramsToAppend).filter(([_, value])=>value != null).forEach((pair)=>{
        parsedUrl.searchParams.append(...pair);
    });
    parsedUrl.searchParams.sort();
    return parsedUrl.toString();
}
function $6c6863351bba029c$export$18cfbabc415d771c(headers, auth, traceContext) {
    if (!auth && !traceContext && !headers) return undefined;
    return {
        ...headers ?? {},
        ...$6c6863351bba029c$export$eaf4479116d2f925(auth),
        ...$6c6863351bba029c$var$mapTraceIdToRequestHeaders(traceContext)
    };
}
function $6c6863351bba029c$export$e0519b126b73efa6(metadata) {
    return async (response)=>{
        try {
            return await response.json();
        } catch (err) {
            throw new (0, $7aQon.RequestError)('serverInvalidBody', {
                ...metadata,
                ...$6c6863351bba029c$export$ea175c0c5497224(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}
function $6c6863351bba029c$export$5cc7b0795397da86(metadata) {
    return async (response)=>{
        try {
            return await response.blob();
        } catch (err) {
            throw new (0, $7aQon.RequestError)('serverInvalidBody', {
                ...metadata,
                ...$6c6863351bba029c$export$ea175c0c5497224(response),
                statusCode: response.status
            }, err instanceof Error ? err : undefined);
        }
    };
}
const $6c6863351bba029c$export$c65cfa70960d8fe5 = {
    startTimeoutInMs: 1000,
    maxAttempts: 5,
    factor: 2
};
function $6c6863351bba029c$export$359f19ca51f9eba1(error, extraMetadata) {
    const { reason: reason, metadata: metadata, innerError: innerError } = error;
    return new (0, $7aQon.RequestError)(reason, {
        ...metadata,
        ...extraMetadata
    }, innerError);
}
async function $6c6863351bba029c$export$782df2acbe10b22c(functionToRetry, metadata, overwriteOptions = {}) {
    const options = {
        ...$6c6863351bba029c$export$c65cfa70960d8fe5,
        ...overwriteOptions
    };
    const { startTimeoutInMs: startTimeoutInMs, maxAttempts: maxAttempts, factor: factor } = options;
    let attempts = 0;
    let timeoutInMs = startTimeoutInMs;
    let lastError;
    const waitAndBumpTimeout = async ()=>{
        await $6c6863351bba029c$export$80c51ea1e89203dd(timeoutInMs);
        timeoutInMs *= factor;
        attempts += 1;
    };
    while(attempts < maxAttempts)try {
        return await functionToRetry();
    } catch (err) {
        lastError = err;
        // don't retry if request was aborted by user
        if ($6c6863351bba029c$export$de0b576cf7ce4a53(err)) throw new (0, $7aQon.RequestError)('clientAbortedRequest', metadata, err);
        if (!$6c6863351bba029c$export$ad8c5cf7dd4c3caf(err) && !(0, $7aQon.isRequestError)(err) || (0, $7aQon.isRequestError)(err) && (!err.metadata || !err.metadata.statusCode || err.metadata.statusCode < 500)) throw err;
        await waitAndBumpTimeout();
    }
    if ((0, $7aQon.isRequestError)(lastError)) throw $6c6863351bba029c$export$359f19ca51f9eba1(lastError, {
        attempts: attempts,
        clientExhaustedRetries: true
    });
    throw new (0, $7aQon.RequestError)('serverUnexpectedError', {
        ...metadata,
        attempts: attempts,
        clientExhaustedRetries: true
    }, lastError);
}
function $6c6863351bba029c$export$6397609af718d008(statusCode) {
    switch(statusCode){
        case 400:
            return 'serverBadRequest';
        case 401:
            return 'serverUnauthorized';
        case 403:
            return 'serverForbidden';
        case 404:
            return 'serverNotFound';
        case 429:
            return 'serverRateLimited';
        case 500:
            return 'serverInternalError';
        case 502:
            return 'serverBadGateway';
        default:
            return 'serverUnexpectedError';
    }
}
function $6c6863351bba029c$export$d171f49f6b4ddc33(metadata, response) {
    const { status: statusCode } = response;
    const reason = $6c6863351bba029c$export$6397609af718d008(statusCode);
    return new (0, $7aQon.RequestError)(reason, {
        ...metadata,
        ...$6c6863351bba029c$export$ea175c0c5497224(response),
        statusCode: statusCode
    });
}
function $6c6863351bba029c$export$6e2e477edb7d6032(metadata) {
    return (response)=>{
        if (response.ok || response.status < 400) return response;
        const requestError = $6c6863351bba029c$export$d171f49f6b4ddc33(metadata, response);
        throw requestError;
    };
}
function $6c6863351bba029c$export$ea175c0c5497224(response) {
    const { headers: headers } = response;
    const mediaRegion = headers.get('x-media-region') || 'unknown';
    const mediaEnv = headers.get('x-media-env') || 'unknown';
    return {
        mediaRegion: mediaRegion,
        mediaEnv: mediaEnv
    };
}

});
parcelRegister("hFyZ6", function(module, exports) {

$parcel$export(module.exports, "mapAuthToQueryParameters", () => $032b1e5883aca6a7$export$6833b130611df767);
parcelRequire("2q7Xj");
var $jrFS0 = parcelRequire("jrFS0");
function $032b1e5883aca6a7$export$6833b130611df767(auth) {
    if ((0, $jrFS0.isClientBasedAuth)(auth)) return {
        client: auth.clientId,
        token: auth.token
    };
    else return {
        issuer: auth.asapIssuer,
        token: auth.token
    };
}

});



parcelRegister("bvZYv", function(module, exports) {

$parcel$export(module.exports, "resolveAuth", () => $9dc00fbb50183c87$export$4b4cec3dcdfce972);
$parcel$export(module.exports, "resolveInitialAuth", () => $9dc00fbb50183c87$export$5211e1371264aec3);

var $89khs = parcelRequire("89khs");

var $aSVFn = parcelRequire("aSVFn");
const $9dc00fbb50183c87$export$560085fe411c0660 = 10000;
const $9dc00fbb50183c87$export$4b4cec3dcdfce972 = async (authProvider, authContext, authProviderTimeout = $9dc00fbb50183c87$export$560085fe411c0660)=>{
    let auth;
    try {
        auth = await Promise.race([
            authProvider(authContext),
            (0, $aSVFn.rejectTimeout)(authProviderTimeout, new (0, $89khs.MediaStoreError)('authProviderTimedOut'))
        ]);
    } catch (err) {
        if (err instanceof (0, $89khs.MediaStoreError)) throw err;
        throw new (0, $89khs.MediaStoreError)('failedAuthProvider', err instanceof Error ? err : undefined);
    }
    if (!auth) throw new (0, $89khs.MediaStoreError)('emptyAuth');
    /*
    We added a token expiration check here in the past, and then we had to revert due to edge cases in the client that we can't control.
    Token expiration check in the frontend is a bad idea. Don't do it!
    More info:
    https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/13080
    https://gist.github.com/timvisee/fcda9bbdff88d45cc9061606b4b923ca
  */ return auth;
};
const $9dc00fbb50183c87$export$5211e1371264aec3 = (auth)=>{
    if (!auth) throw new (0, $89khs.MediaStoreError)('missingInitialAuth');
    return auth;
};

});
parcelRegister("89khs", function(module, exports) {

$parcel$export(module.exports, "MediaStoreError", () => $1f9b2d64052a14af$export$b78480bd311630bc);
$parcel$export(module.exports, "isMediaStoreError", () => $1f9b2d64052a14af$export$8d2a9b675b2ce37a);

var $6bBrC = parcelRequire("6bBrC");
class $1f9b2d64052a14af$export$b78480bd311630bc extends (0, $6bBrC.BaseMediaClientError) {
    constructor(reason, innerError){
        super(reason);
        this.reason = reason;
        this.innerError = innerError;
    }
    get attributes() {
        const { reason: reason, innerError: innerError } = this;
        return {
            reason: reason,
            innerError: innerError
        };
    }
}
function $1f9b2d64052a14af$export$8d2a9b675b2ce37a(err) {
    return err instanceof $1f9b2d64052a14af$export$b78480bd311630bc;
}

});

parcelRegister("aSVFn", function(module, exports) {

$parcel$export(module.exports, "rejectTimeout", () => $e63044c0dd9a5237$export$cf2d2a1124beacb2);
const $e63044c0dd9a5237$export$c30e7cea8bbec3c0 = (timeout, resolveWith)=>new Promise((resolve, _reject)=>{
        setTimeout(resolve, timeout, resolveWith);
    });
const $e63044c0dd9a5237$export$cf2d2a1124beacb2 = (timeout, rejectWith)=>new Promise((_resolve, reject)=>{
        setTimeout(reject, timeout, rejectWith);
    });

});



parcelRegister("3ixzU", function(module, exports) {

$parcel$export(module.exports, "FileFetcherImpl", () => $f9763f928076fcdc$export$fe17eabf77aabacb);
$parcel$export(module.exports, "FileFetcherError", () => (parcelRequire("fIVY8")).FileFetcherError);

var $hIoOm = parcelRequire("hIoOm");

var $aynDk = parcelRequire("aynDk");

var $dFBS3 = parcelRequire("dFBS3");
parcelRequire("inzmU");
parcelRequire("2q7Xj");
var $jrFS0 = parcelRequire("jrFS0");

var $8w4F1 = parcelRequire("8w4F1");

var $EEZOU = parcelRequire("EEZOU");

var $9x67R = parcelRequire("9x67R");

var $fIVY8 = parcelRequire("fIVY8");

var $eSb3E = parcelRequire("eSb3E");

var $1l4qL = parcelRequire("1l4qL");

var $59gZB = parcelRequire("59gZB");

var $aFsdc = parcelRequire("aFsdc");

var $bxYYu = parcelRequire("bxYYu");

var $bVMx4 = parcelRequire("bVMx4");

var $04AOJ = parcelRequire("04AOJ");

var $9sBfG = parcelRequire("9sBfG");

var $dpRAQ = parcelRequire("dpRAQ");

var $eqcfa = parcelRequire("eqcfa");
var $9BeXg = parcelRequire("9BeXg");

var $cfjUA = parcelRequire("cfjUA");

var $rMufQ = parcelRequire("rMufQ");

var $3izHV = parcelRequire("3izHV");
var $br8gy = parcelRequire("br8gy");

var $cILCr = parcelRequire("cILCr");

var $eqlnz = parcelRequire("eqlnz");

var $6wdWp = parcelRequire("6wdWp");
parcelRequire("gHZqD");
var $exlxT = parcelRequire("exlxT");

var $XHGTv = parcelRequire("XHGTv");
class $f9763f928076fcdc$export$fe17eabf77aabacb {
    constructor(mediaApi, store = (0, $exlxT.mediaStore)){
        this.mediaApi = mediaApi;
        this.store = store;
        this.getErrorFileState = (error, id, occurrenceKey)=>typeof error === 'string' ? {
                status: 'error',
                id: id,
                reason: error,
                occurrenceKey: occurrenceKey,
                message: error
            } : {
                status: 'error',
                id: id,
                reason: error?.reason,
                details: error?.attributes,
                occurrenceKey: occurrenceKey,
                message: error?.message
            };
        this.setFileState = (id, fileState)=>{
            this.store.setState((state)=>{
                state.files[id] = fileState;
            });
        };
        this.createDownloadFileStream = (id, collectionName, occurrenceKey)=>{
            const subject = (0, $rMufQ.createMediaSubject)();
            const poll = new (0, $eqlnz.PollingFunction)();
            // ensure subject errors if polling exceeds max iterations or uncaught exception in executor
            poll.onError = (error)=>subject.error(error);
            poll.execute(async ()=>{
                const response = await this.dataloader.load({
                    id: id,
                    collectionName: collectionName
                });
                if (!response) throw new (0, $fIVY8.FileFetcherError)('emptyItems', id, {
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey
                });
                if ((0, $6wdWp.isEmptyFile)(response)) throw new (0, $fIVY8.FileFetcherError)('zeroVersionFile', id, {
                    collectionName: collectionName,
                    occurrenceKey: occurrenceKey
                });
                const fileState = (0, $9x67R.mapMediaItemToFileState)(id, response);
                subject.next(fileState);
                switch(fileState.status){
                    case 'processing':
                        // the only case for continuing polling, otherwise this function is run once only
                        poll.next();
                        break;
                    case 'processed':
                        subject.complete();
                        break;
                }
            });
            return subject;
        };
        this.getUploadingFileStateBase = (file, upfrontId)=>{
            // TODO: DO not modify the input parameter 'content' attribute
            if (typeof file.content === 'string') file.content = (0, $dpRAQ.convertBase64ToBlob)(file.content);
            const { content: content, name: name = '' } = file;
            const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
            let preview;
            // TODO [MSW-796]: get file size for base64
            let size = 0;
            let mimeType = '';
            if (content instanceof Blob) {
                size = content.size;
                mimeType = content.type;
                if ((0, $br8gy.isMimeTypeSupportedByBrowser)(content.type) || (0, $XHGTv.getBooleanFF)('platform.media-svg-rendering')) preview = {
                    value: content,
                    origin: 'local'
                };
            }
            const mediaType = (0, $04AOJ.getMediaTypeFromUploadableFile)(file);
            return {
                id: id,
                occurrenceKey: occurrenceKey,
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: mimeType,
                preview: preview
            };
        };
        this.dataloader = (0, $bVMx4.createFileDataloader)(mediaApi);
    }
    getFileState(id, options = {}) {
        const { collectionName: collectionName, occurrenceKey: occurrenceKey } = options;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($bxYYu)))(id)) {
            const subject = (0, $rMufQ.createMediaSubject)();
            const err = new (0, $fIVY8.FileFetcherError)('invalidFileId', id, {
                collectionName: collectionName,
                occurrenceKey: occurrenceKey
            });
            const errorFileState = {
                status: 'error',
                id: id,
                reason: err?.reason,
                message: err?.message,
                occurrenceKey: occurrenceKey,
                details: err?.attributes
            };
            subject.error(err);
            this.setFileState(id, errorFileState);
            return (0, $eqcfa.fromObservable)(subject);
        }
        return (0, $eqcfa.fromObservable)((0, $1l4qL.getFileStreamsCache)().getOrInsert(id, ()=>{
            const subject = this.createDownloadFileStream(id, collectionName);
            subject.subscribe({
                next: (fileState)=>{
                    this.setFileState(id, fileState);
                },
                error: (err)=>{
                    const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    this.setFileState(id, errorFileState);
                }
            });
            return subject;
        }));
    }
    getCurrentState(id, options) {
        return (0, $9BeXg.toPromise)(this.getFileState(id, options));
    }
    getArtifactURL(artifacts, artifactName, collectionName) {
        return this.mediaApi.getArtifactURL(artifacts, artifactName, collectionName);
    }
    getFileBinaryURL(id, collectionName, maxAge) {
        return this.mediaApi.getFileBinaryURL(id, collectionName, maxAge);
    }
    touchFiles(descriptors, collection, traceContext) {
        return this.mediaApi.touchFiles({
            descriptors: descriptors
        }, {
            collection: collection
        }, traceContext).then(({ data: data })=>data);
    }
    generateUploadableFileUpfrontIds(collection, traceContext) {
        const id = (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))();
        const occurrenceKey = (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))();
        const touchFileDescriptor = {
            fileId: id,
            occurrenceKey: occurrenceKey,
            collection: collection
        };
        const deferredUploadId = this.touchFiles([
            touchFileDescriptor
        ], collection, traceContext).then((touchedFiles)=>touchedFiles.created[0].uploadId);
        return {
            id: id,
            occurrenceKey: occurrenceKey,
            deferredUploadId: deferredUploadId
        };
    }
    async uploadExternal(url, collection, traceContext) {
        const uploadableFileUpfrontIds = this.generateUploadableFileUpfrontIds(collection, traceContext);
        const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
        const subject = (0, $rMufQ.createMediaSubject)();
        const deferredBlob = fetch(url).then((response)=>response.blob()).catch(()=>undefined);
        const preview = new Promise(async (resolve, reject)=>{
            const blob = await deferredBlob;
            if (!blob) reject('Could not fetch the blob');
            resolve({
                value: blob,
                origin: 'remote'
            });
        });
        const name = url.split('/').pop() || '';
        // we create a initial fileState with the minimum info that we have at this point
        const fileState = {
            status: 'processing',
            name: name,
            size: 0,
            mediaType: 'unknown',
            mimeType: '',
            id: id,
            occurrenceKey: occurrenceKey,
            preview: preview
        };
        subject.next(fileState);
        // we save it into the cache as soon as possible, in case someone subscribes
        (0, $1l4qL.getFileStreamsCache)().set(id, subject);
        this.setFileState(id, fileState);
        return new Promise(async (resolve, reject)=>{
            const blob = await deferredBlob;
            if (!blob) return reject('Could not download remote file');
            const { type: type, size: size } = blob;
            const file = {
                content: blob,
                mimeType: type,
                collection: collection,
                name: name,
                size: size
            };
            const mediaType = (0, $3izHV.getMediaTypeFromMimeType)(type);
            // we emit a richer state after the blob is fetched
            subject.next({
                status: 'processing',
                name: name,
                size: size,
                mediaType: mediaType,
                mimeType: type,
                id: id,
                occurrenceKey: occurrenceKey,
                preview: preview
            });
            // we don't want to wait for the file to be upload
            this.upload(file, undefined, uploadableFileUpfrontIds, traceContext);
            let dimensions;
            try {
                dimensions = await (0, $cfjUA.getDimensionsFromBlob)(mediaType, blob);
            } catch (error) {
                reject(error);
                return;
            }
            resolve({
                dimensions: dimensions,
                uploadableFileUpfrontIds: uploadableFileUpfrontIds
            });
        });
    }
    upload(file, controller, uploadableFileUpfrontIds, traceContext) {
        const { collection: collection } = file;
        const upfrontId = uploadableFileUpfrontIds || this.generateUploadableFileUpfrontIds(collection, traceContext);
        const { id: id, occurrenceKey: occurrenceKey } = upfrontId;
        const stateBase = this.getUploadingFileStateBase(file, upfrontId);
        const subject = (0, $rMufQ.createMediaSubject)();
        (0, $1l4qL.getFileStreamsCache)().set(id, subject);
        const onProgress = (progress)=>{
            const fileState = {
                status: 'uploading',
                ...stateBase,
                progress: progress
            };
            subject.next(fileState);
            this.setFileState(id, fileState);
        };
        let processingSubscription = new (0, $hIoOm.Subscription)();
        const onUploadFinish = (error)=>{
            if (error) {
                const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                this.setFileState(id, errorFileState);
                return subject.error(error);
            }
            processingSubscription = this.createDownloadFileStream(id, collection, occurrenceKey).pipe((0, $aynDk.map)((remoteFileState)=>({
                    // merges base state with remote state
                    ...stateBase,
                    ...remoteFileState,
                    ...(0, $9sBfG.overrideMediaTypeIfUnknown)(remoteFileState, stateBase.mediaType)
                }))).subscribe({
                next: (fileState)=>{
                    subject.next(fileState);
                    this.setFileState(id, fileState);
                },
                error: (err)=>{
                    const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                    subject.error(err);
                    this.setFileState(id, errorFileState);
                },
                complete: subject.complete
            });
        };
        const { cancel: cancel } = (0, $eSb3E.uploadFile)(file, this.mediaApi, upfrontId, {
            onUploadFinish: onUploadFinish,
            onProgress: onProgress
        }, traceContext);
        controller?.setAbort(()=>{
            cancel();
            // TODO: filestate should turn to "Aborted" or something.
            // Consider canceling an upload that is already finished
            processingSubscription.unsubscribe();
        });
        // We should report progress asynchronously, since this is what consumer expects
        // (otherwise in newUploadService file-converting event will be emitted before files-added)
        setTimeout(onProgress, 0, 0);
        return (0, $eqcfa.fromObservable)(subject);
    }
    async downloadBinary(id, name = 'download', collectionName) {
        const url = await this.mediaApi.getFileBinaryURL(id, collectionName);
        (0, $8w4F1.downloadUrl)(url, {
            name: name
        });
        (0, $59gZB.globalMediaEventEmitter).emit('media-viewed', {
            fileId: id,
            isUserCollection: collectionName === (0, $aFsdc.RECENTS_COLLECTION),
            viewingLevel: 'download'
        });
    }
    async copyFile(source, destination, options = {}, traceContext) {
        const { authProvider: authProvider, collection: sourceCollection, id: id } = source;
        const { authProvider: destinationAuthProvider, collection: destinationCollectionName, replaceFileId: replaceFileId, occurrenceKey: occurrenceKey } = destination;
        const { preview: preview, mimeType: mimeType } = options;
        const mediaStore = destination.mediaStore || new (0, $EEZOU.MediaStore)({
            authProvider: destinationAuthProvider
        });
        const owner = (0, $jrFS0.authToOwner)(await authProvider({
            collectionName: sourceCollection
        }));
        const body = {
            sourceFile: {
                id: id,
                collection: sourceCollection,
                owner: owner
            }
        };
        const params = {
            collection: destinationCollectionName,
            replaceFileId: replaceFileId,
            occurrenceKey: occurrenceKey
        };
        const cache = (0, $1l4qL.getFileStreamsCache)();
        let processingSubscription;
        try {
            const { data: copiedFile } = await mediaStore.copyFileWithToken(body, params, traceContext);
            // if we were passed a "mimeType", we propagate it into copiedFileWithMimeType
            const copiedFileWithMimeType = {
                ...copiedFile,
                ...mimeType ? {
                    mimeType: mimeType
                } : undefined
            };
            const { id: copiedId, mimeType: copiedMimeType } = copiedFileWithMimeType;
            // backend may return an "unknown" mediaType just after the copy
            // it's better to deduce it from "copiedMimeType" using getMediaTypeFromMimeType()
            const mediaType = copiedMimeType ? (0, $3izHV.getMediaTypeFromMimeType)(copiedMimeType) : 'unknown';
            const copiedFileState = (0, $9x67R.mapMediaFileToFileState)({
                data: copiedFileWithMimeType
            });
            const fileCache = cache.get(copiedId);
            const subject = fileCache || (0, $rMufQ.createMediaSubject)();
            // if we were passed a "preview", we propagate it into the copiedFileState
            const previewOverride = !(0, $9x67R.isErrorFileState)(copiedFileState) && !!preview ? {
                preview: preview
            } : {};
            if (!(0, $9x67R.isFinalFileState)(copiedFileState) && // mimeType should always be returned by "copyFileWithToken"
            // but in case it's not, we don't want to penalize "copyFile"
            copiedMimeType && await (0, $cILCr.shouldFetchRemoteFileStates)(mediaType, copiedMimeType, preview)) {
                const fileState = {
                    ...copiedFileState,
                    ...(0, $9sBfG.overrideMediaTypeIfUnknown)(copiedFileState, mediaType),
                    ...previewOverride
                };
                subject.next(fileState);
                this.setFileState(copiedId, fileState);
                processingSubscription = this.createDownloadFileStream(copiedId, destinationCollectionName, occurrenceKey).subscribe({
                    next: (remoteFileState)=>{
                        const fileState = {
                            ...remoteFileState,
                            ...(0, $9sBfG.overrideMediaTypeIfUnknown)(remoteFileState, mediaType),
                            ...!(0, $9x67R.isErrorFileState)(remoteFileState) && previewOverride
                        };
                        this.setFileState(copiedId, fileState);
                        return subject.next(fileState);
                    },
                    error: (err)=>{
                        const errorFileState = this.getErrorFileState(err, id, occurrenceKey);
                        this.setFileState(copiedId, errorFileState);
                        return subject.error(err);
                    },
                    complete: ()=>subject.complete()
                });
            } else if (!(0, $9x67R.isProcessingFileState)(copiedFileState)) {
                const fileState = {
                    ...copiedFileState,
                    ...!(0, $9x67R.isErrorFileState)(copiedFileState) && previewOverride
                };
                subject.next(fileState);
                this.setFileState(copiedId, fileState);
            }
            if (!cache.has(copiedId)) (0, $1l4qL.getFileStreamsCache)().set(copiedId, subject);
            return copiedFile;
        } catch (error) {
            if (processingSubscription) processingSubscription.unsubscribe();
            if (replaceFileId) {
                const fileCache = cache.get(replaceFileId);
                const replaceFileState = this.store.getState().files[replaceFileId];
                if (fileCache) fileCache.error(error);
                else // Create a new subject with the error state for new subscriptions
                cache.set(id, (0, $rMufQ.createMediaSubject)(error));
                const key = replaceFileState ? replaceFileId : id;
                const errorFileState = this.getErrorFileState(error, id, occurrenceKey);
                this.setFileState(key, errorFileState);
            }
            throw error;
        }
    }
}

});
parcelRegister("8w4F1", function(module, exports) {

$parcel$export(module.exports, "downloadUrl", () => $b20aaa7fa9049904$export$8a96edb1c96563f4);
const $b20aaa7fa9049904$export$8a96edb1c96563f4 = (url, options)=>{
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    if (options && options.name) link.download = options.name;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

});

parcelRegister("9x67R", function(module, exports) {

$parcel$export(module.exports, "isUploadingFileState", () => $4ada6060c1d21d91$export$70eb3481b487c668);
$parcel$export(module.exports, "isProcessingFileState", () => $4ada6060c1d21d91$export$5c30e6dd75278e66);
$parcel$export(module.exports, "isProcessedFileState", () => $4ada6060c1d21d91$export$1d17291aafa5f231);
$parcel$export(module.exports, "isErrorFileState", () => $4ada6060c1d21d91$export$f863e1e09c8a926);
$parcel$export(module.exports, "isPreviewableFileState", () => $4ada6060c1d21d91$export$92dd692b31e42e64);
$parcel$export(module.exports, "isFinalFileState", () => $4ada6060c1d21d91$export$270b3fc27120edd0);
$parcel$export(module.exports, "isImageRepresentationReady", () => $4ada6060c1d21d91$export$4e33ccde53b4f0bf);
$parcel$export(module.exports, "mapMediaFileToFileState", () => $4ada6060c1d21d91$export$ddfd67d20657322f);
$parcel$export(module.exports, "mapMediaItemToFileState", () => $4ada6060c1d21d91$export$ea3730792e8bebfb);
const $4ada6060c1d21d91$export$70eb3481b487c668 = (fileState)=>fileState.status === 'uploading';
const $4ada6060c1d21d91$export$5c30e6dd75278e66 = (fileState)=>fileState.status === 'processing';
const $4ada6060c1d21d91$export$1d17291aafa5f231 = (fileState)=>fileState.status === 'processed';
const $4ada6060c1d21d91$export$f863e1e09c8a926 = (fileState)=>fileState.status === 'error';
const $4ada6060c1d21d91$export$92dd692b31e42e64 = (fileState)=>!$4ada6060c1d21d91$export$f863e1e09c8a926(fileState) && !!fileState.preview;
const $4ada6060c1d21d91$export$270b3fc27120edd0 = (fileState)=>[
        'processed',
        'failed-processing',
        'error'
    ].includes(fileState.status);
const $4ada6060c1d21d91$export$4e33ccde53b4f0bf = (fileState)=>{
    switch(fileState.status){
        case 'processing':
        case 'processed':
        case 'failed-processing':
            return !!(fileState.representations && fileState.representations.image);
        default:
            return false;
    }
};
const $4ada6060c1d21d91$export$ddfd67d20657322f = (mediaFile)=>{
    const { id: id, name: name, size: size, processingStatus: processingStatus, artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, representations: representations, createdAt: createdAt, metadataTraceContext: metadataTraceContext } = mediaFile.data;
    const baseState = {
        id: id,
        name: name,
        size: size,
        mediaType: mediaType,
        mimeType: mimeType,
        artifacts: artifacts,
        representations: representations,
        createdAt: createdAt,
        metadataTraceContext: metadataTraceContext
    };
    switch(processingStatus){
        case 'pending':
        case undefined:
            return {
                ...baseState,
                status: 'processing'
            };
        case 'succeeded':
            return {
                ...baseState,
                status: 'processed'
            };
        case 'failed':
            return {
                ...baseState,
                status: 'failed-processing'
            };
    }
};
const $4ada6060c1d21d91$export$ea3730792e8bebfb = (id, item)=>{
    return $4ada6060c1d21d91$export$ddfd67d20657322f({
        data: {
            id: id,
            ...item
        }
    });
};

});

parcelRegister("fIVY8", function(module, exports) {

$parcel$export(module.exports, "FileFetcherError", () => $0af7ec264212be2b$export$e3e60f0dab8641de);

var $6bBrC = parcelRequire("6bBrC");
class $0af7ec264212be2b$export$e3e60f0dab8641de extends (0, $6bBrC.BaseMediaClientError) {
    constructor(reason, id, metadata){
        super(reason);
        this.reason = reason;
        this.id = id;
        this.metadata = metadata;
    }
    get attributes() {
        const { reason: reason, id: id, metadata: { collectionName: collectionName, occurrenceKey: occurrenceKey } = {} } = this;
        return {
            reason: reason,
            id: id,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey
        };
    }
}
function $0af7ec264212be2b$export$5c3435f75ce0ce70(err) {
    return err instanceof $0af7ec264212be2b$export$e3e60f0dab8641de;
}

});

parcelRegister("eSb3E", function(module, exports) {

$parcel$export(module.exports, "uploadFile", () => $46ff4c8ed9468aee$export$a5575dbeeffdad98);

var $2gF4Y = parcelRequire("2gF4Y");

var $jpkPA = parcelRequire("jpkPA");

var $eGPtZ = parcelRequire("eGPtZ");

var $fLD6W = parcelRequire("fLD6W");

var $1jayH = parcelRequire("1jayH");

var $aFsdc = parcelRequire("aFsdc");

var $eLiN6 = parcelRequire("eLiN6");
const $46ff4c8ed9468aee$var$hashingFunction = async (blob, hashAlgorithm)=>{
    const hasher = await (0, $fLD6W.createHasher)(hashAlgorithm);
    return hasher.hash(blob);
};
const $46ff4c8ed9468aee$var$createUploadingFunction = (store, deferredUploadId, collectionName, traceContext)=>async (chunk)=>{
        return await store.uploadChunk(chunk.hash, chunk.blob, await deferredUploadId, chunk.partNumber, collectionName, traceContext);
    };
const $46ff4c8ed9468aee$var$createProcessingFunction = (store, deferredUploadId, collection, traceContext)=>{
    let offset = 0;
    return async (chunks)=>{
        await store.appendChunksToUpload(await deferredUploadId, {
            chunks: $46ff4c8ed9468aee$var$hashedChunks(chunks),
            offset: offset
        }, collection, traceContext);
        offset += chunks.length;
    };
};
const $46ff4c8ed9468aee$var$createFileFromUpload = async (file, store, uploadableFileUpfrontIds, uploadId, traceContext)=>{
    const { collection: collection, name: name, mimeType: mimeType } = file;
    const { id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
    const body = file.size ? {
        uploadId: uploadId,
        name: name,
        mimeType: mimeType,
        conditions: {
            size: file.size
        }
    } : {
        uploadId: uploadId,
        name: name,
        mimeType: mimeType
    };
    return store.createFileFromUpload(body, {
        occurrenceKey: occurrenceKey,
        collection: collection,
        replaceFileId: id
    }, traceContext);
};
const $46ff4c8ed9468aee$export$a5575dbeeffdad98 = (file, store, uploadableFileUpfrontIds, callbacks, traceContext)=>{
    const { content: content, collection: collection } = file;
    const { deferredUploadId: deferredUploadId, id: id, occurrenceKey: occurrenceKey } = uploadableFileUpfrontIds;
    let chunkSize = (0, $aFsdc.CHUNK_SIZE);
    try {
        if (content instanceof Blob) chunkSize = (0, $eLiN6.calculateChunkSize)(content.size);
    } catch (err) {
        if (err instanceof Error && err.message === (0, $eLiN6.fileSizeError)) callbacks?.onUploadFinish(new (0, $1jayH.UploaderError)(err.message, id, {
            collectionName: collection,
            occurrenceKey: occurrenceKey
        }));
        return {
            cancel: ()=>{
                callbacks?.onUploadFinish('canceled');
            }
        };
    }
    const chunkinatorObservable = (0, $2gF4Y.chunkinator)(content, {
        hashingFunction: (blob)=>$46ff4c8ed9468aee$var$hashingFunction(blob, store.chunkHashAlgorithm),
        hashingConcurrency: 5,
        chunkSize: chunkSize,
        uploadingConcurrency: 3,
        uploadingFunction: $46ff4c8ed9468aee$var$createUploadingFunction(store, deferredUploadId, collection, traceContext),
        processingBatchSize: (0, $aFsdc.PROCESSING_BATCH_SIZE),
        processingFunction: $46ff4c8ed9468aee$var$createProcessingFunction(store, deferredUploadId, collection, traceContext)
    }, {
        onProgress (progress) {
            if (callbacks) callbacks.onProgress(progress);
        }
    });
    const onUploadFinish = callbacks && callbacks.onUploadFinish || (()=>{});
    const subscription = (0, $jpkPA.from)(deferredUploadId).pipe((0, $eGPtZ.concatMap)((uploadId)=>chunkinatorObservable.pipe((0, $eGPtZ.concatMap)(()=>(0, $jpkPA.from)($46ff4c8ed9468aee$var$createFileFromUpload(file, store, uploadableFileUpfrontIds, uploadId, traceContext)))))).subscribe({
        error: (err)=>onUploadFinish(err),
        complete: ()=>onUploadFinish()
    });
    return {
        cancel: ()=>{
            subscription.unsubscribe();
            onUploadFinish('canceled');
        }
    };
};
const $46ff4c8ed9468aee$var$hashedChunks = (chunks)=>chunks.map((chunk)=>chunk.hash);

});
parcelRegister("2gF4Y", function(module, exports) {

$parcel$export(module.exports, "chunkinator", () => $926a40091d882f6c$export$9ab6bef3838698f8);

var $dBQte = parcelRequire("dBQte");

var $eGPtZ = parcelRequire("eGPtZ");

var $4ZLqF = parcelRequire("4ZLqF");

var $8riMk = parcelRequire("8riMk");

var $fZ5s6 = parcelRequire("fZ5s6");

var $66iic = parcelRequire("66iic");

var $f28UZ = parcelRequire("f28UZ");

var $iYmB8 = parcelRequire("iYmB8");

var $7zy4k = parcelRequire("7zy4k");

var $jpkPA = parcelRequire("jpkPA");
const $926a40091d882f6c$export$88e80b3a0bb31f63 = (file, options, callbacks)=>(0, $8riMk.fromPromise)((0, $7zy4k.fetchBlob)(file)).pipe((0, $eGPtZ.concatMap)((blob)=>{
        const { chunkSize: chunkSize } = options;
        const { onProgress: onProgress } = callbacks;
        const totalChunks = Math.ceil(blob.size / chunkSize);
        const slicenatedBlobs = (0, $fZ5s6.slicenator)(blob, {
            size: chunkSize
        });
        const hashinatedBlobs = (0, $66iic.hashinator)(slicenatedBlobs, {
            concurrency: options.hashingConcurrency,
            hasher: options.hashingFunction
        });
        let uploadedChunks = 0;
        let uploadedBlobs = (0, $f28UZ.uploadinator)(hashinatedBlobs, {
            concurrency: options.uploadingConcurrency,
            uploader: options.uploadingFunction
        });
        if (onProgress) uploadedBlobs = uploadedBlobs.pipe((0, $dBQte.tap)(()=>{
            uploadedChunks += 1;
            onProgress(uploadedChunks / totalChunks);
        }));
        return (0, $iYmB8.processinator)(uploadedBlobs, {
            batchSize: options.processingBatchSize,
            processor: options.processingFunction
        }).pipe((0, $eGPtZ.concatMap)((batchedChunks)=>{
            return (0, $jpkPA.from)(batchedChunks);
        }), (0, $4ZLqF.bufferCount)(totalChunks));
    }));
const $926a40091d882f6c$export$9ab6bef3838698f8 = (file, options, callbacks)=>{
    return $926a40091d882f6c$export$88e80b3a0bb31f63(file, options, callbacks);
};

});
parcelRegister("fZ5s6", function(module, exports) {

$parcel$export(module.exports, "slicenator", () => $b09d6a25440d952b$export$5b92d769f2f57509);

var $3fnK6 = parcelRequire("3fnK6");

var $aynDk = parcelRequire("aynDk");
const $b09d6a25440d952b$export$5b92d769f2f57509 = (blob, { size: chunkSize })=>{
    const totalChunks = Math.ceil(blob.size / chunkSize);
    return (0, $3fnK6.range)(0, totalChunks).pipe((0, $aynDk.map)((index)=>{
        return {
            partNumber: index + 1,
            blob: blob.slice(index * chunkSize, (index + 1) * chunkSize)
        };
    }));
};

});

parcelRegister("66iic", function(module, exports) {

$parcel$export(module.exports, "hashinator", () => $bba7ef0a5244bc3b$export$d5f5a550a38ec367);

var $7zy4k = parcelRequire("7zy4k");
const $bba7ef0a5244bc3b$export$28a452a485721473 = (hasher)=>(slicedBlob)=>hasher(slicedBlob.blob).then((hash)=>({
                blob: slicedBlob.blob,
                hash: `${hash}-${slicedBlob.blob.size}`,
                partNumber: slicedBlob.partNumber
            }));
const $bba7ef0a5244bc3b$export$d5f5a550a38ec367 = (blobs$, { hasher: hasher, concurrency: concurrency })=>(0, $7zy4k.asyncMap)($bba7ef0a5244bc3b$export$28a452a485721473(hasher), concurrency)(blobs$);

});
parcelRegister("7zy4k", function(module, exports) {

$parcel$export(module.exports, "fetchBlob", () => $434114a42104e3d7$export$14e9cfd4a872cc1e);
$parcel$export(module.exports, "asyncMap", () => $434114a42104e3d7$export$707ee4c4c95d39e3);

var $3JafE = parcelRequire("3JafE");

var $b1qLQ = parcelRequire("b1qLQ");
async function $434114a42104e3d7$export$14e9cfd4a872cc1e(file) {
    if (typeof file === 'string') return await fetch(file).then((response)=>response.blob());
    else return file;
}
const $434114a42104e3d7$var$notify = (promise, observer, onReady)=>{
    const notifier = {
        notifyIfReady: ()=>false
    };
    promise.then((value)=>{
        notifier.notifyIfReady = ()=>{
            observer.next(value);
            observer.complete();
            return true;
        };
        onReady(notifier);
    }, (reason)=>{
        notifier.notifyIfReady = ()=>{
            observer.error(reason);
            return true;
        };
        onReady(notifier);
    });
    return notifier;
};
const $434114a42104e3d7$var$mapper = (project)=>{
    const notifiers = new Array();
    const onReady = ()=>{
        // find the first non-ready notifier in the queue,
        // while invoking all ready notifiers that we encounter along the way
        const notReadyIdx = notifiers.findIndex((notifier)=>!notifier.notifyIfReady());
        if (notReadyIdx > 0) // remove all the notifiers we invoked
        notifiers.splice(0, notReadyIdx);
    };
    return (value)=>new (0, $3JafE.Observable)((sub)=>{
            notifiers.push($434114a42104e3d7$var$notify(project(value), sub, onReady));
        });
};
const $434114a42104e3d7$export$707ee4c4c95d39e3 = (project, concurrent)=>(0, $b1qLQ.mergeMap)($434114a42104e3d7$var$mapper(project), concurrent);

});


parcelRegister("f28UZ", function(module, exports) {

$parcel$export(module.exports, "uploadinator", () => $6a83285a61ef7586$export$94ce0f3fcf999415);

var $7zy4k = parcelRequire("7zy4k");
const $6a83285a61ef7586$export$94ce0f3fcf999415 = (blobs$, options)=>{
    const upload = (blob)=>{
        return options.uploader(blob).then(()=>blob);
    };
    return blobs$.pipe((0, $7zy4k.asyncMap)(upload, options.concurrency));
};

});

parcelRegister("iYmB8", function(module, exports) {

$parcel$export(module.exports, "processinator", () => $38ace8e9a7e10729$export$2f21790600302ed);

var $4ZLqF = parcelRequire("4ZLqF");

var $eGPtZ = parcelRequire("eGPtZ");
const $38ace8e9a7e10729$export$2f21790600302ed = (blobs$, options)=>{
    const process = (blobs)=>{
        if (options.processor) return options.processor(blobs).then(()=>blobs);
        else return Promise.resolve(blobs);
    };
    return blobs$.pipe((0, $4ZLqF.bufferCount)(options.batchSize)).pipe((0, $eGPtZ.concatMap)(process));
};

});


parcelRegister("fLD6W", function(module, exports) {

$parcel$export(module.exports, "createHasher", () => $80d9fc5820b1f0fe$export$14b114effbc08b6b);
parcelRequire("2q7Xj");
var $fmEc3 = parcelRequire("fmEc3");
let $80d9fc5820b1f0fe$var$hasher = null;
let $80d9fc5820b1f0fe$var$sha256Hasher = null;
const $80d9fc5820b1f0fe$export$b7d263e6bc26b29a = ()=>$80d9fc5820b1f0fe$var$hasher = null;



const $80d9fc5820b1f0fe$export$14b114effbc08b6b = async (algorithm)=>{
    const numWorkers = 3;
    if (algorithm === (0, $fmEc3.ChunkHashAlgorithm).Sha256) {
        if (!$80d9fc5820b1f0fe$var$sha256Hasher) {
            // TODO this needs to support worker sha256 hasher as well
            const { SimpleHasher: SimpleHasher } = await (parcelRequire("3BfQx"));
            $80d9fc5820b1f0fe$var$sha256Hasher = new SimpleHasher();
        }
        return $80d9fc5820b1f0fe$var$sha256Hasher;
    } else if (!$80d9fc5820b1f0fe$var$hasher) try {
        const { WorkerHasher: WorkerHasher } = await (parcelRequire("axVNb"));
        $80d9fc5820b1f0fe$var$hasher = new WorkerHasher(numWorkers);
    } catch (error) {
        const { SimpleHasher: SimpleHasher } = await (parcelRequire("hCBFx"));
        $80d9fc5820b1f0fe$var$hasher = new SimpleHasher();
    }
    return $80d9fc5820b1f0fe$var$hasher;
};

});
parcelRegister("3BfQx", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('iw25e');
        const value = parcelRequire('4HVlI');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("iw25e").then(()=>parcelRequire('4HVlI'));
}

});

parcelRegister("axVNb", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('izugL')
        ]);
        const value = parcelRequire('kAV1m');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("izugL")
    ]).then(()=>parcelRequire('kAV1m'));
}

});

parcelRegister("hCBFx", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('lOaWi')
        ]);
        const value = parcelRequire('7ykMh');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("lOaWi")
    ]).then(()=>parcelRequire('7ykMh'));
}

});


parcelRegister("1jayH", function(module, exports) {

$parcel$export(module.exports, "UploaderError", () => $93268a427390d3ba$export$515240c3f059c807);

var $6bBrC = parcelRequire("6bBrC");
class $93268a427390d3ba$export$515240c3f059c807 extends (0, $6bBrC.BaseMediaClientError) {
    constructor(reason, id, metadata){
        super(reason);
        this.reason = reason;
        this.id = id;
        this.metadata = metadata;
    }
    get attributes() {
        const { reason: reason, id: id, metadata: { collectionName: collectionName, occurrenceKey: occurrenceKey } = {} } = this;
        return {
            reason: reason,
            id: id,
            collectionName: collectionName,
            occurrenceKey: occurrenceKey
        };
    }
}
function $93268a427390d3ba$export$80ee180172bc336(err) {
    return err instanceof $93268a427390d3ba$export$515240c3f059c807;
}

});

parcelRegister("eLiN6", function(module, exports) {

$parcel$export(module.exports, "fileSizeError", () => $1d73b7e36a95c49b$export$b36239e4c33c2902);
$parcel$export(module.exports, "calculateChunkSize", () => $1d73b7e36a95c49b$export$71f452e02035c1e2);

var $bYwuj = parcelRequire("bYwuj");

var $aFsdc = parcelRequire("aFsdc");
const $1d73b7e36a95c49b$export$b36239e4c33c2902 = 'fileSizeExceedsLimit';
const $1d73b7e36a95c49b$export$71f452e02035c1e2 = (fileSize)=>{
    if (fileSize > (0, $aFsdc.MAX_UPLOAD_FILE_SIZE)) throw new Error($1d73b7e36a95c49b$export$b36239e4c33c2902);
    if (fileSize <= 5 * (0, $bYwuj.DATA_UNIT).GB) return 5 * (0, $bYwuj.DATA_UNIT).MB;
    if (fileSize > 5 * (0, $bYwuj.DATA_UNIT).GB && fileSize <= 50 * (0, $bYwuj.DATA_UNIT).GB) return 50 * (0, $bYwuj.DATA_UNIT).MB;
    if (fileSize > 50 * (0, $bYwuj.DATA_UNIT).GB && fileSize <= 0.95 * (0, $bYwuj.DATA_UNIT).TB) return 100 * (0, $bYwuj.DATA_UNIT).MB;
    return 210 * (0, $bYwuj.DATA_UNIT).MB;
};

});


parcelRegister("1l4qL", function(module, exports) {

$parcel$export(module.exports, "getFileStreamsCache", () => $5b31f9f9111d0f01$export$f2f061938c1e6810);
class $5b31f9f9111d0f01$export$4293896e79732236 {
    constructor(streams){
        this.streams = streams;
    }
    has(id) {
        return !!this.streams.find(id);
    }
    set(id, stream) {
        this.streams.set(id, stream);
    }
    get(id) {
        return this.streams.get(id);
    }
    getOrInsert(id, callback) {
        if (!this.has(id)) this.set(id, callback());
        return this.get(id);
    }
    removeAll() {
        this.streams.clear();
    }
    remove(id) {
        this.streams.delete(id);
    }
    get size() {
        return this.streams.size;
    }
}
let $5b31f9f9111d0f01$var$streamCache;

const $5b31f9f9111d0f01$export$f2f061938c1e6810 = ()=>{
    if (!$5b31f9f9111d0f01$var$streamCache) {
        // TODO: we can move this into a static import like
        // import {mediaState} from '@atlaskit/media-core'
        const mediaState = (parcelRequire("iE8r2")).mediaState;
        $5b31f9f9111d0f01$var$streamCache = new $5b31f9f9111d0f01$export$4293896e79732236(mediaState.streams);
    }
    return $5b31f9f9111d0f01$var$streamCache;
};

});

parcelRegister("59gZB", function(module, exports) {

$parcel$export(module.exports, "globalMediaEventEmitter", () => $b6e693db8a3ca69e$export$68d003d3105952ad);
parcelRequire("2q7Xj");
var $iE8r2 = parcelRequire("iE8r2");
const $b6e693db8a3ca69e$export$68d003d3105952ad = {
    on (event, listener) {
        if ((0, $iE8r2.mediaState).eventEmitter) (0, $iE8r2.mediaState).eventEmitter.on(event, listener);
    },
    off (event, listener) {
        if ((0, $iE8r2.mediaState).eventEmitter) (0, $iE8r2.mediaState).eventEmitter.off(event, listener);
    },
    emit (event, payload) {
        if ((0, $iE8r2.mediaState).eventEmitter) return (0, $iE8r2.mediaState).eventEmitter.emit(event, payload);
        return undefined;
    }
};

});

parcelRegister("bxYYu", function(module, exports) {
// Regular expression used for basic parsing of the uuid.

var $aul3P = parcelRequire("aul3P");
var $8682131465584b62$require$Buffer = $aul3P.Buffer;
var $8682131465584b62$var$pattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
/**
 * Unparses a UUID buffer to a string. From node-uuid:
 * https://github.com/defunctzombie/node-uuid/blob/master/uuid.js
 *
 * Copyright (c) 2010-2012 Robert Kieffer
 * MIT License - http://opensource.org/licenses/mit-license.php
 *
 * @param  {Buffer} buf
 * @param  {Number=0} offset
 * @return {String}
 */ var $8682131465584b62$var$_byteToHex = [];
for(var $8682131465584b62$var$i = 0; $8682131465584b62$var$i < 256; $8682131465584b62$var$i++)$8682131465584b62$var$_byteToHex[$8682131465584b62$var$i] = ($8682131465584b62$var$i + 0x100).toString(16).substr(1);
function $8682131465584b62$var$unparse(buf, offset) {
    var i = offset || 0, bth = $8682131465584b62$var$_byteToHex;
    return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
}
/**
 * Determines whether the uuid is valid, converting
 * it from a buffer if necessary.
 *
 * @param  {String|Buffer}  uuid
 * @param  {Number=}  version
 * @return {Boolean}
 */ module.exports = function(uuid, version) {
    var parsedUuid;
    // If the uuid is a biffer, parse it...
    if ($8682131465584b62$require$Buffer.isBuffer(uuid)) parsedUuid = $8682131465584b62$var$unparse(uuid);
    else if (Object.prototype.toString.call(uuid) === '[object String]') parsedUuid = uuid;
    else return false;
    parsedUuid = parsedUuid.toLowerCase();
    // All UUIDs fit a basic schema. Match that.
    if (!$8682131465584b62$var$pattern.test(parsedUuid)) return false;
    // Now extract the version...
    if (version === undefined) version = $8682131465584b62$var$extractVersion(parsedUuid);
    else if ($8682131465584b62$var$extractVersion(parsedUuid) !== version) return false;
    switch(version){
        // For certain versions, the checks we did up to this point are fine.
        case 1:
        case 2:
            return true;
        // For versions 3 and 4, they must specify a variant.
        case 3:
        case 4:
        case 5:
            return [
                '8',
                '9',
                'a',
                'b'
            ].indexOf(parsedUuid.charAt(19)) !== -1;
        default:
            // We should only be able to reach this if the consumer explicitly
            // provided an invalid version. Prior to extractVersion we check
            // that it's 1-4 in the regex.
            throw new Error('Invalid version provided.');
    }
};
/**
 * Extracts the version from the UUID, which is (by definition) the M in
 * xxxxxxxx-xxxx-Mxxx-Nxxx-xxxxxxxxxxxx
 *
 * @param  {String} uuid
 * @return {Number}
 */ var $8682131465584b62$var$extractVersion = module.exports.version = function(uuid) {
    return uuid.charAt(14) | 0;
};

});

parcelRegister("bVMx4", function(module, exports) {

$parcel$export(module.exports, "createFileDataloader", () => $d49dc51366e1ddfa$export$ae188fee39529b82);
// import setimmediate to temporary fix dataloader 2.0.0 bug
// @see https://github.com/graphql/dataloader/issues/249
parcelRequire("inzmU");

var $59wjN = parcelRequire("59wjN");

var $5Cq8b = parcelRequire("5Cq8b");
const $d49dc51366e1ddfa$export$b79d95ee17a87a = 100;
const $d49dc51366e1ddfa$var$isBatchLoadingErrorResult = (result)=>{
    return result.error instanceof Error;
};
const $d49dc51366e1ddfa$var$makeCacheKey = (id, collection)=>collection ? `${id}-${collection}` : id;
const $d49dc51366e1ddfa$export$71cd2e8f8162d47b = (dataloaderKeys, fileItems)=>{
    const itemsByKey = fileItems.reduce((prev, fileItem)=>{
        const { id: id, collection: collection } = fileItem;
        const key = $d49dc51366e1ddfa$var$makeCacheKey(id, collection);
        prev[key] = $d49dc51366e1ddfa$var$isBatchLoadingErrorResult(fileItem) ? fileItem.error : {
            ...fileItem.details,
            metadataTraceContext: fileItem.metadataTraceContext
        };
        return prev;
    }, {});
    return dataloaderKeys.map((dataloaderKey)=>{
        const { id: id, collectionName: collectionName } = dataloaderKey;
        const key = $d49dc51366e1ddfa$var$makeCacheKey(id, collectionName);
        return itemsByKey[key] || null;
    });
};
function $d49dc51366e1ddfa$export$4a53beb129e8c49a(mediaStore) {
    return async (keys)=>{
        const nonCollectionName = '__media-single-file-collection__';
        const fileIdsByCollection = keys.reduce((acc, key)=>{
            const collectionName = key.collectionName || nonCollectionName;
            const fileIds = acc[collectionName] || [];
            // de-duplicate ids in collection
            if (fileIds.indexOf(key.id) === -1) fileIds.push(key.id);
            acc[collectionName] = fileIds;
            return acc;
        }, {});
        const items = [];
        await Promise.all(Object.keys(fileIdsByCollection).map(async (collectionNameKey)=>{
            const metadataTraceContext = {
                traceId: (0, $5Cq8b.getRandomHex)(8),
                spanId: (0, $5Cq8b.getRandomHex)(8)
            };
            const fileIds = fileIdsByCollection[collectionNameKey];
            const collectionName = collectionNameKey === nonCollectionName ? undefined : collectionNameKey;
            try {
                const response = await mediaStore.getItems(fileIds, collectionName, metadataTraceContext);
                const itemsWithMetadataTraceContext = response.data.items.map((item)=>({
                        ...item,
                        metadataTraceContext: metadataTraceContext
                    }));
                items.push(...itemsWithMetadataTraceContext);
            } catch (error) {
                fileIds.forEach((fileId)=>{
                    items.push({
                        id: fileId,
                        collection: collectionName,
                        error: error
                    });
                });
            }
        }));
        return $d49dc51366e1ddfa$export$71cd2e8f8162d47b(keys, items);
    };
}
function $d49dc51366e1ddfa$export$ae188fee39529b82(mediaStore) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($59wjN)))($d49dc51366e1ddfa$export$4a53beb129e8c49a(mediaStore), {
        maxBatchSize: $d49dc51366e1ddfa$export$b79d95ee17a87a
    });
}

});
parcelRegister("59wjN", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
"use strict";
/**
 * Copyright (c) 2019-present, GraphQL Foundation
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ // A Function, which when given an Array of keys, returns a Promise of an Array
// of values or Errors.
// Optionally turn off batching or caching or provide a cache key function or a
// custom cache instance.
// If a custom cache is provided, it must be of this type (a subset of ES6 Map).
/**
 * A `DataLoader` creates a public API for loading data from a particular
 * data back-end with unique keys such as the `id` column of a SQL table or
 * document name in a MongoDB database, given a batch loading function.
 *
 * Each `DataLoader` instance contains a unique memoized cache. Use caution when
 * used in long-lived applications or those which serve many users with
 * different access permissions and consider creating a new instance per
 * web request.
 */ var $3c06dcbd0553bcff$var$DataLoader = /*#__PURE__*/ function() {
    function DataLoader(batchLoadFn, options) {
        if (typeof batchLoadFn !== 'function') throw new TypeError('DataLoader must be constructed with a function which accepts ' + ("Array<key> and returns Promise<Array<value>>, but got: " + batchLoadFn + "."));
        this._batchLoadFn = batchLoadFn;
        this._maxBatchSize = $3c06dcbd0553bcff$var$getValidMaxBatchSize(options);
        this._batchScheduleFn = $3c06dcbd0553bcff$var$getValidBatchScheduleFn(options);
        this._cacheKeyFn = $3c06dcbd0553bcff$var$getValidCacheKeyFn(options);
        this._cacheMap = $3c06dcbd0553bcff$var$getValidCacheMap(options);
        this._batch = null;
    } // Private
    var _proto = DataLoader.prototype;
    /**
   * Loads a key, returning a `Promise` for the value represented by that key.
   */ _proto.load = function load(key) {
        if (key === null || key === undefined) throw new TypeError('The loader.load() function must be called with a value,' + ("but got: " + String(key) + "."));
        var batch = $3c06dcbd0553bcff$var$getCurrentBatch(this);
        var cacheMap = this._cacheMap;
        var cacheKey = this._cacheKeyFn(key); // If caching and there is a cache-hit, return cached Promise.
        if (cacheMap) {
            var cachedPromise = cacheMap.get(cacheKey);
            if (cachedPromise) {
                var cacheHits = batch.cacheHits || (batch.cacheHits = []);
                return new Promise(function(resolve) {
                    cacheHits.push(function() {
                        return resolve(cachedPromise);
                    });
                });
            }
        } // Otherwise, produce a new Promise for this key, and enqueue it to be
        // dispatched along with the current batch.
        batch.keys.push(key);
        var promise = new Promise(function(resolve, reject) {
            batch.callbacks.push({
                resolve: resolve,
                reject: reject
            });
        }); // If caching, cache this promise.
        if (cacheMap) cacheMap.set(cacheKey, promise);
        return promise;
    } /**
   * Loads multiple keys, promising an array of values:
   *
   *     var [ a, b ] = await myLoader.loadMany([ 'a', 'b' ]);
   *
   * This is similar to the more verbose:
   *
   *     var [ a, b ] = await Promise.all([
   *       myLoader.load('a'),
   *       myLoader.load('b')
   *     ]);
   *
   * However it is different in the case where any load fails. Where
   * Promise.all() would reject, loadMany() always resolves, however each result
   * is either a value or an Error instance.
   *
   *     var [ a, b, c ] = await myLoader.loadMany([ 'a', 'b', 'badkey' ]);
   *     // c instanceof Error
   *
   */ ;
    _proto.loadMany = function loadMany(keys) {
        if (!$3c06dcbd0553bcff$var$isArrayLike(keys)) throw new TypeError('The loader.loadMany() function must be called with Array<key> ' + ("but got: " + keys + "."));
         // Support ArrayLike by using only minimal property access
        var loadPromises = [];
        for(var i = 0; i < keys.length; i++)loadPromises.push(this.load(keys[i])["catch"](function(error) {
            return error;
        }));
        return Promise.all(loadPromises);
    } /**
   * Clears the value at `key` from the cache, if it exists. Returns itself for
   * method chaining.
   */ ;
    _proto.clear = function clear(key) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key);
            cacheMap["delete"](cacheKey);
        }
        return this;
    } /**
   * Clears the entire cache. To be used when some event results in unknown
   * invalidations across this particular `DataLoader`. Returns itself for
   * method chaining.
   */ ;
    _proto.clearAll = function clearAll() {
        var cacheMap = this._cacheMap;
        if (cacheMap) cacheMap.clear();
        return this;
    } /**
   * Adds the provided key and value to the cache. If the key already
   * exists, no change is made. Returns itself for method chaining.
   *
   * To prime the cache with an error at a key, provide an Error instance.
   */ ;
    _proto.prime = function prime(key, value) {
        var cacheMap = this._cacheMap;
        if (cacheMap) {
            var cacheKey = this._cacheKeyFn(key); // Only add the key if it does not already exist.
            if (cacheMap.get(cacheKey) === undefined) {
                // Cache a rejected promise if the value is an Error, in order to match
                // the behavior of load(key).
                var promise;
                if (value instanceof Error) {
                    promise = Promise.reject(value); // Since this is a case where an Error is intentionally being primed
                    // for a given key, we want to disable unhandled promise rejection.
                    promise["catch"](function() {});
                } else promise = Promise.resolve(value);
                cacheMap.set(cacheKey, promise);
            }
        }
        return this;
    };
    return DataLoader;
}(); // Private: Enqueue a Job to be executed after all "PromiseJobs" Jobs.
//
// ES6 JavaScript uses the concepts Job and JobQueue to schedule work to occur
// after the current execution context has completed:
// http://www.ecma-international.org/ecma-262/6.0/#sec-jobs-and-job-queues
//
// Node.js uses the `process.nextTick` mechanism to implement the concept of a
// Job, maintaining a global FIFO JobQueue for all Jobs, which is flushed after
// the current call stack ends.
//
// When calling `then` on a Promise, it enqueues a Job on a specific
// "PromiseJobs" JobQueue which is flushed in Node as a single Job on the
// global JobQueue.
//
// DataLoader batches all loads which occur in a single frame of execution, but
// should include in the batch all loads which occur during the flushing of the
// "PromiseJobs" JobQueue after that same execution frame.
//
// In order to avoid the DataLoader dispatch Job occuring before "PromiseJobs",
// A Promise Job is created with the sole purpose of enqueuing a global Job,
// ensuring that it always occurs after "PromiseJobs" ends.
//
// Node.js's job queue is unique. Browsers do not have an equivalent mechanism
// for enqueuing a job to be performed after promise microtasks and before the
// next macrotask. For browser environments, a macrotask is used (via
// setImmediate or setTimeout) at a potential performance penalty.
var $3c06dcbd0553bcff$var$enqueuePostPromiseJob = typeof $2fFJv === 'object' && typeof $2fFJv.nextTick === 'function' ? function(fn) {
    if (!$3c06dcbd0553bcff$var$resolvedPromise) $3c06dcbd0553bcff$var$resolvedPromise = Promise.resolve();
    $3c06dcbd0553bcff$var$resolvedPromise.then(function() {
        return $2fFJv.nextTick(fn);
    });
} : setImmediate || setTimeout; // Private: cached resolved Promise instance
var $3c06dcbd0553bcff$var$resolvedPromise; // Private: Describes a batch of requests
// Private: Either returns the current batch, or creates and schedules a
// dispatch of a new batch for the given loader.
function $3c06dcbd0553bcff$var$getCurrentBatch(loader) {
    // If there is an existing batch which has not yet dispatched and is within
    // the limit of the batch size, then return it.
    var existingBatch = loader._batch;
    if (existingBatch !== null && !existingBatch.hasDispatched && existingBatch.keys.length < loader._maxBatchSize && (!existingBatch.cacheHits || existingBatch.cacheHits.length < loader._maxBatchSize)) return existingBatch;
     // Otherwise, create a new batch for this loader.
    var newBatch = {
        hasDispatched: false,
        keys: [],
        callbacks: []
    }; // Store it on the loader so it may be reused.
    loader._batch = newBatch; // Then schedule a task to dispatch this batch of requests.
    loader._batchScheduleFn(function() {
        return $3c06dcbd0553bcff$var$dispatchBatch(loader, newBatch);
    });
    return newBatch;
}
function $3c06dcbd0553bcff$var$dispatchBatch(loader, batch) {
    // Mark this batch as having been dispatched.
    batch.hasDispatched = true; // If there's nothing to load, resolve any cache hits and return early.
    if (batch.keys.length === 0) {
        $3c06dcbd0553bcff$var$resolveCacheHits(batch);
        return;
    } // Call the provided batchLoadFn for this loader with the batch's keys and
    // with the loader as the `this` context.
    var batchPromise = loader._batchLoadFn(batch.keys); // Assert the expected response from batchLoadFn
    if (!batchPromise || typeof batchPromise.then !== 'function') return $3c06dcbd0553bcff$var$failedDispatch(loader, batch, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(batchPromise) + ".")));
     // Await the resolution of the call to batchLoadFn.
    batchPromise.then(function(values) {
        // Assert the expected resolution from batchLoadFn.
        if (!$3c06dcbd0553bcff$var$isArrayLike(values)) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(values) + "."));
        if (values.length !== batch.keys.length) throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + ("\n\nKeys:\n" + String(batch.keys)) + ("\n\nValues:\n" + String(values)));
         // Resolve all cache hits in the same micro-task as freshly loaded values.
        $3c06dcbd0553bcff$var$resolveCacheHits(batch); // Step through values, resolving or rejecting each Promise in the batch.
        for(var i = 0; i < batch.callbacks.length; i++){
            var value = values[i];
            if (value instanceof Error) batch.callbacks[i].reject(value);
            else batch.callbacks[i].resolve(value);
        }
    })["catch"](function(error) {
        return $3c06dcbd0553bcff$var$failedDispatch(loader, batch, error);
    });
} // Private: do not cache individual loads if the entire batch dispatch fails,
// but still reject each request so they do not hang.
function $3c06dcbd0553bcff$var$failedDispatch(loader, batch, error) {
    // Cache hits are resolved, even though the batch failed.
    $3c06dcbd0553bcff$var$resolveCacheHits(batch);
    for(var i = 0; i < batch.keys.length; i++){
        loader.clear(batch.keys[i]);
        batch.callbacks[i].reject(error);
    }
} // Private: Resolves the Promises for any cache hits in this batch.
function $3c06dcbd0553bcff$var$resolveCacheHits(batch) {
    if (batch.cacheHits) for(var i = 0; i < batch.cacheHits.length; i++)batch.cacheHits[i]();
} // Private: given the DataLoader's options, produce a valid max batch size.
function $3c06dcbd0553bcff$var$getValidMaxBatchSize(options) {
    var shouldBatch = !options || options.batch !== false;
    if (!shouldBatch) return 1;
    var maxBatchSize = options && options.maxBatchSize;
    if (maxBatchSize === undefined) return Infinity;
    if (typeof maxBatchSize !== 'number' || maxBatchSize < 1) throw new TypeError("maxBatchSize must be a positive number: " + maxBatchSize);
    return maxBatchSize;
} // Private
function $3c06dcbd0553bcff$var$getValidBatchScheduleFn(options) {
    var batchScheduleFn = options && options.batchScheduleFn;
    if (batchScheduleFn === undefined) return $3c06dcbd0553bcff$var$enqueuePostPromiseJob;
    if (typeof batchScheduleFn !== 'function') throw new TypeError("batchScheduleFn must be a function: " + batchScheduleFn);
    return batchScheduleFn;
} // Private: given the DataLoader's options, produce a cache key function.
function $3c06dcbd0553bcff$var$getValidCacheKeyFn(options) {
    var cacheKeyFn = options && options.cacheKeyFn;
    if (cacheKeyFn === undefined) return function(key) {
        return key;
    };
    if (typeof cacheKeyFn !== 'function') throw new TypeError("cacheKeyFn must be a function: " + cacheKeyFn);
    return cacheKeyFn;
} // Private: given the DataLoader's options, produce a CacheMap to be used.
function $3c06dcbd0553bcff$var$getValidCacheMap(options) {
    var shouldCache = !options || options.cache !== false;
    if (!shouldCache) return null;
    var cacheMap = options && options.cacheMap;
    if (cacheMap === undefined) return new Map();
    if (cacheMap !== null) {
        var cacheFunctions = [
            'get',
            'set',
            'delete',
            'clear'
        ];
        var missingFunctions = cacheFunctions.filter(function(fnName) {
            return cacheMap && typeof cacheMap[fnName] !== 'function';
        });
        if (missingFunctions.length !== 0) throw new TypeError('Custom cacheMap missing methods: ' + missingFunctions.join(', '));
    }
    return cacheMap;
} // Private
function $3c06dcbd0553bcff$var$isArrayLike(x) {
    return typeof x === 'object' && x !== null && typeof x.length === 'number' && (x.length === 0 || x.length > 0 && Object.prototype.hasOwnProperty.call(x, x.length - 1));
}
module.exports = $3c06dcbd0553bcff$var$DataLoader;

});


parcelRegister("04AOJ", function(module, exports) {

$parcel$export(module.exports, "getMediaTypeFromUploadableFile", () => $2d99bdcc193fb729$export$ac3214931ffd82af);

var $3izHV = parcelRequire("3izHV");
const $2d99bdcc193fb729$export$ac3214931ffd82af = (file)=>{
    if (file.content instanceof Blob) {
        const type = file.content.type;
        return (0, $3izHV.getMediaTypeFromMimeType)(type);
    } else return 'unknown';
};

});
parcelRegister("3izHV", function(module, exports) {

$parcel$export(module.exports, "getMediaTypeFromMimeType", () => $271e34cd6fe1cabd$export$79e1dc0d1801e8ef);
$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => (parcelRequire("br8gy")).isImageMimeTypeSupportedByBrowser);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => (parcelRequire("br8gy")).isVideoMimeTypeSupportedByBrowser);

var $hZoAg = parcelRequire("hZoAg");

var $br8gy = parcelRequire("br8gy");

var $5BRco = parcelRequire("5BRco");
const $271e34cd6fe1cabd$export$79e1dc0d1801e8ef = (mimeType)=>{
    if ((0, $hZoAg.isArchive)(mimeType)) return 'archive';
    if ((0, $br8gy.isImageMimeTypeSupportedByBrowser)(mimeType) || (0, $5BRco.isImageMimeTypeSupportedByServer)(mimeType)) return 'image';
    if ((0, $br8gy.isDocumentMimeTypeSupportedByBrowser)(mimeType) || (0, $5BRco.isDocumentMimeTypeSupportedByServer)(mimeType)) return 'doc';
    if ((0, $br8gy.isAudioMimeTypeSupportedByBrowser)(mimeType) || (0, $5BRco.isAudioMimeTypeSupportedByServer)(mimeType)) return 'audio';
    if ((0, $br8gy.isVideoMimeTypeSupportedByBrowser)(mimeType) || (0, $5BRco.isVideoMimeTypeSupportedByServer)(mimeType)) return 'video';
    return 'unknown';
};

});
parcelRegister("hZoAg", function(module, exports) {

$parcel$export(module.exports, "isArchive", () => $4c79e3ce7fc2a8d0$export$f47f3fe506e20fe6);
// Based on https://en.wikipedia.org/wiki/List_of_archive_formats
const $4c79e3ce7fc2a8d0$export$f47f3fe506e20fe6 = (mimeType)=>[
        'application/x-archive',
        'application/x-cpio',
        'application/x-shar',
        'application/x-iso9660-image',
        'application/x-sbx',
        'application/x-tar',
        'application/x-bzip2',
        'application/gzip',
        'application/x-gzip',
        'application/x-lzip',
        'application/x-lzma',
        'application/x-lzop',
        'application/x-snappy-framed',
        'application/x-xz',
        'application/x-compress',
        'application/zstd',
        'application/x-7z-compressed',
        'application/x-ace-compressed',
        'application/x-astrotite-afa',
        'application/x-alz-compressed',
        'application/vnd.android.package-archive',
        'application/x-freearc',
        'application/x-arj',
        'application/x-b1',
        'application/vnd.ms-cab-compressed',
        'application/x-cfs-compressed',
        'application/x-dar',
        'application/x-dgc-compressed',
        'application/x-apple-diskimage',
        'application/x-gca-compressed',
        'application/java-archive',
        'application/x-lzh',
        'application/x-lzx',
        'application/x-rar-compressed',
        'application/x-stuffit',
        'application/x-stuffitx',
        'application/x-gtar',
        'application/x-ms-wim',
        'application/x-xar',
        'application/zip',
        'application/x-zoo',
        'application/x-par2'
    ].indexOf(mimeType.toLowerCase()) > -1;

});

parcelRegister("br8gy", function(module, exports) {

$parcel$export(module.exports, "isImageMimeTypeSupportedByBrowser", () => $7e5c6394ef188971$export$c021f2623a75015f);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByBrowser", () => $7e5c6394ef188971$export$74325e3c843a9555);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByBrowser", () => $7e5c6394ef188971$export$ff36075ea755a717);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByBrowser", () => $7e5c6394ef188971$export$87bf945cf31ec2d9);
$parcel$export(module.exports, "isMimeTypeSupportedByBrowser", () => $7e5c6394ef188971$export$55ca6cdaf6093034);
// Based on https://developer.mozilla.org/en-US/docs/Web/Media/Formats/Image_types
const $7e5c6394ef188971$export$c021f2623a75015f = (mimeType)=>[
        'image/apng',
        'image/bmp',
        'image/gif',
        'image/x-icon',
        'image/jpeg',
        'image/png',
        'image/webp'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $7e5c6394ef188971$export$74325e3c843a9555 = (mimeType)=>mimeType.toLowerCase() === 'application/pdf';
const $7e5c6394ef188971$export$ff36075ea755a717 = (mimeType)=>[
        'audio/aac',
        'audio/flac',
        'audio/mp4',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/wav',
        'audio/x-wav'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $7e5c6394ef188971$export$87bf945cf31ec2d9 = (mimeType)=>[
        'video/mp4',
        'video/quicktime'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $7e5c6394ef188971$export$55ca6cdaf6093034 = (mimeType)=>$7e5c6394ef188971$export$74325e3c843a9555(mimeType) || $7e5c6394ef188971$export$c021f2623a75015f(mimeType) || $7e5c6394ef188971$export$ff36075ea755a717(mimeType) || $7e5c6394ef188971$export$87bf945cf31ec2d9(mimeType);

});

parcelRegister("5BRco", function(module, exports) {

$parcel$export(module.exports, "isImageMimeTypeSupportedByServer", () => $85f5842a210424b1$export$e9a065a80f76311e);
$parcel$export(module.exports, "isDocumentMimeTypeSupportedByServer", () => $85f5842a210424b1$export$86baad7a89d908e9);
$parcel$export(module.exports, "isAudioMimeTypeSupportedByServer", () => $85f5842a210424b1$export$8cba23825d020bbb);
$parcel$export(module.exports, "isVideoMimeTypeSupportedByServer", () => $85f5842a210424b1$export$9c2b4de5fdca2ce3);
$parcel$export(module.exports, "isMimeTypeSupportedByServer", () => $85f5842a210424b1$export$548d9148a80556a3);
// Based on https://developer.atlassian.com/platform/media/learning/file-previews/
const $85f5842a210424b1$export$e9a065a80f76311e = (mimeType)=>[
        'image/bmp',
        'image/x-windows-bmp',
        'application/dicom',
        'image/gif',
        'image/jpeg',
        'image/jpg',
        'image/jp_',
        'application/jpg',
        'application/x-jpg',
        'image/png',
        'application/png',
        'application/x-png',
        'application/vnd.adobe.photoshop',
        'image/vnd.adobe.photoshop',
        'image/photoshop',
        'image/x-photoshop',
        'image/psd',
        'application/photoshop',
        'application/psd',
        'zz-application/zz-winassoc-psd',
        'image/tiff',
        'image/x-tif',
        'image/x-tiff',
        'application/tif',
        'application/x-tif',
        'application/tiff',
        'application/x-tiff',
        'image/svg+xml',
        'image/heif',
        'image/heif-sequence',
        'image/heic',
        'image/heic-sequence'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $85f5842a210424b1$export$86baad7a89d908e9 = (mimeType)=>[
        // Adobe PDF
        'application/pdf',
        'application/x-pdf',
        'application/acrobat',
        'applications/vnd.pdf',
        'text/pdf',
        'text/x-pdf',
        // Adobe Illustrator
        'application/vnd.adobe.illustrator',
        // Microsoft Office
        'application/vnd.ms-office',
        // Microsoft Word
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
        'application/vnd.ms-word.document.macroenabled.12',
        'application/vnd.ms-word.template.macroenabled.12',
        // Microsoft Excel
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
        'application/vnd.ms-excel.sheet.macroenabled.12',
        'application/vnd.ms-excel.template.macroenabled.12',
        'application/vnd.ms-excel.addin.macroenabled.12',
        'application/vnd.ms-excel.sheet.macroenabled',
        'application/vnd.ms-excel.template.macroenabled',
        'application/vnd.ms-excel.addin.macroenabled',
        // Microsoft Powerpoint
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'application/vnd.openxmlformats-officedocument.presentationml.template',
        'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
        'application/vnd.ms-powerpoint.presentation.macroenabled.12',
        'application/vnd.ms-powerpoint.template.macroenabled.12',
        'application/vnd.ms-powerpoint.slideshow.macroenabled.12',
        // OpenOffice
        'application/vnd.sun.xml.writer',
        'application/vnd.sun.xml.writer.template',
        // OpenDocument
        'application/vnd.sun.xml.draw',
        'application/vnd.sun.xml.draw.template',
        'application/vnd.oasis.opendocument.graphics',
        'application/vnd.oasis.opendocument.presentation',
        'application/x-vnd.oasis.opendocument.presentation',
        'application/vnd.sun.xml.calc',
        'application/vnd.sun.xml.calc.template',
        'application/vnd.oasis.opendocument.spreadsheet',
        'application/x-vnd.oasis.opendocument.spreadsheet',
        'application/vnd.oasis.opendocument.spreadsheet-template',
        'application/vnd.oasis.opendocument.text',
        'application/vnd.oasis.opendocument.text-template',
        'application/vnd.oasis.opendocument.text-master',
        'application/x-vnd.oasis.opendocument.text',
        'application/x-vnd.oasis.opendocument.text-template',
        'application/x-vnd.oasis.opendocument.text-master',
        // WordPerfect
        'application/vnd.wordperfect',
        // Text files
        'text/csv',
        'text/x-diff',
        'text/x-perl',
        'text/x-python',
        'text/x-ruby',
        'text/rtf',
        'text/richtext',
        'text/plain',
        'application/txt',
        // Rich text
        'application/rtf',
        'application/x-rtf',
        // PostScript
        'application/postscript'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $85f5842a210424b1$export$8cba23825d020bbb = (mimeType)=>[
        'audio/aac',
        'audio/x-hx-aac-adts',
        'audio/vnd.dolby.dd-raw',
        'audio/aiff',
        'audio/x-aiff',
        'audio/x-monkeys-audio',
        'audio/x-ape',
        'audio/basic',
        'audio/flac',
        'audio/mp4',
        'audio/midi',
        'audio/x-matroska',
        'audio/x-mod',
        'audio/mpeg',
        'audio/ogg',
        'audio/x-ogg',
        'audio/x-pn-realaudio',
        'audio/wav',
        'audio/x-wav',
        'audio/x-ms-wma'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $85f5842a210424b1$export$9c2b4de5fdca2ce3 = (mimeType)=>[
        'video/3gpp',
        'video/3gpp2',
        'video/x-ms-asf',
        'video/avi',
        'video/msvideo',
        'video/x-msvideo',
        'video/x-dv',
        'video/x-flv',
        'video/m2ts',
        'video/x-m4v',
        'video/x-matroska',
        'video/quicktime',
        'video/mp4',
        'video/mpeg',
        'video/ogg',
        'video/x-ogg',
        'video/webm',
        'video/x-ms-wmv'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $85f5842a210424b1$export$94e1479e01d2af53 = (mimeType)=>[
        'binary/octet-stream'
    ].indexOf(mimeType.toLowerCase()) > -1;
const $85f5842a210424b1$export$548d9148a80556a3 = (mimeType)=>$85f5842a210424b1$export$e9a065a80f76311e(mimeType) || $85f5842a210424b1$export$86baad7a89d908e9(mimeType) || $85f5842a210424b1$export$8cba23825d020bbb(mimeType) || $85f5842a210424b1$export$9c2b4de5fdca2ce3(mimeType) || $85f5842a210424b1$export$94e1479e01d2af53(mimeType);

});



parcelRegister("9sBfG", function(module, exports) {

$parcel$export(module.exports, "overrideMediaTypeIfUnknown", () => $4579abe2682788f5$export$89097c0ec1e0dee1);

var $9x67R = parcelRequire("9x67R");
const $4579abe2682788f5$export$89097c0ec1e0dee1 = (fileState, mediaType)=>{
    if (!(0, $9x67R.isErrorFileState)(fileState) && fileState.mediaType === 'unknown') return {
        mediaType: mediaType
    };
    return {};
};

});

parcelRegister("dpRAQ", function(module, exports) {

$parcel$export(module.exports, "convertBase64ToBlob", () => $241808151c7df3d7$export$ed17558b11b88056);
const $241808151c7df3d7$export$ed17558b11b88056 = (base64)=>{
    const sliceSize = 512;
    const base64Data = base64.split(',')[1];
    const byteCharacters = atob(base64Data);
    const byteArrays = [];
    for(let offset = 0; offset < byteCharacters.length; offset += sliceSize){
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = slice.split('').map((_, i)=>slice.charCodeAt(i));
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }
    return new Blob(byteArrays, {
        type: 'image/jpeg'
    });
};

});

parcelRegister("eqcfa", function(module, exports) {

$parcel$export(module.exports, "fromObservable", () => $5370b0715ba587e9$export$4b2432e2d8723823);

var $rMufQ = parcelRequire("rMufQ");
function $5370b0715ba587e9$export$4b2432e2d8723823(observable) {
    return {
        subscribe: (observer)=>{
            const subscription = // This is needed to handle "subscribe" function overload.
            // It allows accepting a single "next" callback function as an argument.
            observer instanceof Function ? observable.subscribe(observer) : observable.subscribe(observer);
            return {
                unsubscribe: ()=>{
                    subscription.unsubscribe();
                }
            };
        }
    };
}
function $5370b0715ba587e9$export$8659d1f07d151381(item) {
    return $5370b0715ba587e9$export$4b2432e2d8723823((0, $rMufQ.createMediaSubject)(item));
}

});
parcelRegister("rMufQ", function(module, exports) {

$parcel$export(module.exports, "createMediaSubject", () => $b1945b205bb99a41$export$bc76d51553fa5e35);

var $lXGL9 = parcelRequire("lXGL9");
function $b1945b205bb99a41$export$bc76d51553fa5e35(initialState) {
    const subject = new (0, $lXGL9.ReplaySubject)(1);
    if (initialState instanceof Error) subject.error(initialState);
    else if (initialState) subject.next(initialState);
    return subject;
}

});


parcelRegister("9BeXg", function(module, exports) {

$parcel$export(module.exports, "toPromise", () => $41ac1ff94334ef1d$export$4dbaaf6c79705e6c);

var $hIoOm = parcelRequire("hIoOm");
const $41ac1ff94334ef1d$export$4dbaaf6c79705e6c = (mediaSubscribable, subscription = new (0, $hIoOm.Subscription)())=>new Promise((resolve, reject)=>subscription.add(mediaSubscribable.subscribe({
            next: (state)=>{
                resolve(state);
                subscription.unsubscribe();
            },
            error: (error)=>{
                reject(error);
                subscription.unsubscribe();
            }
        })));

});

parcelRegister("cfjUA", function(module, exports) {

$parcel$export(module.exports, "getDimensionsFromBlob", () => $e97c761e4a22f2e8$export$71797c284d89a3e1);

var $leGRQ = parcelRequire("leGRQ");

var $USL4H = parcelRequire("USL4H");
const $e97c761e4a22f2e8$export$71797c284d89a3e1 = async (mediaType, blob)=>{
    switch(mediaType){
        case 'image':
            {
                const url = URL.createObjectURL(blob);
                try {
                    return await (0, $leGRQ.getImageDimensionsFromBlob)(url);
                } finally{
                    URL.revokeObjectURL(url);
                }
            }
        case 'video':
            return (0, $USL4H.getVideoDimensionsFromBlob)(blob);
        default:
            throw new Error(`Can't extract dimensions from ${mediaType}`);
    }
};

});
parcelRegister("leGRQ", function(module, exports) {

$parcel$export(module.exports, "getImageDimensionsFromBlob", () => $dc02c409650d12cb$export$a1c3205f28a20414);
const $dc02c409650d12cb$export$a1c3205f28a20414 = (url)=>new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = url;
        img.onload = ()=>resolve({
                width: img.width,
                height: img.height
            });
        img.onerror = reject;
    });

});

parcelRegister("USL4H", function(module, exports) {

$parcel$export(module.exports, "getVideoDimensionsFromBlob", () => $8e2e403157239a69$export$62aabd5ff85d0451);
const $8e2e403157239a69$export$62aabd5ff85d0451 = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        // loadedmetadata, loadeddata, play, playing
        video.addEventListener('loadedmetadata', function timeupdateHandler() {
            video.removeEventListener('loadedmetadata', timeupdateHandler);
            resolve({
                width: video.videoWidth,
                height: video.videoHeight
            });
            URL.revokeObjectURL(url);
        });
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});


parcelRegister("cILCr", function(module, exports) {

$parcel$export(module.exports, "shouldFetchRemoteFileStates", () => $5cccb92ec7f36e1d$export$2ccdd6f9a9eba6a);

var $br8gy = parcelRequire("br8gy");
var $5BRco = parcelRequire("5BRco");

var $USL4H = parcelRequire("USL4H");
async function $5cccb92ec7f36e1d$export$2ccdd6f9a9eba6a(mediaType, mimeType, preview) {
    if ((mediaType === 'doc' || !(0, $br8gy.isMimeTypeSupportedByBrowser)(mimeType) || !preview) && (0, $5BRco.isMimeTypeSupportedByServer)(mimeType)) return true;
    if (mediaType === 'video' && !!preview) {
        const content = (await preview).value;
        if (!(content instanceof Blob)) return false;
        try {
            const { width: width, height: height } = await (0, $USL4H.getVideoDimensionsFromBlob)(content);
            return !width && !height;
        } catch (e) {
            // any exception from getVideoDimensionsFromBlob() may imply that local video isn't playable
            // hence we'll need remote fileStates to grab a "processed" video
            return true;
        }
    }
    return false;
}

});

parcelRegister("eqlnz", function(module, exports) {

$parcel$export(module.exports, "PollingFunction", () => $f01979f4321e41b7$export$4c54d536f8e37dc2);

var $foadk = parcelRequire("foadk");
const $f01979f4321e41b7$export$9f15a162d6785fc9 = {
    poll_intervalMs: 3000,
    poll_maxAttempts: 30,
    poll_backoffFactor: 1.25,
    poll_maxIntervalMs: 200000
};
class $f01979f4321e41b7$export$4c54d536f8e37dc2 {
    constructor(options){
        this.poll_intervalMs = 0;
        this.attempt = 1;
        this.shouldIterate = true;
        this.timeoutId = 0;
        this.options = {
            ...$f01979f4321e41b7$export$9f15a162d6785fc9,
            ...options
        };
        this.poll_intervalMs = this.options.poll_intervalMs;
    }
    async execute(executor) {
        const { poll_maxAttempts: poll_maxAttempts } = this.options;
        if (poll_maxAttempts === 0) // hard kill, polling disabled
        return this.fail(new (0, $foadk.PollingError)('pollingMaxAttemptsExceeded', this.attempt));
        try {
            // executor must explicitly call this.next() for triggering next iteration (pull)
            this.shouldIterate = false;
            await executor();
            if (!this.shouldIterate) return;
            if (this.attempt >= poll_maxAttempts) // max iterations exceeded, let the consumer know
            return this.fail(new (0, $foadk.PollingError)('pollingMaxAttemptsExceeded', this.attempt));
            this.poll_intervalMs = this.getIntervalMsForIteration(this.attempt);
            this.attempt++;
            this.timeoutId = window.setTimeout(()=>this.execute(executor), this.poll_intervalMs);
        } catch (error) {
            this.fail(error);
        }
    }
    fail(error) {
        const { onError: onError } = this;
        this.cancel();
        onError && onError(error);
    }
    getIntervalMsForIteration(iteration) {
        let poll_intervalMs = this.options.poll_intervalMs;
        if (iteration === 1) return poll_intervalMs;
        for(let i = 2; i <= iteration; i++)poll_intervalMs = poll_intervalMs * this.options.poll_backoffFactor;
        return Math.min(Math.round(poll_intervalMs), this.options.poll_maxIntervalMs);
    }
    next() {
        this.shouldIterate = true;
    }
    cancel() {
        window.clearTimeout(this.timeoutId);
        this.timeoutId = 0;
    }
}

});
parcelRegister("foadk", function(module, exports) {

$parcel$export(module.exports, "PollingError", () => $830cdba99e9f23c2$export$c3748c310e92340a);
$parcel$export(module.exports, "isPollingError", () => $830cdba99e9f23c2$export$541e3e52eea6fece);

var $6bBrC = parcelRequire("6bBrC");
class $830cdba99e9f23c2$export$c3748c310e92340a extends (0, $6bBrC.BaseMediaClientError) {
    constructor(reason, attempts){
        super(reason);
        this.reason = reason;
        this.attempts = attempts;
    }
    get attributes() {
        const { reason: reason, attempts: attempts } = this;
        return {
            reason: reason,
            attempts: attempts
        };
    }
}
function $830cdba99e9f23c2$export$541e3e52eea6fece(err) {
    return err instanceof $830cdba99e9f23c2$export$c3748c310e92340a;
}

});


parcelRegister("6wdWp", function(module, exports) {

$parcel$export(module.exports, "isEmptyFile", () => $8d001a32183537d3$export$728192ce8dd94659);
const $8d001a32183537d3$export$d32fc52697b2ec92 = 43200000; /* 12 hours */ 
function $8d001a32183537d3$export$728192ce8dd94659(fileDetails, now = Date.now()) {
    const { artifacts: artifacts, mediaType: mediaType, mimeType: mimeType, name: name, processingStatus: processingStatus, representations: representations, size: size, createdAt: createdAt } = fileDetails;
    if (!artifacts && !mediaType && !mimeType && !name && !processingStatus && !representations && !size && typeof createdAt === 'number') {
        const msSinceFileCreation = now - createdAt;
        if (msSinceFileCreation > $8d001a32183537d3$export$d32fc52697b2ec92) return true;
    }
    return false;
}

});

parcelRegister("gHZqD", function(module, exports) {

$parcel$export(module.exports, "mediaStore", () => (parcelRequire("exlxT")).mediaStore);

var $exlxT = parcelRequire("exlxT");

});
parcelRegister("exlxT", function(module, exports) {

$parcel$export(module.exports, "mediaStore", () => $107a0f046eaf76d8$export$5785580dea19518d);

var $7dY5U = parcelRequire("7dY5U");

var $2Qvr5 = parcelRequire("2Qvr5");

var $gQVOz = parcelRequire("gQVOz");
const $107a0f046eaf76d8$var$mediaStoreWithoutDevtools = (0, $gQVOz.createStore)()((0, $7dY5U.subscribeWithSelector)((0, $2Qvr5.immer)(()=>({
        files: {}
    }))));
const $107a0f046eaf76d8$var$mediaStoreWithDevtools = (0, $gQVOz.createStore)()((0, $7dY5U.devtools)((0, $7dY5U.subscribeWithSelector)((0, $2Qvr5.immer)(()=>({
        files: {}
    })))));
const $107a0f046eaf76d8$export$5785580dea19518d = $107a0f046eaf76d8$var$mediaStoreWithoutDevtools;
const $107a0f046eaf76d8$export$503459913a0dc356 = (initialStore)=>{
    return (0, $gQVOz.createStore)()((0, $7dY5U.subscribeWithSelector)((0, $2Qvr5.immer)(()=>({
            files: {},
            ...initialStore
        }))));
};

});
parcelRegister("7dY5U", function(module, exports) {

$parcel$export(module.exports, "devtools", () => $45f0a2b2efc9d9f9$export$6922d3b3a607469e);
$parcel$export(module.exports, "subscribeWithSelector", () => $45f0a2b2efc9d9f9$export$5c593627aef9f076);
var $45f0a2b2efc9d9f9$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/middleware.mjs"
});
const $45f0a2b2efc9d9f9$var$reduxImpl = (reducer, initial)=>(set, _get, api)=>{
        api.dispatch = (action)=>{
            set((state)=>reducer(state, action), false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return {
            dispatch: (...a)=>api.dispatch(...a),
            ...initial
        };
    };
const $45f0a2b2efc9d9f9$export$4feba8a1bc8e9afd = $45f0a2b2efc9d9f9$var$reduxImpl;
const $45f0a2b2efc9d9f9$var$trackedConnections = /* @__PURE__ */ new Map();
const $45f0a2b2efc9d9f9$var$getTrackedConnectionState = (name)=>{
    const api = $45f0a2b2efc9d9f9$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(([key, api2])=>[
            key,
            api2.getState()
        ]));
};
const $45f0a2b2efc9d9f9$var$extractConnectionInformation = (store, extensionConnector, options)=>{
    if (store === void 0) return {
        type: "untracked",
        connection: extensionConnector.connect(options)
    };
    const existingConnection = $45f0a2b2efc9d9f9$var$trackedConnections.get(options.name);
    if (existingConnection) return {
        type: "tracked",
        store: store,
        ...existingConnection
    };
    const newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $45f0a2b2efc9d9f9$var$trackedConnections.set(options.name, newConnection);
    return {
        type: "tracked",
        store: store,
        ...newConnection
    };
};
const $45f0a2b2efc9d9f9$var$devtoolsImpl = (fn, devtoolsOptions = {})=>(set, get, api)=>{
        const { enabled: enabled, anonymousActionType: anonymousActionType, store: store, ...options } = devtoolsOptions;
        let extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : ($45f0a2b2efc9d9f9$import_meta.env ? $45f0a2b2efc9d9f9$import_meta.env.MODE : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (e) {}
        if (!extensionConnector) {
            if (($45f0a2b2efc9d9f9$import_meta.env ? $45f0a2b2efc9d9f9$import_meta.env.MODE : void 0) !== "production" && enabled) console.warn("[zustand devtools middleware] Please install/enable Redux devtools extension");
            return fn(set, get, api);
        }
        const { connection: connection, ...connectionInformation } = $45f0a2b2efc9d9f9$var$extractConnectionInformation(store, extensionConnector, options);
        let isRecording = true;
        api.setState = (state, replace, nameOrAction)=>{
            const r = set(state, replace);
            if (!isRecording) return r;
            const action = nameOrAction === void 0 ? {
                type: anonymousActionType || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === void 0) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send({
                ...action,
                type: `${store}/${action.type}`
            }, {
                ...$45f0a2b2efc9d9f9$var$getTrackedConnectionState(options.name),
                [store]: api.getState()
            });
            return r;
        };
        const setStateFromDevtools = (...a)=>{
            const originalIsRecording = isRecording;
            isRecording = false;
            set(...a);
            isRecording = originalIsRecording;
        };
        const initialState = fn(api.setState, get, api);
        if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(([key, store2])=>[
                    key,
                    key === connectionInformation.store ? initialState : store2.getState()
                ])));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
            let didWarnAboutReservedActionType = false;
            const originalDispatch = api.dispatch;
            api.dispatch = (...a)=>{
                if (($45f0a2b2efc9d9f9$import_meta.env ? $45f0a2b2efc9d9f9$import_meta.env.MODE : void 0) !== "production" && a[0].type === "__setState" && !didWarnAboutReservedActionType) {
                    console.warn('[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.');
                    didWarnAboutReservedActionType = true;
                }
                originalDispatch(...a);
            };
        }
        connection.subscribe((message)=>{
            var _a;
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return $45f0a2b2efc9d9f9$var$parseJsonThen(message.payload, (action)=>{
                        if (action.type === "__setState") {
                            if (store === void 0) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error(`
                    [zustand devtools middleware] Unsupported __setState action format. 
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `);
                            const stateFromDevtools = action.state[store];
                            if (stateFromDevtools === void 0 || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== "function") return;
                        api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            if (store === void 0) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init($45f0a2b2efc9d9f9$var$getTrackedConnectionState(options.name));
                        case "COMMIT":
                            if (store === void 0) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init($45f0a2b2efc9d9f9$var$getTrackedConnectionState(options.name));
                        case "ROLLBACK":
                            return $45f0a2b2efc9d9f9$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init($45f0a2b2efc9d9f9$var$getTrackedConnectionState(options.name));
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return $45f0a2b2efc9d9f9$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case "IMPORT_STATE":
                            {
                                const { nextLiftedState: nextLiftedState } = message.payload;
                                const lastComputedState = (_a = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _a.state;
                                if (!lastComputedState) return;
                                if (store === void 0) setStateFromDevtools(lastComputedState);
                                else setStateFromDevtools(lastComputedState[store]);
                                connection == null || connection.send(null, // FIXME no-any
                                nextLiftedState);
                                return;
                            }
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
const $45f0a2b2efc9d9f9$export$6922d3b3a607469e = $45f0a2b2efc9d9f9$var$devtoolsImpl;
const $45f0a2b2efc9d9f9$var$parseJsonThen = (stringified, f)=>{
    let parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== void 0) f(parsed);
};
const $45f0a2b2efc9d9f9$var$subscribeWithSelectorImpl = (fn)=>(set, get, api)=>{
        const origSubscribe = api.subscribe;
        api.subscribe = (selector, optListener, options)=>{
            let listener = selector;
            if (optListener) {
                const equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                let currentSlice = selector(api.getState());
                listener = (state)=>{
                    const nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        const previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options == null ? void 0 : options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        const initialState = fn(set, get, api);
        return initialState;
    };
const $45f0a2b2efc9d9f9$export$5c593627aef9f076 = $45f0a2b2efc9d9f9$var$subscribeWithSelectorImpl;
const $45f0a2b2efc9d9f9$export$1be1fc439b849fdf = (initialState, create)=>(...a)=>Object.assign({}, initialState, create(...a));
function $45f0a2b2efc9d9f9$export$95a3b7b12ab518f9(getStorage, options) {
    let storage;
    try {
        storage = getStorage();
    } catch (e) {
        return;
    }
    const persistStorage = {
        getItem: (name)=>{
            var _a;
            const parse = (str2)=>{
                if (str2 === null) return null;
                return JSON.parse(str2, options == null ? void 0 : options.reviver);
            };
            const str = (_a = storage.getItem(name)) != null ? _a : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: (name, newValue)=>storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer)),
        removeItem: (name)=>storage.removeItem(name)
    };
    return persistStorage;
}
const $45f0a2b2efc9d9f9$var$toThenable = (fn)=>(input)=>{
        try {
            const result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then (onFulfilled) {
                    return $45f0a2b2efc9d9f9$var$toThenable(onFulfilled)(result);
                },
                catch (_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then (_onFulfilled) {
                    return this;
                },
                catch (onRejected) {
                    return $45f0a2b2efc9d9f9$var$toThenable(onRejected)(e);
                }
            };
        }
    };
const $45f0a2b2efc9d9f9$var$oldImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            getStorage: ()=>localStorage,
            serialize: JSON.stringify,
            deserialize: JSON.parse,
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage;
        try {
            storage = options.getStorage();
        } catch (e) {}
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const thenableSerialize = $45f0a2b2efc9d9f9$var$toThenable(options.serialize);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            let errorInSync;
            const thenable = thenableSerialize({
                state: state,
                version: options.version
            }).then((serializedValue)=>storage.setItem(options.name, serializedValue)).catch((e)=>{
                errorInSync = e;
            });
            if (errorInSync) throw errorInSync;
            return thenable;
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        let stateFromStorage;
        const hydrate = ()=>{
            var _a;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>cb(get()));
            const postRehydrationCallback = ((_a = options.onRehydrateStorage) == null ? void 0 : _a.call(options, get())) || void 0;
            return $45f0a2b2efc9d9f9$var$toThenable(storage.getItem.bind(storage))(options.name).then((storageValue)=>{
                if (storageValue) return options.deserialize(storageValue);
            }).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return deserializedStorageValue.state;
                }
            }).then((migratedState)=>{
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.getStorage) storage = newOptions.getStorage();
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        hydrate();
        return stateFromStorage || configResult;
    };
const $45f0a2b2efc9d9f9$var$newImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            storage: $45f0a2b2efc9d9f9$export$95a3b7b12ab518f9(()=>localStorage),
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage = options.storage;
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        api.getInitialState = ()=>configResult;
        let stateFromStorage;
        const hydrate = ()=>{
            var _a, _b;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>{
                var _a2;
                return cb((_a2 = get()) != null ? _a2 : configResult);
            });
            const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? void 0 : _b.call(options, (_a = get()) != null ? _a : configResult)) || void 0;
            return $45f0a2b2efc9d9f9$var$toThenable(storage.getItem.bind(storage))(options.name).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return deserializedStorageValue.state;
                }
            }).then((migratedState)=>{
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                stateFromStorage = get();
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
const $45f0a2b2efc9d9f9$var$persistImpl = (config, baseOptions)=>{
    if ("getStorage" in baseOptions || "serialize" in baseOptions || "deserialize" in baseOptions) {
        if (($45f0a2b2efc9d9f9$import_meta.env ? $45f0a2b2efc9d9f9$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] `getStorage`, `serialize` and `deserialize` options are deprecated. Use `storage` option instead.");
        return $45f0a2b2efc9d9f9$var$oldImpl(config, baseOptions);
    }
    return $45f0a2b2efc9d9f9$var$newImpl(config, baseOptions);
};
const $45f0a2b2efc9d9f9$export$9a6132153fba2e0 = $45f0a2b2efc9d9f9$var$persistImpl;

});

parcelRegister("2Qvr5", function(module, exports) {

$parcel$export(module.exports, "immer", () => $a3e9bebcfca14386$export$428de7ec69ac95c);

var $lbd4c = parcelRequire("lbd4c");
const $a3e9bebcfca14386$var$immerImpl = (initializer)=>(set, get, store)=>{
        store.setState = (updater, replace, ...a)=>{
            const nextState = typeof updater === "function" ? (0, $lbd4c.produce)(updater) : updater;
            return set(nextState, replace, ...a);
        };
        return initializer(store.setState, get, store);
    };
const $a3e9bebcfca14386$export$428de7ec69ac95c = $a3e9bebcfca14386$var$immerImpl;

});
parcelRegister("lbd4c", function(module, exports) {

$parcel$export(module.exports, "produce", () => fn);
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $221c0e7836ac0785$export$2e2bcd8739ae039 = fn;

});


parcelRegister("gQVOz", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $14d460da377d9036$export$f51a9068ac82ea43);
var $14d460da377d9036$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/vanilla.mjs"
});
const $14d460da377d9036$var$createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const getInitialState = ()=>initialState;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const destroy = ()=>{
        if (($14d460da377d9036$import_meta.env ? $14d460da377d9036$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected.");
        listeners.clear();
    };
    const api = {
        setState: setState,
        getState: getState,
        getInitialState: getInitialState,
        subscribe: subscribe,
        destroy: destroy
    };
    const initialState = state = createState(setState, getState, api);
    return api;
};
const $14d460da377d9036$export$f51a9068ac82ea43 = (createState)=>createState ? $14d460da377d9036$var$createStoreImpl(createState) : $14d460da377d9036$var$createStoreImpl;
var $14d460da377d9036$export$2e2bcd8739ae039 = (createState)=>{
    if (($14d460da377d9036$import_meta.env ? $14d460da377d9036$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'.");
    return $14d460da377d9036$export$f51a9068ac82ea43(createState);
};

});




parcelRegister("eJAUz", function(module, exports) {

$parcel$export(module.exports, "StargateClient", () => $aebd1b09d3f1d2ab$export$c66ca190f89caaac);
class $aebd1b09d3f1d2ab$export$c66ca190f89caaac {
    constructor(baseUrl){
        this.baseUrl = baseUrl || '/gateway/api';
    }
    async fetchToken(clientId) {
        return (await fetch(`${this.baseUrl}/media/auth/smartedge`, {
            credentials: 'include',
            headers: {
                'x-client-id': clientId
            }
        })).json();
    }
    isTokenExpired(token) {
        const currentTimeInSeconds = new Date().getTime() / 1000;
        return token.data.iat + token.data.expiresIn - currentTimeInSeconds < 0;
    }
}

});

parcelRegister("jSRlT", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('kRysi');
        const value = parcelRequire('8gBya');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("kRysi").then(()=>parcelRequire('8gBya'));
}

});





parcelRegister("iUp5j", function(module, exports) {

$parcel$export(module.exports, "useEmojiProvider", () => $5ae6a65eeb3660a0$export$d80cf6b7758b1c7e);

var $eUqFw = parcelRequire("eUqFw");

var $fLfen = parcelRequire("fLfen");

var $95Rby = parcelRequire("95Rby");

var $dxcfv = parcelRequire("dxcfv");
var $dWLk9 = parcelRequire("dWLk9");
const $5ae6a65eeb3660a0$export$d80cf6b7758b1c7e = ()=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const atlassianAccountId = (0, $dxcfv.useAccountId)();
    const emojiProvider = (0, $eUqFw.useMemo)(()=>{
        const dataProviders = new (0, $fLfen.default)();
        dataProviders.setProvider('emojiProvider', (0, $95Rby.getEmojiProviderWithCustomEmoji)(cloudId, atlassianAccountId) || undefined);
        return dataProviders;
    }, [
        cloudId,
        atlassianAccountId
    ]);
    return emojiProvider;
};

});
parcelRegister("95Rby", function(module, exports) {

$parcel$export(module.exports, "getEmojiProvider", () => $dd0833923ef463d6$export$8210f5f78c0bcf27);
$parcel$export(module.exports, "getEmojiProviderWithCustomEmoji", () => $dd0833923ef463d6$export$f9c5a1e85ff0cb72);
$parcel$export(module.exports, "getEmojiProviderWithCustomEmojiUploadDisabled", () => $dd0833923ef463d6$export$7cda0fc535c2710f);

var $88oUO = parcelRequire("88oUO");

var $k7z88 = parcelRequire("k7z88");
const $dd0833923ef463d6$var$baseProviders = (serviceBaseUrl)=>[
        {
            url: `${serviceBaseUrl}/emoji/standard`
        },
        {
            url: `${serviceBaseUrl}/emoji/atlassian`
        }
    ];
const $dd0833923ef463d6$export$8210f5f78c0bcf27 = ()=>(0, $k7z88.getServiceProvider)((0, $k7z88.EMOJI_SERVICEID), (serviceBaseUrl)=>{
        const emojiResource = new (0, $88oUO.default)({
            providers: $dd0833923ef463d6$var$baseProviders(serviceBaseUrl)
        });
        return emojiResource.getEmojiProvider();
    });
const $dd0833923ef463d6$export$f9c5a1e85ff0cb72 = (cloudId, accountId)=>(0, $k7z88.getServiceProvider)((0, $k7z88.EMOJI_WITH_CUSTOM_SERVICEID), (serviceBaseUrl)=>{
        const providers = cloudId ? [
            ...$dd0833923ef463d6$var$baseProviders(serviceBaseUrl),
            {
                url: `${serviceBaseUrl}/emoji/${cloudId}/site`
            }
        ] : $dd0833923ef463d6$var$baseProviders(serviceBaseUrl);
        const emojiResource = new (0, $88oUO.default)({
            providers: providers,
            allowUpload: true,
            // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string'.
            currentUser: {
                id: accountId
            }
        });
        return emojiResource.getEmojiProvider();
    });
const $dd0833923ef463d6$export$7cda0fc535c2710f = (cloudId, accountId)=>(0, $k7z88.getServiceProvider)((0, $k7z88.EMOJI_WITH_CUSTOM_UPLOAD_DISABLED_SERVICEID), (serviceBaseUrl)=>{
        const providers = cloudId ? [
            ...$dd0833923ef463d6$var$baseProviders(serviceBaseUrl),
            {
                url: `${serviceBaseUrl}/emoji/${cloudId}/site`
            }
        ] : $dd0833923ef463d6$var$baseProviders(serviceBaseUrl);
        const emojiResource = new (0, $88oUO.default)({
            providers: providers,
            allowUpload: false,
            // @ts-expect-error - TS2322 - Type 'string | null' is not assignable to type 'string'.
            currentUser: {
                id: accountId
            }
        });
        return emojiResource.getEmojiProvider();
    });

});
parcelRegister("88oUO", function(module, exports) {

$parcel$export(module.exports, "supportsUploadFeature", () => $0bc4b679c969736b$export$7b697b720032fd6f);
$parcel$export(module.exports, "default", () => $0bc4b679c969736b$export$2e2bcd8739ae039);
parcelRequire("16UJG");
var $gdgmj = parcelRequire("gdgmj");
var $16UJG = parcelRequire("16UJG");

var $dfT6d = parcelRequire("dfT6d");

var $1JT4v = parcelRequire("1JT4v");

var $eG1kR = parcelRequire("eG1kR");

var $cfJOp = parcelRequire("cfJOp");

var $9L9vJ = parcelRequire("9L9vJ");

var $9AK7V = parcelRequire("9AK7V");

var $QniiQ = parcelRequire("QniiQ");

var $7yGtX = parcelRequire("7yGtX");

var $iggLf = parcelRequire("iggLf");
const $0bc4b679c969736b$export$7b697b720032fd6f = (emojiProvider)=>{
    const emojiUploadProvider = emojiProvider;
    return !!emojiUploadProvider.isUploadSupported && !!emojiUploadProvider.uploadCustomEmoji && !!emojiUploadProvider.prepareForUpload;
};
class $0bc4b679c969736b$export$b5efafc6dd611ec5 extends (0, $gdgmj.AbstractResource) {
    constructor(config){
        super();
        this.activeLoaders = 0;
        this.initialLoaders = 0;
        this.retries = new Map();
        this.isInitialised = false;
        this.fetchOnDemand = false;
        this.getOptimisticImageURL = (emojiId)=>{
            if (this.emojiProviderConfig.optimisticImageApi) return this.emojiProviderConfig.optimisticImageApi.getUrl(emojiId);
            return;
        };
        this.isRepositoryAvailable = (repository)=>{
            return !!repository;
        };
        this.isLoaded = ()=>this.initialLoaders !== 0 && this.activeLoaders === 0;
        this.emojiProviderConfig = config;
        this.recordConfig = config.recordConfig;
        this.currentUser = config.currentUser;
        if ((0, $cfJOp.default)('localStorage')) this.selectedTone = this.loadStoredTone();
        if (config.providers.length === 0) throw new Error('No providers specified');
        this.fetchOnDemand = !!config.options && !!config.options.onlyFetchOnDemand;
        this.initialLoaders = this.emojiProviderConfig.providers.length;
        this.activeLoaders = this.emojiProviderConfig.providers.length;
        this.emojiResponses = [];
    }
    /**
	 * Get the emoji provider from Emoji Resource
	 * @returns Promise<EmojiProvider>
	 */ async getEmojiProvider(options = {
        fetchAtStart: !this.fetchOnDemand
    }) {
        if (options.fetchAtStart) try {
            await this.fetchEmojiProvider();
        } catch (error) {
            (0, $1JT4v.default)(error);
            return Promise.resolve(this);
        }
        return Promise.resolve(this);
    }
    async fetchIndividualProvider(provider, index) {
        const providerType = this.getProviderType(provider);
        try {
            (0, $iggLf.sampledUfoEmojiResourceFetched)(providerType).start({
                samplingRate: (0, $dfT6d.SAMPLING_RATE_EMOJI_RESOURCE_FETCHED_EXP)
            });
            (0, $iggLf.sampledUfoEmojiResourceFetched)(providerType).addMetadata({
                type: providerType
            });
            const loader = new (0, $9AK7V.default)(provider);
            // fetch emoji from provider url and denormalise
            const emojiResponse = await loader.loadEmoji();
            (0, $iggLf.sampledUfoEmojiResourceFetched)(providerType).success();
            // setup emoji repository
            this.emojiResponses[index] = emojiResponse;
            this.initEmojiRepository(this.emojiResponses);
            await this.initSiteEmojiResource(emojiResponse, provider);
            this.activeLoaders--;
            this.performRetries();
            this.refreshLastFilter();
        } catch (error) {
            this.activeLoaders--;
            this.notifyError(error);
            (0, $iggLf.sampledUfoEmojiResourceFetched)(providerType).failure({
                metadata: {
                    reason: error,
                    source: 'EmojiProvider',
                    providerUrl: provider.url
                }
            });
            (0, $1JT4v.default)(`failed to fetch emoji provider for ${provider.url}`, error);
            throw new Error(`failed to fetch emoji from ${provider.url}`);
        }
    }
    async fetchEmojiProvider(force = false) {
        // unless (re-)fetch is being forced, fetching will only
        // happen if no emojiRepository exists
        // in case this method is called and emojiRepository has already been populated
        // the method will just return the existing emojiRepository
        if (force || !this.isRepositoryAvailable(this.emojiRepository) && !this.isInitialised) {
            this.isInitialised = true;
            this.emojiResponses = [];
            // fetch emoji providers
            await Promise.all(this.emojiProviderConfig.providers.map((provider, index)=>this.fetchIndividualProvider(provider, index)));
        }
        return Promise.resolve(this.emojiRepository);
    }
    onlyFetchOnDemand() {
        return this.fetchOnDemand;
    }
    async fetchByEmojiId(emojiId, optimistic) {
        // Check if repository exists and emoji is defined.
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) {
            const emoji = await this.findByEmojiId(emojiId);
            if (emoji) return await this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
        }
        // If optimistic is fetched
        if (this.emojiProviderConfig.singleEmojiApi && optimistic) {
            // if config has singleEmojiApi then fetch single emoji
            const provider = {
                url: this.emojiProviderConfig.singleEmojiApi.getUrl(emojiId),
                securityProvider: this.emojiProviderConfig.singleEmojiApi.securityProvider
            };
            const loader = new (0, $9AK7V.default)(provider);
            try {
                const loadEmoji = await loader.loadEmoji();
                if (!loadEmoji.emojis[0]) return;
                if (!this.isRepositoryAvailable(this.siteEmojiResource)) await this.initSiteEmojiResource(loadEmoji, provider);
                return this.getMediaEmojiDescriptionURLWithInlineToken(loadEmoji.emojis[0]);
            } catch  {
                const emoji = await this.findByEmojiId(emojiId);
                if (!emoji) return;
                return this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
            }
        }
        const emoji = await this.findByEmojiId(emojiId);
        if (!emoji) return;
        return this.getMediaEmojiDescriptionURLWithInlineToken(emoji);
    }
    getProviderType(provider) {
        if (provider.url.includes('/site')) return (0, $9L9vJ.ProviderTypes).SITE;
        else if (provider.url.includes('/standard')) return (0, $9L9vJ.ProviderTypes).STANDARD;
        else if (provider.url.includes('/atlassian')) return (0, $9L9vJ.ProviderTypes).ATLASSIAN;
        return (0, $9L9vJ.ProviderTypes).UNKNOWN;
    }
    initEmojiRepository(emojiResponses) {
        let emojis = [];
        emojiResponses.forEach((emojiResponse)=>{
            emojis = emojis.concat(emojiResponse.emojis);
        });
        this.emojiRepository = new (0, $QniiQ.default)(emojis);
    }
    initSiteEmojiResource(emojiResponse, provider) {
        if (!this.isRepositoryAvailable(this.siteEmojiResource) && emojiResponse.mediaApiToken) {
            this.siteEmojiResource = new (0, $7yGtX.default)(provider, emojiResponse.mediaApiToken);
            // Prime cache type + optimistic rendering by checking first Emoji.
            // If this is fails, it won't be primed until a good emoji is loaded later.
            const { emojis: emojis } = emojiResponse;
            if (emojis.length) {
                const done = this.siteEmojiResource.optimisticRendering(emojis[0]);
                if ((0, $eG1kR.isPromise)(done)) return done.then(()=>{
                    (0, $1JT4v.default)('Primed siteEmojiResource');
                }).catch(()=>{
                    (0, $1JT4v.default)('Failed to prime siteEmojiResource');
                });
                else (0, $1JT4v.default)('Already primed siteEmojiResource');
            } else (0, $1JT4v.default)('No emoji to prime siteEmojiResource with');
        }
        return Promise.resolve();
    }
    performRetries() {
        const currentRetries = this.retries;
        this.retries = new Map();
        currentRetries.forEach((resolveReject, retry)=>{
            const result = retry();
            if ((0, $eG1kR.isPromise)(result)) result.then((response)=>{
                resolveReject.resolve(response);
            }).catch((reason)=>{
                resolveReject.reject(reason);
            });
            else resolveReject.resolve(result);
        });
    }
    loadStoredTone() {
        if (typeof window === 'undefined') return undefined;
        const storedToneString = window.localStorage.getItem((0, $dfT6d.selectedToneStorageKey));
        if (storedToneString) {
            const storedTone = parseInt(storedToneString, 10);
            return !isNaN(storedTone) ? storedTone : undefined;
        }
        return undefined;
    }
    refreshLastFilter() {
        if (typeof this.lastQuery !== 'undefined') {
            const { query: query, options: options } = this.lastQuery;
            this.filter(query, options);
        }
    }
    retryIfLoading(retry, defaultResponse) {
        if (!this.isLoaded()) return new Promise((resolve, reject)=>{
            this.retries.set(retry, {
                resolve: resolve,
                reject: reject
            });
        });
        return Promise.resolve(defaultResponse);
    }
    notifyResult(result) {
        if (this.lastQuery && result.query === this.lastQuery.query) super.notifyResult(result);
    }
    /**
	 *  Returns the EmojiDescription with a valid media path that includes query token and client attributes to access the emoji media inline.
	 */ async getMediaEmojiDescriptionURLWithInlineToken(emoji) {
        if (this.isRepositoryAvailable(this.siteEmojiResource)) {
            const { representation: representation, altRepresentation: altRepresentation } = await this.siteEmojiResource.generateTokenisedMediaURLS(emoji.representation, emoji.altRepresentation);
            return {
                ...emoji,
                representation: representation,
                altRepresentation: altRepresentation
            };
        }
        return emoji;
    }
    loadMediaEmoji(emoji, useAlt) {
        if (!this.isRepositoryAvailable(this.siteEmojiResource) || !(0, $eG1kR.isMediaEmoji)(emoji)) return emoji;
        return this.siteEmojiResource.loadMediaEmoji(emoji, useAlt);
    }
    optimisticMediaRendering(emoji, useAlt) {
        if (!(0, $eG1kR.isMediaEmoji)(emoji)) return true;
        if (!this.isRepositoryAvailable(this.siteEmojiResource)) // Shouldn't have a media emoji without a siteEmojiResouce, but anyway ;)
        return false;
        const optimistic = this.siteEmojiResource.optimisticRendering(emoji, useAlt);
        if ((0, $eG1kR.isPromise)(optimistic)) // Not sure yet, so lets say no for now (this should normally be primed in most/all cases)
        return false;
        return optimistic;
    }
    filter(query, options) {
        (0, $iggLf.ufoExperiences)['emoji-searched'].start();
        (0, $iggLf.ufoExperiences)['emoji-searched'].addMetadata({
            queryLength: query?.length || 0
        });
        this.lastQuery = {
            query: query,
            options: options
        };
        if (this.isRepositoryAvailable(this.emojiRepository)) {
            const searchResults = this.emojiRepository.search(query, options);
            this.notifyResult(searchResults);
            (0, $iggLf.ufoExperiences)['emoji-searched'].success({
                metadata: {
                    emojisLength: searchResults.emojis.length,
                    source: options?.source || 'typeahead'
                }
            });
        } else // not ready
        this.notifyNotReady();
    }
    findByShortName(shortName) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) // Wait for all emoji to load before looking by shortName (to ensure correct priority)
        return this.emojiRepository.findByShortName(shortName);
        return this.retryIfLoading(()=>this.findByShortName(shortName), undefined);
    }
    findByEmojiId(emojiId) {
        const { id: id, shortName: shortName } = emojiId;
        if (this.isRepositoryAvailable(this.emojiRepository)) {
            if (id) {
                const emoji = this.emojiRepository.findById(id);
                if (emoji) return emoji;
                if (this.isLoaded()) {
                    // all loaded but not found by id, try server to see if
                    // this is a newly uploaded emoji
                    if (this.isRepositoryAvailable(this.siteEmojiResource)) return this.siteEmojiResource.findEmoji(emojiId).then((emoji)=>{
                        if (!emoji) // if not, fallback to searching by shortName to
                        // at least render an alternative
                        return this.findByShortName(shortName);
                        this.addUnknownEmoji(emoji);
                        return emoji;
                    });
                    // if not, fallback to searching by shortName to
                    // at least render an alternative
                    return this.findByShortName(shortName);
                }
            } else // no id fallback to shortName
            return this.findByShortName(shortName);
        }
        return this.retryIfLoading(()=>this.findByEmojiId(emojiId), undefined);
    }
    findById(id) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return this.emojiRepository.findById(id);
        return this.retryIfLoading(()=>this.findById(id), undefined);
    }
    findInCategory(categoryId) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.findInCategory(categoryId));
        return this.retryIfLoading(()=>this.findInCategory(categoryId), []);
    }
    getAsciiMap() {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getAsciiMap());
        return this.retryIfLoading(()=>this.getAsciiMap(), new Map());
    }
    getFrequentlyUsed(options) {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getFrequentlyUsed(options));
        return this.retryIfLoading(()=>this.getFrequentlyUsed(options), []);
    }
    /**
	 * Record the selection of an emoji to a remote service if 'recordConfig' has been supplied.
	 * Regardless of the recordConfig, emoji selections will always be recorded on the EmojiRepository
	 * for the purposes of tracking the frequency of use.
	 *
	 * @param emoji The full description of the emoji to record usage for.
	 */ recordSelection(emoji) {
        const { recordConfig: recordConfig } = this;
        if (this.isRepositoryAvailable(this.emojiRepository)) this.emojiRepository.used(emoji);
        if (recordConfig) {
            const queryParams = {
                emojiId: (0, $eG1kR.toEmojiId)(emoji)
            };
            const requestInit = {
                method: 'POST'
            };
            return (0, $16UJG.utils).requestService(recordConfig, {
                queryParams: queryParams,
                requestInit: requestInit
            });
        }
        return Promise.resolve();
    }
    deleteSiteEmoji(emoji) {
        if (this.isRepositoryAvailable(this.siteEmojiResource) && emoji.id) return this.siteEmojiResource.deleteEmoji(emoji).then((success)=>{
            if (success && this.isRepositoryAvailable(this.emojiRepository)) {
                this.emojiRepository.delete(emoji);
                return true;
            }
            return false;
        }).catch((err)=>{
            // eslint-disable-next-line no-console
            console.error('failed to delete site emoji', err);
            return false;
        });
        return this.retryIfLoading(()=>this.deleteSiteEmoji(emoji), false);
    }
    getSelectedTone() {
        return this.selectedTone;
    }
    setSelectedTone(tone) {
        this.selectedTone = tone;
        if (typeof window === 'undefined') return;
        if ((0, $cfJOp.default)('localStorage')) try {
            window.localStorage.setItem((0, $dfT6d.selectedToneStorageKey), tone ? tone.toString() : '');
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error('failed to store selected emoji skin tone', e);
        }
    }
    calculateDynamicCategories() {
        if (this.isLoaded() && this.isRepositoryAvailable(this.emojiRepository)) return Promise.resolve(this.emojiRepository.getDynamicCategoryList());
        return this.retryIfLoading(()=>this.calculateDynamicCategories(), []);
    }
    getCurrentUser() {
        return this.currentUser;
    }
    addUnknownEmoji(emoji) {
        if (this.isRepositoryAvailable(this.emojiRepository)) this.emojiRepository.addUnknownEmoji(emoji);
    }
}
class $0bc4b679c969736b$export$2e2bcd8739ae039 extends $0bc4b679c969736b$export$b5efafc6dd611ec5 {
    constructor(config){
        super(config);
        this.allowUpload = !!config.allowUpload;
    }
    isUploadSupported() {
        if (!this.allowUpload) return Promise.resolve(false);
        if (this.isRepositoryAvailable(this.siteEmojiResource)) return this.siteEmojiResource.hasUploadToken();
        return this.retryIfLoading(()=>this.isUploadSupported(), false);
    }
    uploadCustomEmoji(upload, retry = false) {
        return this.isUploadSupported().then((supported)=>{
            if (!supported || !this.isRepositoryAvailable(this.siteEmojiResource)) return Promise.reject('No media api support is configured');
            return this.siteEmojiResource.uploadEmoji(upload, retry).then((emoji)=>{
                // Use file preview blob URL to temporarily fix the graybox issue after uploading,
                // Because the media service takes time to process the image.
                // Ideally should improve CachingMediaImage by using mediaClient or mediaImage,
                // But that requires more efforts in FE & BE.
                // TODO: revist this when pick up COLLAB-2294
                emoji.representation.imagePath = upload.dataURL;
                this.addUnknownEmoji(emoji);
                this.refreshLastFilter();
                return emoji;
            });
        });
    }
    prepareForUpload() {
        if (this.isRepositoryAvailable(this.siteEmojiResource)) this.siteEmojiResource.prepareForUpload();
        return this.retryIfLoading(()=>this.prepareForUpload(), undefined);
    }
}

});
parcelRegister("16UJG", function(module, exports) {
$parcel$export(module.exports, "AbstractResource", () => (parcelRequire("gdgmj")).AbstractResource);

$parcel$export(module.exports, "utils", () => $30e3ff12b332d773$export$eab97d15b1788b8d);
parcelRequire("1GW5Z");
parcelRequire("gdgmj");

var $eG8mk = parcelRequire("eG8mk");
const $30e3ff12b332d773$export$eab97d15b1788b8d = $eG8mk;

});
parcelRegister("1GW5Z", function(module, exports) {

$parcel$export(module.exports, "buildCredentials", () => $b0494a54f1853cda$export$2ac26f1ab7eda637);
const $b0494a54f1853cda$export$2ac26f1ab7eda637 = (secOptions)=>{
    return secOptions && secOptions.omitCredentials ? 'omit' : 'include';
};

});

parcelRegister("gdgmj", function(module, exports) {

$parcel$export(module.exports, "AbstractResource", () => $f733c180c466e71c$export$4529f10aed0950d4);
class $f733c180c466e71c$export$4529f10aed0950d4 {
    subscribe(onChange) {
        this.listeners.add(onChange);
        if (this.lastResult) // Notify subscribe of last result (i.e. initial state)
        onChange.result(this.lastResult);
    }
    unsubscribe(onChange) {
        this.listeners.delete(onChange);
    }
    notifyResult(result) {
        this.listeners.forEach((onChange)=>{
            onChange.result(result);
        });
    }
    notifyError(error) {
        this.listeners.forEach((onChange)=>{
            if (onChange.error) onChange.error(error);
        });
    }
    notifyInfo(info) {
        this.listeners.forEach((onChange)=>{
            if (onChange.info) onChange.info(info);
        });
    }
    notifyNotReady() {
        this.listeners.forEach((onChange)=>{
            if (onChange.notReady) onChange.notReady();
        });
    }
    constructor(){
        this.listeners = new Set();
    }
}

});

parcelRegister("eG8mk", function(module, exports) {

$parcel$export(module.exports, "requestService", () => $55e0d7df395d2852$export$97bfde5a702aaeca);

var $1GW5Z = parcelRequire("1GW5Z");
const $55e0d7df395d2852$var$defaultRequestServiceOptions = {};
const $55e0d7df395d2852$var$buildUrl = (baseUrl, path = '', queryParams, secOptions)=>{
    const searchParam = new URLSearchParams(// For relative urls, the URL class requires base to be set. It's ignored if a url is not relative.
    // Since we only care about search params it is fine to have any base url here.
    new URL(baseUrl, 'https://BASE_FALLBACK').search || undefined);
    baseUrl = baseUrl.split('?')[0];
    if (queryParams) {
        for(const key in queryParams)if (({}).hasOwnProperty.call(queryParams, key)) searchParam.append(key, queryParams[key]);
    }
    if (secOptions && secOptions.params) {
        for(const key in secOptions.params)if (({}).hasOwnProperty.call(secOptions.params, key)) {
            const values = secOptions.params[key];
            if (Array.isArray(values)) for(let i = 0; i < values.length; i++)searchParam.append(key, values[i]);
            else searchParam.append(key, values);
        }
    }
    let separator = '';
    if (path && baseUrl.substr(-1) !== '/' && !path.startsWith('/')) separator = '/';
    let params = searchParam.toString();
    if (params) params = '?' + params;
    return `${baseUrl}${separator}${path}${params}`;
};
const $55e0d7df395d2852$var$addToHeaders = (headers, keyValues)=>{
    if (keyValues) {
        for(const key in keyValues)if (({}).hasOwnProperty.call(keyValues, key)) {
            const values = keyValues[key];
            if (Array.isArray(values)) for(let i = 0; i < values.length; i++)headers[key] = values[i];
            else headers[key] = values;
        }
    }
};
const $55e0d7df395d2852$var$buildHeaders = (secOptions, extraHeaders)=>{
    const headers = {};
    $55e0d7df395d2852$var$addToHeaders(headers, extraHeaders);
    if (secOptions) $55e0d7df395d2852$var$addToHeaders(headers, secOptions.headers);
    return headers;
};
const $55e0d7df395d2852$export$97bfde5a702aaeca = (serviceConfig, options)=>{
    const { url: url, securityProvider: securityProvider, refreshedSecurityProvider: refreshedSecurityProvider } = serviceConfig;
    const { path: path, queryParams: queryParams, requestInit: requestInit } = options || $55e0d7df395d2852$var$defaultRequestServiceOptions;
    const secOptions = securityProvider && securityProvider();
    const requestUrl = $55e0d7df395d2852$var$buildUrl(url, path, queryParams, secOptions);
    const headers = $55e0d7df395d2852$var$buildHeaders(secOptions, requestInit && requestInit.headers);
    const credentials = (0, $1GW5Z.buildCredentials)(secOptions);
    const ignoreResponsePayload = options?.ignoreResponsePayload || false;
    const requestOptions = {
        ...requestInit,
        headers: headers,
        credentials: credentials
    };
    return fetch(requestUrl, requestOptions).then((response)=>{
        if (response.status === 204) return Promise.resolve();
        else if (response.ok) return ignoreResponsePayload ? Promise.resolve() : response.json();
        else if (response.status === 401 && refreshedSecurityProvider) // auth issue - try once
        return refreshedSecurityProvider().then((newSecOptions)=>{
            const retryServiceConfig = {
                url: url,
                securityProvider: ()=>newSecOptions
            };
            return $55e0d7df395d2852$export$97bfde5a702aaeca(retryServiceConfig, options);
        });
        return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
    });
};

});


parcelRegister("dfT6d", function(module, exports) {

$parcel$export(module.exports, "customCategory", () => $6c84915fafd28375$export$5e4e3d1c3e43156a);
$parcel$export(module.exports, "frequentCategory", () => $6c84915fafd28375$export$78ccdc4be403c468);
$parcel$export(module.exports, "searchCategory", () => $6c84915fafd28375$export$1b0258512be88334);
$parcel$export(module.exports, "yourUploadsCategory", () => $6c84915fafd28375$export$42b510423367f354);
$parcel$export(module.exports, "customTitle", () => $6c84915fafd28375$export$5d0f2d8ee50f86f5);
$parcel$export(module.exports, "userCustomTitle", () => $6c84915fafd28375$export$1debc2f10cc69389);
$parcel$export(module.exports, "dataURLPrefix", () => $6c84915fafd28375$export$8ac325bfd32359b0);
$parcel$export(module.exports, "deleteEmojiLabel", () => $6c84915fafd28375$export$a330961542edfe6f);
$parcel$export(module.exports, "MAX_ORDINAL", () => $6c84915fafd28375$export$1a817f1886276c6d);
$parcel$export(module.exports, "defaultEmojiHeight", () => $6c84915fafd28375$export$3f99ac31dc0406db);
$parcel$export(module.exports, "emojiPickerWidth", () => $6c84915fafd28375$export$d171dc12fee2b1da);
$parcel$export(module.exports, "sizeGap", () => $6c84915fafd28375$export$c10ac8125a260041);
$parcel$export(module.exports, "defaultEmojiPickerSize", () => $6c84915fafd28375$export$5248fb9e0cccc41f);
$parcel$export(module.exports, "emojiPickerMinHeight", () => $6c84915fafd28375$export$94f75d625e7801d3);
$parcel$export(module.exports, "emojiPickerHeight", () => $6c84915fafd28375$export$7ed599d166d65aea);
$parcel$export(module.exports, "emojiPickerListHeight", () => $6c84915fafd28375$export$7722b8e9522021df);
$parcel$export(module.exports, "emojiPickerHeightWithPreview", () => $6c84915fafd28375$export$e67f617938b111f1);
$parcel$export(module.exports, "localStoragePrefix", () => $6c84915fafd28375$export$e394a0c530ae5631);
$parcel$export(module.exports, "selectedToneStorageKey", () => $6c84915fafd28375$export$79ee4ef84c545f8f);
$parcel$export(module.exports, "defaultCategories", () => $6c84915fafd28375$export$d7ab74456f1aa1ad);
$parcel$export(module.exports, "KeyboardKeys", () => $6c84915fafd28375$export$70f9e5bc10d7eac);
$parcel$export(module.exports, "KeyboardNavigationDirection", () => $6c84915fafd28375$export$1c4f2adc1f8e19d3);
$parcel$export(module.exports, "CATEGORYSELECTOR_KEYBOARD_KEYS_SUPPORTED", () => $6c84915fafd28375$export$99130b698ea188ae);
$parcel$export(module.exports, "EMOJI_KEYBOARD_KEYS_SUPPORTED", () => $6c84915fafd28375$export$84b035f8d01101cc);
$parcel$export(module.exports, "TONESELECTOR_KEYBOARD_KEYS_SUPPORTED", () => $6c84915fafd28375$export$e27d4e477c0cd4ec);
$parcel$export(module.exports, "EMOJIPICKERLIST_KEYBOARD_KEYS_SUPPORTED", () => $6c84915fafd28375$export$97027974dc06eeee);
$parcel$export(module.exports, "DEFAULT_TONE", () => $6c84915fafd28375$export$4f0ee90b28d6efc5);
$parcel$export(module.exports, "EMOJI_LIST_COLUMNS", () => $6c84915fafd28375$export$2829f3ec323f8ec0);
$parcel$export(module.exports, "EMOJI_LIST_PAGE_COUNT", () => $6c84915fafd28375$export$ce3a0e7d2d7d6ba2);
$parcel$export(module.exports, "EMOJI_SEARCH_DEBOUNCE", () => $6c84915fafd28375$export$858e8dc100a97278);
$parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RENDERED_EXP", () => $6c84915fafd28375$export$83aab2ae64548423);
$parcel$export(module.exports, "SAMPLING_RATE_EMOJI_RESOURCE_FETCHED_EXP", () => $6c84915fafd28375$export$66cabad5e268b05e);
const $6c84915fafd28375$export$5e4e3d1c3e43156a = 'CUSTOM';
const $6c84915fafd28375$export$78ccdc4be403c468 = 'FREQUENT';
const $6c84915fafd28375$export$2c4b04c3aacdf1b3 = 'SITE';
const $6c84915fafd28375$export$1b0258512be88334 = 'SEARCH';
const $6c84915fafd28375$export$42b510423367f354 = 'USER_CUSTOM';
const $6c84915fafd28375$export$5d0f2d8ee50f86f5 = 'allUploadsCustomCategory';
const $6c84915fafd28375$export$1debc2f10cc69389 = 'userUploadsCustomCategory';
const $6c84915fafd28375$export$8ac325bfd32359b0 = 'data:';
const $6c84915fafd28375$export$a330961542edfe6f = 'delete-emoji';
const $6c84915fafd28375$export$1a817f1886276c6d = 100000;
const $6c84915fafd28375$export$3f99ac31dc0406db = 20;
const $6c84915fafd28375$export$d171dc12fee2b1da = 350;
const $6c84915fafd28375$export$c10ac8125a260041 = 80;
const $6c84915fafd28375$export$5248fb9e0cccc41f = 'medium';
const $6c84915fafd28375$export$94f75d625e7801d3 = 260;
const $6c84915fafd28375$export$7ed599d166d65aea = 295;
const $6c84915fafd28375$export$7722b8e9522021df = $6c84915fafd28375$export$7ed599d166d65aea - 58; // picker height - actions height
const $6c84915fafd28375$export$e218e5cb105a0e22 = 54;
const $6c84915fafd28375$export$e67f617938b111f1 = $6c84915fafd28375$export$7ed599d166d65aea + $6c84915fafd28375$export$e218e5cb105a0e22;
const $6c84915fafd28375$export$e394a0c530ae5631 = 'fabric.emoji';
const $6c84915fafd28375$export$79ee4ef84c545f8f = `${$6c84915fafd28375$export$e394a0c530ae5631}.selectedTone`;
const $6c84915fafd28375$export$d7ab74456f1aa1ad = [
    'PEOPLE',
    'NATURE',
    'FOODS',
    'ACTIVITY',
    'PLACES',
    'OBJECTS',
    'SYMBOLS',
    'FLAGS'
];
var $6c84915fafd28375$export$70f9e5bc10d7eac;
(function(KeyboardKeys) {
    KeyboardKeys["ArrowLeft"] = "ArrowLeft";
    KeyboardKeys["ArrowRight"] = "ArrowRight";
    KeyboardKeys["ArrowUp"] = "ArrowUp";
    KeyboardKeys["ArrowDown"] = "ArrowDown";
    KeyboardKeys["PageUp"] = "PageUp";
    KeyboardKeys["PageDown"] = "PageDown";
    KeyboardKeys["Home"] = "Home";
    KeyboardKeys["End"] = "End";
    KeyboardKeys["Enter"] = "Enter";
    KeyboardKeys["Tab"] = "Tab";
    KeyboardKeys["Space"] = " ";
    KeyboardKeys["Backspace"] = "Backspace";
})($6c84915fafd28375$export$70f9e5bc10d7eac || ($6c84915fafd28375$export$70f9e5bc10d7eac = {}));
var $6c84915fafd28375$export$1c4f2adc1f8e19d3;
(function(KeyboardNavigationDirection) {
    KeyboardNavigationDirection["Down"] = "Down";
    KeyboardNavigationDirection["Up"] = "Up";
    KeyboardNavigationDirection["Left"] = "Left";
    KeyboardNavigationDirection["Right"] = "Right";
})($6c84915fafd28375$export$1c4f2adc1f8e19d3 || ($6c84915fafd28375$export$1c4f2adc1f8e19d3 = {}));
const $6c84915fafd28375$export$99130b698ea188ae = [
    "ArrowRight",
    "ArrowLeft",
    "Home",
    "End"
];
const $6c84915fafd28375$export$84b035f8d01101cc = [
    "Enter",
    "Backspace",
    " "
];
const $6c84915fafd28375$export$e27d4e477c0cd4ec = [
    "Enter",
    "Tab",
    " "
];
const $6c84915fafd28375$export$97027974dc06eeee = [
    "ArrowRight",
    "ArrowLeft",
    "Home",
    "End",
    "ArrowUp",
    "ArrowDown",
    "PageUp",
    "PageDown"
];
const $6c84915fafd28375$export$4f0ee90b28d6efc5 = 0;
const $6c84915fafd28375$export$9f7de4293d27f3aa = 50;
const $6c84915fafd28375$export$41388d9a435030e6 = 'hipchat_migration_emoticons';
const $6c84915fafd28375$export$273d18db3ba5f6b1 = 'atlassian.fabric.emoji.picker';
const $6c84915fafd28375$export$2829f3ec323f8ec0 = 8;
const $6c84915fafd28375$export$ce3a0e7d2d7d6ba2 = 5;
const $6c84915fafd28375$export$858e8dc100a97278 = 150;
const $6c84915fafd28375$export$83aab2ae64548423 = 20;
const $6c84915fafd28375$export$66cabad5e268b05e = 100;

});

parcelRegister("1JT4v", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6f307f280114d75$export$2e2bcd8739ae039);
let $e6f307f280114d75$var$debugEnabled = false;
let $e6f307f280114d75$var$stacktracesEnabled = false;
function $e6f307f280114d75$export$748ada60eaf985cc(enable) {
    $e6f307f280114d75$var$debugEnabled = enable;
}
function $e6f307f280114d75$export$4f7017086af31c25(enable) {
    $e6f307f280114d75$var$stacktracesEnabled = enable;
}
function $e6f307f280114d75$export$2a858f450a2f66d() {
    if ($e6f307f280114d75$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $e6f307f280114d75$export$2e2bcd8739ae039(msg, ...args) {
    if ($e6f307f280114d75$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});

parcelRegister("eG1kR", function(module, exports) {

$parcel$export(module.exports, "isSpriteServiceRepresentation", () => $e236d7b13598847d$export$1c52f72b88b558e8);
$parcel$export(module.exports, "isSpriteRepresentation", () => $e236d7b13598847d$export$a194199d673d75de);
$parcel$export(module.exports, "isImageRepresentation", () => $e236d7b13598847d$export$90b099a26fbd8b41);
$parcel$export(module.exports, "isMediaRepresentation", () => $e236d7b13598847d$export$979133dc1df141c6);
$parcel$export(module.exports, "isPromise", () => $e236d7b13598847d$export$4369c812aac99591);
$parcel$export(module.exports, "isEmojiDescription", () => $e236d7b13598847d$export$378ed2c87d03531c);
$parcel$export(module.exports, "isMediaEmoji", () => $e236d7b13598847d$export$a7e82c67204c73a1);
$parcel$export(module.exports, "isLoadedMediaEmoji", () => $e236d7b13598847d$export$d25a80b2c86d7fdf);
$parcel$export(module.exports, "isEmojiDescriptionWithVariations", () => $e236d7b13598847d$export$b0ed6d8df471f3cc);
$parcel$export(module.exports, "isEmojiVariationDescription", () => $e236d7b13598847d$export$82a0350e1f6b5c0a);
$parcel$export(module.exports, "isMessagesKey", () => $e236d7b13598847d$export$dddfba07c16c94d2);
$parcel$export(module.exports, "toEmojiId", () => $e236d7b13598847d$export$8d7d3de6b5b305d1);
$parcel$export(module.exports, "containsEmojiId", () => $e236d7b13598847d$export$39ed0ad389e58ef7);
$parcel$export(module.exports, "convertImageToMediaRepresentation", () => $e236d7b13598847d$export$20a1bd1d33069ce7);
$parcel$export(module.exports, "convertMediaToImageEmoji", () => $e236d7b13598847d$export$f1a89a11f425faaa);
$parcel$export(module.exports, "buildEmojiDescriptionWithAltRepresentation", () => $e236d7b13598847d$export$a48c58c688a3131);
$parcel$export(module.exports, "getCategoryId", () => $e236d7b13598847d$export$4bcbf61cb6832a8e);

var $iV58y = parcelRequire("iV58y");

var $dfT6d = parcelRequire("dfT6d");
const $e236d7b13598847d$export$1c52f72b88b558e8 = (rep)=>!!(rep && rep.spriteRef);
const $e236d7b13598847d$export$a194199d673d75de = (rep)=>!!(rep && rep.sprite);
const $e236d7b13598847d$export$90b099a26fbd8b41 = (rep)=>!!(rep && rep.imagePath);
const $e236d7b13598847d$export$979133dc1df141c6 = (rep)=>!!(rep && rep.mediaPath);
const $e236d7b13598847d$export$4369c812aac99591 = (p)=>!!(p && p.then);
const $e236d7b13598847d$export$378ed2c87d03531c = (possibleEmojiDescription)=>possibleEmojiDescription && possibleEmojiDescription.shortName && possibleEmojiDescription.type;
const $e236d7b13598847d$export$a7e82c67204c73a1 = (emoji)=>$e236d7b13598847d$export$979133dc1df141c6(emoji.representation);
const $e236d7b13598847d$export$7720a4954d6f75f8 = (rep)=>$e236d7b13598847d$export$90b099a26fbd8b41(rep) && rep.imagePath.indexOf((0, $dfT6d.dataURLPrefix)) === 0;
const $e236d7b13598847d$export$d25a80b2c86d7fdf = (emoji)=>emoji.category === (0, $dfT6d.customCategory) && $e236d7b13598847d$export$7720a4954d6f75f8(emoji.representation);
const $e236d7b13598847d$export$b0ed6d8df471f3cc = (emoji)=>!!(emoji && emoji.skinVariations);
const $e236d7b13598847d$export$82a0350e1f6b5c0a = (object)=>{
    return 'baseId' in object;
};
const $e236d7b13598847d$export$dddfba07c16c94d2 = (key)=>key in (0, $iV58y.messages);
const $e236d7b13598847d$export$8d7d3de6b5b305d1 = (emoji)=>({
        shortName: emoji.shortName,
        id: emoji.id,
        fallback: emoji.fallback
    });
const $e236d7b13598847d$export$2dbfa5a5d35af350 = (emoji)=>{
    if (!emoji) return undefined;
    return $e236d7b13598847d$export$8d7d3de6b5b305d1(emoji);
};
const $e236d7b13598847d$export$92ad509d7c96b723 = (l, r)=>l === r || l && r && l.id === r.id && l.shortName === r.shortName;
const $e236d7b13598847d$export$39ed0ad389e58ef7 = (emojis, emojiId)=>{
    if (!emojiId) return false;
    for(let i = 0; i < emojis.length; i++){
        if ($e236d7b13598847d$export$92ad509d7c96b723(emojis[i], emojiId)) return true;
    }
    return false;
};
const $e236d7b13598847d$export$20a1bd1d33069ce7 = (rep)=>({
        mediaPath: rep.imagePath,
        height: rep.height,
        width: rep.width
    });
const $e236d7b13598847d$export$3197405d49d2e298 = (rep, newImagePath)=>({
        imagePath: newImagePath || rep.mediaPath,
        height: rep.height,
        width: rep.width
    });
const $e236d7b13598847d$export$f1a89a11f425faaa = (emoji, newImagePath, useAlt)=>{
    const mediaRepresentation = emoji.representation;
    const mediaAltRepresentation = emoji.altRepresentation;
    const imgPath = !useAlt ? newImagePath : undefined;
    const altImgPath = useAlt ? newImagePath : undefined;
    if (!$e236d7b13598847d$export$979133dc1df141c6(mediaRepresentation) && !$e236d7b13598847d$export$979133dc1df141c6(mediaAltRepresentation)) return emoji;
    const representation = $e236d7b13598847d$export$979133dc1df141c6(mediaRepresentation) ? $e236d7b13598847d$export$3197405d49d2e298(mediaRepresentation, imgPath) : mediaRepresentation;
    const altRepresentation = $e236d7b13598847d$export$979133dc1df141c6(mediaAltRepresentation) ? $e236d7b13598847d$export$3197405d49d2e298(mediaAltRepresentation, altImgPath) : mediaAltRepresentation;
    const baseEmoji = {
        ...emoji,
        representation: representation
    };
    return $e236d7b13598847d$export$a48c58c688a3131(baseEmoji, altRepresentation);
};
const $e236d7b13598847d$export$a48c58c688a3131 = (emoji, altRepresentation)=>{
    if (!altRepresentation) return emoji;
    return {
        ...emoji,
        altRepresentation: altRepresentation
    };
};
const $e236d7b13598847d$export$4bcbf61cb6832a8e = (emoji)=>emoji.category;

});
parcelRegister("iV58y", function(module, exports) {

$parcel$export(module.exports, "messages", () => $892439d1838eaeab$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $892439d1838eaeab$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    deleteEmojiTooltip: {
        id: 'fabric.emoji.delete.tooltip',
        defaultMessage: 'Delete',
        description: 'Tooltip content for delete emoji when focus on deletable emoji'
    },
    deleteEmojiTooltipForScreenreader: {
        id: 'fabric.emoji.delete.screenreader.tooltip',
        defaultMessage: 'To delete {shortName} emoji, press Backspace',
        description: 'Tooltip content for delete emoji when focus on deletable emoji'
    },
    deleteEmojiTitle: {
        id: 'fabric.emoji.delete.title',
        defaultMessage: 'Remove emoji',
        description: 'Title for emoji removal dialog'
    },
    deleteEmojiDescription: {
        id: 'fabric.emoji.delete.description',
        defaultMessage: 'All existing instances of this emoji will be replaced with {emojiShortName}',
        description: 'Description for emoji removal dialog'
    },
    deleteEmojiLabel: {
        id: 'fabric.emoji.delete.label',
        defaultMessage: 'Remove',
        description: 'Button label to remove emoji'
    },
    addCustomEmojiLabel: {
        id: 'fabric.emoji.add.custom.emoji.label',
        defaultMessage: 'Add your own emoji',
        description: 'Button label to add custom emoji'
    },
    emojiPlaceholder: {
        id: 'fabric.emoji.placeholder',
        defaultMessage: 'e.g. hello',
        description: 'Placeholder for emoji that provides an example for emoji name'
    },
    emojiNameAriaLabel: {
        id: 'fabric.emoji.name.ariaLabel',
        defaultMessage: 'Enter a name for the new emoji',
        description: 'Explains to enter a name for a new emoji'
    },
    emojiChooseFileTitle: {
        id: 'fabric.emoji.choose.file.title',
        defaultMessage: 'Choose file',
        description: 'Choose custom emoji file'
    },
    emojiChooseFileScreenReaderDescription: {
        id: 'fabric.emoji.choose.file.screenReaderDescription',
        defaultMessage: 'Choose a file for the emoji. JPG, PNG or GIF. Max size 1 MB',
        description: 'Message indicating the purpose of choosing the file and requirements for the file'
    },
    emojiSelectSkinToneButtonAriaLabelText: {
        id: 'fabric.emoji.select.skin.tone.ariaLabel',
        defaultMessage: 'Choose your skin tone, {selectedTone} selected',
        description: 'Message indicating the purpose of the skin tone selection button and the selected tone'
    },
    emojiSelectSkinToneListAriaLabelText: {
        id: 'fabric.emoji.select.skin.list.ariaLabel',
        defaultMessage: 'Skin tone selector',
        description: 'Message indicating the purpose of the skin tone list and make user to choose one tone'
    },
    emojiImageRequirements: {
        id: 'fabric.emoji.image.requirements',
        defaultMessage: 'JPG, PNG or GIF. Max size 1 MB.',
        description: 'Message for emoji image requirements and maximum file size'
    },
    emojiPreviewTitle: {
        id: 'fabric.emoji.preview.title',
        defaultMessage: 'Preview',
        description: 'Emoji preview title'
    },
    emojiPreview: {
        id: 'fabric.emoji.preview',
        defaultMessage: 'Your new emoji {emoji} looks great',
        description: 'Emoji preview'
    },
    addEmojiLabel: {
        id: 'fabric.emoji.add.label',
        defaultMessage: 'Add emoji',
        description: 'verb - Button label to add emoji'
    },
    retryLabel: {
        id: 'fabric.emoji.retry.label',
        defaultMessage: 'Retry',
        description: 'verb - Button label to retry upload'
    },
    cancelLabel: {
        id: 'fabric.emoji.cancel.label',
        defaultMessage: 'Cancel',
        description: 'verb - button label to cancel operation'
    },
    searchPlaceholder: {
        id: 'fabric.emoji.search.placeholder',
        defaultMessage: 'Search',
        description: 'Placeholder for search emoji field'
    },
    searchLabel: {
        id: 'fabric.emoji.search.label',
        defaultMessage: 'Emoji name',
        description: 'verb - button label to search'
    },
    searchResultsStatus: {
        id: 'fabric.emoji.search.status',
        defaultMessage: 'Found {count} emojis',
        description: 'search results status for screenreader to read out'
    },
    searchResultsStatusSeeAll: {
        id: 'fabric.emoji.search.status',
        defaultMessage: 'Seeing all emojis',
        description: 'search results status when no search query for screenreader to read out'
    },
    categoriesSelectorLabel: {
        id: 'fabric.emoji.categories.label',
        defaultMessage: 'Choose an emoji category',
        description: 'Aria label for Emoji categories selector at the top of emoji picker'
    },
    categoriesSearchResults: {
        id: 'fabric.emoji.categories.search.results',
        defaultMessage: 'Search results',
        description: 'Emoji categories search results'
    },
    frequentCategory: {
        id: 'fabric.emoji.category.frequent',
        defaultMessage: 'Frequent',
        description: 'Emoji frequent category'
    },
    peopleCategory: {
        id: 'fabric.emoji.category.people',
        defaultMessage: 'People',
        description: 'Emoji frequent category'
    },
    natureCategory: {
        id: 'fabric.emoji.category.nature',
        defaultMessage: 'Nature',
        description: 'Emoji nature category'
    },
    foodsCategory: {
        id: 'fabric.emoji.category.foods',
        defaultMessage: 'Food & Drink',
        description: 'Emoji Foods category'
    },
    activityCategory: {
        id: 'fabric.emoji.category.activity',
        defaultMessage: 'Activity',
        description: 'Emoji activity category'
    },
    placesCategory: {
        id: 'fabric.emoji.category.places',
        defaultMessage: 'Travel & Places',
        description: 'Emoji Places category'
    },
    objectsCategory: {
        id: 'fabric.emoji.category.objects',
        defaultMessage: 'Objects',
        description: 'Emoji objects category'
    },
    symbolsCategory: {
        id: 'fabric.emoji.category.symbols',
        defaultMessage: 'Symbols',
        description: 'Emoji symbols category'
    },
    flagsCategory: {
        id: 'fabric.emoji.category.flags',
        defaultMessage: 'Flags',
        description: 'Emoji flags category'
    },
    productivityCategory: {
        id: 'fabric.emoji.category.productivity',
        defaultMessage: 'Productivity',
        description: 'Emoji productivity category'
    },
    userUploadsCustomCategory: {
        id: 'fabric.emoji.category.user.uploads',
        defaultMessage: 'Your uploads',
        description: 'User uploads in the custom category'
    },
    allUploadsCustomCategory: {
        id: 'fabric.emoji.category.all.uploads',
        defaultMessage: 'All uploads',
        description: 'All uploads in the custom category'
    },
    deleteEmojiFailed: {
        id: 'fabric.emoji.error.delete.failed',
        defaultMessage: 'Remove failed',
        description: 'Error message when custom emoji failed to be removed'
    },
    emojiInvalidImage: {
        id: 'fabric.emoji.error.invalid.image',
        defaultMessage: 'Selected image is invalid',
        description: 'Error message for invalid selected image'
    },
    emojiUploadFailed: {
        id: 'fabric.emoji.error.upload.failed',
        defaultMessage: 'Upload failed',
        description: 'Failed to upload emoji image'
    },
    emojiImageTooBig: {
        id: 'fabric.emoji.error.image.too.big',
        defaultMessage: 'Selected image is more than 1 MB',
        description: 'Error message for image too big, beyond the size limit'
    },
    emojiPickerTitle: {
        id: 'fabric.emoji.picker',
        defaultMessage: 'Emoji picker',
        description: 'Aria label for emoji picker'
    },
    emojiPickerListPanel: {
        id: 'fabric.emoji.pickerlist.tabpanel',
        defaultMessage: 'Emojis actions and list panel',
        description: 'Aria lable for tabpanel of emoji picker, which shows emojis actions and list'
    },
    emojiPickerGrid: {
        id: 'fabric.emoji.pickerlist.grid',
        defaultMessage: '{showSearchResults, select, true{Search results} other{Emojis}}',
        description: `Aria label for emoji picker grid, showSearchResults is a boolean variable, message will be "Entering Emojis table", or "Leaving Emojis"`
    },
    emojiButtonRoleDescription: {
        id: 'fabric.emoji.emojipicker.emoi.roledescription',
        defaultMessage: 'emoji button',
        description: `Aria roledescription for emoji button, used in emoji picker.`
    },
    error: {
        id: 'fabric.emoji.emojipicker.error',
        defaultMessage: 'Error!',
        description: `Aria label for error icon, apperaed in emoji uploader screens and delete emoji screens of emoji picker`
    }
});

});


parcelRegister("cfJOp", function(module, exports) {

$parcel$export(module.exports, "default", () => $602498cd222aad7d$export$2e2bcd8739ae039);
function $602498cd222aad7d$export$2e2bcd8739ae039(type) {
    if (typeof window === 'undefined') return false;
    var storage;
    try {
        storage = window[type];
        var x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (e) {
        return e instanceof DOMException && // everything except Firefox
        (e.code === 22 || // Firefox
        e.code === 1014 || // test name field too, because code might not be present
        // everything except Firefox
        e.name === 'QuotaExceededError' || // Firefox
        e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && // acknowledge QuotaExceededError only if there's something already stored
        storage && storage.length !== 0;
    }
}

});

parcelRegister("9L9vJ", function(module, exports) {

$parcel$export(module.exports, "SearchSort", () => $1374d09a22698b2b$export$a15e9a4340d08b2e);
$parcel$export(module.exports, "SearchSourceTypes", () => $1374d09a22698b2b$export$db41220f541db607);
$parcel$export(module.exports, "ProviderTypes", () => $1374d09a22698b2b$export$bf337c9223e5c8b);
$parcel$export(module.exports, "UfoExperienceName", () => $1374d09a22698b2b$export$d0d1c9cd31a11a64);
$parcel$export(module.exports, "UfoComponentName", () => $1374d09a22698b2b$export$122ce5c8fda96269);
$parcel$export(module.exports, "UfoEmojiTimingsKeys", () => $1374d09a22698b2b$export$265ee18146a6885e);
$parcel$export(module.exports, "UfoEmojiTimings", () => $1374d09a22698b2b$export$482549d945a3723);
var $1374d09a22698b2b$export$a15e9a4340d08b2e;
(function(SearchSort) {
    // no sort - just the default ordering of emoji
    SearchSort[SearchSort["None"] = 0] = "None";
    // a sort taking into account a number of factors including, usage, closeness of match to the query, etc
    SearchSort[SearchSort["Default"] = 1] = "Default";
    // sort such that the most frequently used emoji come first, and then standard, service defined ordering is preserved.
    SearchSort[SearchSort["UsageFrequency"] = 2] = "UsageFrequency";
})($1374d09a22698b2b$export$a15e9a4340d08b2e || ($1374d09a22698b2b$export$a15e9a4340d08b2e = {}));
var $1374d09a22698b2b$export$db41220f541db607;
(function(SearchSourceTypes) {
    SearchSourceTypes["PICKER"] = "picker";
    SearchSourceTypes["TYPEAHEAD"] = "typeahead";
})($1374d09a22698b2b$export$db41220f541db607 || ($1374d09a22698b2b$export$db41220f541db607 = {}));
var $1374d09a22698b2b$export$bf337c9223e5c8b;
(function(ProviderTypes) {
    ProviderTypes["SITE"] = "SITE";
    ProviderTypes["STANDARD"] = "STANDARD";
    ProviderTypes["ATLASSIAN"] = "ATLASSIAN";
    ProviderTypes["UNKNOWN"] = "UNKNOWN";
    ProviderTypes["SINGLE"] = "SINGLE";
})($1374d09a22698b2b$export$bf337c9223e5c8b || ($1374d09a22698b2b$export$bf337c9223e5c8b = {}));
var $1374d09a22698b2b$export$d0d1c9cd31a11a64;
(function(UfoExperienceName) {
    UfoExperienceName["EMOJI_RENDERED"] = "emoji-rendered";
    UfoExperienceName["EMOJI_RESOURCE_FETCHED"] = "emoji-resource-fetched";
    UfoExperienceName["EMOJI_PICKER_OPENED"] = "emoji-picker-opened";
    UfoExperienceName["EMOJI_SELECTION_RECORDED"] = "emoji-selection-recorded";
    UfoExperienceName["EMOJI_UPLOADED"] = "emoji-uploaded";
    UfoExperienceName["EMOJI_SEARCHED"] = "emoji-searched";
})($1374d09a22698b2b$export$d0d1c9cd31a11a64 || ($1374d09a22698b2b$export$d0d1c9cd31a11a64 = {}));
var $1374d09a22698b2b$export$122ce5c8fda96269;
(function(UfoComponentName) {
    UfoComponentName["EMOJI"] = "emoji";
    UfoComponentName["EMOJI_PICKER"] = "emoji-picker";
    UfoComponentName["EMOJI_PROVIDER"] = "emoji-provider";
})($1374d09a22698b2b$export$122ce5c8fda96269 || ($1374d09a22698b2b$export$122ce5c8fda96269 = {}));
var $1374d09a22698b2b$export$265ee18146a6885e;
(function(UfoEmojiTimingsKeys) {
    UfoEmojiTimingsKeys["FMP"] = "fmp";
    UfoEmojiTimingsKeys["MOUNTED"] = "emoji-mount";
    UfoEmojiTimingsKeys["METADATA"] = "emoji-metadata";
    UfoEmojiTimingsKeys["MEDIADATA"] = "emoji-media";
    UfoEmojiTimingsKeys["ONLOAD"] = "emoji-onload";
})($1374d09a22698b2b$export$265ee18146a6885e || ($1374d09a22698b2b$export$265ee18146a6885e = {}));
var $1374d09a22698b2b$export$482549d945a3723;
(function(UfoEmojiTimings) {
    UfoEmojiTimings["FMP_END"] = "fmp";
    UfoEmojiTimings["MOUNTED_END"] = "emoji-mount_end";
    UfoEmojiTimings["METADATA_START"] = "emoji-metadata_start";
    UfoEmojiTimings["METADATA_END"] = "emoji-metadata_end";
    UfoEmojiTimings["MEDIA_START"] = "emoji-media_start";
    UfoEmojiTimings["MEDIA_END"] = "emoji-media_end";
    UfoEmojiTimings["ONLOAD_START"] = "emoji-onload_start";
    UfoEmojiTimings["ONLOAD_END"] = "emoji-onload_end";
})($1374d09a22698b2b$export$482549d945a3723 || ($1374d09a22698b2b$export$482549d945a3723 = {}));

});

parcelRegister("9AK7V", function(module, exports) {

$parcel$export(module.exports, "default", () => $884c2227220417b5$export$2e2bcd8739ae039);

var $1IjlQ = parcelRequire("1IjlQ");
class $884c2227220417b5$export$2e2bcd8739ae039 {
    constructor(config){
        this.config = config;
    }
    /**
	 * Returns a promise with an array of Emoji from all providers.
	 */ loadEmoji() {
        const emojisPromise = (0, $1IjlQ.emojiRequest)(this.config);
        return emojisPromise.then((emojiServiceResponse)=>(0, $1IjlQ.denormaliseEmojiServiceResponse)(emojiServiceResponse));
    }
}

});
parcelRegister("1IjlQ", function(module, exports) {

$parcel$export(module.exports, "emojiRequest", () => $d48d07c2901fb5db$export$ea1accde4cc117f4);
$parcel$export(module.exports, "getAltRepresentation", () => $d48d07c2901fb5db$export$4a0301d636367e1d);
$parcel$export(module.exports, "denormaliseEmojiServiceResponse", () => $d48d07c2901fb5db$export$afaea97e40b5ca70);
$parcel$export(module.exports, "shouldUseAltRepresentation", () => $d48d07c2901fb5db$export$b7e9058f156d8d19);

var $16UJG = parcelRequire("16UJG");

var $eG1kR = parcelRequire("eG1kR");

var $1JT4v = parcelRequire("1JT4v");
const $d48d07c2901fb5db$export$ea1accde4cc117f4 = (provider, options)=>{
    const { getRatio: getRatio = $d48d07c2901fb5db$export$d39ce20a37bba061, ...serviceConfig } = provider;
    const scaleQueryParams = $d48d07c2901fb5db$var$calculateScale(getRatio);
    const { queryParams: queryParams = {}, ...otherOptions } = options || {};
    const requestOptions = {
        ...otherOptions,
        queryParams: {
            ...scaleQueryParams,
            ...queryParams,
            preferredRepresentation: 'IMAGE'
        }
    };
    return (0, $16UJG.utils).requestService(serviceConfig, requestOptions);
};
const $d48d07c2901fb5db$var$calculateScale = (getRatio)=>{
    // Retina display
    if (getRatio() > 1) return {
        scale: 'XHDPI',
        altScale: 'XXXHDPI'
    };
    // Default set used for desktop
    return {
        altScale: 'XHDPI'
    };
};
const $d48d07c2901fb5db$export$d39ce20a37bba061 = ()=>{
    if (typeof window === 'undefined') return 0;
    return window.devicePixelRatio;
};
const $d48d07c2901fb5db$export$4a0301d636367e1d = (reps)=>{
    // Invalid reps handled outside function - logic may change depending what the service returns
    return reps[$d48d07c2901fb5db$var$calculateScale($d48d07c2901fb5db$export$d39ce20a37bba061).altScale];
};
const $d48d07c2901fb5db$export$db05e6ae1fd416af = (url, meta)=>!!(meta && meta.mediaApiToken && url.indexOf(meta.mediaApiToken.url) === 0);
const $d48d07c2901fb5db$export$55077db3efc820aa = (representation, meta)=>{
    if ((0, $eG1kR.isSpriteServiceRepresentation)(representation) && meta && meta.spriteSheets) {
        const { height: height, width: width, x: x, y: y, xIndex: xIndex, yIndex: yIndex, spriteRef: spriteRef } = representation;
        const spriteSheet = meta.spriteSheets[spriteRef];
        if (spriteSheet) return {
            sprite: spriteSheet,
            height: height,
            width: width,
            x: x,
            y: y,
            xIndex: xIndex,
            yIndex: yIndex
        };
    } else if ((0, $eG1kR.isImageRepresentation)(representation)) {
        const { height: height, width: width, imagePath: imagePath } = representation;
        if ($d48d07c2901fb5db$export$db05e6ae1fd416af(imagePath, meta)) return (0, $eG1kR.convertImageToMediaRepresentation)(representation);
        return {
            height: height,
            width: width,
            imagePath: imagePath
        };
    }
    (0, $1JT4v.default)('failed conversion for representation', representation, meta);
    return undefined;
};
const $d48d07c2901fb5db$export$aa9faa01267cb2e7 = (altReps, meta)=>{
    return !altReps || Object.keys(altReps).length === 0 ? undefined : $d48d07c2901fb5db$export$55077db3efc820aa($d48d07c2901fb5db$export$4a0301d636367e1d(altReps), meta);
};
const $d48d07c2901fb5db$export$e3da49c88c2e54d5 = (emoji, meta)=>{
    if (!emoji.skinVariations) return [];
    const skinEmoji = emoji.skinVariations;
    const baseId = emoji.id;
    return skinEmoji.map((skin)=>{
        const { representation: representation, altRepresentations: altRepresentations, ...other } = skin;
        return {
            baseId: baseId,
            representation: $d48d07c2901fb5db$export$55077db3efc820aa(representation, meta),
            altRepresentation: $d48d07c2901fb5db$export$aa9faa01267cb2e7(altRepresentations, meta),
            ...other
        };
    });
};
const $d48d07c2901fb5db$export$afaea97e40b5ca70 = (emojiData)=>{
    const emojis = emojiData.emojis.map((emoji)=>{
        const newRepresentation = $d48d07c2901fb5db$export$55077db3efc820aa(emoji.representation, emojiData.meta);
        const altRepresentation = $d48d07c2901fb5db$export$aa9faa01267cb2e7(emoji.altRepresentations, emojiData.meta);
        const newSkinVariations = $d48d07c2901fb5db$export$e3da49c88c2e54d5(emoji, emojiData.meta);
        // create trimmedServiceDesc which is emoji with no representations or skinVariations
        const { representation: representation, skinVariations: skinVariations, altRepresentations: altRepresentations, ...trimmedServiceDesc } = emoji;
        const response = {
            ...trimmedServiceDesc,
            representation: newRepresentation,
            skinVariations: newSkinVariations
        };
        return (0, $eG1kR.buildEmojiDescriptionWithAltRepresentation)(response, altRepresentation);
    });
    const mediaApiToken = emojiData.meta && emojiData.meta.mediaApiToken;
    return {
        emojis: emojis,
        mediaApiToken: mediaApiToken
    };
};
const $d48d07c2901fb5db$var$getHeight = (fitToHeight)=>$d48d07c2901fb5db$export$d39ce20a37bba061() > 1 ? fitToHeight * 2 : fitToHeight;
const $d48d07c2901fb5db$export$b7e9058f156d8d19 = (emoji, fitToHeight)=>!!(fitToHeight && emoji.altRepresentation && $d48d07c2901fb5db$var$getHeight(fitToHeight) > emoji.representation.height);

});


parcelRegister("QniiQ", function(module, exports) {

$parcel$export(module.exports, "getEmojiVariation", () => $896c1f013ba0c0c9$export$e55e46e1520c899d);
$parcel$export(module.exports, "default", () => $896c1f013ba0c0c9$export$2e2bcd8739ae039);

var $eI6D0 = parcelRequire("eI6D0");

var $dfT6d = parcelRequire("dfT6d");

var $eG1kR = parcelRequire("eG1kR");

var $9L9vJ = parcelRequire("9L9vJ");

var $cQka3 = parcelRequire("cQka3");

var $ekdQj = parcelRequire("ekdQj");

var $5H2wb = parcelRequire("5H2wb");
// FS-1097 - duplicated in mentions - extract at some point into a shared library
class $896c1f013ba0c0c9$var$Tokenizer {
    tokenize(text) {
        return this.tokenizeAsTokens(text).map((token)=>token.token);
    }
    tokenizeAsTokens(text) {
        let match;
        let tokens = [];
        (0, $cQka3.tokenizerRegex).lastIndex = 0;
        while((match = (0, $cQka3.tokenizerRegex).exec(text)) !== null)if (match[0]) tokens.push({
            token: match[0],
            start: match.index
        });
        return tokens;
    }
}
const $896c1f013ba0c0c9$var$addAllVariants = (emoji, fnKey, map)=>{
    const key = fnKey(emoji);
    if (!map.has(key)) map.set(key, []);
    const emojisForKey = map.get(key);
    // Unnecessary, but typescript thinks it is. :/
    if (emojisForKey) emojisForKey.push(emoji);
    if ((0, $eG1kR.isEmojiDescriptionWithVariations)(emoji)) {
        // map variations too
        const variations = emoji.skinVariations;
        if (variations) variations.forEach((variation)=>$896c1f013ba0c0c9$var$addAllVariants(variation, fnKey, map));
    }
};
const $896c1f013ba0c0c9$var$findByKey = (map, key)=>{
    const emojis = map.get(key);
    if (emojis && emojis.length) // Priority is always to source from the last emoji set (last overrides first)
    return emojis[emojis.length - 1];
    return undefined;
};
const $896c1f013ba0c0c9$var$splitQuery = (query = '')=>{
    const isColonQuery = query.indexOf(':') === 0;
    if (isColonQuery) return {
        nameQuery: query.slice(1),
        asciiQuery: query
    };
    return {
        nameQuery: query,
        asciiQuery: ''
    };
};
const $896c1f013ba0c0c9$export$e55e46e1520c899d = (emoji, options)=>{
    if ((0, $eG1kR.isEmojiDescriptionWithVariations)(emoji) && options) {
        const skinTone = options.skinTone;
        if (skinTone && emoji.skinVariations && emoji.skinVariations.length) {
            const skinToneEmoji = emoji.skinVariations[skinTone - 1]; // skinTone start at 1
            if (skinToneEmoji) return skinToneEmoji;
        }
    }
    return emoji;
};
const $896c1f013ba0c0c9$var$findEmojiIndex = (emojis, toFind)=>{
    const findId = toFind.id;
    let match = -1;
    emojis.forEach((emoji, index)=>{
        // Match if ID is defined and are equal
        // Or both have no id and shortnames match
        if (emoji.id && emoji.id === findId || !emoji.id && !findId && emoji.shortName === toFind.shortName) {
            match = index;
            return;
        }
    });
    return match;
};
class $896c1f013ba0c0c9$export$2e2bcd8739ae039 {
    static{
        this.defaultEmojiWeight = 1000000;
    }
    constructor(emojis, usageTracker){
        this.emojis = emojis;
        this.initMembers(usageTracker);
    }
    /**
	 * Returns all available (and searchable) emoji in some default order.
	 */ all() {
        const options = {
            sort: (0, $9L9vJ.SearchSort).None
        };
        return this.search('', options);
    }
    /**
	 * Text search of emoji shortName and name field for suitable matches.
	 *
	 * Returns an array of all (searchable) emoji if query is empty or null, otherwise returns matching emoji.
	 *
	 * You can change how the results are sorted by specifying a custom EmojiComparator in the SearchOptions. If
	 * you don't want any sorting you can also disable via the SearchOptions (this might be a useful optimisation).
	 * If no sort is specified in SearchOptions then a default sorting it applied based on the query.
	 */ search(query, options) {
        let filteredEmoji = [];
        const { nameQuery: nameQuery, asciiQuery: asciiQuery } = $896c1f013ba0c0c9$var$splitQuery(query);
        if (nameQuery) {
            filteredEmoji = this.fullSearch.search(nameQuery);
            if (asciiQuery) filteredEmoji = this.withAsciiMatch(asciiQuery, filteredEmoji);
        } else filteredEmoji = this.getAllSearchableEmojis();
        filteredEmoji = this.applySearchOptions(filteredEmoji, query, options);
        return {
            emojis: filteredEmoji,
            query: query
        };
    }
    /**
	 * Returns all emoji with matching shortName
	 */ findAllMatchingShortName(shortName) {
        return this.shortNameMap.get(shortName) || [];
    }
    /**
	 * Returns the first matching emoji matching the shortName, or null if none found.
	 */ findByShortName(shortName) {
        return $896c1f013ba0c0c9$var$findByKey(this.shortNameMap, shortName);
    }
    /**
	 * Returns the first matching emoji matching the id, or null if none found.
	 */ findById(id) {
        return $896c1f013ba0c0c9$var$findByKey(this.idMap, id);
    }
    findByAsciiRepresentation(asciiEmoji) {
        return this.asciiMap.get(asciiEmoji);
    }
    findInCategory(categoryId) {
        if (categoryId === (0, $dfT6d.frequentCategory)) return this.getFrequentlyUsed();
        else return this.all().emojis.filter((emoji)=>emoji.category === categoryId);
    }
    addUnknownEmoji(emoji) {
        this.emojis = [
            ...this.emojis,
            emoji
        ];
        this.fullSearch.addDocuments([
            emoji
        ]);
        this.addToMaps(emoji);
        this.addToDynamicCategories(emoji);
    }
    getAsciiMap() {
        return this.asciiMap;
    }
    /**
	 * Return the most frequently used emoji, ordered from most frequent to least frequent. Return an empty array if
	 * there are none.
	 *
	 * @param options optional settings to be applied to the set of frequently used emoji
	 */ getFrequentlyUsed(options) {
        const emojiIds = this.usageTracker.getOrder();
        let emojiResult = emojiIds.map((id)=>this.findById(id)).filter((e)=>e !== undefined);
        if (options) emojiResult = this.applySearchOptions(emojiResult, '', options);
        return emojiResult;
    }
    getDynamicCategoryList() {
        return this.dynamicCategoryList.slice();
    }
    /**
	 * Call this on emoji usage to allow the EmojiRepository to track the usage of emoji (which could be useful
	 * in sorting, etc).
	 *
	 * @param emoji the emoji that was just used
	 */ used(emoji) {
        this.usageTracker.recordUsage(emoji);
        // If this is the first usage ensure that we update the dynamic categories.
        // This is done in a 'timeout' since the usageTracker call previously also happens in a timeout. This ensures that
        // the frequent category will not appear until the usage has been tracked (avoiding the possibility of an empty
        // frequent category being shown in the picker).
        if (this.dynamicCategoryList.indexOf((0, $dfT6d.frequentCategory)) === -1) {
            if (typeof window === 'undefined') return;
            window.setTimeout(()=>{
                this.dynamicCategoryList.push((0, $dfT6d.frequentCategory));
            });
        }
    }
    delete(emoji) {
        const deletedIndex = $896c1f013ba0c0c9$var$findEmojiIndex(this.emojis, emoji);
        if (deletedIndex !== -1) {
            // Remove the deleted emojis from the internal list
            this.emojis.splice(deletedIndex, 1);
            // Reconstruct repository member variables
            this.initMembers(this.usageTracker);
        }
    }
    withAsciiMatch(ascii, emojis) {
        let result = emojis;
        const asciiEmoji = this.findByAsciiRepresentation(ascii);
        if (asciiEmoji) {
            // Ensures that the same emoji isn't already in the list
            // If it is, we give precedence to the ascii match
            result = emojis.filter((e)=>e.id !== asciiEmoji.id);
            result = [
                asciiEmoji,
                ...result
            ];
        }
        return result;
    }
    applySearchOptions(emojis, query, options) {
        if (!options) options = {};
        if (options.sort === undefined) options.sort = (0, $9L9vJ.SearchSort).Default;
        let comparator;
        if (options.sort === (0, $9L9vJ.SearchSort).Default) comparator = (0, $ekdQj.createSearchEmojiComparator)(query, this.usageTracker.getOrder());
        else if (options.sort === (0, $9L9vJ.SearchSort).UsageFrequency) comparator = (0, $ekdQj.createUsageOnlyEmojiComparator)(this.usageTracker.getOrder());
        if (comparator) {
            comparator.compare = comparator.compare.bind(comparator); // TODO bind at a better place
            emojis = emojis.sort(comparator.compare);
        }
        if (options.limit && options.limit > 0) emojis = emojis.slice(0, options.limit);
        if (options.skinTone) return emojis.map((emoji)=>{
            return $896c1f013ba0c0c9$export$e55e46e1520c899d(emoji, options);
        });
        return emojis;
    }
    initMembers(usageTracker) {
        this.usageTracker = usageTracker || new (0, $5H2wb.UsageFrequencyTracker)();
        this.initRepositoryMetadata();
        this.initSearchIndex();
    }
    /**
	 * Optimisation to initialise all map member variables in single loop over emojis
	 */ initRepositoryMetadata() {
        this.shortNameMap = new Map();
        this.idMap = new Map();
        this.asciiMap = new Map();
        const categorySet = new Set();
        this.emojis.forEach((emoji)=>{
            categorySet.add(emoji.category);
            this.addToMaps(emoji);
        });
        if (this.usageTracker.getOrder().length) categorySet.add((0, $dfT6d.frequentCategory));
        this.dynamicCategoryList = Array.from(categorySet).filter((category)=>(0, $dfT6d.defaultCategories).indexOf(category) === -1);
    }
    initSearchIndex() {
        this.fullSearch = new (0, $eI6D0.Search)('id');
        this.fullSearch.tokenizer = new $896c1f013ba0c0c9$var$Tokenizer();
        this.fullSearch.searchIndex = new (0, $eI6D0.UnorderedSearchIndex)();
        this.fullSearch.addIndex('name');
        this.fullSearch.addIndex('shortName');
        this.fullSearch.addDocuments(this.getAllSearchableEmojis());
    }
    getAllSearchableEmojis() {
        return this.emojis.filter((emojiDescription)=>emojiDescription.searchable);
    }
    addToMaps(emoji) {
        // Give default value and assign higher weight to Atlassian emojis for logical order when sorting
        if (typeof emoji.order === 'undefined' || emoji.order === -1) emoji.order = $896c1f013ba0c0c9$export$2e2bcd8739ae039.defaultEmojiWeight;
        if (typeof emoji.id === 'undefined') emoji.id = $896c1f013ba0c0c9$export$2e2bcd8739ae039.defaultEmojiWeight.toString();
        $896c1f013ba0c0c9$var$addAllVariants(emoji, (e)=>e.shortName, this.shortNameMap);
        $896c1f013ba0c0c9$var$addAllVariants(emoji, (e)=>e.id, this.idMap);
        if (emoji.ascii) emoji.ascii.forEach((a)=>this.asciiMap.set(a, emoji));
    }
    addToDynamicCategories(emoji) {
        const category = (0, $eG1kR.getCategoryId)(emoji);
        if ((0, $dfT6d.defaultCategories).indexOf(category) === -1 && this.dynamicCategoryList.indexOf(category) === -1) this.dynamicCategoryList.push(category);
    }
}

});
parcelRegister("eI6D0", function(module, exports) {

$parcel$export(module.exports, "UnorderedSearchIndex", () => $ab5a50fa126dae14$export$5e70dbef3f0d47db);
$parcel$export(module.exports, "Search", () => $ab5a50fa126dae14$export$4b85d3515bd863a5);
/**
 * Indexes for all substring searches (e.g. the term "cat" is indexed as "c", "ca", "cat", "a", "at", and "t").
 */ var $ab5a50fa126dae14$export$58ac23006833dfe0 = /*#__PURE__*/ function() {
    function AllSubstringsIndexStrategy() {}
    var _proto = AllSubstringsIndexStrategy.prototype;
    /**
   * @inheritDocs
   */ _proto.expandToken = function expandToken(token) {
        var expandedTokens = [];
        var string;
        for(var i = 0, length = token.length; i < length; ++i){
            string = '';
            for(var j = i; j < length; ++j){
                string += token.charAt(j);
                expandedTokens.push(string);
            }
        }
        return expandedTokens;
    };
    return AllSubstringsIndexStrategy;
}();
/**
 * Indexes for exact word matches.
 */ var $ab5a50fa126dae14$export$1dcc2d6a64836c8f = /*#__PURE__*/ function() {
    function ExactWordIndexStrategy() {}
    var _proto = ExactWordIndexStrategy.prototype;
    /**
   * @inheritDocs
   */ _proto.expandToken = function expandToken(token) {
        return token ? [
            token
        ] : [];
    };
    return ExactWordIndexStrategy;
}();
/**
 * Indexes for prefix searches (e.g. the term "cat" is indexed as "c", "ca", and "cat" allowing prefix search lookups).
 */ var $ab5a50fa126dae14$export$eb7fc80cfe9abfe6 = /*#__PURE__*/ function() {
    function PrefixIndexStrategy() {}
    var _proto = PrefixIndexStrategy.prototype;
    /**
   * @inheritDocs
   */ _proto.expandToken = function expandToken(token) {
        var expandedTokens = [];
        var string = '';
        for(var i = 0, length = token.length; i < length; ++i){
            string += token.charAt(i);
            expandedTokens.push(string);
        }
        return expandedTokens;
    };
    return PrefixIndexStrategy;
}();
/**
 * Enforces case-sensitive text matches.
 */ var $ab5a50fa126dae14$export$b88ffe9b5486f99a = /*#__PURE__*/ function() {
    function CaseSensitiveSanitizer() {}
    var _proto = CaseSensitiveSanitizer.prototype;
    /**
   * @inheritDocs
   */ _proto.sanitize = function sanitize(text) {
        return text ? text.trim() : '';
    };
    return CaseSensitiveSanitizer;
}();
/**
 * Sanitizes text by converting to a locale-friendly lower-case version and triming leading and trailing whitespace.
 */ var $ab5a50fa126dae14$export$147e8ac43c84713a = /*#__PURE__*/ function() {
    function LowerCaseSanitizer() {}
    var _proto = LowerCaseSanitizer.prototype;
    /**
   * @inheritDocs
   */ _proto.sanitize = function sanitize(text) {
        return text ? text.toLocaleLowerCase().trim() : '';
    };
    return LowerCaseSanitizer;
}();
/**
 * Find and return a nested object value.
 *
 * @param object to crawl
 * @param path Property path
 * @returns {any}
 */ function $ab5a50fa126dae14$var$getNestedFieldValue(object, path) {
    path = path || [];
    object = object || {};
    var value = object; // walk down the property path
    for(var i = 0; i < path.length; i++){
        value = value[path[i]];
        if (value == null) return null;
    }
    return value;
}
/**
 * Search index capable of returning results matching a set of tokens and ranked according to TF-IDF.
 */ var $ab5a50fa126dae14$export$a1138c79781169cc = /*#__PURE__*/ function() {
    function TfIdfSearchIndex(uidFieldName) {
        this._uidFieldName = uidFieldName;
        this._tokenToIdfCache = {};
        this._tokenMap = {};
    }
    /**
   * @inheritDocs
   */ var _proto = TfIdfSearchIndex.prototype;
    _proto.indexDocument = function indexDocument(token, uid, doc) {
        this._tokenToIdfCache = {}; // New index invalidates previous IDF caches
        var tokenMap = this._tokenMap;
        var tokenDatum;
        if (typeof tokenMap[token] !== 'object') tokenMap[token] = tokenDatum = {
            $numDocumentOccurrences: 0,
            $totalNumOccurrences: 1,
            $uidMap: {}
        };
        else {
            tokenDatum = tokenMap[token];
            tokenDatum.$totalNumOccurrences++;
        }
        var uidMap = tokenDatum.$uidMap;
        if (typeof uidMap[uid] !== 'object') {
            tokenDatum.$numDocumentOccurrences++;
            uidMap[uid] = {
                $document: doc,
                $numTokenOccurrences: 1
            };
        } else uidMap[uid].$numTokenOccurrences++;
    } /**
   * @inheritDocs
   */ ;
    _proto.search = function search(tokens, corpus) {
        var uidToDocumentMap = {};
        for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
            var token = tokens[i];
            var tokenMetadata = this._tokenMap[token]; // Short circuit if no matches were found for any given token.
            if (!tokenMetadata) return [];
            if (i === 0) {
                var keys = Object.keys(tokenMetadata.$uidMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    uidToDocumentMap[uid] = tokenMetadata.$uidMap[uid].$document;
                }
            } else {
                var keys = Object.keys(uidToDocumentMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    if (typeof tokenMetadata.$uidMap[uid] !== 'object') delete uidToDocumentMap[uid];
                }
            }
        }
        var documents = [];
        for(var uid in uidToDocumentMap)documents.push(uidToDocumentMap[uid]);
        var calculateTfIdf = this._createCalculateTfIdf(); // Return documents sorted by TF-IDF
        return documents.sort(function(documentA, documentB) {
            return calculateTfIdf(tokens, documentB, corpus) - calculateTfIdf(tokens, documentA, corpus);
        });
    };
    _proto._createCalculateIdf = function _createCalculateIdf() {
        var tokenMap = this._tokenMap;
        var tokenToIdfCache = this._tokenToIdfCache;
        return function calculateIdf(token, documents) {
            if (!tokenToIdfCache[token]) {
                var numDocumentsWithToken = typeof tokenMap[token] !== 'undefined' ? tokenMap[token].$numDocumentOccurrences : 0;
                tokenToIdfCache[token] = 1 + Math.log(documents.length / (1 + numDocumentsWithToken));
            }
            return tokenToIdfCache[token];
        };
    };
    _proto._createCalculateTfIdf = function _createCalculateTfIdf() {
        var tokenMap = this._tokenMap;
        var uidFieldName = this._uidFieldName;
        var calculateIdf = this._createCalculateIdf();
        return function calculateTfIdf(tokens, document, documents) {
            var score = 0;
            for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
                var token = tokens[i];
                var inverseDocumentFrequency = calculateIdf(token, documents);
                if (inverseDocumentFrequency === Infinity) inverseDocumentFrequency = 0;
                var uid;
                if (uidFieldName instanceof Array) uid = document && $ab5a50fa126dae14$var$getNestedFieldValue(document, uidFieldName);
                else uid = document && document[uidFieldName];
                var termFrequency = typeof tokenMap[token] !== 'undefined' && typeof tokenMap[token].$uidMap[uid] !== 'undefined' ? tokenMap[token].$uidMap[uid].$numTokenOccurrences : 0;
                score += termFrequency * inverseDocumentFrequency;
            }
            return score;
        };
    };
    return TfIdfSearchIndex;
}();
/**
 * Search index capable of returning results matching a set of tokens but without any meaningful rank or order.
 */ var $ab5a50fa126dae14$export$5e70dbef3f0d47db = /*#__PURE__*/ function() {
    function UnorderedSearchIndex() {
        this._tokenToUidToDocumentMap = {};
    }
    /**
   * @inheritDocs
   */ var _proto = UnorderedSearchIndex.prototype;
    _proto.indexDocument = function indexDocument(token, uid, doc) {
        if (typeof this._tokenToUidToDocumentMap[token] !== 'object') this._tokenToUidToDocumentMap[token] = {};
        this._tokenToUidToDocumentMap[token][uid] = doc;
    } /**
   * @inheritDocs
   */ ;
    _proto.search = function search(tokens, corpus) {
        var intersectingDocumentMap = {};
        var tokenToUidToDocumentMap = this._tokenToUidToDocumentMap;
        for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
            var token = tokens[i];
            var documentMap = tokenToUidToDocumentMap[token]; // Short circuit if no matches were found for any given token.
            if (!documentMap) return [];
            if (i === 0) {
                var keys = Object.keys(documentMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    intersectingDocumentMap[uid] = documentMap[uid];
                }
            } else {
                var keys = Object.keys(intersectingDocumentMap);
                for(var j = 0, numKeys = keys.length; j < numKeys; j++){
                    var uid = keys[j];
                    if (typeof documentMap[uid] !== 'object') delete intersectingDocumentMap[uid];
                }
            }
        }
        var keys = Object.keys(intersectingDocumentMap);
        var documents = [];
        for(var i = 0, numKeys = keys.length; i < numKeys; i++){
            var uid = keys[i];
            documents.push(intersectingDocumentMap[uid]);
        }
        return documents;
    };
    return UnorderedSearchIndex;
}();
var $ab5a50fa126dae14$var$REGEX = /[^a-zа-яё0-9\-']+/i;
/**
 * Simple tokenizer that splits strings on whitespace characters and returns an array of all non-empty substrings.
 */ var $ab5a50fa126dae14$export$f5ac5ec3cb556ad6 = /*#__PURE__*/ function() {
    function SimpleTokenizer() {}
    var _proto = SimpleTokenizer.prototype;
    /**
   * @inheritDocs
   */ _proto.tokenize = function tokenize(text) {
        return text.split($ab5a50fa126dae14$var$REGEX).filter(function(text) {
            return text;
        } // Filter empty tokens
        );
    };
    return SimpleTokenizer;
}();
/**
 * Stemming is the process of reducing search tokens to their root (or stem) so that searches for different forms of a
 * word will match. For example "search", "searching" and "searched" are all reduced to the stem "search".
 *
 * <p>This stemming tokenizer converts tokens (words) to their stem forms before returning them. It requires an
 * external stemming function to be provided; for this purpose I recommend the NPM 'porter-stemmer' library.
 *
 * <p>For more information see http : //tartarus.org/~martin/PorterStemmer/
 */ var $ab5a50fa126dae14$export$d2c689c98d4dcb27 = /*#__PURE__*/ function() {
    /**
   * Constructor.
   *
   * @param stemmingFunction Function capable of accepting a word and returning its stem.
   * @param decoratedIndexStrategy Index strategy to be run after all stop words have been removed.
   */ function StemmingTokenizer(stemmingFunction, decoratedTokenizer) {
        this._stemmingFunction = stemmingFunction;
        this._tokenizer = decoratedTokenizer;
    }
    /**
   * @inheritDocs
   */ var _proto = StemmingTokenizer.prototype;
    _proto.tokenize = function tokenize(text) {
        return this._tokenizer.tokenize(text).map(this._stemmingFunction);
    };
    return StemmingTokenizer;
}();
/**
 * Stop words list copied from Lunr JS.
 */ var $ab5a50fa126dae14$export$eeaf491a400e882a = {
    a: true,
    able: true,
    about: true,
    across: true,
    after: true,
    all: true,
    almost: true,
    also: true,
    am: true,
    among: true,
    an: true,
    and: true,
    any: true,
    are: true,
    as: true,
    at: true,
    be: true,
    because: true,
    been: true,
    but: true,
    by: true,
    can: true,
    cannot: true,
    could: true,
    dear: true,
    did: true,
    'do': true,
    does: true,
    either: true,
    'else': true,
    ever: true,
    every: true,
    'for': true,
    from: true,
    'get': true,
    got: true,
    had: true,
    has: true,
    have: true,
    he: true,
    her: true,
    hers: true,
    him: true,
    his: true,
    how: true,
    however: true,
    i: true,
    'if': true,
    'in': true,
    into: true,
    is: true,
    it: true,
    its: true,
    just: true,
    least: true,
    "let": true,
    like: true,
    likely: true,
    may: true,
    me: true,
    might: true,
    most: true,
    must: true,
    my: true,
    neither: true,
    no: true,
    nor: true,
    not: true,
    of: true,
    off: true,
    often: true,
    on: true,
    only: true,
    or: true,
    other: true,
    our: true,
    own: true,
    rather: true,
    said: true,
    say: true,
    says: true,
    she: true,
    should: true,
    since: true,
    so: true,
    some: true,
    than: true,
    that: true,
    the: true,
    their: true,
    them: true,
    then: true,
    there: true,
    these: true,
    they: true,
    'this': true,
    tis: true,
    to: true,
    too: true,
    twas: true,
    us: true,
    wants: true,
    was: true,
    we: true,
    were: true,
    what: true,
    when: true,
    where: true,
    which: true,
    'while': true,
    who: true,
    whom: true,
    why: true,
    will: true,
    'with': true,
    would: true,
    yet: true,
    you: true,
    your: true
}; // Prevent false positives for inherited properties
$ab5a50fa126dae14$export$eeaf491a400e882a.constructor = false;
$ab5a50fa126dae14$export$eeaf491a400e882a.hasOwnProperty = false;
$ab5a50fa126dae14$export$eeaf491a400e882a.isPrototypeOf = false;
$ab5a50fa126dae14$export$eeaf491a400e882a.propertyIsEnumerable = false;
$ab5a50fa126dae14$export$eeaf491a400e882a.toLocaleString = false;
$ab5a50fa126dae14$export$eeaf491a400e882a.toString = false;
$ab5a50fa126dae14$export$eeaf491a400e882a.valueOf = false;
/**
 * Stop words are very common (e.g. "a", "and", "the") and are often not semantically meaningful in the context of a
 * search. This tokenizer removes stop words from a set of tokens before passing the remaining tokens along for
 * indexing or searching purposes.
 */ var $ab5a50fa126dae14$export$59d4dfff8ed0ca89 = /*#__PURE__*/ function() {
    /**
   * Constructor.
   *
   * @param decoratedIndexStrategy Index strategy to be run after all stop words have been removed.
   */ function StopWordsTokenizer(decoratedTokenizer) {
        this._tokenizer = decoratedTokenizer;
    }
    /**
   * @inheritDocs
   */ var _proto = StopWordsTokenizer.prototype;
    _proto.tokenize = function tokenize(text) {
        return this._tokenizer.tokenize(text).filter(function(token) {
            return !$ab5a50fa126dae14$export$eeaf491a400e882a[token];
        });
    };
    return StopWordsTokenizer;
}();
function $ab5a50fa126dae14$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ab5a50fa126dae14$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ab5a50fa126dae14$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ab5a50fa126dae14$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/**
 * Simple client-side searching within a set of documents.
 *
 * <p>Documents can be searched by any number of fields. Indexing and search strategies are highly customizable.
 */ var $ab5a50fa126dae14$export$4b85d3515bd863a5 = /*#__PURE__*/ function() {
    /**
   * Array containing either a property name or a path (list of property names) to a nested value
   */ /**
   * Constructor.
   * @param uidFieldName Field containing values that uniquely identify search documents; this field's values are used
   *                     to ensure that a search result set does not contain duplicate objects.
   */ function Search(uidFieldName) {
        if (!uidFieldName) throw Error('js-search requires a uid field name constructor parameter');
        this._uidFieldName = uidFieldName; // Set default/recommended strategies
        this._indexStrategy = new $ab5a50fa126dae14$export$eb7fc80cfe9abfe6();
        this._searchIndex = new $ab5a50fa126dae14$export$a1138c79781169cc(uidFieldName);
        this._sanitizer = new $ab5a50fa126dae14$export$147e8ac43c84713a();
        this._tokenizer = new $ab5a50fa126dae14$export$f5ac5ec3cb556ad6();
        this._documents = [];
        this._searchableFields = [];
    }
    /**
   * Override the default index strategy.
   * @param value Custom index strategy
   * @throws Error if documents have already been indexed by this search instance
   */ var _proto = Search.prototype;
    /**
   * Add a searchable document to the index. Document will automatically be indexed for search.
   * @param document
   */ _proto.addDocument = function addDocument(document) {
        this.addDocuments([
            document
        ]);
    } /**
   * Adds searchable documents to the index. Documents will automatically be indexed for search.
   * @param document
   */ ;
    _proto.addDocuments = function addDocuments(documents) {
        this._documents = this._documents.concat(documents);
        this.indexDocuments_(documents, this._searchableFields);
    } /**
   * Add a new searchable field to the index. Existing documents will automatically be indexed using this new field.
   *
   * @param field Searchable field or field path. Pass a string to index a top-level field and an array of strings for nested fields.
   */ ;
    _proto.addIndex = function addIndex(field) {
        this._searchableFields.push(field);
        this.indexDocuments_(this._documents, [
            field
        ]);
    } /**
   * Search all documents for ones matching the specified query text.
   * @param query
   * @returns {Array<Object>}
   */ ;
    _proto.search = function search(query) {
        var tokens = this._tokenizer.tokenize(this._sanitizer.sanitize(query));
        return this._searchIndex.search(tokens, this._documents);
    } /**
   * @param documents
   * @param _searchableFields Array containing property names and paths (lists of property names) to nested values
   * @private
   */ ;
    _proto.indexDocuments_ = function indexDocuments_(documents, _searchableFields) {
        this._initialized = true;
        var indexStrategy = this._indexStrategy;
        var sanitizer = this._sanitizer;
        var searchIndex = this._searchIndex;
        var tokenizer = this._tokenizer;
        var uidFieldName = this._uidFieldName;
        for(var di = 0, numDocuments = documents.length; di < numDocuments; di++){
            var doc = documents[di];
            var uid;
            if (uidFieldName instanceof Array) uid = $ab5a50fa126dae14$var$getNestedFieldValue(doc, uidFieldName);
            else uid = doc[uidFieldName];
            for(var sfi = 0, numSearchableFields = _searchableFields.length; sfi < numSearchableFields; sfi++){
                var fieldValue;
                var searchableField = _searchableFields[sfi];
                if (searchableField instanceof Array) fieldValue = $ab5a50fa126dae14$var$getNestedFieldValue(doc, searchableField);
                else fieldValue = doc[searchableField];
                if (fieldValue != null && typeof fieldValue !== 'string' && fieldValue.toString) fieldValue = fieldValue.toString();
                if (typeof fieldValue === 'string') {
                    var fieldTokens = tokenizer.tokenize(sanitizer.sanitize(fieldValue));
                    for(var fti = 0, numFieldValues = fieldTokens.length; fti < numFieldValues; fti++){
                        var fieldToken = fieldTokens[fti];
                        var expandedTokens = indexStrategy.expandToken(fieldToken);
                        for(var eti = 0, nummExpandedTokens = expandedTokens.length; eti < nummExpandedTokens; eti++){
                            var expandedToken = expandedTokens[eti];
                            searchIndex.indexDocument(expandedToken, uid, doc);
                        }
                    }
                }
            }
        }
    };
    $ab5a50fa126dae14$var$_createClass(Search, [
        {
            key: "indexStrategy",
            set: function set(value) {
                if (this._initialized) throw Error('IIndexStrategy cannot be set after initialization');
                this._indexStrategy = value;
            },
            get: function get() {
                return this._indexStrategy;
            }
        },
        {
            key: "sanitizer",
            set: function set(value) {
                if (this._initialized) throw Error('ISanitizer cannot be set after initialization');
                this._sanitizer = value;
            },
            get: function get() {
                return this._sanitizer;
            }
        },
        {
            key: "searchIndex",
            set: function set(value) {
                if (this._initialized) throw Error('ISearchIndex cannot be set after initialization');
                this._searchIndex = value;
            },
            get: function get() {
                return this._searchIndex;
            }
        },
        {
            key: "tokenizer",
            set: function set(value) {
                if (this._initialized) throw Error('ITokenizer cannot be set after initialization');
                this._tokenizer = value;
            },
            get: function get() {
                return this._tokenizer;
            }
        }
    ]);
    return Search;
}();
/**
 * This utility highlights the occurrences of tokens within a string of text. It can be used to give visual indicators
 * of match criteria within searchable fields.
 *
 * <p>For performance purposes this highlighter only works with full-word or prefix token indexes.
 */ var $ab5a50fa126dae14$export$11e693a7f8ce1bcc = /*#__PURE__*/ function() {
    /**
   * Constructor.
   *
   * @param opt_indexStrategy Index strategy used by Search
   * @param opt_sanitizer Sanitizer used by Search
   * @param opt_wrapperTagName Optional wrapper tag name; defaults to 'mark' (e.g. <mark>)
   */ function TokenHighlighter(opt_indexStrategy, opt_sanitizer, opt_wrapperTagName) {
        this._indexStrategy = opt_indexStrategy || new $ab5a50fa126dae14$export$eb7fc80cfe9abfe6();
        this._sanitizer = opt_sanitizer || new $ab5a50fa126dae14$export$147e8ac43c84713a();
        this._wrapperTagName = opt_wrapperTagName || 'mark';
    }
    /**
   * Highlights token occurrences within a string by wrapping them with a DOM element.
   *
   * @param text e.g. "john wayne"
   * @param tokens e.g. ["wa"]
   * @returns {string} e.g. "john <mark>wa</mark>yne"
   */ var _proto = TokenHighlighter.prototype;
    _proto.highlight = function highlight(text, tokens) {
        var tagsLength = this._wrapText('').length;
        var tokenDictionary = Object.create(null); // Create a token map for easier lookup below.
        for(var i = 0, numTokens = tokens.length; i < numTokens; i++){
            var token = this._sanitizer.sanitize(tokens[i]);
            var expandedTokens = this._indexStrategy.expandToken(token);
            for(var j = 0, numExpandedTokens = expandedTokens.length; j < numExpandedTokens; j++){
                var expandedToken = expandedTokens[j];
                if (!tokenDictionary[expandedToken]) tokenDictionary[expandedToken] = [
                    token
                ];
                else tokenDictionary[expandedToken].push(token);
            }
        } // Track actualCurrentWord and sanitizedCurrentWord separately in case we encounter nested tags.
        var actualCurrentWord = '';
        var sanitizedCurrentWord = '';
        var currentWordStartIndex = 0; // Note this assumes either prefix or full word matching.
        for(var i = 0, textLength = text.length; i < textLength; i++){
            var character = text.charAt(i);
            if (character === ' ') {
                actualCurrentWord = '';
                sanitizedCurrentWord = '';
                currentWordStartIndex = i + 1;
            } else {
                actualCurrentWord += character;
                sanitizedCurrentWord += this._sanitizer.sanitize(character);
            }
            if (tokenDictionary[sanitizedCurrentWord] && tokenDictionary[sanitizedCurrentWord].indexOf(sanitizedCurrentWord) >= 0) {
                actualCurrentWord = this._wrapText(actualCurrentWord);
                text = text.substring(0, currentWordStartIndex) + actualCurrentWord + text.substring(i + 1);
                i += tagsLength;
                textLength += tagsLength;
            }
        }
        return text;
    } /**
   * @param text to wrap
   * @returns Text wrapped by wrapper tag (e.g. "foo" becomes "<mark>foo</mark>")
   * @private
   */ ;
    _proto._wrapText = function _wrapText(text) {
        var tagName = this._wrapperTagName;
        return "<" + tagName + ">" + text + "</" + tagName + ">";
    };
    return TokenHighlighter;
}();

});

parcelRegister("cQka3", function(module, exports) {

$parcel$export(module.exports, "tokenizerRegex", () => $5168aa125a95a93b$export$6558e5d0f0e834f8);
// \p{Han} => each chinese character is a separate token
// \p{L}+[\p{Mn}|']*\p{L} => consecutive letters, including non spacing mark and apostrophe are a single token
// const tokenizerRegex = new XRegExp("\\p{Han}|[\\p{L}|\\p{N}]+[\\p{Mn}|']*\\p{L}*", 'gi');
// Note: Regex compiled to unicode charsets using xregexp-transformer, refer to it if you need to compile it again.
//       @atlaskit/xregexp-transformer (https://bitbucket.org/atlassian/xregexp-transformer)
// eslint-disable-next-line no-misleading-character-class
const $5168aa125a95a93b$export$6558e5d0f0e834f8 = new RegExp("[\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u3005\u3007\u3021-\u3029\u3038-\u303B\u3400-\u4DB5\u4E00-\u9FEF\uF900-\uFA6D\uFA70-\uFAD9]|[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC|0-9\u00B2\u00B3\u00B9\u00BC-\u00BE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D58-\u0D5E\u0D66-\u0D78\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]+[\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ABD\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F|']*[A-Za-z\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEF\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7B9\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]*", 'gi');

});

parcelRegister("ekdQj", function(module, exports) {

$parcel$export(module.exports, "createSearchEmojiComparator", () => $e8b8369d64072d2b$export$e6097b005751df7);
$parcel$export(module.exports, "createUsageOnlyEmojiComparator", () => $e8b8369d64072d2b$export$1bd055808eeccb4e);

var $dfT6d = parcelRequire("dfT6d");

var $eG1kR = parcelRequire("eG1kR");
function $e8b8369d64072d2b$export$e6097b005751df7(query, orderedIds) {
    const textQuery = query ? query.replace(/:/g, '').toLowerCase().trim() : undefined;
    const comparators = [];
    if (query) comparators.push(new $e8b8369d64072d2b$export$ff92575cd1bbad0e(query));
    // Add the comparators to the 'chain'. The order of adding each comparator is important to the sort that is applied by the
    // ChainedEmojiComparator. (Which is why you may see the same 'if' a few times.)
    if (textQuery) comparators.push(new $e8b8369d64072d2b$export$3026b08b79541139(textQuery));
    if (orderedIds && orderedIds.length) comparators.push(new $e8b8369d64072d2b$export$55e24837a4bf653(orderedIds));
    if (textQuery) comparators.push(new $e8b8369d64072d2b$export$587c775915dc4869(textQuery, 'shortName'), new $e8b8369d64072d2b$export$587c775915dc4869(textQuery, 'name'));
    comparators.push($e8b8369d64072d2b$export$165e96ceead77edd.Instance, $e8b8369d64072d2b$export$30ce221e1adf48c1.Instance);
    const comparator = new $e8b8369d64072d2b$export$a8052d0852821684(...comparators);
    comparator.compare = comparator.compare.bind(comparator);
    return comparator;
}
function $e8b8369d64072d2b$export$1bd055808eeccb4e(orderedIds) {
    const comparator = new $e8b8369d64072d2b$export$a8052d0852821684(new $e8b8369d64072d2b$export$55e24837a4bf653(orderedIds), new $e8b8369d64072d2b$export$a7f7a0b04013a8a8(), $e8b8369d64072d2b$export$165e96ceead77edd.Instance);
    comparator.compare = comparator.compare.bind(comparator);
    return comparator;
}
class $e8b8369d64072d2b$export$a8052d0852821684 {
    constructor(...comparators){
        this.chain = comparators;
    }
    compare(e1, e2) {
        for(let i = 0; i < this.chain.length; i++){
            const result = this.chain[i].compare(e1, e2);
            if (result !== 0) return result;
        }
        return 0;
    }
}
class $e8b8369d64072d2b$export$ff92575cd1bbad0e {
    constructor(query){
        this.query = query;
    }
    compare(e1, e2) {
        const e1HasAscii = e1.ascii && e1.ascii.indexOf(this.query) !== -1;
        const e2HasAscii = e2.ascii && e2.ascii.indexOf(this.query) !== -1;
        if (e1HasAscii && !e2HasAscii) return -1;
        else if (!e1HasAscii && e2HasAscii) return 1;
        return 0;
    }
}
class $e8b8369d64072d2b$export$3026b08b79541139 {
    constructor(query){
        this.colonQuery = `:${query}:`;
        this.typeComparator = new $e8b8369d64072d2b$export$a7f7a0b04013a8a8(true);
    }
    compare(e1, e2) {
        if (e1.shortName === this.colonQuery && e2.shortName === this.colonQuery) return this.typeComparator.compare(e1, e2);
        else if (e1.shortName === this.colonQuery) return -1;
        else if (e2.shortName === this.colonQuery) return 1;
        return 0;
    }
}
class $e8b8369d64072d2b$export$a7f7a0b04013a8a8 {
    constructor(reverse){
        if (reverse) this.typeToNumber = new Map([
            [
                'SITE',
                0
            ],
            [
                'ATLASSIAN',
                1
            ],
            [
                'STANDARD',
                2
            ]
        ]);
        else this.typeToNumber = new Map([
            [
                'STANDARD',
                0
            ],
            [
                'ATLASSIAN',
                1
            ],
            [
                'SITE',
                2
            ]
        ]);
    }
    compare(e1, e2) {
        return this.emojiTypeToOrdinal(e1) - this.emojiTypeToOrdinal(e2);
    }
    emojiTypeToOrdinal(emoji) {
        let ordinal = this.typeToNumber.get(emoji.type);
        if (ordinal === undefined) ordinal = 10;
        return ordinal;
    }
}
class $e8b8369d64072d2b$export$55e24837a4bf653 {
    constructor(orderedIds){
        this.positionLookup = new Map();
        // Make ordering start from 1 to avoid having zero in the map (which is falsey)
        orderedIds.map((id, index)=>this.positionLookup.set(id, index + 1));
    }
    compare(e1, e2) {
        if (!e1.id || !e2.id) return 0; // this shouldn't occur. Leave position unchanged if there is any missing id.
        let i1 = this.getPositionInOrder(e1);
        let i2 = this.getPositionInOrder(e2);
        return i1 - i2;
    }
    /**
	 * Get the ordinal representing the position of this emoji.
	 *
	 * @param id the id of the emoji
	 */ getPositionInOrder(emoji) {
        let id = emoji.id ? emoji.id : '0';
        if ((0, $eG1kR.isEmojiVariationDescription)(emoji)) id = emoji.baseId;
        const position = this.positionLookup.get(id);
        if (position) return position;
        else return 0, $dfT6d.MAX_ORDINAL;
    }
}
class $e8b8369d64072d2b$export$587c775915dc4869 {
    /**
	 * @param query the query to match
	 * @param propertyToCompare the property of EmojiDescription to check for query within
	 */ constructor(query, propertyToCompare){
        this.query = query;
        if (!propertyToCompare) throw new Error('propertyToCompare is required');
        this.propertyName = propertyToCompare;
    }
    getScore(emoji) {
        // It is fine to do override the null check here because we are checking
        // it on the constructor.
        const propertyValue = emoji[this.propertyName];
        const score = propertyValue ? propertyValue.indexOf(this.query) : (0, $dfT6d.MAX_ORDINAL);
        return score === -1 ? (0, $dfT6d.MAX_ORDINAL) : score;
    }
    compare(e1, e2) {
        return this.getScore(e1) - this.getScore(e2);
    }
}
class $e8b8369d64072d2b$export$165e96ceead77edd {
    constructor(){}
    static get Instance() {
        return this.INSTANCE || (this.INSTANCE = new this());
    }
    compare(e1, e2) {
        let o1 = e1.order ? e1.order : (0, $dfT6d.MAX_ORDINAL);
        let o2 = e2.order ? e2.order : (0, $dfT6d.MAX_ORDINAL);
        return o1 - o2;
    }
}
class $e8b8369d64072d2b$export$30ce221e1adf48c1 {
    constructor(){}
    static get Instance() {
        return this.INSTANCE || (this.INSTANCE = new this());
    }
    compare(e1, e2) {
        return e1.shortName.localeCompare(e2.shortName);
    }
}

});

parcelRegister("5H2wb", function(module, exports) {

$parcel$export(module.exports, "UsageFrequencyTracker", () => $1607f522dcac97f3$export$3f86810331c44209);

var $eG1kR = parcelRequire("eG1kR");

var $dfT6d = parcelRequire("dfT6d");

var $7o5Bb = parcelRequire("7o5Bb");

var $71xPE = parcelRequire("71xPE");

var $cfJOp = parcelRequire("cfJOp");
class $1607f522dcac97f3$export$3f86810331c44209 {
    static{
        this.queueOptions = {
            storage: (0, $cfJOp.default)('localStorage') ? window.localStorage : undefined,
            storagePrefix: (0, $dfT6d.localStoragePrefix),
            maxDuplicates: 25,
            minUniqueItems: 5
        };
    }
    constructor(useStorageIfPossible = true){
        const options = $1607f522dcac97f3$export$3f86810331c44209.queueOptions;
        if (useStorageIfPossible && options.storage) {
            const queueOptions = {
                ...options,
                storage: options.storage
            };
            this.queue = new (0, $71xPE.default)(queueOptions);
        } else this.queue = new (0, $7o5Bb.default)(options);
        this.gateway = new $1607f522dcac97f3$export$a0e1fa6601cae894(10);
    }
    /**
	 * Record the fact that the supplied emoji was used. You should note that usage is updated asynchronously so you can not
	 * count on getOrder() reflecting this usage immediately.
	 *
	 * @param emoji the emoji who's usage is to be recorded. If the emoji has no id then no usage will be recorded
	 */ recordUsage(emoji) {
        let emojiId = emoji.id;
        if (emojiId) {
            if ((0, $eG1kR.isEmojiVariationDescription)(emoji)) emojiId = emoji.baseId;
            this.gateway.submit(()=>{
                if (emojiId) this.queue.enqueue(emojiId);
            });
        }
    }
    /**
	 * Returns an array of emoji id (without skin tone variations) sorted by most used to least used. If there
	 * are no usages then an empty array will be returned.
	 */ getOrder() {
        return this.queue.getItemsOrderedByDuplicateCount();
    }
    /**
	 * Exposed for testing only. Clear any recorded usage.
	 */ clear() {
        this.queue.clear();
    }
}
class $1607f522dcac97f3$export$a0e1fa6601cae894 {
    constructor(maximumPermitted){
        if (maximumPermitted < 1) throw new RangeError('The maximumPermitted parameter must be 1 or more.');
        this.maximumPermitted = maximumPermitted;
        this.count = 0;
    }
    /**
	 * Run the supplied function if the count of already submitted work allows it. Drop the work
	 * if it's not allowed to run.
	 *
	 * Will return true if the function has been submitted or false if it was not submitted.
	 */ submit(f) {
        if (this.count >= this.maximumPermitted) return false;
        this.count++;
        const wrappedFunc = ()=>{
            try {
                f();
            } finally{
                this.completed();
            }
        };
        if (typeof window !== 'undefined') window.setTimeout(wrappedFunc);
        return true;
    }
    completed() {
        this.count--;
    }
}

});
parcelRegister("7o5Bb", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a1f34ab83bfb90c$export$2e2bcd8739ae039);
/**
 * The options used to configure a newly constructed queue.
 */ class $5a1f34ab83bfb90c$export$2e2bcd8739ae039 {
    /**
	 * Construct a new DuplicateLimitedQueue.
	 *
	 * @param options the options for this queue.
	 */ constructor(options){
        if (options.maxDuplicates < 1) throw new RangeError('The maxDuplicates option must be at least 1');
        if (options.minUniqueItems < 1) throw new RangeError('The minUniqueItems option must be at least 1');
        this.maximumSize = options.maxDuplicates * options.minUniqueItems;
        this.perItemSize = options.maxDuplicates;
        this.createEmptyState();
    }
    /**
	 * @param item the item to add to the queue.
	 */ enqueue(item) {
        this.enqueueWithoutOrdering(item);
        // enqueues are less time sensitive (and may happen less frequently) than queries against the queue
        // so do the ordering work on each enqueue.
        this.itemsOrderedByFrequency = this.orderItemsByFrequency();
    }
    /**
	 * Return the items in the queue, ordered by how often they are duplicated. The items with the
	 * most duplicates come first in the returned Array.
	 *
	 * If there are no items in the queue then an empty Array will be returned.
	 */ getItemsOrderedByDuplicateCount() {
        return this.itemsOrderedByFrequency;
    }
    /**
	 * Exposed for storybook/testing purposes only. Clear the contents of the queue.
	 */ clear() {
        this.createEmptyState();
    }
    /**
	 * A more efficient mechanism for adding multiple items. Ordering is only performed once all
	 * the items have been added.
	 *
	 * @param items the items to be enqueued, which happens in their presented order.
	 */ bulkEnqueue(items) {
        items.map((item)=>this.enqueueWithoutOrdering(item));
        this.itemsOrderedByFrequency = this.orderItemsByFrequency();
    }
    /**
	 * Return the items currently stored in the queue.
	 */ getItems() {
        return this.items;
    }
    createEmptyState() {
        this.items = new Array();
        this.itemCountMap = new Map();
        this.itemsOrderedByFrequency = new Array();
    }
    /**
	 * Enqueue the supplied item, keeping consistency with the limits configured. However no ordering is
	 * performed by this enqueuing. You must trigger that manually if required.
	 *
	 * @param item the item to be queued
	 */ enqueueWithoutOrdering(item) {
        const count = this.itemCountMap.get(item);
        if (count && count >= this.perItemSize) // find the first item with that key in the array and remove it
        this.removeFirstOccurrence(item);
        else if (this.items.length >= this.maximumSize) this.remove();
        this.add(item);
    }
    /**
	 * Get an array of items from the queue ordered by how often they are duplicated in the queue.
	 */ orderItemsByFrequency() {
        const orderedEntries = Array.from(this.itemCountMap.entries()).sort((a, b)=>{
            return b[1] - a[1];
        });
        return orderedEntries.map((value)=>value[0]);
    }
    decrementCount(item) {
        let count = this.itemCountMap.get(item);
        if (count) {
            count--;
            if (count > 0) this.itemCountMap.set(item, count);
            else this.itemCountMap.delete(item);
        }
    }
    /**
	 * Walk the list of items and remove the first occurrence of the matching item.
	 *
	 * @param item the item to be removed.
	 */ removeFirstOccurrence(item) {
        const index = this.items.indexOf(item);
        if (index !== -1) {
            this.items.splice(index, 1);
            this.decrementCount(item);
        }
    }
    /**
	 * Remove the first item from the queue and update the itemCountMap accordingly.
	 * @return the item add the front of the queue or undefined if the queue is empty
	 */ remove() {
        const removed = this.items.shift();
        if (removed !== undefined) this.decrementCount(removed);
        return removed;
    }
    /**
	 * Add the supplied item to the end of the queue and update the itemCountMap accordingly.
	 * @param item the item to be added to the queue
	 */ add(item) {
        this.items.push(item);
        const count = this.itemCountMap.get(item);
        if (count) this.itemCountMap.set(item, count + 1);
        else this.itemCountMap.set(item, 1);
    }
}

});

parcelRegister("71xPE", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9da82fd0c83dad4$export$2e2bcd8739ae039);

var $7o5Bb = parcelRequire("7o5Bb");

var $1JT4v = parcelRequire("1JT4v");
class $c9da82fd0c83dad4$export$2e2bcd8739ae039 extends (0, $7o5Bb.default) {
    static{
        this.storageKey = 'lastUsed';
    }
    constructor(options){
        super(options);
        this.storage = options.storage;
        this.prefixedStorageKey = `${options.storagePrefix}.${$c9da82fd0c83dad4$export$2e2bcd8739ae039.storageKey}`;
        this.load();
    }
    /**
	 * Enqueue the supplied item and also persist the new contents of the queue to storage.
	 *
	 * @param item the item to be enqueued
	 */ enqueue(item) {
        super.enqueue(item);
        this.save();
    }
    /**
	 * Exposed for storybook/testing purposes only. Clear the contents of the queue, and localStorage.
	 */ clear() {
        super.clear();
        this.storage.removeItem(this.prefixedStorageKey);
    }
    /**
	 * Initialise the queue contents from the configured Storage. If there is no data found in
	 * storage then the queue will have no items added. Likewise, a failure to read or parse stored
	 * data will be swallowed and no items are added to the queue.
	 */ load() {
        const itemsJson = this.storage.getItem(this.prefixedStorageKey);
        if (itemsJson) try {
            const items = JSON.parse(itemsJson);
            this.bulkEnqueue(items);
        } catch (e) {
            (0, $1JT4v.default)(`Error parsing the queue stored as ${this.prefixedStorageKey} key from storage`, e);
        }
    }
    /**
	 * Save the current items in the queue, overwriting any previously stored queue.
	 * Any failure in saving will be silently ignored with the likely outcome that any previous
	 * saved items will remain unchanged in storage.
	 */ save() {
        const itemsJson = JSON.stringify(this.getItems());
        try {
            this.storage.setItem(this.prefixedStorageKey, itemsJson);
        } catch (e) {
            (0, $1JT4v.default)(`Error saving the queued items as ${this.prefixedStorageKey}`, e);
        }
    }
}

});



parcelRegister("7yGtX", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cca0547e59e1546$export$2e2bcd8739ae039);

var $16UJG = parcelRequire("16UJG");

var $kJ7yF = parcelRequire("kJ7yF");

var $eG1kR = parcelRequire("eG1kR");

var $dikGc = parcelRequire("dikGc");

var $1IjlQ = parcelRequire("1IjlQ");

var $7cjLC = parcelRequire("7cjLC");

var $1JT4v = parcelRequire("1JT4v");
const $3cca0547e59e1546$export$6f3a08dea02a7b2b = 0.95;
class $3cca0547e59e1546$export$2e2bcd8739ae039 {
    constructor(siteServiceConfig, mediaApiToken){
        this.postToEmojiService = (upload, fileId)=>{
            const { shortName: shortName, name: name } = upload;
            const { width: width, height: height } = upload;
            const requestInit = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    shortName: shortName,
                    name: name,
                    width: width,
                    height: height,
                    fileId: fileId
                })
            };
            return (0, $16UJG.utils).requestService(this.siteServiceConfig, {
                requestInit: requestInit
            }).then((response)=>{
                const { emojis: emojis } = response;
                if (emojis.length) {
                    const { altRepresentations: altRepresentations, ...emoji } = emojis[0];
                    const response = {
                        ...emoji,
                        representation: (0, $eG1kR.convertImageToMediaRepresentation)(emoji.representation)
                    };
                    const altRepresentation = (0, $1IjlQ.getAltRepresentation)(altRepresentations || {});
                    const imgAltRepresentation = altRepresentation ? (0, $eG1kR.convertImageToMediaRepresentation)(altRepresentation) : undefined;
                    return (0, $eG1kR.buildEmojiDescriptionWithAltRepresentation)(response, imgAltRepresentation);
                }
                throw new Error('No emoji returns from upload. Upload failed.');
            });
        };
        this.siteServiceConfig = siteServiceConfig;
        this.mediaApiToken = mediaApiToken;
        this.tokenManager = new (0, $7cjLC.default)(siteServiceConfig);
        this.tokenManager.addToken('read', mediaApiToken);
        this.mediaEmojiCache = new (0, $dikGc.default)(this.tokenManager);
    }
    /**
	 * Will generate an emoji media path that is inclusive of client and token within the query parameter for media representation and altRepresentation
	 */ async generateTokenisedMediaURLS(representation, altRepresentation) {
        if (!(0, $eG1kR.isMediaRepresentation)(representation)) return {
            representation: representation,
            altRepresentation: altRepresentation
        };
        try {
            const readToken = await this.tokenManager.getToken('read');
            return Object.entries({
                representation: representation,
                altRepresentation: altRepresentation
            }).reduce((acc, [key, value])=>{
                if (value && (0, $eG1kR.isMediaRepresentation)(value)) {
                    const path = new URL(value.mediaPath);
                    const params = path.searchParams;
                    if (params.get('token') !== readToken.jwt) params.set('token', readToken.jwt);
                    if (params.get('client') !== readToken.clientId) params.set('client', readToken.clientId);
                    acc[key] = {
                        ...value,
                        mediaPath: path.toString()
                    };
                }
                return acc;
            }, {
                representation: representation,
                altRepresentation: altRepresentation
            });
        } catch (error) {
            return {
                representation: representation,
                altRepresentation: altRepresentation
            };
        }
    }
    /**
	 * Will load media emoji, returning a new EmojiDescription if, for example,
	 * the URL has changed.
	 */ loadMediaEmoji(emoji, useAlt) {
        if (!(0, $eG1kR.isMediaEmoji)(emoji)) throw new Error('Only supported for media emoji');
        return this.mediaEmojiCache.loadEmoji(emoji, useAlt);
    }
    optimisticRendering(emoji, useAlt) {
        const representation = useAlt ? emoji.altRepresentation : emoji.representation;
        if (!(0, $eG1kR.isMediaRepresentation)(representation)) throw new Error('Only supported for media emoji');
        const { mediaPath: mediaPath } = representation;
        return this.mediaEmojiCache.optimisticRendering(mediaPath);
    }
    uploadEmoji(upload, retry = false, progressCallback) {
        const startTime = Date.now();
        return this.tokenManager.getToken('upload', retry).then((uploadToken)=>{
            const tokenLoadTime = Date.now() - startTime;
            (0, $1JT4v.default)('upload token load time', tokenLoadTime);
            return new Promise((resolve, reject)=>{
                const { url: url, clientId: clientId, collectionName: collectionName } = uploadToken;
                const mediaClient = (0, $kJ7yF.getMediaClient)({
                    authProvider: ()=>Promise.resolve({
                            clientId: clientId,
                            token: uploadToken.jwt,
                            baseUrl: url
                        }),
                    useSha256ForUploads: true
                });
                const subscription = mediaClient.file.upload({
                    content: upload.dataURL,
                    name: upload.filename,
                    collection: collectionName
                }).subscribe({
                    next: (state)=>{
                        if (state.status === 'uploading' && progressCallback) progressCallback({
                            percent: state.progress * $3cca0547e59e1546$export$6f3a08dea02a7b2b
                        });
                        else if (state.status === 'processing') {
                            subscription.unsubscribe();
                            const totalUploadTime = Date.now() - startTime;
                            const mediaUploadTime = totalUploadTime - tokenLoadTime;
                            (0, $1JT4v.default)('total upload / media upload times', totalUploadTime, mediaUploadTime);
                            this.postToEmojiService(upload, state.id).then((emoji)=>{
                                resolve(emoji);
                            }).catch((httpError)=>{
                                reject(httpError.reason || httpError);
                            });
                        }
                    },
                    error (error) {
                        reject(error);
                    }
                });
            });
        });
    }
    /**
	 * Check if the MediaEmojiResource has been able to initialise an uploadToken. Retrieving an upload token
	 * is asynchronous so the Promise will need to resolve before the state is known. If the token retrieval
	 * completes with failure then the Promise will resolve to false.
	 */ hasUploadToken() {
        const tokenPromise = this.tokenManager.getToken('upload');
        return tokenPromise.then((token)=>{
            return token !== undefined;
        }, ()=>{
            return false;
        });
    }
    prepareForUpload() {
        // make sure a token is loaded from the emoji service if we don't have one
        // as future request to uploadEmoji will use this, this to preload it, as it
        // usually takes 1-2 seconds to generate
        this.tokenManager.getToken('upload');
    }
    findEmoji(emojiId) {
        if (!emojiId.id) return Promise.reject(false);
        const path = `../${encodeURIComponent(emojiId.id)}`;
        return (0, $1IjlQ.emojiRequest)(this.siteServiceConfig, {
            path: path
        }).then((serviceResponse)=>{
            const response = (0, $1IjlQ.denormaliseEmojiServiceResponse)(serviceResponse);
            return response.emojis[0];
        }).catch((error)=>{
            (0, $1JT4v.default)('failed to load emoji', emojiId, error);
            return undefined;
        });
    }
    /**
	 * Calls to site-scoped EmojiResource to delete emoji
	 * @param emoji media emoji to delete
	 * @returns Promise.resolve() if success and Promise.reject() for failure
	 */ deleteEmoji(emoji) {
        if (!(0, $eG1kR.isMediaEmoji)(emoji) && !(0, $eG1kR.isLoadedMediaEmoji)(emoji)) return Promise.reject(false);
        if (!emoji.id) return Promise.reject(false);
        const path = `${encodeURIComponent(emoji.id)}`;
        const requestInit = {
            method: 'DELETE'
        };
        return (0, $16UJG.utils).requestService(this.siteServiceConfig, {
            path: path,
            requestInit: requestInit
        })// Successful delete on Promise.resolve
        .then(()=>true)// Unsuccessful delete on Promise.reject
        .catch(()=>false);
    }
}

});
parcelRegister("dikGc", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c5314148d9d4e1b$export$2e2bcd8739ae039);

var $eG1kR = parcelRequire("eG1kR");

var $imaW6 = parcelRequire("imaW6");

var $1JT4v = parcelRequire("1JT4v");

var $6roQF = parcelRequire("6roQF");
const $6c5314148d9d4e1b$var$getRequiredRepresentation = (emoji, useAlt)=>useAlt ? emoji.altRepresentation : emoji.representation;
const $6c5314148d9d4e1b$var$isUnsupportedBrowser = ()=>{
    const isIE = !!document.documentMode; // Internet Explorer 6-11
    const isEdge = !isIE && !!window.StyleMedia; // Edge 20+
    return isIE || isEdge;
};
class $6c5314148d9d4e1b$export$3850f566ce8d817a {
    constructor(mediaImageLoader){
        this.cachedImageUrls = new Set();
        (0, $1JT4v.default)('BrowserCacheStrategy');
        this.mediaImageLoader = mediaImageLoader;
    }
    loadEmoji(emoji, useAlt) {
        const representation = $6c5314148d9d4e1b$var$getRequiredRepresentation(emoji, useAlt);
        if (!(0, $eG1kR.isMediaRepresentation)(representation)) return emoji;
        const { mediaPath: mediaPath } = representation;
        if (this.cachedImageUrls.has(mediaPath)) // Already cached
        return emoji;
        return this.mediaImageLoader.loadMediaImage(mediaPath).then(()=>{
            // Media is loaded, can use original URL now, so just return original emoji
            this.cachedImageUrls.add(mediaPath);
            return emoji;
        }).catch(()=>{
            return undefined;
        });
    }
    optimisticRendering() {
        return true;
    }
    static supported(mediaPath, mediaImageLoader) {
        // IE/Edge uses memory cache strategy else images can fail to load
        // from a clean cache/if they are downloaded from the service
        // TODO: fix as a part of FS-1592
        if ($6c5314148d9d4e1b$var$isUnsupportedBrowser()) return Promise.resolve(false);
        return mediaImageLoader.loadMediaImage(mediaPath).then(()=>// Image should be cached in browser, if supported it should be accessible from the cache by an <img/>
            // Try to load without via image to confirm this support (this fails in Firefox)
            new Promise((resolve)=>{
                const img = new Image();
                img.addEventListener('load', ()=>{
                    resolve(true);
                });
                img.addEventListener('error', ()=>{
                    resolve(false);
                });
                img.src = mediaPath;
            })).catch(()=>false);
    }
}
const $6c5314148d9d4e1b$var$maxImageCached = 1000;
// Don't cache images large than this - dataUrl size in characters
const $6c5314148d9d4e1b$var$maxImageSize = 10000;
class $6c5314148d9d4e1b$export$b522858a3709f4c {
    constructor(mediaImageLoader){
        (0, $1JT4v.default)('MemoryCacheStrategy');
        this.mediaImageLoader = mediaImageLoader;
        this.dataURLCache = new (0, $6roQF.LRUMap)($6c5314148d9d4e1b$var$maxImageCached);
    }
    loadEmoji(emoji, useAlt) {
        const representation = $6c5314148d9d4e1b$var$getRequiredRepresentation(emoji, useAlt);
        if (!(0, $eG1kR.isMediaRepresentation)(representation)) return emoji;
        const { mediaPath: mediaPath } = representation;
        const dataURL = this.dataURLCache.get(mediaPath);
        if (dataURL) // Already cached
        return (0, $eG1kR.convertMediaToImageEmoji)(emoji, dataURL, useAlt);
        // Not cached, load
        return this.mediaImageLoader.loadMediaImage(mediaPath).then((dataURL)=>{
            const loadedEmoji = (0, $eG1kR.convertMediaToImageEmoji)(emoji, dataURL, useAlt);
            if (dataURL.length <= $6c5314148d9d4e1b$var$maxImageSize) // Only cache if not large than max size
            this.dataURLCache.set(mediaPath, dataURL);
            else (0, $1JT4v.default)('No caching as image is too large', dataURL.length, dataURL.slice(0, 15), emoji.shortName);
            return loadedEmoji;
        }).catch(()=>{
            return undefined;
        });
    }
    optimisticRendering() {
        return false;
    }
}
class $6c5314148d9d4e1b$export$2e2bcd8739ae039 {
    constructor(tokenManager){
        this.waitingInitUrls = [];
        (0, $1JT4v.default)('MediaEmojiCache');
        this.mediaImageLoader = new (0, $imaW6.default)(tokenManager);
    }
    loadEmoji(emoji, useAlt) {
        const representation = $6c5314148d9d4e1b$var$getRequiredRepresentation(emoji, useAlt);
        if (!(0, $eG1kR.isMediaRepresentation)(representation)) return emoji;
        const { mediaPath: mediaPath } = representation;
        const emojiCache = this.getCache(mediaPath);
        if ((0, $eG1kR.isPromise)(emojiCache)) // Promise based
        return emojiCache.then((cache)=>cache.loadEmoji(emoji, useAlt)).catch(()=>undefined);
        return emojiCache.loadEmoji(emoji, useAlt);
    }
    optimisticRendering(url) {
        const emojiCache = this.getCache(url);
        if ((0, $eG1kR.isPromise)(emojiCache)) // Promise based
        return emojiCache.then((cache)=>cache.optimisticRendering()).catch(()=>false);
        return emojiCache.optimisticRendering();
    }
    getCache(url) {
        if (this.cache) return this.cache;
        this.waitingInitUrls.push(url);
        if (!this.cacheLoading) this.cacheLoading = this.initCache().then((cache)=>{
            this.cache = cache;
            this.cacheLoading = undefined;
            return cache;
        }).catch((err)=>{
            this.cacheLoading = undefined;
            throw err;
        });
        return this.cacheLoading;
    }
    initCache() {
        const url = this.waitingInitUrls.pop();
        if (!url) return Promise.reject('Unable to initialise cache based on provided url(s)');
        return $6c5314148d9d4e1b$export$3850f566ce8d817a.supported(url, this.mediaImageLoader).then((supported)=>{
            this.waitingInitUrls = []; // clear
            this.cacheLoading = undefined;
            if (supported) return new $6c5314148d9d4e1b$export$3850f566ce8d817a(this.mediaImageLoader);
            return new $6c5314148d9d4e1b$export$b522858a3709f4c(this.mediaImageLoader);
        }).catch(()=>{
            return this.initCache();
        });
    }
}

});
parcelRegister("imaW6", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c341ca59957c85d$export$2e2bcd8739ae039);

var $eMZQf = parcelRequire("eMZQf");
const $4c341ca59957c85d$var$defaultConcurrentDownloadLimit = 16;
const $4c341ca59957c85d$var$backoffMaxDelayInMillis = 600;
const $4c341ca59957c85d$var$defaultMaxRetriesOnNotFound = 2;
class $4c341ca59957c85d$export$2e2bcd8739ae039 {
    constructor(tokenManager, options){
        this.mediaImageQueue = [];
        this.activeProcessing = 0;
        this.pendingRequests = new Map();
        this.concurrentDownloadLimit = options && options.concurrentDownloadLimit || $4c341ca59957c85d$var$defaultConcurrentDownloadLimit;
        this.tokenManager = tokenManager;
    }
    loadMediaImage(url) {
        const maybePending = this.pendingRequests.get(url);
        if (maybePending !== undefined) return maybePending;
        const pending = new Promise((resolve, reject)=>{
            this.mediaImageQueue.push({
                url: url,
                resolve: resolve,
                reject: reject
            });
            this.processFromQueue();
        }).then((result)=>{
            this.pendingRequests.delete(url);
            return result;
        }).catch((error)=>{
            this.pendingRequests.delete(url);
            throw error;
        });
        this.pendingRequests.set(url, pending);
        return pending;
    }
    getQueueSize() {
        return this.mediaImageQueue.length;
    }
    getActiveDownloads() {
        return this.activeProcessing;
    }
    processFromQueue() {
        while(this.activeProcessing < this.concurrentDownloadLimit && this.mediaImageQueue.length > 0){
            this.activeProcessing++;
            const item = this.mediaImageQueue.shift();
            const { url: url, resolve: resolve, reject: reject } = item;
            this.tokenManager.getToken('read', false).then((token)=>{
                this.requestMediaEmoji(url, token, true).then((dataURL)=>{
                    resolve(dataURL);
                    this.completedItem();
                }).catch((error)=>{
                    reject(error);
                    this.completedItem();
                });
            }).catch((error)=>{
                // Failed to load, just resolve to original emoji
                reject(error);
                this.completedItem();
            });
        }
    }
    completedItem() {
        this.activeProcessing--;
        this.processFromQueue();
    }
    delay(durationInMillis) {
        return new Promise((resolve)=>setTimeout(resolve, durationInMillis));
    }
    requestMediaEmoji(url, token, retryOnAuthError, retriesOnNotFound = $4c341ca59957c85d$var$defaultMaxRetriesOnNotFound) {
        return (0, $eMZQf.imageAcceptHeader)().then((acceptHeader)=>{
            // Media REST API: https://media-api-internal.atlassian.io/api.html#file__fileId__image_get
            const options = {
                headers: {
                    Authorization: `Bearer ${token.jwt}`,
                    'X-Client-Id': token.clientId,
                    Accept: acceptHeader
                }
            };
            return fetch(url, options).then((response)=>{
                // retry if 404
                if (response.status === 404 && retriesOnNotFound > 0) return this.delay($4c341ca59957c85d$var$backoffMaxDelayInMillis / retriesOnNotFound) // backoff strategy
                .then(()=>this.requestMediaEmoji(url, token, false, retriesOnNotFound - 1));
                else if (response.status === 403 && retryOnAuthError) // retry once if 403
                return this.tokenManager.getToken('read', true).then((newToken)=>this.requestMediaEmoji(url, newToken, false));
                else if (response.ok) return response.blob().then((blob)=>this.readBlob(blob));
                throw new Error(`Unable to load media image. Status=${response.status} ${response.statusText}`);
            });
        });
    }
    readBlob(blob) {
        return new Promise((resolve, reject)=>{
            const reader = new FileReader();
            // TODO: [ts30] Add proper handling for null and ArrayBuffer
            reader.addEventListener('load', ()=>resolve(reader.result));
            reader.addEventListener('error', ()=>reject(reader.error));
            reader.readAsDataURL(blob);
        });
    }
}

});
parcelRegister("eMZQf", function(module, exports) {

$parcel$export(module.exports, "getNaturalImageSize", () => $64886c8d2111f7ef$export$90153ab95f408dfa);
$parcel$export(module.exports, "parseImage", () => $64886c8d2111f7ef$export$37bbb051492a18a7);
$parcel$export(module.exports, "hasFileExceededSize", () => $64886c8d2111f7ef$export$a115ddd5941792f1);
$parcel$export(module.exports, "imageAcceptHeader", () => $64886c8d2111f7ef$export$f8e7886bc155c2e6);
const $64886c8d2111f7ef$var$maxEmojiSizeInBytes = 1048576;
const $64886c8d2111f7ef$export$90153ab95f408dfa = (dataURL)=>{
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.addEventListener('load', ()=>{
            resolve({
                width: img.naturalWidth,
                height: img.naturalHeight
            });
        });
        img.addEventListener('error', reject);
        img.src = dataURL;
    });
};
const $64886c8d2111f7ef$export$37bbb051492a18a7 = (dataURL)=>{
    return new Promise((resolve, reject)=>{
        let img = new Image();
        img.onload = ()=>resolve({
                src: img.src
            });
        img.onerror = ()=>reject();
        img.src = dataURL;
    });
};
const $64886c8d2111f7ef$export$a115ddd5941792f1 = (file)=>{
    return file && file.size > $64886c8d2111f7ef$var$maxEmojiSizeInBytes;
};
// Duplicates https://bitbucket.org/atlassian/atlaskit/src/0e843df6df8bcd33fa7fc16cc63f11a0f6094957/packages/media-core/src/utils/checkWebpSupport.ts?at=master&fileviewer=file-view-default
// Didn't want to depend on the whole of media-core just for this util
/**
 * Checks if Webp support is enabled in the browser.
 * We know that creating a new image in memory and checking its height,
 * later on we cache this value forever.
 */ let $64886c8d2111f7ef$var$isWebpSupported;
const $64886c8d2111f7ef$export$c5a964eb84c7fca8 = ()=>{
    if ($64886c8d2111f7ef$var$isWebpSupported !== undefined) return Promise.resolve($64886c8d2111f7ef$var$isWebpSupported);
    return new Promise((resolve)=>{
        const img = new Image();
        const checkSupport = ()=>{
            $64886c8d2111f7ef$var$isWebpSupported = img.height === 2;
            resolve($64886c8d2111f7ef$var$isWebpSupported);
        };
        img.addEventListener('load', checkSupport);
        img.addEventListener('error', checkSupport);
        img.src = 'data:image/webp;base64,UklGRi4AAABXRUJQVlA4TCEAAAAvAUAAEB8wAiMwAgSSNtse/cXjxyCCmrYNWPwmHRH9jwMA';
    });
};
const $64886c8d2111f7ef$export$f8e7886bc155c2e6 = ()=>$64886c8d2111f7ef$export$c5a964eb84c7fca8().then((isWebpSupported)=>{
        // q=0.8 stands for 'quality factor' => http://stackoverflow.com/a/10496722
        const noWebpAcceptHeader = 'image/*,*/*;q=0.8';
        const webpAcceptHeader = 'image/webp,image/*,*/*;q=0.8';
        return isWebpSupported ? webpAcceptHeader : noWebpAcceptHeader;
    });

});



parcelRegister("7cjLC", function(module, exports) {

$parcel$export(module.exports, "default", () => $65ca566667d0343f$export$2e2bcd8739ae039);

var $16UJG = parcelRequire("16UJG");
const $65ca566667d0343f$export$866c20c059277b6 = 30;
class $65ca566667d0343f$export$2e2bcd8739ae039 {
    constructor(siteServiceConfig){
        this.siteServiceConfig = siteServiceConfig;
        this.tokens = new Map();
    }
    isValidToken(mediaApiToken) {
        const nowInSeconds = Date.now() / 1000;
        const expiresAt = mediaApiToken.expiresAt - $65ca566667d0343f$export$866c20c059277b6;
        if (nowInSeconds < expiresAt) return true;
        return false;
    }
    fetchNewToken(type) {
        return (0, $16UJG.utils).requestService(this.siteServiceConfig, {
            path: `token/${type}`
        });
    }
    addToken(type, mediaApiToken) {
        this.tokens.set(type, {
            mediaApiToken: mediaApiToken
        });
    }
    getToken(type, forceRefresh) {
        let tokenDetail = this.tokens.get(type);
        if (!tokenDetail) {
            tokenDetail = {};
            this.tokens.set(type, tokenDetail);
        }
        const { mediaApiToken: mediaApiToken, activeTokenRefresh: activeTokenRefresh } = tokenDetail;
        if (mediaApiToken) {
            if (this.isValidToken(mediaApiToken) && !forceRefresh) // still valid
            return Promise.resolve(mediaApiToken);
        }
        if (activeTokenRefresh) // refresh token promise already active, return that
        return activeTokenRefresh;
        // request a new token and track the promise for future requests until completed
        tokenDetail.activeTokenRefresh = this.fetchNewToken(type).then((token)=>{
            tokenDetail.mediaApiToken = token;
            tokenDetail.activeTokenRefresh = undefined;
            return token;
        });
        return tokenDetail.activeTokenRefresh;
    }
}

});


parcelRegister("iggLf", function(module, exports) {

$parcel$export(module.exports, "ufoExperiences", () => $9aee8064de0ae72b$export$615f888019c45765);
$parcel$export(module.exports, "sampledUfoRenderedEmoji", () => $9aee8064de0ae72b$export$71c8cba6f1251ea9);
$parcel$export(module.exports, "hasUfoMarked", () => $9aee8064de0ae72b$export$a9be054d2a5cedc0);
$parcel$export(module.exports, "sampledUfoEmojiResourceFetched", () => $9aee8064de0ae72b$export$1466212a1606133);

var $9L9vJ = parcelRequire("9L9vJ");

var $2kFUE = parcelRequire("2kFUE");
var $3yYXq = parcelRequire("3yYXq");
var $7dDfK = parcelRequire("7dDfK");

var $jHs7L = parcelRequire("jHs7L");
const $9aee8064de0ae72b$var$createRenderExperience = (componentName)=>{
    return {
        platform: {
            component: componentName
        },
        type: (0, $3yYXq.ExperienceTypes).Load,
        performanceType: (0, $3yYXq.ExperiencePerformanceTypes).PageSegmentLoad
    };
};
const $9aee8064de0ae72b$var$createInlineExperience = (componentName)=>{
    return {
        platform: {
            component: componentName
        },
        type: (0, $3yYXq.ExperienceTypes).Experience,
        performanceType: (0, $3yYXq.ExperiencePerformanceTypes).InlineResult
    };
};
const $9aee8064de0ae72b$var$customEmojiTimings = [
    {
        key: (0, $9L9vJ.UfoEmojiTimingsKeys).FMP,
        endMark: (0, $9L9vJ.UfoEmojiTimings).FMP_END
    },
    {
        key: (0, $9L9vJ.UfoEmojiTimingsKeys).METADATA,
        component: 'resourced-emoji',
        startMark: (0, $9L9vJ.UfoEmojiTimings).METADATA_START,
        endMark: (0, $9L9vJ.UfoEmojiTimings).METADATA_END
    },
    {
        key: (0, $9L9vJ.UfoEmojiTimingsKeys).MEDIADATA,
        component: 'caching-emoji',
        startMark: (0, $9L9vJ.UfoEmojiTimings).MEDIA_START,
        endMark: (0, $9L9vJ.UfoEmojiTimings).MEDIA_END
    },
    {
        key: (0, $9L9vJ.UfoEmojiTimingsKeys).MOUNTED,
        component: 'emoji',
        endMark: (0, $9L9vJ.UfoEmojiTimings).MOUNTED_END
    },
    {
        key: (0, $9L9vJ.UfoEmojiTimingsKeys).ONLOAD,
        startMark: (0, $9L9vJ.UfoEmojiTimings).ONLOAD_START,
        endMark: (0, $9L9vJ.UfoEmojiTimings).ONLOAD_END
    }
];
const $9aee8064de0ae72b$export$615f888019c45765 = {
    'emoji-rendered': new (0, $2kFUE.ConcurrentExperience)((0, $9L9vJ.UfoExperienceName).EMOJI_RENDERED, {
        platform: {
            component: (0, $9L9vJ.UfoComponentName).EMOJI
        },
        type: (0, $3yYXq.ExperienceTypes).Operation,
        performanceType: (0, $3yYXq.ExperiencePerformanceTypes).Custom,
        timings: $9aee8064de0ae72b$var$customEmojiTimings
    }),
    'emoji-resource-fetched': new (0, $2kFUE.ConcurrentExperience)((0, $9L9vJ.UfoExperienceName).EMOJI_RESOURCE_FETCHED, $9aee8064de0ae72b$var$createRenderExperience((0, $9L9vJ.UfoComponentName).EMOJI_PROVIDER)),
    'emoji-picker-opened': new (0, $7dDfK.UFOExperience)((0, $9L9vJ.UfoExperienceName).EMOJI_PICKER_OPENED, $9aee8064de0ae72b$var$createRenderExperience((0, $9L9vJ.UfoComponentName).EMOJI_PICKER)),
    'emoji-selection-recorded': new (0, $7dDfK.UFOExperience)((0, $9L9vJ.UfoExperienceName).EMOJI_SELECTION_RECORDED, $9aee8064de0ae72b$var$createInlineExperience((0, $9L9vJ.UfoComponentName).EMOJI_PROVIDER)),
    'emoji-uploaded': new (0, $7dDfK.UFOExperience)((0, $9L9vJ.UfoExperienceName).EMOJI_UPLOADED, $9aee8064de0ae72b$var$createInlineExperience((0, $9L9vJ.UfoComponentName).EMOJI_PICKER)),
    'emoji-searched': new (0, $7dDfK.UFOExperience)((0, $9L9vJ.UfoExperienceName).EMOJI_SEARCHED, $9aee8064de0ae72b$var$createInlineExperience((0, $9L9vJ.UfoComponentName).EMOJI_PICKER))
};
const $9aee8064de0ae72b$export$71c8cba6f1251ea9 = (emojiId)=>{
    return (0, $jHs7L.withSampling)($9aee8064de0ae72b$export$615f888019c45765['emoji-rendered'].getInstance(emojiId.id || emojiId.shortName));
};
const $9aee8064de0ae72b$export$a9be054d2a5cedc0 = (ufoExperience, name)=>{
    return ufoExperience.metrics.marks.some((mask)=>mask.name === name);
};
const $9aee8064de0ae72b$export$1466212a1606133 = (providerType)=>{
    return (0, $jHs7L.withSampling)($9aee8064de0ae72b$export$615f888019c45765['emoji-resource-fetched'].getInstance(providerType));
};

});
parcelRegister("2kFUE", function(module, exports) {

$parcel$export(module.exports, "ConcurrentExperience", () => $a30e24b2c52cc36f$export$ac1cddfee07ba6ac);

var $f0LiU = parcelRequire("f0LiU");

var $7dDfK = parcelRequire("7dDfK");
class $a30e24b2c52cc36f$export$ac1cddfee07ba6ac {
    constructor(experienceId, config){
        this.instances = {};
        this.experienceId = experienceId;
        this.config = config;
    }
    getInstance(instanceId) {
        if (!this.instances[instanceId]) this.instances[instanceId] = new (0, $7dDfK.UFOExperience)(this.experienceId, this.config, instanceId);
        return this.instances[instanceId];
    }
    release(instanceId) {
        (0, $f0LiU.ufolog)('instanceId', instanceId);
        if (this.instances[instanceId]) this.instances[instanceId].abort();
        delete this.instances[instanceId];
    }
}

});
parcelRegister("f0LiU", function(module, exports) {

$parcel$export(module.exports, "ufolog", () => $c2704d0c50f619e5$export$b4958caff08a0960);
$parcel$export(module.exports, "ufowarn", () => $c2704d0c50f619e5$export$d53d07b6034c4560);
class $c2704d0c50f619e5$var$UFOLogger {
    static{
        this.UFOprefix = "[ufo\uD83D\uDEF8]";
    }
    log(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.log($c2704d0c50f619e5$var$UFOLogger.UFOprefix, ...args);
    }
    warn(...args) {
        // eslint-disable-next-line no-console
        this.enabled && console.warn($c2704d0c50f619e5$var$UFOLogger.UFOprefix, ...args);
    }
    enable() {
        this.enabled = true;
    }
    disable() {
        this.enabled = false;
    }
    constructor(){
        this.enabled = false;
    }
}
const $c2704d0c50f619e5$export$4ab84f6f04f6566d = new $c2704d0c50f619e5$var$UFOLogger();
const $c2704d0c50f619e5$export$b4958caff08a0960 = (...args)=>{
    $c2704d0c50f619e5$export$4ab84f6f04f6566d.log(...args);
};
const $c2704d0c50f619e5$export$d53d07b6034c4560 = (...args)=>{
    $c2704d0c50f619e5$export$4ab84f6f04f6566d.warn(...args);
};

});

parcelRegister("7dDfK", function(module, exports) {

$parcel$export(module.exports, "UFOExperience", () => $0bfda9d094674d59$export$c00d22927c60484a);

var $4XjsX = parcelRequire("4XjsX");
class $0bfda9d094674d59$export$c00d22927c60484a extends (0, $4XjsX.UFOAbstractExperience) {
}

});
parcelRegister("4XjsX", function(module, exports) {

$parcel$export(module.exports, "UFOAbstractExperience", () => $b82268227d2a5ae4$export$d31c89db257648c);

var $hompL = parcelRequire("hompL");


var $6fEIi = parcelRequire("6fEIi");

var $f0LiU = parcelRequire("f0LiU");

var $1A03k = parcelRequire("1A03k");

var $5bc3G = parcelRequire("5bc3G");

var $a72vD = parcelRequire("a72vD");

var $9IyR3 = parcelRequire("9IyR3");

var $uMitL = parcelRequire("uMitL");

var $3vocg = parcelRequire("3vocg");

var $3yYXq = parcelRequire("3yYXq");
const $b82268227d2a5ae4$var$getPageVisibleState = ()=>{
    return !(0, $9IyR3.isWindowObjectAvailable)() || !window.document || window.document.visibilityState === 'visible' ? (0, $5bc3G.PageVisibleState).VISIBLE : (0, $5bc3G.PageVisibleState).HIDDEN;
};
const $b82268227d2a5ae4$export$c753e8669d30c8ad = (timestamp)=>{
    if (timestamp !== undefined) return ~~timestamp;
    return (0, $a72vD.roundPerfNow)();
};
class $b82268227d2a5ae4$export$d31c89db257648c {
    constructor(id, config, instanceId = null){
        this.state = (0, $uMitL.UFOExperienceState).NOT_STARTED;
        this.instanceId = null // for concurrent
        ;
        this.parent = null;
        this.category = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.explicitTimings = {};
        // @todo move to page load experience when proper classes/inheritance prepared
        this.isSSROutputAsFMP = false;
        this.uuid = null;
        this._until = null;
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this.performanceConfig = {};
        this.setPageVisibleStateToMixed = ()=>{
            this.pageVisibleState = (0, $5bc3G.PageVisibleState).MIXED;
            (0, $1A03k.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        };
        this.id = id;
        this.category = config?.category || null;
        this.until = config?.until || null;
        this.instanceId = instanceId;
        this.handleDoneBind = this._handleDoneExperience.bind(this);
        this.type = config.type;
        this.performanceType = config.performanceType;
        this.performanceConfig = config.performanceConfig || {};
        this.config = config;
        this.pageVisibleState = $b82268227d2a5ae4$var$getPageVisibleState();
        this.featureFlags = config.featureFlags || [];
        this.timings = config.timings || [];
        if (config.performanceType === (0, $3yYXq.ExperiencePerformanceTypes).PageLoad || config.performanceType === (0, $3yYXq.ExperiencePerformanceTypes).PageSegmentLoad) this.isSSROutputAsFMP = config.isSSROutputAsFMP || false;
    }
    async transition(newState, timestamp) {
        (0, $f0LiU.ufolog)('async transition', this.id, this.state.id, newState.id);
        if ((0, $3vocg.canTransition)(this.state, newState)) {
            (0, $f0LiU.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} successful`, this.state.final, !newState.final);
            if (newState === (0, $uMitL.UFOExperienceState).STARTED) this._reset();
            if (this.state.final && !newState.final) {
                this.metrics.startTime = $b82268227d2a5ae4$export$c753e8669d30c8ad(timestamp);
                this.uuid = (0, $hompL.v4)();
            }
            this.state = newState;
            if (newState.final) {
                this.metrics.endTime = $b82268227d2a5ae4$export$c753e8669d30c8ad(timestamp);
                if (!this._isManualStateEnabled()) (0, $6fEIi.getGlobalEventStream)().push((0, $6fEIi.unsubscribeEvent)((0, $5bc3G.SUBSCRIBE_ALL), this.handleDoneBind));
                const data = await this.exportData();
                (0, $f0LiU.ufolog)('this.parent', this.parent);
                (0, $6fEIi.getGlobalEventStream)().push((0, $6fEIi.experiencePayloadEvent)(data));
            }
            return true;
        }
        (0, $f0LiU.ufolog)(`TRANSITION: ${this.id} from ${this.state.id} to ${newState.id} unsuccessful`);
        (0, $f0LiU.ufowarn)(`transition of ${this.id} from ${this.state} to ${newState} is not possible`);
        return false;
    }
    async start(startTime) {
        const transitionSuccessful = await this.transition((0, $uMitL.UFOExperienceState).STARTED, startTime);
        if (transitionSuccessful) {
            this.pageVisibleState = $b82268227d2a5ae4$var$getPageVisibleState();
            (0, $1A03k.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
            if (!this._isManualStateEnabled()) {
                (0, $f0LiU.ufolog)('subscribed', this.id);
                (0, $6fEIi.getGlobalEventStream)().push((0, $6fEIi.subscribeEvent)((0, $5bc3G.SUBSCRIBE_ALL), this.handleDoneBind));
            }
        }
    }
    mark(name, timestamp) {
        if (name !== (0, $5bc3G.FMP_MARK) && name !== (0, $5bc3G.INLINE_RESPONSE_MARK)) this._mark(name, timestamp);
        else (0, $f0LiU.ufowarn)('please use markFMP or markInlineResponse for specialised marks');
    }
    _mark(name, timestamp) {
        this.metrics.marks.push({
            name: name,
            time: $b82268227d2a5ae4$export$c753e8669d30c8ad(timestamp)
        });
        this.transition((0, $uMitL.UFOExperienceState).IN_PROGRESS);
    }
    markFMP(timestamp) {
        this._mark((0, $5bc3G.FMP_MARK), timestamp);
    }
    markInlineResponse(timestamp) {
        this._mark((0, $5bc3G.INLINE_RESPONSE_MARK), timestamp);
    }
    _isManualStateEnabled() {
        return this.until === null;
    }
    _validateManualState() {
        if (!this._isManualStateEnabled()) {
            (0, $f0LiU.ufowarn)('manual change of state not allowed as "until" is defined');
            return false;
        }
        return true;
    }
    switchToEndState(state, config) {
        if (!config?.force && !this._validateManualState()) return null;
        if (config?.metadata) this.addMetadata(config.metadata);
        (0, $1A03k.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
        return this.transition(state);
    }
    async success(config) {
        return this.switchToEndState((0, $uMitL.UFOExperienceState).SUCCEEDED, config);
    }
    async failure(config) {
        return this.switchToEndState((0, $uMitL.UFOExperienceState).FAILED, config);
    }
    async abort(config) {
        return this.switchToEndState((0, $uMitL.UFOExperienceState).ABORTED, config);
    }
    addMetadata(data) {
        Object.assign(this.metadata, data);
    }
    _handleDoneExperience(data) {
        (0, $f0LiU.ufolog)('_handleDoneExperience in', this.id, data.state, data, this._until);
        if (data.state.final) {
            if (this._until !== null) {
                const { done: done, state: state } = this._until(data);
                if (done && !this.state.final) this.transition(state);
            }
        }
    }
    async getId() {
        return this.id;
    }
    async exportData() {
        return {
            id: await this.getId(),
            uuid: this.uuid,
            type: this.type,
            schemaVersion: (0, $392a4a01cdcd9472$export$2295b861f318254a) || 'unknown',
            performanceType: this.performanceType,
            category: this.category,
            state: this.state,
            metadata: {
                ...this.metadata
            },
            metrics: {
                ...this.metrics
            },
            children: [
                ...this.childExperiences
            ],
            result: {
                success: !!this.state.success,
                startTime: this.metrics.startTime,
                duration: (this.metrics.endTime || 0) - (this.metrics.startTime || 0)
            },
            platform: this.config.platform || null,
            pageVisibleState: this.pageVisibleState,
            featureFlags: this.featureFlags,
            isSSROutputAsFMP: this.isSSROutputAsFMP,
            timings: this.timings,
            explicitTimings: this.explicitTimings,
            performanceConfig: this.performanceConfig
        };
    }
    _reset() {
        this.parent = null;
        this.metadata = {};
        this.onDoneCallbacks = [];
        this.childExperiences = [];
        this.metrics = {
            startTime: null,
            endTime: null,
            marks: []
        };
        this._until = this.until ? this.until() : null;
    }
}

});
// temp solution until we can get it automated
const $392a4a01cdcd9472$export$2295b861f318254a = '0.1.5';

parcelRegister("6fEIi", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventStream", () => $7118726fd593c611$export$6123a44dc2384540);
$parcel$export(module.exports, "subscribeEvent", () => $7118726fd593c611$export$37863216db4b714d);
$parcel$export(module.exports, "unsubscribeEvent", () => $7118726fd593c611$export$ee1a7bd1fc9ea85e);
$parcel$export(module.exports, "experiencePayloadEvent", () => $7118726fd593c611$export$7c957416596ca127);

var $f0LiU = parcelRequire("f0LiU");

var $5bc3G = parcelRequire("5bc3G");
const $7118726fd593c611$var$MAX_EARLY_QUEUE_LENGTH = 250;
const $7118726fd593c611$export$6123a44dc2384540 = ()=>{
    if (!globalThis.__UFO_GLOBAL_EVENT_STREAM__) {
        const earlyStream = (()=>{
            const stream = [];
            return {
                __buffer_only__: true,
                push: (event)=>{
                    if (stream.length < $7118726fd593c611$var$MAX_EARLY_QUEUE_LENGTH) stream.push(event);
                },
                getStream: ()=>stream
            };
        })();
        globalThis.__UFO_GLOBAL_EVENT_STREAM__ = earlyStream;
    }
    return globalThis.__UFO_GLOBAL_EVENT_STREAM__;
};
const $7118726fd593c611$export$c1522520b417b066 = (eventStream)=>{
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__ && !globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) {
        (0, $f0LiU.ufowarn)('Global Event Stream already initialised. Ignoring new event stream setup');
        return;
    }
    if (globalThis.__UFO_GLOBAL_EVENT_STREAM__?.__buffer_only__) globalThis.__UFO_GLOBAL_EVENT_STREAM__.getStream().forEach(eventStream.push.bind(eventStream));
    globalThis.__UFO_GLOBAL_EVENT_STREAM__ = eventStream;
};
const $7118726fd593c611$export$37863216db4b714d = (experienceId, callback)=>{
    return {
        type: (0, $5bc3G.UFOGlobalEventStreamEventType).SUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $7118726fd593c611$export$ee1a7bd1fc9ea85e = (experienceId, callback)=>{
    return {
        type: (0, $5bc3G.UFOGlobalEventStreamEventType).UNSUBSCRIBE,
        payload: {
            experienceId: experienceId,
            callback: callback
        }
    };
};
const $7118726fd593c611$export$7c957416596ca127 = (data)=>{
    return {
        type: (0, $5bc3G.UFOGlobalEventStreamEventType).EXPERIENCE_PAYLOAD,
        payload: data
    };
};

});
parcelRegister("5bc3G", function(module, exports) {

$parcel$export(module.exports, "UFOGlobalEventStreamEventType", () => $6db1c4aca6f838ac$export$96253c35c37cf96b);
$parcel$export(module.exports, "PageVisibleState", () => $6db1c4aca6f838ac$export$a12c67b37a306b13);
$parcel$export(module.exports, "SUBSCRIBE_ALL", () => $6db1c4aca6f838ac$export$79bf131685ad41d7);
$parcel$export(module.exports, "FMP_MARK", () => $6db1c4aca6f838ac$export$9f2bf58999404c75);
$parcel$export(module.exports, "INLINE_RESPONSE_MARK", () => $6db1c4aca6f838ac$export$837e0f79a8056912);
var $6db1c4aca6f838ac$export$96253c35c37cf96b;
(function(UFOGlobalEventStreamEventType) {
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["EXPERIENCE_PAYLOAD"] = 0] = "EXPERIENCE_PAYLOAD";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["SUBSCRIBE"] = 1] = "SUBSCRIBE";
    UFOGlobalEventStreamEventType[UFOGlobalEventStreamEventType["UNSUBSCRIBE"] = 2] = "UNSUBSCRIBE";
})($6db1c4aca6f838ac$export$96253c35c37cf96b || ($6db1c4aca6f838ac$export$96253c35c37cf96b = {}));
var $6db1c4aca6f838ac$export$a12c67b37a306b13;
(function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["HIDDEN"] = "hidden";
    PageVisibleState["MIXED"] = "mixed";
})($6db1c4aca6f838ac$export$a12c67b37a306b13 || ($6db1c4aca6f838ac$export$a12c67b37a306b13 = {}));
var $6db1c4aca6f838ac$export$66b33c055cbb625e;
(function(PageLoadMetrics) {
    PageLoadMetrics["fmp"] = "fmp";
    PageLoadMetrics["tti"] = "tti";
})($6db1c4aca6f838ac$export$66b33c055cbb625e || ($6db1c4aca6f838ac$export$66b33c055cbb625e = {}));
var $6db1c4aca6f838ac$export$3ce489cbe02dc21b;
(function(PageSegmentLoadMetrics) {
    PageSegmentLoadMetrics["fmp"] = "fmp";
    PageSegmentLoadMetrics["tti"] = "tti";
})($6db1c4aca6f838ac$export$3ce489cbe02dc21b || ($6db1c4aca6f838ac$export$3ce489cbe02dc21b = {}));
var $6db1c4aca6f838ac$export$341b330828bd3906;
(function(InteractionMetrics) {
    InteractionMetrics["response"] = "response";
    InteractionMetrics["result"] = "result";
})($6db1c4aca6f838ac$export$341b330828bd3906 || ($6db1c4aca6f838ac$export$341b330828bd3906 = {}));
var $6db1c4aca6f838ac$export$b9b20160f581e4f8;
(function(CustomMetrics) {
    CustomMetrics["duration"] = "duration";
})($6db1c4aca6f838ac$export$b9b20160f581e4f8 || ($6db1c4aca6f838ac$export$b9b20160f581e4f8 = {}));
const $6db1c4aca6f838ac$export$79bf131685ad41d7 = '__SUBSCRIBE_ALL__';
const $6db1c4aca6f838ac$export$9f2bf58999404c75 = 'fmp';
const $6db1c4aca6f838ac$export$837e0f79a8056912 = 'inline-response';

});


parcelRegister("1A03k", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", () => $95f5135adf29b140$export$13e680397ec8f3eb);

var $9IyR3 = parcelRequire("9IyR3");
class $95f5135adf29b140$var$VisibilityChangeObserver {
    start() {
        if (this.started) return;
        this.started = true;
        document.addEventListener('visibilitychange', this.broadcast);
        /**
		 * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
		 * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
		 * so for that case, you need to also include code to listen for the pagehide event.
		 */ if ((0, $9IyR3.isWindowObjectAvailable)()) window.addEventListener('pagehide', this.broadcast);
    }
    subscribe(callback) {
        this.observers.push(callback);
    }
    unsubscribe(callback) {
        this.observers = this.observers.filter((fn)=>fn !== callback);
    }
    constructor(){
        this.started = false;
        this.observers = [];
        this.broadcast = ()=>{
            this.observers.forEach((fn)=>fn());
            this.observers = [];
        };
    }
}
const $95f5135adf29b140$export$13e680397ec8f3eb = new $95f5135adf29b140$var$VisibilityChangeObserver();

});
parcelRegister("9IyR3", function(module, exports) {

$parcel$export(module.exports, "isWindowObjectAvailable", () => $3677fb5e29ccb89d$export$15e172712955e18f);
const $3677fb5e29ccb89d$export$15e172712955e18f = ()=>{
    return typeof window !== 'undefined';
};

});


parcelRegister("a72vD", function(module, exports) {

$parcel$export(module.exports, "roundPerfNow", () => $abf5afa8ee98b73d$export$5f490af6b2b115cf);
const $abf5afa8ee98b73d$export$5f490af6b2b115cf = ()=>~~performance.now();

});

parcelRegister("uMitL", function(module, exports) {

$parcel$export(module.exports, "UFOExperienceState", () => $dce4f34a405f688c$export$81b70111112841a0);
const $dce4f34a405f688c$export$81b70111112841a0 = {
    NOT_STARTED: {
        id: 'NOT_STARTED',
        final: true
    },
    STARTED: {
        id: 'STARTED'
    },
    IN_PROGRESS: {
        id: 'IN_PROGRESS'
    },
    BLOCKED: {
        id: 'BLOCKED'
    },
    RECOVERED: {
        id: 'RECOVERED'
    },
    SUCCEEDED: {
        id: 'SUCCEEDED',
        final: true,
        success: true
    },
    SUCCEEDED_WAITING_FOR_DEPS: {
        id: 'SUCCEEDED_WAITING_FOR_DEPS'
    },
    FAILED: {
        id: 'FAILED',
        final: true
    },
    ABORTED: {
        id: 'ABORTED',
        final: true
    }
};

});

parcelRegister("3vocg", function(module, exports) {

$parcel$export(module.exports, "canTransition", () => $5c3cafcf3c197b83$export$178881f329fdb81f);

var $uMitL = parcelRequire("uMitL");
const $5c3cafcf3c197b83$var$UFOStateAvailableTransitions = {
    [(0, $uMitL.UFOExperienceState).NOT_STARTED.id]: [
        (0, $uMitL.UFOExperienceState).STARTED.id
    ],
    [(0, $uMitL.UFOExperienceState).STARTED.id]: [
        (0, $uMitL.UFOExperienceState).IN_PROGRESS.id,
        (0, $uMitL.UFOExperienceState).BLOCKED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $uMitL.UFOExperienceState).FAILED.id,
        (0, $uMitL.UFOExperienceState).ABORTED.id
    ],
    [(0, $uMitL.UFOExperienceState).IN_PROGRESS.id]: [
        (0, $uMitL.UFOExperienceState).BLOCKED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $uMitL.UFOExperienceState).FAILED.id,
        (0, $uMitL.UFOExperienceState).ABORTED.id
    ],
    [(0, $uMitL.UFOExperienceState).BLOCKED.id]: [
        (0, $uMitL.UFOExperienceState).RECOVERED.id,
        (0, $uMitL.UFOExperienceState).ABORTED.id
    ],
    [(0, $uMitL.UFOExperienceState).RECOVERED.id]: [
        (0, $uMitL.UFOExperienceState).STARTED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED.id,
        (0, $uMitL.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id,
        (0, $uMitL.UFOExperienceState).FAILED.id,
        (0, $uMitL.UFOExperienceState).ABORTED.id
    ],
    [(0, $uMitL.UFOExperienceState).SUCCEEDED.id]: [
        (0, $uMitL.UFOExperienceState).STARTED.id
    ],
    [(0, $uMitL.UFOExperienceState).SUCCEEDED_WAITING_FOR_DEPS.id]: [
        (0, $uMitL.UFOExperienceState).SUCCEEDED.id,
        (0, $uMitL.UFOExperienceState).FAILED.id,
        (0, $uMitL.UFOExperienceState).ABORTED.id
    ],
    [(0, $uMitL.UFOExperienceState).FAILED.id]: [
        (0, $uMitL.UFOExperienceState).STARTED.id
    ],
    [(0, $uMitL.UFOExperienceState).ABORTED.id]: [
        (0, $uMitL.UFOExperienceState).STARTED.id
    ]
};
const $5c3cafcf3c197b83$export$178881f329fdb81f = (state1, state2)=>{
    return $5c3cafcf3c197b83$var$UFOStateAvailableTransitions[state1.id] && $5c3cafcf3c197b83$var$UFOStateAvailableTransitions[state1.id].includes(state2.id);
};

});

parcelRegister("3yYXq", function(module, exports) {

$parcel$export(module.exports, "ExperienceTypes", () => $156ab33d023ea8cf$export$994164cf3ae1cc9a);
$parcel$export(module.exports, "ExperiencePerformanceTypes", () => $156ab33d023ea8cf$export$cc26007c03242fff);
var $156ab33d023ea8cf$export$994164cf3ae1cc9a;
(function(ExperienceTypes) {
    ExperienceTypes["Load"] = "load";
    ExperienceTypes["Experience"] = "experience";
    ExperienceTypes["Operation"] = "operation";
})($156ab33d023ea8cf$export$994164cf3ae1cc9a || ($156ab33d023ea8cf$export$994164cf3ae1cc9a = {}));
var $156ab33d023ea8cf$export$cc26007c03242fff;
(function(ExperiencePerformanceTypes) {
    ExperiencePerformanceTypes["PageLoad"] = "page-load";
    ExperiencePerformanceTypes["PageSegmentLoad"] = "page-segment-load";
    ExperiencePerformanceTypes["InlineResult"] = "inline-result";
    ExperiencePerformanceTypes["Custom"] = "custom";
})($156ab33d023ea8cf$export$cc26007c03242fff || ($156ab33d023ea8cf$export$cc26007c03242fff = {}));

});




parcelRegister("jHs7L", function(module, exports) {

$parcel$export(module.exports, "withSampling", () => $d5787feff7886cec$export$dc2f0946255b3f89);
const $d5787feff7886cec$export$c7c4959fece2f3ec = {};
const $d5787feff7886cec$export$cdff9a865136ae27 = ()=>{
    for (const prop of Object.getOwnPropertyNames($d5787feff7886cec$export$c7c4959fece2f3ec))delete $d5787feff7886cec$export$c7c4959fece2f3ec[prop];
};
const $d5787feff7886cec$export$1c967630b3ea2d58 = (rate)=>{
    if (rate === 1) return true;
    if (rate === 0) return false;
    return Math.random() * rate <= 1;
};
const $d5787feff7886cec$var$hasSampledFromStart = (experience)=>{
    if (!$d5787feff7886cec$export$c7c4959fece2f3ec[experience.id]) return false;
    if (experience.instanceId) // if the instance of concurrent exp has been sampled from start, allow it.
    return $d5787feff7886cec$export$c7c4959fece2f3ec[experience.id].sampledInstance[experience.instanceId];
    return $d5787feff7886cec$export$c7c4959fece2f3ec[experience.id].sampled;
};
const $d5787feff7886cec$export$dc2f0946255b3f89 = (ufoExperience)=>{
    const init = ()=>{
        if (!$d5787feff7886cec$export$c7c4959fece2f3ec[ufoExperience.id]) $d5787feff7886cec$export$c7c4959fece2f3ec[ufoExperience.id] = {
            sampled: false,
            sampledInstance: {}
        };
    };
    const start = async (options)=>{
        // check if the experience has already sampled before
        if ($d5787feff7886cec$var$hasSampledFromStart(ufoExperience)) return;
        const isSampled = options.samplingFunc || $d5787feff7886cec$export$1c967630b3ea2d58;
        if (!isSampled(options.samplingRate)) {
            if (ufoExperience.instanceId) $d5787feff7886cec$export$c7c4959fece2f3ec[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = false;
            $d5787feff7886cec$export$c7c4959fece2f3ec[ufoExperience.id].sampled = false;
            return;
        }
        // update sampled records
        if (ufoExperience.instanceId) {
            $d5787feff7886cec$export$c7c4959fece2f3ec[ufoExperience.id].sampledInstance[ufoExperience.instanceId] = true;
            $d5787feff7886cec$export$c7c4959fece2f3ec[ufoExperience.id].sampled = true;
        }
        return ufoExperience.start(options.startTime);
    };
    const success = async (config)=>{
        if (!$d5787feff7886cec$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.success(config);
    };
    const failure = async (config)=>{
        if (!$d5787feff7886cec$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.failure(config);
    };
    const abort = async (config)=>{
        if (!$d5787feff7886cec$var$hasSampledFromStart(ufoExperience)) return null;
        return ufoExperience.abort(config);
    };
    const addMetadata = (data)=>{
        if (!$d5787feff7886cec$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.addMetadata(data);
    };
    const mark = (name, timestamp)=>{
        if (!$d5787feff7886cec$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.mark(name, timestamp);
    };
    const markFMP = (timestamp)=>{
        if (!$d5787feff7886cec$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.markFMP(timestamp);
    };
    const markInlineResponse = (timestamp)=>{
        if (!$d5787feff7886cec$var$hasSampledFromStart(ufoExperience)) return;
        return ufoExperience.markInlineResponse(timestamp);
    };
    init();
    return {
        ...ufoExperience,
        start: start,
        addMetadata: addMetadata,
        success: success,
        failure: failure,
        abort: abort,
        mark: mark,
        markFMP: markFMP,
        markInlineResponse: markInlineResponse
    };
};

});



parcelRegister("k7z88", function(module, exports) {

$parcel$export(module.exports, "EMOJI_SERVICEID", () => $457dd1ed4ad976ac$export$f3c4ed49c0fff3de);
$parcel$export(module.exports, "EMOJI_WITH_CUSTOM_SERVICEID", () => $457dd1ed4ad976ac$export$f8b39b441e3e8eb2);
$parcel$export(module.exports, "EMOJI_WITH_CUSTOM_UPLOAD_DISABLED_SERVICEID", () => $457dd1ed4ad976ac$export$2cdcb9248b6d4704);
$parcel$export(module.exports, "getServiceProvider", () => $457dd1ed4ad976ac$export$a4c27db78169052e);
$parcel$export(module.exports, "default", () => $457dd1ed4ad976ac$export$2e2bcd8739ae039);

var $6rW04 = parcelRequire("6rW04");
const $457dd1ed4ad976ac$var$providersRepository = {};
const $457dd1ed4ad976ac$export$f3c4ed49c0fff3de = 'emoji';
const $457dd1ed4ad976ac$export$f8b39b441e3e8eb2 = 'emoji-with-custom';
const $457dd1ed4ad976ac$export$2cdcb9248b6d4704 = 'emoji-with-custom-upload-disabled';
const $457dd1ed4ad976ac$var$getServiceBaseUrl = (serviceId)=>{
    if (serviceId === $457dd1ed4ad976ac$export$f8b39b441e3e8eb2 || serviceId === $457dd1ed4ad976ac$export$2cdcb9248b6d4704) return (0, $6rW04.default)('ajs-fabric-emoji-url');
    return (0, $6rW04.default)(`ajs-fabric-${serviceId}-url`);
};
const $457dd1ed4ad976ac$export$a4c27db78169052e = (serviceId, serviceProviderGenerator)=>{
    try {
        let serviceProvider = $457dd1ed4ad976ac$var$providersRepository[serviceId];
        if (serviceProvider === undefined) {
            const serviceBaseUrl = $457dd1ed4ad976ac$var$getServiceBaseUrl(serviceId);
            if (serviceBaseUrl) {
                serviceProvider = Promise.resolve(serviceProviderGenerator(serviceBaseUrl));
                $457dd1ed4ad976ac$var$providersRepository[serviceId] = serviceProvider;
            }
        }
        return serviceProvider;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return null;
    }
};
const $457dd1ed4ad976ac$export$59790759c19337ec = ()=>{
    Object.keys($457dd1ed4ad976ac$var$providersRepository).forEach((key)=>{
        delete $457dd1ed4ad976ac$var$providersRepository[key];
    });
};
var $457dd1ed4ad976ac$export$2e2bcd8739ae039 = $457dd1ed4ad976ac$var$getServiceBaseUrl;

});



parcelRegister("9XfZZ", function(module, exports) {

$parcel$export(module.exports, "isExternalLink", () => $037fcbfba11ab4d5$export$b98882f166bb7ce2);
$parcel$export(module.exports, "onLinkClick", () => $037fcbfba11ab4d5$export$dccc97e4cadc9724);
$parcel$export(module.exports, "smartLinksDefault", () => $037fcbfba11ab4d5$export$4f1b881d7a962ce6);
$parcel$export(module.exports, "useSmartCardProductType", () => $037fcbfba11ab4d5$export$3f864e37674c79e7);
$parcel$export(module.exports, "useSmartCardIsAIEnabled", () => $037fcbfba11ab4d5$export$af081b1242bfa300);
$parcel$export(module.exports, "SmartCardProviderWithAIHooks", () => $037fcbfba11ab4d5$export$ca9fa6647337e334);

var $eUqFw = parcelRequire("eUqFw");

var $aml13 = parcelRequire("aml13");

var $hqABm = parcelRequire("hqABm");

var $7ZZxN = parcelRequire("7ZZxN");

var $hJ992 = parcelRequire("hJ992");

var $4zUUC = parcelRequire("4zUUC");

var $guDlK = parcelRequire("guDlK");
const $037fcbfba11ab4d5$var$isLeftClick = (event)=>event.button === 0;
const $037fcbfba11ab4d5$var$isMiddleClick = (event)=>event.button === 1;
const $037fcbfba11ab4d5$var$isCmdOrCtrlClick = (event)=>$037fcbfba11ab4d5$var$isLeftClick(event) && (event.metaKey || event.ctrlKey);
const $037fcbfba11ab4d5$export$b98882f166bb7ce2 = (url)=>{
    const { hostname: hostname, pathname: pathname } = new URL(url);
    return hostname !== window.location.hostname || ![
        '/jira',
        '/browse'
    ].some((includedPath)=>pathname.startsWith(includedPath));
};
const $037fcbfba11ab4d5$export$dccc97e4cadc9724 = (event, url)=>{
    if (!url) return;
    if ($037fcbfba11ab4d5$export$b98882f166bb7ce2(url)) {
        event.preventDefault();
        window.open(url, '_blank', 'noopener,noreferrer');
        return;
    }
    if (event.defaultPrevented) {
        // The default has already been prevented meaning that we need to open links in one
        // way or another to ensure we do eventually open the link
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        const mouseEvent = event;
        $037fcbfba11ab4d5$var$isCmdOrCtrlClick(mouseEvent) || $037fcbfba11ab4d5$var$isMiddleClick(mouseEvent) ? window.open(url, '_blank', 'noopener,noreferrer') : window.location.assign(url);
    }
};
const $037fcbfba11ab4d5$export$4f1b881d7a962ce6 = {
    actionOptions: {
        hide: false,
        exclude: [
            (0, $hqABm.CardAction).ChangeStatusAction
        ]
    }
};
const $037fcbfba11ab4d5$export$4761115a9e18aa47 = (projectType)=>{
    switch(projectType){
        case 0, $7ZZxN.CORE_PROJECT:
            return 'JWM';
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            return 'JSW';
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return 'JSM';
        case 0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT:
            return 'JPD';
        default:
            return undefined;
    }
};
const $037fcbfba11ab4d5$export$3f864e37674c79e7 = ()=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const projectType = (0, $guDlK.useProjectType)(projectKey);
    const product = (0, $eUqFw.useMemo)(()=>// Arbitarily default to Jira Software if not specified
        $037fcbfba11ab4d5$export$4761115a9e18aa47(projectType) ?? 'JSW', [
        projectType
    ]);
    return product;
};
const $037fcbfba11ab4d5$export$af081b1242bfa300 = ()=>{
    const isAiOptInEnabled = (0, $hJ992.useIsAiOptInEnabled)();
    const isPremium = (0, $4zUUC.useIsPremium)();
    const isAIFeatureEnabled = (0, $eUqFw.useMemo)(()=>isAiOptInEnabled && isPremium, [
        isAiOptInEnabled,
        isPremium
    ]);
    return isAIFeatureEnabled;
};
const $037fcbfba11ab4d5$export$ca9fa6647337e334 = (props)=>{
    const product = $037fcbfba11ab4d5$export$3f864e37674c79e7();
    const isAIEnabled = $037fcbfba11ab4d5$export$af081b1242bfa300();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aml13.SmartCardProvider), {
        product: product,
        isAdminHubAIEnabled: isAIEnabled,
        ...props
    }, props.children);
};

});
parcelRegister("hqABm", function(module, exports) {

$parcel$export(module.exports, "CardAction", () => $e9d011026964d0c2$export$f40b7e0b762b928b);
var $e9d011026964d0c2$export$f40b7e0b762b928b;
(function(CardAction) {
    CardAction["DownloadAction"] = "DownloadAction";
    CardAction["PreviewAction"] = "PreviewAction";
    CardAction["ViewAction"] = "ViewAction";
    CardAction["ChangeStatusAction"] = "ChangeStatusAction";
    CardAction["FollowAction"] = "FollowAction";
    CardAction["CopyLinkAction"] = "CopyLinkAction";
    CardAction["AISummaryAction"] = "AISummaryAction";
    CardAction["AutomationAction"] = "AutomationAction";
})($e9d011026964d0c2$export$f40b7e0b762b928b || ($e9d011026964d0c2$export$f40b7e0b762b928b = {}));

});

parcelRegister("4zUUC", function(module, exports) {

$parcel$export(module.exports, "useIsPremium", () => $800159a3fd254246$export$1bb5840a003dc643);
$parcel$export(module.exports, "useCanOptIn", () => $800159a3fd254246$export$bd66bcf1f00b19d2);
$parcel$export(module.exports, "useAIOptIn", () => $800159a3fd254246$export$49e57b9044cda91c);

var $eUqFw = parcelRequire("eUqFw");

var $bW292 = parcelRequire("bW292");

var $7ZZxN = parcelRequire("7ZZxN");

var $1ybV0 = parcelRequire("1ybV0");

var $hJ992 = parcelRequire("hJ992");

var $guDlK = parcelRequire("guDlK");

var $jD3pk = parcelRequire("jD3pk");

var $6WXNs = parcelRequire("6WXNs");

var $ab6rA = parcelRequire("ab6rA");
var $1R3n5 = parcelRequire("1R3n5");

var $6dejM = parcelRequire("6dejM");

var $feY12 = parcelRequire("feY12");
const $800159a3fd254246$export$1bb5840a003dc643 = ()=>{
    const appEditions = (0, $ab6rA.useAppEditions)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const projectType = (0, $guDlK.useProjectType)(projectKey);
    if (!appEditions) return false;
    switch(projectType){
        case 0, $7ZZxN.CORE_PROJECT:
            return appEditions.core === (0, $6WXNs.PREMIUM_EDITION);
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            return appEditions.software === (0, $6WXNs.PREMIUM_EDITION);
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return appEditions.serviceDesk === (0, $6WXNs.PREMIUM_EDITION);
        default:
            return false;
    }
};
const $800159a3fd254246$export$10e0dafdd792475b = ()=>{
    // upsell us for standard but not free subscription admins
    const appEditions = (0, $ab6rA.useAppEditions)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const projectKey = (0, $guDlK.useProjectKey)(issueKey);
    const projectType = (0, $guDlK.useProjectType)(projectKey);
    if (!appEditions) return false;
    switch(projectType){
        case 0, $7ZZxN.CORE_PROJECT:
            return appEditions.core === (0, $6WXNs.STANDARD_EDITION);
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            return appEditions.software === (0, $6WXNs.STANDARD_EDITION);
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return appEditions.serviceDesk === (0, $6WXNs.STANDARD_EDITION);
        default:
            return false;
    }
};
const $800159a3fd254246$export$bd66bcf1f00b19d2 = ()=>{
    const isOrgAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const isPremium = $800159a3fd254246$export$1bb5840a003dc643();
    return isOrgAdmin && isPremium;
};
const $800159a3fd254246$export$1276193c77ae88bf = ()=>{
    const isOrgAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const isStandard = $800159a3fd254246$export$10e0dafdd792475b();
    return (0, $1ybV0.ff)('jsw-premium-edition-eval-admin-ai-upsell_djht5') && isOrgAdmin && isStandard;
};
const $800159a3fd254246$export$5e56b08674e48311 = (isAIOptedIn, product)=>{
    const canOptIn = $800159a3fd254246$export$bd66bcf1f00b19d2();
    const canStartPremiumTrial = $800159a3fd254246$export$1276193c77ae88bf();
    const isValidForGlobalOptIn = [
        product !== 'JPD',
        canOptIn
    ].every((condition)=>condition === true);
    const isValidForPremiumTrial = canStartPremiumTrial && product !== 'JPD';
    const globalOptInEnabled = isValidForGlobalOptIn || isValidForPremiumTrial ? 'disabled-opt-in' : 'disabled';
    return isAIOptedIn ? 'enabled' : globalOptInEnabled;
};
const $800159a3fd254246$export$49e57b9044cda91c = ({ editorPluginAIConfig: editorPluginAIConfig })=>{
    const { isAiOptInEnabled: isAiOptInEnabled, product: product } = editorPluginAIConfig || {};
    const optInStatus = $800159a3fd254246$export$5e56b08674e48311(isAiOptInEnabled, product);
    const isOrgAdmin = (0, $1R3n5.useIsSiteAdmin)();
    const [showOptInModal, setShowOptInModal] = (0, $eUqFw.useState)(false);
    const [showPremiumTrialModal, setShowPremiumTrialModal] = (0, $eUqFw.useState)(false);
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const canStartTrial = $800159a3fd254246$export$1276193c77ae88bf();
    // Callback that will be called when AI buttons are clicked and opt in status is disabled-op-in
    const triggerOptInFlow = (0, $eUqFw.useCallback)(()=>{
        setShowOptInModal(true);
    }, [
        setShowOptInModal
    ]);
    // alt callback for standard admins to trigger a premium upsell in order to opt in
    const triggerUpsellFlow = (0, $eUqFw.useCallback)(()=>{
        setShowPremiumTrialModal(true);
    }, [
        setShowPremiumTrialModal
    ]);
    const aiOptInModal = (0, $eUqFw.useMemo)(()=>{
        const onCloseModal = ()=>setShowOptInModal(false);
        const adminLink = `${(0, $bW292.getATLContextUrl)('admin')}/o/${orgId}/atlassian-intelligence`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6dejM.OptInModal), {
            showOptInModal: showOptInModal,
            isOrgAdmin: isOrgAdmin,
            onCloseModal: onCloseModal,
            adminLink: adminLink
        });
    }, [
        orgId,
        isOrgAdmin,
        showOptInModal
    ]);
    const aiUpsellModal = (0, $eUqFw.useMemo)(()=>{
        const onCloseModal = ()=>setShowPremiumTrialModal(false);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $feY12.AIUpsellPremiumTrialEntryPointContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6dejM.OptInUpsellModal), {
            "data-testid": "platform-react-hooks-use-ai-opt-in.upsell-modal",
            showPremiumTrialModal: showPremiumTrialModal,
            onCloseModal: onCloseModal
        }));
    }, [
        showPremiumTrialModal
    ]);
    if (optInStatus === 'disabled' || optInStatus === 'enabled') return {
        optInStatus: optInStatus,
        triggerOptInFlow: triggerOptInFlow,
        AIOptInModal: null
    };
    if (canStartTrial && optInStatus === 'disabled-opt-in') return {
        optInStatus: optInStatus,
        triggerOptInFlow: triggerUpsellFlow,
        AIOptInModal: aiUpsellModal
    };
    return {
        optInStatus: optInStatus,
        triggerOptInFlow: triggerOptInFlow,
        AIOptInModal: aiOptInModal
    };
};

});
parcelRegister("guDlK", function(module, exports) {

$parcel$export(module.exports, "useProjectKey", () => $598d4d607d97d3ec$export$f87be37f8e8be65);
$parcel$export(module.exports, "useProjectContextActions", () => $598d4d607d97d3ec$export$bd73624ca941f105);
$parcel$export(module.exports, "useProjectType", () => $598d4d607d97d3ec$export$6de29d851c914935);
$parcel$export(module.exports, "useProjectContext", () => $598d4d607d97d3ec$export$8f31c2503e1efa93);
$parcel$export(module.exports, "useApplication", () => $598d4d607d97d3ec$export$aaf75bb403fe1fb5);
$parcel$export(module.exports, "useEdition", () => $598d4d607d97d3ec$export$d56c02945cf5a9e5);
$parcel$export(module.exports, "useIsSimplifiedProject", () => $598d4d607d97d3ec$export$524ef4f6102ed540);
$parcel$export(module.exports, "useIsClassicProject", () => $598d4d607d97d3ec$export$e2cf96f40a8867ce);
$parcel$export(module.exports, "useProjectId", () => $598d4d607d97d3ec$export$16d1475ed6c26568);
$parcel$export(module.exports, "useProjectStatus", () => $598d4d607d97d3ec$export$30f16f2782a4113b);
$parcel$export(module.exports, "useProjectConfiguration", () => $598d4d607d97d3ec$export$af19ad68b52fa1a6);
$parcel$export(module.exports, "useProjectIssueTypes", () => $598d4d607d97d3ec$export$80bef597b440cf71);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $3FyZ4 = parcelRequire("3FyZ4");

var $eIp1n = parcelRequire("eIp1n");
var $6WXNs = parcelRequire("6WXNs");
var $6vrw7 = parcelRequire("6vrw7");

var $gd0Sp = parcelRequire("gd0Sp");

var $lbuGg = parcelRequire("lbuGg");

var $9ZB9O = parcelRequire("9ZB9O");
const $598d4d607d97d3ec$export$f87be37f8e8be65 = (issueKey)=>(0, $6vrw7.toProjectKey)(issueKey.split('-')[0]);
const $598d4d607d97d3ec$export$bd73624ca941f105 = ()=>{
    const [, { setProjectContext: setProjectContext, mergeProjectProperty: mergeProjectProperty }] = (0, $lbuGg.useProjectContextActionStore)();
    const actions = (0, $eUqFw.useMemo)(()=>({
            setProjectContext: setProjectContext,
            mergeProjectProperty: mergeProjectProperty
        }), [
        setProjectContext,
        mergeProjectProperty
    ]);
    return [
        null,
        actions
    ];
};
const $598d4d607d97d3ec$export$6de29d851c914935 = (projectKey)=>{
    const [projectType] = (0, $lbuGg.useProjectContextProjectTypeStore)({
        projectKey: projectKey
    });
    return projectType;
};
const $598d4d607d97d3ec$export$8f31c2503e1efa93 = (projectKey)=>{
    const [projectContext] = (0, $lbuGg.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext;
};
const $598d4d607d97d3ec$export$aaf75bb403fe1fb5 = (projectKey, failSafely = false)=>{
    const projectType = $598d4d607d97d3ec$export$6de29d851c914935(projectKey);
    if (projectType === undefined) {
        if ((0, $1ybV0.ff)('ken-432-missing-project-key-log_hr7zv')) (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
            client.getInstance().sendTrackEvent({
                action: 'project-type-investigation',
                attributes: {
                    message: 'projectType was missing inside the hook'
                },
                actionSubject: 'project-context',
                source: 'project-context-service'
            });
        });
        if (failSafely) return undefined;
        throw new Error(`No project type for project key ${projectKey} in Project Context Service`);
    }
    return (0, $eIp1n.getApplicationForProject)(projectType);
};
const $598d4d607d97d3ec$export$d56c02945cf5a9e5 = (projectKey, failSafely = false)=>{
    const { appEditions: appEditions } = (0, $gd0Sp.useTenantContext)();
    const application = $598d4d607d97d3ec$export$aaf75bb403fe1fb5(projectKey, failSafely);
    if (!application) return undefined;
    return (0, $6WXNs.getEdition)(application, appEditions);
};
const $598d4d607d97d3ec$export$524ef4f6102ed540 = (projectKey)=>{
    const [projectContext] = (0, $lbuGg.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.isSimplified || false;
};
const $598d4d607d97d3ec$export$e2cf96f40a8867ce = (projectKey)=>{
    const [projectContext] = (0, $lbuGg.useProjectContextStore)({
        projectKey: projectKey
    });
    return !projectContext?.isSimplified;
};
const $598d4d607d97d3ec$export$16d1475ed6c26568 = (projectKey)=>{
    const [projectContext] = (0, $lbuGg.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.projectId;
};
const $598d4d607d97d3ec$export$30f16f2782a4113b = (projectKey)=>{
    const [projectContext] = (0, $lbuGg.useProjectContextStore)({
        projectKey: projectKey
    });
    return projectContext?.projectStatus;
};
const $598d4d607d97d3ec$export$af19ad68b52fa1a6 = (projectKey)=>{
    const projectType = $598d4d607d97d3ec$export$6de29d851c914935(projectKey);
    const isSimplified = $598d4d607d97d3ec$export$524ef4f6102ed540(projectKey);
    return (0, $9ZB9O.getIssueConfiguration)({
        isSimplified: isSimplified,
        projectType: projectType
    });
};
const $598d4d607d97d3ec$export$654dd2c557853fbe = (projectKey)=>{
    const [projectName] = (0, $lbuGg.useProjectContextProjectNameStore)({
        projectKey: projectKey
    });
    return projectName;
};
const $598d4d607d97d3ec$export$80bef597b440cf71 = (projectKey)=>{
    const [issueTypes] = (0, $lbuGg.useProjectContextIssueTypesStore)({
        projectKey: projectKey
    });
    return issueTypes;
};

});
parcelRegister("lbuGg", function(module, exports) {

$parcel$export(module.exports, "useProjectContextActionStore", () => $4715ac6bc4ce2fb7$export$9afb89c1fe103bbe);
$parcel$export(module.exports, "useProjectContextStore", () => $4715ac6bc4ce2fb7$export$8b09478b33186ec);
$parcel$export(module.exports, "useProjectContextProjectTypeStore", () => $4715ac6bc4ce2fb7$export$f2e1ed3b2b4707cb);
$parcel$export(module.exports, "useProjectContextProjectNameStore", () => $4715ac6bc4ce2fb7$export$9469fde70658518);
$parcel$export(module.exports, "useProjectContextIssueTypesStore", () => $4715ac6bc4ce2fb7$export$f73e9904779f6be5);

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $bAXOf = parcelRequire("bAXOf");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4715ac6bc4ce2fb7$var$initialState = {};
const $4715ac6bc4ce2fb7$export$6f57813fe9f31bf9 = (0, $a61MH.createStore)({
    name: 'project-context',
    initialState: $4715ac6bc4ce2fb7$var$initialState,
    actions: $bAXOf
});
const $4715ac6bc4ce2fb7$export$9afb89c1fe103bbe = (0, $ggKAj.createHook)($4715ac6bc4ce2fb7$export$6f57813fe9f31bf9, {
    selector: null
});
const $4715ac6bc4ce2fb7$var$getProjectContext = (state, { projectKey: projectKey })=>state[projectKey];
const $4715ac6bc4ce2fb7$export$8b09478b33186ec = (0, $ggKAj.createHook)($4715ac6bc4ce2fb7$export$6f57813fe9f31bf9, {
    selector: $4715ac6bc4ce2fb7$var$getProjectContext
});
const $4715ac6bc4ce2fb7$var$getProjectType = (state, { projectKey: projectKey })=>{
    const projectContext = $4715ac6bc4ce2fb7$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.projectType;
};
const $4715ac6bc4ce2fb7$export$f2e1ed3b2b4707cb = (0, $ggKAj.createHook)($4715ac6bc4ce2fb7$export$6f57813fe9f31bf9, {
    selector: $4715ac6bc4ce2fb7$var$getProjectType
});
const $4715ac6bc4ce2fb7$var$getProjectName = (state, { projectKey: projectKey })=>{
    const projectContext = $4715ac6bc4ce2fb7$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.projectName;
};
const $4715ac6bc4ce2fb7$export$9469fde70658518 = (0, $ggKAj.createHook)($4715ac6bc4ce2fb7$export$6f57813fe9f31bf9, {
    selector: $4715ac6bc4ce2fb7$var$getProjectName
});
const $4715ac6bc4ce2fb7$var$getIssueTypes = (state, { projectKey: projectKey })=>{
    const projectContext = $4715ac6bc4ce2fb7$var$getProjectContext(state, {
        projectKey: projectKey
    });
    return projectContext?.issueTypes;
};
const $4715ac6bc4ce2fb7$export$f73e9904779f6be5 = (0, $ggKAj.createHook)($4715ac6bc4ce2fb7$export$6f57813fe9f31bf9, {
    selector: $4715ac6bc4ce2fb7$var$getIssueTypes
});

});
parcelRegister("bAXOf", function(module, exports) {

$parcel$export(module.exports, "setProjectContext", () => $f8fc64b164fe014a$export$d64151aab9ae5f09);
$parcel$export(module.exports, "mergeProjectProperty", () => $f8fc64b164fe014a$export$78f1c6052937615f);
const $f8fc64b164fe014a$export$d64151aab9ae5f09 = (key, projectContext)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [key]: projectContext
        });
    };
const $f8fc64b164fe014a$export$78f1c6052937615f = (key, projectContext)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const currentProjectContext = currentState[key];
        const newProjectContext = {
            ...currentProjectContext,
            ...projectContext
        };
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [key]: newProjectContext
        });
    };

});


parcelRegister("9ZB9O", function(module, exports) {

$parcel$export(module.exports, "getIssueConfiguration", () => $78bf57e6f575c3aa$export$902f6c5cc939598a);

var $2wUFy = parcelRequire("2wUFy");

var $7ZZxN = parcelRequire("7ZZxN");
const $78bf57e6f575c3aa$export$cdbd1eb3b05729e0 = 'flagActions';
const $78bf57e6f575c3aa$export$c161a774ec2e7e56 = 'cardCoverActions';
const $78bf57e6f575c3aa$export$a52507e68e7aeeb = ()=>({
        issueActions: []
    });
const $78bf57e6f575c3aa$export$381ce08838c53afa = ()=>({
        applicationKey: (0, $2wUFy.default).CORE_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $78bf57e6f575c3aa$export$27e0678365e5dcff = ()=>({
        applicationKey: (0, $2wUFy.default).SOFTWARE_ISSUE,
        issueActions: [
            $78bf57e6f575c3aa$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $78bf57e6f575c3aa$export$aebf676dfa727a1c = ()=>({
        applicationKey: (0, $2wUFy.default).SIMPLE_SOFTWARE_BOARD,
        issueActions: [
            $78bf57e6f575c3aa$export$cdbd1eb3b05729e0,
            $78bf57e6f575c3aa$export$c161a774ec2e7e56
        ],
        ecosystemEnabled: true
    });
const $78bf57e6f575c3aa$export$1afca4d3eb6b218b = ()=>({
        applicationKey: (0, $2wUFy.default).STANDARD_ROADMAP_ISSUE,
        issueActions: [
            $78bf57e6f575c3aa$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $78bf57e6f575c3aa$export$8a060ed6f66c43b0 = ()=>({
        applicationKey: (0, $2wUFy.default).BITBUCKET_ISSUE,
        issueActions: []
    });
const $78bf57e6f575c3aa$export$78a2cb921e46f5eb = ()=>({
        applicationKey: (0, $2wUFy.default).MOBILE_ISSUE,
        issueActions: []
    });
const $78bf57e6f575c3aa$export$db1115186532f6d5 = ()=>({
        applicationKey: (0, $2wUFy.default).SERVICE_DESK,
        issueActions: [],
        ecosystemEnabled: true
    });
const $78bf57e6f575c3aa$export$902f6c5cc939598a = (config)=>{
    if (config) switch(config.projectType){
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            if (config.isSimplified) return $78bf57e6f575c3aa$export$aebf676dfa727a1c();
            return $78bf57e6f575c3aa$export$27e0678365e5dcff();
        case 0, $7ZZxN.CORE_PROJECT:
            return $78bf57e6f575c3aa$export$381ce08838c53afa();
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return $78bf57e6f575c3aa$export$db1115186532f6d5();
        default:
            // fallback to sofware config
            return $78bf57e6f575c3aa$export$27e0678365e5dcff();
    }
    return $78bf57e6f575c3aa$export$27e0678365e5dcff();
};

});
parcelRegister("2wUFy", function(module, exports) {

$parcel$export(module.exports, "default", () => $78d48529cb7f139c$export$2e2bcd8739ae039);
const $78d48529cb7f139c$var$keys = {
    CONNECT_ISSUE: 'connect-issue',
    BITBUCKET_ISSUE: 'bitbucket-issue',
    CORE_ISSUE: 'core-issue',
    MOBILE_ISSUE: 'mobile-issue',
    SIMPLE_SOFTWARE_BOARD: 'simple-software-board',
    SOFTWARE_ISSUE: 'software-issue',
    STANDARD_ROADMAP_ISSUE: 'standard-roadmap-issue',
    SERVICE_DESK: 'service-desk',
    EMPTY_APPLICATION_KEY: ''
};
var $78d48529cb7f139c$export$2e2bcd8739ae039 = $78d48529cb7f139c$var$keys;

});



parcelRegister("6dejM", function(module, exports) {

$parcel$export(module.exports, "OptInModal", () => $8791f6e76183d407$export$1697f043758ae8d2);
$parcel$export(module.exports, "OptInUpsellModal", () => $8791f6e76183d407$export$bbf8d259a508a485);

var $eUqFw = parcelRequire("eUqFw");

var $aOw1G = parcelRequire("aOw1G");
var $dxopF = parcelRequire("dxopF");

var $h5i1o = parcelRequire("h5i1o");

var $1HzcR = parcelRequire("1HzcR");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $3RDyu = parcelRequire("3RDyu");

var $feY12 = parcelRequire("feY12");
const $8791f6e76183d407$export$1697f043758ae8d2 = ({ showOptInModal: showOptInModal, onCloseModal: onCloseModal, isOrgAdmin: isOrgAdmin, adminLink: adminLink })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, showOptInModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        testId: "platform-react-hooks-use-ai-opt-in.ui.ai-modal-test",
        width: "fit-content",
        onClose: onCloseModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h5i1o.default), {
        source: "jira-editor",
        product: "jira",
        isOrgAdmin: isOrgAdmin,
        onAdminClose: onCloseModal,
        adminLink: adminLink
    })));
const $8791f6e76183d407$export$bbf8d259a508a485 = ({ showPremiumTrialModal: showPremiumTrialModal, onCloseModal: onCloseModal })=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions } = (0, $eUqFw.useContext)((0, $feY12.AIUpsellPremiumTrialEntryPointContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const runtimeProps = (0, $eUqFw.useMemo)(()=>({
            onClose: ()=>{
                entryPointActions.unload();
                const analyticsEvent = createAnalyticsEvent({
                    actionSubject: 'button',
                    action: 'clicked'
                });
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'closePremiumTrialModalFromIssueAiUpsell');
            }
        }), [
        entryPointActions,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, showPremiumTrialModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        testId: "platform-react-hooks-use-ai-opt-in.ui.ai-premium-trial-modal-test",
        width: "fit-content",
        onClose: onCloseModal
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3RDyu.AIOptInPremiumUpsell), {
        onClose: onCloseModal
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "platform-react-hooks-use-ai-opt-in.ui.ai-premium-trial-entry-point-container",
        packageName: "platform-react-hooks-use-ai-opt-in",
        runtimeProps: runtimeProps
    }));
};

});
parcelRegister("h5i1o", function(module, exports) {

$parcel$export(module.exports, "default", () => $69751517a92da055$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bFzGY = parcelRequire("bFzGY");

var $6zOB7 = parcelRequire("6zOB7");
var $fI650 = parcelRequire("fI650");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $g0Ket = parcelRequire("g0Ket");


var $6n94o = parcelRequire("6n94o");

var $8Ytlz = parcelRequire("8Ytlz");
const $69751517a92da055$var$VisibleTextOrgAdminStyles = (0, $1ZAYh.xcss)({
    color: 'color.text.subtlest',
    fontSize: '12px'
});
const $69751517a92da055$var$AiOptIn = ({ source: source, product: product, isOrgAdmin: isOrgAdmin, image: image, headerText: headerText, bodyText: bodyText, width: width, testId: testId, onAdminCTA: onAdminCTA, onAdminClose: onAdminClose, adminBodyText: adminBodyText, adminHeaderText: adminHeaderText, adminCTAText: adminCTAText, adminCloseCTAText: adminCloseCTAText, adminLink: adminLink })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onLearnMoreClicked = (e)=>{
        e.stopPropagation();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogLearnMoreLink',
                attributes: {
                    product: product,
                    isOrgAdmin: !!isOrgAdmin
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    const formatMessageValues = {
        a: (s)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                href: (0, $18ca6aaf45aebeca$export$550fac1a4ec3d365),
                target: "_blank",
                onClick: onLearnMoreClicked
            }, s),
        br: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null)
    };
    const defaultHeader = formatMessage((0, $6n94o.messages).aiOptInDialogHeaderText);
    const header = headerText ?? defaultHeader;
    const body = bodyText ?? formatMessage((0, $6n94o.messages).aiOptInDialogBodyText, formatMessageValues);
    const orgAdminBody = adminBodyText ?? formatMessage((0, $6n94o.messages).aiOptInDialogAdminBodyText, formatMessageValues);
    const orgAdminHeader = adminHeaderText ?? defaultHeader;
    (0, $eUqFw.useEffect)(()=>{
        const preloadImages = (paths)=>{
            paths.forEach((path)=>{
                const img = new Image();
                img.src = path;
            });
        };
        preloadImages([
            (0, (/*@__PURE__*/$parcel$interopDefault($g0Ket)))
        ]);
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'aiGlobalOptInDialog',
                attributes: {
                    source: source,
                    product: product,
                    isOrgAdmin: !!isOrgAdmin
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        source,
        product,
        isOrgAdmin
    ]);
    const onCloseClicked = (e)=>{
        e.stopPropagation();
        onAdminClose?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogAdminCloseButton',
                attributes: {
                    product: product
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    const onCTAClicked = (e)=>{
        e.stopPropagation();
        onAdminCTA?.();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                source: source,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'aiGlobalOptInDialogAdminCTAButton',
                attributes: {
                    product: product
                },
                tags: [
                    'fabricElements'
                ]
            }
        }).fire();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Ytlz.OptInBackgroundBorder), {
        width: width,
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Ytlz.OptInContainer), null, image ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Ytlz.ImageWrapper), null, image) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Ytlz.ImageWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($g0Ket))),
        height: "96px",
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Ytlz.ContentContainer), null, isOrgAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $69751517a92da055$var$VisibleTextOrgAdminStyles
    }, formatMessage((0, $6n94o.messages).aiOptInAdminOnlyVisible)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Ytlz.HeaderWrapper), null, isOrgAdmin ? orgAdminHeader : header), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Ytlz.BodyWrapper), {
        "data-testid": "dialog-body-text"
    }, isOrgAdmin ? orgAdminBody : body), isOrgAdmin && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Ytlz.ButtonContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        appearance: "subtle",
        onClick: onCloseClicked,
        testId: "admin-close-button"
    }, adminCloseCTAText ?? formatMessage((0, $6n94o.messages).aiOptInDialogAdminMaybeLaterButtonText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fI650.default), {
        appearance: "primary",
        onClick: onCTAClicked,
        href: adminLink ?? (0, $18ca6aaf45aebeca$export$bae9a077d7ed5dfe),
        target: "_blank",
        testId: "admin-cta-button"
    }, adminCTAText ?? formatMessage((0, $6n94o.messages).aiOptInDialogAdminGetStartedButtonText))))));
};
var $69751517a92da055$export$2e2bcd8739ae039 = $69751517a92da055$var$AiOptIn;

});
parcelRegister("g0Ket", function(module, exports) {
module.exports = new URL("global-opt-in-default-image-banner.8c1c680b.svg", import.meta.url).toString();

});

const $18ca6aaf45aebeca$export$550fac1a4ec3d365 = 'https://support.atlassian.com/organization-administration/docs/understand-atlassian-intelligence-features-in-products';
const $18ca6aaf45aebeca$export$bae9a077d7ed5dfe = 'http://admin.atlassian.com/';

parcelRegister("6n94o", function(module, exports) {

$parcel$export(module.exports, "messages", () => $6e87c7e160d5702b$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $6e87c7e160d5702b$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    /**
	 * Messages for the AI Global Opt-in component
	 */ aiOptInDialogHeaderText: {
        id: 'ai-opt-in.dialog.header.text',
        defaultMessage: 'Work smarter, not harder',
        description: 'Header text for AI Opt In Dialog'
    },
    aiOptInDialogBodyText: {
        id: 'ai-opt-in.dialog.body.text',
        defaultMessage: `Get up to speed quickly and consume information with ease using <a>Atlassian Intelligence</a> (Al). <br></br><br></br> Interested in trying Atlassian Intelligence? Your admin can activate AI features from Atlassian Administration.`,
        description: 'Body text for AI Opt In Dialog'
    },
    aiOptInDialogLearnMoreLinkText: {
        id: 'ai-opt-in.dialog.learn-more.link.text',
        defaultMessage: 'Learn more about Atlassian Intelligence',
        description: 'Learn more link text for AI Opt In Dialog'
    },
    aiOptInDialogAdminBodyText: {
        id: 'ai-opt-in.dialog.admin.body.text',
        defaultMessage: 'Get your team up to speed quickly and consume information with ease using <a>Atlassian Intelligence</a> (Al). <br></br><br></br> Activate Atlassian Intelligence features for your users from Atlassian Administration.',
        description: 'Body text for Admin version of AI Opt In Dialog'
    },
    aiOptInDialogAdminMaybeLaterButtonText: {
        id: 'ai-opt-in.dialog.admin.maybe-later.button.text',
        defaultMessage: 'Maybe later',
        description: 'Admin maybe later button text'
    },
    aiOptInDialogAdminGetStartedButtonText: {
        id: 'ai-opt-in.dialog.admin.get-started.button.text',
        defaultMessage: 'Get started',
        description: 'Admin get started button text'
    },
    aiOptInBannerBodyText: {
        id: 'ai-opt-in.banner.body.text',
        defaultMessage: "Work smarter, not harder. Express your interest in Atlassian Intelligence so your admin knows you\u2019d like them to activate it.",
        description: 'Body text for Banner version of AI Opt In Dialog'
    },
    aiOptInBannerLearnMoreText: {
        id: 'ai-opt-in.banner.learn.more.text',
        defaultMessage: 'Learn more',
        description: 'Learn more text for Banner cta of AI Opt In Dialog'
    },
    aiOptInAdminBannerBodyText: {
        id: 'ai-opt-in.banner.admin.body.text',
        defaultMessage: 'Get everyone up to speed quickly and consume information with ease. Turn on <a>Atlassian Intelligence</a> features for your users from Atlassian Administration.',
        description: 'Body text for Admin version of the Banner Ai Opt In'
    },
    aiOptInAdminOnlyVisible: {
        id: 'ai-opt-in.admin.only.visible.text',
        defaultMessage: 'This message is only visible to org admins.',
        description: 'Text message to let org admins know that the content is only visible to them.'
    }
});

});

parcelRegister("8Ytlz", function(module, exports) {

$parcel$export(module.exports, "OptInBackgroundBorder", () => $2ed1514d8fdcb329$export$24c280970213bb11);
$parcel$export(module.exports, "OptInContainer", () => $2ed1514d8fdcb329$export$a0fab83bea8ccf2e);
$parcel$export(module.exports, "ImageWrapper", () => $2ed1514d8fdcb329$export$75f07c36086c2c81);
$parcel$export(module.exports, "ContentContainer", () => $2ed1514d8fdcb329$export$9d2b4227a95687cc);
$parcel$export(module.exports, "HeaderWrapper", () => $2ed1514d8fdcb329$export$960a49cc3d27a090);
$parcel$export(module.exports, "BodyWrapper", () => $2ed1514d8fdcb329$export$14966827497f4695);
$parcel$export(module.exports, "ButtonContainer", () => $2ed1514d8fdcb329$export$eddf54ea3db8d0f0);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");
const $2ed1514d8fdcb329$export$24c280970213bb11 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1vcp0mh": (0, $9t7rW.default)(__cmplp.width, "px")
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _16qs1o46 _2rko14y2 _1yt4v77o _kqswh2mm _11q71lxv",
            __cmplp.width ? "_1bsb1efm" : "_1bsbkbql",
            __cmplp.className
        ])
    });
});
const $2ed1514d8fdcb329$export$a0fab83bea8ccf2e = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1l7b _1e0c1txw _2lx21bp4 _bfhk1bhr",
            __cmplp.className
        ])
    });
});
const $2ed1514d8fdcb329$export$75f07c36086c2c81 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1k7a _1e0c1txw _1jpx1dfr _mezj1osq _1biu1k7a",
            __cmplp.className
        ])
    });
});
const $2ed1514d8fdcb329$export$9d2b4227a95687cc = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1yt41ejb _2lx21bp4 _1wpz1fhb _zulpu2gc _4cvr1y6m",
            __cmplp.className
        ])
    });
});
const $2ed1514d8fdcb329$export$960a49cc3d27a090 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48pni7l _1wyb7vkz _vwz4gktf",
            __cmplp.className
        ])
    });
});
const $2ed1514d8fdcb329$export$14966827497f4695 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wybdlk8 _vwz4gktf",
            __cmplp.className
        ])
    });
});
const $2ed1514d8fdcb329$export$eddf54ea3db8d0f0 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb1osq _19pku2gc _1bahesu3 _zulp1b66",
            __cmplp.className
        ])
    });
});

});


parcelRegister("3RDyu", function(module, exports) {

$parcel$export(module.exports, "AIOptInPremiumUpsell", () => $70fc8b4331cd3e90$export$54e4ba490d2c6bb5);

var $eUqFw = parcelRequire("eUqFw");

var $j9fWg = parcelRequire("j9fWg");

var $hI5oG = parcelRequire("hI5oG");

var $je5kZ = parcelRequire("je5kZ");

var $cnPHV = parcelRequire("cnPHV");
var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");
var $1zbEq = parcelRequire("1zbEq");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $iFqEI = parcelRequire("iFqEI");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $jXPnZ = parcelRequire("jXPnZ");

var $HJoC3 = parcelRequire("HJoC3");
const $70fc8b4331cd3e90$export$54e4ba490d2c6bb5 = ({ onClose: onClose })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            actionSubject: 'screen',
            action: 'viewed'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'IssueAiUpsellDialog');
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $70fc8b4331cd3e90$var$containerBorderStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        alignBlock: "stretch",
        xcss: $70fc8b4331cd3e90$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignInline: "end",
        grow: "fill",
        xcss: $70fc8b4331cd3e90$var$headerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
        appearance: "subtle",
        onClick: onClose,
        label: formatMessage((0, $jXPnZ.messages).closeModal),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($je5kZ)))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cnPHV.default), {
        all: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFqEI.default), {
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        alignInline: "stretch",
        space: "space.200",
        xcss: $70fc8b4331cd3e90$var$textContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "medium",
        as: "h2"
    }, formatMessage((0, $jXPnZ.messages).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1Yimi.default), {
        as: "p"
    }, formatMessage((0, $jXPnZ.messages).body)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        alignInline: "end",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $HJoC3.StartPremiumTrialButton), {
        onCloseParent: onClose
    })))));
};
const $70fc8b4331cd3e90$var$containerBorderStyles = (0, $1ZAYh.xcss)({
    overflow: 'hidden',
    boxShadow: 'elevation.shadow.overlay',
    borderRadius: 'border.radius',
    width: '438px',
    position: 'relative',
    padding: 'space.025',
    background: `linear-gradient(
      112.4deg,
      ${`var(--ds-background-accent-blue-subtle, ${(0, $PdmhA.B400)})`} 0%,
      ${`var(--ds-background-accent-purple-subtle, ${(0, $PdmhA.P400)})`} 100%
    )`
});
const $70fc8b4331cd3e90$var$containerStyles = (0, $1ZAYh.xcss)({
    borderRadius: 'border.radius',
    backgroundColor: 'elevation.surface.overlay',
    overflow: 'hidden'
});
const $70fc8b4331cd3e90$var$headerStyles = (0, $1ZAYh.xcss)({
    position: 'absolute',
    padding: 'space.075',
    right: 'space.025'
});
const $70fc8b4331cd3e90$var$textContainerStyles = (0, $1ZAYh.xcss)({
    padding: 'space.300'
});

});
parcelRegister("iFqEI", function(module, exports) {

$parcel$export(module.exports, "default", () => $701c171f732e62a2$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md

var $9TZf5 = parcelRequire("9TZf5");

var $6W3m3 = parcelRequire("6W3m3");

var $58c3C = parcelRequire("58c3C");
const $701c171f732e62a2$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($58c3C)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($6W3m3))
});
var $701c171f732e62a2$export$2e2bcd8739ae039 = $701c171f732e62a2$var$Illustration;
// for advanced use only
const $701c171f732e62a2$export$a179c88182cb9d56 = [
    0,
    0,
    438,
    96
];

});
parcelRegister("9TZf5", function(module, exports) {

$parcel$export(module.exports, "Illustration", () => $a7efac7c92ef32a3$export$d43c2e2ca9b2c105);
$parcel$export(module.exports, "createIllustration", () => $a7efac7c92ef32a3$export$4d00e7be716a0093);

var $eUqFw = parcelRequire("eUqFw");

var $evtC7 = parcelRequire("evtC7");
function $a7efac7c92ef32a3$export$d43c2e2ca9b2c105({ embedAs: embedAs, ...props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $evtC7.AsImg), props);
}
function $a7efac7c92ef32a3$export$4d00e7be716a0093({ srcLight: srcLight, srcDark: srcDark, autoDark: autoDark }) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a7efac7c92ef32a3$export$d43c2e2ca9b2c105, {
            srcLight: srcLight,
            srcDark: srcDark,
            autoDark: autoDark,
            ...props
        });
}

});
parcelRegister("evtC7", function(module, exports) {

$parcel$export(module.exports, "AsImg", () => $e7036c28dfac32f8$export$75e378065cb7d6c0);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // This is an INTENTIONAL FORK of @atlaskit/image
// copied 2023-11-09 v1.1.6
// with permission from @DDC from Design System,
// in order to refine the API and use cases.
// Will be back-ported to @atlaskit/image https://hello.atlassian.net/browse/ERAI-1660

var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $4q38b = parcelRequire("4q38b");
// suggested defaults, the consumer is free to override
const $e7036c28dfac32f8$var$defaultStyles = null;
const $e7036c28dfac32f8$var$fillStyles = null;
const $e7036c28dfac32f8$var$autoDarkModeStyles = null;
function $e7036c28dfac32f8$export$75e378065cb7d6c0({ srcLight: srcLight, srcDark: srcDark = srcLight, autoDark: autoDark = true, alt: alt, fill: fill = false, testId: testId, ...imgProps }) {
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        src: colorMode === 'dark' ? srcDark : srcLight,
        alt: alt,
        "data-testid": testId,
        ...imgProps,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _tvdr18uv _p12f1osq _4t3i1wug _5ral1f51 _rsuf1h6o",
            fill && "_kqswstnw _1r04idpf _1bsb1osq _4t3i1osq",
            colorMode === 'dark' && srcDark === srcLight && autoDark && "_kdam1ato"
        ])
    });
}

});


parcelRegister("6W3m3", function(module, exports) {
module.exports = new URL("ai-chat-loading-promoted-darkmode.f2ea2011.svg", import.meta.url).toString();

});

parcelRegister("58c3C", function(module, exports) {
module.exports = new URL("ai-chat-loading-promoted.9a9a0213.svg", import.meta.url).toString();

});


parcelRegister("jXPnZ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $97776fe612de153a$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $97776fe612de153a$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.title",
        "defaultMessage": "Write better, work faster with Atlassian Intelligence"
    },
    body: {
        "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.body",
        "defaultMessage": "Use AI to brainstorm, summarize, change tone, edit and more, with Jira Premium."
    },
    closeModal: {
        "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.close-modal",
        "defaultMessage": "Close Modal"
    },
    tryItFreeButton: {
        "id": "platform-react-hooks-use-ai-opt-in.ai-opt-in-premium-upsell-modal.try-it-free-button",
        "defaultMessage": "Try it free"
    }
});

});

parcelRegister("HJoC3", function(module, exports) {

$parcel$export(module.exports, "StartPremiumTrialButton", () => $fe79884346a2c282$export$a2651a739f515dd4);

var $eUqFw = parcelRequire("eUqFw");

var $bbaTG = parcelRequire("bbaTG");

var $1n6uL = parcelRequire("1n6uL");

var $PdmhA = parcelRequire("PdmhA");

var $l3Qg0 = parcelRequire("l3Qg0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $feY12 = parcelRequire("feY12");

var $jXPnZ = parcelRequire("jXPnZ");
const $fe79884346a2c282$export$a2651a739f515dd4 = ({ onCloseParent: onCloseParent })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { entryPointActions: entryPointActions } = (0, $eUqFw.useContext)((0, $feY12.AIUpsellPremiumTrialEntryPointContext));
    const triggerRef = (0, $l3Qg0.useEntryPointButtonTrigger)(entryPointActions);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onClickAnalytics = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            actionSubject: 'button',
            action: 'clicked'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'openPremiumTrialModalFromIssueAiUpsell');
    }, [
        createAnalyticsEvent
    ]);
    const onClick = ()=>{
        // Nb. premium trial modal open is handled by entry point via ref
        onCloseParent && onCloseParent();
        onClickAnalytics();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        onClick: onClick,
        ref: triggerRef,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1n6uL))), {
            size: "small",
            label: "",
            primaryColor: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`
        }),
        theme: (current, themeProps)=>({
                buttonStyles: {
                    ...current(themeProps).buttonStyles,
                    display: 'flex',
                    alignItems: 'center',
                    background: `linear-gradient(135deg, ${"var(--ds-background-discovery-bold, #6E5DC6)"}, ${"var(--ds-background-brand-bold, #0C66E4)"})`,
                    color: `var(--ds-text-inverse, ${(0, $PdmhA).N0})`,
                    outline: 'none',
                    boxSizing: 'border-box',
                    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"}`,
                    borderRadius: "var(--ds-space-050, 4px)",
                    height: "var(--ds-space-400, 32px)",
                    border: 'none',
                    fontSize: '14px',
                    gap: "var(--ds-space-025, 2px)"
                },
                spinnerStyles: current(themeProps).spinnerStyles
            })
    }, formatMessage((0, $jXPnZ.messages).tryItFreeButton));
};

});
parcelRegister("l3Qg0", function(module, exports) {

$parcel$export(module.exports, "useEntryPointButtonTrigger", () => $c6e813dbc513f02a$export$25d2524a63315ed);
$parcel$export(module.exports, "getDefaultEntrypointActionEventMap", () => $c6e813dbc513f02a$export$5f13515bd3a35325);

var $eUqFw = parcelRequire("eUqFw");

var $a9frS = parcelRequire("a9frS");
const $c6e813dbc513f02a$export$25d2524a63315ed = (actions, isActive = true, eventMap = $c6e813dbc513f02a$export$5f13515bd3a35325(actions))=>{
    const removePreviousListeners = (0, $eUqFw.useRef)(null);
    const isMounted = (0, $eUqFw.useRef)(true);
    (0, $eUqFw.useEffect)(()=>()=>{
            removePreviousListeners.current?.();
            removePreviousListeners.current = null;
            isMounted.current = false;
        }, []);
    return (0, $eUqFw.useCallback)((element)=>{
        if (!isMounted.current) return;
        removePreviousListeners.current?.();
        if (element && isActive) {
            (0, $a9frS.modifyListeners)({
                element: element,
                operationName: 'add',
                eventMap: eventMap
            });
            removePreviousListeners.current = ()=>{
                (0, $a9frS.modifyListeners)({
                    element: element,
                    operationName: 'remove',
                    eventMap: eventMap
                });
            };
        } else removePreviousListeners.current = null;
    }, [
        eventMap,
        isActive
    ]);
};
const $c6e813dbc513f02a$export$5f13515bd3a35325 = (actions)=>({
        click: actions.load,
        mouseenter: actions.preload,
        mouseleave: actions.cancelPreload,
        focusin: actions.preload,
        focusout: actions.cancelPreload
    });

});
parcelRegister("a9frS", function(module, exports) {

$parcel$export(module.exports, "modifyListeners", () => $592b51d0c18fde03$export$15257a36a7e3f9d6);
function $592b51d0c18fde03$export$15257a36a7e3f9d6(params) {
    const { element: element, operationName: operationName, eventMap: eventMap } = params;
    const functionName = operationName === 'add' ? 'addEventListener' : 'removeEventListener';
    if (element) Object.keys(eventMap).forEach((eventName)=>element[functionName](eventName, eventMap[eventName]));
}

});


parcelRegister("feY12", function(module, exports) {

$parcel$export(module.exports, "AIUpsellPremiumTrialEntryPointContext", () => $f717b66909f6070e$export$77aa5ca661b0742c);
$parcel$export(module.exports, "AIUpsellPremiumTrialEntryPointContextProvider", () => $f717b66909f6070e$export$dd0a751f23b19473);

var $eUqFw = parcelRequire("eUqFw");

var $gRxol = parcelRequire("gRxol");
var $6j4bv = parcelRequire("6j4bv");

var $6PHwo = parcelRequire("6PHwo");
const $f717b66909f6070e$export$77aa5ca661b0742c = (0, $gRxol.createUseEntryPointContext)();
const $f717b66909f6070e$export$dd0a751f23b19473 = ({ children: children })=>{
    const entryPointParams = {};
    const entryPointResult = (0, $6j4bv.useEntryPoint)((0, $6PHwo.entryPointPremiumUpgradeModal), entryPointParams);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f717b66909f6070e$export$77aa5ca661b0742c.Provider, {
        value: entryPointResult
    }, children);
};

});
parcelRegister("gRxol", function(module, exports) {

$parcel$export(module.exports, "createUseEntryPointContext", () => $1835b430d1386e11$export$41bce2223126846b);

var $eUqFw = parcelRequire("eUqFw");
const $1835b430d1386e11$export$41bce2223126846b = ()=>/*#__PURE__*/ (0, $eUqFw.createContext)({
        entryPointActions: {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            cancelPreload () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            load () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            preload () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            unload () {}
        },
        entryPointReferenceSubject: {
            getValue: ()=>null,
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            subscribe: ()=>()=>{}
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        stopMetric () {}
    });

});

parcelRegister("6PHwo", function(module, exports) {

$parcel$export(module.exports, "entryPointPremiumUpgradeModal", () => $4cf7dc0dcae42bfd$export$7116d5b1a93db8d6);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $4cf7dc0dcae42bfd$export$7116d5b1a93db8d6 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("5E5Y2")).then((module)=>module.PremiumUpgradeModalEntryPoint), {
        moduleId: "1102b440"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("5E5Y2", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('hPzOn'),
            load('896rB')
        ]);
        const value = parcelRequire('6l8MW');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("hPzOn"),
        load("896rB")
    ]).then(()=>parcelRequire('6l8MW'));
}

});








parcelRegister("huDma", function(module, exports) {

$parcel$export(module.exports, "convertWikiToAdf", () => $a1dc261b23361a02$export$3dfdef94497f0395);

var $9wcjJ = parcelRequire("9wcjJ");

var $3M3qX = parcelRequire("3M3qX");

var $fjUC0 = parcelRequire("fjUC0");
const $a1dc261b23361a02$var$wikiTransformer = new (0, $fjUC0.WikiMarkupTransformer)((0, $9wcjJ.defaultSchema));
const $a1dc261b23361a02$var$adfTransformer = new (0, $3M3qX.JSONTransformer)();
const $a1dc261b23361a02$export$3dfdef94497f0395 = (wiki)=>{
    if (wiki === null || wiki === undefined || wiki === '') return null;
    const pmNode = $a1dc261b23361a02$var$wikiTransformer.parse(wiki);
    return $a1dc261b23361a02$var$adfTransformer.encode(pmNode);
};

});
parcelRegister("fjUC0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "WikiMarkupTransformer", () => $d2f4372eeee3db21$export$caaa00407b56b900);
$parcel$export(module.exports, "default", () => $d2f4372eeee3db21$export$2e2bcd8739ae039);

var $9wcjJ = parcelRequire("9wcjJ");

var $jX0ky = parcelRequire("jX0ky");

var $ZkOGW = parcelRequire("ZkOGW");

var $4RTci = parcelRequire("4RTci");
class $d2f4372eeee3db21$export$caaa00407b56b900 {
    constructor(schema = (0, $9wcjJ.defaultSchema)){
        this.schema = schema;
    }
    // [ADFS-725] Jira breaks if there are null chars it is easier to remove them here
    // The following has to be a regex to remove all instances of null instead of the first
    sanitizeWikiMarkup(wikiMarkup) {
        return wikiMarkup.replace(/\0/g, '');
    }
    encode(node, context) {
        const wikiMarkup = (0, $jX0ky.encode)(node, $d2f4372eeee3db21$var$normalizeContextObject(context));
        // [ADFS-725] Jira breaks if there are null chars it is easier to remove them here
        const sanitizedWikiMarkup = this.sanitizeWikiMarkup(wikiMarkup);
        return sanitizedWikiMarkup;
    }
    parse(wikiMarkup, context) {
        // [ADFS-725] Jira breaks if there are null chars it is easier to remove them here
        const sanitizedWikiMarkup = this.sanitizeWikiMarkup(wikiMarkup);
        const tree = new (0, $ZkOGW.default)(this.schema, sanitizedWikiMarkup);
        return tree.getProseMirrorModel(this.buildContext($d2f4372eeee3db21$var$normalizeContextObject(context)));
    }
    buildContext(context) {
        return context ? {
            ...context,
            issueKeyRegex: context.conversion ? (0, $4RTci.buildIssueKeyRegex)(context.conversion.inlineCardConversion) : undefined
        } : {};
    }
}
/**
 * Turns mentionConversion object keys to lowercase for case insensitivity matching
 * This is okay, because conversion context object contains mapping and that should be case insensitive
 */ const $d2f4372eeee3db21$var$normalizeContextObject = (context)=>{
    if (!context || !context.conversion || !context.conversion.mentionConversion) // nothing to normalize, return original object
    return context;
    const mentionConversion = {};
    for(const key in context.conversion.mentionConversion)mentionConversion[key.toLowerCase()] = context.conversion.mentionConversion[key];
    context.conversion.mentionConversion = mentionConversion;
    return context;
};
var $d2f4372eeee3db21$export$2e2bcd8739ae039 = $d2f4372eeee3db21$export$caaa00407b56b900;

});
parcelRegister("jX0ky", function(module, exports) {

$parcel$export(module.exports, "encode", () => $0118487698e57bdb$export$c564cdbbe6da493);

var $1LRwS = parcelRequire("1LRwS");

var $axYPX = parcelRequire("axYPX");

var $7Risu = parcelRequire("7Risu");

var $9q3yb = parcelRequire("9q3yb");

var $433DX = parcelRequire("433DX");

var $lPxCD = parcelRequire("lPxCD");

var $7rqfg = parcelRequire("7rqfg");

var $haHCt = parcelRequire("haHCt");

var $9PdIu = parcelRequire("9PdIu");

var $hR5ia = parcelRequire("hR5ia");

var $kbkiv = parcelRequire("kbkiv");

var $gKQAY = parcelRequire("gKQAY");

var $cYioR = parcelRequire("cYioR");

var $ikdnB = parcelRequire("ikdnB");

var $lHJNe = parcelRequire("lHJNe");

var $dMxC6 = parcelRequire("dMxC6");

var $fSqxZ = parcelRequire("fSqxZ");

var $kYj1v = parcelRequire("kYj1v");

var $5DckW = parcelRequire("5DckW");
const $0118487698e57bdb$var$nodeEncoderMapping = {
    blockquote: $1LRwS.blockquote,
    bulletList: $axYPX.bulletList,
    taskList: $7Risu.taskList,
    decisionList: $9q3yb.decisionList,
    codeBlock: $433DX.codeBlock,
    doc: $lPxCD.doc,
    heading: $haHCt.heading,
    caption: $5DckW.caption,
    mediaGroup: $9PdIu.mediaGroup,
    mediaInline: $hR5ia.mediaInline,
    mediaSingle: (0, $9PdIu.mediaGroup),
    orderedList: $kbkiv.orderedList,
    panel: $gKQAY.panel,
    paragraph: $cYioR.paragraph,
    rule: $ikdnB.rule,
    table: $lHJNe.table,
    blockCard: $fSqxZ.blockCard,
    embedCard: $kYj1v.embedCard,
    expand: $7rqfg.expand
};
function $0118487698e57bdb$export$c564cdbbe6da493(node, context) {
    const encoder = $0118487698e57bdb$var$nodeEncoderMapping[node.type.name];
    try {
        if (encoder) return encoder(node, {
            context: context
        });
        return (0, $dMxC6.unknown)(node);
    } catch (err) {
        return (0, $dMxC6.unknown)(node);
    }
}

});
parcelRegister("1LRwS", function(module, exports) {

$parcel$export(module.exports, "blockquote", () => $539cef29ce13843d$export$67dc04e652a298ca);

var $jX0ky = parcelRequire("jX0ky");
const $539cef29ce13843d$export$67dc04e652a298ca = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $jX0ky.encode)(n, context));
    });
    return `{quote}${result.join('\n\n')}{quote}`;
};

});

parcelRegister("axYPX", function(module, exports) {

$parcel$export(module.exports, "bulletList", () => $9871651c83f0f72e$export$a140c94e5ea26bee);

var $aTpvz = parcelRequire("aTpvz");
const $9871651c83f0f72e$export$a140c94e5ea26bee = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((item)=>{
        result.push((0, $aTpvz.listItem)(item, '*', context));
    });
    return result.join('\n');
};

});
parcelRegister("aTpvz", function(module, exports) {

$parcel$export(module.exports, "listItem", () => $b12a5511f73aed40$export$76c7e83ecc9cdf05);

var $jX0ky = parcelRequire("jX0ky");

var $cYioR = parcelRequire("cYioR");

var $dMxC6 = parcelRequire("dMxC6");

var $433DX = parcelRequire("433DX");

var $9PdIu = parcelRequire("9PdIu");

var $hR5ia = parcelRequire("hR5ia");
const $b12a5511f73aed40$export$76c7e83ecc9cdf05 = (node, prefix, context)=>{
    const result = [];
    let contentBuffer = [];
    node.forEach((n)=>{
        switch(n.type.name){
            case 'paragraph':
                contentBuffer.push((0, $cYioR.paragraph)(n, {
                    context: context
                }));
                break;
            case 'bulletList':
            case 'orderedList':
                {
                    if (contentBuffer.length) {
                        result.push(`${prefix} ${contentBuffer.join('\n')}`);
                        contentBuffer = [];
                    }
                    const nestedList = (0, $jX0ky.encode)(n, context).split('\n').map((line)=>{
                        if ([
                            '#',
                            '*'
                        ].indexOf(line.substr(0, 1)) !== -1) return `${prefix}${line}`;
                        return line;
                    }).join('\n');
                    result.push(nestedList);
                    break;
                }
            case 'codeBlock':
                contentBuffer.push((0, $433DX.codeBlock)(n));
                break;
            case 'mediaInline':
                contentBuffer.push((0, $hR5ia.mediaInline)(n, {
                    context: context
                }));
                break;
            case 'mediaSingle':
                // mediaSingle and mediaGroup are holding the same conversion logic
                contentBuffer.push((0, $9PdIu.mediaGroup)(n, {
                    context: context
                }));
                break;
            default:
                contentBuffer.push((0, $dMxC6.unknown)(n));
        }
    });
    if (contentBuffer.length) result.push(`${prefix} ${contentBuffer.join('\n')}`);
    return result.join('\n');
};

});
parcelRegister("cYioR", function(module, exports) {

$parcel$export(module.exports, "paragraph", () => $3a8fdb87076b70f9$export$9c206ddddb32a9b);

var $8wJH0 = parcelRequire("8wJH0");
const $3a8fdb87076b70f9$export$9c206ddddb32a9b = (node, { context: context } = {})=>{
    let result = '';
    node.forEach((n)=>{
        result += (0, $8wJH0.inlines)(n, {
            context: context
        });
    });
    return result;
};

});
parcelRegister("8wJH0", function(module, exports) {

$parcel$export(module.exports, "inlines", () => $fe5949771c5d8168$export$96c94bfc00b85760);

var $3TwFx = parcelRequire("3TwFx");

var $7iOup = parcelRequire("7iOup");

var $hR5ia = parcelRequire("hR5ia");

var $6iCyo = parcelRequire("6iCyo");

var $k7Yq1 = parcelRequire("k7Yq1");

var $JPiHV = parcelRequire("JPiHV");

var $2wGmw = parcelRequire("2wGmw");

var $dMxC6 = parcelRequire("dMxC6");

var $fUy1V = parcelRequire("fUy1V");
const $fe5949771c5d8168$var$inlinesEncoderMapping = {
    emoji: $3TwFx.emoji,
    hardBreak: $7iOup.hardBreak,
    mediaInline: $hR5ia.mediaInline,
    mention: $6iCyo.mention,
    text: $k7Yq1.text,
    inlineCard: $JPiHV.inlineCard,
    status: $2wGmw.status,
    date: $fUy1V.date
};
const $fe5949771c5d8168$export$96c94bfc00b85760 = (node, opts)=>{
    const encoder = $fe5949771c5d8168$var$inlinesEncoderMapping[node.type.name];
    if (encoder) return encoder(node, opts);
    return (0, $dMxC6.unknown)(node);
};

});
parcelRegister("3TwFx", function(module, exports) {

$parcel$export(module.exports, "emoji", () => $169df1ce930d44d5$export$a19185d1233fc4b2);

var $gvgya = parcelRequire("gvgya");

var $dMxC6 = parcelRequire("dMxC6");
const $169df1ce930d44d5$export$a19185d1233fc4b2 = (node)=>{
    const value = (0, $gvgya.mapping)[node.attrs.id];
    if (value) return value;
    if (node.attrs.shortName) return node.attrs.shortName;
    return (0, $dMxC6.unknown)(node);
};

});
parcelRegister("gvgya", function(module, exports) {

$parcel$export(module.exports, "mapping", () => $b2b613d050f55ecb$export$83e1f26587c4acd2);
const $b2b613d050f55ecb$export$83e1f26587c4acd2 = {
    '1f600': "\uD83D\uDE00",
    '1f603': "\uD83D\uDE03",
    '1f604': "\uD83D\uDE04",
    '1f601': "\uD83D\uDE01",
    '1f606': "\uD83D\uDE06",
    '1f605': "\uD83D\uDE05",
    '1f602': "\uD83D\uDE02",
    '1f923': "\uD83E\uDD23",
    '263a': "\u263A\uFE0F",
    '1f60a': "\uD83D\uDE0A",
    '1f607': "\uD83D\uDE07",
    '1f642': "\uD83D\uDE42",
    '1f643': "\uD83D\uDE43",
    '1f609': "\uD83D\uDE09",
    '1f60c': "\uD83D\uDE0C",
    '1f60d': "\uD83D\uDE0D",
    '1f618': "\uD83D\uDE18",
    '1f617': "\uD83D\uDE17",
    '1f619': "\uD83D\uDE19",
    '1f61a': "\uD83D\uDE1A",
    '1f60b': "\uD83D\uDE0B",
    '1f61c': "\uD83D\uDE1C",
    '1f61d': "\uD83D\uDE1D",
    '1f61b': "\uD83D\uDE1B",
    '1f911': "\uD83E\uDD11",
    '1f917': "\uD83E\uDD17",
    '1f913': "\uD83E\uDD13",
    '1f60e': "\uD83D\uDE0E",
    '1f921': "\uD83E\uDD21",
    '1f920': "\uD83E\uDD20",
    '1f60f': "\uD83D\uDE0F",
    '1f612': "\uD83D\uDE12",
    '1f61e': "\uD83D\uDE1E",
    '1f614': "\uD83D\uDE14",
    '1f61f': "\uD83D\uDE1F",
    '1f615': "\uD83D\uDE15",
    '1f641': "\uD83D\uDE41",
    '2639': "\u2639\uFE0F",
    '1f623': "\uD83D\uDE23",
    '1f616': "\uD83D\uDE16",
    '1f62b': "\uD83D\uDE2B",
    '1f629': "\uD83D\uDE29",
    '1f624': "\uD83D\uDE24",
    '1f620': "\uD83D\uDE20",
    '1f621': "\uD83D\uDE21",
    '1f636': "\uD83D\uDE36",
    '1f610': "\uD83D\uDE10",
    '1f611': "\uD83D\uDE11",
    '1f62f': "\uD83D\uDE2F",
    '1f626': "\uD83D\uDE26",
    '1f627': "\uD83D\uDE27",
    '1f62e': "\uD83D\uDE2E",
    '1f632': "\uD83D\uDE32",
    '1f635': "\uD83D\uDE35",
    '1f633': "\uD83D\uDE33",
    '1f631': "\uD83D\uDE31",
    '1f628': "\uD83D\uDE28",
    '1f630': "\uD83D\uDE30",
    '1f622': "\uD83D\uDE22",
    '1f625': "\uD83D\uDE25",
    '1f924': "\uD83E\uDD24",
    '1f62d': "\uD83D\uDE2D",
    '1f613': "\uD83D\uDE13",
    '1f62a': "\uD83D\uDE2A",
    '1f634': "\uD83D\uDE34",
    '1f644': "\uD83D\uDE44",
    '1f914': "\uD83E\uDD14",
    '1f925': "\uD83E\uDD25",
    '1f62c': "\uD83D\uDE2C",
    '1f910': "\uD83E\uDD10",
    '1f922': "\uD83E\uDD22",
    '1f927': "\uD83E\uDD27",
    '1f637': "\uD83D\uDE37",
    '1f912': "\uD83E\uDD12",
    '1f915': "\uD83E\uDD15",
    '1f608': "\uD83D\uDE08",
    '1f47f': "\uD83D\uDC7F",
    '1f479': "\uD83D\uDC79",
    '1f47a': "\uD83D\uDC7A",
    '1f4a9': "\uD83D\uDCA9",
    '1f47b': "\uD83D\uDC7B",
    '1f480': "\uD83D\uDC80",
    '2620': "\u2620\uFE0F",
    '1f47d': "\uD83D\uDC7D",
    '1f47e': "\uD83D\uDC7E",
    '1f916': "\uD83E\uDD16",
    '1f383': "\uD83C\uDF83",
    '1f63a': "\uD83D\uDE3A",
    '1f638': "\uD83D\uDE38",
    '1f639': "\uD83D\uDE39",
    '1f63b': "\uD83D\uDE3B",
    '1f63c': "\uD83D\uDE3C",
    '1f63d': "\uD83D\uDE3D",
    '1f640': "\uD83D\uDE40",
    '1f63f': "\uD83D\uDE3F",
    '1f63e': "\uD83D\uDE3E",
    '1f450': "\uD83D\uDC50",
    '1f64c': "\uD83D\uDE4C",
    '1f44f': "\uD83D\uDC4F",
    '1f64f': "\uD83D\uDE4F",
    '1f91d': "\uD83E\uDD1D",
    '1f44d': "\uD83D\uDC4D",
    '1f44e': "\uD83D\uDC4E",
    '1f44a': "\uD83D\uDC4A",
    '270a': "\u270A",
    '1f91b': "\uD83E\uDD1B",
    '1f91c': "\uD83E\uDD1C",
    '1f91e': "\uD83E\uDD1E",
    '270c': "\u270C\uFE0F",
    '1f918': "\uD83E\uDD18",
    '1f44c': "\uD83D\uDC4C",
    '1f448': "\uD83D\uDC48",
    '1f449': "\uD83D\uDC49",
    '1f446': "\uD83D\uDC46",
    '1f447': "\uD83D\uDC47",
    '261d': "\u261D\uFE0F",
    '270b': "\u270B",
    '1f91a': "\uD83E\uDD1A",
    '1f590': "\uD83D\uDD90\uFE0F",
    '1f596': "\uD83D\uDD96",
    '1f44b': "\uD83D\uDC4B",
    '1f919': "\uD83E\uDD19",
    '1f4aa': "\uD83D\uDCAA",
    '1f595': "\uD83D\uDD95",
    '270d': "\u270D\uFE0F",
    '1f933': "\uD83E\uDD33",
    '1f485': "\uD83D\uDC85",
    '1f48d': "\uD83D\uDC8D",
    '1f484': "\uD83D\uDC84",
    '1f48b': "\uD83D\uDC8B",
    '1f444': "\uD83D\uDC44",
    '1f445': "\uD83D\uDC45",
    '1f442': "\uD83D\uDC42",
    '1f443': "\uD83D\uDC43",
    '1f463': "\uD83D\uDC63",
    '1f441': "\uD83D\uDC41\uFE0F",
    '1f440': "\uD83D\uDC40",
    '1f5e3': "\uD83D\uDDE3\uFE0F",
    '1f464': "\uD83D\uDC64",
    '1f465': "\uD83D\uDC65",
    '1f476': "\uD83D\uDC76",
    '1f466': "\uD83D\uDC66",
    '1f467': "\uD83D\uDC67",
    '1f468': "\uD83D\uDC68",
    '1f469': "\uD83D\uDC69",
    '1f471-200d-2640-fe0f': "\uD83D\uDC71\u200D\u2640\uFE0F",
    '1f471': "\uD83D\uDC71",
    '1f471-200d-2642-fe0f': "\uD83D\uDC71\u200D\u2642\uFE0F",
    '1f474': "\uD83D\uDC74",
    '1f475': "\uD83D\uDC75",
    '1f472': "\uD83D\uDC72",
    '1f473-200d-2640-fe0f': "\uD83D\uDC73\u200D\u2640\uFE0F",
    '1f473': "\uD83D\uDC73",
    '1f473-200d-2642-fe0f': "\uD83D\uDC73\u200D\u2642\uFE0F",
    '1f46e-200d-2640-fe0f': "\uD83D\uDC6E\u200D\u2640\uFE0F",
    '1f46e': "\uD83D\uDC6E",
    '1f46e-200d-2642-fe0f': "\uD83D\uDC6E\u200D\u2642\uFE0F",
    '1f477-200d-2640-fe0f': "\uD83D\uDC77\u200D\u2640\uFE0F",
    '1f477': "\uD83D\uDC77",
    '1f477-200d-2642-fe0f': "\uD83D\uDC77\u200D\u2642\uFE0F",
    '1f482-200d-2640-fe0f': "\uD83D\uDC82\u200D\u2640\uFE0F",
    '1f482': "\uD83D\uDC82",
    '1f482-200d-2642-fe0f': "\uD83D\uDC82\u200D\u2642\uFE0F",
    '1f575-fe0f-200d-2640-fe0f': "\uD83D\uDD75\uFE0F\u200D\u2640\uFE0F",
    '1f575': "\uD83D\uDD75\uFE0F",
    '1f575-fe0f-200d-2642-fe0f': "\uD83D\uDD75\uFE0F\u200D\u2642\uFE0F",
    '1f469-200d-2695-fe0f': "\uD83D\uDC69\u200D\u2695\uFE0F",
    '1f468-200d-2695-fe0f': "\uD83D\uDC68\u200D\u2695\uFE0F",
    '1f469-200d-1f33e': "\uD83D\uDC69\u200D\uD83C\uDF3E",
    '1f468-200d-1f33e': "\uD83D\uDC68\u200D\uD83C\uDF3E",
    '1f469-200d-1f373': "\uD83D\uDC69\u200D\uD83C\uDF73",
    '1f468-200d-1f373': "\uD83D\uDC68\u200D\uD83C\uDF73",
    '1f469-200d-1f393': "\uD83D\uDC69\u200D\uD83C\uDF93",
    '1f468-200d-1f393': "\uD83D\uDC68\u200D\uD83C\uDF93",
    '1f469-200d-1f3a4': "\uD83D\uDC69\u200D\uD83C\uDFA4",
    '1f468-200d-1f3a4': "\uD83D\uDC68\u200D\uD83C\uDFA4",
    '1f469-200d-1f3eb': "\uD83D\uDC69\u200D\uD83C\uDFEB",
    '1f468-200d-1f3eb': "\uD83D\uDC68\u200D\uD83C\uDFEB",
    '1f469-200d-1f3ed': "\uD83D\uDC69\u200D\uD83C\uDFED",
    '1f468-200d-1f3ed': "\uD83D\uDC68\u200D\uD83C\uDFED",
    '1f469-200d-1f4bb': "\uD83D\uDC69\u200D\uD83D\uDCBB",
    '1f468-200d-1f4bb': "\uD83D\uDC68\u200D\uD83D\uDCBB",
    '1f469-200d-1f4bc': "\uD83D\uDC69\u200D\uD83D\uDCBC",
    '1f468-200d-1f4bc': "\uD83D\uDC68\u200D\uD83D\uDCBC",
    '1f469-200d-1f527': "\uD83D\uDC69\u200D\uD83D\uDD27",
    '1f468-200d-1f527': "\uD83D\uDC68\u200D\uD83D\uDD27",
    '1f469-200d-1f52c': "\uD83D\uDC69\u200D\uD83D\uDD2C",
    '1f468-200d-1f52c': "\uD83D\uDC68\u200D\uD83D\uDD2C",
    '1f469-200d-1f3a8': "\uD83D\uDC69\u200D\uD83C\uDFA8",
    '1f468-200d-1f3a8': "\uD83D\uDC68\u200D\uD83C\uDFA8",
    '1f469-200d-1f692': "\uD83D\uDC69\u200D\uD83D\uDE92",
    '1f468-200d-1f692': "\uD83D\uDC68\u200D\uD83D\uDE92",
    '1f469-200d-2708-fe0f': "\uD83D\uDC69\u200D\u2708\uFE0F",
    '1f468-200d-2708-fe0f': "\uD83D\uDC68\u200D\u2708\uFE0F",
    '1f469-200d-1f680': "\uD83D\uDC69\u200D\uD83D\uDE80",
    '1f468-200d-1f680': "\uD83D\uDC68\u200D\uD83D\uDE80",
    '1f469-200d-2696-fe0f': "\uD83D\uDC69\u200D\u2696\uFE0F",
    '1f468-200d-2696-fe0f': "\uD83D\uDC68\u200D\u2696\uFE0F",
    '1f936': "\uD83E\uDD36",
    '1f385': "\uD83C\uDF85",
    '1f478': "\uD83D\uDC78",
    '1f934': "\uD83E\uDD34",
    '1f470': "\uD83D\uDC70",
    '1f935': "\uD83E\uDD35",
    '1f47c': "\uD83D\uDC7C",
    '1f930': "\uD83E\uDD30",
    '1f647-200d-2640-fe0f': "\uD83D\uDE47\u200D\u2640\uFE0F",
    '1f647': "\uD83D\uDE47",
    '1f647-200d-2642-fe0f': "\uD83D\uDE47\u200D\u2642\uFE0F",
    '1f481': "\uD83D\uDC81",
    '1f481-200d-2642-fe0f': "\uD83D\uDC81\u200D\u2642\uFE0F",
    '1f481-200d-2640-fe0f': "\uD83D\uDC81\u200D\u2640\uFE0F",
    '1f645': "\uD83D\uDE45",
    '1f645-200d-2642-fe0f': "\uD83D\uDE45\u200D\u2642\uFE0F",
    '1f645-200d-2640-fe0f': "\uD83D\uDE45\u200D\u2640\uFE0F",
    '1f646': "\uD83D\uDE46",
    '1f646-200d-2642-fe0f': "\uD83D\uDE46\u200D\u2642\uFE0F",
    '1f646-200d-2640-fe0f': "\uD83D\uDE46\u200D\u2640\uFE0F",
    '1f64b': "\uD83D\uDE4B",
    '1f64b-200d-2642-fe0f': "\uD83D\uDE4B\u200D\u2642\uFE0F",
    '1f64b-200d-2640-fe0f': "\uD83D\uDE4B\u200D\u2640\uFE0F",
    '1f926-200d-2640-fe0f': "\uD83E\uDD26\u200D\u2640\uFE0F",
    '1f926-200d-2642-fe0f': "\uD83E\uDD26\u200D\u2642\uFE0F",
    '1f926': "\uD83E\uDD26",
    '1f937-200d-2640-fe0f': "\uD83E\uDD37\u200D\u2640\uFE0F",
    '1f937-200d-2642-fe0f': "\uD83E\uDD37\u200D\u2642\uFE0F",
    '1f937': "\uD83E\uDD37",
    '1f64e': "\uD83D\uDE4E",
    '1f64e-200d-2642-fe0f': "\uD83D\uDE4E\u200D\u2642\uFE0F",
    '1f64e-200d-2640-fe0f': "\uD83D\uDE4E\u200D\u2640\uFE0F",
    '1f64d': "\uD83D\uDE4D",
    '1f64d-200d-2642-fe0f': "\uD83D\uDE4D\u200D\u2642\uFE0F",
    '1f64d-200d-2640-fe0f': "\uD83D\uDE4D\u200D\u2640\uFE0F",
    '1f487': "\uD83D\uDC87",
    '1f487-200d-2642-fe0f': "\uD83D\uDC87\u200D\u2642\uFE0F",
    '1f487-200d-2640-fe0f': "\uD83D\uDC87\u200D\u2640\uFE0F",
    '1f486': "\uD83D\uDC86",
    '1f486-200d-2642-fe0f': "\uD83D\uDC86\u200D\u2642\uFE0F",
    '1f486-200d-2640-fe0f': "\uD83D\uDC86\u200D\u2640\uFE0F",
    '1f574': "\uD83D\uDD74\uFE0F",
    '1f483': "\uD83D\uDC83",
    '1f57a': "\uD83D\uDD7A",
    '1f46f': "\uD83D\uDC6F",
    '1f46f-200d-2642-fe0f': "\uD83D\uDC6F\u200D\u2642\uFE0F",
    '1f46f-200d-2640-fe0f': "\uD83D\uDC6F\u200D\u2640\uFE0F",
    '1f6b6-200d-2640-fe0f': "\uD83D\uDEB6\u200D\u2640\uFE0F",
    '1f6b6': "\uD83D\uDEB6",
    '1f6b6-200d-2642-fe0f': "\uD83D\uDEB6\u200D\u2642\uFE0F",
    '1f3c3-200d-2640-fe0f': "\uD83C\uDFC3\u200D\u2640\uFE0F",
    '1f3c3': "\uD83C\uDFC3",
    '1f3c3-200d-2642-fe0f': "\uD83C\uDFC3\u200D\u2642\uFE0F",
    '1f46b': "\uD83D\uDC6B",
    '1f46d': "\uD83D\uDC6D",
    '1f46c': "\uD83D\uDC6C",
    '1f491': "\uD83D\uDC91",
    '1f469-200d-2764-fe0f-200d-1f469': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC69",
    '1f468-200d-2764-fe0f-200d-1f468': "\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC68",
    '1f48f': "\uD83D\uDC8F",
    '1f469-200d-2764-fe0f-200d-1f48b-200d-1f469': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC69",
    '1f468-200d-2764-fe0f-200d-1f48b-200d-1f468': "\uD83D\uDC68\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68",
    '1f46a': "\uD83D\uDC6A",
    '1f468-200d-1f469-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67",
    '1f468-200d-1f469-200d-1f467-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f468-200d-1f469-200d-1f466-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f468-200d-1f469-200d-1f467-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f469-200d-1f469-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66",
    '1f469-200d-1f469-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67",
    '1f469-200d-1f469-200d-1f467-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f469-200d-1f469-200d-1f466-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f469-200d-1f469-200d-1f467-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f468-200d-1f468-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66",
    '1f468-200d-1f468-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67",
    '1f468-200d-1f468-200d-1f467-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f468-200d-1f468-200d-1f466-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f468-200d-1f468-200d-1f467-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f469-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC66",
    '1f469-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC67",
    '1f469-200d-1f467-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f469-200d-1f466-200d-1f466': "\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f469-200d-1f467-200d-1f467': "\uD83D\uDC69\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f468-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC66",
    '1f468-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC67",
    '1f468-200d-1f467-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC66",
    '1f468-200d-1f466-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC66\u200D\uD83D\uDC66",
    '1f468-200d-1f467-200d-1f467': "\uD83D\uDC68\u200D\uD83D\uDC67\u200D\uD83D\uDC67",
    '1f45a': "\uD83D\uDC5A",
    '1f455': "\uD83D\uDC55",
    '1f456': "\uD83D\uDC56",
    '1f454': "\uD83D\uDC54",
    '1f457': "\uD83D\uDC57",
    '1f459': "\uD83D\uDC59",
    '1f458': "\uD83D\uDC58",
    '1f460': "\uD83D\uDC60",
    '1f461': "\uD83D\uDC61",
    '1f462': "\uD83D\uDC62",
    '1f45e': "\uD83D\uDC5E",
    '1f45f': "\uD83D\uDC5F",
    '1f452': "\uD83D\uDC52",
    '1f3a9': "\uD83C\uDFA9",
    '1f393': "\uD83C\uDF93",
    '1f451': "\uD83D\uDC51",
    '26d1': "\u26D1\uFE0F",
    '1f392': "\uD83C\uDF92",
    '1f45d': "\uD83D\uDC5D",
    '1f45b': "\uD83D\uDC5B",
    '1f45c': "\uD83D\uDC5C",
    '1f4bc': "\uD83D\uDCBC",
    '1f453': "\uD83D\uDC53",
    '1f576': "\uD83D\uDD76\uFE0F",
    '1f302': "\uD83C\uDF02",
    '2602': "\u2602\uFE0F",
    '1f436': "\uD83D\uDC36",
    '1f431': "\uD83D\uDC31",
    '1f42d': "\uD83D\uDC2D",
    '1f439': "\uD83D\uDC39",
    '1f430': "\uD83D\uDC30",
    '1f98a': "\uD83E\uDD8A",
    '1f43b': "\uD83D\uDC3B",
    '1f43c': "\uD83D\uDC3C",
    '1f428': "\uD83D\uDC28",
    '1f42f': "\uD83D\uDC2F",
    '1f981': "\uD83E\uDD81",
    '1f42e': "\uD83D\uDC2E",
    '1f437': "\uD83D\uDC37",
    '1f43d': "\uD83D\uDC3D",
    '1f438': "\uD83D\uDC38",
    '1f435': "\uD83D\uDC35",
    '1f648': "\uD83D\uDE48",
    '1f649': "\uD83D\uDE49",
    '1f64a': "\uD83D\uDE4A",
    '1f412': "\uD83D\uDC12",
    '1f414': "\uD83D\uDC14",
    '1f427': "\uD83D\uDC27",
    '1f426': "\uD83D\uDC26",
    '1f424': "\uD83D\uDC24",
    '1f423': "\uD83D\uDC23",
    '1f425': "\uD83D\uDC25",
    '1f986': "\uD83E\uDD86",
    '1f985': "\uD83E\uDD85",
    '1f989': "\uD83E\uDD89",
    '1f987': "\uD83E\uDD87",
    '1f43a': "\uD83D\uDC3A",
    '1f417': "\uD83D\uDC17",
    '1f434': "\uD83D\uDC34",
    '1f984': "\uD83E\uDD84",
    '1f41d': "\uD83D\uDC1D",
    '1f41b': "\uD83D\uDC1B",
    '1f98b': "\uD83E\uDD8B",
    '1f40c': "\uD83D\uDC0C",
    '1f41a': "\uD83D\uDC1A",
    '1f41e': "\uD83D\uDC1E",
    '1f41c': "\uD83D\uDC1C",
    '1f577': "\uD83D\uDD77\uFE0F",
    '1f578': "\uD83D\uDD78\uFE0F",
    '1f422': "\uD83D\uDC22",
    '1f40d': "\uD83D\uDC0D",
    '1f98e': "\uD83E\uDD8E",
    '1f982': "\uD83E\uDD82",
    '1f980': "\uD83E\uDD80",
    '1f991': "\uD83E\uDD91",
    '1f419': "\uD83D\uDC19",
    '1f990': "\uD83E\uDD90",
    '1f420': "\uD83D\uDC20",
    '1f41f': "\uD83D\uDC1F",
    '1f421': "\uD83D\uDC21",
    '1f42c': "\uD83D\uDC2C",
    '1f988': "\uD83E\uDD88",
    '1f433': "\uD83D\uDC33",
    '1f40b': "\uD83D\uDC0B",
    '1f40a': "\uD83D\uDC0A",
    '1f406': "\uD83D\uDC06",
    '1f405': "\uD83D\uDC05",
    '1f403': "\uD83D\uDC03",
    '1f402': "\uD83D\uDC02",
    '1f404': "\uD83D\uDC04",
    '1f98c': "\uD83E\uDD8C",
    '1f42a': "\uD83D\uDC2A",
    '1f42b': "\uD83D\uDC2B",
    '1f418': "\uD83D\uDC18",
    '1f98f': "\uD83E\uDD8F",
    '1f98d': "\uD83E\uDD8D",
    '1f40e': "\uD83D\uDC0E",
    '1f416': "\uD83D\uDC16",
    '1f410': "\uD83D\uDC10",
    '1f40f': "\uD83D\uDC0F",
    '1f411': "\uD83D\uDC11",
    '1f415': "\uD83D\uDC15",
    '1f429': "\uD83D\uDC29",
    '1f408': "\uD83D\uDC08",
    '1f413': "\uD83D\uDC13",
    '1f983': "\uD83E\uDD83",
    '1f54a': "\uD83D\uDD4A\uFE0F",
    '1f407': "\uD83D\uDC07",
    '1f401': "\uD83D\uDC01",
    '1f400': "\uD83D\uDC00",
    '1f43f': "\uD83D\uDC3F\uFE0F",
    '1f43e': "\uD83D\uDC3E",
    '1f409': "\uD83D\uDC09",
    '1f432': "\uD83D\uDC32",
    '1f335': "\uD83C\uDF35",
    '1f384': "\uD83C\uDF84",
    '1f332': "\uD83C\uDF32",
    '1f333': "\uD83C\uDF33",
    '1f334': "\uD83C\uDF34",
    '1f331': "\uD83C\uDF31",
    '1f33f': "\uD83C\uDF3F",
    '2618': "\u2618\uFE0F",
    '1f340': "\uD83C\uDF40",
    '1f38d': "\uD83C\uDF8D",
    '1f38b': "\uD83C\uDF8B",
    '1f343': "\uD83C\uDF43",
    '1f342': "\uD83C\uDF42",
    '1f341': "\uD83C\uDF41",
    '1f344': "\uD83C\uDF44",
    '1f33e': "\uD83C\uDF3E",
    '1f490': "\uD83D\uDC90",
    '1f337': "\uD83C\uDF37",
    '1f339': "\uD83C\uDF39",
    '1f940': "\uD83E\uDD40",
    '1f33b': "\uD83C\uDF3B",
    '1f33c': "\uD83C\uDF3C",
    '1f338': "\uD83C\uDF38",
    '1f33a': "\uD83C\uDF3A",
    '1f30e': "\uD83C\uDF0E",
    '1f30d': "\uD83C\uDF0D",
    '1f30f': "\uD83C\uDF0F",
    '1f315': "\uD83C\uDF15",
    '1f316': "\uD83C\uDF16",
    '1f317': "\uD83C\uDF17",
    '1f318': "\uD83C\uDF18",
    '1f311': "\uD83C\uDF11",
    '1f312': "\uD83C\uDF12",
    '1f313': "\uD83C\uDF13",
    '1f314': "\uD83C\uDF14",
    '1f31a': "\uD83C\uDF1A",
    '1f31d': "\uD83C\uDF1D",
    '1f31e': "\uD83C\uDF1E",
    '1f31b': "\uD83C\uDF1B",
    '1f31c': "\uD83C\uDF1C",
    '1f319': "\uD83C\uDF19",
    '1f4ab': "\uD83D\uDCAB",
    '2b50': "\u2B50",
    '1f31f': "\uD83C\uDF1F",
    '2728': "\u2728",
    '26a1': "\u26A1",
    '1f525': "\uD83D\uDD25",
    '1f4a5': "\uD83D\uDCA5",
    '2604': "\u2604\uFE0F",
    '2600': "\u2600\uFE0F",
    '1f324': "\uD83C\uDF24\uFE0F",
    '26c5': "\u26C5",
    '1f325': "\uD83C\uDF25\uFE0F",
    '1f326': "\uD83C\uDF26\uFE0F",
    '1f308': "\uD83C\uDF08",
    '2601': "\u2601\uFE0F",
    '1f327': "\uD83C\uDF27\uFE0F",
    '26c8': "\u26C8\uFE0F",
    '1f329': "\uD83C\uDF29\uFE0F",
    '1f328': "\uD83C\uDF28\uFE0F",
    '2603': "\u2603\uFE0F",
    '26c4': "\u26C4",
    '2744': "\u2744\uFE0F",
    '1f32c': "\uD83C\uDF2C\uFE0F",
    '1f4a8': "\uD83D\uDCA8",
    '1f32a': "\uD83C\uDF2A\uFE0F",
    '1f32b': "\uD83C\uDF2B\uFE0F",
    '1f30a': "\uD83C\uDF0A",
    '1f4a7': "\uD83D\uDCA7",
    '1f4a6': "\uD83D\uDCA6",
    '2614': "\u2614",
    '1f992': "\uD83E\uDD92",
    '1f993': "\uD83E\uDD93",
    '1f994': "\uD83E\uDD94",
    '1f995': "\uD83E\uDD95",
    '1f996': "\uD83E\uDD96",
    '1f997': "\uD83E\uDD97",
    '1f34f': "\uD83C\uDF4F",
    '1f34e': "\uD83C\uDF4E",
    '1f350': "\uD83C\uDF50",
    '1f34a': "\uD83C\uDF4A",
    '1f34b': "\uD83C\uDF4B",
    '1f34c': "\uD83C\uDF4C",
    '1f349': "\uD83C\uDF49",
    '1f347': "\uD83C\uDF47",
    '1f353': "\uD83C\uDF53",
    '1f348': "\uD83C\uDF48",
    '1f352': "\uD83C\uDF52",
    '1f351': "\uD83C\uDF51",
    '1f34d': "\uD83C\uDF4D",
    '1f95d': "\uD83E\uDD5D",
    '1f951': "\uD83E\uDD51",
    '1f345': "\uD83C\uDF45",
    '1f346': "\uD83C\uDF46",
    '1f952': "\uD83E\uDD52",
    '1f955': "\uD83E\uDD55",
    '1f33d': "\uD83C\uDF3D",
    '1f336': "\uD83C\uDF36\uFE0F",
    '1f954': "\uD83E\uDD54",
    '1f360': "\uD83C\uDF60",
    '1f330': "\uD83C\uDF30",
    '1f95c': "\uD83E\uDD5C",
    '1f36f': "\uD83C\uDF6F",
    '1f950': "\uD83E\uDD50",
    '1f35e': "\uD83C\uDF5E",
    '1f956': "\uD83E\uDD56",
    '1f9c0': "\uD83E\uDDC0",
    '1f95a': "\uD83E\uDD5A",
    '1f373': "\uD83C\uDF73",
    '1f953': "\uD83E\uDD53",
    '1f95e': "\uD83E\uDD5E",
    '1f364': "\uD83C\uDF64",
    '1f357': "\uD83C\uDF57",
    '1f356': "\uD83C\uDF56",
    '1f355': "\uD83C\uDF55",
    '1f32d': "\uD83C\uDF2D",
    '1f354': "\uD83C\uDF54",
    '1f35f': "\uD83C\uDF5F",
    '1f959': "\uD83E\uDD59",
    '1f32e': "\uD83C\uDF2E",
    '1f32f': "\uD83C\uDF2F",
    '1f957': "\uD83E\uDD57",
    '1f958': "\uD83E\uDD58",
    '1f35d': "\uD83C\uDF5D",
    '1f35c': "\uD83C\uDF5C",
    '1f372': "\uD83C\uDF72",
    '1f365': "\uD83C\uDF65",
    '1f363': "\uD83C\uDF63",
    '1f371': "\uD83C\uDF71",
    '1f35b': "\uD83C\uDF5B",
    '1f359': "\uD83C\uDF59",
    '1f35a': "\uD83C\uDF5A",
    '1f358': "\uD83C\uDF58",
    '1f362': "\uD83C\uDF62",
    '1f361': "\uD83C\uDF61",
    '1f367': "\uD83C\uDF67",
    '1f368': "\uD83C\uDF68",
    '1f366': "\uD83C\uDF66",
    '1f370': "\uD83C\uDF70",
    '1f382': "\uD83C\uDF82",
    '1f36e': "\uD83C\uDF6E",
    '1f36d': "\uD83C\uDF6D",
    '1f36c': "\uD83C\uDF6C",
    '1f36b': "\uD83C\uDF6B",
    '1f37f': "\uD83C\uDF7F",
    '1f369': "\uD83C\uDF69",
    '1f36a': "\uD83C\uDF6A",
    '1f95b': "\uD83E\uDD5B",
    '1f37c': "\uD83C\uDF7C",
    '2615': "\u2615",
    '1f375': "\uD83C\uDF75",
    '1f376': "\uD83C\uDF76",
    '1f37a': "\uD83C\uDF7A",
    '1f37b': "\uD83C\uDF7B",
    '1f942': "\uD83E\uDD42",
    '1f377': "\uD83C\uDF77",
    '1f943': "\uD83E\uDD43",
    '1f378': "\uD83C\uDF78",
    '1f379': "\uD83C\uDF79",
    '1f37e': "\uD83C\uDF7E",
    '1f944': "\uD83E\uDD44",
    '1f374': "\uD83C\uDF74",
    '1f37d': "\uD83C\uDF7D\uFE0F",
    '1f95f': "\uD83E\uDD5F",
    '1f960': "\uD83E\uDD60",
    '1f961': "\uD83E\uDD61",
    '1f962': "\uD83E\uDD62",
    '1f963': "\uD83E\uDD63",
    '1f964': "\uD83E\uDD64",
    '1f965': "\uD83E\uDD65",
    '1f966': "\uD83E\uDD66",
    '1f967': "\uD83E\uDD67",
    '1f968': "\uD83E\uDD68",
    '1f969': "\uD83E\uDD69",
    '1f96a': "\uD83E\uDD6A",
    '1f96b': "\uD83E\uDD6B",
    '26bd': "\u26BD",
    '1f3c0': "\uD83C\uDFC0",
    '1f3c8': "\uD83C\uDFC8",
    '26be': "\u26BE",
    '1f3be': "\uD83C\uDFBE",
    '1f3d0': "\uD83C\uDFD0",
    '1f3c9': "\uD83C\uDFC9",
    '1f3b1': "\uD83C\uDFB1",
    '1f3d3': "\uD83C\uDFD3",
    '1f3f8': "\uD83C\uDFF8",
    '1f945': "\uD83E\uDD45",
    '1f3d2': "\uD83C\uDFD2",
    '1f3d1': "\uD83C\uDFD1",
    '1f3cf': "\uD83C\uDFCF",
    '26f3': "\u26F3",
    '1f3f9': "\uD83C\uDFF9",
    '1f3a3': "\uD83C\uDFA3",
    '1f94a': "\uD83E\uDD4A",
    '1f94b': "\uD83E\uDD4B",
    '26f8': "\u26F8\uFE0F",
    '1f3bf': "\uD83C\uDFBF",
    '26f7': "\u26F7\uFE0F",
    '1f3c2': "\uD83C\uDFC2",
    '1f3cb-fe0f-200d-2640-fe0f': "\uD83C\uDFCB\uFE0F\u200D\u2640\uFE0F",
    '1f3cb': "\uD83C\uDFCB\uFE0F",
    '1f3cb-fe0f-200d-2642-fe0f': "\uD83C\uDFCB\uFE0F\u200D\u2642\uFE0F",
    '1f93a': "\uD83E\uDD3A",
    '1f93c-200d-2640-fe0f': "\uD83E\uDD3C\u200D\u2640\uFE0F",
    '1f93c-200d-2642-fe0f': "\uD83E\uDD3C\u200D\u2642\uFE0F",
    '1f93c': "\uD83E\uDD3C",
    '1f938-200d-2640-fe0f': "\uD83E\uDD38\u200D\u2640\uFE0F",
    '1f938-200d-2642-fe0f': "\uD83E\uDD38\u200D\u2642\uFE0F",
    '1f938': "\uD83E\uDD38",
    '26f9-fe0f-200d-2640-fe0f': "\u26F9\uFE0F\u200D\u2640\uFE0F",
    '26f9': "\u26F9\uFE0F",
    '26f9-fe0f-200d-2642-fe0f': "\u26F9\uFE0F\u200D\u2642\uFE0F",
    '1f93e-200d-2640-fe0f': "\uD83E\uDD3E\u200D\u2640\uFE0F",
    '1f93e-200d-2642-fe0f': "\uD83E\uDD3E\u200D\u2642\uFE0F",
    '1f93e': "\uD83E\uDD3E",
    '1f3cc-fe0f-200d-2640-fe0f': "\uD83C\uDFCC\uFE0F\u200D\u2640\uFE0F",
    '1f3cc': "\uD83C\uDFCC\uFE0F",
    '1f3cc-fe0f-200d-2642-fe0f': "\uD83C\uDFCC\uFE0F\u200D\u2642\uFE0F",
    '1f3c4-200d-2640-fe0f': "\uD83C\uDFC4\u200D\u2640\uFE0F",
    '1f3c4': "\uD83C\uDFC4",
    '1f3c4-200d-2642-fe0f': "\uD83C\uDFC4\u200D\u2642\uFE0F",
    '1f3ca-200d-2640-fe0f': "\uD83C\uDFCA\u200D\u2640\uFE0F",
    '1f3ca': "\uD83C\uDFCA",
    '1f3ca-200d-2642-fe0f': "\uD83C\uDFCA\u200D\u2642\uFE0F",
    '1f93d-200d-2640-fe0f': "\uD83E\uDD3D\u200D\u2640\uFE0F",
    '1f93d-200d-2642-fe0f': "\uD83E\uDD3D\u200D\u2642\uFE0F",
    '1f93d': "\uD83E\uDD3D",
    '1f6a3-200d-2640-fe0f': "\uD83D\uDEA3\u200D\u2640\uFE0F",
    '1f6a3': "\uD83D\uDEA3",
    '1f6a3-200d-2642-fe0f': "\uD83D\uDEA3\u200D\u2642\uFE0F",
    '1f3c7': "\uD83C\uDFC7",
    '1f6b4-200d-2640-fe0f': "\uD83D\uDEB4\u200D\u2640\uFE0F",
    '1f6b4': "\uD83D\uDEB4",
    '1f6b4-200d-2642-fe0f': "\uD83D\uDEB4\u200D\u2642\uFE0F",
    '1f6b5-200d-2640-fe0f': "\uD83D\uDEB5\u200D\u2640\uFE0F",
    '1f6b5': "\uD83D\uDEB5",
    '1f6b5-200d-2642-fe0f': "\uD83D\uDEB5\u200D\u2642\uFE0F",
    '1f3bd': "\uD83C\uDFBD",
    '1f3c5': "\uD83C\uDFC5",
    '1f396': "\uD83C\uDF96\uFE0F",
    '1f947': "\uD83E\uDD47",
    '1f948': "\uD83E\uDD48",
    '1f949': "\uD83E\uDD49",
    '1f3c6': "\uD83C\uDFC6",
    '1f3f5': "\uD83C\uDFF5\uFE0F",
    '1f397': "\uD83C\uDF97\uFE0F",
    '1f3ab': "\uD83C\uDFAB",
    '1f39f': "\uD83C\uDF9F\uFE0F",
    '1f3aa': "\uD83C\uDFAA",
    '1f939-200d-2640-fe0f': "\uD83E\uDD39\u200D\u2640\uFE0F",
    '1f939-200d-2642-fe0f': "\uD83E\uDD39\u200D\u2642\uFE0F",
    '1f939': "\uD83E\uDD39",
    '1f3ad': "\uD83C\uDFAD",
    '1f3a8': "\uD83C\uDFA8",
    '1f3ac': "\uD83C\uDFAC",
    '1f3a4': "\uD83C\uDFA4",
    '1f3a7': "\uD83C\uDFA7",
    '1f3bc': "\uD83C\uDFBC",
    '1f3b9': "\uD83C\uDFB9",
    '1f941': "\uD83E\uDD41",
    '1f3b7': "\uD83C\uDFB7",
    '1f3ba': "\uD83C\uDFBA",
    '1f3b8': "\uD83C\uDFB8",
    '1f3bb': "\uD83C\uDFBB",
    '1f3b2': "\uD83C\uDFB2",
    '1f3af': "\uD83C\uDFAF",
    '1f3b3': "\uD83C\uDFB3",
    '1f3ae': "\uD83C\uDFAE",
    '1f3b0': "\uD83C\uDFB0",
    '1f6f7': "\uD83D\uDEF7",
    '1f931': "\uD83E\uDD31",
    '1f94c': "\uD83E\uDD4C",
    '1f9d6': "\uD83E\uDDD6",
    '1f9d7': "\uD83E\uDDD7",
    '1f9d8': "\uD83E\uDDD8",
    '1f9d6-200d-2640-fe0f': "\uD83E\uDDD6\u200D\u2640\uFE0F",
    '1f9d6-200d-2642-fe0f': "\uD83E\uDDD6\u200D\u2642\uFE0F",
    '1f9d7-200d-2640-fe0f': "\uD83E\uDDD7\u200D\u2640\uFE0F",
    '1f9d7-200d-2642-fe0f': "\uD83E\uDDD7\u200D\u2642\uFE0F",
    '1f9d8-200d-2640-fe0f': "\uD83E\uDDD8\u200D\u2640\uFE0F",
    '1f9d8-200d-2642-fe0f': "\uD83E\uDDD8\u200D\u2642\uFE0F",
    '1f697': "\uD83D\uDE97",
    '1f695': "\uD83D\uDE95",
    '1f699': "\uD83D\uDE99",
    '1f68c': "\uD83D\uDE8C",
    '1f68e': "\uD83D\uDE8E",
    '1f3ce': "\uD83C\uDFCE\uFE0F",
    '1f693': "\uD83D\uDE93",
    '1f691': "\uD83D\uDE91",
    '1f692': "\uD83D\uDE92",
    '1f690': "\uD83D\uDE90",
    '1f69a': "\uD83D\uDE9A",
    '1f69b': "\uD83D\uDE9B",
    '1f69c': "\uD83D\uDE9C",
    '1f6f4': "\uD83D\uDEF4",
    '1f6b2': "\uD83D\uDEB2",
    '1f6f5': "\uD83D\uDEF5",
    '1f3cd': "\uD83C\uDFCD\uFE0F",
    '1f6a8': "\uD83D\uDEA8",
    '1f694': "\uD83D\uDE94",
    '1f68d': "\uD83D\uDE8D",
    '1f698': "\uD83D\uDE98",
    '1f696': "\uD83D\uDE96",
    '1f6a1': "\uD83D\uDEA1",
    '1f6a0': "\uD83D\uDEA0",
    '1f69f': "\uD83D\uDE9F",
    '1f683': "\uD83D\uDE83",
    '1f68b': "\uD83D\uDE8B",
    '1f69e': "\uD83D\uDE9E",
    '1f69d': "\uD83D\uDE9D",
    '1f684': "\uD83D\uDE84",
    '1f685': "\uD83D\uDE85",
    '1f688': "\uD83D\uDE88",
    '1f682': "\uD83D\uDE82",
    '1f686': "\uD83D\uDE86",
    '1f687': "\uD83D\uDE87",
    '1f68a': "\uD83D\uDE8A",
    '1f689': "\uD83D\uDE89",
    '1f681': "\uD83D\uDE81",
    '1f6e9': "\uD83D\uDEE9\uFE0F",
    '2708': "\u2708\uFE0F",
    '1f6eb': "\uD83D\uDEEB",
    '1f6ec': "\uD83D\uDEEC",
    '1f680': "\uD83D\uDE80",
    '1f6f0': "\uD83D\uDEF0\uFE0F",
    '1f4ba': "\uD83D\uDCBA",
    '1f6f6': "\uD83D\uDEF6",
    '26f5': "\u26F5",
    '1f6e5': "\uD83D\uDEE5\uFE0F",
    '1f6a4': "\uD83D\uDEA4",
    '1f6f3': "\uD83D\uDEF3\uFE0F",
    '26f4': "\u26F4\uFE0F",
    '1f6a2': "\uD83D\uDEA2",
    '2693': "\u2693",
    '1f6a7': "\uD83D\uDEA7",
    '26fd': "\u26FD",
    '1f68f': "\uD83D\uDE8F",
    '1f6a6': "\uD83D\uDEA6",
    '1f6a5': "\uD83D\uDEA5",
    '1f5fa': "\uD83D\uDDFA\uFE0F",
    '1f5ff': "\uD83D\uDDFF",
    '1f5fd': "\uD83D\uDDFD",
    '26f2': "\u26F2",
    '1f5fc': "\uD83D\uDDFC",
    '1f3f0': "\uD83C\uDFF0",
    '1f3ef': "\uD83C\uDFEF",
    '1f3df': "\uD83C\uDFDF\uFE0F",
    '1f3a1': "\uD83C\uDFA1",
    '1f3a2': "\uD83C\uDFA2",
    '1f3a0': "\uD83C\uDFA0",
    '26f1': "\u26F1\uFE0F",
    '1f3d6': "\uD83C\uDFD6\uFE0F",
    '1f3dd': "\uD83C\uDFDD\uFE0F",
    '26f0': "\u26F0\uFE0F",
    '1f3d4': "\uD83C\uDFD4\uFE0F",
    '1f5fb': "\uD83D\uDDFB",
    '1f30b': "\uD83C\uDF0B",
    '1f3dc': "\uD83C\uDFDC\uFE0F",
    '1f3d5': "\uD83C\uDFD5\uFE0F",
    '26fa': "\u26FA",
    '1f6e4': "\uD83D\uDEE4\uFE0F",
    '1f6e3': "\uD83D\uDEE3\uFE0F",
    '1f3d7': "\uD83C\uDFD7\uFE0F",
    '1f3ed': "\uD83C\uDFED",
    '1f3e0': "\uD83C\uDFE0",
    '1f3e1': "\uD83C\uDFE1",
    '1f3d8': "\uD83C\uDFD8\uFE0F",
    '1f3da': "\uD83C\uDFDA\uFE0F",
    '1f3e2': "\uD83C\uDFE2",
    '1f3ec': "\uD83C\uDFEC",
    '1f3e3': "\uD83C\uDFE3",
    '1f3e4': "\uD83C\uDFE4",
    '1f3e5': "\uD83C\uDFE5",
    '1f3e6': "\uD83C\uDFE6",
    '1f3e8': "\uD83C\uDFE8",
    '1f3ea': "\uD83C\uDFEA",
    '1f3eb': "\uD83C\uDFEB",
    '1f3e9': "\uD83C\uDFE9",
    '1f492': "\uD83D\uDC92",
    '1f3db': "\uD83C\uDFDB\uFE0F",
    '26ea': "\u26EA",
    '1f54c': "\uD83D\uDD4C",
    '1f54d': "\uD83D\uDD4D",
    '1f54b': "\uD83D\uDD4B",
    '26e9': "\u26E9\uFE0F",
    '1f5fe': "\uD83D\uDDFE",
    '1f391': "\uD83C\uDF91",
    '1f3de': "\uD83C\uDFDE\uFE0F",
    '1f305': "\uD83C\uDF05",
    '1f304': "\uD83C\uDF04",
    '1f320': "\uD83C\uDF20",
    '1f387': "\uD83C\uDF87",
    '1f386': "\uD83C\uDF86",
    '1f307': "\uD83C\uDF07",
    '1f306': "\uD83C\uDF06",
    '1f3d9': "\uD83C\uDFD9\uFE0F",
    '1f303': "\uD83C\uDF03",
    '1f30c': "\uD83C\uDF0C",
    '1f309': "\uD83C\uDF09",
    '1f301': "\uD83C\uDF01",
    '1f6f8': "\uD83D\uDEF8",
    '231a': "\u231A",
    '1f4f1': "\uD83D\uDCF1",
    '1f4f2': "\uD83D\uDCF2",
    '1f4bb': "\uD83D\uDCBB",
    '2328': "\u2328\uFE0F",
    '1f5a5': "\uD83D\uDDA5\uFE0F",
    '1f5a8': "\uD83D\uDDA8\uFE0F",
    '1f5b1': "\uD83D\uDDB1\uFE0F",
    '1f5b2': "\uD83D\uDDB2\uFE0F",
    '1f579': "\uD83D\uDD79\uFE0F",
    '1f5dc': "\uD83D\uDDDC\uFE0F",
    '1f4bd': "\uD83D\uDCBD",
    '1f4be': "\uD83D\uDCBE",
    '1f4bf': "\uD83D\uDCBF",
    '1f4c0': "\uD83D\uDCC0",
    '1f4fc': "\uD83D\uDCFC",
    '1f4f7': "\uD83D\uDCF7",
    '1f4f8': "\uD83D\uDCF8",
    '1f4f9': "\uD83D\uDCF9",
    '1f3a5': "\uD83C\uDFA5",
    '1f4fd': "\uD83D\uDCFD\uFE0F",
    '1f39e': "\uD83C\uDF9E\uFE0F",
    '1f4de': "\uD83D\uDCDE",
    '260e': "\u260E\uFE0F",
    '1f4df': "\uD83D\uDCDF",
    '1f4e0': "\uD83D\uDCE0",
    '1f4fa': "\uD83D\uDCFA",
    '1f4fb': "\uD83D\uDCFB",
    '1f399': "\uD83C\uDF99\uFE0F",
    '1f39a': "\uD83C\uDF9A\uFE0F",
    '1f39b': "\uD83C\uDF9B\uFE0F",
    '23f1': "\u23F1\uFE0F",
    '23f2': "\u23F2\uFE0F",
    '23f0': "\u23F0",
    '1f570': "\uD83D\uDD70\uFE0F",
    '231b': "\u231B",
    '23f3': "\u23F3",
    '1f4e1': "\uD83D\uDCE1",
    '1f50b': "\uD83D\uDD0B",
    '1f50c': "\uD83D\uDD0C",
    '1f4a1': "\uD83D\uDCA1",
    '1f526': "\uD83D\uDD26",
    '1f56f': "\uD83D\uDD6F\uFE0F",
    '1f5d1': "\uD83D\uDDD1\uFE0F",
    '1f6e2': "\uD83D\uDEE2\uFE0F",
    '1f4b8': "\uD83D\uDCB8",
    '1f4b5': "\uD83D\uDCB5",
    '1f4b4': "\uD83D\uDCB4",
    '1f4b6': "\uD83D\uDCB6",
    '1f4b7': "\uD83D\uDCB7",
    '1f4b0': "\uD83D\uDCB0",
    '1f4b3': "\uD83D\uDCB3",
    '1f48e': "\uD83D\uDC8E",
    '2696': "\u2696\uFE0F",
    '1f527': "\uD83D\uDD27",
    '1f528': "\uD83D\uDD28",
    '2692': "\u2692\uFE0F",
    '1f6e0': "\uD83D\uDEE0\uFE0F",
    '26cf': "\u26CF\uFE0F",
    '1f529': "\uD83D\uDD29",
    '2699': "\u2699\uFE0F",
    '26d3': "\u26D3\uFE0F",
    '1f52b': "\uD83D\uDD2B",
    '1f4a3': "\uD83D\uDCA3",
    '1f52a': "\uD83D\uDD2A",
    '1f5e1': "\uD83D\uDDE1\uFE0F",
    '2694': "\u2694\uFE0F",
    '1f6e1': "\uD83D\uDEE1\uFE0F",
    '1f6ac': "\uD83D\uDEAC",
    '26b0': "\u26B0\uFE0F",
    '26b1': "\u26B1\uFE0F",
    '1f3fa': "\uD83C\uDFFA",
    '1f52e': "\uD83D\uDD2E",
    '1f4ff': "\uD83D\uDCFF",
    '1f488': "\uD83D\uDC88",
    '2697': "\u2697\uFE0F",
    '1f52d': "\uD83D\uDD2D",
    '1f52c': "\uD83D\uDD2C",
    '1f573': "\uD83D\uDD73\uFE0F",
    '1f48a': "\uD83D\uDC8A",
    '1f489': "\uD83D\uDC89",
    '1f321': "\uD83C\uDF21\uFE0F",
    '1f6bd': "\uD83D\uDEBD",
    '1f6b0': "\uD83D\uDEB0",
    '1f6bf': "\uD83D\uDEBF",
    '1f6c1': "\uD83D\uDEC1",
    '1f6c0': "\uD83D\uDEC0",
    '1f6ce': "\uD83D\uDECE\uFE0F",
    '1f511': "\uD83D\uDD11",
    '1f5dd': "\uD83D\uDDDD\uFE0F",
    '1f6aa': "\uD83D\uDEAA",
    '1f6cb': "\uD83D\uDECB\uFE0F",
    '1f6cf': "\uD83D\uDECF\uFE0F",
    '1f6cc': "\uD83D\uDECC",
    '1f5bc': "\uD83D\uDDBC\uFE0F",
    '1f6cd': "\uD83D\uDECD\uFE0F",
    '1f6d2': "\uD83D\uDED2",
    '1f381': "\uD83C\uDF81",
    '1f388': "\uD83C\uDF88",
    '1f38f': "\uD83C\uDF8F",
    '1f380': "\uD83C\uDF80",
    '1f38a': "\uD83C\uDF8A",
    '1f389': "\uD83C\uDF89",
    '1f38e': "\uD83C\uDF8E",
    '1f3ee': "\uD83C\uDFEE",
    '1f390': "\uD83C\uDF90",
    '2709': "\u2709\uFE0F",
    '1f4e9': "\uD83D\uDCE9",
    '1f4e8': "\uD83D\uDCE8",
    '1f4e7': "\uD83D\uDCE7",
    '1f48c': "\uD83D\uDC8C",
    '1f4e5': "\uD83D\uDCE5",
    '1f4e4': "\uD83D\uDCE4",
    '1f4e6': "\uD83D\uDCE6",
    '1f3f7': "\uD83C\uDFF7\uFE0F",
    '1f4ea': "\uD83D\uDCEA",
    '1f4eb': "\uD83D\uDCEB",
    '1f4ec': "\uD83D\uDCEC",
    '1f4ed': "\uD83D\uDCED",
    '1f4ee': "\uD83D\uDCEE",
    '1f4ef': "\uD83D\uDCEF",
    '1f4dc': "\uD83D\uDCDC",
    '1f4c3': "\uD83D\uDCC3",
    '1f4c4': "\uD83D\uDCC4",
    '1f4d1': "\uD83D\uDCD1",
    '1f4ca': "\uD83D\uDCCA",
    '1f4c8': "\uD83D\uDCC8",
    '1f4c9': "\uD83D\uDCC9",
    '1f5d2': "\uD83D\uDDD2\uFE0F",
    '1f5d3': "\uD83D\uDDD3\uFE0F",
    '1f4c6': "\uD83D\uDCC6",
    '1f4c5': "\uD83D\uDCC5",
    '1f4c7': "\uD83D\uDCC7",
    '1f5c3': "\uD83D\uDDC3\uFE0F",
    '1f5f3': "\uD83D\uDDF3\uFE0F",
    '1f5c4': "\uD83D\uDDC4\uFE0F",
    '1f4cb': "\uD83D\uDCCB",
    '1f4c1': "\uD83D\uDCC1",
    '1f4c2': "\uD83D\uDCC2",
    '1f5c2': "\uD83D\uDDC2\uFE0F",
    '1f5de': "\uD83D\uDDDE\uFE0F",
    '1f4f0': "\uD83D\uDCF0",
    '1f4d3': "\uD83D\uDCD3",
    '1f4d4': "\uD83D\uDCD4",
    '1f4d2': "\uD83D\uDCD2",
    '1f4d5': "\uD83D\uDCD5",
    '1f4d7': "\uD83D\uDCD7",
    '1f4d8': "\uD83D\uDCD8",
    '1f4d9': "\uD83D\uDCD9",
    '1f4da': "\uD83D\uDCDA",
    '1f4d6': "\uD83D\uDCD6",
    '1f516': "\uD83D\uDD16",
    '1f517': "\uD83D\uDD17",
    '1f4ce': "\uD83D\uDCCE",
    '1f587': "\uD83D\uDD87\uFE0F",
    '1f4d0': "\uD83D\uDCD0",
    '1f4cf': "\uD83D\uDCCF",
    '1f4cc': "\uD83D\uDCCC",
    '1f4cd': "\uD83D\uDCCD",
    '2702': "\u2702\uFE0F",
    '1f58a': "\uD83D\uDD8A\uFE0F",
    '1f58b': "\uD83D\uDD8B\uFE0F",
    '2712': "\u2712\uFE0F",
    '1f58c': "\uD83D\uDD8C\uFE0F",
    '1f58d': "\uD83D\uDD8D\uFE0F",
    '1f4dd': "\uD83D\uDCDD",
    '270f': "\u270F\uFE0F",
    '1f50d': "\uD83D\uDD0D",
    '1f50e': "\uD83D\uDD0E",
    '1f50f': "\uD83D\uDD0F",
    '1f510': "\uD83D\uDD10",
    '1f512': "\uD83D\uDD12",
    '1f513': "\uD83D\uDD13",
    '1f9e1': "\uD83E\uDDE1",
    '2764': "\u2764\uFE0F",
    '1f49b': "\uD83D\uDC9B",
    '1f49a': "\uD83D\uDC9A",
    '1f499': "\uD83D\uDC99",
    '1f49c': "\uD83D\uDC9C",
    '1f5a4': "\uD83D\uDDA4",
    '1f494': "\uD83D\uDC94",
    '2763': "\u2763\uFE0F",
    '1f495': "\uD83D\uDC95",
    '1f49e': "\uD83D\uDC9E",
    '1f493': "\uD83D\uDC93",
    '1f497': "\uD83D\uDC97",
    '1f496': "\uD83D\uDC96",
    '1f498': "\uD83D\uDC98",
    '1f49d': "\uD83D\uDC9D",
    '1f49f': "\uD83D\uDC9F",
    '262e': "\u262E\uFE0F",
    '271d': "\u271D\uFE0F",
    '262a': "\u262A\uFE0F",
    '1f549': "\uD83D\uDD49\uFE0F",
    '2638': "\u2638\uFE0F",
    '2721': "\u2721\uFE0F",
    '1f52f': "\uD83D\uDD2F",
    '1f54e': "\uD83D\uDD4E",
    '262f': "\u262F\uFE0F",
    '2626': "\u2626\uFE0F",
    '1f6d0': "\uD83D\uDED0",
    '26ce': "\u26CE",
    '2648': "\u2648",
    '2649': "\u2649",
    '264a': "\u264A",
    '264b': "\u264B",
    '264c': "\u264C",
    '264d': "\u264D",
    '264e': "\u264E",
    '264f': "\u264F",
    '2650': "\u2650",
    '2651': "\u2651",
    '2652': "\u2652",
    '2653': "\u2653",
    '1f194': "\uD83C\uDD94",
    '269b': "\u269B\uFE0F",
    '1f251': "\uD83C\uDE51",
    '2622': "\u2622\uFE0F",
    '2623': "\u2623\uFE0F",
    '1f4f4': "\uD83D\uDCF4",
    '1f4f3': "\uD83D\uDCF3",
    '1f236': "\uD83C\uDE36",
    '1f21a': "\uD83C\uDE1A",
    '1f238': "\uD83C\uDE38",
    '1f23a': "\uD83C\uDE3A",
    '1f237': "\uD83C\uDE37\uFE0F",
    '2734': "\u2734\uFE0F",
    '1f19a': "\uD83C\uDD9A",
    '1f4ae': "\uD83D\uDCAE",
    '1f250': "\uD83C\uDE50",
    '3299': "\u3299\uFE0F",
    '3297': "\u3297\uFE0F",
    '1f234': "\uD83C\uDE34",
    '1f235': "\uD83C\uDE35",
    '1f239': "\uD83C\uDE39",
    '1f232': "\uD83C\uDE32",
    '1f170': "\uD83C\uDD70\uFE0F",
    '1f171': "\uD83C\uDD71\uFE0F",
    '1f18e': "\uD83C\uDD8E",
    '1f191': "\uD83C\uDD91",
    '1f17e': "\uD83C\uDD7E\uFE0F",
    '1f198': "\uD83C\uDD98",
    '274c': "\u274C",
    '2b55': "\u2B55",
    '1f6d1': "\uD83D\uDED1",
    '26d4': "\u26D4",
    '1f4db': "\uD83D\uDCDB",
    '1f6ab': "\uD83D\uDEAB",
    '1f4af': "\uD83D\uDCAF",
    '1f4a2': "\uD83D\uDCA2",
    '2668': "\u2668\uFE0F",
    '1f6b7': "\uD83D\uDEB7",
    '1f6af': "\uD83D\uDEAF",
    '1f6b3': "\uD83D\uDEB3",
    '1f6b1': "\uD83D\uDEB1",
    '1f51e': "\uD83D\uDD1E",
    '1f4f5': "\uD83D\uDCF5",
    '1f6ad': "\uD83D\uDEAD",
    '2757': "\u2757",
    '2755': "\u2755",
    '2753': "\u2753",
    '2754': "\u2754",
    '203c': "\u203C\uFE0F",
    '2049': "\u2049\uFE0F",
    '1f505': "\uD83D\uDD05",
    '1f506': "\uD83D\uDD06",
    '303d': "\u303D\uFE0F",
    '26a0': "\u26A0\uFE0F",
    '1f6b8': "\uD83D\uDEB8",
    '1f531': "\uD83D\uDD31",
    '269c': "\u269C\uFE0F",
    '1f530': "\uD83D\uDD30",
    '267b': "\u267B\uFE0F",
    '2705': "\u2705",
    '1f22f': "\uD83C\uDE2F",
    '1f4b9': "\uD83D\uDCB9",
    '2747': "\u2747\uFE0F",
    '2733': "\u2733\uFE0F",
    '274e': "\u274E",
    '1f310': "\uD83C\uDF10",
    '1f4a0': "\uD83D\uDCA0",
    '24c2': "\u24C2\uFE0F",
    '1f300': "\uD83C\uDF00",
    '1f4a4': "\uD83D\uDCA4",
    '1f3e7': "\uD83C\uDFE7",
    '1f6be': "\uD83D\uDEBE",
    '267f': "\u267F",
    '1f17f': "\uD83C\uDD7F\uFE0F",
    '1f233': "\uD83C\uDE33",
    '1f202': "\uD83C\uDE02\uFE0F",
    '1f6c2': "\uD83D\uDEC2",
    '1f6c3': "\uD83D\uDEC3",
    '1f6c4': "\uD83D\uDEC4",
    '1f6c5': "\uD83D\uDEC5",
    '1f6b9': "\uD83D\uDEB9",
    '1f6ba': "\uD83D\uDEBA",
    '1f6bc': "\uD83D\uDEBC",
    '1f6bb': "\uD83D\uDEBB",
    '1f6ae': "\uD83D\uDEAE",
    '1f3a6': "\uD83C\uDFA6",
    '1f4f6': "\uD83D\uDCF6",
    '1f201': "\uD83C\uDE01",
    '1f523': "\uD83D\uDD23",
    '2139': "\u2139\uFE0F",
    '1f524': "\uD83D\uDD24",
    '1f521': "\uD83D\uDD21",
    '1f520': "\uD83D\uDD20",
    '1f196': "\uD83C\uDD96",
    '1f197': "\uD83C\uDD97",
    '1f199': "\uD83C\uDD99",
    '1f192': "\uD83C\uDD92",
    '1f195': "\uD83C\uDD95",
    '1f193': "\uD83C\uDD93",
    '30-20e3': "0\uFE0F\u20E3",
    '31-20e3': "1\uFE0F\u20E3",
    '32-20e3': "2\uFE0F\u20E3",
    '33-20e3': "3\uFE0F\u20E3",
    '34-20e3': "4\uFE0F\u20E3",
    '35-20e3': "5\uFE0F\u20E3",
    '36-20e3': "6\uFE0F\u20E3",
    '37-20e3': "7\uFE0F\u20E3",
    '38-20e3': "8\uFE0F\u20E3",
    '39-20e3': "9\uFE0F\u20E3",
    '1f51f': "\uD83D\uDD1F",
    '1f522': "\uD83D\uDD22",
    '23-20e3': "#\uFE0F\u20E3",
    '2a-20e3': "*\uFE0F\u20E3",
    '25b6': "\u25B6\uFE0F",
    '23f8': "\u23F8\uFE0F",
    '23ef': "\u23EF\uFE0F",
    '23f9': "\u23F9\uFE0F",
    '23fa': "\u23FA\uFE0F",
    '23cf': "\u23CF\uFE0F",
    '23ed': "\u23ED\uFE0F",
    '23ee': "\u23EE\uFE0F",
    '23e9': "\u23E9",
    '23ea': "\u23EA",
    '23eb': "\u23EB",
    '23ec': "\u23EC",
    '25c0': "\u25C0\uFE0F",
    '1f53c': "\uD83D\uDD3C",
    '1f53d': "\uD83D\uDD3D",
    '27a1': "\u27A1\uFE0F",
    '2b05': "\u2B05\uFE0F",
    '2b06': "\u2B06\uFE0F",
    '2b07': "\u2B07\uFE0F",
    '2197': "\u2197\uFE0F",
    '2198': "\u2198\uFE0F",
    '2199': "\u2199\uFE0F",
    '2196': "\u2196\uFE0F",
    '2195': "\u2195\uFE0F",
    '2194': "\u2194\uFE0F",
    '21aa': "\u21AA\uFE0F",
    '21a9': "\u21A9\uFE0F",
    '2934': "\u2934\uFE0F",
    '2935': "\u2935\uFE0F",
    '1f500': "\uD83D\uDD00",
    '1f501': "\uD83D\uDD01",
    '1f502': "\uD83D\uDD02",
    '1f504': "\uD83D\uDD04",
    '1f503': "\uD83D\uDD03",
    '1f3b5': "\uD83C\uDFB5",
    '1f3b6': "\uD83C\uDFB6",
    '2795': "\u2795",
    '2796': "\u2796",
    '2797': "\u2797",
    '2716': "\u2716\uFE0F",
    '1f4b2': "\uD83D\uDCB2",
    '1f4b1': "\uD83D\uDCB1",
    '2122': "\u2122\uFE0F",
    a9: "\xa9\uFE0F",
    ae: "\xae\uFE0F",
    '3030': "\u3030\uFE0F",
    '27b0': "\u27B0",
    '27bf': "\u27BF",
    '1f51a': "\uD83D\uDD1A",
    '1f519': "\uD83D\uDD19",
    '1f51b': "\uD83D\uDD1B",
    '1f51d': "\uD83D\uDD1D",
    '1f51c': "\uD83D\uDD1C",
    '2714': "\u2714\uFE0F",
    '2611': "\u2611\uFE0F",
    '1f518': "\uD83D\uDD18",
    '26aa': "\u26AA",
    '26ab': "\u26AB",
    '1f534': "\uD83D\uDD34",
    '1f535': "\uD83D\uDD35",
    '1f53a': "\uD83D\uDD3A",
    '1f53b': "\uD83D\uDD3B",
    '1f538': "\uD83D\uDD38",
    '1f539': "\uD83D\uDD39",
    '1f536': "\uD83D\uDD36",
    '1f537': "\uD83D\uDD37",
    '1f533': "\uD83D\uDD33",
    '1f532': "\uD83D\uDD32",
    '25aa': "\u25AA\uFE0F",
    '25ab': "\u25AB\uFE0F",
    '25fe': "\u25FE",
    '25fd': "\u25FD",
    '25fc': "\u25FC\uFE0F",
    '25fb': "\u25FB\uFE0F",
    '2b1b': "\u2B1B",
    '2b1c': "\u2B1C",
    '1f508': "\uD83D\uDD08",
    '1f507': "\uD83D\uDD07",
    '1f509': "\uD83D\uDD09",
    '1f50a': "\uD83D\uDD0A",
    '1f514': "\uD83D\uDD14",
    '1f515': "\uD83D\uDD15",
    '1f4e3': "\uD83D\uDCE3",
    '1f4e2': "\uD83D\uDCE2",
    '1f5e8': "\uD83D\uDDE8\uFE0F",
    '1f441-fe0f-200d-1f5e8-fe0f': "\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8\uFE0F",
    '1f4ac': "\uD83D\uDCAC",
    '1f4ad': "\uD83D\uDCAD",
    '1f5ef': "\uD83D\uDDEF\uFE0F",
    '2660': "\u2660\uFE0F",
    '2663': "\u2663\uFE0F",
    '2665': "\u2665\uFE0F",
    '2666': "\u2666\uFE0F",
    '1f0cf': "\uD83C\uDCCF",
    '1f3b4': "\uD83C\uDFB4",
    '1f004': "\uD83C\uDC04",
    '1f550': "\uD83D\uDD50",
    '1f551': "\uD83D\uDD51",
    '1f552': "\uD83D\uDD52",
    '1f553': "\uD83D\uDD53",
    '1f554': "\uD83D\uDD54",
    '1f555': "\uD83D\uDD55",
    '1f556': "\uD83D\uDD56",
    '1f557': "\uD83D\uDD57",
    '1f558': "\uD83D\uDD58",
    '1f559': "\uD83D\uDD59",
    '1f55a': "\uD83D\uDD5A",
    '1f55b': "\uD83D\uDD5B",
    '1f55c': "\uD83D\uDD5C",
    '1f55d': "\uD83D\uDD5D",
    '1f55e': "\uD83D\uDD5E",
    '1f55f': "\uD83D\uDD5F",
    '1f560': "\uD83D\uDD60",
    '1f561': "\uD83D\uDD61",
    '1f562': "\uD83D\uDD62",
    '1f563': "\uD83D\uDD63",
    '1f564': "\uD83D\uDD64",
    '1f565': "\uD83D\uDD65",
    '1f566': "\uD83D\uDD66",
    '1f567': "\uD83D\uDD67",
    '1f3f3': "\uD83C\uDFF3\uFE0F",
    '1f3f4': "\uD83C\uDFF4",
    '1f3c1': "\uD83C\uDFC1",
    '1f6a9': "\uD83D\uDEA9",
    '1f3f3-fe0f-200d-1f308': "\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08",
    '1f1e6-1f1eb': "\uD83C\uDDE6\uD83C\uDDEB",
    '1f1e6-1f1fd': "\uD83C\uDDE6\uD83C\uDDFD",
    '1f1e6-1f1f1': "\uD83C\uDDE6\uD83C\uDDF1",
    '1f1e9-1f1ff': "\uD83C\uDDE9\uD83C\uDDFF",
    '1f1e6-1f1f8': "\uD83C\uDDE6\uD83C\uDDF8",
    '1f1e6-1f1e9': "\uD83C\uDDE6\uD83C\uDDE9",
    '1f1e6-1f1f4': "\uD83C\uDDE6\uD83C\uDDF4",
    '1f1e6-1f1ee': "\uD83C\uDDE6\uD83C\uDDEE",
    '1f1e6-1f1f6': "\uD83C\uDDE6\uD83C\uDDF6",
    '1f1e6-1f1ec': "\uD83C\uDDE6\uD83C\uDDEC",
    '1f1e6-1f1f7': "\uD83C\uDDE6\uD83C\uDDF7",
    '1f1e6-1f1f2': "\uD83C\uDDE6\uD83C\uDDF2",
    '1f1e6-1f1fc': "\uD83C\uDDE6\uD83C\uDDFC",
    '1f1e6-1f1fa': "\uD83C\uDDE6\uD83C\uDDFA",
    '1f1e6-1f1f9': "\uD83C\uDDE6\uD83C\uDDF9",
    '1f1e6-1f1ff': "\uD83C\uDDE6\uD83C\uDDFF",
    '1f1e7-1f1f8': "\uD83C\uDDE7\uD83C\uDDF8",
    '1f1e7-1f1ed': "\uD83C\uDDE7\uD83C\uDDED",
    '1f1e7-1f1e9': "\uD83C\uDDE7\uD83C\uDDE9",
    '1f1e7-1f1e7': "\uD83C\uDDE7\uD83C\uDDE7",
    '1f1e7-1f1fe': "\uD83C\uDDE7\uD83C\uDDFE",
    '1f1e7-1f1ea': "\uD83C\uDDE7\uD83C\uDDEA",
    '1f1e7-1f1ff': "\uD83C\uDDE7\uD83C\uDDFF",
    '1f1e7-1f1ef': "\uD83C\uDDE7\uD83C\uDDEF",
    '1f1e7-1f1f2': "\uD83C\uDDE7\uD83C\uDDF2",
    '1f1e7-1f1f9': "\uD83C\uDDE7\uD83C\uDDF9",
    '1f1e7-1f1f4': "\uD83C\uDDE7\uD83C\uDDF4",
    '1f1e7-1f1e6': "\uD83C\uDDE7\uD83C\uDDE6",
    '1f1e7-1f1fc': "\uD83C\uDDE7\uD83C\uDDFC",
    '1f1e7-1f1f7': "\uD83C\uDDE7\uD83C\uDDF7",
    '1f1ee-1f1f4': "\uD83C\uDDEE\uD83C\uDDF4",
    '1f1fb-1f1ec': "\uD83C\uDDFB\uD83C\uDDEC",
    '1f1e7-1f1f3': "\uD83C\uDDE7\uD83C\uDDF3",
    '1f1e7-1f1ec': "\uD83C\uDDE7\uD83C\uDDEC",
    '1f1e7-1f1eb': "\uD83C\uDDE7\uD83C\uDDEB",
    '1f1e7-1f1ee': "\uD83C\uDDE7\uD83C\uDDEE",
    '1f1f0-1f1ed': "\uD83C\uDDF0\uD83C\uDDED",
    '1f1e8-1f1f2': "\uD83C\uDDE8\uD83C\uDDF2",
    '1f1e8-1f1e6': "\uD83C\uDDE8\uD83C\uDDE6",
    '1f1ee-1f1e8': "\uD83C\uDDEE\uD83C\uDDE8",
    '1f1e8-1f1fb': "\uD83C\uDDE8\uD83C\uDDFB",
    '1f1e7-1f1f6': "\uD83C\uDDE7\uD83C\uDDF6",
    '1f1f0-1f1fe': "\uD83C\uDDF0\uD83C\uDDFE",
    '1f1e8-1f1eb': "\uD83C\uDDE8\uD83C\uDDEB",
    '1f1f9-1f1e9': "\uD83C\uDDF9\uD83C\uDDE9",
    '1f1e8-1f1f1': "\uD83C\uDDE8\uD83C\uDDF1",
    '1f1e8-1f1f3': "\uD83C\uDDE8\uD83C\uDDF3",
    '1f1e8-1f1fd': "\uD83C\uDDE8\uD83C\uDDFD",
    '1f1e8-1f1e8': "\uD83C\uDDE8\uD83C\uDDE8",
    '1f1e8-1f1f4': "\uD83C\uDDE8\uD83C\uDDF4",
    '1f1f0-1f1f2': "\uD83C\uDDF0\uD83C\uDDF2",
    '1f1e8-1f1ec': "\uD83C\uDDE8\uD83C\uDDEC",
    '1f1e8-1f1e9': "\uD83C\uDDE8\uD83C\uDDE9",
    '1f1e8-1f1f0': "\uD83C\uDDE8\uD83C\uDDF0",
    '1f1e8-1f1f7': "\uD83C\uDDE8\uD83C\uDDF7",
    '1f1e8-1f1ee': "\uD83C\uDDE8\uD83C\uDDEE",
    '1f1ed-1f1f7': "\uD83C\uDDED\uD83C\uDDF7",
    '1f1e8-1f1fa': "\uD83C\uDDE8\uD83C\uDDFA",
    '1f1e8-1f1fc': "\uD83C\uDDE8\uD83C\uDDFC",
    '1f1e8-1f1fe': "\uD83C\uDDE8\uD83C\uDDFE",
    '1f1e8-1f1ff': "\uD83C\uDDE8\uD83C\uDDFF",
    '1f1e9-1f1f0': "\uD83C\uDDE9\uD83C\uDDF0",
    '1f1e9-1f1ef': "\uD83C\uDDE9\uD83C\uDDEF",
    '1f1e9-1f1f2': "\uD83C\uDDE9\uD83C\uDDF2",
    '1f1e9-1f1f4': "\uD83C\uDDE9\uD83C\uDDF4",
    '1f1ea-1f1e8': "\uD83C\uDDEA\uD83C\uDDE8",
    '1f1ea-1f1ec': "\uD83C\uDDEA\uD83C\uDDEC",
    '1f1f8-1f1fb': "\uD83C\uDDF8\uD83C\uDDFB",
    '1f1ec-1f1f6': "\uD83C\uDDEC\uD83C\uDDF6",
    '1f1ea-1f1f7': "\uD83C\uDDEA\uD83C\uDDF7",
    '1f1ea-1f1ea': "\uD83C\uDDEA\uD83C\uDDEA",
    '1f1ea-1f1f9': "\uD83C\uDDEA\uD83C\uDDF9",
    '1f1ea-1f1fa': "\uD83C\uDDEA\uD83C\uDDFA",
    '1f1eb-1f1f0': "\uD83C\uDDEB\uD83C\uDDF0",
    '1f1eb-1f1f4': "\uD83C\uDDEB\uD83C\uDDF4",
    '1f1eb-1f1ef': "\uD83C\uDDEB\uD83C\uDDEF",
    '1f1eb-1f1ee': "\uD83C\uDDEB\uD83C\uDDEE",
    '1f1eb-1f1f7': "\uD83C\uDDEB\uD83C\uDDF7",
    '1f1ec-1f1eb': "\uD83C\uDDEC\uD83C\uDDEB",
    '1f1f5-1f1eb': "\uD83C\uDDF5\uD83C\uDDEB",
    '1f1f9-1f1eb': "\uD83C\uDDF9\uD83C\uDDEB",
    '1f1ec-1f1e6': "\uD83C\uDDEC\uD83C\uDDE6",
    '1f1ec-1f1f2': "\uD83C\uDDEC\uD83C\uDDF2",
    '1f1ec-1f1ea': "\uD83C\uDDEC\uD83C\uDDEA",
    '1f1e9-1f1ea': "\uD83C\uDDE9\uD83C\uDDEA",
    '1f1ec-1f1ed': "\uD83C\uDDEC\uD83C\uDDED",
    '1f1ec-1f1ee': "\uD83C\uDDEC\uD83C\uDDEE",
    '1f1ec-1f1f7': "\uD83C\uDDEC\uD83C\uDDF7",
    '1f1ec-1f1f1': "\uD83C\uDDEC\uD83C\uDDF1",
    '1f1ec-1f1e9': "\uD83C\uDDEC\uD83C\uDDE9",
    '1f1ec-1f1f5': "\uD83C\uDDEC\uD83C\uDDF5",
    '1f1ec-1f1fa': "\uD83C\uDDEC\uD83C\uDDFA",
    '1f1ec-1f1f9': "\uD83C\uDDEC\uD83C\uDDF9",
    '1f1ec-1f1ec': "\uD83C\uDDEC\uD83C\uDDEC",
    '1f1ec-1f1f3': "\uD83C\uDDEC\uD83C\uDDF3",
    '1f1ec-1f1fc': "\uD83C\uDDEC\uD83C\uDDFC",
    '1f1ec-1f1fe': "\uD83C\uDDEC\uD83C\uDDFE",
    '1f1ed-1f1f9': "\uD83C\uDDED\uD83C\uDDF9",
    '1f1ed-1f1f3': "\uD83C\uDDED\uD83C\uDDF3",
    '1f1ed-1f1f0': "\uD83C\uDDED\uD83C\uDDF0",
    '1f1ed-1f1fa': "\uD83C\uDDED\uD83C\uDDFA",
    '1f1ee-1f1f8': "\uD83C\uDDEE\uD83C\uDDF8",
    '1f1ee-1f1f3': "\uD83C\uDDEE\uD83C\uDDF3",
    '1f1ee-1f1e9': "\uD83C\uDDEE\uD83C\uDDE9",
    '1f1ee-1f1f7': "\uD83C\uDDEE\uD83C\uDDF7",
    '1f1ee-1f1f6': "\uD83C\uDDEE\uD83C\uDDF6",
    '1f1ee-1f1ea': "\uD83C\uDDEE\uD83C\uDDEA",
    '1f1ee-1f1f2': "\uD83C\uDDEE\uD83C\uDDF2",
    '1f1ee-1f1f1': "\uD83C\uDDEE\uD83C\uDDF1",
    '1f1ee-1f1f9': "\uD83C\uDDEE\uD83C\uDDF9",
    '1f1ef-1f1f2': "\uD83C\uDDEF\uD83C\uDDF2",
    '1f1ef-1f1f5': "\uD83C\uDDEF\uD83C\uDDF5",
    '1f38c': "\uD83C\uDF8C",
    '1f1ef-1f1ea': "\uD83C\uDDEF\uD83C\uDDEA",
    '1f1ef-1f1f4': "\uD83C\uDDEF\uD83C\uDDF4",
    '1f1f0-1f1ff': "\uD83C\uDDF0\uD83C\uDDFF",
    '1f1f0-1f1ea': "\uD83C\uDDF0\uD83C\uDDEA",
    '1f1f0-1f1ee': "\uD83C\uDDF0\uD83C\uDDEE",
    '1f1fd-1f1f0': "\uD83C\uDDFD\uD83C\uDDF0",
    '1f1f0-1f1fc': "\uD83C\uDDF0\uD83C\uDDFC",
    '1f1f0-1f1ec': "\uD83C\uDDF0\uD83C\uDDEC",
    '1f1f1-1f1e6': "\uD83C\uDDF1\uD83C\uDDE6",
    '1f1f1-1f1fb': "\uD83C\uDDF1\uD83C\uDDFB",
    '1f1f1-1f1e7': "\uD83C\uDDF1\uD83C\uDDE7",
    '1f1f1-1f1f8': "\uD83C\uDDF1\uD83C\uDDF8",
    '1f1f1-1f1f7': "\uD83C\uDDF1\uD83C\uDDF7",
    '1f1f1-1f1fe': "\uD83C\uDDF1\uD83C\uDDFE",
    '1f1f1-1f1ee': "\uD83C\uDDF1\uD83C\uDDEE",
    '1f1f1-1f1f9': "\uD83C\uDDF1\uD83C\uDDF9",
    '1f1f1-1f1fa': "\uD83C\uDDF1\uD83C\uDDFA",
    '1f1f2-1f1f4': "\uD83C\uDDF2\uD83C\uDDF4",
    '1f1f2-1f1f0': "\uD83C\uDDF2\uD83C\uDDF0",
    '1f1f2-1f1ec': "\uD83C\uDDF2\uD83C\uDDEC",
    '1f1f2-1f1fc': "\uD83C\uDDF2\uD83C\uDDFC",
    '1f1f2-1f1fe': "\uD83C\uDDF2\uD83C\uDDFE",
    '1f1f2-1f1fb': "\uD83C\uDDF2\uD83C\uDDFB",
    '1f1f2-1f1f1': "\uD83C\uDDF2\uD83C\uDDF1",
    '1f1f2-1f1f9': "\uD83C\uDDF2\uD83C\uDDF9",
    '1f1f2-1f1ed': "\uD83C\uDDF2\uD83C\uDDED",
    '1f1f2-1f1f6': "\uD83C\uDDF2\uD83C\uDDF6",
    '1f1f2-1f1f7': "\uD83C\uDDF2\uD83C\uDDF7",
    '1f1f2-1f1fa': "\uD83C\uDDF2\uD83C\uDDFA",
    '1f1fe-1f1f9': "\uD83C\uDDFE\uD83C\uDDF9",
    '1f1f2-1f1fd': "\uD83C\uDDF2\uD83C\uDDFD",
    '1f1eb-1f1f2': "\uD83C\uDDEB\uD83C\uDDF2",
    '1f1f2-1f1e9': "\uD83C\uDDF2\uD83C\uDDE9",
    '1f1f2-1f1e8': "\uD83C\uDDF2\uD83C\uDDE8",
    '1f1f2-1f1f3': "\uD83C\uDDF2\uD83C\uDDF3",
    '1f1f2-1f1ea': "\uD83C\uDDF2\uD83C\uDDEA",
    '1f1f2-1f1f8': "\uD83C\uDDF2\uD83C\uDDF8",
    '1f1f2-1f1e6': "\uD83C\uDDF2\uD83C\uDDE6",
    '1f1f2-1f1ff': "\uD83C\uDDF2\uD83C\uDDFF",
    '1f1f2-1f1f2': "\uD83C\uDDF2\uD83C\uDDF2",
    '1f1f3-1f1e6': "\uD83C\uDDF3\uD83C\uDDE6",
    '1f1f3-1f1f7': "\uD83C\uDDF3\uD83C\uDDF7",
    '1f1f3-1f1f5': "\uD83C\uDDF3\uD83C\uDDF5",
    '1f1f3-1f1f1': "\uD83C\uDDF3\uD83C\uDDF1",
    '1f1f3-1f1e8': "\uD83C\uDDF3\uD83C\uDDE8",
    '1f1f3-1f1ff': "\uD83C\uDDF3\uD83C\uDDFF",
    '1f1f3-1f1ee': "\uD83C\uDDF3\uD83C\uDDEE",
    '1f1f3-1f1ea': "\uD83C\uDDF3\uD83C\uDDEA",
    '1f1f3-1f1ec': "\uD83C\uDDF3\uD83C\uDDEC",
    '1f1f3-1f1fa': "\uD83C\uDDF3\uD83C\uDDFA",
    '1f1f3-1f1eb': "\uD83C\uDDF3\uD83C\uDDEB",
    '1f1f0-1f1f5': "\uD83C\uDDF0\uD83C\uDDF5",
    '1f1f2-1f1f5': "\uD83C\uDDF2\uD83C\uDDF5",
    '1f1f3-1f1f4': "\uD83C\uDDF3\uD83C\uDDF4",
    '1f1f4-1f1f2': "\uD83C\uDDF4\uD83C\uDDF2",
    '1f1f5-1f1f0': "\uD83C\uDDF5\uD83C\uDDF0",
    '1f1f5-1f1fc': "\uD83C\uDDF5\uD83C\uDDFC",
    '1f1f5-1f1f8': "\uD83C\uDDF5\uD83C\uDDF8",
    '1f1f5-1f1e6': "\uD83C\uDDF5\uD83C\uDDE6",
    '1f1f5-1f1ec': "\uD83C\uDDF5\uD83C\uDDEC",
    '1f1f5-1f1fe': "\uD83C\uDDF5\uD83C\uDDFE",
    '1f1f5-1f1ea': "\uD83C\uDDF5\uD83C\uDDEA",
    '1f1f5-1f1ed': "\uD83C\uDDF5\uD83C\uDDED",
    '1f1f5-1f1f3': "\uD83C\uDDF5\uD83C\uDDF3",
    '1f1f5-1f1f1': "\uD83C\uDDF5\uD83C\uDDF1",
    '1f1f5-1f1f9': "\uD83C\uDDF5\uD83C\uDDF9",
    '1f1f5-1f1f7': "\uD83C\uDDF5\uD83C\uDDF7",
    '1f1f6-1f1e6': "\uD83C\uDDF6\uD83C\uDDE6",
    '1f1f7-1f1ea': "\uD83C\uDDF7\uD83C\uDDEA",
    '1f1f7-1f1f4': "\uD83C\uDDF7\uD83C\uDDF4",
    '1f1f7-1f1fa': "\uD83C\uDDF7\uD83C\uDDFA",
    '1f1f7-1f1fc': "\uD83C\uDDF7\uD83C\uDDFC",
    '1f1fc-1f1f8': "\uD83C\uDDFC\uD83C\uDDF8",
    '1f1f8-1f1f2': "\uD83C\uDDF8\uD83C\uDDF2",
    '1f1f8-1f1f9': "\uD83C\uDDF8\uD83C\uDDF9",
    '1f1f8-1f1e6': "\uD83C\uDDF8\uD83C\uDDE6",
    '1f1f8-1f1f3': "\uD83C\uDDF8\uD83C\uDDF3",
    '1f1f7-1f1f8': "\uD83C\uDDF7\uD83C\uDDF8",
    '1f1f8-1f1e8': "\uD83C\uDDF8\uD83C\uDDE8",
    '1f1f8-1f1f1': "\uD83C\uDDF8\uD83C\uDDF1",
    '1f1f8-1f1ec': "\uD83C\uDDF8\uD83C\uDDEC",
    '1f1f8-1f1fd': "\uD83C\uDDF8\uD83C\uDDFD",
    '1f1f8-1f1f0': "\uD83C\uDDF8\uD83C\uDDF0",
    '1f1f8-1f1ee': "\uD83C\uDDF8\uD83C\uDDEE",
    '1f1ec-1f1f8': "\uD83C\uDDEC\uD83C\uDDF8",
    '1f1f8-1f1e7': "\uD83C\uDDF8\uD83C\uDDE7",
    '1f1f8-1f1f4': "\uD83C\uDDF8\uD83C\uDDF4",
    '1f1ff-1f1e6': "\uD83C\uDDFF\uD83C\uDDE6",
    '1f1f0-1f1f7': "\uD83C\uDDF0\uD83C\uDDF7",
    '1f1f8-1f1f8': "\uD83C\uDDF8\uD83C\uDDF8",
    '1f1ea-1f1f8': "\uD83C\uDDEA\uD83C\uDDF8",
    '1f1f1-1f1f0': "\uD83C\uDDF1\uD83C\uDDF0",
    '1f1e7-1f1f1': "\uD83C\uDDE7\uD83C\uDDF1",
    '1f1f8-1f1ed': "\uD83C\uDDF8\uD83C\uDDED",
    '1f1f0-1f1f3': "\uD83C\uDDF0\uD83C\uDDF3",
    '1f1f1-1f1e8': "\uD83C\uDDF1\uD83C\uDDE8",
    '1f1f5-1f1f2': "\uD83C\uDDF5\uD83C\uDDF2",
    '1f1fb-1f1e8': "\uD83C\uDDFB\uD83C\uDDE8",
    '1f1f8-1f1e9': "\uD83C\uDDF8\uD83C\uDDE9",
    '1f1f8-1f1f7': "\uD83C\uDDF8\uD83C\uDDF7",
    '1f1f8-1f1ff': "\uD83C\uDDF8\uD83C\uDDFF",
    '1f1f8-1f1ea': "\uD83C\uDDF8\uD83C\uDDEA",
    '1f1e8-1f1ed': "\uD83C\uDDE8\uD83C\uDDED",
    '1f1f8-1f1fe': "\uD83C\uDDF8\uD83C\uDDFE",
    '1f1f9-1f1fc': "\uD83C\uDDF9\uD83C\uDDFC",
    '1f1f9-1f1ef': "\uD83C\uDDF9\uD83C\uDDEF",
    '1f1f9-1f1ff': "\uD83C\uDDF9\uD83C\uDDFF",
    '1f1f9-1f1ed': "\uD83C\uDDF9\uD83C\uDDED",
    '1f1f9-1f1f1': "\uD83C\uDDF9\uD83C\uDDF1",
    '1f1f9-1f1ec': "\uD83C\uDDF9\uD83C\uDDEC",
    '1f1f9-1f1f0': "\uD83C\uDDF9\uD83C\uDDF0",
    '1f1f9-1f1f4': "\uD83C\uDDF9\uD83C\uDDF4",
    '1f1f9-1f1f9': "\uD83C\uDDF9\uD83C\uDDF9",
    '1f1f9-1f1f3': "\uD83C\uDDF9\uD83C\uDDF3",
    '1f1f9-1f1f7': "\uD83C\uDDF9\uD83C\uDDF7",
    '1f1f9-1f1f2': "\uD83C\uDDF9\uD83C\uDDF2",
    '1f1f9-1f1e8': "\uD83C\uDDF9\uD83C\uDDE8",
    '1f1f9-1f1fb': "\uD83C\uDDF9\uD83C\uDDFB",
    '1f1fb-1f1ee': "\uD83C\uDDFB\uD83C\uDDEE",
    '1f1fa-1f1ec': "\uD83C\uDDFA\uD83C\uDDEC",
    '1f1fa-1f1e6': "\uD83C\uDDFA\uD83C\uDDE6",
    '1f1e6-1f1ea': "\uD83C\uDDE6\uD83C\uDDEA",
    '1f1ec-1f1e7': "\uD83C\uDDEC\uD83C\uDDE7",
    '1f1fa-1f1f8': "\uD83C\uDDFA\uD83C\uDDF8",
    '1f1fa-1f1fe': "\uD83C\uDDFA\uD83C\uDDFE",
    '1f1fa-1f1ff': "\uD83C\uDDFA\uD83C\uDDFF",
    '1f1fb-1f1fa': "\uD83C\uDDFB\uD83C\uDDFA",
    '1f1fb-1f1e6': "\uD83C\uDDFB\uD83C\uDDE6",
    '1f1fb-1f1ea': "\uD83C\uDDFB\uD83C\uDDEA",
    '1f1fb-1f1f3': "\uD83C\uDDFB\uD83C\uDDF3",
    '1f1fc-1f1eb': "\uD83C\uDDFC\uD83C\uDDEB",
    '1f1ea-1f1ed': "\uD83C\uDDEA\uD83C\uDDED",
    '1f1fe-1f1ea': "\uD83C\uDDFE\uD83C\uDDEA",
    '1f1ff-1f1f2': "\uD83C\uDDFF\uD83C\uDDF2",
    '1f1ff-1f1fc': "\uD83C\uDDFF\uD83C\uDDFC",
    '1f1e6-1f1e8': "\uD83C\uDDE6\uD83C\uDDE8",
    '1f1f9-1f1e6': "\uD83C\uDDF9\uD83C\uDDE6",
    '1f1e7-1f1fb': "\uD83C\uDDE7\uD83C\uDDFB",
    '1f1ed-1f1f2': "\uD83C\uDDED\uD83C\uDDF2",
    '1f1f8-1f1ef': "\uD83C\uDDF8\uD83C\uDDEF",
    '1f1fa-1f1f2': "\uD83C\uDDFA\uD83C\uDDF2",
    '1f1ea-1f1e6': "\uD83C\uDDEA\uD83C\uDDE6",
    '1f1e8-1f1f5': "\uD83C\uDDE8\uD83C\uDDF5",
    '1f1e9-1f1ec': "\uD83C\uDDE9\uD83C\uDDEC",
    '1f1f2-1f1eb': "\uD83C\uDDF2\uD83C\uDDEB",
    '1f1fa-1f1f3': "\uD83C\uDDFA\uD83C\uDDF3",
    '1f3f4-e0067-e0062-e0065-e006e-e0067-e007f': "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67\uDB40\uDC7F",
    '1f3f4-e0067-e0062-e0073-e0063-e0074-e007f': "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74\uDB40\uDC7F",
    '1f3f4-e0067-e0062-e0077-e006c-e0073-e007f': "\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73\uDB40\uDC7F",
    '1f1ff': "\uD83C\uDDFF",
    '1f1fe': "\uD83C\uDDFE",
    '1f1fd': "\uD83C\uDDFD",
    '1f3fb': "\uD83C\uDFFB",
    '1f3fc': "\uD83C\uDFFC",
    '1f3fd': "\uD83C\uDFFD",
    '1f3fe': "\uD83C\uDFFE",
    '1f3ff': "\uD83C\uDFFF",
    '1f1fc': "\uD83C\uDDFC",
    '1f1fb': "\uD83C\uDDFB",
    '1f1fa': "\uD83C\uDDFA",
    '1f1f9': "\uD83C\uDDF9",
    '1f1f8': "\uD83C\uDDF8",
    '1f1f7': "\uD83C\uDDF7",
    '1f1f6': "\uD83C\uDDF6",
    '1f1f5': "\uD83C\uDDF5",
    '1f1f4': "\uD83C\uDDF4",
    '1f1f3': "\uD83C\uDDF3",
    '1f1f2': "\uD83C\uDDF2",
    '1f1f1': "\uD83C\uDDF1",
    '1f1f0': "\uD83C\uDDF0",
    '1f1ef': "\uD83C\uDDEF",
    '1f1ee': "\uD83C\uDDEE",
    '1f1ed': "\uD83C\uDDED",
    '1f1ec': "\uD83C\uDDEC",
    '1f1eb': "\uD83C\uDDEB",
    '1f1ea': "\uD83C\uDDEA",
    '1f1e9': "\uD83C\uDDE9",
    '1f1e8': "\uD83C\uDDE8",
    '1f1e7': "\uD83C\uDDE7",
    '1f1e6': "\uD83C\uDDE6",
    '2640': "\u2640\uFE0F",
    '2642': "\u2642\uFE0F",
    '2695': "\u2695\uFE0F",
    '1f468-200d-1f469-200d-1f466': "\uD83D\uDC68\u200D\uD83D\uDC69\u200D\uD83D\uDC66",
    '1f469-200d-2764-fe0f-200d-1f468': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC68",
    '1f469-200d-2764-fe0f-200d-1f48b-200d-1f468': "\uD83D\uDC69\u200D\u2764\uFE0F\u200D\uD83D\uDC8B\u200D\uD83D\uDC68",
    '1f928': "\uD83E\uDD28",
    '1f929': "\uD83E\uDD29",
    '1f92a': "\uD83E\uDD2A",
    '1f92b': "\uD83E\uDD2B",
    '1f92c': "\uD83E\uDD2C",
    '1f92d': "\uD83E\uDD2D",
    '1f92e': "\uD83E\uDD2E",
    '1f92f': "\uD83E\uDD2F",
    '1f9d0': "\uD83E\uDDD0",
    '1f9d1': "\uD83E\uDDD1",
    '1f9d2': "\uD83E\uDDD2",
    '1f9d3': "\uD83E\uDDD3",
    '1f9d4': "\uD83E\uDDD4",
    '1f9d5': "\uD83E\uDDD5",
    '1f9e0': "\uD83E\uDDE0",
    '1f9e2': "\uD83E\uDDE2",
    '1f9d9': "\uD83E\uDDD9",
    '1f9da': "\uD83E\uDDDA",
    '1f9db': "\uD83E\uDDDB",
    '1f9dc': "\uD83E\uDDDC",
    '1f9dd': "\uD83E\uDDDD",
    '1f9de': "\uD83E\uDDDE",
    '1f9df': "\uD83E\uDDDF",
    '1f9e3': "\uD83E\uDDE3",
    '1f9e4': "\uD83E\uDDE4",
    '1f9e5': "\uD83E\uDDE5",
    '1f9e6': "\uD83E\uDDE6",
    '1f91f': "\uD83E\uDD1F",
    '1f932': "\uD83E\uDD32",
    '1f9d9-200d-2640-fe0f': "\uD83E\uDDD9\u200D\u2640\uFE0F",
    '1f9d9-200d-2642-fe0f': "\uD83E\uDDD9\u200D\u2642\uFE0F",
    '1f9da-200d-2640-fe0f': "\uD83E\uDDDA\u200D\u2640\uFE0F",
    '1f9da-200d-2642-fe0f': "\uD83E\uDDDA\u200D\u2642\uFE0F",
    '1f9db-200d-2640-fe0f': "\uD83E\uDDDB\u200D\u2640\uFE0F",
    '1f9db-200d-2642-fe0f': "\uD83E\uDDDB\u200D\u2642\uFE0F",
    '1f9dc-200d-2640-fe0f': "\uD83E\uDDDC\u200D\u2640\uFE0F",
    '1f9dc-200d-2642-fe0f': "\uD83E\uDDDC\u200D\u2642\uFE0F",
    '1f9dd-200d-2640-fe0f': "\uD83E\uDDDD\u200D\u2640\uFE0F",
    '1f9dd-200d-2642-fe0f': "\uD83E\uDDDD\u200D\u2642\uFE0F",
    '1f9de-200d-2640-fe0f': "\uD83E\uDDDE\u200D\u2640\uFE0F",
    '1f9de-200d-2642-fe0f': "\uD83E\uDDDE\u200D\u2642\uFE0F",
    '1f9df-200d-2640-fe0f': "\uD83E\uDDDF\u200D\u2640\uFE0F",
    '1f9df-200d-2642-fe0f': "\uD83E\uDDDF\u200D\u2642\uFE0F",
    'atlassian-check_mark': '(/)',
    'atlassian-cross_mark': '(x)',
    'atlassian-plus': '(+)',
    'atlassian-minus': '(-)',
    'atlassian-light_bulb_on': '(on)',
    'atlassian-light_bulb_off': '(off)',
    'atlassian-flag_on': '(flag)',
    'atlassian-flag_off': '(flagoff)',
    'atlassian-warning': '(!)',
    'atlassian-question_mark': '(?)',
    'atlassian-info': '(i)',
    'atlassian-yellow_star': '(*y)',
    'atlassian-blue_star': '(*b)',
    'atlassian-green_star': '(*g)',
    'atlassian-red_star': '(*r)'
};

});

parcelRegister("dMxC6", function(module, exports) {

$parcel$export(module.exports, "unknown", () => $2f836652b9d598ce$export$19282c40b967aec6);

var $3M3qX = parcelRequire("3M3qX");
const $2f836652b9d598ce$var$jsonTransformer = new (0, $3M3qX.JSONTransformer)();
const $2f836652b9d598ce$export$19282c40b967aec6 = (node)=>{
    const content = JSON.stringify($2f836652b9d598ce$var$jsonTransformer.encodeNode(node));
    return node.isBlock ? `{adf:display=block}
${content}
{adf}` : `{adf:display=inline}${content}{adf}`;
};

});


parcelRegister("7iOup", function(module, exports) {

$parcel$export(module.exports, "hardBreak", () => $74a31cb47faf2ba8$export$371da9dd35aba193);
const $74a31cb47faf2ba8$export$371da9dd35aba193 = (_node)=>{
    return '\n';
};

});

parcelRegister("hR5ia", function(module, exports) {

$parcel$export(module.exports, "mediaInline", () => $fffd1208a8d23668$export$38bab695e3f720f1);
const $fffd1208a8d23668$export$38bab695e3f720f1 = (node, { context: context } = {})=>{
    let fileName;
    fileName = context?.conversion?.mediaConversion?.[node.attrs.id]?.transform ?? node.attrs.id;
    return `[^${fileName}]`;
};

});

parcelRegister("6iCyo", function(module, exports) {

$parcel$export(module.exports, "mention", () => $4b87f050fe0e4cf1$export$db83999c14438df4);
const $4b87f050fe0e4cf1$var$PREFIX = 'accountid:';
const $4b87f050fe0e4cf1$var$UNKNOWN_USER = 'UNKNOWN_USER';
const $4b87f050fe0e4cf1$var$addPrefix = (content)=>content.toLowerCase().startsWith($4b87f050fe0e4cf1$var$PREFIX) ? content : `${$4b87f050fe0e4cf1$var$PREFIX}${content}`;
const $4b87f050fe0e4cf1$export$db83999c14438df4 = (node, { context: context } = {})=>{
    if (node.attrs.id === $4b87f050fe0e4cf1$var$UNKNOWN_USER) return `[~${node.attrs.id}]`;
    const mentionKey = node.attrs.id.toLowerCase();
    const content = context && context.conversion && context.conversion.mentionConversion && context.conversion.mentionConversion[mentionKey] ? context.conversion.mentionConversion[mentionKey] : $4b87f050fe0e4cf1$var$addPrefix(node.attrs.id);
    return `[~${content}]`;
};

});

parcelRegister("k7Yq1", function(module, exports) {

$parcel$export(module.exports, "text", () => $ce8d8da7c26e4e0f$export$6f093cfa640b7166);

var $2ROXs = parcelRequire("2ROXs");

var $hf3v9 = parcelRequire("hf3v9");

var $sS3Yw = parcelRequire("sS3Yw");

var $lWqfN = parcelRequire("lWqfN");

var $9hhDh = parcelRequire("9hhDh");

var $aiUyl = parcelRequire("aiUyl");

var $4fuiB = parcelRequire("4fuiB");

var $gUCSO = parcelRequire("gUCSO");

var $ijIl1 = parcelRequire("ijIl1");
/**
 * The order of the mapping matters.
 * For example, textColor will be a macro {color} so
 * we want to process other marks before it.
 */ const $ce8d8da7c26e4e0f$var$markEncoderMapping = new Map([
    [
        'em',
        (0, $lWqfN.em)
    ],
    [
        'strike',
        (0, $aiUyl.strike)
    ],
    [
        'strong',
        (0, $4fuiB.strong)
    ],
    [
        'subsup',
        (0, $gUCSO.subsup)
    ],
    [
        'underline',
        (0, $ijIl1.underline)
    ],
    [
        'textColor',
        (0, $sS3Yw.textColor)
    ],
    [
        'link',
        (0, $9hhDh.link)
    ],
    [
        'code',
        (0, $hf3v9.code)
    ]
]);
/**
 * ADFEXP-131: Improved logic for escaping metacharacters "[" and "!"
 * Before this change, any instance of "[" and "!" was being escaped
 * "[" is used for mentions
 * "!" is used for media
 */ const $ce8d8da7c26e4e0f$var$MENTION_ESCAPE_PATTERN = '(\\[~)'; // Matches pattern like [~
const $ce8d8da7c26e4e0f$var$MEDIA_ESCAPE_PATTERN = '(![^ !]+)(!)'; // Matches non space content between two consecutive "!" e.g. !filename.txt!
const $ce8d8da7c26e4e0f$var$MEDIA_GROUP_ESCAPE_PATTERN = '(\\[\\^[^ ]+)(\\])'; // Matches non space content between two consecutive "[^" "]" e.g. [^filename.txt]
/**
 * Checks if the node's content needs to be escaped before continuing processing.
 * Currently, the `code` mark and `codeBlock` nodes handle their own escaping, and
 * therefore, should not be escaped here.
 *
 * @param node the current node to encode
 * @param parent the parent node, if exist
 * @returns true if the node should have its text escaped when encoding to wikimarkup.
 */ const $ce8d8da7c26e4e0f$var$isEscapeNeeded = (node, parent)=>{
    return !(parent && parent.type.name === 'codeBlock' || node.marks.find((m)=>m.type.name === 'code') !== undefined);
};
/**
 * ESS-2569: Removing the backsalshes from the regex
 * ADFEXP-131: Improved logic for escaping metacharacters "[" and "!"
 */ function $ce8d8da7c26e4e0f$var$escapingWikiFormatter(text) {
    const pattern = [
        $ce8d8da7c26e4e0f$var$MENTION_ESCAPE_PATTERN,
        ...(0, $2ROXs.macroKeywordTokenMap).map((macro)=>`(${macro.regex.source.replace('^', '')})`)
    ].join('|');
    return text.replace(new RegExp(pattern, 'g'), '\\$&').replace(new RegExp($ce8d8da7c26e4e0f$var$MEDIA_ESCAPE_PATTERN, 'g'), '\\$1\\$2') // Extra step required for media as currently both ends need to be escaped e.q. !filename.txt!
    .replace(new RegExp($ce8d8da7c26e4e0f$var$MEDIA_GROUP_ESCAPE_PATTERN, 'g'), '\\$1\\$2');
}
const $ce8d8da7c26e4e0f$export$6f093cfa640b7166 = (node, { parent: parent } = {})=>{
    let result = $ce8d8da7c26e4e0f$var$isEscapeNeeded(node, parent) ? $ce8d8da7c26e4e0f$var$escapingWikiFormatter(node.text) : node.text;
    $ce8d8da7c26e4e0f$var$markEncoderMapping.forEach((encoder, markName)=>{
        const mark = node.marks.find((m)=>m.type.name === markName);
        if (mark) result = encoder(result, mark.attrs);
    });
    return result;
};

});
parcelRegister("2ROXs", function(module, exports) {

$parcel$export(module.exports, "macroKeywordTokenMap", () => $9d1fbe0593fabb36$export$afcd7edeca61ca93);
$parcel$export(module.exports, "parseMacroKeyword", () => $9d1fbe0593fabb36$export$39c29c0b4f759e52);
$parcel$export(module.exports, "parseOtherKeyword", () => $9d1fbe0593fabb36$export$ce89e528658ee2ac);
$parcel$export(module.exports, "parseLeadingKeyword", () => $9d1fbe0593fabb36$export$68162fc57528b560);
$parcel$export(module.exports, "parseIssueKeyword", () => $9d1fbe0593fabb36$export$bcec6d03770b152c);

var $lS4Zv = parcelRequire("lS4Zv");

var $3O0Q2 = parcelRequire("3O0Q2");
const $9d1fbe0593fabb36$export$afcd7edeca61ca93 = [
    {
        type: (0, $lS4Zv.TokenType).ADF_MACRO,
        regex: /^{adf/i
    },
    {
        type: (0, $lS4Zv.TokenType).ANCHOR_MACRO,
        regex: /^{anchor/i
    },
    {
        type: (0, $lS4Zv.TokenType).CODE_MACRO,
        regex: /^{code/i
    },
    {
        type: (0, $lS4Zv.TokenType).QUOTE_MACRO,
        regex: /^{quote/i
    },
    {
        type: (0, $lS4Zv.TokenType).NOFORMAT_MACRO,
        regex: /^{noformat/i
    },
    {
        type: (0, $lS4Zv.TokenType).PANEL_MACRO,
        regex: /^{panel/i
    },
    {
        type: (0, $lS4Zv.TokenType).COLOR_MACRO,
        regex: /^{color/
    },
    {
        type: (0, $lS4Zv.TokenType).LOREM_MACRO,
        regex: /^{loremipsum/i
    }
];
/**
 * The order of this mapping determind which keyword
 * will be checked first, so it matters.
 */ const $9d1fbe0593fabb36$var$keywordTokenMap = {
    '[': (0, $lS4Zv.TokenType).LINK_FORMAT,
    http: (0, $lS4Zv.TokenType).LINK_TEXT,
    ftp: (0, $lS4Zv.TokenType).LINK_TEXT,
    jamfselfservice: (0, $lS4Zv.TokenType).LINK_TEXT,
    irc: (0, $lS4Zv.TokenType).LINK_TEXT,
    mailto: (0, $lS4Zv.TokenType).LINK_TEXT,
    '\\\\': (0, $lS4Zv.TokenType).FORCE_LINE_BREAK,
    '\r': (0, $lS4Zv.TokenType).HARD_BREAK,
    '\n': (0, $lS4Zv.TokenType).HARD_BREAK,
    '\r\n': (0, $lS4Zv.TokenType).HARD_BREAK,
    '!': (0, $lS4Zv.TokenType).MEDIA,
    '----': (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL,
    '---': (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
    '--': (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
    '{-}': (0, $lS4Zv.TokenType).DELETED,
    '{+}': (0, $lS4Zv.TokenType).INSERTED,
    '{*}': (0, $lS4Zv.TokenType).STRONG,
    '{^}': (0, $lS4Zv.TokenType).SUPERSCRIPT,
    '{~}': (0, $lS4Zv.TokenType).SUBSCRIPT,
    '{_}': (0, $lS4Zv.TokenType).EMPHASIS,
    '{{{}': (0, $lS4Zv.TokenType).MONOSPACE,
    '{??}': (0, $lS4Zv.TokenType).CITATION,
    '-': (0, $lS4Zv.TokenType).DELETED,
    '+': (0, $lS4Zv.TokenType).INSERTED,
    '*': (0, $lS4Zv.TokenType).STRONG,
    '^': (0, $lS4Zv.TokenType).SUPERSCRIPT,
    '~': (0, $lS4Zv.TokenType).SUBSCRIPT,
    _: (0, $lS4Zv.TokenType).EMPHASIS,
    '{{': (0, $lS4Zv.TokenType).MONOSPACE,
    '??': (0, $lS4Zv.TokenType).CITATION
};
const $9d1fbe0593fabb36$var$keywordTokenMapKeys = Object.keys($9d1fbe0593fabb36$var$keywordTokenMap);
function $9d1fbe0593fabb36$export$39c29c0b4f759e52(input) {
    for(let i = 0; i < $9d1fbe0593fabb36$export$afcd7edeca61ca93.length; i++){
        const keyword = $9d1fbe0593fabb36$export$afcd7edeca61ca93[i];
        if (keyword.regex.test(input)) return {
            type: keyword.type
        };
    }
    return null;
}
function $9d1fbe0593fabb36$export$ce89e528658ee2ac(input) {
    for(let i = 0; i < $9d1fbe0593fabb36$var$keywordTokenMapKeys.length; i++){
        if (input.startsWith($9d1fbe0593fabb36$var$keywordTokenMapKeys[i])) return {
            type: $9d1fbe0593fabb36$var$keywordTokenMap[$9d1fbe0593fabb36$var$keywordTokenMapKeys[i]]
        };
    }
    // Look for a emoji
    const char = input.charAt(0);
    if ([
        ':',
        '(',
        ';'
    ].indexOf(char) !== -1) return {
        // This potentially can be a emoji. The emoji parser will fail out if it's not
        type: (0, $lS4Zv.TokenType).EMOJI
    };
    return null;
}
/**
 * These keywords only take effect when it's at the
 * beginning of the line
 * The order of the mapping matters. We should not put
 * LIST in front of RULER for example.
 */ const $9d1fbe0593fabb36$var$leadingKeywordTokenMap = [
    {
        type: (0, $lS4Zv.TokenType).QUOTE,
        regex: /^bq\./
    },
    {
        type: (0, $lS4Zv.TokenType).HEADING,
        regex: /^h[1-6]\./
    },
    {
        type: (0, $lS4Zv.TokenType).RULER,
        regex: /^-{4,5}(\s|$)/
    },
    {
        type: (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
        regex: /^-{3}\s/
    },
    {
        type: (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
        regex: /^-{2}\s/
    },
    {
        // Lists are limited to max 20 levels of depth
        type: (0, $lS4Zv.TokenType).LIST,
        regex: new RegExp(`^([*#]{1,${(0, $3O0Q2.MAX_LIST_DEPTH)}}|-) `)
    },
    {
        type: (0, $lS4Zv.TokenType).TABLE,
        regex: /^\|{1,2}/
    }
];
function $9d1fbe0593fabb36$export$68162fc57528b560(input) {
    for(let i = 0; i < $9d1fbe0593fabb36$var$leadingKeywordTokenMap.length; i++){
        const keyword = $9d1fbe0593fabb36$var$leadingKeywordTokenMap[i];
        if (keyword.regex.test(input)) return {
            type: keyword.type
        };
    }
    return null;
}
function $9d1fbe0593fabb36$export$bcec6d03770b152c(input, issueKeyRegex) {
    if (issueKeyRegex && issueKeyRegex.test(input)) return {
        type: (0, $lS4Zv.TokenType).ISSUE_KEY
    };
    return null;
}

});
parcelRegister("lS4Zv", function(module, exports) {

$parcel$export(module.exports, "TokenType", () => $845998d063b9ab8b$export$f435f793048e7a0f);
$parcel$export(module.exports, "parseToken", () => $845998d063b9ab8b$export$af8f4e8328578827);

var $iw2bq = parcelRequire("iw2bq");

var $fxycA = parcelRequire("fxycA");

var $a4Ddm = parcelRequire("a4Ddm");

var $70iSu = parcelRequire("70iSu");

var $bufmJ = parcelRequire("bufmJ");

var $jPNoV = parcelRequire("jPNoV");

var $gJccQ = parcelRequire("gJccQ");

var $g0NwP = parcelRequire("g0NwP");

var $jCitd = parcelRequire("jCitd");

var $r2pEr = parcelRequire("r2pEr");

var $lccs8 = parcelRequire("lccs8");

var $crpDl = parcelRequire("crpDl");

var $3O0Q2 = parcelRequire("3O0Q2");

var $kJ7iC = parcelRequire("kJ7iC");

var $lDSkN = parcelRequire("lDSkN");

var $eyWXo = parcelRequire("eyWXo");

var $66xYR = parcelRequire("66xYR");

var $jWDvo = parcelRequire("jWDvo");

var $4333j = parcelRequire("4333j");

var $VuFCw = parcelRequire("VuFCw");

var $gakJc = parcelRequire("gakJc");

var $j2mJE = parcelRequire("j2mJE");

var $a5fMg = parcelRequire("a5fMg");

var $adHlr = parcelRequire("adHlr");

var $48Szy = parcelRequire("48Szy");

var $3ZquL = parcelRequire("3ZquL");

var $cvl2z = parcelRequire("cvl2z");

var $5PrNl = parcelRequire("5PrNl");

var $eTIGc = parcelRequire("eTIGc");

var $4RTci = parcelRequire("4RTci");
var $845998d063b9ab8b$export$f435f793048e7a0f;
(function(TokenType) {
    TokenType["ADF_MACRO"] = "ADF_MACRO";
    TokenType["ANCHOR_MACRO"] = "ANCHOR_MACRO";
    TokenType["CODE_MACRO"] = "CODE_MACRO";
    TokenType["QUOTE_MACRO"] = "QUOTE_MACRO";
    TokenType["NOFORMAT_MACRO"] = "NOFORMAT_MACRO";
    TokenType["PANEL_MACRO"] = "PANEL_MACRO";
    TokenType["COLOR_MACRO"] = "COLOR_MACRO";
    TokenType["LOREM_MACRO"] = "LOREM_MACRO";
    TokenType["QUOTE"] = "QUOTE";
    TokenType["STRING"] = "STRING";
    TokenType["ISSUE_KEY"] = "ISSUE_KEY";
    TokenType["LINK_FORMAT"] = "LINK_FORMAT";
    TokenType["LINK_TEXT"] = "LINK_TEXT";
    TokenType["MEDIA"] = "MEDIA";
    TokenType["HEADING"] = "HEADING";
    TokenType["LIST"] = "LIST";
    TokenType["TABLE"] = "TABLE";
    TokenType["RULER"] = "RULER";
    TokenType["HARD_BREAK"] = "HARD_BREAK";
    TokenType["DOUBLE_DASH_SYMBOL"] = "DOUBLE_DASH_SYMBOL";
    TokenType["TRIPLE_DASH_SYMBOL"] = "TRIPLE_DASH_SYMBOL";
    TokenType["QUADRUPLE_DASH_SYMBOL"] = "QUADRUPLE_DASH_SYMBOL";
    TokenType["STRONG"] = "STRONG";
    TokenType["MONOSPACE"] = "MONOSPACE";
    TokenType["SUPERSCRIPT"] = "SUPERSCRIPT";
    TokenType["SUBSCRIPT"] = "SUBSCRIPT";
    TokenType["EMPHASIS"] = "EMPHASIS";
    TokenType["CITATION"] = "CITATION";
    TokenType["DELETED"] = "DELETED";
    TokenType["INSERTED"] = "INSERTED";
    TokenType["EMOJI"] = "EMOJI";
    TokenType["FORCE_LINE_BREAK"] = "FORCE_LINE_BREAK";
})($845998d063b9ab8b$export$f435f793048e7a0f || ($845998d063b9ab8b$export$f435f793048e7a0f = {}));
const $845998d063b9ab8b$var$tokenToTokenParserMapping = {
    ["DOUBLE_DASH_SYMBOL"]: (0, $bufmJ.doubleDashSymbol),
    ["TRIPLE_DASH_SYMBOL"]: (0, $gakJc.tripleDashSymbol),
    ["QUADRUPLE_DASH_SYMBOL"]: (0, $lDSkN.quadrupleDashSymbol),
    ["RULER"]: (0, $eyWXo.ruler),
    ["STRONG"]: (0, $66xYR.strong),
    ["MONOSPACE"]: (0, $kJ7iC.monospace),
    ["SUPERSCRIPT"]: (0, $4333j.superscript),
    ["SUBSCRIPT"]: (0, $jWDvo.subscript),
    ["EMPHASIS"]: (0, $gJccQ.emphasis),
    ["CITATION"]: (0, $a4Ddm.citation),
    ["DELETED"]: (0, $70iSu.deleted),
    ["INSERTED"]: (0, $r2pEr.inserted),
    ["HARD_BREAK"]: (0, $g0NwP.hardbreak),
    ["LINK_FORMAT"]: (0, $lccs8.linkFormat),
    ["LINK_TEXT"]: (0, $crpDl.linkText),
    ["HEADING"]: (0, $jCitd.heading),
    ["MEDIA"]: (0, $iw2bq.media),
    ["LIST"]: (0, $3O0Q2.list),
    ["QUOTE"]: (0, $fxycA.blockquote),
    ["TABLE"]: (0, $VuFCw.table),
    ["EMOJI"]: (0, $jPNoV.emoji),
    ["ADF_MACRO"]: (0, $a5fMg.adfMacro),
    ["ANCHOR_MACRO"]: (0, $adHlr.anchorMacro),
    ["CODE_MACRO"]: (0, $48Szy.codeMacro),
    ["QUOTE_MACRO"]: (0, $3ZquL.quoteMacro),
    ["NOFORMAT_MACRO"]: (0, $5PrNl.noformatMacro),
    ["PANEL_MACRO"]: (0, $j2mJE.panelMacro),
    ["COLOR_MACRO"]: (0, $cvl2z.colorMacro),
    ["FORCE_LINE_BREAK"]: (0, $eTIGc.forceLineBreak),
    ["ISSUE_KEY"]: (0, $4RTci.issueKey)
};
function $845998d063b9ab8b$export$af8f4e8328578827(input, type, position, schema, context) {
    const tokenParser = $845998d063b9ab8b$var$tokenToTokenParserMapping[type];
    if (tokenParser) try {
        return tokenParser({
            input: input,
            position: position,
            schema: schema,
            context: context
        });
    } catch (err) {
        if (context.tokenErrCallback && err instanceof Error) context.tokenErrCallback(err, type);
        return $845998d063b9ab8b$var$fallback(input, position);
    }
    return $845998d063b9ab8b$var$fallback(input, position);
}
function $845998d063b9ab8b$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}

});
parcelRegister("iw2bq", function(module, exports) {

$parcel$export(module.exports, "media", () => $7fde38853f3c310a$export$987d49ffe1b0900f);

var $1hrvA = parcelRequire("1hrvA");

var $dFOSZ = parcelRequire("dFOSZ");

var $cndSn = parcelRequire("cndSn");
const $7fde38853f3c310a$export$987d49ffe1b0900f = ({ input: input, position: position, schema: schema, context: context })=>{
    const rawContentProcessor = (raw, length)=>{
        /**
		 * !image.gif|align=right, vspace=4|ignore-this!
		 * If it splits into more than 2 items, we ignore the rest
		 */ const [rawContent, rawAttrs = ''] = raw.split('|');
        const node = (0, $1hrvA.default)(schema, rawContent, (0, $dFOSZ.parseAttrs)(rawAttrs, ','), context);
        return {
            type: 'pmnode',
            nodes: [
                node
            ],
            length: length
        };
    };
    return (0, $cndSn.commonFormatter)(input, position, schema, {
        opening: '!',
        closing: '!',
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});
parcelRegister("1hrvA", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b0fc5f200f5aa47$export$2e2bcd8739ae039);

var $crpDl = parcelRequire("crpDl");
const $6b0fc5f200f5aa47$var$defaultWidth = 200;
const $6b0fc5f200f5aa47$var$defaultHeight = 183;
const $6b0fc5f200f5aa47$var$clamp = (input, lower, upper)=>{
    if (upper !== undefined) input = input <= upper ? input : upper;
    if (lower !== undefined) input = input >= lower ? input : lower;
    return input;
};
function $6b0fc5f200f5aa47$export$2e2bcd8739ae039(schema, filename, attrs, context = {}) {
    const { media: media, mediaSingle: mediaSingle } = schema.nodes;
    const { link: link } = schema.marks;
    const mediaMarks = [];
    let mediaNodeAttrs = {};
    if (context?.defaults?.media?.width !== null) mediaNodeAttrs.width = context?.defaults?.media?.width ?? $6b0fc5f200f5aa47$var$defaultWidth;
    if (context?.defaults?.media?.height !== null) mediaNodeAttrs.height = context?.defaults?.media?.height ?? $6b0fc5f200f5aa47$var$defaultHeight;
    const mediaSingleAttrs = {
        layout: 'center'
    };
    if (attrs.width && attrs.width.endsWith('%')) {
        const parsed = parseInt(attrs.width, 10);
        if (!isNaN(parsed)) mediaSingleAttrs.width = $6b0fc5f200f5aa47$var$clamp(parsed, 0, 100);
        mediaNodeAttrs = {};
    } else {
        if (attrs.width) {
            const parsed = parseInt(attrs.width, 10);
            if (!isNaN(parsed)) mediaNodeAttrs.width = parsed;
        }
        if (attrs.height) {
            const parsed = parseInt(attrs.height, 10);
            if (!isNaN(parsed)) mediaNodeAttrs.height = parsed;
        }
    }
    if (attrs.href) {
        const href = attrs.href.replace(/^"(.+)"$/, '$1');
        mediaMarks.push(link.create({
            href: href
        }));
    }
    if (attrs.alt) {
        // strip wrapping quotes if they exist
        const altText = attrs.alt.replace(/^"(.+)"$/, '$1');
        mediaNodeAttrs.alt = altText;
    }
    if (filename.match((0, $crpDl.LINK_TEXT_REGEXP))) {
        const externalMediaNode = media.createChecked({
            type: 'external',
            url: filename,
            ...mediaNodeAttrs
        }, undefined, mediaMarks);
        return mediaSingle.createChecked(mediaSingleAttrs, externalMediaNode);
    } else {
        // try to look up media ID from conversion context
        const id = context?.conversion?.mediaConversion?.[filename]?.transform ?? filename;
        // try to look up collection from media context
        const collection = context.hydration && context.hydration.media && context.hydration.media.targetCollectionId;
        const mediaNode = media.createChecked({
            id: id,
            type: 'file',
            collection: collection || '',
            ...mediaNodeAttrs
        }, undefined, mediaMarks);
        return mediaSingle.createChecked(mediaSingleAttrs, mediaNode);
    }
}

});
parcelRegister("crpDl", function(module, exports) {

$parcel$export(module.exports, "LINK_TEXT_REGEXP", () => $1765ab2dd26cbf7e$export$f69d1dce349473aa);
$parcel$export(module.exports, "linkText", () => $1765ab2dd26cbf7e$export$cb7bcf09a05b7705);

var $4N6cH = parcelRequire("4N6cH");

var $h2tDj = parcelRequire("h2tDj");
const $1765ab2dd26cbf7e$export$f69d1dce349473aa = /^((?:(?:https?|ftps?):\/\/)|irc:\/\/|mailto:)([\w?!~^\/\\#$%&'()*+,\-.\/:;<=@]*[\w~^\/\\#$%&'()*+,\-\/:;<=@])/i;
const $1765ab2dd26cbf7e$export$cb7bcf09a05b7705 = ({ input: input, position: position, schema: schema })=>{
    let matches = input.substring(position).match($1765ab2dd26cbf7e$export$f69d1dce349473aa);
    if (!matches) return $1765ab2dd26cbf7e$var$fallback(input, position);
    const match = $1765ab2dd26cbf7e$var$trimBadEndChar(matches);
    // Remove mailto:
    const textRepresentation = match[1] === 'mailto:' ? match[2] : match[0];
    // parse and correctly encode any illegal characters, and
    // so no longer need to be encoded when used below
    const url = (0, $h2tDj.decode)($1765ab2dd26cbf7e$var$unescape(match[0]));
    if (!(0, $4N6cH.isSafeUrl)(url)) return $1765ab2dd26cbf7e$var$fallback(input, position);
    const mark = schema.marks.link.create({
        href: url
    });
    const textNode = schema.text(textRepresentation, [
        mark
    ]);
    return {
        type: 'pmnode',
        nodes: [
            textNode
        ],
        length: match[0].length
    };
};
function $1765ab2dd26cbf7e$var$unescape(url) {
    let result = '';
    for(let i = 0; i < url.length; i++){
        const char = url[i];
        if (char !== '\\') {
            result += char;
            continue;
        }
        const nextChar = url[i + 1];
        if (nextChar) {
            result += nextChar;
            i++;
        }
    }
    return result;
}
function $1765ab2dd26cbf7e$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}
// removes bad characters from the end of regex match
function $1765ab2dd26cbf7e$var$trimBadEndChar(input) {
    return [
        input[0].replace(/[.,>)\];}"\'!]*$/, ''),
        input[1],
        input[2].replace(/[.,>)\];}"\'!]*$/, '')
    ];
}

});
parcelRegister("h2tDj", function(module, exports) {

$parcel$export(module.exports, "decode", () => $43b235301c60f824$export$2f872c0f2117be69);
/**
 * returns a correctly percent-encoded & sanitized url.
 * Will fallback to using a DOM based implementation if the `URL` class
 * doesn't exist.
 *
 * @param raw a 'raw' url (possibly mixed percent-encoded).
 */ function $43b235301c60f824$export$2f872c0f2117be69(raw) {
    if (typeof URL === 'function') {
        const decoded = new URL(raw);
        // IE11 doesn't support the `href` property in the `URL` class.
        // Fallback to the DOM below if it doesn't exist.
        if (decoded.href) return decoded.href;
    }
    // no `URL` class - pollyfill using the dom to parse and
    // decode. This should only be needed for IE11 or lower...
    const anchor = document.createElement('a');
    anchor.href = raw; // The DOM will parses even mixed %-encoded segments of a url when set.
    return anchor.href;
}

});



parcelRegister("dFOSZ", function(module, exports) {

$parcel$export(module.exports, "parseAttrs", () => $839f2e057ddb173e$export$e1a9355cfd8f6c64);
function $839f2e057ddb173e$export$e1a9355cfd8f6c64(str, sep = '|') {
    const output = {};
    if (!str) return output;
    const attributesStr = str.split(sep);
    attributesStr.forEach((attributeStr)=>{
        const [key, ...value] = attributeStr.split('=');
        // take only first value of the same keys
        if (!output[key]) output[key] = value.join('=');
    });
    return output;
}

});

parcelRegister("cndSn", function(module, exports) {

$parcel$export(module.exports, "commonFormatter", () => $9fc0c7cd3a3bb618$export$a71d57024d3da1c5);

var $lS4Zv = parcelRequire("lS4Zv");

var $lccs8 = parcelRequire("lccs8");

var $kJkY5 = parcelRequire("kJkY5");

var $2ROXs = parcelRequire("2ROXs");

var $lS4Zv = parcelRequire("lS4Zv");

var $5YILC = parcelRequire("5YILC");
const $9fc0c7cd3a3bb618$var$processState = {
    START: 0,
    BUFFER: 1,
    END: 2,
    INLINE_MACRO: 3,
    LINK_FORMAT: 4,
    ESCAPE: 5
};
function $9fc0c7cd3a3bb618$export$a71d57024d3da1c5(input, position, schema, opt) {
    let index = position;
    let state = $9fc0c7cd3a3bb618$var$processState.START;
    let buffer = [];
    const openingSymbolLength = opt.opening.length;
    const closingSymbolLength = opt.closing.length;
    const openingWrapped = opt.opening.startsWith('{') && opt.opening.endsWith('}');
    const closingWrapped = opt.closing.startsWith('{') && opt.closing.endsWith('}');
    while(index < input.length){
        const char = input.charAt(index);
        const twoChar = input.substr(index, 2);
        const charsMatchClosingSymbol = input.substr(index, closingSymbolLength);
        switch(state){
            case $9fc0c7cd3a3bb618$var$processState.START:
                {
                    if (position > 0) {
                        /**
					 * If the previous char is a alphanumeric, then it's not a valid
					 * formatter
					 */ const charBeforeOpening = input.charAt(position - 1);
                        if (!openingWrapped && /[a-zA-Z0-9]|[^\u0000-\u007F]/.test(charBeforeOpening) && charBeforeOpening !== '\u00A0') return $9fc0c7cd3a3bb618$var$fallback(input, index, openingSymbolLength);
                    }
                    const charAfterOpening = input.charAt(index + openingSymbolLength);
                    if (!input.substring(position).startsWith(opt.opening) || charAfterOpening === ' ') // this is not a valid formatter mark
                    return $9fc0c7cd3a3bb618$var$fallback(input, position, openingSymbolLength);
                    state = $9fc0c7cd3a3bb618$var$processState.BUFFER;
                    index += openingSymbolLength;
                    continue;
                }
            case $9fc0c7cd3a3bb618$var$processState.BUFFER:
                {
                    // the linebreak would break the strong marks
                    const length = (0, $kJkY5.parseNewlineOnly)(input.substring(index));
                    if (length) return $9fc0c7cd3a3bb618$var$fallback(input, position, openingSymbolLength);
                    if (charsMatchClosingSymbol === opt.closing) {
                        state = $9fc0c7cd3a3bb618$var$processState.END;
                        continue;
                    } else if (twoChar === '{{') {
                        // this is a monospace
                        buffer.push(twoChar);
                        index += 2;
                        continue;
                    } else if (char === '{') {
                        state = $9fc0c7cd3a3bb618$var$processState.INLINE_MACRO;
                        continue;
                    } else if (char === '[') {
                        state = $9fc0c7cd3a3bb618$var$processState.LINK_FORMAT;
                        continue;
                    } else if (char === '\\') {
                        state = $9fc0c7cd3a3bb618$var$processState.ESCAPE;
                        continue;
                    } else buffer.push(char);
                    break;
                }
            case $9fc0c7cd3a3bb618$var$processState.END:
                index += closingSymbolLength;
                // empty formatter mark is treated as normal text
                if (buffer.length === 0) return $9fc0c7cd3a3bb618$var$fallback(input, position, openingSymbolLength);
                /**
				 * If the closing symbol is followed by a alphanumeric, it's
				 * not a valid formatter, and we keep looking for
				 * next valid closing formatter.
				 * ESS-1402: checking for the non-breaking space after closing symbol.
				 */ if (index < input.length) {
                    const charAfterEnd = input.charAt(index);
                    if (!closingWrapped && /[a-zA-Z0-9]|[^\u0000-\u007F]/.test(charAfterEnd) && charAfterEnd !== '\u00A0') {
                        buffer.push(charsMatchClosingSymbol);
                        state = $9fc0c7cd3a3bb618$var$processState.BUFFER;
                        continue;
                    }
                }
                /**
				 * If the closing symbol has an empty space before it,
				 * it's not a valid formatter
				 */ if (buffer.length > 0 && buffer[buffer.length - 1].endsWith(' ')) return $9fc0c7cd3a3bb618$var$fallback(input, position, openingSymbolLength);
                return opt.rawContentProcessor(buffer.join(''), index - position);
            case $9fc0c7cd3a3bb618$var$processState.INLINE_MACRO:
                {
                    const match = (0, $2ROXs.parseMacroKeyword)(input.substring(index));
                    if (!match) {
                        buffer.push(char);
                        state = $9fc0c7cd3a3bb618$var$processState.BUFFER;
                        break;
                    }
                    /**
				 * Is not a problem send an empty context because we're only checking
				 * if it has a nested macro inside.
				 */ const token = (0, $lS4Zv.parseToken)(input, match.type, index, schema, {});
                    if (token.type === 'text') {
                        buffer.push(token.text);
                        index += token.length;
                        state = $9fc0c7cd3a3bb618$var$processState.BUFFER;
                        continue;
                    } else if (match.type === (0, $lS4Zv.TokenType).COLOR_MACRO) {
                        /**
					 * {color} is valid in formatter, we simply jump over the length
					 */ buffer.push(input.substr(index, token.length));
                        index += token.length;
                        state = $9fc0c7cd3a3bb618$var$processState.BUFFER;
                        continue;
                    } else // No macro are accepted in formater
                    return $9fc0c7cd3a3bb618$var$fallback(input, position, openingSymbolLength);
                }
            case $9fc0c7cd3a3bb618$var$processState.LINK_FORMAT:
                {
                    /**
				 * We should "fly over" the link format and we dont want
				 * -awesome [link|https://www.atlass-ian.com] nice
				 * to be a strike through because of the '-' in link
				 *
				 * Also, is not a problem send an empty context because we're only
				 * checking if it has a nested macro inside.
				 */ const token = (0, $lccs8.linkFormat)({
                        input: input,
                        schema: schema,
                        position: index,
                        context: {}
                    });
                    if (token.type === 'text') {
                        buffer.push(token.text);
                        index += token.length;
                        state = $9fc0c7cd3a3bb618$var$processState.BUFFER;
                        continue;
                    } else if (token.type === 'pmnode') {
                        buffer.push(input.substr(index, token.length));
                        index += token.length;
                        state = $9fc0c7cd3a3bb618$var$processState.BUFFER;
                        continue;
                    }
                    return $9fc0c7cd3a3bb618$var$fallback(input, position, openingSymbolLength);
                }
            case $9fc0c7cd3a3bb618$var$processState.ESCAPE:
                {
                    const token = (0, $5YILC.escapeHandler)(input, index);
                    buffer.push(token.text);
                    index += token.length;
                    state = $9fc0c7cd3a3bb618$var$processState.BUFFER;
                    continue;
                }
            default:
        }
        index++;
    }
    return $9fc0c7cd3a3bb618$var$fallback(input, position, openingSymbolLength);
}
function $9fc0c7cd3a3bb618$var$fallback(input, position, length) {
    return {
        type: 'text',
        text: input.substr(position, length),
        length: length
    };
}

});
parcelRegister("lccs8", function(module, exports) {

$parcel$export(module.exports, "linkFormat", () => $ac24b5ba4dac9799$export$e1f888a4b6f2ee53);

var $lS4Zv = parcelRequire("lS4Zv");

var $7pbqq = parcelRequire("7pbqq");

var $4GRNK = parcelRequire("4GRNK");

var $6YhuH = parcelRequire("6YhuH");
// [http://www.example.com] and [Example|http://www.example.com]
const $ac24b5ba4dac9799$var$LINK_FORMAT_REGEXP = /^\[([^\[\]\n]+)]/;
const $ac24b5ba4dac9799$export$e1f888a4b6f2ee53 = ({ input: input, position: position, schema: schema, context: context })=>{
    const match = input.substring(position).match($ac24b5ba4dac9799$var$LINK_FORMAT_REGEXP);
    /**
	 * The following token types will be ignored in parsing
	 * the content of a table cell
	 */ const ignoreTokenTypes = [
        (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TABLE,
        (0, $lS4Zv.TokenType).RULER,
        // We want to avoid recursion
        (0, $lS4Zv.TokenType).LINK_TEXT,
        (0, $lS4Zv.TokenType).LINK_FORMAT
    ];
    if (!match) return $ac24b5ba4dac9799$var$fallback();
    const content = (0, $6YhuH.parseContentLink)(match[1]);
    const resolvedLink = (0, $4GRNK.resolveLink)(content, schema, context);
    if (resolvedLink) return resolvedLink;
    const nodes = (0, $7pbqq.parseString)({
        schema: schema,
        context: context,
        ignoreTokenTypes: ignoreTokenTypes,
        input: match[0]
    });
    return {
        type: 'pmnode',
        nodes: nodes,
        length: match[0].length
    };
};
function $ac24b5ba4dac9799$var$fallback() {
    return {
        type: 'text',
        text: '[',
        length: 1
    };
}

});
parcelRegister("7pbqq", function(module, exports) {

$parcel$export(module.exports, "parseString", () => $929d37db672b2042$export$960addfb9e5a0cde);

var $h1mQ4 = parcelRequire("h1mQ4");

var $2ROXs = parcelRequire("2ROXs");

var $lS4Zv = parcelRequire("lS4Zv");

var $kJkY5 = parcelRequire("kJkY5");

var $5YILC = parcelRequire("5YILC");

var $gwvPQ = parcelRequire("gwvPQ");
const $929d37db672b2042$var$processState = {
    NEWLINE: 0,
    BUFFER: 1,
    TOKEN: 2,
    ESCAPE: 3
};
function $929d37db672b2042$export$960addfb9e5a0cde({ input: input, schema: schema, ignoreTokenTypes: ignoreTokenTypes = [], context: context, includeLeadingSpace: includeLeadingSpace = false }) {
    let index = 0;
    let state = $929d37db672b2042$var$processState.NEWLINE;
    let buffer = [];
    let tokenType = (0, $lS4Zv.TokenType).STRING;
    let newLines = [];
    const output = [];
    let inlineNodes = [];
    while(index < input.length){
        const char = input.charAt(index);
        switch(state){
            case $929d37db672b2042$var$processState.NEWLINE:
                {
                    /**
				 * During this state, the parser will trim leading
				 * spaces and looking for any leading keywords.
				 */ const substring = input.substring(index);
                    const length = (0, $kJkY5.parseWhitespaceOnly)(substring);
                    if (length) {
                        index += length;
                        if (includeLeadingSpace) buffer.push(char);
                        continue;
                    }
                    const match = (0, $2ROXs.parseLeadingKeyword)(substring) || (0, $2ROXs.parseMacroKeyword)(substring) || (0, $2ROXs.parseOtherKeyword)(substring) || (0, $2ROXs.parseIssueKeyword)(substring, context.issueKeyRegex);
                    if (match && ignoreTokenTypes.indexOf(match.type) === -1) {
                        tokenType = match.type;
                        state = $929d37db672b2042$var$processState.TOKEN;
                        continue;
                    } else {
                        state = $929d37db672b2042$var$processState.BUFFER;
                        continue;
                    }
                }
            case $929d37db672b2042$var$processState.BUFFER:
                {
                    /**
				 * During this state, the parser will start
				 * saving plaintext into the buffer until it hits
				 * a keyword
				 */ const substring = input.substring(index);
                    /**
				 * If the previous char is not a alphanumeric, we will parse
				 * format keywords.
				 * If the previous char is '{', we need to skip parse macro
				 * keyword
				 */ let match = null;
                    if (buffer.length > 0 && buffer[buffer.length - 1].endsWith('{')) match = (0, $2ROXs.parseOtherKeyword)(substring);
                    else match = (0, $2ROXs.parseMacroKeyword)(substring) || (0, $2ROXs.parseOtherKeyword)(substring) || (0, $2ROXs.parseIssueKeyword)(substring, context.issueKeyRegex);
                    if (match && ignoreTokenTypes.indexOf(match.type) === -1) {
                        tokenType = match.type;
                        state = $929d37db672b2042$var$processState.TOKEN;
                        continue;
                    }
                    if (char === '\\') {
                        state = $929d37db672b2042$var$processState.ESCAPE;
                        continue;
                    }
                    buffer.push(char);
                    break;
                }
            case $929d37db672b2042$var$processState.TOKEN:
                {
                    const token = (0, $lS4Zv.parseToken)(input, tokenType, index, schema, context);
                    if (token.type === 'text') buffer.push(token.text);
                    else if (token.type === 'pmnode') {
                        /*ESS-2539 We are keeping track of consecutive newLines in the newLines array
            Whenever more than two consecutive newLines are encountered, we start a new paragraph
          */ if (newLines.length >= 2 && (tokenType !== (0, $lS4Zv.TokenType).HARD_BREAK || buffer.length > 0)) {
                            output.push(...(0, $gwvPQ.normalizePMNodes)(inlineNodes, schema));
                            // push newLines to the buffer as a separator between media nodes
                            inlineNodes = $929d37db672b2042$var$isConsecutiveMediaGroups(inlineNodes, token.nodes) ? [
                                ...newLines
                            ] : [];
                            newLines = [];
                        }
                        if (inlineNodes.length === 0) newLines = [];
                        if (newLines.length > 0 && $929d37db672b2042$var$isNewLineRequiredBetweenNodes(inlineNodes, buffer, token.nodes)) {
                            inlineNodes.push(...newLines);
                            newLines = [];
                        }
                        inlineNodes.push(...(0, $h1mQ4.createTextNode)(buffer.join(''), schema));
                        if (tokenType === (0, $lS4Zv.TokenType).HARD_BREAK) newLines.push(...token.nodes);
                        else {
                            inlineNodes.push(...token.nodes);
                            if (token.nodes.length > 0) newLines = [];
                        }
                        buffer = []; // clear the buffer
                    }
                    index += token.length;
                    if (tokenType === (0, $lS4Zv.TokenType).HARD_BREAK) state = $929d37db672b2042$var$processState.NEWLINE;
                    else state = $929d37db672b2042$var$processState.BUFFER;
                    continue;
                }
            case $929d37db672b2042$var$processState.ESCAPE:
                {
                    const token = (0, $5YILC.escapeHandler)(input, index);
                    buffer.push(token.text);
                    index += token.length;
                    state = $929d37db672b2042$var$processState.BUFFER;
                    continue;
                }
            default:
        }
        index++;
    }
    const bufferedStr = buffer.join('');
    if (bufferedStr.length > 0) {
        // Wrapping the rest of the buffer into a text node
        if (newLines.length >= 2) {
            // normalize the nodes already parsed if more than two consecutive newLines are encountered
            output.push(...(0, $gwvPQ.normalizePMNodes)(inlineNodes, schema));
            inlineNodes = [];
            newLines = [];
        }
        if (newLines.length > 0 && inlineNodes.length > 0 && !inlineNodes[inlineNodes.length - 1].isBlock) inlineNodes.push(...newLines);
        inlineNodes.push(...(0, $h1mQ4.createTextNode)(bufferedStr, schema));
    }
    return [
        ...output,
        ...inlineNodes
    ];
}
/* checks whether a newLine is required between two consecutive nodes
   Returns true for inline nodes, false for block nodes
*/ function $929d37db672b2042$var$isNewLineRequiredBetweenNodes(currentNodes, buffer, nextNodes) {
    if (currentNodes.length === 0) return false;
    if (buffer.length > 0 && currentNodes[currentNodes.length - 1]?.isBlock) return false;
    if (buffer.length === 0) {
        if (nextNodes.length === 0) return false;
        if (nextNodes[0]?.type.name === 'hardBreak') return false;
        if (nextNodes[0]?.isBlock || currentNodes[currentNodes.length - 1]?.isBlock) return false;
    }
    return true;
}
function $929d37db672b2042$var$isConsecutiveMediaGroups(currentNodes, nextNodes) {
    return currentNodes.length > 0 && currentNodes[currentNodes.length - 1]?.type.name === 'mediaGroup' && nextNodes[0]?.type.name === 'mediaGroup';
}

});
parcelRegister("h1mQ4", function(module, exports) {

$parcel$export(module.exports, "createTextNode", () => $47520f02a58e88f7$export$b2ce9ad90858ed7a);
function $47520f02a58e88f7$export$b2ce9ad90858ed7a(input, schema, marks) {
    if (input === '') return [];
    const node = schema.text(input, marks || []);
    return [
        node
    ];
}

});

parcelRegister("kJkY5", function(module, exports) {

$parcel$export(module.exports, "parseNewlineOnly", () => $9ca95fb6aba50881$export$1b7a83d725c8acf);
$parcel$export(module.exports, "parseWhitespaceOnly", () => $9ca95fb6aba50881$export$9c597b035e16623b);
function $9ca95fb6aba50881$export$877995a80ec11782(input) {
    const newlineLength = $9ca95fb6aba50881$export$1b7a83d725c8acf(input);
    if (newlineLength) return newlineLength;
    const whitespaceLength = $9ca95fb6aba50881$export$9c597b035e16623b(input);
    if (whitespaceLength) return whitespaceLength;
    // There is nether whitespace nor newline
    return 0;
}
function $9ca95fb6aba50881$export$9c597b035e16623b(input) {
    let index = 0;
    const char = input.charAt(index);
    if (char === '\t' || char === ' ') index++;
    return index;
}
function $9ca95fb6aba50881$export$1b7a83d725c8acf(input) {
    let index = 0;
    const char = input.charAt(index);
    if (char === '\r') {
        // CR (Unix)
        index++;
        if (input.charAt(index) === '\n') // CRLF (Windows)
        index++;
    } else if (char === '\n') // LF (MacOS)
    index++;
    return index;
}

});

parcelRegister("5YILC", function(module, exports) {

$parcel$export(module.exports, "escapeHandler", () => $af3b953fda1d38b5$export$d16e8e6cf9622f9a);
/**
 * In Jira, following characters are escaped
 * private static final Pattern ESCAPING_PATTERN = Pattern.compile("(^|(?<!\\\\))\\\\([\\-\\#\\*\\_\\+\\?\\^\\~\\|\\%\\{\\}\\[\\]\\(\\)\\!\\@])");
 * https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-renderer/src/main/java/com/atlassian/renderer/v2/components/BackslashEscapeRendererComponent.java
 */ const $af3b953fda1d38b5$var$escapedChar = [
    '-',
    '#',
    '*',
    '_',
    '+',
    '?',
    '^',
    '~',
    '|',
    '%',
    '{',
    '}',
    '[',
    ']',
    '(',
    ')',
    '!',
    '@'
];
function $af3b953fda1d38b5$export$d16e8e6cf9622f9a(input, position) {
    let buffer = [];
    const char = input.charAt(position);
    const prevChar = input.charAt(position - 1);
    const nextChar = input.charAt(position + 1);
    /**
	 * Ported from Jira:
	 * If previous char is also a backslash, then this is not a valid escape
	 */ if ($af3b953fda1d38b5$var$escapedChar.indexOf(nextChar) === -1 || prevChar === '\\') // Insert \ in buffer mode
    buffer.push(char);
    buffer.push(nextChar);
    return {
        type: 'text',
        text: buffer.join(''),
        length: 2
    };
}

});

parcelRegister("gwvPQ", function(module, exports) {

$parcel$export(module.exports, "normalizePMNodes", () => $76235613b8bd397e$export$e21f6b7efdaf8b5d);

var $PbPoX = parcelRequire("PbPoX");

var $1t19o = parcelRequire("1t19o");
function $76235613b8bd397e$export$e21f6b7efdaf8b5d(nodes, schema, parentNode) {
    return [
        $76235613b8bd397e$var$normalizeMediaGroups,
        $76235613b8bd397e$export$cd936b894f116ed8
    ].reduce((currentNodes, normFunc)=>normFunc(currentNodes, schema, parentNode), nodes);
}
function $76235613b8bd397e$export$cd936b894f116ed8(nodes, schema, parentNode) {
    const output = [];
    let inlineNodeBuffer = [];
    for (const node of nodes){
        if (!node.isBlock) {
            inlineNodeBuffer.push(node);
            continue;
        }
        if (inlineNodeBuffer.length > 0) output.push(...(0, $PbPoX.createParagraphNodeFromInlineNodes)(inlineNodeBuffer, schema));
        inlineNodeBuffer = []; // clear buffer
        if (node?.type?.name === 'nestedExpand' && parentNode === 'doc') //ADFEXP-227 handle nested expand at root level
        output.push($76235613b8bd397e$var$wrapNestedExpandInTable(node, schema));
        else output.push(node);
    }
    if (inlineNodeBuffer.length > 0) output.push(...(0, $PbPoX.createParagraphNodeFromInlineNodes)(inlineNodeBuffer, schema));
    if (output.length === 0) return [
        (0, $PbPoX.createEmptyParagraphNode)(schema)
    ];
    return output;
}
/**
 * Normalize the list of the given nodes for media groups.
 * The rule is: if there are consecutive media group nodes (each with a single child media
 * node) separated by any space or a single newline, then merge them into one media group
 * with multiple child media nodes.
 * @param nodes list of nodes to normalize. Must not be null
 * @param schema
 */ function $76235613b8bd397e$var$normalizeMediaGroups(nodes, schema, parentNode) {
    const output = [];
    let mediaGroupBuffer = [];
    let separatorBuffer = [];
    for (const n of nodes){
        if (n.type.name === 'mediaGroup' && n.childCount === 1) {
            mediaGroupBuffer.push(n);
            //separator buffer keeps track of the seperator(s) between each mediaGroup nodes,
            //so needs resetting every time we encounter a new mediaGroup node
            separatorBuffer = [];
            continue;
        }
        if (mediaGroupBuffer.length > 0) {
            if ($76235613b8bd397e$var$isSignificantSeparatorNode(n, separatorBuffer)) {
                output.push($76235613b8bd397e$var$createMergedMediaGroup(mediaGroupBuffer, schema));
                output.push(...separatorBuffer);
                output.push(n);
                mediaGroupBuffer = [];
                separatorBuffer = [];
            } else separatorBuffer.push(n);
            continue;
        }
        output.push(n);
    }
    if (mediaGroupBuffer.length > 0) output.push($76235613b8bd397e$var$createMergedMediaGroup(mediaGroupBuffer, schema));
    // Dump everything else from separator buffer if anything is left
    output.push(...separatorBuffer);
    return output;
}
/**
 * Creates a single mediaGroup whose children are the single media elements from the given mediaGroupNodes.
 * @param mediaGroupNodes list of mediaGroups that have a single child each
 * @param schema the schema
 */ function $76235613b8bd397e$var$createMergedMediaGroup(mediaGroupNodes, schema) {
    const { mediaGroup: mediaGroup } = schema.nodes;
    const mediaNodes = mediaGroupNodes.map((v)=>v.child(0));
    return mediaGroup.createChecked({}, mediaNodes);
}
function $76235613b8bd397e$var$isSignificantSeparatorNode(n, separatorBuffer) {
    return $76235613b8bd397e$var$isHardBreak(n, separatorBuffer) || !$76235613b8bd397e$var$isEmptyTextNode(n) || $76235613b8bd397e$var$isMediaGroupWithMultipleChildren(n);
}
/**
 * Existing media groups with more than one child is considered as a significant separator.
 */ function $76235613b8bd397e$var$isMediaGroupWithMultipleChildren(n) {
    return n.type.name === 'mediaGroup' && n.childCount > 1;
}
/**
 * If the current node is a hard break, AND there's already at least
 * one hard break in the separator buffer, then we want to return true.
 * @param n the current node to examine
 * @param separatorBuffer the existing separator buffer.
 */ function $76235613b8bd397e$var$isHardBreak(n, separatorBuffer) {
    return n.type.name === 'hardBreak' && separatorBuffer.map((v)=>v.type.name).indexOf('hardBreak') !== -1;
}
function $76235613b8bd397e$var$isEmptyTextNode(n) {
    return n.textContent !== undefined && n.textContent.trim().length === 0;
}
function $76235613b8bd397e$export$19b6d0f3f1dd6ddf(input) {
    // Line with only spaces is considered an empty line
    return input.trim().length === 0;
}
function $76235613b8bd397e$var$wrapNestedExpandInTable(node, schema) {
    const builder = new (0, $1t19o.TableBuilder)(schema);
    const cell = {
        style: '|',
        content: [
            node
        ]
    };
    builder.add([
        cell
    ]);
    const tableNode = builder.buildPMNode();
    return tableNode;
}

});
parcelRegister("PbPoX", function(module, exports) {

$parcel$export(module.exports, "createEmptyParagraphNode", () => $66324d8d739edb2f$export$e930a5cfe8596ea0);
$parcel$export(module.exports, "createParagraphNodeFromInlineNodes", () => $66324d8d739edb2f$export$f0eaed48ea684567);
function $66324d8d739edb2f$export$e930a5cfe8596ea0(schema) {
    const { paragraph: paragraph } = schema.nodes;
    return paragraph.createChecked({}, []);
}
function $66324d8d739edb2f$export$f0eaed48ea684567(inlineNodes, schema) {
    const { paragraph: paragraph } = schema.nodes;
    const result = [];
    const textNodes = inlineNodes.filter((node)=>node.type.name !== 'hardBreak');
    if (textNodes.length > 0) result.push(paragraph.createChecked({}, inlineNodes));
    return result;
}

});

parcelRegister("1t19o", function(module, exports) {

$parcel$export(module.exports, "TableBuilder", () => $ee9dddd7294d397c$export$9e18c07f56f31a89);
/**
 * Return the cell type based on the delimeter
 */ function $ee9dddd7294d397c$var$getType(style) {
    return /\|\|/.test(style) ? 'tableHeader' : 'tableCell';
}
class $ee9dddd7294d397c$export$9e18c07f56f31a89 {
    constructor(schema){
        this.emptyTableCell = ()=>{
            const { tableCell: tableCell, paragraph: paragraph } = this.schema.nodes;
            return tableCell.createChecked({}, paragraph.createChecked());
        };
        this.emptyTableRow = ()=>{
            const { tableRow: tableRow } = this.schema.nodes;
            return tableRow.createChecked({}, this.emptyTableCell());
        };
        /**
	 * Build prosemirror table node
	 * @returns {PMNode}
	 */ this.buildTableNode = ()=>{
            const { root: root } = this;
            const { table: table } = this.schema.nodes;
            const content = root.rows.map(this.buildTableRowNode);
            if (content.length === 0) content.push(this.emptyTableRow());
            return table.createChecked({}, content);
        };
        /**
	 * Build prosemirror tr node
	 * @returns {PMNode}
	 */ this.buildTableRowNode = (row)=>{
            const { tableRow: tableRow } = this.schema.nodes;
            return tableRow.createChecked({}, row.cells.map(this.buildTableCellNode));
        };
        /**
	 * Build prosemirror td/th node
	 * @param {TableCell} cell
	 * @returns {PMNode}
	 */ this.buildTableCellNode = (cell)=>{
            const { type: type, content: content } = cell;
            if (content.length === 0) content.push(this.schema.nodes.paragraph.createChecked());
            const cellNode = this.schema.nodes[type];
            return cellNode.createChecked({}, content);
        };
        this.schema = schema;
        this.root = {
            rows: []
        };
    }
    /**
	 * Return the type of the base element
	 * @returns {string}
	 */ get type() {
        return 'table';
    }
    /**
	 * Add new cells to the table
	 * @param {AddCellArgs[]} cells
	 */ add(cells) {
        if (!cells.length) return;
        // Iterate the cells and create TH/TD based on the delimeter
        let index = 0;
        for (const cell of cells){
            const { content: content, style: style } = cell;
            const cellType = $ee9dddd7294d397c$var$getType(style);
            // For the first item, determine if it's a new row or not
            if (index === 0) this.addRow();
            const newCell = {
                type: cellType,
                content: content
            };
            this.lastRow.cells.push(newCell);
            index += 1;
        }
    }
    /**
	 * Build a prosemirror table from the data
	 * @returns {PMNode}
	 */ buildPMNode() {
        return this.buildTableNode();
    }
    /**
	 * Add a new row to the table
	 */ addRow() {
        const { rows: rows } = this.root;
        const row = {
            cells: []
        };
        rows.push(row);
        this.lastRow = row;
    }
}

});



parcelRegister("4GRNK", function(module, exports) {

$parcel$export(module.exports, "resolveLink", () => $42e2c78a7d1992c7$export$c2baa561eb017101);

var $53dGQ = parcelRequire("53dGQ");

var $hV0Ud = parcelRequire("hV0Ud");

var $eQxlw = parcelRequire("eQxlw");

var $3JaZI = parcelRequire("3JaZI");
// jira-components/jira-core/src/main/resources/system-contentlinkresolvers-plugin.xml
// attachment resolver: 10
// anchor resolver: 20 - unsupported
// jiraissue resolver: 30 - unsupported
// user profile: 40
//
// Fall back to url link resolver
const $42e2c78a7d1992c7$var$linkResolverStrategies = [
    (0, $hV0Ud.attachmentLinkResolver),
    (0, $53dGQ.mentionLinkResolver),
    (0, $3JaZI.issueLinkResolver),
    (0, $eQxlw.urlLinkResolver)
];
function $42e2c78a7d1992c7$export$c2baa561eb017101(link, schema, context) {
    const length = link.originalLinkText.length + 2;
    for (const resolver of $42e2c78a7d1992c7$var$linkResolverStrategies){
        const resolvedLink = resolver(link, schema, context);
        if (resolvedLink) return {
            length: length,
            nodes: resolvedLink,
            type: 'pmnode'
        };
    }
    return undefined;
}

});
parcelRegister("53dGQ", function(module, exports) {

$parcel$export(module.exports, "mentionLinkResolver", () => $35dd3b4723d09d0e$export$1da3b34e38fc6ca8);
function $35dd3b4723d09d0e$export$1da3b34e38fc6ca8(link, schema, context) {
    // [CS-1896] Empty mention nodes should fallback to plaintext
    if (link.notLinkBody.toLowerCase() === '~accountid:' || link.notLinkBody === '~') return [
        schema.nodes.paragraph.createChecked({}, [
            schema.nodes.text.create({})
        ])
    ];
    if (link.notLinkBody.startsWith('~')) {
        const mentionText = link.notLinkBody.substring(1);
        const mentionKey = mentionText.toLowerCase();
        const id = context.conversion && context.conversion.mentionConversion && context.conversion.mentionConversion[mentionKey] ? context.conversion.mentionConversion[mentionKey] : mentionText;
        return [
            schema.nodes.mention.createChecked({
                id: id
            })
        ];
    }
    return;
}

});

parcelRegister("hV0Ud", function(module, exports) {

$parcel$export(module.exports, "attachmentLinkResolver", () => $40bebdfc438dbfb7$export$ce918f41a76b8445);

var $4wFmF = parcelRequire("4wFmF");
function $40bebdfc438dbfb7$export$ce918f41a76b8445(link, schema, context) {
    if (link.attachmentName) return [
        (0, $4wFmF.default)(schema, link.attachmentName, context)
    ];
    return;
}

});
parcelRegister("4wFmF", function(module, exports) {

$parcel$export(module.exports, "default", () => $712942d98c68bb4f$export$2e2bcd8739ae039);
function $712942d98c68bb4f$export$2e2bcd8739ae039(schema, filename, context = {}) {
    const { media: media, mediaGroup: mediaGroup } = schema.nodes;
    // try to look up media ID from conversion context
    const id = context?.conversion?.mediaConversion?.[filename]?.transform ?? filename;
    // try to look up collection from media context
    const collection = context.hydration && context.hydration.media && context.hydration.media.targetCollectionId;
    const mediaNode = media.createChecked({
        id: id,
        type: 'file',
        collection: collection || ''
    });
    return mediaGroup.createChecked({}, mediaNode);
}

});


parcelRegister("eQxlw", function(module, exports) {

$parcel$export(module.exports, "urlLinkResolver", () => $081728bf52cebca2$export$b737d556d2167f9);

var $lS4Zv = parcelRequire("lS4Zv");

var $4N6cH = parcelRequire("4N6cH");

var $7pbqq = parcelRequire("7pbqq");

var $8loUC = parcelRequire("8loUC");
function $081728bf52cebca2$export$b737d556d2167f9(link, schema, context) {
    const output = [];
    const url = link.notLinkBody;
    const textRepresentation = link.linkBody || link.notLinkBody;
    if (!(0, $4N6cH.isSafeUrl)(url)) return;
    const ignoreTokenTypes = [
        (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).LINK_TEXT,
        (0, $lS4Zv.TokenType).ISSUE_KEY
    ];
    const rawContent = (0, $7pbqq.parseString)({
        ignoreTokenTypes: ignoreTokenTypes,
        schema: schema,
        context: context,
        input: textRepresentation.replace(/^mailto:/, '')
    });
    const decoratedContent = rawContent.map((n)=>{
        const mark = schema.marks.link.create({
            href: url
        });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $8loUC.hasAnyOfMarks)(n, [
            'link',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    });
    output.push(...decoratedContent);
    if (!$081728bf52cebca2$var$hasTextNode(rawContent)) {
        const mark = schema.marks.link.create({
            href: url
        });
        const linkTextNode = schema.text(textRepresentation, [
            mark
        ]);
        output.push(linkTextNode);
    }
    return output;
}
function $081728bf52cebca2$var$hasTextNode(nodes) {
    return nodes.find((n)=>{
        return n.type.name === 'text';
    });
}

});
parcelRegister("8loUC", function(module, exports) {

$parcel$export(module.exports, "hasAnyOfMarks", () => $a360c9f677e08143$export$30c14ec359b8cbf0);
$parcel$export(module.exports, "isDigit", () => $a360c9f677e08143$export$727d9dbc4fbb948f);
$parcel$export(module.exports, "isBlank", () => $a360c9f677e08143$export$7ee701e290d9865);
$parcel$export(module.exports, "isNotBlank", () => $a360c9f677e08143$export$4d9e7a1c098df5e2);
$parcel$export(module.exports, "getSurroundingSymbols", () => $a360c9f677e08143$export$ddec3d40bf5e3693);
$parcel$export(module.exports, "StringBuffer", () => $a360c9f677e08143$export$83347051c3437dc9);
function $a360c9f677e08143$export$30c14ec359b8cbf0(node, types) {
    return node.marks.findIndex((m)=>types.findIndex((t)=>m.type.name === t) !== -1) !== -1;
}
function $a360c9f677e08143$export$727d9dbc4fbb948f(value) {
    return !!value.match(/^\d$/);
}
function $a360c9f677e08143$export$7ee701e290d9865(value) {
    return value === null || value.trim() === '';
}
function $a360c9f677e08143$export$4d9e7a1c098df5e2(value) {
    return !$a360c9f677e08143$export$7ee701e290d9865(value);
}
const $a360c9f677e08143$export$ddec3d40bf5e3693 = (trimmedInput, openingText, closingText)=>{
    const openingSymbol = trimmedInput.startsWith(`{${openingText}}`) ? `{${openingText}}` : openingText;
    const endIndex = trimmedInput.indexOf(closingText, openingSymbol === `{${openingText}}` ? openingText.length + 2 : openingText.length);
    const closingSymbol = endIndex > -1 && trimmedInput.charAt(endIndex - 1) === '{' && trimmedInput.charAt(endIndex + closingText.length) === '}' ? `{${closingText}}` : closingText;
    return {
        openingSymbol: openingSymbol,
        closingSymbol: closingSymbol
    };
};
class $a360c9f677e08143$export$83347051c3437dc9 {
    constructor(buffer = ''){
        this.buffer = buffer;
    }
    indexOf(value) {
        return this.buffer.indexOf(value);
    }
    lastIndexOf(value) {
        return this.buffer.lastIndexOf(value);
    }
    charAt(index) {
        return this.buffer.charAt(index);
    }
    length() {
        return this.buffer.length;
    }
    delete(start, end) {
        this.buffer = this.buffer.substring(0, start) + this.buffer.substring(end);
    }
    append(value) {
        this.buffer += value;
    }
    substring(start, end) {
        return this.buffer.substring(start, end);
    }
    deleteCharAt(index) {
        this.delete(index, index + 1);
    }
    toString() {
        return this.buffer;
    }
}

});


parcelRegister("3JaZI", function(module, exports) {

$parcel$export(module.exports, "issueLinkResolver", () => $0352545efe304712$export$f40ed0efa65d4e8);

var $4RTci = parcelRequire("4RTci");
function $0352545efe304712$export$f40ed0efa65d4e8(link, schema, context) {
    const { originalLinkText: originalLinkText, linkTitle: linkTitle, notLinkBody: notLinkBody } = link;
    if (linkTitle === 'smart-card' || linkTitle === 'block-link' // TODO: Depricated should be removed in the next major release
    ) return [
        schema.nodes.blockCard.createChecked({
            url: notLinkBody
        })
    ];
    if (linkTitle === 'smart-link') return [
        schema.nodes.inlineCard.createChecked({
            url: notLinkBody
        })
    ];
    if (linkTitle === 'smart-embed') return [
        schema.nodes.embedCard.createChecked({
            url: notLinkBody
        })
    ];
    const issue = (0, $4RTci.getIssue)(context, originalLinkText);
    if (issue) return (0, $4RTci.buildInlineCard)(schema, issue);
    return undefined;
}

});
parcelRegister("4RTci", function(module, exports) {

$parcel$export(module.exports, "INLINE_CARD_FROM_TEXT_STAMP", () => $a6928660ab95804f$export$a1a15f4d91e860d9);
$parcel$export(module.exports, "issueKey", () => $a6928660ab95804f$export$a0d841e329cebd91);
$parcel$export(module.exports, "getIssue", () => $a6928660ab95804f$export$34403cb88b30d33b);
$parcel$export(module.exports, "buildInlineCard", () => $a6928660ab95804f$export$cdebb4bc59c595a);
$parcel$export(module.exports, "buildIssueKeyRegex", () => $a6928660ab95804f$export$cd8701ad7512efee);

var $8loUC = parcelRequire("8loUC");
const $a6928660ab95804f$export$a1a15f4d91e860d9 = /(#icft=)([A-Z][A-Z]+-[0-9]+)/;
const $a6928660ab95804f$export$a0d841e329cebd91 = ({ input: input, position: position, schema: schema, context: context })=>{
    // This scenario happens when context is empty
    if (!context.issueKeyRegex) return $a6928660ab95804f$var$fallback(input, position);
    const match = input.substring(position).match(context.issueKeyRegex);
    if (!match) return $a6928660ab95804f$var$fallback(input, position);
    const issue = $a6928660ab95804f$export$34403cb88b30d33b(context, match[0]);
    // This scenario happens when context doesn't has all the issues inside a markup
    if (!issue) return $a6928660ab95804f$var$fallback(input, position);
    const charBefore = input.charAt(position - 1);
    const charAfter = input.charAt(position + issue.key.length);
    if ((0, $8loUC.isNotBlank)(charBefore) && $a6928660ab95804f$var$isNotAllowedChars(charBefore) || (0, $8loUC.isNotBlank)(charAfter) && $a6928660ab95804f$var$isNotAllowedChars(charAfter)) return $a6928660ab95804f$var$fallback(input, position);
    return {
        type: 'pmnode',
        nodes: $a6928660ab95804f$export$cdebb4bc59c595a(schema, issue),
        length: match[0].length
    };
};
const $a6928660ab95804f$var$fallback = (input, position)=>({
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    });
const $a6928660ab95804f$export$34403cb88b30d33b = (context, key)=>context.conversion && context.conversion.inlineCardConversion && context.conversion.inlineCardConversion[key] ? {
        key: key,
        url: context.conversion.inlineCardConversion[key]
    } : null;
const $a6928660ab95804f$export$cdebb4bc59c595a = (schema, issue)=>{
    return [
        schema.nodes.inlineCard.createChecked({
            url: $a6928660ab95804f$var$withInlineCardFromTextStamp(issue)
        })
    ];
};
const $a6928660ab95804f$var$withInlineCardFromTextStamp = (issue)=>$a6928660ab95804f$export$a1a15f4d91e860d9.test(issue.url) ? issue.url : `${issue.url}#icft=${issue.key}`;
const $a6928660ab95804f$var$isNotAllowedChars = (char)=>!/\s|\(|\)|!|\.|\,|\/|\:/.test(char);
const $a6928660ab95804f$export$cd8701ad7512efee = (inlineCardConversion)=>{
    if (!inlineCardConversion) return undefined;
    const pattern = Object.keys(inlineCardConversion).join('|');
    if (!pattern) return undefined;
    return new RegExp(`^(${pattern})`);
};

});



parcelRegister("6YhuH", function(module, exports) {

$parcel$export(module.exports, "parseContentLink", () => $a6f686c8544fb04b$export$3a250a08d37b0eae);

var $8loUC = parcelRequire("8loUC");
/*
 * This implementation is ported from JIRA with minimal modifications
 * It uses a mutable "StringBuffer" to parse links. It would be ideal to
 *  move this to operating on immutable strings instead if possible
 *
 * TODO: CS-596 Replace string buffer usage with strings
 */ function $a6f686c8544fb04b$var$trimIfPossible(s) {
    if (s === null) return null;
    return s.trim();
}
function $a6f686c8544fb04b$var$extractLinkBody(buffer) {
    const indexOfBang = buffer.indexOf('!');
    const indexOfPipe = buffer.indexOf('|');
    const lastIndexOfBang = buffer.lastIndexOf('!');
    const notEscaped = indexOfBang === -1 || indexOfBang > indexOfPipe || indexOfBang === lastIndexOfBang;
    if (notEscaped) return $a6f686c8544fb04b$var$divideOn(buffer, '|');
    const body = new (0, $8loUC.StringBuffer)();
    let inEscape = false;
    for(let i = 0; i < buffer.length(); i++){
        const c = buffer.charAt(i);
        if (c === '!') inEscape = !inEscape;
        if (c === '|' && !inEscape) {
            buffer.delete(0, i + 1);
            return body.toString();
        }
        body.append(c);
    }
    return null;
}
function $a6f686c8544fb04b$var$divideAfterLast(buffer, divider) {
    if (buffer.length() === 0) return null;
    return $a6f686c8544fb04b$var$divideAfter(buffer, buffer.lastIndexOf(divider));
}
function $a6f686c8544fb04b$var$divideAfter(buffer, index) {
    if (typeof index === 'string') index = buffer.indexOf(index);
    if (index < 0) return null;
    else if (index === buffer.length() - 1) {
        buffer.deleteCharAt(buffer.length() - 1);
        return null;
    } else {
        const body = buffer.substring(index + 1);
        buffer.delete(index, buffer.length());
        return body;
    }
}
/**
 * Split a StringBuffer on some dividing character. Return everything before the divider,
 * and remove that prefix _and_ the divider from the StringBuffer. If there is no divider,
 * return null.
 * <p/>
 * If the buffer begins with the divider, then the divider will be removed _and_ null returned.
 * If the buffer ends with the divider, everything before the divider is returned and the buffer
 * will remain empty.
 *
 * @param buffer  the text we want to divide. Will be modified during the operation
 * @param divider the character to divide the buffer on
 * @return the characters before the divider, or the default if there are none
 */ function $a6f686c8544fb04b$var$divideOn(buffer, divider) {
    if (buffer.length() === 0) return null;
    const i = buffer.indexOf(divider);
    if (i < 0) return null;
    else if (i === 0) {
        buffer.deleteCharAt(0);
        return null;
    } else {
        const body = buffer.substring(0, i);
        buffer.delete(0, i + 1);
        return body;
    }
}
function $a6f686c8544fb04b$var$extractNumber(buf) {
    const digits = new (0, $8loUC.StringBuffer)();
    let i = 0;
    for(; i < buf.length() && (0, $8loUC.isDigit)(buf.charAt(i)); i++)digits.append(buf.charAt(i));
    if (i > 0) buf.delete(0, i);
    try {
        return parseInt(digits.toString(), 10);
    } catch (e) {
        return 0;
    }
}
function $a6f686c8544fb04b$export$2d20cd44728d07a1(linkText) {
    const originalLinkText = linkText;
    // we want to decode single quotes (represented by &#039;) back before parsing the link test
    if (linkText.indexOf('&#039;') !== -1) linkText = linkText.replace('&#039;', "'");
    const buf = new (0, $8loUC.StringBuffer)(linkText);
    const linkBody = $a6f686c8544fb04b$var$extractLinkBody(buf);
    const linkTitle = $a6f686c8544fb04b$var$trimIfPossible($a6f686c8544fb04b$var$divideAfter(buf, '|'));
    const notLinkBody = buf.toString().trim();
    return {
        originalLinkText: originalLinkText,
        linkBody: linkBody,
        linkTitle: linkTitle,
        notLinkBody: notLinkBody
    };
}
function $a6f686c8544fb04b$export$3a250a08d37b0eae(link) {
    if (typeof link === 'string') link = $a6f686c8544fb04b$export$2d20cd44728d07a1(link);
    const { notLinkBody: notLinkBody } = link;
    let shortcutName = null;
    let shortcutValue = null;
    let spaceKey = null;
    let attachmentName = null;
    let anchor = null;
    let destinationTitle = '';
    let contentId = 0;
    // Don't treat it as a short link when it starts with "~"
    if (!notLinkBody.startsWith('~')) {
        const shortcutBuf = new (0, $8loUC.StringBuffer)(notLinkBody);
        shortcutName = $a6f686c8544fb04b$var$trimIfPossible($a6f686c8544fb04b$var$divideAfterLast(shortcutBuf, '@'));
        if ((0, $8loUC.isNotBlank)(shortcutName)) shortcutValue = shortcutBuf.toString();
    }
    const buf = new (0, $8loUC.StringBuffer)(notLinkBody);
    if ((0, $8loUC.isBlank)(shortcutName)) {
        spaceKey = $a6f686c8544fb04b$var$trimIfPossible($a6f686c8544fb04b$var$divideOn(buf, ':'));
        if (buf.indexOf('$') === 0) {
            buf.deleteCharAt(0);
            contentId = $a6f686c8544fb04b$var$extractNumber(buf);
            if (contentId === 0) return {
                ...link,
                shortcutName: shortcutName,
                shortcutValue: shortcutValue,
                spaceKey: spaceKey,
                contentId: contentId,
                attachmentName: attachmentName,
                anchor: anchor,
                destinationTitle: destinationTitle
            };
        }
        attachmentName = $a6f686c8544fb04b$var$trimIfPossible($a6f686c8544fb04b$var$divideAfter(buf, '^'));
        anchor = $a6f686c8544fb04b$var$trimIfPossible($a6f686c8544fb04b$var$divideAfter(buf, '#'));
    }
    if (contentId === 0) destinationTitle = buf.toString().trim();
    return {
        ...link,
        shortcutName: shortcutName,
        shortcutValue: shortcutValue,
        spaceKey: spaceKey,
        contentId: contentId,
        attachmentName: attachmentName,
        anchor: anchor,
        destinationTitle: destinationTitle
    };
}

});




parcelRegister("fxycA", function(module, exports) {

$parcel$export(module.exports, "blockquote", () => $8818f71c12fe6d5c$export$67dc04e652a298ca);

var $3ZquL = parcelRequire("3ZquL");
// bq. foobarbaz
const $8818f71c12fe6d5c$var$BLOCKQUOTE_REGEXP = /^bq\.(.*)/;
const $8818f71c12fe6d5c$export$67dc04e652a298ca = ({ input: input, position: position, schema: schema, context: context })=>{
    const match = input.substring(position).match($8818f71c12fe6d5c$var$BLOCKQUOTE_REGEXP);
    if (!match) return $8818f71c12fe6d5c$var$fallback(input, position);
    const [, rawContent] = match;
    return (0, $3ZquL.rawContentProcessor)('', rawContent, match[0].length, schema, context);
};
function $8818f71c12fe6d5c$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}

});
parcelRegister("3ZquL", function(module, exports) {

$parcel$export(module.exports, "quoteMacro", () => $d0531372537d3533$export$8f9545cee64b3251);
$parcel$export(module.exports, "rawContentProcessor", () => $d0531372537d3533$export$c2a5e4612254bfa);

var $048B7 = parcelRequire("048B7");

var $8loUC = parcelRequire("8loUC");

var $gwvPQ = parcelRequire("gwvPQ");

var $7pbqq = parcelRequire("7pbqq");
const $d0531372537d3533$export$8f9545cee64b3251 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $048B7.commonMacro)(input.substring(position), schema, {
        keyword: 'quote',
        paired: true,
        rawContentProcessor: $d0531372537d3533$export$c2a5e4612254bfa,
        context: context
    });
};
const $d0531372537d3533$export$c2a5e4612254bfa = (_rawAttrs, rawContent, length, schema, context)=>{
    if (!rawContent.length) {
        const emptyQuote = $d0531372537d3533$var$emptyBlockquote(schema);
        return {
            type: 'pmnode',
            nodes: [
                emptyQuote
            ],
            length: length
        };
    }
    const parsedContent = (0, $7pbqq.parseString)({
        schema: schema,
        context: context,
        ignoreTokenTypes: [],
        input: rawContent
    });
    const normalizedContent = (0, $gwvPQ.normalizePMNodes)(parsedContent, schema);
    return {
        type: 'pmnode',
        nodes: $d0531372537d3533$var$sanitize(normalizedContent, schema),
        length: length
    };
};
function $d0531372537d3533$var$emptyBlockquote(schema) {
    const p = schema.nodes.paragraph.createChecked({}, []);
    return schema.nodes.blockquote.createChecked({}, p);
}
function $d0531372537d3533$var$sanitize(nodes, schema) {
    const output = [];
    let contentBuffer = [];
    for (const n of nodes)switch(n.type.name){
        case 'paragraph':
        case 'bulletList':
        case 'orderedList':
            /**
				 * blockquote is happy with paragraph and list
				 */ contentBuffer.push(n);
            break;
        case 'heading':
            /**
				 * If a heading is inside a list item
				 * - h1. Bold, Uppercase
				 * - h2. Bold, Italic
				 * - h3. Bold
				 * - h4. Bold, Gray
				 * - h5. Gray, Italic
				 * - h6. Gray
				 */ contentBuffer.push($d0531372537d3533$var$transformHeading(n, schema));
            break;
        default:
            /**
				 * Anything else should be lifted
				 */ if (contentBuffer.length) {
                const blockquote = schema.nodes.blockquote.createChecked({}, contentBuffer);
                output.push(blockquote);
                contentBuffer = [];
            }
            output.push(n);
    }
    if (contentBuffer.length) {
        const blockquote = schema.nodes.blockquote.createChecked({}, contentBuffer);
        output.push(blockquote);
    }
    return output;
}
function $d0531372537d3533$var$transformHeading(heading, schema) {
    const contentBuffer = [];
    heading.content.forEach((n)=>{
        const strong = schema.marks.strong.create();
        const italic = schema.marks.em.create();
        const gray = schema.marks.textColor.create({
            color: '#97a0af'
        });
        if (n.type.name === 'text') {
            if (n.text && heading.attrs.level === 1) // @ts-ignore assigning to readonly prop to transform text
            n.text = n.text.toUpperCase();
            if (heading.attrs.level <= 4 && !(0, $8loUC.hasAnyOfMarks)(n, [
                'strong',
                'code'
            ])) n = n.mark([
                ...n.marks,
                strong
            ]);
            if ((heading.attrs.level === 5 || heading.attrs.level === 2) && !(0, $8loUC.hasAnyOfMarks)(n, [
                'em',
                'code'
            ])) n = n.mark([
                ...n.marks,
                italic
            ]);
            if (heading.attrs.level > 3 && !(0, $8loUC.hasAnyOfMarks)(n, [
                'textColor',
                'code'
            ])) n = n.mark([
                ...n.marks,
                gray
            ]);
        }
        contentBuffer.push(n);
    });
    return schema.nodes.paragraph.createChecked({}, contentBuffer);
}

});
parcelRegister("048B7", function(module, exports) {

$parcel$export(module.exports, "commonMacro", () => $531cf0819efc148e$export$b6a12943ac1bb1ba);
function $531cf0819efc148e$export$b6a12943ac1bb1ba(input, schema, opt) {
    /**
	 * Forging the opening regex, the result would look something like
	 * /^\{(quote)(?::([^\{\n\}]*))?\}/i
	 */ const opening = new RegExp(`^\{(${opt.keyword})(?::([^\{\n\}]*))?\}`, 'i');
    const matchOpening = input.match(opening);
    if (!matchOpening) return $531cf0819efc148e$var$fallback(input);
    const [, name, rawAttrs] = matchOpening;
    const openingLength = matchOpening[0].length;
    if (!opt.paired) /**
		 * Some macros do not have a closing symbol, for example
		 * {anchor:here} {loremipsum}
		 */ return opt.rawContentProcessor(rawAttrs, '', openingLength, schema, opt.context);
    /**
	 * Forging the closing regex, the result would look something like
	 * /\{quote\}/
	 */ const closing = new RegExp(`\{${name}\}`);
    const matchClosing = closing.exec(input.substring(openingLength));
    let rawContent = '';
    if (matchClosing) rawContent = input.substring(openingLength, openingLength + matchClosing.index);
    const length = matchClosing ? openingLength + matchClosing.index + matchClosing[0].length : openingLength;
    return opt.rawContentProcessor(rawAttrs, rawContent, length, schema, opt.context);
}
function $531cf0819efc148e$var$fallback(input) {
    return {
        type: 'text',
        text: input.substr(0, 1),
        length: 1
    };
}

});



parcelRegister("a4Ddm", function(module, exports) {

$parcel$export(module.exports, "citation", () => $f32594a62e32f935$export$258632c953c109e9);

var $lS4Zv = parcelRequire("lS4Zv");

var $8loUC = parcelRequire("8loUC");

var $cndSn = parcelRequire("cndSn");

var $7pbqq = parcelRequire("7pbqq");

const $f32594a62e32f935$export$258632c953c109e9 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content
	 */ const ignoreTokenTypes = [
        (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).ISSUE_KEY
    ];
    // Add code mark to each text
    const contentDecorator = (n, index)=>{
        const mark = schema.marks.em.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $8loUC.hasAnyOfMarks)(n, [
            'em',
            'code'
        ])) {
            if (index === 0) // @ts-ignore - [unblock prosemirror bump] allow assign to readonly
            n.text = `${0, $c490cd896aed630e$export$3bca9fae3002bd9b} ${n.text}`;
            return n.mark([
                ...n.marks,
                mark
            ]);
        }
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $7pbqq.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $8loUC.getSurroundingSymbols)(input.substring(position), '??', '??');
    return (0, $cndSn.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});
const $c490cd896aed630e$export$3bca9fae3002bd9b = "\u2014";


parcelRegister("70iSu", function(module, exports) {

$parcel$export(module.exports, "deleted", () => $728089dc2284a93f$export$bccbf0c716f226f4);

var $lS4Zv = parcelRequire("lS4Zv");

var $8loUC = parcelRequire("8loUC");

var $cndSn = parcelRequire("cndSn");

var $7pbqq = parcelRequire("7pbqq");
const $728089dc2284a93f$export$bccbf0c716f226f4 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content
	 */ const ignoreTokenTypes = [
        (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).ISSUE_KEY,
        (0, $lS4Zv.TokenType).TABLE
    ];
    /** Add strike mark to each text */ const contentDecorator = (n)=>{
        const mark = schema.marks.strike.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $8loUC.hasAnyOfMarks)(n, [
            'strike',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $7pbqq.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $8loUC.getSurroundingSymbols)(input.substring(position), '-', '-');
    return (0, $cndSn.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("bufmJ", function(module, exports) {

$parcel$export(module.exports, "doubleDashSymbol", () => $c0d69e139f33918a$export$65e3ca7c95899a2d);

var $60aCS = parcelRequire("60aCS");
const $c0d69e139f33918a$var$token = {
    type: 'text',
    text: '\u2013',
    length: 2
};
const $c0d69e139f33918a$var$fallback = {
    ...$c0d69e139f33918a$var$token,
    text: '--'
};
const $c0d69e139f33918a$export$65e3ca7c95899a2d = (0, $60aCS.createDashTokenParser)($c0d69e139f33918a$var$token, $c0d69e139f33918a$var$fallback);

});
parcelRegister("60aCS", function(module, exports) {

$parcel$export(module.exports, "createDashTokenParser", () => $febcf437b7899c3a$export$d43b58865d429e3c);
const $febcf437b7899c3a$export$d43b58865d429e3c = (token, fallback)=>({ input: input, position: position })=>{
        /**
		 * From Jira https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-renderer/src/main/java/com/atlassian/renderer/v2/components/phrase/DashRendererComponent.java
		 *  public static final Replacer EN_DASH = new Replacer(Pattern.compile("(^|\\s)--(\\s|$)"), "$1&#8211;$2", "--");
		 *  public static final Replacer EM_DASH = new Replacer(Pattern.compile("(^|\\s)---(\\s|$)"), "$1&#8212;$2", "---");
		 */ if (position > 0) {
            const charBeforeToken = input.charAt(position - 1);
            if (!$febcf437b7899c3a$var$isSpace(charBeforeToken)) return fallback;
        }
        if (position + token.length < input.length) {
            const charAfterToken = input.charAt(position + token.length);
            if (!$febcf437b7899c3a$var$isSpace(charAfterToken)) return fallback;
        }
        return token;
    };
const $febcf437b7899c3a$var$isSpace = (char)=>{
    return /\s/.test(char);
};

});


parcelRegister("jPNoV", function(module, exports) {

$parcel$export(module.exports, "emoji", () => $131b8693e561a2d0$export$a19185d1233fc4b2);
const $131b8693e561a2d0$var$emptyOrSpecialCharRegex = new RegExp(/^$|[^A-Za-z0-9]/);
const $131b8693e561a2d0$export$a19185d1233fc4b2 = ({ input: input, position: position, schema: schema })=>{
    const substring = input.substring(position);
    /**
	 * The length of wikimakrup emoji test ranges from 2 to 9 characters at the time of writing.
	 */ for(let i = 2; i <= 9 && i <= substring.length; ++i){
        const candidateText = substring.substring(0, i);
        const emojiId = $131b8693e561a2d0$export$fabd2c9504f5bf35[candidateText];
        // Is current candidate an emoji AND next character empty string any special character?
        if (emojiId && $131b8693e561a2d0$var$emptyOrSpecialCharRegex.test(substring.charAt(i))) return {
            type: 'pmnode',
            nodes: [
                schema.nodes.emoji.createChecked($131b8693e561a2d0$export$797c048dfde076a1[emojiId])
            ],
            length: i
        };
    }
    return {
        type: 'text',
        text: substring.substr(0, 1),
        length: 1
    };
};
const $131b8693e561a2d0$export$797c048dfde076a1 = {
    '1f642': {
        id: '1f642',
        shortName: ':slight_smile:',
        text: "\uD83D\uDE42"
    },
    '1f61e': {
        id: '1f61e',
        shortName: ':disappointed:',
        text: "\uD83D\uDE1E"
    },
    '1f61b': {
        id: '1f61b',
        shortName: ':stuck_out_tongue:',
        text: "\uD83D\uDE1B"
    },
    '1f603': {
        id: '1f603',
        shortName: ':smiley:',
        text: "\uD83D\uDE03"
    },
    '1f609': {
        id: '1f609',
        shortName: ':wink:',
        text: "\uD83D\uDE09"
    },
    '1f44d': {
        id: '1f44d',
        shortName: ':thumbsup:',
        text: "\uD83D\uDC4D"
    },
    '1f44e': {
        id: '1f44e',
        shortName: ':thumbsdown:',
        text: "\uD83D\uDC4E"
    },
    'atlassian-info': {
        id: 'atlassian-info',
        shortName: ':info:',
        text: ':info:'
    },
    'atlassian-check_mark': {
        id: 'atlassian-check_mark',
        shortName: ':check_mark:',
        text: ':check_mark:'
    },
    'atlassian-cross_mark': {
        id: 'atlassian-cross_mark',
        shortName: ':cross_mark:',
        text: ':cross_mark:'
    },
    'atlassian-warning': {
        id: 'atlassian-warning',
        shortName: ':warning:',
        text: ':warning:'
    },
    'atlassian-plus': {
        id: 'atlassian-plus',
        shortName: ':plus:',
        text: ':plus:'
    },
    'atlassian-minus': {
        id: 'atlassian-minus',
        shortName: ':minus:',
        text: ':minus:'
    },
    'atlassian-question_mark': {
        id: 'atlassian-question_mark',
        shortName: ':question:',
        text: ':question:'
    },
    'atlassian-light_bulb_on': {
        id: 'atlassian-light_bulb_on',
        shortName: ':light_bulb_on:',
        text: ':light_bulb_on:'
    },
    'atlassian-light_bulb_off': {
        id: 'atlassian-light_bulb_off',
        shortName: ':light_bulb_off:',
        text: ':light_bulb_off:'
    },
    'atlassian-yellow_star': {
        id: 'atlassian-yellow_star',
        shortName: ':yellow_star:',
        text: ':yellow_star:'
    },
    'atlassian-red_star': {
        id: 'atlassian-red_star',
        shortName: ':red_star:',
        text: ':red_star:'
    },
    'atlassian-green_star': {
        id: 'atlassian-green_star',
        shortName: ':green_star:',
        text: ':green_star:'
    },
    'atlassian-blue_star': {
        id: 'atlassian-blue_star',
        shortName: ':blue_star:',
        text: ':blue_star:'
    },
    'atlassian-flag_on': {
        id: 'atlassian-flag_on',
        shortName: ':flag_on:',
        text: ':flag_on:'
    },
    'atlassian-flag_off': {
        id: 'atlassian-flag_off',
        shortName: ':flag_off:',
        text: ':flag_off:'
    }
};
const $131b8693e561a2d0$export$fabd2c9504f5bf35 = {
    ':)': '1f642',
    ':-)': '1f642',
    ':(': '1f61e',
    ':-(': '1f61e',
    ':P': '1f61b',
    ':-P': '1f61b',
    ':p': '1f61b',
    ':-p': '1f61b',
    ':D': '1f603',
    ':-D': '1f603',
    ';)': '1f609',
    ';-)': '1f609',
    '(y)': '1f44d',
    '(n)': '1f44e',
    '(i)': 'atlassian-info',
    '(/)': 'atlassian-check_mark',
    '(x)': 'atlassian-cross_mark',
    '(!)': 'atlassian-warning',
    '(+)': 'atlassian-plus',
    '(-)': 'atlassian-minus',
    '(?)': 'atlassian-question_mark',
    '(on)': 'atlassian-light_bulb_on',
    '(off)': 'atlassian-light_bulb_off',
    '(*)': 'atlassian-yellow_star',
    '(*y)': 'atlassian-yellow_star',
    '(*r)': 'atlassian-red_star',
    '(*g)': 'atlassian-green_star',
    '(*b)': 'atlassian-blue_star',
    '(flag)': 'atlassian-flag_on',
    '(flagoff)': 'atlassian-flag_off'
};

});

parcelRegister("gJccQ", function(module, exports) {

$parcel$export(module.exports, "emphasis", () => $59b8582b485105d1$export$bef81ba411953b51);

var $lS4Zv = parcelRequire("lS4Zv");

var $8loUC = parcelRequire("8loUC");

var $cndSn = parcelRequire("cndSn");

var $7pbqq = parcelRequire("7pbqq");
const $59b8582b485105d1$export$bef81ba411953b51 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a  mark
	 */ const ignoreTokenTypes = [
        (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).ISSUE_KEY,
        (0, $lS4Zv.TokenType).TABLE
    ];
    // Add underline mark to each text
    const contentDecorator = (n)=>{
        const mark = schema.marks.em.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $8loUC.hasAnyOfMarks)(n, [
            'em',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $7pbqq.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $8loUC.getSurroundingSymbols)(input.substring(position), '_', '_');
    return (0, $cndSn.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("g0NwP", function(module, exports) {

$parcel$export(module.exports, "hardbreak", () => $1b96753f1f0ca08b$export$ac55bb44695749c1);

var $kJkY5 = parcelRequire("kJkY5");
const $1b96753f1f0ca08b$export$ac55bb44695749c1 = ({ input: input, position: position, schema: schema })=>{
    // Look for normal hardbreak \r, \n, \r\n
    const length = (0, $kJkY5.parseNewlineOnly)(input.substring(position));
    if (length === 0) // not a valid hardbreak
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
    return {
        type: 'pmnode',
        nodes: [
            schema.nodes.hardBreak.createChecked()
        ],
        length: length
    };
};

});

parcelRegister("jCitd", function(module, exports) {

$parcel$export(module.exports, "heading", () => $8ef7f4653a487722$export$46e4a324ac90507f);

var $7pbqq = parcelRequire("7pbqq");

var $lS4Zv = parcelRequire("lS4Zv");
// h1. HEADING
const $8ef7f4653a487722$var$HEADING_REGEXP = /^h([1-6])\.(.*)/;
const $8ef7f4653a487722$export$46e4a324ac90507f = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a strong mark
	 */ const ignoreTokenTypes = [
        (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL
    ];
    const match = input.substring(position).match($8ef7f4653a487722$var$HEADING_REGEXP);
    if (!match) return $8ef7f4653a487722$var$fallback(input, position);
    const level = parseInt(match[1], 10);
    const content = (0, $7pbqq.parseString)({
        schema: schema,
        ignoreTokenTypes: ignoreTokenTypes,
        context: context,
        input: match[2]
    });
    try {
        const headingNode = schema.nodes.heading.createChecked({
            level: level
        }, content);
        return {
            type: 'pmnode',
            nodes: [
                headingNode
            ],
            length: match[0].length
        };
    } catch (err) {
        /**
		 * If the heading fails to rendering, we want to skip the text
		 * "h1."
		 */ return {
            type: 'text',
            text: '',
            length: 4
        };
    }
};
function $8ef7f4653a487722$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}

});

parcelRegister("r2pEr", function(module, exports) {

$parcel$export(module.exports, "inserted", () => $2ce10c45c3e91d56$export$744ba74fb86b8ca7);

var $lS4Zv = parcelRequire("lS4Zv");

var $8loUC = parcelRequire("8loUC");

var $cndSn = parcelRequire("cndSn");

var $7pbqq = parcelRequire("7pbqq");
const $2ce10c45c3e91d56$export$744ba74fb86b8ca7 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content
	 */ const ignoreTokenTypes = [
        (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).ISSUE_KEY,
        (0, $lS4Zv.TokenType).TABLE
    ];
    // Add underline mark to each text
    const contentDecorator = (n)=>{
        const mark = schema.marks.underline.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $8loUC.hasAnyOfMarks)(n, [
            'underline',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $7pbqq.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $8loUC.getSurroundingSymbols)(input.substring(position), '+', '+');
    return (0, $cndSn.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("3O0Q2", function(module, exports) {

$parcel$export(module.exports, "MAX_LIST_DEPTH", () => $8e6b28ef20d5dbbb$export$d2a2f0ec33d903e1);
$parcel$export(module.exports, "list", () => $8e6b28ef20d5dbbb$export$8837f4fc672e936d);

var $dTuMp = parcelRequire("dTuMp");

var $7pbqq = parcelRequire("7pbqq");

var $gwvPQ = parcelRequire("gwvPQ");

var $2ROXs = parcelRequire("2ROXs");

var $lS4Zv = parcelRequire("lS4Zv");

var $kJkY5 = parcelRequire("kJkY5");

var $8loUC = parcelRequire("8loUC");
const $8e6b28ef20d5dbbb$export$d2a2f0ec33d903e1 = 20;
const $8e6b28ef20d5dbbb$var$LIST_ITEM_REGEXP = new RegExp(`^ *([*\\-#]{1,${$8e6b28ef20d5dbbb$export$d2a2f0ec33d903e1}}) `);
const $8e6b28ef20d5dbbb$var$EMPTY_LINE_REGEXP = /^[ \t]*\r?\n/;
const $8e6b28ef20d5dbbb$var$RULER_SYMBOL_REGEXP = /^-{4,5}/;
const $8e6b28ef20d5dbbb$var$processState = {
    NEW_LINE: 0,
    BUFFER: 1,
    END: 2,
    MACRO: 3
};
const $8e6b28ef20d5dbbb$export$8837f4fc672e936d = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a listItem
	 */ const ignoreTokenTypes = [
        (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).LIST,
        (0, $lS4Zv.TokenType).TABLE
    ];
    let index = position;
    let state = $8e6b28ef20d5dbbb$var$processState.NEW_LINE;
    let buffer = [];
    let lastListSymbols = null;
    let builder = null;
    let contentBuffer = [];
    const output = [];
    while(index < input.length){
        const char = input.charAt(index);
        switch(state){
            case $8e6b28ef20d5dbbb$var$processState.NEW_LINE:
                {
                    const substring = input.substring(index);
                    const listMatch = substring.match($8e6b28ef20d5dbbb$var$LIST_ITEM_REGEXP);
                    if (listMatch) {
                        const [, symbols] = listMatch;
                        // Handle ruler in list
                        const rulerMatch = symbols.match($8e6b28ef20d5dbbb$var$RULER_SYMBOL_REGEXP);
                        if (rulerMatch) {
                            const remainingAfterSymbol = input.substring(index + rulerMatch[0].length);
                            const emptyLineMatch = remainingAfterSymbol.match($8e6b28ef20d5dbbb$var$EMPTY_LINE_REGEXP);
                            // If this is an empty line skip to the buffering step rather than match as a list element
                            if (emptyLineMatch) {
                                state = $8e6b28ef20d5dbbb$var$processState.BUFFER;
                                continue;
                            }
                        }
                        if (!builder) {
                            // It happens because this is the first item of the list
                            builder = new (0, $dTuMp.ListBuilder)(schema, symbols);
                            lastListSymbols = symbols;
                        } else {
                            /**
						 * There is a builder, so we are in the middle of building a list
						 * and now there is a new list item
						 */ if (buffer.length > 0) {
                                // Wrap up previous list item and clear buffer
                                const content = (0, $7pbqq.parseString)({
                                    ignoreTokenTypes: ignoreTokenTypes,
                                    schema: schema,
                                    context: context,
                                    input: buffer.join(''),
                                    includeLeadingSpace: true
                                });
                                contentBuffer.push(...content);
                                builder.add([
                                    {
                                        style: lastListSymbols,
                                        content: $8e6b28ef20d5dbbb$var$sanitize((0, $gwvPQ.normalizePMNodes)(contentBuffer, schema), schema)
                                    }
                                ]);
                                buffer = [];
                                contentBuffer = [];
                            }
                            // We finished last list item here, going to the new one
                            lastListSymbols = symbols;
                            const type = (0, $dTuMp.getType)(symbols);
                            // If it's top level and doesn't match, create a new list
                            if (type !== builder.type && symbols.length === 1) {
                                output.push(...builder.buildPMNode());
                                builder = new (0, $dTuMp.ListBuilder)(schema, symbols);
                            }
                        }
                        index += listMatch[0].length;
                    }
                    // If we encounter an empty line, we should end the list
                    const emptyLineMatch = substring.match($8e6b28ef20d5dbbb$var$EMPTY_LINE_REGEXP);
                    if (emptyLineMatch) {
                        state = $8e6b28ef20d5dbbb$var$processState.END;
                        continue;
                    }
                    state = $8e6b28ef20d5dbbb$var$processState.BUFFER;
                    continue;
                }
            case $8e6b28ef20d5dbbb$var$processState.BUFFER:
                {
                    const length = (0, $kJkY5.parseNewlineOnly)(input.substring(index));
                    if (length) {
                        buffer.push(input.substr(index, length));
                        state = $8e6b28ef20d5dbbb$var$processState.NEW_LINE;
                        index += length;
                        continue;
                    }
                    if (char === '{') {
                        state = $8e6b28ef20d5dbbb$var$processState.MACRO;
                        continue;
                    } else buffer.push(char);
                    break;
                }
            case $8e6b28ef20d5dbbb$var$processState.MACRO:
                {
                    const match = (0, $2ROXs.parseMacroKeyword)(input.substring(index));
                    if (!match) {
                        buffer.push(char);
                        state = $8e6b28ef20d5dbbb$var$processState.BUFFER;
                        break;
                    }
                    const token = (0, $lS4Zv.parseToken)(input, match.type, index, schema, context);
                    buffer.push(input.substr(index, token.length));
                    index += token.length;
                    state = $8e6b28ef20d5dbbb$var$processState.BUFFER;
                    continue;
                }
            case $8e6b28ef20d5dbbb$var$processState.END:
                if (!builder) // Something is really wrong here
                return $8e6b28ef20d5dbbb$var$fallback(input, position);
                if (buffer.length > 0) {
                    // Wrap up previous list item and clear buffer
                    const content = (0, $7pbqq.parseString)({
                        ignoreTokenTypes: ignoreTokenTypes,
                        schema: schema,
                        context: context,
                        input: buffer.join(''),
                        includeLeadingSpace: true
                    });
                    contentBuffer.push(...content);
                }
                builder.add([
                    {
                        style: lastListSymbols,
                        content: $8e6b28ef20d5dbbb$var$sanitize((0, $gwvPQ.normalizePMNodes)(contentBuffer, schema), schema)
                    }
                ]);
                output.push(...builder.buildPMNode());
                return {
                    type: 'pmnode',
                    nodes: output,
                    length: index - position
                };
        }
        index++;
    }
    if (buffer.length > 0) {
        // Wrap up what's left in the buffer
        const content = (0, $7pbqq.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: buffer.join(''),
            includeLeadingSpace: true
        });
        contentBuffer.push(...content);
    }
    if (builder) {
        builder.add([
            {
                style: lastListSymbols,
                content: $8e6b28ef20d5dbbb$var$sanitize((0, $gwvPQ.normalizePMNodes)(contentBuffer, schema), schema)
            }
        ]);
        output.push(...builder.buildPMNode());
    }
    return {
        type: 'pmnode',
        nodes: output,
        length: index - position
    };
};
function $8e6b28ef20d5dbbb$var$sanitize(nodes, schema) {
    return nodes.reduce((result, curr)=>{
        switch(curr.type.name){
            case 'blockquote':
                /**
				 * If a blockquote is inside a list item
				 * - Convert it to paragraph
				 */ curr.content.forEach((n)=>{
                    result.push(n);
                });
                break;
            case 'heading':
                {
                    /**
				 * If a heading is inside a list item
				 * - Convert the heading to paragraph
				 * - Convert text to upper case
				 * - Mark text with strong.
				 */ const contentBuffer = [];
                    curr.content.forEach((n)=>{
                        const mark = schema.marks.strong.create();
                        if (n.type.name === 'text') {
                            if (n.text) // @ts-ignore - [unblock prosemirror bump] allow assign to readonly
                            n.text = n.text.toUpperCase();
                            if (n.type.name === 'text' && !(0, $8loUC.hasAnyOfMarks)(n, [
                                'strong',
                                'code'
                            ])) contentBuffer.push(n.mark([
                                ...n.marks,
                                mark
                            ]));
                            else contentBuffer.push(n);
                        } else contentBuffer.push(n);
                    });
                    const p = schema.nodes.paragraph.createChecked({}, contentBuffer);
                    result.push(p);
                    break;
                }
            default:
                result.push(curr);
        }
        return result;
    }, []);
}
function $8e6b28ef20d5dbbb$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 1),
        length: 1
    };
}

});
parcelRegister("dTuMp", function(module, exports) {

$parcel$export(module.exports, "getType", () => $1bbe9941d5099473$export$e2b5c5db9e2009fd);
$parcel$export(module.exports, "ListBuilder", () => $1bbe9941d5099473$export$876cfa3161bef296);
const $1bbe9941d5099473$var$supportedContentType = [
    'paragraph',
    'orderedList',
    'bulletList',
    'mediaSingle',
    'codeBlock'
];
function $1bbe9941d5099473$export$e2b5c5db9e2009fd(bullets) {
    return /#$/.test(bullets) ? 'orderedList' : 'bulletList';
}
class $1bbe9941d5099473$export$876cfa3161bef296 {
    constructor(schema, bullets){
        /**
	 * Build prosemirror bulletList or orderedList node
	 * @param {List} list
	 * @returns {PMNode}
	 */ this.parseList = (list)=>{
            const listNode = this.schema.nodes[list.type];
            const output = [];
            let listItemsBuffer = [];
            for(let i = 0; i < list.children.length; i++){
                const parsedContent = this.parseListItem(list.children[i]);
                for(let j = 0; j < parsedContent.length; j++){
                    const parsedNode = parsedContent[j];
                    if (parsedNode.type.name === 'listItem') {
                        listItemsBuffer.push(parsedNode);
                        continue;
                    }
                    /**
				 * If the node is not a listItem, then we need to
				 * wrap exisintg list and break out
				 */ if (listItemsBuffer.length) {
                        const list = listNode.createChecked({}, listItemsBuffer);
                        output.push(list);
                    }
                    output.push(parsedNode); // This is the break out node
                    listItemsBuffer = [];
                }
            }
            if (listItemsBuffer.length) {
                const list = listNode.createChecked({}, listItemsBuffer);
                output.push(list);
            }
            return output;
        };
        /**
	 * Build prosemirror listItem node
	 * This function would possibly return non listItem nodes
	 * which we need to break out later
	 * @param {ListItem} item
	 */ this.parseListItem = (item)=>{
            const output = [];
            if (!item.content) item.content = [];
            // Parse nested list
            const parsedChildren = item.children.reduce((result, list)=>{
                const parsedList = this.parseList(list);
                result.push(...parsedList);
                return result;
            }, []);
            // Append children to the content
            item.content.push(...parsedChildren);
            let contentBuffer = [];
            for(let i = 0; i < item.content.length; i++){
                const pmNode = item.content[i];
                /**
			 * Skip empty paragraph
			 */ if (pmNode.type.name === 'paragraph' && pmNode.childCount === 0) continue;
                /* Skip Empty spaces after rule */ if (this.isParagraphEmptyTextNode(pmNode)) continue;
                if ($1bbe9941d5099473$var$supportedContentType.indexOf(pmNode.type.name) === -1) {
                    const listItem = this.createListItem(contentBuffer, this.schema);
                    output.push(listItem);
                    output.push(pmNode);
                    contentBuffer = [];
                    continue;
                }
                contentBuffer.push(pmNode);
            }
            if (contentBuffer.length) {
                const listItem = this.createListItem(contentBuffer, this.schema);
                output.push(listItem);
            }
            return output;
        };
        this.schema = schema;
        this.root = {
            children: [],
            type: $1bbe9941d5099473$export$e2b5c5db9e2009fd(bullets)
        };
        this.lastDepth = 1;
        this.lastList = this.root;
    }
    /**
	 * Return the type of the base list
	 * @returns {ListType}
	 */ get type() {
        return this.root.type;
    }
    /**
	 * Add a list item to the builder
	 * @param {AddArgs[]} items
	 */ add(items) {
        for (const item of items){
            const { style: style, content: content } = item;
            // If there's no style, add to previous list item as multiline
            if (style === null) {
                this.appendToLastItem(content);
                continue;
            }
            const depth = style.length;
            const type = $1bbe9941d5099473$export$e2b5c5db9e2009fd(style);
            if (depth > this.lastDepth) {
                // Add children starting from last node
                this.createNest(depth - this.lastDepth, type);
                this.lastDepth = depth;
                this.lastList = this.addListItem(type, content);
            } else if (depth === this.lastDepth) // Add list item to current node
            this.lastList = this.addListItem(type, content);
            else {
                // Find node at depth and add list item
                this.lastList = this.findAncestor(this.lastDepth - depth);
                this.lastDepth = depth;
                this.lastList = this.addListItem(type, content);
            }
        }
    }
    /**
	 * Compile a prosemirror node from the root list
	 * @returns {PMNode[]}
	 */ buildPMNode() {
        return this.parseList(this.root);
    }
    /* Check if all paragraph's children nodes are text and empty */ isParagraphEmptyTextNode(node) {
        if (node.type.name !== 'paragraph' || !node.childCount) return false;
        for(let i = 0; i < node.childCount; i++){
            const n = node.content.child(i);
            if (n.type.name !== 'text') // Paragraph contains non-text node, so not empty
            return false;
            else if (n.textContent.trim() !== '') return false;
        }
        return true;
    }
    createListItem(content, schema) {
        if (content.length === 0 || [
            'paragraph',
            'mediaSingle'
        ].indexOf(content[0].type.name) === -1) // If the content is empty or the first element is not paragraph or mediaSingle.
        // this likely to be a nested list where the toplevel list is empty
        // For example: *# item 1
        // In this case we create an empty paragraph for the top level listNode
        content.unshift(this.schema.nodes.paragraph.createChecked());
        return schema.nodes.listItem.createChecked({}, content);
    }
    /**
	 * Add an item at the same level as the current list item
	 * @param {ListType} type
	 * @param {PMNode} content
	 * @returns {PMNode}
	 */ addListItem(type, content) {
        let list = this.lastList;
        // If the list is a different type, create a new list and add it to the parent node
        if (list.type !== type) {
            const parent = list.parent;
            const newList = {
                children: [],
                type: type,
                parent: parent
            };
            parent.children.push(newList);
            this.lastList = list = newList;
        }
        const listItem = {
            content: content,
            parent: list,
            children: []
        };
        list.children = [
            ...list.children,
            listItem
        ];
        return list;
    }
    /**
	 * Append the past content to the last accessed list node (multiline entries)
	 * @param {PMNode[]} content
	 */ appendToLastItem(content) {
        const { children: children } = this.lastList;
        const lastItem = children[children.length - 1];
        lastItem.content.push(...content);
    }
    /**
	 * Created a nested list structure of N depth under the current node
	 * @param {number} depth
	 * @param {ListType} type
	 */ createNest(depth, type) {
        while(depth-- > 0){
            if (this.lastList.children.length === 0) {
                const listItem = {
                    parent: this.lastList,
                    children: []
                };
                this.lastList.children = [
                    listItem
                ];
            }
            const nextItem = this.lastList.children[this.lastList.children.length - 1];
            nextItem.children = [
                {
                    children: [],
                    parent: nextItem,
                    type: type
                }
            ];
            this.lastList = nextItem.children[0];
        }
    }
    /**
	 * Find the Nth list ancestor of the current list
	 * @param {number} depth
	 */ findAncestor(depth) {
        let list = this.lastList;
        while(depth-- > 0 && list.parent){
            const listItem = list.parent;
            if (listItem && listItem.parent) list = listItem.parent;
        }
        return list;
    }
}

});


parcelRegister("kJ7iC", function(module, exports) {

$parcel$export(module.exports, "monospace", () => $897226e11d677a0e$export$2b90969bbc9ff4c9);

var $lS4Zv = parcelRequire("lS4Zv");

var $8loUC = parcelRequire("8loUC");

var $cndSn = parcelRequire("cndSn");

var $7pbqq = parcelRequire("7pbqq");
const $897226e11d677a0e$export$2b90969bbc9ff4c9 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content
	 */ const ignoreTokenTypes = [
        (0, $lS4Zv.TokenType).ADF_MACRO,
        (0, $lS4Zv.TokenType).ANCHOR_MACRO,
        (0, $lS4Zv.TokenType).CODE_MACRO,
        (0, $lS4Zv.TokenType).QUOTE_MACRO,
        (0, $lS4Zv.TokenType).NOFORMAT_MACRO,
        (0, $lS4Zv.TokenType).PANEL_MACRO,
        (0, $lS4Zv.TokenType).COLOR_MACRO,
        (0, $lS4Zv.TokenType).LOREM_MACRO,
        (0, $lS4Zv.TokenType).QUOTE,
        (0, $lS4Zv.TokenType).STRING,
        (0, $lS4Zv.TokenType).ISSUE_KEY,
        (0, $lS4Zv.TokenType).LINK_FORMAT,
        (0, $lS4Zv.TokenType).LINK_TEXT,
        (0, $lS4Zv.TokenType).MEDIA,
        (0, $lS4Zv.TokenType).HEADING,
        (0, $lS4Zv.TokenType).LIST,
        (0, $lS4Zv.TokenType).TABLE,
        (0, $lS4Zv.TokenType).RULER,
        (0, $lS4Zv.TokenType).HARD_BREAK,
        (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).STRONG,
        (0, $lS4Zv.TokenType).MONOSPACE,
        (0, $lS4Zv.TokenType).SUPERSCRIPT,
        (0, $lS4Zv.TokenType).SUBSCRIPT,
        (0, $lS4Zv.TokenType).EMPHASIS,
        (0, $lS4Zv.TokenType).CITATION,
        (0, $lS4Zv.TokenType).DELETED,
        (0, $lS4Zv.TokenType).INSERTED,
        (0, $lS4Zv.TokenType).EMOJI,
        (0, $lS4Zv.TokenType).FORCE_LINE_BREAK
    ];
    // Add code mark to each text
    const contentDecorator = (n)=>{
        const mark = schema.marks.code.create();
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && n.marks.length) return n;
        return n.mark([
            mark
        ]);
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $7pbqq.parseString)({
            ignoreTokenTypes: ignoreTokenTypes,
            schema: schema,
            context: context,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $8loUC.getSurroundingSymbols)(input.substring(position), '{{', '}}');
    return (0, $cndSn.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("lDSkN", function(module, exports) {

$parcel$export(module.exports, "quadrupleDashSymbol", () => $b665ccaa71cf7b7e$export$95a7907a71f31921);
const $b665ccaa71cf7b7e$var$MULTI_DASH_REGEX = /^-{4,}(\s|$)/;
const $b665ccaa71cf7b7e$export$95a7907a71f31921 = ({ input: input, position: position })=>{
    // This won't be a ruler because ruler has been checked at leadingKeywordMapping
    const match = input.substring(position).match($b665ccaa71cf7b7e$var$MULTI_DASH_REGEX);
    if (!match) return {
        type: 'text',
        text: '----',
        length: 4
    };
    return {
        type: 'text',
        text: input.substr(position, match[0].length),
        length: match[0].length
    };
};

});

parcelRegister("eyWXo", function(module, exports) {

$parcel$export(module.exports, "ruler", () => $1d0757d75b47a860$export$f9adada2013e846e);

var $4N3mo = parcelRequire("4N3mo");
const $1d0757d75b47a860$var$RULER_REGEX = /^-{4,5}(\s|$)/;
const $1d0757d75b47a860$export$f9adada2013e846e = ({ input: input, position: position, schema: schema })=>{
    const match = input.substring(position).match($1d0757d75b47a860$var$RULER_REGEX);
    if (match) return {
        type: 'pmnode',
        nodes: (0, $4N3mo.createRuleNode)(schema),
        length: match[0].length
    };
    return {
        type: 'text',
        text: input.substring(position, 1),
        length: 1
    };
};

});
parcelRegister("4N3mo", function(module, exports) {

$parcel$export(module.exports, "createRuleNode", () => $31b4de5795580324$export$4267f2e5716b018a);
const $31b4de5795580324$var$HORIZONTAL_LINE_INSIDE_MACRO = '---';
function $31b4de5795580324$export$2e2bcd8739ae039(schema, containerNodeType) {
    const { paragraph: paragraph, rule: rule } = schema.nodes;
    if (containerNodeType) {
        const textNode = schema.text($31b4de5795580324$var$HORIZONTAL_LINE_INSIDE_MACRO);
        return paragraph.createChecked({}, textNode);
    } else return rule.createChecked();
}
function $31b4de5795580324$export$4267f2e5716b018a(schema) {
    const { rule: rule } = schema.nodes;
    const ruleNode = rule.createChecked();
    return [
        ruleNode
    ];
}

});


parcelRegister("66xYR", function(module, exports) {

$parcel$export(module.exports, "strong", () => $83c0fb2c2624e22e$export$59ae2c325a998f89);

var $lS4Zv = parcelRequire("lS4Zv");

var $8loUC = parcelRequire("8loUC");

var $cndSn = parcelRequire("cndSn");

var $7pbqq = parcelRequire("7pbqq");
const $83c0fb2c2624e22e$export$59ae2c325a998f89 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a strong mark
	 */ const ignoreTokenTypes = [
        (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).ISSUE_KEY,
        (0, $lS4Zv.TokenType).TABLE
    ];
    // Adding strong mark to all text
    const contentDecorator = (pmNode)=>{
        const mark = schema.marks.strong.create();
        // We don't want to mix `code` mark with others
        if (pmNode.type.name === 'text' && !(0, $8loUC.hasAnyOfMarks)(pmNode, [
            'strong',
            'code'
        ])) return pmNode.mark([
            ...pmNode.marks,
            mark
        ]);
        return pmNode;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $7pbqq.parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $8loUC.getSurroundingSymbols)(input.substring(position), '*', '*');
    return (0, $cndSn.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("jWDvo", function(module, exports) {

$parcel$export(module.exports, "subscript", () => $f88bd6b7c0190e05$export$bc5390e4688d2822);

var $lS4Zv = parcelRequire("lS4Zv");

var $8loUC = parcelRequire("8loUC");

var $cndSn = parcelRequire("cndSn");

var $7pbqq = parcelRequire("7pbqq");
const $f88bd6b7c0190e05$export$bc5390e4688d2822 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a  mark
	 */ const ignoreTokenTypes = [
        (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).ISSUE_KEY,
        (0, $lS4Zv.TokenType).TABLE
    ];
    // Adding subsup mark to all text
    const contentDecorator = (n)=>{
        const mark = schema.marks.subsup.create({
            type: 'sub'
        });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $8loUC.hasAnyOfMarks)(n, [
            'subsup',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $7pbqq.parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $8loUC.getSurroundingSymbols)(input.substring(position), '~', '~');
    return (0, $cndSn.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("4333j", function(module, exports) {

$parcel$export(module.exports, "superscript", () => $80a43a44e8eb4ef9$export$b4aab94a5fcfcead);

var $lS4Zv = parcelRequire("lS4Zv");

var $8loUC = parcelRequire("8loUC");

var $cndSn = parcelRequire("cndSn");

var $7pbqq = parcelRequire("7pbqq");
const $80a43a44e8eb4ef9$export$b4aab94a5fcfcead = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a  mark
	 */ const ignoreTokenTypes = [
        (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).ISSUE_KEY,
        (0, $lS4Zv.TokenType).TABLE
    ];
    // Adding subsup mark to all text
    const contentDecorator = (n)=>{
        const mark = schema.marks.subsup.create({
            type: 'sup'
        });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $8loUC.hasAnyOfMarks)(n, [
            'subsup',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    };
    const rawContentProcessor = (raw, length)=>{
        const content = (0, $7pbqq.parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: raw
        });
        const decoratedContent = content.map(contentDecorator);
        return {
            type: 'pmnode',
            nodes: decoratedContent,
            length: length
        };
    };
    const { openingSymbol: openingSymbol, closingSymbol: closingSymbol } = (0, $8loUC.getSurroundingSymbols)(input.substring(position), '^', '^');
    return (0, $cndSn.commonFormatter)(input, position, schema, {
        opening: openingSymbol,
        closing: closingSymbol,
        context: context,
        rawContentProcessor: rawContentProcessor
    });
};

});

parcelRegister("VuFCw", function(module, exports) {

$parcel$export(module.exports, "table", () => $b312622af426b5b5$export$9852986a3ec5f6a0);

var $1t19o = parcelRequire("1t19o");

var $7pbqq = parcelRequire("7pbqq");

var $gwvPQ = parcelRequire("gwvPQ");

var $lccs8 = parcelRequire("lccs8");

var $iw2bq = parcelRequire("iw2bq");

var $jPNoV = parcelRequire("jPNoV");

var $lS4Zv = parcelRequire("lS4Zv");

var $kJkY5 = parcelRequire("kJkY5");

var $2ROXs = parcelRequire("2ROXs");

var $8loUC = parcelRequire("8loUC");
/*
  The following are currently NOT supported
  1. Macros
  2. Escape |
  3. Table of table
*/ const $b312622af426b5b5$var$CELL_REGEXP = /^([ \t]*)([|]+)([ \t]*)/;
const $b312622af426b5b5$var$EMPTY_LINE_REGEXP = /^[ \t]*\r?\n/;
const $b312622af426b5b5$var$processState = {
    END_TABLE: 2,
    BUFFER: 4,
    CLOSE_ROW: 5,
    NEW_ROW: 6,
    LINE_BREAK: 7,
    LINK: 8,
    MEDIA: 9,
    MACRO: 10,
    EMOJI: 11
};
const $b312622af426b5b5$export$9852986a3ec5f6a0 = ({ input: input, position: position, schema: schema, context: context })=>{
    /**
	 * The following token types will be ignored in parsing
	 * the content of a table cell
	 */ const ignoreTokenTypes = [
        (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TABLE,
        (0, $lS4Zv.TokenType).RULER
    ];
    const output = [];
    let index = position;
    let currentState = $b312622af426b5b5$var$processState.NEW_ROW;
    let buffer = [];
    let cellsBuffer = [];
    let cellStyle = '';
    let builder = null;
    while(index < input.length){
        const char = input.charAt(index);
        const substring = input.substring(index);
        switch(currentState){
            case $b312622af426b5b5$var$processState.NEW_ROW:
                {
                    const tableMatch = substring.match($b312622af426b5b5$var$CELL_REGEXP);
                    if (tableMatch) {
                        if (!builder) builder = new (0, $1t19o.TableBuilder)(schema);
                        // Capture empty spaces
                        index += tableMatch[1].length;
                        cellStyle = tableMatch[2];
                        index += tableMatch[2].length;
                        currentState = $b312622af426b5b5$var$processState.BUFFER;
                        continue;
                    }
                    currentState = $b312622af426b5b5$var$processState.END_TABLE;
                    continue;
                }
            case $b312622af426b5b5$var$processState.LINE_BREAK:
                {
                    const emptyLineMatch = substring.match($b312622af426b5b5$var$EMPTY_LINE_REGEXP);
                    if (emptyLineMatch) {
                        // If we encounter an empty line, we should end the table
                        $b312622af426b5b5$var$bufferToCells(cellStyle, buffer.join(''), cellsBuffer, schema, ignoreTokenTypes, context);
                        currentState = $b312622af426b5b5$var$processState.END_TABLE;
                        continue;
                    }
                    // If we enconter a new row
                    const cellMatch = substring.match($b312622af426b5b5$var$CELL_REGEXP);
                    if (cellMatch) currentState = $b312622af426b5b5$var$processState.CLOSE_ROW;
                    else currentState = $b312622af426b5b5$var$processState.BUFFER;
                    continue;
                }
            case $b312622af426b5b5$var$processState.BUFFER:
                {
                    const length = (0, $kJkY5.parseNewlineOnly)(substring);
                    if (length) {
                        // Calculate the index of the end of the current cell,
                        // upto and including the new line
                        const endIndex = index;
                        // Calculate the index of the start of the current cell
                        const startIndex = input.lastIndexOf('|', endIndex) + 1;
                        const charsBefore = input.substring(startIndex, endIndex);
                        if (charsBefore === '' || charsBefore.match($b312622af426b5b5$var$EMPTY_LINE_REGEXP)) currentState = $b312622af426b5b5$var$processState.CLOSE_ROW;
                        else {
                            currentState = $b312622af426b5b5$var$processState.LINE_BREAK;
                            buffer.push(input.substr(index, length));
                        }
                        index += length;
                        continue;
                    }
                    switch(char){
                        case '|':
                            {
                                // This is now end of a cell, we should wrap the buffer into a cell
                                $b312622af426b5b5$var$bufferToCells(cellStyle, buffer.join(''), cellsBuffer, schema, ignoreTokenTypes, context);
                                buffer = [];
                                // Update cells tyle
                                const cellMatch = substring.match($b312622af426b5b5$var$CELL_REGEXP);
                                // The below if statement should aways be true, we leave it here to prevent any future code changes fall into infinite loop
                                if (cellMatch) {
                                    cellStyle = cellMatch[2];
                                    // Move into the cell content
                                    index += cellMatch[2].length;
                                    continue;
                                }
                                break;
                            }
                        case ':':
                        case ';':
                        case '(':
                            currentState = $b312622af426b5b5$var$processState.EMOJI;
                            continue;
                        case '[':
                            currentState = $b312622af426b5b5$var$processState.LINK;
                            continue;
                        case '!':
                            currentState = $b312622af426b5b5$var$processState.MEDIA;
                            continue;
                        case '{':
                            currentState = $b312622af426b5b5$var$processState.MACRO;
                            continue;
                        default:
                            buffer.push(char);
                            index++;
                            continue;
                    }
                    break;
                }
            case $b312622af426b5b5$var$processState.CLOSE_ROW:
                {
                    const bufferOutput = buffer.join('');
                    if (bufferOutput.trim().length > 0) {
                        $b312622af426b5b5$var$bufferToCells(cellStyle, bufferOutput, cellsBuffer, schema, ignoreTokenTypes, context);
                        buffer = [];
                    }
                    if (builder) {
                        builder.add(cellsBuffer);
                        cellsBuffer = [];
                    }
                    currentState = $b312622af426b5b5$var$processState.NEW_ROW;
                    continue;
                }
            case $b312622af426b5b5$var$processState.END_TABLE:
                if (builder) {
                    if (cellsBuffer.length) builder.add(cellsBuffer);
                    output.push(builder.buildPMNode());
                }
                return {
                    type: 'pmnode',
                    nodes: output,
                    length: index - position
                };
            case $b312622af426b5b5$var$processState.MEDIA:
                {
                    const token = (0, $iw2bq.media)({
                        input: input,
                        schema: schema,
                        context: context,
                        position: index
                    });
                    buffer.push(input.substr(index, token.length));
                    index += token.length;
                    currentState = $b312622af426b5b5$var$processState.BUFFER;
                    continue;
                }
            case $b312622af426b5b5$var$processState.EMOJI:
                {
                    const token = (0, $jPNoV.emoji)({
                        input: input,
                        schema: schema,
                        context: context,
                        position: index
                    });
                    buffer.push(input.substr(index, token.length));
                    index += token.length;
                    currentState = $b312622af426b5b5$var$processState.BUFFER;
                    continue;
                }
            case $b312622af426b5b5$var$processState.LINK:
                {
                    /**
				 * We should "fly over" the link format and we dont want
				 * -awesome [link|https://www.atlass-ian.com] nice
				 * to be a strike through because of the '-' in link
				 */ const token = (0, $lccs8.linkFormat)({
                        input: input,
                        schema: schema,
                        context: context,
                        position: index
                    });
                    if (token.type === 'text') {
                        buffer.push(token.text);
                        index += token.length;
                        currentState = $b312622af426b5b5$var$processState.BUFFER;
                        continue;
                    } else if (token.type === 'pmnode') {
                        buffer.push(input.substr(index, token.length));
                        index += token.length;
                        currentState = $b312622af426b5b5$var$processState.BUFFER;
                        continue;
                    }
                    break;
                }
            case $b312622af426b5b5$var$processState.MACRO:
                {
                    const match = (0, $2ROXs.parseMacroKeyword)(input.substring(index));
                    if (!match) {
                        buffer.push(char);
                        currentState = $b312622af426b5b5$var$processState.BUFFER;
                        break;
                    }
                    const token = (0, $lS4Zv.parseToken)(input, match.type, index, schema, context);
                    buffer.push(input.substr(index, token.length));
                    index += token.length;
                    currentState = $b312622af426b5b5$var$processState.BUFFER;
                    continue;
                }
        }
        index++;
    }
    /**
	 * If there are left over content which didn't have a closing |
	 * For example
	 * |cell1|cell2|cell3
	 * we still want to create a new cell for the last cell3 if it's
	 * not empty.
	 */ const bufferOutput = buffer.join('');
    if (bufferOutput.trim().length > 0) $b312622af426b5b5$var$bufferToCells(cellStyle, bufferOutput, cellsBuffer, schema, ignoreTokenTypes, context);
    if (builder) {
        if (cellsBuffer.length) builder.add(cellsBuffer);
        output.push(builder.buildPMNode());
    }
    return {
        type: 'pmnode',
        nodes: output,
        length: index - position
    };
};
function $b312622af426b5b5$var$bufferToCells(style, buffer, cellsBuffer, schema, ignoreTokenTypes, context) {
    if (buffer.length) {
        let contentNode = (0, $7pbqq.parseString)({
            schema: schema,
            context: context,
            ignoreTokenTypes: ignoreTokenTypes,
            input: buffer
        });
        if (style === '||') contentNode = contentNode.map((e)=>{
            return $b312622af426b5b5$var$createTableHeader(e, schema);
        });
        cellsBuffer.push({
            style: style,
            content: (0, $gwvPQ.normalizePMNodes)(contentNode, schema)
        });
    }
}
function $b312622af426b5b5$var$createTableHeader(node, schema) {
    const mark = schema.marks.strong.create();
    return $b312622af426b5b5$var$traverseNodeAndAddMarks(node, mark, schema);
}
function $b312622af426b5b5$var$traverseContent(node, mark, schema) {
    if (node.content.childCount === 0 || !node.content.child(0) || !node.content.firstChild || node.type.name === 'codeBlock') return node;
    for(let i = 0; i < node.content.childCount; i++){
        const child = node.content.child(i);
        const markedChild = $b312622af426b5b5$var$traverseNodeAndAddMarks(child, mark, schema);
        const updatedContent = node.content.replaceChild(i, markedChild);
        node = node.copy(updatedContent);
    }
    return node;
}
function $b312622af426b5b5$var$traverseNodeAndAddMarks(node, mark, schema) {
    if (node.type.name === 'text' && !(0, $8loUC.hasAnyOfMarks)(node, [
        'strong',
        'code'
    ])) {
        const newNode = node.mark([
            ...node.marks,
            mark
        ]);
        return newNode;
    }
    return $b312622af426b5b5$var$traverseContent(node, mark, schema);
}

});

parcelRegister("gakJc", function(module, exports) {

$parcel$export(module.exports, "tripleDashSymbol", () => $1f033a2e27e8b3fd$export$edbcd749367de060);

var $60aCS = parcelRequire("60aCS");
const $1f033a2e27e8b3fd$var$token = {
    type: 'text',
    text: '\u2014',
    length: 3
};
const $1f033a2e27e8b3fd$var$fallback = {
    ...$1f033a2e27e8b3fd$var$token,
    text: '---'
};
const $1f033a2e27e8b3fd$export$edbcd749367de060 = (0, $60aCS.createDashTokenParser)($1f033a2e27e8b3fd$var$token, $1f033a2e27e8b3fd$var$fallback);

});

parcelRegister("j2mJE", function(module, exports) {

$parcel$export(module.exports, "panelMacro", () => $961956c03c5700d1$export$5d7bf7e31a674541);

var $048B7 = parcelRequire("048B7");

var $7pbqq = parcelRequire("7pbqq");

var $dFOSZ = parcelRequire("dFOSZ");

var $gwvPQ = parcelRequire("gwvPQ");

var $kKwIJ = parcelRequire("kKwIJ");

var $412VX = parcelRequire("412VX");
const $961956c03c5700d1$var$allowedNodeType = [
    'paragraph',
    'heading',
    'orderedList',
    'bulletList'
];
const $961956c03c5700d1$export$5d7bf7e31a674541 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $048B7.commonMacro)(input.substring(position), schema, {
        keyword: 'panel',
        paired: true,
        context: context,
        rawContentProcessor: $961956c03c5700d1$var$rawContentProcessor
    });
};
const $961956c03c5700d1$var$rawContentProcessor = (rawAttrs, rawContent, length, schema, context)=>{
    const output = [];
    const parsedAttrs = (0, $dFOSZ.parseAttrs)(rawAttrs);
    const nodeAttrs = {
        ...parsedAttrs,
        panelType: (0, $kKwIJ.getPanelType)(parsedAttrs)
    };
    const parsedContent = (0, $7pbqq.parseString)({
        schema: schema,
        context: context,
        ignoreTokenTypes: [],
        input: rawContent
    });
    const normalizedContent = (0, $gwvPQ.normalizePMNodes)(parsedContent, schema);
    let contentBuffer = parsedAttrs.title ? [
        (0, $412VX.title)(parsedAttrs.title, schema)
    ] : [];
    for (const n of normalizedContent)if ($961956c03c5700d1$var$allowedNodeType.indexOf(n.type.name) !== -1) contentBuffer.push(n);
    else {
        const panelNode = schema.nodes.panel.createChecked(nodeAttrs, contentBuffer.length ? contentBuffer : schema.nodes.paragraph.createChecked());
        contentBuffer = [];
        output.push(panelNode);
        output.push(n);
    }
    if (contentBuffer.length > 0) {
        const panelNode = schema.nodes.panel.createChecked(nodeAttrs, contentBuffer);
        output.push(panelNode);
    }
    return {
        type: 'pmnode',
        nodes: output.length ? output : [
            $961956c03c5700d1$var$emptyPanel(schema)
        ],
        length: length
    };
};
function $961956c03c5700d1$var$emptyPanel(schema) {
    const p = schema.nodes.paragraph.createChecked();
    return schema.nodes.panel.createChecked({}, p);
}

});
parcelRegister("kKwIJ", function(module, exports) {

$parcel$export(module.exports, "getPanelType", () => $b1b231f17e51a80e$export$fa00fa3d6c22a747);

var $27YwJ = parcelRequire("27YwJ");
const $b1b231f17e51a80e$var$COLOR_TYPE_REGEX = {
    hexShort: /^#?([a-f\d])([a-f\d])([a-f\d])$/i,
    hexLong: /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i,
    rgb: /^#?rgb\((\d+),\s*(\d+),\s*(\d+)\)$/,
    prgb: /^#?rgb\((\d+)%,\s*(\d+)%,\s*(\d+)%\)$/
};
const $b1b231f17e51a80e$var$PANEL_TYPE_TO_RGB = {
    info: {
        r: 222,
        g: 235,
        b: 255
    },
    note: {
        r: 234,
        g: 230,
        b: 255
    },
    success: {
        r: 227,
        g: 252,
        b: 239
    },
    warning: {
        r: 255,
        g: 250,
        b: 230
    },
    error: {
        r: 255,
        g: 235,
        b: 230
    }
};
function $b1b231f17e51a80e$export$fa00fa3d6c22a747(attrs) {
    const rgb = $b1b231f17e51a80e$var$generateRgb(attrs.bgColor);
    if (!rgb) return 'info';
    let mapTo = 'info';
    let smallestDistance = Infinity;
    Object.keys($b1b231f17e51a80e$var$PANEL_TYPE_TO_RGB).forEach((panelType)=>{
        const distance = $b1b231f17e51a80e$var$distanceOfRgb($b1b231f17e51a80e$var$PANEL_TYPE_TO_RGB[panelType], rgb);
        if (distance < smallestDistance) {
            smallestDistance = distance;
            mapTo = panelType;
        }
    });
    return mapTo;
}
function $b1b231f17e51a80e$var$distanceOfRgb(a, b) {
    // https://en.wikipedia.org/wiki/Color_difference
    return Math.pow(a.r - b.r, 2) + Math.pow(a.g - b.g, 2) + Math.pow(a.b - b.b, 2);
}
function $b1b231f17e51a80e$var$generateRgb(color) {
    switch(true){
        case $b1b231f17e51a80e$var$COLOR_TYPE_REGEX.hexShort.test(color) || $b1b231f17e51a80e$var$COLOR_TYPE_REGEX.hexLong.test(color):
            return $b1b231f17e51a80e$var$parseHex(color);
        case $b1b231f17e51a80e$var$COLOR_TYPE_REGEX.rgb.test(color):
            return $b1b231f17e51a80e$var$parseRgb(color);
        case $b1b231f17e51a80e$var$COLOR_TYPE_REGEX.prgb.test(color):
            return $b1b231f17e51a80e$var$parsePrgb(color);
        default:
            return $b1b231f17e51a80e$var$parseColorName(color);
    }
}
function $b1b231f17e51a80e$var$parseHex(hex) {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    hex = hex.replace($b1b231f17e51a80e$var$COLOR_TYPE_REGEX.hexShort, (_m, r, g, b)=>{
        return r + r + g + g + b + b;
    });
    const result = $b1b231f17e51a80e$var$COLOR_TYPE_REGEX.hexLong.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
}
function $b1b231f17e51a80e$var$parseRgb(rgb) {
    const result = rgb.match($b1b231f17e51a80e$var$COLOR_TYPE_REGEX.rgb);
    return result ? {
        r: parseInt(result[1], 10),
        g: parseInt(result[2], 10),
        b: parseInt(result[3], 10)
    } : null;
}
function $b1b231f17e51a80e$var$parsePrgb(prgb) {
    const result = prgb.match($b1b231f17e51a80e$var$COLOR_TYPE_REGEX.prgb);
    return result ? {
        r: Math.floor(255 * parseInt(result[1], 10) / 100),
        g: Math.floor(255 * parseInt(result[2], 10) / 100),
        b: Math.floor(255 * parseInt(result[4], 10) / 100)
    } : null;
}
function $b1b231f17e51a80e$var$parseColorName(color) {
    return (0, $27YwJ.default)[color];
}

});
parcelRegister("27YwJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f64a73090b859f18$export$2e2bcd8739ae039);
const $f64a73090b859f18$var$mapping = {
    crimson: {
        r: 220,
        g: 20,
        b: 60
    },
    lightpink: {
        r: 255,
        g: 182,
        b: 193
    },
    pink: {
        r: 255,
        g: 192,
        b: 203
    },
    palevioletred: {
        r: 219,
        g: 112,
        b: 147
    },
    lavenderblush: {
        r: 255,
        g: 240,
        b: 245
    },
    hotpink: {
        r: 255,
        g: 105,
        b: 180
    },
    deeppink: {
        r: 255,
        g: 20,
        b: 147
    },
    mediumvioletred: {
        r: 199,
        g: 21,
        b: 133
    },
    orchid: {
        r: 218,
        g: 112,
        b: 214
    },
    thistle: {
        r: 216,
        g: 191,
        b: 216
    },
    plum: {
        r: 221,
        g: 160,
        b: 221
    },
    violet: {
        r: 238,
        g: 130,
        b: 238
    },
    fuchsia: {
        r: 255,
        g: 0,
        b: 255
    },
    darkmagenta: {
        r: 139,
        g: 0,
        b: 139
    },
    purple: {
        r: 128,
        g: 0,
        b: 128
    },
    mediumorchid: {
        r: 186,
        g: 85,
        b: 211
    },
    darkviolet: {
        r: 148,
        g: 0,
        b: 211
    },
    darkorchid: {
        r: 153,
        g: 50,
        b: 204
    },
    indigo: {
        r: 75,
        g: 0,
        b: 130
    },
    blueviolet: {
        r: 138,
        g: 43,
        b: 226
    },
    mediumpurple: {
        r: 147,
        g: 112,
        b: 219
    },
    darkslateblue: {
        r: 72,
        g: 61,
        b: 139
    },
    mediumslateblue: {
        r: 123,
        g: 104,
        b: 238
    },
    slateblue: {
        r: 106,
        g: 90,
        b: 205
    },
    ghostwhite: {
        r: 248,
        g: 248,
        b: 255
    },
    lavender: {
        r: 230,
        g: 230,
        b: 250
    },
    blue: {
        r: 0,
        g: 0,
        b: 255
    },
    mediumblue: {
        r: 0,
        g: 0,
        b: 205
    },
    darkblue: {
        r: 0,
        g: 0,
        b: 139
    },
    navy: {
        r: 0,
        g: 0,
        b: 128
    },
    midnightblue: {
        r: 25,
        g: 25,
        b: 112
    },
    royalblue: {
        r: 65,
        g: 105,
        b: 225
    },
    cornflowerblue: {
        r: 100,
        g: 149,
        b: 237
    },
    lightsteelblue: {
        r: 176,
        g: 196,
        b: 222
    },
    lightslategray: {
        r: 119,
        g: 136,
        b: 153
    },
    slategray: {
        r: 112,
        g: 128,
        b: 144
    },
    dodgerblue: {
        r: 30,
        g: 144,
        b: 255
    },
    aliceblue: {
        r: 240,
        g: 248,
        b: 255
    },
    steelblue: {
        r: 70,
        g: 130,
        b: 180
    },
    lightskyblue: {
        r: 135,
        g: 206,
        b: 250
    },
    skyblue: {
        r: 135,
        g: 206,
        b: 235
    },
    deepskyblue: {
        r: 0,
        g: 191,
        b: 255
    },
    lightblue: {
        r: 173,
        g: 216,
        b: 230
    },
    powderblue: {
        r: 176,
        g: 224,
        b: 230
    },
    cadetblue: {
        r: 95,
        g: 158,
        b: 160
    },
    darkturquoise: {
        r: 0,
        g: 206,
        b: 209
    },
    azure: {
        r: 240,
        g: 255,
        b: 255
    },
    lightcyan: {
        r: 224,
        g: 255,
        b: 255
    },
    paleturquoise: {
        r: 174,
        g: 238,
        b: 238
    },
    darkslategray: {
        r: 47,
        g: 79,
        b: 79
    },
    aqua: {
        r: 0,
        g: 255,
        b: 255
    },
    darkcyan: {
        r: 0,
        g: 139,
        b: 139
    },
    teal: {
        r: 0,
        g: 128,
        b: 128
    },
    mediumturquoise: {
        r: 72,
        g: 209,
        b: 204
    },
    lightseagreen: {
        r: 32,
        g: 178,
        b: 170
    },
    turquoise: {
        r: 64,
        g: 224,
        b: 208
    },
    aquamarine: {
        r: 127,
        g: 255,
        b: 212
    },
    mediumaquamarine: {
        r: 102,
        g: 205,
        b: 170
    },
    mediumspringgreen: {
        r: 0,
        g: 250,
        b: 154
    },
    mintcream: {
        r: 245,
        g: 255,
        b: 250
    },
    springgreen: {
        r: 0,
        g: 255,
        b: 127
    },
    mediumseagreen: {
        r: 60,
        g: 179,
        b: 113
    },
    seagreen: {
        r: 46,
        g: 139,
        b: 87
    },
    honeydew: {
        r: 240,
        g: 255,
        b: 240
    },
    darkseagreen: {
        r: 143,
        g: 188,
        b: 143
    },
    palegreen: {
        r: 152,
        g: 251,
        b: 152
    },
    lightgreen: {
        r: 144,
        g: 238,
        b: 144
    },
    limegreen: {
        r: 50,
        g: 205,
        b: 50
    },
    forestgreen: {
        r: 34,
        g: 139,
        b: 34
    },
    lime: {
        r: 0,
        g: 255,
        b: 0
    },
    green: {
        r: 0,
        g: 128,
        b: 0
    },
    darkgreen: {
        r: 0,
        g: 100,
        b: 0
    },
    lawngreen: {
        r: 124,
        g: 252,
        b: 0
    },
    chartreuse: {
        r: 127,
        g: 255,
        b: 0
    },
    greenyellow: {
        r: 173,
        g: 255,
        b: 47
    },
    darkolivegreen: {
        r: 85,
        g: 107,
        b: 47
    },
    olivedrab: {
        r: 107,
        g: 142,
        b: 35
    },
    yellowgreen: {
        r: 154,
        g: 205,
        b: 50
    },
    ivory: {
        r: 255,
        g: 255,
        b: 240
    },
    beige: {
        r: 245,
        g: 245,
        b: 220
    },
    lightyellow: {
        r: 255,
        g: 255,
        b: 224
    },
    lightgoldenrodyellow: {
        r: 250,
        g: 250,
        b: 210
    },
    yellow: {
        r: 255,
        g: 255,
        b: 0
    },
    olive: {
        r: 128,
        g: 128,
        b: 0
    },
    darkkhaki: {
        r: 189,
        g: 183,
        b: 107
    },
    khaki: {
        r: 240,
        g: 230,
        b: 140
    },
    palegoldenrod: {
        r: 238,
        g: 232,
        b: 170
    },
    lemonchiffon: {
        r: 255,
        g: 250,
        b: 205
    },
    gold: {
        r: 255,
        g: 215,
        b: 0
    },
    cornsilk: {
        r: 255,
        g: 248,
        b: 220
    },
    goldenrod: {
        r: 218,
        g: 165,
        b: 32
    },
    darkgoldenrod: {
        r: 184,
        g: 134,
        b: 11
    },
    orange: {
        r: 255,
        g: 128,
        b: 0
    },
    floralwhite: {
        r: 255,
        g: 250,
        b: 240
    },
    oldlace: {
        r: 253,
        g: 245,
        b: 230
    },
    wheat: {
        r: 245,
        g: 222,
        b: 179
    },
    moccasin: {
        r: 255,
        g: 228,
        b: 181
    },
    papayawhip: {
        r: 255,
        g: 239,
        b: 213
    },
    blanchedalmond: {
        r: 255,
        g: 235,
        b: 205
    },
    navajowhite: {
        r: 255,
        g: 222,
        b: 173
    },
    tan: {
        r: 210,
        g: 180,
        b: 140
    },
    antiquewhite: {
        r: 250,
        g: 235,
        b: 215
    },
    burlywood: {
        r: 222,
        g: 184,
        b: 135
    },
    bisque: {
        r: 255,
        g: 228,
        b: 196
    },
    darkorange: {
        r: 255,
        g: 140,
        b: 0
    },
    peru: {
        r: 205,
        g: 133,
        b: 63
    },
    linen: {
        r: 250,
        g: 240,
        b: 230
    },
    peachpuff: {
        r: 255,
        g: 218,
        b: 185
    },
    seashell: {
        r: 255,
        g: 245,
        b: 238
    },
    sandybrown: {
        r: 244,
        g: 164,
        b: 96
    },
    chocolate: {
        r: 210,
        g: 105,
        b: 30
    },
    saddlebrown: {
        r: 139,
        g: 69,
        b: 19
    },
    sienna: {
        r: 160,
        g: 82,
        b: 45
    },
    lightsalmon: {
        r: 255,
        g: 160,
        b: 122
    },
    coral: {
        r: 255,
        g: 127,
        b: 80
    },
    orangered: {
        r: 255,
        g: 69,
        b: 0
    },
    darksalmon: {
        r: 233,
        g: 150,
        b: 122
    },
    tomato: {
        r: 255,
        g: 99,
        b: 71
    },
    salmon: {
        r: 250,
        g: 128,
        b: 114
    },
    mistyrose: {
        r: 255,
        g: 228,
        b: 225
    },
    snow: {
        r: 255,
        g: 250,
        b: 250
    },
    rosybrown: {
        r: 188,
        g: 143,
        b: 143
    },
    lightcoral: {
        r: 240,
        g: 128,
        b: 128
    },
    indianred: {
        r: 205,
        g: 92,
        b: 92
    },
    brown: {
        r: 165,
        g: 42,
        b: 42
    },
    firebrick: {
        r: 178,
        g: 34,
        b: 34
    },
    red: {
        r: 255,
        g: 0,
        b: 0
    },
    darkred: {
        r: 139,
        g: 0,
        b: 0
    },
    maroon: {
        r: 128,
        g: 0,
        b: 0
    },
    white: {
        r: 255,
        g: 255,
        b: 255
    },
    gainsboro: {
        r: 220,
        g: 220,
        b: 220
    },
    lightgray: {
        r: 211,
        g: 211,
        b: 211
    },
    silver: {
        r: 192,
        g: 192,
        b: 192
    },
    darkgray: {
        r: 169,
        g: 169,
        b: 169
    },
    gray: {
        r: 128,
        g: 128,
        b: 128
    },
    dimgray: {
        r: 105,
        g: 105,
        b: 105
    },
    black: {
        r: 0,
        g: 0,
        b: 0
    },
    whitesmoke: {
        r: 245,
        g: 245,
        b: 245
    }
};
var $f64a73090b859f18$export$2e2bcd8739ae039 = $f64a73090b859f18$var$mapping;

});


parcelRegister("412VX", function(module, exports) {

$parcel$export(module.exports, "title", () => $e441a2e7780cbef1$export$fb184b623420d9be);
function $e441a2e7780cbef1$export$fb184b623420d9be(text, schema) {
    const mark = schema.marks.strong.create();
    const title = schema.text(text, [
        mark
    ]);
    return schema.nodes.paragraph.createChecked({}, [
        title
    ]);
}

});


parcelRegister("a5fMg", function(module, exports) {

$parcel$export(module.exports, "adfMacro", () => $c510207391721011$export$8fb4b58db8f664fb);

var $048B7 = parcelRequire("048B7");
const $c510207391721011$export$8fb4b58db8f664fb = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $048B7.commonMacro)(input.substring(position), schema, {
        keyword: 'adf',
        paired: true,
        context: context,
        rawContentProcessor: $c510207391721011$var$rawContentProcessor
    });
};
const $c510207391721011$var$rawContentProcessor = (_rawAttrs, rawContent, length, schema, _context)=>{
    try {
        const json = JSON.parse(rawContent);
        const node = schema.nodeFromJSON(json);
        return {
            type: 'pmnode',
            nodes: [
                node
            ],
            length: length
        };
    } catch (_e) {
        const textContent = `Invalid ADF Macro: ${rawContent}`;
        const textNode = rawContent.length ? schema.text(textContent) : undefined;
        const { codeBlock: codeBlock } = schema.nodes;
        const node = codeBlock.create({
            language: undefined
        }, textNode);
        return {
            type: 'pmnode',
            nodes: [
                node
            ],
            length: length
        };
    }
};

});

parcelRegister("adHlr", function(module, exports) {

$parcel$export(module.exports, "anchorMacro", () => $39e5fab8c86e7c66$export$e660dadc21580fa2);

var $048B7 = parcelRequire("048B7");
const $39e5fab8c86e7c66$export$e660dadc21580fa2 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $048B7.commonMacro)(input.substring(position), schema, {
        keyword: 'anchor',
        paired: false,
        context: context,
        rawContentProcessor: $39e5fab8c86e7c66$var$rawContentProcessor
    });
};
const $39e5fab8c86e7c66$var$rawContentProcessor = (_rawAttrs, _rawContent, length, _schema, _context)=>{
    return {
        type: 'text',
        text: '',
        length: length
    };
};

});

parcelRegister("48Szy", function(module, exports) {

$parcel$export(module.exports, "codeMacro", () => $7821c626d71eb9e8$export$db6c131ac26c7700);

var $048B7 = parcelRequire("048B7");

var $dFOSZ = parcelRequire("dFOSZ");

var $412VX = parcelRequire("412VX");
const $7821c626d71eb9e8$var$SUPPORTED_CODEBOCK_LANGUAGES = [
    'abap',
    'actionscript',
    'ada',
    'arduino',
    'autoit',
    'c',
    'c++',
    'clojure',
    'coffeescript',
    'csharp',
    'css',
    'cuda',
    'd',
    'dart',
    'delphi',
    'elixir',
    'erlang',
    'fortran',
    'foxpro',
    'go',
    'groovy',
    'haskell',
    'haxe',
    'html',
    'java',
    'javascript',
    'json',
    'julia',
    'kotlin',
    'latex',
    'livescript',
    'lua',
    'mathematica',
    'matlab',
    'objective-c',
    'objective-j',
    'objectpascal',
    'ocaml',
    'octave',
    'perl',
    'php',
    'powershell',
    'prolog',
    'puppet',
    'python',
    'qml',
    'r',
    'racket',
    'restructuredtext',
    'ruby',
    'rust',
    'sass',
    'scala',
    'scheme',
    'shell',
    'smalltalk',
    'sql',
    'standardml',
    'swift',
    'tcl',
    'tex',
    'typescript',
    'vala',
    'vbnet',
    'verilog',
    'vhdl',
    'xml',
    'xquery'
];
const $7821c626d71eb9e8$export$db6c131ac26c7700 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $048B7.commonMacro)(input.substring(position), schema, {
        keyword: 'code',
        paired: true,
        context: context,
        rawContentProcessor: $7821c626d71eb9e8$var$rawContentProcessor
    });
};
const $7821c626d71eb9e8$var$rawContentProcessor = (rawAttrs, rawContent, length, schema)=>{
    const output = [];
    const { codeBlock: codeBlock } = schema.nodes;
    const parsedAttrs = (0, $dFOSZ.parseAttrs)(rawAttrs);
    const trimedContent = rawContent.replace(/^\s+|\s+$/g, '');
    const textNode = trimedContent.length ? schema.text(trimedContent) : undefined;
    if (parsedAttrs.title) output.push((0, $412VX.title)(parsedAttrs.title, schema));
    const nodeAttrs = {
        ...parsedAttrs,
        language: $7821c626d71eb9e8$var$getCodeLanguage(parsedAttrs)
    };
    output.push(codeBlock.createChecked(nodeAttrs, textNode));
    return {
        type: 'pmnode',
        nodes: output,
        length: length
    };
};
function $7821c626d71eb9e8$var$getCodeLanguage(attrs) {
    const keys = Object.keys(attrs).map((key)=>key.toLowerCase());
    for (const language of $7821c626d71eb9e8$var$SUPPORTED_CODEBOCK_LANGUAGES){
        if (keys.indexOf(language) !== -1) return language;
    }
    if (keys.indexOf('objc') !== -1) return 'objective-c';
    return 'java';
}

});

parcelRegister("cvl2z", function(module, exports) {

$parcel$export(module.exports, "colorMacro", () => $77c4a311a6bce9f0$export$b557be495948d995);

var $lS4Zv = parcelRequire("lS4Zv");

var $048B7 = parcelRequire("048B7");

var $dFOSZ = parcelRequire("dFOSZ");

var $7pbqq = parcelRequire("7pbqq");

var $ec41U = parcelRequire("ec41U");

var $8loUC = parcelRequire("8loUC");
const $77c4a311a6bce9f0$export$b557be495948d995 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $048B7.commonMacro)(input.substring(position), schema, {
        keyword: 'color',
        paired: true,
        context: context,
        rawContentProcessor: $77c4a311a6bce9f0$var$rawContentProcessor
    });
};
const $77c4a311a6bce9f0$var$rawContentProcessor = (rawAttrs, rawContent, length, schema, context)=>{
    // Removed ISSUE_KEY for https://getsupport.atlassian.com/browse/MOVE-1738018
    // Issue keys were not being migrated correctly if they were inside the color macro.
    const ignoreTokenTypes = [
        (0, $lS4Zv.TokenType).DOUBLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TRIPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).QUADRUPLE_DASH_SYMBOL,
        (0, $lS4Zv.TokenType).TABLE
    ];
    const parsedAttrs = (0, $dFOSZ.parseAttrs)(rawAttrs);
    const content = (0, $7pbqq.parseString)({
        ignoreTokenTypes: ignoreTokenTypes,
        schema: schema,
        context: context,
        input: rawContent
    });
    const decoratedContent = content.map((n)=>{
        const mark = schema.marks.textColor.create({
            color: (0, $ec41U.getEditorColor)(parsedAttrs) || '#000000'
        });
        // We don't want to mix `code` mark with others
        if (n.type.name === 'text' && !(0, $8loUC.hasAnyOfMarks)(n, [
            'textColor',
            'code'
        ])) return n.mark([
            ...n.marks,
            mark
        ]);
        return n;
    });
    return {
        type: 'pmnode',
        nodes: decoratedContent,
        length: length
    };
};

});
parcelRegister("ec41U", function(module, exports) {

$parcel$export(module.exports, "getEditorColor", () => $aca1c3aa774ca185$export$c0cfc6f23e0b7578);

var $jR93G = parcelRequire("jR93G");
function $aca1c3aa774ca185$export$c0cfc6f23e0b7578(attrs) {
    const keys = Object.keys(attrs);
    return (0, $jR93G.normalizeHexColor)(keys[0]);
}

});


parcelRegister("5PrNl", function(module, exports) {

$parcel$export(module.exports, "noformatMacro", () => $7891074759cd4bc4$export$9199752eb9b2d5b4);

var $048B7 = parcelRequire("048B7");

var $dFOSZ = parcelRequire("dFOSZ");

var $412VX = parcelRequire("412VX");
const $7891074759cd4bc4$export$9199752eb9b2d5b4 = ({ input: input, position: position, schema: schema, context: context })=>{
    return (0, $048B7.commonMacro)(input.substring(position), schema, {
        keyword: 'noformat',
        paired: true,
        context: context,
        rawContentProcessor: $7891074759cd4bc4$var$rawContentProcessor
    });
};
const $7891074759cd4bc4$var$rawContentProcessor = (rawAttrs, rawContent, length, schema, _context)=>{
    const output = [];
    const { codeBlock: codeBlock } = schema.nodes;
    const parsedAttrs = (0, $dFOSZ.parseAttrs)(rawAttrs);
    const trimedContent = rawContent.replace(/^\s+|\s+$/g, '');
    const textNode = trimedContent.length ? schema.text(trimedContent) : undefined;
    if (parsedAttrs.title) output.push((0, $412VX.title)(parsedAttrs.title, schema));
    output.push(codeBlock.createChecked({}, textNode));
    return {
        type: 'pmnode',
        nodes: output,
        length: length
    };
};

});

parcelRegister("eTIGc", function(module, exports) {

$parcel$export(module.exports, "forceLineBreak", () => $c28d407e42eefac6$export$2de3d7fd25cbc36);
/**
 * Jira is using the following regex to match force line break
 * private static final Pattern FORCE_NEWLINE = Pattern.compile("(?<!\\\\)\\\\{2}(?!\\S*\\\\)");
 */ const $c28d407e42eefac6$var$FORCE_LINE_BREAK_REGEX = /^\\{2}(?!\S*\\)/;
const $c28d407e42eefac6$export$2de3d7fd25cbc36 = ({ input: input, position: position, schema: schema })=>{
    if (position > 0) {
        const charBefore = input.charAt(position - 1);
        if (charBefore === '\\') return $c28d407e42eefac6$var$fallback(input, position);
    }
    const match = input.substring(position).match($c28d407e42eefac6$var$FORCE_LINE_BREAK_REGEX);
    if (match) return {
        type: 'pmnode',
        nodes: [
            schema.nodes.hardBreak.createChecked()
        ],
        length: 2
    };
    return $c28d407e42eefac6$var$fallback(input, position);
};
function $c28d407e42eefac6$var$fallback(input, position) {
    return {
        type: 'text',
        text: input.substr(position, 2),
        length: 2
    };
}

});



parcelRegister("hf3v9", function(module, exports) {

$parcel$export(module.exports, "code", () => $9baabbb4403cf9b3$export$6565f9f03506010b);
const $9baabbb4403cf9b3$export$6565f9f03506010b = (text)=>{
    return `{{${text}}}`;
};

});

parcelRegister("sS3Yw", function(module, exports) {

$parcel$export(module.exports, "textColor", () => $703c8726b73164da$export$32f78bffcd82ff28);
const $703c8726b73164da$export$32f78bffcd82ff28 = (text, attrs)=>{
    return `{color:${attrs.color}}${text}{color}`;
};

});

parcelRegister("lWqfN", function(module, exports) {

$parcel$export(module.exports, "em", () => $b90022f08ab17d9b$export$c63c6f932822f543);

var $18hih = parcelRequire("18hih");
const $b90022f08ab17d9b$export$c63c6f932822f543 = (text)=>{
    if (text.startsWith("\u2014 ")) // This is a citation
    return (0, $18hih.baseMarkPattern)(text.substring(2), '??');
    return (0, $18hih.baseMarkPattern)(text, '_');
};

});
parcelRegister("18hih", function(module, exports) {

$parcel$export(module.exports, "baseMarkPattern", () => $6f34e11c7c351cb8$export$3d8aed7830783c75);
/**
 * For text that has leading and ending space. We don't want to
 * convert it to `* strong *. Instead, we need it to be ` *strong* `
 */ const $6f34e11c7c351cb8$export$3d8aed7830783c75 = (text, token)=>{
    if (/^\s*$/.test(text)) /**
		 * If it's a string with only whitespaces, wiki renderer
		 * will behave incorrect if we apply format on it
		 */ return text;
    return text.replace(/^\s*/, `$&${token}`).replace(/\s*$/, `${token}$&`);
};

});


parcelRegister("9hhDh", function(module, exports) {

$parcel$export(module.exports, "link", () => $caa71b2d0d7ede16$export$9c30223ca0a664fb);
const $caa71b2d0d7ede16$export$9c30223ca0a664fb = (text, attrs)=>{
    return `[${text}|${attrs.href}]`;
};

});

parcelRegister("aiUyl", function(module, exports) {

$parcel$export(module.exports, "strike", () => $b1d2f97e8fc0de3c$export$4899a95d70ec5056);

var $18hih = parcelRequire("18hih");
const $b1d2f97e8fc0de3c$export$4899a95d70ec5056 = (text)=>{
    return (0, $18hih.baseMarkPattern)(text, '-');
};

});

parcelRegister("4fuiB", function(module, exports) {

$parcel$export(module.exports, "strong", () => $148ec1c7d5e290d3$export$59ae2c325a998f89);

var $18hih = parcelRequire("18hih");
const $148ec1c7d5e290d3$export$59ae2c325a998f89 = (text)=>{
    return (0, $18hih.baseMarkPattern)(text, '*');
};

});

parcelRegister("gUCSO", function(module, exports) {

$parcel$export(module.exports, "subsup", () => $a74358391b0936e0$export$b3401ee80eb31041);

var $18hih = parcelRequire("18hih");
const $a74358391b0936e0$export$b3401ee80eb31041 = (text, attrs)=>{
    if (attrs.type === 'sub') return (0, $18hih.baseMarkPattern)(text, '~');
    else return (0, $18hih.baseMarkPattern)(text, '^');
};

});

parcelRegister("ijIl1", function(module, exports) {

$parcel$export(module.exports, "underline", () => $511118f4e5c0322a$export$425327af25286e5e);

var $18hih = parcelRequire("18hih");
const $511118f4e5c0322a$export$425327af25286e5e = (text)=>{
    return (0, $18hih.baseMarkPattern)(text, '+');
};

});


parcelRegister("JPiHV", function(module, exports) {

$parcel$export(module.exports, "inlineCard", () => $417cf7f4aeef481a$export$cbf8224b64e0d942);

var $dMxC6 = parcelRequire("dMxC6");

var $4RTci = parcelRequire("4RTci");
const $417cf7f4aeef481a$export$cbf8224b64e0d942 = (node)=>{
    if (!node.attrs.url) return (0, $dMxC6.unknown)(node);
    const match = node.attrs.url.match((0, $4RTci.INLINE_CARD_FROM_TEXT_STAMP));
    if (!match) return `[${node.attrs.url}|${node.attrs.url}|smart-link]`;
    return `[${match[2]}]`;
};

});

parcelRegister("2wGmw", function(module, exports) {

$parcel$export(module.exports, "status", () => $1c7cf9d16d32feb0$export$471f7ae5c4103ae1);

var $sS3Yw = parcelRequire("sS3Yw");

var $PdmhA = parcelRequire("PdmhA");
const $1c7cf9d16d32feb0$var$color = {
    grey: (0, $PdmhA.N80),
    purple: (0, $PdmhA.P300),
    blue: (0, $PdmhA.T300),
    red: (0, $PdmhA.R300),
    yellow: (0, $PdmhA.Y400),
    green: (0, $PdmhA.G300)
};
const $1c7cf9d16d32feb0$export$471f7ae5c4103ae1 = (node)=>{
    const text = `*[ ${node.attrs.text.toUpperCase()} ]*`;
    const newAttrs = {
        ...node.attrs
    };
    if ($1c7cf9d16d32feb0$var$color[node.attrs.color]) newAttrs.color = $1c7cf9d16d32feb0$var$color[node.attrs.color];
    else newAttrs.color = $1c7cf9d16d32feb0$var$color['grey'];
    return (0, $sS3Yw.textColor)(text, newAttrs);
};

});

parcelRegister("fUy1V", function(module, exports) {

$parcel$export(module.exports, "date", () => $0a10eda5fc7a0cbb$export$324d90190a8b822a);
const $0a10eda5fc7a0cbb$export$324d90190a8b822a = (node)=>{
    const addLeadingZero = (val)=>{
        if (val < 10) return `0${val}`;
        return val;
    };
    const result = new Date(Number(node.attrs.timestamp));
    return `{{${result.getUTCFullYear()}-${addLeadingZero(result.getUTCMonth() + 1)}-${addLeadingZero(result.getUTCDate())}}}`;
};

});



parcelRegister("433DX", function(module, exports) {

$parcel$export(module.exports, "codeBlock", () => $8a22b8049b1154b8$export$7bb0d5c671655cc4);

var $8wJH0 = parcelRequire("8wJH0");
const $8a22b8049b1154b8$var$supportedLanguageInWiki = [
    'actionscript',
    'ada',
    'applescript',
    'bash',
    'c',
    'c#',
    'c++',
    'cpp',
    'css',
    'erlang',
    'go',
    'groovy',
    'haskell',
    'html',
    'java',
    'javascript',
    'js',
    'json',
    'lua',
    'none',
    'nyan',
    'objc',
    'perl',
    'php',
    'python',
    'r',
    'rainbow',
    'ruby',
    'scala',
    'sh',
    'sql',
    'swift',
    'visualbasic',
    'xml',
    'yaml'
];
const $8a22b8049b1154b8$export$7bb0d5c671655cc4 = (node)=>{
    let result = '';
    node.forEach((n)=>{
        result += (0, $8wJH0.inlines)(n, {
            parent: node
        });
    });
    if ($8a22b8049b1154b8$var$supportedLanguageInWiki.indexOf(node.attrs.language) !== -1) return `{code:${node.attrs.language}}${result}{code}`;
    else return `{noformat}${result}{noformat}`;
};

});

parcelRegister("9PdIu", function(module, exports) {

$parcel$export(module.exports, "mediaGroup", () => $62f539123b9da75d$export$2855e964765eac9);

var $5DckW = parcelRequire("5DckW");

var $2ZBc5 = parcelRequire("2ZBc5");

var $dMxC6 = parcelRequire("dMxC6");
const $62f539123b9da75d$export$2855e964765eac9 = (node, opts = {})=>{
    const result = [];
    node.forEach((n)=>{
        switch(n.type.name){
            case 'media':
                result.push((0, $2ZBc5.media)(n, {
                    ...opts,
                    parent: node
                }));
                break;
            case 'caption':
                result.push((0, $5DckW.caption)(n, opts));
                break;
            default:
                result.push((0, $dMxC6.unknown)(n));
                break;
        }
    });
    return result.join('\n');
};

});
parcelRegister("5DckW", function(module, exports) {

$parcel$export(module.exports, "caption", () => $9564736f04490086$export$8e3c2dfdc4f0453d);

var $8wJH0 = parcelRequire("8wJH0");
const $9564736f04490086$export$8e3c2dfdc4f0453d = (node, { context: context } = {})=>{
    let result = '';
    node.forEach((n)=>{
        result += (0, $8wJH0.inlines)(n, {
            context: context
        });
    });
    return result;
};

});

parcelRegister("2ZBc5", function(module, exports) {

$parcel$export(module.exports, "media", () => $cee34f1880720e99$export$987d49ffe1b0900f);
const $cee34f1880720e99$export$987d49ffe1b0900f = (node, { context: context, parent: parent } = {})=>{
    let wikiAttrs = [];
    // Parent width takes precedence over internal dimension attributes
    if (parent && parent.attrs.width) // Parent width is defined in percents
    wikiAttrs.push(`width=${parent.attrs.width}%`);
    else {
        if (node.attrs.width) wikiAttrs.push(`width=${node.attrs.width}`);
        if (node.attrs.height) wikiAttrs.push(`height=${node.attrs.height}`);
    }
    if (node.attrs.alt) wikiAttrs.push(`alt="${node.attrs.alt}"`);
    if (node.marks.length) {
        const linkMark = node.marks.find((mark)=>mark.type.name === 'link');
        if (linkMark) wikiAttrs.push(`href="${linkMark?.attrs.href}"`);
    }
    let fileName;
    if (node.attrs.type === 'external') fileName = node.attrs.url;
    else fileName = context?.conversion?.mediaConversion?.[node.attrs.id]?.transform ?? node.attrs.id;
    if (context?.conversion?.mediaConversion?.[node.attrs.id]?.embed === false) return `[^${fileName}]`;
    if (wikiAttrs.length) return `!${fileName}|${wikiAttrs.join(',')}!`;
    // default to thumbnail if no width or height is set
    return `!${fileName}|thumbnail!`;
};

});




parcelRegister("7Risu", function(module, exports) {

$parcel$export(module.exports, "taskList", () => $bee162bb2f32e9b9$export$375b6afcc5f4d291);

var $g3wEU = parcelRequire("g3wEU");
const $bee162bb2f32e9b9$var$nestedNode = (node, depth = 1)=>{
    const result = [];
    node.forEach((item)=>{
        if (item.type.name === 'taskList') result.push($bee162bb2f32e9b9$var$nestedNode(item, depth + 1));
        else result.push((0, $g3wEU.taskItem)(item, depth));
    });
    return result.join('\n');
};
const $bee162bb2f32e9b9$export$375b6afcc5f4d291 = (node)=>{
    return $bee162bb2f32e9b9$var$nestedNode(node);
};

});
parcelRegister("g3wEU", function(module, exports) {

$parcel$export(module.exports, "taskItem", () => $418cc1c50037a34d$export$6d8b0ef52e2e6390);

var $8wJH0 = parcelRequire("8wJH0");
const $418cc1c50037a34d$export$6d8b0ef52e2e6390 = (node, nestedLevel, { context: context } = {})=>{
    let result = '';
    node.forEach((n)=>{
        // Generate stars based on depth
        const prefix = Array(nestedLevel).fill('*').join('');
        if (node.attrs.state === 'DONE') result += `${prefix} -${(0, $8wJH0.inlines)(n, {
            context: context
        })}-`;
        else result += `${prefix} ${(0, $8wJH0.inlines)(n, {
            context: context
        })}`;
    });
    return result;
};

});


parcelRegister("9q3yb", function(module, exports) {

$parcel$export(module.exports, "decisionList", () => $72cb26933398a6aa$export$62d45a65fb43d95e);

var $03Ql6 = parcelRequire("03Ql6");
const $72cb26933398a6aa$export$62d45a65fb43d95e = (node)=>{
    const result = [];
    node.forEach((item)=>{
        result.push((0, $03Ql6.decisionItem)(item));
    });
    return result.join('\n');
};

});
parcelRegister("03Ql6", function(module, exports) {

$parcel$export(module.exports, "decisionItem", () => $792c9a137da0305d$export$6959e16eeff859b4);

var $8wJH0 = parcelRequire("8wJH0");
const $792c9a137da0305d$export$6959e16eeff859b4 = (node, { context: context } = {})=>{
    let result = '';
    node.forEach((n)=>{
        result += `* <> ${(0, $8wJH0.inlines)(n, {
            context: context
        })}`;
    });
    return result;
};

});


parcelRegister("lPxCD", function(module, exports) {

$parcel$export(module.exports, "doc", () => $80964a588d75e5e9$export$2a111da947c407d2);

var $jX0ky = parcelRequire("jX0ky");
const $80964a588d75e5e9$export$2a111da947c407d2 = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $jX0ky.encode)(n, context));
    });
    return result.join('\n\n');
};

});

parcelRegister("7rqfg", function(module, exports) {

$parcel$export(module.exports, "expand", () => $62f01b5dc84c3d9c$export$9f77e0932fb78f72);

var $jX0ky = parcelRequire("jX0ky");
const $62f01b5dc84c3d9c$export$9f77e0932fb78f72 = (node, { context: context } = {})=>{
    // Title of expand appears as a bold text, followed by empty line
    const result = [
        `*${node.attrs.title}*`,
        ''
    ];
    node.forEach((n)=>{
        result.push((0, $jX0ky.encode)(n, context));
    });
    return result.join('\n');
};

});

parcelRegister("haHCt", function(module, exports) {

$parcel$export(module.exports, "heading", () => $ebdd7f4ed2c4374f$export$46e4a324ac90507f);

var $8wJH0 = parcelRequire("8wJH0");
const $ebdd7f4ed2c4374f$export$46e4a324ac90507f = (node)=>{
    let result = '';
    node.forEach((n)=>{
        result += (0, $8wJH0.inlines)(n);
    });
    return `h${node.attrs.level}. ${result}`;
};

});

parcelRegister("kbkiv", function(module, exports) {

$parcel$export(module.exports, "orderedList", () => $a59abe140fc939d5$export$a5dc81035676e7a);

var $aTpvz = parcelRequire("aTpvz");
const $a59abe140fc939d5$export$a5dc81035676e7a = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((item)=>{
        result.push((0, $aTpvz.listItem)(item, '#', context));
    });
    return result.join('\n');
};

});

parcelRegister("gKQAY", function(module, exports) {

$parcel$export(module.exports, "panel", () => $b1c9c1af1887f5f5$export$21f42ab9b6679f44);

var $jX0ky = parcelRequire("jX0ky");
const $b1c9c1af1887f5f5$var$panelTypeColorMapping = {
    info: '#deebff',
    note: '#eae6ff',
    success: '#e3fcef',
    warning: '#fffae6',
    error: '#ffebe6'
};
const $b1c9c1af1887f5f5$export$21f42ab9b6679f44 = (node, { context: context } = {})=>{
    const result = [];
    node.forEach((n)=>{
        result.push((0, $jX0ky.encode)(n, context));
    });
    return `{panel:bgColor=${$b1c9c1af1887f5f5$var$panelTypeColorMapping[node.attrs.panelType] || ''}}
${result.join('\n\n')}
{panel}`;
};

});

parcelRegister("ikdnB", function(module, exports) {

$parcel$export(module.exports, "rule", () => $d750c553cfb9bc2b$export$fbeb3a3956e8a3c7);
const $d750c553cfb9bc2b$export$fbeb3a3956e8a3c7 = (_node)=>{
    return '----';
};

});

parcelRegister("lHJNe", function(module, exports) {

$parcel$export(module.exports, "table", () => $64091866b6f4487e$export$9852986a3ec5f6a0);

var $jX0ky = parcelRequire("jX0ky");

var $dMxC6 = parcelRequire("dMxC6");
const $64091866b6f4487e$export$9852986a3ec5f6a0 = (node, opts = {})=>{
    try {
        const result = [];
        node.forEach((n)=>{
            result.push($64091866b6f4487e$var$tableRow(n, opts));
        });
        return result.join('\n');
    } catch (err) {
        return (0, $dMxC6.unknown)(node);
    }
};
const $64091866b6f4487e$var$tableRow = (node, opts = {})=>{
    let result = '';
    let separator = '|';
    node.forEach((n)=>{
        if (n.type.name === 'tableHeader') separator = '||';
        else separator = '|';
        result = `${result}${separator}${$64091866b6f4487e$var$tableCell(n, opts)}`;
    });
    return `${result}${separator}`;
};
const $64091866b6f4487e$var$tableCell = (node, { context: context } = {})=>{
    if ($64091866b6f4487e$var$hasMergedCell(node)) // This is an advanced table
    throw new Error('Advanced feature of table is not supported');
    const result = [];
    node.forEach((n)=>{
        result.push((0, $jX0ky.encode)(n, context));
    });
    const output = result.join('\n').trim();
    // Return single whitespace if content of cell is empty
    // to preserve correct empty cell rendering in wiki
    return output === '' ? ' ' : output;
};
const $64091866b6f4487e$var$hasMergedCell = (node)=>{
    if (!node.attrs) return false;
    if (node.attrs.colspan && node.attrs.colspan !== 1) return true;
    if (node.attrs.rowspan && node.attrs.rowspan !== 1) return true;
    return false;
};

});

parcelRegister("fSqxZ", function(module, exports) {

$parcel$export(module.exports, "blockCard", () => $1983797da7981884$export$c4c2f833baaebdb8);

var $dMxC6 = parcelRequire("dMxC6");
const $1983797da7981884$export$c4c2f833baaebdb8 = (node)=>{
    if (!node.attrs.url) return (0, $dMxC6.unknown)(node);
    return `[${node.attrs.url}|${node.attrs.url}|smart-card]`;
};

});

parcelRegister("kYj1v", function(module, exports) {

$parcel$export(module.exports, "embedCard", () => $646070e6044030b7$export$be4283d9a1cb1ff6);

var $dMxC6 = parcelRequire("dMxC6");
const $646070e6044030b7$export$be4283d9a1cb1ff6 = (node)=>{
    if (!node.attrs.url) return (0, $dMxC6.unknown)(node);
    return `[${node.attrs.url}|${node.attrs.url}|smart-embed]`;
};

});


parcelRegister("ZkOGW", function(module, exports) {

$parcel$export(module.exports, "default", () => $e558f06e75d1d84e$export$2e2bcd8739ae039);

var $7pbqq = parcelRequire("7pbqq");

var $gwvPQ = parcelRequire("gwvPQ");
class $e558f06e75d1d84e$export$2e2bcd8739ae039 {
    constructor(schema, wikiMarkup){
        this.schema = schema;
        this.wikiMarkup = wikiMarkup;
    }
    /**
	 * Convert reduced macros tree into prosemirror model tree
	 */ getProseMirrorModel(context) {
        const content = (0, $7pbqq.parseString)({
            context: context,
            ignoreTokenTypes: [],
            input: this.wikiMarkup,
            schema: this.schema
        });
        return this.schema.nodes.doc.createChecked({}, (0, $gwvPQ.normalizePMNodes)(content, this.schema, 'doc'));
    }
}

});



parcelRegister("Gmy9H", function(module, exports) {

$parcel$export(module.exports, "LEARN_MORE_MESSAGES", () => $f6226d3efbb0f87c$export$eedb1bf75e1efb26);

var $a5JEv = parcelRequire("a5JEv");
const $f6226d3efbb0f87c$var$LEARN_MORE_TYPES = {
    IssueTypes: '#IssueTypes',
    PriorityLevels: '#PriorityLevels',
    ResolutionTypes: '#ResolutionTypes',
    SecurityLevels: '#SecurityLevels'
};
const $f6226d3efbb0f87c$export$eedb1bf75e1efb26 = {
    [$f6226d3efbb0f87c$var$LEARN_MORE_TYPES.IssueTypes]: (0, $a5JEv.default).fieldHelpIssueTypes,
    [$f6226d3efbb0f87c$var$LEARN_MORE_TYPES.PriorityLevels]: (0, $a5JEv.default).fieldHelpPriorityLevels,
    [$f6226d3efbb0f87c$var$LEARN_MORE_TYPES.ResolutionTypes]: (0, $a5JEv.default).fieldHelpResolutionDefinitions,
    [$f6226d3efbb0f87c$var$LEARN_MORE_TYPES.SecurityLevels]: (0, $a5JEv.default).fieldHelpSecurityLevels
};

});
parcelRegister("a5JEv", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec3b8030c9f17191$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ec3b8030c9f17191$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    requiredErrorMessage: {
        "id": "issue-create-commons.common.field-message.required-error-message",
        "defaultMessage": "{fieldName} is required"
    },
    labelsInvalidErrorMessage: {
        "id": "issue-create-commons.common.field-message.labels-invalid-error-message",
        "defaultMessage": "Labels can't have spaces or be more than {MAX_LABEL_SIZE, plural, one {# character} other {# characters}}."
    },
    stringInvalidErrorMessage: {
        "id": "issue-create-commons.common.field-message.string-invalid-error-message",
        "defaultMessage": "{fieldName} can't exceed {MAX_STRING_SIZE, plural, one {# character} other {# characters}}."
    },
    forgeLabelsInvalidErrorMessage: {
        "id": "issue-create-commons.common.field-message.forge-labels-invalid-error-message",
        "defaultMessage": "Labels can't have more than {MAX_LABEL_SIZE, plural, one {# character} other {# characters}}."
    },
    labelsMaxErrorMessage: {
        "id": "issue-create-commons.common.field-message.labels-max-error-message",
        "defaultMessage": "Can't have more than {MAX_ALLOWED_LABELS, plural, one {# label} other {# labels}}"
    },
    fieldHelpTextLabel: {
        "id": "issue-create-commons.common.field-message.field-help-text-label",
        "defaultMessage": "Learn more"
    },
    fieldHelpIssueTypes: {
        "id": "issue-create-commons.common.field-message.field-help-issue-types",
        "defaultMessage": "Learn about issue types"
    },
    fieldHelpPriorityLevels: {
        "id": "issue-create-commons.common.field-message.field-help-priority-levels",
        "defaultMessage": "Learn about priority levels"
    },
    fieldHelpResolutionDefinitions: {
        "id": "issue-create-commons.common.field-message.field-help-resolution-definitions",
        "defaultMessage": "Resolutions definitions"
    },
    fieldHelpSecurityLevels: {
        "id": "issue-create-commons.common.field-message.field-help-security-levels",
        "defaultMessage": "More on security levels"
    }
});

});



parcelRegister("6duIW", function(module, exports) {

$parcel$export(module.exports, "ForgeField", () => $0fb8aabb46d9e77f$export$34a15d6027142c62);

var $eUqFw = parcelRequire("eUqFw");

var $1boRu = parcelRequire("1boRu");

var $5syGA = parcelRequire("5syGA");

var $elbiT = parcelRequire("elbiT");


var $6vrw7 = parcelRequire("6vrw7");

var $5VJL3 = parcelRequire("5VJL3");

var $icPhQ = parcelRequire("icPhQ");

var $15xm4 = parcelRequire("15xm4");

var $lWg9w = parcelRequire("lWg9w");

var $1ZhS1 = parcelRequire("1ZhS1");
const $0fb8aabb46d9e77f$export$4f0175d9150f8767 = ({ fieldType: fieldType, fieldName: fieldName, fieldId: fieldId, fieldProps: fieldProps, error: error, selectedProject: selectedProject, selectedIssueType: selectedIssueType, extension: extension, renderDefaultComponent: renderDefaultComponent })=>{
    const { onChange: onChange, value: value } = fieldProps;
    const extensionPayload = (0, $eUqFw.useMemo)(()=>{
        if (value === undefined) return {
            fieldValue: null
        };
        return {
            fieldValue: (0, $1ZhS1.transformValueToExtensionData)(value, extension)
        };
    }, [
        extension,
        value
    ]);
    const extensionData = (0, $eUqFw.useMemo)(()=>{
        const defaultExtensionData = {
            fieldId: fieldId,
            fieldType: (0, $5VJL3.isForgeLegacyFieldType)(fieldType) ? (0, $5VJL3.getExtensionIdFromLegacyFieldType)(fieldType) ?? fieldType : fieldType,
            fieldName: fieldName,
            renderContext: 'issue-create'
        };
        if (!selectedProject || !selectedIssueType) return defaultExtensionData;
        const issueTypeId = (0, $6vrw7.toIssueTypeId)(selectedIssueType.type === (0, $8b8bfa076f313cc4$export$92ab80c1dc9baf44) ? selectedIssueType.issueTypeId : selectedIssueType.value);
        return {
            ...defaultExtensionData,
            project: {
                id: (0, $6vrw7.toProjectId)(selectedProject.value),
                key: (0, $6vrw7.toProjectKey)(selectedProject.projectKey),
                type: selectedProject.projectType
            },
            issue: {
                type: selectedIssueType.type === (0, $8b8bfa076f313cc4$export$92ab80c1dc9baf44) && selectedIssueType.issueTypeName || selectedIssueType.label,
                typeId: issueTypeId
            }
        };
    }, [
        selectedProject,
        selectedIssueType,
        fieldId,
        fieldName,
        fieldType
    ]);
    const analyticsAttributes = (0, $eUqFw.useMemo)(()=>({
            renderContext: 'issue-create',
            fieldType: extension?.properties.type,
            module: extension?.type,
            ...extension ? (0, $5syGA.getAnalyticsAttributesFromExtension)(extension) : {}
        }), [
        extension
    ]);
    if (!extension) return null;
    const renderDefaultView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, renderDefaultComponent(fieldProps, error), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeScreenEvent), {
            attributes: {
                ...analyticsAttributes,
                renderMode: 'default'
            }
        }));
    if (!extension.properties.edit) return renderDefaultView();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $15xm4.EditMode), {
        extension: extension,
        extensionData: extensionData,
        extensionPayload: extensionPayload,
        analyticsAttributes: analyticsAttributes,
        onChange: onChange
    });
};
const $0fb8aabb46d9e77f$export$34a15d6027142c62 = (props)=>{
    const { renderFieldMessage: renderFieldMessage, ...rest } = props;
    const { fieldId: fieldId, extension: extension, error: error } = rest;
    const analyticsAttributes = (0, $eUqFw.useMemo)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        ({
            renderContext: 'issue-create',
            ...extension && (0, $5syGA.getAnalyticsAttributesFromExtension)(extension)
        }), [
        extension
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $elbiT.EditAnalyticsWrapper), {
        attributes: analyticsAttributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: "100%",
        paddingBottom: 6
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0fb8aabb46d9e77f$export$4f0175d9150f8767, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lWg9w.ForgeFieldMessage), {
        error: error,
        fieldId: fieldId,
        renderFieldMessage: renderFieldMessage
    })));
};

});
parcelRegister("1boRu", function(module, exports) {

$parcel$export(module.exports, "ForgeScreenEvent", () => $e499aee6653ef75f$export$92d758d83665314b);
$parcel$export(module.exports, "ForgeOperationaFailedEvent", () => $e499aee6653ef75f$export$a238c3c13f29c134);
$parcel$export(module.exports, "ForgeErrorBoundary", () => $e499aee6653ef75f$export$ac7e7464cefab440);
$parcel$export(module.exports, "ForgeAnalyticsWrapper", () => $e499aee6653ef75f$export$ad2a5d9127152fb8);
$parcel$export(module.exports, "withMetrics", () => $e499aee6653ef75f$export$14e56d7f5d3f917c);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $1ybV0 = parcelRequire("1ybV0");

var $2Rqjr = parcelRequire("2Rqjr");

var $2vJHJ = parcelRequire("2vJHJ");

var $9x02J = parcelRequire("9x02J");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $d6f6c = parcelRequire("d6f6c");
var $2qZHF = parcelRequire("2qZHF");

var $hRcYT = parcelRequire("hRcYT");

var $8XU7c = parcelRequire("8XU7c");

var $bBGpO = parcelRequire("bBGpO");

var $9Z5wa = parcelRequire("9Z5wa");

var $5syGA = parcelRequire("5syGA");

var $d6g7g = parcelRequire("d6g7g");
const $e499aee6653ef75f$export$92d758d83665314b = ({ attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        attributes: (0, $bBGpO.createAttributes)(attributes)
    });
const $e499aee6653ef75f$export$a238c3c13f29c134 = ({ eventId: eventId, attributes: attributes })=>{
    (0, $9Z5wa.fireOperationalFailedEvent)({
        eventId: eventId,
        attributes: attributes
    });
    return null;
};
const $e499aee6653ef75f$export$4c46624a93517c10 = ({ eventId: eventId, action: action, attributes: attributes })=>{
    const hasForgeAccess = (0, $9x02J.useHasForgeAccess)();
    const analyticsAttributes = (0, $bBGpO.createAttributes)({
        ...attributes,
        hasForgeAccess: hasForgeAccess
    });
    const fireEvent = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, (0, $8XU7c.getEventActionName)(eventId, action), analyticsAttributes);
    }, [
        eventId,
        action,
        analyticsAttributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
        onMount: fireEvent
    });
};
const $e499aee6653ef75f$export$f461e628d5e73fa0 = ({ children: children, eventId: eventId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$f636b5b56f1d624a),
        sourceName: `${(0, $hRcYT.PACKAGE_NAME_GASV3)}.${eventId}`
    }, children);
const $e499aee6653ef75f$export$ac7e7464cefab440 = ({ children: children, eventId: eventId, attributes: attributes, onError: onError, errorFallback: errorFallback, resetCaughtError: resetCaughtError })=>{
    const fallback = (0, $eUqFw.useMemo)(()=>errorFallback || 'unmount', [
        errorFallback
    ]);
    const getAttributes = (0, $eUqFw.useCallback)((error)=>(0, $bBGpO.createAttributes)({
            ...attributes,
            error: error
        }), [
        attributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: eventId,
        packageName: (0, $hRcYT.PACKAGE_NAME_GASV3),
        teamName: "smite",
        fallback: fallback,
        attributes: getAttributes,
        onError: onError,
        resetCaughtError: resetCaughtError
    }, children);
};
const $e499aee6653ef75f$export$ad2a5d9127152fb8 = ({ children: children, module: module, entryPoint: entryPoint, attributes: attributes, moduleType: moduleType = (0, $hRcYT.MODULE_TYPE_EXTENSION), errorFallback: errorFallback = 'unmount', shouldFireInitializedEvent: shouldFireInitializedEvent = false, resetCaughtError: resetCaughtError })=>{
    const eventId = (0, $8XU7c.getEventId)({
        module: module,
        moduleType: moduleType,
        entryPoint: entryPoint
    });
    const analyticsAttributes = (0, $eUqFw.useMemo)(()=>(0, $bBGpO.createAttributes)(attributes), [
        attributes
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e499aee6653ef75f$export$f461e628d5e73fa0, {
        eventId: eventId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e499aee6653ef75f$export$ac7e7464cefab440, {
        eventId: eventId,
        attributes: analyticsAttributes,
        errorFallback: errorFallback,
        resetCaughtError: resetCaughtError
    }, shouldFireInitializedEvent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e499aee6653ef75f$export$4c46624a93517c10, {
        eventId: eventId,
        action: "initialized",
        attributes: analyticsAttributes
    }), children));
};
function $e499aee6653ef75f$var$isExtensionTimeMeasuredFromTriggerClick(extensionModule, entryPoint, attributes) {
    if ((extensionModule === (0, $2Rqjr.CUSTOM_FIELD_MODULE) || extensionModule === (0, $2Rqjr.CUSTOM_FIELD_TYPE_MODULE)) && (entryPoint !== 'edit' || attributes.renderContext === 'issue-create')) return false;
    if (extensionModule === (0, $2Rqjr.ISSUE_PANEL_MODULE) && !attributes?.isNewToIssue) return false;
    return /* eslint-disable @typescript-eslint/consistent-type-assertions */ [
        (0, $2Rqjr.GLOBAL_PAGE_MODULE),
        (0, $2Rqjr.ISSUE_ACTION_MODULE),
        (0, $2Rqjr.ISSUE_ACTIVITY_MODULE),
        (0, $2Rqjr.ISSUE_GLANCE_MODULE),
        (0, $2Rqjr.ISSUE_CONTEXT_MODULE),
        (0, $2Rqjr.ISSUE_PANEL_MODULE),
        (0, $2Rqjr.CUSTOM_FIELD_MODULE),
        (0, $2Rqjr.CUSTOM_FIELD_TYPE_MODULE),
        (0, $2Rqjr.PROJECT_PAGE_MODULE),
        (0, $2Rqjr.ADMIN_PAGE_MODULE),
        (0, $2Rqjr.PROJECT_SETTINGS_PAGE_MODULE)
    ].includes(extensionModule);
}
const $e499aee6653ef75f$export$14e56d7f5d3f917c = (Component)=>(props)=>{
        const startTime = (0, $eUqFw.useRef)(performance.now());
        const isCustomUI = (0, $2vJHJ.isCustomUIExtension)(props.extension, props.entryPoint);
        const [isExtensionRendered, setExtensionRendered] = (0, $eUqFw.useState)(false);
        const { module: module, entryPoint: entryPoint, analyticsAttributes: analyticsAttributes, localId: localId = '', onInitialRender: onInitialRender, onLoad: onLoad, extension: extension } = props;
        const extensionId = props.extension?.id;
        const eventId = (0, $8XU7c.getEventId)({
            module: module,
            entryPoint: entryPoint
        });
        const browserMetricsEventId = (0, $8XU7c.getBrowserMetricsEventId)({
            module: module,
            entryPoint: entryPoint,
            forgeUiType: (0, $2vJHJ.getForgeUIType)(extension, entryPoint)
        });
        const attributes = (0, $eUqFw.useMemo)(()=>({
                ...analyticsAttributes,
                ...(0, $5syGA.getAnalyticsAttributesFromExtension)(extension, entryPoint)
            }), // because extension is an object but we only want extension.id to trigger re-render
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [
            analyticsAttributes,
            entryPoint,
            extension.id,
            isCustomUI
        ]);
        if ((0, $1ybV0.ff)('fix-forge-extension-metrics_nkeqx')) (0, $eUqFw.useEffect)(()=>{
            if (!$e499aee6653ef75f$var$isExtensionTimeMeasuredFromTriggerClick(extension.type, entryPoint ?? 'view', attributes) && extensionId) (0, $d6g7g.forgeModulesConcurrentLoadTime)(extensionId).start({
                startTime: startTime.current
            });
        }, // We want to run this code only once on mount
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []);
        else !$e499aee6653ef75f$var$isExtensionTimeMeasuredFromTriggerClick(extension.type, entryPoint ?? 'view', attributes) && extensionId && (0, $d6g7g.forgeModulesLoadTime).start({
            startTime: performance.now()
        });
        const onError = (0, $eUqFw.useCallback)(()=>{
            if ((0, $1ybV0.ff)('fix-forge-extension-metrics_nkeqx')) extensionId && (0, $d6g7g.forgeModulesConcurrentLoadTime)(extensionId).cancel();
            else extensionId && (0, $d6g7g.forgeModulesLoadTime).cancel();
        }, [
            extensionId
        ]);
        const onInitialRenderUiKitWithMetrics = (0, $eUqFw.useCallback)((payload)=>{
            onInitialRender && onInitialRender(payload);
            if (payload?.error == null) {
                const stopTimeDeduction = payload?.appTime || 0;
                setExtensionRendered(true);
                if ((0, $1ybV0.ff)('fix-forge-extension-metrics_nkeqx')) extensionId && (0, $d6g7g.forgeModulesConcurrentLoadTime)(extensionId).stop({
                    stopTime: performance.now() - stopTimeDeduction,
                    customData: {
                        eventId: browserMetricsEventId
                    }
                });
                else extensionId && (0, $d6g7g.forgeModulesLoadTime).stop({
                    stopTime: performance.now() - stopTimeDeduction,
                    customData: {
                        eventId: browserMetricsEventId
                    }
                });
            } else {
                onError();
                (0, $9Z5wa.fireOperationalFailedEvent)({
                    eventId: eventId,
                    attributes: {
                        error: new Error(payload.error),
                        ...attributes
                    }
                });
            }
        }, [
            onInitialRender,
            extensionId,
            browserMetricsEventId,
            onError,
            eventId,
            attributes
        ]);
        const onLoadCustomUiWithMetrics = (0, $eUqFw.useCallback)(()=>{
            onLoad && onLoad();
            setExtensionRendered(true);
            if ((0, $1ybV0.ff)('fix-forge-extension-metrics_nkeqx')) extensionId && (0, $d6g7g.forgeModulesConcurrentLoadTime)(extensionId).stop({
                stopTime: performance.now(),
                customData: {
                    eventId: browserMetricsEventId
                }
            });
            else extensionId && (0, $d6g7g.forgeModulesLoadTime).stop({
                stopTime: performance.now(),
                customData: {
                    eventId: browserMetricsEventId
                }
            });
        // SMT-1418
        // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [
            analyticsAttributes,
            extensionId,
            localId,
            onLoad
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e499aee6653ef75f$export$f461e628d5e73fa0, {
            eventId: eventId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
            ...props,
            ...isCustomUI ? {
                onLoad: onLoadCustomUiWithMetrics
            } : {
                onInitialRender: onInitialRenderUiKitWithMetrics
            }
        }), isExtensionRendered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e499aee6653ef75f$export$92d758d83665314b, {
            attributes: attributes
        }));
    };

});
parcelRegister("2vJHJ", function(module, exports) {

$parcel$export(module.exports, "getForgeUIType", () => $0071fffa92d48f40$export$aed4d8a86badbf61);
$parcel$export(module.exports, "isCustomUIExtension", () => $0071fffa92d48f40$export$edb00cfe4962b026);
$parcel$export(module.exports, "isNativeUiExtension", () => $0071fffa92d48f40$export$2ecba06e617fea0a);
$parcel$export(module.exports, "overrideExtension", () => $0071fffa92d48f40$export$42b85bc9b386c977);

var $8blac = parcelRequire("8blac");

var $1ybV0 = parcelRequire("1ybV0");
const $0071fffa92d48f40$export$aed4d8a86badbf61 = (extension, entryPoint = '')=>{
    const { render: render, resource: resource } = extension.properties;
    if (!(0, $1ybV0.ff)('fix-forge-ui-type-detection_nmgpj')) {
        if (render != null && render !== 'native') return 'ui-kit';
    }
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'CommonProps | (CommonProps & { label: string; dynamicProperties?: { function: string; } | undefined; icon?: string | undefined; status?: IssueGlanceStatus | undefined; }) | ... 9 more ... | { ...; }'.
    if (entryPoint && extension.properties[entryPoint]) {
        const { resource: entryPointResource, render: entryPointRender } = // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'CommonProps | (CommonProps & { label: string; dynamicProperties?: { function: string; } | undefined; icon?: string | undefined; status?: IssueGlanceStatus | undefined; }) | ... 9 more ... | { ...; }'.
        extension.properties[entryPoint];
        if (entryPointResource == null) return 'ui-kit';
        if (entryPointRender === 'native') return 'native-ui';
        return 'custom-ui';
    }
    if (resource == null) return 'ui-kit';
    if (render === 'native') return 'native-ui';
    return 'custom-ui';
};
const $0071fffa92d48f40$export$edb00cfe4962b026 = (extension, entryPoint = '')=>$0071fffa92d48f40$export$aed4d8a86badbf61(extension, entryPoint) === 'custom-ui';
const $0071fffa92d48f40$export$2ecba06e617fea0a = (extension, entryPoint = '')=>$0071fffa92d48f40$export$aed4d8a86badbf61(extension, entryPoint) === 'native-ui';
const $0071fffa92d48f40$export$42b85bc9b386c977 = (extension, propsToOverride)=>{
    if (extension == null) return extension;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(propsToOverride)) return extension;
    const { resource: resource, requiresUserConsent: requiresUserConsent } = propsToOverride;
    // We must also spread `extension.properties` because JS doesn't deep-copy objects.
    // Only spreading `extension` will result in `resource` on the original `extension`
    // object being modified.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const extensionCopy = {
        ...extension,
        properties: {
            ...extension.properties
        },
        requiresUserConsent: requiresUserConsent
    }; // eslint-disable-line @typescript-eslint/no-explicit-any
    if (resource != null) extensionCopy.properties.resource = resource;
    return extensionCopy;
};

});

parcelRegister("9x02J", function(module, exports) {

$parcel$export(module.exports, "useHasForgeAccess", () => $c88d1eb745d9d2ce$export$fd7f94d3d2bac7f2);

var $6yplV = parcelRequire("6yplV");
const $c88d1eb745d9d2ce$export$fd7f94d3d2bac7f2 = ()=>{
    const isAnonymous = (0, $6yplV.useIsAnonymous)();
    return !isAnonymous;
};

});

parcelRegister("8XU7c", function(module, exports) {

$parcel$export(module.exports, "getEventId", () => $ea56d020133ed4ec$export$5639f6a927500d9);
$parcel$export(module.exports, "getBrowserMetricsEventId", () => $ea56d020133ed4ec$export$25830fc7d037f0f2);
$parcel$export(module.exports, "getEventActionName", () => $ea56d020133ed4ec$export$644ccb9a67b9a9c1);

var $2Rqjr = parcelRequire("2Rqjr");

var $TrUS5 = parcelRequire("TrUS5");

var $hRcYT = parcelRequire("hRcYT");


var $eTZsp = parcelRequire("eTZsp");

var $d6g7g = parcelRequire("d6g7g");
const $ea56d020133ed4ec$var$capitalizeFirstLetter = (str)=>str != null && str.charAt(0).toUpperCase() + str.slice(1) || '';
const $ea56d020133ed4ec$var$prepareModuleMode = (entryPoint)=>`${$ea56d020133ed4ec$var$capitalizeFirstLetter(entryPoint)}`;
const $ea56d020133ed4ec$export$3e50bc81d8ed2e3f = (moduleName)=>moduleName.replace(/^jira:/, '');
const $ea56d020133ed4ec$var$prepareModuleName = (moduleName)=>(0, $2Rqjr.SUPPORTED_MODULES).includes(moduleName) ? $ea56d020133ed4ec$export$3e50bc81d8ed2e3f(moduleName) : 'unknown';
const $ea56d020133ed4ec$export$5639f6a927500d9 = ({ module: module, moduleType: moduleType = (0, $hRcYT.MODULE_TYPE_EXTENSION), entryPoint: entryPoint })=>{
    const eventNamePostfix = moduleType === 'trigger' ? 'Trigger' : '';
    return (0, $TrUS5.toEventId)(`${$ea56d020133ed4ec$var$prepareModuleName(module)}${$ea56d020133ed4ec$var$prepareModuleMode(entryPoint)}${eventNamePostfix}`);
};
const $ea56d020133ed4ec$export$25830fc7d037f0f2 = ({ module: module, entryPoint: entryPoint, forgeUiType: forgeUiType })=>(0, $TrUS5.toEventId)(`${$ea56d020133ed4ec$var$prepareModuleName(module)}${$ea56d020133ed4ec$var$prepareModuleMode(entryPoint)}-${forgeUiType}`);
const $ea56d020133ed4ec$export$644ccb9a67b9a9c1 = (eventId, action)=>`${0, $hRcYT.PACKAGE_NAME_GASV3}.${eventId} ${action}`;

});

parcelRegister("9Z5wa", function(module, exports) {

$parcel$export(module.exports, "fireOperationalFailedEvent", () => $2660eb080e6928fb$export$add44f896fb31ba3);

var $hRcYT = parcelRequire("hRcYT");

var $cYWDh = parcelRequire("cYWDh");
const $2660eb080e6928fb$export$add44f896fb31ba3 = ({ eventId: eventId, attributes: attributes })=>{
    (0, $cYWDh.fireOperationalEvent)((0, $hRcYT.OPERATIONAL_ACTIONS).FAILED, {
        id: eventId,
        attributes: attributes
    });
};

});

parcelRegister("5syGA", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsAttributesFromExtension", () => $05fce0f798595dcf$export$5d3b06ab08af139e);

var $2vJHJ = parcelRequire("2vJHJ");

var $70ON1 = parcelRequire("70ON1");
const $05fce0f798595dcf$export$5d3b06ab08af139e = (extension, entryPoint)=>{
    const { appId: appId, envId: envId } = (0, $70ON1.parseExtensionId)(extension.id);
    return {
        appId: appId,
        envId: envId,
        forgeType: (0, $2vJHJ.getForgeUIType)(extension, entryPoint),
        envType: extension?.environmentType
    };
};

});


parcelRegister("elbiT", function(module, exports) {

$parcel$export(module.exports, "ViewAnalyticsWrapper", () => $4ecd31271e5beb2f$export$c794eb4124961145);
$parcel$export(module.exports, "EditAnalyticsWrapper", () => $4ecd31271e5beb2f$export$947ae3996b2bc000);

var $eUqFw = parcelRequire("eUqFw");

var $2Rqjr = parcelRequire("2Rqjr");

var $1boRu = parcelRequire("1boRu");
const $4ecd31271e5beb2f$export$c794eb4124961145 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.CUSTOM_FIELD_MODULE),
        shouldFireInitializedEvent: true,
        ...props
    });
const $4ecd31271e5beb2f$export$947ae3996b2bc000 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1boRu.ForgeAnalyticsWrapper), {
        module: (0, $2Rqjr.CUSTOM_FIELD_MODULE),
        entryPoint: (0, $2Rqjr.ENTRY_POINT_EDIT),
        ...props
    });

});

parcelRegister("15xm4", function(module, exports) {

$parcel$export(module.exports, "EditMode", () => $dcd4a9dea6996051$export$5304145354a3bee9);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $5syGA = parcelRequire("5syGA");

var $dh9qu = parcelRequire("dh9qu");

var $elbiT = parcelRequire("elbiT");

var $7y11V = parcelRequire("7y11V");

var $7ujNe = parcelRequire("7ujNe");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1ZhS1 = parcelRequire("1ZhS1");

var $2NKh3 = parcelRequire("2NKh3");
const $dcd4a9dea6996051$export$ba588b5cce278e96 = ({ extension: extension, extensionData: extensionData, extensionPayload: extensionPayload, analyticsAttributes: analyticsAttributes, onChange: onChange })=>{
    const [isModalMode, setIsModalMode] = (0, $eUqFw.useState)(false);
    const intl = (0, $5JgJ2.default)();
    const onEditConfirm = (0, $eUqFw.useCallback)((newValue)=>{
        onChange((0, $1ZhS1.transformValue)(newValue, extension));
        (0, $dh9qu.fireTrackEditedEvent)('issue-create', analyticsAttributes);
    }, [
        extension,
        analyticsAttributes,
        onChange
    ]);
    const onModalRender = (0, $eUqFw.useCallback)(()=>setIsModalMode(true), []);
    if (isModalMode) {
        // temporary for UI Kit version of 1.2.0 when inline edit is not supported
        // will be fixed with https://ecosystem-platform.atlassian.net/browse/ARKEN-32
        const translatedError = {
            message: intl.formatMessage((0, $2NKh3.default).modalModeErrorTitle),
            errorMessage: intl.formatMessage((0, $2NKh3.default).modalModeErrorDescription)
        };
        (0, $gUUjF.default).safeErrorWithoutCustomerData('jiraForgeUI.customFieldEdit', 'App tried to render modal expierience on issue create', {
            ...analyticsAttributes,
            extension: JSON.stringify(extension)
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ujNe.ErrorPanel), {
            error: translatedError
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7y11V.AsyncCustomFieldInlineEdit), {
        extension: extension,
        extensionData: extensionData,
        analyticsAttributes: analyticsAttributes,
        extensionPayload: extensionPayload,
        onSubmit: onEditConfirm,
        onModalRender: onModalRender
    });
};
const $dcd4a9dea6996051$export$5304145354a3bee9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $elbiT.EditAnalyticsWrapper), {
        attributes: (0, $5syGA.getAnalyticsAttributesFromExtension)(props.extension)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($dcd4a9dea6996051$export$ba588b5cce278e96, props));

});
parcelRegister("dh9qu", function(module, exports) {

$parcel$export(module.exports, "fireTrackEditedEvent", () => $76db82789679977a$export$1798d320c6527c08);
$parcel$export(module.exports, "fireUiCanceledEvent", () => $76db82789679977a$export$fc09afa3d0d5294c);
$parcel$export(module.exports, "fireOperationalEditFailedEvent", () => $76db82789679977a$export$762dee9e981de3e1);
$parcel$export(module.exports, "fireUiTriggerClickEventOld", () => $76db82789679977a$export$1a9fbbff7428ad75);
$parcel$export(module.exports, "fireUiTriggerClickEvent", () => $76db82789679977a$export$cfefb608fbbf02c9);
$parcel$export(module.exports, "fireOperationalFailedEvent", () => $76db82789679977a$export$add44f896fb31ba3);

var $2Rqjr = parcelRequire("2Rqjr");

var $8XU7c = parcelRequire("8XU7c");

var $cYWDh = parcelRequire("cYWDh");

var $d6g7g = parcelRequire("d6g7g");

var $hRcYT = parcelRequire("hRcYT");
const $76db82789679977a$var$moduleEventId = (0, $8XU7c.getEventId)({
    module: (0, $2Rqjr.CUSTOM_FIELD_MODULE),
    moduleType: (0, $hRcYT.MODULE_TYPE_EXTENSION),
    entryPoint: (0, $2Rqjr.ENTRY_POINT_EDIT)
});
const $76db82789679977a$var$triggerEventId = (0, $8XU7c.getEventId)({
    module: (0, $2Rqjr.CUSTOM_FIELD_MODULE),
    moduleType: (0, $hRcYT.MODULE_TYPE_TRIGGER),
    entryPoint: (0, $2Rqjr.ENTRY_POINT_EDIT)
});
const $76db82789679977a$export$1798d320c6527c08 = (source, attributes)=>(0, $cYWDh.fireTrackEvent)((0, $hRcYT.TRACK_ACTIONS).EDITED, {
        id: $76db82789679977a$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $76db82789679977a$export$fc09afa3d0d5294c = (source, attributes)=>(0, $cYWDh.fireUiEvent)((0, $hRcYT.UI_ACTIONS).CANCELED, {
        id: $76db82789679977a$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $76db82789679977a$export$762dee9e981de3e1 = (source, attributes)=>(0, $cYWDh.fireOperationalEvent)((0, $hRcYT.OPERATIONAL_ACTIONS).EDIT_FAILED, {
        id: $76db82789679977a$var$moduleEventId,
        source: source,
        attributes: attributes
    });
const $76db82789679977a$export$1a9fbbff7428ad75 = (source, attributes)=>{
    (0, $d6g7g.forgeModulesLoadTime).start({
        startTime: performance.now()
    });
    return (0, $cYWDh.fireUiEvent)((0, $hRcYT.UI_ACTIONS).CLICKED, {
        id: $76db82789679977a$var$triggerEventId,
        source: source,
        attributes: attributes
    });
};
const $76db82789679977a$export$cfefb608fbbf02c9 = (extensionId, source, attributes)=>{
    (0, $d6g7g.forgeModulesConcurrentLoadTime)(extensionId).start({
        startTime: performance.now()
    });
    return (0, $cYWDh.fireUiEvent)((0, $hRcYT.UI_ACTIONS).CLICKED, {
        id: $76db82789679977a$var$triggerEventId,
        source: source,
        attributes: attributes
    });
};
const $76db82789679977a$export$add44f896fb31ba3 = (source, attributes)=>(0, $cYWDh.fireOperationalEvent)((0, $hRcYT.OPERATIONAL_ACTIONS).FAILED, {
        id: $76db82789679977a$var$moduleEventId,
        source: source,
        attributes: attributes
    });

});

parcelRegister("7y11V", function(module, exports) {

$parcel$export(module.exports, "AsyncCustomFieldInlineEdit", () => $5a273adefb2c2ed1$export$ca6c6772b322056d);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $18to0 = parcelRequire("18to0");

var $d6g7g = parcelRequire("d6g7g");
var $1boRu = parcelRequire("1boRu");

var $hRcYT = parcelRequire("hRcYT");

var $dh9qu = parcelRequire("dh9qu");

var $2Rqjr = parcelRequire("2Rqjr");

var $gamHX = parcelRequire("gamHX");

var $2vJHJ = parcelRequire("2vJHJ");

var $gGtKh = parcelRequire("gGtKh");

var $8Nthx = parcelRequire("8Nthx");

var $gWRle = parcelRequire("gWRle");

const $5a273adefb2c2ed1$var$getModule = ()=>(0, $d6g7g.measureInitialPageLoadAsyncResourcesTiming)((0, $hRcYT.PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_START, (0, $hRcYT.PERFORMANCE_KEYS).MARKS.ASYNC_FORGE_UI_CUSTOM_FIELD_INLINE_EDIT_BUNDLE_END, ()=>(parcelRequire("5N0iz")));
const $5a273adefb2c2ed1$var$skeletonConfig = [
    {
        width: 100
    }
];
const $5a273adefb2c2ed1$export$eef5130ba28e0f4e = (0, $1boRu.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $7rh0R.lazyForPaint)(()=>$5a273adefb2c2ed1$var$getModule().then((module)=>module.CustomFieldInlineEdit), {
    ssr: false
}));
const $5a273adefb2c2ed1$export$980ea0297ad3a4c8 = ({ onSubmit: onSubmit, onModalRender: onModalRender, ...restProps })=>{
    const requestsCount = (0, $eUqFw.useRef)(0);
    const [, { setFieldState: setFieldState }] = (0, $18to0.useInlineField)(restProps.extensionData.fieldId);
    const { extension: extension, extensionData: extensionData, extensionPayload: extensionPayload } = restProps;
    const loadingComponent = (0, $eUqFw.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Nthx.Skeleton), {
            skeletonConfig: $5a273adefb2c2ed1$var$skeletonConfig
        }), []);
    const extensionDataValue = (0, $eUqFw.useMemo)(()=>{
        const preparedExtensionData = extensionData?.issue && extensionData?.project ? extensionData : {
            fieldId: extensionData.fieldId,
            fieldType: extensionData.fieldType,
            fieldName: extensionData.fieldName,
            renderContext: extensionData.renderContext
        };
        return {
            ...preparedExtensionData,
            type: extension.type,
            entryPoint: (0, $2Rqjr.ENTRY_POINT_EDIT),
            isInline: true
        };
    }, [
        extension,
        extensionData
    ]);
    const extraProps = (0, $eUqFw.useMemo)(()=>({
            loadingComponent: loadingComponent,
            module: (0, $2Rqjr.CUSTOM_FIELD_MODULE),
            entryPoint: (0, $2Rqjr.ENTRY_POINT_EDIT),
            extensionData: extensionDataValue,
            extensionPayload: extensionPayload,
            contextToken: (0, $2Rqjr.CONTEXT_TOKEN_TYPE_JIRA)
        }), [
        extensionDataValue,
        extensionPayload,
        loadingComponent
    ]);
    const createRetryFunction = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (fieldValue)=>async ()=>{
            try {
                setFieldState({
                    fieldId: extensionData.fieldId,
                    status: (0, $e456ec6df0e2a730$export$f81c1d6b9217380c)
                });
                requestsCount.current += 1;
                const submitValue = await Promise.resolve(fieldValue);
                onSubmit(submitValue);
                requestsCount.current -= 1;
                if (requestsCount.current === 0) setFieldState({
                    fieldId: extensionData.fieldId,
                    status: (0, $e456ec6df0e2a730$export$9956c6a700e724c4)
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                setFieldState({
                    fieldId: extensionData.fieldId,
                    status: (0, $e456ec6df0e2a730$export$742c877aeb0f3dbd)
                });
                (0, $dh9qu.fireOperationalEditFailedEvent)('issue-create', {
                    error: error,
                    isInline: true
                });
            }
            return undefined;
        }, [
        onSubmit,
        extensionData,
        setFieldState
    ]);
    const submit = (0, $eUqFw.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    async ({ data: fieldValue })=>{
        const retryFunction = createRetryFunction(fieldValue);
        setFieldState({
            fieldId: extensionData.fieldId,
            retryFunction: retryFunction
        });
        await retryFunction();
        return undefined;
    }, [
        createRetryFunction,
        extensionData.fieldId,
        setFieldState
    ]);
    const bridge = (0, $eUqFw.useMemo)(()=>({
            submit: submit
        }), [
        submit
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gWRle.StopSubmitPropagation), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "custom-field-inline-edit",
        fallback: loadingComponent
    }, (0, $2vJHJ.isCustomUIExtension)(extension, (0, $2Rqjr.ENTRY_POINT_EDIT)) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gamHX.LazyIframe), {
        ...restProps,
        ...extraProps,
        bridge: bridge,
        isResizable: true
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5a273adefb2c2ed1$export$eef5130ba28e0f4e, {
        ...restProps,
        ...extraProps,
        onModalRender: onModalRender,
        onSubmit: onSubmit,
        bridge: bridge
    })));
};
const $5a273adefb2c2ed1$export$ca6c6772b322056d = $5a273adefb2c2ed1$export$980ea0297ad3a4c8;

});
parcelRegister("gamHX", function(module, exports) {

$parcel$export(module.exports, "LazyIframe", () => $06c11067a462069c$export$808646051d5a3908);
$parcel$export(module.exports, "LazyModalIframe", () => $06c11067a462069c$export$f35ac420e260eb7);

var $7rh0R = parcelRequire("7rh0R");

var $1boRu = parcelRequire("1boRu");

const $06c11067a462069c$var$getModule = ()=>(parcelRequire("k9s7y"));
const $06c11067a462069c$export$808646051d5a3908 = (0, $1boRu.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $7rh0R.lazyForPaint)(()=>$06c11067a462069c$var$getModule().then((module)=>module.IframeRenderer), {
    ssr: false
}));
const $06c11067a462069c$export$f35ac420e260eb7 = (0, $1boRu.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $7rh0R.lazy)(()=>$06c11067a462069c$var$getModule().then((module)=>module.ModalIframeRenderer), {}));

});
parcelRegister("k9s7y", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('8ficv')
        ]);
        const value = parcelRequire('kq5KC');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("8ficv")
    ]).then(()=>parcelRequire('kq5KC'));
}

});


parcelRegister("8Nthx", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $fb59735ddb4a6800$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "SkeletonLayout", () => $fb59735ddb4a6800$export$af3ba02ef74c9bdf);
/* main.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");
const $fb59735ddb4a6800$export$69f3c7f0b2b87aa2 = [];
const $fb59735ddb4a6800$export$8f31e4c4a37b8e9c = ({ skeletonConfig: skeletonConfig = $fb59735ddb4a6800$export$69f3c7f0b2b87aa2 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, skeletonConfig.map(({ width: width }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fb59735ddb4a6800$var$ForgeSkeleton, {
            "data-testId": `forgeskeleton-${index}`,
            key: index,
            width: width
        })));
const $fb59735ddb4a6800$export$af3ba02ef74c9bdf = ({ children: children, layout: layout })=>{
    if (!layout) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        testId: "forge-ui-async.common.ui.skeleton.box",
        xcss: $fb59735ddb4a6800$var$layoutStyles
    }, children);
};
const $fb59735ddb4a6800$var$shimmer = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fb59735ddb4a6800$var$ForgeSkeleton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1y04s53": (0, $9t7rW.default)(`${__cmplp.width}%`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1mcm _4t3ipxbi _19pkpxbi _5sag9cwz _1o51q7pw _tip812c5 _j7hq1nls _1pglp3kn _bfhkqrzy _1itk1ipn _12vemgnk",
            __cmplp.className
        ])
    });
});
const $fb59735ddb4a6800$var$layoutStyles = (0, $1ZAYh.xcss)({
    paddingTop: 'space.200',
    paddingLeft: 'space.300',
    paddingRight: 'space.300'
});

});

parcelRegister("gWRle", function(module, exports) {

$parcel$export(module.exports, "StopSubmitPropagation", () => $1ee7d0bd2c357478$export$238f56c0891e9254);

var $eUqFw = parcelRequire("eUqFw");
const $1ee7d0bd2c357478$export$e6dfd72ab29f8598 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "forge-ui-async.common.ui.submit-stop-propogation-wrapper.forge-stop-propagation-wrapper",
        onSubmit: props.onSubmit
    }, props.children);
const $1ee7d0bd2c357478$export$238f56c0891e9254 = ({ children: children })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleSubmit = (e)=>{
        e.stopPropagation();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1ee7d0bd2c357478$export$e6dfd72ab29f8598, {
        onSubmit: handleSubmit
    }, children);
};

});

parcelRegister("5N0iz", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('ekVbM'),
            load('h2MrD'),
            load('bYT2S'),
            load('RRgs6')
        ]);
        const value = parcelRequire('akozD');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("ekVbM"),
        load("h2MrD"),
        load("bYT2S"),
        load("RRgs6")
    ]).then(()=>parcelRequire('akozD'));
}

});


parcelRegister("7ujNe", function(module, exports) {

$parcel$export(module.exports, "ErrorPanel", () => $4f4c1cd445d31479$export$9f3dc18e1adf5d8f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lRvnl = parcelRequire("lRvnl");
var $cEUHb = parcelRequire("cEUHb");

var $4Bees = parcelRequire("4Bees");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1N1hD = parcelRequire("1N1hD");
const $4f4c1cd445d31479$var$Loader = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f4c1cd445d31479$var$LoaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
        testId: "forge-ui-renderers.common.ui.error-panel.forge-app-loading-spinner",
        size: "large"
    }));
const $4f4c1cd445d31479$export$9f3dc18e1adf5d8f = ({ error: error, onRetry: onRetry })=>{
    const { message: message, errorMessage: errorMessage, errorDetails: errorDetails } = error;
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const intl = (0, $5JgJ2.default)();
    const onClickStopPropagation = (0, $eUqFw.useCallback)((e)=>e.stopPropagation(), []);
    const reinitializeApp = (0, $eUqFw.useCallback)(async (e)=>{
        setIsLoading(true);
        try {
            e.stopPropagation();
            if (onRetry) await onRetry();
        } catch  {} finally{
            setIsLoading(false);
        }
    }, [
        onRetry
    ]);
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f4c1cd445d31479$var$Loader, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f4c1cd445d31479$var$ContentWrapper, {
        onClick: onClickStopPropagation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        appearance: "error",
        title: message,
        actions: onRetry ? [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cEUHb.default), {
                onClick: reinitializeApp,
                key: "refresh"
            }, intl.formatMessage((0, $1N1hD.default).refreshApp))
        ] : []
    }, errorMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f4c1cd445d31479$var$ErrorMessageWrapper, null, errorMessage), errorDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4f4c1cd445d31479$var$ErrorDetailsWrapper, null, errorDetails)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f4c1cd445d31479$var$ContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _k7zyidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f4c1cd445d31479$var$LoaderWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1h6o _ca0qutpp _n3tdutpp _1bsb1osq _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f4c1cd445d31479$var$ErrorMessageWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5721jtm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f4c1cd445d31479$var$ErrorDetailsWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "pre", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5721jtm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cEUHb", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eba8e69e42130a2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");
/**
 * __Section message action__
 *
 * A section message action is designed to work with the `action` prop from
 * `SectionMessage`. It renders either a button or a link depending on whether
 * an `onClick` or `href` prop is supplied, with a dot separator in between actions.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples#actions)
 */ const $6eba8e69e42130a2$var$SectionMessageAction = /*#__PURE__*/ (0, $eUqFw.memo)(function SectionMessageAction({ children: children, onClick: onClick, href: href, testId: testId, linkComponent: linkComponent }) {
    // FIXME: This path doesn't make sense
    // If the intent of the design for this component is to use an action, not providing `href` or `onClick`
    // makes the use case invalid. This should be addressed.
    return onClick || href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: testId,
        appearance: "link",
        spacing: "none",
        onClick: onClick,
        href: href,
        component: href ? linkComponent : undefined
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
});
$6eba8e69e42130a2$var$SectionMessageAction.displayName = 'SectionMessageAction';
var $6eba8e69e42130a2$export$2e2bcd8739ae039 = $6eba8e69e42130a2$var$SectionMessageAction;

});

parcelRegister("1N1hD", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9b96b0ffaa98017$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c9b96b0ffaa98017$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    refreshApp: {
        "id": "forge-ui-renderers.common.error-panel.refresh-app",
        "defaultMessage": "Refresh app"
    }
});

});


parcelRegister("1ZhS1", function(module, exports) {

$parcel$export(module.exports, "transformValue", () => $8ab1855d728a8881$export$98c150630afe5417);
$parcel$export(module.exports, "transformValueToExtensionData", () => $8ab1855d728a8881$export$b82f09291a00d8c1);
$parcel$export(module.exports, "getExtension", () => $8ab1855d728a8881$export$78d71f9ed5534abe);

var $26Ej0 = parcelRequire("26Ej0");

var $5VJL3 = parcelRequire("5VJL3");

var $3pjiv = parcelRequire("3pjiv");

var $bRVha = parcelRequire("bRVha");
const $8ab1855d728a8881$export$98c150630afe5417 = (value, extension)=>{
    const { properties: { type: type, collection: collection } } = extension;
    switch(type){
        case 'string':
            if (collection === 'list' && Array.isArray(value)) // @ts-expect-error - TS2322 - Type 'Option[]' is not assignable to type 'ForgeCustomFieldValue'. | TS2345 - Argument of type 'string[] | User[] | Group[]' is not assignable to parameter of type 'LabelsValue'.
            return (0, $26Ej0.mapDataToLabelOptions)(value);
            return value;
        case 'object':
            return JSON.stringify(value);
        case 'user':
            if (value != null) // @ts-expect-error - TS2345 - Argument of type 'string | number | string[] | User | Group | { [key: string]: unknown; } | User[] | Group[]' is not assignable to parameter of type 'JiraUser | JiraUser[]'.
            return (0, $bRVha.transformDefaultUserValues)(value);
            return value;
        default:
            return value;
    }
};
const $8ab1855d728a8881$export$b82f09291a00d8c1 = (value, extension)=>{
    const type = extension?.properties?.type;
    const collection = extension?.properties?.collection;
    switch(type){
        case 'string':
            if (collection === 'list') // @ts-expect-error - TS2345 - Argument of type 'ForgeCustomFieldValue' is not assignable to parameter of type 'Option[]'.
            return (0, $26Ej0.mapLabelOptionsToData)(value);
            return value;
        case 'object':
            return (0, $3pjiv.transformJSONStringToObject)(value);
        case 'user':
            if (value === null) return value;
            // @ts-expect-error - TS2345 - Argument of type 'ForgeCustomFieldValue' is not assignable to parameter of type 'UserOption | UserOption[]'.
            return (0, $bRVha.mapUserOptionsToAccountIds)(value);
        default:
            return value;
    }
};
const $8ab1855d728a8881$export$78d71f9ed5534abe = (fieldType, modules)=>modules.find((field)=>(0, $5VJL3.isForgeLegacyFieldType)(fieldType) ? field.id === (0, $5VJL3.getExtensionIdFromLegacyFieldType)(fieldType) : field.id === fieldType);

});
parcelRegister("26Ej0", function(module, exports) {

$parcel$export(module.exports, "mapDataToLabelOptions", () => $14639b9418410a0a$export$cd8e373d5b1325b1);
$parcel$export(module.exports, "mapLabelOptionsToData", () => $14639b9418410a0a$export$1bf703d99c7bcef6);
$parcel$export(module.exports, "mapLabelsResponseToLabelOptions", () => $14639b9418410a0a$export$37f55c1f665c1221);
const $14639b9418410a0a$export$cd8e373d5b1325b1 = (data)=>{
    if (!data) return [];
    return data.map((value)=>({
            value: value,
            label: value
        }));
};
const $14639b9418410a0a$export$1bf703d99c7bcef6 = (options)=>options.map(({ value: value })=>value);
const $14639b9418410a0a$export$37f55c1f665c1221 = (response)=>{
    const { suggestions: suggestions } = response;
    if (!suggestions) return [];
    return suggestions.map(({ label: label })=>({
            label: label,
            value: label
        }));
};

});

parcelRegister("3pjiv", function(module, exports) {

$parcel$export(module.exports, "transformJSONStringToObject", () => $409615a4cc1f157c$export$2de59005e10fd82);

var $4ZYEI = parcelRequire("4ZYEI");
const $409615a4cc1f157c$export$2de59005e10fd82 = (value)=>{
    try {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($4ZYEI)))(value) && JSON.parse(value)) return JSON.parse(value);
    } catch (e) {
        return value;
    }
    return value;
};

});
parcelRegister("4ZYEI", function(module, exports) {

var $2OY5s = parcelRequire("2OY5s");

var $1c8hB = parcelRequire("1c8hB");

var $hYEMs = parcelRequire("hYEMs");
/** `Object#toString` result references. */ var $3a3be8dd1917bddc$var$stringTag = '[object String]';
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $3a3be8dd1917bddc$var$isString(value) {
    return typeof value == 'string' || !$1c8hB(value) && $hYEMs(value) && $2OY5s(value) == $3a3be8dd1917bddc$var$stringTag;
}
module.exports = $3a3be8dd1917bddc$var$isString;

});


parcelRegister("bRVha", function(module, exports) {

$parcel$export(module.exports, "transformJiraUserToUserOption", () => $2314b3b273d33011$export$3e406786572c35b0);
$parcel$export(module.exports, "transformDefaultUserValues", () => $2314b3b273d33011$export$26760e7b66ccf1e1);
$parcel$export(module.exports, "mapUserOptionsToIds", () => $2314b3b273d33011$export$2482a6858a4714ad);
$parcel$export(module.exports, "mapUserOptionsToAccountIds", () => $2314b3b273d33011$export$e4490ea0dfe4173f);
$parcel$export(module.exports, "mutateSingleUserPicker", () => $2314b3b273d33011$export$7937ee6404102aff);
$parcel$export(module.exports, "mutateMultiUserPicker", () => $2314b3b273d33011$export$53e350638c0acebc);

const $2314b3b273d33011$export$3e406786572c35b0 = (userData)=>({
        id: userData.accountId || '',
        name: userData.name || '',
        avatarUrl: userData.picture || ''
    });
const $2314b3b273d33011$export$26760e7b66ccf1e1 = (defaultValue)=>{
    if (Array.isArray(defaultValue)) return defaultValue.map($2314b3b273d33011$export$3e406786572c35b0);
    return $2314b3b273d33011$export$3e406786572c35b0(defaultValue);
};
const $2314b3b273d33011$export$2482a6858a4714ad = (userOption)=>{
    if (Array.isArray(userOption)) return userOption.map((option)=>({
            id: option.id
        }));
    return {
        id: userOption.id
    };
};
const $2314b3b273d33011$export$e4490ea0dfe4173f = (userOption)=>{
    if (Array.isArray(userOption)) return userOption.map((option)=>({
            accountId: option.id
        }));
    return {
        accountId: userOption.id
    };
};
const $2314b3b273d33011$export$7937ee6404102aff = (selectedUser, fieldId)=>({
        fieldId: fieldId,
        mutationGroup: (0, $ab1884f8d9d06de2$export$6684456d545bf498),
        user: {
            accountId: selectedUser.id
        }
    });
const $2314b3b273d33011$export$53e350638c0acebc = (selectedUsers, fieldId)=>({
        fieldId: fieldId,
        mutationGroup: (0, $ab1884f8d9d06de2$export$52003ca9b6035e0c),
        users: selectedUsers.map((user)=>({
                accountId: user.id
            }))
    });

});
const $ab1884f8d9d06de2$export$6684456d545bf498 = 'singleSelectUserPickerFields';
const $ab1884f8d9d06de2$export$52003ca9b6035e0c = 'multipleSelectUserPickerFields';



parcelRegister("2NKh3", function(module, exports) {

$parcel$export(module.exports, "default", () => $b64bf1ba81b43dcd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b64bf1ba81b43dcd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    modalModeErrorTitle: {
        "id": "issue-create-commons.common.forge.edit.modal-mode-error-title",
        "defaultMessage": "We couldn't show this extension"
    },
    modalModeErrorDescription: {
        "id": "issue-create-commons.common.forge.edit.modal-mode-error-description",
        "defaultMessage": "Contact the app vendor to update the app."
    }
});

});


parcelRegister("lWg9w", function(module, exports) {

$parcel$export(module.exports, "ForgeFieldMessage", () => $b98626228635fa8b$export$1df6b326181f4cdf);

var $eUqFw = parcelRequire("eUqFw");

var $7jPhn = parcelRequire("7jPhn");

var $4Bees = parcelRequire("4Bees");

var $18to0 = parcelRequire("18to0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $iayrZ = parcelRequire("iayrZ");

var $3Fja5 = parcelRequire("3Fja5");

var $5kKVt = parcelRequire("5kKVt");
const $b98626228635fa8b$export$1df6b326181f4cdf = (props)=>{
    const failedErrorMessageAppeared = (0, $eUqFw.useRef)(false);
    const { error: error, fieldId: fieldId, renderFieldMessage: renderFieldMessage } = props;
    const [fieldState] = (0, $18to0.useInlineField)(fieldId);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const renderErrorMessage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5kKVt.MessagePartsSeparationWrapper), null, formatMessage((0, $3Fja5.default).forgeFieldErrorTextLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iayrZ.ForgeFieldDispatchButton), {
            fieldId: fieldId
        }));
    const renderSuccessMessage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ValidMessage), null, formatMessage((0, $3Fja5.default).forgeFieldSuccessTextLabel));
    const renderHelperMessage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.HelperMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5kKVt.MessagePartsSeparationWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), {
            size: "small"
        })), formatMessage((0, $3Fja5.default).forgeFieldPendingTextLabel));
    const renderDefaultErrorMessage = ()=>{
        if (renderFieldMessage !== undefined && renderFieldMessage !== null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, renderFieldMessage(error));
        return null;
    };
    if (error !== undefined) return renderDefaultErrorMessage();
    if (failedErrorMessageAppeared.current) {
        if (renderFieldMessage !== undefined && renderFieldMessage !== null) switch(fieldState?.status){
            case 0, $e456ec6df0e2a730$export$742c877aeb0f3dbd:
                return renderErrorMessage();
            case 0, $e456ec6df0e2a730$export$9956c6a700e724c4:
                return renderSuccessMessage();
            case 0, $e456ec6df0e2a730$export$f81c1d6b9217380c:
            case 0, $e456ec6df0e2a730$export$2ace7d3737836262:
                return renderHelperMessage();
            default:
                return renderDefaultErrorMessage();
        }
        return null;
    }
    if (fieldState?.status === (0, $e456ec6df0e2a730$export$742c877aeb0f3dbd)) {
        failedErrorMessageAppeared.current = true;
        return renderErrorMessage();
    }
    return renderDefaultErrorMessage();
};

});
parcelRegister("iayrZ", function(module, exports) {

$parcel$export(module.exports, "ForgeFieldDispatchButton", () => $16eb88a1fc635e0f$export$59e3aafda495153);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $18to0 = parcelRequire("18to0");
const $16eb88a1fc635e0f$export$59e3aafda495153 = (props)=>{
    const { fieldId: fieldId } = props;
    const [fieldState, { dispatchRetryFunction: dispatchRetryFunction }] = (0, $18to0.useInlineField)(fieldId);
    const onClickHandler = async ()=>{
        if (fieldId !== undefined) await dispatchRetryFunction(fieldId);
    };
    const renderRetryButton = ()=>{
        if (fieldState !== undefined && fieldState?.status === (0, $e456ec6df0e2a730$export$742c877aeb0f3dbd)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            spacing: "none",
            appearance: "link",
            onClick: onClickHandler
        }, "Try again?");
        return null;
    };
    return renderRetryButton();
};

});

parcelRegister("3Fja5", function(module, exports) {

$parcel$export(module.exports, "default", () => $12c4803ea9c49b19$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $12c4803ea9c49b19$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    forgeFieldErrorTextLabel: {
        "id": "issue-create-commons.common.forge.forge-field-message.forge-field-error-text-label",
        "defaultMessage": "We couldn't save the value of this custom field."
    },
    forgeFieldSuccessTextLabel: {
        "id": "issue-create-commons.common.forge.forge-field-message.forge-field-success-text-label",
        "defaultMessage": "Custom field value saved."
    },
    forgeFieldPendingTextLabel: {
        "id": "issue-create-commons.common.forge.forge-field-message.forge-field-pending-text-label",
        "defaultMessage": "Saving custom field value."
    }
});

});

parcelRegister("5kKVt", function(module, exports) {

$parcel$export(module.exports, "MessagePartsSeparationWrapper", () => $3e251578feb15a6b$export$16fadfc3d05f6fc0);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // For now, it only gives some space between the spinner and the message
// eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $3e251578feb15a6b$export$16fadfc3d05f6fc0 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_u5f31b66",
            __cmplp.className
        ])
    });
});

});



parcelRegister("l1bxK", function(module, exports) {

$parcel$export(module.exports, "reportForgeFailure", () => $81689cc689c69a39$export$e95b9e5003024a9c);

var $dh9qu = parcelRequire("dh9qu");

var $5VJL3 = parcelRequire("5VJL3");
const $81689cc689c69a39$export$e95b9e5003024a9c = (fieldType, modules, filteredOutModules)=>{
    const isExtensionFilteredOut = filteredOutModules.some((field)=>(0, $5VJL3.isForgeLegacyFieldType)(fieldType) ? field.id === (0, $5VJL3.getExtensionIdFromLegacyFieldType)(fieldType) : field.id === fieldType);
    const isEmptyForgeData = modules.length === 0 && filteredOutModules.length === 0;
    /*
        Not log error:
         * if the extensions is filtered out by display conditions or access narrowing
         * if the forge data is empty (when fetching error there is an excluded error, empty response is returned)
    */ if (isEmptyForgeData || isExtensionFilteredOut) return;
    (0, $dh9qu.fireOperationalFailedEvent)('issue-create', {
        error: Error('Forge extension passed to ForgeCustomField component is null or undefined'),
        renderContext: 'issue-create'
    });
};

});

parcelRegister("ewDib", function(module, exports) {

$parcel$export(module.exports, "FieldSkeleton", () => $d5c4832731156e8b$export$f102dad4aafe4ad4);
$parcel$export(module.exports, "default", () => $d5c4832731156e8b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $9VPEO = parcelRequire("9VPEO");

var $ajD9f = parcelRequire("ajD9f");
const $d5c4832731156e8b$export$f102dad4aafe4ad4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // eslint-disable-next-line jira/integration/enforce-data-testid-usage
        "data-test-id": "issue-create-commons.common.ui.loader.skeleton",
        "data-testid": "issue-create-commons.common.ui.loader.skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d5c4832731156e8b$var$Label, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ajD9f.StyledFieldSkeleton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d5c4832731156e8b$var$Description, null));
const $d5c4832731156e8b$var$IssueCreateLoader = ({ skeletonCount: skeletonCount })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, Array.from({
        length: skeletonCount
    }, (_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d5c4832731156e8b$export$f102dad4aafe4ad4, {
            key: `field-skeleton-${index}`
        })));
var $d5c4832731156e8b$export$2e2bcd8739ae039 = $d5c4832731156e8b$var$IssueCreateLoader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d5c4832731156e8b$var$Label = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $9VPEO.Skeleton), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3iv47k _1bsb68cl _19pkv47k _otyr12x7",
            __cmplp.className
        ])
    });
});
$d5c4832731156e8b$var$Label.displayName = 'LabelSkeleton';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d5c4832731156e8b$var$Description = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $9VPEO.Skeleton), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3ipxbi _1bsb1mjv",
            __cmplp.className
        ])
    });
});
$d5c4832731156e8b$var$Description.displayName = 'DescriptionSkeleton';

});
parcelRegister("9VPEO", function(module, exports) {

$parcel$export(module.exports, "getKeyframes", () => $fdf3dd89d5b95a51$export$b2b5e866b2fbf2ec);
$parcel$export(module.exports, "Skeleton", () => $fdf3dd89d5b95a51$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "Spacer", () => $fdf3dd89d5b95a51$export$d7a54cba636a8cd6);
$parcel$export(module.exports, "SkeletonCompiled", () => $fdf3dd89d5b95a51$export$dc84d515085190e);
$parcel$export(module.exports, "SpacerCompiled", () => $fdf3dd89d5b95a51$export$e477bb7d17087f28);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $kwce8 = parcelRequire("kwce8");

var $PdmhA = parcelRequire("PdmhA");
const $fdf3dd89d5b95a51$export$b2b5e866b2fbf2ec = (offsetX = 0)=>{
    const fromPositionX = -Math.abs(offsetX) - 300;
    const toPositionX = fromPositionX + 2000;
    return (0, $kwce8.keyframes)({
        '0%': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundPosition: `${fromPositionX}px 0`
        },
        '100%': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundPosition: `${toPositionX}px 0`
        }
    });
};
const $fdf3dd89d5b95a51$var$shimmer = $fdf3dd89d5b95a51$export$b2b5e866b2fbf2ec();
const $fdf3dd89d5b95a51$export$8f31e4c4a37b8e9c = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "ieqbub-0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        animationDelay: props.theme.animationDelay || '0s',
        animationDuration: '1s',
        animationFillMode: 'forwards',
        animationIterationCount: 'infinite',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        animationName: props.theme.animationName || $fdf3dd89d5b95a51$var$shimmer,
        animationTimingFunction: 'linear',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundColor: `var(--ds-skeleton, ${(0, $PdmhA).N30})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        backgroundImage: `linear-gradient( to right, ${`var(--ds-skeleton, ${(0, $PdmhA).N30})`} 10%, ${`var(--ds-skeleton-subtle, ${(0, $PdmhA).N20})`} 30%, ${`var(--ds-skeleton, ${(0, $PdmhA).N30})`} 50% )`,
        backgroundRepeat: 'no-repeat',
        borderRadius: '2px',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.height,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: props.width
    }));
const $fdf3dd89d5b95a51$export$d7a54cba636a8cd6 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "ieqbub-1"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.height
    }));
const $fdf3dd89d5b95a51$export$dc84d515085190e = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $9t7rW.default)(__cmplp.height),
            "--_1gljcou": (0, $9t7rW.default)(__cmplp.width)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ju25ru3m _5sag9cwz _1o51q7pw _tip812c5 _j7hq1245 _1pglp3kn _bfhkqrzy _1itk1ipn _12vemgnk _2rkoyh40 _4t3i1474 _1bsb1rkg",
            __cmplp.className
        ])
    });
});
const $fdf3dd89d5b95a51$export$e477bb7d17087f28 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $9t7rW.default)(__cmplp.height)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1474",
            __cmplp.className
        ])
    });
});

});

parcelRegister("ajD9f", function(module, exports) {

$parcel$export(module.exports, "StyledFieldSkeleton", () => $1bbd158b1c31d723$export$ed5de990fe261b7b);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $9VPEO = parcelRequire("9VPEO");
const $1bbd158b1c31d723$export$ed5de990fe261b7b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $9VPEO.Skeleton), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1ylp _1bsb1edt _otyr12x7",
            __cmplp.className
        ])
    });
});
$1bbd158b1c31d723$export$ed5de990fe261b7b.displayName = 'FieldSkeleton';

});


parcelRegister("6UjGk", function(module, exports) {

$parcel$export(module.exports, "generateKeyForRequiredFromUIM", () => $f357f017ac652237$export$920d96e4692b3d51);
const $f357f017ac652237$export$920d96e4692b3d51 = (parameters)=>{
    const { fieldId: fieldId, isRequiredFromUIM: isRequiredFromUIM } = parameters;
    return `${fieldId}-field_${isRequiredFromUIM ? '' : 'non-'}required_from_uim`;
};

});


parcelRegister("kMBLZ", function(module, exports) {

$parcel$export(module.exports, "mutateAffectedServicesField", () => $c08f172552985e53$export$c5ca3c9d905a51f0);
$parcel$export(module.exports, "transformDefaultAffectedServices", () => $c08f172552985e53$export$6f4e94c57a16128c);
$parcel$export(module.exports, "useFetchAffectedServicesName", () => $c08f172552985e53$export$9abe2f602f72a411);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");

var $6t5cq = parcelRequire("6t5cq");
const $c08f172552985e53$export$c5ca3c9d905a51f0 = (selectedAffectedServices, fieldId)=>({
        affectedServicesField: {
            fieldId: fieldId,
            affectedServices: selectedAffectedServices.map(({ value: value })=>({
                    serviceId: value
                }))
        }
    });
const $c08f172552985e53$export$6f4e94c57a16128c = (defaultAffectedServices)=>defaultAffectedServices.map((service)=>({
            value: service.serviceId
        }));
const $c08f172552985e53$export$9abe2f602f72a411 = ()=>{
    const [isLoading, setLoading] = (0, $eUqFw.useState)(false);
    const baseUrl = '';
    const handleFetch = (0, $eUqFw.useRef)((ids, setSelectedOptions)=>{
        setLoading(true);
        (0, $2OdyW.default)(`${baseUrl}/rest/service-registry-api/service`, {
            method: 'POST',
            body: JSON.stringify({
                ids: ids
            })
        }).then((response)=>{
            setLoading(false);
            setSelectedOptions((0, $6t5cq.mapServiceEntitiesToOptions)(response.services));
        }).catch((error)=>{
            setLoading(false);
            setSelectedOptions([]);
            (0, $guiFP.default)({
                meta: {
                    id: 'useFetchAffectedServicesName',
                    packageName: 'jiraIssueCreateCommons',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        });
    });
    return [
        {
            isLoading: isLoading
        },
        handleFetch.current
    ];
};

});


parcelRegister("j2ArP", function(module, exports) {

$parcel$export(module.exports, "default", () => $796d55c45fc02250$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");


var $4YYSX = parcelRequire("4YYSX");

var $icPhQ = parcelRequire("icPhQ");
var $6HoNR = parcelRequire("6HoNR");

var $ajD9f = parcelRequire("ajD9f");

var $7TaJX = parcelRequire("7TaJX");

var $ddgk1 = parcelRequire("ddgk1");
const $796d55c45fc02250$var$AssetsField = (props)=>{
    const { autoCompleteUrl: autoCompleteUrl, width: width, fieldProps: { value: value, onChange: onChange }, onCloseMenuOnScroll: // @ts-expect-error - TS2339 - Property 'onCloseMenuOnScroll' does not exist on type 'Props'.
    onCloseMenuOnScroll = (0, $7TaJX.closeMenuOnScroll), isDropdownMenuFixedAndLayered: // @ts-expect-error - TS2339 - Property 'isDropdownMenuFixedAndLayered' does not exist on type 'Props'.
    isDropdownMenuFixedAndLayered = false, error: error, fieldId: fieldId, defaultValue: defaultValue, isEditable: isEditable = true, nonEditableReason: nonEditableReason, selectedProject: selectedProject, selectedIssueType: selectedIssueType } = props;
    const [shouldFetchServiceName, setShouldFetchServiceName] = (0, $eUqFw.useState)(true);
    const [selectedOptions, setSelectedOptions] = (0, $eUqFw.useState)([]);
    const [{ isLoading: isLoading }, fetchAssetsName] = (0, $ddgk1.useFetchAssetsWithId)();
    const projectId = selectedProject?.value || '';
    let issueTypeId;
    if (selectedIssueType) issueTypeId = selectedIssueType.type === (0, $8b8bfa076f313cc4$export$92ab80c1dc9baf44) ? selectedIssueType.issueTypeId : selectedIssueType.value;
    /*
	 * Fetch the asset names using the IDs from the default values that were saved
	 * */ (0, $eUqFw.useEffect)(()=>{
        if (shouldFetchServiceName && defaultValue && defaultValue.length > 0) {
            /*
			 * defaultValue will be of type AssetEntityForServer but flow gives error
			 * when trying to typecast it
			 * */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const ids = defaultValue.map(({ serializedOrigin: serializedOrigin })=>serializedOrigin);
            fetchAssetsName(ids, setSelectedOptions);
            setShouldFetchServiceName(false);
        } else setSelectedOptions(value);
    }, [
        defaultValue,
        fetchAssetsName,
        setSelectedOptions,
        shouldFetchServiceName,
        value
    ]);
    const getAssetsEdit = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4YYSX.default), {
            autoCompleteUrl: autoCompleteUrl,
            onChange: onChange,
            value: selectedOptions,
            fieldId: fieldId,
            isInvalid: Boolean(error),
            isDisabled: !isEditable,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            issueTypeId: issueTypeId,
            projectId: projectId,
            fetchSuggestionsOnFocus: true
        });
    if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ajD9f.StyledFieldSkeleton), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, isEditable === false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: nonEditableReason?.message || ''
    }, getAssetsEdit()) : getAssetsEdit());
};
var $796d55c45fc02250$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    transformDefaultValue: (0, $ddgk1.transformDefaultAssets)
})($796d55c45fc02250$var$AssetsField);

});
parcelRegister("4YYSX", function(module, exports) {

$parcel$export(module.exports, "default", () => $7acf74a15a5cab89$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fm9CZ = parcelRequire("fm9CZ");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4NcaX = parcelRequire("4NcaX");

var $fO0l8 = parcelRequire("fO0l8");

var $bFzGY = parcelRequire("bFzGY");

var $dxcfv = parcelRequire("dxcfv");

var $c0gPD = parcelRequire("c0gPD");

var $fXLr8 = parcelRequire("fXLr8");
const $7acf74a15a5cab89$export$b7cbf126c81503e1 = 300;
// react-select with isMulti can return both null or an empty array for onChange depending on how
// it was cleared. Normalize this to an empty array https://github.com/JedWatson/react-select/issues/3632
const $7acf74a15a5cab89$var$normalizeOnChangeValues = (onChange)=>(updatedValues)=>onChange(updatedValues || []);
const $7acf74a15a5cab89$var$AssetsEdit = (props)=>{
    const { fieldId: fieldId, value: value, onChange: onChange, autoCompleteUrl: autoCompleteUrl, isInvalid: isInvalid, placeholder: placeholder = '', isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, onCloseMenuOnScroll: onCloseMenuOnScroll, isDisabled: isDisabled, issueTypeId: issueTypeId, projectId: projectId, fetchSuggestionsOnFocus: fetchSuggestionsOnFocus = false, classNamePrefix: classNamePrefix } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const accountId = (0, $dxcfv.useAccountId)();
    const [assetFilterName, setAssetFilterName] = (0, $eUqFw.useState)([]);
    const [, setAssetFilterConfigError] = (0, $eUqFw.useState)(false);
    const [lastFetchFailed, setLastFetchFailed] = (0, $eUqFw.useState)(false);
    const [defaultOptions, setDefaultOptions] = (0, $eUqFw.useState)([]);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const shouldFetchDefaultOptions = (0, $eUqFw.useRef)(true);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    /*
   * 1. Use customFieldId (eg. customfield_10085) to get asset filter contextId (eg. 10025)
   * 2. Use asset filter contextId to get asset filter name (eg. com.atlassian.servicedesk.connect.test-bed/mac.type.id)
   * 3. Use asset filter name for doing query in fetchAssets when user types in name of asset
   * */ (0, $eUqFw.useEffect)(()=>{
        (0, $fXLr8.fetchFieldFilterNames)(createAnalyticsEvent({}), fieldId, projectId, issueTypeId).then((result)=>{
            setAssetFilterName(result.map((res)=>`${res.appKey}/${res.originId}`));
        }).catch(()=>{
            setAssetFilterConfigError(true);
        });
    }, [
        fieldId,
        projectId,
        issueTypeId,
        createAnalyticsEvent
    ]);
    const searchAssets = (0, $eUqFw.useCallback)(async (query)=>{
        setLastFetchFailed(false);
        return (0, $fXLr8.fetchAssets)(query, autoCompleteUrl, accountId, assetFilterName, createAnalyticsEvent({})).catch(()=>{
            setLastFetchFailed(true);
            return [];
        });
    }, [
        autoCompleteUrl,
        accountId,
        assetFilterName,
        createAnalyticsEvent
    ]);
    const onFocus = async ()=>{
        if (shouldFetchDefaultOptions && defaultOptions && shouldFetchDefaultOptions.current && !defaultOptions.length) {
            shouldFetchDefaultOptions.current = false;
            setIsLoading && setIsLoading(true);
            const options = await searchAssets();
            setDefaultOptions && setDefaultOptions(options);
            setIsLoading && setIsLoading(false);
        }
    };
    const loadOptionsDebounced = (0, $fO0l8.default)(searchAssets, $7acf74a15a5cab89$export$b7cbf126c81503e1);
    const noOptionsMessage = (0, $eUqFw.useCallback)(()=>formatMessage(lastFetchFailed ? (0, $c0gPD.default).failedFetch : (0, $c0gPD.default).noMatches), [
        formatMessage,
        lastFetchFailed
    ]);
    const defaultOptionsProps = ()=>{
        if (fetchSuggestionsOnFocus) return {
            onFocus: onFocus,
            isLoading: isLoading,
            defaultOptions: defaultOptions
        };
        return {};
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fm9CZ.default), {
        fieldId: fieldId,
        loadOptions: loadOptionsDebounced,
        // @ts-expect-error - TS2322 - Type '(updatedValues: AssetOption[] | null) => void' is not assignable to type '(value: OptionsType<AssetOption>, action: ActionMeta<AssetOption>) => void'.
        onChange: $7acf74a15a5cab89$var$normalizeOnChangeValues(onChange),
        autoFocus: false,
        ...defaultOptionsProps(),
        isClearable: Boolean(value),
        isMulti: true,
        value: value,
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        noOptionsMessage: noOptionsMessage,
        placeholder: placeholder,
        // @ts-expect-error - TS2322 - Type '((e: ChangeEvent<HTMLElement>) => boolean) | undefined' is not assignable to type 'boolean | EventListener | undefined'.
        closeMenuOnScroll: onCloseMenuOnScroll,
        isDisabled: isDisabled,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        styles: (0, $4NcaX.defaultSelectStyles),
        classNamePrefix: classNamePrefix
    });
};
var $7acf74a15a5cab89$export$2e2bcd8739ae039 = $7acf74a15a5cab89$var$AssetsEdit;

});
parcelRegister("c0gPD", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e7b4167341253e1$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1e7b4167341253e1$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noMatches: {
        "id": "issue-field-assets.edit.no-matches",
        "defaultMessage": "No Matches"
    },
    failedFetch: {
        "id": "issue-field-assets.edit.failed-fetch",
        "defaultMessage": "Search failed. Please try again."
    }
});

});

parcelRegister("fXLr8", function(module, exports) {

$parcel$export(module.exports, "mapAssetEntityToAssetOptions", () => $1ee906068853f9b2$export$65ae210119db9fc5);
$parcel$export(module.exports, "fetchFieldFilterNames", () => $1ee906068853f9b2$export$668516cfbde240de);
$parcel$export(module.exports, "fetchAssets", () => $1ee906068853f9b2$export$6411291ff3741ab1);

var $53ciZ = parcelRequire("53ciZ");

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");
var $lRmyA = parcelRequire("lRmyA");
const $1ee906068853f9b2$export$65ae210119db9fc5 = (data)=>data.map(({ label: label, origin: origin })=>({
            label: label.value,
            value: `${origin.appKey}/${origin.originId}`
        }));
const $1ee906068853f9b2$export$668516cfbde240de = async (analyticsEvent, customFieldId, projectId, issueTypeId)=>{
    const queryString = issueTypeId === null || issueTypeId === undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify({
        projectId: projectId
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify({
        projectId: projectId,
        issueTypeId: issueTypeId
    });
    return (0, $2OdyW.default)(`/rest/assetinternalapi/latest/field/${customFieldId}/config?${queryString}`).then((response)=>response?.types || []).catch((error)=>{
        if (error.statusCode === 404) return Promise.resolve([]);
        (0, $guiFP.default)({
            event: analyticsEvent,
            error: error,
            meta: {
                packageName: 'jiraIssueFieldAssets',
                id: 'fetchFieldFilterNames'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    });
};
const $1ee906068853f9b2$export$6411291ff3741ab1 = async (inputValue = '', autoCompleteUrl, accountId, assetTypesFilter, analyticsEvent)=>{
    const queryParams = {
        prioritizedAssignee: accountId,
        query: inputValue,
        type: assetTypesFilter
    };
    const queryString = (0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).stringify(queryParams);
    return (0, $lRmyA.performGetRequest)(`${autoCompleteUrl}?${queryString}`).then((response)=>$1ee906068853f9b2$export$65ae210119db9fc5(response.values)).catch((error)=>{
        (0, $guiFP.default)({
            event: analyticsEvent,
            error: error,
            meta: {
                packageName: 'jiraIssueFieldAssets',
                id: 'fetchAssets'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    });
};

});


parcelRegister("ddgk1", function(module, exports) {

$parcel$export(module.exports, "mapAssetOptionsToAssetEntity", () => $154801e7aa265401$export$15c347a847be44f6);
$parcel$export(module.exports, "mutateAssetsFields", () => $154801e7aa265401$export$9067b9149eea3adb);
$parcel$export(module.exports, "transformDefaultAssets", () => $154801e7aa265401$export$42e188fe92589513);
$parcel$export(module.exports, "useFetchAssetsWithId", () => $154801e7aa265401$export$aa4b3faecd2997ab);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $2OdyW = parcelRequire("2OdyW");

var $fXLr8 = parcelRequire("fXLr8");
const $154801e7aa265401$export$15c347a847be44f6 = (options)=>options.map(({ value: value })=>({
            appKey: value.split('/')[0],
            originId: value.split('/')[1],
            serializedOrigin: value,
            value: value
        }));
const $154801e7aa265401$export$9067b9149eea3adb = (selectedAssets, fieldId)=>({
        assetsField: {
            fieldId: fieldId,
            assets: selectedAssets.map(({ value: value })=>({
                    appKey: value.split('/')[0],
                    originId: value.split('/')[1],
                    serializedOrigin: value,
                    value: value
                }))
        }
    });
const $154801e7aa265401$export$42e188fe92589513 = (defaultAssets)=>defaultAssets.map(({ serializedOrigin: serializedOrigin })=>({
            value: serializedOrigin
        }));
const $154801e7aa265401$export$aa4b3faecd2997ab = ()=>{
    const [isLoading, setLoading] = (0, $eUqFw.useState)(false);
    const handleFetch = (0, $eUqFw.useRef)((ids, setSelectedOptions)=>{
        setLoading(true);
        Promise.all(ids.map((id)=>(0, $2OdyW.default)(`/rest/assetapi/asset/${id}`))).then((response)=>{
            setLoading(false);
            setSelectedOptions((0, $fXLr8.mapAssetEntityToAssetOptions)(response));
        }).catch((error)=>{
            setLoading(false);
            setSelectedOptions([]);
            (0, $guiFP.default)({
                meta: {
                    id: 'useFetchAssetsWithId',
                    packageName: 'jiraIssueCreateCommons',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        });
    });
    return [
        {
            isLoading: isLoading
        },
        handleFetch.current
    ];
};

});


parcelRegister("6nTlM", function(module, exports) {

$parcel$export(module.exports, "AssigneeField", () => $deefb1800631e37b$export$7c52097ee36bd91);
$parcel$export(module.exports, "default", () => $deefb1800631e37b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $5JgJ2 = parcelRequire("5JgJ2");

var $qWkqR = parcelRequire("qWkqR");

var $lGLse = parcelRequire("lGLse");

var $icPhQ = parcelRequire("icPhQ");
var $6HoNR = parcelRequire("6HoNR");

var $lIor1 = parcelRequire("lIor1");

var $lgGuz = parcelRequire("lgGuz");

var $i8BXG = parcelRequire("i8BXG");
const $deefb1800631e37b$export$7c52097ee36bd91 = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { autoCompleteUrl: autoCompleteUrl = '', width: width, fieldProps: { value: value, onChange: onChange, id: id, ...fieldProps }, autoFocus: autoFocus = false, isReadOnly: isReadOnly = false } = props;
    const [{ data: loggedInUser }] = (0, $lGLse.useUserSubscriber)();
    const onAssignToMeClick = ()=>{
        onChange(loggedInUser);
    };
    const onAddAssigneeKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if (id && (event.key === 'Enter' || event.key === ' ')) {
            onChange(loggedInUser);
            // this focus was implemented with getElementById as there is problem here using ref in UserPicker
            // doesn't pass ref to input inside the component
            setTimeout(()=>document.getElementById(id)?.focus());
        }
    }, [
        id,
        loggedInUser,
        onChange
    ]);
    const showAssignToMe = loggedInUser && !isReadOnly;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($deefb1800631e37b$var$FieldContainer, {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $qWkqR.default), {
        ...fieldProps,
        value: value,
        onChange: onChange,
        shouldPreloadAssignToMe: true,
        autoCompleteUrl: autoCompleteUrl,
        enableAutomaticOption: true,
        autoFocus: autoFocus,
        isDisabled: isReadOnly,
        width: width,
        inputId: id,
        openMenuOnClick: true
    }), showAssignToMe && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "link",
        spacing: "none",
        onClick: onAssignToMeClick,
        onKeyDown: onAddAssigneeKeyDown,
        testId: "issue-create-commons.ui.assignee-field.assing-to-me-button"
    }, formatMessage((0, $lgGuz.default).assignToMe)));
};
var $deefb1800631e37b$export$2e2bcd8739ae039 // eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $6HoNR.withFormField)({
    validator: (0, $lIor1.validateAssigneeField),
    transformDefaultValue: (0, $i8BXG.transformDefaultAssigneeValue // @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<UserPickerFieldConfig, UserValue>, any>'.
    )
})($deefb1800631e37b$export$7c52097ee36bd91);
const $deefb1800631e37b$var$FieldContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $icPhQ.FieldContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1v091b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("qWkqR", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cfa16b75b646ee2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $jYnpi = parcelRequire("jYnpi");

var $4ksts = parcelRequire("4ksts");

var $hiBi9 = parcelRequire("hiBi9");

var $lO4Or = parcelRequire("lO4Or");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");


var $6cPKE = parcelRequire("6cPKE");

var $b5qOz = parcelRequire("b5qOz");

var $51p9V = parcelRequire("51p9V");

var $dRJbT = parcelRequire("dRJbT");

var $aE92Z = parcelRequire("aE92Z");
const $4cfa16b75b646ee2$var$DEFAULT_SEARCH_DEBOUCE_TIMEOUT = 300;
const $4cfa16b75b646ee2$var$InlineAssigneeFieldOptionsLoadExperience = new (0, $kDfSL.UFOExperience)('inline-assignee-picker.field-options-load', {
    type: (0, $12kyE.ExperienceTypes).Operation,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).Custom,
    category: 'inline-assignee-picker.field-options-load'
});
const $4cfa16b75b646ee2$var$InlineAssigneePickerEdit = ({ shouldPreloadAssignToMe: shouldPreloadAssignToMe = false, autoCompleteUrl: autoCompleteUrl, value: value = null, width: width, isDisabled: isDisabled, onFocus: onFocus, onBlur: onBlur, onChange: onChange, searchDebounceTimeout: searchDebounceTimeout = $4cfa16b75b646ee2$var$DEFAULT_SEARCH_DEBOUCE_TIMEOUT, enablePeopleInvite: enablePeopleInvite = true, enableAutomaticOption: enableAutomaticOption = false, isSubtle: isSubtle = false, appearance: appearance = 'normal', autoFocus: autoFocus = false, inputId: inputId, openMenuOnClick: openMenuOnClick = false, ...fieldProps })=>{
    const intl = (0, $4ksts.useIntlV2)();
    const self = (0, $eUqFw.useRef)({
        previousQuery: undefined
    }).current;
    const [{ data: users, loading: loading, error: error }, fetchUsers] = (0, $aE92Z.default)(autoCompleteUrl || '');
    const [assigneeValue, assigneeOptions] = (0, $dRJbT.useAssigneeOptions)(value, users, intl, shouldPreloadAssignToMe, self.previousQuery, enablePeopleInvite, enableAutomaticOption);
    const [, { openDrawer: openDrawer }] = (0, $hiBi9.useInvitePeopleDrawer)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        if (loading) {
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({
                actionSubject: 'inlineAssigneePicker',
                action: 'loading'
            }), 'inlineAssigneeOptions loading');
            $4cfa16b75b646ee2$var$InlineAssigneeFieldOptionsLoadExperience.start();
        }
        if (error) {
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({
                actionSubject: 'inlineAssigneePicker',
                action: 'failed'
            }), 'inlineAssigneeOptions failed');
            $4cfa16b75b646ee2$var$InlineAssigneeFieldOptionsLoadExperience.failure();
        }
        if (users.length) {
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({
                actionSubject: 'inlineAssigneePicker',
                action: 'loaded'
            }), 'inlineAssigneeOptions loaded');
            $4cfa16b75b646ee2$var$InlineAssigneeFieldOptionsLoadExperience.success();
        }
    }, [
        loading,
        error,
        users,
        createAnalyticsEvent
    ]);
    const handleSearch = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((query)=>{
            /*
     * Added extra condition to skip search. it's getting called during onBlur because previousQuery is undefined and query is empty string
     * then query !== self.previousQuery will be true and fetchUsers getting called unnecessarily
     */ if (query === '' && self.previousQuery === undefined) return;
            query !== self.previousQuery && fetchUsers(query);
            self.previousQuery = query;
        }, searchDebounceTimeout), // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        fetchUsers,
        searchDebounceTimeout,
        self.previousQuery
    ]);
    const handleOnFocus = (0, $eUqFw.useCallback)((sessionId)=>{
        onFocus?.(sessionId);
        if (!users || !users.length) fetchUsers();
    }, [
        onFocus,
        users,
        fetchUsers
    ]);
    const handleOnBlur = (0, $eUqFw.useCallback)((sessionId)=>{
        onBlur?.(sessionId);
        self.previousQuery = undefined;
    }, [
        onBlur,
        self
    ]);
    const handleOnChange = (0, $eUqFw.useCallback)((updatedValue, action)=>{
        if (!updatedValue || Array.isArray(updatedValue)) return;
        if ((0, $b5qOz.isInviteFromAssignEnabled)() && enablePeopleInvite && updatedValue.id === (0, $7a4a7348bcf111f0$export$d875316cb0cd94f7)) {
            openDrawer(createAnalyticsEvent ?? null, {
                inviteFlow: 'assignee'
            });
            onChange?.(value, action);
            return;
        }
        let newValue;
        if (updatedValue.id === (0, $7a4a7348bcf111f0$export$bdab9bfb39981463) || updatedValue.id === (0, $7a4a7348bcf111f0$export$d875316cb0cd94f7)) newValue = null;
        else newValue = (0, $6cPKE.getUserFromUserOption)(updatedValue);
        onChange?.(newValue, action);
    }, [
        enablePeopleInvite,
        onChange,
        openDrawer,
        value,
        createAnalyticsEvent
    ]);
    /*
   * user picker default opens on focus, fetchUsers has to be called onFocus
   * when openMenuOnClick is enabled then fetchUsers should be called during onOpen rather than onFocus
   */ const controlProps = openMenuOnClick ? {
        openMenuOnClick: openMenuOnClick,
        onOpen: handleOnFocus
    } : {
        onFocus: handleOnFocus
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jYnpi.UserPicker), {
        inputId: inputId,
        fieldId: (0, $lO4Or.ASSIGNEE_TYPE),
        autoFocus: autoFocus,
        placeholder: intl.formatMessage((0, $51p9V.default).searchForAssignee),
        isLoading: loading,
        options: assigneeOptions,
        value: assigneeValue,
        isMulti: false,
        isClearable: false,
        onBlur: handleOnBlur,
        onChange: handleOnChange,
        onInputChange: handleSearch,
        subtle: isSubtle,
        appearance: appearance,
        width: width,
        isDisabled: isDisabled,
        ariaLabelledBy: fieldProps['aria-labelledby'],
        UNSAFE_hasDraggableParentComponent: true,
        ...controlProps
    });
};
var $4cfa16b75b646ee2$export$2e2bcd8739ae039 = $4cfa16b75b646ee2$var$InlineAssigneePickerEdit;

});
parcelRegister("jYnpi", function(module, exports) {

$parcel$export(module.exports, "UserPicker", () => $a9ecfa55df3af3b8$export$83e0c73b09b3a9cd);

var $2jDha = parcelRequire("2jDha");

var $28t3A = parcelRequire("28t3A");
var $5wCDk = parcelRequire("5wCDk");

var $uMitL = parcelRequire("uMitL");

var $eUqFw = parcelRequire("eUqFw");

var $3IZWd = parcelRequire("3IZWd");

var $dTS4n = parcelRequire("dTS4n");

var $4dR1n = parcelRequire("4dR1n");

var $fiLGD = parcelRequire("fiLGD");

var $bxvbM = parcelRequire("bxvbM");

var $1mZCo = parcelRequire("1mZCo");

var $ToOs1 = parcelRequire("ToOs1");

var $a1Z9P = parcelRequire("a1Z9P");

var $hompL = parcelRequire("hompL");
class $a9ecfa55df3af3b8$export$164f4d95e5d7e2f5 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(props){
        super(props);
        this.ufoId = (0, $hompL.v4)();
        const experienceForId = (0, $a1Z9P.userPickerRenderedUfoExperience).getInstance(this.ufoId);
        experienceForId.start();
    }
    static{
        this.defaultProps = {
            width: 350,
            isMulti: false
        };
    }
    componentDidMount() {
        const experienceForId = (0, $a1Z9P.userPickerRenderedUfoExperience).getInstance(this.ufoId);
        // Send UFO success if the experience is still in progress i.e. hasn't failed
        if ([
            (0, $uMitL.UFOExperienceState).IN_PROGRESS.id,
            (0, $uMitL.UFOExperienceState).STARTED.id
        ].includes(experienceForId.state.id)) experienceForId.success();
    }
    render() {
        const { emailLabel: emailLabel, allowEmail: allowEmail, suggestEmailsForDomain: suggestEmailsForDomain, isMulti: isMulti, isValidEmail: isValidEmail, anchor: anchor, menuPortalTarget: menuPortalTarget, menuPosition: menuPosition, menuShouldBlockScroll: menuShouldBlockScroll, captureMenuScroll: captureMenuScroll, closeMenuOnScroll: closeMenuOnScroll, loadUserSource: loadUserSource, required: required = false } = this.props;
        const width = this.props.width;
        const SelectComponent = allowEmail ? (0, $28t3A.default) : (0, $5wCDk.default);
        const creatableProps = suggestEmailsForDomain ? (0, $bxvbM.getCreatableSuggestedEmailProps)(suggestEmailsForDomain, isValidEmail) : (0, $fiLGD.getCreatableProps)(isValidEmail);
        const defaultPickerProps = {
            closeMenuOnScroll: closeMenuOnScroll,
            menuPortalTarget: menuPortalTarget,
            menuPosition: menuPosition,
            menuShouldBlockScroll: menuShouldBlockScroll,
            captureMenuScroll: captureMenuScroll,
            required: required
        };
        const pickerProps = allowEmail ? {
            ...defaultPickerProps,
            ...creatableProps,
            emailLabel: emailLabel
        } : {
            ...defaultPickerProps
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a1Z9P.UfoErrorBoundary), {
            id: this.ufoId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1mZCo.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ToOs1.ExusUserSourceProvider), {
            fetchUserSource: loadUserSource
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3IZWd.BaseUserPickerWithoutAnalytics), {
            ...this.props,
            width: width,
            SelectComponent: SelectComponent,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            styles: (0, $dTS4n.getStyles)(width, isMulti, this.props.appearance === 'compact', this.props.styles),
            components: (0, $4dR1n.getComponents)(isMulti, anchor),
            pickerProps: pickerProps
        }))));
    }
}
const $a9ecfa55df3af3b8$export$83e0c73b09b3a9cd = (0, $2jDha.default)()($a9ecfa55df3af3b8$export$164f4d95e5d7e2f5);

});
parcelRegister("3IZWd", function(module, exports) {

$parcel$export(module.exports, "BaseUserPickerWithoutAnalytics", () => $f8b053239afa9fd6$export$b4ff48c8d43b18c3);

var $2jDha = parcelRequire("2jDha");

var $uMitL = parcelRequire("uMitL");

var $dxIU5 = parcelRequire("dxIU5");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $hompL = parcelRequire("hompL");

var $bjvv3 = parcelRequire("bjvv3");

var $b9ITu = parcelRequire("b9ITu");

var $hAQEH = parcelRequire("hAQEH");

var $cHYJ6 = parcelRequire("cHYJ6");

var $a1Z9P = parcelRequire("a1Z9P");
const $f8b053239afa9fd6$var$loadingMessage = ()=>null;
const $f8b053239afa9fd6$var$classNamePrefix = 'fabric-user-picker';
class $f8b053239afa9fd6$export$b4ff48c8d43b18c3 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.defaultProps = {
            isMulti: false,
            subtle: false,
            noBorder: false,
            textFieldBackgroundColor: false,
            isClearable: true,
            loadOptionsErrorMessage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $hAQEH.messages).errorMessage),
            openMenuOnClick: false
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const derivedState = {};
        if (nextProps.isDisabled || nextProps.disableInput) derivedState.menuIsOpen = false;
        if (nextProps.open !== undefined) derivedState.menuIsOpen = nextProps.open;
        if (nextProps.value !== undefined) derivedState.value = (0, $cHYJ6.optionToSelectableOptions)(nextProps.value);
        else if ((0, $cHYJ6.isDefaultValuePopulated)(nextProps.defaultValue) && !prevState.isDefaultSet) {
            derivedState.value = (0, $cHYJ6.optionToSelectableOptions)(nextProps.defaultValue);
            derivedState.isDefaultSet = true;
        }
        if (nextProps.search !== undefined && nextProps.search !== prevState.inputValue) derivedState.inputValue = nextProps.search;
        if (nextProps.options !== undefined) derivedState.options = nextProps.options;
        return derivedState;
    }
    constructor(props){
        super(props);
        this.getSessionId = ()=>this.session && this.session.id ? this.session.id : undefined;
        this.withSelectRef = (callback)=>()=>{
                if (this.selectRef) callback(this.selectRef);
            };
        this.nextOption = this.withSelectRef((select)=>select.focusOption('down'));
        this.previousOption = this.withSelectRef((select)=>select.focusOption('up'));
        this.focus = ()=>{
            if (this.selectRef && this.selectRef.focus) this.selectRef.focus();
        };
        this.blur = ()=>{
            if (this.selectRef && this.selectRef.blur) this.selectRef.blur();
        };
        this.selectOption = this.withSelectRef((select)=>{
            const focusedOption = select.state.focusedOption;
            select.selectOption(focusedOption);
        });
        // value = null if user deletes the last item in the user picker
        this.handleChange = (value, { action: action, removedValue: removedValue, option: option })=>{
            if (removedValue && removedValue.data.fixed) return;
            this.resetInputState();
            const { onChange: onChange, onSelection: onSelection, onClear: onClear, isMulti: isMulti } = this.props;
            (0, $cHYJ6.callCallback)(onChange, (0, $cHYJ6.extractOptionValue)(value), action);
            switch(action){
                case 'select-option':
                    if (value) (0, $cHYJ6.callCallback)(onSelection, (0, $cHYJ6.extractOptionValue)(value), this.getSessionId(), this);
                    this.fireEvent((0, $bjvv3.selectEvent), isMulti ? option : value);
                    this.session = isMulti ? (0, $bjvv3.startSession)() : undefined;
                    break;
                case 'clear':
                    (0, $cHYJ6.callCallback)(onClear);
                    this.fireEvent((0, $bjvv3.clearEvent));
                    break;
                case 'remove-value':
                case 'pop-value':
                    if (removedValue) this.fireEvent((0, $bjvv3.deleteEvent), removedValue.data);
                    break;
            }
            this.fireEvent((0, $bjvv3.searchedEvent));
            if (removedValue && this.state.value && Array.isArray(this.state.value)) {
                const remainingValues = this.state.value.filter((val)=>val.data.id !== removedValue.data.id);
                this.setState({
                    value: remainingValues ? remainingValues : [],
                    menuIsOpen: true
                });
            }
            if (!this.props.value) this.setState({
                value: value ? value : []
            });
        };
        this.handleSelectRef = (ref)=>{
            this.selectRef = ref;
        };
        this.addOptions = (0, $b9ITu.batchByKey)((request, newOptions)=>{
            const { resolving: resolving } = this.state;
            this.setState(({ inflightRequest: inflightRequest, options: options, count: count })=>{
                if (inflightRequest.toString() === request) return {
                    options: (resolving ? options : []).concat(newOptions.reduce((nextOptions, item)=>Array.isArray(item) ? nextOptions.concat(item[0]) : nextOptions.concat(item), [])),
                    count: count - newOptions.length,
                    resolving: count - newOptions.length !== 0
                };
                return null;
            });
        });
        this.handleLoadOptionsError = ()=>{
            const { count: count } = this.state;
            const newCount = count - 1;
            const resolving = newCount !== 0;
            let showError = false;
            if (!resolving) showError = true;
            this.setState({
                count: newCount,
                resolving: resolving,
                showError: showError
            });
            this.fireEvent((0, $bjvv3.failedEvent));
        };
        this.debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((search)=>{
            const { loadOptions: loadOptions } = this.props;
            if (loadOptions) this.setState(({ inflightRequest: previousRequest })=>{
                const inflightRequest = previousRequest + 1;
                const result = this.session && this.session.id ? loadOptions(search, this.session.id) : loadOptions(search);
                const addOptions = this.addOptions.bind(this, inflightRequest.toString());
                let count = 0;
                if ((0, $cHYJ6.isIterable)(result)) for (const value of result){
                    Promise.resolve(value).then(addOptions).catch(this.handleLoadOptionsError);
                    count++;
                }
                else {
                    Promise.resolve(result).then(addOptions).catch(this.handleLoadOptionsError);
                    count++;
                }
                return {
                    inflightRequest: inflightRequest,
                    count: count,
                    resolving: count !== 0,
                    options: []
                };
            });
        }, 200);
        this.abortOptionsShownUfoExperience = ()=>{
            if (this.optionsShownUfoExperienceInstance.state.id === (0, $uMitL.UFOExperienceState).STARTED.id) // There may be an existing UFO timing running from previous key entry or focus,
            // so abort it and restart it just in case.
            this.optionsShownUfoExperienceInstance.abort();
        };
        this.startOptionsShownUfoExperience = ()=>{
            this.abortOptionsShownUfoExperience();
            this.optionsShownUfoExperienceInstance.start();
        };
        this.executeLoadOptions = (search)=>{
            const { loadOptions: loadOptions } = this.props;
            if (loadOptions) this.setState({
                resolving: true,
                showError: false
            }, ()=>this.debouncedLoadOptions(search));
        };
        this.handleFocus = (event)=>{
            const { value: value, menuIsOpen: menuIsOpen } = this.state;
            if (!menuIsOpen || !this.session) this.startSession();
            this.startOptionsShownUfoExperience();
            (0, $cHYJ6.callCallback)(this.props.onFocus, this.getSessionId());
            if (!this.isMenuOpenOnClickForSingleSelect) {
                this.setState({
                    menuIsOpen: true
                });
                if (!this.props.isMulti && (0, $cHYJ6.isSingleValue)(value)) {
                    const input = event.target;
                    this.setState({
                        inputValue: value.label
                    }, ()=>{
                        if (input instanceof HTMLInputElement) input.setSelectionRange(0, value.label.length);
                    });
                }
            }
        };
        this.resetInputState = ()=>{
            // Prevent filter if query typed, then blurred with no selection
            this.setState({
                inputValue: ''
            });
            (0, $cHYJ6.callCallback)(this.props.onInputChange, '', this.getSessionId());
        };
        this.handleBlur = ()=>{
            (0, $cHYJ6.callCallback)(this.props.onBlur, this.getSessionId());
            if ((0, $cHYJ6.isPopupUserPickerByComponent)(this.props.SelectComponent)) return;
            this.resetInputState();
            this.abortOptionsShownUfoExperience();
            this.setState({
                menuIsOpen: false,
                initialFocusHandled: false,
                options: []
            });
        };
        this.handleOpen = ()=>{
            (0, $cHYJ6.callCallback)(this.props.onOpen, this.getSessionId());
            this.setState({
                menuIsOpen: true
            });
        };
        this.handleClose = ()=>{
            this.resetInputState();
            (0, $cHYJ6.callCallback)(this.props.onClose, this.getSessionId());
            this.setState({
                menuIsOpen: false,
                options: []
            });
        };
        this.handleInputChange = (search, { action: action })=>{
            if (action === 'input-change' || action === 'set-value') {
                (0, $cHYJ6.callCallback)(this.props.onInputChange, search, this.getSessionId());
                this.setState({
                    inputValue: search
                });
                this.startOptionsShownUfoExperience();
            }
        };
        this.fireEvent = (eventCreator, ...args)=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) (0, $bjvv3.createAndFireEventInElementsChannel)(eventCreator(this.props, this.state, this.session, this.journeyId, ...args))(createAnalyticsEvent);
        };
        this.startSession = ()=>{
            this.session = (0, $bjvv3.startSession)();
            this.journeyId = this.getSessionId();
            this.fireEvent((0, $bjvv3.focusEvent));
        };
        this.handleKeyDown = (event)=>{
            if (!this.isMenuOpenOnClickForSingleSelect) {
                // Escape
                if (event.keyCode === 27) this.blur();
                // Space
                if (event.keyCode === 32 && !this.state.inputValue) {
                    event.preventDefault();
                    !this.props.disableInput && this.setState({
                        inputValue: ' '
                    });
                }
            }
            if (this.session) {
                this.session.lastKey = event.keyCode;
                switch(event.keyCode){
                    // KeyUp 38
                    case 38:
                        this.session.upCount++;
                        break;
                    // KeyDown 40
                    case 40:
                        this.session.downCount++;
                        break;
                }
            }
            this.props.onKeyDown && this.props.onKeyDown(event);
        };
        this.handleClearIndicatorHover = (hoveringClearIndicator)=>{
            this.setState({
                hoveringClearIndicator: hoveringClearIndicator
            });
        };
        this.getOptions = ()=>{
            const options = (0, $cHYJ6.getOptions)(this.state.options) || [];
            const { maxOptions: maxOptions, isMulti: isMulti } = this.props;
            if (maxOptions === 0) return [];
            if (maxOptions && maxOptions > 0 && maxOptions < options.length) {
                const { value: value } = this.state;
                let filteredOptions = options;
                // Filter out previously selected options
                if (isMulti && Array.isArray(value)) {
                    const valueIds = value.map((item)=>item.data.id);
                    filteredOptions = options.filter((option)=>valueIds.indexOf(option.data.id) === -1);
                }
                return filteredOptions.slice(0, maxOptions);
            }
            return options;
        };
        this.getAppearance = ()=>this.props.appearance ? this.props.appearance : 'normal';
        this.handleClickDraggableParentComponent = ()=>{
            if (this.state.initialFocusHandled) {
                // As <Select /> is already focused, calling this.selectRef.current.focus() again no longer triggers its own handlers (i.e. onMenuOpen, onMenuClose)
                // We have to manually handle the open and close states of the dropdown menu based on a user's click from this point onwards to prevent the bug
                if (this.state.menuIsOpen) this.handleClose();
                else this.handleOpen();
            } else if (!this.state.menuIsOpen && !this.isMenuOpenOnClickForSingleSelect) {
                // Trigger focus state when ValueContainer is clicked for the first time
                // The focused state will then invoke <Select /> instance's own handlers (e.g. onMenuOpen, onMenuClose)
                // to manage the state of the dropdown menu
                this.focus();
                this.setState(()=>({
                        initialFocusHandled: true
                    }));
            }
        };
        this.state = {
            options: [],
            isDefaultSet: false,
            inflightRequest: 0,
            count: 0,
            hoveringClearIndicator: false,
            menuIsOpen: !!this.props.open,
            inputValue: props.search || '',
            resolving: false,
            showError: false,
            initialFocusHandled: false
        };
        this.optionsShownUfoExperienceInstance = (0, $a1Z9P.userPickerOptionsShownUfoExperience).getInstance((0, $hompL.v4)());
    }
    get isMenuOpenOnClickForSingleSelect() {
        return this.props.openMenuOnClick && !this.props.isMulti;
    }
    componentDidMount() {
        const { open: open, search: search } = this.props;
        // load options when the picker open
        if (open) {
            if (!this.session) this.startSession();
            this.executeLoadOptions(search);
        }
    }
    componentDidUpdate(_, prevState) {
        const { menuIsOpen: menuIsOpen, options: options, resolving: resolving, count: count, inputValue: inputValue } = this.state;
        // Create a new session when the menu is opened and there is no session
        if (menuIsOpen && !prevState.menuIsOpen && !this.session) this.startSession();
        // Load options when user picker opens or when input value changes
        if (menuIsOpen && !prevState.menuIsOpen || inputValue !== prevState.inputValue) this.executeLoadOptions(inputValue);
        if (!menuIsOpen && prevState.menuIsOpen && this.session) {
            this.fireEvent((0, $bjvv3.cancelEvent), prevState);
            this.session = undefined;
        }
        if (menuIsOpen && (!prevState.menuIsOpen && options.length > 0 || options.length !== prevState.options.length)) this.fireEvent((0, $bjvv3.searchedEvent));
        if (this.state.inputValue !== prevState.inputValue) {
            if (this.session) this.session.inputChangeTime = Date.now();
        }
        if (menuIsOpen && (!_.loadOptions || prevState.menuIsOpen) && count === 0 && !resolving && [
            (0, $uMitL.UFOExperienceState).STARTED.id,
            (0, $uMitL.UFOExperienceState).IN_PROGRESS.id
        ].includes(this.optionsShownUfoExperienceInstance.state.id)) this.optionsShownUfoExperienceInstance.success();
    }
    get ariaProps() {
        const ariaLabels = Object.keys(this.props).filter((key)=>key.startsWith('aria-'));
        const props = {
            ...this.props
        };
        return ariaLabels.reduce((obj, key)=>({
                ...obj,
                [key]: props[key]
            }), {});
    }
    render() {
        const { isMulti: isMulti, isLoading: isLoading, subtle: subtle, noBorder: noBorder, placeholder: placeholder, isClearable: isClearable, isDisabled: isDisabled, clearValueLabel: clearValueLabel, menuMinWidth: menuMinWidth, menuPortalTarget: menuPortalTarget, loadOptionsErrorMessage: loadOptionsErrorMessage, addMoreMessage: addMoreMessage, noOptionsMessage: noOptionsMessage, footer: footer, disableInput: disableInput, components: components, pickerProps: pickerProps, SelectComponent: SelectComponent, styles: styles, autoFocus: autoFocus, fieldId: fieldId, inputId: inputId, maxPickerHeight: maxPickerHeight, textFieldBackgroundColor: textFieldBackgroundColor, ariaLabelledBy: ariaLabelledBy, ariaLive: ariaLive, ariaLabel: ariaLabel, name: name, header: header, required: required, UNSAFE_hasDraggableParentComponent: UNSAFE_hasDraggableParentComponent, placeholderAvatar: placeholderAvatar } = this.props;
        const { count: count, hoveringClearIndicator: hoveringClearIndicator, menuIsOpen: menuIsOpen, value: value, inputValue: inputValue, resolving: resolving, showError: showError } = this.state;
        const appearance = this.getAppearance();
        // these props override the default select menu open and close
        const menuOpenDeciderProps = {
            ...!this.isMenuOpenOnClickForSingleSelect && {
                menuIsOpen: menuIsOpen,
                blurInputOnSelect: !isMulti,
                openMenuOnFocus: true
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SelectComponent, {
            name: name,
            value: value,
            autoFocus: autoFocus !== undefined ? autoFocus : menuIsOpen,
            "aria-labelledby": ariaLabelledBy,
            "aria-label": ariaLabel,
            "aria-live": ariaLive,
            "aria-required": required,
            required: required,
            ref: this.handleSelectRef,
            isMulti: isMulti,
            options: this.getOptions(),
            styles: styles,
            enableAnimation: isMulti,
            components: components,
            inputValue: inputValue,
            isLoading: count > 0 || resolving || isLoading,
            loadingMessage: $f8b053239afa9fd6$var$loadingMessage,
            menuPlacement: "auto",
            placeholder: placeholder ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $hAQEH.messages).placeholder),
            addMoreMessage: addMoreMessage,
            classNamePrefix: $f8b053239afa9fd6$var$classNamePrefix,
            hoveringClearIndicator: hoveringClearIndicator,
            appearance: appearance,
            isClearable: isClearable,
            noBorder: noBorder,
            subtle: subtle,
            closeMenuOnSelect: !isMulti,
            noOptionsMessage: showError ? loadOptionsErrorMessage : typeof noOptionsMessage === 'function' ? noOptionsMessage : ()=>noOptionsMessage,
            footer: footer,
            isDisabled: isDisabled,
            isFocused: menuIsOpen,
            backspaceRemovesValue: isMulti,
            filterOption: null,
            clearValueLabel: clearValueLabel,
            menuMinWidth: menuMinWidth,
            menuPortalTarget: menuPortalTarget,
            disableInput: disableInput || isDisabled,
            instanceId: fieldId,
            inputId: inputId,
            onChange: this.handleChange,
            onMenuOpen: this.handleOpen,
            onFocus: this.handleFocus,
            onBlur: this.handleBlur,
            onMenuClose: this.handleClose,
            onInputChange: this.handleInputChange,
            onClearIndicatorHover: this.handleClearIndicatorHover,
            onKeyDown: this.handleKeyDown,
            maxPickerHeight: maxPickerHeight,
            textFieldBackgroundColor: textFieldBackgroundColor,
            header: header,
            placeholderAvatar: placeholderAvatar,
            ...this.ariaProps,
            ...pickerProps,
            ...UNSAFE_hasDraggableParentComponent && {
                onValueContainerClick: this.handleClickDraggableParentComponent
            },
            ...menuOpenDeciderProps
        });
    }
}
const $f8b053239afa9fd6$export$d099ade7b4f4d2a4 = (0, $2jDha.default)()($f8b053239afa9fd6$export$b4ff48c8d43b18c3);

});
parcelRegister("bjvv3", function(module, exports) {

$parcel$export(module.exports, "startSession", () => $72125c7ae0a2c4a6$export$c0d84948cecf78d8);
$parcel$export(module.exports, "createAndFireEventInElementsChannel", () => $72125c7ae0a2c4a6$export$53eef0dcd9611650);
$parcel$export(module.exports, "focusEvent", () => $72125c7ae0a2c4a6$export$e7818c470f37c4bd);
$parcel$export(module.exports, "clearEvent", () => $72125c7ae0a2c4a6$export$7b5800e732182efb);
$parcel$export(module.exports, "deleteEvent", () => $72125c7ae0a2c4a6$export$95711ec6c6227e9a);
$parcel$export(module.exports, "cancelEvent", () => $72125c7ae0a2c4a6$export$e9caaaecfee38128);
$parcel$export(module.exports, "selectEvent", () => $72125c7ae0a2c4a6$export$48143d759475d90f);
$parcel$export(module.exports, "searchedEvent", () => $72125c7ae0a2c4a6$export$911fb7184b6037eb);
$parcel$export(module.exports, "failedEvent", () => $72125c7ae0a2c4a6$export$c2aec355fef65c9c);
$parcel$export(module.exports, "userInfoEvent", () => $72125c7ae0a2c4a6$export$f541f04954b0c11e);

var $hM7RE = parcelRequire("hM7RE");

var $hompL = parcelRequire("hompL");

var $cHYJ6 = parcelRequire("cHYJ6");
const $72125c7ae0a2c4a6$var$packageName = undefined;
const $72125c7ae0a2c4a6$var$packageVersion = undefined;
const $72125c7ae0a2c4a6$var$UUID_REGEXP_TEAMS_GROUPS = /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $72125c7ae0a2c4a6$var$UUID_REGEXP_OLD_AAID = /^[a-fA-F0-9]{1,8}:[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;
const $72125c7ae0a2c4a6$var$UUID_REGEXP_NEW_AAID = /^[a-fA-F0-9]{24,24}$/;
const $72125c7ae0a2c4a6$export$c0d84948cecf78d8 = ()=>({
        id: (0, $hompL.v4)(),
        start: Date.now(),
        inputChangeTime: Date.now(),
        upCount: 0,
        downCount: 0,
        lastKey: undefined
    });
const $72125c7ae0a2c4a6$export$53eef0dcd9611650 = (0, $hM7RE.default)('fabric-elements');
const $72125c7ae0a2c4a6$var$createEvent = (eventType, action, actionSubject, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        attributes: {
            packageName: $72125c7ae0a2c4a6$var$packageName,
            packageVersion: $72125c7ae0a2c4a6$var$packageVersion,
            ...attributes
        }
    });
const $72125c7ae0a2c4a6$var$checkValidId = (id)=>{
    return $72125c7ae0a2c4a6$var$UUID_REGEXP_NEW_AAID.test(id) || $72125c7ae0a2c4a6$var$UUID_REGEXP_OLD_AAID.test(id) || $72125c7ae0a2c4a6$var$UUID_REGEXP_TEAMS_GROUPS.test(id);
};
const $72125c7ae0a2c4a6$var$optionData2Analytics = (option)=>{
    const { id: id, type: type } = option;
    // id's of email types are emails which is PII
    const validatedData = {
        id: $72125c7ae0a2c4a6$var$checkValidId(id) ? id : null,
        type: type || null
    };
    if ((0, $cHYJ6.isExternalUser)(option)) return {
        ...validatedData,
        type: 'external_user',
        sources: option.sources,
        externalUserType: option.externalUserType
    };
    if ((0, $cHYJ6.isCustom)(option) && option.analyticsType) return {
        ...validatedData,
        type: option.analyticsType
    };
    return validatedData;
};
const $72125c7ae0a2c4a6$var$buildValueForAnalytics = (value)=>{
    if (value) {
        const valueToConvert = Array.isArray(value) ? value : [
            value
        ];
        return valueToConvert.map(({ data: data })=>$72125c7ae0a2c4a6$var$optionData2Analytics(data));
    }
    return [];
};
const $72125c7ae0a2c4a6$var$createDefaultPickerAttributes = (props, session, journeyId)=>({
        context: props.fieldId,
        sessionId: $72125c7ae0a2c4a6$var$sessionId(session),
        pickerType: $72125c7ae0a2c4a6$var$pickerType(props),
        journeyId: journeyId
    });
const $72125c7ae0a2c4a6$export$e7818c470f37c4bd = (props, state, session, journeyId)=>$72125c7ae0a2c4a6$var$createEvent('ui', 'focused', 'userPicker', {
        ...$72125c7ae0a2c4a6$var$createDefaultPickerAttributes(props, session, journeyId),
        values: $72125c7ae0a2c4a6$var$buildValueForAnalytics(state.value)
    });
const $72125c7ae0a2c4a6$export$7b5800e732182efb = (props, state, session, journeyId)=>$72125c7ae0a2c4a6$var$createEvent('ui', 'cleared', 'userPicker', {
        ...$72125c7ae0a2c4a6$var$createDefaultPickerAttributes(props, session, journeyId),
        pickerOpen: state.menuIsOpen,
        values: $72125c7ae0a2c4a6$var$values(state)
    });
const $72125c7ae0a2c4a6$export$95711ec6c6227e9a = (props, state, session, journeyId, ...args)=>$72125c7ae0a2c4a6$var$createEvent('ui', 'deleted', 'userPickerItem', {
        context: props.fieldId,
        sessionId: $72125c7ae0a2c4a6$var$sessionId(session),
        journeyId: journeyId,
        value: $72125c7ae0a2c4a6$var$optionData2Analytics(args[0]),
        pickerOpen: state.menuIsOpen
    });
const $72125c7ae0a2c4a6$export$e9caaaecfee38128 = (props, _, session, journeyId, ...args)=>$72125c7ae0a2c4a6$var$createEvent('ui', 'cancelled', 'userPicker', {
        ...$72125c7ae0a2c4a6$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $72125c7ae0a2c4a6$var$sessionDuration(session),
        queryLength: $72125c7ae0a2c4a6$var$queryLength(args[0]),
        spaceInQuery: $72125c7ae0a2c4a6$var$spaceInQuery(args[0]),
        upKeyCount: $72125c7ae0a2c4a6$var$upKeyCount(session),
        downKeyCount: $72125c7ae0a2c4a6$var$downKeyCount(session)
    });
const $72125c7ae0a2c4a6$export$48143d759475d90f = (props, state, session, journeyId, ...args)=>{
    return $72125c7ae0a2c4a6$var$createEvent('ui', $72125c7ae0a2c4a6$var$selectEventType(session), 'userPicker', {
        ...$72125c7ae0a2c4a6$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $72125c7ae0a2c4a6$var$sessionDuration(session),
        position: $72125c7ae0a2c4a6$var$position(state, args[0]),
        queryLength: $72125c7ae0a2c4a6$var$queryLength(state),
        spaceInQuery: $72125c7ae0a2c4a6$var$spaceInQuery(state),
        upKeyCount: $72125c7ae0a2c4a6$var$upKeyCount(session),
        downKeyCount: $72125c7ae0a2c4a6$var$downKeyCount(session),
        result: $72125c7ae0a2c4a6$var$result(args[0]),
        numberOfResults: $72125c7ae0a2c4a6$var$numberOfResults(state)
    });
};
const $72125c7ae0a2c4a6$export$911fb7184b6037eb = (props, state, session, journeyId)=>{
    const searchResults = $72125c7ae0a2c4a6$var$results(state);
    return $72125c7ae0a2c4a6$var$createEvent('operational', 'searched', 'userPicker', {
        ...$72125c7ae0a2c4a6$var$createDefaultPickerAttributes(props, session, journeyId),
        sessionDuration: $72125c7ae0a2c4a6$var$sessionDuration(session),
        durationSinceInputChange: $72125c7ae0a2c4a6$var$durationSinceInputChange(session),
        queryLength: $72125c7ae0a2c4a6$var$queryLength(state),
        isLoading: $72125c7ae0a2c4a6$var$isLoading(props, state),
        results: searchResults,
        numberOfResults: searchResults.length
    });
};
const $72125c7ae0a2c4a6$export$c2aec355fef65c9c = (props, _, session, journeyId)=>$72125c7ae0a2c4a6$var$createEvent('operational', 'failed', 'userPicker', {
        ...$72125c7ae0a2c4a6$var$createDefaultPickerAttributes(props, session, journeyId)
    });
const $72125c7ae0a2c4a6$export$f541f04954b0c11e = (sources, accountId)=>$72125c7ae0a2c4a6$var$createEvent('ui', 'displayed', 'userInfo', {
        sources: sources,
        // accountId can be PII if it is an email so check that it's an AAID first
        accountId: $72125c7ae0a2c4a6$var$checkValidId(accountId) ? accountId : null
    });
function $72125c7ae0a2c4a6$var$queryLength(state) {
    return state.inputValue.length;
}
function $72125c7ae0a2c4a6$var$selectEventType(session) {
    return session && session.lastKey === 13 ? 'pressed' : 'clicked';
}
function $72125c7ae0a2c4a6$var$upKeyCount(session) {
    return session ? session.upCount : null;
}
function $72125c7ae0a2c4a6$var$downKeyCount(session) {
    return session ? session.downCount : null;
}
function $72125c7ae0a2c4a6$var$spaceInQuery(state) {
    return state.inputValue.indexOf(' ') !== -1;
}
function $72125c7ae0a2c4a6$var$sessionDuration(session) {
    return session ? Date.now() - session.start : null;
}
function $72125c7ae0a2c4a6$var$durationSinceInputChange(session) {
    return session ? Date.now() - session.inputChangeTime : null;
}
function $72125c7ae0a2c4a6$var$sessionId(session) {
    return session && session.id;
}
function $72125c7ae0a2c4a6$var$position(state, value) {
    return value ? state.options.findIndex((option)=>option === value.data) : -1;
}
function $72125c7ae0a2c4a6$var$pickerType(props) {
    return props.isMulti ? 'multi' : 'single';
}
function $72125c7ae0a2c4a6$var$result(option) {
    return option ? $72125c7ae0a2c4a6$var$optionData2Analytics(option.data) : null;
}
function $72125c7ae0a2c4a6$var$results(state) {
    return (state.options || []).map($72125c7ae0a2c4a6$var$optionData2Analytics);
}
function $72125c7ae0a2c4a6$var$isLoading(props, state) {
    return state.count > 0 || props.isLoading;
}
function $72125c7ae0a2c4a6$var$values(state) {
    return state.value ? Array.isArray(state.value) ? state.value.map((option)=>$72125c7ae0a2c4a6$var$optionData2Analytics(option.data)) : [
        $72125c7ae0a2c4a6$var$optionData2Analytics(state.value.data)
    ] : [];
}
function $72125c7ae0a2c4a6$var$numberOfResults(state) {
    return (state.options || []).length;
}

});
parcelRegister("cHYJ6", function(module, exports) {

$parcel$export(module.exports, "isExternalUser", () => $76b83dfd34bdcdb2$export$f6058dbcb5980cb);
$parcel$export(module.exports, "isUser", () => $76b83dfd34bdcdb2$export$2e44165f1da65304);
$parcel$export(module.exports, "isTeam", () => $76b83dfd34bdcdb2$export$f8c4277cb588611f);
$parcel$export(module.exports, "isGroup", () => $76b83dfd34bdcdb2$export$d7976824e9f55785);
$parcel$export(module.exports, "isEmail", () => $76b83dfd34bdcdb2$export$7fbbfbca30081d0);
$parcel$export(module.exports, "isCustom", () => $76b83dfd34bdcdb2$export$d3a8f0b77e9737fc);
$parcel$export(module.exports, "isDefaultValuePopulated", () => $76b83dfd34bdcdb2$export$d6978985a41b0c8);
$parcel$export(module.exports, "extractOptionValue", () => $76b83dfd34bdcdb2$export$7ae97131df521bff);
$parcel$export(module.exports, "isIterable", () => $76b83dfd34bdcdb2$export$9652023d9040757);
$parcel$export(module.exports, "getOptions", () => $76b83dfd34bdcdb2$export$d2312e68e1f5ad00);
$parcel$export(module.exports, "optionToSelectableOptions", () => $76b83dfd34bdcdb2$export$e6fda14a194bcbcc);
$parcel$export(module.exports, "getAvatarSize", () => $76b83dfd34bdcdb2$export$695fb564e621339a);
$parcel$export(module.exports, "isChildInput", () => $76b83dfd34bdcdb2$export$3c62cf9a01367f27);
$parcel$export(module.exports, "isSingleValue", () => $76b83dfd34bdcdb2$export$203c2bd2662d1ca2);
$parcel$export(module.exports, "hasValue", () => $76b83dfd34bdcdb2$export$96bdbc84526f3739);
$parcel$export(module.exports, "callCallback", () => $76b83dfd34bdcdb2$export$df325aa844b03c31);
$parcel$export(module.exports, "getAvatarUrl", () => $76b83dfd34bdcdb2$export$b4f8f1f54acec99b);
$parcel$export(module.exports, "isPopupUserPickerByComponent", () => $76b83dfd34bdcdb2$export$4f60a74234178416);
$parcel$export(module.exports, "isLozengeText", () => $76b83dfd34bdcdb2$export$5419897287f5f1c7);

var $5iWql = parcelRequire("5iWql");


var $l44HT = parcelRequire("l44HT");
const $76b83dfd34bdcdb2$export$f6058dbcb5980cb = (option)=>option.type === (0, $0b440fae145c26fc$export$50042ec1d2e00e63) || Boolean(option.isExternal);
const $76b83dfd34bdcdb2$export$2e44165f1da65304 = (option)=>option.type === undefined || option.type === (0, $0b440fae145c26fc$export$8436e53e45ffe15b);
const $76b83dfd34bdcdb2$export$f8c4277cb588611f = (option)=>option.type === (0, $0b440fae145c26fc$export$26bc40b960693765);
const $76b83dfd34bdcdb2$export$d7976824e9f55785 = (option)=>option.type === (0, $0b440fae145c26fc$export$d460f747b73abb10);
const $76b83dfd34bdcdb2$export$7fbbfbca30081d0 = (option)=>option.type === (0, $0b440fae145c26fc$export$6662b3461398ef8c);
const $76b83dfd34bdcdb2$export$d3a8f0b77e9737fc = (option)=>option.type === (0, $0b440fae145c26fc$export$eafd0979afa5b224);
const $76b83dfd34bdcdb2$export$d6978985a41b0c8 = (value)=>value && !Array.isArray(value) || Array.isArray(value) && value.length > 0;
const $76b83dfd34bdcdb2$var$isOptionData = (option)=>option.name !== undefined;
const $76b83dfd34bdcdb2$export$3f993c492bd6c728 = (option)=>{
    if ($76b83dfd34bdcdb2$var$isOptionData(option)) return {
        data: option,
        isDisabled: option.isDisabled,
        label: option.name,
        value: option.id
    };
    else return {
        data: {
            ...option,
            name: option.id
        },
        isDisabled: option.isDisabled,
        label: option.id,
        value: option.id
    };
};
const $76b83dfd34bdcdb2$export$7ae97131df521bff = (value)=>{
    if (!value) return undefined;
    if (Array.isArray(value)) return value.map(({ data: option })=>option);
    return value.data;
};
const $76b83dfd34bdcdb2$export$9652023d9040757 = (a)=>typeof a[Symbol.iterator] === 'function';
const $76b83dfd34bdcdb2$export$d2312e68e1f5ad00 = (0, $5iWql.default)((options)=>options.map($76b83dfd34bdcdb2$export$3f993c492bd6c728));
const $76b83dfd34bdcdb2$export$e6fda14a194bcbcc = (0, $5iWql.default)((defaultValue)=>{
    if (!defaultValue) return null;
    if (Array.isArray(defaultValue)) return defaultValue.map($76b83dfd34bdcdb2$export$3f993c492bd6c728);
    return $76b83dfd34bdcdb2$export$3f993c492bd6c728(defaultValue);
});
const $76b83dfd34bdcdb2$export$695fb564e621339a = (appearance)=>appearance === 'big' ? 'medium' : appearance === 'multi' ? 'xsmall' : 'small';
const $76b83dfd34bdcdb2$export$3c62cf9a01367f27 = (child)=>child && typeof child === 'object' && child.props && child.props.type === 'text';
const $76b83dfd34bdcdb2$export$203c2bd2662d1ca2 = (value)=>!!value && !Array.isArray(value);
const $76b83dfd34bdcdb2$export$96bdbc84526f3739 = (value)=>!!value && value.trim().length > 0;
const $76b83dfd34bdcdb2$export$df325aa844b03c31 = (callback, ...args)=>{
    if (typeof callback === 'function') try {
        //  there is mystery error in IE 11, so we need this try-catch
        return callback(...args);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('@atlassian/user-select: an error happening in `callCallback`: ', error);
    }
};
const $76b83dfd34bdcdb2$export$b4f8f1f54acec99b = (optionData)=>{
    if ($76b83dfd34bdcdb2$export$2e44165f1da65304(optionData) || $76b83dfd34bdcdb2$export$f8c4277cb588611f(optionData) || $76b83dfd34bdcdb2$export$d3a8f0b77e9737fc(optionData)) return optionData.avatarUrl;
    return undefined;
};
const $76b83dfd34bdcdb2$export$4f60a74234178416 = (SelectComponent)=>SelectComponent === (0, $l44HT.default);
const $76b83dfd34bdcdb2$export$7add003953ca6733 = (selectProps)=>selectProps.searchThreshold === -1;
const $76b83dfd34bdcdb2$export$5419897287f5f1c7 = (lozengeProp)=>{
    return lozengeProp?.hasOwnProperty('text') || false;
};

});
const $0b440fae145c26fc$export$8436e53e45ffe15b = 'user';
const $0b440fae145c26fc$export$50042ec1d2e00e63 = 'external_user';
const $0b440fae145c26fc$export$26bc40b960693765 = 'team';
const $0b440fae145c26fc$export$d460f747b73abb10 = 'group';
const $0b440fae145c26fc$export$6662b3461398ef8c = 'email';
const $0b440fae145c26fc$export$eafd0979afa5b224 = 'custom';

parcelRegister("l44HT", function(module, exports) {

$parcel$export(module.exports, "default", () => $e29cbcff993ea6c5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $6Pq2D = parcelRequire("6Pq2D");

var $hOLnS = parcelRequire("hOLnS");
var $cEc3i = parcelRequire("cEc3i");

var $tkrFt = parcelRequire("tkrFt");

var $3aVBa = parcelRequire("3aVBa");
var $aV2RP = parcelRequire("aV2RP");
var $6XvxP = parcelRequire("6XvxP");

var $lbDTY = parcelRequire("lbDTY");

var $asNSH = parcelRequire("asNSH");

var $5wCDk = parcelRequire("5wCDk");

var $PdmhA = parcelRequire("PdmhA");

var $XHGTv = parcelRequire("XHGTv");

var $7ldaw = parcelRequire("7ldaw");

var $bKJfr = parcelRequire("bKJfr");

var $74BVL = parcelRequire("74BVL");
/** Are we rendering on the client or server? */ const $e29cbcff993ea6c5$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
// ==============================
// Class
// ==============================
const $e29cbcff993ea6c5$var$modifiers = [
    {
        name: 'offset',
        options: {
            offset: [
                0,
                8
            ]
        }
    },
    {
        name: 'preventOverflow',
        enabled: true,
        options: {
            padding: 5,
            boundary: 'clippingParents',
            altAxis: true,
            altBoundary: true
        }
    }
];
const $e29cbcff993ea6c5$var$defaultPopperProps = {
    modifiers: $e29cbcff993ea6c5$var$modifiers,
    placement: 'bottom-start'
};
const $e29cbcff993ea6c5$var$isEmpty = (obj)=>Object.keys(obj).length === 0;
class $e29cbcff993ea6c5$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    static{
        this.defaultProps = {
            closeMenuOnSelect: true,
            components: {},
            maxMenuHeight: 300,
            maxMenuWidth: 440,
            minMenuWidth: 220,
            popperProps: {},
            isSearchable: true,
            searchThreshold: 5,
            styles: {},
            options: []
        };
    }
    static getDerivedStateFromProps(props, state) {
        const newState = {};
        // Merge consumer and default popper props
        const mergedPopperProps = {
            ...$e29cbcff993ea6c5$var$defaultPopperProps,
            ...props.popperProps
        };
        if (!(0, $asNSH.shallowEqualObjects)(mergedPopperProps, state.mergedPopperProps)) newState.mergedPopperProps = mergedPopperProps;
        // Merge consumer and default components
        const mergedComponents = {
            ...(0, $7ldaw.defaultComponents),
            ...props.components
        };
        if (!(0, $asNSH.shallowEqualObjects)(mergedComponents, state.mergedComponents)) newState.mergedComponents = mergedComponents;
        if (!$e29cbcff993ea6c5$var$isEmpty(newState)) return newState;
        return null;
    }
    componentDidMount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick = (0, $74BVL.bind)(window, {
            type: 'click',
            listener: this.handleClick,
            options: {
                capture: true
            }
        });
    }
    componentWillUnmount() {
        if (typeof window === 'undefined') return;
        this.unbindWindowClick?.();
        this.unbindWindowClick = null;
        this.unbindWindowKeydown?.();
        this.unbindWindowKeydown = null;
    }
    componentDidUpdate(prevProps) {
        const { isOpen: isOpen } = this.props;
        if (prevProps.isOpen !== isOpen) {
            if (isOpen === true) this.open({
                controlOverride: true
            });
            else if (isOpen === false) this.close({
                controlOverride: true
            });
        }
    }
    render() {
        const { target: target } = this.props;
        const { isOpen: isOpen } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3aVBa.Manager), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6XvxP.Reference), null, ({ ref: ref })=>target && target({
                isOpen: isOpen,
                onKeyDown: this.handleTargetKeyDown,
                ref: this.resolveTargetRef(ref),
                'aria-haspopup': 'true',
                'aria-expanded': isOpen,
                'aria-controls': isOpen ? this.popperWrapperId : undefined
            })), this.renderSelect());
    }
    constructor(...args){
        super(...args);
        this.menuRef = null;
        this.targetRef = null;
        this.unbindWindowClick = null;
        this.unbindWindowKeydown = null;
        this.defaultStyles = (0, $cEc3i.m)((0, $bKJfr.default)(this.props.validationState || (this.props.isInvalid ? 'error' : 'default'), this.props.spacing === 'compact', 'default'), {
            groupHeading: (provided)=>({
                    ...provided,
                    color: `var(--ds-text-subtlest, ${0, $PdmhA.N80})`
                })
        });
        this.isOpenControlled = this.props.isOpen !== undefined;
        this.defaultOpenState = this.isOpenControlled ? this.props.isOpen : this.props.defaultIsOpen;
        this.state = {
            focusLockEnabled: false,
            isOpen: this.defaultOpenState ?? false,
            mergedComponents: (0, $7ldaw.defaultComponents),
            mergedPopperProps: $e29cbcff993ea6c5$var$defaultPopperProps
        };
        this.popperWrapperId = `${(0, $tkrFt.uid)({
            options: this.props.options
        })}-popup-select`;
        // Event Handlers
        // ==============================
        this.handleTargetKeyDown = (event)=>{
            switch(event.key){
                case 'ArrowDown':
                    this.open();
                    break;
                default:
            }
        };
        this.handleKeyDown = (event)=>{
            switch(event.key){
                case 'Escape':
                case 'Esc':
                    this.close();
                    break;
                default:
            }
            if (this.props.onKeyDown) /* @ts-ignore - updating type of event React.KeyboardEvent effects the unbindWindowsKeyDown listener. Check if this can be fixed once the component gets refactor to functional */ this.props.onKeyDown(event);
        };
        this.handleClick = ({ target: target })=>{
            const { isOpen: isOpen } = this.state;
            // appease flow
            if (!(target instanceof Element)) return;
            // NOTE: Why not use the <Blanket /> component to close?
            // We don't want to interupt the user's flow. Taking this approach allows
            // user to click "through" to other elements and close the popout.
            if (isOpen && this.menuRef && !this.menuRef.contains(target)) this.close();
            // open on target click -- we can't trust consumers to spread the onClick
            // property to the target
            if (!isOpen && this.targetRef && this.targetRef.contains(target)) this.open();
        };
        this.handleSelectChange = (value, actionMeta)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, onChange: onChange } = this.props;
            if (closeMenuOnSelect && actionMeta.action !== 'clear') this.close();
            if (onChange) onChange(value, actionMeta);
        };
        this.handleFirstPopperUpdate = ()=>{
            // When the popup opens it's focused into. Since the popup is inside a portal, it's position is
            // initially set to 0,0 - this causes the window scroll position to jump to the top. To prevent
            // this we defer enabling the focus-lock until after Popper has positioned the popup the first time.
            this.setState({
                focusLockEnabled: true
            });
        };
        // Internal Lifecycle
        // ==============================
        /**
   * Opens the popup
   *
   * @param options.controlOverride  - Force the popup to open when it's open state is being controlled
   */ this.open = (options)=>{
            const { onOpen: onOpen } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup opening if it's open state is already being controlled
            return;
            if (onOpen) onOpen();
            this.setState({
                isOpen: true
            });
            if (this.selectRef) (0, $XHGTv.getBooleanFF)('platform.design-system-team.use-default-select-in-popup-select_46rmj') ? this.selectRef.select?.openMenu('first') : this.selectRef.openMenu('first');
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown = (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: this.handleKeyDown,
                options: {
                    capture: true
                }
            });
        };
        /**
   * Closes the popup
   *
   * @param options.controlOverride  - Force the popup to close when it's open state is being controlled
   */ this.close = (options)=>{
            const { onClose: onClose } = this.props;
            if (!options?.controlOverride && this.isOpenControlled) // Prevent popup closing if it's open state is already being controlled
            return;
            if (onClose) onClose();
            this.setState({
                isOpen: false
            });
            this.setState({
                focusLockEnabled: false
            });
            if (this.targetRef != null) this.targetRef.focus();
            if (typeof window === 'undefined') return;
            this.unbindWindowKeydown?.();
            this.unbindWindowKeydown = null;
        };
        // Refs
        // ==============================
        this.resolveTargetRef = (popperRef)=>(ref)=>{
                // avoid thrashing fn calls
                if (!this.targetRef && popperRef && ref) {
                    this.targetRef = ref;
                    if (typeof popperRef === 'function') popperRef(ref);
                    else popperRef.current = ref;
                }
            };
        this.resolveMenuRef = (popperRef)=>(ref)=>{
                this.menuRef = ref;
                if (typeof popperRef === 'function') popperRef(ref);
                else popperRef.current = ref;
            };
        this.getSelectRef = (ref)=>{
            this.selectRef = ref;
        };
        // Utils
        // ==============================
        // account for groups when counting options
        // this may need to be recursive, right now it just counts one level
        this.getItemCount = ()=>{
            const { options: options } = this.props;
            let count = 0;
            options.forEach((groupOrOption)=>{
                if (groupOrOption.options) groupOrOption.options.forEach(()=>count++);
                else count++;
            });
            return count;
        };
        this.getMaxHeight = ()=>{
            const { maxMenuHeight: maxMenuHeight } = this.props;
            if (!this.selectRef) return maxMenuHeight;
            // subtract the control height to maintain consistency
            const showSearchControl = this.showSearchControl();
            let controlRef = (0, $XHGTv.getBooleanFF)('platform.design-system-team.use-default-select-in-popup-select_46rmj') ? this.selectRef.select?.controlRef : this.selectRef.controlRef;
            const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
            const maxHeight = maxMenuHeight - offsetHeight;
            return maxHeight;
        };
        // if the threshold is exceeded, AND isSearchable is true, then display the search control
        this.showSearchControl = ()=>{
            const { searchThreshold: searchThreshold, isSearchable: isSearchable } = this.props;
            return isSearchable && this.getItemCount() > searchThreshold;
        };
        // Renderers
        // ==============================
        this.renderSelect = ()=>{
            const { footer: footer, label: label, maxMenuWidth: maxMenuWidth, minMenuWidth: minMenuWidth, placeholder: placeholder, target: target, testId: testId, ...props } = this.props;
            const { focusLockEnabled: focusLockEnabled, isOpen: isOpen, mergedComponents: mergedComponents, mergedPopperProps: mergedPopperProps } = this.state;
            const showSearchControl = this.showSearchControl();
            const portalDestination = $e29cbcff993ea6c5$var$canUseDOM() ? document.body : null;
            if (!portalDestination || !isOpen) return null;
            const selectComponents = {
                ...mergedComponents,
                Control: showSearchControl ? mergedComponents.Control : (0, $7ldaw.DummyControl)
            };
            const getLabel = ()=>{
                if (label) return label;
                else if (typeof placeholder === 'string') return placeholder;
            };
            const InternalSelect = (0, $XHGTv.getBooleanFF)('platform.design-system-team.use-default-select-in-popup-select_46rmj') ? (0, $5wCDk.default) : (0, $hOLnS.default);
            const popper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aV2RP.Popper), {
                ...mergedPopperProps,
                onFirstUpdate: (state)=>{
                    this.handleFirstPopperUpdate();
                    mergedPopperProps.onFirstUpdate?.(state);
                }
            }, ({ placement: placement, ref: ref, style: style })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbDTY))), {
                    innerRef: this.resolveMenuRef(ref)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ldaw.MenuDialog), {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    style: style,
                    "data-placement": placement,
                    minWidth: minMenuWidth,
                    maxWidth: maxMenuWidth,
                    id: this.popperWrapperId,
                    testId: testId
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Pq2D.default), {
                    disabled: !focusLockEnabled,
                    returnFocus: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(InternalSelect, {
                    "aria-label": getLabel(),
                    backspaceRemovesValue: false,
                    controlShouldRenderValue: false,
                    isClearable: false,
                    tabSelectsValue: false,
                    menuIsOpen: true,
                    placeholder: placeholder,
                    ref: this.getSelectRef,
                    ...props,
                    onMenuClose: ()=>{
                        (0, $XHGTv.getBooleanFF)('platform.design-system-team.popup-select-close_8h15h') && this.close();
                        props.onMenuClose?.();
                    },
                    isSearchable: showSearchControl,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    styles: (0, $cEc3i.m)(this.defaultStyles, props.styles || {}),
                    maxMenuHeight: this.getMaxHeight(),
                    components: selectComponents,
                    onChange: this.handleSelectChange
                }), footer))));
            return mergedPopperProps.strategy === 'fixed' ? popper : /*#__PURE__*/ (0, $lEfVV.createPortal)(popper, portalDestination);
        };
    }
}

});
parcelRegister("3aVBa", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $24fefc1eb423cf0c$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $24fefc1eb423cf0c$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $24fefc1eb423cf0c$export$d0d38e7dec7a1a61);

var $eUqFw = parcelRequire("eUqFw");
var $24fefc1eb423cf0c$export$3dbd3405086fec7b = $eUqFw.createContext();
var $24fefc1eb423cf0c$export$cbabb21c2529b130 = $eUqFw.createContext();
function $24fefc1eb423cf0c$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $eUqFw.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $eUqFw.useRef(false);
    $eUqFw.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $eUqFw.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $eUqFw.createElement($24fefc1eb423cf0c$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $eUqFw.createElement($24fefc1eb423cf0c$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("aV2RP", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $7f317398a3c1e136$export$badac9ada3a0bdf9);

var $eUqFw = parcelRequire("eUqFw");

var $3aVBa = parcelRequire("3aVBa");

var $4J8wt = parcelRequire("4J8wt");

var $fATwl = parcelRequire("fATwl");
var $7f317398a3c1e136$var$NOOP = function NOOP() {
    return void 0;
};
var $7f317398a3c1e136$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $7f317398a3c1e136$var$EMPTY_MODIFIERS = [];
function $7f317398a3c1e136$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $7f317398a3c1e136$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $eUqFw.useContext((0, $3aVBa.ManagerReferenceNodeContext));
    var _React$useState = $eUqFw.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $eUqFw.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $eUqFw.useEffect(function() {
        (0, $4J8wt.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $eUqFw.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $fATwl.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $eUqFw.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $7f317398a3c1e136$var$NOOP,
            update: update || $7f317398a3c1e136$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $4J8wt.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("4J8wt", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", () => $3711f9d89c6c0713$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $3711f9d89c6c0713$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $3711f9d89c6c0713$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $3711f9d89c6c0713$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $3711f9d89c6c0713$export$700979bc83e7db82);

var $eUqFw = parcelRequire("eUqFw");
var $3711f9d89c6c0713$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $3711f9d89c6c0713$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $3711f9d89c6c0713$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $3711f9d89c6c0713$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $3711f9d89c6c0713$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $3711f9d89c6c0713$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $eUqFw.useLayoutEffect : $eUqFw.useEffect;

});

parcelRegister("fATwl", function(module, exports) {

$parcel$export(module.exports, "usePopper", () => $b5a5490e72f59dbf$export$f4d5bf230a36dd6e);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $1sNnY = parcelRequire("1sNnY");

var $an8Qp = parcelRequire("an8Qp");

var $4J8wt = parcelRequire("4J8wt");
var $b5a5490e72f59dbf$var$EMPTY_MODIFIERS = [];
var $b5a5490e72f59dbf$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $eUqFw.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $b5a5490e72f59dbf$var$EMPTY_MODIFIERS
    };
    var _React$useState = $eUqFw.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $eUqFw.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $lEfVV.flushSync(function() {
                    setState({
                        styles: (0, $4J8wt.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $4J8wt.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $eUqFw.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($an8Qp)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $eUqFw.useRef();
    (0, $4J8wt.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $4J8wt.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $1sNnY.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("1sNnY", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $110eb6f1d5d14a7b$export$8f7491d57c8f97a9);

var $6dO3d = parcelRequire("6dO3d");

var $hKNVt = parcelRequire("hKNVt");

var $1hjVu = parcelRequire("1hjVu");

var $1T37S = parcelRequire("1T37S");

var $gbbnc = parcelRequire("gbbnc");

var $bX36N = parcelRequire("bX36N");

var $9chVh = parcelRequire("9chVh");

var $e0gkO = parcelRequire("e0gkO");

var $RxAbB = parcelRequire("RxAbB");

var $4Jkbd = parcelRequire("4Jkbd");


var $110eb6f1d5d14a7b$export$d34966752335dd47 = [
    (0, $hKNVt.default),
    (0, $1hjVu.default),
    (0, $1T37S.default),
    (0, $gbbnc.default),
    (0, $bX36N.default),
    (0, $9chVh.default),
    (0, $e0gkO.default),
    (0, $RxAbB.default),
    (0, $4Jkbd.default)
];
var $110eb6f1d5d14a7b$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $6dO3d.popperGenerator)({
    defaultModifiers: $110eb6f1d5d14a7b$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("6dO3d", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $487ac80c4f86ec1e$export$ed5e13716264f202);

var $gka9g = parcelRequire("gka9g");

var $3F4KV = parcelRequire("3F4KV");

var $edd0p = parcelRequire("edd0p");

var $1Z5jy = parcelRequire("1Z5jy");

var $UiAmo = parcelRequire("UiAmo");

var $4YkF9 = parcelRequire("4YkF9");

var $aCxpo = parcelRequire("aCxpo");


var $jxz5k = parcelRequire("jxz5k");
var $487ac80c4f86ec1e$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $487ac80c4f86ec1e$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $487ac80c4f86ec1e$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $487ac80c4f86ec1e$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $487ac80c4f86ec1e$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $jxz5k.isElement)(reference) ? (0, $edd0p.default)(reference) : reference.contextElement ? (0, $edd0p.default)(reference.contextElement) : [],
                    popper: (0, $edd0p.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $UiAmo.default)((0, $aCxpo.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$487ac80c4f86ec1e$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $gka9g.default)(reference, (0, $1Z5jy.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $3F4KV.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $4YkF9.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$487ac80c4f86ec1e$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $487ac80c4f86ec1e$export$8f7491d57c8f97a9 = /*#__PURE__*/ $487ac80c4f86ec1e$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("gka9g", function(module, exports) {

$parcel$export(module.exports, "default", () => $be2662d6eb9e3a4a$export$2e2bcd8739ae039);

var $gQlmL = parcelRequire("gQlmL");

var $3Q5Qy = parcelRequire("3Q5Qy");

var $3Ih4r = parcelRequire("3Ih4r");

var $jxz5k = parcelRequire("jxz5k");

var $gIy3I = parcelRequire("gIy3I");

var $9ce0D = parcelRequire("9ce0D");

var $lp2b7 = parcelRequire("lp2b7");

var $3Gelu = parcelRequire("3Gelu");
function $be2662d6eb9e3a4a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $3Gelu.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $3Gelu.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $be2662d6eb9e3a4a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $jxz5k.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $jxz5k.isHTMLElement)(offsetParent) && $be2662d6eb9e3a4a$var$isElementScaled(offsetParent);
    var documentElement = (0, $9ce0D.default)(offsetParent);
    var rect = (0, $gQlmL.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $3Ih4r.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $lp2b7.default)(documentElement)) scroll = (0, $3Q5Qy.default)(offsetParent);
        if ((0, $jxz5k.isHTMLElement)(offsetParent)) {
            offsets = (0, $gQlmL.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $gIy3I.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("gQlmL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c432138ece0d4fa8$export$2e2bcd8739ae039);

var $jxz5k = parcelRequire("jxz5k");

var $3Gelu = parcelRequire("3Gelu");

var $eNjCb = parcelRequire("eNjCb");

var $2QPpT = parcelRequire("2QPpT");
function $c432138ece0d4fa8$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $jxz5k.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $3Gelu.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $3Gelu.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $jxz5k.isElement)(element) ? (0, $eNjCb.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $2QPpT.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("jxz5k", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $e39c508a61a40243$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $e39c508a61a40243$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $e39c508a61a40243$export$af51f0f06c0f328a);

var $eNjCb = parcelRequire("eNjCb");
function $e39c508a61a40243$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $eNjCb.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $e39c508a61a40243$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $eNjCb.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $e39c508a61a40243$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $eNjCb.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("eNjCb", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac54db6104c61765$export$2e2bcd8739ae039);
function $ac54db6104c61765$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("3Gelu", function(module, exports) {

$parcel$export(module.exports, "max", () => $2ae06c1a24639922$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $2ae06c1a24639922$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $2ae06c1a24639922$export$2077e0241d6afd3c);
var $2ae06c1a24639922$export$8960430cfd85939f = Math.max;
var $2ae06c1a24639922$export$96ec731ed4dcb222 = Math.min;
var $2ae06c1a24639922$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("2QPpT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2138525ae724b403$export$2e2bcd8739ae039);

var $j87Uw = parcelRequire("j87Uw");
function $2138525ae724b403$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $j87Uw.default)());
}

});
parcelRegister("j87Uw", function(module, exports) {

$parcel$export(module.exports, "default", () => $ded4e693f114a81c$export$2e2bcd8739ae039);
function $ded4e693f114a81c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("3Q5Qy", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cbac36da0487101$export$2e2bcd8739ae039);

var $hRE8q = parcelRequire("hRE8q");

var $eNjCb = parcelRequire("eNjCb");

var $jxz5k = parcelRequire("jxz5k");

var $4K3DC = parcelRequire("4K3DC");
function $2cbac36da0487101$export$2e2bcd8739ae039(node) {
    if (node === (0, $eNjCb.default)(node) || !(0, $jxz5k.isHTMLElement)(node)) return (0, $hRE8q.default)(node);
    else return (0, $4K3DC.default)(node);
}

});
parcelRegister("hRE8q", function(module, exports) {

$parcel$export(module.exports, "default", () => $d01684e258e44be2$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");
function $d01684e258e44be2$export$2e2bcd8739ae039(node) {
    var win = (0, $eNjCb.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("4K3DC", function(module, exports) {

$parcel$export(module.exports, "default", () => $373e47b99d05f3c9$export$2e2bcd8739ae039);
function $373e47b99d05f3c9$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("3Ih4r", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b42b9085e0eb740$export$2e2bcd8739ae039);
function $2b42b9085e0eb740$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("gIy3I", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2bb2ccf0fe2e3c3$export$2e2bcd8739ae039);

var $gQlmL = parcelRequire("gQlmL");

var $9ce0D = parcelRequire("9ce0D");

var $hRE8q = parcelRequire("hRE8q");
function $c2bb2ccf0fe2e3c3$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $gQlmL.default)((0, $9ce0D.default)(element)).left + (0, $hRE8q.default)(element).scrollLeft;
}

});
parcelRegister("9ce0D", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b2019f883903c78$export$2e2bcd8739ae039);

var $jxz5k = parcelRequire("jxz5k");
function $6b2019f883903c78$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $jxz5k.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("lp2b7", function(module, exports) {

$parcel$export(module.exports, "default", () => $f94d9f5c84260b26$export$2e2bcd8739ae039);

var $itp1E = parcelRequire("itp1E");
function $f94d9f5c84260b26$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $itp1E.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("itp1E", function(module, exports) {

$parcel$export(module.exports, "default", () => $d72e58fb356d483c$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");
function $d72e58fb356d483c$export$2e2bcd8739ae039(element) {
    return (0, $eNjCb.default)(element).getComputedStyle(element);
}

});



parcelRegister("3F4KV", function(module, exports) {

$parcel$export(module.exports, "default", () => $2aa8e3d950b93051$export$2e2bcd8739ae039);

var $gQlmL = parcelRequire("gQlmL");
function $2aa8e3d950b93051$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $gQlmL.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("edd0p", function(module, exports) {

$parcel$export(module.exports, "default", () => $a58c5e38958f7507$export$2e2bcd8739ae039);

var $hfADZ = parcelRequire("hfADZ");

var $6P0Dy = parcelRequire("6P0Dy");

var $eNjCb = parcelRequire("eNjCb");

var $lp2b7 = parcelRequire("lp2b7");
function $a58c5e38958f7507$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $hfADZ.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $eNjCb.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $lp2b7.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($a58c5e38958f7507$export$2e2bcd8739ae039((0, $6P0Dy.default)(target)));
}

});
parcelRegister("hfADZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8f043198ffd7cdf$export$2e2bcd8739ae039);

var $6P0Dy = parcelRequire("6P0Dy");

var $lp2b7 = parcelRequire("lp2b7");

var $3Ih4r = parcelRequire("3Ih4r");

var $jxz5k = parcelRequire("jxz5k");
function $c8f043198ffd7cdf$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $3Ih4r.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $jxz5k.isHTMLElement)(node) && (0, $lp2b7.default)(node)) return node;
    return $c8f043198ffd7cdf$export$2e2bcd8739ae039((0, $6P0Dy.default)(node));
}

});
parcelRegister("6P0Dy", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f780000a33023fc$export$2e2bcd8739ae039);

var $3Ih4r = parcelRequire("3Ih4r");

var $9ce0D = parcelRequire("9ce0D");

var $jxz5k = parcelRequire("jxz5k");
function $4f780000a33023fc$export$2e2bcd8739ae039(element) {
    if ((0, $3Ih4r.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $jxz5k.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $9ce0D.default)(element) // fallback
    );
}

});



parcelRegister("1Z5jy", function(module, exports) {

$parcel$export(module.exports, "default", () => $171f9c4bd8752ce1$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");

var $3Ih4r = parcelRequire("3Ih4r");

var $itp1E = parcelRequire("itp1E");

var $jxz5k = parcelRequire("jxz5k");

var $cPuw6 = parcelRequire("cPuw6");

var $6P0Dy = parcelRequire("6P0Dy");

var $j87Uw = parcelRequire("j87Uw");
function $171f9c4bd8752ce1$var$getTrueOffsetParent(element) {
    if (!(0, $jxz5k.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $itp1E.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $171f9c4bd8752ce1$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $j87Uw.default)());
    var isIE = /Trident/i.test((0, $j87Uw.default)());
    if (isIE && (0, $jxz5k.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $itp1E.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $6P0Dy.default)(element);
    if ((0, $jxz5k.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $jxz5k.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $3Ih4r.default)(currentNode)) < 0){
        var css = (0, $itp1E.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $171f9c4bd8752ce1$export$2e2bcd8739ae039(element) {
    var window = (0, $eNjCb.default)(element);
    var offsetParent = $171f9c4bd8752ce1$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $cPuw6.default)(offsetParent) && (0, $itp1E.default)(offsetParent).position === 'static')offsetParent = $171f9c4bd8752ce1$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $3Ih4r.default)(offsetParent) === 'html' || (0, $3Ih4r.default)(offsetParent) === 'body' && (0, $itp1E.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $171f9c4bd8752ce1$var$getContainingBlock(element) || window;
}

});
parcelRegister("cPuw6", function(module, exports) {

$parcel$export(module.exports, "default", () => $9571eb7890da3be6$export$2e2bcd8739ae039);

var $3Ih4r = parcelRequire("3Ih4r");
function $9571eb7890da3be6$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $3Ih4r.default)(element)) >= 0;
}

});


parcelRegister("UiAmo", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a93a5c300cea5e9$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");
function $0a93a5c300cea5e9$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $0a93a5c300cea5e9$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $0a93a5c300cea5e9$var$order(modifiers); // order based on phase
    return (0, $cUxAV.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("cUxAV", function(module, exports) {

$parcel$export(module.exports, "top", () => $9664c6303656943f$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $9664c6303656943f$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $9664c6303656943f$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $9664c6303656943f$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $9664c6303656943f$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $9664c6303656943f$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $9664c6303656943f$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $9664c6303656943f$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $9664c6303656943f$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $9664c6303656943f$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $9664c6303656943f$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $9664c6303656943f$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $9664c6303656943f$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $9664c6303656943f$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $9664c6303656943f$export$d087d3878fdf71d5);
var $9664c6303656943f$export$1e95b668f3b82d = 'top';
var $9664c6303656943f$export$40e543e69a8b3fbb = 'bottom';
var $9664c6303656943f$export$79ffe56a765070d2 = 'right';
var $9664c6303656943f$export$eabcd2c8791e7bf4 = 'left';
var $9664c6303656943f$export$dfb5619354ba860 = 'auto';
var $9664c6303656943f$export$aec2ce47c367b8c3 = [
    $9664c6303656943f$export$1e95b668f3b82d,
    $9664c6303656943f$export$40e543e69a8b3fbb,
    $9664c6303656943f$export$79ffe56a765070d2,
    $9664c6303656943f$export$eabcd2c8791e7bf4
];
var $9664c6303656943f$export$b3571188c770cc5a = 'start';
var $9664c6303656943f$export$bd5df0f255a350f8 = 'end';
var $9664c6303656943f$export$390fd549c5303b4d = 'clippingParents';
var $9664c6303656943f$export$d7b7311ec04a3e8f = 'viewport';
var $9664c6303656943f$export$ae5ab1c730825774 = 'popper';
var $9664c6303656943f$export$ca50aac9f3ba507f = 'reference';
var $9664c6303656943f$export$368f9a87e87fa4e1 = /*#__PURE__*/ $9664c6303656943f$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $9664c6303656943f$export$b3571188c770cc5a,
        placement + "-" + $9664c6303656943f$export$bd5df0f255a350f8
    ]);
}, []);
var $9664c6303656943f$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($9664c6303656943f$export$aec2ce47c367b8c3, [
    $9664c6303656943f$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $9664c6303656943f$export$b3571188c770cc5a,
        placement + "-" + $9664c6303656943f$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $9664c6303656943f$export$421679a7c3d56e = 'beforeRead';
var $9664c6303656943f$export$aafa59e2e03f2942 = 'read';
var $9664c6303656943f$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $9664c6303656943f$export$c65e99957a05207c = 'beforeMain';
var $9664c6303656943f$export$f22da7240b7add18 = 'main';
var $9664c6303656943f$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $9664c6303656943f$export$8d4d2d70e7d46032 = 'beforeWrite';
var $9664c6303656943f$export$68d8715fc104d294 = 'write';
var $9664c6303656943f$export$70a6e5159acce2e6 = 'afterWrite';
var $9664c6303656943f$export$d087d3878fdf71d5 = [
    $9664c6303656943f$export$421679a7c3d56e,
    $9664c6303656943f$export$aafa59e2e03f2942,
    $9664c6303656943f$export$6964f6c886723980,
    $9664c6303656943f$export$c65e99957a05207c,
    $9664c6303656943f$export$f22da7240b7add18,
    $9664c6303656943f$export$bab79516f2d662fe,
    $9664c6303656943f$export$8d4d2d70e7d46032,
    $9664c6303656943f$export$68d8715fc104d294,
    $9664c6303656943f$export$70a6e5159acce2e6
];

});


parcelRegister("4YkF9", function(module, exports) {

$parcel$export(module.exports, "default", () => $39eccb35e3c50f87$export$2e2bcd8739ae039);
function $39eccb35e3c50f87$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("aCxpo", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bb75e3a2d172ac3$export$2e2bcd8739ae039);
function $7bb75e3a2d172ac3$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("hKNVt", function(module, exports) {

$parcel$export(module.exports, "default", () => $cecd75ca68a9b247$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");
var $cecd75ca68a9b247$var$passive = {
    passive: true
};
function $cecd75ca68a9b247$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $eNjCb.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $cecd75ca68a9b247$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $cecd75ca68a9b247$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $cecd75ca68a9b247$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $cecd75ca68a9b247$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $cecd75ca68a9b247$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $cecd75ca68a9b247$var$effect,
    data: {}
};

});

parcelRegister("1hjVu", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ee6d5e58dbc65f7$export$2e2bcd8739ae039);

var $2v9wJ = parcelRequire("2v9wJ");
function $0ee6d5e58dbc65f7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $2v9wJ.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $0ee6d5e58dbc65f7$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $0ee6d5e58dbc65f7$var$popperOffsets,
    data: {}
};

});
parcelRegister("2v9wJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d25dddec077799d$export$2e2bcd8739ae039);

var $i0vbU = parcelRequire("i0vbU");

var $hqMUN = parcelRequire("hqMUN");

var $lM4La = parcelRequire("lM4La");

var $cUxAV = parcelRequire("cUxAV");
function $1d25dddec077799d$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $i0vbU.default)(placement) : null;
    var variation = placement ? (0, $hqMUN.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $cUxAV.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $cUxAV.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $cUxAV.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $cUxAV.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $lM4La.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $cUxAV.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $cUxAV.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("i0vbU", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1c06bfb436e5b63$export$2e2bcd8739ae039);

function $d1c06bfb436e5b63$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("hqMUN", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb0acede73c1ccbf$export$2e2bcd8739ae039);
function $cb0acede73c1ccbf$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("lM4La", function(module, exports) {

$parcel$export(module.exports, "default", () => $fda1c5d978c44f54$export$2e2bcd8739ae039);
function $fda1c5d978c44f54$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("1T37S", function(module, exports) {

$parcel$export(module.exports, "default", () => $15fd5a492bd54a2d$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");

var $1Z5jy = parcelRequire("1Z5jy");

var $eNjCb = parcelRequire("eNjCb");

var $9ce0D = parcelRequire("9ce0D");

var $itp1E = parcelRequire("itp1E");

var $i0vbU = parcelRequire("i0vbU");

var $hqMUN = parcelRequire("hqMUN");

var $3Gelu = parcelRequire("3Gelu");
var $15fd5a492bd54a2d$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $15fd5a492bd54a2d$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $3Gelu.round)(x * dpr) / dpr || 0,
        y: (0, $3Gelu.round)(y * dpr) / dpr || 0
    };
}
function $15fd5a492bd54a2d$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $cUxAV.left);
    var sideY = (0, $cUxAV.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $1Z5jy.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $eNjCb.default)(popper)) {
            offsetParent = (0, $9ce0D.default)(popper);
            if ((0, $itp1E.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $cUxAV.top) || (placement === (0, $cUxAV.left) || placement === (0, $cUxAV.right)) && variation === (0, $cUxAV.end)) {
            sideY = (0, $cUxAV.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $cUxAV.left) || (placement === (0, $cUxAV.top) || placement === (0, $cUxAV.bottom)) && variation === (0, $cUxAV.end)) {
            sideX = (0, $cUxAV.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $15fd5a492bd54a2d$var$unsetSides);
    var _ref4 = roundOffsets === true ? $15fd5a492bd54a2d$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $eNjCb.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $15fd5a492bd54a2d$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $i0vbU.default)(state.placement),
        variation: (0, $hqMUN.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $15fd5a492bd54a2d$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $15fd5a492bd54a2d$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $15fd5a492bd54a2d$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $15fd5a492bd54a2d$var$computeStyles,
    data: {}
};

});

parcelRegister("gbbnc", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc767ee95e24374d$export$2e2bcd8739ae039);

var $3Ih4r = parcelRequire("3Ih4r");

var $jxz5k = parcelRequire("jxz5k");
// and applies them to the HTMLElements such as popper and arrow
function $bc767ee95e24374d$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $jxz5k.isHTMLElement)(element) || !(0, $3Ih4r.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $bc767ee95e24374d$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $jxz5k.isHTMLElement)(element) || !(0, $3Ih4r.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $bc767ee95e24374d$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $bc767ee95e24374d$var$applyStyles,
    effect: $bc767ee95e24374d$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("bX36N", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b379db63df9cbb0$export$2e2bcd8739ae039);

var $i0vbU = parcelRequire("i0vbU");

var $cUxAV = parcelRequire("cUxAV");
function $8b379db63df9cbb0$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $i0vbU.default)(placement);
    var invertDistance = [
        (0, $cUxAV.left),
        (0, $cUxAV.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $cUxAV.left),
        (0, $cUxAV.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $8b379db63df9cbb0$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $cUxAV.placements).reduce(function(acc, placement) {
        acc[placement] = $8b379db63df9cbb0$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $8b379db63df9cbb0$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $8b379db63df9cbb0$var$offset
};

});

parcelRegister("9chVh", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b23232380764dc2$export$2e2bcd8739ae039);

var $3J90z = parcelRequire("3J90z");

var $i0vbU = parcelRequire("i0vbU");

var $69vda = parcelRequire("69vda");

var $9c30h = parcelRequire("9c30h");

var $cnkWG = parcelRequire("cnkWG");

var $cUxAV = parcelRequire("cUxAV");

var $hqMUN = parcelRequire("hqMUN");
function $6b23232380764dc2$var$getExpandedFallbackPlacements(placement) {
    if ((0, $i0vbU.default)(placement) === (0, $cUxAV.auto)) return [];
    var oppositePlacement = (0, $3J90z.default)(placement);
    return [
        (0, $69vda.default)(placement),
        oppositePlacement,
        (0, $69vda.default)(oppositePlacement)
    ];
}
function $6b23232380764dc2$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $i0vbU.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $3J90z.default)(preferredPlacement)
    ] : $6b23232380764dc2$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $i0vbU.default)(placement) === (0, $cUxAV.auto) ? (0, $cnkWG.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $i0vbU.default)(placement);
        var isStartVariation = (0, $hqMUN.default)(placement) === (0, $cUxAV.start);
        var isVertical = [
            (0, $cUxAV.top),
            (0, $cUxAV.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $9c30h.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $cUxAV.right) : (0, $cUxAV.left) : isStartVariation ? (0, $cUxAV.bottom) : (0, $cUxAV.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $3J90z.default)(mainVariationSide);
        var altVariationSide = (0, $3J90z.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $6b23232380764dc2$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $6b23232380764dc2$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("3J90z", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b6c8fe3295acfa9$export$2e2bcd8739ae039);
var $2b6c8fe3295acfa9$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $2b6c8fe3295acfa9$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $2b6c8fe3295acfa9$var$hash[matched];
    });
}

});

parcelRegister("69vda", function(module, exports) {

$parcel$export(module.exports, "default", () => $47abcb4441e1bf89$export$2e2bcd8739ae039);
var $47abcb4441e1bf89$var$hash = {
    start: 'end',
    end: 'start'
};
function $47abcb4441e1bf89$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $47abcb4441e1bf89$var$hash[matched];
    });
}

});

parcelRegister("9c30h", function(module, exports) {

$parcel$export(module.exports, "default", () => $01ba2fbfff0d8e73$export$2e2bcd8739ae039);

var $euRUt = parcelRequire("euRUt");

var $9ce0D = parcelRequire("9ce0D");

var $gQlmL = parcelRequire("gQlmL");

var $2v9wJ = parcelRequire("2v9wJ");

var $e4Nvn = parcelRequire("e4Nvn");

var $cUxAV = parcelRequire("cUxAV");

var $jxz5k = parcelRequire("jxz5k");

var $k6Ryt = parcelRequire("k6Ryt");

var $5kx8d = parcelRequire("5kx8d");
function $01ba2fbfff0d8e73$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $cUxAV.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $cUxAV.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $cUxAV.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $k6Ryt.default)(typeof padding !== 'number' ? padding : (0, $5kx8d.default)(padding, (0, $cUxAV.basePlacements)));
    var altContext = elementContext === (0, $cUxAV.popper) ? (0, $cUxAV.reference) : (0, $cUxAV.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $euRUt.default)((0, $jxz5k.isElement)(element) ? element : element.contextElement || (0, $9ce0D.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $gQlmL.default)(state.elements.reference);
    var popperOffsets = (0, $2v9wJ.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $e4Nvn.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $cUxAV.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $cUxAV.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $cUxAV.right),
                (0, $cUxAV.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $cUxAV.top),
                (0, $cUxAV.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("euRUt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8ddaf68f655dcbb$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");

var $9VLoV = parcelRequire("9VLoV");

var $4dh5d = parcelRequire("4dh5d");

var $edd0p = parcelRequire("edd0p");

var $1Z5jy = parcelRequire("1Z5jy");

var $9ce0D = parcelRequire("9ce0D");

var $itp1E = parcelRequire("itp1E");

var $jxz5k = parcelRequire("jxz5k");

var $gQlmL = parcelRequire("gQlmL");

var $6P0Dy = parcelRequire("6P0Dy");

var $lzCV1 = parcelRequire("lzCV1");

var $3Ih4r = parcelRequire("3Ih4r");

var $e4Nvn = parcelRequire("e4Nvn");

var $3Gelu = parcelRequire("3Gelu");
function $a8ddaf68f655dcbb$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $gQlmL.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $a8ddaf68f655dcbb$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $cUxAV.viewport) ? (0, $e4Nvn.default)((0, $9VLoV.default)(element, strategy)) : (0, $jxz5k.isElement)(clippingParent) ? $a8ddaf68f655dcbb$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $e4Nvn.default)((0, $4dh5d.default)((0, $9ce0D.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $a8ddaf68f655dcbb$var$getClippingParents(element) {
    var clippingParents = (0, $edd0p.default)((0, $6P0Dy.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $itp1E.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $jxz5k.isHTMLElement)(element) ? (0, $1Z5jy.default)(element) : element;
    if (!(0, $jxz5k.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $jxz5k.isElement)(clippingParent) && (0, $lzCV1.default)(clippingParent, clipperElement) && (0, $3Ih4r.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $a8ddaf68f655dcbb$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $a8ddaf68f655dcbb$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $a8ddaf68f655dcbb$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $3Gelu.max)(rect.top, accRect.top);
        accRect.right = (0, $3Gelu.min)(rect.right, accRect.right);
        accRect.bottom = (0, $3Gelu.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3Gelu.max)(rect.left, accRect.left);
        return accRect;
    }, $a8ddaf68f655dcbb$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("9VLoV", function(module, exports) {

$parcel$export(module.exports, "default", () => $73ae34c7061d9956$export$2e2bcd8739ae039);

var $eNjCb = parcelRequire("eNjCb");

var $9ce0D = parcelRequire("9ce0D");

var $gIy3I = parcelRequire("gIy3I");

var $2QPpT = parcelRequire("2QPpT");
function $73ae34c7061d9956$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $eNjCb.default)(element);
    var html = (0, $9ce0D.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $2QPpT.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $gIy3I.default)(element),
        y: y
    };
}

});

parcelRegister("4dh5d", function(module, exports) {

$parcel$export(module.exports, "default", () => $3115a0ad95105587$export$2e2bcd8739ae039);

var $9ce0D = parcelRequire("9ce0D");

var $itp1E = parcelRequire("itp1E");

var $gIy3I = parcelRequire("gIy3I");

var $hRE8q = parcelRequire("hRE8q");

var $3Gelu = parcelRequire("3Gelu");
function $3115a0ad95105587$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $9ce0D.default)(element);
    var winScroll = (0, $hRE8q.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $3Gelu.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $3Gelu.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $gIy3I.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $itp1E.default)(body || html).direction === 'rtl') x += (0, $3Gelu.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("lzCV1", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb4b0e4a19431f61$export$2e2bcd8739ae039);

var $jxz5k = parcelRequire("jxz5k");
function $fb4b0e4a19431f61$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $jxz5k.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("e4Nvn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3f7d713ddb7bbc6$export$2e2bcd8739ae039);
function $a3f7d713ddb7bbc6$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("k6Ryt", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea3de91a59864afc$export$2e2bcd8739ae039);

var $5ZEXv = parcelRequire("5ZEXv");
function $ea3de91a59864afc$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $5ZEXv.default)(), paddingObject);
}

});
parcelRegister("5ZEXv", function(module, exports) {

$parcel$export(module.exports, "default", () => $45d26bcdb7eb1b34$export$2e2bcd8739ae039);
function $45d26bcdb7eb1b34$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("5kx8d", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e1885427cc06434$export$2e2bcd8739ae039);
function $3e1885427cc06434$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("cnkWG", function(module, exports) {

$parcel$export(module.exports, "default", () => $9027e15f6f74b552$export$2e2bcd8739ae039);

var $hqMUN = parcelRequire("hqMUN");

var $cUxAV = parcelRequire("cUxAV");

var $9c30h = parcelRequire("9c30h");

var $i0vbU = parcelRequire("i0vbU");
function $9027e15f6f74b552$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $cUxAV.placements) : _options$allowedAutoP;
    var variation = (0, $hqMUN.default)(placement);
    var placements = variation ? flipVariations ? (0, $cUxAV.variationPlacements) : (0, $cUxAV.variationPlacements).filter(function(placement) {
        return (0, $hqMUN.default)(placement) === variation;
    }) : (0, $cUxAV.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $9c30h.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $i0vbU.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("e0gkO", function(module, exports) {

$parcel$export(module.exports, "default", () => $a31dbc8612778f59$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");

var $i0vbU = parcelRequire("i0vbU");

var $lM4La = parcelRequire("lM4La");

var $3ZBe7 = parcelRequire("3ZBe7");

var $1lJXP = parcelRequire("1lJXP");

var $3F4KV = parcelRequire("3F4KV");

var $1Z5jy = parcelRequire("1Z5jy");

var $9c30h = parcelRequire("9c30h");

var $hqMUN = parcelRequire("hqMUN");

var $5ZEXv = parcelRequire("5ZEXv");

var $3Gelu = parcelRequire("3Gelu");
function $a31dbc8612778f59$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $9c30h.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $i0vbU.default)(state.placement);
    var variation = (0, $hqMUN.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $lM4La.default)(basePlacement);
    var altAxis = (0, $3ZBe7.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $cUxAV.top) : (0, $cUxAV.left);
        var altSide = mainAxis === 'y' ? (0, $cUxAV.bottom) : (0, $cUxAV.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $cUxAV.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $cUxAV.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $3F4KV.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $5ZEXv.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $1lJXP.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $1Z5jy.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $1lJXP.within)(tether ? (0, $3Gelu.min)(min, tetherMin) : min, offset, tether ? (0, $3Gelu.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $cUxAV.top) : (0, $cUxAV.left);
        var _altSide = mainAxis === 'x' ? (0, $cUxAV.bottom) : (0, $cUxAV.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $cUxAV.top),
            (0, $cUxAV.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $1lJXP.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $1lJXP.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $a31dbc8612778f59$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $a31dbc8612778f59$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("3ZBe7", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e83f21121a987af$export$2e2bcd8739ae039);
function $2e83f21121a987af$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("1lJXP", function(module, exports) {

$parcel$export(module.exports, "within", () => $0fbb681521294cde$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $0fbb681521294cde$export$86c8af6d3ef0b4a);

var $3Gelu = parcelRequire("3Gelu");
function $0fbb681521294cde$export$f28d906d67a997f3(min, value, max) {
    return (0, $3Gelu.max)(min, (0, $3Gelu.min)(value, max));
}
function $0fbb681521294cde$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $0fbb681521294cde$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("RxAbB", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a0f002a9e1932ee$export$2e2bcd8739ae039);

var $i0vbU = parcelRequire("i0vbU");

var $3F4KV = parcelRequire("3F4KV");

var $lzCV1 = parcelRequire("lzCV1");

var $1Z5jy = parcelRequire("1Z5jy");

var $lM4La = parcelRequire("lM4La");

var $1lJXP = parcelRequire("1lJXP");

var $k6Ryt = parcelRequire("k6Ryt");

var $5kx8d = parcelRequire("5kx8d");

var $cUxAV = parcelRequire("cUxAV");
var $0a0f002a9e1932ee$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $k6Ryt.default)(typeof padding !== 'number' ? padding : (0, $5kx8d.default)(padding, (0, $cUxAV.basePlacements)));
};
function $0a0f002a9e1932ee$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $i0vbU.default)(state.placement);
    var axis = (0, $lM4La.default)(basePlacement);
    var isVertical = [
        (0, $cUxAV.left),
        (0, $cUxAV.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $0a0f002a9e1932ee$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $3F4KV.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $cUxAV.top) : (0, $cUxAV.left);
    var maxProp = axis === 'y' ? (0, $cUxAV.bottom) : (0, $cUxAV.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $1Z5jy.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $1lJXP.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $0a0f002a9e1932ee$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $lzCV1.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $0a0f002a9e1932ee$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $0a0f002a9e1932ee$var$arrow,
    effect: $0a0f002a9e1932ee$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("4Jkbd", function(module, exports) {

$parcel$export(module.exports, "default", () => $371b04b800cbe6bc$export$2e2bcd8739ae039);

var $cUxAV = parcelRequire("cUxAV");

var $9c30h = parcelRequire("9c30h");
function $371b04b800cbe6bc$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $371b04b800cbe6bc$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $cUxAV.top),
        (0, $cUxAV.right),
        (0, $cUxAV.bottom),
        (0, $cUxAV.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $371b04b800cbe6bc$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $9c30h.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $9c30h.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $371b04b800cbe6bc$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $371b04b800cbe6bc$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $371b04b800cbe6bc$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $371b04b800cbe6bc$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $371b04b800cbe6bc$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $371b04b800cbe6bc$var$hide
};

});




parcelRegister("6XvxP", function(module, exports) {

$parcel$export(module.exports, "Reference", () => $5110b8d9e7655c91$export$e0be378c32fb70a7);

var $eUqFw = parcelRequire("eUqFw");

var $k6muC = parcelRequire("k6muC");

var $3aVBa = parcelRequire("3aVBa");

var $4J8wt = parcelRequire("4J8wt");
function $5110b8d9e7655c91$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $eUqFw.useContext((0, $3aVBa.ManagerReferenceNodeSetterContext));
    var refHandler = $eUqFw.useCallback(function(node) {
        (0, $4J8wt.setRef)(innerRef, node);
        (0, $4J8wt.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $eUqFw.useEffect(function() {
        return function() {
            return (0, $4J8wt.setRef)(innerRef, null);
        };
    }, []);
    $eUqFw.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $4J8wt.unwrapArray)(children)({
        ref: refHandler
    });
}

});

parcelRegister("asNSH", function(module, exports) {

$parcel$export(module.exports, "shallowEqualObjects", () => $c9294410708307cc$export$3e67810a3f0e9f1c);
function $c9294410708307cc$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $c9294410708307cc$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $c9294410708307cc$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $c9294410708307cc$export$967a6b9924a689f7(a, b);
    return $c9294410708307cc$export$3e67810a3f0e9f1c(a, b);
}

});

parcelRegister("7ldaw", function(module, exports) {

$parcel$export(module.exports, "MenuDialog", () => $e208c4fdfb4dbbc3$export$c94219dad7c0e37d);
$parcel$export(module.exports, "DummyControl", () => $e208c4fdfb4dbbc3$export$87ce933b7fc29b8c);
$parcel$export(module.exports, "defaultComponents", () => $e208c4fdfb4dbbc3$export$71abc632aa29e6fe);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $jQxSL = parcelRequire("jQxSL");

var $byn9U = parcelRequire("byn9U");

var $lkPEe = parcelRequire("lkPEe");

var $bPZtE = parcelRequire("bPZtE");

var $lcnyw = parcelRequire("lcnyw");

var $PdmhA = parcelRequire("PdmhA");
function $e208c4fdfb4dbbc3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e208c4fdfb4dbbc3$var$menuDialogStyles = /*#__PURE__*/ (0, $byn9U.css)({
    backgroundColor: "var(--ds-surface-overlay, white)",
    borderRadius: "var(--ds-border-radius-100, 4px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $PdmhA.N40A)}, 0 4px 11px ${(0, $PdmhA.N40A)}`})`,
    zIndex: (0, $lcnyw.layers).modal()
});
const $e208c4fdfb4dbbc3$export$c94219dad7c0e37d = ({ maxWidth: maxWidth, minWidth: minWidth, children: children, id: id, style: style, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $e208c4fdfb4dbbc3$var$menuDialogStyles,
            // There is not a limited amount of values for the widths, so they need
            // to remain dynamic.
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            {
                maxWidth: maxWidth,
                minWidth: minWidth
            }
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        id: id,
        "data-testid": testId && `${testId}--menu`
    }, children);
// ==============================
// Custom Components
// ==============================
const $e208c4fdfb4dbbc3$var$dropdownStyles = {
    name: "1sujbl1",
    styles: "margin-inline-end:var(--ds-space-025, 2px);text-align:center;width:32px"
};
const $e208c4fdfb4dbbc3$var$DropdownIndicator = ()=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $e208c4fdfb4dbbc3$var$dropdownStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bPZtE))), {
        label: "open"
    }));
const $e208c4fdfb4dbbc3$var$controlStyles = /*#__PURE__*/ (0, $byn9U.css)({
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-050, 4px)"}`
});
const $e208c4fdfb4dbbc3$var$Control = ({ innerRef: innerRef, innerProps: innerProps, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: innerRef,
        css: $e208c4fdfb4dbbc3$var$controlStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).Control, {
        ...props,
        innerProps: innerProps
    }));
const $e208c4fdfb4dbbc3$export$87ce933b7fc29b8c = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $lkPEe.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).Control, props));
// NOTE `props` intentionally omitted from `Fragment`
const $e208c4fdfb4dbbc3$var$Menu = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", innerProps, children);
const $e208c4fdfb4dbbc3$export$71abc632aa29e6fe = {
    Control: $e208c4fdfb4dbbc3$var$Control,
    DropdownIndicator: $e208c4fdfb4dbbc3$var$DropdownIndicator,
    Menu: $e208c4fdfb4dbbc3$var$Menu
};

});
parcelRegister("bPZtE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $89e4253a013a6022$var$_react = $89e4253a013a6022$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $89e4253a013a6022$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $89e4253a013a6022$var$EditorSearchIcon = (props)=>/*#__PURE__*/ $89e4253a013a6022$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M14.823 15.883a5.5 5.5 0 111.06-1.06l2.647 2.647c.293.293.53.59 0 1.06-.53.47-.767.293-1.06 0l-2.647-2.647zM11.5 15.5a4 4 0 100-8 4 4 0 000 8z" fill="currentColor"/></svg>`
    }, props));
$89e4253a013a6022$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
var $89e4253a013a6022$var$_default = $89e4253a013a6022$var$EditorSearchIcon;
module.exports.default = $89e4253a013a6022$var$_default;

});





parcelRegister("b9ITu", function(module, exports) {

$parcel$export(module.exports, "batchByKey", () => $6fd848c9243cf2a4$export$da86c38211c1c0a8);
function $6fd848c9243cf2a4$export$da86c38211c1c0a8(callback) {
    const calls = {};
    return (key, ...args)=>{
        if (!calls[key]) {
            window.setTimeout(()=>{
                callback(key, calls[key]);
                delete calls[key];
            });
            calls[key] = [];
        }
        calls[key].push(args);
    };
}

});

parcelRegister("hAQEH", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0166325e684f6a54$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $0166325e684f6a54$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    placeholder: {
        id: 'fabric.elements.user-picker.placeholder',
        defaultMessage: 'Enter people or teams...',
        description: 'Placeholder description for empty user/team/email select field.'
    },
    addMore: {
        id: 'fabric.elements.user-picker.placeholder.add-more',
        defaultMessage: 'add more people...',
        description: 'Placeholder for multi user picker when the field is not empty.'
    },
    remove: {
        id: 'fabric.elements.user-picker.multi.remove-item',
        defaultMessage: 'Remove',
        description: 'Tooltip for the single item remove button in a multi user select field.'
    },
    clear: {
        id: 'fabric.elements.user-picker.single.clear',
        defaultMessage: 'Clear',
        description: 'Tooltip for clear button in the single user select field.'
    },
    errorMessage: {
        id: 'fabric.elements.user-picker.error.message',
        defaultMessage: 'Something went wrong',
        description: 'Error message to display when options fail to load.'
    },
    memberCountWithoutYou: {
        id: 'fabric.elements.user-picker.team.member.count',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}",
        description: 'Byline to show the number of members in the team when the current user is not a member of the team'
    },
    memberCountWithYou: {
        id: 'fabric.elements.user-picker.team.member.count.including.you',
        defaultMessage: "Team \u2022 {count} {count, plural, one {member} other {members}}, including you",
        description: 'Byline to show the number of members in the team when the current user is also a member of the team'
    },
    plus50MembersWithoutYou: {
        id: 'fabric.elements.user-picker.team.member.50plus',
        defaultMessage: "Team \u2022 50+ members",
        description: 'Byline to show the number of members in the team when the number exceeds 50'
    },
    plus50MembersWithYou: {
        id: 'fabric.elements.user-picker.team.member.50plus.including.you',
        defaultMessage: "Team \u2022 50+ members, including you",
        description: 'Byline to show the number of members in the team when the number exceeds 50 and also includes the current user'
    },
    addEmail: {
        id: 'fabric.elements.user-picker.email.add',
        defaultMessage: 'Add user',
        description: 'Byline for valid email option.'
    },
    selectToAddEmail: {
        id: 'fabric.elements.user-picker.email.select.to.add',
        defaultMessage: 'Select an email address',
        description: 'Byline for valid email option.'
    },
    continueToAddEmail: {
        id: 'fabric.elements.user-picker.email.add.potential',
        defaultMessage: 'Enter an email address',
        description: 'Byline for a potentially valid email option.'
    },
    groupByline: {
        id: 'fabric.elements.user-picker.group.byline',
        defaultMessage: 'Admin-managed group',
        description: 'Byline for admin-managed groups'
    },
    externalUserSourcesHeading: {
        id: 'fabric.elements.user-picker.external.sourced.from',
        defaultMessage: 'Found in:',
        description: 'From where the external user is coming'
    },
    externalUserSourcesError: {
        id: 'fabric.elements.user-picker.external.sourced.error',
        defaultMessage: "We can't connect you right now.",
        description: "Error message when we can't fetch a user's import sources"
    },
    slackProvider: {
        id: 'fabric.elements.user-picker.slack.provider',
        defaultMessage: 'Slack',
        description: 'This external user is sourced from Slack provider'
    },
    googleProvider: {
        id: 'fabric.elements.user-picker.google.provider',
        defaultMessage: 'Google',
        description: 'This external user is sourced from Google provider'
    },
    microsoftProvider: {
        id: 'fabric.elements.user-picker.microsoft.provider',
        defaultMessage: 'Microsoft',
        description: 'This external user is sourced from Microsoft provider'
    },
    gitHubProvider: {
        id: 'fabric.elements.user-picker.github.provider',
        defaultMessage: 'GitHub',
        description: 'This external user is sourced from GitHub provider'
    },
    jiraSource: {
        id: 'fabric.elements.user-picker.source.jira',
        defaultMessage: 'Jira',
        description: 'This external user is sourced from Jira'
    },
    confluenceSource: {
        id: 'fabric.elements.user-picker.source.confluence',
        defaultMessage: 'Confluence',
        description: 'This external user is sourced from Confluence'
    },
    otherAtlassianSource: {
        id: 'fabric.elements.user-picker.source.other-atlassian',
        defaultMessage: 'Other Atlassian products',
        description: 'This external user is sourced from Atlassian products other than Jira and Confluence'
    },
    memberLozengeText: {
        id: 'fabric.elements.user-picker.member.lozenge.text',
        defaultMessage: 'MEMBER',
        description: 'Text within the Lozenge when the user is a workspace member'
    },
    guestLozengeText: {
        id: 'fabric.elements.user-picker.guest.lozenge.text',
        defaultMessage: 'GUEST',
        description: 'Text within the lozenge when the user is a guest of confluence'
    },
    guestUserLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.user',
        defaultMessage: 'Guests can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for guest lozenge showing that a user is a guest in Confluence'
    },
    guestGroupLozengeTooltip: {
        id: 'fabric.elements.user-picker.guest.lozenge.tooltip.group',
        defaultMessage: 'Guest groups can only access certain spaces and have limited access to user info.',
        description: 'Tooltip text for lozenge showing that a group is for guests in Confluence'
    }
});

});

parcelRegister("a1Z9P", function(module, exports) {

$parcel$export(module.exports, "userPickerRenderedUfoExperience", () => $542454000b8812af$export$b49757166e1acfc2);
$parcel$export(module.exports, "userPickerOptionsShownUfoExperience", () => $542454000b8812af$export$135a264e0da507ae);
$parcel$export(module.exports, "UfoErrorBoundary", () => $542454000b8812af$export$5ef1c2550074a375);

var $eUqFw = parcelRequire("eUqFw");

var $2kFUE = parcelRequire("2kFUE");
var $3yYXq = parcelRequire("3yYXq");
var $uMitL = parcelRequire("uMitL");
const $542454000b8812af$export$b49757166e1acfc2 = new (0, $2kFUE.ConcurrentExperience)('user-picker-rendered', {
    platform: {
        component: 'user-picker'
    },
    type: (0, $3yYXq.ExperienceTypes).Load,
    performanceType: (0, $3yYXq.ExperiencePerformanceTypes).PageSegmentLoad
});
const $542454000b8812af$export$135a264e0da507ae = new (0, $2kFUE.ConcurrentExperience)('user-picker-options-shown', {
    platform: {
        component: 'user-picker'
    },
    type: (0, $3yYXq.ExperienceTypes).Operation,
    performanceType: (0, $3yYXq.ExperiencePerformanceTypes).InlineResult
});
class $542454000b8812af$export$5ef1c2550074a375 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    componentDidCatch() {
        const instance = $542454000b8812af$export$b49757166e1acfc2.getInstance(this.props.id);
        if (instance.state.id !== (0, $uMitL.UFOExperienceState).FAILED.id) instance.failure();
    }
    render() {
        return this.props.children;
    }
}

});


parcelRegister("dTS4n", function(module, exports) {

$parcel$export(module.exports, "BORDER_PADDING", () => $c46738fef3a1a380$export$59c188914e58c94b);
$parcel$export(module.exports, "getStyles", () => $c46738fef3a1a380$export$ffd58b7f6f099a57);
$parcel$export(module.exports, "getPopupStyles", () => $c46738fef3a1a380$export$4e983f376ad8a3af);

var $PdmhA = parcelRequire("PdmhA");

var $5iWql = parcelRequire("5iWql");

var $cEc3i = parcelRequire("cEc3i");
const $c46738fef3a1a380$export$59c188914e58c94b = "var(--ds-space-075, 6px)";
const $c46738fef3a1a380$export$53937c04f7dfc2ae = 6;
const $c46738fef3a1a380$export$2c62ba763e976c54 = 39;
const $c46738fef3a1a380$export$ffd58b7f6f099a57 = (0, $5iWql.default)((width, isMulti, isCompact, overrideStyles)=>{
    let styles = {
        menu: (css, state)=>({
                ...css,
                width: width,
                minWidth: state.selectProps.menuMinWidth,
                zIndex: '400'
            }),
        menuList: (css)=>({
                ...css,
                zIndex: '400'
            }),
        control: (css, state)=>{
            const isMulti = state.selectProps.isMulti;
            return {
                ...css,
                width: width,
                borderColor: state.isFocused ? `var(--ds-border-focused, ${css.borderColor})` : state.selectProps.subtle || state.selectProps.noBorder ? 'transparent' : `var(--ds-border-input, ${0, $PdmhA.N90})`,
                backgroundColor: state.isFocused ? `var(--ds-background-input, ${css['backgroundColor']})` : state.selectProps.subtle ? 'transparent' : state.selectProps.textFieldBackgroundColor ? `var(--ds-background-input, ${0, $PdmhA.N10})` : `var(--ds-background-input, ${0, $PdmhA.N20})`,
                '&:hover .fabric-user-picker__clear-indicator': {
                    opacity: 1
                },
                ':hover': {
                    ...css[':hover'],
                    borderColor: state.isFocused ? css[':hover'] ? `var(--ds-border-focused, ${css[':hover'].borderColor})` : `var(--ds-border-focused, ${0, $PdmhA.B100})` : state.selectProps.subtle ? 'transparent' : `var(--ds-border-input, ${0, $PdmhA.N90})`,
                    backgroundColor: state.selectProps.subtle && state.selectProps.hoveringClearIndicator ? `var(--ds-background-danger, ${0, $PdmhA.R50})` : state.isFocused ? css[':hover'] ? `var(--ds-background-input, ${css[':hover'].backgroundColor})` : `var(--ds-background-input, ${0, $PdmhA.N0})` : state.isDisabled ? `var(--ds-background-disabled, ${0, $PdmhA.N10})` : `var(--ds-background-input-hovered, ${0, $PdmhA.N30})`
                },
                padding: 0,
                minHeight: isCompact ? 'none' : 44,
                /* IE 11 needs to set height explicitly to be vertical align when being in not compact mode */ height: isCompact || isMulti ? '100%' : 44,
                maxWidth: '100%'
            };
        },
        clearIndicator: ({ paddingTop: paddingTop, paddingBottom: paddingBottom, paddingLeft: paddingLeft, paddingRight: paddingRight, ...css })=>({
                ...css,
                // By default show clear indicator, except for on devices where "hover" is supported.
                // This means mobile devices (which do not support hover) will be able to see the clear indicator.
                opacity: 1,
                '@media (hover: hover) and (pointer: fine)': {
                    opacity: 0
                },
                transition: css.transition + ', opacity 150ms',
                paddingTop: 0,
                padding: 0,
                ':hover': {
                    color: `var(--ds-icon-danger, ${0, $PdmhA.R400})`
                }
            }),
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        valueContainer: ({ paddingTop: paddingTop, paddingBottom: paddingBottom, position: position, ...css }, state)=>{
            const isMulti = state.selectProps.isMulti;
            return {
                ...css,
                gridTemplateColumns: 'auto 1fr',
                paddingTop: isCompact ? 0 : $c46738fef3a1a380$export$59c188914e58c94b,
                paddingBottom: isCompact ? 0 : $c46738fef3a1a380$export$59c188914e58c94b,
                paddingLeft: isMulti ? $c46738fef3a1a380$export$59c188914e58c94b : 0,
                overflowX: 'hidden',
                overflowY: 'auto',
                scrollbarWidth: 'none',
                maxHeight: state.selectProps.maxPickerHeight || '100%',
                '::-webkit-scrollbar': {
                    width: 0,
                    background: 'transparent'
                }
            };
        },
        multiValue: (css)=>({
                ...css,
                borderRadius: 24,
                cursor: 'default'
            }),
        multiValueLabel: (css)=>({
                ...css,
                fontSize: '100%',
                display: 'flex'
            }),
        multiValueRemove: (css)=>({
                ...css,
                borderRadius: 24,
                cursor: 'pointer'
            }),
        placeholder: (css, state)=>{
            // fix styling in IE 11: when the position is absolute and `left` prop is not defined,
            // IE and other browsers auto calculate value of "left" prop differently,
            // so we want to explicitly set value for the `left` property
            if (css.position === 'absolute' && !css.left) css.left = `${$c46738fef3a1a380$export$59c188914e58c94b}px`;
            return {
                ...css,
                gridArea: '1/2/2/3',
                paddingLeft: state.selectProps.isMulti ? 0 : $c46738fef3a1a380$export$59c188914e58c94b,
                /* Margin left right of 2px set by default */ // margin: `0 ${BORDER_PADDING}px`,
                margin: 0,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            };
        },
        option: (css)=>({
                ...css,
                overflow: 'hidden'
            }),
        input: (css, state)=>({
                ...css,
                gridArea: '1/2/2/3',
                gridTemplateColumns: isMulti && state.placeholder ? '0 123px' : css.gridTemplateColumns,
                /* Necessary to make input height and tag height the same. */ margin: `${"var(--ds-space-050, 4px)"} 0`,
                /* Padding top and bottom of 2 is set by default. */ paddingTop: 0,
                paddingBottom: 0,
                paddingLeft: state.selectProps.isMulti ? 0 : $c46738fef3a1a380$export$59c188914e58c94b,
                '& input::placeholder': {
                    /* Chrome, Firefox, Opera, Safari 10.1+ */ color: `var(--ds-text-subtlest, ${0, $PdmhA.N100})`,
                    opacity: 1 /* Firefox */ 
                },
                '& input:-ms-input-placeholder': {
                    /* Internet Explorer 10-11 */ color: `var(--ds-text-subtlest, ${0, $PdmhA.N100})`
                }
            }),
        singleValue: (css)=>({
                ...css,
                margin: 0,
                gridArea: '1/2/2/3'
            })
    };
    return overrideStyles ? (0, $cEc3i.m)(styles, overrideStyles) : styles;
});
const $c46738fef3a1a380$export$4e983f376ad8a3af = (0, $5iWql.default)((width, isMulti, overrideStyles)=>({
        ...$c46738fef3a1a380$export$ffd58b7f6f099a57(width, isMulti, false, overrideStyles)
    }));

});

parcelRegister("4dR1n", function(module, exports) {

$parcel$export(module.exports, "getComponents", () => $a3dbd76a262a50b0$export$4e811121b221213b);
$parcel$export(module.exports, "getPopupComponents", () => $a3dbd76a262a50b0$export$19205fd341a6bb08);

var $5iWql = parcelRequire("5iWql");

var $bEfg9 = parcelRequire("bEfg9");

var $y5ydU = parcelRequire("y5ydU");

var $3oEge = parcelRequire("3oEge");

var $g5mgF = parcelRequire("g5mgF");

var $lftfg = parcelRequire("lftfg");

var $aRUd7 = parcelRequire("aRUd7");

var $cRDmG = parcelRequire("cRDmG");

var $5Hu7b = parcelRequire("5Hu7b");

var $6BfkR = parcelRequire("6BfkR");

var $bP6rt = parcelRequire("bP6rt");
const $a3dbd76a262a50b0$export$4e811121b221213b = (0, $5iWql.default)((multi, anchor)=>{
    if (anchor) return {
        Control: anchor,
        Option: $g5mgF.Option
    };
    else return {
        MultiValue: $y5ydU.MultiValue,
        DropdownIndicator: null,
        SingleValue: $lftfg.SingleValue,
        ClearIndicator: multi ? null : (0, $bEfg9.ClearIndicator),
        Option: $g5mgF.Option,
        ValueContainer: multi ? (0, $3oEge.MultiValueContainer) : (0, $cRDmG.SingleValueContainer),
        Input: $aRUd7.Input,
        Menu: $bP6rt.Menu
    };
});
const $a3dbd76a262a50b0$export$19205fd341a6bb08 = (0, $5iWql.default)((hasPopupTitle)=>{
    const baseProps = {
        DropdownIndicator: null,
        SingleValue: $lftfg.SingleValue,
        ClearIndicator: $bEfg9.ClearIndicator,
        Option: $g5mgF.Option,
        ValueContainer: (0, $cRDmG.SingleValueContainer),
        Input: (0, $5Hu7b.PopupInput)
    };
    if (hasPopupTitle) return {
        ...baseProps,
        Control: (0, $6BfkR.PopupControl)
    };
    return baseProps;
});

});
parcelRegister("bEfg9", function(module, exports) {

$parcel$export(module.exports, "ClearIndicator", () => $29bd55272a291249$export$ecf9cf59142dd54a);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

const $29bd55272a291249$var$AsyncTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).lazy(()=>(parcelRequire("18Hlr")).then((module)=>{
        return {
            default: module.default
        };
    }));
class $29bd55272a291249$export$ecf9cf59142dd54a extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    render() {
        const { selectProps: { clearValueLabel: clearValueLabel } } = this.props;
        const Indicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).ClearIndicator, {
            ...this.props,
            innerProps: {
                ...this.props.innerProps,
                onMouseDown: this.handleMouseDown
            }
        });
        return clearValueLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Suspense, {
            fallback: Indicator
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($29bd55272a291249$var$AsyncTooltip, {
            content: clearValueLabel
        }, Indicator)) : Indicator;
    }
    constructor(...args){
        super(...args);
        this.handleMouseDown = (event)=>{
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            // Prevent focus when clear on blurred state
            const { clearValue: clearValue, selectProps: selectProps } = this.props;
            clearValue();
            if (selectProps && !selectProps.isFocused) event.stopPropagation();
        };
    }
}

});
parcelRegister("18Hlr", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('d9TBY');
        const value = parcelRequire('fxbL4');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("d9TBY").then(()=>parcelRequire('fxbL4'));
}

});


parcelRegister("y5ydU", function(module, exports) {

$parcel$export(module.exports, "MultiValue", () => $af295f744665a83e$export$419cdf50db8b579);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $jQxSL = parcelRequire("jQxSL");

var $byn9U = parcelRequire("byn9U");

var $6CQF2 = parcelRequire("6CQF2");

var $fWEEw = parcelRequire("fWEEw");

var $hAQEH = parcelRequire("hAQEH");

var $cHYJ6 = parcelRequire("cHYJ6");

var $4nce6 = parcelRequire("4nce6");
const $af295f744665a83e$export$118122ebc1e626fa = (valueContainer, control)=>{
    const { top: top, height: height } = valueContainer.getBoundingClientRect();
    const { height: controlHeight } = control.getBoundingClientRect();
    if (top - height < 0) valueContainer.scrollIntoView();
    if (top + height > controlHeight) valueContainer.scrollIntoView(false);
};
const $af295f744665a83e$var$groupTagContainer = (0, $1ZAYh.xcss)({
    paddingLeft: 'space.025'
});
const $af295f744665a83e$var$nameWrapper = /*#__PURE__*/ (0, $byn9U.css)({
    paddingLeft: `${"var(--ds-space-050, 4px)"}`
});
class $af295f744665a83e$export$419cdf50db8b579 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(props){
        super(props);
        this.getElemBefore = ()=>{
            const { data: { data: data }, selectProps: selectProps } = this.props;
            if ((0, $cHYJ6.isEmail)(data)) return selectProps.emailLabel ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $6CQF2.AddOptionAvatar), {
                isLozenge: true,
                label: selectProps.emailLabel
            }) : /*#__PURE__*/ (0, $byn9U.jsx)((0, $8uD7Y.default), (0, $hAQEH.messages).addEmail, (label)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $6CQF2.AddOptionAvatar), {
                    isLozenge: true,
                    label: label
                }));
            if ((0, $cHYJ6.isGroup)(data)) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
                xcss: $af295f744665a83e$var$groupTagContainer
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4nce6))), {
                label: "group-icon",
                size: "small"
            }));
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $fWEEw.SizeableAvatar), {
                appearance: "multi",
                src: (0, $cHYJ6.getAvatarUrl)(data)
            });
        };
        this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
    }
    componentDidUpdate() {
        const { isFocused: isFocused } = this.props;
        if (isFocused && this.containerRef.current && this.containerRef.current.parentElement && this.containerRef.current.parentElement.parentElement) $af295f744665a83e$export$118122ebc1e626fa(this.containerRef.current, this.containerRef.current.parentElement.parentElement);
    }
    shouldComponentUpdate(nextProps) {
        const { data: { label: label, data: data }, innerProps: innerProps, isFocused: isFocused } = this.props;
        const { data: { label: nextLabel, data: nextData }, innerProps: nextInnerProps, isFocused: nextIsFocused } = nextProps;
        // We can ignore onRemove here because it is an anonymous function
        // that will be recreated every time but with the same implementation.
        return data !== nextData || label !== nextLabel || innerProps !== nextInnerProps || isFocused !== nextIsFocused;
    }
    render() {
        const { children: children, innerProps: innerProps, ...rest } = this.props;
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).MultiValue, {
            ...rest,
            innerProps: {
                ref: this.containerRef
            },
            cropWithEllipsis: false
        }, this.getElemBefore(), " ", /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $af295f744665a83e$var$nameWrapper
        }, children));
    }
}

});
parcelRegister("6CQF2", function(module, exports) {

$parcel$export(module.exports, "AddOptionAvatar", () => $9d5e4069310b8c35$export$df396db45e491922);
/** @jsx jsx */ 
var $8IVhP = parcelRequire("8IVhP");

var $PdmhA = parcelRequire("PdmhA");

var $byn9U = parcelRequire("byn9U");
parcelRequire("eUqFw");
const $9d5e4069310b8c35$var$getEmailAvatarWrapperStyle = (isLozenge)=>{
    const padding = isLozenge ? `${"var(--ds-space-0, 0px)"}` : `${"var(--ds-space-050, 4px)"}`;
    return /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: padding,
        backgroundColor: `var(--ds-background-neutral, ${(0, $PdmhA.N40)})`,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center'
    });
};
const $9d5e4069310b8c35$export$df396db45e491922 = ({ isLozenge: isLozenge, label: label })=>{
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $9d5e4069310b8c35$var$getEmailAvatarWrapperStyle(isLozenge)
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8IVhP))), {
        label: label,
        size: isLozenge ? 'small' : 'medium',
        primaryColor: `var(--ds-text-subtle, ${(0, $PdmhA.N500)})`
    })));
};

});
parcelRegister("8IVhP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $659edeb603307d4b$var$_react = $659edeb603307d4b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $659edeb603307d4b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $659edeb603307d4b$var$EmailIcon = (props)=>/*#__PURE__*/ $659edeb603307d4b$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M5 7v10h14V7H5zm14-2c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2h14z" fill-rule="nonzero"/><path d="M5.498 6.5H3.124c.149.44.399.854.75 1.205l5.882 5.881a3.117 3.117 0 004.41 0l5.882-5.881c.35-.351.6-.765.749-1.205h-2.373l-5.672 5.672a1.119 1.119 0 01-1.583 0L5.498 6.5z"/></g></svg>`
    }, props));
$659edeb603307d4b$var$EmailIcon.displayName = 'EmailIcon';
var $659edeb603307d4b$var$_default = $659edeb603307d4b$var$EmailIcon;
module.exports.default = $659edeb603307d4b$var$_default;

});


parcelRegister("fWEEw", function(module, exports) {

$parcel$export(module.exports, "SizeableAvatar", () => $c352fe32cb3aa4c8$export$44d81a88129649da);

var $iJlfe = parcelRequire("iJlfe");

var $3Dk5Z = parcelRequire("3Dk5Z");

var $eUqFw = parcelRequire("eUqFw");

var $cHYJ6 = parcelRequire("cHYJ6");
class $c352fe32cb3aa4c8$export$44d81a88129649da extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    render() {
        const { src: src, presence: presence, appearance: appearance, type: type = 'person' } = this.props;
        const props = {
            size: (0, $cHYJ6.getAvatarSize)(appearance),
            src: src,
            borderColor: 'transparent',
            presence: presence
        };
        return type === 'team' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Dk5Z.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), props);
    }
}

});
parcelRegister("3Dk5Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $1869a65c00213d53$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $PdmhA = parcelRequire("PdmhA");

var $eJ2Jf = parcelRequire("eJ2Jf");
const $1869a65c00213d53$export$ebe0b8fe8b6acbfd = `var(--ds-icon-inverse, ${(0, $PdmhA.N0)})`;
const $1869a65c00213d53$export$72502e51aebdd94e = `var(--ds-icon-subtle, ${(0, $PdmhA.N90)})`;
function $1869a65c00213d53$export$2e2bcd8739ae039({ testId: testId, src: src, size: size = 'medium', ...props }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        appearance: "circle",
        ...props,
        size: size,
        src: src,
        testId: `${testId}-team-avatar`
    }, (innerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eJ2Jf.TeamAvatarImage), {
            src: src,
            size: size,
            testId: testId,
            ...innerProps
        }));
}

});
parcelRegister("eJ2Jf", function(module, exports) {

$parcel$export(module.exports, "TeamAvatarImage", () => $3fb7f58cf3c7f578$export$ac3673635a5387be);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $eri7S = parcelRequire("eri7S");

var $4nce6 = parcelRequire("4nce6");

var $PdmhA = parcelRequire("PdmhA");
function $3fb7f58cf3c7f578$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3fb7f58cf3c7f578$var$ICON_BACKGROUND = `var(--ds-icon-inverse, ${(0, $PdmhA.N0)})`;
const $3fb7f58cf3c7f578$var$ICON_COLOR = `var(--ds-icon-subtle, ${(0, $PdmhA.N90)})`;
// used in a size calculation so can't be a token. Without this the avatar looks very squished
const $3fb7f58cf3c7f578$var$ICON_PADDING = 4;
const $3fb7f58cf3c7f578$var$avatarDefaultIconStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    backgroundColor: $3fb7f58cf3c7f578$var$ICON_COLOR,
    borderRadius: '50%',
    width: '100%',
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center'
});
const $3fb7f58cf3c7f578$var$nestedAvatarStyles = Object.entries((0, $eri7S.AVATAR_SIZES)).reduce((styles, [key, size])=>{
    return {
        ...styles,
        [key]: /*#__PURE__*/ (0, $byn9U.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${size}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${size}px`,
            // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '& svg': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: `${size - $3fb7f58cf3c7f578$var$ICON_PADDING}px`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: `${size - $3fb7f58cf3c7f578$var$ICON_PADDING}px`
            }
        })
    };
}, {});
const $3fb7f58cf3c7f578$var$avatarImageStyles = {
    name: "n68006",
    styles: "display:flex;flex:1 1 100%;width:100%;height:100%"
};
const $3fb7f58cf3c7f578$export$ac3673635a5387be = ({ alt: alt = '', src: src, size: size, testId: testId, ...rest })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $eUqFw.useState)(false);
    // If src changes, reset state
    (0, $eUqFw.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            $3fb7f58cf3c7f578$var$avatarDefaultIconStyles,
            $3fb7f58cf3c7f578$var$nestedAvatarStyles[size]
        ]
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4nce6))), {
        label: alt,
        primaryColor: $3fb7f58cf3c7f578$var$ICON_BACKGROUND,
        secondaryColor: $3fb7f58cf3c7f578$var$ICON_COLOR,
        testId: testId && `${testId}--team`
    }));
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", rest, /*#__PURE__*/ (0, $byn9U.jsx)("img", {
        src: src,
        alt: alt,
        "data-testid": testId && `${testId}--image`,
        css: $3fb7f58cf3c7f578$var$avatarImageStyles,
        onError: ()=>setHasImageErrored(true)
    }));
};

});




parcelRegister("3oEge", function(module, exports) {

$parcel$export(module.exports, "MultiValueContainer", () => $d9c4f0fcc6c50ee5$export$cf9cf2a30a59265c);

var $jQxSL = parcelRequire("jQxSL");

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $8uD7Y = parcelRequire("8uD7Y");

var $hAQEH = parcelRequire("hAQEH");

var $cHYJ6 = parcelRequire("cHYJ6");

var $8fe8e = parcelRequire("8fe8e");
class $d9c4f0fcc6c50ee5$export$cf9cf2a30a59265c extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    static getDerivedStateFromProps(nextProps, prevState) {
        return {
            valueSize: nextProps.getValue ? nextProps.getValue().length : 0,
            previousValueSize: prevState.valueSize
        };
    }
    constructor(props){
        super(props);
        this.timeoutId = null;
        this.scrollToBottom = ()=>{
            this.timeoutId = window.setTimeout(()=>{
                const { ref: { current: current } } = this.valueContainerInnerProps;
                if (current !== null) {
                    const container = (0, (/*@__PURE__*/$parcel$interopDefault($lEfVV))).findDOMNode(current);
                    if (container instanceof HTMLDivElement) container.scrollTop = container.scrollHeight;
                }
                this.timeoutId = null;
            });
        };
        this.showPlaceholder = ()=>{
            const { selectProps: { value: value } } = this.props;
            return value && value.length > 0;
        };
        this.addPlaceholder = (placeholder)=>{
            const children = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.map(this.props.children, (child)=>(0, $cHYJ6.isChildInput)(child) && this.showPlaceholder() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(child, {
                    placeholder: placeholder
                }) : child);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, children);
        };
        this.renderChildren = ()=>{
            const { selectProps: { addMoreMessage: addMoreMessage, isDisabled: isDisabled } } = this.props;
            // Do not render "Add more..." message if picker is disabled
            if (isDisabled) return this.props.children;
            if (addMoreMessage === undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $hAQEH.messages).addMore, (addMore)=>{
                let addMoreMessages = addMore;
                if (addMore && typeof addMore === 'string') addMoreMessages = [
                    addMore
                ];
                const placeholder = addMoreMessages?.join('') ?? '';
                return this.addPlaceholder(placeholder);
            });
            return this.addPlaceholder(addMoreMessage);
        };
        this.onValueContainerClick = this.props.selectProps.onValueContainerClick;
        this.state = {
            valueSize: 0,
            previousValueSize: 0
        };
        this.valueContainerInnerProps = {
            ref: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef()
        };
    }
    componentDidUpdate() {
        const { previousValueSize: previousValueSize, valueSize: valueSize } = this.state;
        const { isFocused: isFocused } = this.props.selectProps;
        if (valueSize > previousValueSize && isFocused) {
            if (this.timeoutId) {
                window.clearTimeout(this.timeoutId);
                this.timeoutId = null;
            }
            this.scrollToBottom();
        }
    }
    componentWillUnmount() {
        if (this.timeoutId) window.clearTimeout(this.timeoutId);
    }
    render() {
        const { children: children, innerProps: innerProps, ...valueContainerProps } = this.props;
        const props = {
            ...valueContainerProps,
            innerProps: this.valueContainerInnerProps
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8fe8e.default), {
            isEnabled: this.onValueContainerClick,
            onMouseDown: this.onValueContainerClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).ValueContainer, props, this.renderChildren()));
    }
}

});
parcelRegister("8fe8e", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2d958d4fcf0f18b$export$2e2bcd8739ae039);
/** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
function $b2d958d4fcf0f18b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Conditional wrapper for the ValueContainer in Select. Provides a workaround
 * for issues using react-select on react-beautiful-dnd Draggable elements.
 * @returns
 */ var $b2d958d4fcf0f18b$var$_ref = {
    name: "1ff36h2",
    styles: "flex-grow:1"
};
const $b2d958d4fcf0f18b$var$ValueContainerWrapper = ({ children: children, isEnabled: isEnabled, onMouseDown: onMouseDown })=>{
    return isEnabled ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $b2d958d4fcf0f18b$var$_ref,
        onMouseDown: onMouseDown
    }, children) : children;
};
var $b2d958d4fcf0f18b$export$2e2bcd8739ae039 = $b2d958d4fcf0f18b$var$ValueContainerWrapper;

});


parcelRegister("g5mgF", function(module, exports) {

$parcel$export(module.exports, "Option", () => $69e114acf80b738d$export$36d18380658d5d20);

var $b5IAe = parcelRequire("b5IAe");

var $jQxSL = parcelRequire("jQxSL");

var $8cU5f = parcelRequire("8cU5f");

var $eUqFw = parcelRequire("eUqFw");

var $geaMl = parcelRequire("geaMl");

var $eV39A = parcelRequire("eV39A");

var $dqj52 = parcelRequire("dqj52");

var $diO51 = parcelRequire("diO51");

var $4jmtC = parcelRequire("4jmtC");

var $19gl5 = parcelRequire("19gl5");

var $cHYJ6 = parcelRequire("cHYJ6");

var $eL5KE = parcelRequire("eL5KE");
const $69e114acf80b738d$var$defaultOption = ({ data: { data: data }, isSelected: isSelected, status: status })=>// @ts-expect-error - <UserOption> expects `data` to be of User interface, but data is OptionData interface by default. Check if the `user` props in UserOption should also accept OptionData or refactor this file to accept generics
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $geaMl.UserOption), {
        user: data,
        status: status,
        isSelected: isSelected
    });
const $69e114acf80b738d$var$dataOption = ({ data: { data: data }, isSelected: isSelected, status: status, selectProps: selectProps })=>{
    if ((0, $cHYJ6.isExternalUser)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eV39A.default), {
        user: data,
        status: status,
        isSelected: isSelected
    });
    if ((0, $cHYJ6.isUser)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $geaMl.UserOption), {
        user: data,
        status: status,
        isSelected: isSelected
    });
    if ((0, $cHYJ6.isEmail)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4jmtC.default), {
        email: data,
        emailValidity: (0, $eL5KE.isValidEmail)(data.id),
        isSelected: isSelected,
        label: selectProps.emailLabel
    });
    if ((0, $cHYJ6.isTeam)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dqj52.default), {
        team: data,
        isSelected: isSelected
    });
    if ((0, $cHYJ6.isGroup)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $diO51.default), {
        group: data,
        isSelected: isSelected
    });
    if ((0, $cHYJ6.isCustom)(data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $19gl5.default), {
        data: data,
        isSelected: isSelected
    });
    return null;
};
const $69e114acf80b738d$var$dataOptionWithTooltip = (props)=>{
    if (props.data?.data?.tooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: props.data?.data?.tooltip
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), tooltipProps, $69e114acf80b738d$var$dataOption(props)));
    return $69e114acf80b738d$var$dataOption(props);
};
const $69e114acf80b738d$export$36d18380658d5d20 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Suspense, {
        fallback: $69e114acf80b738d$var$defaultOption(props)
    }, $69e114acf80b738d$var$dataOptionWithTooltip(props)));

});
parcelRegister("geaMl", function(module, exports) {

$parcel$export(module.exports, "UserOption", () => $a2ecfda802f63071$export$8e59f78010871662);
/** @jsx jsx */ 
var $PdmhA = parcelRequire("PdmhA");

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $7cBHL = parcelRequire("7cBHL");

var $decpf = parcelRequire("decpf");

var $fWEEw = parcelRequire("fWEEw");

var $cHYJ6 = parcelRequire("cHYJ6");
class $a2ecfda802f63071$export$8e59f78010871662 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $7cBHL.AvatarItemOption), {
            avatar: this.renderAvatar(),
            lozenge: this.getLozengeProps(),
            isDisabled: this.props.user.isDisabled,
            primaryText: this.getPrimaryText(),
            secondaryText: this.renderSecondaryText()
        });
    }
    constructor(...args){
        super(...args);
        this.getPrimaryText = ()=>{
            const { user: { name: name, publicName: publicName, highlight: highlight } } = this.props;
            const result = [
                /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                    key: "name",
                    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    css: (0, $7cBHL.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $PdmhA.B400})` : `var(--ds-text, ${0, $PdmhA.N800})`)
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $decpf.HighlightText), {
                    highlights: highlight && highlight.name
                }, name))
            ];
            if ((0, $cHYJ6.hasValue)(publicName) && name.trim() !== publicName.trim()) result.push(/*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, {
                key: "publicName"
            }, ' ', /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: (0, $7cBHL.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $PdmhA.B400})` : `var(--ds-text-subtlest, ${0, $PdmhA.N200})`)
            }, "(", /*#__PURE__*/ (0, $byn9U.jsx)((0, $decpf.HighlightText), {
                highlights: highlight && highlight.publicName
            }, publicName), ")")));
            return result;
        };
        this.renderSecondaryText = ()=>this.props.user.byline ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: (0, $7cBHL.textWrapper)(this.props.isSelected ? `var(--ds-text-selected, ${0, $PdmhA.B400})` : `var(--ds-text-subtlest, ${0, $PdmhA.N200})`)
            }, this.props.user.byline) : undefined;
        this.renderAvatar = ()=>{
            const { user: { avatarUrl: avatarUrl }, status: status } = this.props;
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $fWEEw.SizeableAvatar), {
                appearance: "big",
                src: avatarUrl,
                presence: status
            });
        };
        this.getLozengeProps = ()=>typeof this.props.user.lozenge === 'string' ? {
                text: this.props.user.lozenge
            } : this.props.user.lozenge;
    }
}

});
parcelRegister("7cBHL", function(module, exports) {

$parcel$export(module.exports, "textWrapper", () => $da888a92b8218389$export$aa6223da92b253dd);
$parcel$export(module.exports, "AvatarItemOption", () => $da888a92b8218389$export$164a9d9b3b86dd0c);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $ffiyv = parcelRequire("ffiyv");

var $cHYJ6 = parcelRequire("cHYJ6");
function $da888a92b8218389$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

const $da888a92b8218389$var$AsyncTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).lazy(()=>(parcelRequire("18Hlr")).then((module)=>{
        return {
            default: module.default
        };
    }));
const $da888a92b8218389$var$wrapper = (isDisabled)=>/*#__PURE__*/ (0, $byn9U.css)({
        alignItems: 'center',
        boxSizing: 'border-box',
        display: 'flex',
        lineHeight: 1,
        outline: 'none',
        margin: 0,
        width: '100%',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: isDisabled ? "var(--ds-opacity-disabled, 0.4)" : undefined
    });
const $da888a92b8218389$var$optionWrapper = {
    name: "yyrqoa",
    styles: "max-width:100%;min-width:0;flex:1 1 100%;line-height:1.4;padding-left:var(--ds-space-100, 8px)"
};
const $da888a92b8218389$var$getTextStyle = (isSecondary)=>{
    const secondaryCssArgs = isSecondary ? {
        fontSize: '0.85em'
    } : {};
    return /*#__PURE__*/ (0, $byn9U.css)({
        margin: 0,
        overflowX: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...secondaryCssArgs
    });
};
const $da888a92b8218389$var$additionalInfo = {
    name: "tjo4qw",
    styles: "float:right"
};
const $da888a92b8218389$export$aa6223da92b253dd = (color)=>/*#__PURE__*/ (0, $byn9U.css)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: 'inline',
        color: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color
    });
const $da888a92b8218389$export$164a9d9b3b86dd0c = ({ avatar: avatar, isDisabled: isDisabled, lozenge: lozenge, primaryText: primaryText, secondaryText: secondaryText })=>{
    const renderLozenge = ()=>{
        if ((0, $cHYJ6.isLozengeText)(lozenge)) {
            if (lozenge?.tooltip) // Note that entire Lozenge must be wrapped in the Tooltip (rather than just the
            // Lozenge text) or tooltip won't work
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Suspense, {
                fallback: /*#__PURE__*/ (0, $byn9U.jsx)((0, $ffiyv.default), lozenge, lozenge.text)
            }, /*#__PURE__*/ (0, $byn9U.jsx)($da888a92b8218389$var$AsyncTooltip, {
                content: lozenge.tooltip
            }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $ffiyv.default), lozenge, lozenge.text)));
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $ffiyv.default), lozenge, lozenge.text);
        }
        return lozenge;
    };
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $da888a92b8218389$var$wrapper(isDisabled)
    }, avatar, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $da888a92b8218389$var$optionWrapper
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", null, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $da888a92b8218389$var$getTextStyle()
    }, primaryText), secondaryText && /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $da888a92b8218389$var$getTextStyle(true)
    }, secondaryText))), lozenge && /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $da888a92b8218389$var$additionalInfo
    }, renderLozenge())));
};

});

parcelRegister("decpf", function(module, exports) {

$parcel$export(module.exports, "HighlightText", () => $394febfe0c687d04$export$bb02e7bc6e1a7119);

var $eUqFw = parcelRequire("eUqFw");
class $394febfe0c687d04$export$bb02e7bc6e1a7119 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    render() {
        const { children: children, highlights: highlights } = this.props;
        const parts = [];
        let lastIndex = 0;
        if (highlights) highlights.sort((a, b)=>a.start - b.start).reduce((highlights, highlight)=>{
            const lastHighlight = highlights[highlights.length - 1];
            if (!lastHighlight || highlight.start > lastHighlight.end + 1) return highlights.concat(highlight);
            if (highlight.end > lastHighlight.end) lastHighlight.end = highlight.end;
            return highlights;
        }, []).forEach((highlight)=>{
            const { start: start, end: end } = highlight;
            if (start >= end) return;
            if (start > lastIndex) parts.push({
                value: children.substring(lastIndex, start),
                matches: false
            });
            parts.push({
                value: children.substring(start, end + 1),
                matches: true
            });
            lastIndex = end + 1;
        });
        if (lastIndex < children.length) parts.push({
            value: children.substring(lastIndex, children.length),
            matches: false
        });
        return parts.map((part, index)=>{
            if (part.matches) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", {
                key: index
            }, part.value);
            return part.value;
        });
    }
}

});


parcelRegister("eV39A", function(module, exports) {

$parcel$export(module.exports, "default", () => $876fe813f4c1c632$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $876fe813f4c1c632$var$AsyncExternalUserOption = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).lazy(()=>(parcelRequire("k8VAH")).then((module)=>{
        return {
            default: module.ExternalUserOption
        };
    }));
var $876fe813f4c1c632$export$2e2bcd8739ae039 = $876fe813f4c1c632$var$AsyncExternalUserOption;

});
parcelRegister("k8VAH", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('h2MrD'),
            load('bYT2S'),
            load('d3tcO')
        ]);
        const value = parcelRequire('ipFJ8');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("h2MrD"),
        load("bYT2S"),
        load("d3tcO")
    ]).then(()=>parcelRequire('ipFJ8'));
}

});


parcelRegister("dqj52", function(module, exports) {

$parcel$export(module.exports, "default", () => $99124d670f0cce21$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $99124d670f0cce21$var$AsyncTeamOption = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).lazy(()=>(parcelRequire("1Kwnd")).then((module)=>{
        return {
            default: module.TeamOption
        };
    }));
var $99124d670f0cce21$export$2e2bcd8739ae039 = $99124d670f0cce21$var$AsyncTeamOption;

});
parcelRegister("1Kwnd", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('kS5MT');
        const value = parcelRequire('h6N8Y');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("kS5MT").then(()=>parcelRequire('h6N8Y'));
}

});


parcelRegister("diO51", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ca6f28ecfe324c4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $1ca6f28ecfe324c4$var$AsyncGroupOption = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).lazy(()=>(parcelRequire("2RZtg")).then((module)=>{
        return {
            default: module.GroupOption
        };
    }));
var $1ca6f28ecfe324c4$export$2e2bcd8739ae039 = $1ca6f28ecfe324c4$var$AsyncGroupOption;

});
parcelRegister("2RZtg", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('cupcD');
        const value = parcelRequire('67Bgx');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("cupcD").then(()=>parcelRequire('67Bgx'));
}

});


parcelRegister("4jmtC", function(module, exports) {

$parcel$export(module.exports, "default", () => $c70a8ac55002f9ee$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $c70a8ac55002f9ee$var$AsyncEmailOption = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).lazy(()=>(parcelRequire("3BKGs")).then((module)=>{
        return {
            default: module.EmailOption
        };
    }));
var $c70a8ac55002f9ee$export$2e2bcd8739ae039 = $c70a8ac55002f9ee$var$AsyncEmailOption;

});
parcelRegister("3BKGs", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('jHxNy');
        const value = parcelRequire('fGM7m');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("jHxNy").then(()=>parcelRequire('fGM7m'));
}

});


parcelRegister("19gl5", function(module, exports) {

$parcel$export(module.exports, "default", () => $939b3c40c1c8ea24$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

const $939b3c40c1c8ea24$var$AsyncCustomOption = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).lazy(()=>(parcelRequire("8ZBAx")).then((module)=>{
        return {
            default: module.CustomOption
        };
    }));
var $939b3c40c1c8ea24$export$2e2bcd8739ae039 = $939b3c40c1c8ea24$var$AsyncCustomOption;

});
parcelRegister("8ZBAx", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('jiY6F');
        const value = parcelRequire('70iAn');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("jiY6F").then(()=>parcelRequire('70iAn'));
}

});


parcelRegister("eL5KE", function(module, exports) {

$parcel$export(module.exports, "isValidEmail", () => $74079603909b5140$export$371e338370561054);
const $74079603909b5140$var$validRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
const $74079603909b5140$var$potentialRegex = /^[^\s@]+@[^\s@]*$/i;
const $74079603909b5140$export$371e338370561054 = (inputText)=>{
    if (inputText.match($74079603909b5140$var$validRegex)) return 'VALID';
    if (inputText.match($74079603909b5140$var$potentialRegex)) return 'POTENTIAL';
    return 'INVALID';
};

});


parcelRegister("lftfg", function(module, exports) {

$parcel$export(module.exports, "SingleValue", () => $b0efde321d2f82a0$export$1949dac661ba6e3a);
/** @jsx jsx */ 
var $6R0C9 = parcelRequire("6R0C9");

var $byn9U = parcelRequire("byn9U");

var $jQxSL = parcelRequire("jQxSL");

var $fWEEw = parcelRequire("fWEEw");

var $cHYJ6 = parcelRequire("cHYJ6");
const $b0efde321d2f82a0$var$avatarItemComponent = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    border: 'none !important',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    padding: `${"var(--ds-space-0, 0px)"} !important`,
    width: 'auto',
    overflow: 'hidden',
    minWidth: '100px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > span': {
        boxSizing: 'border-box'
    },
    '&:hover': {
        width: 'auto',
        padding: 0,
        border: 'none'
    }
});
const $b0efde321d2f82a0$export$1949dac661ba6e3a = (props)=>{
    const { data: { label: label, data: data }, selectProps: { appearance: appearance, isFocused: isFocused } } = props;
    return !isFocused ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).SingleValue, props, /*#__PURE__*/ (0, $byn9U.jsx)((0, $6R0C9.default), {
        backgroundColor: "transparent",
        avatar: /*#__PURE__*/ (0, $byn9U.jsx)((0, $fWEEw.SizeableAvatar), {
            src: (0, $cHYJ6.getAvatarUrl)(data),
            appearance: appearance
        }),
        primaryText: label
    }, ({ ref: ref, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $b0efde321d2f82a0$var$avatarItemComponent,
            ...props
        }))) : null;
};

});
parcelRegister("6R0C9", function(module, exports) {

$parcel$export(module.exports, "default", () => $d303d2caa12f1c14$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $1Yimi = parcelRequire("1Yimi");

var $PdmhA = parcelRequire("PdmhA");

var $lcnyw = parcelRequire("lcnyw");

var $eri7S = parcelRequire("eri7S");

var $6ecEX = parcelRequire("6ecEX");
function $d303d2caa12f1c14$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d303d2caa12f1c14$var$avatarItemStyles = {
    name: "1dq1lfl",
    styles: "min-width:0;max-width:100%;flex:1 1 100%;line-height:1.4;padding-inline-start:var(--ds-space-100, 8px)"
};
const $d303d2caa12f1c14$var$secondaryTextOldStyles = {
    name: "1udad45",
    styles: "color:var(--ds-text-subtlest, #626F86);font-size:0.85em"
};
const $d303d2caa12f1c14$var$baseTextStyles = {
    name: "1sodx6b",
    styles: "display:block;color:var(--ds-text, #172B4D)"
};
const $d303d2caa12f1c14$var$truncationStyles = {
    name: "n3ut7m",
    styles: "overflow-x:hidden;text-overflow:ellipsis;white-space:nowrap"
};
const $d303d2caa12f1c14$var$getStyles = (css, { backgroundColor: backgroundColor, isInteractive: isInteractive, isDisabled: isDisabled })=>// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @repo/internal/react/no-css-string-literals
    css`
		align-items: center;
		background-color: ${backgroundColor};
		border-radius: ${(0, $lcnyw.borderRadius)()}px;
		border: ${0, $eri7S.BORDER_WIDTH}px solid transparent;
		box-sizing: border-box;
		color: inherit;
		display: flex;
		font-size: inherit;
		font-style: normal;
		font-weight: normal;
		line-height: 1;
		outline: none;
		margin: ${"var(--ds-space-0, 0px)"};
		padding: ${"var(--ds-space-050, 4px)"};
		text-align: left;
		text-decoration: none;
		width: 100%;

		${isInteractive && `
        :hover {
          background-color: ${`var(--ds-background-neutral-subtle-hovered, ${0, $PdmhA.N30})`};
          cursor: pointer;
          text-decoration: none;
        }

        :focus {
          outline: none;
          border-color: ${`var(--ds-border-focused, ${0, $PdmhA.B200})`};
        }

        :active {
          background-color: ${`var(--ds-background-neutral-subtle-pressed, ${0, $PdmhA.B50})`};
        }
      `}

		${isDisabled && `
        cursor: not-allowed;
        opacity: ${"var(--ds-opacity-disabled, 0.5)"};
        pointer-events: none;
      `}
	`;
/**
 * __Avatar item__
 *
 * An avatar item is a wrapper that goes around an avatar when it's displayed alongside text, such as a name or status.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-item/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-item/code)
 */ const $d303d2caa12f1c14$var$AvatarItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ avatar: avatar, backgroundColor: backgroundColor = 'transparent', children: children, isTruncationDisabled: isTruncationDisabled, href: href, isDisabled: isDisabled, onClick: onClick, primaryText: primaryText, secondaryText: secondaryText, target: target, testId: testId, label: label }, ref)=>{
    const getTestId = (testId, children)=>!children ? {
            'data-testid': `${testId}--itemInner`
        } : {
            testId: `${testId}--itemInner`
        };
    const componentProps = ()=>{
        if (isDisabled) return {
            disabled: true
        };
        // return only relevant props for either anchor or button elements
        return {
            ...href && (0, $6ecEX.getLinkProps)(href, target),
            ...onClick && !href ? (0, $6ecEX.getButtonProps)(onClick) : {
                onClick: onClick
            }
        };
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $byn9U.ClassNames), null, ({ css: css })=>{
        const props = {
            ref: ref,
            className: $d303d2caa12f1c14$var$getStyles(css, {
                backgroundColor: backgroundColor,
                isInteractive: Boolean(onClick || href),
                isDisabled: isDisabled
            }),
            ...componentProps(),
            ...testId && getTestId(testId, children),
            ...(onClick || href) && {
                'aria-label': label
            },
            children: /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, avatar, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                css: $d303d2caa12f1c14$var$avatarItemStyles
            }, (0, $XHGTv.getBooleanFF)('platform.design-system-team.avatar-item-font-size_830x6') ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
                maxLines: isTruncationDisabled ? undefined : 1
            }, primaryText), /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
                color: "color.text.subtlest",
                maxLines: isTruncationDisabled ? undefined : 1,
                size: "UNSAFE_small"
            }, secondaryText)) : /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                css: [
                    $d303d2caa12f1c14$var$baseTextStyles,
                    !isTruncationDisabled && $d303d2caa12f1c14$var$truncationStyles
                ]
            }, primaryText), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
                css: [
                    $d303d2caa12f1c14$var$baseTextStyles,
                    $d303d2caa12f1c14$var$secondaryTextOldStyles,
                    !isTruncationDisabled && $d303d2caa12f1c14$var$truncationStyles
                ]
            }, secondaryText))))
        };
        return children ? children(props) : /*#__PURE__*/ (0, $eUqFw.createElement)((0, $6ecEX.getCustomElement)(isDisabled, href, onClick), props);
    });
});
$d303d2caa12f1c14$var$AvatarItem.displayName = 'AvatarItem';
var $d303d2caa12f1c14$export$2e2bcd8739ae039 = $d303d2caa12f1c14$var$AvatarItem;

});


parcelRegister("aRUd7", function(module, exports) {

$parcel$export(module.exports, "Input", () => $a6afe550849f2f63$export$f5b8910cec6cf069);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
class $a6afe550849f2f63$export$f5b8910cec6cf069 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    /**
	 * Overrides the default behaviour of react-select lib
	 *
	 * The getter is a workaround for original behaviour of the react-select lib.
	 * Placeholder and Input are linked not via label, aria-label or aria-labeledby, but through aria-describedby.
	 * Basically in the getter we reassign Placeholder ID from aria-describedby to aria-labelledby
	 * {@link https://github.com/JedWatson/react-select/issues/5651#issue-1731353197 GitHub}
	 */ get ariaLabelledBy() {
        return this.props['aria-labelledby'] ?? this.props['aria-describedby'];
    }
    get ariaDescribedBy() {
        return this.props.selectProps?.['aria-describedby'] ?? this.props['aria-describedby'];
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Input, {
            ...this.props,
            "aria-labelledby": this.ariaLabelledBy,
            "aria-describedby": this.ariaDescribedBy,
            innerRef: this.props.innerRef,
            onKeyPress: this.handleKeyPress
        });
    }
    constructor(...args){
        super(...args);
        // onKeyPress is used instead as
        // react-select is using onKeyDown for capturing keyboard input
        this.handleKeyPress = (e)=>{
            if (e.key === 'Enter') e.preventDefault();
            if (this.props.selectProps?.disableInput) e.preventDefault();
        };
    }
}

});

parcelRegister("cRDmG", function(module, exports) {

$parcel$export(module.exports, "SingleValueContainer", () => $9a44acf63722ec21$export$afa5f855316c6a48);
/** @jsx jsx */ 
var $jQxSL = parcelRequire("jQxSL");

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $fWEEw = parcelRequire("fWEEw");

var $dTS4n = parcelRequire("dTS4n");

var $8fe8e = parcelRequire("8fe8e");
function $9a44acf63722ec21$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9a44acf63722ec21$var$placeholderIconContainer = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingLeft: (0, $dTS4n.BORDER_PADDING),
    lineHeight: 0,
    gridArea: '1/1/2/2'
});
const $9a44acf63722ec21$var$showUserAvatar = (inputValue, value)=>value && value.data && inputValue === value.label;
var $9a44acf63722ec21$var$_ref = {
    name: "1ff36h2",
    styles: "flex-grow:1"
};
class $9a44acf63722ec21$export$afa5f855316c6a48 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { children: children, ...valueContainerProps } = this.props;
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8fe8e.default), {
            isEnabled: this.onValueContainerClick,
            onMouseDown: this.onValueContainerClick
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).ValueContainer, valueContainerProps, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $9a44acf63722ec21$var$placeholderIconContainer
        }, this.renderAvatar()), children));
    }
    constructor(...args){
        super(...args);
        this.renderAvatar = ()=>{
            const { hasValue: hasValue, selectProps: { appearance: appearance, isFocused: isFocused, inputValue: inputValue, value: value, placeholderAvatar: placeholderAvatar } } = this.props;
            if (isFocused || !hasValue) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $fWEEw.SizeableAvatar), {
                appearance: appearance,
                type: placeholderAvatar,
                src: $9a44acf63722ec21$var$showUserAvatar(inputValue, value) ? value.data.avatarUrl : undefined
            });
            return null;
        };
        this.onValueContainerClick = this.props.selectProps.onValueContainerClick;
        this.Wrapper = ({ children: children })=>{
            return this.onValueContainerClick ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $byn9U.jsx)("div", {
                css: $9a44acf63722ec21$var$_ref,
                onMouseDown: this.onValueContainerClick
            }, children) : children;
        };
    }
}

});

parcelRegister("5Hu7b", function(module, exports) {

$parcel$export(module.exports, "PopupInput", () => $af7bd16282155901$export$d8edbfd510a7db82);

var $eUqFw = parcelRequire("eUqFw");

var $aRUd7 = parcelRequire("aRUd7");
class $af7bd16282155901$export$d8edbfd510a7db82 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    componentDidMount() {
        if (this.ref) // @ts-ignore
        this.ref.select();
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aRUd7.Input), {
            ...this.props,
            innerRef: this.handleInnerRef
        });
    }
    constructor(...args){
        super(...args);
        this.ref = null;
        this.handleInnerRef = (ref)=>{
            this.ref = ref;
            if (this.props.innerRef) this.props.innerRef(ref);
        };
    }
}

});

parcelRegister("6BfkR", function(module, exports) {

$parcel$export(module.exports, "PopupControl", () => $2db2d66d3748ae86$export$a0cb1b4352357fcc);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
const $2db2d66d3748ae86$var$spacing = 8;
const $2db2d66d3748ae86$var$fontSize = 12;
const $2db2d66d3748ae86$var$innerHeight = $2db2d66d3748ae86$var$spacing * 2; // 16px
const $2db2d66d3748ae86$var$lineHeight = $2db2d66d3748ae86$var$innerHeight / $2db2d66d3748ae86$var$fontSize;
const $2db2d66d3748ae86$var$controlWrapper = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    flexDirection: 'column',
    padding: `0px ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`
});
const $2db2d66d3748ae86$var$getLabelStyle = ()=>/*#__PURE__*/ (0, $byn9U.css)({
        color: `var(--ds-text-subtlest, ${(0, $PdmhA.N200)})`,
        fontSize: `${$2db2d66d3748ae86$var$fontSize}px`,
        fontWeight: 600,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        lineHeight: `${$2db2d66d3748ae86$var$lineHeight}`,
        paddingBottom: "var(--ds-space-050, 4px)",
        paddingLeft: "var(--ds-space-0, 0px)",
        paddingRight: "var(--ds-space-0, 0px)",
        paddingTop: "var(--ds-space-250, 20px)"
    });
class $2db2d66d3748ae86$export$a0cb1b4352357fcc extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    render() {
        const { selectProps: { popupTitle: popupTitle } } = this.props;
        return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $2db2d66d3748ae86$var$controlWrapper
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $2db2d66d3748ae86$var$getLabelStyle()
        }, popupTitle), /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).Control, this.props));
    }
}

});

parcelRegister("bP6rt", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $f6008453f5d5b3f2$export$d9b273488cd8ce6f);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");

var $byn9U = parcelRequire("byn9U");
const $f6008453f5d5b3f2$var$getFooterStyle = ()=>{
    return /*#__PURE__*/ (0, $byn9U.css)({
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`
    });
};
class $f6008453f5d5b3f2$export$d9b273488cd8ce6f extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).Menu, this.props, this.props.selectProps.header, this.props.children, this.props.selectProps.footer && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $f6008453f5d5b3f2$var$getFooterStyle()
        }, this.props.selectProps.footer));
    }
}

});


parcelRegister("fiLGD", function(module, exports) {

$parcel$export(module.exports, "getCreatableProps", () => $8c4e3608dc9bf116$export$36f97d8afa97203d);

var $5iWql = parcelRequire("5iWql");


var $eL5KE = parcelRequire("eL5KE");

var $cHYJ6 = parcelRequire("cHYJ6");
const $8c4e3608dc9bf116$var$validOption = [
    'VALID',
    'POTENTIAL'
];
const $8c4e3608dc9bf116$var$isValidNewOption = (isValidEmail = (0, $eL5KE.isValidEmail))=>(inputValue)=>inputValue && $8c4e3608dc9bf116$var$validOption.includes(isValidEmail(inputValue));
const $8c4e3608dc9bf116$var$getNewOptionData = (inputValue)=>({
        label: inputValue,
        value: inputValue,
        data: {
            id: inputValue,
            name: inputValue,
            type: (0, $0b440fae145c26fc$export$6662b3461398ef8c)
        }
    });
const $8c4e3608dc9bf116$var$formatCreateLabel = (inputText)=>{
    if (inputText) return inputText.trim();
    return '';
};
const $8c4e3608dc9bf116$var$isOptionDisabled = (isValidEmail = (0, $eL5KE.isValidEmail))=>(option)=>{
        if ((0, $cHYJ6.isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
        return !!option.isDisabled;
    };
function $8c4e3608dc9bf116$var$creatableProps(isValidEmail) {
    return {
        allowCreateWhileLoading: true,
        createOptionPosition: 'first',
        isValidNewOption: $8c4e3608dc9bf116$var$isValidNewOption(isValidEmail),
        getNewOptionData: $8c4e3608dc9bf116$var$getNewOptionData,
        formatCreateLabel: $8c4e3608dc9bf116$var$formatCreateLabel,
        isOptionDisabled: $8c4e3608dc9bf116$var$isOptionDisabled(isValidEmail)
    };
}
const $8c4e3608dc9bf116$export$36f97d8afa97203d = (0, $5iWql.default)($8c4e3608dc9bf116$var$creatableProps);

});

parcelRegister("bxvbM", function(module, exports) {

$parcel$export(module.exports, "getCreatableSuggestedEmailProps", () => $c7d74c04cc603d9e$export$34b9dd2dd6a225e5);

var $5iWql = parcelRequire("5iWql");


var $eL5KE = parcelRequire("eL5KE");

var $cHYJ6 = parcelRequire("cHYJ6");
const $c7d74c04cc603d9e$var$validOption = [
    'VALID',
    'POTENTIAL'
];
const $c7d74c04cc603d9e$var$isValidNewOption = (inputValue)=>inputValue && inputValue.length > 0;
// Generates suggested option data based on user input and validity of the input (if it is an email or not);
const $c7d74c04cc603d9e$var$getNewOptionData = (isValidEmail = (0, $eL5KE.isValidEmail), emailDomain)=>(inputValue)=>{
        if (!inputValue) return null;
        const isEmail = inputValue && $c7d74c04cc603d9e$var$validOption.includes(isValidEmail(inputValue));
        const value = isEmail ? inputValue : `${inputValue.replace(/\s+/g, '.').toLocaleLowerCase()}@${emailDomain}`;
        return {
            label: value,
            value: value,
            data: {
                id: value,
                name: value,
                type: (0, $0b440fae145c26fc$export$6662b3461398ef8c),
                suggestion: true
            }
        };
    };
const $c7d74c04cc603d9e$var$formatCreateLabel = (inputText)=>{
    if (inputText) return inputText.trim();
    return '';
};
// Option will not be selectable until the email value is valid and can actually be invited
const $c7d74c04cc603d9e$var$isOptionDisabled = (isValidEmail = (0, $eL5KE.isValidEmail))=>(option)=>{
        if ((0, $cHYJ6.isEmail)(option.data)) return isValidEmail(option.data.id) !== 'VALID';
        return !!option.isDisabled;
    };
const $c7d74c04cc603d9e$export$34b9dd2dd6a225e5 = (0, $5iWql.default)((emailDomain, isValidEmail)=>({
        allowCreateWhileLoading: true,
        createOptionPosition: 'last',
        isValidNewOption: $c7d74c04cc603d9e$var$isValidNewOption,
        getNewOptionData: $c7d74c04cc603d9e$var$getNewOptionData(isValidEmail, emailDomain),
        formatCreateLabel: $c7d74c04cc603d9e$var$formatCreateLabel,
        isOptionDisabled: $c7d74c04cc603d9e$var$isOptionDisabled(isValidEmail)
    }));

});

parcelRegister("1mZCo", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bdf5d8ea911c991$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3dpxL = parcelRequire("3dpxL");
var $5JgJ2 = parcelRequire("5JgJ2");

var $fgOWi = parcelRequire("fgOWi");
const $5bdf5d8ea911c991$var$EMPTY = {};
const $5bdf5d8ea911c991$var$useI18n = (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState($5bdf5d8ea911c991$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        let aborted = false;
        setMessages($5bdf5d8ea911c991$var$EMPTY);
        (0, $fgOWi.getMessagesForLocale)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $5bdf5d8ea911c991$var$MessagesIntlProvider = (props)=>{
    const intl = (0, $5JgJ2.default)();
    const { children: children } = props;
    const messages = $5bdf5d8ea911c991$var$useI18n(intl.locale);
    const mergedMessages = (0, $eUqFw.useMemo)(()=>{
        return {
            ...intl.messages,
            ...messages
        };
    }, [
        intl.messages,
        messages
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
        locale: intl.locale,
        messages: mergedMessages
    }, children);
};
var $5bdf5d8ea911c991$export$2e2bcd8739ae039 = $5bdf5d8ea911c991$var$MessagesIntlProvider;

});
parcelRegister("fgOWi", function(module, exports) {

$parcel$export(module.exports, "getMessagesForLocale", () => $0294972dd0e7529b$export$d0a3169680473b6c);
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ 





























const $0294972dd0e7529b$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("ixT7h")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("8fbOx")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("d2VBC")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("PaFEO")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("a6vNm")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("6P6vD")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("kr5va")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("gKeZQ")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("etKfz")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("hVfoA")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("1YkqD")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("iIDxo")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("lh4qA")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("62kNV")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("aWuWP")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("g6zic")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("4g3HV")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("h2shK")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("iCHIH")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("gMaCG")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("lKlLR")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("lf6nY")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("eyDJz")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("5s6TH")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("bBCIv")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("84yTz")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("2tb2Z")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("akOJS")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("3Ozo4")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $0294972dd0e7529b$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("PaFEO")).then((mod)=>mod.default);
            }
    }
};

});
parcelRegister("ixT7h", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('i0Pe8');
        const value = parcelRequire('or03D');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("i0Pe8").then(()=>parcelRequire('or03D'));
}

});

parcelRegister("8fbOx", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('8BOU0');
        const value = parcelRequire('lNiRt');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("8BOU0").then(()=>parcelRequire('lNiRt'));
}

});

parcelRegister("d2VBC", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('8l0dy');
        const value = parcelRequire('p7JNt');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("8l0dy").then(()=>parcelRequire('p7JNt'));
}

});

parcelRegister("PaFEO", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('bxgOi');
        const value = parcelRequire('eILmt');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("bxgOi").then(()=>parcelRequire('eILmt'));
}

});

parcelRegister("a6vNm", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('3pgy1');
        const value = parcelRequire('7vzzX');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("3pgy1").then(()=>parcelRequire('7vzzX'));
}

});

parcelRegister("6P6vD", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('8W7RH');
        const value = parcelRequire('7Ptvo');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("8W7RH").then(()=>parcelRequire('7Ptvo'));
}

});

parcelRegister("kr5va", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('7NgAP');
        const value = parcelRequire('bYcIY');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("7NgAP").then(()=>parcelRequire('bYcIY'));
}

});

parcelRegister("gKeZQ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('ifr0G');
        const value = parcelRequire('2HL4d');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("ifr0G").then(()=>parcelRequire('2HL4d'));
}

});

parcelRegister("etKfz", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('4TLdl');
        const value = parcelRequire('gBgnK');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("4TLdl").then(()=>parcelRequire('gBgnK'));
}

});

parcelRegister("hVfoA", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('knvW7');
        const value = parcelRequire('fWgwA');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("knvW7").then(()=>parcelRequire('fWgwA'));
}

});

parcelRegister("1YkqD", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('7BTAu');
        const value = parcelRequire('bWAwm');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("7BTAu").then(()=>parcelRequire('bWAwm'));
}

});

parcelRegister("iIDxo", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('kMXHV');
        const value = parcelRequire('bfB2v');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("kMXHV").then(()=>parcelRequire('bfB2v'));
}

});

parcelRegister("lh4qA", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('6szWe');
        const value = parcelRequire('fEK8N');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("6szWe").then(()=>parcelRequire('fEK8N'));
}

});

parcelRegister("62kNV", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('6nfH5');
        const value = parcelRequire('guy7d');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("6nfH5").then(()=>parcelRequire('guy7d'));
}

});

parcelRegister("aWuWP", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hcA4m');
        const value = parcelRequire('8b2sJ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hcA4m").then(()=>parcelRequire('8b2sJ'));
}

});

parcelRegister("g6zic", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('dGDd3');
        const value = parcelRequire('3CFXE');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("dGDd3").then(()=>parcelRequire('3CFXE'));
}

});

parcelRegister("4g3HV", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('b1OEX');
        const value = parcelRequire('5OhZL');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("b1OEX").then(()=>parcelRequire('5OhZL'));
}

});

parcelRegister("h2shK", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('6L31b');
        const value = parcelRequire('2usan');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("6L31b").then(()=>parcelRequire('2usan'));
}

});

parcelRegister("iCHIH", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('aJiHI');
        const value = parcelRequire('fUbQi');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("aJiHI").then(()=>parcelRequire('fUbQi'));
}

});

parcelRegister("gMaCG", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('6oIXh');
        const value = parcelRequire('87pIs');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("6oIXh").then(()=>parcelRequire('87pIs'));
}

});

parcelRegister("lKlLR", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('l6J1G');
        const value = parcelRequire('1Ydae');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("l6J1G").then(()=>parcelRequire('1Ydae'));
}

});

parcelRegister("lf6nY", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('bYIVb');
        const value = parcelRequire('cNlCa');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("bYIVb").then(()=>parcelRequire('cNlCa'));
}

});

parcelRegister("eyDJz", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('2SONo');
        const value = parcelRequire('24GPb');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("2SONo").then(()=>parcelRequire('24GPb'));
}

});

parcelRegister("5s6TH", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('bUOZE');
        const value = parcelRequire('4Zzmi');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("bUOZE").then(()=>parcelRequire('4Zzmi'));
}

});

parcelRegister("bBCIv", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('b3vK4');
        const value = parcelRequire('cZgsZ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("b3vK4").then(()=>parcelRequire('cZgsZ'));
}

});

parcelRegister("84yTz", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('czbsK');
        const value = parcelRequire('eLbuu');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("czbsK").then(()=>parcelRequire('eLbuu'));
}

});

parcelRegister("2tb2Z", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('cdt3f');
        const value = parcelRequire('3UnDQ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("cdt3f").then(()=>parcelRequire('3UnDQ'));
}

});

parcelRegister("akOJS", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('jzy6n');
        const value = parcelRequire('7qhnG');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("jzy6n").then(()=>parcelRequire('7qhnG'));
}

});

parcelRegister("3Ozo4", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('kukRa');
        const value = parcelRequire('mz9nj');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("kukRa").then(()=>parcelRequire('mz9nj'));
}

});



parcelRegister("ToOs1", function(module, exports) {

$parcel$export(module.exports, "ExusUserSourceProvider", () => $8f66b178b236b94b$export$bcd5c65b586ee3c3);
$parcel$export(module.exports, "useUserSource", () => $8f66b178b236b94b$export$c6c0c1a2bac363f);

var $eUqFw = parcelRequire("eUqFw");
const $8f66b178b236b94b$var$ExusUserSourceContext = /*#__PURE__*/ (0, $eUqFw.createContext)({});
const $8f66b178b236b94b$export$bcd5c65b586ee3c3 = ({ fetchUserSource: fetchUserSource, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8f66b178b236b94b$var$ExusUserSourceContext.Provider, {
        value: {
            fetchUserSource: fetchUserSource
        }
    }, children);
const $8f66b178b236b94b$export$c6c0c1a2bac363f = (accountId, shouldFetchSources, existingSources)=>{
    const { fetchUserSource: fetchUserSource } = (0, $eUqFw.useContext)($8f66b178b236b94b$var$ExusUserSourceContext);
    const [externalSources, setExternalSources] = (0, $eUqFw.useState)([]);
    const [loading, setLoading] = (0, $eUqFw.useState)(true);
    const [error, setError] = (0, $eUqFw.useState)(null);
    const abortController = (0, $eUqFw.useMemo)(()=>{
        if (typeof AbortController === 'undefined') return;
        return new AbortController();
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        let isMounted = true;
        const cleanup = ()=>{
            abortController?.abort();
            isMounted = false;
        };
        if (!fetchUserSource || !shouldFetchSources) {
            setLoading(false);
            return cleanup;
        }
        fetchUserSource(accountId, abortController?.signal).then((externalSources)=>{
            if (!isMounted) return;
            setLoading(false);
            const externalSourceTypes = externalSources.map((source)=>source.sourceType);
            setExternalSources(externalSourceTypes);
        }).catch((error)=>{
            if (!isMounted) return;
            setLoading(false);
            setError(error);
        });
        return cleanup;
    }, [
        fetchUserSource,
        accountId,
        abortController,
        shouldFetchSources
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            sources: Array.from(new Set([
                ...existingSources ?? [],
                ...externalSources
            ])),
            loading: loading,
            error: error
        }), [
        error,
        existingSources,
        externalSources,
        loading
    ]);
};

});


const $7a4a7348bcf111f0$export$bdab9bfb39981463 = '__UNASSIGNED_ID__';
const $7a4a7348bcf111f0$export$d875316cb0cd94f7 = '__INVITE_PEOPLE_ID__';
const $7a4a7348bcf111f0$export$f5d5f6bb902f1027 = '-1';

parcelRegister("6cPKE", function(module, exports) {

$parcel$export(module.exports, "getUnassignedUser", () => $c06f6916b7f49c06$export$42c5a0b65ef9ee80);
$parcel$export(module.exports, "getAutomaticUserOption", () => $c06f6916b7f49c06$export$8d7a63500893c8c);
$parcel$export(module.exports, "getInvitePeopleOption", () => $c06f6916b7f49c06$export$84a82764cf0a696e);
$parcel$export(module.exports, "getUserOptionFromUser", () => $c06f6916b7f49c06$export$16086438354dcc85);
$parcel$export(module.exports, "getUserFromUserOption", () => $c06f6916b7f49c06$export$78a8bcc5bd21caa2);
$parcel$export(module.exports, "getUserAvatarUrl", () => $c06f6916b7f49c06$export$7d801d84202c7743);
$parcel$export(module.exports, "getUserShape", () => $c06f6916b7f49c06$export$322b6ab8c29a006e);

var $51p9V = parcelRequire("51p9V");

var $43MEA = parcelRequire("43MEA");

const $c06f6916b7f49c06$export$42c5a0b65ef9ee80 = ({ formatMessage: formatMessage })=>({
        accountId: (0, $7a4a7348bcf111f0$export$bdab9bfb39981463),
        displayName: formatMessage((0, $51p9V.default).unassignedOption),
        avatarUrls: {}
    });
const $c06f6916b7f49c06$export$8d7a63500893c8c = ({ formatMessage: formatMessage })=>({
        accountId: (0, $7a4a7348bcf111f0$export$f5d5f6bb902f1027),
        displayName: formatMessage((0, $51p9V.default).automaticOption),
        avatarUrls: {}
    });
const $c06f6916b7f49c06$export$84a82764cf0a696e = ({ formatMessage: formatMessage }, isAdmin)=>({
        accountId: (0, $7a4a7348bcf111f0$export$d875316cb0cd94f7),
        displayName: formatMessage(isAdmin ? (0, $51p9V.default).invitePeopleOptionAdmin : (0, $51p9V.default).invitePeopleOption),
        avatarUrls: {
            '48x48': (0, (/*@__PURE__*/$parcel$interopDefault($43MEA)))
        }
    });
const $c06f6916b7f49c06$export$16086438354dcc85 = ({ accountId: accountId, displayName: displayName, avatarUrls: avatarUrls, emailAddress: emailAddress })=>({
        id: accountId || '',
        name: displayName,
        avatarUrl: avatarUrls['48x48'],
        // @ts-expect-error Will be part of JIV-13488; `user.emailAddress` returned by the REST API can be null depending on their privacy settings
        byline: emailAddress
    });
const $c06f6916b7f49c06$export$78a8bcc5bd21caa2 = ({ id: id, name: name, avatarUrl: avatarUrl })=>({
        accountId: id,
        displayName: name,
        avatarUrls: {
            '48x48': avatarUrl
        }
    });
const $c06f6916b7f49c06$export$7d801d84202c7743 = ({ avatarUrls: avatarUrls })=>avatarUrls['48x48'];
const $c06f6916b7f49c06$export$322b6ab8c29a006e = (accountId, displayName, avatarUrl)=>({
        accountId: accountId,
        displayName: displayName,
        avatarUrls: {
            '48x48': avatarUrl
        }
    });

});
parcelRegister("51p9V", function(module, exports) {

$parcel$export(module.exports, "default", () => $62a9b3be869d04c4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $62a9b3be869d04c4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    unassignedOption: {
        "id": "issue-field-assignee.unassigned-option",
        "defaultMessage": "Unassigned"
    },
    automaticOption: {
        "id": "issue-field-assignee.automatic-option",
        "defaultMessage": "Automatic"
    },
    assignToMe: {
        "id": "issue-field-assignee.assign-to-me",
        "defaultMessage": "Assign to me"
    },
    searchForAssignee: {
        "id": "issue-field-assignee.search-for-assignee",
        "defaultMessage": "Search for assignee"
    },
    invitePeopleOption: {
        "id": "issue-field-assignee.invite-people-option",
        "defaultMessage": "Add teammate to Jira"
    },
    invitePeopleOptionAdmin: {
        "id": "issue-field-assignee.invite-people-option-admin",
        "defaultMessage": "Invite teammate to Jira"
    }
});

});

parcelRegister("43MEA", function(module, exports) {
module.exports = new URL("add.6dea82c4.png", import.meta.url).toString();

});


parcelRegister("b5qOz", function(module, exports) {

$parcel$export(module.exports, "INVITE_FROM_ASSIGN", () => $2ebcd2dcd5becbb5$export$d304132d091ca1ac);
$parcel$export(module.exports, "getInviteFromAssignCohort", () => $2ebcd2dcd5becbb5$export$dfa2a595c2323732);
$parcel$export(module.exports, "isInviteFromAssignEnabled", () => $2ebcd2dcd5becbb5$export$cdd5c612352d7bf0);
/**
 * Feature flags convention: go/frontend-feature-flags. Please ensure integration tests are still working afterwards.
 */ 
var $1Iui1 = parcelRequire("1Iui1");

var $1ybV0 = parcelRequire("1ybV0");
const $2ebcd2dcd5becbb5$export$d304132d091ca1ac = 'invite.from.assign';
const $2ebcd2dcd5becbb5$export$dfa2a595c2323732 = ()=>(0, $1ybV0.getMultivariateFeatureFlag)($2ebcd2dcd5becbb5$export$d304132d091ca1ac, (0, $1Iui1.NOT_ENROLLED), [
        (0, $1Iui1.NOT_ENROLLED),
        (0, $1Iui1.CONTROL),
        (0, $1Iui1.VARIATION)
    ]);
const $2ebcd2dcd5becbb5$export$cdd5c612352d7bf0 = ()=>$2ebcd2dcd5becbb5$export$dfa2a595c2323732() === (0, $1Iui1.VARIATION);

});

parcelRegister("dRJbT", function(module, exports) {

$parcel$export(module.exports, "useAssigneeOptions", () => $256397ae5b7d05ee$export$1eb7ccf9fc55d2e8);

var $eUqFw = parcelRequire("eUqFw");

var $9ZJqc = parcelRequire("9ZJqc");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $c7H0g = parcelRequire("c7H0g");

var $lGLse = parcelRequire("lGLse");


var $6cPKE = parcelRequire("6cPKE");

var $b5qOz = parcelRequire("b5qOz");

var $51p9V = parcelRequire("51p9V");
const $256397ae5b7d05ee$var$fireInviteFromAssignExposureEvent = (createAnalyticsEvent, suggestionsCount, isAdmin)=>{
    if (createAnalyticsEvent === undefined || createAnalyticsEvent === null) return;
    const action = 'exposed';
    const actionSubject = 'feature';
    const event = createAnalyticsEvent({
        action: action,
        actionSubject: actionSubject
    });
    const attrs = {
        fieldId: 'assignee',
        flagKey: (0, $b5qOz.INVITE_FROM_ASSIGN),
        value: (0, $b5qOz.getInviteFromAssignCohort)(),
        userRole: isAdmin ? 'admin' : 'basic',
        suggestionsCount: suggestionsCount,
        source: 'assigneeField'
    };
    (0, $jMP2a.fireOperationalAnalytics)(event, `${actionSubject} ${action}`, attrs);
};
const $256397ae5b7d05ee$var$fireInviteItemRendererEvent = (createAnalyticsEvent, suggestionsCount, isAdmin, isInviteAndAssignFromBoard = false)=>{
    if (createAnalyticsEvent === undefined || createAnalyticsEvent === null) return;
    const action = 'rendered';
    const actionSubject = 'inviteItem';
    const event = createAnalyticsEvent({
        action: action,
        actionSubject: actionSubject
    });
    const attrs = {
        fieldId: 'assignee',
        userRole: isAdmin ? 'admin' : 'basic',
        suggestionsCount: suggestionsCount,
        source: 'assigneeField',
        ...isInviteAndAssignFromBoard && {
            isInviteAndAssignFromBoard: true
        }
    };
    (0, $jMP2a.fireUIAnalytics)(event, `${actionSubject} ${action}`, attrs);
};
const $256397ae5b7d05ee$export$1eb7ccf9fc55d2e8 = (value, users, intl, shouldPreloadAssignToMe, search, enablePeopleInvite, enableAutomaticOption, suggestedEmailDomain, isEligibleForInviteAndAssign)=>{
    const [exposureEventTriggered, setExposureEventTriggered] = (0, $eUqFw.useState)(false);
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const unassigned = (0, $6cPKE.getUnassignedUser)(intl);
    const automaticOption = (0, $6cPKE.getAutomaticUserOption)(intl);
    const valueOption = (0, $6cPKE.getUserOptionFromUser)(value || unassigned);
    const [{ data: loggedInUser }] = (0, $lGLse.useUserSubscriber)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const loggedInUserOption = loggedInUser ? {
        ...(0, $6cPKE.getUserOptionFromUser)(loggedInUser),
        publicName: intl.formatMessage((0, $51p9V.default).assignToMe)
    } : null;
    const isInvalidSearch = search === undefined || search === '';
    // show unassigned option if value is defined and no search or unassigned display name match the search
    const showUnassigned = isInvalidSearch ? Boolean(value?.accountId) : unassigned.displayName.toLowerCase().startsWith((search || '').toLowerCase());
    let showAutomaticOption = false;
    if (enableAutomaticOption === true) showAutomaticOption = isInvalidSearch ? Boolean(value?.accountId !== (0, $7a4a7348bcf111f0$export$f5d5f6bb902f1027)) : automaticOption.displayName.toLowerCase().startsWith((search || '').toLowerCase());
    const isLoggedInUserCurrentValue = loggedInUserOption !== null && valueOption.id === loggedInUserOption.id;
    const isLoggedInUserMatchSearch = users.some((user)=>loggedInUserOption !== null && user.accountId === loggedInUserOption.id);
    const showAssignToMeOnInit = !isLoggedInUserCurrentValue && (shouldPreloadAssignToMe || isLoggedInUserMatchSearch);
    const showAssignToMe = isInvalidSearch ? showAssignToMeOnInit : isLoggedInUserMatchSearch;
    const userOptions = users.filter((user)=>// remove selected user (value) from users list when search is not defined
        (!isInvalidSearch || user.accountId !== valueOption.id) && // remove logged in user (is already added in 2nd position above)
        !(loggedInUserOption !== null && user.accountId === loggedInUserOption.id)).map((0, $6cPKE.getUserOptionFromUser));
    const invitePeopleOptions = [];
    if (enablePeopleInvite === true && !isInvalidSearch && userOptions.length < 3) {
        if (!exposureEventTriggered) {
            setExposureEventTriggered(true);
            $256397ae5b7d05ee$var$fireInviteFromAssignExposureEvent(createAnalyticsEvent, userOptions.length, isAdmin);
        }
        if (isEligibleForInviteAndAssign) {
            invitePeopleOptions.push((0, $9ZJqc.getInviteAndAssignPeopleOption)(intl.formatMessage, search, suggestedEmailDomain));
            $256397ae5b7d05ee$var$fireInviteItemRendererEvent(createAnalyticsEvent, userOptions.length, isAdmin, true);
        } else if ((0, $b5qOz.isInviteFromAssignEnabled)()) {
            $256397ae5b7d05ee$var$fireInviteItemRendererEvent(createAnalyticsEvent, userOptions.length, isAdmin);
            invitePeopleOptions.push((0, $6cPKE.getUserOptionFromUser)((0, $6cPKE.getInvitePeopleOption)(intl, isAdmin)));
        }
    }
    const options = [
        ...showUnassigned ? [
            (0, $6cPKE.getUserOptionFromUser)(unassigned)
        ] : [],
        ...showAutomaticOption ? [
            (0, $6cPKE.getUserOptionFromUser)(automaticOption)
        ] : [],
        ...showAssignToMe && loggedInUserOption !== null ? [
            loggedInUserOption
        ] : [],
        ...userOptions,
        ...invitePeopleOptions
    ];
    return [
        valueOption,
        options
    ];
};

});
parcelRegister("9ZJqc", function(module, exports) {

$parcel$export(module.exports, "isValidEmailAddress", () => $3811abc2872da18e$export$866f45a7554d0870);
$parcel$export(module.exports, "getInviteAndAssignPeopleOption", () => $3811abc2872da18e$export$34e0d98131b0b98a);

var $eL5KE = parcelRequire("eL5KE");

var $4gwMF = parcelRequire("4gwMF");


var $obNhg = parcelRequire("obNhg");
const $3811abc2872da18e$var$getInviteAndAssignOption = (inputValue, suggestedEmailDomain)=>{
    const isEmail = inputValue && [
        (0, $1199e142050a1a33$export$18d36911c7f94286),
        (0, $1199e142050a1a33$export$da1c529049028734)
    ].includes((0, $eL5KE.isValidEmail)(inputValue));
    const value = isEmail || !suggestedEmailDomain ? inputValue : `${inputValue.replace(/\s+/g, '.').toLocaleLowerCase()}@${suggestedEmailDomain}`;
    return value;
};
const $3811abc2872da18e$export$866f45a7554d0870 = (inputValue)=>inputValue && (0, $eL5KE.isValidEmail)(inputValue) === (0, $1199e142050a1a33$export$18d36911c7f94286);
const $3811abc2872da18e$export$34e0d98131b0b98a = (formatMessage, input, suggestedEmailDomain)=>{
    const possibleEmail = $3811abc2872da18e$var$getInviteAndAssignOption(input, suggestedEmailDomain);
    return {
        id: (0, $1199e142050a1a33$export$898547b9297d1a3a),
        name: possibleEmail,
        avatarUrl: (0, (/*@__PURE__*/$parcel$interopDefault($4gwMF))),
        byline: formatMessage((0, $obNhg.default).inviteAndAssign),
        isDisabled: (0, $eL5KE.isValidEmail)(possibleEmail) !== 'VALID'
    };
};

});
parcelRegister("4gwMF", function(module, exports) {
module.exports = new URL("email.43fa850c.png", import.meta.url).toString();

});

const $1199e142050a1a33$export$898547b9297d1a3a = '_INVITE_AND_ASSIGN_ID_';
const $1199e142050a1a33$export$18d36911c7f94286 = 'VALID';
const $1199e142050a1a33$export$da1c529049028734 = 'POTENTIAL';

parcelRegister("obNhg", function(module, exports) {

$parcel$export(module.exports, "default", () => $d50baaac4d43c10b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d50baaac4d43c10b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    inviteAndAssign: {
        "id": "invite-and-assign.common.invite-and-assign",
        "defaultMessage": "Invite and assign"
    }
});

});



parcelRegister("aE92Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $49c15bb5f3c640bd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $2OdyW = parcelRequire("2OdyW");
const $49c15bb5f3c640bd$var$useUsersQuery = (autoCompleteUrl)=>{
    const [users, setUsers] = (0, $eUqFw.useState)([]);
    const [error, setError] = (0, $eUqFw.useState)(undefined);
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const currentQuery = (0, $eUqFw.useRef)('');
    const fetchUsers = (0, $eUqFw.useCallback)(// @ts-expect-error - TS2345 - Argument of type '(query?: string | undefined) => Promise<void> | Promise<never[]>' is not assignable to parameter of type 'FetchUsers'.
    (query = '')=>{
        if ([
            '',
            null,
            undefined
        ].includes(autoCompleteUrl)) return Promise.resolve([]);
        const usersFetchUrl = `${autoCompleteUrl || ''}${query}`;
        setLoading(true);
        currentQuery.current = query;
        if (error) setError(undefined);
        return (0, $2OdyW.default)(usersFetchUrl).then((response)=>{
            if (query === currentQuery.current) setUsers(response);
        }).catch((err)=>{
            if (query === currentQuery.current) setError(err);
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.fields.assigne', 'Failed to fetch users', err);
        }).finally(()=>setLoading(false));
    }, [
        autoCompleteUrl,
        error
    ]);
    return [
        {
            data: users,
            error: error,
            loading: loading
        },
        fetchUsers
    ];
};
var $49c15bb5f3c640bd$export$2e2bcd8739ae039 = $49c15bb5f3c640bd$var$useUsersQuery;

});


parcelRegister("lgGuz", function(module, exports) {

$parcel$export(module.exports, "default", () => $6266b64a40eff077$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6266b64a40eff077$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    assignToMe: {
        "id": "issue-create-commons.assignee-field.assign-to-me",
        "defaultMessage": "Assign to me"
    }
});

});

parcelRegister("i8BXG", function(module, exports) {

$parcel$export(module.exports, "transformDefaultAssigneeValue", () => $33563d704875dd71$export$f5415de9103f1c69);
$parcel$export(module.exports, "mapUserToAssigneeValue", () => $33563d704875dd71$export$c4dfa893fba82437);
$parcel$export(module.exports, "mutateAssigneeUserPicker", () => $33563d704875dd71$export$a6706b2f4762043b);


const $33563d704875dd71$export$f5415de9103f1c69 = (value)=>({
        accountId: (value.accountId === '-1' ? (0, $7a4a7348bcf111f0$export$f5d5f6bb902f1027) : value.accountId) || '',
        displayName: value.name || '',
        avatarUrls: value.picture !== undefined ? {
            '16x16': value.picture,
            '24x24': value.picture,
            '32x32': value.picture,
            '48x48': value.picture
        } : {}
    });
const $33563d704875dd71$export$c4dfa893fba82437 = (value)=>{
    if (value === null) return null;
    if (value.accountId === (0, $7a4a7348bcf111f0$export$f5d5f6bb902f1027)) return undefined;
    return {
        id: value.accountId
    };
};
const $33563d704875dd71$export$a6706b2f4762043b = (selectedUser, fieldId)=>{
    if (selectedUser === null || selectedUser.accountId === null) return null;
    return {
        fieldId: fieldId,
        mutationGroup: (0, $ab1884f8d9d06de2$export$6684456d545bf498),
        user: {
            accountId: selectedUser.accountId
        }
    };
};

});


parcelRegister("cVsIh", function(module, exports) {

$parcel$export(module.exports, "default", () => $9de4748d32e5e185$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $1ybV0 = parcelRequire("1ybV0");

var $eHKLj = parcelRequire("eHKLj");

var $QjiuJ = parcelRequire("QjiuJ");

var $gGtKh = parcelRequire("gGtKh");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $gd0Sp = parcelRequire("gd0Sp");

var $icPhQ = parcelRequire("icPhQ");
var $dibFF = parcelRequire("dibFF");
var $6HoNR = parcelRequire("6HoNR");

var $iuMpO = parcelRequire("iuMpO");
const $9de4748d32e5e185$var$overrideSelectStyles = {
    // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type.
    control: (base)=>({
            ...base,
            padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-075, 6px)"} ${"var(--ds-space-075, 6px)"} 0`
        })
};
const $9de4748d32e5e185$var$stopFormPropagation = (e)=>{
    e.stopPropagation();
    e.preventDefault();
};
const $9de4748d32e5e185$export$96c8ee98de63ec5b = (props)=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const siteId = tenantContext.cloudId;
    /**
   * The following is a hack to force the TeamPickerEdit to close after creating a team.
   * @atlaskit/smart-user-picker does not provide a way to close the dropdown menu, as it
   * doesn't expose the select Ref.
   *  */ const [hackIsEditable, setHackIsEditable] = (0, $eUqFw.useState)(true);
    const { width: width, fieldProps: { value: value, onChange: onChange, ...fieldProps }, isEditable: isEditable = true, nonEditableReason: nonEditableReason, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, autoFocus: autoFocus } = props;
    const onCreate = (0, $eUqFw.useCallback)((team)=>{
        if (team && team?.id !== value?.id) {
            (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'createTeamInline succeeded', 'issueCreate', {
                memberCount: team.memberCount
            });
            /**
       * The following is a hack to force the TeamPickerEdit to close after creating a team.
       * @atlaskit/smart-user-picker does not provide a way to close the dropdown menu, as it
       * doesn't expose the select Ref.
       *  */ setHackIsEditable(false);
            // required wait for new created team to be available
            setTimeout(()=>{
                onChange(team);
                setHackIsEditable(true);
            }, 1000);
        }
    }, [
        createAnalyticsEvent,
        onChange,
        value?.id
    ]);
    const [createTeamDialog, createTeamDialogTrigger] = (0, $eHKLj.useCreateTeamDialog)({
        onCreate: onCreate
    });
    const ComponentToRender = (0, $eUqFw.useMemo)(()=>(0, $1ybV0.ff)('load-async-team-picker-field-edit-view-in-gic_gx04r') ? (0, $QjiuJ.AsyncTeamPickerEdit) : (0, $QjiuJ.LazyTeamPickerEdit), []);
    const getTeamEdit = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "team-picker-edit",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dibFF.FieldLoader), null)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ComponentToRender, {
            ...fieldProps,
            width: width,
            siteId: siteId,
            autoFocus: autoFocus,
            defaultValue: value,
            // @ts-expect-error - TS2322 - Type '(value: TeamValue) => void' is not assignable to type 'OnChange'.
            onChange: onChange,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            isDisabled: isEditable === false || !hackIsEditable,
            styles: $9de4748d32e5e185$var$overrideSelectStyles,
            createTeamDialogTrigger: createTeamDialogTrigger
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, isEditable === false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: nonEditableReason?.message || ''
    }, getTeamEdit()) : getTeamEdit(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "create-issue-field-team-create-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("form", {
        name: "gic-create-team-dialog-form",
        onSubmit: $9de4748d32e5e185$var$stopFormPropagation
    }, createTeamDialog)));
};
var $9de4748d32e5e185$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    validator: (0, $iuMpO.validateAtlassianTeamsField),
    transformDefaultValue: (0, $iuMpO.transformDefaultAtlassianTeam)
})($9de4748d32e5e185$export$96c8ee98de63ec5b);

});
parcelRegister("eHKLj", function(module, exports) {

$parcel$export(module.exports, "useCreateTeamDialog", () => $d4e307a1265eaa92$export$e8b8170429d616be);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ao10V = parcelRequire("ao10V");

var $1ybV0 = parcelRequire("1ybV0");

var $k8Qyf = parcelRequire("k8Qyf");

var $3Y2Y8 = parcelRequire("3Y2Y8");

var $Gz4Lz = parcelRequire("Gz4Lz");

var $82rJa = parcelRequire("82rJa");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gGtKh = parcelRequire("gGtKh");

var $cWiVr = parcelRequire("cWiVr");

var $jD3pk = parcelRequire("jD3pk");

var $gd0Sp = parcelRequire("gd0Sp");

var $45GTD = parcelRequire("45GTD");

const $d4e307a1265eaa92$export$75096afde50756fd = (0, $7rh0R.lazy)(()=>(parcelRequire("dNLwe")).then((module)=>module.TeamCreateDialog), {
    moduleId: "./node_modules/@atlassian/people-teams/dist/cjs/index.js"
});
const $d4e307a1265eaa92$export$e8b8170429d616be = (props = {})=>{
    const { locale: locale } = (0, $5JgJ2.default)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const [inputTeamName, setInputTeamName] = (0, $eUqFw.useState)('');
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const enableMembershipSettingsChoice = (0, $1ybV0.ff)('ptc.membership-controls');
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const { cloudId: cloudId, atlassianAccountId: atlassianAccountId } = tenantContext;
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const { data: { user: user } } = (0, $cWiVr.useCurrentUser)();
    if (!atlassianAccountId && !user.accountId) throw new Error('Missing current user id');
    const addFlag = (0, $eUqFw.useCallback)(({ appearance: appearance, ...flagProps })=>{
        if (appearance === 'success' || appearance === 'normal') showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $Gz4Lz.default), {
                ...flagProps,
                ...serviceProps
            }));
        if (appearance === 'warning') showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $82rJa.default), {
                ...flagProps,
                ...serviceProps
            }));
        if (appearance === 'error') showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Y2Y8.default), {
                ...flagProps,
                ...serviceProps
            }));
    }, [
        showFlag
    ]);
    const { onCancel: onCancel } = {
        onCancel: ()=>null,
        ...props
    };
    const callback = (0, $eUqFw.useCallback)((teamName)=>{
        setInputTeamName(teamName);
        setIsOpen(true);
    }, []);
    const handleOnClose = ()=>{
        setIsOpen(false);
        onCancel();
    };
    const handleOnCreate = (team)=>{
        const formattedTeam = {
            ...team,
            name: team.displayName
        };
        props.onCreate?.(formattedTeam);
    };
    return [
        isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "team-create-dialog"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $45GTD.PeopleAndTeamsConfigurationProvider), {
            product: "jira",
            locale: (0, $ao10V.default)(locale)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d4e307a1265eaa92$export$75096afde50756fd, {
            cloudId: cloudId,
            orgId: orgId,
            product: "jira",
            principalId: atlassianAccountId || user.accountId || '',
            onClose: handleOnClose,
            onCreateTeamSuccess: handleOnCreate,
            extraAnalyticsAttrs: props.analyticsCtx,
            enableMembershipSettingsChoice: enableMembershipSettingsChoice,
            currentUser: user.accountId ? {
                id: user.accountId,
                fullName: user.userFullname,
                // @ts-expect-error - TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'. | TS2339 - Property 'avatarUrls' does not exist on type 'DataBasic | (DataBasic & ResponseSuccess)'.
                avatarUrl: user.avatarUrls && user.avatarUrls['48x48'],
                ...user
            } : undefined,
            prepopulatedFields: {
                teamName: inputTeamName
            },
            addFlag: addFlag
        }))) : null,
        callback
    ];
};

});
parcelRegister("dNLwe", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('41Rip')
        ]);
        const value = parcelRequire('3PkL8');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("41Rip")
    ]).then(()=>parcelRequire('3PkL8'));
}

});


parcelRegister("QjiuJ", function(module, exports) {

$parcel$export(module.exports, "LazyTeamPickerEdit", () => $466c06ff57d4ee5e$export$eaed616868423e8a);
$parcel$export(module.exports, "AsyncTeamPickerEdit", () => $466c06ff57d4ee5e$export$7db2ade8dff2be91);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $9VPEO = parcelRequire("9VPEO");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $gd6Co = parcelRequire("gd6Co");
const $466c06ff57d4ee5e$var$EMPTY_OBJECT = {};

const $466c06ff57d4ee5e$export$eaed616868423e8a = (0, $7rh0R.lazy)(()=>(parcelRequire("eQrd8")), {
    moduleId: "./src/packages/issue/fields/team/src/ui/edit-mode/index.tsx"
});
const $466c06ff57d4ee5e$export$7db2ade8dff2be91 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $gd6Co.asyncTeamPickerEditEntryPoint), // use stable object reference to avoid re-renders
    $466c06ff57d4ee5e$var$EMPTY_OBJECT);
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "async-jira-issue-atlassian-team-picker-edit",
        packageName: "jira-issue-field-team",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.SkeletonCompiled), {
            width: "350px",
            height: "40px"
        }),
        errorFallback: "unmount"
    });
};

});
parcelRegister("gd6Co", function(module, exports) {

$parcel$export(module.exports, "asyncTeamPickerEditEntryPoint", () => $68b8796b9db76c2a$export$80ec8c2b96e9988);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $68b8796b9db76c2a$export$80ec8c2b96e9988 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("eQrd8")).then((module)=>module.TeamPickerEditEntryPointContent), {
        moduleId: "ce0fa7b5"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("eQrd8", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('jLoIc');
        const value = parcelRequire('hOa1E');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("jLoIc").then(()=>parcelRequire('hOa1E'));
}

});



parcelRegister("dibFF", function(module, exports) {

$parcel$export(module.exports, "FieldLoader", () => $8479f60db9ef4b80$export$dbd27b551621740c);

var $eUqFw = parcelRequire("eUqFw");

var $9VPEO = parcelRequire("9VPEO");
const $8479f60db9ef4b80$export$dbd27b551621740c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
        width: "350px",
        height: "40px"
    });

});

parcelRegister("iuMpO", function(module, exports) {

$parcel$export(module.exports, "mutateAtlassianTeamField", () => $7e86af44a59a06c6$export$c8b8a48d1ff67754);
$parcel$export(module.exports, "transformDefaultAtlassianTeam", () => $7e86af44a59a06c6$export$3fee94ad0b9e180c);
$parcel$export(module.exports, "transformAtlassianTeamFieldTypeString", () => $7e86af44a59a06c6$export$450002773f9da0a4);
$parcel$export(module.exports, "validateAtlassianTeamsField", () => $7e86af44a59a06c6$export$8222f94513c7d2e6);

var $dEMIg = parcelRequire("dEMIg");

const $7e86af44a59a06c6$export$c8b8a48d1ff67754 = (selectedTeam, fieldId)=>selectedTeam ? {
        fieldId: fieldId,
        mutationGroup: (0, $382d64cd40713055$export$31fd86f8f183952c),
        team: {
            teamId: selectedTeam.id
        }
    } : null;
const $7e86af44a59a06c6$export$3fee94ad0b9e180c = (team)=>({
        name: team.name,
        id: team.teamId,
        avatarUrl: team?.avatar?.small
    });
const $7e86af44a59a06c6$export$450002773f9da0a4 = (team)=>{
    if (team && team.id) return team.id;
    return null;
};
const $7e86af44a59a06c6$export$8222f94513c7d2e6 = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $dEMIg.REQUIRED;
    }
    return undefined;
};

});
const $382d64cd40713055$export$31fd86f8f183952c = 'atlassianTeamFields';



parcelRegister("8MMgG", function(module, exports) {

$parcel$export(module.exports, "default", () => $6272172d78f39ff5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $aUcBK = parcelRequire("aUcBK");

var $gGtKh = parcelRequire("gGtKh");

var $icPhQ = parcelRequire("icPhQ");
var $dibFF = parcelRequire("dibFF");
var $6HoNR = parcelRequire("6HoNR");

var $7TaJX = parcelRequire("7TaJX");
var $lIor1 = parcelRequire("lIor1");

var $8YKza = parcelRequire("8YKza");
const $6272172d78f39ff5$var$CascadingSelectField = (props)=>{
    const { fieldProps: { value: value, onChange: onChange, ...fieldProps }, allowedValues: cascadingSelectOptions, width: width, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $7TaJX.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isReadOnly: isReadOnly = false, isEditable: isEditable = true } = props;
    const { allowedValues: allowedValues, allowedChildValues: allowedChildValues } = (0, $8YKza.transformToCascadingSelectOptions)(cascadingSelectOptions);
    // TODO remove `Placeholder` and `FieldLoader` during cleanup of ff("load-async-cascading-select-field-edit-view-in-gic_k5etu")
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "cascading-select-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dibFF.FieldLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aUcBK.AsyncCascadingSelectEdit), {
        ...fieldProps,
        value: value,
        allowedValues: allowedValues,
        allowedChildValues: allowedChildValues,
        // @ts-expect-error - TS2322 - Type '(e: ChangeEvent<HTMLElement>) => boolean' is not assignable to type '(e: SyntheticEvent<HTMLElement, Event>) => boolean'.
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        // @ts-expect-error - TS2322 - Type '(value: SelectedOption) => void' is not assignable to type '(value: SelectedOption, meta: null, analyticsEvent: UIAnalyticsEventInterface) => Promise<void>'.
        onChange: onChange,
        isInvalid: false,
        autoFocus: autoFocus,
        areOptionsOnSameRow: false,
        isEditable: (0, $1ybV0.ff)('uim-cascading-select-field-support-gic_h1cda') ? !isReadOnly && isEditable : isEditable
    })));
};
var $6272172d78f39ff5$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    validator: (0, $lIor1.validateCascadingSelectField),
    transformDefaultValue: $8YKza.transformDefaultValue
})($6272172d78f39ff5$var$CascadingSelectField);

});
parcelRegister("aUcBK", function(module, exports) {

$parcel$export(module.exports, "AsyncCascadingSelectEdit", () => $50f8b3db4e20aa16$export$7db21897d0716698);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $9VPEO = parcelRequire("9VPEO");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $bAQOb = parcelRequire("bAQOb");

var $cDM4A = parcelRequire("cDM4A");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $50f8b3db4e20aa16$var$AsyncCascadingSelectEditControl = (0, $7rh0R.lazy)(()=>(parcelRequire("cAOlt")).then((module)=>module.CascadingSelectView), {
    moduleId: "./src/packages/issue/fields/cascading-select-custom-field/src/index.tsx"
});
const $50f8b3db4e20aa16$var$EMPTY_OBJECT = {};
const $50f8b3db4e20aa16$var$AsyncCascadingSelectEditExperiment = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $cDM4A.asyncCascadingSelectEditEntryPoint), // use stable object reference to avoid re-renders
    $50f8b3db4e20aa16$var$EMPTY_OBJECT);
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "async-jira-issue-field-cascading-select-edit",
        packageName: "jira-issue-field-cascading-select",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.SkeletonCompiled), {
            width: "350px",
            height: "40px"
        }),
        errorFallback: "unmount"
    });
};
const $50f8b3db4e20aa16$export$7db21897d0716698 = (0, $bAQOb.componentWithFF)('load-async-cascading-select-field-edit-view-in-gic_k5etu', $50f8b3db4e20aa16$var$AsyncCascadingSelectEditExperiment, $50f8b3db4e20aa16$var$AsyncCascadingSelectEditControl);

});
parcelRegister("cDM4A", function(module, exports) {

$parcel$export(module.exports, "asyncCascadingSelectEditEntryPoint", () => $570cf4bf71d193ec$export$336a3a4bd9539e41);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $570cf4bf71d193ec$export$336a3a4bd9539e41 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("fDt8l")).then((module)=>module.CascadingSelectViewEntryPointContent), {
        moduleId: "dba9fb26"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("fDt8l", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('fkQ79');
        const value = parcelRequire('g5UOm');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("fkQ79").then(()=>parcelRequire('g5UOm'));
}

});


parcelRegister("cAOlt", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('l9Qgq');
        const value = parcelRequire('bJvCH');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("l9Qgq").then(()=>parcelRequire('bJvCH'));
}

});


parcelRegister("8YKza", function(module, exports) {

$parcel$export(module.exports, "transformToCascadingSelectOptions", () => $6234c682ca01b3c0$export$b06e6053830d7554);
$parcel$export(module.exports, "transformDefaultValue", () => $6234c682ca01b3c0$export$e2f4e5d31db527cc);
$parcel$export(module.exports, "mutateCascadingSelectField", () => $6234c682ca01b3c0$export$f402e35d933d11b5);

const $6234c682ca01b3c0$export$facac75482a8e0c5 = (option)=>{
    const { value: value, id: id } = option || {};
    if (value && id) return {
        label: value,
        value: id
    };
    return null;
};
const $6234c682ca01b3c0$export$b06e6053830d7554 = (cascadingSelectData)=>{
    const allowedValues = [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const allowedChildValues = {};
    cascadingSelectData.forEach(({ parentOptionValue: parentOptionValue, childOptionValues: childOptionValues })=>{
        const transformedParentOption = $6234c682ca01b3c0$export$facac75482a8e0c5(parentOptionValue);
        if (parentOptionValue !== null && transformedParentOption !== null) {
            allowedValues.push(transformedParentOption);
            allowedChildValues[parentOptionValue.id] = childOptionValues.map($6234c682ca01b3c0$export$facac75482a8e0c5);
        }
    });
    return {
        allowedValues: allowedValues,
        allowedChildValues: allowedChildValues
    };
};
const $6234c682ca01b3c0$export$e2f4e5d31db527cc = (defaultValue)=>{
    const { parentOptionValue: parentOptionValue, childOptionValue: childOptionValue } = defaultValue;
    const transformedParentOption = $6234c682ca01b3c0$export$facac75482a8e0c5(parentOptionValue);
    let transformedDefaultValue = null;
    if (transformedParentOption !== null) transformedDefaultValue = {
        ...transformedParentOption,
        child: childOptionValue ? $6234c682ca01b3c0$export$facac75482a8e0c5(childOptionValue) : undefined
    };
    return transformedDefaultValue;
};
const $6234c682ca01b3c0$export$f402e35d933d11b5 = (selectedOption, fieldId)=>({
        fieldId: fieldId,
        parentOptionValue: {
            optionId: selectedOption.value
        },
        // @ts-expect-error - TS2339 - Property 'child' does not exist on type 'Option | ParentChildOption'.
        childOptionValue: selectedOption.child ? {
            // @ts-expect-error - TS2339 - Property 'child' does not exist on type 'Option | ParentChildOption'.
            optionId: selectedOption.child.value
        } : null,
        mutationGroup: (0, $f67d0c0fa3404504$export$31fd86f8f183952c)
    });

});
const $f67d0c0fa3404504$export$31fd86f8f183952c = 'cascadingSelectFields';



parcelRegister("l3c1m", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8c7312bc09ec7d5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $co2Cj = parcelRequire("co2Cj");
var $j8vGU = parcelRequire("j8vGU");

var $icPhQ = parcelRequire("icPhQ");
var $6HoNR = parcelRequire("6HoNR");

var $lIor1 = parcelRequire("lIor1");

var $8aayW = parcelRequire("8aayW");
const $b8c7312bc09ec7d5$var$CheckboxField = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange }, error: error, allowedValues: allowedValues, fieldId: fieldId, isReadOnly: isReadOnly = false } = props;
    const options = (0, $j8vGU.mapDataToOptions)(allowedValues);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $co2Cj.default), {
        options: options,
        values: value,
        onChange: onChange,
        isInvalid: Boolean(error),
        isDisabled: isReadOnly,
        fieldId: fieldId
    }));
};
var $b8c7312bc09ec7d5$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    validator: (0, $lIor1.validateCheckboxField),
    transformDefaultValue: (0, $j8vGU.mapDataToOptions)
})($b8c7312bc09ec7d5$var$CheckboxField);

});
parcelRegister("co2Cj", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbecb855bd4cdc94$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bT7k5 = parcelRequire("bT7k5");

var $fq5oV = parcelRequire("fq5oV");

var $j8vGU = parcelRequire("j8vGU");
const $fbecb855bd4cdc94$var$CheckboxGroupEdit = (props)=>{
    const { values: values, options: options, isDisabled: isDisabled = false, onChange: onChange, isInvalid: isInvalid, fieldId: fieldId } = props;
    const onChangeCheckedItems = (event)=>{
        const itemValue = event.target.value;
        const retainValue = (0, $j8vGU.setRetainValue)({
            options: options,
            itemValue: itemValue,
            values: values
        });
        onChange(retainValue);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, options?.map((option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fq5oV.default), {
            name: fieldId,
            key: option.value
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
                ...fieldProps,
                key: option.value,
                value: option.value,
                label: option.label,
                isChecked: values?.some((data)=>data.value === option.value),
                onChange: onChangeCheckedItems,
                isInvalid: isInvalid,
                isDisabled: isDisabled
            }))));
};
var $fbecb855bd4cdc94$export$2e2bcd8739ae039 = $fbecb855bd4cdc94$var$CheckboxGroupEdit;

});
parcelRegister("fq5oV", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4e274233a51aeef$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4LhB6 = parcelRequire("4LhB6");
/**
 * __Checkbox field__
 *
 * A checkbox field is a form field that lets users select an item. Users can check or uncheck the checkbox.
 *
 * - [Examples] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Code] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Usage] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 */ const $f4e274233a51aeef$var$CheckboxField = (props)=>{
    const { children: children, defaultIsChecked: defaultIsChecked = false, value: value, ...rest } = props;
    // Maintains a memoised list of the default values
    const defaultValue = (0, $eUqFw.useCallback)((currentValue = [])=>defaultIsChecked && value !== undefined ? [
            ...currentValue,
            value
        ] : currentValue, [
        value,
        defaultIsChecked
    ]);
    return value !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        ...rest,
        defaultValue: defaultValue,
        transform: (event, currentValue)=>event.currentTarget.checked && currentValue ? [
                ...currentValue,
                value
            ] : currentValue.filter((v)=>v !== value)
    }, ({ fieldProps: { value: fieldValue, ...otherFieldProps }, ...others })=>children({
            fieldProps: {
                ...otherFieldProps,
                isChecked: !!fieldValue.find((v)=>v === value),
                value: value
            },
            ...others
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        ...rest,
        defaultValue: defaultIsChecked,
        transform: (event)=>event.currentTarget.checked
    }, ({ fieldProps: { value: fieldValue, ...otherFieldProps }, ...others })=>children({
            fieldProps: {
                ...otherFieldProps,
                isChecked: fieldValue,
                value: value
            },
            ...others
        }));
};
$f4e274233a51aeef$var$CheckboxField.defaultProps = {
    defaultIsChecked: false
};
var $f4e274233a51aeef$export$2e2bcd8739ae039 = $f4e274233a51aeef$var$CheckboxField;

});

parcelRegister("j8vGU", function(module, exports) {

$parcel$export(module.exports, "mapDataToOptions", () => $e7d037b2bc2c8341$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionsToData", () => $e7d037b2bc2c8341$export$ffef3a401aef987b);
$parcel$export(module.exports, "setRetainValue", () => $e7d037b2bc2c8341$export$7f2b89a121299348);
const $e7d037b2bc2c8341$export$99a866ffa3af7d8b = (data)=>data.map(({ id: id, value: value })=>({
            label: value,
            value: id
        }));
const $e7d037b2bc2c8341$export$ffef3a401aef987b = (options)=>options.map(({ label: label, value: value })=>({
            id: value,
            value: label
        }));
const $e7d037b2bc2c8341$export$7f2b89a121299348 = ({ options: options, itemValue: itemValue, values: values })=>{
    const selectedOption = options?.find((option)=>option.value === itemValue);
    let retainValue = [
        ...values || []
    ];
    let isElementAlreadyChecked = false;
    const newCheckedItems = values?.filter((item)=>{
        if (item.value === itemValue) isElementAlreadyChecked = true;
        return item.value !== itemValue;
    });
    if (isElementAlreadyChecked && newCheckedItems !== undefined) retainValue = newCheckedItems;
    else if (selectedOption) retainValue.push(selectedOption);
    return retainValue;
};

});


parcelRegister("8aayW", function(module, exports) {

$parcel$export(module.exports, "mutateCheckboxField", () => $44836f02c5d0fe1e$export$23a688ac1e0973b5);

const $44836f02c5d0fe1e$export$23a688ac1e0973b5 = (values, fieldId)=>{
    const transformedValues = values.map(({ value: value })=>({
            optionId: value
        }));
    return {
        fieldId: fieldId,
        mutationGroup: (0, $6af160c7980ac15f$export$31fd86f8f183952c),
        options: transformedValues
    };
};

});
const $6af160c7980ac15f$export$31fd86f8f183952c = 'multipleSelectFields';



parcelRegister("6ynFi", function(module, exports) {

$parcel$export(module.exports, "default", () => $142ded1e16a3a44b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $d7a37 = parcelRequire("d7a37");

var $8ZEDa = parcelRequire("8ZEDa");

var $gGtKh = parcelRequire("gGtKh");

var $icPhQ = parcelRequire("icPhQ");
var $dibFF = parcelRequire("dibFF");
var $6HoNR = parcelRequire("6HoNR");

var $lIor1 = parcelRequire("lIor1");

var $7TaJX = parcelRequire("7TaJX");

var $k8ImN = parcelRequire("k8ImN");
const $142ded1e16a3a44b$var$CheckboxSelectField = (props)=>{
    const { autoFocus: autoFocus, width: width, fieldProps: { value: value, onChange: onChange, ...fieldProps }, error: error, allowedValues: allowedValues, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $7TaJX.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isReadOnly: isReadOnly = false } = props;
    const options = (0, $d7a37.mapDataToOptions)(allowedValues);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "async-checkbox-select-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dibFF.FieldLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ZEDa.AsyncCheckboxSelectEdit), {
        ...fieldProps,
        options: options,
        value: value,
        onChange: onChange,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        autoFocus: autoFocus,
        isInvalid: Boolean(error),
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDisabled: isReadOnly
    })));
};
var $142ded1e16a3a44b$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    validator: (0, $lIor1.validateCheckboxField),
    transformDefaultValue: (0, $d7a37.mapDataToOptions)
})($142ded1e16a3a44b$var$CheckboxSelectField);

});
parcelRegister("d7a37", function(module, exports) {

$parcel$export(module.exports, "mapDataToOptions", () => $9aa1711e7f9491e1$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionsToData", () => $9aa1711e7f9491e1$export$ffef3a401aef987b);
const $9aa1711e7f9491e1$export$99a866ffa3af7d8b = (data)=>data.map(({ id: id, value: value })=>({
            label: value,
            value: id
        }));
const $9aa1711e7f9491e1$export$ffef3a401aef987b = (options)=>options.map(({ label: label, value: value })=>({
            id: value,
            value: label
        }));

});

parcelRegister("8ZEDa", function(module, exports) {

$parcel$export(module.exports, "AsyncCheckboxSelectEdit", () => $70e0995699598355$export$48ad7b39ee5392c2);

var $7rh0R = parcelRequire("7rh0R");

const $70e0995699598355$export$48ad7b39ee5392c2 = (0, $7rh0R.lazy)(()=>(parcelRequire("10ykO")).then((module)=>module.CheckboxSelectEdit), {
    moduleId: "./src/packages/issue/fields/checkbox-select/src/index.tsx"
});

});
parcelRegister("10ykO", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('coVry');
        const value = parcelRequire('kXRO4');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("coVry").then(()=>parcelRequire('kXRO4'));
}

});


parcelRegister("k8ImN", function(module, exports) {

$parcel$export(module.exports, "mutateCheckboxSelectField", () => $3000672f0e7b8811$export$132960f869959e21);

const $3000672f0e7b8811$export$132960f869959e21 = (selectedValues, fieldId)=>({
        fieldId: fieldId,
        mutationGroup: (0, $a028cb2f549b82b2$export$31fd86f8f183952c),
        options: selectedValues.map(({ value: value })=>({
                optionId: value
            }))
    });

});
const $a028cb2f549b82b2$export$31fd86f8f183952c = 'multipleSelectFields';



parcelRegister("aYzpN", function(module, exports) {

$parcel$export(module.exports, "default", () => $9811fb9fa50afca1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $80Y9u = parcelRequire("80Y9u");

var $53c4R = parcelRequire("53c4R");

var $icPhQ = parcelRequire("icPhQ");
var $6HoNR = parcelRequire("6HoNR");

var $7TaJX = parcelRequire("7TaJX");
const $9811fb9fa50afca1$var$CmdbField = (props)=>{
    const { autoCompleteUrl: autoCompleteUrl, additionalData: { isMulti: isMulti = false, attributesIncludedInAutoCompleteSearch: attributesIncludedInAutoCompleteSearch }, fieldProps: { value: value, onChange: onChange }, contextAndValuesOfIssueBeingCreated: contextAndValuesOfIssueBeingCreated, selectedProject: selectedProject, autoFocus: autoFocus = false, width: width, fieldId: fieldId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $53c4R.LimitData), {
        limitProperty: (0, $53c4R.MAX_CMDB_OBJECTS_PER_FIELD)
    }, (limit)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80Y9u.CmdbFieldObjectPicker), {
            autoCompleteUrl: `${autoCompleteUrl}?`,
            displayedValues: value,
            selectedValues: value,
            attributesToDisplayInSearch: attributesIncludedInAutoCompleteSearch,
            multiple: isMulti,
            onChange: onChange,
            autoFocus: autoFocus,
            limit: limit,
            menuPosition: "fixed",
            onCloseMenuOnScroll: (0, $7TaJX.closeMenuOnScroll),
            contextAndValuesOfIssueBeingCreated: {
                ...contextAndValuesOfIssueBeingCreated,
                fieldId: fieldId,
                selectedProject: selectedProject
            }
        })));
};
var // @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<CmdbFieldConfig, FieldValue>, any>'.
$9811fb9fa50afca1$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({})($9811fb9fa50afca1$var$CmdbField);

});
parcelRegister("80Y9u", function(module, exports) {

$parcel$export(module.exports, "CmdbFieldObjectPicker", () => $70ce0b5c5f86916a$export$2c337ae5a2979962);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
var $5wCDk = parcelRequire("5wCDk");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $cwPlh = parcelRequire("cwPlh");
var $c1pIO = parcelRequire("c1pIO");

var $gHxUc = parcelRequire("gHxUc");

var $7lyjF = parcelRequire("7lyjF");

var $79K7j = parcelRequire("79K7j");

var $jc68F = parcelRequire("jc68F");

var $fJdfC = parcelRequire("fJdfC");

var $45iG4 = parcelRequire("45iG4");

var $4bK0l = parcelRequire("4bK0l");
const $70ce0b5c5f86916a$export$f3d4a8207a9d907f = (attributesToDisplayInSearch)=>(cmdbObject)=>{
        const getDisplayValuesFromAttribute = (attribute)=>attribute.objectAttributeValues.map((val)=>val.displayValue).join(' ');
        // This label is the string value that @atlaskit/select uses under the hood
        // to determine a 'match' when typing in the select field. Therefore, we need to
        // build a string that includes values for all the attributes marked as
        // 'searchable' within the Insight field configuration.
        const searchableLabel = cmdbObject.attributes.map((attribute)=>{
            if (// @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
            attributesToDisplayInSearch.includes(attribute.objectTypeAttribute.name) || attributesToDisplayInSearch.includes('Label') && attribute.objectTypeAttribute.label === true) return getDisplayValuesFromAttribute(attribute);
            return undefined;
        }).filter(Boolean).join(' ');
        // Label should fall back to the label attribute of the object if it doesn't contain any of the search attributes
        return {
            value: cmdbObject.id,
            label: searchableLabel || cmdbObject.label,
            rawData: cmdbObject
        };
    };
const $70ce0b5c5f86916a$export$cc2466dccf2cb27d = (values)=>{
    if (!values) return values;
    return values.map((x)=>({
            label: x.label,
            value: x.objectId,
            rawData: x
        }));
};
const $70ce0b5c5f86916a$export$2c337ae5a2979962 = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [hasConfigError, setHasConfigError] = (0, $eUqFw.useState)(false);
    const { autoCompleteUrl: autoCompleteUrl, attributesToDisplayInSearch: attributesToDisplayInSearch = [], multiple: multiple = false, displayedValues: displayedValues, selectedValues: selectedValues = [], onChange: propsOnChange, issueId: issueId, limit: limit, autoFocus: autoFocus, menuPosition: menuPosition = 'absolute', onCloseMenuOnScroll: onCloseMenuOnScroll, contextAndValuesOfIssueBeingCreated: contextAndValuesOfIssueBeingCreated, testId: testId } = props;
    const fetchCmdbObjects = (searchValue)=>{
        if (typeof autoCompleteUrl === 'string' && autoCompleteUrl) return (0, $7lyjF.searchCmdbObjects)(autoCompleteUrl, searchValue, issueId, (0, $cwPlh.extractFieldValueMap)(contextAndValuesOfIssueBeingCreated));
        throw new Error('Invalid URL');
    };
    const transformObjectToSelectOption = (0, $eUqFw.useMemo)(()=>$70ce0b5c5f86916a$export$f3d4a8207a9d907f(attributesToDisplayInSearch), [
        attributesToDisplayInSearch
    ]);
    const { selectProps: selectProps, error: error, totalNumberOfResults: totalNumberOfResults } = (0, $c1pIO.usePaginatedAutocomplete)(selectedValues, fetchCmdbObjects, transformObjectToSelectOption, contextAndValuesOfIssueBeingCreated);
    let numberOfSearchResults;
    if ((0, $eI5EY.fg)('assets_rearch_total_count_deprecated_for_field')) numberOfSearchResults = (totalNumberOfResults ?? 0) >= (0, $gHxUc.MAX_OBJECT_COUNT_CUTOFF) ? `${0, $gHxUc.MAX_OBJECT_COUNT_CUTOFF}+` : totalNumberOfResults;
    else numberOfSearchResults = totalNumberOfResults;
    const selectPropsWithLabel = selectProps && Object.keys(selectProps).length && {
        ...selectProps,
        options: [
            {
                label: formatMessage((0, $45iG4.default).dropdownNumberOfSearchResultsLabel, {
                    numberOfSearchResults: numberOfSearchResults,
                    isLoading: selectProps.isLoading
                }),
                options: selectProps.options
            }
        ]
    };
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const onChange = (0, $eUqFw.useCallback)((selectedOption)=>{
        if (!selectedOption) {
            propsOnChange([]);
            return;
        }
        if (Array.isArray(selectedOption)) propsOnChange(selectedOption.map((x)=>x.rawData));
        if (!Array.isArray(selectedOption)) propsOnChange([
            selectedOption.rawData
        ]);
    }, [
        propsOnChange
    ]);
    const showGenericErrorFlag = (0, $eUqFw.useCallback)(()=>{
        showFlag({
            type: 'error',
            title: formatMessage((0, $45iG4.default).errorTitleCmdbAssets),
            description: formatMessage((0, $45iG4.default).errorMessage),
            isAutoDismiss: true
        });
    }, [
        formatMessage,
        showFlag
    ]);
    const responseErrorHandler = (0, $eUqFw.useMemo)(()=>({
            404: ()=>(0, $1ybV0.ff)('cmdb-field-object-picker-error-message_w69je') ? setHasConfigError(true) : showGenericErrorFlag(),
            400: ()=>(0, $1ybV0.ff)('fly-1941-cmdb-field-aql-error_crp0k') ? showFlag({
                    type: 'error',
                    title: formatMessage((0, $45iG4.default).errorTitleCmdbFieldSearch),
                    description: formatMessage((0, $45iG4.default).errorMessageCmdbFieldSearch),
                    isAutoDismiss: true
                }) : showGenericErrorFlag()
        }), [
        formatMessage,
        showFlag,
        showGenericErrorFlag
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (error) responseErrorHandler[error.statusCode] ? responseErrorHandler[error.statusCode]() : showGenericErrorFlag();
    }, [
        error,
        responseErrorHandler,
        showGenericErrorFlag
    ]);
    const { Option: Option } = (0, $jQxSL.c);
    const customComponents = (0, $eUqFw.useMemo)(()=>({
            // @ts-expect-error - TS7006 - Parameter 'optionProps' implicitly has an 'any' type.
            Option: (optionProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Option, optionProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jc68F.CmdbSelectOption), {
                    label: optionProps.label,
                    data: optionProps.data,
                    selectProps: optionProps.selectProps,
                    attributesToDisplayInSearch: attributesToDisplayInSearch
                }))
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        attributesToDisplayInSearch
    ]);
    const singleObjectReached = !multiple && selectedValues.length === 1;
    const singleObjectExceeded = !multiple && selectedValues.length > 1;
    const objectLimitReached = selectedValues.length === limit;
    const objectLimitExceeded = selectedValues.length > limit;
    const shouldShowSelect = (multiple || selectedValues.length === 0) && selectedValues.length < limit;
    const getMessages = (objectLimit)=>{
        const validationMessages = [];
        singleObjectExceeded && validationMessages.push({
            label: 'warning',
            messageContent: formatMessage((0, $45iG4.default).warningMultipleObjectsMessage)
        });
        objectLimitExceeded && validationMessages.push({
            label: 'warning',
            messageContent: formatMessage((0, $45iG4.default).warningObjectLimitExceeded, {
                objectLimit: objectLimit
            })
        });
        singleObjectReached && validationMessages.push({
            label: 'info',
            messageContent: formatMessage((0, $45iG4.default).infoSingleObjectMessage)
        });
        objectLimitReached && validationMessages.push({
            label: 'info',
            messageContent: formatMessage((0, $45iG4.default).infoObjectLimitReached, {
                objectLimit: objectLimit
            })
        });
        return validationMessages.length > 0 ? [
            validationMessages[0]
        ] : [];
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": testId
    }, hasConfigError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $79K7j.CmdbFieldError), {
        fieldId: contextAndValuesOfIssueBeingCreated?.fieldId
    }), !hasConfigError && (displayedValues || shouldShowSelect) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
        // Setting a value of null causes the field to go back to being empty after a selection is made
        value: $70ce0b5c5f86916a$export$cc2466dccf2cb27d(displayedValues),
        isMulti: multiple,
        autoFocus: autoFocus,
        // @ts-expect-error - TS2322 - Type '(selectedOption: OptionsType<CmdbObject> | OptionsType<CmdbObject>[]) => void' is not assignable to type '(value: OptionsType<CmdbObject> | OptionsType<...> | null, action: ActionMeta<...>) => void'.
        onChange: onChange,
        placeholder: formatMessage((0, $45iG4.default).searchPlaceholder),
        components: customComponents,
        isClearable: true,
        menuPlacement: "auto",
        // @ts-expect-error - TS2322 - Type 'string | null' is not assignable to type 'MenuPosition | undefined'.
        menuPosition: menuPosition,
        // @ts-expect-error - TS2322 - Type '{ readonly menu: (base: CSSProperties) => { zIndex: 510; accentColor?: string | undefined; alignContent?: string | undefined; alignItems?: string | undefined; alignSelf?: string | undefined; alignmentBaseline?: string | undefined; ... 446 more ...; setProperty?: ((property: string, value: string | null, priority?: s...' is not assignable to type 'Partial<Styles<OptionsType<CmdbObject>, boolean, GroupTypeBase<OptionsType<CmdbObject>>>>'.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        styles: (0, $4bK0l.customStyles),
        closeMenuOnScroll: onCloseMenuOnScroll,
        ...selectPropsWithLabel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fJdfC.EditMessage), {
        messages: getMessages(limit)
    }));
};

});
parcelRegister("cwPlh", function(module, exports) {

$parcel$export(module.exports, "extractFieldValueMap", () => $1014a428250fc6fe$export$fb98c8002c9a4960);

var $lO4Or = parcelRequire("lO4Or");
const $1014a428250fc6fe$var$getStringValue = (fieldValues)=>fieldValues;
const $1014a428250fc6fe$var$getJoinedArray = (fieldValues)=>fieldValues.map(({ value: value })=>value).join(',');
const $1014a428250fc6fe$var$extractFieldValueMethods = {
    [(0, $lO4Or.SUMMARY_TYPE)]: $1014a428250fc6fe$var$getStringValue,
    [(0, $lO4Or.DUE_DATE_TYPE)]: $1014a428250fc6fe$var$getStringValue,
    [(0, $lO4Or.AFFECTS_VERSIONS_TYPE)]: $1014a428250fc6fe$var$getJoinedArray,
    [(0, $lO4Or.FIX_VERSIONS_TYPE)]: $1014a428250fc6fe$var$getJoinedArray,
    [(0, $lO4Or.COMPONENTS_TYPE)]: $1014a428250fc6fe$var$getJoinedArray,
    [(0, $lO4Or.ASSIGNEE_TYPE)]: ({ accountId: accountId })=>accountId,
    [(0, $lO4Or.REPORTER_TYPE)]: ({ id: id })=>id,
    [(0, $lO4Or.PRIORITY_TYPE)]: ({ value: value })=>value,
    [(0, $lO4Or.RESOLUTION_TYPE)]: ({ value: value })=>value,
    [(0, $lO4Or.CMDB_OBJECT_CF_TYPE)]: (fieldValues)=>fieldValues.map(({ workspaceId: workspaceId, objectId: objectId })=>`${workspaceId}:${objectId}`).join(',')
};
const $1014a428250fc6fe$var$extractIssueTypeValue = (selectedIssueType)=>selectedIssueType.type === 'REQUEST_TYPE' ? selectedIssueType.issueTypeId : selectedIssueType.value;
const $1014a428250fc6fe$export$fb98c8002c9a4960 = (contextAndValues)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    if (contextAndValues) {
        const { getFormState: getFormState, fieldConfig: fieldConfig, selectedProject: selectedProject, selectedIssueType: selectedIssueType } = contextAndValues;
        const formData = getFormState().values;
        Object.keys(formData).forEach((fieldId)=>{
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly summary: (fieldValues: string) => string; readonly duedate: (fieldValues: string) => string; readonly versions: (fieldValues: Options | VersionOption[]) => string; ... 6 more ...; readonly "com.atlassian.jira.plugins.cmdb:cmdb-object-cftype": (fieldValues: CmdbObject[]) => string; }'.
            const extractFieldValue = $1014a428250fc6fe$var$extractFieldValueMethods[fieldConfig[fieldId]?.fieldType];
            const fieldValues = formData[fieldId];
            if (extractFieldValue && fieldValues) result[fieldId] = extractFieldValue(fieldValues);
        });
        if (selectedProject) result.pid = selectedProject.value;
        if (selectedIssueType) result.issuetype = $1014a428250fc6fe$var$extractIssueTypeValue(selectedIssueType);
    }
    return result;
};

});

parcelRegister("c1pIO", function(module, exports) {

$parcel$export(module.exports, "usePaginatedAutocomplete", () => $62c786ede77d3485$export$6e13ec0c80bdfaa8);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $9U2XD = parcelRequire("9U2XD");

var $cwPlh = parcelRequire("cwPlh");

var $jW6Gq = parcelRequire("jW6Gq");
const $62c786ede77d3485$var$filterOutAlreadySelectedOptionFromAvailableOptions = (availableOptions, optionsToRemove)=>availableOptions.filter((optionFromRequest)=>!optionsToRemove.find((selectedOption)=>selectedOption.id === optionFromRequest.id));
const $62c786ede77d3485$var$addOrReplaceNewResults = (action, optionsToSave)=>(oldOptions)=>{
        switch(action){
            case (0, $jW6Gq.Actions).APPEND:
                return [
                    ...oldOptions,
                    ...optionsToSave
                ];
            case (0, $jW6Gq.Actions).REPLACE:
            default:
                return optionsToSave;
        }
    };
const $62c786ede77d3485$var$calculateNumberOfResults = (totalNumberOfResults, savedResultFromTheSearch, displayedOptions)=>{
    if (totalNumberOfResults) return totalNumberOfResults - (savedResultFromTheSearch.length - displayedOptions.length);
    return totalNumberOfResults;
};
const $62c786ede77d3485$export$6e13ec0c80bdfaa8 = (selectedResults, doFetch, transform, contextAndValuesOfIssueBeingCreated)=>{
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [savedResultFromTheSearch, setSavedResultFromTheSearch] = (0, $eUqFw.useState)([]);
    const [hasUserEnteredTextForLastSearch, setHasUserEnteredTextForLastSearch] = (0, $eUqFw.useState)(undefined);
    const [totalNumberOfResults, setTotalNumberOfResults] = (0, $eUqFw.useState)();
    const [error, setError] = (0, $eUqFw.useState)();
    const fetchNextPageRef = (0, $eUqFw.useRef)();
    const isMenuOpen = (0, $eUqFw.useRef)(false);
    const oldContextRef = (0, $eUqFw.useRef)();
    const fetchSearchResults = async (fetchFunction, action)=>{
        setIsLoading(true);
        try {
            const { results: results, fetchNextPage: nextPageFunction, total: total } = await fetchFunction();
            setTotalNumberOfResults(total);
            const newOptions = $62c786ede77d3485$var$filterOutAlreadySelectedOptionFromAvailableOptions(results, selectedResults);
            if (newOptions.length === 0 && nextPageFunction) await fetchSearchResults(nextPageFunction, (0, $jW6Gq.Actions).APPEND);
            else fetchNextPageRef.current = nextPageFunction;
            setSavedResultFromTheSearch($62c786ede77d3485$var$addOrReplaceNewResults(action, results));
            (0, $9U2XD.autocompleteInsightFieldExperience).success();
            setIsLoading(false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            fetchNextPageRef.current = undefined;
            (0, $9U2XD.autocompleteInsightFieldExperience).failure();
            if (err && err.name === 'AbortError') return;
            setError(err);
            setIsLoading(false);
        }
    };
    const onInputChange = (searchValue, type)=>{
        // Fetch search results not triggered on selection of object
        if (type.action === 'input-change') {
            (0, $9U2XD.autocompleteInsightFieldExperience).start();
            setHasUserEnteredTextForLastSearch(searchValue !== '');
            fetchSearchResults(()=>doFetch(searchValue), (0, $jW6Gq.Actions).REPLACE);
        }
    };
    const debouncedOnInputChange = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(onInputChange, 400);
    const onMenuScrollToBottom = async ()=>{
        if (fetchNextPageRef.current) {
            (0, $9U2XD.autocompleteInsightFieldExperience).start();
            await fetchSearchResults(fetchNextPageRef.current, (0, $jW6Gq.Actions).APPEND);
        }
    };
    const hasContextChanged = (currentContext)=>{
        const fieldId = contextAndValuesOfIssueBeingCreated?.fieldId;
        const oldContext = oldContextRef.current;
        if (!oldContext || !currentContext) return false;
        const currentContextKeys = Object.keys(currentContext);
        const oldContextKeys = Object.keys(oldContext);
        if (currentContextKeys.length !== oldContextKeys.length) return true;
        for(let i = 0; i < currentContextKeys.length; i += 1){
            const key = currentContextKeys[i];
            const value1 = currentContext[key];
            const value2 = oldContext[key];
            const isCheckingValueOfCurrentField = fieldId === key;
            if (!isCheckingValueOfCurrentField && value1 !== value2) return true;
        }
        return false;
    };
    const onMenuOpen = async ()=>{
        if (!isMenuOpen.current) {
            isMenuOpen.current = true;
            (0, $9U2XD.autocompleteInsightFieldExperience).start();
            const currentContext = (0, $cwPlh.extractFieldValueMap)(contextAndValuesOfIssueBeingCreated);
            if (hasUserEnteredTextForLastSearch !== false || hasContextChanged(currentContext)) {
                await fetchSearchResults(()=>doFetch(''), (0, $jW6Gq.Actions).REPLACE);
                setHasUserEnteredTextForLastSearch(false);
                oldContextRef.current = currentContext;
            } else (0, $9U2XD.autocompleteInsightFieldExperience).success();
        }
    };
    const onMenuClose = ()=>{
        isMenuOpen.current = false;
    };
    const displayedOptions = (0, $eUqFw.useMemo)(()=>$62c786ede77d3485$var$filterOutAlreadySelectedOptionFromAvailableOptions(savedResultFromTheSearch, selectedResults).map(transform), [
        savedResultFromTheSearch,
        selectedResults,
        transform
    ]);
    return {
        error: error,
        selectProps: {
            isLoading: isLoading,
            options: displayedOptions,
            onInputChange: debouncedOnInputChange,
            onMenuScrollToBottom: onMenuScrollToBottom,
            onMenuOpen: onMenuOpen,
            onMenuClose: onMenuClose
        },
        totalNumberOfResults: $62c786ede77d3485$var$calculateNumberOfResults(totalNumberOfResults, savedResultFromTheSearch, displayedOptions)
    };
};

});
parcelRegister("jW6Gq", function(module, exports) {

$parcel$export(module.exports, "Actions", () => $38a482b6d58a995c$export$b52183d5cfb26dc9);
const $38a482b6d58a995c$export$b52183d5cfb26dc9 = Object.freeze({
    APPEND: 'APPEND',
    REPLACE: 'REPLACE'
});

});


parcelRegister("gHxUc", function(module, exports) {

$parcel$export(module.exports, "ALLOWED_TEXT_AREA_ATTRIBUTE_HTML_TAGS", () => $51946cde09cfe7c0$export$3d2246e48d9cfed3);
$parcel$export(module.exports, "DATE_VALUE_FORMAT", () => $51946cde09cfe7c0$export$d1fb6689cfa66d9b);
$parcel$export(module.exports, "TIME_VALUE_FORMAT", () => $51946cde09cfe7c0$export$5f2ab89513b5926a);
$parcel$export(module.exports, "ZONE_VALUE_FORMAT", () => $51946cde09cfe7c0$export$5c2d6de3ca9adcbe);
$parcel$export(module.exports, "GENERAL_DATE_TIME_FORMAT", () => $51946cde09cfe7c0$export$defafc11b2455f78);
$parcel$export(module.exports, "SCREEN_READER_DATE_TIME_FORMAT", () => $51946cde09cfe7c0$export$f61f3fa9ed38719a);
$parcel$export(module.exports, "globalErrorContexts", () => $51946cde09cfe7c0$export$b896d7bac8b72b0);
$parcel$export(module.exports, "MAX_OBJECT_COUNT_CUTOFF", () => $51946cde09cfe7c0$export$89b103afe26b1ad0);
/**
 * When there is a `textarea` type attribute on an object, the user can enter rich text that
 * is saved and transferred as raw HTML. Because of this, we need to sanitize the input
 * before rendering it to prevent XSS. The below is the allowlist of HTML tags we're expecting
 * to receieve from the editor. All other tags will be stripped out before rendering.
 */ const $51946cde09cfe7c0$export$3d2246e48d9cfed3 = [
    'p',
    'u',
    'a',
    'em',
    'strong',
    'span',
    'ol',
    'ul',
    'li',
    'pre',
    'code',
    'h2',
    'h3',
    'h4',
    'hr',
    'table',
    'thead',
    'tbody',
    'tr',
    'th',
    'td'
];
const $51946cde09cfe7c0$export$d1fb6689cfa66d9b = 'yyyy-MM-dd';
const $51946cde09cfe7c0$export$5f2ab89513b5926a = 'HH:mm';
const $51946cde09cfe7c0$export$5c2d6de3ca9adcbe = 'XXX';
const $51946cde09cfe7c0$export$defafc11b2455f78 = 'dd/MMM/yy h:mm a';
const $51946cde09cfe7c0$export$f97789ccd031e7d = 'dd/MMM/yy';
const $51946cde09cfe7c0$export$f61f3fa9ed38719a = 'do MMMM Y h:mm a';
const $51946cde09cfe7c0$export$b896d7bac8b72b0 = [
    'objectsLimit',
    'objectTypeAttributesLimit',
    'objectSchemaLimit'
];
const $51946cde09cfe7c0$export$89b103afe26b1ad0 = 1000;

});

parcelRegister("7lyjF", function(module, exports) {

$parcel$export(module.exports, "searchCmdbObjects", () => $d6745f3b90212859$export$24be3d709330b09);

var $2OdyW = parcelRequire("2OdyW");
const $d6745f3b90212859$var$RESULTS_PER_PAGE = 50;
// @ts-expect-error - TS7031 - Binding element 'size' implicitly has an 'any' type. | TS7031 - Binding element 'hasNextPage' implicitly has an 'any' type. | TS7031 - Binding element 'results' implicitly has an 'any' type. | TS7031 - Binding element 'total' implicitly has an 'any' type.
const $d6745f3b90212859$var$transform = ({ size: size, hasNextPage: hasNextPage, results: results, total: total })=>({
        size: size,
        hasNextPage: hasNextPage,
        // @ts-expect-error - TS7006 - Parameter 'entry' implicitly has an 'any' type.
        results: results.map((entry)=>({
                ...entry,
                // @ts-expect-error - TS7006 - Parameter 'att' implicitly has an 'any' type.
                attributes: entry.attributes.map((att)=>({
                        ...att,
                        type: att.objectTypeAttribute.type
                    }))
            })),
        total: total
    });
let $d6745f3b90212859$var$abortController = null;
const $d6745f3b90212859$export$24be3d709330b09 = async (autoCompleteUrl, query, issueId, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
fieldValueMap, page = 0)=>{
    if ($d6745f3b90212859$var$abortController && $d6745f3b90212859$var$abortController.abort) $d6745f3b90212859$var$abortController.abort();
    $d6745f3b90212859$var$abortController = new AbortController();
    const result = await (0, $2OdyW.default)(`${autoCompleteUrl}start=${$d6745f3b90212859$var$RESULTS_PER_PAGE * page}&limit=${$d6745f3b90212859$var$RESULTS_PER_PAGE}`, {
        method: 'POST',
        body: JSON.stringify({
            query: query,
            issueId: issueId,
            fieldValueMap: fieldValueMap
        }),
        signal: $d6745f3b90212859$var$abortController.signal
    }).then($d6745f3b90212859$var$transform);
    return {
        results: result.results,
        fetchNextPage: result.hasNextPage ? ()=>$d6745f3b90212859$export$24be3d709330b09(autoCompleteUrl, query, issueId, fieldValueMap, page + 1) : undefined,
        total: result.total
    };
};

});

parcelRegister("79K7j", function(module, exports) {

$parcel$export(module.exports, "CmdbFieldError", () => $151fa476da8c9718$export$bd2288ff08a8a1d9);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $96IgR = parcelRequire("96IgR");

var $PdmhA = parcelRequire("PdmhA");

var $g6F7o = parcelRequire("g6F7o");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8PehF = parcelRequire("8PehF");

var $c6eA5 = parcelRequire("c6eA5");

var $aeCba = parcelRequire("aeCba");

var $gd0Sp = parcelRequire("gd0Sp");

var $lxLSP = parcelRequire("lxLSP");
const $151fa476da8c9718$var$UpgradeToPremiumLink = (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        href: (0, $c6eA5.getJsmChangeEditionUrl)(''),
        target: "_blank"
    }, chunks);
const $151fa476da8c9718$export$cf18a118761851fd = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($151fa476da8c9718$var$InlineMessageContentWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($151fa476da8c9718$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        label: "error",
        primaryColor: `var(--ds-icon-danger, ${(0, $PdmhA).R400})`
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, children));
const $151fa476da8c9718$export$eb21c278059498f8 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $lxLSP.default).errorInvalidFieldConfig));
};
const $151fa476da8c9718$export$22a4392f7c676bd6 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $lxLSP.default).errorInvalidFieldConfigDisabledCmdbAssets));
};
const $151fa476da8c9718$export$14493edb463e15ea = ({ fieldId: fieldId })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $lxLSP.default).errorInvalidFieldConfigAdmin)), fieldId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "servicedesk-cmdb-field-object-picker.ui.cmdb-field-error.button",
        appearance: "link",
        href: (0, $g6F7o.getConfigureCustomFieldUrl)(fieldId),
        target: "_blank"
    }, formatMessage((0, $lxLSP.default).errorInvalidFieldConfigAdminLink)));
};
const $151fa476da8c9718$export$3d5c9691c28d309d = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const notPremiumErrorAdmin = formatMessage((0, $lxLSP.default).errorInvalidFieldConfigDowngradedAdminCmdbAssets, {
        a: $151fa476da8c9718$var$UpgradeToPremiumLink
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "xsmall",
        as: "span"
    }, notPremiumErrorAdmin);
};
const $151fa476da8c9718$export$192152d4765eff13 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $lxLSP.default).errorUnknown));
};
const $151fa476da8c9718$export$bd2288ff08a8a1d9 = (props)=>{
    const tenantContext = (0, $gd0Sp.useTenantContext)();
    const hasPremium = (0, $aeCba.isPremiumInstance)(tenantContext);
    const isCmdbEnabled = (0, $8PehF.isCMDBEnabledInEnvironment)();
    const { isAdmin: isAdmin } = tenantContext;
    const errorBody = (0, $eUqFw.useMemo)(()=>{
        if (!isCmdbEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($151fa476da8c9718$export$22a4392f7c676bd6, null);
        if (hasPremium && !isAdmin) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($151fa476da8c9718$export$eb21c278059498f8, null);
        if (hasPremium && isAdmin) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($151fa476da8c9718$export$14493edb463e15ea, {
            fieldId: props.fieldId
        });
        if (!hasPremium && isAdmin) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($151fa476da8c9718$export$3d5c9691c28d309d, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($151fa476da8c9718$export$192152d4765eff13, null);
    }, [
        hasPremium,
        isAdmin,
        isCmdbEnabled,
        props.fieldId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($151fa476da8c9718$export$cf18a118761851fd, null, errorBody);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $151fa476da8c9718$var$IconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $151fa476da8c9718$var$InlineMessageContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _ep9tidpf _1oh2idpf _9r1zidpf _99ztidpf _f5gaidpf _1m2uidpf _hstcidpf _9n9oidpf _1vkjeo28",
            __cmplp.className
        ])
    });
});

});
parcelRegister("g6F7o", function(module, exports) {

$parcel$export(module.exports, "getAssociateFieldToScreensUrl", () => $643ced4d9666b9b4$export$23b03b7fae19e4d9);
$parcel$export(module.exports, "getScreenUrl", () => $643ced4d9666b9b4$export$f7bdae1f819aa43b);
$parcel$export(module.exports, "getTranslateCustomFieldUrl", () => $643ced4d9666b9b4$export$d190ce44f97f903);
$parcel$export(module.exports, "getConfigureCustomFieldUrl", () => $643ced4d9666b9b4$export$6e2455bbc376835a);
$parcel$export(module.exports, "getEditCustomFieldUrl", () => $643ced4d9666b9b4$export$16e5d0ee7be5b38f);
$parcel$export(module.exports, "getDeleteCustomFieldUrl", () => $643ced4d9666b9b4$export$45ccfea6f6fbf3cc);
$parcel$export(module.exports, "CUSTOM_FIELD_STATUSES", () => $643ced4d9666b9b4$export$cdc53e716471f6e5);
$parcel$export(module.exports, "defaultQuery", () => $643ced4d9666b9b4$export$c08de3b5cc335eeb);
$parcel$export(module.exports, "ITEMS_PER_PAGE", () => $643ced4d9666b9b4$export$ec93a669a20aa982);
$parcel$export(module.exports, "CUSTOM_FIELDS_TYPE", () => $643ced4d9666b9b4$export$49b8e5da9a1d0738);
$parcel$export(module.exports, "ATLASSIAN_TEAM_CF_TYPE", () => $643ced4d9666b9b4$export$d5f572ebd2c1f0d1);

var $19dfl = parcelRequire("19dfl");

const $643ced4d9666b9b4$export$23b03b7fae19e4d9 = (id)=>`/secure/admin/AssociateFieldToScreens!default.jspa?fieldId=${id}`;
const $643ced4d9666b9b4$export$f7bdae1f819aa43b = (screenId)=>`/secure/admin/ConfigureFieldScreen.jspa?id=${screenId}`;
const $643ced4d9666b9b4$export$d190ce44f97f903 = (id)=>`/secure/admin/TranslateCustomField!default.jspa?id=${(0, $19dfl.getTrimId)(id)}`;
const $643ced4d9666b9b4$export$6e2455bbc376835a = (id)=>`/secure/admin/ConfigureCustomField!default.jspa?customFieldId=${(0, $19dfl.getTrimId)(id)}`;
const $643ced4d9666b9b4$export$18cc37ac1ea4ff7e = (fieldId, contextId)=>`/secure/admin/EditCustomFieldDefaults!default.jspa?fieldConfigSchemeId=${contextId}&fieldConfigId=${contextId}&customFieldId=${(0, $19dfl.getTrimId)(fieldId)}`;
const $643ced4d9666b9b4$export$16e5d0ee7be5b38f = (id)=>`/secure/admin/EditCustomField!default.jspa?id=${(0, $19dfl.getTrimId)(id)}`;
const $643ced4d9666b9b4$export$45ccfea6f6fbf3cc = (id)=>`/secure/admin/DeleteCustomField!default.jspa?id=${(0, $19dfl.getTrimId)(id)}`;
const $643ced4d9666b9b4$export$cdc53e716471f6e5 = [
    (0, $588fdaaf3eff5391$export$2b35adb71b3f6143),
    (0, $588fdaaf3eff5391$export$f1ded5eab7e819b3)
];
const $643ced4d9666b9b4$export$c08de3b5cc335eeb = {
    searchFilter: undefined,
    customFieldStatus: (0, $588fdaaf3eff5391$export$2b35adb71b3f6143)
};
const $643ced4d9666b9b4$export$ec93a669a20aa982 = 15;
const $643ced4d9666b9b4$export$49b8e5da9a1d0738 = 'custom';
const $643ced4d9666b9b4$export$d5f572ebd2c1f0d1 = 'com.atlassian.jira.plugin.system.customfieldtypes:atlassian-team';

});
parcelRegister("19dfl", function(module, exports) {

$parcel$export(module.exports, "getTrimId", () => $7dbec85b2fc3973d$export$4817065c39922b39);
const $7dbec85b2fc3973d$export$4817065c39922b39 = (id)=>id.split('_').reverse()[0];

});

const $588fdaaf3eff5391$export$3c5e605ca7ade9f2 = 'NAME';
const $588fdaaf3eff5391$export$965630dc71fb3a05 = 'LAST_USED';
const $588fdaaf3eff5391$export$d5a7f00a6a604217 = 'SCREENS_AND_CONTEXTS';
const $588fdaaf3eff5391$export$44d67b522cbcce6d = 'PROJECTS';
const $588fdaaf3eff5391$export$421090ea46f71c9c = 'DELETED_ON';
const $588fdaaf3eff5391$export$a7cd2db90465ec68 = 'PERMANENTLY_DELETING';
const $588fdaaf3eff5391$export$2b35adb71b3f6143 = 'Active';
const $588fdaaf3eff5391$export$f1ded5eab7e819b3 = 'Trashed';


parcelRegister("c6eA5", function(module, exports) {

$parcel$export(module.exports, "projectSettingsPageUrl", () => $f41a4e01757ed78f$export$4b9f132c11a424d9);
$parcel$export(module.exports, "navigate", () => $f41a4e01757ed78f$export$ff7962acd6052c28);
$parcel$export(module.exports, "getAutomationUrl", () => $f41a4e01757ed78f$export$3dc1f6ab809332a6);
$parcel$export(module.exports, "getProjectUrl", () => $f41a4e01757ed78f$export$951b86b8e730b952);
$parcel$export(module.exports, "getRequestTypesUrl", () => $f41a4e01757ed78f$export$9d7c743b509e267);
$parcel$export(module.exports, "getChangeRequestTypesUrl", () => $f41a4e01757ed78f$export$6096ac65eb900914);
$parcel$export(module.exports, "getProjectSettingsUrl", () => $f41a4e01757ed78f$export$a497c8f8c3782075);
$parcel$export(module.exports, "getWorkflowSettingsUrl", () => $f41a4e01757ed78f$export$c2a8139910ee6c);
$parcel$export(module.exports, "getJsmChangeEditionUrl", () => $f41a4e01757ed78f$export$b87292f363462760);
$parcel$export(module.exports, "getChangeManagementSettingsUrl", () => $f41a4e01757ed78f$export$79f53a18784c22d3);
$parcel$export(module.exports, "getUserManagementUrl", () => $f41a4e01757ed78f$export$13f39b40814e5f3e);

var $3JafE = parcelRequire("3JafE");
parcelRequire("jyKN9");
parcelRequire("8jBvP");
parcelRequire("cpH8E");
parcelRequire("iects");
parcelRequire("1Lcr1");

var $7ZZxN = parcelRequire("7ZZxN");

var $cqJw8 = parcelRequire("cqJw8");

var $fKADw = parcelRequire("fKADw");

var $fT7HZ = parcelRequire("fT7HZ");
const $f41a4e01757ed78f$export$4b9f132c11a424d9 = (projectKey, relativeUrl)=>`/jira/servicedesk/projects/${projectKey}/settings/${relativeUrl}`;
const $f41a4e01757ed78f$export$ff7962acd6052c28 = (projectKey, fragment)=>(0, $3JafE.Observable).fromPromise((0, $fT7HZ.getPushStateNavigator)()).mergeMap((pushStateNavigator)=>{
        pushStateNavigator.navigateToFragment(fragment);
        return (0, $3JafE.Observable).empty();
    }).catch(()=>(0, $3JafE.Observable).of((0, $fKADw.navigate)($f41a4e01757ed78f$export$4b9f132c11a424d9(projectKey, fragment))));
const $f41a4e01757ed78f$var$getNextgenAutomationUrl = (projectKey)=>(0, $cqJw8.getNextgenSettingsJSDAutomationUrl)(projectKey);
const $f41a4e01757ed78f$export$3dc1f6ab809332a6 = (baseUrl, projectKey)=>$f41a4e01757ed78f$var$getNextgenAutomationUrl(projectKey);
const $f41a4e01757ed78f$export$951b86b8e730b952 = (baseUrl, projectKey)=>`/projects/${projectKey}`;
const $f41a4e01757ed78f$var$getNextgenIssueTypesUrl = (projectKey, issueTypeId)=>(0, $cqJw8.getNextgenSettingsIssueTypesUrl)((0, $7ZZxN.SERVICE_DESK_PROJECT), projectKey, issueTypeId);
const $f41a4e01757ed78f$export$9d7c743b509e267 = (baseUrl, projectKey, isSimplified = false)=>isSimplified ? $f41a4e01757ed78f$var$getNextgenIssueTypesUrl(projectKey) : `/jira/servicedesk/projects/${projectKey}/settings/request-types`;
const $f41a4e01757ed78f$export$6096ac65eb900914 = (baseUrl, projectKey, isSimplified = false)=>isSimplified ? $f41a4e01757ed78f$var$getNextgenIssueTypesUrl(projectKey) : `${$f41a4e01757ed78f$export$9d7c743b509e267(baseUrl, projectKey, isSimplified)}/category/changes`;
const $f41a4e01757ed78f$export$a497c8f8c3782075 = (baseUrl, projectKey, isSimplified = false)=>{
    const classicSettingsUrl = `/plugins/servlet/project-config/${projectKey}`;
    return isSimplified ? $f41a4e01757ed78f$var$getNextgenIssueTypesUrl(projectKey) : classicSettingsUrl;
};
const $f41a4e01757ed78f$export$c2a8139910ee6c = (baseUrl, projectKey, issueTypeId, isSimplified = false)=>{
    if (!issueTypeId) return isSimplified ? $f41a4e01757ed78f$var$getNextgenIssueTypesUrl(projectKey) : `/plugins/servlet/project-config/${projectKey}/workflows`;
    return isSimplified ? $f41a4e01757ed78f$var$getNextgenIssueTypesUrl(projectKey, issueTypeId) : `/plugins/servlet/project-config/${projectKey}/issuetypes/${issueTypeId}/workflow`;
};
const $f41a4e01757ed78f$export$b87292f363462760 = (baseUrl)=>`${baseUrl}/admin/billing/applications/change-edition/jira-servicedesk.ondemand`;
const $f41a4e01757ed78f$export$79f53a18784c22d3 = (baseUrl, projectKey)=>`${baseUrl}/jira/servicedesk/projects/${projectKey}/settings/change-management`;
const $f41a4e01757ed78f$export$13f39b40814e5f3e = ()=>'/admin/users?referrerName=JIRA';

});
parcelRegister("fKADw", function(module, exports) {

$parcel$export(module.exports, "NAVIGATE", () => $1cafefa097b184aa$export$73eaf8b5ccae9412);
$parcel$export(module.exports, "navigate", () => $1cafefa097b184aa$export$ff7962acd6052c28);
// NAVIGATE
const $1cafefa097b184aa$export$73eaf8b5ccae9412 = 'navigation.actions.NAVIGATE';
const $1cafefa097b184aa$export$ff7962acd6052c28 = (location)=>({
        type: $1cafefa097b184aa$export$73eaf8b5ccae9412,
        payload: {
            location: location
        }
    });

});

parcelRegister("fT7HZ", function(module, exports) {

$parcel$export(module.exports, "getPushStateNavigator", () => $62b68bdd3062a060$export$4bb04bbf2bef4c4b);

var $1MlrF = parcelRequire("1MlrF");
let $62b68bdd3062a060$var$navigatorPromise;
const $62b68bdd3062a060$export$4bb04bbf2bef4c4b = ()=>{
    if (!$62b68bdd3062a060$var$navigatorPromise) $62b68bdd3062a060$var$navigatorPromise = (0, $1MlrF.createPushStateNavigator)();
    return $62b68bdd3062a060$var$navigatorPromise;
};

});
parcelRegister("1MlrF", function(module, exports) {

$parcel$export(module.exports, "createPushStateNavigator", () => $7831c13a1ae73fca$export$d3bf579f8e5cd838);

var $eUqFw = parcelRequire("eUqFw");

var $2BvS3 = parcelRequire("2BvS3");
const $7831c13a1ae73fca$var$PUSH_STATE_NAVIGATOR_MODULE = 'servicedesk/internal-api/core/util/push-state-navigator/push-state-navigator';
// Try to require push-state-navigator over 500ms, otherwise we'll fallback.
const $7831c13a1ae73fca$var$REQUIRE_TIMEOUT = 100;
const $7831c13a1ae73fca$var$REQUIRE_RETRIES = 5;
const $7831c13a1ae73fca$export$d3bf579f8e5cd838 = ()=>// eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $2BvS3.loadBridge)({
        name: $7831c13a1ae73fca$var$PUSH_STATE_NAVIGATOR_MODULE,
        timeout: $7831c13a1ae73fca$var$REQUIRE_TIMEOUT,
        tentatives: $7831c13a1ae73fca$var$REQUIRE_RETRIES
    });
const $7831c13a1ae73fca$export$e1a0976aa2630905 = ()=>{
    const [pushStateNavigatorState, setPushStateNavigator] = (0, $eUqFw.useState)({
        data: null,
        loading: true,
        error: null
    });
    (0, $eUqFw.useEffect)(()=>{
        $7831c13a1ae73fca$export$d3bf579f8e5cd838().then((pushStateNavigator)=>{
            setPushStateNavigator({
                data: pushStateNavigator,
                loading: false,
                error: null
            });
        }).catch((error)=>{
            setPushStateNavigator({
                data: null,
                loading: false,
                error: error
            });
        });
    }, []);
    return pushStateNavigatorState;
};

});



parcelRegister("lxLSP", function(module, exports) {

$parcel$export(module.exports, "default", () => $94735774fd73df18$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $94735774fd73df18$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorInvalidFieldConfig: {
        "id": "servicedesk-cmdb-field-object-picker.cmdb-field-error.error-invalid-field-config",
        "defaultMessage": "This field needs to be configured with an object schema. Please contact your admin to configure this field."
    },
    errorInvalidFieldConfigAdmin: {
        "id": "servicedesk-cmdb-field-object-picker.cmdb-field-error.error-invalid-field-config-admin",
        "defaultMessage": "This field needs to be configured with an object schema."
    },
    errorInvalidFieldConfigAdminLink: {
        "id": "servicedesk-cmdb-field-object-picker.cmdb-field-error.error-invalid-field-config-admin-link",
        "defaultMessage": "Configure this custom field"
    },
    errorInvalidFieldConfigDowngradedAdminCmdbAssets: {
        "id": "servicedesk-cmdb-field-object-picker.cmdb-field-error.error-invalid-field-config-downgraded-admin-cmdb-assets",
        "defaultMessage": "Assets is not available in this Jira instance. <a>Upgrade to Premium</a> to re-enable Assets and see this data."
    },
    errorInvalidFieldConfigDisabledCmdbAssets: {
        "id": "servicedesk-cmdb-field-object-picker.cmdb-field-error.error-invalid-field-config-disabled-cmdb-assets",
        "defaultMessage": "Assets is not available in this Jira instance."
    },
    errorUnknown: {
        "id": "servicedesk-cmdb-field-object-picker.cmdb-field-error.error-unknown",
        "defaultMessage": "Something went wrong. Please refresh the page or contact your admin if the problem persists."
    }
});

});


parcelRegister("jc68F", function(module, exports) {

$parcel$export(module.exports, "CmdbSelectOption", () => $f24fac19ae67c497$export$a7be07965a3ed09b);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hoasw = parcelRequire("hoasw");
const $f24fac19ae67c497$export$fee117cd50d6234b = ({ match: match, children: children })=>{
    if (match === '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    // we need to escape special characters to avoid getting them interpreted in the RegExp group
    const escapedSpecialCharsInMatchQuery = match.replace(/[\\.,*+?^${}()|[\]]/g, '\\$&');
    const parts = children.split(new RegExp(`(${escapedSpecialCharsInMatchQuery})`, 'gi'));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, parts.map((part, i)=>{
        if (part.toLowerCase() === match.toLowerCase()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", {
            key: i
        }, part);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, {
            key: i
        }, part);
    }));
};
const $f24fac19ae67c497$export$cd0f2f750043f4bc = (attributes)=>attributes.map(({ objectAttributeValues: objectAttributeValues })=>objectAttributeValues.map(({ displayValue: displayValue })=>displayValue).join(', ')).join(' | ');
const $f24fac19ae67c497$export$a7be07965a3ed09b = ({ attributesToDisplayInSearch: attributesToDisplayInSearch, data: data, selectProps: selectProps, label: label })=>{
    // Casting to CmdbObject as typing gets lost when passed through AK Select
    const object = data.rawData;
    const { inputValue: inputValue } = selectProps;
    const displayedAttributes = (0, $eUqFw.useMemo)(()=>attributesToDisplayInSearch.map((attrName)=>attrName === 'Label' ? object.attributes.find((attr)=>attr.objectTypeAttribute.label) : object.attributes.find((attr)=>attr.objectTypeAttribute.name === attrName)).filter(Boolean), [
        object,
        attributesToDisplayInSearch
    ]);
    const primaryAttributeString = displayedAttributes?.[0]?.objectAttributeValues?.filter((v)=>v.displayValue) // eslint-disable-line @typescript-eslint/no-explicit-any
    .map((v)=>v.displayValue) // eslint-disable-line @typescript-eslint/no-explicit-any
    .join(', ') || label;
    const attributesString = $f24fac19ae67c497$export$cd0f2f750043f4bc(displayedAttributes.slice(1));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f24fac19ae67c497$var$Outer, {
        "data-testid": "servicedesk-cmdb-field-object-picker.ui.cmdb-select-option"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f24fac19ae67c497$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hoasw.MemoizedInsightIcon), {
        mediaClientConfig: object.avatar.mediaClientConfig,
        iconUrl: object.avatar.url48,
        label: object.label,
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f24fac19ae67c497$var$Content, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f24fac19ae67c497$var$ObjectName, {
        "data-testid": "servicedesk-cmdb-field-object-picker.ui.cmdb-select-option.object-name"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f24fac19ae67c497$export$fee117cd50d6234b, {
        match: inputValue ?? ''
    }, primaryAttributeString)), attributesString && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f24fac19ae67c497$var$Attributes, {
        "data-testid": "servicedesk-cmdb-field-object-picker.ui.cmdb-select-option.attributes"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f24fac19ae67c497$export$fee117cd50d6234b, {
        match: inputValue ?? ''
    }, attributesString))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f24fac19ae67c497$var$Outer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1yt41pyq _irr314ae",
            __cmplp.className
        ])
    });
});
const $f24fac19ae67c497$var$IconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxutpp _1o9zidpf",
            __cmplp.className
        ])
    });
});
const $f24fac19ae67c497$var$Content = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.className
        ])
    });
});
const $f24fac19ae67c497$var$ObjectName = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wybdlk8 _vwz41tcg",
            __cmplp.className
        ])
    });
});
const $f24fac19ae67c497$var$Attributes = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyb1crf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hoasw", function(module, exports) {

$parcel$export(module.exports, "InsightIcon", () => $92badab1baa94ec2$export$4f72cced31fa9b94);
$parcel$export(module.exports, "MemoizedInsightIcon", () => $92badab1baa94ec2$export$55641517b59933d7);
$parcel$export(module.exports, "UnstyledInsightIcon", () => $92badab1baa94ec2$export$30c7947f25987be2);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $eri7S = parcelRequire("eri7S");
var $iJlfe = parcelRequire("iJlfe");
var $aWAMO = parcelRequire("aWAMO");

var $bo9Jt = parcelRequire("bo9Jt");

var $guiFP = parcelRequire("guiFP");
const $92badab1baa94ec2$var$hasAuth = (// @ts-expect-error - TS2739 - Type '{}' is missing the following properties from type 'CmdbMediaClientConfig': mediaBaseUrl, mediaJwtToken, issuer, fileId, clientId
{ mediaBaseUrl: mediaBaseUrl, mediaJwtToken: mediaJwtToken, fileId: fileId, issuer: issuer } = {})=>Boolean(mediaBaseUrl) && Boolean(mediaJwtToken) && Boolean(issuer) && Boolean(fileId);
const $92badab1baa94ec2$var$DefaultIcon = ({ size: size, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        appearance: "square",
        size: size,
        name: label
    });
const $92badab1baa94ec2$export$4f72cced31fa9b94 = (props)=>{
    const { iconUrl: iconUrl, size: size, label: label, mediaClientConfig: mediaClientConfig } = props;
    const { fileId: fileId, mediaJwtToken: mediaJwtToken, issuer: issuer, mediaBaseUrl: mediaBaseUrl } = mediaClientConfig ?? {};
    if ($92badab1baa94ec2$var$hasAuth(mediaClientConfig) === false) {
        if (iconUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
            src: iconUrl,
            appearance: "square",
            size: size,
            name: label
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($92badab1baa94ec2$var$DefaultIcon, {
            size: size,
            label: label
        });
    }
    const fileIdentifier = {
        id: fileId
    };
    const imageSize = {
        width: (0, $eri7S.AVATAR_SIZES)[size],
        height: (0, $eri7S.AVATAR_SIZES)[size]
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo9Jt.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        identifier: fileIdentifier,
        mediaClientConfig: {
            authProvider: ()=>Promise.resolve({
                    asapIssuer: issuer || '',
                    token: mediaJwtToken || '',
                    baseUrl: mediaBaseUrl || ''
                })
        },
        apiConfig: imageSize
    }, ({ loading: loading, error: error, data: data })=>{
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aWAMO.default), {
            appearance: "square",
            size: size
        });
        if (error) {
            (0, $guiFP.default)({
                error: // @ts-expect-error - TS2322 - Type 'true' is not assignable to type 'Error | undefined'.
                error,
                meta: {
                    id: 'insightIcon',
                    packageName: 'jiraServicedeskInsightIcon',
                    teamName: 'falcons'
                }
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($92badab1baa94ec2$var$DefaultIcon, {
                size: size,
                label: label
            });
        }
        if (!data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($92badab1baa94ec2$var$DefaultIcon, {
            size: size,
            label: label
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
            src: data.src,
            appearance: "square",
            size: size,
            name: label
        });
    });
};
const $92badab1baa94ec2$export$55641517b59933d7 = /*#__PURE__*/ (0, $eUqFw.memo)($92badab1baa94ec2$export$4f72cced31fa9b94);
const $92badab1baa94ec2$export$30c7947f25987be2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($92badab1baa94ec2$var$UnstyledInsightIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($92badab1baa94ec2$export$55641517b59933d7, props));
/**
 * The reason for calling !important on display block is to ovveride the inherited
 * CSS from Avatar atlaskit component in order to centre the icon within the reference
 * object container.
 */ // Double check the shadow !
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $92badab1baa94ec2$var$UnstyledInsightIconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s81i6y _p7r1tcjq _1ugpglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aWAMO", function(module, exports) {

$parcel$export(module.exports, "default", () => $77d4bbf842392835$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $byn9U = parcelRequire("byn9U");

var $eri7S = parcelRequire("eri7S");
function $77d4bbf842392835$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $77d4bbf842392835$var$skeletonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-block',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: `var(${(0, $eri7S.CSS_VAR_AVATAR_BGCOLOR)})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    border: `${(0, $eri7S.BORDER_WIDTH)}px solid transparent`
});
const $77d4bbf842392835$var$sizeStyles = Object.entries((0, $eri7S.AVATAR_SIZES)).reduce((styles, [key, size])=>{
    return {
        ...styles,
        [key]: /*#__PURE__*/ (0, $byn9U.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${size}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${size}px`
        })
    };
}, {});
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $77d4bbf842392835$var$radiusStyles = Object.entries((0, $eri7S.AVATAR_RADIUS)).reduce((styles, [key, size])=>{
    return {
        ...styles,
        [key]: /*#__PURE__*/ (0, $byn9U.css)({
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderRadius: `${size}px`
        })
    };
}, {});
const $77d4bbf842392835$var$defaultRadiusStyles = {
    name: "1by8p7f",
    styles: "border-radius:var(--ds-border-radius-circle, 50%)"
};
const $77d4bbf842392835$var$strongOpacityStyles = {
    name: "19sqbed",
    styles: "opacity:0.3"
};
const $77d4bbf842392835$var$defaultOpacityStyles = {
    name: "1rz7oiv",
    styles: "opacity:0.15"
};
/**
 * __Skeleton__
 *
 * A skeleton is the loading state for the avatar component.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-skeleton/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-skeleton/code)
 */ const $77d4bbf842392835$var$Skeleton = ({ size: size, appearance: appearance, color: color, weight: weight })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $77d4bbf842392835$var$skeletonStyles,
            $77d4bbf842392835$var$sizeStyles[size ?? 'medium'],
            appearance === 'square' ? $77d4bbf842392835$var$radiusStyles[size ?? 'medium'] : $77d4bbf842392835$var$defaultRadiusStyles,
            weight === 'strong' ? $77d4bbf842392835$var$strongOpacityStyles : $77d4bbf842392835$var$defaultOpacityStyles
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $eri7S.CSS_VAR_AVATAR_BGCOLOR)]: color ?? 'currentColor'
        }
    });
var $77d4bbf842392835$export$2e2bcd8739ae039 = $77d4bbf842392835$var$Skeleton;

});

parcelRegister("bo9Jt", function(module, exports) {

$parcel$export(module.exports, "default", () => $5119868f92ca8f16$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6pr5B = parcelRequire("6pr5B");
class $5119868f92ca8f16$var$ErrorBoundary extends (0, $eUqFw.Component) {
    static getDerivedStateFromError(_) {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    componentDidCatch(error, errorInfo) {
    // TODO: handle error
    // console.error('Uncaught error:', error, errorInfo);
    }
    render() {
        if (this.state.hasError) return this.props.fallback;
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            hasError: false
        };
    }
}
const $5119868f92ca8f16$var$MediaImageWithErrorBoundary = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5119868f92ca8f16$var$ErrorBoundary, {
        fallback: props.children({
            loading: false,
            error: true
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6pr5B.default), props));
};
var $5119868f92ca8f16$export$2e2bcd8739ae039 = $5119868f92ca8f16$var$MediaImageWithErrorBoundary;

});
parcelRegister("6pr5B", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea3800f514cd0946$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $mtjJr = parcelRequire("mtjJr");

var $CCkTq = parcelRequire("CCkTq");
const $ea3800f514cd0946$var$MediaImageWithMediaClient = (props)=>{
    const Image = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useMemo(()=>{
        return (0, $mtjJr.withMediaClient)((0, $CCkTq.MediaImageBase));
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Image, props);
};
var $ea3800f514cd0946$export$2e2bcd8739ae039 = $ea3800f514cd0946$var$MediaImageWithMediaClient;

});
parcelRegister("mtjJr", function(module, exports) {

$parcel$export(module.exports, "withMediaClient", () => $9c77d1cdc83d45af$export$9f7977d4a2561bee);

var $eUqFw = parcelRequire("eUqFw");

var $kJ7yF = parcelRequire("kJ7yF");
const $9c77d1cdc83d45af$export$9f7977d4a2561bee = (Component)=>({ mediaClientConfig: mediaClientConfig, ...otherProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJ7yF.MediaClientContext).Consumer, null, (value)=>value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
                ...otherProps,
                mediaClient: value
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJ7yF.MediaClientProvider), {
                clientConfig: mediaClientConfig
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJ7yF.MediaClientContext).Consumer, null, (client)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
                    ...otherProps,
                    mediaClient: client
                }))));

});

parcelRegister("CCkTq", function(module, exports) {

$parcel$export(module.exports, "MediaImageBase", () => $5f0b8d2d211e7c97$export$f8df30549217a566);

var $1xvoH = parcelRequire("1xvoH");

var $eUqFw = parcelRequire("eUqFw");
const $5f0b8d2d211e7c97$export$f8df30549217a566 = ({ identifier: identifier, apiConfig: apiConfig = {}, children: children, ssr: ssr })=>{
    const { width: width, height: height, mode: mode, allowAnimated: allowAnimated, upscale: upscale, 'max-age': maxAge } = apiConfig;
    const dimensions = {
        width: width,
        height: height
    };
    const { preview: preview, error: error, getSsrScriptProps: getSsrScriptProps } = (0, $1xvoH.useFilePreview)({
        identifier: identifier,
        dimensions: dimensions,
        ssr: ssr,
        resizeMode: mode,
        allowAnimated: allowAnimated,
        upscale: upscale,
        maxAge: maxAge
    });
    //----------------------------------------------------------------
    // RENDER
    //----------------------------------------------------------------
    let status = 'loading';
    if (preview?.dataURI) status = 'succeeded';
    else if (error) status = 'error';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children({
        loading: status === 'loading',
        error: status === 'error',
        data: status === 'succeeded' ? {
            status: status,
            src: preview?.dataURI
        } : undefined
    }), getSsrScriptProps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("script", getSsrScriptProps()));
};

});
parcelRegister("1xvoH", function(module, exports) {

$parcel$export(module.exports, "useFilePreview", () => $86ba7cfc6df4e172$export$4eaebdef02112fe4);

var $eUqFw = parcelRequire("eUqFw");

var $9x67R = parcelRequire("9x67R");

var $RBcRl = parcelRequire("RBcRl");
var $kJ7yF = parcelRequire("kJ7yF");

var $br8gy = parcelRequire("br8gy");

var $iP4HA = parcelRequire("iP4HA");

var $kj8oZ = parcelRequire("kj8oZ");

var $jvF4x = parcelRequire("jvF4x");
var $1eI0l = parcelRequire("1eI0l");
var $jyk7o = parcelRequire("jyk7o");

var $862c0 = parcelRequire("862c0");
var $6tTCR = parcelRequire("6tTCR");

var $2GnF5 = parcelRequire("2GnF5");
const $86ba7cfc6df4e172$export$4eaebdef02112fe4 = ({ resizeMode: resizeMode = 'crop', identifier: identifier, ssr: ssr, dimensions: dimensions, traceContext: traceContext, skipRemote: skipRemote, mediaBlobUrlAttrs: mediaBlobUrlAttrs, allowAnimated: allowAnimated = true, upscale: upscale, maxAge: maxAge })=>{
    const mediaClient = (0, $kJ7yF.useMediaClient)();
    const [status, setStatus] = (0, $eUqFw.useState)('loading');
    const [error, setError] = (0, $eUqFw.useState)();
    const [nonCriticalError, setNonCriticalError] = (0, $eUqFw.useState)();
    const [isBannedLocalPreview, setIsBannedLocalPreview] = (0, $eUqFw.useState)(false);
    const [upfrontPreviewStatus, setUpfrontPreviewStatus] = (0, $eUqFw.useState)('not-resolved');
    const ssrReliabilityRef = (0, $eUqFw.useRef)({
        server: {
            status: 'unknown'
        },
        client: {
            status: 'unknown'
        }
    });
    const requestDimensions = (0, $eUqFw.useMemo)(()=>dimensions ? (0, $2GnF5.createRequestDimensions)(dimensions) : undefined, [
        dimensions
    ]);
    const requestDimensionsRef = (0, $2GnF5.useCurrentValueRef)(requestDimensions);
    const imageURLParams = {
        collection: identifier.collectionName,
        mode: resizeMode,
        ...requestDimensions,
        allowAnimated: allowAnimated,
        upscale: upscale,
        'max-age': maxAge
    };
    const previewInitializer = ()=>{
        const preview = (0, $jyk7o.mediaFilePreviewCache).get(identifier.id, resizeMode);
        if (preview) return preview;
        if (ssr) {
            const ssrData = (0, $6tTCR.getSSRData)(identifier);
            if (ssrData?.error) ssrReliabilityRef.current.server = {
                status: 'fail',
                ...ssrData.error
            };
            if (!ssrData?.dataURI) try {
                return (0, $jvF4x.getSSRPreview)(ssr, mediaClient, identifier.id, imageURLParams, mediaBlobUrlAttrs);
            } catch (e) {
                ssrReliabilityRef.current[ssr] = {
                    status: 'fail',
                    ...(0, $iP4HA.extractErrorInfo)(e, traceContext)
                };
            }
            else {
                const { dimensions: dimensions, dataURI: dataURI } = ssrData;
                return {
                    dataURI: dataURI,
                    dimensions: dimensions,
                    source: 'ssr-data'
                };
            }
        }
    };
    const [preview, setPreview] = (0, $eUqFw.useState)(previewInitializer);
    //----------------------------------------------------------------
    // FILE STATE
    //----------------------------------------------------------------
    const { fileState: fileState } = (0, $RBcRl.useFileState)(identifier.id, {
        skipRemote: skipRemote,
        collectionName: identifier.collectionName,
        occurrenceKey: identifier.occurrenceKey
    });
    // Derived from File State
    const fileStatus = fileState?.status;
    const isBackendPreviewReady = !!fileState && (0, $9x67R.isImageRepresentationReady)(fileState);
    const fileStateErrorMessage = fileState?.status === 'error' ? fileState.message : undefined;
    const { preview: localBinary, mediaType: mediaType, mimeType: mimeType } = fileState && fileState?.status !== 'error' ? fileState : {};
    //----------------------------------------------------------------
    // Update status
    //----------------------------------------------------------------
    // TOOD: make a full hook reset (remount) on New identifier or client
    (0, $eUqFw.useEffect)(()=>{
        setStatus('loading');
    }, [
        identifier
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (status !== 'error') {
            if (preview || fileStatus === 'processed' && !isBackendPreviewReady) setStatus('complete');
            else if (!preview && fileStatus === 'failed-processing' && !isBackendPreviewReady) {
                setStatus('error');
                setError(new (0, $kj8oZ.MediaFilePreviewError)('failed-processing'));
            } else if (!preview && fileStatus === 'error' && upfrontPreviewStatus === 'resolved') {
                setStatus('error');
                setError(new (0, $kj8oZ.MediaFilePreviewError)('metadata-fetch', new Error(fileStateErrorMessage)));
            } else setStatus('loading');
        }
    }, [
        preview,
        status,
        fileStatus,
        isBackendPreviewReady,
        fileStateErrorMessage,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Preview Fetch Helper
    //----------------------------------------------------------------
    const getAndCacheRemotePreviewRef = (0, $2GnF5.useCurrentValueRef)(()=>{
        return (0, $jvF4x.getAndCacheRemotePreview)(mediaClient, identifier.id, requestDimensions || {}, imageURLParams, mediaBlobUrlAttrs, traceContext);
    });
    //----------------------------------------------------------------
    // Upfront Preview
    //----------------------------------------------------------------
    (0, $eUqFw.useEffect)(()=>{
        // Only fetch upfront (no file state) if there is no preview in the state already
        if (preview) setUpfrontPreviewStatus('resolved');
        else if (!preview && upfrontPreviewStatus === 'not-resolved' && !skipRemote) {
            // We block any possible future call to this method regardless of the outcome (success or fail)
            // If it fails, the normal preview fetch should occur after the file state is fetched anyways
            setUpfrontPreviewStatus('resolving');
            const fetchedDimensions = {
                ...requestDimensions
            };
            getAndCacheRemotePreviewRef.current().then((newPreview)=>{
                // If there are new and bigger dimensions in the props, and the upfront preview is still resolving,
                // the fetched preview is no longer valid, and thus, we dismiss it
                if (!(0, $2GnF5.isBigger)(fetchedDimensions, requestDimensionsRef.current)) setPreview(newPreview);
            }).catch(()=>{
            // NO need to log error. If this call fails, a refetch will happen after
            }).finally(()=>{
                setUpfrontPreviewStatus('resolved');
            });
        }
    }, [
        getAndCacheRemotePreviewRef,
        preview,
        requestDimensions,
        requestDimensionsRef,
        skipRemote,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Cache, Local & Remote Preview
    //----------------------------------------------------------------
    (0, $eUqFw.useEffect)(()=>{
        const cachedPreview = (0, $jyk7o.mediaFilePreviewCache).get(identifier.id, resizeMode);
        // Cached Preview ----------------------------------------------------------------
        if (!preview && cachedPreview && !(0, $2GnF5.isBigger)(cachedPreview?.dimensions, requestDimensions)) setPreview(cachedPreview);
        else if (!preview && !isBannedLocalPreview && localBinary && (0, $1eI0l.isSupportedLocalPreview)(mediaType) && (0, $br8gy.isMimeTypeSupportedByBrowser)(mimeType || '')) // Local preview is available only if it's supported by browser and supported by Media Card (isSupportedLocalPreview)
        // For example, SVGs are mime type NOT supported by browser but media type supported by Media Card (image)
        // Then, local Preview NOT available
        (0, $jvF4x.getAndCacheLocalPreview)(identifier.id, localBinary, requestDimensions || {}, resizeMode, mediaBlobUrlAttrs).then(setPreview).catch((e)=>{
            setIsBannedLocalPreview(true);
            // CXP-2723 TODO: We might have to wrap this error in MediaCardError
            setNonCriticalError(e);
        });
        else if (!error && !nonCriticalError && (!preview || (0, $2GnF5.isBigger)(preview.dimensions, requestDimensions) || // We always refetch SSR preview to be able to browser-cache a version without the token in the query parameters
        (0, $jvF4x.isSSRPreview)(preview)) && !skipRemote && upfrontPreviewStatus !== 'not-resolved' && isBackendPreviewReady) getAndCacheRemotePreviewRef.current().then(setPreview).catch((e)=>{
            const wrappedError = (0, $kj8oZ.ensureMediaFilePreviewError)('preview-fetch', e);
            if (!preview) {
                setStatus('error');
                setError(wrappedError);
            } else // If there is already a preview, we consider it a non-critical error
            setNonCriticalError(wrappedError);
        });
    }, [
        error,
        nonCriticalError,
        getAndCacheRemotePreviewRef,
        identifier.id,
        resizeMode,
        isBannedLocalPreview,
        mediaBlobUrlAttrs,
        preview,
        requestDimensions,
        skipRemote,
        isBackendPreviewReady,
        localBinary,
        mediaType,
        mimeType,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // RETURN
    //----------------------------------------------------------------
    const onImageError = (0, $eUqFw.useCallback)((failedPreview)=>{
        if (!failedPreview) return;
        if ((0, $jvF4x.isSSRClientPreview)(failedPreview)) ssrReliabilityRef.current.client = (0, $iP4HA.createFailedSSRObject)(failedPreview, traceContext);
        // If the preview failed and it comes from server (global scope / ssrData), it means that we have reused it in client and the error counts for both: server & client.
        if ((0, $jvF4x.isSSRDataPreview)(failedPreview)) {
            ssrReliabilityRef.current.server = (0, $iP4HA.createFailedSSRObject)(failedPreview, traceContext);
            ssrReliabilityRef.current.client = (0, $iP4HA.createFailedSSRObject)(failedPreview, traceContext);
        }
        // If the dataURI has been replaced, we can dismiss this error
        if (failedPreview.dataURI !== preview?.dataURI) return;
        const isLocal = (0, $jvF4x.isLocalPreview)(failedPreview);
        const isRemote = (0, $jvF4x.isRemotePreview)(failedPreview);
        if (isLocal || isRemote) {
            const error = new (0, $kj8oZ.ImageLoadError)(failedPreview?.source);
            (0, $jyk7o.mediaFilePreviewCache).remove(identifier.id, resizeMode);
            if (isLocal) setIsBannedLocalPreview(true);
            if (isRemote) {
                setStatus('error');
                setError(error);
            }
            setPreview(undefined);
        }
    }, [
        identifier.id,
        preview?.dataURI,
        resizeMode,
        traceContext
    ]);
    const onImageLoad = (0, $eUqFw.useCallback)((newPreview)=>{
        if (newPreview) {
            if ((0, $jvF4x.isSSRClientPreview)(newPreview) && ssrReliabilityRef.current.client.status === 'unknown') ssrReliabilityRef.current.client = {
                status: 'success'
            };
            /*
        If the image loads successfully and it comes from server (global scope / ssrData), it means that we have reused it in client and the success counts for both: server & client.
      */ if ((0, $jvF4x.isSSRDataPreview)(newPreview) && ssrReliabilityRef.current.server.status === 'unknown') {
                ssrReliabilityRef.current.server = {
                    status: 'success'
                };
                ssrReliabilityRef.current.client = {
                    status: 'success'
                };
            }
        }
        // If the dataURI has been replaced, we can dismiss this callback
        if (newPreview?.dataURI !== preview?.dataURI) return;
    }, [
        preview?.dataURI
    ]);
    // FOR SSR
    const getSsrScriptProps = ssr === 'server' ? ()=>(0, $862c0.generateScriptProps)(identifier, preview?.dataURI, requestDimensions, ssrReliabilityRef.current.server?.status === 'fail' ? ssrReliabilityRef.current.server : undefined) : undefined;
    // CXP-2723 TODO: should consider simplifying our analytics, and how
    // we might get rid of ssrReliabiltyRef from our hook
    return {
        preview: preview,
        status: status,
        error: error,
        nonCriticalError: nonCriticalError,
        ssrReliability: ssrReliabilityRef.current,
        onImageError: onImageError,
        onImageLoad: onImageLoad,
        getSsrScriptProps: getSsrScriptProps
    };
};

});
parcelRegister("RBcRl", function(module, exports) {

$parcel$export(module.exports, "useFileState", () => $d6b826f28e3bf18f$export$90ff537b0999afb);

var $eUqFw = parcelRequire("eUqFw");

var $kJ7yF = parcelRequire("kJ7yF");

var $eC7jK = parcelRequire("eC7jK");
function $d6b826f28e3bf18f$export$90ff537b0999afb(id, options = {}) {
    const { collectionName: collectionName, occurrenceKey: occurrenceKey, skipRemote: skipRemote = false } = options;
    const mediaClient = (0, $kJ7yF.useMediaClient)();
    const fileState = (0, $eC7jK.useMediaStore)((state)=>state.files[id]);
    (0, $eUqFw.useEffect)(()=>{
        // No need to resubscribe if there is a fileState already
        if (!fileState && !skipRemote) mediaClient.file.getFileState(id, {
            collectionName: collectionName,
            occurrenceKey: occurrenceKey
        });
    }, [
        id,
        mediaClient,
        collectionName,
        occurrenceKey,
        skipRemote,
        fileState
    ]);
    return {
        fileState: fileState
    };
}

});
parcelRegister("eC7jK", function(module, exports) {

$parcel$export(module.exports, "useMediaStore", () => $7ebccbb6e4a1c8db$export$8a9cc8c330400af8);

var $k4N4B = parcelRequire("k4N4B");

var $kJ7yF = parcelRequire("kJ7yF");
const $7ebccbb6e4a1c8db$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $k4N4B.useStore)(store, selector, equals);
function $7ebccbb6e4a1c8db$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $kJ7yF.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $7ebccbb6e4a1c8db$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}

});
parcelRegister("k4N4B", function(module, exports) {

$parcel$export(module.exports, "useStore", () => $0605707b4ba00383$export$6ccbb43953eebf8);

var $gQVOz = parcelRequire("gQVOz");

var $eUqFw = parcelRequire("eUqFw");

var $awFmn = parcelRequire("awFmn");
var $0605707b4ba00383$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $0605707b4ba00383$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw)));
const { useSyncExternalStoreWithSelector: $0605707b4ba00383$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($awFmn)));
let $0605707b4ba00383$var$didWarnAboutEqualityFn = false;
const $0605707b4ba00383$var$identity = (arg)=>arg;
function $0605707b4ba00383$export$6ccbb43953eebf8(api, selector = $0605707b4ba00383$var$identity, equalityFn) {
    if (($0605707b4ba00383$import_meta.env ? $0605707b4ba00383$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$0605707b4ba00383$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $0605707b4ba00383$var$didWarnAboutEqualityFn = true;
    }
    const slice = $0605707b4ba00383$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $0605707b4ba00383$var$useDebugValue(slice);
    return slice;
}
const $0605707b4ba00383$var$createImpl = (createState)=>{
    if (($0605707b4ba00383$import_meta.env ? $0605707b4ba00383$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $gQVOz.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$0605707b4ba00383$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $0605707b4ba00383$export$185802fd694ee1f5 = (createState)=>createState ? $0605707b4ba00383$var$createImpl(createState) : $0605707b4ba00383$var$createImpl;
var $0605707b4ba00383$export$2e2bcd8739ae039 = (createState)=>{
    if (($0605707b4ba00383$import_meta.env ? $0605707b4ba00383$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $0605707b4ba00383$export$185802fd694ee1f5(createState);
};

});



parcelRegister("iP4HA", function(module, exports) {

$parcel$export(module.exports, "extractErrorInfo", () => $9e13c15b19442f5f$export$74aaf4784c2edb2c);
$parcel$export(module.exports, "createFailedSSRObject", () => $9e13c15b19442f5f$export$768c370ed0dbaeb3);

var $eKK8L = parcelRequire("eKK8L");
var $7aQon = parcelRequire("7aQon");

var $kj8oZ = parcelRequire("kj8oZ");
const $9e13c15b19442f5f$export$29aa614726672b2e = (error)=>{
    if ((0, $kj8oZ.isMediaFilePreviewError)(error) && !!error.secondaryError) {
        if ((0, $7aQon.isRequestError)(error.secondaryError)) return error.secondaryError.metadata?.traceContext;
        else if ((0, $kj8oZ.isMediaFileStateError)(error.secondaryError)) return error.secondaryError.details?.metadata?.traceContext;
    }
};
const $9e13c15b19442f5f$export$4af9d71992e89714 = (error)=>{
    if ((0, $kj8oZ.isMediaFilePreviewError)(error)) return error.primaryReason;
    else return 'nativeError';
};
const $9e13c15b19442f5f$export$88c61dcad53762da = (error)=>{
    if ((0, $kj8oZ.isMediaFilePreviewError)(error) && error.secondaryError) {
        const mediaClientReason = (0, $kj8oZ.isMediaFileStateError)(error.secondaryError) ? (0, $kj8oZ.getFileStateErrorReason)(error.secondaryError) : (0, $eKK8L.getMediaClientErrorReason)(error.secondaryError);
        if (mediaClientReason !== 'unknown') return mediaClientReason;
    }
    return 'nativeError';
};
const $9e13c15b19442f5f$export$9ccc5365d056da4b = (error)=>{
    if ((0, $kj8oZ.isMediaFilePreviewError)(error) && error.secondaryError) return error.secondaryError.message;
    else return error.message;
};
const $9e13c15b19442f5f$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: $9e13c15b19442f5f$export$4af9d71992e89714(error),
        error: $9e13c15b19442f5f$export$88c61dcad53762da(error),
        errorDetail: $9e13c15b19442f5f$export$9ccc5365d056da4b(error),
        metadataTraceContext: metadataTraceContext ?? $9e13c15b19442f5f$export$29aa614726672b2e(error)
    };
};
const $9e13c15b19442f5f$export$768c370ed0dbaeb3 = (preview, metadataTraceContext)=>({
        status: 'fail',
        ...$9e13c15b19442f5f$export$74aaf4784c2edb2c(new (0, $kj8oZ.ImageLoadError)(preview.source), metadataTraceContext)
    });

});
parcelRegister("kj8oZ", function(module, exports) {

$parcel$export(module.exports, "MediaFilePreviewError", () => $ee0c6ebccdf3d6b2$export$96e559194c287cf4);
$parcel$export(module.exports, "LocalPreviewError", () => $ee0c6ebccdf3d6b2$export$2c035820a31723e);
$parcel$export(module.exports, "RemotePreviewError", () => $ee0c6ebccdf3d6b2$export$10ab445310d30114);
$parcel$export(module.exports, "SsrPreviewError", () => $ee0c6ebccdf3d6b2$export$18e89b7e50818288);
$parcel$export(module.exports, "ImageLoadError", () => $ee0c6ebccdf3d6b2$export$d0a45ab59b4606b);
$parcel$export(module.exports, "isMediaFilePreviewError", () => $ee0c6ebccdf3d6b2$export$553696a6e769784c);
$parcel$export(module.exports, "ensureMediaFilePreviewError", () => $ee0c6ebccdf3d6b2$export$7156ce7b78b49bd7);
$parcel$export(module.exports, "isMediaFileStateError", () => $ee0c6ebccdf3d6b2$export$166a250c03366459);
$parcel$export(module.exports, "getFileStateErrorReason", () => $ee0c6ebccdf3d6b2$export$2e87e6d20b09376d);

var $gqduQ = parcelRequire("gqduQ");
class $ee0c6ebccdf3d6b2$export$96e559194c287cf4 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason);
        this.primaryReason = primaryReason;
        this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $ee0c6ebccdf3d6b2$export$2c035820a31723e extends $ee0c6ebccdf3d6b2$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError);
        this.primaryReason = primaryReason;
        this.secondaryError = secondaryError;
    }
}
class $ee0c6ebccdf3d6b2$export$10ab445310d30114 extends $ee0c6ebccdf3d6b2$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError);
        this.primaryReason = primaryReason;
        this.secondaryError = secondaryError;
    }
}
class $ee0c6ebccdf3d6b2$export$18e89b7e50818288 extends $ee0c6ebccdf3d6b2$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError);
        this.primaryReason = primaryReason;
        this.secondaryError = secondaryError;
    }
}
const $ee0c6ebccdf3d6b2$var$getImageLoadPrimaryReason = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        case 'ssr-client':
            return 'ssr-client-uri';
        case 'ssr-server':
        case 'ssr-data':
            return 'ssr-server-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $ee0c6ebccdf3d6b2$export$d0a45ab59b4606b extends $ee0c6ebccdf3d6b2$export$96e559194c287cf4 {
    constructor(source){
        super($ee0c6ebccdf3d6b2$var$getImageLoadPrimaryReason(source));
    }
}
function $ee0c6ebccdf3d6b2$export$553696a6e769784c(err) {
    return err instanceof $ee0c6ebccdf3d6b2$export$96e559194c287cf4;
}
const $ee0c6ebccdf3d6b2$export$b380593ba3516c6f = (err)=>err instanceof $ee0c6ebccdf3d6b2$export$2c035820a31723e;
const $ee0c6ebccdf3d6b2$export$e1d87830b3784f94 = (err)=>err instanceof $ee0c6ebccdf3d6b2$export$10ab445310d30114;
const $ee0c6ebccdf3d6b2$export$443aeb298d35d79d = (err)=>$ee0c6ebccdf3d6b2$export$553696a6e769784c(err) && err.primaryReason === 'local-preview-unsupported';
const $ee0c6ebccdf3d6b2$export$7156ce7b78b49bd7 = (primaryReason, error, updatePrimaryReason)=>{
    if ($ee0c6ebccdf3d6b2$export$553696a6e769784c(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new $ee0c6ebccdf3d6b2$export$96e559194c287cf4(primaryReason, error.secondaryError);
        return error;
    }
    return new $ee0c6ebccdf3d6b2$export$96e559194c287cf4(primaryReason, error);
};
function $ee0c6ebccdf3d6b2$export$166a250c03366459(err) {
    return err instanceof (0, $gqduQ.MediaFileStateError);
}
function $ee0c6ebccdf3d6b2$export$2e87e6d20b09376d(err) {
    return err.details?.reason ?? 'unknown';
}

});
parcelRegister("gqduQ", function(module, exports) {

$parcel$export(module.exports, "MediaFileStateError", () => $bbb89c3abac14beb$export$38242da09b559a);
class $bbb89c3abac14beb$export$38242da09b559a extends Error {
    constructor(id, reason, message = '', details){
        super(reason);
        this.id = id;
        this.reason = reason;
        this.message = message;
        this.details = details;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}

});



parcelRegister("jvF4x", function(module, exports) {

$parcel$export(module.exports, "getSSRPreview", () => $50ac7c582533743d$export$faf1c301c59a1bdc);
$parcel$export(module.exports, "isLocalPreview", () => $50ac7c582533743d$export$78ad02c5efc361c9);
$parcel$export(module.exports, "isRemotePreview", () => $50ac7c582533743d$export$87442a14a8a19e0);
$parcel$export(module.exports, "isSSRClientPreview", () => $50ac7c582533743d$export$36aae1afbc0a9661);
$parcel$export(module.exports, "isSSRDataPreview", () => $50ac7c582533743d$export$f366c2c8a792cce6);
$parcel$export(module.exports, "isSSRPreview", () => $50ac7c582533743d$export$dea79d05143ccf4);
$parcel$export(module.exports, "getAndCacheRemotePreview", () => $50ac7c582533743d$export$49721bcc26fb9388);
$parcel$export(module.exports, "getAndCacheLocalPreview", () => $50ac7c582533743d$export$98e935d981c884d);

var $1p7md = parcelRequire("1p7md");

var $kj8oZ = parcelRequire("kj8oZ");

var $jyk7o = parcelRequire("jyk7o");

var $1eI0l = parcelRequire("1eI0l");
const $50ac7c582533743d$var$extendAndCachePreview = (id, mode, preview, mediaBlobUrlAttrs)=>{
    let source;
    switch(preview.source){
        case 'local':
            source = 'cache-local';
            break;
        case 'remote':
            source = 'cache-remote';
            break;
        default:
            source = preview.source;
    }
    // We want to embed some meta context into dataURI for Copy/Paste to work.
    const dataURI = mediaBlobUrlAttrs ? (0, $1p7md.addFileAttrsToUrl)(preview.dataURI, mediaBlobUrlAttrs) : preview.dataURI;
    // We store new cardPreview into cache
    (0, $jyk7o.mediaFilePreviewCache).set(id, mode, {
        ...preview,
        source: source,
        dataURI: dataURI
    });
    return {
        ...preview,
        dataURI: dataURI
    };
};
const $50ac7c582533743d$export$faf1c301c59a1bdc = (ssr, mediaClient, id, params, mediaBlobUrlAttrs)=>{
    let dataURI;
    try {
        const rawDataURI = mediaClient.getImageUrlSync(id, params);
        // We want to embed some meta context into dataURI for Copy/Paste to work.
        dataURI = mediaBlobUrlAttrs ? (0, $1p7md.addFileAttrsToUrl)(rawDataURI, mediaBlobUrlAttrs) : rawDataURI;
        const source = ssr === 'client' ? 'ssr-client' : 'ssr-server';
        return {
            dataURI: dataURI,
            source: source,
            orientation: 1
        };
    } catch (e) {
        const reason = ssr === 'server' ? 'ssr-server-uri' : 'ssr-client-uri';
        throw new (0, $kj8oZ.SsrPreviewError)(reason, e instanceof Error ? e : undefined);
    }
};
const $50ac7c582533743d$export$78ad02c5efc361c9 = (preview)=>{
    const localSources = [
        'local',
        'cache-local'
    ];
    return localSources.includes(preview.source);
};
const $50ac7c582533743d$export$87442a14a8a19e0 = (preview)=>{
    const remoteSources = [
        'remote',
        'cache-remote'
    ];
    return remoteSources.includes(preview.source);
};
const $50ac7c582533743d$export$36aae1afbc0a9661 = (preview)=>preview.source === 'ssr-client';
const $50ac7c582533743d$export$f366c2c8a792cce6 = (preview)=>preview.source === 'ssr-data';
const $50ac7c582533743d$export$dea79d05143ccf4 = (preview)=>{
    const ssrClientSources = [
        'ssr-client',
        'ssr-server',
        'ssr-data'
    ];
    return ssrClientSources.includes(preview.source);
};
const $50ac7c582533743d$export$49721bcc26fb9388 = async (mediaClient, id, dimensions, params, mediaBlobUrlAttrs, traceContext)=>{
    const remotePreview = await (0, $1eI0l.getRemotePreview)(mediaClient, id, params, traceContext);
    return $50ac7c582533743d$var$extendAndCachePreview(id, params.mode, {
        ...remotePreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};
const $50ac7c582533743d$export$98e935d981c884d = async (id, filePreview, dimensions, mode, mediaBlobUrlAttrs)=>{
    const localPreview = await (0, $1eI0l.getLocalPreview)(filePreview);
    return $50ac7c582533743d$var$extendAndCachePreview(id, mode, {
        ...localPreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};

});
parcelRegister("1p7md", function(module, exports) {

$parcel$export(module.exports, "isMediaBlobUrl", () => $8948517ceba57403$export$e1e8ad57ada2d90);
$parcel$export(module.exports, "getAttrsFromUrl", () => $8948517ceba57403$export$b91a9e94ff0cbb29);
$parcel$export(module.exports, "addFileAttrsToUrl", () => $8948517ceba57403$export$e51a8146182600b8);
const $8948517ceba57403$var$mediaBlobUrlIdentifier = 'media-blob-url';
const $8948517ceba57403$export$e1e8ad57ada2d90 = (url)=>{
    return url.indexOf(`${$8948517ceba57403$var$mediaBlobUrlIdentifier}=true`) > -1;
};
const $8948517ceba57403$var$getNumberFromParams = (params, name)=>{
    const value = params.get(name);
    return typeof value === 'string' && !isNaN(parseInt(value)) ? parseInt(value) : undefined;
};
const $8948517ceba57403$var$getStringFromParams = (params, name)=>{
    const value = params.get(name);
    if (!value) return;
    return decodeURIComponent(value);
};
const $8948517ceba57403$export$b91a9e94ff0cbb29 = (blobUrl)=>{
    const url = new URL(blobUrl);
    const hash = url.hash.replace('#', '');
    const params = new URLSearchParams(hash);
    const id = params.get('id');
    const contextId = params.get('contextId');
    // check if we have the required params
    if (!id || !contextId) return;
    return {
        id: id,
        contextId: contextId,
        collection: $8948517ceba57403$var$getStringFromParams(params, 'collection'),
        alt: $8948517ceba57403$var$getStringFromParams(params, 'alt'),
        height: $8948517ceba57403$var$getNumberFromParams(params, 'height'),
        width: $8948517ceba57403$var$getNumberFromParams(params, 'width'),
        size: $8948517ceba57403$var$getNumberFromParams(params, 'size'),
        name: $8948517ceba57403$var$getStringFromParams(params, 'name'),
        mimeType: $8948517ceba57403$var$getStringFromParams(params, 'mimeType')
    };
};
const $8948517ceba57403$export$89a7e74069fbb7af = (json)=>{
    return Object.keys(json).filter((attrName)=>typeof json[attrName] !== 'undefined' && json[attrName] !== null).map((key)=>{
        const value = json[key];
        if (typeof value === 'undefined' || value === null) return;
        return `${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`;
    }).join('&');
};
const $8948517ceba57403$export$e51a8146182600b8 = (url, fileAttrs)=>{
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) return url;
    const mediaIdentifierAttr = {
        [$8948517ceba57403$var$mediaBlobUrlIdentifier]: 'true'
    };
    const mergedAttrs = {
        ...mediaIdentifierAttr,
        ...fileAttrs
    };
    const queryAttrs = $8948517ceba57403$export$89a7e74069fbb7af(mergedAttrs);
    // we can't use '?' separator for blob url params
    return `${url}#${queryAttrs}`;
};

});

parcelRegister("jyk7o", function(module, exports) {

$parcel$export(module.exports, "mediaFilePreviewCache", () => $a222999f2a3917ca$export$b7e8ee3f7a41459);

var $fxEZn = parcelRequire("fxEZn");
const $a222999f2a3917ca$export$611736262b635f8d = (id, mode)=>{
    const resizeMode = mode || 'crop';
    return [
        id,
        resizeMode
    ].join('-');
};
class $a222999f2a3917ca$export$7b50526c091bb915 {
    constructor(previewCache){
        this.previewCache = previewCache;
        this.get = (id, mode)=>{
            const cacheKey = $a222999f2a3917ca$export$611736262b635f8d(id, mode);
            return this.previewCache.get(cacheKey);
        };
        this.set = (id, mode, cardPreview)=>{
            const cacheKey = $a222999f2a3917ca$export$611736262b635f8d(id, mode);
            this.previewCache.set(cacheKey, cardPreview);
        };
        this.remove = (id, mode)=>{
            const cacheKey = $a222999f2a3917ca$export$611736262b635f8d(id, mode);
            this.previewCache.remove(cacheKey);
        };
        this.clear = ()=>{
            this.previewCache.clear();
        };
    }
}
const $a222999f2a3917ca$export$b7e8ee3f7a41459 = new $a222999f2a3917ca$export$7b50526c091bb915((0, $fxEZn.createObjectURLCache)());

});
parcelRegister("fxEZn", function(module, exports) {

$parcel$export(module.exports, "createObjectURLCache", () => $3fcfa7c3b88343f6$export$ba71be67d5c32535);

var $4FH8r = parcelRequire("4FH8r");

var $6roQF = parcelRequire("6roQF");
const $3fcfa7c3b88343f6$export$36d0f9859761643d = 50;
class $3fcfa7c3b88343f6$var$ExtendedLRUCache extends (0, $6roQF.LRUMap) {
    constructor(limit){
        super(limit);
        this.eventEmitter = new (0, $4FH8r.EventEmitter2)();
    }
    shift() {
        const entry = super.shift();
        this.eventEmitter.emit('shift', entry);
        return entry;
    }
    on(event, callback) {
        this.eventEmitter.on(event, callback);
    }
}
class $3fcfa7c3b88343f6$export$75d1c8c9ba1d0773 {
    constructor(size){
        this.cache = new $3fcfa7c3b88343f6$var$ExtendedLRUCache(size);
        this.cache.on('shift', (entry)=>{
            if (entry && entry[1].dataURI) URL.revokeObjectURL(entry[1].dataURI);
        });
    }
    has(key) {
        return !!this.cache.find(key);
    }
    get(key) {
        return this.cache.get(key);
    }
    set(key, value) {
        this.cache.set(key, value);
    }
    remove(key) {
        const removed = this.cache.delete(key);
        removed && URL.revokeObjectURL(removed.dataURI);
    }
    clear() {
        this.cache.clear();
    }
}
const $3fcfa7c3b88343f6$export$ba71be67d5c32535 = ()=>new $3fcfa7c3b88343f6$export$75d1c8c9ba1d0773($3fcfa7c3b88343f6$export$36d0f9859761643d);

});


parcelRegister("1eI0l", function(module, exports) {

$parcel$export(module.exports, "isSupportedLocalPreview", () => $3baf1546cf72426c$export$1fa85b75e8662d54);
$parcel$export(module.exports, "getLocalPreview", () => $3baf1546cf72426c$export$3d6ed68e437b8c99);
$parcel$export(module.exports, "getRemotePreview", () => $3baf1546cf72426c$export$bfe20bd01db02b3);

var $3izHV = parcelRequire("3izHV");

var $dZWOK = parcelRequire("dZWOK");

var $kj8oZ = parcelRequire("kj8oZ");

var $3J2hq = parcelRequire("3J2hq");
const $3baf1546cf72426c$export$1fa85b75e8662d54 = (mediaType)=>mediaType === 'image' || mediaType === 'video';
const $3baf1546cf72426c$var$getImageLocalPreview = async (value)=>{
    try {
        const orientation = await (0, $dZWOK.getOrientation)(value);
        const dataURI = URL.createObjectURL(value);
        return {
            dataURI: dataURI,
            orientation: orientation,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $kj8oZ.LocalPreviewError)('local-preview-image', e instanceof Error ? e : undefined);
    }
};
const $3baf1546cf72426c$var$getVideoLocalPreview = async (value)=>{
    try {
        const dataURI = await (0, $3J2hq.takeSnapshot)(value);
        return {
            dataURI: dataURI,
            orientation: 1,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $kj8oZ.LocalPreviewError)('local-preview-video', e instanceof Error ? e : undefined);
    }
};
const $3baf1546cf72426c$export$3d6ed68e437b8c99 = async (filePreview)=>{
    let value;
    try {
        const resolvedFilePreview = await filePreview;
        value = resolvedFilePreview.value;
    } catch (e) {
        throw new (0, $kj8oZ.LocalPreviewError)('local-preview-rejected', e instanceof Error ? e : undefined);
    }
    if (typeof value === 'string') return {
        dataURI: value,
        orientation: 1,
        source: 'local'
    };
    else if (value instanceof Blob) {
        const { type: type } = value;
        const mediaType = (0, $3izHV.getMediaTypeFromMimeType)(type);
        switch(mediaType){
            case 'image':
                return $3baf1546cf72426c$var$getImageLocalPreview(value);
            case 'video':
                return $3baf1546cf72426c$var$getVideoLocalPreview(value);
            default:
                throw new (0, $kj8oZ.LocalPreviewError)('local-preview-unsupported');
        }
    }
    throw new (0, $kj8oZ.LocalPreviewError)('local-preview-unsupported');
};
const $3baf1546cf72426c$export$bfe20bd01db02b3 = async (mediaClient, id, params, traceContext)=>{
    try {
        const blob = await mediaClient.getImage(id, params, undefined, undefined, traceContext);
        return {
            dataURI: URL.createObjectURL(blob),
            orientation: 1,
            source: 'remote'
        };
    } catch (e) {
        throw new (0, $kj8oZ.RemotePreviewError)('remote-preview-fetch', e instanceof Error ? e : undefined);
    }
};

});
parcelRegister("dZWOK", function(module, exports) {

$parcel$export(module.exports, "getImageInfo", () => $20d9cb8065ed9c55$export$2176b0e68c10508f);
$parcel$export(module.exports, "getOrientation", () => $20d9cb8065ed9c55$export$67689507e8404821);

var $7Ks1a = parcelRequire("7Ks1a");

var $dcjbt = parcelRequire("dcjbt");

var $7R2PQ = parcelRequire("7R2PQ");

var $hTKdV = parcelRequire("hTKdV");
const { Orientation: $20d9cb8065ed9c55$var$Orientation, XResolution: $20d9cb8065ed9c55$var$XResolution } = (0, $7Ks1a.SupportedImageMetaTag);
// http://bonfx.com/why-is-the-web-72-dpi-and-print-300-dpi/
const $20d9cb8065ed9c55$var$DPI_WEB_BASELINE = 72;
async function $20d9cb8065ed9c55$export$2176b0e68c10508f(fileInfo) {
    const metadata = await $20d9cb8065ed9c55$export$c142eb1c8c5c79c(fileInfo);
    if (!metadata) return null;
    const { width: width, height: height, tags: tags } = metadata;
    const scaleFactor = $20d9cb8065ed9c55$export$dd08dbbf61041ccd(fileInfo.file, tags);
    return {
        scaleFactor: scaleFactor,
        width: width,
        height: height
    };
}
function $20d9cb8065ed9c55$export$dd08dbbf61041ccd(file, tags) {
    const scaleFactorFromFilename = $20d9cb8065ed9c55$export$11cb6a214555dd36(file);
    if (scaleFactorFromFilename !== null) return scaleFactorFromFilename;
    else if (tags) {
        /**
		 * Scale Factor is actually a 2D thing, but in practice X & Y are same in 99% cases.
		 * So we are only relying on X axis.
		 */ if (typeof tags['PixelPerUnitX'] === 'number') // 1 inch = 0.0254 meters
        return Math.round(tags['PixelPerUnitX'] * 0.0254) / $20d9cb8065ed9c55$var$DPI_WEB_BASELINE;
        else return $20d9cb8065ed9c55$export$268f92356524130b(tags, $20d9cb8065ed9c55$var$XResolution, $20d9cb8065ed9c55$var$DPI_WEB_BASELINE) / $20d9cb8065ed9c55$var$DPI_WEB_BASELINE;
    } else return 1;
}
const $20d9cb8065ed9c55$var$getOrientationFromTags = (tags)=>{
    if (tags && tags[$20d9cb8065ed9c55$var$Orientation]) {
        const tagValue = tags[$20d9cb8065ed9c55$var$Orientation];
        if (tagValue) {
            const numericValue = parseInt(tagValue, 10);
            if (isNaN(numericValue)) return (0, $7Ks1a.ExifOrientation)[tagValue];
            return numericValue;
        }
    }
    return 1;
};
async function $20d9cb8065ed9c55$export$67689507e8404821(file) {
    const tags = await (0, $dcjbt.readImageMetaTags)(file);
    return $20d9cb8065ed9c55$var$getOrientationFromTags(tags);
}
function $20d9cb8065ed9c55$export$268f92356524130b(tags, key, defaultValue) {
    try {
        const num = parseFloat(`${tags[key]}`);
        if (!isNaN(num)) return num;
    } catch (e) {
    //
    }
    return defaultValue;
}
function $20d9cb8065ed9c55$export$11cb6a214555dd36(file) {
    try {
        // filenames with scale ratio in name take precedence - eg. filename@2x.png
        const match = file.name.trim().match(/@([0-9\.]+)x\.[a-z]{3}$/);
        if (match) return parseFloat(match[1]);
    } catch (e) {
    // parse problem, return null
    }
    return null;
}
async function $20d9cb8065ed9c55$export$c142eb1c8c5c79c(fileInfo) {
    const { file: file, src: src } = fileInfo;
    const type = file.type;
    let width = 0;
    let height = 0;
    const tags = await (0, $dcjbt.readImageMetaTags)(file);
    // since we're reading metadata anyway, try to get dimensions from there...
    if (tags && tags.PixelXDimension) width = $20d9cb8065ed9c55$export$268f92356524130b(tags, 'PixelXDimension', 0);
    if (tags && tags.PixelXDimension) height = $20d9cb8065ed9c55$export$268f92356524130b(tags, 'PixelYDimension', 0);
    const data = {
        type: type,
        width: width,
        height: height,
        naturalWidth: width,
        naturalHeight: height,
        tags: tags
    };
    /*
	 * The PixelXDimension and PixelYDimension of image tags can mean something different than just width and height, especially when images are compressed or for other reasons.
	 * https://imagemagick.org/discourse-server/viewtopic.php?t=27037
	 * We've also received JAC tickets reporting incorrect dimensions because of this
	 * https://jira.atlassian.com/browse/CONFCLOUD-78275
	 * The best way to get accurate dimensions is by loading images into the HTML, which reflects the actual dimensions the browser will render
	 */ try {
        const img = await (0, $7R2PQ.loadImage)(src);
        const { width: width, height: height } = (0, $7R2PQ.readImageNaturalOrientationFromDOM)(img);
        data.width = width;
        data.height = height;
        data.naturalWidth = img.naturalWidth;
        data.naturalHeight = img.naturalHeight;
    } catch (e) {
        return null;
    }
    return data;
}

});
parcelRegister("7Ks1a", function(module, exports) {

$parcel$export(module.exports, "ImageType", () => $3451dd865f26bcbe$export$48c85e6e32ef0825);
$parcel$export(module.exports, "SupportedImageMetaTag", () => $3451dd865f26bcbe$export$e369bb48cf33e564);
$parcel$export(module.exports, "ExifOrientation", () => $3451dd865f26bcbe$export$f6ea0c89fd7d156);
var $3451dd865f26bcbe$export$48c85e6e32ef0825;
(function(ImageType) {
    ImageType["JPEG"] = "image/jpeg";
    ImageType["PNG"] = "image/png";
})($3451dd865f26bcbe$export$48c85e6e32ef0825 || ($3451dd865f26bcbe$export$48c85e6e32ef0825 = {}));
var $3451dd865f26bcbe$export$e369bb48cf33e564;
(function(SupportedImageMetaTag) {
    SupportedImageMetaTag["XResolution"] = "XResolution";
    SupportedImageMetaTag["YResolution"] = "YResolution";
    SupportedImageMetaTag["Orientation"] = "Orientation";
})($3451dd865f26bcbe$export$e369bb48cf33e564 || ($3451dd865f26bcbe$export$e369bb48cf33e564 = {}));
const $3451dd865f26bcbe$export$f6ea0c89fd7d156 = {
    'top-left': 1,
    'top-right': 2,
    'bottom-right': 3,
    'bottom-left': 4,
    'left-top': 5,
    'right-top': 6,
    'right-bottom': 7,
    'left-bottom': 8
};

});

parcelRegister("dcjbt", function(module, exports) {

$parcel$export(module.exports, "readImageMetaTags", () => $3968a72b4e3e5571$export$41982b5c7acb23c4);

var $7Ks1a = parcelRequire("7Ks1a");

var $90lR8 = parcelRequire("90lR8");

var $932a4 = parcelRequire("932a4");

var $g4zYY = parcelRequire("g4zYY");
async function $3968a72b4e3e5571$export$41982b5c7acb23c4(file) {
    const type = file.type;
    try {
        if (type === (0, $7Ks1a.ImageType).PNG) {
            // http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
            // iTXt = XML text with metadata
            // pHYs = Physical pixel dimensions
            const { iTXt: iTXt, pHYs: pHYs } = await (0, $932a4.readPNGXMPMetaData)(file);
            const xmpMetaData = {
                ...(0, $g4zYY.parseXMPMetaData)(iTXt),
                ...pHYs
            };
            return xmpMetaData;
        } else if (file.type === (0, $7Ks1a.ImageType).JPEG) return await (0, $90lR8.readJPEGExifMetaData)(file);
    } catch (e) {
    // problem parsing metadata
    }
    return null;
}

});
parcelRegister("90lR8", function(module, exports) {

$parcel$export(module.exports, "readJPEGExifMetaData", () => $3cfacf7fa7775806$export$556b2ccec62d7f2a);

var $7Ks1a = parcelRequire("7Ks1a");
const { XResolution: $3cfacf7fa7775806$var$XResolution, YResolution: $3cfacf7fa7775806$var$YResolution } = (0, $7Ks1a.SupportedImageMetaTag);
let $3cfacf7fa7775806$var$loadImage;

function $3cfacf7fa7775806$export$556b2ccec62d7f2a(file) {
    return new Promise(async (resolve, reject)=>{
        if (!$3cfacf7fa7775806$var$loadImage) {
            const module = await (parcelRequire("9KHD3"));
            $3cfacf7fa7775806$var$loadImage = module.default || module;
        }
        $3cfacf7fa7775806$var$loadImage.parseMetaData(file, (data)=>{
            try {
                const tags = data && data.exif ? data.exif.getAll() : {};
                Object.keys(tags).forEach((key)=>{
                    const value = tags[key];
                    if (typeof value === 'object' && (key === $3cfacf7fa7775806$var$XResolution || key === $3cfacf7fa7775806$var$YResolution) && 'numerator' in value) // some test images had this structure, so just take the numerator value to simplify returned value
                    tags[key] = value.numerator;
                    if (typeof tags[key] === 'number') // in case numbers types were auto-converted, keep everything the same between jpeg & png we keep as strings
                    tags[key] = `${tags[key]}`;
                });
                resolve(tags);
            } catch (e) {
                reject(e);
            }
        });
    });
}

});
parcelRegister("9KHD3", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('4EQ6s');
        const value = parcelRequire('hB5r9');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("4EQ6s").then(()=>parcelRequire('hB5r9'));
}

});


parcelRegister("932a4", function(module, exports) {

$parcel$export(module.exports, "readPNGXMPMetaData", () => $d107ad611f184457$export$5fb37736440fca6f);

var $7R2PQ = parcelRequire("7R2PQ");
let $d107ad611f184457$var$pngChunksExtract;

async function $d107ad611f184457$export$5fb37736440fca6f(file) {
    if (!$d107ad611f184457$var$pngChunksExtract) {
        const module = await (parcelRequire("5bjZ0"));
        $d107ad611f184457$var$pngChunksExtract = module.default || module;
    }
    const buffer = await (0, $7R2PQ.fileToArrayBuffer)(file);
    const chunks = $d107ad611f184457$var$pngChunksExtract(buffer);
    return await $d107ad611f184457$export$9185743fdd58ce45(chunks);
}
async function $d107ad611f184457$export$9185743fdd58ce45(chunks) {
    let iTXt = '';
    let pHYs = {};
    /**
	 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
	 * Order of every chunk is not guaranteed.
	 * And both iTXt and pHYs are Ancillary chunks.
	 */ for(let i = 0; i < chunks.length; ++i){
        const chunk = chunks[i];
        // Must be last
        if (chunk.name === 'IEND') break;
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Anc-text
		 * iTXt contains the useful XMP/XML string data of meta tags
		 */ if (chunk.name === 'iTXt') iTXt = String.fromCharCode.apply(null, Array.from(chunk.data));
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.pHYs
		 * Pixels per unit, X axis: 4 bytes (unsigned integer)
		 * Pixels per unit, Y axis: 4 bytes (unsigned integer)
		 * Unit specifier:          1 byte  (0: unit is unknown 1: unit is the meter)
		 */ if (chunk.name === 'pHYs') {
            const dv = new DataView(chunk.data.buffer);
            const unitSpecifier = dv.getUint8(8);
            // meter
            if (unitSpecifier === 1) {
                const PixelPerUnitX = dv.getUint32(0);
                const PixelPerUnitY = dv.getUint32(4);
                pHYs = {
                    PixelPerUnitX: PixelPerUnitX,
                    PixelPerUnitY: PixelPerUnitY
                };
            }
        }
    }
    return {
        iTXt: iTXt,
        pHYs: pHYs
    };
}

});
parcelRegister("7R2PQ", function(module, exports) {

$parcel$export(module.exports, "dataURItoFile", () => $762b6f6dab9d1b7f$export$80d19edb7b1ae293);
$parcel$export(module.exports, "fileToDataURI", () => $762b6f6dab9d1b7f$export$849633012686f7ee);
$parcel$export(module.exports, "getFileInfo", () => $762b6f6dab9d1b7f$export$ca39f27fe4f7d9b4);
$parcel$export(module.exports, "fileToArrayBuffer", () => $762b6f6dab9d1b7f$export$956310555b96755a);
$parcel$export(module.exports, "loadImage", () => $762b6f6dab9d1b7f$export$fe58198efe02b173);
$parcel$export(module.exports, "readImageNaturalOrientationFromDOM", () => $762b6f6dab9d1b7f$export$325d46491952db2d);
$parcel$export(module.exports, "findParentByClassname", () => $762b6f6dab9d1b7f$export$89ff65f1d45dfb03);
$parcel$export(module.exports, "getMimeIcon", () => $762b6f6dab9d1b7f$export$61a1de0822e2820);

var $hdGyo = parcelRequire("hdGyo");

var $8LNkR = parcelRequire("8LNkR");

var $eCjZE = parcelRequire("eCjZE");

var $9x8bE = parcelRequire("9x8bE");

var $eKyyR = parcelRequire("eKyyR");

var $3WWqq = parcelRequire("3WWqq");

var $hq1pc = parcelRequire("hq1pc");

var $2qasA = parcelRequire("2qasA");

var $dMHxL = parcelRequire("dMHxL");

var $bMNrG = parcelRequire("bMNrG");

var $h7CpT = parcelRequire("h7CpT");

var $6Wxq8 = parcelRequire("6Wxq8");

var $h5uIF = parcelRequire("h5uIF");

var $3FCIk = parcelRequire("3FCIk");

var $3NApm = parcelRequire("3NApm");

var $1OdUR = parcelRequire("1OdUR");
function $762b6f6dab9d1b7f$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const dataURIParts = dataURI.split(',');
    const byteString = dataURIParts[0].indexOf('base64') >= 0 ? atob(dataURIParts[1]) : decodeURIComponent(dataURIParts[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        // https://stackoverflow.com/questions/1176022/unknown-file-type-mime
        mimeString = 'application/octet-stream';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 does not allow the File constructor (yay!)
        // we get around this by decorating the blob instance with File properties
        // effectively casting up from Blob to File.
        const ie11File = blob;
        const date = new Date();
        ie11File.lastModified = date.getTime();
        ie11File.lastModifiedDate = date;
        ie11File.name = filename;
        ie11File.webkitRelativePath = '';
        return ie11File;
    }
}
function $762b6f6dab9d1b7f$export$849633012686f7ee(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const result = reader.result;
            if (typeof result === 'string') resolve(result);
            else if (result === null) reject();
        });
        reader.addEventListener('error', reject);
        reader.readAsDataURL(blob);
    });
}
async function $762b6f6dab9d1b7f$export$ca39f27fe4f7d9b4(file, src) {
    return {
        file: file,
        src: src || await $762b6f6dab9d1b7f$export$849633012686f7ee(file)
    };
}
async function $762b6f6dab9d1b7f$export$d727e14d7168c14(src, file) {
    return {
        file: file || await $762b6f6dab9d1b7f$export$80d19edb7b1ae293(src),
        src: src
    };
}
function $762b6f6dab9d1b7f$export$956310555b96755a(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const array = new Uint8Array(reader.result);
            resolve(array);
        });
        reader.addEventListener('error', reject);
        reader.readAsArrayBuffer(file);
    });
}
function $762b6f6dab9d1b7f$export$fe58198efe02b173(src) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = src;
        img.onload = ()=>{
            resolve(img);
        };
        img.onerror = reject;
    });
}
function $762b6f6dab9d1b7f$export$325d46491952db2d(img) {
    img.style.position = 'absolute';
    img.style.visibility = 'hidden';
    document.body.appendChild(img);
    const { width: width, height: height } = img.getBoundingClientRect();
    document.body.removeChild(img);
    return {
        width: width,
        height: height
    };
}
const $762b6f6dab9d1b7f$export$89ff65f1d45dfb03 = (element, className, maxParentElement = document.body)=>{
    if (element.classList.contains(className)) return element;
    let currentElement = element;
    while(currentElement.parentElement !== maxParentElement){
        if (currentElement.parentElement) {
            currentElement = currentElement.parentElement;
            if (currentElement.classList.contains(className)) return currentElement;
        } else return undefined;
    }
    return undefined;
};
const $762b6f6dab9d1b7f$var$mimeTypes = [
    {
        label: 'pdf',
        mimeTypes: [
            'application/pdf'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hdGyo)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dMHxL)))
    },
    {
        label: 'google-slides',
        mimeTypes: [
            'application/vnd.google-apps.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($h7CpT)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dMHxL)))
    },
    {
        label: 'google-sheets',
        mimeTypes: [
            'application/vnd.google-apps.spreadsheet'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bMNrG)))
    },
    {
        label: 'google-docs',
        mimeTypes: [
            'application/vnd.google-apps.document',
            'application/vnd.google-apps.kix'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2qasA)))
    },
    {
        label: 'microsoft-word',
        mimeTypes: [
            'application/msword',
            'application/vnd.openxmlformats-officedocument.word'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9x8bE)))
    },
    {
        label: 'presentation',
        mimeTypes: [
            'application/x-iwork-keynote-sffkey',
            'application/vnd.oasis.opendocument.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3FCIk)))
    },
    {
        label: 'powerpoint-presentation',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.ms-powerpoint'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eCjZE)))
    },
    {
        label: 'giphy',
        mimeTypes: [
            'image/gif'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8LNkR)))
    },
    {
        label: 'spreadsheet',
        mimeTypes: [
            'text/csv'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($h5uIF)))
    },
    {
        label: 'excel-spreadsheet',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
            'application/x-iwork-keynote-sffnumbers'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6Wxq8)))
    }
];
function $762b6f6dab9d1b7f$export$61a1de0822e2820(mimeType, fileName) {
    // based on the mimeType, determine the corresponding icon and label
    const iconInfo = $762b6f6dab9d1b7f$var$mimeTypes.find((file)=>file.mimeTypes.indexOf(mimeType) > -1);
    //return the appropriate icon and its label if we have it
    if (iconInfo) return iconInfo;
    if ((0, $1OdUR.isCodeViewerItem)(fileName, mimeType)) return {
        label: 'source-code',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3NApm)))
    };
    // we are not able to determine what icon to render based on the mimeType
    // hence we render the icon based on the filename
    if (fileName.match(/.*\.sketch$/)) return {
        label: 'sketch',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eKyyR)))
    };
    if (fileName.match(/.*\.fig$/)) return {
        label: 'figma',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3WWqq)))
    };
    if (fileName.match(/.*\.exe$/) || fileName.match(/.*\.dmg$/)) return {
        label: 'executable',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hq1pc)))
    };
    // cannot find a corresponding mimeType icon.
    return undefined;
}

});
parcelRegister("hdGyo", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c894a8df21fa5c84$var$_react = $c894a8df21fa5c84$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $c894a8df21fa5c84$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c894a8df21fa5c84$var$PdfDocument24Icon = (props)=>/*#__PURE__*/ $c894a8df21fa5c84$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#FF5630" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm1.846 12.17h.483c1.116 0 1.203-.322 1.203-.776 0-.518-.268-.771-.817-.771h-.869v1.546zm6.29 2.183h.664c.742 0 1.501-.22 1.501-1.855 0-1.65-.802-1.86-1.501-1.86h-.665v3.715zM4.462 15.99h-1.08A.384.384 0 013 15.606V9.383c0-.21.171-.383.383-.383h2.494c1.483 0 2.52.984 2.52 2.394 0 1.43-1.015 2.39-2.525 2.39H4.846v1.822a.384.384 0 01-.383.384zm7.45 0h-2.24a.384.384 0 01-.384-.384V9.383c0-.21.172-.383.383-.383h2.242c2.107 0 3.268 1.237 3.268 3.484 0 2.26-1.16 3.506-3.268 3.506zm5.776 0h-1.08a.384.384 0 01-.384-.384V9.383c0-.21.172-.383.383-.383h4.009c.21 0 .383.172.383.383v.88a.383.383 0 01-.383.383h-2.545v1.14h2.292c.212 0 .383.172.383.383v.867c0 .21-.171.383-.383.383h-2.292v2.187a.384.384 0 01-.383.384z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c894a8df21fa5c84$var$PdfDocument24Icon.displayName = 'PdfDocument24Icon';
var $c894a8df21fa5c84$var$_default = $c894a8df21fa5c84$var$PdfDocument24Icon;
module.exports.default = $c894a8df21fa5c84$var$_default;

});

parcelRegister("8LNkR", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $6628fb7cf0e02b12$var$_react = $6628fb7cf0e02b12$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $6628fb7cf0e02b12$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $6628fb7cf0e02b12$var$Gif24Icon = (props)=>/*#__PURE__*/ $6628fb7cf0e02b12$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#FFAB00" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm10.564 16.636h-1.93a.243.243 0 01-.244-.243V8.384c0-.135.108-.243.243-.243h1.93c.135 0 .244.108.244.243v8.009a.243.243 0 01-.243.243m3.79 0h-1.931a.243.243 0 01-.243-.243V8.384c0-.135.109-.243.243-.243h5.334c.133 0 .243.108.243.243v1.573c0 .134-.11.243-.243.243h-3.16v1.42h2.848c.135 0 .244.11.244.244v1.518a.243.243 0 01-.244.244h-2.847v2.767c0 .134-.11.243-.244.243m-10.567.146C4.416 16.782 3 15.31 3 12.843v-.962C3 9.487 4.453 8 6.793 8c2.314 0 3.436 1.467 3.522 2.922a.241.241 0 01-.242.258H8.195a.243.243 0 01-.24-.2c-.1-.55-.552-.892-1.18-.892-1.108 0-1.34.985-1.34 1.81v.94c0 1.231.467 1.856 1.393 1.856.885 0 1.2-.538 1.2-1v-.092H6.874a.243.243 0 01-.243-.243v-1.373c0-.134.11-.243.243-.243h3.216c.134 0 .243.109.243.243v1.555c0 1.496-.929 3.241-3.546 3.241"/></svg>`
    }, props, {
        size: 'medium'
    }));
$6628fb7cf0e02b12$var$Gif24Icon.displayName = 'Gif24Icon';
var $6628fb7cf0e02b12$var$_default = $6628fb7cf0e02b12$var$Gif24Icon;
module.exports.default = $6628fb7cf0e02b12$var$_default;

});

parcelRegister("eCjZE", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $aa441f8cde622841$var$_react = $aa441f8cde622841$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $aa441f8cde622841$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $aa441f8cde622841$var$PowerpointPresentation24Icon = (props)=>/*#__PURE__*/ $aa441f8cde622841$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#CA5010" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm1.376 6.013A.437.437 0 004 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 00.497-.434V4.868a.437.437 0 00-.499-.434L4.376 6.014zM17 7v10h2.5a.5.5 0 00.5-.5v-9a.5.5 0 00-.5-.5H17zM7.854 8.454h2.94c1.45 0 2.441.972 2.441 2.437 0 1.45-1.03 2.421-2.514 2.421H9.329V15.5H7.854V8.454zM9.33 9.665v2.451h1.07c.844 0 1.337-.43 1.337-1.22 0-.801-.483-1.231-1.333-1.231H9.33z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$aa441f8cde622841$var$PowerpointPresentation24Icon.displayName = 'PowerpointPresentation24Icon';
var $aa441f8cde622841$var$_default = $aa441f8cde622841$var$PowerpointPresentation24Icon;
module.exports.default = $aa441f8cde622841$var$_default;

});

parcelRegister("9x8bE", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $6f0d8bdcc8cbb422$var$_react = $6f0d8bdcc8cbb422$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $6f0d8bdcc8cbb422$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $6f0d8bdcc8cbb422$var$WordDocument24Icon = (props)=>/*#__PURE__*/ $6f0d8bdcc8cbb422$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#1D7AFC" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm1.376 6.013A.437.437 0 004 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 00.497-.434V4.868a.437.437 0 00-.499-.434L4.376 6.014zm5.629 5.324L8.687 16H7.295L5.43 8.954h1.533l1.099 4.966h.078l1.284-4.966h1.245l1.309 4.966h.078l1.089-4.966h1.523L12.798 16h-1.382l-1.333-4.663h-.078zM17 7v10h2.5a.5.5 0 00.5-.5v-9a.5.5 0 00-.5-.5H17z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$6f0d8bdcc8cbb422$var$WordDocument24Icon.displayName = 'WordDocument24Icon';
var $6f0d8bdcc8cbb422$var$_default = $6f0d8bdcc8cbb422$var$WordDocument24Icon;
module.exports.default = $6f0d8bdcc8cbb422$var$_default;

});

parcelRegister("eKyyR", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $abd02bb672a51ffd$var$_react = $abd02bb672a51ffd$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $abd02bb672a51ffd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $abd02bb672a51ffd$var$Sketch24Icon = (props)=>/*#__PURE__*/ $abd02bb672a51ffd$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#FF8B00" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm9.03 20h.001c.29-.001.562-.126.752-.343l6.971-8a1 1 0 00.095-1.185l-2.485-4a1.003 1.003 0 00-.85-.472h-8.84c-.334 0-.646.167-.832.444l-2.674 4a1 1 0 00.081 1.216l7.03 8c.188.216.462.34.75.34z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$abd02bb672a51ffd$var$Sketch24Icon.displayName = 'Sketch24Icon';
var $abd02bb672a51ffd$var$_default = $abd02bb672a51ffd$var$Sketch24Icon;
module.exports.default = $abd02bb672a51ffd$var$_default;

});

parcelRegister("3WWqq", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $2e041bec93092120$var$_react = $2e041bec93092120$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $2e041bec93092120$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $2e041bec93092120$var$Figma24Icon = (props)=>/*#__PURE__*/ $2e041bec93092120$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.248 0A3.248 3.248 0 000 3.248v17.504A3.248 3.248 0 003.248 24h17.504A3.248 3.248 0 0024 20.752V3.248A3.248 3.248 0 0020.752 0H3.248zm8.755 17.012a2.506 2.506 0 01-2.505 2.507 2.506 2.506 0 010-5.013 2.506 2.506 0 010-5.012 2.506 2.506 0 010-5.013h5.009a2.506 2.506 0 010 5.013h-2.505v2.5a2.506 2.506 0 012.505-2.5 2.506 2.506 0 010 5.012 2.506 2.506 0 01-2.505-2.5v5.006z" fill="#8270DB"/></svg>`
    }, props, {
        size: 'medium'
    }));
$2e041bec93092120$var$Figma24Icon.displayName = 'Figma24Icon';
var $2e041bec93092120$var$_default = $2e041bec93092120$var$Figma24Icon;
module.exports.default = $2e041bec93092120$var$_default;

});

parcelRegister("hq1pc", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $cae5f47c2a571309$var$_react = $cae5f47c2a571309$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $cae5f47c2a571309$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $cae5f47c2a571309$var$Executable24Icon = (props)=>/*#__PURE__*/ $cae5f47c2a571309$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm2 13v5a1 1 0 001 1h12a1 1 0 001-1v-5H5zm1.883-8a1 1 0 00-.992.876L5 13h14l-.89-7.124A1 1 0 0017.116 5H6.883zM8 15h8a1 1 0 010 2H8a1 1 0 010-2z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$cae5f47c2a571309$var$Executable24Icon.displayName = 'Executable24Icon';
var $cae5f47c2a571309$var$_default = $cae5f47c2a571309$var$Executable24Icon;
module.exports.default = $cae5f47c2a571309$var$_default;

});

parcelRegister("2qasA", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1c361fa263fe065a$var$_react = $1c361fa263fe065a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $1c361fa263fe065a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $1c361fa263fe065a$var$GoogleDoc24Icon = (props)=>/*#__PURE__*/ $1c361fa263fe065a$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2196F3" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm12.049 5l-5.422.055 4.677 8.15 5.422-.055L15.049 5zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697L4 14.108zm6.646.141L7.982 19h9.354L20 14.249h-9.354z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$1c361fa263fe065a$var$GoogleDoc24Icon.displayName = 'GoogleDoc24Icon';
var $1c361fa263fe065a$var$_default = $1c361fa263fe065a$var$GoogleDoc24Icon;
module.exports.default = $1c361fa263fe065a$var$_default;

});

parcelRegister("dMHxL", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $a09188e84ea7ab45$var$_react = $a09188e84ea7ab45$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $a09188e84ea7ab45$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a09188e84ea7ab45$var$GoogleForm24Icon = (props)=>/*#__PURE__*/ $a09188e84ea7ab45$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270DB" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm12.049 5l-5.422.055 4.677 8.15 5.422-.055L15.049 5zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697L4 14.108zm6.646.141L7.982 19h9.354L20 14.249h-9.354z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$a09188e84ea7ab45$var$GoogleForm24Icon.displayName = 'GoogleForm24Icon';
var $a09188e84ea7ab45$var$_default = $a09188e84ea7ab45$var$GoogleForm24Icon;
module.exports.default = $a09188e84ea7ab45$var$_default;

});

parcelRegister("bMNrG", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $894a8844a9a1528d$var$_react = $894a8844a9a1528d$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $894a8844a9a1528d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $894a8844a9a1528d$var$GoogleSheet24Icon = (props)=>/*#__PURE__*/ $894a8844a9a1528d$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#0A9D58" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm12.049 5l-5.422.055 4.677 8.15 5.422-.055L15.049 5zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697L4 14.108zm6.646.141L7.982 19h9.354L20 14.249h-9.354z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$894a8844a9a1528d$var$GoogleSheet24Icon.displayName = 'GoogleSheet24Icon';
var $894a8844a9a1528d$var$_default = $894a8844a9a1528d$var$GoogleSheet24Icon;
module.exports.default = $894a8844a9a1528d$var$_default;

});

parcelRegister("h7CpT", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c770e3deabcd313a$var$_react = $c770e3deabcd313a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $c770e3deabcd313a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c770e3deabcd313a$var$GoogleSlide24Icon = (props)=>/*#__PURE__*/ $c770e3deabcd313a$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#FFC107" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm12.049 5l-5.422.055 4.677 8.15 5.422-.055L15.049 5zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697L4 14.108zm6.646.141L7.982 19h9.354L20 14.249h-9.354z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c770e3deabcd313a$var$GoogleSlide24Icon.displayName = 'GoogleSlide24Icon';
var $c770e3deabcd313a$var$_default = $c770e3deabcd313a$var$GoogleSlide24Icon;
module.exports.default = $c770e3deabcd313a$var$_default;

});

parcelRegister("6Wxq8", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $50e215742d0d2558$var$_react = $50e215742d0d2558$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $50e215742d0d2558$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $50e215742d0d2558$var$ExcelSpreadsheet24Icon = (props)=>/*#__PURE__*/ $50e215742d0d2558$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#22A06B" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm1.376 6.013A.437.437 0 004 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 00.497-.434V4.868a.437.437 0 00-.499-.434L4.376 6.014zM17 7v10h2.5a.5.5 0 00.5-.5v-9a.5.5 0 00-.5-.5H17zM6.93 15.5l2.25-3.55-2.236-3.496h1.734l1.47 2.466h.087l1.485-2.466h1.65l-2.32 3.52 2.286 3.526h-1.68l-1.513-2.388h-.088L8.52 15.5H6.93z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$50e215742d0d2558$var$ExcelSpreadsheet24Icon.displayName = 'ExcelSpreadsheet24Icon';
var $50e215742d0d2558$var$_default = $50e215742d0d2558$var$ExcelSpreadsheet24Icon;
module.exports.default = $50e215742d0d2558$var$_default;

});

parcelRegister("h5uIF", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c70abb8afd54d479$var$_react = $c70abb8afd54d479$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $c70abb8afd54d479$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $c70abb8afd54d479$var$Spreadsheet24Icon = (props)=>/*#__PURE__*/ $c70abb8afd54d479$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36B37E" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm2 5a1 1 0 100 2h3a1 1 0 100-2H5zm0 4a1 1 0 100 2h3a1 1 0 000-2H5zm0 4a1 1 0 000 2h3a1 1 0 000-2H5zm0 4a1 1 0 000 2h3a1 1 0 000-2H5zm7-12a1 1 0 000 2h7a1 1 0 000-2h-7zm0 4a1 1 0 000 2h7a1 1 0 000-2h-7zm0 4a1 1 0 000 2h7a1 1 0 000-2h-7zm0 4a1 1 0 000 2h7a1 1 0 000-2h-7z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c70abb8afd54d479$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
var $c70abb8afd54d479$var$_default = $c70abb8afd54d479$var$Spreadsheet24Icon;
module.exports.default = $c70abb8afd54d479$var$_default;

});

parcelRegister("3FCIk", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $2ac33b3cb49c77eb$var$_react = $2ac33b3cb49c77eb$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $2ac33b3cb49c77eb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $2ac33b3cb49c77eb$var$Presentation24Icon = (props)=>/*#__PURE__*/ $2ac33b3cb49c77eb$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270DB" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm3 14a1 1 0 00-1 1v3a1 1 0 002 0v-3a1 1 0 00-1-1zm8-6a1 1 0 00-1 1v9a1 1 0 002 0V9a1 1 0 00-1-1zm-4 4a1 1 0 00-1 1v5a1 1 0 002 0v-5a1 1 0 00-1-1zm8-7a1 1 0 00-1 1v12a1 1 0 002 0V6a1 1 0 00-1-1z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$2ac33b3cb49c77eb$var$Presentation24Icon.displayName = 'Presentation24Icon';
var $2ac33b3cb49c77eb$var$_default = $2ac33b3cb49c77eb$var$Presentation24Icon;
module.exports.default = $2ac33b3cb49c77eb$var$_default;

});

parcelRegister("3NApm", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $2c42309754fc4881$var$_react = $2c42309754fc4881$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $2c42309754fc4881$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $2c42309754fc4881$var$SourceCode24Icon = (props)=>/*#__PURE__*/ $2c42309754fc4881$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#00B8D9" fill-rule="evenodd" d="M3 0h18a3 3 0 013 3v18a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3zm5.017 12.265l-2.58-2.501L8.236 7.05a.999.999 0 10-1.392-1.436l-3.54 3.432a1 1 0 000 1.436l3.32 3.219a1 1 0 101.393-1.436zm6.638-8.21a1 1 0 00-1.271.62l-4.83 14.046a1 1 0 001.892.65l4.829-14.045a1 1 0 00-.62-1.271zm6.081 9.776l-3.32-3.219a.999.999 0 10-1.393 1.436l2.58 2.501-2.799 2.714a.999.999 0 101.392 1.436l3.54-3.432a1 1 0 000-1.436z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$2c42309754fc4881$var$SourceCode24Icon.displayName = 'SourceCode24Icon';
var $2c42309754fc4881$var$_default = $2c42309754fc4881$var$SourceCode24Icon;
module.exports.default = $2c42309754fc4881$var$_default;

});

parcelRegister("1OdUR", function(module, exports) {

$parcel$export(module.exports, "getExtension", () => $d49392d0af6b4c2e$export$78d71f9ed5534abe);
$parcel$export(module.exports, "isCodeViewerItem", () => $d49392d0af6b4c2e$export$bb139b46f345ca28);
$parcel$export(module.exports, "getLanguageType", () => $d49392d0af6b4c2e$export$ba4368c844580f9e);
function $d49392d0af6b4c2e$export$78d71f9ed5534abe(filename) {
    if (filename.indexOf('.') > -1) return filename.split('.').pop();
    return '';
}
const $d49392d0af6b4c2e$var$codeViewerMimeTypes = [
    {
        mimetype: 'application/json',
        language: 'json'
    },
    {
        mimetype: 'text/html',
        language: 'html'
    }
];
function $d49392d0af6b4c2e$export$bb139b46f345ca28(name, mimetype = 'unknown') {
    return $d49392d0af6b4c2e$export$ba4368c844580f9e(name, mimetype) !== null;
}
function $d49392d0af6b4c2e$export$ba4368c844580f9e(name, mimetype) {
    if (mimetype) {
        const languageForMimeType = $d49392d0af6b4c2e$var$codeViewerMimeTypes.find((x)=>x.mimetype === mimetype);
        if (languageForMimeType) return languageForMimeType.language;
    }
    const ext = $d49392d0af6b4c2e$export$78d71f9ed5534abe(name);
    switch(ext){
        case 'abap':
        case 'ada':
        case 'c':
        case 'css':
        case 'd':
        case 'dart':
        case 'go':
        case 'graphql':
        case 'groovy':
        case 'html':
        case 'java':
        case 'json':
        case 'matlab':
        case 'xml':
        case 'lua':
        case 'puppet':
        case 'qml':
        case 'sass':
        case 'sql':
        case 'php':
        case 'r':
        case 'swift':
        case 'tcl':
        case 'vala':
        case 'vhdl':
        case 'xquery':
            return ext;
        case 'as':
        case 'asc':
            return 'actionscript';
        case 'ino':
            return 'arduino';
        case 'au3':
            return 'autoit';
        case 'cpp':
        case 'h':
        case 'c++':
            return 'c++';
        case 'coffee':
            return 'coffeescript';
        case 'cs':
            return 'csharp';
        case 'cu':
            return 'cuda';
        case 'pas':
        case 'dpr':
        case 'dproj':
        case 'dpk':
            return 'delphi';
        case 'ex':
        case 'exs':
            return 'elixir';
        case 'erl':
        case 'hrl':
            return 'erlang';
        case 'f90':
        case 'for':
        case 'f':
        case 'fpp':
        case 'i':
        case 'i90':
        case 'ftn':
            return 'fortran';
        case 'dbc':
            return 'foxpro';
        case 'hs':
        case 'has':
            return 'haskell';
        case 'hx':
            return 'haxe';
        case 'js':
        case 'jsx':
            return 'javascript';
        case 'jl':
            return 'julia';
        case 'kt':
            return 'kotlin';
        case 'm':
        case 'mm':
            return 'objective-c';
        case 'j':
            return 'objective-j';
        case 'tex':
            return 'latex';
        case 'nb':
        case 'cdf':
            return 'mathematica';
        case 'cma':
            return 'ocaml';
        case 'pl':
            return 'perl';
        case 'py':
            return 'python';
        case 'ps1':
        case 'psd1':
        case 'psm1':
            return 'powershell';
        case 'rb':
            return 'ruby';
        case 'rst':
            return 'restructuredtext';
        case 'rs':
            return 'rust';
        case 'rkt':
            return 'racket';
        case 'sh':
            return 'shell';
        case 'sc':
        case 'sch':
            return 'scheme';
        case 'txt':
        case 'msg':
        case 'log':
        case 'csv':
        case 'md':
            return 'text';
        case 'ts':
        case 'tsx':
            return 'typescript';
        case 'v':
            return 'verilog';
        case 'xq':
        case 'xql':
        case 'xqm':
        case 'xqy':
            return 'xquery';
        case 'lock':
        case 'yaml':
        case 'yml':
            return 'yaml';
        default:
            return null;
    }
}

});


parcelRegister("5bjZ0", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('f26P8');
        const value = parcelRequire('3TpCy');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("f26P8").then(()=>parcelRequire('3TpCy'));
}

});


parcelRegister("g4zYY", function(module, exports) {

$parcel$export(module.exports, "parseXMPMetaData", () => $75e912d905a332c2$export$55c3bc9841b19de2);
function $75e912d905a332c2$export$55c3bc9841b19de2(xmpMetaData) {
    const metadata = {};
    const tags = xmpMetaData.match(/<(tiff|exif):.+>/gi);
    if (tags) tags.forEach((tag)=>{
        const match = tag.match(/<(tiff|exif):([^>]+)>([^<]+)/i);
        if (match) {
            const name = match[2];
            metadata[name] = match[3];
        }
    });
    return metadata;
}

});


parcelRegister("hTKdV", function(module, exports) {

$parcel$export(module.exports, "isRotated", () => $5ac62904b0493085$export$8af433705f41088f);
$parcel$export(module.exports, "getCssFromImageOrientation", () => $5ac62904b0493085$export$43142f95b8de7a91);
const $5ac62904b0493085$var$ORIENT_TRANSFORMS = {
    1: 'none',
    2: 'rotateY(180deg)',
    3: 'rotate(180deg)',
    4: 'rotate(180deg) rotateY(180deg)',
    5: 'rotate(270deg) rotateY(180deg)',
    6: 'rotate(90deg)',
    7: 'rotate(90deg) rotateY(180deg)',
    8: 'rotate(270deg)'
};
const $5ac62904b0493085$export$8af433705f41088f = (orientation)=>orientation >= 5;
const $5ac62904b0493085$export$43142f95b8de7a91 = (orientation)=>{
    return $5ac62904b0493085$var$ORIENT_TRANSFORMS[orientation];
};

});


parcelRegister("3J2hq", function(module, exports) {

$parcel$export(module.exports, "takeSnapshot", () => $34418b456963f386$export$4269d30173168e5c);
const $34418b456963f386$export$4269d30173168e5c = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        video.play().catch(()=>{
            return reject(new Error('failed to play video'));
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('timeupdate', function timeUpdateHandler() {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            video.removeEventListener('timeupdate', timeUpdateHandler);
            video.pause();
            URL.revokeObjectURL(url);
            //create canvas to draw our first frame on.
            if (!video.videoWidth && !video.videoHeight) return reject(new Error('error retrieving video dimensions'));
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const context = canvas.getContext('2d');
            if (!context) return reject(new Error('error creating canvas context'));
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const dataURL = canvas.toDataURL('image/jpeg', 0.85);
            resolve(dataURL);
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});



parcelRegister("862c0", function(module, exports) {

$parcel$export(module.exports, "getMediaCardSSR", () => $635d7cc412152f53$export$ede93d4564eaa8da);
$parcel$export(module.exports, "getKey", () => $635d7cc412152f53$export$a47fb462a08de82f);
$parcel$export(module.exports, "generateScriptProps", () => $635d7cc412152f53$export$de7c49925e44d75d);

var $7UQrl = parcelRequire("7UQrl");
const $635d7cc412152f53$export$21c2ece80f3e3137 = 'mediaCardSsr';
const $635d7cc412152f53$export$5b1a163e413609f8 = '__MEDIA_INTERNAL';
function $635d7cc412152f53$export$96a3cfb3a41e9bb2(globalScope = window) {
    // Must match GLOBAL_MEDIA_NAMESPACE. Can't reference the constant from here.
    const namespace = '__MEDIA_INTERNAL';
    if (!globalScope[namespace]) globalScope[namespace] = {};
    return globalScope[namespace];
}
function $635d7cc412152f53$export$ede93d4564eaa8da(globalScope = window) {
    const globalMedia = $635d7cc412152f53$export$96a3cfb3a41e9bb2(globalScope);
    // Must match GLOBAL_MEDIA_CARD_SSR. Can't reference the constant from here.
    const key = 'mediaCardSsr';
    if (!globalMedia[key]) globalMedia[key] = {};
    return globalMedia[key];
}
const $635d7cc412152f53$var$dashed = (param)=>param ? `-${param}` : '';
const $635d7cc412152f53$export$a47fb462a08de82f = ({ id: id, collectionName: collectionName, occurrenceKey: occurrenceKey })=>`${id}${$635d7cc412152f53$var$dashed(collectionName)}${$635d7cc412152f53$var$dashed(occurrenceKey)}`;
const $635d7cc412152f53$export$4310981e0aa4ce67 = (key, dataURI, dimensions, error, globalScope = window)=>{
    const mediaCardSsr = $635d7cc412152f53$export$ede93d4564eaa8da(globalScope);
    mediaCardSsr[key] = {
        dataURI: dataURI,
        dimensions: dimensions,
        error: error
    };
};
const $635d7cc412152f53$var$generateScript = (identifier, dataURI, dimensions, error)=>{
    const functionCall = (0, $7UQrl.printFunctionCall)($635d7cc412152f53$export$4310981e0aa4ce67, $635d7cc412152f53$export$a47fb462a08de82f(identifier), dataURI, dimensions, error);
    return (0, $7UQrl.printScript)([
        $635d7cc412152f53$export$ede93d4564eaa8da.toString(),
        $635d7cc412152f53$export$96a3cfb3a41e9bb2.toString(),
        functionCall
    ]);
};
const $635d7cc412152f53$export$de7c49925e44d75d = (identifier, dataURI, dimensions, error)=>({
        dangerouslySetInnerHTML: {
            __html: $635d7cc412152f53$var$generateScript(identifier, dataURI, dimensions, error)
        }
    });

});
parcelRegister("7UQrl", function(module, exports) {

$parcel$export(module.exports, "printFunctionCall", () => $9e4757ccfa33a587$export$3742967cc82ac85a);
$parcel$export(module.exports, "printScript", () => $9e4757ccfa33a587$export$8b902fb69a2f17c1);
const $9e4757ccfa33a587$var$printParam = (param)=>{
    if (typeof param === 'string') return `'${param}'`;
    else if (typeof param === 'object') return JSON.stringify(param);
    else if (param === undefined) return 'undefined';
    return param;
};
const $9e4757ccfa33a587$var$printParams = (args)=>args.map((arg)=>$9e4757ccfa33a587$var$printParam(arg)).join(',');
const $9e4757ccfa33a587$export$3742967cc82ac85a = (fn, ...args)=>`(${fn.toString()})(${$9e4757ccfa33a587$var$printParams(args)});`;
const $9e4757ccfa33a587$export$8b902fb69a2f17c1 = (statements)=>`(function(){
  ${statements.join(';')}
})();
`;

});


parcelRegister("6tTCR", function(module, exports) {

$parcel$export(module.exports, "getSSRData", () => $88c51d281a1c15e7$export$d3a890b0f7844b6f);

var $862c0 = parcelRequire("862c0");
const $88c51d281a1c15e7$export$d3a890b0f7844b6f = (identifier)=>{
    const mediaCardSsr = (0, $862c0.getMediaCardSSR)();
    if (!mediaCardSsr) return;
    return mediaCardSsr[(0, $862c0.getKey)(identifier)];
};

});

parcelRegister("2GnF5", function(module, exports) {

$parcel$export(module.exports, "isBigger", () => $0956df2291cfa61d$export$912a00e9a5470d9a);
$parcel$export(module.exports, "createRequestDimensions", () => $0956df2291cfa61d$export$3063221e86a58f9);
$parcel$export(module.exports, "useCurrentValueRef", () => $0956df2291cfa61d$export$b3e10e1f0fbb71db);

var $eUqFw = parcelRequire("eUqFw");
const $0956df2291cfa61d$export$912a00e9a5470d9a = (current, next)=>{
    const { width: currentWidth, height: currentHeight } = current || {};
    const { width: nextWidth, height: nextHeight } = next || {};
    if (!!currentWidth && !!currentHeight && !!nextWidth && !!nextHeight) {
        const nextIsWider = currentWidth < nextWidth;
        const nextIsHigher = currentHeight < nextHeight;
        return nextIsHigher || nextIsWider;
    } else return false;
};
/** Verifies if the current screen is retina display */ function $0956df2291cfa61d$var$isRetina() {
    const mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';
    return window.devicePixelRatio > 1 || window.matchMedia && window.matchMedia(mediaQuery).matches;
}
const $0956df2291cfa61d$export$3063221e86a58f9 = (dimensions)=>{
    if (!dimensions) return;
    const retinaFactor = $0956df2291cfa61d$var$isRetina() ? 2 : 1;
    const { width: width, height: height } = dimensions;
    const result = {};
    if (width) result.width = width * retinaFactor;
    if (height) result.height = height * retinaFactor;
    return result;
};
function $0956df2291cfa61d$export$b3e10e1f0fbb71db(value) {
    const ref = (0, $eUqFw.useRef)(value);
    ref.current = value;
    return ref;
}

});







parcelRegister("fJdfC", function(module, exports) {

$parcel$export(module.exports, "EditMessage", () => $a017129fc788b1f8$export$1951eb47789629cd);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $aUqTb = parcelRequire("aUqTb");

var $blejQ = parcelRequire("blejQ");

var $PdmhA = parcelRequire("PdmhA");
const $a017129fc788b1f8$export$1951eb47789629cd = (props)=>{
    const renderMessage = (message, index)=>{
        switch(message.label){
            case 'warning':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a017129fc788b1f8$var$MessageContainer, {
                    key: index
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($blejQ))), {
                    label: "warning",
                    primaryColor: `var(--ds-icon-warning, ${(0, $PdmhA).Y300})`
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a017129fc788b1f8$var$Message, null, message.messageContent));
            case 'info':
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a017129fc788b1f8$var$MessageContainer, {
                    key: index
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aUqTb))), {
                    label: "info"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a017129fc788b1f8$var$Message, null, message.messageContent));
            default:
                return undefined;
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, props.messages.map(renderMessage));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a017129fc788b1f8$var$MessageContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1thw _1e0c1txw _4cvr1h6o _1wyb1skh _vwz41cnx",
            __cmplp.className
        ])
    });
});
const $a017129fc788b1f8$var$Message = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("blejQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $841cc35b0ae95138$var$_react = $841cc35b0ae95138$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $841cc35b0ae95138$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $841cc35b0ae95138$var$EditorWarningIcon = (props)=>/*#__PURE__*/ $841cc35b0ae95138$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M13.31 5.343l7.359 13.17A1 1 0 0119.796 20H4.204a1 1 0 01-.873-1.488l7.36-13.169a1.5 1.5 0 012.618 0zM12 8.5a1.091 1.091 0 00-1.081 1.239l.513 3.766a.573.573 0 001.136 0l.513-3.766A1.091 1.091 0 0012 8.5zm0 8.63a1.125 1.125 0 100-2.25 1.125 1.125 0 000 2.25z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$841cc35b0ae95138$var$EditorWarningIcon.displayName = 'EditorWarningIcon';
var $841cc35b0ae95138$var$_default = $841cc35b0ae95138$var$EditorWarningIcon;
module.exports.default = $841cc35b0ae95138$var$_default;

});


parcelRegister("45iG4", function(module, exports) {

$parcel$export(module.exports, "default", () => $70ba4f0807f800c3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $70ba4f0807f800c3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    searchPlaceholder: {
        "id": "servicedesk-cmdb-field-object-picker.search-placeholder",
        "defaultMessage": "Select or search for objects"
    },
    errorTitleCmdbAssets: {
        "id": "servicedesk-cmdb-field-object-picker.error-title-cmdb-assets",
        "defaultMessage": "Could not fetch Assets objects"
    },
    errorMessage: {
        "id": "servicedesk-cmdb-field-object-picker.error-message",
        "defaultMessage": "Please refresh the page and try again"
    },
    errorTitleCmdbFieldSearch: {
        "id": "servicedesk-cmdb-field-object-picker.error-title-cmdb-field-search",
        "defaultMessage": "We couldn't fetch any objects for this field"
    },
    errorMessageCmdbFieldSearch: {
        "id": "servicedesk-cmdb-field-object-picker.error-message-cmdb-field-search",
        "defaultMessage": "Remove attributes that no longer exist in the Assets Custom field configuration filter, and ensure the AQL query is valid."
    },
    infoSingleObjectMessage: {
        "id": "servicedesk-cmdb-field-object-picker.info-single-object-message",
        "defaultMessage": "This field can only store a single object"
    },
    warningMultipleObjectsMessage: {
        "id": "servicedesk-cmdb-field-object-picker.warning-multiple-objects-message",
        "defaultMessage": "This field is configured to store a single object. Remove some objects to save changes."
    },
    infoObjectLimitReached: {
        "id": "servicedesk-cmdb-field-object-picker.info-object-limit-reached",
        "defaultMessage": "This field can only store {objectLimit, plural, one {# object} other {# objects}}."
    },
    warningObjectLimitExceeded: {
        "id": "servicedesk-cmdb-field-object-picker.warning-object-limit-exceeded",
        "defaultMessage": "This field is configured to store {objectLimit, plural, one {# object} other {# objects}}. Remove some objects to save changes."
    },
    dropdownNumberOfSearchResultsLabel: {
        "id": "servicedesk-cmdb-field-object-picker.dropdown-number-of-search-results-label",
        "defaultMessage": "{numberOfSearchResults} search {numberOfSearchResults, plural, one {result} other {results}} {isLoading, select, true {(refreshing)} other {}}"
    }
});

});

parcelRegister("4bK0l", function(module, exports) {

$parcel$export(module.exports, "customStyles", () => $b28ded684b662b54$export$edf5b2501a573922);

var $c9TLT = parcelRequire("c9TLT");
const $b28ded684b662b54$export$edf5b2501a573922 = {
    menu: (base)=>({
            ...base,
            zIndex: (0, $c9TLT.layers).modal
        }),
    menuPortal: (base)=>({
            ...base,
            zIndex: (0, $c9TLT.layers).modal
        })
};

});


parcelRegister("53c4R", function(module, exports) {

$parcel$export(module.exports, "MAX_AUTOMATION_RULES_PER_SD", () => $d0467ae3b0b1cf99$export$dca2c2105b681490);
$parcel$export(module.exports, "MAX_AUTOMATION_BRANCHES_PER_RULE", () => $d0467ae3b0b1cf99$export$a48ac34d39e0fc22);
$parcel$export(module.exports, "MAX_QUEUES_PER_SD", () => $d0467ae3b0b1cf99$export$2e0ba662d5bb7742);
$parcel$export(module.exports, "MAX_SLA_GOALS_PER_SD", () => $d0467ae3b0b1cf99$export$eb69982aa3a172b4);
$parcel$export(module.exports, "MAX_CMDB_OBJECTS_PER_FIELD", () => $d0467ae3b0b1cf99$export$cb3888a8c43147d2);
$parcel$export(module.exports, "MAX_NUM_TEAM_PRIORITY_QUEUES_PER_SD", () => $d0467ae3b0b1cf99$export$801a603585fb94d8);
$parcel$export(module.exports, "LIMIT_DEFAULTS", () => $d0467ae3b0b1cf99$export$5ed1d2ac050e39d);
$parcel$export(module.exports, "getLimit", () => $d0467ae3b0b1cf99$export$fb8ce379717a383d);
$parcel$export(module.exports, "LimitData", () => $d0467ae3b0b1cf99$export$9989835030ecd317);
$parcel$export(module.exports, "withLimitData", () => $d0467ae3b0b1cf99$export$c5d8aa8a650e690f);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $2OdyW = parcelRequire("2OdyW");
const $d0467ae3b0b1cf99$export$dca2c2105b681490 = 'max_automation_rules_per_sd';
const $d0467ae3b0b1cf99$export$a48ac34d39e0fc22 = 'max_automation_branches_per_rule';
const $d0467ae3b0b1cf99$export$2e0ba662d5bb7742 = 'max_queues_per_sd';
const $d0467ae3b0b1cf99$export$eb69982aa3a172b4 = 'max_sla_goals_per_sd';
const $d0467ae3b0b1cf99$export$cb3888a8c43147d2 = 'max_cmdb_objects_per_field';
const $d0467ae3b0b1cf99$export$801a603585fb94d8 = 'max_num_team_priority_queues_per_sd';
const $d0467ae3b0b1cf99$export$5ed1d2ac050e39d = {
    [$d0467ae3b0b1cf99$export$dca2c2105b681490]: 30,
    [$d0467ae3b0b1cf99$export$a48ac34d39e0fc22]: 30,
    [$d0467ae3b0b1cf99$export$2e0ba662d5bb7742]: 300,
    [$d0467ae3b0b1cf99$export$eb69982aa3a172b4]: 30,
    [$d0467ae3b0b1cf99$export$cb3888a8c43147d2]: 20,
    [$d0467ae3b0b1cf99$export$801a603585fb94d8]: 50
};
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $d0467ae3b0b1cf99$var$limitCache = {};
const $d0467ae3b0b1cf99$export$c419786abd6faaad = (limitProperty)=>{
    delete $d0467ae3b0b1cf99$var$limitCache[limitProperty];
};
const $d0467ae3b0b1cf99$export$fb8ce379717a383d = (limitProperty)=>{
    if (!$d0467ae3b0b1cf99$var$limitCache[limitProperty]) $d0467ae3b0b1cf99$var$limitCache[limitProperty] = (0, $2OdyW.default)(`/rest/servicedesk/latest/limit/${limitProperty}?_=${Date.now()}`).then(({ limit: limit })=>limit, (error)=>{
        // Will allow us to try again to fetch limit
        $d0467ae3b0b1cf99$export$c419786abd6faaad(limitProperty);
        (0, $gUUjF.default).safeWarnWithoutCustomerData('servicedesk.common.view.components.limit-data', `Failed to fetch limit for ${limitProperty}`);
        throw error;
    });
    return $d0467ae3b0b1cf99$var$limitCache[limitProperty];
};
class $d0467ae3b0b1cf99$export$9989835030ecd317 extends (0, $eUqFw.Component) {
    componentDidMount() {
        const { limitProperty: limitProperty } = this.props;
        const defaultLimit = $d0467ae3b0b1cf99$export$5ed1d2ac050e39d[limitProperty];
        $d0467ae3b0b1cf99$export$fb8ce379717a383d(limitProperty).then((limit)=>{
            this.updateLimit(limit || defaultLimit);
        }).catch(()=>{
            this.updateLimit(defaultLimit);
        });
    }
    updateLimit(newLimit) {
        this.setState(({ limit: oldLimit })=>oldLimit !== newLimit ? {
                limit: newLimit
            } : undefined);
    }
    render() {
        return this.props.children(this.state.limit);
    }
    constructor(...args){
        super(...args);
        this.state = {
            // Current consumers of LimitData expect typeof number so this cannot be an empty value.
            // This also voids limit messages showing until we have a reliable limit,
            // instead of showing then changing the value
            limit: Infinity
        };
    }
}
const $d0467ae3b0b1cf99$export$c5d8aa8a650e690f = (limitProperty, WrappedComponent)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d0467ae3b0b1cf99$export$9989835030ecd317, {
            limitProperty: limitProperty
        }, (limit)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
                limit: limit,
                ...props
            }));

});


parcelRegister("5hGgp", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e713717cf425e6d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7SFgg = parcelRequire("7SFgg");

var $lPQPn = parcelRequire("lPQPn");

var $6HoNR = parcelRequire("6HoNR");

var $j0x3u = parcelRequire("j0x3u");
const $7e713717cf425e6d$var$ColorPickerField = (props)=>{
    const { fieldProps: { value: value, onChange: onChange } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7SFgg.ColorPicker), {
        value: value,
        onChange: onChange,
        showColorName: true
    });
};
var $7e713717cf425e6d$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    transformDefaultValue: (0, $lPQPn.asColor)
})($7e713717cf425e6d$var$ColorPickerField);

});
parcelRegister("7SFgg", function(module, exports) {

$parcel$export(module.exports, "ColorPicker", () => $6b809ba85cd965e0$export$9feb1bc2e5f1ccb3);
$parcel$export(module.exports, "ColorPickerWrapper", () => $6b809ba85cd965e0$export$3144fa159460e52e);
$parcel$export(module.exports, "ColorName", () => $6b809ba85cd965e0$export$93f3fcc778132720);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $01F0p = parcelRequire("01F0p");

var $4ksts = parcelRequire("4ksts");

var $tgbCK = parcelRequire("tgbCK");

var $QcW4I = parcelRequire("QcW4I");

var $dUhk8 = parcelRequire("dUhk8");
const $6b809ba85cd965e0$var$popperProps = {
    strategy: 'fixed',
    modifiers: [
        {
            name: 'offset',
            options: {
                offset: [
                    -10,
                    5
                ]
            }
        }
    ]
};
const $6b809ba85cd965e0$export$9feb1bc2e5f1ccb3 = ({ value: color, showColorName: showColorName, onChange: onChange })=>{
    const intl = (0, $4ksts.useIntlV2)();
    const colorPalette = (0, $QcW4I.getI18nColorPalette)(intl);
    const colorString = (0, $tgbCK.MAP_COLORS_TO_VALUE)[color];
    const maybeColorLabel = colorPalette.filter((pcol)=>pcol.value === colorString)[0];
    const colorLabel = maybeColorLabel && maybeColorLabel.label || '';
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onChangeHandler = (changedTo)=>{
        // changedTo is a CSS value string like '#FF7452', so we have to map it back to Color
        onChange((0, $tgbCK.MAP_VALUE_TO_COLOR)[changedTo]);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6b809ba85cd965e0$export$3144fa159460e52e, {
        "data-testid": (0, $QcW4I.colorFieldDataTestId)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $01F0p.default), {
        label: intl.formatMessage((0, $dUhk8.default).label),
        palette: colorPalette,
        selectedColor: colorString,
        cols: colorPalette.length / 2,
        onChange: onChangeHandler,
        popperProps: $6b809ba85cd965e0$var$popperProps
    }), showColorName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6b809ba85cd965e0$export$93f3fcc778132720, null, colorLabel));
};
var $6b809ba85cd965e0$export$2e2bcd8739ae039 // Move 2px to the left to align with other components
 = $6b809ba85cd965e0$export$9feb1bc2e5f1ccb3;
const $6b809ba85cd965e0$export$3144fa159460e52e = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o _18u01i6y _ca0qu2gc _u5f3u2gc _4t3izwfg _z29hglyw",
            __cmplp.className
        ])
    });
});
$6b809ba85cd965e0$export$3144fa159460e52e.displayName = 'ColorPickerWrapper'; // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $6b809ba85cd965e0$export$93f3fcc778132720 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s84w17",
            __cmplp.className
        ])
    });
});
$6b809ba85cd965e0$export$93f3fcc778132720.displayName = 'ColorName';

});
parcelRegister("01F0p", function(module, exports) {

$parcel$export(module.exports, "Compact", () => $e0f2aa3037ee4cdc$export$6479582a9c9e50ce);
$parcel$export(module.exports, "default", () => $e0f2aa3037ee4cdc$export$2e2bcd8739ae039);
$parcel$export(module.exports, "ColorPaletteMenu", () => (parcelRequire("cu9kj")).default);

var $jx7pE = parcelRequire("jx7pE");

var $dUxck = parcelRequire("dUxck");

var $cu9kj = parcelRequire("cu9kj");
const { Compact: $e0f2aa3037ee4cdc$export$6479582a9c9e50ce, Standard: $e0f2aa3037ee4cdc$export$d5a1f56087d42b19 } = (0, $dUxck.Mode);
var $e0f2aa3037ee4cdc$export$2e2bcd8739ae039 = (0, $jx7pE.default);

});
parcelRegister("jx7pE", function(module, exports) {

$parcel$export(module.exports, "default", () => $beb72bcd9e150791$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $l44HT = parcelRequire("l44HT");

var $85AtA = parcelRequire("85AtA");

var $k8uYo = parcelRequire("k8uYo");


var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $c0Y4D = parcelRequire("c0Y4D");

var $byn9U = parcelRequire("byn9U");

var $2qhQi = parcelRequire("2qhQi");

var $jiLMl = parcelRequire("jiLMl");
function $beb72bcd9e150791$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $beb72bcd9e150791$var$defaultPopperProps = {
    strategy: 'fixed',
    modifiers: [
        {
            name: 'offset',
            options: {
                offset: [
                    0,
                    8
                ]
            }
        }
    ],
    placement: 'bottom-start'
};
const $beb72bcd9e150791$var$packageName = undefined;
const $beb72bcd9e150791$var$packageVersion = undefined;
class $beb72bcd9e150791$var$ColorPickerWithoutAnalyticsBase extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { palette: palette, selectedColor: selectedColor, checkMarkColor: checkMarkColor, cols: cols, popperProps: popperProps = $beb72bcd9e150791$var$defaultPopperProps, label: label = 'Color picker', selectedColourSwatchSize: selectedColourSwatchSize, showDefaultSwatchColor: showDefaultSwatchColor = true, isDisabledSelectedSwatch: isDisabledSelectedSwatch, intl: intl } = this.props;
        const { options: options, value: value } = (0, $c0Y4D.getOptions)(palette, selectedColor, showDefaultSwatchColor);
        const fullLabel = this.getFullLabel(intl, value, label);
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $l44HT.default), {
            target: ({ ref: ref, isOpen: isOpen })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
                    css: $beb72bcd9e150791$var$colorCardWrapperStyles,
                    ref: ref
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $85AtA.default), {
                    ...value,
                    label: fullLabel,
                    expanded: isOpen,
                    swatchSize: selectedColourSwatchSize,
                    isDisabled: isDisabledSelectedSwatch
                })),
            popperProps: popperProps,
            maxMenuWidth: "auto",
            minMenuWidth: "auto",
            options: options,
            "aria-label": fullLabel,
            value: value,
            components: $k8uYo,
            onChange: this.onChangeSelect,
            // never show search input
            searchThreshold: Number.MAX_VALUE,
            // palette props
            cols: cols,
            checkMarkColor: checkMarkColor,
            onKeyDown: this.onKeyDown,
            isTabbing: this.state.isTabbing,
            onOptionKeyDown: this.onOptionKeyDown
        });
    }
    constructor(...args){
        super(...args);
        this.createAndFireEventOnAtlaskit = (0, $hM7RE.default)('atlaskit');
        this.state = {
            isTabbing: false
        };
        this.changeAnalyticsCaller = ()=>{
            const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
            if (createAnalyticsEvent) return this.createAndFireEventOnAtlaskit({
                action: 'clicked',
                actionSubject: 'color-picker',
                attributes: {
                    componentName: 'color-picker',
                    packageName: $beb72bcd9e150791$var$packageName,
                    packageVersion: $beb72bcd9e150791$var$packageVersion
                }
            })(createAnalyticsEvent);
            return undefined;
        };
        this.onChangeSelect = (option)=>{
            this.props.onChange(option.value, this.changeAnalyticsCaller());
        };
        this.onOptionKeyDown = (value)=>{
            this.props.onChange(value, this.changeAnalyticsCaller());
        };
        this.onKeyDown = (e)=>{
            const key = e.key;
            if (key === (0, $5094de7401eea7ba$export$10f6869ed0a7d75b)) this.setState({
                isTabbing: true
            });
            else if (key === (0, $5094de7401eea7ba$export$b34c7ae3fd8138d2) || key === (0, $5094de7401eea7ba$export$1734a06b2397c2a8)) this.setState({
                isTabbing: false
            });
            else if (key === 'Escape') e.stopPropagation();
        };
        this.getFullLabel = (intl, value, label)=>{
            if (value && value.label) return intl.formatMessage((0, $jiLMl.default).colorPickerAriaLabel, {
                color: value.label,
                message: label
            });
            else return label;
        };
    }
}
const $beb72bcd9e150791$export$2fcf66ed38ff3cf5 = (0, $2qhQi.default)($beb72bcd9e150791$var$ColorPickerWithoutAnalyticsBase);
var $beb72bcd9e150791$export$2e2bcd8739ae039 = (0, $1ngde.default)({
    componentName: 'color-picker',
    packageName: $beb72bcd9e150791$var$packageName,
    packageVersion: $beb72bcd9e150791$var$packageVersion
})((0, $2jDha.default)()($beb72bcd9e150791$export$2fcf66ed38ff3cf5));
const $beb72bcd9e150791$var$colorCardWrapperStyles = {
    name: "1r5gb7q",
    styles: "display:inline-block"
};

});
parcelRegister("85AtA", function(module, exports) {

$parcel$export(module.exports, "default", () => $3225ae62471df5f8$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
function $3225ae62471df5f8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3225ae62471df5f8$var$ColorCard = ({ value: value, label: label, expanded: expanded, onClick: onClick, swatchSize: swatchSize = 'default', isDisabled: isDisabled })=>{
    const handleMouseDown = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
    }, []);
    const handleClick = (0, $eUqFw.useCallback)((event)=>{
        event.currentTarget.focus();
        if (onClick) {
            event.preventDefault();
            onClick();
        }
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cU5f.default), {
        content: label
    }, /*#__PURE__*/ (0, $byn9U.jsx)("button", {
        css: [
            $3225ae62471df5f8$var$sharedColorContainerStyles,
            swatchSize === 'small' ? $3225ae62471df5f8$var$smallColorContainerSize : $3225ae62471df5f8$var$defaultColorContainerSize,
            $3225ae62471df5f8$var$colorCardButtonStyles,
            expanded && $3225ae62471df5f8$var$colorCardButtonFocusedStyles
        ],
        disabled: isDisabled,
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        "aria-label": label,
        "aria-expanded": expanded,
        "aria-haspopup": true,
        type: "button"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $3225ae62471df5f8$var$colorCardWrapperStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            $3225ae62471df5f8$var$colorCardContentStyles,
            swatchSize === 'small' ? $3225ae62471df5f8$var$smallColorCardContentSize : $3225ae62471df5f8$var$defaultColorCardContentSize
        ],
        style: {
            background: value || 'transparent'
        }
    }))));
};
var $3225ae62471df5f8$export$2e2bcd8739ae039 = $3225ae62471df5f8$var$ColorCard;
const $3225ae62471df5f8$var$sharedColorContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-block',
    position: 'relative',
    border: '2px solid transparent',
    boxSizing: 'border-box',
    borderRadius: '6px',
    transition: 'border-color 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
    backgroundColor: `var(--ds-background-neutral-subtle, ${(0, $PdmhA.N0)})`,
    borderColor: `var(--ds-background-neutral-subtle, ${(0, $PdmhA.N0)})`,
    padding: "var(--ds-space-0, 0px)",
    cursor: 'pointer',
    outline: 'none'
});
const $3225ae62471df5f8$var$smallColorContainerSize = {
    name: "1435ao5",
    styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px);top:var(--ds-space-negative-025, -2px)"
};
const $3225ae62471df5f8$var$defaultColorContainerSize = {
    name: "1uafl10",
    styles: "width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px)"
};
const $3225ae62471df5f8$var$colorCardButtonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        borderColor: `var(--ds-background-neutral-subtle, ${(0, $PdmhA.N0)})`
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':not(:focus):hover, :focus': {
        borderColor: `var(--ds-border-focused, ${(0, $PdmhA.B100)})`,
        outline: 'none'
    }
});
const $3225ae62471df5f8$var$colorCardButtonFocusedStyles = /*#__PURE__*/ (0, $byn9U.css)({
    borderColor: `var(--ds-border-focused, ${(0, $PdmhA.B100)})`,
    outline: 'none'
});
const $3225ae62471df5f8$var$colorCardWrapperStyles = {
    name: "10qlvma",
    styles: "width:100%;height:100%;display:flex;align-items:center;justify-content:center"
};
const $3225ae62471df5f8$var$colorCardContentStyles = /*#__PURE__*/ (0, $byn9U.css)({
    borderRadius: "var(--ds-border-radius-100, 3px)",
    boxShadow: `inset 0px 0px 0px 1px ${`var(--ds-background-inverse-subtle, ${(0, $PdmhA.DN600A)})`}`
});
const $3225ae62471df5f8$var$smallColorCardContentSize = {
    name: "1rrhp72",
    styles: "width:var(--ds-space-200, 16px);height:var(--ds-space-200, 16px)"
};
const $3225ae62471df5f8$var$defaultColorCardContentSize = {
    name: "ljflj6",
    styles: "width:var(--ds-space-300, 24px);height:var(--ds-space-300, 24px)"
};

});

parcelRegister("k8uYo", function(module, exports) {

$parcel$export(module.exports, "MenuList", () => $1392b51a14debfe3$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "Option", () => $1392b51a14debfe3$export$36d18380658d5d20);
$parcel$export(module.exports, "DropdownIndicator", () => $1392b51a14debfe3$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "Placeholder", () => $1392b51a14debfe3$export$84712d0562a614b8);
/** @jsx jsx */ 
var $158Fh = parcelRequire("158Fh");

var $c0Y4D = parcelRequire("c0Y4D");

var $byn9U = parcelRequire("byn9U");
function $1392b51a14debfe3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1392b51a14debfe3$export$d4c4e98c5044dc8 = (props)=>{
    const { selectProps: { cols: cols }, innerRef: innerRef, children: children } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $1392b51a14debfe3$var$colorPaletteContainerStyles,
        role: "radiogroup",
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            maxWidth: cols ? (0, $c0Y4D.getWidth)(cols) : undefined
        },
        ref: innerRef
    }, children);
};
const $1392b51a14debfe3$export$36d18380658d5d20 = (props)=>{
    const { data: { value: value, label: label }, selectProps: { checkMarkColor: checkMarkColor, onOptionKeyDown: onOptionKeyDown, isTabbing: isTabbing }, isFocused: isFocused, isSelected: isSelected, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $1392b51a14debfe3$var$colorCardWrapperStyles,
        ...innerProps
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $158Fh.default), {
        label: label,
        value: value,
        checkMarkColor: checkMarkColor,
        isOption: true,
        focused: isFocused,
        selected: isSelected,
        onKeyDown: (value)=>onOptionKeyDown(value),
        isTabbing: isTabbing
    }));
};
const $1392b51a14debfe3$export$ec98719d3db7f2e4 = ()=>null;
const $1392b51a14debfe3$export$84712d0562a614b8 = ()=>null;
const $1392b51a14debfe3$var$colorCardWrapperStyles = {
    name: "yotnll",
    styles: "display:flex;margin:var(--ds-space-025, 2px);height:var(--ds-space-400, 32px)"
};
const $1392b51a14debfe3$var$colorPaletteContainerStyles = {
    name: "4t056h",
    styles: "display:flex;flex-wrap:wrap;padding:var(--ds-space-050, 4px)"
};

});
parcelRegister("158Fh", function(module, exports) {

$parcel$export(module.exports, "default", () => $a35978981991cf34$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $k9Z3M = parcelRequire("k9Z3M");

var $8cU5f = parcelRequire("8cU5f");


var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $XHGTv = parcelRequire("XHGTv");

var $jaTu3 = parcelRequire("jaTu3");
function $a35978981991cf34$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a35978981991cf34$var$ColorCard = (props)=>{
    const { value: value, label: label, selected: selected, focused: focused, checkMarkColor: checkMarkColor = (0, $PdmhA.N0), isTabbing: isTabbing, onClick: onClick, onKeyDown: onKeyDown } = props;
    const ref = (0, $eUqFw.useRef)(null);
    const handleMouseDown = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
    }, []);
    const handleClick = (0, $eUqFw.useCallback)((event)=>{
        if (onClick) {
            event.preventDefault();
            onClick(value);
        }
    }, [
        onClick,
        value
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        const { key: key } = event;
        if ((isTabbing === undefined || isTabbing) && onKeyDown && (key === (0, $5094de7401eea7ba$export$8152f929a25a0ff4) || key === (0, $5094de7401eea7ba$export$e51a3576c045c8d5))) {
            event.preventDefault();
            if (isTabbing) event.stopPropagation();
            onKeyDown(value);
        }
    }, [
        isTabbing,
        onKeyDown,
        value
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const refCurrent = ref.current;
        const handleKeyDown = (e)=>{
            if (e.key === 'Tab') {
                e.stopPropagation();
                e.preventDefault();
            }
        };
        refCurrent?.addEventListener('keydown', handleKeyDown);
        return ()=>{
            refCurrent?.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cU5f.default), {
        content: label
    }, (0, $XHGTv.getBooleanFF)('platform.jca11y-2997-remove-duplicate-screen-reader-announcements_fz13s') ? (tooltipProps)=>{
        delete tooltipProps['aria-describedby'];
        return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            ...tooltipProps,
            css: [
                $a35978981991cf34$var$sharedColorContainerStyles,
                (isTabbing === undefined || isTabbing) && $a35978981991cf34$var$colorCardOptionTabbingStyles,
                focused && !isTabbing && $a35978981991cf34$var$colorCardOptionFocusedStyles
            ],
            onClick: handleClick,
            onMouseDown: handleMouseDown,
            onKeyDown: handleKeyDown,
            role: "radio",
            "aria-checked": selected,
            "aria-label": label,
            tabIndex: 0,
            ref: (0, $jaTu3.mergeRefs)([
                ref,
                tooltipProps.ref
            ])
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $a35978981991cf34$var$colorCardWrapperStyles
        }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $a35978981991cf34$var$colorCardContentStyles,
            style: {
                background: value || 'transparent'
            }
        }, selected && /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $a35978981991cf34$var$colorCardContentCheckMarkStyles
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($k9Z3M))), {
            primaryColor: checkMarkColor,
            label: ""
        })))));
    } : /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $a35978981991cf34$var$sharedColorContainerStyles,
            (isTabbing === undefined || isTabbing) && $a35978981991cf34$var$colorCardOptionTabbingStyles,
            focused && !isTabbing && $a35978981991cf34$var$colorCardOptionFocusedStyles
        ],
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        onKeyDown: handleKeyDown,
        role: "radio",
        "aria-checked": selected,
        "aria-label": label,
        tabIndex: 0,
        ref: ref
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $a35978981991cf34$var$colorCardWrapperStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $a35978981991cf34$var$colorCardContentStyles,
        style: {
            background: value || 'transparent'
        }
    }, selected && /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $a35978981991cf34$var$colorCardContentCheckMarkStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($k9Z3M))), {
        primaryColor: checkMarkColor,
        label: ""
    }))))));
};
var $a35978981991cf34$export$2e2bcd8739ae039 = $a35978981991cf34$var$ColorCard;
const $a35978981991cf34$var$colorCardOptionTabbingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover, :focus': {
        borderColor: `var(--ds-border-focused, ${(0, $PdmhA.B75)})`
    }
});
const $a35978981991cf34$var$colorCardOptionFocusedStyles = /*#__PURE__*/ (0, $byn9U.css)({
    borderColor: `var(--ds-border-focused, ${(0, $PdmhA.B75)})`
});
const $a35978981991cf34$var$colorCardContentCheckMarkStyles = {
    name: "gyevkv",
    styles: "margin:1px"
};
const $a35978981991cf34$var$sharedColorContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-block',
    position: 'relative',
    width: "var(--ds-space-400, 32px)",
    height: "var(--ds-space-400, 32px)",
    border: '2px solid transparent',
    boxSizing: 'border-box',
    borderRadius: "var(--ds-border-radius-200, 6px)",
    transition: 'border-color 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
    backgroundColor: `var(--ds-background-neutral-subtle, ${(0, $PdmhA.N0)})`,
    borderColor: `var(--ds-background-neutral-subtle, ${(0, $PdmhA.N0)})`,
    padding: "var(--ds-space-0, 0px)",
    cursor: 'pointer',
    outline: 'none'
});
const $a35978981991cf34$var$colorCardWrapperStyles = {
    name: "10qlvma",
    styles: "width:100%;height:100%;display:flex;align-items:center;justify-content:center"
};
const $a35978981991cf34$var$colorCardContentStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: "var(--ds-space-300, 24px)",
    height: "var(--ds-space-300, 24px)",
    borderRadius: "var(--ds-border-radius-100, 3px)",
    boxShadow: `inset 0px 0px 0px 1px ${`var(--ds-background-inverse-subtle, ${(0, $PdmhA.DN600A)})`}`
});

});
const $5094de7401eea7ba$export$64c9b8c6e6a2c6ac = 32;
const $5094de7401eea7ba$export$e51a3576c045c8d5 = ' ';
const $5094de7401eea7ba$export$8152f929a25a0ff4 = 'Enter';
const $5094de7401eea7ba$export$b34c7ae3fd8138d2 = 'ArrowDown';
const $5094de7401eea7ba$export$1734a06b2397c2a8 = 'ArrowUp';
const $5094de7401eea7ba$export$10f6869ed0a7d75b = 'Tab';

parcelRegister("jaTu3", function(module, exports) {

$parcel$export(module.exports, "mergeRefs", () => $df59fd64c73fe87e$export$c9058316764c140e);

var $iYh9J = parcelRequire("iYh9J");

var $37WxO = parcelRequire("37WxO");
function $df59fd64c73fe87e$export$c9058316764c140e(refs) {
    return (0, $37WxO.createCallbackRef)((newValue)=>refs.forEach((ref)=>(0, $iYh9J.assignRef)(ref, newValue)));
}

});
parcelRegister("37WxO", function(module, exports) {

$parcel$export(module.exports, "createCallbackRef", () => $246f7040b169dc51$export$35a19128eb4acba4);
/**
 * creates a Ref object with on change callback
 * @param callback
 * @returns {RefObject}
 *
 * @see {@link useCallbackRef}
 * @see https://reactjs.org/docs/refs-and-the-dom.html#creating-refs
 */ function $246f7040b169dc51$export$35a19128eb4acba4(callback) {
    let current = null;
    return {
        get current () {
            return current;
        },
        set current (value){
            const last = current;
            if (last !== value) {
                current = value;
                callback(value, last);
            }
        }
    };
}

});



parcelRegister("c0Y4D", function(module, exports) {

$parcel$export(module.exports, "getWidth", () => $b46f108815c58f3f$export$3c49c185de0c2bfc);
$parcel$export(module.exports, "getOptions", () => $b46f108815c58f3f$export$d2312e68e1f5ad00);
// AFP-2532 TODO: Fix automatic suppressions below
// eslint-disable-next-line @atlassian/tangerine/import/entry-points

var $lcnyw = parcelRequire("lcnyw");


var $5iWql = parcelRequire("5iWql");

var $dUxck = parcelRequire("dUxck");
const $b46f108815c58f3f$export$3c49c185de0c2bfc = (cols, mode)=>{
    const width = cols * ((0, $5094de7401eea7ba$export$64c9b8c6e6a2c6ac) + (0, $lcnyw.gridSize)() / 2);
    return mode === (0, $dUxck.Mode).Standard ? width + (0, $lcnyw.gridSize)() : width;
};
const $b46f108815c58f3f$export$d2312e68e1f5ad00 = (0, $5iWql.default)((palette, selectedColor, showDefaultSwatchColor)=>{
    let focusedItemIndex = 0;
    let defaultSelectedColor = palette[0];
    if (!showDefaultSwatchColor) defaultSelectedColor = {
        label: '',
        value: ''
    };
    const value = palette.find((color, index)=>{
        if (color.value === selectedColor) {
            focusedItemIndex = index;
            return true;
        }
        return false;
    }) || defaultSelectedColor;
    return {
        options: palette,
        value: value,
        focusedItemIndex: focusedItemIndex
    };
});

});
parcelRegister("dUxck", function(module, exports) {

$parcel$export(module.exports, "Mode", () => $53c487a191c92002$export$9484bbecc3c49a2e);
var $53c487a191c92002$export$9484bbecc3c49a2e;
(function(Mode) {
    Mode[Mode["Compact"] = 0] = "Compact";
    Mode[Mode["Standard"] = 1] = "Standard";
})($53c487a191c92002$export$9484bbecc3c49a2e || ($53c487a191c92002$export$9484bbecc3c49a2e = {}));

});



parcelRegister("jiLMl", function(module, exports) {

$parcel$export(module.exports, "default", () => $403c80e207605265$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $403c80e207605265$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    colorPickerAriaLabel: {
        id: 'jira.color-picker.src.color-picker-aria-label',
        defaultMessage: '{color} selected, {message}',
        description: 'This text is used as aria-label text in color picker component'
    }
});

});


parcelRegister("cu9kj", function(module, exports) {

$parcel$export(module.exports, "default", () => $f56609052bab10ee$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $dUxck = parcelRequire("dUxck");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $158Fh = parcelRequire("158Fh");

var $c0Y4D = parcelRequire("c0Y4D");

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
function $f56609052bab10ee$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f56609052bab10ee$export$4bbfe93c6a14e8e6 = ({ createAnalyticsEvent: createAnalyticsEvent, onChange: onChange, palette: palette, selectedColor: selectedColor, checkMarkColor: checkMarkColor, label: label = 'Color picker', cols: cols = 6, mode: mode = (0, $dUxck.Mode).Standard })=>{
    const createAndFireEventOnAtlaskit = (0, $hM7RE.default)('atlaskit');
    const changeAnalyticsCaller = ()=>{
        if (createAnalyticsEvent) return createAndFireEventOnAtlaskit({
            action: 'clicked',
            actionSubject: 'color-palette-menu',
            attributes: {
                componentName: 'color-picker',
                packageName: undefined,
                packageVersion: undefined
            }
        })(createAnalyticsEvent);
        return undefined;
    };
    const handleChange = (value)=>{
        onChange(value, changeAnalyticsCaller());
    };
    const { options: options, value: selectedValue } = (0, $c0Y4D.getOptions)(palette, selectedColor);
    const fullLabel = `${label}, ${selectedValue.label} selected`;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "aria-label": fullLabel,
        role: "radiogroup",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: [
            $f56609052bab10ee$var$colorPaletteMenuStyles,
            mode === (0, $dUxck.Mode).Standard && $f56609052bab10ee$var$colorPaletteMenuStandardStyles
        ],
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            width: `${(0, $c0Y4D.getWidth)(cols, mode)}px`
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $f56609052bab10ee$var$colorPaletteContainerStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            mode === (0, $dUxck.Mode).Compact && $f56609052bab10ee$var$colorPaletteContainerCompactStyles
        ]
    }, options.map(({ label: label, value: value })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $f56609052bab10ee$var$colorCardWrapperStyles,
            key: value
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $158Fh.default), {
            label: label,
            value: value,
            checkMarkColor: checkMarkColor,
            isOption: true,
            selected: value === selectedValue.value,
            onClick: handleChange,
            onKeyDown: handleChange
        })))));
};
var $f56609052bab10ee$export$2e2bcd8739ae039 = (0, $1ngde.default)({
    componentName: 'color-picker',
    packageName: undefined,
    packageVersion: undefined
})((0, $2jDha.default)()($f56609052bab10ee$export$4bbfe93c6a14e8e6));
const $f56609052bab10ee$var$colorCardWrapperStyles = {
    name: "yotnll",
    styles: "display:flex;margin:var(--ds-space-025, 2px);height:var(--ds-space-400, 32px)"
};
const $f56609052bab10ee$var$colorPaletteContainerStyles = {
    name: "4t056h",
    styles: "display:flex;flex-wrap:wrap;padding:var(--ds-space-050, 4px)"
};
const $f56609052bab10ee$var$colorPaletteContainerCompactStyles = {
    name: "h6te2n",
    styles: "padding:var(--ds-space-0, 0)"
};
const $f56609052bab10ee$var$colorPaletteMenuStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    position: 'relative',
    margin: "var(--ds-space-0, 0)",
    backgroundColor: `var(--ds-surface-overlay, ${(0, $PdmhA.N0)})`
});
const $f56609052bab10ee$var$colorPaletteMenuStandardStyles = /*#__PURE__*/ (0, $byn9U.css)({
    borderRadius: "var(--ds-border-radius-100, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $PdmhA.N40)}, 0 0 8px ${(0, $PdmhA.N40)}`})`
});

});


parcelRegister("QcW4I", function(module, exports) {

$parcel$export(module.exports, "colorFieldDataTestId", () => $d039f222141cbb6a$export$d5ae1babf783fed9);
$parcel$export(module.exports, "getI18nColorPalette", () => $d039f222141cbb6a$export$9ceccb3244ae7dac);

var $5iWql = parcelRequire("5iWql");

var $lPQPn = parcelRequire("lPQPn");
const $d039f222141cbb6a$export$d5ae1babf783fed9 = 'issue.views.issue-base.foundation.color.color-picker-wrapper';
const $d039f222141cbb6a$export$9ceccb3244ae7dac = (0, $5iWql.default)(({ formatMessage: formatMessage })=>(0, $lPQPn.getDefaultColorPalette)(formatMessage));

});

parcelRegister("dUhk8", function(module, exports) {

$parcel$export(module.exports, "default", () => $acdd07c3cfbb8740$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $acdd07c3cfbb8740$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    label: {
        "id": "color-picker.edit.label",
        "defaultMessage": "Change color"
    }
});

});


parcelRegister("j0x3u", function(module, exports) {

$parcel$export(module.exports, "mutateEpicColorField", () => $6df92e9427dfff14$export$80288f09329d6da0);
$parcel$export(module.exports, "mutateIssueColorField", () => $6df92e9427dfff14$export$9e0b17281ec856bc);

var $lPQPn = parcelRequire("lPQPn");

const $6df92e9427dfff14$export$80288f09329d6da0 = (selectedColor, fieldId)=>({
        fieldId: fieldId,
        mutationGroup: (0, $6e2668d7a6fcf283$export$31fd86f8f183952c),
        color: {
            name: (0, $lPQPn.asClassicEpicColor)(selectedColor)
        }
    });
const $6df92e9427dfff14$export$9e0b17281ec856bc = (selectedColor, fieldId)=>({
        fieldId: fieldId,
        mutationGroup: (0, $6e2668d7a6fcf283$export$31fd86f8f183952c),
        color: {
            name: (0, $lPQPn.asServerColor)(selectedColor)
        }
    });

});
const $6e2668d7a6fcf283$export$31fd86f8f183952c = 'colorFields';



parcelRegister("5GK4N", function(module, exports) {

$parcel$export(module.exports, "default", () => $eda68cac2df93489$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");

var $e1gDz = parcelRequire("e1gDz");

var $5JgJ2 = parcelRequire("5JgJ2");

var $cKBPA = parcelRequire("cKBPA");
var $7mH0H = parcelRequire("7mH0H");

var $icPhQ = parcelRequire("icPhQ");
var $5i7Lk = parcelRequire("5i7Lk");
var $6HoNR = parcelRequire("6HoNR");

var $ajD9f = parcelRequire("ajD9f");

var $7TaJX = parcelRequire("7TaJX");
var $lIor1 = parcelRequire("lIor1");

var $6HcMO = parcelRequire("6HcMO");

var $fV68f = parcelRequire("fV68f");
const $eda68cac2df93489$var$ComponentsField = (props)=>{
    const { autoFocus: autoFocus, width: width, fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired, ...fieldProps }, error: error, allowedValues: allowedValues, selectedProject: selectedProject, description: description, fieldName: fieldName, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $7TaJX.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isReadOnly: isReadOnly = false, isMini: isMini } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isDisabled = allowedValues.length === 0;
    const options = (0, $7mH0H.mapDataToOptions)(allowedValues);
    const { projectKey: projectKey } = selectedProject || {};
    const projectKeyStr = projectKey || '';
    const { enabled: areGlobalComponentsEnabled, loading: loading } = (0, $e1gDz.useGlobalComponentsProperty)(projectKeyStr);
    const getComponentSelectEdit = ()=>{
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ajD9f.StyledFieldSkeleton), null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cKBPA.default), {
            ...fieldProps,
            options: options,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            value: value,
            onChange: onChange,
            autoFocus: autoFocus,
            isInvalid: Boolean(error),
            showFooter: false,
            projectKey: projectKeyStr,
            placeholder: isDisabled ? formatMessage((0, $6HcMO.default).none) : '',
            isDisabled: isDisabled || isReadOnly,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            canCreateNewItem: !areGlobalComponentsEnabled,
            inputId: id,
            isRequired: isRequired
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: formatMessage((0, $6HcMO.default).tooltipWhenDisabled)
    }, getComponentSelectEdit()) : getComponentSelectEdit(), !isDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5i7Lk.FieldMessage), {
        description: description,
        error: error,
        fieldName: fieldName,
        isMini: isMini
    }));
};
var $eda68cac2df93489$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    transformDefaultValue: (0, $7mH0H.mapDataToOptions),
    validator: (0, $lIor1.validateComponentField),
    shouldRenderFieldMessage: false
})($eda68cac2df93489$var$ComponentsField);

});
parcelRegister("e1gDz", function(module, exports) {

$parcel$export(module.exports, "useGlobalComponentsProperty", () => $10977af94640a909$export$a070f388fcd93df0);

var $eUqFw = parcelRequire("eUqFw");

var $gyj10 = parcelRequire("gyj10");

var $jD201 = parcelRequire("jD201");
function $10977af94640a909$export$a070f388fcd93df0(projectKey) {
    const [loading, setLoading] = (0, $eUqFw.useState)(true);
    const [enabled, setEnabled] = (0, $eUqFw.useState)(undefined);
    const [error, setError] = (0, $eUqFw.useState)(undefined);
    const loadGlobalComponentsProperty = (0, $eUqFw.useCallback)(()=>{
        setEnabled(undefined);
        setError(undefined);
        setLoading(true);
    }, [
        setEnabled,
        setError,
        setLoading
    ]);
    const resolveGlobalComponentsProperty = (0, $eUqFw.useCallback)((value)=>{
        if (value instanceof Error) {
            setEnabled(undefined);
            setError(value);
        } else {
            setEnabled(value);
            setError(undefined);
        }
        setLoading(false);
    }, [
        setEnabled,
        setError,
        setLoading
    ]);
    (0, $eUqFw.useEffect)(()=>{
        loadGlobalComponentsProperty();
        (0, $jD201.getGlobalComponentsProperty)(projectKey).then((r)=>resolveGlobalComponentsProperty(r.value)).catch((e)=>resolveGlobalComponentsProperty(e));
    }, [
        loadGlobalComponentsProperty,
        resolveGlobalComponentsProperty,
        projectKey
    ]);
    const setProperty = (0, $eUqFw.useCallback)((newValue)=>{
        loadGlobalComponentsProperty();
        return (0, $jD201.setGlobalComponentsProperty)(projectKey, newValue)// We are clearing the Jira components cache here which is the
        // data source for "Recent components" in the components field
        // for Jira issues. This should be cleared when toggling between
        // global components enabled or disabled to avoid stales
        // suggestions from either.
        .then(()=>(0, $gyj10.default).clearAll()).then(()=>resolveGlobalComponentsProperty(newValue)).catch((e)=>{
            resolveGlobalComponentsProperty(e);
            throw e;
        });
    }, [
        loadGlobalComponentsProperty,
        resolveGlobalComponentsProperty,
        projectKey
    ]);
    return {
        enabled: enabled,
        loading: loading,
        error: error,
        setProperty: setProperty
    };
}

});
parcelRegister("gyj10", function(module, exports) {

$parcel$export(module.exports, "default", () => $59f5d6a8cf5cca0c$export$2e2bcd8739ae039);

var $jhVpU = parcelRequire("jhVpU");

var $3bIxc = parcelRequire("3bIxc");
var $59f5d6a8cf5cca0c$export$2e2bcd8739ae039 = (0, $jhVpU.default)((0, $3bIxc.props));

});
parcelRegister("jhVpU", function(module, exports) {

$parcel$export(module.exports, "default", () => $47a98829846b4116$export$2e2bcd8739ae039);

var $kBiqn = parcelRequire("kBiqn");
const $47a98829846b4116$var$pNothing = ()=>Promise.resolve();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$47a98829846b4116$export$2e2bcd8739ae039 = (config)=>{
    if (!false) {
        const Cache = (0, $kBiqn.default)(config);
        const getAll = ()=>Cache.then((cache)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
                cache.getEntries().then((entries)=>entries.map(([, value])=>value)));
        const get = (key)=>Cache.then((cache)=>cache.get(key));
        const set = (key, value)=>Cache.then((cache)=>cache.set(key, value));
        const remove = (key)=>Cache.then((cache)=>cache.delete(key));
        const update = (key, value)=>Cache.then((cache)=>cache.update(key, value));
        const refresh = ()=>Cache.then((cache)=>cache.refresh()).then(()=>getAll());
        const clearAll = ()=>Cache.then((cache)=>cache.getEntries().then((entries)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
                    Promise.all(entries.map(([key])=>cache.delete(key)))) // Replace with lodash/noop
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                .then(()=>{}));
        return {
            get: get,
            getAll: getAll,
            set: set,
            remove: remove,
            update: update,
            refresh: refresh,
            clearAll: clearAll
        };
    }
    return {
        // @ts-expect-error - TS2322 - Type '() => Promise<void>' is not assignable to type '(key: string) => Promise<C | undefined>'.
        get: $47a98829846b4116$var$pNothing,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        getAll: ()=>Promise.resolve([]),
        set: ()=>Promise.resolve(),
        remove: $47a98829846b4116$var$pNothing,
        update: $47a98829846b4116$var$pNothing,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        refresh: ()=>Promise.resolve([]),
        clearAll: $47a98829846b4116$var$pNothing
    };
};

});
parcelRegister("kBiqn", function(module, exports) {

$parcel$export(module.exports, "Cache", () => $32f02625ea3a7ccc$export$94affb487e701bf2);
$parcel$export(module.exports, "default", () => $32f02625ea3a7ccc$export$2e2bcd8739ae039);

var $aZaPn = parcelRequire("aZaPn");
var $89bO2 = parcelRequire("89bO2");

var $gUUjF = parcelRequire("gUUjF");


var $48k9t = parcelRequire("48k9t");
const $32f02625ea3a7ccc$var$calculateEntryAge = (timestamp)=>Date.now() - timestamp;
function $32f02625ea3a7ccc$export$94affb487e701bf2(props) {
    const cache = new Map();
    const { size: size } = props;
    let storage;
    let hasSyncedFromStorage = false;
    const devTools = window && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__.connect({
        name: `Cache ${props.cacheKey}`,
        serialize: true
    }) : null;
    const syncWithDevTools = (type, payload)=>{
        if ((0, $48k9t.default).devTools) devTools && devTools.send({
            type: type,
            payload: payload
        }, cache, {}, props.cacheKey);
    };
    const removeExpiredKeysFromStorage = async (store)=>{
        const updatedStore = {
            ...store
        };
        if (props.storageType === (0, $834cc2f16be60bc5$export$bf340b99118a1511)) return {};
        const { cacheKey: cacheKey, maxAge: maxAge } = props;
        if (maxAge !== undefined) {
            Object.keys(store).forEach((key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                const keyAge = $32f02625ea3a7ccc$var$calculateEntryAge(store[key].timestamp);
                if (keyAge > maxAge) {
                    // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: any; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    syncWithDevTools((0, $834cc2f16be60bc5$export$26d12233004a7a60), {
                        [String(key)]: updatedStore[key]
                    });
                    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                    delete updatedStore[key];
                    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'K'.
                    cache.delete(key);
                }
            });
            storage.set(cacheKey, updatedStore);
        }
        return updatedStore;
    };
    const removeExpiredEntry = (key, val)=>{
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            const { maxAge: maxAge } = props;
            if (maxAge !== undefined && $32f02625ea3a7ccc$var$calculateEntryAge(val.timestamp) > maxAge) {
                // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
                syncWithDevTools((0, $834cc2f16be60bc5$export$26d12233004a7a60), {
                    [String(key)]: val
                });
                cache.delete(key);
                return true;
            }
        }
        return false;
    };
    const createStore = ()=>{
        if (props.storageType === (0, $834cc2f16be60bc5$export$2670cb7d5d4f7184)) storage = (0, $aZaPn.createLocalStorageProvider)((0, $48k9t.CACHE_PREFIX));
        else storage = (0, $89bO2.createSessionStorageProvider)((0, $48k9t.CACHE_PREFIX));
        return storage;
    };
    const set = async (key, value)=>{
        await load();
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.delete(key);
        const entry = {
            value: value,
            timestamp: Date.now()
        };
        let storedContent = {};
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            // @ts-expect-error - TS2536 - Type 'string | K' cannot be used to index type 'Partial<Record<K, Entry<V>>>'.
            storedContent[key] = entry;
        }
        // @ts-expect-error - TS2345 - Argument of type 'string | K' is not assignable to parameter of type 'K'.
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $834cc2f16be60bc5$export$5e8f180ef0142226), {
            [String(key)]: entry
        });
        if (cache.size > size) {
            const keys = cache.keys();
            const firstEntry = keys.next().value;
            if (firstEntry !== undefined) {
                cache.delete(firstEntry);
                syncWithDevTools((0, $834cc2f16be60bc5$export$a61768fefd33fcb1), firstEntry);
                if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                delete storedContent[firstEntry];
            }
        }
        props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const load = async ()=>{
        if (false || hasSyncedFromStorage) return;
        hasSyncedFromStorage = true;
        if (props.storageType === (0, $834cc2f16be60bc5$export$bf340b99118a1511)) return;
        const { cacheKey: cacheKey } = props;
        storage = createStore();
        try {
            let data = storage.get(cacheKey) || {};
            data = await removeExpiredKeysFromStorage(data);
            syncWithDevTools((0, $834cc2f16be60bc5$export$61f74127e2b53cbe), data);
            const orderedKeys = Object.keys(data).sort(// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
            (key1, key2)=>data[key1].timestamp - data[key2].timestamp);
            await Promise.all(orderedKeys.map(async (key)=>{
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<K, Entry<V>>>'.
                await set(key, data[key].value);
            }));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            (0, $gUUjF.default).safeWarnWithoutCustomerData((0, $834cc2f16be60bc5$export$7271276960377470), `There was an error syncing with storage - ${cacheKey}`, err);
            throw err;
        }
    };
    const clear = async ()=>{
        await load();
        cache.clear();
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            const { cacheKey: cacheKey } = props;
            storage.remove(cacheKey);
        }
        syncWithDevTools((0, $834cc2f16be60bc5$export$6c4d37c7f376a1de), {});
    };
    const get = async (key)=>{
        await load();
        let val = cache.get(key);
        if (val) {
            if (removeExpiredEntry(key, val)) val = undefined;
        }
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $834cc2f16be60bc5$export$1bb358554aac31c1), {
            [String(key)]: val
        });
        return val && val.value;
    };
    const update = async (key, value)=>{
        await load();
        const previousValue = cache.get(key);
        if (!previousValue) return;
        const entry = {
            value: value,
            timestamp: previousValue.timestamp
        };
        let storedContent = {};
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            storedContent = storage.get(props.cacheKey) || {};
            storedContent[key] = entry;
        }
        cache.set(key, entry);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V>; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $834cc2f16be60bc5$export$e271b26eefe41db8), {
            [String(key)]: entry
        });
        props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511) && storage.set(props.cacheKey, storedContent);
    };
    const getEntries = async ()=>{
        await load();
        const entries = Array.from(cache.entries()).filter(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        ([key, value])=>!removeExpiredEntry(key, value));
        syncWithDevTools((0, $834cc2f16be60bc5$export$9eb68924983e00fb), entries);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return entries.map(([key, { value: value }])=>[
                key,
                value
            ]);
    };
    const deleteEntry = async (key)=>{
        await load();
        if (props.storageType !== (0, $834cc2f16be60bc5$export$bf340b99118a1511)) {
            const storedContent = storage.get(props.cacheKey) || {};
            delete storedContent[key];
            storage.set(props.cacheKey, storedContent);
        }
        cache.delete(key);
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: Entry<V> | undefined; }' is not assignable to parameter of type 'K | Entry<V> | Partial<Record<K, Entry<V>>> | [K, Entry<V>][]'.
        syncWithDevTools((0, $834cc2f16be60bc5$export$4bd2facc4a3e6aa1), {
            [String(key)]: cache.get(key)
        });
    };
    const refresh = async ()=>{
        if (props.storageType === (0, $834cc2f16be60bc5$export$bf340b99118a1511)) return;
        cache.clear();
        hasSyncedFromStorage = false;
        await load();
    };
    if ((0, $48k9t.default).scopes.current !== (0, $48k9t.default).scopes.prev) clear();
    return {
        cache: cache,
        get: get,
        set: set,
        delete: deleteEntry,
        clear: clear,
        load: load,
        update: update,
        getEntries: // @ts-expect-error - TS2322 - Type '() => Promise<any[][]>' is not assignable to type '() => Promise<[K, V][]>'.
        getEntries,
        refresh: refresh
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $32f02625ea3a7ccc$var$cacheMap = {};
const $32f02625ea3a7ccc$var$getCache = async (props)=>{
    await (0, $48k9t.scopeGuard)().catch((error)=>{
        (0, $gUUjF.default).safeErrorWithoutCustomerData('common.cache.scope', 'There was a failure within cache scopeGuard', error);
    });
    const { cacheKey: cacheKey } = props;
    // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
    $32f02625ea3a7ccc$var$cacheMap[cacheKey] = $32f02625ea3a7ccc$var$cacheMap[cacheKey] || new $32f02625ea3a7ccc$export$94affb487e701bf2(props);
    return $32f02625ea3a7ccc$var$cacheMap[cacheKey];
};
const $32f02625ea3a7ccc$export$710d301bf26d9700 = ()=>{
    Object.values($32f02625ea3a7ccc$var$cacheMap).forEach((cache)=>cache.clear());
};
var $32f02625ea3a7ccc$export$2e2bcd8739ae039 = $32f02625ea3a7ccc$var$getCache;

});
const $834cc2f16be60bc5$export$7271276960377470 = 'common-cache';
const $834cc2f16be60bc5$export$a61768fefd33fcb1 = 'capacity exceeded';
const $834cc2f16be60bc5$export$6c4d37c7f376a1de = 'clear';
const $834cc2f16be60bc5$export$e271b26eefe41db8 = 'update';
const $834cc2f16be60bc5$export$4bd2facc4a3e6aa1 = 'delete';
const $834cc2f16be60bc5$export$26d12233004a7a60 = 'delete stale entry';
const $834cc2f16be60bc5$export$1bb358554aac31c1 = 'get';
const $834cc2f16be60bc5$export$61f74127e2b53cbe = 'hydrate';
const $834cc2f16be60bc5$export$5e8f180ef0142226 = 'set';
const $834cc2f16be60bc5$export$9eb68924983e00fb = 'get entries';
const $834cc2f16be60bc5$export$bf340b99118a1511 = 'memory';
const $834cc2f16be60bc5$export$2670cb7d5d4f7184 = 'local';
const $834cc2f16be60bc5$export$b796061ff0c82e1a = 'session';



parcelRegister("3bIxc", function(module, exports) {

$parcel$export(module.exports, "props", () => $db1ce1616d9abcdd$export$8128bb6492cf3de7);

const $db1ce1616d9abcdd$var$MAX_RESULTS = 10;
const $db1ce1616d9abcdd$var$CACHE_SIZE = $db1ce1616d9abcdd$var$MAX_RESULTS * 2;
const $db1ce1616d9abcdd$var$COMPONENTS_CACHE_KEY = 'components';
const $db1ce1616d9abcdd$export$8128bb6492cf3de7 = {
    size: $db1ce1616d9abcdd$var$CACHE_SIZE,
    cacheKey: $db1ce1616d9abcdd$var$COMPONENTS_CACHE_KEY,
    maxAge: 604800000,
    storageType: (0, $834cc2f16be60bc5$export$2670cb7d5d4f7184)
};

});


parcelRegister("jD201", function(module, exports) {

$parcel$export(module.exports, "getGlobalComponentsProperty", () => $623baa6e9886872f$export$1db3503600a1638e);
$parcel$export(module.exports, "setGlobalComponentsProperty", () => $623baa6e9886872f$export$71702a5b14caff65);

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");
const $623baa6e9886872f$var$GLOBAL_COMPONENTS_PROPERTY_KEY = 'jira.global.components';
// Default projectKey regex, source: https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-api/src/main/java/com/atlassian/jira/util/JiraKeyUtils.java#421
const $623baa6e9886872f$var$PROJECT_KEY_REGEX = /^[A-Z][A-Z]+$/;
const $623baa6e9886872f$var$url = (projectIdOrKey, entityKey)=>`/rest/api/3/project/${projectIdOrKey}/properties/${entityKey}`;
const $623baa6e9886872f$var$getProjectId = async (projectKey)=>{
    const project = await (0, $lRmyA.performGetRequest)(`/rest/api/3/project/${projectKey}`);
    return project?.id;
};
const $623baa6e9886872f$export$1db3503600a1638e = async (projectKey)=>{
    try {
        let endpoint;
        if (!$623baa6e9886872f$var$PROJECT_KEY_REGEX.test(projectKey)) {
            // We need to fetch the project id here because some users have malformed project keys that are not compatible with the project properties endpoint
            const projectId = await $623baa6e9886872f$var$getProjectId(projectKey);
            if (!projectId) return {
                key: $623baa6e9886872f$var$GLOBAL_COMPONENTS_PROPERTY_KEY,
                value: null
            };
            endpoint = $623baa6e9886872f$var$url(projectId, $623baa6e9886872f$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        } else endpoint = $623baa6e9886872f$var$url(projectKey, $623baa6e9886872f$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        return await (0, $lRmyA.performGetRequest)(endpoint);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // The endpoint returns 404 if the project property is not set, but we don't treat it as an
        // actual error
        if (error.statusCode === 404) return {
            key: $623baa6e9886872f$var$GLOBAL_COMPONENTS_PROPERTY_KEY,
            value: null
        };
        (0, $guiFP.default)({
            meta: {
                id: 'getGlobalComponentsProperty',
                packageName: 'jiraCompassCommon',
                teamName: 'compass-lodestone'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                projectKey: projectKey
            }
        });
        throw error;
    }
};
async function $623baa6e9886872f$export$71702a5b14caff65(projectKey, value) {
    try {
        let endpoint;
        if (!$623baa6e9886872f$var$PROJECT_KEY_REGEX.test(projectKey)) {
            // We need to fetch the project id here because some users have malformed project keys that are not compatible with the project properties endpoint
            const projectId = await $623baa6e9886872f$var$getProjectId(projectKey);
            if (!projectId) return;
            endpoint = $623baa6e9886872f$var$url(projectId, $623baa6e9886872f$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        } else endpoint = $623baa6e9886872f$var$url(projectKey, $623baa6e9886872f$var$GLOBAL_COMPONENTS_PROPERTY_KEY);
        await (0, $lRmyA.performPutRequest)(endpoint, {
            body: JSON.stringify(value)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'setGlobalComponentsProperty',
                packageName: 'jiraCompassCommon',
                teamName: 'compass-lodestone'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true,
            attributes: {
                projectKey: projectKey
            }
        });
        throw error;
    }
}

});


parcelRegister("cKBPA", function(module, exports) {

$parcel$export(module.exports, "default", () => $d320f9634daf574a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $28t3A = parcelRequire("28t3A");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4NcaX = parcelRequire("4NcaX");

var $4Pih6 = parcelRequire("4Pih6");

var $d0efy = parcelRequire("d0efy");
const $d320f9634daf574a$var$ComponentsSelectEdit = (props)=>{
    const { value: value, options: options, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', autoFocus: autoFocus = false, isInvalid: isInvalid = false, isDisabled: isDisabled = false, showFooter: showFooter = false, onCloseMenuOnScroll: onCloseMenuOnScroll, projectKey: projectKey, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, canCreateNewItem: canCreateNewItem = false, formatNewInlineComponentCreateLabel: formatNewInlineComponentCreateLabel, inputId: inputId, isRequired: isRequired, ...fieldProps } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const getNewInlineComponentCreateLabel = (0, $eUqFw.useCallback)((inputValue)=>`${inputValue} (${formatNewInlineComponentCreateLabel !== undefined ? formatNewInlineComponentCreateLabel : formatMessage((0, $d0efy.default).createNewItem)})`, [
        formatNewInlineComponentCreateLabel,
        formatMessage
    ]);
    const isValidNewOption = (0, $eUqFw.useCallback)((query)=>{
        const fieldInputLabels = options.map((option)=>option.label.toLowerCase());
        return canCreateNewItem && query.trim() !== '' && !fieldInputLabels.includes(query.trim().toLowerCase());
    }, [
        canCreateNewItem,
        options
    ]);
    const handleInlineComponentCreate = (inputValue)=>{
        onChange([
            ...value || [],
            {
                label: inputValue,
                value: null
            }
        ]);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $28t3A.default), {
        inputId: inputId,
        required: isRequired,
        ...fieldProps,
        value: value,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - TS2322 - Type 'Options' is not assignable to type 'readonly (Options | GroupBase<Options>)[]
        options: options,
        placeholder: placeholder || formatMessage((0, $d0efy.default).placeholder),
        // @ts-expect-error - TS2322 - Type '(arg1: Options) => void' is not assignable to type '(value: OptionsType<{ label: string; value: string; }>, action: ActionMeta<{ label: string; value: string; }>) => void'.
        onChange: onChange,
        onFocus: onFocus,
        onBlur: onBlur,
        autoFocus: autoFocus,
        closeMenuOnScroll: onCloseMenuOnScroll,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        styles: (0, $4NcaX.defaultSelectStyles),
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        components: {
            MenuList: (menuListProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Pih6.default), {
                    ...menuListProps,
                    showFooter: showFooter,
                    projectKey: projectKey
                })
        },
        isMulti: true,
        isDisabled: isDisabled,
        isValidNewOption: isValidNewOption,
        formatCreateLabel: getNewInlineComponentCreateLabel,
        onCreateOption: handleInlineComponentCreate,
        // eslint-disable-next-line jira/react/no-classname-attribute, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "components-field-select" // added this for testing purpose, it doesn't apply any style
        ,
        classNamePrefix: "components-field-select"
    });
};
var $d320f9634daf574a$export$2e2bcd8739ae039 = $d320f9634daf574a$var$ComponentsSelectEdit;

});
parcelRegister("4Pih6", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb8800057fba71ce$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $gO9Xw = parcelRequire("gO9Xw");

var $jQxSL = parcelRequire("jQxSL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fGb0D = parcelRequire("fGb0D");
const $cb8800057fba71ce$var$MenuWithFooter = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { children: children, showFooter: showFooter, projectKey: projectKey, footerLabel: footerLabel, ...restProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).MenuList, restProps, children), showFooter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cb8800057fba71ce$export$fd9000017733fabf, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cb8800057fba71ce$export$500fb058ad7aeb1, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cb8800057fba71ce$export$e0513c91be1318ca, {
        href: `/plugins/servlet/project-config/${projectKey}/administer-components`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gO9Xw))), {
        label: "componentFooterAddIcon",
        size: "small"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cb8800057fba71ce$var$LinkText, null, footerLabel ?? formatMessage((0, $fGb0D.default).componentLabel))))));
};
var $cb8800057fba71ce$export$2e2bcd8739ae039 = $cb8800057fba71ce$var$MenuWithFooter;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cb8800057fba71ce$var$LinkText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc",
            __cmplp.className
        ])
    });
});
const $cb8800057fba71ce$export$fd9000017733fabf = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1yt41bpf _x3dope8f",
            __cmplp.className
        ])
    });
});
const $cb8800057fba71ce$export$500fb058ad7aeb1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41r6r _1bsb1osq _irr314ae",
            __cmplp.className
        ])
    });
});
const $cb8800057fba71ce$export$e0513c91be1318ca = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fGb0D", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca8bfcff55204f10$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ca8bfcff55204f10$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    componentLabel: {
        "id": "issue-field-components-field.edit.menu.component-label",
        "defaultMessage": "Create new component"
    }
});

});


parcelRegister("d0efy", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e3f12f632cacfc6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0e3f12f632cacfc6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "issue-field-components-field.edit.placeholder",
        "defaultMessage": "Select Component"
    },
    createNewItem: {
        "id": "issue-field-components-field.edit.create-new-item",
        "defaultMessage": "New Component"
    }
});

});


parcelRegister("7mH0H", function(module, exports) {

$parcel$export(module.exports, "mapDataToOptions", () => $ba98fedd4072563e$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionsToData", () => $ba98fedd4072563e$export$ffef3a401aef987b);
const $ba98fedd4072563e$export$99a866ffa3af7d8b = (data)=>data.map(({ id: id, name: name })=>({
            label: name,
            value: id
        }));
const $ba98fedd4072563e$export$ffef3a401aef987b = (data)=>data.map(({ label: label, value: value })=>({
            id: value,
            name: label
        }));

});

parcelRegister("6HcMO", function(module, exports) {

$parcel$export(module.exports, "default", () => $40f739078738245f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $40f739078738245f$var$messages = (0, $90IgZ.defineMessages)({
    none: {
        "id": "issue-create-commons.components-field.none",
        "defaultMessage": "None"
    },
    tooltipWhenDisabled: {
        "id": "issue-create-commons.components-field.tooltip-when-disabled",
        "defaultMessage": "We couldn't find any components for this project"
    }
});
var $40f739078738245f$export$2e2bcd8739ae039 = $40f739078738245f$var$messages;

});

parcelRegister("fV68f", function(module, exports) {

$parcel$export(module.exports, "mutateComponentsField", () => $03edaa3e3c4220d9$export$499415d02c5db090);
const $03edaa3e3c4220d9$export$499415d02c5db090 = (selectedComponents)=>({
        components: selectedComponents.reduce((acc, { value: value })=>{
            if (value !== null) acc.push({
                componentId: value
            });
            return acc;
        }, [])
    });

});


parcelRegister("kfu77", function(module, exports) {

$parcel$export(module.exports, "default", () => $5470905411abe2a7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");

var $h9GI9 = parcelRequire("h9GI9");

var $icPhQ = parcelRequire("icPhQ");
var $6HoNR = parcelRequire("6HoNR");

var $lIor1 = parcelRequire("lIor1");

var $7TaJX = parcelRequire("7TaJX");

var $3GT6n = parcelRequire("3GT6n");
const $5470905411abe2a7$export$c3b8fa1b9560fb7e = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange }, fieldId: fieldId, error: error, autoCompleteUrl: autoCompleteUrl = '/rest/teams/1.0/teams/find', isEditable: isEditable = true, nonEditableReason: nonEditableReason, onCloseMenuOnScroll: // @ts-expect-error - TS2339 - Property 'onCloseMenuOnScroll' does not exist on type 'Props'.
    onCloseMenuOnScroll = (0, $7TaJX.closeMenuOnScroll), isDropdownMenuFixedAndLayered: // @ts-expect-error - TS2339 - Property 'isDropdownMenuFixedAndLayered' does not exist on type 'Props'.
    isDropdownMenuFixedAndLayered = false } = props;
    const getTeamEdit = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h9GI9.default), {
            autoCompleteUrl: autoCompleteUrl,
            onChange: onChange,
            value: value,
            fieldId: fieldId,
            isInvalid: Boolean(error),
            isDisabled: !isEditable,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            fetchSuggestionsOnFocus: true
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, isEditable === false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: nonEditableReason?.message || ''
    }, getTeamEdit()) : getTeamEdit());
};
var $5470905411abe2a7$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    validator: (0, $lIor1.validateCustomTeamsField),
    transformDefaultValue: (0, $3GT6n.transformDefaultTeam)
})($5470905411abe2a7$export$c3b8fa1b9560fb7e);

});
parcelRegister("h9GI9", function(module, exports) {

$parcel$export(module.exports, "default", () => $5585e8088f239d77$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fm9CZ = parcelRequire("fm9CZ");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4NcaX = parcelRequire("4NcaX");

var $fO0l8 = parcelRequire("fO0l8");

var $jSTFD = parcelRequire("jSTFD");

var $jKAMv = parcelRequire("jKAMv");

var $kkYM2 = parcelRequire("kkYM2");

var $6b6yO = parcelRequire("6b6yO");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5585e8088f239d77$var$MenuList = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jKAMv.default), props);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5585e8088f239d77$var$Option = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kkYM2.default), props);
const $5585e8088f239d77$var$CustomTeamPickerEdit = (props)=>{
    const { fieldId: fieldId, value: value, onChange: onChange, autoCompleteUrl: autoCompleteUrl, isInvalid: isInvalid, autoFocus: autoFocus = false, isDisabled: isDisabled, placeholder: placeholder = '', isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, onCloseMenuOnScroll: onCloseMenuOnScroll, fetchSuggestionsOnFocus: fetchSuggestionsOnFocus = false, classNamePrefix: classNamePrefix } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [defaultOptions, setDefaultOptions] = (0, $eUqFw.useState)([]);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const shouldFetchDefaultOptions = (0, $eUqFw.useRef)(true);
    const handleSearch = (0, $fO0l8.default)(async (query)=>(0, $6b6yO.fetchTeams)(query || '', autoCompleteUrl), 300);
    const onFocus = async ()=>{
        if (shouldFetchDefaultOptions && defaultOptions && shouldFetchDefaultOptions.current && !defaultOptions.length) {
            shouldFetchDefaultOptions.current = false;
            setIsLoading && setIsLoading(true);
            const options = await handleSearch();
            setDefaultOptions && setDefaultOptions(options);
            setIsLoading && setIsLoading(false);
        }
    };
    const defaultOptionsProps = ()=>{
        if (fetchSuggestionsOnFocus) return {
            onFocus: onFocus,
            isLoading: isLoading,
            defaultOptions: defaultOptions
        };
        return {};
    };
    const noOptionsMessage = (0, $eUqFw.useCallback)(()=>formatMessage((0, $jSTFD.default).noMatches), [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fm9CZ.default), {
        fieldId: fieldId,
        ...defaultOptionsProps(),
        loadOptions: handleSearch,
        onChange: onChange,
        autoFocus: autoFocus,
        isClearable: Boolean(value),
        isMulti: false,
        value: value,
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        components: {
            MenuList: $5585e8088f239d77$var$MenuList,
            Option: $5585e8088f239d77$var$Option
        },
        noOptionsMessage: noOptionsMessage,
        placeholder: placeholder,
        isDisabled: isDisabled,
        // @ts-expect-error - TS2322 - Type '((e: ChangeEvent<HTMLElement>) => boolean) | undefined' is not assignable to type 'boolean | EventListener | undefined'.
        closeMenuOnScroll: onCloseMenuOnScroll,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        styles: (0, $4NcaX.defaultSelectStyles),
        classNamePrefix: classNamePrefix
    });
};
var $5585e8088f239d77$export$2e2bcd8739ae039 = $5585e8088f239d77$var$CustomTeamPickerEdit;

});
parcelRegister("jSTFD", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3167cca46c9d2c9$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $e3167cca46c9d2c9$var$messages = (0, $90IgZ.defineMessages)({
    menuHeader: {
        "id": "issue-field-custom-team.menu-header",
        "defaultMessage": "Pick a shared team that you\u2019ve created through a Portfolio plan"
    },
    noMatches: {
        "id": "issue-field-custom-team.no-matches",
        "defaultMessage": "No Matches"
    },
    menuFooter: {
        "id": "issue-field-custom-team.menu-footer",
        "defaultMessage": "Showing 100 results. To display more results, please refine your search."
    }
});
var $e3167cca46c9d2c9$export$2e2bcd8739ae039 = $e3167cca46c9d2c9$var$messages;

});

parcelRegister("jKAMv", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9b2116316498d63$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jQxSL = parcelRequire("jQxSL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jSTFD = parcelRequire("jSTFD");
const $b9b2116316498d63$var$MenuListComponent = (props)=>{
    const { options: options } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const footer = options.length > 0 && options[0].moreResultsAvailable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b9b2116316498d63$var$MenuFooterText, null, formatMessage((0, $jSTFD.default).menuFooter)) : null;
    return(// @ts-expect-error - TS2740 - Type '{ children: (Element | ReactNode)[]; options: GroupOption[]; }' is missing the following properties from type 'CommonProps<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>>': clearValue, cx, getStyles, getValue, and 7 more.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).MenuList, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b9b2116316498d63$var$Container, null, formatMessage((0, $jSTFD.default).menuHeader)), props.children, footer));
};
var $b9b2116316498d63$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $b9b2116316498d63$var$MenuListComponent;
const $b9b2116316498d63$var$MenuFooterText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1ifp _1wybdlk8 _1yt41pyq",
            __cmplp.className
        ])
    });
});
const $b9b2116316498d63$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41pyq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("kkYM2", function(module, exports) {

$parcel$export(module.exports, "default", () => $1893208c9969fdac$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $jQxSL = parcelRequire("jQxSL");

var $1hABw = parcelRequire("1hABw");
const $1893208c9969fdac$var$OptionComponent = (props)=>{
    const value = props.data;
    if (value) {
        const { avatarUrl: avatarUrl } = value;
        return(// @ts-expect-error - TS2740 - Type '{ children: Element; data: TeamFieldType; }' is missing the following properties from type 'CommonProps<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>>': clearValue, cx, getStyles, getValue, and 8 more.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1893208c9969fdac$var$OptionWrapper, null, avatarUrl ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1893208c9969fdac$var$Icon, {
            src: avatarUrl
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $1893208c9969fdac$var$boxStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1hABw.default), {
            alt: ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1893208c9969fdac$var$OptionText, null, props.children))));
    }
    return null;
};
var $1893208c9969fdac$export$2e2bcd8739ae039 = $1893208c9969fdac$var$OptionComponent;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1893208c9969fdac$var$Icon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb7vkz _4t3i7vkz _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $1893208c9969fdac$var$OptionWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1reo15vq _18m915vq _4cvr1h6o _1bahv2br _1yt4otz2",
            __cmplp.className
        ])
    });
});
const $1893208c9969fdac$var$OptionText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});
const $1893208c9969fdac$var$boxStyle = (0, $1ZAYh.xcss)({
    height: '16px',
    width: '16px',
    marginRight: 'space.100'
});

});
parcelRegister("1hABw", function(module, exports) {

$parcel$export(module.exports, "default", () => $670cd22bb8a64b13$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See closest README.md

var $9TZf5 = parcelRequire("9TZf5");

var $cpt52 = parcelRequire("cpt52");
const $670cd22bb8a64b13$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($cpt52)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($cpt52))
});
var $670cd22bb8a64b13$export$2e2bcd8739ae039 = $670cd22bb8a64b13$var$Illustration;
// for advanced use only
const $670cd22bb8a64b13$export$a179c88182cb9d56 = [
    0,
    0,
    596,
    596
];

});
parcelRegister("cpt52", function(module, exports) {
module.exports = new URL("team.aa9af04e.svg", import.meta.url).toString();

});



parcelRegister("6b6yO", function(module, exports) {

$parcel$export(module.exports, "transformTeamFieldTypeString", () => $49363b8d604d92fe$export$f7d628c77d5447d0);
$parcel$export(module.exports, "fetchTeams", () => $49363b8d604d92fe$export$a789e725ac68b08d);

var $lRmyA = parcelRequire("lRmyA");
const $49363b8d604d92fe$export$4accbe1c2fbc55dd = (team)=>({
        label: team.title,
        value: team.id.toString(),
        isShared: team.shareable,
        avatarUrl: team.avatarUrl
    });
const $49363b8d604d92fe$export$f7d628c77d5447d0 = (team)=>{
    if (team) return team.value.toString();
    return null;
};
const $49363b8d604d92fe$export$a789e725ac68b08d = async (query, autoCompleteUrl)=>{
    const response = await (0, $lRmyA.performPostRequest)(autoCompleteUrl, {
        body: JSON.stringify({
            excludedIds: [],
            maxResults: 100,
            query: query
        })
    });
    if (response) {
        const teams = response.teams.map($49363b8d604d92fe$export$4accbe1c2fbc55dd);
        return [
            {
                moreResultsAvailable: response.moreResultsAvailable,
                options: teams
            }
        ];
    }
    return [];
};

});


parcelRegister("3GT6n", function(module, exports) {

$parcel$export(module.exports, "mutateTeamField", () => $07ff2bf39f4c18fe$export$8db32a33b76e5823);
$parcel$export(module.exports, "transformDefaultTeam", () => $07ff2bf39f4c18fe$export$d2d64eb763c850a1);

const $07ff2bf39f4c18fe$export$8db32a33b76e5823 = (selectedTeam, fieldId)=>selectedTeam ? {
        fieldId: fieldId,
        mutationGroup: (0, $76b8053c60983826$export$31fd86f8f183952c),
        team: {
            teamId: selectedTeam.value
        }
    } : null;
const $07ff2bf39f4c18fe$export$d2d64eb763c850a1 = (team)=>({
        label: team.name,
        value: team.teamId,
        isShared: true
    });

});
const $76b8053c60983826$export$31fd86f8f183952c = 'teamFields';



parcelRegister("5hR1J", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee12d8d12ea5e023$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6ROLN = parcelRequire("6ROLN");

var $c0jFd = parcelRequire("c0jFd");

var $2hZCh = parcelRequire("2hZCh");

var $c9TLT = parcelRequire("c9TLT");

var $0cdA8 = parcelRequire("0cdA8");

var $5JgJ2 = parcelRequire("5JgJ2");

var $icPhQ = parcelRequire("icPhQ");

var $2KWIB = parcelRequire("2KWIB");
const $ee12d8d12ea5e023$var$DataClassificationField = (props)=>{
    const { width: width, value: value, onChange: onChange, allowedValues: allowedValues, errorMessage: errorMessage, isDisabled: isDisabled, nonEditableReason: nonEditableReason } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "dataClassificationField",
        packageName: "jiraIssueCreateCommons",
        fallback: "unmount",
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width,
        marginTop: (0, $c9TLT.gridSize) * 2.25,
        paddingBottom: (0, $c9TLT.gridSize) * 2.25
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ROLN.Label), {
        htmlFor: "data-classification-dropdown-input",
        id: "data-classification-select"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c0jFd.default), {
        justifyContent: "start"
    }, formatMessage((0, $2KWIB.default).classificationFieldLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2hZCh.DataClassificationDropdown), {
        options: allowedValues,
        value: value,
        onChange: onChange,
        isDisabled: isDisabled,
        disabledTooltipMessage: nonEditableReason?.message,
        errorMessage: errorMessage
    })));
};
var $ee12d8d12ea5e023$export$2e2bcd8739ae039 = $ee12d8d12ea5e023$var$DataClassificationField;

});

parcelRegister("2sjGj", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1f2648675395af2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jXg8H = parcelRequire("jXg8H");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8K9kM = parcelRequire("8K9kM");

var $4xHig = parcelRequire("4xHig");

var $icPhQ = parcelRequire("icPhQ");
var $6HoNR = parcelRequire("6HoNR");

var $5OZ28 = parcelRequire("5OZ28");
var $lIor1 = parcelRequire("lIor1");

var $9lTIY = parcelRequire("9lTIY");

var $aRKjl = parcelRequire("aRKjl");
const $e1f2648675395af2$var$DateField = (props)=>{
    const { autoFocus: autoFocus = false, width: width, fieldProps: { value: value = '', onChange: onChange, id: id }, error: error, isReadOnly: isReadOnly = false } = props;
    const locale = (0, $4xHig.useLocale)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const weekStartDay = (0, $8K9kM.getLocale)(locale)?.options?.weekStartsOn;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jXg8H.default), {
        // @ts-expect-error - TS2322 - Type 'FieldValue' is not assignable to type 'string | undefined'.
        value: value,
        isDisabled: isReadOnly,
        onChange: onChange,
        autoFocus: autoFocus,
        locale: locale,
        isInvalid: Boolean(error),
        selectProps: {
            /**
                         Temporary fix to prevent form submit on enter press on an open calendar.
                         Ideally this should either be handled by atlaskit or keypress enter event should only be supressed when calendar is open.
                         There is no way to know if the calendar is open in the current implementation
                          Side Effect: Form will not submit on enter keyPress even when calendar is not open.
                      */ inputId: id,
            onKeyDown: (0, $5OZ28.preventFormSubmitOnEnterKeyPress),
            placeholder: formatMessage((0, $9lTIY.default).placeholder),
            'aria-describedby': `${id}-helper`
        },
        weekStartDay: weekStartDay
    }));
};
var // @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<DateFieldConfig, FieldValue>, any>'.
$e1f2648675395af2$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    validator: (0, $lIor1.validateString)
})($e1f2648675395af2$var$DateField);

});
parcelRegister("jXg8H", function(module, exports) {

$parcel$export(module.exports, "default", () => $a38f1e4301a686fa$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $EN9B6 = parcelRequire("EN9B6");
var $7ueqz = parcelRequire("7ueqz");
var $eztWc = parcelRequire("eztWc");
var $3xcI8 = parcelRequire("3xcI8");

var $8dloj = parcelRequire("8dloj");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $kMHOY = parcelRequire("kMHOY");

var $5cS2Y = parcelRequire("5cS2Y");

var $XHGTv = parcelRequire("XHGTv");

var $5wCDk = parcelRequire("5wCDk");
var $cEc3i = parcelRequire("cEc3i");

var $7i5dr = parcelRequire("7i5dr");

var $dEsso = parcelRequire("dEsso");

var $1ym5t = parcelRequire("1ym5t");

var $jP55W = parcelRequire("jP55W");

var $cJOhG = parcelRequire("cJOhG");
const $a38f1e4301a686fa$var$packageName = undefined;
const $a38f1e4301a686fa$var$packageVersion = undefined;
const $a38f1e4301a686fa$var$datePickerDefaultProps = {
    appearance: 'default',
    autoFocus: false,
    defaultIsOpen: false,
    defaultValue: '',
    disabled: [],
    disabledDateFilter: (_)=>false,
    hideIcon: false,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($kMHOY))),
    id: '',
    innerProps: {},
    isDisabled: false,
    isInvalid: false,
    label: '',
    name: '',
    // These disables are here for proper typing when used as defaults. They
    // should *not* use the `noop` function.
    /* eslint-disable @repo/internal/react/use-noop */ onBlur: (_event)=>{},
    onChange: (_value)=>{},
    onFocus: (_event)=>{},
    /* eslint-enable @repo/internal/react/use-noop */ selectProps: {},
    spacing: 'default',
    locale: 'en-US'
};
class $a38f1e4301a686fa$export$df43d21f5faca9f7 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = $a38f1e4301a686fa$var$datePickerDefaultProps;
    }
    constructor(props){
        super(props);
        this.calendarRef = null;
        this.containerRef = null;
        // All state needs to be accessed via this function so that the state is mapped from props
        // correctly to allow controlled/uncontrolled usage.
        this.getSafeState = ()=>{
            return {
                ...this.state,
                ...(0, (/*@__PURE__*/$parcel$interopDefault($8dloj)))(this.props, [
                    'value',
                    'isOpen'
                ]),
                ...(0, (/*@__PURE__*/$parcel$interopDefault($8dloj)))(this.props.selectProps, [
                    'inputValue'
                ])
            };
        };
        this.isDateDisabled = (date)=>{
            return this.props.disabled.indexOf(date) > -1;
        };
        this.onCalendarChange = ({ iso: iso })=>{
            const [year, month, date] = iso.split('-');
            let newIso = iso;
            const parsedDate = parseInt(date, 10);
            const parsedMonth = parseInt(month, 10);
            const parsedYear = parseInt(year, 10);
            const lastDayInMonth = (0, $eztWc.default)(new Date(parsedYear, parsedMonth - 1) // This needs to be -1, because the Date constructor expects an index of the given month
            ).getDate();
            if (lastDayInMonth < parsedDate) newIso = `${year}-${(0, $7i5dr.padToTwo)(parsedMonth)}-${(0, $7i5dr.padToTwo)(lastDayInMonth)}`;
            else newIso = `${year}-${(0, $7i5dr.padToTwo)(parsedMonth)}-${(0, $7i5dr.padToTwo)(parsedDate)}`;
            this.setState({
                calendarValue: newIso
            });
        };
        this.onCalendarSelect = ({ iso: iso })=>{
            this.setState({
                selectInputValue: '',
                isOpen: false,
                calendarValue: iso,
                value: iso
            });
            this.props.onChange(iso);
            // Not ideal, and the alternative is to place a ref on the inner input of the Select
            // but that would require a lot of extra work on the Select component just for this
            // focus functionality. While that would be the 'right react' way to do it, it doesnt
            // post any other benefits; performance wise, we are only searching within the
            // container, making it quick.
            const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
            innerCombobox?.focus();
            this.setState({
                isOpen: false
            });
        };
        this.onInputClick = ()=>{
            if (!this.props.isDisabled && !this.getSafeState().isOpen) this.setState({
                isOpen: true
            });
        };
        this.onContainerBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (!this.containerRef?.contains(newlyFocusedElement)) {
                this.setState({
                    isOpen: false
                });
                this.props.onBlur(event);
            }
        };
        this.onSelectBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (this.getSafeState().clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else if (!this.containerRef?.contains(newlyFocusedElement)) // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            this.setState({
                isOpen: false,
                isFocused: false
            });
        };
        this.onSelectFocus = (event)=>{
            const { clearingFromIcon: clearingFromIcon, value: value } = this.getSafeState();
            if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else this.setState({
                isOpen: true,
                calendarValue: value,
                isFocused: true
            });
            this.props.onFocus(event);
        };
        this.onTextInput = (event)=>{
            const inputValue = event.target.value;
            if (inputValue) {
                const parsed = this.parseDate(inputValue);
                // Only try to set the date if we have month & day
                if (parsed && (0, $7ueqz.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
                // this is the format expected by the @atlaskit/calendar component
                this.setState({
                    calendarValue: (0, $1ym5t.getShortISOString)(parsed)
                });
            }
            this.setState({
                isOpen: true
            });
        };
        this.onInputKeyDown = (event)=>{
            const { value: value, calendarValue: calendarValue } = this.getSafeState();
            const keyPressed = event.key.toLowerCase();
            // If the input is focused and the calendar is not visible, handle space and enter clicks
            if (!this.state.isOpen && (keyPressed === 'enter' || keyPressed === ' ')) this.setState({
                isOpen: true
            });
            switch(keyPressed){
                case 'escape':
                    // Yes, this is not ideal. The alternative is to be able to place a ref
                    // on the inner input of Select itself, which would require a lot of
                    // extra stuff in the Select component for only this one thing. While
                    // this would be more "React-y", it doesn't seem to pose any other
                    // benefits. Performance-wise, we are only searching within the
                    // container, so it's quick.
                    const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                    innerCombobox?.focus();
                    this.setState({
                        isOpen: false
                    });
                    break;
                case 'backspace':
                case 'delete':
                    {
                        const inputCount = (0, $XHGTv.getBooleanFF)('platform.design-system-team.date-picker-input-a11y-fix_cbbxs') ? 1 : 0;
                        if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) // If being cleared from keyboard, don't change behaviour
                        this.setState({
                            clearingFromIcon: false,
                            value: ''
                        });
                        break;
                    }
                case 'enter':
                    if (!this.state.isOpen) return;
                    // Prevent form submission when a date is selected
                    // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                    // for more details.
                    event.preventDefault();
                    if (!this.isDateDisabled(calendarValue)) {
                        // Get a safe `calendarValue` in case the value exceeds the maximum
                        // allowed by ISO 8601
                        const safeCalendarValue = (0, $1ym5t.getSafeCalendarValue)(calendarValue);
                        const valueChanged = safeCalendarValue !== value;
                        this.setState({
                            selectInputValue: '',
                            isOpen: false,
                            value: safeCalendarValue,
                            calendarValue: safeCalendarValue
                        });
                        if (valueChanged) this.props.onChange(safeCalendarValue);
                    }
                    break;
                default:
                    break;
            }
        };
        this.onClear = ()=>{
            let changedState = {
                value: '',
                calendarValue: this.props.defaultValue || (0, $1ym5t.getShortISOString)(new Date())
            };
            if (!this.props.hideIcon) changedState = {
                ...changedState,
                clearingFromIcon: true
            };
            this.setState(changedState);
            this.props.onChange('');
        };
        this.onSelectChange = (_value, action)=>{
            // Used for native clear event in React Select
            // Triggered when clicking ClearIndicator or backspace with no value
            if (action.action === 'clear') this.onClear();
        };
        this.refCalendar = (ref)=>{
            this.calendarRef = ref;
        };
        this.handleSelectInputChange = (selectInputValue, actionMeta)=>{
            const { onInputChange: onInputChange } = this.props.selectProps;
            if (onInputChange) onInputChange(selectInputValue, actionMeta);
            this.setState({
                selectInputValue: selectInputValue
            });
        };
        this.getContainerRef = (ref)=>{
            const oldRef = this.containerRef;
            this.containerRef = ref;
            // Cause a re-render if we're getting the container ref for the first time
            // as the layered menu requires it for dimension calculation
            if (oldRef == null && ref != null) this.forceUpdate();
        };
        /**
   * There are two props that can change how the date is parsed.
   * The priority of props used is:
   *   1. `parseInputValue`
   *   2. `locale`
   */ this.parseDate = (date)=>{
            const { parseInputValue: parseInputValue, dateFormat: dateFormat } = this.props;
            if (parseInputValue) return parseInputValue(date, dateFormat || (0, $7i5dr.defaultDateFormat));
            const { l10n: l10n } = this.getSafeState();
            return l10n.parseDate(date);
        };
        /**
   * There are multiple props that can change how the date is formatted.
   * The priority of props used is:
   *   1. `formatDisplayLabel`
   *   2. `dateFormat`
   *   3. `locale`
   */ this.formatDate = (value)=>{
            const { formatDisplayLabel: formatDisplayLabel, dateFormat: dateFormat } = this.props;
            const { l10n: l10n } = this.getSafeState();
            if (formatDisplayLabel) return formatDisplayLabel(value, dateFormat || (0, $7i5dr.defaultDateFormat));
            const date = (0, $3xcI8.default)(value);
            return dateFormat ? (0, $EN9B6.default)(date, (0, $jP55W.convertTokens)(dateFormat)) : l10n.formatDate(date);
        };
        this.getPlaceholder = ()=>{
            const { placeholder: placeholder } = this.props;
            if (placeholder) return placeholder;
            const { l10n: l10n } = this.getSafeState();
            return l10n.formatDate((0, $7i5dr.placeholderDatetime));
        };
        this.state = {
            isOpen: this.props.defaultIsOpen,
            isFocused: false,
            clearingFromIcon: false,
            selectInputValue: this.props.selectProps.inputValue || '',
            value: this.props.value || this.props.defaultValue,
            calendarValue: this.props.value || this.props.defaultValue || (0, $1ym5t.getShortISOString)(new Date()),
            l10n: (0, $5cS2Y.createLocalizationProvider)(this.props.locale),
            locale: this.props.locale
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.locale !== prevState.locale) return {
            l10n: (0, $5cS2Y.createLocalizationProvider)(nextProps.locale),
            locale: nextProps.locale
        };
        else return null;
    }
    render() {
        const { appearance: appearance, autoFocus: autoFocus, disabled: disabled, hideIcon: hideIcon, icon: icon, id: id, innerProps: innerProps, isDisabled: isDisabled, disabledDateFilter: disabledDateFilter, maxDate: maxDate, minDate: minDate, isInvalid: isInvalid, label: label, name: name, nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, selectProps: selectProps, spacing: spacing, locale: locale, testId: testId, weekStartDay: weekStartDay } = this.props;
        const { value: value, calendarValue: calendarValue, isOpen: isOpen, selectInputValue: selectInputValue } = this.getSafeState();
        let actualSelectInputValue;
        if ((0, $XHGTv.getBooleanFF)('platform.design-system-team.date-picker-input-a11y-fix_cbbxs')) actualSelectInputValue = selectInputValue || (value ? this.formatDate(value) : undefined);
        else actualSelectInputValue = selectInputValue;
        const menuIsOpen = isOpen && !isDisabled;
        const showClearIndicator = Boolean((value || selectInputValue) && !hideIcon);
        const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : icon;
        const SingleValue = (0, $cJOhG.makeSingleValue)({
            lang: this.props.locale
        });
        const selectComponents = {
            DropdownIndicator: dropDownIcon,
            Menu: $dEsso.Menu,
            SingleValue: SingleValue,
            ...!showClearIndicator && {
                ClearIndicator: (0, $7i5dr.EmptyComponent)
            }
        };
        const { styles: selectStyles = {} } = selectProps;
        const disabledStyle = isDisabled ? {
            pointerEvents: 'none',
            color: "var(--ds-icon-disabled, inherit)"
        } : {};
        const calendarProps = {
            calendarContainerRef: this.containerRef,
            calendarRef: this.refCalendar,
            calendarDisabled: disabled,
            calendarDisabledDateFilter: disabledDateFilter,
            calendarMaxDate: maxDate,
            calendarMinDate: minDate,
            calendarValue: value && (0, $1ym5t.getShortISOString)((0, $3xcI8.default)(value)),
            calendarView: calendarValue,
            onCalendarChange: this.onCalendarChange,
            onCalendarSelect: this.onCalendarSelect,
            calendarLocale: locale,
            calendarWeekStartDay: weekStartDay,
            nextMonthLabel: nextMonthLabel,
            previousMonthLabel: previousMonthLabel
        };
        return(// These event handlers must be on this element because the events come
        // from different child elements.
        /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            ...innerProps,
            role: "presentation",
            onBlur: this.onContainerBlur,
            onClick: this.onInputClick,
            onInput: this.onTextInput,
            onKeyDown: this.onInputKeyDown,
            ref: this.getContainerRef,
            "data-testid": testId && `${testId}--container`
        }, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
            name: name,
            type: "hidden",
            value: value,
            "data-testid": testId && `${testId}--input`
        }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $5wCDk.default), {
            "aria-label": label || undefined,
            appearance: this.props.appearance,
            enableAnimation: false,
            menuIsOpen: menuIsOpen,
            closeMenuOnSelect: true,
            autoFocus: autoFocus,
            inputId: id,
            isDisabled: isDisabled,
            onBlur: this.onSelectBlur,
            onFocus: this.onSelectFocus,
            inputValue: actualSelectInputValue,
            onInputChange: this.handleSelectInputChange,
            components: selectComponents,
            onChange: this.onSelectChange,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            styles: (0, $cEc3i.m)(selectStyles, {
                control: (base)=>({
                        ...base,
                        ...disabledStyle
                    }),
                indicatorsContainer: (base)=>({
                        ...base,
                        paddingLeft: "var(--ds-space-025, 2px)",
                        // ICON_PADDING = 2
                        paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
                    })
            }),
            placeholder: this.getPlaceholder(),
            value: value && {
                label: this.formatDate(value),
                value: value
            },
            ...selectProps,
            ...calendarProps,
            isClearable: true,
            spacing: spacing,
            isInvalid: isInvalid,
            testId: testId
        })));
    }
}
var $a38f1e4301a686fa$export$2e2bcd8739ae039 = (0, $1ngde.default)({
    componentName: 'datePicker',
    packageName: $a38f1e4301a686fa$var$packageName,
    packageVersion: $a38f1e4301a686fa$var$packageVersion
})((0, $2jDha.default)({
    onChange: (0, $hM7RE.default)('atlaskit')({
        action: 'selectedDate',
        actionSubject: 'datePicker',
        attributes: {
            componentName: 'datePicker',
            packageName: $a38f1e4301a686fa$var$packageName,
            packageVersion: $a38f1e4301a686fa$var$packageVersion
        }
    })
})($a38f1e4301a686fa$export$df43d21f5faca9f7));

});
parcelRegister("8dloj", function(module, exports) {

var $7Smv0 = parcelRequire("7Smv0");

var $224h2 = parcelRequire("224h2");
/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $5fb02174d73b0468$var$pick = $224h2(function(object, paths) {
    return object == null ? {} : $7Smv0(object, paths);
});
module.exports = $5fb02174d73b0468$var$pick;

});
parcelRegister("7Smv0", function(module, exports) {

var $h5G5y = parcelRequire("h5G5y");

var $cj1vT = parcelRequire("cj1vT");
/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $5bbf076b50457091$var$basePick(object, paths) {
    return $h5G5y(object, paths, function(value, path) {
        return $cj1vT(object, path);
    });
}
module.exports = $5bbf076b50457091$var$basePick;

});


parcelRegister("5cS2Y", function(module, exports) {

$parcel$export(module.exports, "createLocalizationProvider", () => $86465af92d724b82$export$ea56ca58f08ffa52);

var $1UgKe = parcelRequire("1UgKe");

var $4sIIB = parcelRequire("4sIIB");

var $jsW9o = parcelRequire("jsW9o");
const $86465af92d724b82$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $1UgKe.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date)=>(0, $4sIIB.createDateParser)(normalizedLocale)(date);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
		 * Safari has a bug that returns the wrong month for years 2005 and before.
		 * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
		 * Not all the months fail in each year. To ensure the correct output,
		 * we select 2020 as the base year for the whole date,
		 * then we replace in the result the original input year
		 */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $jsW9o.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $jsW9o.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
		 * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
		 * We fix it by detecting the real time with getHours method
		 */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};

});
parcelRegister("1UgKe", function(module, exports) {

$parcel$export(module.exports, "normalizeLocale", () => $ff27e1f10dff7b66$export$dca0327c9b9c6498);
const $ff27e1f10dff7b66$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');

});

parcelRegister("4sIIB", function(module, exports) {

$parcel$export(module.exports, "createDateParser", () => $eeb4480d7ef4717c$export$cfa2ef2687faeda2);

var $ccks3 = parcelRequire("ccks3");

var $1UgKe = parcelRequire("1UgKe");
const $eeb4480d7ef4717c$var$INVALID_DATE = new Date(NaN);
const $eeb4480d7ef4717c$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $eeb4480d7ef4717c$var$INVARIANT_DATE = (0, $ccks3.toDate)($eeb4480d7ef4717c$var$INVARIANT);
const $eeb4480d7ef4717c$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $eeb4480d7ef4717c$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $eeb4480d7ef4717c$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $eeb4480d7ef4717c$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $eeb4480d7ef4717c$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $1UgKe.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($eeb4480d7ef4717c$var$INVARIANT_DATE);
    const shortDate = $eeb4480d7ef4717c$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($eeb4480d7ef4717c$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $eeb4480d7ef4717c$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($eeb4480d7ef4717c$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($eeb4480d7ef4717c$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($eeb4480d7ef4717c$var$INVARIANT.day);
    return (date)=>{
        const dateMatch = $eeb4480d7ef4717c$var$stripExtras(date).match($eeb4480d7ef4717c$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $eeb4480d7ef4717c$var$INVALID_DATE;
        const dateParts = $eeb4480d7ef4717c$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $ccks3.normalizeDate)(extractedDate);
        if (!(0, $ccks3.isValid)(normalizedDate)) return $eeb4480d7ef4717c$var$INVALID_DATE;
        return (0, $ccks3.toDate)(normalizedDate);
    };
};

});
parcelRegister("ccks3", function(module, exports) {

$parcel$export(module.exports, "toDate", () => $f0db4dd5fecddc7d$export$e67a095c620b86fe);
$parcel$export(module.exports, "isValid", () => $f0db4dd5fecddc7d$export$1ea939691cdc45b8);
$parcel$export(module.exports, "normalizeDate", () => $f0db4dd5fecddc7d$export$fcc71269590ba0a8);
/**
 * A numerical representation of a date:
 *  - year: any positive integer
 *  - month: 1 - 12 (Jan - Dec)
 *  - day: 1 - [28, 29, 30, 31] (depending on month)
 */ const $f0db4dd5fecddc7d$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
const $f0db4dd5fecddc7d$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
const $f0db4dd5fecddc7d$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
const $f0db4dd5fecddc7d$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && $f0db4dd5fecddc7d$export$553d7fa8e3805fc0(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
const $f0db4dd5fecddc7d$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = $f0db4dd5fecddc7d$export$f645ddd439eb259d(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
const $f0db4dd5fecddc7d$export$fcc71269590ba0a8 = (date)=>{
    const now = $f0db4dd5fecddc7d$export$abe96da78d4f59dd(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};

});


parcelRegister("jsW9o", function(module, exports) {

$parcel$export(module.exports, "toFormattedParts", () => $e7d91a8396bb549f$export$9b7ca29af37c192);
const $e7d91a8396bb549f$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});

});


parcelRegister("7i5dr", function(module, exports) {

$parcel$export(module.exports, "EmptyComponent", () => $e52f111a686e55c4$export$5e30e9a24d6c1203);
$parcel$export(module.exports, "placeholderDatetime", () => $e52f111a686e55c4$export$fff8babee5abe3e2);
$parcel$export(module.exports, "defaultTimes", () => $e52f111a686e55c4$export$b42ffb9f09b1861b);
$parcel$export(module.exports, "defaultTimeFormat", () => $e52f111a686e55c4$export$9e6d8fcf62256b85);
$parcel$export(module.exports, "defaultDateFormat", () => $e52f111a686e55c4$export$75032c84f56650eb);
$parcel$export(module.exports, "padToTwo", () => $e52f111a686e55c4$export$a7de57e5b672ccdb);
$parcel$export(module.exports, "formatDateTimeZoneIntoIso", () => $e52f111a686e55c4$export$2eeb05a2ecc2ce0a);
/**
 * This component is used to hide portions of Select component.
 */ const $e52f111a686e55c4$export$5e30e9a24d6c1203 = ()=>null;
const $e52f111a686e55c4$export$fff8babee5abe3e2 = new Date(1993, 1, 18, 13);
const $e52f111a686e55c4$export$b42ffb9f09b1861b = [
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00'
];
const $e52f111a686e55c4$export$9e6d8fcf62256b85 = 'h:mma';
const $e52f111a686e55c4$export$75032c84f56650eb = 'YYYY/MM/DD';
function $e52f111a686e55c4$export$a7de57e5b672ccdb(number) {
    return number <= 99 ? `0${number}`.slice(-2) : `${number}`;
}
function $e52f111a686e55c4$export$2eeb05a2ecc2ce0a(date, time, zone) {
    // 12:00 => 12:00, 1:00 => 01:00
    const needsLeadingZero = /^\d:/;
    const sanitizedTime = needsLeadingZero.test(time) ? `0${time}` : time;
    return `${date}T${sanitizedTime}${zone}`;
}

});

parcelRegister("dEsso", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $c845995965375b9a$export$d9b273488cd8ce6f);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $7ueqz = parcelRequire("7ueqz");
var $3xcI8 = parcelRequire("3xcI8");

var $gSA5V = parcelRequire("gSA5V");

var $etCs9 = parcelRequire("etCs9");

var $XHGTv = parcelRequire("XHGTv");

var $PdmhA = parcelRequire("PdmhA");

var $lcnyw = parcelRequire("lcnyw");

var $isGDw = parcelRequire("isGDw");
function $c845995965375b9a$var$getValidDate(iso) {
    const date = (0, $3xcI8.default)(iso);
    return (0, $7ueqz.default)(date) ? {
        day: date.getDate(),
        month: date.getMonth() + 1,
        year: date.getFullYear()
    } : {};
}
const $c845995965375b9a$var$menuStyles = /*#__PURE__*/ (0, $byn9U.css)({
    zIndex: (0, $lcnyw.layers).dialog(),
    backgroundColor: `var(--ds-surface-overlay, ${(0, $PdmhA.N0)})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $PdmhA.N50A)}, 0 0 1px ${(0, $PdmhA.N60A)}`})`,
    overflow: 'hidden'
});
const $c845995965375b9a$export$d9b273488cd8ce6f = ({ selectProps: selectProps, innerProps: innerProps })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $etCs9.UNSAFE_LAYERING), {
        isDisabled: (0, $XHGTv.getBooleanFF)('platform.design-system-team.layering_qmiw3') ? false : true
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $isGDw.default), {
        inputValue: selectProps.inputValue,
        containerRef: selectProps.calendarContainerRef,
        content: /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $c845995965375b9a$var$menuStyles,
            ...innerProps
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $gSA5V.default), {
            ...$c845995965375b9a$var$getValidDate(selectProps.calendarValue),
            ...$c845995965375b9a$var$getValidDate(selectProps.calendarView),
            disabled: selectProps.calendarDisabled,
            disabledDateFilter: selectProps.calendarDisabledDateFilter,
            minDate: selectProps.calendarMinDate,
            maxDate: selectProps.calendarMaxDate,
            nextMonthLabel: selectProps.nextMonthLabel,
            onChange: selectProps.onCalendarChange,
            onSelect: selectProps.onCalendarSelect,
            previousMonthLabel: selectProps.previousMonthLabel,
            calendarRef: selectProps.calendarRef,
            selected: [
                selectProps.calendarValue
            ],
            locale: selectProps.calendarLocale,
            testId: selectProps.testId && `${selectProps.testId}--calendar`,
            weekStartDay: selectProps.calendarWeekStartDay
        })),
        testId: selectProps.testId
    }));

});
parcelRegister("gSA5V", function(module, exports) {

$parcel$export(module.exports, "default", () => $1af99c613641f933$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $5Q9wj = parcelRequire("5Q9wj");

var $b5IAe = parcelRequire("b5IAe");
var $1zbEq = parcelRequire("1zbEq");
var $1ZAYh = parcelRequire("1ZAYh");

var $iXbgj = parcelRequire("iXbgj");

var $1IWJO = parcelRequire("1IWJO");

var $dydFN = parcelRequire("dydFN");

var $ergjS = parcelRequire("ergjS");

var $boty7 = parcelRequire("boty7");

var $lGc1K = parcelRequire("lGc1K");

var $01Rd0 = parcelRequire("01Rd0");

var $aaAaO = parcelRequire("aaAaO");

var $kJhEz = parcelRequire("kJhEz");

var $jFxm9 = parcelRequire("jFxm9");

var $jBW6h = parcelRequire("jBW6h");

var $fUeB0 = parcelRequire("fUeB0");
const $1af99c613641f933$var$boxStyles = (0, $1ZAYh.xcss)({
    display: 'inline-block',
    userSelect: 'none'
});
const $1af99c613641f933$var$analyticsAttributes = {
    componentName: 'calendar',
    packageName: undefined,
    packageVersion: undefined
};
const $1af99c613641f933$var$InnerCalendar = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function Calendar({ day: day, defaultDay: defaultDay = 0, defaultMonth: defaultMonth = 0, defaultPreviouslySelected: defaultPreviouslySelected = (0, $ergjS.blankStringArray), defaultSelected: defaultSelected = (0, $ergjS.blankStringArray), defaultYear: defaultYear = 0, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDate, maxDate: maxDate, month: month, nextMonthLabel: nextMonthLabel, onBlur: onBlur = (0, $5Q9wj.default), onChange: onChange = (0, $5Q9wj.default), onFocus: onFocus = (0, $5Q9wj.default), onSelect: onSelect = (0, $5Q9wj.default), previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, today: today, locale: locale = 'en-US', year: year, analyticsContext: analyticsContext, weekStartDay: weekStartDay = 0, testId: testId, calendarRef: calendarRef, className: className, style: style, tabIndex: tabIndex = 0 }, ref) {
    const { day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], today: [todayValue], selected: [selectedValue, setSelectedValue], previous: [previouslySelectedValue, setPreviouslySelectedValue] } = (0, $lGc1K.default)({
        day: day,
        defaultDay: defaultDay,
        month: month,
        defaultMonth: defaultMonth,
        year: year,
        defaultYear: defaultYear,
        today: today,
        selected: selected,
        defaultSelected: defaultSelected,
        previouslySelected: previouslySelected,
        defaultPreviouslySelected: defaultPreviouslySelected
    });
    const [shouldSetFocus, setShouldSetFocus] = (0, $eUqFw.useState)(false);
    const onChangeWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        ...$1af99c613641f933$var$analyticsAttributes
    });
    const { navigate: navigate, handleClickNext: handleClickNext, handleClickPrev: handleClickPrev } = (0, $kJhEz.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        shouldSetFocus: [
            shouldSetFocus,
            setShouldSetFocus
        ],
        onChange: onChangeWithAnalytics
    });
    const onSelectWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onSelect,
        action: 'selected',
        analyticsData: analyticsContext,
        ...$1af99c613641f933$var$analyticsAttributes
    });
    const { handleClickDay: handleClickDay, handleContainerKeyDown: handleContainerKeyDown } = (0, $jFxm9.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            ,
            setPreviouslySelectedValue
        ],
        onSelect: onSelectWithAnalytics,
        navigate: navigate
    });
    const { handleContainerBlur: handleContainerBlur, handleContainerFocus: handleContainerFocus } = (0, $01Rd0.default)({
        onFocus: onFocus,
        onBlur: onBlur
    });
    (0, $boty7.default)(calendarRef, {
        navigate: navigate
    });
    const { monthsLong: monthsLong, daysShort: daysShort, daysLong: daysLong } = (0, $jBW6h.default)({
        locale: locale,
        weekStartDay: weekStartDay
    });
    const weeks = (0, $aaAaO.default)({
        day: dayValue,
        month: monthValue,
        year: yearValue,
        today: todayValue,
        selected: selectedValue,
        previouslySelected: previouslySelectedValue,
        disabled: disabled,
        disabledDateFilter: disabledDateFilter,
        minDate: minDate,
        maxDate: maxDate,
        daysLong: daysLong,
        weekStartDay: weekStartDay
    });
    const getNextHeading = ()=>{
        // Next month is (currentMonth - 1) + 1, or just currentMonth in this
        // instance.
        const nextMonth = monthValue % 12;
        const showNextYear = monthValue === 12;
        return `${monthsLong[nextMonth]} ${showNextYear ? yearValue + 1 : yearValue}`;
    };
    const getPreviousHeading = ()=>{
        // Previous month is (monthValue - 1) - 1. Need to add 12 so the modulo
        // works as expected and stays positive.
        const previousMonth = (monthValue + 12 - 2) % 12;
        const showPreviousYear = monthValue === 1;
        return `${monthsLong[previousMonth]} ${showPreviousYear ? yearValue - 1 : yearValue}`;
    };
    const headerId = (0, $fUeB0.default)('month-year-header');
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        onBlur: handleContainerBlur,
        onFocus: handleContainerFocus,
        "data-testid": testId && `${testId}--container`,
        ref: ref
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        xcss: $1af99c613641f933$var$boxStyles,
        padding: "space.200",
        "aria-label": "calendar",
        testId: testId && `${testId}--calendar`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1zbEq.default), {
        space: "space.150"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $iXbgj.default), {
        // The month number needs to be translated to index in the month
        // name array e.g. 1 (January) -> 0
        monthLongTitle: monthsLong[monthValue - 1],
        year: yearValue,
        nextMonthLabel: nextMonthLabel,
        previousMonthLabel: previousMonthLabel,
        nextHeading: getNextHeading(),
        previousHeading: getPreviousHeading(),
        handleClickNext: handleClickNext,
        handleClickPrev: handleClickPrev,
        headerId: headerId,
        tabIndex: tabIndex,
        testId: testId
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        role: "grid",
        onKeyDown: handleContainerKeyDown,
        "aria-labelledby": headerId,
        testId: testId && `${testId}--calendar-dates`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $dydFN.default), {
        daysShort: daysShort,
        testId: testId
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $1IWJO.default), {
        weeks: weeks,
        handleClickDay: handleClickDay,
        monthsLong: monthsLong,
        shouldSetFocus: shouldSetFocus,
        tabIndex: tabIndex,
        testId: testId
    })))));
});
/**
 * __Calendar__
 *
 * A calendar is used for date selection.
 *
 * - [Examples](https://atlassian.design/components/calendar/examples)
 * - [Code](https://atlassian.design/components/calendar/code)
 * - [Usage](https://atlassian.design/components/calendar/usage)
 */ const $1af99c613641f933$var$Calendar = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Calendar(props, ref) {
    return /*#__PURE__*/ (0, $byn9U.jsx)($1af99c613641f933$var$InnerCalendar, {
        ...props,
        ref: ref
    });
}));
$1af99c613641f933$var$Calendar.displayName = 'Calendar';
var $1af99c613641f933$export$2e2bcd8739ae039 = $1af99c613641f933$var$Calendar;

});
parcelRegister("iXbgj", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd89dfd89a56bcc4$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $j9fWg = parcelRequire("j9fWg");

var $hI5oG = parcelRequire("hI5oG");

var $dXKde = parcelRequire("dXKde");

var $dwj4T = parcelRequire("dwj4T");

var $b5IAe = parcelRequire("b5IAe");
var $9Amv1 = parcelRequire("9Amv1");

var $fUeB0 = parcelRequire("fUeB0");
const $fd89dfd89a56bcc4$var$Header = /*#__PURE__*/ (0, $eUqFw.memo)(function Header({ monthLongTitle: monthLongTitle, year: year, previousMonthLabel: previousMonthLabel = 'Previous month', previousHeading: previousHeading, nextMonthLabel: nextMonthLabel = 'Next month', nextHeading: nextHeading, handleClickPrev: handleClickPrev, handleClickNext: handleClickNext, headerId: headerId, tabIndex: tabIndex, testId: testId }) {
    const announceId = (0, $fUeB0.default)('month-year-announce');
    // All of this is because `aria-atomic` is not fully supported for different
    // assistive technologies. We want the value of the current month and year to
    // be announced, but *only* if that value has been interacted with since
    // being mounted. This allows us to conditionally apply the `aria-live`
    // attribute.  Without this, the `aria-live` property is set on mount and
    // overrides the default input's readout in downstream consumers (e.g.
    // datetime picker).
    const [hasInteractedWithMonth, setHasInteractedWithMonth] = (0, $eUqFw.useState)(false);
    const handlePrevMonthInteraction = (e)=>{
        if (!hasInteractedWithMonth) setHasInteractedWithMonth(true);
        handleClickPrev(e);
    };
    const handleNextMonthInteraction = (e)=>{
        if (!hasInteractedWithMonth) setHasInteractedWithMonth(true);
        handleClickNext(e);
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9Amv1.default), {
        space: "space.0",
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $j9fWg.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handlePrevMonthInteraction,
        testId: testId && `${testId}--previous-month`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dXKde))),
        label: `${previousMonthLabel}, ${previousHeading}`
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        "aria-live": hasInteractedWithMonth ? 'polite' : undefined,
        id: announceId,
        testId: testId && `${testId}--current-month-year--container`
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $hI5oG.default), {
        size: "xsmall",
        as: "h2",
        id: headerId,
        testId: testId && `${testId}--current-month-year`
    }, `${monthLongTitle} ${year}`)), /*#__PURE__*/ (0, $byn9U.jsx)((0, $j9fWg.default), {
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex,
        onClick: handleNextMonthInteraction,
        testId: testId && `${testId}--next-month`,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dwj4T))),
        label: `${nextMonthLabel}, ${nextHeading}`
    })));
});
$fd89dfd89a56bcc4$var$Header.displayName = 'Header';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fd89dfd89a56bcc4$export$2e2bcd8739ae039 = $fd89dfd89a56bcc4$var$Header;

});
parcelRegister("dXKde", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a2a4a1e4b9148f86$var$_react = $a2a4a1e4b9148f86$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $a2a4a1e4b9148f86$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $a2a4a1e4b9148f86$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $a2a4a1e4b9148f86$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M9.005 10.995l4.593-4.593a.99.99 0 111.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 01-1.4 1.4L9.005 12.41a1 1 0 010-1.414z"/></svg>`
    }, props));
$a2a4a1e4b9148f86$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $a2a4a1e4b9148f86$var$_default = $a2a4a1e4b9148f86$var$ChevronLeftLargeIcon;
module.exports.default = $a2a4a1e4b9148f86$var$_default;

});

parcelRegister("dwj4T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9d7d0ffff46f5f00$var$_react = $9d7d0ffff46f5f00$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $9d7d0ffff46f5f00$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9d7d0ffff46f5f00$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $9d7d0ffff46f5f00$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentColor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 010 1.414l-4.593 4.593a.99.99 0 01-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 011.4-1.4l4.593 4.593z"/></svg>`
    }, props));
$9d7d0ffff46f5f00$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $9d7d0ffff46f5f00$var$_default = $9d7d0ffff46f5f00$var$ChevronRightLargeIcon;
module.exports.default = $9d7d0ffff46f5f00$var$_default;

});

parcelRegister("fUeB0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b40d1eadda8cdb8f$export$2e2bcd8739ae039);

var $jFtVs = parcelRequire("jFtVs");
function $b40d1eadda8cdb8f$export$2e2bcd8739ae039(prefix) {
    const seed = (0, $jFtVs.useUIDSeed)();
    return `${prefix}-${seed(prefix)}`;
}

});


parcelRegister("1IWJO", function(module, exports) {

$parcel$export(module.exports, "default", () => $e06105409509e654$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $b5IAe = parcelRequire("b5IAe");

var $lNcDQ = parcelRequire("lNcDQ");

var $n5aAA = parcelRequire("n5aAA");
const $e06105409509e654$var$WeekDays = /*#__PURE__*/ (0, $eUqFw.memo)(function WeekDays({ weeks: weeks, handleClickDay: handleClickDay, monthsLong: monthsLong, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
        role: "rowgroup",
        testId: testId && `${testId}--month`
    }, weeks.map((week, i)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $n5aAA.default), {
            key: i,
            testId: testId && `${testId}--week`
        }, week.values.map((weekDay)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $lNcDQ.default), {
                key: `${week.id}-${weekDay.id}`,
                isDisabled: weekDay.isDisabled,
                isFocused: weekDay.isFocused,
                isToday: weekDay.isToday,
                dayLong: weekDay.weekDayName,
                month: weekDay.month,
                monthLong: monthsLong[weekDay.month - 1],
                onClick: handleClickDay,
                isPreviouslySelected: weekDay.isPreviouslySelected,
                isSelected: weekDay.isSelected,
                isSibling: weekDay.isSiblingMonth,
                year: weekDay.year,
                shouldSetFocus: shouldSetFocus,
                tabIndex: tabIndex,
                testId: testId
            }, weekDay.day)))));
});
$e06105409509e654$var$WeekDays.displayName = 'WeekDays';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e06105409509e654$export$2e2bcd8739ae039 = $e06105409509e654$var$WeekDays;

});
parcelRegister("lNcDQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $be7321a8185a5350$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $5Q9wj = parcelRequire("5Q9wj");

var $27KYr = parcelRequire("27KYr");

var $hsbXD = parcelRequire("hsbXD");
const $be7321a8185a5350$var$Date = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Date({ children: day, isDisabled: isDisabled = false, isFocused: isFocused = false, isToday: isToday = false, dayLong: dayLong, month: month, monthLong: monthLong, onClick: onClick = (0, $5Q9wj.default), isPreviouslySelected: isPreviouslySelected = false, isSelected: isSelected = false, isSibling: isSibling = false, year: year, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }, _ref) {
    const dateRef = (0, $eUqFw.useRef)({
        day: day,
        month: month,
        year: year,
        isDisabled: isDisabled
    });
    (0, $eUqFw.useEffect)(()=>{
        dateRef.current = {
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        };
    }, [
        day,
        month,
        year,
        isDisabled
    ]);
    const focusRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
    }, [
        isFocused,
        shouldSetFocus
    ]);
    const handleClick = (0, $eUqFw.useCallback)(()=>{
        const { day: dayValue, month: monthValue, year: yearValue, isDisabled: isDisabledValue } = dateRef.current;
        if (!isDisabledValue) onClick({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
    }, [
        onClick
    ]);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const dateCellStyles = /*#__PURE__*/ (0, $byn9U.css)((0, $hsbXD.dateCellStyles)());
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $27KYr.default), {
        role: "gridcell",
        alignItems: "center"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("button", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: dateCellStyles,
        "aria-current": isToday ? 'date' : undefined,
        "aria-disabled": isDisabled || undefined,
        "aria-label": `${day}, ${dayLong} ${monthLong} ${year}`,
        "aria-pressed": isSelected ? 'true' : 'false',
        tabIndex: isFocused ? tabIndex : -1,
        type: "button",
        onClick: handleClick,
        ref: focusRef,
        "data-disabled": isDisabled || undefined,
        "data-focused": isFocused || undefined,
        "data-prev-selected": isPreviouslySelected || undefined,
        "data-selected": isSelected || undefined,
        "data-sibling": isSibling || undefined,
        "data-today": isToday || undefined,
        "data-testid": testId && (isSelected ? `${testId}--selected-day` : `${testId}--day`)
    }, day));
}));
$be7321a8185a5350$var$Date.displayName = 'Date';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$be7321a8185a5350$export$2e2bcd8739ae039 = $be7321a8185a5350$var$Date;

});
parcelRegister("hsbXD", function(module, exports) {

$parcel$export(module.exports, "dateCellStyles", () => $be03e6720d201133$export$f62807af68630d86);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $PdmhA = parcelRequire("PdmhA");
const $be03e6720d201133$export$f62807af68630d86 = ()=>({
        all: 'unset',
        display: 'block',
        padding: `${"var(--ds-space-050, 4px)"} 9px`,
        position: 'relative',
        backgroundColor: 'transparent',
        border: '2px solid transparent',
        borderRadius: 3,
        color: `var(--ds-text, ${0, $PdmhA.N900})`,
        cursor: 'pointer',
        flexGrow: 1,
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        textAlign: 'center',
        '&[data-sibling]': {
            color: `var(--ds-text-subtlest, ${0, $PdmhA.N200})`
        },
        '&[data-today]': {
            color: `var(--ds-text-selected, ${0, $PdmhA.B400})`,
            fontWeight: "var(--ds-font-weight-bold, bold)",
            '&::after': {
                display: 'block',
                height: 2,
                position: 'absolute',
                right: "var(--ds-space-025, 2px)",
                bottom: "var(--ds-space-025, 2px)",
                left: "var(--ds-space-025, 2px)",
                backgroundColor: 'currentColor',
                content: '""'
            }
        },
        '&[data-prev-selected]': {
            backgroundColor: `var(--ds-background-selected, ${0, $PdmhA.B50})`,
            color: `var(--ds-text-subtle, ${0, $PdmhA.N600})`
        },
        '&[data-selected]': {
            backgroundColor: `var(--ds-background-selected, ${0, $PdmhA.N500})`,
            color: `var(--ds-text-selected, ${0, $PdmhA.N0})`
        },
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${0, $PdmhA.N40})`,
            cursor: 'not-allowed'
        },
        '&:focus-visible': {
            border: `2px solid ${`var(--ds-border-focused, ${0, $PdmhA.B200})`}`
        },
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${0, $PdmhA.N30})`,
            color: `var(--ds-text, ${0, $PdmhA.N900})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${0, $PdmhA.B50})`,
            color: `var(--ds-text, ${0, $PdmhA.N900})`
        },
        '&[data-selected]:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${0, $PdmhA.B50})`,
            color: `var(--ds-text-selected, ${0, $PdmhA.N600})`
        },
        '&[data-prev-selected]:hover': {
            color: `var(--ds-text-subtle, ${0, $PdmhA.N600})`
        },
        '&[data-sibling]:hover': {
            color: `var(--ds-text-subtlest, ${0, $PdmhA.N200})`
        },
        '&[data-disabled]:hover': {
            backgroundColor: 'transparent',
            color: `var(--ds-text-disabled, ${0, $PdmhA.N40})`
        }
    });

});


parcelRegister("n5aAA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c35bac64845b7641$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $27KYr = parcelRequire("27KYr");
/**
 * __Week day grid__
 *
 * A week day grid aligns elements in a 7 wide grid layout.
 *
 */ const $c35bac64845b7641$var$WeekDayGrid = ({ testId: testId, children: children, isHidden: isHidden })=>{
    const row = /*#__PURE__*/ (0, $byn9U.jsx)((0, $27KYr.default), {
        testId: testId,
        templateColumns: "repeat(7, minmax(max-content, 1fr))",
        role: "row"
    }, children);
    return isHidden ? /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "aria-hidden": "true"
    }, row) : row;
};
var $c35bac64845b7641$export$2e2bcd8739ae039 = $c35bac64845b7641$var$WeekDayGrid;

});


parcelRegister("dydFN", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b5ed8e7817e4bf0$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $b5IAe = parcelRequire("b5IAe");
var $1Yimi = parcelRequire("1Yimi");
var $1ZAYh = parcelRequire("1ZAYh");

var $n5aAA = parcelRequire("n5aAA");
const $0b5ed8e7817e4bf0$var$columnHeaderStyles = (0, $1ZAYh.xcss)({
    minWidth: 'size.400',
    // Account for languages with short week day names
    whiteSpace: 'nowrap',
    // Account for languages with long week day names
    display: 'flex',
    justifyContent: 'center'
});
const $0b5ed8e7817e4bf0$var$WeekHeader = /*#__PURE__*/ (0, $eUqFw.memo)(function WeekHeader({ daysShort: daysShort, testId: testId }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $n5aAA.default), {
        isHidden: true,
        testId: testId && `${testId}--column-headers`
    }, daysShort.map((shortDay)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $b5IAe.default), {
            padding: "space.100",
            xcss: $0b5ed8e7817e4bf0$var$columnHeaderStyles,
            key: shortDay,
            role: "columnheader",
            testId: testId && `${testId}--column-header`
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
            weight: "bold",
            size: "UNSAFE_small",
            align: "center",
            color: "color.text.subtle"
        }, shortDay))));
});
$0b5ed8e7817e4bf0$var$WeekHeader.displayName = 'WeekHeader';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0b5ed8e7817e4bf0$export$2e2bcd8739ae039 = $0b5ed8e7817e4bf0$var$WeekHeader;

});

parcelRegister("ergjS", function(module, exports) {

$parcel$export(module.exports, "arrowKeys", () => $caa546bae879d9aa$export$8b15eca9c6d5c48a);
$parcel$export(module.exports, "daysPerWeek", () => $caa546bae879d9aa$export$3ae905d9742bef55);
$parcel$export(module.exports, "monthsPerYear", () => $caa546bae879d9aa$export$c9b7c010035d60c6);
$parcel$export(module.exports, "blankStringArray", () => $caa546bae879d9aa$export$8fa20d70624f8b9d);
const $caa546bae879d9aa$export$8b15eca9c6d5c48a = {
    ArrowDown: 'down',
    ArrowLeft: 'left',
    ArrowRight: 'right',
    ArrowUp: 'up'
};
const $caa546bae879d9aa$export$3ae905d9742bef55 = 7;
const $caa546bae879d9aa$export$c9b7c010035d60c6 = 12;
const $caa546bae879d9aa$export$8fa20d70624f8b9d = [];

});

parcelRegister("boty7", function(module, exports) {

$parcel$export(module.exports, "default", () => $986db25f452819ee$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $986db25f452819ee$export$2e2bcd8739ae039(calendarRef, { navigate: navigate }) {
    (0, $eUqFw.useImperativeHandle)(calendarRef, ()=>({
            navigate: navigate
        }), [
        navigate
    ]);
}

});

parcelRegister("lGc1K", function(module, exports) {

$parcel$export(module.exports, "default", () => $16ff190d3d2aa24b$export$2e2bcd8739ae039);

var $2WwAS = parcelRequire("2WwAS");

var $9pgGL = parcelRequire("9pgGL");

var $gTmDA = parcelRequire("gTmDA");
function $16ff190d3d2aa24b$export$2e2bcd8739ae039({ day: day, defaultDay: defaultDay, month: month, defaultMonth: defaultMonth, year: year, defaultYear: defaultYear, today: today, selected: selected, defaultSelected: defaultSelected, previouslySelected: previouslySelected, defaultPreviouslySelected: defaultPreviouslySelected }) {
    const { current: { thisDay: thisDay, thisMonth: thisMonth, thisYear: thisYear } } = (0, $9pgGL.default)(()=>{
        const now = new Date();
        const thisDay = now.getDate();
        const thisMonth = now.getMonth() + 1;
        const thisYear = now.getFullYear();
        return {
            thisDay: thisDay,
            thisMonth: thisMonth,
            thisYear: thisYear
        };
    });
    const [dayValue, setDayValue] = (0, $2WwAS.default)(day, ()=>defaultDay || thisDay);
    const [monthValue, setMonthValue] = (0, $2WwAS.default)(month, ()=>defaultMonth || thisMonth);
    const [yearValue, setYearValue] = (0, $2WwAS.default)(year, ()=>defaultYear || thisYear);
    const [todayValue] = (0, $2WwAS.default)(today, ()=>today || `${thisYear}-${(0, $gTmDA.default)(thisMonth)}-${(0, $gTmDA.default)(thisDay)}`);
    const [selectedValue, setSelectedValue] = (0, $2WwAS.default)(selected, ()=>defaultSelected);
    const [previouslySelectedValue, setPreviouslySelectedValue] = (0, $2WwAS.default)(previouslySelected, ()=>defaultPreviouslySelected);
    return {
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        today: [
            todayValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            previouslySelectedValue,
            setPreviouslySelectedValue
        ]
    };
}

});
parcelRegister("gTmDA", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e118521e98610b7$export$2e2bcd8739ae039);
function $4e118521e98610b7$export$2e2bcd8739ae039(num) {
    return num < 10 ? `0${num}` : `${num}`;
}

});


parcelRegister("01Rd0", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b1f1c7b7e16ff71$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $5b1f1c7b7e16ff71$export$2e2bcd8739ae039({ onBlur: onBlur, onFocus: onFocus }) {
    const handleContainerBlur = (0, $eUqFw.useCallback)((event)=>{
        onBlur(event);
    }, [
        onBlur
    ]);
    const handleContainerFocus = (0, $eUqFw.useCallback)((event)=>{
        onFocus(event);
    }, [
        onFocus
    ]);
    return {
        handleContainerBlur: handleContainerBlur,
        handleContainerFocus: handleContainerFocus
    };
}

});

parcelRegister("aaAaO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5a06340eae1cb34$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3xcI8 = parcelRequire("3xcI8");

var $ergjS = parcelRequire("ergjS");

var $bViNq = parcelRequire("bViNq");

var $f9hmQ = parcelRequire("f9hmQ");
function $c5a06340eae1cb34$var$useGetCalendarWithSixthWeek(calendar, { month: month, year: year, weekStartDay: weekStartDay }) {
    const shouldDisplaySixthWeek = calendar.length % 6;
    const calendarLastValue = calendar[calendar.length - 1];
    return (0, $eUqFw.useMemo)(()=>{
        // Some months jump between 5 and 6 weeks to display. In some cases 4 (Feb
        // with the 1st on a Monday etc). This ensures the UI doesn't jump around by
        // catering to always showing 6 weeks.
        if (shouldDisplaySixthWeek) {
            const lastDayIsSibling = calendarLastValue.siblingMonth;
            const sliceStart = lastDayIsSibling ? (0, $ergjS.daysPerWeek) : 0;
            return (0, $f9hmQ.default)(year, month, {
                weekStartDay: weekStartDay
            }).slice(sliceStart, sliceStart + (0, $ergjS.daysPerWeek)).map((date)=>({
                    ...date,
                    siblingMonth: true
                }));
        }
    }, [
        calendarLastValue,
        month,
        shouldDisplaySixthWeek,
        weekStartDay,
        year
    ]);
}
function $c5a06340eae1cb34$export$2e2bcd8739ae039({ day: day, daysLong: daysLong, month: month, year: year, today: today, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDateString, maxDate: maxDateString, selected: selected, previouslySelected: previouslySelected, weekStartDay: weekStartDay }) {
    const calendar = (0, $eUqFw.useMemo)(()=>(0, $f9hmQ.default)(year, month - 1, {
            weekStartDay: weekStartDay
        }), [
        month,
        weekStartDay,
        year
    ]);
    const calendarWithSixthWeek = $c5a06340eae1cb34$var$useGetCalendarWithSixthWeek(calendar, {
        month: month,
        year: year,
        weekStartDay: weekStartDay
    });
    if (calendarWithSixthWeek) calendar.push(...calendarWithSixthWeek);
    const minDate = minDateString ? (0, $3xcI8.default)(minDateString) : undefined;
    const maxDate = maxDateString ? (0, $3xcI8.default)(maxDateString) : undefined;
    const needJsDate = minDateString || maxDateString;
    return (0, $eUqFw.useMemo)(()=>{
        const weeks = [];
        calendar.forEach((date)=>{
            const dateAsString = (0, $bViNq.default)(date, {
                fixMonth: true
            });
            const JSDate = needJsDate ? (0, $3xcI8.default)(dateAsString) : undefined;
            let week;
            if (date.weekDay === weekStartDay) {
                week = {
                    id: dateAsString,
                    values: []
                };
                weeks.push(week);
            } else week = weeks[weeks.length - 1];
            const weekDayOffset = (date.weekDay - weekStartDay) % 7;
            // Define a bunch of `const`s
            const weekDayName = daysLong[weekDayOffset];
            const isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
            const isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
            const isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
            const isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
            const isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
            const isFocused = day === date.day && !date.siblingMonth;
            const isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
            const isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
            const isSiblingMonth = !!date.siblingMonth;
            const isToday = today === dateAsString;
            week.values.push({
                id: dateAsString,
                isDisabled: isDisabled,
                isFocused: isFocused,
                isToday: isToday,
                month: date.month + 1,
                isPreviouslySelected: isPreviouslySelected,
                isSelected: isSelected,
                isSiblingMonth: isSiblingMonth,
                year: date.year,
                day: date.day,
                weekDayName: weekDayName
            });
        });
        return weeks;
    }, [
        calendar,
        day,
        disabled,
        disabledDateFilter,
        minDate,
        maxDate,
        needJsDate,
        previouslySelected,
        selected,
        today,
        weekStartDay,
        daysLong
    ]);
}

});
parcelRegister("bViNq", function(module, exports) {

$parcel$export(module.exports, "default", () => $18b8c563db2aa2af$export$2e2bcd8739ae039);

var $gTmDA = parcelRequire("gTmDA");
function $18b8c563db2aa2af$export$2e2bcd8739ae039(date, options) {
    return `${date.year}-${(0, $gTmDA.default)(date.month + (options && options.fixMonth ? 1 : 0))}-${(0, $gTmDA.default)(date.day)}`;
}

});

parcelRegister("f9hmQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c51fbd108798174$export$2e2bcd8739ae039);
/**
 * Logic taken from https://github.com/WesSouza/calendar-base which is not maintained for quite sometime.
 * This will help us fixing any issue we might get or any new functionality we might want to support.
 * Not changing much code below. Just removed those parts which we don't need.
 */ 
var $ergjS = parcelRequire("ergjS");

var $2WiSD = parcelRequire("2WiSD");
function $4c51fbd108798174$export$2e2bcd8739ae039(year, month, { weekStartDay: weekStartDay = 0 } = {
    weekStartDay: 0
}) {
    const date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
    const utcYear = date.getUTCFullYear();
    const utcMonth = date.getUTCMonth();
    const calendar = [];
    const firstDay = date.getUTCDay();
    const firstDate = -(((0, $ergjS.daysPerWeek) - weekStartDay + firstDay) % (0, $ergjS.daysPerWeek));
    const lastDate = (0, $2WiSD.default)(utcYear, utcMonth);
    const lastDay = (lastDate - firstDate) % (0, $ergjS.daysPerWeek);
    const lastDateOfPreviousMonth = (0, $2WiSD.default)(utcYear, utcMonth - 1);
    let dateCounter = firstDate;
    let currentDay;
    let currentDate;
    let currentDateObject = null;
    let calculatedMonth;
    let calculatedYear;
    const maxDateCount = lastDate - dateCounter + (lastDay !== 0 ? (0, $ergjS.daysPerWeek) - lastDay : 0) + firstDate;
    while(dateCounter < maxDateCount){
        currentDate = dateCounter + 1;
        currentDay = ((dateCounter < 1 ? (0, $ergjS.daysPerWeek) + dateCounter : dateCounter) + firstDay) % (0, $ergjS.daysPerWeek);
        if (currentDate < 1 || currentDate > lastDate) {
            if (currentDate < 1) {
                calculatedMonth = utcMonth - 1;
                calculatedYear = utcYear;
                if (calculatedMonth < 0) {
                    calculatedMonth = (0, $ergjS.monthsPerYear) - 1;
                    calculatedYear--;
                }
                currentDate = lastDateOfPreviousMonth + currentDate;
            } else if (currentDate > lastDate) {
                calculatedMonth = utcMonth + 1;
                calculatedYear = utcYear;
                if (calculatedMonth > (0, $ergjS.monthsPerYear) - 1) {
                    calculatedMonth = 0;
                    calculatedYear++;
                }
                currentDate = dateCounter - lastDate + 1;
            }
            if (calculatedMonth !== undefined && calculatedYear !== undefined) currentDateObject = {
                day: currentDate,
                weekDay: currentDay,
                month: calculatedMonth,
                year: calculatedYear,
                siblingMonth: true
            };
        } else currentDateObject = {
            day: currentDate,
            weekDay: currentDay,
            month: utcMonth,
            year: utcYear
        };
        calendar.push(currentDateObject);
        dateCounter++;
    }
    return calendar;
}

});
parcelRegister("2WiSD", function(module, exports) {

$parcel$export(module.exports, "default", () => $907d26aeb7ef5d98$export$2e2bcd8739ae039);
function $907d26aeb7ef5d98$export$2e2bcd8739ae039(year, month) {
    return new Date(year, month + 1, 0).getDate();
}

});



parcelRegister("kJhEz", function(module, exports) {

$parcel$export(module.exports, "default", () => $678baae139881731$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ergjS = parcelRequire("ergjS");

var $bViNq = parcelRequire("bViNq");

var $2WiSD = parcelRequire("2WiSD");
const $678baae139881731$var$getNextMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === (0, $ergjS.monthsPerYear)) {
        month = 1;
        year += 1;
    } else month += 1;
    return {
        month: month,
        year: year
    };
};
const $678baae139881731$var$getPrevMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === 1) {
        month = (0, $ergjS.monthsPerYear);
        year -= 1;
    } else month -= 1;
    return {
        month: month,
        year: year
    };
};
function $678baae139881731$export$2e2bcd8739ae039({ day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], shouldSetFocus: [_shouldSetFocus, setShouldSetFocus], onChange: onChange }) {
    const dateRef = (0, $eUqFw.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $eUqFw.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnChange = (0, $eUqFw.useCallback)(({ year: year, month: month, day: day, type: type })=>{
        const iso = (0, $bViNq.default)({
            year: year,
            month: month,
            day: day
        });
        const isFocusableType = [
            'up',
            'down',
            'left',
            'right'
        ].includes(type);
        onChange({
            day: day,
            month: month,
            year: year,
            iso: iso,
            type: type
        });
        setDayValue(day);
        setMonthValue(month);
        setYearValue(year);
        setShouldSetFocus(isFocusableType);
    }, [
        onChange,
        setDayValue,
        setMonthValue,
        setYearValue,
        setShouldSetFocus
    ]);
    const navigate = (0, $eUqFw.useCallback)((type)=>{
        const { day: day, month: month, year: year } = dateRef.current;
        if (type === 'down') {
            const next = day + (0, $ergjS.daysPerWeek);
            const daysInMonth = (0, $2WiSD.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $678baae139881731$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: next - daysInMonth,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'left') {
            const prev = day - 1;
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $678baae139881731$var$getPrevMonth(month, year);
                const prevDay = (0, $2WiSD.default)(prevYear, prevMonth - 1);
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        } else if (type === 'right') {
            const next = day + 1;
            const daysInMonth = (0, $2WiSD.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $678baae139881731$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: 1,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'up') {
            const prev = day - (0, $ergjS.daysPerWeek);
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $678baae139881731$var$getPrevMonth(month, year);
                const prevDay = (0, $2WiSD.default)(prevYear, prevMonth - 1) + prev;
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        }
    }, [
        triggerOnChange
    ]);
    const handleClickNext = (0, $eUqFw.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$678baae139881731$var$getNextMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'next'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrev = (0, $eUqFw.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$678baae139881731$var$getPrevMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'prev'
        });
    }, [
        triggerOnChange
    ]);
    return {
        navigate: navigate,
        handleClickNext: handleClickNext,
        handleClickPrev: handleClickPrev
    };
}

});

parcelRegister("jFxm9", function(module, exports) {

$parcel$export(module.exports, "default", () => $648acf144993a0ec$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ergjS = parcelRequire("ergjS");

var $bViNq = parcelRequire("bViNq");
function $648acf144993a0ec$export$2e2bcd8739ae039({ day: [dayValue], month: [monthValue], year: [yearValue], selected: [selectedValue, setSelectedValue], previous: [, setPreviouslySelectedValue], onSelect: onSelect, navigate: navigate }) {
    const dateRef = (0, $eUqFw.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $eUqFw.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnSelect = (0, $eUqFw.useCallback)(({ year: year, month: month, day: day })=>{
        const iso = (0, $bViNq.default)({
            year: year,
            month: month,
            day: day
        });
        onSelect({
            day: day,
            month: month,
            year: year,
            iso: iso
        });
        setPreviouslySelectedValue(selectedValue);
        setSelectedValue([
            iso
        ]);
    }, [
        onSelect,
        selectedValue,
        setPreviouslySelectedValue,
        setSelectedValue
    ]);
    const handleClickDay = (0, $eUqFw.useCallback)(({ year: year, month: month, day: day })=>{
        triggerOnSelect({
            year: year,
            month: month,
            day: day
        });
    }, [
        triggerOnSelect
    ]);
    const handleContainerKeyDown = (0, $eUqFw.useCallback)((e)=>{
        const { key: key } = e;
        const arrowKey = (0, $ergjS.arrowKeys)[key];
        if (key === 'Enter' || key === ' ') {
            e.preventDefault();
            triggerOnSelect(dateRef.current);
        } else if (arrowKey) {
            e.preventDefault();
            navigate(arrowKey);
        }
    }, [
        triggerOnSelect,
        navigate
    ]);
    return {
        handleClickDay: handleClickDay,
        handleContainerKeyDown: handleContainerKeyDown
    };
}

});

parcelRegister("jBW6h", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc9bf1b0468c3ab3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5cS2Y = parcelRequire("5cS2Y");
function $bc9bf1b0468c3ab3$export$2e2bcd8739ae039({ locale: locale, weekStartDay: weekStartDay }) {
    const l10n = (0, $eUqFw.useMemo)(()=>(0, $5cS2Y.createLocalizationProvider)(locale), [
        locale
    ]);
    const monthsLong = (0, $eUqFw.useMemo)(()=>l10n.getMonthsLong(), [
        l10n
    ]);
    const daysShort = (0, $eUqFw.useMemo)(()=>l10n.getDaysShort(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    const daysLong = (0, $eUqFw.useMemo)(()=>l10n.getDaysLong(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    return {
        monthsLong: monthsLong,
        daysShort: daysShort,
        daysLong: daysLong
    };
}

});


parcelRegister("isGDw", function(module, exports) {

$parcel$export(module.exports, "default", () => $164042300001804e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8MHxr = parcelRequire("8MHxr");

var $5Q9wj = parcelRequire("5Q9wj");

var $cAX3Z = parcelRequire("cAX3Z");

var $XHGTv = parcelRequire("XHGTv");

var $8nlzU = parcelRequire("8nlzU");
var $i6BC8 = parcelRequire("i6BC8");
var $6frYP = parcelRequire("6frYP");

var $lcnyw = parcelRequire("lcnyw");
class $164042300001804e$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.inputValue !== this.props.inputValue) this.update();
    }
    render() {
        const { containerRef: containerRef, content: content, testId: testId } = this.props;
        // Wait for containerRef callback to cause a re-render
        if (!containerRef) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null);
        const divStyles = {
            background: 'transparent',
            position: 'absolute',
            top: 0,
            height: containerRef.getBoundingClientRect().height,
            // Don't block the clear button
            width: containerRef.getBoundingClientRect().width - parseInt((0, $cAX3Z.sizes).small.slice(0, -2)) - (0, $lcnyw.gridSize)(),
            ...(0, $XHGTv.getBooleanFF)('platform.design-system-team.date-picker-input-a11y-fix_cbbxs') && {
                pointerEvents: 'none'
            }
        };
        return(/* Need to wrap layer in a fixed position div so that it will render its content as fixed
			 * We need to set the intial top value to where the container is and zIndex so that it still
			 * applies since we're creating a new stacking context. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8nlzU.Manager), null, (0, $XHGTv.getBooleanFF)('platform.design-system-team.remove-scroll-lock-on-datetime-picker_6h6oi') ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8MHxr))), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6frYP.Reference), null, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                ref: ref,
                "data-layer-child": true,
                style: divStyles
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i6BC8.Popper), null, ({ ref: ref, style: style, update: update })=>{
            this.update = update;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
                ref: ref,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: {
                    ...style,
                    zIndex: (0, $lcnyw.layers).dialog()
                },
                "data-testid": testId && `${testId}--popper--container`
            }, content);
        })));
    }
    constructor(...args){
        super(...args);
        this.update = (0, $5Q9wj.default);
    }
}

});


parcelRegister("1ym5t", function(module, exports) {

$parcel$export(module.exports, "getShortISOString", () => $1aa7ae37c35d9611$export$77d5bc49fed7ef14);
$parcel$export(module.exports, "getSafeCalendarValue", () => $1aa7ae37c35d9611$export$ff525416014fb67d);

var $EN9B6 = parcelRequire("EN9B6");

var $jP55W = parcelRequire("jP55W");
function $1aa7ae37c35d9611$export$77d5bc49fed7ef14(date) {
    return (0, $EN9B6.default)(date, (0, $jP55W.convertTokens)('YYYY-MM-DD'));
}
function $1aa7ae37c35d9611$export$ff525416014fb67d(calendarValue) {
    // If `calendarValue` has a year that is greater than 9999, default to
    // today's date
    const yearIsOverLimit = calendarValue.match(/^\d{5,}/);
    if (yearIsOverLimit) return $1aa7ae37c35d9611$export$77d5bc49fed7ef14(new Date());
    return calendarValue;
}

});
parcelRegister("jP55W", function(module, exports) {

$parcel$export(module.exports, "convertTokens", () => $ca62b172b02bdaaf$export$4d5430175be73d45);
// https://github.com/date-fns/date-fns-upgrade/blob/master/src/v2/convertTokens/index.ts
const $ca62b172b02bdaaf$var$tokensMap = {
    // 'D MMMM': '',
    // 'Do MMMM': '',
    // 'DD MMMM': '',
    M: 'L',
    Mo: 'Mo',
    MM: 'LL',
    MMM: 'LLL',
    MMMM: 'LLLL',
    Q: 'q',
    Qo: 'qo',
    D: 'd',
    Do: 'do',
    DD: 'dd',
    DDD: 'D',
    DDDo: 'Do',
    DDDD: 'DDD',
    d: 'i',
    do: 'io',
    dd: 'iiiiii',
    ddd: 'iii',
    dddd: 'iiii',
    A: 'a',
    a: 'a',
    aa: 'aaaa',
    E: 'i',
    W: 'I',
    Wo: 'Io',
    WW: 'II',
    YY: 'yy',
    YYYY: 'yyyy',
    GG: 'RR',
    GGGG: 'RRRR',
    H: 'H',
    HH: 'HH',
    h: 'h',
    hh: 'hh',
    m: 'm',
    mm: 'mm',
    s: 's',
    ss: 'ss',
    S: 'S',
    SS: 'SS',
    SSS: 'SSS',
    Z: 'xxx',
    ZZ: 'xx',
    X: 't',
    x: 'T'
};
const $ca62b172b02bdaaf$var$v1tokens = Object.keys($ca62b172b02bdaaf$var$tokensMap).sort().reverse();
const $ca62b172b02bdaaf$var$tokensRegExp = new RegExp(// v1 escape string (unsure the purpose of post-pipe capture group)
"(\\[[^\\[]*\\])|(\\\\)?('.+'|" + // All v1 tokens
$ca62b172b02bdaaf$var$v1tokens.join('|') + '|.)', 'g');
function $ca62b172b02bdaaf$export$4d5430175be73d45(format) {
    const tokensCaptures = format.match($ca62b172b02bdaaf$var$tokensRegExp);
    if (!tokensCaptures) return format;
    return tokensCaptures.reduce((parsed, tokenString, index)=>{
        const v2token = $ca62b172b02bdaaf$var$tokensMap[tokenString];
        if (!v2token) {
            const escapedCaptures = tokenString.match(/^\[(.+)\]$/);
            if (escapedCaptures) parsed.escapedTextBuffer.push(escapedCaptures[1]);
            else parsed.escapedTextBuffer.push(tokenString);
        }
        const endOfString = index === tokensCaptures.length - 1;
        if (parsed.escapedTextBuffer.length && (v2token || endOfString)) {
            // This allows double parentheses to be rendered correctly
            // according to date-fns's spec.
            // https://date-fns.org/v2.29.3/docs/format
            //
            // We have to keep the single quote and then remove it because
            // browser support for lookahead/behind is low and causes breaking
            // errors (HOT-104152)
            const filteredEscapedTextBuffer = parsed.escapedTextBuffer.map((token)=>token[0] === "'" && token.slice(-1) === "'" ? token.slice(1, -1) : token).filter((token)=>token !== "'").join('');
            parsed.formatBuffer.push(`'${filteredEscapedTextBuffer}'`);
            parsed.escapedTextBuffer = [];
        }
        if (v2token) parsed.formatBuffer.push(v2token);
        return parsed;
    }, {
        formatBuffer: [],
        escapedTextBuffer: []
    }).formatBuffer.join('');
}

});


parcelRegister("cJOhG", function(module, exports) {

$parcel$export(module.exports, "makeSingleValue", () => $10128cb6581a570a$export$6e30bf8cb1347b56);

var $eUqFw = parcelRequire("eUqFw");

var $jQxSL = parcelRequire("jQxSL");
const $10128cb6581a570a$export$6e30bf8cb1347b56 = ({ lang: lang })=>({ children: children, ...props })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).SingleValue, {
            ...props,
            innerProps: {
                lang: lang
            }
        }, children);
    };

});


parcelRegister("9lTIY", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebb1ebbe0063e50d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $ebb1ebbe0063e50d$var$messages = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "issue-create-commons.date-field.placeholder",
        "defaultMessage": "Select date"
    }
});
var $ebb1ebbe0063e50d$export$2e2bcd8739ae039 = $ebb1ebbe0063e50d$var$messages;

});

parcelRegister("aRKjl", function(module, exports) {

$parcel$export(module.exports, "mutateDateField", () => $20fe79856e70ebb7$export$cc256064cc35499f);
$parcel$export(module.exports, "transformDate", () => $20fe79856e70ebb7$export$57e73ea84b51baf0);

var $EN9B6 = parcelRequire("EN9B6");

var $3xcI8 = parcelRequire("3xcI8");

const $20fe79856e70ebb7$export$cc256064cc35499f = (date, fieldId)=>{
    const dateInputFormat = 'yyyy-MM-dd';
    return {
        fieldId: fieldId,
        date: {
            formattedDate: (0, $EN9B6.default)((0, $3xcI8.default)(date), dateInputFormat)
        },
        mutationGroup: (0, $8478ff17d7c1f70d$export$31fd86f8f183952c)
    };
};
const $20fe79856e70ebb7$export$57e73ea84b51baf0 = (date)=>date || null;

});
const $8478ff17d7c1f70d$export$31fd86f8f183952c = 'datePickerFields';



parcelRegister("4KGIz", function(module, exports) {

$parcel$export(module.exports, "default", () => $9afe2be1047ba6e6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $cdxKQ = parcelRequire("cdxKQ");

var $emnwK = parcelRequire("emnwK");

var $gGtKh = parcelRequire("gGtKh");

var $icPhQ = parcelRequire("icPhQ");
var $dibFF = parcelRequire("dibFF");
var $6HoNR = parcelRequire("6HoNR");

var $5OZ28 = parcelRequire("5OZ28");
var $lIor1 = parcelRequire("lIor1");

var $7MRtn = parcelRequire("7MRtn");

var $aU3XJ = parcelRequire("aU3XJ");
const $9afe2be1047ba6e6$export$ae1ced156568f0b0 = (props)=>{
    const { autoFocus: autoFocus = false, width: width, fieldProps: { value: value, onChange: onChange, isDisabled: isDisabled, ...fieldProps }, error: error, isReadOnly: isReadOnly = false, fieldName: fieldName } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleChange = (dateTimeValue)=>{
        onChange(dateTimeValue || '');
    };
    const ComponentToRender = (0, $1ybV0.ff)('load-async-date-time-field-edit-view-in-gic_uas6k') ? (0, $emnwK.AsyncDateTimeFieldEditView) : (0, $cdxKQ.LazyDateTimeFieldEditView);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "date-time-field-edit-view",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dibFF.FieldLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ComponentToRender, {
        label: fieldName,
        ...fieldProps,
        isDisabled: isDisabled || isReadOnly,
        autoFocus: autoFocus,
        value: value,
        onChange: handleChange,
        isInvalid: Boolean(error),
        datePickerSelectProps: {
            // @ts-expect-error - TS2322 - Type '(event: KeyboardEvent<HTMLElement>) => void' is not assignable to type '(event: KeyboardEvent<HTMLElement>) => boolean | undefined'.
            onKeyDown: (0, $5OZ28.preventFormSubmitOnEnterKeyPress),
            placeholder: formatMessage((0, $7MRtn.default).datePickerPlaceholder)
        },
        timePickerSelectProps: {
            placeholder: formatMessage((0, $7MRtn.default).timePickerPlaceholder)
        }
    })));
};
var $9afe2be1047ba6e6$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    validator: (0, $lIor1.validateString)
})(// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<DateTimeFieldConfig, FieldValue>, any>'.
$9afe2be1047ba6e6$export$ae1ced156568f0b0);

});
parcelRegister("cdxKQ", function(module, exports) {

$parcel$export(module.exports, "LazyDateTimeFieldEditView", () => $b2177b7d225ed9b6$export$550854cb5022e367);

var $7rh0R = parcelRequire("7rh0R");

const $b2177b7d225ed9b6$export$cf103585d52cb656 = (0, $7rh0R.lazy)(()=>(parcelRequire("1AiBn")).then((module)=>module.DateTimeField), {
    moduleId: "./src/packages/issue/fields/date-time/src/ui/main.tsx"
});

const $b2177b7d225ed9b6$export$a4fb05ac731ff32 = (0, $7rh0R.lazy)(()=>(parcelRequire("geAMf")).then((module)=>module.DateTimeFieldReadView), {
    moduleId: "./src/packages/issue/fields/date-time/src/ui/view/index.tsx"
});

const $b2177b7d225ed9b6$export$550854cb5022e367 = (0, $7rh0R.lazy)(()=>(parcelRequire("b3woH")).then((module)=>module.DateTimeFieldEditView), {
    moduleId: "./src/packages/issue/fields/date-time/src/ui/edit/index.tsx"
});

});
parcelRegister("1AiBn", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('f4ZMh');
        const value = parcelRequire('7zkAK');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("f4ZMh").then(()=>parcelRequire('7zkAK'));
}

});

parcelRegister("geAMf", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('koQzR');
        const value = parcelRequire('gQHT8');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("koQzR").then(()=>parcelRequire('gQHT8'));
}

});

parcelRegister("b3woH", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('1dfP8');
        const value = parcelRequire('9zdZs');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("1dfP8").then(()=>parcelRequire('9zdZs'));
}

});


parcelRegister("emnwK", function(module, exports) {

$parcel$export(module.exports, "AsyncDateTimeFieldEditView", () => $24ad4db56fbb2b06$export$657a1b8545a979b8);

var $eUqFw = parcelRequire("eUqFw");

var $9VPEO = parcelRequire("9VPEO");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $alNkm = parcelRequire("alNkm");
const $24ad4db56fbb2b06$var$EMPTY_OBJECT = {};
const $24ad4db56fbb2b06$export$657a1b8545a979b8 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $alNkm.asyncDateTimeFieldEditViewEntrypoint), // use stable reference to avoid re-renders
    $24ad4db56fbb2b06$var$EMPTY_OBJECT);
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "async-jira-issue-field-date-time-edit-view",
        packageName: "jira-issue-field-date-time",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.SkeletonCompiled), {
            width: "350px",
            height: "40px"
        }),
        errorFallback: "unmount"
    });
};

});
parcelRegister("alNkm", function(module, exports) {

$parcel$export(module.exports, "asyncDateTimeFieldEditViewEntrypoint", () => $de0e04c2ef3b4ff6$export$971e82244ad6d423);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $de0e04c2ef3b4ff6$export$971e82244ad6d423 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("b3woH")).then((module)=>module.DateTimeFieldEditViewEntryPointContent), {
        moduleId: "267b9282"
    }),
    getPreloadProps: ()=>({})
});

});


parcelRegister("7MRtn", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b817dcd3c1298f6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $9b817dcd3c1298f6$var$messages = (0, $90IgZ.defineMessages)({
    datePickerPlaceholder: {
        "id": "issue-create-commons.date-time-field.date-picker-placeholder",
        "defaultMessage": "Select date"
    },
    timePickerPlaceholder: {
        "id": "issue-create-commons.date-time-field.time-picker-placeholder",
        "defaultMessage": "Select time"
    }
});
var $9b817dcd3c1298f6$export$2e2bcd8739ae039 = $9b817dcd3c1298f6$var$messages;

});

parcelRegister("aU3XJ", function(module, exports) {

$parcel$export(module.exports, "mutateDateTimeField", () => $f4d9ef3a1238d1df$export$c17fd814c724a443);

var $EN9B6 = parcelRequire("EN9B6");

var $3xcI8 = parcelRequire("3xcI8");

const $f4d9ef3a1238d1df$export$c17fd814c724a443 = (date, fieldId)=>{
    const dateTimeInputFormat = "yyyy-MM-dd'T'HH:mm:ssXXX";
    return {
        fieldId: fieldId,
        dateTime: {
            formattedDateTime: (0, $EN9B6.default)((0, $3xcI8.default)(date), dateTimeInputFormat)
        },
        mutationGroup: (0, $dd1c053d0424589a$export$31fd86f8f183952c)
    };
};

});
const $dd1c053d0424589a$export$31fd86f8f183952c = 'dateTimePickerFields';



parcelRegister("l7nwo", function(module, exports) {

$parcel$export(module.exports, "ForgeLabelsField", () => $eb55394608fb0f2e$export$f77bab10d748bb71);
$parcel$export(module.exports, "default", () => $eb55394608fb0f2e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ff51f = parcelRequire("ff51f");

var $icPhQ = parcelRequire("icPhQ");
var $6HoNR = parcelRequire("6HoNR");

var $7TaJX = parcelRequire("7TaJX");

var $lIor1 = parcelRequire("lIor1");

var $6Wef2 = parcelRequire("6Wef2");
const $eb55394608fb0f2e$var$LabelsField = (props)=>{
    const { autoCompleteUrl: autoCompleteUrl, error: error, width: width, autoFocus: autoFocus = false, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $7TaJX.closeMenuOnScroll), fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired }, isReadOnly: isReadOnly = false } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ff51f.LabelsEdit), {
        isInvalid: Boolean(error),
        fetchSuggestionsOnMount: false,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        autoCompleteUrl: autoCompleteUrl,
        onChange: onChange,
        value: value,
        autoFocus: autoFocus,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDisabled: isReadOnly,
        inputId: id,
        isRequired: isRequired
    }));
};
const $eb55394608fb0f2e$export$f77bab10d748bb71 = (0, $6HoNR.withFormField)({
    validator: (0, $lIor1.validateForgeLabelField),
    transformDefaultValue: (0, $6Wef2.mapDataToLabelOptions)
})($eb55394608fb0f2e$var$LabelsField);
var $eb55394608fb0f2e$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    validator: (0, $lIor1.validateLabelField),
    transformDefaultValue: (0, $6Wef2.mapDataToLabelOptions)
})($eb55394608fb0f2e$var$LabelsField);

});
parcelRegister("ff51f", function(module, exports) {

$parcel$export(module.exports, "LabelsEdit", () => $7889fb92b3af48af$export$23584166c0ffb901);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $hompL = parcelRequire("hompL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4NcaX = parcelRequire("4NcaX");
var $jM2Oz = parcelRequire("jM2Oz");
var $g6sIQ = parcelRequire("g6sIQ");

var $lO4Or = parcelRequire("lO4Or");

var $26Ej0 = parcelRequire("26Ej0");

var $42tjQ = parcelRequire("42tjQ");

var $8cY6u = parcelRequire("8cY6u");

var $4y9tu = parcelRequire("4y9tu");

var $63Mv3 = parcelRequire("63Mv3");
const $7889fb92b3af48af$export$251bdbdbce9550ea = 300;
const $7889fb92b3af48af$export$23584166c0ffb901 = (props)=>{
    const { autoCompleteUrl: autoCompleteUrl, autoFocus: autoFocus, onChange: onChange, onFocus: onFocus, onBlur: onBlur, spacing: spacing, value: value, options: options, cachedOptions: cachedOptions = [], formatCreateLabel: formatCreateLabel, noOptionsMessage: noOptionsMessage, loadingMessage: loadingMessage, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, getSuggestions: getSuggestions, fetchSuggestionsOnMount: fetchSuggestionsOnMount = true, fieldId: fieldId = (0, $lO4Or.LABELS_TYPE), isInvalid: isInvalid = false, isDisabled: isDisabled = false, ariaLabel: ariaLabel = '', inputId: inputId, isRequired: isRequired, openMenuOnFocus: openMenuOnFocus } = props;
    const [menuIsOpen, setMenuIsOpen] = (0, $eUqFw.useState)(false);
    const [suggestions, setSuggestions] = (0, $eUqFw.useState)();
    const [defaultSuggestions, setDefaultSuggestions] = (0, $eUqFw.useState)();
    const [hasLastFetchFailed, setHasLastFetchFailed] = (0, $eUqFw.useState)(false);
    const lastQuery = (0, $eUqFw.useRef)('');
    const sessionId = (0, $eUqFw.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4());
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ isLoadingSuggestions: isLoadingSuggestions }, { getLabelsSuggestions: getLabelsSuggestions, setIsLoadingSuggestions: setIsLoadingSuggestions }] = (0, $8cY6u.useLabelsSuggestions)({
        fieldId: fieldId,
        getSuggestions: getSuggestions
    });
    const getFailedFetchMessage = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jM2Oz.FailedFetchOptionWrapper), null, formatMessage((0, $63Mv3.default).failedFetch)), [
        formatMessage
    ]);
    const fetchSuggestions = (0, $eUqFw.useCallback)(async (query = '')=>{
        try {
            const response = await getLabelsSuggestions(autoCompleteUrl, query, sessionId.current);
            setIsLoadingSuggestions(false);
            if (lastQuery.current === query) {
                const results = (0, $26Ej0.mapLabelsResponseToLabelOptions)(response);
                setSuggestions(results);
                if (query === '') setDefaultSuggestions(results);
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setIsLoadingSuggestions(false);
            setHasLastFetchFailed(true);
            setSuggestions([
                {
                    label: getFailedFetchMessage(),
                    value: '',
                    isDisabled: true
                }
            ]);
        }
    }, [
        autoCompleteUrl,
        getFailedFetchMessage,
        getLabelsSuggestions,
        lastQuery,
        sessionId,
        setHasLastFetchFailed,
        setIsLoadingSuggestions
    ]);
    (0, $eUqFw.useMemo)(()=>{
        if (fetchSuggestionsOnMount) {
            if (!options && !defaultSuggestions) {
                setIsLoadingSuggestions(true);
                fetchSuggestions();
            } else if (options && !defaultSuggestions) {
                setDefaultSuggestions(options);
                setSuggestions(options);
            } else {
                lastQuery.current = '';
                setIsLoadingSuggestions(true);
                fetchSuggestions();
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const groupedSuggestions = (0, $eUqFw.useMemo)(()=>[
            {
                label: formatMessage((0, $63Mv3.default).recent),
                options: cachedOptions
            },
            {
                label: formatMessage((0, $63Mv3.default).all),
                options: suggestions || []
            }
        ], [
        cachedOptions,
        formatMessage,
        suggestions
    ]);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedFetchSuggestions = (0, $eUqFw.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(fetchSuggestions, $7889fb92b3af48af$export$251bdbdbce9550ea), []);
    const getCreateLabel = (0, $eUqFw.useCallback)((inputValue)=>`${inputValue} (${formatCreateLabel !== undefined ? formatCreateLabel : formatMessage((0, $63Mv3.default).createNewItem)})`, [
        formatCreateLabel,
        formatMessage
    ]);
    const getNoOptionsMessage = (0, $eUqFw.useCallback)(()=>noOptionsMessage !== undefined ? noOptionsMessage : formatMessage((0, $63Mv3.default).empty), [
        formatMessage,
        noOptionsMessage
    ]);
    const getLoadingMessage = (0, $eUqFw.useCallback)(()=>loadingMessage !== undefined ? loadingMessage : formatMessage((0, $63Mv3.default).loading), [
        formatMessage,
        loadingMessage
    ]);
    const filterOption = (0, $eUqFw.useCallback)((option, query)=>{
        if (hasLastFetchFailed) // If the fetch has failed, we will show a disabled option to indicate the error to users
        return true;
        return (0, $g6sIQ.filterOptionByLabelAndFilterValues)(option, query || '');
    }, [
        hasLastFetchFailed
    ]);
    const onQueryChange = (0, $eUqFw.useCallback)((query)=>{
        debouncedFetchSuggestions.cancel();
        setHasLastFetchFailed(false);
        if (query) {
            lastQuery.current = query;
            setIsLoadingSuggestions(true);
            debouncedFetchSuggestions(query);
        } else {
            lastQuery.current = '';
            setIsLoadingSuggestions(false);
            setSuggestions(defaultSuggestions);
        }
    }, [
        debouncedFetchSuggestions,
        defaultSuggestions,
        setIsLoadingSuggestions,
        setSuggestions
    ]);
    const onSelectFocus = (0, $eUqFw.useCallback)((e)=>{
        if (!(0, $42tjQ.isBehaviourCommonForAllFieldsInNewGic)()) setMenuIsOpen(true);
        if ((0, $42tjQ.isBehaviourCommonForAllFieldsInNewGic)() ? !suggestions : fetchSuggestionsOnMount === false) {
            setIsLoadingSuggestions(true);
            fetchSuggestions('');
        }
        onFocus && onFocus(e);
    }, [
        suggestions,
        fetchSuggestionsOnMount,
        onFocus,
        setIsLoadingSuggestions,
        fetchSuggestions
    ]);
    const onSelectBlur = (0, $eUqFw.useCallback)((e)=>{
        if (!(0, $42tjQ.isBehaviourCommonForAllFieldsInNewGic)()) setMenuIsOpen(false);
        onBlur && onBlur(e);
    }, [
        onBlur
    ]);
    const menuPosition = isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined;
    const isLoading = (0, $42tjQ.isBehaviourCommonForAllFieldsInNewGic)() ? isLoadingSuggestions : menuIsOpen && isLoadingSuggestions;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4y9tu.default), {
        isMulti: true,
        autoFocus: autoFocus,
        fieldId: fieldId,
        options: groupedSuggestions,
        value: value,
        isDisabled: isDisabled,
        ...(0, $42tjQ.isBehaviourCommonForAllFieldsInNewGic)() ? {} : {
            menuIsOpen: menuIsOpen
        },
        onBlur: onSelectBlur,
        menuPosition: menuPosition,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        styles: (0, $4NcaX.defaultSelectStyles),
        onFocus: onSelectFocus,
        noOptionsMessage: getNoOptionsMessage,
        closeMenuOnScroll: onCloseMenuOnScroll,
        loadingMessage: getLoadingMessage,
        placeholder: formatMessage((0, $63Mv3.default).placeholder),
        onInputChange: onQueryChange,
        onChange: onChange,
        spacing: spacing,
        isLoading: isLoading,
        filterOption: filterOption,
        formatCreateLabel: getCreateLabel,
        validationState: isInvalid === true ? 'error' : null,
        sessionId: sessionId.current,
        "aria-label": ariaLabel,
        inputId: inputId,
        isRequired: isRequired,
        openMenuOnFocus: openMenuOnFocus
    });
};
var $7889fb92b3af48af$export$2e2bcd8739ae039 = $7889fb92b3af48af$export$23584166c0ffb901;

});
parcelRegister("jM2Oz", function(module, exports) {

$parcel$export(module.exports, "FailedFetchOptionWrapper", () => $9987adeb236c664b$export$38a1a0a811e06255);
$parcel$export(module.exports, "getFailedFetchSelectOptionsWithDefaultLabel", () => $9987adeb236c664b$export$aa3357fb0ebcdb2b);
$parcel$export(module.exports, "OptionWrapper", () => $9987adeb236c664b$export$d6f6a072cce04542);
$parcel$export(module.exports, "ImgSpan", () => $9987adeb236c664b$export$df67068a00dece12);
$parcel$export(module.exports, "FlexSpan", () => $9987adeb236c664b$export$d90eccb59fb62cab);
$parcel$export(module.exports, "ErrorMessageWrapper", () => $9987adeb236c664b$export$9e874bb1adc98a55);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hnFco = parcelRequire("hnFco");
const $9987adeb236c664b$export$6ed0d629c0656ce1 = (query, label)=>[
        {
            options: [
                {
                    label: label,
                    value: '',
                    isDisabled: true,
                    filterValues: [
                        query
                    ] // filterOptionByLabelAndFilterValues will check `filterValues` and since it contains the user's query, this option will always show
                }
            ]
        }
    ];
const $9987adeb236c664b$var$DefaultFailedFetchMessage = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const failedFetchMessage = (0, $hnFco.default).failedFetch;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9987adeb236c664b$export$38a1a0a811e06255, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, formatMessage(failedFetchMessage), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        role: "button",
        href: window.location.href,
        onClick: ()=>window.location.reload()
    }, formatMessage((0, $hnFco.default).reloadIssue))));
};
const $9987adeb236c664b$export$aa3357fb0ebcdb2b = (query)=>$9987adeb236c664b$export$6ed0d629c0656ce1(query, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9987adeb236c664b$var$DefaultFailedFetchMessage, null)); // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $9987adeb236c664b$export$d6f6a072cce04542 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $9987adeb236c664b$export$38a1a0a811e06255 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $9987adeb236c664b$export$d6f6a072cce04542, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bah1h6o",
            __cmplp.className
        ])
    });
});
const $9987adeb236c664b$export$df67068a00dece12 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _u5f3u2gc",
            __cmplp.className
        ])
    });
});
const $9987adeb236c664b$export$d90eccb59fb62cab = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $9987adeb236c664b$export$9e874bb1adc98a55 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { errorMessagePopsition: errorMessagePopsition, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.errorMessagePopsition === 'top' && "_otyri2wt",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hnFco", function(module, exports) {

$parcel$export(module.exports, "default", () => $79fb52d38fb3e29a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $79fb52d38fb3e29a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    failedFetch: {
        "id": "issue-field-select-base.failed-fetch-options.failed-fetch",
        "defaultMessage": "Search failed."
    },
    reloadIssue: {
        "id": "issue-field-select-base.failed-fetch-options.reload-issue",
        "defaultMessage": "Try reloading the issue."
    }
});

});


parcelRegister("g6sIQ", function(module, exports) {

$parcel$export(module.exports, "filterOptionByLabelAndFilterValues", () => $2dc2777cac843338$export$58bb91b619b113f6);

var $5iWql = parcelRequire("5iWql");

var $cEc3i = parcelRequire("cEc3i");
const $2dc2777cac843338$export$d3e698d53f63efcd = (val, inputValueIgnoredCase)=>// label can be Object for new option in CreatableSelect
    typeof val === 'string' && val// no need to .trim() since input is already trimmed and we search for .includes() so it does not matter if field has leading or trailing spaces
    .toLowerCase().includes(inputValueIgnoredCase);
const $2dc2777cac843338$var$stringifyLabelAndDataFilterValues = (option)=>{
    const { label: label, data: data } = option || {};
    const { filterValues: filterValues } = data || {};
    const labelString = typeof label === 'string' ? label : '';
    const filterValuesString = (filterValues || []).join(' ');
    return `${labelString} ${filterValuesString}`;
};
/**
 * By default react-select matches by both option.label and option.value: https://github.com/JedWatson/react-select/blob/b7868d23ccd0b9e623b277f971e89020d426fbdb/packages/react-select/src/filters.js#L14.
 * This leads to undesired UX, when filter result includes options without displayed text including the query (which is very confusing for the user): BENTO-5735, BENTO-5655.
 * That's why we need this function.
 */ const $2dc2777cac843338$var$filterOptionByLabelAndFilterValuesInternal = (0, $5iWql.default)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $cEc3i.c)({
        // Take an option object and convert it to a string that needs to partially match the user's query
        stringify: $2dc2777cac843338$var$stringifyLabelAndDataFilterValues
    }));
const $2dc2777cac843338$export$58bb91b619b113f6 = (option, inputValue)=>$2dc2777cac843338$var$filterOptionByLabelAndFilterValuesInternal()(option, inputValue);

});

parcelRegister("42tjQ", function(module, exports) {

$parcel$export(module.exports, "isBehaviourCommonForAllFieldsInNewGic", () => $967ee6a6d611ac6d$export$b2f73d54757eb059);

var $1ybV0 = parcelRequire("1ybV0");
const $967ee6a6d611ac6d$export$b2f73d54757eb059 = ()=>(0, $1ybV0.ff)('common-field-behaviour-for-new-gic_q9mgt', false);

});

parcelRegister("8cY6u", function(module, exports) {

$parcel$export(module.exports, "useLabelsSuggestions", () => $9e3ddd644508ee83$export$c5b80cd78ff71c5f);

var $eUqFw = parcelRequire("eUqFw");

var $8uNQc = parcelRequire("8uNQc");

var $lRmyA = parcelRequire("lRmyA");

var $kwEon = parcelRequire("kwEon");

var $lO4Or = parcelRequire("lO4Or");

var $bFzGY = parcelRequire("bFzGY");
const $9e3ddd644508ee83$export$343652b9755c68e7 = async (autoCompleteUrl, query, sessionId)=>{
    let url = `${autoCompleteUrl}${encodeURIComponent(query)}`;
    if (sessionId !== undefined && sessionId !== null) url = `${url}&sessionId=${sessionId}`;
    return (0, $lRmyA.performGetRequest)(url);
};
const $9e3ddd644508ee83$export$c5b80cd78ff71c5f = (props)=>{
    const { fieldId: fieldId, getSuggestions: getSuggestions = $9e3ddd644508ee83$export$343652b9755c68e7 } = props;
    const [isLoadingSuggestions, setIsLoadingSuggestions] = (0, $eUqFw.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const getLabelsSuggestions = (0, $eUqFw.useCallback)(async (autoCompleteUrl, query, sessionId)=>{
        const startTime = (0, $8uNQc.default).now();
        const queryLength = query.length;
        try {
            const response = await getSuggestions(autoCompleteUrl, query, sessionId);
            if (fieldId === (0, $lO4Or.LABELS_TYPE)) (0, $kwEon.fireSuggestionsRequestSuccessEvent)((0, $lO4Or.LABELS_TYPE), startTime, createAnalyticsEvent, {
                sessionId: sessionId,
                queryLength: queryLength
            });
            setIsLoadingSuggestions(false);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            if (fieldId === (0, $lO4Or.LABELS_TYPE)) (0, $kwEon.fireSuggestionsRequestFailedEvent)((0, $lO4Or.LABELS_TYPE), startTime, createAnalyticsEvent, {
                sessionId: sessionId
            });
            setIsLoadingSuggestions(false);
            throw error;
        }
    }, [
        createAnalyticsEvent,
        fieldId,
        getSuggestions,
        setIsLoadingSuggestions
    ]);
    const actions = (0, $eUqFw.useMemo)(()=>({
            getLabelsSuggestions: getLabelsSuggestions,
            setIsLoadingSuggestions: setIsLoadingSuggestions
        }), [
        getLabelsSuggestions,
        setIsLoadingSuggestions
    ]);
    return [
        {
            isLoadingSuggestions: isLoadingSuggestions
        },
        actions
    ];
};

});
parcelRegister("kwEon", function(module, exports) {

$parcel$export(module.exports, "fireSuggestionsRequestSuccessEvent", () => $fdc9d057cb7638cd$export$7eeca21c46efa338);
$parcel$export(module.exports, "fireSuggestionsRequestFailedEvent", () => $fdc9d057cb7638cd$export$a31ac580130dee62);

var $8uNQc = parcelRequire("8uNQc");

var $jMP2a = parcelRequire("jMP2a");
const $fdc9d057cb7638cd$var$fireRequestEvent = (action, actionSubject, startTime, createAnalyticsEvent, additionalAttributes)=>{
    const attributes = {
        ...additionalAttributes,
        elapsedTimeMs: (0, $8uNQc.default).now() - startTime
    };
    createAnalyticsEvent && (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({
        action: action,
        actionSubject: actionSubject
    }), `${actionSubject} ${action}`, attributes);
};
const $fdc9d057cb7638cd$export$7eeca21c46efa338 = (fieldId, startTime, createAnalyticsEvent, additionalAttributes)=>{
    $fdc9d057cb7638cd$var$fireRequestEvent('succeeded', `${fieldId}Suggestions`, startTime, createAnalyticsEvent, additionalAttributes);
};
const $fdc9d057cb7638cd$export$a31ac580130dee62 = (fieldId, startTime, createAnalyticsEvent, additionalAttributes)=>{
    $fdc9d057cb7638cd$var$fireRequestEvent('failed', `${fieldId}Suggestions`, startTime, createAnalyticsEvent, additionalAttributes);
};

});


parcelRegister("4y9tu", function(module, exports) {

$parcel$export(module.exports, "default", () => $341125a445ce24f9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $ldoFd = parcelRequire("ldoFd");

var $hompL = parcelRequire("hompL");

var $28t3A = parcelRequire("28t3A");

var $8uNQc = parcelRequire("8uNQc");

var $azx3n = parcelRequire("azx3n");

var $g8JvH = parcelRequire("g8JvH");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $bICpe = parcelRequire("bICpe");
const $341125a445ce24f9$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE = 20;
const $341125a445ce24f9$var$analyticsProps = {
    onChange: 'valueChanged',
    onInputChange: 'inputChanged',
    onMenuOpen: 'menuOpened',
    onMenuClose: 'menuClosed'
};
const $341125a445ce24f9$var$CreatableSelectWithAnalyticsNew = (0, $g8JvH.AnalyticsEventToProps)('select', $341125a445ce24f9$var$analyticsProps)((0, $28t3A.default));
const $341125a445ce24f9$var$CreatableSelectWithAnalyticsView = (props)=>{
    const { fieldId: fieldId, isLoading: isLoading, onChange: onChange, onInputChange: onInputChange, options: options, value: value, isDisabled: isDisabled, sessionId: customSessionId, isMulti: isMulti, inputId: inputId, isRequired: isRequired } = props;
    const sessionId = (0, $eUqFw.useRef)(customSessionId);
    const sessionStartedAt = (0, $eUqFw.useRef)(0);
    const [flatOptions, setFlatOptions] = (0, $eUqFw.useState)((0, $bICpe.flattenOptions)(options));
    const [queryAtSetValue, setQueryAtSetValue] = (0, $eUqFw.useState)('');
    const [savedQuery, setSavedQuery] = (0, $eUqFw.useState)('');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const getAnalyticsAttributes = (0, $eUqFw.useCallback)((query)=>{
        const selectedOptions = !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(value) ? value : [];
        let filteredOptions = (0, $bICpe.filterOptions)(flatOptions, query);
        const optionsLength = filteredOptions.length;
        // truncate to reduce payload size
        filteredOptions = filteredOptions.slice(0, $341125a445ce24f9$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE);
        const safeFilteredOptions = (0, $bICpe.getSafeOptionsForAnalytics)(filteredOptions);
        return {
            inputId: inputId,
            required: isRequired,
            fieldId: fieldId,
            isLoading: isLoading,
            isDisabled: isDisabled,
            optionsLength: optionsLength,
            componentName: 'select',
            packageName: '@atlaskit/select',
            optionValuesSafeForAnalytics: false,
            options: safeFilteredOptions,
            optionsLengths: (0, $bICpe.getOptionValuesLengths)(filteredOptions),
            queryLength: query.length,
            queryHash: query === '' ? query : (0, $azx3n.memoizedHashString)(query),
            selectedOptions: (0, $bICpe.getSafeOptionsForAnalytics)(selectedOptions),
            selectedOptionsLengths: (0, $bICpe.getOptionValuesLengths)(selectedOptions),
            sessionId: sessionId.current,
            truncationSize: $341125a445ce24f9$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE
        };
    }, [
        value,
        flatOptions,
        inputId,
        isRequired,
        fieldId,
        isLoading,
        isDisabled
    ]);
    const getItemOrder = (0, $eUqFw.useCallback)((selectedItem)=>{
        const matchedIndexes = [];
        flatOptions.forEach((option, index)=>{
            if (option.value === selectedItem.value) matchedIndexes.push(index);
        });
        return matchedIndexes.length > 0 ? matchedIndexes[0] : -1;
    }, [
        flatOptions
    ]);
    const fireUIAnalyticsEvent = (0, $eUqFw.useCallback)((analyticsEvent, query, extraAttributes)=>{
        const attributes = {
            ...getAnalyticsAttributes(query),
            ...extraAttributes
        };
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, attributes);
    }, [
        getAnalyticsAttributes
    ]);
    const fireTrackAnalyticsEvent = (0, $eUqFw.useCallback)((analyticsEvent, action, actionSubject, extraAttributes)=>{
        const attributes = {
            ...getAnalyticsAttributes(savedQuery),
            ...extraAttributes
        };
        (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, `${actionSubject} ${action}`, attributes);
    }, [
        getAnalyticsAttributes,
        savedQuery
    ]);
    const startSession = (0, $eUqFw.useCallback)(()=>{
        if (sessionId.current === undefined) sessionId.current = (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4();
        sessionStartedAt.current = (0, $8uNQc.default).now();
        fireTrackAnalyticsEvent(createAnalyticsEvent({
            action: 'started'
        }), 'started', 'optionSelectionSession');
    }, [
        createAnalyticsEvent,
        fireTrackAnalyticsEvent,
        sessionId,
        sessionStartedAt
    ]);
    const endSession = (0, $eUqFw.useCallback)(()=>{
        if (sessionId.current !== undefined) {
            const currentStartedAt = sessionStartedAt.current;
            const elapsedTime = currentStartedAt === 0 ? (0, $8uNQc.default).now() - currentStartedAt : 0;
            fireTrackAnalyticsEvent(createAnalyticsEvent({
                action: 'ended'
            }), 'ended', 'optionSelectionSession', {
                elapsedTime: elapsedTime
            });
        }
        sessionId.current = undefined;
        sessionStartedAt.current = 0;
    }, [
        createAnalyticsEvent,
        fireTrackAnalyticsEvent,
        sessionId,
        sessionStartedAt
    ]);
    const restartSession = (0, $eUqFw.useCallback)(()=>{
        endSession();
        startSession();
    }, [
        endSession,
        startSession
    ]);
    const fireInputChangedEvent = (0, $eUqFw.useCallback)((query, actionMeta, analyticsEvent)=>{
        if (actionMeta.action === 'set-value') // Save query for option changed analytic
        setQueryAtSetValue(savedQuery);
        setSavedQuery(query);
        analyticsEvent.update({
            action: 'changed',
            actionSubject: 'filter'
        });
        fireUIAnalyticsEvent(analyticsEvent, query);
    }, [
        fireUIAnalyticsEvent,
        savedQuery,
        setSavedQuery,
        setQueryAtSetValue
    ]);
    const fireOptionCreatedEvent = (0, $eUqFw.useCallback)((option, analyticsEvent)=>{
        analyticsEvent.update({
            action: 'created',
            actionSubject: 'option'
        });
        const oldSessionId = sessionId.current;
        restartSession();
        fireUIAnalyticsEvent(analyticsEvent, queryAtSetValue, {
            selectedOption: (0, $bICpe.getSafeValue)(option.value),
            sessionId: oldSessionId
        });
    }, [
        fireUIAnalyticsEvent,
        queryAtSetValue,
        restartSession,
        sessionId
    ]);
    const fireOptionRemovedEvent = (0, $eUqFw.useCallback)((option, analyticsEvent)=>{
        analyticsEvent.update({
            action: 'removed',
            actionSubject: 'option'
        });
        fireUIAnalyticsEvent(analyticsEvent, savedQuery, {
            removedItem: option ? (0, $bICpe.getSafeValue)(option.value) : undefined
        });
    }, [
        fireUIAnalyticsEvent,
        savedQuery
    ]);
    const fireOptionSelectedEvent = (0, $eUqFw.useCallback)((option, analyticsEvent)=>{
        analyticsEvent.update({
            action: 'changed',
            actionSubject: 'option'
        });
        const oldSessionId = sessionId.current;
        restartSession();
        fireUIAnalyticsEvent(analyticsEvent, queryAtSetValue, {
            selectedOption: (0, $bICpe.getSafeValue)(option.value),
            selectedOptionLength: option.value !== null ? `${option.value}`.length : 0,
            selectedOrder: getItemOrder(option),
            sessionId: oldSessionId
        });
    }, [
        fireUIAnalyticsEvent,
        getItemOrder,
        queryAtSetValue,
        restartSession,
        sessionId
    ]);
    const onChangeWithAnalytics = (0, $eUqFw.useCallback)((selectedOptionOrOptions, actionMeta, analyticsEvent)=>{
        const selectedOption = Array.isArray(selectedOptionOrOptions) ? selectedOptionOrOptions[selectedOptionOrOptions.length - 1] : selectedOptionOrOptions;
        switch(actionMeta.action){
            case 'create-option':
                if (selectedOption !== null) fireOptionCreatedEvent(selectedOption, analyticsEvent);
                break;
            case 'remove-value':
            case 'pop-value':
            case 'deselect-option':
                fireOptionRemovedEvent(actionMeta.removedValue || actionMeta.option, analyticsEvent);
                break;
            case 'select-option':
                if (selectedOption !== null) fireOptionSelectedEvent(selectedOption, analyticsEvent);
                break;
            default:
                break;
        }
        const selectedValue = isMulti ? selectedOptionOrOptions || [] : selectedOptionOrOptions;
        if (onChange) onChange(selectedValue, actionMeta);
    }, [
        fireOptionCreatedEvent,
        fireOptionRemovedEvent,
        fireOptionSelectedEvent,
        onChange,
        isMulti
    ]);
    const onInputChangeWithAnalytics = (0, $eUqFw.useCallback)((query, actionMeta, analyticsEvent)=>{
        if (actionMeta.action === 'input-change' || actionMeta.action === 'set-value') fireInputChangedEvent(query, actionMeta, analyticsEvent);
        onInputChange(query, sessionId.current);
    }, [
        fireInputChangedEvent,
        onInputChange,
        sessionId
    ]);
    (0, $eUqFw.useEffect)(()=>{
        startSession();
        fireInputChangedEvent('', {
            action: 'fake-action'
        }, createAnalyticsEvent({}));
        return ()=>{
            endSession();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        // since due to multiple setState calls component is rerendered
        // added this change to reduce the number of setState call will be fixed,
        // wasn't able to replicate this issue in local so adding this change in feature flag.
        // sentry link: https://sentry.prod.atl-paas.net/atlassian/jira-frontend/issues/4943577/?query=is%3Aunresolved%20logger%3AjiraIssueCreateModal.withFormField
        const flattenedOption = (0, $bICpe.flattenOptions)(options);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(flatOptions, flattenedOption)) setFlatOptions(flattenedOption);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        options
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($341125a445ce24f9$var$CreatableSelectWithAnalyticsNew, {
        ...props,
        onChange: onChangeWithAnalytics,
        onInputChange: onInputChangeWithAnalytics
    });
};
var $341125a445ce24f9$export$2e2bcd8739ae039 = $341125a445ce24f9$var$CreatableSelectWithAnalyticsView;

});
parcelRegister("azx3n", function(module, exports) {

$parcel$export(module.exports, "memoizedHashString", () => $403b450273ddd0e6$export$c9e165da390f6283);

var $aHQJS = parcelRequire("aHQJS");

var $5iWql = parcelRequire("5iWql");

var $e91YZ = parcelRequire("e91YZ");
const $403b450273ddd0e6$export$fdd2c0ba94025c3c = (0, $5iWql.default)(()=>{
    const { cloudId: cloudId } = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)();
    return cloudId;
});
const $403b450273ddd0e6$export$c9e165da390f6283 = (attribute)=>{
    const cloudId = $403b450273ddd0e6$export$fdd2c0ba94025c3c();
    const hash = (0, $aHQJS.createHash)('sha256').update(`${cloudId}_${attribute.trim()}`).digest('hex');
    return hash;
};

});
parcelRegister("aHQJS", function(module, exports) {

$parcel$export(module.exports, "randomBytes", () => $7cb6d463ef497bec$export$5f828d93ff035aa8, (v) => $7cb6d463ef497bec$export$5f828d93ff035aa8 = v);
$parcel$export(module.exports, "rng", () => $7cb6d463ef497bec$export$cd94982b18c6332c, (v) => $7cb6d463ef497bec$export$cd94982b18c6332c = v);
$parcel$export(module.exports, "pseudoRandomBytes", () => $7cb6d463ef497bec$export$1d518568e4f529b0, (v) => $7cb6d463ef497bec$export$1d518568e4f529b0 = v);
$parcel$export(module.exports, "prng", () => $7cb6d463ef497bec$export$5285b6d41c912b41, (v) => $7cb6d463ef497bec$export$5285b6d41c912b41 = v);
$parcel$export(module.exports, "createHash", () => $7cb6d463ef497bec$export$2fb37efbf6ae0c0e, (v) => $7cb6d463ef497bec$export$2fb37efbf6ae0c0e = v);
$parcel$export(module.exports, "Hash", () => $7cb6d463ef497bec$export$ab85ecd77ce6a5cd, (v) => $7cb6d463ef497bec$export$ab85ecd77ce6a5cd = v);
$parcel$export(module.exports, "createHmac", () => $7cb6d463ef497bec$export$da39cf97e1eb7c91, (v) => $7cb6d463ef497bec$export$da39cf97e1eb7c91 = v);
$parcel$export(module.exports, "Hmac", () => $7cb6d463ef497bec$export$52a9039d7177394f, (v) => $7cb6d463ef497bec$export$52a9039d7177394f = v);
$parcel$export(module.exports, "getHashes", () => $7cb6d463ef497bec$export$f7201db400317331, (v) => $7cb6d463ef497bec$export$f7201db400317331 = v);
$parcel$export(module.exports, "pbkdf2", () => $7cb6d463ef497bec$export$448fa22aedc9dbca, (v) => $7cb6d463ef497bec$export$448fa22aedc9dbca = v);
$parcel$export(module.exports, "pbkdf2Sync", () => $7cb6d463ef497bec$export$b80c7ba289c8fa56, (v) => $7cb6d463ef497bec$export$b80c7ba289c8fa56 = v);
$parcel$export(module.exports, "Cipher", () => $7cb6d463ef497bec$export$26e5786e8ac8e530, (v) => $7cb6d463ef497bec$export$26e5786e8ac8e530 = v);
$parcel$export(module.exports, "createCipher", () => $7cb6d463ef497bec$export$bdd223f16383713e, (v) => $7cb6d463ef497bec$export$bdd223f16383713e = v);
$parcel$export(module.exports, "Cipheriv", () => $7cb6d463ef497bec$export$20533d26f07f1ee0, (v) => $7cb6d463ef497bec$export$20533d26f07f1ee0 = v);
$parcel$export(module.exports, "createCipheriv", () => $7cb6d463ef497bec$export$2f64596b8cbf08b4, (v) => $7cb6d463ef497bec$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "Decipher", () => $7cb6d463ef497bec$export$2ce6d8d0e8b04e1a, (v) => $7cb6d463ef497bec$export$2ce6d8d0e8b04e1a = v);
$parcel$export(module.exports, "createDecipher", () => $7cb6d463ef497bec$export$12ada9414fbc594c, (v) => $7cb6d463ef497bec$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "Decipheriv", () => $7cb6d463ef497bec$export$f5e7e39d57cd9700, (v) => $7cb6d463ef497bec$export$f5e7e39d57cd9700 = v);
$parcel$export(module.exports, "createDecipheriv", () => $7cb6d463ef497bec$export$36b6d6ef312eab39, (v) => $7cb6d463ef497bec$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "getCiphers", () => $7cb6d463ef497bec$export$58a258485f1e49f6, (v) => $7cb6d463ef497bec$export$58a258485f1e49f6 = v);
$parcel$export(module.exports, "listCiphers", () => $7cb6d463ef497bec$export$dedd8dc3dc62b370, (v) => $7cb6d463ef497bec$export$dedd8dc3dc62b370 = v);
$parcel$export(module.exports, "DiffieHellmanGroup", () => $7cb6d463ef497bec$export$971862a2fcb1bb40, (v) => $7cb6d463ef497bec$export$971862a2fcb1bb40 = v);
$parcel$export(module.exports, "createDiffieHellmanGroup", () => $7cb6d463ef497bec$export$c6ff6a88acbeaf40, (v) => $7cb6d463ef497bec$export$c6ff6a88acbeaf40 = v);
$parcel$export(module.exports, "getDiffieHellman", () => $7cb6d463ef497bec$export$fdc27893e98845cc, (v) => $7cb6d463ef497bec$export$fdc27893e98845cc = v);
$parcel$export(module.exports, "createDiffieHellman", () => $7cb6d463ef497bec$export$6671fb9a1323bed, (v) => $7cb6d463ef497bec$export$6671fb9a1323bed = v);
$parcel$export(module.exports, "DiffieHellman", () => $7cb6d463ef497bec$export$d74daf141a551db, (v) => $7cb6d463ef497bec$export$d74daf141a551db = v);
$parcel$export(module.exports, "createSign", () => $7cb6d463ef497bec$export$45df7cae684751af, (v) => $7cb6d463ef497bec$export$45df7cae684751af = v);
$parcel$export(module.exports, "Sign", () => $7cb6d463ef497bec$export$1db683ad541682f6, (v) => $7cb6d463ef497bec$export$1db683ad541682f6 = v);
$parcel$export(module.exports, "createVerify", () => $7cb6d463ef497bec$export$6f65485f87568e37, (v) => $7cb6d463ef497bec$export$6f65485f87568e37 = v);
$parcel$export(module.exports, "Verify", () => $7cb6d463ef497bec$export$91a8e56769aeb334, (v) => $7cb6d463ef497bec$export$91a8e56769aeb334 = v);
$parcel$export(module.exports, "createECDH", () => $7cb6d463ef497bec$export$2d4117e99c2179e4, (v) => $7cb6d463ef497bec$export$2d4117e99c2179e4 = v);
$parcel$export(module.exports, "publicEncrypt", () => $7cb6d463ef497bec$export$512823e338ddb1b7, (v) => $7cb6d463ef497bec$export$512823e338ddb1b7 = v);
$parcel$export(module.exports, "privateEncrypt", () => $7cb6d463ef497bec$export$9d0e0c0c4a8d30f3, (v) => $7cb6d463ef497bec$export$9d0e0c0c4a8d30f3 = v);
$parcel$export(module.exports, "publicDecrypt", () => $7cb6d463ef497bec$export$b9d55ff329113abd, (v) => $7cb6d463ef497bec$export$b9d55ff329113abd = v);
$parcel$export(module.exports, "privateDecrypt", () => $7cb6d463ef497bec$export$7efb24e2fddf99b9, (v) => $7cb6d463ef497bec$export$7efb24e2fddf99b9 = v);
$parcel$export(module.exports, "randomFill", () => $7cb6d463ef497bec$export$bb1abf2ce84fc7e8, (v) => $7cb6d463ef497bec$export$bb1abf2ce84fc7e8 = v);
$parcel$export(module.exports, "randomFillSync", () => $7cb6d463ef497bec$export$2f7171e78e524d5e, (v) => $7cb6d463ef497bec$export$2f7171e78e524d5e = v);
$parcel$export(module.exports, "createCredentials", () => $7cb6d463ef497bec$export$e1d879b482f37d98, (v) => $7cb6d463ef497bec$export$e1d879b482f37d98 = v);
$parcel$export(module.exports, "constants", () => $7cb6d463ef497bec$export$1a988e7317c65621, (v) => $7cb6d463ef497bec$export$1a988e7317c65621 = v);
var $7cb6d463ef497bec$export$5f828d93ff035aa8;
var $7cb6d463ef497bec$export$cd94982b18c6332c;
var $7cb6d463ef497bec$export$1d518568e4f529b0;
var $7cb6d463ef497bec$export$5285b6d41c912b41;
var $7cb6d463ef497bec$export$2fb37efbf6ae0c0e;
var $7cb6d463ef497bec$export$ab85ecd77ce6a5cd;
var $7cb6d463ef497bec$export$da39cf97e1eb7c91;
var $7cb6d463ef497bec$export$52a9039d7177394f;
var $7cb6d463ef497bec$export$f7201db400317331;
var $7cb6d463ef497bec$export$448fa22aedc9dbca;
var $7cb6d463ef497bec$export$b80c7ba289c8fa56;
var $7cb6d463ef497bec$export$26e5786e8ac8e530;
var $7cb6d463ef497bec$export$bdd223f16383713e;
var $7cb6d463ef497bec$export$20533d26f07f1ee0;
var $7cb6d463ef497bec$export$2f64596b8cbf08b4;
var $7cb6d463ef497bec$export$2ce6d8d0e8b04e1a;
var $7cb6d463ef497bec$export$12ada9414fbc594c;
var $7cb6d463ef497bec$export$f5e7e39d57cd9700;
var $7cb6d463ef497bec$export$36b6d6ef312eab39;
var $7cb6d463ef497bec$export$58a258485f1e49f6;
var $7cb6d463ef497bec$export$dedd8dc3dc62b370;
var $7cb6d463ef497bec$export$971862a2fcb1bb40;
var $7cb6d463ef497bec$export$c6ff6a88acbeaf40;
var $7cb6d463ef497bec$export$fdc27893e98845cc;
var $7cb6d463ef497bec$export$6671fb9a1323bed;
var $7cb6d463ef497bec$export$d74daf141a551db;
var $7cb6d463ef497bec$export$45df7cae684751af;
var $7cb6d463ef497bec$export$1db683ad541682f6;
var $7cb6d463ef497bec$export$6f65485f87568e37;
var $7cb6d463ef497bec$export$91a8e56769aeb334;
var $7cb6d463ef497bec$export$2d4117e99c2179e4;
var $7cb6d463ef497bec$export$512823e338ddb1b7;
var $7cb6d463ef497bec$export$9d0e0c0c4a8d30f3;
var $7cb6d463ef497bec$export$b9d55ff329113abd;
var $7cb6d463ef497bec$export$7efb24e2fddf99b9;
var $7cb6d463ef497bec$export$bb1abf2ce84fc7e8;
var $7cb6d463ef497bec$export$2f7171e78e524d5e;
var $7cb6d463ef497bec$export$e1d879b482f37d98;
var $7cb6d463ef497bec$export$1a988e7317c65621;
'use strict';

$7cb6d463ef497bec$export$5f828d93ff035aa8 = $7cb6d463ef497bec$export$cd94982b18c6332c = $7cb6d463ef497bec$export$1d518568e4f529b0 = $7cb6d463ef497bec$export$5285b6d41c912b41 = (parcelRequire("ugwNY"));

$7cb6d463ef497bec$export$2fb37efbf6ae0c0e = $7cb6d463ef497bec$export$ab85ecd77ce6a5cd = (parcelRequire("cnL2y"));

$7cb6d463ef497bec$export$da39cf97e1eb7c91 = $7cb6d463ef497bec$export$52a9039d7177394f = (parcelRequire("jPoqK"));

var $61Iwu = parcelRequire("61Iwu");
var $7cb6d463ef497bec$var$algoKeys = Object.keys($61Iwu);
var $7cb6d463ef497bec$var$hashes = [
    'sha1',
    'sha224',
    'sha256',
    'sha384',
    'sha512',
    'md5',
    'rmd160'
].concat($7cb6d463ef497bec$var$algoKeys);
$7cb6d463ef497bec$export$f7201db400317331 = function() {
    return $7cb6d463ef497bec$var$hashes;
};

var $8bTm7 = parcelRequire("8bTm7");
$7cb6d463ef497bec$export$448fa22aedc9dbca = $8bTm7.pbkdf2;
$7cb6d463ef497bec$export$b80c7ba289c8fa56 = $8bTm7.pbkdf2Sync;

var $9rGLx = parcelRequire("9rGLx");
$7cb6d463ef497bec$export$26e5786e8ac8e530 = $9rGLx.Cipher;
$7cb6d463ef497bec$export$bdd223f16383713e = $9rGLx.createCipher;
$7cb6d463ef497bec$export$20533d26f07f1ee0 = $9rGLx.Cipheriv;
$7cb6d463ef497bec$export$2f64596b8cbf08b4 = $9rGLx.createCipheriv;
$7cb6d463ef497bec$export$2ce6d8d0e8b04e1a = $9rGLx.Decipher;
$7cb6d463ef497bec$export$12ada9414fbc594c = $9rGLx.createDecipher;
$7cb6d463ef497bec$export$f5e7e39d57cd9700 = $9rGLx.Decipheriv;
$7cb6d463ef497bec$export$36b6d6ef312eab39 = $9rGLx.createDecipheriv;
$7cb6d463ef497bec$export$58a258485f1e49f6 = $9rGLx.getCiphers;
$7cb6d463ef497bec$export$dedd8dc3dc62b370 = $9rGLx.listCiphers;

var $fPWK2 = parcelRequire("fPWK2");
$7cb6d463ef497bec$export$971862a2fcb1bb40 = $fPWK2.DiffieHellmanGroup;
$7cb6d463ef497bec$export$c6ff6a88acbeaf40 = $fPWK2.createDiffieHellmanGroup;
$7cb6d463ef497bec$export$fdc27893e98845cc = $fPWK2.getDiffieHellman;
$7cb6d463ef497bec$export$6671fb9a1323bed = $fPWK2.createDiffieHellman;
$7cb6d463ef497bec$export$d74daf141a551db = $fPWK2.DiffieHellman;

var $cQURD = parcelRequire("cQURD");
$7cb6d463ef497bec$export$45df7cae684751af = $cQURD.createSign;
$7cb6d463ef497bec$export$1db683ad541682f6 = $cQURD.Sign;
$7cb6d463ef497bec$export$6f65485f87568e37 = $cQURD.createVerify;
$7cb6d463ef497bec$export$91a8e56769aeb334 = $cQURD.Verify;

$7cb6d463ef497bec$export$2d4117e99c2179e4 = (parcelRequire("ks6qZ"));

var $bZRnR = parcelRequire("bZRnR");
$7cb6d463ef497bec$export$512823e338ddb1b7 = $bZRnR.publicEncrypt;
$7cb6d463ef497bec$export$9d0e0c0c4a8d30f3 = $bZRnR.privateEncrypt;
$7cb6d463ef497bec$export$b9d55ff329113abd = $bZRnR.publicDecrypt;
$7cb6d463ef497bec$export$7efb24e2fddf99b9 = $bZRnR.privateDecrypt;

var $hF130 = parcelRequire("hF130");
$7cb6d463ef497bec$export$bb1abf2ce84fc7e8 = $hF130.randomFill;
$7cb6d463ef497bec$export$2f7171e78e524d5e = $hF130.randomFillSync;
$7cb6d463ef497bec$export$e1d879b482f37d98 = function() {
    throw new Error([
        'sorry, createCredentials is not implemented yet',
        'we accept pull requests',
        'https://github.com/crypto-browserify/crypto-browserify'
    ].join('\n'));
};
$7cb6d463ef497bec$export$1a988e7317c65621 = {
    'DH_CHECK_P_NOT_SAFE_PRIME': 2,
    'DH_CHECK_P_NOT_PRIME': 1,
    'DH_UNABLE_TO_CHECK_GENERATOR': 4,
    'DH_NOT_SUITABLE_GENERATOR': 8,
    'NPN_ENABLED': 1,
    'ALPN_ENABLED': 1,
    'RSA_PKCS1_PADDING': 1,
    'RSA_SSLV23_PADDING': 2,
    'RSA_NO_PADDING': 3,
    'RSA_PKCS1_OAEP_PADDING': 4,
    'RSA_X931_PADDING': 5,
    'RSA_PKCS1_PSS_PADDING': 6,
    'POINT_CONVERSION_COMPRESSED': 2,
    'POINT_CONVERSION_UNCOMPRESSED': 4,
    'POINT_CONVERSION_HYBRID': 6
};

});
parcelRegister("ugwNY", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
'use strict';
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $05af9f9868efc57c$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $05af9f9868efc57c$var$MAX_UINT32 = 4294967295;
function $05af9f9868efc57c$var$oldBrowser() {
    throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11');
}

var $ijh2q = parcelRequire("ijh2q");
var $05af9f9868efc57c$require$Buffer = $ijh2q.Buffer;
var $05af9f9868efc57c$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($05af9f9868efc57c$var$crypto && $05af9f9868efc57c$var$crypto.getRandomValues) module.exports = $05af9f9868efc57c$var$randomBytes;
else module.exports = $05af9f9868efc57c$var$oldBrowser;
function $05af9f9868efc57c$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $05af9f9868efc57c$var$MAX_UINT32) throw new RangeError('requested too many random bytes');
    var bytes = $05af9f9868efc57c$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $05af9f9868efc57c$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $05af9f9868efc57c$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $05af9f9868efc57c$var$crypto.getRandomValues(bytes.slice(generated, generated + $05af9f9868efc57c$var$MAX_BYTES));
        else $05af9f9868efc57c$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === 'function') return $2fFJv.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});
parcelRegister("ijh2q", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $aul3P = parcelRequire("aul3P");
var $d54737c7644fd369$var$Buffer = $aul3P.Buffer;
// alternative to using Object.keys for old browsers
function $d54737c7644fd369$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($d54737c7644fd369$var$Buffer.from && $d54737c7644fd369$var$Buffer.alloc && $d54737c7644fd369$var$Buffer.allocUnsafe && $d54737c7644fd369$var$Buffer.allocUnsafeSlow) module.exports = $aul3P;
else {
    // Copy properties from require('buffer')
    $d54737c7644fd369$var$copyProps($aul3P, module.exports);
    module.exports.Buffer = $d54737c7644fd369$var$SafeBuffer;
}
function $d54737c7644fd369$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $d54737c7644fd369$var$Buffer(arg, encodingOrOffset, length);
}
$d54737c7644fd369$var$SafeBuffer.prototype = Object.create($d54737c7644fd369$var$Buffer.prototype);
// Copy static methods from Buffer
$d54737c7644fd369$var$copyProps($d54737c7644fd369$var$Buffer, $d54737c7644fd369$var$SafeBuffer);
$d54737c7644fd369$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $d54737c7644fd369$var$Buffer(arg, encodingOrOffset, length);
};
$d54737c7644fd369$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $d54737c7644fd369$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$d54737c7644fd369$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $d54737c7644fd369$var$Buffer(size);
};
$d54737c7644fd369$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $aul3P.SlowBuffer(size);
};

});


parcelRegister("cnL2y", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $903c1f32ad17f34f$require$Buffer = $aul3P.Buffer;
'use strict';

var $lyUaN = parcelRequire("lyUaN");

var $6Kk1A = parcelRequire("6Kk1A");

var $bGrC1 = parcelRequire("bGrC1");

var $lqV5D = parcelRequire("lqV5D");

var $7hBrF = parcelRequire("7hBrF");
function $903c1f32ad17f34f$var$HashNoConstructor(hash) {
    $7hBrF.call(this, 'digest');
    this._hash = hash;
    this.buffers = [];
}
$lyUaN($903c1f32ad17f34f$var$HashNoConstructor, $7hBrF);
$903c1f32ad17f34f$var$HashNoConstructor.prototype._update = function(data) {
    this.buffers.push(data);
};
$903c1f32ad17f34f$var$HashNoConstructor.prototype._final = function() {
    var buf = $903c1f32ad17f34f$require$Buffer.concat(this.buffers);
    var r = this._hash(buf);
    this.buffers = null;
    return r;
};
function $903c1f32ad17f34f$var$Hash(hash) {
    $7hBrF.call(this, 'digest');
    this._hash = hash;
}
$lyUaN($903c1f32ad17f34f$var$Hash, $7hBrF);
$903c1f32ad17f34f$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$903c1f32ad17f34f$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === 'md5') return new $903c1f32ad17f34f$var$HashNoConstructor($6Kk1A);
    if (alg === 'rmd160' || alg === 'ripemd160') return new $903c1f32ad17f34f$var$Hash(new $bGrC1());
    return new $903c1f32ad17f34f$var$Hash($lqV5D(alg));
};

});
parcelRegister("lyUaN", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("6Kk1A", function(module, exports) {
'use strict';

var $9nTll = parcelRequire("9nTll");
/*
 * Calculate the MD5 of an array of little-endian words, and a bit length
 */ function $4e969272193b5eb7$var$core_md5(x, len) {
    /* append padding */ x[len >> 5] |= 0x80 << len % 32;
    x[(len + 64 >>> 9 << 4) + 14] = len;
    var a = 1732584193;
    var b = -271733879;
    var c = -1732584194;
    var d = 271733878;
    for(var i = 0; i < x.length; i += 16){
        var olda = a;
        var oldb = b;
        var oldc = c;
        var oldd = d;
        a = $4e969272193b5eb7$var$md5_ff(a, b, c, d, x[i + 0], 7, -680876936);
        d = $4e969272193b5eb7$var$md5_ff(d, a, b, c, x[i + 1], 12, -389564586);
        c = $4e969272193b5eb7$var$md5_ff(c, d, a, b, x[i + 2], 17, 606105819);
        b = $4e969272193b5eb7$var$md5_ff(b, c, d, a, x[i + 3], 22, -1044525330);
        a = $4e969272193b5eb7$var$md5_ff(a, b, c, d, x[i + 4], 7, -176418897);
        d = $4e969272193b5eb7$var$md5_ff(d, a, b, c, x[i + 5], 12, 1200080426);
        c = $4e969272193b5eb7$var$md5_ff(c, d, a, b, x[i + 6], 17, -1473231341);
        b = $4e969272193b5eb7$var$md5_ff(b, c, d, a, x[i + 7], 22, -45705983);
        a = $4e969272193b5eb7$var$md5_ff(a, b, c, d, x[i + 8], 7, 1770035416);
        d = $4e969272193b5eb7$var$md5_ff(d, a, b, c, x[i + 9], 12, -1958414417);
        c = $4e969272193b5eb7$var$md5_ff(c, d, a, b, x[i + 10], 17, -42063);
        b = $4e969272193b5eb7$var$md5_ff(b, c, d, a, x[i + 11], 22, -1990404162);
        a = $4e969272193b5eb7$var$md5_ff(a, b, c, d, x[i + 12], 7, 1804603682);
        d = $4e969272193b5eb7$var$md5_ff(d, a, b, c, x[i + 13], 12, -40341101);
        c = $4e969272193b5eb7$var$md5_ff(c, d, a, b, x[i + 14], 17, -1502002290);
        b = $4e969272193b5eb7$var$md5_ff(b, c, d, a, x[i + 15], 22, 1236535329);
        a = $4e969272193b5eb7$var$md5_gg(a, b, c, d, x[i + 1], 5, -165796510);
        d = $4e969272193b5eb7$var$md5_gg(d, a, b, c, x[i + 6], 9, -1069501632);
        c = $4e969272193b5eb7$var$md5_gg(c, d, a, b, x[i + 11], 14, 643717713);
        b = $4e969272193b5eb7$var$md5_gg(b, c, d, a, x[i + 0], 20, -373897302);
        a = $4e969272193b5eb7$var$md5_gg(a, b, c, d, x[i + 5], 5, -701558691);
        d = $4e969272193b5eb7$var$md5_gg(d, a, b, c, x[i + 10], 9, 38016083);
        c = $4e969272193b5eb7$var$md5_gg(c, d, a, b, x[i + 15], 14, -660478335);
        b = $4e969272193b5eb7$var$md5_gg(b, c, d, a, x[i + 4], 20, -405537848);
        a = $4e969272193b5eb7$var$md5_gg(a, b, c, d, x[i + 9], 5, 568446438);
        d = $4e969272193b5eb7$var$md5_gg(d, a, b, c, x[i + 14], 9, -1019803690);
        c = $4e969272193b5eb7$var$md5_gg(c, d, a, b, x[i + 3], 14, -187363961);
        b = $4e969272193b5eb7$var$md5_gg(b, c, d, a, x[i + 8], 20, 1163531501);
        a = $4e969272193b5eb7$var$md5_gg(a, b, c, d, x[i + 13], 5, -1444681467);
        d = $4e969272193b5eb7$var$md5_gg(d, a, b, c, x[i + 2], 9, -51403784);
        c = $4e969272193b5eb7$var$md5_gg(c, d, a, b, x[i + 7], 14, 1735328473);
        b = $4e969272193b5eb7$var$md5_gg(b, c, d, a, x[i + 12], 20, -1926607734);
        a = $4e969272193b5eb7$var$md5_hh(a, b, c, d, x[i + 5], 4, -378558);
        d = $4e969272193b5eb7$var$md5_hh(d, a, b, c, x[i + 8], 11, -2022574463);
        c = $4e969272193b5eb7$var$md5_hh(c, d, a, b, x[i + 11], 16, 1839030562);
        b = $4e969272193b5eb7$var$md5_hh(b, c, d, a, x[i + 14], 23, -35309556);
        a = $4e969272193b5eb7$var$md5_hh(a, b, c, d, x[i + 1], 4, -1530992060);
        d = $4e969272193b5eb7$var$md5_hh(d, a, b, c, x[i + 4], 11, 1272893353);
        c = $4e969272193b5eb7$var$md5_hh(c, d, a, b, x[i + 7], 16, -155497632);
        b = $4e969272193b5eb7$var$md5_hh(b, c, d, a, x[i + 10], 23, -1094730640);
        a = $4e969272193b5eb7$var$md5_hh(a, b, c, d, x[i + 13], 4, 681279174);
        d = $4e969272193b5eb7$var$md5_hh(d, a, b, c, x[i + 0], 11, -358537222);
        c = $4e969272193b5eb7$var$md5_hh(c, d, a, b, x[i + 3], 16, -722521979);
        b = $4e969272193b5eb7$var$md5_hh(b, c, d, a, x[i + 6], 23, 76029189);
        a = $4e969272193b5eb7$var$md5_hh(a, b, c, d, x[i + 9], 4, -640364487);
        d = $4e969272193b5eb7$var$md5_hh(d, a, b, c, x[i + 12], 11, -421815835);
        c = $4e969272193b5eb7$var$md5_hh(c, d, a, b, x[i + 15], 16, 530742520);
        b = $4e969272193b5eb7$var$md5_hh(b, c, d, a, x[i + 2], 23, -995338651);
        a = $4e969272193b5eb7$var$md5_ii(a, b, c, d, x[i + 0], 6, -198630844);
        d = $4e969272193b5eb7$var$md5_ii(d, a, b, c, x[i + 7], 10, 1126891415);
        c = $4e969272193b5eb7$var$md5_ii(c, d, a, b, x[i + 14], 15, -1416354905);
        b = $4e969272193b5eb7$var$md5_ii(b, c, d, a, x[i + 5], 21, -57434055);
        a = $4e969272193b5eb7$var$md5_ii(a, b, c, d, x[i + 12], 6, 1700485571);
        d = $4e969272193b5eb7$var$md5_ii(d, a, b, c, x[i + 3], 10, -1894986606);
        c = $4e969272193b5eb7$var$md5_ii(c, d, a, b, x[i + 10], 15, -1051523);
        b = $4e969272193b5eb7$var$md5_ii(b, c, d, a, x[i + 1], 21, -2054922799);
        a = $4e969272193b5eb7$var$md5_ii(a, b, c, d, x[i + 8], 6, 1873313359);
        d = $4e969272193b5eb7$var$md5_ii(d, a, b, c, x[i + 15], 10, -30611744);
        c = $4e969272193b5eb7$var$md5_ii(c, d, a, b, x[i + 6], 15, -1560198380);
        b = $4e969272193b5eb7$var$md5_ii(b, c, d, a, x[i + 13], 21, 1309151649);
        a = $4e969272193b5eb7$var$md5_ii(a, b, c, d, x[i + 4], 6, -145523070);
        d = $4e969272193b5eb7$var$md5_ii(d, a, b, c, x[i + 11], 10, -1120210379);
        c = $4e969272193b5eb7$var$md5_ii(c, d, a, b, x[i + 2], 15, 718787259);
        b = $4e969272193b5eb7$var$md5_ii(b, c, d, a, x[i + 9], 21, -343485551);
        a = $4e969272193b5eb7$var$safe_add(a, olda);
        b = $4e969272193b5eb7$var$safe_add(b, oldb);
        c = $4e969272193b5eb7$var$safe_add(c, oldc);
        d = $4e969272193b5eb7$var$safe_add(d, oldd);
    }
    return [
        a,
        b,
        c,
        d
    ];
}
/*
 * These functions implement the four basic operations the algorithm uses.
 */ function $4e969272193b5eb7$var$md5_cmn(q, a, b, x, s, t) {
    return $4e969272193b5eb7$var$safe_add($4e969272193b5eb7$var$bit_rol($4e969272193b5eb7$var$safe_add($4e969272193b5eb7$var$safe_add(a, q), $4e969272193b5eb7$var$safe_add(x, t)), s), b);
}
function $4e969272193b5eb7$var$md5_ff(a, b, c, d, x, s, t) {
    return $4e969272193b5eb7$var$md5_cmn(b & c | ~b & d, a, b, x, s, t);
}
function $4e969272193b5eb7$var$md5_gg(a, b, c, d, x, s, t) {
    return $4e969272193b5eb7$var$md5_cmn(b & d | c & ~d, a, b, x, s, t);
}
function $4e969272193b5eb7$var$md5_hh(a, b, c, d, x, s, t) {
    return $4e969272193b5eb7$var$md5_cmn(b ^ c ^ d, a, b, x, s, t);
}
function $4e969272193b5eb7$var$md5_ii(a, b, c, d, x, s, t) {
    return $4e969272193b5eb7$var$md5_cmn(c ^ (b | ~d), a, b, x, s, t);
}
/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */ function $4e969272193b5eb7$var$safe_add(x, y) {
    var lsw = (x & 0xFFFF) + (y & 0xFFFF);
    var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
    return msw << 16 | lsw & 0xFFFF;
}
/*
 * Bitwise rotate a 32-bit number to the left.
 */ function $4e969272193b5eb7$var$bit_rol(num, cnt) {
    return num << cnt | num >>> 32 - cnt;
}
module.exports = function md5(buf) {
    return $9nTll(buf, $4e969272193b5eb7$var$core_md5);
};

});
parcelRegister("9nTll", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $6d5131133b33993d$require$Buffer = $aul3P.Buffer;
'use strict';
var $6d5131133b33993d$var$intSize = 4;
var $6d5131133b33993d$var$zeroBuffer = new $6d5131133b33993d$require$Buffer($6d5131133b33993d$var$intSize);
$6d5131133b33993d$var$zeroBuffer.fill(0);
var $6d5131133b33993d$var$charSize = 8;
var $6d5131133b33993d$var$hashSize = 16;
function $6d5131133b33993d$var$toArray(buf) {
    if (buf.length % $6d5131133b33993d$var$intSize !== 0) {
        var len = buf.length + ($6d5131133b33993d$var$intSize - buf.length % $6d5131133b33993d$var$intSize);
        buf = $6d5131133b33993d$require$Buffer.concat([
            buf,
            $6d5131133b33993d$var$zeroBuffer
        ], len);
    }
    var arr = new Array(buf.length >>> 2);
    for(var i = 0, j = 0; i < buf.length; i += $6d5131133b33993d$var$intSize, j++)arr[j] = buf.readInt32LE(i);
    return arr;
}
module.exports = function hash(buf, fn) {
    var arr = fn($6d5131133b33993d$var$toArray(buf), buf.length * $6d5131133b33993d$var$charSize);
    buf = new $6d5131133b33993d$require$Buffer($6d5131133b33993d$var$hashSize);
    for(var i = 0; i < arr.length; i++)buf.writeInt32LE(arr[i], i << 2, true);
    return buf;
};

});


parcelRegister("bGrC1", function(module, exports) {
'use strict';

var $aul3P = parcelRequire("aul3P");
var $88190928fdba87c8$require$Buffer = $aul3P.Buffer;

var $lyUaN = parcelRequire("lyUaN");

var $2UmI8 = parcelRequire("2UmI8");
var $88190928fdba87c8$var$ARRAY16 = new Array(16);
var $88190928fdba87c8$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $88190928fdba87c8$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $88190928fdba87c8$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $88190928fdba87c8$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $88190928fdba87c8$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $88190928fdba87c8$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $88190928fdba87c8$var$RIPEMD160() {
    $2UmI8.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$lyUaN($88190928fdba87c8$var$RIPEMD160, $2UmI8);
$88190928fdba87c8$var$RIPEMD160.prototype._update = function() {
    var words = $88190928fdba87c8$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $88190928fdba87c8$var$fn1(al, bl, cl, dl, el, words[$88190928fdba87c8$var$zl[i]], $88190928fdba87c8$var$hl[0], $88190928fdba87c8$var$sl[i]);
            tr = $88190928fdba87c8$var$fn5(ar, br, cr, dr, er, words[$88190928fdba87c8$var$zr[i]], $88190928fdba87c8$var$hr[0], $88190928fdba87c8$var$sr[i]);
        } else if (i < 32) {
            tl = $88190928fdba87c8$var$fn2(al, bl, cl, dl, el, words[$88190928fdba87c8$var$zl[i]], $88190928fdba87c8$var$hl[1], $88190928fdba87c8$var$sl[i]);
            tr = $88190928fdba87c8$var$fn4(ar, br, cr, dr, er, words[$88190928fdba87c8$var$zr[i]], $88190928fdba87c8$var$hr[1], $88190928fdba87c8$var$sr[i]);
        } else if (i < 48) {
            tl = $88190928fdba87c8$var$fn3(al, bl, cl, dl, el, words[$88190928fdba87c8$var$zl[i]], $88190928fdba87c8$var$hl[2], $88190928fdba87c8$var$sl[i]);
            tr = $88190928fdba87c8$var$fn3(ar, br, cr, dr, er, words[$88190928fdba87c8$var$zr[i]], $88190928fdba87c8$var$hr[2], $88190928fdba87c8$var$sr[i]);
        } else if (i < 64) {
            tl = $88190928fdba87c8$var$fn4(al, bl, cl, dl, el, words[$88190928fdba87c8$var$zl[i]], $88190928fdba87c8$var$hl[3], $88190928fdba87c8$var$sl[i]);
            tr = $88190928fdba87c8$var$fn2(ar, br, cr, dr, er, words[$88190928fdba87c8$var$zr[i]], $88190928fdba87c8$var$hr[3], $88190928fdba87c8$var$sr[i]);
        } else {
            tl = $88190928fdba87c8$var$fn5(al, bl, cl, dl, el, words[$88190928fdba87c8$var$zl[i]], $88190928fdba87c8$var$hl[4], $88190928fdba87c8$var$sl[i]);
            tr = $88190928fdba87c8$var$fn1(ar, br, cr, dr, er, words[$88190928fdba87c8$var$zr[i]], $88190928fdba87c8$var$hr[4], $88190928fdba87c8$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $88190928fdba87c8$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $88190928fdba87c8$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$88190928fdba87c8$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $88190928fdba87c8$require$Buffer.alloc ? $88190928fdba87c8$require$Buffer.alloc(20) : new $88190928fdba87c8$require$Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function $88190928fdba87c8$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $88190928fdba87c8$var$fn1(a, b, c, d, e, m, k, s) {
    return $88190928fdba87c8$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $88190928fdba87c8$var$fn2(a, b, c, d, e, m, k, s) {
    return $88190928fdba87c8$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $88190928fdba87c8$var$fn3(a, b, c, d, e, m, k, s) {
    return $88190928fdba87c8$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $88190928fdba87c8$var$fn4(a, b, c, d, e, m, k, s) {
    return $88190928fdba87c8$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $88190928fdba87c8$var$fn5(a, b, c, d, e, m, k, s) {
    return $88190928fdba87c8$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
module.exports = $88190928fdba87c8$var$RIPEMD160;

});
parcelRegister("2UmI8", function(module, exports) {
'use strict';

var $ijh2q = parcelRequire("ijh2q");
var $21e26da029925685$require$Buffer = $ijh2q.Buffer;

var $anz8L = parcelRequire("anz8L");
var $21e26da029925685$require$Transform = $anz8L.Transform;

var $lyUaN = parcelRequire("lyUaN");
function $21e26da029925685$var$throwIfNotStringOrBuffer(val, prefix) {
    if (!$21e26da029925685$require$Buffer.isBuffer(val) && typeof val !== 'string') throw new TypeError(prefix + ' must be a string or a buffer');
}
function $21e26da029925685$var$HashBase(blockSize) {
    $21e26da029925685$require$Transform.call(this);
    this._block = $21e26da029925685$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$lyUaN($21e26da029925685$var$HashBase, $21e26da029925685$require$Transform);
$21e26da029925685$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$21e26da029925685$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$21e26da029925685$var$HashBase.prototype.update = function(data, encoding) {
    $21e26da029925685$var$throwIfNotStringOrBuffer(data, 'Data');
    if (this._finalized) throw new Error('Digest already called');
    if (!$21e26da029925685$require$Buffer.isBuffer(data)) data = $21e26da029925685$require$Buffer.from(data, encoding);
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$21e26da029925685$var$HashBase.prototype._update = function() {
    throw new Error('_update is not implemented');
};
$21e26da029925685$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$21e26da029925685$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $21e26da029925685$var$HashBase;

});
parcelRegister("anz8L", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $78e74f7c5379cef2$var$Stream;

var $3sTLs = parcelRequire("3sTLs");
var $78e74f7c5379cef2$require$EE = $3sTLs.EventEmitter;

var $lyUaN = parcelRequire("lyUaN");
$lyUaN($78e74f7c5379cef2$var$Stream, $78e74f7c5379cef2$require$EE);

$78e74f7c5379cef2$var$Stream.Readable = (parcelRequire("hd0Wp"));

$78e74f7c5379cef2$var$Stream.Writable = (parcelRequire("kKpgC"));

$78e74f7c5379cef2$var$Stream.Duplex = (parcelRequire("aoI29"));

$78e74f7c5379cef2$var$Stream.Transform = (parcelRequire("lUyqo"));

$78e74f7c5379cef2$var$Stream.PassThrough = (parcelRequire("4kZwd"));

$78e74f7c5379cef2$var$Stream.finished = (parcelRequire("jV6VG"));

$78e74f7c5379cef2$var$Stream.pipeline = (parcelRequire("8Ms18"));
// Backwards-compat with node 0.4.x
$78e74f7c5379cef2$var$Stream.Stream = $78e74f7c5379cef2$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $78e74f7c5379cef2$var$Stream() {
    $78e74f7c5379cef2$require$EE.call(this);
}
$78e74f7c5379cef2$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($78e74f7c5379cef2$require$EE.listenerCount(this, 'error') === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on('error', onerror);
    dest.on('error', onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});
parcelRegister("hd0Wp", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $2fFJv = parcelRequire("2fFJv");
'use strict';
module.exports = $c874616fccc431a8$var$Readable;
/*<replacement>*/ var $c874616fccc431a8$var$Duplex;
/*</replacement>*/ $c874616fccc431a8$var$Readable.ReadableState = $c874616fccc431a8$var$ReadableState;

var $3sTLs = parcelRequire("3sTLs");
var $c874616fccc431a8$require$EE = $3sTLs.EventEmitter;
var $c874616fccc431a8$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $8wk3O = parcelRequire("8wk3O");

var $aul3P = parcelRequire("aul3P");
var $c874616fccc431a8$require$Buffer = $aul3P.Buffer;
var $c874616fccc431a8$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $c874616fccc431a8$var$_uint8ArrayToBuffer(chunk) {
    return $c874616fccc431a8$require$Buffer.from(chunk);
}
function $c874616fccc431a8$var$_isUint8Array(obj) {
    return $c874616fccc431a8$require$Buffer.isBuffer(obj) || obj instanceof $c874616fccc431a8$var$OurUint8Array;
}

var $jFleb = parcelRequire("jFleb");
var $c874616fccc431a8$var$debug;
if ($jFleb && $jFleb.debuglog) $c874616fccc431a8$var$debug = $jFleb.debuglog('stream');
else $c874616fccc431a8$var$debug = function debug() {};

var $jx80w = parcelRequire("jx80w");

var $lzWKR = parcelRequire("lzWKR");

var $dsJPG = parcelRequire("dsJPG");
var $c874616fccc431a8$var$getHighWaterMark = $dsJPG.getHighWaterMark;

var $i8n8u = parcelRequire("i8n8u");
var $c874616fccc431a8$require$_require$codes = $i8n8u.codes;
var $c874616fccc431a8$var$ERR_INVALID_ARG_TYPE = $c874616fccc431a8$require$_require$codes.ERR_INVALID_ARG_TYPE, $c874616fccc431a8$var$ERR_STREAM_PUSH_AFTER_EOF = $c874616fccc431a8$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $c874616fccc431a8$var$ERR_METHOD_NOT_IMPLEMENTED = $c874616fccc431a8$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $c874616fccc431a8$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $c874616fccc431a8$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $c874616fccc431a8$var$StringDecoder;
var $c874616fccc431a8$var$createReadableStreamAsyncIterator;
var $c874616fccc431a8$var$from;

(parcelRequire("lyUaN"))($c874616fccc431a8$var$Readable, $8wk3O);
var $c874616fccc431a8$var$errorOrDestroy = $lzWKR.errorOrDestroy;
var $c874616fccc431a8$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $c874616fccc431a8$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $c874616fccc431a8$var$ReadableState(options, stream, isDuplex) {
    $c874616fccc431a8$var$Duplex = $c874616fccc431a8$var$Duplex || (parcelRequire("aoI29"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $c874616fccc431a8$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $c874616fccc431a8$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $jx80w();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$c874616fccc431a8$var$StringDecoder) $c874616fccc431a8$var$StringDecoder = (parcelRequire("iSptP")).StringDecoder;
        this.decoder = new $c874616fccc431a8$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $c874616fccc431a8$var$Readable(options) {
    $c874616fccc431a8$var$Duplex = $c874616fccc431a8$var$Duplex || (parcelRequire("aoI29"));
    if (!(this instanceof $c874616fccc431a8$var$Readable)) return new $c874616fccc431a8$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $c874616fccc431a8$var$Duplex;
    this._readableState = new $c874616fccc431a8$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $8wk3O.call(this);
}
Object.defineProperty($c874616fccc431a8$var$Readable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$c874616fccc431a8$var$Readable.prototype.destroy = $lzWKR.destroy;
$c874616fccc431a8$var$Readable.prototype._undestroy = $lzWKR.undestroy;
$c874616fccc431a8$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$c874616fccc431a8$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $c874616fccc431a8$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $c874616fccc431a8$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$c874616fccc431a8$var$Readable.prototype.unshift = function(chunk) {
    return $c874616fccc431a8$var$readableAddChunk(this, chunk, null, true, false);
};
function $c874616fccc431a8$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $c874616fccc431a8$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $c874616fccc431a8$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $c874616fccc431a8$var$chunkInvalid(state, chunk);
        if (er) $c874616fccc431a8$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $c874616fccc431a8$require$Buffer.prototype) chunk = $c874616fccc431a8$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $c874616fccc431a8$var$errorOrDestroy(stream, new $c874616fccc431a8$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $c874616fccc431a8$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $c874616fccc431a8$var$errorOrDestroy(stream, new $c874616fccc431a8$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $c874616fccc431a8$var$addChunk(stream, state, chunk, false);
                    else $c874616fccc431a8$var$maybeReadMore(stream, state);
                } else $c874616fccc431a8$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $c874616fccc431a8$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $c874616fccc431a8$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit('data', chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $c874616fccc431a8$var$emitReadable(stream);
    }
    $c874616fccc431a8$var$maybeReadMore(stream, state);
}
function $c874616fccc431a8$var$chunkInvalid(state, chunk) {
    var er;
    if (!$c874616fccc431a8$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new $c874616fccc431a8$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer',
        'Uint8Array'
    ], chunk);
    return er;
}
$c874616fccc431a8$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$c874616fccc431a8$var$Readable.prototype.setEncoding = function(enc) {
    if (!$c874616fccc431a8$var$StringDecoder) $c874616fccc431a8$var$StringDecoder = (parcelRequire("iSptP")).StringDecoder;
    var decoder = new $c874616fccc431a8$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = '';
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== '') this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $c874616fccc431a8$var$MAX_HWM = 0x40000000;
function $c874616fccc431a8$var$computeNewHighWaterMark(n) {
    if (n >= $c874616fccc431a8$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $c874616fccc431a8$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $c874616fccc431a8$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $c874616fccc431a8$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$c874616fccc431a8$var$Readable.prototype.read = function(n) {
    $c874616fccc431a8$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $c874616fccc431a8$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $c874616fccc431a8$var$endReadable(this);
        else $c874616fccc431a8$var$emitReadable(this);
        return null;
    }
    n = $c874616fccc431a8$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $c874616fccc431a8$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $c874616fccc431a8$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $c874616fccc431a8$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $c874616fccc431a8$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $c874616fccc431a8$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $c874616fccc431a8$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $c874616fccc431a8$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $c874616fccc431a8$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $c874616fccc431a8$var$onEofChunk(stream, state) {
    $c874616fccc431a8$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $c874616fccc431a8$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $c874616fccc431a8$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $c874616fccc431a8$var$emitReadable(stream) {
    var state = stream._readableState;
    $c874616fccc431a8$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $c874616fccc431a8$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $2fFJv.nextTick($c874616fccc431a8$var$emitReadable_, stream);
    }
}
function $c874616fccc431a8$var$emitReadable_(stream) {
    var state = stream._readableState;
    $c874616fccc431a8$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $c874616fccc431a8$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $c874616fccc431a8$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $2fFJv.nextTick($c874616fccc431a8$var$maybeReadMore_, stream, state);
    }
}
function $c874616fccc431a8$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $c874616fccc431a8$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$c874616fccc431a8$var$Readable.prototype._read = function(n) {
    $c874616fccc431a8$var$errorOrDestroy(this, new $c874616fccc431a8$var$ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
$c874616fccc431a8$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $c874616fccc431a8$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $2fFJv.stdout && dest !== $2fFJv.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $2fFJv.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $c874616fccc431a8$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $c874616fccc431a8$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $c874616fccc431a8$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $c874616fccc431a8$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $c874616fccc431a8$var$debug('ondata');
        var ret = dest.write(chunk);
        $c874616fccc431a8$var$debug('dest.write', ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $c874616fccc431a8$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $c874616fccc431a8$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $c874616fccc431a8$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($c874616fccc431a8$var$EElistenerCount(dest, 'error') === 0) $c874616fccc431a8$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $c874616fccc431a8$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $c874616fccc431a8$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $c874616fccc431a8$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $c874616fccc431a8$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $c874616fccc431a8$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $c874616fccc431a8$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $c874616fccc431a8$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $c874616fccc431a8$var$flow(src);
        }
    };
}
$c874616fccc431a8$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $c874616fccc431a8$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$c874616fccc431a8$var$Readable.prototype.on = function(ev, fn) {
    var res = $8wk3O.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $c874616fccc431a8$var$debug('on readable', state.length, state.reading);
            if (state.length) $c874616fccc431a8$var$emitReadable(this);
            else if (!state.reading) $2fFJv.nextTick($c874616fccc431a8$var$nReadingNextTick, this);
        }
    }
    return res;
};
$c874616fccc431a8$var$Readable.prototype.addListener = $c874616fccc431a8$var$Readable.prototype.on;
$c874616fccc431a8$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $8wk3O.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2fFJv.nextTick($c874616fccc431a8$var$updateReadableListening, this);
    return res;
};
$c874616fccc431a8$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $8wk3O.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $2fFJv.nextTick($c874616fccc431a8$var$updateReadableListening, this);
    return res;
};
function $c874616fccc431a8$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount('readable') > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount('data') > 0) self1.resume();
}
function $c874616fccc431a8$var$nReadingNextTick(self1) {
    $c874616fccc431a8$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$c874616fccc431a8$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $c874616fccc431a8$var$debug('resume');
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $c874616fccc431a8$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $c874616fccc431a8$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $2fFJv.nextTick($c874616fccc431a8$var$resume_, stream, state);
    }
}
function $c874616fccc431a8$var$resume_(stream, state) {
    $c874616fccc431a8$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $c874616fccc431a8$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$c874616fccc431a8$var$Readable.prototype.pause = function() {
    $c874616fccc431a8$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $c874616fccc431a8$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState.paused = true;
    return this;
};
function $c874616fccc431a8$var$flow(stream) {
    var state = stream._readableState;
    $c874616fccc431a8$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$c874616fccc431a8$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $c874616fccc431a8$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $c874616fccc431a8$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $c874616fccc431a8$var$kProxyEvents.length; n++)stream.on($c874616fccc431a8$var$kProxyEvents[n], this.emit.bind(this, $c874616fccc431a8$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $c874616fccc431a8$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === 'function') $c874616fccc431a8$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($c874616fccc431a8$var$createReadableStreamAsyncIterator === undefined) $c874616fccc431a8$var$createReadableStreamAsyncIterator = (parcelRequire("eryNp"));
    return $c874616fccc431a8$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($c874616fccc431a8$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($c874616fccc431a8$var$Readable.prototype, 'readableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($c874616fccc431a8$var$Readable.prototype, 'readableFlowing', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$c874616fccc431a8$var$Readable._fromList = $c874616fccc431a8$var$fromList;
Object.defineProperty($c874616fccc431a8$var$Readable.prototype, 'readableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $c874616fccc431a8$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $c874616fccc431a8$var$endReadable(stream) {
    var state = stream._readableState;
    $c874616fccc431a8$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $2fFJv.nextTick($c874616fccc431a8$var$endReadableNT, state, stream);
    }
}
function $c874616fccc431a8$var$endReadableNT(state, stream) {
    $c874616fccc431a8$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === 'function') $c874616fccc431a8$var$Readable.from = function(iterable, opts) {
    if ($c874616fccc431a8$var$from === undefined) $c874616fccc431a8$var$from = (parcelRequire("gljMO"));
    return $c874616fccc431a8$var$from($c874616fccc431a8$var$Readable, iterable, opts);
};
function $c874616fccc431a8$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("8wk3O", function(module, exports) {

module.exports = (parcelRequire("3sTLs")).EventEmitter;

});

parcelRegister("jFleb", function(module, exports) {
"use strict";

});

parcelRegister("jx80w", function(module, exports) {
'use strict';
function $e3874f7ac1f848ee$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e3874f7ac1f848ee$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $e3874f7ac1f848ee$var$ownKeys(Object(source), !0).forEach(function(key) {
            $e3874f7ac1f848ee$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $e3874f7ac1f848ee$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e3874f7ac1f848ee$var$_defineProperty(obj, key, value) {
    key = $e3874f7ac1f848ee$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e3874f7ac1f848ee$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e3874f7ac1f848ee$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $e3874f7ac1f848ee$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $e3874f7ac1f848ee$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e3874f7ac1f848ee$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e3874f7ac1f848ee$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $e3874f7ac1f848ee$var$_toPropertyKey(arg) {
    var key = $e3874f7ac1f848ee$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $e3874f7ac1f848ee$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $aul3P = parcelRequire("aul3P");
var $e3874f7ac1f848ee$var$Buffer = $aul3P.Buffer;

var $jFleb = parcelRequire("jFleb");
var $e3874f7ac1f848ee$var$inspect = $jFleb.inspect;
var $e3874f7ac1f848ee$var$custom = $e3874f7ac1f848ee$var$inspect && $e3874f7ac1f848ee$var$inspect.custom || 'inspect';
function $e3874f7ac1f848ee$var$copyBuffer(src, target, offset) {
    $e3874f7ac1f848ee$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $e3874f7ac1f848ee$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $e3874f7ac1f848ee$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $e3874f7ac1f848ee$var$Buffer.alloc(0);
                var ret = $e3874f7ac1f848ee$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $e3874f7ac1f848ee$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $e3874f7ac1f848ee$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $e3874f7ac1f848ee$var$custom,
            value: function value(_, options) {
                return $e3874f7ac1f848ee$var$inspect(this, $e3874f7ac1f848ee$var$_objectSpread($e3874f7ac1f848ee$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("lzWKR", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
'use strict';
// undocumented cb() API, needed for core, not for public API
function $fb5a7154f411547f$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $2fFJv.nextTick($fb5a7154f411547f$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $2fFJv.nextTick($fb5a7154f411547f$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $2fFJv.nextTick($fb5a7154f411547f$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $2fFJv.nextTick($fb5a7154f411547f$var$emitErrorAndCloseNT, _this, err);
            } else $2fFJv.nextTick($fb5a7154f411547f$var$emitCloseNT, _this);
        } else if (cb) {
            $2fFJv.nextTick($fb5a7154f411547f$var$emitCloseNT, _this);
            cb(err);
        } else $2fFJv.nextTick($fb5a7154f411547f$var$emitCloseNT, _this);
    });
    return this;
}
function $fb5a7154f411547f$var$emitErrorAndCloseNT(self, err) {
    $fb5a7154f411547f$var$emitErrorNT(self, err);
    $fb5a7154f411547f$var$emitCloseNT(self);
}
function $fb5a7154f411547f$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit('close');
}
function $fb5a7154f411547f$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $fb5a7154f411547f$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
function $fb5a7154f411547f$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit('error', err);
}
module.exports = {
    destroy: $fb5a7154f411547f$var$destroy,
    undestroy: $fb5a7154f411547f$var$undestroy,
    errorOrDestroy: $fb5a7154f411547f$var$errorOrDestroy
};

});

parcelRegister("dsJPG", function(module, exports) {
'use strict';

var $9cd1714906576d1f$var$ERR_INVALID_OPT_VALUE = (parcelRequire("i8n8u")).codes.ERR_INVALID_OPT_VALUE;
function $9cd1714906576d1f$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $9cd1714906576d1f$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $9cd1714906576d1f$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : 'highWaterMark';
            throw new $9cd1714906576d1f$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $9cd1714906576d1f$var$getHighWaterMark
};

});
parcelRegister("i8n8u", function(module, exports) {

$parcel$export(module.exports, "codes", () => $d33aeba58cf9ee4e$export$e45cb6485273080e, (v) => $d33aeba58cf9ee4e$export$e45cb6485273080e = v);
var $d33aeba58cf9ee4e$export$e45cb6485273080e;
'use strict';
function $d33aeba58cf9ee4e$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $d33aeba58cf9ee4e$var$codes = {};
function $d33aeba58cf9ee4e$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $d33aeba58cf9ee4e$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $d33aeba58cf9ee4e$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $d33aeba58cf9ee4e$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $d33aeba58cf9ee4e$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $d33aeba58cf9ee4e$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $d33aeba58cf9ee4e$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$d33aeba58cf9ee4e$var$createErrorType('ERR_INVALID_OPT_VALUE', function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$d33aeba58cf9ee4e$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $d33aeba58cf9ee4e$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($d33aeba58cf9ee4e$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($d33aeba58cf9ee4e$var$oneOf(expected, 'type'));
    else {
        var type = $d33aeba58cf9ee4e$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($d33aeba58cf9ee4e$var$oneOf(expected, 'type'));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$d33aeba58cf9ee4e$var$createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
$d33aeba58cf9ee4e$var$createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function(name) {
    return 'The ' + name + ' method is not implemented';
});
$d33aeba58cf9ee4e$var$createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
$d33aeba58cf9ee4e$var$createErrorType('ERR_STREAM_DESTROYED', function(name) {
    return 'Cannot call ' + name + ' after a stream was destroyed';
});
$d33aeba58cf9ee4e$var$createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
$d33aeba58cf9ee4e$var$createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
$d33aeba58cf9ee4e$var$createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
$d33aeba58cf9ee4e$var$createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$d33aeba58cf9ee4e$var$createErrorType('ERR_UNKNOWN_ENCODING', function(arg) {
    return 'Unknown encoding: ' + arg;
}, TypeError);
$d33aeba58cf9ee4e$var$createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
$d33aeba58cf9ee4e$export$e45cb6485273080e = $d33aeba58cf9ee4e$var$codes;

});


parcelRegister("aoI29", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $2fFJv = parcelRequire("2fFJv");
'use strict';
/*<replacement>*/ var $791e4d7664ce07ae$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $791e4d7664ce07ae$var$Duplex;

var $hd0Wp = parcelRequire("hd0Wp");

var $kKpgC = parcelRequire("kKpgC");

(parcelRequire("lyUaN"))($791e4d7664ce07ae$var$Duplex, $hd0Wp);
// Allow the keys array to be GC'ed.
var $791e4d7664ce07ae$var$keys = $791e4d7664ce07ae$var$objectKeys($kKpgC.prototype);
for(var $791e4d7664ce07ae$var$v = 0; $791e4d7664ce07ae$var$v < $791e4d7664ce07ae$var$keys.length; $791e4d7664ce07ae$var$v++){
    var $791e4d7664ce07ae$var$method = $791e4d7664ce07ae$var$keys[$791e4d7664ce07ae$var$v];
    if (!$791e4d7664ce07ae$var$Duplex.prototype[$791e4d7664ce07ae$var$method]) $791e4d7664ce07ae$var$Duplex.prototype[$791e4d7664ce07ae$var$method] = $kKpgC.prototype[$791e4d7664ce07ae$var$method];
}
function $791e4d7664ce07ae$var$Duplex(options) {
    if (!(this instanceof $791e4d7664ce07ae$var$Duplex)) return new $791e4d7664ce07ae$var$Duplex(options);
    $hd0Wp.call(this, options);
    $kKpgC.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once('end', $791e4d7664ce07ae$var$onend);
        }
    }
}
Object.defineProperty($791e4d7664ce07ae$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($791e4d7664ce07ae$var$Duplex.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($791e4d7664ce07ae$var$Duplex.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $791e4d7664ce07ae$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $2fFJv.nextTick($791e4d7664ce07ae$var$onEndNT, this);
}
function $791e4d7664ce07ae$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($791e4d7664ce07ae$var$Duplex.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("kKpgC", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $2fFJv = parcelRequire("2fFJv");
'use strict';
module.exports = $f1abb40b22f49859$var$Writable;
/* <replacement> */ function $f1abb40b22f49859$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $f1abb40b22f49859$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $f1abb40b22f49859$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $f1abb40b22f49859$var$Duplex;
/*</replacement>*/ $f1abb40b22f49859$var$Writable.WritableState = $f1abb40b22f49859$var$WritableState;

/*<replacement>*/ var $f1abb40b22f49859$var$internalUtil = {
    deprecate: (parcelRequire("6UWyy"))
};

var $8wk3O = parcelRequire("8wk3O");

var $aul3P = parcelRequire("aul3P");
var $f1abb40b22f49859$require$Buffer = $aul3P.Buffer;
var $f1abb40b22f49859$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $f1abb40b22f49859$var$_uint8ArrayToBuffer(chunk) {
    return $f1abb40b22f49859$require$Buffer.from(chunk);
}
function $f1abb40b22f49859$var$_isUint8Array(obj) {
    return $f1abb40b22f49859$require$Buffer.isBuffer(obj) || obj instanceof $f1abb40b22f49859$var$OurUint8Array;
}

var $lzWKR = parcelRequire("lzWKR");

var $dsJPG = parcelRequire("dsJPG");
var $f1abb40b22f49859$var$getHighWaterMark = $dsJPG.getHighWaterMark;

var $i8n8u = parcelRequire("i8n8u");
var $f1abb40b22f49859$require$_require$codes = $i8n8u.codes;
var $f1abb40b22f49859$var$ERR_INVALID_ARG_TYPE = $f1abb40b22f49859$require$_require$codes.ERR_INVALID_ARG_TYPE, $f1abb40b22f49859$var$ERR_METHOD_NOT_IMPLEMENTED = $f1abb40b22f49859$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $f1abb40b22f49859$var$ERR_MULTIPLE_CALLBACK = $f1abb40b22f49859$require$_require$codes.ERR_MULTIPLE_CALLBACK, $f1abb40b22f49859$var$ERR_STREAM_CANNOT_PIPE = $f1abb40b22f49859$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $f1abb40b22f49859$var$ERR_STREAM_DESTROYED = $f1abb40b22f49859$require$_require$codes.ERR_STREAM_DESTROYED, $f1abb40b22f49859$var$ERR_STREAM_NULL_VALUES = $f1abb40b22f49859$require$_require$codes.ERR_STREAM_NULL_VALUES, $f1abb40b22f49859$var$ERR_STREAM_WRITE_AFTER_END = $f1abb40b22f49859$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $f1abb40b22f49859$var$ERR_UNKNOWN_ENCODING = $f1abb40b22f49859$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $f1abb40b22f49859$var$errorOrDestroy = $lzWKR.errorOrDestroy;

(parcelRequire("lyUaN"))($f1abb40b22f49859$var$Writable, $8wk3O);
function $f1abb40b22f49859$var$nop() {}

function $f1abb40b22f49859$var$WritableState(options, stream, isDuplex) {
    $f1abb40b22f49859$var$Duplex = $f1abb40b22f49859$var$Duplex || (parcelRequire("aoI29"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $f1abb40b22f49859$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $f1abb40b22f49859$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $f1abb40b22f49859$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $f1abb40b22f49859$var$CorkedRequest(this);
}
$f1abb40b22f49859$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($f1abb40b22f49859$var$WritableState.prototype, 'buffer', {
            get: $f1abb40b22f49859$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $f1abb40b22f49859$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $f1abb40b22f49859$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($f1abb40b22f49859$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($f1abb40b22f49859$var$realHasInstance.call(this, object)) return true;
            if (this !== $f1abb40b22f49859$var$Writable) return false;
            return object && object._writableState instanceof $f1abb40b22f49859$var$WritableState;
        }
    });
} else $f1abb40b22f49859$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $f1abb40b22f49859$var$Writable(options) {
    $f1abb40b22f49859$var$Duplex = $f1abb40b22f49859$var$Duplex || (parcelRequire("aoI29"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $f1abb40b22f49859$var$Duplex;
    if (!isDuplex && !$f1abb40b22f49859$var$realHasInstance.call($f1abb40b22f49859$var$Writable, this)) return new $f1abb40b22f49859$var$Writable(options);
    this._writableState = new $f1abb40b22f49859$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $8wk3O.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$f1abb40b22f49859$var$Writable.prototype.pipe = function() {
    $f1abb40b22f49859$var$errorOrDestroy(this, new $f1abb40b22f49859$var$ERR_STREAM_CANNOT_PIPE());
};
function $f1abb40b22f49859$var$writeAfterEnd(stream, cb) {
    var er = new $f1abb40b22f49859$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $f1abb40b22f49859$var$errorOrDestroy(stream, er);
    $2fFJv.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $f1abb40b22f49859$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $f1abb40b22f49859$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== 'string' && !state.objectMode) er = new $f1abb40b22f49859$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer'
    ], chunk);
    if (er) {
        $f1abb40b22f49859$var$errorOrDestroy(stream, er);
        $2fFJv.nextTick(cb, er);
        return false;
    }
    return true;
}
$f1abb40b22f49859$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $f1abb40b22f49859$var$_isUint8Array(chunk);
    if (isBuf && !$f1abb40b22f49859$require$Buffer.isBuffer(chunk)) chunk = $f1abb40b22f49859$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $f1abb40b22f49859$var$nop;
    if (state.ending) $f1abb40b22f49859$var$writeAfterEnd(this, cb);
    else if (isBuf || $f1abb40b22f49859$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $f1abb40b22f49859$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$f1abb40b22f49859$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$f1abb40b22f49859$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $f1abb40b22f49859$var$clearBuffer(this, state);
    }
};
$f1abb40b22f49859$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new $f1abb40b22f49859$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($f1abb40b22f49859$var$Writable.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $f1abb40b22f49859$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $f1abb40b22f49859$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($f1abb40b22f49859$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $f1abb40b22f49859$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $f1abb40b22f49859$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $f1abb40b22f49859$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $f1abb40b22f49859$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $f1abb40b22f49859$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $f1abb40b22f49859$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $2fFJv.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $2fFJv.nextTick($f1abb40b22f49859$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $f1abb40b22f49859$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $f1abb40b22f49859$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $f1abb40b22f49859$var$finishMaybe(stream, state);
    }
}
function $f1abb40b22f49859$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $f1abb40b22f49859$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') throw new $f1abb40b22f49859$var$ERR_MULTIPLE_CALLBACK();
    $f1abb40b22f49859$var$onwriteStateUpdate(state);
    if (er) $f1abb40b22f49859$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $f1abb40b22f49859$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $f1abb40b22f49859$var$clearBuffer(stream, state);
        if (sync) $2fFJv.nextTick($f1abb40b22f49859$var$afterWrite, stream, state, finished, cb);
        else $f1abb40b22f49859$var$afterWrite(stream, state, finished, cb);
    }
}
function $f1abb40b22f49859$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $f1abb40b22f49859$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $f1abb40b22f49859$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $f1abb40b22f49859$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $f1abb40b22f49859$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $f1abb40b22f49859$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $f1abb40b22f49859$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $f1abb40b22f49859$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$f1abb40b22f49859$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $f1abb40b22f49859$var$ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
$f1abb40b22f49859$var$Writable.prototype._writev = null;
$f1abb40b22f49859$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $f1abb40b22f49859$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($f1abb40b22f49859$var$Writable.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $f1abb40b22f49859$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $f1abb40b22f49859$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $f1abb40b22f49859$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit('prefinish');
        $f1abb40b22f49859$var$finishMaybe(stream, state);
    });
}
function $f1abb40b22f49859$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $2fFJv.nextTick($f1abb40b22f49859$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $f1abb40b22f49859$var$finishMaybe(stream, state) {
    var need = $f1abb40b22f49859$var$needFinish(state);
    if (need) {
        $f1abb40b22f49859$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $f1abb40b22f49859$var$endWritable(stream, state, cb) {
    state.ending = true;
    $f1abb40b22f49859$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $2fFJv.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $f1abb40b22f49859$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($f1abb40b22f49859$var$Writable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$f1abb40b22f49859$var$Writable.prototype.destroy = $lzWKR.destroy;
$f1abb40b22f49859$var$Writable.prototype._undestroy = $lzWKR.undestroy;
$f1abb40b22f49859$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("6UWyy", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $50956520c48d9d9c$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $50956520c48d9d9c$var$deprecate(fn, msg) {
    if ($50956520c48d9d9c$var$config('noDeprecation')) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($50956520c48d9d9c$var$config('throwDeprecation')) throw new Error(msg);
            else if ($50956520c48d9d9c$var$config('traceDeprecation')) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $50956520c48d9d9c$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === 'true';
}

});



parcelRegister("iSptP", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $dbe108f5fb9524a7$export$63a7aa211a91ed69, (v) => $dbe108f5fb9524a7$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $dbe108f5fb9524a7$export$63a7aa211a91ed69;
'use strict';

var $ijh2q = parcelRequire("ijh2q");
var $dbe108f5fb9524a7$require$Buffer = $ijh2q.Buffer;
/*</replacement>*/ var $dbe108f5fb9524a7$var$isEncoding = $dbe108f5fb9524a7$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $dbe108f5fb9524a7$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $dbe108f5fb9524a7$var$normalizeEncoding(enc) {
    var nenc = $dbe108f5fb9524a7$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($dbe108f5fb9524a7$require$Buffer.isEncoding === $dbe108f5fb9524a7$var$isEncoding || !$dbe108f5fb9524a7$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$dbe108f5fb9524a7$export$63a7aa211a91ed69 = $dbe108f5fb9524a7$var$StringDecoder;
function $dbe108f5fb9524a7$var$StringDecoder(encoding) {
    this.encoding = $dbe108f5fb9524a7$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $dbe108f5fb9524a7$var$utf16Text;
            this.end = $dbe108f5fb9524a7$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $dbe108f5fb9524a7$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $dbe108f5fb9524a7$var$base64Text;
            this.end = $dbe108f5fb9524a7$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $dbe108f5fb9524a7$var$simpleWrite;
            this.end = $dbe108f5fb9524a7$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $dbe108f5fb9524a7$require$Buffer.allocUnsafe(nb);
}
$dbe108f5fb9524a7$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$dbe108f5fb9524a7$var$StringDecoder.prototype.end = $dbe108f5fb9524a7$var$utf8End;
// Returns only complete characters in a Buffer
$dbe108f5fb9524a7$var$StringDecoder.prototype.text = $dbe108f5fb9524a7$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$dbe108f5fb9524a7$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $dbe108f5fb9524a7$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $dbe108f5fb9524a7$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $dbe108f5fb9524a7$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $dbe108f5fb9524a7$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $dbe108f5fb9524a7$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $dbe108f5fb9524a7$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $dbe108f5fb9524a7$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $dbe108f5fb9524a7$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $dbe108f5fb9524a7$var$utf8Text(buf, i) {
    var total = $dbe108f5fb9524a7$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $dbe108f5fb9524a7$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $dbe108f5fb9524a7$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $dbe108f5fb9524a7$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $dbe108f5fb9524a7$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $dbe108f5fb9524a7$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $dbe108f5fb9524a7$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $dbe108f5fb9524a7$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});

parcelRegister("eryNp", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
'use strict';
var $a83e941260fb2f21$var$_Object$setPrototypeO;
function $a83e941260fb2f21$var$_defineProperty(obj, key, value) {
    key = $a83e941260fb2f21$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a83e941260fb2f21$var$_toPropertyKey(arg) {
    var key = $a83e941260fb2f21$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $a83e941260fb2f21$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $jV6VG = parcelRequire("jV6VG");
var $a83e941260fb2f21$var$kLastResolve = Symbol('lastResolve');
var $a83e941260fb2f21$var$kLastReject = Symbol('lastReject');
var $a83e941260fb2f21$var$kError = Symbol('error');
var $a83e941260fb2f21$var$kEnded = Symbol('ended');
var $a83e941260fb2f21$var$kLastPromise = Symbol('lastPromise');
var $a83e941260fb2f21$var$kHandlePromise = Symbol('handlePromise');
var $a83e941260fb2f21$var$kStream = Symbol('stream');
function $a83e941260fb2f21$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $a83e941260fb2f21$var$readAndResolve(iter) {
    var resolve = iter[$a83e941260fb2f21$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$a83e941260fb2f21$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$a83e941260fb2f21$var$kLastPromise] = null;
            iter[$a83e941260fb2f21$var$kLastResolve] = null;
            iter[$a83e941260fb2f21$var$kLastReject] = null;
            resolve($a83e941260fb2f21$var$createIterResult(data, false));
        }
    }
}
function $a83e941260fb2f21$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $2fFJv.nextTick($a83e941260fb2f21$var$readAndResolve, iter);
}
function $a83e941260fb2f21$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$a83e941260fb2f21$var$kEnded]) {
                resolve($a83e941260fb2f21$var$createIterResult(undefined, true));
                return;
            }
            iter[$a83e941260fb2f21$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $a83e941260fb2f21$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $a83e941260fb2f21$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($a83e941260fb2f21$var$_Object$setPrototypeO = {
    get stream () {
        return this[$a83e941260fb2f21$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$a83e941260fb2f21$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$a83e941260fb2f21$var$kEnded]) return Promise.resolve($a83e941260fb2f21$var$createIterResult(undefined, true));
        if (this[$a83e941260fb2f21$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $2fFJv.nextTick(function() {
                if (_this[$a83e941260fb2f21$var$kError]) reject(_this[$a83e941260fb2f21$var$kError]);
                else resolve($a83e941260fb2f21$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$a83e941260fb2f21$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($a83e941260fb2f21$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$a83e941260fb2f21$var$kStream].read();
            if (data !== null) return Promise.resolve($a83e941260fb2f21$var$createIterResult(data, false));
            promise = new Promise(this[$a83e941260fb2f21$var$kHandlePromise]);
        }
        this[$a83e941260fb2f21$var$kLastPromise] = promise;
        return promise;
    }
}, $a83e941260fb2f21$var$_defineProperty($a83e941260fb2f21$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $a83e941260fb2f21$var$_defineProperty($a83e941260fb2f21$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$a83e941260fb2f21$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($a83e941260fb2f21$var$createIterResult(undefined, true));
        });
    });
}), $a83e941260fb2f21$var$_Object$setPrototypeO), $a83e941260fb2f21$var$AsyncIteratorPrototype);
var $a83e941260fb2f21$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($a83e941260fb2f21$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $a83e941260fb2f21$var$_defineProperty(_Object$create, $a83e941260fb2f21$var$kStream, {
        value: stream,
        writable: true
    }), $a83e941260fb2f21$var$_defineProperty(_Object$create, $a83e941260fb2f21$var$kLastResolve, {
        value: null,
        writable: true
    }), $a83e941260fb2f21$var$_defineProperty(_Object$create, $a83e941260fb2f21$var$kLastReject, {
        value: null,
        writable: true
    }), $a83e941260fb2f21$var$_defineProperty(_Object$create, $a83e941260fb2f21$var$kError, {
        value: null,
        writable: true
    }), $a83e941260fb2f21$var$_defineProperty(_Object$create, $a83e941260fb2f21$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $a83e941260fb2f21$var$_defineProperty(_Object$create, $a83e941260fb2f21$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$a83e941260fb2f21$var$kStream].read();
            if (data) {
                iterator[$a83e941260fb2f21$var$kLastPromise] = null;
                iterator[$a83e941260fb2f21$var$kLastResolve] = null;
                iterator[$a83e941260fb2f21$var$kLastReject] = null;
                resolve($a83e941260fb2f21$var$createIterResult(data, false));
            } else {
                iterator[$a83e941260fb2f21$var$kLastResolve] = resolve;
                iterator[$a83e941260fb2f21$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$a83e941260fb2f21$var$kLastPromise] = null;
    $jV6VG(stream, function(err) {
        if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
            var reject = iterator[$a83e941260fb2f21$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$a83e941260fb2f21$var$kLastPromise] = null;
                iterator[$a83e941260fb2f21$var$kLastResolve] = null;
                iterator[$a83e941260fb2f21$var$kLastReject] = null;
                reject(err);
            }
            iterator[$a83e941260fb2f21$var$kError] = err;
            return;
        }
        var resolve = iterator[$a83e941260fb2f21$var$kLastResolve];
        if (resolve !== null) {
            iterator[$a83e941260fb2f21$var$kLastPromise] = null;
            iterator[$a83e941260fb2f21$var$kLastResolve] = null;
            iterator[$a83e941260fb2f21$var$kLastReject] = null;
            resolve($a83e941260fb2f21$var$createIterResult(undefined, true));
        }
        iterator[$a83e941260fb2f21$var$kEnded] = true;
    });
    stream.on('readable', $a83e941260fb2f21$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $a83e941260fb2f21$var$createReadableStreamAsyncIterator;

});
parcelRegister("jV6VG", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $e808b73f4846b37f$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("i8n8u")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $e808b73f4846b37f$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $e808b73f4846b37f$var$noop() {}
function $e808b73f4846b37f$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
function $e808b73f4846b37f$var$eos(stream, opts, callback) {
    if (typeof opts === 'function') return $e808b73f4846b37f$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $e808b73f4846b37f$var$once(callback || $e808b73f4846b37f$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $e808b73f4846b37f$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $e808b73f4846b37f$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on('finish', onfinish);
    };
    if ($e808b73f4846b37f$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (opts.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    return function() {
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
}
module.exports = $e808b73f4846b37f$var$eos;

});


parcelRegister("gljMO", function(module, exports) {
module.exports = function() {
    throw new Error('Readable.from is not available in the browser');
};

});


parcelRegister("lUyqo", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $ff3987f7b5428486$var$Transform;

var $i8n8u = parcelRequire("i8n8u");
var $ff3987f7b5428486$require$_require$codes = $i8n8u.codes;
var $ff3987f7b5428486$var$ERR_METHOD_NOT_IMPLEMENTED = $ff3987f7b5428486$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $ff3987f7b5428486$var$ERR_MULTIPLE_CALLBACK = $ff3987f7b5428486$require$_require$codes.ERR_MULTIPLE_CALLBACK, $ff3987f7b5428486$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $ff3987f7b5428486$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $ff3987f7b5428486$var$ERR_TRANSFORM_WITH_LENGTH_0 = $ff3987f7b5428486$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $aoI29 = parcelRequire("aoI29");

(parcelRequire("lyUaN"))($ff3987f7b5428486$var$Transform, $aoI29);
function $ff3987f7b5428486$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit('error', new $ff3987f7b5428486$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $ff3987f7b5428486$var$Transform(options) {
    if (!(this instanceof $ff3987f7b5428486$var$Transform)) return new $ff3987f7b5428486$var$Transform(options);
    $aoI29.call(this, options);
    this._transformState = {
        afterTransform: $ff3987f7b5428486$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $ff3987f7b5428486$var$prefinish);
}
function $ff3987f7b5428486$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function' && !this._readableState.destroyed) this._flush(function(er, data) {
        $ff3987f7b5428486$var$done(_this, er, data);
    });
    else $ff3987f7b5428486$var$done(this, null, null);
}
$ff3987f7b5428486$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $aoI29.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$ff3987f7b5428486$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $ff3987f7b5428486$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
$ff3987f7b5428486$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$ff3987f7b5428486$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$ff3987f7b5428486$var$Transform.prototype._destroy = function(err, cb) {
    $aoI29.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $ff3987f7b5428486$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $ff3987f7b5428486$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $ff3987f7b5428486$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("4kZwd", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $3288bffe507d45ca$var$PassThrough;

var $lUyqo = parcelRequire("lUyqo");

(parcelRequire("lyUaN"))($3288bffe507d45ca$var$PassThrough, $lUyqo);
function $3288bffe507d45ca$var$PassThrough(options) {
    if (!(this instanceof $3288bffe507d45ca$var$PassThrough)) return new $3288bffe507d45ca$var$PassThrough(options);
    $lUyqo.call(this, options);
}
$3288bffe507d45ca$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("8Ms18", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';
var $66488a15dea22053$var$eos;
function $66488a15dea22053$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $i8n8u = parcelRequire("i8n8u");
var $66488a15dea22053$require$_require$codes = $i8n8u.codes;
var $66488a15dea22053$var$ERR_MISSING_ARGS = $66488a15dea22053$require$_require$codes.ERR_MISSING_ARGS, $66488a15dea22053$var$ERR_STREAM_DESTROYED = $66488a15dea22053$require$_require$codes.ERR_STREAM_DESTROYED;
function $66488a15dea22053$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $66488a15dea22053$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}

function $66488a15dea22053$var$destroyer(stream, reading, writing, callback) {
    callback = $66488a15dea22053$var$once(callback);
    var closed = false;
    stream.on('close', function() {
        closed = true;
    });
    if ($66488a15dea22053$var$eos === undefined) $66488a15dea22053$var$eos = (parcelRequire("jV6VG"));
    $66488a15dea22053$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($66488a15dea22053$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === 'function') return stream.destroy();
        callback(err || new $66488a15dea22053$var$ERR_STREAM_DESTROYED('pipe'));
    };
}
function $66488a15dea22053$var$call(fn) {
    fn();
}
function $66488a15dea22053$var$pipe(from, to) {
    return from.pipe(to);
}
function $66488a15dea22053$var$popCallback(streams) {
    if (!streams.length) return $66488a15dea22053$var$noop;
    if (typeof streams[streams.length - 1] !== 'function') return $66488a15dea22053$var$noop;
    return streams.pop();
}
function $66488a15dea22053$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $66488a15dea22053$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $66488a15dea22053$var$ERR_MISSING_ARGS('streams');
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $66488a15dea22053$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($66488a15dea22053$var$call);
            if (reading) return;
            destroys.forEach($66488a15dea22053$var$call);
            callback(error);
        });
    });
    return streams.reduce($66488a15dea22053$var$pipe);
}
module.exports = $66488a15dea22053$var$pipeline;

});




parcelRegister("lqV5D", function(module, exports) {
var $f9a84f91b73961ae$var$exports = module.exports = function SHA(algorithm) {
    algorithm = algorithm.toLowerCase();
    var Algorithm = $f9a84f91b73961ae$var$exports[algorithm];
    if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)');
    return new Algorithm();
};

$f9a84f91b73961ae$var$exports.sha = (parcelRequire("aq7sD"));

$f9a84f91b73961ae$var$exports.sha1 = (parcelRequire("5hjhX"));

$f9a84f91b73961ae$var$exports.sha224 = (parcelRequire("7Rfie"));

$f9a84f91b73961ae$var$exports.sha256 = (parcelRequire("eF9el"));

$f9a84f91b73961ae$var$exports.sha384 = (parcelRequire("9B479"));

$f9a84f91b73961ae$var$exports.sha512 = (parcelRequire("bir8L"));

});
parcelRegister("aq7sD", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */ 
var $lyUaN = parcelRequire("lyUaN");

var $laXlc = parcelRequire("laXlc");

var $ijh2q = parcelRequire("ijh2q");
var $79621eabed5f8c00$require$Buffer = $ijh2q.Buffer;
var $79621eabed5f8c00$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $79621eabed5f8c00$var$W = new Array(80);
function $79621eabed5f8c00$var$Sha() {
    this.init();
    this._w = $79621eabed5f8c00$var$W;
    $laXlc.call(this, 64, 56);
}
$lyUaN($79621eabed5f8c00$var$Sha, $laXlc);
$79621eabed5f8c00$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $79621eabed5f8c00$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $79621eabed5f8c00$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $79621eabed5f8c00$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$79621eabed5f8c00$var$Sha.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $79621eabed5f8c00$var$rotl5(a) + $79621eabed5f8c00$var$ft(s, b, c, d) + e + W[j] + $79621eabed5f8c00$var$K[s] | 0;
        e = d;
        d = c;
        c = $79621eabed5f8c00$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$79621eabed5f8c00$var$Sha.prototype._hash = function() {
    var H = $79621eabed5f8c00$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $79621eabed5f8c00$var$Sha;

});
parcelRegister("laXlc", function(module, exports) {

var $ijh2q = parcelRequire("ijh2q");
var $f6a89006f13ce239$require$Buffer = $ijh2q.Buffer;
// prototype class for hash functions
function $f6a89006f13ce239$var$Hash(blockSize, finalSize) {
    this._block = $f6a89006f13ce239$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$f6a89006f13ce239$var$Hash.prototype.update = function(data, enc) {
    if (typeof data === 'string') {
        enc = enc || 'utf8';
        data = $f6a89006f13ce239$require$Buffer.from(data, enc);
    }
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$f6a89006f13ce239$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
    // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
    this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$f6a89006f13ce239$var$Hash.prototype._update = function() {
    throw new Error('_update must be implemented by subclass');
};
module.exports = $f6a89006f13ce239$var$Hash;

});


parcelRegister("5hjhX", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */ 
var $lyUaN = parcelRequire("lyUaN");

var $laXlc = parcelRequire("laXlc");

var $ijh2q = parcelRequire("ijh2q");
var $3d7d809e7a1ab643$require$Buffer = $ijh2q.Buffer;
var $3d7d809e7a1ab643$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $3d7d809e7a1ab643$var$W = new Array(80);
function $3d7d809e7a1ab643$var$Sha1() {
    this.init();
    this._w = $3d7d809e7a1ab643$var$W;
    $laXlc.call(this, 64, 56);
}
$lyUaN($3d7d809e7a1ab643$var$Sha1, $laXlc);
$3d7d809e7a1ab643$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $3d7d809e7a1ab643$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $3d7d809e7a1ab643$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $3d7d809e7a1ab643$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $3d7d809e7a1ab643$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$3d7d809e7a1ab643$var$Sha1.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = $3d7d809e7a1ab643$var$rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $3d7d809e7a1ab643$var$rotl5(a) + $3d7d809e7a1ab643$var$ft(s, b, c, d) + e + W[j] + $3d7d809e7a1ab643$var$K[s] | 0;
        e = d;
        d = c;
        c = $3d7d809e7a1ab643$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$3d7d809e7a1ab643$var$Sha1.prototype._hash = function() {
    var H = $3d7d809e7a1ab643$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $3d7d809e7a1ab643$var$Sha1;

});

parcelRegister("7Rfie", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $lyUaN = parcelRequire("lyUaN");

var $eF9el = parcelRequire("eF9el");

var $laXlc = parcelRequire("laXlc");

var $ijh2q = parcelRequire("ijh2q");
var $5b895883d67b9370$require$Buffer = $ijh2q.Buffer;
var $5b895883d67b9370$var$W = new Array(64);
function $5b895883d67b9370$var$Sha224() {
    this.init();
    this._w = $5b895883d67b9370$var$W // new Array(64)
    ;
    $laXlc.call(this, 64, 56);
}
$lyUaN($5b895883d67b9370$var$Sha224, $eF9el);
$5b895883d67b9370$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$5b895883d67b9370$var$Sha224.prototype._hash = function() {
    var H = $5b895883d67b9370$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $5b895883d67b9370$var$Sha224;

});
parcelRegister("eF9el", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $lyUaN = parcelRequire("lyUaN");

var $laXlc = parcelRequire("laXlc");

var $ijh2q = parcelRequire("ijh2q");
var $aacc0e009da62399$require$Buffer = $ijh2q.Buffer;
var $aacc0e009da62399$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $aacc0e009da62399$var$W = new Array(64);
function $aacc0e009da62399$var$Sha256() {
    this.init();
    this._w = $aacc0e009da62399$var$W // new Array(64)
    ;
    $laXlc.call(this, 64, 56);
}
$lyUaN($aacc0e009da62399$var$Sha256, $laXlc);
$aacc0e009da62399$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $aacc0e009da62399$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $aacc0e009da62399$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $aacc0e009da62399$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $aacc0e009da62399$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $aacc0e009da62399$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $aacc0e009da62399$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$aacc0e009da62399$var$Sha256.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)W[i] = $aacc0e009da62399$var$gamma1(W[i - 2]) + W[i - 7] + $aacc0e009da62399$var$gamma0(W[i - 15]) + W[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $aacc0e009da62399$var$sigma1(e) + $aacc0e009da62399$var$ch(e, f, g) + $aacc0e009da62399$var$K[j] + W[j] | 0;
        var T2 = $aacc0e009da62399$var$sigma0(a) + $aacc0e009da62399$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$aacc0e009da62399$var$Sha256.prototype._hash = function() {
    var H = $aacc0e009da62399$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $aacc0e009da62399$var$Sha256;

});


parcelRegister("9B479", function(module, exports) {

var $lyUaN = parcelRequire("lyUaN");

var $bir8L = parcelRequire("bir8L");

var $laXlc = parcelRequire("laXlc");

var $ijh2q = parcelRequire("ijh2q");
var $6fcac2cb2d39f17a$require$Buffer = $ijh2q.Buffer;
var $6fcac2cb2d39f17a$var$W = new Array(160);
function $6fcac2cb2d39f17a$var$Sha384() {
    this.init();
    this._w = $6fcac2cb2d39f17a$var$W;
    $laXlc.call(this, 128, 112);
}
$lyUaN($6fcac2cb2d39f17a$var$Sha384, $bir8L);
$6fcac2cb2d39f17a$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$6fcac2cb2d39f17a$var$Sha384.prototype._hash = function() {
    var H = $6fcac2cb2d39f17a$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $6fcac2cb2d39f17a$var$Sha384;

});
parcelRegister("bir8L", function(module, exports) {

var $lyUaN = parcelRequire("lyUaN");

var $laXlc = parcelRequire("laXlc");

var $ijh2q = parcelRequire("ijh2q");
var $83966da3ee4e453b$require$Buffer = $ijh2q.Buffer;
var $83966da3ee4e453b$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $83966da3ee4e453b$var$W = new Array(160);
function $83966da3ee4e453b$var$Sha512() {
    this.init();
    this._w = $83966da3ee4e453b$var$W;
    $laXlc.call(this, 128, 112);
}
$lyUaN($83966da3ee4e453b$var$Sha512, $laXlc);
$83966da3ee4e453b$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $83966da3ee4e453b$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $83966da3ee4e453b$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $83966da3ee4e453b$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $83966da3ee4e453b$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $83966da3ee4e453b$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $83966da3ee4e453b$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $83966da3ee4e453b$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $83966da3ee4e453b$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $83966da3ee4e453b$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$83966da3ee4e453b$var$Sha512.prototype._update = function(M) {
    var W = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        W[i] = M.readInt32BE(i * 4);
        W[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = W[i - 30];
        var xl = W[i - 30 + 1];
        var gamma0 = $83966da3ee4e453b$var$Gamma0(xh, xl);
        var gamma0l = $83966da3ee4e453b$var$Gamma0l(xl, xh);
        xh = W[i - 4];
        xl = W[i - 4 + 1];
        var gamma1 = $83966da3ee4e453b$var$Gamma1(xh, xl);
        var gamma1l = $83966da3ee4e453b$var$Gamma1l(xl, xh);
        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
        var Wi7h = W[i - 14];
        var Wi7l = W[i - 14 + 1];
        var Wi16h = W[i - 32];
        var Wi16l = W[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $83966da3ee4e453b$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $83966da3ee4e453b$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $83966da3ee4e453b$var$getCarry(Wil, Wi16l) | 0;
        W[i] = Wih;
        W[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = W[j];
        Wil = W[j + 1];
        var majh = $83966da3ee4e453b$var$maj(ah, bh, ch);
        var majl = $83966da3ee4e453b$var$maj(al, bl, cl);
        var sigma0h = $83966da3ee4e453b$var$sigma0(ah, al);
        var sigma0l = $83966da3ee4e453b$var$sigma0(al, ah);
        var sigma1h = $83966da3ee4e453b$var$sigma1(eh, el);
        var sigma1l = $83966da3ee4e453b$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + W[j]
        var Kih = $83966da3ee4e453b$var$K[j];
        var Kil = $83966da3ee4e453b$var$K[j + 1];
        var chh = $83966da3ee4e453b$var$Ch(eh, fh, gh);
        var chl = $83966da3ee4e453b$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $83966da3ee4e453b$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $83966da3ee4e453b$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $83966da3ee4e453b$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $83966da3ee4e453b$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $83966da3ee4e453b$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $83966da3ee4e453b$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $83966da3ee4e453b$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $83966da3ee4e453b$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $83966da3ee4e453b$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $83966da3ee4e453b$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $83966da3ee4e453b$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $83966da3ee4e453b$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $83966da3ee4e453b$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $83966da3ee4e453b$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $83966da3ee4e453b$var$getCarry(this._hl, hl) | 0;
};
$83966da3ee4e453b$var$Sha512.prototype._hash = function() {
    var H = $83966da3ee4e453b$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $83966da3ee4e453b$var$Sha512;

});



parcelRegister("7hBrF", function(module, exports) {

var $ijh2q = parcelRequire("ijh2q");
var $54d72ac3f9f3d584$require$Buffer = $ijh2q.Buffer;

var $anz8L = parcelRequire("anz8L");
var $54d72ac3f9f3d584$require$Transform = $anz8L.Transform;

var $iSptP = parcelRequire("iSptP");
var $54d72ac3f9f3d584$require$StringDecoder = $iSptP.StringDecoder;

var $lyUaN = parcelRequire("lyUaN");
function $54d72ac3f9f3d584$var$CipherBase(hashMode) {
    $54d72ac3f9f3d584$require$Transform.call(this);
    this.hashMode = typeof hashMode === 'string';
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this.final = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$lyUaN($54d72ac3f9f3d584$var$CipherBase, $54d72ac3f9f3d584$require$Transform);
$54d72ac3f9f3d584$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    if (typeof data === 'string') data = $54d72ac3f9f3d584$require$Buffer.from(data, inputEnc);
    var outData = this._update(data);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$54d72ac3f9f3d584$var$CipherBase.prototype.setAutoPadding = function() {};
$54d72ac3f9f3d584$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error('trying to get auth tag in unsupported state');
};
$54d72ac3f9f3d584$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error('trying to set auth tag in unsupported state');
};
$54d72ac3f9f3d584$var$CipherBase.prototype.setAAD = function() {
    throw new Error('trying to set aad in unsupported state');
};
$54d72ac3f9f3d584$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$54d72ac3f9f3d584$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$54d72ac3f9f3d584$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $54d72ac3f9f3d584$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$54d72ac3f9f3d584$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $54d72ac3f9f3d584$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error('can\'t switch encodings');
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $54d72ac3f9f3d584$var$CipherBase;

});


parcelRegister("jPoqK", function(module, exports) {
'use strict';

var $lyUaN = parcelRequire("lyUaN");

var $lYCTE = parcelRequire("lYCTE");

var $7hBrF = parcelRequire("7hBrF");

var $ijh2q = parcelRequire("ijh2q");
var $e6f5bb1bc44e45c9$require$Buffer = $ijh2q.Buffer;

var $6Kk1A = parcelRequire("6Kk1A");

var $bGrC1 = parcelRequire("bGrC1");

var $lqV5D = parcelRequire("lqV5D");
var $e6f5bb1bc44e45c9$var$ZEROS = $e6f5bb1bc44e45c9$require$Buffer.alloc(128);
function $e6f5bb1bc44e45c9$var$Hmac(alg, key) {
    $7hBrF.call(this, 'digest');
    if (typeof key === 'string') key = $e6f5bb1bc44e45c9$require$Buffer.from(key);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === 'rmd160' ? new $bGrC1() : $lqV5D(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $e6f5bb1bc44e45c9$require$Buffer.concat([
        key,
        $e6f5bb1bc44e45c9$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $e6f5bb1bc44e45c9$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $e6f5bb1bc44e45c9$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === 'rmd160' ? new $bGrC1() : $lqV5D(alg);
    this._hash.update(ipad);
}
$lyUaN($e6f5bb1bc44e45c9$var$Hmac, $7hBrF);
$e6f5bb1bc44e45c9$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$e6f5bb1bc44e45c9$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === 'rmd160' ? new $bGrC1() : $lqV5D(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $e6f5bb1bc44e45c9$var$Hmac('rmd160', key);
    if (alg === 'md5') return new $lYCTE($6Kk1A, key);
    return new $e6f5bb1bc44e45c9$var$Hmac(alg, key);
};

});
parcelRegister("lYCTE", function(module, exports) {
'use strict';

var $lyUaN = parcelRequire("lyUaN");

var $ijh2q = parcelRequire("ijh2q");
var $fffd5f9b09d9e4a8$require$Buffer = $ijh2q.Buffer;

var $7hBrF = parcelRequire("7hBrF");
var $fffd5f9b09d9e4a8$var$ZEROS = $fffd5f9b09d9e4a8$require$Buffer.alloc(128);
var $fffd5f9b09d9e4a8$var$blocksize = 64;
function $fffd5f9b09d9e4a8$var$Hmac(alg, key) {
    $7hBrF.call(this, 'digest');
    if (typeof key === 'string') key = $fffd5f9b09d9e4a8$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $fffd5f9b09d9e4a8$var$blocksize) key = alg(key);
    else if (key.length < $fffd5f9b09d9e4a8$var$blocksize) key = $fffd5f9b09d9e4a8$require$Buffer.concat([
        key,
        $fffd5f9b09d9e4a8$var$ZEROS
    ], $fffd5f9b09d9e4a8$var$blocksize);
    var ipad = this._ipad = $fffd5f9b09d9e4a8$require$Buffer.allocUnsafe($fffd5f9b09d9e4a8$var$blocksize);
    var opad = this._opad = $fffd5f9b09d9e4a8$require$Buffer.allocUnsafe($fffd5f9b09d9e4a8$var$blocksize);
    for(var i = 0; i < $fffd5f9b09d9e4a8$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$lyUaN($fffd5f9b09d9e4a8$var$Hmac, $7hBrF);
$fffd5f9b09d9e4a8$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$fffd5f9b09d9e4a8$var$Hmac.prototype._final = function() {
    var h = this._alg($fffd5f9b09d9e4a8$require$Buffer.concat(this._hash));
    return this._alg($fffd5f9b09d9e4a8$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $fffd5f9b09d9e4a8$var$Hmac;

});


parcelRegister("61Iwu", function(module, exports) {

module.exports = (parcelRequire("5x0OM"));

});
parcelRegister("5x0OM", function(module, exports) {
module.exports = JSON.parse("{\"sha224WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"RSA-SHA224\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"sha256WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"RSA-SHA256\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"sha384WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"RSA-SHA384\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"sha512WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA512\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA1\":{\"sign\":\"rsa\",\"hash\":\"sha1\",\"id\":\"3021300906052b0e03021a05000414\"},\"ecdsa-with-SHA1\":{\"sign\":\"ecdsa\",\"hash\":\"sha1\",\"id\":\"\"},\"sha256\":{\"sign\":\"ecdsa\",\"hash\":\"sha256\",\"id\":\"\"},\"sha224\":{\"sign\":\"ecdsa\",\"hash\":\"sha224\",\"id\":\"\"},\"sha384\":{\"sign\":\"ecdsa\",\"hash\":\"sha384\",\"id\":\"\"},\"sha512\":{\"sign\":\"ecdsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-SHA1\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-WITH-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-WITH-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-WITH-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-WITH-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-RIPEMD160\":{\"sign\":\"dsa\",\"hash\":\"rmd160\",\"id\":\"\"},\"ripemd160WithRSA\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"RSA-RIPEMD160\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"md5WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"},\"RSA-MD5\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"}}");

});


parcelRegister("8bTm7", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", () => $5f6a4a4c3eb5e5e3$export$448fa22aedc9dbca, (v) => $5f6a4a4c3eb5e5e3$export$448fa22aedc9dbca = v);
$parcel$export(module.exports, "pbkdf2Sync", () => $5f6a4a4c3eb5e5e3$export$b80c7ba289c8fa56, (v) => $5f6a4a4c3eb5e5e3$export$b80c7ba289c8fa56 = v);
var $5f6a4a4c3eb5e5e3$export$448fa22aedc9dbca;
var $5f6a4a4c3eb5e5e3$export$b80c7ba289c8fa56;

$5f6a4a4c3eb5e5e3$export$448fa22aedc9dbca = (parcelRequire("fkARo"));

$5f6a4a4c3eb5e5e3$export$b80c7ba289c8fa56 = (parcelRequire("fVtzD"));

});
parcelRegister("fkARo", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");

var $jS82b = parcelRequire("jS82b");

var $lniV2 = parcelRequire("lniV2");

var $fVtzD = parcelRequire("fVtzD");

var $ijh2q = parcelRequire("ijh2q");
var $b29550e988d9fb77$require$Buffer = $ijh2q.Buffer;
var $b29550e988d9fb77$var$ZERO_BUF;
var $b29550e988d9fb77$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $b29550e988d9fb77$var$toBrowser = {
    'sha': 'SHA-1',
    'sha-1': 'SHA-1',
    'sha1': 'SHA-1',
    'sha256': 'SHA-256',
    'sha-256': 'SHA-256',
    'sha384': 'SHA-384',
    'sha-384': 'SHA-384',
    'sha-512': 'SHA-512',
    'sha512': 'SHA-512'
};
var $b29550e988d9fb77$var$checks = [];
function $b29550e988d9fb77$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$b29550e988d9fb77$var$subtle || !$b29550e988d9fb77$var$subtle.importKey || !$b29550e988d9fb77$var$subtle.deriveBits) return Promise.resolve(false);
    if ($b29550e988d9fb77$var$checks[algo] !== undefined) return $b29550e988d9fb77$var$checks[algo];
    $b29550e988d9fb77$var$ZERO_BUF = $b29550e988d9fb77$var$ZERO_BUF || $b29550e988d9fb77$require$Buffer.alloc(8);
    var prom = $b29550e988d9fb77$var$browserPbkdf2($b29550e988d9fb77$var$ZERO_BUF, $b29550e988d9fb77$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }).catch(function() {
        return false;
    });
    $b29550e988d9fb77$var$checks[algo] = prom;
    return prom;
}
function $b29550e988d9fb77$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $b29550e988d9fb77$var$subtle.importKey('raw', password, {
        name: 'PBKDF2'
    }, false, [
        'deriveBits'
    ]).then(function(key) {
        return $b29550e988d9fb77$var$subtle.deriveBits({
            name: 'PBKDF2',
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $b29550e988d9fb77$require$Buffer.from(res);
    });
}
function $b29550e988d9fb77$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $2fFJv.nextTick(function() {
            callback(null, out);
        });
    }, function(e) {
        $2fFJv.nextTick(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (!$b29550e988d9fb77$require$Buffer.isBuffer(password)) password = $b29550e988d9fb77$require$Buffer.from(password, $lniV2);
    if (!$b29550e988d9fb77$require$Buffer.isBuffer(salt)) salt = $b29550e988d9fb77$require$Buffer.from(salt, $lniV2);
    $jS82b(iterations, keylen);
    if (typeof digest === 'function') {
        callback = digest;
        digest = undefined;
    }
    if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2');
    digest = digest || 'sha1';
    var algo = $b29550e988d9fb77$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== 'function') return $2fFJv.nextTick(function() {
        var out;
        try {
            out = $fVtzD(password, salt, iterations, keylen, digest);
        } catch (e) {
            return callback(e);
        }
        callback(null, out);
    });
    $b29550e988d9fb77$var$resolvePromise($b29550e988d9fb77$var$checkNative(algo).then(function(resp) {
        if (resp) return $b29550e988d9fb77$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        else return $fVtzD(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRegister("jS82b", function(module, exports) {
var $e7794aead791fe5d$var$MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs
;
module.exports = function(iterations, keylen) {
    if (typeof iterations !== 'number') throw new TypeError('Iterations not a number');
    if (iterations < 0) throw new TypeError('Bad iterations');
    if (typeof keylen !== 'number') throw new TypeError('Key length not a number');
    if (keylen < 0 || keylen > $e7794aead791fe5d$var$MAX_ALLOC || keylen !== keylen) throw new TypeError('Bad key length');
};

});

parcelRegister("lniV2", function(module, exports) {
var $f8fa6bde347fdcff$var$defaultEncoding;
var $f8fa6bde347fdcff$var$pVersionMajor;
$f8fa6bde347fdcff$var$defaultEncoding = 'utf-8';
module.exports = $f8fa6bde347fdcff$var$defaultEncoding;

});

parcelRegister("fVtzD", function(module, exports) {

var $6Kk1A = parcelRequire("6Kk1A");

var $bGrC1 = parcelRequire("bGrC1");

var $lqV5D = parcelRequire("lqV5D");

var $jS82b = parcelRequire("jS82b");

var $lniV2 = parcelRequire("lniV2");

var $ijh2q = parcelRequire("ijh2q");
var $b9831e9db81e0e59$require$Buffer = $ijh2q.Buffer;
var $b9831e9db81e0e59$var$ZEROS = $b9831e9db81e0e59$require$Buffer.alloc(128);
var $b9831e9db81e0e59$var$sizes = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
};
function $b9831e9db81e0e59$var$Hmac(alg, key, saltLen) {
    var hash = $b9831e9db81e0e59$var$getDigest(alg);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $b9831e9db81e0e59$require$Buffer.concat([
        key,
        $b9831e9db81e0e59$var$ZEROS
    ], blocksize);
    var ipad = $b9831e9db81e0e59$require$Buffer.allocUnsafe(blocksize + $b9831e9db81e0e59$var$sizes[alg]);
    var opad = $b9831e9db81e0e59$require$Buffer.allocUnsafe(blocksize + $b9831e9db81e0e59$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $b9831e9db81e0e59$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $b9831e9db81e0e59$var$sizes[alg];
}
$b9831e9db81e0e59$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $b9831e9db81e0e59$var$getDigest(alg) {
    function shaFunc(data) {
        return $lqV5D(alg).update(data).digest();
    }
    if (alg === 'rmd160' || alg === 'ripemd160') return $bGrC1;
    if (alg === 'md5') return $6Kk1A;
    return shaFunc;
}
function $b9831e9db81e0e59$var$pbkdf2(password, salt, iterations, keylen, digest) {
    if (!$b9831e9db81e0e59$require$Buffer.isBuffer(password)) password = $b9831e9db81e0e59$require$Buffer.from(password, $lniV2);
    if (!$b9831e9db81e0e59$require$Buffer.isBuffer(salt)) salt = $b9831e9db81e0e59$require$Buffer.from(salt, $lniV2);
    $jS82b(iterations, keylen);
    digest = digest || 'sha1';
    var hmac = new $b9831e9db81e0e59$var$Hmac(digest, password, salt.length);
    var DK = $b9831e9db81e0e59$require$Buffer.allocUnsafe(keylen);
    var block1 = $b9831e9db81e0e59$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = $b9831e9db81e0e59$var$sizes[digest];
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $b9831e9db81e0e59$var$pbkdf2;

});



parcelRegister("9rGLx", function(module, exports) {

$parcel$export(module.exports, "createCipher", () => $6e07cf0dc2bcbbb7$export$bdd223f16383713e, (v) => $6e07cf0dc2bcbbb7$export$bdd223f16383713e = v);
$parcel$export(module.exports, "Cipher", () => $6e07cf0dc2bcbbb7$export$26e5786e8ac8e530, (v) => $6e07cf0dc2bcbbb7$export$26e5786e8ac8e530 = v);
$parcel$export(module.exports, "createCipheriv", () => $6e07cf0dc2bcbbb7$export$2f64596b8cbf08b4, (v) => $6e07cf0dc2bcbbb7$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "Cipheriv", () => $6e07cf0dc2bcbbb7$export$20533d26f07f1ee0, (v) => $6e07cf0dc2bcbbb7$export$20533d26f07f1ee0 = v);
$parcel$export(module.exports, "createDecipher", () => $6e07cf0dc2bcbbb7$export$12ada9414fbc594c, (v) => $6e07cf0dc2bcbbb7$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "Decipher", () => $6e07cf0dc2bcbbb7$export$2ce6d8d0e8b04e1a, (v) => $6e07cf0dc2bcbbb7$export$2ce6d8d0e8b04e1a = v);
$parcel$export(module.exports, "createDecipheriv", () => $6e07cf0dc2bcbbb7$export$36b6d6ef312eab39, (v) => $6e07cf0dc2bcbbb7$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "Decipheriv", () => $6e07cf0dc2bcbbb7$export$f5e7e39d57cd9700, (v) => $6e07cf0dc2bcbbb7$export$f5e7e39d57cd9700 = v);
$parcel$export(module.exports, "listCiphers", () => $6e07cf0dc2bcbbb7$export$dedd8dc3dc62b370, (v) => $6e07cf0dc2bcbbb7$export$dedd8dc3dc62b370 = v);
$parcel$export(module.exports, "getCiphers", () => $6e07cf0dc2bcbbb7$export$58a258485f1e49f6, (v) => $6e07cf0dc2bcbbb7$export$58a258485f1e49f6 = v);
var $6e07cf0dc2bcbbb7$export$bdd223f16383713e;
var $6e07cf0dc2bcbbb7$export$26e5786e8ac8e530;
var $6e07cf0dc2bcbbb7$export$2f64596b8cbf08b4;
var $6e07cf0dc2bcbbb7$export$20533d26f07f1ee0;
var $6e07cf0dc2bcbbb7$export$12ada9414fbc594c;
var $6e07cf0dc2bcbbb7$export$2ce6d8d0e8b04e1a;
var $6e07cf0dc2bcbbb7$export$36b6d6ef312eab39;
var $6e07cf0dc2bcbbb7$export$f5e7e39d57cd9700;
var $6e07cf0dc2bcbbb7$export$dedd8dc3dc62b370;
var $6e07cf0dc2bcbbb7$export$58a258485f1e49f6;

var $d9sFZ = parcelRequire("d9sFZ");

var $FyTgm = parcelRequire("FyTgm");

var $A6QqV = parcelRequire("A6QqV");

var $9Xue6 = parcelRequire("9Xue6");

var $2z1oX = parcelRequire("2z1oX");
function $6e07cf0dc2bcbbb7$var$createCipher(suite, password) {
    var keyLen, ivLen;
    suite = suite.toLowerCase();
    if ($2z1oX[suite]) {
        keyLen = $2z1oX[suite].key;
        ivLen = $2z1oX[suite].iv;
    } else if ($9Xue6[suite]) {
        keyLen = $9Xue6[suite].key * 8;
        ivLen = $9Xue6[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $d9sFZ(password, false, keyLen, ivLen);
    return $6e07cf0dc2bcbbb7$var$createCipheriv(suite, keys.key, keys.iv);
}
function $6e07cf0dc2bcbbb7$var$createDecipher(suite, password) {
    var keyLen, ivLen;
    suite = suite.toLowerCase();
    if ($2z1oX[suite]) {
        keyLen = $2z1oX[suite].key;
        ivLen = $2z1oX[suite].iv;
    } else if ($9Xue6[suite]) {
        keyLen = $9Xue6[suite].key * 8;
        ivLen = $9Xue6[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $d9sFZ(password, false, keyLen, ivLen);
    return $6e07cf0dc2bcbbb7$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $6e07cf0dc2bcbbb7$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($2z1oX[suite]) return $FyTgm.createCipheriv(suite, key, iv);
    else if ($9Xue6[suite]) return new $A6QqV({
        key: key,
        iv: iv,
        mode: suite
    });
    else throw new TypeError('invalid suite type');
}
function $6e07cf0dc2bcbbb7$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($2z1oX[suite]) return $FyTgm.createDecipheriv(suite, key, iv);
    else if ($9Xue6[suite]) return new $A6QqV({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    else throw new TypeError('invalid suite type');
}
$6e07cf0dc2bcbbb7$export$bdd223f16383713e = $6e07cf0dc2bcbbb7$export$26e5786e8ac8e530 = $6e07cf0dc2bcbbb7$var$createCipher;
$6e07cf0dc2bcbbb7$export$2f64596b8cbf08b4 = $6e07cf0dc2bcbbb7$export$20533d26f07f1ee0 = $6e07cf0dc2bcbbb7$var$createCipheriv;
$6e07cf0dc2bcbbb7$export$12ada9414fbc594c = $6e07cf0dc2bcbbb7$export$2ce6d8d0e8b04e1a = $6e07cf0dc2bcbbb7$var$createDecipher;
$6e07cf0dc2bcbbb7$export$36b6d6ef312eab39 = $6e07cf0dc2bcbbb7$export$f5e7e39d57cd9700 = $6e07cf0dc2bcbbb7$var$createDecipheriv;
function $6e07cf0dc2bcbbb7$var$getCiphers() {
    return Object.keys($9Xue6).concat($FyTgm.getCiphers());
}
$6e07cf0dc2bcbbb7$export$dedd8dc3dc62b370 = $6e07cf0dc2bcbbb7$export$58a258485f1e49f6 = $6e07cf0dc2bcbbb7$var$getCiphers;

});
parcelRegister("d9sFZ", function(module, exports) {

var $ijh2q = parcelRequire("ijh2q");
var $99325c1fe2a705db$require$Buffer = $ijh2q.Buffer;

var $fVE4x = parcelRequire("fVE4x");
/* eslint-disable camelcase */ function $99325c1fe2a705db$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$99325c1fe2a705db$require$Buffer.isBuffer(password)) password = $99325c1fe2a705db$require$Buffer.from(password, 'binary');
    if (salt) {
        if (!$99325c1fe2a705db$require$Buffer.isBuffer(salt)) salt = $99325c1fe2a705db$require$Buffer.from(salt, 'binary');
        if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length');
    }
    var keyLen = keyBits / 8;
    var key = $99325c1fe2a705db$require$Buffer.alloc(keyLen);
    var iv = $99325c1fe2a705db$require$Buffer.alloc(ivLen || 0);
    var tmp = $99325c1fe2a705db$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $fVE4x();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $99325c1fe2a705db$var$EVP_BytesToKey;

});
parcelRegister("fVE4x", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $b98b436904fea768$require$Buffer = $aul3P.Buffer;
'use strict';

var $lyUaN = parcelRequire("lyUaN");

var $2UmI8 = parcelRequire("2UmI8");
var $b98b436904fea768$var$ARRAY16 = new Array(16);
function $b98b436904fea768$var$MD5() {
    $2UmI8.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$lyUaN($b98b436904fea768$var$MD5, $2UmI8);
$b98b436904fea768$var$MD5.prototype._update = function() {
    var M = $b98b436904fea768$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $b98b436904fea768$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $b98b436904fea768$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $b98b436904fea768$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $b98b436904fea768$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $b98b436904fea768$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $b98b436904fea768$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $b98b436904fea768$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $b98b436904fea768$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $b98b436904fea768$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $b98b436904fea768$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $b98b436904fea768$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $b98b436904fea768$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $b98b436904fea768$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $b98b436904fea768$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $b98b436904fea768$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $b98b436904fea768$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $b98b436904fea768$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $b98b436904fea768$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $b98b436904fea768$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $b98b436904fea768$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $b98b436904fea768$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $b98b436904fea768$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $b98b436904fea768$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $b98b436904fea768$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $b98b436904fea768$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $b98b436904fea768$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $b98b436904fea768$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $b98b436904fea768$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $b98b436904fea768$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $b98b436904fea768$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $b98b436904fea768$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $b98b436904fea768$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $b98b436904fea768$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $b98b436904fea768$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $b98b436904fea768$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $b98b436904fea768$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $b98b436904fea768$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $b98b436904fea768$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $b98b436904fea768$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $b98b436904fea768$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $b98b436904fea768$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $b98b436904fea768$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $b98b436904fea768$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $b98b436904fea768$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $b98b436904fea768$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $b98b436904fea768$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $b98b436904fea768$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $b98b436904fea768$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $b98b436904fea768$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $b98b436904fea768$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $b98b436904fea768$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $b98b436904fea768$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $b98b436904fea768$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $b98b436904fea768$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $b98b436904fea768$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $b98b436904fea768$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $b98b436904fea768$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $b98b436904fea768$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $b98b436904fea768$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $b98b436904fea768$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $b98b436904fea768$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $b98b436904fea768$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $b98b436904fea768$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $b98b436904fea768$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$b98b436904fea768$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = new $b98b436904fea768$require$Buffer(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $b98b436904fea768$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $b98b436904fea768$var$fnF(a, b, c, d, m, k, s) {
    return $b98b436904fea768$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $b98b436904fea768$var$fnG(a, b, c, d, m, k, s) {
    return $b98b436904fea768$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $b98b436904fea768$var$fnH(a, b, c, d, m, k, s) {
    return $b98b436904fea768$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $b98b436904fea768$var$fnI(a, b, c, d, m, k, s) {
    return $b98b436904fea768$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $b98b436904fea768$var$MD5;

});


parcelRegister("FyTgm", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $07cee4f1b56d3371$export$2f64596b8cbf08b4, (v) => $07cee4f1b56d3371$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createDecipheriv", () => $07cee4f1b56d3371$export$36b6d6ef312eab39, (v) => $07cee4f1b56d3371$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "getCiphers", () => $07cee4f1b56d3371$export$58a258485f1e49f6, (v) => $07cee4f1b56d3371$export$58a258485f1e49f6 = v);
var $07cee4f1b56d3371$export$bdd223f16383713e;
var $07cee4f1b56d3371$export$26e5786e8ac8e530;
var $07cee4f1b56d3371$export$2f64596b8cbf08b4;
var $07cee4f1b56d3371$export$20533d26f07f1ee0;
var $07cee4f1b56d3371$export$12ada9414fbc594c;
var $07cee4f1b56d3371$export$2ce6d8d0e8b04e1a;
var $07cee4f1b56d3371$export$36b6d6ef312eab39;
var $07cee4f1b56d3371$export$f5e7e39d57cd9700;
var $07cee4f1b56d3371$export$dedd8dc3dc62b370;
var $07cee4f1b56d3371$export$58a258485f1e49f6;

var $6VQvi = parcelRequire("6VQvi");

var $2o6Y4 = parcelRequire("2o6Y4");

var $bv6dQ = parcelRequire("bv6dQ");
function $07cee4f1b56d3371$var$getCiphers() {
    return Object.keys($bv6dQ);
}
$07cee4f1b56d3371$export$bdd223f16383713e = $07cee4f1b56d3371$export$26e5786e8ac8e530 = $6VQvi.createCipher;
$07cee4f1b56d3371$export$2f64596b8cbf08b4 = $07cee4f1b56d3371$export$20533d26f07f1ee0 = $6VQvi.createCipheriv;
$07cee4f1b56d3371$export$12ada9414fbc594c = $07cee4f1b56d3371$export$2ce6d8d0e8b04e1a = $2o6Y4.createDecipher;
$07cee4f1b56d3371$export$36b6d6ef312eab39 = $07cee4f1b56d3371$export$f5e7e39d57cd9700 = $2o6Y4.createDecipheriv;
$07cee4f1b56d3371$export$dedd8dc3dc62b370 = $07cee4f1b56d3371$export$58a258485f1e49f6 = $07cee4f1b56d3371$var$getCiphers;

});
parcelRegister("6VQvi", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $50c0cb1d854268c2$export$2f64596b8cbf08b4, (v) => $50c0cb1d854268c2$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createCipher", () => $50c0cb1d854268c2$export$bdd223f16383713e, (v) => $50c0cb1d854268c2$export$bdd223f16383713e = v);
var $50c0cb1d854268c2$export$2f64596b8cbf08b4;
var $50c0cb1d854268c2$export$bdd223f16383713e;

var $2z1oX = parcelRequire("2z1oX");

var $jEzvF = parcelRequire("jEzvF");

var $ijh2q = parcelRequire("ijh2q");
var $50c0cb1d854268c2$require$Buffer = $ijh2q.Buffer;

var $96zpw = parcelRequire("96zpw");

var $7hBrF = parcelRequire("7hBrF");

var $hPkMt = parcelRequire("hPkMt");

var $d9sFZ = parcelRequire("d9sFZ");

var $lyUaN = parcelRequire("lyUaN");
function $50c0cb1d854268c2$var$Cipher(mode, key, iv) {
    $7hBrF.call(this);
    this._cache = new $50c0cb1d854268c2$var$Splitter();
    this._cipher = new $hPkMt.AES(key);
    this._prev = $50c0cb1d854268c2$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$lyUaN($50c0cb1d854268c2$var$Cipher, $7hBrF);
$50c0cb1d854268c2$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $50c0cb1d854268c2$require$Buffer.concat(out);
};
var $50c0cb1d854268c2$var$PADDING = $50c0cb1d854268c2$require$Buffer.alloc(16, 0x10);
$50c0cb1d854268c2$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($50c0cb1d854268c2$var$PADDING)) {
        this._cipher.scrub();
        throw new Error('data not multiple of block length');
    }
};
$50c0cb1d854268c2$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $50c0cb1d854268c2$var$Splitter() {
    this.cache = $50c0cb1d854268c2$require$Buffer.allocUnsafe(0);
}
$50c0cb1d854268c2$var$Splitter.prototype.add = function(data) {
    this.cache = $50c0cb1d854268c2$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$50c0cb1d854268c2$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$50c0cb1d854268c2$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $50c0cb1d854268c2$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $50c0cb1d854268c2$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $50c0cb1d854268c2$var$createCipheriv(suite, password, iv) {
    var config = $2z1oX[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof password === 'string') password = $50c0cb1d854268c2$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (typeof iv === 'string') iv = $50c0cb1d854268c2$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (config.type === 'stream') return new $96zpw(config.module, password, iv);
    else if (config.type === 'auth') return new $jEzvF(config.module, password, iv);
    return new $50c0cb1d854268c2$var$Cipher(config.module, password, iv);
}
function $50c0cb1d854268c2$var$createCipher(suite, password) {
    var config = $2z1oX[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $d9sFZ(password, false, config.key, config.iv);
    return $50c0cb1d854268c2$var$createCipheriv(suite, keys.key, keys.iv);
}
$50c0cb1d854268c2$export$2f64596b8cbf08b4 = $50c0cb1d854268c2$var$createCipheriv;
$50c0cb1d854268c2$export$bdd223f16383713e = $50c0cb1d854268c2$var$createCipher;

});
parcelRegister("2z1oX", function(module, exports) {








var $1ddfeffa5f98a92e$var$modeModules = {
    ECB: (parcelRequire("hZIaM")),
    CBC: (parcelRequire("fmope")),
    CFB: (parcelRequire("lG0PJ")),
    CFB8: (parcelRequire("llTPt")),
    CFB1: (parcelRequire("efIgE")),
    OFB: (parcelRequire("1xe0H")),
    CTR: (parcelRequire("dJNe4")),
    GCM: (parcelRequire("dJNe4"))
};

var $bv6dQ = parcelRequire("bv6dQ");
for(var $1ddfeffa5f98a92e$var$key in $bv6dQ)$bv6dQ[$1ddfeffa5f98a92e$var$key].module = $1ddfeffa5f98a92e$var$modeModules[$bv6dQ[$1ddfeffa5f98a92e$var$key].mode];
module.exports = $bv6dQ;

});
parcelRegister("hZIaM", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $d19a65fdbdc127ec$export$5b0f6292f11d1d18, (v) => $d19a65fdbdc127ec$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $d19a65fdbdc127ec$export$e85a0c9a1067c5d3, (v) => $d19a65fdbdc127ec$export$e85a0c9a1067c5d3 = v);
var $d19a65fdbdc127ec$export$5b0f6292f11d1d18;
var $d19a65fdbdc127ec$export$e85a0c9a1067c5d3;
$d19a65fdbdc127ec$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$d19a65fdbdc127ec$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRegister("fmope", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b2ebd79d572bda0f$export$5b0f6292f11d1d18, (v) => $b2ebd79d572bda0f$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $b2ebd79d572bda0f$export$e85a0c9a1067c5d3, (v) => $b2ebd79d572bda0f$export$e85a0c9a1067c5d3 = v);
var $b2ebd79d572bda0f$export$5b0f6292f11d1d18;
var $b2ebd79d572bda0f$export$e85a0c9a1067c5d3;

var $4fAiV = parcelRequire("4fAiV");
$b2ebd79d572bda0f$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $4fAiV(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$b2ebd79d572bda0f$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $4fAiV(out, pad);
};

});
parcelRegister("4fAiV", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $3184b96a1696b3ca$require$Buffer = $aul3P.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $3184b96a1696b3ca$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRegister("lG0PJ", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $fc7e2ab8e9fb41d3$export$5b0f6292f11d1d18, (v) => $fc7e2ab8e9fb41d3$export$5b0f6292f11d1d18 = v);
var $fc7e2ab8e9fb41d3$export$5b0f6292f11d1d18;

var $ijh2q = parcelRequire("ijh2q");
var $fc7e2ab8e9fb41d3$require$Buffer = $ijh2q.Buffer;

var $4fAiV = parcelRequire("4fAiV");
function $fc7e2ab8e9fb41d3$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $4fAiV(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $fc7e2ab8e9fb41d3$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$fc7e2ab8e9fb41d3$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $fc7e2ab8e9fb41d3$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $fc7e2ab8e9fb41d3$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $fc7e2ab8e9fb41d3$require$Buffer.concat([
                out,
                $fc7e2ab8e9fb41d3$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $fc7e2ab8e9fb41d3$require$Buffer.concat([
                out,
                $fc7e2ab8e9fb41d3$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRegister("llTPt", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $f8b6dda5639be9f3$export$5b0f6292f11d1d18, (v) => $f8b6dda5639be9f3$export$5b0f6292f11d1d18 = v);
var $f8b6dda5639be9f3$export$5b0f6292f11d1d18;

var $ijh2q = parcelRequire("ijh2q");
var $f8b6dda5639be9f3$require$Buffer = $ijh2q.Buffer;
function $f8b6dda5639be9f3$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $f8b6dda5639be9f3$require$Buffer.concat([
        self._prev.slice(1),
        $f8b6dda5639be9f3$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$f8b6dda5639be9f3$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $f8b6dda5639be9f3$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $f8b6dda5639be9f3$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("efIgE", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $a604cdff2a21876e$export$5b0f6292f11d1d18, (v) => $a604cdff2a21876e$export$5b0f6292f11d1d18 = v);
var $a604cdff2a21876e$export$5b0f6292f11d1d18;

var $ijh2q = parcelRequire("ijh2q");
var $a604cdff2a21876e$require$Buffer = $ijh2q.Buffer;
function $a604cdff2a21876e$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $a604cdff2a21876e$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $a604cdff2a21876e$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $a604cdff2a21876e$require$Buffer.allocUnsafe(buffer.length);
    buffer = $a604cdff2a21876e$require$Buffer.concat([
        buffer,
        $a604cdff2a21876e$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$a604cdff2a21876e$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $a604cdff2a21876e$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $a604cdff2a21876e$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("1xe0H", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $11e3bdad54d46713$export$5b0f6292f11d1d18, (v) => $11e3bdad54d46713$export$5b0f6292f11d1d18 = v);
var $11e3bdad54d46713$export$5b0f6292f11d1d18;

var $aul3P = parcelRequire("aul3P");
var $11e3bdad54d46713$require$Buffer = $aul3P.Buffer;

var $4fAiV = parcelRequire("4fAiV");
function $11e3bdad54d46713$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$11e3bdad54d46713$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $11e3bdad54d46713$require$Buffer.concat([
        self._cache,
        $11e3bdad54d46713$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $4fAiV(chunk, pad);
};

});

parcelRegister("dJNe4", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $a005a98f556409fd$export$5b0f6292f11d1d18, (v) => $a005a98f556409fd$export$5b0f6292f11d1d18 = v);
var $a005a98f556409fd$export$5b0f6292f11d1d18;

var $4fAiV = parcelRequire("4fAiV");

var $ijh2q = parcelRequire("ijh2q");
var $a005a98f556409fd$require$Buffer = $ijh2q.Buffer;

var $lkgcL = parcelRequire("lkgcL");
function $a005a98f556409fd$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $lkgcL(self._prev);
    return out;
}
var $a005a98f556409fd$var$blockSize = 16;
$a005a98f556409fd$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $a005a98f556409fd$var$blockSize);
    var start = self._cache.length;
    self._cache = $a005a98f556409fd$require$Buffer.concat([
        self._cache,
        $a005a98f556409fd$require$Buffer.allocUnsafe(chunkNum * $a005a98f556409fd$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $a005a98f556409fd$var$getBlock(self);
        var offset = start + i * $a005a98f556409fd$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $4fAiV(chunk, pad);
};

});
parcelRegister("lkgcL", function(module, exports) {
function $f868092934fdc144$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $f868092934fdc144$var$incr32;

});


parcelRegister("bv6dQ", function(module, exports) {
module.exports = JSON.parse("{\"aes-128-ecb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-192-ecb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-256-ecb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-128-cbc\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-192-cbc\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-256-cbc\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes128\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes192\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes256\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-128-cfb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-192-cfb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-256-cfb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-128-cfb8\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-192-cfb8\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-256-cfb8\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-128-cfb1\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-192-cfb1\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-256-cfb1\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-128-ofb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-192-ofb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-256-ofb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-128-ctr\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-192-ctr\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-256-ctr\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-128-gcm\":{\"cipher\":\"AES\",\"key\":128,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-192-gcm\":{\"cipher\":\"AES\",\"key\":192,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-256-gcm\":{\"cipher\":\"AES\",\"key\":256,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"}}");

});


parcelRegister("jEzvF", function(module, exports) {

var $hPkMt = parcelRequire("hPkMt");

var $ijh2q = parcelRequire("ijh2q");
var $e4ed4c3b1c2c6a88$require$Buffer = $ijh2q.Buffer;

var $7hBrF = parcelRequire("7hBrF");

var $lyUaN = parcelRequire("lyUaN");

var $kWTRq = parcelRequire("kWTRq");

var $4fAiV = parcelRequire("4fAiV");

var $lkgcL = parcelRequire("lkgcL");
function $e4ed4c3b1c2c6a88$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $e4ed4c3b1c2c6a88$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $e4ed4c3b1c2c6a88$require$Buffer.concat([
            iv,
            $e4ed4c3b1c2c6a88$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $e4ed4c3b1c2c6a88$require$Buffer.concat([
            iv,
            $e4ed4c3b1c2c6a88$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $kWTRq(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($e4ed4c3b1c2c6a88$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($e4ed4c3b1c2c6a88$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $e4ed4c3b1c2c6a88$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $e4ed4c3b1c2c6a88$require$Buffer.from(self._finID);
    $lkgcL(out);
    return out;
}
function $e4ed4c3b1c2c6a88$var$StreamCipher(mode, key, iv, decrypt) {
    $7hBrF.call(this);
    var h = $e4ed4c3b1c2c6a88$require$Buffer.alloc(4, 0);
    this._cipher = new $hPkMt.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $kWTRq(ck);
    iv = $e4ed4c3b1c2c6a88$var$calcIv(this, iv, ck);
    this._prev = $e4ed4c3b1c2c6a88$require$Buffer.from(iv);
    this._cache = $e4ed4c3b1c2c6a88$require$Buffer.allocUnsafe(0);
    this._secCache = $e4ed4c3b1c2c6a88$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$lyUaN($e4ed4c3b1c2c6a88$var$StreamCipher, $7hBrF);
$e4ed4c3b1c2c6a88$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $e4ed4c3b1c2c6a88$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$e4ed4c3b1c2c6a88$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data');
    var tag = $4fAiV(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $e4ed4c3b1c2c6a88$var$xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data');
    this._authTag = tag;
    this._cipher.scrub();
};
$e4ed4c3b1c2c6a88$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$e4ed4c3b1c2c6a88$require$Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state');
    return this._authTag;
};
$e4ed4c3b1c2c6a88$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state');
    this._authTag = tag;
};
$e4ed4c3b1c2c6a88$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error('Attempting to set AAD in unsupported state');
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $e4ed4c3b1c2c6a88$var$StreamCipher;

});
parcelRegister("hPkMt", function(module, exports) {

$parcel$export(module.exports, "AES", () => $cfa751ba4428ce31$export$b80fbe1c3a2b92b5, (v) => $cfa751ba4428ce31$export$b80fbe1c3a2b92b5 = v);
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $cfa751ba4428ce31$export$b80fbe1c3a2b92b5;

var $ijh2q = parcelRequire("ijh2q");
var $cfa751ba4428ce31$require$Buffer = $ijh2q.Buffer;
function $cfa751ba4428ce31$var$asUInt32Array(buf) {
    if (!$cfa751ba4428ce31$require$Buffer.isBuffer(buf)) buf = $cfa751ba4428ce31$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $cfa751ba4428ce31$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $cfa751ba4428ce31$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $cfa751ba4428ce31$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $cfa751ba4428ce31$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $cfa751ba4428ce31$var$AES(key) {
    this._key = $cfa751ba4428ce31$var$asUInt32Array(key);
    this._reset();
}
$cfa751ba4428ce31$var$AES.blockSize = 16;
$cfa751ba4428ce31$var$AES.keySize = 32;
$cfa751ba4428ce31$var$AES.prototype.blockSize = $cfa751ba4428ce31$var$AES.blockSize;
$cfa751ba4428ce31$var$AES.prototype.keySize = $cfa751ba4428ce31$var$AES.keySize;
$cfa751ba4428ce31$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $cfa751ba4428ce31$var$G.SBOX[t >>> 24] << 24 | $cfa751ba4428ce31$var$G.SBOX[t >>> 16 & 0xff] << 16 | $cfa751ba4428ce31$var$G.SBOX[t >>> 8 & 0xff] << 8 | $cfa751ba4428ce31$var$G.SBOX[t & 0xff];
            t ^= $cfa751ba4428ce31$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $cfa751ba4428ce31$var$G.SBOX[t >>> 24] << 24 | $cfa751ba4428ce31$var$G.SBOX[t >>> 16 & 0xff] << 16 | $cfa751ba4428ce31$var$G.SBOX[t >>> 8 & 0xff] << 8 | $cfa751ba4428ce31$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $cfa751ba4428ce31$var$G.INV_SUB_MIX[0][$cfa751ba4428ce31$var$G.SBOX[tt >>> 24]] ^ $cfa751ba4428ce31$var$G.INV_SUB_MIX[1][$cfa751ba4428ce31$var$G.SBOX[tt >>> 16 & 0xff]] ^ $cfa751ba4428ce31$var$G.INV_SUB_MIX[2][$cfa751ba4428ce31$var$G.SBOX[tt >>> 8 & 0xff]] ^ $cfa751ba4428ce31$var$G.INV_SUB_MIX[3][$cfa751ba4428ce31$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$cfa751ba4428ce31$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $cfa751ba4428ce31$var$asUInt32Array(M);
    return $cfa751ba4428ce31$var$cryptBlock(M, this._keySchedule, $cfa751ba4428ce31$var$G.SUB_MIX, $cfa751ba4428ce31$var$G.SBOX, this._nRounds);
};
$cfa751ba4428ce31$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $cfa751ba4428ce31$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$cfa751ba4428ce31$var$AES.prototype.decryptBlock = function(M) {
    M = $cfa751ba4428ce31$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $cfa751ba4428ce31$var$cryptBlock(M, this._invKeySchedule, $cfa751ba4428ce31$var$G.INV_SUB_MIX, $cfa751ba4428ce31$var$G.INV_SBOX, this._nRounds);
    var buf = $cfa751ba4428ce31$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$cfa751ba4428ce31$var$AES.prototype.scrub = function() {
    $cfa751ba4428ce31$var$scrubVec(this._keySchedule);
    $cfa751ba4428ce31$var$scrubVec(this._invKeySchedule);
    $cfa751ba4428ce31$var$scrubVec(this._key);
};
$cfa751ba4428ce31$export$b80fbe1c3a2b92b5 = $cfa751ba4428ce31$var$AES;

});

parcelRegister("kWTRq", function(module, exports) {

var $ijh2q = parcelRequire("ijh2q");
var $f4048e34861b21d9$require$Buffer = $ijh2q.Buffer;
var $f4048e34861b21d9$var$ZEROES = $f4048e34861b21d9$require$Buffer.alloc(16, 0);
function $f4048e34861b21d9$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $f4048e34861b21d9$var$fromArray(out) {
    var buf = $f4048e34861b21d9$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $f4048e34861b21d9$var$GHASH(key) {
    this.h = key;
    this.state = $f4048e34861b21d9$require$Buffer.alloc(16, 0);
    this.cache = $f4048e34861b21d9$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$f4048e34861b21d9$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$f4048e34861b21d9$var$GHASH.prototype._multiply = function() {
    var Vi = $f4048e34861b21d9$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $f4048e34861b21d9$var$fromArray(Zi);
};
$f4048e34861b21d9$var$GHASH.prototype.update = function(buf) {
    this.cache = $f4048e34861b21d9$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$f4048e34861b21d9$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($f4048e34861b21d9$require$Buffer.concat([
        this.cache,
        $f4048e34861b21d9$var$ZEROES
    ], 16));
    this.ghash($f4048e34861b21d9$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $f4048e34861b21d9$var$GHASH;

});


parcelRegister("96zpw", function(module, exports) {

var $hPkMt = parcelRequire("hPkMt");

var $ijh2q = parcelRequire("ijh2q");
var $6a10246aaec37d32$require$Buffer = $ijh2q.Buffer;

var $7hBrF = parcelRequire("7hBrF");

var $lyUaN = parcelRequire("lyUaN");
function $6a10246aaec37d32$var$StreamCipher(mode, key, iv, decrypt) {
    $7hBrF.call(this);
    this._cipher = new $hPkMt.AES(key);
    this._prev = $6a10246aaec37d32$require$Buffer.from(iv);
    this._cache = $6a10246aaec37d32$require$Buffer.allocUnsafe(0);
    this._secCache = $6a10246aaec37d32$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$lyUaN($6a10246aaec37d32$var$StreamCipher, $7hBrF);
$6a10246aaec37d32$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$6a10246aaec37d32$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $6a10246aaec37d32$var$StreamCipher;

});


parcelRegister("2o6Y4", function(module, exports) {

$parcel$export(module.exports, "createDecipher", () => $1bd33a57d41157b4$export$12ada9414fbc594c, (v) => $1bd33a57d41157b4$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "createDecipheriv", () => $1bd33a57d41157b4$export$36b6d6ef312eab39, (v) => $1bd33a57d41157b4$export$36b6d6ef312eab39 = v);
var $1bd33a57d41157b4$export$12ada9414fbc594c;
var $1bd33a57d41157b4$export$36b6d6ef312eab39;

var $jEzvF = parcelRequire("jEzvF");

var $ijh2q = parcelRequire("ijh2q");
var $1bd33a57d41157b4$require$Buffer = $ijh2q.Buffer;

var $2z1oX = parcelRequire("2z1oX");

var $96zpw = parcelRequire("96zpw");

var $7hBrF = parcelRequire("7hBrF");

var $hPkMt = parcelRequire("hPkMt");

var $d9sFZ = parcelRequire("d9sFZ");

var $lyUaN = parcelRequire("lyUaN");
function $1bd33a57d41157b4$var$Decipher(mode, key, iv) {
    $7hBrF.call(this);
    this._cache = new $1bd33a57d41157b4$var$Splitter();
    this._last = void 0;
    this._cipher = new $hPkMt.AES(key);
    this._prev = $1bd33a57d41157b4$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$lyUaN($1bd33a57d41157b4$var$Decipher, $7hBrF);
$1bd33a57d41157b4$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $1bd33a57d41157b4$require$Buffer.concat(out);
};
$1bd33a57d41157b4$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $1bd33a57d41157b4$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error('data not multiple of block length');
};
$1bd33a57d41157b4$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $1bd33a57d41157b4$var$Splitter() {
    this.cache = $1bd33a57d41157b4$require$Buffer.allocUnsafe(0);
}
$1bd33a57d41157b4$var$Splitter.prototype.add = function(data) {
    this.cache = $1bd33a57d41157b4$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$1bd33a57d41157b4$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$1bd33a57d41157b4$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $1bd33a57d41157b4$var$unpad(last) {
    var padded = last[15];
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error('unable to decrypt data');
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $1bd33a57d41157b4$var$createDecipheriv(suite, password, iv) {
    var config = $2z1oX[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof iv === 'string') iv = $1bd33a57d41157b4$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (typeof password === 'string') password = $1bd33a57d41157b4$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (config.type === 'stream') return new $96zpw(config.module, password, iv, true);
    else if (config.type === 'auth') return new $jEzvF(config.module, password, iv, true);
    return new $1bd33a57d41157b4$var$Decipher(config.module, password, iv);
}
function $1bd33a57d41157b4$var$createDecipher(suite, password) {
    var config = $2z1oX[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $d9sFZ(password, false, config.key, config.iv);
    return $1bd33a57d41157b4$var$createDecipheriv(suite, keys.key, keys.iv);
}
$1bd33a57d41157b4$export$12ada9414fbc594c = $1bd33a57d41157b4$var$createDecipher;
$1bd33a57d41157b4$export$36b6d6ef312eab39 = $1bd33a57d41157b4$var$createDecipheriv;

});


parcelRegister("A6QqV", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $06c8ac1f3fd38271$require$Buffer = $aul3P.Buffer;

var $7hBrF = parcelRequire("7hBrF");

var $dGxNe = parcelRequire("dGxNe");

var $lyUaN = parcelRequire("lyUaN");
var $06c8ac1f3fd38271$var$modes = {
    'des-ede3-cbc': $dGxNe.CBC.instantiate($dGxNe.EDE),
    'des-ede3': $dGxNe.EDE,
    'des-ede-cbc': $dGxNe.CBC.instantiate($dGxNe.EDE),
    'des-ede': $dGxNe.EDE,
    'des-cbc': $dGxNe.CBC.instantiate($dGxNe.DES),
    'des-ecb': $dGxNe.DES
};
$06c8ac1f3fd38271$var$modes.des = $06c8ac1f3fd38271$var$modes['des-cbc'];
$06c8ac1f3fd38271$var$modes.des3 = $06c8ac1f3fd38271$var$modes['des-ede3-cbc'];
module.exports = $06c8ac1f3fd38271$var$DES;
$lyUaN($06c8ac1f3fd38271$var$DES, $7hBrF);
function $06c8ac1f3fd38271$var$DES(opts) {
    $7hBrF.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $06c8ac1f3fd38271$var$modes[modeName];
    var type;
    if (opts.decrypt) type = 'decrypt';
    else type = 'encrypt';
    var key = opts.key;
    if (modeName === 'des-ede' || modeName === 'des-ede-cbc') key = $06c8ac1f3fd38271$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$06c8ac1f3fd38271$var$DES.prototype._update = function(data) {
    return new $06c8ac1f3fd38271$require$Buffer(this._des.update(data));
};
$06c8ac1f3fd38271$var$DES.prototype._final = function() {
    return new $06c8ac1f3fd38271$require$Buffer(this._des.final());
};

});
parcelRegister("dGxNe", function(module, exports) {

$parcel$export(module.exports, "utils", () => $9f69693503109cbe$export$eab97d15b1788b8d, (v) => $9f69693503109cbe$export$eab97d15b1788b8d = v);
$parcel$export(module.exports, "Cipher", () => $9f69693503109cbe$export$26e5786e8ac8e530, (v) => $9f69693503109cbe$export$26e5786e8ac8e530 = v);
$parcel$export(module.exports, "DES", () => $9f69693503109cbe$export$cc8859615686b300, (v) => $9f69693503109cbe$export$cc8859615686b300 = v);
$parcel$export(module.exports, "CBC", () => $9f69693503109cbe$export$8ad3f227af08fcc5, (v) => $9f69693503109cbe$export$8ad3f227af08fcc5 = v);
$parcel$export(module.exports, "EDE", () => $9f69693503109cbe$export$947646e34766044f, (v) => $9f69693503109cbe$export$947646e34766044f = v);
var $9f69693503109cbe$export$eab97d15b1788b8d;
var $9f69693503109cbe$export$26e5786e8ac8e530;
var $9f69693503109cbe$export$cc8859615686b300;
var $9f69693503109cbe$export$8ad3f227af08fcc5;
var $9f69693503109cbe$export$947646e34766044f;
'use strict';

$9f69693503109cbe$export$eab97d15b1788b8d = (parcelRequire("7GCGw"));

$9f69693503109cbe$export$26e5786e8ac8e530 = (parcelRequire("5sKz7"));

$9f69693503109cbe$export$cc8859615686b300 = (parcelRequire("dZrBr"));

$9f69693503109cbe$export$8ad3f227af08fcc5 = (parcelRequire("gNVcN"));

$9f69693503109cbe$export$947646e34766044f = (parcelRequire("4Xu4n"));

});
parcelRegister("7GCGw", function(module, exports) {

$parcel$export(module.exports, "readUInt32BE", () => $598a76a19b3b2ec0$export$cfaef8ed399428b0, (v) => $598a76a19b3b2ec0$export$cfaef8ed399428b0 = v);
$parcel$export(module.exports, "writeUInt32BE", () => $598a76a19b3b2ec0$export$a80c7deaea7cbd80, (v) => $598a76a19b3b2ec0$export$a80c7deaea7cbd80 = v);
$parcel$export(module.exports, "ip", () => $598a76a19b3b2ec0$export$ed7577ae6e1cd0ef, (v) => $598a76a19b3b2ec0$export$ed7577ae6e1cd0ef = v);
$parcel$export(module.exports, "rip", () => $598a76a19b3b2ec0$export$5dcbef3aa594f567, (v) => $598a76a19b3b2ec0$export$5dcbef3aa594f567 = v);
$parcel$export(module.exports, "pc1", () => $598a76a19b3b2ec0$export$5bc8001ca71ed9c5, (v) => $598a76a19b3b2ec0$export$5bc8001ca71ed9c5 = v);
$parcel$export(module.exports, "r28shl", () => $598a76a19b3b2ec0$export$3e714e2c5d5d8cb2, (v) => $598a76a19b3b2ec0$export$3e714e2c5d5d8cb2 = v);
$parcel$export(module.exports, "pc2", () => $598a76a19b3b2ec0$export$94c3e544fd062b7f, (v) => $598a76a19b3b2ec0$export$94c3e544fd062b7f = v);
$parcel$export(module.exports, "expand", () => $598a76a19b3b2ec0$export$9f77e0932fb78f72, (v) => $598a76a19b3b2ec0$export$9f77e0932fb78f72 = v);
$parcel$export(module.exports, "substitute", () => $598a76a19b3b2ec0$export$d865ce2836f5927f, (v) => $598a76a19b3b2ec0$export$d865ce2836f5927f = v);
$parcel$export(module.exports, "permute", () => $598a76a19b3b2ec0$export$95e62ad65da8b7d2, (v) => $598a76a19b3b2ec0$export$95e62ad65da8b7d2 = v);
$parcel$export(module.exports, "padSplit", () => $598a76a19b3b2ec0$export$209139ff098c441a, (v) => $598a76a19b3b2ec0$export$209139ff098c441a = v);
var $598a76a19b3b2ec0$export$cfaef8ed399428b0;
var $598a76a19b3b2ec0$export$a80c7deaea7cbd80;
var $598a76a19b3b2ec0$export$ed7577ae6e1cd0ef;
var $598a76a19b3b2ec0$export$5dcbef3aa594f567;
var $598a76a19b3b2ec0$export$5bc8001ca71ed9c5;
var $598a76a19b3b2ec0$export$3e714e2c5d5d8cb2;
var $598a76a19b3b2ec0$export$94c3e544fd062b7f;
var $598a76a19b3b2ec0$export$9f77e0932fb78f72;
var $598a76a19b3b2ec0$export$d865ce2836f5927f;
var $598a76a19b3b2ec0$export$95e62ad65da8b7d2;
var $598a76a19b3b2ec0$export$209139ff098c441a;
'use strict';
$598a76a19b3b2ec0$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$598a76a19b3b2ec0$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$598a76a19b3b2ec0$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$598a76a19b3b2ec0$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$598a76a19b3b2ec0$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$598a76a19b3b2ec0$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $598a76a19b3b2ec0$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$598a76a19b3b2ec0$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $598a76a19b3b2ec0$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $598a76a19b3b2ec0$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $598a76a19b3b2ec0$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $598a76a19b3b2ec0$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$598a76a19b3b2ec0$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $598a76a19b3b2ec0$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$598a76a19b3b2ec0$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $598a76a19b3b2ec0$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $598a76a19b3b2ec0$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $598a76a19b3b2ec0$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$598a76a19b3b2ec0$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $598a76a19b3b2ec0$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $598a76a19b3b2ec0$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$598a76a19b3b2ec0$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = '0' + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(' ');
};

});

parcelRegister("5sKz7", function(module, exports) {
'use strict';

var $aOIMZ = parcelRequire("aOIMZ");
function $3fa3b03628a4362d$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
}
module.exports = $3fa3b03628a4362d$var$Cipher;
$3fa3b03628a4362d$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$3fa3b03628a4362d$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === 'decrypt') return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$3fa3b03628a4362d$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$3fa3b03628a4362d$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$3fa3b03628a4362d$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$3fa3b03628a4362d$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$3fa3b03628a4362d$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === 'encrypt') last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$3fa3b03628a4362d$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$3fa3b03628a4362d$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$3fa3b03628a4362d$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$3fa3b03628a4362d$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $aOIMZ.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});
parcelRegister("aOIMZ", function(module, exports) {
module.exports = $7e015117bb8d6cde$var$assert;
function $7e015117bb8d6cde$var$assert(val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
}
$7e015117bb8d6cde$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || 'Assertion failed: ' + l + ' != ' + r);
};

});


parcelRegister("dZrBr", function(module, exports) {
'use strict';

var $aOIMZ = parcelRequire("aOIMZ");

var $lyUaN = parcelRequire("lyUaN");

var $dGxNe = parcelRequire("dGxNe");
var $a2f6623cd6d516cb$var$utils = $dGxNe.utils;
var $a2f6623cd6d516cb$var$Cipher = $dGxNe.Cipher;
function $a2f6623cd6d516cb$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $a2f6623cd6d516cb$var$DES(options) {
    $a2f6623cd6d516cb$var$Cipher.call(this, options);
    var state = new $a2f6623cd6d516cb$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$lyUaN($a2f6623cd6d516cb$var$DES, $a2f6623cd6d516cb$var$Cipher);
module.exports = $a2f6623cd6d516cb$var$DES;
$a2f6623cd6d516cb$var$DES.create = function create(options) {
    return new $a2f6623cd6d516cb$var$DES(options);
};
var $a2f6623cd6d516cb$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$a2f6623cd6d516cb$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $aOIMZ.equal(key.length, this.blockSize, 'Invalid key length');
    var kL = $a2f6623cd6d516cb$var$utils.readUInt32BE(key, 0);
    var kR = $a2f6623cd6d516cb$var$utils.readUInt32BE(key, 4);
    $a2f6623cd6d516cb$var$utils.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $a2f6623cd6d516cb$var$shiftTable[i >>> 1];
        kL = $a2f6623cd6d516cb$var$utils.r28shl(kL, shift);
        kR = $a2f6623cd6d516cb$var$utils.r28shl(kR, shift);
        $a2f6623cd6d516cb$var$utils.pc2(kL, kR, state.keys, i);
    }
};
$a2f6623cd6d516cb$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $a2f6623cd6d516cb$var$utils.readUInt32BE(inp, inOff);
    var r = $a2f6623cd6d516cb$var$utils.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $a2f6623cd6d516cb$var$utils.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === 'encrypt') this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $a2f6623cd6d516cb$var$utils.writeUInt32BE(out, l, outOff);
    $a2f6623cd6d516cb$var$utils.writeUInt32BE(out, r, outOff + 4);
};
$a2f6623cd6d516cb$var$DES.prototype._pad = function _pad(buffer, off) {
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$a2f6623cd6d516cb$var$DES.prototype._unpad = function _unpad(buffer) {
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$aOIMZ.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$a2f6623cd6d516cb$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $a2f6623cd6d516cb$var$utils.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $a2f6623cd6d516cb$var$utils.substitute(keyL, keyR);
        var f = $a2f6623cd6d516cb$var$utils.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $a2f6623cd6d516cb$var$utils.rip(r, l, out, off);
};
$a2f6623cd6d516cb$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $a2f6623cd6d516cb$var$utils.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $a2f6623cd6d516cb$var$utils.substitute(keyL, keyR);
        var f = $a2f6623cd6d516cb$var$utils.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $a2f6623cd6d516cb$var$utils.rip(l, r, out, off);
};

});

parcelRegister("gNVcN", function(module, exports) {

$parcel$export(module.exports, "instantiate", () => $c3bd98be17497432$export$f9bb8d20ccc7477a, (v) => $c3bd98be17497432$export$f9bb8d20ccc7477a = v);
var $c3bd98be17497432$export$f9bb8d20ccc7477a;
'use strict';

var $aOIMZ = parcelRequire("aOIMZ");

var $lyUaN = parcelRequire("lyUaN");
var $c3bd98be17497432$var$proto = {};
function $c3bd98be17497432$var$CBCState(iv) {
    $aOIMZ.equal(iv.length, 8, 'Invalid IV length');
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $c3bd98be17497432$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $lyUaN(CBC, Base);
    var keys = Object.keys($c3bd98be17497432$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $c3bd98be17497432$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$c3bd98be17497432$export$f9bb8d20ccc7477a = $c3bd98be17497432$var$instantiate;
$c3bd98be17497432$var$proto._cbcInit = function _cbcInit() {
    var state = new $c3bd98be17497432$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$c3bd98be17497432$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === 'encrypt') {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRegister("4Xu4n", function(module, exports) {
'use strict';

var $aOIMZ = parcelRequire("aOIMZ");

var $lyUaN = parcelRequire("lyUaN");

var $dGxNe = parcelRequire("dGxNe");
var $39c3ff54fa87a964$var$Cipher = $dGxNe.Cipher;
var $39c3ff54fa87a964$var$DES = $dGxNe.DES;
function $39c3ff54fa87a964$var$EDEState(type, key) {
    $aOIMZ.equal(key.length, 24, 'Invalid key length');
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === 'encrypt') this.ciphers = [
        $39c3ff54fa87a964$var$DES.create({
            type: 'encrypt',
            key: k1
        }),
        $39c3ff54fa87a964$var$DES.create({
            type: 'decrypt',
            key: k2
        }),
        $39c3ff54fa87a964$var$DES.create({
            type: 'encrypt',
            key: k3
        })
    ];
    else this.ciphers = [
        $39c3ff54fa87a964$var$DES.create({
            type: 'decrypt',
            key: k3
        }),
        $39c3ff54fa87a964$var$DES.create({
            type: 'encrypt',
            key: k2
        }),
        $39c3ff54fa87a964$var$DES.create({
            type: 'decrypt',
            key: k1
        })
    ];
}
function $39c3ff54fa87a964$var$EDE(options) {
    $39c3ff54fa87a964$var$Cipher.call(this, options);
    var state = new $39c3ff54fa87a964$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$lyUaN($39c3ff54fa87a964$var$EDE, $39c3ff54fa87a964$var$Cipher);
module.exports = $39c3ff54fa87a964$var$EDE;
$39c3ff54fa87a964$var$EDE.create = function create(options) {
    return new $39c3ff54fa87a964$var$EDE(options);
};
$39c3ff54fa87a964$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$39c3ff54fa87a964$var$EDE.prototype._pad = $39c3ff54fa87a964$var$DES.prototype._pad;
$39c3ff54fa87a964$var$EDE.prototype._unpad = $39c3ff54fa87a964$var$DES.prototype._unpad;

});



parcelRegister("9Xue6", function(module, exports) {

$parcel$export(module.exports, "des-ecb", () => $7401121727af84fc$export$116f8a5cee447347, (v) => $7401121727af84fc$export$116f8a5cee447347 = v);
$parcel$export(module.exports, "des-cbc", () => $7401121727af84fc$export$7483c4066bfb7ae9, (v) => $7401121727af84fc$export$7483c4066bfb7ae9 = v);
$parcel$export(module.exports, "des", () => $7401121727af84fc$export$e7a565d2e588bb06, (v) => $7401121727af84fc$export$e7a565d2e588bb06 = v);
$parcel$export(module.exports, "des-ede3-cbc", () => $7401121727af84fc$export$aaa2f54a426f3eb8, (v) => $7401121727af84fc$export$aaa2f54a426f3eb8 = v);
$parcel$export(module.exports, "des3", () => $7401121727af84fc$export$eba20568dde4ada, (v) => $7401121727af84fc$export$eba20568dde4ada = v);
$parcel$export(module.exports, "des-ede3", () => $7401121727af84fc$export$d3b5e5996938f5ae, (v) => $7401121727af84fc$export$d3b5e5996938f5ae = v);
$parcel$export(module.exports, "des-ede-cbc", () => $7401121727af84fc$export$57c08356130bc99b, (v) => $7401121727af84fc$export$57c08356130bc99b = v);
$parcel$export(module.exports, "des-ede", () => $7401121727af84fc$export$c7169791d5c1e65d, (v) => $7401121727af84fc$export$c7169791d5c1e65d = v);
var $7401121727af84fc$export$116f8a5cee447347;
var $7401121727af84fc$export$7483c4066bfb7ae9;
var $7401121727af84fc$export$e7a565d2e588bb06;
var $7401121727af84fc$export$aaa2f54a426f3eb8;
var $7401121727af84fc$export$eba20568dde4ada;
var $7401121727af84fc$export$d3b5e5996938f5ae;
var $7401121727af84fc$export$57c08356130bc99b;
var $7401121727af84fc$export$c7169791d5c1e65d;
$7401121727af84fc$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$7401121727af84fc$export$7483c4066bfb7ae9 = $7401121727af84fc$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$7401121727af84fc$export$aaa2f54a426f3eb8 = $7401121727af84fc$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$7401121727af84fc$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$7401121727af84fc$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$7401121727af84fc$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};

});


parcelRegister("fPWK2", function(module, exports) {

$parcel$export(module.exports, "DiffieHellmanGroup", () => $b8792f4d453e7272$export$971862a2fcb1bb40, (v) => $b8792f4d453e7272$export$971862a2fcb1bb40 = v);
$parcel$export(module.exports, "createDiffieHellmanGroup", () => $b8792f4d453e7272$export$c6ff6a88acbeaf40, (v) => $b8792f4d453e7272$export$c6ff6a88acbeaf40 = v);
$parcel$export(module.exports, "getDiffieHellman", () => $b8792f4d453e7272$export$fdc27893e98845cc, (v) => $b8792f4d453e7272$export$fdc27893e98845cc = v);
$parcel$export(module.exports, "createDiffieHellman", () => $b8792f4d453e7272$export$6671fb9a1323bed, (v) => $b8792f4d453e7272$export$6671fb9a1323bed = v);
$parcel$export(module.exports, "DiffieHellman", () => $b8792f4d453e7272$export$d74daf141a551db, (v) => $b8792f4d453e7272$export$d74daf141a551db = v);
var $b8792f4d453e7272$export$971862a2fcb1bb40;
var $b8792f4d453e7272$export$c6ff6a88acbeaf40;
var $b8792f4d453e7272$export$fdc27893e98845cc;
var $b8792f4d453e7272$export$6671fb9a1323bed;
var $b8792f4d453e7272$export$d74daf141a551db;

var $aul3P = parcelRequire("aul3P");
var $b8792f4d453e7272$require$Buffer = $aul3P.Buffer;

var $5Imi1 = parcelRequire("5Imi1");

var $aBb26 = parcelRequire("aBb26");

var $4ybg5 = parcelRequire("4ybg5");
function $b8792f4d453e7272$var$getDiffieHellman(mod) {
    var prime = new $b8792f4d453e7272$require$Buffer($aBb26[mod].prime, 'hex');
    var gen = new $b8792f4d453e7272$require$Buffer($aBb26[mod].gen, 'hex');
    return new $4ybg5(prime, gen);
}
var $b8792f4d453e7272$var$ENCODINGS = {
    'binary': true,
    'hex': true,
    'base64': true
};
function $b8792f4d453e7272$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($b8792f4d453e7272$require$Buffer.isBuffer(enc) || $b8792f4d453e7272$var$ENCODINGS[enc] === undefined) return $b8792f4d453e7272$var$createDiffieHellman(prime, 'binary', enc, generator);
    enc = enc || 'binary';
    genc = genc || 'binary';
    generator = generator || new $b8792f4d453e7272$require$Buffer([
        2
    ]);
    if (!$b8792f4d453e7272$require$Buffer.isBuffer(generator)) generator = new $b8792f4d453e7272$require$Buffer(generator, genc);
    if (typeof prime === 'number') return new $4ybg5($5Imi1(prime, generator), generator, true);
    if (!$b8792f4d453e7272$require$Buffer.isBuffer(prime)) prime = new $b8792f4d453e7272$require$Buffer(prime, enc);
    return new $4ybg5(prime, generator, true);
}
$b8792f4d453e7272$export$971862a2fcb1bb40 = $b8792f4d453e7272$export$c6ff6a88acbeaf40 = $b8792f4d453e7272$export$fdc27893e98845cc = $b8792f4d453e7272$var$getDiffieHellman;
$b8792f4d453e7272$export$6671fb9a1323bed = $b8792f4d453e7272$export$d74daf141a551db = $b8792f4d453e7272$var$createDiffieHellman;

});
parcelRegister("5Imi1", function(module, exports) {

var $ugwNY = parcelRequire("ugwNY");
module.exports = $42925a0e7985bf7e$var$findPrime;
$42925a0e7985bf7e$var$findPrime.simpleSieve = $42925a0e7985bf7e$var$simpleSieve;
$42925a0e7985bf7e$var$findPrime.fermatTest = $42925a0e7985bf7e$var$fermatTest;

var $61SlE = parcelRequire("61SlE");
var $42925a0e7985bf7e$var$TWENTYFOUR = new $61SlE(24);

var $4qHnY = parcelRequire("4qHnY");
var $42925a0e7985bf7e$var$millerRabin = new $4qHnY();
var $42925a0e7985bf7e$var$ONE = new $61SlE(1);
var $42925a0e7985bf7e$var$TWO = new $61SlE(2);
var $42925a0e7985bf7e$var$FIVE = new $61SlE(5);
var $42925a0e7985bf7e$var$SIXTEEN = new $61SlE(16);
var $42925a0e7985bf7e$var$EIGHT = new $61SlE(8);
var $42925a0e7985bf7e$var$TEN = new $61SlE(10);
var $42925a0e7985bf7e$var$THREE = new $61SlE(3);
var $42925a0e7985bf7e$var$SEVEN = new $61SlE(7);
var $42925a0e7985bf7e$var$ELEVEN = new $61SlE(11);
var $42925a0e7985bf7e$var$FOUR = new $61SlE(4);
var $42925a0e7985bf7e$var$TWELVE = new $61SlE(12);
var $42925a0e7985bf7e$var$primes = null;
function $42925a0e7985bf7e$var$_getPrimes() {
    if ($42925a0e7985bf7e$var$primes !== null) return $42925a0e7985bf7e$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $42925a0e7985bf7e$var$primes = res;
    return res;
}
function $42925a0e7985bf7e$var$simpleSieve(p) {
    var primes = $42925a0e7985bf7e$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $42925a0e7985bf7e$var$fermatTest(p) {
    var red = $61SlE.mont(p);
    return $42925a0e7985bf7e$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $42925a0e7985bf7e$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $61SlE([
            0x8c,
            0x7b
        ]);
        else return new $61SlE([
            0x8c,
            0x27
        ]);
    }
    gen = new $61SlE(gen);
    var num, n2;
    while(true){
        num = new $61SlE($ugwNY(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($42925a0e7985bf7e$var$ONE);
        if (!num.testn(1)) num.iadd($42925a0e7985bf7e$var$TWO);
        if (!gen.cmp($42925a0e7985bf7e$var$TWO)) while(num.mod($42925a0e7985bf7e$var$TWENTYFOUR).cmp($42925a0e7985bf7e$var$ELEVEN))num.iadd($42925a0e7985bf7e$var$FOUR);
        else if (!gen.cmp($42925a0e7985bf7e$var$FIVE)) while(num.mod($42925a0e7985bf7e$var$TEN).cmp($42925a0e7985bf7e$var$THREE))num.iadd($42925a0e7985bf7e$var$FOUR);
        n2 = num.shrn(1);
        if ($42925a0e7985bf7e$var$simpleSieve(n2) && $42925a0e7985bf7e$var$simpleSieve(num) && $42925a0e7985bf7e$var$fermatTest(n2) && $42925a0e7985bf7e$var$fermatTest(num) && $42925a0e7985bf7e$var$millerRabin.test(n2) && $42925a0e7985bf7e$var$millerRabin.test(num)) return num;
    }
}

});
parcelRegister("61SlE", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        Buffer = (parcelRequire("jFleb")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') start++;
        if (base === 16) this._parseHex(number, start);
        else this._parseBase(number, base, start);
        if (number[0] === '-') this.negative = 1;
        this.strip();
        if (endian !== 'le') return;
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex(str, start, end) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r <<= 4;
            // 'a' - 'f'
            if (c >= 49 && c <= 54) r |= c - 49 + 0xa;
            else if (c >= 17 && c <= 22) r |= c - 17 + 0xa;
            else r |= c & 0xf;
        }
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        // Scan 24-bit chunks and add them to the number
        var off = 0;
        for(i = number.length - 6, j = 0; i >= start; i -= 6){
            w = parseHex(number, i, i + 6);
            this.words[j] |= w << off & 0x3ffffff;
            // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
            this.words[j + 1] |= w >>> 26 - off & 0x3fffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        if (i + 6 !== start) {
            w = parseHex(number, start, i + 6);
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] |= w >>> 26 - off & 0x3fffff;
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else r.strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("4qHnY", function(module, exports) {

var $61SlE = parcelRequire("61SlE");

var $7EB5r = parcelRequire("7EB5r");
function $339b3e9b9b7e3050$var$MillerRabin(rand) {
    this.rand = rand || new $7EB5r.Rand();
}
module.exports = $339b3e9b9b7e3050$var$MillerRabin;
$339b3e9b9b7e3050$var$MillerRabin.create = function create(rand) {
    return new $339b3e9b9b7e3050$var$MillerRabin(rand);
};
$339b3e9b9b7e3050$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $61SlE(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$339b3e9b9b7e3050$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$339b3e9b9b7e3050$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $61SlE.mont(n);
    var rone = new $61SlE(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $61SlE(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$339b3e9b9b7e3050$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $61SlE.mont(n);
    var rone = new $61SlE(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $61SlE(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};

});
parcelRegister("7EB5r", function(module, exports) {
var $5929097e933a50fa$var$r;
module.exports = function rand(len) {
    if (!$5929097e933a50fa$var$r) $5929097e933a50fa$var$r = new $5929097e933a50fa$var$Rand(null);
    return $5929097e933a50fa$var$r.generate(len);
};
function $5929097e933a50fa$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $5929097e933a50fa$var$Rand;
$5929097e933a50fa$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$5929097e933a50fa$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === 'object') {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $5929097e933a50fa$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $5929097e933a50fa$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === 'object') // Old junk
    $5929097e933a50fa$var$Rand.prototype._rand = function() {
        throw new Error('Not implemented yet');
    };
} else // Node.js or Web worker with no crypto support
try {
    var $5929097e933a50fa$var$crypto = (parcelRequire("jFleb"));
    if (typeof $5929097e933a50fa$var$crypto.randomBytes !== 'function') throw new Error('Not supported');
    $5929097e933a50fa$var$Rand.prototype._rand = function _rand(n) {
        return $5929097e933a50fa$var$crypto.randomBytes(n);
    };
} catch (e) {}

});



parcelRegister("aBb26", function(module, exports) {
module.exports = JSON.parse("{\"modp1\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff\"},\"modp2\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff\"},\"modp5\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff\"},\"modp14\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff\"},\"modp15\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff\"},\"modp16\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff\"},\"modp17\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff\"},\"modp18\":{\"gen\":\"02\",\"prime\":\"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\"}}");

});

parcelRegister("4ybg5", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $3503121994d90ae3$require$Buffer = $aul3P.Buffer;

var $61SlE = parcelRequire("61SlE");

var $4qHnY = parcelRequire("4qHnY");
var $3503121994d90ae3$var$millerRabin = new $4qHnY();
var $3503121994d90ae3$var$TWENTYFOUR = new $61SlE(24);
var $3503121994d90ae3$var$ELEVEN = new $61SlE(11);
var $3503121994d90ae3$var$TEN = new $61SlE(10);
var $3503121994d90ae3$var$THREE = new $61SlE(3);
var $3503121994d90ae3$var$SEVEN = new $61SlE(7);

var $5Imi1 = parcelRequire("5Imi1");

var $ugwNY = parcelRequire("ugwNY");
module.exports = $3503121994d90ae3$var$DH;
function $3503121994d90ae3$var$setPublicKey(pub, enc) {
    enc = enc || 'utf8';
    if (!$3503121994d90ae3$require$Buffer.isBuffer(pub)) pub = new $3503121994d90ae3$require$Buffer(pub, enc);
    this._pub = new $61SlE(pub);
    return this;
}
function $3503121994d90ae3$var$setPrivateKey(priv, enc) {
    enc = enc || 'utf8';
    if (!$3503121994d90ae3$require$Buffer.isBuffer(priv)) priv = new $3503121994d90ae3$require$Buffer(priv, enc);
    this._priv = new $61SlE(priv);
    return this;
}
var $3503121994d90ae3$var$primeCache = {};
function $3503121994d90ae3$var$checkPrime(prime, generator) {
    var gen = generator.toString('hex');
    var hex = [
        gen,
        prime.toString(16)
    ].join('_');
    if (hex in $3503121994d90ae3$var$primeCache) return $3503121994d90ae3$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$5Imi1.simpleSieve || !$5Imi1.fermatTest(prime) || !$3503121994d90ae3$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === '02' || gen === '05') // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $3503121994d90ae3$var$primeCache[hex] = error;
        return error;
    }
    if (!$3503121994d90ae3$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case '02':
            if (prime.mod($3503121994d90ae3$var$TWENTYFOUR).cmp($3503121994d90ae3$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case '05':
            rem = prime.mod($3503121994d90ae3$var$TEN);
            if (rem.cmp($3503121994d90ae3$var$THREE) && rem.cmp($3503121994d90ae3$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $3503121994d90ae3$var$primeCache[hex] = error;
    return error;
}
function $3503121994d90ae3$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $61SlE(prime);
    this._prime = $61SlE.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $3503121994d90ae3$var$setPublicKey;
        this.setPrivateKey = $3503121994d90ae3$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($3503121994d90ae3$var$DH.prototype, 'verifyError', {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== 'number') this._primeCode = $3503121994d90ae3$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$3503121994d90ae3$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $61SlE($ugwNY(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$3503121994d90ae3$var$DH.prototype.computeSecret = function(other) {
    other = new $61SlE(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $3503121994d90ae3$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $3503121994d90ae3$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $3503121994d90ae3$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$3503121994d90ae3$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $3503121994d90ae3$var$formatReturnValue(this._pub, enc);
};
$3503121994d90ae3$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $3503121994d90ae3$var$formatReturnValue(this._priv, enc);
};
$3503121994d90ae3$var$DH.prototype.getPrime = function(enc) {
    return $3503121994d90ae3$var$formatReturnValue(this.__prime, enc);
};
$3503121994d90ae3$var$DH.prototype.getGenerator = function(enc) {
    return $3503121994d90ae3$var$formatReturnValue(this._gen, enc);
};
$3503121994d90ae3$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || 'utf8';
    if (!$3503121994d90ae3$require$Buffer.isBuffer(gen)) gen = new $3503121994d90ae3$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $61SlE(gen);
    return this;
};
function $3503121994d90ae3$var$formatReturnValue(bn, enc) {
    var buf = new $3503121994d90ae3$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}

});


parcelRegister("cQURD", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $95b6735c8554685b$require$Buffer = $aul3P.Buffer;

var $cnL2y = parcelRequire("cnL2y");

var $anz8L = parcelRequire("anz8L");

var $lyUaN = parcelRequire("lyUaN");

var $9WtmX = parcelRequire("9WtmX");

var $bdxL8 = parcelRequire("bdxL8");

var $5x0OM = parcelRequire("5x0OM");
Object.keys($5x0OM).forEach(function(key) {
    $5x0OM[key].id = new $95b6735c8554685b$require$Buffer($5x0OM[key].id, 'hex');
    $5x0OM[key.toLowerCase()] = $5x0OM[key];
});
function $95b6735c8554685b$var$Sign(algorithm) {
    $anz8L.Writable.call(this);
    var data = $5x0OM[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hashType = data.hash;
    this._hash = $cnL2y(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$lyUaN($95b6735c8554685b$var$Sign, $anz8L.Writable);
$95b6735c8554685b$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$95b6735c8554685b$var$Sign.prototype.update = function update(data, enc) {
    if (typeof data === 'string') data = new $95b6735c8554685b$require$Buffer(data, enc);
    this._hash.update(data);
    return this;
};
$95b6735c8554685b$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $9WtmX(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $95b6735c8554685b$var$Verify(algorithm) {
    $anz8L.Writable.call(this);
    var data = $5x0OM[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hash = $cnL2y(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$lyUaN($95b6735c8554685b$var$Verify, $anz8L.Writable);
$95b6735c8554685b$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$95b6735c8554685b$var$Verify.prototype.update = function update(data, enc) {
    if (typeof data === 'string') data = new $95b6735c8554685b$require$Buffer(data, enc);
    this._hash.update(data);
    return this;
};
$95b6735c8554685b$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    if (typeof sig === 'string') sig = new $95b6735c8554685b$require$Buffer(sig, enc);
    this.end();
    var hash = this._hash.digest();
    return $bdxL8(sig, hash, key, this._signType, this._tag);
};
function $95b6735c8554685b$var$createSign(algorithm) {
    return new $95b6735c8554685b$var$Sign(algorithm);
}
function $95b6735c8554685b$var$createVerify(algorithm) {
    return new $95b6735c8554685b$var$Verify(algorithm);
}
module.exports = {
    Sign: $95b6735c8554685b$var$createSign,
    Verify: $95b6735c8554685b$var$createVerify,
    createSign: $95b6735c8554685b$var$createSign,
    createVerify: $95b6735c8554685b$var$createVerify
};

});
parcelRegister("9WtmX", function(module, exports) {
// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js

var $aul3P = parcelRequire("aul3P");
var $73d04ff15cc0067d$require$Buffer = $aul3P.Buffer;

var $jPoqK = parcelRequire("jPoqK");

var $kFMzy = parcelRequire("kFMzy");

var $6nTxf = parcelRequire("6nTxf");
var $73d04ff15cc0067d$require$EC = $6nTxf.ec;

var $61SlE = parcelRequire("61SlE");

var $lXsfV = parcelRequire("lXsfV");

var $fyXn0 = parcelRequire("fyXn0");
function $73d04ff15cc0067d$var$sign(hash, key, hashType, signType, tag) {
    var priv = $lXsfV(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
        return $73d04ff15cc0067d$var$ecSign(hash, priv);
    } else if (priv.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong private key type');
        return $73d04ff15cc0067d$var$dsaSign(hash, priv, hashType);
    } else {
        if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
    }
    hash = $73d04ff15cc0067d$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $kFMzy(pad, priv);
    return out;
}
function $73d04ff15cc0067d$var$ecSign(hash, priv) {
    var curveId = $fyXn0[priv.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'));
    var curve = new $73d04ff15cc0067d$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return new $73d04ff15cc0067d$require$Buffer(out.toDER());
}
function $73d04ff15cc0067d$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $61SlE(0);
    var k;
    var H = $73d04ff15cc0067d$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $73d04ff15cc0067d$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $73d04ff15cc0067d$var$makeKey(q, kv, algo);
        r = $73d04ff15cc0067d$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $61SlE(0);
        }
    }
    return $73d04ff15cc0067d$var$toDER(r, s);
}
function $73d04ff15cc0067d$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return new $73d04ff15cc0067d$require$Buffer(res);
}
function $73d04ff15cc0067d$var$getKey(x, q, hash, algo) {
    x = new $73d04ff15cc0067d$require$Buffer(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = new $73d04ff15cc0067d$require$Buffer(q.byteLength() - x.length);
        zeros.fill(0);
        x = $73d04ff15cc0067d$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $73d04ff15cc0067d$var$bits2octets(hash, q);
    var v = new $73d04ff15cc0067d$require$Buffer(hlen);
    v.fill(1);
    var k = new $73d04ff15cc0067d$require$Buffer(hlen);
    k.fill(0);
    k = $jPoqK(algo, k).update(v).update(new $73d04ff15cc0067d$require$Buffer([
        0
    ])).update(x).update(hbits).digest();
    v = $jPoqK(algo, k).update(v).digest();
    k = $jPoqK(algo, k).update(v).update(new $73d04ff15cc0067d$require$Buffer([
        1
    ])).update(x).update(hbits).digest();
    v = $jPoqK(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $73d04ff15cc0067d$var$bits2int(obits, q) {
    var bits = new $61SlE(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $73d04ff15cc0067d$var$bits2octets(bits, q) {
    bits = $73d04ff15cc0067d$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = new $73d04ff15cc0067d$require$Buffer(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = new $73d04ff15cc0067d$require$Buffer(q.byteLength() - out.length);
        zeros.fill(0);
        out = $73d04ff15cc0067d$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $73d04ff15cc0067d$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = new $73d04ff15cc0067d$require$Buffer(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $jPoqK(algo, kv.k).update(kv.v).digest();
            t = $73d04ff15cc0067d$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $73d04ff15cc0067d$var$bits2int(t, q);
        kv.k = $jPoqK(algo, kv.k).update(kv.v).update(new $73d04ff15cc0067d$require$Buffer([
            0
        ])).digest();
        kv.v = $jPoqK(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $73d04ff15cc0067d$var$makeR(g, k, p, q) {
    return g.toRed($61SlE.mont(p)).redPow(k).fromRed().mod(q);
}
module.exports = $73d04ff15cc0067d$var$sign;
module.exports.getKey = $73d04ff15cc0067d$var$getKey;
module.exports.makeKey = $73d04ff15cc0067d$var$makeKey;

});
parcelRegister("kFMzy", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $f0cd5073c174da16$require$Buffer = $aul3P.Buffer;

var $61SlE = parcelRequire("61SlE");

var $ugwNY = parcelRequire("ugwNY");
module.exports = $f0cd5073c174da16$var$crt;
function $f0cd5073c174da16$var$blind(priv) {
    var r = $f0cd5073c174da16$var$getr(priv);
    var blinder = r.toRed($61SlE.mont(priv.modulus)).redPow(new $61SlE(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $f0cd5073c174da16$var$crt(msg, priv) {
    var blinds = $f0cd5073c174da16$var$blind(priv);
    var len = priv.modulus.byteLength();
    var mod = $61SlE.mont(priv.modulus);
    var blinded = new $61SlE(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($61SlE.mont(priv.prime1));
    var c2 = blinded.toRed($61SlE.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1);
    var m2 = c2.redPow(priv.exponent2);
    m1 = m1.fromRed();
    m2 = m2.fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p);
    h.imul(q);
    m2.iadd(h);
    return new $f0cd5073c174da16$require$Buffer(m2.imul(blinds.unblinder).umod(priv.modulus).toArray(false, len));
}
$f0cd5073c174da16$var$crt.getr = $f0cd5073c174da16$var$getr;
function $f0cd5073c174da16$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r = new $61SlE($ugwNY(len));
    while(r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2))r = new $61SlE($ugwNY(len));
    return r;
}

});

parcelRegister("6nTxf", function(module, exports) {
'use strict';
var $4a5ff836d3f5a0fb$var$elliptic = module.exports;

$4a5ff836d3f5a0fb$var$elliptic.version = (parcelRequire("aeDj6")).version;

$4a5ff836d3f5a0fb$var$elliptic.utils = (parcelRequire("8qPu3"));

$4a5ff836d3f5a0fb$var$elliptic.rand = (parcelRequire("7EB5r"));

$4a5ff836d3f5a0fb$var$elliptic.curve = (parcelRequire("g9z1u"));

$4a5ff836d3f5a0fb$var$elliptic.curves = (parcelRequire("8XT4W"));

// Protocols
$4a5ff836d3f5a0fb$var$elliptic.ec = (parcelRequire("h6mem"));

$4a5ff836d3f5a0fb$var$elliptic.eddsa = (parcelRequire("j0pZO"));

});
parcelRegister("aeDj6", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"elliptic\",\"version\":\"6.4.0\",\"description\":\"EC cryptography\",\"main\":\"lib/elliptic.js\",\"files\":[\"lib\"],\"scripts\":{\"jscs\":\"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js\",\"jshint\":\"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js\",\"lint\":\"npm run jscs && npm run jshint\",\"unit\":\"istanbul test _mocha --reporter=spec test/index.js\",\"test\":\"npm run lint && npm run unit\",\"version\":\"grunt dist && git add dist/\"},\"repository\":{\"type\":\"git\",\"url\":\"git@github.com:indutny/elliptic\"},\"keywords\":[\"EC\",\"Elliptic\",\"curve\",\"Cryptography\"],\"author\":\"Fedor Indutny <fedor@indutny.com>\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/indutny/elliptic/issues\"},\"homepage\":\"https://github.com/indutny/elliptic\",\"devDependencies\":{\"brfs\":\"^1.4.3\",\"coveralls\":\"^2.11.3\",\"grunt\":\"^0.4.5\",\"grunt-browserify\":\"^5.0.0\",\"grunt-cli\":\"^1.2.0\",\"grunt-contrib-connect\":\"^1.0.0\",\"grunt-contrib-copy\":\"^1.0.0\",\"grunt-contrib-uglify\":\"^1.0.1\",\"grunt-mocha-istanbul\":\"^3.0.1\",\"grunt-saucelabs\":\"^8.6.2\",\"istanbul\":\"^0.4.2\",\"jscs\":\"^2.9.0\",\"jshint\":\"^2.6.0\",\"mocha\":\"^2.1.0\"},\"dependencies\":{\"bn.js\":\"^4.4.0\",\"brorand\":\"^1.0.1\",\"hash.js\":\"^1.0.0\",\"hmac-drbg\":\"^1.0.0\",\"inherits\":\"^2.0.1\",\"minimalistic-assert\":\"^1.0.0\",\"minimalistic-crypto-utils\":\"^1.0.0\"}}");

});

parcelRegister("8qPu3", function(module, exports) {
'use strict';
var $6238b007fc990f16$var$utils = module.exports;

var $61SlE = parcelRequire("61SlE");

var $aOIMZ = parcelRequire("aOIMZ");

var $9a0Ug = parcelRequire("9a0Ug");
$6238b007fc990f16$var$utils.assert = $aOIMZ;
$6238b007fc990f16$var$utils.toArray = $9a0Ug.toArray;
$6238b007fc990f16$var$utils.zero2 = $9a0Ug.zero2;
$6238b007fc990f16$var$utils.toHex = $9a0Ug.toHex;
$6238b007fc990f16$var$utils.encode = $9a0Ug.encode;
// Represent num in a w-NAF form
function $6238b007fc990f16$var$getNAF(num, w) {
    var naf = [];
    var ws = 1 << w + 1;
    var k = num.clone();
    while(k.cmpn(1) >= 0){
        var z;
        if (k.isOdd()) {
            var mod = k.andln(ws - 1);
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf.push(z);
        // Optimization, shift by word if possible
        var shift = k.cmpn(0) !== 0 && k.andln(ws - 1) === 0 ? w + 1 : 1;
        for(var i = 1; i < shift; i++)naf.push(0);
        k.iushrn(shift);
    }
    return naf;
}
$6238b007fc990f16$var$utils.getNAF = $6238b007fc990f16$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $6238b007fc990f16$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            var m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            var m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$6238b007fc990f16$var$utils.getJSF = $6238b007fc990f16$var$getJSF;
function $6238b007fc990f16$var$cachedProperty(obj, name, computer) {
    var key = '_' + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$6238b007fc990f16$var$utils.cachedProperty = $6238b007fc990f16$var$cachedProperty;
function $6238b007fc990f16$var$parseBytes(bytes) {
    return typeof bytes === 'string' ? $6238b007fc990f16$var$utils.toArray(bytes, 'hex') : bytes;
}
$6238b007fc990f16$var$utils.parseBytes = $6238b007fc990f16$var$parseBytes;
function $6238b007fc990f16$var$intFromLE(bytes) {
    return new $61SlE(bytes, 'hex', 'le');
}
$6238b007fc990f16$var$utils.intFromLE = $6238b007fc990f16$var$intFromLE;

});
parcelRegister("9a0Ug", function(module, exports) {
'use strict';
var $6ab5c03eb880a4ce$var$utils = module.exports;
function $6ab5c03eb880a4ce$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== 'string') {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === 'hex') {
        msg = msg.replace(/[^a-z0-9]+/ig, '');
        if (msg.length % 2 !== 0) msg = '0' + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$6ab5c03eb880a4ce$var$utils.toArray = $6ab5c03eb880a4ce$var$toArray;
function $6ab5c03eb880a4ce$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$6ab5c03eb880a4ce$var$utils.zero2 = $6ab5c03eb880a4ce$var$zero2;
function $6ab5c03eb880a4ce$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $6ab5c03eb880a4ce$var$zero2(msg[i].toString(16));
    return res;
}
$6ab5c03eb880a4ce$var$utils.toHex = $6ab5c03eb880a4ce$var$toHex;
$6ab5c03eb880a4ce$var$utils.encode = function encode(arr, enc) {
    if (enc === 'hex') return $6ab5c03eb880a4ce$var$toHex(arr);
    else return arr;
};

});


parcelRegister("g9z1u", function(module, exports) {
'use strict';
var $bc28a777bbaba7c9$var$curve = module.exports;

$bc28a777bbaba7c9$var$curve.base = (parcelRequire("7FXqf"));

$bc28a777bbaba7c9$var$curve.short = (parcelRequire("o1Os9"));

$bc28a777bbaba7c9$var$curve.mont = (parcelRequire("hap7r"));

$bc28a777bbaba7c9$var$curve.edwards = (parcelRequire("3Oe4N"));

});
parcelRegister("7FXqf", function(module, exports) {
'use strict';

var $61SlE = parcelRequire("61SlE");

var $6nTxf = parcelRequire("6nTxf");
var $596a74c8a0293328$var$utils = $6nTxf.utils;
var $596a74c8a0293328$var$getNAF = $596a74c8a0293328$var$utils.getNAF;
var $596a74c8a0293328$var$getJSF = $596a74c8a0293328$var$utils.getJSF;
var $596a74c8a0293328$var$assert = $596a74c8a0293328$var$utils.assert;
function $596a74c8a0293328$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $61SlE(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $61SlE.red(conf.prime) : $61SlE.mont(this.p);
    // Useful for many curves
    this.zero = new $61SlE(0).toRed(this.red);
    this.one = new $61SlE(1).toRed(this.red);
    this.two = new $61SlE(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $61SlE(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $596a74c8a0293328$var$BaseCurve;
$596a74c8a0293328$var$BaseCurve.prototype.point = function point() {
    throw new Error('Not implemented');
};
$596a74c8a0293328$var$BaseCurve.prototype.validate = function validate() {
    throw new Error('Not implemented');
};
$596a74c8a0293328$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $596a74c8a0293328$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $596a74c8a0293328$var$getNAF(k, 1);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    for(var j = 0; j < naf.length; j += doubles.step){
        var nafW = 0;
        for(var k = j + doubles.step - 1; k >= j; k--)nafW = (nafW << 1) + naf[k];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(var j = 0; j < repr.length; j++){
            var nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$596a74c8a0293328$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $596a74c8a0293328$var$getNAF(k, w);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var k = 0; i >= 0 && naf[i] === 0; i--)k++;
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        var z = naf[i];
        $596a74c8a0293328$var$assert(z !== 0);
        if (p.type === 'affine') {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === 'affine' ? acc.toP() : acc;
};
$596a74c8a0293328$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    for(var i = 0; i < len; i++){
        var p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(var i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $596a74c8a0293328$var$getNAF(coeffs[a], wndWidth[a]);
            naf[b] = $596a74c8a0293328$var$getNAF(coeffs[b], wndWidth[b]);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3 /* 1 1 */ 
        ];
        var jsf = $596a74c8a0293328$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(var j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(var i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(var j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(var j = 0; j < len; j++){
            var z = tmp[j];
            var p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === 'affine') acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(var i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $596a74c8a0293328$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$596a74c8a0293328$var$BaseCurve.BasePoint = $596a74c8a0293328$var$BasePoint;
$596a74c8a0293328$var$BasePoint.prototype.eq = function eq() {
    throw new Error('Not implemented');
};
$596a74c8a0293328$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$596a74c8a0293328$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $596a74c8a0293328$var$utils.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $596a74c8a0293328$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $596a74c8a0293328$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error('Unknown point format');
};
$596a74c8a0293328$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$596a74c8a0293328$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray('be', len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray('be', len));
};
$596a74c8a0293328$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $596a74c8a0293328$var$utils.encode(this._encode(compact), enc);
};
$596a74c8a0293328$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$596a74c8a0293328$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$596a74c8a0293328$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$596a74c8a0293328$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$596a74c8a0293328$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$596a74c8a0293328$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("o1Os9", function(module, exports) {
'use strict';

var $g9z1u = parcelRequire("g9z1u");

var $6nTxf = parcelRequire("6nTxf");

var $61SlE = parcelRequire("61SlE");

var $lyUaN = parcelRequire("lyUaN");
var $0483a5fb6d44f11e$var$Base = $g9z1u.base;
var $0483a5fb6d44f11e$var$assert = $6nTxf.utils.assert;
function $0483a5fb6d44f11e$var$ShortCurve(conf) {
    $0483a5fb6d44f11e$var$Base.call(this, 'short', conf);
    this.a = new $61SlE(conf.a, 16).toRed(this.red);
    this.b = new $61SlE(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$lyUaN($0483a5fb6d44f11e$var$ShortCurve, $0483a5fb6d44f11e$var$Base);
module.exports = $0483a5fb6d44f11e$var$ShortCurve;
$0483a5fb6d44f11e$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $61SlE(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $61SlE(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $0483a5fb6d44f11e$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $61SlE(vec.a, 16),
            b: new $61SlE(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$0483a5fb6d44f11e$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $61SlE.mont(num);
    var tinv = new $61SlE(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $61SlE(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$0483a5fb6d44f11e$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $61SlE(1);
    var y1 = new $61SlE(0);
    var x2 = new $61SlE(0);
    var y2 = new $61SlE(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$0483a5fb6d44f11e$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$0483a5fb6d44f11e$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $61SlE(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$0483a5fb6d44f11e$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$0483a5fb6d44f11e$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $0483a5fb6d44f11e$var$Point(curve, x, y, isRed) {
    $0483a5fb6d44f11e$var$Base.BasePoint.call(this, curve, 'affine');
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $61SlE(x, 16);
        this.y = new $61SlE(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$lyUaN($0483a5fb6d44f11e$var$Point, $0483a5fb6d44f11e$var$Base.BasePoint);
$0483a5fb6d44f11e$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $0483a5fb6d44f11e$var$Point(this, x, y, isRed);
};
$0483a5fb6d44f11e$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $0483a5fb6d44f11e$var$Point.fromJSON(this, obj, red);
};
$0483a5fb6d44f11e$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$0483a5fb6d44f11e$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$0483a5fb6d44f11e$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === 'string') obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$0483a5fb6d44f11e$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};
$0483a5fb6d44f11e$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$0483a5fb6d44f11e$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$0483a5fb6d44f11e$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$0483a5fb6d44f11e$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$0483a5fb6d44f11e$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$0483a5fb6d44f11e$var$Point.prototype.mul = function mul(k) {
    k = new $61SlE(k, 16);
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$0483a5fb6d44f11e$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$0483a5fb6d44f11e$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$0483a5fb6d44f11e$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$0483a5fb6d44f11e$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$0483a5fb6d44f11e$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $0483a5fb6d44f11e$var$JPoint(curve, x, y, z) {
    $0483a5fb6d44f11e$var$Base.BasePoint.call(this, curve, 'jacobian');
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $61SlE(0);
    } else {
        this.x = new $61SlE(x, 16);
        this.y = new $61SlE(y, 16);
        this.z = new $61SlE(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$lyUaN($0483a5fb6d44f11e$var$JPoint, $0483a5fb6d44f11e$var$Base.BasePoint);
$0483a5fb6d44f11e$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $0483a5fb6d44f11e$var$JPoint(this, x, y, z);
};
$0483a5fb6d44f11e$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$0483a5fb6d44f11e$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$0483a5fb6d44f11e$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$0483a5fb6d44f11e$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$0483a5fb6d44f11e$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(var i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(var i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$0483a5fb6d44f11e$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$0483a5fb6d44f11e$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$0483a5fb6d44f11e$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$0483a5fb6d44f11e$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$0483a5fb6d44f11e$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$0483a5fb6d44f11e$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $61SlE(k, kbase);
    return this.curve._wnafMul(this, k);
};
$0483a5fb6d44f11e$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === 'affine') return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$0483a5fb6d44f11e$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
    return false;
};
$0483a5fb6d44f11e$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC JPoint Infinity>';
    return '<EC JPoint x: ' + this.x.toString(16, 2) + ' y: ' + this.y.toString(16, 2) + ' z: ' + this.z.toString(16, 2) + '>';
};
$0483a5fb6d44f11e$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("hap7r", function(module, exports) {
'use strict';

var $g9z1u = parcelRequire("g9z1u");

var $61SlE = parcelRequire("61SlE");

var $lyUaN = parcelRequire("lyUaN");
var $c7f6daee520e45ff$var$Base = $g9z1u.base;

var $6nTxf = parcelRequire("6nTxf");
var $c7f6daee520e45ff$var$utils = $6nTxf.utils;
function $c7f6daee520e45ff$var$MontCurve(conf) {
    $c7f6daee520e45ff$var$Base.call(this, 'mont', conf);
    this.a = new $61SlE(conf.a, 16).toRed(this.red);
    this.b = new $61SlE(conf.b, 16).toRed(this.red);
    this.i4 = new $61SlE(4).toRed(this.red).redInvm();
    this.two = new $61SlE(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$lyUaN($c7f6daee520e45ff$var$MontCurve, $c7f6daee520e45ff$var$Base);
module.exports = $c7f6daee520e45ff$var$MontCurve;
$c7f6daee520e45ff$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $c7f6daee520e45ff$var$Point(curve, x, z) {
    $c7f6daee520e45ff$var$Base.BasePoint.call(this, curve, 'projective');
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $61SlE(x, 16);
        this.z = new $61SlE(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$lyUaN($c7f6daee520e45ff$var$Point, $c7f6daee520e45ff$var$Base.BasePoint);
$c7f6daee520e45ff$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($c7f6daee520e45ff$var$utils.toArray(bytes, enc), 1);
};
$c7f6daee520e45ff$var$MontCurve.prototype.point = function point(x, z) {
    return new $c7f6daee520e45ff$var$Point(this, x, z);
};
$c7f6daee520e45ff$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $c7f6daee520e45ff$var$Point.fromJSON(this, obj);
};
$c7f6daee520e45ff$var$Point.prototype.precompute = function precompute() {
// No-op
};
$c7f6daee520e45ff$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray('be', this.curve.p.byteLength());
};
$c7f6daee520e45ff$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $c7f6daee520e45ff$var$Point(curve, obj[0], obj[1] || curve.one);
};
$c7f6daee520e45ff$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$c7f6daee520e45ff$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$c7f6daee520e45ff$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$c7f6daee520e45ff$var$Point.prototype.add = function add() {
    throw new Error('Not supported on Montgomery curve');
};
$c7f6daee520e45ff$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$c7f6daee520e45ff$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$c7f6daee520e45ff$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$c7f6daee520e45ff$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$c7f6daee520e45ff$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$c7f6daee520e45ff$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$c7f6daee520e45ff$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("3Oe4N", function(module, exports) {
'use strict';

var $g9z1u = parcelRequire("g9z1u");

var $6nTxf = parcelRequire("6nTxf");

var $61SlE = parcelRequire("61SlE");

var $lyUaN = parcelRequire("lyUaN");
var $2c60f5dbd111f643$var$Base = $g9z1u.base;
var $2c60f5dbd111f643$var$assert = $6nTxf.utils.assert;
function $2c60f5dbd111f643$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $2c60f5dbd111f643$var$Base.call(this, 'edwards', conf);
    this.a = new $61SlE(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $61SlE(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $61SlE(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $2c60f5dbd111f643$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$lyUaN($2c60f5dbd111f643$var$EdwardsCurve, $2c60f5dbd111f643$var$Base);
module.exports = $2c60f5dbd111f643$var$EdwardsCurve;
$2c60f5dbd111f643$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$2c60f5dbd111f643$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$2c60f5dbd111f643$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$2c60f5dbd111f643$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $61SlE(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$2c60f5dbd111f643$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $61SlE(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - 1) / (d y^2 + 1)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.one);
    var rhs = y2.redMul(this.d).redAdd(this.one);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error('invalid point');
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error('invalid point');
    if (x.isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$2c60f5dbd111f643$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $2c60f5dbd111f643$var$Point(curve, x, y, z, t) {
    $2c60f5dbd111f643$var$Base.BasePoint.call(this, curve, 'projective');
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $61SlE(x, 16);
        this.y = new $61SlE(y, 16);
        this.z = z ? new $61SlE(z, 16) : this.curve.one;
        this.t = t && new $61SlE(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$lyUaN($2c60f5dbd111f643$var$Point, $2c60f5dbd111f643$var$Base.BasePoint);
$2c60f5dbd111f643$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $2c60f5dbd111f643$var$Point.fromJSON(this, obj);
};
$2c60f5dbd111f643$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $2c60f5dbd111f643$var$Point(this, x, y, z, t);
};
$2c60f5dbd111f643$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $2c60f5dbd111f643$var$Point(curve, obj[0], obj[1], obj[2]);
};
$2c60f5dbd111f643$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$2c60f5dbd111f643$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && this.y.cmp(this.z) === 0;
};
$2c60f5dbd111f643$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$2c60f5dbd111f643$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    if (this.curve.twisted) {
        // E = a * C
        var e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            var h = this.z.redSqr();
            // J = F - 2 * H
            var j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        var e = c.redAdd(d);
        // H = (c * Z1)^2
        var h = this.curve._mulC(this.c.redMul(this.z)).redSqr();
        // J = E - 2 * H
        var j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$2c60f5dbd111f643$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$2c60f5dbd111f643$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$2c60f5dbd111f643$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$2c60f5dbd111f643$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$2c60f5dbd111f643$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$2c60f5dbd111f643$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$2c60f5dbd111f643$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$2c60f5dbd111f643$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$2c60f5dbd111f643$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$2c60f5dbd111f643$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$2c60f5dbd111f643$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$2c60f5dbd111f643$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$2c60f5dbd111f643$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
    return false;
};
// Compatibility with BaseCurve
$2c60f5dbd111f643$var$Point.prototype.toP = $2c60f5dbd111f643$var$Point.prototype.normalize;
$2c60f5dbd111f643$var$Point.prototype.mixedAdd = $2c60f5dbd111f643$var$Point.prototype.add;

});


parcelRegister("8XT4W", function(module, exports) {
'use strict';
var $686e8eebd7f02f1e$var$curves = module.exports;

var $1b2Pi = parcelRequire("1b2Pi");

var $6nTxf = parcelRequire("6nTxf");
var $686e8eebd7f02f1e$var$assert = $6nTxf.utils.assert;
function $686e8eebd7f02f1e$var$PresetCurve(options) {
    if (options.type === 'short') this.curve = new $6nTxf.curve.short(options);
    else if (options.type === 'edwards') this.curve = new $6nTxf.curve.edwards(options);
    else this.curve = new $6nTxf.curve.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $686e8eebd7f02f1e$var$assert(this.g.validate(), 'Invalid curve');
    $686e8eebd7f02f1e$var$assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
$686e8eebd7f02f1e$var$curves.PresetCurve = $686e8eebd7f02f1e$var$PresetCurve;
function $686e8eebd7f02f1e$var$defineCurve(name, options) {
    Object.defineProperty($686e8eebd7f02f1e$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $686e8eebd7f02f1e$var$PresetCurve(options);
            Object.defineProperty($686e8eebd7f02f1e$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$686e8eebd7f02f1e$var$defineCurve('p192', {
    type: 'short',
    prime: 'p192',
    p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
    b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
    n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
    hash: $1b2Pi.sha256,
    gRed: false,
    g: [
        '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
        '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
    ]
});
$686e8eebd7f02f1e$var$defineCurve('p224', {
    type: 'short',
    prime: 'p224',
    p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
    b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
    n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
    hash: $1b2Pi.sha256,
    gRed: false,
    g: [
        'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
        'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
    ]
});
$686e8eebd7f02f1e$var$defineCurve('p256', {
    type: 'short',
    prime: null,
    p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
    a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
    b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
    n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
    hash: $1b2Pi.sha256,
    gRed: false,
    g: [
        '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
        '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
    ]
});
$686e8eebd7f02f1e$var$defineCurve('p384', {
    type: 'short',
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $1b2Pi.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$686e8eebd7f02f1e$var$defineCurve('p521', {
    type: 'short',
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $1b2Pi.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$686e8eebd7f02f1e$var$defineCurve('curve25519', {
    type: 'mont',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '76d06',
    b: '1',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $1b2Pi.sha256,
    gRed: false,
    g: [
        '9'
    ]
});
$686e8eebd7f02f1e$var$defineCurve('ed25519', {
    type: 'edwards',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '-1',
    c: '1',
    // -121665 * (121666^(-1)) (mod P)
    d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $1b2Pi.sha256,
    gRed: false,
    g: [
        '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',
        // 4/5
        '6666666666666666666666666666666666666666666666666666666666666658'
    ]
});
var $686e8eebd7f02f1e$var$pre;

try {
    $686e8eebd7f02f1e$var$pre = (parcelRequire("93PGC"));
} catch (e) {
    $686e8eebd7f02f1e$var$pre = undefined;
}
$686e8eebd7f02f1e$var$defineCurve('secp256k1', {
    type: 'short',
    prime: 'k256',
    p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
    a: '0',
    b: '7',
    n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
    h: '1',
    hash: $1b2Pi.sha256,
    // Precomputed endomorphism
    beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
    lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
    basis: [
        {
            a: '3086d221a7d46bcde86c90e49284eb15',
            b: '-e4437ed6010e88286f547fa90abfe4c3'
        },
        {
            a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
            b: '3086d221a7d46bcde86c90e49284eb15'
        }
    ],
    gRed: false,
    g: [
        '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
        '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
        $686e8eebd7f02f1e$var$pre
    ]
});

});
parcelRegister("1b2Pi", function(module, exports) {
var $0db902c75b4d9429$var$hash = module.exports;

$0db902c75b4d9429$var$hash.utils = (parcelRequire("5m5RF"));

$0db902c75b4d9429$var$hash.common = (parcelRequire("ap5FC"));

$0db902c75b4d9429$var$hash.sha = (parcelRequire("4TZSF"));

$0db902c75b4d9429$var$hash.ripemd = (parcelRequire("8pLmN"));

$0db902c75b4d9429$var$hash.hmac = (parcelRequire("bVEBB"));
// Proxy hash functions to the main object
$0db902c75b4d9429$var$hash.sha1 = $0db902c75b4d9429$var$hash.sha.sha1;
$0db902c75b4d9429$var$hash.sha256 = $0db902c75b4d9429$var$hash.sha.sha256;
$0db902c75b4d9429$var$hash.sha224 = $0db902c75b4d9429$var$hash.sha.sha224;
$0db902c75b4d9429$var$hash.sha384 = $0db902c75b4d9429$var$hash.sha.sha384;
$0db902c75b4d9429$var$hash.sha512 = $0db902c75b4d9429$var$hash.sha.sha512;
$0db902c75b4d9429$var$hash.ripemd160 = $0db902c75b4d9429$var$hash.ripemd.ripemd160;

});
parcelRegister("5m5RF", function(module, exports) {

$parcel$export(module.exports, "inherits", () => $3e638e6515e2acb0$export$69f1b2dcda23c5f8, (v) => $3e638e6515e2acb0$export$69f1b2dcda23c5f8 = v);
$parcel$export(module.exports, "toArray", () => $3e638e6515e2acb0$export$45b10814cc054894, (v) => $3e638e6515e2acb0$export$45b10814cc054894 = v);
$parcel$export(module.exports, "toHex", () => $3e638e6515e2acb0$export$7ea66e3774a60b67, (v) => $3e638e6515e2acb0$export$7ea66e3774a60b67 = v);
$parcel$export(module.exports, "htonl", () => $3e638e6515e2acb0$export$34a52f00f601f6f1, (v) => $3e638e6515e2acb0$export$34a52f00f601f6f1 = v);
$parcel$export(module.exports, "toHex32", () => $3e638e6515e2acb0$export$812b0cbd5e8a72ab, (v) => $3e638e6515e2acb0$export$812b0cbd5e8a72ab = v);
$parcel$export(module.exports, "zero2", () => $3e638e6515e2acb0$export$f24f9e11d63bb314, (v) => $3e638e6515e2acb0$export$f24f9e11d63bb314 = v);
$parcel$export(module.exports, "zero8", () => $3e638e6515e2acb0$export$b71357c7e07ca1f1, (v) => $3e638e6515e2acb0$export$b71357c7e07ca1f1 = v);
$parcel$export(module.exports, "join32", () => $3e638e6515e2acb0$export$2e58a4b541fdcbe8, (v) => $3e638e6515e2acb0$export$2e58a4b541fdcbe8 = v);
$parcel$export(module.exports, "split32", () => $3e638e6515e2acb0$export$183b950bde9faab8, (v) => $3e638e6515e2acb0$export$183b950bde9faab8 = v);
$parcel$export(module.exports, "rotr32", () => $3e638e6515e2acb0$export$4785c77169fea59e, (v) => $3e638e6515e2acb0$export$4785c77169fea59e = v);
$parcel$export(module.exports, "rotl32", () => $3e638e6515e2acb0$export$242a185dfcffac5b, (v) => $3e638e6515e2acb0$export$242a185dfcffac5b = v);
$parcel$export(module.exports, "sum32", () => $3e638e6515e2acb0$export$58c04ae0ae31877d, (v) => $3e638e6515e2acb0$export$58c04ae0ae31877d = v);
$parcel$export(module.exports, "sum32_3", () => $3e638e6515e2acb0$export$d058ca695f8c6f11, (v) => $3e638e6515e2acb0$export$d058ca695f8c6f11 = v);
$parcel$export(module.exports, "sum32_4", () => $3e638e6515e2acb0$export$a1efd7fc3e986367, (v) => $3e638e6515e2acb0$export$a1efd7fc3e986367 = v);
$parcel$export(module.exports, "sum32_5", () => $3e638e6515e2acb0$export$bbfea4a2b5abaab4, (v) => $3e638e6515e2acb0$export$bbfea4a2b5abaab4 = v);
$parcel$export(module.exports, "sum64", () => $3e638e6515e2acb0$export$97ad4afc7de86152, (v) => $3e638e6515e2acb0$export$97ad4afc7de86152 = v);
$parcel$export(module.exports, "sum64_hi", () => $3e638e6515e2acb0$export$ce4673d9a79f6a4b, (v) => $3e638e6515e2acb0$export$ce4673d9a79f6a4b = v);
$parcel$export(module.exports, "sum64_lo", () => $3e638e6515e2acb0$export$786cc99fc6eedc0b, (v) => $3e638e6515e2acb0$export$786cc99fc6eedc0b = v);
$parcel$export(module.exports, "sum64_4_hi", () => $3e638e6515e2acb0$export$45c59b9a1848dd0, (v) => $3e638e6515e2acb0$export$45c59b9a1848dd0 = v);
$parcel$export(module.exports, "sum64_4_lo", () => $3e638e6515e2acb0$export$50d8f613e76d3034, (v) => $3e638e6515e2acb0$export$50d8f613e76d3034 = v);
$parcel$export(module.exports, "sum64_5_hi", () => $3e638e6515e2acb0$export$b8e83683c60ee162, (v) => $3e638e6515e2acb0$export$b8e83683c60ee162 = v);
$parcel$export(module.exports, "sum64_5_lo", () => $3e638e6515e2acb0$export$aeeb51790d1bcc4a, (v) => $3e638e6515e2acb0$export$aeeb51790d1bcc4a = v);
$parcel$export(module.exports, "rotr64_hi", () => $3e638e6515e2acb0$export$bb7c616f719ad9c, (v) => $3e638e6515e2acb0$export$bb7c616f719ad9c = v);
$parcel$export(module.exports, "rotr64_lo", () => $3e638e6515e2acb0$export$4d63290824f9d7df, (v) => $3e638e6515e2acb0$export$4d63290824f9d7df = v);
$parcel$export(module.exports, "shr64_hi", () => $3e638e6515e2acb0$export$2f64ceb90ef28ea1, (v) => $3e638e6515e2acb0$export$2f64ceb90ef28ea1 = v);
$parcel$export(module.exports, "shr64_lo", () => $3e638e6515e2acb0$export$8d2089d465f6d10d, (v) => $3e638e6515e2acb0$export$8d2089d465f6d10d = v);
var $3e638e6515e2acb0$export$69f1b2dcda23c5f8;
var $3e638e6515e2acb0$export$45b10814cc054894;
var $3e638e6515e2acb0$export$7ea66e3774a60b67;
var $3e638e6515e2acb0$export$34a52f00f601f6f1;
var $3e638e6515e2acb0$export$812b0cbd5e8a72ab;
var $3e638e6515e2acb0$export$f24f9e11d63bb314;
var $3e638e6515e2acb0$export$b71357c7e07ca1f1;
var $3e638e6515e2acb0$export$2e58a4b541fdcbe8;
var $3e638e6515e2acb0$export$183b950bde9faab8;
var $3e638e6515e2acb0$export$4785c77169fea59e;
var $3e638e6515e2acb0$export$242a185dfcffac5b;
var $3e638e6515e2acb0$export$58c04ae0ae31877d;
var $3e638e6515e2acb0$export$d058ca695f8c6f11;
var $3e638e6515e2acb0$export$a1efd7fc3e986367;
var $3e638e6515e2acb0$export$bbfea4a2b5abaab4;
var $3e638e6515e2acb0$export$97ad4afc7de86152;
var $3e638e6515e2acb0$export$ce4673d9a79f6a4b;
var $3e638e6515e2acb0$export$786cc99fc6eedc0b;
var $3e638e6515e2acb0$export$45c59b9a1848dd0;
var $3e638e6515e2acb0$export$50d8f613e76d3034;
var $3e638e6515e2acb0$export$b8e83683c60ee162;
var $3e638e6515e2acb0$export$aeeb51790d1bcc4a;
var $3e638e6515e2acb0$export$bb7c616f719ad9c;
var $3e638e6515e2acb0$export$4d63290824f9d7df;
var $3e638e6515e2acb0$export$2f64ceb90ef28ea1;
var $3e638e6515e2acb0$export$8d2089d465f6d10d;
'use strict';

var $aOIMZ = parcelRequire("aOIMZ");

var $lyUaN = parcelRequire("lyUaN");
$3e638e6515e2acb0$export$69f1b2dcda23c5f8 = $lyUaN;
function $3e638e6515e2acb0$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === 'string') {
        if (!enc) for(var i = 0; i < msg.length; i++){
            var c = msg.charCodeAt(i);
            var hi = c >> 8;
            var lo = c & 0xff;
            if (hi) res.push(hi, lo);
            else res.push(lo);
        }
        else if (enc === 'hex') {
            msg = msg.replace(/[^a-z0-9]+/ig, '');
            if (msg.length % 2 !== 0) msg = '0' + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$3e638e6515e2acb0$export$45b10814cc054894 = $3e638e6515e2acb0$var$toArray;
function $3e638e6515e2acb0$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $3e638e6515e2acb0$var$zero2(msg[i].toString(16));
    return res;
}
$3e638e6515e2acb0$export$7ea66e3774a60b67 = $3e638e6515e2acb0$var$toHex;
function $3e638e6515e2acb0$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$3e638e6515e2acb0$export$34a52f00f601f6f1 = $3e638e6515e2acb0$var$htonl;
function $3e638e6515e2acb0$var$toHex32(msg, endian) {
    var res = '';
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === 'little') w = $3e638e6515e2acb0$var$htonl(w);
        res += $3e638e6515e2acb0$var$zero8(w.toString(16));
    }
    return res;
}
$3e638e6515e2acb0$export$812b0cbd5e8a72ab = $3e638e6515e2acb0$var$toHex32;
function $3e638e6515e2acb0$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$3e638e6515e2acb0$export$f24f9e11d63bb314 = $3e638e6515e2acb0$var$zero2;
function $3e638e6515e2acb0$var$zero8(word) {
    if (word.length === 7) return '0' + word;
    else if (word.length === 6) return '00' + word;
    else if (word.length === 5) return '000' + word;
    else if (word.length === 4) return '0000' + word;
    else if (word.length === 3) return '00000' + word;
    else if (word.length === 2) return '000000' + word;
    else if (word.length === 1) return '0000000' + word;
    else return word;
}
$3e638e6515e2acb0$export$b71357c7e07ca1f1 = $3e638e6515e2acb0$var$zero8;
function $3e638e6515e2acb0$var$join32(msg, start, end, endian) {
    var len = end - start;
    $aOIMZ(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === 'big') w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$3e638e6515e2acb0$export$2e58a4b541fdcbe8 = $3e638e6515e2acb0$var$join32;
function $3e638e6515e2acb0$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === 'big') {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$3e638e6515e2acb0$export$183b950bde9faab8 = $3e638e6515e2acb0$var$split32;
function $3e638e6515e2acb0$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$3e638e6515e2acb0$export$4785c77169fea59e = $3e638e6515e2acb0$var$rotr32;
function $3e638e6515e2acb0$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$3e638e6515e2acb0$export$242a185dfcffac5b = $3e638e6515e2acb0$var$rotl32;
function $3e638e6515e2acb0$var$sum32(a, b) {
    return a + b >>> 0;
}
$3e638e6515e2acb0$export$58c04ae0ae31877d = $3e638e6515e2acb0$var$sum32;
function $3e638e6515e2acb0$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$3e638e6515e2acb0$export$d058ca695f8c6f11 = $3e638e6515e2acb0$var$sum32_3;
function $3e638e6515e2acb0$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$3e638e6515e2acb0$export$a1efd7fc3e986367 = $3e638e6515e2acb0$var$sum32_4;
function $3e638e6515e2acb0$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$3e638e6515e2acb0$export$bbfea4a2b5abaab4 = $3e638e6515e2acb0$var$sum32_5;
function $3e638e6515e2acb0$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$3e638e6515e2acb0$export$97ad4afc7de86152 = $3e638e6515e2acb0$var$sum64;
function $3e638e6515e2acb0$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$3e638e6515e2acb0$export$ce4673d9a79f6a4b = $3e638e6515e2acb0$var$sum64_hi;
function $3e638e6515e2acb0$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$3e638e6515e2acb0$export$786cc99fc6eedc0b = $3e638e6515e2acb0$var$sum64_lo;
function $3e638e6515e2acb0$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$3e638e6515e2acb0$export$45c59b9a1848dd0 = $3e638e6515e2acb0$var$sum64_4_hi;
function $3e638e6515e2acb0$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$3e638e6515e2acb0$export$50d8f613e76d3034 = $3e638e6515e2acb0$var$sum64_4_lo;
function $3e638e6515e2acb0$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$3e638e6515e2acb0$export$b8e83683c60ee162 = $3e638e6515e2acb0$var$sum64_5_hi;
function $3e638e6515e2acb0$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$3e638e6515e2acb0$export$aeeb51790d1bcc4a = $3e638e6515e2acb0$var$sum64_5_lo;
function $3e638e6515e2acb0$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$3e638e6515e2acb0$export$bb7c616f719ad9c = $3e638e6515e2acb0$var$rotr64_hi;
function $3e638e6515e2acb0$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$3e638e6515e2acb0$export$4d63290824f9d7df = $3e638e6515e2acb0$var$rotr64_lo;
function $3e638e6515e2acb0$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$3e638e6515e2acb0$export$2f64ceb90ef28ea1 = $3e638e6515e2acb0$var$shr64_hi;
function $3e638e6515e2acb0$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$3e638e6515e2acb0$export$8d2089d465f6d10d = $3e638e6515e2acb0$var$shr64_lo;

});

parcelRegister("ap5FC", function(module, exports) {

$parcel$export(module.exports, "BlockHash", () => $7930a331e2b8bb39$export$8687658379b577e6, (v) => $7930a331e2b8bb39$export$8687658379b577e6 = v);
var $7930a331e2b8bb39$export$8687658379b577e6;
'use strict';

var $5m5RF = parcelRequire("5m5RF");

var $aOIMZ = parcelRequire("aOIMZ");
function $7930a331e2b8bb39$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = 'big';
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$7930a331e2b8bb39$export$8687658379b577e6 = $7930a331e2b8bb39$var$BlockHash;
$7930a331e2b8bb39$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $5m5RF.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $5m5RF.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$7930a331e2b8bb39$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $aOIMZ(this.pending === null);
    return this._digest(enc);
};
$7930a331e2b8bb39$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === 'big') {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("4TZSF", function(module, exports) {

$parcel$export(module.exports, "sha1", () => $391c4cb3e26fcd89$export$5091bdda49ba90f5, (v) => $391c4cb3e26fcd89$export$5091bdda49ba90f5 = v);
$parcel$export(module.exports, "sha224", () => $391c4cb3e26fcd89$export$97b70509d4e397ea, (v) => $391c4cb3e26fcd89$export$97b70509d4e397ea = v);
$parcel$export(module.exports, "sha256", () => $391c4cb3e26fcd89$export$bced8d2aada2d1c9, (v) => $391c4cb3e26fcd89$export$bced8d2aada2d1c9 = v);
$parcel$export(module.exports, "sha384", () => $391c4cb3e26fcd89$export$612d47d55dedde45, (v) => $391c4cb3e26fcd89$export$612d47d55dedde45 = v);
$parcel$export(module.exports, "sha512", () => $391c4cb3e26fcd89$export$a888d2532e6dc7bb, (v) => $391c4cb3e26fcd89$export$a888d2532e6dc7bb = v);
var $391c4cb3e26fcd89$export$5091bdda49ba90f5;
var $391c4cb3e26fcd89$export$97b70509d4e397ea;
var $391c4cb3e26fcd89$export$bced8d2aada2d1c9;
var $391c4cb3e26fcd89$export$612d47d55dedde45;
var $391c4cb3e26fcd89$export$a888d2532e6dc7bb;
'use strict';

$391c4cb3e26fcd89$export$5091bdda49ba90f5 = (parcelRequire("1YLg9"));

$391c4cb3e26fcd89$export$97b70509d4e397ea = (parcelRequire("fTyPw"));

$391c4cb3e26fcd89$export$bced8d2aada2d1c9 = (parcelRequire("kjGwI"));

$391c4cb3e26fcd89$export$612d47d55dedde45 = (parcelRequire("fVCT0"));

$391c4cb3e26fcd89$export$a888d2532e6dc7bb = (parcelRequire("hpDZE"));

});
parcelRegister("1YLg9", function(module, exports) {
'use strict';

var $5m5RF = parcelRequire("5m5RF");

var $ap5FC = parcelRequire("ap5FC");

var $5pCtI = parcelRequire("5pCtI");
var $17100dcd25bebb06$var$rotl32 = $5m5RF.rotl32;
var $17100dcd25bebb06$var$sum32 = $5m5RF.sum32;
var $17100dcd25bebb06$var$sum32_5 = $5m5RF.sum32_5;
var $17100dcd25bebb06$var$ft_1 = $5pCtI.ft_1;
var $17100dcd25bebb06$var$BlockHash = $ap5FC.BlockHash;
var $17100dcd25bebb06$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $17100dcd25bebb06$var$SHA1() {
    if (!(this instanceof $17100dcd25bebb06$var$SHA1)) return new $17100dcd25bebb06$var$SHA1();
    $17100dcd25bebb06$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$5m5RF.inherits($17100dcd25bebb06$var$SHA1, $17100dcd25bebb06$var$BlockHash);
module.exports = $17100dcd25bebb06$var$SHA1;
$17100dcd25bebb06$var$SHA1.blockSize = 512;
$17100dcd25bebb06$var$SHA1.outSize = 160;
$17100dcd25bebb06$var$SHA1.hmacStrength = 80;
$17100dcd25bebb06$var$SHA1.padLength = 64;
$17100dcd25bebb06$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $17100dcd25bebb06$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $17100dcd25bebb06$var$sum32_5($17100dcd25bebb06$var$rotl32(a, 5), $17100dcd25bebb06$var$ft_1(s, b, c, d), e, W[i], $17100dcd25bebb06$var$sha1_K[s]);
        e = d;
        d = c;
        c = $17100dcd25bebb06$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $17100dcd25bebb06$var$sum32(this.h[0], a);
    this.h[1] = $17100dcd25bebb06$var$sum32(this.h[1], b);
    this.h[2] = $17100dcd25bebb06$var$sum32(this.h[2], c);
    this.h[3] = $17100dcd25bebb06$var$sum32(this.h[3], d);
    this.h[4] = $17100dcd25bebb06$var$sum32(this.h[4], e);
};
$17100dcd25bebb06$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $5m5RF.toHex32(this.h, 'big');
    else return $5m5RF.split32(this.h, 'big');
};

});
parcelRegister("5pCtI", function(module, exports) {

$parcel$export(module.exports, "ft_1", () => $3f0d228f2ba28050$export$5a92649d7ddb9f63, (v) => $3f0d228f2ba28050$export$5a92649d7ddb9f63 = v);
$parcel$export(module.exports, "ch32", () => $3f0d228f2ba28050$export$c6d0d020c3a6269, (v) => $3f0d228f2ba28050$export$c6d0d020c3a6269 = v);
$parcel$export(module.exports, "maj32", () => $3f0d228f2ba28050$export$eb90c27fca05f956, (v) => $3f0d228f2ba28050$export$eb90c27fca05f956 = v);
$parcel$export(module.exports, "s0_256", () => $3f0d228f2ba28050$export$14a4a98e063b1999, (v) => $3f0d228f2ba28050$export$14a4a98e063b1999 = v);
$parcel$export(module.exports, "s1_256", () => $3f0d228f2ba28050$export$d20cecfa1564c686, (v) => $3f0d228f2ba28050$export$d20cecfa1564c686 = v);
$parcel$export(module.exports, "g0_256", () => $3f0d228f2ba28050$export$44fd472a12fc6db, (v) => $3f0d228f2ba28050$export$44fd472a12fc6db = v);
$parcel$export(module.exports, "g1_256", () => $3f0d228f2ba28050$export$1ed238bb6ea1dd47, (v) => $3f0d228f2ba28050$export$1ed238bb6ea1dd47 = v);
var $3f0d228f2ba28050$export$5a92649d7ddb9f63;
var $3f0d228f2ba28050$export$c6d0d020c3a6269;
var $3f0d228f2ba28050$export$eb90c27fca05f956;
var $3f0d228f2ba28050$export$cc992891a14496a1;
var $3f0d228f2ba28050$export$14a4a98e063b1999;
var $3f0d228f2ba28050$export$d20cecfa1564c686;
var $3f0d228f2ba28050$export$44fd472a12fc6db;
var $3f0d228f2ba28050$export$1ed238bb6ea1dd47;
'use strict';

var $5m5RF = parcelRequire("5m5RF");
var $3f0d228f2ba28050$var$rotr32 = $5m5RF.rotr32;
function $3f0d228f2ba28050$var$ft_1(s, x, y, z) {
    if (s === 0) return $3f0d228f2ba28050$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $3f0d228f2ba28050$var$p32(x, y, z);
    if (s === 2) return $3f0d228f2ba28050$var$maj32(x, y, z);
}
$3f0d228f2ba28050$export$5a92649d7ddb9f63 = $3f0d228f2ba28050$var$ft_1;
function $3f0d228f2ba28050$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$3f0d228f2ba28050$export$c6d0d020c3a6269 = $3f0d228f2ba28050$var$ch32;
function $3f0d228f2ba28050$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$3f0d228f2ba28050$export$eb90c27fca05f956 = $3f0d228f2ba28050$var$maj32;
function $3f0d228f2ba28050$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$3f0d228f2ba28050$export$cc992891a14496a1 = $3f0d228f2ba28050$var$p32;
function $3f0d228f2ba28050$var$s0_256(x) {
    return $3f0d228f2ba28050$var$rotr32(x, 2) ^ $3f0d228f2ba28050$var$rotr32(x, 13) ^ $3f0d228f2ba28050$var$rotr32(x, 22);
}
$3f0d228f2ba28050$export$14a4a98e063b1999 = $3f0d228f2ba28050$var$s0_256;
function $3f0d228f2ba28050$var$s1_256(x) {
    return $3f0d228f2ba28050$var$rotr32(x, 6) ^ $3f0d228f2ba28050$var$rotr32(x, 11) ^ $3f0d228f2ba28050$var$rotr32(x, 25);
}
$3f0d228f2ba28050$export$d20cecfa1564c686 = $3f0d228f2ba28050$var$s1_256;
function $3f0d228f2ba28050$var$g0_256(x) {
    return $3f0d228f2ba28050$var$rotr32(x, 7) ^ $3f0d228f2ba28050$var$rotr32(x, 18) ^ x >>> 3;
}
$3f0d228f2ba28050$export$44fd472a12fc6db = $3f0d228f2ba28050$var$g0_256;
function $3f0d228f2ba28050$var$g1_256(x) {
    return $3f0d228f2ba28050$var$rotr32(x, 17) ^ $3f0d228f2ba28050$var$rotr32(x, 19) ^ x >>> 10;
}
$3f0d228f2ba28050$export$1ed238bb6ea1dd47 = $3f0d228f2ba28050$var$g1_256;

});


parcelRegister("fTyPw", function(module, exports) {
'use strict';

var $5m5RF = parcelRequire("5m5RF");

var $kjGwI = parcelRequire("kjGwI");
function $b927028e6008aa5f$var$SHA224() {
    if (!(this instanceof $b927028e6008aa5f$var$SHA224)) return new $b927028e6008aa5f$var$SHA224();
    $kjGwI.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$5m5RF.inherits($b927028e6008aa5f$var$SHA224, $kjGwI);
module.exports = $b927028e6008aa5f$var$SHA224;
$b927028e6008aa5f$var$SHA224.blockSize = 512;
$b927028e6008aa5f$var$SHA224.outSize = 224;
$b927028e6008aa5f$var$SHA224.hmacStrength = 192;
$b927028e6008aa5f$var$SHA224.padLength = 64;
$b927028e6008aa5f$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === 'hex') return $5m5RF.toHex32(this.h.slice(0, 7), 'big');
    else return $5m5RF.split32(this.h.slice(0, 7), 'big');
};

});
parcelRegister("kjGwI", function(module, exports) {
'use strict';

var $5m5RF = parcelRequire("5m5RF");

var $ap5FC = parcelRequire("ap5FC");

var $5pCtI = parcelRequire("5pCtI");

var $aOIMZ = parcelRequire("aOIMZ");
var $eca691e7cafb0ba8$var$sum32 = $5m5RF.sum32;
var $eca691e7cafb0ba8$var$sum32_4 = $5m5RF.sum32_4;
var $eca691e7cafb0ba8$var$sum32_5 = $5m5RF.sum32_5;
var $eca691e7cafb0ba8$var$ch32 = $5pCtI.ch32;
var $eca691e7cafb0ba8$var$maj32 = $5pCtI.maj32;
var $eca691e7cafb0ba8$var$s0_256 = $5pCtI.s0_256;
var $eca691e7cafb0ba8$var$s1_256 = $5pCtI.s1_256;
var $eca691e7cafb0ba8$var$g0_256 = $5pCtI.g0_256;
var $eca691e7cafb0ba8$var$g1_256 = $5pCtI.g1_256;
var $eca691e7cafb0ba8$var$BlockHash = $ap5FC.BlockHash;
var $eca691e7cafb0ba8$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $eca691e7cafb0ba8$var$SHA256() {
    if (!(this instanceof $eca691e7cafb0ba8$var$SHA256)) return new $eca691e7cafb0ba8$var$SHA256();
    $eca691e7cafb0ba8$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $eca691e7cafb0ba8$var$sha256_K;
    this.W = new Array(64);
}
$5m5RF.inherits($eca691e7cafb0ba8$var$SHA256, $eca691e7cafb0ba8$var$BlockHash);
module.exports = $eca691e7cafb0ba8$var$SHA256;
$eca691e7cafb0ba8$var$SHA256.blockSize = 512;
$eca691e7cafb0ba8$var$SHA256.outSize = 256;
$eca691e7cafb0ba8$var$SHA256.hmacStrength = 192;
$eca691e7cafb0ba8$var$SHA256.padLength = 64;
$eca691e7cafb0ba8$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $eca691e7cafb0ba8$var$sum32_4($eca691e7cafb0ba8$var$g1_256(W[i - 2]), W[i - 7], $eca691e7cafb0ba8$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $aOIMZ(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $eca691e7cafb0ba8$var$sum32_5(h, $eca691e7cafb0ba8$var$s1_256(e), $eca691e7cafb0ba8$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $eca691e7cafb0ba8$var$sum32($eca691e7cafb0ba8$var$s0_256(a), $eca691e7cafb0ba8$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $eca691e7cafb0ba8$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $eca691e7cafb0ba8$var$sum32(T1, T2);
    }
    this.h[0] = $eca691e7cafb0ba8$var$sum32(this.h[0], a);
    this.h[1] = $eca691e7cafb0ba8$var$sum32(this.h[1], b);
    this.h[2] = $eca691e7cafb0ba8$var$sum32(this.h[2], c);
    this.h[3] = $eca691e7cafb0ba8$var$sum32(this.h[3], d);
    this.h[4] = $eca691e7cafb0ba8$var$sum32(this.h[4], e);
    this.h[5] = $eca691e7cafb0ba8$var$sum32(this.h[5], f);
    this.h[6] = $eca691e7cafb0ba8$var$sum32(this.h[6], g);
    this.h[7] = $eca691e7cafb0ba8$var$sum32(this.h[7], h);
};
$eca691e7cafb0ba8$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $5m5RF.toHex32(this.h, 'big');
    else return $5m5RF.split32(this.h, 'big');
};

});


parcelRegister("fVCT0", function(module, exports) {
'use strict';

var $5m5RF = parcelRequire("5m5RF");

var $hpDZE = parcelRequire("hpDZE");
function $b98a57e318409183$var$SHA384() {
    if (!(this instanceof $b98a57e318409183$var$SHA384)) return new $b98a57e318409183$var$SHA384();
    $hpDZE.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$5m5RF.inherits($b98a57e318409183$var$SHA384, $hpDZE);
module.exports = $b98a57e318409183$var$SHA384;
$b98a57e318409183$var$SHA384.blockSize = 1024;
$b98a57e318409183$var$SHA384.outSize = 384;
$b98a57e318409183$var$SHA384.hmacStrength = 192;
$b98a57e318409183$var$SHA384.padLength = 128;
$b98a57e318409183$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $5m5RF.toHex32(this.h.slice(0, 12), 'big');
    else return $5m5RF.split32(this.h.slice(0, 12), 'big');
};

});
parcelRegister("hpDZE", function(module, exports) {
'use strict';

var $5m5RF = parcelRequire("5m5RF");

var $ap5FC = parcelRequire("ap5FC");

var $aOIMZ = parcelRequire("aOIMZ");
var $cad3cb514f4c9f49$var$rotr64_hi = $5m5RF.rotr64_hi;
var $cad3cb514f4c9f49$var$rotr64_lo = $5m5RF.rotr64_lo;
var $cad3cb514f4c9f49$var$shr64_hi = $5m5RF.shr64_hi;
var $cad3cb514f4c9f49$var$shr64_lo = $5m5RF.shr64_lo;
var $cad3cb514f4c9f49$var$sum64 = $5m5RF.sum64;
var $cad3cb514f4c9f49$var$sum64_hi = $5m5RF.sum64_hi;
var $cad3cb514f4c9f49$var$sum64_lo = $5m5RF.sum64_lo;
var $cad3cb514f4c9f49$var$sum64_4_hi = $5m5RF.sum64_4_hi;
var $cad3cb514f4c9f49$var$sum64_4_lo = $5m5RF.sum64_4_lo;
var $cad3cb514f4c9f49$var$sum64_5_hi = $5m5RF.sum64_5_hi;
var $cad3cb514f4c9f49$var$sum64_5_lo = $5m5RF.sum64_5_lo;
var $cad3cb514f4c9f49$var$BlockHash = $ap5FC.BlockHash;
var $cad3cb514f4c9f49$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $cad3cb514f4c9f49$var$SHA512() {
    if (!(this instanceof $cad3cb514f4c9f49$var$SHA512)) return new $cad3cb514f4c9f49$var$SHA512();
    $cad3cb514f4c9f49$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $cad3cb514f4c9f49$var$sha512_K;
    this.W = new Array(160);
}
$5m5RF.inherits($cad3cb514f4c9f49$var$SHA512, $cad3cb514f4c9f49$var$BlockHash);
module.exports = $cad3cb514f4c9f49$var$SHA512;
$cad3cb514f4c9f49$var$SHA512.blockSize = 1024;
$cad3cb514f4c9f49$var$SHA512.outSize = 512;
$cad3cb514f4c9f49$var$SHA512.hmacStrength = 192;
$cad3cb514f4c9f49$var$SHA512.padLength = 128;
$cad3cb514f4c9f49$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $cad3cb514f4c9f49$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $cad3cb514f4c9f49$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $cad3cb514f4c9f49$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $cad3cb514f4c9f49$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $cad3cb514f4c9f49$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $cad3cb514f4c9f49$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$cad3cb514f4c9f49$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $aOIMZ(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $cad3cb514f4c9f49$var$s1_512_hi(eh, el);
        var c1_lo = $cad3cb514f4c9f49$var$s1_512_lo(eh, el);
        var c2_hi = $cad3cb514f4c9f49$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $cad3cb514f4c9f49$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $cad3cb514f4c9f49$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $cad3cb514f4c9f49$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $cad3cb514f4c9f49$var$s0_512_hi(ah, al);
        c0_lo = $cad3cb514f4c9f49$var$s0_512_lo(ah, al);
        c1_hi = $cad3cb514f4c9f49$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $cad3cb514f4c9f49$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $cad3cb514f4c9f49$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $cad3cb514f4c9f49$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $cad3cb514f4c9f49$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $cad3cb514f4c9f49$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $cad3cb514f4c9f49$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $cad3cb514f4c9f49$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $cad3cb514f4c9f49$var$sum64(this.h, 0, ah, al);
    $cad3cb514f4c9f49$var$sum64(this.h, 2, bh, bl);
    $cad3cb514f4c9f49$var$sum64(this.h, 4, ch, cl);
    $cad3cb514f4c9f49$var$sum64(this.h, 6, dh, dl);
    $cad3cb514f4c9f49$var$sum64(this.h, 8, eh, el);
    $cad3cb514f4c9f49$var$sum64(this.h, 10, fh, fl);
    $cad3cb514f4c9f49$var$sum64(this.h, 12, gh, gl);
    $cad3cb514f4c9f49$var$sum64(this.h, 14, hh, hl);
};
$cad3cb514f4c9f49$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $5m5RF.toHex32(this.h, 'big');
    else return $5m5RF.split32(this.h, 'big');
};
function $cad3cb514f4c9f49$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $cad3cb514f4c9f49$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $cad3cb514f4c9f49$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $cad3cb514f4c9f49$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $cad3cb514f4c9f49$var$s0_512_hi(xh, xl) {
    var c0_hi = $cad3cb514f4c9f49$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $cad3cb514f4c9f49$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $cad3cb514f4c9f49$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $cad3cb514f4c9f49$var$s0_512_lo(xh, xl) {
    var c0_lo = $cad3cb514f4c9f49$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $cad3cb514f4c9f49$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $cad3cb514f4c9f49$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $cad3cb514f4c9f49$var$s1_512_hi(xh, xl) {
    var c0_hi = $cad3cb514f4c9f49$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $cad3cb514f4c9f49$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $cad3cb514f4c9f49$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $cad3cb514f4c9f49$var$s1_512_lo(xh, xl) {
    var c0_lo = $cad3cb514f4c9f49$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $cad3cb514f4c9f49$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $cad3cb514f4c9f49$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $cad3cb514f4c9f49$var$g0_512_hi(xh, xl) {
    var c0_hi = $cad3cb514f4c9f49$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $cad3cb514f4c9f49$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $cad3cb514f4c9f49$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $cad3cb514f4c9f49$var$g0_512_lo(xh, xl) {
    var c0_lo = $cad3cb514f4c9f49$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $cad3cb514f4c9f49$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $cad3cb514f4c9f49$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $cad3cb514f4c9f49$var$g1_512_hi(xh, xl) {
    var c0_hi = $cad3cb514f4c9f49$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $cad3cb514f4c9f49$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $cad3cb514f4c9f49$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $cad3cb514f4c9f49$var$g1_512_lo(xh, xl) {
    var c0_lo = $cad3cb514f4c9f49$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $cad3cb514f4c9f49$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $cad3cb514f4c9f49$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("8pLmN", function(module, exports) {

$parcel$export(module.exports, "ripemd160", () => $62056695c4cb62fc$export$d1cea0ee4e3f0d3e, (v) => $62056695c4cb62fc$export$d1cea0ee4e3f0d3e = v);
var $62056695c4cb62fc$export$d1cea0ee4e3f0d3e;
'use strict';

var $5m5RF = parcelRequire("5m5RF");

var $ap5FC = parcelRequire("ap5FC");
var $62056695c4cb62fc$var$rotl32 = $5m5RF.rotl32;
var $62056695c4cb62fc$var$sum32 = $5m5RF.sum32;
var $62056695c4cb62fc$var$sum32_3 = $5m5RF.sum32_3;
var $62056695c4cb62fc$var$sum32_4 = $5m5RF.sum32_4;
var $62056695c4cb62fc$var$BlockHash = $ap5FC.BlockHash;
function $62056695c4cb62fc$var$RIPEMD160() {
    if (!(this instanceof $62056695c4cb62fc$var$RIPEMD160)) return new $62056695c4cb62fc$var$RIPEMD160();
    $62056695c4cb62fc$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = 'little';
}
$5m5RF.inherits($62056695c4cb62fc$var$RIPEMD160, $62056695c4cb62fc$var$BlockHash);
$62056695c4cb62fc$export$d1cea0ee4e3f0d3e = $62056695c4cb62fc$var$RIPEMD160;
$62056695c4cb62fc$var$RIPEMD160.blockSize = 512;
$62056695c4cb62fc$var$RIPEMD160.outSize = 160;
$62056695c4cb62fc$var$RIPEMD160.hmacStrength = 192;
$62056695c4cb62fc$var$RIPEMD160.padLength = 64;
$62056695c4cb62fc$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $62056695c4cb62fc$var$sum32($62056695c4cb62fc$var$rotl32($62056695c4cb62fc$var$sum32_4(A, $62056695c4cb62fc$var$f(j, B, C, D), msg[$62056695c4cb62fc$var$r[j] + start], $62056695c4cb62fc$var$K(j)), $62056695c4cb62fc$var$s[j]), E);
        A = E;
        E = D;
        D = $62056695c4cb62fc$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $62056695c4cb62fc$var$sum32($62056695c4cb62fc$var$rotl32($62056695c4cb62fc$var$sum32_4(Ah, $62056695c4cb62fc$var$f(79 - j, Bh, Ch, Dh), msg[$62056695c4cb62fc$var$rh[j] + start], $62056695c4cb62fc$var$Kh(j)), $62056695c4cb62fc$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $62056695c4cb62fc$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $62056695c4cb62fc$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $62056695c4cb62fc$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $62056695c4cb62fc$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $62056695c4cb62fc$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $62056695c4cb62fc$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$62056695c4cb62fc$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $5m5RF.toHex32(this.h, 'little');
    else return $5m5RF.split32(this.h, 'little');
};
function $62056695c4cb62fc$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $62056695c4cb62fc$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $62056695c4cb62fc$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $62056695c4cb62fc$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $62056695c4cb62fc$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $62056695c4cb62fc$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $62056695c4cb62fc$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("bVEBB", function(module, exports) {
'use strict';

var $5m5RF = parcelRequire("5m5RF");

var $aOIMZ = parcelRequire("aOIMZ");
function $8af483f723c67b6b$var$Hmac(hash, key, enc) {
    if (!(this instanceof $8af483f723c67b6b$var$Hmac)) return new $8af483f723c67b6b$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($5m5RF.toArray(key, enc));
}
module.exports = $8af483f723c67b6b$var$Hmac;
$8af483f723c67b6b$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $aOIMZ(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$8af483f723c67b6b$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$8af483f723c67b6b$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("93PGC", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
                'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
            ],
            [
                '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
                '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
            ],
            [
                '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
                'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
            ],
            [
                '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
                '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
            ],
            [
                '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
                '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
            ],
            [
                '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
                '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
            ],
            [
                'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
                '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
            ],
            [
                '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
                'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
            ],
            [
                'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
                '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
            ],
            [
                'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
                'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
            ],
            [
                'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
                '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
            ],
            [
                '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
                '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
            ],
            [
                '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
                '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
            ],
            [
                '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
                '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
            ],
            [
                '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
                '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
            ],
            [
                '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
                '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
            ],
            [
                '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
                '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
            ],
            [
                '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
                '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
            ],
            [
                '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
                'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
            ],
            [
                'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
                '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
            ],
            [
                'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
                '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
            ],
            [
                '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
                '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
            ],
            [
                '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
                '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
            ],
            [
                'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
                '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
            ],
            [
                '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
                'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
            ],
            [
                'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
                '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
            ],
            [
                'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
                'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
            ],
            [
                'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
                '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
            ],
            [
                'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
                'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
            ],
            [
                'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
                '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
            ],
            [
                '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
                'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
            ],
            [
                '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
                '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
            ],
            [
                'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
                '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
            ],
            [
                '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
                'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
            ],
            [
                'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
                '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
            ],
            [
                'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
                '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
            ],
            [
                'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
                'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
            ],
            [
                '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
                '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
            ],
            [
                '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
                '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
            ],
            [
                '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
                'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
            ],
            [
                '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
                '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
            ],
            [
                'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
                '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
            ],
            [
                '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
                '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
            ],
            [
                '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
                'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
            ],
            [
                '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
                '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
            ],
            [
                'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
                '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
            ],
            [
                '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
                'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
            ],
            [
                'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
                'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
            ],
            [
                'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
                '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
            ],
            [
                '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
                'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
            ],
            [
                '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
                'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
            ],
            [
                'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
                '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
            ],
            [
                'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
                '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
            ],
            [
                'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
                '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
            ],
            [
                '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
                'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
            ],
            [
                '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
                '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
            ],
            [
                'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
                'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
            ],
            [
                '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
                'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
            ],
            [
                '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
                '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
            ],
            [
                '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
                '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
            ],
            [
                'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
                'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
            ],
            [
                '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
                '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
            ],
            [
                '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
                '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
            ],
            [
                'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
                '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
            ],
            [
                'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
                'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
                '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
            ],
            [
                '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
                'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
            ],
            [
                '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
                '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
            ],
            [
                'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
                'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
            ],
            [
                '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
                'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
            ],
            [
                'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
                'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
            ],
            [
                'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
                '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
            ],
            [
                'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
                '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
            ],
            [
                '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
                '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
            ],
            [
                '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
                '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
            ],
            [
                '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
                '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
            ],
            [
                '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
                '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
            ],
            [
                'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
                'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
            ],
            [
                'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
                '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
            ],
            [
                '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
                'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
            ],
            [
                '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
                'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
            ],
            [
                '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
                '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
            ],
            [
                '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
                '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
            ],
            [
                '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
                '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
            ],
            [
                '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
                'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
            ],
            [
                'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
                'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
            ],
            [
                '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
                '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
            ],
            [
                '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
                '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
            ],
            [
                'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
                'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
            ],
            [
                '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
                '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
            ],
            [
                'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
                'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
            ],
            [
                'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
                'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
            ],
            [
                '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
                '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
            ],
            [
                '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
                '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
            ],
            [
                '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
                '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
            ],
            [
                'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
                '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
            ],
            [
                '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
                '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
            ],
            [
                'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
                '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
            ],
            [
                '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
                'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
            ],
            [
                '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
                'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
            ],
            [
                'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
                'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
            ],
            [
                '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
                '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
            ],
            [
                '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
                'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
            ],
            [
                'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
                'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
            ],
            [
                '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
                '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
            ],
            [
                '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
                'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
            ],
            [
                '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
                '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
            ],
            [
                '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
                'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
            ],
            [
                'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
                '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
            ],
            [
                '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
                '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
            ],
            [
                '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
                'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
            ],
            [
                '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
                'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
            ],
            [
                'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
                'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
            ],
            [
                'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
                'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
            ],
            [
                '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
                '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
            ],
            [
                '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
                '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
            ],
            [
                'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
                '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
            ],
            [
                'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
                'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
            ],
            [
                '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
                '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
            ],
            [
                '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
                '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
            ],
            [
                'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
                '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
            ],
            [
                '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
                '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
            ],
            [
                'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
                'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
            ],
            [
                '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
                'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
            ],
            [
                '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
                '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
            ],
            [
                'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
                '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
            ],
            [
                'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
                '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
            ],
            [
                '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
                '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
            ],
            [
                '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
                '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
            ],
            [
                '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
                'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
            ],
            [
                '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
                'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
            ],
            [
                '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
                '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
            ],
            [
                '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
                '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
            ],
            [
                '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
                '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
            ],
            [
                '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
                'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
            ],
            [
                'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
                'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
            ],
            [
                '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
                'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
            ],
            [
                'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
                '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
            ],
            [
                'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
                '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
            ],
            [
                'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
                '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
            ],
            [
                'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
                '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
            ],
            [
                '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
                'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
            ],
            [
                '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
                '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
            ],
            [
                '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
                'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
            ],
            [
                'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
                'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
            ],
            [
                'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
                '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
            ],
            [
                'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
                'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
            ],
            [
                'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
                '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
            ],
            [
                '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
                '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
            ],
            [
                'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
                '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
            ],
            [
                'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
                '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
            ],
            [
                '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
                '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
            ],
            [
                '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
                'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
            ],
            [
                'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
                '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
            ],
            [
                'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
                '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
            ],
            [
                'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
                '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
            ],
            [
                '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
                '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
            ],
            [
                'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
                'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
            ],
            [
                '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
                'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
            ],
            [
                'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
                'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
            ],
            [
                'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
                '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
            ],
            [
                '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
                'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
            ],
            [
                'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
                '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
            ],
            [
                'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
                '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
            ],
            [
                'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
                '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
            ],
            [
                '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
                'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
            ],
            [
                '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
                'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
            ],
            [
                'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
                '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
            ],
            [
                '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
                'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
            ],
            [
                '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
                '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
            ],
            [
                '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
                'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
            ],
            [
                'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
                'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
            ],
            [
                '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
                'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
            ],
            [
                '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
                '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
            ],
            [
                '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
                'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
            ],
            [
                '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
                '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
            ],
            [
                'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
                'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
            ],
            [
                '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
                '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
            ],
            [
                'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
                '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
            ],
            [
                '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
                '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
            ],
            [
                'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
                'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
            ],
            [
                'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
                '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
            ],
            [
                'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
                'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
            ],
            [
                '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
                'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
            ],
            [
                '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
                '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
            ],
            [
                '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
                'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
            ],
            [
                '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
                '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
            ],
            [
                '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
                '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
            ],
            [
                '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
                'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
            ],
            [
                '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
                '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
            ],
            [
                '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
                '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
            ],
            [
                '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
                '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
            ]
        ]
    }
};

});


parcelRegister("h6mem", function(module, exports) {
'use strict';

var $61SlE = parcelRequire("61SlE");

var $g1um0 = parcelRequire("g1um0");

var $6nTxf = parcelRequire("6nTxf");
var $c7343dc2badb09ab$var$utils = $6nTxf.utils;
var $c7343dc2badb09ab$var$assert = $c7343dc2badb09ab$var$utils.assert;

var $5G0Zf = parcelRequire("5G0Zf");

var $27zvB = parcelRequire("27zvB");
function $c7343dc2badb09ab$var$EC(options) {
    if (!(this instanceof $c7343dc2badb09ab$var$EC)) return new $c7343dc2badb09ab$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === 'string') {
        $c7343dc2badb09ab$var$assert($6nTxf.curves.hasOwnProperty(options), 'Unknown curve ' + options);
        options = $6nTxf.curves[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $6nTxf.curves.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $c7343dc2badb09ab$var$EC;
$c7343dc2badb09ab$var$EC.prototype.keyPair = function keyPair(options) {
    return new $5G0Zf(this, options);
};
$c7343dc2badb09ab$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $5G0Zf.fromPrivate(this, priv, enc);
};
$c7343dc2badb09ab$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $5G0Zf.fromPublic(this, pub, enc);
};
$c7343dc2badb09ab$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $g1um0({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8',
        entropy: options.entropy || $6nTxf.rand(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || 'utf8',
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $61SlE(2));
    do {
        var priv = new $61SlE(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }while (true);
};
$c7343dc2badb09ab$var$EC.prototype._truncateToN = function truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$c7343dc2badb09ab$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === 'object') {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new $61SlE(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray('be', bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray('be', bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $g1um0({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8'
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $61SlE(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $61SlE(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $27zvB({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$c7343dc2badb09ab$var$EC.prototype.verify = function verify(msg, signature, key, enc) {
    msg = this._truncateToN(new $61SlE(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature = new $27zvB(signature, 'hex');
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    if (!this.curve._maxwellTrick) {
        var p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    var p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$c7343dc2badb09ab$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $c7343dc2badb09ab$var$assert((3 & j) === j, 'The recovery param is more than two bits');
    signature = new $27zvB(signature, enc);
    var n = this.n;
    var e = new $61SlE(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error('Unable to find sencond key candinate');
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$c7343dc2badb09ab$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $27zvB(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error('Unable to find valid recovery factor');
};

});
parcelRegister("g1um0", function(module, exports) {
'use strict';

var $1b2Pi = parcelRequire("1b2Pi");

var $9a0Ug = parcelRequire("9a0Ug");

var $aOIMZ = parcelRequire("aOIMZ");
function $baa448f8c81bebd3$var$HmacDRBG(options) {
    if (!(this instanceof $baa448f8c81bebd3$var$HmacDRBG)) return new $baa448f8c81bebd3$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $9a0Ug.toArray(options.entropy, options.entropyEnc || 'hex');
    var nonce = $9a0Ug.toArray(options.nonce, options.nonceEnc || 'hex');
    var pers = $9a0Ug.toArray(options.pers, options.persEnc || 'hex');
    $aOIMZ(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._init(entropy, nonce, pers);
}
module.exports = $baa448f8c81bebd3$var$HmacDRBG;
$baa448f8c81bebd3$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$baa448f8c81bebd3$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $1b2Pi.hmac(this.hash, this.K);
};
$baa448f8c81bebd3$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$baa448f8c81bebd3$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== 'string') {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $9a0Ug.toArray(entropy, entropyEnc);
    add = $9a0Ug.toArray(add, addEnc);
    $aOIMZ(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$baa448f8c81bebd3$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error('Reseed is required');
    // Optional encoding
    if (typeof enc !== 'string') {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $9a0Ug.toArray(add, addEnc || 'hex');
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $9a0Ug.encode(res, enc);
};

});

parcelRegister("5G0Zf", function(module, exports) {
'use strict';

var $61SlE = parcelRequire("61SlE");

var $6nTxf = parcelRequire("6nTxf");
var $4221a3fd0ff06be5$var$utils = $6nTxf.utils;
var $4221a3fd0ff06be5$var$assert = $4221a3fd0ff06be5$var$utils.assert;
function $4221a3fd0ff06be5$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $4221a3fd0ff06be5$var$KeyPair;
$4221a3fd0ff06be5$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $4221a3fd0ff06be5$var$KeyPair) return pub;
    return new $4221a3fd0ff06be5$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$4221a3fd0ff06be5$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $4221a3fd0ff06be5$var$KeyPair) return priv;
    return new $4221a3fd0ff06be5$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$4221a3fd0ff06be5$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: 'Invalid public key'
    };
    if (!pub.validate()) return {
        result: false,
        reason: 'Public key is not a point'
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: 'Public key * N != O'
    };
    return {
        result: true,
        reason: null
    };
};
$4221a3fd0ff06be5$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === 'string') {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$4221a3fd0ff06be5$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === 'hex') return this.priv.toString(16, 2);
    else return this.priv;
};
$4221a3fd0ff06be5$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $61SlE(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$4221a3fd0ff06be5$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === 'mont') $4221a3fd0ff06be5$var$assert(key.x, 'Need x coordinate');
        else if (this.ec.curve.type === 'short' || this.ec.curve.type === 'edwards') $4221a3fd0ff06be5$var$assert(key.x && key.y, 'Need both x and y coordinate');
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$4221a3fd0ff06be5$var$KeyPair.prototype.derive = function derive(pub) {
    return pub.mul(this.priv).getX();
};
// ECDSA
$4221a3fd0ff06be5$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$4221a3fd0ff06be5$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$4221a3fd0ff06be5$var$KeyPair.prototype.inspect = function inspect() {
    return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) + ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};

});

parcelRegister("27zvB", function(module, exports) {
'use strict';

var $61SlE = parcelRequire("61SlE");

var $6nTxf = parcelRequire("6nTxf");
var $18b7c786830ea982$var$utils = $6nTxf.utils;
var $18b7c786830ea982$var$assert = $18b7c786830ea982$var$utils.assert;
function $18b7c786830ea982$var$Signature(options, enc) {
    if (options instanceof $18b7c786830ea982$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $18b7c786830ea982$var$assert(options.r && options.s, 'Signature without r or s');
    this.r = new $61SlE(options.r, 16);
    this.s = new $61SlE(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $18b7c786830ea982$var$Signature;
function $18b7c786830ea982$var$Position() {
    this.place = 0;
}
function $18b7c786830ea982$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
    }
    p.place = off;
    return val;
}
function $18b7c786830ea982$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$18b7c786830ea982$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $18b7c786830ea982$var$utils.toArray(data, enc);
    var p = new $18b7c786830ea982$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $18b7c786830ea982$var$getLength(data, p);
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $18b7c786830ea982$var$getLength(data, p);
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $18b7c786830ea982$var$getLength(data, p);
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0 && r[1] & 0x80) r = r.slice(1);
    if (s[0] === 0 && s[1] & 0x80) s = s.slice(1);
    this.r = new $61SlE(r);
    this.s = new $61SlE(s);
    this.recoveryParam = null;
    return true;
};
function $18b7c786830ea982$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$18b7c786830ea982$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $18b7c786830ea982$var$rmPadding(r);
    s = $18b7c786830ea982$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $18b7c786830ea982$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $18b7c786830ea982$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $18b7c786830ea982$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $18b7c786830ea982$var$utils.encode(res, enc);
};

});


parcelRegister("j0pZO", function(module, exports) {
'use strict';

var $1b2Pi = parcelRequire("1b2Pi");

var $6nTxf = parcelRequire("6nTxf");
var $dd622ea45c6600da$var$utils = $6nTxf.utils;
var $dd622ea45c6600da$var$assert = $dd622ea45c6600da$var$utils.assert;
var $dd622ea45c6600da$var$parseBytes = $dd622ea45c6600da$var$utils.parseBytes;

var $kiVpu = parcelRequire("kiVpu");

var $jwPwB = parcelRequire("jwPwB");
function $dd622ea45c6600da$var$EDDSA(curve) {
    $dd622ea45c6600da$var$assert(curve === 'ed25519', 'only tested with ed25519 so far');
    if (!(this instanceof $dd622ea45c6600da$var$EDDSA)) return new $dd622ea45c6600da$var$EDDSA(curve);
    var curve = $6nTxf.curves[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $1b2Pi.sha512;
}
module.exports = $dd622ea45c6600da$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $dd622ea45c6600da$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $dd622ea45c6600da$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $dd622ea45c6600da$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $dd622ea45c6600da$var$parseBytes(message);
    sig = this.makeSignature(sig);
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$dd622ea45c6600da$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $dd622ea45c6600da$var$utils.intFromLE(hash.digest()).umod(this.curve.n);
};
$dd622ea45c6600da$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $kiVpu.fromPublic(this, pub);
};
$dd622ea45c6600da$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $kiVpu.fromSecret(this, secret);
};
$dd622ea45c6600da$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $jwPwB) return sig;
    return new $jwPwB(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $dd622ea45c6600da$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray('le', this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$dd622ea45c6600da$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $dd622ea45c6600da$var$utils.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $dd622ea45c6600da$var$utils.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$dd622ea45c6600da$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray('le', this.encodingLength);
};
$dd622ea45c6600da$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $dd622ea45c6600da$var$utils.intFromLE(bytes);
};
$dd622ea45c6600da$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("kiVpu", function(module, exports) {
'use strict';

var $6nTxf = parcelRequire("6nTxf");
var $ec82058b2f28f2e5$var$utils = $6nTxf.utils;
var $ec82058b2f28f2e5$var$assert = $ec82058b2f28f2e5$var$utils.assert;
var $ec82058b2f28f2e5$var$parseBytes = $ec82058b2f28f2e5$var$utils.parseBytes;
var $ec82058b2f28f2e5$var$cachedProperty = $ec82058b2f28f2e5$var$utils.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $ec82058b2f28f2e5$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $ec82058b2f28f2e5$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $ec82058b2f28f2e5$var$parseBytes(params.pub);
}
$ec82058b2f28f2e5$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $ec82058b2f28f2e5$var$KeyPair) return pub;
    return new $ec82058b2f28f2e5$var$KeyPair(eddsa, {
        pub: pub
    });
};
$ec82058b2f28f2e5$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $ec82058b2f28f2e5$var$KeyPair) return secret;
    return new $ec82058b2f28f2e5$var$KeyPair(eddsa, {
        secret: secret
    });
};
$ec82058b2f28f2e5$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$ec82058b2f28f2e5$var$cachedProperty($ec82058b2f28f2e5$var$KeyPair, 'pubBytes', function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$ec82058b2f28f2e5$var$cachedProperty($ec82058b2f28f2e5$var$KeyPair, 'pub', function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$ec82058b2f28f2e5$var$cachedProperty($ec82058b2f28f2e5$var$KeyPair, 'privBytes', function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$ec82058b2f28f2e5$var$cachedProperty($ec82058b2f28f2e5$var$KeyPair, 'priv', function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$ec82058b2f28f2e5$var$cachedProperty($ec82058b2f28f2e5$var$KeyPair, 'hash', function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$ec82058b2f28f2e5$var$cachedProperty($ec82058b2f28f2e5$var$KeyPair, 'messagePrefix', function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$ec82058b2f28f2e5$var$KeyPair.prototype.sign = function sign(message) {
    $ec82058b2f28f2e5$var$assert(this._secret, 'KeyPair can only verify');
    return this.eddsa.sign(message, this);
};
$ec82058b2f28f2e5$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$ec82058b2f28f2e5$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $ec82058b2f28f2e5$var$assert(this._secret, 'KeyPair is public only');
    return $ec82058b2f28f2e5$var$utils.encode(this.secret(), enc);
};
$ec82058b2f28f2e5$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $ec82058b2f28f2e5$var$utils.encode(this.pubBytes(), enc);
};
module.exports = $ec82058b2f28f2e5$var$KeyPair;

});

parcelRegister("jwPwB", function(module, exports) {
'use strict';

var $61SlE = parcelRequire("61SlE");

var $6nTxf = parcelRequire("6nTxf");
var $e378f93fe9f62b7b$var$utils = $6nTxf.utils;
var $e378f93fe9f62b7b$var$assert = $e378f93fe9f62b7b$var$utils.assert;
var $e378f93fe9f62b7b$var$cachedProperty = $e378f93fe9f62b7b$var$utils.cachedProperty;
var $e378f93fe9f62b7b$var$parseBytes = $e378f93fe9f62b7b$var$utils.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $e378f93fe9f62b7b$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== 'object') sig = $e378f93fe9f62b7b$var$parseBytes(sig);
    if (Array.isArray(sig)) sig = {
        R: sig.slice(0, eddsa.encodingLength),
        S: sig.slice(eddsa.encodingLength)
    };
    $e378f93fe9f62b7b$var$assert(sig.R && sig.S, 'Signature without R or S');
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $61SlE) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$e378f93fe9f62b7b$var$cachedProperty($e378f93fe9f62b7b$var$Signature, 'S', function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$e378f93fe9f62b7b$var$cachedProperty($e378f93fe9f62b7b$var$Signature, 'R', function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$e378f93fe9f62b7b$var$cachedProperty($e378f93fe9f62b7b$var$Signature, 'Rencoded', function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$e378f93fe9f62b7b$var$cachedProperty($e378f93fe9f62b7b$var$Signature, 'Sencoded', function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$e378f93fe9f62b7b$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$e378f93fe9f62b7b$var$Signature.prototype.toHex = function toHex() {
    return $e378f93fe9f62b7b$var$utils.encode(this.toBytes(), 'hex').toUpperCase();
};
module.exports = $e378f93fe9f62b7b$var$Signature;

});



parcelRegister("lXsfV", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $ffc506b4f2050cfc$require$Buffer = $aul3P.Buffer;

var $cfiQZ = parcelRequire("cfiQZ");

var $fJ1z5 = parcelRequire("fJ1z5");

var $1qG0a = parcelRequire("1qG0a");

var $FyTgm = parcelRequire("FyTgm");

var $8bTm7 = parcelRequire("8bTm7");
module.exports = $ffc506b4f2050cfc$var$parseKeys;
function $ffc506b4f2050cfc$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === 'object' && !$ffc506b4f2050cfc$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === 'string') buffer = new $ffc506b4f2050cfc$require$Buffer(buffer);
    var stripped = $1qG0a(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case 'CERTIFICATE':
            ndata = $cfiQZ.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case 'PUBLIC KEY':
            if (!ndata) ndata = $cfiQZ.PublicKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $cfiQZ.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der');
                case '1.2.840.10045.2.1':
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: 'ec',
                        data: ndata
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.pub_key = $cfiQZ.DSAparam.decode(ndata.subjectPublicKey.data, 'der');
                    return {
                        type: 'dsa',
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
            throw new Error('unknown key type ' + type);
        case 'ENCRYPTED PRIVATE KEY':
            data = $cfiQZ.EncryptedPrivateKey.decode(data, 'der');
            data = $ffc506b4f2050cfc$var$decrypt(data, password);
        // falls through
        case 'PRIVATE KEY':
            ndata = $cfiQZ.PrivateKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $cfiQZ.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der');
                case '1.2.840.10045.2.1':
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $cfiQZ.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.priv_key = $cfiQZ.DSAparam.decode(ndata.subjectPrivateKey, 'der');
                    return {
                        type: 'dsa',
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
            throw new Error('unknown key type ' + type);
        case 'RSA PUBLIC KEY':
            return $cfiQZ.RSAPublicKey.decode(data, 'der');
        case 'RSA PRIVATE KEY':
            return $cfiQZ.RSAPrivateKey.decode(data, 'der');
        case 'DSA PRIVATE KEY':
            return {
                type: 'dsa',
                params: $cfiQZ.DSAPrivateKey.decode(data, 'der')
            };
        case 'EC PRIVATE KEY':
            data = $cfiQZ.ECPrivateKey.decode(data, 'der');
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error('unknown key type ' + type);
    }
}
$ffc506b4f2050cfc$var$parseKeys.signature = $cfiQZ.signature;
function $ffc506b4f2050cfc$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $fJ1z5[data.algorithm.decrypt.cipher.algo.join('.')];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split('-')[1], 10) / 8;
    var key = $8bTm7.pbkdf2Sync(password, salt, iters, keylen);
    var cipher = $FyTgm.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher.final());
    return $ffc506b4f2050cfc$require$Buffer.concat(out);
}

});
parcelRegister("cfiQZ", function(module, exports) {

$parcel$export(module.exports, "certificate", () => $8ea582b0d1e4c2ff$export$c98397a6eb8d0678, (v) => $8ea582b0d1e4c2ff$export$c98397a6eb8d0678 = v);
$parcel$export(module.exports, "RSAPrivateKey", () => $8ea582b0d1e4c2ff$export$f4aab6816f64fa6b, (v) => $8ea582b0d1e4c2ff$export$f4aab6816f64fa6b = v);
$parcel$export(module.exports, "RSAPublicKey", () => $8ea582b0d1e4c2ff$export$4471f5c65d097c11, (v) => $8ea582b0d1e4c2ff$export$4471f5c65d097c11 = v);
$parcel$export(module.exports, "PublicKey", () => $8ea582b0d1e4c2ff$export$ca8b6604d6ce14de, (v) => $8ea582b0d1e4c2ff$export$ca8b6604d6ce14de = v);
$parcel$export(module.exports, "PrivateKey", () => $8ea582b0d1e4c2ff$export$8f54525b330fd87b, (v) => $8ea582b0d1e4c2ff$export$8f54525b330fd87b = v);
$parcel$export(module.exports, "EncryptedPrivateKey", () => $8ea582b0d1e4c2ff$export$23cd2842b44ca3e7, (v) => $8ea582b0d1e4c2ff$export$23cd2842b44ca3e7 = v);
$parcel$export(module.exports, "DSAPrivateKey", () => $8ea582b0d1e4c2ff$export$245c9aaa9f5ce4ce, (v) => $8ea582b0d1e4c2ff$export$245c9aaa9f5ce4ce = v);
$parcel$export(module.exports, "DSAparam", () => $8ea582b0d1e4c2ff$export$8ad762e3e6399afe, (v) => $8ea582b0d1e4c2ff$export$8ad762e3e6399afe = v);
$parcel$export(module.exports, "ECPrivateKey", () => $8ea582b0d1e4c2ff$export$32ef6f92e22c6ab0, (v) => $8ea582b0d1e4c2ff$export$32ef6f92e22c6ab0 = v);
$parcel$export(module.exports, "signature", () => $8ea582b0d1e4c2ff$export$c9cd164b539ebb63, (v) => $8ea582b0d1e4c2ff$export$c9cd164b539ebb63 = v);
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $8ea582b0d1e4c2ff$export$c98397a6eb8d0678;
var $8ea582b0d1e4c2ff$export$f4aab6816f64fa6b;
var $8ea582b0d1e4c2ff$export$4471f5c65d097c11;
var $8ea582b0d1e4c2ff$export$ca8b6604d6ce14de;
var $8ea582b0d1e4c2ff$export$8f54525b330fd87b;
var $8ea582b0d1e4c2ff$export$23cd2842b44ca3e7;
var $8ea582b0d1e4c2ff$export$245c9aaa9f5ce4ce;
var $8ea582b0d1e4c2ff$export$8ad762e3e6399afe;
var $8ea582b0d1e4c2ff$export$32ef6f92e22c6ab0;
var $8ea582b0d1e4c2ff$export$c9cd164b539ebb63;
'use strict';

var $7nj2w = parcelRequire("7nj2w");

$8ea582b0d1e4c2ff$export$c98397a6eb8d0678 = (parcelRequire("hZGUx"));
var $8ea582b0d1e4c2ff$var$RSAPrivateKey = $7nj2w.define('RSAPrivateKey', function() {
    this.seq().obj(this.key('version').int(), this.key('modulus').int(), this.key('publicExponent').int(), this.key('privateExponent').int(), this.key('prime1').int(), this.key('prime2').int(), this.key('exponent1').int(), this.key('exponent2').int(), this.key('coefficient').int());
});
$8ea582b0d1e4c2ff$export$f4aab6816f64fa6b = $8ea582b0d1e4c2ff$var$RSAPrivateKey;
var $8ea582b0d1e4c2ff$var$RSAPublicKey = $7nj2w.define('RSAPublicKey', function() {
    this.seq().obj(this.key('modulus').int(), this.key('publicExponent').int());
});
$8ea582b0d1e4c2ff$export$4471f5c65d097c11 = $8ea582b0d1e4c2ff$var$RSAPublicKey;
var $8ea582b0d1e4c2ff$var$PublicKey = $7nj2w.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($8ea582b0d1e4c2ff$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
$8ea582b0d1e4c2ff$export$ca8b6604d6ce14de = $8ea582b0d1e4c2ff$var$PublicKey;
var $8ea582b0d1e4c2ff$var$AlgorithmIdentifier = $7nj2w.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('none').null_().optional(), this.key('curve').objid().optional(), this.key('params').seq().obj(this.key('p').int(), this.key('q').int(), this.key('g').int()).optional());
});
var $8ea582b0d1e4c2ff$var$PrivateKeyInfo = $7nj2w.define('PrivateKeyInfo', function() {
    this.seq().obj(this.key('version').int(), this.key('algorithm').use($8ea582b0d1e4c2ff$var$AlgorithmIdentifier), this.key('subjectPrivateKey').octstr());
});
$8ea582b0d1e4c2ff$export$8f54525b330fd87b = $8ea582b0d1e4c2ff$var$PrivateKeyInfo;
var $8ea582b0d1e4c2ff$var$EncryptedPrivateKeyInfo = $7nj2w.define('EncryptedPrivateKeyInfo', function() {
    this.seq().obj(this.key('algorithm').seq().obj(this.key('id').objid(), this.key('decrypt').seq().obj(this.key('kde').seq().obj(this.key('id').objid(), this.key('kdeparams').seq().obj(this.key('salt').octstr(), this.key('iters').int())), this.key('cipher').seq().obj(this.key('algo').objid(), this.key('iv').octstr()))), this.key('subjectPrivateKey').octstr());
});
$8ea582b0d1e4c2ff$export$23cd2842b44ca3e7 = $8ea582b0d1e4c2ff$var$EncryptedPrivateKeyInfo;
var $8ea582b0d1e4c2ff$var$DSAPrivateKey = $7nj2w.define('DSAPrivateKey', function() {
    this.seq().obj(this.key('version').int(), this.key('p').int(), this.key('q').int(), this.key('g').int(), this.key('pub_key').int(), this.key('priv_key').int());
});
$8ea582b0d1e4c2ff$export$245c9aaa9f5ce4ce = $8ea582b0d1e4c2ff$var$DSAPrivateKey;
$8ea582b0d1e4c2ff$export$8ad762e3e6399afe = $7nj2w.define('DSAparam', function() {
    this.int();
});
var $8ea582b0d1e4c2ff$var$ECPrivateKey = $7nj2w.define('ECPrivateKey', function() {
    this.seq().obj(this.key('version').int(), this.key('privateKey').octstr(), this.key('parameters').optional().explicit(0).use($8ea582b0d1e4c2ff$var$ECParameters), this.key('publicKey').optional().explicit(1).bitstr());
});
$8ea582b0d1e4c2ff$export$32ef6f92e22c6ab0 = $8ea582b0d1e4c2ff$var$ECPrivateKey;
var $8ea582b0d1e4c2ff$var$ECParameters = $7nj2w.define('ECParameters', function() {
    this.choice({
        namedCurve: this.objid()
    });
});
$8ea582b0d1e4c2ff$export$c9cd164b539ebb63 = $7nj2w.define('signature', function() {
    this.seq().obj(this.key('r').int(), this.key('s').int());
});

});
parcelRegister("7nj2w", function(module, exports) {
var $55e9734436f4a826$var$asn1 = module.exports;

$55e9734436f4a826$var$asn1.bignum = (parcelRequire("61SlE"));

$55e9734436f4a826$var$asn1.define = (parcelRequire("6uEen")).define;

$55e9734436f4a826$var$asn1.base = (parcelRequire("gvyuX"));

$55e9734436f4a826$var$asn1.constants = (parcelRequire("cgbG6"));

$55e9734436f4a826$var$asn1.decoders = (parcelRequire("9EvL1"));

$55e9734436f4a826$var$asn1.encoders = (parcelRequire("i6gsd"));

});
parcelRegister("6uEen", function(module, exports) {

var $7nj2w = parcelRequire("7nj2w");

var $lyUaN = parcelRequire("lyUaN");
var $4ba4c06a7be5b446$var$api = module.exports;
$4ba4c06a7be5b446$var$api.define = function define(name, body) {
    return new $4ba4c06a7be5b446$var$Entity(name, body);
};
function $4ba4c06a7be5b446$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}

$4ba4c06a7be5b446$var$Entity.prototype._createNamed = function createNamed(base) {
    var named;
    try {
        named = (parcelRequire("gLs15")).runInThisContext('(function ' + this.name + '(entity) {\n' + '  this._initNamed(entity);\n' + '})');
    } catch (e) {
        named = function(entity) {
            this._initNamed(entity);
        };
    }
    $lyUaN(named, base);
    named.prototype._initNamed = function initnamed(entity) {
        base.call(this, entity);
    };
    return new named(this);
};
$4ba4c06a7be5b446$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || 'der';
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($7nj2w.decoders[enc]);
    return this.decoders[enc];
};
$4ba4c06a7be5b446$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$4ba4c06a7be5b446$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || 'der';
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($7nj2w.encoders[enc]);
    return this.encoders[enc];
};
$4ba4c06a7be5b446$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRegister("gLs15", function(module, exports) {
var indexOf = function(xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for(var i = 0; i < xs.length; i++){
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function(obj) {
    if (Object.keys) return Object.keys(obj);
    else {
        var res = [];
        for(var key in obj)res.push(key);
        return res;
    }
};
var forEach = function(xs, fn) {
    if (xs.forEach) return xs.forEach(fn);
    else for(var i = 0; i < xs.length; i++)fn(xs[i], i, xs);
};
var defineProp = function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            });
        };
    } catch (e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}();
var globals = [
    'Array',
    'Boolean',
    'Date',
    'Error',
    'EvalError',
    'Function',
    'Infinity',
    'JSON',
    'Math',
    'NaN',
    'Number',
    'Object',
    'RangeError',
    'ReferenceError',
    'RegExp',
    'String',
    'SyntaxError',
    'TypeError',
    'URIError',
    'decodeURI',
    'decodeURIComponent',
    'encodeURI',
    'encodeURIComponent',
    'escape',
    'eval',
    'isFinite',
    'isNaN',
    'parseFloat',
    'parseInt',
    'undefined',
    'unescape'
];
function Context() {}
Context.prototype = {};
var Script = exports.Script = function NodeScript(code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};
Script.prototype.runInContext = function(context) {
    if (!(context instanceof Context)) throw new TypeError("needs a 'context' argument.");
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;
    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    forEach(Object_keys(context), function(key) {
        win[key] = context[key];
    });
    forEach(globals, function(key) {
        if (context[key]) win[key] = context[key];
    });
    var winKeys = Object_keys(win);
    var res = wEval.call(win, this.code);
    forEach(Object_keys(win), function(key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) context[key] = win[key];
    });
    forEach(globals, function(key) {
        if (!(key in context)) defineProp(context, key, win[key]);
    });
    document.body.removeChild(iframe);
    return res;
};
Script.prototype.runInThisContext = function() {
    return eval(this.code); // maybe...
};
Script.prototype.runInNewContext = function(context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);
    if (context) forEach(Object_keys(ctx), function(key) {
        context[key] = ctx[key];
    });
    return res;
};
forEach(Object_keys(Script.prototype), function(name) {
    exports[name] = Script[name] = function(code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});
exports.isContext = function(context) {
    return context instanceof Context;
};
exports.createScript = function(code) {
    return exports.Script(code);
};
exports.createContext = Script.createContext = function(context) {
    var copy = new Context();
    if (typeof context === 'object') forEach(Object_keys(context), function(key) {
        copy[key] = context[key];
    });
    return copy;
};

});


parcelRegister("gvyuX", function(module, exports) {
var $c04a4d3689eb5b96$var$base = module.exports;

$c04a4d3689eb5b96$var$base.Reporter = (parcelRequire("5vbYl")).Reporter;

$c04a4d3689eb5b96$var$base.DecoderBuffer = (parcelRequire("hv1XP")).DecoderBuffer;

$c04a4d3689eb5b96$var$base.EncoderBuffer = (parcelRequire("hv1XP")).EncoderBuffer;

$c04a4d3689eb5b96$var$base.Node = (parcelRequire("kFkCQ"));

});
parcelRegister("5vbYl", function(module, exports) {

$parcel$export(module.exports, "Reporter", () => $4019227616839f63$export$957313a2f485e5ed, (v) => $4019227616839f63$export$957313a2f485e5ed = v);
var $4019227616839f63$export$957313a2f485e5ed;

var $lyUaN = parcelRequire("lyUaN");
function $4019227616839f63$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$4019227616839f63$export$957313a2f485e5ed = $4019227616839f63$var$Reporter;
$4019227616839f63$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $4019227616839f63$var$ReporterError;
};
$4019227616839f63$var$Reporter.prototype.save = function save() {
    var state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$4019227616839f63$var$Reporter.prototype.restore = function restore(data) {
    var state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$4019227616839f63$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$4019227616839f63$var$Reporter.prototype.exitKey = function exitKey(index) {
    var state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$4019227616839f63$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    var state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$4019227616839f63$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join('/');
};
$4019227616839f63$var$Reporter.prototype.enterObject = function enterObject() {
    var state = this._reporterState;
    var prev = state.obj;
    state.obj = {};
    return prev;
};
$4019227616839f63$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    var state = this._reporterState;
    var now = state.obj;
    state.obj = prev;
    return now;
};
$4019227616839f63$var$Reporter.prototype.error = function error(msg) {
    var err;
    var state = this._reporterState;
    var inherited = msg instanceof $4019227616839f63$var$ReporterError;
    if (inherited) err = msg;
    else err = new $4019227616839f63$var$ReporterError(state.path.map(function(elem) {
        return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$4019227616839f63$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    var state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $4019227616839f63$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$lyUaN($4019227616839f63$var$ReporterError, Error);
$4019227616839f63$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + ' at: ' + (this.path || '(shallow)');
    if (Error.captureStackTrace) Error.captureStackTrace(this, $4019227616839f63$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRegister("hv1XP", function(module, exports) {

$parcel$export(module.exports, "DecoderBuffer", () => $cbd6daf20c01fb9a$export$bf9f79cdc4a49163, (v) => $cbd6daf20c01fb9a$export$bf9f79cdc4a49163 = v);
$parcel$export(module.exports, "EncoderBuffer", () => $cbd6daf20c01fb9a$export$8ff24f7760c7a78e, (v) => $cbd6daf20c01fb9a$export$8ff24f7760c7a78e = v);
var $cbd6daf20c01fb9a$export$bf9f79cdc4a49163;
var $cbd6daf20c01fb9a$export$8ff24f7760c7a78e;

var $lyUaN = parcelRequire("lyUaN");

var $gvyuX = parcelRequire("gvyuX");
var $cbd6daf20c01fb9a$require$Reporter = $gvyuX.Reporter;

var $aul3P = parcelRequire("aul3P");
var $cbd6daf20c01fb9a$require$Buffer = $aul3P.Buffer;
function $cbd6daf20c01fb9a$var$DecoderBuffer(base, options) {
    $cbd6daf20c01fb9a$require$Reporter.call(this, options);
    if (!$cbd6daf20c01fb9a$require$Buffer.isBuffer(base)) {
        this.error('Input not Buffer');
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$lyUaN($cbd6daf20c01fb9a$var$DecoderBuffer, $cbd6daf20c01fb9a$require$Reporter);
$cbd6daf20c01fb9a$export$bf9f79cdc4a49163 = $cbd6daf20c01fb9a$var$DecoderBuffer;
$cbd6daf20c01fb9a$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $cbd6daf20c01fb9a$require$Reporter.prototype.save.call(this)
    };
};
$cbd6daf20c01fb9a$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    var res = new $cbd6daf20c01fb9a$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $cbd6daf20c01fb9a$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$cbd6daf20c01fb9a$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$cbd6daf20c01fb9a$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || 'DecoderBuffer overrun');
};
$cbd6daf20c01fb9a$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || 'DecoderBuffer overrun');
    var res = new $cbd6daf20c01fb9a$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$cbd6daf20c01fb9a$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $cbd6daf20c01fb9a$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!(item instanceof $cbd6daf20c01fb9a$var$EncoderBuffer)) item = new $cbd6daf20c01fb9a$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === 'number') {
        if (!(0 <= value && value <= 0xff)) return reporter.error('non-byte EncoderBuffer value');
        this.value = value;
        this.length = 1;
    } else if (typeof value === 'string') {
        this.value = value;
        this.length = $cbd6daf20c01fb9a$require$Buffer.byteLength(value);
    } else if ($cbd6daf20c01fb9a$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error('Unsupported type: ' + typeof value);
}
$cbd6daf20c01fb9a$export$8ff24f7760c7a78e = $cbd6daf20c01fb9a$var$EncoderBuffer;
$cbd6daf20c01fb9a$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = new $cbd6daf20c01fb9a$require$Buffer(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === 'number') out[offset] = this.value;
        else if (typeof this.value === 'string') out.write(this.value, offset);
        else if ($cbd6daf20c01fb9a$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});

parcelRegister("kFkCQ", function(module, exports) {

var $gvyuX = parcelRequire("gvyuX");
var $f0b7a2ced72bd4e2$require$Reporter = $gvyuX.Reporter;

var $gvyuX = parcelRequire("gvyuX");
var $f0b7a2ced72bd4e2$require$EncoderBuffer = $gvyuX.EncoderBuffer;

var $gvyuX = parcelRequire("gvyuX");
var $f0b7a2ced72bd4e2$require$DecoderBuffer = $gvyuX.DecoderBuffer;

var $aOIMZ = parcelRequire("aOIMZ");
// Supported tags
var $f0b7a2ced72bd4e2$var$tags = [
    'seq',
    'seqof',
    'set',
    'setof',
    'objid',
    'bool',
    'gentime',
    'utctime',
    'null_',
    'enum',
    'int',
    'objDesc',
    'bitstr',
    'bmpstr',
    'charstr',
    'genstr',
    'graphstr',
    'ia5str',
    'iso646str',
    'numstr',
    'octstr',
    'printstr',
    't61str',
    'unistr',
    'utf8str',
    'videostr'
];
// Public methods list
var $f0b7a2ced72bd4e2$var$methods = [
    'key',
    'obj',
    'use',
    'optional',
    'explicit',
    'implicit',
    'def',
    'choice',
    'any',
    'contains'
].concat($f0b7a2ced72bd4e2$var$tags);
// Overrided methods list
var $f0b7a2ced72bd4e2$var$overrided = [
    '_peekTag',
    '_decodeTag',
    '_use',
    '_decodeStr',
    '_decodeObjid',
    '_decodeTime',
    '_decodeNull',
    '_decodeInt',
    '_decodeBool',
    '_decodeList',
    '_encodeComposite',
    '_encodeStr',
    '_encodeObjid',
    '_encodeTime',
    '_encodeNull',
    '_encodeInt',
    '_encodeBool'
];
function $f0b7a2ced72bd4e2$var$Node(enc, parent) {
    var state = {};
    this._baseState = state;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state['default'] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $f0b7a2ced72bd4e2$var$Node;
var $f0b7a2ced72bd4e2$var$stateProps = [
    'enc',
    'parent',
    'children',
    'tag',
    'args',
    'reverseArgs',
    'choice',
    'optional',
    'any',
    'obj',
    'use',
    'alteredUse',
    'key',
    'default',
    'explicit',
    'implicit',
    'contains'
];
$f0b7a2ced72bd4e2$var$Node.prototype.clone = function clone() {
    var state = this._baseState;
    var cstate = {};
    $f0b7a2ced72bd4e2$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    var res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$f0b7a2ced72bd4e2$var$Node.prototype._wrap = function wrap() {
    var state = this._baseState;
    $f0b7a2ced72bd4e2$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            var clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$f0b7a2ced72bd4e2$var$Node.prototype._init = function init(body) {
    var state = this._baseState;
    $aOIMZ(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $aOIMZ.equal(state.children.length, 1, 'Root node can have only one child');
};
$f0b7a2ced72bd4e2$var$Node.prototype._useArgs = function useArgs(args) {
    var state = this._baseState;
    // Filter children and args
    var children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $aOIMZ(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $aOIMZ(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== 'object' || arg.constructor !== Object) return arg;
            var res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                var value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$f0b7a2ced72bd4e2$var$overrided.forEach(function(method) {
    $f0b7a2ced72bd4e2$var$Node.prototype[method] = function _overrided() {
        var state = this._baseState;
        throw new Error(method + ' not implemented for encoding: ' + state.enc);
    };
});
//
// Public methods
//
$f0b7a2ced72bd4e2$var$tags.forEach(function(tag) {
    $f0b7a2ced72bd4e2$var$Node.prototype[tag] = function _tagMethod() {
        var state = this._baseState;
        var args = Array.prototype.slice.call(arguments);
        $aOIMZ(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$f0b7a2ced72bd4e2$var$Node.prototype.use = function use(item) {
    $aOIMZ(item);
    var state = this._baseState;
    $aOIMZ(state.use === null);
    state.use = item;
    return this;
};
$f0b7a2ced72bd4e2$var$Node.prototype.optional = function optional() {
    var state = this._baseState;
    state.optional = true;
    return this;
};
$f0b7a2ced72bd4e2$var$Node.prototype.def = function def(val) {
    var state = this._baseState;
    $aOIMZ(state['default'] === null);
    state['default'] = val;
    state.optional = true;
    return this;
};
$f0b7a2ced72bd4e2$var$Node.prototype.explicit = function explicit(num) {
    var state = this._baseState;
    $aOIMZ(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$f0b7a2ced72bd4e2$var$Node.prototype.implicit = function implicit(num) {
    var state = this._baseState;
    $aOIMZ(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$f0b7a2ced72bd4e2$var$Node.prototype.obj = function obj() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$f0b7a2ced72bd4e2$var$Node.prototype.key = function key(newKey) {
    var state = this._baseState;
    $aOIMZ(state.key === null);
    state.key = newKey;
    return this;
};
$f0b7a2ced72bd4e2$var$Node.prototype.any = function any() {
    var state = this._baseState;
    state.any = true;
    return this;
};
$f0b7a2ced72bd4e2$var$Node.prototype.choice = function choice(obj) {
    var state = this._baseState;
    $aOIMZ(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$f0b7a2ced72bd4e2$var$Node.prototype.contains = function contains(item) {
    var state = this._baseState;
    $aOIMZ(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$f0b7a2ced72bd4e2$var$Node.prototype._decode = function decode(input, options) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    var result = state['default'];
    var present = true;
    var prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        var tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            var save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    var prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            var explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        var start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            if (state.any) var save = input.save();
            var body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, 'tagged');
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, 'content');
        // Select proper method for tag
        if (state.any) result;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
            var data = new $f0b7a2ced72bd4e2$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$f0b7a2ced72bd4e2$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    var state = this._baseState;
    if (tag === 'seq' || tag === 'set') return null;
    if (tag === 'seqof' || tag === 'setof') return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === 'objid' && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === 'objid') return this._decodeObjid(input, null, null, options);
    else if (tag === 'gentime' || tag === 'utctime') return this._decodeTime(input, tag, options);
    else if (tag === 'null_') return this._decodeNull(input, options);
    else if (tag === 'bool') return this._decodeBool(input, options);
    else if (tag === 'objDesc') return this._decodeStr(input, tag, options);
    else if (tag === 'int' || tag === 'enum') return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error('unknown tag: ' + tag);
};
$f0b7a2ced72bd4e2$var$Node.prototype._getUse = function _getUse(entity, obj) {
    var state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $aOIMZ(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$f0b7a2ced72bd4e2$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    var state = this._baseState;
    var result = null;
    var match = false;
    Object.keys(state.choice).some(function(key) {
        var save = input.save();
        var node = state.choice[key];
        try {
            var value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error('Choice not matched');
    return result;
};
//
// Encoding
//
$f0b7a2ced72bd4e2$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $f0b7a2ced72bd4e2$require$EncoderBuffer(data, this.reporter);
};
$f0b7a2ced72bd4e2$var$Node.prototype._encode = function encode(data, reporter, parent) {
    var state = this._baseState;
    if (state['default'] !== null && state['default'] === data) return;
    var result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$f0b7a2ced72bd4e2$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $f0b7a2ced72bd4e2$require$Reporter());
    var result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state['default'] !== null) data = state['default'];
        else return;
    }
    // Encode children first
    var content = null;
    var primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === 'null_') return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error('Child should have a key');
            var prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== 'object') return reporter.error('Child expected, but input is not object');
            var res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === 'seqof' || state.tag === 'setof') {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error('Too many args for : ' + state.tag);
            if (!Array.isArray(data)) return reporter.error('seqof/setof, but data is not Array');
            var child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                var state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    var result;
    if (!state.any && state.choice === null) {
        var tag = state.implicit !== null ? state.implicit : state.tag;
        var cls = state.implicit === null ? 'universal' : 'context';
        if (tag === null) {
            if (state.use === null) reporter.error('Tag could be ommited only for .use()');
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, 'context', result);
    return result;
};
$f0b7a2ced72bd4e2$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    var state = this._baseState;
    var node = state.choice[data.type];
    if (!node) $aOIMZ(false, data.type + ' not found in ' + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$f0b7a2ced72bd4e2$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    var state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === 'objid' && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === 'objid') return this._encodeObjid(data, null, null);
    else if (tag === 'gentime' || tag === 'utctime') return this._encodeTime(data, tag);
    else if (tag === 'null_') return this._encodeNull();
    else if (tag === 'int' || tag === 'enum') return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === 'bool') return this._encodeBool(data);
    else if (tag === 'objDesc') return this._encodeStr(data, tag);
    else throw new Error('Unsupported tag: ' + tag);
};
$f0b7a2ced72bd4e2$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$f0b7a2ced72bd4e2$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};

});


parcelRegister("cgbG6", function(module, exports) {
var $8ed009b1b044eb12$var$constants = module.exports;
// Helper
$8ed009b1b044eb12$var$constants._reverse = function reverse(map) {
    var res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        var value = map[key];
        res[value] = key;
    });
    return res;
};

$8ed009b1b044eb12$var$constants.der = (parcelRequire("iMa14"));

});
parcelRegister("iMa14", function(module, exports) {

$parcel$export(module.exports, "tagClass", () => $dab47ab30b53675f$export$3584c46ed60baee8, (v) => $dab47ab30b53675f$export$3584c46ed60baee8 = v);
$parcel$export(module.exports, "tagClassByName", () => $dab47ab30b53675f$export$f18596ef8d632e49, (v) => $dab47ab30b53675f$export$f18596ef8d632e49 = v);
$parcel$export(module.exports, "tag", () => $dab47ab30b53675f$export$2b067c6666111485, (v) => $dab47ab30b53675f$export$2b067c6666111485 = v);
$parcel$export(module.exports, "tagByName", () => $dab47ab30b53675f$export$f17df38a421ab9e3, (v) => $dab47ab30b53675f$export$f17df38a421ab9e3 = v);
var $dab47ab30b53675f$export$3584c46ed60baee8;
var $dab47ab30b53675f$export$f18596ef8d632e49;
var $dab47ab30b53675f$export$2b067c6666111485;
var $dab47ab30b53675f$export$f17df38a421ab9e3;

var $cgbG6 = parcelRequire("cgbG6");
$dab47ab30b53675f$export$3584c46ed60baee8 = {
    0: 'universal',
    1: 'application',
    2: 'context',
    3: 'private'
};
$dab47ab30b53675f$export$f18596ef8d632e49 = $cgbG6._reverse($dab47ab30b53675f$export$3584c46ed60baee8);
$dab47ab30b53675f$export$2b067c6666111485 = {
    0x00: 'end',
    0x01: 'bool',
    0x02: 'int',
    0x03: 'bitstr',
    0x04: 'octstr',
    0x05: 'null_',
    0x06: 'objid',
    0x07: 'objDesc',
    0x08: 'external',
    0x09: 'real',
    0x0a: 'enum',
    0x0b: 'embed',
    0x0c: 'utf8str',
    0x0d: 'relativeOid',
    0x10: 'seq',
    0x11: 'set',
    0x12: 'numstr',
    0x13: 'printstr',
    0x14: 't61str',
    0x15: 'videostr',
    0x16: 'ia5str',
    0x17: 'utctime',
    0x18: 'gentime',
    0x19: 'graphstr',
    0x1a: 'iso646str',
    0x1b: 'genstr',
    0x1c: 'unistr',
    0x1d: 'charstr',
    0x1e: 'bmpstr'
};
$dab47ab30b53675f$export$f17df38a421ab9e3 = $cgbG6._reverse($dab47ab30b53675f$export$2b067c6666111485);

});


parcelRegister("9EvL1", function(module, exports) {
var $70707bd996b6328a$var$decoders = module.exports;

$70707bd996b6328a$var$decoders.der = (parcelRequire("1fGAm"));

$70707bd996b6328a$var$decoders.pem = (parcelRequire("kKHKZ"));

});
parcelRegister("1fGAm", function(module, exports) {

var $lyUaN = parcelRequire("lyUaN");

var $7nj2w = parcelRequire("7nj2w");
var $0e9839ba2999c100$var$base = $7nj2w.base;
var $0e9839ba2999c100$var$bignum = $7nj2w.bignum;
// Import DER constants
var $0e9839ba2999c100$var$der = $7nj2w.constants.der;
function $0e9839ba2999c100$var$DERDecoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $0e9839ba2999c100$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $0e9839ba2999c100$var$DERDecoder;
$0e9839ba2999c100$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!(data instanceof $0e9839ba2999c100$var$base.DecoderBuffer)) data = new $0e9839ba2999c100$var$base.DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $0e9839ba2999c100$var$DERNode(parent) {
    $0e9839ba2999c100$var$base.Node.call(this, 'der', parent);
}
$lyUaN($0e9839ba2999c100$var$DERNode, $0e9839ba2999c100$var$base.Node);
$0e9839ba2999c100$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    var state = buffer.save();
    var decodedTag = $0e9839ba2999c100$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + 'of' === tag || any;
};
$0e9839ba2999c100$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    var decodedTag = $0e9839ba2999c100$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    var len = $0e9839ba2999c100$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + 'of' !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    var state = buffer.save();
    var res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$0e9839ba2999c100$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    while(true){
        var tag = $0e9839ba2999c100$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        var len = $0e9839ba2999c100$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        var res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === 'end') break;
    }
};
$0e9839ba2999c100$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    var result = [];
    while(!buffer.isEmpty()){
        var possibleEnd = this._peekTag(buffer, 'end');
        if (buffer.isError(possibleEnd)) return possibleEnd;
        var res = decoder.decode(buffer, 'der', options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$0e9839ba2999c100$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === 'bitstr') {
        var unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === 'bmpstr') {
        var raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error('Decoding of string type: bmpstr length mismatch');
        var str = '';
        for(var i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === 'numstr') {
        var numstr = buffer.raw().toString('ascii');
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === 'octstr') return buffer.raw();
    else if (tag === 'objDesc') return buffer.raw();
    else if (tag === 'printstr') {
        var printstr = buffer.raw().toString('ascii');
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error('Decoding of string type: ' + tag + ' unsupported');
};
$0e9839ba2999c100$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    var result;
    var identifiers = [];
    var ident = 0;
    while(!buffer.isEmpty()){
        var subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    var first = identifiers[0] / 40 | 0;
    var second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        var tmp = values[result.join(' ')];
        if (tmp === undefined) tmp = values[result.join('.')];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$0e9839ba2999c100$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    var str = buffer.raw().toString();
    if (tag === 'gentime') {
        var year = str.slice(0, 4) | 0;
        var mon = str.slice(4, 6) | 0;
        var day = str.slice(6, 8) | 0;
        var hour = str.slice(8, 10) | 0;
        var min = str.slice(10, 12) | 0;
        var sec = str.slice(12, 14) | 0;
    } else if (tag === 'utctime') {
        var year = str.slice(0, 2) | 0;
        var mon = str.slice(2, 4) | 0;
        var day = str.slice(4, 6) | 0;
        var hour = str.slice(6, 8) | 0;
        var min = str.slice(8, 10) | 0;
        var sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error('Decoding ' + tag + ' time is not supported yet');
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$0e9839ba2999c100$var$DERNode.prototype._decodeNull = function decodeNull(buffer) {
    return null;
};
$0e9839ba2999c100$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    var res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$0e9839ba2999c100$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    var raw = buffer.raw();
    var res = new $0e9839ba2999c100$var$bignum(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$0e9839ba2999c100$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getDecoder('der').tree;
};
// Utility methods
function $0e9839ba2999c100$var$derDecodeTag(buf, fail) {
    var tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    var cls = $0e9839ba2999c100$var$der.tagClass[tag >> 6];
    var primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        var oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    var tagStr = $0e9839ba2999c100$var$der.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $0e9839ba2999c100$var$derDecodeLen(buf, primitive, fail) {
    var len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    var num = len & 0x7f;
    if (num > 4) return buf.error('length octect is too long');
    len = 0;
    for(var i = 0; i < num; i++){
        len <<= 8;
        var j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRegister("kKHKZ", function(module, exports) {

var $lyUaN = parcelRequire("lyUaN");

var $aul3P = parcelRequire("aul3P");
var $f1ba0bbf43f136ce$require$Buffer = $aul3P.Buffer;

var $1fGAm = parcelRequire("1fGAm");
function $f1ba0bbf43f136ce$var$PEMDecoder(entity) {
    $1fGAm.call(this, entity);
    this.enc = 'pem';
}
$lyUaN($f1ba0bbf43f136ce$var$PEMDecoder, $1fGAm);
module.exports = $f1ba0bbf43f136ce$var$PEMDecoder;
$f1ba0bbf43f136ce$var$PEMDecoder.prototype.decode = function decode(data, options) {
    var lines = data.toString().split(/[\r\n]+/g);
    var label = options.label.toUpperCase();
    var re = /^-----(BEGIN|END) ([^-]+)-----$/;
    var start = -1;
    var end = -1;
    for(var i = 0; i < lines.length; i++){
        var match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== 'BEGIN') break;
            start = i;
        } else {
            if (match[1] !== 'END') break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error('PEM section not found for: ' + label);
    var base64 = lines.slice(start + 1, end).join('');
    // Remove excessive symbols
    base64.replace(/[^a-z0-9\+\/=]+/gi, '');
    var input = new $f1ba0bbf43f136ce$require$Buffer(base64, 'base64');
    return $1fGAm.prototype.decode.call(this, input, options);
};

});


parcelRegister("i6gsd", function(module, exports) {
var $d2d58cf9aaab919e$var$encoders = module.exports;

$d2d58cf9aaab919e$var$encoders.der = (parcelRequire("87XP3"));

$d2d58cf9aaab919e$var$encoders.pem = (parcelRequire("2eIuS"));

});
parcelRegister("87XP3", function(module, exports) {

var $lyUaN = parcelRequire("lyUaN");

var $aul3P = parcelRequire("aul3P");
var $5ead61af4dab57dd$require$Buffer = $aul3P.Buffer;

var $7nj2w = parcelRequire("7nj2w");
var $5ead61af4dab57dd$var$base = $7nj2w.base;
// Import DER constants
var $5ead61af4dab57dd$var$der = $7nj2w.constants.der;
function $5ead61af4dab57dd$var$DEREncoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $5ead61af4dab57dd$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $5ead61af4dab57dd$var$DEREncoder;
$5ead61af4dab57dd$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $5ead61af4dab57dd$var$DERNode(parent) {
    $5ead61af4dab57dd$var$base.Node.call(this, 'der', parent);
}
$lyUaN($5ead61af4dab57dd$var$DERNode, $5ead61af4dab57dd$var$base.Node);
$5ead61af4dab57dd$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    var encodedTag = $5ead61af4dab57dd$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        var header = new $5ead61af4dab57dd$require$Buffer(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    var lenOctets = 1;
    for(var i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    var header = new $5ead61af4dab57dd$require$Buffer(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$5ead61af4dab57dd$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === 'bitstr') return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === 'bmpstr') {
        var buf = new $5ead61af4dab57dd$require$Buffer(str.length * 2);
        for(var i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === 'numstr') {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === 'printstr') {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === 'objDesc') return this._createEncoderBuffer(str);
    else return this.reporter.error('Encoding of string type: ' + tag + ' unsupported');
};
$5ead61af4dab57dd$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === 'string') {
        if (!values) return this.reporter.error('string objid given, but no values map found');
        if (!values.hasOwnProperty(id)) return this.reporter.error('objid not found in values map');
        id = values[id].split(/[\s\.]+/g);
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error('Second objid identifier OOB');
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    var size = 0;
    for(var i = 0; i < id.length; i++){
        var ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    var objid = new $5ead61af4dab57dd$require$Buffer(size);
    var offset = objid.length - 1;
    for(var i = id.length - 1; i >= 0; i--){
        var ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $5ead61af4dab57dd$var$two(num) {
    if (num < 10) return '0' + num;
    else return num;
}
$5ead61af4dab57dd$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    var str;
    var date = new Date(time);
    if (tag === 'gentime') str = [
        $5ead61af4dab57dd$var$two(date.getFullYear()),
        $5ead61af4dab57dd$var$two(date.getUTCMonth() + 1),
        $5ead61af4dab57dd$var$two(date.getUTCDate()),
        $5ead61af4dab57dd$var$two(date.getUTCHours()),
        $5ead61af4dab57dd$var$two(date.getUTCMinutes()),
        $5ead61af4dab57dd$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else if (tag === 'utctime') str = [
        $5ead61af4dab57dd$var$two(date.getFullYear() % 100),
        $5ead61af4dab57dd$var$two(date.getUTCMonth() + 1),
        $5ead61af4dab57dd$var$two(date.getUTCDate()),
        $5ead61af4dab57dd$var$two(date.getUTCHours()),
        $5ead61af4dab57dd$var$two(date.getUTCMinutes()),
        $5ead61af4dab57dd$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else this.reporter.error('Encoding ' + tag + ' time is not supported yet');
    return this._encodeStr(str, 'octstr');
};
$5ead61af4dab57dd$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer('');
};
$5ead61af4dab57dd$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === 'string') {
        if (!values) return this.reporter.error('String int or enum given, but no values map');
        if (!values.hasOwnProperty(num)) return this.reporter.error('Values map doesn\'t contain: ' + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== 'number' && !$5ead61af4dab57dd$require$Buffer.isBuffer(num)) {
        var numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = new $5ead61af4dab57dd$require$Buffer(numArray);
    }
    if ($5ead61af4dab57dd$require$Buffer.isBuffer(num)) {
        var size = num.length;
        if (num.length === 0) size++;
        var out = new $5ead61af4dab57dd$require$Buffer(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    var size = 1;
    for(var i = num; i >= 0x100; i >>= 8)size++;
    var out = new Array(size);
    for(var i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer(new $5ead61af4dab57dd$require$Buffer(out));
};
$5ead61af4dab57dd$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$5ead61af4dab57dd$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getEncoder('der').tree;
};
$5ead61af4dab57dd$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    var state = this._baseState;
    var i;
    if (state['default'] === null) return false;
    var data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $5ead61af4dab57dd$var$encodeTag(tag, primitive, cls, reporter) {
    var res;
    if (tag === 'seqof') tag = 'seq';
    else if (tag === 'setof') tag = 'set';
    if ($5ead61af4dab57dd$var$der.tagByName.hasOwnProperty(tag)) res = $5ead61af4dab57dd$var$der.tagByName[tag];
    else if (typeof tag === 'number' && (tag | 0) === tag) res = tag;
    else return reporter.error('Unknown tag: ' + tag);
    if (res >= 0x1f) return reporter.error('Multi-octet tag encoding unsupported');
    if (!primitive) res |= 0x20;
    res |= $5ead61af4dab57dd$var$der.tagClassByName[cls || 'universal'] << 6;
    return res;
}

});

parcelRegister("2eIuS", function(module, exports) {

var $lyUaN = parcelRequire("lyUaN");

var $87XP3 = parcelRequire("87XP3");
function $1a0f67c4be613f4f$var$PEMEncoder(entity) {
    $87XP3.call(this, entity);
    this.enc = 'pem';
}
$lyUaN($1a0f67c4be613f4f$var$PEMEncoder, $87XP3);
module.exports = $1a0f67c4be613f4f$var$PEMEncoder;
$1a0f67c4be613f4f$var$PEMEncoder.prototype.encode = function encode(data, options) {
    var buf = $87XP3.prototype.encode.call(this, data);
    var p = buf.toString('base64');
    var out = [
        '-----BEGIN ' + options.label + '-----'
    ];
    for(var i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push('-----END ' + options.label + '-----');
    return out.join('\n');
};

});



parcelRegister("hZGUx", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
'use strict';

var $7nj2w = parcelRequire("7nj2w");
var $d1996b602810d0a2$var$Time = $7nj2w.define('Time', function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $d1996b602810d0a2$var$AttributeTypeValue = $7nj2w.define('AttributeTypeValue', function() {
    this.seq().obj(this.key('type').objid(), this.key('value').any());
});
var $d1996b602810d0a2$var$AlgorithmIdentifier = $7nj2w.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('parameters').optional());
});
var $d1996b602810d0a2$var$SubjectPublicKeyInfo = $7nj2w.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($d1996b602810d0a2$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
var $d1996b602810d0a2$var$RelativeDistinguishedName = $7nj2w.define('RelativeDistinguishedName', function() {
    this.setof($d1996b602810d0a2$var$AttributeTypeValue);
});
var $d1996b602810d0a2$var$RDNSequence = $7nj2w.define('RDNSequence', function() {
    this.seqof($d1996b602810d0a2$var$RelativeDistinguishedName);
});
var $d1996b602810d0a2$var$Name = $7nj2w.define('Name', function() {
    this.choice({
        rdnSequence: this.use($d1996b602810d0a2$var$RDNSequence)
    });
});
var $d1996b602810d0a2$var$Validity = $7nj2w.define('Validity', function() {
    this.seq().obj(this.key('notBefore').use($d1996b602810d0a2$var$Time), this.key('notAfter').use($d1996b602810d0a2$var$Time));
});
var $d1996b602810d0a2$var$Extension = $7nj2w.define('Extension', function() {
    this.seq().obj(this.key('extnID').objid(), this.key('critical').bool().def(false), this.key('extnValue').octstr());
});
var $d1996b602810d0a2$var$TBSCertificate = $7nj2w.define('TBSCertificate', function() {
    this.seq().obj(this.key('version').explicit(0).int(), this.key('serialNumber').int(), this.key('signature').use($d1996b602810d0a2$var$AlgorithmIdentifier), this.key('issuer').use($d1996b602810d0a2$var$Name), this.key('validity').use($d1996b602810d0a2$var$Validity), this.key('subject').use($d1996b602810d0a2$var$Name), this.key('subjectPublicKeyInfo').use($d1996b602810d0a2$var$SubjectPublicKeyInfo), this.key('issuerUniqueID').implicit(1).bitstr().optional(), this.key('subjectUniqueID').implicit(2).bitstr().optional(), this.key('extensions').explicit(3).seqof($d1996b602810d0a2$var$Extension).optional());
});
var $d1996b602810d0a2$var$X509Certificate = $7nj2w.define('X509Certificate', function() {
    this.seq().obj(this.key('tbsCertificate').use($d1996b602810d0a2$var$TBSCertificate), this.key('signatureAlgorithm').use($d1996b602810d0a2$var$AlgorithmIdentifier), this.key('signatureValue').bitstr());
});
module.exports = $d1996b602810d0a2$var$X509Certificate;

});


parcelRegister("fJ1z5", function(module, exports) {
module.exports = JSON.parse("{\"2.16.840.1.101.3.4.1.1\":\"aes-128-ecb\",\"2.16.840.1.101.3.4.1.2\":\"aes-128-cbc\",\"2.16.840.1.101.3.4.1.3\":\"aes-128-ofb\",\"2.16.840.1.101.3.4.1.4\":\"aes-128-cfb\",\"2.16.840.1.101.3.4.1.21\":\"aes-192-ecb\",\"2.16.840.1.101.3.4.1.22\":\"aes-192-cbc\",\"2.16.840.1.101.3.4.1.23\":\"aes-192-ofb\",\"2.16.840.1.101.3.4.1.24\":\"aes-192-cfb\",\"2.16.840.1.101.3.4.1.41\":\"aes-256-ecb\",\"2.16.840.1.101.3.4.1.42\":\"aes-256-cbc\",\"2.16.840.1.101.3.4.1.43\":\"aes-256-ofb\",\"2.16.840.1.101.3.4.1.44\":\"aes-256-cfb\"}");

});

parcelRegister("1qG0a", function(module, exports) {
// adapted from https://github.com/apatil/pemstrip

var $aul3P = parcelRequire("aul3P");
var $10a8cccf60464d54$require$Buffer = $aul3P.Buffer;
var $10a8cccf60464d54$var$findProc = /Proc-Type: 4,ENCRYPTED\n\r?DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)\n\r?\n\r?([0-9A-z\n\r\+\/\=]+)\n\r?/m;
var $10a8cccf60464d54$var$startRegex = /^-----BEGIN ((?:.* KEY)|CERTIFICATE)-----\n/m;
var $10a8cccf60464d54$var$fullRegex = /^-----BEGIN ((?:.* KEY)|CERTIFICATE)-----\n\r?([0-9A-z\n\r\+\/\=]+)\n\r?-----END \1-----$/m;

var $d9sFZ = parcelRequire("d9sFZ");

var $FyTgm = parcelRequire("FyTgm");
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($10a8cccf60464d54$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($10a8cccf60464d54$var$fullRegex);
        decrypted = new $10a8cccf60464d54$require$Buffer(match2[2].replace(/\r?\n/g, ''), 'base64');
    } else {
        var suite = 'aes' + match[1];
        var iv = new $10a8cccf60464d54$require$Buffer(match[2], 'hex');
        var cipherText = new $10a8cccf60464d54$require$Buffer(match[3].replace(/\r?\n/g, ''), 'base64');
        var cipherKey = $d9sFZ(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $FyTgm.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher.final());
        decrypted = $10a8cccf60464d54$require$Buffer.concat(out);
    }
    var tag = key.match($10a8cccf60464d54$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});


parcelRegister("fyXn0", function(module, exports) {
module.exports = JSON.parse("{\"1.3.132.0.10\":\"secp256k1\",\"1.3.132.0.33\":\"p224\",\"1.2.840.10045.3.1.1\":\"p192\",\"1.2.840.10045.3.1.7\":\"p256\",\"1.3.132.0.34\":\"p384\",\"1.3.132.0.35\":\"p521\"}");

});


parcelRegister("bdxL8", function(module, exports) {
// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js

var $aul3P = parcelRequire("aul3P");
var $82ab18793442ce1b$require$Buffer = $aul3P.Buffer;

var $61SlE = parcelRequire("61SlE");

var $6nTxf = parcelRequire("6nTxf");
var $82ab18793442ce1b$require$EC = $6nTxf.ec;

var $lXsfV = parcelRequire("lXsfV");

var $fyXn0 = parcelRequire("fyXn0");
function $82ab18793442ce1b$var$verify(sig, hash, key, signType, tag) {
    var pub = $lXsfV(key);
    if (pub.type === 'ec') {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
        return $82ab18793442ce1b$var$ecVerify(sig, hash, pub);
    } else if (pub.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong public key type');
        return $82ab18793442ce1b$var$dsaVerify(sig, hash, pub);
    } else {
        if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
    }
    hash = $82ab18793442ce1b$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum++;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = new $82ab18793442ce1b$require$Buffer(pad);
    var red = $61SlE.mont(pub.modulus);
    sig = new $61SlE(sig).toRed(red);
    sig = sig.redPow(new $61SlE(pub.publicExponent));
    sig = new $82ab18793442ce1b$require$Buffer(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $82ab18793442ce1b$var$ecVerify(sig, hash, pub) {
    var curveId = $fyXn0[pub.data.algorithm.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'));
    var curve = new $82ab18793442ce1b$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $82ab18793442ce1b$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $lXsfV.signature.decode(sig, 'der');
    var s = unpacked.s;
    var r = unpacked.r;
    $82ab18793442ce1b$var$checkValue(s, q);
    $82ab18793442ce1b$var$checkValue(r, q);
    var montp = $61SlE.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $61SlE(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $82ab18793442ce1b$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error('invalid sig');
    if (b.cmp(q) >= q) throw new Error('invalid sig');
}
module.exports = $82ab18793442ce1b$var$verify;

});


parcelRegister("ks6qZ", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $ee3b69e69526809e$require$Buffer = $aul3P.Buffer;

var $6nTxf = parcelRequire("6nTxf");

var $61SlE = parcelRequire("61SlE");
module.exports = function createECDH(curve) {
    return new $ee3b69e69526809e$var$ECDH(curve);
};
var $ee3b69e69526809e$var$aliases = {
    secp256k1: {
        name: 'secp256k1',
        byteLength: 32
    },
    secp224r1: {
        name: 'p224',
        byteLength: 28
    },
    prime256v1: {
        name: 'p256',
        byteLength: 32
    },
    prime192v1: {
        name: 'p192',
        byteLength: 24
    },
    ed25519: {
        name: 'ed25519',
        byteLength: 32
    },
    secp384r1: {
        name: 'p384',
        byteLength: 48
    },
    secp521r1: {
        name: 'p521',
        byteLength: 66
    }
};
$ee3b69e69526809e$var$aliases.p224 = $ee3b69e69526809e$var$aliases.secp224r1;
$ee3b69e69526809e$var$aliases.p256 = $ee3b69e69526809e$var$aliases.secp256r1 = $ee3b69e69526809e$var$aliases.prime256v1;
$ee3b69e69526809e$var$aliases.p192 = $ee3b69e69526809e$var$aliases.secp192r1 = $ee3b69e69526809e$var$aliases.prime192v1;
$ee3b69e69526809e$var$aliases.p384 = $ee3b69e69526809e$var$aliases.secp384r1;
$ee3b69e69526809e$var$aliases.p521 = $ee3b69e69526809e$var$aliases.secp521r1;
function $ee3b69e69526809e$var$ECDH(curve) {
    this.curveType = $ee3b69e69526809e$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $6nTxf.ec(this.curveType.name);
    this.keys = void 0;
}
$ee3b69e69526809e$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$ee3b69e69526809e$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || 'utf8';
    if (!$ee3b69e69526809e$require$Buffer.isBuffer(other)) other = new $ee3b69e69526809e$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $ee3b69e69526809e$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$ee3b69e69526809e$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === 'compressed', true);
    if (format === 'hybrid') {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $ee3b69e69526809e$var$formatReturnValue(key, enc);
};
$ee3b69e69526809e$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $ee3b69e69526809e$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$ee3b69e69526809e$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || 'utf8';
    if (!$ee3b69e69526809e$require$Buffer.isBuffer(pub)) pub = new $ee3b69e69526809e$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$ee3b69e69526809e$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || 'utf8';
    if (!$ee3b69e69526809e$require$Buffer.isBuffer(priv)) priv = new $ee3b69e69526809e$require$Buffer(priv, enc);
    var _priv = new $61SlE(priv);
    _priv = _priv.toString(16);
    this.keys._importPrivate(_priv);
    return this;
};
function $ee3b69e69526809e$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $ee3b69e69526809e$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $ee3b69e69526809e$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $ee3b69e69526809e$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});

parcelRegister("bZRnR", function(module, exports) {

$parcel$export(module.exports, "publicEncrypt", () => $8bbecd28b745cfbe$export$512823e338ddb1b7, (v) => $8bbecd28b745cfbe$export$512823e338ddb1b7 = v);
$parcel$export(module.exports, "privateDecrypt", () => $8bbecd28b745cfbe$export$7efb24e2fddf99b9, (v) => $8bbecd28b745cfbe$export$7efb24e2fddf99b9 = v);
$parcel$export(module.exports, "privateEncrypt", () => $8bbecd28b745cfbe$export$9d0e0c0c4a8d30f3, (v) => $8bbecd28b745cfbe$export$9d0e0c0c4a8d30f3 = v);
$parcel$export(module.exports, "publicDecrypt", () => $8bbecd28b745cfbe$export$b9d55ff329113abd, (v) => $8bbecd28b745cfbe$export$b9d55ff329113abd = v);
var $8bbecd28b745cfbe$export$512823e338ddb1b7;
var $8bbecd28b745cfbe$export$7efb24e2fddf99b9;
var $8bbecd28b745cfbe$export$9d0e0c0c4a8d30f3;
var $8bbecd28b745cfbe$export$b9d55ff329113abd;

$8bbecd28b745cfbe$export$512823e338ddb1b7 = (parcelRequire("bFrdv"));

$8bbecd28b745cfbe$export$7efb24e2fddf99b9 = (parcelRequire("9r10x"));
$8bbecd28b745cfbe$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $8bbecd28b745cfbe$export$512823e338ddb1b7(key, buf, true);
};
$8bbecd28b745cfbe$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $8bbecd28b745cfbe$export$7efb24e2fddf99b9(key, buf, true);
};

});
parcelRegister("bFrdv", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $87e8a2b93b4dc2f1$require$Buffer = $aul3P.Buffer;

var $lXsfV = parcelRequire("lXsfV");

var $ugwNY = parcelRequire("ugwNY");

var $cnL2y = parcelRequire("cnL2y");

var $6y9Gi = parcelRequire("6y9Gi");

var $dphJC = parcelRequire("dphJC");

var $61SlE = parcelRequire("61SlE");

var $6P0f1 = parcelRequire("6P0f1");

var $kFMzy = parcelRequire("kFMzy");
var $87e8a2b93b4dc2f1$var$constants = {
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_PKCS1_PADDIN: 1,
    RSA_NO_PADDING: 3
};
module.exports = function publicEncrypt(public_key, msg, reverse) {
    var padding;
    if (public_key.padding) padding = public_key.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $lXsfV(public_key);
    var paddedMsg;
    if (padding === 4) paddedMsg = $87e8a2b93b4dc2f1$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $87e8a2b93b4dc2f1$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $61SlE(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error('data too long for modulus');
    } else throw new Error('unknown padding');
    if (reverse) return $kFMzy(paddedMsg, key);
    else return $6P0f1(paddedMsg, key);
};
function $87e8a2b93b4dc2f1$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $cnL2y('sha1').update(new $87e8a2b93b4dc2f1$require$Buffer('')).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error('message too long');
    var ps = new $87e8a2b93b4dc2f1$require$Buffer(k - mLen - hLen2 - 2);
    ps.fill(0);
    var dblen = k - hLen - 1;
    var seed = $ugwNY(hLen);
    var maskedDb = $dphJC($87e8a2b93b4dc2f1$require$Buffer.concat([
        iHash,
        ps,
        new $87e8a2b93b4dc2f1$require$Buffer([
            1
        ]),
        msg
    ], dblen), $6y9Gi(seed, dblen));
    var maskedSeed = $dphJC(seed, $6y9Gi(maskedDb, hLen));
    return new $61SlE($87e8a2b93b4dc2f1$require$Buffer.concat([
        new $87e8a2b93b4dc2f1$require$Buffer([
            0
        ]),
        maskedSeed,
        maskedDb
    ], k));
}
function $87e8a2b93b4dc2f1$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error('message too long');
    var ps;
    if (reverse) {
        ps = new $87e8a2b93b4dc2f1$require$Buffer(k - mLen - 3);
        ps.fill(0xff);
    } else ps = $87e8a2b93b4dc2f1$var$nonZero(k - mLen - 3);
    return new $61SlE($87e8a2b93b4dc2f1$require$Buffer.concat([
        new $87e8a2b93b4dc2f1$require$Buffer([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        new $87e8a2b93b4dc2f1$require$Buffer([
            0
        ]),
        msg
    ], k));
}
function $87e8a2b93b4dc2f1$var$nonZero(len, crypto) {
    var out = new $87e8a2b93b4dc2f1$require$Buffer(len);
    var i = 0;
    var cache = $ugwNY(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $ugwNY(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRegister("6y9Gi", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $4c4d6d8832c8b18b$require$Buffer = $aul3P.Buffer;

var $cnL2y = parcelRequire("cnL2y");
module.exports = function(seed, len) {
    var t = new $4c4d6d8832c8b18b$require$Buffer('');
    var i = 0, c;
    while(t.length < len){
        c = $4c4d6d8832c8b18b$var$i2ops(i++);
        t = $4c4d6d8832c8b18b$require$Buffer.concat([
            t,
            $cnL2y('sha1').update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $4c4d6d8832c8b18b$var$i2ops(c) {
    var out = new $4c4d6d8832c8b18b$require$Buffer(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRegister("dphJC", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRegister("6P0f1", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $4f77b16f6d4bef69$require$Buffer = $aul3P.Buffer;

var $61SlE = parcelRequire("61SlE");
function $4f77b16f6d4bef69$var$withPublic(paddedMsg, key) {
    return new $4f77b16f6d4bef69$require$Buffer(paddedMsg.toRed($61SlE.mont(key.modulus)).redPow(new $61SlE(key.publicExponent)).fromRed().toArray());
}
module.exports = $4f77b16f6d4bef69$var$withPublic;

});


parcelRegister("9r10x", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $6de76ac48d76b0c4$require$Buffer = $aul3P.Buffer;

var $lXsfV = parcelRequire("lXsfV");

var $6y9Gi = parcelRequire("6y9Gi");

var $dphJC = parcelRequire("dphJC");

var $61SlE = parcelRequire("61SlE");

var $kFMzy = parcelRequire("kFMzy");

var $cnL2y = parcelRequire("cnL2y");

var $6P0f1 = parcelRequire("6P0f1");
module.exports = function privateDecrypt(private_key, enc, reverse) {
    var padding;
    if (private_key.padding) padding = private_key.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $lXsfV(private_key);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $61SlE(enc).cmp(key.modulus) >= 0) throw new Error('decryption error');
    var msg;
    if (reverse) msg = $6P0f1(new $61SlE(enc), key);
    else msg = $kFMzy(enc, key);
    var zBuffer = new $6de76ac48d76b0c4$require$Buffer(k - msg.length);
    zBuffer.fill(0);
    msg = $6de76ac48d76b0c4$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $6de76ac48d76b0c4$var$oaep(key, msg);
    else if (padding === 1) return $6de76ac48d76b0c4$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error('unknown padding');
};
function $6de76ac48d76b0c4$var$oaep(key, msg) {
    var n = key.modulus;
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $cnL2y('sha1').update(new $6de76ac48d76b0c4$require$Buffer('')).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (msg[0] !== 0) throw new Error('decryption error');
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $dphJC(maskedSeed, $6y9Gi(maskedDb, hLen));
    var db = $dphJC(maskedDb, $6y9Gi(seed, k - hLen - 1));
    if ($6de76ac48d76b0c4$var$compare(iHash, db.slice(0, hLen))) throw new Error('decryption error');
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error('decryption error');
    return db.slice(i);
}
function $6de76ac48d76b0c4$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    var p2 = msg.slice(i - 1, i);
    if (p1.toString('hex') !== '0002' && !reverse || p1.toString('hex') !== '0001' && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error('decryption error');
    return msg.slice(i);
}
function $6de76ac48d76b0c4$var$compare(a, b) {
    a = new $6de76ac48d76b0c4$require$Buffer(a);
    b = new $6de76ac48d76b0c4$require$Buffer(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});


parcelRegister("hF130", function(module, exports) {

$parcel$export(module.exports, "randomFill", () => $cdb7140970b08e8d$export$bb1abf2ce84fc7e8, (v) => $cdb7140970b08e8d$export$bb1abf2ce84fc7e8 = v);
$parcel$export(module.exports, "randomFillSync", () => $cdb7140970b08e8d$export$2f7171e78e524d5e, (v) => $cdb7140970b08e8d$export$2f7171e78e524d5e = v);
var $cdb7140970b08e8d$export$bb1abf2ce84fc7e8;
var $cdb7140970b08e8d$export$2f7171e78e524d5e;

var $2fFJv = parcelRequire("2fFJv");
'use strict';
function $cdb7140970b08e8d$var$oldBrowser() {
    throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11');
}

var $ijh2q = parcelRequire("ijh2q");

var $ugwNY = parcelRequire("ugwNY");
var $cdb7140970b08e8d$var$Buffer = $ijh2q.Buffer;
var $cdb7140970b08e8d$var$kBufferMaxLength = $ijh2q.kMaxLength;
var $cdb7140970b08e8d$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $cdb7140970b08e8d$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $cdb7140970b08e8d$var$assertOffset(offset, length) {
    if (typeof offset !== 'number' || offset !== offset) throw new TypeError('offset must be a number');
    if (offset > $cdb7140970b08e8d$var$kMaxUint32 || offset < 0) throw new TypeError('offset must be a uint32');
    if (offset > $cdb7140970b08e8d$var$kBufferMaxLength || offset > length) throw new RangeError('offset out of range');
}
function $cdb7140970b08e8d$var$assertSize(size, offset, length) {
    if (typeof size !== 'number' || size !== size) throw new TypeError('size must be a number');
    if (size > $cdb7140970b08e8d$var$kMaxUint32 || size < 0) throw new TypeError('size must be a uint32');
    if (size + offset > length || size > $cdb7140970b08e8d$var$kBufferMaxLength) throw new RangeError('buffer too small');
}
if ($cdb7140970b08e8d$var$crypto && $cdb7140970b08e8d$var$crypto.getRandomValues || false) {
    $cdb7140970b08e8d$export$bb1abf2ce84fc7e8 = $cdb7140970b08e8d$var$randomFill;
    $cdb7140970b08e8d$export$2f7171e78e524d5e = $cdb7140970b08e8d$var$randomFillSync;
} else {
    $cdb7140970b08e8d$export$bb1abf2ce84fc7e8 = $cdb7140970b08e8d$var$oldBrowser;
    $cdb7140970b08e8d$export$2f7171e78e524d5e = $cdb7140970b08e8d$var$oldBrowser;
}
function $cdb7140970b08e8d$var$randomFill(buf, offset, size, cb) {
    if (!$cdb7140970b08e8d$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === 'function') {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === 'function') {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== 'function') throw new TypeError('"cb" argument must be a function');
    $cdb7140970b08e8d$var$assertOffset(offset, buf.length);
    $cdb7140970b08e8d$var$assertSize(size, offset, buf.length);
    return $cdb7140970b08e8d$var$actualFill(buf, offset, size, cb);
}
function $cdb7140970b08e8d$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $cdb7140970b08e8d$var$crypto.getRandomValues(uint);
    if (cb) {
        $2fFJv.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $ugwNY(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $ugwNY(size);
    bytes.copy(buf, offset);
    return buf;
}
function $cdb7140970b08e8d$var$randomFillSync(buf, offset, size) {
    if (typeof offset === 'undefined') offset = 0;
    if (!$cdb7140970b08e8d$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $cdb7140970b08e8d$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $cdb7140970b08e8d$var$assertSize(size, offset, buf.length);
    return $cdb7140970b08e8d$var$actualFill(buf, offset, size);
}

});



parcelRegister("g8JvH", function(module, exports) {

$parcel$export(module.exports, "AnalyticsEventToProps", () => $4e66802e461455f0$export$3e9ef96ba97ea9dc);

var $2jDha = parcelRequire("2jDha");
const $4e66802e461455f0$export$871de8747c9eaa88 = (props, componentName)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(props).reduce((result, key)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result,
            [key]: {
                action: props[key],
                actionSubject: componentName
            }
        }), {});
const $4e66802e461455f0$export$3e9ef96ba97ea9dc = (componentName, eventActions)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (WrappedComponent)=>(0, $2jDha.default)($4e66802e461455f0$export$871de8747c9eaa88(eventActions, componentName))(WrappedComponent);

});

parcelRegister("bICpe", function(module, exports) {

$parcel$export(module.exports, "getSafeValue", () => $13683bbd54f5e2c1$export$d05672fd1312a6d);
$parcel$export(module.exports, "getSafeOptionsForAnalytics", () => $13683bbd54f5e2c1$export$fde3d804891b8254);
$parcel$export(module.exports, "flattenOptions", () => $13683bbd54f5e2c1$export$7baa7c13b358b002);
$parcel$export(module.exports, "getOptionValuesLengths", () => $13683bbd54f5e2c1$export$e2e167245697ed4e);
$parcel$export(module.exports, "filterOptions", () => $13683bbd54f5e2c1$export$60d56ed3961c839c);

var $9OdO2 = parcelRequire("9OdO2");

var $azx3n = parcelRequire("azx3n");
const $13683bbd54f5e2c1$export$d05672fd1312a6d = (val)=>(0, $azx3n.memoizedHashString)(val.toString()).toString();
const $13683bbd54f5e2c1$export$fde3d804891b8254 = (items)=>items.filter((item)=>item.value).map(({ value: value })=>$13683bbd54f5e2c1$export$d05672fd1312a6d(value));
const $13683bbd54f5e2c1$export$7baa7c13b358b002 = (optionGroups)=>(0, (/*@__PURE__*/$parcel$interopDefault($9OdO2)))(optionGroups.map((group)=>group.options));
const $13683bbd54f5e2c1$export$e2e167245697ed4e = (items)=>items.filter((item)=>item.value).map(({ value: value })=>value != null ? `${value}`.length : 0);
const $13683bbd54f5e2c1$export$60d56ed3961c839c = (options, query)=>options.filter((option)=>typeof option.value === 'string' && option.value.toLowerCase().includes((query || '').toLowerCase()) || typeof option.label === 'string' && option.label.toLowerCase().includes((query || '').toLowerCase()));

});
parcelRegister("9OdO2", function(module, exports) {

var $hKE3p = parcelRequire("hKE3p");

var $eo8NR = parcelRequire("eo8NR");
/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $72437e2c2a373df9$var$flatMap(collection, iteratee) {
    return $hKE3p($eo8NR(collection, iteratee), 1);
}
module.exports = $72437e2c2a373df9$var$flatMap;

});
parcelRegister("eo8NR", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");

var $7qARj = parcelRequire("7qARj");

var $iA1h1 = parcelRequire("iA1h1");

var $1c8hB = parcelRequire("1c8hB");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $a79a22b5b4895d6c$var$map(collection, iteratee) {
    var func = $1c8hB(collection) ? $kJvGp : $iA1h1;
    return func(collection, $7qARj(iteratee, 3));
}
module.exports = $a79a22b5b4895d6c$var$map;

});




parcelRegister("63Mv3", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a079fc0d1c4986e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9a079fc0d1c4986e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    empty: {
        "id": "issue-field-labels.edit.empty",
        "defaultMessage": "No matches found"
    },
    failedFetch: {
        "id": "issue-field-labels.edit.failed-fetch",
        "defaultMessage": "Search failed. Please try again."
    },
    placeholder: {
        "id": "issue-field-labels.edit.placeholder",
        "defaultMessage": "Select label"
    },
    createNewItem: {
        "id": "issue-field-labels.edit.create-new-item",
        "defaultMessage": "New label"
    },
    loading: {
        "id": "issue-field-labels.edit.loading",
        "defaultMessage": "Searching..."
    },
    recent: {
        "id": "issue-field-labels.edit.recent",
        "defaultMessage": "Recent labels"
    },
    all: {
        "id": "issue-field-labels.edit.all",
        "defaultMessage": "All labels"
    }
});

});


parcelRegister("6Wef2", function(module, exports) {

$parcel$export(module.exports, "mapDataToLabelOptions", () => $1a006528ac4d483a$export$cd8e373d5b1325b1);
$parcel$export(module.exports, "mutateLabelsFields", () => $1a006528ac4d483a$export$f691a7c5b86be653);

const $1a006528ac4d483a$export$cd8e373d5b1325b1 = (data)=>data.map(({ name: name })=>({
            value: name,
            label: name
        }));
const $1a006528ac4d483a$export$f691a7c5b86be653 = (selectedLabels, fieldId)=>({
        fieldId: fieldId,
        labels: selectedLabels.map(({ value: value })=>({
                name: value
            })),
        mutationGroup: (0, $f4d348fab48bf1e9$export$31fd86f8f183952c)
    });

});
const $f4d348fab48bf1e9$export$31fd86f8f183952c = 'labelsFields';



parcelRegister("9PXwb", function(module, exports) {

$parcel$export(module.exports, "getFileIdsFromFiles", () => $8a78f806d9d9e125$export$90bf402b5b4274c7);
$parcel$export(module.exports, "validateAttachment", () => $8a78f806d9d9e125$export$8af997fabc69757a);
$parcel$export(module.exports, "getFieldDropZoneContainerID", () => $8a78f806d9d9e125$export$2fab292eea84487a);

var $dEMIg = parcelRequire("dEMIg");
const $8a78f806d9d9e125$export$90bf402b5b4274c7 = (files)=>files.map((file)=>file.id.toString());
const $8a78f806d9d9e125$export$8af997fabc69757a = (value, isRequired)=>{
    if (isRequired) {
        if (!value || value.length === 0) return 0, $dEMIg.REQUIRED;
    }
    return undefined;
};
const $8a78f806d9d9e125$export$2fab292eea84487a = (fieldId)=>`${fieldId ? `${fieldId}-` : ''}dropzone-container`;

});

parcelRegister("6BUcO", function(module, exports) {

$parcel$export(module.exports, "getIsTimeEstimateExceeded", () => $7237b0c35d191813$export$20e7052b315e94b);
$parcel$export(module.exports, "getCalculatedTimeRemainingIfAny", () => $7237b0c35d191813$export$51a45955a3207e1b);
$parcel$export(module.exports, "getLogWorkSubmitValue", () => $7237b0c35d191813$export$7d47ca3907f5addd);

var $EN9B6 = parcelRequire("EN9B6");

var $7Ymv3 = parcelRequire("7Ymv3");
var $734NL = parcelRequire("734NL");
var $eH7pq = parcelRequire("eH7pq");
const $7237b0c35d191813$export$20e7052b315e94b = (args)=>{
    const { config: config, timeTrackingValue: timeTrackingValue, timeSpent: timeSpent, timeRemaining: timeRemaining } = args;
    const isTimeRemainingValid = (0, $7Ymv3.isValidTimeString)(config)(timeRemaining);
    const isTimeSpentValid = (0, $7Ymv3.isValidTimeString)(config)(timeSpent);
    const isTimeTrackingValid = (0, $7Ymv3.isValidTimeString)(config)(timeTrackingValue);
    if (isTimeTrackingValid && (isTimeRemainingValid || isTimeSpentValid)) {
        let timeSpentInSeconds = 0;
        let timeRemainingInSeconds = 0;
        const timeTrackingValueInSeconds = (0, $eH7pq.default)(config.daysPerWeek, config.hoursPerDay)(timeTrackingValue);
        if (isTimeSpentValid) // @ts-expect-error - TS2322 - Type 'number | null' is not assignable to type 'number'.
        timeSpentInSeconds = (0, $eH7pq.default)(config.daysPerWeek, config.hoursPerDay)(timeSpent);
        if (isTimeRemainingValid) // @ts-expect-error - TS2322 - Type 'number | null' is not assignable to type 'number'.
        timeRemainingInSeconds = (0, $eH7pq.default)(config.daysPerWeek, config.hoursPerDay)(timeRemaining);
        timeRemainingInSeconds = typeof timeRemainingInSeconds !== 'number' ? 0 : timeRemainingInSeconds;
        timeSpentInSeconds = typeof timeSpentInSeconds !== 'number' ? 0 : timeSpentInSeconds;
        if (typeof timeTrackingValueInSeconds === 'number') {
            if (timeSpentInSeconds + timeRemainingInSeconds > timeTrackingValueInSeconds) return true;
        }
    }
    return false;
};
const $7237b0c35d191813$export$51a45955a3207e1b = (args)=>{
    let calculatedTimeRemaining = null;
    const { timeSpent: timeSpent, timeTrackingValue: timeTrackingValue, config: config } = args;
    const isValidTimeTrackingValue = (0, $7Ymv3.isValidTimeString)(config)(timeTrackingValue);
    if (!timeSpent && isValidTimeTrackingValue) return timeTrackingValue;
    const isValidTimeSpent = (0, $7Ymv3.isValidTimeString)(config)(timeSpent);
    if (isValidTimeTrackingValue && isValidTimeSpent) {
        const timeSpentInSeconds = (0, $eH7pq.default)(config.daysPerWeek, config.hoursPerDay)(timeSpent) || 0;
        const timeTrackingInSeconds = (0, $eH7pq.default)(config.daysPerWeek, config.hoursPerDay)(timeTrackingValue) || 0;
        if (timeTrackingInSeconds >= timeSpentInSeconds) calculatedTimeRemaining = (0, $734NL.default)(config.daysPerWeek, config.hoursPerDay)(timeTrackingInSeconds - timeSpentInSeconds);
    }
    return calculatedTimeRemaining;
};
const $7237b0c35d191813$export$7d47ca3907f5addd = (value)=>{
    const { dateValue: dateValue, timeSpent: timeSpent, timeRemaining: timeRemaining, description: description } = value;
    const adjustEstimate = timeRemaining ? 'new' : 'leave';
    return [
        {
            add: {
                started: dateValue ? (0, $EN9B6.default)(new Date(dateValue), "yyyy-MM-dd'T'HH:mm:ss.SSSxxxx") : undefined,
                timeSpent: timeSpent,
                adjustEstimate: adjustEstimate,
                newEstimate: timeRemaining,
                comment: description && JSON.stringify(description)
            }
        }
    ];
};

});
parcelRegister("7Ymv3", function(module, exports) {

$parcel$export(module.exports, "formatTimeString", () => $344ebf6d57e1d18f$export$2de90790c3ad23b1);
$parcel$export(module.exports, "isValidTimeString", () => $344ebf6d57e1d18f$export$669626963db3b187);
$parcel$export(module.exports, "parseTimeString", () => $344ebf6d57e1d18f$export$53148bfa4e677363);
$parcel$export(module.exports, "secondsToTimeString", () => (parcelRequire("734NL")).default);
$parcel$export(module.exports, "timeStringToSeconds", () => (parcelRequire("eH7pq")).default);
$parcel$export(module.exports, "getDefaultTimeTrackingUnit", () => (parcelRequire("lQaym")).getDefaultTimeTrackingUnit);

var $dVIX2 = parcelRequire("dVIX2");
var $ie5Ph = parcelRequire("ie5Ph");
var $734NL = parcelRequire("734NL");
var $eH7pq = parcelRequire("eH7pq");

var $lQaym = parcelRequire("lQaym");

var $eDEru = parcelRequire("eDEru");
const $344ebf6d57e1d18f$export$2de90790c3ad23b1 = (config)=>(timeValue)=>(0, $734NL.default)(config.daysPerWeek, config.hoursPerDay)(timeValue || 0);
const $344ebf6d57e1d18f$export$5eb9d332712102eb = (config)=>(value)=>{
        let trimmedValue = value.trim();
        // If user doesn't type the valid format (m, h, d, or w), use default unit format set in the configuration.
        if ((0, $dVIX2.isNumeric)(trimmedValue)) {
            const { defaultUnit: defaultUnit } = config;
            trimmedValue = `${trimmedValue}${(0, $lQaym.getDefaultTimeTrackingUnit)(defaultUnit)}`;
        }
        return trimmedValue;
    };
const $344ebf6d57e1d18f$export$669626963db3b187 = (config)=>(value)=>{
        const timeString = $344ebf6d57e1d18f$export$5eb9d332712102eb(config)(value);
        return timeString === '' || (0, $ie5Ph.default)(timeString);
    };
const $344ebf6d57e1d18f$export$53148bfa4e677363 = (config)=>(value)=>{
        const timeString = $344ebf6d57e1d18f$export$5eb9d332712102eb(config)(value);
        if (!$344ebf6d57e1d18f$export$669626963db3b187(config)(timeString)) return 0;
        return (0, $eH7pq.default)(config.daysPerWeek, config.hoursPerDay)(timeString);
    };

});
parcelRegister("dVIX2", function(module, exports) {

$parcel$export(module.exports, "isNumeric", () => $067bfbcbce038d78$export$e90fb89750dba83f);
const $067bfbcbce038d78$export$e90fb89750dba83f = (num)=>num.length > 0 && !Number.isNaN(Number(num));

});

parcelRegister("ie5Ph", function(module, exports) {

$parcel$export(module.exports, "default", () => $77051c53846fa8c6$export$2e2bcd8739ae039);

var $3fphB = parcelRequire("3fphB");

var $eH7pq = parcelRequire("eH7pq");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$77051c53846fa8c6$export$2e2bcd8739ae039 = (timeString)=>{
    // We don't care about daysPerWeek or hoursPerDay - we only need to test that the value can be parsed.
    const result = (0, $eH7pq.default)(1, 1)(timeString);
    return result !== null && (0, (/*@__PURE__*/$parcel$interopDefault($3fphB)))(result);
};

});
parcelRegister("3fphB", function(module, exports) {

var $c1MCs = parcelRequire("c1MCs");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $25d6627b2429993c$var$nativeIsFinite = $c1MCs.isFinite;
/**
 * Checks if `value` is a finite primitive number.
 *
 * **Note:** This method is based on
 * [`Number.isFinite`](https://mdn.io/Number/isFinite).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
 * @example
 *
 * _.isFinite(3);
 * // => true
 *
 * _.isFinite(Number.MIN_VALUE);
 * // => true
 *
 * _.isFinite(Infinity);
 * // => false
 *
 * _.isFinite('3');
 * // => false
 */ function $25d6627b2429993c$var$isFinite(value) {
    return typeof value == 'number' && $25d6627b2429993c$var$nativeIsFinite(value);
}
module.exports = $25d6627b2429993c$var$isFinite;

});

parcelRegister("eH7pq", function(module, exports) {

$parcel$export(module.exports, "default", () => $283b92ae394aef5a$export$2e2bcd8739ae039);
const $283b92ae394aef5a$var$MINUTES_PER_HOUR = 60;
const $283b92ae394aef5a$var$SECONDS_PER_MINUTE = 60;
const $283b92ae394aef5a$var$UNIT_STRING_PATTERN = /^(\d+(?:\.\d+)?)([wdhm])$/;
const $283b92ae394aef5a$var$convertToUnitQuantity = (rawString)=>{
    const matches = $283b92ae394aef5a$var$UNIT_STRING_PATTERN.exec(rawString);
    if (!matches) return null;
    return {
        quantity: parseFloat(matches[1]),
        unit: matches[2]
    };
};
const $283b92ae394aef5a$var$timeStringToSeconds = (daysPerWeek, hoursPerDay)=>{
    const unitDefinitions = [
        {
            unit: 'w',
            seconds: daysPerWeek * hoursPerDay * $283b92ae394aef5a$var$MINUTES_PER_HOUR * $283b92ae394aef5a$var$SECONDS_PER_MINUTE
        },
        {
            unit: 'd',
            seconds: hoursPerDay * $283b92ae394aef5a$var$MINUTES_PER_HOUR * $283b92ae394aef5a$var$SECONDS_PER_MINUTE
        },
        {
            unit: 'h',
            seconds: $283b92ae394aef5a$var$MINUTES_PER_HOUR * $283b92ae394aef5a$var$SECONDS_PER_MINUTE
        },
        {
            unit: 'm',
            seconds: $283b92ae394aef5a$var$SECONDS_PER_MINUTE
        }
    ];
    return (timeString)=>{
        // Split up the time string, and parse it into an array of UnitQuantities.
        const unitQuantities = timeString.split(' ').map($283b92ae394aef5a$var$convertToUnitQuantity);
        let quantitiesConsumed = 0;
        let seconds = 0;
        for(let i = 0; i < unitDefinitions.length; i += 1){
            // If we have consumed all the quantity-unit pairs in the string
            // we are done.
            if (quantitiesConsumed === unitQuantities.length) break;
            const unitDefinition = unitDefinitions[i];
            const unitQuantity = unitQuantities[quantitiesConsumed];
            if (!unitQuantity) return null;
            // If the quantity-unit pair matches the unit definition we are up to, consume it.
            if (unitQuantity.unit === unitDefinition.unit) {
                seconds += unitQuantity.quantity * unitDefinition.seconds;
                quantitiesConsumed += 1;
            }
        }
        // We have made it through all the unit definitions, but there is still some left-over input
        if (quantitiesConsumed < unitQuantities.length) return null;
        return Math.floor(seconds);
    };
};
var $283b92ae394aef5a$export$2e2bcd8739ae039 = $283b92ae394aef5a$var$timeStringToSeconds;

});


parcelRegister("734NL", function(module, exports) {

$parcel$export(module.exports, "default", () => $f60e814852ba3602$export$2e2bcd8739ae039);
const $f60e814852ba3602$var$MINUTES_PER_HOUR = 60;
const $f60e814852ba3602$var$SECONDS_PER_MINUTE = 60;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f60e814852ba3602$export$2e2bcd8739ae039 = (daysPerWeek, hoursPerDay)=>{
    const units = [
        {
            suffix: 'w',
            seconds: daysPerWeek * hoursPerDay * $f60e814852ba3602$var$MINUTES_PER_HOUR * $f60e814852ba3602$var$SECONDS_PER_MINUTE
        },
        {
            suffix: 'd',
            seconds: hoursPerDay * $f60e814852ba3602$var$MINUTES_PER_HOUR * $f60e814852ba3602$var$SECONDS_PER_MINUTE
        },
        {
            suffix: 'h',
            seconds: $f60e814852ba3602$var$MINUTES_PER_HOUR * $f60e814852ba3602$var$SECONDS_PER_MINUTE
        },
        {
            suffix: 'm',
            seconds: $f60e814852ba3602$var$SECONDS_PER_MINUTE
        }
    ];
    return (seconds)=>{
        const initial = {
            secondsRemaining: seconds,
            timeString: ''
        };
        const result = units.reduce((acc, unit)=>{
            // Skip this unit if it doesn't have a valid number of seconds
            if (unit.seconds <= 0) return acc;
            const numUnits = Math.floor(acc.secondsRemaining / unit.seconds);
            const updatedSecondsRemaining = numUnits >= 1 ? acc.secondsRemaining % unit.seconds : acc.secondsRemaining;
            const updatedTimeString = numUnits >= 1 ? `${acc.timeString} ${numUnits}${unit.suffix}` : acc.timeString;
            return {
                secondsRemaining: updatedSecondsRemaining,
                timeString: updatedTimeString
            };
        }, initial);
        return result.timeString.trim() || '0m';
    };
};

});

parcelRegister("lQaym", function(module, exports) {

$parcel$export(module.exports, "getDefaultTimeTrackingUnit", () => $1a98cbfbb1c11444$export$2b38dfc7401492ba);
// This is required to map the default time-tracking unit coming from the server (gira endpoint BENTO: 3334) to client
const $1a98cbfbb1c11444$var$DEFAULT_TIME_TRACKING_UNIT_CLIENT = {
    minute: 'm',
    hour: 'h',
    day: 'd',
    week: 'w'
};
const $1a98cbfbb1c11444$export$2b38dfc7401492ba = (serverDefaultUnit)=>$1a98cbfbb1c11444$var$DEFAULT_TIME_TRACKING_UNIT_CLIENT[serverDefaultUnit] || $1a98cbfbb1c11444$var$DEFAULT_TIME_TRACKING_UNIT_CLIENT.minute;

});

parcelRegister("eDEru", function(module, exports) {

$parcel$export(module.exports, "secondsToWholeMinuteTimeString", () => $e60ef9ff18ec9e8a$export$e090c313e2cb7081);
const $e60ef9ff18ec9e8a$var$SECONDS_PER_MINUTE = 60;
const $e60ef9ff18ec9e8a$export$e090c313e2cb7081 = (seconds)=>`${Math.round(seconds / $e60ef9ff18ec9e8a$var$SECONDS_PER_MINUTE)}m`;
var $e60ef9ff18ec9e8a$export$2e2bcd8739ae039 = $e60ef9ff18ec9e8a$export$e090c313e2cb7081;

});



parcelRegister("bcUzb", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3d6d36ba3a9e242$export$2e2bcd8739ae039);
$parcel$export(module.exports, "transformDefaultIssueLinksValue", () => (parcelRequire("dkhuh")).transformDefaultIssueLinksValue);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bT7k5 = parcelRequire("bT7k5");

var $1ybV0 = parcelRequire("1ybV0");

var $4ksts = parcelRequire("4ksts");

var $SIwbf = parcelRequire("SIwbf");
var $eamzO = parcelRequire("eamzO");

var $icPhQ = parcelRequire("icPhQ");
var $6HoNR = parcelRequire("6HoNR");

var $7TaJX = parcelRequire("7TaJX");

var $hsETB = parcelRequire("hsETB");

var $dkhuh = parcelRequire("dkhuh");
const $c3d6d36ba3a9e242$export$5939eb0b0c440cdc = (props)=>{
    const { autoCompleteUrl: autoCompleteUrl, width: width, fieldId: fieldId, allowedValues: allowedValues, autoFocus: autoFocus = false, fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired }, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $7TaJX.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isCreateLinkedIssue: isCreateLinkedIssue = false, additionalData: additionalData } = props;
    const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)();
    const options = (0, $eamzO.mapDataToOptions)(allowedValues);
    // According to the new implemented logic, the initial values of the checkboxes will be determined by the BE payload.
    // If the response from the BE is null, we wont display the checkbox
    // if it's false, we'll display it and mark it unchecked
    // it it's true, we'll display it and mark it checked
    const { copyLinks: copyLinks, copyAttachments: copyAttachments } = additionalData?.copyLinksAndAttachments || {};
    (0, $eUqFw.useEffect)(()=>{
        if ((0, $1ybV0.ff)('create-linked-issues-trigger-point-issue-view') && isCreateLinkedIssue) {
            if (value.includeAttachments === undefined && value.includeLinks === undefined) onChange({
                ...value || {},
                includeLinks: copyLinks || false,
                includeAttachments: copyAttachments || false
            });
        }
    }, [
        copyAttachments,
        copyLinks,
        isCreateLinkedIssue,
        onChange,
        value
    ]);
    const onIssueLinksEditChange = (newValue)=>{
        onChange({
            ...value || {},
            ...newValue
        });
    };
    const onIncludeAttachmentsChange = (e)=>{
        onChange({
            ...value,
            includeAttachments: e.currentTarget.checked
        });
    };
    const onIncludeLinksChange = (e)=>{
        onChange({
            ...value,
            includeLinks: e.currentTarget.checked
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $SIwbf.IssueLinksEdit), {
        linkTypeOptions: options,
        autoFocus: autoFocus,
        autoCompleteUrl: autoCompleteUrl,
        onChange: (0, $1ybV0.ff)('create-linked-issues-trigger-point-issue-view') && isCreateLinkedIssue ? onIssueLinksEditChange : onChange,
        fetchSuggestionsOnMount: false,
        value: value,
        fieldId: fieldId,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        inputId: id,
        isRequired: isRequired
    }), (0, $1ybV0.ff)('create-linked-issues-trigger-point-issue-view') && isCreateLinkedIssue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c3d6d36ba3a9e242$var$CheckboxWrapper, null, copyLinks !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
        onChange: onIncludeLinksChange,
        label: formatMessage((0, $hsETB.default).includeLinks),
        isChecked: value?.includeLinks || false
    }), copyAttachments !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
        onChange: onIncludeAttachmentsChange,
        label: formatMessage((0, $hsETB.default).includeAttachments),
        isChecked: value?.includeAttachments || false
    })));
};
var $c3d6d36ba3a9e242$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $6HoNR.withFormField)({
    transformDefaultValue: (0, $dkhuh.transformDefaultIssueLinksValue),
    validator: (0, $dkhuh.validateIssueLinksField // @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<IssueLinksFieldConfig, IssueLink>, any>'.
    )
})($c3d6d36ba3a9e242$export$5939eb0b0c440cdc);
const $c3d6d36ba3a9e242$var$CheckboxWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _ca0q1b66 _19bv1b66 _zulp1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("SIwbf", function(module, exports) {

$parcel$export(module.exports, "IssueLinksEdit", () => $62096faeea47ec6c$export$4db6edf6dd313d5a);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $eoKxb = parcelRequire("eoKxb");

var $c9f3r = parcelRequire("c9f3r");
const $62096faeea47ec6c$export$4db6edf6dd313d5a = (props)=>{
    const { fieldId: fieldId, autoCompleteUrl: autoCompleteUrl, onChange: onChange, linkTypeOptions: linkTypeOptions, autoFocus: autoFocus = false, value: value, fetchSuggestionsOnMount: fetchSuggestionsOnMount, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, isDisabled: isDisabled, isRequired: isRequired, inputId: inputId } = props;
    const onLinkTypeChange = (val)=>{
        onChange({
            linkType: val,
            issues: value ? value.issues : []
        });
    };
    const onLinkSearchChange = (val)=>{
        if (value) onChange({
            linkType: value.linkType,
            issues: val
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($62096faeea47ec6c$var$FlexColumn, {
        "data-testid": "issue-field-issue-links.ui.edit.issue-links"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eoKxb.default), {
        options: linkTypeOptions,
        autoFocus: autoFocus,
        value: value ? value.linkType : undefined,
        onChange: onLinkTypeChange,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        isDisabled: isDisabled,
        inputId: inputId,
        isRequired: isRequired
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c9f3r.default), {
        fieldId: fieldId,
        value: value ? value.issues : undefined,
        fetchSuggestionsOnMount: fetchSuggestionsOnMount,
        autoCompleteUrl: autoCompleteUrl,
        onChange: onLinkSearchChange,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        isDisabled: isDisabled
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $62096faeea47ec6c$var$FlexColumn = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eoKxb", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8d569d59b2b99b7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5wCDk = parcelRequire("5wCDk");

var $4NcaX = parcelRequire("4NcaX");
const $e8d569d59b2b99b7$var$IssueLinksType = (props)=>{
    const { options: options, value: value, onChange: onChange, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, isDisabled: isDisabled, inputId: inputId, isRequired: isRequired } = props;
    (0, $eUqFw.useEffect)(()=>{
        if (value === undefined) onChange(options[0]);
    }, [
        value,
        onChange,
        options
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $e8d569d59b2b99b7$var$linkTypeWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
        inputId: inputId,
        required: isRequired,
        options: options,
        value: value,
        // @ts-expect-error - TS2322 - Type '(arg1: IssueLinkType) => void' is not assignable to type '(value: IssueLinkType | null, action: ActionMeta<IssueLinkType>) => void'.
        onChange: onChange,
        isMulti: false,
        autoFocus: autoFocus,
        defaultValue: options[0],
        closeMenuOnScroll: onCloseMenuOnScroll,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        styles: (0, $4NcaX.defaultSelectStyles),
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        isDisabled: isDisabled,
        classNamePrefix: "issue-link-type"
    }));
};
var $e8d569d59b2b99b7$export$2e2bcd8739ae039 = $e8d569d59b2b99b7$var$IssueLinksType;
const $e8d569d59b2b99b7$var$linkTypeWrapperStyles = (0, $1ZAYh.xcss)({
    width: '100%',
    marginBottom: 'space.100'
});

});

parcelRegister("c9f3r", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe1dec14eafceb40$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $lRmyA = parcelRequire("lRmyA");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8mGD0 = parcelRequire("8mGD0");

var $8tIPD = parcelRequire("8tIPD");

var $dGOvY = parcelRequire("dGOvY");
const $fe1dec14eafceb40$var$IssueLinksSearchEdit = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [invalidSelections, setInValidSelections] = (0, $eUqFw.useState)([]);
    const [isInvalidState, setIsInvalidState] = (0, $eUqFw.useState)(false);
    const { fieldId: fieldId, onFocus: onFocus, onBlur: onBlur, value: value, options: options, onChange: onChange, autoCompleteUrl: autoCompleteUrl, loadingMessage: loadingMessage, getSuggestions: getSuggestions, useTransformSuggestions: useTransformSuggestions, noOptionsMessage: noOptionsMessage, fetchSuggestionsOnMount: fetchSuggestionsOnMount, isInvalid: isInvalid, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, isDisabled: isDisabled } = props;
    const fetchSuggestions = (0, $eUqFw.useCallback)(async (query)=>{
        const response = await (0, $lRmyA.performGetRequest)(`${autoCompleteUrl}${query}`);
        return response;
    }, [
        autoCompleteUrl
    ]);
    /** returns the update invalid selection list that only contains values still present in the user selections */ const updateInvalidSelections = (0, $eUqFw.useCallback)((selectionValues)=>{
        const issueKeyValues = selectionValues ? selectionValues.map((v)=>v.value) : []; // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const updateSelections = invalidSelections.length ? // @ts-expect-error - TS2571 - Object is of type 'unknown'. | TS7006 - Parameter 'i' implicitly has an 'any' type.
        invalidSelections.filter((i)=>issueKeyValues.includes(i)) : [];
        if (updateSelections.length) setIsInvalidState(true);
        else setIsInvalidState(false);
        setInValidSelections(updateSelections);
    }, [
        invalidSelections
    ]);
    const onChangeSelectedValues = (0, $eUqFw.useCallback)((values, suggestions)=>{
        const currentHost = (0, $dGOvY.getCurrentHostPattern)();
        updateInvalidSelections(values);
        const newIssueLinks = values !== null && values !== undefined ? values.map((issueLink)=>{
            const strippedIssueKey = (0, $dGOvY.stripUrlToIssueKey)(currentHost, issueLink.value.toString());
            return {
                ...issueLink,
                iconUrl: issueLink.__isNew__ === true && suggestions && suggestions[0].options ? suggestions[0].options.find((option)=>option.value === issueLink.value)?.iconUrl : issueLink.iconUrl,
                label: strippedIssueKey,
                value: strippedIssueKey
            };
        }) : values;
        onChange(newIssueLinks);
    }, [
        onChange,
        updateInvalidSelections
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fe1dec14eafceb40$var$FlexRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $fe1dec14eafceb40$var$searchWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8mGD0.SearchableSelect), {
        fieldId: fieldId,
        getSuggestions: getSuggestions !== undefined ? getSuggestions : fetchSuggestions,
        onChange: onChangeSelectedValues,
        isMulti: true,
        value: value,
        options: options,
        onBlur: onBlur,
        onFocus: onFocus,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        isDisabled: isDisabled,
        placeholder: formatMessage((0, $8tIPD.default).placeholder),
        getTransformedSuggestions: useTransformSuggestions !== undefined ? useTransformSuggestions : (0, $dGOvY.transformIssueSuggestionItems),
        canCreateNewItem: true,
        loadingMessage: loadingMessage,
        noOptionsMessage: noOptionsMessage,
        onChangeQueryValue: (0, $dGOvY.stripQueryValueToIssueKey),
        isInvalid: isInvalid === true || isInvalidState,
        fetchSuggestionsOnMount: fetchSuggestionsOnMount,
        formatCreateLabel: formatMessage((0, $8tIPD.default).createNewIssueLink),
        ariaLabel: formatMessage((0, $8tIPD.default).placeholder)
    })));
};
var $fe1dec14eafceb40$export$2e2bcd8739ae039 = $fe1dec14eafceb40$var$IssueLinksSearchEdit;
const $fe1dec14eafceb40$var$searchWrapperStyles = (0, $1ZAYh.xcss)({
    width: '100%'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fe1dec14eafceb40$var$FlexRow = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8mGD0", function(module, exports) {

$parcel$export(module.exports, "SearchableSelect", () => $e48703538e50398f$export$6037a18d4e29dfa9);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $7jPhn = parcelRequire("7jPhn");

var $28t3A = parcelRequire("28t3A");

var $c9TLT = parcelRequire("c9TLT");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4NcaX = parcelRequire("4NcaX");
var $jM2Oz = parcelRequire("jM2Oz");
var $g6sIQ = parcelRequire("g6sIQ");

var $kOFyI = parcelRequire("kOFyI");
const $e48703538e50398f$export$251bdbdbce9550ea = 300;
const $e48703538e50398f$export$6037a18d4e29dfa9 = (props)=>{
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [menuIsOpen, setMenuIsOpen] = (0, $eUqFw.useState)(false);
    const [suggestions, setSuggestions] = (0, $eUqFw.useState)();
    const [defaultSuggestions, setDefaultSuggestions] = (0, $eUqFw.useState)();
    const [hasLastFetchFailed, setHasLastFetchFailed] = (0, $eUqFw.useState)(false);
    const lastQuery = (0, $eUqFw.useRef)('');
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { fieldId: fieldId, isMulti: isMulti, isInvalid: isInvalid, placeholder: placeholder, value: value, options: options, components: components, canCreateNewItem: canCreateNewItem, classNamePrefix: classNamePrefix, onChangeQueryValue: onChangeQueryValue, onChange: onChange, onFocus: onFocus, onBlur: onBlur, fetchSuggestionsOnMount: fetchSuggestionsOnMount, getSuggestions: getSuggestions, formatOptionLabel: formatOptionLabel, noOptionsMessage: noOptionsMessage, loadingMessage: loadingMessage, componentsProps: componentsProps, getTransformedSuggestions: getTransformedSuggestions, errorMessagePosition: errorMessagePosition, invalidMessage: invalidMessage, onPostTransformSuggestions: onPostTransformSuggestions, formatCreateLabel: formatCreateLabel, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, isDisabled: isDisabled, ariaLabel: ariaLabel } = props;
    /** Fetching and transforming results logic below * */ const handleSuggestions = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'query' implicitly has an 'any' type.
    (results, query)=>{
        if (lastQuery.current === query) {
            const response = getTransformedSuggestions(results, formatMessage, query);
            if (onPostTransformSuggestions) onPostTransformSuggestions(response, query);
            setSuggestions(response);
            if (query === '') setDefaultSuggestions(response);
        }
    }, [
        formatMessage,
        getTransformedSuggestions,
        onPostTransformSuggestions
    ]);
    const getFailedFetchMessage = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jM2Oz.FailedFetchOptionWrapper), null, formatMessage((0, $kOFyI.default).failedFetch)), [
        formatMessage
    ]);
    const requestSuggestions = (0, $eUqFw.useCallback)(async (query = '')=>{
        try {
            const response = await getSuggestions(query, componentsProps);
            setIsLoading(false);
            handleSuggestions(response, query);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setIsLoading(false);
            setHasLastFetchFailed(true);
            const failedOption = [
                {
                    label: getFailedFetchMessage(),
                    value: '',
                    isDisabled: true
                }
            ];
            setSuggestions(failedOption);
        }
    }, [
        componentsProps,
        getFailedFetchMessage,
        getSuggestions,
        handleSuggestions
    ]);
    (0, $eUqFw.useMemo)(()=>{
        if (fetchSuggestionsOnMount) {
            if (!options && !defaultSuggestions) {
                setIsLoading(true);
                requestSuggestions();
            } else if (options) {
                setDefaultSuggestions(options);
                setSuggestions(options);
            } else {
                lastQuery.current = '';
                setIsLoading(true);
                requestSuggestions();
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        componentsProps
    ]);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedRequestSuggestions = (0, $eUqFw.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(requestSuggestions, $e48703538e50398f$export$251bdbdbce9550ea), []);
    /** Action handlers below * */ const onQueryChange = (0, $eUqFw.useCallback)((query)=>{
        debouncedRequestSuggestions.cancel();
        setHasLastFetchFailed(false);
        if (query) {
            const transformedQuery = onChangeQueryValue ? onChangeQueryValue(query) : query;
            lastQuery.current = transformedQuery;
            setIsLoading(true);
            debouncedRequestSuggestions(transformedQuery);
        } else {
            lastQuery.current = '';
            setIsLoading(false);
            setSuggestions(defaultSuggestions);
        }
    }, [
        debouncedRequestSuggestions,
        defaultSuggestions,
        onChangeQueryValue
    ]);
    const onSelectFocus = (0, $eUqFw.useCallback)((e)=>{
        setMenuIsOpen(true);
        if (lastQuery.current === '' && !defaultSuggestions) {
            setIsLoading(true);
            requestSuggestions();
        }
        onFocus && onFocus(e);
    }, [
        defaultSuggestions,
        onFocus,
        requestSuggestions
    ]);
    const onSelectBlur = (0, $eUqFw.useCallback)((e)=>{
        setMenuIsOpen(false);
        onBlur && onBlur(e);
    }, [
        onBlur
    ]);
    const onChangeSelected = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter 'values' implicitly has an 'any' type.
    (values)=>{
        onChange(values, suggestions);
    }, [
        onChange,
        suggestions
    ]);
    /** Custom rendering through functions below * */ const getFormatOptionLabel = (0, $eUqFw.useCallback)((option, meta)=>{
        if (formatOptionLabel !== undefined) return formatOptionLabel(option, meta);
        if (option.iconUrl === undefined) return option.label;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jM2Oz.OptionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jM2Oz.ImgSpan), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
            src: option.iconUrl,
            alt: "",
            width: 2 * (0, $c9TLT.gridSize),
            height: 2 * (0, $c9TLT.gridSize),
            role: "none"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jM2Oz.FlexSpan), null, option.label));
    }, [
        formatOptionLabel
    ]);
    const renderErrorMessage = (0, $eUqFw.useCallback)(()=>invalidMessage !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jM2Oz.ErrorMessageWrapper), {
            key: `${fieldId}-error-message`,
            errorMessagePosition: errorMessagePosition
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, invalidMessage)) : null, [
        errorMessagePosition,
        fieldId,
        invalidMessage
    ]);
    const getCreateLabel = (0, $eUqFw.useCallback)((inputValue)=>`${inputValue} (${formatCreateLabel !== undefined ? formatCreateLabel : formatMessage((0, $kOFyI.default).createNewItem)})`, [
        formatCreateLabel,
        formatMessage
    ]);
    const getNoOptionsMessage = (0, $eUqFw.useCallback)(()=>noOptionsMessage !== undefined ? noOptionsMessage : formatMessage((0, $kOFyI.default).empty), [
        formatMessage,
        noOptionsMessage
    ]);
    const getLoadingMessage = (0, $eUqFw.useCallback)(()=>loadingMessage !== undefined ? loadingMessage : formatMessage((0, $kOFyI.default).loading), [
        formatMessage,
        loadingMessage
    ]);
    const filterOption = (0, $eUqFw.useCallback)((option)=>{
        if (hasLastFetchFailed) // If the fetch has failed, we will show a disabled option to indicate the error to users
        return true;
        return (0, $g6sIQ.filterOptionByLabelAndFilterValues)(option, lastQuery.current || '');
    }, [
        hasLastFetchFailed
    ]);
    const isValidNewOption = (0, $eUqFw.useCallback)((query)=>{
        if (canCreateNewItem && query !== '') return true;
        return false;
    }, [
        canCreateNewItem
    ]);
    /**  Rendering logic below * */ const renderSelectField = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $28t3A.default), {
            classNamePrefix: classNamePrefix,
            key: fieldId,
            options: suggestions,
            autoFocus: autoFocus,
            // @ts-expect-error TS2345: Argument of type '{ new <Option = OptionType, IsMulti extends boolean = false>(props: SelectProps<Option, IsMulti>): { components: Partial<SelectComponents<Option, IsMulti, GroupBase<Option>>>; ... 23 more ...; UNSAFE_componentWillUpdate?(nextProps: Readonly<...>, nextState: Readonly<...>, nextContext: any): void; }; defaultProps: { ...' is not assignable to parameter of type 'ComponentType<SelectProps<unknown, boolean> | AsyncSelectProps<unknown, boolean> | CreatableSelectProps<unknown, boolean>>'.
            value: value,
            onBlur: onSelectBlur,
            onFocus: onSelectFocus,
            noOptionsMessage: getNoOptionsMessage,
            loadingMessage: getLoadingMessage,
            menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            styles: (0, $4NcaX.defaultSelectStyles),
            placeholder: placeholder !== undefined ? placeholder : formatMessage((0, $kOFyI.default).placeholder),
            onInputChange: onQueryChange,
            onChange: onChangeSelected,
            isLoading: menuIsOpen && isLoading,
            filterOption: filterOption,
            isClearable: true,
            formatOptionLabel: getFormatOptionLabel,
            // @ts-expect-error - Type '{ Menu: ComponentType<MenuProps>; } | undefined' is not assignable to type 'Partial<SelectComponents<Option, boolean, GroupBase<Option>>> | undefined'
            components: components,
            componentsProps: componentsProps,
            isMulti: isMulti,
            isValidNewOption: isValidNewOption,
            // @ts-expect-error - null has to be changed to undefined
            validationState: isInvalid === true ? 'error' : null,
            formatCreateLabel: getCreateLabel,
            closeMenuOnScroll: onCloseMenuOnScroll,
            isDisabled: isDisabled,
            "aria-label": ariaLabel
        });
    const componentList = [
        renderSelectField()
    ];
    errorMessagePosition === 'top' ? componentList.unshift(renderErrorMessage()) : componentList.push(renderErrorMessage());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, componentList);
};
$e48703538e50398f$export$6037a18d4e29dfa9.defaultProps = {
    isMulti: false,
    canCreateNewItem: false,
    fetchSuggestionsOnMount: true
};
var $e48703538e50398f$export$2e2bcd8739ae039 = $e48703538e50398f$export$6037a18d4e29dfa9;

});
parcelRegister("kOFyI", function(module, exports) {

$parcel$export(module.exports, "default", () => $a969df55f0106059$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a969df55f0106059$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    empty: {
        "id": "searchable-select.empty",
        "defaultMessage": "No matches found"
    },
    failedFetch: {
        "id": "searchable-select.failed-fetch",
        "defaultMessage": "Search failed. Please try again."
    },
    placeholder: {
        "id": "searchable-select.placeholder",
        "defaultMessage": "Select an option"
    },
    loading: {
        "id": "searchable-select.loading",
        "defaultMessage": "Searching..."
    },
    createNewItem: {
        "id": "searchable-select.create-new-item",
        "defaultMessage": "Create"
    }
});

});


parcelRegister("8tIPD", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a97e539579002ee$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6a97e539579002ee$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "issue-field-issue-links.edit.search.placeholder",
        "defaultMessage": "Select Issue"
    },
    openIssues: {
        "id": "issue-field-issue-links.edit.search.open-issues",
        "defaultMessage": "Open Issues"
    },
    noHistoryResults: {
        "id": "issue-field-issue-links.edit.search.no-history-results",
        "defaultMessage": "Type to search for an issue summary or key"
    },
    singleInvalidIssue: {
        "id": "issue-field-issue-links.edit.search.single-invalid-issue",
        "defaultMessage": "We can't find an issue with the key"
    },
    multipleInvalidIssues: {
        "id": "issue-field-issue-links.edit.search.multiple-invalid-issues",
        "defaultMessage": "We can't find issues with the keys"
    },
    createNewIssueLink: {
        "id": "issue-field-issue-links.edit.search.create-new-issue-link",
        "defaultMessage": "Exact key"
    }
});

});

parcelRegister("dGOvY", function(module, exports) {

$parcel$export(module.exports, "getCurrentHostPattern", () => $2af05f1c7aca67da$export$47e10df7c3c19b6b);
$parcel$export(module.exports, "stripUrlToIssueKey", () => $2af05f1c7aca67da$export$1f3c6284caef177b);
$parcel$export(module.exports, "stripQueryValueToIssueKey", () => $2af05f1c7aca67da$export$a1fbc8ef5ec2d6e3);
$parcel$export(module.exports, "transformIssueSuggestionItems", () => $2af05f1c7aca67da$export$41cc13f7ec7b4b3d);

var $8tIPD = parcelRequire("8tIPD");
// If the full URL supplied matches the Jira view issue pattern for the specified site then strip the URL
// to just the issue key. If the URL does not match the pattern then return it unchanged.
const $2af05f1c7aca67da$var$ISSUE_BROWSE_PATH = 'browse/';
const $2af05f1c7aca67da$var$ISSUE_KEY_REGEXP = /^(([A-Z][A-Z0-9]+)-([0-9]+))($|\?.*)/;
const $2af05f1c7aca67da$export$47e10df7c3c19b6b = ()=>{
    if (window.location.port !== '') return `${window.location.protocol}//${window.location.hostname}:${window.location.port}`;
    return `${window.location.protocol}//${window.location.hostname}`;
};
const $2af05f1c7aca67da$export$1f3c6284caef177b = (tenantUrl, candidateUrl)=>{
    let tenantUrlPath = tenantUrl;
    if (tenantUrlPath === undefined || candidateUrl === undefined) return candidateUrl || '';
    if (!tenantUrlPath.endsWith('/')) tenantUrlPath += '/';
    tenantUrlPath += $2af05f1c7aca67da$var$ISSUE_BROWSE_PATH;
    if (candidateUrl.indexOf(tenantUrlPath) !== 0) return candidateUrl;
    const candidatePath = candidateUrl.slice(tenantUrlPath.length);
    const match = candidatePath.match($2af05f1c7aca67da$var$ISSUE_KEY_REGEXP);
    if (match === null) return candidateUrl;
    return match[1] || ''; // issue key is at index 1 (first capture group)
};
const $2af05f1c7aca67da$export$a1fbc8ef5ec2d6e3 = (queryValue)=>{
    const currentHost = $2af05f1c7aca67da$export$47e10df7c3c19b6b();
    return $2af05f1c7aca67da$export$1f3c6284caef177b(currentHost, queryValue);
};
const $2af05f1c7aca67da$export$41cc13f7ec7b4b3d = (results, formatMessage, query = '')=>{
    const { sections: sections } = results;
    const heading = formatMessage((0, $8tIPD.default).openIssues);
    const noSuggestionsMessage = formatMessage((0, $8tIPD.default).noHistoryResults);
    const suggestions = sections.map((section)=>section.issues).filter((issues)=>!!issues) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((flatten, current)=>flatten.concat(current.map((issue)=>({
                label: `${issue.key} ${issue.summaryText}`,
                value: issue.key,
                id: issue.id ? issue.id.toString() : '',
                iconUrl: issue.img,
                // Allows us to force all items returned by the endpoint to be displayed.
                filterValues: [
                    query
                ]
            }))), []) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((uniq, current)=>uniq.findIndex((item)=>item.value === current.value) < 0 ? [
            ...uniq,
            current
        ] : uniq, []);
    if (suggestions.length) {
        const selectSuggestions = [
            {
                label: heading,
                options: suggestions
            }
        ];
        return selectSuggestions;
    }
    const noSuggestion = [
        {
            label: noSuggestionsMessage,
            isDisabled: true,
            value: ''
        }
    ];
    return noSuggestion;
};
const $2af05f1c7aca67da$export$fb7a6b38a05bd2b7 = ({ value: value })=>Number(value);

});



parcelRegister("eamzO", function(module, exports) {

$parcel$export(module.exports, "mapDataToOption", () => $8133f7099a0b8553$export$5c1e24ea9ccb80aa);
$parcel$export(module.exports, "mapDataToOptions", () => $8133f7099a0b8553$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionsToData", () => $8133f7099a0b8553$export$ffef3a401aef987b);
const $8133f7099a0b8553$export$5c1e24ea9ccb80aa = (linkType)=>({
        id: linkType.linkTypeId,
        label: linkType.relationName,
        value: linkType.relationName,
        name: linkType.linkTypeName,
        direction: linkType.direction
    });
const $8133f7099a0b8553$export$99a866ffa3af7d8b = (linkTypes)=>linkTypes.map($8133f7099a0b8553$export$5c1e24ea9ccb80aa);
const $8133f7099a0b8553$export$ffef3a401aef987b = (option)=>{
    // handling the case where default value may get set in the process of setting the default value of link type dropdown but the user never selects any issues
    if (option.issues.length === 0) return undefined;
    const direction = option.linkType.direction === 'INWARD' ? 'inwardIssues' : 'outwardIssues';
    return [
        {
            add: {
                values: [
                    {
                        type: {
                            id: option.linkType.id
                        },
                        [direction]: option.issues.map((issue)=>({
                                key: issue.value
                            }))
                    }
                ]
            }
        }
    ];
};

});

parcelRegister("hsETB", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3eb2f99f55d2a65$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $c3eb2f99f55d2a65$var$messages = (0, $90IgZ.defineMessages)({
    includeLinks: {
        "id": "issue-create-commons.issue-links-field.include-links",
        "defaultMessage": "Include links"
    },
    includeAttachments: {
        "id": "issue-create-commons.issue-links-field.include-attachments",
        "defaultMessage": "Include attachments"
    }
});
var $c3eb2f99f55d2a65$export$2e2bcd8739ae039 = $c3eb2f99f55d2a65$var$messages;

});

parcelRegister("dkhuh", function(module, exports) {

$parcel$export(module.exports, "transformDefaultIssueLinksValue", () => $2d0aaeadb0bc7822$export$acce6bb888b6838c);
$parcel$export(module.exports, "validateIssueLinksField", () => $2d0aaeadb0bc7822$export$542fc2dd23d5dbdc);
$parcel$export(module.exports, "mutateIssueLinksField", () => $2d0aaeadb0bc7822$export$c498672524a9f24d);

var $1ybV0 = parcelRequire("1ybV0");

var $dEMIg = parcelRequire("dEMIg");

var $eamzO = parcelRequire("eamzO");
const $2d0aaeadb0bc7822$export$acce6bb888b6838c = (value)=>{
    if (value && value.length > 0) {
        const issues = [];
        value.forEach((issueLink)=>{
            if (issueLink.issue) issues.push({
                iconUrl: issueLink.issue.avatar?.small,
                id: issueLink.issue.issueId.toString(),
                label: issueLink.issue.key,
                value: issueLink.issue.key
            });
        });
        return (0, $1ybV0.ff)('create-linked-issues-trigger-point-issue-view') ? {
            linkType: (0, $eamzO.mapDataToOption)(value?.[0]?.relatedBy),
            issues: issues,
            includeAttachments: undefined,
            includeLinks: undefined
        } : {
            linkType: (0, $eamzO.mapDataToOption)(value?.[0]?.relatedBy),
            issues: issues
        };
    }
    return undefined;
};
const $2d0aaeadb0bc7822$export$542fc2dd23d5dbdc = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $dEMIg.REQUIRED;
        // issues can be [] when default value is set for the link type select, check the default transformer for this field
        if (value.issues.length === 0) return 0, $dEMIg.REQUIRED;
    }
    return undefined;
};
const $2d0aaeadb0bc7822$export$c498672524a9f24d = (value)=>({
        issueLinks: {
            linkTypeName: value.linkType.value,
            linkedIssueKeys: value.issues.map((issue)=>issue.value.toString())
        }
    });

});


parcelRegister("j6rDO", function(module, exports) {

$parcel$export(module.exports, "mutateMultiSelectField", () => $392a998c28aa9272$export$3313ce8403b211b4);
$parcel$export(module.exports, "mapMultiSelectOptionsToConnectData", () => $392a998c28aa9272$export$a7431ac3899bcd4d);

const $392a998c28aa9272$export$3313ce8403b211b4 = (selectedValues, fieldId)=>({
        fieldId: fieldId,
        mutationGroup: (0, $be514ea467a9338a$export$31fd86f8f183952c),
        options: selectedValues.map(({ value: value })=>({
                optionId: value
            }))
    });
const $392a998c28aa9272$export$a7431ac3899bcd4d = (options)=>options.map((option)=>option.value);

});
const $be514ea467a9338a$export$31fd86f8f183952c = 'multipleSelectFields';


parcelRegister("74tp8", function(module, exports) {

$parcel$export(module.exports, "mutateSingleSelectField", () => $e5b0428a192a6592$export$35684f6945108587);
$parcel$export(module.exports, "mapSelectOptionsToConnectData", () => $e5b0428a192a6592$export$ed4050ca50f08036);

const $e5b0428a192a6592$export$35684f6945108587 = ({ value: value }, fieldId)=>({
        fieldId: fieldId,
        mutationGroup: (0, $b5519c131deb46e9$export$31fd86f8f183952c),
        option: {
            optionId: value
        }
    });
const $e5b0428a192a6592$export$ed4050ca50f08036 = (option)=>option.value;

});
const $b5519c131deb46e9$export$31fd86f8f183952c = 'singleSelectFields';


parcelRegister("dR4yn", function(module, exports) {

$parcel$export(module.exports, "mutatePeopleField", () => $a3872804fada7283$export$62bbb242ba3788ab);
$parcel$export(module.exports, "mapUserOptionOrOptionsToIds", () => $a3872804fada7283$export$2ebc7514b112dd56);
$parcel$export(module.exports, "transformToUserOption", () => $a3872804fada7283$export$5924759166d7a225);

const $a3872804fada7283$export$62bbb242ba3788ab = (selectedValue, fieldId)=>({
        fieldId: fieldId,
        mutationGroup: (0, $f7c5568ec687a83d$export$34a73409a6330355),
        users: Array.isArray(selectedValue) ? selectedValue.map((user)=>({
                accountId: user.id
            })) : [
            {
                accountId: selectedValue.id
            }
        ]
    });
const $a3872804fada7283$export$2ebc7514b112dd56 = (userOption)=>{
    if (Array.isArray(userOption)) return userOption.map((option)=>({
            id: option.id
        }));
    return [
        {
            id: userOption.id
        }
    ];
};
const $a3872804fada7283$export$5924759166d7a225 = (userData)=>({
        id: userData.accountId,
        name: userData.displayName || '',
        avatarUrl: userData.avatarUrl || userData.avatarUrls?.['32x32'] || ''
    });

});
const $f7c5568ec687a83d$export$34a73409a6330355 = 'peopleFields';


parcelRegister("lWQTA", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c6528b1b88007e2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $9wcjJ = parcelRequire("9wcjJ");

var $7Y6sw = parcelRequire("7Y6sw");

var $1ybV0 = parcelRequire("1ybV0");

var $9XfZZ = parcelRequire("9XfZZ");
const $2c6528b1b88007e2$var$MessageCFBehaviour = (props)=>{
    const { defaultValue: defaultValue } = props;
    if (defaultValue === undefined) return null;
    const rendererFFProps = (0, $1ybV0.ff)('platform.linking-platform.jira-renderer-use-default-smartlinks-value') ? {
        smartLinks: (0, $9XfZZ.smartLinksDefault)
    } : {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Y6sw.default), {
        document: defaultValue,
        schema: (0, $9wcjJ.defaultSchema),
        disableHeadingIDs: true,
        eventHandlers: {
            smartCard: {
                onClick: (0, $9XfZZ.onLinkClick)
            },
            link: {
                onClick: (0, $9XfZZ.onLinkClick)
            }
        },
        featureFlags: {
            codeBidiWarnings: true,
            'code-bidi-warnings': true,
            // enables sending analytics event with renderer specific tti measurement
            // please do not clean up, this feature flag is meant to be rolled out permanently just for a fraction of users
            'renderer-tti-tracking': (0, $1ybV0.ff)('issue.details.renderer.tti-tracking')
        },
        ...rendererFFProps
    });
};
const $2c6528b1b88007e2$var$MessageCF = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2c6528b1b88007e2$var$MessageCFBehaviour, {
        key: "message-custom-field",
        ...props
    });
var $2c6528b1b88007e2$export$2e2bcd8739ae039 = $2c6528b1b88007e2$var$MessageCF;

});

parcelRegister("8AMXG", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bf315aff35606e2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fXyiT = parcelRequire("fXyiT");

var $1ybV0 = parcelRequire("1ybV0");

var $dvJOo = parcelRequire("dvJOo");

var $icPhQ = parcelRequire("icPhQ");
var $6HoNR = parcelRequire("6HoNR");

var $lIor1 = parcelRequire("lIor1");

var $7TaJX = parcelRequire("7TaJX");

var $ksJvI = parcelRequire("ksJvI");
const $7bf315aff35606e2$var$MultiGroupPickerField = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange, ...fieldProps }, fieldId: fieldId, error: error, autoCompleteUrl: autoCompleteUrl, autoFocus: autoFocus = false, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false } = props;
    const getExtraProps = ()=>{
        if ((0, $1ybV0.ff)('common-field-behaviour-for-new-gic_q9mgt') && isDropdownMenuFixedAndLayered) return {
            menuPosition: 'fixed',
            groupPickerStyles: (0, $fXyiT.defaultUserPickerStyles),
            onCloseMenuOnScroll: (0, $7TaJX.closeMenuOnScroll)
        };
        if ((0, $1ybV0.ff)('common-field-behaviour-for-new-gic_q9mgt')) return {
            onCloseMenuOnScroll: (0, $7TaJX.closeMenuOnScroll)
        };
        return {};
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dvJOo.default), {
        ...fieldProps,
        autoCompleteUrl: autoCompleteUrl,
        onChange: onChange,
        value: value,
        fieldId: fieldId,
        isInvalid: Boolean(error),
        autoFocus: autoFocus,
        isMulti: true,
        placeholder: " ",
        ...getExtraProps()
    }));
};
var $7bf315aff35606e2$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    validator: (0, $lIor1.validateGroupPickerField),
    transformDefaultValue: (0, $ksJvI.transformGroupDefaultValueToUserOption)
})($7bf315aff35606e2$var$MultiGroupPickerField);

});
parcelRegister("fXyiT", function(module, exports) {

$parcel$export(module.exports, "defaultUserPickerStyles", () => $6da490b0db05b7db$export$ddd4b90ea2d7a329);

var $c9TLT = parcelRequire("c9TLT");
const $6da490b0db05b7db$export$ddd4b90ea2d7a329 = {
    menuPortal: (base)=>({
            ...base,
            zIndex: String((0, $c9TLT.layers).modal)
        })
};

});

parcelRegister("dvJOo", function(module, exports) {

$parcel$export(module.exports, "default", () => $429926a88a015fd5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $jYnpi = parcelRequire("jYnpi");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gnxL7 = parcelRequire("gnxL7");

var $fLCSu = parcelRequire("fLCSu");

var $lEbr0 = parcelRequire("lEbr0");

var $27L64 = parcelRequire("27L64");

var $auQXa = parcelRequire("auQXa");
const $429926a88a015fd5$var$DEFAULT_SEARCH_DEBOUCE_TIMEOUT = 300;
const $429926a88a015fd5$var$GroupPicker = ({ autoCompleteUrl: autoCompleteUrl, value: value, onFocus: onFocus, onBlur: onBlur, onChange: onChange, isMulti: isMulti, isDisabled: isDisabled, fieldId: fieldId, width: width, searchDebounceTimeout: // @ts-expect-error - TS2339 - Property 'searchDebounceTimeout' does not exist on type 'Props'.
searchDebounceTimeout = $429926a88a015fd5$var$DEFAULT_SEARCH_DEBOUCE_TIMEOUT, isInvalid: isInvalid, autoFocus: autoFocus = false, placeholder: placeholder, onCloseMenuOnScroll: onCloseMenuOnScroll, menuPosition: menuPosition, groupPickerStyles: groupPickerStyles = {}, isClearable: isClearable = true, ...fieldProps })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const previousQuery = (0, $eUqFw.useRef)('');
    const { groups: groups, loading: loading, fetchGroups: fetchGroups } = (0, $lEbr0.default)(autoCompleteUrl || '');
    const [isDropdownVisible, setIsDropdownVisible] = (0, $eUqFw.useState)(false);
    const getUserPickerControlStyle = (0, $eUqFw.useCallback)((styles)=>{
        if (isInvalid === true) return {
            ...styles,
            ...(0, $auQXa.invalidStateStyle)
        };
        return styles;
    }, [
        isInvalid
    ]);
    const handleSearch = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((query)=>{
            if ((0, $fLCSu.isBehaviourCommonForAllFieldsInNewGic)()) setIsDropdownVisible(!!query);
            // if query has changed, get groups
            if (query !== previousQuery.current && query !== undefined) fetchGroups(query);
            previousQuery.current = query || '';
        }, searchDebounceTimeout), [
        fetchGroups,
        previousQuery,
        searchDebounceTimeout
    ]);
    const handleOnFocus = (0, $eUqFw.useCallback)((sessionId)=>{
        if ((0, $fLCSu.isBehaviourCommonForAllFieldsInNewGic)()) setIsDropdownVisible(true);
        onFocus?.(sessionId);
        if (!groups || !groups.length) fetchGroups();
    }, [
        fetchGroups,
        groups,
        onFocus
    ]);
    const handleOnBlur = (0, $eUqFw.useCallback)((sessionId)=>{
        if ((0, $fLCSu.isBehaviourCommonForAllFieldsInNewGic)()) setIsDropdownVisible(false);
        onBlur?.(sessionId);
        previousQuery.current = '';
    }, [
        onBlur,
        previousQuery
    ]);
    const handleOnChange = (updatedValue)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        onChange(updatedValue);
    };
    const getOptions = ()=>groups.filter((group)=>group.name.includes(previousQuery.current)).map((group)=>(0, $gnxL7.transformGroupToUserOption)(group));
    const onClear = ()=>{
        onChange(null);
    };
    const closeMenuOnScroll = (e)=>{
        if (isDropdownVisible && onCloseMenuOnScroll && onCloseMenuOnScroll(e)) setIsDropdownVisible(false);
    };
    const getIsClearable = ()=>isClearable ? Boolean(value) : false;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jYnpi.UserPicker), {
        ariaLabelledBy: fieldProps['aria-labelledby'],
        fieldId: fieldId,
        width: width,
        autoFocus: autoFocus,
        isLoading: loading,
        options: getOptions(),
        value: value,
        onFocus: handleOnFocus,
        onClear: onClear,
        isMulti: isMulti,
        isDisabled: isDisabled,
        isClearable: getIsClearable(),
        onBlur: handleOnBlur,
        onInputChange: handleSearch,
        onChange: handleOnChange,
        placeholder: placeholder,
        addMoreMessage: formatMessage((0, $27L64.default).addMoreGroupsPrompt),
        UNSAFE_hasDraggableParentComponent: true,
        ...(0, $fLCSu.isBehaviourCommonForAllFieldsInNewGic)() ? {
            closeMenuOnScroll: closeMenuOnScroll,
            open: isDropdownVisible,
            menuPosition: menuPosition,
            styles: {
                control: getUserPickerControlStyle,
                ...groupPickerStyles
            }
        } : {
            styles: {
                control: getUserPickerControlStyle
            }
        }
    });
};
var $429926a88a015fd5$export$2e2bcd8739ae039 = $429926a88a015fd5$var$GroupPicker;

});
parcelRegister("gnxL7", function(module, exports) {

$parcel$export(module.exports, "transformGroupToUserOption", () => $75026b89b941da9d$export$f9f97cb0418e400f);
$parcel$export(module.exports, "transformUserPickerOptionToGroup", () => $75026b89b941da9d$export$7727449e04185a4c);
$parcel$export(module.exports, "transformGroupToName", () => $75026b89b941da9d$export$c76efe48b8ca8203);
$parcel$export(module.exports, "transformGroupsToNames", () => $75026b89b941da9d$export$285022bf9288513e);
$parcel$export(module.exports, "appendTypePropertyToGroupOptions", () => $75026b89b941da9d$export$705009f1a414da46);
const $75026b89b941da9d$export$f9f97cb0418e400f = (group)=>({
        id: group.name,
        name: group.name,
        type: 'group'
    });
const $75026b89b941da9d$export$7727449e04185a4c = (userOption)=>({
        groupId: userOption.id,
        name: userOption.name,
        type: 'group'
    });
const $75026b89b941da9d$export$c76efe48b8ca8203 = (group)=>({
        name: group.name
    });
const $75026b89b941da9d$export$285022bf9288513e = (groups)=>groups.map((group)=>$75026b89b941da9d$export$c76efe48b8ca8203(group));
const $75026b89b941da9d$export$705009f1a414da46 = (groups)=>groups.map((group)=>({
            ...group,
            type: 'group'
        }));

});

parcelRegister("fLCSu", function(module, exports) {

$parcel$export(module.exports, "isBehaviourCommonForAllFieldsInNewGic", () => $1b708590e658ced7$export$b2f73d54757eb059);

var $1ybV0 = parcelRequire("1ybV0");
const $1b708590e658ced7$export$b2f73d54757eb059 = ()=>(0, $1ybV0.ff)('common-field-behaviour-for-new-gic_q9mgt', false);

});

parcelRegister("lEbr0", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c63266297e3fcf9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $lRmyA = parcelRequire("lRmyA");

var $gnxL7 = parcelRequire("gnxL7");
const $5c63266297e3fcf9$var$useGroupsQuery = (autoCompleteUrl)=>{
    const [groups, setGroups] = (0, $eUqFw.useState)([]);
    const [error, setError] = (0, $eUqFw.useState)(undefined);
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const currentQuery = (0, $eUqFw.useRef)('');
    const fetchGroups = (0, $eUqFw.useCallback)(async (query = '')=>{
        if ([
            '',
            null,
            undefined
        ].includes(autoCompleteUrl)) return Promise.resolve([]);
        const groupsFetchUrl = `${autoCompleteUrl || ''}${query}`;
        setLoading(true);
        currentQuery.current = query;
        if (error) setError(undefined);
        try {
            const response = await (0, $lRmyA.performGetRequest)(groupsFetchUrl);
            let groupsWithType = [];
            if (query === currentQuery.current) {
                if (response && response.groups) {
                    groupsWithType = (0, $gnxL7.appendTypePropertyToGroupOptions)(response.groups);
                    setGroups(groupsWithType);
                } else setGroups([]);
            }
            return groupsWithType;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            if (query === currentQuery.current) setError(err);
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.fields.grouppicker', 'Failed to fetch groups', err);
            return err;
        } finally{
            setLoading(false);
        }
    }, [
        autoCompleteUrl,
        error
    ]);
    return {
        groups: groups,
        error: error,
        loading: loading,
        fetchGroups: fetchGroups
    };
};
var $5c63266297e3fcf9$export$2e2bcd8739ae039 = $5c63266297e3fcf9$var$useGroupsQuery;

});

parcelRegister("27L64", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bd6b2182548f118$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3bd6b2182548f118$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    addMoreGroupsPrompt: {
        "id": "issue-field-group-picker.edit.add-more-groups-prompt",
        "defaultMessage": "add more groups..."
    }
});

});

parcelRegister("auQXa", function(module, exports) {

$parcel$export(module.exports, "invalidStateStyle", () => $861c966777ce7f65$export$f204658c943efb85);

var $PdmhA = parcelRequire("PdmhA");
const $861c966777ce7f65$export$f204658c943efb85 = {
    borderColor: `var(--ds-border-danger, ${(0, $PdmhA).R400})`
};

});


parcelRegister("ksJvI", function(module, exports) {

$parcel$export(module.exports, "transformGroupDefaultValueToUserOption", () => $9c62fe3b8ccb2570$export$d9591be6713fcfc8);
$parcel$export(module.exports, "mutateMultipleGroupPickerField", () => $9c62fe3b8ccb2570$export$8cb86783be488510);
// @ts-expect-error - TS2614 - Module '"@atlaskit/user-picker"' has no exported member 'LegacyValue'. Did you mean to use 'import LegacyValue from "@atlaskit/user-picker"' instead?

var $gnxL7 = parcelRequire("gnxL7");

const $9c62fe3b8ccb2570$export$d9591be6713fcfc8 = (group)=>{
    if (!group) return null;
    if (Array.isArray(group)) return group.map((groupItem)=>(0, $gnxL7.transformGroupToUserOption)(groupItem));
    return (0, $gnxL7.transformGroupToUserOption)(group);
};
const $9c62fe3b8ccb2570$export$8cb86783be488510 = (selectedGroups, fieldId)=>({
        fieldId: fieldId,
        groups: selectedGroups.map(({ name: name })=>({
                groupName: name
            })),
        mutationGroup: (0, $1be53a03bb30e458$export$31fd86f8f183952c)
    });

});
const $1be53a03bb30e458$export$31fd86f8f183952c = 'multipleGroupPickerFields';



parcelRegister("hQhuO", function(module, exports) {

$parcel$export(module.exports, "default", () => $50e32c6ac3be7f6d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jRCtV = parcelRequire("jRCtV");

var $j6rDO = parcelRequire("j6rDO");
const $50e32c6ac3be7f6d$var$MultiSelectField = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jRCtV.default), {
        ...props,
        isMulti: true
    });
var $50e32c6ac3be7f6d$export$2e2bcd8739ae039 = $50e32c6ac3be7f6d$var$MultiSelectField;

});
parcelRegister("jRCtV", function(module, exports) {

$parcel$export(module.exports, "default", () => $277269de9b68edcf$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $42gdJ = parcelRequire("42gdJ");
var $jRjxU = parcelRequire("jRjxU");

var $7TaJX = parcelRequire("7TaJX");

var $lIor1 = parcelRequire("lIor1");

var $6HoNR = parcelRequire("6HoNR");

var $icPhQ = parcelRequire("icPhQ");

var $fwjqo = parcelRequire("fwjqo");
const $277269de9b68edcf$var$SelectField = (props)=>{
    const { fieldId: fieldId, autoFocus: autoFocus = false, allowedValues: allowedValues, width: width, error: error, fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired }, isMulti: isMulti = false, isReadOnly: isReadOnly = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $7TaJX.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jRjxU.default), {
        onChange: onChange,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        options: (0, $42gdJ.mapDataToSelectOptions)(allowedValues),
        value: value,
        autoFocus: autoFocus,
        isInvalid: Boolean(error),
        classNamePrefix: `select-${fieldId}`,
        isMulti: isMulti,
        hideSelectedOptions: true,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isClearable: true,
        onFilterOption: (0, $fwjqo.onFilterOption),
        isDisabled: isReadOnly,
        isRequired: isRequired,
        inputId: id
    }));
};
var $277269de9b68edcf$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    transformDefaultValue: (0, $fwjqo.transformDefaultSelectValues),
    validator: (0, $lIor1.validateSelectField)
})($277269de9b68edcf$var$SelectField);

});
parcelRegister("42gdJ", function(module, exports) {

$parcel$export(module.exports, "mapSelectOptionsToData", () => $8e4379316c73d7ec$export$7cdfccbc726f6f22);
$parcel$export(module.exports, "mapMultiSelectOptionsToData", () => $8e4379316c73d7ec$export$b91253d30be01e62);
$parcel$export(module.exports, "mapDataToSelectOption", () => $8e4379316c73d7ec$export$8f475f1fdc96a964);
$parcel$export(module.exports, "mapDataToSelectOptions", () => $8e4379316c73d7ec$export$dc22cde66e28d4af);
const $8e4379316c73d7ec$export$7cdfccbc726f6f22 = (option)=>({
        id: option.value,
        value: option.label
    });
const $8e4379316c73d7ec$export$b91253d30be01e62 = (options)=>options.map((option)=>({
            id: option.value,
            value: option.label
        }));
const $8e4379316c73d7ec$export$8f475f1fdc96a964 = (optionExternal)=>({
        label: optionExternal.value,
        value: optionExternal.id
    });
const $8e4379316c73d7ec$export$dc22cde66e28d4af = (data)=>data.map((optionExternal)=>$8e4379316c73d7ec$export$8f475f1fdc96a964(optionExternal));

});

parcelRegister("jRjxU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ea19a7a7289690d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5wCDk = parcelRequire("5wCDk");

var $4NcaX = parcelRequire("4NcaX");
const $7ea19a7a7289690d$var$SelectEdit = (props)=>{
    const { classNamePrefix: classNamePrefix, placeholder: placeholder = '', options: options, onChange: onChange, onBlur: onBlur, onFocus: onFocus, autoFocus: autoFocus = false, isInvalid: isInvalid, isMulti: isMulti = false, isDisabled: isDisabled = false, value: value, isClearable: isClearable, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, onFilterOption: onFilterOption, inputId: inputId, isRequired: isRequired } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
        placeholder: placeholder,
        options: options,
        value: value,
        classNamePrefix: classNamePrefix,
        // @ts-expect-error - TS2322 - Type '(option: SelectOption) => void' is not assignable to type '(value: SelectOption | OptionsType<SelectOption> | null, action: ActionMeta<SelectOption>) => void'.
        onChange: onChange,
        onBlur: onBlur,
        isMulti: isMulti,
        onFocus: onFocus,
        autoFocus: autoFocus,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        styles: (0, $4NcaX.defaultSelectStyles),
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        isClearable: isClearable,
        isDisabled: isDisabled,
        closeMenuOnScroll: onCloseMenuOnScroll,
        filterOption: onFilterOption,
        inputId: inputId,
        required: isRequired
    });
};
var $7ea19a7a7289690d$export$2e2bcd8739ae039 = $7ea19a7a7289690d$var$SelectEdit;

});

parcelRegister("fwjqo", function(module, exports) {

$parcel$export(module.exports, "transformDefaultSelectValues", () => $f6b66909689bc95b$export$cfb7677fb5241257);
$parcel$export(module.exports, "onFilterOption", () => $f6b66909689bc95b$export$5fde4483c43b93b);

var $42gdJ = parcelRequire("42gdJ");
const $f6b66909689bc95b$export$cfb7677fb5241257 = (defaultValue)=>{
    if (Array.isArray(defaultValue)) return (0, $42gdJ.mapDataToSelectOptions)(defaultValue);
    return (0, $42gdJ.mapDataToSelectOption)(defaultValue);
};
const $f6b66909689bc95b$export$5fde4483c43b93b = (option, inputValue)=>option.label.toLowerCase().includes(inputValue.toLowerCase());

});



parcelRegister("7EBWy", function(module, exports) {

$parcel$export(module.exports, "default", () => $e70572f948a859a6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b7b1I = parcelRequire("b7b1I");
const $e70572f948a859a6$var$MultiUserPickerField = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b7b1I.default), {
        ...props,
        isMulti: true,
        context: "CustomMultiUserField"
    });
var $e70572f948a859a6$export$2e2bcd8739ae039 = $e70572f948a859a6$var$MultiUserPickerField;

});
parcelRegister("b7b1I", function(module, exports) {

$parcel$export(module.exports, "default", () => $44490b1e46778077$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $l760E = parcelRequire("l760E");

var $7TaJX = parcelRequire("7TaJX");

var $lIor1 = parcelRequire("lIor1");

var $6HoNR = parcelRequire("6HoNR");

var $icPhQ = parcelRequire("icPhQ");

var $bRVha = parcelRequire("bRVha");
const $44490b1e46778077$var$getAutoCompleteUrl = (context, fieldId, projectKey)=>`/rest/api/3/user/recommend?${new URLSearchParams({
        context: context,
        ...projectKey && {
            project: projectKey
        },
        ...fieldId && {
            fieldId: fieldId
        },
        query: ''
    })}`;
const $44490b1e46778077$var$UserPickerField = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange, id: id }, isMulti: isMulti, autoFocus: autoFocus = false, fieldId: fieldId, placeholder: placeholder = ' ', isDisabled: isDisabled = false, isReadOnly: isReadOnly = false, onFetchSuggestions: onFetchSuggestions, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, context: context, selectedProject: selectedProject } = props;
    const getExtraProps = ()=>{
        if ((0, $1ybV0.ff)('common-field-behaviour-for-new-gic_q9mgt')) return {
            onCloseMenuOnScroll: (0, $7TaJX.closeMenuOnScroll),
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered
        };
        return {};
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l760E.default), {
        autoCompleteUrl: $44490b1e46778077$var$getAutoCompleteUrl(context, fieldId, selectedProject?.projectKey),
        placeholder: placeholder,
        isDisabled: isReadOnly || isDisabled,
        onChange: onChange,
        value: value,
        appearance: "normal",
        isMulti: isMulti,
        autoFocus: autoFocus,
        fieldId: fieldId,
        fetchSuggestions: onFetchSuggestions,
        isClearable: true,
        width: width,
        inputId: id,
        ...getExtraProps()
    }));
};
var $44490b1e46778077$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    validator: (0, $lIor1.validateUserPickerField),
    transformDefaultValue: (0, $bRVha.transformDefaultUserValues)
})($44490b1e46778077$var$UserPickerField);

});
parcelRegister("l760E", function(module, exports) {

$parcel$export(module.exports, "default", () => $486d78b4e0f4b8d2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $f6ziy = parcelRequire("f6ziy");
var $fXyiT = parcelRequire("fXyiT");

var $9U5c4 = parcelRequire("9U5c4");
const $486d78b4e0f4b8d2$var$UserPickerEdit = (props)=>{
    const { fieldId: fieldId, appearance: appearance, width: width, onChange: onChange, onSelection: onSelection, value: value, autoFocus: autoFocus = false, placeholder: placeholder = '', isDisabled: isDisabled = false, autoCompleteUrl: autoCompleteUrl, isMulti: isMulti, fetchSuggestions: fetchSuggestions, emptyOption: emptyOption, onDataLoaded: onDataLoaded, onDataRequest: onDataRequest, onCancel: onCancel, isDropdownVisibleByDefault: isDropdownVisibleByDefault, isClearable: isClearable, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, onCloseMenuOnScroll: onCloseMenuOnScroll, inputId: inputId, isBulkEdit: isBulkEdit = false, ...fieldProps } = props;
    const extraProps = ()=>{
        if ((0, $9U5c4.isBehaviourCommonForAllFieldsInNewGic)() && isDropdownMenuFixedAndLayered) return {
            menuPosition: 'fixed',
            styles: (0, $fXyiT.defaultUserPickerStyles),
            onCloseMenuOnScroll: onCloseMenuOnScroll
        };
        if ((0, $9U5c4.isBehaviourCommonForAllFieldsInNewGic)()) return {
            onCloseMenuOnScroll: onCloseMenuOnScroll
        };
        return {};
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f6ziy.default), {
        ...fieldProps,
        fieldId: fieldId,
        inputId: inputId,
        appearance: appearance,
        width: width,
        onChange: onChange,
        value: value,
        autoFocus: autoFocus,
        placeholder: placeholder,
        isDisabled: isDisabled,
        isMulti: isMulti,
        autoCompleteUrl: autoCompleteUrl,
        fetchSuggestions: fetchSuggestions,
        emptyOption: emptyOption,
        onSelection: onSelection,
        onDataLoaded: onDataLoaded,
        onDataRequest: onDataRequest,
        onCancel: onCancel,
        isDropdownVisibleByDefault: isDropdownVisibleByDefault,
        isClearable: isClearable,
        isBulkEdit: isBulkEdit,
        ...extraProps()
    });
};
var $486d78b4e0f4b8d2$export$2e2bcd8739ae039 = $486d78b4e0f4b8d2$var$UserPickerEdit;

});
parcelRegister("f6ziy", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5419167c244652a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $jG2Eu = parcelRequire("jG2Eu");

var $jYnpi = parcelRequire("jYnpi");

var $lRmyA = parcelRequire("lRmyA");

var $5JgJ2 = parcelRequire("5JgJ2");


var $2pDIr = parcelRequire("2pDIr");

var $iVXi8 = parcelRequire("iVXi8");

var $aofgi = parcelRequire("aofgi");
const $d5419167c244652a$var$stringContains = (str, substr)=>{
    if (str == null) return false;
    if (substr == null || substr === '') return true;
    return str.toLowerCase().includes(substr.toLowerCase());
};
const $d5419167c244652a$export$251bdbdbce9550ea = 400;
const $d5419167c244652a$var$UserPickerWrapper = (props)=>{
    const { allowEmail: allowEmail = false, isDisabled: isDisabled, isMulti: isMulti = false, value: value = null, emptyOption: emptyOption = null, appearance: appearance = 'compact', onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onCancel: onCancel = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onSelection: onSelection = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onDataRequest: onDataRequest = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onDataLoaded: onDataLoaded = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), isClearable: isClearable = false, portalElement: portalElement, isDropdownVisibleByDefault: isDropdownVisibleByDefault, menuPosition: menuPosition, onCloseMenuOnScroll: onCloseMenuOnScroll, autoFocus: autoFocus, fieldId: fieldId, placeholder: placeholder, width: width, autoCompleteUrl: autoCompleteUrl, noBorder: noBorder, styles: styles, shouldShowEmailInOptions: shouldShowEmailInOptions = false, withoutDebounce: withoutDebounce = false, inputId: inputId, isBulkEdit: isBulkEdit = false, openMenuOnClick: openMenuOnClick = false, isRequired: isRequired = false, ...fieldProps } = props;
    const [isDropdownVisible, setIsDropdownVisible] = (0, $eUqFw.useState)(Boolean(isDropdownVisibleByDefault));
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    // null instead of '' because:
    // 1. fetchSuggestions is called as part of useEffect with query as one of the dependencies
    // 2. we dont want to call fetchSuggestions on mount, so added a check query !== null
    // 3. we want to call fetchSuggestions when query is '' and when picker gets focused (we set query as '') when it gets focused
    const [query, setQueryString] = (0, $eUqFw.useState)(null);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [wasFocused, setWasFocused] = (0, $eUqFw.useState)(false);
    const [wasCleared, setWasCleared] = (0, $eUqFw.useState)(false);
    const [suggestions, setSuggestions] = (0, $eUqFw.useState)([]);
    const [sessionId, setSessionId] = (0, $eUqFw.useState)('');
    const getEmptyValue = ()=>emptyOption ? {
            ...emptyOption,
            id: (0, $8c03579f1a24f6e2$export$61a0b64dfe00294c)
        } : null;
    const debounceTime = withoutDebounce ? 0 : $d5419167c244652a$export$251bdbdbce9550ea;
    const requestSuggestionsDebounced = (0, $eUqFw.useMemo)(()=>{
        const isCurrentValue = (userOptionValue)=>{
            if (!userOptionValue) return value === null;
            if (Array.isArray(value)) return value.length > 0 ? !!value.find((suggestion)=>suggestion.id === userOptionValue.id) : userOptionValue.id === (0, $8c03579f1a24f6e2$export$61a0b64dfe00294c);
            return value ? userOptionValue.id === value.id : userOptionValue.id === (0, $8c03579f1a24f6e2$export$61a0b64dfe00294c);
        };
        const fetchSuggestions = async ()=>{
            let users = [];
            if (autoCompleteUrl !== undefined) {
                const autoCompleteResponse = await (0, $lRmyA.performGetRequest)(`${autoCompleteUrl}${query || ''}`);
                users = (0, $aofgi.mapAutoCompleteResponseToUsers)(autoCompleteResponse, isBulkEdit);
            }
            return users.map((userData)=>(0, $aofgi.mapUserObjectToUserOption)(userData, shouldShowEmailInOptions));
        };
        const handleSuggestions = (newSuggestions)=>{
            if (!isDropdownVisible || !newSuggestions) return;
            // Prevent the selected value from appearing in the list of suggestions at initial load.
            const filteredSuggestions = wasFocused ? newSuggestions.filter((suggestion)=>!isCurrentValue(suggestion)) : newSuggestions;
            setIsLoading(false);
            setSuggestions(filteredSuggestions);
            onDataLoaded(!query, filteredSuggestions.length);
        };
        const handleError = ()=>{
            setIsLoading(false);
            setSuggestions([]);
        };
        // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
        const requestSuggestions = ()=>{
            onDataRequest(!query);
            const { fetchSuggestions: fetchSuggestionsProps } = props;
            if (fetchSuggestionsProps) return fetchSuggestionsProps(query, sessionId).then((results)=>{
                handleSuggestions(results);
            }).catch(handleError);
            return fetchSuggestions().then((results)=>handleSuggestions(results)).catch(handleError);
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(()=>{
            requestSuggestions();
        }, debounceTime);
    }, [
        debounceTime,
        value,
        autoCompleteUrl,
        query,
        isBulkEdit,
        shouldShowEmailInOptions,
        isDropdownVisible,
        wasFocused,
        onDataLoaded,
        onDataRequest,
        props,
        sessionId
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // Added extra !isDropdownVisible condition - avoid query when dropdown is closed
        if (query === null || !isDropdownVisible) return;
        requestSuggestionsDebounced();
        return ()=>{
            requestSuggestionsDebounced.cancel();
        };
    }, [
        requestSuggestionsDebounced,
        query,
        isDropdownVisible
    ]);
    const onSelectedValueChangeMulti = (userOptionValue)=>{
        if (userOptionValue && userOptionValue.length === 0) onChange(null);
        else onChange(userOptionValue);
    };
    const onSelectedValueChangeSingle = (userOptionValue)=>{
        const valueId = userOptionValue && !Array.isArray(userOptionValue) && userOptionValue.id;
        if (valueId === (0, $8c03579f1a24f6e2$export$61a0b64dfe00294c)) onChange(null);
        else onChange(userOptionValue);
    };
    const onSuggestionSelect = (userOptionValue, sId)=>{
        setSessionId(sId || '');
        setWasFocused(false);
        setWasCleared(false);
        setIsLoading(false);
        setSuggestions([]);
        onSelection(sessionId);
        if (Array.isArray(userOptionValue)) onSelectedValueChangeMulti(userOptionValue);
        else // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        onSelectedValueChangeSingle(userOptionValue);
    };
    const onBlur = ()=>{
        setIsDropdownVisible(false);
        setIsLoading(false);
        setWasFocused(false);
        setSuggestions([]);
        if (wasCleared) {
            onSuggestionSelect(getEmptyValue());
            return;
        }
        onCancel();
    };
    const onDropdownOpen = (sId)=>{
        setSessionId(sId || '');
        setQueryString('');
        setIsDropdownVisible(true);
        setIsLoading(true);
        setWasFocused(true);
        setWasCleared(false);
    };
    const onQueryChange = (queryStr, sId)=>{
        setSessionId(sId || '');
        setQueryString(queryStr || '');
        setIsLoading(!!queryStr);
        setWasFocused(false);
        setIsDropdownVisible(!!queryStr);
    };
    const onClear = ()=>{
        setWasCleared(true);
        onSuggestionSelect(null);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const closeMenuOnScroll = (e)=>{
        if (onCloseMenuOnScroll && onCloseMenuOnScroll(e)) setIsDropdownVisible(false);
    };
    const isMatchingQuery = (suggestion)=>{
        // when feature flag is false the predict should allow all
        const { displayName: displayName, name: name } = suggestion;
        return !isLoading || $d5419167c244652a$var$stringContains(displayName, query) || $d5419167c244652a$var$stringContains(name, query);
    };
    const getSuggestions = ()=>suggestions.filter((suggestion)=>isMatchingQuery(suggestion));
    const filteredSuggestions = getSuggestions();
    const pickerValue = value || getEmptyValue();
    const getNoOptionsMessage = ()=>query === null || query === '' ? formatMessage((0, $iVXi8.default).emptyQueryMessage) : undefined;
    /*
   * user picker default opens on focus, so most of the operations like loading, querying, dropdown open/close are modified during onFocus
   * when openMenuOnClick is true then dropdown state managed internally as like select then have to use onOpen to modify any state like loading, querying
   */ const controlProps = openMenuOnClick ? {
        openMenuOnClick: openMenuOnClick,
        onOpen: onDropdownOpen
    } : {
        open: isDropdownVisible,
        onFocus: onDropdownOpen
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jYnpi.UserPicker), {
        value: pickerValue,
        options: filteredSuggestions,
        isMulti: isMulti,
        fieldId: fieldId,
        menuMinWidth: props.menuMinWidth,
        menuPortalTarget: portalElement,
        width: width,
        appearance: appearance,
        isClearable: isClearable,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        placeholder: placeholder,
        onBlur: onBlur,
        isLoading: isLoading && isDropdownVisible,
        onClear: onClear,
        onInputChange: onQueryChange,
        onChange: onSuggestionSelect,
        noBorder: noBorder,
        styles: styles,
        noOptionsMessage: getNoOptionsMessage,
        allowEmail: allowEmail,
        inputId: inputId,
        required: isRequired,
        ariaLabelledBy: fieldProps['aria-labelledby'],
        ...(0, $2pDIr.isBehaviourCommonForAllFieldsInNewGic)() ? {
            closeMenuOnScroll: closeMenuOnScroll,
            menuPosition: menuPosition
        } : {},
        ...controlProps
    });
};
var $d5419167c244652a$export$2e2bcd8739ae039 = $d5419167c244652a$var$UserPickerWrapper;

});
const $8c03579f1a24f6e2$export$61a0b64dfe00294c = 'USER_PICKER_EMPTY';

parcelRegister("2pDIr", function(module, exports) {

$parcel$export(module.exports, "isBehaviourCommonForAllFieldsInNewGic", () => $99030681acc4fdc6$export$b2f73d54757eb059);

var $1ybV0 = parcelRequire("1ybV0");
const $99030681acc4fdc6$export$b2f73d54757eb059 = ()=>(0, $1ybV0.ff)('common-field-behaviour-for-new-gic_q9mgt', false);

});

parcelRegister("iVXi8", function(module, exports) {

$parcel$export(module.exports, "default", () => $34009d93e46b078d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $34009d93e46b078d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    emptyQueryMessage: {
        "id": "base-user-picker.empty-query-message",
        "defaultMessage": "Start typing to get a list of possible matches."
    }
});

});

parcelRegister("aofgi", function(module, exports) {

$parcel$export(module.exports, "mapUserObjectToUserOption", () => $656635459ed543f4$export$e11fc32dba4fe919);
$parcel$export(module.exports, "mapAutoCompleteResponseToUsers", () => $656635459ed543f4$export$ec325826d2bf6655);

var $guiFP = parcelRequire("guiFP");
const $656635459ed543f4$export$e11fc32dba4fe919 = (userData, shouldShowEmailInOptions = false)=>{
    let userOption = {
        id: userData.accountId || '',
        name: userData.displayName || '',
        avatarUrl: userData?.avatarUrl || userData.avatarUrls?.['32x32'] || ''
    };
    if (shouldShowEmailInOptions === true && userData.emailAddress !== null && userData.emailAddress !== undefined) // @ts-expect-error - TS2322 - Type '{ byline: string; id: string; name: string; avatarUrl: string; }' is not assignable to type '{ id: string; name: string; avatarUrl: string; }'.
    userOption = {
        ...userOption,
        byline: userData.emailAddress
    };
    return userOption;
};
const $656635459ed543f4$export$ec325826d2bf6655 = (autoCompleteResponse, isBulkEdit)=>{
    try {
        if (isBulkEdit) {
            if (autoCompleteResponse && typeof autoCompleteResponse === 'object' && 'users' in autoCompleteResponse && autoCompleteResponse.users) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return autoCompleteResponse.users;
        } else if (Array.isArray(autoCompleteResponse)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return autoCompleteResponse;
        throw Error('autoCompleteResponse is either null or not expected value');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'mapAutoCompleteResponse',
                packageName: 'jiraBaseUserPicker',
                teamName: 'gryffindor'
            },
            error: error
        });
    }
    return [];
};

});


parcelRegister("9U5c4", function(module, exports) {

$parcel$export(module.exports, "isBehaviourCommonForAllFieldsInNewGic", () => $2789f9b7d7c3ea89$export$b2f73d54757eb059);

var $1ybV0 = parcelRequire("1ybV0");
const $2789f9b7d7c3ea89$export$b2f73d54757eb059 = ()=>(0, $1ybV0.ff)('common-field-behaviour-for-new-gic_q9mgt', false);

});




parcelRegister("h5iE1", function(module, exports) {

$parcel$export(module.exports, "default", () => $a95693b07f216a4a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hKm1t = parcelRequire("hKm1t");

var $icPhQ = parcelRequire("icPhQ");
var $5i7Lk = parcelRequire("5i7Lk");
var $6HoNR = parcelRequire("6HoNR");

var $7TaJX = parcelRequire("7TaJX");
var $lIor1 = parcelRequire("lIor1");

var $2NRUM = parcelRequire("2NRUM");

var $14d8O = parcelRequire("14d8O");
const $a95693b07f216a4a$var$MultiVersionsField = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired }, fieldId: fieldId, fieldName: fieldName, description: description, isReadOnly: isReadOnly = false, allowedValues: allowedValues, error: error, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $7TaJX.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isMini: isMini } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const options = (0, $14d8O.transformVersionExternalOptionstoVersionOptions)(allowedValues);
    const isDisabled = allowedValues.length === 0;
    const onChangeVersionsEdit = (versionEditValue)=>{
        if (Array.isArray(versionEditValue) || versionEditValue === null) onChange(versionEditValue);
    };
    const getVersionsEdit = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hKm1t.default), {
            options: options,
            value: value,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            isMulti: true,
            onChange: onChangeVersionsEdit,
            isInvalid: Boolean(error),
            fieldId: fieldId,
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            isDisabled: isReadOnly || isDisabled,
            autoFocus: autoFocus,
            placeholder: isDisabled ? formatMessage((0, $2NRUM.default).none) : '',
            inputId: id,
            isRequired: isRequired
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: formatMessage((0, $2NRUM.default).tooltip)
    }, getVersionsEdit()) : getVersionsEdit(), !isDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5i7Lk.FieldMessage), {
        description: description,
        error: error,
        fieldName: fieldName,
        isMini: isMini
    }));
};
var $a95693b07f216a4a$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    validator: (0, $lIor1.validateMultiVersionsField),
    transformDefaultValue: (0, $14d8O.transformVersionExternalOptionstoVersionOptions),
    shouldRenderFieldMessage: false
})($a95693b07f216a4a$var$MultiVersionsField);

});
parcelRegister("hKm1t", function(module, exports) {

$parcel$export(module.exports, "default", () => $af5221ed4d00caac$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5wCDk = parcelRequire("5wCDk");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4NcaX = parcelRequire("4NcaX");

var $bHNyo = parcelRequire("bHNyo");
const $af5221ed4d00caac$var$Versions = (props)=>{
    const { value: value, options: options, onChange: onChange, placeholder: placeholder = '', isInvalid: isInvalid, fieldId: fieldId, isMulti: isMulti, autoFocus: autoFocus = false, isDisabled: isDisabled, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, inputId: inputId, isRequired: isRequired, classNamePrefix: classNamePrefix, isClearable: isClearable = true } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const getIsClearable = ()=>{
        if (!isClearable) return false;
        return Array.isArray(value) ? value.length > 0 : Boolean(value);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
        placeholder: placeholder,
        options: (0, $bHNyo.getGroupedOptions)((0, $bHNyo.removeArchivedOptions)(options), formatMessage),
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        value: value,
        fieldId: fieldId,
        isMulti: isMulti,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
        styles: (0, $4NcaX.defaultSelectStyles),
        // @ts-expect-error - TS2322 - Type '(option: VersionOption | VersionOption[] | null) => void' is not assignable to type '(value: VersionOption | OptionsType<VersionOption> | null, action: ActionMeta<VersionOption>) => void'.
        onChange: onChange,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        closeMenuOnScroll: onCloseMenuOnScroll,
        isClearable: getIsClearable(),
        inputId: inputId,
        required: isRequired,
        classNamePrefix: classNamePrefix
    });
};
var $af5221ed4d00caac$export$2e2bcd8739ae039 = $af5221ed4d00caac$var$Versions;

});
parcelRegister("bHNyo", function(module, exports) {

$parcel$export(module.exports, "transformVersionExternalToVersion", () => $d5d7d94cd14e5f85$export$c1c38f7974aa8bed);
$parcel$export(module.exports, "removeArchivedOptions", () => $d5d7d94cd14e5f85$export$6f0b68b6e372a0e6);
$parcel$export(module.exports, "getGroupedOptions", () => $d5d7d94cd14e5f85$export$721c3d9226425f9c);
$parcel$export(module.exports, "getVersionsIds", () => $d5d7d94cd14e5f85$export$c96a1607e976ccc6);
$parcel$export(module.exports, "getVersionId", () => $d5d7d94cd14e5f85$export$d0a84488c5034e2b);

var $aWNGG = parcelRequire("aWNGG");
const $d5d7d94cd14e5f85$var$getStatusFromRestOption = (option)=>{
    if (option.released) return 'RELEASED';
    if (option.archived) return 'ARCHIVED';
    return 'UNRELEASED';
};
const $d5d7d94cd14e5f85$export$eb178ff2323a1ab3 = (option)=>({
        label: option.name,
        value: option.id,
        status: $d5d7d94cd14e5f85$var$getStatusFromRestOption(option)
    });
const $d5d7d94cd14e5f85$export$c1c38f7974aa8bed = (option)=>({
        label: option.name,
        value: option.id,
        status: option.status
    });
const $d5d7d94cd14e5f85$export$6f0b68b6e372a0e6 = (options)=>options.filter((option)=>option.status !== 'ARCHIVED');
const $d5d7d94cd14e5f85$export$721c3d9226425f9c = (options, formatMessage)=>{
    const groupedOptions = [];
    // archived options are assumed to be filtered out already since we don't want to display them. Here, we are grouping according to 'status' being RELEASED or UNRELEASED
    if (options.length) {
        // the order of versions is decided from the first option since the API response follows the order
        const versionOrder = options.length && options[0].status === 'RELEASED' ? [
            'RELEASED',
            'UNRELEASED'
        ] : [
            'UNRELEASED',
            'RELEASED'
        ];
        // @ts-expect-error - TS2345 - Argument of type '(status: Status) => void' is not assignable to parameter of type '(value: string, index: number, array: string[]) => void'.
        versionOrder.forEach((status)=>{
            const statusOptions = options.filter((option)=>option.status === status);
            if (statusOptions.length) groupedOptions.push({
                options: statusOptions,
                label: status === 'RELEASED' ? formatMessage((0, $aWNGG.default).released) : formatMessage((0, $aWNGG.default).unreleased)
            });
        });
    }
    return groupedOptions;
};
const $d5d7d94cd14e5f85$export$c96a1607e976ccc6 = (selectedVersions)=>selectedVersions.map((v)=>({
            id: v.value
        }));
const $d5d7d94cd14e5f85$export$d0a84488c5034e2b = (selectedVersion)=>({
        id: selectedVersion.value
    });

});
parcelRegister("aWNGG", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ac7f02f1d07cad0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $7ac7f02f1d07cad0$var$messages = (0, $90IgZ.defineMessages)({
    released: {
        "id": "issue-field-versions.released",
        "defaultMessage": "Released"
    },
    unreleased: {
        "id": "issue-field-versions.unreleased",
        "defaultMessage": "Unreleased"
    }
});
var $7ac7f02f1d07cad0$export$2e2bcd8739ae039 = $7ac7f02f1d07cad0$var$messages;

});



parcelRegister("2NRUM", function(module, exports) {

$parcel$export(module.exports, "default", () => $cec18bfc532ca994$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $cec18bfc532ca994$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    none: {
        "id": "issue-create-commons.multi-versions-field.none",
        "defaultMessage": "None"
    },
    tooltip: {
        "id": "issue-create-commons.multi-versions-field.tooltip",
        "defaultMessage": "We couldn't find any versions for this project"
    }
});

});

parcelRegister("14d8O", function(module, exports) {

$parcel$export(module.exports, "transformVersionExternalOptionstoVersionOptions", () => $195c57f342e4e0a8$export$11cad9e2f2e9ae55);
$parcel$export(module.exports, "mutateMultiVersionsField", () => $195c57f342e4e0a8$export$6999207a9642bd09);

var $bHNyo = parcelRequire("bHNyo");

const $195c57f342e4e0a8$export$11cad9e2f2e9ae55 = (options)=>options.map((option)=>(0, $bHNyo.transformVersionExternalToVersion)(option));
const $195c57f342e4e0a8$export$6999207a9642bd09 = (selectedVersions, fieldId)=>({
        fieldId: fieldId,
        mutationGroup: (0, $44dff69849bf970d$export$31fd86f8f183952c),
        versions: selectedVersions.map(({ value: value })=>({
                versionId: value
            }))
    });

});
const $44dff69849bf970d$export$31fd86f8f183952c = 'multipleVersionPickerFields';



parcelRegister("dLN4D", function(module, exports) {

$parcel$export(module.exports, "transformDefaultEpicValue", () => $7ccc520250d48f3d$export$d1fe9e25b0dbb9af);
$parcel$export(module.exports, "mutateEpicLinkField", () => $7ccc520250d48f3d$export$5e81faed0a30e719);
const $7ccc520250d48f3d$export$d1fe9e25b0dbb9af = ({ key: key, summary: summary })=>({
        label: summary,
        value: key
    });
const $7ccc520250d48f3d$export$5e81faed0a30e719 = ({ value: value }, fieldId)=>({
        epicLinkField: {
            fieldId: fieldId,
            epicLink: {
                issueKey: value
            }
        }
    });

});

parcelRegister("5F4bs", function(module, exports) {

$parcel$export(module.exports, "transformDefaultSprintValue", () => $c0727d09190d4de6$export$94efa001ab93bfd1);
$parcel$export(module.exports, "mutateJiraSprintField", () => $c0727d09190d4de6$export$38f8d6ec9f8dd490);
$parcel$export(module.exports, "getSprintSuggestions", () => $c0727d09190d4de6$export$a5ccca5b51d5d670);

var $lRmyA = parcelRequire("lRmyA");
const $c0727d09190d4de6$export$94efa001ab93bfd1 = (selectedSprints)=>{
    const sprint = selectedSprints[0];
    return sprint && {
        label: sprint.name,
        value: sprint.sprintId,
        state: sprint.state
    };
};
const $c0727d09190d4de6$export$38f8d6ec9f8dd490 = ({ value: value }, fieldId)=>({
        sprintsField: {
            fieldId: fieldId,
            sprints: [
                {
                    sprintId: value.toString()
                }
            ]
        }
    });
const $c0727d09190d4de6$export$c1102c96d31ebe29 = (autoCompleteUrl, query, projectKey)=>{
    const queryString = `${autoCompleteUrl}${encodeURIComponent(query)}`;
    if (projectKey !== null && projectKey !== undefined) return `${queryString}&projectKey=${encodeURIComponent(projectKey)}`;
    return queryString;
};
const $c0727d09190d4de6$export$a5ccca5b51d5d670 = async (autoCompleteUrl, query, projectKey)=>(0, $lRmyA.performGetRequest)($c0727d09190d4de6$export$c1102c96d31ebe29(autoCompleteUrl, query, projectKey));

});

parcelRegister("ia8XI", function(module, exports) {

$parcel$export(module.exports, "transformAsNumber", () => $73768a38660ac389$export$52c4e7404b9db862);
$parcel$export(module.exports, "mutateNumberField", () => $73768a38660ac389$export$6701d4d68ea6db95);
$parcel$export(module.exports, "transformAsString", () => $73768a38660ac389$export$afe59f8094df7220);

const $73768a38660ac389$export$52c4e7404b9db862 = (value)=>{
    if (value) return Number(value);
    return undefined;
};
const $73768a38660ac389$export$6701d4d68ea6db95 = (value, fieldId)=>({
        fieldId: fieldId,
        value: Number(value),
        mutationGroup: (0, $7c4e31f147f56501$export$31fd86f8f183952c)
    });
const $73768a38660ac389$export$afe59f8094df7220 = (value)=>{
    if (value !== undefined) return String(value);
    return undefined;
};

});
const $7c4e31f147f56501$export$31fd86f8f183952c = 'numberFields';


parcelRegister("6gsqy", function(module, exports) {

$parcel$export(module.exports, "mapDataToOrganizationOptions", () => $c0cae145a4ac925a$export$bb720a783a78b0f4);
$parcel$export(module.exports, "mutateOrganizationsField", () => $c0cae145a4ac925a$export$51fa85dc3b5fc461);
const $c0cae145a4ac925a$export$bb720a783a78b0f4 = (data)=>data.map(({ organizationName: organizationName, organizationId: organizationId })=>({
            value: organizationId,
            label: organizationName
        }));
const $c0cae145a4ac925a$export$51fa85dc3b5fc461 = (selectedOrganizations, fieldId)=>({
        organizationField: {
            fieldId: fieldId,
            organizations: selectedOrganizations.map(({ value: value })=>({
                    organizationId: value
                }))
        }
    });

});

parcelRegister("897qz", function(module, exports) {

$parcel$export(module.exports, "transformDefaultParentValue", () => $f264ebfdd5ad9a23$export$f38bec4d01c88544);
$parcel$export(module.exports, "validateParentField", () => $f264ebfdd5ad9a23$export$656803053e0b9113);
$parcel$export(module.exports, "mutateParentField", () => $f264ebfdd5ad9a23$export$15ec054c85ac7db1);

var $dEMIg = parcelRequire("dEMIg");

var $tgbCK = parcelRequire("tgbCK");
const $f264ebfdd5ad9a23$export$f38bec4d01c88544 = (defaultValue)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const summaryField = defaultValue.fieldsById.edges.find((field)=>field.node.__typename === 'JiraSingleLineTextField');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const issueTypeField = defaultValue.fieldsById.edges.find((field)=>field.node.__typename === 'JiraIssueType');
    const { key: key, issueId: issueId, issueColorField: issueColorField } = defaultValue;
    const summary = summaryField?.node.text;
    const label = `${key} ${summary}`;
    return {
        label: label,
        value: issueId,
        key: key,
        color: issueColorField && issueColorField.color !== null ? (0, $tgbCK.MAP_FROM_SERVER_COLOR)[issueColorField.color] : undefined,
        fields: {
            summary: summary,
            issuetype: {
                name: issueTypeField?.node.issueType.name,
                iconUrl: issueTypeField?.node.issueType.avatar.xsmall
            }
        }
    };
};
const $f264ebfdd5ad9a23$export$656803053e0b9113 = (data, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!data) return 0, $dEMIg.REQUIRED;
    }
    return undefined;
};
const $f264ebfdd5ad9a23$export$15ec054c85ac7db1 = ({ value: value })=>({
        parentField: {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            issueId: value
        }
    });

});

parcelRegister("3O2c6", function(module, exports) {

$parcel$export(module.exports, "transformDefaultValue", () => $d4d92de5d27920ea$export$e2f4e5d31db527cc);
$parcel$export(module.exports, "mutatePriorityField", () => $d4d92de5d27920ea$export$2c46dd13be598543);
const $d4d92de5d27920ea$export$e2f4e5d31db527cc = ({ id: id, name: name, iconUrl: iconUrl })=>({
        label: name,
        value: id,
        iconUrl: iconUrl
    });
const $d4d92de5d27920ea$export$2c46dd13be598543 = ({ value: value })=>({
        priority: {
            priorityId: value
        }
    });

});

parcelRegister("6Pq4z", function(module, exports) {

$parcel$export(module.exports, "mutateProjectField", () => $8dc977ef8d446137$export$fb6480503bf79949);
$parcel$export(module.exports, "validateProjectField", () => $8dc977ef8d446137$export$5c1e30a9f731caaf);
$parcel$export(module.exports, "transformDefaultProjectValue", () => $8dc977ef8d446137$export$c77f86922e480ac0);

var $dEMIg = parcelRequire("dEMIg");
const $8dc977ef8d446137$export$fb6480503bf79949 = (selectedProject, fieldId)=>({
        projectFields: [
            {
                fieldId: fieldId,
                project: {
                    projectId: selectedProject.projectId || ''
                }
            }
        ]
    });
const $8dc977ef8d446137$export$5c1e30a9f731caaf = (data, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!data) return 0, $dEMIg.REQUIRED;
    }
    return undefined;
};
const $8dc977ef8d446137$export$c77f86922e480ac0 = (data)=>({
        label: data.name,
        value: data.key,
        iconUrl: data.avatar.large,
        projectId: data.id
    });

});

parcelRegister("gtaAU", function(module, exports) {

$parcel$export(module.exports, "mapAllowedValuesToSelectOptions", () => $4e3583cd2a60d08a$export$103f56c5c26f12e5);
$parcel$export(module.exports, "transformDefaultResolutionValue", () => $4e3583cd2a60d08a$export$dbeca145fe19aaf1);
$parcel$export(module.exports, "mutateResolutionField", () => $4e3583cd2a60d08a$export$a08b1e842f0a7a26);
const $4e3583cd2a60d08a$export$103f56c5c26f12e5 = (allowedValues)=>allowedValues.map((value)=>({
            value: value.id,
            label: value.name
        }));
const $4e3583cd2a60d08a$export$dbeca145fe19aaf1 = (value)=>({
        value: value.id,
        label: value.name
    });
const $4e3583cd2a60d08a$export$a08b1e842f0a7a26 = (selectedResolution)=>({
        resolution: {
            resolutionId: selectedResolution.value
        }
    });

});

parcelRegister("3x0xT", function(module, exports) {

$parcel$export(module.exports, "transformGroupDefaultValueToUserOption", () => $03c43028a694f8c2$export$d9591be6713fcfc8);
$parcel$export(module.exports, "mutateSingleGroupPickerField", () => $03c43028a694f8c2$export$daeca2ffaa5d8b62);

var $gnxL7 = parcelRequire("gnxL7");

const $03c43028a694f8c2$export$d9591be6713fcfc8 = (group)=>{
    if (!group) return null;
    return (0, $gnxL7.transformGroupToUserOption)(group);
};
const $03c43028a694f8c2$export$daeca2ffaa5d8b62 = (selectedGroup, fieldId)=>({
        fieldId: fieldId,
        group: {
            groupName: selectedGroup.name
        },
        mutationGroup: (0, $d295d044454c3082$export$31fd86f8f183952c)
    });

});
const $d295d044454c3082$export$31fd86f8f183952c = 'singleGroupPickerFields';


parcelRegister("ePdOt", function(module, exports) {

$parcel$export(module.exports, "transformVersionExternalOptionstoVersionOptions", () => $cb698ff3c17d94b7$export$11cad9e2f2e9ae55);
$parcel$export(module.exports, "mutateSingleVersionField", () => $cb698ff3c17d94b7$export$57ed62196c76c8b6);

var $bHNyo = parcelRequire("bHNyo");

const $cb698ff3c17d94b7$export$11cad9e2f2e9ae55 = (options)=>options.map((option)=>(0, $bHNyo.transformVersionExternalToVersion)(option));
const $cb698ff3c17d94b7$export$57ed62196c76c8b6 = ({ value: value }, fieldId)=>({
        fieldId: fieldId,
        mutationGroup: (0, $de7e1a312ba062c4$export$31fd86f8f183952c),
        version: {
            versionId: value
        }
    });

});
const $de7e1a312ba062c4$export$31fd86f8f183952c = 'singleVersionPickerFields';


parcelRegister("5TtxV", function(module, exports) {

$parcel$export(module.exports, "mutateTextAreaField", () => $cbf31238b37b1bec$export$26988cd8ac7fed9b);

const $cbf31238b37b1bec$export$26988cd8ac7fed9b = (value, fieldId)=>({
        fieldId: fieldId,
        mutationGroup: (0, $833488308f5e98e7$export$31fd86f8f183952c),
        richText: {
            wikiText: value
        }
    });

});
const $833488308f5e98e7$export$31fd86f8f183952c = 'richTextFields';


parcelRegister("ljNBY", function(module, exports) {

$parcel$export(module.exports, "mutateTextField", () => $6424694ac02a8a4e$export$5dd442db0007fb2d);

const $6424694ac02a8a4e$export$5dd442db0007fb2d = (value, fieldId)=>({
        fieldId: fieldId,
        text: value,
        mutationGroup: (0, $eea34806b0e9f5c7$export$31fd86f8f183952c)
    });

});
const $eea34806b0e9f5c7$export$31fd86f8f183952c = 'singleLineTextFields';


parcelRegister("5d2AR", function(module, exports) {

$parcel$export(module.exports, "mutateUrlField", () => $8678185a37f46f5a$export$68f54af506df5feb);

const $8678185a37f46f5a$export$68f54af506df5feb = (url, fieldId)=>{
    const mutatedValue = {
        fieldId: fieldId,
        mutationGroup: (0, $c661d526046976b4$export$31fd86f8f183952c)
    };
    mutatedValue.url = url;
    return mutatedValue;
};

});
const $c661d526046976b4$export$31fd86f8f183952c = 'urlFields';


parcelRegister("5u49X", function(module, exports) {

$parcel$export(module.exports, "default", () => $1768a5d7fc57faa0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $guGTQ = parcelRequire("guGTQ");

var $6HoNR = parcelRequire("6HoNR");

var $lIor1 = parcelRequire("lIor1");

var $ia8XI = parcelRequire("ia8XI");
const $1768a5d7fc57faa0$export$63c5fa0b2fdccd2e = (props)=>{
    const { width: width = 350, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $guGTQ.InputField), {
        type: "number",
        width: width,
        ...rest
    });
};
var $1768a5d7fc57faa0$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    validator: (0, $lIor1.validateString),
    transformDefaultValue: (0, $ia8XI.transformAsString)
})(// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<InputFieldConfig, string>, any>'.
$1768a5d7fc57faa0$export$63c5fa0b2fdccd2e);

});
parcelRegister("guGTQ", function(module, exports) {

$parcel$export(module.exports, "InputField", () => $63f0096515b05ab8$export$dd2171e2b7d3bc5b);
$parcel$export(module.exports, "default", () => $63f0096515b05ab8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cf2Y4 = parcelRequire("cf2Y4");

var $lIor1 = parcelRequire("lIor1");

var $6HoNR = parcelRequire("6HoNR");

var $f5AnN = parcelRequire("f5AnN");
const $63f0096515b05ab8$export$dd2171e2b7d3bc5b = (props)=>{
    const { type: type = 'text', width: width = 'auto', error: error, fieldProps: { value: value = '', onChange: onChange, ...rest }, autoFocus: autoFocus, isReadOnly: isReadOnly = false } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
        ...rest,
        // @ts-expect-error - TS2322 - Type '(value: string) => void' is not assignable to type 'FormEventHandler<HTMLInputElement>'.
        onChange: onChange,
        value: value,
        type: type,
        width: width,
        step: "any",
        testId: "issue-create-commons.common.ui.fields.base-fields.input-field.textfield",
        isInvalid: Boolean(error),
        autoFocus: autoFocus,
        onWheel: (0, $f5AnN.preventMouseScrollForNumericFieldHandler),
        isDisabled: isReadOnly || rest.isDisabled
    });
};
var $63f0096515b05ab8$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    validator: (0, $lIor1.validateString)
})(// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<InputFieldConfig, string>, any>'.
$63f0096515b05ab8$export$dd2171e2b7d3bc5b);

});
parcelRegister("f5AnN", function(module, exports) {

$parcel$export(module.exports, "preventMouseScrollForNumericFieldHandler", () => $5e92c6f878fb6e67$export$3fedcbfe1c53d8f);
const $5e92c6f878fb6e67$export$3fedcbfe1c53d8f = (event)=>{
    if (event?.currentTarget?.type === 'number') event.currentTarget.blur?.();
};

});



parcelRegister("eUIIn", function(module, exports) {

$parcel$export(module.exports, "default", () => $45ce49bc8d143ced$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jnAdG = parcelRequire("jnAdG");

var $gGtKh = parcelRequire("gGtKh");

var $icPhQ = parcelRequire("icPhQ");
var $dibFF = parcelRequire("dibFF");
var $6HoNR = parcelRequire("6HoNR");

var $7TaJX = parcelRequire("7TaJX");

var $lIor1 = parcelRequire("lIor1");

var $6gsqy = parcelRequire("6gsqy");
const $45ce49bc8d143ced$var$OrganizationsField = (props)=>{
    const { autoCompleteUrl: autoCompleteUrl, width: width, autoFocus: autoFocus = false, fieldProps: { value: value, onChange: onChange, ...fieldProps }, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $7TaJX.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, error: error } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "organizations-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dibFF.FieldLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jnAdG.LazyOrganizationsEdit), {
        ...fieldProps,
        isInvalid: Boolean(error),
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        autoCompleteUrl: autoCompleteUrl,
        onChange: onChange,
        value: value,
        autoFocus: autoFocus,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        fetchSuggestionsOnFocus: true
    })));
};
var $45ce49bc8d143ced$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    validator: (0, $lIor1.validateOrganizationsField),
    transformDefaultValue: (0, $6gsqy.mapDataToOrganizationOptions)
})($45ce49bc8d143ced$var$OrganizationsField);

});
parcelRegister("jnAdG", function(module, exports) {

$parcel$export(module.exports, "LazyOrganizationsEdit", () => $4232ad2273aded69$export$f11d485f96c53cba);

var $7rh0R = parcelRequire("7rh0R");

const $4232ad2273aded69$export$f11d485f96c53cba = (0, $7rh0R.lazy)(()=>(parcelRequire("ebZPI")).then((module)=>module.OrganizationsEdit), {
    moduleId: "./src/packages/issue/fields/organizations/src/index.tsx"
});

});
parcelRegister("ebZPI", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('lJzT4');
        const value = parcelRequire('L8xlT');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("lJzT4").then(()=>parcelRequire('L8xlT'));
}

});



parcelRegister("b81gR", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bf9e91932e8e20c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dfBCt = parcelRequire("dfBCt");

var $1ybV0 = parcelRequire("1ybV0");


var $d9Uys = parcelRequire("d9Uys");
var $ctBfd = parcelRequire("ctBfd");

var $icPhQ = parcelRequire("icPhQ");

var $6HoNR = parcelRequire("6HoNR");

var $7TaJX = parcelRequire("7TaJX");

var $897qz = parcelRequire("897qz");
// The width of Parent label in English with default font settings
const $2bf9e91932e8e20c$var$parentLabelWidthDefault = 39;
const $2bf9e91932e8e20c$export$96c87c0afbe06b37 = (props)=>{
    const { fieldId: fieldId, fieldName: fieldName, fieldProps: { value: value, onChange: onChange }, width: width, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $7TaJX.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isExistingIssue: isExistingIssue, selectedProject: selectedProject, selectedIssueType: selectedIssueType, issueKey: issueKey, isReadOnly: isReadOnly = false } = props;
    const [leftPosition, setLeftPosition] = (0, $eUqFw.useState)($2bf9e91932e8e20c$var$parentLabelWidthDefault);
    (0, $eUqFw.useLayoutEffect)(()=>{
        const element = document?.querySelector('#parent-field-label') || null;
        setLeftPosition(element?.offsetWidth ?? $2bf9e91932e8e20c$var$parentLabelWidthDefault);
    }, [
        fieldName
    ]);
    let issueTypeId;
    if ((0, $1ybV0.ff)('jsm-gic-passes-issue-type-id-rather-than-request-type-value_hhksq') && selectedIssueType) issueTypeId = selectedIssueType.type === (0, $8b8bfa076f313cc4$export$92ab80c1dc9baf44) ? selectedIssueType.issueTypeId : selectedIssueType.value;
    const selectedIssueTypeId = selectedIssueType ? selectedIssueType.value : undefined;
    /**
	 * When creating a sub-task from the GIC modal, we:
	 * - pre-populate the parent field in "src/packages/issue-navigator/issue-operations/meatball-menu/src/ui/dropdown-menu-group/button-item/index"
	 * - disable the parent field to prevent the user to change it
	 *
	 * This prevents the user to make a mistake or bump into potential edge cases.
	 */ const isDisabled = props.isSubTaskCreationOpen || isReadOnly;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, (0, $1ybV0.ff)('parent-field-changeboarding_4ljdy') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d9Uys.Changeboarding), {
        leftPosition: leftPosition
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ctBfd.ParentFieldEdit), {
        fieldId: fieldId,
        value: value,
        onChange: onChange,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isExistingIssue: isExistingIssue,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        selectedProjectId: selectedProject ? selectedProject.value : undefined,
        selectedIssueTypeId: (0, $1ybV0.ff)('jsm-gic-passes-issue-type-id-rather-than-request-type-value_hhksq') ? issueTypeId : selectedIssueTypeId,
        fetchSuggestionsOnFocus: true,
        passedInIssueKey: (0, $1ybV0.ff)('render-modern-issue-transition_cxt0z') || (0, $dfBCt.isFedRamp)() ? issueKey : undefined,
        spacing: "default"
    }));
};
var $2bf9e91932e8e20c$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    transformDefaultValue: (0, $897qz.transformDefaultParentValue),
    validator: (0, $897qz.validateParentField)
})(// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<ParentFieldConfig, LegacyValue<Option>>, any>'.
$2bf9e91932e8e20c$export$96c87c0afbe06b37);

});
parcelRegister("d9Uys", function(module, exports) {

$parcel$export(module.exports, "Changeboarding", () => $2b58ec9c229c5623$export$d7cfba75deb33e5);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $ffiyv = parcelRequire("ffiyv");

var $hJJD2 = parcelRequire("hJJD2");
var $aOINP = parcelRequire("aOINP");
var $ltfxy = parcelRequire("ltfxy");
var $7zpSo = parcelRequire("7zpSo");

var $3MV1G = parcelRequire("3MV1G");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $lcnyw = parcelRequire("lcnyw");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $kJlBc = parcelRequire("kJlBc");

var $dxcfv = parcelRequire("dxcfv");

var $1rtMV = parcelRequire("1rtMV");

var $d8va8 = parcelRequire("d8va8");

var $aZZKa = parcelRequire("aZZKa");

var $eGo1D = parcelRequire("eGo1D");
const $2b58ec9c229c5623$var$PARENT_CHANGEBOARDING_UI_EVENT = 'parentFieldChangeboarding';
const $2b58ec9c229c5623$export$8f7c37cb3352ceb8 = 'https://community.atlassian.com/t5/Jira-Software-articles/Introducing-the-new-Parent-field-in-company-managed-projects/ba-p/2377758';
const $2b58ec9c229c5623$export$f960f87b7b043226 = 'https://support.atlassian.com/jira-cloud-administration/docs/what-are-issue-types/#What-are-parent-and-child-issues';
const $2b58ec9c229c5623$export$d7cfba75deb33e5 = (props)=>{
    const { leftPosition: leftPosition } = props; // setting the default to true to avoid new/seen flicker in the long run.
    const [changeboardingDismissed, setChangeboardingDismissed] = (0, $eUqFw.useState)(true);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const [isSpotlightActive, setIsSpotlightActive] = (0, $eUqFw.useState)(false);
    const accountId = (0, $dxcfv.useAccountId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        if (accountId != null) (0, $eGo1D.getUserProperty)(accountId).then((hasDismissed)=>setChangeboardingDismissed(hasDismissed));
    }, [
        accountId
    ]);
    const onClickNewLozenge = (0, $eUqFw.useCallback)(()=>{
        setIsSpotlightActive(true);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'lozenge'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, $2b58ec9c229c5623$var$PARENT_CHANGEBOARDING_UI_EVENT);
    }, [
        setIsSpotlightActive,
        createAnalyticsEvent
    ]);
    const onClickInfo = (0, $eUqFw.useCallback)(()=>{
        setIsOpen(!isOpen);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'infoButton'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, $2b58ec9c229c5623$var$PARENT_CHANGEBOARDING_UI_EVENT);
    }, [
        isOpen,
        setIsOpen,
        createAnalyticsEvent
    ]);
    const onInfolinkClicked = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'learnMoreLink'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, $2b58ec9c229c5623$var$PARENT_CHANGEBOARDING_UI_EVENT);
    }, [
        createAnalyticsEvent
    ]);
    const onDismiss = (0, $eUqFw.useCallback)(()=>{
        if (accountId != null) {
            setChangeboardingDismissed(true);
            (0, $eGo1D.setUserProperty)(accountId);
        }
    }, [
        setChangeboardingDismissed,
        accountId
    ]);
    const newLearnMore = (0, $eUqFw.useCallback)(()=>{
        setIsSpotlightActive(false);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'newLearnMoreLink'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, $2b58ec9c229c5623$var$PARENT_CHANGEBOARDING_UI_EVENT);
        onDismiss();
    }, [
        setIsSpotlightActive,
        onDismiss,
        createAnalyticsEvent
    ]);
    const newDismiss = (0, $eUqFw.useCallback)(()=>{
        setIsSpotlightActive(false);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'okButton'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, $2b58ec9c229c5623$var$PARENT_CHANGEBOARDING_UI_EVENT);
        onDismiss();
    }, [
        setIsSpotlightActive,
        onDismiss,
        createAnalyticsEvent
    ]);
    return changeboardingDismissed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        shouldRenderToParent: true,
        placement: "right",
        zIndex: (0, $lcnyw.layers).tooltip(),
        content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: $2b58ec9c229c5623$var$popupContentStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $aZZKa.default).infoMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kJlBc.Link), {
                ref: setInitialFocusRef,
                target: "_blank",
                href: $2b58ec9c229c5623$export$f960f87b7b043226,
                onClick: ()=>onInfolinkClicked()
            }, formatMessage((0, $aZZKa.default).infoLearnMore)))),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
                xcss: [
                    leftPosition ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                    (0, $1ZAYh.xcss)({
                        position: 'absolute',
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                        left: `${leftPosition}px`,
                        top: '3px'
                    }) : undefined,
                    $2b58ec9c229c5623$var$infoButtonContainerStyles
                ]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...triggerProps,
                appearance: "subtle-link",
                "data-ds--inline-message--button": true,
                spacing: "none",
                isSelected: isOpen,
                onClick: ()=>onClickInfo(),
                "aria-label": formatMessage((0, $aZZKa.default).spotligthLearnMore)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d8va8.default), null)))
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOINP.default), {
        blanketIsTinted: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ltfxy.default), {
        name: "parent-field-new"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: [
            leftPosition ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $1ZAYh.xcss)({
                position: 'absolute',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                left: `${leftPosition}px`,
                top: '3px'
            }) : undefined,
            $2b58ec9c229c5623$var$newButtonContainerStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        spacing: "none",
        appearance: "subtle-link",
        onClick: ()=>onClickNewLozenge()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: "new" // @ts-expect-error Property 'css' does not exist on type 'IntrinsicAttributes & LozengeProps'.ts(2322)
        ,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        className: (0, $7JEyt.default)([
            "_vwz4gktf"
        ])
    }, formatMessage((0, $aZZKa.default).newLabel))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7zpSo.default), null, isSpotlightActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hJJD2.default), {
        pulse: false,
        dialogPlacement: "right middle",
        dialogWidth: 350,
        image: (0, (/*@__PURE__*/$parcel$interopDefault($1rtMV))),
        actions: [
            {
                onClick: ()=>newDismiss(),
                text: formatMessage((0, $aZZKa.default).ok)
            },
            {
                onClick: ()=>newLearnMore(),
                text: formatMessage((0, $aZZKa.default).spotligthLearnMore),
                href: $2b58ec9c229c5623$export$8f7c37cb3352ceb8,
                target: '_blank',
                appearance: 'subtle'
            }
        ],
        heading: "",
        target: "parent-field-new",
        key: "parent-field-new",
        targetRadius: 3
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $aZZKa.default).spotlightMessage,
        values: {
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, chunks)
        }
    })))));
};
const $2b58ec9c229c5623$var$infoButtonContainerStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.050',
    marginTop: 'space.negative.025',
    display: 'inline-block'
});
const $2b58ec9c229c5623$var$newButtonLozengeStyles = null;
const $2b58ec9c229c5623$var$newButtonContainerStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.negative.050',
    marginBottom: 'space.negative.025',
    marginLeft: 'space.050',
    marginRight: '0',
    display: 'inline-block'
});
const $2b58ec9c229c5623$var$popupContentStyles = (0, $1ZAYh.xcss)({
    paddingTop: 'space.200',
    paddingBottom: 'space.200',
    paddingLeft: 'space.250',
    paddingRight: 'space.250',
    width: '300px'
});

});
parcelRegister("1rtMV", function(module, exports) {
module.exports = new URL("hieararchy-animation.763a6bfd.gif", import.meta.url).toString();

});

parcelRegister("d8va8", function(module, exports) {

$parcel$export(module.exports, "default", () => $8924d5c8fdd85c41$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $8924d5c8fdd85c41$var$InfoIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "issue-field-parent.ui.changeboarding.assets.icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12ZM6 10.6667C8.57733 10.6667 10.6667 8.57733 10.6667 6C10.6667 3.42267 8.57733 1.33333 6 1.33333C3.42267 1.33333 1.33333 3.42267 1.33333 6C1.33333 8.57733 3.42267 10.6667 6 10.6667ZM6 9.33333C5.65811 9.33333 5.37633 9.07597 5.33782 8.74441L5.33333 8.66667V6C5.33333 5.63181 5.63181 5.33333 6 5.33333C6.34189 5.33333 6.62367 5.59069 6.66218 5.92225L6.66667 6V8.66667C6.66667 9.03486 6.36819 9.33333 6 9.33333Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M6 2.66667C5.53976 2.66667 5.16667 3.03976 5.16667 3.5C5.16667 3.96024 5.53976 4.33333 6 4.33333C6.46024 4.33333 6.83333 3.96024 6.83333 3.5C6.83333 3.03976 6.46024 2.66667 6 2.66667Z",
        fill: "currentColor"
    }));
var $8924d5c8fdd85c41$export$2e2bcd8739ae039 = $8924d5c8fdd85c41$var$InfoIcon;

});

parcelRegister("aZZKa", function(module, exports) {

$parcel$export(module.exports, "default", () => $592fafeca2c728e3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $592fafeca2c728e3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    newLabel: {
        "id": "issue-field-parent.changeboarding.new-label",
        "defaultMessage": "New"
    },
    icon: {
        "id": "issue-field-parent.changeboarding.icon",
        "defaultMessage": "{issueType} icon"
    },
    spotlightMessage: {
        "id": "issue-field-parent.changeboarding.spotlight-message",
        "defaultMessage": "The <strong>Parent</strong> field has replaced <strong>Epic Link</strong> and <strong>Parent Link</strong>. It works in the same way."
    },
    spotligthLearnMore: {
        "id": "issue-field-parent.changeboarding.spotligth-learn-more",
        "defaultMessage": "Information on the parent field"
    },
    infoMessage: {
        "id": "issue-field-parent.changeboarding.info-message",
        "defaultMessage": "Your issue type hierarchy determines the issues you can select here."
    },
    infoLearnMore: {
        "id": "issue-field-parent.changeboarding.info-learn-more",
        "defaultMessage": "Learn more about parent issues"
    },
    ok: {
        "id": "issue-field-parent.changeboarding.ok",
        "defaultMessage": "OK"
    },
    parentFieldInfoTitle: {
        "id": "issue-field-parent.changeboarding.parent-field-info-title",
        "defaultMessage": "Parent field information"
    }
});

});

parcelRegister("eGo1D", function(module, exports) {

$parcel$export(module.exports, "setUserProperty", () => $8276a70a04cf6ae6$export$ba821ce5e177c7ef);
$parcel$export(module.exports, "getUserProperty", () => $8276a70a04cf6ae6$export$b3126db2ef6e34ed);

var $lRmyA = parcelRequire("lRmyA");
const $8276a70a04cf6ae6$export$bb10a02fc2feb574 = 'jira.user.parent-field.changeboarding';
const $8276a70a04cf6ae6$var$getUserUrl = (accountId)=>`/rest/api/3/user/properties/${$8276a70a04cf6ae6$export$bb10a02fc2feb574}?accountId=${accountId}`;
const $8276a70a04cf6ae6$export$ba821ce5e177c7ef = async (accountId)=>{
    const url = $8276a70a04cf6ae6$var$getUserUrl(accountId);
    const response = await (0, $lRmyA.performPutRequest)(url, {
        body: JSON.stringify(true)
    });
    if (response && !response.ok) throw Error('Failed to dismiss changeboarding spotlight for Parent field');
};
const $8276a70a04cf6ae6$export$b3126db2ef6e34ed = async (accountId)=>{
    const url = $8276a70a04cf6ae6$var$getUserUrl(accountId);
    const response = await fetch(url);
    // ok is true only when status code is 2xx.
    if (response.ok) {
        const responseObj = await response.json();
        return responseObj.value;
    }
    const { status: status } = response;
    // 404: API deliberately returns 404 if user property is not found, which implies the user has not dismissed the spotlight.
    if (status === 404) return false;
    // returning the default value (dismissed) regardless of endpoint errors.
    return true;
};

});


parcelRegister("ctBfd", function(module, exports) {

$parcel$export(module.exports, "ParentFieldEdit", () => $16b7cfe9b86e2ec5$export$55c2cccecfd24751);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $5wCDk = parcelRequire("5wCDk");

var $8cU5f = parcelRequire("8cU5f");

var $1ybV0 = parcelRequire("1ybV0");

var $eI5EY = parcelRequire("eI5EY");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $4NcaX = parcelRequire("4NcaX");
var $g6sIQ = parcelRequire("g6sIQ");

var $dWLk9 = parcelRequire("dWLk9");

var $3K8W2 = parcelRequire("3K8W2");

var $gFHZL = parcelRequire("gFHZL");

var $4RHil = parcelRequire("4RHil");

var $1h91k = parcelRequire("1h91k");

var $lNJbX = parcelRequire("lNJbX");
const $16b7cfe9b86e2ec5$var$LOAD_OPTIONS_DEBOUNCE_TIMER = 300;
const $16b7cfe9b86e2ec5$export$55c2cccecfd24751 = (props)=>{
    const { onFocus: onFocus, onBlur: onBlur, value: value = null, onChange: onChange, selectedProjectId: selectedProjectId, selectedIssueTypeId: selectedIssueTypeId, isInvalid: isInvalid = false, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, isDisabled: isDisabled = false, isExistingIssue: isExistingIssue = false, defaultMenuIsOpen: defaultMenuIsOpen = false, isEditing: isEditing, classNamePrefix: classNamePrefix, isClearable: isClearable = true, passedInIssueKey: passedInIssueKey, fieldId: // used for experiences that don't have issueKey in context, eg. bulk edit
    fieldId, spacing: spacingProps = 'compact' } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [suggestions, setSuggestions] = (0, $eUqFw.useState)();
    const [defaultSuggestions, setDefaultSuggestions] = (0, $eUqFw.useState)();
    const [noOptionsMessage, setNoOptionsMessage] = (0, $eUqFw.useState)('');
    const [hasLastFetchFailed, setHasLastFetchFailed] = (0, $eUqFw.useState)(false);
    const [excludeDone, setExcludeDone] = (0, $eUqFw.useState)(true);
    const isInitialMount = (0, $eUqFw.useRef)(true);
    const lastQuery = (0, $eUqFw.useRef)('');
    const cloudId = (0, $dWLk9.useCloudId)();
    const issueKey = (0, $hJ992.useIssueKey)();
    const onCheckboxClick = (0, $eUqFw.useCallback)(()=>{
        setExcludeDone(!excludeDone);
    }, [
        excludeDone
    ]);
    const componentProps = (0, $eUqFw.useMemo)(()=>({
            isChecked: !excludeDone,
            onChange: onCheckboxClick
        }), [
        excludeDone,
        onCheckboxClick
    ]);
    const formatOptionLabel = (0, $eUqFw.useCallback)((option, { context: context })=>{
        if (context === 'menu') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: option.label
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1h91k.default), {
            option: option
        }));
        const label = (0, $1ybV0.ff)('jsm-request-type-layout-supports-parent-field_jiq2s') ? option.label || `${option.key} ${option.fields.summary}` : `${option.key} ${option.fields.summary}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, label);
    }, []);
    const searchParents = (0, $eUqFw.useCallback)(async (query = '')=>{
        setHasLastFetchFailed(false);
        try {
            lastQuery.current = query;
            if (isExistingIssue) {
                const fetchedOptions = await (0, $lNJbX.fetchParentsForExisting)({
                    searchTerm: query,
                    issueKey: passedInIssueKey || issueKey,
                    cloudId: cloudId,
                    excludeDone: excludeDone
                });
                return fetchedOptions;
            }
            if (selectedProjectId && selectedIssueTypeId) {
                const fetchedOptions = await (0, $lNJbX.fetchParentsForNew)({
                    searchTerm: query,
                    selectedProjectId: selectedProjectId,
                    selectedIssueTypeId: selectedIssueTypeId,
                    cloudId: cloudId,
                    excludeDone: excludeDone
                });
                return fetchedOptions;
            }
            setHasLastFetchFailed(true);
            return {
                options: []
            };
        } catch  {
            setHasLastFetchFailed(true);
            return {
                options: []
            };
        }
    }, [
        isExistingIssue,
        issueKey,
        cloudId,
        excludeDone,
        selectedProjectId,
        selectedIssueTypeId,
        passedInIssueKey
    ]);
    const requestSuggestions = (0, $eUqFw.useCallback)(async (query = '')=>{
        const response = await searchParents(query);
        if (lastQuery.current === query) {
            if (response.options !== undefined) {
                setSuggestions(response.options);
                if (response.options.length === 0 && response.message) setNoOptionsMessage(response.message);
                if (query === '') setDefaultSuggestions(response.options);
            } else {
                setSuggestions([]);
                if (query === '') setDefaultSuggestions([]);
            }
            setIsLoading(false);
        }
    }, [
        searchParents
    ]);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedRequestSuggestions = (0, $eUqFw.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(requestSuggestions, $16b7cfe9b86e2ec5$var$LOAD_OPTIONS_DEBOUNCE_TIMER), [
        excludeDone
    ]);
    const onQueryChange = (0, $eUqFw.useCallback)((query)=>{
        debouncedRequestSuggestions.cancel();
        setHasLastFetchFailed(false);
        if (query) {
            lastQuery.current = query;
            setIsLoading(true);
            debouncedRequestSuggestions(query);
        } else {
            lastQuery.current = '';
            setIsLoading(false);
            setSuggestions(defaultSuggestions);
        }
    }, [
        debouncedRequestSuggestions,
        defaultSuggestions
    ]);
    const handleFocus = (0, $eUqFw.useCallback)((e)=>{
        if (lastQuery.current === '' && !defaultSuggestions) {
            setIsLoading(true);
            requestSuggestions();
        }
        onFocus && onFocus(e);
    }, [
        defaultSuggestions,
        onFocus,
        requestSuggestions
    ]);
    const filterOption = (0, $eUqFw.useCallback)((option)=>{
        if (hasLastFetchFailed) // If the fetch has failed, we will show a disabled option to indicate the error to users
        return true;
        return (0, $g6sIQ.filterOptionByLabelAndFilterValues)(option, lastQuery.current || '');
    }, [
        hasLastFetchFailed
    ]);
    const getNoOptionsMessage = (0, $eUqFw.useCallback)(()=>{
        const noOptions = noOptionsMessage !== '' ? noOptionsMessage : formatMessage((0, $4RHil.default).noMatches);
        // we now get the translated message from the backend, but will fall back to the old message if it's not there
        return hasLastFetchFailed ? formatMessage((0, $4RHil.default).failedFetch) : noOptions;
    }, [
        formatMessage,
        hasLastFetchFailed,
        noOptionsMessage
    ]);
    const getLoadingMessage = (0, $eUqFw.useCallback)(()=>formatMessage((0, $4RHil.default).loading), [
        formatMessage
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isInitialMount.current) {
            setIsLoading(true);
            requestSuggestions(lastQuery.current);
        }
        isInitialMount.current = false;
    }, [
        excludeDone,
        requestSuggestions
    ]);
    const spacing = (0, $eUqFw.useMemo)(()=>(0, $eI5EY.fg)('jira_-_list_-_add_onclick_handler_to_parentview') ? spacingProps : 'compact', [
        spacingProps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
        // need to stop esc keydown propagation to avoid modal close if select is open
        onKeyDown: (0, $3K8W2.preventEscKeyPropagationKeyPressHandler),
        inputId: `${fieldId}-field`,
        options: suggestions,
        value: value,
        formatOptionLabel: formatOptionLabel,
        onBlur: onBlur,
        onFocus: handleFocus,
        onChange: onChange,
        menuPosition: isDropdownMenuFixedAndLayered ? 'fixed' : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        styles: (0, $4NcaX.defaultSelectStyles),
        closeMenuOnScroll: onCloseMenuOnScroll,
        isMulti: false,
        isLoading: isLoading,
        onInputChange: onQueryChange,
        loadingMessage: getLoadingMessage,
        noOptionsMessage: getNoOptionsMessage,
        placeholder: formatMessage((0, $4RHil.default).placeholder),
        components: {
            Menu: $gFHZL.default
        },
        componentsProps: componentProps,
        autoFocus: autoFocus,
        filterOption: filterOption,
        validationState: isInvalid === true ? 'error' : undefined,
        hideSelectedOptions: true,
        isClearable: isClearable,
        ...isEditing !== undefined && {
            menuIsOpen: isEditing
        },
        isDisabled: isDisabled,
        defaultMenuIsOpen: defaultMenuIsOpen,
        classNamePrefix: classNamePrefix,
        spacing: spacing
    });
};

});
parcelRegister("3K8W2", function(module, exports) {

$parcel$export(module.exports, "getOptionColorElem", () => $95b0c6b6b9af6b91$export$b00899e73680c477);
$parcel$export(module.exports, "mapDataToOptions", () => $95b0c6b6b9af6b91$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionToData", () => $95b0c6b6b9af6b91$export$fc800909123977f3);
$parcel$export(module.exports, "preventEscKeyPropagationKeyPressHandler", () => $95b0c6b6b9af6b91$export$feb08457bf70a411);
$parcel$export(module.exports, "getLozengeThemeByColor", () => $95b0c6b6b9af6b91$export$949dc67535a8ff2);
/* utils.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $1ybV0 = parcelRequire("1ybV0");

var $tgbCK = parcelRequire("tgbCK");
var $lPQPn = parcelRequire("lPQPn");
const $95b0c6b6b9af6b91$export$bc913b9c9057634d = (color)=>color === undefined || color === '' ? 'transparent' : (0, $tgbCK.MAP_COLORS_TO_VALUE)[color];
const $95b0c6b6b9af6b91$export$b00899e73680c477 = (color)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($95b0c6b6b9af6b91$var$ColorPatch, {
        color: color,
        "data-testid": `issue-field-parent.common.color-patch-${color}`
    });
const $95b0c6b6b9af6b91$export$99a866ffa3af7d8b = (issueParents)=>{
    const transformedResponse = (0, $1ybV0.ff)('request-isdone-when-requesting-parent-candidates-and-display-in-parent-field_3becy') ? issueParents.map(({ id: id, issueType: issueType, key: key, summary: summary, color: color, isDone: isDone })=>({
            id: id,
            key: key,
            fields: {
                issuetype: issueType,
                summary: summary
            },
            color: color,
            value: id,
            label: `${key} ${summary}`,
            isDone: isDone
        })) : issueParents.map(({ id: id, issueType: issueType, key: key, summary: summary, color: color })=>({
            id: id,
            key: key,
            fields: {
                issuetype: issueType,
                summary: summary
            },
            color: color,
            value: id,
            label: `${key} ${summary}`
        }));
    return transformedResponse;
};
const $95b0c6b6b9af6b91$export$fc800909123977f3 = (option)=>({
        id: option.value
    });
const $95b0c6b6b9af6b91$export$9b822862d986dfdf = (0, $lPQPn.transformColorToTheme)((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $95b0c6b6b9af6b91$export$feb08457bf70a411 = (event)=>{
    if (event?.key === 'Escape') event?.nativeEvent?.stopImmediatePropagation();
};
const $95b0c6b6b9af6b91$export$949dc67535a8ff2 = (color)=>$95b0c6b6b9af6b91$export$9b822862d986dfdf[color];
// We adjust the size of the color patch away from normal grid sizes because
// the issue type icon actually has a 1px border on each side, which is 2x1px on width/height
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $95b0c6b6b9af6b91$var$ColorPatch = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1nzbko4": (0, $9t7rW.default)($95b0c6b6b9af6b91$export$bc913b9c9057634d(__cmplp.color))
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbdlk8 _1ul9dlk8 _4t3idlk8 _2rko1y44 _bfhk1vzt",
            __cmplp.className
        ])
    });
});

});

parcelRegister("gFHZL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddeadf926ee0a27e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bT7k5 = parcelRequire("bT7k5");

var $jQxSL = parcelRequire("jQxSL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $2iqfg = parcelRequire("2iqfg");
const $ddeadf926ee0a27e$var$Menu = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { children: children, ...restProps } = props;
    const isChecked = props.selectProps?.componentsProps?.isChecked || false;
    const label = formatMessage((0, $2iqfg.default).checkboxLabel);
    const onKeyDown = (0, $eUqFw.useCallback)((event)=>{
        // stopping propagation when focus moves to checkbox because select already binded with space and enter for selection
        if (event.key === ' ') event.stopPropagation();
    }, []);
    /**
   * When the checkbox is clicked, we need to stop the event propagation to prevent the select from closing.
   */ const onChange = (0, $eUqFw.useCallback)((event)=>{
        // stopping propagation when checkbox is clicked to prevent select from closing
        event.stopPropagation();
        event.preventDefault();
        props.selectProps?.componentsProps?.onChange?.(event);
    }, [
        props.selectProps?.componentsProps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Menu, restProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ddeadf926ee0a27e$var$CheckboxWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
        onKeyDown: onKeyDown,
        onClick: onChange,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onChange: ()=>{},
        isChecked: isChecked,
        size: "medium",
        id: "issue-field-parent.ui.edit.menu.checkbox"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ddeadf926ee0a27e$var$CheckboxLabel, {
        onClick: onChange,
        htmlFor: "issue-field-parent.ui.edit.menu.checkbox",
        "data-testid": "issue-field-parent.ui.edit.menu.checkbox-label"
    }, label)), children);
};
var $ddeadf926ee0a27e$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $ddeadf926ee0a27e$var$Menu;
const $ddeadf926ee0a27e$var$CheckboxWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1bah1y6m _1yt4lce4 _n7zlpe8f _4cvr1h6o _zulp1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ddeadf926ee0a27e$var$CheckboxLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2iqfg", function(module, exports) {

$parcel$export(module.exports, "default", () => $527b2a926f101da8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $527b2a926f101da8$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    checkboxLabel: {
        "id": "issue-field-parent.edit.menu.checkbox-label",
        "defaultMessage": "Show done issues"
    }
});

});


parcelRegister("4RHil", function(module, exports) {

$parcel$export(module.exports, "default", () => $1453541c4aca35df$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1453541c4aca35df$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noMatches: {
        "id": "issue-field-parent.edit.no-matches",
        "defaultMessage": "No matches"
    },
    failedFetch: {
        "id": "issue-field-parent.edit.failed-fetch",
        "defaultMessage": "Search failed. Please try again."
    },
    placeholder: {
        "id": "issue-field-parent.edit.placeholder",
        "defaultMessage": "Select parent"
    },
    loading: {
        "id": "issue-field-parent.edit.loading",
        "defaultMessage": "Searching..."
    }
});

});

parcelRegister("1h91k", function(module, exports) {

$parcel$export(module.exports, "default", () => $3459ab43a3b207bd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $k9Z3M = parcelRequire("k9Z3M");

var $PdmhA = parcelRequire("PdmhA");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3K8W2 = parcelRequire("3K8W2");

var $gDuhX = parcelRequire("gDuhX");

var $eNV5F = parcelRequire("eNV5F");
const $3459ab43a3b207bd$var$renderOptionDescription = (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3459ab43a3b207bd$var$OptionDescriptionWrapper, null, option.description != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNV5F.Description), null, option.description) : null);
const $3459ab43a3b207bd$var$renderIconsKeyAndDoneLabel = (option, doneParentLabel, iconAltMessage)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3459ab43a3b207bd$var$OptionColorTypeKeyWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3459ab43a3b207bd$var$IconColorKeyWrapper, null, option?.color ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (0, $3K8W2.getOptionColorElem)(option?.color), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3459ab43a3b207bd$var$IconWithColor, {
        src: option.fields?.issuetype.iconUrl,
        alt: iconAltMessage
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3459ab43a3b207bd$var$Icon, {
        src: option.fields?.issuetype.iconUrl,
        alt: iconAltMessage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3459ab43a3b207bd$var$IssueKey, null, option.key)), option.isDone ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3459ab43a3b207bd$var$DoneWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k9Z3M))), {
        primaryColor: `var(--ds-text-success, ${(0, $PdmhA).G500})`,
        label: "done-parent-issue"
    }), doneParentLabel) : null);
const $3459ab43a3b207bd$var$CustomOption = ({ option: option })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)(); // narrowing type to ParentFieldOption
    if ('fields' in option) {
        const fields = option?.fields;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNV5F.OptionWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNV5F.OptionTextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNV5F.OptionLabel), null, $3459ab43a3b207bd$var$renderIconsKeyAndDoneLabel(option, formatMessage((0, $gDuhX.default).doneParentLabel), formatMessage((0, $gDuhX.default).icon, {
            issueType: fields?.issuetype.name || ''
        })), option.fields.summary)));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNV5F.OptionWrapper), null, option.elemBefore != null ? option.elemBefore : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNV5F.OptionTextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eNV5F.OptionLabel), null, option.label), $3459ab43a3b207bd$var$renderOptionDescription(option)));
};
var $3459ab43a3b207bd$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $3459ab43a3b207bd$var$CustomOption;
const $3459ab43a3b207bd$var$IconWithColor = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u0u2gc _p12f7vkz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3459ab43a3b207bd$var$Icon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f7vkz",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3459ab43a3b207bd$var$IconColorKeyWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _syaz1a45",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3459ab43a3b207bd$var$DoneWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _syaz1rc1",
            __cmplp.className
        ])
    });
});
const $3459ab43a3b207bd$var$IssueKey = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bto1l2s _p12f1osq _18u0u2gc",
            __cmplp.className
        ])
    });
});
const $3459ab43a3b207bd$var$OptionColorTypeKeyWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4 _2lx2vrvc _4cvr1h6o _syaz1rc1 _1wyb1crf _otyr1b66",
            __cmplp.className
        ])
    });
});
const $3459ab43a3b207bd$var$OptionDescriptionWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o _1wyb1crf _19pk1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gDuhX", function(module, exports) {

$parcel$export(module.exports, "default", () => $de48ca9994a523f3$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $de48ca9994a523f3$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    icon: {
        "id": "issue-field-parent.edit.option.icon",
        "defaultMessage": "{issueType} icon"
    },
    doneParentLabel: {
        "id": "issue-field-parent.edit.option.done-parent-label",
        "defaultMessage": "Done"
    }
});

});

parcelRegister("eNV5F", function(module, exports) {

$parcel$export(module.exports, "OptionWrapper", () => $8880269126d01244$export$d6f6a072cce04542);
$parcel$export(module.exports, "OptionTextContainer", () => $8880269126d01244$export$c6c33847de6c74ef);
$parcel$export(module.exports, "Description", () => $8880269126d01244$export$393edc798c47379d);
$parcel$export(module.exports, "OptionLabel", () => $8880269126d01244$export$2cf7ef1e2dd6c6b1);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $8880269126d01244$export$d6f6a072cce04542 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $8880269126d01244$export$c6c33847de6c74ef = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _18s8h8dc _1yt4x7n9 _1reo15vq _18m915vq _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $8880269126d01244$export$393edc798c47379d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bto1l2s _p12f1osq",
            __cmplp.className
        ])
    });
});
const $8880269126d01244$export$2cf7ef1e2dd6c6b1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bto1l2s _1reo15vq _18m915vq _o5721q9c _16jlkb7n",
            __cmplp.className
        ])
    });
});

});


parcelRegister("lNJbX", function(module, exports) {

$parcel$export(module.exports, "fetchParentsForNew", () => $a94fa604b4d453e4$export$73bed6a0175e413);
$parcel$export(module.exports, "fetchParentsForExisting", () => $a94fa604b4d453e4$export$f995718992ca6c2f);

var $guiFP = parcelRequire("guiFP");

var $ksJPv = parcelRequire("ksJPv");
var $ijrxj = parcelRequire("ijrxj");

var $3K8W2 = parcelRequire("3K8W2");
const $a94fa604b4d453e4$export$cfeee2ee86ead336 = 'bento';
const $a94fa604b4d453e4$export$73bed6a0175e413 = async (props)=>{
    const { searchTerm: searchTerm, selectedProjectId: selectedProjectId, selectedIssueTypeId: selectedIssueTypeId, cloudId: cloudId, excludeDone: excludeDone } = props;
    // This is a gira request
    try {
        const response = await (0, $ijrxj.fetchParentCandidatesForNewIssue)(cloudId, selectedProjectId, selectedIssueTypeId, searchTerm, excludeDone);
        return {
            options: (0, $3K8W2.mapDataToOptions)(response.candidates),
            message: response.message
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'fetchParentsForNew',
                packageName: 'jiraIssueFieldParent',
                teamName: $a94fa604b4d453e4$export$cfeee2ee86ead336
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw new Error(error);
    }
};
const $a94fa604b4d453e4$export$f995718992ca6c2f = async (props)=>{
    const { searchTerm: searchTerm, issueKey: issueKey, cloudId: cloudId, excludeDone: excludeDone } = props;
    // This is a gira request
    try {
        const response = await (0, $ksJPv.fetchParentCandidatesForExistingIssue)(cloudId, issueKey, searchTerm, excludeDone);
        return {
            options: (0, $3K8W2.mapDataToOptions)(response.candidates),
            message: response.message
        };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'fetchParentsForExisting',
                packageName: 'jiraIssueFieldParent',
                teamName: $a94fa604b4d453e4$export$cfeee2ee86ead336
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});
parcelRegister("ksJPv", function(module, exports) {

$parcel$export(module.exports, "fetchParentCandidatesForExistingIssue", () => $30bdd1b75406f614$export$59a0f41a1d5dcee0);


var $7EhAs = parcelRequire("7EhAs");

var $4NW4H = parcelRequire("4NW4H");

var $gSE5U = parcelRequire("gSE5U");

var $gbHOB = parcelRequire("gbHOB");

var $hKxcm = parcelRequire("hKxcm");
const $30bdd1b75406f614$export$59a0f41a1d5dcee0 = async (cloudId, issueKey, searchTerm, excludeDone)=>{
    const response = (0, $4NW4H.default)(cloudId, issueKey, searchTerm, excludeDone);
    const { data: data, errors: errors } = await response;
    if (!data || errors) {
        const message = errors ? JSON.stringify(errors) : 'No data returned from graphql call';
        throw new (0, $gbHOB.default)(new Error(message), (0, $gSE5U.PARENT_CANDIDATES_FOR_EXISTING_ISSUES_QUERY_WITH_INFO));
    }
    if (data.jira.parentCandidatesWithInfoForExistingIssue !== undefined && !data.jira?.parentCandidatesWithInfoForExistingIssue) {
        // @ts-expect-error - TS2339 - Property 'length' does not exist on type 'never'.
        if (Array.isArray(errors) && errors.length > 0) {
            const errorMessage = JSON.stringify(errors);
            // if `parentCandidatesForExistingIssue` is missing and any errors were in the response
            // assume that an error caused the data to be missing.
            throw new (0, $gbHOB.default)(new (0, $7EhAs.default)((0, $1c3fbb431a173cc6$export$e813cd7045fcc98d), `Call to gira for parent candidates returned with errors: ${errorMessage}`), (0, $gSE5U.PARENT_CANDIDATES_FOR_EXISTING_ISSUES_QUERY_WITH_INFO));
        } else // GraphQL doesn't rely on HTTP status codes to classify errors.
        // But we do have code that knows how to handle 404s (display "Issue not found"
        // screen, etc.), so that's why we're forcing a 404 here.
        throw new (0, $gbHOB.default)(new (0, $7EhAs.default)((0, $1c3fbb431a173cc6$export$8bca792d963eb0ef), 'Call to gira for parent candidates returned empty response'), (0, $gSE5U.PARENT_CANDIDATES_FOR_EXISTING_ISSUES_QUERY_WITH_INFO));
    }
    const candidates = data.jira.parentCandidatesWithInfoForExistingIssue !== undefined ? (0, $hKxcm.transformData)(data.jira.parentCandidatesWithInfoForExistingIssue.parentCandidates.edges) : [];
    return {
        candidates: candidates,
        message: data.jira.parentCandidatesWithInfoForExistingIssue !== undefined ? data.jira.parentCandidatesWithInfoForExistingIssue.message : undefined
    };
};

});
parcelRegister("4NW4H", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b4ab2a034cf0653$export$2e2bcd8739ae039);

var $gSE5U = parcelRequire("gSE5U");

var $kXzsJ = parcelRequire("kXzsJ");
const $5b4ab2a034cf0653$export$83bff8b82e36a9e9 = 20;
var /**
 * Returns parent candidates for an existing issue
 *
 * @param cloudId - The cloud ID of the instance
 * @param issueKey - The key of the issue to find parents for e.g SCRUM-1000
 * @param searchTerm - A search string for the parent, on either full key match or partial summary match
 * @param excludeDone - Whether to exclude done issues from the list of parent candidate results
 * @returns A list of possible parent issues for the specified issue
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$5b4ab2a034cf0653$export$2e2bcd8739ae039 = async (cloudId, issueKey, searchTerm, excludeDone)=>{
    const variables = {
        cloudId: cloudId,
        issueKey: issueKey,
        searchTerm: searchTerm,
        excludeDone: excludeDone,
        first: $5b4ab2a034cf0653$export$83bff8b82e36a9e9
    };
    const response = await (0, $kXzsJ.getClient)('').query({
        query: (0, $gSE5U.buildParentCandidatesForExistingIssueQuery)(),
        variables: variables
    });
    return response;
};

});
parcelRegister("gSE5U", function(module, exports) {

$parcel$export(module.exports, "PARENT_CANDIDATES_FOR_EXISTING_ISSUES_QUERY_WITH_INFO", () => $e9da6eadea09a233$export$c7c7f21787854c5b);
$parcel$export(module.exports, "buildParentCandidatesForExistingIssueQuery", () => $e9da6eadea09a233$export$b64c34b6ba3d6bf5);

var $8OLx5 = parcelRequire("8OLx5");
const $e9da6eadea09a233$export$c7c7f21787854c5b = 'issueParentCandidatesForExistingIssuesQueryWithInfo';
const $e9da6eadea09a233$export$b64c34b6ba3d6bf5 = ()=>`
    query jira_parenting_${$e9da6eadea09a233$export$c7c7f21787854c5b}($issueKey: String!, $cloudId: ID!, $searchTerm: String, $excludeDone: Boolean, $first: Int)  {
        ${(0, $8OLx5.parentCandidatesForExistingIssueQuery)()}
    }
`;

});
parcelRegister("8OLx5", function(module, exports) {

$parcel$export(module.exports, "parentCandidatesForExistingIssueQuery", () => $3bad3c743a64005c$export$f63a6e3151b9dd82);

var $bKxX9 = parcelRequire("bKxX9");
const $3bad3c743a64005c$var$issueType = ()=>`
    ... on JiraIssueTypeField {
        fieldId
        issueType {
            issueTypeId
            name
            avatar {
                xsmall
            }
        }
    }
`;
const $3bad3c743a64005c$var$summary = ()=>`
    ... on JiraSingleLineTextField {
        fieldId
        text
    }
`;
const $3bad3c743a64005c$var$color = ()=>`
    issueColorField {
      color {
        colorKey
      }
    }
`;
const $3bad3c743a64005c$var$status = ()=>`
    ... on JiraStatusField {
      fieldId
      status {
        statusCategory{
          statusCategoryId
        }
      }
    }
`;
const $3bad3c743a64005c$var$fieldsByIdOld = ()=>`fieldsById(ids:["summary", "issuetype"]){
  edges{
    node{
      ${$3bad3c743a64005c$var$issueType()}
      ${$3bad3c743a64005c$var$summary()}
    }
  }
}`;
const $3bad3c743a64005c$var$fieldsById = ()=>`fieldsById(ids:["summary", "issuetype", "status"]){
  edges{
    node{
      ${$3bad3c743a64005c$var$issueType()}
      ${$3bad3c743a64005c$var$summary()}
      ${$3bad3c743a64005c$var$status()}
    }
  }
}`;
const $3bad3c743a64005c$export$f63a6e3151b9dd82 = ()=>`
    jira {
      parentCandidatesWithInfoForExistingIssue(key: $issueKey, cloudId: $cloudId, searchTerm: $searchTerm, excludeDone: $excludeDone, first: $first) {
        parentCandidates {
          edges {
            node {
              issueId
              key
              ${$3bad3c743a64005c$var$color()}
              ${(0, $bKxX9.ff)('request-isdone-when-requesting-parent-candidates-and-display-in-parent-field_3becy') ? $3bad3c743a64005c$var$fieldsById() : $3bad3c743a64005c$var$fieldsByIdOld()}
            }
          }
        }
        message
      }
    }
`;

});



parcelRegister("gbHOB", function(module, exports) {

$parcel$export(module.exports, "default", () => $c796f884883538e4$export$2e2bcd8739ae039);

var $7byHA = parcelRequire("7byHA");
class $c796f884883538e4$export$2e2bcd8739ae039 extends Error {
    constructor(error, endpoint){
        if (error instanceof $c796f884883538e4$export$2e2bcd8739ae039) return error;
        super(error.message);
        this.error = error;
        this.message = error.message;
        if (error instanceof (0, $7byHA.default)) {
            if (error.traceId != null) this.traceId = error.traceId;
            this.statusCode = error.statusCode;
        }
        this.endpoint = endpoint;
    }
}

});

parcelRegister("hKxcm", function(module, exports) {

$parcel$export(module.exports, "transformData", () => $eafcb23fdcdaf55d$export$3ceb62baab058c6b);

var $8Qd0L = parcelRequire("8Qd0L");


var $1ybV0 = parcelRequire("1ybV0");

var $7byHA = parcelRequire("7byHA");

var $tgbCK = parcelRequire("tgbCK");
const $eafcb23fdcdaf55d$export$3ceb62baab058c6b = (edges)=>edges.map((edge)=>{
        const edgeNode = edge.node;
        const fieldsEdges = edgeNode.fieldsById.edges;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const summaryField = fieldsEdges.find((field)=>field.node.fieldId === 'summary');
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const issueTypeField = fieldsEdges.find((field)=>field.node.fieldId === 'issuetype');
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const statusField = fieldsEdges.find((field)=>field.node.fieldId === 'status');
        const colorField = edgeNode.issueColorField;
        if (summaryField === undefined) throw new (0, $7byHA.ValidationError)('Validation Error', [
            {
                field: 'summary',
                error: 'Call to gira for parent candidates returned without summary data'
            }
        ], (0, $1c3fbb431a173cc6$export$8bca792d963eb0ef));
        if (issueTypeField === undefined) throw new (0, $7byHA.ValidationError)('Validation Error', [
            {
                field: 'issueType',
                error: 'Call to gira for parent candidates returned without issue type data'
            }
        ], (0, $1c3fbb431a173cc6$export$8bca792d963eb0ef));
        if ((0, $1ybV0.ff)('request-isdone-when-requesting-parent-candidates-and-display-in-parent-field_3becy') && statusField === undefined) throw new (0, $7byHA.ValidationError)('Validation Error', [
            {
                field: 'status',
                error: 'Call to gira for parent candidates returned without status data'
            }
        ], (0, $1c3fbb431a173cc6$export$8bca792d963eb0ef));
        if (// only issues at level 1 are expected to have a hierarchy level (i.e Epics)
        issueTypeField.node.issueType?.hierarchy?.level === 1 && colorField === undefined) throw new (0, $7byHA.ValidationError)('Validation Error', [
            {
                field: 'Issue Color',
                error: 'Call to gira for parent candidates returned without color data'
            }
        ], (0, $1c3fbb431a173cc6$export$8bca792d963eb0ef));
        const summaryFieldNode = summaryField.node;
        const issueTypeFieldNode = issueTypeField.node;
        const checkParentIssueIsDone = (statusCategoryId)=>{
            const doneStatusCategoryId = (0, $8Qd0L).StatusCategoryIds[(0, $8Qd0L).StatusCategoryTypes.DONE];
            return doneStatusCategoryId && String(doneStatusCategoryId) === statusCategoryId;
        };
        const isDone = (0, $1ybV0.ff)('request-isdone-when-requesting-parent-candidates-and-display-in-parent-field_3becy') ? checkParentIssueIsDone(statusField.node.status.statusCategory.statusCategoryId) : undefined;
        const statusCategoryId = (0, $1ybV0.ff)('compal-issue-actions-parent-statuscategoryid_s2esc') ? statusField?.node.status.statusCategory.statusCategoryId : undefined;
        const parent = {
            id: edgeNode.issueId,
            key: edgeNode.key,
            summary: summaryFieldNode.text,
            issueType: {
                id: String(issueTypeFieldNode.issueType.issueTypeId),
                name: issueTypeFieldNode.issueType.name,
                iconUrl: issueTypeFieldNode.issueType.avatar.xsmall
            },
            isDone: isDone,
            statusCategoryId: statusCategoryId
        };
        // todo: write a test for issueColor undefined
        return {
            ...parent,
            color: colorField?.color?.colorKey ? (0, $tgbCK.MAP_FROM_SERVER_COLOR)[colorField.color.colorKey] : undefined
        };
    });

});


parcelRegister("ijrxj", function(module, exports) {

$parcel$export(module.exports, "fetchParentCandidatesForNewIssue", () => $5934be41627d9230$export$48a29a1313179c04);


var $7EhAs = parcelRequire("7EhAs");

var $go64Z = parcelRequire("go64Z");

var $7SU3A = parcelRequire("7SU3A");

var $gbHOB = parcelRequire("gbHOB");

var $hKxcm = parcelRequire("hKxcm");
const $5934be41627d9230$export$48a29a1313179c04 = async (cloudId, projectId, issueTypeId, searchTerm, excludeDone)=>{
    const response = (0, $go64Z.default)(cloudId, projectId, issueTypeId, searchTerm, excludeDone);
    const { data: data, errors: errors } = await response;
    if (!data || errors) {
        const message = errors ? JSON.stringify(errors) : 'No data returned from graphql call';
        throw new (0, $gbHOB.default)(new Error(message), (0, $7SU3A.PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO));
    }
    if (!data.jira?.parentCandidatesWithInfoForNewIssue) {
        // @ts-expect-error - TS2339 - Property 'length' does not exist on type 'never'.
        if (Array.isArray(errors) && errors.length > 0) {
            const errorMessage = JSON.stringify(errors);
            // if `parentCandidatesForExistingIssue` is missing and any errors were in the response
            // assume that an error caused the data to be missing.
            throw new (0, $gbHOB.default)(new (0, $7EhAs.default)((0, $1c3fbb431a173cc6$export$e813cd7045fcc98d), `Call to gira for parent candidates returned with errors: ${errorMessage}`), (0, $7SU3A.PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO));
        } else // GraphQL doesn't rely on HTTP status codes to classify errors.
        // But we do have code that knows how to handle 404s (display "Issue not found"
        // screen, etc.), so that's why we're forcing a 404 here.
        throw new (0, $gbHOB.default)(new (0, $7EhAs.default)((0, $1c3fbb431a173cc6$export$8bca792d963eb0ef), 'Call to gira for parent candidates returned empty response'), (0, $7SU3A.PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO));
    }
    const candidates = data.jira.parentCandidatesWithInfoForNewIssue !== undefined ? (0, $hKxcm.transformData)(data.jira.parentCandidatesWithInfoForNewIssue.parentCandidates.edges) : [];
    return {
        candidates: candidates,
        message: data.jira.parentCandidatesWithInfoForNewIssue !== undefined ? data.jira.parentCandidatesWithInfoForNewIssue.message : undefined
    };
};

});
parcelRegister("go64Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $381d472c7acaff8f$export$2e2bcd8739ae039);

var $7SU3A = parcelRequire("7SU3A");

var $kXzsJ = parcelRequire("kXzsJ");
const $381d472c7acaff8f$export$1fd3b40492f4ef9f = 20;
var /**
 * Returns parent candidates for a new issue (e.g one that is about to be created)
 *
 * @param cloudId - The cloud ID of the instance
 * @param projectId - The ID of the project in which the issue will be created
 * @param issueTypeId - The issue type of the project to be created
 * @param searchTerm - A search string for the parent, on either full key match or partial summary match
 * @param excludeDone - Whether to exclude done issues from the list of parent candidate results
 * @returns A list of possible parent issues for the specified project and issue type
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$381d472c7acaff8f$export$2e2bcd8739ae039 = async (cloudId, projectId, issueTypeId, searchTerm, excludeDone)=>{
    const variables = {
        cloudId: cloudId,
        projectId: projectId,
        issueTypeId: issueTypeId,
        searchTerm: searchTerm,
        excludeDone: excludeDone,
        first: $381d472c7acaff8f$export$1fd3b40492f4ef9f
    };
    const response = await (0, $kXzsJ.getClient)('').query({
        query: (0, $7SU3A.buildParentCandidatesForNewIssueQuery)(),
        variables: variables,
        operationName: `jira_parenting_${(0, $7SU3A.PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO)}`
    });
    return response;
};

});
parcelRegister("7SU3A", function(module, exports) {

$parcel$export(module.exports, "PARENT_CANDIDATES_FOR_NEW_ISSUES_QUERY_WITH_INFO", () => $dbe4fea6910fdc7f$export$26f006aaa0389bc0);
$parcel$export(module.exports, "buildParentCandidatesForNewIssueQuery", () => $dbe4fea6910fdc7f$export$453f3d2e0fac3592);

var $hIakI = parcelRequire("hIakI");
const $dbe4fea6910fdc7f$export$26f006aaa0389bc0 = 'issueParentCandidatesForNewIssuesQueryWithInfo';
const $dbe4fea6910fdc7f$export$453f3d2e0fac3592 = ()=>`
    query jira_parenting_${$dbe4fea6910fdc7f$export$26f006aaa0389bc0}($projectId: ID!, $issueTypeId: ID!, $cloudId: ID!, $searchTerm: String, $excludeDone: Boolean, $first: Int)  {
        ${(0, $hIakI.parentCandidatesForNewIssueQuery)()}
    }
`;

});
parcelRegister("hIakI", function(module, exports) {

$parcel$export(module.exports, "parentCandidatesForNewIssueQuery", () => $a7df5a978940517d$export$1dfd5c8a625d5960);

var $bKxX9 = parcelRequire("bKxX9");
const $a7df5a978940517d$var$issueType = ()=>`
    ... on JiraIssueTypeField {
        fieldId
        issueType {
            issueTypeId
            name
            avatar {
                xsmall
            }
        }
    }
`;
const $a7df5a978940517d$var$summary = ()=>`
    ... on JiraSingleLineTextField {
        fieldId
        text
    }
`;
const $a7df5a978940517d$var$color = ()=>`
    issueColorField {
      color {
        colorKey
      }
    }
`;
const $a7df5a978940517d$var$status = ()=>`
    ... on JiraStatusField {
      fieldId
      status {
        statusCategory{
          statusCategoryId
        }
      }
    }
`;
const $a7df5a978940517d$var$fieldsByIdOld = ()=>`fieldsById(ids:["summary", "issuetype"]){
  edges{
    node{
      ${$a7df5a978940517d$var$issueType()}
      ${$a7df5a978940517d$var$summary()}
    }
  }
}`;
const $a7df5a978940517d$var$fieldsById = ()=>`fieldsById(ids:["summary", "issuetype", "status"]){
  edges{
    node{
      ${$a7df5a978940517d$var$issueType()}
      ${$a7df5a978940517d$var$summary()}
      ${$a7df5a978940517d$var$status()}
    }
  }
}`;
const $a7df5a978940517d$export$1dfd5c8a625d5960 = ()=>`
    jira {
        parentCandidatesWithInfoForNewIssue(projectId: $projectId, issueTypeId: $issueTypeId, cloudId: $cloudId, searchTerm: $searchTerm, excludeDone: $excludeDone, first: $first) {
          parentCandidates {
            edges {
              node {
                issueId
                key
                ${$a7df5a978940517d$var$color()}
                ${(0, $bKxX9.ff)('request-isdone-when-requesting-parent-candidates-and-display-in-parent-field_3becy') ? $a7df5a978940517d$var$fieldsById() : $a7df5a978940517d$var$fieldsByIdOld()}
              }
            }
          }
          message
        }
      }
`;

});







parcelRegister("frqgn", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d6f55fe2b6a317b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lRmyA = parcelRequire("lRmyA");

var $b7b1I = parcelRequire("b7b1I");

var $dR4yn = parcelRequire("dR4yn");
const $8d6f55fe2b6a317b$var$PeopleField = (props)=>{
    const { additionalData: { isMulti: isMulti }, autoCompleteUrl: autoCompleteUrl, selectedProject: selectedProject, ...rest } = props;
    const projectKey = selectedProject?.projectKey;
    const fetchSuggestions = (0, $eUqFw.useCallback)(async (query)=>{
        const autoCompleteResponse = await (0, $lRmyA.performGetRequest)(`/rest/api/3/user/recommend?${new URLSearchParams({
            context: 'People',
            ...projectKey && {
                project: projectKey
            },
            query: query ?? ''
        })}`);
        return (autoCompleteResponse ?? []).map((0, $dR4yn.transformToUserOption));
    }, [
        projectKey
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b7b1I.default), {
        ...rest,
        isMulti: isMulti,
        autoCompleteUrl: autoCompleteUrl,
        onFetchSuggestions: fetchSuggestions
    });
};
var $8d6f55fe2b6a317b$export$2e2bcd8739ae039 = $8d6f55fe2b6a317b$var$PeopleField;

});

parcelRegister("ltG3Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcf28946f95fc30b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2XekW = parcelRequire("2XekW");
var $96Tfy = parcelRequire("96Tfy");

var $icPhQ = parcelRequire("icPhQ");
var $6HoNR = parcelRequire("6HoNR");

var $lIor1 = parcelRequire("lIor1");

var $7TaJX = parcelRequire("7TaJX");

var $3O2c6 = parcelRequire("3O2c6");
const $fcf28946f95fc30b$var$PriorityField = (props)=>{
    const { autoFocus: autoFocus, width: width, fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired }, error: error, allowedValues: allowedValues, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $7TaJX.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isReadOnly: isReadOnly = false } = props;
    const options = (0, $2XekW.mapDataToOptions)(allowedValues);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $96Tfy.default), {
        options: options,
        value: value,
        onChange: onChange,
        autoFocus: autoFocus,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        isInvalid: Boolean(error),
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDisabled: isReadOnly,
        inputId: id,
        isRequired: isRequired
    }));
};
var $fcf28946f95fc30b$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    validator: (0, $lIor1.validatePriorityField),
    transformDefaultValue: $3O2c6.transformDefaultValue
})($fcf28946f95fc30b$var$PriorityField);

});
parcelRegister("2XekW", function(module, exports) {

$parcel$export(module.exports, "mapDataToOptions", () => $cc4c4a8eb8b0f299$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionToData", () => $cc4c4a8eb8b0f299$export$fc800909123977f3);
const $cc4c4a8eb8b0f299$export$99a866ffa3af7d8b = (data)=>data.map(({ id: id, name: name, iconUrl: iconUrl })=>({
            label: name,
            value: id,
            iconUrl: iconUrl
        }));
const $cc4c4a8eb8b0f299$export$fc800909123977f3 = ({ label: label, value: value, iconUrl: iconUrl })=>({
        id: value,
        name: label,
        iconUrl: iconUrl
    });

});

parcelRegister("96Tfy", function(module, exports) {

$parcel$export(module.exports, "default", () => $c938ab475b18514d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5wCDk = parcelRequire("5wCDk");

var $4NcaX = parcelRequire("4NcaX");
var $bKilX = parcelRequire("bKilX");
const $c938ab475b18514d$var$PriorityEdit = (props)=>{
    const { value: value, options: options, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', autoFocus: autoFocus, isInvalid: isInvalid, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, isDisabled: isDisabled, inputId: inputId, isRequired: isRequired, classNamePrefix: classNamePrefix, openMenuOnFocus: openMenuOnFocus } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
        inputId: inputId,
        required: isRequired,
        value: value,
        options: options,
        placeholder: placeholder,
        // @ts-expect-error - TS2322 - Type '(arg1: Option) => void' is not assignable to type '(value: Option | null, action: ActionMeta<Option>) => void'.
        onChange: onChange,
        onFocus: onFocus,
        onBlur: onBlur,
        autoFocus: autoFocus,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        styles: (0, $4NcaX.defaultSelectStyles),
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        formatOptionLabel: (0, $bKilX.formatOptionLabel),
        isClearable: false,
        hideSelectedOptions: true,
        closeMenuOnScroll: onCloseMenuOnScroll,
        isDisabled: isDisabled,
        classNamePrefix: classNamePrefix,
        openMenuOnFocus: openMenuOnFocus
    });
};
var $c938ab475b18514d$export$2e2bcd8739ae039 = $c938ab475b18514d$var$PriorityEdit;

});
parcelRegister("bKilX", function(module, exports) {

$parcel$export(module.exports, "formatOptionLabel", () => $03dfe231efe3dc8b$export$322216d90ffb8d0e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iJlfe = parcelRequire("iJlfe");
const $03dfe231efe3dc8b$export$b4053b30a2d3983b = (props)=>{
    const { option: { label: label, iconUrl: iconUrl, description: description }, optionContext: optionContext } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($03dfe231efe3dc8b$var$FlexRow, null, Boolean(iconUrl) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($03dfe231efe3dc8b$var$AvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        appearance: "square",
        size: "xsmall",
        src: iconUrl,
        borderColor: "transparent"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($03dfe231efe3dc8b$var$FlexColumn, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($03dfe231efe3dc8b$var$Label, null, label), optionContext === 'menu' && Boolean(description) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($03dfe231efe3dc8b$var$Description, null, description)));
};
const $03dfe231efe3dc8b$export$322216d90ffb8d0e = (option, { context: context })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($03dfe231efe3dc8b$export$b4053b30a2d3983b, {
        option: option,
        optionContext: context
    });
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $03dfe231efe3dc8b$var$FlexRow = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $03dfe231efe3dc8b$var$FlexColumn = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2lx21bp4 _1e0c1txw _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $03dfe231efe3dc8b$var$AvatarWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxu2gc _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $03dfe231efe3dc8b$var$Label = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.className
        ])
    });
});
const $03dfe231efe3dc8b$var$Description = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyb1skh _syaz1rc1",
            __cmplp.className
        ])
    });
});

});



parcelRegister("0dKMy", function(module, exports) {

$parcel$export(module.exports, "default", () => $57b46e5a0f6dbb9f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $cD14K = parcelRequire("cD14K");

var $icPhQ = parcelRequire("icPhQ");
var $6HoNR = parcelRequire("6HoNR");

var $7TaJX = parcelRequire("7TaJX");

var $6Pq4z = parcelRequire("6Pq4z");
const $57b46e5a0f6dbb9f$var$ProjectCF = (props)=>{
    const { fieldId: fieldId, autoCompleteUrl: autoCompleteUrl = '', fieldProps: { value: value = null, onChange: onChange }, width: width, autoFocus: autoFocus = false, onCloseMenuOnScroll: // @ts-expect-error - TS2339 - Property 'onCloseMenuOnScroll' does not exist on type 'Props'.
    onCloseMenuOnScroll = (0, $7TaJX.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cD14K.ProjectCustomFieldEdit), {
        fieldId: fieldId,
        value: value,
        onChange: onChange,
        autoFocus: autoFocus,
        autoCompleteUrl: autoCompleteUrl,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        fetchSuggestionsOnFocus: true
    }));
};
var $57b46e5a0f6dbb9f$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    validator: (0, $6Pq4z.validateProjectField),
    transformDefaultValue: (0, $6Pq4z.transformDefaultProjectValue)
})($57b46e5a0f6dbb9f$var$ProjectCF);

});
parcelRegister("cD14K", function(module, exports) {

$parcel$export(module.exports, "ProjectCustomFieldEdit", () => $1ce22f3ef8bc3b96$export$8d413eb197febcb2);

var $eUqFw = parcelRequire("eUqFw");

var $fm9CZ = parcelRequire("fm9CZ");

var $lNfG4 = parcelRequire("lNfG4");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4NcaX = parcelRequire("4NcaX");
var $bKilX = parcelRequire("bKilX");

var $a60Hj = parcelRequire("a60Hj");

var $fO0l8 = parcelRequire("fO0l8");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $fdV7M = parcelRequire("fdV7M");

var $40Hqo = parcelRequire("40Hqo");
const $1ce22f3ef8bc3b96$var$LOAD_OPTIONS_DEBOUNCE_TIMER = 300;
const $1ce22f3ef8bc3b96$var$PROJECT_OPTIONS_LOADED = 'issue-field-project-options-loaded';
const $1ce22f3ef8bc3b96$var$projectOptionsLoadedMetric = (0, $lNfG4.metrics).custom({
    key: $1ce22f3ef8bc3b96$var$PROJECT_OPTIONS_LOADED
});
const $1ce22f3ef8bc3b96$export$8d413eb197febcb2 = (props)=>{
    const { fieldId: fieldId, autoCompleteUrl: autoCompleteUrl, autoFocus: autoFocus, blurInputOnSelect: blurInputOnSelect, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, hideSelectedOptions: hideSelectedOptions, onChange: onChange, onCloseMenuOnScroll: onCloseMenuOnScroll, openMenuOnFocus: openMenuOnFocus, spacing: spacing, fetchSuggestionsOnFocus: fetchSuggestionsOnFocus = false, isInvalid: isInvalid = false, value: value = null, onBlur: onBlur } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [lastFetchFailed, setLastFetchFailed] = (0, $eUqFw.useState)(false);
    const [defaultOptions, setDefaultOptions] = (0, $eUqFw.useState)([]);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const shouldFetchDefaultOptions = (0, $eUqFw.useRef)(true);
    const isInSampleAnalytics = (0, $eUqFw.useRef)((0, $a60Hj.isInSample)());
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fireOptionsLoadedAnalyticsEvent = (duration)=>{
        const action = 'loaded';
        const actionSubject = 'projectFieldOptions';
        const event = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject
        });
        const attrs = {
            duration: duration
        };
        (0, $jMP2a.fireOperationalAnalytics)(event, `${actionSubject} ${action}`, attrs);
    };
    const searchProjects = async (query = '')=>{
        setLastFetchFailed(false);
        isInSampleAnalytics.current && $1ce22f3ef8bc3b96$var$projectOptionsLoadedMetric.start();
        return (0, $40Hqo.fetchProjects)(query, autoCompleteUrl).then((projectsData)=>{
            if (isInSampleAnalytics.current) {
                $1ce22f3ef8bc3b96$var$projectOptionsLoadedMetric.stop();
                const { start: start, stop: stop } = $1ce22f3ef8bc3b96$var$projectOptionsLoadedMetric.getData();
                const duration = stop && start ? stop - start : null;
                fireOptionsLoadedAnalyticsEvent(duration);
            }
            return projectsData;
        }).catch(()=>{
            isInSampleAnalytics.current && $1ce22f3ef8bc3b96$var$projectOptionsLoadedMetric.cancel();
            setLastFetchFailed(true);
            return [];
        });
    };
    const onFocus = async ()=>{
        if (shouldFetchDefaultOptions && defaultOptions && shouldFetchDefaultOptions.current && !defaultOptions.length) {
            shouldFetchDefaultOptions.current = false;
            setIsLoading && setIsLoading(true);
            const options = await searchProjects();
            setDefaultOptions && setDefaultOptions(options);
            setIsLoading && setIsLoading(false);
        }
    };
    // go/jfe-eslint
    const loadOptionsDebounced = (0, $fO0l8.default)(searchProjects, $1ce22f3ef8bc3b96$var$LOAD_OPTIONS_DEBOUNCE_TIMER);
    const getNoOptionsMessage = (0, $eUqFw.useCallback)(()=>formatMessage(lastFetchFailed ? (0, $fdV7M.default).failedFetch : (0, $fdV7M.default).noMatches), [
        formatMessage,
        lastFetchFailed
    ]);
    const defaultOptionsProps = ()=>{
        if (fetchSuggestionsOnFocus) return {
            onFocus: onFocus,
            isLoading: isLoading,
            defaultOptions: defaultOptions
        };
        return {};
    };
    // NOTE: Only used for drilling down `react-select` props!
    // See: https://react-select.com/props
    const additionalSelectProps = {
        blurInputOnSelect: blurInputOnSelect,
        hideSelectedOptions: hideSelectedOptions,
        openMenuOnFocus: openMenuOnFocus,
        spacing: spacing
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fm9CZ.default), {
        fieldId: fieldId,
        autoFocus: autoFocus,
        ...defaultOptionsProps(),
        ...additionalSelectProps,
        isClearable: true,
        // @ts-expect-error - TS2322 - Type '((e: ChangeEvent<HTMLElement>) => boolean) | undefined' is not assignable to type 'boolean | EventListener | undefined'.
        closeMenuOnScroll: onCloseMenuOnScroll,
        formatOptionLabel: (0, $bKilX.formatOptionLabel),
        loadOptions: loadOptionsDebounced,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        noOptionsMessage: getNoOptionsMessage,
        placeholder: formatMessage((0, $fdV7M.default).placeholder),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        styles: (0, $4NcaX.defaultSelectStyles),
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        value: value,
        // @ts-expect-error - TS2322 - Type '(value: Option) => void' is not assignable to type '(value: Option | null, action: ActionMeta<Option>) => void'.
        onChange: onChange,
        onBlur: onBlur
    });
};

});
parcelRegister("a60Hj", function(module, exports) {

$parcel$export(module.exports, "isInSample", () => $433b34397a9756c8$export$a994c91d08ead5ff);

const $433b34397a9756c8$export$a994c91d08ead5ff = (sampleRate = (0, $3e173c13cba9c734$export$9fc1f2d681a9e609))=>Math.random() <= 1 / sampleRate;

});
/**
 * Sample rates are defined as the inverse.
 * e.g. a sample rate of 100 = 1 in 100 events are sent.
 */ const $3e173c13cba9c734$export$9fc1f2d681a9e609 = 100; // 1%


parcelRegister("fdV7M", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecb26ea260b249b4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ecb26ea260b249b4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noMatches: {
        "id": "issue-field-project.edit.async-project-cf.no-matches",
        "defaultMessage": "No matches"
    },
    failedFetch: {
        "id": "issue-field-project.edit.async-project-cf.failed-fetch",
        "defaultMessage": "Search failed. Please try again."
    },
    placeholder: {
        "id": "issue-field-project.edit.async-project-cf.placeholder",
        "defaultMessage": "Select project"
    },
    loading: {
        "id": "issue-field-project.edit.async-project-cf.loading",
        "defaultMessage": "Searching..."
    }
});

});

parcelRegister("40Hqo", function(module, exports) {

$parcel$export(module.exports, "fetchProjects", () => $4c62c9e4bb900226$export$f0d2ca471cdb99b0);

var $guiFP = parcelRequire("guiFP");

var $7byHA = parcelRequire("7byHA");
var $lRmyA = parcelRequire("lRmyA");

var $25vda = parcelRequire("25vda");
const $4c62c9e4bb900226$export$f0d2ca471cdb99b0 = async (inputValue, autoCompleteUrl)=>(0, $lRmyA.performGetRequest)(`${autoCompleteUrl}${inputValue}`).then((response)=>(0, $25vda.mapDataToOptions)(response.values)).catch((error)=>{
        (0, $guiFP.trackFetchErrors)({
            error: error,
            id: 'fetchProjects',
            packageName: 'jiraIssueFieldProject',
            logToSentry: !(0, $7byHA.isValidationError)(error),
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    });

});
parcelRegister("25vda", function(module, exports) {

$parcel$export(module.exports, "mapDataToOption", () => $ffcb0af364b4a885$export$5c1e24ea9ccb80aa);
$parcel$export(module.exports, "mapDataToOptions", () => $ffcb0af364b4a885$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionToData", () => $ffcb0af364b4a885$export$fc800909123977f3);
const $ffcb0af364b4a885$export$5c1e24ea9ccb80aa = (data)=>({
        label: data.name,
        value: data.key,
        iconUrl: data.avatarUrls['48x48'],
        projectId: data.id
    });
const $ffcb0af364b4a885$export$99a866ffa3af7d8b = (data)=>data.map($ffcb0af364b4a885$export$5c1e24ea9ccb80aa);
const $ffcb0af364b4a885$export$fc800909123977f3 = ({ label: label, value: value, iconUrl: iconUrl })=>({
        key: value,
        name: label,
        avatarUrls: {
            '48x48': iconUrl
        }
    });

});




parcelRegister("3n4oY", function(module, exports) {

$parcel$export(module.exports, "RadioGroupField", () => $53eac62a47f7dfa1$export$a314277471067e8a);
$parcel$export(module.exports, "default", () => $53eac62a47f7dfa1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $l6Z7J = parcelRequire("l6Z7J");
var $ka2EH = parcelRequire("ka2EH");

var $icPhQ = parcelRequire("icPhQ");
var $6HoNR = parcelRequire("6HoNR");

var $lIor1 = parcelRequire("lIor1");

var $gNkUS = parcelRequire("gNkUS");
const $53eac62a47f7dfa1$export$a314277471067e8a = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange, isDisabled: isDisabled = false, ...fieldProps }, error: error, allowedValues: allowedValues, isReadOnly: isReadOnly = false } = props;
    const options = (0, $l6Z7J.mapDataToOptions)(allowedValues);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ka2EH.default), {
        ...fieldProps,
        options: options,
        isDisabled: isReadOnly || isDisabled,
        value: value,
        onChange: onChange,
        isInvalid: Boolean(error)
    }));
};
var $53eac62a47f7dfa1$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    validator: (0, $lIor1.validateRadioGroupField),
    transformDefaultValue: $gNkUS.transformDefaultValue
})($53eac62a47f7dfa1$export$a314277471067e8a);

});
parcelRegister("l6Z7J", function(module, exports) {

$parcel$export(module.exports, "mapDataToOptions", () => $f328e5e0a24fa2ef$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionToData", () => $f328e5e0a24fa2ef$export$fc800909123977f3);
const $f328e5e0a24fa2ef$export$99a866ffa3af7d8b = (data)=>data?.map(({ id: id, value: value })=>({
            label: value,
            value: id,
            testId: id
        }));
const $f328e5e0a24fa2ef$export$fc800909123977f3 = (option)=>({
        id: option?.value,
        value: option?.label
    });

});

parcelRegister("ka2EH", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c094377a03733c6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hiIej = parcelRequire("hiIej");
const $4c094377a03733c6$var$RadioGroupEdit = (props)=>{
    const { value: value, options: options, onChange: onChange, isInvalid: isInvalid, isDisabled: isDisabled = false, ...fieldProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hiIej.default), {
        ...fieldProps,
        // radio group component handles undefined and null differently, pay attention when change value property
        value: value === null ? value : value?.value,
        options: options,
        isDisabled: isDisabled,
        onChange: (e)=>onChange(options.find((option)=>option.value === e?.target?.value) || null),
        isInvalid: isInvalid
    });
};
var $4c094377a03733c6$export$2e2bcd8739ae039 = $4c094377a03733c6$var$RadioGroupEdit;

});
parcelRegister("hiIej", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2025a66c6553d911$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5Q9wj = parcelRequire("5Q9wj");

var $hnuwz = parcelRequire("hnuwz");
const $2025a66c6553d911$var$noOptions = [];
function $2025a66c6553d911$export$2e2bcd8739ae039(props) {
    const { onChange: onChange, options: options = $2025a66c6553d911$var$noOptions, value: propValue, defaultValue: defaultValue, isDisabled: isDisabled, isRequired: isRequired, isInvalid: isInvalid, onInvalid: onInvalid = (0, $5Q9wj.default), name: name, analyticsContext: analyticsContext, ['aria-labelledby']: ariaLabelledBy, testId: testId } = props;
    const [selectedValue, setSelectedValue] = (0, $eUqFw.useState)(propValue !== undefined ? propValue : defaultValue);
    const onRadioChange = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        setSelectedValue(e.currentTarget.value);
        if (onChange) onChange(e, analyticsEvent);
    }, [
        onChange
    ]);
    // If propValue is provided than act as a controlled component
    // If not then act as an uncontrolled component using the value from state
    const value = typeof propValue !== 'undefined' ? propValue : selectedValue;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        role: "radiogroup",
        "aria-labelledby": ariaLabelledBy,
        "data-testid": testId
    }, options.map(({ ...optionProps }, index)=>{
        if (typeof isDisabled !== 'undefined') optionProps.isDisabled = isDisabled;
        const isChecked = value !== null && optionProps.value === value;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnuwz.default), {
            ...optionProps,
            name: name || optionProps.name,
            key: index,
            onChange: onRadioChange,
            onInvalid: onInvalid,
            isInvalid: isChecked && isInvalid,
            isChecked: isChecked,
            testId: optionProps.testId || testId,
            isRequired: isRequired,
            analyticsContext: analyticsContext
        });
    }));
}

});


parcelRegister("gNkUS", function(module, exports) {

$parcel$export(module.exports, "transformDefaultValue", () => $0e1cc9a64130f863$export$e2f4e5d31db527cc);
const $0e1cc9a64130f863$export$e2f4e5d31db527cc = ({ id: id, value: value })=>({
        label: value,
        value: id,
        testId: id
    });

});


parcelRegister("f6c5h", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0e526566e7426f7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7ZZxN = parcelRequire("7ZZxN");

var $7ZywE = parcelRequire("7ZywE");

var $icPhQ = parcelRequire("icPhQ");
var $6HoNR = parcelRequire("6HoNR");

var $bRVha = parcelRequire("bRVha");

var $lIor1 = parcelRequire("lIor1");
const $d0e526566e7426f7$var$ReporterField = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange, ...fieldProps }, autoFocus: autoFocus = false, isRequired: isRequired, isReadOnly: isReadOnly = false, selectedProject: selectedProject } = props;
    const { projectType: projectType, projectKey: projectKey } = selectedProject || {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7ZywE.default), {
        ...fieldProps,
        value: value,
        onChange: onChange,
        appearance: "normal",
        isDisabled: isReadOnly,
        autoCompleteUrl: `/rest/api/3/user/recommend?${new URLSearchParams({
            context: 'Reporter',
            ...projectKey && {
                project: projectKey
            },
            query: ''
        })}`,
        isMulti: false,
        autoFocus: autoFocus,
        isClearable: !isRequired,
        allowEmail: projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT),
        width: width,
        inputId: fieldProps.id,
        openMenuOnClick: true
    }));
};
var $d0e526566e7426f7$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    validator: (0, $lIor1.validateUserPickerField),
    transformDefaultValue: (0, $bRVha.transformJiraUserToUserOption)
})($d0e526566e7426f7$var$ReporterField);

});
parcelRegister("7ZywE", function(module, exports) {

$parcel$export(module.exports, "default", () => $96b6f0d0926d110f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $f6ziy = parcelRequire("f6ziy");
var $aofgi = parcelRequire("aofgi");

var $lO4Or = parcelRequire("lO4Or");

var $cWiVr = parcelRequire("cWiVr");

var $lT3ph = parcelRequire("lT3ph");
const $96b6f0d0926d110f$var$ReporterEdit = (props)=>{
    const { allowEmail: allowEmail = false, appearance: appearance, width: width, onChange: onChange, onSelection: onSelection, value: value = null, autoFocus: autoFocus = false, placeholder: placeholder = '', isDisabled: isDisabled = false, autoCompleteUrl: autoCompleteUrl, onCancel: onCancel, isClearable: isClearable = true, fetchSuggestions: fetchSuggestionsProps, shouldSetDefaultValue: shouldSetDefaultValueProp = true, openMenuOnClick: openMenuOnClick = false, ...fieldProps } = props;
    const { data: { user: user } } = (0, $cWiVr.useCurrentUser)();
    const shouldSetDefaultValue = (0, $eUqFw.useRef)(!value && shouldSetDefaultValueProp);
    // to store default value in form field wrapper if value is not set
    (0, $eUqFw.useEffect)(()=>{
        if (shouldSetDefaultValue.current && user && !value) {
            shouldSetDefaultValue.current = false;
            onChange((0, $aofgi.mapUserObjectToUserOption)(user, true));
        }
    }, [
        onChange,
        user,
        value
    ]);
    const fetchSuggestionsCallback = (0, $eUqFw.useCallback)(async (query)=>(0, $lT3ph.fetchSuggestions)(autoCompleteUrl, query), [
        autoCompleteUrl
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f6ziy.default), {
        ...fieldProps,
        appearance: appearance,
        width: width,
        fieldId: (0, $lO4Or.REPORTER_TYPE),
        autoCompleteUrl: autoCompleteUrl,
        // @ts-expect-error TS2322: Type (arg1: UserOption) => void is not assignable to type (arg1: UserOption | UserOption[]) => void
        onChange: onChange,
        value: value,
        autoFocus: autoFocus,
        placeholder: placeholder,
        isDisabled: isDisabled,
        fetchSuggestions: fetchSuggestionsProps || fetchSuggestionsCallback,
        onSelection: onSelection,
        onCancel: onCancel,
        isClearable: isClearable,
        allowEmail: allowEmail,
        shouldShowEmailInOptions: true,
        openMenuOnClick: openMenuOnClick
    });
};
var $96b6f0d0926d110f$export$2e2bcd8739ae039 = $96b6f0d0926d110f$var$ReporterEdit;

});
parcelRegister("lT3ph", function(module, exports) {

$parcel$export(module.exports, "fetchSuggestions", () => $6848edeb9436e36d$export$ebf2f44fe450da2b);

var $aofgi = parcelRequire("aofgi");

var $lRmyA = parcelRequire("lRmyA");
const $6848edeb9436e36d$export$ebf2f44fe450da2b = async (autoCompleteUrl, query)=>{
    let users = [];
    const url = `${autoCompleteUrl}${query || ''}`;
    const suggestionsResponse = await (0, $lRmyA.performGetRequest)(url) || [];
    if (Array.isArray(suggestionsResponse)) // user/search returns array
    users = suggestionsResponse.map((userFromApi)=>(0, $aofgi.mapUserObjectToUserOption)(userFromApi, true));
    else if (suggestionsResponse.users) // user/picker returns object
    // @ts-expect-error - TS7006 - Parameter 'userFromApi' implicitly has an 'any' type.
    users = suggestionsResponse.users.map((userFromApi)=>(0, $aofgi.mapUserObjectToUserOption)(userFromApi, true));
    return users;
};

});



parcelRegister("dA8Yc", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaad683e2ce6ef7f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3YvWp = parcelRequire("3YvWp");

var $gGtKh = parcelRequire("gGtKh");

var $icPhQ = parcelRequire("icPhQ");
var $dibFF = parcelRequire("dibFF");
var $6HoNR = parcelRequire("6HoNR");

var $lIor1 = parcelRequire("lIor1");

var $7TaJX = parcelRequire("7TaJX");

var $gtaAU = parcelRequire("gtaAU");
const $aaad683e2ce6ef7f$var$ResolutionField = (props)=>{
    const { allowedValues: allowedValues, fieldId: fieldId, width: width, error: error, fieldProps: { value: value, onChange: onChange, ...fieldProps }, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $7TaJX.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "inline-resolution-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dibFF.FieldLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3YvWp.AsyncInlineResolutionEdit), {
        ...fieldProps,
        options: (0, $gtaAU.mapAllowedValuesToSelectOptions)(allowedValues),
        value: value,
        // @ts-expect-error - TS2322 - Type '(value: ResolutionOption) => void' is not assignable to type '(option: ResolutionOption) => Promise<undefined> | undefined'.
        onChange: onChange,
        isInvalid: Boolean(error),
        autoFocus: autoFocus,
        classNamePrefix: `resolution-field-${fieldId}`,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered
    })));
};
var $aaad683e2ce6ef7f$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    transformDefaultValue: (0, $gtaAU.transformDefaultResolutionValue),
    validator: (0, $lIor1.validateResolutionField)
})($aaad683e2ce6ef7f$var$ResolutionField);

});
parcelRegister("3YvWp", function(module, exports) {

$parcel$export(module.exports, "AsyncInlineResolutionEdit", () => $97524fe27609594d$export$af39bdbe1dcb0a1e);

var $7rh0R = parcelRequire("7rh0R");

const $97524fe27609594d$export$af39bdbe1dcb0a1e = (0, $7rh0R.lazy)(()=>(parcelRequire("cepex")).then((module)=>module.InlineResolutionEdit), {
    moduleId: "./src/packages/issue/fields/resolution/src/index.tsx"
});

});
parcelRegister("cepex", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('5R3Pb');
        const value = parcelRequire('8SR9s');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("5R3Pb").then(()=>parcelRequire('8SR9s'));
}

});



parcelRegister("4Dz8o", function(module, exports) {

$parcel$export(module.exports, "default", () => $6104a65b1b5abd07$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lRmyA = parcelRequire("lRmyA");

var $l760E = parcelRequire("l760E");

var $icPhQ = parcelRequire("icPhQ");

var $6HoNR = parcelRequire("6HoNR");

var $lIor1 = parcelRequire("lIor1");

var $ed9FR = parcelRequire("ed9FR");
const $6104a65b1b5abd07$var$RespondersField = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange, ...fieldProps }, autoFocus: autoFocus = false, fieldId: fieldId, autoCompleteUrl: autoCompleteUrl = '', placeholder: placeholder = '', isDisabled: isDisabled = false } = props;
    const onFetchSuggestions = async (query)=>{
        let responders = [];
        if (autoCompleteUrl !== undefined) {
            let autoCompleteResponse;
            try {
                autoCompleteResponse = await (0, $lRmyA.performGetRequest)(`${autoCompleteUrl}/?query=${query || ''}`);
            } catch (err) {
                return [];
            }
            if (autoCompleteResponse.responders) responders = autoCompleteResponse.responders;
        }
        return (0, $ed9FR.transformDefaultUserValues)(responders);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l760E.default), {
        ...fieldProps,
        autoCompleteUrl: autoCompleteUrl,
        placeholder: placeholder,
        isDisabled: isDisabled,
        onChange: onChange,
        value: value,
        appearance: "normal",
        isMulti: true,
        autoFocus: autoFocus,
        fieldId: fieldId,
        fetchSuggestions: onFetchSuggestions,
        isClearable: true
    }));
};
var $6104a65b1b5abd07$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    validator: (0, $lIor1.validateUserPickerField),
    transformDefaultValue: (0, $ed9FR.transformDefaultUserValues)
})($6104a65b1b5abd07$var$RespondersField);

});
parcelRegister("ed9FR", function(module, exports) {

$parcel$export(module.exports, "transformDefaultUserValues", () => $860442f6589f3f68$export$26760e7b66ccf1e1);
$parcel$export(module.exports, "mapUserOptionsToAris", () => $860442f6589f3f68$export$80dc4fd89a4c227d);
const $860442f6589f3f68$var$transformResponderTypeToUserOption = (userData)=>({
        id: userData?.ari || '',
        name: userData?.name || '',
        avatarUrl: userData?.avatarUrl || ''
    });
const $860442f6589f3f68$var$validateDefaultValue = (responder)=>{
    if (responder === null || responder === undefined) return false;
    if (!responder.ari || !responder.name) return false;
    return true;
};
const $860442f6589f3f68$export$26760e7b66ccf1e1 = (defaultValue)=>{
    if (defaultValue === null || defaultValue === undefined) return [];
    return defaultValue.filter($860442f6589f3f68$var$validateDefaultValue).map($860442f6589f3f68$var$transformResponderTypeToUserOption);
};
const $860442f6589f3f68$var$mapUserOptionToAri = (userData)=>({
        ari: userData.id
    });
const $860442f6589f3f68$export$80dc4fd89a4c227d = (userData)=>userData.map($860442f6589f3f68$var$mapUserOptionToAri);

});


parcelRegister("ikozW", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca3502f904942eed$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fXyiT = parcelRequire("fXyiT");

var $1ybV0 = parcelRequire("1ybV0");

var $dvJOo = parcelRequire("dvJOo");

var $6HoNR = parcelRequire("6HoNR");

var $lIor1 = parcelRequire("lIor1");

var $7TaJX = parcelRequire("7TaJX");

var $3x0xT = parcelRequire("3x0xT");
const $ca3502f904942eed$var$SingleGroupPickerField = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange }, fieldId: fieldId, error: error, autoCompleteUrl: autoCompleteUrl, autoFocus: autoFocus = false, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false } = props;
    const getExtraProps = ()=>{
        if ((0, $1ybV0.ff)('common-field-behaviour-for-new-gic_q9mgt') && isDropdownMenuFixedAndLayered) return {
            menuPosition: 'fixed',
            groupPickerStyles: (0, $fXyiT.defaultUserPickerStyles),
            onCloseMenuOnScroll: (0, $7TaJX.closeMenuOnScroll)
        };
        if ((0, $1ybV0.ff)('common-field-behaviour-for-new-gic_q9mgt')) return {
            onCloseMenuOnScroll: (0, $7TaJX.closeMenuOnScroll)
        };
        return {};
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dvJOo.default), {
        autoCompleteUrl: autoCompleteUrl,
        onChange: onChange,
        value: value,
        fieldId: fieldId,
        autoFocus: autoFocus,
        isMulti: false,
        width: width,
        isInvalid: Boolean(error),
        placeholder: " ",
        ...getExtraProps()
    });
};
var $ca3502f904942eed$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    validator: (0, $lIor1.validateGroupPickerField),
    transformDefaultValue: (0, $3x0xT.transformGroupDefaultValueToUserOption)
})($ca3502f904942eed$var$SingleGroupPickerField);

});

parcelRegister("k4Bm6", function(module, exports) {

$parcel$export(module.exports, "default", () => $31c7d83ba7e51369$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jRCtV = parcelRequire("jRCtV");

var $74tp8 = parcelRequire("74tp8");
const $31c7d83ba7e51369$var$SingleSelectField = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jRCtV.default), {
        ...props,
        isMulti: false
    });
var $31c7d83ba7e51369$export$2e2bcd8739ae039 = $31c7d83ba7e51369$var$SingleSelectField;

});

parcelRegister("60BSb", function(module, exports) {

$parcel$export(module.exports, "default", () => $5807f51a8e3ff420$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b7b1I = parcelRequire("b7b1I");
const $5807f51a8e3ff420$var$SingleUserPickerField = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b7b1I.default), {
        ...props,
        isMulti: false,
        context: "CustomUserField"
    });
var $5807f51a8e3ff420$export$2e2bcd8739ae039 = $5807f51a8e3ff420$var$SingleUserPickerField;

});

parcelRegister("39m9P", function(module, exports) {

$parcel$export(module.exports, "default", () => $efd5b060a5a685d6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $bHNyo = parcelRequire("bHNyo");
var $hKm1t = parcelRequire("hKm1t");

var $icPhQ = parcelRequire("icPhQ");
var $6HoNR = parcelRequire("6HoNR");

var $5i7Lk = parcelRequire("5i7Lk");

var $lIor1 = parcelRequire("lIor1");

var $7TaJX = parcelRequire("7TaJX");

var $66l3t = parcelRequire("66l3t");

var $ePdOt = parcelRequire("ePdOt");
const $efd5b060a5a685d6$var$SingleVersionField = (props)=>{
    const { width: width, fieldProps: { value: value, onChange: onChange }, fieldId: fieldId, fieldName: fieldName, description: description, allowedValues: allowedValues, error: error, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $7TaJX.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isMini: isMini } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onChangeVersionsEdit = (versionEditValue)=>{
        if (!Array.isArray(versionEditValue)) onChange(versionEditValue);
    };
    const options = (0, $ePdOt.transformVersionExternalOptionstoVersionOptions)(allowedValues);
    const isDisabled = allowedValues.length === 0;
    const getVersionsEdit = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hKm1t.default), {
            options: options,
            value: value,
            onChange: onChangeVersionsEdit,
            isInvalid: Boolean(error),
            fieldId: fieldId,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            isMulti: false,
            isDisabled: isDisabled,
            placeholder: isDisabled ? formatMessage((0, $66l3t.default).none) : '',
            autoFocus: autoFocus,
            onCloseMenuOnScroll: onCloseMenuOnScroll
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: formatMessage((0, $66l3t.default).tooltip)
    }, getVersionsEdit()) : getVersionsEdit(), !isDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5i7Lk.FieldMessage), {
        description: description,
        error: error,
        fieldName: fieldName,
        isMini: isMini
    }));
};
var $efd5b060a5a685d6$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    validator: (0, $lIor1.validateSingleVersionField),
    transformDefaultValue: (0, $bHNyo.transformVersionExternalToVersion),
    shouldRenderFieldMessage: false
})($efd5b060a5a685d6$var$SingleVersionField);

});
parcelRegister("66l3t", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc871b305f67628a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $dc871b305f67628a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    none: {
        "id": "issue-create-commons.single-version-field.none",
        "defaultMessage": "None"
    },
    tooltip: {
        "id": "issue-create-commons.single-version-field.tooltip",
        "defaultMessage": "We couldn't find any versions for this project"
    }
});

});


parcelRegister("gO6fZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $680084cd7784f5b0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $lRvnl = parcelRequire("lRvnl");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hTGqw = parcelRequire("hTGqw");

var $aJ90T = parcelRequire("aJ90T");

var $icPhQ = parcelRequire("icPhQ");
var $6HoNR = parcelRequire("6HoNR");

var $5i7Lk = parcelRequire("5i7Lk");

var $7TaJX = parcelRequire("7TaJX");

var $5dMG0 = parcelRequire("5dMG0");

var $5F4bs = parcelRequire("5F4bs");
const $680084cd7784f5b0$var$SprintField = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { width: width, autoCompleteUrl: autoCompleteUrl = '/rest/greenhopper/1.0/sprint/picker?query=', fieldProps: { value: value, onChange: onChange, id: id, isRequired: isRequired }, selectedProject: selectedProject, error: error, fieldId: fieldId, autoFocus: autoFocus = false, description: description, fieldName: fieldName, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $7TaJX.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isEditable: isEditable = true, nonEditableReason: nonEditableReason, isMini: isMini } = props;
    const renderSprintEdit = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hTGqw.default), {
            fieldId: fieldId,
            autoCompleteUrl: autoCompleteUrl,
            onChange: onChange,
            value: value,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            fetchSuggestionsOnMount: false,
            autoFocus: autoFocus,
            isInvalid: Boolean(error),
            onCloseMenuOnScroll: onCloseMenuOnScroll,
            isDisabled: isEditable === false,
            getSuggestions: (0, $5F4bs.getSprintSuggestions),
            ...selectedProject?.projectKey ? {
                projectKey: selectedProject?.projectKey
            } : {},
            inputId: id,
            isRequired: isRequired
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, isEditable === false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: nonEditableReason?.message || ''
    }, renderSprintEdit()) : renderSprintEdit(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5i7Lk.FieldMessage), {
        description: description,
        error: error,
        fieldName: fieldName,
        isMini: isMini
    }), value && value.state === (0, $aJ90T.ACTIVE_SPRINT_STATE) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $680084cd7784f5b0$var$messageContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        appearance: "warning",
        testId: "issue-create-commons.ui.sprint-field.required-fields-message"
    }, formatMessage((0, $5dMG0.default).activeSprintSelectionWarningMessage))) : null);
};
var $680084cd7784f5b0$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    transformDefaultValue: (0, $5F4bs.transformDefaultSprintValue),
    shouldRenderFieldMessage: false
})($680084cd7784f5b0$var$SprintField);
const $680084cd7784f5b0$var$messageContainerStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.050'
});

});
parcelRegister("hTGqw", function(module, exports) {

$parcel$export(module.exports, "default", () => $f65c4424ed3ef430$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4NcaX = parcelRequire("4NcaX");
var $jM2Oz = parcelRequire("jM2Oz");
var $g6sIQ = parcelRequire("g6sIQ");
var $bKilX = parcelRequire("bKilX");

var $cx3nD = parcelRequire("cx3nD");

var $lO4Or = parcelRequire("lO4Or");

var $cbDYy = parcelRequire("cbDYy");

var $iXRIr = parcelRequire("iXRIr");

var $4kJKh = parcelRequire("4kJKh");

var $5C3wV = parcelRequire("5C3wV");

var $9SGuZ = parcelRequire("9SGuZ");

var $gKEgR = parcelRequire("gKEgR");
const $f65c4424ed3ef430$export$251bdbdbce9550ea = 300;
const $f65c4424ed3ef430$var$SprintEdit = (props)=>{
    const { autoCompleteUrl: autoCompleteUrl, projectKey: projectKey, autoFocus: autoFocus, onChange: onChange, onFocus: onFocus, onBlur: onBlur, spacing: spacing, value: value, options: options, noOptionsMessage: noOptionsMessage, loadingMessage: loadingMessage, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, useTransformSuggestions: useTransformSuggestions, onPostTransformSuggestions: onPostTransformSuggestions, getSuggestions: getSuggestions, fetchSuggestionsOnMount: fetchSuggestionsOnMount = true, fieldId: fieldId = (0, $lO4Or.SPRINT_TYPE), isInvalid: isInvalid = false, isDisabled: isDisabled = false, inputId: inputId, isRequired: isRequired, openMenuOnFocus: openMenuOnFocus } = props;
    const [menuIsOpen, setMenuIsOpen] = (0, $eUqFw.useState)(false);
    const [suggestions, setSuggestions] = (0, $eUqFw.useState)();
    const [defaultSuggestions, setDefaultSuggestions] = (0, $eUqFw.useState)();
    const [hasLastFetchFailed, setHasLastFetchFailed] = (0, $eUqFw.useState)(false);
    const lastQuery = (0, $eUqFw.useRef)('');
    const [restrictSprints, setRestrictSprint] = (0, $eUqFw.useState)((0, $5C3wV.getCheckboxValueFromLocalStorage)((0, $5C3wV.EDIT_SPRINT_CHECKBOX_CACHE_KEY)));
    const isInitialMount = (0, $eUqFw.useRef)(true);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ isLoadingSuggestions: isLoadingSuggestions }, { getSprintSuggestions: getSprintSuggestions, setIsLoadingSuggestions: setIsLoadingSuggestions }] = (0, $4kJKh.useSprintSuggestions)({
        getSuggestions: getSuggestions
    });
    const onCheckboxClick = (0, $eUqFw.useCallback)(()=>{
        setRestrictSprint(!restrictSprints);
        (0, $5C3wV.setCheckBoxValueInLocalStorage)((0, $5C3wV.EDIT_SPRINT_CHECKBOX_CACHE_KEY), !restrictSprints);
    }, [
        restrictSprints
    ]);
    const componentProps = (0, $eUqFw.useMemo)(()=>({
            isChecked: restrictSprints,
            onChange: onCheckboxClick,
            projectKey: projectKey
        }), [
        restrictSprints,
        projectKey,
        onCheckboxClick
    ]);
    const handleSuggestions = (0, $eUqFw.useCallback)((results, query)=>{
        if (lastQuery.current === query) {
            const transformSuggestions = useTransformSuggestions || (0, $cbDYy.transformSuggestions);
            const response = transformSuggestions(results, formatMessage);
            if (onPostTransformSuggestions) onPostTransformSuggestions(response, query);
            setSuggestions(response);
            if (query === '') setDefaultSuggestions(response);
        }
    }, [
        formatMessage,
        useTransformSuggestions,
        onPostTransformSuggestions
    ]);
    const getFailedFetchMessage = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jM2Oz.FailedFetchOptionWrapper), null, formatMessage((0, $gKEgR.default).failedFetch)), [
        formatMessage
    ]);
    const fetchSuggestions = (0, $eUqFw.useCallback)(async (query = '')=>{
        try {
            let response;
            if (restrictSprints && projectKey) response = await getSprintSuggestions(autoCompleteUrl, query, projectKey);
            else response = await getSprintSuggestions(autoCompleteUrl, query);
            handleSuggestions(response, query);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setHasLastFetchFailed(true);
            const failedOption = [
                {
                    label: getFailedFetchMessage(),
                    value: '',
                    isDisabled: true
                }
            ];
            setSuggestions(failedOption);
        }
    }, [
        autoCompleteUrl,
        restrictSprints,
        projectKey,
        getFailedFetchMessage,
        getSprintSuggestions,
        handleSuggestions
    ]);
    (0, $eUqFw.useMemo)(()=>{
        if (fetchSuggestionsOnMount) {
            if (!options && !defaultSuggestions) {
                setIsLoadingSuggestions(true);
                fetchSuggestions();
            } else if (options && !defaultSuggestions) {
                setDefaultSuggestions(options);
                setSuggestions(options);
            } else {
                lastQuery.current = '';
                setIsLoadingSuggestions(true);
                fetchSuggestions();
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedFetchSuggestions = (0, $eUqFw.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(fetchSuggestions, $f65c4424ed3ef430$export$251bdbdbce9550ea), [
        restrictSprints
    ]);
    const getNoOptionsMessage = (0, $eUqFw.useCallback)(()=>noOptionsMessage !== undefined ? noOptionsMessage : formatMessage((0, $gKEgR.default).empty), [
        formatMessage,
        noOptionsMessage
    ]);
    const getLoadingMessage = (0, $eUqFw.useCallback)(()=>loadingMessage !== undefined ? loadingMessage : formatMessage((0, $gKEgR.default).loading), [
        formatMessage,
        loadingMessage
    ]);
    const filterOption = (0, $eUqFw.useCallback)((option, query)=>{
        if (hasLastFetchFailed) // If the fetch has failed, we will show a disabled option to indicate the error to users
        return true;
        return (0, $g6sIQ.filterOptionByLabelAndFilterValues)(option, query || '');
    }, [
        hasLastFetchFailed
    ]);
    const onQueryChange = (0, $eUqFw.useCallback)((query)=>{
        debouncedFetchSuggestions.cancel();
        setHasLastFetchFailed(false);
        if (query) {
            lastQuery.current = query;
            setIsLoadingSuggestions(true);
            debouncedFetchSuggestions(query);
        } else {
            lastQuery.current = '';
            setIsLoadingSuggestions(false);
            setSuggestions(defaultSuggestions);
        }
    }, [
        debouncedFetchSuggestions,
        defaultSuggestions,
        setIsLoadingSuggestions,
        setSuggestions
    ]);
    const onSelectFocus = (0, $eUqFw.useCallback)((e)=>{
        if (!(0, $iXRIr.isBehaviourCommonForAllFieldsInNewGic)()) setMenuIsOpen(true);
        if (!((0, $iXRIr.isBehaviourCommonForAllFieldsInNewGic)() && suggestions)) {
            setIsLoadingSuggestions(true);
            fetchSuggestions('');
        }
        onFocus && onFocus(e);
    }, [
        fetchSuggestions,
        onFocus,
        setIsLoadingSuggestions,
        suggestions
    ]);
    const onSelectBlur = (0, $eUqFw.useCallback)((e)=>{
        if (!(0, $iXRIr.isBehaviourCommonForAllFieldsInNewGic)()) setMenuIsOpen(false);
        onBlur && onBlur(e);
    }, [
        onBlur
    ]);
    const onValueChange = (0, $eUqFw.useCallback)((newValues)=>{
        if (!(0, $iXRIr.isBehaviourCommonForAllFieldsInNewGic)()) setMenuIsOpen(false);
        // We're passing in suggestions for validation
        // e.g., if selected sprint is active and will affect the issue
        onChange && onChange(newValues, suggestions);
    }, [
        onChange,
        suggestions
    ]);
    const menuPosition = isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined;
    // Fetch the suggestions again if user toggles the checkbox
    (0, $eUqFw.useEffect)(()=>{
        if (!isInitialMount.current) {
            setIsLoadingSuggestions(true);
            debouncedFetchSuggestions(lastQuery.current);
        }
        isInitialMount.current = false;
    }, [
        restrictSprints,
        debouncedFetchSuggestions,
        setIsLoadingSuggestions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cx3nD.default), {
        inputId: inputId,
        isRequired: isRequired,
        isClearable: true,
        hideSelectedOptions: true,
        autoFocus: autoFocus,
        fieldId: fieldId,
        options: suggestions,
        value: value,
        onBlur: onSelectBlur,
        ...(0, $iXRIr.isBehaviourCommonForAllFieldsInNewGic)() ? {} : {
            menuIsOpen: menuIsOpen
        },
        menuPosition: menuPosition,
        componentsProps: projectKey ? componentProps : undefined,
        components: projectKey ? {
            Menu: $9SGuZ.default
        } : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        styles: (0, $4NcaX.defaultSelectStyles),
        onFocus: onSelectFocus,
        noOptionsMessage: getNoOptionsMessage,
        closeMenuOnScroll: onCloseMenuOnScroll,
        loadingMessage: getLoadingMessage,
        placeholder: formatMessage((0, $gKEgR.default).placeholder),
        onInputChange: onQueryChange,
        onChange: onValueChange,
        spacing: spacing,
        isLoading: (0, $iXRIr.isBehaviourCommonForAllFieldsInNewGic)() ? isLoadingSuggestions : menuIsOpen && isLoadingSuggestions,
        filterOption: filterOption,
        formatOptionLabel: (0, $bKilX.formatOptionLabel),
        validationState: isInvalid === true ? 'error' : null,
        isDisabled: isDisabled,
        openMenuOnFocus: openMenuOnFocus
    });
};
var $f65c4424ed3ef430$export$2e2bcd8739ae039 = $f65c4424ed3ef430$var$SprintEdit;

});
parcelRegister("cx3nD", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0fe507d86e7c625$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $hompL = parcelRequire("hompL");

var $28t3A = parcelRequire("28t3A");

var $8uNQc = parcelRequire("8uNQc");

var $1ybV0 = parcelRequire("1ybV0");

var $azx3n = parcelRequire("azx3n");

var $g8JvH = parcelRequire("g8JvH");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $c3dTh = parcelRequire("c3dTh");
const $f0fe507d86e7c625$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE = 20;
const $f0fe507d86e7c625$var$analyticsProps = {
    onChange: 'valueChanged',
    onInputChange: 'inputChanged',
    onMenuOpen: 'menuOpened',
    onMenuClose: 'menuClosed'
};
const $f0fe507d86e7c625$export$53574ab050410077 = (0, $g8JvH.AnalyticsEventToProps)('select', $f0fe507d86e7c625$var$analyticsProps)((0, $28t3A.default));
const $f0fe507d86e7c625$var$CreatableSelectWithAnalyticsView = (props)=>{
    const { fieldId: fieldId, isLoading: isLoading, onChange: onChange, onInputChange: onInputChange, options: options = [], value: value, sessionId: customSessionId, canCreateNewItem: canCreateNewItem = false, inputId: inputId, isRequired: isRequired } = props;
    const hasSessionStarted = (0, $eUqFw.useRef)(false);
    const sessionId = (0, $eUqFw.useRef)(customSessionId);
    const sessionStartedAt = (0, $eUqFw.useRef)(0);
    const endSessionRef = (0, $eUqFw.useRef)(undefined);
    const [queryAtSetValue, setQueryAtSetValue] = (0, $eUqFw.useState)('');
    const [savedQuery, setSavedQuery] = (0, $eUqFw.useState)('');
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const flatOptions = (0, $eUqFw.useMemo)(()=>(0, $c3dTh.flattenOptions)(options), [
        options
    ]);
    const getAnalyticsAttributes = (0, $eUqFw.useCallback)((query)=>{
        const selectedOptions = !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(value) ? value : [];
        let filteredOptions = (0, $c3dTh.filterOptions)(flatOptions, query);
        const optionsLength = filteredOptions.length;
        // truncate to reduce payload size
        filteredOptions = filteredOptions.slice(0, $f0fe507d86e7c625$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE);
        const safeFilteredOptions = (0, $c3dTh.getSafeOptionsForAnalytics)(filteredOptions);
        return {
            inputId: inputId,
            required: isRequired,
            fieldId: fieldId,
            isLoading: isLoading,
            optionsLength: optionsLength,
            componentName: 'select',
            // TODO: update the lib's version after the bump
            packageName: '@atlaskit/select',
            optionValuesSafeForAnalytics: false,
            options: safeFilteredOptions,
            optionsLengths: (0, $c3dTh.getOptionValuesLengths)(filteredOptions),
            queryLength: query.length,
            queryHash: query === '' ? query : (0, $azx3n.memoizedHashString)(query),
            selectedOptions: (0, $c3dTh.getSafeOptionsForAnalytics)(selectedOptions),
            selectedOptionsLengths: (0, $c3dTh.getOptionValuesLengths)(selectedOptions),
            sessionId: sessionId.current,
            truncationSize: $f0fe507d86e7c625$var$ANALYTICS_PAYLOAD_TRUNCATION_SIZE
        };
    }, [
        value,
        flatOptions,
        inputId,
        isRequired,
        fieldId,
        isLoading
    ]);
    const getItemOrder = (0, $eUqFw.useCallback)((selectedItem)=>{
        const matchedIndexes = [];
        flatOptions.forEach((option, index)=>{
            if (option.value === selectedItem.value) matchedIndexes.push(index);
        });
        return matchedIndexes.length > 0 ? matchedIndexes[0] : -1;
    }, [
        flatOptions
    ]);
    const fireUIAnalyticsEvent = (0, $eUqFw.useCallback)((analyticsEvent, query, extraAttributes)=>{
        const attributes = {
            ...getAnalyticsAttributes(query),
            ...extraAttributes
        };
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, attributes);
    }, [
        getAnalyticsAttributes
    ]);
    const fireTrackAnalyticsEvent = (0, $eUqFw.useCallback)((analyticsEvent, action, actionSubject, extraAttributes)=>{
        const attributes = {
            ...getAnalyticsAttributes(savedQuery),
            ...extraAttributes
        };
        (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, `${actionSubject} ${action}`, attributes);
    }, [
        getAnalyticsAttributes,
        savedQuery
    ]);
    const startSession = (0, $eUqFw.useCallback)(()=>{
        if (sessionId.current === undefined) sessionId.current = (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4();
        sessionStartedAt.current = (0, $8uNQc.default).now();
        fireTrackAnalyticsEvent(createAnalyticsEvent({
            action: 'started'
        }), 'started', 'optionSelectionSession');
    }, [
        createAnalyticsEvent,
        fireTrackAnalyticsEvent,
        sessionId,
        sessionStartedAt
    ]);
    const endSession = (0, $eUqFw.useCallback)(()=>{
        if (sessionId.current !== undefined) {
            const currentStartedAt = sessionStartedAt.current;
            const elapsedTime = currentStartedAt === 0 ? (0, $8uNQc.default).now() - currentStartedAt : 0;
            fireTrackAnalyticsEvent(createAnalyticsEvent({
                action: 'ended'
            }), 'ended', 'optionSelectionSession', {
                elapsedTime: elapsedTime
            });
        }
        sessionId.current = undefined;
        sessionStartedAt.current = 0;
    }, [
        createAnalyticsEvent,
        fireTrackAnalyticsEvent,
        sessionId,
        sessionStartedAt
    ]);
    const restartSession = (0, $eUqFw.useCallback)(()=>{
        endSession();
        startSession();
    }, [
        endSession,
        startSession
    ]);
    const fireInputChangedEvent = (0, $eUqFw.useCallback)((query, actionMeta, analyticsEvent)=>{
        if (actionMeta.action === 'set-value') // Save query for option changed analytic
        setQueryAtSetValue(savedQuery);
        setSavedQuery(query);
        analyticsEvent.update({
            action: 'changed',
            actionSubject: 'filter'
        });
        fireUIAnalyticsEvent(analyticsEvent, query);
    }, [
        fireUIAnalyticsEvent,
        savedQuery,
        setSavedQuery,
        setQueryAtSetValue
    ]);
    const fireOptionCreatedEvent = (0, $eUqFw.useCallback)((option, analyticsEvent)=>{
        analyticsEvent.update({
            action: 'created',
            actionSubject: 'option'
        });
        const oldSessionId = sessionId.current;
        restartSession();
        fireUIAnalyticsEvent(analyticsEvent, queryAtSetValue, {
            selectedOption: (0, $c3dTh.getSafeValue)(option.value),
            sessionId: oldSessionId
        });
    }, [
        fireUIAnalyticsEvent,
        queryAtSetValue,
        restartSession,
        sessionId
    ]);
    const fireOptionRemovedEvent = (0, $eUqFw.useCallback)((option, analyticsEvent)=>{
        analyticsEvent.update({
            action: 'removed',
            actionSubject: 'option'
        });
        fireUIAnalyticsEvent(analyticsEvent, savedQuery, {
            removedItem: option ? (0, $c3dTh.getSafeValue)(option.value) : undefined
        });
    }, [
        fireUIAnalyticsEvent,
        savedQuery
    ]);
    const fireOptionSelectedEvent = (0, $eUqFw.useCallback)((option, analyticsEvent)=>{
        analyticsEvent.update({
            action: 'changed',
            actionSubject: 'option'
        });
        const oldSessionId = sessionId.current;
        restartSession();
        fireUIAnalyticsEvent(analyticsEvent, queryAtSetValue, {
            selectedOption: (0, $c3dTh.getSafeValue)(option.value),
            selectedOptionLength: option.value !== null ? `${option.value}`.length : 0,
            selectedOrder: getItemOrder(option),
            sessionId: oldSessionId
        });
    }, [
        fireUIAnalyticsEvent,
        getItemOrder,
        queryAtSetValue,
        restartSession,
        sessionId
    ]);
    const onChangeWithAnalytics = (0, $eUqFw.useCallback)((selectedOptionOrOptions, actionMeta, analyticsEvent)=>{
        const selectedOption = Array.isArray(selectedOptionOrOptions) ? selectedOptionOrOptions[selectedOptionOrOptions.length - 1] : selectedOptionOrOptions;
        switch(actionMeta.action){
            case 'create-option':
                if (selectedOption !== null) fireOptionCreatedEvent(selectedOption, analyticsEvent);
                break;
            case 'remove-value':
            case 'pop-value':
            case 'deselect-option':
                fireOptionRemovedEvent(actionMeta.removedValue || actionMeta.option, analyticsEvent);
                break;
            case 'select-option':
                if (selectedOption !== null) fireOptionSelectedEvent(selectedOption, analyticsEvent);
                break;
            default:
                break;
        }
        onChange && onChange(selectedOptionOrOptions, actionMeta);
    }, [
        fireOptionCreatedEvent,
        fireOptionRemovedEvent,
        fireOptionSelectedEvent,
        onChange
    ]);
    const onInputChangeWithAnalytics = (0, $eUqFw.useCallback)((query, actionMeta, analyticsEvent)=>{
        if (actionMeta.action === 'input-change' || actionMeta.action === 'set-value') fireInputChangedEvent(query, actionMeta, analyticsEvent);
        onInputChange && onInputChange(query, sessionId.current);
    }, [
        fireInputChangedEvent,
        onInputChange,
        sessionId
    ]);
    const isValidNewOption = (0, $eUqFw.useCallback)(()=>!!canCreateNewItem, [
        canCreateNewItem
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!hasSessionStarted.current) {
            startSession();
            fireInputChangedEvent('', {
                action: 'fake-action'
            }, createAnalyticsEvent({}));
            hasSessionStarted.current = true;
        }
    }, [
        createAnalyticsEvent,
        fireInputChangedEvent,
        startSession
    ]);
    (0, $eUqFw.useEffect)(()=>{
        endSessionRef.current = endSession;
    }, [
        endSession
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            endSessionRef.current && endSessionRef.current();
        }, // In order to avoid triggering this cleanup when the endSession callback is updated by adding a dependency to endSession here,
    // we call it via a ref instead
    []);
    const passRequiredProp = (0, $1ybV0.ff)('pass-required-prop-to-createble-select-from-sprint-field_yvnwn', false);
    const { isRequired: required, ...propsWithoutRequired } = props;
    const propsToSpread = passRequiredProp ? propsWithoutRequired : props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f0fe507d86e7c625$export$53574ab050410077, {
        ...propsToSpread,
        ...passRequiredProp ? {
            required: isRequired
        } : {},
        onChange: onChangeWithAnalytics,
        onInputChange: onInputChangeWithAnalytics,
        isValidNewOption: isValidNewOption
    });
};
var $f0fe507d86e7c625$export$2e2bcd8739ae039 = $f0fe507d86e7c625$var$CreatableSelectWithAnalyticsView;

});
parcelRegister("c3dTh", function(module, exports) {

$parcel$export(module.exports, "getSafeValue", () => $9e457b0d8a407f15$export$d05672fd1312a6d);
$parcel$export(module.exports, "getSafeOptionsForAnalytics", () => $9e457b0d8a407f15$export$fde3d804891b8254);
$parcel$export(module.exports, "flattenOptions", () => $9e457b0d8a407f15$export$7baa7c13b358b002);
$parcel$export(module.exports, "getOptionValuesLengths", () => $9e457b0d8a407f15$export$e2e167245697ed4e);
$parcel$export(module.exports, "filterOptions", () => $9e457b0d8a407f15$export$60d56ed3961c839c);

var $9OdO2 = parcelRequire("9OdO2");

var $azx3n = parcelRequire("azx3n");
const $9e457b0d8a407f15$export$d05672fd1312a6d = (val)=>(0, $azx3n.memoizedHashString)(val.toString()).toString();
const $9e457b0d8a407f15$export$fde3d804891b8254 = (items)=>{
    const itemsToFilter = Array.isArray(items) ? items : [
        items
    ];
    return itemsToFilter.filter((item)=>item.value).map(({ value: value })=>$9e457b0d8a407f15$export$d05672fd1312a6d(value));
};
const $9e457b0d8a407f15$export$7baa7c13b358b002 = (optionGroups)=>(0, (/*@__PURE__*/$parcel$interopDefault($9OdO2)))(optionGroups.map((optionOrGroup)=>optionOrGroup.options ? optionOrGroup.options : [
            optionOrGroup
        ]));
const $9e457b0d8a407f15$export$e2e167245697ed4e = (items)=>{
    const itemsToFilter = Array.isArray(items) ? items : [
        items
    ];
    return itemsToFilter.filter((item)=>item.value).map(({ value: value })=>value != null ? `${value}`.length : 0);
};
const $9e457b0d8a407f15$export$60d56ed3961c839c = (options, query)=>options.filter((option)=>typeof option.value === 'string' && option.value.toLowerCase().includes((query || '').toLowerCase()) || typeof option.label === 'string' && option.label.toLowerCase().includes((query || '').toLowerCase()));

});


parcelRegister("cbDYy", function(module, exports) {

$parcel$export(module.exports, "hasState", () => $8a075e979a5ccce6$export$d2fec4e2fc5f065a);
$parcel$export(module.exports, "findSprintWithState", () => $8a075e979a5ccce6$export$fb6b70a9c996212b);
$parcel$export(module.exports, "mapSprintOptionToData", () => $8a075e979a5ccce6$export$fb7a6b38a05bd2b7);
$parcel$export(module.exports, "transformSuggestions", () => $8a075e979a5ccce6$export$1d0ee4320c26fb60);

var $aJ90T = parcelRequire("aJ90T");

var $iciya = parcelRequire("iciya");
const $8a075e979a5ccce6$export$e6c9132cef5ee76f = (sprintId)=>`/secure/GHGoToBoard.jspa?sprintId=${sprintId}`;
const $8a075e979a5ccce6$export$d2fec4e2fc5f065a = (state)=>(sprint)=>sprint.state !== undefined && sprint.state.toLowerCase() === state.toLowerCase();
const $8a075e979a5ccce6$export$fb6b70a9c996212b = (sprints, state)=>{
    if (!sprints) return undefined;
    return sprints.find($8a075e979a5ccce6$export$d2fec4e2fc5f065a(state));
};
const $8a075e979a5ccce6$export$d63c3784bf3852ca = (state)=>{
    if (state !== undefined) {
        const stateKey = state.toUpperCase();
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly ACTIVE: "ACTIVE"; readonly CLOSED: "CLOSED"; readonly FUTURE: "FUTURE"; }'.
        return (0, $aJ90T.SPRINT_STATES)[stateKey];
    }
    return undefined;
};
const $8a075e979a5ccce6$export$fb7a6b38a05bd2b7 = ({ value: value })=>Number(value);
const $8a075e979a5ccce6$export$fbb2e1641ffac377 = (option)=>({
        id: Number(option.value),
        name: String(option.label),
        state: option.state,
        // mapSprintValueToOption ensures there will always be a boardId
        boardId: Number(option.data?.boardId) || 0
    });
const $8a075e979a5ccce6$export$b9928e57702db7d9 = (items)=>items.map($8a075e979a5ccce6$export$fbb2e1641ffac377);
const $8a075e979a5ccce6$export$cbdf60de7f2200e7 = (option)=>({
        id: Number(option.value),
        boardName: option.description,
        name: String(option.label),
        // mapSprintSuggestionToOption ensures there will always be a state
        // @ts-expect-error - TS2322 - Type 'SprintState | undefined' is not assignable to type 'SprintState'.
        stateKey: $8a075e979a5ccce6$export$d63c3784bf3852ca(option.state),
        // mapSprintSuggestionToOption ensures there will always be a date
        date: String(option.data?.date)
    });
const $8a075e979a5ccce6$export$db10bf437c75c497 = (items)=>items.map($8a075e979a5ccce6$export$cbdf60de7f2200e7);
const $8a075e979a5ccce6$export$15c97379ebef6b30 = (sprint)=>({
        id: sprint.id,
        description: sprint.boardName,
        label: sprint.name,
        state: sprint.stateKey,
        value: sprint.id,
        data: {
            date: sprint.date,
            fromCache: sprint.fromCache
        }
    });
const $8a075e979a5ccce6$export$c1cb9e6f1beaee0d = (items)=>items.map($8a075e979a5ccce6$export$15c97379ebef6b30);
const $8a075e979a5ccce6$export$ce3013ece3dbf252 = (sprint)=>({
        id: sprint.id,
        name: sprint.name,
        href: $8a075e979a5ccce6$export$e6c9132cef5ee76f(sprint.id),
        endDate: sprint.endDate || ''
    });
const $8a075e979a5ccce6$export$755a6a3c6172f7e = (sprint)=>({
        label: sprint.name,
        value: sprint.id,
        href: $8a075e979a5ccce6$export$e6c9132cef5ee76f(sprint.id),
        state: $8a075e979a5ccce6$export$d63c3784bf3852ca(sprint.state),
        data: {
            boardId: sprint.boardId,
            date: sprint.startDate
        }
    });
const $8a075e979a5ccce6$export$cbcaba92baa2e404 = (items)=>items.map($8a075e979a5ccce6$export$755a6a3c6172f7e);
const $8a075e979a5ccce6$export$1d0ee4320c26fb60 = (suggestionsFromServer, formatMessage)=>{
    const serverSuggestions = suggestionsFromServer.suggestions || [];
    const allMatches = suggestionsFromServer.allMatches || [];
    const allItems = serverSuggestions.concat(allMatches);
    const activeItems = allItems.filter((sprint)=>sprint.stateKey === (0, $aJ90T.ACTIVE_SPRINT_STATE)).map($8a075e979a5ccce6$export$15c97379ebef6b30);
    const futureItems = allItems.filter((sprint)=>sprint.stateKey === (0, $aJ90T.FUTURE_SPRINT_STATE)).map($8a075e979a5ccce6$export$15c97379ebef6b30);
    const sprints = [
        {
            label: formatMessage((0, $iciya.default).activeSprints),
            options: activeItems
        },
        {
            label: formatMessage((0, $iciya.default).futureSprints),
            options: futureItems
        }
    ];
    return sprints;
};

});
parcelRegister("aJ90T", function(module, exports) {

$parcel$export(module.exports, "ACTIVE_SPRINT_STATE", () => $d6857bb95b01f76c$export$3ebc9911a79d714f);
$parcel$export(module.exports, "FUTURE_SPRINT_STATE", () => $d6857bb95b01f76c$export$863e42082c6bde5);
$parcel$export(module.exports, "CLOSED_SPRINT_STATE", () => $d6857bb95b01f76c$export$86cdef09a89e8c4b);
$parcel$export(module.exports, "SPRINT_STATES", () => $d6857bb95b01f76c$export$73a0206a4dc59760);
const $d6857bb95b01f76c$export$3ebc9911a79d714f = 'ACTIVE';
const $d6857bb95b01f76c$export$863e42082c6bde5 = 'FUTURE';
const $d6857bb95b01f76c$export$86cdef09a89e8c4b = 'CLOSED';
const $d6857bb95b01f76c$export$73a0206a4dc59760 = {
    ACTIVE: $d6857bb95b01f76c$export$3ebc9911a79d714f,
    CLOSED: $d6857bb95b01f76c$export$86cdef09a89e8c4b,
    FUTURE: $d6857bb95b01f76c$export$863e42082c6bde5
};

});

parcelRegister("iciya", function(module, exports) {

$parcel$export(module.exports, "default", () => $2522434b5de850c0$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $2522434b5de850c0$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    activeSprints: {
        "id": "issue-field-sprint.common.active-sprints",
        "defaultMessage": "Active"
    },
    futureSprints: {
        "id": "issue-field-sprint.common.future-sprints",
        "defaultMessage": "Future"
    },
    recentSprints: {
        "id": "issue-field-sprint.common.recent-sprints",
        "defaultMessage": "Recent sprints"
    }
});

});


parcelRegister("iXRIr", function(module, exports) {

$parcel$export(module.exports, "isBehaviourCommonForAllFieldsInNewGic", () => $e0e7574f8eede218$export$b2f73d54757eb059);
/**
 * Feature flags convention: go/frontend-feature-flags
 */ 
var $1ybV0 = parcelRequire("1ybV0");
const $e0e7574f8eede218$export$b2f73d54757eb059 = ()=>(0, $1ybV0.ff)('common-field-behaviour-for-new-gic_q9mgt', false);

});

parcelRegister("4kJKh", function(module, exports) {

$parcel$export(module.exports, "useSprintSuggestions", () => $9a76b79f86a878bd$export$16d0ab78a0b529dc);

var $eUqFw = parcelRequire("eUqFw");

var $53ciZ = parcelRequire("53ciZ");

var $lRmyA = parcelRequire("lRmyA");

const $9a76b79f86a878bd$var$defaultParams = (0, $53ciZ.stringify)({
    maxActiveSprints: (0, $db8abf61fe4d4c9b$export$7112c73100e3ee45),
    maxResults: (0, $db8abf61fe4d4c9b$export$f6b2881bc1090cea)
});
const $9a76b79f86a878bd$export$6945d45e210d19eb = async (autoCompleteUrl, query, projectKey)=>{
    let queryString;
    if (projectKey !== null && projectKey !== undefined) queryString = `${autoCompleteUrl}${encodeURIComponent(query)}&projectKey=${encodeURIComponent(projectKey)}&${$9a76b79f86a878bd$var$defaultParams}`;
    else queryString = `${autoCompleteUrl}${encodeURIComponent(query)}&${$9a76b79f86a878bd$var$defaultParams}`;
    return (0, $lRmyA.performGetRequest)(queryString);
};
const $9a76b79f86a878bd$export$16d0ab78a0b529dc = (props)=>{
    const { getSuggestions: getSuggestions = $9a76b79f86a878bd$export$6945d45e210d19eb } = props || {};
    const [isLoadingSuggestions, setIsLoadingSuggestions] = (0, $eUqFw.useState)(false);
    const getSprintSuggestions = (0, $eUqFw.useCallback)(async (autoCompleteUrl, query, projectKey)=>{
        try {
            const response = await getSuggestions(autoCompleteUrl, query, projectKey);
            setIsLoadingSuggestions(false);
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setIsLoadingSuggestions(false);
            throw error;
        }
    }, [
        getSuggestions,
        setIsLoadingSuggestions
    ]);
    const actions = (0, $eUqFw.useMemo)(()=>({
            getSprintSuggestions: getSprintSuggestions,
            setIsLoadingSuggestions: setIsLoadingSuggestions
        }), [
        getSprintSuggestions,
        setIsLoadingSuggestions
    ]);
    return [
        {
            isLoadingSuggestions: isLoadingSuggestions
        },
        actions
    ];
};

});
const $db8abf61fe4d4c9b$export$f27038d72181627e = '/rest/greenhopper/1.0/sprint/picker?query=';
const $db8abf61fe4d4c9b$export$7112c73100e3ee45 = 5;
const $db8abf61fe4d4c9b$export$f6b2881bc1090cea = 10;


parcelRegister("5C3wV", function(module, exports) {

$parcel$export(module.exports, "EDIT_SPRINT_CHECKBOX_CACHE_KEY", () => $0fe4293f03bf1f14$export$90fd8fcc9388370d);
$parcel$export(module.exports, "getCheckboxValueFromLocalStorage", () => $0fe4293f03bf1f14$export$b6ec857d138d143b);
$parcel$export(module.exports, "setCheckBoxValueInLocalStorage", () => $0fe4293f03bf1f14$export$1750bf12ee05e0ac);

var $53ciZ = parcelRequire("53ciZ");
const $0fe4293f03bf1f14$var$getViewMode = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($53ciZ))).parse(window.location.search).view || '';
const $0fe4293f03bf1f14$export$d5e150c1e3186bd1 = ()=>$0fe4293f03bf1f14$var$getViewMode().includes('planning');
const $0fe4293f03bf1f14$export$90fd8fcc9388370d = 'edit_sprint_cache_value';
const $0fe4293f03bf1f14$export$b6ec857d138d143b = (key)=>{
    const value = window.localStorage?.getItem(key);
    return value ? JSON.parse(value) : true;
};
const $0fe4293f03bf1f14$export$1750bf12ee05e0ac = (key, value)=>{
    try {
        // @ts-expect-error - TS2345 - Argument of type 'boolean' is not assignable to parameter of type 'string'.
        window.localStorage.setItem(key, value);
    } catch  {
    // do nothing
    }
};

});

parcelRegister("9SGuZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $949140d940a171ec$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bT7k5 = parcelRequire("bT7k5");

var $jQxSL = parcelRequire("jQxSL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fsrhm = parcelRequire("fsrhm");

var $c4gPs = parcelRequire("c4gPs");
const $949140d940a171ec$var$Menu = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { children: children, ...restProps } = props;
    const isChecked = props.selectProps?.componentsProps?.isChecked || false;
    const projectKey = props.selectProps?.componentsProps?.projectKey || null;
    const label = formatMessage((0, $fsrhm.default).checkboxLabel, {
        projectKey: projectKey
    });
    const onKeyDown = (0, $eUqFw.useCallback)((event)=>{
        // stopping propagation when focus moves to checkbox because select already binded with space and enter for selection
        if (event.key === ' ') event.stopPropagation();
    }, []);
    return(// @ts-expect-error - TS2746 - This JSX tag's 'children' prop expects a single child of type 'ReactElement<any, string | JSXElementConstructor<any>>', but multiple children were provided.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Menu, restProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c4gPs.CheckboxWrapper), {
        onClick: props.selectProps?.componentsProps?.onChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
        onKeyDown: onKeyDown,
        isChecked: isChecked,
        size: "medium",
        label: label,
        testId: "issue-field-sprint.ui.edit.menu.checkbox"
    })), children)));
};
var // @ts-expect-error - TS2352 - Conversion of type '(props: Props) => JSX.Element' to type 'ReactNode' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$949140d940a171ec$export$2e2bcd8739ae039 = $949140d940a171ec$var$Menu;

});
parcelRegister("fsrhm", function(module, exports) {

$parcel$export(module.exports, "default", () => $a44e5d63af21206e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a44e5d63af21206e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    checkboxLabel: {
        "id": "issue-field-sprint.edit.menu.checkbox-label",
        "defaultMessage": "Only show sprints in this project ({projectKey})"
    }
});

});

parcelRegister("c4gPs", function(module, exports) {

$parcel$export(module.exports, "CheckboxWrapper", () => $eb0173849e3208ba$export$eef12940a6696c78);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $eb0173849e3208ba$export$eef12940a6696c78 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1bah1y6m _1yt41bs6 _n7zlpe8f _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});


parcelRegister("gKEgR", function(module, exports) {

$parcel$export(module.exports, "default", () => $94472aa97763d39f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $94472aa97763d39f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "issue-field-sprint.edit.placeholder",
        "defaultMessage": "Select sprint"
    },
    empty: {
        "id": "issue-field-sprint.edit.empty",
        "defaultMessage": "No matches found"
    },
    failedFetch: {
        "id": "issue-field-sprint.edit.failed-fetch",
        "defaultMessage": "Search failed. Please try again."
    },
    loading: {
        "id": "issue-field-sprint.edit.loading",
        "defaultMessage": "Searching..."
    }
});

});


parcelRegister("5dMG0", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e884aca5cec7e1e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $9e884aca5cec7e1e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    activeSprintSelectionWarningMessage: {
        "id": "issue-create-commons.sprint-field.active-sprint-selection-warning-message",
        "defaultMessage": "Creating this issue will affect the active sprint's scope"
    }
});

});


parcelRegister("a3FRc", function(module, exports) {

$parcel$export(module.exports, "default", () => $8245715f63eaa826$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3xOFI = parcelRequire("3xOFI");

var $icPhQ = parcelRequire("icPhQ");
var $6HoNR = parcelRequire("6HoNR");

var $lIor1 = parcelRequire("lIor1");

var $5TtxV = parcelRequire("5TtxV");
const $8245715f63eaa826$var$TextAreaField = (props)=>{
    const { width: width = '100%', fieldProps: { value: value = '', onChange: onChange, onBlur: onBlur, ...fieldProps }, error: error, autoFocus: autoFocus = false, isReadOnly: isReadOnly = false } = props;
    const onTextAreaChange = (e)=>{
        onChange(e.target.value);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3xOFI.default), {
        ...fieldProps,
        value: value,
        onChange: onTextAreaChange,
        onBlur: onBlur,
        isInvalid: Boolean(error),
        autoFocus: autoFocus,
        isDisabled: isReadOnly
    }));
};
var $8245715f63eaa826$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    validator: (0, $lIor1.validateString)
})(// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<TextAreaFieldConfig, string>, any>'.
$8245715f63eaa826$var$TextAreaField);

});
parcelRegister("3xOFI", function(module, exports) {

$parcel$export(module.exports, "default", () => $abebd97e0a4b55bd$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $xeS7R = parcelRequire("xeS7R");
const $abebd97e0a4b55bd$var$TextAreaEdit = (props)=>{
    const { isRequired: isRequired = false, isInvalid: isInvalid, value: value, placeholder: placeholder = '', onBlur: onBlur, onFocus: onFocus, onChange: onChange, minimumRows: minimumRows = 3, autoFocus: autoFocus = false, isDisabled: isDisabled = false, ...fieldProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $xeS7R.default), {
        ...fieldProps,
        isRequired: isRequired,
        placeholder: placeholder,
        value: value,
        autoFocus: autoFocus,
        onBlur: onBlur,
        onFocus: onFocus,
        onChange: onChange,
        isInvalid: isInvalid,
        minimumRows: minimumRows,
        isDisabled: isDisabled
    });
};
var $abebd97e0a4b55bd$export$2e2bcd8739ae039 = $abebd97e0a4b55bd$var$TextAreaEdit;

});
parcelRegister("xeS7R", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fe3143162b284fd$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $dkGpW = parcelRequire("dkGpW");
const $2fe3143162b284fd$var$packageName = undefined;
const $2fe3143162b284fd$var$packageVersion = undefined;
const $2fe3143162b284fd$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $2fe3143162b284fd$var$packageName,
    packageVersion: $2fe3143162b284fd$var$packageVersion
};
const $2fe3143162b284fd$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = (0, $dkGpW.borderWidth);
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $2fe3143162b284fd$var$InnerTextArea = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const ourRef = (0, $eUqFw.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, ...rest } = props;
    (0, $eUqFw.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $2fe3143162b284fd$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$2fe3143162b284fd$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$2fe3143162b284fd$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $eUqFw.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $2fe3143162b284fd$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const baseStyles = (0, $eUqFw.useMemo)(()=>(0, $dkGpW.getBaseStyles)({
            minimumRows: minimumRows,
            resize: resize,
            appearance: appearance,
            isMonospaced: isMonospaced,
            maxHeight: maxHeight
        }), [
        minimumRows,
        resize,
        appearance,
        isMonospaced,
        maxHeight
    ]);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-array-arguments, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    const textAreaStyles = /*#__PURE__*/ (0, $byn9U.css)([
        baseStyles,
        (0, $dkGpW.dynamicStyles)(appearance)
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        // TODO refactor to follow emotion styling rules
        // see: https://product-fabric.atlassian.net/browse/DSP-6060
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: textAreaStyles,
        ...rest
    });
});
/**
 * __Text area__
 *
 * A text area lets users enter long form text which spans over multiple lines.
 *
 * - [Examples](https://atlassian.design/components/textarea/examples)
 * - [Code](https://atlassian.design/components/textarea/code)
 * - [Usage](https://atlassian.design/components/textarea/usage)
 */ const $2fe3143162b284fd$var$TextArea = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $byn9U.jsx)($2fe3143162b284fd$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$2fe3143162b284fd$var$TextArea.displayName = 'TextArea';
var $2fe3143162b284fd$export$2e2bcd8739ae039 = $2fe3143162b284fd$var$TextArea;

});
parcelRegister("dkGpW", function(module, exports) {

$parcel$export(module.exports, "borderWidth", () => $ffa47244c710aa2a$export$12879c7697ed953d);
$parcel$export(module.exports, "getBaseStyles", () => $ffa47244c710aa2a$export$bff8031d86bb089);
$parcel$export(module.exports, "dynamicStyles", () => $ffa47244c710aa2a$export$98856a888ef36079);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $9rnqv = parcelRequire("9rnqv");
function $ffa47244c710aa2a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ffa47244c710aa2a$var$disabledRules = {
    backgroundColor: $9rnqv.disabledBackground,
    backgroundColorFocus: $9rnqv.disabledBackground,
    backgroundColorHover: $9rnqv.disabledBackground,
    borderColor: $9rnqv.disabledBorder,
    borderColorFocus: $9rnqv.defaultBorderColorFocus,
    textColor: $9rnqv.disabledTextColor
};
const $ffa47244c710aa2a$var$invalidRules = {
    borderColor: $9rnqv.invalidBorderColor,
    borderColorFocus: $9rnqv.defaultBorderColorFocus,
    backgroundColor: $9rnqv.defaultBackgroundColor,
    backgroundColorFocus: $9rnqv.defaultBackgroundColorFocus,
    backgroundColorHover: $9rnqv.defaultBackgroundColorHover
};
const $ffa47244c710aa2a$var$backgroundColor = {
    standard: $9rnqv.defaultBackgroundColor,
    subtle: $9rnqv.transparent,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$backgroundColorFocus = {
    standard: $9rnqv.defaultBackgroundColorFocus,
    subtle: $9rnqv.defaultBackgroundColorFocus,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$backgroundColorHover = {
    standard: $9rnqv.defaultBackgroundColorHover,
    subtle: $9rnqv.defaultBackgroundColorHover,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$borderColor = {
    standard: $9rnqv.defaultBorderColor,
    subtle: $9rnqv.transparent,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$borderColorFocus = {
    standard: $9rnqv.defaultBorderColorFocus,
    subtle: $9rnqv.defaultBorderColorFocus,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$borderColorHover = {
    standard: $9rnqv.defaultBorderColor,
    subtle: $9rnqv.subtleBorderColorHover,
    none: $9rnqv.transparent
};
const $ffa47244c710aa2a$var$lineHeightBase = 20;
const $ffa47244c710aa2a$var$lineHeightCompact = 16;
const $ffa47244c710aa2a$var$compactVerticalPadding = 2;
const $ffa47244c710aa2a$var$verticalPadding = 6;
const $ffa47244c710aa2a$var$horizontalPadding = 8;
const $ffa47244c710aa2a$var$transitionDuration = '0.2s';
const $ffa47244c710aa2a$var$fontFamily = "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)";
const $ffa47244c710aa2a$var$codeFontFamily = "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
const $ffa47244c710aa2a$export$12879c7697ed953d = 2;
// Safari puts on some difficult to remove styles, mainly for disabled inputs
// but we want full control so need to override them in all cases
const $ffa47244c710aa2a$var$overrideSafariDisabledStyles = {
    WebkitTextFillColor: 'unset',
    WebkitOpacity: '1'
};
const $ffa47244c710aa2a$var$borderBoxMinHeight = (minimumRows, borderHeight)=>{
    const contentHeight = $ffa47244c710aa2a$var$lineHeightBase * minimumRows;
    return contentHeight + $ffa47244c710aa2a$var$verticalPadding * 2 + borderHeight * 2;
};
const $ffa47244c710aa2a$var$borderBoxMinHeightCompact = (minimumRows, borderHeight)=>{
    const contentHeightCompact = $ffa47244c710aa2a$var$lineHeightCompact * minimumRows;
    return contentHeightCompact + $ffa47244c710aa2a$var$compactVerticalPadding * 2 + borderHeight * 2;
};
const $ffa47244c710aa2a$var$bgAndBorderColorStyles = (appearance)=>appearance && /*#__PURE__*/ (0, $byn9U.css)({
        '&:focus': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$backgroundColorFocus[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$borderColorFocus[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$ffa47244c710aa2a$var$borderColorFocus[appearance]}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$backgroundColor[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$borderColor[appearance]
        },
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid]:focus': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$invalidRules.backgroundColorFocus,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$invalidRules.borderColorFocus,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$ffa47244c710aa2a$var$invalidRules.borderColorFocus}`
        },
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-invalid]:not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$invalidRules.backgroundColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$invalidRules.borderColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$ffa47244c710aa2a$var$invalidRules.borderColor}`
        },
        // Disabled background and border styles should not be applied to components that
        // have either no background or transparent background to begin with
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...appearance === 'standard' ? {
            '&:disabled:focus': {
                backgroundColor: $ffa47244c710aa2a$var$disabledRules.backgroundColorFocus,
                borderColor: $ffa47244c710aa2a$var$disabledRules.borderColorFocus
            },
            '&:disabled:not(:focus)': {
                backgroundColor: $ffa47244c710aa2a$var$disabledRules.backgroundColor,
                borderColor: $ffa47244c710aa2a$var$disabledRules.borderColor
            }
        } : {}
    });
const $ffa47244c710aa2a$var$placeholderStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&::placeholder': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $9rnqv.placeholderTextColor
    },
    '&:disabled::placeholder': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $ffa47244c710aa2a$var$disabledRules.textColor
    }
});
const $ffa47244c710aa2a$var$hoverBackgroundAndBorderStyles = (appearance)=>appearance && /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:hover:not(:read-only):not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $ffa47244c710aa2a$var$backgroundColorHover[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $ffa47244c710aa2a$var$borderColorHover[appearance],
            '&:disabled': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: $ffa47244c710aa2a$var$disabledRules.backgroundColorHover
            },
            // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&[data-invalid]': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: $ffa47244c710aa2a$var$invalidRules.backgroundColorHover,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderColor: $ffa47244c710aa2a$var$invalidRules.borderColor,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$ffa47244c710aa2a$var$invalidRules.borderColor}`
            }
        }
    });
var $ffa47244c710aa2a$var$_ref = {
    name: "utehjx",
    styles: "resize:none"
};
var $ffa47244c710aa2a$var$_ref2 = {
    name: "bolgb9",
    styles: "resize:both"
};
const $ffa47244c710aa2a$var$resizeStyle = (resize)=>{
    if (resize === 'horizontal' || resize === 'vertical') // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $byn9U.css)({
        resize: resize
    });
    if (resize === 'auto') return $ffa47244c710aa2a$var$_ref2;
    return $ffa47244c710aa2a$var$_ref;
};
const $ffa47244c710aa2a$var$borderStyle = (appearance)=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderStyle: appearance === 'none' ? 'none' : 'solid'
    });
const $ffa47244c710aa2a$var$fontFamilyStyle = (isMonospaced)=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontFamily: isMonospaced ? $ffa47244c710aa2a$var$codeFontFamily : $ffa47244c710aa2a$var$fontFamily
    });
const $ffa47244c710aa2a$var$borderPaddingAndHeightStyles = (minimumRows = 1, appearance)=>{
    const borderWidth = appearance !== 'none' ? 1 : 2;
    const horizontalPaddingWithoutBorderWidth = $ffa47244c710aa2a$var$horizontalPadding - borderWidth;
    const borderHeight = borderWidth;
    return /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-compact]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            minHeight: $ffa47244c710aa2a$var$borderBoxMinHeightCompact(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            padding: `${$ffa47244c710aa2a$var$compactVerticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values
            lineHeight: $ffa47244c710aa2a$var$lineHeightCompact / 14
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not([data-compact])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            minHeight: $ffa47244c710aa2a$var$borderBoxMinHeight(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            padding: `${$ffa47244c710aa2a$var$verticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values
            lineHeight: $ffa47244c710aa2a$var$lineHeightBase / 14
        }
    });
};
const $ffa47244c710aa2a$var$staticStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'block',
    boxSizing: 'border-box',
    width: '100%',
    minWidth: 0,
    maxWidth: '100%',
    margin: 0,
    position: 'relative',
    flex: '1 1 100%',
    borderRadius: "var(--ds-border-radius, 3px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    borderWidth: 1,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    outline: 'none',
    overflow: 'auto',
    transition: `background-color ${$ffa47244c710aa2a$var$transitionDuration} ease-in-out,
               border-color ${$ffa47244c710aa2a$var$transitionDuration} ease-in-out`,
    wordWrap: 'break-word',
    '&:disabled': {
        cursor: 'not-allowed',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$ffa47244c710aa2a$var$overrideSafariDisabledStyles
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-ms-clear': {
        display: 'none'
    },
    '&:invalid': {
        boxShadow: 'none'
    }
});
const $ffa47244c710aa2a$export$bff8031d86bb089 = ({ minimumRows: minimumRows, resize: resize, appearance: appearance, isMonospaced: isMonospaced, maxHeight: maxHeight })=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$staticStyles, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$borderPaddingAndHeightStyles(minimumRows, appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$resizeStyle(resize), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$borderStyle(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$fontFamilyStyle(isMonospaced), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    {
        maxHeight: maxHeight
    });
const $ffa47244c710aa2a$export$98856a888ef36079 = (appearance)=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$bgAndBorderColorStyles(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$hoverBackgroundAndBorderStyles(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $ffa47244c710aa2a$var$placeholderStyles, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $9rnqv.textColor,
        '&:disabled': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: $ffa47244c710aa2a$var$disabledRules.textColor
        }
    });

});
parcelRegister("9rnqv", function(module, exports) {

$parcel$export(module.exports, "disabledBackground", () => $f5064939140dcbf4$export$ae3cba7672df0890);
$parcel$export(module.exports, "disabledBorder", () => $f5064939140dcbf4$export$fe505fe3c5edbdf6);
$parcel$export(module.exports, "invalidBorderColor", () => $f5064939140dcbf4$export$7f333bbf7ddab792);
$parcel$export(module.exports, "defaultBorderColor", () => $f5064939140dcbf4$export$dafd83031c202ca8);
$parcel$export(module.exports, "defaultBorderColorFocus", () => $f5064939140dcbf4$export$e8320c09dc1e4012);
$parcel$export(module.exports, "defaultBackgroundColor", () => $f5064939140dcbf4$export$b13414ee9ac9cae6);
$parcel$export(module.exports, "defaultBackgroundColorHover", () => $f5064939140dcbf4$export$bca15982c103d57b);
$parcel$export(module.exports, "defaultBackgroundColorFocus", () => $f5064939140dcbf4$export$21287e4b7f134f09);
$parcel$export(module.exports, "subtleBorderColorHover", () => $f5064939140dcbf4$export$a87538d56ee366ec);
$parcel$export(module.exports, "placeholderTextColor", () => $f5064939140dcbf4$export$5e076b2557ef7bbb);
$parcel$export(module.exports, "textColor", () => $f5064939140dcbf4$export$32f78bffcd82ff28);
$parcel$export(module.exports, "disabledTextColor", () => $f5064939140dcbf4$export$eb4a7d363eec53c8);
$parcel$export(module.exports, "transparent", () => $f5064939140dcbf4$export$f4d082c200a4b4b8);

var $PdmhA = parcelRequire("PdmhA");
const $f5064939140dcbf4$export$ae3cba7672df0890 = `var(--ds-background-disabled, ${(0, $PdmhA.N20)})`;
const $f5064939140dcbf4$export$fe505fe3c5edbdf6 = `var(--ds-border-disabled, ${(0, $PdmhA.N40)})`;
const $f5064939140dcbf4$export$7f333bbf7ddab792 = `var(--ds-border-danger, ${(0, $PdmhA.R400)})`;
const $f5064939140dcbf4$export$dafd83031c202ca8 = `var(--ds-border-input, ${(0, $PdmhA.N100)})`;
const $f5064939140dcbf4$export$e8320c09dc1e4012 = `var(--ds-border-focused, ${(0, $PdmhA.B200)})`;
const $f5064939140dcbf4$export$b13414ee9ac9cae6 = `var(--ds-background-input, ${(0, $PdmhA.N10)})`;
const $f5064939140dcbf4$export$bca15982c103d57b = `var(--ds-background-input-hovered, ${(0, $PdmhA.N30)})`;
const $f5064939140dcbf4$export$21287e4b7f134f09 = `var(--ds-background-input-pressed, ${(0, $PdmhA.N0)})`;
const $f5064939140dcbf4$export$a87538d56ee366ec = "var(--ds-border-input, transparent)";
const $f5064939140dcbf4$export$5e076b2557ef7bbb = `var(--ds-text-subtlest, ${(0, $PdmhA.N200)})`;
const $f5064939140dcbf4$export$32f78bffcd82ff28 = `var(--ds-text, ${(0, $PdmhA.N900)})`;
const $f5064939140dcbf4$export$eb4a7d363eec53c8 = `var(--ds-text-disabled, ${(0, $PdmhA.N70)})`;
const $f5064939140dcbf4$export$f4d082c200a4b4b8 = 'transparent';

});





parcelRegister("fKpo5", function(module, exports) {

$parcel$export(module.exports, "default", () => $145f54946b273072$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $guGTQ = parcelRequire("guGTQ");

var $ljNBY = parcelRequire("ljNBY");
const $145f54946b273072$var$TextField = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $guGTQ.default), {
        type: "text",
        ...props
    });
var $145f54946b273072$export$2e2bcd8739ae039 = $145f54946b273072$var$TextField;

});

parcelRegister("9LZ9B", function(module, exports) {

$parcel$export(module.exports, "default", () => $531cfc54e5b6818a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $guGTQ = parcelRequire("guGTQ");

var $5d2AR = parcelRequire("5d2AR");
const $531cfc54e5b6818a$var$UrlField = (props)=>{
    const { width: width = 350, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $guGTQ.default), {
        type: "url",
        width: width,
        ...rest
    });
};
var $531cfc54e5b6818a$export$2e2bcd8739ae039 = $531cfc54e5b6818a$var$UrlField;

});

parcelRegister("8JQyN", function(module, exports) {

$parcel$export(module.exports, "transformCmdbField", () => $488495349da900c5$export$3c3af8d272413d1c);
const $488495349da900c5$export$3c3af8d272413d1c = (options)=>options.map((option)=>({
            id: option.id,
            objectId: option.objectId,
            workspaceId: option.workspaceId
        }));

});

parcelRegister("i5YRy", function(module, exports) {

$parcel$export(module.exports, "transformToOptionValue", () => $07c7b256a725a010$export$d1480328df7a42bf);
$parcel$export(module.exports, "transformToOptions", () => $07c7b256a725a010$export$899758961952c638);
$parcel$export(module.exports, "transformToParentChildOptionMap", () => $07c7b256a725a010$export$575da772c90849b8);
$parcel$export(module.exports, "transformToServerValue", () => $07c7b256a725a010$export$6f0c6eec5b71d787);

var $jqvCZ = parcelRequire("jqvCZ");
const $07c7b256a725a010$export$d1480328df7a42bf = (serverValue)=>{
    if (!serverValue) return null;
    const { id: id, value: value, child: child } = serverValue;
    return {
        value: id,
        label: value,
        child: child && {
            value: child.id,
            label: child.value
        }
    };
};
const $07c7b256a725a010$export$899758961952c638 = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((values)=>values.map(({ id: id, value: value })=>({
            value: id,
            label: value
        })));
const $07c7b256a725a010$export$575da772c90849b8 = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((values)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    values.reduce((acc, { id: id, children: children })=>{
        acc[id] = children ? $07c7b256a725a010$export$899758961952c638(children) : [];
        return acc;
    }, {}));
const $07c7b256a725a010$export$6f0c6eec5b71d787 = (option)=>{
    if (!option) return null;
    const { label: label, value: value } = option;
    // @ts-expect-error - TS2339 - Property 'child' does not exist on type 'Option | ParentChildOption'.
    const child = option.child || undefined;
    return {
        id: value,
        value: label,
        child: child && {
            id: child.value,
            value: child.label
        }
    };
};

});

parcelRegister("e6t0U", function(module, exports) {

$parcel$export(module.exports, "transformSuggestions", () => $de8f59646b6bba78$export$1d0ee4320c26fb60);
$parcel$export(module.exports, "mapEpicLinkOptionToData", () => $de8f59646b6bba78$export$2d8fd73a87ecc4de);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $tgbCK = parcelRequire("tgbCK");

var $g0g8z = parcelRequire("g0g8z");

var $cfxst = parcelRequire("cfxst");

var $5cl49 = parcelRequire("5cl49");
const $de8f59646b6bba78$export$b00899e73680c477 = (color)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5cl49.ColorPatch), {
        color: color
    });
const $de8f59646b6bba78$export$9227063fc962e54 = (epic)=>{
    const color = (0, $tgbCK.MAP_FROM_SERVER_COLOR)[epic.issueColor.key];
    return {
        color: color,
        label: epic.summary,
        value: epic.key,
        id: epic.id.toString(),
        description: epic.key,
        elemBefore: $de8f59646b6bba78$export$b00899e73680c477(color),
        filterValues: [
            epic.summary,
            epic.key
        ],
        isDone: epic.done
    };
};
const $de8f59646b6bba78$export$1d0ee4320c26fb60 = (response, formatMessage)=>{
    const label = (0, $g0g8z.isEpicLinkFieldRenamedToParent)() ? formatMessage((0, $cfxst.default).allIssues) : formatMessage((0, $cfxst.default).allEpics);
    const epicLists = response.values || [];
    const epicLink = [
        {
            label: label,
            options: epicLists.map($de8f59646b6bba78$export$9227063fc962e54)
        }
    ];
    return epicLink;
};
const $de8f59646b6bba78$export$2d8fd73a87ecc4de = ({ value: value })=>value;

});
parcelRegister("g0g8z", function(module, exports) {

$parcel$export(module.exports, "isEpicLinkFieldRenamedToParent", () => $6236175baa4613d9$export$3daacb605a35d65c);

var $1ybV0 = parcelRequire("1ybV0");
const $6236175baa4613d9$export$3daacb605a35d65c = ()=>(0, $1ybV0.ff)('rename-epic-link-field-to-parent-in-gic-epic-renaming-beta_pwfm1', false);

});

parcelRegister("cfxst", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8c7fd345aabec57$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e8c7fd345aabec57$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    placeholder: {
        "id": "issue-field-epic-link.edit.placeholder",
        "defaultMessage": "Select Epic"
    },
    placeholderRenamedParent: {
        "id": "issue-field-epic-link.edit.placeholder-renamed-parent",
        "defaultMessage": "Select parent"
    },
    noOptionsMessage: {
        "id": "issue-field-epic-link.edit.no-options-message",
        "defaultMessage": "No matches found"
    },
    failedFetch: {
        "id": "issue-field-epic-link.edit.failed-fetch",
        "defaultMessage": "Search failed. Please try again."
    },
    loadingMessage: {
        "id": "issue-field-epic-link.edit.loading-message",
        "defaultMessage": "Searching..."
    },
    allEpics: {
        "id": "issue-field-epic-link.edit.all-epics",
        "defaultMessage": "All epics"
    },
    allIssues: {
        "id": "issue-field-epic-link.edit.all-issues",
        "defaultMessage": "All issues"
    }
});

});

parcelRegister("5cl49", function(module, exports) {

$parcel$export(module.exports, "ColorPatch", () => $38a90e54ac6c18e3$export$a3f78762e82c8733);
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $kwce8 = parcelRequire("kwce8");

var $c9TLT = parcelRequire("c9TLT");

var $tgbCK = parcelRequire("tgbCK");
const $38a90e54ac6c18e3$export$a3f78762e82c8733 = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "p05qyv-0"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `${(0, $c9TLT.gridSize) * 2.5}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: `${(0, $c9TLT.gridSize) * 2.5}px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderRadius: `${(0, $c9TLT.gridSize) / 2}px`,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: (0, $tgbCK.MAP_COLORS_TO_VALUE)[props.color]
    }));

});


parcelRegister("cAsYI", function(module, exports) {

$parcel$export(module.exports, "mapOrganizationOptionsToData", () => $d1a3930c9b78df61$export$aa1a3b6fac8d058a);
$parcel$export(module.exports, "mapDataToOrganizationOptions", () => $d1a3930c9b78df61$export$bb720a783a78b0f4);
const $d1a3930c9b78df61$export$aa1a3b6fac8d058a = (options)=>options.map(({ value: value })=>Number.parseInt(value, 10));
const $d1a3930c9b78df61$export$bb720a783a78b0f4 = (data)=>data.map(({ id: id, name: name })=>({
            label: name,
            value: `${id}`
        }));

});

parcelRegister("aFVOZ", function(module, exports) {

$parcel$export(module.exports, "mapDataToOptions", () => $8d3c9983bc40bc04$export$99a866ffa3af7d8b);
$parcel$export(module.exports, "mapOptionToData", () => $8d3c9983bc40bc04$export$fc800909123977f3);
const $8d3c9983bc40bc04$export$4c05e2584b34e4d8 = (issueTypes)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const transformedIssueTypes = {};
    issueTypes.forEach((issueType)=>{
        const { id: id, iconUrl: iconUrl } = issueType;
        transformedIssueTypes[id] = iconUrl;
    });
    return transformedIssueTypes;
};
const $8d3c9983bc40bc04$export$227473965d2e27db = (projects)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const transformedProjects = {};
    projects.forEach((project)=>{
        const { id: id, key: key } = project;
        transformedProjects[id] = key;
    });
    return transformedProjects;
};
const $8d3c9983bc40bc04$export$99a866ffa3af7d8b = (response)=>{
    const transformedIssueTypes = $8d3c9983bc40bc04$export$4c05e2584b34e4d8(response.issueTypes);
    const transformedProjects = $8d3c9983bc40bc04$export$227473965d2e27db(response.projects);
    const transformedResponse = response.issues.map((issue)=>{
        const { issueKey: issueKey, issueSummary: issueSummary, issueTypeId: issueTypeId, projectId: projectId } = issue;
        const projectKey = transformedProjects[projectId];
        return {
            label: `${projectKey}-${issueKey} ${issueSummary}`,
            value: `${projectKey}-${issueKey}`,
            iconUrl: transformedIssueTypes[String(issueTypeId)]
        };
    });
    return transformedResponse;
};
const $8d3c9983bc40bc04$export$fc800909123977f3 = (option)=>option.value;

});

parcelRegister("cWMyd", function(module, exports) {

$parcel$export(module.exports, "mapOptionToResolutionOption", () => $f9f03c224d6c8eff$export$f915ce0689a595ca);
$parcel$export(module.exports, "mapResolutionOptionToOption", () => $f9f03c224d6c8eff$export$203456290cf27045);
$parcel$export(module.exports, "mapAndFilterResolutionOptions", () => $f9f03c224d6c8eff$export$38929c8b23814052);
const $f9f03c224d6c8eff$export$f915ce0689a595ca = (option)=>({
        id: option.value,
        name: option.label
    });
const $f9f03c224d6c8eff$export$203456290cf27045 = (option)=>({
        value: option.id,
        label: option.name
    });
const $f9f03c224d6c8eff$export$2ad0f62ebcc9982d = (options)=>options.map((option)=>$f9f03c224d6c8eff$export$203456290cf27045(option));
const $f9f03c224d6c8eff$export$38929c8b23814052 = (currentOption, options)=>{
    if (!currentOption) return $f9f03c224d6c8eff$export$2ad0f62ebcc9982d(options);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return options.reduce((resolutionOptions, option)=>{
        if (option.id !== currentOption.id) resolutionOptions.push($f9f03c224d6c8eff$export$203456290cf27045(option));
        return resolutionOptions;
    }, []);
};

});

parcelRegister("lKd2p", function(module, exports) {

$parcel$export(module.exports, "getOptionLabel", () => $103fb2043c182dc6$export$dac6ace3020563ca);
$parcel$export(module.exports, "getOptionValue", () => $103fb2043c182dc6$export$40be908210c5a79c);
$parcel$export(module.exports, "convertRolesToCurrentRole", () => $103fb2043c182dc6$export$dede06c97eeff392);
$parcel$export(module.exports, "transformRolesToArrayIfNull", () => $103fb2043c182dc6$export$394ee8daa9411a86);
$parcel$export(module.exports, "mapRoleToRestrictionValue", () => $103fb2043c182dc6$export$3bb7b17fecda53ae);
$parcel$export(module.exports, "isUserRoleIncludedInRestrictedRoles", () => $103fb2043c182dc6$export$e3d70e1822e7e331);

var $fDLYe = parcelRequire("fDLYe");
const $103fb2043c182dc6$export$dac6ace3020563ca = (role)=>role.name;
const $103fb2043c182dc6$export$40be908210c5a79c = (role)=>role.roleId;
const $103fb2043c182dc6$export$dede06c97eeff392 = (selectedRoles, allRoles)=>{
    const transformedCurrentRoles = [];
    selectedRoles.forEach((restriction)=>{
        const matchedRestriction = allRoles.find((role)=>role.roleId === restriction.roleId);
        matchedRestriction && transformedCurrentRoles.push(matchedRestriction);
    });
    return transformedCurrentRoles;
};
const $103fb2043c182dc6$export$394ee8daa9411a86 = (roles, onChange)=>onChange(roles || []);
const $103fb2043c182dc6$export$3bb7b17fecda53ae = (roles)=>({
        projectrole: roles.map(({ roleId: roleId })=>({
                restrictionValue: roleId
            }))
    });
const $103fb2043c182dc6$export$e3d70e1822e7e331 = (selectedRoles, rolesWithCurrentUserRole)=>{
    // no restrictions applied
    if (selectedRoles.length === 0) return true;
    const selectedRoleWithCurrentUserRoles = (0, (/*@__PURE__*/$parcel$interopDefault($fDLYe)))(selectedRoles, rolesWithCurrentUserRole, 'roleId');
    return Boolean(selectedRoleWithCurrentUserRoles.length);
};

});
parcelRegister("fDLYe", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");

var $kIBQX = parcelRequire("kIBQX");

var $7qARj = parcelRequire("7qARj");

var $9eFtX = parcelRequire("9eFtX");

var $arA63 = parcelRequire("arA63");

var $iTvqy = parcelRequire("iTvqy");
/**
 * This method is like `_.intersection` except that it accepts `iteratee`
 * which is invoked for each element of each `arrays` to generate the criterion
 * by which they're compared. The order and references of result values are
 * determined by the first array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [2.1]
 *
 * // The `_.property` iteratee shorthand.
 * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }]
 */ var $b62fb573ac3fa07e$var$intersectionBy = $9eFtX(function(arrays) {
    var iteratee = $iTvqy(arrays), mapped = $kJvGp(arrays, $arA63);
    if (iteratee === $iTvqy(mapped)) iteratee = undefined;
    else mapped.pop();
    return mapped.length && mapped[0] === arrays[0] ? $kIBQX(mapped, $7qARj(iteratee, 2)) : [];
});
module.exports = $b62fb573ac3fa07e$var$intersectionBy;

});
parcelRegister("kIBQX", function(module, exports) {

var $lYFvJ = parcelRequire("lYFvJ");

var $lqZWH = parcelRequire("lqZWH");

var $6v6uu = parcelRequire("6v6uu");

var $kJvGp = parcelRequire("kJvGp");

var $74vSq = parcelRequire("74vSq");

var $8AO5Q = parcelRequire("8AO5Q");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $f155478e4676feef$var$nativeMin = Math.min;
/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */ function $f155478e4676feef$var$baseIntersection(arrays, iteratee, comparator) {
    var includes = comparator ? $6v6uu : $lqZWH, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result = [];
    while(othIndex--){
        var array = arrays[othIndex];
        if (othIndex && iteratee) array = $kJvGp(array, $74vSq(iteratee));
        maxLength = $f155478e4676feef$var$nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new $lYFvJ(othIndex && array) : undefined;
    }
    array = arrays[0];
    var index = -1, seen = caches[0];
    outer: while(++index < length && result.length < maxLength){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (!(seen ? $8AO5Q(seen, computed) : includes(result, computed, comparator))) {
            othIndex = othLength;
            while(--othIndex){
                var cache = caches[othIndex];
                if (!(cache ? $8AO5Q(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
            }
            if (seen) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $f155478e4676feef$var$baseIntersection;

});

parcelRegister("arA63", function(module, exports) {

var $cRpul = parcelRequire("cRpul");
/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */ function $79a86d09190de0cd$var$castArrayLikeObject(value) {
    return $cRpul(value) ? value : [];
}
module.exports = $79a86d09190de0cd$var$castArrayLikeObject;

});



parcelRegister("hdX72", function(module, exports) {

$parcel$export(module.exports, "IssueCreateEntitlementField", () => $9e0179c4abb1ecf2$export$99314741193b044b);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");

var $7TaJX = parcelRequire("7TaJX");
var $icPhQ = parcelRequire("icPhQ");
var $dibFF = parcelRequire("dibFF");
var $6HoNR = parcelRequire("6HoNR");

var $gGtKh = parcelRequire("gGtKh");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");

var $6Qy8u = parcelRequire("6Qy8u");
var $9IbuV = parcelRequire("9IbuV");

var $5RdxW = parcelRequire("5RdxW");

var $fBXcZ = parcelRequire("fBXcZ");

var $3rBGb = parcelRequire("3rBGb");
const $9e0179c4abb1ecf2$export$48549219ad5358dc = (props)=>{
    const { width: width, autoFocus: autoFocus = false, fieldProps: { value: value, onChange: onChange, ...fieldProps }, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $7TaJX.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, error: error, contextAndValuesOfIssueBeingCreated: contextAndValuesOfIssueBeingCreated } = props;
    const { getFormState: getFormState } = contextAndValuesOfIssueBeingCreated;
    const formState = getFormState();
    const reporter = formState?.values?.reporter;
    const [currentReporter, setCurrentReporter] = (0, $eUqFw.useState)(reporter);
    (0, $eUqFw.useEffect)(()=>{
        if (reporter?.id !== currentReporter?.id) {
            onChange(null);
            setCurrentReporter(reporter);
        }
    }, [
        reporter,
        currentReporter,
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "entitlement-edit",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dibFF.FieldLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "entitlementsFieldGIC",
        sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), {
        attributes: {
            entitlementsFieldViewed: 'GIC'
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5RdxW.LazyEditView), {
        ...fieldProps,
        isInvalid: Boolean(error),
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        onChange: onChange,
        value: value,
        autoFocus: autoFocus,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        reporterId: reporter?.id,
        spacing: "default"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Qy8u.ExperienceSuccess), {
        experience: (0, $fBXcZ.entitlementFieldGicMountExperience)
    })));
};
const $9e0179c4abb1ecf2$export$f13f32889402194 = (props)=>{
    (0, $9IbuV.useUFOComponentExperience)((0, $fBXcZ.entitlementFieldGicMountExperience));
    const onError = (_, error)=>{
        (0, $fBXcZ.entitlementFieldGicMountExperience).failure();
        throw error; // rethrow error to be caught by WithFormField erorr boundary so that the field label doesn't show
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "entitlementField",
        packageName: "jiraServicedeskCustomerServiceEntitlementsField",
        onError: onError,
        teamName: "boysenberry",
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9e0179c4abb1ecf2$export$48549219ad5358dc, props));
};
const $9e0179c4abb1ecf2$export$99314741193b044b = (0, $6HoNR.withFormField)({
    validator: (0, $3rBGb.validateEntitlementField)
})($9e0179c4abb1ecf2$export$f13f32889402194);

});
parcelRegister("9IbuV", function(module, exports) {

$parcel$export(module.exports, "useUFOComponentExperience", () => $dfcd8ff9c232688c$export$30ab340faaed55d4);

var $eUqFw = parcelRequire("eUqFw");
const $dfcd8ff9c232688c$var$useConstructor = (callback)=>{
    const hasBeenFired = (0, $eUqFw.useRef)(false);
    if (!hasBeenFired.current) {
        callback();
        hasBeenFired.current = true;
    }
    return null;
};
const $dfcd8ff9c232688c$export$30ab340faaed55d4 = (experience)=>{
    (0, $eUqFw.useEffect)(()=>{
        return ()=>{
            experience.abort();
        };
    // we want this cleanup to only happen on unmount so this is a legit use of empty array
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $dfcd8ff9c232688c$var$useConstructor(()=>experience.start());
    return null;
};

});

parcelRegister("5RdxW", function(module, exports) {

$parcel$export(module.exports, "LazyEditView", () => $b97dfebc8d670c4b$export$a17259a78f401488);

var $7rh0R = parcelRequire("7rh0R");

const $b97dfebc8d670c4b$export$a17259a78f401488 = (0, $7rh0R.lazy)(()=>(parcelRequire("j7EzA")).then((module)=>module.EditView), {
    moduleId: "./src/packages/servicedesk/customer-service/entitlements-field/src/common/ui/edit-view/index.tsx"
});

});
parcelRegister("j7EzA", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('7cdir');
        const value = parcelRequire('ghBiB');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("7cdir").then(()=>parcelRequire('ghBiB'));
}

});


parcelRegister("fBXcZ", function(module, exports) {

$parcel$export(module.exports, "entitlementFieldGicMountExperience", () => $64cb0afcb2836c16$export$588fc8ac7a187272);
$parcel$export(module.exports, "entitlementFieldDataFetchExperience", () => $64cb0afcb2836c16$export$7f9aebf7c6d536d6);
$parcel$export(module.exports, "entitlementFieldIssueViewMountExperience", () => $64cb0afcb2836c16$export$66e03de8aa0e97b8);
$parcel$export(module.exports, "editEntitlementFieldIssueViewExperience", () => $64cb0afcb2836c16$export$6889e91b24599276);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $64cb0afcb2836c16$export$588fc8ac7a187272 = new (0, $kDfSL.UFOExperience)('jsm-cs-entitlement-custom-field-gic-mount', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult
});
const $64cb0afcb2836c16$export$7f9aebf7c6d536d6 = new (0, $kDfSL.UFOExperience)('jsm-cs-entitlement-custom-field-data-fetch', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult
});
const $64cb0afcb2836c16$export$66e03de8aa0e97b8 = new (0, $kDfSL.UFOExperience)('jsm-cs-entitlement-custom-field-issue-view-mount', {
    type: (0, $12kyE.ExperienceTypes).Load,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageSegmentLoad
});
const $64cb0afcb2836c16$export$6889e91b24599276 = new (0, $kDfSL.UFOExperience)('jsm-cs-entitlement-custom-field-issue-view-edit', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).InlineResult
});

});

parcelRegister("3rBGb", function(module, exports) {

$parcel$export(module.exports, "mapEntitlementOptionToData", () => $bbd6aafee07a951c$export$1c1e5611b1980840);
$parcel$export(module.exports, "validateEntitlementField", () => $bbd6aafee07a951c$export$3f9370506eb4fa6c);

var $dEMIg = parcelRequire("dEMIg");
const $bbd6aafee07a951c$export$1c1e5611b1980840 = (option)=>option.value;
const $bbd6aafee07a951c$export$3b43598c7abb6d70 = (selectedEntitlement, fieldId)=>({
        entitlementField: {
            fieldId: fieldId,
            entitlement: {
                entitlementId: `${selectedEntitlement.value}`
            }
        }
    });
const $bbd6aafee07a951c$export$3f9370506eb4fa6c = (value, isRequired)=>{
    if (isRequired) {
        if (!value) return 0, $dEMIg.REQUIRED;
    }
    return undefined;
};

});


parcelRegister("12Skn", function(module, exports) {

$parcel$export(module.exports, "default", () => $59261e79343a476b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gRUtg = parcelRequire("gRUtg");

var $7jPhn = parcelRequire("7jPhn");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dEMIg = parcelRequire("dEMIg");

var $d6mZY = parcelRequire("d6mZY");

var $gya0p = parcelRequire("gya0p");

var $7SSqk = parcelRequire("7SSqk");
const $59261e79343a476b$export$f10e1476c0ddb959 = ()=>(0, $eUqFw.useState)(false);
const $59261e79343a476b$var$AttachmentsField = (props)=>{
    const { view: view } = (0, $gya0p.useMinimizableModal)();
    const { fieldId: fieldId, fieldName: fieldName, description: description, isRequired: isRequired, additionalData: additionalData, selectedProject: selectedProject, onInProgressChange: onInProgressChange, additionalData: { maxAllowedTotalAttachmentsSize: maxAllowedTotalAttachmentsSize }, defaultValue: defaultValue, isCollapsed: isCollapsed } = props;
    const { mediaContext: mediaContext } = additionalData;
    const uploadToken = mediaContext?.uploadToken;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [attachmentSizeValidation, onAttachmentSizeValidation] = $59261e79343a476b$export$f10e1476c0ddb959();
    let attachmentUploadContext;
    if (uploadToken) attachmentUploadContext = {
        clientId: uploadToken.clientId,
        serviceHost: uploadToken.endpointUrl,
        collection: uploadToken.targetCollection,
        token: uploadToken.token
    };
    const dropzoneContainerId = view === 'modal' ? (0, $dEMIg.FORM_DROPZONE_CONTAINER_ID) : (0, $dEMIg.MINIMISED_DROPZONE_CONTAINER_ID);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6mZY.default), {
        fieldId: fieldId,
        fieldName: fieldName,
        description: description,
        isRequired: isRequired,
        mediaUploadContext: attachmentUploadContext,
        projectId: selectedProject?.value || null,
        onInProgressChange: onInProgressChange,
        maxAllowedTotalAttachmentsSize: maxAllowedTotalAttachmentsSize,
        onAttachmentSizeValidation: onAttachmentSizeValidation,
        dropzoneContainerId: dropzoneContainerId,
        shouldScrollIntoViewOnUploadStart: true,
        defaultValue: defaultValue,
        ...(0, $1ybV0.ff)('gic-smart-fields-jira-labs_8uwvr') && {
            isCollapsed: isCollapsed
        }
    }), !attachmentUploadContext && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, formatMessage((0, $7SSqk.default).missingToken)), attachmentSizeValidation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, formatMessage((0, $7SSqk.default).attachmentSizeLimitCheck), " (", (0, (/*@__PURE__*/$parcel$interopDefault($gRUtg)))(maxAllowedTotalAttachmentsSize, {
        unitSeparator: ' '
    }), ")."));
};
var $59261e79343a476b$export$2e2bcd8739ae039 = $59261e79343a476b$var$AttachmentsField;

});
parcelRegister("gRUtg", function(module, exports) {
/*!
 * bytes
 * Copyright(c) 2012-2014 TJ Holowaychuk
 * Copyright(c) 2015 Jed Watson
 * MIT Licensed
 */ 'use strict';
/**
 * Module exports.
 * @public
 */ module.exports = $c47d668c1c005307$var$bytes;
module.exports.format = $c47d668c1c005307$var$format;
module.exports.parse = $c47d668c1c005307$var$parse;
/**
 * Module variables.
 * @private
 */ var $c47d668c1c005307$var$formatThousandsRegExp = /\B(?=(\d{3})+(?!\d))/g;
var $c47d668c1c005307$var$formatDecimalsRegExp = /(?:\.0*|(\.[^0]+)0+)$/;
var $c47d668c1c005307$var$map = {
    b: 1,
    kb: 1024,
    mb: 1048576,
    gb: 1073741824,
    tb: Math.pow(1024, 4),
    pb: Math.pow(1024, 5)
};
var $c47d668c1c005307$var$parseRegExp = /^((-|\+)?(\d+(?:\.\d+)?)) *(kb|mb|gb|tb|pb)$/i;
/**
 * Convert the given value in bytes into a string or parse to string to an integer in bytes.
 *
 * @param {string|number} value
 * @param {{
 *  case: [string],
 *  decimalPlaces: [number]
 *  fixedDecimals: [boolean]
 *  thousandsSeparator: [string]
 *  unitSeparator: [string]
 *  }} [options] bytes options.
 *
 * @returns {string|number|null}
 */ function $c47d668c1c005307$var$bytes(value, options) {
    if (typeof value === 'string') return $c47d668c1c005307$var$parse(value);
    if (typeof value === 'number') return $c47d668c1c005307$var$format(value, options);
    return null;
}
/**
 * Format the given value in bytes into a string.
 *
 * If the value is negative, it is kept as such. If it is a float,
 * it is rounded.
 *
 * @param {number} value
 * @param {object} [options]
 * @param {number} [options.decimalPlaces=2]
 * @param {number} [options.fixedDecimals=false]
 * @param {string} [options.thousandsSeparator=]
 * @param {string} [options.unit=]
 * @param {string} [options.unitSeparator=]
 *
 * @returns {string|null}
 * @public
 */ function $c47d668c1c005307$var$format(value, options) {
    if (!Number.isFinite(value)) return null;
    var mag = Math.abs(value);
    var thousandsSeparator = options && options.thousandsSeparator || '';
    var unitSeparator = options && options.unitSeparator || '';
    var decimalPlaces = options && options.decimalPlaces !== undefined ? options.decimalPlaces : 2;
    var fixedDecimals = Boolean(options && options.fixedDecimals);
    var unit = options && options.unit || '';
    if (!unit || !$c47d668c1c005307$var$map[unit.toLowerCase()]) {
        if (mag >= $c47d668c1c005307$var$map.pb) unit = 'PB';
        else if (mag >= $c47d668c1c005307$var$map.tb) unit = 'TB';
        else if (mag >= $c47d668c1c005307$var$map.gb) unit = 'GB';
        else if (mag >= $c47d668c1c005307$var$map.mb) unit = 'MB';
        else if (mag >= $c47d668c1c005307$var$map.kb) unit = 'KB';
        else unit = 'B';
    }
    var val = value / $c47d668c1c005307$var$map[unit.toLowerCase()];
    var str = val.toFixed(decimalPlaces);
    if (!fixedDecimals) str = str.replace($c47d668c1c005307$var$formatDecimalsRegExp, '$1');
    if (thousandsSeparator) str = str.split('.').map(function(s, i) {
        return i === 0 ? s.replace($c47d668c1c005307$var$formatThousandsRegExp, thousandsSeparator) : s;
    }).join('.');
    return str + unitSeparator + unit;
}
/**
 * Parse the string value into an integer in bytes.
 *
 * If no unit is given, it is assumed the value is in bytes.
 *
 * @param {number|string} val
 *
 * @returns {number|null}
 * @public
 */ function $c47d668c1c005307$var$parse(val) {
    if (typeof val === 'number' && !isNaN(val)) return val;
    if (typeof val !== 'string') return null;
    // Test if the string passed is valid
    var results = $c47d668c1c005307$var$parseRegExp.exec(val);
    var floatValue;
    var unit = 'b';
    if (!results) {
        // Nothing could be extracted from the given string
        floatValue = parseInt(val, 10);
        unit = 'b';
    } else {
        // Retrieve the value and the unit
        floatValue = parseFloat(results[1]);
        unit = results[4].toLowerCase();
    }
    if (isNaN(floatValue)) return null;
    return Math.floor($c47d668c1c005307$var$map[unit] * floatValue);
}

});

parcelRegister("d6mZY", function(module, exports) {

$parcel$export(module.exports, "AttachmentsField", () => $6416e3ced7c01193$export$f7c49e57ef98664f);
$parcel$export(module.exports, "default", () => $6416e3ced7c01193$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $k7cZh = parcelRequire("k7cZh");

var $7u4fN = parcelRequire("7u4fN");

var $iHib2 = parcelRequire("iHib2");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dEMIg = parcelRequire("dEMIg");

var $jrHde = parcelRequire("jrHde");
var $9Tbvq = parcelRequire("9Tbvq");

var $gY5ty = parcelRequire("gY5ty");

var $gGtKh = parcelRequire("gGtKh");

var $6HoNR = parcelRequire("6HoNR");

var $9vlI9 = parcelRequire("9vlI9");

var $9PXwb = parcelRequire("9PXwb");
const $6416e3ced7c01193$export$f7c49e57ef98664f = (props)=>{
    const { mediaUploadContext: mediaUploadContext, onInProgressChange: onInProgressChange, projectId: projectId, fieldId: fieldId = '', fieldProps: { onChange: onChange, value: value, ...fieldProps }, maxAllowedTotalAttachmentsSize: maxAllowedTotalAttachmentsSize, onAttachmentSizeValidation: onAttachmentSizeValidation, dropzoneContainerId: dropzoneContainerId = '', shouldScrollIntoViewOnUploadStart: shouldScrollIntoViewOnUploadStart = false, defaultValue: defaultValue = [], attachmentCustomUploadURL: attachmentCustomUploadURL } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { files: files, onUploadStart: onUploadStart, onUploadError: onUploadError, mediaClientConfig: mediaClientConfig, uploadConfig: uploadConfig, onRemoveFile: onRemoveFile, onUploadEnd: onUploadEnd, isUploading: isUploading, setAttachments: setAttachments, ...resUseAttachments } = (0, $9Tbvq.default)({
        mediaUploadContext: mediaUploadContext,
        projectId: projectId,
        maxAllowedTotalAttachmentsSize: maxAllowedTotalAttachmentsSize,
        onAttachmentSizeValidation: onAttachmentSizeValidation,
        attachmentCustomUploadURL: attachmentCustomUploadURL
    });
    const { isDefaultValueInitialized: isDefaultValueInitialized, setDefaultValueInitialized: setDefaultValueInitialized } = resUseAttachments;
    (0, $eUqFw.useEffect)(()=>{
        // setting DefaultValueInitialized only when receiving default Value to guarantee we will set DefaultValue even if it's loaded with some delay.
        if (defaultValue && Array.isArray(defaultValue) && isDefaultValueInitialized === false) {
            const currentAttachments = [];
            setAttachments(currentAttachments.concat(defaultValue.map((mediaFile)=>({
                    mediaFile: mediaFile,
                    isUploading: false
                }))));
            setDefaultValueInitialized(true);
        }
    }, [
        setAttachments,
        defaultValue,
        isDefaultValueInitialized,
        setDefaultValueInitialized
    ]);
    (0, $eUqFw.useEffect)(()=>{
        let shouldCallOnChange = false;
        const isValueAnArray = Array.isArray(value);
        if (isValueAnArray && value.length !== files.length) shouldCallOnChange = true;
        if (!isValueAnArray && files.length) shouldCallOnChange = true;
        if (shouldCallOnChange) onChange(files);
    }, [
        files,
        onChange,
        value
    ]);
    // TBD: create a controlled reusable attachment component
    (0, $eUqFw.useEffect)(()=>{
        // @ts-expect-error - TS2339 - Property 'shouldClear' does not exist on type 'FieldValue'.
        if (value && value.shouldClear === true) setAttachments([]);
    }, [
        setAttachments,
        value
    ]);
    (0, $eUqFw.useEffect)(()=>{
        onInProgressChange && onInProgressChange(isUploading);
    }, [
        isUploading,
        onInProgressChange
    ]);
    if (!mediaUploadContext) return null;
    const onAttachmentUploadStart = (uploadStartPayload)=>{
        onUploadStart(uploadStartPayload);
        if (shouldScrollIntoViewOnUploadStart) {
            const fieldElement = document.getElementById((0, $9PXwb.getFieldDropZoneContainerID)(fieldId));
            if (fieldElement) (0, $k7cZh.default)(fieldElement, (0, $dEMIg.DEFAULT_SCROLL_OPTIONS));
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6416e3ced7c01193$var$FieldDropzoneContainer, {
        id: (0, $9PXwb.getFieldDropZoneContainerID)(fieldId)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6416e3ced7c01193$var$BrowseDropzoneArea, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iHib2))), {
        label: "Upload",
        primaryColor: `var(--ds-icon, ${(0, $PdmhA).N100})`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6416e3ced7c01193$var$BrowseDropzoneAreaText, null, `${formatMessage((0, $9vlI9.default).dropzone)}`, "\xa0"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jrHde.default), {
        ...fieldProps,
        mediaClientConfig: mediaClientConfig,
        uploadConfig: uploadConfig,
        onUploadError: onUploadError,
        onUploadStart: onAttachmentUploadStart,
        onUploadEnd: onUploadEnd,
        dropzoneContainer: document.getElementById(dropzoneContainerId || (0, $9PXwb.getFieldDropZoneContainerID)(fieldId))
    }, ({ setIsBrowserOpen: setIsBrowserOpen })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            "aria-labelledby": fieldProps['aria-labelledby'],
            spacing: "none",
            appearance: "link",
            onClick: ()=>setIsBrowserOpen(true)
        }, formatMessage((0, $9vlI9.default).browse))))), files.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $6416e3ced7c01193$var$mediaContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "attachments-filmstrip-view",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gY5ty.AsyncAttachmentsFilmstripView), {
        mediaClientConfig: mediaClientConfig,
        files: files,
        onRemoveFile: onRemoveFile,
        collectionName: mediaUploadContext.collection
    }))));
};
var $6416e3ced7c01193$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $6HoNR.withFormField)({
    validator: (0, $9PXwb.validateAttachment // @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element | null' is not assignable to parameter of type 'AbstractComponent<ComponentProps<AttachmentFieldConfig, FieldValue>, any>'.
    )
})($6416e3ced7c01193$export$f7c49e57ef98664f);
const $6416e3ced7c01193$var$FieldDropzoneContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _19it1p8j _1yt4utpp _syaz1e9r",
            __cmplp.className
        ])
    });
});
const $6416e3ced7c01193$var$mediaContainerStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.050'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6416e3ced7c01193$var$BrowseDropzoneArea = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6416e3ced7c01193$var$BrowseDropzoneAreaText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iHib2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d9ca57b7a20a40df$var$_react = $d9ca57b7a20a40df$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $d9ca57b7a20a40df$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $d9ca57b7a20a40df$var$UploadIcon = (props)=>/*#__PURE__*/ $d9ca57b7a20a40df$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M11.208 9.32L9.29 11.253a1 1 0 000 1.409.982.982 0 001.397 0l1.29-1.301 1.336 1.347a.982.982 0 001.397.001 1.002 1.002 0 00.001-1.408l-1.965-1.98a1.08 1.08 0 00-1.538-.001z"/><path d="M11 10.007l.001 9.986c0 .557.448 1.008 1 1.007.553 0 1-.45 1-1.007L13 10.006C13 9.451 12.552 9 12 9s-1.001.451-1 1.007z"/><path d="M7.938 5.481a4.8 4.8 0 00-.777-.063C4.356 5.419 2 7.62 2 10.499 2 13.408 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.051.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.119a4.14 4.14 0 014.069 3.644l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-1.999-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.021-3.901.901-5.038 2.481z"/></g></svg>`
    }, props));
$d9ca57b7a20a40df$var$UploadIcon.displayName = 'UploadIcon';
var $d9ca57b7a20a40df$var$_default = $d9ca57b7a20a40df$var$UploadIcon;
module.exports.default = $d9ca57b7a20a40df$var$_default;

});

parcelRegister("jrHde", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f587ae560b0e1b4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("5WZms");
var $lQaP0 = parcelRequire("lQaP0");
var $lfPxH = parcelRequire("lfPxH");

var $j9zyb = parcelRequire("j9zyb");
const $5f587ae560b0e1b4$var$AttachmentsUpload = (props)=>{
    const [isBrowserOpen, setIsBrowserOpen] = (0, $eUqFw.useState)(false);
    const { dropzoneContainer: dropzoneContainer, onUploadStart: onUploadStart, onUploadError: onUploadError, mediaClientConfig: mediaClientConfig, uploadConfig: uploadConfig, onUploadEnd: onUploadEnd, children: renderPropFn } = props;
    const dropzoneConfig = {
        ...uploadConfig
    };
    const browserConfig = {
        ...uploadConfig,
        multiple: true
    };
    const clipboardConfig = {
        ...uploadConfig
    };
    if (dropzoneContainer) dropzoneConfig.container = dropzoneContainer;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lQaP0.BrowserLoader), {
        isOpen: isBrowserOpen,
        config: browserConfig,
        mediaClientConfig: mediaClientConfig,
        onUploadsStart: onUploadStart,
        onError: onUploadError,
        onEnd: onUploadEnd,
        onClose: ()=>setIsBrowserOpen(false)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfPxH.DropzoneLoader), {
        mediaClientConfig: mediaClientConfig,
        config: dropzoneConfig,
        onUploadsStart: onUploadStart,
        onEnd: onUploadEnd
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9zyb.Clipboard), {
        mediaClientConfig: mediaClientConfig,
        config: clipboardConfig,
        onUploadsStart: onUploadStart,
        onEnd: onUploadEnd,
        isolated: false
    }), renderPropFn({
        setIsBrowserOpen: setIsBrowserOpen
    }));
};
var $5f587ae560b0e1b4$export$2e2bcd8739ae039 = $5f587ae560b0e1b4$var$AttachmentsUpload;

});
parcelRegister("5WZms", function(module, exports) {

$parcel$export(module.exports, "isImagePreview", () => (parcelRequire("2v0lC")).isImagePreview);
$parcel$export(module.exports, "Dropzone", () => (parcelRequire("lfPxH")).DropzoneLoader);
$parcel$export(module.exports, "Clipboard", () => (parcelRequire("dTbMy")).ClipboardLoader);
$parcel$export(module.exports, "Browser", () => (parcelRequire("lQaP0")).BrowserLoader);

var $2v0lC = parcelRequire("2v0lC");

var $lfPxH = parcelRequire("lfPxH");

var $dTbMy = parcelRequire("dTbMy");

var $lQaP0 = parcelRequire("lQaP0");

});
parcelRegister("2v0lC", function(module, exports) {

$parcel$export(module.exports, "isImagePreview", () => $3ff8fcb755fe1e8c$export$5fe5572478566289);
const $3ff8fcb755fe1e8c$export$5fe5572478566289 = (preview)=>!!preview.dimensions;

});

parcelRegister("lfPxH", function(module, exports) {

$parcel$export(module.exports, "DropzoneLoader", () => $b97c6c9a97affaba$export$66201d263cd6342);

var $eUqFw = parcelRequire("eUqFw");



class $b97c6c9a97affaba$export$66201d263cd6342 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    static{
        this.displayName = 'AsyncDropzone';
    }
    async UNSAFE_componentWillMount() {
        if (!this.state.Dropzone || !this.state.MediaPickerErrorBoundary) try {
            const [mediaClient, dropzoneModule, mediaPickerErrorBoundaryModule] = await Promise.all([
                (parcelRequire("gYZBn")),
                (parcelRequire("jWt0v")),
                (parcelRequire("fhBAu"))
            ]);
            $b97c6c9a97affaba$export$66201d263cd6342.Dropzone = mediaClient.withMediaClient(dropzoneModule.Dropzone);
            $b97c6c9a97affaba$export$66201d263cd6342.MediaPickerErrorBoundary = mediaPickerErrorBoundaryModule.default;
            this.setState({
                Dropzone: $b97c6c9a97affaba$export$66201d263cd6342.Dropzone,
                MediaPickerErrorBoundary: $b97c6c9a97affaba$export$66201d263cd6342.MediaPickerErrorBoundary
            });
        } catch (error) {
        // TODO [MS-2272]: Add operational error to catch async import error
        }
    }
    render() {
        const { Dropzone: Dropzone, MediaPickerErrorBoundary: MediaPickerErrorBoundary } = this.state;
        if (!Dropzone || !MediaPickerErrorBoundary) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MediaPickerErrorBoundary, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Dropzone, this.props));
    }
    constructor(...args){
        super(...args);
        this.state = {
            Dropzone: $b97c6c9a97affaba$export$66201d263cd6342.Dropzone,
            MediaPickerErrorBoundary: $b97c6c9a97affaba$export$66201d263cd6342.MediaPickerErrorBoundary
        };
    }
}

});
parcelRegister("gYZBn", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('IXWjR');
        const value = parcelRequire('7bu2U');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("IXWjR").then(()=>parcelRequire('7bu2U'));
}

});

parcelRegister("jWt0v", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('2ujg4');
        const value = parcelRequire('9MwW0');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("2ujg4").then(()=>parcelRequire('9MwW0'));
}

});

parcelRegister("fhBAu", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('hPzOn'),
            load('jJJbp')
        ]);
        const value = parcelRequire('dLH1Z');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("hPzOn"),
        load("jJJbp")
    ]).then(()=>parcelRequire('dLH1Z'));
}

});


parcelRegister("dTbMy", function(module, exports) {

$parcel$export(module.exports, "ClipboardLoader", () => $a4d33d18f4520334$export$d7936799bf32b554);

var $eUqFw = parcelRequire("eUqFw");


class $a4d33d18f4520334$export$d7936799bf32b554 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    static{
        this.displayName = 'AsyncClipboard';
    }
    async UNSAFE_componentWillMount() {
        if (!this.state.Clipboard) {
            const [mediaClient, clipboardModule] = await Promise.all([
                (parcelRequire("gYZBn")),
                (parcelRequire("9aLr8"))
            ]);
            $a4d33d18f4520334$export$d7936799bf32b554.Clipboard = mediaClient.withMediaClient(clipboardModule.Clipboard);
            this.setState({
                Clipboard: $a4d33d18f4520334$export$d7936799bf32b554.Clipboard
            });
        }
    }
    render() {
        if (!this.state.Clipboard) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(this.state.Clipboard, this.props);
    }
    constructor(...args){
        super(...args);
        this.state = {
            Clipboard: $a4d33d18f4520334$export$d7936799bf32b554.Clipboard
        };
    }
}

});
parcelRegister("9aLr8", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('4AVSa');
        const value = parcelRequire('b4HVU');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("4AVSa").then(()=>parcelRequire('b4HVU'));
}

});


parcelRegister("lQaP0", function(module, exports) {

$parcel$export(module.exports, "BrowserLoader", () => $d86767e0d9993d6e$export$3ce634ac4a869e2c);

var $eUqFw = parcelRequire("eUqFw");


class $d86767e0d9993d6e$export$3ce634ac4a869e2c extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    static{
        this.displayName = 'AsyncBrowser';
    }
    componentDidMount() {
        this.mounted = true;
    }
    componentWillUnmount() {
        this.mounted = false;
    }
    async UNSAFE_componentWillMount() {
        if (!this.state.Browser) {
            const [mediaClient, browserModule] = await Promise.all([
                (parcelRequire("gYZBn")),
                (parcelRequire("bYVhC"))
            ]);
            $d86767e0d9993d6e$export$3ce634ac4a869e2c.Browser = mediaClient.withMediaClient(browserModule.Browser);
            if (this.mounted) this.setState({
                Browser: $d86767e0d9993d6e$export$3ce634ac4a869e2c.Browser
            });
        }
    }
    render() {
        if (!this.state.Browser) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(this.state.Browser, this.props);
    }
    constructor(...args){
        super(...args);
        this.mounted = false;
        this.state = {
            Browser: $d86767e0d9993d6e$export$3ce634ac4a869e2c.Browser
        };
    }
}

});
parcelRegister("bYVhC", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('3woaI');
        const value = parcelRequire('2fiTb');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("3woaI").then(()=>parcelRequire('2fiTb'));
}

});



parcelRegister("j9zyb", function(module, exports) {

$parcel$export(module.exports, "Clipboard", () => $c7c5f3dfc37493c5$export$8b44c43c7d8f0830);

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("5WZms");
var $dTbMy = parcelRequire("dTbMy");

var $7wp7z = parcelRequire("7wp7z");
const $c7c5f3dfc37493c5$export$7b1ba4955557a858 = ()=>null;
const $c7c5f3dfc37493c5$export$8b44c43c7d8f0830 = ({ config: config, isolated: isolated, ...props })=>{
    const container = (0, $7wp7z.useClipboardContextBoundary)();
    const onPaste = (0, $eUqFw.useCallback)((event)=>{
        // do not propagate event above container boundary
        event.stopPropagation();
        // preventing default will disable any copy-paste
        // event.preventDefault();
        // false means "allow"
        return false;
    }, []);
    const derivedConfig = (0, $eUqFw.useMemo)(()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        container ? {
            ...config,
            container: container,
            onPaste: onPaste
        } : config, [
        config,
        container,
        onPaste
    ]);
    if (!container && isolated !== false) // hard block clipboard if boundary is not set
    // render "marker" to ease testing
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c7c5f3dfc37493c5$export$7b1ba4955557a858, null);
    // Here there is a good opportunity to report own existence to the boundary to prevent two Clipboards from being active at the same node
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dTbMy.ClipboardLoader), {
        ...props,
        config: derivedConfig
    });
};

});
parcelRegister("7wp7z", function(module, exports) {

$parcel$export(module.exports, "ClipboardStoreContainer", () => $5ea82582ff996af1$export$c4bc9440a978eec1);
$parcel$export(module.exports, "useClipboardContextActions", () => $5ea82582ff996af1$export$a3e41c5b3d4c30b7);
$parcel$export(module.exports, "useClipboardContextBoundary", () => $5ea82582ff996af1$export$37046969a30ae0a0);

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");
const $5ea82582ff996af1$var$ClipboardStore = (0, $a61MH.createStore)({
    name: 'clipboard-store',
    // using containedBy will break all "unscoped" locations. We dont want it for now
    // containedBy: ClipboardStoreContainer,
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    initialState: {
        boundary: null
    },
    actions: {
        setClipBoardContext: (boundary)=>({ setState: setState })=>{
                setState({
                    boundary: boundary
                });
            }
    }
});
const $5ea82582ff996af1$export$c4bc9440a978eec1 = (0, $heB5U.createContainer)($5ea82582ff996af1$var$ClipboardStore);
const $5ea82582ff996af1$export$a3e41c5b3d4c30b7 = (0, $ggKAj.createActionsHook)($5ea82582ff996af1$var$ClipboardStore);
const $5ea82582ff996af1$var$useClipboardContextBoundarySelector = (0, $ggKAj.createHook)($5ea82582ff996af1$var$ClipboardStore, {
    selector: (state)=>state.boundary
});
const $5ea82582ff996af1$export$37046969a30ae0a0 = ()=>$5ea82582ff996af1$var$useClipboardContextBoundarySelector()[0];

});



parcelRegister("9Tbvq", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc16146f478a9b2f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $YVYIZ = parcelRequire("YVYIZ");
const $dc16146f478a9b2f$var$useAttachments = (attachmentArgs)=>{
    const { mediaUploadContext: mediaUploadContext, projectId: projectId, issueId: issueId, maxAllowedTotalAttachmentsSize: maxAllowedTotalAttachmentsSize, onAttachmentSizeValidation: onAttachmentSizeValidation, attachmentCustomUploadURL: attachmentCustomUploadURL } = attachmentArgs;
    if (!mediaUploadContext) throw new Error('mediaUploadContext is null!');
    const [attachments, setAttachments] = (0, $eUqFw.useState)([]);
    const [files, setFiles] = (0, $eUqFw.useState)([]);
    const [isUploading, setUploading] = (0, $eUqFw.useState)(false);
    const [isDefaultValueInitialized, setDefaultValueInitialized] = (0, $eUqFw.useState)(false);
    const stateRef = (0, $eUqFw.useRef)();
    stateRef.current = files;
    (0, $eUqFw.useEffect)(()=>{
        setFiles(attachments.map((attachment)=>attachment.mediaFile));
        setUploading(attachments.some((attachment)=>attachment.isUploading));
    }, [
        attachments
    ]);
    const mediaClientConfig = (0, $eUqFw.useMemo)(()=>({
            authProvider: ()=>Promise.resolve({
                    baseUrl: mediaUploadContext.serviceHost,
                    clientId: mediaUploadContext.clientId,
                    token: mediaUploadContext.token
                }),
            useSha256ForUploads: true
        }), [
        mediaUploadContext
    ]);
    const uploadConfig = (0, $eUqFw.useMemo)(()=>({
            uploadParams: {
                collection: mediaUploadContext.collection
            }
        }), [
        mediaUploadContext.collection
    ]);
    const onUploadStart = (0, $eUqFw.useCallback)((uploadStartPayload)=>{
        const currentFiles = stateRef.current ? stateRef.current : [];
        const totalAttachments = [
            ...uploadStartPayload.files,
            ...currentFiles
        ];
        if (maxAllowedTotalAttachmentsSize === undefined || (0, $YVYIZ.getAttachmentsSize)(totalAttachments) <= maxAllowedTotalAttachmentsSize) {
            if (onAttachmentSizeValidation) onAttachmentSizeValidation(false);
            setAttachments((currentAttachments)=>currentAttachments.concat(uploadStartPayload.files.map((mediaFile)=>({
                        mediaFile: mediaFile,
                        isUploading: true
                    }))));
        } else if (onAttachmentSizeValidation) onAttachmentSizeValidation(true);
    }, [
        onAttachmentSizeValidation,
        maxAllowedTotalAttachmentsSize
    ]);
    const onUploadError = (0, $eUqFw.useCallback)((uploadError)=>{
        setAttachments((currentAttachments)=>currentAttachments.filter((attachment)=>attachment.mediaFile.id !== uploadError.fileId));
    }, []);
    const onUploadEnd = (0, $eUqFw.useCallback)((uploadEndPayload)=>{
        (async ()=>{
            const mediaFile = uploadEndPayload.file;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(projectId)) await (0, $YVYIZ.copyToAttachment)({
                id: projectId,
                isProjectId: true,
                mediaFile: mediaFile,
                attachmentCustomUploadURL: attachmentCustomUploadURL
            });
            else if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(issueId)) await (0, $YVYIZ.copyToAttachment)({
                id: issueId,
                isProjectId: false,
                mediaFile: mediaFile,
                attachmentCustomUploadURL: attachmentCustomUploadURL
            });
            setAttachments((currentAttachments)=>{
                const isAttachmentPresentInCurrentAttachments = currentAttachments.find((attachment)=>attachment.mediaFile.id === mediaFile.id);
                if (isAttachmentPresentInCurrentAttachments) return currentAttachments.filter((attachment)=>attachment.mediaFile.id !== mediaFile.id).concat([
                    {
                        mediaFile: mediaFile,
                        isUploading: false
                    }
                ]);
                return currentAttachments;
            });
        })();
    }, [
        issueId,
        projectId,
        attachmentCustomUploadURL
    ]);
    const onRemoveFile = (fileToBeRemoved)=>{
        setAttachments((currentAttachments)=>currentAttachments.filter((attachment)=>attachment.mediaFile.id !== fileToBeRemoved.details.id));
        if (onAttachmentSizeValidation) onAttachmentSizeValidation(false);
    };
    return {
        files: files,
        setAttachments: setAttachments,
        onUploadStart: onUploadStart,
        onUploadError: onUploadError,
        mediaClientConfig: mediaClientConfig,
        uploadConfig: uploadConfig,
        onRemoveFile: onRemoveFile,
        onUploadEnd: onUploadEnd,
        isUploading: isUploading,
        isDefaultValueInitialized: isDefaultValueInitialized,
        setDefaultValueInitialized: setDefaultValueInitialized
    };
};
var $dc16146f478a9b2f$export$2e2bcd8739ae039 = $dc16146f478a9b2f$var$useAttachments;

});
parcelRegister("YVYIZ", function(module, exports) {

$parcel$export(module.exports, "copyToAttachment", () => $553768b90e216cce$export$b9a44fdbc3de4b85);
$parcel$export(module.exports, "getAttachmentsSize", () => $553768b90e216cce$export$ed1597b81cfdb5f6);

var $lRmyA = parcelRequire("lRmyA");
const $553768b90e216cce$export$a7455b0d8bb5c44e = (projectId)=>`/rest/api/2/attachment/upload/project/${projectId}`;
const $553768b90e216cce$export$cf1f2654bf86294f = (issueId)=>`/rest/api/2/attachment/upload/issue/${issueId}`;
const $553768b90e216cce$export$b9a44fdbc3de4b85 = async (props)=>{
    const { id: id, mediaFile: mediaFile, isProjectId: isProjectId, attachmentCustomUploadURL: attachmentCustomUploadURL } = props;
    const { attachmentId: attachmentId } = await (0, $lRmyA.performPostRequest)(attachmentCustomUploadURL || (isProjectId ? $553768b90e216cce$export$a7455b0d8bb5c44e(id) : $553768b90e216cce$export$cf1f2654bf86294f(id)), {
        body: JSON.stringify({
            fileId: mediaFile.id
        })
    });
    return attachmentId;
};
const $553768b90e216cce$export$ed1597b81cfdb5f6 = (files)=>files.reduce((attachmentsSize, attachment)=>attachmentsSize + attachment.size, 0);

});


parcelRegister("gY5ty", function(module, exports) {

$parcel$export(module.exports, "AsyncAttachmentsFilmstripView", () => $81cd5bf6f2a23908$export$85605b8f3b532b83);

var $7rh0R = parcelRequire("7rh0R");

const $81cd5bf6f2a23908$export$85605b8f3b532b83 = (0, $7rh0R.lazy)(()=>(parcelRequire("8rriw")).then((module)=>module.AttachmentsFilmstripView), {
    moduleId: "./src/packages/issue/fields/attachments/src/index.tsx"
});

});
parcelRegister("8rriw", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('bg1Rz');
        const value = parcelRequire('gVr7S');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("bg1Rz").then(()=>parcelRequire('gVr7S'));
}

});


parcelRegister("9vlI9", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dd084dfab64de7a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $9dd084dfab64de7a$var$messages = (0, $90IgZ.defineMessages)({
    dropzone: {
        "id": "issue-create-commons.attachments-field.dropzone",
        "defaultMessage": "Drop files to attach or"
    },
    browse: {
        "id": "issue-create-commons.attachments-field.browse",
        "defaultMessage": "browse"
    },
    missingToken: {
        "id": "issue-create-commons.attachments-field.missing-token",
        "defaultMessage": "Something went wrong"
    }
});
var $9dd084dfab64de7a$export$2e2bcd8739ae039 = $9dd084dfab64de7a$var$messages;

});


parcelRegister("gya0p", function(module, exports) {

$parcel$export(module.exports, "MinimizableModalProvider", () => $2e13a8e8a0c7aa73$export$582a26efcd805dfd);
$parcel$export(module.exports, "useMinimizableModal", () => $2e13a8e8a0c7aa73$export$40bb90ec193b1c2f);
$parcel$export(module.exports, "TransitionState", () => (parcelRequire("9Pqox")).TransitionState);

var $eUqFw = parcelRequire("eUqFw");

var $8YJjX = parcelRequire("8YJjX");

var $1ybV0 = parcelRequire("1ybV0");

var $9Pqox = parcelRequire("9Pqox");

var $gqX0S = parcelRequire("gqX0S");
const $2e13a8e8a0c7aa73$export$a9554de703151814 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    shouldFocusChanger: false,
    view: 'modal',
    previousView: 'modal',
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setView: ()=>{},
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    unminimizeModal: ()=>{},
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onClose: ()=>{},
    transitionByKeyboardFrom: null,
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setTransitionByKeyboardFrom: ()=>{},
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setShouldFocusChanger: ()=>{},
    isTransitionInState: ()=>false,
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setTransitionState: ()=>{},
    shouldDisableViewChangerButtons: false,
    customDisabledViewChangerButtonsMessage: '',
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setShouldDisableViewChangerButtons: ()=>{},
    isNestedModal: false,
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setIsNestedModal: ()=>{},
    displayMinimizableButtons: true
});
const $2e13a8e8a0c7aa73$export$582a26efcd805dfd = ({ initialView: initialView = 'modal', view: view, onViewChange: onViewChange, onClose: onClose, children: children, displayMinimizableButtons: displayMinimizableButtons = true })=>{
    /**
	 * When view is passed in as a prop, this modal is controlled
	 * When it is not passed in, _view is used to handle the view changes when the modal is uncontrolled
	 * actualView is the view that we are displaying
	 * previousView is the previously displayed view (so that minimized knows what view to expand to)
	 */ const [_view, _setView] = (0, $eUqFw.useState)(view || initialView);
    const actualView = (0, $eUqFw.useMemo)(()=>view || _view, [
        view,
        _view
    ]);
    const previousView = (0, $gqX0S.usePrevious)(actualView, [
        'minimized'
    ]);
    const [modalState, setModalState] = (0, $eUqFw.useState)((0, $9Pqox.TransitionState).EXITED);
    const [aiEnabledState, setAiEnabledState] = (0, $eUqFw.useState)((0, $9Pqox.TransitionState).EXITED);
    const [aiEnabledMinimizedState, setaiEnabledMinimizedStateState] = (0, $eUqFw.useState)((0, $9Pqox.TransitionState).EXITED);
    const [miniState, setMiniState] = (0, $eUqFw.useState)((0, $9Pqox.TransitionState).EXITED);
    const [minimizedState, setMinimizedState] = (0, $eUqFw.useState)((0, $9Pqox.TransitionState).EXITED);
    const [fullscreenState, setFullscreenState] = (0, $eUqFw.useState)((0, $9Pqox.TransitionState).EXITED);
    const [_shouldDisableViewChangerButtons, _setShouldDisableViewChangerButtons] = (0, $eUqFw.useState)(false);
    const [_customDisabledViewChangerButtonsMessage, _setCustomDisabledViewChangerButtonsMessage] = (0, $eUqFw.useState)('');
    const [isNestedModal, setIsNestedModal] = (0, $eUqFw.useState)(false);
    const transitionByKeyboardFrom = (0, $eUqFw.useRef)(null);
    const shouldFocusChanger = (0, $eUqFw.useRef)(false);
    const currentTransitionState = (0, $eUqFw.useMemo)(()=>({
            modal: modalState,
            mini: miniState,
            minimized: minimizedState,
            fullscreen: fullscreenState,
            ...(0, $1ybV0.ff)('jira-intelligent-issue-breakdown_18syl') ? {
                'ai-enabled': aiEnabledState,
                'ai-enabled-minimized': aiEnabledMinimizedState
            } : {}
        }), [
        modalState,
        miniState,
        minimizedState,
        fullscreenState,
        aiEnabledState,
        aiEnabledMinimizedState
    ]);
    /**
	 * Will always return true if OS reduced motion is turned on since all usages of isTransitionInState
	 * are checking for a transition to be done before doing something
	 * With reduced motion its easiest to assume that the transition is always done since there are no transitions
	 */ const isTransitionInState = (0, $eUqFw.useCallback)((viewsTransitioning, state, fallbackForReducedMotion = true)=>{
        if ((0, $8YJjX.isReducedMotion)()) return fallbackForReducedMotion;
        return viewsTransitioning.every((viewTransitioning)=>currentTransitionState[viewTransitioning] === state);
    }, [
        currentTransitionState
    ]);
    const setTransitionState = (0, $eUqFw.useCallback)((viewTransitioning, state)=>{
        if (viewTransitioning === 'modal') setModalState(state);
        if (viewTransitioning === 'mini') setMiniState(state);
        if (viewTransitioning === 'minimized') setMinimizedState(state);
        if (viewTransitioning === 'fullscreen') setFullscreenState(state);
        if ((0, $1ybV0.ff)('jira-intelligent-issue-breakdown_18syl') && viewTransitioning === 'ai-enabled') setAiEnabledState(state);
        if ((0, $1ybV0.ff)('jira-intelligent-issue-breakdown_18syl') && viewTransitioning === 'ai-enabled-minimized') setaiEnabledMinimizedStateState(state);
    }, []);
    const setShouldFocusChanger = (hasTransitioned)=>{
        shouldFocusChanger.current = hasTransitioned;
    };
    const setView = (0, $eUqFw.useCallback)((newView, force = false)=>{
        if (_shouldDisableViewChangerButtons && !force) return;
        if (view) {
            if (onViewChange) onViewChange(newView);
            return;
        }
        _setView(newView);
    }, [
        _shouldDisableViewChangerButtons,
        onViewChange,
        view
    ]);
    const unminimizeModal = (0, $eUqFw.useCallback)((fallbackView)=>{
        // For the case where the user controls the view of the minimizable modal, and starts it as 'minimized'
        if (previousView === 'minimized' || previousView === 'ai-enabled-minimized') {
            setView(fallbackView);
            return;
        }
        setView(previousView);
    }, [
        setView,
        previousView
    ]);
    const setTransitionByKeyboardFrom = (0, $eUqFw.useCallback)((keyPressedFrom)=>{
        transitionByKeyboardFrom.current = keyPressedFrom;
    }, []);
    const setShouldDisableViewChangerButtons = (0, $eUqFw.useCallback)((shouldDisableViewChangerButtons, customDisabledViewChangerButtonsMessage = '')=>{
        _setShouldDisableViewChangerButtons(shouldDisableViewChangerButtons);
        _setCustomDisabledViewChangerButtonsMessage(customDisabledViewChangerButtonsMessage);
    }, []);
    const context = (0, $eUqFw.useMemo)(()=>({
            shouldFocusChanger: shouldFocusChanger.current,
            view: actualView,
            setView: setView,
            previousView: previousView,
            onClose: onClose,
            unminimizeModal: unminimizeModal,
            transitionByKeyboardFrom: transitionByKeyboardFrom.current,
            setTransitionByKeyboardFrom: setTransitionByKeyboardFrom,
            setShouldFocusChanger: setShouldFocusChanger,
            isTransitionInState: isTransitionInState,
            setTransitionState: setTransitionState,
            shouldDisableViewChangerButtons: _shouldDisableViewChangerButtons,
            customDisabledViewChangerButtonsMessage: _customDisabledViewChangerButtonsMessage,
            setShouldDisableViewChangerButtons: setShouldDisableViewChangerButtons,
            isNestedModal: isNestedModal,
            setIsNestedModal: setIsNestedModal,
            displayMinimizableButtons: displayMinimizableButtons
        }), [
        _customDisabledViewChangerButtonsMessage,
        _shouldDisableViewChangerButtons,
        actualView,
        isNestedModal,
        isTransitionInState,
        onClose,
        previousView,
        setShouldDisableViewChangerButtons,
        setTransitionByKeyboardFrom,
        setTransitionState,
        setView,
        unminimizeModal,
        displayMinimizableButtons
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2e13a8e8a0c7aa73$export$a9554de703151814.Provider, {
        value: context
    }, children);
};
const $2e13a8e8a0c7aa73$export$40bb90ec193b1c2f = ()=>{
    const context = (0, $eUqFw.useContext)($2e13a8e8a0c7aa73$export$a9554de703151814);
    if (context === undefined) throw new Error('useMinimizableModal must be used within a MinimizableModalProvider');
    return context;
};

});
parcelRegister("9Pqox", function(module, exports) {

$parcel$export(module.exports, "TransitionState", () => $9cdc0ac87a92d734$export$145c1ed87b1a2216);
const $9cdc0ac87a92d734$export$145c1ed87b1a2216 = {
    EXITED: 1,
    ENTERED: 2,
    TRANSITIONING: 3
};

});

parcelRegister("gqX0S", function(module, exports) {

$parcel$export(module.exports, "usePrevious", () => $73e9a329cdf4bfe1$export$5cae361ad82dce8b);

var $eUqFw = parcelRequire("eUqFw");
function $73e9a329cdf4bfe1$export$5cae361ad82dce8b(value, ignoreValues) {
    const ref = (0, $eUqFw.useRef)(value);
    (0, $eUqFw.useEffect)(()=>{
        if (ref.current !== value && !ignoreValues.includes(value)) ref.current = value;
    }, [
        value,
        ignoreValues
    ]);
    return ref.current;
}

});


parcelRegister("7SSqk", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f4acfb9d890500f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1f4acfb9d890500f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    missingToken: {
        "id": "issue-create.common.fields.attachments-field.missing-token",
        "defaultMessage": "Something went wrong"
    },
    attachmentSizeLimitCheck: {
        "id": "issue-create.common.fields.attachments-field.attachment-size-limit-check",
        "defaultMessage": "We couldn\u2019t upload the attachment as you\u2019ve exceeded the limit"
    }
});

});


parcelRegister("bJTcd", function(module, exports) {

$parcel$export(module.exports, "default", () => $42b8e4e77189a753$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kFGm5 = parcelRequire("kFGm5");

var $9VPEO = parcelRequire("9VPEO");

var $c9TLT = parcelRequire("c9TLT");

var $1ybV0 = parcelRequire("1ybV0");

var $icPhQ = parcelRequire("icPhQ");
var $6HoNR = parcelRequire("6HoNR");

var $9KxVf = parcelRequire("9KxVf");

var $ifBoM = parcelRequire("ifBoM");

var $gGtKh = parcelRequire("gGtKh");

var $27gnh = parcelRequire("27gnh");

var $jD3pk = parcelRequire("jD3pk");

var $6vrw7 = parcelRequire("6vrw7");

var $dWLk9 = parcelRequire("dWLk9");

var $hFagV = parcelRequire("hFagV");

var $fokXx = parcelRequire("fokXx");
const $42b8e4e77189a753$var$skeletonHeight = `${(0, $c9TLT.gridSize) * 18.75}px`;
const $42b8e4e77189a753$var$PRINCIPAL_ID = 'context';
/**
 * We use the same DescriptionField component for all fields of "paragraph" type, including custom fields
 * This constant is for the default issue description field name
 */ const $42b8e4e77189a753$var$DESCRIPTION_FIELD_DEFAULT_FIELD_NAME = 'Description';
const $42b8e4e77189a753$export$336230c809f2ec53 = (props)=>{
    const { width: width = '100%', fieldProps: { value: value, onChange: onChange, onBlur: onBlur }, selectedProject: selectedProject, defaultValue: defaultValue, additionalData: additionalData, fieldName: fieldName, autoFocus: autoFocus = false, isReadOnly: isReadOnly = false, selectedIssueType: selectedIssueType, getFormState: getFormState } = props;
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const isGICPositioningEnabled = (0, $hFagV.useIsGICPositioningEnabled)();
    // TODO Add this field with the fields on previous line when cleaning FF
    // @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value. | TS2525 - Initializer provides no value for this binding element and the binding element has no default value.
    const { onFocus: onFocusField, onBlur: onBlurField } = isGICPositioningEnabled() ? props : {};
    const { mediaContext: mediaContext, adminRichTextConfig: adminRichTextConfig } = additionalData;
    let mediaUploadContext;
    const uploadToken = mediaContext?.uploadToken;
    if (uploadToken) mediaUploadContext = {
        clientId: uploadToken.clientId,
        serviceHost: uploadToken.endpointUrl,
        collection: uploadToken.targetCollection,
        token: uploadToken.token
    };
    const product = (0, $27gnh.getProductForEditorAIPlugin)(selectedProject?.projectType);
    const issueTypeLabel = selectedIssueType?.label?.toLowerCase();
    const allowIssueReformatter = (0, $eUqFw.useMemo)(()=>(0, $1ybV0.ff)('disable-issue-reformatter-for-non-description-fields_osvmf') ? fieldName === $42b8e4e77189a753$var$DESCRIPTION_FIELD_DEFAULT_FIELD_NAME : true, [
        fieldName
    ]);
    const editorPluginAIConfig = (0, $eUqFw.useMemo)(()=>({
            editorPluginAIConfig: {
                product: product,
                isAiOptInEnabled: !!adminRichTextConfig?.aiEnabledByProject,
                allowIssueReformatter: // For more context about allowIssueReformatter option, please refer to this PR: https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/91592/overview
                allowIssueReformatter,
                getAdditionalProps: ()=>({
                        issue_type_label: issueTypeLabel,
                        issue_summary: getFormState?.()?.values.summary || ''
                    })
            }
        }), [
        product,
        adminRichTextConfig?.aiEnabledByProject,
        issueTypeLabel,
        getFormState,
        allowIssueReformatter
    ]);
    const sharedEditorConfig = (0, $27gnh.useSharedEditorConfig)(editorPluginAIConfig);
    const editorConfig = (0, $1ybV0.ff)('issue-view-admin-global-opt-in-ai') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $27gnh.useEditorConfig)(editorPluginAIConfig) : {};
    const mentionProvider = (0, $eUqFw.useRef)(new (0, $ifBoM.UserTeamProjectMentionProvider)({
        projectKey: (0, $6vrw7.toProjectKey)(`${selectedProject?.projectKey || ''}`),
        projectType: selectedProject?.projectType
    }, {
        userId: $42b8e4e77189a753$var$PRINCIPAL_ID,
        cloudId: cloudId,
        orgId: orgId
    }));
    const editorKey = (0, $eUqFw.useRef)(Date.now());
    const mediaProvider = {
        viewContext: mediaUploadContext,
        uploadContext: mediaUploadContext
    };
    let actualValue = defaultValue;
    // We are force resetting the editor using key as we could not achieve using EditorActions.replaceDocument or clear
    // We tried to pass down ref to the DescriptionEdit component and call the replaceDocument from here. Which did not work.
    // If we find a better way to achieve this, this code inside should be replaced.
    (0, $eUqFw.useEffect)(()=>{
        // @ts-expect-error - TS2339 - Property 'resetRequired' does not exist on type 'DocNode | ResetDescriptionValue | OverrideDescriptionValue'.
        if (value?.resetRequired === true) {
            editorKey.current = Date.now();
            onChange(defaultValue);
        }
    }, [
        defaultValue,
        onChange,
        value
    ]);
    // This is a similar hack to the one you see above for the case when we don't want to reset the editor to the
    // initial value but instead override the existing one with new one. It's needed for UI modifications setValue to work.
    // As above: once a better way is found, this code should be replaced.
    // UNBOX-505
    // @ts-expect-error - TS2339 - Property 'overrideRequired' does not exist on type 'DocNode | ResetDescriptionValue | OverrideDescriptionValue'.
    const overrideRequired = value?.overrideRequired || false;
    // @ts-expect-error - TS2322 - Type 'Pick<DocNode | ResetDescriptionValue | OverrideDescriptionValue, never> | undefined' is not assignable to type 'FieldValue'.
    actualValue = overrideRequired ? (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(value, 'overrideRequired') : value ?? defaultValue;
    // Since this useEffect call is in the feature-flag condition we can ignore eslint complaints
    (0, $eUqFw.useEffect)(()=>{
        if (overrideRequired === true) {
            editorKey.current = Date.now();
            onChange(actualValue);
        }
    }, [
        overrideRequired,
        onChange,
        actualValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "description-field",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
            height: $42b8e4e77189a753$var$skeletonHeight
        })
    }, isGICPositioningEnabled() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($42b8e4e77189a753$var$WrapperDiv, {
        tabIndex: -1,
        onFocus: ()=>{
            if (isGICPositioningEnabled() && onFocusField) onFocusField();
        },
        onBlur: isGICPositioningEnabled() ? onBlurField : undefined,
        "data-testid": isGICPositioningEnabled() ? 'issue-create.common.ui.fields.description-field.wrapper' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9KxVf.AsyncRichTextEditView), {
        key: editorKey.current,
        onChange: onChange,
        onBlur: onBlur,
        // @ts-expect-error - TS2322 - Type 'FieldValue' is not assignable to type 'DocNode | undefined'.
        defaultValue: actualValue,
        mentionProvider: mentionProvider.current,
        // @ts-expect-error - TS2322 - Type '{ viewContext: {}; uploadContext: { clientId: string; serviceHost: string; collection: string; token: string; } | undefined; }' is not assignable to type 'Readonly<{ uploadContext: UploadContext | null; userAuth: UserAuth | null; viewContext: ViewContext | null; }>'.
        mediaContext: mediaProvider,
        shouldFocus: autoFocus,
        isDisabled: isReadOnly,
        assistiveLabel: fieldName,
        sharedEditorConfig: (0, $1ybV0.ff)('issue-view-admin-global-opt-in-ai') ? editorConfig : sharedEditorConfig
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9KxVf.AsyncRichTextEditView), {
        key: editorKey.current,
        onChange: onChange,
        onBlur: onBlur,
        // @ts-expect-error - TS2322 - Type 'FieldValue' is not assignable to type 'DocNode | undefined'.
        defaultValue: actualValue,
        mentionProvider: mentionProvider.current,
        // @ts-expect-error - TS2741 - Property 'userAuth' is missing in type '{ viewContext: {}; uploadContext: { clientId: string; serviceHost: string; collection: string; token: string; } | undefined; }' but required in type 'Readonly<{ uploadContext: UploadContext | null; userAuth: UserAuth | null; viewContext: ViewContext | null; }>'.
        mediaContext: mediaProvider,
        shouldFocus: autoFocus,
        isDisabled: isReadOnly,
        assistiveLabel: fieldName,
        sharedEditorConfig: (0, $1ybV0.ff)('issue-view-admin-global-opt-in-ai') ? editorConfig : sharedEditorConfig
    })));
};
var $42b8e4e77189a753$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    validator: (0, $fokXx.validateDescriptionField)
})($42b8e4e77189a753$export$336230c809f2ec53);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $42b8e4e77189a753$var$WrapperDiv = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_12ji1r31 _1qu2glyw _12y31o36",
            __cmplp.className
        ])
    });
});
$42b8e4e77189a753$var$WrapperDiv.displayName = 'WrapperDiv';

});
parcelRegister("9KxVf", function(module, exports) {

$parcel$export(module.exports, "AsyncRichTextEditView", () => $c89053f88af22b51$export$ba962c8a1ae57ac);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $9VPEO = parcelRequire("9VPEO");

var $6j4bv = parcelRequire("6j4bv");

var $1HzcR = parcelRequire("1HzcR");

var $bAQOb = parcelRequire("bAQOb");

var $60V7C = parcelRequire("60V7C");

// TODO delete when cleaning ff('gic-rich-text-entrypoint_8vt3i')
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $c89053f88af22b51$var$AsyncRichTextEditViewControl = (0, $7rh0R.lazy)(()=>(parcelRequire("geIUA")).then((module)=>module.DescriptionEdit), {
    moduleId: "./src/packages/issue/fields/rich-text/src/ui/edit/index.tsx"
});
const $c89053f88af22b51$var$EMPTY_OBJECT = {};
const $c89053f88af22b51$export$7202c9d484df1552 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $6j4bv.useEntryPoint)((0, $60V7C.asyncRichTextEditEntryPoint), // use stable object reference to avoid re-renders
    $c89053f88af22b51$var$EMPTY_OBJECT);
    (0, $eUqFw.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1HzcR.JiraEntryPointContainer), {
        id: "jira-issue-field-rich-text-edit-async",
        packageName: "jira-issue-field-rich-text",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.SkeletonCompiled), {
            height: "150px"
        }),
        errorFallback: "unmount"
    });
};
const $c89053f88af22b51$export$ba962c8a1ae57ac = (0, $bAQOb.componentWithFF)('gic-rich-text-entrypoint_8vt3i', $c89053f88af22b51$export$7202c9d484df1552, $c89053f88af22b51$var$AsyncRichTextEditViewControl);

});
parcelRegister("60V7C", function(module, exports) {

$parcel$export(module.exports, "asyncRichTextEditEntryPoint", () => $64d058c077a5e888$export$153c0381975152a7);

var $1K77P = parcelRequire("1K77P");

var $7QhYz = parcelRequire("7QhYz");

const $64d058c077a5e888$export$153c0381975152a7 = (0, $7QhYz.createEntryPoint)({
    root: (0, $1K77P.JSResourceForInteraction)(()=>(parcelRequire("geIUA")).then((module)=>module.EntryPointContent), {
        moduleId: "7ade4e9b"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("geIUA", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await Promise.all([
            load('2hmUs'),
            load('bCeK4'),
            load('h2MrD'),
            load('bYT2S'),
            load('i8NOQ')
        ]);
        const value = parcelRequire('5Ucyf');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = Promise.all([
        load("2hmUs"),
        load("bCeK4"),
        load("h2MrD"),
        load("bYT2S"),
        load("i8NOQ")
    ]).then(()=>parcelRequire('5Ucyf'));
}

});



parcelRegister("ifBoM", function(module, exports) {

$parcel$export(module.exports, "UserTeamProjectMentionProvider", () => $021184d38adbbe07$export$68d633262339b833);

var $dxIU5 = parcelRequire("dxIU5");

var $ldoFd = parcelRequire("ldoFd");

var $fOYsF = parcelRequire("fOYsF");

var $9HjWu = parcelRequire("9HjWu");
const $021184d38adbbe07$var$MENTION_DEBOUNCE_MS = 150;
class $021184d38adbbe07$export$68d633262339b833 extends (0, $fOYsF.ProjectMentionProvider) {
    constructor(projectOptions, teamOptions){
        super('', projectOptions.projectKey, projectOptions.projectType);
        this.debouncedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(async (query, contextIdentifier)=>{
            const currentSearchTime = Date.now();
            try {
                const mentionResults = await Promise.all([
                    // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string'.
                    this.teamMentionProvider.getRecommendedMentions(query, contextIdentifier),
                    // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string'.
                    this.search(query, contextIdentifier)
                ]);
                // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string'.
                this.activeSearches.delete(query);
                // discard the response from previous requests
                if (currentSearchTime > this.lastSearchTime) this.lastSearchTime = currentSearchTime;
                return mentionResults.reduce((acc, mentionResult)=>{
                    if (mentionResult) acc.mentions = [
                        ...acc.mentions,
                        ...mentionResult.mentions
                    ];
                    return acc;
                }, {
                    mentions: [],
                    query: query ?? ''
                });
            } catch (e) {
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(query) && query.length > 0) this.activeSearches.delete(query);
                throw e;
            }
        }, $021184d38adbbe07$var$MENTION_DEBOUNCE_MS);
        this.teamMentionProvider = new (0, $9HjWu.TeamMentionProvider)({
            cloudId: teamOptions.cloudId,
            userId: teamOptions.userId,
            orgId: teamOptions.orgId
        });
    }
    /**
	 * We override the filter function to search and interpolate the results from both the project and team mention providers.
	 * This is so that we can only show users that have project access.
	 */ async filter(query, contextIdentifier) {
        try {
            const currentSearchTime = Date.now();
            const mentionResults = await this.debouncedSearch(query, contextIdentifier);
            const results = mentionResults ?? {
                mentions: [],
                query: query ?? ''
            };
            this._notifyListeners(results, {
                duration: Date.now() - currentSearchTime
            });
            this._notifyAllResultsListeners(results);
        } catch (e) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            this._notifyErrorListeners(e);
        }
    }
}

});
parcelRegister("fOYsF", function(module, exports) {

$parcel$export(module.exports, "ProjectMentionProvider", () => $f07853061ef561e5$export$40976f7091c70c78);

var $53ciZ = parcelRequire("53ciZ");

var $5Apwp = parcelRequire("5Apwp");
class $f07853061ef561e5$export$40976f7091c70c78 extends (0, $5Apwp.AbstractMentionProvider) {
    constructor(baseUrl, projectKey, projectType){
        super(baseUrl, projectType);
        this.getQueryString = (query)=>(0, $53ciZ.stringify)({
                query: query,
                projectKey: this.projectKey,
                maxResults: 10
            });
        this.getUrl = (queryString)=>`${this.baseUrl}/rest/api/2/user/viewissue/search?${queryString}`;
        this.shouldHighlightMention = (mention)=>mention.id === this.projectKey;
        this.projectKey = projectKey;
    }
}

});
parcelRegister("5Apwp", function(module, exports) {

$parcel$export(module.exports, "AbstractMentionProvider", () => $dbb32da3cbeebe5d$export$1503942bd70a06a4);

var $dxIU5 = parcelRequire("dxIU5");

var $ldoFd = parcelRequire("ldoFd");

var $44HQw = parcelRequire("44HQw");

var $e91YZ = parcelRequire("e91YZ");

var $2OdyW = parcelRequire("2OdyW");

var $hiBi9 = parcelRequire("hiBi9");

var $1jQHs = parcelRequire("1jQHs");
const $dbb32da3cbeebe5d$var$MENTION_DEBOUNCE_MS = 150;
class $dbb32da3cbeebe5d$export$1503942bd70a06a4 extends (0, $44HQw.AbstractMentionResource) {
    constructor(baseUrl, projectType, createAnalyticsEvent){
        super();
        this.debouncedFilter = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((query, contextIdentifier)=>{
            const currentSearchTime = Date.now();
            // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string'.
            return this.search(query, contextIdentifier).then((mentionResult)=>{
                // @ts-expect-error - TS2345 - Argument of type 'string | null | undefined' is not assignable to parameter of type 'string'.
                this.activeSearches.delete(query);
                // discard the response from previous requests
                if (currentSearchTime > this.lastSearchTime) {
                    this.lastSearchTime = currentSearchTime;
                    this._notifyListeners(mentionResult, {
                        duration: Date.now() - currentSearchTime
                    });
                }
                this._notifyAllResultsListeners(mentionResult);
            }).catch((e)=>{
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(query) && query.length > 0) this.activeSearches.delete(query);
                this._notifyErrorListeners(e);
            });
        }, $dbb32da3cbeebe5d$var$MENTION_DEBOUNCE_MS);
        this.baseUrl = baseUrl;
        this.lastSearchTime = 0;
        this.activeSearches = new Set();
        this.productName = (0, $1jQHs.subProductFromProjectType)(projectType);
        this.userRole = (0, $e91YZ.getTenantContext_DEPRECATED_DO_NOT_USE)().isAdmin ? 'admin' : 'basic';
        this.onInviteItemClick = ()=>{
            (0, $hiBi9.triggerOpenDrawer)(createAnalyticsEvent ?? null, {
                inviteFlow: 'mention'
            });
        };
        this.shouldEnableInvite = true;
    }
    isFiltering(query) {
        return this.activeSearches.has(query);
    }
    filter(query, contextIdentifier) {
        return this.debouncedFilter(query, contextIdentifier);
    }
    search(query, context) {
        const queryString = this.getQueryString(query, context);
        const url = this.getUrl(queryString);
        this.activeSearches.add(query);
        return this.fetchMentions(url).then((users)=>users.map((user)=>({
                    name: user.displayName,
                    mentionName: user.displayName,
                    nickname: user.displayName,
                    id: user.accountId,
                    avatarUrl: user.avatarUrls['48x48']
                }))).then((mentions)=>({
                query: query,
                mentions: mentions
            }));
    }
    // Allow concrete subclasses to override this method so fetch calls can be instrumented
    fetchMentions(url) {
        return (0, $2OdyW.default)(url);
    }
}

});
parcelRegister("44HQw", function(module, exports) {

$parcel$export(module.exports, "AbstractMentionResource", () => $5bd1ab4d6b90a67d$export$8576ba1ed2760927);
$parcel$export(module.exports, "isResolvingMentionProvider", () => $5bd1ab4d6b90a67d$export$ae1fce5f69858ef3);
$parcel$export(module.exports, "default", () => $5bd1ab4d6b90a67d$export$2e2bcd8739ae039);

var $16UJG = parcelRequire("16UJG");

var $hWvv0 = parcelRequire("hWvv0");

var $2In19 = parcelRequire("2In19");

var $4lC4o = parcelRequire("4lC4o");

var $dxIU5 = parcelRequire("dxIU5");
const $5bd1ab4d6b90a67d$var$MAX_QUERY_ITEMS = 100;
const $5bd1ab4d6b90a67d$var$MAX_NOTIFIED_ITEMS = 20;
const $5bd1ab4d6b90a67d$var$emptySecurityProvider = ()=>{
    return {
        params: {},
        headers: {}
    };
};
class $5bd1ab4d6b90a67d$export$4529f10aed0950d4 {
    constructor(){
        this.changeListeners = new Map();
        this.allResultsListeners = new Map();
        this.errListeners = new Map();
        this.infoListeners = new Map();
        this.analyticsListeners = new Map();
    }
    subscribe(key, callback, errCallback, infoCallback, allResultsCallback, analyticsListeners) {
        if (callback) this.changeListeners.set(key, callback);
        if (errCallback) this.errListeners.set(key, errCallback);
        if (infoCallback) this.infoListeners.set(key, infoCallback);
        if (allResultsCallback) this.allResultsListeners.set(key, allResultsCallback);
        if (analyticsListeners) this.analyticsListeners.set(key, analyticsListeners);
    }
    unsubscribe(key) {
        this.changeListeners.delete(key);
        this.errListeners.delete(key);
        this.infoListeners.delete(key);
        this.allResultsListeners.delete(key);
        this.analyticsListeners.delete(key);
    }
}
class $5bd1ab4d6b90a67d$export$8576ba1ed2760927 extends $5bd1ab4d6b90a67d$export$4529f10aed0950d4 {
    shouldHighlightMention(_mention) {
        return false;
    }
    // eslint-disable-next-line class-methods-use-this
    filter(query) {
        throw new Error(`not yet implemented.\nParams: query=${query}`);
    }
    // eslint-disable-next-line class-methods-use-this, no-unused-vars
    recordMentionSelection(_mention) {
    // Do nothing
    }
    isFiltering(_query) {
        return false;
    }
    _notifyListeners(mentionsResult, stats) {
        (0, $2In19.default)('ak-mention-resource._notifyListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.changeListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $5bd1ab4d6b90a67d$var$MAX_NOTIFIED_ITEMS), mentionsResult.query, stats);
            } catch (e) {
                // ignore error from listener
                (0, $2In19.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAllResultsListeners(mentionsResult) {
        (0, $2In19.default)('ak-mention-resource._notifyAllResultsListeners', mentionsResult && mentionsResult.mentions && mentionsResult.mentions.length, this.changeListeners);
        this.allResultsListeners.forEach((listener, key)=>{
            try {
                listener(mentionsResult.mentions.slice(0, $5bd1ab4d6b90a67d$var$MAX_NOTIFIED_ITEMS), mentionsResult.query);
            } catch (e) {
                // ignore error from listener
                (0, $2In19.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyErrorListeners(error, query) {
        this.errListeners.forEach((listener, key)=>{
            try {
                listener(error, query);
            } catch (e) {
                // ignore error from listener
                (0, $2In19.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyInfoListeners(info) {
        this.infoListeners.forEach((listener, key)=>{
            try {
                listener(info);
            } catch (e) {
                // ignore error fromr listener
                (0, $2In19.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
    _notifyAnalyticsListeners(event, actionSubject, action, attributes) {
        this.analyticsListeners.forEach((listener, key)=>{
            try {
                listener(event, actionSubject, action, attributes);
            } catch (e) {
                // ignore error from listener
                (0, $2In19.default)(`error from listener '${key}', ignoring`, e);
            }
        });
    }
}
class $5bd1ab4d6b90a67d$export$5a4331e3e1c43553 extends $5bd1ab4d6b90a67d$export$8576ba1ed2760927 {
    constructor(config){
        super();
        this.verifyMentionConfig(config);
        this.config = config;
        this.lastReturnedSearch = 0;
        this.activeSearches = new Set();
        this.productName = config.productName;
        this.shouldEnableInvite = !!config.shouldEnableInvite;
        this.onInviteItemClick = config.onInviteItemClick;
        this.userRole = config.userRole || 'basic';
        if (this.config.debounceTime) this.filter = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(this.filter, this.config.debounceTime);
    }
    shouldHighlightMention(mention) {
        if (this.config.shouldHighlightMention) return this.config.shouldHighlightMention(mention);
        return false;
    }
    notify(searchTime, mentionResult, query) {
        if (searchTime > this.lastReturnedSearch) {
            this.lastReturnedSearch = searchTime;
            this._notifyListeners(mentionResult, {
                duration: Date.now() - searchTime
            });
        } else {
            const date = new Date(searchTime).toISOString().substr(17, 6);
            (0, $2In19.default)('Stale search result, skipping', date, query); // eslint-disable-line no-console, max-len
        }
        this._notifyAllResultsListeners(mentionResult);
    }
    notifyError(error, query) {
        this._notifyErrorListeners(error, query);
        if (query) this.activeSearches.delete(query);
    }
    async filter(query, contextIdentifier) {
        try {
            const searchTime = Date.now();
            let results;
            if (!query) results = await this.initialState(contextIdentifier);
            else {
                this.activeSearches.add(query);
                const searchResponse = this.search(query, contextIdentifier);
                results = await searchResponse.mentions;
            }
            this.notify(searchTime, results, query);
        } catch (error) {
            this.notifyError(error, query);
        }
    }
    recordMentionSelection(mention, contextIdentifier) {
        return this.recordSelection(mention, contextIdentifier).then(()=>{}, (error)=>(0, $2In19.default)(`error recording mention selection: ${error}`, error));
    }
    isFiltering(query) {
        return this.activeSearches.has(query);
    }
    resolveMentionName(id) {
        if (!this.config.mentionNameResolver) return {
            id: id,
            name: '',
            status: (0, $hWvv0.MentionNameStatus).UNKNOWN
        };
        return this.config.mentionNameResolver.lookupName(id);
    }
    cacheMentionName(id, mentionName) {
        if (!this.config.mentionNameResolver) return;
        this.config.mentionNameResolver.cacheName(id, mentionName);
    }
    supportsMentionNameResolving() {
        return !!this.config.mentionNameResolver;
    }
    updateActiveSearches(query) {
        this.activeSearches.add(query);
    }
    verifyMentionConfig(config) {
        if (!config.url) throw new Error('config.url is a required parameter');
        if (!config.securityProvider) config.securityProvider = $5bd1ab4d6b90a67d$var$emptySecurityProvider;
    }
    initialState(contextIdentifier) {
        return this.remoteInitialState(contextIdentifier);
    }
    /**
	 * Clear a context object to generate query params by removing empty
	 * strings, `undefined` and empty values.
	 *
	 * @param contextIdentifier the current context identifier
	 * @returns a safe context for query encoding
	 */ clearContext(contextIdentifier = {}) {
        return Object.keys(contextIdentifier).filter((key)=>contextIdentifier[key]).reduce((context, key)=>({
                [key]: contextIdentifier[key],
                ...context
            }), {});
    }
    getQueryParams(contextIdentifier) {
        const configParams = {};
        if (this.config.containerId) configParams['containerId'] = this.config.containerId;
        if (this.config.productId) configParams['productIdentifier'] = this.config.productId;
        // if contextParams exist then it will override configParams for containerId
        return {
            ...configParams,
            ...this.clearContext(contextIdentifier)
        };
    }
    /**
	 * Returns the initial mention display list before a search is performed for the specified
	 * container.
	 *
	 * @param contextIdentifier
	 * @returns Promise
	 */ async remoteInitialState(contextIdentifier) {
        const queryParams = this.getQueryParams(contextIdentifier);
        const options = {
            path: 'bootstrap',
            queryParams: queryParams
        };
        try {
            const result = await (0, $16UJG.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $4lC4o.SLI_EVENT_TYPE), (0, $4lC4o.SliNames).INITIAL_STATE, (0, $4lC4o.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, '');
        } catch (error) {
            this._notifyAnalyticsListeners((0, $4lC4o.SLI_EVENT_TYPE), (0, $4lC4o.SliNames).INITIAL_STATE, (0, $4lC4o.Actions).FAILED);
            throw error;
        }
    }
    search(query, contextIdentifier) {
        return {
            mentions: this.remoteSearch(query, contextIdentifier)
        };
    }
    async remoteSearch(query, contextIdentifier) {
        const options = {
            path: 'search',
            queryParams: {
                query: query,
                limit: $5bd1ab4d6b90a67d$var$MAX_QUERY_ITEMS,
                ...this.getQueryParams(contextIdentifier)
            }
        };
        try {
            const result = await (0, $16UJG.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $4lC4o.SLI_EVENT_TYPE), (0, $4lC4o.SliNames).SEARCH, (0, $4lC4o.Actions).SUCCEEDED);
            return this.transformServiceResponse(result, query);
        } catch (error) {
            this._notifyAnalyticsListeners((0, $4lC4o.SLI_EVENT_TYPE), (0, $4lC4o.SliNames).SEARCH, (0, $4lC4o.Actions).FAILED);
            throw error;
        }
    }
    transformServiceResponse(result, query) {
        const mentions = result.mentions.map((mention)=>{
            let lozenge;
            if ((0, $hWvv0.isAppMention)(mention)) lozenge = mention.userType;
            else if ((0, $hWvv0.isTeamMention)(mention)) lozenge = mention.userType;
            return {
                ...mention,
                lozenge: lozenge,
                query: query
            };
        });
        return {
            ...result,
            mentions: mentions,
            query: result.query || query
        };
    }
    async recordSelection(mention, contextIdentifier) {
        const options = {
            path: 'record',
            queryParams: {
                selectedUserId: mention.id,
                ...this.getQueryParams(contextIdentifier)
            },
            requestInit: {
                method: 'POST'
            }
        };
        const sliName = (0, $hWvv0.isTeamMention)(mention) ? (0, $4lC4o.SliNames).SELECT_TEAM : (0, $4lC4o.SliNames).SELECT;
        try {
            const result = await (0, $16UJG.utils).requestService(this.config, options);
            this._notifyAnalyticsListeners((0, $4lC4o.SLI_EVENT_TYPE), sliName, (0, $4lC4o.Actions).SUCCEEDED);
            return result;
        } catch (error) {
            this._notifyAnalyticsListeners((0, $4lC4o.SLI_EVENT_TYPE), sliName, (0, $4lC4o.Actions).FAILED);
            throw error;
        }
    }
}
class $5bd1ab4d6b90a67d$export$65bd6083489bd8bb {
    constructor(statusCode, statusMessage){
        this.statusCode = statusCode;
        this.message = statusMessage;
        this.name = 'HttpError';
        this.stack = new Error().stack;
    }
}
const $5bd1ab4d6b90a67d$export$ae1fce5f69858ef3 = (p)=>!!(p && p.supportsMentionNameResolving && p.supportsMentionNameResolving());
var $5bd1ab4d6b90a67d$export$2e2bcd8739ae039 = $5bd1ab4d6b90a67d$export$5a4331e3e1c43553;

});
parcelRegister("hWvv0", function(module, exports) {

$parcel$export(module.exports, "MentionType", () => $0e3c071eb6987c64$export$2102863a3c660c6b);
$parcel$export(module.exports, "UserAccessLevel", () => $0e3c071eb6987c64$export$81124e6148ca5db0);
$parcel$export(module.exports, "UserType", () => $0e3c071eb6987c64$export$8436e53e45ffe15b);
$parcel$export(module.exports, "MentionNameStatus", () => $0e3c071eb6987c64$export$b8fa67dc54502853);
$parcel$export(module.exports, "isRestricted", () => $0e3c071eb6987c64$export$dbaa15dc1820b89a);
$parcel$export(module.exports, "isSpecialMention", () => $0e3c071eb6987c64$export$37b8dcac6198c514);
$parcel$export(module.exports, "isAppMention", () => $0e3c071eb6987c64$export$eb590c844d13454c);
$parcel$export(module.exports, "isTeamMention", () => $0e3c071eb6987c64$export$803b1379348dbfd5);
$parcel$export(module.exports, "isSpecialMentionText", () => $0e3c071eb6987c64$export$d13d4f976b36a397);
$parcel$export(module.exports, "isPromise", () => $0e3c071eb6987c64$export$4369c812aac99591);
var $0e3c071eb6987c64$export$2102863a3c660c6b;
(function(MentionType) {
    MentionType[MentionType["SELF"] = 0] = "SELF";
    MentionType[MentionType["RESTRICTED"] = 1] = "RESTRICTED";
    MentionType[MentionType["DEFAULT"] = 2] = "DEFAULT";
})($0e3c071eb6987c64$export$2102863a3c660c6b || ($0e3c071eb6987c64$export$2102863a3c660c6b = {}));
var $0e3c071eb6987c64$export$81124e6148ca5db0;
(function(UserAccessLevel) {
    UserAccessLevel[UserAccessLevel["NONE"] = 0] = "NONE";
    UserAccessLevel[UserAccessLevel["SITE"] = 1] = "SITE";
    UserAccessLevel[UserAccessLevel["APPLICATION"] = 2] = "APPLICATION";
    UserAccessLevel[UserAccessLevel["CONTAINER"] = 3] = "CONTAINER";
})($0e3c071eb6987c64$export$81124e6148ca5db0 || ($0e3c071eb6987c64$export$81124e6148ca5db0 = {}));
var $0e3c071eb6987c64$export$8436e53e45ffe15b;
(function(UserType) {
    UserType[UserType["DEFAULT"] = 0] = "DEFAULT";
    UserType[UserType["SPECIAL"] = 1] = "SPECIAL";
    UserType[UserType["APP"] = 2] = "APP";
    UserType[UserType["TEAM"] = 3] = "TEAM";
    UserType[UserType["SYSTEM"] = 4] = "SYSTEM";
})($0e3c071eb6987c64$export$8436e53e45ffe15b || ($0e3c071eb6987c64$export$8436e53e45ffe15b = {}));
var $0e3c071eb6987c64$export$b8fa67dc54502853;
(function(MentionNameStatus) {
    MentionNameStatus[MentionNameStatus["UNKNOWN"] = 0] = "UNKNOWN";
    MentionNameStatus[MentionNameStatus["SERVICE_ERROR"] = 1] = "SERVICE_ERROR";
    MentionNameStatus[MentionNameStatus["OK"] = 2] = "OK";
})($0e3c071eb6987c64$export$b8fa67dc54502853 || ($0e3c071eb6987c64$export$b8fa67dc54502853 = {}));
function $0e3c071eb6987c64$export$dbaa15dc1820b89a(accessLevel) {
    return !!accessLevel && accessLevel === $0e3c071eb6987c64$export$81124e6148ca5db0[0];
}
function $0e3c071eb6987c64$export$37b8dcac6198c514(mention) {
    return !!mention.userType && mention.userType === $0e3c071eb6987c64$export$8436e53e45ffe15b[1];
}
function $0e3c071eb6987c64$export$eb590c844d13454c(mention) {
    return mention.userType && mention.userType === $0e3c071eb6987c64$export$8436e53e45ffe15b[2];
}
function $0e3c071eb6987c64$export$803b1379348dbfd5(mention) {
    return mention.userType && mention.userType === $0e3c071eb6987c64$export$8436e53e45ffe15b[3];
}
function $0e3c071eb6987c64$export$d13d4f976b36a397(mentionText) {
    return mentionText && (mentionText === '@all' || mentionText === '@here');
}
const $0e3c071eb6987c64$export$4369c812aac99591 = (p)=>!!(p && p.then);

});

parcelRegister("2In19", function(module, exports) {

$parcel$export(module.exports, "default", () => $6aafc073576331d2$export$2e2bcd8739ae039);
let $6aafc073576331d2$var$debugEnabled = false;
let $6aafc073576331d2$var$stacktracesEnabled = false;
function $6aafc073576331d2$export$748ada60eaf985cc(enable) {
    $6aafc073576331d2$var$debugEnabled = enable;
}
function $6aafc073576331d2$export$4f7017086af31c25(enable) {
    $6aafc073576331d2$var$stacktracesEnabled = enable;
}
function $6aafc073576331d2$export$2a858f450a2f66d() {
    if ($6aafc073576331d2$var$stacktracesEnabled) // eslint-disable-next-line no-console
    console.log(new Error().stack);
}
function $6aafc073576331d2$export$2e2bcd8739ae039(msg, ...args) {
    if ($6aafc073576331d2$var$debugEnabled) // eslint-disable-next-line no-console
    console.log(msg, ...args);
}

});

parcelRegister("4lC4o", function(module, exports) {

$parcel$export(module.exports, "SLI_EVENT_TYPE", () => $dfdfb81b6234304f$export$245097525aef1262);
$parcel$export(module.exports, "SMART_EVENT_TYPE", () => $dfdfb81b6234304f$export$c724588856bbfbcf);
$parcel$export(module.exports, "SliNames", () => $dfdfb81b6234304f$export$7afb0727c7d7e8af);
$parcel$export(module.exports, "Actions", () => $dfdfb81b6234304f$export$b52183d5cfb26dc9);
$parcel$export(module.exports, "fireAnalyticsMentionEvent", () => $dfdfb81b6234304f$export$44902bc7b3f0b09f);
$parcel$export(module.exports, "buildSliPayload", () => $dfdfb81b6234304f$export$c357a2872628de7c);



var $hWvv0 = parcelRequire("hWvv0");
const $dfdfb81b6234304f$var$packageName = undefined;
const $dfdfb81b6234304f$var$packageVersion = undefined;
const $dfdfb81b6234304f$export$245097525aef1262 = 'sli';
const $dfdfb81b6234304f$export$c724588856bbfbcf = 'smart';
var $dfdfb81b6234304f$export$7afb0727c7d7e8af;
(function(SliNames) {
    SliNames["SEARCH"] = "searchUser";
    SliNames["SEARCH_TEAM"] = "searchTeam";
    SliNames["INITIAL_STATE"] = "initialState";
    SliNames["SELECT"] = "select";
    SliNames["SELECT_TEAM"] = "selectTeam";
})($dfdfb81b6234304f$export$7afb0727c7d7e8af || ($dfdfb81b6234304f$export$7afb0727c7d7e8af = {}));
var $dfdfb81b6234304f$export$5c42d9dea6d035c1;
(function(ComponentNames) {
    ComponentNames["TYPEAHEAD"] = "mentionTypeahead";
    ComponentNames["MENTION"] = "mention";
})($dfdfb81b6234304f$export$5c42d9dea6d035c1 || ($dfdfb81b6234304f$export$5c42d9dea6d035c1 = {}));
var $dfdfb81b6234304f$export$b52183d5cfb26dc9;
(function(Actions) {
    Actions["VIEWED"] = "viewed";
    Actions["CLICKED"] = "clicked";
    Actions["CLOSED"] = "closed";
    Actions["SUCCEEDED"] = "succeeded";
    Actions["FAILED"] = "failed";
})($dfdfb81b6234304f$export$b52183d5cfb26dc9 || ($dfdfb81b6234304f$export$b52183d5cfb26dc9 = {}));
const $dfdfb81b6234304f$export$a823474ae5cb9e9c = (props)=>(action, duration, userIds = [], query)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: "mentionTypeahead",
                attributes: {
                    packageName: $dfdfb81b6234304f$var$packageName,
                    packageVersion: $dfdfb81b6234304f$var$packageVersion,
                    componentName: "mention",
                    duration: Math.round(duration),
                    userIds: userIds,
                    queryLength: query ? query.length : 0
                },
                eventType: (0, $662e33bb7444ae33$export$12346a674644c156)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $ff610ba30633db9d$export$d821aa4c8afb384e));
        }
    };
const $dfdfb81b6234304f$export$44902bc7b3f0b09f = (createEvent)=>(actionSubject, action, text, id, accessLevel)=>{
        const payload = {
            action: action,
            actionSubject: actionSubject,
            eventType: (0, $662e33bb7444ae33$export$a1562d08625f5d7e),
            attributes: {
                packageName: $dfdfb81b6234304f$var$packageName,
                packageVersion: $dfdfb81b6234304f$var$packageVersion,
                componentName: "mention",
                accessLevel: accessLevel,
                isSpecial: (0, $hWvv0.isSpecialMentionText)(text),
                userId: id
            }
        };
        const event = createEvent(payload);
        event.fire((0, $ff610ba30633db9d$export$d821aa4c8afb384e));
        return event;
    };
const $dfdfb81b6234304f$export$c8b245b690e10169 = (props)=>(actionSubject, action)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = $dfdfb81b6234304f$export$c357a2872628de7c(actionSubject, action);
            props.createAnalyticsEvent(eventPayload).fire((0, $ff610ba30633db9d$export$d821aa4c8afb384e));
        }
    };
const $dfdfb81b6234304f$export$c357a2872628de7c = (actionSubject, action, attributes)=>{
    const eventPayload = {
        action: action,
        actionSubject: actionSubject,
        eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
        attributes: {
            packageName: $dfdfb81b6234304f$var$packageName,
            packageVersion: $dfdfb81b6234304f$var$packageVersion,
            componentName: "mention",
            ...attributes
        }
    };
    return eventPayload;
};
const $dfdfb81b6234304f$export$91b2fa6a0fe06408 = (props)=>(action, userId, fromCache, duration)=>{
        if (props.createAnalyticsEvent) {
            const eventPayload = {
                action: action,
                actionSubject: "mention",
                actionSubjectId: 'hydration',
                attributes: {
                    packageName: $dfdfb81b6234304f$var$packageName,
                    packageVersion: $dfdfb81b6234304f$var$packageVersion,
                    componentName: "mention",
                    userId: userId,
                    fromCache: fromCache,
                    duration: Math.round(duration)
                },
                eventType: (0, $662e33bb7444ae33$export$12346a674644c156)
            };
            const analyticsEvent = props.createAnalyticsEvent(eventPayload);
            analyticsEvent.fire((0, $ff610ba30633db9d$export$d821aa4c8afb384e));
        }
    };
// OLD Analytics
const $dfdfb81b6234304f$var$MENTION_ANALYTICS_PREFIX = 'atlassian.fabric.mention';
const $dfdfb81b6234304f$export$34ac71ce24cddec2 = (firePrivateAnalyticsEvent)=>(eventName, text, accessLevel)=>{
        if (firePrivateAnalyticsEvent) firePrivateAnalyticsEvent(`${$dfdfb81b6234304f$var$MENTION_ANALYTICS_PREFIX}.${eventName}`, {
            accessLevel: accessLevel,
            isSpecial: (0, $hWvv0.isSpecialMentionText)(text)
        });
    };

});
// same types defined in analytics-web-client but avoid creating dependency with that
const $662e33bb7444ae33$export$a1562d08625f5d7e = 'ui';
const $662e33bb7444ae33$export$947dac6c72b26f81 = 'track';
const $662e33bb7444ae33$export$f1d537d508d2945a = 'screen';
const $662e33bb7444ae33$export$12346a674644c156 = 'operational';
const $662e33bb7444ae33$export$b055de0e665cb20c = 'unknown';

const $ff610ba30633db9d$export$d821aa4c8afb384e = 'fabric-elements';



parcelRegister("1jQHs", function(module, exports) {

$parcel$export(module.exports, "subProductFromProjectType", () => $3fcd30c3ff37f410$export$246e1e2a5c86a633);

var $7ZZxN = parcelRequire("7ZZxN");
const $3fcd30c3ff37f410$var$SERVICEDESK_APPLICATION_ROLE = 'jira-servicedesk';
const $3fcd30c3ff37f410$var$SOFTWARE_APPLICATION_ROLE = 'jira-software';
const $3fcd30c3ff37f410$var$CORE_APPLICATION_ROLE = 'jira-core';
const $3fcd30c3ff37f410$export$246e1e2a5c86a633 = (projectType)=>{
    switch(projectType){
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return 'Jira Service Management';
        default:
            return 'Jira';
    }
};

});



parcelRegister("9HjWu", function(module, exports) {

$parcel$export(module.exports, "TeamMentionProvider", () => $d2b3be28e9053088$export$d113415d07aa661c);

var $c2Ntg = parcelRequire("c2Ntg");
const $d2b3be28e9053088$var$BaseSmartMentionConfigOptions = {
    env: 'prod',
    productKey: 'jira',
    includeTeams: true,
    includeUsers: false
};
class $d2b3be28e9053088$export$d113415d07aa661c extends (0, $c2Ntg.default) {
    constructor({ cloudId: cloudId, orgId: orgId, userId: userId }){
        super({
            ...$d2b3be28e9053088$var$BaseSmartMentionConfigOptions,
            siteId: cloudId,
            orgId: orgId,
            principalId: userId ?? undefined
        });
    }
}

});
parcelRegister("c2Ntg", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b17f3dad13a39f0$export$2e2bcd8739ae039);

var $44HQw = parcelRequire("44HQw");
var $hWvv0 = parcelRequire("hWvv0");

var $9KAeg = parcelRequire("9KAeg");

var $gwvLM = parcelRequire("gwvLM");

var $dYXZj = parcelRequire("dYXZj");

var $lOU4s = parcelRequire("lOU4s");
const $9b17f3dad13a39f0$var$CONTEXT_TYPE = 'Mentions';
const $9b17f3dad13a39f0$var$isSmartMentionConfigWithMentionNameResolver = (smartMentionConfig)=>!!smartMentionConfig.mentionNameResolver;
/*
 * This is a provider implementation which calls URS to provide a list of recommended users/teams to mention.
 * The entryPoint hierarchy is : Editor -> editor-core -> plugins -> mentions -> typeAhead -> getItems -> pluginState.pluginProvider.filter
 * The results are then mapped to mentionItems which have a render prop mentionToTypeaheadItem -> MentionItem
 * https://bitbucket.org/atlassian/atlassian-frontend/src/0884032d85f11f43c13532cd21f13f696b0d28a7/packages/editor/editor-core/src/plugins/mentions/index.tsx#lines-219
 *
 */ class $9b17f3dad13a39f0$var$SmartMentionResource extends (0, $44HQw.AbstractMentionResource) {
    constructor(smartMentionConfig){
        super();
        // If the product doesn't provide a mention name resolve, use the default resolver so that
        // mention names can be looked up from PRS without configuration.
        this.smartMentionConfig = $9b17f3dad13a39f0$var$isSmartMentionConfigWithMentionNameResolver(smartMentionConfig) ? smartMentionConfig : {
            ...smartMentionConfig,
            mentionNameResolver: new (0, $dYXZj.DefaultMentionNameResolver)(smartMentionConfig.baseUrl)
        };
        this.lastReturnedSearch = 0;
    }
    shouldHighlightMention(mention) {
        if (this.smartMentionConfig.shouldHighlightMention) return this.smartMentionConfig.shouldHighlightMention(mention);
        return false;
    }
    notify(searchTime, mentionResult, query) {
        if (searchTime > this.lastReturnedSearch) {
            this.lastReturnedSearch = searchTime;
            this._notifyListeners(mentionResult, {
                duration: Date.now() - searchTime
            });
        }
        this._notifyAllResultsListeners(mentionResult);
    }
    notifyError(error, query) {
        this._notifyErrorListeners(error, query);
    }
    async filter(query, contextIdentifier) {
        this.contextIdentifier = contextIdentifier;
        const searchTime = Date.now();
        try {
            let results = await this.getRecommendedMentions(query ? query : '', contextIdentifier);
            this.notify(searchTime, results, query);
        } catch (error) {
            this.notifyError(error, query);
        }
    }
    async getRecommendedMentions(query, contextIdentifier) {
        const startTime = window.performance.now();
        const conf = this.smartMentionConfig;
        const maxNumberOfResults = conf.maxNumberOfResults || 100;
        const request = {
            baseUrl: conf.baseUrl,
            context: {
                productKey: conf.productKey,
                contextType: $9b17f3dad13a39f0$var$CONTEXT_TYPE,
                principalId: conf.principalId || 'context',
                containerId: contextIdentifier && contextIdentifier.containerId,
                siteId: conf.siteId,
                organizationId: conf.orgId,
                objectId: contextIdentifier && contextIdentifier.objectId || 'undefined',
                childObjectId: contextIdentifier && contextIdentifier.childObjectId || 'undefined',
                mentionsSessionId: contextIdentifier && contextIdentifier.sessionId || 'undefined',
                sessionId: contextIdentifier && contextIdentifier.sessionId || 'undefined'
            },
            includeGroups: conf.includeGroups,
            includeTeams: conf.includeTeams,
            includeUsers: typeof conf.includeUsers === 'undefined' ? true : conf.includeUsers,
            maxNumberOfResults: maxNumberOfResults,
            searchQueryFilter: conf.searchQueryFilter,
            query: query
        };
        try {
            this._notifyAnalyticsListeners((0, $gwvLM.SMART_EVENT_TYPE), 'users', (0, $gwvLM.Actions).REQUESTED, (0, $gwvLM.defaultAttributes)(contextIdentifier));
            const users = await (0, $lOU4s.default)(request);
            const elapsedTimeMilli = window.performance.now() - startTime;
            const usersForAnalytics = (0, $gwvLM.getUsersForAnalytics)(users);
            this._notifyAnalyticsListeners((0, $gwvLM.SMART_EVENT_TYPE), 'usersRequest', (0, $gwvLM.Actions).SUCCESSFUL, {
                elapsedTimeMilli: elapsedTimeMilli,
                users: usersForAnalytics,
                displayedUsers: usersForAnalytics,
                ...(0, $gwvLM.defaultAttributes)(contextIdentifier)
            });
            const mentions = this.transformUsersToMentions(users);
            return {
                mentions: mentions,
                query: query
            };
        } catch (e) {
            const elapsedTimeMilli = window.performance.now() - startTime;
            this._notifyAnalyticsListeners((0, $gwvLM.SMART_EVENT_TYPE), 'usersRequest', (0, $gwvLM.Actions).FAILED, {
                elapsedTimeMilli: elapsedTimeMilli,
                ...(0, $gwvLM.defaultAttributes)(contextIdentifier)
            });
            throw e instanceof Error ? e : new Error(String(e));
        }
    }
    transformTeamMember(member) {
        return {
            id: member.id,
            name: member.name
        };
    }
    transformUserToMention(item) {
        const type = item.entityType;
        let defaultVals = {
            source: 'smarts'
        };
        if (type === (0, $9KAeg.EntityType).USER) {
            const user = item;
            return {
                ...defaultVals,
                id: user.id,
                accessLevel: user.accessLevel,
                avatarUrl: user.avatarUrl,
                mentionName: user.nickname || '',
                name: user.name,
                userType: user.userType
            };
        }
        if (type === (0, $9KAeg.EntityType).TEAM) {
            const team = item;
            let teamLink = '';
            const defaultTeamLink = `${window.location.origin}/people/team/${team.id}`;
            if (typeof this.smartMentionConfig.teamLinkResolver === 'function') teamLink = this.smartMentionConfig.teamLinkResolver(item.id);
            return {
                ...defaultVals,
                id: team.id,
                name: team.displayName || '',
                mentionName: team.displayName,
                avatarUrl: team.smallAvatarImageUrl,
                accessLevel: (0, $hWvv0.UserAccessLevel)[(0, $hWvv0.UserAccessLevel).CONTAINER],
                userType: (0, $hWvv0.UserType)[(0, $hWvv0.UserType).TEAM],
                lozenge: (0, $hWvv0.UserType)[(0, $hWvv0.UserType).TEAM],
                context: {
                    members: team.members ? team.members.map(this.transformTeamMember) : [],
                    includesYou: team.includesYou || false,
                    memberCount: team.memberCount || 0,
                    teamLink: teamLink || defaultTeamLink
                },
                source: 'smarts'
            };
        }
        if (type === (0, $9KAeg.EntityType).GROUP) {
            const group = item;
            return {
                ...defaultVals,
                id: group.id,
                userType: type.toLowerCase(),
                name: group.name || '',
                lozenge: type.toLowerCase()
            };
        }
        return {
            id: item.id,
            userType: (0, $9KAeg.EntityType).USER.toLowerCase(),
            avatarUrl: item.avatarUrl,
            name: item.name,
            lozenge: (0, $9KAeg.EntityType).USER.toLowerCase()
        };
    }
    transformUsersToMentions(recommendationItems) {
        return (recommendationItems || []).map(this.transformUserToMention, this).filter((user)=>!!user).map((user)=>user);
    }
    cacheMentionName(id, mentionName) {
        this.smartMentionConfig.mentionNameResolver.cacheName(id, mentionName);
    }
    resolveMentionName(id) {
        return this.smartMentionConfig.mentionNameResolver.lookupName(id);
    }
    supportsMentionNameResolving() {
        return true;
    }
    recordMentionSelection(_mention) {
        this._notifyAnalyticsListeners((0, $gwvLM.SMART_EVENT_TYPE), 'usersRequest', (0, $gwvLM.Actions).SELECTED, {
            selectedOption: _mention.id,
            ...(0, $gwvLM.defaultAttributes)(this.contextIdentifier)
        });
    }
}
var $9b17f3dad13a39f0$export$2e2bcd8739ae039 = $9b17f3dad13a39f0$var$SmartMentionResource;

});
parcelRegister("9KAeg", function(module, exports) {

$parcel$export(module.exports, "EntityType", () => $5c96f111b04fb049$export$8eda7e02f8f033b2);
var $5c96f111b04fb049$export$8eda7e02f8f033b2;
(function(EntityType) {
    EntityType["USER"] = "USER";
    EntityType["TEAM"] = "TEAM";
    EntityType["GROUP"] = "GROUP";
})($5c96f111b04fb049$export$8eda7e02f8f033b2 || ($5c96f111b04fb049$export$8eda7e02f8f033b2 = {}));

});

parcelRegister("gwvLM", function(module, exports) {

$parcel$export(module.exports, "SMART_EVENT_TYPE", () => $c0d7fc5b78b56498$export$c724588856bbfbcf);
$parcel$export(module.exports, "Actions", () => $c0d7fc5b78b56498$export$b52183d5cfb26dc9);
$parcel$export(module.exports, "defaultAttributes", () => $c0d7fc5b78b56498$export$38cd8db2db178f58);
$parcel$export(module.exports, "getUsersForAnalytics", () => $c0d7fc5b78b56498$export$e8be30a842a4b49d);
const $c0d7fc5b78b56498$export$c724588856bbfbcf = 'smart';
var $c0d7fc5b78b56498$export$b52183d5cfb26dc9;
(function(Actions) {
    Actions["REQUESTED"] = "requested";
    Actions["SUCCESSFUL"] = "successful";
    Actions["SEARCHED"] = "searched";
    Actions["FAILED"] = "failed";
    Actions["SELECTED"] = "selected";
})($c0d7fc5b78b56498$export$b52183d5cfb26dc9 || ($c0d7fc5b78b56498$export$b52183d5cfb26dc9 = {}));
const $c0d7fc5b78b56498$export$38cd8db2db178f58 = (context)=>{
    return {
        context: context?.objectId || '',
        sessionId: context?.sessionId || '',
        pickerType: 'mentions',
        source: 'smarts'
    };
};
const $c0d7fc5b78b56498$export$e8be30a842a4b49d = (users)=>{
    return users ? users.map(({ id: id, entityType: entityType })=>({
            id: id,
            type: entityType.toLowerCase()
        })) : [];
};

});

parcelRegister("dYXZj", function(module, exports) {

$parcel$export(module.exports, "DefaultMentionNameResolver", () => $7a949c317afb1c16$export$2ae0434dccdcb77e);

var $hWvv0 = parcelRequire("hWvv0");

var $epYTf = parcelRequire("epYTf");

var $72ydv = parcelRequire("72ydv");
const $7a949c317afb1c16$var$buildUsersQuery = (accountIds)=>({
        query: `query usersQuery($accountIds: [ID!]!) {
    users(accountIds: $accountIds) {
      name
      accountId
    }
  }`,
        variables: {
            accountIds: accountIds
        }
    });
const $7a949c317afb1c16$var$makeRequest = async (url, accountIds)=>{
    const query = $7a949c317afb1c16$var$buildUsersQuery(accountIds);
    return (0, $72ydv.graphqlQuery)(url, query);
};
class $7a949c317afb1c16$export$2ae0434dccdcb77e {
    constructor(baseUrl){
        this.baseUrl = baseUrl;
        this.cache = new Map();
    }
    async lookupName(id) {
        try {
            if (this.cache.has(id)) return {
                id: id,
                name: this.cache.get(id),
                status: (0, $hWvv0.MentionNameStatus).OK
            };
            const url = (0, $epYTf.PRD_CONFIG).getGraphQLUrl(this.baseUrl);
            const data = await $7a949c317afb1c16$var$makeRequest(url, [
                id
            ]);
            const userInfo = data.users?.find((user)=>user.accountId === id);
            return userInfo ? {
                id: id,
                name: userInfo.name,
                status: (0, $hWvv0.MentionNameStatus).OK
            } : {
                id: id,
                status: (0, $hWvv0.MentionNameStatus).UNKNOWN
            };
        } catch (error) {
            // on network error, return original list with label 'Unknown'
            return {
                id: id,
                status: (0, $hWvv0.MentionNameStatus).UNKNOWN
            };
        }
    }
    cacheName(id, name) {
        this.cache.set(id, name);
    }
}

});
parcelRegister("epYTf", function(module, exports) {

$parcel$export(module.exports, "PRD_CONFIG", () => $da8e218a68ae540c$export$d4fff2dfff3e2bc1);
const $da8e218a68ae540c$export$d4fff2dfff3e2bc1 = {
    getRecommendationServiceUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/v1/recommendations` : '/gateway/api/v1/recommendations';
    },
    getUsersServiceUrl (productKey) {
        return productKey === 'jira' ? `/rest/api/3/user/bulk` : `/wiki/rest/api/user/bulk`;
    },
    getGraphQLUrl (baseUrl) {
        return baseUrl ? `${baseUrl}/gateway/api/graphql` : `/gateway/api/graphql`;
    },
    getTeamsUrl (baseUrl) {
        return baseUrl ? `/${baseUrl}/gateway/api/v3/teams` : `/gateway/api/v3/teams`;
    }
};

});

parcelRegister("72ydv", function(module, exports) {

$parcel$export(module.exports, "graphqlQuery", () => $cfdb74c161d13896$export$74eb8d79ae3e02b5);
const $cfdb74c161d13896$var$buildHeaders = ()=>{
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return headers;
};
function $cfdb74c161d13896$export$74eb8d79ae3e02b5(serviceUrl, query) {
    const headers = $cfdb74c161d13896$var$buildHeaders();
    return fetch(new Request(`${serviceUrl}`, {
        method: 'POST',
        credentials: 'include',
        mode: 'cors',
        headers: headers,
        body: JSON.stringify(query)
    })).then((response)=>{
        if (!response.ok) return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
        return response;
    }).then((response)=>response.json()).then((json)=>{
        if (json.errors) return Promise.reject({
            reason: json.errors[0]?.category || 'default'
        });
        return json.data;
    });
}

});


parcelRegister("lOU4s", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ced0b91a067ff73$export$2e2bcd8739ae039);

var $epYTf = parcelRequire("epYTf");
const $6ced0b91a067ff73$var$getUserRecommendations = (request)=>{
    const url = (0, $epYTf.PRD_CONFIG).getRecommendationServiceUrl(request.baseUrl);
    return fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'content-type': 'application/json'
        },
        body: JSON.stringify({
            context: request.context,
            includeUsers: request.includeUsers,
            includeGroups: request.includeGroups,
            includeTeams: request.includeTeams,
            maxNumberOfResults: request.maxNumberOfResults,
            performSearchQueryOnly: false,
            searchQuery: {
                cpusQueryHighlights: {
                    query: '',
                    field: ''
                },
                customQuery: '',
                customerDirectoryId: '',
                filter: request.searchQueryFilter || '',
                minimumAccessLevel: 'APPLICATION',
                queryString: request.query,
                restrictTo: {
                    userIds: [],
                    groupIds: []
                },
                searchUserbase: false
            }
        })
    }).then((response)=>{
        if (response.status === 200) return response.json();
        return Promise.reject({
            message: `error calling smart service, statusCode=${response.status}, statusText=${response.statusText}`
        });
    }).then((response)=>response.recommendedUsers);
};
var $6ced0b91a067ff73$export$2e2bcd8739ae039 = $6ced0b91a067ff73$var$getUserRecommendations;

});




parcelRegister("27gnh", function(module, exports) {

$parcel$export(module.exports, "getProductForEditorAIPlugin", () => $10f80159d5d99423$export$ae2611ff27e7ff5);
$parcel$export(module.exports, "useSharedEditorConfig", () => $10f80159d5d99423$export$a74853f2a973f6f);
$parcel$export(module.exports, "useEditorConfig", () => $10f80159d5d99423$export$68f5e61568cc49bc);

var $eUqFw = parcelRequire("eUqFw");

var $bT7k5 = parcelRequire("bT7k5");

var $1F7Vk = parcelRequire("1F7Vk");

var $7ZZxN = parcelRequire("7ZZxN");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $1c02D = parcelRequire("1c02D");
var $irg9D = parcelRequire("irg9D");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $4zUUC = parcelRequire("4zUUC");

var $2ujsF = parcelRequire("2ujsF");

var $7cir5 = parcelRequire("7cir5");
const $10f80159d5d99423$var$FEEDBACK_COLLECTOR_ID = 'fb2a9bff-f1e7-4deb-b396-7bfaae5af671';
const $10f80159d5d99423$var$FEEDBACK_CONTEXT_ID = 'customfield_10047';
const $10f80159d5d99423$var$LINK_TO_PRIVACY_POLICY = 'https://www.atlassian.com/legal/privacy-policy';
const $10f80159d5d99423$var$LINK_TO_RESEARCH_GROUP = 'https://www.atlassian.com/research-group';
const $10f80159d5d99423$var$buildAdditionalFields = (props, hasUserConsent)=>{
    if (!props || !props.getAIExperience) return undefined;
    const { getAIExperience: getAIExperience, sentiment: sentiment, editorAttributes: editorAttributes } = props;
    const aiExperience = getAIExperience?.(hasUserConsent) || {};
    let feedbackMetadataStringified = `sentiment: ${sentiment}\n`;
    Object.entries({
        ...aiExperience,
        ...editorAttributes
    }).forEach((item)=>{
        feedbackMetadataStringified += `${item[0]}: ${item[1]}\n`;
    });
    return [
        {
            id: $10f80159d5d99423$var$FEEDBACK_CONTEXT_ID,
            value: feedbackMetadataStringified
        }
    ];
};
const $10f80159d5d99423$var$CanContactLabel = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $2ujsF.default).canContactText,
        values: {
            // this is done exactly as documented here: https://developer.atlassian.com/platform/localization/i18n-formatting/avoiding-concatenation/#links
            // @ts-expect-error - https://github.com/formatjs/formatjs/issues/3550 need to updated to v6 intl
            a: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                    target: "_blank",
                    href: $10f80159d5d99423$var$LINK_TO_PRIVACY_POLICY
                }, chunks)
        }
    });
const $10f80159d5d99423$var$EnrolLabel = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $2ujsF.default).improveAtlassianText,
        values: {
            // this is done exactly as documented here: https://developer.atlassian.com/platform/localization/i18n-formatting/avoiding-concatenation/#links
            // @ts-expect-error - https://github.com/formatjs/formatjs/issues/3550 need to updated to v6 intl
            a: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                    target: "_blank",
                    href: $10f80159d5d99423$var$LINK_TO_RESEARCH_GROUP
                }, chunks)
        }
    });
const $10f80159d5d99423$export$ae2611ff27e7ff5 = (projectType)=>{
    switch(projectType){
        case 0, $7ZZxN.CORE_PROJECT:
            return (0, $7cir5.Product).JWM;
        case 0, $7ZZxN.SOFTWARE_PROJECT:
            return (0, $7cir5.Product).JSW;
        case 0, $7ZZxN.SERVICE_DESK_PROJECT:
            return (0, $7cir5.Product).JSM;
        case 0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT:
            return (0, $7cir5.Product).JPD;
        default:
            return null;
    }
};
const $10f80159d5d99423$export$7543cd52952bad27 = (editorPluginAIConfig)=>{
    const isAIOptedIn = editorPluginAIConfig.isAiOptInEnabled;
    return isAIOptedIn ? 'enabled' : 'disabled';
};
const $10f80159d5d99423$export$ff2962de2b2c930f = (product)=>{
    switch(product){
        case (0, $7cir5.Product).JSW:
            return 'jira-software';
        case (0, $7cir5.Product).JPD:
            return 'jpd';
        case (0, $7cir5.Product).JSM:
            return 'jsm';
        default:
            return 'jira';
    }
};
const $10f80159d5d99423$export$a74853f2a973f6f = ({ editorPluginAIConfig: editorPluginAIConfig })=>{
    const { openFeedbackCollector: openFeedbackCollector } = (0, $irg9D.useFeedbackCollectorActions)();
    const editorPluginAI = (0, $eUqFw.useMemo)(()=>{
        if (!editorPluginAIConfig?.product) return undefined;
        const optInStatus = $10f80159d5d99423$export$7543cd52952bad27(editorPluginAIConfig);
        const editorPluginAIProvider = (0, $1F7Vk.createJiraEditorPluginAIProvider)({
            generativeAIApiUrl: '/gateway/api/editor-ai/v1/generative/ai',
            product: editorPluginAIConfig.product,
            allowIssueReformatter: editorPluginAIConfig.product === (0, $7cir5.Product).JSW && editorPluginAIConfig?.allowIssueReformatter,
            getAdditionalProps: editorPluginAIConfig?.getAdditionalProps,
            handleFeedbackSubmission: async ({ sentiment: sentiment, editorAttributes: editorAttributes, getAIExperience: getAIExperience })=>{
                try {
                    openFeedbackCollector({
                        entrypointId: (0, $1c02D.ENTRY_POINT_ID_GENERATIVE_AI),
                        feedbackCollectorId: $10f80159d5d99423$var$FEEDBACK_COLLECTOR_ID,
                        feedbackContext: [
                            {
                                id: 'sentiment',
                                value: sentiment
                            },
                            ...Object.entries(getAIExperience?.() ?? {}).map(([id, value])=>({
                                    id: id,
                                    value: value
                                })),
                            ...Object.entries(editorAttributes).map(([id, value])=>({
                                    id: id,
                                    value: value
                                }))
                        ]
                    });
                    return {
                        status: 'submitted'
                    };
                } catch (error) {
                    (0, $gUUjF.default).safeErrorWithoutCustomerData('platforms.utils.shared-editor-config.entry', 'Error sending feedback submission', error instanceof Error ? error : undefined);
                    return {
                        status: 'failed'
                    };
                }
            }
        });
        return (0, $1F7Vk.createJiraEditorPluginAI)({
            editorPluginAIProvider: editorPluginAIProvider,
            aiGlobalOptIn: {
                status: optInStatus,
                // Replace with lodash/noop
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                triggerOptInFlow: ()=>{}
            }
        }).editorPluginAI;
    }, [
        editorPluginAIConfig,
        openFeedbackCollector
    ]);
    return {
        dangerouslyAppendPlugins: {
            __plugins: editorPluginAI ? [
                editorPluginAI
            ] : []
        }
    };
};
const $10f80159d5d99423$export$68f5e61568cc49bc = ({ editorPluginAIConfig: editorPluginAIConfig })=>{
    const { openFeedbackCollector: openFeedbackCollector, updateCustomRenderComponent: updateCustomRenderComponent, updateAdditionalFields: updateAdditionalFields } = (0, $irg9D.useFeedbackCollectorActions)();
    const { optInStatus: optInStatus, triggerOptInFlow: triggerOptInFlow, AIOptInModal: AIOptInModal } = (0, $4zUUC.useAIOptIn)({
        editorPluginAIConfig: editorPluginAIConfig
    });
    const [hasUserConsent, setHasUserConsent] = (0, $eUqFw.useState)(false);
    const [additionalFieldsData, setAdditionalFieldsData] = (0, $eUqFw.useState)(null);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const handleHasUserConsent = (0, $eUqFw.useCallback)(()=>{
        setHasUserConsent(!hasUserConsent);
        updateAdditionalFields($10f80159d5d99423$var$buildAdditionalFields(additionalFieldsData, !hasUserConsent));
    }, [
        hasUserConsent,
        additionalFieldsData,
        updateAdditionalFields
    ]);
    const renderCustomFeedbackContent = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
            label: formatMessage((0, $2ujsF.default).userConsentCheckboxLabel),
            onChange: handleHasUserConsent,
            isChecked: hasUserConsent
        }), [
        hasUserConsent,
        formatMessage,
        handleHasUserConsent
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if ((0, $1ybV0.ff)('issue.details.update-jira-editor-ai-feedback-collector_qv6kk')) updateCustomRenderComponent(renderCustomFeedbackContent);
    }, [
        renderCustomFeedbackContent,
        updateCustomRenderComponent
    ]);
    const editorPluginAI = (0, $eUqFw.useMemo)(()=>{
        if (!editorPluginAIConfig?.product) return undefined;
        const editorPluginAIProvider = (0, $1F7Vk.createJiraEditorPluginAIProvider)({
            generativeAIApiUrl: '/gateway/api/editor-ai/v1/generative/ai',
            product: editorPluginAIConfig.product,
            allowIssueReformatter: editorPluginAIConfig.product === (0, $7cir5.Product).JSW && editorPluginAIConfig?.allowIssueReformatter,
            getAdditionalProps: editorPluginAIConfig?.getAdditionalProps,
            handleFeedbackSubmission: async ({ sentiment: sentiment, editorAttributes: editorAttributes, getAIExperience: getAIExperience })=>{
                const feedbackCollectorPropsOld = {
                    entrypointId: (0, $1c02D.ENTRY_POINT_ID_GENERATIVE_AI),
                    feedbackCollectorId: $10f80159d5d99423$var$FEEDBACK_COLLECTOR_ID,
                    feedbackContext: [
                        {
                            id: 'sentiment',
                            value: sentiment
                        },
                        ...Object.entries(getAIExperience?.(hasUserConsent) ?? {}).map(([id, value])=>({
                                id: id,
                                value: value
                            })),
                        ...Object.entries(editorAttributes).map(([id, value])=>({
                                id: id,
                                value: value
                            }))
                    ]
                };
                // @ts-expect-error plugin issue
                const feedbackContextData = {
                    getAIExperience: getAIExperience,
                    sentiment: sentiment,
                    editorAttributes: editorAttributes
                };
                const feedbackCollectorProps = {
                    entrypointId: (0, $1c02D.ENTRY_POINT_ID_GENERATIVE_AI),
                    feedbackTitle: formatMessage((0, $2ujsF.default).feedBackTitle),
                    feedbackCollectorId: $10f80159d5d99423$var$FEEDBACK_COLLECTOR_ID,
                    renderCustomContent: renderCustomFeedbackContent,
                    showTypeField: false,
                    summaryPlaceholder: formatMessage((0, $2ujsF.default).summaryPlaceholder),
                    additionalFields: $10f80159d5d99423$var$buildAdditionalFields(feedbackContextData, hasUserConsent),
                    canBeContactedLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($10f80159d5d99423$var$CanContactLabel, null),
                    enrolInResearchLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($10f80159d5d99423$var$EnrolLabel, null)
                };
                if ((0, $1ybV0.ff)('issue.details.update-jira-editor-ai-feedback-collector_qv6kk')) setAdditionalFieldsData(feedbackContextData);
                try {
                    openFeedbackCollector((0, $1ybV0.ff)('issue.details.update-jira-editor-ai-feedback-collector_qv6kk') ? feedbackCollectorProps : feedbackCollectorPropsOld);
                    return {
                        status: 'submitted'
                    };
                } catch (error) {
                    (0, $gUUjF.default).safeErrorWithoutCustomerData('platforms.utils.shared-editor-config.entry', 'Error sending feedback submission', error instanceof Error ? error : undefined);
                    return {
                        status: 'failed'
                    };
                }
            }
        });
        return (0, $1F7Vk.createJiraEditorPluginAI)({
            editorPluginAIProvider: editorPluginAIProvider,
            aiGlobalOptIn: {
                status: optInStatus,
                triggerOptInFlow: triggerOptInFlow
            }
        }).editorPluginAI;
    }, [
        hasUserConsent,
        optInStatus,
        triggerOptInFlow,
        editorPluginAIConfig,
        openFeedbackCollector,
        formatMessage,
        renderCustomFeedbackContent
    ]);
    return {
        props: {
            dangerouslyAppendPlugins: {
                __plugins: editorPluginAI ? [
                    editorPluginAI
                ] : []
            }
        },
        components: {
            AIOptInModal: AIOptInModal
        }
    };
};

});
parcelRegister("1F7Vk", function(module, exports) {

$parcel$export(module.exports, "createJiraEditorPluginAIProvider", () => $135fc43e23a4b0e8$export$9e0c22f6cd8535b3);
$parcel$export(module.exports, "createJiraEditorPluginAI", () => $135fc43e23a4b0e8$export$d3b8c68e72134ac3);
/**
 * We may eventually need to split the Jira presets out to the various
 * - JSW
 * - JSM
 * - JWM
 * - JPD
 *
 * Variations, however we'll start simple for now.
 */ /**
 * Please reference
 * https://hello.atlassian.net/wiki/spaces/CONF/pages/2714833063/Gen+AI+in+Editor+EAP2+-+Product-specific+requirements
 * Also see: https://hello.atlassian.net/wiki/spaces/EDAI/pages/2731933104/Editor+AI+EAP+Part+2+Dev+Documentation+Prebuilt+Providers+Plugin+Presets
 */ 
var $3F75R = parcelRequire("3F75R");

var $8ae7G = parcelRequire("8ae7G");

var $4wVbQ = parcelRequire("4wVbQ");

var $56bKX = parcelRequire("56bKX");

var $47oBW = parcelRequire("47oBW");

var $atNpT = parcelRequire("atNpT");

var $3w1uM = parcelRequire("3w1uM");

var $fHj8R = parcelRequire("fHj8R");

var $eeljI = parcelRequire("eeljI");

var $6BHl7 = parcelRequire("6BHl7");

var $bF9YU = parcelRequire("bF9YU");

var $XHGTv = parcelRequire("XHGTv");

var $ix5LP = parcelRequire("ix5LP");
const $135fc43e23a4b0e8$export$9e0c22f6cd8535b3 = (props)=>{
    var _props$disableInterro;
    // Now deprecated - migrate to handleFeedbackSubmission
    const onExperienceEvent = (props === null || props === void 0 ? void 0 : props.onExperienceEvent) || {
        THUMBS_UP: ()=>{},
        THUMBS_DOWN: ()=>{},
        REVIEW_STATE_ENTERED: ()=>{},
        EXPERIENCE_COMPLETE: ()=>{}
    };
    const reformatWithTemplate = (0, $XHGTv.getBooleanFF)('platform.reformat-issue-with-template-in-jira_jc0pb') && props.allowIssueReformatter ? [
        (0, $ix5LP.reformatWithTemplateConfigItem)({
            getAdditionalProps: props.getAdditionalProps || (()=>({}))
        })
    ] : [];
    return (0, $eeljI.createEditorPluginAIProvider)({
        disableAISelectionToolbar: !(0, $XHGTv.getBooleanFF)('platform.editor.ai-use-selection-toolbar_xosiv'),
        emptyConfig: {
            baseGenerate: (0, $4wVbQ.generateContentConfigItem),
            getSuggestions () {
                if ((0, $XHGTv.getBooleanFF)('platform.reformat-issue-with-template-in-jira_jc0pb')) return [
                    ...reformatWithTemplate,
                    (0, $56bKX.summarizePageConfigItem),
                    (0, $3w1uM.improveWriting),
                    (0, $3w1uM.fixSpellingAndGrammar),
                    (0, $6BHl7.brainstormConfigItem),
                    (0, $47oBW.shortenConfigItem),
                    (0, $fHj8R.professionalTone),
                    (0, $fHj8R.empatheticTone),
                    (0, $fHj8R.casualTone),
                    (0, $fHj8R.neutralTone),
                    (0, $fHj8R.educationalTone)
                ];
                return [
                    (0, $56bKX.summarizePageConfigItem),
                    (0, $3w1uM.improveWriting),
                    (0, $3w1uM.fixSpellingAndGrammar),
                    (0, $6BHl7.brainstormConfigItem),
                    (0, $47oBW.shortenConfigItem),
                    (0, $fHj8R.professionalTone),
                    (0, $fHj8R.empatheticTone),
                    (0, $fHj8R.casualTone),
                    (0, $fHj8R.neutralTone),
                    (0, $fHj8R.educationalTone)
                ];
            }
        },
        rangeConfig: {
            baseGenerate: (0, $bF9YU.generateFromSelectionConfigItem),
            getSuggestions () {
                if ((0, $XHGTv.getBooleanFF)('platform.reformat-issue-with-template-in-jira_jc0pb')) return [
                    ...reformatWithTemplate,
                    (0, $atNpT.summarizeConfigItem),
                    (0, $3w1uM.improveWriting),
                    (0, $3w1uM.fixSpellingAndGrammar),
                    (0, $47oBW.shortenConfigItem),
                    (0, $fHj8R.professionalTone),
                    (0, $fHj8R.empatheticTone),
                    (0, $fHj8R.casualTone),
                    (0, $fHj8R.neutralTone),
                    (0, $fHj8R.educationalTone)
                ];
                return [
                    (0, $atNpT.summarizeConfigItem),
                    (0, $3w1uM.improveWriting),
                    (0, $3w1uM.fixSpellingAndGrammar),
                    (0, $47oBW.shortenConfigItem),
                    (0, $fHj8R.professionalTone),
                    (0, $fHj8R.empatheticTone),
                    (0, $fHj8R.casualTone),
                    (0, $fHj8R.neutralTone),
                    (0, $fHj8R.educationalTone)
                ];
            }
        },
        generativeAIApiUrl: props.generativeAIApiUrl,
        product: props.product,
        getFetchCustomHeaders: (props === null || props === void 0 ? void 0 : props.getFetchCustomHeaders) || (0, $8ae7G._getFetchCustomHeaders),
        onExperienceEvent: onExperienceEvent,
        handleFeedbackSubmission: props === null || props === void 0 ? void 0 : props.handleFeedbackSubmission,
        AIButtonWrapper: props.AIButtonWrapper,
        PromptEditor: props.PromptEditor,
        disableInterrogation: (_props$disableInterro = props.disableInterrogation) !== null && _props$disableInterro !== void 0 ? _props$disableInterro : false,
        proactiveAIConfig: {
            ...(0, $8ae7G.deriveProactiveAIConfig)(),
            ...props.proactiveAIConfig
        }
    });
};
const $135fc43e23a4b0e8$export$d3b8c68e72134ac3 = ({ editorPluginAIProvider: editorPluginAIProvider, aiGlobalOptIn: /**
   * While you don't have a aiGlobalOptIn setup, you can pass in a dummy
   * object with the status set to 'enabled' and a no-op triggerOptInFlow
   *
   * @example
   * ```ts
   * const editorPluginAI = createJiraEditorPluginAI({
   *  editorPluginAIProvider,
   *  aiGlobalOptIn: { status: 'enabled', triggerOptInFlow: () => {} },
   * });
   * ```
   *
   * Before setting up the opt-in nag, you may want to refactor to use the
   * disabled state, rather than the dynamically added plugin strategy.
   *
   * @example
   * ```ts
   * const editorPluginAI = createJiraEditorPluginAI({
   *  editorPluginAIProvider,
   *  aiGlobalOptIn: { status: aiOptInStatus ? 'enabled' : 'disabled', triggerOptInFlow: () => {} },
   * });
   * ```
   *
   */ aiGlobalOptIn })=>{
    const editorPluginAI = new (0, $3F75R.EditorPluginAI)({
        editorPluginAIProvider: editorPluginAIProvider,
        aiGlobalOptIn: aiGlobalOptIn
    });
    return {
        editorPluginAI: editorPluginAI,
        nextEditorPluginAI: (0, $3F75R.NextEditorPluginAI)
    };
};

});
parcelRegister("3F75R", function(module, exports) {

$parcel$export(module.exports, "EditorPluginAI", () => $2aaab40de427366f$export$dcf9e5d3b3228e1f);
$parcel$export(module.exports, "NextEditorPluginAI", () => $2aaab40de427366f$export$7825a101a7e6b70b);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $fBDHJ = parcelRequire("fBDHJ");

var $kpTIW = parcelRequire("kpTIW");

var $dIobN = parcelRequire("dIobN");

var $XHGTv = parcelRequire("XHGTv");

var $epPZ1 = parcelRequire("epPZ1");

var $a7I3b = parcelRequire("a7I3b");

var $byn9U = parcelRequire("byn9U");

var $3NkaD = parcelRequire("3NkaD");

var $h5CUW = parcelRequire("h5CUW");

var $21dqI = parcelRequire("21dqI");

var $3zwnb = parcelRequire("3zwnb");

var $2KDKi = parcelRequire("2KDKi");

var $eUgBc = parcelRequire("eUgBc");

var $1Mxcu = parcelRequire("1Mxcu");

var $cSyJ8 = parcelRequire("cSyJ8");

var $3S4st = parcelRequire("3S4st");

var $djrA4 = parcelRequire("djrA4");

var $iTCOg = parcelRequire("iTCOg");

var $99bKD = parcelRequire("99bKD");

var $3Ycnu = parcelRequire("3Ycnu");

var $9O1Gs = parcelRequire("9O1Gs");

var $9jzX6 = parcelRequire("9jzX6");

var $eJsil = parcelRequire("eJsil");

var $R7bnX = parcelRequire("R7bnX");

var $b6fWz = parcelRequire("b6fWz");

var $74tSh = parcelRequire("74tSh");

var $9PopJ = parcelRequire("9PopJ");

var $dWb99 = parcelRequire("dWb99");

var $7NjJC = parcelRequire("7NjJC");

var $2VOb5 = parcelRequire("2VOb5");

var $cSjNj = parcelRequire("cSjNj");

var $iFWYD = parcelRequire("iFWYD");

var $2eiCd = parcelRequire("2eiCd");

var $j9fWg = parcelRequire("j9fWg");

var $cDGhz = parcelRequire("cDGhz");

var $2fbrZ = parcelRequire("2fbrZ");

var $iGVse = parcelRequire("iGVse");

var $fmQ5E = parcelRequire("fmQ5E");

var $bAoVQ = parcelRequire("bAoVQ");
const $2aaab40de427366f$var$GlobalWrapper = ({ children: children })=>{
    const aiThemeColor = (0, $epPZ1.useAIThemeColor)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $byn9U.Global), {
        styles: (0, $9jzX6.globalStyles)(aiThemeColor)
    }), children);
};
class $2aaab40de427366f$export$dcf9e5d3b3228e1f {
    // Facade EditorPlugin methods
    constructor({ editorPluginAIProvider: editorPluginAIProvider, aiGlobalOptIn: aiGlobalOptIn }){
        (0, $5zQU9.default)(this, "name", 'aiExperience');
        this.editorPluginAIProvider = editorPluginAIProvider;
        if (aiGlobalOptIn.status === 'disabled') return;
        this.nextPlugin = $2aaab40de427366f$export$7825a101a7e6b70b({
            config: {
                editorPluginAIProvider: editorPluginAIProvider,
                aiGlobalOptIn: aiGlobalOptIn
            }
        });
        this.pluginsOptions = this.nextPlugin.pluginsOptions;
        this.pmPlugins = this.nextPlugin.pmPlugins;
        this.primaryToolbarComponent = this.nextPlugin.primaryToolbarComponent;
        this.contentComponent = this.nextPlugin.contentComponent;
    }
}
const $2aaab40de427366f$export$7825a101a7e6b70b = ({ config: { editorPluginAIProvider: editorPluginAIProvider, aiGlobalOptIn: aiGlobalOptIn }, api: api })=>{
    var _editorPluginAIProvid, _editorPluginAIProvid2;
    let editorView;
    const setEditorView = (newEditorView)=>{
        editorView = newEditorView;
    };
    let providerFactory;
    const setProviderFactory = (newProviderFactory)=>{
        providerFactory = newProviderFactory;
    };
    let newIDMap = {};
    const updateIdMap = ({ idMap: idMap, selectionType: selectionType })=>{
        newIDMap = idMap;
    };
    // TODO: clean up once this version is implemented in confluence and aiGlobalOptIn is made mandatory
    const aiOptIn = aiGlobalOptIn || {
        status: 'enabled',
        triggerOptInFlow: ()=>{}
    };
    const isFullPageExperimentsEnabled = !!editorPluginAIProvider.isFullPageExperimentsEnabled;
    const isRealtimeSGEnabled = !!(0, $XHGTv.getBooleanFF)('platform.editor.ai-real-time-spelling-and-grammar_mtaik');
    const isProactiveAISupported = Boolean(isRealtimeSGEnabled && !!((_editorPluginAIProvid = editorPluginAIProvider.proactiveAIConfig) !== null && _editorPluginAIProvid !== void 0 && _editorPluginAIProvid.apiUrl) && ((_editorPluginAIProvid2 = editorPluginAIProvider.proactiveAIConfig) === null || _editorPluginAIProvid2 === void 0 ? void 0 : _editorPluginAIProvid2.enabled));
    const quickInsert = (intl)=>{
        const configItems = [];
        const { baseGenerate: baseGenerate, getSuggestions: getSuggestions, disableQuickInsert: disableQuickInsert } = editorPluginAIProvider.emptyConfig;
        if (!disableQuickInsert) configItems.push(baseGenerate, ...getSuggestions({}));
        const quickInsertItems = (0, $3NkaD.mapConfigItemsToQuickInsertItems)({
            configItems: configItems,
            formatMessage: intl.formatMessage,
            aiGlobalOptIn: aiOptIn,
            // The editor view will always be available when quick insert items are being created
            editorView: editorView
        });
        return quickInsertItems;
    };
    if ((0, $XHGTv.getBooleanFF)('platform.editor.ai-dynamic-show-hide-quick-insert-items_4ie8s')) // Ignore to allow current editor-plugin-ai version to be adopted
    // without causing type issues if the corresponding editor-common version
    // isn't adopted at the same time.
    // @ts-ignore-next-line
    quickInsert.disableMemo = true;
    return {
        name: 'aiExperience',
        pmPlugins: ()=>{
            const plugins = [
                {
                    name: 'ai-experience-actor',
                    plugin: ()=>new (0, $R7bnX.SafePlugin)({
                            view: (editorView)=>{
                                // This sets up an [actor](https://xstate.js.org/docs/guides/actors.html#actor-api) using
                                // the editor-plugin-ai machine and starts it up.
                                const editorPluginAIActor = (0, $b6fWz.aiActorCache).getActor(editorView);
                                return {
                                    destroy: ()=>{
                                        // This cleansup any listeners from the actor -- to ensure we don't leak memory.
                                        editorPluginAIActor === null || editorPluginAIActor === void 0 || editorPluginAIActor.stop();
                                        (0, $b6fWz.aiActorCache).delete(editorView);
                                    }
                                };
                            }
                        })
                },
                {
                    name: 'aiExperience',
                    plugin: (options)=>(0, $21dqI.createDecorationPlugin)({
                            dispatchAnalyticsEvent: options.dispatchAnalyticsEvent,
                            dispatch: options.dispatch,
                            api: api
                        })
                },
                {
                    name: 'ai-experience-get-editor-view-and-provider-factory',
                    plugin: (options)=>{
                        setProviderFactory(options.providerFactory);
                        return (0, $h5CUW.createGetEditorViewPlugin)({
                            setEditorView: setEditorView
                        });
                    }
                },
                {
                    name: 'ai-experience-ai-button',
                    plugin: (options)=>(0, $cSyJ8.createAIButtonPlugin)({
                            dispatch: options.dispatch
                        })
                },
                {
                    name: 'ai-experience-selection-preview',
                    plugin: ()=>(0, $9PopJ.createSelectionPreviewPlugin)()
                },
                {
                    name: 'ai-experience-floating-ai-button-tracker',
                    plugin: (options)=>(0, $2VOb5.createAskAIButtonTrackerPlugin)({
                            dispatch: options.dispatch
                        })
                }
            ];
            if (isProactiveAISupported) plugins.push({
                name: 'ai-spelling-grammar-plugin',
                plugin: ({ dispatch: dispatch, getIntl: getIntl })=>{
                    return (0, $7NjJC.createAISpellingGrammarPlugin)({
                        dispatch: dispatch,
                        getIntl: getIntl,
                        proactiveAIConfig: editorPluginAIProvider.proactiveAIConfig
                    });
                }
            });
            if (!(0, $XHGTv.getBooleanFF)('platform.editor.enable-selection-toolbar_ucdwd')) plugins.push({
                name: 'ai-patch-annotation-floating-toolbar',
                plugin: (options)=>(0, $1Mxcu.createPatchAnnotationFloatingToolbarPlugin)({
                        getIntl: options.getIntl,
                        rangeConfig: editorPluginAIProvider.rangeConfig,
                        aiGlobalOptIn: aiOptIn
                    })
            });
            if (isFullPageExperimentsEnabled && (0, $XHGTv.getBooleanFF)('platform.editor.ai-suggest-title-in-title-toolbar_h3ww0')) {
                0, $2eiCd.createAISuggestTitleFromTitleToolbarPlugin;
                plugins.push({
                    name: 'ai-suggest-title-from-title-toolbar',
                    plugin: (_options)=>(0, $2eiCd.createAISuggestTitleFromTitleToolbarPlugin)({
                            aiGlobalOptIn: aiOptIn
                        })
                });
            }
            if ((0, $bAoVQ.isAIPanelsEnabled)()) plugins.push({
                name: 'ai-panels',
                plugin: ()=>(0, $fmQ5E.createAIPanelsPlugin)()
            });
            const persistentPlaceholderCohort = (0, $3Ycnu.getExperimentCohort)('editor_ai_-_persistent_placeholder_experiment');
            const isPersistentPlaceholderEnabled = (0, $3Ycnu.isExperimentEnabled)('editor_ai_-_persistent_placeholder_experiment');
            if (isFullPageExperimentsEnabled && persistentPlaceholderCohort === 'persistent-placeholder' && isPersistentPlaceholderEnabled && aiOptIn.status === 'enabled') plugins.push({
                name: 'ai-patch-editor-placeholder-plugin',
                plugin: (options)=>(0, $dWb99.createAIPlaceholderPlugin)({
                        getIntl: options.getIntl,
                        api: api
                    })
            });
            return plugins;
        },
        actions: {
            triggerAIPanelFeedbackCollector: (extensionKey, markdown, locale, fireAnalyticsEvent)=>{
                return (0, $cDGhz.triggerAIPanelFeedbackCollector)({
                    extensionKey: extensionKey,
                    markdown: markdown,
                    locale: locale,
                    editorPluginAIProvider: editorPluginAIProvider,
                    fireAnalyticsEvent: fireAnalyticsEvent
                });
            },
            getInitialAIPanelContext: ({ intl: intl, configItem: configItem, intentSchemaId: intentSchemaId })=>{
                return (0, $cDGhz.getAIPanelContext)({
                    configItem: configItem,
                    intentSchemaId: intentSchemaId,
                    editorView: editorView,
                    providerFactory: providerFactory,
                    idMap: newIDMap,
                    intl: intl,
                    updateIdMap: updateIdMap
                });
            },
            summariseDocument: (callback, intl, initialContext)=>{
                (0, $cDGhz.summarisePage)({
                    editorView: editorView,
                    generativeAIApiUrl: editorPluginAIProvider.generativeAIApiUrl,
                    product: editorPluginAIProvider.product,
                    callback: callback,
                    intl: intl,
                    initialContext: initialContext
                });
            },
            findActionItems: (callback, intl, initialContext)=>{
                (0, $cDGhz.findActionItems)({
                    editorView: editorView,
                    generativeAIApiUrl: editorPluginAIProvider.generativeAIApiUrl,
                    product: editorPluginAIProvider.product,
                    callback: callback,
                    intl: intl,
                    initialContext: initialContext
                });
            },
            convertExtension: (localId, extensionKey, addToHistory)=>{
                (0, $cDGhz.convertExtension)({
                    editorView: editorView,
                    localId: localId,
                    extensionKey: extensionKey,
                    idMap: newIDMap,
                    addToHistory: addToHistory
                });
            },
            regenerateExtension: (localId, extensionKey)=>{
                (0, $cDGhz.regenerateExtension)({
                    editorView: editorView,
                    localId: localId,
                    extensionKey: extensionKey,
                    idMap: newIDMap
                });
            }
        },
        pluginsOptions: {
            selectionToolbar: (state, intl)=>{
                const items = [];
                if (editorPluginAIProvider.disableAISelectionToolbar) return;
                const aiDropdowns = (0, $74tSh.getAIExperienceDropdowns)({
                    intl: intl,
                    rangeConfig: editorPluginAIProvider.rangeConfig,
                    aiGlobalOptIn: aiOptIn
                });
                const aiIconButton = (0, $74tSh.getAIExperienceButton)({
                    intl: intl,
                    rangeBaseGenerate: editorPluginAIProvider.rangeConfig.baseGenerate,
                    hideTitle: !!aiDropdowns.length,
                    aiGlobalOptIn: aiOptIn
                });
                if ((0, $XHGTv.getBooleanFF)('platform.editor.enable-selection-toolbar_ucdwd')) items.push(aiIconButton, ...aiDropdowns);
                return {
                    // make sure the AI button is after the comment button in Confluence
                    rank: -10,
                    isToolbarAbove: true,
                    items: items
                };
            },
            quickInsert: quickInsert,
            floatingToolbar: (0, $iGVse.getFloatingToolbarConfig)()
        },
        contentComponent: ({ editorView: editorView, wrapperElement: wrapperElement, appearance: appearance })=>{
            // We use this point to render the modal if needed instead of decorators
            // The reason this is preferrable is it has access to mount points
            // where decorators are rendered with a mount point within the Editor content
            // and longer modals get clipped as a result.
            const renderModalRegion = (aiExperienceDecorationPluginState)=>{
                // If there are no active decorations -- then we don't want to render the ai experience.
                if (!aiExperienceDecorationPluginState || aiExperienceDecorationPluginState.modalDecorationSet === (0, $fBDHJ.DecorationSet).empty) return null;
                if ((0, $eJsil.hasGeneratedContentDecorations)(aiExperienceDecorationPluginState)) return null;
                const modalDecorationElement = editorView === null || editorView === void 0 ? void 0 : editorView.dom.querySelector('.ai-modal-end-widget');
                // This protects against cases where there is an active decoration
                // but the document has not been updated to include it
                if (!modalDecorationElement) return null;
                // Prioritise getting position from inlineDecoration,
                // otherwise get decoration position from start or end widget
                const decoration = aiExperienceDecorationPluginState.modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'inlineDecoration').shift() || aiExperienceDecorationPluginState.modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'startWidgetDecoration' || spec.key === 'endWidgetDecoration').shift();
                if (!decoration) return null;
                const positions = [
                    decoration.from,
                    decoration.to
                ];
                const endExperience = ()=>{
                    // TODO POSTEAP
                    // When the full experience is moved to the state machine -- the intention is
                    // to have the modal experience ended via state transitions like "action taken"
                    // or "modal dismissed" and have side effects (actions) which run as part of
                    // those transition to do any clean up.
                    // Also to note -- this is not currently the end of the AI experience
                    // following this being called -- we decorate the document with a highlight following
                    // actions taken.
                    const state = (0, $9O1Gs.getPluginState)(editorView.state);
                    const endAIExperienceCommand = (0, $2KDKi.createEndAIExperienceCommand)((0, $eJsil.hasGeneratedContentDecorations)(state) ? state.modalDecorationSet : undefined);
                    endAIExperienceCommand(editorView.state, editorView.dispatch);
                    editorView.focus();
                };
                return(/*#__PURE__*/ // TODO POSTEAP
                // This error boundary will be unexpectedly positioned
                // as it's not wrapped in the ModalRegion.
                // In the case the modal region throws an exception
                // we should come up with an alternative positioning
                // strategy for error feedback.
                (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $99bKD.ModalRegionErrorBoundary), {
                    onCloseFallback: endExperience
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iTCOg.ModalRegion), {
                    key: aiExperienceDecorationPluginState.modalMountedTimeStamp,
                    decoration: decoration,
                    modalDecorationElement: modalDecorationElement,
                    editorView: editorView,
                    editorRelativeWrapper: wrapperElement === null || wrapperElement === void 0 ? void 0 : wrapperElement.offsetParent,
                    endExperience: endExperience,
                    appearance: appearance
                }, aiExperienceDecorationPluginState.configItem && editorView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $djrA4.ExperienceApplication), {
                    configItem: aiExperienceDecorationPluginState.configItem,
                    editorPluginAIProvider: editorPluginAIProvider,
                    endExperience: endExperience,
                    positions: positions,
                    editorView: editorView,
                    providerFactory: providerFactory,
                    lastTriggeredFrom: aiExperienceDecorationPluginState.lastTriggeredFrom,
                    triggerMethod: aiExperienceDecorationPluginState.triggerMethod,
                    appearance: appearance
                }))));
            };
            let pluginsToTrack = {
                aiExperienceDecorationPluginState: (0, $3zwnb.aiExperienceDecorationPluginKey)
            };
            const persistentUICohort = (0, $3Ycnu.getExperimentCohort)('editor_ai_-_persistent_button_experiment');
            const persistentUIEnabled = (0, $3Ycnu.isExperimentEnabled)('editor_ai_-_persistent_button_experiment');
            if (persistentUICohort === 'floating-button' && persistentUIEnabled) // listen on positon change to rerender floating ai button
            pluginsToTrack.floatingAiButtonTrackerState = (0, $cSjNj.floatingAiButtonTrackerPluginKey);
            if (persistentUICohort === 'tip-tap-menu' && persistentUIEnabled) {
                const typeAheadPluginKeyName = 'typeAheadPlugin$';
                const typeAheadPluginKey = {
                    key: typeAheadPluginKeyName,
                    getState: (state)=>{
                        return state[typeAheadPluginKeyName];
                    },
                    get: (state)=>{
                        return state[typeAheadPluginKeyName];
                    }
                };
                const placeholderPluginKeyName = 'placeholderPlugin$';
                const placeholderPluginKey = {
                    key: placeholderPluginKeyName,
                    getState: (state)=>{
                        return state[placeholderPluginKeyName];
                    },
                    get: (state)=>{
                        return state[placeholderPluginKeyName];
                    }
                };
                //listen on positon change to rerender floating ai button
                pluginsToTrack.floatingAiButtonTrackerState = (0, $cSjNj.floatingAiButtonTrackerPluginKey);
                // for tip tap mode listen on typeahead state change to hide button when typeahead is open
                pluginsToTrack.typeAheadPluginState = typeAheadPluginKey;
                // for tip tap mode listen to placeholder state change to hide button when placeholder is present
                pluginsToTrack.placeholderPluginState = placeholderPluginKey;
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2aaab40de427366f$var$GlobalWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dIobN.WithPluginState), {
                plugins: pluginsToTrack,
                render: ({ aiExperienceDecorationPluginState: aiExperienceDecorationPluginState, floatingAiButtonTrackerState: floatingAiButtonTrackerState })=>{
                    // The WithPluginState function does not support typing the plugin states it returns
                    // so we need to manually assert this.
                    const modalRegion = renderModalRegion(aiExperienceDecorationPluginState);
                    const selection = editorView.state.selection;
                    if (modalRegion) return modalRegion;
                    const showFloatingAIButton = persistentUICohort === 'floating-button';
                    const showTipTapMenu = persistentUICohort === 'tip-tap-menu';
                    const showPersistentButtonExperiment = floatingAiButtonTrackerState && selection instanceof (0, $kpTIW.TextSelection) && (showFloatingAIButton || showTipTapMenu) && persistentUIEnabled;
                    if (!showPersistentButtonExperiment) return null;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iFWYD.AskAIButtonWrapper), {
                        editorView: editorView,
                        selection: selection,
                        editorPluginAIProvider: editorPluginAIProvider,
                        showButton: [
                            'full-page',
                            'full-width'
                        ].includes(appearance) && floatingAiButtonTrackerState.shouldShowAskAIButton,
                        aiGlobalOptIn: aiOptIn,
                        appearance: persistentUICohort
                    });
                }
            }));
        },
        primaryToolbarComponent: ({ editorView: editorView })=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dIobN.WithPluginState), {
                plugins: {
                    pluginState: (0, $3S4st.aiButtonPluginKey),
                    spellingAndGrammar: (0, $2fbrZ.aiSpellingGrammarPluginKey)
                },
                render: ({ pluginState: pluginState, spellingAndGrammar: spellingAndGrammar })=>{
                    const aiButtonPluginState = pluginState;
                    const spellingAndGrammarPluginState = spellingAndGrammar;
                    const onClick = ()=>{
                        const { state: state, dispatch: dispatch } = editorView;
                        const configItem = state.selection.empty ? editorPluginAIProvider.emptyConfig.baseGenerate : editorPluginAIProvider.rangeConfig.baseGenerate;
                        const openAIModalCommand = (0, $2KDKi.createOpenAIModalCommand)({
                            state: state,
                            configItem: configItem,
                            lastTriggeredFrom: 'mainToolbar',
                            aiGlobalOptIn: aiOptIn
                        });
                        openAIModalCommand(state, dispatch);
                    };
                    const realtimeAIOnClick = async ()=>{
                        const { state: state, dispatch: dispatch } = editorView;
                        (0, $eUgBc.toggleSpellingAndGrammar)()(state, dispatch);
                    };
                    const Icon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg"
                        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                            d: "M12 4C12.676 4 13.284 4.399 13.556 5.008L13.609 5.142L16.944 14.67C17.0283 14.9108 17.0173 15.1748 16.9134 15.4078C16.8094 15.6408 16.6203 15.8252 16.3848 15.9234C16.1493 16.0215 15.8851 16.0259 15.6465 15.9357C15.4078 15.8455 15.2127 15.6674 15.101 15.438L15.056 15.33L14.232 12.973L14.117 12.993L14 13H10C9.92255 12.9999 9.84536 12.9909 9.77 12.973L8.944 15.33C8.86313 15.5614 8.70011 15.755 8.4859 15.8741C8.27169 15.9932 8.0212 16.0294 7.782 15.976L7.67 15.944C7.43863 15.8631 7.24502 15.7001 7.12593 15.4859C7.00684 15.2717 6.97057 15.0212 7.024 14.782L7.056 14.67L10.391 5.142C10.5078 4.80818 10.7255 4.51893 11.0139 4.31432C11.3024 4.10971 11.6473 3.99987 12.001 4H12ZM12 6.598L10.46 11H13.542L12.002 6.598H12Z",
                            fill: "currentColor"
                        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
                            d: "M14 17L16 19L20 15",
                            stroke: "currentColor",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, isProactiveAISupported && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j9fWg.default), {
                        isSelected: spellingAndGrammarPluginState.isSpellingAndGrammarEnabled,
                        icon: Icon,
                        appearance: "subtle",
                        onClick: realtimeAIOnClick,
                        label: "Spellcheck"
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a7I3b.AtlassianIntelligenceToolbarButton), {
                        ButtonWrapper: editorPluginAIProvider === null || editorPluginAIProvider === void 0 ? void 0 : editorPluginAIProvider.AIButtonWrapper,
                        onClick: onClick,
                        disabled: !(aiButtonPluginState !== null && aiButtonPluginState !== void 0 && aiButtonPluginState.isSelectionValidForAIExperience)
                    }));
                }
            });
        }
    };
};

});
parcelRegister("fBDHJ", function(module, exports) {

$parcel$export(module.exports, "Decoration", () => $b5c91c309b2647a1$export$10e30b733df217ea);
$parcel$export(module.exports, "DecorationSet", () => $b5c91c309b2647a1$export$93bf62eb445cec98);
$parcel$export(module.exports, "EditorView", () => $b5c91c309b2647a1$export$eece2fccabbb77c5);

var $kpTIW = parcelRequire("kpTIW");

var $7dkLM = parcelRequire("7dkLM");

var $d6JJW = parcelRequire("d6JJW");
const $b5c91c309b2647a1$var$domIndex = function(node) {
    for(var index = 0;; index++){
        node = node.previousSibling;
        if (!node) return index;
    }
};
const $b5c91c309b2647a1$var$parentNode = function(node) {
    let parent = node.assignedSlot || node.parentNode;
    return parent && parent.nodeType == 11 ? parent.host : parent;
};
let $b5c91c309b2647a1$var$reusedRange = null;
// Note that this will always return the same range, because DOM range
// objects are every expensive, and keep slowing down subsequent DOM
// updates, for some reason.
const $b5c91c309b2647a1$var$textRange = function(node, from, to) {
    let range = $b5c91c309b2647a1$var$reusedRange || ($b5c91c309b2647a1$var$reusedRange = document.createRange());
    range.setEnd(node, to == null ? node.nodeValue.length : to);
    range.setStart(node, from || 0);
    return range;
};
const $b5c91c309b2647a1$var$clearReusedRange = function() {
    $b5c91c309b2647a1$var$reusedRange = null;
};
// Scans forward and backward through DOM positions equivalent to the
// given one to see if the two are in the same place (i.e. after a
// text node vs at the end of that text node)
const $b5c91c309b2647a1$var$isEquivalentPosition = function(node, off, targetNode, targetOff) {
    return targetNode && ($b5c91c309b2647a1$var$scanFor(node, off, targetNode, targetOff, -1) || $b5c91c309b2647a1$var$scanFor(node, off, targetNode, targetOff, 1));
};
const $b5c91c309b2647a1$var$atomElements = /^(img|br|input|textarea|hr)$/i;
function $b5c91c309b2647a1$var$scanFor(node, off, targetNode, targetOff, dir) {
    for(;;){
        if (node == targetNode && off == targetOff) return true;
        if (off == (dir < 0 ? 0 : $b5c91c309b2647a1$var$nodeSize(node))) {
            let parent = node.parentNode;
            if (!parent || parent.nodeType != 1 || $b5c91c309b2647a1$var$hasBlockDesc(node) || $b5c91c309b2647a1$var$atomElements.test(node.nodeName) || node.contentEditable == "false") return false;
            off = $b5c91c309b2647a1$var$domIndex(node) + (dir < 0 ? 0 : 1);
            node = parent;
        } else if (node.nodeType == 1) {
            node = node.childNodes[off + (dir < 0 ? -1 : 0)];
            if (node.contentEditable == "false") return false;
            off = dir < 0 ? $b5c91c309b2647a1$var$nodeSize(node) : 0;
        } else return false;
    }
}
function $b5c91c309b2647a1$var$nodeSize(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $b5c91c309b2647a1$var$textNodeBefore$1(node, offset) {
    for(;;){
        if (node.nodeType == 3 && offset) return node;
        if (node.nodeType == 1 && offset > 0) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset - 1];
            offset = $b5c91c309b2647a1$var$nodeSize(node);
        } else if (node.parentNode && !$b5c91c309b2647a1$var$hasBlockDesc(node)) {
            offset = $b5c91c309b2647a1$var$domIndex(node);
            node = node.parentNode;
        } else return null;
    }
}
function $b5c91c309b2647a1$var$textNodeAfter$1(node, offset) {
    for(;;){
        if (node.nodeType == 3 && offset < node.nodeValue.length) return node;
        if (node.nodeType == 1 && offset < node.childNodes.length) {
            if (node.contentEditable == "false") return null;
            node = node.childNodes[offset];
            offset = 0;
        } else if (node.parentNode && !$b5c91c309b2647a1$var$hasBlockDesc(node)) {
            offset = $b5c91c309b2647a1$var$domIndex(node) + 1;
            node = node.parentNode;
        } else return null;
    }
}
function $b5c91c309b2647a1$var$isOnEdge(node, offset, parent) {
    for(let atStart = offset == 0, atEnd = offset == $b5c91c309b2647a1$var$nodeSize(node); atStart || atEnd;){
        if (node == parent) return true;
        let index = $b5c91c309b2647a1$var$domIndex(node);
        node = node.parentNode;
        if (!node) return false;
        atStart = atStart && index == 0;
        atEnd = atEnd && index == $b5c91c309b2647a1$var$nodeSize(node);
    }
}
function $b5c91c309b2647a1$var$hasBlockDesc(dom) {
    let desc;
    for(let cur = dom; cur; cur = cur.parentNode)if (desc = cur.pmViewDesc) break;
    return desc && desc.node && desc.node.isBlock && (desc.dom == dom || desc.contentDOM == dom);
}
// Work around Chrome issue https://bugs.chromium.org/p/chromium/issues/detail?id=447523
// (isCollapsed inappropriately returns true in shadow dom)
const $b5c91c309b2647a1$var$selectionCollapsed = function(domSel) {
    return domSel.focusNode && $b5c91c309b2647a1$var$isEquivalentPosition(domSel.focusNode, domSel.focusOffset, domSel.anchorNode, domSel.anchorOffset);
};
function $b5c91c309b2647a1$var$keyEvent(keyCode, key) {
    let event = document.createEvent("Event");
    event.initEvent("keydown", true, true);
    event.keyCode = keyCode;
    event.key = event.code = key;
    return event;
}
function $b5c91c309b2647a1$var$deepActiveElement(doc) {
    let elt = doc.activeElement;
    while(elt && elt.shadowRoot)elt = elt.shadowRoot.activeElement;
    return elt;
}
function $b5c91c309b2647a1$var$caretFromPoint(doc, x, y) {
    if (doc.caretPositionFromPoint) try {
        let pos = doc.caretPositionFromPoint(x, y);
        if (pos) return {
            node: pos.offsetNode,
            offset: pos.offset
        };
    } catch (_) {}
    if (doc.caretRangeFromPoint) {
        let range = doc.caretRangeFromPoint(x, y);
        if (range) return {
            node: range.startContainer,
            offset: range.startOffset
        };
    }
}
const $b5c91c309b2647a1$var$nav = typeof navigator != "undefined" ? navigator : null;
const $b5c91c309b2647a1$var$doc = typeof document != "undefined" ? document : null;
const $b5c91c309b2647a1$var$agent = $b5c91c309b2647a1$var$nav && $b5c91c309b2647a1$var$nav.userAgent || "";
const $b5c91c309b2647a1$var$ie_edge = /Edge\/(\d+)/.exec($b5c91c309b2647a1$var$agent);
const $b5c91c309b2647a1$var$ie_upto10 = /MSIE \d/.exec($b5c91c309b2647a1$var$agent);
const $b5c91c309b2647a1$var$ie_11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec($b5c91c309b2647a1$var$agent);
const $b5c91c309b2647a1$var$ie = !!($b5c91c309b2647a1$var$ie_upto10 || $b5c91c309b2647a1$var$ie_11up || $b5c91c309b2647a1$var$ie_edge);
const $b5c91c309b2647a1$var$ie_version = $b5c91c309b2647a1$var$ie_upto10 ? document.documentMode : $b5c91c309b2647a1$var$ie_11up ? +$b5c91c309b2647a1$var$ie_11up[1] : $b5c91c309b2647a1$var$ie_edge ? +$b5c91c309b2647a1$var$ie_edge[1] : 0;
const $b5c91c309b2647a1$var$gecko = !$b5c91c309b2647a1$var$ie && /gecko\/(\d+)/i.test($b5c91c309b2647a1$var$agent);
$b5c91c309b2647a1$var$gecko && (/Firefox\/(\d+)/.exec($b5c91c309b2647a1$var$agent) || [
    0,
    0
])[1];
const $b5c91c309b2647a1$var$_chrome = !$b5c91c309b2647a1$var$ie && /Chrome\/(\d+)/.exec($b5c91c309b2647a1$var$agent);
const $b5c91c309b2647a1$var$chrome = !!$b5c91c309b2647a1$var$_chrome;
const $b5c91c309b2647a1$var$chrome_version = $b5c91c309b2647a1$var$_chrome ? +$b5c91c309b2647a1$var$_chrome[1] : 0;
const $b5c91c309b2647a1$var$safari = !$b5c91c309b2647a1$var$ie && !!$b5c91c309b2647a1$var$nav && /Apple Computer/.test($b5c91c309b2647a1$var$nav.vendor);
// Is true for both iOS and iPadOS for convenience
const $b5c91c309b2647a1$var$ios = $b5c91c309b2647a1$var$safari && (/Mobile\/\w+/.test($b5c91c309b2647a1$var$agent) || !!$b5c91c309b2647a1$var$nav && $b5c91c309b2647a1$var$nav.maxTouchPoints > 2);
const $b5c91c309b2647a1$var$mac = $b5c91c309b2647a1$var$ios || ($b5c91c309b2647a1$var$nav ? /Mac/.test($b5c91c309b2647a1$var$nav.platform) : false);
const $b5c91c309b2647a1$var$windows = $b5c91c309b2647a1$var$nav ? /Win/.test($b5c91c309b2647a1$var$nav.platform) : false;
const $b5c91c309b2647a1$var$android = /Android \d/.test($b5c91c309b2647a1$var$agent);
const $b5c91c309b2647a1$var$webkit = !!$b5c91c309b2647a1$var$doc && "webkitFontSmoothing" in $b5c91c309b2647a1$var$doc.documentElement.style;
const $b5c91c309b2647a1$var$webkit_version = $b5c91c309b2647a1$var$webkit ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [
    0,
    0
])[1] : 0;
function $b5c91c309b2647a1$var$windowRect(doc) {
    let vp = doc.defaultView && doc.defaultView.visualViewport;
    if (vp) return {
        left: 0,
        right: vp.width,
        top: 0,
        bottom: vp.height
    };
    return {
        left: 0,
        right: doc.documentElement.clientWidth,
        top: 0,
        bottom: doc.documentElement.clientHeight
    };
}
function $b5c91c309b2647a1$var$getSide(value, side) {
    return typeof value == "number" ? value : value[side];
}
function $b5c91c309b2647a1$var$clientRect(node) {
    let rect = node.getBoundingClientRect();
    // Adjust for elements with style "transform: scale()"
    let scaleX = rect.width / node.offsetWidth || 1;
    let scaleY = rect.height / node.offsetHeight || 1;
    // Make sure scrollbar width isn't included in the rectangle
    return {
        left: rect.left,
        right: rect.left + node.clientWidth * scaleX,
        top: rect.top,
        bottom: rect.top + node.clientHeight * scaleY
    };
}
function $b5c91c309b2647a1$var$scrollRectIntoView(view, rect, startDOM) {
    let scrollThreshold = view.someProp("scrollThreshold") || 0, scrollMargin = view.someProp("scrollMargin") || 5;
    let doc = view.dom.ownerDocument;
    for(let parent = startDOM || view.dom;; parent = $b5c91c309b2647a1$var$parentNode(parent)){
        if (!parent) break;
        if (parent.nodeType != 1) continue;
        let elt = parent;
        let atTop = elt == doc.body;
        let bounding = atTop ? $b5c91c309b2647a1$var$windowRect(doc) : $b5c91c309b2647a1$var$clientRect(elt);
        let moveX = 0, moveY = 0;
        if (rect.top < bounding.top + $b5c91c309b2647a1$var$getSide(scrollThreshold, "top")) moveY = -(bounding.top - rect.top + $b5c91c309b2647a1$var$getSide(scrollMargin, "top"));
        else if (rect.bottom > bounding.bottom - $b5c91c309b2647a1$var$getSide(scrollThreshold, "bottom")) moveY = rect.bottom - rect.top > bounding.bottom - bounding.top ? rect.top + $b5c91c309b2647a1$var$getSide(scrollMargin, "top") - bounding.top : rect.bottom - bounding.bottom + $b5c91c309b2647a1$var$getSide(scrollMargin, "bottom");
        if (rect.left < bounding.left + $b5c91c309b2647a1$var$getSide(scrollThreshold, "left")) moveX = -(bounding.left - rect.left + $b5c91c309b2647a1$var$getSide(scrollMargin, "left"));
        else if (rect.right > bounding.right - $b5c91c309b2647a1$var$getSide(scrollThreshold, "right")) moveX = rect.right - bounding.right + $b5c91c309b2647a1$var$getSide(scrollMargin, "right");
        if (moveX || moveY) {
            if (atTop) doc.defaultView.scrollBy(moveX, moveY);
            else {
                let startX = elt.scrollLeft, startY = elt.scrollTop;
                if (moveY) elt.scrollTop += moveY;
                if (moveX) elt.scrollLeft += moveX;
                let dX = elt.scrollLeft - startX, dY = elt.scrollTop - startY;
                rect = {
                    left: rect.left - dX,
                    top: rect.top - dY,
                    right: rect.right - dX,
                    bottom: rect.bottom - dY
                };
            }
        }
        if (atTop || /^(fixed|sticky)$/.test(getComputedStyle(parent).position)) break;
    }
}
// Store the scroll position of the editor's parent nodes, along with
// the top position of an element near the top of the editor, which
// will be used to make sure the visible viewport remains stable even
// when the size of the content above changes.
function $b5c91c309b2647a1$var$storeScrollPos(view) {
    let rect = view.dom.getBoundingClientRect(), startY = Math.max(0, rect.top);
    let refDOM, refTop;
    for(let x = (rect.left + rect.right) / 2, y = startY + 1; y < Math.min(innerHeight, rect.bottom); y += 5){
        let dom = view.root.elementFromPoint(x, y);
        if (!dom || dom == view.dom || !view.dom.contains(dom)) continue;
        let localRect = dom.getBoundingClientRect();
        if (localRect.top >= startY - 20) {
            refDOM = dom;
            refTop = localRect.top;
            break;
        }
    }
    return {
        refDOM: refDOM,
        refTop: refTop,
        stack: $b5c91c309b2647a1$var$scrollStack(view.dom)
    };
}
function $b5c91c309b2647a1$var$scrollStack(dom) {
    let stack = [], doc = dom.ownerDocument;
    for(let cur = dom; cur; cur = $b5c91c309b2647a1$var$parentNode(cur)){
        stack.push({
            dom: cur,
            top: cur.scrollTop,
            left: cur.scrollLeft
        });
        if (dom == doc) break;
    }
    return stack;
}
// Reset the scroll position of the editor's parent nodes to that what
// it was before, when storeScrollPos was called.
function $b5c91c309b2647a1$var$resetScrollPos({ refDOM: refDOM, refTop: refTop, stack: stack }) {
    let newRefTop = refDOM ? refDOM.getBoundingClientRect().top : 0;
    $b5c91c309b2647a1$var$restoreScrollStack(stack, newRefTop == 0 ? 0 : newRefTop - refTop);
}
function $b5c91c309b2647a1$var$restoreScrollStack(stack, dTop) {
    for(let i = 0; i < stack.length; i++){
        let { dom: dom, top: top, left: left } = stack[i];
        if (dom.scrollTop != top + dTop) dom.scrollTop = top + dTop;
        if (dom.scrollLeft != left) dom.scrollLeft = left;
    }
}
let $b5c91c309b2647a1$var$preventScrollSupported = null;
// Feature-detects support for .focus({preventScroll: true}), and uses
// a fallback kludge when not supported.
function $b5c91c309b2647a1$var$focusPreventScroll(dom) {
    if (dom.setActive) return dom.setActive(); // in IE
    if ($b5c91c309b2647a1$var$preventScrollSupported) return dom.focus($b5c91c309b2647a1$var$preventScrollSupported);
    let stored = $b5c91c309b2647a1$var$scrollStack(dom);
    dom.focus($b5c91c309b2647a1$var$preventScrollSupported == null ? {
        get preventScroll () {
            $b5c91c309b2647a1$var$preventScrollSupported = {
                preventScroll: true
            };
            return true;
        }
    } : undefined);
    if (!$b5c91c309b2647a1$var$preventScrollSupported) {
        $b5c91c309b2647a1$var$preventScrollSupported = false;
        $b5c91c309b2647a1$var$restoreScrollStack(stored, 0);
    }
}
function $b5c91c309b2647a1$var$findOffsetInNode(node, coords) {
    let closest, dxClosest = 2e8, coordsClosest, offset = 0;
    let rowBot = coords.top, rowTop = coords.top;
    let firstBelow, coordsBelow;
    for(let child = node.firstChild, childIndex = 0; child; child = child.nextSibling, childIndex++){
        let rects;
        if (child.nodeType == 1) rects = child.getClientRects();
        else if (child.nodeType == 3) rects = $b5c91c309b2647a1$var$textRange(child).getClientRects();
        else continue;
        for(let i = 0; i < rects.length; i++){
            let rect = rects[i];
            if (rect.top <= rowBot && rect.bottom >= rowTop) {
                rowBot = Math.max(rect.bottom, rowBot);
                rowTop = Math.min(rect.top, rowTop);
                let dx = rect.left > coords.left ? rect.left - coords.left : rect.right < coords.left ? coords.left - rect.right : 0;
                if (dx < dxClosest) {
                    closest = child;
                    dxClosest = dx;
                    coordsClosest = dx && closest.nodeType == 3 ? {
                        left: rect.right < coords.left ? rect.right : rect.left,
                        top: coords.top
                    } : coords;
                    if (child.nodeType == 1 && dx) offset = childIndex + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0);
                    continue;
                }
            } else if (rect.top > coords.top && !firstBelow && rect.left <= coords.left && rect.right >= coords.left) {
                firstBelow = child;
                coordsBelow = {
                    left: Math.max(rect.left, Math.min(rect.right, coords.left)),
                    top: rect.top
                };
            }
            if (!closest && (coords.left >= rect.right && coords.top >= rect.top || coords.left >= rect.left && coords.top >= rect.bottom)) offset = childIndex + 1;
        }
    }
    if (!closest && firstBelow) {
        closest = firstBelow;
        coordsClosest = coordsBelow;
        dxClosest = 0;
    }
    if (closest && closest.nodeType == 3) return $b5c91c309b2647a1$var$findOffsetInText(closest, coordsClosest);
    if (!closest || dxClosest && closest.nodeType == 1) return {
        node: node,
        offset: offset
    };
    return $b5c91c309b2647a1$var$findOffsetInNode(closest, coordsClosest);
}
function $b5c91c309b2647a1$var$findOffsetInText(node, coords) {
    let len = node.nodeValue.length;
    let range = document.createRange();
    for(let i = 0; i < len; i++){
        range.setEnd(node, i + 1);
        range.setStart(node, i);
        let rect = $b5c91c309b2647a1$var$singleRect(range, 1);
        if (rect.top == rect.bottom) continue;
        if ($b5c91c309b2647a1$var$inRect(coords, rect)) return {
            node: node,
            offset: i + (coords.left >= (rect.left + rect.right) / 2 ? 1 : 0)
        };
    }
    return {
        node: node,
        offset: 0
    };
}
function $b5c91c309b2647a1$var$inRect(coords, rect) {
    return coords.left >= rect.left - 1 && coords.left <= rect.right + 1 && coords.top >= rect.top - 1 && coords.top <= rect.bottom + 1;
}
function $b5c91c309b2647a1$var$targetKludge(dom, coords) {
    let parent = dom.parentNode;
    if (parent && /^li$/i.test(parent.nodeName) && coords.left < dom.getBoundingClientRect().left) return parent;
    return dom;
}
function $b5c91c309b2647a1$var$posFromElement(view, elt, coords) {
    let { node: node, offset: offset } = $b5c91c309b2647a1$var$findOffsetInNode(elt, coords), bias = -1;
    if (node.nodeType == 1 && !node.firstChild) {
        let rect = node.getBoundingClientRect();
        bias = rect.left != rect.right && coords.left > (rect.left + rect.right) / 2 ? 1 : -1;
    }
    return view.docView.posFromDOM(node, offset, bias);
}
function $b5c91c309b2647a1$var$posFromCaret(view, node, offset, coords) {
    // Browser (in caretPosition/RangeFromPoint) will agressively
    // normalize towards nearby inline nodes. Since we are interested in
    // positions between block nodes too, we first walk up the hierarchy
    // of nodes to see if there are block nodes that the coordinates
    // fall outside of. If so, we take the position before/after that
    // block. If not, we call `posFromDOM` on the raw node/offset.
    let outsideBlock = -1;
    for(let cur = node, sawBlock = false;;){
        if (cur == view.dom) break;
        let desc = view.docView.nearestDesc(cur, true);
        if (!desc) return null;
        if (desc.dom.nodeType == 1 && (desc.node.isBlock && desc.parent && !sawBlock || !desc.contentDOM)) {
            let rect = desc.dom.getBoundingClientRect();
            if (desc.node.isBlock && desc.parent && !sawBlock) {
                sawBlock = true;
                if (rect.left > coords.left || rect.top > coords.top) outsideBlock = desc.posBefore;
                else if (rect.right < coords.left || rect.bottom < coords.top) outsideBlock = desc.posAfter;
            }
            if (!desc.contentDOM && outsideBlock < 0 && !desc.node.isText) {
                // If we are inside a leaf, return the side of the leaf closer to the coords
                let before = desc.node.isBlock ? coords.top < (rect.top + rect.bottom) / 2 : coords.left < (rect.left + rect.right) / 2;
                return before ? desc.posBefore : desc.posAfter;
            }
        }
        cur = desc.dom.parentNode;
    }
    return outsideBlock > -1 ? outsideBlock : view.docView.posFromDOM(node, offset, -1);
}
function $b5c91c309b2647a1$var$elementFromPoint(element, coords, box) {
    let len = element.childNodes.length;
    if (len && box.top < box.bottom) for(let startI = Math.max(0, Math.min(len - 1, Math.floor(len * (coords.top - box.top) / (box.bottom - box.top)) - 2)), i = startI;;){
        let child = element.childNodes[i];
        if (child.nodeType == 1) {
            let rects = child.getClientRects();
            for(let j = 0; j < rects.length; j++){
                let rect = rects[j];
                if ($b5c91c309b2647a1$var$inRect(coords, rect)) return $b5c91c309b2647a1$var$elementFromPoint(child, coords, rect);
            }
        }
        if ((i = (i + 1) % len) == startI) break;
    }
    return element;
}
// Given an x,y position on the editor, get the position in the document.
function $b5c91c309b2647a1$var$posAtCoords(view, coords) {
    let doc = view.dom.ownerDocument, node, offset = 0;
    let caret = $b5c91c309b2647a1$var$caretFromPoint(doc, coords.left, coords.top);
    if (caret) ({ node: node, offset: offset } = caret);
    let elt = (view.root.elementFromPoint ? view.root : doc).elementFromPoint(coords.left, coords.top);
    let pos;
    if (!elt || !view.dom.contains(elt.nodeType != 1 ? elt.parentNode : elt)) {
        let box = view.dom.getBoundingClientRect();
        if (!$b5c91c309b2647a1$var$inRect(coords, box)) return null;
        elt = $b5c91c309b2647a1$var$elementFromPoint(view.dom, coords, box);
        if (!elt) return null;
    }
    // Safari's caretRangeFromPoint returns nonsense when on a draggable element
    if ($b5c91c309b2647a1$var$safari) {
        for(let p = elt; node && p; p = $b5c91c309b2647a1$var$parentNode(p))if (p.draggable) node = undefined;
    }
    elt = $b5c91c309b2647a1$var$targetKludge(elt, coords);
    if (node) {
        if ($b5c91c309b2647a1$var$gecko && node.nodeType == 1) {
            // Firefox will sometimes return offsets into <input> nodes, which
            // have no actual children, from caretPositionFromPoint (#953)
            offset = Math.min(offset, node.childNodes.length);
            // It'll also move the returned position before image nodes,
            // even if those are behind it.
            if (offset < node.childNodes.length) {
                let next = node.childNodes[offset], box;
                if (next.nodeName == "IMG" && (box = next.getBoundingClientRect()).right <= coords.left && box.bottom > coords.top) offset++;
            }
        }
        let prev;
        // When clicking above the right side of an uneditable node, Chrome will report a cursor position after that node.
        if ($b5c91c309b2647a1$var$webkit && offset && node.nodeType == 1 && (prev = node.childNodes[offset - 1]).nodeType == 1 && prev.contentEditable == "false" && prev.getBoundingClientRect().top >= coords.top) offset--;
        // Suspiciously specific kludge to work around caret*FromPoint
        // never returning a position at the end of the document
        if (node == view.dom && offset == node.childNodes.length - 1 && node.lastChild.nodeType == 1 && coords.top > node.lastChild.getBoundingClientRect().bottom) pos = view.state.doc.content.size;
        else if (offset == 0 || node.nodeType != 1 || node.childNodes[offset - 1].nodeName != "BR") pos = $b5c91c309b2647a1$var$posFromCaret(view, node, offset, coords);
    }
    if (pos == null) pos = $b5c91c309b2647a1$var$posFromElement(view, elt, coords);
    let desc = view.docView.nearestDesc(elt, true);
    return {
        pos: pos,
        inside: desc ? desc.posAtStart - desc.border : -1
    };
}
function $b5c91c309b2647a1$var$nonZero(rect) {
    return rect.top < rect.bottom || rect.left < rect.right;
}
function $b5c91c309b2647a1$var$singleRect(target, bias) {
    let rects = target.getClientRects();
    if (rects.length) {
        let first = rects[bias < 0 ? 0 : rects.length - 1];
        if ($b5c91c309b2647a1$var$nonZero(first)) return first;
    }
    return Array.prototype.find.call(rects, $b5c91c309b2647a1$var$nonZero) || target.getBoundingClientRect();
}
const $b5c91c309b2647a1$var$BIDI = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
// Given a position in the document model, get a bounding box of the
// character at that position, relative to the window.
function $b5c91c309b2647a1$var$coordsAtPos(view, pos, side) {
    let { node: node, offset: offset, atom: atom } = view.docView.domFromPos(pos, side < 0 ? -1 : 1);
    let supportEmptyRange = $b5c91c309b2647a1$var$webkit || $b5c91c309b2647a1$var$gecko;
    if (node.nodeType == 3) {
        // These browsers support querying empty text ranges. Prefer that in
        // bidi context or when at the end of a node.
        if (supportEmptyRange && ($b5c91c309b2647a1$var$BIDI.test(node.nodeValue) || (side < 0 ? !offset : offset == node.nodeValue.length))) {
            let rect = $b5c91c309b2647a1$var$singleRect($b5c91c309b2647a1$var$textRange(node, offset, offset), side);
            // Firefox returns bad results (the position before the space)
            // when querying a position directly after line-broken
            // whitespace. Detect this situation and and kludge around it
            if ($b5c91c309b2647a1$var$gecko && offset && /\s/.test(node.nodeValue[offset - 1]) && offset < node.nodeValue.length) {
                let rectBefore = $b5c91c309b2647a1$var$singleRect($b5c91c309b2647a1$var$textRange(node, offset - 1, offset - 1), -1);
                if (rectBefore.top == rect.top) {
                    let rectAfter = $b5c91c309b2647a1$var$singleRect($b5c91c309b2647a1$var$textRange(node, offset, offset + 1), -1);
                    if (rectAfter.top != rect.top) return $b5c91c309b2647a1$var$flattenV(rectAfter, rectAfter.left < rectBefore.left);
                }
            }
            return rect;
        } else {
            let from = offset, to = offset, takeSide = side < 0 ? 1 : -1;
            if (side < 0 && !offset) {
                to++;
                takeSide = -1;
            } else if (side >= 0 && offset == node.nodeValue.length) {
                from--;
                takeSide = 1;
            } else if (side < 0) from--;
            else to++;
            return $b5c91c309b2647a1$var$flattenV($b5c91c309b2647a1$var$singleRect($b5c91c309b2647a1$var$textRange(node, from, to), takeSide), takeSide < 0);
        }
    }
    let $dom = view.state.doc.resolve(pos - (atom || 0));
    // Return a horizontal line in block context
    if (!$dom.parent.inlineContent) {
        if (atom == null && offset && (side < 0 || offset == $b5c91c309b2647a1$var$nodeSize(node))) {
            let before = node.childNodes[offset - 1];
            if (before.nodeType == 1) return $b5c91c309b2647a1$var$flattenH(before.getBoundingClientRect(), false);
        }
        if (atom == null && offset < $b5c91c309b2647a1$var$nodeSize(node)) {
            let after = node.childNodes[offset];
            if (after.nodeType == 1) return $b5c91c309b2647a1$var$flattenH(after.getBoundingClientRect(), true);
        }
        return $b5c91c309b2647a1$var$flattenH(node.getBoundingClientRect(), side >= 0);
    }
    // Inline, not in text node (this is not Bidi-safe)
    if (atom == null && offset && (side < 0 || offset == $b5c91c309b2647a1$var$nodeSize(node))) {
        let before = node.childNodes[offset - 1];
        let target = before.nodeType == 3 ? $b5c91c309b2647a1$var$textRange(before, $b5c91c309b2647a1$var$nodeSize(before) - (supportEmptyRange ? 0 : 1)) : before.nodeType == 1 && (before.nodeName != "BR" || !before.nextSibling) ? before : null;
        if (target) return $b5c91c309b2647a1$var$flattenV($b5c91c309b2647a1$var$singleRect(target, 1), false);
    }
    if (atom == null && offset < $b5c91c309b2647a1$var$nodeSize(node)) {
        let after = node.childNodes[offset];
        while(after.pmViewDesc && after.pmViewDesc.ignoreForCoords)after = after.nextSibling;
        let target = !after ? null : after.nodeType == 3 ? $b5c91c309b2647a1$var$textRange(after, 0, supportEmptyRange ? 0 : 1) : after.nodeType == 1 ? after : null;
        if (target) return $b5c91c309b2647a1$var$flattenV($b5c91c309b2647a1$var$singleRect(target, -1), true);
    }
    // All else failed, just try to get a rectangle for the target node
    return $b5c91c309b2647a1$var$flattenV($b5c91c309b2647a1$var$singleRect(node.nodeType == 3 ? $b5c91c309b2647a1$var$textRange(node) : node, -side), side >= 0);
}
function $b5c91c309b2647a1$var$flattenV(rect, left) {
    if (rect.width == 0) return rect;
    let x = left ? rect.left : rect.right;
    return {
        top: rect.top,
        bottom: rect.bottom,
        left: x,
        right: x
    };
}
function $b5c91c309b2647a1$var$flattenH(rect, top) {
    if (rect.height == 0) return rect;
    let y = top ? rect.top : rect.bottom;
    return {
        top: y,
        bottom: y,
        left: rect.left,
        right: rect.right
    };
}
function $b5c91c309b2647a1$var$withFlushedState(view, state, f) {
    let viewState = view.state, active = view.root.activeElement;
    if (viewState != state) view.updateState(state);
    if (active != view.dom) view.focus();
    try {
        return f();
    } finally{
        if (viewState != state) view.updateState(viewState);
        if (active != view.dom && active) active.focus();
    }
}
// Whether vertical position motion in a given direction
// from a position would leave a text block.
function $b5c91c309b2647a1$var$endOfTextblockVertical(view, state, dir) {
    let sel = state.selection;
    let $pos = dir == "up" ? sel.$from : sel.$to;
    return $b5c91c309b2647a1$var$withFlushedState(view, state, ()=>{
        let { node: dom } = view.docView.domFromPos($pos.pos, dir == "up" ? -1 : 1);
        for(;;){
            let nearest = view.docView.nearestDesc(dom, true);
            if (!nearest) break;
            if (nearest.node.isBlock) {
                dom = nearest.contentDOM || nearest.dom;
                break;
            }
            dom = nearest.dom.parentNode;
        }
        let coords = $b5c91c309b2647a1$var$coordsAtPos(view, $pos.pos, 1);
        for(let child = dom.firstChild; child; child = child.nextSibling){
            let boxes;
            if (child.nodeType == 1) boxes = child.getClientRects();
            else if (child.nodeType == 3) boxes = $b5c91c309b2647a1$var$textRange(child, 0, child.nodeValue.length).getClientRects();
            else continue;
            for(let i = 0; i < boxes.length; i++){
                let box = boxes[i];
                if (box.bottom > box.top + 1 && (dir == "up" ? coords.top - box.top > (box.bottom - coords.top) * 2 : box.bottom - coords.bottom > (coords.bottom - box.top) * 2)) return false;
            }
        }
        return true;
    });
}
const $b5c91c309b2647a1$var$maybeRTL = /[\u0590-\u08ac]/;
function $b5c91c309b2647a1$var$endOfTextblockHorizontal(view, state, dir) {
    let { $head: $head } = state.selection;
    if (!$head.parent.isTextblock) return false;
    let offset = $head.parentOffset, atStart = !offset, atEnd = offset == $head.parent.content.size;
    let sel = view.domSelection();
    // If the textblock is all LTR, or the browser doesn't support
    // Selection.modify (Edge), fall back to a primitive approach
    if (!$b5c91c309b2647a1$var$maybeRTL.test($head.parent.textContent) || !sel.modify) return dir == "left" || dir == "backward" ? atStart : atEnd;
    return $b5c91c309b2647a1$var$withFlushedState(view, state, ()=>{
        // This is a huge hack, but appears to be the best we can
        // currently do: use `Selection.modify` to move the selection by
        // one character, and see if that moves the cursor out of the
        // textblock (or doesn't move it at all, when at the start/end of
        // the document).
        let { focusNode: oldNode, focusOffset: oldOff, anchorNode: anchorNode, anchorOffset: anchorOffset } = view.domSelectionRange();
        let oldBidiLevel = sel.caretBidiLevel // Only for Firefox
        ;
        sel.modify("move", dir, "character");
        let parentDOM = $head.depth ? view.docView.domAfterPos($head.before()) : view.dom;
        let { focusNode: newNode, focusOffset: newOff } = view.domSelectionRange();
        let result = newNode && !parentDOM.contains(newNode.nodeType == 1 ? newNode : newNode.parentNode) || oldNode == newNode && oldOff == newOff;
        // Restore the previous selection
        try {
            sel.collapse(anchorNode, anchorOffset);
            if (oldNode && (oldNode != anchorNode || oldOff != anchorOffset) && sel.extend) sel.extend(oldNode, oldOff);
        } catch (_) {}
        if (oldBidiLevel != null) sel.caretBidiLevel = oldBidiLevel;
        return result;
    });
}
let $b5c91c309b2647a1$var$cachedState = null;
let $b5c91c309b2647a1$var$cachedDir = null;
let $b5c91c309b2647a1$var$cachedResult = false;
function $b5c91c309b2647a1$var$endOfTextblock(view, state, dir) {
    if ($b5c91c309b2647a1$var$cachedState == state && $b5c91c309b2647a1$var$cachedDir == dir) return $b5c91c309b2647a1$var$cachedResult;
    $b5c91c309b2647a1$var$cachedState = state;
    $b5c91c309b2647a1$var$cachedDir = dir;
    return $b5c91c309b2647a1$var$cachedResult = dir == "up" || dir == "down" ? $b5c91c309b2647a1$var$endOfTextblockVertical(view, state, dir) : $b5c91c309b2647a1$var$endOfTextblockHorizontal(view, state, dir);
}
// View descriptions are data structures that describe the DOM that is
// used to represent the editor's content. They are used for:
//
// - Incremental redrawing when the document changes
//
// - Figuring out what part of the document a given DOM position
//   corresponds to
//
// - Wiring in custom implementations of the editing interface for a
//   given node
//
// They form a doubly-linked mutable tree, starting at `view.docView`.
const $b5c91c309b2647a1$var$NOT_DIRTY = 0, $b5c91c309b2647a1$var$CHILD_DIRTY = 1, $b5c91c309b2647a1$var$CONTENT_DIRTY = 2, $b5c91c309b2647a1$var$NODE_DIRTY = 3;
// Superclass for the various kinds of descriptions. Defines their
// basic structure and shared methods.
class $b5c91c309b2647a1$var$ViewDesc {
    constructor(parent, children, dom, // This is the node that holds the child views. It may be null for
    // descs that don't have children.
    contentDOM){
        this.parent = parent;
        this.children = children;
        this.dom = dom;
        this.contentDOM = contentDOM;
        this.dirty = $b5c91c309b2647a1$var$NOT_DIRTY;
        // An expando property on the DOM node provides a link back to its
        // description.
        dom.pmViewDesc = this;
    }
    // Used to check whether a given description corresponds to a
    // widget/mark/node.
    matchesWidget(widget) {
        return false;
    }
    matchesMark(mark) {
        return false;
    }
    matchesNode(node, outerDeco, innerDeco) {
        return false;
    }
    matchesHack(nodeName) {
        return false;
    }
    // When parsing in-editor content (in domchange.js), we allow
    // descriptions to determine the parse rules that should be used to
    // parse them.
    parseRule() {
        return null;
    }
    // Used by the editor's event handler to ignore events that come
    // from certain descs.
    stopEvent(event) {
        return false;
    }
    // The size of the content represented by this desc.
    get size() {
        let size = 0;
        for(let i = 0; i < this.children.length; i++)size += this.children[i].size;
        return size;
    }
    // For block nodes, this represents the space taken up by their
    // start/end tokens.
    get border() {
        return 0;
    }
    destroy() {
        this.parent = undefined;
        if (this.dom.pmViewDesc == this) this.dom.pmViewDesc = undefined;
        for(let i = 0; i < this.children.length; i++)this.children[i].destroy();
    }
    posBeforeChild(child) {
        for(let i = 0, pos = this.posAtStart;; i++){
            let cur = this.children[i];
            if (cur == child) return pos;
            pos += cur.size;
        }
    }
    get posBefore() {
        return this.parent.posBeforeChild(this);
    }
    get posAtStart() {
        return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
    }
    get posAfter() {
        return this.posBefore + this.size;
    }
    get posAtEnd() {
        return this.posAtStart + this.size - 2 * this.border;
    }
    localPosFromDOM(dom, offset, bias) {
        // If the DOM position is in the content, use the child desc after
        // it to figure out a position.
        if (this.contentDOM && this.contentDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode)) {
            if (bias < 0) {
                let domBefore, desc;
                if (dom == this.contentDOM) domBefore = dom.childNodes[offset - 1];
                else {
                    while(dom.parentNode != this.contentDOM)dom = dom.parentNode;
                    domBefore = dom.previousSibling;
                }
                while(domBefore && !((desc = domBefore.pmViewDesc) && desc.parent == this))domBefore = domBefore.previousSibling;
                return domBefore ? this.posBeforeChild(desc) + desc.size : this.posAtStart;
            } else {
                let domAfter, desc;
                if (dom == this.contentDOM) domAfter = dom.childNodes[offset];
                else {
                    while(dom.parentNode != this.contentDOM)dom = dom.parentNode;
                    domAfter = dom.nextSibling;
                }
                while(domAfter && !((desc = domAfter.pmViewDesc) && desc.parent == this))domAfter = domAfter.nextSibling;
                return domAfter ? this.posBeforeChild(desc) : this.posAtEnd;
            }
        }
        // Otherwise, use various heuristics, falling back on the bias
        // parameter, to determine whether to return the position at the
        // start or at the end of this view desc.
        let atEnd;
        if (dom == this.dom && this.contentDOM) atEnd = offset > $b5c91c309b2647a1$var$domIndex(this.contentDOM);
        else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM)) atEnd = dom.compareDocumentPosition(this.contentDOM) & 2;
        else if (this.dom.firstChild) {
            if (offset == 0) for(let search = dom;; search = search.parentNode){
                if (search == this.dom) {
                    atEnd = false;
                    break;
                }
                if (search.previousSibling) break;
            }
            if (atEnd == null && offset == dom.childNodes.length) for(let search = dom;; search = search.parentNode){
                if (search == this.dom) {
                    atEnd = true;
                    break;
                }
                if (search.nextSibling) break;
            }
        }
        return (atEnd == null ? bias > 0 : atEnd) ? this.posAtEnd : this.posAtStart;
    }
    nearestDesc(dom, onlyNodes = false) {
        for(let first = true, cur = dom; cur; cur = cur.parentNode){
            let desc = this.getDesc(cur), nodeDOM;
            if (desc && (!onlyNodes || desc.node)) {
                // If dom is outside of this desc's nodeDOM, don't count it.
                if (first && (nodeDOM = desc.nodeDOM) && !(nodeDOM.nodeType == 1 ? nodeDOM.contains(dom.nodeType == 1 ? dom : dom.parentNode) : nodeDOM == dom)) first = false;
                else return desc;
            }
        }
    }
    getDesc(dom) {
        let desc = dom.pmViewDesc;
        for(let cur = desc; cur; cur = cur.parent)if (cur == this) return desc;
    }
    posFromDOM(dom, offset, bias) {
        for(let scan = dom; scan; scan = scan.parentNode){
            let desc = this.getDesc(scan);
            if (desc) return desc.localPosFromDOM(dom, offset, bias);
        }
        return -1;
    }
    // Find the desc for the node after the given pos, if any. (When a
    // parent node overrode rendering, there might not be one.)
    descAt(pos) {
        for(let i = 0, offset = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (offset == pos && end != offset) {
                while(!child.border && child.children.length)child = child.children[0];
                return child;
            }
            if (pos < end) return child.descAt(pos - offset - child.border);
            offset = end;
        }
    }
    domFromPos(pos, side) {
        if (!this.contentDOM) return {
            node: this.dom,
            offset: 0,
            atom: pos + 1
        };
        // First find the position in the child array
        let i = 0, offset = 0;
        for(let curPos = 0; i < this.children.length; i++){
            let child = this.children[i], end = curPos + child.size;
            if (end > pos || child instanceof $b5c91c309b2647a1$var$TrailingHackViewDesc) {
                offset = pos - curPos;
                break;
            }
            curPos = end;
        }
        // If this points into the middle of a child, call through
        if (offset) return this.children[i].domFromPos(offset - this.children[i].border, side);
        // Go back if there were any zero-length widgets with side >= 0 before this point
        for(let prev; i && !(prev = this.children[i - 1]).size && prev instanceof $b5c91c309b2647a1$var$WidgetViewDesc && prev.side >= 0; i--);
        // Scan towards the first useable node
        if (side <= 0) {
            let prev, enter = true;
            for(;; i--, enter = false){
                prev = i ? this.children[i - 1] : null;
                if (!prev || prev.dom.parentNode == this.contentDOM) break;
            }
            if (prev && side && enter && !prev.border && !prev.domAtom) return prev.domFromPos(prev.size, side);
            return {
                node: this.contentDOM,
                offset: prev ? $b5c91c309b2647a1$var$domIndex(prev.dom) + 1 : 0
            };
        } else {
            let next, enter = true;
            for(;; i++, enter = false){
                next = i < this.children.length ? this.children[i] : null;
                if (!next || next.dom.parentNode == this.contentDOM) break;
            }
            if (next && enter && !next.border && !next.domAtom) return next.domFromPos(0, side);
            return {
                node: this.contentDOM,
                offset: next ? $b5c91c309b2647a1$var$domIndex(next.dom) : this.contentDOM.childNodes.length
            };
        }
    }
    // Used to find a DOM range in a single parent for a given changed
    // range.
    parseRange(from, to, base = 0) {
        if (this.children.length == 0) return {
            node: this.contentDOM,
            from: from,
            to: to,
            fromOffset: 0,
            toOffset: this.contentDOM.childNodes.length
        };
        let fromOffset = -1, toOffset = -1;
        for(let offset = base, i = 0;; i++){
            let child = this.children[i], end = offset + child.size;
            if (fromOffset == -1 && from <= end) {
                let childBase = offset + child.border;
                // FIXME maybe descend mark views to parse a narrower range?
                if (from >= childBase && to <= end - child.border && child.node && child.contentDOM && this.contentDOM.contains(child.contentDOM)) return child.parseRange(from, to, childBase);
                from = offset;
                for(let j = i; j > 0; j--){
                    let prev = this.children[j - 1];
                    if (prev.size && prev.dom.parentNode == this.contentDOM && !prev.emptyChildAt(1)) {
                        fromOffset = $b5c91c309b2647a1$var$domIndex(prev.dom) + 1;
                        break;
                    }
                    from -= prev.size;
                }
                if (fromOffset == -1) fromOffset = 0;
            }
            if (fromOffset > -1 && (end > to || i == this.children.length - 1)) {
                to = end;
                for(let j = i + 1; j < this.children.length; j++){
                    let next = this.children[j];
                    if (next.size && next.dom.parentNode == this.contentDOM && !next.emptyChildAt(-1)) {
                        toOffset = $b5c91c309b2647a1$var$domIndex(next.dom);
                        break;
                    }
                    to += next.size;
                }
                if (toOffset == -1) toOffset = this.contentDOM.childNodes.length;
                break;
            }
            offset = end;
        }
        return {
            node: this.contentDOM,
            from: from,
            to: to,
            fromOffset: fromOffset,
            toOffset: toOffset
        };
    }
    emptyChildAt(side) {
        if (this.border || !this.contentDOM || !this.children.length) return false;
        let child = this.children[side < 0 ? 0 : this.children.length - 1];
        return child.size == 0 || child.emptyChildAt(side);
    }
    domAfterPos(pos) {
        let { node: node, offset: offset } = this.domFromPos(pos, 0);
        if (node.nodeType != 1 || offset == node.childNodes.length) throw new RangeError("No node after pos " + pos);
        return node.childNodes[offset];
    }
    // View descs are responsible for setting any selection that falls
    // entirely inside of them, so that custom implementations can do
    // custom things with the selection. Note that this falls apart when
    // a selection starts in such a node and ends in another, in which
    // case we just use whatever domFromPos produces as a best effort.
    setSelection(anchor, head, root, force = false) {
        // If the selection falls entirely in a child, give it to that child
        let from = Math.min(anchor, head), to = Math.max(anchor, head);
        for(let i = 0, offset = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (from > offset && to < end) return child.setSelection(anchor - offset - child.border, head - offset - child.border, root, force);
            offset = end;
        }
        let anchorDOM = this.domFromPos(anchor, anchor ? -1 : 1);
        let headDOM = head == anchor ? anchorDOM : this.domFromPos(head, head ? -1 : 1);
        let domSel = root.getSelection();
        let brKludge = false;
        // On Firefox, using Selection.collapse to put the cursor after a
        // BR node for some reason doesn't always work (#1073). On Safari,
        // the cursor sometimes inexplicable visually lags behind its
        // reported position in such situations (#1092).
        if (($b5c91c309b2647a1$var$gecko || $b5c91c309b2647a1$var$safari) && anchor == head) {
            let { node: node, offset: offset } = anchorDOM;
            if (node.nodeType == 3) {
                brKludge = !!(offset && node.nodeValue[offset - 1] == "\n");
                // Issue #1128
                if (brKludge && offset == node.nodeValue.length) for(let scan = node, after; scan; scan = scan.parentNode){
                    if (after = scan.nextSibling) {
                        if (after.nodeName == "BR") anchorDOM = headDOM = {
                            node: after.parentNode,
                            offset: $b5c91c309b2647a1$var$domIndex(after) + 1
                        };
                        break;
                    }
                    let desc = scan.pmViewDesc;
                    if (desc && desc.node && desc.node.isBlock) break;
                }
            } else {
                let prev = node.childNodes[offset - 1];
                brKludge = prev && (prev.nodeName == "BR" || prev.contentEditable == "false");
            }
        }
        // Firefox can act strangely when the selection is in front of an
        // uneditable node. See #1163 and https://bugzilla.mozilla.org/show_bug.cgi?id=1709536
        if ($b5c91c309b2647a1$var$gecko && domSel.focusNode && domSel.focusNode != headDOM.node && domSel.focusNode.nodeType == 1) {
            let after = domSel.focusNode.childNodes[domSel.focusOffset];
            if (after && after.contentEditable == "false") force = true;
        }
        if (!(force || brKludge && $b5c91c309b2647a1$var$safari) && $b5c91c309b2647a1$var$isEquivalentPosition(anchorDOM.node, anchorDOM.offset, domSel.anchorNode, domSel.anchorOffset) && $b5c91c309b2647a1$var$isEquivalentPosition(headDOM.node, headDOM.offset, domSel.focusNode, domSel.focusOffset)) return;
        // Selection.extend can be used to create an 'inverted' selection
        // (one where the focus is before the anchor), but not all
        // browsers support it yet.
        let domSelExtended = false;
        if ((domSel.extend || anchor == head) && !brKludge) {
            domSel.collapse(anchorDOM.node, anchorDOM.offset);
            try {
                if (anchor != head) domSel.extend(headDOM.node, headDOM.offset);
                domSelExtended = true;
            } catch (_) {
            // In some cases with Chrome the selection is empty after calling
            // collapse, even when it should be valid. This appears to be a bug, but
            // it is difficult to isolate. If this happens fallback to the old path
            // without using extend.
            // Similarly, this could crash on Safari if the editor is hidden, and
            // there was no selection.
            }
        }
        if (!domSelExtended) {
            if (anchor > head) {
                let tmp = anchorDOM;
                anchorDOM = headDOM;
                headDOM = tmp;
            }
            let range = document.createRange();
            range.setEnd(headDOM.node, headDOM.offset);
            range.setStart(anchorDOM.node, anchorDOM.offset);
            domSel.removeAllRanges();
            domSel.addRange(range);
        }
    }
    ignoreMutation(mutation) {
        return !this.contentDOM && mutation.type != "selection";
    }
    get contentLost() {
        return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
    }
    // Remove a subtree of the element tree that has been touched
    // by a DOM change, so that the next update will redraw it.
    markDirty(from, to) {
        for(let offset = 0, i = 0; i < this.children.length; i++){
            let child = this.children[i], end = offset + child.size;
            if (offset == end ? from <= end && to >= offset : from < end && to > offset) {
                let startInside = offset + child.border, endInside = end - child.border;
                if (from >= startInside && to <= endInside) {
                    this.dirty = from == offset || to == end ? $b5c91c309b2647a1$var$CONTENT_DIRTY : $b5c91c309b2647a1$var$CHILD_DIRTY;
                    if (from == startInside && to == endInside && (child.contentLost || child.dom.parentNode != this.contentDOM)) child.dirty = $b5c91c309b2647a1$var$NODE_DIRTY;
                    else child.markDirty(from - startInside, to - startInside);
                    return;
                } else child.dirty = child.dom == child.contentDOM && child.dom.parentNode == this.contentDOM && !child.children.length ? $b5c91c309b2647a1$var$CONTENT_DIRTY : $b5c91c309b2647a1$var$NODE_DIRTY;
            }
            offset = end;
        }
        this.dirty = $b5c91c309b2647a1$var$CONTENT_DIRTY;
    }
    markParentsDirty() {
        let level = 1;
        for(let node = this.parent; node; node = node.parent, level++){
            let dirty = level == 1 ? $b5c91c309b2647a1$var$CONTENT_DIRTY : $b5c91c309b2647a1$var$CHILD_DIRTY;
            if (node.dirty < dirty) node.dirty = dirty;
        }
    }
    get domAtom() {
        return false;
    }
    get ignoreForCoords() {
        return false;
    }
    isText(text) {
        return false;
    }
}
// A widget desc represents a widget decoration, which is a DOM node
// drawn between the document nodes.
class $b5c91c309b2647a1$var$WidgetViewDesc extends $b5c91c309b2647a1$var$ViewDesc {
    constructor(parent, widget, view, pos){
        let self, dom = widget.type.toDOM;
        if (typeof dom == "function") dom = dom(view, ()=>{
            if (!self) return pos;
            if (self.parent) return self.parent.posBeforeChild(self);
        });
        if (!widget.type.spec.raw) {
            if (dom.nodeType != 1) {
                let wrap = document.createElement("span");
                wrap.appendChild(dom);
                dom = wrap;
            }
            dom.contentEditable = "false";
            dom.classList.add("ProseMirror-widget");
        }
        super(parent, [], dom, null);
        this.widget = widget;
        this.widget = widget;
        self = this;
    }
    matchesWidget(widget) {
        return this.dirty == $b5c91c309b2647a1$var$NOT_DIRTY && widget.type.eq(this.widget.type);
    }
    parseRule() {
        return {
            ignore: true
        };
    }
    stopEvent(event) {
        let stop = this.widget.spec.stopEvent;
        return stop ? stop(event) : false;
    }
    ignoreMutation(mutation) {
        return mutation.type != "selection" || this.widget.spec.ignoreSelection;
    }
    destroy() {
        this.widget.type.destroy(this.dom);
        super.destroy();
    }
    get domAtom() {
        return true;
    }
    get side() {
        return this.widget.type.side;
    }
}
class $b5c91c309b2647a1$var$CompositionViewDesc extends $b5c91c309b2647a1$var$ViewDesc {
    constructor(parent, dom, textDOM, text){
        super(parent, [], dom, null);
        this.textDOM = textDOM;
        this.text = text;
    }
    get size() {
        return this.text.length;
    }
    localPosFromDOM(dom, offset) {
        if (dom != this.textDOM) return this.posAtStart + (offset ? this.size : 0);
        return this.posAtStart + offset;
    }
    domFromPos(pos) {
        return {
            node: this.textDOM,
            offset: pos
        };
    }
    ignoreMutation(mut) {
        return mut.type === 'characterData' && mut.target.nodeValue == mut.oldValue;
    }
}
// A mark desc represents a mark. May have multiple children,
// depending on how the mark is split. Note that marks are drawn using
// a fixed nesting order, for simplicity and predictability, so in
// some cases they will be split more often than would appear
// necessary.
class $b5c91c309b2647a1$var$MarkViewDesc extends $b5c91c309b2647a1$var$ViewDesc {
    constructor(parent, mark, dom, contentDOM){
        super(parent, [], dom, contentDOM);
        this.mark = mark;
    }
    static create(parent, mark, inline, view) {
        let custom = view.nodeViews[mark.type.name];
        let spec = custom && custom(mark, view, inline);
        if (!spec || !spec.dom) spec = (0, $7dkLM.DOMSerializer).renderSpec(document, mark.type.spec.toDOM(mark, inline));
        return new $b5c91c309b2647a1$var$MarkViewDesc(parent, mark, spec.dom, spec.contentDOM || spec.dom);
    }
    parseRule() {
        if (this.dirty & $b5c91c309b2647a1$var$NODE_DIRTY || this.mark.type.spec.reparseInView) return null;
        return {
            mark: this.mark.type.name,
            attrs: this.mark.attrs,
            contentElement: this.contentDOM
        };
    }
    matchesMark(mark) {
        return this.dirty != $b5c91c309b2647a1$var$NODE_DIRTY && this.mark.eq(mark);
    }
    markDirty(from, to) {
        super.markDirty(from, to);
        // Move dirty info to nearest node view
        if (this.dirty != $b5c91c309b2647a1$var$NOT_DIRTY) {
            let parent = this.parent;
            while(!parent.node)parent = parent.parent;
            if (parent.dirty < this.dirty) parent.dirty = this.dirty;
            this.dirty = $b5c91c309b2647a1$var$NOT_DIRTY;
        }
    }
    slice(from, to, view) {
        let copy = $b5c91c309b2647a1$var$MarkViewDesc.create(this.parent, this.mark, true, view);
        let nodes = this.children, size = this.size;
        if (to < size) nodes = $b5c91c309b2647a1$var$replaceNodes(nodes, to, size, view);
        if (from > 0) nodes = $b5c91c309b2647a1$var$replaceNodes(nodes, 0, from, view);
        for(let i = 0; i < nodes.length; i++)nodes[i].parent = copy;
        copy.children = nodes;
        return copy;
    }
}
// Node view descs are the main, most common type of view desc, and
// correspond to an actual node in the document. Unlike mark descs,
// they populate their child array themselves.
class $b5c91c309b2647a1$var$NodeViewDesc extends $b5c91c309b2647a1$var$ViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos){
        super(parent, [], dom, contentDOM);
        this.node = node;
        this.outerDeco = outerDeco;
        this.innerDeco = innerDeco;
        this.nodeDOM = nodeDOM;
    }
    // By default, a node is rendered using the `toDOM` method from the
    // node type spec. But client code can use the `nodeViews` spec to
    // supply a custom node view, which can influence various aspects of
    // the way the node works.
    //
    // (Using subclassing for this was intentionally decided against,
    // since it'd require exposing a whole slew of finicky
    // implementation details to the user code that they probably will
    // never need.)
    static create(parent, node, outerDeco, innerDeco, view, pos) {
        let custom = view.nodeViews[node.type.name], descObj;
        let spec = custom && custom(node, view, ()=>{
            // (This is a function that allows the custom view to find its
            // own position)
            if (!descObj) return pos;
            if (descObj.parent) return descObj.parent.posBeforeChild(descObj);
        }, outerDeco, innerDeco);
        let dom = spec && spec.dom, contentDOM = spec && spec.contentDOM;
        if (node.isText) {
            if (!dom) dom = document.createTextNode(node.text);
            else if (dom.nodeType != 3) throw new RangeError("Text must be rendered as a DOM text node");
        } else if (!dom) ({ dom: dom, contentDOM: contentDOM } = (0, $7dkLM.DOMSerializer).renderSpec(document, node.type.spec.toDOM(node)));
        if (!contentDOM && !node.isText && dom.nodeName != "BR") {
            if (!dom.hasAttribute("contenteditable")) dom.contentEditable = "false";
            if (node.type.spec.draggable) dom.draggable = true;
        }
        let nodeDOM = dom;
        dom = $b5c91c309b2647a1$var$applyOuterDeco(dom, outerDeco, node);
        if (spec) return descObj = new $b5c91c309b2647a1$var$CustomNodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, spec, view, pos + 1);
        else if (node.isText) return new $b5c91c309b2647a1$var$TextViewDesc(parent, node, outerDeco, innerDeco, dom, nodeDOM, view);
        else return new $b5c91c309b2647a1$var$NodeViewDesc(parent, node, outerDeco, innerDeco, dom, contentDOM || null, nodeDOM, view, pos + 1);
    }
    parseRule() {
        // Experimental kludge to allow opt-in re-parsing of nodes
        if (this.node.type.spec.reparseInView) return null;
        // FIXME the assumption that this can always return the current
        // attrs means that if the user somehow manages to change the
        // attrs in the dom, that won't be picked up. Not entirely sure
        // whether this is a problem
        let rule = {
            node: this.node.type.name,
            attrs: this.node.attrs
        };
        if (this.node.type.whitespace == "pre") rule.preserveWhitespace = "full";
        if (!this.contentDOM) rule.getContent = ()=>this.node.content;
        else if (!this.contentLost) rule.contentElement = this.contentDOM;
        else {
            // Chrome likes to randomly recreate parent nodes when
            // backspacing things. When that happens, this tries to find the
            // new parent.
            for(let i = this.children.length - 1; i >= 0; i--){
                let child = this.children[i];
                if (this.dom.contains(child.dom.parentNode)) {
                    rule.contentElement = child.dom.parentNode;
                    break;
                }
            }
            if (!rule.contentElement) rule.getContent = ()=>(0, $7dkLM.Fragment).empty;
        }
        return rule;
    }
    matchesNode(node, outerDeco, innerDeco) {
        return this.dirty == $b5c91c309b2647a1$var$NOT_DIRTY && node.eq(this.node) && $b5c91c309b2647a1$var$sameOuterDeco(outerDeco, this.outerDeco) && innerDeco.eq(this.innerDeco);
    }
    get size() {
        return this.node.nodeSize;
    }
    get border() {
        return this.node.isLeaf ? 0 : 1;
    }
    // Syncs `this.children` to match `this.node.content` and the local
    // decorations, possibly introducing nesting for marks. Then, in a
    // separate step, syncs the DOM inside `this.contentDOM` to
    // `this.children`.
    updateChildren(view, pos) {
        let inline = this.node.inlineContent, off = pos;
        let composition = view.composing ? this.localCompositionInfo(view, pos) : null;
        let localComposition = composition && composition.pos > -1 ? composition : null;
        let compositionInChild = composition && composition.pos < 0;
        let updater = new $b5c91c309b2647a1$var$ViewTreeUpdater(this, localComposition && localComposition.node, view);
        $b5c91c309b2647a1$var$iterDeco(this.node, this.innerDeco, (widget, i, insideNode)=>{
            if (widget.spec.marks) updater.syncToMarks(widget.spec.marks, inline, view);
            else if (widget.type.side >= 0 && !insideNode) updater.syncToMarks(i == this.node.childCount ? (0, $7dkLM.Mark).none : this.node.child(i).marks, inline, view);
            // If the next node is a desc matching this widget, reuse it,
            // otherwise insert the widget as a new view desc.
            updater.placeWidget(widget, view, off);
        }, (child, outerDeco, innerDeco, i)=>{
            // Make sure the wrapping mark descs match the node's marks.
            updater.syncToMarks(child.marks, inline, view);
            // Try several strategies for drawing this node
            let compIndex;
            if (updater.findNodeMatch(child, outerDeco, innerDeco, i)) ;
            else if (compositionInChild && view.state.selection.from > off && view.state.selection.to < off + child.nodeSize && (compIndex = updater.findIndexWithChild(composition.node)) > -1 && updater.updateNodeAt(child, outerDeco, innerDeco, compIndex, view)) ;
            else if (updater.updateNextNode(child, outerDeco, innerDeco, view, i, off)) ;
            else // Add it as a new view
            updater.addNode(child, outerDeco, innerDeco, view, off);
            off += child.nodeSize;
        });
        // Drop all remaining descs after the current position.
        updater.syncToMarks([], inline, view);
        if (this.node.isTextblock) updater.addTextblockHacks();
        updater.destroyRest();
        // Sync the DOM if anything changed
        if (updater.changed || this.dirty == $b5c91c309b2647a1$var$CONTENT_DIRTY) {
            // May have to protect focused DOM from being changed if a composition is active
            if (localComposition) this.protectLocalComposition(view, localComposition);
            $b5c91c309b2647a1$var$renderDescs(this.contentDOM, this.children, view);
            if ($b5c91c309b2647a1$var$ios) $b5c91c309b2647a1$var$iosHacks(this.dom);
        }
    }
    localCompositionInfo(view, pos) {
        // Only do something if both the selection and a focused text node
        // are inside of this node
        let { from: from, to: to } = view.state.selection;
        if (!(view.state.selection instanceof (0, $kpTIW.TextSelection)) || from < pos || to > pos + this.node.content.size) return null;
        let textNode = view.input.compositionNode;
        if (!textNode || !this.dom.contains(textNode.parentNode)) return null;
        if (this.node.inlineContent) {
            // Find the text in the focused node in the node, stop if it's not
            // there (may have been modified through other means, in which
            // case it should overwritten)
            let text = textNode.nodeValue;
            let textPos = $b5c91c309b2647a1$var$findTextInFragment(this.node.content, text, from - pos, to - pos);
            return textPos < 0 ? null : {
                node: textNode,
                pos: textPos,
                text: text
            };
        } else return {
            node: textNode,
            pos: -1,
            text: ""
        };
    }
    protectLocalComposition(view, { node: node, pos: pos, text: text }) {
        // The node is already part of a local view desc, leave it there
        if (this.getDesc(node)) return;
        // Create a composition view for the orphaned nodes
        let topNode = node;
        for(;; topNode = topNode.parentNode){
            if (topNode.parentNode == this.contentDOM) break;
            while(topNode.previousSibling)topNode.parentNode.removeChild(topNode.previousSibling);
            while(topNode.nextSibling)topNode.parentNode.removeChild(topNode.nextSibling);
            if (topNode.pmViewDesc) topNode.pmViewDesc = undefined;
        }
        let desc = new $b5c91c309b2647a1$var$CompositionViewDesc(this, topNode, node, text);
        view.input.compositionNodes.push(desc);
        // Patch up this.children to contain the composition view
        this.children = $b5c91c309b2647a1$var$replaceNodes(this.children, pos, pos + text.length, view, desc);
    }
    // If this desc must be updated to match the given node decoration,
    // do so and return true.
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $b5c91c309b2647a1$var$NODE_DIRTY || !node.sameMarkup(this.node)) return false;
        this.updateInner(node, outerDeco, innerDeco, view);
        return true;
    }
    updateInner(node, outerDeco, innerDeco, view) {
        this.updateOuterDeco(outerDeco);
        this.node = node;
        this.innerDeco = innerDeco;
        if (this.contentDOM) this.updateChildren(view, this.posAtStart);
        this.dirty = $b5c91c309b2647a1$var$NOT_DIRTY;
    }
    updateOuterDeco(outerDeco) {
        if ($b5c91c309b2647a1$var$sameOuterDeco(outerDeco, this.outerDeco)) return;
        let needsWrap = this.nodeDOM.nodeType != 1;
        let oldDOM = this.dom;
        this.dom = $b5c91c309b2647a1$var$patchOuterDeco(this.dom, this.nodeDOM, $b5c91c309b2647a1$var$computeOuterDeco(this.outerDeco, this.node, needsWrap), $b5c91c309b2647a1$var$computeOuterDeco(outerDeco, this.node, needsWrap));
        if (this.dom != oldDOM) {
            oldDOM.pmViewDesc = undefined;
            this.dom.pmViewDesc = this;
        }
        this.outerDeco = outerDeco;
    }
    // Mark this node as being the selected node.
    selectNode() {
        if (this.nodeDOM.nodeType == 1) this.nodeDOM.classList.add("ProseMirror-selectednode");
        if (this.contentDOM || !this.node.type.spec.draggable) this.dom.draggable = true;
    }
    // Remove selected node marking from this node.
    deselectNode() {
        if (this.nodeDOM.nodeType == 1) this.nodeDOM.classList.remove("ProseMirror-selectednode");
        if (this.contentDOM || !this.node.type.spec.draggable) this.dom.removeAttribute("draggable");
    }
    get domAtom() {
        return this.node.isAtom;
    }
}
// Create a view desc for the top-level document node, to be exported
// and used by the view class.
function $b5c91c309b2647a1$var$docViewDesc(doc, outerDeco, innerDeco, dom, view) {
    $b5c91c309b2647a1$var$applyOuterDeco(dom, outerDeco, doc);
    let docView = new $b5c91c309b2647a1$var$NodeViewDesc(undefined, doc, outerDeco, innerDeco, dom, dom, dom, view, 0);
    if (docView.contentDOM) docView.updateChildren(view, 0);
    return docView;
}
class $b5c91c309b2647a1$var$TextViewDesc extends $b5c91c309b2647a1$var$NodeViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, nodeDOM, view){
        super(parent, node, outerDeco, innerDeco, dom, null, nodeDOM, view, 0);
    }
    parseRule() {
        let skip = this.nodeDOM.parentNode;
        while(skip && skip != this.dom && !skip.pmIsDeco)skip = skip.parentNode;
        return {
            skip: skip || true
        };
    }
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $b5c91c309b2647a1$var$NODE_DIRTY || this.dirty != $b5c91c309b2647a1$var$NOT_DIRTY && !this.inParent() || !node.sameMarkup(this.node)) return false;
        this.updateOuterDeco(outerDeco);
        if ((this.dirty != $b5c91c309b2647a1$var$NOT_DIRTY || node.text != this.node.text) && node.text != this.nodeDOM.nodeValue) {
            this.nodeDOM.nodeValue = node.text;
            if (view.trackWrites == this.nodeDOM) view.trackWrites = null;
        }
        this.node = node;
        this.dirty = $b5c91c309b2647a1$var$NOT_DIRTY;
        return true;
    }
    inParent() {
        let parentDOM = this.parent.contentDOM;
        for(let n = this.nodeDOM; n; n = n.parentNode)if (n == parentDOM) return true;
        return false;
    }
    domFromPos(pos) {
        return {
            node: this.nodeDOM,
            offset: pos
        };
    }
    localPosFromDOM(dom, offset, bias) {
        if (dom == this.nodeDOM) return this.posAtStart + Math.min(offset, this.node.text.length);
        return super.localPosFromDOM(dom, offset, bias);
    }
    ignoreMutation(mutation) {
        return mutation.type != "characterData" && mutation.type != "selection";
    }
    slice(from, to, view) {
        let node = this.node.cut(from, to), dom = document.createTextNode(node.text);
        return new $b5c91c309b2647a1$var$TextViewDesc(this.parent, node, this.outerDeco, this.innerDeco, dom, dom, view);
    }
    markDirty(from, to) {
        super.markDirty(from, to);
        if (this.dom != this.nodeDOM && (from == 0 || to == this.nodeDOM.nodeValue.length)) this.dirty = $b5c91c309b2647a1$var$NODE_DIRTY;
    }
    get domAtom() {
        return false;
    }
    isText(text) {
        return this.node.text == text;
    }
}
// A dummy desc used to tag trailing BR or IMG nodes created to work
// around contentEditable terribleness.
class $b5c91c309b2647a1$var$TrailingHackViewDesc extends $b5c91c309b2647a1$var$ViewDesc {
    parseRule() {
        return {
            ignore: true
        };
    }
    matchesHack(nodeName) {
        return this.dirty == $b5c91c309b2647a1$var$NOT_DIRTY && this.dom.nodeName == nodeName;
    }
    get domAtom() {
        return true;
    }
    get ignoreForCoords() {
        return this.dom.nodeName == "IMG";
    }
}
// A separate subclass is used for customized node views, so that the
// extra checks only have to be made for nodes that are actually
// customized.
class $b5c91c309b2647a1$var$CustomNodeViewDesc extends $b5c91c309b2647a1$var$NodeViewDesc {
    constructor(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, spec, view, pos){
        super(parent, node, outerDeco, innerDeco, dom, contentDOM, nodeDOM, view, pos);
        this.spec = spec;
    }
    // A custom `update` method gets to decide whether the update goes
    // through. If it does, and there's a `contentDOM` node, our logic
    // updates the children.
    update(node, outerDeco, innerDeco, view) {
        if (this.dirty == $b5c91c309b2647a1$var$NODE_DIRTY) return false;
        if (this.spec.update) {
            let result = this.spec.update(node, outerDeco, innerDeco);
            if (result) this.updateInner(node, outerDeco, innerDeco, view);
            return result;
        } else if (!this.contentDOM && !node.isLeaf) return false;
        else return super.update(node, outerDeco, innerDeco, view);
    }
    selectNode() {
        this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
    }
    deselectNode() {
        this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
    }
    setSelection(anchor, head, root, force) {
        this.spec.setSelection ? this.spec.setSelection(anchor, head, root) : super.setSelection(anchor, head, root, force);
    }
    destroy() {
        if (this.spec.destroy) this.spec.destroy();
        super.destroy();
    }
    stopEvent(event) {
        return this.spec.stopEvent ? this.spec.stopEvent(event) : false;
    }
    ignoreMutation(mutation) {
        return this.spec.ignoreMutation ? this.spec.ignoreMutation(mutation) : super.ignoreMutation(mutation);
    }
}
// Sync the content of the given DOM node with the nodes associated
// with the given array of view descs, recursing into mark descs
// because this should sync the subtree for a whole node at a time.
function $b5c91c309b2647a1$var$renderDescs(parentDOM, descs, view) {
    let dom = parentDOM.firstChild, written = false;
    for(let i = 0; i < descs.length; i++){
        let desc = descs[i], childDOM = desc.dom;
        if (childDOM.parentNode == parentDOM) {
            while(childDOM != dom){
                dom = $b5c91c309b2647a1$var$rm(dom);
                written = true;
            }
            dom = dom.nextSibling;
        } else {
            written = true;
            parentDOM.insertBefore(childDOM, dom);
        }
        if (desc instanceof $b5c91c309b2647a1$var$MarkViewDesc) {
            let pos = dom ? dom.previousSibling : parentDOM.lastChild;
            $b5c91c309b2647a1$var$renderDescs(desc.contentDOM, desc.children, view);
            dom = pos ? pos.nextSibling : parentDOM.firstChild;
        }
    }
    while(dom){
        dom = $b5c91c309b2647a1$var$rm(dom);
        written = true;
    }
    if (written && view.trackWrites == parentDOM) view.trackWrites = null;
}
const $b5c91c309b2647a1$var$OuterDecoLevel = function(nodeName) {
    if (nodeName) this.nodeName = nodeName;
};
$b5c91c309b2647a1$var$OuterDecoLevel.prototype = Object.create(null);
const $b5c91c309b2647a1$var$noDeco = [
    new $b5c91c309b2647a1$var$OuterDecoLevel
];
function $b5c91c309b2647a1$var$computeOuterDeco(outerDeco, node, needsWrap) {
    if (outerDeco.length == 0) return $b5c91c309b2647a1$var$noDeco;
    let top = needsWrap ? $b5c91c309b2647a1$var$noDeco[0] : new $b5c91c309b2647a1$var$OuterDecoLevel, result = [
        top
    ];
    for(let i = 0; i < outerDeco.length; i++){
        let attrs = outerDeco[i].type.attrs;
        if (!attrs) continue;
        if (attrs.nodeName) result.push(top = new $b5c91c309b2647a1$var$OuterDecoLevel(attrs.nodeName));
        for(let name in attrs){
            let val = attrs[name];
            if (val == null) continue;
            if (needsWrap && result.length == 1) result.push(top = new $b5c91c309b2647a1$var$OuterDecoLevel(node.isInline ? "span" : "div"));
            if (name == "class") top.class = (top.class ? top.class + " " : "") + val;
            else if (name == "style") top.style = (top.style ? top.style + ";" : "") + val;
            else if (name != "nodeName") top[name] = val;
        }
    }
    return result;
}
function $b5c91c309b2647a1$var$patchOuterDeco(outerDOM, nodeDOM, prevComputed, curComputed) {
    // Shortcut for trivial case
    if (prevComputed == $b5c91c309b2647a1$var$noDeco && curComputed == $b5c91c309b2647a1$var$noDeco) return nodeDOM;
    let curDOM = nodeDOM;
    for(let i = 0; i < curComputed.length; i++){
        let deco = curComputed[i], prev = prevComputed[i];
        if (i) {
            let parent;
            if (prev && prev.nodeName == deco.nodeName && curDOM != outerDOM && (parent = curDOM.parentNode) && parent.nodeName.toLowerCase() == deco.nodeName) curDOM = parent;
            else {
                parent = document.createElement(deco.nodeName);
                parent.pmIsDeco = true;
                parent.appendChild(curDOM);
                prev = $b5c91c309b2647a1$var$noDeco[0];
                curDOM = parent;
            }
        }
        $b5c91c309b2647a1$var$patchAttributes(curDOM, prev || $b5c91c309b2647a1$var$noDeco[0], deco);
    }
    return curDOM;
}
function $b5c91c309b2647a1$var$patchAttributes(dom, prev, cur) {
    for(let name in prev)if (name != "class" && name != "style" && name != "nodeName" && !(name in cur)) dom.removeAttribute(name);
    for(let name in cur)if (name != "class" && name != "style" && name != "nodeName" && cur[name] != prev[name]) dom.setAttribute(name, cur[name]);
    if (prev.class != cur.class) {
        let prevList = prev.class ? prev.class.split(" ").filter(Boolean) : [];
        let curList = cur.class ? cur.class.split(" ").filter(Boolean) : [];
        for(let i = 0; i < prevList.length; i++)if (curList.indexOf(prevList[i]) == -1) dom.classList.remove(prevList[i]);
        for(let i = 0; i < curList.length; i++)if (prevList.indexOf(curList[i]) == -1) dom.classList.add(curList[i]);
        if (dom.classList.length == 0) dom.removeAttribute("class");
    }
    if (prev.style != cur.style) {
        if (prev.style) {
            let prop = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, m;
            while(m = prop.exec(prev.style))dom.style.removeProperty(m[1]);
        }
        if (cur.style) dom.style.cssText += cur.style;
    }
}
function $b5c91c309b2647a1$var$applyOuterDeco(dom, deco, node) {
    return $b5c91c309b2647a1$var$patchOuterDeco(dom, dom, $b5c91c309b2647a1$var$noDeco, $b5c91c309b2647a1$var$computeOuterDeco(deco, node, dom.nodeType != 1));
}
function $b5c91c309b2647a1$var$sameOuterDeco(a, b) {
    if (a.length != b.length) return false;
    for(let i = 0; i < a.length; i++)if (!a[i].type.eq(b[i].type)) return false;
    return true;
}
// Remove a DOM node and return its next sibling.
function $b5c91c309b2647a1$var$rm(dom) {
    let next = dom.nextSibling;
    dom.parentNode.removeChild(dom);
    return next;
}
// Helper class for incrementally updating a tree of mark descs and
// the widget and node descs inside of them.
class $b5c91c309b2647a1$var$ViewTreeUpdater {
    constructor(top, lock, view){
        this.lock = lock;
        this.view = view;
        // Index into `this.top`'s child array, represents the current
        // update position.
        this.index = 0;
        // When entering a mark, the current top and index are pushed
        // onto this.
        this.stack = [];
        // Tracks whether anything was changed
        this.changed = false;
        this.top = top;
        this.preMatch = $b5c91c309b2647a1$var$preMatch(top.node.content, top);
    }
    // Destroy and remove the children between the given indices in
    // `this.top`.
    destroyBetween(start, end) {
        if (start == end) return;
        for(let i = start; i < end; i++)this.top.children[i].destroy();
        this.top.children.splice(start, end - start);
        this.changed = true;
    }
    // Destroy all remaining children in `this.top`.
    destroyRest() {
        this.destroyBetween(this.index, this.top.children.length);
    }
    // Sync the current stack of mark descs with the given array of
    // marks, reusing existing mark descs when possible.
    syncToMarks(marks, inline, view) {
        let keep = 0, depth = this.stack.length >> 1;
        let maxKeep = Math.min(depth, marks.length);
        while(keep < maxKeep && (keep == depth - 1 ? this.top : this.stack[keep + 1 << 1]).matchesMark(marks[keep]) && marks[keep].type.spec.spanning !== false)keep++;
        while(keep < depth){
            this.destroyRest();
            this.top.dirty = $b5c91c309b2647a1$var$NOT_DIRTY;
            this.index = this.stack.pop();
            this.top = this.stack.pop();
            depth--;
        }
        while(depth < marks.length){
            this.stack.push(this.top, this.index + 1);
            let found = -1;
            for(let i = this.index; i < Math.min(this.index + 3, this.top.children.length); i++){
                let next = this.top.children[i];
                if (next.matchesMark(marks[depth]) && !this.isLocked(next.dom)) {
                    found = i;
                    break;
                }
            }
            if (found > -1) {
                if (found > this.index) {
                    this.changed = true;
                    this.destroyBetween(this.index, found);
                }
                this.top = this.top.children[this.index];
            } else {
                let markDesc = $b5c91c309b2647a1$var$MarkViewDesc.create(this.top, marks[depth], inline, view);
                this.top.children.splice(this.index, 0, markDesc);
                this.top = markDesc;
                this.changed = true;
            }
            this.index = 0;
            depth++;
        }
    }
    // Try to find a node desc matching the given data. Skip over it and
    // return true when successful.
    findNodeMatch(node, outerDeco, innerDeco, index) {
        let found = -1, targetDesc;
        if (index >= this.preMatch.index && (targetDesc = this.preMatch.matches[index - this.preMatch.index]).parent == this.top && targetDesc.matchesNode(node, outerDeco, innerDeco)) found = this.top.children.indexOf(targetDesc, this.index);
        else for(let i = this.index, e = Math.min(this.top.children.length, i + 5); i < e; i++){
            let child = this.top.children[i];
            if (child.matchesNode(node, outerDeco, innerDeco) && !this.preMatch.matched.has(child)) {
                found = i;
                break;
            }
        }
        if (found < 0) return false;
        this.destroyBetween(this.index, found);
        this.index++;
        return true;
    }
    updateNodeAt(node, outerDeco, innerDeco, index, view) {
        let child = this.top.children[index];
        if (child.dirty == $b5c91c309b2647a1$var$NODE_DIRTY && child.dom == child.contentDOM) child.dirty = $b5c91c309b2647a1$var$CONTENT_DIRTY;
        if (!child.update(node, outerDeco, innerDeco, view)) return false;
        this.destroyBetween(this.index, index);
        this.index++;
        return true;
    }
    findIndexWithChild(domNode) {
        for(;;){
            let parent = domNode.parentNode;
            if (!parent) return -1;
            if (parent == this.top.contentDOM) {
                let desc = domNode.pmViewDesc;
                if (desc) for(let i = this.index; i < this.top.children.length; i++){
                    if (this.top.children[i] == desc) return i;
                }
                return -1;
            }
            domNode = parent;
        }
    }
    // Try to update the next node, if any, to the given data. Checks
    // pre-matches to avoid overwriting nodes that could still be used.
    updateNextNode(node, outerDeco, innerDeco, view, index, pos) {
        for(let i = this.index; i < this.top.children.length; i++){
            let next = this.top.children[i];
            if (next instanceof $b5c91c309b2647a1$var$NodeViewDesc) {
                let preMatch = this.preMatch.matched.get(next);
                if (preMatch != null && preMatch != index) return false;
                let nextDOM = next.dom, updated;
                // Can't update if nextDOM is or contains this.lock, except if
                // it's a text node whose content already matches the new text
                // and whose decorations match the new ones.
                let locked = this.isLocked(nextDOM) && !(node.isText && next.node && next.node.isText && next.nodeDOM.nodeValue == node.text && next.dirty != $b5c91c309b2647a1$var$NODE_DIRTY && $b5c91c309b2647a1$var$sameOuterDeco(outerDeco, next.outerDeco));
                if (!locked && next.update(node, outerDeco, innerDeco, view)) {
                    this.destroyBetween(this.index, i);
                    if (next.dom != nextDOM) this.changed = true;
                    this.index++;
                    return true;
                } else if (!locked && (updated = this.recreateWrapper(next, node, outerDeco, innerDeco, view, pos))) {
                    this.top.children[this.index] = updated;
                    if (updated.contentDOM) {
                        updated.dirty = $b5c91c309b2647a1$var$CONTENT_DIRTY;
                        updated.updateChildren(view, pos + 1);
                        updated.dirty = $b5c91c309b2647a1$var$NOT_DIRTY;
                    }
                    this.changed = true;
                    this.index++;
                    return true;
                }
                break;
            }
        }
        return false;
    }
    // When a node with content is replaced by a different node with
    // identical content, move over its children.
    recreateWrapper(next, node, outerDeco, innerDeco, view, pos) {
        if (next.dirty || node.isAtom || !next.children.length || !next.node.content.eq(node.content)) return null;
        let wrapper = $b5c91c309b2647a1$var$NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
        if (wrapper.contentDOM) {
            wrapper.children = next.children;
            next.children = [];
            for (let ch of wrapper.children)ch.parent = wrapper;
        }
        next.destroy();
        return wrapper;
    }
    // Insert the node as a newly created node desc.
    addNode(node, outerDeco, innerDeco, view, pos) {
        let desc = $b5c91c309b2647a1$var$NodeViewDesc.create(this.top, node, outerDeco, innerDeco, view, pos);
        if (desc.contentDOM) desc.updateChildren(view, pos + 1);
        this.top.children.splice(this.index++, 0, desc);
        this.changed = true;
    }
    placeWidget(widget, view, pos) {
        let next = this.index < this.top.children.length ? this.top.children[this.index] : null;
        if (next && next.matchesWidget(widget) && (widget == next.widget || !next.widget.type.toDOM.parentNode)) this.index++;
        else {
            let desc = new $b5c91c309b2647a1$var$WidgetViewDesc(this.top, widget, view, pos);
            this.top.children.splice(this.index++, 0, desc);
            this.changed = true;
        }
    }
    // Make sure a textblock looks and behaves correctly in
    // contentEditable.
    addTextblockHacks() {
        let lastChild = this.top.children[this.index - 1], parent = this.top;
        while(lastChild instanceof $b5c91c309b2647a1$var$MarkViewDesc){
            parent = lastChild;
            lastChild = parent.children[parent.children.length - 1];
        }
        if (!lastChild || // Empty textblock
        !(lastChild instanceof $b5c91c309b2647a1$var$TextViewDesc) || /\n$/.test(lastChild.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(lastChild.node.text)) {
            // Avoid bugs in Safari's cursor drawing (#1165) and Chrome's mouse selection (#1152)
            if (($b5c91c309b2647a1$var$safari || $b5c91c309b2647a1$var$chrome) && lastChild && lastChild.dom.contentEditable == "false") this.addHackNode("IMG", parent);
            this.addHackNode("BR", this.top);
        }
    }
    addHackNode(nodeName, parent) {
        if (parent == this.top && this.index < parent.children.length && parent.children[this.index].matchesHack(nodeName)) this.index++;
        else {
            let dom = document.createElement(nodeName);
            if (nodeName == "IMG") {
                dom.className = "ProseMirror-separator";
                dom.alt = "";
            }
            if (nodeName == "BR") dom.className = "ProseMirror-trailingBreak";
            let hack = new $b5c91c309b2647a1$var$TrailingHackViewDesc(this.top, [], dom, null);
            if (parent != this.top) parent.children.push(hack);
            else parent.children.splice(this.index++, 0, hack);
            this.changed = true;
        }
    }
    isLocked(node) {
        return this.lock && (node == this.lock || node.nodeType == 1 && node.contains(this.lock.parentNode));
    }
}
// Iterate from the end of the fragment and array of descs to find
// directly matching ones, in order to avoid overeagerly reusing those
// for other nodes. Returns the fragment index of the first node that
// is part of the sequence of matched nodes at the end of the
// fragment.
function $b5c91c309b2647a1$var$preMatch(frag, parentDesc) {
    let curDesc = parentDesc, descI = curDesc.children.length;
    let fI = frag.childCount, matched = new Map, matches = [];
    outer: while(fI > 0){
        let desc;
        for(;;){
            if (descI) {
                let next = curDesc.children[descI - 1];
                if (next instanceof $b5c91c309b2647a1$var$MarkViewDesc) {
                    curDesc = next;
                    descI = next.children.length;
                } else {
                    desc = next;
                    descI--;
                    break;
                }
            } else if (curDesc == parentDesc) break outer;
            else {
                // FIXME
                descI = curDesc.parent.children.indexOf(curDesc);
                curDesc = curDesc.parent;
            }
        }
        let node = desc.node;
        if (!node) continue;
        if (node != frag.child(fI - 1)) break;
        --fI;
        matched.set(desc, fI);
        matches.push(desc);
    }
    return {
        index: fI,
        matched: matched,
        matches: matches.reverse()
    };
}
function $b5c91c309b2647a1$var$compareSide(a, b) {
    return a.type.side - b.type.side;
}
// This function abstracts iterating over the nodes and decorations in
// a fragment. Calls `onNode` for each node, with its local and child
// decorations. Splits text nodes when there is a decoration starting
// or ending inside of them. Calls `onWidget` for each widget.
function $b5c91c309b2647a1$var$iterDeco(parent, deco, onWidget, onNode) {
    let locals = deco.locals(parent), offset = 0;
    // Simple, cheap variant for when there are no local decorations
    if (locals.length == 0) {
        for(let i = 0; i < parent.childCount; i++){
            let child = parent.child(i);
            onNode(child, locals, deco.forChild(offset, child), i);
            offset += child.nodeSize;
        }
        return;
    }
    let decoIndex = 0, active = [], restNode = null;
    for(let parentIndex = 0;;){
        let widget, widgets;
        while(decoIndex < locals.length && locals[decoIndex].to == offset){
            let next = locals[decoIndex++];
            if (next.widget) {
                if (!widget) widget = next;
                else (widgets || (widgets = [
                    widget
                ])).push(next);
            }
        }
        if (widget) {
            if (widgets) {
                widgets.sort($b5c91c309b2647a1$var$compareSide);
                for(let i = 0; i < widgets.length; i++)onWidget(widgets[i], parentIndex, !!restNode);
            } else onWidget(widget, parentIndex, !!restNode);
        }
        let child, index;
        if (restNode) {
            index = -1;
            child = restNode;
            restNode = null;
        } else if (parentIndex < parent.childCount) {
            index = parentIndex;
            child = parent.child(parentIndex++);
        } else break;
        for(let i = 0; i < active.length; i++)if (active[i].to <= offset) active.splice(i--, 1);
        while(decoIndex < locals.length && locals[decoIndex].from <= offset && locals[decoIndex].to > offset)active.push(locals[decoIndex++]);
        let end = offset + child.nodeSize;
        if (child.isText) {
            let cutAt = end;
            if (decoIndex < locals.length && locals[decoIndex].from < cutAt) cutAt = locals[decoIndex].from;
            for(let i = 0; i < active.length; i++)if (active[i].to < cutAt) cutAt = active[i].to;
            if (cutAt < end) {
                restNode = child.cut(cutAt - offset);
                child = child.cut(0, cutAt - offset);
                end = cutAt;
                index = -1;
            }
        } else while(decoIndex < locals.length && locals[decoIndex].to < end)decoIndex++;
        let outerDeco = child.isInline && !child.isLeaf ? active.filter((d)=>!d.inline) : active.slice();
        onNode(child, outerDeco, deco.forChild(offset, child), index);
        offset = end;
    }
}
// List markers in Mobile Safari will mysteriously disappear
// sometimes. This works around that.
function $b5c91c309b2647a1$var$iosHacks(dom) {
    if (dom.nodeName == "UL" || dom.nodeName == "OL") {
        let oldCSS = dom.style.cssText;
        dom.style.cssText = oldCSS + "; list-style: square !important";
        window.getComputedStyle(dom).listStyle;
        dom.style.cssText = oldCSS;
    }
}
// Find a piece of text in an inline fragment, overlapping from-to
function $b5c91c309b2647a1$var$findTextInFragment(frag, text, from, to) {
    for(let i = 0, pos = 0; i < frag.childCount && pos <= to;){
        let child = frag.child(i++), childStart = pos;
        pos += child.nodeSize;
        if (!child.isText) continue;
        let str = child.text;
        while(i < frag.childCount){
            let next = frag.child(i++);
            pos += next.nodeSize;
            if (!next.isText) break;
            str += next.text;
        }
        if (pos >= from) {
            if (pos >= to && str.slice(to - text.length - childStart, to - childStart) == text) return to - text.length;
            let found = childStart < to ? str.lastIndexOf(text, to - childStart - 1) : -1;
            if (found >= 0 && found + text.length + childStart >= from) return childStart + found;
            if (from == to && str.length >= to + text.length - childStart && str.slice(to - childStart, to - childStart + text.length) == text) return to;
        }
    }
    return -1;
}
// Replace range from-to in an array of view descs with replacement
// (may be null to just delete). This goes very much against the grain
// of the rest of this code, which tends to create nodes with the
// right shape in one go, rather than messing with them after
// creation, but is necessary in the composition hack.
function $b5c91c309b2647a1$var$replaceNodes(nodes, from, to, view, replacement) {
    let result = [];
    for(let i = 0, off = 0; i < nodes.length; i++){
        let child = nodes[i], start = off, end = off += child.size;
        if (start >= to || end <= from) result.push(child);
        else {
            if (start < from) result.push(child.slice(0, from - start, view));
            if (replacement) {
                result.push(replacement);
                replacement = undefined;
            }
            if (end > to) result.push(child.slice(to - start, child.size, view));
        }
    }
    return result;
}
function $b5c91c309b2647a1$var$selectionFromDOM(view, origin = null) {
    let domSel = view.domSelectionRange(), doc = view.state.doc;
    if (!domSel.focusNode) return null;
    let nearestDesc = view.docView.nearestDesc(domSel.focusNode), inWidget = nearestDesc && nearestDesc.size == 0;
    let head = view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset, 1);
    if (head < 0) return null;
    let $head = doc.resolve(head), $anchor, selection;
    if ($b5c91c309b2647a1$var$selectionCollapsed(domSel)) {
        $anchor = $head;
        while(nearestDesc && !nearestDesc.node)nearestDesc = nearestDesc.parent;
        let nearestDescNode = nearestDesc.node;
        if (nearestDesc && nearestDescNode.isAtom && (0, $kpTIW.NodeSelection).isSelectable(nearestDescNode) && nearestDesc.parent && !(nearestDescNode.isInline && $b5c91c309b2647a1$var$isOnEdge(domSel.focusNode, domSel.focusOffset, nearestDesc.dom))) {
            let pos = nearestDesc.posBefore;
            selection = new (0, $kpTIW.NodeSelection)(head == pos ? $head : doc.resolve(pos));
        }
    } else {
        let anchor = view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset, 1);
        if (anchor < 0) return null;
        $anchor = doc.resolve(anchor);
    }
    if (!selection) {
        let bias = origin == "pointer" || view.state.selection.head < $head.pos && !inWidget ? 1 : -1;
        selection = $b5c91c309b2647a1$var$selectionBetween(view, $anchor, $head, bias);
    }
    return selection;
}
function $b5c91c309b2647a1$var$editorOwnsSelection(view) {
    return view.editable ? view.hasFocus() : $b5c91c309b2647a1$var$hasSelection(view) && document.activeElement && document.activeElement.contains(view.dom);
}
function $b5c91c309b2647a1$var$selectionToDOM(view, force = false) {
    let sel = view.state.selection;
    $b5c91c309b2647a1$var$syncNodeSelection(view, sel);
    if (!$b5c91c309b2647a1$var$editorOwnsSelection(view)) return;
    // The delayed drag selection causes issues with Cell Selections
    // in Safari. And the drag selection delay is to workarond issues
    // which only present in Chrome.
    if (!force && view.input.mouseDown && view.input.mouseDown.allowDefault && $b5c91c309b2647a1$var$chrome) {
        let domSel = view.domSelectionRange(), curSel = view.domObserver.currentSelection;
        if (domSel.anchorNode && curSel.anchorNode && $b5c91c309b2647a1$var$isEquivalentPosition(domSel.anchorNode, domSel.anchorOffset, curSel.anchorNode, curSel.anchorOffset)) {
            view.input.mouseDown.delayedSelectionSync = true;
            view.domObserver.setCurSelection();
            return;
        }
    }
    view.domObserver.disconnectSelection();
    if (view.cursorWrapper) $b5c91c309b2647a1$var$selectCursorWrapper(view);
    else {
        let { anchor: anchor, head: head } = sel, resetEditableFrom, resetEditableTo;
        if ($b5c91c309b2647a1$var$brokenSelectBetweenUneditable && !(sel instanceof (0, $kpTIW.TextSelection))) {
            if (!sel.$from.parent.inlineContent) resetEditableFrom = $b5c91c309b2647a1$var$temporarilyEditableNear(view, sel.from);
            if (!sel.empty && !sel.$from.parent.inlineContent) resetEditableTo = $b5c91c309b2647a1$var$temporarilyEditableNear(view, sel.to);
        }
        view.docView.setSelection(anchor, head, view.root, force);
        if ($b5c91c309b2647a1$var$brokenSelectBetweenUneditable) {
            if (resetEditableFrom) $b5c91c309b2647a1$var$resetEditable(resetEditableFrom);
            if (resetEditableTo) $b5c91c309b2647a1$var$resetEditable(resetEditableTo);
        }
        if (sel.visible) view.dom.classList.remove("ProseMirror-hideselection");
        else {
            view.dom.classList.add("ProseMirror-hideselection");
            if ("onselectionchange" in document) $b5c91c309b2647a1$var$removeClassOnSelectionChange(view);
        }
    }
    view.domObserver.setCurSelection();
    view.domObserver.connectSelection();
}
// Kludge to work around Webkit not allowing a selection to start/end
// between non-editable block nodes. We briefly make something
// editable, set the selection, then set it uneditable again.
const $b5c91c309b2647a1$var$brokenSelectBetweenUneditable = $b5c91c309b2647a1$var$safari || $b5c91c309b2647a1$var$chrome && $b5c91c309b2647a1$var$chrome_version < 63;
function $b5c91c309b2647a1$var$temporarilyEditableNear(view, pos) {
    let { node: node, offset: offset } = view.docView.domFromPos(pos, 0);
    let after = offset < node.childNodes.length ? node.childNodes[offset] : null;
    let before = offset ? node.childNodes[offset - 1] : null;
    if ($b5c91c309b2647a1$var$safari && after && after.contentEditable == "false") return $b5c91c309b2647a1$var$setEditable(after);
    if ((!after || after.contentEditable == "false") && (!before || before.contentEditable == "false")) {
        if (after) return $b5c91c309b2647a1$var$setEditable(after);
        else if (before) return $b5c91c309b2647a1$var$setEditable(before);
    }
}
function $b5c91c309b2647a1$var$setEditable(element) {
    element.contentEditable = "true";
    if ($b5c91c309b2647a1$var$safari && element.draggable) {
        element.draggable = false;
        element.wasDraggable = true;
    }
    return element;
}
function $b5c91c309b2647a1$var$resetEditable(element) {
    element.contentEditable = "false";
    if (element.wasDraggable) {
        element.draggable = true;
        element.wasDraggable = null;
    }
}
function $b5c91c309b2647a1$var$removeClassOnSelectionChange(view) {
    let doc = view.dom.ownerDocument;
    doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
    let domSel = view.domSelectionRange();
    let node = domSel.anchorNode, offset = domSel.anchorOffset;
    doc.addEventListener("selectionchange", view.input.hideSelectionGuard = ()=>{
        if (domSel.anchorNode != node || domSel.anchorOffset != offset) {
            doc.removeEventListener("selectionchange", view.input.hideSelectionGuard);
            setTimeout(()=>{
                if (!$b5c91c309b2647a1$var$editorOwnsSelection(view) || view.state.selection.visible) view.dom.classList.remove("ProseMirror-hideselection");
            }, 20);
        }
    });
}
function $b5c91c309b2647a1$var$selectCursorWrapper(view) {
    let domSel = view.domSelection(), range = document.createRange();
    let node = view.cursorWrapper.dom, img = node.nodeName == "IMG";
    if (img) range.setEnd(node.parentNode, $b5c91c309b2647a1$var$domIndex(node) + 1);
    else range.setEnd(node, 0);
    range.collapse(false);
    domSel.removeAllRanges();
    domSel.addRange(range);
    // Kludge to kill 'control selection' in IE11 when selecting an
    // invisible cursor wrapper, since that would result in those weird
    // resize handles and a selection that considers the absolutely
    // positioned wrapper, rather than the root editable node, the
    // focused element.
    if (!img && !view.state.selection.visible && $b5c91c309b2647a1$var$ie && $b5c91c309b2647a1$var$ie_version <= 11) {
        node.disabled = true;
        node.disabled = false;
    }
}
function $b5c91c309b2647a1$var$syncNodeSelection(view, sel) {
    if (sel instanceof (0, $kpTIW.NodeSelection)) {
        let desc = view.docView.descAt(sel.from);
        if (desc != view.lastSelectedViewDesc) {
            $b5c91c309b2647a1$var$clearNodeSelection(view);
            if (desc) desc.selectNode();
            view.lastSelectedViewDesc = desc;
        }
    } else $b5c91c309b2647a1$var$clearNodeSelection(view);
}
// Clear all DOM statefulness of the last node selection.
function $b5c91c309b2647a1$var$clearNodeSelection(view) {
    if (view.lastSelectedViewDesc) {
        if (view.lastSelectedViewDesc.parent) view.lastSelectedViewDesc.deselectNode();
        view.lastSelectedViewDesc = undefined;
    }
}
function $b5c91c309b2647a1$var$selectionBetween(view, $anchor, $head, bias) {
    return view.someProp("createSelectionBetween", (f)=>f(view, $anchor, $head)) || (0, $kpTIW.TextSelection).between($anchor, $head, bias);
}
function $b5c91c309b2647a1$var$hasFocusAndSelection(view) {
    if (view.editable && !view.hasFocus()) return false;
    return $b5c91c309b2647a1$var$hasSelection(view);
}
function $b5c91c309b2647a1$var$hasSelection(view) {
    let sel = view.domSelectionRange();
    if (!sel.anchorNode) return false;
    try {
        // Firefox will raise 'permission denied' errors when accessing
        // properties of `sel.anchorNode` when it's in a generated CSS
        // element.
        return view.dom.contains(sel.anchorNode.nodeType == 3 ? sel.anchorNode.parentNode : sel.anchorNode) && (view.editable || view.dom.contains(sel.focusNode.nodeType == 3 ? sel.focusNode.parentNode : sel.focusNode));
    } catch (_) {
        return false;
    }
}
function $b5c91c309b2647a1$var$anchorInRightPlace(view) {
    let anchorDOM = view.docView.domFromPos(view.state.selection.anchor, 0);
    let domSel = view.domSelectionRange();
    return $b5c91c309b2647a1$var$isEquivalentPosition(anchorDOM.node, anchorDOM.offset, domSel.anchorNode, domSel.anchorOffset);
}
function $b5c91c309b2647a1$var$moveSelectionBlock(state, dir) {
    let { $anchor: $anchor, $head: $head } = state.selection;
    let $side = dir > 0 ? $anchor.max($head) : $anchor.min($head);
    let $start = !$side.parent.inlineContent ? $side : $side.depth ? state.doc.resolve(dir > 0 ? $side.after() : $side.before()) : null;
    return $start && (0, $kpTIW.Selection).findFrom($start, dir);
}
function $b5c91c309b2647a1$var$apply(view, sel) {
    view.dispatch(view.state.tr.setSelection(sel).scrollIntoView());
    return true;
}
function $b5c91c309b2647a1$var$selectHorizontally(view, dir, mods) {
    let sel = view.state.selection;
    if (sel instanceof (0, $kpTIW.TextSelection)) {
        if (mods.indexOf("s") > -1) {
            let { $head: $head } = sel, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter;
            if (!node || node.isText || !node.isLeaf) return false;
            let $newHead = view.state.doc.resolve($head.pos + node.nodeSize * (dir < 0 ? -1 : 1));
            return $b5c91c309b2647a1$var$apply(view, new (0, $kpTIW.TextSelection)(sel.$anchor, $newHead));
        } else if (!sel.empty) return false;
        else if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) {
            let next = $b5c91c309b2647a1$var$moveSelectionBlock(view.state, dir);
            if (next && next instanceof (0, $kpTIW.NodeSelection)) return $b5c91c309b2647a1$var$apply(view, next);
            return false;
        } else if (!($b5c91c309b2647a1$var$mac && mods.indexOf("m") > -1)) {
            let $head = sel.$head, node = $head.textOffset ? null : dir < 0 ? $head.nodeBefore : $head.nodeAfter, desc;
            if (!node || node.isText) return false;
            let nodePos = dir < 0 ? $head.pos - node.nodeSize : $head.pos;
            if (!(node.isAtom || (desc = view.docView.descAt(nodePos)) && !desc.contentDOM)) return false;
            if ((0, $kpTIW.NodeSelection).isSelectable(node)) return $b5c91c309b2647a1$var$apply(view, new (0, $kpTIW.NodeSelection)(dir < 0 ? view.state.doc.resolve($head.pos - node.nodeSize) : $head));
            else if ($b5c91c309b2647a1$var$webkit) // Chrome and Safari will introduce extra pointless cursor
            // positions around inline uneditable nodes, so we have to
            // take over and move the cursor past them (#937)
            return $b5c91c309b2647a1$var$apply(view, new (0, $kpTIW.TextSelection)(view.state.doc.resolve(dir < 0 ? nodePos : nodePos + node.nodeSize)));
            else return false;
        }
    } else if (sel instanceof (0, $kpTIW.NodeSelection) && sel.node.isInline) return $b5c91c309b2647a1$var$apply(view, new (0, $kpTIW.TextSelection)(dir > 0 ? sel.$to : sel.$from));
    else {
        let next = $b5c91c309b2647a1$var$moveSelectionBlock(view.state, dir);
        if (next) return $b5c91c309b2647a1$var$apply(view, next);
        return false;
    }
}
function $b5c91c309b2647a1$var$nodeLen(node) {
    return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function $b5c91c309b2647a1$var$isIgnorable(dom, dir) {
    let desc = dom.pmViewDesc;
    return desc && desc.size == 0 && (dir < 0 || dom.nextSibling || dom.nodeName != "BR");
}
function $b5c91c309b2647a1$var$skipIgnoredNodes(view, dir) {
    return dir < 0 ? $b5c91c309b2647a1$var$skipIgnoredNodesBefore(view) : $b5c91c309b2647a1$var$skipIgnoredNodesAfter(view);
}
// Make sure the cursor isn't directly after one or more ignored
// nodes, which will confuse the browser's cursor motion logic.
function $b5c91c309b2647a1$var$skipIgnoredNodesBefore(view) {
    let sel = view.domSelectionRange();
    let node = sel.focusNode, offset = sel.focusOffset;
    if (!node) return;
    let moveNode, moveOffset, force = false;
    // Gecko will do odd things when the selection is directly in front
    // of a non-editable node, so in that case, move it into the next
    // node if possible. Issue prosemirror/prosemirror#832.
    if ($b5c91c309b2647a1$var$gecko && node.nodeType == 1 && offset < $b5c91c309b2647a1$var$nodeLen(node) && $b5c91c309b2647a1$var$isIgnorable(node.childNodes[offset], -1)) force = true;
    for(;;){
        if (offset > 0) {
            if (node.nodeType != 1) break;
            else {
                let before = node.childNodes[offset - 1];
                if ($b5c91c309b2647a1$var$isIgnorable(before, -1)) {
                    moveNode = node;
                    moveOffset = --offset;
                } else if (before.nodeType == 3) {
                    node = before;
                    offset = node.nodeValue.length;
                } else break;
            }
        } else if ($b5c91c309b2647a1$var$isBlockNode(node)) break;
        else {
            let prev = node.previousSibling;
            while(prev && $b5c91c309b2647a1$var$isIgnorable(prev, -1)){
                moveNode = node.parentNode;
                moveOffset = $b5c91c309b2647a1$var$domIndex(prev);
                prev = prev.previousSibling;
            }
            if (!prev) {
                node = node.parentNode;
                if (node == view.dom) break;
                offset = 0;
            } else {
                node = prev;
                offset = $b5c91c309b2647a1$var$nodeLen(node);
            }
        }
    }
    if (force) $b5c91c309b2647a1$var$setSelFocus(view, node, offset);
    else if (moveNode) $b5c91c309b2647a1$var$setSelFocus(view, moveNode, moveOffset);
}
// Make sure the cursor isn't directly before one or more ignored
// nodes.
function $b5c91c309b2647a1$var$skipIgnoredNodesAfter(view) {
    let sel = view.domSelectionRange();
    let node = sel.focusNode, offset = sel.focusOffset;
    if (!node) return;
    let len = $b5c91c309b2647a1$var$nodeLen(node);
    let moveNode, moveOffset;
    for(;;){
        if (offset < len) {
            if (node.nodeType != 1) break;
            let after = node.childNodes[offset];
            if ($b5c91c309b2647a1$var$isIgnorable(after, 1)) {
                moveNode = node;
                moveOffset = ++offset;
            } else break;
        } else if ($b5c91c309b2647a1$var$isBlockNode(node)) break;
        else {
            let next = node.nextSibling;
            while(next && $b5c91c309b2647a1$var$isIgnorable(next, 1)){
                moveNode = next.parentNode;
                moveOffset = $b5c91c309b2647a1$var$domIndex(next) + 1;
                next = next.nextSibling;
            }
            if (!next) {
                node = node.parentNode;
                if (node == view.dom) break;
                offset = len = 0;
            } else {
                node = next;
                offset = 0;
                len = $b5c91c309b2647a1$var$nodeLen(node);
            }
        }
    }
    if (moveNode) $b5c91c309b2647a1$var$setSelFocus(view, moveNode, moveOffset);
}
function $b5c91c309b2647a1$var$isBlockNode(dom) {
    let desc = dom.pmViewDesc;
    return desc && desc.node && desc.node.isBlock;
}
function $b5c91c309b2647a1$var$textNodeAfter(node, offset) {
    while(node && offset == node.childNodes.length && !$b5c91c309b2647a1$var$hasBlockDesc(node)){
        offset = $b5c91c309b2647a1$var$domIndex(node) + 1;
        node = node.parentNode;
    }
    while(node && offset < node.childNodes.length){
        let next = node.childNodes[offset];
        if (next.nodeType == 3) return next;
        if (next.nodeType == 1 && next.contentEditable == "false") break;
        node = next;
        offset = 0;
    }
}
function $b5c91c309b2647a1$var$textNodeBefore(node, offset) {
    while(node && !offset && !$b5c91c309b2647a1$var$hasBlockDesc(node)){
        offset = $b5c91c309b2647a1$var$domIndex(node);
        node = node.parentNode;
    }
    while(node && offset){
        let next = node.childNodes[offset - 1];
        if (next.nodeType == 3) return next;
        if (next.nodeType == 1 && next.contentEditable == "false") break;
        node = next;
        offset = node.childNodes.length;
    }
}
function $b5c91c309b2647a1$var$setSelFocus(view, node, offset) {
    if (node.nodeType != 3) {
        let before, after;
        if (after = $b5c91c309b2647a1$var$textNodeAfter(node, offset)) {
            node = after;
            offset = 0;
        } else if (before = $b5c91c309b2647a1$var$textNodeBefore(node, offset)) {
            node = before;
            offset = before.nodeValue.length;
        }
    }
    let sel = view.domSelection();
    if ($b5c91c309b2647a1$var$selectionCollapsed(sel)) {
        let range = document.createRange();
        range.setEnd(node, offset);
        range.setStart(node, offset);
        sel.removeAllRanges();
        sel.addRange(range);
    } else if (sel.extend) sel.extend(node, offset);
    view.domObserver.setCurSelection();
    let { state: state } = view;
    // If no state update ends up happening, reset the selection.
    setTimeout(()=>{
        if (view.state == state) $b5c91c309b2647a1$var$selectionToDOM(view);
    }, 50);
}
function $b5c91c309b2647a1$var$findDirection(view, pos) {
    let $pos = view.state.doc.resolve(pos);
    if (!($b5c91c309b2647a1$var$chrome || $b5c91c309b2647a1$var$windows) && $pos.parent.inlineContent) {
        let coords = view.coordsAtPos(pos);
        if (pos > $pos.start()) {
            let before = view.coordsAtPos(pos - 1);
            let mid = (before.top + before.bottom) / 2;
            if (mid > coords.top && mid < coords.bottom && Math.abs(before.left - coords.left) > 1) return before.left < coords.left ? "ltr" : "rtl";
        }
        if (pos < $pos.end()) {
            let after = view.coordsAtPos(pos + 1);
            let mid = (after.top + after.bottom) / 2;
            if (mid > coords.top && mid < coords.bottom && Math.abs(after.left - coords.left) > 1) return after.left > coords.left ? "ltr" : "rtl";
        }
    }
    let computed = getComputedStyle(view.dom).direction;
    return computed == "rtl" ? "rtl" : "ltr";
}
// Check whether vertical selection motion would involve node
// selections. If so, apply it (if not, the result is left to the
// browser)
function $b5c91c309b2647a1$var$selectVertically(view, dir, mods) {
    let sel = view.state.selection;
    if (sel instanceof (0, $kpTIW.TextSelection) && !sel.empty || mods.indexOf("s") > -1) return false;
    if ($b5c91c309b2647a1$var$mac && mods.indexOf("m") > -1) return false;
    let { $from: $from, $to: $to } = sel;
    if (!$from.parent.inlineContent || view.endOfTextblock(dir < 0 ? "up" : "down")) {
        let next = $b5c91c309b2647a1$var$moveSelectionBlock(view.state, dir);
        if (next && next instanceof (0, $kpTIW.NodeSelection)) return $b5c91c309b2647a1$var$apply(view, next);
    }
    if (!$from.parent.inlineContent) {
        let side = dir < 0 ? $from : $to;
        let beyond = sel instanceof (0, $kpTIW.AllSelection) ? (0, $kpTIW.Selection).near(side, dir) : (0, $kpTIW.Selection).findFrom(side, dir);
        return beyond ? $b5c91c309b2647a1$var$apply(view, beyond) : false;
    }
    return false;
}
function $b5c91c309b2647a1$var$stopNativeHorizontalDelete(view, dir) {
    if (!(view.state.selection instanceof (0, $kpTIW.TextSelection))) return true;
    let { $head: $head, $anchor: $anchor, empty: empty } = view.state.selection;
    if (!$head.sameParent($anchor)) return true;
    if (!empty) return false;
    if (view.endOfTextblock(dir > 0 ? "forward" : "backward")) return true;
    let nextNode = !$head.textOffset && (dir < 0 ? $head.nodeBefore : $head.nodeAfter);
    if (nextNode && !nextNode.isText) {
        let tr = view.state.tr;
        if (dir < 0) tr.delete($head.pos - nextNode.nodeSize, $head.pos);
        else tr.delete($head.pos, $head.pos + nextNode.nodeSize);
        view.dispatch(tr);
        return true;
    }
    return false;
}
function $b5c91c309b2647a1$var$switchEditable(view, node, state) {
    view.domObserver.stop();
    node.contentEditable = state;
    view.domObserver.start();
}
// Issue #867 / #1090 / https://bugs.chromium.org/p/chromium/issues/detail?id=903821
// In which Safari (and at some point in the past, Chrome) does really
// wrong things when the down arrow is pressed when the cursor is
// directly at the start of a textblock and has an uneditable node
// after it
function $b5c91c309b2647a1$var$safariDownArrowBug(view) {
    if (!$b5c91c309b2647a1$var$safari || view.state.selection.$head.parentOffset > 0) return false;
    let { focusNode: focusNode, focusOffset: focusOffset } = view.domSelectionRange();
    if (focusNode && focusNode.nodeType == 1 && focusOffset == 0 && focusNode.firstChild && focusNode.firstChild.contentEditable == "false") {
        let child = focusNode.firstChild;
        $b5c91c309b2647a1$var$switchEditable(view, child, "true");
        setTimeout(()=>$b5c91c309b2647a1$var$switchEditable(view, child, "false"), 20);
    }
    return false;
}
// A backdrop key mapping used to make sure we always suppress keys
// that have a dangerous default effect, even if the commands they are
// bound to return false, and to make sure that cursor-motion keys
// find a cursor (as opposed to a node selection) when pressed. For
// cursor-motion keys, the code in the handlers also takes care of
// block selections.
function $b5c91c309b2647a1$var$getMods(event) {
    let result = "";
    if (event.ctrlKey) result += "c";
    if (event.metaKey) result += "m";
    if (event.altKey) result += "a";
    if (event.shiftKey) result += "s";
    return result;
}
function $b5c91c309b2647a1$var$captureKeyDown(view, event) {
    let code = event.keyCode, mods = $b5c91c309b2647a1$var$getMods(event);
    if (code == 8 || $b5c91c309b2647a1$var$mac && code == 72 && mods == "c") return $b5c91c309b2647a1$var$stopNativeHorizontalDelete(view, -1) || $b5c91c309b2647a1$var$skipIgnoredNodes(view, -1);
    else if (code == 46 && !event.shiftKey || $b5c91c309b2647a1$var$mac && code == 68 && mods == "c") return $b5c91c309b2647a1$var$stopNativeHorizontalDelete(view, 1) || $b5c91c309b2647a1$var$skipIgnoredNodes(view, 1);
    else if (code == 13 || code == 27) return true;
    else if (code == 37 || $b5c91c309b2647a1$var$mac && code == 66 && mods == "c") {
        let dir = code == 37 ? $b5c91c309b2647a1$var$findDirection(view, view.state.selection.from) == "ltr" ? -1 : 1 : -1;
        return $b5c91c309b2647a1$var$selectHorizontally(view, dir, mods) || $b5c91c309b2647a1$var$skipIgnoredNodes(view, dir);
    } else if (code == 39 || $b5c91c309b2647a1$var$mac && code == 70 && mods == "c") {
        let dir = code == 39 ? $b5c91c309b2647a1$var$findDirection(view, view.state.selection.from) == "ltr" ? 1 : -1 : 1;
        return $b5c91c309b2647a1$var$selectHorizontally(view, dir, mods) || $b5c91c309b2647a1$var$skipIgnoredNodes(view, dir);
    } else if (code == 38 || $b5c91c309b2647a1$var$mac && code == 80 && mods == "c") return $b5c91c309b2647a1$var$selectVertically(view, -1, mods) || $b5c91c309b2647a1$var$skipIgnoredNodes(view, -1);
    else if (code == 40 || $b5c91c309b2647a1$var$mac && code == 78 && mods == "c") return $b5c91c309b2647a1$var$safariDownArrowBug(view) || $b5c91c309b2647a1$var$selectVertically(view, 1, mods) || $b5c91c309b2647a1$var$skipIgnoredNodes(view, 1);
    else if (mods == ($b5c91c309b2647a1$var$mac ? "m" : "c") && (code == 66 || code == 73 || code == 89 || code == 90)) return true;
    return false;
}
function $b5c91c309b2647a1$var$serializeForClipboard(view, slice) {
    view.someProp("transformCopied", (f)=>{
        slice = f(slice, view);
    });
    let context = [], { content: content, openStart: openStart, openEnd: openEnd } = slice;
    while(openStart > 1 && openEnd > 1 && content.childCount == 1 && content.firstChild.childCount == 1){
        openStart--;
        openEnd--;
        let node = content.firstChild;
        context.push(node.type.name, node.attrs != node.type.defaultAttrs ? node.attrs : null);
        content = node.content;
    }
    let serializer = view.someProp("clipboardSerializer") || (0, $7dkLM.DOMSerializer).fromSchema(view.state.schema);
    let doc = $b5c91c309b2647a1$var$detachedDoc(), wrap = doc.createElement("div");
    wrap.appendChild(serializer.serializeFragment(content, {
        document: doc
    }));
    let firstChild = wrap.firstChild, needsWrap, wrappers = 0;
    while(firstChild && firstChild.nodeType == 1 && (needsWrap = $b5c91c309b2647a1$var$wrapMap[firstChild.nodeName.toLowerCase()])){
        for(let i = needsWrap.length - 1; i >= 0; i--){
            let wrapper = doc.createElement(needsWrap[i]);
            while(wrap.firstChild)wrapper.appendChild(wrap.firstChild);
            wrap.appendChild(wrapper);
            wrappers++;
        }
        firstChild = wrap.firstChild;
    }
    if (firstChild && firstChild.nodeType == 1) firstChild.setAttribute("data-pm-slice", `${openStart} ${openEnd}${wrappers ? ` -${wrappers}` : ""} ${JSON.stringify(context)}`);
    let text = view.someProp("clipboardTextSerializer", (f)=>f(slice, view)) || slice.content.textBetween(0, slice.content.size, "\n\n");
    return {
        dom: wrap,
        text: text
    };
}
// Read a slice of content from the clipboard (or drop data).
function $b5c91c309b2647a1$var$parseFromClipboard(view, text, html, plainText, $context) {
    let inCode = $context.parent.type.spec.code;
    let dom, slice;
    if (!html && !text) return null;
    let asText = text && (plainText || inCode || !html);
    if (asText) {
        view.someProp("transformPastedText", (f)=>{
            text = f(text, inCode || plainText, view);
        });
        if (inCode) return text ? new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(view.state.schema.text(text.replace(/\r\n?/g, "\n"))), 0, 0) : (0, $7dkLM.Slice).empty;
        let parsed = view.someProp("clipboardTextParser", (f)=>f(text, $context, plainText, view));
        if (parsed) slice = parsed;
        else {
            let marks = $context.marks();
            let { schema: schema } = view.state, serializer = (0, $7dkLM.DOMSerializer).fromSchema(schema);
            dom = document.createElement("div");
            text.split(/(?:\r\n?|\n)+/).forEach((block)=>{
                let p = dom.appendChild(document.createElement("p"));
                if (block) p.appendChild(serializer.serializeNode(schema.text(block, marks)));
            });
        }
    } else {
        view.someProp("transformPastedHTML", (f)=>{
            html = f(html, view);
        });
        dom = $b5c91c309b2647a1$var$readHTML(html);
        if ($b5c91c309b2647a1$var$webkit) $b5c91c309b2647a1$var$restoreReplacedSpaces(dom);
    }
    let contextNode = dom && dom.querySelector("[data-pm-slice]");
    let sliceData = contextNode && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(contextNode.getAttribute("data-pm-slice") || "");
    if (sliceData && sliceData[3]) for(let i = +sliceData[3]; i > 0; i--){
        let child = dom.firstChild;
        while(child && child.nodeType != 1)child = child.nextSibling;
        if (!child) break;
        dom = child;
    }
    if (!slice) {
        let parser = view.someProp("clipboardParser") || view.someProp("domParser") || (0, $7dkLM.DOMParser).fromSchema(view.state.schema);
        slice = parser.parseSlice(dom, {
            preserveWhitespace: !!(asText || sliceData),
            context: $context,
            ruleFromNode (dom) {
                if (dom.nodeName == "BR" && !dom.nextSibling && dom.parentNode && !$b5c91c309b2647a1$var$inlineParents.test(dom.parentNode.nodeName)) return {
                    ignore: true
                };
                return null;
            }
        });
    }
    if (sliceData) slice = $b5c91c309b2647a1$var$addContext($b5c91c309b2647a1$var$closeSlice(slice, +sliceData[1], +sliceData[2]), sliceData[4]);
    else {
        slice = (0, $7dkLM.Slice).maxOpen($b5c91c309b2647a1$var$normalizeSiblings(slice.content, $context), true);
        if (slice.openStart || slice.openEnd) {
            let openStart = 0, openEnd = 0;
            for(let node = slice.content.firstChild; openStart < slice.openStart && !node.type.spec.isolating; openStart++, node = node.firstChild);
            for(let node = slice.content.lastChild; openEnd < slice.openEnd && !node.type.spec.isolating; openEnd++, node = node.lastChild);
            slice = $b5c91c309b2647a1$var$closeSlice(slice, openStart, openEnd);
        }
    }
    view.someProp("transformPasted", (f)=>{
        slice = f(slice, view);
    });
    return slice;
}
const $b5c91c309b2647a1$var$inlineParents = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
// Takes a slice parsed with parseSlice, which means there hasn't been
// any content-expression checking done on the top nodes, tries to
// find a parent node in the current context that might fit the nodes,
// and if successful, rebuilds the slice so that it fits into that parent.
//
// This addresses the problem that Transform.replace expects a
// coherent slice, and will fail to place a set of siblings that don't
// fit anywhere in the schema.
function $b5c91c309b2647a1$var$normalizeSiblings(fragment, $context) {
    if (fragment.childCount < 2) return fragment;
    for(let d = $context.depth; d >= 0; d--){
        let parent = $context.node(d);
        let match = parent.contentMatchAt($context.index(d));
        let lastWrap, result = [];
        fragment.forEach((node)=>{
            if (!result) return;
            let wrap = match.findWrapping(node.type), inLast;
            if (!wrap) return result = null;
            if (inLast = result.length && lastWrap.length && $b5c91c309b2647a1$var$addToSibling(wrap, lastWrap, node, result[result.length - 1], 0)) result[result.length - 1] = inLast;
            else {
                if (result.length) result[result.length - 1] = $b5c91c309b2647a1$var$closeRight(result[result.length - 1], lastWrap.length);
                let wrapped = $b5c91c309b2647a1$var$withWrappers(node, wrap);
                result.push(wrapped);
                match = match.matchType(wrapped.type);
                lastWrap = wrap;
            }
        });
        if (result) return (0, $7dkLM.Fragment).from(result);
    }
    return fragment;
}
function $b5c91c309b2647a1$var$withWrappers(node, wrap, from = 0) {
    for(let i = wrap.length - 1; i >= from; i--)node = wrap[i].create(null, (0, $7dkLM.Fragment).from(node));
    return node;
}
// Used to group adjacent nodes wrapped in similar parents by
// normalizeSiblings into the same parent node
function $b5c91c309b2647a1$var$addToSibling(wrap, lastWrap, node, sibling, depth) {
    if (depth < wrap.length && depth < lastWrap.length && wrap[depth] == lastWrap[depth]) {
        let inner = $b5c91c309b2647a1$var$addToSibling(wrap, lastWrap, node, sibling.lastChild, depth + 1);
        if (inner) return sibling.copy(sibling.content.replaceChild(sibling.childCount - 1, inner));
        let match = sibling.contentMatchAt(sibling.childCount);
        if (match.matchType(depth == wrap.length - 1 ? node.type : wrap[depth + 1])) return sibling.copy(sibling.content.append((0, $7dkLM.Fragment).from($b5c91c309b2647a1$var$withWrappers(node, wrap, depth + 1))));
    }
}
function $b5c91c309b2647a1$var$closeRight(node, depth) {
    if (depth == 0) return node;
    let fragment = node.content.replaceChild(node.childCount - 1, $b5c91c309b2647a1$var$closeRight(node.lastChild, depth - 1));
    let fill = node.contentMatchAt(node.childCount).fillBefore((0, $7dkLM.Fragment).empty, true);
    return node.copy(fragment.append(fill));
}
function $b5c91c309b2647a1$var$closeRange(fragment, side, from, to, depth, openEnd) {
    let node = side < 0 ? fragment.firstChild : fragment.lastChild, inner = node.content;
    if (fragment.childCount > 1) openEnd = 0;
    if (depth < to - 1) inner = $b5c91c309b2647a1$var$closeRange(inner, side, from, to, depth + 1, openEnd);
    if (depth >= from) inner = side < 0 ? node.contentMatchAt(0).fillBefore(inner, openEnd <= depth).append(inner) : inner.append(node.contentMatchAt(node.childCount).fillBefore((0, $7dkLM.Fragment).empty, true));
    return fragment.replaceChild(side < 0 ? 0 : fragment.childCount - 1, node.copy(inner));
}
function $b5c91c309b2647a1$var$closeSlice(slice, openStart, openEnd) {
    if (openStart < slice.openStart) slice = new (0, $7dkLM.Slice)($b5c91c309b2647a1$var$closeRange(slice.content, -1, openStart, slice.openStart, 0, slice.openEnd), openStart, slice.openEnd);
    if (openEnd < slice.openEnd) slice = new (0, $7dkLM.Slice)($b5c91c309b2647a1$var$closeRange(slice.content, 1, openEnd, slice.openEnd, 0, 0), slice.openStart, openEnd);
    return slice;
}
// Trick from jQuery -- some elements must be wrapped in other
// elements for innerHTML to work. I.e. if you do `div.innerHTML =
// "<td>..</td>"` the table cells are ignored.
const $b5c91c309b2647a1$var$wrapMap = {
    thead: [
        "table"
    ],
    tbody: [
        "table"
    ],
    tfoot: [
        "table"
    ],
    caption: [
        "table"
    ],
    colgroup: [
        "table"
    ],
    col: [
        "table",
        "colgroup"
    ],
    tr: [
        "table",
        "tbody"
    ],
    td: [
        "table",
        "tbody",
        "tr"
    ],
    th: [
        "table",
        "tbody",
        "tr"
    ]
};
let $b5c91c309b2647a1$var$_detachedDoc = null;
function $b5c91c309b2647a1$var$detachedDoc() {
    return $b5c91c309b2647a1$var$_detachedDoc || ($b5c91c309b2647a1$var$_detachedDoc = document.implementation.createHTMLDocument("title"));
}
function $b5c91c309b2647a1$var$readHTML(html) {
    let metas = /^(\s*<meta [^>]*>)*/.exec(html);
    if (metas) html = html.slice(metas[0].length);
    let elt = $b5c91c309b2647a1$var$detachedDoc().createElement("div");
    let firstTag = /<([a-z][^>\s]+)/i.exec(html), wrap;
    if (wrap = firstTag && $b5c91c309b2647a1$var$wrapMap[firstTag[1].toLowerCase()]) html = wrap.map((n)=>"<" + n + ">").join("") + html + wrap.map((n)=>"</" + n + ">").reverse().join("");
    elt.innerHTML = html;
    if (wrap) for(let i = 0; i < wrap.length; i++)elt = elt.querySelector(wrap[i]) || elt;
    return elt;
}
// Webkit browsers do some hard-to-predict replacement of regular
// spaces with non-breaking spaces when putting content on the
// clipboard. This tries to convert such non-breaking spaces (which
// will be wrapped in a plain span on Chrome, a span with class
// Apple-converted-space on Safari) back to regular spaces.
function $b5c91c309b2647a1$var$restoreReplacedSpaces(dom) {
    let nodes = dom.querySelectorAll($b5c91c309b2647a1$var$chrome ? "span:not([class]):not([style])" : "span.Apple-converted-space");
    for(let i = 0; i < nodes.length; i++){
        let node = nodes[i];
        if (node.childNodes.length == 1 && node.textContent == "\u00a0" && node.parentNode) node.parentNode.replaceChild(dom.ownerDocument.createTextNode(" "), node);
    }
}
function $b5c91c309b2647a1$var$addContext(slice, context) {
    if (!slice.size) return slice;
    let schema = slice.content.firstChild.type.schema, array;
    try {
        array = JSON.parse(context);
    } catch (e) {
        return slice;
    }
    let { content: content, openStart: openStart, openEnd: openEnd } = slice;
    for(let i = array.length - 2; i >= 0; i -= 2){
        let type = schema.nodes[array[i]];
        if (!type || type.hasRequiredAttrs()) break;
        content = (0, $7dkLM.Fragment).from(type.create(array[i + 1], content));
        openStart++;
        openEnd++;
    }
    return new (0, $7dkLM.Slice)(content, openStart, openEnd);
}
// A collection of DOM events that occur within the editor, and callback functions
// to invoke when the event fires.
const $b5c91c309b2647a1$var$handlers = {};
const $b5c91c309b2647a1$var$editHandlers = {};
const $b5c91c309b2647a1$var$passiveHandlers = {
    touchstart: true,
    touchmove: true
};
class $b5c91c309b2647a1$var$InputState {
    constructor(){
        this.shiftKey = false;
        this.mouseDown = null;
        this.lastKeyCode = null;
        this.lastKeyCodeTime = 0;
        this.lastClick = {
            time: 0,
            x: 0,
            y: 0,
            type: ""
        };
        this.lastSelectionOrigin = null;
        this.lastSelectionTime = 0;
        this.lastIOSEnter = 0;
        this.lastIOSEnterFallbackTimeout = -1;
        this.lastFocus = 0;
        this.lastTouch = 0;
        this.lastAndroidDelete = 0;
        this.composing = false;
        this.compositionNode = null;
        this.composingTimeout = -1;
        this.compositionNodes = [];
        this.compositionEndedAt = -200000000;
        this.compositionID = 1;
        // Set to a composition ID when there are pending changes at compositionend
        this.compositionPendingChanges = 0;
        this.domChangeCount = 0;
        this.eventHandlers = Object.create(null);
        this.hideSelectionGuard = null;
    }
}
function $b5c91c309b2647a1$var$initInput(view) {
    for(let event in $b5c91c309b2647a1$var$handlers){
        let handler = $b5c91c309b2647a1$var$handlers[event];
        view.dom.addEventListener(event, view.input.eventHandlers[event] = (event)=>{
            if ($b5c91c309b2647a1$var$eventBelongsToView(view, event) && !$b5c91c309b2647a1$var$runCustomHandler(view, event) && (view.editable || !(event.type in $b5c91c309b2647a1$var$editHandlers))) handler(view, event);
        }, $b5c91c309b2647a1$var$passiveHandlers[event] ? {
            passive: true
        } : undefined);
    }
    // On Safari, for reasons beyond my understanding, adding an input
    // event handler makes an issue where the composition vanishes when
    // you press enter go away.
    if ($b5c91c309b2647a1$var$safari) view.dom.addEventListener("input", ()=>null);
    $b5c91c309b2647a1$var$ensureListeners(view);
}
function $b5c91c309b2647a1$var$setSelectionOrigin(view, origin) {
    view.input.lastSelectionOrigin = origin;
    view.input.lastSelectionTime = Date.now();
}
function $b5c91c309b2647a1$var$destroyInput(view) {
    view.domObserver.stop();
    for(let type in view.input.eventHandlers)view.dom.removeEventListener(type, view.input.eventHandlers[type]);
    clearTimeout(view.input.composingTimeout);
    clearTimeout(view.input.lastIOSEnterFallbackTimeout);
}
function $b5c91c309b2647a1$var$ensureListeners(view) {
    view.someProp("handleDOMEvents", (currentHandlers)=>{
        for(let type in currentHandlers)if (!view.input.eventHandlers[type]) view.dom.addEventListener(type, view.input.eventHandlers[type] = (event)=>$b5c91c309b2647a1$var$runCustomHandler(view, event));
    });
}
function $b5c91c309b2647a1$var$runCustomHandler(view, event) {
    return view.someProp("handleDOMEvents", (handlers)=>{
        let handler = handlers[event.type];
        return handler ? handler(view, event) || event.defaultPrevented : false;
    });
}
function $b5c91c309b2647a1$var$eventBelongsToView(view, event) {
    if (!event.bubbles) return true;
    if (event.defaultPrevented) return false;
    for(let node = event.target; node != view.dom; node = node.parentNode)if (!node || node.nodeType == 11 || node.pmViewDesc && node.pmViewDesc.stopEvent(event)) return false;
    return true;
}
function $b5c91c309b2647a1$var$dispatchEvent(view, event) {
    if (!$b5c91c309b2647a1$var$runCustomHandler(view, event) && $b5c91c309b2647a1$var$handlers[event.type] && (view.editable || !(event.type in $b5c91c309b2647a1$var$editHandlers))) $b5c91c309b2647a1$var$handlers[event.type](view, event);
}
$b5c91c309b2647a1$var$editHandlers.keydown = (view, _event)=>{
    let event = _event;
    view.input.shiftKey = event.keyCode == 16 || event.shiftKey;
    if ($b5c91c309b2647a1$var$inOrNearComposition(view, event)) return;
    view.input.lastKeyCode = event.keyCode;
    view.input.lastKeyCodeTime = Date.now();
    // Suppress enter key events on Chrome Android, because those tend
    // to be part of a confused sequence of composition events fired,
    // and handling them eagerly tends to corrupt the input.
    if ($b5c91c309b2647a1$var$android && $b5c91c309b2647a1$var$chrome && event.keyCode == 13) return;
    if (event.keyCode != 229) view.domObserver.forceFlush();
    // On iOS, if we preventDefault enter key presses, the virtual
    // keyboard gets confused. So the hack here is to set a flag that
    // makes the DOM change code recognize that what just happens should
    // be replaced by whatever the Enter key handlers do.
    if ($b5c91c309b2647a1$var$ios && event.keyCode == 13 && !event.ctrlKey && !event.altKey && !event.metaKey) {
        let now = Date.now();
        view.input.lastIOSEnter = now;
        view.input.lastIOSEnterFallbackTimeout = setTimeout(()=>{
            if (view.input.lastIOSEnter == now) {
                view.someProp("handleKeyDown", (f)=>f(view, $b5c91c309b2647a1$var$keyEvent(13, "Enter")));
                view.input.lastIOSEnter = 0;
            }
        }, 200);
    } else if (view.someProp("handleKeyDown", (f)=>f(view, event)) || $b5c91c309b2647a1$var$captureKeyDown(view, event)) event.preventDefault();
    else $b5c91c309b2647a1$var$setSelectionOrigin(view, "key");
};
$b5c91c309b2647a1$var$editHandlers.keyup = (view, event)=>{
    if (event.keyCode == 16) view.input.shiftKey = false;
};
$b5c91c309b2647a1$var$editHandlers.keypress = (view, _event)=>{
    let event = _event;
    if ($b5c91c309b2647a1$var$inOrNearComposition(view, event) || !event.charCode || event.ctrlKey && !event.altKey || $b5c91c309b2647a1$var$mac && event.metaKey) return;
    if (view.someProp("handleKeyPress", (f)=>f(view, event))) {
        event.preventDefault();
        return;
    }
    let sel = view.state.selection;
    if (!(sel instanceof (0, $kpTIW.TextSelection)) || !sel.$from.sameParent(sel.$to)) {
        let text = String.fromCharCode(event.charCode);
        if (!/[\r\n]/.test(text) && !view.someProp("handleTextInput", (f)=>f(view, sel.$from.pos, sel.$to.pos, text))) view.dispatch(view.state.tr.insertText(text).scrollIntoView());
        event.preventDefault();
    }
};
function $b5c91c309b2647a1$var$eventCoords(event) {
    return {
        left: event.clientX,
        top: event.clientY
    };
}
function $b5c91c309b2647a1$var$isNear(event, click) {
    let dx = click.x - event.clientX, dy = click.y - event.clientY;
    return dx * dx + dy * dy < 100;
}
function $b5c91c309b2647a1$var$runHandlerOnContext(view, propName, pos, inside, event) {
    if (inside == -1) return false;
    let $pos = view.state.doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        if (view.someProp(propName, (f)=>i > $pos.depth ? f(view, pos, $pos.nodeAfter, $pos.before(i), event, true) : f(view, pos, $pos.node(i), $pos.before(i), event, false))) return true;
    }
    return false;
}
function $b5c91c309b2647a1$var$updateSelection(view, selection, origin) {
    if (!view.focused) view.focus();
    let tr = view.state.tr.setSelection(selection);
    if (origin == "pointer") tr.setMeta("pointer", true);
    view.dispatch(tr);
}
function $b5c91c309b2647a1$var$selectClickedLeaf(view, inside) {
    if (inside == -1) return false;
    let $pos = view.state.doc.resolve(inside), node = $pos.nodeAfter;
    if (node && node.isAtom && (0, $kpTIW.NodeSelection).isSelectable(node)) {
        $b5c91c309b2647a1$var$updateSelection(view, new (0, $kpTIW.NodeSelection)($pos), "pointer");
        return true;
    }
    return false;
}
function $b5c91c309b2647a1$var$selectClickedNode(view, inside) {
    if (inside == -1) return false;
    let sel = view.state.selection, selectedNode, selectAt;
    if (sel instanceof (0, $kpTIW.NodeSelection)) selectedNode = sel.node;
    let $pos = view.state.doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
        if ((0, $kpTIW.NodeSelection).isSelectable(node)) {
            if (selectedNode && sel.$from.depth > 0 && i >= sel.$from.depth && $pos.before(sel.$from.depth + 1) == sel.$from.pos) selectAt = $pos.before(sel.$from.depth);
            else selectAt = $pos.before(i);
            break;
        }
    }
    if (selectAt != null) {
        $b5c91c309b2647a1$var$updateSelection(view, (0, $kpTIW.NodeSelection).create(view.state.doc, selectAt), "pointer");
        return true;
    } else return false;
}
function $b5c91c309b2647a1$var$handleSingleClick(view, pos, inside, event, selectNode) {
    return $b5c91c309b2647a1$var$runHandlerOnContext(view, "handleClickOn", pos, inside, event) || view.someProp("handleClick", (f)=>f(view, pos, event)) || (selectNode ? $b5c91c309b2647a1$var$selectClickedNode(view, inside) : $b5c91c309b2647a1$var$selectClickedLeaf(view, inside));
}
function $b5c91c309b2647a1$var$handleDoubleClick(view, pos, inside, event) {
    return $b5c91c309b2647a1$var$runHandlerOnContext(view, "handleDoubleClickOn", pos, inside, event) || view.someProp("handleDoubleClick", (f)=>f(view, pos, event));
}
function $b5c91c309b2647a1$var$handleTripleClick(view, pos, inside, event) {
    return $b5c91c309b2647a1$var$runHandlerOnContext(view, "handleTripleClickOn", pos, inside, event) || view.someProp("handleTripleClick", (f)=>f(view, pos, event)) || $b5c91c309b2647a1$var$defaultTripleClick(view, inside, event);
}
function $b5c91c309b2647a1$var$defaultTripleClick(view, inside, event) {
    if (event.button != 0) return false;
    let doc = view.state.doc;
    if (inside == -1) {
        if (doc.inlineContent) {
            $b5c91c309b2647a1$var$updateSelection(view, (0, $kpTIW.TextSelection).create(doc, 0, doc.content.size), "pointer");
            return true;
        }
        return false;
    }
    let $pos = doc.resolve(inside);
    for(let i = $pos.depth + 1; i > 0; i--){
        let node = i > $pos.depth ? $pos.nodeAfter : $pos.node(i);
        let nodePos = $pos.before(i);
        if (node.inlineContent) $b5c91c309b2647a1$var$updateSelection(view, (0, $kpTIW.TextSelection).create(doc, nodePos + 1, nodePos + 1 + node.content.size), "pointer");
        else if ((0, $kpTIW.NodeSelection).isSelectable(node)) $b5c91c309b2647a1$var$updateSelection(view, (0, $kpTIW.NodeSelection).create(doc, nodePos), "pointer");
        else continue;
        return true;
    }
}
function $b5c91c309b2647a1$var$forceDOMFlush(view) {
    return $b5c91c309b2647a1$var$endComposition(view);
}
const $b5c91c309b2647a1$var$selectNodeModifier = $b5c91c309b2647a1$var$mac ? "metaKey" : "ctrlKey";
$b5c91c309b2647a1$var$handlers.mousedown = (view, _event)=>{
    let event = _event;
    view.input.shiftKey = event.shiftKey;
    let flushed = $b5c91c309b2647a1$var$forceDOMFlush(view);
    let now = Date.now(), type = "singleClick";
    if (now - view.input.lastClick.time < 500 && $b5c91c309b2647a1$var$isNear(event, view.input.lastClick) && !event[$b5c91c309b2647a1$var$selectNodeModifier]) {
        if (view.input.lastClick.type == "singleClick") type = "doubleClick";
        else if (view.input.lastClick.type == "doubleClick") type = "tripleClick";
    }
    view.input.lastClick = {
        time: now,
        x: event.clientX,
        y: event.clientY,
        type: type
    };
    let pos = view.posAtCoords($b5c91c309b2647a1$var$eventCoords(event));
    if (!pos) return;
    if (type == "singleClick") {
        if (view.input.mouseDown) view.input.mouseDown.done();
        view.input.mouseDown = new $b5c91c309b2647a1$var$MouseDown(view, pos, event, !!flushed);
    } else if ((type == "doubleClick" ? $b5c91c309b2647a1$var$handleDoubleClick : $b5c91c309b2647a1$var$handleTripleClick)(view, pos.pos, pos.inside, event)) event.preventDefault();
    else $b5c91c309b2647a1$var$setSelectionOrigin(view, "pointer");
};
class $b5c91c309b2647a1$var$MouseDown {
    constructor(view, pos, event, flushed){
        this.view = view;
        this.pos = pos;
        this.event = event;
        this.flushed = flushed;
        this.delayedSelectionSync = false;
        this.mightDrag = null;
        this.startDoc = view.state.doc;
        this.selectNode = !!event[$b5c91c309b2647a1$var$selectNodeModifier];
        this.allowDefault = event.shiftKey;
        let targetNode, targetPos;
        if (pos.inside > -1) {
            targetNode = view.state.doc.nodeAt(pos.inside);
            targetPos = pos.inside;
        } else {
            let $pos = view.state.doc.resolve(pos.pos);
            targetNode = $pos.parent;
            targetPos = $pos.depth ? $pos.before() : 0;
        }
        const target = flushed ? null : event.target;
        const targetDesc = target ? view.docView.nearestDesc(target, true) : null;
        this.target = targetDesc ? targetDesc.dom : null;
        let { selection: selection } = view.state;
        if (event.button == 0 && targetNode.type.spec.draggable && targetNode.type.spec.selectable !== false || selection instanceof (0, $kpTIW.NodeSelection) && selection.from <= targetPos && selection.to > targetPos) this.mightDrag = {
            node: targetNode,
            pos: targetPos,
            addAttr: !!(this.target && !this.target.draggable),
            setUneditable: !!(this.target && $b5c91c309b2647a1$var$gecko && !this.target.hasAttribute("contentEditable"))
        };
        if (this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable)) {
            this.view.domObserver.stop();
            if (this.mightDrag.addAttr) this.target.draggable = true;
            if (this.mightDrag.setUneditable) setTimeout(()=>{
                if (this.view.input.mouseDown == this) this.target.setAttribute("contentEditable", "false");
            }, 20);
            this.view.domObserver.start();
        }
        view.root.addEventListener("mouseup", this.up = this.up.bind(this));
        view.root.addEventListener("mousemove", this.move = this.move.bind(this));
        $b5c91c309b2647a1$var$setSelectionOrigin(view, "pointer");
    }
    done() {
        this.view.root.removeEventListener("mouseup", this.up);
        this.view.root.removeEventListener("mousemove", this.move);
        if (this.mightDrag && this.target) {
            this.view.domObserver.stop();
            if (this.mightDrag.addAttr) this.target.removeAttribute("draggable");
            if (this.mightDrag.setUneditable) this.target.removeAttribute("contentEditable");
            this.view.domObserver.start();
        }
        if (this.delayedSelectionSync) setTimeout(()=>$b5c91c309b2647a1$var$selectionToDOM(this.view));
        this.view.input.mouseDown = null;
    }
    up(event) {
        this.done();
        if (!this.view.dom.contains(event.target)) return;
        let pos = this.pos;
        if (this.view.state.doc != this.startDoc) pos = this.view.posAtCoords($b5c91c309b2647a1$var$eventCoords(event));
        this.updateAllowDefault(event);
        if (this.allowDefault || !pos) $b5c91c309b2647a1$var$setSelectionOrigin(this.view, "pointer");
        else if ($b5c91c309b2647a1$var$handleSingleClick(this.view, pos.pos, pos.inside, event, this.selectNode)) event.preventDefault();
        else if (event.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
        $b5c91c309b2647a1$var$safari && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
        // cursor, but still report that the node is selected
        // when asked through getSelection. You'll then get a
        // situation where clicking at the point where that
        // (hidden) cursor is doesn't change the selection, and
        // thus doesn't get a reaction from ProseMirror. This
        // works around that.
        $b5c91c309b2647a1$var$chrome && !this.view.state.selection.visible && Math.min(Math.abs(pos.pos - this.view.state.selection.from), Math.abs(pos.pos - this.view.state.selection.to)) <= 2)) {
            $b5c91c309b2647a1$var$updateSelection(this.view, (0, $kpTIW.Selection).near(this.view.state.doc.resolve(pos.pos)), "pointer");
            event.preventDefault();
        } else $b5c91c309b2647a1$var$setSelectionOrigin(this.view, "pointer");
    }
    move(event) {
        this.updateAllowDefault(event);
        $b5c91c309b2647a1$var$setSelectionOrigin(this.view, "pointer");
        if (event.buttons == 0) this.done();
    }
    updateAllowDefault(event) {
        if (!this.allowDefault && (Math.abs(this.event.x - event.clientX) > 4 || Math.abs(this.event.y - event.clientY) > 4)) this.allowDefault = true;
    }
}
$b5c91c309b2647a1$var$handlers.touchstart = (view)=>{
    view.input.lastTouch = Date.now();
    $b5c91c309b2647a1$var$forceDOMFlush(view);
    $b5c91c309b2647a1$var$setSelectionOrigin(view, "pointer");
};
$b5c91c309b2647a1$var$handlers.touchmove = (view)=>{
    view.input.lastTouch = Date.now();
    $b5c91c309b2647a1$var$setSelectionOrigin(view, "pointer");
};
$b5c91c309b2647a1$var$handlers.contextmenu = (view)=>$b5c91c309b2647a1$var$forceDOMFlush(view);
function $b5c91c309b2647a1$var$inOrNearComposition(view, event) {
    if (view.composing) return true;
    // See https://www.stum.de/2016/06/24/handling-ime-events-in-javascript/.
    // On Japanese input method editors (IMEs), the Enter key is used to confirm character
    // selection. On Safari, when Enter is pressed, compositionend and keydown events are
    // emitted. The keydown event triggers newline insertion, which we don't want.
    // This method returns true if the keydown event should be ignored.
    // We only ignore it once, as pressing Enter a second time *should* insert a newline.
    // Furthermore, the keydown event timestamp must be close to the compositionEndedAt timestamp.
    // This guards against the case where compositionend is triggered without the keyboard
    // (e.g. character confirmation may be done with the mouse), and keydown is triggered
    // afterwards- we wouldn't want to ignore the keydown event in this case.
    if ($b5c91c309b2647a1$var$safari && Math.abs(event.timeStamp - view.input.compositionEndedAt) < 500) {
        view.input.compositionEndedAt = -200000000;
        return true;
    }
    return false;
}
// Drop active composition after 5 seconds of inactivity on Android
const $b5c91c309b2647a1$var$timeoutComposition = $b5c91c309b2647a1$var$android ? 5000 : -1;
$b5c91c309b2647a1$var$editHandlers.compositionstart = $b5c91c309b2647a1$var$editHandlers.compositionupdate = (view)=>{
    if (!view.composing) {
        view.domObserver.flush();
        let { state: state } = view, $pos = state.selection.$from;
        if (state.selection.empty && (state.storedMarks || !$pos.textOffset && $pos.parentOffset && $pos.nodeBefore.marks.some((m)=>m.type.spec.inclusive === false))) {
            // Need to wrap the cursor in mark nodes different from the ones in the DOM context
            view.markCursor = view.state.storedMarks || $pos.marks();
            $b5c91c309b2647a1$var$endComposition(view, true);
            view.markCursor = null;
        } else {
            $b5c91c309b2647a1$var$endComposition(view);
            // In firefox, if the cursor is after but outside a marked node,
            // the inserted text won't inherit the marks. So this moves it
            // inside if necessary.
            if ($b5c91c309b2647a1$var$gecko && state.selection.empty && $pos.parentOffset && !$pos.textOffset && $pos.nodeBefore.marks.length) {
                let sel = view.domSelectionRange();
                for(let node = sel.focusNode, offset = sel.focusOffset; node && node.nodeType == 1 && offset != 0;){
                    let before = offset < 0 ? node.lastChild : node.childNodes[offset - 1];
                    if (!before) break;
                    if (before.nodeType == 3) {
                        view.domSelection().collapse(before, before.nodeValue.length);
                        break;
                    } else {
                        node = before;
                        offset = -1;
                    }
                }
            }
        }
        view.input.composing = true;
    }
    $b5c91c309b2647a1$var$scheduleComposeEnd(view, $b5c91c309b2647a1$var$timeoutComposition);
};
$b5c91c309b2647a1$var$editHandlers.compositionend = (view, event)=>{
    if (view.composing) {
        view.input.composing = false;
        view.input.compositionEndedAt = event.timeStamp;
        view.input.compositionPendingChanges = view.domObserver.pendingRecords().length ? view.input.compositionID : 0;
        view.input.compositionNode = null;
        if (view.input.compositionPendingChanges) Promise.resolve().then(()=>view.domObserver.flush());
        view.input.compositionID++;
        $b5c91c309b2647a1$var$scheduleComposeEnd(view, 20);
    }
};
function $b5c91c309b2647a1$var$scheduleComposeEnd(view, delay) {
    clearTimeout(view.input.composingTimeout);
    if (delay > -1) view.input.composingTimeout = setTimeout(()=>$b5c91c309b2647a1$var$endComposition(view), delay);
}
function $b5c91c309b2647a1$var$clearComposition(view) {
    if (view.composing) {
        view.input.composing = false;
        view.input.compositionEndedAt = $b5c91c309b2647a1$var$timestampFromCustomEvent();
    }
    while(view.input.compositionNodes.length > 0)view.input.compositionNodes.pop().markParentsDirty();
}
function $b5c91c309b2647a1$var$findCompositionNode(view) {
    let sel = view.domSelectionRange();
    if (!sel.focusNode) return null;
    let textBefore = $b5c91c309b2647a1$var$textNodeBefore$1(sel.focusNode, sel.focusOffset);
    let textAfter = $b5c91c309b2647a1$var$textNodeAfter$1(sel.focusNode, sel.focusOffset);
    if (textBefore && textAfter && textBefore != textAfter) {
        let descAfter = textAfter.pmViewDesc;
        if (!descAfter || !descAfter.isText(textAfter.nodeValue)) return textAfter;
        else if (view.input.compositionNode == textAfter) {
            let descBefore = textBefore.pmViewDesc;
            if (!(!descBefore || !descBefore.isText(textBefore.nodeValue))) return textAfter;
        }
    }
    return textBefore || textAfter;
}
function $b5c91c309b2647a1$var$timestampFromCustomEvent() {
    let event = document.createEvent("Event");
    event.initEvent("event", true, true);
    return event.timeStamp;
}
/**
@internal
*/ function $b5c91c309b2647a1$var$endComposition(view, forceUpdate = false) {
    if ($b5c91c309b2647a1$var$android && view.domObserver.flushingSoon >= 0) return;
    view.domObserver.forceFlush();
    $b5c91c309b2647a1$var$clearComposition(view);
    if (forceUpdate || view.docView && view.docView.dirty) {
        let sel = $b5c91c309b2647a1$var$selectionFromDOM(view);
        if (sel && !sel.eq(view.state.selection)) view.dispatch(view.state.tr.setSelection(sel));
        else view.updateState(view.state);
        return true;
    }
    return false;
}
function $b5c91c309b2647a1$var$captureCopy(view, dom) {
    // The extra wrapper is somehow necessary on IE/Edge to prevent the
    // content from being mangled when it is put onto the clipboard
    if (!view.dom.parentNode) return;
    let wrap = view.dom.parentNode.appendChild(document.createElement("div"));
    wrap.appendChild(dom);
    wrap.style.cssText = "position: fixed; left: -10000px; top: 10px";
    let sel = getSelection(), range = document.createRange();
    range.selectNodeContents(dom);
    // Done because IE will fire a selectionchange moving the selection
    // to its start when removeAllRanges is called and the editor still
    // has focus (which will mess up the editor's selection state).
    view.dom.blur();
    sel.removeAllRanges();
    sel.addRange(range);
    setTimeout(()=>{
        if (wrap.parentNode) wrap.parentNode.removeChild(wrap);
        view.focus();
    }, 50);
}
// This is very crude, but unfortunately both these browsers _pretend_
// that they have a clipboard API—all the objects and methods are
// there, they just don't work, and they are hard to test.
const $b5c91c309b2647a1$var$brokenClipboardAPI = $b5c91c309b2647a1$var$ie && $b5c91c309b2647a1$var$ie_version < 15 || $b5c91c309b2647a1$var$ios && $b5c91c309b2647a1$var$webkit_version < 604;
$b5c91c309b2647a1$var$handlers.copy = $b5c91c309b2647a1$var$editHandlers.cut = (view, _event)=>{
    let event = _event;
    let sel = view.state.selection, cut = event.type == "cut";
    if (sel.empty) return;
    // IE and Edge's clipboard interface is completely broken
    let data = $b5c91c309b2647a1$var$brokenClipboardAPI ? null : event.clipboardData;
    let slice = sel.content(), { dom: dom, text: text } = $b5c91c309b2647a1$var$serializeForClipboard(view, slice);
    if (data) {
        event.preventDefault();
        data.clearData();
        data.setData("text/html", dom.innerHTML);
        data.setData("text/plain", text);
    } else $b5c91c309b2647a1$var$captureCopy(view, dom);
    if (cut) view.dispatch(view.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function $b5c91c309b2647a1$var$sliceSingleNode(slice) {
    return slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1 ? slice.content.firstChild : null;
}
function $b5c91c309b2647a1$var$capturePaste(view, event) {
    if (!view.dom.parentNode) return;
    let plainText = view.input.shiftKey || view.state.selection.$from.parent.type.spec.code;
    let target = view.dom.parentNode.appendChild(document.createElement(plainText ? "textarea" : "div"));
    if (!plainText) target.contentEditable = "true";
    target.style.cssText = "position: fixed; left: -10000px; top: 10px";
    target.focus();
    let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
    setTimeout(()=>{
        view.focus();
        if (target.parentNode) target.parentNode.removeChild(target);
        if (plainText) $b5c91c309b2647a1$var$doPaste(view, target.value, null, plain, event);
        else $b5c91c309b2647a1$var$doPaste(view, target.textContent, target.innerHTML, plain, event);
    }, 50);
}
function $b5c91c309b2647a1$var$doPaste(view, text, html, preferPlain, event) {
    let slice = $b5c91c309b2647a1$var$parseFromClipboard(view, text, html, preferPlain, view.state.selection.$from);
    if (view.someProp("handlePaste", (f)=>f(view, event, slice || (0, $7dkLM.Slice).empty))) return true;
    if (!slice) return false;
    let singleNode = $b5c91c309b2647a1$var$sliceSingleNode(slice);
    let tr = singleNode ? view.state.tr.replaceSelectionWith(singleNode, preferPlain) : view.state.tr.replaceSelection(slice);
    view.dispatch(tr.scrollIntoView().setMeta("paste", true).setMeta("uiEvent", "paste"));
    return true;
}
function $b5c91c309b2647a1$var$getText(clipboardData) {
    let text = clipboardData.getData("text/plain") || clipboardData.getData("Text");
    if (text) return text;
    let uris = clipboardData.getData("text/uri-list");
    return uris ? uris.replace(/\r?\n/g, " ") : "";
}
$b5c91c309b2647a1$var$editHandlers.paste = (view, _event)=>{
    let event = _event;
    // Handling paste from JavaScript during composition is very poorly
    // handled by browsers, so as a dodgy but preferable kludge, we just
    // let the browser do its native thing there, except on Android,
    // where the editor is almost always composing.
    if (view.composing && !$b5c91c309b2647a1$var$android) return;
    let data = $b5c91c309b2647a1$var$brokenClipboardAPI ? null : event.clipboardData;
    let plain = view.input.shiftKey && view.input.lastKeyCode != 45;
    if (data && $b5c91c309b2647a1$var$doPaste(view, $b5c91c309b2647a1$var$getText(data), data.getData("text/html"), plain, event)) event.preventDefault();
    else $b5c91c309b2647a1$var$capturePaste(view, event);
};
class $b5c91c309b2647a1$var$Dragging {
    constructor(slice, move, node){
        this.slice = slice;
        this.move = move;
        this.node = node;
    }
}
const $b5c91c309b2647a1$var$dragCopyModifier = $b5c91c309b2647a1$var$mac ? "altKey" : "ctrlKey";
$b5c91c309b2647a1$var$handlers.dragstart = (view, _event)=>{
    let event = _event;
    let mouseDown = view.input.mouseDown;
    if (mouseDown) mouseDown.done();
    if (!event.dataTransfer) return;
    let sel = view.state.selection;
    let pos = sel.empty ? null : view.posAtCoords($b5c91c309b2647a1$var$eventCoords(event));
    let node;
    if (pos && pos.pos >= sel.from && pos.pos <= (sel instanceof (0, $kpTIW.NodeSelection) ? sel.to - 1 : sel.to)) ;
    else if (mouseDown && mouseDown.mightDrag) node = (0, $kpTIW.NodeSelection).create(view.state.doc, mouseDown.mightDrag.pos);
    else if (event.target && event.target.nodeType == 1) {
        let desc = view.docView.nearestDesc(event.target, true);
        if (desc && desc.node.type.spec.draggable && desc != view.docView) node = (0, $kpTIW.NodeSelection).create(view.state.doc, desc.posBefore);
    }
    let slice = (node || view.state.selection).content(), { dom: dom, text: text } = $b5c91c309b2647a1$var$serializeForClipboard(view, slice);
    event.dataTransfer.clearData();
    event.dataTransfer.setData($b5c91c309b2647a1$var$brokenClipboardAPI ? "Text" : "text/html", dom.innerHTML);
    // See https://github.com/ProseMirror/prosemirror/issues/1156
    event.dataTransfer.effectAllowed = "copyMove";
    if (!$b5c91c309b2647a1$var$brokenClipboardAPI) event.dataTransfer.setData("text/plain", text);
    view.dragging = new $b5c91c309b2647a1$var$Dragging(slice, !event[$b5c91c309b2647a1$var$dragCopyModifier], node);
};
$b5c91c309b2647a1$var$handlers.dragend = (view)=>{
    let dragging = view.dragging;
    window.setTimeout(()=>{
        if (view.dragging == dragging) view.dragging = null;
    }, 50);
};
$b5c91c309b2647a1$var$editHandlers.dragover = $b5c91c309b2647a1$var$editHandlers.dragenter = (_, e)=>e.preventDefault();
$b5c91c309b2647a1$var$editHandlers.drop = (view, _event)=>{
    let event = _event;
    let dragging = view.dragging;
    view.dragging = null;
    if (!event.dataTransfer) return;
    let eventPos = view.posAtCoords($b5c91c309b2647a1$var$eventCoords(event));
    if (!eventPos) return;
    let $mouse = view.state.doc.resolve(eventPos.pos);
    let slice = dragging && dragging.slice;
    if (slice) view.someProp("transformPasted", (f)=>{
        slice = f(slice, view);
    });
    else slice = $b5c91c309b2647a1$var$parseFromClipboard(view, $b5c91c309b2647a1$var$getText(event.dataTransfer), $b5c91c309b2647a1$var$brokenClipboardAPI ? null : event.dataTransfer.getData("text/html"), false, $mouse);
    let move = !!(dragging && !event[$b5c91c309b2647a1$var$dragCopyModifier]);
    if (view.someProp("handleDrop", (f)=>f(view, event, slice || (0, $7dkLM.Slice).empty, move))) {
        event.preventDefault();
        return;
    }
    if (!slice) return;
    event.preventDefault();
    let insertPos = slice ? (0, $d6JJW.dropPoint)(view.state.doc, $mouse.pos, slice) : $mouse.pos;
    if (insertPos == null) insertPos = $mouse.pos;
    let tr = view.state.tr;
    if (move) {
        let { node: node } = dragging;
        if (node) node.replace(tr);
        else tr.deleteSelection();
    }
    let pos = tr.mapping.map(insertPos);
    let isNode = slice.openStart == 0 && slice.openEnd == 0 && slice.content.childCount == 1;
    let beforeInsert = tr.doc;
    if (isNode) tr.replaceRangeWith(pos, pos, slice.content.firstChild);
    else tr.replaceRange(pos, pos, slice);
    if (tr.doc.eq(beforeInsert)) return;
    let $pos = tr.doc.resolve(pos);
    if (isNode && (0, $kpTIW.NodeSelection).isSelectable(slice.content.firstChild) && $pos.nodeAfter && $pos.nodeAfter.sameMarkup(slice.content.firstChild)) tr.setSelection(new (0, $kpTIW.NodeSelection)($pos));
    else {
        let end = tr.mapping.map(insertPos);
        tr.mapping.maps[tr.mapping.maps.length - 1].forEach((_from, _to, _newFrom, newTo)=>end = newTo);
        tr.setSelection($b5c91c309b2647a1$var$selectionBetween(view, $pos, tr.doc.resolve(end)));
    }
    view.focus();
    view.dispatch(tr.setMeta("uiEvent", "drop"));
};
$b5c91c309b2647a1$var$handlers.focus = (view)=>{
    view.input.lastFocus = Date.now();
    if (!view.focused) {
        view.domObserver.stop();
        view.dom.classList.add("ProseMirror-focused");
        view.domObserver.start();
        view.focused = true;
        setTimeout(()=>{
            if (view.docView && view.hasFocus() && !view.domObserver.currentSelection.eq(view.domSelectionRange())) $b5c91c309b2647a1$var$selectionToDOM(view);
        }, 20);
    }
};
$b5c91c309b2647a1$var$handlers.blur = (view, _event)=>{
    let event = _event;
    if (view.focused) {
        view.domObserver.stop();
        view.dom.classList.remove("ProseMirror-focused");
        view.domObserver.start();
        if (event.relatedTarget && view.dom.contains(event.relatedTarget)) view.domObserver.currentSelection.clear();
        view.focused = false;
    }
};
$b5c91c309b2647a1$var$handlers.beforeinput = (view, _event)=>{
    let event = _event;
    // We should probably do more with beforeinput events, but support
    // is so spotty that I'm still waiting to see where they are going.
    // Very specific hack to deal with backspace sometimes failing on
    // Chrome Android when after an uneditable node.
    if ($b5c91c309b2647a1$var$chrome && $b5c91c309b2647a1$var$android && event.inputType == "deleteContentBackward") {
        view.domObserver.flushSoon();
        let { domChangeCount: domChangeCount } = view.input;
        setTimeout(()=>{
            if (view.input.domChangeCount != domChangeCount) return; // Event already had some effect
            // This bug tends to close the virtual keyboard, so we refocus
            view.dom.blur();
            view.focus();
            if (view.someProp("handleKeyDown", (f)=>f(view, $b5c91c309b2647a1$var$keyEvent(8, "Backspace")))) return;
            let { $cursor: $cursor } = view.state.selection;
            // Crude approximation of backspace behavior when no command handled it
            if ($cursor && $cursor.pos > 0) view.dispatch(view.state.tr.delete($cursor.pos - 1, $cursor.pos).scrollIntoView());
        }, 50);
    }
};
// Make sure all handlers get registered
for(let prop in $b5c91c309b2647a1$var$editHandlers)$b5c91c309b2647a1$var$handlers[prop] = $b5c91c309b2647a1$var$editHandlers[prop];
function $b5c91c309b2647a1$var$compareObjs(a, b) {
    if (a == b) return true;
    for(let p in a)if (a[p] !== b[p]) return false;
    for(let p in b)if (!(p in a)) return false;
    return true;
}
class $b5c91c309b2647a1$var$WidgetType {
    constructor(toDOM, spec){
        this.toDOM = toDOM;
        this.spec = spec || $b5c91c309b2647a1$var$noSpec;
        this.side = this.spec.side || 0;
    }
    map(mapping, span, offset, oldOffset) {
        let { pos: pos, deleted: deleted } = mapping.mapResult(span.from + oldOffset, this.side < 0 ? -1 : 1);
        return deleted ? null : new $b5c91c309b2647a1$export$10e30b733df217ea(pos - offset, pos - offset, this);
    }
    valid() {
        return true;
    }
    eq(other) {
        return this == other || other instanceof $b5c91c309b2647a1$var$WidgetType && (this.spec.key && this.spec.key == other.spec.key || this.toDOM == other.toDOM && $b5c91c309b2647a1$var$compareObjs(this.spec, other.spec));
    }
    destroy(node) {
        if (this.spec.destroy) this.spec.destroy(node);
    }
}
class $b5c91c309b2647a1$var$InlineType {
    constructor(attrs, spec){
        this.attrs = attrs;
        this.spec = spec || $b5c91c309b2647a1$var$noSpec;
    }
    map(mapping, span, offset, oldOffset) {
        let from = mapping.map(span.from + oldOffset, this.spec.inclusiveStart ? -1 : 1) - offset;
        let to = mapping.map(span.to + oldOffset, this.spec.inclusiveEnd ? 1 : -1) - offset;
        return from >= to ? null : new $b5c91c309b2647a1$export$10e30b733df217ea(from, to, this);
    }
    valid(_, span) {
        return span.from < span.to;
    }
    eq(other) {
        return this == other || other instanceof $b5c91c309b2647a1$var$InlineType && $b5c91c309b2647a1$var$compareObjs(this.attrs, other.attrs) && $b5c91c309b2647a1$var$compareObjs(this.spec, other.spec);
    }
    static is(span) {
        return span.type instanceof $b5c91c309b2647a1$var$InlineType;
    }
    destroy() {}
}
class $b5c91c309b2647a1$var$NodeType {
    constructor(attrs, spec){
        this.attrs = attrs;
        this.spec = spec || $b5c91c309b2647a1$var$noSpec;
    }
    map(mapping, span, offset, oldOffset) {
        let from = mapping.mapResult(span.from + oldOffset, 1);
        if (from.deleted) return null;
        let to = mapping.mapResult(span.to + oldOffset, -1);
        if (to.deleted || to.pos <= from.pos) return null;
        return new $b5c91c309b2647a1$export$10e30b733df217ea(from.pos - offset, to.pos - offset, this);
    }
    valid(node, span) {
        let { index: index, offset: offset } = node.content.findIndex(span.from), child;
        return offset == span.from && !(child = node.child(index)).isText && offset + child.nodeSize == span.to;
    }
    eq(other) {
        return this == other || other instanceof $b5c91c309b2647a1$var$NodeType && $b5c91c309b2647a1$var$compareObjs(this.attrs, other.attrs) && $b5c91c309b2647a1$var$compareObjs(this.spec, other.spec);
    }
    destroy() {}
}
/**
Decoration objects can be provided to the view through the
[`decorations` prop](https://prosemirror.net/docs/ref/#view.EditorProps.decorations). They come in
several variants—see the static members of this class for details.
*/ class $b5c91c309b2647a1$export$10e30b733df217ea {
    /**
    @internal
    */ constructor(/**
    The start position of the decoration.
    */ from, /**
    The end position. Will be the same as `from` for [widget
    decorations](https://prosemirror.net/docs/ref/#view.Decoration^widget).
    */ to, /**
    @internal
    */ type){
        this.from = from;
        this.to = to;
        this.type = type;
    }
    /**
    @internal
    */ copy(from, to) {
        return new $b5c91c309b2647a1$export$10e30b733df217ea(from, to, this.type);
    }
    /**
    @internal
    */ eq(other, offset = 0) {
        return this.type.eq(other.type) && this.from + offset == other.from && this.to + offset == other.to;
    }
    /**
    @internal
    */ map(mapping, offset, oldOffset) {
        return this.type.map(mapping, this, offset, oldOffset);
    }
    /**
    Creates a widget decoration, which is a DOM node that's shown in
    the document at the given position. It is recommended that you
    delay rendering the widget by passing a function that will be
    called when the widget is actually drawn in a view, but you can
    also directly pass a DOM node. `getPos` can be used to find the
    widget's current document position.
    */ static widget(pos, toDOM, spec) {
        return new $b5c91c309b2647a1$export$10e30b733df217ea(pos, pos, new $b5c91c309b2647a1$var$WidgetType(toDOM, spec));
    }
    /**
    Creates an inline decoration, which adds the given attributes to
    each inline node between `from` and `to`.
    */ static inline(from, to, attrs, spec) {
        return new $b5c91c309b2647a1$export$10e30b733df217ea(from, to, new $b5c91c309b2647a1$var$InlineType(attrs, spec));
    }
    /**
    Creates a node decoration. `from` and `to` should point precisely
    before and after a node in the document. That node, and only that
    node, will receive the given attributes.
    */ static node(from, to, attrs, spec) {
        return new $b5c91c309b2647a1$export$10e30b733df217ea(from, to, new $b5c91c309b2647a1$var$NodeType(attrs, spec));
    }
    /**
    The spec provided when creating this decoration. Can be useful
    if you've stored extra information in that object.
    */ get spec() {
        return this.type.spec;
    }
    /**
    @internal
    */ get inline() {
        return this.type instanceof $b5c91c309b2647a1$var$InlineType;
    }
    /**
    @internal
    */ get widget() {
        return this.type instanceof $b5c91c309b2647a1$var$WidgetType;
    }
}
const $b5c91c309b2647a1$var$none = [], $b5c91c309b2647a1$var$noSpec = {};
/**
A collection of [decorations](https://prosemirror.net/docs/ref/#view.Decoration), organized in such
a way that the drawing algorithm can efficiently use and compare
them. This is a persistent data structure—it is not modified,
updates create a new value.
*/ class $b5c91c309b2647a1$export$93bf62eb445cec98 {
    /**
    @internal
    */ constructor(local, children){
        this.local = local.length ? local : $b5c91c309b2647a1$var$none;
        this.children = children.length ? children : $b5c91c309b2647a1$var$none;
    }
    /**
    Create a set of decorations, using the structure of the given
    document. This will consume (modify) the `decorations` array, so
    you must make a copy if you want need to preserve that.
    */ static create(doc, decorations) {
        return decorations.length ? $b5c91c309b2647a1$var$buildTree(decorations, doc, 0, $b5c91c309b2647a1$var$noSpec) : $b5c91c309b2647a1$var$empty;
    }
    /**
    Find all decorations in this set which touch the given range
    (including decorations that start or end directly at the
    boundaries) and match the given predicate on their spec. When
    `start` and `end` are omitted, all decorations in the set are
    considered. When `predicate` isn't given, all decorations are
    assumed to match.
    */ find(start, end, predicate) {
        let result = [];
        this.findInner(start == null ? 0 : start, end == null ? 1e9 : end, result, 0, predicate);
        return result;
    }
    findInner(start, end, result, offset, predicate) {
        for(let i = 0; i < this.local.length; i++){
            let span = this.local[i];
            if (span.from <= end && span.to >= start && (!predicate || predicate(span.spec))) result.push(span.copy(span.from + offset, span.to + offset));
        }
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] < end && this.children[i + 1] > start) {
            let childOff = this.children[i] + 1;
            this.children[i + 2].findInner(start - childOff, end - childOff, result, offset + childOff, predicate);
        }
    }
    /**
    Map the set of decorations in response to a change in the
    document.
    */ map(mapping, doc, options) {
        if (this == $b5c91c309b2647a1$var$empty || mapping.maps.length == 0) return this;
        return this.mapInner(mapping, doc, 0, 0, options || $b5c91c309b2647a1$var$noSpec);
    }
    /**
    @internal
    */ mapInner(mapping, node, offset, oldOffset, options) {
        let newLocal;
        for(let i = 0; i < this.local.length; i++){
            let mapped = this.local[i].map(mapping, offset, oldOffset);
            if (mapped && mapped.type.valid(node, mapped)) (newLocal || (newLocal = [])).push(mapped);
            else if (options.onRemove) options.onRemove(this.local[i].spec);
        }
        if (this.children.length) return $b5c91c309b2647a1$var$mapChildren(this.children, newLocal || [], mapping, node, offset, oldOffset, options);
        else return newLocal ? new $b5c91c309b2647a1$export$93bf62eb445cec98(newLocal.sort($b5c91c309b2647a1$var$byPos), $b5c91c309b2647a1$var$none) : $b5c91c309b2647a1$var$empty;
    }
    /**
    Add the given array of decorations to the ones in the set,
    producing a new set. Consumes the `decorations` array. Needs
    access to the current document to create the appropriate tree
    structure.
    */ add(doc, decorations) {
        if (!decorations.length) return this;
        if (this == $b5c91c309b2647a1$var$empty) return $b5c91c309b2647a1$export$93bf62eb445cec98.create(doc, decorations);
        return this.addInner(doc, decorations, 0);
    }
    addInner(doc, decorations, offset) {
        let children, childIndex = 0;
        doc.forEach((childNode, childOffset)=>{
            let baseOffset = childOffset + offset, found;
            if (!(found = $b5c91c309b2647a1$var$takeSpansForNode(decorations, childNode, baseOffset))) return;
            if (!children) children = this.children.slice();
            while(childIndex < children.length && children[childIndex] < childOffset)childIndex += 3;
            if (children[childIndex] == childOffset) children[childIndex + 2] = children[childIndex + 2].addInner(childNode, found, baseOffset + 1);
            else children.splice(childIndex, 0, childOffset, childOffset + childNode.nodeSize, $b5c91c309b2647a1$var$buildTree(found, childNode, baseOffset + 1, $b5c91c309b2647a1$var$noSpec));
            childIndex += 3;
        });
        let local = $b5c91c309b2647a1$var$moveSpans(childIndex ? $b5c91c309b2647a1$var$withoutNulls(decorations) : decorations, -offset);
        for(let i = 0; i < local.length; i++)if (!local[i].type.valid(doc, local[i])) local.splice(i--, 1);
        return new $b5c91c309b2647a1$export$93bf62eb445cec98(local.length ? this.local.concat(local).sort($b5c91c309b2647a1$var$byPos) : this.local, children || this.children);
    }
    /**
    Create a new set that contains the decorations in this set, minus
    the ones in the given array.
    */ remove(decorations) {
        if (decorations.length == 0 || this == $b5c91c309b2647a1$var$empty) return this;
        return this.removeInner(decorations, 0);
    }
    removeInner(decorations, offset) {
        let children = this.children, local = this.local;
        for(let i = 0; i < children.length; i += 3){
            let found;
            let from = children[i] + offset, to = children[i + 1] + offset;
            for(let j = 0, span; j < decorations.length; j++)if (span = decorations[j]) {
                if (span.from > from && span.to < to) {
                    decorations[j] = null;
                    (found || (found = [])).push(span);
                }
            }
            if (!found) continue;
            if (children == this.children) children = this.children.slice();
            let removed = children[i + 2].removeInner(found, from + 1);
            if (removed != $b5c91c309b2647a1$var$empty) children[i + 2] = removed;
            else {
                children.splice(i, 3);
                i -= 3;
            }
        }
        if (local.length) {
            for(let i = 0, span; i < decorations.length; i++)if (span = decorations[i]) {
                for(let j = 0; j < local.length; j++)if (local[j].eq(span, offset)) {
                    if (local == this.local) local = this.local.slice();
                    local.splice(j--, 1);
                }
            }
        }
        if (children == this.children && local == this.local) return this;
        return local.length || children.length ? new $b5c91c309b2647a1$export$93bf62eb445cec98(local, children) : $b5c91c309b2647a1$var$empty;
    }
    forChild(offset, node) {
        if (this == $b5c91c309b2647a1$var$empty) return this;
        if (node.isLeaf) return $b5c91c309b2647a1$export$93bf62eb445cec98.empty;
        let child, local;
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] >= offset) {
            if (this.children[i] == offset) child = this.children[i + 2];
            break;
        }
        let start = offset + 1, end = start + node.content.size;
        for(let i = 0; i < this.local.length; i++){
            let dec = this.local[i];
            if (dec.from < end && dec.to > start && dec.type instanceof $b5c91c309b2647a1$var$InlineType) {
                let from = Math.max(start, dec.from) - start, to = Math.min(end, dec.to) - start;
                if (from < to) (local || (local = [])).push(dec.copy(from, to));
            }
        }
        if (local) {
            let localSet = new $b5c91c309b2647a1$export$93bf62eb445cec98(local.sort($b5c91c309b2647a1$var$byPos), $b5c91c309b2647a1$var$none);
            return child ? new $b5c91c309b2647a1$var$DecorationGroup([
                localSet,
                child
            ]) : localSet;
        }
        return child || $b5c91c309b2647a1$var$empty;
    }
    /**
    @internal
    */ eq(other) {
        if (this == other) return true;
        if (!(other instanceof $b5c91c309b2647a1$export$93bf62eb445cec98) || this.local.length != other.local.length || this.children.length != other.children.length) return false;
        for(let i = 0; i < this.local.length; i++)if (!this.local[i].eq(other.local[i])) return false;
        for(let i = 0; i < this.children.length; i += 3)if (this.children[i] != other.children[i] || this.children[i + 1] != other.children[i + 1] || !this.children[i + 2].eq(other.children[i + 2])) return false;
        return true;
    }
    /**
    @internal
    */ locals(node) {
        return $b5c91c309b2647a1$var$removeOverlap(this.localsInner(node));
    }
    /**
    @internal
    */ localsInner(node) {
        if (this == $b5c91c309b2647a1$var$empty) return $b5c91c309b2647a1$var$none;
        if (node.inlineContent || !this.local.some($b5c91c309b2647a1$var$InlineType.is)) return this.local;
        let result = [];
        for(let i = 0; i < this.local.length; i++)if (!(this.local[i].type instanceof $b5c91c309b2647a1$var$InlineType)) result.push(this.local[i]);
        return result;
    }
}
/**
The empty set of decorations.
*/ $b5c91c309b2647a1$export$93bf62eb445cec98.empty = new $b5c91c309b2647a1$export$93bf62eb445cec98([], []);
/**
@internal
*/ $b5c91c309b2647a1$export$93bf62eb445cec98.removeOverlap = $b5c91c309b2647a1$var$removeOverlap;
const $b5c91c309b2647a1$var$empty = $b5c91c309b2647a1$export$93bf62eb445cec98.empty;
// An abstraction that allows the code dealing with decorations to
// treat multiple DecorationSet objects as if it were a single object
// with (a subset of) the same interface.
class $b5c91c309b2647a1$var$DecorationGroup {
    constructor(members){
        this.members = members;
    }
    map(mapping, doc) {
        const mappedDecos = this.members.map((member)=>member.map(mapping, doc, $b5c91c309b2647a1$var$noSpec));
        return $b5c91c309b2647a1$var$DecorationGroup.from(mappedDecos);
    }
    forChild(offset, child) {
        if (child.isLeaf) return $b5c91c309b2647a1$export$93bf62eb445cec98.empty;
        let found = [];
        for(let i = 0; i < this.members.length; i++){
            let result = this.members[i].forChild(offset, child);
            if (result == $b5c91c309b2647a1$var$empty) continue;
            if (result instanceof $b5c91c309b2647a1$var$DecorationGroup) found = found.concat(result.members);
            else found.push(result);
        }
        return $b5c91c309b2647a1$var$DecorationGroup.from(found);
    }
    eq(other) {
        if (!(other instanceof $b5c91c309b2647a1$var$DecorationGroup) || other.members.length != this.members.length) return false;
        for(let i = 0; i < this.members.length; i++)if (!this.members[i].eq(other.members[i])) return false;
        return true;
    }
    locals(node) {
        let result, sorted = true;
        for(let i = 0; i < this.members.length; i++){
            let locals = this.members[i].localsInner(node);
            if (!locals.length) continue;
            if (!result) result = locals;
            else {
                if (sorted) {
                    result = result.slice();
                    sorted = false;
                }
                for(let j = 0; j < locals.length; j++)result.push(locals[j]);
            }
        }
        return result ? $b5c91c309b2647a1$var$removeOverlap(sorted ? result : result.sort($b5c91c309b2647a1$var$byPos)) : $b5c91c309b2647a1$var$none;
    }
    // Create a group for the given array of decoration sets, or return
    // a single set when possible.
    static from(members) {
        switch(members.length){
            case 0:
                return $b5c91c309b2647a1$var$empty;
            case 1:
                return members[0];
            default:
                return new $b5c91c309b2647a1$var$DecorationGroup(members.every((m)=>m instanceof $b5c91c309b2647a1$export$93bf62eb445cec98) ? members : members.reduce((r, m)=>r.concat(m instanceof $b5c91c309b2647a1$export$93bf62eb445cec98 ? m : m.members), []));
        }
    }
}
function $b5c91c309b2647a1$var$mapChildren(oldChildren, newLocal, mapping, node, offset, oldOffset, options) {
    let children = oldChildren.slice();
    // Mark the children that are directly touched by changes, and
    // move those that are after the changes.
    for(let i = 0, baseOffset = oldOffset; i < mapping.maps.length; i++){
        let moved = 0;
        mapping.maps[i].forEach((oldStart, oldEnd, newStart, newEnd)=>{
            let dSize = newEnd - newStart - (oldEnd - oldStart);
            for(let i = 0; i < children.length; i += 3){
                let end = children[i + 1];
                if (end < 0 || oldStart > end + baseOffset - moved) continue;
                let start = children[i] + baseOffset - moved;
                if (oldEnd >= start) children[i + 1] = oldStart <= start ? -2 : -1;
                else if (oldStart >= baseOffset && dSize) {
                    children[i] += dSize;
                    children[i + 1] += dSize;
                }
            }
            moved += dSize;
        });
        baseOffset = mapping.maps[i].map(baseOffset, -1);
    }
    // Find the child nodes that still correspond to a single node,
    // recursively call mapInner on them and update their positions.
    let mustRebuild = false;
    for(let i = 0; i < children.length; i += 3)if (children[i + 1] < 0) {
        if (children[i + 1] == -2) {
            mustRebuild = true;
            children[i + 1] = -1;
            continue;
        }
        let from = mapping.map(oldChildren[i] + oldOffset), fromLocal = from - offset;
        if (fromLocal < 0 || fromLocal >= node.content.size) {
            mustRebuild = true;
            continue;
        }
        // Must read oldChildren because children was tagged with -1
        let to = mapping.map(oldChildren[i + 1] + oldOffset, -1), toLocal = to - offset;
        let { index: index, offset: childOffset } = node.content.findIndex(fromLocal);
        let childNode = node.maybeChild(index);
        if (childNode && childOffset == fromLocal && childOffset + childNode.nodeSize == toLocal) {
            let mapped = children[i + 2].mapInner(mapping, childNode, from + 1, oldChildren[i] + oldOffset + 1, options);
            if (mapped != $b5c91c309b2647a1$var$empty) {
                children[i] = fromLocal;
                children[i + 1] = toLocal;
                children[i + 2] = mapped;
            } else {
                children[i + 1] = -2;
                mustRebuild = true;
            }
        } else mustRebuild = true;
    }
    // Remaining children must be collected and rebuilt into the appropriate structure
    if (mustRebuild) {
        let decorations = $b5c91c309b2647a1$var$mapAndGatherRemainingDecorations(children, oldChildren, newLocal, mapping, offset, oldOffset, options);
        let built = $b5c91c309b2647a1$var$buildTree(decorations, node, 0, options);
        newLocal = built.local;
        for(let i = 0; i < children.length; i += 3)if (children[i + 1] < 0) {
            children.splice(i, 3);
            i -= 3;
        }
        for(let i = 0, j = 0; i < built.children.length; i += 3){
            let from = built.children[i];
            while(j < children.length && children[j] < from)j += 3;
            children.splice(j, 0, built.children[i], built.children[i + 1], built.children[i + 2]);
        }
    }
    return new $b5c91c309b2647a1$export$93bf62eb445cec98(newLocal.sort($b5c91c309b2647a1$var$byPos), children);
}
function $b5c91c309b2647a1$var$moveSpans(spans, offset) {
    if (!offset || !spans.length) return spans;
    let result = [];
    for(let i = 0; i < spans.length; i++){
        let span = spans[i];
        result.push(new $b5c91c309b2647a1$export$10e30b733df217ea(span.from + offset, span.to + offset, span.type));
    }
    return result;
}
function $b5c91c309b2647a1$var$mapAndGatherRemainingDecorations(children, oldChildren, decorations, mapping, offset, oldOffset, options) {
    // Gather all decorations from the remaining marked children
    function gather(set, oldOffset) {
        for(let i = 0; i < set.local.length; i++){
            let mapped = set.local[i].map(mapping, offset, oldOffset);
            if (mapped) decorations.push(mapped);
            else if (options.onRemove) options.onRemove(set.local[i].spec);
        }
        for(let i = 0; i < set.children.length; i += 3)gather(set.children[i + 2], set.children[i] + oldOffset + 1);
    }
    for(let i = 0; i < children.length; i += 3)if (children[i + 1] == -1) gather(children[i + 2], oldChildren[i] + oldOffset + 1);
    return decorations;
}
function $b5c91c309b2647a1$var$takeSpansForNode(spans, node, offset) {
    if (node.isLeaf) return null;
    let end = offset + node.nodeSize, found = null;
    for(let i = 0, span; i < spans.length; i++)if ((span = spans[i]) && span.from > offset && span.to < end) {
        (found || (found = [])).push(span);
        spans[i] = null;
    }
    return found;
}
function $b5c91c309b2647a1$var$withoutNulls(array) {
    let result = [];
    for(let i = 0; i < array.length; i++)if (array[i] != null) result.push(array[i]);
    return result;
}
// Build up a tree that corresponds to a set of decorations. `offset`
// is a base offset that should be subtracted from the `from` and `to`
// positions in the spans (so that we don't have to allocate new spans
// for recursive calls).
function $b5c91c309b2647a1$var$buildTree(spans, node, offset, options) {
    let children = [], hasNulls = false;
    node.forEach((childNode, localStart)=>{
        let found = $b5c91c309b2647a1$var$takeSpansForNode(spans, childNode, localStart + offset);
        if (found) {
            hasNulls = true;
            let subtree = $b5c91c309b2647a1$var$buildTree(found, childNode, offset + localStart + 1, options);
            if (subtree != $b5c91c309b2647a1$var$empty) children.push(localStart, localStart + childNode.nodeSize, subtree);
        }
    });
    let locals = $b5c91c309b2647a1$var$moveSpans(hasNulls ? $b5c91c309b2647a1$var$withoutNulls(spans) : spans, -offset).sort($b5c91c309b2647a1$var$byPos);
    for(let i = 0; i < locals.length; i++)if (!locals[i].type.valid(node, locals[i])) {
        if (options.onRemove) options.onRemove(locals[i].spec);
        locals.splice(i--, 1);
    }
    return locals.length || children.length ? new $b5c91c309b2647a1$export$93bf62eb445cec98(locals, children) : $b5c91c309b2647a1$var$empty;
}
// Used to sort decorations so that ones with a low start position
// come first, and within a set with the same start position, those
// with an smaller end position come first.
function $b5c91c309b2647a1$var$byPos(a, b) {
    return a.from - b.from || a.to - b.to;
}
// Scan a sorted array of decorations for partially overlapping spans,
// and split those so that only fully overlapping spans are left (to
// make subsequent rendering easier). Will return the input array if
// no partially overlapping spans are found (the common case).
function $b5c91c309b2647a1$var$removeOverlap(spans) {
    let working = spans;
    for(let i = 0; i < working.length - 1; i++){
        let span = working[i];
        if (span.from != span.to) for(let j = i + 1; j < working.length; j++){
            let next = working[j];
            if (next.from == span.from) {
                if (next.to != span.to) {
                    if (working == spans) working = spans.slice();
                    // Followed by a partially overlapping larger span. Split that
                    // span.
                    working[j] = next.copy(next.from, span.to);
                    $b5c91c309b2647a1$var$insertAhead(working, j + 1, next.copy(span.to, next.to));
                }
                continue;
            } else {
                if (next.from < span.to) {
                    if (working == spans) working = spans.slice();
                    // The end of this one overlaps with a subsequent span. Split
                    // this one.
                    working[i] = span.copy(span.from, next.from);
                    $b5c91c309b2647a1$var$insertAhead(working, j, span.copy(next.from, span.to));
                }
                break;
            }
        }
    }
    return working;
}
function $b5c91c309b2647a1$var$insertAhead(array, i, deco) {
    while(i < array.length && $b5c91c309b2647a1$var$byPos(deco, array[i]) > 0)i++;
    array.splice(i, 0, deco);
}
// Get the decorations associated with the current props of a view.
function $b5c91c309b2647a1$var$viewDecorations(view) {
    let found = [];
    view.someProp("decorations", (f)=>{
        let result = f(view.state);
        if (result && result != $b5c91c309b2647a1$var$empty) found.push(result);
    });
    if (view.cursorWrapper) found.push($b5c91c309b2647a1$export$93bf62eb445cec98.create(view.state.doc, [
        view.cursorWrapper.deco
    ]));
    return $b5c91c309b2647a1$var$DecorationGroup.from(found);
}
const $b5c91c309b2647a1$var$observeOptions = {
    childList: true,
    characterData: true,
    characterDataOldValue: true,
    attributes: true,
    attributeOldValue: true,
    subtree: true
};
// IE11 has very broken mutation observers, so we also listen to DOMCharacterDataModified
const $b5c91c309b2647a1$var$useCharData = $b5c91c309b2647a1$var$ie && $b5c91c309b2647a1$var$ie_version <= 11;
class $b5c91c309b2647a1$var$SelectionState {
    constructor(){
        this.anchorNode = null;
        this.anchorOffset = 0;
        this.focusNode = null;
        this.focusOffset = 0;
    }
    set(sel) {
        this.anchorNode = sel.anchorNode;
        this.anchorOffset = sel.anchorOffset;
        this.focusNode = sel.focusNode;
        this.focusOffset = sel.focusOffset;
    }
    clear() {
        this.anchorNode = this.focusNode = null;
    }
    eq(sel) {
        return sel.anchorNode == this.anchorNode && sel.anchorOffset == this.anchorOffset && sel.focusNode == this.focusNode && sel.focusOffset == this.focusOffset;
    }
}
class $b5c91c309b2647a1$var$DOMObserver {
    constructor(view, handleDOMChange){
        this.view = view;
        this.handleDOMChange = handleDOMChange;
        this.queue = [];
        this.flushingSoon = -1;
        this.observer = null;
        this.currentSelection = new $b5c91c309b2647a1$var$SelectionState;
        this.onCharData = null;
        this.suppressingSelectionUpdates = false;
        this.observer = window.MutationObserver && new window.MutationObserver((mutations)=>{
            for(let i = 0; i < mutations.length; i++)this.queue.push(mutations[i]);
            // IE11 will sometimes (on backspacing out a single character
            // text node after a BR node) call the observer callback
            // before actually updating the DOM, which will cause
            // ProseMirror to miss the change (see #930)
            if ($b5c91c309b2647a1$var$ie && $b5c91c309b2647a1$var$ie_version <= 11 && mutations.some((m)=>m.type == "childList" && m.removedNodes.length || m.type == "characterData" && m.oldValue.length > m.target.nodeValue.length)) this.flushSoon();
            else this.flush();
        });
        if ($b5c91c309b2647a1$var$useCharData) this.onCharData = (e)=>{
            this.queue.push({
                target: e.target,
                type: "characterData",
                oldValue: e.prevValue
            });
            this.flushSoon();
        };
        this.onSelectionChange = this.onSelectionChange.bind(this);
    }
    flushSoon() {
        if (this.flushingSoon < 0) this.flushingSoon = window.setTimeout(()=>{
            this.flushingSoon = -1;
            this.flush();
        }, 20);
    }
    forceFlush() {
        if (this.flushingSoon > -1) {
            window.clearTimeout(this.flushingSoon);
            this.flushingSoon = -1;
            this.flush();
        }
    }
    start() {
        if (this.observer) {
            this.observer.takeRecords();
            this.observer.observe(this.view.dom, $b5c91c309b2647a1$var$observeOptions);
        }
        if (this.onCharData) this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData);
        this.connectSelection();
    }
    stop() {
        if (this.observer) {
            let take = this.observer.takeRecords();
            if (take.length) {
                for(let i = 0; i < take.length; i++)this.queue.push(take[i]);
                window.setTimeout(()=>this.flush(), 20);
            }
            this.observer.disconnect();
        }
        if (this.onCharData) this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData);
        this.disconnectSelection();
    }
    connectSelection() {
        this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
    }
    disconnectSelection() {
        this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
    }
    suppressSelectionUpdates() {
        this.suppressingSelectionUpdates = true;
        setTimeout(()=>this.suppressingSelectionUpdates = false, 50);
    }
    onSelectionChange() {
        if (!$b5c91c309b2647a1$var$hasFocusAndSelection(this.view)) return;
        if (this.suppressingSelectionUpdates) return $b5c91c309b2647a1$var$selectionToDOM(this.view);
        // Deletions on IE11 fire their events in the wrong order, giving
        // us a selection change event before the DOM changes are
        // reported.
        if ($b5c91c309b2647a1$var$ie && $b5c91c309b2647a1$var$ie_version <= 11 && !this.view.state.selection.empty) {
            let sel = this.view.domSelectionRange();
            // Selection.isCollapsed isn't reliable on IE
            if (sel.focusNode && $b5c91c309b2647a1$var$isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset)) return this.flushSoon();
        }
        this.flush();
    }
    setCurSelection() {
        this.currentSelection.set(this.view.domSelectionRange());
    }
    ignoreSelectionChange(sel) {
        if (!sel.focusNode) return true;
        let ancestors = new Set, container;
        for(let scan = sel.focusNode; scan; scan = $b5c91c309b2647a1$var$parentNode(scan))ancestors.add(scan);
        for(let scan = sel.anchorNode; scan; scan = $b5c91c309b2647a1$var$parentNode(scan))if (ancestors.has(scan)) {
            container = scan;
            break;
        }
        let desc = container && this.view.docView.nearestDesc(container);
        if (desc && desc.ignoreMutation({
            type: "selection",
            target: container.nodeType == 3 ? container.parentNode : container
        })) {
            this.setCurSelection();
            return true;
        }
    }
    pendingRecords() {
        if (this.observer) for (let mut of this.observer.takeRecords())this.queue.push(mut);
        return this.queue;
    }
    flush() {
        let { view: view } = this;
        if (!view.docView || this.flushingSoon > -1) return;
        let mutations = this.pendingRecords();
        if (mutations.length) this.queue = [];
        let sel = view.domSelectionRange();
        let newSel = !this.suppressingSelectionUpdates && !this.currentSelection.eq(sel) && $b5c91c309b2647a1$var$hasFocusAndSelection(view) && !this.ignoreSelectionChange(sel);
        let from = -1, to = -1, typeOver = false, added = [];
        if (view.editable) for(let i = 0; i < mutations.length; i++){
            let result = this.registerMutation(mutations[i], added);
            if (result) {
                from = from < 0 ? result.from : Math.min(result.from, from);
                to = to < 0 ? result.to : Math.max(result.to, to);
                if (result.typeOver) typeOver = true;
            }
        }
        if ($b5c91c309b2647a1$var$gecko && added.length > 1) {
            let brs = added.filter((n)=>n.nodeName == "BR");
            if (brs.length == 2) {
                let a = brs[0], b = brs[1];
                if (a.parentNode && a.parentNode.parentNode == b.parentNode) b.remove();
                else a.remove();
            }
        }
        let readSel = null;
        // If it looks like the browser has reset the selection to the
        // start of the document after focus, restore the selection from
        // the state
        if (from < 0 && newSel && view.input.lastFocus > Date.now() - 200 && Math.max(view.input.lastTouch, view.input.lastClick.time) < Date.now() - 300 && $b5c91c309b2647a1$var$selectionCollapsed(sel) && (readSel = $b5c91c309b2647a1$var$selectionFromDOM(view)) && readSel.eq((0, $kpTIW.Selection).near(view.state.doc.resolve(0), 1))) {
            view.input.lastFocus = 0;
            $b5c91c309b2647a1$var$selectionToDOM(view);
            this.currentSelection.set(sel);
            view.scrollToSelection();
        } else if (from > -1 || newSel) {
            if (from > -1) {
                view.docView.markDirty(from, to);
                $b5c91c309b2647a1$var$checkCSS(view);
            }
            this.handleDOMChange(from, to, typeOver, added);
            if (view.docView && view.docView.dirty) view.updateState(view.state);
            else if (!this.currentSelection.eq(sel)) $b5c91c309b2647a1$var$selectionToDOM(view);
            this.currentSelection.set(sel);
        }
    }
    registerMutation(mut, added) {
        // Ignore mutations inside nodes that were already noted as inserted
        if (added.indexOf(mut.target) > -1) return null;
        let desc = this.view.docView.nearestDesc(mut.target);
        if (mut.type == "attributes" && (desc == this.view.docView || mut.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
        mut.attributeName == "style" && !mut.oldValue && !mut.target.getAttribute("style"))) return null;
        if (!desc || desc.ignoreMutation(mut)) return null;
        if (mut.type == "childList") {
            for(let i = 0; i < mut.addedNodes.length; i++)added.push(mut.addedNodes[i]);
            if (desc.contentDOM && desc.contentDOM != desc.dom && !desc.contentDOM.contains(mut.target)) return {
                from: desc.posBefore,
                to: desc.posAfter
            };
            let prev = mut.previousSibling, next = mut.nextSibling;
            if ($b5c91c309b2647a1$var$ie && $b5c91c309b2647a1$var$ie_version <= 11 && mut.addedNodes.length) // IE11 gives us incorrect next/prev siblings for some
            // insertions, so if there are added nodes, recompute those
            for(let i = 0; i < mut.addedNodes.length; i++){
                let { previousSibling: previousSibling, nextSibling: nextSibling } = mut.addedNodes[i];
                if (!previousSibling || Array.prototype.indexOf.call(mut.addedNodes, previousSibling) < 0) prev = previousSibling;
                if (!nextSibling || Array.prototype.indexOf.call(mut.addedNodes, nextSibling) < 0) next = nextSibling;
            }
            let fromOffset = prev && prev.parentNode == mut.target ? $b5c91c309b2647a1$var$domIndex(prev) + 1 : 0;
            let from = desc.localPosFromDOM(mut.target, fromOffset, -1);
            let toOffset = next && next.parentNode == mut.target ? $b5c91c309b2647a1$var$domIndex(next) : mut.target.childNodes.length;
            let to = desc.localPosFromDOM(mut.target, toOffset, 1);
            return {
                from: from,
                to: to
            };
        } else if (mut.type == "attributes") return {
            from: desc.posAtStart - desc.border,
            to: desc.posAtEnd + desc.border
        };
        else return {
            from: desc.posAtStart,
            to: desc.posAtEnd,
            // An event was generated for a text change that didn't change
            // any text. Mark the dom change to fall back to assuming the
            // selection was typed over with an identical value if it can't
            // find another change.
            typeOver: mut.target.nodeValue == mut.oldValue
        };
    }
}
let $b5c91c309b2647a1$var$cssChecked = new WeakMap();
let $b5c91c309b2647a1$var$cssCheckWarned = false;
function $b5c91c309b2647a1$var$checkCSS(view) {
    if ($b5c91c309b2647a1$var$cssChecked.has(view)) return;
    $b5c91c309b2647a1$var$cssChecked.set(view, null);
    if ([
        'normal',
        'nowrap',
        'pre-line'
    ].indexOf(getComputedStyle(view.dom).whiteSpace) !== -1) {
        view.requiresGeckoHackNode = $b5c91c309b2647a1$var$gecko;
        if ($b5c91c309b2647a1$var$cssCheckWarned) return;
        console["warn"]("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package.");
        $b5c91c309b2647a1$var$cssCheckWarned = true;
    }
}
function $b5c91c309b2647a1$var$rangeToSelectionRange(view, range) {
    let anchorNode = range.startContainer, anchorOffset = range.startOffset;
    let focusNode = range.endContainer, focusOffset = range.endOffset;
    let currentAnchor = view.domAtPos(view.state.selection.anchor);
    // Since such a range doesn't distinguish between anchor and head,
    // use a heuristic that flips it around if its end matches the
    // current anchor.
    if ($b5c91c309b2647a1$var$isEquivalentPosition(currentAnchor.node, currentAnchor.offset, focusNode, focusOffset)) [anchorNode, anchorOffset, focusNode, focusOffset] = [
        focusNode,
        focusOffset,
        anchorNode,
        anchorOffset
    ];
    return {
        anchorNode: anchorNode,
        anchorOffset: anchorOffset,
        focusNode: focusNode,
        focusOffset: focusOffset
    };
}
// Used to work around a Safari Selection/shadow DOM bug
// Based on https://github.com/codemirror/dev/issues/414 fix
function $b5c91c309b2647a1$var$safariShadowSelectionRange(view, selection) {
    if (selection.getComposedRanges) {
        let range = selection.getComposedRanges(view.root)[0];
        if (range) return $b5c91c309b2647a1$var$rangeToSelectionRange(view, range);
    }
    let found;
    function read(event) {
        event.preventDefault();
        event.stopImmediatePropagation();
        found = event.getTargetRanges()[0];
    }
    // Because Safari (at least in 2018-2022) doesn't provide regular
    // access to the selection inside a shadowRoot, we have to perform a
    // ridiculous hack to get at it—using `execCommand` to trigger a
    // `beforeInput` event so that we can read the target range from the
    // event.
    view.dom.addEventListener("beforeinput", read, true);
    document.execCommand("indent");
    view.dom.removeEventListener("beforeinput", read, true);
    return found ? $b5c91c309b2647a1$var$rangeToSelectionRange(view, found) : null;
}
// Note that all referencing and parsing is done with the
// start-of-operation selection and document, since that's the one
// that the DOM represents. If any changes came in in the meantime,
// the modification is mapped over those before it is applied, in
// readDOMChange.
function $b5c91c309b2647a1$var$parseBetween(view, from_, to_) {
    let { node: parent, fromOffset: fromOffset, toOffset: toOffset, from: from, to: to } = view.docView.parseRange(from_, to_);
    let domSel = view.domSelectionRange();
    let find;
    let anchor = domSel.anchorNode;
    if (anchor && view.dom.contains(anchor.nodeType == 1 ? anchor : anchor.parentNode)) {
        find = [
            {
                node: anchor,
                offset: domSel.anchorOffset
            }
        ];
        if (!$b5c91c309b2647a1$var$selectionCollapsed(domSel)) find.push({
            node: domSel.focusNode,
            offset: domSel.focusOffset
        });
    }
    // Work around issue in Chrome where backspacing sometimes replaces
    // the deleted content with a random BR node (issues #799, #831)
    if ($b5c91c309b2647a1$var$chrome && view.input.lastKeyCode === 8) for(let off = toOffset; off > fromOffset; off--){
        let node = parent.childNodes[off - 1], desc = node.pmViewDesc;
        if (node.nodeName == "BR" && !desc) {
            toOffset = off;
            break;
        }
        if (!desc || desc.size) break;
    }
    let startDoc = view.state.doc;
    let parser = view.someProp("domParser") || (0, $7dkLM.DOMParser).fromSchema(view.state.schema);
    let $from = startDoc.resolve(from);
    let sel = null, doc = parser.parse(parent, {
        topNode: $from.parent,
        topMatch: $from.parent.contentMatchAt($from.index()),
        topOpen: true,
        from: fromOffset,
        to: toOffset,
        preserveWhitespace: $from.parent.type.whitespace == "pre" ? "full" : true,
        findPositions: find,
        ruleFromNode: $b5c91c309b2647a1$var$ruleFromNode,
        context: $from
    });
    if (find && find[0].pos != null) {
        let anchor = find[0].pos, head = find[1] && find[1].pos;
        if (head == null) head = anchor;
        sel = {
            anchor: anchor + from,
            head: head + from
        };
    }
    return {
        doc: doc,
        sel: sel,
        from: from,
        to: to
    };
}
function $b5c91c309b2647a1$var$ruleFromNode(dom) {
    let desc = dom.pmViewDesc;
    if (desc) return desc.parseRule();
    else if (dom.nodeName == "BR" && dom.parentNode) {
        // Safari replaces the list item or table cell with a BR
        // directly in the list node (?!) if you delete the last
        // character in a list item or table cell (#708, #862)
        if ($b5c91c309b2647a1$var$safari && /^(ul|ol)$/i.test(dom.parentNode.nodeName)) {
            let skip = document.createElement("div");
            skip.appendChild(document.createElement("li"));
            return {
                skip: skip
            };
        } else if (dom.parentNode.lastChild == dom || $b5c91c309b2647a1$var$safari && /^(tr|table)$/i.test(dom.parentNode.nodeName)) return {
            ignore: true
        };
    } else if (dom.nodeName == "IMG" && dom.getAttribute("mark-placeholder")) return {
        ignore: true
    };
    return null;
}
const $b5c91c309b2647a1$var$isInline = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function $b5c91c309b2647a1$var$readDOMChange(view, from, to, typeOver, addedNodes) {
    let compositionID = view.input.compositionPendingChanges || (view.composing ? view.input.compositionID : 0);
    view.input.compositionPendingChanges = 0;
    if (from < 0) {
        let origin = view.input.lastSelectionTime > Date.now() - 50 ? view.input.lastSelectionOrigin : null;
        let newSel = $b5c91c309b2647a1$var$selectionFromDOM(view, origin);
        if (newSel && !view.state.selection.eq(newSel)) {
            if ($b5c91c309b2647a1$var$chrome && $b5c91c309b2647a1$var$android && view.input.lastKeyCode === 13 && Date.now() - 100 < view.input.lastKeyCodeTime && view.someProp("handleKeyDown", (f)=>f(view, $b5c91c309b2647a1$var$keyEvent(13, "Enter")))) return;
            let tr = view.state.tr.setSelection(newSel);
            if (origin == "pointer") tr.setMeta("pointer", true);
            else if (origin == "key") tr.scrollIntoView();
            if (compositionID) tr.setMeta("composition", compositionID);
            view.dispatch(tr);
        }
        return;
    }
    let $before = view.state.doc.resolve(from);
    let shared = $before.sharedDepth(to);
    from = $before.before(shared + 1);
    to = view.state.doc.resolve(to).after(shared + 1);
    let sel = view.state.selection;
    let parse = $b5c91c309b2647a1$var$parseBetween(view, from, to);
    let doc = view.state.doc, compare = doc.slice(parse.from, parse.to);
    let preferredPos, preferredSide;
    // Prefer anchoring to end when Backspace is pressed
    if (view.input.lastKeyCode === 8 && Date.now() - 100 < view.input.lastKeyCodeTime) {
        preferredPos = view.state.selection.to;
        preferredSide = "end";
    } else {
        preferredPos = view.state.selection.from;
        preferredSide = "start";
    }
    view.input.lastKeyCode = null;
    let change = $b5c91c309b2647a1$var$findDiff(compare.content, parse.doc.content, parse.from, preferredPos, preferredSide);
    if (($b5c91c309b2647a1$var$ios && view.input.lastIOSEnter > Date.now() - 225 || $b5c91c309b2647a1$var$android) && addedNodes.some((n)=>n.nodeType == 1 && !$b5c91c309b2647a1$var$isInline.test(n.nodeName)) && (!change || change.endA >= change.endB) && view.someProp("handleKeyDown", (f)=>f(view, $b5c91c309b2647a1$var$keyEvent(13, "Enter")))) {
        view.input.lastIOSEnter = 0;
        return;
    }
    if (!change) {
        if (typeOver && sel instanceof (0, $kpTIW.TextSelection) && !sel.empty && sel.$head.sameParent(sel.$anchor) && !view.composing && !(parse.sel && parse.sel.anchor != parse.sel.head)) change = {
            start: sel.from,
            endA: sel.to,
            endB: sel.to
        };
        else {
            if (parse.sel) {
                let sel = $b5c91c309b2647a1$var$resolveSelection(view, view.state.doc, parse.sel);
                if (sel && !sel.eq(view.state.selection)) {
                    let tr = view.state.tr.setSelection(sel);
                    if (compositionID) tr.setMeta("composition", compositionID);
                    view.dispatch(tr);
                }
            }
            return;
        }
    }
    view.input.domChangeCount++;
    // Handle the case where overwriting a selection by typing matches
    // the start or end of the selected content, creating a change
    // that's smaller than what was actually overwritten.
    if (view.state.selection.from < view.state.selection.to && change.start == change.endB && view.state.selection instanceof (0, $kpTIW.TextSelection)) {
        if (change.start > view.state.selection.from && change.start <= view.state.selection.from + 2 && view.state.selection.from >= parse.from) change.start = view.state.selection.from;
        else if (change.endA < view.state.selection.to && change.endA >= view.state.selection.to - 2 && view.state.selection.to <= parse.to) {
            change.endB += view.state.selection.to - change.endA;
            change.endA = view.state.selection.to;
        }
    }
    // IE11 will insert a non-breaking space _ahead_ of the space after
    // the cursor space when adding a space before another space. When
    // that happened, adjust the change to cover the space instead.
    if ($b5c91c309b2647a1$var$ie && $b5c91c309b2647a1$var$ie_version <= 11 && change.endB == change.start + 1 && change.endA == change.start && change.start > parse.from && parse.doc.textBetween(change.start - parse.from - 1, change.start - parse.from + 1) == " \u00a0") {
        change.start--;
        change.endA--;
        change.endB--;
    }
    let $from = parse.doc.resolveNoCache(change.start - parse.from);
    let $to = parse.doc.resolveNoCache(change.endB - parse.from);
    let $fromA = doc.resolve(change.start);
    let inlineChange = $from.sameParent($to) && $from.parent.inlineContent && $fromA.end() >= change.endA;
    let nextSel;
    // If this looks like the effect of pressing Enter (or was recorded
    // as being an iOS enter press), just dispatch an Enter key instead.
    if (($b5c91c309b2647a1$var$ios && view.input.lastIOSEnter > Date.now() - 225 && (!inlineChange || addedNodes.some((n)=>n.nodeName == "DIV" || n.nodeName == "P")) || !inlineChange && $from.pos < parse.doc.content.size && !$from.sameParent($to) && (nextSel = (0, $kpTIW.Selection).findFrom(parse.doc.resolve($from.pos + 1), 1, true)) && nextSel.head == $to.pos) && view.someProp("handleKeyDown", (f)=>f(view, $b5c91c309b2647a1$var$keyEvent(13, "Enter")))) {
        view.input.lastIOSEnter = 0;
        return;
    }
    // Same for backspace
    if (view.state.selection.anchor > change.start && $b5c91c309b2647a1$var$looksLikeBackspace(doc, change.start, change.endA, $from, $to) && view.someProp("handleKeyDown", (f)=>f(view, $b5c91c309b2647a1$var$keyEvent(8, "Backspace")))) {
        if ($b5c91c309b2647a1$var$android && $b5c91c309b2647a1$var$chrome) view.domObserver.suppressSelectionUpdates(); // #820
        return;
    }
    // Chrome Android will occasionally, during composition, delete the
    // entire composition and then immediately insert it again. This is
    // used to detect that situation.
    if ($b5c91c309b2647a1$var$chrome && $b5c91c309b2647a1$var$android && change.endB == change.start) view.input.lastAndroidDelete = Date.now();
    // This tries to detect Android virtual keyboard
    // enter-and-pick-suggestion action. That sometimes (see issue
    // #1059) first fires a DOM mutation, before moving the selection to
    // the newly created block. And then, because ProseMirror cleans up
    // the DOM selection, it gives up moving the selection entirely,
    // leaving the cursor in the wrong place. When that happens, we drop
    // the new paragraph from the initial change, and fire a simulated
    // enter key afterwards.
    if ($b5c91c309b2647a1$var$android && !inlineChange && $from.start() != $to.start() && $to.parentOffset == 0 && $from.depth == $to.depth && parse.sel && parse.sel.anchor == parse.sel.head && parse.sel.head == change.endA) {
        change.endB -= 2;
        $to = parse.doc.resolveNoCache(change.endB - parse.from);
        setTimeout(()=>{
            view.someProp("handleKeyDown", function(f) {
                return f(view, $b5c91c309b2647a1$var$keyEvent(13, "Enter"));
            });
        }, 20);
    }
    let chFrom = change.start, chTo = change.endA;
    let tr, storedMarks, markChange;
    if (inlineChange) {
        if ($from.pos == $to.pos) {
            // IE11 sometimes weirdly moves the DOM selection around after
            // backspacing out the first element in a textblock
            if ($b5c91c309b2647a1$var$ie && $b5c91c309b2647a1$var$ie_version <= 11 && $from.parentOffset == 0) {
                view.domObserver.suppressSelectionUpdates();
                setTimeout(()=>$b5c91c309b2647a1$var$selectionToDOM(view), 20);
            }
            tr = view.state.tr.delete(chFrom, chTo);
            storedMarks = doc.resolve(change.start).marksAcross(doc.resolve(change.endA));
        } else if (change.endA == change.endB && (markChange = $b5c91c309b2647a1$var$isMarkChange($from.parent.content.cut($from.parentOffset, $to.parentOffset), $fromA.parent.content.cut($fromA.parentOffset, change.endA - $fromA.start())))) {
            tr = view.state.tr;
            if (markChange.type == "add") tr.addMark(chFrom, chTo, markChange.mark);
            else tr.removeMark(chFrom, chTo, markChange.mark);
        } else if ($from.parent.child($from.index()).isText && $from.index() == $to.index() - ($to.textOffset ? 0 : 1)) {
            // Both positions in the same text node -- simply insert text
            let text = $from.parent.textBetween($from.parentOffset, $to.parentOffset);
            if (view.someProp("handleTextInput", (f)=>f(view, chFrom, chTo, text))) return;
            tr = view.state.tr.insertText(text, chFrom, chTo);
        }
    }
    if (!tr) tr = view.state.tr.replace(chFrom, chTo, parse.doc.slice(change.start - parse.from, change.endB - parse.from));
    if (parse.sel) {
        let sel = $b5c91c309b2647a1$var$resolveSelection(view, tr.doc, parse.sel);
        // Chrome Android will sometimes, during composition, report the
        // selection in the wrong place. If it looks like that is
        // happening, don't update the selection.
        // Edge just doesn't move the cursor forward when you start typing
        // in an empty block or between br nodes.
        if (sel && !($b5c91c309b2647a1$var$chrome && $b5c91c309b2647a1$var$android && view.composing && sel.empty && (change.start != change.endB || view.input.lastAndroidDelete < Date.now() - 100) && (sel.head == chFrom || sel.head == tr.mapping.map(chTo) - 1) || $b5c91c309b2647a1$var$ie && sel.empty && sel.head == chFrom)) tr.setSelection(sel);
    }
    if (storedMarks) tr.ensureMarks(storedMarks);
    if (compositionID) tr.setMeta("composition", compositionID);
    view.dispatch(tr.scrollIntoView());
}
function $b5c91c309b2647a1$var$resolveSelection(view, doc, parsedSel) {
    if (Math.max(parsedSel.anchor, parsedSel.head) > doc.content.size) return null;
    return $b5c91c309b2647a1$var$selectionBetween(view, doc.resolve(parsedSel.anchor), doc.resolve(parsedSel.head));
}
// Given two same-length, non-empty fragments of inline content,
// determine whether the first could be created from the second by
// removing or adding a single mark type.
function $b5c91c309b2647a1$var$isMarkChange(cur, prev) {
    let curMarks = cur.firstChild.marks, prevMarks = prev.firstChild.marks;
    let added = curMarks, removed = prevMarks, type, mark, update;
    for(let i = 0; i < prevMarks.length; i++)added = prevMarks[i].removeFromSet(added);
    for(let i = 0; i < curMarks.length; i++)removed = curMarks[i].removeFromSet(removed);
    if (added.length == 1 && removed.length == 0) {
        mark = added[0];
        type = "add";
        update = (node)=>node.mark(mark.addToSet(node.marks));
    } else if (added.length == 0 && removed.length == 1) {
        mark = removed[0];
        type = "remove";
        update = (node)=>node.mark(mark.removeFromSet(node.marks));
    } else return null;
    let updated = [];
    for(let i = 0; i < prev.childCount; i++)updated.push(update(prev.child(i)));
    if ((0, $7dkLM.Fragment).from(updated).eq(cur)) return {
        mark: mark,
        type: type
    };
}
function $b5c91c309b2647a1$var$looksLikeBackspace(old, start, end, $newStart, $newEnd) {
    if (end - start <= $newEnd.pos - $newStart.pos || // newEnd must point directly at or after the end of the block that newStart points into
    $b5c91c309b2647a1$var$skipClosingAndOpening($newStart, true, false) < $newEnd.pos) return false;
    let $start = old.resolve(start);
    // Handle the case where, rather than joining blocks, the change just removed an entire block
    if (!$newStart.parent.isTextblock) {
        let after = $start.nodeAfter;
        return after != null && end == start + after.nodeSize;
    }
    // Start must be at the end of a block
    if ($start.parentOffset < $start.parent.content.size || !$start.parent.isTextblock) return false;
    let $next = old.resolve($b5c91c309b2647a1$var$skipClosingAndOpening($start, true, true));
    // The next textblock must start before end and end near it
    if (!$next.parent.isTextblock || $next.pos > end || $b5c91c309b2647a1$var$skipClosingAndOpening($next, true, false) < end) return false;
    // The fragments after the join point must match
    return $newStart.parent.content.cut($newStart.parentOffset).eq($next.parent.content);
}
function $b5c91c309b2647a1$var$skipClosingAndOpening($pos, fromEnd, mayOpen) {
    let depth = $pos.depth, end = fromEnd ? $pos.end() : $pos.pos;
    while(depth > 0 && (fromEnd || $pos.indexAfter(depth) == $pos.node(depth).childCount)){
        depth--;
        end++;
        fromEnd = false;
    }
    if (mayOpen) {
        let next = $pos.node(depth).maybeChild($pos.indexAfter(depth));
        while(next && !next.isLeaf){
            next = next.firstChild;
            end++;
        }
    }
    return end;
}
function $b5c91c309b2647a1$var$findDiff(a, b, pos, preferredPos, preferredSide) {
    let start = a.findDiffStart(b, pos);
    if (start == null) return null;
    let { a: endA, b: endB } = a.findDiffEnd(b, pos + a.size, pos + b.size);
    if (preferredSide == "end") {
        let adjust = Math.max(0, start - Math.min(endA, endB));
        preferredPos -= endA + adjust - start;
    }
    if (endA < start && a.size < b.size) {
        let move = preferredPos <= start && preferredPos >= endA ? start - preferredPos : 0;
        start -= move;
        if (start && start < b.size && $b5c91c309b2647a1$var$isSurrogatePair(b.textBetween(start - 1, start + 1))) start += move ? 1 : -1;
        endB = start + (endB - endA);
        endA = start;
    } else if (endB < start) {
        let move = preferredPos <= start && preferredPos >= endB ? start - preferredPos : 0;
        start -= move;
        if (start && start < a.size && $b5c91c309b2647a1$var$isSurrogatePair(a.textBetween(start - 1, start + 1))) start += move ? 1 : -1;
        endA = start + (endA - endB);
        endB = start;
    }
    return {
        start: start,
        endA: endA,
        endB: endB
    };
}
function $b5c91c309b2647a1$var$isSurrogatePair(str) {
    if (str.length != 2) return false;
    let a = str.charCodeAt(0), b = str.charCodeAt(1);
    return a >= 0xDC00 && a <= 0xDFFF && b >= 0xD800 && b <= 0xDBFF;
}
/**
@internal
*/ const $b5c91c309b2647a1$export$38b79e3fdcfcfd68 = $b5c91c309b2647a1$var$serializeForClipboard;
/**
@internal
*/ const $b5c91c309b2647a1$export$5d42ca91c11c9e4d = $b5c91c309b2647a1$var$parseFromClipboard;
/**
@internal
*/ const $b5c91c309b2647a1$export$76b14d3c719c32fc = $b5c91c309b2647a1$var$endComposition;
/**
An editor view manages the DOM structure that represents an
editable document. Its state and behavior are determined by its
[props](https://prosemirror.net/docs/ref/#view.DirectEditorProps).
*/ class $b5c91c309b2647a1$export$eece2fccabbb77c5 {
    /**
    Create a view. `place` may be a DOM node that the editor should
    be appended to, a function that will place it into the document,
    or an object whose `mount` property holds the node to use as the
    document container. If it is `null`, the editor will not be
    added to the document.
    */ constructor(place, props){
        this._root = null;
        /**
        @internal
        */ this.focused = false;
        /**
        Kludge used to work around a Chrome bug @internal
        */ this.trackWrites = null;
        this.mounted = false;
        /**
        @internal
        */ this.markCursor = null;
        /**
        @internal
        */ this.cursorWrapper = null;
        /**
        @internal
        */ this.lastSelectedViewDesc = undefined;
        /**
        @internal
        */ this.input = new $b5c91c309b2647a1$var$InputState;
        this.prevDirectPlugins = [];
        this.pluginViews = [];
        /**
        Holds `true` when a hack node is needed in Firefox to prevent the
        [space is eaten issue](https://github.com/ProseMirror/prosemirror/issues/651)
        @internal
        */ this.requiresGeckoHackNode = false;
        /**
        When editor content is being dragged, this object contains
        information about the dragged slice and whether it is being
        copied or moved. At any other time, it is null.
        */ this.dragging = null;
        this._props = props;
        this.state = props.state;
        this.directPlugins = props.plugins || [];
        this.directPlugins.forEach($b5c91c309b2647a1$var$checkStateComponent);
        this.dispatch = this.dispatch.bind(this);
        this.dom = place && place.mount || document.createElement("div");
        if (place) {
            if (place.appendChild) place.appendChild(this.dom);
            else if (typeof place == "function") place(this.dom);
            else if (place.mount) this.mounted = true;
        }
        this.editable = $b5c91c309b2647a1$var$getEditable(this);
        $b5c91c309b2647a1$var$updateCursorWrapper(this);
        this.nodeViews = $b5c91c309b2647a1$var$buildNodeViews(this);
        this.docView = $b5c91c309b2647a1$var$docViewDesc(this.state.doc, $b5c91c309b2647a1$var$computeDocDeco(this), $b5c91c309b2647a1$var$viewDecorations(this), this.dom, this);
        this.domObserver = new $b5c91c309b2647a1$var$DOMObserver(this, (from, to, typeOver, added)=>$b5c91c309b2647a1$var$readDOMChange(this, from, to, typeOver, added));
        this.domObserver.start();
        $b5c91c309b2647a1$var$initInput(this);
        this.updatePluginViews();
    }
    /**
    Holds `true` when a
    [composition](https://w3c.github.io/uievents/#events-compositionevents)
    is active.
    */ get composing() {
        return this.input.composing;
    }
    /**
    The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
    */ get props() {
        if (this._props.state != this.state) {
            let prev = this._props;
            this._props = {};
            for(let name in prev)this._props[name] = prev[name];
            this._props.state = this.state;
        }
        return this._props;
    }
    /**
    Update the view's props. Will immediately cause an update to
    the DOM.
    */ update(props) {
        if (props.handleDOMEvents != this._props.handleDOMEvents) $b5c91c309b2647a1$var$ensureListeners(this);
        let prevProps = this._props;
        this._props = props;
        if (props.plugins) {
            props.plugins.forEach($b5c91c309b2647a1$var$checkStateComponent);
            this.directPlugins = props.plugins;
        }
        this.updateStateInner(props.state, prevProps);
    }
    /**
    Update the view by updating existing props object with the object
    given as argument. Equivalent to `view.update(Object.assign({},
    view.props, props))`.
    */ setProps(props) {
        let updated = {};
        for(let name in this._props)updated[name] = this._props[name];
        updated.state = this.state;
        for(let name in props)updated[name] = props[name];
        this.update(updated);
    }
    /**
    Update the editor's `state` prop, without touching any of the
    other props.
    */ updateState(state) {
        this.updateStateInner(state, this._props);
    }
    updateStateInner(state, prevProps) {
        var _a;
        let prev = this.state, redraw = false, updateSel = false;
        // When stored marks are added, stop composition, so that they can
        // be displayed.
        if (state.storedMarks && this.composing) {
            $b5c91c309b2647a1$var$clearComposition(this);
            updateSel = true;
        }
        this.state = state;
        let pluginsChanged = prev.plugins != state.plugins || this._props.plugins != prevProps.plugins;
        if (pluginsChanged || this._props.plugins != prevProps.plugins || this._props.nodeViews != prevProps.nodeViews) {
            let nodeViews = $b5c91c309b2647a1$var$buildNodeViews(this);
            if ($b5c91c309b2647a1$var$changedNodeViews(nodeViews, this.nodeViews)) {
                this.nodeViews = nodeViews;
                redraw = true;
            }
        }
        if (pluginsChanged || prevProps.handleDOMEvents != this._props.handleDOMEvents) $b5c91c309b2647a1$var$ensureListeners(this);
        this.editable = $b5c91c309b2647a1$var$getEditable(this);
        $b5c91c309b2647a1$var$updateCursorWrapper(this);
        let innerDeco = $b5c91c309b2647a1$var$viewDecorations(this), outerDeco = $b5c91c309b2647a1$var$computeDocDeco(this);
        let scroll = prev.plugins != state.plugins && !prev.doc.eq(state.doc) ? "reset" : state.scrollToSelection > prev.scrollToSelection ? "to selection" : "preserve";
        let updateDoc = redraw || !this.docView.matchesNode(state.doc, outerDeco, innerDeco);
        if (updateDoc || !state.selection.eq(prev.selection)) updateSel = true;
        let oldScrollPos = scroll == "preserve" && updateSel && this.dom.style.overflowAnchor == null && $b5c91c309b2647a1$var$storeScrollPos(this);
        if (updateSel) {
            this.domObserver.stop();
            // Work around an issue in Chrome, IE, and Edge where changing
            // the DOM around an active selection puts it into a broken
            // state where the thing the user sees differs from the
            // selection reported by the Selection object (#710, #973,
            // #1011, #1013, #1035).
            let forceSelUpdate = updateDoc && ($b5c91c309b2647a1$var$ie || $b5c91c309b2647a1$var$chrome) && !this.composing && !prev.selection.empty && !state.selection.empty && $b5c91c309b2647a1$var$selectionContextChanged(prev.selection, state.selection);
            if (updateDoc) {
                // If the node that the selection points into is written to,
                // Chrome sometimes starts misreporting the selection, so this
                // tracks that and forces a selection reset when our update
                // did write to the node.
                let chromeKludge = $b5c91c309b2647a1$var$chrome ? this.trackWrites = this.domSelectionRange().focusNode : null;
                if (this.composing) this.input.compositionNode = $b5c91c309b2647a1$var$findCompositionNode(this);
                if (redraw || !this.docView.update(state.doc, outerDeco, innerDeco, this)) {
                    this.docView.updateOuterDeco(outerDeco);
                    this.docView.destroy();
                    this.docView = $b5c91c309b2647a1$var$docViewDesc(state.doc, outerDeco, innerDeco, this.dom, this);
                }
                if (chromeKludge && !this.trackWrites) forceSelUpdate = true;
            }
            // Work around for an issue where an update arriving right between
            // a DOM selection change and the "selectionchange" event for it
            // can cause a spurious DOM selection update, disrupting mouse
            // drag selection.
            if (forceSelUpdate || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && $b5c91c309b2647a1$var$anchorInRightPlace(this))) $b5c91c309b2647a1$var$selectionToDOM(this, forceSelUpdate);
            else {
                $b5c91c309b2647a1$var$syncNodeSelection(this, state.selection);
                this.domObserver.setCurSelection();
            }
            this.domObserver.start();
        }
        this.updatePluginViews(prev);
        if (((_a = this.dragging) === null || _a === void 0 ? void 0 : _a.node) && !prev.doc.eq(state.doc)) this.updateDraggedNode(this.dragging, prev);
        if (scroll == "reset") this.dom.scrollTop = 0;
        else if (scroll == "to selection") this.scrollToSelection();
        else if (oldScrollPos) $b5c91c309b2647a1$var$resetScrollPos(oldScrollPos);
    }
    /**
    @internal
    */ scrollToSelection() {
        let startDOM = this.domSelectionRange().focusNode;
        if (this.someProp("handleScrollToSelection", (f)=>f(this))) ;
        else if (this.state.selection instanceof (0, $kpTIW.NodeSelection)) {
            let target = this.docView.domAfterPos(this.state.selection.from);
            if (target.nodeType == 1) $b5c91c309b2647a1$var$scrollRectIntoView(this, target.getBoundingClientRect(), startDOM);
        } else $b5c91c309b2647a1$var$scrollRectIntoView(this, this.coordsAtPos(this.state.selection.head, 1), startDOM);
    }
    destroyPluginViews() {
        let view;
        while(view = this.pluginViews.pop())if (view.destroy) view.destroy();
    }
    updatePluginViews(prevState) {
        if (!prevState || prevState.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
            this.prevDirectPlugins = this.directPlugins;
            this.destroyPluginViews();
            for(let i = 0; i < this.directPlugins.length; i++){
                let plugin = this.directPlugins[i];
                if (plugin.spec.view) this.pluginViews.push(plugin.spec.view(this));
            }
            for(let i = 0; i < this.state.plugins.length; i++){
                let plugin = this.state.plugins[i];
                if (plugin.spec.view) this.pluginViews.push(plugin.spec.view(this));
            }
        } else for(let i = 0; i < this.pluginViews.length; i++){
            let pluginView = this.pluginViews[i];
            if (pluginView.update) pluginView.update(this, prevState);
        }
    }
    updateDraggedNode(dragging, prev) {
        let sel = dragging.node, found = -1;
        if (this.state.doc.nodeAt(sel.from) == sel.node) found = sel.from;
        else {
            let movedPos = sel.from + (this.state.doc.content.size - prev.doc.content.size);
            let moved = movedPos > 0 && this.state.doc.nodeAt(movedPos);
            if (moved == sel.node) found = movedPos;
        }
        this.dragging = new $b5c91c309b2647a1$var$Dragging(dragging.slice, dragging.move, found < 0 ? undefined : (0, $kpTIW.NodeSelection).create(this.state.doc, found));
    }
    someProp(propName, f) {
        let prop = this._props && this._props[propName], value;
        if (prop != null && (value = f ? f(prop) : prop)) return value;
        for(let i = 0; i < this.directPlugins.length; i++){
            let prop = this.directPlugins[i].props[propName];
            if (prop != null && (value = f ? f(prop) : prop)) return value;
        }
        let plugins = this.state.plugins;
        if (plugins) for(let i = 0; i < plugins.length; i++){
            let prop = plugins[i].props[propName];
            if (prop != null && (value = f ? f(prop) : prop)) return value;
        }
    }
    /**
    Query whether the view has focus.
    */ hasFocus() {
        // Work around IE not handling focus correctly if resize handles are shown.
        // If the cursor is inside an element with resize handles, activeElement
        // will be that element instead of this.dom.
        if ($b5c91c309b2647a1$var$ie) {
            // If activeElement is within this.dom, and there are no other elements
            // setting `contenteditable` to false in between, treat it as focused.
            let node = this.root.activeElement;
            if (node == this.dom) return true;
            if (!node || !this.dom.contains(node)) return false;
            while(node && this.dom != node && this.dom.contains(node)){
                if (node.contentEditable == 'false') return false;
                node = node.parentElement;
            }
            return true;
        }
        return this.root.activeElement == this.dom;
    }
    /**
    Focus the editor.
    */ focus() {
        this.domObserver.stop();
        if (this.editable) $b5c91c309b2647a1$var$focusPreventScroll(this.dom);
        $b5c91c309b2647a1$var$selectionToDOM(this);
        this.domObserver.start();
    }
    /**
    Get the document root in which the editor exists. This will
    usually be the top-level `document`, but might be a [shadow
    DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
    root if the editor is inside one.
    */ get root() {
        let cached = this._root;
        if (cached == null) {
            for(let search = this.dom.parentNode; search; search = search.parentNode)if (search.nodeType == 9 || search.nodeType == 11 && search.host) {
                if (!search.getSelection) Object.getPrototypeOf(search).getSelection = ()=>search.ownerDocument.getSelection();
                return this._root = search;
            }
        }
        return cached || document;
    }
    /**
    When an existing editor view is moved to a new document or
    shadow tree, call this to make it recompute its root.
    */ updateRoot() {
        this._root = null;
    }
    /**
    Given a pair of viewport coordinates, return the document
    position that corresponds to them. May return null if the given
    coordinates aren't inside of the editor. When an object is
    returned, its `pos` property is the position nearest to the
    coordinates, and its `inside` property holds the position of the
    inner node that the position falls inside of, or -1 if it is at
    the top level, not in any node.
    */ posAtCoords(coords) {
        return $b5c91c309b2647a1$var$posAtCoords(this, coords);
    }
    /**
    Returns the viewport rectangle at a given document position.
    `left` and `right` will be the same number, as this returns a
    flat cursor-ish rectangle. If the position is between two things
    that aren't directly adjacent, `side` determines which element
    is used. When < 0, the element before the position is used,
    otherwise the element after.
    */ coordsAtPos(pos, side = 1) {
        return $b5c91c309b2647a1$var$coordsAtPos(this, pos, side);
    }
    /**
    Find the DOM position that corresponds to the given document
    position. When `side` is negative, find the position as close as
    possible to the content before the position. When positive,
    prefer positions close to the content after the position. When
    zero, prefer as shallow a position as possible.
    
    Note that you should **not** mutate the editor's internal DOM,
    only inspect it (and even that is usually not necessary).
    */ domAtPos(pos, side = 0) {
        return this.docView.domFromPos(pos, side);
    }
    /**
    Find the DOM node that represents the document node after the
    given position. May return `null` when the position doesn't point
    in front of a node or if the node is inside an opaque node view.
    
    This is intended to be able to call things like
    `getBoundingClientRect` on that DOM node. Do **not** mutate the
    editor DOM directly, or add styling this way, since that will be
    immediately overriden by the editor as it redraws the node.
    */ nodeDOM(pos) {
        let desc = this.docView.descAt(pos);
        return desc ? desc.nodeDOM : null;
    }
    /**
    Find the document position that corresponds to a given DOM
    position. (Whenever possible, it is preferable to inspect the
    document structure directly, rather than poking around in the
    DOM, but sometimes—for example when interpreting an event
    target—you don't have a choice.)
    
    The `bias` parameter can be used to influence which side of a DOM
    node to use when the position is inside a leaf node.
    */ posAtDOM(node, offset, bias = -1) {
        let pos = this.docView.posFromDOM(node, offset, bias);
        if (pos == null) throw new RangeError("DOM position not inside the editor");
        return pos;
    }
    /**
    Find out whether the selection is at the end of a textblock when
    moving in a given direction. When, for example, given `"left"`,
    it will return true if moving left from the current cursor
    position would leave that position's parent textblock. Will apply
    to the view's current state by default, but it is possible to
    pass a different state.
    */ endOfTextblock(dir, state) {
        return $b5c91c309b2647a1$var$endOfTextblock(this, state || this.state, dir);
    }
    /**
    Run the editor's paste logic with the given HTML string. The
    `event`, if given, will be passed to the
    [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
    */ pasteHTML(html, event) {
        return $b5c91c309b2647a1$var$doPaste(this, "", html, false, event || new ClipboardEvent("paste"));
    }
    /**
    Run the editor's paste logic with the given plain-text input.
    */ pasteText(text, event) {
        return $b5c91c309b2647a1$var$doPaste(this, text, null, true, event || new ClipboardEvent("paste"));
    }
    /**
    Removes the editor from the DOM and destroys all [node
    views](https://prosemirror.net/docs/ref/#view.NodeView).
    */ destroy() {
        if (!this.docView) return;
        $b5c91c309b2647a1$var$destroyInput(this);
        this.destroyPluginViews();
        if (this.mounted) {
            this.docView.update(this.state.doc, [], $b5c91c309b2647a1$var$viewDecorations(this), this);
            this.dom.textContent = "";
        } else if (this.dom.parentNode) this.dom.parentNode.removeChild(this.dom);
        this.docView.destroy();
        this.docView = null;
        $b5c91c309b2647a1$var$clearReusedRange();
    }
    /**
    This is true when the view has been
    [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
    used anymore).
    */ get isDestroyed() {
        return this.docView == null;
    }
    /**
    Used for testing.
    */ dispatchEvent(event) {
        return $b5c91c309b2647a1$var$dispatchEvent(this, event);
    }
    /**
    Dispatch a transaction. Will call
    [`dispatchTransaction`](https://prosemirror.net/docs/ref/#view.DirectEditorProps.dispatchTransaction)
    when given, and otherwise defaults to applying the transaction to
    the current state and calling
    [`updateState`](https://prosemirror.net/docs/ref/#view.EditorView.updateState) with the result.
    This method is bound to the view instance, so that it can be
    easily passed around.
    */ dispatch(tr) {
        let dispatchTransaction = this._props.dispatchTransaction;
        if (dispatchTransaction) dispatchTransaction.call(this, tr);
        else this.updateState(this.state.apply(tr));
    }
    /**
    @internal
    */ domSelectionRange() {
        let sel = this.domSelection();
        return $b5c91c309b2647a1$var$safari && this.root.nodeType === 11 && $b5c91c309b2647a1$var$deepActiveElement(this.dom.ownerDocument) == this.dom && $b5c91c309b2647a1$var$safariShadowSelectionRange(this, sel) || sel;
    }
    /**
    @internal
    */ domSelection() {
        return this.root.getSelection();
    }
}
function $b5c91c309b2647a1$var$computeDocDeco(view) {
    let attrs = Object.create(null);
    attrs.class = "ProseMirror";
    attrs.contenteditable = String(view.editable);
    view.someProp("attributes", (value)=>{
        if (typeof value == "function") value = value(view.state);
        if (value) for(let attr in value){
            if (attr == "class") attrs.class += " " + value[attr];
            else if (attr == "style") attrs.style = (attrs.style ? attrs.style + ";" : "") + value[attr];
            else if (!attrs[attr] && attr != "contenteditable" && attr != "nodeName") attrs[attr] = String(value[attr]);
        }
    });
    if (!attrs.translate) attrs.translate = "no";
    return [
        $b5c91c309b2647a1$export$10e30b733df217ea.node(0, view.state.doc.content.size, attrs)
    ];
}
function $b5c91c309b2647a1$var$updateCursorWrapper(view) {
    if (view.markCursor) {
        let dom = document.createElement("img");
        dom.className = "ProseMirror-separator";
        dom.setAttribute("mark-placeholder", "true");
        dom.setAttribute("alt", "");
        view.cursorWrapper = {
            dom: dom,
            deco: $b5c91c309b2647a1$export$10e30b733df217ea.widget(view.state.selection.head, dom, {
                raw: true,
                marks: view.markCursor
            })
        };
    } else view.cursorWrapper = null;
}
function $b5c91c309b2647a1$var$getEditable(view) {
    return !view.someProp("editable", (value)=>value(view.state) === false);
}
function $b5c91c309b2647a1$var$selectionContextChanged(sel1, sel2) {
    let depth = Math.min(sel1.$anchor.sharedDepth(sel1.head), sel2.$anchor.sharedDepth(sel2.head));
    return sel1.$anchor.start(depth) != sel2.$anchor.start(depth);
}
function $b5c91c309b2647a1$var$buildNodeViews(view) {
    let result = Object.create(null);
    function add(obj) {
        for(let prop in obj)if (!Object.prototype.hasOwnProperty.call(result, prop)) result[prop] = obj[prop];
    }
    view.someProp("nodeViews", add);
    view.someProp("markViews", add);
    return result;
}
function $b5c91c309b2647a1$var$changedNodeViews(a, b) {
    let nA = 0, nB = 0;
    for(let prop in a){
        if (a[prop] != b[prop]) return true;
        nA++;
    }
    for(let _ in b)nB++;
    return nA != nB;
}
function $b5c91c309b2647a1$var$checkStateComponent(plugin) {
    if (plugin.spec.state || plugin.spec.filterTransaction || plugin.spec.appendTransaction) throw new RangeError("Plugins passed directly to the view must not have a state component");
}

});

parcelRegister("dIobN", function(module, exports) {

$parcel$export(module.exports, "WithPluginState", () => $fdbfb9064e558229$export$38a2fcbdfe5b863a);

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $auyn4 = parcelRequire("auyn4");

var $89pLp = parcelRequire("89pLp");

var $cC72g = parcelRequire("cC72g");
var $jwP4O = parcelRequire("jwP4O");
const $fdbfb9064e558229$var$DEFAULT_SAMPLING_RATE = 100;
const $fdbfb9064e558229$var$DEFAULT_SLOW_THRESHOLD = 4;
/**
 * @private
 * @deprecated
 *
 * Using this component is deprecated. It should be replaced with `useSharedPluginState`.
 * This requires having access to the injection API from the plugin itself.
 *
 * An example of the refactor with the new hook (using hyperlink as an example) is:
 *
 * Before:
 * ```ts
 * <WithPluginState
 *   editorView={editorView}
 *   plugins={{
 *     hyperlinkState: hyperlinkPluginKey
 *   }}
 *   render={({ hyperlinkState }) =>
 *     renderComponent({ hyperlinkState })
 *   }
 * />
 * ```
 *
 * After:
 * ```ts
 * import { useSharedPluginState } from '@atlaskit/editor-common/hooks';
 * import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';
 *
 * function ComponentWithState(
 *   api: ExtractInjectionAPI<typeof hyperlinkPlugin> | undefined
 * ) {
 *   const { hyperlinkState } = useSharedPluginState(api, ['hyperlink']);
 *   return renderComponent({ hyperlinkState })
 * }
 * ```
 *
 */ class $fdbfb9064e558229$export$38a2fcbdfe5b863a extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.displayName = 'WithPluginState';
    }
    static{
        this.contextTypes = {
            editorActions: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
            editorSharedConfig: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
        };
    }
    constructor(props, context){
        super(props, context);
        this.listeners = {};
        this.debounce = null;
        this.notAppliedState = {};
        this.isSubscribed = false;
        this.callsCount = 0;
        this.handlePluginStateChange = (propName, pluginName, performanceOptions, skipEqualityCheck)=>(pluginState)=>{
                // skipEqualityCheck is being used for old plugins since they are mutating plugin state instead of creating a new one
                if (this.state[propName] !== pluginState || skipEqualityCheck) this.updateState({
                    stateSubset: {
                        [propName]: pluginState
                    },
                    pluginName: pluginName,
                    performanceOptions: performanceOptions
                });
            };
        /**
	 * Debounces setState calls in order to reduce number of re-renders caused by several plugin state changes.
	 */ this.updateState = ({ stateSubset: stateSubset, pluginName: pluginName, performanceOptions: performanceOptions })=>{
            this.notAppliedState = {
                ...this.notAppliedState,
                ...stateSubset
            };
            if (this.debounce) window.clearTimeout(this.debounce);
            const debounce = this.props.debounce !== false ? (fn)=>window.setTimeout(fn, 0) : (fn)=>fn();
            this.debounce = debounce(()=>{
                const measure = `\u{1F989}${pluginName}::WithPluginState`;
                performanceOptions.trackingEnabled && (0, $jwP4O.startMeasure)(measure);
                this.setState(this.notAppliedState, ()=>{
                    performanceOptions.trackingEnabled && (0, $jwP4O.stopMeasure)(measure, (duration)=>{
                        // Each WithPluginState component will fire analytics event no more than once every `samplingLimit` times
                        if (++this.callsCount % performanceOptions.samplingRate === 0 && duration > performanceOptions.slowThreshold) this.dispatchAnalyticsEvent({
                            action: (0, $auyn4.ACTION).WITH_PLUGIN_STATE_CALLED,
                            actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
                            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL,
                            attributes: {
                                plugin: pluginName,
                                duration: duration
                            }
                        });
                    });
                });
                this.debounce = null;
                this.notAppliedState = {};
            });
        };
        this.dispatchAnalyticsEvent = (payload)=>{
            const eventDispatcher = this.getEventDispatcher();
            if (eventDispatcher) {
                const dispatch = (0, $89pLp.createDispatch)(eventDispatcher);
                dispatch((0, $cC72g.analyticsEventKey), {
                    payload: payload
                });
            }
        };
        this.onContextUpdate = ()=>{
            this.subscribe(this.props);
        };
        this.state = this.getPluginsStates(this.props.plugins, this.getEditorView(props, context));
    }
    getEditorView(maybeProps, maybeContext) {
        const props = maybeProps || this.props;
        const context = maybeContext || this.context;
        return props.editorView || context && context.editorActions && context.editorActions._privateGetEditorView() || context && context.editorSharedConfig && context.editorSharedConfig.editorView;
    }
    getEventDispatcher(maybeProps) {
        const props = maybeProps || this.props;
        return props.eventDispatcher || this.context && this.context.editorActions && this.context.editorActions._privateGetEventDispatcher() || this.context && this.context.editorSharedConfig && this.context.editorSharedConfig.eventDispatcher;
    }
    getPluginsStates(plugins, editorView) {
        if (!editorView || !plugins) return {};
        const keys = Object.keys(plugins);
        return keys.reduce((acc, propName)=>{
            const pluginKey = plugins[propName];
            if (!pluginKey) return acc;
            acc[propName] = pluginKey.getState(editorView.state);
            return acc;
        }, {});
    }
    subscribe(props) {
        const plugins = props.plugins;
        const eventDispatcher = this.getEventDispatcher(props);
        const editorView = this.getEditorView(props);
        if (!eventDispatcher || !editorView || this.isSubscribed) return;
        // TODO: ED-15663
        // Please, do not copy or use this kind of code below
        // @ts-ignore
        const fakePluginKey = {
            key: 'analyticsPlugin$',
            getState: (state)=>{
                return state['analyticsPlugin$'];
            }
        };
        const analyticsPlugin = fakePluginKey.getState(editorView.state);
        const uiTracking = analyticsPlugin && analyticsPlugin.performanceTracking ? analyticsPlugin.performanceTracking.uiTracking || {} : {};
        const trackingEnabled = uiTracking.enabled === true;
        const samplingRate = uiTracking.samplingRate ?? $fdbfb9064e558229$var$DEFAULT_SAMPLING_RATE;
        const slowThreshold = uiTracking.slowThreshold ?? $fdbfb9064e558229$var$DEFAULT_SLOW_THRESHOLD;
        this.isSubscribed = true;
        const pluginsStates = this.getPluginsStates(plugins, editorView);
        this.setState(pluginsStates);
        Object.keys(plugins).forEach((propName)=>{
            const pluginKey = plugins[propName];
            if (!pluginKey) return;
            const pluginName = pluginKey.key;
            const pluginState = pluginsStates[propName];
            const isPluginWithSubscribe = pluginState && pluginState.subscribe;
            const handler = this.handlePluginStateChange(propName, pluginName, {
                samplingRate: samplingRate,
                slowThreshold: slowThreshold,
                trackingEnabled: trackingEnabled
            }, isPluginWithSubscribe);
            if (isPluginWithSubscribe) pluginState.subscribe(handler);
            else eventDispatcher.on(pluginKey.key, handler);
            this.listeners[pluginKey.key] = {
                handler: handler,
                pluginKey: pluginKey
            };
        });
    }
    unsubscribe() {
        const eventDispatcher = this.getEventDispatcher();
        const editorView = this.getEditorView();
        if (!eventDispatcher || !editorView || !this.isSubscribed) return;
        Object.keys(this.listeners).forEach((key)=>{
            const pluginState = this.listeners[key].pluginKey.getState(editorView.state);
            if (pluginState && pluginState.unsubscribe) pluginState.unsubscribe(this.listeners[key].handler);
            else eventDispatcher.off(key, this.listeners[key].handler);
        });
        this.listeners = [];
    }
    subscribeToContextUpdates(context) {
        if (context && context.editorActions) context.editorActions._privateSubscribe(this.onContextUpdate);
    }
    unsubscribeFromContextUpdates(context) {
        if (context && context.editorActions) context.editorActions._privateUnsubscribe(this.onContextUpdate);
    }
    componentDidMount() {
        this.subscribe(this.props);
        this.subscribeToContextUpdates(this.context);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!this.isSubscribed) this.subscribe(nextProps);
    }
    componentWillUnmount() {
        if (this.debounce) window.clearTimeout(this.debounce);
        this.unsubscribeFromContextUpdates(this.context);
        this.unsubscribe();
    }
    render() {
        const { render: render } = this.props;
        return render(this.state);
    }
}

});
parcelRegister("89pLp", function(module, exports) {

$parcel$export(module.exports, "EventDispatcher", () => $dee83704227c6311$export$ec8b666c5fe2c75a);
$parcel$export(module.exports, "createDispatch", () => $dee83704227c6311$export$f57f9cc7ce57b7d0);
class $dee83704227c6311$export$ec8b666c5fe2c75a {
    on(event, cb) {
        if (!this.listeners[event]) this.listeners[event] = new Set();
        this.listeners[event].add(cb);
    }
    has(event, cb) {
        if (!this.listeners[event]) return false;
        return this.listeners[event].has(cb);
    }
    off(event, cb) {
        if (!this.listeners[event]) return;
        if (this.listeners[event].has(cb)) this.listeners[event].delete(cb);
    }
    emit(event, data) {
        if (!this.listeners[event]) return;
        this.listeners[event].forEach((cb)=>cb(data));
    }
    destroy() {
        this.listeners = {};
    }
    constructor(){
        this.listeners = {};
    }
}
function $dee83704227c6311$var$getEventFromEventName(eventName) {
    return typeof eventName === 'string' ? eventName : eventName.key;
}
function $dee83704227c6311$export$f57f9cc7ce57b7d0(eventDispatcher) {
    return (eventName, data)=>{
        if (!eventName) throw new Error('event name is required!');
        eventDispatcher.emit($dee83704227c6311$var$getEventFromEventName(eventName), data);
    };
}

});


parcelRegister("epPZ1", function(module, exports) {

$parcel$export(module.exports, "useAIThemeColor", () => $a7ebb94a2a833dcc$export$a253e56048cb99a1);
/**
 * TODO AIFOLLOWUP ED-18808, EDITOR-56:
 * This should no longer be needed once token case been finalised + added.
 * Once AI tokens are available, replace usages of `aiThemeColor` with
 * the correct tokens.
 */ 
var $4q38b = parcelRequire("4q38b");
const $a7ebb94a2a833dcc$export$a253e56048cb99a1 = ()=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    return (key)=>$a7ebb94a2a833dcc$var$aiTheme[key][colorMode || 'light'];
};
const $a7ebb94a2a833dcc$var$aiTheme = {
    // Prism border gradient steps
    ['prism.border.step.1']: {
        light: '#0065FF',
        // Blue
        dark: '#0065FF' // Blue
    },
    ['prism.border.step.2']: {
        light: '#0469FF',
        // Blue
        dark: '#0469FF' // Blue
    },
    ['prism.border.step.3']: {
        light: '#BF63F3',
        // Purple
        dark: '#BF63F3' // Purple
    },
    ['prism.border.step.4']: {
        light: '#FFA900',
        // Yellow
        dark: '#FFA900' // Yellow
    },
    // AI Logo Color
    ['icon.brand']: {
        light: '#44546F',
        dark: '#9FADBC'
    },
    // Telepointer background gradient steps
    ['telepointer.background.step.1']: {
        light: '#F8E6A0',
        dark: '#F5CD47'
    },
    ['telepointer.background.step.2']: {
        light: '#8BDBE5',
        dark: '#60C6D2'
    },
    ['telepointer.background.step.3']: {
        light: '#0C66E4',
        // Blue700
        dark: '#388BFF' // Blue500
    },
    // Loading dots colours
    ['loading.step.1']: {
        light: '#0C66E4',
        // Blue700
        dark: '#0C66E4' // Blue700
    },
    ['loading.step.2']: {
        light: '#1D7AFC',
        // Blue600
        dark: '#1D7AFC' // Blue600
    },
    ['loading.step.3']: {
        light: '#388BFF',
        // Blue500
        dark: '#388BFF' // Blue500
    }
};

});

parcelRegister("a7I3b", function(module, exports) {

$parcel$export(module.exports, "AtlassianIntelligenceToolbarButton", () => $75ecba525e6e2e77$export$d680bd36e1545039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7nPJR = parcelRequire("7nPJR");

var $6eWD6 = parcelRequire("6eWD6");

var $jQbVr = parcelRequire("jQbVr");

var $aCOKY = parcelRequire("aCOKY");

var $74BVL = parcelRequire("74BVL");

var $7Beqi = parcelRequire("7Beqi");
const $75ecba525e6e2e77$var$shouldShowSeparator = (node)=>{
    var _node$previousElement;
    if (!node) return false;
    const prevSeparator = (_node$previousElement = node.previousElementSibling) === null || _node$previousElement === void 0 ? void 0 : _node$previousElement.querySelector(`:scope > span:last-child:empty`);
    const prevSeparatorVisible = prevSeparator && prevSeparator.clientWidth > 0;
    return !prevSeparatorVisible;
};
function $75ecba525e6e2e77$var$useWindowWidth() {
    const [windowWidth, setWindowWidth] = (0, $eUqFw.useState)(window.innerWidth);
    (0, $eUqFw.useEffect)(()=>{
        function handleResize() {
            setWindowWidth(window.innerWidth);
        }
        const unbind = (0, $74BVL.bind)(window, {
            type: 'resize',
            listener: handleResize
        });
        return ()=>unbind();
    }, []);
    return windowWidth;
}
const $75ecba525e6e2e77$export$d680bd36e1545039 = ({ onClick: onClick, disabled: disabled, ButtonWrapper: ButtonWrapper })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const title = formatMessage((0, $6eWD6.default).aiUniversalDescriptor);
    const [showSeparator, setShowSeperator] = (0, $eUqFw.useState)(false);
    const width = $75ecba525e6e2e77$var$useWindowWidth();
    const callbackRef = (node)=>{
        const result = $75ecba525e6e2e77$var$shouldShowSeparator(node);
        setShowSeperator(result);
    };
    // This const is derived from the breakpoint where the toolbar hides its icons. It is used to hide the text in the AI button.
    // Derived from values from platform/packages/editor/editor-core/src/ui/Appearance/FullPage/MainToolbar.tsx
    const AI_BUTTON_WIDTH_BREAKPOINT = 1076;
    const button = (0, $byn9U.jsx)((0, $aCOKY.default), {
        onClick: onClick,
        buttonId: "atlassian-intelligence",
        "aria-label": title,
        testId: "atlassian-intelligence-toolbar-button",
        title: title,
        iconBefore: (0, $byn9U.jsx)((0, $7nPJR.AtlassianIntelligenceLogo), {
            isDisabled: disabled
        }),
        disabled: disabled
    }, width >= AI_BUTTON_WIDTH_BREAKPOINT && (0, $byn9U.jsx)("span", null, formatMessage((0, $6eWD6.default).aiUniversalShortCallToAction)));
    const toolbarMutationCount = (0, $7Beqi.useEditorToolbarChangeDetector)(ButtonWrapper);
    const wrapped = ButtonWrapper ? (0, $byn9U.jsx)(ButtonWrapper, {
        key: `${toolbarMutationCount}-key-wrapper`
    }, button) : button;
    return (0, $byn9U.jsx)("span", {
        ref: callbackRef,
        css: [
            (0, $jQbVr.wrapperStyle),
            (0, $jQbVr.svgIconStyles)
        ]
    }, showSeparator && (0, $byn9U.jsx)("span", {
        "data-testid": "ai-toolbar-button-seperator",
        css: (0, $jQbVr.separatorStyles)
    }), wrapped);
};

});
parcelRegister("7nPJR", function(module, exports) {

$parcel$export(module.exports, "AtlassianIntelligenceLogo", () => $5602d09af6800f5b$export$b58d43d92d088553);
/* @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $5JgJ2 = parcelRequire("5JgJ2");

var $izdMb = parcelRequire("izdMb");

var $4NAKV = parcelRequire("4NAKV");

var $eDB6q = parcelRequire("eDB6q");
const $5602d09af6800f5b$export$b58d43d92d088553 = ({ isDisabled: isDisabled = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return (0, $byn9U.jsx)("div", {
        "data-testid": "atlassian-intelligence-logo",
        css: (0, $eDB6q.logoContainer)
    }, (0, $byn9U.jsx)((0, $izdMb.LogoSvg), {
        alt: formatMessage((0, $4NAKV.default).logoAltText),
        isDisabled: isDisabled
    }));
};

});
parcelRegister("izdMb", function(module, exports) {

$parcel$export(module.exports, "LogoSvg", () => $d8462e84d946bcf9$export$77af5b11f07c3aed);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");
const $d8462e84d946bcf9$export$77af5b11f07c3aed = ({ alt: alt, isDisabled: isDisabled = false, className: className, size: size = 24 })=>{
    const stroke = isDisabled ? "var(--ds-icon-disabled, #091E424F)" : "var(--ds-icon, #44546F)";
    return (0, $byn9U.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        stroke: stroke,
        className: className,
        role: alt === '' ? 'presentation' : undefined
    }, alt && (0, $byn9U.jsx)("title", null, alt), (0, $byn9U.jsx)("path", {
        d: "M14.5 14.5L17.5 17.5",
        strokeWidth: "1.5",
        strokeLinecap: "square"
    }), (0, $byn9U.jsx)("path", {
        d: "M9.5 14.5L6.5 17.5",
        strokeWidth: "1.5",
        strokeLinecap: "square"
    }), (0, $byn9U.jsx)("path", {
        d: "M9.5 9.5L6.5 6.5",
        strokeWidth: "1.5",
        strokeLinecap: "square"
    }), (0, $byn9U.jsx)("path", {
        d: "M14.5 9.5L17.5 6.5",
        strokeWidth: "1.5",
        strokeLinecap: "square"
    }), (0, $byn9U.jsx)("path", {
        d: "M12.0001 16V19",
        strokeWidth: "1.5"
    }), (0, $byn9U.jsx)("path", {
        d: "M8.00012 12L5.00012 12",
        strokeWidth: "1.5"
    }), (0, $byn9U.jsx)("path", {
        d: "M12.0001 8.00002L12.0001 4.99999",
        strokeWidth: "1.5"
    }), (0, $byn9U.jsx)("path", {
        d: "M16.0002 12L19.0002 12",
        strokeWidth: "1.5"
    }));
};

});

parcelRegister("4NAKV", function(module, exports) {

$parcel$export(module.exports, "default", () => $37e83ffa1abc2c64$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $37e83ffa1abc2c64$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    logoAltText: {
        id: 'fabric.editor.ai.components.atlassianIntelligenceLogo.logoAltText',
        defaultMessage: 'Atlassian Intelligence Logo',
        description: 'Atlassian Intelligence logo alt text'
    }
});

});

parcelRegister("eDB6q", function(module, exports) {

$parcel$export(module.exports, "logoContainer", () => $aa817d069a1fe262$export$a1fe6a2d7788354f);

var $byn9U = parcelRequire("byn9U");
const $aa817d069a1fe262$export$a1fe6a2d7788354f = (0, $byn9U.css)({
    height: '24px',
    width: '24px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});

});


parcelRegister("6eWD6", function(module, exports) {

$parcel$export(module.exports, "default", () => $48b1877e2404bb70$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $48b1877e2404bb70$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    aiUniversalLongCallToAction: {
        id: 'fabric.editor.ai.shared.aiUniversalLongCallToAction',
        defaultMessage: 'Let Atlassian Intelligence assist your writing',
        description: 'Call-to-action text for activating the AI, used universally across UI elements like hover buttons, tooltips, and menu entries'
    },
    aiUniversalShortCallToAction: {
        id: 'fabric.editor.ai.shared.aiUniversalShortCallToAction',
        defaultMessage: 'Write',
        description: 'Call-to-action text for activating the AI, used universally across UI elements like buttons and menu entries'
    },
    aiUniversalDescriptor: {
        id: 'fabric.editor.ai.shared.aiUniversalDescriptor',
        defaultMessage: 'Writing assistant',
        description: 'Descriptive text for activating the AI, used universally across UI elements like hover buttons, tooltips, and menu entries'
    },
    aiButtonTitle: {
        id: 'fabric.editor.ai.shared.generateContent.aiButtonTitle',
        defaultMessage: 'AI (Atlassian Intelligence)',
        description: 'Title for Atlassian Intelligence feature shown in editor typeahead and element browser.'
    },
    betaLabel: {
        id: 'fabric.editor.ai.shared.betaLabel',
        defaultMessage: 'Beta',
        description: 'The label describing the beta status of an Atlassian Intelligence prompt'
    }
});

});

parcelRegister("jQbVr", function(module, exports) {

$parcel$export(module.exports, "svgIconStyles", () => $03ba4293e477de27$export$de796c4c6ba956e4);
$parcel$export(module.exports, "wrapperStyle", () => $03ba4293e477de27$export$c4d4f06a25de97f);
$parcel$export(module.exports, "separatorStyles", () => $03ba4293e477de27$export$39b9f83b35c7456d);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
const $03ba4293e477de27$export$de796c4c6ba956e4 = (0, $byn9U.css)({
    button: {
        svg: {
            pointerEvents: 'none'
        }
    }
});
const $03ba4293e477de27$export$c4d4f06a25de97f = (0, $byn9U.css)({
    display: 'flex',
    alignItems: 'center',
    '> div, > span': {
        display: 'flex'
    },
    '> div > div': {
        display: 'flex'
    },
    marginLeft: 0,
    minWidth: 'auto'
});
const $03ba4293e477de27$export$39b9f83b35c7456d = (0, $byn9U.css)({
    background: `var(--ds-border, ${(0, $PdmhA.N30)})`,
    width: '1px',
    height: '24px',
    display: 'inline-block',
    margin: `0 ${"var(--ds-space-100, 8px)"}`,
    userSelect: 'none'
});

});

parcelRegister("aCOKY", function(module, exports) {

$parcel$export(module.exports, "default", () => $01ff0baa3a81b2b1$export$2e2bcd8739ae039);
// File copied from `packages/editor/editor-common/src/ui-menu/ToolbarButton/index.tsx`
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $6PJBT = parcelRequire("6PJBT");

var $8cU5f = parcelRequire("8cU5f");

var $fQ9uD = parcelRequire("fQ9uD");
const $01ff0baa3a81b2b1$var$buttonWrapper = (0, $byn9U.css)({
    display: 'flex',
    height: '100%'
});
const $01ff0baa3a81b2b1$var$ToolbarButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef((props, ref)=>{
    const { buttonId: buttonId, testId: testId, className: className = '', href: href, iconAfter: iconAfter, iconBefore: iconBefore, disabled: disabled, selected: selected, spacing: spacing, target: target, children: children, hideTooltip: hideTooltip, title: title, titlePosition: titlePosition = 'top', item: item, 'aria-label': ariaLabel, 'aria-haspopup': ariaHasPopup, 'aria-expanded': ariaExpanded, 'aria-pressed': ariaPressed, 'aria-keyshortcuts': ariaKeyShortcuts, onClick: onClick, onKeyDown: onKeyDown, onItemClick: onItemClick } = props;
    const handleClick = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        if (disabled) return;
        if (buttonId) analyticsEvent.update((payload)=>({
                ...payload,
                action: 'clicked',
                // equivalent to ACTION.CLICKED,
                actionSubject: 'toolbarButton',
                // equivalent to ACTION_SUBJECT.TOOLBAR_BUTTON,
                actionSubjectId: buttonId,
                eventType: 'ui' // equivalent to EVENT_TYPE.UI,
            })).fire((0, $6PJBT.FabricChannel).editor);
        if (onClick) onClick(event);
        if (item && onItemClick) onItemClick(item);
    }, [
        disabled,
        onClick,
        onItemClick,
        item,
        buttonId
    ]);
    const id = buttonId ? `editor-toolbar__${buttonId}` : undefined;
    const button = (0, $byn9U.jsx)((0, $fQ9uD.default), {
        id: id,
        ref: ref,
        appearance: "subtle",
        testId: testId,
        className: className,
        href: href,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isDisabled: disabled,
        isSelected: selected,
        onClick: handleClick,
        spacing: spacing || 'default',
        target: target,
        shouldFitContainer: true,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        "aria-label": ariaLabel,
        "aria-pressed": ariaPressed,
        "aria-keyshortcuts": ariaKeyShortcuts,
        onKeyDown: onKeyDown
    }, children);
    if (!title) return button;
    const tooltipContent = !hideTooltip ? title : null;
    return (0, $byn9U.jsx)((0, $8cU5f.default), {
        content: tooltipContent,
        hideTooltipOnClick: true,
        position: titlePosition
    }, (0, $byn9U.jsx)("div", {
        css: $01ff0baa3a81b2b1$var$buttonWrapper
    }, button));
});
var $01ff0baa3a81b2b1$export$2e2bcd8739ae039 = $01ff0baa3a81b2b1$var$ToolbarButton;

});
parcelRegister("fQ9uD", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8831376a926d2a4$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $dBH6i = parcelRequire("dBH6i");
var $b8831376a926d2a4$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef((props, ref)=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dBH6i.default), (0, $kU09D.default)({
        ref: ref
    }, props, {
        style: {
            alignItems: 'center'
        }
    }));
});

});


parcelRegister("7Beqi", function(module, exports) {

$parcel$export(module.exports, "useEditorToolbarChangeDetector", () => $58872d39926e7573$export$cf19468c196a204d);

var $eUqFw = parcelRequire("eUqFw");
const $58872d39926e7573$export$cf19468c196a204d = (ButtonWrapper)=>{
    const [toolbarMutationCount, setToolbarMutationCount] = (0, $eUqFw.useState)(0);
    (0, $eUqFw.useEffect)(()=>{
        if (!ButtonWrapper) return;
        const observer = new MutationObserver((mutations)=>{
            mutations.forEach((mutation)=>{
                const { addedNodes: addedNodes, removedNodes: removedNodes } = mutation;
                const isRelevantMutation = [
                    ...addedNodes,
                    ...removedNodes
                ].some((node)=>node.nodeType === 1 && node.nodeName === 'DIV');
                if (isRelevantMutation) setToolbarMutationCount(toolbarMutationCount + 1);
            });
        });
        const mainToolBar = document.querySelector(`[data-testid="ak-editor-main-toolbar"]`);
        if (mainToolBar) observer.observe(mainToolBar, {
            childList: true,
            subtree: true
        });
        return ()=>{
            observer.disconnect();
        };
    }, [
        toolbarMutationCount,
        ButtonWrapper
    ]);
    return toolbarMutationCount;
};

});


parcelRegister("3NkaD", function(module, exports) {

$parcel$export(module.exports, "mapConfigItemsToQuickInsertItems", () => $2c359828cb4b14d4$export$f3e5bb240cf24df5);

var $eUqFw = parcelRequire("eUqFw");

var $2KDKi = parcelRequire("2KDKi");

var $eXCAT = parcelRequire("eXCAT");

var $XHGTv = parcelRequire("XHGTv");
function $2c359828cb4b14d4$export$f3e5bb240cf24df5({ configItems: configItems, formatMessage: formatMessage, aiGlobalOptIn: aiGlobalOptIn, editorView: editorView }) {
    const aiPriorities = 9000;
    const dispatch = editorView.dispatch;
    return configItems// hide quickInsert items that shouldn't be visible (for e.g. because of
    // an empty document, or other config-defined logic)
    .filter((configItem)=>{
        if ((0, $XHGTv.getBooleanFF)('platform.editor.ai-dynamic-show-hide-quick-insert-items_4ie8s')) return configItem.isVisible({
            editorView: editorView
        });
        if ((0, $XHGTv.getBooleanFF)('platform.editor.ai-enable-multi-lang-translation-prompts')) {
            var _configItem$title, _configItem$title$sta;
            if ((_configItem$title = configItem.title({
                formatMessage: formatMessage
            })) !== null && _configItem$title !== void 0 && (_configItem$title$sta = _configItem$title.startsWith) !== null && _configItem$title$sta !== void 0 && _configItem$title$sta.call(_configItem$title, 'Translate to')) {
                if ((0, $XHGTv.getBooleanFF)('platform.editor.ai-enable-multi-lang-translations-in-quick-insert')) return true;
                return false;
            }
        }
        return configItem;
    }).map((configItem)=>{
        var _configItem$quickInse, _configItem$descripti;
        return {
            priority: (_configItem$quickInse = configItem.quickInsertPriority) !== null && _configItem$quickInse !== void 0 ? _configItem$quickInse : aiPriorities,
            categories: [
                'AI'
            ],
            title: configItem.title({
                formatMessage: formatMessage
            }),
            description: ((_configItem$descripti = configItem.description) === null || _configItem$descripti === void 0 ? void 0 : _configItem$descripti.call(configItem, {
                formatMessage: formatMessage
            })) || configItem.title({
                formatMessage: formatMessage
            }),
            keywords: [
                'ai',
                'generate',
                configItem.title({
                    formatMessage: formatMessage
                })
            ],
            icon: ()=>{
                return configItem.icon ? configItem.icon({
                    formatMessage: formatMessage,
                    shownAt: 'quickInsert'
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eXCAT.Logo), null);
            },
            action: (insert, editorState)=>{
                // TODO POSTEAP
                // Post EAP our intention is to kick off a state machine on entry --
                // and have a transistion on the state machine which starts the decoration
                // on the document, and links a content comopnent to the decoration.
                //
                // For now we set the openAIModalCommand to run on the next tick for now -- as it then
                // performs additional transactions to update the document (in a way that does not
                // reflect later direction)
                requestAnimationFrame(()=>{
                    const openAIModalCommand = (0, $2KDKi.createOpenAIModalCommand)({
                        state: editorView.state,
                        configItem: configItem,
                        lastTriggeredFrom: 'quickInsert',
                        aiGlobalOptIn: aiGlobalOptIn
                    });
                    openAIModalCommand(editorView.state, dispatch);
                });
                // Insert empty string to remove the typeahead raw text
                // close the quick insert immediately
                const transaction = insert('');
                return transaction;
            }
        };
    });
}

});
parcelRegister("2KDKi", function(module, exports) {

$parcel$export(module.exports, "createWidgetDecoration", () => $200eb5579fff6be8$export$6428b9f2a07e29a5);
$parcel$export(module.exports, "createInlineDecoration", () => $200eb5579fff6be8$export$1690e22aee311809);
$parcel$export(module.exports, "createGeneratedContentDecorations", () => $200eb5579fff6be8$export$ee67e3280dab453d);
$parcel$export(module.exports, "createOpenAIModalCommand", () => $200eb5579fff6be8$export$2c80ad35b3530be1);
$parcel$export(module.exports, "createEndAIExperienceCommand", () => $200eb5579fff6be8$export$d547a4e9ddb6b51);

var $kpTIW = parcelRequire("kpTIW");

var $fBDHJ = parcelRequire("fBDHJ");

var $9O1Gs = parcelRequire("9O1Gs");

var $aFbB0 = parcelRequire("aFbB0");

var $66XPt = parcelRequire("66XPt");

var $3QQwc = parcelRequire("3QQwc");
const $200eb5579fff6be8$export$6428b9f2a07e29a5 = (pos, type, key)=>{
    const widgetSpanElement = document.createElement('span');
    // Firefox needs content inside the span in order to add height to the element.
    // Otherwise, the height is set to 0 which prevents the start and
    // end widgets from rendering correctly and produces incorrect measurements
    // when we need to determine where to place the modal under the content.
    // Zero width spaces have been known to introduce some strange selection
    // behaviour in the Editor, however this approach works for our use case
    // in the ai-plugin where we do not expect users to be making selections
    // over ai-highlighted content in the same way they select regular content
    // in the Editor, this is also not intended to be a permanent fix post EAP.
    widgetSpanElement.appendChild(document.createTextNode('\u200b'));
    widgetSpanElement.setAttribute('data-testid', `ai-modal-${type}-widget`);
    // TODO: https://product-fabric.atlassian.net/browse/ED-17641
    // Issue in safari when pressing cmd+shift+right at start widget highlights
    // all text
    widgetSpanElement.className = `ai-modal-${type}-widget`;
    widgetSpanElement.contentEditable = 'false';
    return (0, $fBDHJ.Decoration).widget(pos, widgetSpanElement, {
        side: type === 'start' ? 0 : -1,
        key: key !== null && key !== void 0 ? key : `${type}WidgetDecoration`
    });
};
const $200eb5579fff6be8$export$1690e22aee311809 = (from, to)=>{
    return (0, $fBDHJ.Decoration).inline(from, to, {
        class: 'ai-selection-highlight',
        'data-testid': 'ai-selection-highlight'
    }, {
        key: 'inlineDecoration'
    });
};
const $200eb5579fff6be8$export$ee67e3280dab453d = (from, to)=>{
    const startWidgetDecoration = $200eb5579fff6be8$export$6428b9f2a07e29a5(from, 'start', 'generatedStartWidget');
    const highlightInlineDecoration = (0, $fBDHJ.Decoration).inline(from, to, {
        class: 'ai-generated-content-highlight',
        'data-testid': 'ai-generated-content-highlight'
    }, {
        key: 'generatedInlineDecoration'
    });
    const endWidgetDecoration = $200eb5579fff6be8$export$6428b9f2a07e29a5(to, 'end', 'generatedEndWidget');
    return [
        startWidgetDecoration,
        highlightInlineDecoration,
        endWidgetDecoration
    ];
};
function $200eb5579fff6be8$var$getInitialPositions(selection) {
    switch(true){
        case selection instanceof (0, $kpTIW.AllSelection):
            return {
                startPos: selection.from + 1,
                endPos: selection.to - 1
            };
        default:
            return {
                startPos: selection.from,
                endPos: selection.to
            };
    }
}
const $200eb5579fff6be8$export$2c80ad35b3530be1 = ({ state: state, configItem: configItem, lastTriggeredFrom: lastTriggeredFrom, triggerMethod: triggerMethod, aiGlobalOptIn: aiGlobalOptIn })=>{
    if (aiGlobalOptIn.status === 'disabled') // If the user has opted out of AI, do not show the modal
    // it's unclear how this function would be triggered if the
    // ai feature is disabled as all entry points should be removed
    return ()=>false;
    if (aiGlobalOptIn.status === 'disabled-opt-in') {
        aiGlobalOptIn.triggerOptInFlow();
        return (0, $9O1Gs.createCommand)({}, (tr)=>{
            (0, $aFbB0.addAnalytics)({
                editorState: state,
                tr: tr,
                payload: {
                    action: 'triggerOptInFlow',
                    actionSubject: 'editorPluginAI',
                    actionSubjectId: 'aiGlobalOptIn',
                    attributes: {
                        experienceType: configItem.title({
                            formatMessage: (0, $3QQwc.analyticsFormatMessage)
                        }),
                        lastTriggeredFrom: lastTriggeredFrom,
                        selectionType: configItem.selectionType
                    },
                    eventType: 'ui'
                }
            });
            return tr;
        });
    }
    /**
   * We add decoration based on the current selection
   * state of the document and the config item in the command palette
   * 2 scenarios
   * 1. If the selection is empty and the document is not empty -> we decorate the entire document
   * 2. If the selection is empty and the current config type is 'empty config' -> we decorate based on selection preview plugin
   */ let useCurrentSelection = true;
    if (state.selection.empty) useCurrentSelection = state.doc.content.size !== 0 && configItem.selectionType !== 'empty' ? false : true;
    /**
   * EXPERIMENTAL: For experimental flow where 'Suggest title' in
   * Confluence title toolbar will trigger the 'Suggest a title' flow in Editor AI.
   * Forces whole document selection, even if an existing selection exists.
   */ if ((0, $66XPt.isConfluenceTitleToolbarSuggestTitle)({
        configItem: configItem,
        lastTriggeredFrom: lastTriggeredFrom
    })) useCurrentSelection = false;
    // First get the positions that the decorations will be added to the document at
    const { startPos: startPos, endPos: endPos } = $200eb5579fff6be8$var$getInitialPositions(useCurrentSelection ? state.selection : new (0, $kpTIW.AllSelection)(state.doc));
    // Then create the decorations and add them to a decoration set
    const startWidgetDecoration = $200eb5579fff6be8$export$6428b9f2a07e29a5(startPos, 'start');
    const endWidgetDecoration = $200eb5579fff6be8$export$6428b9f2a07e29a5(endPos, 'end');
    const highlightInlineDecoration = $200eb5579fff6be8$export$1690e22aee311809(startPos, endPos);
    const widgetDecorations = startPos === endPos ? [
        endWidgetDecoration
    ] : [
        startWidgetDecoration,
        endWidgetDecoration
    ];
    const modalDecorationSet = (0, $fBDHJ.DecorationSet).create(state.doc, [
        ...widgetDecorations,
        highlightInlineDecoration
    ]);
    // This "command" is later picked up by a state reducer
    const action = {
        type: 'SHOW_MODAL',
        data: {
            lastTriggeredFrom: lastTriggeredFrom,
            triggerMethod: triggerMethod,
            modalDecorationSet: modalDecorationSet,
            configItem: configItem,
            modalMountedTimeStamp: Date.now()
        }
    };
    // Clear the selection after opening the modal to hide annotation toolbar
    return (0, $9O1Gs.createCommand)(action, (tr)=>{
        const { to: to, from: from } = tr.selection;
        if (to !== from) tr.setSelection((0, $kpTIW.TextSelection).create(tr.doc, to));
        return tr;
    });
};
const $200eb5579fff6be8$export$d547a4e9ddb6b51 = (modalDecorationSet)=>{
    const action = {
        type: 'END_EXPERIENCE',
        data: modalDecorationSet ? {
            modalDecorationSet: modalDecorationSet
        } : {}
    };
    return (0, $9O1Gs.createCommand)(action);
};

});
parcelRegister("9O1Gs", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $723a16f502ead239$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "createCommand", () => $723a16f502ead239$export$8d4021544bdece00);
$parcel$export(module.exports, "getPluginState", () => $723a16f502ead239$export$f05434c51e3762e);
$parcel$export(module.exports, "createDecorationPluginFactory", () => $723a16f502ead239$export$5796e41b25b7e5ea);

var $h2nc0 = parcelRequire("h2nc0");

var $fBDHJ = parcelRequire("fBDHJ");

var $2KDKi = parcelRequire("2KDKi");

var $bhF7K = parcelRequire("bhF7K");

var $3zwnb = parcelRequire("3zwnb");

var $i0Grp = parcelRequire("i0Grp");

var $eJsil = parcelRequire("eJsil");

var $8pKer = parcelRequire("8pKer");
/**
 * This creates a function which is called inside the prosemirror plugin state apply method via the
 * pluginFactory.
 *
 * The docChanged is called for every transaction where the docChanged property of the transaction is true,
 * and the returned value is set to the PluginState value.
 *
 * It takes a dispatchAnalyticsEvent in order to track whether the mapping we use to build a new PluginState
 * is throwing any errors.  This is a temporary measure to track whether we are hitting any edge cases
 * where the mapping is throwing errors. If we find that this is happening, we will revisit the approach
 * to building a new PluginState.
 *
 * The state being built here is used to  from the document used to;
 * - both apply and remove decorations to display the AI modal,
 * - apply decorations following the insertion of AI generated content, to highlight the inserted content (these are removed in the selectionChanged below).
 *
 * In future the intention is to seperate these concerns into seperate plugins.
 */ function $723a16f502ead239$var$createOnDocChanged({ dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
    return function docChanged(tr, pluginState) {
        // In some collab edge cases mapping decorations could throw an error
        // The ProseMirror .mapping approach has a “dangerous” axiom:
        // Besides the initial state, a document will always “change” through a Transaction
        // However, in some conditions we may reconfigure the EditorState, and a new document
        // will be created without a transaction.
        // This try/catch intends to track cases of this happening and see if it impacts users
        try {
            var _tr$getMeta;
            // Check if transaction is from inserting AI generated content
            const generatedContentMeta = tr.getMeta('isAiContentTransformation');
            // Return with generated content decoration
            if (generatedContentMeta) {
                const newDecoration = (0, $bhF7K.getGeneratedDecorationFromTransaction)(tr);
                if (!newDecoration) throw new Error('Did not expect not to find new content in a `isAiContentTransformation` transaction?');
                return {
                    ...pluginState,
                    modalDecorationSet: (0, $fBDHJ.DecorationSet).create(tr.doc, newDecoration)
                };
            }
            // If there is no existing modal decoration -- exit early
            if (pluginState.modalDecorationSet === (0, $fBDHJ.DecorationSet).empty) return pluginState;
            // Check if generated AI decorations already exist
            const hasGeneratedContentDecoration = (0, $eJsil.hasGeneratedContentDecorations)(pluginState);
            const isRemote = (_tr$getMeta = tr.getMeta('isRemote')) !== null && _tr$getMeta !== void 0 ? _tr$getMeta : false;
            /**
       * Make sure it isn't a selection change from an appendTransaction
       */ const selectionWasSet = tr.selectionSet && tr.getMeta('appendedTransaction') === undefined;
            /**
       * Remove decorations if
       * - current user interacts with doc
       *   - and it is not an appendedTransaction
       */ if (hasGeneratedContentDecoration && !isRemote && selectionWasSet) return {
                ...pluginState,
                modalDecorationSet: (0, $fBDHJ.DecorationSet).empty
            };
            // Map the modal decorationSet against the transaction
            const mappedModalDecorationSet = pluginState.modalDecorationSet.map(tr.mapping, tr.doc);
            // return mapped decoration set for case where other users in collab are making changes to doc
            if (hasGeneratedContentDecoration) return {
                ...pluginState,
                modalDecorationSet: mappedModalDecorationSet
            };
            // Find the start/inline/end decoration
            const decorations = mappedModalDecorationSet.find();
            let inlineDecoration = decorations.find((d)=>d.spec.key === 'inlineDecoration');
            let startDecoration = decorations.find((d)=>d.spec.key === 'startWidgetDecoration');
            let endDecoration = decorations.find((d)=>d.spec.key === 'endWidgetDecoration');
            // AI experience was triggered by quick insert, no start widget or inline decoration
            if (endDecoration && !startDecoration && !inlineDecoration) return {
                ...pluginState,
                modalDecorationSet: mappedModalDecorationSet
            };
            // Check if inlineDecoration has any content by looping through the textBetween
            const inlineDecorationHasContent = !!inlineDecoration && tr.doc.textBetween(inlineDecoration.from, inlineDecoration.to) !== '';
            // Return with no decorations if inline decoration does not exist
            // Handles edge case where the inline decoration can't be deleted at the start
            // of a doc even when it has no content
            // OR if it has no content (eg. selection is just empty paragraphs)
            if (!inlineDecoration || !inlineDecorationHasContent) return {
                ...pluginState,
                modalDecorationSet: (0, $fBDHJ.DecorationSet).empty
            };
            // Handle the case where doc changes move inlineDecoration to position 0
            // We cannot add text before inline decoration if from position is 0
            // Remove and recreate inline decoration starting at position 1
            if (inlineDecoration.from === 0) inlineDecoration = (0, $2KDKi.createInlineDecoration)(inlineDecoration.from || 1, // widget cannot be placed at pos 0,
            inlineDecoration.to || 1 // widget cannot be placed at pos 0
            );
            // Create and add start widget into DecorationSet if it's been deleted
            if (!startDecoration) startDecoration = (0, $2KDKi.createWidgetDecoration)(inlineDecoration.from, 'start');
            // Create and add end widget into DecorationSet if it doesn't exist
            if (!endDecoration) endDecoration = (0, $2KDKi.createWidgetDecoration)(inlineDecoration.to, 'end');
            return {
                ...pluginState,
                modalDecorationSet: (0, $fBDHJ.DecorationSet).create(tr.doc, [
                    startDecoration,
                    inlineDecoration,
                    endDecoration
                ])
            };
        } catch (error) {
            const analyticsPayload = {
                action: 'unhandledErrorCaught',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'decorationPluginFactory',
                attributes: {
                    errorType: 'handleDocChangedError',
                    errorMessage: (0, $8pKer.ErrorUtils).extractErrorMessage(error)
                },
                eventType: 'operational'
            };
            dispatchAnalyticsEvent(analyticsPayload);
            return {
                ...pluginState,
                modalDecorationSet: (0, $fBDHJ.DecorationSet).empty
            };
        }
    };
}
/**
 * This function is called inside the prosemirror plugin state apply method via the pluginFactory.
 *
 * The docChanged is called for every transaction where the selectionSet property of the transaction is true,
 * and the returned value is set to the PluginState value.
 *
 * The state transformation here is being used to remove the decorations that are added when the AI experience has inserted content.
 *
 * These are added inside docChanged above.
 *
 * In future the intention is to seperate this concerns into seperate plugin (currently the majority of this file is dealing
 * with decorations related to the presentation of a modal for the AI experience).
 */ function $723a16f502ead239$var$onSelectionChanged(_tr, pluginState) {
    if (pluginState.modalDecorationSet === (0, $fBDHJ.DecorationSet).empty || pluginState.configItem) return pluginState;
    if ((0, $eJsil.hasGeneratedContentDecorations)(pluginState)) return {
        ...pluginState,
        modalDecorationSet: (0, $fBDHJ.DecorationSet).empty
    };
    return pluginState;
}
const $723a16f502ead239$export$d4c72bab9d6cc13a = {
    /**
   * Longer term it would be good to expand the decorationset to include
   * the entire selection, as well as the 'valid inline position' to place
   * an inline widget visualising start+end of valid selections
   */ modalDecorationSet: (0, $fBDHJ.DecorationSet).empty
};
const $723a16f502ead239$export$8d4021544bdece00 = (action, transform)=>{
    return (state, dispatch)=>{
        if (dispatch) {
            const tr = transform ? transform(state.tr, state) : state.tr;
            const resolvedAction = (0, $h2nc0.isFunction)(action) ? action(state) : action;
            if (tr && resolvedAction) dispatch(tr.setMeta((0, $3zwnb.aiExperienceDecorationPluginKey), resolvedAction));
            else return false;
        }
        return true;
    };
};
const $723a16f502ead239$export$f05434c51e3762e = (state)=>{
    return (0, $3zwnb.aiExperienceDecorationPluginKey).getState(state) || $723a16f502ead239$export$d4c72bab9d6cc13a;
};
const $723a16f502ead239$export$5796e41b25b7e5ea = ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const { createPluginState: createPluginState, createCommand: createCommand, getPluginState: getPluginState } = (0, $h2nc0.pluginFactory)((0, $3zwnb.aiExperienceDecorationPluginKey), (0, $i0Grp.createReducer)(()=>$723a16f502ead239$export$d4c72bab9d6cc13a), {
        onDocChanged: $723a16f502ead239$var$createOnDocChanged({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent
        }),
        onSelectionChanged: $723a16f502ead239$var$onSelectionChanged
    });
    return {
        createPluginState: createPluginState,
        createCommand: createCommand,
        getPluginState: getPluginState
    };
};

});
parcelRegister("h2nc0", function(module, exports) {

$parcel$export(module.exports, "isFunction", () => $c6749d21ab3ece8a$export$f6e2535fb5126e54);
$parcel$export(module.exports, "pluginFactory", () => $c6749d21ab3ece8a$export$3dd00fb488ab385a);
// File copied from `packages/editor/editor-common/src/utils/plugin-state-factory.ts`
// Copied from `packages/editor/editor-common/src/event-dispatcher/index.ts`
// import { Dispatch } from '../event-dispatcher';
// Copied from `packages/editor/editor-common/src/types/command.ts`
// import { Command } from '../types';
/**
 * Creates a ProseMirror plugin's state and handles UI updates.
 *
 * Here's a few things to keep in mind:
 * - plugin's state is stored as a single object
 * - `Reducer` specifies how plugin's state changes in response to commands
 * - `Command` describes only what happen, but not how state changes
 * - `mapping` could be used to map ProseMirror positions stored in plugin's state
 *
 * Example:
 *  const { createPluginState, createCommand, getPluginState } = pluginFactory(
 *    reducer,
 *    pluginKey
 *  );
 *
 *  export const createPlugin = (dispatch: Dispatch, initialState) =>
 *    new SafePlugin({
 *      state: createPluginState(dispatch, initialState),
 *      key: pluginKey
 *    });
 *
 * Example of a reducer:
 *
 *  export const reducer = (
 *    state: TablePluginState,
 *    action: TableAction,
 *  ): TablePluginState => {
 *    switch (action.type) {
 *      case 'TOGGLE_CONTEXTUAL_MENU':
 *      return {
 *        ...state,
 *        isContextualMenuOpen: !state.isContextualMenuOpen,
 *      };
 *    default:
 *      return state;
 *    }
 *  };
 *
 *
 * Example of a command:
 *
 * export const toggleContextualMenu = createCommand({
 *   type: 'TOGGLE_CONTEXTUAL_MENU',
 * }, tr => tr.setMeta('addToHistory', false));
 *
 */ function $c6749d21ab3ece8a$export$f6e2535fb5126e54(x) {
    return typeof x === 'function';
}
function $c6749d21ab3ece8a$export$3dd00fb488ab385a(pluginKey, reducer, options = {}) {
    const { mapping: mapping, onDocChanged: onDocChanged, onSelectionChanged: onSelectionChanged } = options;
    return {
        createPluginState (dispatch, initialState) {
            return {
                init: (_, state)=>$c6749d21ab3ece8a$export$f6e2535fb5126e54(initialState) ? initialState(state) : initialState,
                apply: (tr, _pluginState, _oldEditorState, newEditorState)=>{
                    const oldPluginState = mapping ? mapping(tr, _pluginState, newEditorState) : _pluginState;
                    let newPluginState = oldPluginState;
                    const meta = tr.getMeta(pluginKey);
                    if (meta) newPluginState = reducer(oldPluginState, meta);
                    if (onDocChanged && tr.docChanged) newPluginState = onDocChanged(tr, newPluginState, newEditorState);
                    else if (onSelectionChanged && tr.selectionSet) newPluginState = onSelectionChanged(tr, newPluginState, newEditorState);
                    if (newPluginState !== oldPluginState) dispatch(pluginKey, newPluginState);
                    return newPluginState;
                }
            };
        },
        createCommand (action, transform) {
            return (state, dispatch)=>{
                if (dispatch) {
                    const tr = transform ? transform(state.tr, state) : state.tr;
                    const resolvedAction = $c6749d21ab3ece8a$export$f6e2535fb5126e54(action) ? action(state) : action;
                    if (tr && resolvedAction) dispatch(tr.setMeta(pluginKey, resolvedAction));
                    else return false;
                }
                return true;
            };
        },
        getPluginState (state) {
            return pluginKey.getState(state);
        }
    };
}

});

parcelRegister("bhF7K", function(module, exports) {

$parcel$export(module.exports, "getValidEndTextPosition", () => $83712e9ecd4e7a3f$export$a2bf0757549da456);
$parcel$export(module.exports, "findFirstReplaceStep", () => $83712e9ecd4e7a3f$export$ec5fde712084a8ed);
$parcel$export(module.exports, "getGeneratedDecorationFromTransaction", () => $83712e9ecd4e7a3f$export$9d1e89ce90c0a9a);
/**
 * Figure out what to do with these, possibly export/shift into editor-common
 * during move into editor-core
 */ 
var $2KDKi = parcelRequire("2KDKi");

var $d6JJW = parcelRequire("d6JJW");
function $83712e9ecd4e7a3f$var$getClosestValidTextPositionBefore({ pos: pos, doc: doc }) {
    let validPos = pos;
    while(validPos > 0){
        if (doc.resolve(validPos).parent.inlineContent) break;
        validPos--;
    }
    return validPos;
}
function $83712e9ecd4e7a3f$var$getClosestValidTextPositionAfter({ pos: pos, doc: doc }) {
    let validPos = pos;
    let isValidPos = false;
    while(isValidPos === false){
        if (doc.resolve(validPos).parent.inlineContent) {
            isValidPos = true;
            break;
        }
        validPos++;
    }
    return validPos;
}
function $83712e9ecd4e7a3f$var$findLastChildWithTextContent(content) {
    if (content.childCount <= 0) return null;
    let count = content.childCount - 1;
    let validNode = content.child(count);
    while(count >= 0){
        if (content.child(count).textContent !== '') break;
        count--;
    }
    return validNode;
}
function $83712e9ecd4e7a3f$var$getEndPosition({ step: step, doc: doc }) {
    let validPos = step.from + step.slice.size;
    let isValidPos = false;
    // Fragments can contain empty nodes, find the last childNode that has textContent
    const validNode = $83712e9ecd4e7a3f$var$findLastChildWithTextContent(step.slice.content);
    // Return start position if there are no valid nodes
    if (!validNode) return step.from;
    // Find textContent of last childNode with textContent
    const textContent = validNode.textContent;
    // Loop through endPos and find position where textBetween start and endPos matches textContent from last childNode in step
    // Check slice created between the positions to ensure no empty child nodes
    while(isValidPos === false && validPos > 0){
        var _slice$content$lastCh;
        const textBetween = doc.textBetween(step.from, validPos);
        const slice = doc.slice(step.from, validPos);
        if (textBetween.endsWith(textContent) && ((_slice$content$lastCh = slice.content.lastChild) === null || _slice$content$lastCh === void 0 ? void 0 : _slice$content$lastCh.textContent) !== '') {
            isValidPos = true;
            break;
        }
        validPos--;
    }
    return validPos;
}
function $83712e9ecd4e7a3f$export$e9a1e089d4b44f6c({ pos: pos, doc: doc }) {
    let startPos = pos;
    let isValidPos = false;
    while(isValidPos === false){
        if (doc.nodeAt(startPos)) {
            isValidPos = true;
            break;
        }
        startPos++;
    }
    return $83712e9ecd4e7a3f$var$getClosestValidTextPositionAfter({
        pos: startPos,
        doc: doc
    });
}
function $83712e9ecd4e7a3f$export$a2bf0757549da456({ step: step, doc: doc }) {
    const endPos = $83712e9ecd4e7a3f$var$getEndPosition({
        step: step,
        doc: doc
    });
    return $83712e9ecd4e7a3f$var$getClosestValidTextPositionBefore({
        pos: endPos,
        doc: doc
    });
}
function $83712e9ecd4e7a3f$export$ec5fde712084a8ed(steps) {
    const step = steps.find((step)=>step instanceof (0, $d6JJW.ReplaceStep) || step instanceof (0, $d6JJW.ReplaceAroundStep));
    if (!step) return null;
    return step;
}
function $83712e9ecd4e7a3f$export$9d1e89ce90c0a9a(transaction) {
    const step = $83712e9ecd4e7a3f$export$ec5fde712084a8ed(transaction.steps);
    if (!step) return null;
    const validStartDecorationPos = $83712e9ecd4e7a3f$export$e9a1e089d4b44f6c({
        pos: step.from,
        doc: transaction.doc
    });
    const validEndDecorationPos = $83712e9ecd4e7a3f$export$a2bf0757549da456({
        step: step,
        doc: transaction.doc
    });
    return (0, $2KDKi.createGeneratedContentDecorations)(validStartDecorationPos, validEndDecorationPos);
}

});

parcelRegister("3zwnb", function(module, exports) {

$parcel$export(module.exports, "aiExperienceDecorationPluginKey", () => $299dc08e1712dae9$export$32db9543f41e636c);

var $kpTIW = parcelRequire("kpTIW");
const $299dc08e1712dae9$export$32db9543f41e636c = new (0, $kpTIW.PluginKey)('aiExperienceDecoration');

});

parcelRegister("i0Grp", function(module, exports) {

$parcel$export(module.exports, "createReducer", () => $d1c9260475ac1ac2$export$473eb76d322d0290);
function $d1c9260475ac1ac2$export$473eb76d322d0290(getInitialState) {
    function reducer(state, action) {
        switch(action.type){
            case 'END_EXPERIENCE':
                return {
                    ...getInitialState(),
                    ...action.data
                };
            case 'SHOW_MODAL':
                return {
                    ...state,
                    ...action.data
                };
            default:
                return state;
        }
    }
    return reducer;
}

});

parcelRegister("eJsil", function(module, exports) {

$parcel$export(module.exports, "hasGeneratedContentDecorations", () => $ab9b37737311b75c$export$4306d8811b2d2e31);
const $ab9b37737311b75c$export$4306d8811b2d2e31 = (state)=>state.modalDecorationSet.find(undefined, undefined, (spec)=>spec.key === 'generatedInlineDecoration' || spec.key === 'generatedStartWidget' || spec.key === 'generatedEndWidget').length > 0;

});

parcelRegister("8pKer", function(module, exports) {

$parcel$export(module.exports, "ErrorUtils", () => $620485351b22a8f8$export$7edca8cfa9634e37);

var $5zQU9 = parcelRequire("5zQU9");
class $620485351b22a8f8$export$7edca8cfa9634e37 {
    static extractErrorMessage(error) {
        if (error instanceof Error) return $620485351b22a8f8$export$7edca8cfa9634e37.redactSensitiveInfo(error.message || 'unknown-error');
        else return $620485351b22a8f8$export$7edca8cfa9634e37.redactSensitiveInfo(String(error));
    }
}
(0, $5zQU9.default)($620485351b22a8f8$export$7edca8cfa9634e37, "redactSensitiveInfo", (str)=>{
    const redacted = str.replace(/[^,\s]+\@[^,\s]+/g, '[REDACTED EMAIL]').replace(/[^,\s]+\.[^,\s]+/g, '[REDACTED URL]');
    return redacted;
});

});


parcelRegister("aFbB0", function(module, exports) {

$parcel$export(module.exports, "addAnalytics", () => $7c36ba6ab48f7ea3$export$5bef18c22bfe95d);
$parcel$export(module.exports, "useFireAIAnalyticsEvent", () => $7c36ba6ab48f7ea3$export$5098b64908ee530);

var $bFzGY = parcelRequire("bFzGY");

var $7kz4m = parcelRequire("7kz4m");

var $6PJBT = parcelRequire("6PJBT");

var $j7TpU = parcelRequire("j7TpU");

var $XHGTv = parcelRequire("XHGTv");

var $40bp2 = parcelRequire("40bp2");
function $7c36ba6ab48f7ea3$export$2758b2c09b7b9915() {
    const editorAiFeatureFlags = {};
    /**
   * Note that we are not required to cleanup getBooleanFF usage here.
   * This is a helper function to get active Editor AI feature flags.
   *
   * We also trim flag keys in our events as a temporary measure against
   * Statsig errors when metadata is too large.
   */ Object.keys((0, $40bp2.EDITOR_AI_PLATFORM_FEATURE_FLAGS)).forEach((flagKey)=>{
        const EDITOR_FLAG_PREFIX = 'platform.editor.';
        const trimmedFlagKey = flagKey.startsWith(EDITOR_FLAG_PREFIX) ? flagKey.replace(EDITOR_FLAG_PREFIX, '') : flagKey;
        // eslint-disable-next-line @atlaskit/platform/no-invalid-feature-flag-usage
        editorAiFeatureFlags[trimmedFlagKey] = (0, $XHGTv.getBooleanFF)(flagKey);
    });
    return editorAiFeatureFlags;
}
function $7c36ba6ab48f7ea3$export$e65dc2451c080d01(payload) {
    const packageInfo = (0, $j7TpU.getPackageInfo)();
    const attributes = payload.attributes || {};
    let isInternalOrSyntheticUser = false;
    if ((0, $XHGTv.getBooleanFF)('platform.editor.ai-tag-synthetic-and-internal-users_eb7tz')) isInternalOrSyntheticUser = true;
    return {
        ...payload,
        attributes: {
            ...attributes,
            aiPluginPackageName: packageInfo.packageName,
            aiPluginPackageVersion: packageInfo.packageVersion,
            aiPluginFeatureFlags: $7c36ba6ab48f7ea3$export$2758b2c09b7b9915(),
            isInternalOrSyntheticUser: isInternalOrSyntheticUser
        }
    };
}
// This utils is referenced from packages/editor/editor-core/src/analytics-api/attach-payload-into-transaction.ts
// Note: this adds extra step to a transaction which effectively marks it as docChanged and can cause editor onchange to fire on dispatch
function $7c36ba6ab48f7ea3$var$attachPayloadIntoTransaction({ editorState: editorState, payload: payload, channel: channel = (0, $6PJBT.FabricChannel).editor }) {
    return (tr)=>{
        const { storedMarks: storedMarks } = tr;
        const pos = tr.mapping.map(editorState.selection.$from.pos, -1);
        tr.step(new (0, $7kz4m.AnalyticsStep)([
            {
                payload: $7c36ba6ab48f7ea3$export$e65dc2451c080d01(payload),
                channel: channel
            }
        ], [], // We don't understand now why we need position in AnalyticsStep.
        // So we are keeping same as it is in original util.
        // Below comment is taken from original util from packages/editor/editor-core/src/analytics-api/attach-payload-into-transaction.ts
        // We need to create the step based on a position, this prevent split history for relative changes.
        pos));
        // We don't understand now why we need to store marks again in transaction.
        // So we are keeping same as it is in original util.
        // Below comment is taken from original util from packages/editor/editor-core/src/analytics-api/attach-payload-into-transaction.ts
        // When you add a new step all the storedMarks are removed it
        if (storedMarks) tr.setStoredMarks(storedMarks);
        return true;
    };
}
function $7c36ba6ab48f7ea3$export$5bef18c22bfe95d({ editorState: editorState, tr: tr, payload: payload, channel: channel = (0, $6PJBT.FabricChannel).editor }) {
    $7c36ba6ab48f7ea3$var$attachPayloadIntoTransaction({
        editorState: editorState,
        payload: payload,
        channel: channel
    })(tr);
    return tr;
}
function $7c36ba6ab48f7ea3$export$af9baadf0e4f6e13({ payload: payload, channel: channel = (0, $6PJBT.FabricChannel).editor }) {
    return (command)=>(state, dispatch, view)=>command(state, (tr)=>{
                if (dispatch) {
                    if (payload instanceof Function) {
                        const dynamicPayload = payload(state);
                        if (dynamicPayload) dispatch($7c36ba6ab48f7ea3$export$5bef18c22bfe95d({
                            editorState: state,
                            tr: tr,
                            payload: dynamicPayload,
                            channel: channel
                        }));
                    } else dispatch($7c36ba6ab48f7ea3$export$5bef18c22bfe95d({
                        editorState: state,
                        tr: tr,
                        payload: payload,
                        channel: channel
                    }));
                }
            }, view);
}
function $7c36ba6ab48f7ea3$export$12ef4e1e68d53406(createAnalyticsEvent) {
    return ({ payload: payload, channel: channel = (0, $6PJBT.FabricChannel).editor })=>{
        if (!createAnalyticsEvent) return;
        const fireEvent = ()=>{
            var _createAnalyticsEvent;
            return (_createAnalyticsEvent = createAnalyticsEvent($7c36ba6ab48f7ea3$export$e65dc2451c080d01(payload))) === null || _createAnalyticsEvent === void 0 ? void 0 : _createAnalyticsEvent.fire(channel);
        };
        if (window.requestIdleCallback) window.requestIdleCallback(fireEvent);
        else if (window.requestAnimationFrame) window.requestAnimationFrame(fireEvent);
        else setTimeout(fireEvent, 0);
    };
}
function $7c36ba6ab48f7ea3$export$5098b64908ee530() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fireAIAnalyticsEvent = $7c36ba6ab48f7ea3$export$12ef4e1e68d53406(createAnalyticsEvent);
    return fireAIAnalyticsEvent;
}

});
parcelRegister("7kz4m", function(module, exports) {

$parcel$export(module.exports, "AnalyticsStep", () => $55659ab20b6cb2c4$export$cc33374693c7fb23);

var $5zQU9 = parcelRequire("5zQU9");

var $d6JJW = parcelRequire("d6JJW");

var $7dkLM = parcelRequire("7dkLM");
const $55659ab20b6cb2c4$export$9126078e8b0f76e4 = 'atlaskit-analytics';
const $55659ab20b6cb2c4$export$89a6d622be04d823 = 'atlaskit-analytics-invert';
var $55659ab20b6cb2c4$var$HISTORY_ACTIONS = /*#__PURE__*/ function(HISTORY_ACTIONS) {
    HISTORY_ACTIONS["UNDID"] = "undid";
    HISTORY_ACTIONS["REDID"] = "redid";
    return HISTORY_ACTIONS;
}($55659ab20b6cb2c4$var$HISTORY_ACTIONS || {});
/** Creates undo event from a normal analytics event */ function $55659ab20b6cb2c4$var$createUndoEvent(analyticsEvent) {
    var _analyticsEvent$paylo;
    return {
        ...analyticsEvent,
        payload: {
            action: $55659ab20b6cb2c4$var$HISTORY_ACTIONS.UNDID,
            actionSubject: analyticsEvent.payload.actionSubject,
            actionSubjectId: analyticsEvent.payload.action,
            attributes: {
                ...analyticsEvent.payload.attributes,
                actionSubjectId: analyticsEvent.payload.actionSubjectId,
                inputMethod: ((_analyticsEvent$paylo = analyticsEvent.payload.attributes) === null || _analyticsEvent$paylo === void 0 ? void 0 : _analyticsEvent$paylo.inputMethod) || ''
            },
            eventType: 'track'
        }
    };
}
/** Toggles event action between undo & redo */ const $55659ab20b6cb2c4$var$toggleEventAction = (analyticsEvent)=>({
        ...analyticsEvent,
        payload: {
            ...analyticsEvent.payload,
            action: analyticsEvent.payload.action === $55659ab20b6cb2c4$var$HISTORY_ACTIONS.UNDID ? $55659ab20b6cb2c4$var$HISTORY_ACTIONS.REDID : $55659ab20b6cb2c4$var$HISTORY_ACTIONS.UNDID
        }
    });
function $55659ab20b6cb2c4$var$isHistoryAnalyticsEvent(event) {
    return event.payload.action === $55659ab20b6cb2c4$var$HISTORY_ACTIONS.UNDID || event.payload.action === $55659ab20b6cb2c4$var$HISTORY_ACTIONS.REDID;
}
class $55659ab20b6cb2c4$export$cc33374693c7fb23 extends (0, $d6JJW.Step) {
    constructor(analyticsEvents, actionsToIgnore = [], pos // Used to create the map, prevent splitting history.
    ){
        super();
        (0, $5zQU9.default)(this, "analyticsEvents", []);
        (0, $5zQU9.default)(this, "actionsToIgnore", []);
        this.analyticsEvents = analyticsEvents;
        this.actionsToIgnore = actionsToIgnore;
        this.pos = pos;
    }
    /**
   * Generate new undo/redo analytics event when step is inverted
   */ invert() {
        const analyticsEvents = this.analyticsEvents.filter((analyticsEvent)=>this.actionsToIgnore.indexOf(analyticsEvent.payload.action) === -1).map((analyticsEvent)=>{
            if ($55659ab20b6cb2c4$var$isHistoryAnalyticsEvent(analyticsEvent)) return $55659ab20b6cb2c4$var$toggleEventAction(analyticsEvent);
            else return $55659ab20b6cb2c4$var$createUndoEvent(analyticsEvent);
        });
        return new $55659ab20b6cb2c4$export$cc33374693c7fb23(analyticsEvents, []);
    }
    apply(doc) {
        return (0, $d6JJW.StepResult).ok(doc);
    }
    map(mapping) {
        let newPos = this.pos;
        if (typeof newPos === 'number') newPos = mapping.map(newPos);
        // Return the same events, this step will never be removed
        return new $55659ab20b6cb2c4$export$cc33374693c7fb23(this.analyticsEvents, this.actionsToIgnore, newPos);
    }
    getMap() {
        if (typeof this.pos === 'number') return new (0, $d6JJW.StepMap)([
            this.pos,
            0,
            0
        ]);
        return new (0, $d6JJW.StepMap)([]);
    }
    merge(other) {
        if (other instanceof $55659ab20b6cb2c4$export$cc33374693c7fb23) {
            const otherAnalyticsEvents = other.analyticsEvents;
            return new $55659ab20b6cb2c4$export$cc33374693c7fb23([
                ...otherAnalyticsEvents,
                ...this.analyticsEvents
            ]);
        }
        return null;
    }
    toJSON() {
        return {
            stepType: $55659ab20b6cb2c4$export$9126078e8b0f76e4
        };
    }
    static fromJSON() {
        return new (0, $d6JJW.ReplaceStep)(0, 0, (0, $7dkLM.Slice).empty);
    }
}
/** Register this step with Prosemirror */ (0, $d6JJW.Step).jsonID($55659ab20b6cb2c4$export$9126078e8b0f76e4, $55659ab20b6cb2c4$export$cc33374693c7fb23);

});

parcelRegister("j7TpU", function(module, exports) {

$parcel$export(module.exports, "getPackageInfo", () => $dec9a86ed4f19ede$export$cd17d76da7967240);
const $dec9a86ed4f19ede$var$packageName = "@atlassian/editor-plugin-ai";
const $dec9a86ed4f19ede$var$packageVersion = "25.22.0";
function $dec9a86ed4f19ede$export$cd17d76da7967240() {
    return {
        packageName: $dec9a86ed4f19ede$var$packageName,
        packageVersion: $dec9a86ed4f19ede$var$packageVersion
    };
}

});

parcelRegister("40bp2", function(module, exports) {

$parcel$export(module.exports, "EDITOR_AI_PLATFORM_FEATURE_FLAGS", () => $2ea001e46fc26e61$export$ade036ff0c819406);
/********************************************************************
 * Do not update this file manually!
 * Use 'yarn sync-flags' inside 'editor-plugin-ai' folder to update it
 *********************************************************************/ const $2ea001e46fc26e61$export$ade036ff0c819406 = {
    'platform.editor.ai-assistance-service-free-generate': {
        type: 'boolean'
    },
    'platform.editor.ai-markdown-plus_9v1w7': {
        type: 'boolean'
    },
    'platform.editor.ai-markdown-plus-v2_j5m0c': {
        type: 'boolean'
    },
    'platform.editor.ai-send-full-content_r1qpp': {
        type: 'boolean'
    },
    'platform.editor.ai-use-selection-toolbar_xosiv': {
        type: 'boolean'
    },
    'platform.editor.enable-selection-toolbar_ucdwd': {
        type: 'boolean'
    },
    'platform.editor.ai-remove-beta-lozenge_s5yrq': {
        type: 'boolean',
        referenceOnly: true
    },
    'platform.editor.ai-remove-beta-lozenge-jpd_1t8rt': {
        type: 'boolean',
        referenceOnly: true
    },
    'platform.editor.ai-bitbucket-partial-prompt-pr-template': {
        type: 'boolean'
    },
    'platform.editor.ai-save-response-history-in-state_dw857': {
        type: 'boolean'
    },
    'platform.editor.ai-dynamic-show-hide-quick-insert-items_4ie8s': {
        type: 'boolean'
    },
    'platform.editor.ai-markdown-plus-media_svrli': {
        type: 'boolean'
    },
    'platform.editor.ai-markdown-plus-extension_m8eb1': {
        type: 'boolean'
    },
    'platform.editor.ai-markdown-plus-marks_eitjo': {
        type: 'boolean'
    },
    'platform.editor.ai-markdown-plus-v2-streaming_o9h6u': {
        type: 'boolean'
    },
    'platform.editor.ai-markdown-plus-nested-expands_ru5xx': {
        type: 'boolean'
    },
    'platform.editor.ai-markdown-plus-expands_5h7qa': {
        type: 'boolean'
    },
    'platform.editor.ai-markdown-plus-panels_veh92': {
        type: 'boolean'
    },
    'platform.editor.ai-markdown-plus-decisions_4lriq': {
        type: 'boolean'
    },
    'platform.editor.ai-markdown-plus-tables_ipb1h': {
        type: 'boolean'
    },
    'platform.editor.ai-markdown-plus-layouts_jw2zj': {
        type: 'boolean'
    },
    'platform.editor.ai-tag-synthetic-and-internal-users_eb7tz': {
        type: 'boolean'
    },
    'platform.editor.ai-enable-multi-lang-translation-prompts': {
        type: 'boolean'
    },
    'platform.editor.ai-enable-multi-lang-translations-in-quick-insert': {
        type: 'boolean'
    },
    'platform.editor.ai-interrogate-with-convo-ai': {
        type: 'boolean'
    },
    'platform.editor.ai-lightweight-editor-prompt_f92x1': {
        type: 'boolean'
    },
    'platform.editor.ai-suggest-title-in-title-toolbar_h3ww0': {
        type: 'boolean'
    },
    'platform.editor.ai-assistance-service-summarise-writing': {
        type: 'boolean'
    },
    'platform.editor.ai-assistance-service-improve-writing': {
        type: 'boolean'
    },
    'platform.editor.ai-assistance-service-fix-spelling-grammar': {
        type: 'boolean'
    },
    'platform.editor.ai-assistance-service-suggest-title': {
        type: 'boolean'
    },
    'platform.editor.ai-assistance-service-make-shorter': {
        type: 'boolean'
    },
    'platform.editor.ai-assistance-service-find-action-items': {
        type: 'boolean'
    },
    'platform.editor.ai-assistance-service-brainstorm': {
        type: 'boolean'
    },
    'platform.editor.ai-assistance-service-change-tone': {
        type: 'boolean'
    },
    'platform.editor.ai-assistance-service-atlas-custom-shorten': {
        type: 'boolean'
    },
    'platform.editor.ai-real-time-spelling-and-grammar_mtaik': {
        type: 'boolean'
    },
    'platform.editor.ai.enable-ai-summary-blocks_r040m': {
        type: 'boolean'
    },
    'platform.editor.ai.enable-ai-action-items-block_vctyf': {
        type: 'boolean'
    },
    'platform.editor.ai-lightweight-editor-interrogate_x356n': {
        type: 'boolean',
        referenceOnly: true
    },
    'platform.reformat-issue-with-template-in-jira_jc0pb': {
        type: 'boolean'
    },
    'platform.gravity.enable-the-support-for-status-labels-for-editor-ai-suggestions_em3y4': {
        type: 'boolean'
    },
    'platform.editor.ai-multi-lang-translations-popular-sort-order': {
        type: 'boolean'
    },
    'platform.editor.ai-translate-in-floating-toolbar_7dqkh': {
        type: 'boolean'
    },
    'platform.editor.explicit-html-element-check': {
        type: 'boolean'
    },
    'platform.editor.ai-proactive-ai-api-url_k6yy7': {
        type: 'boolean'
    },
    'platform.editor.ai-rovo-agents': {
        type: 'boolean'
    }
};

});


parcelRegister("66XPt", function(module, exports) {

$parcel$export(module.exports, "isConfluenceTitleToolbarSuggestTitle", () => $4731b6719e24a87d$export$fc21f0ec31fe4ec0);
const $4731b6719e24a87d$export$fc21f0ec31fe4ec0 = ({ configItem: configItem, lastTriggeredFrom: lastTriggeredFrom })=>{
    if (!configItem || !lastTriggeredFrom) return false;
    const configItemDefaultTitle = configItem.title({
        formatMessage: (message)=>typeof message.defaultMessage === 'string' ? message.defaultMessage : ''
    });
    return configItemDefaultTitle === 'Suggest a title' && lastTriggeredFrom === 'confluenceTitleToolbar';
};

});

parcelRegister("3QQwc", function(module, exports) {

$parcel$export(module.exports, "analyticsFormatMessage", () => $2cdef7734f4e66ee$export$b8128b77ab699236);
const $2cdef7734f4e66ee$export$b8128b77ab699236 = (message)=>{
    return message.defaultMessage;
};

});


parcelRegister("eXCAT", function(module, exports) {

$parcel$export(module.exports, "Logo", () => $ae4483574b7e3b16$export$e6ff31bff12b7ff4);
// This file can't be exported from generative-ai-modal due to issues
// with Playwright not picking up the imported file.
// It's not clear why this is a problem and needs to be revisited.

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $aska3 = parcelRequire("aska3");

var $izdMb = parcelRequire("izdMb");
const $ae4483574b7e3b16$export$e6ff31bff12b7ff4 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $izdMb.LogoSvg), {
        alt: formatMessage((0, $aska3.default).logoAltText)
    });
};

});
parcelRegister("aska3", function(module, exports) {

$parcel$export(module.exports, "default", () => $79cc2884692f2083$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var // This file is currently being used in Error-screen Example as to display error messages
// Any additional message will be show up in the example.
$79cc2884692f2083$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    documentInsertError: {
        id: 'fabric.editor.ai.experience-application.documentInsertError',
        defaultMessage: `We're having trouble inserting the response. Close the dialog and try again.`,
        description: 'Message to users that displays when error happens during document insertion.'
    },
    tokenLimitExceeded: {
        id: 'fabric.editor.ai.experience-application.tokenLimitExceeded',
        defaultMessage: "We couldn't get a response. Your prompt or response was over the limit for this request. Close the dialog and try again.",
        description: 'Message to users that displays when their request has exceeded the maximum input or output limit.'
    },
    rateLimitEnforced: {
        id: 'fabric.editor.ai.experience-application.rateLimitEnforced',
        defaultMessage: "We\u2019ve received too many recent requests for Atlassian Intelligence (AI). Try again in a few minutes or read about <link>excessive use of AI</link>.",
        description: 'Message to users that rate limiting has been enforced.'
    },
    apiError: {
        id: 'fabric.editor.ai.experience.apiError',
        defaultMessage: `We couldn\u{2019}t get a response, please try again.`,
        description: `We couldn't get a response due to an api error (ie. the backend responded with an error, or got a timeout)`
    },
    elevateDisabledGenetateError: {
        id: 'fabric.editor.ai.experience.elevateDisabledGenetateError',
        defaultMessage: `Free generate is disabled in Elevate at this time.`,
        description: `Message to let internal users know that the free generate editor ai feature is is disabled in Elevate at this time.`
    },
    internalServerError: {
        id: 'fabric.editor.ai.experience.internalServerError',
        defaultMessage: `Atlassian Intelligence (AI) isn\u{2019}t responding. Try again later or <link>check the status of AI</link>.`,
        description: `We couldn't get a response due to an internal server error.`
    },
    inputTooShortError: {
        id: 'fabric.editor.ai.experience.inputTooShortError',
        defaultMessage: `The content is too short to summarize. Please add more and try again.`,
        description: `The input was too short to summarize`
    },
    hipaaContentError: {
        id: 'fabric.editor.ai.experience.hipaaContentError',
        defaultMessage: `Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content. Please remove these links and try again.`,
        description: `The input contained HIPAA content`
    },
    logoAltText: {
        id: 'fabric.editor.ai.screens.prompt.logoAltText',
        defaultMessage: 'Atlassian Intelligence Logo',
        description: 'Atlassian Intelligence logo alt text of the Prompt screen'
    },
    floatingAiButtonTooltip: {
        id: 'fabric.editor.ai.floatingAiButton.tooltip',
        defaultMessage: 'Tell Atlassian Intelligence to write anything',
        description: 'The tooltip text for the floating button that invokes AI modal'
    }
});

});



parcelRegister("h5CUW", function(module, exports) {

$parcel$export(module.exports, "createGetEditorViewPlugin", () => $c7111781db6cbdd7$export$3de1ac9a9cd13933);

var $b0GDg = parcelRequire("b0GDg");

var $R7bnX = parcelRequire("R7bnX");
const $c7111781db6cbdd7$export$3de1ac9a9cd13933 = ({ setEditorView: setEditorView })=>new (0, $R7bnX.SafePlugin)({
        key: (0, $b0GDg.getEditorViewPluginKey),
        view (editorView) {
            setEditorView(editorView);
            return {};
        }
    });

});
parcelRegister("b0GDg", function(module, exports) {

$parcel$export(module.exports, "getEditorViewPluginKey", () => $8040c3b0feebb5ea$export$519cafec2c63c5bb);

var $kpTIW = parcelRequire("kpTIW");
const $8040c3b0feebb5ea$export$519cafec2c63c5bb = new (0, $kpTIW.PluginKey)('aiExperienceGetEditorView');

});

parcelRegister("R7bnX", function(module, exports) {

$parcel$export(module.exports, "SafePlugin", () => $09fa85ac75eec451$export$1d44e2741b8f180d);

var $kpTIW = parcelRequire("kpTIW");
class $09fa85ac75eec451$export$1d44e2741b8f180d extends (0, $kpTIW.Plugin) {
    // This variable isn't (and shouldn't) be used anywhere. Its purpose is
    // to distinguish Plugin from SafePlugin, thus ensuring that an 'unsafe'
    // Plugin cannot be assigned as an item in EditorPlugin → pmPlugins.
    constructor(spec){
        super(spec);
    }
}

});


parcelRegister("21dqI", function(module, exports) {

$parcel$export(module.exports, "createDecorationPlugin", () => $178617ab1f45fb54$export$f99722d744184238);

var $R7bnX = parcelRequire("R7bnX");

var $3zwnb = parcelRequire("3zwnb");

var $9O1Gs = parcelRequire("9O1Gs");

var $kgmDK = parcelRequire("kgmDK");

var $bvbDz = parcelRequire("bvbDz");
const $178617ab1f45fb54$export$f99722d744184238 = (options)=>{
    const { dispatch: dispatch, api: api } = options;
    const { createPluginState: createPluginState, getPluginState: getPluginState } = (0, $9O1Gs.createDecorationPluginFactory)({
        dispatchAnalyticsEvent: options.dispatchAnalyticsEvent
    });
    return new (0, $R7bnX.SafePlugin)({
        key: (0, $3zwnb.aiExperienceDecorationPluginKey),
        state: createPluginState(dispatch, (0, $9O1Gs.initialState)),
        props: {
            handleDOMEvents: {
                click: (0, $kgmDK.onClearGeneratedContentDecorator)
            },
            decorations: (editorState)=>{
                const pluginState = getPluginState(editorState);
                return pluginState.modalDecorationSet;
            }
        },
        view: (0, $bvbDz.manageSelectionMarkerView)(getPluginState, api)
    });
};

});
parcelRegister("kgmDK", function(module, exports) {

$parcel$export(module.exports, "onClearGeneratedContentDecorator", () => $ec06dd1958639fe0$export$f5369c92191ba6f);

var $eJsil = parcelRequire("eJsil");

var $9O1Gs = parcelRequire("9O1Gs");

var $2KDKi = parcelRequire("2KDKi");
const $ec06dd1958639fe0$export$f5369c92191ba6f = (view, event)=>{
    const pluginState = (0, $9O1Gs.getPluginState)(view.state);
    if ((0, $eJsil.hasGeneratedContentDecorations)(pluginState)) {
        const endAIExperienceCommand = (0, $2KDKi.createEndAIExperienceCommand)();
        endAIExperienceCommand(view.state, view.dispatch);
        return true;
    }
    return false;
};

});

parcelRegister("bvbDz", function(module, exports) {

$parcel$export(module.exports, "manageSelectionMarkerView", () => $85fb9ddbf700b148$export$6181eb45d9edf6d3);

var $fBDHJ = parcelRequire("fBDHJ");
const $85fb9ddbf700b148$export$6181eb45d9edf6d3 = (getPluginState, api)=>()=>{
        // If the plugin doesn't exist let's avoid running this code.
        if (!(api !== null && api !== void 0 && api.selectionMarker)) return {};
        let releaseSelectionMarker;
        return {
            update: (editorView)=>{
                const pluginState = getPluginState(editorView.state);
                const modalIsOpen = pluginState.modalDecorationSet !== (0, $fBDHJ.DecorationSet).empty;
                if (modalIsOpen && !releaseSelectionMarker) {
                    var _api$selectionMarker;
                    releaseSelectionMarker = api === null || api === void 0 ? void 0 : (_api$selectionMarker = api.selectionMarker) === null || _api$selectionMarker === void 0 ? void 0 : _api$selectionMarker.actions.hideDecoration();
                } else if (!modalIsOpen && releaseSelectionMarker) {
                    releaseSelectionMarker();
                    releaseSelectionMarker = undefined;
                }
            },
            destroy: ()=>{
                var _releaseSelectionMark;
                (_releaseSelectionMark = releaseSelectionMarker) === null || _releaseSelectionMark === void 0 || _releaseSelectionMark();
            }
        };
    };

});


parcelRegister("eUgBc", function(module, exports) {

$parcel$export(module.exports, "insertSuggestion", () => $ada32bd768e52d39$export$b021a9df2a70c70d);
$parcel$export(module.exports, "removeSuggestion", () => $ada32bd768e52d39$export$b0e3040c2e637887);
$parcel$export(module.exports, "toggleSpellingAndGrammar", () => $ada32bd768e52d39$export$a2e91513349f68ce);
$parcel$export(module.exports, "createTriggerSpellingAndGrammerCheck", () => $ada32bd768e52d39$export$c74c2e18aa3e3688);

var $dxIU5 = parcelRequire("dxIU5");

var $a576Y = parcelRequire("a576Y");

var $eytaR = parcelRequire("eytaR");

var $3cUp7 = parcelRequire("3cUp7");

var $8BfgW = parcelRequire("8BfgW");

var $bV5S0 = parcelRequire("bV5S0");

var $hXrOM = parcelRequire("hXrOM");
const $ada32bd768e52d39$export$b021a9df2a70c70d = (from, to, tr)=>(0, $8BfgW.createCommand)((state)=>{
        const pluginState = (0, $8BfgW.getPluginState)(state);
        const { decorationSet: decorationSet, allDiffObjects: currentDiffObjects } = pluginState;
        if (!currentDiffObjects) return false;
        const allDiffObjects = currentDiffObjects.filter(({ from: _from, to: _to })=>from !== _from && to !== _to);
        return {
            type: (0, $bV5S0.ACTIONS).UPDATE_PLUGIN_STATE,
            data: {
                allDiffObjects: allDiffObjects,
                // Upon inserting a suggestion we need to ensure that that the insertion widget is removed.
                decorationSet: (0, $3cUp7.resetAllDecorations)({
                    decorationSet: decorationSet,
                    tr: tr || state.tr,
                    pluginState: {
                        ...pluginState,
                        allDiffObjects: allDiffObjects
                    }
                })
            }
        };
    }, (originalTr, state)=>{
        const { schema: schema } = state;
        const { allDiffObjects: allDiffObjects } = (0, $8BfgW.getPluginState)(state);
        const transaction = tr || originalTr;
        const { selection: selection } = transaction;
        if (allDiffObjects && selection.from === selection.to) {
            const selectedDiff = allDiffObjects === null || allDiffObjects === void 0 ? void 0 : allDiffObjects.find(({ from: from, to: to })=>selection.from <= to && selection.from >= from);
            if (selectedDiff) {
                var _resolvedPos$nodeAfte;
                /**
       * mark transaction as suggestionAccepted, so that we can ignore update
       * 	while updating proactiveAIBlocks.
       */ transaction.setMeta('suggestionAccepted', true);
                const { from: from, to: to, text: text } = selectedDiff;
                /**
       * Take the marks from the 'from' position
       * (beginning of the word to be replaced)
       *
       * This is to ensure that the new text has the same marks as the old text.
       * To be more pragmatic, we only look at 'from' position in case the
       * word has different mark combinations in each letter.
       */ const resolvedPos = state.doc.resolve(from);
                const marks = ((_resolvedPos$nodeAfte = resolvedPos.nodeAfter) === null || _resolvedPos$nodeAfte === void 0 ? void 0 : _resolvedPos$nodeAfte.marks) || [];
                return transaction.replaceWith(from, to, schema.text(text, marks));
            }
        }
        return transaction;
    });
const $ada32bd768e52d39$export$b0e3040c2e637887 = (from, to, originalText, tr)=>(0, $8BfgW.createCommand)((state)=>{
        const pluginState = (0, $8BfgW.getPluginState)(state);
        const { decorationSet: decorationSet, allDiffObjects: currentDiffObjects } = pluginState;
        if (!currentDiffObjects) return false;
        const allDiffObjects = currentDiffObjects.filter(({ from: _from, to: _to, originalText: _text })=>{
            return originalText !== _text;
        });
        return {
            type: (0, $bV5S0.ACTIONS).UPDATE_PLUGIN_STATE,
            data: {
                allDiffObjects: allDiffObjects,
                newDismissedWord: originalText,
                decorationSet: (0, $3cUp7.resetAllDecorations)({
                    decorationSet: decorationSet,
                    tr: tr || state.tr,
                    pluginState: {
                        ...pluginState,
                        allDiffObjects: allDiffObjects
                    }
                })
            }
        };
    });
const $ada32bd768e52d39$export$a2e91513349f68ce = ()=>(0, $8BfgW.createCommand)({
        type: (0, $bV5S0.ACTIONS).TOGGLE_SPELLING_AND_GRAMMAR_ENABLED
    });
const $ada32bd768e52d39$export$17c99fe1293f8885 = async (view, blocksNeedingSpellAndGrammerCheck, locale)=>{
    const state = view.state;
    const { proactiveAIApiUrl: proactiveAIApiUrl } = (0, $8BfgW.getPluginState)(state);
    const suggestionGenerator = (0, $eytaR.fetchAIParagraphs)(proactiveAIApiUrl, locale)(blocksNeedingSpellAndGrammerCheck);
    if (!suggestionGenerator) return;
    for await (const suggestionState of suggestionGenerator)switch(suggestionState.state){
        case 'parsed':
            {
                const suggestion = suggestionState.suggestion;
                const block = blocksNeedingSpellAndGrammerCheck.find((block)=>block.id === suggestion.original.id);
                if (!block) break;
                /**
           * TODO EDF-848
           * This should be refined since we now process suggestions individually as it streams
           */ const blocksDiffObjectsByBlockId = (0, $hXrOM.getDiffObjectsForBlocks)([
                    {
                        block: block,
                        suggestion: suggestion
                    }
                ]);
                (0, $8BfgW.createCommand)(()=>{
                    return {
                        type: (0, $bV5S0.ACTIONS).UPDATE_BLOCKS_DIFF_OBJECTS,
                        data: {
                            blocksDiffObjectsByBlockId: blocksDiffObjectsByBlockId
                        }
                    };
                }, (tr)=>{
                    return tr.setMeta('addToHistory', false);
                })(view.state, view.dispatch);
                /**
           * TODO EDF-848
           * This currently recalculates all diff objects and decorations in the document
           * This should be refined to only update the diff objects and decorations for the block that has been updated
           */ $ada32bd768e52d39$export$a39c5389e3986df0(view);
                break;
            }
        case 'done':
            return;
    }
};
const $ada32bd768e52d39$export$a39c5389e3986df0 = (view)=>{
    const { proactiveAIBlocks: proactiveAIBlocks, dismissedWords: dismissedWords } = (0, $8BfgW.getPluginState)(view.state);
    if (proactiveAIBlocks && proactiveAIBlocks.length > 0) {
        /**
     * When block is affected by transaction, we create new block out of it.
     * New block won't have diffObjects in it.
     * Then when we call S+G API, we will get new diffObjects stored in blocks.
     * Now after having new diffObjects in blocks, then we need to
     *  create allDiffObjects and decorations from it.
     */ let allDiffObjects = [];
        proactiveAIBlocks.forEach((block)=>{
            if (block.diffObjects) allDiffObjects = allDiffObjects.concat(...block.diffObjects);
        });
        allDiffObjects = allDiffObjects.filter(({ originalText: originalText })=>!dismissedWords.has(originalText));
        const command = (0, $8BfgW.createCommand)((state)=>{
            const pluginState = (0, $8BfgW.getPluginState)(state);
            const { decorationSet: decorationSet } = pluginState;
            return {
                type: (0, $bV5S0.ACTIONS).UPDATE_PLUGIN_STATE,
                data: {
                    decorationSet: (0, $3cUp7.resetAllDecorations)({
                        decorationSet: decorationSet,
                        tr: state.tr,
                        pluginState: {
                            ...pluginState,
                            allDiffObjects: allDiffObjects
                        }
                    }),
                    allDiffObjects: allDiffObjects
                }
            };
        }, (tr, state)=>{
            return tr.setMeta('addToHistory', false);
        });
        command(view.state, view.dispatch);
    }
};
const $ada32bd768e52d39$var$isSelectionInBlock = (from, to, block)=>{
    return block.from <= from && block.to >= from || block.from <= to && block.to >= to;
};
const $ada32bd768e52d39$var$getBlocksNeedingSpellAndGrammerCheck = (state)=>{
    const { proactiveAIBlocks: proactiveAIBlocks } = (0, $8BfgW.getPluginState)(state);
    if (!proactiveAIBlocks || !proactiveAIBlocks.length) return [];
    return proactiveAIBlocks === null || proactiveAIBlocks === void 0 ? void 0 : proactiveAIBlocks.filter((block)=>!!block.needSpellingAndGrammarCheck);
};
const $ada32bd768e52d39$var$getBlocksEligibleForSGPrompt = (state, currentBlocks)=>{
    const blocksNeedingSpellAndGrammerCheck = $ada32bd768e52d39$var$getBlocksNeedingSpellAndGrammerCheck(state);
    const { from: from, to: to } = state.selection;
    return blocksNeedingSpellAndGrammerCheck.filter((block)=>{
        const selectionInBlock = $ada32bd768e52d39$var$isSelectionInBlock(from, to, block);
        return currentBlocks ? selectionInBlock : !selectionInBlock;
    });
};
const $ada32bd768e52d39$export$fcd3542049ec7e59 = async (view, locale)=>{
    /**
   * If selection is overlap with block and it's been more than Y seconds
   *  since it was last updated then send it for S+G prompt.
   * Ignore non current blocks, as they will be handled separately.
   */ const blocksEligibleForSGPrompt = $ada32bd768e52d39$var$getBlocksEligibleForSGPrompt(view.state, true);
    if (blocksEligibleForSGPrompt.length) await $ada32bd768e52d39$export$17c99fe1293f8885(view, blocksEligibleForSGPrompt, locale);
};
const $ada32bd768e52d39$export$ecdf31178b6cad74 = async (view, locale)=>{
    const blocksEligibleForSGPrompt = $ada32bd768e52d39$var$getBlocksEligibleForSGPrompt(view.state, false);
    if (blocksEligibleForSGPrompt.length) await $ada32bd768e52d39$export$17c99fe1293f8885(view, blocksEligibleForSGPrompt, locale);
};
const $ada32bd768e52d39$export$c74c2e18aa3e3688 = (timings)=>{
    const triggerSpellingAndGrammarCheckForNonCurrentBlocksThrottled = (0, (/*@__PURE__*/$parcel$interopDefault($a576Y)))($ada32bd768e52d39$export$ecdf31178b6cad74, timings.nonCurrentChunks);
    const triggerSpellingAndGrammarCheckForCurrentBlocksDebounced = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))($ada32bd768e52d39$export$fcd3542049ec7e59, timings.currentChunks, {
        maxWait: timings.currentChunksMaxWait
    });
    const triggerSpellingAndGrammerCheck = (view, locale)=>{
        triggerSpellingAndGrammarCheckForNonCurrentBlocksThrottled(view, locale);
        triggerSpellingAndGrammarCheckForCurrentBlocksDebounced(view, locale);
    };
    const cancelDebouncedAndThrottledSpellingAndGrammerCheck = ()=>{
        triggerSpellingAndGrammarCheckForNonCurrentBlocksThrottled.cancel();
        triggerSpellingAndGrammarCheckForCurrentBlocksDebounced.cancel();
    };
    return {
        triggerSpellingAndGrammerCheck: triggerSpellingAndGrammerCheck,
        cancelDebouncedAndThrottledSpellingAndGrammerCheck: cancelDebouncedAndThrottledSpellingAndGrammerCheck
    };
};

});
parcelRegister("eytaR", function(module, exports) {

$parcel$export(module.exports, "fetchAIParagraphs", () => $a98adf09070a21ce$export$ff0b89bde37d855d);

var $XHGTv = parcelRequire("XHGTv");

var $4WES2 = parcelRequire("4WES2");
const $a98adf09070a21ce$export$ff0b89bde37d855d = (proactiveAIApiUrl, locale)=>(paragraphs)=>(0, $XHGTv.getBooleanFF)('platform.editor.ai-proactive-ai-api-url_k6yy7') ? $a98adf09070a21ce$var$fetchAIParagraphsV1(proactiveAIApiUrl, locale, paragraphs) : $a98adf09070a21ce$var$fetchAIParagraphsMVP(proactiveAIApiUrl, paragraphs);
const $a98adf09070a21ce$export$f795cf8a51531ffb = (chunk)=>chunk.from === chunk.to || !chunk.text || !chunk.text.trim().length;
/**
 * fetchAIMVP is for the MVP endpoint which only supports a single string
 */ /* istanbul ignore next */ const $a98adf09070a21ce$var$fetchAIMVP = async (proactiveAIApiUrl, chunk)=>{
    const payload = {
        smartsModel: 'CC_SMARTS_SPELLING_CORRECTION_MODEL',
        inputText: chunk.text
    };
    const abortController = new AbortController();
    const fetchInit = {
        method: 'POST',
        body: JSON.stringify(payload),
        credentials: 'include',
        signal: abortController.signal,
        mode: 'cors'
    };
    const response = await fetch(proactiveAIApiUrl, {
        ...fetchInit,
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        }
    });
    return response.json();
};
/* istanbul ignore next */ // This is the original MVP endpoint used for the initial spike. This will be replaced by the V1 endpoint.
const $a98adf09070a21ce$var$fetchAIParagraphsMVP = (proactiveAIApiUrl, paragraphs)=>{
    const included = paragraphs.filter((chunk)=>!$a98adf09070a21ce$export$f795cf8a51531ffb(chunk));
    const promises = included.map((chunk)=>$a98adf09070a21ce$var$fetchAIMVP(proactiveAIApiUrl, chunk));
    return (0, $4WES2.resolvedMVPResponseGenerator)({
        paragraphs: included,
        promises: promises
    });
};
/* istanbul ignore next */ // This V1 endpoint is the final endpoint we're targetting for hello release.
const $a98adf09070a21ce$var$fetchAIParagraphsV1 = (proactiveAIApiUrl, locale, paragraphs)=>{
    const included = paragraphs.filter((chunk)=>!$a98adf09070a21ce$export$f795cf8a51531ffb(chunk));
    if (!!included.length) {
        const requests = {};
        included.forEach(({ id: id, text: text })=>{
            requests[id] = text;
        });
        /**
     * API Spec documented at https://hello.atlassian.net/wiki/spaces/CA3/pages/3776161653/Bulk+Spelling+and+Grammar+Endpoint
     */ const payload = {
            requests: requests
        };
        return (0, $4WES2.suggestionGenerator)({
            endpoint: proactiveAIApiUrl,
            paragraphs: included,
            payload: JSON.stringify(payload),
            abortController: new AbortController()
        });
    }
    return;
};

});
parcelRegister("4WES2", function(module, exports) {

$parcel$export(module.exports, "suggestionGenerator", () => $399c48445638bc70$export$446c4c603ad3a8df);
$parcel$export(module.exports, "resolvedMVPResponseGenerator", () => $399c48445638bc70$export$a3f6c451648c0bdd);
function $399c48445638bc70$var$mapResponseToSuggestion(paragraphs, response) {
    const original = paragraphs.find((p)=>response.id === p.id);
    if (!original || !response.part) return;
    return {
        original: original,
        suggestion: response.part
    };
}
async function* $399c48445638bc70$export$446c4c603ad3a8df({ endpoint: endpoint, paragraphs: paragraphs, payload: payload, abortController: abortController }) {
    try {
        const requestPayload = JSON.parse(payload);
        const response = await fetch(endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
            },
            body: JSON.stringify({
                ...requestPayload
            }),
            credentials: 'include',
            signal: abortController.signal,
            mode: 'cors'
        });
        if (!response.ok) return yield {
            state: 'failed',
            reason: 'backend',
            error: `unexpected response status: ${response.status}`,
            statusCode: response.status
        };
        if (!response.body) {
            yield {
                state: 'failed',
                reason: 'network',
                error: 'response.body missing',
                statusCode: response.status
            };
            return;
        }
        try {
            const reader = response.body.getReader();
            const decoder = new TextDecoder('utf-8');
            let buffer = '';
            let done = false;
            while(!done){
                const { value: value, done: doneReading } = await reader.read();
                done = doneReading;
                const chunkValue = decoder.decode(value);
                buffer = buffer + chunkValue;
                // Split the buffer by line breaks
                const lines = buffer.split('\n');
                // Process all complete lines, except for the last one (which might be incomplete)
                while(lines.length > 1){
                    const line = lines.shift();
                    const parsedData = JSON.parse(line);
                    const mappedData = $399c48445638bc70$var$mapResponseToSuggestion(paragraphs, parsedData);
                    if (!mappedData) yield {
                        state: 'failed',
                        reason: 'backend',
                        error: (parsedData === null || parsedData === void 0 ? void 0 : parsedData.error) || 'backend',
                        statusCode: response.status
                    };
                    else yield {
                        state: 'parsed',
                        suggestion: mappedData
                    };
                }
                // Keep the last (potentially incomplete) line in the buffer
                buffer = lines[0];
                if (done) {
                    yield {
                        state: 'done'
                    };
                    return;
                }
            }
            yield {
                state: 'done'
            };
            return;
        } catch (parsingError) {
            yield {
                state: 'failed',
                reason: 'parsing',
                error: parsingError,
                statusCode: response.status
            };
            return;
        }
    } catch (error) {
        if (error.name === 'AbortError') yield {
            state: 'failed',
            reason: 'aborted',
            error: error,
            statusCode: error.status
        };
        else yield {
            state: 'failed',
            reason: 'network',
            error: error,
            statusCode: error.status
        };
        return;
    }
}
async function* $399c48445638bc70$export$a3f6c451648c0bdd({ paragraphs: paragraphs, promises: promises }) {
    let doneCount = 0;
    while(doneCount !== paragraphs.length){
        if (promises.length > 0) for(let i = 0; i < promises.length; i++){
            const response = await promises[i];
            if (response.error) yield {
                state: 'failed',
                reason: 'backend',
                error: response.error,
                statusCode: response.statusCode
            };
            else if (!!(response !== null && response !== void 0 && response.response)) yield {
                state: 'parsed',
                suggestion: {
                    original: paragraphs[i],
                    suggestion: response === null || response === void 0 ? void 0 : response.response
                }
            };
            else yield {
                state: 'failed',
                reason: 'backend',
                error: 'not fulfilled',
                statusCode: response.statusCode
            };
            doneCount++;
        }
        if (doneCount === paragraphs.length) {
            yield {
                state: 'done'
            };
            return;
        }
    }
}

});


parcelRegister("3cUp7", function(module, exports) {

$parcel$export(module.exports, "SpellingAndGrammarDecorations", () => $255e3ec0ac31c29c$export$b8f003972dc1d0f5);
$parcel$export(module.exports, "filterDecorationByKey", () => $255e3ec0ac31c29c$export$ad950d3225a13eae);
$parcel$export(module.exports, "regenerateSpellingDecorations", () => $255e3ec0ac31c29c$export$1b16c3b5ef0a3385);
$parcel$export(module.exports, "regenerateSelectedSpellingDecorations", () => $255e3ec0ac31c29c$export$869ca1e6f091229e);
$parcel$export(module.exports, "resetAllDecorations", () => $255e3ec0ac31c29c$export$46606d1280917594);

var $9rc6f = parcelRequire("9rc6f");

var $dtqwz = parcelRequire("dtqwz");
const $255e3ec0ac31c29c$export$b8f003972dc1d0f5 = {
    SPELLING_ERROR: 'spellingError',
    SPELLING_ERROR_SELECTED: 'spellingErrorSelected',
    SUGGESTION: 'suggestion'
};
const $255e3ec0ac31c29c$export$c3909dd6d9555879 = (transformers)=>({ decorationSet: decorationSet, tr: tr, pluginState: pluginState })=>transformers.reduce((decorationSet, transform)=>transform({
                decorationSet: decorationSet,
                tr: tr,
                pluginState: pluginState
            }), decorationSet);
const $255e3ec0ac31c29c$export$ad950d3225a13eae = (key, decorationSet)=>decorationSet.find(undefined, undefined, (spec)=>spec.key.indexOf(key) > -1);
const $255e3ec0ac31c29c$export$d6b78f11c528c153 = (params)=>{
    return $255e3ec0ac31c29c$export$c3909dd6d9555879([
        (0, $9rc6f.removeSpellingDecoration),
        (0, $dtqwz.removeSelectedSpellingDecoration)
    ])(params);
};
const $255e3ec0ac31c29c$export$1b16c3b5ef0a3385 = (params)=>{
    return $255e3ec0ac31c29c$export$c3909dd6d9555879([
        (0, $9rc6f.removeSpellingDecoration),
        (0, $dtqwz.removeSelectedSpellingDecoration),
        (0, $9rc6f.addSpellingDecoration),
        (0, $dtqwz.addSelectedSpellingDecoration)
    ])(params);
};
const $255e3ec0ac31c29c$export$869ca1e6f091229e = (params)=>{
    return $255e3ec0ac31c29c$export$c3909dd6d9555879([
        (0, $dtqwz.removeSelectedSpellingDecoration),
        (0, $dtqwz.addSelectedSpellingDecoration)
    ])(params);
};
const $255e3ec0ac31c29c$export$46606d1280917594 = (params)=>{
    return $255e3ec0ac31c29c$export$c3909dd6d9555879([
        $255e3ec0ac31c29c$export$d6b78f11c528c153,
        (0, $9rc6f.addSpellingDecoration),
        (0, $dtqwz.addSelectedSpellingDecoration)
    ])(params);
};

});
parcelRegister("9rc6f", function(module, exports) {

$parcel$export(module.exports, "removeSpellingDecoration", () => $6df0056cf56fe3c3$export$e740aa9dfc513b7c);
$parcel$export(module.exports, "addSpellingDecoration", () => $6df0056cf56fe3c3$export$430f2f633a9f01a6);

var $fBDHJ = parcelRequire("fBDHJ");

var $3cUp7 = parcelRequire("3cUp7");
const $6df0056cf56fe3c3$export$e740aa9dfc513b7c = ({ decorationSet: decorationSet })=>{
    return decorationSet.remove((0, $3cUp7.filterDecorationByKey)((0, $3cUp7.SpellingAndGrammarDecorations).SPELLING_ERROR, decorationSet));
};
const $6df0056cf56fe3c3$export$430f2f633a9f01a6 = ({ decorationSet: decorationSet, tr: tr, pluginState: pluginState })=>{
    const { allDiffObjects: allDiffObjects } = pluginState;
    const decorations = allDiffObjects === null || allDiffObjects === void 0 ? void 0 : allDiffObjects.map(({ id: id, from: from, to: to })=>{
        return (0, $fBDHJ.Decoration).inline(from, to, {
            nodeName: 'span',
            class: `ai-suggestions`,
            id: `ai-sg-${id}`,
            'data-testid': `ai-suggestions`
        }, {
            key: `${(0, $3cUp7.SpellingAndGrammarDecorations).SPELLING_ERROR}_${from}_${to}`
        });
    });
    if (!!(decorations !== null && decorations !== void 0 && decorations.length)) return decorationSet.add(tr.doc, decorations);
    return decorationSet;
};

});

parcelRegister("dtqwz", function(module, exports) {

$parcel$export(module.exports, "removeSelectedSpellingDecoration", () => $9cf28efc0ba30aa6$export$55a4a250b4381d59);
$parcel$export(module.exports, "addSelectedSpellingDecoration", () => $9cf28efc0ba30aa6$export$caecada8d781cb5a);

var $fBDHJ = parcelRequire("fBDHJ");

var $3cUp7 = parcelRequire("3cUp7");
const $9cf28efc0ba30aa6$export$55a4a250b4381d59 = ({ decorationSet: decorationSet, pluginState: pluginState })=>{
    return decorationSet.remove((0, $3cUp7.filterDecorationByKey)((0, $3cUp7.SpellingAndGrammarDecorations).SPELLING_ERROR_SELECTED, decorationSet));
};
const $9cf28efc0ba30aa6$export$caecada8d781cb5a = ({ decorationSet: decorationSet, tr: tr, pluginState: pluginState })=>{
    const { allDiffObjects: allDiffObjects } = pluginState;
    const { selection: selection } = tr;
    if (allDiffObjects && selection.from === selection.to) {
        const selectedDiff = allDiffObjects === null || allDiffObjects === void 0 ? void 0 : allDiffObjects.find(({ from: from, to: to })=>selection.from <= to && selection.from >= from);
        if (selectedDiff) {
            const { from: from, to: to } = selectedDiff;
            return decorationSet.add(tr.doc, [
                (0, $fBDHJ.Decoration).inline(from, to, {
                    class: `ai-suggestions-selected`
                }, {
                    key: `${(0, $3cUp7.SpellingAndGrammarDecorations).SPELLING_ERROR_SELECTED}`
                })
            ]);
        }
    }
    return decorationSet;
};

});


parcelRegister("8BfgW", function(module, exports) {

$parcel$export(module.exports, "createInitialState", () => $642da02d94625df5$export$de5e90bd767c5d82);
$parcel$export(module.exports, "createPluginState", () => $642da02d94625df5$export$656c7661095efe2e);
$parcel$export(module.exports, "createCommand", () => $642da02d94625df5$export$8d4021544bdece00);
$parcel$export(module.exports, "getPluginState", () => $642da02d94625df5$export$f05434c51e3762e);

var $cCShG = parcelRequire("cCShG");

var $cbmoF = parcelRequire("cbmoF");

var $d6JJW = parcelRequire("d6JJW");

var $fBDHJ = parcelRequire("fBDHJ");

var $3cUp7 = parcelRequire("3cUp7");

var $2fbrZ = parcelRequire("2fbrZ");

var $hXrOM = parcelRequire("hXrOM");
const $642da02d94625df5$var$handleDocChanged = (tr, pluginState, newEditorState)=>{
    const { updatedProactiveAIBlock: updatedProactiveAIBlock } = (0, $hXrOM.findProactiveAIBlockToUpdate)(tr, pluginState, newEditorState);
    const { allDiffObjects: allDiffObjects, decorationSet: decorationSet } = pluginState;
    if ((allDiffObjects === null || allDiffObjects === void 0 ? void 0 : allDiffObjects.length) === 0) return {
        ...pluginState,
        proactiveAIBlocks: updatedProactiveAIBlock
    };
    let newAllDiffObjects = allDiffObjects || [];
    const isOverlappingPos = (pos, diffObject)=>{
        const { from: from, to: to } = diffObject;
        if (pos >= from && pos <= to) return true;
        return false;
    };
    tr.steps.filter((step)=>step instanceof (0, $d6JJW.ReplaceStep) || step instanceof (0, $d6JJW.ReplaceAroundStep)).forEach((step)=>{
        newAllDiffObjects = newAllDiffObjects.filter((diffObject)=>!(isOverlappingPos(step.from, diffObject) || isOverlappingPos(step.to, diffObject)));
    });
    const nextPluginState = {
        ...pluginState,
        allDiffObjects: newAllDiffObjects.map((diffObject)=>({
                ...diffObject,
                from: tr.mapping.map(diffObject.from),
                to: tr.mapping.map(diffObject.to)
            }))
    };
    // Update positions of diffObjects stored in blocks as well.
    const proactiveAIBlockWithPositionsUpdated = updatedProactiveAIBlock === null || updatedProactiveAIBlock === void 0 ? void 0 : updatedProactiveAIBlock.map((proactiveAIBlock)=>{
        if (proactiveAIBlock.diffObjects) return {
            ...proactiveAIBlock,
            diffObjects: proactiveAIBlock.diffObjects.map((diffObject)=>({
                    ...diffObject,
                    from: tr.mapping.map(diffObject.from),
                    to: tr.mapping.map(diffObject.to)
                }))
        };
        return proactiveAIBlock;
    });
    return {
        ...nextPluginState,
        decorationSet: (0, $3cUp7.regenerateSpellingDecorations)({
            decorationSet: decorationSet,
            tr: tr,
            pluginState: nextPluginState
        }),
        proactiveAIBlocks: proactiveAIBlockWithPositionsUpdated
    };
};
const $642da02d94625df5$var$handleSelectionChanged = (tr, pluginState)=>{
    const { decorationSet: decorationSet } = pluginState;
    return {
        ...pluginState,
        decorationSet: (0, $3cUp7.regenerateSelectedSpellingDecorations)({
            decorationSet: decorationSet,
            tr: tr,
            pluginState: pluginState
        })
    };
};
const $642da02d94625df5$export$de5e90bd767c5d82 = (proactiveAIApiUrl)=>(state)=>{
        return {
            proactiveAIBlocks: (0, $hXrOM.getAllProactiveAIBlocks)(state),
            isSpellingAndGrammarEnabled: true,
            allDiffObjects: [],
            decorationSet: (0, $fBDHJ.DecorationSet).empty,
            proactiveAIApiUrl: proactiveAIApiUrl,
            dismissedWords: new Set()
        };
    };
const { createPluginState: $642da02d94625df5$export$656c7661095efe2e, createCommand: $642da02d94625df5$export$8d4021544bdece00, getPluginState: $642da02d94625df5$export$f05434c51e3762e } = (0, $cCShG.pluginFactory)((0, $2fbrZ.aiSpellingGrammarPluginKey), (0, $cbmoF.reducer), {
    mapping: (tr, pluginState)=>{
        if (tr.docChanged) {
            var _pluginState$decorati;
            return {
                ...pluginState,
                decorationSet: (_pluginState$decorati = pluginState.decorationSet) === null || _pluginState$decorati === void 0 ? void 0 : _pluginState$decorati.map(tr.mapping, tr.doc)
            };
        }
        return pluginState;
    },
    onDocChanged: $642da02d94625df5$var$handleDocChanged,
    onSelectionChanged: $642da02d94625df5$var$handleSelectionChanged
});

});
parcelRegister("cCShG", function(module, exports) {

$parcel$export(module.exports, "pluginFactory", () => $4f1c24362c2e02e6$export$3dd00fb488ab385a);
/**
 * Creates a ProseMirror plugin's state and handles UI updates.
 *
 * Here's a few things to keep in mind:
 * - plugin's state is stored as a single object
 * - `Reducer` specifies how plugin's state changes in response to commands
 * - `Command` describes only what happen, but not how state changes
 * - `mapping` could be used to map ProseMirror positions stored in plugin's state
 *
 * Example:
 *  const { createPluginState, createCommand, getPluginState } = pluginFactory(
 *    reducer,
 *    pluginKey
 *  );
 *
 *  export const createPlugin = (dispatch: Dispatch, initialState) =>
 *    new SafePlugin({
 *      state: createPluginState(dispatch, initialState),
 *      key: pluginKey
 *    });
 *
 * Example of a reducer:
 *
 *  export const reducer = (
 *    state: TablePluginState,
 *    action: TableAction,
 *  ): TablePluginState => {
 *    switch (action.type) {
 *      case 'TOGGLE_CONTEXTUAL_MENU':
 *      return {
 *        ...state,
 *        isContextualMenuOpen: !state.isContextualMenuOpen,
 *      };
 *    default:
 *      return state;
 *    }
 *  };
 *
 *
 * Example of a command:
 *
 * export const toggleContextualMenu = createCommand({
 *   type: 'TOGGLE_CONTEXTUAL_MENU',
 * }, tr => tr.setMeta('addToHistory', false));
 *
 */ function $4f1c24362c2e02e6$var$isFunction(x) {
    return typeof x === 'function';
}
function $4f1c24362c2e02e6$export$3dd00fb488ab385a(pluginKey, reducer, options = {}) {
    const { mapping: mapping, onDocChanged: onDocChanged, onSelectionChanged: onSelectionChanged } = options;
    return {
        createPluginState (dispatch, initialState) {
            return {
                init: (_, state)=>$4f1c24362c2e02e6$var$isFunction(initialState) ? initialState(state) : initialState,
                apply: (tr, _pluginState, _oldEditorState, newEditorState)=>{
                    const oldPluginState = mapping ? mapping(tr, _pluginState, newEditorState) : _pluginState;
                    let newPluginState = oldPluginState;
                    const meta = tr.getMeta(pluginKey);
                    if (meta) newPluginState = reducer(oldPluginState, meta);
                    if (onDocChanged && tr.docChanged) newPluginState = onDocChanged(tr, newPluginState, newEditorState);
                    else if (onSelectionChanged && tr.selectionSet) newPluginState = onSelectionChanged(tr, newPluginState, newEditorState);
                    if (newPluginState !== oldPluginState) dispatch(pluginKey, newPluginState);
                    return newPluginState;
                }
            };
        },
        createCommand (action, transform) {
            return (state, dispatch)=>{
                if (dispatch) {
                    const tr = transform ? transform(state.tr, state) : state.tr;
                    const resolvedAction = $4f1c24362c2e02e6$var$isFunction(action) ? action(state) : action;
                    if (tr && resolvedAction) dispatch(tr.setMeta(pluginKey, resolvedAction));
                    else return false;
                }
                return true;
            };
        },
        getPluginState (state) {
            return pluginKey.getState(state);
        }
    };
}

});

parcelRegister("cbmoF", function(module, exports) {

$parcel$export(module.exports, "reducer", () => $8de7e2a50c868e34$export$1650419e431d3ba3);

var $bV5S0 = parcelRequire("bV5S0");
const $8de7e2a50c868e34$export$1650419e431d3ba3 = (pluginState, action)=>{
    var _pluginState$proactiv;
    switch(action.type){
        case (0, $bV5S0.ACTIONS).UPDATE_PLUGIN_STATE:
            return {
                ...pluginState,
                ...action.data,
                dismissedWords: !!action.data.newDismissedWord ? pluginState.dismissedWords.add(action.data.newDismissedWord) : pluginState.dismissedWords
            };
        case (0, $bV5S0.ACTIONS).TOGGLE_SPELLING_AND_GRAMMAR_ENABLED:
            return {
                ...pluginState,
                isSpellingAndGrammarEnabled: !pluginState.isSpellingAndGrammarEnabled
            };
        case (0, $bV5S0.ACTIONS).UPDATE_BLOCKS_DIFF_OBJECTS:
            return {
                ...pluginState,
                proactiveAIBlocks: (_pluginState$proactiv = pluginState.proactiveAIBlocks) === null || _pluginState$proactiv === void 0 ? void 0 : _pluginState$proactiv.map((block)=>{
                    if (action.data.blocksDiffObjectsByBlockId.has(block.id)) {
                        block.diffObjects = action.data.blocksDiffObjectsByBlockId.get(block.id);
                        block.needSpellingAndGrammarCheck = false;
                    }
                    return block;
                })
            };
        default:
            return pluginState;
    }
};

});
parcelRegister("bV5S0", function(module, exports) {

$parcel$export(module.exports, "ACTIONS", () => $8ad992461c763cbc$export$92a1a3b7554e9387);
let $8ad992461c763cbc$export$92a1a3b7554e9387 = /*#__PURE__*/ function(ACTIONS) {
    ACTIONS[ACTIONS["UPDATE_PLUGIN_STATE"] = 0] = "UPDATE_PLUGIN_STATE";
    ACTIONS[ACTIONS["TOGGLE_SPELLING_AND_GRAMMAR_ENABLED"] = 1] = "TOGGLE_SPELLING_AND_GRAMMAR_ENABLED";
    ACTIONS[ACTIONS["UPDATE_BLOCKS_DIFF_OBJECTS"] = 2] = "UPDATE_BLOCKS_DIFF_OBJECTS";
    return ACTIONS;
}({});

});


parcelRegister("2fbrZ", function(module, exports) {

$parcel$export(module.exports, "aiSpellingGrammarPluginKey", () => $1a25dd51a80e2624$export$6efc670e6f6b178d);

var $kpTIW = parcelRequire("kpTIW");
const $1a25dd51a80e2624$export$6efc670e6f6b178d = new (0, $kpTIW.PluginKey)('aiSpellingGrammarPlugin');

});

parcelRegister("hXrOM", function(module, exports) {

$parcel$export(module.exports, "getDiffObjectsForBlocks", () => $d12d8675f64157e1$export$f7dd2538e868d9e4);
$parcel$export(module.exports, "findProactiveAIBlockToUpdate", () => $d12d8675f64157e1$export$9301b11c75053a3b);
$parcel$export(module.exports, "getAllProactiveAIBlocks", () => $d12d8675f64157e1$export$84c79514d0cb7da7);

var $dFBS3 = parcelRequire("dFBS3");

var $d6JJW = parcelRequire("d6JJW");

var $1YM8X = parcelRequire("1YM8X");
const $d12d8675f64157e1$export$e5022a60bacc9f19 = ({ schema: { nodes: nodes } })=>new Set([
        nodes.blockquote,
        nodes.bulletList,
        nodes.caption,
        nodes.decisionItem,
        nodes.decisionList,
        nodes.expand,
        nodes.heading,
        nodes.layoutColumn,
        nodes.layoutSection,
        nodes.listItem,
        nodes.nestedExpand,
        nodes.orderedList,
        nodes.panel,
        nodes.paragraph,
        nodes.table,
        nodes.tableRow,
        nodes.tableCell,
        nodes.tableHeader,
        nodes.taskItem,
        nodes.taskList
    ]);
const $d12d8675f64157e1$export$2e312585e39e3b9f = ({ schema: { nodes: nodes } })=>new Set([
        nodes.decisionItem,
        nodes.heading,
        nodes.paragraph,
        nodes.taskItem
    ]);
const $d12d8675f64157e1$export$f7dd2538e868d9e4 = (blocksWitSuggestions)=>{
    const blocksDiffObjectsByBlockId = new Map();
    blocksWitSuggestions.forEach(({ block: block, suggestion: suggestion })=>{
        blocksDiffObjectsByBlockId.set(block.id, (0, $1YM8X.getDiffObjectsForParagraph)(block, suggestion.suggestion || suggestion.original.text));
    });
    return blocksDiffObjectsByBlockId;
};
function $d12d8675f64157e1$export$9301b11c75053a3b(tr, pluginState, newEditorState) {
    const { proactiveAIBlocks: proactiveAIBlocks, isSpellingAndGrammarEnabled: isSpellingAndGrammarEnabled } = pluginState;
    const shouldIgnoreChanges = !isSpellingAndGrammarEnabled || tr.getMeta('isRemote') || tr.getMeta('replaceDocument') || tr.getMeta('suggestionAccepted') || tr.getMeta('isAiContentTransformation');
    const nodeTypes = $d12d8675f64157e1$export$2e312585e39e3b9f(newEditorState);
    const includedNodeTypes = $d12d8675f64157e1$export$e5022a60bacc9f19(newEditorState);
    const doc = tr.doc;
    const replaceSteps = tr.steps.filter((step)=>step instanceof (0, $d6JJW.ReplaceStep) || step instanceof (0, $d6JJW.ReplaceAroundStep));
    if (proactiveAIBlocks) {
        let updatedProactiveAIBlock = Array.from(proactiveAIBlocks);
        replaceSteps.forEach((step)=>{
            const newProactiveAIBlocks = [];
            /**
       * First find new nodes that needs to be checked against
       * proactive AI prompt.
       */ step.getMap().forEach((oldStart, oldEnd, newStart, newEnd)=>{
                doc.nodesBetween(newStart, Math.min(newEnd, tr.doc.content.size), (node, pos)=>{
                    if (nodeTypes.has(node.type) && !newProactiveAIBlocks.find((newProactiveAIBlock)=>newProactiveAIBlock.node === node)) {
                        const inlineNodePositions = [];
                        node.descendants((node, pos)=>{
                            if (node.isInline && !node.isText) inlineNodePositions.push(pos);
                        });
                        newProactiveAIBlocks.push({
                            id: (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))(),
                            from: pos,
                            to: pos + node.nodeSize,
                            inlineNodeStart: pos + 1,
                            inlineNodeEnd: pos + node.nodeSize - 1,
                            text: node.textContent,
                            nodeTypeName: node.type.name,
                            /**
               * If it's remote transaction, then we don't want new blocks
               * created from that transaction to be checked for S+G,
               * because they must be checked where it's originated.
               *
               * Also when document is loaded in confluence, collab service
               *  fetches document and fires transaction to replace whole document.
               * In that case as well, we don't want to trigger S+G for whole document.
               */ needSpellingAndGrammarCheck: !shouldIgnoreChanges,
                            newBlock: true,
                            inlineNodePositions: inlineNodePositions,
                            node: node
                        });
                        return false;
                    }
                    return includedNodeTypes.has(node.type);
                });
            });
            /**
       * Now find existing range of proactiveAIBlock that needs to be
       * replaced with new blocks found.
       *
       * ASSUMPTIONS:
       * 1. We have assumed here that new proactiveAIBlocks will be in
       *    continous range.
       *    For example: New 4 blocks will be from positions 350 to 550.
       *                 Let's say there are 3 blocks before 350 and
       *                 2 blocks after 550. And there were 2 blocks in 350 to 550 before.
       *                 That means existing Array is
       *                 [b1, b2, b3, -- b4, b5 --, b6, b7 )], affected blocks are b4, b5.
       *                 So they will be replaced with new 3 blocks.
       *                 Final array will look like
       *                 [old_b1, old_b2, old_b3, -- new_b4, new_b5, new_b6 --, old_b6, old_b7 )]
       */ let startIndex = -1, endIndex = -1;
            updatedProactiveAIBlock.forEach((block, index)=>{
                if (block.inlineNodeStart <= step.from && block.inlineNodeEnd >= step.from || block.inlineNodeStart <= step.to && block.inlineNodeEnd >= step.to) {
                    if (startIndex === -1) {
                        startIndex = index;
                        endIndex = index;
                    } else if (startIndex > -1) endIndex = index;
                }
                // or if block is within step range
                if (block.inlineNodeStart >= step.from && block.inlineNodeEnd <= step.to) {
                    if (startIndex === -1) {
                        startIndex = index;
                        endIndex = index;
                    } else if (startIndex > -1) endIndex = index;
                }
                // if range is between current and next block,
                //	thus neigher current or next block should be replaced
                if (index < updatedProactiveAIBlock.length - 1) {
                    const nextBlock = updatedProactiveAIBlock[index + 1];
                    if (step.from > block.inlineNodeEnd && step.to < nextBlock.inlineNodeStart) {
                        /**
             * We want to add new block after current block.
             * So startIndex has to be "index + 1".
             * Also we don't want to delete any block.
             * So expression "endIndex - startIndex + 1" must be 0.
             * So setting endIndex to "index".
             */ startIndex = index + 1;
                        endIndex = index;
                    }
                }
                // if step range is outside last block then it's new blocks
                if (index === updatedProactiveAIBlock.length - 1 && step.from > block.inlineNodeEnd && step.to > block.inlineNodeEnd) {
                    startIndex = index + 1;
                    endIndex = index + 1;
                }
            });
            if (startIndex > -1 && endIndex > -1) updatedProactiveAIBlock.splice(startIndex, endIndex - startIndex + 1, ...newProactiveAIBlocks);
        });
        updatedProactiveAIBlock = updatedProactiveAIBlock.map((block)=>{
            if (block.newBlock) {
                delete block.newBlock;
                delete block.node;
            } else {
                block.from = tr.mapping.map(block.from);
                block.to = tr.mapping.map(block.to);
                block.inlineNodeStart = tr.mapping.map(block.inlineNodeStart);
                block.inlineNodeEnd = tr.mapping.map(block.inlineNodeEnd);
            }
            return block;
        });
        return {
            originProactiveAIBlock: proactiveAIBlocks,
            updatedProactiveAIBlock: updatedProactiveAIBlock
        };
    }
    return {
        originProactiveAIBlock: proactiveAIBlocks,
        updatedProactiveAIBlock: proactiveAIBlocks
    };
}
function $d12d8675f64157e1$export$84c79514d0cb7da7(state) {
    const nodeTypes = $d12d8675f64157e1$export$2e312585e39e3b9f(state);
    const includedNodeTypes = $d12d8675f64157e1$export$e5022a60bacc9f19(state);
    const proactiveAIBlocks = [];
    state.doc.descendants((node, pos)=>{
        if (nodeTypes.has(node.type)) {
            const inlineNodePositions = [];
            node.descendants((node, pos)=>{
                if (node.isInline && !node.isText) inlineNodePositions.push(pos);
            });
            proactiveAIBlocks.push({
                id: (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))(),
                text: node.textContent,
                from: pos,
                to: pos + node.nodeSize,
                nodeTypeName: node.type.name,
                inlineNodeStart: pos + 1,
                inlineNodeEnd: pos + node.nodeSize - 1,
                inlineNodePositions: inlineNodePositions,
                needSpellingAndGrammarCheck: false
            });
        }
        return includedNodeTypes.has(node.type);
    });
    return proactiveAIBlocks;
}

});
parcelRegister("1YM8X", function(module, exports) {

$parcel$export(module.exports, "getDiffObjectsBetweenParagraphs", () => $1710bd5ab4a1d027$export$c1fe10ff57101ea1);
$parcel$export(module.exports, "getDiffObjectsForParagraph", () => $1710bd5ab4a1d027$export$f4a6062f6829e3a5);

var $dFBS3 = parcelRequire("dFBS3");

var $7GY5V = parcelRequire("7GY5V");
const $1710bd5ab4a1d027$export$e4dfc69b82492f0e = (a, b)=>{
    const diff = (0, $7GY5V.DiffMatchPatch).diff_linesToWords_(a, b);
    const diffs = (0, $7GY5V.DiffMatchPatch).diff_main(diff.chars1, diff.chars2, false);
    (0, $7GY5V.DiffMatchPatch).diff_charsToLines_(diffs, diff.lineArray);
    return diffs.map((diff)=>({
            type: diff[0],
            text: diff[1],
            length: diff[1].length
        }));
};
const $1710bd5ab4a1d027$var$normaliseType = (diff, nextDiff)=>{
    if (diff.type === -1 && (nextDiff === null || nextDiff === void 0 ? void 0 : nextDiff.type) === 1) // Lookahead 1 diff to see if the next diff is an Addition
    return 'REPLACEMENT';
    else if (diff.type === 1) return 'DELETION';
    else if (diff.type === -1 && (!nextDiff || nextDiff && nextDiff.type !== 1)) return 'ADDITION';
};
const $1710bd5ab4a1d027$export$c1fe10ff57101ea1 = (paragraphsA, paragraphsB)=>paragraphsA.reduce((acc, paragraph, index)=>acc.concat($1710bd5ab4a1d027$export$f4a6062f6829e3a5(paragraph, paragraphsB[index].text)), []);
const $1710bd5ab4a1d027$export$f4a6062f6829e3a5 = (originalParagraph, correctedParagraphText)=>{
    const diffObjects = [];
    const originalText = originalParagraph.text;
    const diffs = $1710bd5ab4a1d027$export$e4dfc69b82492f0e(originalText.trim(), correctedParagraphText.trim());
    const trimmingStartOffset = originalText.length - originalText.trimStart().length;
    let offset = originalParagraph.from + trimmingStartOffset;
    const n = diffs.length;
    for(let i = 0; i < n; i++){
        const { type: type, text: text, length: length } = diffs[i];
        const finalType = $1710bd5ab4a1d027$var$normaliseType(diffs[i], diffs === null || diffs === void 0 ? void 0 : diffs[i + 1]);
        if (finalType === 'DELETION') diffObjects.push({
            id: (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))(),
            from: 1 + offset,
            to: 1 + offset,
            type: finalType,
            text: text,
            originalText: text
        });
        else if (finalType === 'REPLACEMENT' || finalType === 'ADDITION') {
            // Count how many inline nodes are overlapping with the word correction, and cater for them
            const inlineNodeOverlapCount = originalParagraph.inlineNodePositions.filter((pos)=>originalParagraph.from + pos <= offset + length && originalParagraph.from + pos >= offset).length;
            const inlineNodeOffsetCount = originalParagraph.inlineNodePositions.filter((pos)=>originalParagraph.from + pos < offset).length;
            const obj = {
                id: (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))(),
                from: 1 + offset + inlineNodeOffsetCount,
                to: 1 + offset + length + inlineNodeOffsetCount - inlineNodeOverlapCount,
                type: finalType,
                text: text,
                originalText: text
            };
            if (finalType === 'REPLACEMENT') {
                var _diffs$text, _diffs;
                const nextText = (_diffs$text = diffs === null || diffs === void 0 ? void 0 : (_diffs = diffs[i + 1]) === null || _diffs === void 0 ? void 0 : _diffs.text) !== null && _diffs$text !== void 0 ? _diffs$text : text;
                const shouldTrimEndingSpace = text.endsWith(' ') && nextText.endsWith(' ');
                obj.to += shouldTrimEndingSpace ? -1 : 0;
                obj.text = shouldTrimEndingSpace ? nextText.slice(0, -1) : nextText;
                obj.originalText = shouldTrimEndingSpace ? text.slice(0, -1) : text;
                i++;
            }
            diffObjects.push(obj);
        }
        // unchanged and removed words are part of original text
        if (type === 0 || type === -1) offset += length;
    }
    return diffObjects;
};

});
parcelRegister("7GY5V", function(module, exports) {

$parcel$export(module.exports, "DiffMatchPatch", () => $599b122ba8104afa$export$c1e60f059545054a);
/* eslint-disable @typescript-eslint/no-this-alias */ /* eslint-disable eqeqeq */ /* eslint-disable block-scoped-var */ // @ts-nocheck
/**
 * Diff Match and Patch
 * Copyright 2018 The diff-match-patch Authors.
 * https://github.com/google/diff-match-patch
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Computes the difference between two texts to create a patch.
 * Applies the patch onto another text, allowing for errors.
 * @author fraser@google.com (Neil Fraser)
 */ /**
 * Class containing the diff, match and patch methods.
 * @constructor
 */ var $599b122ba8104afa$export$b7b760e1e7f1805e = function() {
    // Defaults.
    // Redefine these in your program to override the defaults.
    // Number of seconds to map a diff before giving up (0 for infinity).
    this.Diff_Timeout = 1.0;
    // Cost of an empty edit operation in terms of edit characters.
    this.Diff_EditCost = 4;
    // At what point is no match declared (0.0 = perfection, 1.0 = very loose).
    this.Match_Threshold = 0.5;
    // How far to search for a match (0 = exact location, 1000+ = broad match).
    // A match this many characters away from the expected location will add
    // 1.0 to the score (0.0 is a perfect match).
    this.Match_Distance = 1000;
    // When deleting a large block of text (over ~64 characters), how close do
    // the contents have to be to match the expected contents. (0.0 = perfection,
    // 1.0 = very loose).  Note that Match_Threshold controls how closely the
    // end points of a delete need to match.
    this.Patch_DeleteThreshold = 0.5;
    // Chunk size for context length.
    this.Patch_Margin = 4;
    // The number of bits in an int.
    this.Match_MaxBits = 32;
};
//  DIFF FUNCTIONS
/**
 * The data structure representing a diff is an array of tuples:
 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
 */ var $599b122ba8104afa$var$DIFF_DELETE = -1;
var $599b122ba8104afa$var$DIFF_INSERT = 1;
var $599b122ba8104afa$var$DIFF_EQUAL = 0;
/**
 * Class representing one diff tuple.
 * Attempts to look like a two-element array (which is what this used to be).
 * @param {number} op Operation, one of: DIFF_DELETE, DIFF_INSERT, DIFF_EQUAL.
 * @param {string} text Text to be deleted, inserted, or retained.
 * @constructor
 */ $599b122ba8104afa$export$b7b760e1e7f1805e.Diff = function(op, text) {
    this[0] = op;
    this[1] = text;
};
$599b122ba8104afa$export$b7b760e1e7f1805e.Diff.prototype.length = 2;
/**
 * Emulate the output of a two-element array.
 * @return {string} Diff operation as a string.
 */ $599b122ba8104afa$export$b7b760e1e7f1805e.Diff.prototype.toString = function() {
    return this[0] + ',' + this[1];
};
/**
 * Find the differences between two texts.  Simplifies the problem by stripping
 * any common prefix or suffix off the texts before diffing.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {boolean=} opt_checklines Optional speedup flag. If present and false,
 *     then don't run a line-level diff first to identify the changed areas.
 *     Defaults to true, which does a faster, slightly less optimal diff.
 * @param {number=} opt_deadline Optional time when the diff should be complete
 *     by.  Used internally for recursive calls.  Users should set DiffTimeout
 *     instead.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 */ $599b122ba8104afa$export$b7b760e1e7f1805e.prototype.diff_main = function(text1, text2, opt_checklines, opt_deadline) {
    // Set a deadline by which time the diff must be complete.
    if (typeof opt_deadline == 'undefined') {
        if (this.Diff_Timeout <= 0) opt_deadline = Number.MAX_VALUE;
        else opt_deadline = new Date().getTime() + this.Diff_Timeout * 1000;
    }
    var deadline = opt_deadline;
    // Check for null inputs.
    if (text1 == null || text2 == null) throw new Error('Null input. (diff_main)');
    // Check for equality (speedup).
    if (text1 == text2) {
        if (text1) return [
            new $599b122ba8104afa$export$b7b760e1e7f1805e.Diff($599b122ba8104afa$var$DIFF_EQUAL, text1)
        ];
        return [];
    }
    if (typeof opt_checklines == 'undefined') opt_checklines = true;
    var checklines = opt_checklines;
    // Trim off common prefix (speedup).
    var commonlength = this.diff_commonPrefix(text1, text2);
    var commonprefix = text1.substring(0, commonlength);
    text1 = text1.substring(commonlength);
    text2 = text2.substring(commonlength);
    // Trim off common suffix (speedup).
    commonlength = this.diff_commonSuffix(text1, text2);
    var commonsuffix = text1.substring(text1.length - commonlength);
    text1 = text1.substring(0, text1.length - commonlength);
    text2 = text2.substring(0, text2.length - commonlength);
    // Compute the diff on the middle block.
    var diffs = this.diff_compute_(text1, text2, checklines, deadline);
    // Restore the prefix and suffix.
    if (commonprefix) diffs.unshift(new $599b122ba8104afa$export$b7b760e1e7f1805e.Diff($599b122ba8104afa$var$DIFF_EQUAL, commonprefix));
    if (commonsuffix) diffs.push(new $599b122ba8104afa$export$b7b760e1e7f1805e.Diff($599b122ba8104afa$var$DIFF_EQUAL, commonsuffix));
    this.diff_cleanupMerge(diffs);
    return diffs;
};
/**
 * Find the differences between two texts.  Assumes that the texts do not
 * have any common prefix or suffix.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {boolean} checklines Speedup flag.  If false, then don't run a
 *     line-level diff first to identify the changed areas.
 *     If true, then run a faster, slightly less optimal diff.
 * @param {number} deadline Time when the diff should be complete by.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @private
 */ $599b122ba8104afa$export$b7b760e1e7f1805e.prototype.diff_compute_ = function(text1, text2, checklines, deadline) {
    var diffs;
    if (!text1) // Just add some text (speedup).
    return [
        new $599b122ba8104afa$export$b7b760e1e7f1805e.Diff($599b122ba8104afa$var$DIFF_INSERT, text2)
    ];
    if (!text2) // Just delete some text (speedup).
    return [
        new $599b122ba8104afa$export$b7b760e1e7f1805e.Diff($599b122ba8104afa$var$DIFF_DELETE, text1)
    ];
    var longtext = text1.length > text2.length ? text1 : text2;
    var shorttext = text1.length > text2.length ? text2 : text1;
    var i = longtext.indexOf(shorttext);
    if (i != -1) {
        // Shorter text is inside the longer text (speedup).
        diffs = [
            new $599b122ba8104afa$export$b7b760e1e7f1805e.Diff($599b122ba8104afa$var$DIFF_INSERT, longtext.substring(0, i)),
            new $599b122ba8104afa$export$b7b760e1e7f1805e.Diff($599b122ba8104afa$var$DIFF_EQUAL, shorttext),
            new $599b122ba8104afa$export$b7b760e1e7f1805e.Diff($599b122ba8104afa$var$DIFF_INSERT, longtext.substring(i + shorttext.length))
        ];
        // Swap insertions for deletions if diff is reversed.
        if (text1.length > text2.length) diffs[0][0] = diffs[2][0] = $599b122ba8104afa$var$DIFF_DELETE;
        return diffs;
    }
    if (shorttext.length == 1) // Single character string.
    // After the previous speedup, the character can't be an equality.
    return [
        new $599b122ba8104afa$export$b7b760e1e7f1805e.Diff($599b122ba8104afa$var$DIFF_DELETE, text1),
        new $599b122ba8104afa$export$b7b760e1e7f1805e.Diff($599b122ba8104afa$var$DIFF_INSERT, text2)
    ];
    // Check to see if the problem can be split in two.
    var hm = this.diff_halfMatch_(text1, text2);
    if (hm) {
        // A half-match was found, sort out the return data.
        var text1_a = hm[0];
        var text1_b = hm[1];
        var text2_a = hm[2];
        var text2_b = hm[3];
        var mid_common = hm[4];
        // Send both pairs off for separate processing.
        var diffs_a = this.diff_main(text1_a, text2_a, checklines, deadline);
        var diffs_b = this.diff_main(text1_b, text2_b, checklines, deadline);
        // Merge the results.
        return diffs_a.concat([
            new $599b122ba8104afa$export$b7b760e1e7f1805e.Diff($599b122ba8104afa$var$DIFF_EQUAL, mid_common)
        ], diffs_b);
    }
    if (checklines && text1.length > 100 && text2.length > 100) return this.diff_lineMode_(text1, text2, deadline);
    return this.diff_bisect_(text1, text2, deadline);
};
/**
 * Do a quick line-level diff on both strings, then rediff the parts for
 * greater accuracy.
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} deadline Time when the diff should be complete by.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @private
 */ $599b122ba8104afa$export$b7b760e1e7f1805e.prototype.diff_lineMode_ = function(text1, text2, deadline) {
    // Scan the text on a line-by-line basis first.
    var a = this.diff_linesToChars_(text1, text2);
    text1 = a.chars1;
    text2 = a.chars2;
    var linearray = a.lineArray;
    var diffs = this.diff_main(text1, text2, false, deadline);
    // Convert the diff back to original text.
    this.diff_charsToLines_(diffs, linearray);
    // Eliminate freak matches (e.g. blank lines)
    this.diff_cleanupSemantic(diffs);
    // Rediff any replacement blocks, this time character-by-character.
    // Add a dummy entry at the end.
    diffs.push(new $599b122ba8104afa$export$b7b760e1e7f1805e.Diff($599b122ba8104afa$var$DIFF_EQUAL, ''));
    var pointer = 0;
    var count_delete = 0;
    var count_insert = 0;
    var text_delete = '';
    var text_insert = '';
    while(pointer < diffs.length){
        switch(diffs[pointer][0]){
            case $599b122ba8104afa$var$DIFF_INSERT:
                count_insert++;
                text_insert += diffs[pointer][1];
                break;
            case $599b122ba8104afa$var$DIFF_DELETE:
                count_delete++;
                text_delete += diffs[pointer][1];
                break;
            case $599b122ba8104afa$var$DIFF_EQUAL:
                // Upon reaching an equality, check for prior redundancies.
                if (count_delete >= 1 && count_insert >= 1) {
                    // Delete the offending records and add the merged ones.
                    diffs.splice(pointer - count_delete - count_insert, count_delete + count_insert);
                    pointer = pointer - count_delete - count_insert;
                    var subDiff = this.diff_main(text_delete, text_insert, false, deadline);
                    for(var j = subDiff.length - 1; j >= 0; j--)diffs.splice(pointer, 0, subDiff[j]);
                    pointer = pointer + subDiff.length;
                }
                count_insert = 0;
                count_delete = 0;
                text_delete = '';
                text_insert = '';
                break;
        }
        pointer++;
    }
    diffs.pop(); // Remove the dummy entry at the end.
    return diffs;
};
/**
 * Find the 'middle snake' of a diff, split the problem in two
 * and return the recursively constructed diff.
 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} deadline Time at which to bail if not yet complete.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @private
 */ $599b122ba8104afa$export$b7b760e1e7f1805e.prototype.diff_bisect_ = function(text1, text2, deadline) {
    // Cache the text lengths to prevent multiple calls.
    var text1_length = text1.length;
    var text2_length = text2.length;
    var max_d = Math.ceil((text1_length + text2_length) / 2);
    var v_offset = max_d;
    var v_length = 2 * max_d;
    var v1 = new Array(v_length);
    var v2 = new Array(v_length);
    // Setting all elements to -1 is faster in Chrome & Firefox than mixing
    // integers and undefined.
    for(var x = 0; x < v_length; x++){
        v1[x] = -1;
        v2[x] = -1;
    }
    v1[v_offset + 1] = 0;
    v2[v_offset + 1] = 0;
    var delta = text1_length - text2_length;
    // If the total number of characters is odd, then the front path will collide
    // with the reverse path.
    var front = delta % 2 != 0;
    // Offsets for start and end of k loop.
    // Prevents mapping of space beyond the grid.
    var k1start = 0;
    var k1end = 0;
    var k2start = 0;
    var k2end = 0;
    for(var d = 0; d < max_d; d++){
        // Bail out if deadline is reached.
        if (new Date().getTime() > deadline) break;
        // Walk the front path one step.
        for(var k1 = -d + k1start; k1 <= d - k1end; k1 += 2){
            var k1_offset = v_offset + k1;
            var x1;
            if (k1 == -d || k1 != d && v1[k1_offset - 1] < v1[k1_offset + 1]) x1 = v1[k1_offset + 1];
            else x1 = v1[k1_offset - 1] + 1;
            var y1 = x1 - k1;
            while(x1 < text1_length && y1 < text2_length && text1.charAt(x1) == text2.charAt(y1)){
                x1++;
                y1++;
            }
            v1[k1_offset] = x1;
            if (x1 > text1_length) // Ran off the right of the graph.
            k1end += 2;
            else if (y1 > text2_length) // Ran off the bottom of the graph.
            k1start += 2;
            else if (front) {
                var k2_offset = v_offset + delta - k1;
                if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
                    // Mirror x2 onto top-left coordinate system.
                    var x2 = text1_length - v2[k2_offset];
                    if (x1 >= x2) // Overlap detected.
                    return this.diff_bisectSplit_(text1, text2, x1, y1, deadline);
                }
            }
        }
        // Walk the reverse path one step.
        for(var k2 = -d + k2start; k2 <= d - k2end; k2 += 2){
            var k2_offset = v_offset + k2;
            var x2;
            if (k2 == -d || k2 != d && v2[k2_offset - 1] < v2[k2_offset + 1]) x2 = v2[k2_offset + 1];
            else x2 = v2[k2_offset - 1] + 1;
            var y2 = x2 - k2;
            while(x2 < text1_length && y2 < text2_length && text1.charAt(text1_length - x2 - 1) == text2.charAt(text2_length - y2 - 1)){
                x2++;
                y2++;
            }
            v2[k2_offset] = x2;
            if (x2 > text1_length) // Ran off the left of the graph.
            k2end += 2;
            else if (y2 > text2_length) // Ran off the top of the graph.
            k2start += 2;
            else if (!front) {
                var k1_offset = v_offset + delta - k2;
                if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
                    var x1 = v1[k1_offset];
                    var y1 = v_offset + x1 - k1_offset;
                    // Mirror x2 onto top-left coordinate system.
                    x2 = text1_length - x2;
                    if (x1 >= x2) // Overlap detected.
                    return this.diff_bisectSplit_(text1, text2, x1, y1, deadline);
                }
            }
        }
    }
    // Diff took too long and hit the deadline or
    // number of diffs equals number of characters, no commonality at all.
    return [
        new $599b122ba8104afa$export$b7b760e1e7f1805e.Diff($599b122ba8104afa$var$DIFF_DELETE, text1),
        new $599b122ba8104afa$export$b7b760e1e7f1805e.Diff($599b122ba8104afa$var$DIFF_INSERT, text2)
    ];
};
/**
 * Given the location of the 'middle snake', split the diff in two parts
 * and recurse.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} x Index of split point in text1.
 * @param {number} y Index of split point in text2.
 * @param {number} deadline Time at which to bail if not yet complete.
 * @return {!Array.<!diff_match_patch.Diff>} Array of diff tuples.
 * @private
 */ $599b122ba8104afa$export$b7b760e1e7f1805e.prototype.diff_bisectSplit_ = function(text1, text2, x, y, deadline) {
    var text1a = text1.substring(0, x);
    var text2a = text2.substring(0, y);
    var text1b = text1.substring(x);
    var text2b = text2.substring(y);
    // Compute both diffs serially.
    var diffs = this.diff_main(text1a, text2a, false, deadline);
    var diffsb = this.diff_main(text1b, text2b, false, deadline);
    return diffs.concat(diffsb);
};
/**
 * Split two texts into an array of strings.  Reduce the texts to a string of
 * hashes where each Unicode character represents one line.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {{chars1: string, chars2: string, lineArray: !Array.<string>}}
 *     An object containing the encoded text1, the encoded text2 and
 *     the array of unique strings.
 *     The zeroth element of the array of unique strings is intentionally blank.
 * @private
 */ $599b122ba8104afa$export$b7b760e1e7f1805e.prototype.diff_linesToChars_ = function(text1, text2) {
    var lineArray = []; // e.g. lineArray[4] == 'Hello\n'
    var lineHash = {}; // e.g. lineHash['Hello\n'] == 4
    // '\x00' is a valid character, but various debuggers don't like it.
    // So we'll insert a junk entry to avoid generating a null character.
    lineArray[0] = '';
    /**
   * Split a text into an array of strings.  Reduce the texts to a string of
   * hashes where each Unicode character represents one line.
   * Modifies linearray and linehash through being a closure.
   * @param {string} text String to encode.
   * @return {string} Encoded string.
   * @private
   */ function diff_linesToCharsMunge_(text) {
        var chars = '';
        // Walk the text, pulling out a substring for each line.
        // text.split('\n') would would temporarily double our memory footprint.
        // Modifying text would create many large strings to garbage collect.
        var lineStart = 0;
        var lineEnd = -1;
        // Keeping our own length variable is faster than looking it up.
        var lineArrayLength = lineArray.length;
        while(lineEnd < text.length - 1){
            lineEnd = text.indexOf('\n', lineStart);
            if (lineEnd == -1) lineEnd = text.length - 1;
            var line = text.substring(lineStart, lineEnd + 1);
            if (lineHash.hasOwnProperty ? lineHash.hasOwnProperty(line) : lineHash[line] !== undefined) chars += String.fromCharCode(lineHash[line]);
            else {
                if (lineArrayLength == maxLines) {
                    // Bail out at 65535 because
                    // String.fromCharCode(65536) == String.fromCharCode(0)
                    line = text.substring(lineStart);
                    lineEnd = text.length;
                }
                chars += String.fromCharCode(lineArrayLength);
                lineHash[line] = lineArrayLength;
                lineArray[lineArrayLength++] = line;
            }
            lineStart = lineEnd + 1;
        }
        return chars;
    }
    // Allocate 2/3rds of the space for text1, the rest for text2.
    var maxLines = 40000;
    var chars1 = diff_linesToCharsMunge_(text1);
    maxLines = 65535;
    var chars2 = diff_linesToCharsMunge_(text2);
    return {
        chars1: chars1,
        chars2: chars2,
        lineArray: lineArray
    };
};
/**
 * Split two texts into an array of strings.  Reduce the texts to a string of
 * hashes where each Unicode character represents one line.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {{chars1: string, chars2: string, lineArray: !Array.<string>}}
 *     An object containing the encoded text1, the encoded text2 and
 *     the array of unique strings.
 *     The zeroth element of the array of unique strings is intentionally blank.
 * @private
 */ $599b122ba8104afa$export$b7b760e1e7f1805e.prototype.diff_linesToWords_ = function(text1, text2) {
    var lineArray = []; // e.g. lineArray[4] == 'Hello\n'
    var lineHash = {}; // e.g. lineHash['Hello\n'] == 4
    // '\x00' is a valid character, but various debuggers don't like it.
    // So we'll insert a junk entry to avoid generating a null character.
    lineArray[0] = '';
    /**
   * Split a text into an array of strings.  Reduce the texts to a string of
   * hashes where each Unicode character represents one line.
   * Modifies linearray and linehash through being a closure.
   * @param {string} text String to encode.
   * @return {string} Encoded string.
   * @private
   */ function diff_linesToWordsMunge_(text) {
        var chars = '';
        // Walk the text, pulling out a substring for each line.
        // text.split('\n') would would temporarily double our memory footprint.
        // Modifying text would create many large strings to garbage collect.
        var lineStart = 0;
        var lineEnd = -1;
        const delims = [
            '.',
            ',',
            '?',
            '!',
            ':',
            ';',
            ' '
        ];
        // Keeping our own length variable is faster than looking it up.
        var lineArrayLength = lineArray.length;
        while(text !== null && text !== void 0 && text.length && lineEnd < text.length - 1){
            lineEnd = delims.reduce((v, c)=>{
                const i = text.indexOf(c, lineStart);
                return i !== -1 && i < v ? i : v;
            }, text.length - 1);
            const foundDelim = delims.includes(text.charAt(lineEnd));
            if (lineEnd == -1) lineEnd = text.length - 1;
            if (foundDelim) {
                const delim = text.charAt(lineEnd);
                // This is a simple tally of all the matching same delims after the current one
                let length = 1;
                for(let i = lineEnd + 1; i < text.length; i++){
                    if (text.charAt(i) !== delim) break;
                    length++;
                }
                // We need to offset the linend to the index of the last matching delimeter. This will ensure that the group of
                // delims are treated as unique and the next iteration of the while loop starts on the char after the last delim.
                lineEnd += length - 1;
            }
            var line = text.substring(lineStart, lineEnd + 1);
            if (lineHash.hasOwnProperty ? lineHash.hasOwnProperty(line) : lineHash[line] !== undefined) chars += String.fromCharCode(lineHash[line]);
            else {
                if (lineArrayLength == maxLines) {
                    // Bail out at 65535 because
                    // String.fromCharCode(65536) == String.fromCharCode(0)
                    line = text.substring(lineStart);
                    lineEnd = text.length;
                }
                chars += String.fromCharCode(lineArrayLength);
                lineHash[line] = lineArrayLength;
                lineArray[lineArrayLength++] = line;
            }
            lineStart = lineEnd + 1;
        }
        return chars;
    }
    // Allocate 2/3rds of the space for text1, the rest for text2.
    var maxLines = 40000;
    var chars1 = diff_linesToWordsMunge_(text1);
    maxLines = 65535;
    var chars2 = diff_linesToWordsMunge_(text2);
    return {
        chars1: chars1,
        chars2: chars2,
        lineArray: lineArray
    };
};
/**
 * Rehydrate the text in a diff from a string of line hashes to real lines of
 * text.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 * @param {!Array.<string>} lineArray Array of unique strings.
 * @private
 */ $599b122ba8104afa$export$b7b760e1e7f1805e.prototype.diff_charsToLines_ = function(diffs, lineArray) {
    for(var i = 0; i < diffs.length; i++){
        var chars = diffs[i][1];
        var text = [];
        for(var j = 0; j < chars.length; j++)text[j] = lineArray[chars.charCodeAt(j)];
        diffs[i][1] = text.join('');
    }
};
/**
 * Determine the common prefix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the start of each
 *     string.
 */ $599b122ba8104afa$export$b7b760e1e7f1805e.prototype.diff_commonPrefix = function(text1, text2) {
    // Quick check for common null cases.
    if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) return 0;
    // Binary search.
    // Performance analysis: https://neil.fraser.name/news/2007/10/09/
    var pointermin = 0;
    var pointermax = Math.min(text1.length, text2.length);
    var pointermid = pointermax;
    var pointerstart = 0;
    while(pointermin < pointermid){
        if (text1.substring(pointerstart, pointermid) == text2.substring(pointerstart, pointermid)) {
            pointermin = pointermid;
            pointerstart = pointermin;
        } else pointermax = pointermid;
        pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
    }
    return pointermid;
};
/**
 * Determine the common suffix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of each string.
 */ $599b122ba8104afa$export$b7b760e1e7f1805e.prototype.diff_commonSuffix = function(text1, text2) {
    // Quick check for common null cases.
    if (!text1 || !text2 || text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) return 0;
    // Binary search.
    // Performance analysis: https://neil.fraser.name/news/2007/10/09/
    var pointermin = 0;
    var pointermax = Math.min(text1.length, text2.length);
    var pointermid = pointermax;
    var pointerend = 0;
    while(pointermin < pointermid){
        if (text1.substring(text1.length - pointermid, text1.length - pointerend) == text2.substring(text2.length - pointermid, text2.length - pointerend)) {
            pointermin = pointermid;
            pointerend = pointermin;
        } else pointermax = pointermid;
        pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
    }
    return pointermid;
};
/**
 * Determine if the suffix of one string is the prefix of another.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of the first
 *     string and the start of the second string.
 * @private
 */ $599b122ba8104afa$export$b7b760e1e7f1805e.prototype.diff_commonOverlap_ = function(text1, text2) {
    // Cache the text lengths to prevent multiple calls.
    var text1_length = text1.length;
    var text2_length = text2.length;
    // Eliminate the null case.
    if (text1_length == 0 || text2_length == 0) return 0;
    // Truncate the longer string.
    if (text1_length > text2_length) text1 = text1.substring(text1_length - text2_length);
    else if (text1_length < text2_length) text2 = text2.substring(0, text1_length);
    var text_length = Math.min(text1_length, text2_length);
    // Quick check for the worst case.
    if (text1 == text2) return text_length;
    // Start by looking for a single character match
    // and increase length until no match is found.
    // Performance analysis: https://neil.fraser.name/news/2010/11/04/
    var best = 0;
    var length = 1;
    while(true){
        var pattern = text1.substring(text_length - length);
        var found = text2.indexOf(pattern);
        if (found == -1) return best;
        length += found;
        if (found == 0 || text1.substring(text_length - length) == text2.substring(0, length)) {
            best = length;
            length++;
        }
    }
};
/**
 * Do the two texts share a substring which is at least half the length of the
 * longer text?
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {Array.<string>} Five element Array, containing the prefix of
 *     text1, the suffix of text1, the prefix of text2, the suffix of
 *     text2 and the common middle.  Or null if there was no match.
 * @private
 */ $599b122ba8104afa$export$b7b760e1e7f1805e.prototype.diff_halfMatch_ = function(text1, text2) {
    if (this.Diff_Timeout <= 0) // Don't risk returning a non-optimal diff if we have unlimited time.
    return null;
    var longtext = text1.length > text2.length ? text1 : text2;
    var shorttext = text1.length > text2.length ? text2 : text1;
    if (longtext.length < 4 || shorttext.length * 2 < longtext.length) return null; // Pointless.
    var dmp = this; // 'this' becomes 'window' in a closure.
    /**
   * Does a substring of shorttext exist within longtext such that the substring
   * is at least half the length of longtext?
   * Closure, but does not reference any external variables.
   * @param {string} longtext Longer string.
   * @param {string} shorttext Shorter string.
   * @param {number} i Start index of quarter length substring within longtext.
   * @return {Array.<string>} Five element Array, containing the prefix of
   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
   *     of shorttext and the common middle.  Or null if there was no match.
   * @private
   */ function diff_halfMatchI_(longtext, shorttext, i) {
        // Start with a 1/4 length substring at position i as a seed.
        var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
        var j = -1;
        var best_common = '';
        var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
        while((j = shorttext.indexOf(seed, j + 1)) != -1){
            var prefixLength = dmp.diff_commonPrefix(longtext.substring(i), shorttext.substring(j));
            var suffixLength = dmp.diff_commonSuffix(longtext.substring(0, i), shorttext.substring(0, j));
            if (best_common.length < suffixLength + prefixLength) {
                best_common = shorttext.substring(j - suffixLength, j) + shorttext.substring(j, j + prefixLength);
                best_longtext_a = longtext.substring(0, i - suffixLength);
                best_longtext_b = longtext.substring(i + prefixLength);
                best_shorttext_a = shorttext.substring(0, j - suffixLength);
                best_shorttext_b = shorttext.substring(j + prefixLength);
            }
        }
        if (best_common.length * 2 >= longtext.length) return [
            best_longtext_a,
            best_longtext_b,
            best_shorttext_a,
            best_shorttext_b,
            best_common
        ];
        else return null;
    }
    // First check if the second quarter is the seed for a half-match.
    var hm1 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 4));
    // Check again based on the third quarter.
    var hm2 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 2));
    var hm;
    if (!hm1 && !hm2) return null;
    else if (!hm2) hm = hm1;
    else if (!hm1) hm = hm2;
    else // Both matched.  Select the longest.
    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
    // A half-match was found, sort out the return data.
    var text1_a, text1_b, text2_a, text2_b;
    if (text1.length > text2.length) {
        text1_a = hm[0];
        text1_b = hm[1];
        text2_a = hm[2];
        text2_b = hm[3];
    } else {
        text2_a = hm[0];
        text2_b = hm[1];
        text1_a = hm[2];
        text1_b = hm[3];
    }
    var mid_common = hm[4];
    return [
        text1_a,
        text1_b,
        text2_a,
        text2_b,
        mid_common
    ];
};
/**
 * Reduce the number of edits by eliminating semantically trivial equalities.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */ $599b122ba8104afa$export$b7b760e1e7f1805e.prototype.diff_cleanupSemantic = function(diffs) {
    var changes = false;
    var equalities = []; // Stack of indices where equalities are found.
    var equalitiesLength = 0; // Keeping our own length var is faster in JS.
    /** @type {?string} */ var lastEquality = null;
    // Always equal to diffs[equalities[equalitiesLength - 1]][1]
    var pointer = 0; // Index of current position.
    // Number of characters that changed prior to the equality.
    var length_insertions1 = 0;
    var length_deletions1 = 0;
    // Number of characters that changed after the equality.
    var length_insertions2 = 0;
    var length_deletions2 = 0;
    while(pointer < diffs.length){
        if (diffs[pointer][0] == $599b122ba8104afa$var$DIFF_EQUAL) {
            // Equality found.
            equalities[equalitiesLength++] = pointer;
            length_insertions1 = length_insertions2;
            length_deletions1 = length_deletions2;
            length_insertions2 = 0;
            length_deletions2 = 0;
            lastEquality = diffs[pointer][1];
        } else {
            // An insertion or deletion.
            if (diffs[pointer][0] == $599b122ba8104afa$var$DIFF_INSERT) length_insertions2 += diffs[pointer][1].length;
            else length_deletions2 += diffs[pointer][1].length;
            // Eliminate an equality that is smaller or equal to the edits on both
            // sides of it.
            if (lastEquality && lastEquality.length <= Math.max(length_insertions1, length_deletions1) && lastEquality.length <= Math.max(length_insertions2, length_deletions2)) {
                // Duplicate record.
                diffs.splice(equalities[equalitiesLength - 1], 0, new $599b122ba8104afa$export$b7b760e1e7f1805e.Diff($599b122ba8104afa$var$DIFF_DELETE, lastEquality));
                // Change second copy to insert.
                diffs[equalities[equalitiesLength - 1] + 1][0] = $599b122ba8104afa$var$DIFF_INSERT;
                // Throw away the equality we just deleted.
                equalitiesLength--;
                // Throw away the previous equality (it needs to be reevaluated).
                equalitiesLength--;
                pointer = equalitiesLength > 0 ? equalities[equalitiesLength - 1] : -1;
                length_insertions1 = 0; // Reset the counters.
                length_deletions1 = 0;
                length_insertions2 = 0;
                length_deletions2 = 0;
                lastEquality = null;
                changes = true;
            }
        }
        pointer++;
    }
    // Normalize the diff.
    if (changes) this.diff_cleanupMerge(diffs);
    this.diff_cleanupSemanticLossless(diffs);
    // Find any overlaps between deletions and insertions.
    // e.g: <del>abcxxx</del><ins>xxxdef</ins>
    //   -> <del>abc</del>xxx<ins>def</ins>
    // e.g: <del>xxxabc</del><ins>defxxx</ins>
    //   -> <ins>def</ins>xxx<del>abc</del>
    // Only extract an overlap if it is as big as the edit ahead or behind it.
    pointer = 1;
    while(pointer < diffs.length){
        if (diffs[pointer - 1][0] == $599b122ba8104afa$var$DIFF_DELETE && diffs[pointer][0] == $599b122ba8104afa$var$DIFF_INSERT) {
            var deletion = diffs[pointer - 1][1];
            var insertion = diffs[pointer][1];
            var overlap_length1 = this.diff_commonOverlap_(deletion, insertion);
            var overlap_length2 = this.diff_commonOverlap_(insertion, deletion);
            if (overlap_length1 >= overlap_length2) {
                if (overlap_length1 >= deletion.length / 2 || overlap_length1 >= insertion.length / 2) {
                    // Overlap found.  Insert an equality and trim the surrounding edits.
                    diffs.splice(pointer, 0, new $599b122ba8104afa$export$b7b760e1e7f1805e.Diff($599b122ba8104afa$var$DIFF_EQUAL, insertion.substring(0, overlap_length1)));
                    diffs[pointer - 1][1] = deletion.substring(0, deletion.length - overlap_length1);
                    diffs[pointer + 1][1] = insertion.substring(overlap_length1);
                    pointer++;
                }
            } else if (overlap_length2 >= deletion.length / 2 || overlap_length2 >= insertion.length / 2) {
                // Reverse overlap found.
                // Insert an equality and swap and trim the surrounding edits.
                diffs.splice(pointer, 0, new $599b122ba8104afa$export$b7b760e1e7f1805e.Diff($599b122ba8104afa$var$DIFF_EQUAL, deletion.substring(0, overlap_length2)));
                diffs[pointer - 1][0] = $599b122ba8104afa$var$DIFF_INSERT;
                diffs[pointer - 1][1] = insertion.substring(0, insertion.length - overlap_length2);
                diffs[pointer + 1][0] = $599b122ba8104afa$var$DIFF_DELETE;
                diffs[pointer + 1][1] = deletion.substring(overlap_length2);
                pointer++;
            }
            pointer++;
        }
        pointer++;
    }
};
/**
 * Look for single edits surrounded on both sides by equalities
 * which can be shifted sideways to align the edit to a word boundary.
 * e.g: The c<ins>at c</ins>ame. -> The <ins>cat </ins>came.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */ $599b122ba8104afa$export$b7b760e1e7f1805e.prototype.diff_cleanupSemanticLossless = function(diffs) {
    /**
   * Given two strings, compute a score representing whether the internal
   * boundary falls on logical boundaries.
   * Scores range from 6 (best) to 0 (worst).
   * Closure, but does not reference any external variables.
   * @param {string} one First string.
   * @param {string} two Second string.
   * @return {number} The score.
   * @private
   */ function diff_cleanupSemanticScore_(one, two) {
        if (!one || !two) // Edges are the best.
        return 6;
        // Each port of this function behaves slightly differently due to
        // subtle differences in each language's definition of things like
        // 'whitespace'.  Since this function's purpose is largely cosmetic,
        // the choice has been made to use each language's native features
        // rather than force total conformity.
        var char1 = one.charAt(one.length - 1);
        var char2 = two.charAt(0);
        var nonAlphaNumeric1 = char1.match($599b122ba8104afa$export$b7b760e1e7f1805e.nonAlphaNumericRegex_);
        var nonAlphaNumeric2 = char2.match($599b122ba8104afa$export$b7b760e1e7f1805e.nonAlphaNumericRegex_);
        var whitespace1 = nonAlphaNumeric1 && char1.match($599b122ba8104afa$export$b7b760e1e7f1805e.whitespaceRegex_);
        var whitespace2 = nonAlphaNumeric2 && char2.match($599b122ba8104afa$export$b7b760e1e7f1805e.whitespaceRegex_);
        var lineBreak1 = whitespace1 && char1.match($599b122ba8104afa$export$b7b760e1e7f1805e.linebreakRegex_);
        var lineBreak2 = whitespace2 && char2.match($599b122ba8104afa$export$b7b760e1e7f1805e.linebreakRegex_);
        var blankLine1 = lineBreak1 && one.match($599b122ba8104afa$export$b7b760e1e7f1805e.blanklineEndRegex_);
        var blankLine2 = lineBreak2 && two.match($599b122ba8104afa$export$b7b760e1e7f1805e.blanklineStartRegex_);
        if (blankLine1 || blankLine2) // Five points for blank lines.
        return 5;
        else if (lineBreak1 || lineBreak2) // Four points for line breaks.
        return 4;
        else if (nonAlphaNumeric1 && !whitespace1 && whitespace2) // Three points for end of sentences.
        return 3;
        else if (whitespace1 || whitespace2) // Two points for whitespace.
        return 2;
        else if (nonAlphaNumeric1 || nonAlphaNumeric2) // One point for non-alphanumeric.
        return 1;
        return 0;
    }
    var pointer = 1;
    // Intentionally ignore the first and last element (don't need checking).
    while(pointer < diffs.length - 1){
        if (diffs[pointer - 1][0] == $599b122ba8104afa$var$DIFF_EQUAL && diffs[pointer + 1][0] == $599b122ba8104afa$var$DIFF_EQUAL) {
            // This is a single edit surrounded by equalities.
            var equality1 = diffs[pointer - 1][1];
            var edit = diffs[pointer][1];
            var equality2 = diffs[pointer + 1][1];
            // First, shift the edit as far left as possible.
            var commonOffset = this.diff_commonSuffix(equality1, edit);
            if (commonOffset) {
                var commonString = edit.substring(edit.length - commonOffset);
                equality1 = equality1.substring(0, equality1.length - commonOffset);
                edit = commonString + edit.substring(0, edit.length - commonOffset);
                equality2 = commonString + equality2;
            }
            // Second, step character by character right, looking for the best fit.
            var bestEquality1 = equality1;
            var bestEdit = edit;
            var bestEquality2 = equality2;
            var bestScore = diff_cleanupSemanticScore_(equality1, edit) + diff_cleanupSemanticScore_(edit, equality2);
            while(edit.charAt(0) === equality2.charAt(0)){
                equality1 += edit.charAt(0);
                edit = edit.substring(1) + equality2.charAt(0);
                equality2 = equality2.substring(1);
                var score = diff_cleanupSemanticScore_(equality1, edit) + diff_cleanupSemanticScore_(edit, equality2);
                // The >= encourages trailing rather than leading whitespace on edits.
                if (score >= bestScore) {
                    bestScore = score;
                    bestEquality1 = equality1;
                    bestEdit = edit;
                    bestEquality2 = equality2;
                }
            }
            if (diffs[pointer - 1][1] != bestEquality1) {
                // We have an improvement, save it back to the diff.
                if (bestEquality1) diffs[pointer - 1][1] = bestEquality1;
                else {
                    diffs.splice(pointer - 1, 1);
                    pointer--;
                }
                diffs[pointer][1] = bestEdit;
                if (bestEquality2) diffs[pointer + 1][1] = bestEquality2;
                else {
                    diffs.splice(pointer + 1, 1);
                    pointer--;
                }
            }
        }
        pointer++;
    }
};
// Define some regex patterns for matching boundaries.
$599b122ba8104afa$export$b7b760e1e7f1805e.nonAlphaNumericRegex_ = /[^a-zA-Z0-9]/;
$599b122ba8104afa$export$b7b760e1e7f1805e.whitespaceRegex_ = /\s/;
$599b122ba8104afa$export$b7b760e1e7f1805e.linebreakRegex_ = /[\r\n]/;
$599b122ba8104afa$export$b7b760e1e7f1805e.blanklineEndRegex_ = /\n\r?\n$/;
$599b122ba8104afa$export$b7b760e1e7f1805e.blanklineStartRegex_ = /^\r?\n\r?\n/;
/**
 * Reduce the number of edits by eliminating operationally trivial equalities.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */ // diff_match_patch.prototype.diff_cleanupEfficiency = function (diffs) {
//   var changes = false;
//   var equalities = []; // Stack of indices where equalities are found.
//   var equalitiesLength = 0; // Keeping our own length var is faster in JS.
//   /** @type {?string} */
//   var lastEquality = null;
//   // Always equal to diffs[equalities[equalitiesLength - 1]][1]
//   var pointer = 0; // Index of current position.
//   // Is there an insertion operation before the last equality.
//   var pre_ins = false;
//   // Is there a deletion operation before the last equality.
//   var pre_del = false;
//   // Is there an insertion operation after the last equality.
//   var post_ins = false;
//   // Is there a deletion operation after the last equality.
//   var post_del = false;
//   while (pointer < diffs.length) {
//     if (diffs[pointer][0] == DIFF_EQUAL) {
//       // Equality found.
//       if (
//         diffs[pointer][1].length < this.Diff_EditCost &&
//         (post_ins || post_del)
//       ) {
//         // Candidate found.
//         equalities[equalitiesLength++] = pointer;
//         pre_ins = post_ins;
//         pre_del = post_del;
//         lastEquality = diffs[pointer][1];
//       } else {
//         // Not a candidate, and can never become one.
//         equalitiesLength = 0;
//         lastEquality = null;
//       }
//       post_ins = post_del = false;
//     } else {
//       // An insertion or deletion.
//       if (diffs[pointer][0] == DIFF_DELETE) {
//         post_del = true;
//       } else {
//         post_ins = true;
//       }
//       /*
//        * Five types to be split:
//        * <ins>A</ins><del>B</del>XY<ins>C</ins><del>D</del>
//        * <ins>A</ins>X<ins>C</ins><del>D</del>
//        * <ins>A</ins><del>B</del>X<ins>C</ins>
//        * <ins>A</del>X<ins>C</ins><del>D</del>
//        * <ins>A</ins><del>B</del>X<del>C</del>
//        */
//       if (
//         lastEquality &&
//         ((pre_ins && pre_del && post_ins && post_del) ||
//           (lastEquality.length < this.Diff_EditCost / 2 &&
//             pre_ins + pre_del + post_ins + post_del == 3))
//       ) {
//         // Duplicate record.
//         diffs.splice(
//           equalities[equalitiesLength - 1],
//           0,
//           new diff_match_patch.Diff(DIFF_DELETE, lastEquality),
//         );
//         // Change second copy to insert.
//         diffs[equalities[equalitiesLength - 1] + 1][0] = DIFF_INSERT;
//         equalitiesLength--; // Throw away the equality we just deleted;
//         lastEquality = null;
//         if (pre_ins && pre_del) {
//           // No changes made which could affect previous entry, keep going.
//           post_ins = post_del = true;
//           equalitiesLength = 0;
//         } else {
//           equalitiesLength--; // Throw away the previous equality.
//           pointer =
//             equalitiesLength > 0 ? equalities[equalitiesLength - 1] : -1;
//           post_ins = post_del = false;
//         }
//         changes = true;
//       }
//     }
//     pointer++;
//   }
//   if (changes) {
//     this.diff_cleanupMerge(diffs);
//   }
// };
/**
 * Reorder and merge like edit sections.  Merge equalities.
 * Any edit section can move as long as it doesn't cross an equality.
 * @param {!Array.<!diff_match_patch.Diff>} diffs Array of diff tuples.
 */ $599b122ba8104afa$export$b7b760e1e7f1805e.prototype.diff_cleanupMerge = function(diffs) {
    // Add a dummy entry at the end.
    diffs.push(new $599b122ba8104afa$export$b7b760e1e7f1805e.Diff($599b122ba8104afa$var$DIFF_EQUAL, ''));
    var pointer = 0;
    var count_delete = 0;
    var count_insert = 0;
    var text_delete = '';
    var text_insert = '';
    var commonlength;
    while(pointer < diffs.length)switch(diffs[pointer][0]){
        case $599b122ba8104afa$var$DIFF_INSERT:
            count_insert++;
            text_insert += diffs[pointer][1];
            pointer++;
            break;
        case $599b122ba8104afa$var$DIFF_DELETE:
            count_delete++;
            text_delete += diffs[pointer][1];
            pointer++;
            break;
        case $599b122ba8104afa$var$DIFF_EQUAL:
            // Upon reaching an equality, check for prior redundancies.
            if (count_delete + count_insert > 1) {
                if (count_delete !== 0 && count_insert !== 0) {
                    // Factor out any common prefixies.
                    commonlength = this.diff_commonPrefix(text_insert, text_delete);
                    if (commonlength !== 0) {
                        if (pointer - count_delete - count_insert > 0 && diffs[pointer - count_delete - count_insert - 1][0] == $599b122ba8104afa$var$DIFF_EQUAL) diffs[pointer - count_delete - count_insert - 1][1] += text_insert.substring(0, commonlength);
                        else {
                            diffs.splice(0, 0, new $599b122ba8104afa$export$b7b760e1e7f1805e.Diff($599b122ba8104afa$var$DIFF_EQUAL, text_insert.substring(0, commonlength)));
                            pointer++;
                        }
                        text_insert = text_insert.substring(commonlength);
                        text_delete = text_delete.substring(commonlength);
                    }
                    // Factor out any common suffixies.
                    commonlength = this.diff_commonSuffix(text_insert, text_delete);
                    if (commonlength !== 0) {
                        diffs[pointer][1] = text_insert.substring(text_insert.length - commonlength) + diffs[pointer][1];
                        text_insert = text_insert.substring(0, text_insert.length - commonlength);
                        text_delete = text_delete.substring(0, text_delete.length - commonlength);
                    }
                }
                // Delete the offending records and add the merged ones.
                pointer -= count_delete + count_insert;
                diffs.splice(pointer, count_delete + count_insert);
                if (text_delete.length) {
                    diffs.splice(pointer, 0, new $599b122ba8104afa$export$b7b760e1e7f1805e.Diff($599b122ba8104afa$var$DIFF_DELETE, text_delete));
                    pointer++;
                }
                if (text_insert.length) {
                    diffs.splice(pointer, 0, new $599b122ba8104afa$export$b7b760e1e7f1805e.Diff($599b122ba8104afa$var$DIFF_INSERT, text_insert));
                    pointer++;
                }
                pointer++;
            } else if (pointer !== 0 && diffs[pointer - 1][0] == $599b122ba8104afa$var$DIFF_EQUAL) {
                // Merge this equality with the previous one.
                diffs[pointer - 1][1] += diffs[pointer][1];
                diffs.splice(pointer, 1);
            } else pointer++;
            count_insert = 0;
            count_delete = 0;
            text_delete = '';
            text_insert = '';
            break;
    }
    if (diffs[diffs.length - 1][1] === '') diffs.pop(); // Remove the dummy entry at the end.
    // Second pass: look for single edits surrounded on both sides by equalities
    // which can be shifted sideways to eliminate an equality.
    // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
    var changes = false;
    pointer = 1;
    // Intentionally ignore the first and last element (don't need checking).
    while(pointer < diffs.length - 1){
        if (diffs[pointer - 1][0] == $599b122ba8104afa$var$DIFF_EQUAL && diffs[pointer + 1][0] == $599b122ba8104afa$var$DIFF_EQUAL) {
            // This is a single edit surrounded by equalities.
            if (diffs[pointer][1].substring(diffs[pointer][1].length - diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
                // Shift the edit over the previous equality.
                diffs[pointer][1] = diffs[pointer - 1][1] + diffs[pointer][1].substring(0, diffs[pointer][1].length - diffs[pointer - 1][1].length);
                diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
                diffs.splice(pointer - 1, 1);
                changes = true;
            } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) == diffs[pointer + 1][1]) {
                // Shift the edit over the next equality.
                diffs[pointer - 1][1] += diffs[pointer + 1][1];
                diffs[pointer][1] = diffs[pointer][1].substring(diffs[pointer + 1][1].length) + diffs[pointer + 1][1];
                diffs.splice(pointer + 1, 1);
                changes = true;
            }
        }
        pointer++;
    }
    // If shifts were made, the diff needs reordering and another shift sweep.
    if (changes) this.diff_cleanupMerge(diffs);
};
const $599b122ba8104afa$export$c1e60f059545054a = new $599b122ba8104afa$export$b7b760e1e7f1805e();

});





parcelRegister("1Mxcu", function(module, exports) {

$parcel$export(module.exports, "createPatchAnnotationFloatingToolbarPlugin", () => $14c40710dd14b947$export$25486814fb95664c);

var $R7bnX = parcelRequire("R7bnX");

var $5XrVu = parcelRequire("5XrVu");

var $89jds = parcelRequire("89jds");
function $14c40710dd14b947$export$25486814fb95664c({ getIntl: getIntl, rangeConfig: rangeConfig, aiGlobalOptIn: aiGlobalOptIn }) {
    return new (0, $R7bnX.SafePlugin)({
        key: (0, $5XrVu.patchAnnotationFloatingToolbarPluginKey),
        appendTransaction: (_tx, _oldState, newState)=>{
            (0, $89jds.patchFloatingToolbar)({
                editorState: newState,
                rangeConfig: rangeConfig,
                getIntl: getIntl,
                aiGlobalOptIn: aiGlobalOptIn
            });
            return null;
        }
    });
}

});
parcelRegister("5XrVu", function(module, exports) {

$parcel$export(module.exports, "patchAnnotationFloatingToolbarPluginKey", () => $456820049ab2d740$export$e9581ce101d1c6da);

var $kpTIW = parcelRequire("kpTIW");
const $456820049ab2d740$export$e9581ce101d1c6da = new (0, $kpTIW.PluginKey)('aiPatchAnnotationFloatingToolbar');

});

parcelRegister("89jds", function(module, exports) {

$parcel$export(module.exports, "patchFloatingToolbar", () => $5eee11e5e21da6b6$export$4a2c5b8bd64ea235);

var $74tSh = parcelRequire("74tSh");
// Copied from packages/editor/editor-core/src/plugins/floating-toolbar/index.tsx
// Copied from packages/editor/editor-core/src/plugins/floating-toolbar/index.tsx
const $5eee11e5e21da6b6$var$floatingToolbarPluginKey = 'floatingToolbarPluginKey$';
const $5eee11e5e21da6b6$export$4a2c5b8bd64ea235 = ({ editorState: editorState, rangeConfig: rangeConfig, getIntl: getIntl, aiGlobalOptIn: aiGlobalOptIn })=>{
    const toolbarPlugin = editorState.plugins.find(// @ts-expect-error Property 'key' does not exist on type 'Plugin<any, any>'.ts(2339)
    (plugin)=>plugin.key === $5eee11e5e21da6b6$var$floatingToolbarPluginKey);
    /* istanbul ignore next */ if (!toolbarPlugin) return;
    const toolbarState = toolbarPlugin.getState(editorState);
    /* istanbul ignore next */ if (!toolbarState) return;
    const originalGetConfigWithNodeInfo = toolbarState.getConfigWithNodeInfo;
    if (originalGetConfigWithNodeInfo.aiPatched) return;
    toolbarState.getConfigWithNodeInfo = (state)=>{
        const toolbarConfig = originalGetConfigWithNodeInfo(state);
        if (!toolbarConfig || !toolbarConfig.config) return toolbarConfig;
        const { items: items } = toolbarConfig.config;
        if (Array.isArray(items) && items.length === 1) {
            const createCommentButton = items[0];
            // Return early if it's not the annotation create button
            // This means it's another floating toolbar that we don't want to target
            if (createCommentButton.testId !== 'ak-editor-annotation-toolbar-create-button') return toolbarConfig;
            const aiDropdowns = (0, $74tSh.getAIExperienceDropdowns)({
                intl: getIntl(),
                rangeConfig: rangeConfig,
                aiGlobalOptIn: aiGlobalOptIn
            });
            const aiIconButton = (0, $74tSh.getAIExperienceButton)({
                intl: getIntl(),
                rangeBaseGenerate: rangeConfig.baseGenerate,
                hideTitle: !!aiDropdowns.length,
                aiGlobalOptIn: aiGlobalOptIn
            });
            const separator = {
                type: 'separator'
            };
            items.push(separator);
            items.push(aiIconButton, ...aiDropdowns);
        }
        return toolbarConfig;
    };
    // Track that we've patched it
    toolbarState.getConfigWithNodeInfo.aiPatched = true;
};

});
parcelRegister("74tSh", function(module, exports) {

$parcel$export(module.exports, "getAIExperienceButton", () => $5260148d28c52315$export$a3e7258dd93ab690);
$parcel$export(module.exports, "getAIExperienceDropdowns", () => $5260148d28c52315$export$bd2fe0c8f25cb579);

var $eXCAT = parcelRequire("eXCAT");

var $2KDKi = parcelRequire("2KDKi");

var $imtoG = parcelRequire("imtoG");

var $6eWD6 = parcelRequire("6eWD6");
const $5260148d28c52315$export$ef1d0b9899d7de5 = `ak-editor-ai-selection-toolbar-ai-button`;
const $5260148d28c52315$export$9629d9d0267faff3 = `ak-editor-ai-selection-toolbar-dropdown-`;
const $5260148d28c52315$export$a3e7258dd93ab690 = ({ intl: intl, rangeBaseGenerate: rangeBaseGenerate, hideTitle: hideTitle, aiGlobalOptIn: aiGlobalOptIn })=>{
    let didMouseEnter = false;
    return {
        type: 'button',
        showTitle: true,
        testId: $5260148d28c52315$export$ef1d0b9899d7de5,
        icon: (0, $eXCAT.Logo),
        ...!hideTitle && {
            title: intl.formatMessage((0, $imtoG.messages).aiToolbarTitle)
        },
        tooltipContent: intl.formatMessage((0, $6eWD6.default).aiUniversalShortCallToAction),
        disabled: false,
        onMouseEnter: ()=>{
            didMouseEnter = true;
            return false;
        },
        onClick: (state, dispatch, view)=>{
            const openAIModalCommand = (0, $2KDKi.createOpenAIModalCommand)({
                state: state,
                configItem: rangeBaseGenerate,
                lastTriggeredFrom: 'floatingToolbar',
                // ED-18194 Added analytics for floating toolbar to determine
                // the % of users who click the button vs shift tab to it
                triggerMethod: !didMouseEnter ? 'keyboard' : 'click',
                aiGlobalOptIn: aiGlobalOptIn
            });
            openAIModalCommand(state, dispatch);
            return false;
        }
    };
};
const $5260148d28c52315$var$mapSelectionToolbarDropdowns = ({ selectionToolbarDropdowns: selectionToolbarDropdowns, intl: intl, aiGlobalOptIn: aiGlobalOptIn })=>{
    if (!selectionToolbarDropdowns) return [];
    return selectionToolbarDropdowns.map((dropdownConfig)=>{
        let title = intl.formatMessage(dropdownConfig.label);
        if (dropdownConfig !== null && dropdownConfig !== void 0 && dropdownConfig.beta) title = `${title} (${intl.formatMessage((0, $6eWD6.default).betaLabel)})`;
        return {
            type: 'dropdown',
            testId: $5260148d28c52315$export$9629d9d0267faff3 + dropdownConfig.id,
            title: title,
            tooltip: title,
            disabled: false,
            options: dropdownConfig.options.map((option, index)=>({
                    title: intl.formatMessage(option.label),
                    testId: `ak-editor-ai-selection-toolbar-${dropdownConfig.id}-button-${index}`,
                    onClick: (state, dispatch, view)=>{
                        const openAIModalCommand = (0, $2KDKi.createOpenAIModalCommand)({
                            state: state,
                            configItem: option.configItem,
                            lastTriggeredFrom: 'floatingToolbarDropdown',
                            aiGlobalOptIn: // ED-18194 Added analytics for floating toolbar to determine
                            // the % of users who click the button vs shift tab to it
                            // triggerMethod: !didMouseEnter ? 'keyboard' : 'click',
                            aiGlobalOptIn
                        });
                        openAIModalCommand(state, dispatch);
                        return false;
                    }
                }))
        };
    });
};
const $5260148d28c52315$export$bd2fe0c8f25cb579 = ({ intl: intl, rangeConfig: rangeConfig, aiGlobalOptIn: aiGlobalOptIn })=>{
    var _rangeConfig$getSelec;
    const selectionToolbarDropdowns = (_rangeConfig$getSelec = rangeConfig.getSelectionToolbarDropdowns) === null || _rangeConfig$getSelec === void 0 ? void 0 : _rangeConfig$getSelec.call(rangeConfig);
    const aiDropdowns = $5260148d28c52315$var$mapSelectionToolbarDropdowns({
        selectionToolbarDropdowns: selectionToolbarDropdowns,
        intl: intl,
        aiGlobalOptIn: aiGlobalOptIn
    });
    const separator = {
        type: 'separator'
    };
    const separatedAIDropdowns = aiDropdowns.reduce((acc, val)=>acc.concat(separator, val), []);
    return separatedAIDropdowns;
};
const $5260148d28c52315$export$1b72c4c519f3931f = ({ intl: intl, rangeConfig: rangeConfig, aiGlobalOptIn: aiGlobalOptIn })=>{
    var _rangeConfig$getSelec2, _selectionToolbarProm;
    let didMouseEnter = false;
    const selectionToolbarPromptButton = (_rangeConfig$getSelec2 = rangeConfig.getSelectionToolbarPromptButton) === null || _rangeConfig$getSelec2 === void 0 ? void 0 : _rangeConfig$getSelec2.call(rangeConfig);
    if (!selectionToolbarPromptButton) return;
    const icon = (_selectionToolbarProm = selectionToolbarPromptButton.configItem) !== null && _selectionToolbarProm !== void 0 && _selectionToolbarProm.icon ? ()=>{
        var _selectionToolbarProm2;
        return(// extra check for icon to satisfy TS
        ((_selectionToolbarProm2 = selectionToolbarPromptButton.configItem) === null || _selectionToolbarProm2 === void 0 ? void 0 : _selectionToolbarProm2.icon) && selectionToolbarPromptButton.configItem.icon({
            formatMessage: intl.formatMessage,
            shownAt: 'suggestions'
        }));
    } : undefined;
    return {
        id: selectionToolbarPromptButton.id,
        type: 'button',
        title: selectionToolbarPromptButton.configItem.title({
            formatMessage: intl.formatMessage
        }),
        showTitle: true,
        testId: `ak-editor-ai-selection-toolbar-${selectionToolbarPromptButton.id}-button`,
        ...(selectionToolbarPromptButton === null || selectionToolbarPromptButton === void 0 ? void 0 : selectionToolbarPromptButton.tooltip) && {
            tooltipContent: intl.formatMessage(selectionToolbarPromptButton.tooltip)
        },
        icon: icon,
        onMouseEnter: ()=>{
            didMouseEnter = true;
            return false;
        },
        onClick: (state, dispatch, view)=>{
            const openAIModalCommand = (0, $2KDKi.createOpenAIModalCommand)({
                state: state,
                configItem: selectionToolbarPromptButton.configItem,
                lastTriggeredFrom: 'floatingToolbarPromptButton',
                // ED-18194 Added analytics for floating toolbar to determine
                // the % of users who click the button vs shift tab to it
                triggerMethod: !didMouseEnter ? 'keyboard' : 'click',
                aiGlobalOptIn: aiGlobalOptIn
            });
            openAIModalCommand(state, dispatch);
            return false;
        }
    };
};

});
parcelRegister("imtoG", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d5e115b9b6e8f465$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $d5e115b9b6e8f465$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    aiToolbarTitle: {
        id: 'fabric.editor.ai.toolbar.titleText',
        defaultMessage: 'Atlassian Intelligence',
        description: 'Title for Atlassian Intelligence button in editor selection floating toolbar'
    },
    improveWritingToolbarIconTitle: {
        id: 'fabric.editor.ai.toolbar.improveWriting.title',
        defaultMessage: 'Improve writing',
        description: 'Title for an option to use Atlassian Intellgience to improve the writing of content currently selected by the user'
    },
    improveWritingToolbarIconTooltip: {
        id: 'fabric.editor.ai.toolbar.improveWriting.tooltip',
        defaultMessage: 'Tell Atlassian Intelligence to improve the writing of your selection',
        description: 'Tooltip text for an option to use Atlassian Intellgience to improve the writing of content currently selected by the user'
    }
});

});




parcelRegister("cSyJ8", function(module, exports) {

$parcel$export(module.exports, "createAIButtonPlugin", () => $96057740dc957309$export$e65c99dea6a50353);

var $kpTIW = parcelRequire("kpTIW");

var $3S4st = parcelRequire("3S4st");

var $R7bnX = parcelRequire("R7bnX");
const $96057740dc957309$export$e65c99dea6a50353 = (options)=>{
    const { dispatch: dispatch } = options;
    return new (0, $R7bnX.SafePlugin)({
        key: (0, $3S4st.aiButtonPluginKey),
        state: {
            init: (_, state)=>({
                    isSelectionValidForAIExperience: true
                }),
            apply: (tr, _pluginState, _oldEditorState, newEditorState)=>{
                if (tr.selectionSet) {
                    const selection = tr.selection;
                    const { $from: $from } = selection;
                    const parent = $from.parent;
                    const codeBlockType = newEditorState.schema.nodes.codeBlock.name;
                    const isNodeSelection = selection instanceof (0, $kpTIW.NodeSelection);
                    const isSelectionInCodeBlock = parent.type.name === codeBlockType;
                    // We don't want to import CellSelection from @atlaskit/editor-tables
                    //  in order to avoid dependency.
                    // $anchorCell only exists in CellSelection.
                    // So if it exists, then we can assume that, it is cell selection.
                    // Not even import CellSelection as type in order to avoid
                    //  dependency management when we are close to EAP.
                    // TODO AIFOLLOWUP
                    const isCellSelection = !!selection.$anchorCell;
                    // AI button is always disabled for Node selection.
                    // AI button is always disabled for Cell selection.
                    // AI button is always disabled for selection in code block.
                    // For all other selection and empty selections AI button is enabled.
                    let isSelectionValidForAIExperience = true;
                    if (isSelectionInCodeBlock || isNodeSelection || isCellSelection) isSelectionValidForAIExperience = false;
                    const newPluginState = {
                        isSelectionValidForAIExperience: isSelectionValidForAIExperience
                    };
                    // We need to dispatch state change
                    // As we use WithPluginState to enable/disable AI button.
                    dispatch((0, $3S4st.aiButtonPluginKey), newPluginState);
                    return newPluginState;
                }
                return _pluginState;
            }
        }
    });
};

});
parcelRegister("3S4st", function(module, exports) {

$parcel$export(module.exports, "aiButtonPluginKey", () => $2d19df8c05a92ffa$export$521879fd431ff390);

var $kpTIW = parcelRequire("kpTIW");
const $2d19df8c05a92ffa$export$521879fd431ff390 = new (0, $kpTIW.PluginKey)('aiExperienceAIButton');

});


parcelRegister("djrA4", function(module, exports) {

$parcel$export(module.exports, "ExperienceApplication", () => $9b1271b4014df205$export$8b0e36b4d2610ae7);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $74BVL = parcelRequire("74BVL");

var $XHGTv = parcelRequire("XHGTv");

var $l20YV = parcelRequire("l20YV");
var $lR0Yf = parcelRequire("lR0Yf");

var $lJutJ = parcelRequire("lJutJ");

var $jRfpS = parcelRequire("jRfpS");

var $99bKD = parcelRequire("99bKD");

var $1cdJa = parcelRequire("1cdJa");

var $iypWf = parcelRequire("iypWf");

var $f0jcg = parcelRequire("f0jcg");

var $gm3e9 = parcelRequire("gm3e9");

var $g4i45 = parcelRequire("g4i45");

var $c4X6r = parcelRequire("c4X6r");

var $huA1W = parcelRequire("huA1W");

var $1KeVc = parcelRequire("1KeVc");

var $8EeGs = parcelRequire("8EeGs");

var $5laZa = parcelRequire("5laZa");

var $3QQwc = parcelRequire("3QQwc");
function $9b1271b4014df205$export$501630857d1b4132(props) {
    var _context$configItem, _context$configItem$g;
    /**
   * Note -- because we are on an old version of xstate -- when adding new states
   * they will not automatically be typed.
   *
   * You need to add these in the `AIExperienceMachineState` type in the
   * `get-experience-service.ts` file
   **/ const state = props.state;
    /**
   * Note -- because we are on an old version of xstate -- when adding new events
   * they will not automatically be typed.
   *
   * You need to add these in the `AIExperienceMachineEvent` type in the
   * `get-experience-service.ts` file
   **/ const send = props.send;
    const context = props.context;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        // Note -- the intention is to have the state machine created at a higher
        // level, and have the positions updated without being passed into this react
        // component.
        send({
            type: 'update positions',
            positions: props.positions
        });
    }, [
        send,
        props.positions
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        if (state === 'started state') send({
            type: 'kick off'
        });
    }, [
        state,
        send
    ]);
    /**
   * Used to pass the backendModel to analytics and
   * feedback submission metadata
   */ const backendModel = context === null || context === void 0 ? void 0 : (_context$configItem = context.configItem) === null || _context$configItem === void 0 ? void 0 : (_context$configItem$g = _context$configItem.getBackendModel) === null || _context$configItem$g === void 0 ? void 0 : _context$configItem$g.call(_context$configItem, !!(context !== null && context !== void 0 && context.latestPromptResponse));
    const analyticsFlow = (0, $jRfpS.useAnalyticsFlow)();
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        analyticsFlow.updateCommonAttributes({
            backendModel: backendModel
        });
    }, [
        analyticsFlow,
        backendModel
    ]);
    // Note -- the intention is to move the creation of the state machine higher
    // and for the ExperienceApplication (react component that appears in the modal)
    // to only be started once the machine is in the modal active state.
    if (state === 'started state') return null;
    const isModalActiveState = typeof state !== 'string' && state['modal active state'];
    if (!isModalActiveState) // TODO AIFOLLOWUP
    // ERROR handler
    throw new Error('unhandled state');
    const experienceState = state['modal active state']['experience'];
    if (typeof state['modal active state'] === 'object' && state['modal active state']['discard'] === 'active') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1KeVc.DiscardScreenWithLogic), {
        state: experienceState,
        endExperience: props.endExperience,
        send: send,
        editCount: context.editCount,
        retryPromptCount: context.retryPromptCount,
        history: context.responseHistory
    });
    if (typeof experienceState === 'string' && experienceState === 'command palette state') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8EeGs.UserInputCommandPaletteWithLogic), {
        editorPluginAIProvider: props.editorPluginAIProvider,
        send: send,
        endExperience: props.endExperience,
        context: context
    });
    if (typeof experienceState === 'object' && 'loading state' in experienceState) {
        const loadingState = experienceState['loading state'];
        if (loadingState === 'loading') {
            const getLoadingMessage = (status)=>{
                // TODO AIFOLLOWUP
                // Add analytics for when we get an unknown message descriptor
                if (!status || !(0, $lJutJ.isConvoAIKnownMessageTemplate)(status)) return status;
                const messageTemplate = (0, $5laZa.mapLoadingStatusToMessageTemplate)(status);
                if (messageTemplate) return formatMessage(messageTemplate);
                return status;
            };
            const loadingMessage = getLoadingMessage(context === null || context === void 0 ? void 0 : context.loadingStatus);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f0jcg.LoadingScreenWithLogic), {
                title: loadingMessage ? loadingMessage : formatMessage((0, $iypWf.messages).loadingTitle),
                markdown: context.markdown,
                editorView: props.editorView,
                schema: props.editorView.state.schema,
                send: send,
                editorPluginAIProvider: props.editorPluginAIProvider,
                latestPrompt: context.latestPrompt,
                promptTrigger: context.promptTrigger,
                latestPromptRetried: context.latestPromptRetried,
                idMap: context.idMap,
                providerFactory: props.providerFactory,
                contextStatistics: context.contextStatistics
            });
        }
        if (loadingState === 'rate limit active' || loadingState === 'rate limit inactive') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gm3e9.RateLimitScreenWithLogic), {
            loadingState: loadingState,
            send: send,
            endExperience: props.endExperience,
            errorInfo: context.apiErrorInfo
        });
        if (loadingState === 'api failed state') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g4i45.ApiFailedScreenWithLogic), {
            send: send,
            endExperience: props.endExperience,
            errorInfo: context.apiErrorInfo
        });
    }
    if (typeof experienceState !== 'string' && 'review state' in experienceState) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $huA1W.PreviewScreenWithLogic), {
        userInput: context.userInput || '',
        userADFInput: context.userADFInput || '',
        isInputActive: experienceState['review state'] === 'refinement',
        aupViolation: context.aupViolation,
        markdown: context.markdown,
        schema: props.editorView.state.schema,
        editorPluginAIProvider: props.editorPluginAIProvider,
        editorView: props.editorView,
        positions: props.positions,
        configItem: context.configItem,
        endExperience: props.endExperience,
        send: send,
        latestPrompt: context.latestPrompt,
        appearance: props.appearance,
        product: props.editorPluginAIProvider.product,
        lastTriggeredFrom: props.lastTriggeredFrom,
        editCount: context.editCount,
        retryPromptCount: context.retryPromptCount,
        idMap: context.idMap,
        providerFactory: props.providerFactory,
        history: context.responseHistory,
        contextStatistics: context.contextStatistics,
        backendModel: backendModel,
        errorInfo: context.apiErrorInfo,
        promptTrigger: context.promptTrigger
    });
    if (experienceState === 'failed') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c4X6r.FailedScreenWithLogic), {
        failureReason: context.failureReason,
        endExperience: props.endExperience,
        errorInfo: context.apiErrorInfo
    });
    throw new Error('unhandled state');
}
function $9b1271b4014df205$var$ExperienceApplicationStateWrapper(props) {
    const intl = (0, $5JgJ2.default)();
    const modalRef = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(null);
    const { context: context, state: state, send: send } = (0, $1cdJa.useAIExperienceService)({
        context: {
            aiProvider: props.editorPluginAIProvider,
            intl: intl,
            editorView: props.editorView,
            positions: props.positions,
            baseGenerate: props.configItem.selectionType === 'empty' ? props.editorPluginAIProvider.emptyConfig.baseGenerate : props.editorPluginAIProvider.rangeConfig.baseGenerate,
            configItem: props.configItem,
            markdown: '',
            aupViolation: false,
            latestPromptResponse: null,
            editCount: 0,
            retryPromptCount: 0,
            latestPromptRetried: false,
            userInput: '',
            apiErrorInfo: {},
            responseHistory: {
                positionFromEnd: 0,
                entries: []
            },
            agents: []
        },
        endExperience: props.endExperience
    });
    // Request information about the latest Rovo agents and update the state accordingly
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        if (!(0, $XHGTv.getBooleanFF)('platform.editor.ai-rovo-agents')) return;
        else if (!props.editorPluginAIProvider.getChannelVariables) // Flag can be on, but off for this specific editor
        // eg. Confluence only wants it on for full page editors, not comment editors
        return;
        // TODO: EDF-767: Fetch agent information from Rovo
        // Not entirely sure what data we'll get, but we can mould it as needed
        const agents = [
            (0, $l20YV.CommsCrafterAgent),
            (0, $l20YV.JobWriterAgent),
            (0, $l20YV.A11yMateAgent)
        ].map((0, $lR0Yf.getEditorAgent));
        send({
            type: 'update agents',
            context: {
                agents: agents
            }
        });
    }, [
        send,
        props.editorPluginAIProvider.getChannelVariables
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        if (!modalRef.current) return;
        /**
     * KeyDown (as opposed to KeyPress) event is used to handle the escape key so that
     * other escape key handlers will not override this behaviour.
     * Additionally this aligns with other escape listeners e.g. for closing typeahead popup.
     */ function handleEscapeKeyDown(event) {
            // Exit early if the key is not Escape
            if (event.key !== 'Escape') return;
            // Continue only if the AI modal is open / in active state
            if (typeof state === 'string' || !('modal active state' in state)) return;
            event.preventDefault();
            event.stopPropagation();
            // AI TODO REFACTOR as part of ED-17975. For now, this fixes the streaming
            // cancellation that happened when relying solely on the 'escape' event
            const modalActiveState = state === null || state === void 0 ? void 0 : state['modal active state'];
            const experience = modalActiveState === null || modalActiveState === void 0 ? void 0 : modalActiveState.experience;
            if (typeof experience === 'object' && 'loading state' in experience && experience['loading state'] === 'loading') {
                if ((modalActiveState === null || modalActiveState === void 0 ? void 0 : modalActiveState.discard) === 'active') send({
                    type: 'disable discard'
                });
                else send({
                    type: 'enable discard'
                });
            } else send({
                type: 'escape'
            });
        }
        /**
     * Handle KeyUp event to prevent unexpected escape behaviours when
     * there are other escape handlers outside of component (e.g. in product)
     */ function handleEscapeKeyUp(event) {
            // Exit early if the key is not Escape
            if (event.key !== 'Escape') return;
            // Continue only if the AI modal is open / in active state
            if (typeof state === 'string' || !('modal active state' in state)) return;
            event.preventDefault();
            event.stopPropagation();
        }
        return (0, $74BVL.bindAll)(modalRef.current, [
            {
                type: 'keydown',
                listener: handleEscapeKeyDown
            },
            {
                type: 'keyup',
                listener: handleEscapeKeyUp
            }
        ]);
    }, [
        modalRef,
        state,
        send
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        // We set these to ensure that when focus initially moves to
        // an element within the modal, that context about the modal
        // (e.g. "Atlassian Intelligence Dialog") is announced too
        role: "dialog",
        ref: modalRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9b1271b4014df205$export$501630857d1b4132, (0, $kU09D.default)({}, props, {
        state: state,
        context: context,
        send: send
    })));
}
function $9b1271b4014df205$export$8b0e36b4d2610ae7(props) {
    const analyticsFlow = (0, $jRfpS.useCreateAnalyticsFlow)({
        invokeAttributes: {
            invokedFrom: props.lastTriggeredFrom,
            triggerMethod: props.triggerMethod,
            experienceName: props.configItem.title({
                formatMessage: (0, $3QQwc.analyticsFormatMessage)
            })
        }
    });
    // finish analytics flow and fire remaining steps on unmount
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        return ()=>{
            // have to postpone until animation frame to make sure we end analytics flow after child components unmount
            // which is where we enqueue last events
            window.requestAnimationFrame(()=>{
                analyticsFlow.fireQueuedStep();
            });
        };
    }, [
        analyticsFlow
    ]);
    // This makes sure that the selection preview is hidden when the experience is unmounted
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        return ()=>{
            const tr = props.editorView.state.tr;
            tr.setMeta('hideSelectionPreview', true);
            props.editorView.dispatch(tr);
        };
    }, [
        props.editorView
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $99bKD.ModalRegionErrorBoundary), {
        onCloseFallback: ()=>{
            props.endExperience();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jRfpS.AnalyticsFlowContextProvider), {
        value: analyticsFlow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($9b1271b4014df205$var$ExperienceApplicationStateWrapper, props)));
}

});
parcelRegister("l20YV", function(module, exports) {

$parcel$export(module.exports, "CommsCrafterAgent", () => $f4fa8bcdb64795c6$export$2036d10b5adbaa07);
$parcel$export(module.exports, "JobWriterAgent", () => $f4fa8bcdb64795c6$export$c6b96d4ac6b48aa6);
$parcel$export(module.exports, "A11yMateAgent", () => $f4fa8bcdb64795c6$export$3b92ff78ca28a6e3);
/**
 * This is similar to Agent from @atlassian/conversation-assistant-service,
 * but creating our own type as it seems to be out of date.
 */ // The sample agent data was copied straight from poking around Rovo chat `AgentSelector` component props
const $f4fa8bcdb64795c6$export$198c236a78ec089b = {
    actor_type: 'AGENT',
    available_plugins: {
        'Content-Read-Plugin': {},
        'Ethical-Filtering-Plugin': {},
        'Jira-JQL-Plugin': {},
        'Jira-NL-JQL-Plugin': {},
        'Jira-Software-Plugin': {},
        'Page-Search-Plugin': {},
        'People-Plugin': {},
        'Search-QA-Plugin': {}
    },
    creator: null,
    creator_cloud_id: null,
    creator_type: 'SYSTEM',
    description: 'Get answers, generate new ideas, and accelerate everyday work. Write a prompt to get started.',
    external_files: null,
    follow_up_prompt_template: '\nYour task is to generate follow-up questions for the given conversation from the user\'s perspective.\nThe conversation history is provided in triple backticks.\n\nConversation History:\n```\n{message_history}\n```\n\nWhen you generate follow-up questions, follow these steps closely:\n1. Read the conversation history carefully to understand the user\'s intent. Keep it open and refer back to it as necessary.\n2. Pretend that you are the user and think about what you would ask next based on the conversation history and the original intent.\n3. Generate 3 follow-up questions from the perspective of the user that meet the following criteria.\n    - Relevant to the conversation.\n    - Unique and different from previously asked questions.\n    - Requests new information.\n    - Insightful and enhances the engagement of the conversation.\n    - Succinct and straight to the point.\n    - Specific and avoids being too general.\n    - Less than 9 words.\n    - When the subject of the question is the user asking questions, use the first-person pronoun "I".\n4. Read your follow-up questions again and remove the ones that do not meet ALL of the listed criteria.\n5. If there are no follow-up questions left, return an empty list.\n6. If there are follow-up questions left, paraphrase them to make them more concise.\n7. Return your paraphrased follow-up questions.\n',
    id: 'f3a534d9-1498-e0d4-8b50-e058a8fb8156',
    is_default: true,
    model: null,
    name: 'Chat',
    named_id: 'ai_mate_agent',
    plugin_routing_type: 'DEFAULT',
    preferred_plugin: null,
    system_prompt_template: '\nYou are Rovo Chat, an AI assistant built by Atlassian, you can do everything in the list of functions available. \nTreat the human in a friendly and personalised way, if what they ask is completely nonsensical, ask for clarification.  \n\nFollowing are the details of the human user:\n\nName: {{ user_name }}\n{{ location_info }}\n\nCurrent Time: {{ current_time }}\n\n{{ browsing_context }}\n\nFollow these rules:\n- Respond with names in the following format [name](/people/id) when appropriate.\n- Always use a function to find information, even if you know the answer.\n- Prioritise the Search-QA-Plugin when the function to use is not obvious.\n- Never answer the user directly without results from a function, unless they asked to reformat an existing answer.\n- Do not use your pretrained knowledge to answer.\n- Do not return function details in your answer.\n- If the answer is not available from the current function, always call another function.\n',
    visibility: 'PRIVATE',
    conversation_starters: [
        '[Action 1]',
        '[Action 2]',
        '[Action 3]'
    ]
};
const $f4fa8bcdb64795c6$export$2036d10b5adbaa07 = {
    actor_type: 'AGENT',
    available_plugins: {
        'Confluence-Suggestion-Plugin': {
            is_terminal: true,
            raise_no_answer_exception: true
        },
        'Page-Search-Plugin': {}
    },
    creator: null,
    creator_cloud_id: null,
    creator_type: 'SYSTEM',
    description: "Craft and refine all things blogs, external comms, and announcements. Align with your brand's voice.",
    external_files: null,
    follow_up_prompt_template: null,
    id: '3506f1fa-13ab-0c9c-d645-f26c759ef903',
    is_default: false,
    model: null,
    name: 'Comms crafter',
    named_id: 'confluence_reviewer_agent',
    plugin_routing_type: 'DEFAULT',
    preferred_plugin: null,
    system_prompt_template: 'You are the Comms crafter, a helpful assistant for reviewing Confluence documents. You are tasked with providing suggestions to improve a Confluence document.\n\nA user may highlight an important part of the document for you to focus on using a document selection.\n\nFollow these rules:\n- Always use a function to provide a suggested replacement for the current document selection when there is a suggested replacement.\n- If the user asks for similar documents, you rely on the document selection.\n- If there is a suggested replacement to a document selection, the final answer should be only a 1 sentence summary of the changes suggested, not the update itself.\n- Do not return function details in your answer.\n- Respond with names in the following format [name](/people/id) if at all possible.\n- Do not use your pretrained knowledge to answer.\n\nFollowing are the details of the users session:\n\nName: {{ user_name }}\nLocation: {{ location_info }}\nCurrent Time: {{ current_time }}\nDocument Selection: {{ additional_context.confluence.selection }}\nDocument: {{ additional_context.confluence.document }}\n',
    visibility: 'PRIVATE',
    conversation_starters: [
        '[Action 1]',
        '[Action 2]',
        '[Action 3]'
    ]
};
const $f4fa8bcdb64795c6$export$c6b96d4ac6b48aa6 = {
    actor_type: 'AGENT',
    available_plugins: {
        'Confluence-Suggestion-Plugin': {},
        'Content-Read-Plugin': {},
        'Page-Search-Plugin': {}
    },
    creator: null,
    creator_cloud_id: null,
    creator_type: 'SYSTEM',
    description: 'Crafts job descriptions that align with corporate guidelines and ensures they promote inclusivity and diversity.',
    external_files: null,
    follow_up_prompt_template: null,
    id: '5692d6dd-3045-499f-b08b-77ed2d253941',
    is_default: false,
    model: 'gpt-3-5-turbo-atlassian-0125',
    name: 'Job writer',
    named_id: 'job_writer_agent',
    plugin_routing_type: 'DEFAULT',
    preferred_plugin: null,
    system_prompt_template: 'You are the Job writer agent, a helpful assistant for hiring managers and recruitment teams to standardize on job descriptions which follow diversity and inclusion guidelines. \nYou are tasked with providing suggestions to improve a Confluence document for job descriptions.\n\nA user may highlight an important part of the document for you to focus on using a document selection.\n\nFollow these rules:\n- You must always provide a suggested replacement for insertion when asked to create, insert or draft job descriptions, summaries or any unique content.\n- You must always use a function to provide a suggested replacement for the current document selection when there is a suggested replacement.\n- If the user asks for similar documents, you rely on the document selection.\n- If there is a suggested replacement to a document selection, the final answer should be only a 1 sentence summary of the changes suggested, not the update itself.\n- Do not return function details in your answer.\n- Respond with names in the following format [name](/people/id) if at all possible.\n- Do not use your pretrained knowledge to answer.\n\nFollowing are the details of the users session:\n\nName: {{ user_name }}\nLocation: {{ location_info }}\nCurrent Time: {{ current_time }}\nDocument Selection: {{ additional_context.confluence.selection }}\nDocument: {{ additional_context.confluence.document }}\nBrowsing Context: {{ browsing_context }}',
    visibility: 'PRIVATE',
    conversation_starters: [
        '[Action 1]',
        '[Action 2]',
        '[Action 3]'
    ]
};
const $f4fa8bcdb64795c6$export$3b92ff78ca28a6e3 = {
    actor_type: 'AGENT',
    available_plugins: {
        'Search-QA-Plugin': {
            space_filter: [
                'A11YKB'
            ]
        }
    },
    creator: 'ari:cloud:identity::user/557057:db25fe7e-23f8-4e0f-aa1d-74a8c29bbc10',
    creator_cloud_id: 'a436116f-02ce-4520-8fbb-7301462a1674',
    creator_type: 'CUSTOMER',
    description: 'Accessibility help by Central Accessibility Team',
    external_files: [],
    follow_up_prompt_template: null,
    id: 'a7f547de-aa39-4d25-9234-65ac13c19acd',
    is_default: false,
    model: null,
    name: 'A11Y Mate',
    named_id: 'A11Y Mate',
    plugin_routing_type: null,
    preferred_plugin: null,
    system_prompt_template: '',
    visibility: 'PUBLIC',
    conversation_starters: [
        '[Action 1]',
        '[Action 2]',
        '[Action 3]'
    ]
};

});

parcelRegister("lR0Yf", function(module, exports) {

$parcel$export(module.exports, "getEditorAgent", () => $fe8f4cf59cfeb71c$export$c1402aba00d7d987);
// Testing data until we start to load it from client.

var $l20YV = parcelRequire("l20YV");
const $fe8f4cf59cfeb71c$export$c1402aba00d7d987 = (rawAgentData)=>{
    const { id: id, name: name, description: description, named_id: named_id, creator_type: creator_type, system_prompt_template: system_prompt_template, creator: creator, visibility: visibility, is_default: is_default, conversation_starters: conversation_starters } = rawAgentData;
    // TODO: we can use this place to populate additional fields like color, iconInitials etc.
    return {
        id: id,
        name: name,
        description: description,
        namedId: named_id,
        creatorType: creator_type,
        systemPromptTemplate: system_prompt_template,
        creator: creator !== null && creator !== void 0 ? creator : undefined,
        visibility: visibility,
        isDefault: is_default,
        conversationStarters: conversation_starters !== null && conversation_starters !== void 0 ? conversation_starters : []
    };
};

});

parcelRegister("lJutJ", function(module, exports) {

$parcel$export(module.exports, "isConvoAIKnownMessageTemplate", () => $fd257159e6fa01e8$export$1a5f02b8a03164a3);
/**
 * WARNING - consider removal or renames of these events breaking changes - as
 * they are now surfaced in the prebuilt
 */ const $fd257159e6fa01e8$export$6c956891ec0d52cf = {
    /**
   * @private
   * @deprecated
   * This could change within the next few weeks, as we are looking to rework
   * the logic to better capture feedback collection when those requirements
   * become clearer. The change is likely to be an (additive) breaking API
   * change, in the form of a more specific, feedback-focused type on the
   * provider with information about success/failure.
   *
   * When a thumbs up button is clicked
   */ THUMBS_UP: 'THUMBS_UP',
    /**
   * @private
   * @deprecated
   * This could change within the next few weeks, as we are looking to rework
   * the logic to better capture feedback collection when those requirements
   * become clearer. The change is likely to be an (additive) breaking API
   * change, in the form of a more specific, feedback-focused type on the
   * provider with information about success/failure.
   *
   * When a thumbs down button is clicked
   */ THUMBS_DOWN: 'THUMBS_DOWN',
    /**
   * Please check with Ethan/PM upon removing onExperienceEvent
   * calls, to confirm it is no longer used in any ongoing experiments.
   * Specifically `REVIEW_STATE_ENTERED` && `EXPERIENCE_COMPLETE`
   */ /**
   * When a user enters ANY review state (initial/interrogate)
   */ REVIEW_STATE_ENTERED: 'REVIEW_STATE_ENTERED',
    /**
   * When the experience is complete (e.g. clicked an action in the preview
   * screen leading to insertion of ai content)
   */ EXPERIENCE_COMPLETE: 'EXPERIENCE_COMPLETE'
};
function $fd257159e6fa01e8$export$1a5f02b8a03164a3(type) {
    return [
        'ANALYSING_QUERY',
        'CONTENT_SEARCH',
        'PAGE_HYDRATION',
        'NEXT_BEST_TASK',
        'WRITING'
    ].includes(type);
}

});

parcelRegister("jRfpS", function(module, exports) {

$parcel$export(module.exports, "useCreateAnalyticsFlow", () => $e74eecf2e3d58aa5$export$b26e0d212ef01829);
$parcel$export(module.exports, "AnalyticsFlowContextProvider", () => $e74eecf2e3d58aa5$export$b8f39b5859612546);
$parcel$export(module.exports, "useAnalyticsFlow", () => $e74eecf2e3d58aa5$export$8af1809310de64fa);
$parcel$export(module.exports, "useAnalyticsFlowEventsQueue", () => $e74eecf2e3d58aa5$export$f06fb39743945e19);

var $eUqFw = parcelRequire("eUqFw");

var $187Wq = parcelRequire("187Wq");

var $1YRgv = parcelRequire("1YRgv");
function $e74eecf2e3d58aa5$export$b26e0d212ef01829({ invokeAttributes: invokeAttributes }) {
    const fireAIAnalyticsEvent = (0, $187Wq._useFireAIAnalyticsEvent)();
    let analyticsFlowRef = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef();
    if (!analyticsFlowRef.current) analyticsFlowRef.current = (0, $1YRgv.createAnalyticsFlow)({
        fireAIAnalyticsEvent: fireAIAnalyticsEvent,
        invokeAttributes: invokeAttributes
    });
    return analyticsFlowRef.current;
}
const $e74eecf2e3d58aa5$var$AnalyticsFlowContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(undefined);
const $e74eecf2e3d58aa5$export$b8f39b5859612546 = $e74eecf2e3d58aa5$var$AnalyticsFlowContext.Provider;
const $e74eecf2e3d58aa5$export$8af1809310de64fa = ()=>{
    const analyticsFlowInstance = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext($e74eecf2e3d58aa5$var$AnalyticsFlowContext);
    if (!analyticsFlowInstance) throw new Error('No analyticsFlowInstance available in the context, make sure to have container wrapped with AnalyticsFlowContextProvider');
    return analyticsFlowInstance;
};
function $e74eecf2e3d58aa5$export$f06fb39743945e19({ stepName: stepName, attributes: attributes }) {
    const analyticsFlow = $e74eecf2e3d58aa5$export$8af1809310de64fa();
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        analyticsFlow.fireQueuedStep(stepName);
        return ()=>{
            analyticsFlow.enqueueStep({
                stepName: stepName,
                attributes: attributes
            });
        };
    // expecting to enqueue step only once on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return analyticsFlow;
}

});
parcelRegister("187Wq", function(module, exports) {

$parcel$export(module.exports, "_useFireAIAnalyticsEvent", () => $0d2cb2c3c1d3d18c$export$208739d1cee71469);

var $aFbB0 = parcelRequire("aFbB0");
const $0d2cb2c3c1d3d18c$export$208739d1cee71469 = (0, $aFbB0.useFireAIAnalyticsEvent);

});

parcelRegister("1YRgv", function(module, exports) {

$parcel$export(module.exports, "createAnalyticsFlow", () => $1714b66e05833116$export$7e715b9b9acf423a);

var $dFBS3 = parcelRequire("dFBS3");

var $6PJBT = parcelRequire("6PJBT");
function $1714b66e05833116$export$7e715b9b9acf423a({ fireAIAnalyticsEvent: fireAIAnalyticsEvent, invokeAttributes: invokeAttributes }) {
    const startTime = performance.now();
    const stepTracker = {};
    const aiSessionId = (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))();
    let prevStepEnd = performance.now();
    let prevStepName;
    let experienceName;
    let adhocAttributes = {};
    let commonAttributes = {};
    let finished = false;
    let contentCopiedSometime = false;
    let sawAupViolation = false;
    let interactionsCounter = 0;
    let lastAiInteractionID;
    let queuedStepArgs = {
        stepName: 'invoke',
        attributes: invokeAttributes
    };
    const analyticsFlow = {
        /**
     * Add a step to the queue to be fired on next screen.
     * @example
     * ```tsx
     * const analyticsFlow = useAnalyticsFlow();
     * analyticsFlow.enqueueStep({ stepName, attributes });
     * ```
     */ enqueueStep: (stepArgs)=>{
            // If the user has already finished the experience, we fire an operational error and return
            if (finished) {
                fireAIAnalyticsEvent($1714b66e05833116$var$createErrorPayload({
                    aiSessionId: aiSessionId,
                    errorSubType: 'userFlowAlreadyFinished',
                    errorProperties: {
                        stepArgs: stepArgs,
                        queuedStepArgs: queuedStepArgs
                    }
                }));
                return;
            }
            if (stepArgs.stepName === 'loading') {
                lastAiInteractionID = `${aiSessionId}-${++interactionsCounter}`;
                fireAIAnalyticsEvent({
                    payload: {
                        action: 'initiated',
                        actionSubject: 'aiInteraction',
                        actionSubjectId: 'editorPluginAI',
                        eventType: 'track',
                        attributes: {
                            aiInteractionID: lastAiInteractionID,
                            aiFeatureName: 'Editor AI',
                            proactiveAIGenerated: 0,
                            userGeneratedAI: 1,
                            aiInteractionType: experienceName
                        }
                    }
                });
            }
            // If there is already a queued step, we fire an operational error and return
            if (queuedStepArgs !== undefined) {
                fireAIAnalyticsEvent($1714b66e05833116$var$createErrorPayload({
                    aiSessionId: aiSessionId,
                    errorSubType: 'cannotEnqueueMoreThanOneEvent',
                    errorProperties: {
                        stepArgs: stepArgs,
                        queuedStepArgs: queuedStepArgs
                    }
                }));
                return;
            }
            queuedStepArgs = stepArgs;
        },
        fireQueuedStep: (target)=>{
            // If the user has already finished the experience, we fire an operational error and return
            if (finished) {
                fireAIAnalyticsEvent($1714b66e05833116$var$createErrorPayload({
                    aiSessionId: aiSessionId,
                    errorSubType: 'userFlowAlreadyFinished',
                    errorProperties: {
                        target: target,
                        queuedStepArgs: queuedStepArgs
                    }
                }));
                return;
            }
            // If there is no queued step, we fire an operational error and return
            if (!queuedStepArgs) {
                fireAIAnalyticsEvent($1714b66e05833116$var$createErrorPayload({
                    aiSessionId: aiSessionId,
                    errorSubType: 'noEventExistsToBeFired',
                    errorProperties: {
                        target: target
                    }
                }));
                return;
            }
            // Add target to attributes and fire the event
            queuedStepArgs.attributes = {
                ...queuedStepArgs.attributes,
                ...adhocAttributes,
                ...commonAttributes,
                invokedFrom: invokeAttributes.invokedFrom,
                triggerMethod: invokeAttributes.triggerMethod,
                target: target
            };
            fireUserFlowStep(queuedStepArgs);
            // Remove the queued event
            queuedStepArgs = undefined;
        },
        /**
     * This is useful when you want to add attributes to the current step
     * but you don't know them at the time of enqueuing the step.
     *
     * It's safe to fire this on dismount -- because the step is enqueued in the dismount
     * of a parent component (where AnalyticsFlowContextProvider is setup).
     *
     * @example
     * ```tsx
     * const analyticsFlow = useAnalyticsFlow();
     * React.useEffect(() => {
     *  return () => {
     *    // add attribute on dismount
     *    analyticsFlow.addAttributes({ loadingTime })
     *  }
     * })
     * ```
     */ addAttributes: (attributes)=>{
            // The user copying the content is being treated as a potential success indicator
            // This is a weak signal as we don't know if the user actually used the copied content
            // and might expect the user to copy the content in cases where the generation failed.
            // @ts-ignore
            if (attributes.contentCopied) contentCopiedSometime = true;
            // There is a type gap here -- where the attributes don't reflect possible attributes
            // from the various user flow steps
            // @ts-ignore
            sawAupViolation = attributes.isAupViolation || sawAupViolation;
            adhocAttributes = {
                ...adhocAttributes,
                ...attributes
            };
        },
        /**
     * Common attributes will be retained for the rest of the analytics flow
     * until it is updated again
     *
     * Example uses: keeping track of which backendModel has been selected
     */ updateCommonAttributes: (attributes)=>{
            commonAttributes = {
                ...commonAttributes,
                ...attributes
            };
        },
        getLastAiInteractionId: ()=>lastAiInteractionID
    };
    return analyticsFlow;
    function fireUserFlowStep({ stepName: stepName, attributes: attributes = {} }) {
        if (!stepTracker[stepName]) stepTracker[stepName] = 1;
        else stepTracker[stepName] = stepTracker[stepName] + 1;
        if (attributes.experienceName) experienceName = attributes.experienceName;
        let stepAttributes = {
            ...commonAttributes,
            // the duration is currently being overriden in the complete step
            duration: Math.round(performance.now() - prevStepEnd),
            ...attributes,
            aiSessionId: aiSessionId,
            experienceName: experienceName,
            source: prevStepName,
            invokedFrom: attributes.invokedFrom,
            triggerMethod: attributes.triggerMethod,
            stepOccurrence: String(stepTracker[stepName]),
            sawAupViolation: sawAupViolation
        };
        // add totalDuration only to the final step
        // and set the experience as finished
        if (!attributes.target) {
            stepAttributes.totalDuration = Math.round(performance.now() - startTime);
            stepAttributes.contentCopiedSometime = contentCopiedSometime;
            finished = true;
        }
        // adding interaction ID to the events coming after the loading step, + final complete step
        if (stepAttributes.source === 'loading' || stepName === 'complete') stepAttributes.aiInteractionID = lastAiInteractionID;
        let payload = {
            action: stepName,
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'userFlow',
            attributes: stepAttributes,
            eventType: 'ui'
        };
        //each step is a starting point for measuring duration for next step
        prevStepEnd = performance.now();
        //reset previous step name and custom attributes
        prevStepName = stepName;
        adhocAttributes = {};
        fireAIAnalyticsEvent({
            payload: payload
        });
        if (finished) fireAIAnalyticsEvent({
            payload: {
                ...payload,
                action: 'finished',
                attributes: {
                    ...payload.attributes,
                    // override source to be the previous last step in the flow
                    source: stepName
                }
            }
        });
    }
}
/**
 * Creates an operational error payload
 */ function $1714b66e05833116$var$createErrorPayload({ errorSubType: errorSubType, errorProperties: errorProperties }) {
    return {
        payload: {
            action: 'unhandledErrorCaught',
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'experienceApplication',
            attributes: {
                errorType: 'userFlowAnalyticsError',
                errorSubType: errorSubType,
                ...errorProperties
            },
            eventType: 'operational'
        },
        channel: (0, $6PJBT.FabricChannel).editor
    };
}

});


parcelRegister("99bKD", function(module, exports) {

$parcel$export(module.exports, "ModalRegionErrorBoundary", () => $6a8e11df81b9c4bb$export$61f6bd9fac8ed53);

var $5zQU9 = parcelRequire("5zQU9");

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $epQu3 = parcelRequire("epQu3");

var $aFbB0 = parcelRequire("aFbB0");

var $fIYRM = parcelRequire("fIYRM");

var $6cItu = parcelRequire("6cItu");

var $8pKer = parcelRequire("8pKer");
const $6a8e11df81b9c4bb$export$61f6bd9fac8ed53 = (props)=>{
    const fireAIAnalyticsEvent = (0, $aFbB0.useFireAIAnalyticsEvent)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6a8e11df81b9c4bb$var$ExperienceApplicationErrorBoundaryClass, (0, $kU09D.default)({}, props, {
        fireAIAnalyticsEvent: fireAIAnalyticsEvent,
        formatMessage: formatMessage
    }));
};
class $6a8e11df81b9c4bb$var$ExperienceApplicationErrorBoundaryClass extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "getFallbackMessage", (descriptor)=>{
            return this.props.formatMessage(descriptor);
        });
        (0, $5zQU9.default)(this, "state", {
            errorCaptured: false,
            fallbackMessage: this.getFallbackMessage((0, $6cItu.default).unhandledErrorMessage)
        });
    }
    shouldRecover() {
        return this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        if (error.name === (0, $epQu3.markdownConversionErrorName)) {
            const errorHasTypeProperty = 'type' in error;
            const errorSubType = errorHasTypeProperty ? error.type : undefined;
            this.props.fireAIAnalyticsEvent({
                payload: {
                    action: 'unhandledErrorCaught',
                    actionSubject: 'editorPluginAI',
                    actionSubjectId: 'experienceApplication',
                    attributes: {
                        componentStack: errorInfo.componentStack,
                        errorType: 'markdownToProseMirrorError',
                        errorSubType: errorSubType,
                        errorMessage: (0, $8pKer.ErrorUtils).extractErrorMessage(error)
                    },
                    eventType: 'operational'
                }
            });
            this.setState({
                errorCaptured: true,
                fallbackMessage: this.getFallbackMessage((0, $6cItu.default).markdownErrorMessage)
            });
        } else {
            this.props.fireAIAnalyticsEvent({
                payload: {
                    action: 'unhandledErrorCaught',
                    actionSubject: 'editorPluginAI',
                    actionSubjectId: 'experienceApplication',
                    attributes: {
                        componentStack: errorInfo.componentStack,
                        errorMessage: (0, $8pKer.ErrorUtils).extractErrorMessage(error)
                    },
                    eventType: 'operational'
                }
            });
            this.setState({
                errorCaptured: true,
                fallbackMessage: this.getFallbackMessage((0, $6cItu.default).unhandledErrorMessage)
            });
        }
    }
    render() {
        if (this.shouldRecover()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fIYRM.UnhandledErrorScreen), {
            text: this.state.fallbackMessage,
            onCancel: this.props.onCloseFallback
        });
        return this.props.children;
    }
}

});
parcelRegister("epQu3", function(module, exports) {

$parcel$export(module.exports, "markdownConversionErrorName", () => $a7ec1ca95179a0a0$export$8a78f5c7307b478b);
$parcel$export(module.exports, "MarkdownConversionError", () => $a7ec1ca95179a0a0$export$6c16da0c287c00c);
/**
 * This Error exists so that we can specifically
 * capture and handle this particular error in the
 * ErrorBoundary
 */ const $a7ec1ca95179a0a0$export$8a78f5c7307b478b = 'MarkdownConversionError';
class $a7ec1ca95179a0a0$export$6c16da0c287c00c extends Error {
    constructor({ message: message, type: type }){
        super(message);
        this.name = $a7ec1ca95179a0a0$export$8a78f5c7307b478b;
        this.type = type;
    }
}

});

parcelRegister("fIYRM", function(module, exports) {

$parcel$export(module.exports, "UnhandledErrorScreen", () => $b72a2ddfdcf30eaa$export$40729e8ab35829ea);
/* @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lkPEe = parcelRequire("lkPEe");

var $c3u17 = parcelRequire("c3u17");

var $bFJ7u = parcelRequire("bFJ7u");

var $2fOPm = parcelRequire("2fOPm");
const $b72a2ddfdcf30eaa$export$40729e8ab35829ea = ({ onCancel: onCancel, text: text })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { ref: ref, breakpoint: breakpoint } = (0, $bFJ7u.useContainerBreakpoints)();
    return (0, $byn9U.jsx)((0, $2fOPm.ErrorFloatingContainer), {
        ref: ref,
        breakpoint: breakpoint
    }, (0, $byn9U.jsx)((0, $lkPEe.default), null, formatMessage((0, $c3u17.default).ariaErrorTitle)), (0, $byn9U.jsx)((0, $2fOPm.ErrorMessage), {
        breakpoint: breakpoint
    }, text), (0, $byn9U.jsx)((0, $2fOPm.ErrorButtonContainer), null, (0, $byn9U.jsx)((0, $2fOPm.ErrorButton), {
        autoFocus: true,
        testId: 'cancel',
        onClick: onCancel,
        appearance: "primary"
    }, formatMessage((0, $c3u17.default).cancelLabel))));
};

});
parcelRegister("c3u17", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c6d0c9ca5accc3e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8c6d0c9ca5accc3e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    documentInsertError: {
        id: 'fabric.editor.ai.experience-application.documentInsertError',
        defaultMessage: `We're having trouble inserting the response. Close the dialog and try again.`,
        description: 'Message to users that displays when error happens during document insertion.'
    },
    tokenLimitExceeded: {
        id: 'fabric.editor.ai.experience-application.tokenLimitExceeded',
        defaultMessage: "We couldn't get a response. Your prompt or response was over the limit for this request. Close the dialog and try again.",
        description: 'Message to users that displays when their request has exceeded the maximum input or output limit.'
    },
    apiError: {
        id: 'fabric.editor.ai.experience.apiError',
        defaultMessage: `We couldn\u{2019}t get a response, please try again.`,
        description: `We couldn't get a response due to an api error (ie. the backend responded with an error, or got a timeout)`
    },
    inputTooShortError: {
        id: 'fabric.editor.ai.experience.inputTooShortError',
        defaultMessage: `The content is too short to summarize. Please add more and try again.`,
        description: `The input was too short to summarize`
    },
    cancelLabel: {
        id: 'fabric.editor.ai.screens.error.cancelLabel',
        defaultMessage: 'Cancel',
        description: 'Label for the "Cancel" button on the "Error" screen, which allows users to close the error message and return to the previous screen'
    },
    retryLabel: {
        id: 'fabric.editor.ai.screens.error.retryLabel',
        defaultMessage: 'Try again',
        description: 'Label for the "Try again" button on the "Error" screen, which allows users to retry the failed action or process'
    },
    warningIconLabel: {
        id: 'fabric.editor.ai.screens.error.warningIconLabel',
        defaultMessage: 'Warning',
        description: 'Aria label for the warning icon on error screens'
    },
    ariaErrorTitle: {
        id: 'fabric.editor.ai.screens.error.ariaErrorTitle',
        defaultMessage: 'Error',
        description: 'Accessible title for the error screen'
    }
});

});

parcelRegister("bFJ7u", function(module, exports) {

$parcel$export(module.exports, "Breakpoint", () => $87f685e153c7eb92$export$114247090b0aae30);
$parcel$export(module.exports, "useContainerBreakpoints", () => $87f685e153c7eb92$export$2aa1887afbd6d218);

var $eUqFw = parcelRequire("eUqFw");
let $87f685e153c7eb92$export$114247090b0aae30 = /*#__PURE__*/ function(Breakpoint) {
    Breakpoint[Breakpoint["Small"] = 320] = "Small";
    Breakpoint[Breakpoint["Large"] = Infinity] = "Large";
    return Breakpoint;
}({});
const $87f685e153c7eb92$export$2aa1887afbd6d218 = ()=>{
    const ref = (0, $eUqFw.useRef)(null);
    const [breakpoint, setBreakpoint] = (0, $eUqFw.useState)($87f685e153c7eb92$export$114247090b0aae30.Small);
    (0, $eUqFw.useEffect)(()=>{
        if (ref.current) {
            const currentRef = ref.current;
            const updateWidth = (entries)=>{
                for (const entry of entries){
                    const width = entry.contentRect.width;
                    if (width <= $87f685e153c7eb92$export$114247090b0aae30.Small) setBreakpoint($87f685e153c7eb92$export$114247090b0aae30.Small);
                    else setBreakpoint($87f685e153c7eb92$export$114247090b0aae30.Large);
                }
            };
            const resizeObserver = new ResizeObserver(updateWidth);
            resizeObserver.observe(currentRef);
            return ()=>{
                resizeObserver.unobserve(currentRef);
            };
        }
    }, []);
    return {
        ref: ref,
        breakpoint: breakpoint
    };
};

});

parcelRegister("2fOPm", function(module, exports) {

$parcel$export(module.exports, "ErrorMessage", () => $1a4468bfa5a5bd8a$export$915e9e7bd4f0f96d);
$parcel$export(module.exports, "ErrorButton", () => $1a4468bfa5a5bd8a$export$a359b30953f5499e);
$parcel$export(module.exports, "ErrorButtonContainer", () => $1a4468bfa5a5bd8a$export$e7ce0c27e387222f);
$parcel$export(module.exports, "ErrorFloatingContainer", () => $1a4468bfa5a5bd8a$export$f31c7963ee61af);
/* @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5YsMl = parcelRequire("5YsMl");

var $9kEID = parcelRequire("9kEID");

var $2GXlj = parcelRequire("2GXlj");

var $dBH6i = parcelRequire("dBH6i");

var $c3u17 = parcelRequire("c3u17");


var $jjK5n = parcelRequire("jjK5n");
function $1a4468bfa5a5bd8a$export$915e9e7bd4f0f96d({ children: children, breakpoint: breakpoint }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return (0, $byn9U.jsx)("div", {
        css: (0, $9kEID.getTextContainerStyles)(breakpoint)
    }, (0, $byn9U.jsx)("span", {
        css: (0, $9kEID.getIconStyles)(breakpoint)
    }, (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
        label: formatMessage((0, $c3u17.default).warningIconLabel),
        primaryColor: (0, $9kEID.iconColor)
    })), (0, $byn9U.jsx)("p", {
        css: (0, $9kEID.textStyles)
    }, children));
}
function $1a4468bfa5a5bd8a$export$a359b30953f5499e({ children: children, onClick: onClick, appearance: appearance, testId: testId, autoFocus: autoFocus, disabled: disabled = false }) {
    return (0, $byn9U.jsx)((0, $dBH6i.default), {
        css: (0, $jjK5n.buttonAutoFocusRingFix),
        autoFocus: autoFocus,
        testId: testId,
        spacing: "compact",
        onClick: onClick,
        type: "button",
        appearance: appearance,
        isDisabled: disabled
    }, children);
}
function $1a4468bfa5a5bd8a$export$e7ce0c27e387222f({ children: children }) {
    return (0, $byn9U.jsx)("div", {
        css: (0, $9kEID.buttonContainerStyles)
    }, children);
}
const $1a4468bfa5a5bd8a$export$f31c7963ee61af = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, breakpoint: breakpoint }, ref)=>{
    return (0, $byn9U.jsx)((0, $2GXlj.FloatingContainer), {
        ref: ref,
        "data-testid": "error-screen",
        className: `error-screen ${(0, $64ce3526fe10ea0e$export$9df59400d72ad68f)}`,
        css: (0, $9kEID.getContainerStyles)(breakpoint),
        paddingAdjustments: {
            top: 1,
            bottom: 1
        }
    }, children);
});

});
parcelRegister("9kEID", function(module, exports) {

$parcel$export(module.exports, "getTextContainerStyles", () => $6cb591432a969e9a$export$6d3ae856f3ad1a39);
$parcel$export(module.exports, "textStyles", () => $6cb591432a969e9a$export$6a54c24d15b0f6ba);
$parcel$export(module.exports, "iconColor", () => $6cb591432a969e9a$export$3797a580396e3639);
$parcel$export(module.exports, "getIconStyles", () => $6cb591432a969e9a$export$85b8da3d52ee4014);
$parcel$export(module.exports, "buttonContainerStyles", () => $6cb591432a969e9a$export$98120bf687c4a90f);
$parcel$export(module.exports, "getContainerStyles", () => $6cb591432a969e9a$export$8947b11ec08f5f9d);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $bFJ7u = parcelRequire("bFJ7u");

var $kIeme = parcelRequire("kIeme");
const $6cb591432a969e9a$var$textContainerLayoutStyles = (breakpoint)=>(0, $byn9U.css)({
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: breakpoint <= (0, $bFJ7u.Breakpoint).Small ? 'flex-start' : 'center',
        flex: 1,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        gap: '10px'
    });
const $6cb591432a969e9a$export$6d3ae856f3ad1a39 = (breakpoint)=>[
        $6cb591432a969e9a$var$textContainerLayoutStyles(breakpoint)
    ];
const $6cb591432a969e9a$var$textSpacingStyles = (0, $byn9U.css)({
    margin: 0
});
const $6cb591432a969e9a$export$6a54c24d15b0f6ba = [
    $6cb591432a969e9a$var$textSpacingStyles,
    (0, $kIeme.commonTextStyles)
];
const $6cb591432a969e9a$export$3797a580396e3639 = `var(--ds-icon-warning, ${(0, $PdmhA.Y500)})`;
const $6cb591432a969e9a$var$ICON_TEXT_ALIGNMENT_OFFSET = '-2px';
const $6cb591432a969e9a$export$85b8da3d52ee4014 = (breakpoint)=>(0, $byn9U.css)({
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        lineHeight: 1,
        position: 'relative',
        flexShrink: 0,
        // 2px top offset at small breakpoints for better icon-text alignment
        top: breakpoint <= (0, $bFJ7u.Breakpoint).Small ? $6cb591432a969e9a$var$ICON_TEXT_ALIGNMENT_OFFSET : '0'
    });
const $6cb591432a969e9a$export$98120bf687c4a90f = (0, $byn9U.css)({
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: "var(--ds-space-100, 8px)"
});
const $6cb591432a969e9a$export$8947b11ec08f5f9d = (breakpoint)=>(0, $byn9U.css)({
        display: 'flex',
        flexDirection: breakpoint <= (0, $bFJ7u.Breakpoint).Small ? 'column' : 'row',
        gap: breakpoint <= (0, $bFJ7u.Breakpoint).Small ? '16px' : '8px'
    });

});
parcelRegister("kIeme", function(module, exports) {

$parcel$export(module.exports, "commonTextStyles", () => $f1430dd5261d8f96$export$ca5111e3c5be4e7d);

var $byn9U = parcelRequire("byn9U");

var $4lTFP = parcelRequire("4lTFP");
const $f1430dd5261d8f96$export$ca5111e3c5be4e7d = (0, $byn9U.css)({
    font: `var(--ds-font-body, ${(0, $4lTFP.fontFallback).body.medium})`,
    wordBreak: 'break-word'
});

});


parcelRegister("2GXlj", function(module, exports) {

$parcel$export(module.exports, "FloatingContainer", () => $1f5d893c8d14aeb2$export$4ddaad941c29ad29);

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $7NBW6 = parcelRequire("7NBW6");

var $epPZ1 = parcelRequire("epPZ1");
const $1f5d893c8d14aeb2$export$4ddaad941c29ad29 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, paddingAdjustments: paddingAdjustments, rainbowBorder: rainbowBorder = true, rainbowBorderAnimation: rainbowBorderAnimation, disablePadding: disablePadding, css: css, ...rest }, ref)=>{
    const paddingStyles = disablePadding ? null : paddingAdjustments ? (0, $7NBW6.getPaddingAdjustments)(paddingAdjustments) : (0, $7NBW6.defaultPaddingStyles);
    const aiThemeColor = (0, $epPZ1.useAIThemeColor)();
    const cssStyles = [
        (0, $7NBW6.floatingContainerStyles),
        paddingStyles,
        css
    ];
    if (rainbowBorder) {
        cssStyles.push((0, $7NBW6.prismBorderStyles)(aiThemeColor));
        if (rainbowBorderAnimation) cssStyles.push((0, $7NBW6.prismBorderAnimationStyles));
    }
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        ref: ref,
        css: cssStyles
    }, rest), children);
});

});
parcelRegister("7NBW6", function(module, exports) {

$parcel$export(module.exports, "prismBorderAnimationStyles", () => $5ada89575e92f492$export$a01bc07561beef67);
$parcel$export(module.exports, "prismBorderStyles", () => $5ada89575e92f492$export$a5736548b03aac1a);
$parcel$export(module.exports, "floatingContainerStyles", () => $5ada89575e92f492$export$8833ec6a339f43a0);
$parcel$export(module.exports, "defaultPaddingStyles", () => $5ada89575e92f492$export$f8a8f4dcef342279);
$parcel$export(module.exports, "getPaddingAdjustments", () => $5ada89575e92f492$export$cfd50dc61b5efbbd);
$parcel$export(module.exports, "scrollTopMargin", () => $5ada89575e92f492$export$241bafe0360eb71d);
$parcel$export(module.exports, "scrollMarginStyles", () => $5ada89575e92f492$export$3de32da52b6918c2);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
const $5ada89575e92f492$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
const $5ada89575e92f492$var$shadowStyles = (0, $byn9U.css)({
    boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $PdmhA.N60A)}, 0 0 1px ${(0, $PdmhA.N60A)}`})`
});
const $5ada89575e92f492$var$rotationAnimation = (0, $byn9U.keyframes)({
    '0%': {
        '--gradient-angle': '0deg',
        ...$5ada89575e92f492$var$isFirefox ? {
            backgroundPosition: '100%'
        } : {}
    },
    '100%': {
        '--gradient-angle': '360deg',
        ...$5ada89575e92f492$var$isFirefox ? {
            backgroundPosition: '-100%'
        } : {}
    }
});
const $5ada89575e92f492$export$a01bc07561beef67 = (0, $byn9U.css)({
    '&::before, &::after': {
        animation: `${$5ada89575e92f492$var$rotationAnimation} linear 2s infinite`,
        ...$5ada89575e92f492$var$isFirefox ? {
            animationDirection: 'normal',
            animationDuration: '1s'
        } : {},
        '@media (prefers-reduced-motion)': {
            animation: 'none'
        }
    }
});
const $5ada89575e92f492$export$a5736548b03aac1a = (aiThemeColor)=>(0, $byn9U.css)`
	// This style is used to define gradient angle around the border,
	// used widely across every modals with a prism border
	@property --gradient-angle {
		syntax: '<angle>';
		initial-value: 270deg;
		inherits: false;
	}

	position: relative;
	border-radius: ${"var(--ds-border-radius-200, 6px)"};
	box-shadow: none;

	&::before,
	&::after {
		content: '';
		position: absolute;
		${$5ada89575e92f492$var$isFirefox ? `background: linear-gradient(90deg,
          ${aiThemeColor('prism.border.step.1')} 0%,
          ${aiThemeColor('prism.border.step.2')} 12%,
          ${aiThemeColor('prism.border.step.3')} 24%,
          ${aiThemeColor('prism.border.step.4')} 48%,
          ${aiThemeColor('prism.border.step.3')} 64%,
          ${aiThemeColor('prism.border.step.2')} 80%,
          ${aiThemeColor('prism.border.step.1')} 100%
        );
        background-size: 200%;` : `
      background: conic-gradient(
      from var(--gradient-angle, 270deg),
      ${aiThemeColor('prism.border.step.1')} 0%,
      ${aiThemeColor('prism.border.step.2')} 20%,
      ${aiThemeColor('prism.border.step.3')} 50%,
      ${aiThemeColor('prism.border.step.4')} 56%,
      ${aiThemeColor('prism.border.step.1')} 100%
    );`}
		z-index: -1;
		width: calc(100% + 2px);
		height: calc(100% + 2px);
		top: -1px;
		left: -1px;
		border-radius: calc(${"var(--ds-border-radius-200, 6px)"} + 1px);

		// Avoid css filter issues in Safari
		transform: translate3d(0, 0, 0);
	}

	&::after {
		filter: blur(8px);
		opacity: 0.5;
	}
`;
const $5ada89575e92f492$var$borderStyles = (0, $byn9U.css)({
    borderRadius: "var(--ds-border-radius-200, 6px)",
    '> :first-child': {
        borderTopLeftRadius: 'inherit',
        borderTopRightRadius: 'inherit'
    },
    '> :last-child': {
        borderBottomLeftRadius: 'inherit',
        borderBottomRightRadius: 'inherit'
    }
});
const $5ada89575e92f492$var$dimensionStyles = (0, $byn9U.css)({
    height: '100%',
    width: '100%',
    boxSizing: 'border-box'
});
const $5ada89575e92f492$var$backgroundStyles = (0, $byn9U.css)({
    backgroundColor: `var(--ds-surface-overlay, ${(0, $PdmhA.N0)})`
});
const $5ada89575e92f492$export$8833ec6a339f43a0 = [
    $5ada89575e92f492$var$shadowStyles,
    $5ada89575e92f492$var$borderStyles,
    $5ada89575e92f492$var$dimensionStyles,
    $5ada89575e92f492$var$backgroundStyles
];
const $5ada89575e92f492$var$defaultPadding = {
    top: 12,
    bottom: 12,
    left: 12,
    right: 12
};
const $5ada89575e92f492$export$f8a8f4dcef342279 = (0, $byn9U.css)({
    padding: `${$5ada89575e92f492$var$defaultPadding.top}px ${$5ada89575e92f492$var$defaultPadding.left}px`
});
const $5ada89575e92f492$export$cfd50dc61b5efbbd = (adjustments)=>{
    if (!adjustments) return null;
    const { top: top, right: right, bottom: bottom, left: left } = adjustments;
    return (0, $byn9U.css)({
        paddingTop: `${$5ada89575e92f492$var$defaultPadding.top + (top !== null && top !== void 0 ? top : 0)}px`,
        paddingRight: `${$5ada89575e92f492$var$defaultPadding.right + (right !== null && right !== void 0 ? right : 0)}px`,
        paddingBottom: `${$5ada89575e92f492$var$defaultPadding.bottom + (bottom !== null && bottom !== void 0 ? bottom : 0)}px`,
        paddingLeft: `${$5ada89575e92f492$var$defaultPadding.left + (left !== null && left !== void 0 ? left : 0)}px`
    });
};
const $5ada89575e92f492$export$241bafe0360eb71d = 32;
const $5ada89575e92f492$export$3de32da52b6918c2 = (0, $byn9U.css)({
    scrollMarginTop: `var(--ds-space-400, ${`${$5ada89575e92f492$export$241bafe0360eb71d}px`})`
});

});


// Request from Trello to add a single selector for all modal screens
// This is to prevent click events within the Editor AI plugin screens
// from triggering a “close” event hiding the Editor while in edit mode.
// See https://hello.atlassian.net/browse/EDITOR-75
const $64ce3526fe10ea0e$export$9df59400d72ad68f = 'ai-modal-screen';

parcelRegister("jjK5n", function(module, exports) {

$parcel$export(module.exports, "buttonAutoFocusRingFix", () => $e1038a5b3655e8c1$export$c56249aee6987832);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $byn9U = parcelRequire("byn9U");
const $e1038a5b3655e8c1$export$c56249aee6987832 = (0, $byn9U.css)({
    /**
   * TODO AIFOLLOWUP
   * This is a workaround for programmatic focus from autoFocus not using
   * :focus-visible styling in the modal. (See: ED-18908).
   * Styles taken from packages/design-system/focus-ring/src/focus-ring.tsx
   */ ':focus': {
        outline: `2px solid ${"var(--ds-border-focused, #2684FF)"}`,
        outlineOffset: "var(--ds-space-025, 2px)"
    }
});

});



parcelRegister("6cItu", function(module, exports) {

$parcel$export(module.exports, "default", () => $48465ccee6dac8d5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var // These messages have been copied to packages/editor/generative-ai-modal/examples/screen-errors-unhandled.tsx
$48465ccee6dac8d5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    unhandledErrorMessage: {
        id: 'fabric.editor.ai.experience-application.unhandledErrorMessage',
        defaultMessage: "We're having trouble. Close the dialog and try again.",
        description: 'Message to users that displays when an unexpected error happens'
    },
    markdownErrorMessage: {
        id: 'fabric.editor.ai.experience-application.error-boundary.markdownErrorMessage',
        defaultMessage: "We're having trouble generating the preview. Close the dialog and try again.",
        description: 'Message to users that displays when an error occurs while generating a preview.'
    }
});

});


parcelRegister("1cdJa", function(module, exports) {

$parcel$export(module.exports, "useAIExperienceService", () => $0df18f720023d435$export$519bc24a166a4cfd);

var $eUqFw = parcelRequire("eUqFw");

var $lLbOi = parcelRequire("lLbOi");

var $3TkyW = parcelRequire("3TkyW");
function $0df18f720023d435$export$519bc24a166a4cfd(options) {
    const machineRef = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(null);
    if (machineRef.current === null) machineRef.current = (0, $3TkyW.createAIExperienceMachine)(options);
    const [state, send] = (0, $lLbOi.useMachine)(machineRef.current);
    return {
        // In a later version of xstate -- the type gen means the machine
        // has good types, so these assertions are not required
        state: state.value,
        context: state.context,
        // Out of the box -- the type of the event received by the xstate send
        // will allow any "payload".
        // ie. `send("correct event type", {incorrect: "event payload"})`
        //
        // To avoid related issues -- we've limited the type to only allow
        // sending the full event.
        // ie. `send({type: "correct event type", correct: "event payload"})`
        send: send
    };
}

});
parcelRegister("lLbOi", function(module, exports) {

$parcel$export(module.exports, "executeEffect", () => $fd77260c5ac410a6$export$5b2b7e8fec35690c);
$parcel$export(module.exports, "useMachine", () => $fd77260c5ac410a6$export$e0338c4153421160);

var $eUqFw = parcelRequire("eUqFw");

var $cqUHI = parcelRequire("cqUHI");

var $XJXVw = parcelRequire("XJXVw");

var $j1P2b = parcelRequire("j1P2b");
var $fd77260c5ac410a6$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $fd77260c5ac410a6$var$__spread = undefined && undefined.__spread || function() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($fd77260c5ac410a6$var$__read(arguments[i]));
    return ar;
};
function $fd77260c5ac410a6$var$createReactActionFunction(exec, tag) {
    var effectExec = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        // don't execute; just return
        return function() {
            return exec.apply(void 0, $fd77260c5ac410a6$var$__spread(args));
        };
    };
    Object.defineProperties(effectExec, {
        name: {
            value: "effect:" + exec.name
        },
        __effect: {
            value: tag
        }
    });
    return effectExec;
}
function $fd77260c5ac410a6$export$6338d86c17f4b021(exec) {
    return $fd77260c5ac410a6$var$createReactActionFunction(exec, (0, $XJXVw.ReactEffectType).Effect);
}
function $fd77260c5ac410a6$export$14bc29259b87b462(exec) {
    return $fd77260c5ac410a6$var$createReactActionFunction(exec, (0, $XJXVw.ReactEffectType).LayoutEffect);
}
function $fd77260c5ac410a6$export$5b2b7e8fec35690c(action, state) {
    var exec = action.exec;
    var originalExec = exec(state.context, state._event.data, {
        action: action,
        state: state,
        _event: state._event
    });
    originalExec();
}
function $fd77260c5ac410a6$export$e0338c4153421160(getMachine, options) {
    if (options === void 0) options = {};
    var listener = (0, $eUqFw.useCallback)(function(nextState) {
        // Only change the current state if:
        // - the incoming state is the "live" initial state (since it might have new actors)
        // - OR the incoming state actually changed.
        //
        // The "live" initial state will have .changed === undefined.
        var initialStateChanged = nextState.changed === undefined && Object.keys(nextState.children).length;
        if (nextState.changed || initialStateChanged) setState(nextState);
    }, []);
    var service = (0, $j1P2b.useInterpret)(getMachine, options, listener);
    var _a = $fd77260c5ac410a6$var$__read((0, $eUqFw.useState)(function() {
        var initialState = service.machine.initialState;
        return options.state ? (0, $cqUHI.State).create(options.state) : initialState;
    }), 2), state = _a[0], setState = _a[1];
    return [
        state,
        service.send,
        service
    ];
}

});
parcelRegister("cqUHI", function(module, exports) {

$parcel$export(module.exports, "stateValuesEqual", () => $90d3e5fc458ff0ae$export$3a6d15eeb5fb214c);
$parcel$export(module.exports, "isState", () => $90d3e5fc458ff0ae$export$e5d60a6bbabd36f);
$parcel$export(module.exports, "bindActionToState", () => $90d3e5fc458ff0ae$export$e42513ad58964418);
$parcel$export(module.exports, "State", () => $90d3e5fc458ff0ae$export$7254cc27399e90bd);

var $iRfl8 = parcelRequire("iRfl8");

var $l1Yh8 = parcelRequire("l1Yh8");

var $1Rgbm = parcelRequire("1Rgbm");

var $kUKMl = parcelRequire("kUKMl");

var $7LdyK = parcelRequire("7LdyK");
function $90d3e5fc458ff0ae$export$3a6d15eeb5fb214c(a, b) {
    if (a === b) return true;
    if (a === undefined || b === undefined) return false;
    if ((0, $1Rgbm.isString)(a) || (0, $1Rgbm.isString)(b)) return a === b;
    var aKeys = (0, $1Rgbm.keys)(a);
    var bKeys = (0, $1Rgbm.keys)(b);
    return aKeys.length === bKeys.length && aKeys.every(function(key) {
        return $90d3e5fc458ff0ae$export$3a6d15eeb5fb214c(a[key], b[key]);
    });
}
function $90d3e5fc458ff0ae$export$e5d60a6bbabd36f(state) {
    if ((0, $1Rgbm.isString)(state)) return false;
    return 'value' in state && 'history' in state;
}
function $90d3e5fc458ff0ae$export$e42513ad58964418(action, state) {
    var exec = action.exec;
    var boundAction = (0, $iRfl8.__assign)((0, $iRfl8.__assign)({}, action), {
        exec: exec !== undefined ? function() {
            return exec(state.context, state.event, {
                action: action,
                state: state,
                _event: state._event
            });
        } : undefined
    });
    return boundAction;
}
var $90d3e5fc458ff0ae$export$7254cc27399e90bd = /*#__PURE__*/ /** @class */ function() {
    /**
   * Creates a new State instance.
   * @param value The state value
   * @param context The extended state
   * @param historyValue The tree representing historical values of the state nodes
   * @param history The previous state
   * @param actions An array of action objects to execute as side-effects
   * @param activities A mapping of activities and whether they are started (`true`) or stopped (`false`).
   * @param meta
   * @param events Internal event queue. Should be empty with run-to-completion semantics.
   * @param configuration
   */ function State(config) {
        var _this = this;
        var _a;
        this.actions = [];
        this.activities = (0, $l1Yh8.EMPTY_ACTIVITY_MAP);
        this.meta = {};
        this.events = [];
        this.value = config.value;
        this.context = config.context;
        this._event = config._event;
        this._sessionid = config._sessionid;
        this.event = this._event.data;
        this.historyValue = config.historyValue;
        this.history = config.history;
        this.actions = config.actions || [];
        this.activities = config.activities || (0, $l1Yh8.EMPTY_ACTIVITY_MAP);
        this.meta = config.meta || {};
        this.events = config.events || [];
        this.matches = this.matches.bind(this);
        this.toStrings = this.toStrings.bind(this);
        this.configuration = config.configuration;
        this.transitions = config.transitions;
        this.children = config.children;
        this.done = !!config.done;
        this.tags = (_a = config.tags) !== null && _a !== void 0 ? _a : new Set();
        Object.defineProperty(this, 'nextEvents', {
            get: function() {
                return (0, $kUKMl.nextEvents)(_this.configuration);
            }
        });
    }
    /**
   * Creates a new State instance for the given `stateValue` and `context`.
   * @param stateValue
   * @param context
   */ State.from = function(stateValue, context) {
        if (stateValue instanceof State) {
            if (stateValue.context !== context) return new State({
                value: stateValue.value,
                context: context,
                _event: stateValue._event,
                _sessionid: null,
                historyValue: stateValue.historyValue,
                history: stateValue.history,
                actions: [],
                activities: stateValue.activities,
                meta: {},
                events: [],
                configuration: [],
                transitions: [],
                children: {}
            });
            return stateValue;
        }
        var _event = (0, $7LdyK.initEvent);
        return new State({
            value: stateValue,
            context: context,
            _event: _event,
            _sessionid: null,
            historyValue: undefined,
            history: undefined,
            actions: [],
            activities: undefined,
            meta: undefined,
            events: [],
            configuration: [],
            transitions: [],
            children: {}
        });
    };
    /**
   * Creates a new State instance for the given `config`.
   * @param config The state config
   */ State.create = function(config) {
        return new State(config);
    };
    /**
   * Creates a new `State` instance for the given `stateValue` and `context` with no actions (side-effects).
   * @param stateValue
   * @param context
   */ State.inert = function(stateValue, context) {
        if (stateValue instanceof State) {
            if (!stateValue.actions.length) return stateValue;
            var _event = (0, $7LdyK.initEvent);
            return new State({
                value: stateValue.value,
                context: context,
                _event: _event,
                _sessionid: null,
                historyValue: stateValue.historyValue,
                history: stateValue.history,
                activities: stateValue.activities,
                configuration: stateValue.configuration,
                transitions: [],
                children: {}
            });
        }
        return State.from(stateValue, context);
    };
    /**
   * Returns an array of all the string leaf state node paths.
   * @param stateValue
   * @param delimiter The character(s) that separate each subpath in the string state node path.
   */ State.prototype.toStrings = function(stateValue, delimiter) {
        var _this = this;
        if (stateValue === void 0) stateValue = this.value;
        if (delimiter === void 0) delimiter = '.';
        if ((0, $1Rgbm.isString)(stateValue)) return [
            stateValue
        ];
        var valueKeys = (0, $1Rgbm.keys)(stateValue);
        return valueKeys.concat.apply(valueKeys, (0, $iRfl8.__spreadArray)([], (0, $iRfl8.__read)(valueKeys.map(function(key) {
            return _this.toStrings(stateValue[key], delimiter).map(function(s) {
                return key + delimiter + s;
            });
        }))));
    };
    State.prototype.toJSON = function() {
        var _a = this, configuration = _a.configuration, transitions = _a.transitions, tags = _a.tags, jsonValues = (0, $iRfl8.__rest)(_a, [
            "configuration",
            "transitions",
            "tags"
        ]);
        return (0, $iRfl8.__assign)((0, $iRfl8.__assign)({}, jsonValues), {
            tags: Array.from(tags)
        });
    };
    /**
   * Whether the current state value is a subset of the given parent state value.
   * @param parentStateValue
   */ State.prototype.matches = function(parentStateValue) {
        return (0, $1Rgbm.matchesState)(parentStateValue, this.value);
    };
    /**
   * Whether the current state configuration has a state node with the specified `tag`.
   * @param tag
   */ State.prototype.hasTag = function(tag) {
        return this.tags.has(tag);
    };
    return State;
}();

});
parcelRegister("iRfl8", function(module, exports) {

$parcel$export(module.exports, "__assign", () => $dba9136b1a9b8846$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $dba9136b1a9b8846$export$3c9a16f847548506);
$parcel$export(module.exports, "__values", () => $dba9136b1a9b8846$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $dba9136b1a9b8846$export$8d051b38c9118094);
$parcel$export(module.exports, "__spreadArray", () => $dba9136b1a9b8846$export$1216008129fb82ed);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $dba9136b1a9b8846$export$18ce0697a983be9b = function() {
    $dba9136b1a9b8846$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $dba9136b1a9b8846$export$18ce0697a983be9b.apply(this, arguments);
};
function $dba9136b1a9b8846$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $dba9136b1a9b8846$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $dba9136b1a9b8846$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $dba9136b1a9b8846$export$1216008129fb82ed(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
}

});

parcelRegister("l1Yh8", function(module, exports) {

$parcel$export(module.exports, "STATE_DELIMITER", () => $f4f87267e4989598$export$b060f3cec92ef5c9);
$parcel$export(module.exports, "EMPTY_ACTIVITY_MAP", () => $f4f87267e4989598$export$505a390a702f4a23);
$parcel$export(module.exports, "DEFAULT_GUARD_TYPE", () => $f4f87267e4989598$export$656461011b562379);
$parcel$export(module.exports, "TARGETLESS_KEY", () => $f4f87267e4989598$export$31935b4577455331);
var $f4f87267e4989598$export$b060f3cec92ef5c9 = '.';
var $f4f87267e4989598$export$505a390a702f4a23 = {};
var $f4f87267e4989598$export$656461011b562379 = 'xstate.guard';
var $f4f87267e4989598$export$31935b4577455331 = '';

});

parcelRegister("1Rgbm", function(module, exports) {

$parcel$export(module.exports, "keys", () => $15a74b1fe3a1f83c$export$ed97f33186d4b816);
$parcel$export(module.exports, "matchesState", () => $15a74b1fe3a1f83c$export$2870710bf0eac88e);
$parcel$export(module.exports, "toStateValue", () => $15a74b1fe3a1f83c$export$fb3aecd1d93744e3);
$parcel$export(module.exports, "isString", () => $15a74b1fe3a1f83c$export$844ec244b1367d54);
$parcel$export(module.exports, "getEventType", () => $15a74b1fe3a1f83c$export$7193fc8c8cd445e9);
$parcel$export(module.exports, "toStatePath", () => $15a74b1fe3a1f83c$export$304cde62ecda7af8);
$parcel$export(module.exports, "isArray", () => $15a74b1fe3a1f83c$export$43bee75e5e14138e);
$parcel$export(module.exports, "pathToStateValue", () => $15a74b1fe3a1f83c$export$f2ee84fc53c45e74);
$parcel$export(module.exports, "mapValues", () => $15a74b1fe3a1f83c$export$825e789796ab7275);
$parcel$export(module.exports, "mapFilterValues", () => $15a74b1fe3a1f83c$export$2d4204fe9b34204e);
$parcel$export(module.exports, "path", () => $15a74b1fe3a1f83c$export$bb654e07daaf8c3a);
$parcel$export(module.exports, "nestedPath", () => $15a74b1fe3a1f83c$export$314d0a1a7c835392);
$parcel$export(module.exports, "toStatePaths", () => $15a74b1fe3a1f83c$export$a2618e9e89698dd6);
$parcel$export(module.exports, "flatten", () => $15a74b1fe3a1f83c$export$bffa455ba8c619a6);
$parcel$export(module.exports, "toArray", () => $15a74b1fe3a1f83c$export$45b10814cc054894);
$parcel$export(module.exports, "mapContext", () => $15a74b1fe3a1f83c$export$e756e60189cc2351);
$parcel$export(module.exports, "isFunction", () => $15a74b1fe3a1f83c$export$f6e2535fb5126e54);
$parcel$export(module.exports, "isBuiltInEvent", () => $15a74b1fe3a1f83c$export$479b1b8942fd0b8d);
$parcel$export(module.exports, "isPromiseLike", () => $15a74b1fe3a1f83c$export$ae936b9d47e5870e);
$parcel$export(module.exports, "partition", () => $15a74b1fe3a1f83c$export$b29f828819edca8d);
$parcel$export(module.exports, "updateHistoryValue", () => $15a74b1fe3a1f83c$export$240d7cdd99ccb95a);
$parcel$export(module.exports, "updateContext", () => $15a74b1fe3a1f83c$export$d84706064a6e6c1c);
$parcel$export(module.exports, "warn", () => $15a74b1fe3a1f83c$export$c106dd0671a0fc2d);
$parcel$export(module.exports, "toGuard", () => $15a74b1fe3a1f83c$export$b0f5a08e0ca47933);
$parcel$export(module.exports, "isObservable", () => $15a74b1fe3a1f83c$export$5cd057a6046189f9);
$parcel$export(module.exports, "symbolObservable", () => $15a74b1fe3a1f83c$export$c45ebe72e3b2885);
$parcel$export(module.exports, "isMachine", () => $15a74b1fe3a1f83c$export$2163e7903738b5df);
$parcel$export(module.exports, "isActor", () => $15a74b1fe3a1f83c$export$e769f6913f14f1b7);
$parcel$export(module.exports, "uniqueId", () => $15a74b1fe3a1f83c$export$8b15d37bc3f197d4);
$parcel$export(module.exports, "toEventObject", () => $15a74b1fe3a1f83c$export$5a4ea50826a01d14);
$parcel$export(module.exports, "toSCXMLEvent", () => $15a74b1fe3a1f83c$export$eaf22249b410f633);
$parcel$export(module.exports, "toTransitionConfigArray", () => $15a74b1fe3a1f83c$export$3822a36ea084a4d5);
$parcel$export(module.exports, "normalizeTarget", () => $15a74b1fe3a1f83c$export$2a4fe5c3c80e3288);
$parcel$export(module.exports, "reportUnhandledExceptionOnInvocation", () => $15a74b1fe3a1f83c$export$b240b9b7a78b5f3e);
$parcel$export(module.exports, "evaluateGuard", () => $15a74b1fe3a1f83c$export$91646ab912d254e8);
$parcel$export(module.exports, "toInvokeSource", () => $15a74b1fe3a1f83c$export$436e852aa2feda95);
$parcel$export(module.exports, "toObserver", () => $15a74b1fe3a1f83c$export$75b67481063f2f98);

var $iRfl8 = parcelRequire("iRfl8");

var $l1Yh8 = parcelRequire("l1Yh8");

var $2vepS = parcelRequire("2vepS");
function $15a74b1fe3a1f83c$export$ed97f33186d4b816(value) {
    return Object.keys(value);
}
function $15a74b1fe3a1f83c$export$2870710bf0eac88e(parentStateId, childStateId, delimiter) {
    if (delimiter === void 0) delimiter = (0, $l1Yh8.STATE_DELIMITER);
    var parentStateValue = $15a74b1fe3a1f83c$export$fb3aecd1d93744e3(parentStateId, delimiter);
    var childStateValue = $15a74b1fe3a1f83c$export$fb3aecd1d93744e3(childStateId, delimiter);
    if ($15a74b1fe3a1f83c$export$844ec244b1367d54(childStateValue)) {
        if ($15a74b1fe3a1f83c$export$844ec244b1367d54(parentStateValue)) return childStateValue === parentStateValue;
         // Parent more specific than child
        return false;
    }
    if ($15a74b1fe3a1f83c$export$844ec244b1367d54(parentStateValue)) return parentStateValue in childStateValue;
    return $15a74b1fe3a1f83c$export$ed97f33186d4b816(parentStateValue).every(function(key) {
        if (!(key in childStateValue)) return false;
        return $15a74b1fe3a1f83c$export$2870710bf0eac88e(parentStateValue[key], childStateValue[key]);
    });
}
function $15a74b1fe3a1f83c$export$7193fc8c8cd445e9(event) {
    try {
        return $15a74b1fe3a1f83c$export$844ec244b1367d54(event) || typeof event === 'number' ? "" + event : event.type;
    } catch (e) {
        throw new Error('Events must be strings or objects with a string event.type property.');
    }
}
function $15a74b1fe3a1f83c$export$304cde62ecda7af8(stateId, delimiter) {
    try {
        if ($15a74b1fe3a1f83c$export$43bee75e5e14138e(stateId)) return stateId;
        return stateId.toString().split(delimiter);
    } catch (e) {
        throw new Error("'" + stateId + "' is not a valid state path.");
    }
}
function $15a74b1fe3a1f83c$export$e080e3931a079c9b(state) {
    return typeof state === 'object' && 'value' in state && 'context' in state && 'event' in state && '_event' in state;
}
function $15a74b1fe3a1f83c$export$fb3aecd1d93744e3(stateValue, delimiter) {
    if ($15a74b1fe3a1f83c$export$e080e3931a079c9b(stateValue)) return stateValue.value;
    if ($15a74b1fe3a1f83c$export$43bee75e5e14138e(stateValue)) return $15a74b1fe3a1f83c$export$f2ee84fc53c45e74(stateValue);
    if (typeof stateValue !== 'string') return stateValue;
    var statePath = $15a74b1fe3a1f83c$export$304cde62ecda7af8(stateValue, delimiter);
    return $15a74b1fe3a1f83c$export$f2ee84fc53c45e74(statePath);
}
function $15a74b1fe3a1f83c$export$f2ee84fc53c45e74(statePath) {
    if (statePath.length === 1) return statePath[0];
    var value = {};
    var marker = value;
    for(var i = 0; i < statePath.length - 1; i++)if (i === statePath.length - 2) marker[statePath[i]] = statePath[i + 1];
    else {
        marker[statePath[i]] = {};
        marker = marker[statePath[i]];
    }
    return value;
}
function $15a74b1fe3a1f83c$export$825e789796ab7275(collection, iteratee) {
    var result = {};
    var collectionKeys = $15a74b1fe3a1f83c$export$ed97f33186d4b816(collection);
    for(var i = 0; i < collectionKeys.length; i++){
        var key = collectionKeys[i];
        result[key] = iteratee(collection[key], key, collection, i);
    }
    return result;
}
function $15a74b1fe3a1f83c$export$2d4204fe9b34204e(collection, iteratee, predicate) {
    var e_1, _a;
    var result = {};
    try {
        for(var _b = (0, $iRfl8.__values)($15a74b1fe3a1f83c$export$ed97f33186d4b816(collection)), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var item = collection[key];
            if (!predicate(item)) continue;
            result[key] = iteratee(item, key, collection);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return result;
}
/**
 * Retrieves a value at the given path.
 * @param props The deep path to the prop of the desired value
 */ var $15a74b1fe3a1f83c$export$bb654e07daaf8c3a = function(props) {
    return function(object) {
        var e_2, _a;
        var result = object;
        try {
            for(var props_1 = (0, $iRfl8.__values)(props), props_1_1 = props_1.next(); !props_1_1.done; props_1_1 = props_1.next()){
                var prop = props_1_1.value;
                result = result[prop];
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (props_1_1 && !props_1_1.done && (_a = props_1.return)) _a.call(props_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return result;
    };
};
/**
 * Retrieves a value at the given path via the nested accessor prop.
 * @param props The deep path to the prop of the desired value
 */ function $15a74b1fe3a1f83c$export$314d0a1a7c835392(props, accessorProp) {
    return function(object) {
        var e_3, _a;
        var result = object;
        try {
            for(var props_2 = (0, $iRfl8.__values)(props), props_2_1 = props_2.next(); !props_2_1.done; props_2_1 = props_2.next()){
                var prop = props_2_1.value;
                result = result[accessorProp][prop];
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (props_2_1 && !props_2_1.done && (_a = props_2.return)) _a.call(props_2);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        return result;
    };
}
function $15a74b1fe3a1f83c$export$a2618e9e89698dd6(stateValue) {
    if (!stateValue) return [
        []
    ];
    if ($15a74b1fe3a1f83c$export$844ec244b1367d54(stateValue)) return [
        [
            stateValue
        ]
    ];
    var result = $15a74b1fe3a1f83c$export$bffa455ba8c619a6($15a74b1fe3a1f83c$export$ed97f33186d4b816(stateValue).map(function(key) {
        var subStateValue = stateValue[key];
        if (typeof subStateValue !== 'string' && (!subStateValue || !Object.keys(subStateValue).length)) return [
            [
                key
            ]
        ];
        return $15a74b1fe3a1f83c$export$a2618e9e89698dd6(stateValue[key]).map(function(subPath) {
            return [
                key
            ].concat(subPath);
        });
    }));
    return result;
}
function $15a74b1fe3a1f83c$export$bffa455ba8c619a6(array) {
    var _a;
    return (_a = []).concat.apply(_a, (0, $iRfl8.__spreadArray)([], (0, $iRfl8.__read)(array)));
}
function $15a74b1fe3a1f83c$export$2c0b6b2f4faf21e1(value) {
    if ($15a74b1fe3a1f83c$export$43bee75e5e14138e(value)) return value;
    return [
        value
    ];
}
function $15a74b1fe3a1f83c$export$45b10814cc054894(value) {
    if (value === undefined) return [];
    return $15a74b1fe3a1f83c$export$2c0b6b2f4faf21e1(value);
}
function $15a74b1fe3a1f83c$export$e756e60189cc2351(mapper, context, _event) {
    var e_5, _a;
    if ($15a74b1fe3a1f83c$export$f6e2535fb5126e54(mapper)) return mapper(context, _event.data);
    var result = {};
    try {
        for(var _b = (0, $iRfl8.__values)(Object.keys(mapper)), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var subMapper = mapper[key];
            if ($15a74b1fe3a1f83c$export$f6e2535fb5126e54(subMapper)) result[key] = subMapper(context, _event.data);
            else result[key] = subMapper;
        }
    } catch (e_5_1) {
        e_5 = {
            error: e_5_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_5) throw e_5.error;
        }
    }
    return result;
}
function $15a74b1fe3a1f83c$export$479b1b8942fd0b8d(eventType) {
    return /^(done|error)\./.test(eventType);
}
function $15a74b1fe3a1f83c$export$ae936b9d47e5870e(value) {
    if (value instanceof Promise) return true;
     // Check if shape matches the Promise/A+ specification for a "thenable".
    if (value !== null && ($15a74b1fe3a1f83c$export$f6e2535fb5126e54(value) || typeof value === 'object') && $15a74b1fe3a1f83c$export$f6e2535fb5126e54(value.then)) return true;
    return false;
}
function $15a74b1fe3a1f83c$export$b29f828819edca8d(items, predicate) {
    var e_6, _a;
    var _b = (0, $iRfl8.__read)([
        [],
        []
    ], 2), truthy = _b[0], falsy = _b[1];
    try {
        for(var items_1 = (0, $iRfl8.__values)(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()){
            var item = items_1_1.value;
            if (predicate(item)) truthy.push(item);
            else falsy.push(item);
        }
    } catch (e_6_1) {
        e_6 = {
            error: e_6_1
        };
    } finally{
        try {
            if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
        } finally{
            if (e_6) throw e_6.error;
        }
    }
    return [
        truthy,
        falsy
    ];
}
function $15a74b1fe3a1f83c$export$3737909a0074eb1(hist, stateValue) {
    return $15a74b1fe3a1f83c$export$825e789796ab7275(hist.states, function(subHist, key) {
        if (!subHist) return undefined;
        var subStateValue = ($15a74b1fe3a1f83c$export$844ec244b1367d54(stateValue) ? undefined : stateValue[key]) || (subHist ? subHist.current : undefined);
        if (!subStateValue) return undefined;
        return {
            current: subStateValue,
            states: $15a74b1fe3a1f83c$export$3737909a0074eb1(subHist, subStateValue)
        };
    });
}
function $15a74b1fe3a1f83c$export$240d7cdd99ccb95a(hist, stateValue) {
    return {
        current: stateValue,
        states: $15a74b1fe3a1f83c$export$3737909a0074eb1(hist, stateValue)
    };
}
function $15a74b1fe3a1f83c$export$d84706064a6e6c1c(context, _event, assignActions, state) {
    if (!(0, $2vepS.IS_PRODUCTION)) $15a74b1fe3a1f83c$export$c106dd0671a0fc2d(!!context, 'Attempting to update undefined context');
    var updatedContext = context ? assignActions.reduce(function(acc, assignAction) {
        var e_7, _a;
        var assignment = assignAction.assignment;
        var meta = {
            state: state,
            action: assignAction,
            _event: _event
        };
        var partialUpdate = {};
        if ($15a74b1fe3a1f83c$export$f6e2535fb5126e54(assignment)) partialUpdate = assignment(acc, _event.data, meta);
        else try {
            for(var _b = (0, $iRfl8.__values)($15a74b1fe3a1f83c$export$ed97f33186d4b816(assignment)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                var propAssignment = assignment[key];
                partialUpdate[key] = $15a74b1fe3a1f83c$export$f6e2535fb5126e54(propAssignment) ? propAssignment(acc, _event.data, meta) : propAssignment;
            }
        } catch (e_7_1) {
            e_7 = {
                error: e_7_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_7) throw e_7.error;
            }
        }
        return Object.assign({}, acc, partialUpdate);
    }, context) : context;
    return updatedContext;
} // tslint:disable-next-line:no-empty
var $15a74b1fe3a1f83c$export$c106dd0671a0fc2d = function() {};
if (!(0, $2vepS.IS_PRODUCTION)) $15a74b1fe3a1f83c$export$c106dd0671a0fc2d = function(condition, message) {
    var error = condition instanceof Error ? condition : undefined;
    if (!error && condition) return;
    if (console !== undefined) {
        var args = [
            "Warning: " + message
        ];
        if (error) args.push(error);
         // tslint:disable-next-line:no-console
        console.warn.apply(console, args);
    }
};
function $15a74b1fe3a1f83c$export$43bee75e5e14138e(value) {
    return Array.isArray(value);
} // tslint:disable-next-line:ban-types
function $15a74b1fe3a1f83c$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}
function $15a74b1fe3a1f83c$export$844ec244b1367d54(value) {
    return typeof value === 'string';
} // export function memoizedGetter<T, TP extends { prototype: object }>(
//   o: TP,
//   property: string,
//   getter: () => T
// ): void {
//   Object.defineProperty(o.prototype, property, {
//     get: getter,
//     enumerable: false,
//     configurable: false
//   });
// }
function $15a74b1fe3a1f83c$export$b0f5a08e0ca47933(condition, guardMap) {
    if (!condition) return undefined;
    if ($15a74b1fe3a1f83c$export$844ec244b1367d54(condition)) return {
        type: (0, $l1Yh8.DEFAULT_GUARD_TYPE),
        name: condition,
        predicate: guardMap ? guardMap[condition] : undefined
    };
    if ($15a74b1fe3a1f83c$export$f6e2535fb5126e54(condition)) return {
        type: (0, $l1Yh8.DEFAULT_GUARD_TYPE),
        name: condition.name,
        predicate: condition
    };
    return condition;
}
function $15a74b1fe3a1f83c$export$5cd057a6046189f9(value) {
    try {
        return 'subscribe' in value && $15a74b1fe3a1f83c$export$f6e2535fb5126e54(value.subscribe);
    } catch (e) {
        return false;
    }
}
var $15a74b1fe3a1f83c$export$c45ebe72e3b2885 = /*#__PURE__*/ function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
function $15a74b1fe3a1f83c$export$2163e7903738b5df(value) {
    try {
        return '__xstatenode' in value;
    } catch (e) {
        return false;
    }
}
function $15a74b1fe3a1f83c$export$e769f6913f14f1b7(value) {
    return !!value && typeof value.send === 'function';
}
var $15a74b1fe3a1f83c$export$8b15d37bc3f197d4 = /*#__PURE__*/ function() {
    var currentId = 0;
    return function() {
        currentId++;
        return currentId.toString(16);
    };
}();
function $15a74b1fe3a1f83c$export$5a4ea50826a01d14(event, payload // id?: TEvent['type']
) {
    if ($15a74b1fe3a1f83c$export$844ec244b1367d54(event) || typeof event === 'number') return (0, $iRfl8.__assign)({
        type: event
    }, payload);
    return event;
}
function $15a74b1fe3a1f83c$export$eaf22249b410f633(event, scxmlEvent) {
    if (!$15a74b1fe3a1f83c$export$844ec244b1367d54(event) && '$$type' in event && event.$$type === 'scxml') return event;
    var eventObject = $15a74b1fe3a1f83c$export$5a4ea50826a01d14(event);
    return (0, $iRfl8.__assign)({
        name: eventObject.type,
        data: eventObject,
        $$type: 'scxml',
        type: 'external'
    }, scxmlEvent);
}
function $15a74b1fe3a1f83c$export$3822a36ea084a4d5(event, configLike) {
    var transitions = $15a74b1fe3a1f83c$export$2c0b6b2f4faf21e1(configLike).map(function(transitionLike) {
        if (typeof transitionLike === 'undefined' || typeof transitionLike === 'string' || $15a74b1fe3a1f83c$export$2163e7903738b5df(transitionLike)) return {
            target: transitionLike,
            event: event
        };
        return (0, $iRfl8.__assign)((0, $iRfl8.__assign)({}, transitionLike), {
            event: event
        });
    });
    return transitions;
}
function $15a74b1fe3a1f83c$export$2a4fe5c3c80e3288(target) {
    if (target === undefined || target === (0, $l1Yh8.TARGETLESS_KEY)) return undefined;
    return $15a74b1fe3a1f83c$export$45b10814cc054894(target);
}
function $15a74b1fe3a1f83c$export$b240b9b7a78b5f3e(originalError, currentError, id) {
    if (!(0, $2vepS.IS_PRODUCTION)) {
        var originalStackTrace = originalError.stack ? " Stacktrace was '" + originalError.stack + "'" : '';
        if (originalError === currentError) // tslint:disable-next-line:no-console
        console.error("Missing onError handler for invocation '" + id + "', error was '" + originalError + "'." + originalStackTrace);
        else {
            var stackTrace = currentError.stack ? " Stacktrace was '" + currentError.stack + "'" : ''; // tslint:disable-next-line:no-console
            console.error("Missing onError handler and/or unhandled exception/promise rejection for invocation '" + id + "'. " + ("Original error: '" + originalError + "'. " + originalStackTrace + " Current error is '" + currentError + "'." + stackTrace));
        }
    }
}
function $15a74b1fe3a1f83c$export$91646ab912d254e8(machine, guard, context, _event, state) {
    var guards = machine.options.guards;
    var guardMeta = {
        state: state,
        cond: guard,
        _event: _event
    }; // TODO: do not hardcode!
    if (guard.type === (0, $l1Yh8.DEFAULT_GUARD_TYPE)) return guard.predicate(context, _event.data, guardMeta);
    var condFn = guards[guard.type];
    if (!condFn) throw new Error("Guard '" + guard.type + "' is not implemented on machine '" + machine.id + "'.");
    return condFn(context, _event.data, guardMeta);
}
function $15a74b1fe3a1f83c$export$436e852aa2feda95(src) {
    if (typeof src === 'string') return {
        type: src
    };
    return src;
}
function $15a74b1fe3a1f83c$export$75b67481063f2f98(nextHandler, errorHandler, completionHandler) {
    if (typeof nextHandler === 'object') return nextHandler;
    var noop = function() {
        return void 0;
    };
    return {
        next: nextHandler,
        error: errorHandler || noop,
        complete: completionHandler || noop
    };
}

});
parcelRegister("2vepS", function(module, exports) {

$parcel$export(module.exports, "IS_PRODUCTION", () => $1d29a8d51d5396fe$export$9b5f2e1c20ef6571);
var $1d29a8d51d5396fe$export$9b5f2e1c20ef6571 = true;

});


parcelRegister("kUKMl", function(module, exports) {

$parcel$export(module.exports, "isLeafNode", () => $f39d52e751130fc4$export$335db82b86111fd1);
$parcel$export(module.exports, "getChildren", () => $f39d52e751130fc4$export$f8cf48ee793b41be);
$parcel$export(module.exports, "getAllStateNodes", () => $f39d52e751130fc4$export$3de19bba299e3801);
$parcel$export(module.exports, "getConfiguration", () => $f39d52e751130fc4$export$3de01744a82b21a4);
$parcel$export(module.exports, "getValue", () => $f39d52e751130fc4$export$bf7199a9ebcb84a9);
$parcel$export(module.exports, "has", () => $f39d52e751130fc4$export$a4f4bb6b1453fff5);
$parcel$export(module.exports, "nextEvents", () => $f39d52e751130fc4$export$c661ab6895e3ed73);
$parcel$export(module.exports, "isInFinalState", () => $f39d52e751130fc4$export$cf3d5dae927fcf63);

var $iRfl8 = parcelRequire("iRfl8");

var $1Rgbm = parcelRequire("1Rgbm");
var $f39d52e751130fc4$export$335db82b86111fd1 = function(stateNode) {
    return stateNode.type === 'atomic' || stateNode.type === 'final';
};
function $f39d52e751130fc4$export$f8cf48ee793b41be(stateNode) {
    return (0, $1Rgbm.keys)(stateNode.states).map(function(key) {
        return stateNode.states[key];
    });
}
function $f39d52e751130fc4$export$3de19bba299e3801(stateNode) {
    var stateNodes = [
        stateNode
    ];
    if ($f39d52e751130fc4$export$335db82b86111fd1(stateNode)) return stateNodes;
    return stateNodes.concat((0, $1Rgbm.flatten)($f39d52e751130fc4$export$f8cf48ee793b41be(stateNode).map($f39d52e751130fc4$export$3de19bba299e3801)));
}
function $f39d52e751130fc4$export$3de01744a82b21a4(prevStateNodes, stateNodes) {
    var e_1, _a, e_2, _b, e_3, _c, e_4, _d;
    var prevConfiguration = new Set(prevStateNodes);
    var prevAdjList = $f39d52e751130fc4$export$b837d8c2d0189d63(prevConfiguration);
    var configuration = new Set(stateNodes);
    try {
        // add all ancestors
        for(var configuration_1 = (0, $iRfl8.__values)(configuration), configuration_1_1 = configuration_1.next(); !configuration_1_1.done; configuration_1_1 = configuration_1.next()){
            var s = configuration_1_1.value;
            var m = s.parent;
            while(m && !configuration.has(m)){
                configuration.add(m);
                m = m.parent;
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (configuration_1_1 && !configuration_1_1.done && (_a = configuration_1.return)) _a.call(configuration_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    var adjList = $f39d52e751130fc4$export$b837d8c2d0189d63(configuration);
    try {
        // add descendants
        for(var configuration_2 = (0, $iRfl8.__values)(configuration), configuration_2_1 = configuration_2.next(); !configuration_2_1.done; configuration_2_1 = configuration_2.next()){
            var s = configuration_2_1.value; // if previously active, add existing child nodes
            if (s.type === 'compound' && (!adjList.get(s) || !adjList.get(s).length)) {
                if (prevAdjList.get(s)) prevAdjList.get(s).forEach(function(sn) {
                    return configuration.add(sn);
                });
                else s.initialStateNodes.forEach(function(sn) {
                    return configuration.add(sn);
                });
            } else {
                if (s.type === 'parallel') try {
                    for(var _e = (e_3 = void 0, (0, $iRfl8.__values)($f39d52e751130fc4$export$f8cf48ee793b41be(s))), _f = _e.next(); !_f.done; _f = _e.next()){
                        var child = _f.value;
                        if (child.type === 'history') continue;
                        if (!configuration.has(child)) {
                            configuration.add(child);
                            if (prevAdjList.get(child)) prevAdjList.get(child).forEach(function(sn) {
                                return configuration.add(sn);
                            });
                            else child.initialStateNodes.forEach(function(sn) {
                                return configuration.add(sn);
                            });
                        }
                    }
                } catch (e_3_1) {
                    e_3 = {
                        error: e_3_1
                    };
                } finally{
                    try {
                        if (_f && !_f.done && (_c = _e.return)) _c.call(_e);
                    } finally{
                        if (e_3) throw e_3.error;
                    }
                }
            }
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (configuration_2_1 && !configuration_2_1.done && (_b = configuration_2.return)) _b.call(configuration_2);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    try {
        // add all ancestors
        for(var configuration_3 = (0, $iRfl8.__values)(configuration), configuration_3_1 = configuration_3.next(); !configuration_3_1.done; configuration_3_1 = configuration_3.next()){
            var s = configuration_3_1.value;
            var m = s.parent;
            while(m && !configuration.has(m)){
                configuration.add(m);
                m = m.parent;
            }
        }
    } catch (e_4_1) {
        e_4 = {
            error: e_4_1
        };
    } finally{
        try {
            if (configuration_3_1 && !configuration_3_1.done && (_d = configuration_3.return)) _d.call(configuration_3);
        } finally{
            if (e_4) throw e_4.error;
        }
    }
    return configuration;
}
function $f39d52e751130fc4$var$getValueFromAdj(baseNode, adjList) {
    var childStateNodes = adjList.get(baseNode);
    if (!childStateNodes) return {}; // todo: fix?
    if (baseNode.type === 'compound') {
        var childStateNode = childStateNodes[0];
        if (childStateNode) {
            if ($f39d52e751130fc4$export$335db82b86111fd1(childStateNode)) return childStateNode.key;
        } else return {};
    }
    var stateValue = {};
    childStateNodes.forEach(function(csn) {
        stateValue[csn.key] = $f39d52e751130fc4$var$getValueFromAdj(csn, adjList);
    });
    return stateValue;
}
function $f39d52e751130fc4$export$b837d8c2d0189d63(configuration) {
    var e_5, _a;
    var adjList = new Map();
    try {
        for(var configuration_4 = (0, $iRfl8.__values)(configuration), configuration_4_1 = configuration_4.next(); !configuration_4_1.done; configuration_4_1 = configuration_4.next()){
            var s = configuration_4_1.value;
            if (!adjList.has(s)) adjList.set(s, []);
            if (s.parent) {
                if (!adjList.has(s.parent)) adjList.set(s.parent, []);
                adjList.get(s.parent).push(s);
            }
        }
    } catch (e_5_1) {
        e_5 = {
            error: e_5_1
        };
    } finally{
        try {
            if (configuration_4_1 && !configuration_4_1.done && (_a = configuration_4.return)) _a.call(configuration_4);
        } finally{
            if (e_5) throw e_5.error;
        }
    }
    return adjList;
}
function $f39d52e751130fc4$export$bf7199a9ebcb84a9(rootNode, configuration) {
    var config = $f39d52e751130fc4$export$3de01744a82b21a4([
        rootNode
    ], configuration);
    return $f39d52e751130fc4$var$getValueFromAdj(rootNode, $f39d52e751130fc4$export$b837d8c2d0189d63(config));
}
function $f39d52e751130fc4$export$a4f4bb6b1453fff5(iterable, item) {
    if (Array.isArray(iterable)) return iterable.some(function(member) {
        return member === item;
    });
    if (iterable instanceof Set) return iterable.has(item);
    return false; // TODO: fix
}
function $f39d52e751130fc4$export$c661ab6895e3ed73(configuration) {
    return (0, $iRfl8.__spreadArray)([], (0, $iRfl8.__read)(new Set((0, $1Rgbm.flatten)((0, $iRfl8.__spreadArray)([], (0, $iRfl8.__read)(configuration.map(function(sn) {
        return sn.ownEvents;
    })))))));
}
function $f39d52e751130fc4$export$cf3d5dae927fcf63(configuration, stateNode) {
    if (stateNode.type === 'compound') return $f39d52e751130fc4$export$f8cf48ee793b41be(stateNode).some(function(s) {
        return s.type === 'final' && $f39d52e751130fc4$export$a4f4bb6b1453fff5(configuration, s);
    });
    if (stateNode.type === 'parallel') return $f39d52e751130fc4$export$f8cf48ee793b41be(stateNode).every(function(sn) {
        return $f39d52e751130fc4$export$cf3d5dae927fcf63(configuration, sn);
    });
    return false;
}

});

parcelRegister("7LdyK", function(module, exports) {

$parcel$export(module.exports, "initEvent", () => $5a6770ca7f808cf1$export$163c566c60ed2ec9);
$parcel$export(module.exports, "getActionFunction", () => $5a6770ca7f808cf1$export$c7e5ca927bd4567);
$parcel$export(module.exports, "toActionObject", () => $5a6770ca7f808cf1$export$b38b66cc2da3ede7);
$parcel$export(module.exports, "toActionObjects", () => $5a6770ca7f808cf1$export$aa68691f32e6c459);
$parcel$export(module.exports, "toActivityDefinition", () => $5a6770ca7f808cf1$export$e81fdd8937d44864);
$parcel$export(module.exports, "raise", () => $5a6770ca7f808cf1$export$66313c302b2ea154);
$parcel$export(module.exports, "send", () => $5a6770ca7f808cf1$export$89db4734f6c919c4);
$parcel$export(module.exports, "sendParent", () => $5a6770ca7f808cf1$export$408d8d51fa351f53);
$parcel$export(module.exports, "sendUpdate", () => $5a6770ca7f808cf1$export$7f8b724299523eb6);
$parcel$export(module.exports, "respond", () => $5a6770ca7f808cf1$export$72b816ae90496f19);
$parcel$export(module.exports, "log", () => $5a6770ca7f808cf1$export$bef1f36f5486a6a3);
$parcel$export(module.exports, "cancel", () => $5a6770ca7f808cf1$export$70b61ad426ddbe54);
$parcel$export(module.exports, "start", () => $5a6770ca7f808cf1$export$b3571188c770cc5a);
$parcel$export(module.exports, "stop", () => $5a6770ca7f808cf1$export$fa6813432f753b0d);
$parcel$export(module.exports, "assign", () => $5a6770ca7f808cf1$export$e6e34fd1f2686227);
$parcel$export(module.exports, "after", () => $5a6770ca7f808cf1$export$742acabee3dd6465);
$parcel$export(module.exports, "done", () => $5a6770ca7f808cf1$export$3df11c9c20e7b288);
$parcel$export(module.exports, "doneInvoke", () => $5a6770ca7f808cf1$export$c105e588793f70b4);
$parcel$export(module.exports, "error", () => $5a6770ca7f808cf1$export$a3bc9b8ed74fc);
$parcel$export(module.exports, "pure", () => $5a6770ca7f808cf1$export$48ec4a2b1cfc6557);
$parcel$export(module.exports, "forwardTo", () => $5a6770ca7f808cf1$export$eb147b7589db8e8a);
$parcel$export(module.exports, "escalate", () => $5a6770ca7f808cf1$export$f514678a4137c4d6);
$parcel$export(module.exports, "choose", () => $5a6770ca7f808cf1$export$7877a478dd30fd3d);
$parcel$export(module.exports, "resolveActions", () => $5a6770ca7f808cf1$export$b8b9e7ba5b8c7b3e);

var $iRfl8 = parcelRequire("iRfl8");

var $2vepS = parcelRequire("2vepS");

var $1Rgbm = parcelRequire("1Rgbm");

var $av07t = parcelRequire("av07t");

var $kWOvn = parcelRequire("kWOvn");
var $5a6770ca7f808cf1$export$163c566c60ed2ec9 = /*#__PURE__*/ (0, $1Rgbm.toSCXMLEvent)({
    type: (0, $kWOvn.init)
});
function $5a6770ca7f808cf1$export$c7e5ca927bd4567(actionType, actionFunctionMap) {
    return actionFunctionMap ? actionFunctionMap[actionType] || undefined : undefined;
}
function $5a6770ca7f808cf1$export$b38b66cc2da3ede7(action, actionFunctionMap) {
    var actionObject;
    if ((0, $1Rgbm.isString)(action) || typeof action === 'number') {
        var exec = $5a6770ca7f808cf1$export$c7e5ca927bd4567(action, actionFunctionMap);
        if ((0, $1Rgbm.isFunction)(exec)) actionObject = {
            type: action,
            exec: exec
        };
        else if (exec) actionObject = exec;
        else actionObject = {
            type: action,
            exec: undefined
        };
    } else if ((0, $1Rgbm.isFunction)(action)) actionObject = {
        // Convert action to string if unnamed
        type: action.name || action.toString(),
        exec: action
    };
    else {
        var exec = $5a6770ca7f808cf1$export$c7e5ca927bd4567(action.type, actionFunctionMap);
        if ((0, $1Rgbm.isFunction)(exec)) actionObject = (0, $iRfl8.__assign)((0, $iRfl8.__assign)({}, action), {
            exec: exec
        });
        else if (exec) {
            var actionType = exec.type || action.type;
            actionObject = (0, $iRfl8.__assign)((0, $iRfl8.__assign)((0, $iRfl8.__assign)({}, exec), action), {
                type: actionType
            });
        } else actionObject = action;
    }
    Object.defineProperty(actionObject, 'toString', {
        value: function() {
            return actionObject.type;
        },
        enumerable: false,
        configurable: true
    });
    return actionObject;
}
var $5a6770ca7f808cf1$export$aa68691f32e6c459 = function(action, actionFunctionMap) {
    if (!action) return [];
    var actions = (0, $1Rgbm.isArray)(action) ? action : [
        action
    ];
    return actions.map(function(subAction) {
        return $5a6770ca7f808cf1$export$b38b66cc2da3ede7(subAction, actionFunctionMap);
    });
};
function $5a6770ca7f808cf1$export$e81fdd8937d44864(action) {
    var actionObject = $5a6770ca7f808cf1$export$b38b66cc2da3ede7(action);
    return (0, $iRfl8.__assign)((0, $iRfl8.__assign)({
        id: (0, $1Rgbm.isString)(action) ? action : actionObject.id
    }, actionObject), {
        type: actionObject.type
    });
}
/**
 * Raises an event. This places the event in the internal event queue, so that
 * the event is immediately consumed by the machine in the current step.
 *
 * @param eventType The event to raise.
 */ function $5a6770ca7f808cf1$export$66313c302b2ea154(event) {
    if (!(0, $1Rgbm.isString)(event)) return $5a6770ca7f808cf1$export$89db4734f6c919c4(event, {
        to: (0, $av07t.SpecialTargets).Internal
    });
    return {
        type: (0, $kWOvn.raise),
        event: event
    };
}
function $5a6770ca7f808cf1$export$ed3daf8e935ede01(action) {
    return {
        type: (0, $kWOvn.raise),
        _event: (0, $1Rgbm.toSCXMLEvent)(action.event)
    };
}
/**
 * Sends an event. This returns an action that will be read by an interpreter to
 * send the event in the next step, after the current step is finished executing.
 *
 * @param event The event to send.
 * @param options Options to pass into the send event:
 *  - `id` - The unique send event identifier (used with `cancel()`).
 *  - `delay` - The number of milliseconds to delay the sending of the event.
 *  - `to` - The target of this event (by default, the machine the event was sent from).
 */ function $5a6770ca7f808cf1$export$89db4734f6c919c4(event, options) {
    return {
        to: options ? options.to : undefined,
        type: (0, $kWOvn.send),
        event: (0, $1Rgbm.isFunction)(event) ? event : (0, $1Rgbm.toEventObject)(event),
        delay: options ? options.delay : undefined,
        id: options && options.id !== undefined ? options.id : (0, $1Rgbm.isFunction)(event) ? event.name : (0, $1Rgbm.getEventType)(event)
    };
}
function $5a6770ca7f808cf1$export$f43e8cbb721d72d5(action, ctx, _event, delaysMap) {
    var meta = {
        _event: _event
    }; // TODO: helper function for resolving Expr
    var resolvedEvent = (0, $1Rgbm.toSCXMLEvent)((0, $1Rgbm.isFunction)(action.event) ? action.event(ctx, _event.data, meta) : action.event);
    var resolvedDelay;
    if ((0, $1Rgbm.isString)(action.delay)) {
        var configDelay = delaysMap && delaysMap[action.delay];
        resolvedDelay = (0, $1Rgbm.isFunction)(configDelay) ? configDelay(ctx, _event.data, meta) : configDelay;
    } else resolvedDelay = (0, $1Rgbm.isFunction)(action.delay) ? action.delay(ctx, _event.data, meta) : action.delay;
    var resolvedTarget = (0, $1Rgbm.isFunction)(action.to) ? action.to(ctx, _event.data, meta) : action.to;
    return (0, $iRfl8.__assign)((0, $iRfl8.__assign)({}, action), {
        to: resolvedTarget,
        _event: resolvedEvent,
        event: resolvedEvent.data,
        delay: resolvedDelay
    });
}
/**
 * Sends an event to this machine's parent.
 *
 * @param event The event to send to the parent machine.
 * @param options Options to pass into the send event.
 */ function $5a6770ca7f808cf1$export$408d8d51fa351f53(event, options) {
    return $5a6770ca7f808cf1$export$89db4734f6c919c4(event, (0, $iRfl8.__assign)((0, $iRfl8.__assign)({}, options), {
        to: (0, $av07t.SpecialTargets).Parent
    }));
}
/**
 * Sends an update event to this machine's parent.
 */ function $5a6770ca7f808cf1$export$7f8b724299523eb6() {
    return $5a6770ca7f808cf1$export$408d8d51fa351f53((0, $kWOvn.update));
}
/**
 * Sends an event back to the sender of the original event.
 *
 * @param event The event to send back to the sender
 * @param options Options to pass into the send event
 */ function $5a6770ca7f808cf1$export$72b816ae90496f19(event, options) {
    return $5a6770ca7f808cf1$export$89db4734f6c919c4(event, (0, $iRfl8.__assign)((0, $iRfl8.__assign)({}, options), {
        to: function(_, __, _a) {
            var _event = _a._event;
            return _event.origin; // TODO: handle when _event.origin is undefined
        }
    }));
}
var $5a6770ca7f808cf1$var$defaultLogExpr = function(context, event) {
    return {
        context: context,
        event: event
    };
};
/**
 *
 * @param expr The expression function to evaluate which will be logged.
 *  Takes in 2 arguments:
 *  - `ctx` - the current state context
 *  - `event` - the event that caused this action to be executed.
 * @param label The label to give to the logged expression.
 */ function $5a6770ca7f808cf1$export$bef1f36f5486a6a3(expr, label) {
    if (expr === void 0) expr = $5a6770ca7f808cf1$var$defaultLogExpr;
    return {
        type: (0, $kWOvn.log),
        label: label,
        expr: expr
    };
}
var $5a6770ca7f808cf1$export$12cba28d36be4946 = function(action, ctx, _event) {
    return (0, $iRfl8.__assign)((0, $iRfl8.__assign)({}, action), {
        value: (0, $1Rgbm.isString)(action.expr) ? action.expr : action.expr(ctx, _event.data, {
            _event: _event
        })
    });
};
/**
 * Cancels an in-flight `send(...)` action. A canceled sent action will not
 * be executed, nor will its event be sent, unless it has already been sent
 * (e.g., if `cancel(...)` is called after the `send(...)` action's `delay`).
 *
 * @param sendId The `id` of the `send(...)` action to cancel.
 */ var $5a6770ca7f808cf1$export$70b61ad426ddbe54 = function(sendId) {
    return {
        type: (0, $kWOvn.cancel),
        sendId: sendId
    };
};
/**
 * Starts an activity.
 *
 * @param activity The activity to start.
 */ function $5a6770ca7f808cf1$export$b3571188c770cc5a(activity) {
    var activityDef = $5a6770ca7f808cf1$export$e81fdd8937d44864(activity);
    return {
        type: (0, $av07t.ActionTypes).Start,
        activity: activityDef,
        exec: undefined
    };
}
/**
 * Stops an activity.
 *
 * @param actorRef The activity to stop.
 */ function $5a6770ca7f808cf1$export$fa6813432f753b0d(actorRef) {
    var activity = (0, $1Rgbm.isFunction)(actorRef) ? actorRef : $5a6770ca7f808cf1$export$e81fdd8937d44864(actorRef);
    return {
        type: (0, $av07t.ActionTypes).Stop,
        activity: activity,
        exec: undefined
    };
}
function $5a6770ca7f808cf1$export$21aa461f4eb8e82(action, context, _event) {
    var actorRefOrString = (0, $1Rgbm.isFunction)(action.activity) ? action.activity(context, _event.data) : action.activity;
    var resolvedActorRef = typeof actorRefOrString === 'string' ? {
        id: actorRefOrString
    } : actorRefOrString;
    var actionObject = {
        type: (0, $av07t.ActionTypes).Stop,
        activity: resolvedActorRef
    };
    return actionObject;
}
/**
 * Updates the current context of the machine.
 *
 * @param assignment An object that represents the partial context to update.
 */ var $5a6770ca7f808cf1$export$e6e34fd1f2686227 = function(assignment) {
    return {
        type: (0, $kWOvn.assign),
        assignment: assignment
    };
};
/**
 * Returns an event type that represents an implicit event that
 * is sent after the specified `delay`.
 *
 * @param delayRef The delay in milliseconds
 * @param id The state node ID where this event is handled
 */ function $5a6770ca7f808cf1$export$742acabee3dd6465(delayRef, id) {
    var idSuffix = id ? "#" + id : '';
    return (0, $av07t.ActionTypes).After + "(" + delayRef + ")" + idSuffix;
}
/**
 * Returns an event that represents that a final state node
 * has been reached in the parent state node.
 *
 * @param id The final state node's parent state node `id`
 * @param data The data to pass into the event
 */ function $5a6770ca7f808cf1$export$3df11c9c20e7b288(id, data) {
    var type = (0, $av07t.ActionTypes).DoneState + "." + id;
    var eventObject = {
        type: type,
        data: data
    };
    eventObject.toString = function() {
        return type;
    };
    return eventObject;
}
/**
 * Returns an event that represents that an invoked service has terminated.
 *
 * An invoked service is terminated when it has reached a top-level final state node,
 * but not when it is canceled.
 *
 * @param id The final state node ID
 * @param data The data to pass into the event
 */ function $5a6770ca7f808cf1$export$c105e588793f70b4(id, data) {
    var type = (0, $av07t.ActionTypes).DoneInvoke + "." + id;
    var eventObject = {
        type: type,
        data: data
    };
    eventObject.toString = function() {
        return type;
    };
    return eventObject;
}
function $5a6770ca7f808cf1$export$a3bc9b8ed74fc(id, data) {
    var type = (0, $av07t.ActionTypes).ErrorPlatform + "." + id;
    var eventObject = {
        type: type,
        data: data
    };
    eventObject.toString = function() {
        return type;
    };
    return eventObject;
}
function $5a6770ca7f808cf1$export$48ec4a2b1cfc6557(getActions) {
    return {
        type: (0, $av07t.ActionTypes).Pure,
        get: getActions
    };
}
/**
 * Forwards (sends) an event to a specified service.
 *
 * @param target The target service to forward the event to.
 * @param options Options to pass into the send action creator.
 */ function $5a6770ca7f808cf1$export$eb147b7589db8e8a(target, options) {
    return $5a6770ca7f808cf1$export$89db4734f6c919c4(function(_, event) {
        return event;
    }, (0, $iRfl8.__assign)((0, $iRfl8.__assign)({}, options), {
        to: target
    }));
}
/**
 * Escalates an error by sending it as an event to this machine's parent.
 *
 * @param errorData The error data to send, or the expression function that
 * takes in the `context`, `event`, and `meta`, and returns the error data to send.
 * @param options Options to pass into the send action creator.
 */ function $5a6770ca7f808cf1$export$f514678a4137c4d6(errorData, options) {
    return $5a6770ca7f808cf1$export$408d8d51fa351f53(function(context, event, meta) {
        return {
            type: (0, $kWOvn.error),
            data: (0, $1Rgbm.isFunction)(errorData) ? errorData(context, event, meta) : errorData
        };
    }, (0, $iRfl8.__assign)((0, $iRfl8.__assign)({}, options), {
        to: (0, $av07t.SpecialTargets).Parent
    }));
}
function $5a6770ca7f808cf1$export$7877a478dd30fd3d(conds) {
    return {
        type: (0, $av07t.ActionTypes).Choose,
        conds: conds
    };
}
function $5a6770ca7f808cf1$export$b8b9e7ba5b8c7b3e(machine, currentState, currentContext, _event, actions) {
    var _a = (0, $iRfl8.__read)((0, $1Rgbm.partition)(actions, function(action) {
        return action.type === (0, $kWOvn.assign);
    }), 2), assignActions = _a[0], otherActions = _a[1];
    var updatedContext = assignActions.length ? (0, $1Rgbm.updateContext)(currentContext, _event, assignActions, currentState) : currentContext;
    var resolvedActions = (0, $1Rgbm.flatten)(otherActions.map(function(actionObject) {
        var _a;
        switch(actionObject.type){
            case 0, $kWOvn.raise:
                return $5a6770ca7f808cf1$export$ed3daf8e935ede01(actionObject);
            case 0, $kWOvn.send:
                var sendAction = $5a6770ca7f808cf1$export$f43e8cbb721d72d5(actionObject, updatedContext, _event, machine.options.delays); // TODO: fix ActionTypes.Init
                if (!(0, $2vepS.IS_PRODUCTION)) // warn after resolving as we can create better contextual message here
                (0, $1Rgbm.warn)(!(0, $1Rgbm.isString)(actionObject.delay) || typeof sendAction.delay === 'number', "No delay reference for delay expression '" + actionObject.delay + "' was found on machine '" + machine.id + "'");
                return sendAction;
            case 0, $kWOvn.log:
                return $5a6770ca7f808cf1$export$12cba28d36be4946(actionObject, updatedContext, _event);
            case 0, $kWOvn.choose:
                var chooseAction = actionObject;
                var matchedActions = (_a = chooseAction.conds.find(function(condition) {
                    var guard = (0, $1Rgbm.toGuard)(condition.cond, machine.options.guards);
                    return !guard || (0, $1Rgbm.evaluateGuard)(machine, guard, updatedContext, _event, currentState);
                })) === null || _a === void 0 ? void 0 : _a.actions;
                if (!matchedActions) return [];
                var resolved = $5a6770ca7f808cf1$export$b8b9e7ba5b8c7b3e(machine, currentState, updatedContext, _event, $5a6770ca7f808cf1$export$aa68691f32e6c459((0, $1Rgbm.toArray)(matchedActions), machine.options.actions));
                updatedContext = resolved[1];
                return resolved[0];
            case 0, $kWOvn.pure:
                var matchedActions = actionObject.get(updatedContext, _event.data);
                if (!matchedActions) return [];
                var resolved = $5a6770ca7f808cf1$export$b8b9e7ba5b8c7b3e(machine, currentState, updatedContext, _event, $5a6770ca7f808cf1$export$aa68691f32e6c459((0, $1Rgbm.toArray)(matchedActions), machine.options.actions));
                updatedContext = resolved[1];
                return resolved[0];
            case 0, $kWOvn.stop:
                return $5a6770ca7f808cf1$export$21aa461f4eb8e82(actionObject, updatedContext, _event);
            default:
                return $5a6770ca7f808cf1$export$b38b66cc2da3ede7(actionObject, machine.options.actions);
        }
    }));
    return [
        resolvedActions,
        updatedContext
    ];
}

});
parcelRegister("av07t", function(module, exports) {

$parcel$export(module.exports, "ActionTypes", () => $7a4ce4648167f738$export$1385d81a6c6bbcd4);
$parcel$export(module.exports, "SpecialTargets", () => $7a4ce4648167f738$export$79f5baa747fbdd45);
var $7a4ce4648167f738$export$1385d81a6c6bbcd4;
(function(ActionTypes) {
    ActionTypes["Start"] = "xstate.start";
    ActionTypes["Stop"] = "xstate.stop";
    ActionTypes["Raise"] = "xstate.raise";
    ActionTypes["Send"] = "xstate.send";
    ActionTypes["Cancel"] = "xstate.cancel";
    ActionTypes["NullEvent"] = "";
    ActionTypes["Assign"] = "xstate.assign";
    ActionTypes["After"] = "xstate.after";
    ActionTypes["DoneState"] = "done.state";
    ActionTypes["DoneInvoke"] = "done.invoke";
    ActionTypes["Log"] = "xstate.log";
    ActionTypes["Init"] = "xstate.init";
    ActionTypes["Invoke"] = "xstate.invoke";
    ActionTypes["ErrorExecution"] = "error.execution";
    ActionTypes["ErrorCommunication"] = "error.communication";
    ActionTypes["ErrorPlatform"] = "error.platform";
    ActionTypes["ErrorCustom"] = "xstate.error";
    ActionTypes["Update"] = "xstate.update";
    ActionTypes["Pure"] = "xstate.pure";
    ActionTypes["Choose"] = "xstate.choose";
})($7a4ce4648167f738$export$1385d81a6c6bbcd4 || ($7a4ce4648167f738$export$1385d81a6c6bbcd4 = {}));
var $7a4ce4648167f738$export$79f5baa747fbdd45;
(function(SpecialTargets) {
    SpecialTargets["Parent"] = "#_parent";
    SpecialTargets["Internal"] = "#_internal";
})($7a4ce4648167f738$export$79f5baa747fbdd45 || ($7a4ce4648167f738$export$79f5baa747fbdd45 = {}));

});

parcelRegister("kWOvn", function(module, exports) {

$parcel$export(module.exports, "start", () => $f40066b4a34fd2e7$export$b3571188c770cc5a);
$parcel$export(module.exports, "stop", () => $f40066b4a34fd2e7$export$fa6813432f753b0d);
$parcel$export(module.exports, "raise", () => $f40066b4a34fd2e7$export$66313c302b2ea154);
$parcel$export(module.exports, "send", () => $f40066b4a34fd2e7$export$89db4734f6c919c4);
$parcel$export(module.exports, "cancel", () => $f40066b4a34fd2e7$export$70b61ad426ddbe54);
$parcel$export(module.exports, "nullEvent", () => $f40066b4a34fd2e7$export$9477ceca5dcd796a);
$parcel$export(module.exports, "assign", () => $f40066b4a34fd2e7$export$e6e34fd1f2686227);
$parcel$export(module.exports, "log", () => $f40066b4a34fd2e7$export$bef1f36f5486a6a3);
$parcel$export(module.exports, "init", () => $f40066b4a34fd2e7$export$2cd8252107eb640b);
$parcel$export(module.exports, "invoke", () => $f40066b4a34fd2e7$export$468cda29b159ee5d);
$parcel$export(module.exports, "errorPlatform", () => $f40066b4a34fd2e7$export$503a23d0e5cd1226);
$parcel$export(module.exports, "error", () => $f40066b4a34fd2e7$export$a3bc9b8ed74fc);
$parcel$export(module.exports, "update", () => $f40066b4a34fd2e7$export$722fbec263ad908a);
$parcel$export(module.exports, "choose", () => $f40066b4a34fd2e7$export$7877a478dd30fd3d);
$parcel$export(module.exports, "pure", () => $f40066b4a34fd2e7$export$48ec4a2b1cfc6557);

var $av07t = parcelRequire("av07t");
var $f40066b4a34fd2e7$export$b3571188c770cc5a = (0, $av07t.ActionTypes).Start;
var $f40066b4a34fd2e7$export$fa6813432f753b0d = (0, $av07t.ActionTypes).Stop;
var $f40066b4a34fd2e7$export$66313c302b2ea154 = (0, $av07t.ActionTypes).Raise;
var $f40066b4a34fd2e7$export$89db4734f6c919c4 = (0, $av07t.ActionTypes).Send;
var $f40066b4a34fd2e7$export$70b61ad426ddbe54 = (0, $av07t.ActionTypes).Cancel;
var $f40066b4a34fd2e7$export$9477ceca5dcd796a = (0, $av07t.ActionTypes).NullEvent;
var $f40066b4a34fd2e7$export$e6e34fd1f2686227 = (0, $av07t.ActionTypes).Assign;
var $f40066b4a34fd2e7$export$742acabee3dd6465 = (0, $av07t.ActionTypes).After;
var $f40066b4a34fd2e7$export$de2557b5933c9ac6 = (0, $av07t.ActionTypes).DoneState;
var $f40066b4a34fd2e7$export$bef1f36f5486a6a3 = (0, $av07t.ActionTypes).Log;
var $f40066b4a34fd2e7$export$2cd8252107eb640b = (0, $av07t.ActionTypes).Init;
var $f40066b4a34fd2e7$export$468cda29b159ee5d = (0, $av07t.ActionTypes).Invoke;
var $f40066b4a34fd2e7$export$aca059ee6fbf94e8 = (0, $av07t.ActionTypes).ErrorExecution;
var $f40066b4a34fd2e7$export$503a23d0e5cd1226 = (0, $av07t.ActionTypes).ErrorPlatform;
var $f40066b4a34fd2e7$export$a3bc9b8ed74fc = (0, $av07t.ActionTypes).ErrorCustom;
var $f40066b4a34fd2e7$export$722fbec263ad908a = (0, $av07t.ActionTypes).Update;
var $f40066b4a34fd2e7$export$7877a478dd30fd3d = (0, $av07t.ActionTypes).Choose;
var $f40066b4a34fd2e7$export$48ec4a2b1cfc6557 = (0, $av07t.ActionTypes).Pure;

});



parcelRegister("XJXVw", function(module, exports) {

$parcel$export(module.exports, "ReactEffectType", () => $0b392a9b2b31186d$export$ce678d4420306bda);
var $0b392a9b2b31186d$export$ce678d4420306bda;
(function(ReactEffectType) {
    ReactEffectType[ReactEffectType["Effect"] = 1] = "Effect";
    ReactEffectType[ReactEffectType["LayoutEffect"] = 2] = "LayoutEffect";
})($0b392a9b2b31186d$export$ce678d4420306bda || ($0b392a9b2b31186d$export$ce678d4420306bda = {}));

});

parcelRegister("j1P2b", function(module, exports) {

$parcel$export(module.exports, "useInterpret", () => $dda5b2a7c2c8ef4d$export$d9e9b060fbbae528);
parcelRequire("eUqFw");

var $k286k = parcelRequire("k286k");

var $a4kch = parcelRequire("a4kch");
var $cqUHI = parcelRequire("cqUHI");

var $8Rv1C = parcelRequire("8Rv1C");

var $7Im09 = parcelRequire("7Im09");

var $bFiQl = parcelRequire("bFiQl");
var $dda5b2a7c2c8ef4d$var$__assign = undefined && undefined.__assign || function() {
    $dda5b2a7c2c8ef4d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $dda5b2a7c2c8ef4d$var$__assign.apply(this, arguments);
};
var $dda5b2a7c2c8ef4d$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $dda5b2a7c2c8ef4d$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
function $dda5b2a7c2c8ef4d$export$d9e9b060fbbae528(getMachine, options, observerOrListener) {
    if (options === void 0) options = {};
    var machine = (0, $7Im09.default)(function() {
        return typeof getMachine === 'function' ? getMachine() : getMachine;
    });
    var _a, initialMachine;
    var context = options.context, guards = options.guards, actions = options.actions, activities = options.activities, services = options.services, delays = options.delays, rehydratedState = options.state, interpreterOptions = $dda5b2a7c2c8ef4d$var$__rest(options, [
        "context",
        "guards",
        "actions",
        "activities",
        "services",
        "delays",
        "state"
    ]);
    var service = (0, $7Im09.default)(function() {
        var machineConfig = {
            context: context,
            guards: guards,
            actions: actions,
            activities: activities,
            services: services,
            delays: delays
        };
        var machineWithConfig = machine.withConfig(machineConfig, $dda5b2a7c2c8ef4d$var$__assign($dda5b2a7c2c8ef4d$var$__assign({}, machine.context), context));
        return (0, $a4kch.interpret)(machineWithConfig, $dda5b2a7c2c8ef4d$var$__assign({
            deferEvents: true
        }, interpreterOptions));
    });
    (0, $k286k.default)(function() {
        var sub;
        if (observerOrListener) sub = service.subscribe((0, $8Rv1C.toObserver)(observerOrListener));
        return function() {
            sub === null || sub === void 0 || sub.unsubscribe();
        };
    }, [
        observerOrListener
    ]);
    (0, $k286k.default)(function() {
        service.start(rehydratedState ? (0, $cqUHI.State).create(rehydratedState) : undefined);
        return function() {
            service.stop();
        };
    }, []);
    // Make sure actions and services are kept updated when they change.
    // This mutation assignment is safe because the service instance is only used
    // in one place -- this hook's caller.
    (0, $k286k.default)(function() {
        Object.assign(service.machine.options.actions, actions);
    }, [
        actions
    ]);
    (0, $k286k.default)(function() {
        Object.assign(service.machine.options.services, services);
    }, [
        services
    ]);
    (0, $bFiQl.useReactEffectActions)(service);
    return service;
}

});
parcelRegister("a4kch", function(module, exports) {

$parcel$export(module.exports, "interpret", () => $7549f1d61b763570$export$67beed298888a38b);

var $iRfl8 = parcelRequire("iRfl8");

var $2vepS = parcelRequire("2vepS");

var $1Rgbm = parcelRequire("1Rgbm");

var $av07t = parcelRequire("av07t");

var $kUKMl = parcelRequire("kUKMl");

var $kWOvn = parcelRequire("kWOvn");

var $7LdyK = parcelRequire("7LdyK");

var $cqUHI = parcelRequire("cqUHI");

var $5GWYU = parcelRequire("5GWYU");

var $lUBej = parcelRequire("lUBej");

var $bUWgc = parcelRequire("bUWgc");

var $hyaBM = parcelRequire("hyaBM");

var $g1JwA = parcelRequire("g1JwA");
var $7549f1d61b763570$var$DEFAULT_SPAWN_OPTIONS = {
    sync: false,
    autoForward: false
};
var $7549f1d61b763570$export$7a567c9c5088a551;
(function(InterpreterStatus) {
    InterpreterStatus[InterpreterStatus["NotStarted"] = 0] = "NotStarted";
    InterpreterStatus[InterpreterStatus["Running"] = 1] = "Running";
    InterpreterStatus[InterpreterStatus["Stopped"] = 2] = "Stopped";
})($7549f1d61b763570$export$7a567c9c5088a551 || ($7549f1d61b763570$export$7a567c9c5088a551 = {}));
var $7549f1d61b763570$export$e5b52c46a548ff03 = /*#__PURE__*/ /** @class */ function() {
    /**
   * Creates a new Interpreter instance (i.e., service) for the given machine with the provided options, if any.
   *
   * @param machine The machine to be interpreted
   * @param options Interpreter options
   */ function Interpreter(machine, options) {
        var _this = this;
        if (options === void 0) options = Interpreter.defaultOptions;
        this.machine = machine;
        this.scheduler = new (0, $bUWgc.Scheduler)();
        this.delayedEventsMap = {};
        this.listeners = new Set();
        this.contextListeners = new Set();
        this.stopListeners = new Set();
        this.doneListeners = new Set();
        this.eventListeners = new Set();
        this.sendListeners = new Set();
        /**
     * Whether the service is started.
     */ this.initialized = false;
        this.status = $7549f1d61b763570$export$7a567c9c5088a551.NotStarted;
        this.children = new Map();
        this.forwardTo = new Set();
        /**
     * Alias for Interpreter.prototype.start
     */ this.init = this.start;
        /**
     * Sends an event to the running interpreter to trigger a transition.
     *
     * An array of events (batched) can be sent as well, which will send all
     * batched events to the running interpreter. The listeners will be
     * notified only **once** when all events are processed.
     *
     * @param event The event(s) to send
     */ this.send = function(event1, payload) {
            if ((0, $1Rgbm.isArray)(event1)) {
                _this.batch(event1);
                return _this.state;
            }
            var _event = (0, $1Rgbm.toSCXMLEvent)((0, $1Rgbm.toEventObject)(event1, payload));
            if (_this.status === $7549f1d61b763570$export$7a567c9c5088a551.Stopped) {
                // do nothing
                if (!(0, $2vepS.IS_PRODUCTION)) (0, $1Rgbm.warn)(false, "Event \"" + _event.name + "\" was sent to stopped service \"" + _this.machine.id + "\". This service has already reached its final state, and will not transition.\nEvent: " + JSON.stringify(_event.data));
                return _this.state;
            }
            if (_this.status !== $7549f1d61b763570$export$7a567c9c5088a551.Running && !_this.options.deferEvents) throw new Error("Event \"" + _event.name + "\" was sent to uninitialized service \"" + _this.machine.id + "\". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.\nEvent: " + JSON.stringify(_event.data));
            _this.scheduler.schedule(function() {
                // Forward copy of event to child actors
                _this.forward(_event);
                var nextState = _this.nextState(_event);
                _this.update(nextState, _event);
            });
            return _this._state; // TODO: deprecate (should return void)
        // tslint:disable-next-line:semicolon
        };
        this.sendTo = function(event1, to) {
            var isParent = _this.parent && (to === (0, $av07t.SpecialTargets).Parent || _this.parent.id === to);
            var target = isParent ? _this.parent : (0, $1Rgbm.isString)(to) ? _this.children.get(to) || (0, $hyaBM.registry).get(to) : (0, $1Rgbm.isActor)(to) ? to : undefined;
            if (!target) {
                if (!isParent) throw new Error("Unable to send event to child '" + to + "' from service '" + _this.id + "'.");
                 // tslint:disable-next-line:no-console
                if (!(0, $2vepS.IS_PRODUCTION)) (0, $1Rgbm.warn)(false, "Service '" + _this.id + "' has no parent: unable to send event " + event1.type);
                return;
            }
            if ('machine' in target) // Send SCXML events to machines
            target.send((0, $iRfl8.__assign)((0, $iRfl8.__assign)({}, event1), {
                name: event1.name === (0, $kWOvn.error) ? "" + (0, $7LdyK.error)(_this.id) : event1.name,
                origin: _this.sessionId
            }));
            else // Send normal events to other targets
            target.send(event1.data);
        };
        var resolvedOptions = (0, $iRfl8.__assign)((0, $iRfl8.__assign)({}, Interpreter.defaultOptions), options);
        var clock = resolvedOptions.clock, logger = resolvedOptions.logger, parent = resolvedOptions.parent, id = resolvedOptions.id;
        var resolvedId = id !== undefined ? id : machine.id;
        this.id = resolvedId;
        this.logger = logger;
        this.clock = clock;
        this.parent = parent;
        this.options = resolvedOptions;
        this.scheduler = new (0, $bUWgc.Scheduler)({
            deferEvents: this.options.deferEvents
        });
        this.sessionId = (0, $hyaBM.registry).bookId();
    }
    Object.defineProperty(Interpreter.prototype, "initialState", {
        get: function() {
            var _this = this;
            if (this._initialState) return this._initialState;
            return (0, $5GWYU.provide)(this, function() {
                _this._initialState = _this.machine.initialState;
                return _this._initialState;
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Interpreter.prototype, "state", {
        get: function() {
            if (!(0, $2vepS.IS_PRODUCTION)) (0, $1Rgbm.warn)(this.status !== $7549f1d61b763570$export$7a567c9c5088a551.NotStarted, "Attempted to read state from uninitialized service '" + this.id + "'. Make sure the service is started first.");
            return this._state;
        },
        enumerable: false,
        configurable: true
    });
    /**
   * Executes the actions of the given state, with that state's `context` and `event`.
   *
   * @param state The state whose actions will be executed
   * @param actionsConfig The action implementations to use
   */ Interpreter.prototype.execute = function(state, actionsConfig) {
        var e_1, _a;
        try {
            for(var _b = (0, $iRfl8.__values)(state.actions), _c = _b.next(); !_c.done; _c = _b.next()){
                var action = _c.value;
                this.exec(action, state, actionsConfig);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    Interpreter.prototype.update = function(state, _event) {
        var e_2, _a, e_3, _b, e_4, _c, e_5, _d;
        var _this = this; // Attach session ID to state
        state._sessionid = this.sessionId; // Update state
        this._state = state; // Execute actions
        if (this.options.execute) this.execute(this.state);
         // Update children
        this.children.forEach(function(child) {
            _this.state.children[child.id] = child;
        }); // Dev tools
        if (this.devTools) this.devTools.send(_event.data, state);
         // Execute listeners
        if (state.event) try {
            for(var _e = (0, $iRfl8.__values)(this.eventListeners), _f = _e.next(); !_f.done; _f = _e.next()){
                var listener = _f.value;
                listener(state.event);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        try {
            for(var _g = (0, $iRfl8.__values)(this.listeners), _h = _g.next(); !_h.done; _h = _g.next()){
                var listener = _h.value;
                listener(state, state.event);
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        try {
            for(var _j = (0, $iRfl8.__values)(this.contextListeners), _k = _j.next(); !_k.done; _k = _j.next()){
                var contextListener = _k.value;
                contextListener(this.state.context, this.state.history ? this.state.history.context : undefined);
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (_k && !_k.done && (_c = _j.return)) _c.call(_j);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        var isDone = (0, $kUKMl.isInFinalState)(state.configuration || [], this.machine);
        if (this.state.configuration && isDone) {
            // get final child state node
            var finalChildStateNode = state.configuration.find(function(sn) {
                return sn.type === 'final' && sn.parent === _this.machine;
            });
            var doneData = finalChildStateNode && finalChildStateNode.doneData ? (0, $1Rgbm.mapContext)(finalChildStateNode.doneData, state.context, _event) : undefined;
            try {
                for(var _l = (0, $iRfl8.__values)(this.doneListeners), _m = _l.next(); !_m.done; _m = _l.next()){
                    var listener = _m.value;
                    listener((0, $7LdyK.doneInvoke)(this.id, doneData));
                }
            } catch (e_5_1) {
                e_5 = {
                    error: e_5_1
                };
            } finally{
                try {
                    if (_m && !_m.done && (_d = _l.return)) _d.call(_l);
                } finally{
                    if (e_5) throw e_5.error;
                }
            }
            this.stop();
        }
    };
    /*
   * Adds a listener that is notified whenever a state transition happens. The listener is called with
   * the next state and the event object that caused the state transition.
   *
   * @param listener The state listener
   */ Interpreter.prototype.onTransition = function(listener) {
        this.listeners.add(listener); // Send current state to listener
        if (this.status === $7549f1d61b763570$export$7a567c9c5088a551.Running) listener(this.state, this.state.event);
        return this;
    };
    Interpreter.prototype.subscribe = function(nextListenerOrObserver, _, completeListener) {
        var _this = this;
        if (!nextListenerOrObserver) return {
            unsubscribe: function() {
                return void 0;
            }
        };
        var listener;
        var resolvedCompleteListener = completeListener;
        if (typeof nextListenerOrObserver === 'function') listener = nextListenerOrObserver;
        else {
            listener = nextListenerOrObserver.next.bind(nextListenerOrObserver);
            resolvedCompleteListener = nextListenerOrObserver.complete.bind(nextListenerOrObserver);
        }
        this.listeners.add(listener); // Send current state to listener
        if (this.status === $7549f1d61b763570$export$7a567c9c5088a551.Running) listener(this.state);
        if (resolvedCompleteListener) this.onDone(resolvedCompleteListener);
        return {
            unsubscribe: function() {
                listener && _this.listeners.delete(listener);
                resolvedCompleteListener && _this.doneListeners.delete(resolvedCompleteListener);
            }
        };
    };
    /**
   * Adds an event listener that is notified whenever an event is sent to the running interpreter.
   * @param listener The event listener
   */ Interpreter.prototype.onEvent = function(listener) {
        this.eventListeners.add(listener);
        return this;
    };
    /**
   * Adds an event listener that is notified whenever a `send` event occurs.
   * @param listener The event listener
   */ Interpreter.prototype.onSend = function(listener) {
        this.sendListeners.add(listener);
        return this;
    };
    /**
   * Adds a context listener that is notified whenever the state context changes.
   * @param listener The context listener
   */ Interpreter.prototype.onChange = function(listener) {
        this.contextListeners.add(listener);
        return this;
    };
    /**
   * Adds a listener that is notified when the machine is stopped.
   * @param listener The listener
   */ Interpreter.prototype.onStop = function(listener) {
        this.stopListeners.add(listener);
        return this;
    };
    /**
   * Adds a state listener that is notified when the statechart has reached its final state.
   * @param listener The state listener
   */ Interpreter.prototype.onDone = function(listener) {
        this.doneListeners.add(listener);
        return this;
    };
    /**
   * Removes a listener.
   * @param listener The listener to remove
   */ Interpreter.prototype.off = function(listener) {
        this.listeners.delete(listener);
        this.eventListeners.delete(listener);
        this.sendListeners.delete(listener);
        this.stopListeners.delete(listener);
        this.doneListeners.delete(listener);
        this.contextListeners.delete(listener);
        return this;
    };
    /**
   * Starts the interpreter from the given state, or the initial state.
   * @param initialState The state to start the statechart from
   */ Interpreter.prototype.start = function(initialState) {
        var _this = this;
        if (this.status === $7549f1d61b763570$export$7a567c9c5088a551.Running) // Do not restart the service if it is already started
        return this;
        (0, $hyaBM.registry).register(this.sessionId, this);
        this.initialized = true;
        this.status = $7549f1d61b763570$export$7a567c9c5088a551.Running;
        var resolvedState = initialState === undefined ? this.initialState : (0, $5GWYU.provide)(this, function() {
            return (0, $cqUHI.isState)(initialState) ? _this.machine.resolveState(initialState) : _this.machine.resolveState((0, $cqUHI.State).from(initialState, _this.machine.context));
        });
        if (this.options.devTools) this.attachDev();
        this.scheduler.initialize(function() {
            _this.update(resolvedState, (0, $7LdyK.initEvent));
        });
        return this;
    };
    /**
   * Stops the interpreter and unsubscribe all listeners.
   *
   * This will also notify the `onStop` listeners.
   */ Interpreter.prototype.stop = function() {
        var e_6, _a, e_7, _b, e_8, _c, e_9, _d, e_10, _e;
        var _this = this;
        try {
            for(var _f = (0, $iRfl8.__values)(this.listeners), _g = _f.next(); !_g.done; _g = _f.next()){
                var listener = _g.value;
                this.listeners.delete(listener);
            }
        } catch (e_6_1) {
            e_6 = {
                error: e_6_1
            };
        } finally{
            try {
                if (_g && !_g.done && (_a = _f.return)) _a.call(_f);
            } finally{
                if (e_6) throw e_6.error;
            }
        }
        try {
            for(var _h = (0, $iRfl8.__values)(this.stopListeners), _j = _h.next(); !_j.done; _j = _h.next()){
                var listener = _j.value; // call listener, then remove
                listener();
                this.stopListeners.delete(listener);
            }
        } catch (e_7_1) {
            e_7 = {
                error: e_7_1
            };
        } finally{
            try {
                if (_j && !_j.done && (_b = _h.return)) _b.call(_h);
            } finally{
                if (e_7) throw e_7.error;
            }
        }
        try {
            for(var _k = (0, $iRfl8.__values)(this.contextListeners), _l = _k.next(); !_l.done; _l = _k.next()){
                var listener = _l.value;
                this.contextListeners.delete(listener);
            }
        } catch (e_8_1) {
            e_8 = {
                error: e_8_1
            };
        } finally{
            try {
                if (_l && !_l.done && (_c = _k.return)) _c.call(_k);
            } finally{
                if (e_8) throw e_8.error;
            }
        }
        try {
            for(var _m = (0, $iRfl8.__values)(this.doneListeners), _o = _m.next(); !_o.done; _o = _m.next()){
                var listener = _o.value;
                this.doneListeners.delete(listener);
            }
        } catch (e_9_1) {
            e_9 = {
                error: e_9_1
            };
        } finally{
            try {
                if (_o && !_o.done && (_d = _m.return)) _d.call(_m);
            } finally{
                if (e_9) throw e_9.error;
            }
        }
        if (!this.initialized) // Interpreter already stopped; do nothing
        return this;
        this.state.configuration.forEach(function(stateNode) {
            var e_11, _a;
            try {
                for(var _b = (0, $iRfl8.__values)(stateNode.definition.exit), _c = _b.next(); !_c.done; _c = _b.next()){
                    var action = _c.value;
                    _this.exec(action, _this.state);
                }
            } catch (e_11_1) {
                e_11 = {
                    error: e_11_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_11) throw e_11.error;
                }
            }
        }); // Stop all children
        this.children.forEach(function(child) {
            if ((0, $1Rgbm.isFunction)(child.stop)) child.stop();
        });
        try {
            // Cancel all delayed events
            for(var _p = (0, $iRfl8.__values)((0, $1Rgbm.keys)(this.delayedEventsMap)), _q = _p.next(); !_q.done; _q = _p.next()){
                var key = _q.value;
                this.clock.clearTimeout(this.delayedEventsMap[key]);
            }
        } catch (e_10_1) {
            e_10 = {
                error: e_10_1
            };
        } finally{
            try {
                if (_q && !_q.done && (_e = _p.return)) _e.call(_p);
            } finally{
                if (e_10) throw e_10.error;
            }
        }
        this.scheduler.clear();
        this.initialized = false;
        this.status = $7549f1d61b763570$export$7a567c9c5088a551.Stopped;
        (0, $hyaBM.registry).free(this.sessionId);
        return this;
    };
    Interpreter.prototype.batch = function(events) {
        var _this = this;
        if (this.status === $7549f1d61b763570$export$7a567c9c5088a551.NotStarted && this.options.deferEvents) // tslint:disable-next-line:no-console
        {
            if (!(0, $2vepS.IS_PRODUCTION)) (0, $1Rgbm.warn)(false, events.length + " event(s) were sent to uninitialized service \"" + this.machine.id + "\" and are deferred. Make sure .start() is called for this service.\nEvent: " + JSON.stringify(event));
        } else if (this.status !== $7549f1d61b763570$export$7a567c9c5088a551.Running) throw new Error(events.length + " event(s) were sent to uninitialized service \"" + this.machine.id + "\". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.");
        this.scheduler.schedule(function() {
            var e_12, _a;
            var nextState = _this.state;
            var batchChanged = false;
            var batchedActions = [];
            var _loop_1 = function(event_1) {
                var _event = (0, $1Rgbm.toSCXMLEvent)(event_1);
                _this.forward(_event);
                nextState = (0, $5GWYU.provide)(_this, function() {
                    return _this.machine.transition(nextState, _event);
                });
                batchedActions.push.apply(batchedActions, (0, $iRfl8.__spreadArray)([], (0, $iRfl8.__read)(nextState.actions.map(function(a) {
                    return (0, $cqUHI.bindActionToState)(a, nextState);
                }))));
                batchChanged = batchChanged || !!nextState.changed;
            };
            try {
                for(var events_1 = (0, $iRfl8.__values)(events), events_1_1 = events_1.next(); !events_1_1.done; events_1_1 = events_1.next()){
                    var event_1 = events_1_1.value;
                    _loop_1(event_1);
                }
            } catch (e_12_1) {
                e_12 = {
                    error: e_12_1
                };
            } finally{
                try {
                    if (events_1_1 && !events_1_1.done && (_a = events_1.return)) _a.call(events_1);
                } finally{
                    if (e_12) throw e_12.error;
                }
            }
            nextState.changed = batchChanged;
            nextState.actions = batchedActions;
            _this.update(nextState, (0, $1Rgbm.toSCXMLEvent)(events[events.length - 1]));
        });
    };
    /**
   * Returns a send function bound to this interpreter instance.
   *
   * @param event The event to be sent by the sender.
   */ Interpreter.prototype.sender = function(event1) {
        return this.send.bind(this, event1);
    };
    /**
   * Returns the next state given the interpreter's current state and the event.
   *
   * This is a pure method that does _not_ update the interpreter's state.
   *
   * @param event The event to determine the next state
   */ Interpreter.prototype.nextState = function(event1) {
        var _this = this;
        var _event = (0, $1Rgbm.toSCXMLEvent)(event1);
        if (_event.name.indexOf((0, $kWOvn.errorPlatform)) === 0 && !this.state.nextEvents.some(function(nextEvent) {
            return nextEvent.indexOf((0, $kWOvn.errorPlatform)) === 0;
        })) throw _event.data.data;
        var nextState = (0, $5GWYU.provide)(this, function() {
            return _this.machine.transition(_this.state, _event);
        });
        return nextState;
    };
    Interpreter.prototype.forward = function(event1) {
        var e_13, _a;
        try {
            for(var _b = (0, $iRfl8.__values)(this.forwardTo), _c = _b.next(); !_c.done; _c = _b.next()){
                var id = _c.value;
                var child = this.children.get(id);
                if (!child) throw new Error("Unable to forward event '" + event1 + "' from interpreter '" + this.id + "' to nonexistant child '" + id + "'.");
                child.send(event1);
            }
        } catch (e_13_1) {
            e_13 = {
                error: e_13_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_13) throw e_13.error;
            }
        }
    };
    Interpreter.prototype.defer = function(sendAction) {
        var _this = this;
        this.delayedEventsMap[sendAction.id] = this.clock.setTimeout(function() {
            if (sendAction.to) _this.sendTo(sendAction._event, sendAction.to);
            else _this.send(sendAction._event);
        }, sendAction.delay);
    };
    Interpreter.prototype.cancel = function(sendId) {
        this.clock.clearTimeout(this.delayedEventsMap[sendId]);
        delete this.delayedEventsMap[sendId];
    };
    Interpreter.prototype.exec = function(action, state, actionFunctionMap) {
        if (actionFunctionMap === void 0) actionFunctionMap = this.machine.options.actions;
        var context = state.context, _event = state._event;
        var actionOrExec = action.exec || (0, $7LdyK.getActionFunction)(action.type, actionFunctionMap);
        var exec = (0, $1Rgbm.isFunction)(actionOrExec) ? actionOrExec : actionOrExec ? actionOrExec.exec : action.exec;
        if (exec) try {
            return exec(context, _event.data, {
                action: action,
                state: this.state,
                _event: _event
            });
        } catch (err) {
            if (this.parent) this.parent.send({
                type: 'xstate.error',
                data: err
            });
            throw err;
        }
        switch(action.type){
            case 0, $kWOvn.send:
                var sendAction = action;
                if (typeof sendAction.delay === 'number') {
                    this.defer(sendAction);
                    return;
                } else if (sendAction.to) this.sendTo(sendAction._event, sendAction.to);
                else this.send(sendAction._event);
                break;
            case 0, $kWOvn.cancel:
                this.cancel(action.sendId);
                break;
            case 0, $kWOvn.start:
                var activity = action.activity; // If the activity will be stopped right after it's started
                // (such as in transient states)
                // don't bother starting the activity.
                if (!this.state.activities[activity.id || activity.type]) break;
                 // Invoked services
                if (activity.type === (0, $av07t.ActionTypes).Invoke) {
                    var invokeSource = (0, $1Rgbm.toInvokeSource)(activity.src);
                    var serviceCreator = this.machine.options.services ? this.machine.options.services[invokeSource.type] : undefined;
                    var id = activity.id, data = activity.data;
                    if (!(0, $2vepS.IS_PRODUCTION)) (0, $1Rgbm.warn)(!('forward' in activity), "`forward` property is deprecated (found in invocation of '" + activity.src + "' in in machine '" + this.machine.id + "'). " + "Please use `autoForward` instead.");
                    var autoForward = 'autoForward' in activity ? activity.autoForward : !!activity.forward;
                    if (!serviceCreator) {
                        // tslint:disable-next-line:no-console
                        if (!(0, $2vepS.IS_PRODUCTION)) (0, $1Rgbm.warn)(false, "No service found for invocation '" + activity.src + "' in machine '" + this.machine.id + "'.");
                        return;
                    }
                    var resolvedData = data ? (0, $1Rgbm.mapContext)(data, context, _event) : undefined;
                    var source = (0, $1Rgbm.isFunction)(serviceCreator) ? serviceCreator(context, _event.data, {
                        data: resolvedData,
                        src: invokeSource
                    }) : serviceCreator;
                    if ((0, $1Rgbm.isPromiseLike)(source)) this.spawnPromise(Promise.resolve(source), id);
                    else if ((0, $1Rgbm.isFunction)(source)) this.spawnCallback(source, id);
                    else if ((0, $1Rgbm.isObservable)(source)) this.spawnObservable(source, id);
                    else if ((0, $1Rgbm.isMachine)(source)) // TODO: try/catch here
                    this.spawnMachine(resolvedData ? source.withContext(resolvedData) : source, {
                        id: id,
                        autoForward: autoForward
                    });
                } else this.spawnActivity(activity);
                break;
            case 0, $kWOvn.stop:
                this.stopChild(action.activity.id);
                break;
            case 0, $kWOvn.log:
                var label = action.label, value = action.value;
                if (label) this.logger(label, value);
                else this.logger(value);
                break;
            default:
                if (!(0, $2vepS.IS_PRODUCTION)) (0, $1Rgbm.warn)(false, "No implementation found for action type '" + action.type + "'");
                break;
        }
        return undefined;
    };
    Interpreter.prototype.removeChild = function(childId) {
        this.children.delete(childId);
        this.forwardTo.delete(childId);
        delete this.state.children[childId];
    };
    Interpreter.prototype.stopChild = function(childId) {
        var child = this.children.get(childId);
        if (!child) return;
        this.removeChild(childId);
        if ((0, $1Rgbm.isFunction)(child.stop)) child.stop();
    };
    Interpreter.prototype.spawn = function(entity, name, options) {
        if ((0, $1Rgbm.isPromiseLike)(entity)) return this.spawnPromise(Promise.resolve(entity), name);
        else if ((0, $1Rgbm.isFunction)(entity)) return this.spawnCallback(entity, name);
        else if ((0, $lUBej.isSpawnedActor)(entity)) return this.spawnActor(entity);
        else if ((0, $1Rgbm.isObservable)(entity)) return this.spawnObservable(entity, name);
        else if ((0, $1Rgbm.isMachine)(entity)) return this.spawnMachine(entity, (0, $iRfl8.__assign)((0, $iRfl8.__assign)({}, options), {
            id: name
        }));
        else throw new Error("Unable to spawn entity \"" + name + "\" of type \"" + typeof entity + "\".");
    };
    Interpreter.prototype.spawnMachine = function(machine, options) {
        var _this = this;
        if (options === void 0) options = {};
        var childService = new Interpreter(machine, (0, $iRfl8.__assign)((0, $iRfl8.__assign)({}, this.options), {
            parent: this,
            id: options.id || machine.id
        }));
        var resolvedOptions = (0, $iRfl8.__assign)((0, $iRfl8.__assign)({}, $7549f1d61b763570$var$DEFAULT_SPAWN_OPTIONS), options);
        if (resolvedOptions.sync) childService.onTransition(function(state) {
            _this.send((0, $kWOvn.update), {
                state: state,
                id: childService.id
            });
        });
        var actor = childService;
        this.children.set(childService.id, actor);
        if (resolvedOptions.autoForward) this.forwardTo.add(childService.id);
        childService.onDone(function(doneEvent) {
            _this.removeChild(childService.id);
            _this.send((0, $1Rgbm.toSCXMLEvent)(doneEvent, {
                origin: childService.id
            }));
        }).start();
        return actor;
    };
    Interpreter.prototype.spawnPromise = function(promise, id) {
        var _this = this;
        var canceled = false;
        var resolvedData = undefined;
        promise.then(function(response) {
            if (!canceled) {
                resolvedData = response;
                _this.removeChild(id);
                _this.send((0, $1Rgbm.toSCXMLEvent)((0, $7LdyK.doneInvoke)(id, response), {
                    origin: id
                }));
            }
        }, function(errorData) {
            if (!canceled) {
                _this.removeChild(id);
                var errorEvent = (0, $7LdyK.error)(id, errorData);
                try {
                    // Send "error.platform.id" to this (parent).
                    _this.send((0, $1Rgbm.toSCXMLEvent)(errorEvent, {
                        origin: id
                    }));
                } catch (error) {
                    (0, $1Rgbm.reportUnhandledExceptionOnInvocation)(errorData, error, id);
                    if (_this.devTools) _this.devTools.send(errorEvent, _this.state);
                    if (_this.machine.strict) // it would be better to always stop the state machine if unhandled
                    // exception/promise rejection happens but because we don't want to
                    // break existing code so enforce it on strict mode only especially so
                    // because documentation says that onError is optional
                    _this.stop();
                }
            }
        });
        var actor = {
            id: id,
            send: function() {
                return void 0;
            },
            subscribe: function(next, handleError, complete) {
                var observer = (0, $1Rgbm.toObserver)(next, handleError, complete);
                var unsubscribed = false;
                promise.then(function(response) {
                    if (unsubscribed) return;
                    observer.next(response);
                    if (unsubscribed) return;
                    observer.complete();
                }, function(err) {
                    if (unsubscribed) return;
                    observer.error(err);
                });
                return {
                    unsubscribe: function() {
                        return unsubscribed = true;
                    }
                };
            },
            stop: function() {
                canceled = true;
            },
            toJSON: function() {
                return {
                    id: id
                };
            },
            getSnapshot: function() {
                return resolvedData;
            }
        };
        this.children.set(id, actor);
        return actor;
    };
    Interpreter.prototype.spawnCallback = function(callback, id) {
        var _this = this;
        var canceled = false;
        var receivers = new Set();
        var listeners = new Set();
        var emitted = undefined;
        var receive = function(e) {
            emitted = e;
            listeners.forEach(function(listener) {
                return listener(e);
            });
            if (canceled) return;
            _this.send((0, $1Rgbm.toSCXMLEvent)(e, {
                origin: id
            }));
        };
        var callbackStop;
        try {
            callbackStop = callback(receive, function(newListener) {
                receivers.add(newListener);
            });
        } catch (err) {
            this.send((0, $7LdyK.error)(id, err));
        }
        if ((0, $1Rgbm.isPromiseLike)(callbackStop)) // it turned out to be an async function, can't reliably check this before calling `callback`
        // because transpiled async functions are not recognizable
        return this.spawnPromise(callbackStop, id);
        var actor = {
            id: id,
            send: function(event1) {
                return receivers.forEach(function(receiver) {
                    return receiver(event1);
                });
            },
            subscribe: function(next) {
                listeners.add(next);
                return {
                    unsubscribe: function() {
                        listeners.delete(next);
                    }
                };
            },
            stop: function() {
                canceled = true;
                if ((0, $1Rgbm.isFunction)(callbackStop)) callbackStop();
            },
            toJSON: function() {
                return {
                    id: id
                };
            },
            getSnapshot: function() {
                return emitted;
            }
        };
        this.children.set(id, actor);
        return actor;
    };
    Interpreter.prototype.spawnObservable = function(source, id) {
        var _this = this;
        var emitted = undefined;
        var subscription = source.subscribe(function(value) {
            emitted = value;
            _this.send((0, $1Rgbm.toSCXMLEvent)(value, {
                origin: id
            }));
        }, function(err) {
            _this.removeChild(id);
            _this.send((0, $1Rgbm.toSCXMLEvent)((0, $7LdyK.error)(id, err), {
                origin: id
            }));
        }, function() {
            _this.removeChild(id);
            _this.send((0, $1Rgbm.toSCXMLEvent)((0, $7LdyK.doneInvoke)(id), {
                origin: id
            }));
        });
        var actor = {
            id: id,
            send: function() {
                return void 0;
            },
            subscribe: function(next, handleError, complete) {
                return source.subscribe(next, handleError, complete);
            },
            stop: function() {
                return subscription.unsubscribe();
            },
            getSnapshot: function() {
                return emitted;
            },
            toJSON: function() {
                return {
                    id: id
                };
            }
        };
        this.children.set(id, actor);
        return actor;
    };
    Interpreter.prototype.spawnActor = function(actor) {
        this.children.set(actor.id, actor);
        return actor;
    };
    Interpreter.prototype.spawnActivity = function(activity) {
        var implementation = this.machine.options && this.machine.options.activities ? this.machine.options.activities[activity.type] : undefined;
        if (!implementation) {
            if (!(0, $2vepS.IS_PRODUCTION)) (0, $1Rgbm.warn)(false, "No implementation found for activity '" + activity.type + "'");
             // tslint:disable-next-line:no-console
            return;
        } // Start implementation
        var dispose = implementation(this.state.context, activity);
        this.spawnEffect(activity.id, dispose);
    };
    Interpreter.prototype.spawnEffect = function(id, dispose) {
        this.children.set(id, {
            id: id,
            send: function() {
                return void 0;
            },
            subscribe: function() {
                return {
                    unsubscribe: function() {
                        return void 0;
                    }
                };
            },
            stop: dispose || undefined,
            getSnapshot: function() {
                return undefined;
            },
            toJSON: function() {
                return {
                    id: id
                };
            }
        });
    };
    Interpreter.prototype.attachDev = function() {
        var global1 = (0, $g1JwA.getGlobal)();
        if (this.options.devTools && global1) {
            if (global1.__REDUX_DEVTOOLS_EXTENSION__) {
                var devToolsOptions = typeof this.options.devTools === 'object' ? this.options.devTools : undefined;
                this.devTools = global1.__REDUX_DEVTOOLS_EXTENSION__.connect((0, $iRfl8.__assign)((0, $iRfl8.__assign)({
                    name: this.id,
                    autoPause: true,
                    stateSanitizer: function(state) {
                        return {
                            value: state.value,
                            context: state.context,
                            actions: state.actions
                        };
                    }
                }, devToolsOptions), {
                    features: (0, $iRfl8.__assign)({
                        jump: false,
                        skip: false
                    }, devToolsOptions ? devToolsOptions.features : undefined)
                }), this.machine);
                this.devTools.init(this.state);
            } // add XState-specific dev tooling hook
            (0, $g1JwA.registerService)(this);
        }
    };
    Interpreter.prototype.toJSON = function() {
        return {
            id: this.id
        };
    };
    Interpreter.prototype[0, $1Rgbm.symbolObservable] = function() {
        return this;
    };
    Interpreter.prototype.getSnapshot = function() {
        return this._state;
    };
    /**
   * The default interpreter options:
   *
   * - `clock` uses the global `setTimeout` and `clearTimeout` functions
   * - `logger` uses the global `console.log()` method
   */ Interpreter.defaultOptions = /*#__PURE__*/ function(global1) {
        return {
            execute: true,
            deferEvents: true,
            clock: {
                setTimeout: function(fn, ms) {
                    return setTimeout(fn, ms);
                },
                clearTimeout: function(id) {
                    return clearTimeout(id);
                }
            },
            logger: global1.console.log.bind(console),
            devTools: false
        };
    }(typeof self !== 'undefined' ? self : $parcel$global);
    Interpreter.interpret = $7549f1d61b763570$export$67beed298888a38b;
    return Interpreter;
}();
var $7549f1d61b763570$var$resolveSpawnOptions = function(nameOrOptions) {
    if ((0, $1Rgbm.isString)(nameOrOptions)) return (0, $iRfl8.__assign)((0, $iRfl8.__assign)({}, $7549f1d61b763570$var$DEFAULT_SPAWN_OPTIONS), {
        name: nameOrOptions
    });
    return (0, $iRfl8.__assign)((0, $iRfl8.__assign)((0, $iRfl8.__assign)({}, $7549f1d61b763570$var$DEFAULT_SPAWN_OPTIONS), {
        name: (0, $1Rgbm.uniqueId)()
    }), nameOrOptions);
};
function $7549f1d61b763570$export$1713f5ac2bf0caf5(entity, nameOrOptions) {
    var resolvedOptions = $7549f1d61b763570$var$resolveSpawnOptions(nameOrOptions);
    return (0, $5GWYU.consume)(function(service) {
        if (!(0, $2vepS.IS_PRODUCTION)) {
            var isLazyEntity = (0, $1Rgbm.isMachine)(entity) || (0, $1Rgbm.isFunction)(entity);
            (0, $1Rgbm.warn)(!!service || isLazyEntity, "Attempted to spawn an Actor (ID: \"" + ((0, $1Rgbm.isMachine)(entity) ? entity.id : 'undefined') + "\") outside of a service. This will have no effect.");
        }
        if (service) return service.spawn(entity, resolvedOptions.name, resolvedOptions);
        else return (0, $lUBej.createDeferredActor)(entity, resolvedOptions.name);
    });
}
/**
 * Creates a new Interpreter instance for the given machine with the provided options, if any.
 *
 * @param machine The machine to interpret
 * @param options Interpreter options
 */ function $7549f1d61b763570$export$67beed298888a38b(machine, options) {
    var interpreter = new $7549f1d61b763570$export$e5b52c46a548ff03(machine, options);
    return interpreter;
}

});
parcelRegister("5GWYU", function(module, exports) {

$parcel$export(module.exports, "provide", () => $424ea07cc9df432f$export$abe1e183e22e10ad);
$parcel$export(module.exports, "consume", () => $424ea07cc9df432f$export$e11e6a155c5c4d9d);
/**
 * Maintains a stack of the current service in scope.
 * This is used to provide the correct service to spawn().
 */ var $424ea07cc9df432f$var$serviceStack = [];
var $424ea07cc9df432f$export$abe1e183e22e10ad = function(service, fn) {
    $424ea07cc9df432f$var$serviceStack.push(service);
    var result = fn(service);
    $424ea07cc9df432f$var$serviceStack.pop();
    return result;
};
var $424ea07cc9df432f$export$e11e6a155c5c4d9d = function(fn) {
    return fn($424ea07cc9df432f$var$serviceStack[$424ea07cc9df432f$var$serviceStack.length - 1]);
};

});

parcelRegister("lUBej", function(module, exports) {

$parcel$export(module.exports, "createInvocableActor", () => $ff3bb5059020d315$export$78b4a98dcb5ac328);
$parcel$export(module.exports, "createDeferredActor", () => $ff3bb5059020d315$export$59bcb51d8e40ed48);
$parcel$export(module.exports, "isSpawnedActor", () => $ff3bb5059020d315$export$b0f989039dc164f9);

var $1Rgbm = parcelRequire("1Rgbm");

var $5GWYU = parcelRequire("5GWYU");
function $ff3bb5059020d315$export$8998449b468dcdad(id) {
    return {
        id: id,
        send: function() {
            return void 0;
        },
        subscribe: function() {
            return {
                unsubscribe: function() {
                    return void 0;
                }
            };
        },
        getSnapshot: function() {
            return undefined;
        },
        toJSON: function() {
            return {
                id: id
            };
        }
    };
}
/**
 * Creates a deferred actor that is able to be invoked given the provided
 * invocation information in its `.meta` value.
 *
 * @param invokeDefinition The meta information needed to invoke the actor.
 */ function $ff3bb5059020d315$export$78b4a98dcb5ac328(invokeDefinition, machine, context, _event) {
    var _a;
    var invokeSrc = (0, $1Rgbm.toInvokeSource)(invokeDefinition.src);
    var serviceCreator = (_a = machine === null || machine === void 0 ? void 0 : machine.options.services) === null || _a === void 0 ? void 0 : _a[invokeSrc.type];
    var resolvedData = invokeDefinition.data ? (0, $1Rgbm.mapContext)(invokeDefinition.data, context, _event) : undefined;
    var tempActor = serviceCreator ? $ff3bb5059020d315$export$59bcb51d8e40ed48(serviceCreator, invokeDefinition.id, resolvedData) : $ff3bb5059020d315$export$8998449b468dcdad(invokeDefinition.id); // @ts-ignore
    tempActor.meta = invokeDefinition;
    return tempActor;
}
function $ff3bb5059020d315$export$59bcb51d8e40ed48(entity, id, data) {
    var tempActor = $ff3bb5059020d315$export$8998449b468dcdad(id); // @ts-ignore
    tempActor.deferred = true;
    if ((0, $1Rgbm.isMachine)(entity)) // "mute" the existing service scope so potential spawned actors within the `.initialState` stay deferred here
    // @ts-ignore
    tempActor.state = (0, $5GWYU.provide)(undefined, function() {
        return (data ? entity.withContext(data) : entity).initialState;
    });
    return tempActor;
}
function $ff3bb5059020d315$export$e769f6913f14f1b7(item) {
    try {
        return typeof item.send === 'function';
    } catch (e) {
        return false;
    }
}
function $ff3bb5059020d315$export$b0f989039dc164f9(item) {
    return $ff3bb5059020d315$export$e769f6913f14f1b7(item) && 'id' in item;
}

});

parcelRegister("bUWgc", function(module, exports) {

$parcel$export(module.exports, "Scheduler", () => $8ad21df80c3bf3df$export$d3e54bb8584cda7c);

var $iRfl8 = parcelRequire("iRfl8");
var $8ad21df80c3bf3df$var$defaultOptions = {
    deferEvents: false
};
var $8ad21df80c3bf3df$export$d3e54bb8584cda7c = /*#__PURE__*/ /** @class */ function() {
    function Scheduler(options) {
        this.processingEvent = false;
        this.queue = [];
        this.initialized = false;
        this.options = (0, $iRfl8.__assign)((0, $iRfl8.__assign)({}, $8ad21df80c3bf3df$var$defaultOptions), options);
    }
    Scheduler.prototype.initialize = function(callback) {
        this.initialized = true;
        if (callback) {
            if (!this.options.deferEvents) {
                this.schedule(callback);
                return;
            }
            this.process(callback);
        }
        this.flushEvents();
    };
    Scheduler.prototype.schedule = function(task) {
        if (!this.initialized || this.processingEvent) {
            this.queue.push(task);
            return;
        }
        if (this.queue.length !== 0) throw new Error('Event queue should be empty when it is not processing events');
        this.process(task);
        this.flushEvents();
    };
    Scheduler.prototype.clear = function() {
        this.queue = [];
    };
    Scheduler.prototype.flushEvents = function() {
        var nextCallback = this.queue.shift();
        while(nextCallback){
            this.process(nextCallback);
            nextCallback = this.queue.shift();
        }
    };
    Scheduler.prototype.process = function(callback) {
        this.processingEvent = true;
        try {
            callback();
        } catch (e) {
            // there is no use to keep the future events
            // as the situation is not anymore the same
            this.clear();
            throw e;
        } finally{
            this.processingEvent = false;
        }
    };
    return Scheduler;
}();

});

parcelRegister("hyaBM", function(module, exports) {

$parcel$export(module.exports, "registry", () => $cc6dd7408610e822$export$4bb7493d241fd8a5);
var $cc6dd7408610e822$var$children = /*#__PURE__*/ new Map();
var $cc6dd7408610e822$var$sessionIdIndex = 0;
var $cc6dd7408610e822$export$4bb7493d241fd8a5 = {
    bookId: function() {
        return "x:" + $cc6dd7408610e822$var$sessionIdIndex++;
    },
    register: function(id, actor) {
        $cc6dd7408610e822$var$children.set(id, actor);
        return id;
    },
    get: function(id) {
        return $cc6dd7408610e822$var$children.get(id);
    },
    free: function(id) {
        $cc6dd7408610e822$var$children.delete(id);
    }
};

});

parcelRegister("g1JwA", function(module, exports) {

$parcel$export(module.exports, "getGlobal", () => $bab00d9741d7a521$export$a4e55266d2135a7f);
$parcel$export(module.exports, "registerService", () => $bab00d9741d7a521$export$4d7a7d14704ebc13);
// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis
function $bab00d9741d7a521$export$a4e55266d2135a7f() {
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof $parcel$global !== 'undefined') return $parcel$global;
    return undefined;
}
function $bab00d9741d7a521$var$getDevTools() {
    var global1 = $bab00d9741d7a521$export$a4e55266d2135a7f();
    if (global1 && '__xstate__' in global1) return global1.__xstate__;
    return undefined;
}
function $bab00d9741d7a521$export$4d7a7d14704ebc13(service) {
    if (!$bab00d9741d7a521$export$a4e55266d2135a7f()) return;
    var devTools = $bab00d9741d7a521$var$getDevTools();
    if (devTools) devTools.register(service);
}

});


parcelRegister("8Rv1C", function(module, exports) {
"use strict";
var $673b56e60b1827c4$var$__assign = module.exports && module.exports.__assign || function() {
    $673b56e60b1827c4$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $673b56e60b1827c4$var$__assign.apply(this, arguments);
};
var $673b56e60b1827c4$var$__values = module.exports && module.exports.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $673b56e60b1827c4$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $673b56e60b1827c4$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toObserver = module.exports.toInvokeSource = module.exports.evaluateGuard = module.exports.reportUnhandledExceptionOnInvocation = module.exports.normalizeTarget = module.exports.toTransitionConfigArray = module.exports.toSCXMLEvent = module.exports.toEventObject = module.exports.uniqueId = module.exports.isActor = module.exports.isMachine = module.exports.symbolObservable = module.exports.isObservable = module.exports.toGuard = module.exports.isString = module.exports.isFunction = module.exports.isArray = module.exports.warn = module.exports.updateContext = module.exports.updateHistoryValue = module.exports.updateHistoryStates = module.exports.partition = module.exports.isPromiseLike = module.exports.isBuiltInEvent = module.exports.mapContext = module.exports.toArray = module.exports.toArrayStrict = module.exports.flatten = module.exports.pathsToStateValue = module.exports.toStatePaths = module.exports.nestedPath = module.exports.path = module.exports.mapFilterValues = module.exports.mapValues = module.exports.pathToStateValue = module.exports.toStateValue = module.exports.isStateLike = module.exports.toStatePath = module.exports.getActionType = module.exports.getEventType = module.exports.matchesState = module.exports.keys = void 0;

var $ayEaS = parcelRequire("ayEaS");

var $6NAhf = parcelRequire("6NAhf");
function $673b56e60b1827c4$var$keys(value) {
    return Object.keys(value);
}
module.exports.keys = $673b56e60b1827c4$var$keys;
function $673b56e60b1827c4$var$matchesState(parentStateId, childStateId, delimiter) {
    if (delimiter === void 0) delimiter = $ayEaS.STATE_DELIMITER;
    var parentStateValue = $673b56e60b1827c4$var$toStateValue(parentStateId, delimiter);
    var childStateValue = $673b56e60b1827c4$var$toStateValue(childStateId, delimiter);
    if ($673b56e60b1827c4$var$isString(childStateValue)) {
        if ($673b56e60b1827c4$var$isString(parentStateValue)) return childStateValue === parentStateValue;
        // Parent more specific than child
        return false;
    }
    if ($673b56e60b1827c4$var$isString(parentStateValue)) return parentStateValue in childStateValue;
    return $673b56e60b1827c4$var$keys(parentStateValue).every(function(key) {
        if (!(key in childStateValue)) return false;
        return $673b56e60b1827c4$var$matchesState(parentStateValue[key], childStateValue[key]);
    });
}
module.exports.matchesState = $673b56e60b1827c4$var$matchesState;
function $673b56e60b1827c4$var$getEventType(event) {
    try {
        return $673b56e60b1827c4$var$isString(event) || typeof event === 'number' ? "" + event : event.type;
    } catch (e) {
        throw new Error('Events must be strings or objects with a string event.type property.');
    }
}
module.exports.getEventType = $673b56e60b1827c4$var$getEventType;
function $673b56e60b1827c4$var$getActionType(action) {
    try {
        return $673b56e60b1827c4$var$isString(action) || typeof action === 'number' ? "" + action : $673b56e60b1827c4$var$isFunction(action) ? action.name : action.type;
    } catch (e) {
        throw new Error('Actions must be strings or objects with a string action.type property.');
    }
}
module.exports.getActionType = $673b56e60b1827c4$var$getActionType;
function $673b56e60b1827c4$var$toStatePath(stateId, delimiter) {
    try {
        if ($673b56e60b1827c4$var$isArray(stateId)) return stateId;
        return stateId.toString().split(delimiter);
    } catch (e) {
        throw new Error("'" + stateId + "' is not a valid state path.");
    }
}
module.exports.toStatePath = $673b56e60b1827c4$var$toStatePath;
function $673b56e60b1827c4$var$isStateLike(state) {
    return typeof state === 'object' && 'value' in state && 'context' in state && 'event' in state && '_event' in state;
}
module.exports.isStateLike = $673b56e60b1827c4$var$isStateLike;
function $673b56e60b1827c4$var$toStateValue(stateValue, delimiter) {
    if ($673b56e60b1827c4$var$isStateLike(stateValue)) return stateValue.value;
    if ($673b56e60b1827c4$var$isArray(stateValue)) return $673b56e60b1827c4$var$pathToStateValue(stateValue);
    if (typeof stateValue !== 'string') return stateValue;
    var statePath = $673b56e60b1827c4$var$toStatePath(stateValue, delimiter);
    return $673b56e60b1827c4$var$pathToStateValue(statePath);
}
module.exports.toStateValue = $673b56e60b1827c4$var$toStateValue;
function $673b56e60b1827c4$var$pathToStateValue(statePath) {
    if (statePath.length === 1) return statePath[0];
    var value = {};
    var marker = value;
    for(var i = 0; i < statePath.length - 1; i++)if (i === statePath.length - 2) marker[statePath[i]] = statePath[i + 1];
    else {
        marker[statePath[i]] = {};
        marker = marker[statePath[i]];
    }
    return value;
}
module.exports.pathToStateValue = $673b56e60b1827c4$var$pathToStateValue;
function $673b56e60b1827c4$var$mapValues(collection, iteratee) {
    var result = {};
    var collectionKeys = $673b56e60b1827c4$var$keys(collection);
    for(var i = 0; i < collectionKeys.length; i++){
        var key = collectionKeys[i];
        result[key] = iteratee(collection[key], key, collection, i);
    }
    return result;
}
module.exports.mapValues = $673b56e60b1827c4$var$mapValues;
function $673b56e60b1827c4$var$mapFilterValues(collection, iteratee, predicate) {
    var e_1, _a;
    var result = {};
    try {
        for(var _b = $673b56e60b1827c4$var$__values($673b56e60b1827c4$var$keys(collection)), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var item = collection[key];
            if (!predicate(item)) continue;
            result[key] = iteratee(item, key, collection);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return result;
}
module.exports.mapFilterValues = $673b56e60b1827c4$var$mapFilterValues;
/**
 * Retrieves a value at the given path.
 * @param props The deep path to the prop of the desired value
 */ var $673b56e60b1827c4$var$path = function(props) {
    return function(object) {
        var e_2, _a;
        var result = object;
        try {
            for(var props_1 = $673b56e60b1827c4$var$__values(props), props_1_1 = props_1.next(); !props_1_1.done; props_1_1 = props_1.next()){
                var prop = props_1_1.value;
                result = result[prop];
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (props_1_1 && !props_1_1.done && (_a = props_1.return)) _a.call(props_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        return result;
    };
};
module.exports.path = $673b56e60b1827c4$var$path;
/**
 * Retrieves a value at the given path via the nested accessor prop.
 * @param props The deep path to the prop of the desired value
 */ function $673b56e60b1827c4$var$nestedPath(props, accessorProp) {
    return function(object) {
        var e_3, _a;
        var result = object;
        try {
            for(var props_2 = $673b56e60b1827c4$var$__values(props), props_2_1 = props_2.next(); !props_2_1.done; props_2_1 = props_2.next()){
                var prop = props_2_1.value;
                result = result[accessorProp][prop];
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (props_2_1 && !props_2_1.done && (_a = props_2.return)) _a.call(props_2);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        return result;
    };
}
module.exports.nestedPath = $673b56e60b1827c4$var$nestedPath;
function $673b56e60b1827c4$var$toStatePaths(stateValue) {
    if (!stateValue) return [
        []
    ];
    if ($673b56e60b1827c4$var$isString(stateValue)) return [
        [
            stateValue
        ]
    ];
    var result = $673b56e60b1827c4$var$flatten($673b56e60b1827c4$var$keys(stateValue).map(function(key) {
        var subStateValue = stateValue[key];
        if (typeof subStateValue !== 'string' && (!subStateValue || !Object.keys(subStateValue).length)) return [
            [
                key
            ]
        ];
        return $673b56e60b1827c4$var$toStatePaths(stateValue[key]).map(function(subPath) {
            return [
                key
            ].concat(subPath);
        });
    }));
    return result;
}
module.exports.toStatePaths = $673b56e60b1827c4$var$toStatePaths;
function $673b56e60b1827c4$var$pathsToStateValue(paths) {
    var e_4, _a;
    var result = {};
    if (paths && paths.length === 1 && paths[0].length === 1) return paths[0][0];
    try {
        for(var paths_1 = $673b56e60b1827c4$var$__values(paths), paths_1_1 = paths_1.next(); !paths_1_1.done; paths_1_1 = paths_1.next()){
            var currentPath = paths_1_1.value;
            var marker = result;
            // tslint:disable-next-line:prefer-for-of
            for(var i = 0; i < currentPath.length; i++){
                var subPath = currentPath[i];
                if (i === currentPath.length - 2) {
                    marker[subPath] = currentPath[i + 1];
                    break;
                }
                marker[subPath] = marker[subPath] || {};
                marker = marker[subPath];
            }
        }
    } catch (e_4_1) {
        e_4 = {
            error: e_4_1
        };
    } finally{
        try {
            if (paths_1_1 && !paths_1_1.done && (_a = paths_1.return)) _a.call(paths_1);
        } finally{
            if (e_4) throw e_4.error;
        }
    }
    return result;
}
module.exports.pathsToStateValue = $673b56e60b1827c4$var$pathsToStateValue;
function $673b56e60b1827c4$var$flatten(array) {
    var _a;
    return (_a = []).concat.apply(_a, $673b56e60b1827c4$var$__spreadArray([], $673b56e60b1827c4$var$__read(array)));
}
module.exports.flatten = $673b56e60b1827c4$var$flatten;
function $673b56e60b1827c4$var$toArrayStrict(value) {
    if ($673b56e60b1827c4$var$isArray(value)) return value;
    return [
        value
    ];
}
module.exports.toArrayStrict = $673b56e60b1827c4$var$toArrayStrict;
function $673b56e60b1827c4$var$toArray(value) {
    if (value === undefined) return [];
    return $673b56e60b1827c4$var$toArrayStrict(value);
}
module.exports.toArray = $673b56e60b1827c4$var$toArray;
function $673b56e60b1827c4$var$mapContext(mapper, context, _event) {
    var e_5, _a;
    if ($673b56e60b1827c4$var$isFunction(mapper)) return mapper(context, _event.data);
    var result = {};
    try {
        for(var _b = $673b56e60b1827c4$var$__values(Object.keys(mapper)), _c = _b.next(); !_c.done; _c = _b.next()){
            var key = _c.value;
            var subMapper = mapper[key];
            if ($673b56e60b1827c4$var$isFunction(subMapper)) result[key] = subMapper(context, _event.data);
            else result[key] = subMapper;
        }
    } catch (e_5_1) {
        e_5 = {
            error: e_5_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_5) throw e_5.error;
        }
    }
    return result;
}
module.exports.mapContext = $673b56e60b1827c4$var$mapContext;
function $673b56e60b1827c4$var$isBuiltInEvent(eventType) {
    return /^(done|error)\./.test(eventType);
}
module.exports.isBuiltInEvent = $673b56e60b1827c4$var$isBuiltInEvent;
function $673b56e60b1827c4$var$isPromiseLike(value) {
    if (value instanceof Promise) return true;
    // Check if shape matches the Promise/A+ specification for a "thenable".
    if (value !== null && ($673b56e60b1827c4$var$isFunction(value) || typeof value === 'object') && $673b56e60b1827c4$var$isFunction(value.then)) return true;
    return false;
}
module.exports.isPromiseLike = $673b56e60b1827c4$var$isPromiseLike;
function $673b56e60b1827c4$var$partition(items, predicate) {
    var e_6, _a;
    var _b = $673b56e60b1827c4$var$__read([
        [],
        []
    ], 2), truthy = _b[0], falsy = _b[1];
    try {
        for(var items_1 = $673b56e60b1827c4$var$__values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()){
            var item = items_1_1.value;
            if (predicate(item)) truthy.push(item);
            else falsy.push(item);
        }
    } catch (e_6_1) {
        e_6 = {
            error: e_6_1
        };
    } finally{
        try {
            if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
        } finally{
            if (e_6) throw e_6.error;
        }
    }
    return [
        truthy,
        falsy
    ];
}
module.exports.partition = $673b56e60b1827c4$var$partition;
function $673b56e60b1827c4$var$updateHistoryStates(hist, stateValue) {
    return $673b56e60b1827c4$var$mapValues(hist.states, function(subHist, key) {
        if (!subHist) return undefined;
        var subStateValue = ($673b56e60b1827c4$var$isString(stateValue) ? undefined : stateValue[key]) || (subHist ? subHist.current : undefined);
        if (!subStateValue) return undefined;
        return {
            current: subStateValue,
            states: $673b56e60b1827c4$var$updateHistoryStates(subHist, subStateValue)
        };
    });
}
module.exports.updateHistoryStates = $673b56e60b1827c4$var$updateHistoryStates;
function $673b56e60b1827c4$var$updateHistoryValue(hist, stateValue) {
    return {
        current: stateValue,
        states: $673b56e60b1827c4$var$updateHistoryStates(hist, stateValue)
    };
}
module.exports.updateHistoryValue = $673b56e60b1827c4$var$updateHistoryValue;
function $673b56e60b1827c4$var$updateContext(context, _event, assignActions, state) {
    if (!$6NAhf.IS_PRODUCTION) $673b56e60b1827c4$var$warn(!!context, 'Attempting to update undefined context');
    var updatedContext = context ? assignActions.reduce(function(acc, assignAction) {
        var e_7, _a;
        var assignment = assignAction.assignment;
        var meta = {
            state: state,
            action: assignAction,
            _event: _event
        };
        var partialUpdate = {};
        if ($673b56e60b1827c4$var$isFunction(assignment)) partialUpdate = assignment(acc, _event.data, meta);
        else try {
            for(var _b = $673b56e60b1827c4$var$__values($673b56e60b1827c4$var$keys(assignment)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                var propAssignment = assignment[key];
                partialUpdate[key] = $673b56e60b1827c4$var$isFunction(propAssignment) ? propAssignment(acc, _event.data, meta) : propAssignment;
            }
        } catch (e_7_1) {
            e_7 = {
                error: e_7_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_7) throw e_7.error;
            }
        }
        return Object.assign({}, acc, partialUpdate);
    }, context) : context;
    return updatedContext;
}
module.exports.updateContext = $673b56e60b1827c4$var$updateContext;
// tslint:disable-next-line:no-empty
var $673b56e60b1827c4$var$warn = function() {};
module.exports.warn = $673b56e60b1827c4$var$warn;
if (!$6NAhf.IS_PRODUCTION) module.exports.warn = $673b56e60b1827c4$var$warn = function(condition, message) {
    var error = condition instanceof Error ? condition : undefined;
    if (!error && condition) return;
    if (console !== undefined) {
        var args = [
            "Warning: " + message
        ];
        if (error) args.push(error);
        // tslint:disable-next-line:no-console
        console.warn.apply(console, args);
    }
};
function $673b56e60b1827c4$var$isArray(value) {
    return Array.isArray(value);
}
module.exports.isArray = $673b56e60b1827c4$var$isArray;
// tslint:disable-next-line:ban-types
function $673b56e60b1827c4$var$isFunction(value) {
    return typeof value === 'function';
}
module.exports.isFunction = $673b56e60b1827c4$var$isFunction;
function $673b56e60b1827c4$var$isString(value) {
    return typeof value === 'string';
}
module.exports.isString = $673b56e60b1827c4$var$isString;
// export function memoizedGetter<T, TP extends { prototype: object }>(
//   o: TP,
//   property: string,
//   getter: () => T
// ): void {
//   Object.defineProperty(o.prototype, property, {
//     get: getter,
//     enumerable: false,
//     configurable: false
//   });
// }
function $673b56e60b1827c4$var$toGuard(condition, guardMap) {
    if (!condition) return undefined;
    if ($673b56e60b1827c4$var$isString(condition)) return {
        type: $ayEaS.DEFAULT_GUARD_TYPE,
        name: condition,
        predicate: guardMap ? guardMap[condition] : undefined
    };
    if ($673b56e60b1827c4$var$isFunction(condition)) return {
        type: $ayEaS.DEFAULT_GUARD_TYPE,
        name: condition.name,
        predicate: condition
    };
    return condition;
}
module.exports.toGuard = $673b56e60b1827c4$var$toGuard;
function $673b56e60b1827c4$var$isObservable(value) {
    try {
        return 'subscribe' in value && $673b56e60b1827c4$var$isFunction(value.subscribe);
    } catch (e) {
        return false;
    }
}
module.exports.isObservable = $673b56e60b1827c4$var$isObservable;
module.exports.symbolObservable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
function $673b56e60b1827c4$var$isMachine(value) {
    try {
        return '__xstatenode' in value;
    } catch (e) {
        return false;
    }
}
module.exports.isMachine = $673b56e60b1827c4$var$isMachine;
function $673b56e60b1827c4$var$isActor(value) {
    return !!value && typeof value.send === 'function';
}
module.exports.isActor = $673b56e60b1827c4$var$isActor;
module.exports.uniqueId = function() {
    var currentId = 0;
    return function() {
        currentId++;
        return currentId.toString(16);
    };
}();
function $673b56e60b1827c4$var$toEventObject(event, payload) {
    if ($673b56e60b1827c4$var$isString(event) || typeof event === 'number') return $673b56e60b1827c4$var$__assign({
        type: event
    }, payload);
    return event;
}
module.exports.toEventObject = $673b56e60b1827c4$var$toEventObject;
function $673b56e60b1827c4$var$toSCXMLEvent(event, scxmlEvent) {
    if (!$673b56e60b1827c4$var$isString(event) && '$$type' in event && event.$$type === 'scxml') return event;
    var eventObject = $673b56e60b1827c4$var$toEventObject(event);
    return $673b56e60b1827c4$var$__assign({
        name: eventObject.type,
        data: eventObject,
        $$type: 'scxml',
        type: 'external'
    }, scxmlEvent);
}
module.exports.toSCXMLEvent = $673b56e60b1827c4$var$toSCXMLEvent;
function $673b56e60b1827c4$var$toTransitionConfigArray(event, configLike) {
    var transitions = $673b56e60b1827c4$var$toArrayStrict(configLike).map(function(transitionLike) {
        if (typeof transitionLike === 'undefined' || typeof transitionLike === 'string' || $673b56e60b1827c4$var$isMachine(transitionLike)) return {
            target: transitionLike,
            event: event
        };
        return $673b56e60b1827c4$var$__assign($673b56e60b1827c4$var$__assign({}, transitionLike), {
            event: event
        });
    });
    return transitions;
}
module.exports.toTransitionConfigArray = $673b56e60b1827c4$var$toTransitionConfigArray;
function $673b56e60b1827c4$var$normalizeTarget(target) {
    if (target === undefined || target === $ayEaS.TARGETLESS_KEY) return undefined;
    return $673b56e60b1827c4$var$toArray(target);
}
module.exports.normalizeTarget = $673b56e60b1827c4$var$normalizeTarget;
function $673b56e60b1827c4$var$reportUnhandledExceptionOnInvocation(originalError, currentError, id) {
    if (!$6NAhf.IS_PRODUCTION) {
        var originalStackTrace = originalError.stack ? " Stacktrace was '" + originalError.stack + "'" : '';
        if (originalError === currentError) // tslint:disable-next-line:no-console
        console.error("Missing onError handler for invocation '" + id + "', error was '" + originalError + "'." + originalStackTrace);
        else {
            var stackTrace = currentError.stack ? " Stacktrace was '" + currentError.stack + "'" : '';
            // tslint:disable-next-line:no-console
            console.error("Missing onError handler and/or unhandled exception/promise rejection for invocation '" + id + "'. " + ("Original error: '" + originalError + "'. " + originalStackTrace + " Current error is '" + currentError + "'." + stackTrace));
        }
    }
}
module.exports.reportUnhandledExceptionOnInvocation = $673b56e60b1827c4$var$reportUnhandledExceptionOnInvocation;
function $673b56e60b1827c4$var$evaluateGuard(machine, guard, context, _event, state) {
    var guards = machine.options.guards;
    var guardMeta = {
        state: state,
        cond: guard,
        _event: _event
    };
    // TODO: do not hardcode!
    if (guard.type === $ayEaS.DEFAULT_GUARD_TYPE) return guard.predicate(context, _event.data, guardMeta);
    var condFn = guards[guard.type];
    if (!condFn) throw new Error("Guard '" + guard.type + "' is not implemented on machine '" + machine.id + "'.");
    return condFn(context, _event.data, guardMeta);
}
module.exports.evaluateGuard = $673b56e60b1827c4$var$evaluateGuard;
function $673b56e60b1827c4$var$toInvokeSource(src) {
    if (typeof src === 'string') return {
        type: src
    };
    return src;
}
module.exports.toInvokeSource = $673b56e60b1827c4$var$toInvokeSource;
function $673b56e60b1827c4$var$toObserver(nextHandler, errorHandler, completionHandler) {
    if (typeof nextHandler === 'object') return nextHandler;
    var noop = function() {
        return void 0;
    };
    return {
        next: nextHandler,
        error: errorHandler || noop,
        complete: completionHandler || noop
    };
}
module.exports.toObserver = $673b56e60b1827c4$var$toObserver;

});
parcelRegister("ayEaS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TARGETLESS_KEY = module.exports.DEFAULT_GUARD_TYPE = module.exports.EMPTY_ACTIVITY_MAP = module.exports.STATE_DELIMITER = void 0;
module.exports.STATE_DELIMITER = '.';
module.exports.EMPTY_ACTIVITY_MAP = {};
module.exports.DEFAULT_GUARD_TYPE = 'xstate.guard';
module.exports.TARGETLESS_KEY = '';

});

parcelRegister("6NAhf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IS_PRODUCTION = void 0;
module.exports.IS_PRODUCTION = true;

});


parcelRegister("7Im09", function(module, exports) {

$parcel$export(module.exports, "default", () => $59ddb5802b068dd1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $59ddb5802b068dd1$export$2e2bcd8739ae039(fn) {
    var ref = $eUqFw.useRef();
    if (!ref.current) ref.current = {
        v: fn()
    };
    return ref.current.v;
}

});

parcelRegister("bFiQl", function(module, exports) {

$parcel$export(module.exports, "useReactEffectActions", () => $87e223f2fa966353$export$a73dbfb5780c94db);

var $eUqFw = parcelRequire("eUqFw");

var $k286k = parcelRequire("k286k");

var $XJXVw = parcelRequire("XJXVw");

var $617sA = parcelRequire("617sA");

var $lLbOi = parcelRequire("lLbOi");
var $87e223f2fa966353$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $87e223f2fa966353$var$__spread = undefined && undefined.__spread || function() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($87e223f2fa966353$var$__read(arguments[i]));
    return ar;
};
function $87e223f2fa966353$export$a73dbfb5780c94db(service) {
    var effectActionsRef = (0, $eUqFw.useRef)([]);
    var layoutEffectActionsRef = (0, $eUqFw.useRef)([]);
    (0, $k286k.default)(function() {
        var sub = service.subscribe(function(currentState) {
            var _a, _b;
            if (currentState.actions.length) {
                var reactEffectActions = currentState.actions.filter(function(action) {
                    return typeof action.exec === 'function' && '__effect' in action.exec;
                });
                var _c = $87e223f2fa966353$var$__read((0, $617sA.partition)(reactEffectActions, function(action) {
                    return action.exec.__effect === (0, $XJXVw.ReactEffectType).Effect;
                }), 2), effectActions = _c[0], layoutEffectActions = _c[1];
                (_a = effectActionsRef.current).push.apply(_a, $87e223f2fa966353$var$__spread(effectActions.map(function(effectAction) {
                    return [
                        effectAction,
                        currentState
                    ];
                })));
                (_b = layoutEffectActionsRef.current).push.apply(_b, $87e223f2fa966353$var$__spread(layoutEffectActions.map(function(layoutEffectAction) {
                    return [
                        layoutEffectAction,
                        currentState
                    ];
                })));
            }
        });
        return function() {
            sub.unsubscribe();
        };
    }, []);
    // this is somewhat weird - this should always be flushed within useLayoutEffect
    // but we don't want to receive warnings about useLayoutEffect being used on the server
    // so we have to use `useIsomorphicLayoutEffect` to silence those warnings
    (0, $k286k.default)(function() {
        while(layoutEffectActionsRef.current.length){
            var _a = $87e223f2fa966353$var$__read(layoutEffectActionsRef.current.shift(), 2), layoutEffectAction = _a[0], effectState = _a[1];
            (0, $lLbOi.executeEffect)(layoutEffectAction, effectState);
        }
    }); // https://github.com/davidkpiano/xstate/pull/1202#discussion_r429677773
    (0, $eUqFw.useEffect)(function() {
        while(effectActionsRef.current.length){
            var _a = $87e223f2fa966353$var$__read(effectActionsRef.current.shift(), 2), effectAction = _a[0], effectState = _a[1];
            (0, $lLbOi.executeEffect)(effectAction, effectState);
        }
    });
}

});
parcelRegister("617sA", function(module, exports) {

$parcel$export(module.exports, "partition", () => $46189f834bfa8031$export$b29f828819edca8d);
var $46189f834bfa8031$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $46189f834bfa8031$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
function $46189f834bfa8031$export$b29f828819edca8d(items, predicate) {
    var e_1, _a;
    var _b = $46189f834bfa8031$var$__read([
        [],
        []
    ], 2), truthy = _b[0], falsy = _b[1];
    try {
        for(var items_1 = $46189f834bfa8031$var$__values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()){
            var item = items_1_1.value;
            if (predicate(item)) truthy.push(item);
            else falsy.push(item);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return [
        truthy,
        falsy
    ];
}

});




parcelRegister("3TkyW", function(module, exports) {

$parcel$export(module.exports, "createAIExperienceMachine", () => $2d56757211a38f16$export$d89ac572d9ca416a);

var $i1LcY = parcelRequire("i1LcY");
var $7LdyK = parcelRequire("7LdyK");
var $8O42R = parcelRequire("8O42R");

var $XHGTv = parcelRequire("XHGTv");

var $kVY5A = parcelRequire("kVY5A");
function $2d56757211a38f16$export$d89ac572d9ca416a(options) {
    const machine = (0, $8O42R.createMachine)({
        /** @xstate-layout N4IgpgJg5mDOIC5QEECSACAogDwA5gCcBLMAOwGMx0BZAQ3IAsjSwBiAV1wloBcrcA9rCI8iA0rADaABgC6iUIOGjxCkNkQBGAMwA2ABwA6abukB2TZv37tAVgBMmgCwAaEAE8t2w-oCcm+207bXtA-199AF9ItzQsPEISCio6RmYwQ1geWgI+CHQs3jYAayJyYvQBADMqmXkkECURMVI1DQRNM0cfWxsQ7U1bXVsBt08EEOljMzNbX10nW1mh+ydo2IwcfGIyShp6JhZM7NzIAuy+VlLyyprJTXrFIWbVBvbLeyn7Je1pc1NpJYxohJsZ9E5fNJwU5Zk5dNp1iA4ltErsUgd0oYALYCbgAG3Q9FEADcqIVLnByLR8HU1E0VK03oh7L4LIZnGYbPpHE4WfYzMCEL1fIZTCM5mYQty4YjkQkdsl9mkjjj8YTyCSyRc2FkBAQwABhcR8bA8ADKFyIWTKUjkdOeDLaIPsunshhCFjMul8TmkoRmgpdIrhei6phZcN8ss28qSe1ShwyqtoBKJRFJ5yKHC4RUJMFIPFtj0aDpaToQLMB7K9cOk2iccICge9hhD3u0kIc+jmaxiSJj2zj6OVSdxKfVmszfEMYFjaMMeIEtAgzCgU7Y5AEWNweLAfFpDXpZaZHV0XXdzgbZ6G4N82kFASh7pm-P0XQCQQRfblg7RSsT2JjqmGrplqRQznOyQLkuK6kGu5JsOwpDFKQAgAO6kOgVS0EQeIHk8yjHqA7SrMMhhepCThvjCLq2A+vy2D4DYRJ8VFeqs0bxL+ioJpiybAZOCEQdxlDQcuq7rqwsC0FiVBUowVDFGA7j4SWhGvMRXh2KKzjXiYHp6IKb6aIYthONokpnto3JhpxKIKvGGIqkBE6geuwmolBi7iXB7nebBUBSTw+oyapR4aeoWjgt4LoQqEQzer4-JGb4IpWAYUrUb6X4bFxnmOSOgFqmmGZCbOIkZP5ElCVVcHZtwfDoIwtCkCweKoBAYWlhF7zzCKUL6Jo5i2FYfqSoKVnkfW5hvt60hDDl-Z5Q5w4AfxrmldqHkrWJAV+TBq71bmRAQHQuBdepjKaRWYQ+AN9jgn6gKckZZhOMYDjSD6VhJSNi0-vlq18S5JVgdO5WA7t1VbbVgXUkQWE4XhdqHt1V2RRWQSMYNb6Qh2SV3g+UImboBiQgTrodnZkEFWtIMgZt4EQztsP7T5gUELmeJEFiIiQBdLzoyRTiaLohguvouiWBZwzsSlRhDPMnwmA2MK6NTFX-sDxUM2DGTM0OUO+TVB11TwAhKZh3O8zwiO4QLjonqEVYi-yb2SssvgPqRrZnpYPqct8ksa4DWvOTrglbQb86syb7OsMwuDsLb5sCAUDB6rb2H2yjBGC+Wnz+KKrrmZKA1wg+vJi+Tvgjd8IyDCHK1h6OEduWVNOVab8Ew93rBMLgtC0E1xpkFnSMO0RGNhGLb4mMTwwNvYD6aJChj+H4X0spTUbfgOoe8eH46g+50ded3bMBawyAAKoAAroMSYh4rwLToBAe5gBq-O52p+cnqvKid1vSdF5CGRYK9zyDG7INWw5hPhmCbkOFuRVj661Pp3I2PdwKw1YPqWAggJBUFTgUHmuEciTx6lFZw4teS-Asg4RYy8PBeBbPNKWiwQGb3sEgv8h9W5oMjkzTBsctrwztrufICFWDiP1MFFSv9wpC2ZJ9VsgcFidFASYImQRRSzF+tyEYoR-r72bvw1BAl25RxERfISnNGrWxEBtNg2AhK0CqHwAgAAKAASpgAAKj4gAmgAfWQAAGXCQAeQAOqYAACIAEpr6mOQeY9aJ8O4VSwe5exVBHG21BpQ5RFZXRTFdLCBYI0FjmCMqYdeZ4vrsVZBEXeuV7JpKcgIyxjNwY2PZrkrmZDbbMFBjI3ACM5EEAUcWJRBcvqMXmhZMwfoDDemYeMN6wYAgskls4Pwg1eE8S6RY5xGDsn6ifmANCklmCeIIAIKARRinlg5EYQEtd4Si1sL0UYLCOh1m8A4EIqVFhfX8Ec2m2tBFWOERcsAVybnSKQihdCmFs7I1mWjAucJ3oL1+SNPwugHwjCMIEfQX0IS9Elo4SFQMj49L1ttQ2lySBIu1Hgvc0z0C4AeduHgLynZUTdJ8VeKsqILIfG9MW3xpB0PMsMQY6s97LU6YVDJ6CsmQ1ZdcySkAnG8q3LgAVijsUnhGiZbsKyYSpTMr8L2-yEo+ApWeB6NEAi2DpSgjVQi+nwsRe5XlCK2VBRyLbfUVR0iyQLIK66Sq3T2tAaTOYHqHykzdCs1pP0-htKWh0vhJyfWwr9dq4Nuq7FgEjSwaNPBWCUmpGAWNGMlUimlJyeEb16yaAfMZd0DZrBK1CL6T1Kr83HPVfTX1+tME6vZeBCNUax6sCpMkAkC7q1jybe8H5jEQGsmcF9VZUrfjkW9MKeEvpRaINHZ3b1k7i3Tv9Wy3JlbF0FiOo1dgsBCDoETsnLdUUIhMTfBSn5MwDBprmOvP6z0paryiDezW6T729MfaWgNFaq1gBrR+qgX6f1-sKRAWoprLrzJFsXT5kohidDelKgwpkIwui9P7BD7Tb3Ibbqh5l85NxYixC1fIg9dw8EatI64xRqhVHQGhEQDAR78cEzylMe5GqEYAx0LGaiOwHLMKyCD-zErsh+R2GYNgQyaC9ZxmF3Gz6iT4wJ0gQmVOib1rhkeBZZwmqxWRk88IRX+09IS0w95-ktNFPNMBFL5gQjY3mjjhaUNMrsxkBzSnhOqbcyuygmL7S+bjQNRjnJ-C9F5KsImNDuykoiKNIIuaAZmMS1x5LmC0tOeUyJsTHLstgDwg8PL-8406EYj8nQo0-R3gcIGJpopHAfBFnoUIVmms2aZSuWAVICAQEMKM3WdbSC0AAEa7nflaTbnVSODYxiEb4PhHyuwbAlabrJZuWACAt10PDEMHxW4y9y63zuGDGeto7J2Ac5Auz5q77QBjzXZP6QY8xnBJQfHebwUIzyLA7A2AI172NId+2coS4OttA72-Wmkl3HbXQGLoq1OgIgGF9PoabLoLy7LMo4Osu8+yoQ-vABoDW1WJgG9T67Z4ejWr07XcyX0e0mXmHoH5qzaezGW4VQopwpHalF1PEiuzjABFMGUmwQxXD-IGCKWYD1TC+kcJKOLQuC0Tua+uXXVCEAi2xksOV0u7Vy4t9ZcWXbWIPSsDLdXdNXdapWu7kpIZJe+9tbLh14xeSMUlCLIaehggQu+41l3q3zmQ1EUUOPry9OMViklb4pNUrJUdToYPvpbUWUi5H6Ff2Y+G1L9OWG5enbDfZJjmw3yl6CkZ+RPTdZBq+ldNyDvDKifWOyb3jI4iMVnAQgP669cRVUR9FLQOoXxhDW5ORawXYatmRGov7py+4Ul9sVtPJ6ACnOJ39PC9d3vSShr2VifFkUUO8MUEuCwbsO-U5TJFfJ-AZOxIZG2X9A7XWT-EicMVsL6fZZwP6DZRAL0KYCEOKBYW3bsSzfPYXTvB-EtHaWdN3VGfLZtesDPX4VeMpYYaiElc8RYMbKwIOKuSAotWzGdMtOdacINRFVArwO8KaD5Ng3oOjf5ToepWYXSbsGpV1AQpLYvGgkQl9LDGtSQjoaLd0BYXGNQ2jc3U-L0MwcWf0O8CwZNPHeLAnQvLvGAnaTfCAQw1YaQyUayCEQYPTeEOiRQ8ybwbPD1fweBEdfHH7VwqgtDHaNrZzTrPWQwroGw34DKUmefIYAUQzUmZ1PoPwBwM8PTTQ6PLaEnLw+g6HZkWuIwH0PZXSHwoIHtRYUySWZYRYTsSUCoovYnM7CHHbZAzUQwqURZXkO8XHLeUWabVecWdZEYJKOEF0fotw8CaosnMY2osXGHP4auKiODVYiENo-5UVEUIMZHLIuEXoaIaIIAA */ id: 'AI Experience Machine',
        initial: 'started state',
        states: {
            'started state': {
                on: {
                    'kick off': [
                        {
                            target: 'modal active state.experience.loading state',
                            cond: 'neither base generate nor custom prompt'
                        },
                        '#AI Experience Machine.modal active state.experience.command palette state'
                    ]
                }
            },
            'modal active state': {
                type: 'parallel',
                on: {
                    escape: {
                        target: '#AI Experience Machine.modal active state.discard.active'
                    },
                    storeContextStatistics: {
                        actions: 'storeContextStatistics'
                    },
                    'update agents': {
                        cond: 'is rovo agents FF on',
                        actions: 'updateAgents'
                    }
                },
                states: {
                    experience: {
                        states: {
                            'loading state': {
                                on: {
                                    complete: {
                                        target: 'review state',
                                        actions: [
                                            'pushToHistory',
                                            'updateMarkdown',
                                            'clearUserInput'
                                        ]
                                    },
                                    'unknown fail': {
                                        target: 'failed',
                                        actions: 'fail'
                                    },
                                    'same cache key': {
                                        target: 'review state',
                                        actions: [
                                            'restoreResponseFromHistory',
                                            'clearUserInput'
                                        ]
                                    }
                                },
                                states: {
                                    loading: {
                                        invoke: {
                                            src: (0, $kVY5A.streamingService)
                                        },
                                        on: {
                                            stream: {
                                                target: 'loading',
                                                internal: true,
                                                actions: [
                                                    'updateMarkdown',
                                                    'updateLoadingStatus'
                                                ]
                                            },
                                            'update channelId': {
                                                actions: 'updateChannelId'
                                            },
                                            'update idMap': {
                                                target: 'loading',
                                                internal: true,
                                                actions: 'updateIdMap'
                                            },
                                            'api fail': {
                                                target: 'api failed state',
                                                actions: 'storeFailureContext'
                                            },
                                            'rate limited': {
                                                target: 'rate limit active',
                                                actions: 'storeFailureContext'
                                            },
                                            'token limit fail': {
                                                target: '#AI Experience Machine.modal active state.experience.failed',
                                                actions: 'fail'
                                            },
                                            'input too short fail': {
                                                target: '#AI Experience Machine.modal active state.experience.failed',
                                                actions: 'fail'
                                            },
                                            'hipaa content fail': {
                                                target: '#AI Experience Machine.modal active state.experience.failed',
                                                actions: 'fail'
                                            },
                                            'AUP violation detected': {
                                                target: '#AI Experience Machine.modal active state.experience.review state',
                                                actions: [
                                                    'pushToHistory',
                                                    'storeAupViolation',
                                                    'clearUserInput',
                                                    'storeFailureContext'
                                                ]
                                            },
                                            'response too similar': {
                                                target: '#AI Experience Machine.modal active state.experience.review state',
                                                actions: [
                                                    'pushToHistory',
                                                    'clearUserInput'
                                                ]
                                            }
                                        }
                                    },
                                    'api failed state': {
                                        on: {
                                            'api retry': 'loading'
                                        },
                                        exit: [
                                            'clearFailureContext',
                                            'clearLoadingStatus'
                                        ]
                                    },
                                    'rate limit active': {
                                        after: {
                                            RETRY_ALLOWED: {
                                                target: 'rate limit inactive'
                                            }
                                        }
                                    },
                                    'rate limit inactive': {
                                        on: {
                                            'api retry': {
                                                target: 'loading',
                                                actions: 'clearLoadingStatus'
                                            }
                                        },
                                        exit: [
                                            'clearFailureContext'
                                        ]
                                    }
                                },
                                initial: 'loading',
                                entry: 'setLatestPrompt',
                                exit: 'clearLoadingStatus'
                            },
                            'review state': {
                                on: {
                                    interrogate: {
                                        target: 'loading state',
                                        actions: [
                                            'clearFromHistory',
                                            'updatePromptContextBasedOnTrigger',
                                            'interrogate'
                                        ]
                                    },
                                    'unknown fail': {
                                        target: 'failed',
                                        actions: 'fail'
                                    },
                                    'retry prompt': {
                                        target: 'loading state',
                                        actions: [
                                            'updatePromptContextBasedOnTrigger',
                                            'updateUserInput',
                                            'updateUserInputADF',
                                            'clearMarkdown',
                                            'incrementRetryPromptCount',
                                            'clearFromHistory'
                                        ]
                                    },
                                    'edit prompt': {
                                        target: 'command palette state',
                                        actions: [
                                            'editPrompt'
                                        ]
                                    }
                                },
                                states: {
                                    preview: {
                                        on: {
                                            'start refinement': 'refinement'
                                        }
                                    },
                                    refinement: {
                                        on: {
                                            escape: {
                                                target: 'preview',
                                                actions: [
                                                    'clearUserInput',
                                                    'clearFocus'
                                                ]
                                            },
                                            'cancel refinement': {
                                                target: 'preview',
                                                actions: [
                                                    'clearUserInput',
                                                    'clearFocus'
                                                ]
                                            },
                                            'update user input': {
                                                internal: true,
                                                actions: 'updateUserInput'
                                            },
                                            'update user input adf': {
                                                internal: true,
                                                actions: 'updateUserInputADF'
                                            }
                                        }
                                    }
                                },
                                initial: 'preview'
                            },
                            failed: {},
                            'command palette state': {
                                on: {
                                    'kickoff with command palette input': {
                                        target: 'loading state',
                                        actions: [
                                            'updatePromptContextBasedOnTrigger',
                                            'updateContext'
                                        ]
                                    },
                                    'update context': {
                                        target: 'command palette state',
                                        internal: true,
                                        actions: 'updateContext',
                                        // ! TODO: When xstate v5+ is adopted remove the ts-expect-error
                                        // This will swallow ts-errors, take care
                                        // This occurs because createMachine's options input does not include state.description
                                        // However the state.description field is useful for the visual editor
                                        // Tested 2023-07-06 on xstate@5.0.0-beta.15 and this problem will be resolved
                                        // @ts-expect-error(TS2769) "No overload matches this call"
                                        description: `This must be called before 'cancel' transition to make sure the context is updated before the 'if command input is empty' guard is evaluated.`
                                    },
                                    cancel: [
                                        {
                                            cond: 'if command input is empty',
                                            target: 'command palette state',
                                            internal: true,
                                            actions: 'endExperience'
                                        },
                                        '#AI Experience Machine.modal active state.discard.active'
                                    ]
                                },
                                description: `This state creates a nested state machine that handles all the state of the command palette.

  It needs to know the 'userInput', 'baseGenerate' and 'configItem' from the AI Experience State Machine.

  Whenever we exit this state we need to update the AI Experience State Machine's context with the 'updateContext' action.`
                            }
                        }
                    },
                    discard: {
                        initial: 'inactive',
                        states: {
                            inactive: {
                                on: {
                                    'enable discard': 'active'
                                }
                            },
                            active: {
                                on: {
                                    'disable discard': 'inactive',
                                    escape: 'inactive'
                                }
                            }
                        }
                    }
                }
            }
        },
        schema: {
            // Typed explicitly due to old xstate version not having
            // type generation
            events: {}
        },
        context: options.context,
        on: {
            'update positions': {
                internal: true,
                actions: 'updatePositions'
            }
        }
    }, {
        actions: {
            updatePositions: (0, $7LdyK.assign)((context, event)=>{
                if (event.type !== 'update positions') return {};
                return {
                    positions: event.positions
                };
            }),
            storeFailureContext: (0, $7LdyK.assign)((context, event)=>{
                if ([
                    'api fail',
                    'rate limited',
                    'AUP violation detected'
                ].includes(event.type) && 'errorInfo' in event) return {
                    apiErrorInfo: event.errorInfo
                };
                return {};
            }),
            clearFailureContext: (0, $7LdyK.assign)(()=>{
                return {
                    apiErrorInfo: {}
                };
            }),
            updateMarkdown: (0, $7LdyK.assign)((context, event)=>{
                if (event.type !== 'stream' && event.type !== 'complete') return {};
                return {
                    markdown: event.markdown
                };
            }),
            updateLoadingStatus: (0, $7LdyK.assign)((context, event)=>{
                if (event.type !== 'stream') return {};
                // If the loading status is empty, we want to clear it from the context
                if (event.loadingStatus === '') return {
                    loadingStatus: undefined
                };
                return {
                    loadingStatus: event.loadingStatus
                };
            }),
            clearLoadingStatus: (0, $7LdyK.assign)(()=>{
                return {
                    loadingStatus: undefined
                };
            }),
            storeContextStatistics: (0, $7LdyK.assign)((_context, event)=>{
                if (event.type === 'storeContextStatistics') return {
                    contextStatistics: event.contextStatistics
                };
                return {};
            }),
            storeAupViolation: (0, $7LdyK.assign)((context, event)=>{
                if (event.type === 'AUP violation detected') return {
                    aupViolation: true,
                    // clear any markdown that may have already come through
                    // at time of implementation -- this is not possible -- as aup check happens before
                    // streaming
                    markdown: ''
                };
                return {
                    aupViolation: true
                };
            }),
            clearMarkdown: (0, $7LdyK.assign)((context, event)=>{
                if (event.type !== 'retry prompt') return {};
                return {
                    markdown: undefined,
                    idMap: undefined
                };
            }),
            interrogate: (0, $7LdyK.assign)((_context, event)=>{
                if (event.type !== 'interrogate') return {};
                /**
         * Need to wipe out markdown as per user story designs where we don't use
         * the prior response in the latest response
         */ return {
                    markdown: '',
                    userInput: event.userInput,
                    userADFInput: event.userADFInput,
                    latestPromptResponse: event.latestPromptResponse
                };
            }),
            clearUserInput: (0, $7LdyK.assign)((context, event)=>{
                return {
                    userInput: '',
                    userADFInput: ''
                };
            }),
            updateUserInput: (0, $7LdyK.assign)((context, event)=>{
                if (event.type !== 'update user input' && event.type !== 'retry prompt') return {};
                return {
                    userInput: event.input
                };
            }),
            updateUserInputADF: (0, $7LdyK.assign)((context, event)=>{
                if (event.type !== 'update user input adf' && event.type !== 'retry prompt') return {};
                return {
                    userADFInput: event.adf
                };
            }),
            pushToHistory: (0, $7LdyK.assign)((context, event)=>{
                if (event.type !== 'complete' && event.type !== 'AUP violation detected' && event.type !== 'response too similar') return {};
                const { cacheKey: cacheKey } = event;
                // Right now we only ever have one object in history as we do not
                // yet support traversing the history object array. This is also to
                // prevent us saving large documents into history multip[le times.
                if (context.responseHistory.entries.length > 0 && context.responseHistory.entries[0].cacheKey === cacheKey) return {};
                if (event.type === 'complete') {
                    const historyEvent = {
                        userInput: context.userInput || '',
                        userADFInput: context.userADFInput || '',
                        configItem: context.configItem,
                        markdown: event.markdown,
                        cacheKey: cacheKey,
                        modelInput: event.modelInput,
                        inputOutputDiffRatio: event.inputOutputDiffRatio
                    };
                    return {
                        responseHistory: {
                            entries: [
                                historyEvent
                            ],
                            positionFromEnd: 0
                        }
                    };
                }
                if (event.type === 'AUP violation detected') {
                    const historyEvent = {
                        userInput: context.userInput || '',
                        userADFInput: context.userADFInput || '',
                        configItem: context.configItem,
                        markdown: '',
                        aupViolation: true,
                        cacheKey: cacheKey,
                        modelInput: event.modelInput
                    };
                    return {
                        responseHistory: {
                            entries: [
                                historyEvent
                            ],
                            positionFromEnd: 0
                        }
                    };
                }
                if (event.type === 'response too similar') {
                    const historyEvent = {
                        userInput: context.userInput || '',
                        userADFInput: context.userADFInput || '',
                        configItem: context.configItem,
                        markdown: '',
                        responseTooSimilar: true,
                        cacheKey: cacheKey,
                        modelInput: event.modelInput,
                        inputOutputDiffRatio: event.inputOutputDiffRatio
                    };
                    return {
                        responseHistory: {
                            entries: [
                                historyEvent
                            ],
                            positionFromEnd: 0
                        }
                    };
                }
                return {};
            }),
            restoreResponseFromHistory: (0, $7LdyK.assign)((context, event)=>{
                if (event.type !== 'same cache key') return {};
                const { entries: entries } = context.responseHistory;
                const historyEvent = entries[0];
                if (!historyEvent) return {};
                return {
                    userInput: historyEvent.userInput,
                    userADFInput: historyEvent.userADFInput,
                    markdown: historyEvent.markdown,
                    configItem: historyEvent.configItem,
                    latestPromptResponse: historyEvent.markdown,
                    aupViolation: historyEvent.aupViolation || false
                };
            }),
            clearFromHistory: (0, $7LdyK.assign)((context, event)=>{
                if (event.type !== 'retry prompt' && event.type !== 'interrogate') return {};
                return {
                    responseHistory: {
                        entries: [],
                        positionFromEnd: 0
                    }
                };
            }),
            setLatestPrompt: (0, $i1LcY.actions).choose([
                {
                    cond: 'is base generate',
                    actions: (0, $7LdyK.assign)((context)=>({
                            latestPrompt: {
                                userInput: (context === null || context === void 0 ? void 0 : context.userInput) || '',
                                userADFInput: (context === null || context === void 0 ? void 0 : context.userADFInput) || ''
                            },
                            aupViolation: false
                        }))
                },
                /**
       * TODO AIFOLLOWUP: ensure that this condition is still correct
       * after promptLabel is removed.
       * This condition is for preset prompts such as 'Brainstorm'
       * which require additional user input.
       * Also check to see if event.type !== 'interrogate' still
       * makes sense down the line.
       */ {
                    cond: 'has custom prompt',
                    actions: (0, $7LdyK.assign)((context, event)=>{
                        var _context$configItem;
                        return {
                            latestPrompt: {
                                ...event.type !== 'interrogate' && {
                                    presetTitle: (_context$configItem = context.configItem) === null || _context$configItem === void 0 ? void 0 : _context$configItem.title
                                },
                                userInput: (context === null || context === void 0 ? void 0 : context.userInput) || '',
                                userADFInput: (context === null || context === void 0 ? void 0 : context.userADFInput) || ''
                            }
                        };
                    })
                },
                /**
       * Falls through to options which do not take additional
       * user input and is not base generate, e.g.
       * - Improve writing
       * - Summarize
       * Upon interrogation, there may also be user input.
       * We preference showing user input over the preset title for
       * non-partial presets.
       */ {
                    actions: (0, $7LdyK.assign)((context)=>{
                        var _context$configItem2;
                        return context !== null && context !== void 0 && context.userInput ? {
                            latestPrompt: {
                                userInput: (context === null || context === void 0 ? void 0 : context.userInput) || '',
                                userADFInput: (context === null || context === void 0 ? void 0 : context.userADFInput) || ''
                            }
                        } : {
                            latestPrompt: {
                                presetTitle: (_context$configItem2 = context.configItem) === null || _context$configItem2 === void 0 ? void 0 : _context$configItem2.title
                            }
                        };
                    })
                }
            ]),
            clearFocus: ()=>{
                var _document$activeEleme;
                (_document$activeEleme = document.activeElement) === null || _document$activeEleme === void 0 || _document$activeEleme.blur();
            },
            fail: (0, $7LdyK.assign)((context, event)=>{
                if (event.type !== 'unknown fail' && event.type !== 'token limit fail' && event.type !== 'input too short fail' && event.type !== 'hipaa content fail') return {};
                return {
                    failureReason: event.type,
                    apiErrorInfo: event.errorInfo
                };
            }),
            endExperience: ()=>{
                options.endExperience();
            },
            updateContext: (0, $7LdyK.assign)((_context, event)=>{
                if (event.type === 'kickoff with command palette input' || event.type === 'update context') return {
                    ...event.context
                };
                return {};
            }),
            updateAgents: (0, $7LdyK.assign)((_context, event)=>{
                if (event.type === 'update agents') return {
                    ...event.context
                };
                return {};
            }),
            updateChannelId: (0, $7LdyK.assign)((_context, event)=>{
                if (event.type === 'update channelId') return {
                    ...event.context
                };
                return {};
            }),
            updateIdMap: (0, $7LdyK.assign)((context, event)=>{
                /**
         * The idMap is not persisted between each new experience.
         *
         * Multiple calls to this are expected from config items:
         * *selection -> markdown*
         * - The selection is always sent for 'range' selectionType config items.
         *
         * *document -> markdown*
         * - The document is always sent for 'empty' selectionType config items.
         * - The document can be sent for 'range' selectionType config items.
         */ if (event.type === 'update idMap') {
                    /**
           * - Always update the idMap in state on the first call.
           * - Always update the idMap in state if the selectionType is 'empty'
           *   as these config items won't ever have a user selection.
           */ if (!context.idMap || event.context.selectionType === 'empty') return {
                        idMap: {
                            ...event.context.idMap
                        }
                    };
                    /**
           * If the selectionType is 'range' we only want to store an idMap
           * for whatever the user has selected.
           */ if (event.context.selectionType === 'range') /**
             * - Always update the idMap in state for a user selection.
             * - Always update the idMap in state if the user has selected the document.
             * - Do not update the idMap if there have been multiple calls
             *   to updateIdMap where one of those calls was for the whole document
             *   and the other was for a user selection.
             */ {
                        if (event.context.idMap) {
                            /**
               * A selection cannot have more items than a document, so we can
               * compare map lengths to determine whether to update or not.
               *
               * If the user has selected the whole document, the incoming idMap
               * will have the same number of items as the idMap already in state.
               * */ const incomingIdMapIsUserSelection = event.context.idMap && Object.keys(event.context.idMap).length <= Object.keys(context.idMap).length;
                            if (incomingIdMapIsUserSelection) return {
                                idMap: {
                                    ...event.context.idMap
                                }
                            };
                        }
                    }
                    return {
                        idMap: {
                            ...context.idMap
                        }
                    };
                }
                return {};
            }),
            editPrompt: (0, $7LdyK.assign)((_context, event)=>{
                var _context$baseGenerate;
                if (event.type !== 'edit prompt') return {};
                // from 'neither base generate nor custom prompt'
                const isBaseGenerate = _context.configItem.title === ((_context$baseGenerate = _context.baseGenerate) === null || _context$baseGenerate === void 0 ? void 0 : _context$baseGenerate.title);
                const hasCustomPrompt = _context.configItem.promptLabel !== undefined;
                const isPresetPrompt = !isBaseGenerate && !hasCustomPrompt;
                let configItem = _context.configItem;
                if (isPresetPrompt && _context.baseGenerate) // from dismissCustomPrompt
                configItem = _context.baseGenerate;
                // If we detect a preset prompt, clear everything
                // otherwise preserve what we can.
                return {
                    markdown: undefined,
                    userInput: isPresetPrompt ? undefined : event.userInput,
                    userADFInput: isPresetPrompt ? undefined : event.userADFInput,
                    presetTitle: isPresetPrompt ? undefined : event.presetTitle,
                    configItem: configItem,
                    latestPromptResponse: undefined,
                    editCount: _context.editCount + 1,
                    idMap: undefined
                };
            }),
            incrementRetryPromptCount: (0, $7LdyK.assign)((context, _event)=>{
                return {
                    retryPromptCount: context.retryPromptCount + 1
                };
            }),
            updatePromptContextBasedOnTrigger: (0, $i1LcY.actions).choose([
                {
                    actions: (0, $7LdyK.assign)((_context, event)=>{
                        if (event.type === 'interrogate') return {
                            promptTrigger: 'interrogate',
                            latestPromptRetried: false
                        };
                        if (event.type === 'retry prompt') return {
                            latestPromptRetried: true
                        };
                        if (event.type === 'kickoff with command palette input') return {
                            promptTrigger: 'generate',
                            latestPromptRetried: false
                        };
                        return {};
                    })
                }
            ])
        },
        delays: {
            RETRY_ALLOWED: (context, event)=>{
                // Convert Retry-After value from seconds to milliseconds
                return event.retryAfter * 1000;
            // Typed as any due to old xstate version not handling
            // the inference correctly
            }
        },
        guards: {
            /**
       * TODO AIFOLLOWUP: promptLabel will be removed in favour of
       * adding an attribute to the config item to determine
       * whether a preset prompt supports additional user input
       * Adjust the conditions in setLatestPrompt's `choose` accordingly
       */ ['has custom prompt']: (context, event)=>{
                return context.configItem.promptLabel !== undefined;
            },
            ['is base generate']: (context, event)=>{
                var _context$baseGenerate2;
                // Doing configItem direct comparision fails in tests where we mutate or create custom
                // items.
                return context.configItem.title === ((_context$baseGenerate2 = context.baseGenerate) === null || _context$baseGenerate2 === void 0 ? void 0 : _context$baseGenerate2.title);
            },
            ['neither base generate nor custom prompt']: (context, event)=>{
                var _context$baseGenerate3;
                const isBaseGenerate = context.configItem.title === ((_context$baseGenerate3 = context.baseGenerate) === null || _context$baseGenerate3 === void 0 ? void 0 : _context$baseGenerate3.title);
                const hasCustomPrompt = context.configItem.promptLabel !== undefined;
                return !isBaseGenerate && !hasCustomPrompt;
            },
            ['if command input is empty']: (context, event)=>{
                var _context$userInput, _context$userInput$tr, _context$userInput$tr2;
                return ((_context$userInput = context.userInput) === null || _context$userInput === void 0 ? void 0 : (_context$userInput$tr = _context$userInput.trim) === null || _context$userInput$tr === void 0 ? void 0 : (_context$userInput$tr2 = _context$userInput$tr.call(_context$userInput)) === null || _context$userInput$tr2 === void 0 ? void 0 : _context$userInput$tr2.length) === 0;
            },
            ['is rovo agents FF on']: ()=>{
                // eslint-disable-next-line @atlaskit/platform/no-invalid-feature-flag-usage
                return (0, $XHGTv.getBooleanFF)('platform.editor.ai-rovo-agents');
            }
        }
    });
    return machine;
} // Typed explicitly due to old xstate version not having
 // type generation.
 // Whenever adding a new state to the machine -- you will need to update this union
 // Typed explicitly due to old xstate version not having
 // type generation
 // Whenever adding a new event to the machine -- you will need to update this union

});
parcelRegister("i1LcY", function(module, exports) {

$parcel$export(module.exports, "actions", () => $d1fcf095e553d783$export$e324594224ef24da);
$parcel$export(module.exports, "assign", () => (parcelRequire("7LdyK")).assign);
$parcel$export(module.exports, "send", () => (parcelRequire("7LdyK")).send);




var $7LdyK = parcelRequire("7LdyK");

var $cqUHI = parcelRequire("cqUHI");


var $8O42R = parcelRequire("8O42R");

var $a4kch = parcelRequire("a4kch");


var $d1fcf095e553d783$export$e324594224ef24da = {
    raise: (0, $7LdyK.raise),
    send: (0, $7LdyK.send),
    sendParent: (0, $7LdyK.sendParent),
    sendUpdate: (0, $7LdyK.sendUpdate),
    log: (0, $7LdyK.log),
    cancel: (0, $7LdyK.cancel),
    start: (0, $7LdyK.start),
    stop: (0, $7LdyK.stop),
    assign: (0, $7LdyK.assign),
    after: (0, $7LdyK.after),
    done: (0, $7LdyK.done),
    respond: (0, $7LdyK.respond),
    forwardTo: (0, $7LdyK.forwardTo),
    escalate: (0, $7LdyK.escalate),
    choose: (0, $7LdyK.choose),
    pure: (0, $7LdyK.pure)
};

});
parcelRegister("8O42R", function(module, exports) {

$parcel$export(module.exports, "createMachine", () => $6696218aa5f4035d$export$aaa7fa18f8e9b2e8);

var $fXyzN = parcelRequire("fXyzN");
function $6696218aa5f4035d$export$f391db14ff2d9279(config, options, initialContext) {
    if (initialContext === void 0) initialContext = config.context;
    var resolvedInitialContext = typeof initialContext === 'function' ? initialContext() : initialContext;
    return new (0, $fXyzN.StateNode)(config, options, resolvedInitialContext);
}
function $6696218aa5f4035d$export$aaa7fa18f8e9b2e8(config, options) {
    var resolvedInitialContext = typeof config.context === 'function' ? config.context() : config.context;
    return new (0, $fXyzN.StateNode)(config, options, resolvedInitialContext);
}

});
parcelRegister("fXyzN", function(module, exports) {

$parcel$export(module.exports, "StateNode", () => $b9e72fdf36b0016c$export$342f24f5edd47b1);

var $iRfl8 = parcelRequire("iRfl8");

var $l1Yh8 = parcelRequire("l1Yh8");

var $2vepS = parcelRequire("2vepS");

var $1Rgbm = parcelRequire("1Rgbm");

var $av07t = parcelRequire("av07t");

var $kUKMl = parcelRequire("kUKMl");

var $kWOvn = parcelRequire("kWOvn");

var $7LdyK = parcelRequire("7LdyK");

var $cqUHI = parcelRequire("cqUHI");

var $lUBej = parcelRequire("lUBej");

var $lxUZx = parcelRequire("lxUZx");
var $b9e72fdf36b0016c$var$NULL_EVENT = '';
var $b9e72fdf36b0016c$var$STATE_IDENTIFIER = '#';
var $b9e72fdf36b0016c$var$WILDCARD = '*';
var $b9e72fdf36b0016c$var$EMPTY_OBJECT = {};
var $b9e72fdf36b0016c$var$isStateId = function(str) {
    return str[0] === $b9e72fdf36b0016c$var$STATE_IDENTIFIER;
};
var $b9e72fdf36b0016c$var$createDefaultOptions = function() {
    return {
        actions: {},
        guards: {},
        services: {},
        activities: {},
        delays: {}
    };
};
var $b9e72fdf36b0016c$var$validateArrayifiedTransitions = function(stateNode, event, transitions) {
    var hasNonLastUnguardedTarget = transitions.slice(0, -1).some(function(transition) {
        return !('cond' in transition) && !('in' in transition) && ((0, $1Rgbm.isString)(transition.target) || (0, $1Rgbm.isMachine)(transition.target));
    });
    var eventText = event === $b9e72fdf36b0016c$var$NULL_EVENT ? 'the transient event' : "event '" + event + "'";
    (0, $1Rgbm.warn)(!hasNonLastUnguardedTarget, "One or more transitions for " + eventText + " on state '" + stateNode.id + "' are unreachable. " + "Make sure that the default transition is the last one defined.");
};
var $b9e72fdf36b0016c$export$342f24f5edd47b1 = /*#__PURE__*/ /** @class */ function() {
    function StateNode(/**
   * The raw config used to create the machine.
   */ config, options, /**
   * The initial extended state
   */ context // TODO: this is unsafe, but we're removing it in v5 anyway
    ) {
        var _this = this;
        if (context === void 0) context = undefined;
        var _a;
        this.config = config;
        this.context = context;
        /**
     * The order this state node appears. Corresponds to the implicit SCXML document order.
     */ this.order = -1;
        this.__xstatenode = true;
        this.__cache = {
            events: undefined,
            relativeValue: new Map(),
            initialStateValue: undefined,
            initialState: undefined,
            on: undefined,
            transitions: undefined,
            candidates: {},
            delayedTransitions: undefined
        };
        this.idMap = {};
        this.tags = [];
        this.options = Object.assign($b9e72fdf36b0016c$var$createDefaultOptions(), options);
        this.parent = this.options._parent;
        this.key = this.config.key || this.options._key || this.config.id || '(machine)';
        this.machine = this.parent ? this.parent.machine : this;
        this.path = this.parent ? this.parent.path.concat(this.key) : [];
        this.delimiter = this.config.delimiter || (this.parent ? this.parent.delimiter : (0, $l1Yh8.STATE_DELIMITER));
        this.id = this.config.id || (0, $iRfl8.__spreadArray)([
            this.machine.key
        ], (0, $iRfl8.__read)(this.path)).join(this.delimiter);
        this.version = this.parent ? this.parent.version : this.config.version;
        this.type = this.config.type || (this.config.parallel ? 'parallel' : this.config.states && (0, $1Rgbm.keys)(this.config.states).length ? 'compound' : this.config.history ? 'history' : 'atomic');
        this.schema = this.parent ? this.machine.schema : (_a = this.config.schema) !== null && _a !== void 0 ? _a : {};
        if (!(0, $2vepS.IS_PRODUCTION)) (0, $1Rgbm.warn)(!('parallel' in this.config), "The \"parallel\" property is deprecated and will be removed in version 4.1. " + (this.config.parallel ? "Replace with `type: 'parallel'`" : "Use `type: '" + this.type + "'`") + " in the config for state node '" + this.id + "' instead.");
        this.initial = this.config.initial;
        this.states = this.config.states ? (0, $1Rgbm.mapValues)(this.config.states, function(stateConfig, key) {
            var _a;
            var stateNode = new StateNode(stateConfig, {
                _parent: _this,
                _key: key
            });
            Object.assign(_this.idMap, (0, $iRfl8.__assign)((_a = {}, _a[stateNode.id] = stateNode, _a), stateNode.idMap));
            return stateNode;
        }) : $b9e72fdf36b0016c$var$EMPTY_OBJECT; // Document order
        var order = 0;
        function dfs(stateNode) {
            var e_1, _a;
            stateNode.order = order++;
            try {
                for(var _b = (0, $iRfl8.__values)((0, $kUKMl.getChildren)(stateNode)), _c = _b.next(); !_c.done; _c = _b.next()){
                    var child = _c.value;
                    dfs(child);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }
        dfs(this); // History config
        this.history = this.config.history === true ? 'shallow' : this.config.history || false;
        this._transient = !!this.config.always || (!this.config.on ? false : Array.isArray(this.config.on) ? this.config.on.some(function(_a) {
            var event = _a.event;
            return event === $b9e72fdf36b0016c$var$NULL_EVENT;
        }) : $b9e72fdf36b0016c$var$NULL_EVENT in this.config.on);
        this.strict = !!this.config.strict; // TODO: deprecate (entry)
        this.onEntry = (0, $1Rgbm.toArray)(this.config.entry || this.config.onEntry).map(function(action) {
            return (0, $7LdyK.toActionObject)(action);
        }); // TODO: deprecate (exit)
        this.onExit = (0, $1Rgbm.toArray)(this.config.exit || this.config.onExit).map(function(action) {
            return (0, $7LdyK.toActionObject)(action);
        });
        this.meta = this.config.meta;
        this.doneData = this.type === 'final' ? this.config.data : undefined;
        this.invoke = (0, $1Rgbm.toArray)(this.config.invoke).map(function(invokeConfig, i) {
            var _a, _b;
            if ((0, $1Rgbm.isMachine)(invokeConfig)) {
                _this.machine.options.services = (0, $iRfl8.__assign)((_a = {}, _a[invokeConfig.id] = invokeConfig, _a), _this.machine.options.services);
                return (0, $lxUZx.toInvokeDefinition)({
                    src: invokeConfig.id,
                    id: invokeConfig.id
                });
            } else if ((0, $1Rgbm.isString)(invokeConfig.src)) return (0, $lxUZx.toInvokeDefinition)((0, $iRfl8.__assign)((0, $iRfl8.__assign)({}, invokeConfig), {
                id: invokeConfig.id || invokeConfig.src,
                src: invokeConfig.src
            }));
            else if ((0, $1Rgbm.isMachine)(invokeConfig.src) || (0, $1Rgbm.isFunction)(invokeConfig.src)) {
                var invokeSrc = _this.id + ":invocation[" + i + "]"; // TODO: util function
                _this.machine.options.services = (0, $iRfl8.__assign)((_b = {}, _b[invokeSrc] = invokeConfig.src, _b), _this.machine.options.services);
                return (0, $lxUZx.toInvokeDefinition)((0, $iRfl8.__assign)((0, $iRfl8.__assign)({
                    id: invokeSrc
                }, invokeConfig), {
                    src: invokeSrc
                }));
            } else {
                var invokeSource = invokeConfig.src;
                return (0, $lxUZx.toInvokeDefinition)((0, $iRfl8.__assign)((0, $iRfl8.__assign)({
                    id: invokeSource.type
                }, invokeConfig), {
                    src: invokeSource
                }));
            }
        });
        this.activities = (0, $1Rgbm.toArray)(this.config.activities).concat(this.invoke).map(function(activity) {
            return (0, $7LdyK.toActivityDefinition)(activity);
        });
        this.transition = this.transition.bind(this);
        this.tags = (0, $1Rgbm.toArray)(this.config.tags); // TODO: this is the real fix for initialization once
    // state node getters are deprecated
    // if (!this.parent) {
    //   this._init();
    // }
    }
    StateNode.prototype._init = function() {
        if (this.__cache.transitions) return;
        (0, $kUKMl.getAllStateNodes)(this).forEach(function(stateNode) {
            return stateNode.on;
        });
    };
    /**
   * Clones this state machine with custom options and context.
   *
   * @param options Options (actions, guards, activities, services) to recursively merge with the existing options.
   * @param context Custom context (will override predefined context)
   */ StateNode.prototype.withConfig = function(options, context) {
        if (context === void 0) context = this.context;
        var _a = this.options, actions = _a.actions, activities = _a.activities, guards = _a.guards, services = _a.services, delays = _a.delays;
        return new StateNode(this.config, {
            actions: (0, $iRfl8.__assign)((0, $iRfl8.__assign)({}, actions), options.actions),
            activities: (0, $iRfl8.__assign)((0, $iRfl8.__assign)({}, activities), options.activities),
            guards: (0, $iRfl8.__assign)((0, $iRfl8.__assign)({}, guards), options.guards),
            services: (0, $iRfl8.__assign)((0, $iRfl8.__assign)({}, services), options.services),
            delays: (0, $iRfl8.__assign)((0, $iRfl8.__assign)({}, delays), options.delays)
        }, context);
    };
    /**
   * Clones this state machine with custom context.
   *
   * @param context Custom context (will override predefined context, not recursive)
   */ StateNode.prototype.withContext = function(context) {
        return new StateNode(this.config, this.options, context);
    };
    Object.defineProperty(StateNode.prototype, "definition", {
        /**
     * The well-structured state node definition.
     */ get: function() {
            return {
                id: this.id,
                key: this.key,
                version: this.version,
                context: this.context,
                type: this.type,
                initial: this.initial,
                history: this.history,
                states: (0, $1Rgbm.mapValues)(this.states, function(state) {
                    return state.definition;
                }),
                on: this.on,
                transitions: this.transitions,
                entry: this.onEntry,
                exit: this.onExit,
                activities: this.activities || [],
                meta: this.meta,
                order: this.order || -1,
                data: this.doneData,
                invoke: this.invoke
            };
        },
        enumerable: false,
        configurable: true
    });
    StateNode.prototype.toJSON = function() {
        return this.definition;
    };
    Object.defineProperty(StateNode.prototype, "on", {
        /**
     * The mapping of events to transitions.
     */ get: function() {
            if (this.__cache.on) return this.__cache.on;
            var transitions = this.transitions;
            return this.__cache.on = transitions.reduce(function(map, transition) {
                map[transition.eventType] = map[transition.eventType] || [];
                map[transition.eventType].push(transition);
                return map;
            }, {});
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "after", {
        get: function() {
            return this.__cache.delayedTransitions || (this.__cache.delayedTransitions = this.getDelayedTransitions(), this.__cache.delayedTransitions);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "transitions", {
        /**
     * All the transitions that can be taken from this state node.
     */ get: function() {
            return this.__cache.transitions || (this.__cache.transitions = this.formatTransitions(), this.__cache.transitions);
        },
        enumerable: false,
        configurable: true
    });
    StateNode.prototype.getCandidates = function(eventName) {
        if (this.__cache.candidates[eventName]) return this.__cache.candidates[eventName];
        var transient = eventName === $b9e72fdf36b0016c$var$NULL_EVENT;
        var candidates = this.transitions.filter(function(transition) {
            var sameEventType = transition.eventType === eventName; // null events should only match against eventless transitions
            return transient ? sameEventType : sameEventType || transition.eventType === $b9e72fdf36b0016c$var$WILDCARD;
        });
        this.__cache.candidates[eventName] = candidates;
        return candidates;
    };
    /**
   * All delayed transitions from the config.
   */ StateNode.prototype.getDelayedTransitions = function() {
        var _this = this;
        var afterConfig = this.config.after;
        if (!afterConfig) return [];
        var mutateEntryExit = function(delay, i) {
            var delayRef = (0, $1Rgbm.isFunction)(delay) ? _this.id + ":delay[" + i + "]" : delay;
            var eventType = (0, $7LdyK.after)(delayRef, _this.id);
            _this.onEntry.push((0, $7LdyK.send)(eventType, {
                delay: delay
            }));
            _this.onExit.push((0, $7LdyK.cancel)(eventType));
            return eventType;
        };
        var delayedTransitions = (0, $1Rgbm.isArray)(afterConfig) ? afterConfig.map(function(transition, i) {
            var eventType = mutateEntryExit(transition.delay, i);
            return (0, $iRfl8.__assign)((0, $iRfl8.__assign)({}, transition), {
                event: eventType
            });
        }) : (0, $1Rgbm.flatten)((0, $1Rgbm.keys)(afterConfig).map(function(delay, i) {
            var configTransition = afterConfig[delay];
            var resolvedTransition = (0, $1Rgbm.isString)(configTransition) ? {
                target: configTransition
            } : configTransition;
            var resolvedDelay = !isNaN(+delay) ? +delay : delay;
            var eventType = mutateEntryExit(resolvedDelay, i);
            return (0, $1Rgbm.toArray)(resolvedTransition).map(function(transition) {
                return (0, $iRfl8.__assign)((0, $iRfl8.__assign)({}, transition), {
                    event: eventType,
                    delay: resolvedDelay
                });
            });
        }));
        return delayedTransitions.map(function(delayedTransition) {
            var delay = delayedTransition.delay;
            return (0, $iRfl8.__assign)((0, $iRfl8.__assign)({}, _this.formatTransition(delayedTransition)), {
                delay: delay
            });
        });
    };
    /**
   * Returns the state nodes represented by the current state value.
   *
   * @param state The state value or State instance
   */ StateNode.prototype.getStateNodes = function(state) {
        var _a;
        var _this = this;
        if (!state) return [];
        var stateValue = state instanceof (0, $cqUHI.State) ? state.value : (0, $1Rgbm.toStateValue)(state, this.delimiter);
        if ((0, $1Rgbm.isString)(stateValue)) {
            var initialStateValue = this.getStateNode(stateValue).initial;
            return initialStateValue !== undefined ? this.getStateNodes((_a = {}, _a[stateValue] = initialStateValue, _a)) : [
                this,
                this.states[stateValue]
            ];
        }
        var subStateKeys = (0, $1Rgbm.keys)(stateValue);
        var subStateNodes = subStateKeys.map(function(subStateKey) {
            return _this.getStateNode(subStateKey);
        });
        subStateNodes.push(this);
        return subStateNodes.concat(subStateKeys.reduce(function(allSubStateNodes, subStateKey) {
            var subStateNode = _this.getStateNode(subStateKey).getStateNodes(stateValue[subStateKey]);
            return allSubStateNodes.concat(subStateNode);
        }, []));
    };
    /**
   * Returns `true` if this state node explicitly handles the given event.
   *
   * @param event The event in question
   */ StateNode.prototype.handles = function(event) {
        var eventType = (0, $1Rgbm.getEventType)(event);
        return this.events.includes(eventType);
    };
    /**
   * Resolves the given `state` to a new `State` instance relative to this machine.
   *
   * This ensures that `.events` and `.nextEvents` represent the correct values.
   *
   * @param state The state to resolve
   */ StateNode.prototype.resolveState = function(state) {
        var configuration = Array.from((0, $kUKMl.getConfiguration)([], this.getStateNodes(state.value)));
        return new (0, $cqUHI.State)((0, $iRfl8.__assign)((0, $iRfl8.__assign)({}, state), {
            value: this.resolve(state.value),
            configuration: configuration,
            done: (0, $kUKMl.isInFinalState)(configuration, this)
        }));
    };
    StateNode.prototype.transitionLeafNode = function(stateValue, state, _event) {
        var stateNode = this.getStateNode(stateValue);
        var next = stateNode.next(state, _event);
        if (!next || !next.transitions.length) return this.next(state, _event);
        return next;
    };
    StateNode.prototype.transitionCompoundNode = function(stateValue, state, _event) {
        var subStateKeys = (0, $1Rgbm.keys)(stateValue);
        var stateNode = this.getStateNode(subStateKeys[0]);
        var next = stateNode._transition(stateValue[subStateKeys[0]], state, _event);
        if (!next || !next.transitions.length) return this.next(state, _event);
        return next;
    };
    StateNode.prototype.transitionParallelNode = function(stateValue, state, _event) {
        var e_2, _a;
        var transitionMap = {};
        try {
            for(var _b = (0, $iRfl8.__values)((0, $1Rgbm.keys)(stateValue)), _c = _b.next(); !_c.done; _c = _b.next()){
                var subStateKey = _c.value;
                var subStateValue = stateValue[subStateKey];
                if (!subStateValue) continue;
                var subStateNode = this.getStateNode(subStateKey);
                var next = subStateNode._transition(subStateValue, state, _event);
                if (next) transitionMap[subStateKey] = next;
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        var stateTransitions = (0, $1Rgbm.keys)(transitionMap).map(function(key) {
            return transitionMap[key];
        });
        var enabledTransitions = (0, $1Rgbm.flatten)(stateTransitions.map(function(st) {
            return st.transitions;
        }));
        var willTransition = stateTransitions.some(function(st) {
            return st.transitions.length > 0;
        });
        if (!willTransition) return this.next(state, _event);
        var entryNodes = (0, $1Rgbm.flatten)(stateTransitions.map(function(t) {
            return t.entrySet;
        }));
        var configuration = (0, $1Rgbm.flatten)((0, $1Rgbm.keys)(transitionMap).map(function(key) {
            return transitionMap[key].configuration;
        }));
        return {
            transitions: enabledTransitions,
            entrySet: entryNodes,
            exitSet: (0, $1Rgbm.flatten)(stateTransitions.map(function(t) {
                return t.exitSet;
            })),
            configuration: configuration,
            source: state,
            actions: (0, $1Rgbm.flatten)((0, $1Rgbm.keys)(transitionMap).map(function(key) {
                return transitionMap[key].actions;
            }))
        };
    };
    StateNode.prototype._transition = function(stateValue, state, _event) {
        // leaf node
        if ((0, $1Rgbm.isString)(stateValue)) return this.transitionLeafNode(stateValue, state, _event);
         // hierarchical node
        if ((0, $1Rgbm.keys)(stateValue).length === 1) return this.transitionCompoundNode(stateValue, state, _event);
         // orthogonal node
        return this.transitionParallelNode(stateValue, state, _event);
    };
    StateNode.prototype.next = function(state, _event) {
        var e_3, _a;
        var _this = this;
        var eventName = _event.name;
        var actions = [];
        var nextStateNodes = [];
        var selectedTransition;
        try {
            for(var _b = (0, $iRfl8.__values)(this.getCandidates(eventName)), _c = _b.next(); !_c.done; _c = _b.next()){
                var candidate = _c.value;
                var cond = candidate.cond, stateIn = candidate.in;
                var resolvedContext = state.context;
                var isInState = stateIn ? (0, $1Rgbm.isString)(stateIn) && $b9e72fdf36b0016c$var$isStateId(stateIn) ? state.matches((0, $1Rgbm.toStateValue)(this.getStateNodeById(stateIn).path, this.delimiter)) : (0, $1Rgbm.matchesState)((0, $1Rgbm.toStateValue)(stateIn, this.delimiter), (0, $1Rgbm.path)(this.path.slice(0, -2))(state.value)) : true;
                var guardPassed = false;
                try {
                    guardPassed = !cond || (0, $1Rgbm.evaluateGuard)(this.machine, cond, resolvedContext, _event, state);
                } catch (err) {
                    throw new Error("Unable to evaluate guard '" + (cond.name || cond.type) + "' in transition for event '" + eventName + "' in state node '" + this.id + "':\n" + err.message);
                }
                if (guardPassed && isInState) {
                    if (candidate.target !== undefined) nextStateNodes = candidate.target;
                    actions.push.apply(actions, (0, $iRfl8.__spreadArray)([], (0, $iRfl8.__read)(candidate.actions)));
                    selectedTransition = candidate;
                    break;
                }
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        if (!selectedTransition) return undefined;
        if (!nextStateNodes.length) return {
            transitions: [
                selectedTransition
            ],
            entrySet: [],
            exitSet: [],
            configuration: state.value ? [
                this
            ] : [],
            source: state,
            actions: actions
        };
        var allNextStateNodes = (0, $1Rgbm.flatten)(nextStateNodes.map(function(stateNode) {
            return _this.getRelativeStateNodes(stateNode, state.historyValue);
        }));
        var isInternal = !!selectedTransition.internal;
        var reentryNodes = isInternal ? [] : (0, $1Rgbm.flatten)(allNextStateNodes.map(function(n) {
            return _this.nodesFromChild(n);
        }));
        return {
            transitions: [
                selectedTransition
            ],
            entrySet: reentryNodes,
            exitSet: isInternal ? [] : [
                this
            ],
            configuration: allNextStateNodes,
            source: state,
            actions: actions
        };
    };
    StateNode.prototype.nodesFromChild = function(childStateNode) {
        if (childStateNode.escapes(this)) return [];
        var nodes = [];
        var marker = childStateNode;
        while(marker && marker !== this){
            nodes.push(marker);
            marker = marker.parent;
        }
        nodes.push(this); // inclusive
        return nodes;
    };
    /**
   * Whether the given state node "escapes" this state node. If the `stateNode` is equal to or the parent of
   * this state node, it does not escape.
   */ StateNode.prototype.escapes = function(stateNode) {
        if (this === stateNode) return false;
        var parent = this.parent;
        while(parent){
            if (parent === stateNode) return false;
            parent = parent.parent;
        }
        return true;
    };
    StateNode.prototype.getActions = function(transition, currentContext, _event, prevState) {
        var e_4, _a, e_5, _b;
        var prevConfig = (0, $kUKMl.getConfiguration)([], prevState ? this.getStateNodes(prevState.value) : [
            this
        ]);
        var resolvedConfig = transition.configuration.length ? (0, $kUKMl.getConfiguration)(prevConfig, transition.configuration) : prevConfig;
        try {
            for(var resolvedConfig_1 = (0, $iRfl8.__values)(resolvedConfig), resolvedConfig_1_1 = resolvedConfig_1.next(); !resolvedConfig_1_1.done; resolvedConfig_1_1 = resolvedConfig_1.next()){
                var sn = resolvedConfig_1_1.value;
                if (!(0, $kUKMl.has)(prevConfig, sn)) transition.entrySet.push(sn);
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (resolvedConfig_1_1 && !resolvedConfig_1_1.done && (_a = resolvedConfig_1.return)) _a.call(resolvedConfig_1);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        try {
            for(var prevConfig_1 = (0, $iRfl8.__values)(prevConfig), prevConfig_1_1 = prevConfig_1.next(); !prevConfig_1_1.done; prevConfig_1_1 = prevConfig_1.next()){
                var sn = prevConfig_1_1.value;
                if (!(0, $kUKMl.has)(resolvedConfig, sn) || (0, $kUKMl.has)(transition.exitSet, sn.parent)) transition.exitSet.push(sn);
            }
        } catch (e_5_1) {
            e_5 = {
                error: e_5_1
            };
        } finally{
            try {
                if (prevConfig_1_1 && !prevConfig_1_1.done && (_b = prevConfig_1.return)) _b.call(prevConfig_1);
            } finally{
                if (e_5) throw e_5.error;
            }
        }
        if (!transition.source) {
            transition.exitSet = []; // Ensure that root StateNode (machine) is entered
            transition.entrySet.push(this);
        }
        var doneEvents = (0, $1Rgbm.flatten)(transition.entrySet.map(function(sn) {
            var events = [];
            if (sn.type !== 'final') return events;
            var parent = sn.parent;
            if (!parent.parent) return events;
            events.push((0, $7LdyK.done)(sn.id, sn.doneData), (0, $7LdyK.done)(parent.id, sn.doneData ? (0, $1Rgbm.mapContext)(sn.doneData, currentContext, _event) : undefined));
            var grandparent = parent.parent;
            if (grandparent.type === 'parallel') {
                if ((0, $kUKMl.getChildren)(grandparent).every(function(parentNode) {
                    return (0, $kUKMl.isInFinalState)(transition.configuration, parentNode);
                })) events.push((0, $7LdyK.done)(grandparent.id));
            }
            return events;
        }));
        transition.exitSet.sort(function(a, b) {
            return b.order - a.order;
        });
        transition.entrySet.sort(function(a, b) {
            return a.order - b.order;
        });
        var entryStates = new Set(transition.entrySet);
        var exitStates = new Set(transition.exitSet);
        var _c = (0, $iRfl8.__read)([
            (0, $1Rgbm.flatten)(Array.from(entryStates).map(function(stateNode) {
                return (0, $iRfl8.__spreadArray)((0, $iRfl8.__spreadArray)([], (0, $iRfl8.__read)(stateNode.activities.map(function(activity) {
                    return (0, $7LdyK.start)(activity);
                }))), (0, $iRfl8.__read)(stateNode.onEntry));
            })).concat(doneEvents.map((0, $7LdyK.raise))),
            (0, $1Rgbm.flatten)(Array.from(exitStates).map(function(stateNode) {
                return (0, $iRfl8.__spreadArray)((0, $iRfl8.__spreadArray)([], (0, $iRfl8.__read)(stateNode.onExit)), (0, $iRfl8.__read)(stateNode.activities.map(function(activity) {
                    return (0, $7LdyK.stop)(activity);
                })));
            }))
        ], 2), entryActions = _c[0], exitActions = _c[1];
        var actions = (0, $7LdyK.toActionObjects)(exitActions.concat(transition.actions).concat(entryActions), this.machine.options.actions);
        return actions;
    };
    /**
   * Determines the next state given the current `state` and sent `event`.
   *
   * @param state The current State instance or state value
   * @param event The event that was sent at the current state
   * @param context The current context (extended state) of the current state
   */ StateNode.prototype.transition = function(state, event, context) {
        if (state === void 0) state = this.initialState;
        var _event = (0, $1Rgbm.toSCXMLEvent)(event);
        var currentState;
        if (state instanceof (0, $cqUHI.State)) currentState = context === undefined ? state : this.resolveState((0, $cqUHI.State).from(state, context));
        else {
            var resolvedStateValue = (0, $1Rgbm.isString)(state) ? this.resolve((0, $1Rgbm.pathToStateValue)(this.getResolvedPath(state))) : this.resolve(state);
            var resolvedContext = context ? context : this.machine.context;
            currentState = this.resolveState((0, $cqUHI.State).from(resolvedStateValue, resolvedContext));
        }
        if (!(0, $2vepS.IS_PRODUCTION) && _event.name === $b9e72fdf36b0016c$var$WILDCARD) throw new Error("An event cannot have the wildcard type ('" + $b9e72fdf36b0016c$var$WILDCARD + "')");
        if (this.strict) {
            if (!this.events.includes(_event.name) && !(0, $1Rgbm.isBuiltInEvent)(_event.name)) throw new Error("Machine '" + this.id + "' does not accept event '" + _event.name + "'");
        }
        var stateTransition = this._transition(currentState.value, currentState, _event) || {
            transitions: [],
            configuration: [],
            entrySet: [],
            exitSet: [],
            source: currentState,
            actions: []
        };
        var prevConfig = (0, $kUKMl.getConfiguration)([], this.getStateNodes(currentState.value));
        var resolvedConfig = stateTransition.configuration.length ? (0, $kUKMl.getConfiguration)(prevConfig, stateTransition.configuration) : prevConfig;
        stateTransition.configuration = (0, $iRfl8.__spreadArray)([], (0, $iRfl8.__read)(resolvedConfig));
        return this.resolveTransition(stateTransition, currentState, _event);
    };
    StateNode.prototype.resolveRaisedTransition = function(state, _event, originalEvent) {
        var _a;
        var currentActions = state.actions;
        state = this.transition(state, _event); // Save original event to state
        // TODO: this should be the raised event! Delete in V5 (breaking)
        state._event = originalEvent;
        state.event = originalEvent.data;
        (_a = state.actions).unshift.apply(_a, (0, $iRfl8.__spreadArray)([], (0, $iRfl8.__read)(currentActions)));
        return state;
    };
    StateNode.prototype.resolveTransition = function(stateTransition, currentState, _event, context) {
        var e_6, _a;
        var _this = this;
        if (_event === void 0) _event = (0, $7LdyK.initEvent);
        if (context === void 0) context = this.machine.context;
        var configuration = stateTransition.configuration; // Transition will "apply" if:
        // - this is the initial state (there is no current state)
        // - OR there are transitions
        var willTransition = !currentState || stateTransition.transitions.length > 0;
        var resolvedStateValue = willTransition ? (0, $kUKMl.getValue)(this.machine, configuration) : undefined;
        var historyValue = currentState ? currentState.historyValue ? currentState.historyValue : stateTransition.source ? this.machine.historyValue(currentState.value) : undefined : undefined;
        var currentContext = currentState ? currentState.context : context;
        var actions = this.getActions(stateTransition, currentContext, _event, currentState);
        var activities = currentState ? (0, $iRfl8.__assign)({}, currentState.activities) : {};
        try {
            for(var actions_1 = (0, $iRfl8.__values)(actions), actions_1_1 = actions_1.next(); !actions_1_1.done; actions_1_1 = actions_1.next()){
                var action = actions_1_1.value;
                if (action.type === (0, $kWOvn.start)) activities[action.activity.id || action.activity.type] = action;
                else if (action.type === (0, $kWOvn.stop)) activities[action.activity.id || action.activity.type] = false;
            }
        } catch (e_6_1) {
            e_6 = {
                error: e_6_1
            };
        } finally{
            try {
                if (actions_1_1 && !actions_1_1.done && (_a = actions_1.return)) _a.call(actions_1);
            } finally{
                if (e_6) throw e_6.error;
            }
        }
        var _b = (0, $iRfl8.__read)((0, $7LdyK.resolveActions)(this, currentState, currentContext, _event, actions), 2), resolvedActions = _b[0], updatedContext = _b[1];
        var _c = (0, $iRfl8.__read)((0, $1Rgbm.partition)(resolvedActions, function(action) {
            return action.type === (0, $kWOvn.raise) || action.type === (0, $kWOvn.send) && action.to === (0, $av07t.SpecialTargets).Internal;
        }), 2), raisedEvents = _c[0], nonRaisedActions = _c[1];
        var invokeActions = resolvedActions.filter(function(action) {
            var _a;
            return action.type === (0, $kWOvn.start) && ((_a = action.activity) === null || _a === void 0 ? void 0 : _a.type) === (0, $kWOvn.invoke);
        });
        var children = invokeActions.reduce(function(acc, action) {
            acc[action.activity.id] = (0, $lUBej.createInvocableActor)(action.activity, _this.machine, updatedContext, _event);
            return acc;
        }, currentState ? (0, $iRfl8.__assign)({}, currentState.children) : {});
        var resolvedConfiguration = resolvedStateValue ? stateTransition.configuration : currentState ? currentState.configuration : [];
        var meta = resolvedConfiguration.reduce(function(acc, stateNode) {
            if (stateNode.meta !== undefined) acc[stateNode.id] = stateNode.meta;
            return acc;
        }, {});
        var isDone = (0, $kUKMl.isInFinalState)(resolvedConfiguration, this);
        var nextState = new (0, $cqUHI.State)({
            value: resolvedStateValue || currentState.value,
            context: updatedContext,
            _event: _event,
            // Persist _sessionid between states
            _sessionid: currentState ? currentState._sessionid : null,
            historyValue: resolvedStateValue ? historyValue ? (0, $1Rgbm.updateHistoryValue)(historyValue, resolvedStateValue) : undefined : currentState ? currentState.historyValue : undefined,
            history: !resolvedStateValue || stateTransition.source ? currentState : undefined,
            actions: resolvedStateValue ? nonRaisedActions : [],
            activities: resolvedStateValue ? activities : currentState ? currentState.activities : {},
            meta: resolvedStateValue ? meta : currentState ? currentState.meta : undefined,
            events: [],
            configuration: resolvedConfiguration,
            transitions: stateTransition.transitions,
            children: children,
            done: isDone,
            tags: currentState === null || currentState === void 0 ? void 0 : currentState.tags
        });
        var didUpdateContext = currentContext !== updatedContext;
        nextState.changed = _event.name === (0, $kWOvn.update) || didUpdateContext; // Dispose of penultimate histories to prevent memory leaks
        var history = nextState.history;
        if (history) delete history.history;
        if (!resolvedStateValue) return nextState;
        var maybeNextState = nextState;
        if (!isDone) {
            var isTransient = this._transient || configuration.some(function(stateNode) {
                return stateNode._transient;
            });
            if (isTransient) maybeNextState = this.resolveRaisedTransition(maybeNextState, {
                type: (0, $kWOvn.nullEvent)
            }, _event);
            while(raisedEvents.length){
                var raisedEvent = raisedEvents.shift();
                maybeNextState = this.resolveRaisedTransition(maybeNextState, raisedEvent._event, _event);
            }
        } // Detect if state changed
        var changed = maybeNextState.changed || (history ? !!maybeNextState.actions.length || didUpdateContext || typeof history.value !== typeof maybeNextState.value || !(0, $cqUHI.stateValuesEqual)(maybeNextState.value, history.value) : undefined);
        maybeNextState.changed = changed; // Preserve original history after raised events
        maybeNextState.history = history;
        maybeNextState.tags = new Set((0, $1Rgbm.flatten)(maybeNextState.configuration.map(function(sn) {
            return sn.tags;
        })));
        return maybeNextState;
    };
    /**
   * Returns the child state node from its relative `stateKey`, or throws.
   */ StateNode.prototype.getStateNode = function(stateKey) {
        if ($b9e72fdf36b0016c$var$isStateId(stateKey)) return this.machine.getStateNodeById(stateKey);
        if (!this.states) throw new Error("Unable to retrieve child state '" + stateKey + "' from '" + this.id + "'; no child states exist.");
        var result = this.states[stateKey];
        if (!result) throw new Error("Child state '" + stateKey + "' does not exist on '" + this.id + "'");
        return result;
    };
    /**
   * Returns the state node with the given `stateId`, or throws.
   *
   * @param stateId The state ID. The prefix "#" is removed.
   */ StateNode.prototype.getStateNodeById = function(stateId) {
        var resolvedStateId = $b9e72fdf36b0016c$var$isStateId(stateId) ? stateId.slice($b9e72fdf36b0016c$var$STATE_IDENTIFIER.length) : stateId;
        if (resolvedStateId === this.id) return this;
        var stateNode = this.machine.idMap[resolvedStateId];
        if (!stateNode) throw new Error("Child state node '#" + resolvedStateId + "' does not exist on machine '" + this.id + "'");
        return stateNode;
    };
    /**
   * Returns the relative state node from the given `statePath`, or throws.
   *
   * @param statePath The string or string array relative path to the state node.
   */ StateNode.prototype.getStateNodeByPath = function(statePath) {
        if (typeof statePath === 'string' && $b9e72fdf36b0016c$var$isStateId(statePath)) try {
            return this.getStateNodeById(statePath.slice(1));
        } catch (e) {
        // throw e;
        }
        var arrayStatePath = (0, $1Rgbm.toStatePath)(statePath, this.delimiter).slice();
        var currentStateNode = this;
        while(arrayStatePath.length){
            var key = arrayStatePath.shift();
            if (!key.length) break;
            currentStateNode = currentStateNode.getStateNode(key);
        }
        return currentStateNode;
    };
    /**
   * Resolves a partial state value with its full representation in this machine.
   *
   * @param stateValue The partial state value to resolve.
   */ StateNode.prototype.resolve = function(stateValue) {
        var _a;
        var _this = this;
        if (!stateValue) return this.initialStateValue || $b9e72fdf36b0016c$var$EMPTY_OBJECT; // TODO: type-specific properties
        switch(this.type){
            case 'parallel':
                return (0, $1Rgbm.mapValues)(this.initialStateValue, function(subStateValue, subStateKey) {
                    return subStateValue ? _this.getStateNode(subStateKey).resolve(stateValue[subStateKey] || subStateValue) : $b9e72fdf36b0016c$var$EMPTY_OBJECT;
                });
            case 'compound':
                if ((0, $1Rgbm.isString)(stateValue)) {
                    var subStateNode = this.getStateNode(stateValue);
                    if (subStateNode.type === 'parallel' || subStateNode.type === 'compound') return _a = {}, _a[stateValue] = subStateNode.initialStateValue, _a;
                    return stateValue;
                }
                if (!(0, $1Rgbm.keys)(stateValue).length) return this.initialStateValue || {};
                return (0, $1Rgbm.mapValues)(stateValue, function(subStateValue, subStateKey) {
                    return subStateValue ? _this.getStateNode(subStateKey).resolve(subStateValue) : $b9e72fdf36b0016c$var$EMPTY_OBJECT;
                });
            default:
                return stateValue || $b9e72fdf36b0016c$var$EMPTY_OBJECT;
        }
    };
    StateNode.prototype.getResolvedPath = function(stateIdentifier) {
        if ($b9e72fdf36b0016c$var$isStateId(stateIdentifier)) {
            var stateNode = this.machine.idMap[stateIdentifier.slice($b9e72fdf36b0016c$var$STATE_IDENTIFIER.length)];
            if (!stateNode) throw new Error("Unable to find state node '" + stateIdentifier + "'");
            return stateNode.path;
        }
        return (0, $1Rgbm.toStatePath)(stateIdentifier, this.delimiter);
    };
    Object.defineProperty(StateNode.prototype, "initialStateValue", {
        get: function() {
            var _a;
            if (this.__cache.initialStateValue) return this.__cache.initialStateValue;
            var initialStateValue;
            if (this.type === 'parallel') initialStateValue = (0, $1Rgbm.mapFilterValues)(this.states, function(state) {
                return state.initialStateValue || $b9e72fdf36b0016c$var$EMPTY_OBJECT;
            }, function(stateNode) {
                return !(stateNode.type === 'history');
            });
            else if (this.initial !== undefined) {
                if (!this.states[this.initial]) throw new Error("Initial state '" + this.initial + "' not found on '" + this.key + "'");
                initialStateValue = (0, $kUKMl.isLeafNode)(this.states[this.initial]) ? this.initial : (_a = {}, _a[this.initial] = this.states[this.initial].initialStateValue, _a);
            } else // The finite state value of a machine without child states is just an empty object
            initialStateValue = {};
            this.__cache.initialStateValue = initialStateValue;
            return this.__cache.initialStateValue;
        },
        enumerable: false,
        configurable: true
    });
    StateNode.prototype.getInitialState = function(stateValue, context) {
        var configuration = this.getStateNodes(stateValue);
        return this.resolveTransition({
            configuration: configuration,
            entrySet: configuration,
            exitSet: [],
            transitions: [],
            source: undefined,
            actions: []
        }, undefined, undefined, context);
    };
    Object.defineProperty(StateNode.prototype, "initialState", {
        /**
     * The initial State instance, which includes all actions to be executed from
     * entering the initial state.
     */ get: function() {
            this._init(); // TODO: this should be in the constructor (see note in constructor)
            var initialStateValue = this.initialStateValue;
            if (!initialStateValue) throw new Error("Cannot retrieve initial state from simple state '" + this.id + "'.");
            return this.getInitialState(initialStateValue);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "target", {
        /**
     * The target state value of the history state node, if it exists. This represents the
     * default state value to transition to if no history value exists yet.
     */ get: function() {
            var target;
            if (this.type === 'history') {
                var historyConfig = this.config;
                if ((0, $1Rgbm.isString)(historyConfig.target)) target = $b9e72fdf36b0016c$var$isStateId(historyConfig.target) ? (0, $1Rgbm.pathToStateValue)(this.machine.getStateNodeById(historyConfig.target).path.slice(this.path.length - 1)) : historyConfig.target;
                else target = historyConfig.target;
            }
            return target;
        },
        enumerable: false,
        configurable: true
    });
    /**
   * Returns the leaf nodes from a state path relative to this state node.
   *
   * @param relativeStateId The relative state path to retrieve the state nodes
   * @param history The previous state to retrieve history
   * @param resolve Whether state nodes should resolve to initial child state nodes
   */ StateNode.prototype.getRelativeStateNodes = function(relativeStateId, historyValue, resolve) {
        if (resolve === void 0) resolve = true;
        return resolve ? relativeStateId.type === 'history' ? relativeStateId.resolveHistory(historyValue) : relativeStateId.initialStateNodes : [
            relativeStateId
        ];
    };
    Object.defineProperty(StateNode.prototype, "initialStateNodes", {
        get: function() {
            var _this = this;
            if ((0, $kUKMl.isLeafNode)(this)) return [
                this
            ];
             // Case when state node is compound but no initial state is defined
            if (this.type === 'compound' && !this.initial) {
                if (!(0, $2vepS.IS_PRODUCTION)) (0, $1Rgbm.warn)(false, "Compound state node '" + this.id + "' has no initial state.");
                return [
                    this
                ];
            }
            var initialStateNodePaths = (0, $1Rgbm.toStatePaths)(this.initialStateValue);
            return (0, $1Rgbm.flatten)(initialStateNodePaths.map(function(initialPath) {
                return _this.getFromRelativePath(initialPath);
            }));
        },
        enumerable: false,
        configurable: true
    });
    /**
   * Retrieves state nodes from a relative path to this state node.
   *
   * @param relativePath The relative path from this state node
   * @param historyValue
   */ StateNode.prototype.getFromRelativePath = function(relativePath) {
        if (!relativePath.length) return [
            this
        ];
        var _a = (0, $iRfl8.__read)(relativePath), stateKey = _a[0], childStatePath = _a.slice(1);
        if (!this.states) throw new Error("Cannot retrieve subPath '" + stateKey + "' from node with no states");
        var childStateNode = this.getStateNode(stateKey);
        if (childStateNode.type === 'history') return childStateNode.resolveHistory();
        if (!this.states[stateKey]) throw new Error("Child state '" + stateKey + "' does not exist on '" + this.id + "'");
        return this.states[stateKey].getFromRelativePath(childStatePath);
    };
    StateNode.prototype.historyValue = function(relativeStateValue) {
        if (!(0, $1Rgbm.keys)(this.states).length) return undefined;
        return {
            current: relativeStateValue || this.initialStateValue,
            states: (0, $1Rgbm.mapFilterValues)(this.states, function(stateNode, key) {
                if (!relativeStateValue) return stateNode.historyValue();
                var subStateValue = (0, $1Rgbm.isString)(relativeStateValue) ? undefined : relativeStateValue[key];
                return stateNode.historyValue(subStateValue || stateNode.initialStateValue);
            }, function(stateNode) {
                return !stateNode.history;
            })
        };
    };
    /**
   * Resolves to the historical value(s) of the parent state node,
   * represented by state nodes.
   *
   * @param historyValue
   */ StateNode.prototype.resolveHistory = function(historyValue) {
        var _this = this;
        if (this.type !== 'history') return [
            this
        ];
        var parent = this.parent;
        if (!historyValue) {
            var historyTarget = this.target;
            return historyTarget ? (0, $1Rgbm.flatten)((0, $1Rgbm.toStatePaths)(historyTarget).map(function(relativeChildPath) {
                return parent.getFromRelativePath(relativeChildPath);
            })) : parent.initialStateNodes;
        }
        var subHistoryValue = (0, $1Rgbm.nestedPath)(parent.path, 'states')(historyValue).current;
        if ((0, $1Rgbm.isString)(subHistoryValue)) return [
            parent.getStateNode(subHistoryValue)
        ];
        return (0, $1Rgbm.flatten)((0, $1Rgbm.toStatePaths)(subHistoryValue).map(function(subStatePath) {
            return _this.history === 'deep' ? parent.getFromRelativePath(subStatePath) : [
                parent.states[subStatePath[0]]
            ];
        }));
    };
    Object.defineProperty(StateNode.prototype, "stateIds", {
        /**
     * All the state node IDs of this state node and its descendant state nodes.
     */ get: function() {
            var _this = this;
            var childStateIds = (0, $1Rgbm.flatten)((0, $1Rgbm.keys)(this.states).map(function(stateKey) {
                return _this.states[stateKey].stateIds;
            }));
            return [
                this.id
            ].concat(childStateIds);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "events", {
        /**
     * All the event types accepted by this state node and its descendants.
     */ get: function() {
            var e_7, _a, e_8, _b;
            if (this.__cache.events) return this.__cache.events;
            var states = this.states;
            var events = new Set(this.ownEvents);
            if (states) try {
                for(var _c = (0, $iRfl8.__values)((0, $1Rgbm.keys)(states)), _d = _c.next(); !_d.done; _d = _c.next()){
                    var stateId = _d.value;
                    var state = states[stateId];
                    if (state.states) try {
                        for(var _e = (e_8 = void 0, (0, $iRfl8.__values)(state.events)), _f = _e.next(); !_f.done; _f = _e.next()){
                            var event_1 = _f.value;
                            events.add("" + event_1);
                        }
                    } catch (e_8_1) {
                        e_8 = {
                            error: e_8_1
                        };
                    } finally{
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        } finally{
                            if (e_8) throw e_8.error;
                        }
                    }
                }
            } catch (e_7_1) {
                e_7 = {
                    error: e_7_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally{
                    if (e_7) throw e_7.error;
                }
            }
            return this.__cache.events = Array.from(events);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StateNode.prototype, "ownEvents", {
        /**
     * All the events that have transitions directly from this state node.
     *
     * Excludes any inert events.
     */ get: function() {
            var events = new Set(this.transitions.filter(function(transition) {
                return !(!transition.target && !transition.actions.length && transition.internal);
            }).map(function(transition) {
                return transition.eventType;
            }));
            return Array.from(events);
        },
        enumerable: false,
        configurable: true
    });
    StateNode.prototype.resolveTarget = function(_target) {
        var _this = this;
        if (_target === undefined) // an undefined target signals that the state node should not transition from that state when receiving that event
        return undefined;
        return _target.map(function(target) {
            if (!(0, $1Rgbm.isString)(target)) return target;
            var isInternalTarget = target[0] === _this.delimiter; // If internal target is defined on machine,
            // do not include machine key on target
            if (isInternalTarget && !_this.parent) return _this.getStateNodeByPath(target.slice(1));
            var resolvedTarget = isInternalTarget ? _this.key + target : target;
            if (_this.parent) try {
                var targetStateNode = _this.parent.getStateNodeByPath(resolvedTarget);
                return targetStateNode;
            } catch (err) {
                throw new Error("Invalid transition definition for state node '" + _this.id + "':\n" + err.message);
            }
            else return _this.getStateNodeByPath(resolvedTarget);
        });
    };
    StateNode.prototype.formatTransition = function(transitionConfig) {
        var _this = this;
        var normalizedTarget = (0, $1Rgbm.normalizeTarget)(transitionConfig.target);
        var internal = 'internal' in transitionConfig ? transitionConfig.internal : normalizedTarget ? normalizedTarget.some(function(_target) {
            return (0, $1Rgbm.isString)(_target) && _target[0] === _this.delimiter;
        }) : true;
        var guards = this.machine.options.guards;
        var target = this.resolveTarget(normalizedTarget);
        var transition = (0, $iRfl8.__assign)((0, $iRfl8.__assign)({}, transitionConfig), {
            actions: (0, $7LdyK.toActionObjects)((0, $1Rgbm.toArray)(transitionConfig.actions)),
            cond: (0, $1Rgbm.toGuard)(transitionConfig.cond, guards),
            target: target,
            source: this,
            internal: internal,
            eventType: transitionConfig.event,
            toJSON: function() {
                return (0, $iRfl8.__assign)((0, $iRfl8.__assign)({}, transition), {
                    target: transition.target ? transition.target.map(function(t) {
                        return "#" + t.id;
                    }) : undefined,
                    source: "#" + _this.id
                });
            }
        });
        return transition;
    };
    StateNode.prototype.formatTransitions = function() {
        var e_9, _a;
        var _this = this;
        var onConfig;
        if (!this.config.on) onConfig = [];
        else if (Array.isArray(this.config.on)) onConfig = this.config.on;
        else {
            var _b = this.config.on, _c = $b9e72fdf36b0016c$var$WILDCARD, _d = _b[_c], wildcardConfigs = _d === void 0 ? [] : _d, strictTransitionConfigs_1 = (0, $iRfl8.__rest)(_b, [
                typeof _c === "symbol" ? _c : _c + ""
            ]);
            onConfig = (0, $1Rgbm.flatten)((0, $1Rgbm.keys)(strictTransitionConfigs_1).map(function(key) {
                if (!(0, $2vepS.IS_PRODUCTION) && key === $b9e72fdf36b0016c$var$NULL_EVENT) (0, $1Rgbm.warn)(false, "Empty string transition configs (e.g., `{ on: { '': ... }}`) for transient transitions are deprecated. Specify the transition in the `{ always: ... }` property instead. " + ("Please check the `on` configuration for \"#" + _this.id + "\"."));
                var transitionConfigArray = (0, $1Rgbm.toTransitionConfigArray)(key, strictTransitionConfigs_1[key]);
                if (!(0, $2vepS.IS_PRODUCTION)) $b9e72fdf36b0016c$var$validateArrayifiedTransitions(_this, key, transitionConfigArray);
                return transitionConfigArray;
            }).concat((0, $1Rgbm.toTransitionConfigArray)($b9e72fdf36b0016c$var$WILDCARD, wildcardConfigs)));
        }
        var eventlessConfig = this.config.always ? (0, $1Rgbm.toTransitionConfigArray)('', this.config.always) : [];
        var doneConfig = this.config.onDone ? (0, $1Rgbm.toTransitionConfigArray)(String((0, $7LdyK.done)(this.id)), this.config.onDone) : [];
        if (!(0, $2vepS.IS_PRODUCTION)) (0, $1Rgbm.warn)(!(this.config.onDone && !this.parent), "Root nodes cannot have an \".onDone\" transition. Please check the config of \"" + this.id + "\".");
        var invokeConfig = (0, $1Rgbm.flatten)(this.invoke.map(function(invokeDef) {
            var settleTransitions = [];
            if (invokeDef.onDone) settleTransitions.push.apply(settleTransitions, (0, $iRfl8.__spreadArray)([], (0, $iRfl8.__read)((0, $1Rgbm.toTransitionConfigArray)(String((0, $7LdyK.doneInvoke)(invokeDef.id)), invokeDef.onDone))));
            if (invokeDef.onError) settleTransitions.push.apply(settleTransitions, (0, $iRfl8.__spreadArray)([], (0, $iRfl8.__read)((0, $1Rgbm.toTransitionConfigArray)(String((0, $7LdyK.error)(invokeDef.id)), invokeDef.onError))));
            return settleTransitions;
        }));
        var delayedTransitions = this.after;
        var formattedTransitions = (0, $1Rgbm.flatten)((0, $iRfl8.__spreadArray)((0, $iRfl8.__spreadArray)((0, $iRfl8.__spreadArray)((0, $iRfl8.__spreadArray)([], (0, $iRfl8.__read)(doneConfig)), (0, $iRfl8.__read)(invokeConfig)), (0, $iRfl8.__read)(onConfig)), (0, $iRfl8.__read)(eventlessConfig)).map(function(transitionConfig) {
            return (0, $1Rgbm.toArray)(transitionConfig).map(function(transition) {
                return _this.formatTransition(transition);
            });
        }));
        try {
            for(var delayedTransitions_1 = (0, $iRfl8.__values)(delayedTransitions), delayedTransitions_1_1 = delayedTransitions_1.next(); !delayedTransitions_1_1.done; delayedTransitions_1_1 = delayedTransitions_1.next()){
                var delayedTransition = delayedTransitions_1_1.value;
                formattedTransitions.push(delayedTransition);
            }
        } catch (e_9_1) {
            e_9 = {
                error: e_9_1
            };
        } finally{
            try {
                if (delayedTransitions_1_1 && !delayedTransitions_1_1.done && (_a = delayedTransitions_1.return)) _a.call(delayedTransitions_1);
            } finally{
                if (e_9) throw e_9.error;
            }
        }
        return formattedTransitions;
    };
    return StateNode;
}();

});
parcelRegister("lxUZx", function(module, exports) {

$parcel$export(module.exports, "toInvokeDefinition", () => $faf8e35a61ef2905$export$4c73f685ba879446);

var $iRfl8 = parcelRequire("iRfl8");

var $kWOvn = parcelRequire("kWOvn");

function $faf8e35a61ef2905$export$436e852aa2feda95(src) {
    if (typeof src === 'string') {
        var simpleSrc = {
            type: src
        };
        simpleSrc.toString = function() {
            return src;
        }; // v4 compat - TODO: remove in v5
        return simpleSrc;
    }
    return src;
}
function $faf8e35a61ef2905$export$4c73f685ba879446(invokeConfig) {
    return (0, $iRfl8.__assign)((0, $iRfl8.__assign)({
        type: (0, $kWOvn.invoke)
    }, invokeConfig), {
        toJSON: function() {
            var onDone = invokeConfig.onDone, onError = invokeConfig.onError, invokeDef = (0, $iRfl8.__rest)(invokeConfig, [
                "onDone",
                "onError"
            ]);
            return (0, $iRfl8.__assign)((0, $iRfl8.__assign)({}, invokeDef), {
                type: (0, $kWOvn.invoke),
                src: $faf8e35a61ef2905$export$436e852aa2feda95(invokeConfig.src)
            });
        }
    });
}

});




parcelRegister("kVY5A", function(module, exports) {

$parcel$export(module.exports, "streamingService", () => $f3d7bdf212bf569b$export$b523ed22ab6d4165);

var $EZ9eX = parcelRequire("EZ9eX");

var $XHGTv = parcelRequire("XHGTv");
function $f3d7bdf212bf569b$export$b523ed22ab6d4165(context, event) {
    function callbackHandler(callback) {
        var _configItemToUse$getI, _configItemToUse$getB;
        const abortController = new AbortController();
        /**
     * Vary prompt request triggered - if latest response exists, we are interrogating,
     * and do not want to use the original config item (i.e. may possibly be summarise/transform)
     *
     * If it is a generate with tag, the response will be captured within
     * the latest "latest response, prompt", flow.
     *
     * REVISIT THIS: analytics is based on the config item, however
     * interrogation analytics uses base generate instead to complete;
     */ const configItemToUse = context.baseGenerate && context.latestPromptResponse ? context.baseGenerate : context.configItem;
        const initialContext = (_configItemToUse$getI = configItemToUse.getInitialContext) === null || _configItemToUse$getI === void 0 ? void 0 : _configItemToUse$getI.call(configItemToUse, {
            editorView: context.editorView,
            positions: context.positions,
            intl: context.intl,
            updateIdMap: ({ idMap: idMap, selectionType: selectionType })=>{
                callback({
                    type: 'update idMap',
                    context: {
                        idMap: idMap,
                        selectionType: selectionType
                    }
                });
            }
        });
        if (initialContext !== null && initialContext !== void 0 && initialContext.contentStatistics) callback({
            type: 'storeContextStatistics',
            contextStatistics: {
                inputDocument: initialContext.contentStatistics
            }
        });
        if (!initialContext) throw new Error('Initial context is undefined');
        const promptRequest = configItemToUse.triggerPromptRequest({
            initialContext: initialContext,
            promptInput: context.userInput,
            promptInputADF: context.userADFInput,
            latestPromptResponse: context.latestPromptResponse || undefined,
            formatMessage: context.intl.formatMessage,
            editorSchema: context.editorView.state.schema,
            backendModel: configItemToUse === null || configItemToUse === void 0 ? void 0 : (_configItemToUse$getB = configItemToUse.getBackendModel) === null || _configItemToUse$getB === void 0 ? void 0 : _configItemToUse$getB.call(configItemToUse, !!context.latestPromptResponse)
        });
        const cacheKey = JSON.stringify({
            initialContext: initialContext,
            userInput: context.userInput
        });
        // Right now we only ever have one object in history as we do not
        // yet support traversing the history object array. This is also to
        // prevent us saving large documents into history multip[le times.
        const lastHistoryItem = context.responseHistory.entries[0];
        if ((0, $XHGTv.getBooleanFF)('platform.editor.ai-save-response-history-in-state_dw857')) {
            if (lastHistoryItem && cacheKey === lastHistoryItem.cacheKey) {
                callback({
                    type: 'same cache key'
                });
                return;
            }
        }
        const streaming = promptRequest({
            abortController: abortController,
            // Note -- when we collapse to a single "prompt request" with "api v2"
            // this would be a good opportunity to group these and pass them as a group
            generativeAIApiUrl: context.aiProvider.generativeAIApiUrl,
            product: context.aiProvider.product,
            getFetchCustomHeaders: context.aiProvider.getFetchCustomHeaders,
            getChannelVariables: context.aiProvider.getChannelVariables
        });
        (async function() {
            for await (const streamItem of streaming){
                if (streamItem.state === 'loaded') {
                    var _streamItem$data$meta;
                    //loading done on success
                    callback({
                        type: 'complete',
                        markdown: streamItem.data.content,
                        cacheKey: cacheKey,
                        modelInput: {
                            selection: (0, $EZ9eX.isInitialContextSelectionRange)(initialContext) ? initialContext.selection : undefined
                        },
                        inputOutputDiffRatio: (_streamItem$data$meta = streamItem.data.meta) === null || _streamItem$data$meta === void 0 ? void 0 : _streamItem$data$meta.inputOutputDiffRatio
                    });
                    continue;
                } else if (streamItem.state === 'failed') {
                    //loading done on api failed
                    // If the error comes from ConvoAI
                    if ('apiName' in streamItem && streamItem.apiName === 'assistance-service') {
                        if ([
                            'RATE_LIMIT',
                            'OPENAI_RATE_LIMIT_USER_ABUSE'
                        ].includes(streamItem.guard) && 'retryAfter' in streamItem) {
                            callback({
                                type: 'rate limited',
                                retryAfter: streamItem.retryAfter,
                                errorInfo: {
                                    statusCode: streamItem.statusCode,
                                    errorKey: streamItem.guard,
                                    apiName: streamItem.apiName,
                                    errorContent: 'error' in streamItem ? streamItem.error : undefined
                                }
                            });
                            continue;
                        }
                        if (streamItem.guard === 'HIPAA_CONTENT_DETECTED') {
                            callback({
                                type: 'hipaa content fail',
                                errorInfo: {
                                    statusCode: streamItem.statusCode,
                                    errorKey: streamItem.guard,
                                    apiName: streamItem.apiName,
                                    errorContent: 'error' in streamItem ? streamItem.error : undefined
                                }
                            });
                            continue;
                        }
                        if (streamItem.guard === 'EXCEEDING_CONTEXT_LENGTH_ERROR') {
                            callback({
                                type: 'token limit fail',
                                errorInfo: {
                                    statusCode: streamItem.statusCode,
                                    errorKey: streamItem.guard,
                                    apiName: streamItem.apiName,
                                    errorContent: 'error' in streamItem ? streamItem.error : undefined
                                }
                            });
                            continue;
                        }
                        if (streamItem.guard === 'ACCEPTABLE_USE_VIOLATIONS') {
                            callback({
                                type: 'AUP violation detected',
                                cacheKey: cacheKey,
                                modelInput: {
                                    selection: (0, $EZ9eX.isInitialContextSelectionRange)(initialContext) ? initialContext.selection : undefined
                                },
                                errorInfo: {
                                    statusCode: streamItem.statusCode,
                                    errorKey: streamItem.guard,
                                    apiName: streamItem.apiName,
                                    errorContent: 'error' in streamItem ? streamItem.error : undefined
                                }
                            });
                            continue;
                        }
                        // All other errors from ConvoAI
                        callback({
                            type: 'api fail',
                            errorInfo: {
                                statusCode: streamItem.statusCode,
                                errorKey: streamItem.guard,
                                apiName: streamItem.apiName,
                                errorContent: 'error' in streamItem ? streamItem.error : undefined
                            }
                        });
                        continue;
                    }
                    if ('reason' in streamItem && streamItem.reason === 'backend-input-guard') {
                        if (streamItem.guard === 'INPUT_EXCEEDS_TOKEN_LIMIT') {
                            callback({
                                type: 'token limit fail',
                                errorInfo: {
                                    errorKey: streamItem.guard,
                                    statusCode: streamItem.statusCode
                                }
                            });
                            continue;
                        }
                        if (streamItem.guard === 'INPUT_TOO_SHORT_TO_SUMMARIZE' || streamItem.guard === 'INPUT_TOO_SHORT_TO_PROCESS') {
                            callback({
                                type: 'input too short fail',
                                errorInfo: {
                                    errorKey: streamItem.guard,
                                    statusCode: streamItem.statusCode
                                }
                            });
                            continue;
                        }
                    }
                    if ('reason' in streamItem && streamItem.reason === 'rate-limited') {
                        callback({
                            type: 'rate limited',
                            retryAfter: streamItem.retryAfter
                        });
                        continue;
                    }
                    if ('reason' in streamItem && streamItem.reason === 'response-too-similar') {
                        var _streamItem$data$meta2;
                        callback({
                            type: 'response too similar',
                            cacheKey: cacheKey,
                            modelInput: {
                                selection: (0, $EZ9eX.isInitialContextSelectionRange)(initialContext) ? initialContext.selection : undefined
                            },
                            inputOutputDiffRatio: (_streamItem$data$meta2 = streamItem.data.meta) === null || _streamItem$data$meta2 === void 0 ? void 0 : _streamItem$data$meta2.inputOutputDiffRatio
                        });
                        continue;
                    }
                    callback({
                        type: 'api fail',
                        errorInfo: {
                            statusCode: streamItem.statusCode
                        }
                    });
                } else if (streamItem.state === 'created-channel') callback({
                    type: 'update channelId',
                    context: {
                        channelId: streamItem.data.channelId
                    }
                });
                else if (streamItem.state === 'aup-violation') {
                    callback({
                        type: 'AUP violation detected',
                        cacheKey: cacheKey,
                        modelInput: {
                            selection: (0, $EZ9eX.isInitialContextSelectionRange)(initialContext) ? initialContext.selection : undefined
                        }
                    });
                    continue;
                } else {
                    var _streamItem$data$meta3;
                    callback({
                        type: 'stream',
                        markdown: streamItem.data.content,
                        loadingStatus: (_streamItem$data$meta3 = streamItem.data.meta) === null || _streamItem$data$meta3 === void 0 ? void 0 : _streamItem$data$meta3.loadingStatus
                    });
                    continue;
                }
            }
        })();
        // Cleanup function
        return ()=>{
            abortController.abort();
        };
    }
    return callbackHandler;
}

});
parcelRegister("EZ9eX", function(module, exports) {

$parcel$export(module.exports, "isInitialContextSelectionRange", () => $07b32b4484ccfdea$export$2c6858d7c847006);
$parcel$export(module.exports, "createEditorPluginAIConfigItemMarkdown", () => $07b32b4484ccfdea$export$c155edbb8a393939);
/**
 * For empty selections, the start and end will be the same
 */ /**
 * type guard to detect if the initial context is for range selection
 * based on selection prop availability
 */ function $07b32b4484ccfdea$export$2c6858d7c847006(value) {
    return 'selection' in value && typeof value.selection === 'string';
}
function $07b32b4484ccfdea$export$c155edbb8a393939(editorPluginAIConfigItem) {
    return editorPluginAIConfigItem;
}

});




parcelRegister("iypWf", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d81f85cec8fcc55e$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $d81f85cec8fcc55e$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    aupViolationMessage: {
        id: 'fabric.editor.ai.experience.aupViolationMessage',
        defaultMessage: // This is based on guidance at
        // https://developer.atlassian.com/platform/localization/i18n-formatting/avoiding-concatenation/#links
        'Your prompt or content might not comply with our Acceptable Use Policy. Please review both and refer to our <auplink>Acceptable Use Policy</auplink> if needed. If the problem persists, consider trying a different prompt or content.',
        description: 'Message to indicate to user their prompt or content (this can be a range of content, such as a selection or document -- we used content to keep it vague -- as this will change without user knowing) has been detected as violating Atlassians acceptable use policy.  Note the markdown link -- this is expected to remain as markdown as this string is converted to html.'
    },
    responseTooSimilarMessage: {
        id: 'fabric.editor.ai.experience.responseTooSimilarMessage',
        defaultMessage: 'Atlassian Intelligence has no suggestions at this time. Feel free to try a different prompt or content.',
        description: 'Message to indicate to user the response from Atlassian Intelligence response is too similar or the same as their input.'
    },
    discardMessagePrompt: {
        id: 'fabric.editor.ai.experience.discardMessagePrompt',
        defaultMessage: 'Do you want to discard your prompt?',
        description: 'Message to confirm if the user wants to discard their input.'
    },
    discardMessageResponse: {
        id: 'fabric.editor.ai.experience.discardMessageResponse',
        defaultMessage: 'Do you want to discard your response?',
        description: 'Message to confirm if the user wants to discard the generated response from Atlassian Intelligence.'
    },
    loadingTitle: {
        id: 'fabric.editor.ai.experience.loadingTitle',
        defaultMessage: 'Generating',
        description: 'The title string that appears on the "Loading" screen when the user is waiting for Atlassian Intelligence to generate content'
    },
    messageTemplateAnalysingQuery: {
        id: 'fabric.editor.ai.experience.messageTemplateAnalysingQuery',
        defaultMessage: 'Analyzing: Reviewing your question.',
        description: 'Message to indicate to user that the AI is reading and understanding their question'
    },
    messageTemplateContentSearch: {
        id: 'fabric.editor.ai.experience.messageTemplateContentSearch',
        defaultMessage: 'Searching: One moment while we search for information.',
        description: 'Message to indicate to user that the AI is searching for content'
    },
    messageTemplatePageHydration: {
        id: 'fabric.editor.ai.experience.messageTemplatePageHydration',
        defaultMessage: 'Searching: One moment while we search the page.',
        description: 'Message to indicate to user that the AI is searching a URL for content'
    },
    messageTemplateNextBestTask: {
        id: 'fabric.editor.ai.experience.messageTemplateNextBestTask',
        defaultMessage: 'Searching: One moment while we search Jira.',
        description: 'Message to indicate to user that the AI is searching Jira'
    },
    convoAIBeta: {
        id: 'fabric.editor.ai.screens.preview.convoAIBeta',
        defaultMessage: 'Content generation requests that reference URLs is in beta.',
        description: 'The disclaimer for convo ai beta lozenge'
    },
    agentsSuggestionGroupHeading: {
        id: 'fabric.editor.ai.experience.suggestionGroupHeading.agents',
        defaultMessage: 'Agents',
        description: 'Heading text to indicate that the next set of features are for agents'
    }
});

});

parcelRegister("f0jcg", function(module, exports) {

$parcel$export(module.exports, "LoadingScreenWithLogic", () => $aec5bf3033f76de4$export$9c279fd5d5bced59);
/* @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $74BVL = parcelRequire("74BVL");

var $byn9U = parcelRequire("byn9U");
parcelRequire("a3BOl");
var $5QPz6 = parcelRequire("5QPz6");

var $ghKKt = parcelRequire("ghKKt");

var $ln5HZ = parcelRequire("ln5HZ");

var $jRfpS = parcelRequire("jRfpS");

var $e32NX = parcelRequire("e32NX");

var $7NBW6 = parcelRequire("7NBW6");

var $aFbB0 = parcelRequire("aFbB0");

var $XHGTv = parcelRequire("XHGTv");

var $gZGlT = parcelRequire("gZGlT");
// Selectors will be used for editorView.dom.closest() to track
// the scroll parent element and scrollable content height
const $aec5bf3033f76de4$var$AK_EDITOR_CONTENT_AREA_SELECTOR = '.ak-editor-content-area';
function $aec5bf3033f76de4$export$9c279fd5d5bced59({ providerFactory: providerFactory, title: title, latestPrompt: latestPrompt, promptTrigger: promptTrigger, latestPromptRetried: latestPromptRetried, markdown: markdown, schema: schema, editorView: editorView, send: send, idMap: idMap, contextStatistics: contextStatistics }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const fireAIAnalyticsEvent = (0, $aFbB0.useFireAIAnalyticsEvent)();
    const [preview, setPreview] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState();
    const [hasPreview, setHasPreview] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState(false);
    const containerRef = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(null);
    // raf is used for debouncing, if useEffect is called
    // multiple times before raf is run this prevents rendering
    // multiple times if we receive streams very quickly
    const raf = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef();
    const errorReported = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(false);
    /**
   * scrollParentRef is for
   * storing the scroll parent element once its found
   * to be re-used in calculations
   */ const scrollParentRef = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(null);
    const initialScrollTop = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(0);
    const modalOffsetTop = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(0);
    const isUserScroll = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(false);
    /**
   * isProgrammaticScroll is set to true initially
   * to detect any initial changes on render which affect
   * scroll position. There will be multiple scroll events
   * within a single user scroll so it will be set to false
   * accordingly within a single scroll action.
   */ const isProgrammaticScroll = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(true);
    const isModalAtTop = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(false);
    const scrollModalAlignBottom = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((modalEl, scrollParentEl)=>{
        // We set isProgrammaticScroll to true to flag it as a non-user scroll.
        isProgrammaticScroll.current = true;
        scrollParentEl.scroll({
            top: initialScrollTop.current + modalOffsetTop.current + modalEl.scrollHeight - scrollParentEl.offsetHeight,
            // Ignore is for typecheck failing unexpectedly on pipeline
            // @ts-ignore-next-line
            behavior: 'instant'
        });
    }, []);
    const scrollModalToTop = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((scrollParentEl)=>{
        // We set isProgrammaticScroll to true to flag it as a non-user scroll.
        isProgrammaticScroll.current = true;
        scrollParentEl.scroll({
            top: initialScrollTop.current + modalOffsetTop.current - (0, $7NBW6.scrollTopMargin),
            // Ignore is for typecheck failing unexpectedly on pipeline
            // @ts-ignore-next-line
            behavior: 'instant'
        });
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        /**
     * Set up ResizeObserver to detect cases where the editor content grows,
     * as it will normally trigger a scroll event due to scrollHeight and scrollTop changes.
     * We set isProgrammaticScroll to true to flag it as a non-user scroll.
     */ const editorContentArea = editorView.dom.closest($aec5bf3033f76de4$var$AK_EDITOR_CONTENT_AREA_SELECTOR);
        if (!editorContentArea) return;
        const resizeObserver = new ResizeObserver(()=>{
            isProgrammaticScroll.current = true;
        });
        resizeObserver.observe(editorContentArea);
        return ()=>resizeObserver.unobserve(editorContentArea);
    }, [
        editorView
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        /**
     * Setup init values to calculate scroll distance and
     * scroll the modal into view if it is not already visible.
     */ const modalEl = containerRef.current;
        if (!modalEl) return;
        const scrollParentEl = (0, $5QPz6.findOverflowScrollParent)(modalEl);
        if (!scrollParentEl) return;
        scrollParentRef.current = scrollParentEl;
        // Calculate the offset of the modal from the top of editor
        modalOffsetTop.current = modalEl.getBoundingClientRect().top - scrollParentEl.getBoundingClientRect().top;
        // Calculate initial scroll position of editor
        initialScrollTop.current = scrollParentEl.scrollTop;
        // Calculate position of the bottom of the modal from top of editor
        const modalBottomOffsetTop = modalOffsetTop.current + modalEl.scrollHeight;
        if (modalBottomOffsetTop < 0) // Edge case: if modal above the top of the editor
        scrollModalToTop(scrollParentEl);
        else if (modalOffsetTop.current > scrollParentEl.offsetHeight) /**
       * Edge case: if modal is below the bottom of the editor
       * Call scrollModalAlignBottom to move modal into view.
       */ scrollModalAlignBottom(modalEl, scrollParentEl);
        const unbind = (0, $74BVL.bind)(scrollParentEl, {
            type: 'scroll',
            listener: ()=>{
                if (!isProgrammaticScroll.current) {
                    isUserScroll.current = true;
                    unbind();
                }
                isProgrammaticScroll.current = false;
            }
        });
        return unbind;
    }, [
        scrollModalToTop,
        scrollModalAlignBottom
    ]);
    function scrollModalIntoView() {
        /**
     * Early exits:
     * - If user has manually scrolled, stop auto-scrolling
     * - If modal has reached the top of the editor, no more calculations or scrolling needed
     */ if (isUserScroll.current || isModalAtTop.current) return;
        const modalEl = containerRef.current;
        if (!modalEl) return;
        const scrollParentEl = scrollParentRef.current;
        if (!scrollParentEl) return;
        // Check if modal is already fully visible
        const isModalFullyVisible = scrollParentEl.offsetHeight > modalOffsetTop.current + modalEl.scrollHeight;
        /**
     * Check if modal height exceeds scroll parent's height
     * Scroll margin is used to prevent the modal from being scrolled to the top
     * and should match scroll margin in other modals e.g. from
     * packages/editor/editor-plugin-ai/src/ui/components/FloatingContainer/styles.ts
     */ const isModalFullHeight = scrollParentEl.offsetHeight - (0, $7NBW6.scrollTopMargin) < modalEl.scrollHeight;
        if (isModalFullyVisible) return;
        if (isModalFullHeight) {
            scrollModalToTop(scrollParentEl);
            isModalAtTop.current = true;
            return;
        }
        scrollModalAlignBottom(modalEl, scrollParentEl);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        // only run the callback if the raf has not been set, and then
        // reset raf to undefined
        if (raf.current === undefined) raf.current = window.requestAnimationFrame(()=>{
            let _preview;
            raf.current = undefined;
            if (!markdown || markdown === '') // When there is no streamed preview content -- set the preview to
            // undefined.
            // This allows a nicer loading screen (rather than showing an empty paragraph).
            _preview = undefined;
            else {
                const { pmFragment: pmFragment } = (0, $ln5HZ.getPMFragmentWithFallback)({
                    markdown: markdown,
                    schema: schema,
                    source: 'loading',
                    fireAIAnalyticsEvent: (event)=>{
                        if (!errorReported.current) {
                            errorReported.current = true;
                            fireAIAnalyticsEvent(event);
                        }
                    },
                    idMap: idMap
                });
                /**
           * Hold off on setting the preview if we appear to be receiving
           * a custom tag through our stream. This is to hide raw tags from
           * users until the tags are complete and can be rendered back into nodes.
           */ if ((0, $XHGTv.getBooleanFF)('platform.editor.ai-markdown-plus_9v1w7') && (0, $gZGlT.isMarkdownEndingWithCustomTag)(markdown, // eslint-disable-next-line @atlaskit/platform/no-invalid-feature-flag-usage
                (0, $XHGTv.getBooleanFF)('platform.editor.ai-markdown-plus-v2-streaming_o9h6u'))) return;
                _preview = (0, $e32NX.convertPMFragmentToPreview)({
                    schema: schema,
                    pmFragment: pmFragment,
                    showTelepointer: true,
                    providerFactory: providerFactory
                });
                setPreview(_preview);
                setHasPreview(true);
                scrollModalIntoView();
            }
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        markdown
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        return ()=>{
            // if the component is unmounted before the raf callback
            // has run, we cancel it
            if (raf.current) window.cancelAnimationFrame(raf.current);
        };
    }, []);
    const analyticsFlow = (0, $jRfpS.useAnalyticsFlowEventsQueue)({
        stepName: 'loading',
        attributes: {
            promptType: promptTrigger,
            latestPromptRetried: latestPromptRetried,
            modelIO: {
                contextStatistics: contextStatistics
            }
        }
    });
    const previewBecameAvailable = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef();
    if (!previewBecameAvailable.current && hasPreview) previewBecameAvailable.current = performance.now();
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        const noPreviewAvailable = performance.now();
        return ()=>{
            if (!previewBecameAvailable.current) return;
            analyticsFlow.addAttributes({
                durations: {
                    timeSpentWithoutPartialPreview: previewBecameAvailable.current - noPreviewAvailable,
                    timeSpentWithPartialPreview: performance.now() - previewBecameAvailable.current
                }
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // preset prompt or base generate / interrogation
    const localizedLatestPrompt = latestPrompt !== null && latestPrompt !== void 0 && latestPrompt.presetTitle ? {
        presetTitle: latestPrompt.presetTitle({
            formatMessage: formatMessage
        }),
        userInput: latestPrompt === null || latestPrompt === void 0 ? void 0 : latestPrompt.userInput,
        userADFInput: latestPrompt === null || latestPrompt === void 0 ? void 0 : latestPrompt.userADFInput
    } : {
        userInput: (latestPrompt === null || latestPrompt === void 0 ? void 0 : latestPrompt.userInput) || '',
        userADFInput: (latestPrompt === null || latestPrompt === void 0 ? void 0 : latestPrompt.userADFInput) || ''
    };
    return (0, $byn9U.jsx)("div", {
        ref: containerRef,
        css: (0, $7NBW6.scrollMarginStyles)
    }, (0, $byn9U.jsx)((0, $ghKKt.LoadingScreen), {
        latestPrompt: localizedLatestPrompt,
        title: title,
        preview: preview,
        providerFactory: providerFactory,
        onCancel: ()=>{
            send({
                type: 'enable discard'
            });
        },
        schema: schema
    }));
}

});
parcelRegister("a3BOl", function(module, exports) {

$parcel$export(module.exports, "default", () => $de58b20628cac712$export$2e2bcd8739ae039);
$parcel$export(module.exports, "findOverflowScrollParent", () => (parcelRequire("5QPz6")).findOverflowScrollParent);

var $eUqFw = parcelRequire("eUqFw");

var $a2Ury = parcelRequire("a2Ury");

var $8yx6O = parcelRequire("8yx6O");

var $lEfVV = parcelRequire("lEfVV");

var $25FYC = parcelRequire("25FYC");

var $5QPz6 = parcelRequire("5QPz6");
class $de58b20628cac712$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.defaultProps = {
            offset: [
                0,
                0
            ],
            allowOutOfBound: false
        };
    }
    /**
	 * Calculates new popup position
	 */ calculatePosition(props, popup) {
        const { target: target, fitHeight: fitHeight, fitWidth: fitWidth, boundariesElement: boundariesElement, offset: offset, onPositionCalculated: onPositionCalculated, onPlacementChanged: onPlacementChanged, alignX: alignX, alignY: alignY, stick: stick, forcePlacement: forcePlacement, allowOutOfBounds: allowOutOfBounds, rect: rect, preventOverflow: preventOverflow, absoluteOffset: absoluteOffset } = props;
        if (!target || !popup) return {};
        const placement = (0, $5QPz6.calculatePlacement)(target, boundariesElement || document.body, fitWidth, fitHeight, alignX, alignY, forcePlacement, preventOverflow);
        if (onPlacementChanged && this.placement.join('') !== placement.join('')) {
            onPlacementChanged(placement);
            this.placement = placement;
        }
        let position = (0, $5QPz6.calculatePosition)({
            placement: placement,
            popup: popup,
            target: target,
            stick: stick,
            offset: offset,
            allowOutOfBounds: allowOutOfBounds,
            rect: rect
        });
        position = onPositionCalculated ? onPositionCalculated(position) : position;
        if (typeof position.top !== 'undefined' && absoluteOffset?.top) position.top = position.top + absoluteOffset.top;
        if (typeof position.bottom !== 'undefined' && absoluteOffset?.bottom) position.bottom = position.bottom + absoluteOffset.bottom;
        if (typeof position.right !== 'undefined' && absoluteOffset?.right) position.right = position.right + absoluteOffset.right;
        if (typeof position.left !== 'undefined' && absoluteOffset?.left) position.left = position.left + absoluteOffset.left;
        return {
            position: position,
            validPosition: (0, $5QPz6.validatePosition)(target)
        };
    }
    updatePosition(props = this.props, state = this.state) {
        const { popup: popup } = state;
        const { position: position, validPosition: validPosition } = this.calculatePosition(props, popup);
        if (position && validPosition) (0, $lEfVV.flushSync)(()=>{
            this.setState({
                position: position,
                validPosition: validPosition
            });
        });
    }
    cannotSetPopup(popup, target, overflowScrollParent) {
        /**
		 * Check whether:
		 * 1. Popup's offset targets which means whether or not its possible to correctly position popup along with given target.
		 * 2. Popup is inside "overflow: scroll" container, but its offset parent isn't.
		 *
		 * Currently Popup isn't capable of position itself correctly in case 2,
		 * Add "position: relative" to "overflow: scroll" container or to some other FloatingPanel wrapper inside it.
		 */ return !target || document.body.contains(target) && popup.offsetParent && !popup.offsetParent.contains(target) || overflowScrollParent && !overflowScrollParent.contains(popup.offsetParent);
    }
    /**
	 * Popup initialization.
	 * Checks whether it's possible to position popup along given target, and if it's not throws an error.
	 */ initPopup(popup) {
        this.popupRef.current = popup;
        const { target: target } = this.props;
        const overflowScrollParent = (0, $5QPz6.findOverflowScrollParent)(popup);
        if (this.cannotSetPopup(popup, target, overflowScrollParent)) return;
        this.setState({
            popup: popup
        });
        /**
		 * Some plugins (like image) have async rendering of component in floating toolbar(which is popup).
		 * Now, floating toolbar position depends on it's size.
		 * Size of floating toolbar changes, when async component renders.
		 * There is currently, no way to re position floating toolbar or
		 *  better to not show floating toolbar till all the async component are ready to render.
		 * Also, it is not even Popup's responsibility to take care of it as popup's children are passed
		 *  as a prop.
		 * So, calling scheduledUpdatePosition to position popup on next request animation frame,
		 * which is currently working for most of the floating toolbar and other popups.
		 */ this.scheduledUpdatePosition(this.props);
        if (this.props.focusTrap) this.initFocusTrap();
    }
    UNSAFE_componentWillReceiveProps(newProps) {
        // We are delaying `updatePosition` otherwise it happens before the children
        // get rendered and we end up with a wrong position
        this.scheduledUpdatePosition(newProps);
    }
    /**
	 * Cancels the initialisation of the focus trap if it has not yet occured
	 * Deactivates the focus trap if it exists
	 */ destroyFocusTrap() {
        this.initFocusTrap.cancel();
        this.focusTrap?.deactivate();
    }
    /**
	 * Handle pausing, unpausing, and initialising (if not yet initialised) of the focus trap
	 */ handleChangedFocusTrapProp(prevProps) {
        if (prevProps.focusTrap !== this.props.focusTrap) {
            // If currently set to disable, then pause the trap if it exists
            if (!this.props.focusTrap) return this.focusTrap?.pause();
            // If set to enabled and trap already exists, unpause
            if (this.focusTrap) this.focusTrap.unpause();
            // Else initialise the focus trap
            return this.initFocusTrap();
        }
    }
    componentDidUpdate(prevProps) {
        this.handleChangedFocusTrapProp(prevProps);
    }
    componentDidMount() {
        window.addEventListener('resize', this.onResize);
        const { stick: stick } = this.props;
        this.scrollParentElement = (0, $5QPz6.findOverflowScrollParent)(this.props.target);
        if (this.scrollParentElement && this.resizeObserver) this.resizeObserver.observe(this.scrollParentElement);
        if (stick) this.scrollElement = this.scrollParentElement;
        else this.scrollElement = this.props.scrollableElement;
        if (this.scrollElement) this.scrollElement.addEventListener('scroll', this.onResize);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize);
        if (this.scrollElement) this.scrollElement.removeEventListener('scroll', this.onResize);
        if (this.scrollParentElement && this.resizeObserver) this.resizeObserver.unobserve(this.scrollParentElement);
        this.scheduledUpdatePosition.cancel();
        this.destroyFocusTrap();
        const { onUnmount: onUnmount } = this.props;
        if (onUnmount) onUnmount();
    }
    renderPopup() {
        const { position: position } = this.state;
        const { shouldRenderPopup: shouldRenderPopup } = this.props;
        if (shouldRenderPopup && !shouldRenderPopup(position || {})) return null;
        //In some cases we don't want to use default "Popup" text as an aria-label. It might be tedious for screen reader users.
        const ariaLabel = this.props.ariaLabel === null ? undefined : this.props.ariaLabel || 'Popup';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ref: this.handleRef,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'absolute',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                zIndex: this.props.zIndex || (0, $25FYC.akEditorFloatingPanelZIndex),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...position,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...this.props.style
            },
            "aria-label": ariaLabel,
            "data-testid": "popup-wrapper",
            // Indicates component is an editor pop. Required for focus handling in Message.tsx
            "data-editor-popup": true
        }, this.props.children);
    }
    render() {
        const { target: target, mountTo: mountTo } = this.props;
        const { validPosition: validPosition } = this.state;
        if (!target || !validPosition) return null;
        if (mountTo) return /*#__PURE__*/ (0, $lEfVV.createPortal)(this.renderPopup(), mountTo);
        // Without mountTo property renders popup as is,
        // which means it will be cropped by "overflow: hidden" container.
        return this.renderPopup();
    }
    constructor(...args){
        super(...args);
        this.rafIds = new Set();
        this.state = {
            validPosition: true
        };
        this.popupRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef();
        this.placement = [
            '',
            ''
        ];
        this.handleRef = (popup)=>{
            if (!popup) return;
            this.initPopup(popup);
        };
        this.scheduledUpdatePosition = (0, $8yx6O.default)((props)=>{
            this.updatePosition(this.props);
        });
        this.onResize = ()=>this.scheduledUpdatePosition(this.props);
        this.resizeObserver = window?.ResizeObserver ? new ResizeObserver(()=>{
            this.scheduledUpdatePosition(this.props);
        }) : undefined;
        /**
	 * Raf scheduled so that it also occurs after the initial update position
	 */ this.initFocusTrap = (0, $8yx6O.default)(()=>{
            const popup = this.popupRef.current;
            if (!popup) return;
            const trapConfig = {
                clickOutsideDeactivates: true,
                escapeDeactivates: true,
                initialFocus: popup,
                fallbackFocus: popup,
                returnFocusOnDeactivate: false
            };
            this.focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($a2Ury)))(popup, trapConfig);
            this.focusTrap.activate();
        });
    }
}

});
parcelRegister("5QPz6", function(module, exports) {

$parcel$export(module.exports, "calculatePlacement", () => $8b3347a5720c5d14$export$b81415a09b611cb);
$parcel$export(module.exports, "findOverflowScrollParent", () => $8b3347a5720c5d14$export$69742dd9a26edd3e);
$parcel$export(module.exports, "calculatePosition", () => $8b3347a5720c5d14$export$b3ceb0cbf1056d98);
$parcel$export(module.exports, "validatePosition", () => $8b3347a5720c5d14$export$ab306cb155a0ca1b);
function $8b3347a5720c5d14$export$540dbd453ede1ce3(elem) {
    return elem === document.body;
}
function $8b3347a5720c5d14$export$ccbedd67ef6e9417(elem) {
    return elem && elem.nodeType === 3;
}
function $8b3347a5720c5d14$export$ba5b1093dd832251(target, boundariesElement, fitHeight, alignY, forcePlacement, preventOverflow) {
    if (forcePlacement && alignY) return alignY;
    if (!fitHeight) return 'bottom';
    if ($8b3347a5720c5d14$export$ccbedd67ef6e9417(target)) target = target.parentElement;
    const boundariesClientRect = boundariesElement.getBoundingClientRect();
    const { height: boundariesHeight } = boundariesClientRect;
    const boundariesTop = $8b3347a5720c5d14$export$540dbd453ede1ce3(boundariesElement) ? 0 : boundariesClientRect.top;
    const { top: targetTop, height: targetHeight } = target.getBoundingClientRect();
    const spaceAbove = targetTop - (boundariesTop - boundariesElement.scrollTop);
    const spaceBelow = boundariesTop + boundariesHeight - (targetTop + targetHeight);
    // Force vertical placement to bottom if the space above doesn't accomodate the fitHeight
    if (preventOverflow) {
        if (spaceAbove <= fitHeight) return 'bottom';
    }
    if (spaceBelow >= fitHeight || spaceBelow >= spaceAbove) return 'bottom';
    return 'top';
}
function $8b3347a5720c5d14$export$af26c34d66be95d6(target, boundariesElement, fitWidth, alignX, forcePlacement, preventOverflow) {
    // force placement unless preventOverflow is enabled
    if (forcePlacement && alignX && !preventOverflow) return alignX;
    if (!fitWidth) return alignX || 'left';
    if ($8b3347a5720c5d14$export$ccbedd67ef6e9417(target)) target = target.parentElement;
    const { left: targetLeft, width: targetWidth } = target.getBoundingClientRect();
    const { left: boundariesLeft, width: boundariesWidth } = boundariesElement.getBoundingClientRect();
    const spaceLeft = targetLeft - boundariesLeft + targetWidth;
    const spaceRight = boundariesLeft + boundariesWidth - targetLeft;
    if (alignX && spaceLeft > fitWidth && spaceRight > fitWidth) return alignX;
    else if (spaceRight >= fitWidth || spaceRight >= spaceLeft && !alignX) return 'left';
    return 'right';
}
function $8b3347a5720c5d14$export$b81415a09b611cb(target, boundariesElement, fitWidth, fitHeight, alignX, alignY, forcePlacement, preventOverflow) {
    return [
        $8b3347a5720c5d14$export$ba5b1093dd832251(target, boundariesElement, fitHeight, alignY, forcePlacement, preventOverflow),
        $8b3347a5720c5d14$export$af26c34d66be95d6(target, boundariesElement, fitWidth, alignX, forcePlacement, preventOverflow)
    ];
}
const $8b3347a5720c5d14$var$calculateHorizontalPlacement = ({ placement: placement, targetLeft: targetLeft, targetRight: targetRight, targetWidth: targetWidth, isPopupParentBody: isPopupParentBody, popupOffsetParentLeft: popupOffsetParentLeft, popupOffsetParentRight: popupOffsetParentRight, popupOffsetParentScrollLeft: popupOffsetParentScrollLeft, popupOffsetParentClientWidth: popupOffsetParentClientWidth, popupClientWidth: popupClientWidth, offset: offset, allowOutOfBounds: allowOutOfBounds = false })=>{
    const position = {};
    if (placement === 'left') position.left = Math.ceil(targetLeft - popupOffsetParentLeft + (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) + offset[0]);
    else if (placement === 'center') position.left = Math.ceil(targetLeft - popupOffsetParentLeft + (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) + offset[0] + targetWidth / 2 - popupClientWidth / 2);
    else if (placement === 'end') {
        const left = Math.ceil(targetRight - popupOffsetParentLeft + (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) + offset[0]);
        position.left = left;
    } else position.right = Math.ceil(popupOffsetParentRight - targetRight - (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) + offset[0]);
    if (!allowOutOfBounds) {
        if (position.left !== undefined) position.left = $8b3347a5720c5d14$var$getPopupXInsideParent(position.left, popupClientWidth, popupOffsetParentClientWidth);
        if (position.right !== undefined) position.right = $8b3347a5720c5d14$var$getPopupXInsideParent(position.right, popupClientWidth, popupOffsetParentClientWidth);
    }
    return position;
};
const $8b3347a5720c5d14$var$getPopupXInsideParent = (x, popupClientWidth, popupOffsetParentClientWidth)=>{
    // minimum distance the popup can be from the edge of its parent
    const minPopupMargin = 1;
    // prevent going too far right
    if (popupOffsetParentClientWidth < x + popupClientWidth) x = popupOffsetParentClientWidth - popupClientWidth - minPopupMargin;
    // prevent going too far left
    return Math.max(minPopupMargin, x);
};
const $8b3347a5720c5d14$var$calculateVerticalStickBottom = ({ target: target, targetTop: targetTop, targetHeight: targetHeight, popup: popup, offset: offset, position: position })=>{
    const scrollParent = $8b3347a5720c5d14$export$69742dd9a26edd3e(target);
    const newPos = {
        ...position
    };
    if (scrollParent) {
        let topOffsetTop = targetTop - scrollParent.getBoundingClientRect().top;
        let targetEnd = targetHeight + topOffsetTop;
        if (scrollParent.clientHeight - targetEnd <= popup.clientHeight + offset[1] * 2 && topOffsetTop < scrollParent.clientHeight) {
            const scroll = targetEnd - scrollParent.clientHeight + offset[1] * 2;
            let top = newPos.top || 0;
            top = top - (scroll + popup.clientHeight);
            newPos.top = top;
        }
    }
    return newPos;
};
const $8b3347a5720c5d14$var$calculateVerticalStickTop = ({ target: target, targetTop: targetTop, targetHeight: targetHeight, popupOffsetParentHeight: popupOffsetParentHeight, popupOffsetParent: popupOffsetParent, offset: offset, position: position, placement: placement })=>{
    const scrollParent = $8b3347a5720c5d14$export$69742dd9a26edd3e(target);
    const newPos = {
        ...position
    };
    if (scrollParent) {
        const { top: scrollParentTop } = scrollParent.getBoundingClientRect();
        const topBoundary = targetTop - scrollParentTop;
        const scrollParentScrollTop = scrollParent.scrollTop;
        if (topBoundary < 0) {
            const isBelowNodeBoundary = targetTop + (scrollParentScrollTop - scrollParentTop) + targetHeight + offset[1] < scrollParentScrollTop;
            if (placement === 'top') {
                if (isBelowNodeBoundary) newPos.bottom = popupOffsetParentHeight - (topBoundary + popupOffsetParent.scrollTop + targetHeight);
                else newPos.bottom = topBoundary + (newPos.bottom || 0);
            }
            if (placement === 'start') {
                if (isBelowNodeBoundary) newPos.top = topBoundary + popupOffsetParent.scrollTop + targetHeight;
                else newPos.top = Math.abs(topBoundary) + (newPos.top || 0) + offset[1];
            }
        }
    }
    return newPos;
};
const $8b3347a5720c5d14$var$calculateVerticalPlacement = ({ placement: placement, targetTop: targetTop, targetHeight: targetHeight, isPopupParentBody: isPopupParentBody, popupOffsetParentHeight: popupOffsetParentHeight, popupOffsetParentTop: popupOffsetParentTop, popupOffsetParentScrollTop: popupOffsetParentScrollTop, borderBottomWidth: borderBottomWidth, offset: offset })=>{
    const position = {};
    if (placement === 'top') position.bottom = Math.ceil(popupOffsetParentHeight - (targetTop - popupOffsetParentTop) - (isPopupParentBody ? 0 : popupOffsetParentScrollTop) - borderBottomWidth + offset[1]);
    else if (placement === 'start') position.top = Math.ceil(targetTop - popupOffsetParentTop - offset[1] + (isPopupParentBody ? 0 : popupOffsetParentScrollTop));
    else {
        let top = Math.ceil(targetTop - popupOffsetParentTop + targetHeight + (isPopupParentBody ? 0 : popupOffsetParentScrollTop) - borderBottomWidth + offset[1]);
        position.top = top;
    }
    return position;
};
function $8b3347a5720c5d14$export$b3ceb0cbf1056d98({ placement: placement, target: target, popup: popup, offset: offset, stick: stick, allowOutOfBounds: allowOutOfBounds = false, rect: rect }) {
    let position = {};
    if (!target || !popup || !popup.offsetParent) return position;
    if ($8b3347a5720c5d14$export$ccbedd67ef6e9417(target)) target = target.parentElement;
    const popupOffsetParent = popup.offsetParent;
    const offsetParentStyle = popupOffsetParent.style;
    let borderBottomWidth = 0;
    if (offsetParentStyle && offsetParentStyle.borderBottomWidth) borderBottomWidth = parseInt(offsetParentStyle.borderBottomWidth, 10);
    const [verticalPlacement, horizontalPlacement] = placement;
    const { top: popupOffsetParentTop, left: popupOffsetParentLeft, right: popupOffsetParentRight, height: popupOffsetParentHeight } = rect ? rect : popupOffsetParent.getBoundingClientRect();
    const { top: targetTop, left: targetLeft, right: targetRight, height: targetHeight, width: targetWidth } = target.getBoundingClientRect();
    const isPopupParentBody = $8b3347a5720c5d14$export$540dbd453ede1ce3(popupOffsetParent);
    const verticalPosition = $8b3347a5720c5d14$var$calculateVerticalPlacement({
        placement: verticalPlacement,
        targetTop: targetTop,
        isPopupParentBody: isPopupParentBody,
        popupOffsetParentHeight: popupOffsetParentHeight,
        popupOffsetParentTop: popupOffsetParentTop,
        popupOffsetParentScrollTop: popupOffsetParent.scrollTop || 0,
        targetHeight: targetHeight,
        borderBottomWidth: borderBottomWidth,
        offset: offset
    });
    position = {
        ...position,
        ...verticalPosition
    };
    if ((verticalPlacement === 'top' || verticalPlacement === 'start') && stick) position = $8b3347a5720c5d14$var$calculateVerticalStickTop({
        target: target,
        targetTop: targetTop,
        targetHeight: targetHeight,
        popupOffsetParentHeight: popupOffsetParentHeight,
        popupOffsetParent: popupOffsetParent,
        popup: popup,
        offset: offset,
        position: position,
        placement: verticalPlacement
    });
    if (verticalPlacement !== 'top' && verticalPlacement !== 'start' && stick) position = $8b3347a5720c5d14$var$calculateVerticalStickBottom({
        target: target,
        targetTop: targetTop,
        targetHeight: targetHeight,
        popup: popup,
        offset: offset,
        position: position
    });
    const horizontalPosition = $8b3347a5720c5d14$var$calculateHorizontalPlacement({
        placement: horizontalPlacement,
        targetLeft: targetLeft,
        targetRight: targetRight,
        targetWidth: targetWidth,
        isPopupParentBody: isPopupParentBody,
        popupOffsetParentLeft: popupOffsetParentLeft,
        popupOffsetParentRight: popupOffsetParentRight,
        popupOffsetParentScrollLeft: popupOffsetParent.scrollLeft || 0,
        popupOffsetParentClientWidth: popup.offsetParent.clientWidth,
        popupClientWidth: popup.clientWidth || 0,
        offset: offset,
        allowOutOfBounds: allowOutOfBounds
    });
    position = {
        ...position,
        ...horizontalPosition
    };
    return position;
}
function $8b3347a5720c5d14$export$ab306cb155a0ca1b(popup) {
    // popup.offsetParent does not exist if the popup element is not mounted
    if (!popup || !popup.offsetParent) return false;
    return true;
}
function $8b3347a5720c5d14$export$69742dd9a26edd3e(popup) {
    let parent = popup;
    if (!parent) return false;
    while(parent = parent.parentElement){
        // IE11 on Window 8 doesn't show styles from CSS when accessing through element.style property.
        const style = window.getComputedStyle(parent);
        if (style.overflow === 'scroll' || style.overflowX === 'scroll' || style.overflowY === 'scroll' || parent.classList.contains('fabric-editor-popup-scroll-parent')) return parent;
    }
    return false;
}

});


parcelRegister("ghKKt", function(module, exports) {

$parcel$export(module.exports, "LoadingScreen", () => $bdb27f29dc6dbd82$export$e2b0760399e6dece);
/* @jsx jsx */ 
var $5JgJ2 = parcelRequire("5JgJ2");

var $byn9U = parcelRequire("byn9U");

var $lkPEe = parcelRequire("lkPEe");

var $8yqSf = parcelRequire("8yqSf");

var $gsDfo = parcelRequire("gsDfo");

var $liRQN = parcelRequire("liRQN");

var $2GXlj = parcelRequire("2GXlj");

var $7NBW6 = parcelRequire("7NBW6");

var $cp9TA = parcelRequire("cp9TA");

var $bU7Hk = parcelRequire("bU7Hk");

const $bdb27f29dc6dbd82$export$e2b0760399e6dece = ({ title: title, latestPrompt: latestPrompt, preview: preview, providerFactory: providerFactory, schema: schema, onCancel: onCancel })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return (0, $byn9U.jsx)((0, $2GXlj.FloatingContainer), {
        "data-testid": "loading-screen",
        className: `loading-screen ${(0, $64ce3526fe10ea0e$export$9df59400d72ad68f)}`,
        rainbowBorderAnimation: true,
        disablePadding: true
    }, (0, $byn9U.jsx)((0, $lkPEe.default), null, formatMessage((0, $8yqSf.default).loadingAriaTitle)), (0, $byn9U.jsx)((0, $liRQN.LatestPromptHeader), {
        prompt: latestPrompt === null || latestPrompt === void 0 ? void 0 : latestPrompt.userInput,
        promptADF: latestPrompt === null || latestPrompt === void 0 ? void 0 : latestPrompt.userADFInput,
        presetTitle: latestPrompt === null || latestPrompt === void 0 ? void 0 : latestPrompt.presetTitle,
        providerFactory: providerFactory,
        schema: schema
    }), preview && /*
   * We use a live region so that content updates will be announced to screenreaders. We set:
   * - aria-atomic="false": because if aria-atomic were set to true, the screen reader would keep
   * reannouncing the content from the beginning rather than providing updates only for the newly added content.
   * - aria-live="polite": to ensure that updates are announced by screen readers in a non-disruptive manner,
   * allowing the user to finish their current task before the new content is communicated.
   *
   * We also add a visually hidden description for the live region ("Live updating content:") so that
   * there is at least some minimal context presented to the user about the incoming updates.
   */ (0, $byn9U.jsx)("div", {
        "data-testid": "adf-content-live-region",
        "aria-atomic": "false",
        "aria-live": "polite",
        css: [
            (0, $gsDfo.previewContainer),
            (0, $7NBW6.defaultPaddingStyles)
        ]
    }, (0, $byn9U.jsx)((0, $lkPEe.default), {
        testId: "description"
    }, formatMessage((0, $8yqSf.default).liveRegionDescription)), preview), (0, $byn9U.jsx)("div", {
        css: [
            (0, $7NBW6.defaultPaddingStyles),
            (0, $gsDfo.layoutStyles)
        ]
    }, (0, $byn9U.jsx)("div", {
        "data-testid": "loading-icon",
        css: (0, $gsDfo.logoStyles)
    }, (0, $byn9U.jsx)((0, $bU7Hk.default), {
        alt: formatMessage((0, $8yqSf.default).iconAltText)
    })), (0, $byn9U.jsx)("div", {
        css: (0, $gsDfo.titleStyles)
    }, title), (0, $byn9U.jsx)((0, $cp9TA.CancelEscButton), {
        autoFocus: true,
        onCancel: onCancel
    })));
};

});
parcelRegister("8yqSf", function(module, exports) {

$parcel$export(module.exports, "default", () => $63a6584b0492ad4d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $63a6584b0492ad4d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    iconAltText: {
        id: 'fabric.editor.ai.screens.loading.iconAltText',
        defaultMessage: 'Generating icon',
        description: 'Icon alt text of the Loading screen'
    },
    liveRegionDescription: {
        id: 'fabric.editor.ai.screens.loading.adfContentAriaLiveRegionDescription',
        defaultMessage: 'Live updating content:',
        description: 'Description for content that may update frequently and asynchronously. It is hidden and exists for accessibility'
    },
    loadingAriaTitle: {
        id: 'fabric.editor.ai.experience.loadingAriaTitle',
        defaultMessage: 'Generating',
        description: 'The title string that appears on the "Loading" screen when the user is waiting for Atlassian Intelligence to generate content'
    }
});

});

parcelRegister("gsDfo", function(module, exports) {

$parcel$export(module.exports, "previewContainer", () => $bfbdb4907108647c$export$8aade8ce2b5d7e87);
$parcel$export(module.exports, "layoutStyles", () => $bfbdb4907108647c$export$ac8f5049e4e10701);
$parcel$export(module.exports, "logoStyles", () => $bfbdb4907108647c$export$ff8f5da7da487b1);
$parcel$export(module.exports, "titleStyles", () => $bfbdb4907108647c$export$405b853093cc10c7);

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $kIeme = parcelRequire("kIeme");
const $bfbdb4907108647c$export$8aade8ce2b5d7e87 = (0, $byn9U.css)({
    borderTop: `1px solid ${`var(--ds-border, ${(0, $PdmhA.N40A)})`}`,
    borderBottom: `1px solid ${`var(--ds-border, ${(0, $PdmhA.N40A)})`}`
});
const $bfbdb4907108647c$export$ac8f5049e4e10701 = (0, $byn9U.css)({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'left',
    alignItems: 'center',
    flexWrap: 'wrap'
});
const $bfbdb4907108647c$export$ff8f5da7da487b1 = (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginRight: '5px',
    display: 'flex',
    alignItems: 'center'
});
const $bfbdb4907108647c$var$titleLayoutStyles = (0, $byn9U.css)({
    flex: 1
});
const $bfbdb4907108647c$export$405b853093cc10c7 = [
    $bfbdb4907108647c$var$titleLayoutStyles,
    (0, $kIeme.commonTextStyles)
];

});

parcelRegister("liRQN", function(module, exports) {

$parcel$export(module.exports, "LatestPromptHeader", () => $f8250cfc8aabca59$export$289e4ad0cf050b01);
/* @jsx jsx */ /** @jsxFrag */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $5JgJ2 = parcelRequire("5JgJ2");

var $XHGTv = parcelRequire("XHGTv");

var $jx84U = parcelRequire("jx84U");

var $b2hnG = parcelRequire("b2hnG");

var $1dKbP = parcelRequire("1dKbP");

var $kOSo2 = parcelRequire("kOSo2");
const $f8250cfc8aabca59$var$PROMPT_CONTENT_ID = 'ai-latest-prompt-content';
const $f8250cfc8aabca59$export$289e4ad0cf050b01 = ({ prompt: prompt, promptADF: promptADF, presetTitle: presetTitle, providerFactory: providerFactory, onEditPromptClick: onEditPromptClick, schema: schema })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    // Use renderer only if FF is on and we have user input in ADF.
    const usePromptRenderer = (0, $XHGTv.getBooleanFF)('platform.editor.ai-lightweight-editor-prompt_f92x1') && promptADF;
    // TODO AIFOLLOWUP: We should memoize whole component as we are memoizing all the props below in useMemo.
    const header = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useMemo(()=>{
        if (usePromptRenderer) return (0, $byn9U.jsx)((0, $jx84U.LatestPromptRenderer), {
            presetTitle: presetTitle,
            promptADF: promptADF,
            providerFactory: providerFactory,
            schema: schema
        });
        else return (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, presetTitle && (0, $byn9U.jsx)((0, $b2hnG.RefinementTag), {
            label: presetTitle
        }), prompt && (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, prompt));
    }, [
        usePromptRenderer,
        presetTitle,
        promptADF,
        providerFactory,
        schema,
        prompt
    ]);
    if (!(prompt || presetTitle)) return null;
    return (0, $byn9U.jsx)("div", {
        "data-testid": "prompt-header"
    }, !onEditPromptClick ? (0, $byn9U.jsx)("div", {
        css: [
            (0, $1dKbP.headerStyles),
            usePromptRenderer && (0, $1dKbP.headerWrapperStyles)
        ],
        id: $f8250cfc8aabca59$var$PROMPT_CONTENT_ID
    }, header) : (0, $byn9U.jsx)("button", {
        type: "button",
        "data-testid": "edit-prompt-button",
        onClick: onEditPromptClick,
        css: [
            (0, $1dKbP.headerStyles),
            (0, $1dKbP.headerEditStyles),
            usePromptRenderer && (0, $1dKbP.headerEditRendererStyles)
        ],
        "aria-label": formatMessage((0, $kOSo2.messages).editPrompt),
        "aria-describedby": $f8250cfc8aabca59$var$PROMPT_CONTENT_ID
    }, (0, $byn9U.jsx)("div", {
        css: [
            usePromptRenderer && (0, $1dKbP.headerWrapperStyles)
        ],
        id: $f8250cfc8aabca59$var$PROMPT_CONTENT_ID
    }, header)));
};

});
parcelRegister("jx84U", function(module, exports) {

$parcel$export(module.exports, "LatestPromptRenderer", () => $e3875d8f44f93bd4$export$308e8087851b72a3);

var $eUqFw = parcelRequire("eUqFw");

var $7Y6sw = parcelRequire("7Y6sw");

var $1RkyB = parcelRequire("1RkyB");
const $e3875d8f44f93bd4$export$308e8087851b72a3 = ({ promptADF: promptADF, providerFactory: providerFactory, presetTitle: presetTitle, schema: schema })=>{
    const jsonDocument = (0, $1RkyB.prefixDocumentWithStatusNode)(promptADF, schema, presetTitle);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7Y6sw.default), {
        document: jsonDocument,
        media: {
            // We don't currently support images with captions
            allowLinking: false
        },
        useSpecBasedValidator: true,
        dataProviders: providerFactory
    });
};

});
parcelRegister("1RkyB", function(module, exports) {

$parcel$export(module.exports, "prefixDocumentWithStatusNode", () => $15aaafea26c2c474$export$d9f0641d4fe6723e);

var $dFBS3 = parcelRequire("dFBS3");
function $15aaafea26c2c474$export$d9f0641d4fe6723e(userADFInput, schema, presetTitle) {
    /**
   * We don't need to encode using JSONTransformer because,
   *  before saving in adf string we have already encoded document to json.
   * Checkout platform/packages/editor/editor-ai-injected-editors/src/editors/prompt.tsx
   * Just need to parse that json here.
   */ const jsonDocument = JSON.parse(userADFInput);
    if (!presetTitle) return jsonDocument;
    const status = schema.nodes['status'];
    const statusNode = status.createChecked({
        color: 'neutral',
        localId: (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))(),
        text: presetTitle
    }, undefined);
    const statusJson = statusNode.toJSON();
    const textNode = schema.text(' ');
    const textJson = textNode.toJSON();
    const firstNode = jsonDocument.content[0];
    if (firstNode.type === 'paragraph') {
        const paragraphNode = firstNode;
        const paragraphContent = paragraphNode.content;
        if (paragraphContent) paragraphNode.content = [
            statusJson,
            textJson
        ].concat(paragraphNode.content);
    }
    return jsonDocument;
}

});


parcelRegister("b2hnG", function(module, exports) {

$parcel$export(module.exports, "RefinementTag", () => $808d5d178357f233$export$21c661408d518ab6);
/* @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lXabx = parcelRequire("lXabx");
var $9jNAz = parcelRequire("9jNAz");

var $8yr5x = parcelRequire("8yr5x");

var $4nIEF = parcelRequire("4nIEF");
const $808d5d178357f233$export$21c661408d518ab6 = ({ label: label, onClick: onClick, elemBefore: elemBefore, appearance: appearance })=>{
    const styles = {
        [(0, $4nIEF.cssVars).alignItems]: appearance === 'rounded' ? 'center' : 'flex-start',
        [(0, $4nIEF.cssVars).elemBeforeHeight]: appearance === 'rounded' ? '100%' : 'auto'
    };
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return (0, $byn9U.jsx)("span", {
        style: styles,
        css: (0, $4nIEF.refinementTagStyles),
        className: "refinement-tag",
        "data-testid": "command-palette-refinement-tag",
        role: "status",
        "aria-atomic": "true",
        "aria-label": formatMessage((0, $8yr5x.default).promptSelected, {
            promptName: label
        }),
        "aria-live": "assertive"
    }, !onClick ? (0, $byn9U.jsx)((0, $9jNAz.default), {
        testId: 'refinement-tag',
        text: label
    }) : (0, $byn9U.jsx)((0, $lXabx.default), {
        appearance: appearance,
        elemBefore: elemBefore,
        testId: 'refinement-tag',
        removeButtonLabel: formatMessage((0, $8yr5x.default).removeLabel),
        text: label,
        onBeforeRemoveAction: ()=>{
            onClick();
            return false;
        }
    }));
};

});
parcelRegister("lXabx", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3ff7c9e14de284a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $co43T = parcelRequire("co43T");

var $1lQG9 = parcelRequire("1lQG9");

var $5Q9wj = parcelRequire("5Q9wj");

var $lSV8Z = parcelRequire("lSV8Z");
var $5Dp4O = parcelRequire("5Dp4O");

var $jFsza = parcelRequire("jFsza");

var $i6wnX = parcelRequire("i6wnX");

var $d9W8K = parcelRequire("d9W8K");

var $6aZHE = parcelRequire("6aZHE");

var $gz2Bi = parcelRequire("gz2Bi");

var $keeN7 = parcelRequire("keeN7");
var $c3ff7c9e14de284a$var$TagStatus;
(function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
})($c3ff7c9e14de284a$var$TagStatus || ($c3ff7c9e14de284a$var$TagStatus = {}));
const $c3ff7c9e14de284a$var$packageName = undefined;
const $c3ff7c9e14de284a$var$packageVersion = undefined;
const $c3ff7c9e14de284a$var$defaultBeforeRemoveAction = ()=>true;
/**
 * These hide the focus ring for the tag when its remove button is focused,
 * preventing a double focus ring.
 */ const $c3ff7c9e14de284a$var$removingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:focus-within': {
        boxShadow: `0 0 0 2px transparent`,
        outline: 'none'
    }
});
const $c3ff7c9e14de284a$var$RemovableTag = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, removeButtonLabel: removeButtonLabel, testId: testId, onBeforeRemoveAction: onBeforeRemoveAction = $c3ff7c9e14de284a$var$defaultBeforeRemoveAction, onAfterRemoveAction: onAfterRemoveAction = (0, $5Q9wj.default), linkComponent: linkComponent }, ref)=>{
    const [status, setStatus] = (0, $eUqFw.useState)("showing");
    const [isHoverCloseButton, setIsHoverCloseButton] = (0, $eUqFw.useState)(false);
    const onAfterRemoveActionWithAnalytics = (0, $co43T.useCallbackWithAnalytics)(onAfterRemoveAction, {
        action: 'removed',
        actionSubject: 'tag',
        attributes: {
            componentName: 'tag',
            packageName: $c3ff7c9e14de284a$var$packageName,
            packageVersion: $c3ff7c9e14de284a$var$packageVersion
        }
    }, 'atlaskit');
    const handleRemoveComplete = (0, $eUqFw.useCallback)(()=>{
        onAfterRemoveActionWithAnalytics(text);
        setStatus("removed");
    }, [
        onAfterRemoveActionWithAnalytics,
        text
    ]);
    const handleRemoveRequest = (0, $eUqFw.useCallback)(()=>{
        if (onBeforeRemoveAction && onBeforeRemoveAction()) handleRemoveComplete();
    }, [
        handleRemoveComplete,
        onBeforeRemoveAction
    ]);
    const onKeyPress = (0, $eUqFw.useCallback)((e)=>{
        const spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    const removingTag = (0, $eUqFw.useCallback)(()=>setStatus("removing"), []);
    const showingTag = (0, $eUqFw.useCallback)(()=>setStatus("showing"), []);
    const handleMouseOver = (0, $eUqFw.useCallback)(()=>setIsHoverCloseButton(true), []);
    const handleMouseOut = (0, $eUqFw.useCallback)(()=>setIsHoverCloseButton(false), []);
    const removeButton = isRemovable ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $keeN7.default), {
        "aria-label": `${removeButtonLabel} ${text}`,
        onClick: handleRemoveRequest,
        onFocus: removingTag,
        onBlur: showingTag,
        onKeyPress: onKeyPress,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        testId: `close-button-${testId}`
    }) : undefined;
    const content = /*#__PURE__*/ (0, $byn9U.jsx)((0, $gz2Bi.default), {
        elemBefore: elemBefore,
        isRemovable: isRemovable,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    const hoverCloseButtonColors = {
        // Tag background color on hover
        [(0, $jFsza.cssVar).color.background.hover]: $i6wnX.removalHoverBackgroundColors,
        // Tag background color on press
        [(0, $jFsza.cssVar).color.background.active]: $i6wnX.removalActiveBackgroundColors,
        // The tag text on hover of remove button
        [(0, $jFsza.cssVar).color.text.default]: $i6wnX.removalTextColors,
        // 'elemBefore' text on press of remove button
        [(0, $jFsza.cssVar).color.text.active]: $i6wnX.removalTextColors,
        // The tag link text on hover of remove button
        [(0, $jFsza.cssVar).color.text.link]: $i6wnX.removalTextColors
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $lSV8Z.default), null, !(status === "removed") && /*#__PURE__*/ (0, $byn9U.jsx)((0, $5Dp4O.default), null, (motion)=>{
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $d9W8K.default), {
            ref: (0, $1lQG9.default)([
                motion.ref,
                ref
            ]),
            appearance: appearance,
            color: color,
            testId: testId,
            css: [
                status === "removing" && $c3ff7c9e14de284a$var$removingStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: isHoverCloseButton ? hoverCloseButtonColors : undefined,
            "data-removable": true,
            "data-removing": status === "removing",
            "data-ishoverclosebutton": isHoverCloseButton,
            href: href,
            before: /*#__PURE__*/ (0, $byn9U.jsx)((0, $6aZHE.default), {
                elemBefore: elemBefore
            }),
            contentElement: content,
            after: removeButton
        });
    }));
});
var $c3ff7c9e14de284a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($c3ff7c9e14de284a$var$RemovableTag);

});
parcelRegister("5Dp4O", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fb4b88a82b6f14c$export$2e2bcd8739ae039);


var $5LHuc = parcelRequire("5LHuc");

var $5bTtn = parcelRequire("5bTtn");

var $hcijx = parcelRequire("hcijx");

var $3WV8S = parcelRequire("3WV8S");

var $lSV8Z = parcelRequire("lSV8Z");
/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ const $8fb4b88a82b6f14c$var$ShrinkOut = ({ children: children, duration: duration = (0, $5LHuc.smallDurationMs), onFinish: onFinish })=>{
    const [element, setElementRef] = (0, $hcijx.useElementRef)();
    const exiting = (0, $lSV8Z.useExitingPersistence)();
    const requestAnimationFrame = (0, $5bTtn.useRequestAnimationFrame)();
    const setTimeout = (0, $5bTtn.useSetTimeout)();
    const direction = exiting.isExiting ? 'exiting' : 'entering';
    (0, $3WV8S.useLayoutEffect)(()=>{
        if (exiting.isExiting && element) {
            const newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: `${element.offsetWidth}px`,
                height: `${element.offsetHeight}px`,
                boxSizing: 'border-box',
                willChange: 'width,margin'
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    const newStyles = {
                        width: '0px',
                        margin: '0px',
                        transitionTimingFunction: (0, $d58b680a02f4d6a4$export$929e5a82286172a6),
                        transitionDuration: `${duration}ms`,
                        transitionProperty: 'width,margin'
                    };
                    Object.assign(element.style, newStyles);
                    setTimeout(()=>{
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish('exiting');
                    }, duration);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
var $8fb4b88a82b6f14c$export$2e2bcd8739ae039 = $8fb4b88a82b6f14c$var$ShrinkOut;

});
const $d58b680a02f4d6a4$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $d58b680a02f4d6a4$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $d58b680a02f4d6a4$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';

parcelRegister("hcijx", function(module, exports) {

$parcel$export(module.exports, "useElementRef", () => $81c15b5f9718dda0$export$ff879f35a69d56b7);

var $eUqFw = parcelRequire("eUqFw");
const $81c15b5f9718dda0$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $eUqFw.useRef)(null);
    const setRef = (0, $eUqFw.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};

});


parcelRegister("jFsza", function(module, exports) {

$parcel$export(module.exports, "tagHeight", () => $2e837ad2e72491cc$export$5b2b1030a679f37);
$parcel$export(module.exports, "buttonWidthUnitless", () => $2e837ad2e72491cc$export$c6f3ea2b4cffd0ca);
$parcel$export(module.exports, "maxTextWidthUnitless", () => $2e837ad2e72491cc$export$2e3bcb01bf928995);
$parcel$export(module.exports, "maxTextWidth", () => $2e837ad2e72491cc$export$982d4a1a6de11130);
$parcel$export(module.exports, "defaultBorderRadius", () => $2e837ad2e72491cc$export$35d5d1e251b985cf);
$parcel$export(module.exports, "defaultRoundedBorderRadius", () => $2e837ad2e72491cc$export$c49771100fee18c8);
$parcel$export(module.exports, "defaultMargin", () => $2e837ad2e72491cc$export$6728fea658cfb92e);
$parcel$export(module.exports, "defaultTextPadding", () => $2e837ad2e72491cc$export$c2d03c4c68282362);
$parcel$export(module.exports, "textPaddingRight", () => $2e837ad2e72491cc$export$b5686dedf408caa0);
$parcel$export(module.exports, "textMarginLeft", () => $2e837ad2e72491cc$export$b824cac86306f7a2);
$parcel$export(module.exports, "cssVar", () => $2e837ad2e72491cc$export$8b4981022bd80a4e);
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $lcnyw = parcelRequire("lcnyw");
const $2e837ad2e72491cc$var$gridSizeValue = (0, $lcnyw.gridSize)();
const $2e837ad2e72491cc$var$borderRadiusValue = (0, $lcnyw.borderRadius)();
const $2e837ad2e72491cc$export$b4d89c3994664204 = 2.5 * $2e837ad2e72491cc$var$gridSizeValue;
const $2e837ad2e72491cc$export$5b2b1030a679f37 = `var(--ds-space-250, ${`${$2e837ad2e72491cc$export$b4d89c3994664204}px`})`;
const $2e837ad2e72491cc$export$c6f3ea2b4cffd0ca = $2e837ad2e72491cc$export$b4d89c3994664204; // button should be square
const $2e837ad2e72491cc$export$aba002ef70684916 = $2e837ad2e72491cc$export$5b2b1030a679f37; // button should be square
const $2e837ad2e72491cc$export$d5949a2c2ea9dcea = 25 * $2e837ad2e72491cc$var$gridSizeValue;
const $2e837ad2e72491cc$export$488fda99655ff65a = `${$2e837ad2e72491cc$export$d5949a2c2ea9dcea}px`;
const $2e837ad2e72491cc$export$2e3bcb01bf928995 = $2e837ad2e72491cc$export$d5949a2c2ea9dcea - $2e837ad2e72491cc$export$b4d89c3994664204;
const $2e837ad2e72491cc$export$982d4a1a6de11130 = `${$2e837ad2e72491cc$export$2e3bcb01bf928995}px`;
const $2e837ad2e72491cc$export$35d5d1e251b985cf = `${$2e837ad2e72491cc$var$borderRadiusValue}px`;
const $2e837ad2e72491cc$export$c49771100fee18c8 = `${$2e837ad2e72491cc$export$c6f3ea2b4cffd0ca / 2}px`;
const $2e837ad2e72491cc$export$6728fea658cfb92e = `var(--ds-space-050, ${`${$2e837ad2e72491cc$var$gridSizeValue / 2}px`})`;
const $2e837ad2e72491cc$export$c2d03c4c68282362 = `var(--ds-space-050, ${`${$2e837ad2e72491cc$var$gridSizeValue / 2}px`})`;
const $2e837ad2e72491cc$export$b5686dedf408caa0 = `var(--ds-space-200, ${`${2 * $2e837ad2e72491cc$var$gridSizeValue}px`})`;
const $2e837ad2e72491cc$export$b824cac86306f7a2 = $2e837ad2e72491cc$export$5b2b1030a679f37;
const $2e837ad2e72491cc$export$8b4981022bd80a4e = {
    color: {
        background: {
            default: '--ds-cb',
            hover: '--ds-cbh',
            active: '--ds-cba'
        },
        focusRing: '--ds-cfr',
        text: {
            default: '--ds-ct',
            hover: '--ds-cth',
            active: '--ds-ctp',
            link: '--ds-ctl'
        },
        removeButton: {
            default: '--ds-rb',
            hover: '--ds-rbh'
        }
    },
    borderRadius: '--ds-br'
};

});

parcelRegister("i6wnX", function(module, exports) {

$parcel$export(module.exports, "textColors", () => $fc0da2a7c84ba49c$export$daa0ace263cb20d2);
$parcel$export(module.exports, "textHoverColors", () => $fc0da2a7c84ba49c$export$7c7104a5f052cab7);
$parcel$export(module.exports, "textActiveColors", () => $fc0da2a7c84ba49c$export$382469baad253eb7);
$parcel$export(module.exports, "backgroundColors", () => $fc0da2a7c84ba49c$export$b9d7c59a579c23c6);
$parcel$export(module.exports, "linkHoverBackgroundColors", () => $fc0da2a7c84ba49c$export$4410079763249c74);
$parcel$export(module.exports, "linkActiveBackgroundColors", () => $fc0da2a7c84ba49c$export$76be99c5e13e3566);
$parcel$export(module.exports, "focusRingColors", () => $fc0da2a7c84ba49c$export$2a31dbe82788f940);
$parcel$export(module.exports, "borderRadius", () => $fc0da2a7c84ba49c$export$7a57f79000377ca2);
$parcel$export(module.exports, "removalHoverBackgroundColors", () => $fc0da2a7c84ba49c$export$1202b7eb21da7b58);
$parcel$export(module.exports, "removalActiveBackgroundColors", () => $fc0da2a7c84ba49c$export$62ace793ebb16bda);
$parcel$export(module.exports, "removalTextColors", () => $fc0da2a7c84ba49c$export$17d206ccea111bbb);
$parcel$export(module.exports, "removeButtonColors", () => $fc0da2a7c84ba49c$export$f64c7641cbc22da7);
$parcel$export(module.exports, "removeButtonHoverColors", () => $fc0da2a7c84ba49c$export$b03fbc2a369c563e);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $PdmhA = parcelRequire("PdmhA");

var $jFsza = parcelRequire("jFsza");
const $fc0da2a7c84ba49c$export$daa0ace263cb20d2 = {
    standard: `var(--ds-text, ${$PdmhA.N700})`,
    standardLink: `var(--ds-link, ${$PdmhA.B400})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$PdmhA.N800})`,
    red: `var(--ds-text-accent-red-bolder, ${$PdmhA.N800})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$PdmhA.N800})`,
    green: `var(--ds-text-accent-green-bolder, ${$PdmhA.N800})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$PdmhA.N800})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$PdmhA.N800})`,
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: `var(--ds-text-accent-gray-bolder, ${$PdmhA.N0})`,
    blueLight: `var(--ds-text-accent-blue, ${$PdmhA.B500})`,
    redLight: `var(--ds-text-accent-red, ${$PdmhA.N500})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$PdmhA.N500})`,
    greenLight: `var(--ds-text-accent-green, ${$PdmhA.G500})`,
    tealLight: `var(--ds-text-accent-teal, ${$PdmhA.N500})`,
    purpleLight: `var(--ds-text-accent-purple, ${$PdmhA.P500})`,
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: `var(--ds-text-accent-gray, ${$PdmhA.N500})`
};
const $fc0da2a7c84ba49c$export$7c7104a5f052cab7 = {
    standard: `var(--ds-link, ${$PdmhA.B300})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$PdmhA.N800})`,
    red: `var(--ds-text-accent-red-bolder, ${$PdmhA.N800})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$PdmhA.N800})`,
    green: `var(--ds-text-accent-green-bolder, ${$PdmhA.N800})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$PdmhA.N800})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$PdmhA.N800})`,
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: `var(--ds-text-accent-gray-bolder, ${$PdmhA.N0})`,
    blueLight: `var(--ds-text-accent-blue, ${$PdmhA.B500})`,
    redLight: `var(--ds-text-accent-red, ${$PdmhA.N500})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$PdmhA.N500})`,
    greenLight: `var(--ds-text-accent-green, ${$PdmhA.G500})`,
    tealLight: `var(--ds-text-accent-teal, ${$PdmhA.N500})`,
    purpleLight: `var(--ds-text-accent-purple, ${$PdmhA.P500})`,
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: `var(--ds-text-accent-gray, ${$PdmhA.N500})`
};
const $fc0da2a7c84ba49c$export$382469baad253eb7 = {
    standard: `var(--ds-link-pressed, ${$PdmhA.B300})`,
    blue: `var(--ds-text-accent-blue, ${$PdmhA.N800})`,
    red: `var(--ds-text-accent-red, ${$PdmhA.N800})`,
    yellow: `var(--ds-text-accent-yellow, ${$PdmhA.N800})`,
    green: `var(--ds-text-accent-green, ${$PdmhA.N800})`,
    teal: `var(--ds-text-accent-teal, ${$PdmhA.N800})`,
    purple: `var(--ds-text-accent-purple, ${$PdmhA.N800})`,
    lime: "var(--ds-text-accent-lime, #4C6B1F)",
    magenta: "var(--ds-text-accent-magenta, #943D73)",
    orange: "var(--ds-text-accent-orange, #974F0C)",
    grey: `var(--ds-text-accent-gray, ${$PdmhA.N0})`,
    blueLight: `var(--ds-text-accent-blue-bolder, ${$PdmhA.B500})`,
    redLight: `var(--ds-text-accent-red-bolder, ${$PdmhA.N500})`,
    yellowLight: `var(--ds-text-accent-yellow-bolder, ${$PdmhA.N500})`,
    greenLight: `var(--ds-text-accent-green-bolder, ${$PdmhA.G500})`,
    tealLight: `var(--ds-text-accent-teal-bolder, ${$PdmhA.N500})`,
    purpleLight: `var(--ds-text-accent-purple-bolder, ${$PdmhA.P500})`,
    limeLight: "var(--ds-text-accent-lime-bolder, #37471F)",
    magentaLight: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orangeLight: "var(--ds-text-accent-orange-bolder, #5F3811)",
    greyLight: `var(--ds-text-accent-gray-bolder, ${$PdmhA.N500})`
};
const $fc0da2a7c84ba49c$export$b9d7c59a579c23c6 = {
    standard: `var(--ds-background-neutral, ${$PdmhA.N20})`,
    blue: `var(--ds-background-accent-blue-subtle, ${$PdmhA.B100})`,
    red: `var(--ds-background-accent-red-subtle, ${$PdmhA.R100})`,
    yellow: `var(--ds-background-accent-yellow-subtle, ${$PdmhA.Y200})`,
    green: `var(--ds-background-accent-green-subtle, ${$PdmhA.G200})`,
    teal: `var(--ds-background-accent-teal-subtle, ${$PdmhA.T200})`,
    purple: `var(--ds-background-accent-purple-subtle, ${$PdmhA.P100})`,
    lime: "var(--ds-background-accent-lime-subtle, #94C748)",
    magenta: "var(--ds-background-accent-magenta-subtle, #E774BB)",
    orange: "var(--ds-background-accent-orange-subtle, #FAA53D)",
    grey: `var(--ds-background-accent-gray-subtle, ${$PdmhA.N500})`,
    blueLight: `var(--ds-background-accent-blue-subtler, ${$PdmhA.B75})`,
    redLight: `var(--ds-background-accent-red-subtler, ${$PdmhA.R75})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler, ${$PdmhA.Y100})`,
    greenLight: `var(--ds-background-accent-green-subtler, ${$PdmhA.G100})`,
    tealLight: `var(--ds-background-accent-teal-subtler, ${$PdmhA.T100})`,
    purpleLight: `var(--ds-background-accent-purple-subtler, ${$PdmhA.P75})`,
    limeLight: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    magentaLight: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    orangeLight: "var(--ds-background-accent-orange-subtler, #FFE2BD)",
    greyLight: `var(--ds-background-accent-gray-subtler, ${$PdmhA.N30})`
};
const $fc0da2a7c84ba49c$export$4410079763249c74 = {
    standard: `var(--ds-background-neutral-hovered, ${$PdmhA.N30})`,
    blue: `var(--ds-background-accent-blue-subtle-hovered, ${$PdmhA.B75})`,
    red: `var(--ds-background-accent-red-subtle-hovered, ${$PdmhA.R75})`,
    yellow: `var(--ds-background-accent-yellow-subtle-hovered, ${$PdmhA.Y100})`,
    green: `var(--ds-background-accent-green-subtle-hovered, ${$PdmhA.G100})`,
    teal: `var(--ds-background-accent-teal-subtle-hovered, ${$PdmhA.T100})`,
    purple: `var(--ds-background-accent-purple-subtle-hovered, ${$PdmhA.P75})`,
    lime: "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    magenta: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    orange: "var(--ds-background-accent-orange-subtle-hovered, #FEC57B)",
    grey: `var(--ds-background-accent-gray-subtle-hovered, ${$PdmhA.N400})`,
    blueLight: `var(--ds-background-accent-blue-subtler-hovered, ${$PdmhA.B50})`,
    redLight: `var(--ds-background-accent-red-subtler-hovered, ${$PdmhA.R50})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler-hovered, ${$PdmhA.Y75})`,
    greenLight: `var(--ds-background-accent-green-subtler-hovered, ${$PdmhA.G75})`,
    tealLight: `var(--ds-background-accent-teal-subtler-hovered, ${$PdmhA.T75})`,
    purpleLight: `var(--ds-background-accent-purple-subtler-hovered, ${$PdmhA.P50})`,
    limeLight: "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    orangeLight: "var(--ds-background-accent-orange-subtler-hovered, #FEC57B)",
    greyLight: `var(--ds-background-accent-gray-subtler-hovered, ${$PdmhA.N40})`
};
const $fc0da2a7c84ba49c$export$76be99c5e13e3566 = {
    standard: `var(--ds-background-neutral-pressed, ${$PdmhA.N30})`,
    blue: `var(--ds-background-accent-blue-subtle-pressed, ${$PdmhA.B50})`,
    red: `var(--ds-background-accent-red-subtle-pressed, ${$PdmhA.R50})`,
    yellow: `var(--ds-background-accent-yellow-subtle-pressed, ${$PdmhA.Y75})`,
    green: `var(--ds-background-accent-green-subtle-pressed, ${$PdmhA.G75})`,
    teal: `var(--ds-background-accent-teal-subtle-pressed, ${$PdmhA.T75})`,
    purple: `var(--ds-background-accent-purple-subtle-pressed, ${$PdmhA.P50})`,
    grey: `var(--ds-background-accent-gray-subtle-pressed, ${$PdmhA.N300})`,
    lime: "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    magenta: "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    orange: "var(--ds-background-accent-orange-subtle-pressed, #FFE2BD)",
    blueLight: `var(--ds-background-accent-blue-subtler-pressed, ${$PdmhA.B100})`,
    redLight: `var(--ds-background-accent-red-subtler-pressed, ${$PdmhA.R100})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler-pressed, ${$PdmhA.Y200})`,
    greenLight: `var(--ds-background-accent-green-subtler-pressed, ${$PdmhA.G200})`,
    tealLight: `var(--ds-background-accent-teal-subtler-pressed, ${$PdmhA.T200})`,
    purpleLight: `var(--ds-background-accent-purple-subtler-pressed, ${$PdmhA.P100})`,
    limeLight: "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    orangeLight: "var(--ds-background-accent-orange-subtler-pressed, #FAA53D)",
    greyLight: `var(--ds-background-accent-gray-subtler-pressed, ${$PdmhA.N50})`
};
const $fc0da2a7c84ba49c$export$2a31dbe82788f940 = `var(--ds-border-focused, ${$PdmhA.B100})`;
const $fc0da2a7c84ba49c$export$7a57f79000377ca2 = {
    default: (0, $jFsza.defaultBorderRadius),
    rounded: (0, $jFsza.defaultRoundedBorderRadius)
};
const $fc0da2a7c84ba49c$export$1202b7eb21da7b58 = `var(--ds-background-danger, ${$PdmhA.R50})`;
const $fc0da2a7c84ba49c$export$62ace793ebb16bda = `var(--ds-background-danger-hovered, ${$PdmhA.R50})`;
const $fc0da2a7c84ba49c$export$17d206ccea111bbb = `var(--ds-text-danger, ${$PdmhA.R500})`;
const $fc0da2a7c84ba49c$export$f64c7641cbc22da7 = {
    standard: `var(--ds-text, ${$PdmhA.N500})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$PdmhA.N500})`,
    red: `var(--ds-text-accent-red-bolder, ${$PdmhA.N500})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$PdmhA.N500})`,
    green: `var(--ds-text-accent-green-bolder, ${$PdmhA.N500})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$PdmhA.N500})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$PdmhA.N500})`,
    lime: `var(--ds-text-accent-lime-bolder, ${$PdmhA.N500})`,
    magenta: `var(--ds-text-accent-magenta-bolder, ${$PdmhA.N500})`,
    orange: `var(--ds-text-accent-orange-bolder, ${$PdmhA.N500})`,
    grey: `var(--ds-text-accent-gray-bolder, ${$PdmhA.N500})`,
    blueLight: `var(--ds-text-accent-blue, ${$PdmhA.N500})`,
    redLight: `var(--ds-text-accent-red, ${$PdmhA.N500})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$PdmhA.N500})`,
    greenLight: `var(--ds-text-accent-green, ${$PdmhA.N500})`,
    tealLight: `var(--ds-text-accent-teal, ${$PdmhA.N500})`,
    purpleLight: `var(--ds-text-accent-purple, ${$PdmhA.N500})`,
    limeLight: `var(--ds-text-accent-lime, ${$PdmhA.N500})`,
    magentaLight: `var(--ds-text-accent-magenta, ${$PdmhA.N500})`,
    orangeLight: `var(--ds-text-accent-orange, ${$PdmhA.N500})`,
    greyLight: `var(--ds-text-accent-gray, ${$PdmhA.N500})`
};
const $fc0da2a7c84ba49c$export$b03fbc2a369c563e = {
    standard: `var(--ds-text-danger, ${$PdmhA.N700})`,
    standardLink: `var(--ds-text-danger, ${$PdmhA.B400})`,
    blue: `var(--ds-text-danger, ${$PdmhA.N800})`,
    red: `var(--ds-text-danger, ${$PdmhA.N800})`,
    yellow: `var(--ds-text-danger, ${$PdmhA.N800})`,
    green: `var(--ds-text-danger, ${$PdmhA.N800})`,
    teal: `var(--ds-text-danger, ${$PdmhA.N800})`,
    purple: `var(--ds-text-danger, ${$PdmhA.N800})`,
    lime: `var(--ds-text-danger, ${$PdmhA.N800})`,
    magenta: `var(--ds-text-danger, ${$PdmhA.N800})`,
    orange: `var(--ds-text-danger, ${$PdmhA.N800})`,
    grey: `var(--ds-text-danger, ${$PdmhA.N0})`,
    blueLight: `var(--ds-text-danger, ${$PdmhA.B500})`,
    redLight: `var(--ds-text-danger, ${$PdmhA.N500})`,
    yellowLight: `var(--ds-text-danger, ${$PdmhA.N500})`,
    greenLight: `var(--ds-text-danger, ${$PdmhA.G500})`,
    tealLight: `var(--ds-text-danger, ${$PdmhA.N500})`,
    purpleLight: `var(--ds-text-danger, ${$PdmhA.P500})`,
    limeLight: `var(--ds-text-danger, ${$PdmhA.P500})`,
    magentaLight: `var(--ds-text-danger, ${$PdmhA.P500})`,
    orangeLight: `var(--ds-text-danger, ${$PdmhA.P500})`,
    greyLight: `var(--ds-text-danger, ${$PdmhA.N500})`
};

});

parcelRegister("d9W8K", function(module, exports) {

$parcel$export(module.exports, "default", () => $98c5a9f7a5ded4f8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $jFsza = parcelRequire("jFsza");

var $i6wnX = parcelRequire("i6wnX");
const $98c5a9f7a5ded4f8$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-flex',
    minWidth: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $jFsza.tagHeight),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: (0, $jFsza.defaultMargin),
    padding: "var(--ds-space-0, 0px)",
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: `var(${(0, $jFsza.cssVar).color.background.default})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `var(${(0, $jFsza.cssVar).borderRadius})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: `var(${(0, $jFsza.cssVar).color.text.default})`,
    cursor: 'default'
});
const $98c5a9f7a5ded4f8$var$interactiveStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: `var(${(0, $jFsza.cssVar).color.background.hover})`
    },
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: `var(${(0, $jFsza.cssVar).color.background.active})`
    }
});
const $98c5a9f7a5ded4f8$var$focusRingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:focus-within': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        boxShadow: `0 0 0 2px var(${(0, $jFsza.cssVar).color.focusRing})`,
        outline: 'none'
    }
});
const $98c5a9f7a5ded4f8$var$nonStandardLinkStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $jFsza.cssVar).color.text.active})`
    }
});
const $98c5a9f7a5ded4f8$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(function BaseTag({ before: before, contentElement: contentElement, after: after, testId: testId, appearance: appearance = 'default', style: style, color: color = 'standard', href: href, className: className, ...other }, ref) {
    const isLink = Boolean(href);
    const isRemovable = Boolean(after);
    const isInteractive = isLink || isRemovable;
    const isStandardLink = isLink && color === 'standard';
    // Change link text color if  the tag is standard color
    const textLinkColors = isStandardLink ? $i6wnX.textColors['standardLink'] : $i6wnX.textColors[color];
    const backgroundHoverColors = isRemovable && !isLink ? $i6wnX.backgroundColors[color] : $i6wnX.linkHoverBackgroundColors[color];
    const backgroundActiveColors = isRemovable && !isLink ? $i6wnX.backgroundColors[color] : $i6wnX.linkActiveBackgroundColors[color];
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        ...other,
        ref: ref,
        css: [
            $98c5a9f7a5ded4f8$var$baseStyles,
            (isRemovable || isLink) && $98c5a9f7a5ded4f8$var$focusRingStyles,
            isLink && !isStandardLink && $98c5a9f7a5ded4f8$var$nonStandardLinkStyles,
            isInteractive && $98c5a9f7a5ded4f8$var$interactiveStyles
        ],
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.text.default]: $i6wnX.textColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.text.hover]: $i6wnX.textHoverColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.text.active]: $i6wnX.textActiveColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.text.link]: textLinkColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.background.default]: $i6wnX.backgroundColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.background.hover]: backgroundHoverColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.background.active]: backgroundActiveColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.focusRing]: $i6wnX.focusRingColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.removeButton.default]: $i6wnX.removeButtonColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).color.removeButton.hover]: $i6wnX.removeButtonHoverColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $jFsza.cssVar).borderRadius]: $i6wnX.borderRadius[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-testid": testId
    }, before, contentElement, after);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$98c5a9f7a5ded4f8$export$2e2bcd8739ae039 = $98c5a9f7a5ded4f8$var$BaseTag;

});

parcelRegister("6aZHE", function(module, exports) {

$parcel$export(module.exports, "default", () => $70eddb948b5989f5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $jFsza = parcelRequire("jFsza");
const $70eddb948b5989f5$var$beforeElementStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `var(${(0, $jFsza.cssVar).borderRadius})`,
    insetBlockStart: "var(--ds-space-0, 0px)"
});
const $70eddb948b5989f5$var$Before = ({ elemBefore: elemBefore })=>elemBefore ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $70eddb948b5989f5$var$beforeElementStyles
    }, elemBefore) : null;
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$70eddb948b5989f5$export$2e2bcd8739ae039 = $70eddb948b5989f5$var$Before;

});

parcelRegister("gz2Bi", function(module, exports) {

$parcel$export(module.exports, "default", () => $154b7edc63fec879$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $jFsza = parcelRequire("jFsza");
const $154b7edc63fec879$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: (0, $jFsza.maxTextWidth),
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    overflow: 'hidden',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineEnd: (0, $jFsza.defaultTextPadding),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineStart: (0, $jFsza.defaultTextPadding),
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $154b7edc63fec879$var$linkStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: `var(${(0, $jFsza.cssVar).color.text.link})`,
    pointerEvents: 'auto',
    textDecoration: 'none',
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $jFsza.cssVar).color.text.hover})`,
        textDecoration: 'underline'
    },
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $jFsza.cssVar).color.text.active})`,
        textDecoration: 'underline'
    },
    '&:focus': {
        outline: 'none'
    }
});
const $154b7edc63fec879$var$hasAfterStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $jFsza.maxTextWidthUnitless) - (0, $jFsza.buttonWidthUnitless)}px`,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineEnd: (0, $jFsza.textPaddingRight)
});
const $154b7edc63fec879$var$hasBeforeStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineStart: (0, $jFsza.textMarginLeft)
});
const $154b7edc63fec879$var$Content = ({ elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, linkComponent: linkComponent })=>{
    const Link = linkComponent ?? 'a';
    if (href) return /*#__PURE__*/ (0, $byn9U.jsx)(Link, {
        href: href,
        "data-color": color,
        css: [
            $154b7edc63fec879$var$baseStyles,
            $154b7edc63fec879$var$linkStyles,
            elemBefore && $154b7edc63fec879$var$hasBeforeStyles,
            isRemovable && $154b7edc63fec879$var$hasAfterStyles
        ]
    }, text);
    else return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            $154b7edc63fec879$var$baseStyles,
            elemBefore && $154b7edc63fec879$var$hasBeforeStyles,
            isRemovable && $154b7edc63fec879$var$hasAfterStyles
        ]
    }, text);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$154b7edc63fec879$export$2e2bcd8739ae039 = $154b7edc63fec879$var$Content;

});

parcelRegister("keeN7", function(module, exports) {

$parcel$export(module.exports, "default", () => $4292d770fb9954c5$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $je5kZ = parcelRequire("je5kZ");

var $4ZL0y = parcelRequire("4ZL0y");
var $1ZAYh = parcelRequire("1ZAYh");

var $jFsza = parcelRequire("jFsza");
const $4292d770fb9954c5$var$removeButtonStyles = (0, $1ZAYh.xcss)({
    display: 'flex',
    height: '16px',
    margin: 'space.0',
    padding: 'space.0',
    position: 'absolute',
    insetInlineEnd: 'space.0',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    appearance: 'none',
    backgroundColor: 'color.background.neutral.subtle',
    border: 'none',
    // Once legacy theming is dropped, this can be changed to 'border.radius'
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `var(${(0, $jFsza.cssVar).borderRadius})`,
    // Once legacy theming is dropped, this can be changed to 'inherit'
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: `var(${(0, $jFsza.cssVar).color.removeButton.default})`,
    cursor: 'pointer',
    pointerEvents: 'auto',
    ':focus-visible': {
        outlineOffset: 'space.0'
    },
    ':hover': {
        // Once legacy theming is dropped, this can be changed to 'cssVar.color.text.default'
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $jFsza.cssVar).color.removeButton.hover})`
    }
});
const $4292d770fb9954c5$var$RemoveButton = ({ 'aria-label': ariaLabel, onClick: onClick, onFocus: onFocus, onBlur: onBlur, onKeyPress: onKeyPress, onMouseOver: onMouseOver, onMouseOut: onMouseOut, testId: testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4ZL0y.default), {
        xcss: $4292d770fb9954c5$var$removeButtonStyles,
        "aria-label": ariaLabel,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyPress: onKeyPress,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($je5kZ))), {
        label: "close tag",
        size: "small"
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4292d770fb9954c5$export$2e2bcd8739ae039 = $4292d770fb9954c5$var$RemoveButton;

});


parcelRegister("9jNAz", function(module, exports) {

$parcel$export(module.exports, "default", () => $02a667cb3800fd5a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $d9W8K = parcelRequire("d9W8K");

var $6aZHE = parcelRequire("6aZHE");

var $gz2Bi = parcelRequire("gz2Bi");
const $02a667cb3800fd5a$var$SimpleTag = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, color: color = 'standard', href: href, testId: testId, text: text = '', linkComponent: linkComponent }, ref)=>{
    const content = /*#__PURE__*/ (0, $byn9U.jsx)((0, $gz2Bi.default), {
        elemBefore: elemBefore,
        isRemovable: false,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $d9W8K.default), {
        ref: ref,
        testId: testId,
        href: href,
        appearance: appearance,
        color: color,
        before: /*#__PURE__*/ (0, $byn9U.jsx)((0, $6aZHE.default), {
            elemBefore: elemBefore
        }),
        contentElement: content
    });
});
var $02a667cb3800fd5a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eUqFw.memo)($02a667cb3800fd5a$var$SimpleTag);

});

parcelRegister("8yr5x", function(module, exports) {

$parcel$export(module.exports, "default", () => $63a682dd98ff1103$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $63a682dd98ff1103$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    removeLabel: {
        id: 'fabric.editor.ai.screens.promptWithSelectedOption.removeLabel',
        defaultMessage: 'Remove',
        description: "Label text for the \u2018Remove\u2019 button within the tag UI, that is used to unset the selected option in the Prompt screen"
    },
    promptSelected: {
        id: 'fabric.editor.ai.screens.promptWithSelectedOption.promptSelected',
        defaultMessage: '{promptName} - Selected',
        description: 'This message is read to users when a preset ai prompt is selected, the prompt name is dynamic an example is "Brainstorm"'
    }
});

});

parcelRegister("4nIEF", function(module, exports) {

$parcel$export(module.exports, "cssVars", () => $330bf2f7b85d8736$export$fd62969fb0b7081c);
$parcel$export(module.exports, "refinementTagStyles", () => $330bf2f7b85d8736$export$5ba6aa6d27efca96);

var $byn9U = parcelRequire("byn9U");
const $330bf2f7b85d8736$export$fd62969fb0b7081c = {
    alignItems: '--align-items',
    elemBeforeHeight: '--elem-before-height'
};
const $330bf2f7b85d8736$export$5ba6aa6d27efca96 = (0, $byn9U.css)({
    '> span': {
        margin: `${"var(--ds-space-025, 2px)"} ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-025, 2px)"} 0px`,
        alignItems: `var(${$330bf2f7b85d8736$export$fd62969fb0b7081c.alignItems})`,
        '> span': {
            maxWidth: 'var(--content-width)',
            '&:has([data-testid="command-palette-rovo-agent-icon"])': {
                height: `var(${$330bf2f7b85d8736$export$fd62969fb0b7081c.elemBeforeHeight})`
            }
        }
    }
});

});


parcelRegister("1dKbP", function(module, exports) {

$parcel$export(module.exports, "headerStyles", () => $0e3ad5abf798db40$export$4132d24633fd95f2);
$parcel$export(module.exports, "headerEditStyles", () => $0e3ad5abf798db40$export$c97356e155296067);
$parcel$export(module.exports, "headerWrapperStyles", () => $0e3ad5abf798db40$export$2a081c1596bd1773);
$parcel$export(module.exports, "headerEditRendererStyles", () => $0e3ad5abf798db40$export$c546ac45b8f4d977);

var $byn9U = parcelRequire("byn9U");
const $0e3ad5abf798db40$export$4132d24633fd95f2 = (0, $byn9U.css)({
    padding: "var(--ds-space-150, 12px)",
    overflowWrap: 'break-word'
});
const $0e3ad5abf798db40$export$c97356e155296067 = (0, $byn9U.css)({
    cursor: 'pointer',
    border: 'none',
    width: '100%',
    backgroundColor: 'transparent',
    color: 'inherit',
    textAlign: 'start',
    fontSize: 'unset',
    lineHeight: 'inherit',
    borderRadius: "var(--ds-border-radius-200, 4px)",
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    '&:hover': {
        backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
        textDecoration: 'underline'
    },
    '&:active': {
        backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
    },
    '&:focus': {
        outline: `2px solid ${"var(--ds-border-focused, #4C9AFF)"}`,
        outlineOffset: "var(--ds-space-negative-025, -2px)"
    }
});
const $0e3ad5abf798db40$export$2a081c1596bd1773 = (0, $byn9U.css)({
    display: 'flex'
});
const $0e3ad5abf798db40$export$c546ac45b8f4d977 = (0, $byn9U.css)({
    '&:hover': {
        textDecoration: 'none'
    }
});

});

parcelRegister("kOSo2", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f282aa36da3cc64f$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $f282aa36da3cc64f$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    editPrompt: {
        id: 'fabric.editor.ai.screens.preview.header.edit',
        defaultMessage: 'Edit prompt',
        description: 'Label for the edit prompt button in the preview screen'
    }
});

});


parcelRegister("cp9TA", function(module, exports) {

$parcel$export(module.exports, "CancelEscButton", () => $907f7edd4a1d6624$export$d17714f4f279b358);
/* @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dBH6i = parcelRequire("dBH6i");

var $2eXNg = parcelRequire("2eXNg");

var $gPQ6i = parcelRequire("gPQ6i");

var $jjK5n = parcelRequire("jjK5n");
const $907f7edd4a1d6624$export$d17714f4f279b358 = ({ onCancel: onCancel, autoFocus: autoFocus })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return (0, $byn9U.jsx)((0, $dBH6i.default), {
        css: (0, $jjK5n.buttonAutoFocusRingFix),
        autoFocus: autoFocus,
        testId: "cancel-esc-button",
        type: "button",
        onClick: onCancel
    }, formatMessage((0, $2eXNg.default).labelCancel), (0, $byn9U.jsx)("span", {
        css: (0, $gPQ6i.escTextStyles)
    }, formatMessage((0, $2eXNg.default).labelEsc)));
};

});
parcelRegister("2eXNg", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a1b45543cf55630$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1a1b45543cf55630$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    labelCancel: {
        id: 'fabric.editor.ai.components.cancelEscButton.cancelLabel',
        defaultMessage: 'Cancel',
        description: 'CancelEsc\'s "Cancel" button label'
    },
    labelEsc: {
        id: 'fabric.editor.ai.components.cancelEscButton.escLabel',
        defaultMessage: 'Esc',
        description: 'CancelEsc\'s "Esc" button label'
    }
});

});

parcelRegister("gPQ6i", function(module, exports) {

$parcel$export(module.exports, "escTextStyles", () => $c419d2d5e0f120f4$export$d18a373525facb91);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");
const $c419d2d5e0f120f4$export$d18a373525facb91 = (0, $byn9U.css)({
    borderRadius: "var(--ds-border-radius-100, 3px)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    padding: '3px',
    color: "var(--ds-text-subtle, #44546F)",
    background: "var(--ds-background-neutral, #091E420F)",
    fontWeight: "var(--ds-font-weight-regular, 400)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    marginLeft: '5px'
});

});


parcelRegister("bU7Hk", function(module, exports) {

$parcel$export(module.exports, "default", () => $8aaae54b33e97b10$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $eUqFw = parcelRequire("eUqFw");

var $epPZ1 = parcelRequire("epPZ1");
const $8aaae54b33e97b10$var$Loading = (props)=>{
    const aiThemeColor = (0, $epPZ1.useAIThemeColor)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("title", null, props.alt), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        cx: "5.5",
        cy: "12.5",
        r: "1.5",
        fill: aiThemeColor('loading.step.1')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        cx: "11.5",
        cy: "10.5",
        r: "1.5",
        fill: aiThemeColor('loading.step.2')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.2s"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("circle", {
        cx: "17.5",
        cy: "12.5",
        r: "1.5",
        fill: aiThemeColor('loading.step.3')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("animate", {
        attributeName: "cy",
        values: "11;13;13;13;13;13;13;11",
        dur: "1s",
        repeatCount: "indefinite",
        begin: "0.4s"
    })));
};
var $8aaae54b33e97b10$export$2e2bcd8739ae039 = $8aaae54b33e97b10$var$Loading;

});


parcelRegister("ln5HZ", function(module, exports) {

$parcel$export(module.exports, "getPMFragmentWithFallback", () => $f8f02c8add2fc830$export$a08e8b3dacf7ffcc);

var $7dkLM = parcelRequire("7dkLM");

var $iVHJE = parcelRequire("iVHJE");

var $8pKer = parcelRequire("8pKer");

var $XHGTv = parcelRequire("XHGTv");
function $f8f02c8add2fc830$export$a08e8b3dacf7ffcc({ markdown: markdown, schema: schema, source: source, fireAIAnalyticsEvent: fireAIAnalyticsEvent, idMap: idMap }) {
    try {
        const { pmFragment: pmFragment, htmlConvertedToFallbackNodes: htmlConvertedToFallbackNodes, htmlConvertedToNodes: htmlConvertedToNodes } = (0, $iVHJE.convertMarkdownToProsemirror)({
            schema: schema,
            markdown: markdown,
            idMap: idMap,
            featureToggles: {
                // This ternary is needed because feature flags can only be called as part of
                // an expression or we get a lint error & ignoring the error prevents the
                // cleanup script from finding the flag.
                markdownPlus: (0, $XHGTv.getBooleanFF)('platform.editor.ai-markdown-plus_9v1w7') ? true : false,
                markdownPlusMarks: (0, $XHGTv.getBooleanFF)('platform.editor.ai-markdown-plus-marks_eitjo') ? true : false,
                markdownPlusV2: (0, $XHGTv.getBooleanFF)('platform.editor.ai-markdown-plus-v2_j5m0c') ? true : false,
                markdownPlusMedia: (0, $XHGTv.getBooleanFF)('platform.editor.ai-markdown-plus-media_svrli') ? true : false,
                markdownPlusExtensions: (0, $XHGTv.getBooleanFF)('platform.editor.ai-markdown-plus-extension_m8eb1') ? true : false,
                markdownPlusExpands: (0, $XHGTv.getBooleanFF)('platform.editor.ai-markdown-plus-expands_5h7qa') ? true : false,
                markdownPlusNestedExpands: (0, $XHGTv.getBooleanFF)('platform.editor.ai-markdown-plus-nested-expands_ru5xx') ? true : false,
                markdownPlusPanels: (0, $XHGTv.getBooleanFF)('platform.editor.ai-markdown-plus-panels_veh92') ? true : false,
                markdownPlusDecisions: (0, $XHGTv.getBooleanFF)('platform.editor.ai-markdown-plus-decisions_4lriq') ? true : false,
                markdownPlusTables: (0, $XHGTv.getBooleanFF)('platform.editor.ai-markdown-plus-tables_ipb1h') ? true : false,
                markdownPlusLayouts: (0, $XHGTv.getBooleanFF)('platform.editor.ai-markdown-plus-layouts_jw2zj') ? true : false
            }
        });
        return {
            pmFragment: pmFragment,
            htmlConvertedToFallbackNodes: htmlConvertedToFallbackNodes,
            htmlConvertedToNodes: htmlConvertedToNodes,
            isTextFallbackUsed: false
        };
    } catch (error) {
        // When convertMarkdownToProsemirror a fragment
        // we log an analytics event to call out that markdown conversion has failed
        fireAIAnalyticsEvent({
            payload: {
                action: 'failed',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'markdownParser',
                attributes: {
                    source: source,
                    errorMessage: (0, $8pKer.ErrorUtils).extractErrorMessage(error)
                },
                eventType: 'operational'
            }
        });
        // Instead of erroring, we fallback to rendering as plaintext in a single paragraph.
        const fallbackPMFragment = (0, $7dkLM.Fragment).from(schema.nodes.paragraph.create(null, schema.text(markdown)));
        return {
            pmFragment: fallbackPMFragment,
            htmlConvertedToFallbackNodes: 0,
            htmlConvertedToNodes: 0,
            isTextFallbackUsed: true
        };
    }
}

});
parcelRegister("iVHJE", function(module, exports) {

$parcel$export(module.exports, "convertMarkdownToProsemirror", () => $dc7f79c828200581$export$b2bf04f78f72b123);

var $k8wSn = parcelRequire("k8wSn");

var $hhJg2 = parcelRequire("hhJg2");

var $1RkS8 = parcelRequire("1RkS8");

var $dzYNe = parcelRequire("dzYNe");

var $7dkLM = parcelRequire("7dkLM");

var $6jrty = parcelRequire("6jrty");

var $9GnoM = parcelRequire("9GnoM");

var $696i6 = parcelRequire("696i6");

var $9dukA = parcelRequire("9dukA");

var $dTcF8 = parcelRequire("dTcF8");

var $6gudU = parcelRequire("6gudU");

var $aGE35 = parcelRequire("aGE35");

var $e0eRy = parcelRequire("e0eRy");

var $kgeKs = parcelRequire("kgeKs");

var $4BHv5 = parcelRequire("4BHv5");

var $7rHFe = parcelRequire("7rHFe");
function $dc7f79c828200581$export$b2bf04f78f72b123({ markdown: markdown, schema: schema, idMap: idMap, featureToggles: featureToggles = {} }) {
    const { markdownPlus: markdownPlus, markdownPlusV2: markdownPlusV2 } = featureToggles;
    const tokenizer = new (0, (/*@__PURE__*/$parcel$interopDefault($k8wSn)))('zero', {
        html: false
    });
    tokenizer.enable([
        // Process html entity - &#123;, &#xAF;, &quot;, ...
        'entity',
        // Process escaped chars and hardbreaks
        'escape',
        'newline'
    ]);
    [
        'nodes',
        'marks'
    ].forEach((key)=>{
        for(const idx in (0, $6jrty.PM_SCHEMA_TO_MD_MAPPING)[key])if (schema[key][idx]) tokenizer.enable((0, $6jrty.PM_SCHEMA_TO_MD_MAPPING)[key][idx]);
    });
    const htmlConversionCounts = {
        htmlConvertedToNodes: 0,
        htmlConvertedToFallbackNodes: 0
    };
    if (markdownPlus) {
        if (markdownPlusV2) {
            tokenizer.use((0, $696i6.default), idMap, htmlConversionCounts);
            tokenizer.use((0, $dTcF8.default), idMap);
        }
        tokenizer.use((0, $9dukA.default), idMap, featureToggles, htmlConversionCounts);
    }
    tokenizer.use((0, $kgeKs.default));
    // enable modified version of linkify plugin
    // @see https://product-fabric.atlassian.net/browse/ED-3097
    tokenizer.use((0, $6gudU.default));
    tokenizer.use((0, $e0eRy.default));
    // Custom Table tokenizer
    if (schema.nodes.table) tokenizer.use((0, $hhJg2.markdownItTable));
    // Custom Media tokenizer
    if (schema.nodes.media && schema.nodes.mediaSingle) {
        tokenizer.use((0, $aGE35.markdownItMedia));
        if (markdownPlus && markdownPlusV2 && featureToggles.markdownPlusMedia && schema.nodes.caption) tokenizer.use((0, $9GnoM.default));
    }
    // Custom TaskList tokenizer
    if (schema.nodes.taskList) tokenizer.use((0, $4BHv5.default));
    const markdownParser = new (0, $dzYNe.MarkdownParser)(schema, tokenizer, (0, $6jrty.filterMdToPmSchemaMapping)(schema, (0, $6jrty.getMdToPmMapping)(!!markdownPlus)));
    if (markdown === '') return {
        htmlConvertedToNodes: 0,
        htmlConvertedToFallbackNodes: 0,
        pmFragment: (0, $7dkLM.Fragment).empty
    };
    // normalize duplicated backticks (needed as a safeguard to avoid rendering malformed escape characters coming from backed)
    // the case with newline characters
    markdown = markdown.replace(/\\n/g, '\n');
    // the case with custom field attributes (limit only to data- attributes inside custom fields)
    if (markdownPlus) markdown = markdown.replace(/<custom[^>]*?>/g, function(match) {
        return match.replace(/(data-\w+=)\\\"(.*?)\\\"/g, '$1"$2"');
    });
    let prosemirrorNode = markdownPlus ? markdownParser.parse(markdown) : markdownParser.parse((0, $7rHFe.escapeLinks)(markdown));
    // @ts-ignore
    if (!prosemirrorNode.content) throw new Error('Markdown conversion did not result in a valid document being created');
    // This logic is duplicated from editor-cores paste transformation.
    // The editor-plugin-ai package is avoiding sharing dependencies with editor-core to support
    // products using it with various versions of editor packages.
    // The duplication is from the following file:
    // packages/editor/editor-core/src/plugins/media/utils/media-single.ts
    // WARNING
    // If the `mapFragment` usage changes -- it means we have a breaking change for products
    // where currently it's expected they are using older versions of editor-common
    // @ts-ignore
    const mappedContent = (0, $1RkS8.mapFragment)(prosemirrorNode.content, (node)=>{
        if (node.type.name === 'media') return schema.nodes.media.createChecked({
            ...node.attrs,
            // Adding this attribute results in the media node being rendered
            // initially using the external url, but then triggering an upload
            // of the external url as an atlassian artifact, and this media
            // will then be replaced to use the atlassian artifact.
            //
            // This is done in the media nodeview by checking the attributes
            // when rendering.
            __external: node.attrs.type === 'external',
            __mediaTraceId: null
        }, node.content, node.marks);
        return node;
    });
    return {
        ...htmlConversionCounts,
        pmFragment: mappedContent
    };
}
function $dc7f79c828200581$export$e661a057c2263d64({ markdown: markdown, schema: schema, idMap: idMap, featureToggles: featureToggles = {} }) {
    const fragment = $dc7f79c828200581$export$b2bf04f78f72b123({
        markdown: markdown,
        schema: schema,
        idMap: idMap,
        featureToggles: {
            markdownPlus: true,
            ...featureToggles
        }
    });
    try {
        const node = schema.nodes.doc.createChecked({}, fragment.pmFragment);
        return node;
    } catch  {
        throw new Error('Markdown conversion did not result in a valid ProseMirror node');
    }
}

});
parcelRegister("k8wSn", function(module, exports) {
'use strict';

module.exports = (parcelRequire("cobq5"));

});
parcelRegister("cobq5", function(module, exports) {
// Main parser class
'use strict';

var $1hHFA = parcelRequire("1hHFA");

var $9v59Z = parcelRequire("9v59Z");

var $69SbI = parcelRequire("69SbI");

var $6TpVm = parcelRequire("6TpVm");

var $y5nz9 = parcelRequire("y5nz9");

var $kYTqE = parcelRequire("kYTqE");

var $6nCWf = parcelRequire("6nCWf");

var $lBnMO = parcelRequire("lBnMO");

var $1s3qa = parcelRequire("1s3qa");



var $905095a5fbec7ff0$var$config = {
    default: (parcelRequire("a3CyB")),
    zero: (parcelRequire("lwtXx")),
    commonmark: (parcelRequire("83lxA"))
};
////////////////////////////////////////////////////////////////////////////////
//
// This validator can prohibit more than really needed to prevent XSS. It's a
// tradeoff to keep code simple and to be secure by default.
//
// If you need different setup - override validator method as you wish. Or
// replace it with dummy function and use external sanitizer.
//
var $905095a5fbec7ff0$var$BAD_PROTO_RE = /^(vbscript|javascript|file|data):/;
var $905095a5fbec7ff0$var$GOOD_DATA_RE = /^data:image\/(gif|png|jpeg|webp);/;
function $905095a5fbec7ff0$var$validateLink(url) {
    // url should be normalized at this point, and existing entities are decoded
    var str = url.trim().toLowerCase();
    return $905095a5fbec7ff0$var$BAD_PROTO_RE.test(str) ? $905095a5fbec7ff0$var$GOOD_DATA_RE.test(str) ? true : false : true;
}
////////////////////////////////////////////////////////////////////////////////
var $905095a5fbec7ff0$var$RECODE_HOSTNAME_FOR = [
    'http:',
    'https:',
    'mailto:'
];
function $905095a5fbec7ff0$var$normalizeLink(url) {
    var parsed = $lBnMO.parse(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $905095a5fbec7ff0$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = $1s3qa.toASCII(parsed.hostname);
        } catch (er) {}
    }
    return $lBnMO.encode($lBnMO.format(parsed));
}
function $905095a5fbec7ff0$var$normalizeLinkText(url) {
    var parsed = $lBnMO.parse(url, true);
    if (parsed.hostname) {
        // Encode hostnames in urls like:
        // `http://host/`, `https://host/`, `mailto:user@host`, `//host/`
        //
        // We don't encode unknown schemas, because it's likely that we encode
        // something we shouldn't (e.g. `skype:name` treated as `skype:host`)
        //
        if (!parsed.protocol || $905095a5fbec7ff0$var$RECODE_HOSTNAME_FOR.indexOf(parsed.protocol) >= 0) try {
            parsed.hostname = $1s3qa.toUnicode(parsed.hostname);
        } catch (er) {}
    }
    // add '%' to exclude list because of https://github.com/markdown-it/markdown-it/issues/720
    return $lBnMO.decode($lBnMO.format(parsed), $lBnMO.decode.defaultChars + '%');
}
/**
 * class MarkdownIt
 *
 * Main parser/renderer class.
 *
 * ##### Usage
 *
 * ```javascript
 * // node.js, "classic" way:
 * var MarkdownIt = require('markdown-it'),
 *     md = new MarkdownIt();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // node.js, the same, but with sugar:
 * var md = require('markdown-it')();
 * var result = md.render('# markdown-it rulezz!');
 *
 * // browser without AMD, added to "window" on script load
 * // Note, there are no dash.
 * var md = window.markdownit();
 * var result = md.render('# markdown-it rulezz!');
 * ```
 *
 * Single line rendering, without paragraph wrap:
 *
 * ```javascript
 * var md = require('markdown-it')();
 * var result = md.renderInline('__markdown-it__ rulezz!');
 * ```
 **/ /**
 * new MarkdownIt([presetName, options])
 * - presetName (String): optional, `commonmark` / `zero`
 * - options (Object)
 *
 * Creates parser instanse with given config. Can be called without `new`.
 *
 * ##### presetName
 *
 * MarkdownIt provides named presets as a convenience to quickly
 * enable/disable active syntax rules and options for common use cases.
 *
 * - ["commonmark"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/commonmark.js) -
 *   configures parser to strict [CommonMark](http://commonmark.org/) mode.
 * - [default](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/default.js) -
 *   similar to GFM, used when no preset name given. Enables all available rules,
 *   but still without html, typographer & autolinker.
 * - ["zero"](https://github.com/markdown-it/markdown-it/blob/master/lib/presets/zero.js) -
 *   all rules disabled. Useful to quickly setup your config via `.enable()`.
 *   For example, when you need only `bold` and `italic` markup and nothing else.
 *
 * ##### options:
 *
 * - __html__ - `false`. Set `true` to enable HTML tags in source. Be careful!
 *   That's not safe! You may need external sanitizer to protect output from XSS.
 *   It's better to extend features via plugins, instead of enabling HTML.
 * - __xhtmlOut__ - `false`. Set `true` to add '/' when closing single tags
 *   (`<br />`). This is needed only for full CommonMark compatibility. In real
 *   world you will need HTML output.
 * - __breaks__ - `false`. Set `true` to convert `\n` in paragraphs into `<br>`.
 * - __langPrefix__ - `language-`. CSS language class prefix for fenced blocks.
 *   Can be useful for external highlighters.
 * - __linkify__ - `false`. Set `true` to autoconvert URL-like text to links.
 * - __typographer__  - `false`. Set `true` to enable [some language-neutral
 *   replacement](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/replacements.js) +
 *   quotes beautification (smartquotes).
 * - __quotes__ - `“”‘’`, String or Array. Double + single quotes replacement
 *   pairs, when typographer enabled and smartquotes on. For example, you can
 *   use `'«»„“'` for Russian, `'„“‚‘'` for German, and
 *   `['«\xA0', '\xA0»', '‹\xA0', '\xA0›']` for French (including nbsp).
 * - __highlight__ - `null`. Highlighter function for fenced code blocks.
 *   Highlighter `function (str, lang)` should return escaped HTML. It can also
 *   return empty string if the source was not changed and should be escaped
 *   externaly. If result starts with <pre... internal wrapper is skipped.
 *
 * ##### Example
 *
 * ```javascript
 * // commonmark mode
 * var md = require('markdown-it')('commonmark');
 *
 * // default mode
 * var md = require('markdown-it')();
 *
 * // enable everything
 * var md = require('markdown-it')({
 *   html: true,
 *   linkify: true,
 *   typographer: true
 * });
 * ```
 *
 * ##### Syntax highlighting
 *
 * ```js
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return hljs.highlight(str, { language: lang, ignoreIllegals: true }).value;
 *       } catch (__) {}
 *     }
 *
 *     return ''; // use external default escaping
 *   }
 * });
 * ```
 *
 * Or with full wrapper override (if you need assign class to `<pre>`):
 *
 * ```javascript
 * var hljs = require('highlight.js') // https://highlightjs.org/
 *
 * // Actual default values
 * var md = require('markdown-it')({
 *   highlight: function (str, lang) {
 *     if (lang && hljs.getLanguage(lang)) {
 *       try {
 *         return '<pre class="hljs"><code>' +
 *                hljs.highlight(str, { language: lang, ignoreIllegals: true }).value +
 *                '</code></pre>';
 *       } catch (__) {}
 *     }
 *
 *     return '<pre class="hljs"><code>' + md.utils.escapeHtml(str) + '</code></pre>';
 *   }
 * });
 * ```
 *
 **/ function $905095a5fbec7ff0$var$MarkdownIt(presetName, options) {
    if (!(this instanceof $905095a5fbec7ff0$var$MarkdownIt)) return new $905095a5fbec7ff0$var$MarkdownIt(presetName, options);
    if (!options) {
        if (!$1hHFA.isString(presetName)) {
            options = presetName || {};
            presetName = 'default';
        }
    }
    /**
   * MarkdownIt#inline -> ParserInline
   *
   * Instance of [[ParserInline]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.inline = new $kYTqE();
    /**
   * MarkdownIt#block -> ParserBlock
   *
   * Instance of [[ParserBlock]]. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.block = new $y5nz9();
    /**
   * MarkdownIt#core -> Core
   *
   * Instance of [[Core]] chain executor. You may need it to add new rules when
   * writing plugins. For simple rules control use [[MarkdownIt.disable]] and
   * [[MarkdownIt.enable]].
   **/ this.core = new $6TpVm();
    /**
   * MarkdownIt#renderer -> Renderer
   *
   * Instance of [[Renderer]]. Use it to modify output look. Or to add rendering
   * rules for new token types, generated by plugins.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * function myToken(tokens, idx, options, env, self) {
   *   //...
   *   return result;
   * };
   *
   * md.renderer.rules['my_token'] = myToken
   * ```
   *
   * See [[Renderer]] docs and [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js).
   **/ this.renderer = new $69SbI();
    /**
   * MarkdownIt#linkify -> LinkifyIt
   *
   * [linkify-it](https://github.com/markdown-it/linkify-it) instance.
   * Used by [linkify](https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js)
   * rule.
   **/ this.linkify = new $6nCWf();
    /**
   * MarkdownIt#validateLink(url) -> Boolean
   *
   * Link validation function. CommonMark allows too much in links. By default
   * we disable `javascript:`, `vbscript:`, `file:` schemas, and almost all `data:...` schemas
   * except some embedded image types.
   *
   * You can change this behaviour:
   *
   * ```javascript
   * var md = require('markdown-it')();
   * // enable everything
   * md.validateLink = function () { return true; }
   * ```
   **/ this.validateLink = $905095a5fbec7ff0$var$validateLink;
    /**
   * MarkdownIt#normalizeLink(url) -> String
   *
   * Function used to encode link url to a machine-readable format,
   * which includes url-encoding, punycode, etc.
   **/ this.normalizeLink = $905095a5fbec7ff0$var$normalizeLink;
    /**
   * MarkdownIt#normalizeLinkText(url) -> String
   *
   * Function used to decode link url to a human-readable format`
   **/ this.normalizeLinkText = $905095a5fbec7ff0$var$normalizeLinkText;
    // Expose utils & helpers for easy acces from plugins
    /**
   * MarkdownIt#utils -> utils
   *
   * Assorted utility functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/common/utils.js).
   **/ this.utils = $1hHFA;
    /**
   * MarkdownIt#helpers -> helpers
   *
   * Link components parser functions, useful to write plugins. See details
   * [here](https://github.com/markdown-it/markdown-it/blob/master/lib/helpers).
   **/ this.helpers = $1hHFA.assign({}, $9v59Z);
    this.options = {};
    this.configure(presetName);
    if (options) this.set(options);
}
/** chainable
 * MarkdownIt.set(options)
 *
 * Set parser options (in the same format as in constructor). Probably, you
 * will never need it, but you can change options after constructor call.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .set({ html: true, breaks: true })
 *             .set({ typographer, true });
 * ```
 *
 * __Note:__ To achieve the best possible performance, don't modify a
 * `markdown-it` instance options on the fly. If you need multiple configurations
 * it's best to create multiple instances and initialize each with separate
 * config.
 **/ $905095a5fbec7ff0$var$MarkdownIt.prototype.set = function(options) {
    $1hHFA.assign(this.options, options);
    return this;
};
/** chainable, internal
 * MarkdownIt.configure(presets)
 *
 * Batch load of all options and compenent settings. This is internal method,
 * and you probably will not need it. But if you will - see available presets
 * and data structure [here](https://github.com/markdown-it/markdown-it/tree/master/lib/presets)
 *
 * We strongly recommend to use presets instead of direct config loads. That
 * will give better compatibility with next versions.
 **/ $905095a5fbec7ff0$var$MarkdownIt.prototype.configure = function(presets) {
    var self = this, presetName;
    if ($1hHFA.isString(presets)) {
        presetName = presets;
        presets = $905095a5fbec7ff0$var$config[presetName];
        if (!presets) throw new Error('Wrong `markdown-it` preset "' + presetName + '", check name');
    }
    if (!presets) throw new Error('Wrong `markdown-it` preset, can\'t be empty');
    if (presets.options) self.set(presets.options);
    if (presets.components) Object.keys(presets.components).forEach(function(name) {
        if (presets.components[name].rules) self[name].ruler.enableOnly(presets.components[name].rules);
        if (presets.components[name].rules2) self[name].ruler2.enableOnly(presets.components[name].rules2);
    });
    return this;
};
/** chainable
 * MarkdownIt.enable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to enable
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable list or rules. It will automatically find appropriate components,
 * containing rules with given names. If rule not found, and `ignoreInvalid`
 * not set - throws exception.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')()
 *             .enable(['sub', 'sup'])
 *             .disable('smartquotes');
 * ```
 **/ $905095a5fbec7ff0$var$MarkdownIt.prototype.enable = function(list, ignoreInvalid) {
    var result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        'core',
        'block',
        'inline'
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.enable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.enable(list, true));
    var missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error('MarkdownIt. Failed to enable unknown rule(s): ' + missed);
    return this;
};
/** chainable
 * MarkdownIt.disable(list, ignoreInvalid)
 * - list (String|Array): rule name or list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * The same as [[MarkdownIt.enable]], but turn specified rules off.
 **/ $905095a5fbec7ff0$var$MarkdownIt.prototype.disable = function(list, ignoreInvalid) {
    var result = [];
    if (!Array.isArray(list)) list = [
        list
    ];
    [
        'core',
        'block',
        'inline'
    ].forEach(function(chain) {
        result = result.concat(this[chain].ruler.disable(list, true));
    }, this);
    result = result.concat(this.inline.ruler2.disable(list, true));
    var missed = list.filter(function(name) {
        return result.indexOf(name) < 0;
    });
    if (missed.length && !ignoreInvalid) throw new Error('MarkdownIt. Failed to disable unknown rule(s): ' + missed);
    return this;
};
/** chainable
 * MarkdownIt.use(plugin, params)
 *
 * Load specified plugin with given params into current parser instance.
 * It's just a sugar to call `plugin(md, params)` with curring.
 *
 * ##### Example
 *
 * ```javascript
 * var iterator = require('markdown-it-for-inline');
 * var md = require('markdown-it')()
 *             .use(iterator, 'foo_replace', 'text', function (tokens, idx) {
 *               tokens[idx].content = tokens[idx].content.replace(/foo/g, 'bar');
 *             });
 * ```
 **/ $905095a5fbec7ff0$var$MarkdownIt.prototype.use = function(plugin /*, params, ... */ ) {
    var args = [
        this
    ].concat(Array.prototype.slice.call(arguments, 1));
    plugin.apply(plugin, args);
    return this;
};
/** internal
 * MarkdownIt.parse(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Parse input string and return list of block tokens (special token type
 * "inline" will contain list of inline tokens). You should not call this
 * method directly, until you write custom renderer (for example, to produce
 * AST).
 *
 * `env` is used to pass data between "distributed" rules and return additional
 * metadata like reference info, needed for the renderer. It also can be used to
 * inject data in specific cases. Usually, you will be ok to pass `{}`,
 * and then pass updated object to renderer.
 **/ $905095a5fbec7ff0$var$MarkdownIt.prototype.parse = function(src, env) {
    if (typeof src !== 'string') throw new Error('Input data should be a String');
    var state = new this.core.State(src, this, env);
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.render(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Render markdown string into html. It does all magic for you :).
 *
 * `env` can be used to inject additional metadata (`{}` by default).
 * But you will not need it with high probability. See also comment
 * in [[MarkdownIt.parse]].
 **/ $905095a5fbec7ff0$var$MarkdownIt.prototype.render = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parse(src, env), this.options, env);
};
/** internal
 * MarkdownIt.parseInline(src, env) -> Array
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * The same as [[MarkdownIt.parse]] but skip all block rules. It returns the
 * block tokens list with the single `inline` element, containing parsed inline
 * tokens in `children` property. Also updates `env` object.
 **/ $905095a5fbec7ff0$var$MarkdownIt.prototype.parseInline = function(src, env) {
    var state = new this.core.State(src, this, env);
    state.inlineMode = true;
    this.core.process(state);
    return state.tokens;
};
/**
 * MarkdownIt.renderInline(src [, env]) -> String
 * - src (String): source string
 * - env (Object): environment sandbox
 *
 * Similar to [[MarkdownIt.render]] but for single paragraph content. Result
 * will NOT be wrapped into `<p>` tags.
 **/ $905095a5fbec7ff0$var$MarkdownIt.prototype.renderInline = function(src, env) {
    env = env || {};
    return this.renderer.render(this.parseInline(src, env), this.options, env);
};
module.exports = $905095a5fbec7ff0$var$MarkdownIt;

});
parcelRegister("1hHFA", function(module, exports) {

$parcel$export(module.exports, "lib", () => $0ef940ddd5945ecd$export$16c08b91f883959a, (v) => $0ef940ddd5945ecd$export$16c08b91f883959a = v);
$parcel$export(module.exports, "assign", () => $0ef940ddd5945ecd$export$e6e34fd1f2686227, (v) => $0ef940ddd5945ecd$export$e6e34fd1f2686227 = v);
$parcel$export(module.exports, "isString", () => $0ef940ddd5945ecd$export$844ec244b1367d54, (v) => $0ef940ddd5945ecd$export$844ec244b1367d54 = v);
$parcel$export(module.exports, "has", () => $0ef940ddd5945ecd$export$a4f4bb6b1453fff5, (v) => $0ef940ddd5945ecd$export$a4f4bb6b1453fff5 = v);
$parcel$export(module.exports, "unescapeMd", () => $0ef940ddd5945ecd$export$5ccde1ea0c14bb03, (v) => $0ef940ddd5945ecd$export$5ccde1ea0c14bb03 = v);
$parcel$export(module.exports, "unescapeAll", () => $0ef940ddd5945ecd$export$db8a17c6655f7e2c, (v) => $0ef940ddd5945ecd$export$db8a17c6655f7e2c = v);
$parcel$export(module.exports, "isValidEntityCode", () => $0ef940ddd5945ecd$export$644a8f5b13b2a36d, (v) => $0ef940ddd5945ecd$export$644a8f5b13b2a36d = v);
$parcel$export(module.exports, "fromCodePoint", () => $0ef940ddd5945ecd$export$73bfc63873071f74, (v) => $0ef940ddd5945ecd$export$73bfc63873071f74 = v);
$parcel$export(module.exports, "escapeHtml", () => $0ef940ddd5945ecd$export$4cf11838cdc2a8a8, (v) => $0ef940ddd5945ecd$export$4cf11838cdc2a8a8 = v);
$parcel$export(module.exports, "arrayReplaceAt", () => $0ef940ddd5945ecd$export$f78478f71955b6bc, (v) => $0ef940ddd5945ecd$export$f78478f71955b6bc = v);
$parcel$export(module.exports, "isSpace", () => $0ef940ddd5945ecd$export$1d5ccafae59b4926, (v) => $0ef940ddd5945ecd$export$1d5ccafae59b4926 = v);
$parcel$export(module.exports, "isWhiteSpace", () => $0ef940ddd5945ecd$export$3c52dd84024ae72c, (v) => $0ef940ddd5945ecd$export$3c52dd84024ae72c = v);
$parcel$export(module.exports, "isMdAsciiPunct", () => $0ef940ddd5945ecd$export$829a0d33ae4e744, (v) => $0ef940ddd5945ecd$export$829a0d33ae4e744 = v);
$parcel$export(module.exports, "isPunctChar", () => $0ef940ddd5945ecd$export$4888a643af800fc1, (v) => $0ef940ddd5945ecd$export$4888a643af800fc1 = v);
$parcel$export(module.exports, "escapeRE", () => $0ef940ddd5945ecd$export$bc616c8f7dc20d5d, (v) => $0ef940ddd5945ecd$export$bc616c8f7dc20d5d = v);
$parcel$export(module.exports, "normalizeReference", () => $0ef940ddd5945ecd$export$20ef46802c8744b, (v) => $0ef940ddd5945ecd$export$20ef46802c8744b = v);
// Utilities
//
////////////////////////////////////////////////////////////////////////////////
// Re-export libraries commonly used in both markdown-it and its plugins,
// so plugins won't have to depend on them explicitly, which reduces their
// bundled size (e.g. a browser build).
//
var $0ef940ddd5945ecd$export$16c08b91f883959a;
var $0ef940ddd5945ecd$export$e6e34fd1f2686227;
var $0ef940ddd5945ecd$export$844ec244b1367d54;
var $0ef940ddd5945ecd$export$a4f4bb6b1453fff5;
var $0ef940ddd5945ecd$export$5ccde1ea0c14bb03;
var $0ef940ddd5945ecd$export$db8a17c6655f7e2c;
var $0ef940ddd5945ecd$export$644a8f5b13b2a36d;
var $0ef940ddd5945ecd$export$73bfc63873071f74;
// exports.replaceEntities     = replaceEntities;
var $0ef940ddd5945ecd$export$4cf11838cdc2a8a8;
var $0ef940ddd5945ecd$export$f78478f71955b6bc;
var $0ef940ddd5945ecd$export$1d5ccafae59b4926;
var $0ef940ddd5945ecd$export$3c52dd84024ae72c;
var $0ef940ddd5945ecd$export$829a0d33ae4e744;
var $0ef940ddd5945ecd$export$4888a643af800fc1;
var $0ef940ddd5945ecd$export$bc616c8f7dc20d5d;
var $0ef940ddd5945ecd$export$20ef46802c8744b;
'use strict';
function $0ef940ddd5945ecd$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $0ef940ddd5945ecd$var$isString(obj) {
    return $0ef940ddd5945ecd$var$_class(obj) === '[object String]';
}
var $0ef940ddd5945ecd$var$_hasOwnProperty = Object.prototype.hasOwnProperty;
function $0ef940ddd5945ecd$var$has(object, key) {
    return $0ef940ddd5945ecd$var$_hasOwnProperty.call(object, key);
}
// Merge objects
//
function $0ef940ddd5945ecd$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        if (typeof source !== 'object') throw new TypeError(source + 'must be object');
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
// Remove element from array and put another array at those position.
// Useful for some operations with tokens
function $0ef940ddd5945ecd$var$arrayReplaceAt(src, pos, newElements) {
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
}
////////////////////////////////////////////////////////////////////////////////
function $0ef940ddd5945ecd$var$isValidEntityCode(c) {
    /*eslint no-bitwise:0*/ // broken sequence
    if (c >= 0xD800 && c <= 0xDFFF) return false;
    // never used
    if (c >= 0xFDD0 && c <= 0xFDEF) return false;
    if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) return false;
    // control codes
    if (c >= 0x00 && c <= 0x08) return false;
    if (c === 0x0B) return false;
    if (c >= 0x0E && c <= 0x1F) return false;
    if (c >= 0x7F && c <= 0x9F) return false;
    // out of range
    if (c > 0x10FFFF) return false;
    return true;
}
function $0ef940ddd5945ecd$var$fromCodePoint(c) {
    /*eslint no-bitwise:0*/ if (c > 0xffff) {
        c -= 0x10000;
        var surrogate1 = 0xd800 + (c >> 10), surrogate2 = 0xdc00 + (c & 0x3ff);
        return String.fromCharCode(surrogate1, surrogate2);
    }
    return String.fromCharCode(c);
}
var $0ef940ddd5945ecd$var$UNESCAPE_MD_RE = /\\([!"#$%&'()*+,\-.\/:;<=>?@[\\\]^_`{|}~])/g;
var $0ef940ddd5945ecd$var$ENTITY_RE = /&([a-z#][a-z0-9]{1,31});/gi;
var $0ef940ddd5945ecd$var$UNESCAPE_ALL_RE = new RegExp($0ef940ddd5945ecd$var$UNESCAPE_MD_RE.source + '|' + $0ef940ddd5945ecd$var$ENTITY_RE.source, 'gi');
var $0ef940ddd5945ecd$var$DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;

var $3gFDb = parcelRequire("3gFDb");
function $0ef940ddd5945ecd$var$replaceEntityPattern(match, name) {
    var code;
    if ($0ef940ddd5945ecd$var$has($3gFDb, name)) return $3gFDb[name];
    if (name.charCodeAt(0) === 0x23 /* # */  && $0ef940ddd5945ecd$var$DIGITAL_ENTITY_TEST_RE.test(name)) {
        code = name[1].toLowerCase() === 'x' ? parseInt(name.slice(2), 16) : parseInt(name.slice(1), 10);
        if ($0ef940ddd5945ecd$var$isValidEntityCode(code)) return $0ef940ddd5945ecd$var$fromCodePoint(code);
    }
    return match;
}
/*function replaceEntities(str) {
  if (str.indexOf('&') < 0) { return str; }

  return str.replace(ENTITY_RE, replaceEntityPattern);
}*/ function $0ef940ddd5945ecd$var$unescapeMd(str) {
    if (str.indexOf('\\') < 0) return str;
    return str.replace($0ef940ddd5945ecd$var$UNESCAPE_MD_RE, '$1');
}
function $0ef940ddd5945ecd$var$unescapeAll(str) {
    if (str.indexOf('\\') < 0 && str.indexOf('&') < 0) return str;
    return str.replace($0ef940ddd5945ecd$var$UNESCAPE_ALL_RE, function(match, escaped, entity) {
        if (escaped) return escaped;
        return $0ef940ddd5945ecd$var$replaceEntityPattern(match, entity);
    });
}
////////////////////////////////////////////////////////////////////////////////
var $0ef940ddd5945ecd$var$HTML_ESCAPE_TEST_RE = /[&<>"]/;
var $0ef940ddd5945ecd$var$HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
var $0ef940ddd5945ecd$var$HTML_REPLACEMENTS = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;'
};
function $0ef940ddd5945ecd$var$replaceUnsafeChar(ch) {
    return $0ef940ddd5945ecd$var$HTML_REPLACEMENTS[ch];
}
function $0ef940ddd5945ecd$var$escapeHtml(str) {
    if ($0ef940ddd5945ecd$var$HTML_ESCAPE_TEST_RE.test(str)) return str.replace($0ef940ddd5945ecd$var$HTML_ESCAPE_REPLACE_RE, $0ef940ddd5945ecd$var$replaceUnsafeChar);
    return str;
}
////////////////////////////////////////////////////////////////////////////////
var $0ef940ddd5945ecd$var$REGEXP_ESCAPE_RE = /[.?*+^$[\]\\(){}|-]/g;
function $0ef940ddd5945ecd$var$escapeRE(str) {
    return str.replace($0ef940ddd5945ecd$var$REGEXP_ESCAPE_RE, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
function $0ef940ddd5945ecd$var$isSpace(code) {
    switch(code){
        case 0x09:
        case 0x20:
            return true;
    }
    return false;
}
// Zs (unicode class) || [\t\f\v\r\n]
function $0ef940ddd5945ecd$var$isWhiteSpace(code) {
    if (code >= 0x2000 && code <= 0x200A) return true;
    switch(code){
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0C:
        case 0x0D:
        case 0x20:
        case 0xA0:
        case 0x1680:
        case 0x202F:
        case 0x205F:
        case 0x3000:
            return true;
    }
    return false;
}

var $aUAJj = parcelRequire("aUAJj");
// Currently without astral characters support.
function $0ef940ddd5945ecd$var$isPunctChar(ch) {
    return $aUAJj.test(ch);
}
// Markdown ASCII punctuation characters.
//
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
//
// Don't confuse with unicode punctuation !!! It lacks some chars in ascii range.
//
function $0ef940ddd5945ecd$var$isMdAsciiPunct(ch) {
    switch(ch){
        case 0x21 /* ! */ :
        case 0x22 /* " */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x27 /* ' */ :
        case 0x28 /* ( */ :
        case 0x29 /* ) */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2C /* , */ :
        case 0x2D /* - */ :
        case 0x2E /* . */ :
        case 0x2F /* / */ :
        case 0x3A /* : */ :
        case 0x3B /* ; */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x3F /* ? */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7C /* | */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
// Hepler to unify [reference labels].
//
function $0ef940ddd5945ecd$var$normalizeReference(str) {
    // Trim and collapse whitespace
    //
    str = str.trim().replace(/\s+/g, ' ');
    // In node v10 'ẞ'.toLowerCase() === 'Ṿ', which is presumed to be a bug
    // fixed in v12 (couldn't find any details).
    //
    // So treat this one as a special case
    // (remove this when node v10 is no longer supported).
    //
    if ("\u1E9E".toLowerCase() === "\u1E7E") str = str.replace(/ẞ/g, "\xdf");
    // .toLowerCase().toUpperCase() should get rid of all differences
    // between letter variants.
    //
    // Simple .toLowerCase() doesn't normalize 125 code points correctly,
    // and .toUpperCase doesn't normalize 6 of them (list of exceptions:
    // İ, ϴ, ẞ, Ω, K, Å - those are already uppercased, but have differently
    // uppercased versions).
    //
    // Here's an example showing how it happens. Lets take greek letter omega:
    // uppercase U+0398 (Θ), U+03f4 (ϴ) and lowercase U+03b8 (θ), U+03d1 (ϑ)
    //
    // Unicode entries:
    // 0398;GREEK CAPITAL LETTER THETA;Lu;0;L;;;;;N;;;;03B8;
    // 03B8;GREEK SMALL LETTER THETA;Ll;0;L;;;;;N;;;0398;;0398
    // 03D1;GREEK THETA SYMBOL;Ll;0;L;<compat> 03B8;;;;N;GREEK SMALL LETTER SCRIPT THETA;;0398;;0398
    // 03F4;GREEK CAPITAL THETA SYMBOL;Lu;0;L;<compat> 0398;;;;N;;;;03B8;
    //
    // Case-insensitive comparison should treat all of them as equivalent.
    //
    // But .toLowerCase() doesn't change ϑ (it's already lowercase),
    // and .toUpperCase() doesn't change ϴ (already uppercase).
    //
    // Applying first lower then upper case normalizes any character:
    // '\u0398\u03f4\u03b8\u03d1'.toLowerCase().toUpperCase() === '\u0398\u0398\u0398\u0398'
    //
    // Note: this is equivalent to unicode case folding; unicode normalization
    // is a different step that is not required here.
    //
    // Final result should be uppercased, because it's later stored in an object
    // (this avoid a conflict with Object.prototype members,
    // most notably, `__proto__`)
    //
    return str.toLowerCase().toUpperCase();
}
$0ef940ddd5945ecd$export$16c08b91f883959a = {};

$0ef940ddd5945ecd$export$16c08b91f883959a.mdurl = (parcelRequire("lBnMO"));

$0ef940ddd5945ecd$export$16c08b91f883959a.ucmicro = (parcelRequire("hekrg"));
$0ef940ddd5945ecd$export$e6e34fd1f2686227 = $0ef940ddd5945ecd$var$assign;
$0ef940ddd5945ecd$export$844ec244b1367d54 = $0ef940ddd5945ecd$var$isString;
$0ef940ddd5945ecd$export$a4f4bb6b1453fff5 = $0ef940ddd5945ecd$var$has;
$0ef940ddd5945ecd$export$5ccde1ea0c14bb03 = $0ef940ddd5945ecd$var$unescapeMd;
$0ef940ddd5945ecd$export$db8a17c6655f7e2c = $0ef940ddd5945ecd$var$unescapeAll;
$0ef940ddd5945ecd$export$644a8f5b13b2a36d = $0ef940ddd5945ecd$var$isValidEntityCode;
$0ef940ddd5945ecd$export$73bfc63873071f74 = $0ef940ddd5945ecd$var$fromCodePoint;
$0ef940ddd5945ecd$export$4cf11838cdc2a8a8 = $0ef940ddd5945ecd$var$escapeHtml;
$0ef940ddd5945ecd$export$f78478f71955b6bc = $0ef940ddd5945ecd$var$arrayReplaceAt;
$0ef940ddd5945ecd$export$1d5ccafae59b4926 = $0ef940ddd5945ecd$var$isSpace;
$0ef940ddd5945ecd$export$3c52dd84024ae72c = $0ef940ddd5945ecd$var$isWhiteSpace;
$0ef940ddd5945ecd$export$829a0d33ae4e744 = $0ef940ddd5945ecd$var$isMdAsciiPunct;
$0ef940ddd5945ecd$export$4888a643af800fc1 = $0ef940ddd5945ecd$var$isPunctChar;
$0ef940ddd5945ecd$export$bc616c8f7dc20d5d = $0ef940ddd5945ecd$var$escapeRE;
$0ef940ddd5945ecd$export$20ef46802c8744b = $0ef940ddd5945ecd$var$normalizeReference;

});
parcelRegister("3gFDb", function(module, exports) {
// HTML5 entities map: { name -> utf16string }
//
'use strict';

/*eslint quotes:0*/ module.exports = (parcelRequire("lFaMw"));

});
parcelRegister("lFaMw", function(module, exports) {
module.exports = JSON.parse('{"Aacute":"\xc1","aacute":"\xe1","Abreve":"\u0102","abreve":"\u0103","ac":"\u223E","acd":"\u223F","acE":"\u223E\u0333","Acirc":"\xc2","acirc":"\xe2","acute":"\xb4","Acy":"\u0410","acy":"\u0430","AElig":"\xc6","aelig":"\xe6","af":"\u2061","Afr":"\uD835\uDD04","afr":"\uD835\uDD1E","Agrave":"\xc0","agrave":"\xe0","alefsym":"\u2135","aleph":"\u2135","Alpha":"\u0391","alpha":"\u03B1","Amacr":"\u0100","amacr":"\u0101","amalg":"\u2A3F","amp":"&","AMP":"&","andand":"\u2A55","And":"\u2A53","and":"\u2227","andd":"\u2A5C","andslope":"\u2A58","andv":"\u2A5A","ang":"\u2220","ange":"\u29A4","angle":"\u2220","angmsdaa":"\u29A8","angmsdab":"\u29A9","angmsdac":"\u29AA","angmsdad":"\u29AB","angmsdae":"\u29AC","angmsdaf":"\u29AD","angmsdag":"\u29AE","angmsdah":"\u29AF","angmsd":"\u2221","angrt":"\u221F","angrtvb":"\u22BE","angrtvbd":"\u299D","angsph":"\u2222","angst":"\xc5","angzarr":"\u237C","Aogon":"\u0104","aogon":"\u0105","Aopf":"\uD835\uDD38","aopf":"\uD835\uDD52","apacir":"\u2A6F","ap":"\u2248","apE":"\u2A70","ape":"\u224A","apid":"\u224B","apos":"\'","ApplyFunction":"\u2061","approx":"\u2248","approxeq":"\u224A","Aring":"\xc5","aring":"\xe5","Ascr":"\uD835\uDC9C","ascr":"\uD835\uDCB6","Assign":"\u2254","ast":"*","asymp":"\u2248","asympeq":"\u224D","Atilde":"\xc3","atilde":"\xe3","Auml":"\xc4","auml":"\xe4","awconint":"\u2233","awint":"\u2A11","backcong":"\u224C","backepsilon":"\u03F6","backprime":"\u2035","backsim":"\u223D","backsimeq":"\u22CD","Backslash":"\u2216","Barv":"\u2AE7","barvee":"\u22BD","barwed":"\u2305","Barwed":"\u2306","barwedge":"\u2305","bbrk":"\u23B5","bbrktbrk":"\u23B6","bcong":"\u224C","Bcy":"\u0411","bcy":"\u0431","bdquo":"\u201E","becaus":"\u2235","because":"\u2235","Because":"\u2235","bemptyv":"\u29B0","bepsi":"\u03F6","bernou":"\u212C","Bernoullis":"\u212C","Beta":"\u0392","beta":"\u03B2","beth":"\u2136","between":"\u226C","Bfr":"\uD835\uDD05","bfr":"\uD835\uDD1F","bigcap":"\u22C2","bigcirc":"\u25EF","bigcup":"\u22C3","bigodot":"\u2A00","bigoplus":"\u2A01","bigotimes":"\u2A02","bigsqcup":"\u2A06","bigstar":"\u2605","bigtriangledown":"\u25BD","bigtriangleup":"\u25B3","biguplus":"\u2A04","bigvee":"\u22C1","bigwedge":"\u22C0","bkarow":"\u290D","blacklozenge":"\u29EB","blacksquare":"\u25AA","blacktriangle":"\u25B4","blacktriangledown":"\u25BE","blacktriangleleft":"\u25C2","blacktriangleright":"\u25B8","blank":"\u2423","blk12":"\u2592","blk14":"\u2591","blk34":"\u2593","block":"\u2588","bne":"=\u20E5","bnequiv":"\u2261\u20E5","bNot":"\u2AED","bnot":"\u2310","Bopf":"\uD835\uDD39","bopf":"\uD835\uDD53","bot":"\u22A5","bottom":"\u22A5","bowtie":"\u22C8","boxbox":"\u29C9","boxdl":"\u2510","boxdL":"\u2555","boxDl":"\u2556","boxDL":"\u2557","boxdr":"\u250C","boxdR":"\u2552","boxDr":"\u2553","boxDR":"\u2554","boxh":"\u2500","boxH":"\u2550","boxhd":"\u252C","boxHd":"\u2564","boxhD":"\u2565","boxHD":"\u2566","boxhu":"\u2534","boxHu":"\u2567","boxhU":"\u2568","boxHU":"\u2569","boxminus":"\u229F","boxplus":"\u229E","boxtimes":"\u22A0","boxul":"\u2518","boxuL":"\u255B","boxUl":"\u255C","boxUL":"\u255D","boxur":"\u2514","boxuR":"\u2558","boxUr":"\u2559","boxUR":"\u255A","boxv":"\u2502","boxV":"\u2551","boxvh":"\u253C","boxvH":"\u256A","boxVh":"\u256B","boxVH":"\u256C","boxvl":"\u2524","boxvL":"\u2561","boxVl":"\u2562","boxVL":"\u2563","boxvr":"\u251C","boxvR":"\u255E","boxVr":"\u255F","boxVR":"\u2560","bprime":"\u2035","breve":"\u02D8","Breve":"\u02D8","brvbar":"\xa6","bscr":"\uD835\uDCB7","Bscr":"\u212C","bsemi":"\u204F","bsim":"\u223D","bsime":"\u22CD","bsolb":"\u29C5","bsol":"\\\\","bsolhsub":"\u27C8","bull":"\u2022","bullet":"\u2022","bump":"\u224E","bumpE":"\u2AAE","bumpe":"\u224F","Bumpeq":"\u224E","bumpeq":"\u224F","Cacute":"\u0106","cacute":"\u0107","capand":"\u2A44","capbrcup":"\u2A49","capcap":"\u2A4B","cap":"\u2229","Cap":"\u22D2","capcup":"\u2A47","capdot":"\u2A40","CapitalDifferentialD":"\u2145","caps":"\u2229\uFE00","caret":"\u2041","caron":"\u02C7","Cayleys":"\u212D","ccaps":"\u2A4D","Ccaron":"\u010C","ccaron":"\u010D","Ccedil":"\xc7","ccedil":"\xe7","Ccirc":"\u0108","ccirc":"\u0109","Cconint":"\u2230","ccups":"\u2A4C","ccupssm":"\u2A50","Cdot":"\u010A","cdot":"\u010B","cedil":"\xb8","Cedilla":"\xb8","cemptyv":"\u29B2","cent":"\xa2","centerdot":"\xb7","CenterDot":"\xb7","cfr":"\uD835\uDD20","Cfr":"\u212D","CHcy":"\u0427","chcy":"\u0447","check":"\u2713","checkmark":"\u2713","Chi":"\u03A7","chi":"\u03C7","circ":"\u02C6","circeq":"\u2257","circlearrowleft":"\u21BA","circlearrowright":"\u21BB","circledast":"\u229B","circledcirc":"\u229A","circleddash":"\u229D","CircleDot":"\u2299","circledR":"\xae","circledS":"\u24C8","CircleMinus":"\u2296","CirclePlus":"\u2295","CircleTimes":"\u2297","cir":"\u25CB","cirE":"\u29C3","cire":"\u2257","cirfnint":"\u2A10","cirmid":"\u2AEF","cirscir":"\u29C2","ClockwiseContourIntegral":"\u2232","CloseCurlyDoubleQuote":"\u201D","CloseCurlyQuote":"\u2019","clubs":"\u2663","clubsuit":"\u2663","colon":":","Colon":"\u2237","Colone":"\u2A74","colone":"\u2254","coloneq":"\u2254","comma":",","commat":"@","comp":"\u2201","compfn":"\u2218","complement":"\u2201","complexes":"\u2102","cong":"\u2245","congdot":"\u2A6D","Congruent":"\u2261","conint":"\u222E","Conint":"\u222F","ContourIntegral":"\u222E","copf":"\uD835\uDD54","Copf":"\u2102","coprod":"\u2210","Coproduct":"\u2210","copy":"\xa9","COPY":"\xa9","copysr":"\u2117","CounterClockwiseContourIntegral":"\u2233","crarr":"\u21B5","cross":"\u2717","Cross":"\u2A2F","Cscr":"\uD835\uDC9E","cscr":"\uD835\uDCB8","csub":"\u2ACF","csube":"\u2AD1","csup":"\u2AD0","csupe":"\u2AD2","ctdot":"\u22EF","cudarrl":"\u2938","cudarrr":"\u2935","cuepr":"\u22DE","cuesc":"\u22DF","cularr":"\u21B6","cularrp":"\u293D","cupbrcap":"\u2A48","cupcap":"\u2A46","CupCap":"\u224D","cup":"\u222A","Cup":"\u22D3","cupcup":"\u2A4A","cupdot":"\u228D","cupor":"\u2A45","cups":"\u222A\uFE00","curarr":"\u21B7","curarrm":"\u293C","curlyeqprec":"\u22DE","curlyeqsucc":"\u22DF","curlyvee":"\u22CE","curlywedge":"\u22CF","curren":"\xa4","curvearrowleft":"\u21B6","curvearrowright":"\u21B7","cuvee":"\u22CE","cuwed":"\u22CF","cwconint":"\u2232","cwint":"\u2231","cylcty":"\u232D","dagger":"\u2020","Dagger":"\u2021","daleth":"\u2138","darr":"\u2193","Darr":"\u21A1","dArr":"\u21D3","dash":"\u2010","Dashv":"\u2AE4","dashv":"\u22A3","dbkarow":"\u290F","dblac":"\u02DD","Dcaron":"\u010E","dcaron":"\u010F","Dcy":"\u0414","dcy":"\u0434","ddagger":"\u2021","ddarr":"\u21CA","DD":"\u2145","dd":"\u2146","DDotrahd":"\u2911","ddotseq":"\u2A77","deg":"\xb0","Del":"\u2207","Delta":"\u0394","delta":"\u03B4","demptyv":"\u29B1","dfisht":"\u297F","Dfr":"\uD835\uDD07","dfr":"\uD835\uDD21","dHar":"\u2965","dharl":"\u21C3","dharr":"\u21C2","DiacriticalAcute":"\xb4","DiacriticalDot":"\u02D9","DiacriticalDoubleAcute":"\u02DD","DiacriticalGrave":"`","DiacriticalTilde":"\u02DC","diam":"\u22C4","diamond":"\u22C4","Diamond":"\u22C4","diamondsuit":"\u2666","diams":"\u2666","die":"\xa8","DifferentialD":"\u2146","digamma":"\u03DD","disin":"\u22F2","div":"\xf7","divide":"\xf7","divideontimes":"\u22C7","divonx":"\u22C7","DJcy":"\u0402","djcy":"\u0452","dlcorn":"\u231E","dlcrop":"\u230D","dollar":"$","Dopf":"\uD835\uDD3B","dopf":"\uD835\uDD55","Dot":"\xa8","dot":"\u02D9","DotDot":"\u20DC","doteq":"\u2250","doteqdot":"\u2251","DotEqual":"\u2250","dotminus":"\u2238","dotplus":"\u2214","dotsquare":"\u22A1","doublebarwedge":"\u2306","DoubleContourIntegral":"\u222F","DoubleDot":"\xa8","DoubleDownArrow":"\u21D3","DoubleLeftArrow":"\u21D0","DoubleLeftRightArrow":"\u21D4","DoubleLeftTee":"\u2AE4","DoubleLongLeftArrow":"\u27F8","DoubleLongLeftRightArrow":"\u27FA","DoubleLongRightArrow":"\u27F9","DoubleRightArrow":"\u21D2","DoubleRightTee":"\u22A8","DoubleUpArrow":"\u21D1","DoubleUpDownArrow":"\u21D5","DoubleVerticalBar":"\u2225","DownArrowBar":"\u2913","downarrow":"\u2193","DownArrow":"\u2193","Downarrow":"\u21D3","DownArrowUpArrow":"\u21F5","DownBreve":"\u0311","downdownarrows":"\u21CA","downharpoonleft":"\u21C3","downharpoonright":"\u21C2","DownLeftRightVector":"\u2950","DownLeftTeeVector":"\u295E","DownLeftVectorBar":"\u2956","DownLeftVector":"\u21BD","DownRightTeeVector":"\u295F","DownRightVectorBar":"\u2957","DownRightVector":"\u21C1","DownTeeArrow":"\u21A7","DownTee":"\u22A4","drbkarow":"\u2910","drcorn":"\u231F","drcrop":"\u230C","Dscr":"\uD835\uDC9F","dscr":"\uD835\uDCB9","DScy":"\u0405","dscy":"\u0455","dsol":"\u29F6","Dstrok":"\u0110","dstrok":"\u0111","dtdot":"\u22F1","dtri":"\u25BF","dtrif":"\u25BE","duarr":"\u21F5","duhar":"\u296F","dwangle":"\u29A6","DZcy":"\u040F","dzcy":"\u045F","dzigrarr":"\u27FF","Eacute":"\xc9","eacute":"\xe9","easter":"\u2A6E","Ecaron":"\u011A","ecaron":"\u011B","Ecirc":"\xca","ecirc":"\xea","ecir":"\u2256","ecolon":"\u2255","Ecy":"\u042D","ecy":"\u044D","eDDot":"\u2A77","Edot":"\u0116","edot":"\u0117","eDot":"\u2251","ee":"\u2147","efDot":"\u2252","Efr":"\uD835\uDD08","efr":"\uD835\uDD22","eg":"\u2A9A","Egrave":"\xc8","egrave":"\xe8","egs":"\u2A96","egsdot":"\u2A98","el":"\u2A99","Element":"\u2208","elinters":"\u23E7","ell":"\u2113","els":"\u2A95","elsdot":"\u2A97","Emacr":"\u0112","emacr":"\u0113","empty":"\u2205","emptyset":"\u2205","EmptySmallSquare":"\u25FB","emptyv":"\u2205","EmptyVerySmallSquare":"\u25AB","emsp13":"\u2004","emsp14":"\u2005","emsp":"\u2003","ENG":"\u014A","eng":"\u014B","ensp":"\u2002","Eogon":"\u0118","eogon":"\u0119","Eopf":"\uD835\uDD3C","eopf":"\uD835\uDD56","epar":"\u22D5","eparsl":"\u29E3","eplus":"\u2A71","epsi":"\u03B5","Epsilon":"\u0395","epsilon":"\u03B5","epsiv":"\u03F5","eqcirc":"\u2256","eqcolon":"\u2255","eqsim":"\u2242","eqslantgtr":"\u2A96","eqslantless":"\u2A95","Equal":"\u2A75","equals":"=","EqualTilde":"\u2242","equest":"\u225F","Equilibrium":"\u21CC","equiv":"\u2261","equivDD":"\u2A78","eqvparsl":"\u29E5","erarr":"\u2971","erDot":"\u2253","escr":"\u212F","Escr":"\u2130","esdot":"\u2250","Esim":"\u2A73","esim":"\u2242","Eta":"\u0397","eta":"\u03B7","ETH":"\xd0","eth":"\xf0","Euml":"\xcb","euml":"\xeb","euro":"\u20AC","excl":"!","exist":"\u2203","Exists":"\u2203","expectation":"\u2130","exponentiale":"\u2147","ExponentialE":"\u2147","fallingdotseq":"\u2252","Fcy":"\u0424","fcy":"\u0444","female":"\u2640","ffilig":"\uFB03","fflig":"\uFB00","ffllig":"\uFB04","Ffr":"\uD835\uDD09","ffr":"\uD835\uDD23","filig":"\uFB01","FilledSmallSquare":"\u25FC","FilledVerySmallSquare":"\u25AA","fjlig":"fj","flat":"\u266D","fllig":"\uFB02","fltns":"\u25B1","fnof":"\u0192","Fopf":"\uD835\uDD3D","fopf":"\uD835\uDD57","forall":"\u2200","ForAll":"\u2200","fork":"\u22D4","forkv":"\u2AD9","Fouriertrf":"\u2131","fpartint":"\u2A0D","frac12":"\xbd","frac13":"\u2153","frac14":"\xbc","frac15":"\u2155","frac16":"\u2159","frac18":"\u215B","frac23":"\u2154","frac25":"\u2156","frac34":"\xbe","frac35":"\u2157","frac38":"\u215C","frac45":"\u2158","frac56":"\u215A","frac58":"\u215D","frac78":"\u215E","frasl":"\u2044","frown":"\u2322","fscr":"\uD835\uDCBB","Fscr":"\u2131","gacute":"\u01F5","Gamma":"\u0393","gamma":"\u03B3","Gammad":"\u03DC","gammad":"\u03DD","gap":"\u2A86","Gbreve":"\u011E","gbreve":"\u011F","Gcedil":"\u0122","Gcirc":"\u011C","gcirc":"\u011D","Gcy":"\u0413","gcy":"\u0433","Gdot":"\u0120","gdot":"\u0121","ge":"\u2265","gE":"\u2267","gEl":"\u2A8C","gel":"\u22DB","geq":"\u2265","geqq":"\u2267","geqslant":"\u2A7E","gescc":"\u2AA9","ges":"\u2A7E","gesdot":"\u2A80","gesdoto":"\u2A82","gesdotol":"\u2A84","gesl":"\u22DB\uFE00","gesles":"\u2A94","Gfr":"\uD835\uDD0A","gfr":"\uD835\uDD24","gg":"\u226B","Gg":"\u22D9","ggg":"\u22D9","gimel":"\u2137","GJcy":"\u0403","gjcy":"\u0453","gla":"\u2AA5","gl":"\u2277","glE":"\u2A92","glj":"\u2AA4","gnap":"\u2A8A","gnapprox":"\u2A8A","gne":"\u2A88","gnE":"\u2269","gneq":"\u2A88","gneqq":"\u2269","gnsim":"\u22E7","Gopf":"\uD835\uDD3E","gopf":"\uD835\uDD58","grave":"`","GreaterEqual":"\u2265","GreaterEqualLess":"\u22DB","GreaterFullEqual":"\u2267","GreaterGreater":"\u2AA2","GreaterLess":"\u2277","GreaterSlantEqual":"\u2A7E","GreaterTilde":"\u2273","Gscr":"\uD835\uDCA2","gscr":"\u210A","gsim":"\u2273","gsime":"\u2A8E","gsiml":"\u2A90","gtcc":"\u2AA7","gtcir":"\u2A7A","gt":">","GT":">","Gt":"\u226B","gtdot":"\u22D7","gtlPar":"\u2995","gtquest":"\u2A7C","gtrapprox":"\u2A86","gtrarr":"\u2978","gtrdot":"\u22D7","gtreqless":"\u22DB","gtreqqless":"\u2A8C","gtrless":"\u2277","gtrsim":"\u2273","gvertneqq":"\u2269\uFE00","gvnE":"\u2269\uFE00","Hacek":"\u02C7","hairsp":"\u200A","half":"\xbd","hamilt":"\u210B","HARDcy":"\u042A","hardcy":"\u044A","harrcir":"\u2948","harr":"\u2194","hArr":"\u21D4","harrw":"\u21AD","Hat":"^","hbar":"\u210F","Hcirc":"\u0124","hcirc":"\u0125","hearts":"\u2665","heartsuit":"\u2665","hellip":"\u2026","hercon":"\u22B9","hfr":"\uD835\uDD25","Hfr":"\u210C","HilbertSpace":"\u210B","hksearow":"\u2925","hkswarow":"\u2926","hoarr":"\u21FF","homtht":"\u223B","hookleftarrow":"\u21A9","hookrightarrow":"\u21AA","hopf":"\uD835\uDD59","Hopf":"\u210D","horbar":"\u2015","HorizontalLine":"\u2500","hscr":"\uD835\uDCBD","Hscr":"\u210B","hslash":"\u210F","Hstrok":"\u0126","hstrok":"\u0127","HumpDownHump":"\u224E","HumpEqual":"\u224F","hybull":"\u2043","hyphen":"\u2010","Iacute":"\xcd","iacute":"\xed","ic":"\u2063","Icirc":"\xce","icirc":"\xee","Icy":"\u0418","icy":"\u0438","Idot":"\u0130","IEcy":"\u0415","iecy":"\u0435","iexcl":"\xa1","iff":"\u21D4","ifr":"\uD835\uDD26","Ifr":"\u2111","Igrave":"\xcc","igrave":"\xec","ii":"\u2148","iiiint":"\u2A0C","iiint":"\u222D","iinfin":"\u29DC","iiota":"\u2129","IJlig":"\u0132","ijlig":"\u0133","Imacr":"\u012A","imacr":"\u012B","image":"\u2111","ImaginaryI":"\u2148","imagline":"\u2110","imagpart":"\u2111","imath":"\u0131","Im":"\u2111","imof":"\u22B7","imped":"\u01B5","Implies":"\u21D2","incare":"\u2105","in":"\u2208","infin":"\u221E","infintie":"\u29DD","inodot":"\u0131","intcal":"\u22BA","int":"\u222B","Int":"\u222C","integers":"\u2124","Integral":"\u222B","intercal":"\u22BA","Intersection":"\u22C2","intlarhk":"\u2A17","intprod":"\u2A3C","InvisibleComma":"\u2063","InvisibleTimes":"\u2062","IOcy":"\u0401","iocy":"\u0451","Iogon":"\u012E","iogon":"\u012F","Iopf":"\uD835\uDD40","iopf":"\uD835\uDD5A","Iota":"\u0399","iota":"\u03B9","iprod":"\u2A3C","iquest":"\xbf","iscr":"\uD835\uDCBE","Iscr":"\u2110","isin":"\u2208","isindot":"\u22F5","isinE":"\u22F9","isins":"\u22F4","isinsv":"\u22F3","isinv":"\u2208","it":"\u2062","Itilde":"\u0128","itilde":"\u0129","Iukcy":"\u0406","iukcy":"\u0456","Iuml":"\xcf","iuml":"\xef","Jcirc":"\u0134","jcirc":"\u0135","Jcy":"\u0419","jcy":"\u0439","Jfr":"\uD835\uDD0D","jfr":"\uD835\uDD27","jmath":"\u0237","Jopf":"\uD835\uDD41","jopf":"\uD835\uDD5B","Jscr":"\uD835\uDCA5","jscr":"\uD835\uDCBF","Jsercy":"\u0408","jsercy":"\u0458","Jukcy":"\u0404","jukcy":"\u0454","Kappa":"\u039A","kappa":"\u03BA","kappav":"\u03F0","Kcedil":"\u0136","kcedil":"\u0137","Kcy":"\u041A","kcy":"\u043A","Kfr":"\uD835\uDD0E","kfr":"\uD835\uDD28","kgreen":"\u0138","KHcy":"\u0425","khcy":"\u0445","KJcy":"\u040C","kjcy":"\u045C","Kopf":"\uD835\uDD42","kopf":"\uD835\uDD5C","Kscr":"\uD835\uDCA6","kscr":"\uD835\uDCC0","lAarr":"\u21DA","Lacute":"\u0139","lacute":"\u013A","laemptyv":"\u29B4","lagran":"\u2112","Lambda":"\u039B","lambda":"\u03BB","lang":"\u27E8","Lang":"\u27EA","langd":"\u2991","langle":"\u27E8","lap":"\u2A85","Laplacetrf":"\u2112","laquo":"\xab","larrb":"\u21E4","larrbfs":"\u291F","larr":"\u2190","Larr":"\u219E","lArr":"\u21D0","larrfs":"\u291D","larrhk":"\u21A9","larrlp":"\u21AB","larrpl":"\u2939","larrsim":"\u2973","larrtl":"\u21A2","latail":"\u2919","lAtail":"\u291B","lat":"\u2AAB","late":"\u2AAD","lates":"\u2AAD\uFE00","lbarr":"\u290C","lBarr":"\u290E","lbbrk":"\u2772","lbrace":"{","lbrack":"[","lbrke":"\u298B","lbrksld":"\u298F","lbrkslu":"\u298D","Lcaron":"\u013D","lcaron":"\u013E","Lcedil":"\u013B","lcedil":"\u013C","lceil":"\u2308","lcub":"{","Lcy":"\u041B","lcy":"\u043B","ldca":"\u2936","ldquo":"\u201C","ldquor":"\u201E","ldrdhar":"\u2967","ldrushar":"\u294B","ldsh":"\u21B2","le":"\u2264","lE":"\u2266","LeftAngleBracket":"\u27E8","LeftArrowBar":"\u21E4","leftarrow":"\u2190","LeftArrow":"\u2190","Leftarrow":"\u21D0","LeftArrowRightArrow":"\u21C6","leftarrowtail":"\u21A2","LeftCeiling":"\u2308","LeftDoubleBracket":"\u27E6","LeftDownTeeVector":"\u2961","LeftDownVectorBar":"\u2959","LeftDownVector":"\u21C3","LeftFloor":"\u230A","leftharpoondown":"\u21BD","leftharpoonup":"\u21BC","leftleftarrows":"\u21C7","leftrightarrow":"\u2194","LeftRightArrow":"\u2194","Leftrightarrow":"\u21D4","leftrightarrows":"\u21C6","leftrightharpoons":"\u21CB","leftrightsquigarrow":"\u21AD","LeftRightVector":"\u294E","LeftTeeArrow":"\u21A4","LeftTee":"\u22A3","LeftTeeVector":"\u295A","leftthreetimes":"\u22CB","LeftTriangleBar":"\u29CF","LeftTriangle":"\u22B2","LeftTriangleEqual":"\u22B4","LeftUpDownVector":"\u2951","LeftUpTeeVector":"\u2960","LeftUpVectorBar":"\u2958","LeftUpVector":"\u21BF","LeftVectorBar":"\u2952","LeftVector":"\u21BC","lEg":"\u2A8B","leg":"\u22DA","leq":"\u2264","leqq":"\u2266","leqslant":"\u2A7D","lescc":"\u2AA8","les":"\u2A7D","lesdot":"\u2A7F","lesdoto":"\u2A81","lesdotor":"\u2A83","lesg":"\u22DA\uFE00","lesges":"\u2A93","lessapprox":"\u2A85","lessdot":"\u22D6","lesseqgtr":"\u22DA","lesseqqgtr":"\u2A8B","LessEqualGreater":"\u22DA","LessFullEqual":"\u2266","LessGreater":"\u2276","lessgtr":"\u2276","LessLess":"\u2AA1","lesssim":"\u2272","LessSlantEqual":"\u2A7D","LessTilde":"\u2272","lfisht":"\u297C","lfloor":"\u230A","Lfr":"\uD835\uDD0F","lfr":"\uD835\uDD29","lg":"\u2276","lgE":"\u2A91","lHar":"\u2962","lhard":"\u21BD","lharu":"\u21BC","lharul":"\u296A","lhblk":"\u2584","LJcy":"\u0409","ljcy":"\u0459","llarr":"\u21C7","ll":"\u226A","Ll":"\u22D8","llcorner":"\u231E","Lleftarrow":"\u21DA","llhard":"\u296B","lltri":"\u25FA","Lmidot":"\u013F","lmidot":"\u0140","lmoustache":"\u23B0","lmoust":"\u23B0","lnap":"\u2A89","lnapprox":"\u2A89","lne":"\u2A87","lnE":"\u2268","lneq":"\u2A87","lneqq":"\u2268","lnsim":"\u22E6","loang":"\u27EC","loarr":"\u21FD","lobrk":"\u27E6","longleftarrow":"\u27F5","LongLeftArrow":"\u27F5","Longleftarrow":"\u27F8","longleftrightarrow":"\u27F7","LongLeftRightArrow":"\u27F7","Longleftrightarrow":"\u27FA","longmapsto":"\u27FC","longrightarrow":"\u27F6","LongRightArrow":"\u27F6","Longrightarrow":"\u27F9","looparrowleft":"\u21AB","looparrowright":"\u21AC","lopar":"\u2985","Lopf":"\uD835\uDD43","lopf":"\uD835\uDD5D","loplus":"\u2A2D","lotimes":"\u2A34","lowast":"\u2217","lowbar":"_","LowerLeftArrow":"\u2199","LowerRightArrow":"\u2198","loz":"\u25CA","lozenge":"\u25CA","lozf":"\u29EB","lpar":"(","lparlt":"\u2993","lrarr":"\u21C6","lrcorner":"\u231F","lrhar":"\u21CB","lrhard":"\u296D","lrm":"\u200E","lrtri":"\u22BF","lsaquo":"\u2039","lscr":"\uD835\uDCC1","Lscr":"\u2112","lsh":"\u21B0","Lsh":"\u21B0","lsim":"\u2272","lsime":"\u2A8D","lsimg":"\u2A8F","lsqb":"[","lsquo":"\u2018","lsquor":"\u201A","Lstrok":"\u0141","lstrok":"\u0142","ltcc":"\u2AA6","ltcir":"\u2A79","lt":"<","LT":"<","Lt":"\u226A","ltdot":"\u22D6","lthree":"\u22CB","ltimes":"\u22C9","ltlarr":"\u2976","ltquest":"\u2A7B","ltri":"\u25C3","ltrie":"\u22B4","ltrif":"\u25C2","ltrPar":"\u2996","lurdshar":"\u294A","luruhar":"\u2966","lvertneqq":"\u2268\uFE00","lvnE":"\u2268\uFE00","macr":"\xaf","male":"\u2642","malt":"\u2720","maltese":"\u2720","Map":"\u2905","map":"\u21A6","mapsto":"\u21A6","mapstodown":"\u21A7","mapstoleft":"\u21A4","mapstoup":"\u21A5","marker":"\u25AE","mcomma":"\u2A29","Mcy":"\u041C","mcy":"\u043C","mdash":"\u2014","mDDot":"\u223A","measuredangle":"\u2221","MediumSpace":"\u205F","Mellintrf":"\u2133","Mfr":"\uD835\uDD10","mfr":"\uD835\uDD2A","mho":"\u2127","micro":"\xb5","midast":"*","midcir":"\u2AF0","mid":"\u2223","middot":"\xb7","minusb":"\u229F","minus":"\u2212","minusd":"\u2238","minusdu":"\u2A2A","MinusPlus":"\u2213","mlcp":"\u2ADB","mldr":"\u2026","mnplus":"\u2213","models":"\u22A7","Mopf":"\uD835\uDD44","mopf":"\uD835\uDD5E","mp":"\u2213","mscr":"\uD835\uDCC2","Mscr":"\u2133","mstpos":"\u223E","Mu":"\u039C","mu":"\u03BC","multimap":"\u22B8","mumap":"\u22B8","nabla":"\u2207","Nacute":"\u0143","nacute":"\u0144","nang":"\u2220\u20D2","nap":"\u2249","napE":"\u2A70\u0338","napid":"\u224B\u0338","napos":"\u0149","napprox":"\u2249","natural":"\u266E","naturals":"\u2115","natur":"\u266E","nbsp":"\xa0","nbump":"\u224E\u0338","nbumpe":"\u224F\u0338","ncap":"\u2A43","Ncaron":"\u0147","ncaron":"\u0148","Ncedil":"\u0145","ncedil":"\u0146","ncong":"\u2247","ncongdot":"\u2A6D\u0338","ncup":"\u2A42","Ncy":"\u041D","ncy":"\u043D","ndash":"\u2013","nearhk":"\u2924","nearr":"\u2197","neArr":"\u21D7","nearrow":"\u2197","ne":"\u2260","nedot":"\u2250\u0338","NegativeMediumSpace":"\u200B","NegativeThickSpace":"\u200B","NegativeThinSpace":"\u200B","NegativeVeryThinSpace":"\u200B","nequiv":"\u2262","nesear":"\u2928","nesim":"\u2242\u0338","NestedGreaterGreater":"\u226B","NestedLessLess":"\u226A","NewLine":"\\n","nexist":"\u2204","nexists":"\u2204","Nfr":"\uD835\uDD11","nfr":"\uD835\uDD2B","ngE":"\u2267\u0338","nge":"\u2271","ngeq":"\u2271","ngeqq":"\u2267\u0338","ngeqslant":"\u2A7E\u0338","nges":"\u2A7E\u0338","nGg":"\u22D9\u0338","ngsim":"\u2275","nGt":"\u226B\u20D2","ngt":"\u226F","ngtr":"\u226F","nGtv":"\u226B\u0338","nharr":"\u21AE","nhArr":"\u21CE","nhpar":"\u2AF2","ni":"\u220B","nis":"\u22FC","nisd":"\u22FA","niv":"\u220B","NJcy":"\u040A","njcy":"\u045A","nlarr":"\u219A","nlArr":"\u21CD","nldr":"\u2025","nlE":"\u2266\u0338","nle":"\u2270","nleftarrow":"\u219A","nLeftarrow":"\u21CD","nleftrightarrow":"\u21AE","nLeftrightarrow":"\u21CE","nleq":"\u2270","nleqq":"\u2266\u0338","nleqslant":"\u2A7D\u0338","nles":"\u2A7D\u0338","nless":"\u226E","nLl":"\u22D8\u0338","nlsim":"\u2274","nLt":"\u226A\u20D2","nlt":"\u226E","nltri":"\u22EA","nltrie":"\u22EC","nLtv":"\u226A\u0338","nmid":"\u2224","NoBreak":"\u2060","NonBreakingSpace":"\xa0","nopf":"\uD835\uDD5F","Nopf":"\u2115","Not":"\u2AEC","not":"\xac","NotCongruent":"\u2262","NotCupCap":"\u226D","NotDoubleVerticalBar":"\u2226","NotElement":"\u2209","NotEqual":"\u2260","NotEqualTilde":"\u2242\u0338","NotExists":"\u2204","NotGreater":"\u226F","NotGreaterEqual":"\u2271","NotGreaterFullEqual":"\u2267\u0338","NotGreaterGreater":"\u226B\u0338","NotGreaterLess":"\u2279","NotGreaterSlantEqual":"\u2A7E\u0338","NotGreaterTilde":"\u2275","NotHumpDownHump":"\u224E\u0338","NotHumpEqual":"\u224F\u0338","notin":"\u2209","notindot":"\u22F5\u0338","notinE":"\u22F9\u0338","notinva":"\u2209","notinvb":"\u22F7","notinvc":"\u22F6","NotLeftTriangleBar":"\u29CF\u0338","NotLeftTriangle":"\u22EA","NotLeftTriangleEqual":"\u22EC","NotLess":"\u226E","NotLessEqual":"\u2270","NotLessGreater":"\u2278","NotLessLess":"\u226A\u0338","NotLessSlantEqual":"\u2A7D\u0338","NotLessTilde":"\u2274","NotNestedGreaterGreater":"\u2AA2\u0338","NotNestedLessLess":"\u2AA1\u0338","notni":"\u220C","notniva":"\u220C","notnivb":"\u22FE","notnivc":"\u22FD","NotPrecedes":"\u2280","NotPrecedesEqual":"\u2AAF\u0338","NotPrecedesSlantEqual":"\u22E0","NotReverseElement":"\u220C","NotRightTriangleBar":"\u29D0\u0338","NotRightTriangle":"\u22EB","NotRightTriangleEqual":"\u22ED","NotSquareSubset":"\u228F\u0338","NotSquareSubsetEqual":"\u22E2","NotSquareSuperset":"\u2290\u0338","NotSquareSupersetEqual":"\u22E3","NotSubset":"\u2282\u20D2","NotSubsetEqual":"\u2288","NotSucceeds":"\u2281","NotSucceedsEqual":"\u2AB0\u0338","NotSucceedsSlantEqual":"\u22E1","NotSucceedsTilde":"\u227F\u0338","NotSuperset":"\u2283\u20D2","NotSupersetEqual":"\u2289","NotTilde":"\u2241","NotTildeEqual":"\u2244","NotTildeFullEqual":"\u2247","NotTildeTilde":"\u2249","NotVerticalBar":"\u2224","nparallel":"\u2226","npar":"\u2226","nparsl":"\u2AFD\u20E5","npart":"\u2202\u0338","npolint":"\u2A14","npr":"\u2280","nprcue":"\u22E0","nprec":"\u2280","npreceq":"\u2AAF\u0338","npre":"\u2AAF\u0338","nrarrc":"\u2933\u0338","nrarr":"\u219B","nrArr":"\u21CF","nrarrw":"\u219D\u0338","nrightarrow":"\u219B","nRightarrow":"\u21CF","nrtri":"\u22EB","nrtrie":"\u22ED","nsc":"\u2281","nsccue":"\u22E1","nsce":"\u2AB0\u0338","Nscr":"\uD835\uDCA9","nscr":"\uD835\uDCC3","nshortmid":"\u2224","nshortparallel":"\u2226","nsim":"\u2241","nsime":"\u2244","nsimeq":"\u2244","nsmid":"\u2224","nspar":"\u2226","nsqsube":"\u22E2","nsqsupe":"\u22E3","nsub":"\u2284","nsubE":"\u2AC5\u0338","nsube":"\u2288","nsubset":"\u2282\u20D2","nsubseteq":"\u2288","nsubseteqq":"\u2AC5\u0338","nsucc":"\u2281","nsucceq":"\u2AB0\u0338","nsup":"\u2285","nsupE":"\u2AC6\u0338","nsupe":"\u2289","nsupset":"\u2283\u20D2","nsupseteq":"\u2289","nsupseteqq":"\u2AC6\u0338","ntgl":"\u2279","Ntilde":"\xd1","ntilde":"\xf1","ntlg":"\u2278","ntriangleleft":"\u22EA","ntrianglelefteq":"\u22EC","ntriangleright":"\u22EB","ntrianglerighteq":"\u22ED","Nu":"\u039D","nu":"\u03BD","num":"#","numero":"\u2116","numsp":"\u2007","nvap":"\u224D\u20D2","nvdash":"\u22AC","nvDash":"\u22AD","nVdash":"\u22AE","nVDash":"\u22AF","nvge":"\u2265\u20D2","nvgt":">\u20D2","nvHarr":"\u2904","nvinfin":"\u29DE","nvlArr":"\u2902","nvle":"\u2264\u20D2","nvlt":"<\u20D2","nvltrie":"\u22B4\u20D2","nvrArr":"\u2903","nvrtrie":"\u22B5\u20D2","nvsim":"\u223C\u20D2","nwarhk":"\u2923","nwarr":"\u2196","nwArr":"\u21D6","nwarrow":"\u2196","nwnear":"\u2927","Oacute":"\xd3","oacute":"\xf3","oast":"\u229B","Ocirc":"\xd4","ocirc":"\xf4","ocir":"\u229A","Ocy":"\u041E","ocy":"\u043E","odash":"\u229D","Odblac":"\u0150","odblac":"\u0151","odiv":"\u2A38","odot":"\u2299","odsold":"\u29BC","OElig":"\u0152","oelig":"\u0153","ofcir":"\u29BF","Ofr":"\uD835\uDD12","ofr":"\uD835\uDD2C","ogon":"\u02DB","Ograve":"\xd2","ograve":"\xf2","ogt":"\u29C1","ohbar":"\u29B5","ohm":"\u03A9","oint":"\u222E","olarr":"\u21BA","olcir":"\u29BE","olcross":"\u29BB","oline":"\u203E","olt":"\u29C0","Omacr":"\u014C","omacr":"\u014D","Omega":"\u03A9","omega":"\u03C9","Omicron":"\u039F","omicron":"\u03BF","omid":"\u29B6","ominus":"\u2296","Oopf":"\uD835\uDD46","oopf":"\uD835\uDD60","opar":"\u29B7","OpenCurlyDoubleQuote":"\u201C","OpenCurlyQuote":"\u2018","operp":"\u29B9","oplus":"\u2295","orarr":"\u21BB","Or":"\u2A54","or":"\u2228","ord":"\u2A5D","order":"\u2134","orderof":"\u2134","ordf":"\xaa","ordm":"\xba","origof":"\u22B6","oror":"\u2A56","orslope":"\u2A57","orv":"\u2A5B","oS":"\u24C8","Oscr":"\uD835\uDCAA","oscr":"\u2134","Oslash":"\xd8","oslash":"\xf8","osol":"\u2298","Otilde":"\xd5","otilde":"\xf5","otimesas":"\u2A36","Otimes":"\u2A37","otimes":"\u2297","Ouml":"\xd6","ouml":"\xf6","ovbar":"\u233D","OverBar":"\u203E","OverBrace":"\u23DE","OverBracket":"\u23B4","OverParenthesis":"\u23DC","para":"\xb6","parallel":"\u2225","par":"\u2225","parsim":"\u2AF3","parsl":"\u2AFD","part":"\u2202","PartialD":"\u2202","Pcy":"\u041F","pcy":"\u043F","percnt":"%","period":".","permil":"\u2030","perp":"\u22A5","pertenk":"\u2031","Pfr":"\uD835\uDD13","pfr":"\uD835\uDD2D","Phi":"\u03A6","phi":"\u03C6","phiv":"\u03D5","phmmat":"\u2133","phone":"\u260E","Pi":"\u03A0","pi":"\u03C0","pitchfork":"\u22D4","piv":"\u03D6","planck":"\u210F","planckh":"\u210E","plankv":"\u210F","plusacir":"\u2A23","plusb":"\u229E","pluscir":"\u2A22","plus":"+","plusdo":"\u2214","plusdu":"\u2A25","pluse":"\u2A72","PlusMinus":"\xb1","plusmn":"\xb1","plussim":"\u2A26","plustwo":"\u2A27","pm":"\xb1","Poincareplane":"\u210C","pointint":"\u2A15","popf":"\uD835\uDD61","Popf":"\u2119","pound":"\xa3","prap":"\u2AB7","Pr":"\u2ABB","pr":"\u227A","prcue":"\u227C","precapprox":"\u2AB7","prec":"\u227A","preccurlyeq":"\u227C","Precedes":"\u227A","PrecedesEqual":"\u2AAF","PrecedesSlantEqual":"\u227C","PrecedesTilde":"\u227E","preceq":"\u2AAF","precnapprox":"\u2AB9","precneqq":"\u2AB5","precnsim":"\u22E8","pre":"\u2AAF","prE":"\u2AB3","precsim":"\u227E","prime":"\u2032","Prime":"\u2033","primes":"\u2119","prnap":"\u2AB9","prnE":"\u2AB5","prnsim":"\u22E8","prod":"\u220F","Product":"\u220F","profalar":"\u232E","profline":"\u2312","profsurf":"\u2313","prop":"\u221D","Proportional":"\u221D","Proportion":"\u2237","propto":"\u221D","prsim":"\u227E","prurel":"\u22B0","Pscr":"\uD835\uDCAB","pscr":"\uD835\uDCC5","Psi":"\u03A8","psi":"\u03C8","puncsp":"\u2008","Qfr":"\uD835\uDD14","qfr":"\uD835\uDD2E","qint":"\u2A0C","qopf":"\uD835\uDD62","Qopf":"\u211A","qprime":"\u2057","Qscr":"\uD835\uDCAC","qscr":"\uD835\uDCC6","quaternions":"\u210D","quatint":"\u2A16","quest":"?","questeq":"\u225F","quot":"\\"","QUOT":"\\"","rAarr":"\u21DB","race":"\u223D\u0331","Racute":"\u0154","racute":"\u0155","radic":"\u221A","raemptyv":"\u29B3","rang":"\u27E9","Rang":"\u27EB","rangd":"\u2992","range":"\u29A5","rangle":"\u27E9","raquo":"\xbb","rarrap":"\u2975","rarrb":"\u21E5","rarrbfs":"\u2920","rarrc":"\u2933","rarr":"\u2192","Rarr":"\u21A0","rArr":"\u21D2","rarrfs":"\u291E","rarrhk":"\u21AA","rarrlp":"\u21AC","rarrpl":"\u2945","rarrsim":"\u2974","Rarrtl":"\u2916","rarrtl":"\u21A3","rarrw":"\u219D","ratail":"\u291A","rAtail":"\u291C","ratio":"\u2236","rationals":"\u211A","rbarr":"\u290D","rBarr":"\u290F","RBarr":"\u2910","rbbrk":"\u2773","rbrace":"}","rbrack":"]","rbrke":"\u298C","rbrksld":"\u298E","rbrkslu":"\u2990","Rcaron":"\u0158","rcaron":"\u0159","Rcedil":"\u0156","rcedil":"\u0157","rceil":"\u2309","rcub":"}","Rcy":"\u0420","rcy":"\u0440","rdca":"\u2937","rdldhar":"\u2969","rdquo":"\u201D","rdquor":"\u201D","rdsh":"\u21B3","real":"\u211C","realine":"\u211B","realpart":"\u211C","reals":"\u211D","Re":"\u211C","rect":"\u25AD","reg":"\xae","REG":"\xae","ReverseElement":"\u220B","ReverseEquilibrium":"\u21CB","ReverseUpEquilibrium":"\u296F","rfisht":"\u297D","rfloor":"\u230B","rfr":"\uD835\uDD2F","Rfr":"\u211C","rHar":"\u2964","rhard":"\u21C1","rharu":"\u21C0","rharul":"\u296C","Rho":"\u03A1","rho":"\u03C1","rhov":"\u03F1","RightAngleBracket":"\u27E9","RightArrowBar":"\u21E5","rightarrow":"\u2192","RightArrow":"\u2192","Rightarrow":"\u21D2","RightArrowLeftArrow":"\u21C4","rightarrowtail":"\u21A3","RightCeiling":"\u2309","RightDoubleBracket":"\u27E7","RightDownTeeVector":"\u295D","RightDownVectorBar":"\u2955","RightDownVector":"\u21C2","RightFloor":"\u230B","rightharpoondown":"\u21C1","rightharpoonup":"\u21C0","rightleftarrows":"\u21C4","rightleftharpoons":"\u21CC","rightrightarrows":"\u21C9","rightsquigarrow":"\u219D","RightTeeArrow":"\u21A6","RightTee":"\u22A2","RightTeeVector":"\u295B","rightthreetimes":"\u22CC","RightTriangleBar":"\u29D0","RightTriangle":"\u22B3","RightTriangleEqual":"\u22B5","RightUpDownVector":"\u294F","RightUpTeeVector":"\u295C","RightUpVectorBar":"\u2954","RightUpVector":"\u21BE","RightVectorBar":"\u2953","RightVector":"\u21C0","ring":"\u02DA","risingdotseq":"\u2253","rlarr":"\u21C4","rlhar":"\u21CC","rlm":"\u200F","rmoustache":"\u23B1","rmoust":"\u23B1","rnmid":"\u2AEE","roang":"\u27ED","roarr":"\u21FE","robrk":"\u27E7","ropar":"\u2986","ropf":"\uD835\uDD63","Ropf":"\u211D","roplus":"\u2A2E","rotimes":"\u2A35","RoundImplies":"\u2970","rpar":")","rpargt":"\u2994","rppolint":"\u2A12","rrarr":"\u21C9","Rrightarrow":"\u21DB","rsaquo":"\u203A","rscr":"\uD835\uDCC7","Rscr":"\u211B","rsh":"\u21B1","Rsh":"\u21B1","rsqb":"]","rsquo":"\u2019","rsquor":"\u2019","rthree":"\u22CC","rtimes":"\u22CA","rtri":"\u25B9","rtrie":"\u22B5","rtrif":"\u25B8","rtriltri":"\u29CE","RuleDelayed":"\u29F4","ruluhar":"\u2968","rx":"\u211E","Sacute":"\u015A","sacute":"\u015B","sbquo":"\u201A","scap":"\u2AB8","Scaron":"\u0160","scaron":"\u0161","Sc":"\u2ABC","sc":"\u227B","sccue":"\u227D","sce":"\u2AB0","scE":"\u2AB4","Scedil":"\u015E","scedil":"\u015F","Scirc":"\u015C","scirc":"\u015D","scnap":"\u2ABA","scnE":"\u2AB6","scnsim":"\u22E9","scpolint":"\u2A13","scsim":"\u227F","Scy":"\u0421","scy":"\u0441","sdotb":"\u22A1","sdot":"\u22C5","sdote":"\u2A66","searhk":"\u2925","searr":"\u2198","seArr":"\u21D8","searrow":"\u2198","sect":"\xa7","semi":";","seswar":"\u2929","setminus":"\u2216","setmn":"\u2216","sext":"\u2736","Sfr":"\uD835\uDD16","sfr":"\uD835\uDD30","sfrown":"\u2322","sharp":"\u266F","SHCHcy":"\u0429","shchcy":"\u0449","SHcy":"\u0428","shcy":"\u0448","ShortDownArrow":"\u2193","ShortLeftArrow":"\u2190","shortmid":"\u2223","shortparallel":"\u2225","ShortRightArrow":"\u2192","ShortUpArrow":"\u2191","shy":"\xad","Sigma":"\u03A3","sigma":"\u03C3","sigmaf":"\u03C2","sigmav":"\u03C2","sim":"\u223C","simdot":"\u2A6A","sime":"\u2243","simeq":"\u2243","simg":"\u2A9E","simgE":"\u2AA0","siml":"\u2A9D","simlE":"\u2A9F","simne":"\u2246","simplus":"\u2A24","simrarr":"\u2972","slarr":"\u2190","SmallCircle":"\u2218","smallsetminus":"\u2216","smashp":"\u2A33","smeparsl":"\u29E4","smid":"\u2223","smile":"\u2323","smt":"\u2AAA","smte":"\u2AAC","smtes":"\u2AAC\uFE00","SOFTcy":"\u042C","softcy":"\u044C","solbar":"\u233F","solb":"\u29C4","sol":"/","Sopf":"\uD835\uDD4A","sopf":"\uD835\uDD64","spades":"\u2660","spadesuit":"\u2660","spar":"\u2225","sqcap":"\u2293","sqcaps":"\u2293\uFE00","sqcup":"\u2294","sqcups":"\u2294\uFE00","Sqrt":"\u221A","sqsub":"\u228F","sqsube":"\u2291","sqsubset":"\u228F","sqsubseteq":"\u2291","sqsup":"\u2290","sqsupe":"\u2292","sqsupset":"\u2290","sqsupseteq":"\u2292","square":"\u25A1","Square":"\u25A1","SquareIntersection":"\u2293","SquareSubset":"\u228F","SquareSubsetEqual":"\u2291","SquareSuperset":"\u2290","SquareSupersetEqual":"\u2292","SquareUnion":"\u2294","squarf":"\u25AA","squ":"\u25A1","squf":"\u25AA","srarr":"\u2192","Sscr":"\uD835\uDCAE","sscr":"\uD835\uDCC8","ssetmn":"\u2216","ssmile":"\u2323","sstarf":"\u22C6","Star":"\u22C6","star":"\u2606","starf":"\u2605","straightepsilon":"\u03F5","straightphi":"\u03D5","strns":"\xaf","sub":"\u2282","Sub":"\u22D0","subdot":"\u2ABD","subE":"\u2AC5","sube":"\u2286","subedot":"\u2AC3","submult":"\u2AC1","subnE":"\u2ACB","subne":"\u228A","subplus":"\u2ABF","subrarr":"\u2979","subset":"\u2282","Subset":"\u22D0","subseteq":"\u2286","subseteqq":"\u2AC5","SubsetEqual":"\u2286","subsetneq":"\u228A","subsetneqq":"\u2ACB","subsim":"\u2AC7","subsub":"\u2AD5","subsup":"\u2AD3","succapprox":"\u2AB8","succ":"\u227B","succcurlyeq":"\u227D","Succeeds":"\u227B","SucceedsEqual":"\u2AB0","SucceedsSlantEqual":"\u227D","SucceedsTilde":"\u227F","succeq":"\u2AB0","succnapprox":"\u2ABA","succneqq":"\u2AB6","succnsim":"\u22E9","succsim":"\u227F","SuchThat":"\u220B","sum":"\u2211","Sum":"\u2211","sung":"\u266A","sup1":"\xb9","sup2":"\xb2","sup3":"\xb3","sup":"\u2283","Sup":"\u22D1","supdot":"\u2ABE","supdsub":"\u2AD8","supE":"\u2AC6","supe":"\u2287","supedot":"\u2AC4","Superset":"\u2283","SupersetEqual":"\u2287","suphsol":"\u27C9","suphsub":"\u2AD7","suplarr":"\u297B","supmult":"\u2AC2","supnE":"\u2ACC","supne":"\u228B","supplus":"\u2AC0","supset":"\u2283","Supset":"\u22D1","supseteq":"\u2287","supseteqq":"\u2AC6","supsetneq":"\u228B","supsetneqq":"\u2ACC","supsim":"\u2AC8","supsub":"\u2AD4","supsup":"\u2AD6","swarhk":"\u2926","swarr":"\u2199","swArr":"\u21D9","swarrow":"\u2199","swnwar":"\u292A","szlig":"\xdf","Tab":"\\t","target":"\u2316","Tau":"\u03A4","tau":"\u03C4","tbrk":"\u23B4","Tcaron":"\u0164","tcaron":"\u0165","Tcedil":"\u0162","tcedil":"\u0163","Tcy":"\u0422","tcy":"\u0442","tdot":"\u20DB","telrec":"\u2315","Tfr":"\uD835\uDD17","tfr":"\uD835\uDD31","there4":"\u2234","therefore":"\u2234","Therefore":"\u2234","Theta":"\u0398","theta":"\u03B8","thetasym":"\u03D1","thetav":"\u03D1","thickapprox":"\u2248","thicksim":"\u223C","ThickSpace":"\u205F\u200A","ThinSpace":"\u2009","thinsp":"\u2009","thkap":"\u2248","thksim":"\u223C","THORN":"\xde","thorn":"\xfe","tilde":"\u02DC","Tilde":"\u223C","TildeEqual":"\u2243","TildeFullEqual":"\u2245","TildeTilde":"\u2248","timesbar":"\u2A31","timesb":"\u22A0","times":"\xd7","timesd":"\u2A30","tint":"\u222D","toea":"\u2928","topbot":"\u2336","topcir":"\u2AF1","top":"\u22A4","Topf":"\uD835\uDD4B","topf":"\uD835\uDD65","topfork":"\u2ADA","tosa":"\u2929","tprime":"\u2034","trade":"\u2122","TRADE":"\u2122","triangle":"\u25B5","triangledown":"\u25BF","triangleleft":"\u25C3","trianglelefteq":"\u22B4","triangleq":"\u225C","triangleright":"\u25B9","trianglerighteq":"\u22B5","tridot":"\u25EC","trie":"\u225C","triminus":"\u2A3A","TripleDot":"\u20DB","triplus":"\u2A39","trisb":"\u29CD","tritime":"\u2A3B","trpezium":"\u23E2","Tscr":"\uD835\uDCAF","tscr":"\uD835\uDCC9","TScy":"\u0426","tscy":"\u0446","TSHcy":"\u040B","tshcy":"\u045B","Tstrok":"\u0166","tstrok":"\u0167","twixt":"\u226C","twoheadleftarrow":"\u219E","twoheadrightarrow":"\u21A0","Uacute":"\xda","uacute":"\xfa","uarr":"\u2191","Uarr":"\u219F","uArr":"\u21D1","Uarrocir":"\u2949","Ubrcy":"\u040E","ubrcy":"\u045E","Ubreve":"\u016C","ubreve":"\u016D","Ucirc":"\xdb","ucirc":"\xfb","Ucy":"\u0423","ucy":"\u0443","udarr":"\u21C5","Udblac":"\u0170","udblac":"\u0171","udhar":"\u296E","ufisht":"\u297E","Ufr":"\uD835\uDD18","ufr":"\uD835\uDD32","Ugrave":"\xd9","ugrave":"\xf9","uHar":"\u2963","uharl":"\u21BF","uharr":"\u21BE","uhblk":"\u2580","ulcorn":"\u231C","ulcorner":"\u231C","ulcrop":"\u230F","ultri":"\u25F8","Umacr":"\u016A","umacr":"\u016B","uml":"\xa8","UnderBar":"_","UnderBrace":"\u23DF","UnderBracket":"\u23B5","UnderParenthesis":"\u23DD","Union":"\u22C3","UnionPlus":"\u228E","Uogon":"\u0172","uogon":"\u0173","Uopf":"\uD835\uDD4C","uopf":"\uD835\uDD66","UpArrowBar":"\u2912","uparrow":"\u2191","UpArrow":"\u2191","Uparrow":"\u21D1","UpArrowDownArrow":"\u21C5","updownarrow":"\u2195","UpDownArrow":"\u2195","Updownarrow":"\u21D5","UpEquilibrium":"\u296E","upharpoonleft":"\u21BF","upharpoonright":"\u21BE","uplus":"\u228E","UpperLeftArrow":"\u2196","UpperRightArrow":"\u2197","upsi":"\u03C5","Upsi":"\u03D2","upsih":"\u03D2","Upsilon":"\u03A5","upsilon":"\u03C5","UpTeeArrow":"\u21A5","UpTee":"\u22A5","upuparrows":"\u21C8","urcorn":"\u231D","urcorner":"\u231D","urcrop":"\u230E","Uring":"\u016E","uring":"\u016F","urtri":"\u25F9","Uscr":"\uD835\uDCB0","uscr":"\uD835\uDCCA","utdot":"\u22F0","Utilde":"\u0168","utilde":"\u0169","utri":"\u25B5","utrif":"\u25B4","uuarr":"\u21C8","Uuml":"\xdc","uuml":"\xfc","uwangle":"\u29A7","vangrt":"\u299C","varepsilon":"\u03F5","varkappa":"\u03F0","varnothing":"\u2205","varphi":"\u03D5","varpi":"\u03D6","varpropto":"\u221D","varr":"\u2195","vArr":"\u21D5","varrho":"\u03F1","varsigma":"\u03C2","varsubsetneq":"\u228A\uFE00","varsubsetneqq":"\u2ACB\uFE00","varsupsetneq":"\u228B\uFE00","varsupsetneqq":"\u2ACC\uFE00","vartheta":"\u03D1","vartriangleleft":"\u22B2","vartriangleright":"\u22B3","vBar":"\u2AE8","Vbar":"\u2AEB","vBarv":"\u2AE9","Vcy":"\u0412","vcy":"\u0432","vdash":"\u22A2","vDash":"\u22A8","Vdash":"\u22A9","VDash":"\u22AB","Vdashl":"\u2AE6","veebar":"\u22BB","vee":"\u2228","Vee":"\u22C1","veeeq":"\u225A","vellip":"\u22EE","verbar":"|","Verbar":"\u2016","vert":"|","Vert":"\u2016","VerticalBar":"\u2223","VerticalLine":"|","VerticalSeparator":"\u2758","VerticalTilde":"\u2240","VeryThinSpace":"\u200A","Vfr":"\uD835\uDD19","vfr":"\uD835\uDD33","vltri":"\u22B2","vnsub":"\u2282\u20D2","vnsup":"\u2283\u20D2","Vopf":"\uD835\uDD4D","vopf":"\uD835\uDD67","vprop":"\u221D","vrtri":"\u22B3","Vscr":"\uD835\uDCB1","vscr":"\uD835\uDCCB","vsubnE":"\u2ACB\uFE00","vsubne":"\u228A\uFE00","vsupnE":"\u2ACC\uFE00","vsupne":"\u228B\uFE00","Vvdash":"\u22AA","vzigzag":"\u299A","Wcirc":"\u0174","wcirc":"\u0175","wedbar":"\u2A5F","wedge":"\u2227","Wedge":"\u22C0","wedgeq":"\u2259","weierp":"\u2118","Wfr":"\uD835\uDD1A","wfr":"\uD835\uDD34","Wopf":"\uD835\uDD4E","wopf":"\uD835\uDD68","wp":"\u2118","wr":"\u2240","wreath":"\u2240","Wscr":"\uD835\uDCB2","wscr":"\uD835\uDCCC","xcap":"\u22C2","xcirc":"\u25EF","xcup":"\u22C3","xdtri":"\u25BD","Xfr":"\uD835\uDD1B","xfr":"\uD835\uDD35","xharr":"\u27F7","xhArr":"\u27FA","Xi":"\u039E","xi":"\u03BE","xlarr":"\u27F5","xlArr":"\u27F8","xmap":"\u27FC","xnis":"\u22FB","xodot":"\u2A00","Xopf":"\uD835\uDD4F","xopf":"\uD835\uDD69","xoplus":"\u2A01","xotime":"\u2A02","xrarr":"\u27F6","xrArr":"\u27F9","Xscr":"\uD835\uDCB3","xscr":"\uD835\uDCCD","xsqcup":"\u2A06","xuplus":"\u2A04","xutri":"\u25B3","xvee":"\u22C1","xwedge":"\u22C0","Yacute":"\xdd","yacute":"\xfd","YAcy":"\u042F","yacy":"\u044F","Ycirc":"\u0176","ycirc":"\u0177","Ycy":"\u042B","ycy":"\u044B","yen":"\xa5","Yfr":"\uD835\uDD1C","yfr":"\uD835\uDD36","YIcy":"\u0407","yicy":"\u0457","Yopf":"\uD835\uDD50","yopf":"\uD835\uDD6A","Yscr":"\uD835\uDCB4","yscr":"\uD835\uDCCE","YUcy":"\u042E","yucy":"\u044E","yuml":"\xff","Yuml":"\u0178","Zacute":"\u0179","zacute":"\u017A","Zcaron":"\u017D","zcaron":"\u017E","Zcy":"\u0417","zcy":"\u0437","Zdot":"\u017B","zdot":"\u017C","zeetrf":"\u2128","ZeroWidthSpace":"\u200B","Zeta":"\u0396","zeta":"\u03B6","zfr":"\uD835\uDD37","Zfr":"\u2128","ZHcy":"\u0416","zhcy":"\u0436","zigrarr":"\u21DD","zopf":"\uD835\uDD6B","Zopf":"\u2124","Zscr":"\uD835\uDCB5","zscr":"\uD835\uDCCF","zwj":"\u200D","zwnj":"\u200C"}');

});


parcelRegister("lBnMO", function(module, exports) {

$parcel$export(module.exports, "encode", () => $fb9f8122dc284f46$export$c564cdbbe6da493, (v) => $fb9f8122dc284f46$export$c564cdbbe6da493 = v);
$parcel$export(module.exports, "decode", () => $fb9f8122dc284f46$export$2f872c0f2117be69, (v) => $fb9f8122dc284f46$export$2f872c0f2117be69 = v);
$parcel$export(module.exports, "format", () => $fb9f8122dc284f46$export$d9468344d3651243, (v) => $fb9f8122dc284f46$export$d9468344d3651243 = v);
$parcel$export(module.exports, "parse", () => $fb9f8122dc284f46$export$98e6a39c04603d36, (v) => $fb9f8122dc284f46$export$98e6a39c04603d36 = v);
var $fb9f8122dc284f46$export$c564cdbbe6da493;
var $fb9f8122dc284f46$export$2f872c0f2117be69;
var $fb9f8122dc284f46$export$d9468344d3651243;
var $fb9f8122dc284f46$export$98e6a39c04603d36;
'use strict';

$fb9f8122dc284f46$export$c564cdbbe6da493 = (parcelRequire("l8S0y"));

$fb9f8122dc284f46$export$2f872c0f2117be69 = (parcelRequire("u1yDj"));

$fb9f8122dc284f46$export$d9468344d3651243 = (parcelRequire("gc3GY"));

$fb9f8122dc284f46$export$98e6a39c04603d36 = (parcelRequire("icEsx"));

});
parcelRegister("l8S0y", function(module, exports) {
'use strict';
var $f6443d31a981371f$var$encodeCache = {};
// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function $f6443d31a981371f$var$getEncodeCache(exclude) {
    var i, ch, cache = $f6443d31a981371f$var$encodeCache[exclude];
    if (cache) return cache;
    cache = $f6443d31a981371f$var$encodeCache[exclude] = [];
    for(i = 0; i < 128; i++){
        ch = String.fromCharCode(i);
        if (/^[0-9a-z]$/i.test(ch)) // always allow unencoded alphanumeric characters
        cache.push(ch);
        else cache.push('%' + ('0' + i.toString(16).toUpperCase()).slice(-2));
    }
    for(i = 0; i < exclude.length; i++)cache[exclude.charCodeAt(i)] = exclude[i];
    return cache;
}
// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function $f6443d31a981371f$var$encode(string, exclude, keepEscaped) {
    var i, l, code, nextCode, cache, result = '';
    if (typeof exclude !== 'string') {
        // encode(string, keepEscaped)
        keepEscaped = exclude;
        exclude = $f6443d31a981371f$var$encode.defaultChars;
    }
    if (typeof keepEscaped === 'undefined') keepEscaped = true;
    cache = $f6443d31a981371f$var$getEncodeCache(exclude);
    for(i = 0, l = string.length; i < l; i++){
        code = string.charCodeAt(i);
        if (keepEscaped && code === 0x25 /* % */  && i + 2 < l) {
            if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
                result += string.slice(i, i + 3);
                i += 2;
                continue;
            }
        }
        if (code < 128) {
            result += cache[code];
            continue;
        }
        if (code >= 0xD800 && code <= 0xDFFF) {
            if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
                nextCode = string.charCodeAt(i + 1);
                if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
                    result += encodeURIComponent(string[i] + string[i + 1]);
                    i++;
                    continue;
                }
            }
            result += '%EF%BF%BD';
            continue;
        }
        result += encodeURIComponent(string[i]);
    }
    return result;
}
$f6443d31a981371f$var$encode.defaultChars = ";/?:@&=+$,-_.!~*'()#";
$f6443d31a981371f$var$encode.componentChars = "-_.!~*'()";
module.exports = $f6443d31a981371f$var$encode;

});

parcelRegister("u1yDj", function(module, exports) {
'use strict';
/* eslint-disable no-bitwise */ var $05a402c3701f248f$var$decodeCache = {};
function $05a402c3701f248f$var$getDecodeCache(exclude) {
    var i, ch, cache = $05a402c3701f248f$var$decodeCache[exclude];
    if (cache) return cache;
    cache = $05a402c3701f248f$var$decodeCache[exclude] = [];
    for(i = 0; i < 128; i++){
        ch = String.fromCharCode(i);
        cache.push(ch);
    }
    for(i = 0; i < exclude.length; i++){
        ch = exclude.charCodeAt(i);
        cache[ch] = '%' + ('0' + ch.toString(16).toUpperCase()).slice(-2);
    }
    return cache;
}
// Decode percent-encoded string.
//
function $05a402c3701f248f$var$decode(string, exclude) {
    var cache;
    if (typeof exclude !== 'string') exclude = $05a402c3701f248f$var$decode.defaultChars;
    cache = $05a402c3701f248f$var$getDecodeCache(exclude);
    return string.replace(/(%[a-f0-9]{2})+/gi, function(seq) {
        var i, l, b1, b2, b3, b4, chr, result = '';
        for(i = 0, l = seq.length; i < l; i += 3){
            b1 = parseInt(seq.slice(i + 1, i + 3), 16);
            if (b1 < 0x80) {
                result += cache[b1];
                continue;
            }
            if ((b1 & 0xE0) === 0xC0 && i + 3 < l) {
                // 110xxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                if ((b2 & 0xC0) === 0x80) {
                    chr = b1 << 6 & 0x7C0 | b2 & 0x3F;
                    if (chr < 0x80) result += '\ufffd\ufffd';
                    else result += String.fromCharCode(chr);
                    i += 3;
                    continue;
                }
            }
            if ((b1 & 0xF0) === 0xE0 && i + 6 < l) {
                // 1110xxxx 10xxxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80) {
                    chr = b1 << 12 & 0xF000 | b2 << 6 & 0xFC0 | b3 & 0x3F;
                    if (chr < 0x800 || chr >= 0xD800 && chr <= 0xDFFF) result += '\ufffd\ufffd\ufffd';
                    else result += String.fromCharCode(chr);
                    i += 6;
                    continue;
                }
            }
            if ((b1 & 0xF8) === 0xF0 && i + 9 < l) {
                // 111110xx 10xxxxxx 10xxxxxx 10xxxxxx
                b2 = parseInt(seq.slice(i + 4, i + 6), 16);
                b3 = parseInt(seq.slice(i + 7, i + 9), 16);
                b4 = parseInt(seq.slice(i + 10, i + 12), 16);
                if ((b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80 && (b4 & 0xC0) === 0x80) {
                    chr = b1 << 18 & 0x1C0000 | b2 << 12 & 0x3F000 | b3 << 6 & 0xFC0 | b4 & 0x3F;
                    if (chr < 0x10000 || chr > 0x10FFFF) result += '\ufffd\ufffd\ufffd\ufffd';
                    else {
                        chr -= 0x10000;
                        result += String.fromCharCode(0xD800 + (chr >> 10), 0xDC00 + (chr & 0x3FF));
                    }
                    i += 9;
                    continue;
                }
            }
            result += '\ufffd';
        }
        return result;
    });
}
$05a402c3701f248f$var$decode.defaultChars = ';/?:@&=+$,#';
$05a402c3701f248f$var$decode.componentChars = '';
module.exports = $05a402c3701f248f$var$decode;

});

parcelRegister("gc3GY", function(module, exports) {
'use strict';
module.exports = function format(url) {
    var result = '';
    result += url.protocol || '';
    result += url.slashes ? '//' : '';
    result += url.auth ? url.auth + '@' : '';
    if (url.hostname && url.hostname.indexOf(':') !== -1) // ipv6 address
    result += '[' + url.hostname + ']';
    else result += url.hostname || '';
    result += url.port ? ':' + url.port : '';
    result += url.pathname || '';
    result += url.search || '';
    result += url.hash || '';
    return result;
};

});

parcelRegister("icEsx", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
//
// Changes from joyent/node:
//
// 1. No leading slash in paths,
//    e.g. in `url.parse('http://foo?bar')` pathname is ``, not `/`
//
// 2. Backslashes are not replaced with slashes,
//    so `http:\\example.org\` is treated like a relative path
//
// 3. Trailing colon is treated like a part of the path,
//    i.e. in `http://example.org:foo` pathname is `:foo`
//
// 4. Nothing is URL-encoded in the resulting object,
//    (in joyent/node some chars in auth and paths are encoded)
//
// 5. `url.parse()` does not have `parseQueryString` argument
//
// 6. Removed extraneous result properties: `host`, `path`, `query`, etc.,
//    which can be constructed using other parts of the url.
//
function $d408bb5a96d68512$var$Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.pathname = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
var $d408bb5a96d68512$var$protocolPattern = /^([a-z0-9.+-]+:)/i, $d408bb5a96d68512$var$portPattern = /:[0-9]*$/, // Special case for a simple path URL
$d408bb5a96d68512$var$simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, // RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
$d408bb5a96d68512$var$delims = [
    '<',
    '>',
    '"',
    '`',
    ' ',
    '\r',
    '\n',
    '\t'
], // RFC 2396: characters not allowed for various reasons.
$d408bb5a96d68512$var$unwise = [
    '{',
    '}',
    '|',
    '\\',
    '^',
    '`'
].concat($d408bb5a96d68512$var$delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
$d408bb5a96d68512$var$autoEscape = [
    '\''
].concat($d408bb5a96d68512$var$unwise), // Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
$d408bb5a96d68512$var$nonHostChars = [
    '%',
    '/',
    '?',
    ';',
    '#'
].concat($d408bb5a96d68512$var$autoEscape), $d408bb5a96d68512$var$hostEndingChars = [
    '/',
    '?',
    '#'
], $d408bb5a96d68512$var$hostnameMaxLen = 255, $d408bb5a96d68512$var$hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, $d408bb5a96d68512$var$hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
/* eslint-disable no-script-url */ // protocols that never have a hostname.
$d408bb5a96d68512$var$hostlessProtocol = {
    'javascript': true,
    'javascript:': true
}, // protocols that always contain a // bit.
$d408bb5a96d68512$var$slashedProtocol = {
    'http': true,
    'https': true,
    'ftp': true,
    'gopher': true,
    'file': true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
};
/* eslint-enable no-script-url */ function $d408bb5a96d68512$var$urlParse(url, slashesDenoteHost) {
    if (url && url instanceof $d408bb5a96d68512$var$Url) return url;
    var u = new $d408bb5a96d68512$var$Url();
    u.parse(url, slashesDenoteHost);
    return u;
}
$d408bb5a96d68512$var$Url.prototype.parse = function(url, slashesDenoteHost) {
    var i, l, lowerProto, hec, slashes, rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        var simplePath = $d408bb5a96d68512$var$simplePathPattern.exec(rest);
        if (simplePath) {
            this.pathname = simplePath[1];
            if (simplePath[2]) this.search = simplePath[2];
            return this;
        }
    }
    var proto = $d408bb5a96d68512$var$protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        lowerProto = proto.toLowerCase();
        this.protocol = proto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && $d408bb5a96d68512$var$hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!$d408bb5a96d68512$var$hostlessProtocol[proto] && (slashes || proto && !$d408bb5a96d68512$var$slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(i = 0; i < $d408bb5a96d68512$var$hostEndingChars.length; i++){
            hec = rest.indexOf($d408bb5a96d68512$var$hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf('@');
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf('@', hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = auth;
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(i = 0; i < $d408bb5a96d68512$var$nonHostChars.length; i++){
            hec = rest.indexOf($d408bb5a96d68512$var$nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        if (rest[hostEnd - 1] === ':') hostEnd--;
        var host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost(host);
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || '';
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match($d408bb5a96d68512$var$hostnamePartPattern)) {
                    var newpart = '';
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += 'x';
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match($d408bb5a96d68512$var$hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match($d408bb5a96d68512$var$hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = notHost.join('.') + rest;
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > $d408bb5a96d68512$var$hostnameMaxLen) this.hostname = '';
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) this.hostname = this.hostname.substr(1, this.hostname.length - 2);
    }
    // chop off from the tail first.
    var hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        rest = rest.slice(0, qm);
    }
    if (rest) this.pathname = rest;
    if ($d408bb5a96d68512$var$slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = '';
    return this;
};
$d408bb5a96d68512$var$Url.prototype.parseHost = function(host) {
    var port = $d408bb5a96d68512$var$portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
module.exports = $d408bb5a96d68512$var$urlParse;

});


parcelRegister("hekrg", function(module, exports) {

$parcel$export(module.exports, "Any", () => $c8b399336172e951$export$b24b633b1364b94b, (v) => $c8b399336172e951$export$b24b633b1364b94b = v);
$parcel$export(module.exports, "Cc", () => $c8b399336172e951$export$15dafbac7aec8a57, (v) => $c8b399336172e951$export$15dafbac7aec8a57 = v);
$parcel$export(module.exports, "Cf", () => $c8b399336172e951$export$239cff0cce87eb56, (v) => $c8b399336172e951$export$239cff0cce87eb56 = v);
$parcel$export(module.exports, "P", () => $c8b399336172e951$export$56c0d5a1e737357d, (v) => $c8b399336172e951$export$56c0d5a1e737357d = v);
$parcel$export(module.exports, "Z", () => $c8b399336172e951$export$dc98b0b04f4c7758, (v) => $c8b399336172e951$export$dc98b0b04f4c7758 = v);
var $c8b399336172e951$export$b24b633b1364b94b;
var $c8b399336172e951$export$15dafbac7aec8a57;
var $c8b399336172e951$export$239cff0cce87eb56;
var $c8b399336172e951$export$56c0d5a1e737357d;
var $c8b399336172e951$export$dc98b0b04f4c7758;
'use strict';

$c8b399336172e951$export$b24b633b1364b94b = (parcelRequire("4NOMA"));

$c8b399336172e951$export$15dafbac7aec8a57 = (parcelRequire("jvFHg"));

$c8b399336172e951$export$239cff0cce87eb56 = (parcelRequire("99wGz"));

$c8b399336172e951$export$56c0d5a1e737357d = (parcelRequire("aUAJj"));

$c8b399336172e951$export$dc98b0b04f4c7758 = (parcelRequire("8UCq2"));

});
parcelRegister("99wGz", function(module, exports) {
module.exports = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804\uDCBD|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/;

});



parcelRegister("9v59Z", function(module, exports) {

$parcel$export(module.exports, "parseLinkLabel", () => $6eab0302e9dee4de$export$2a2c8612930e58d0, (v) => $6eab0302e9dee4de$export$2a2c8612930e58d0 = v);
$parcel$export(module.exports, "parseLinkDestination", () => $6eab0302e9dee4de$export$22bd24080f95f2b3, (v) => $6eab0302e9dee4de$export$22bd24080f95f2b3 = v);
$parcel$export(module.exports, "parseLinkTitle", () => $6eab0302e9dee4de$export$89650c5477a69db9, (v) => $6eab0302e9dee4de$export$89650c5477a69db9 = v);
// Just a shortcut for bulk export
var $6eab0302e9dee4de$export$2a2c8612930e58d0;
var $6eab0302e9dee4de$export$22bd24080f95f2b3;
var $6eab0302e9dee4de$export$89650c5477a69db9;
'use strict';

$6eab0302e9dee4de$export$2a2c8612930e58d0 = (parcelRequire("l6fpj"));

$6eab0302e9dee4de$export$22bd24080f95f2b3 = (parcelRequire("1Bt2k"));

$6eab0302e9dee4de$export$89650c5477a69db9 = (parcelRequire("7VVHa"));

});
parcelRegister("l6fpj", function(module, exports) {
// Parse link label
//
// this function assumes that first character ("[") already matches;
// returns the end of the label
//
'use strict';
module.exports = function parseLinkLabel(state, start, disableNested) {
    var level, found, marker, prevPos, labelEnd = -1, max = state.posMax, oldPos = state.pos;
    state.pos = start + 1;
    level = 1;
    while(state.pos < max){
        marker = state.src.charCodeAt(state.pos);
        if (marker === 0x5D /* ] */ ) {
            level--;
            if (level === 0) {
                found = true;
                break;
            }
        }
        prevPos = state.pos;
        state.md.inline.skipToken(state);
        if (marker === 0x5B /* [ */ ) {
            if (prevPos === state.pos - 1) // increase level if we find text `[`, which is not a part of any token
            level++;
            else if (disableNested) {
                state.pos = oldPos;
                return -1;
            }
        }
    }
    if (found) labelEnd = state.pos;
    // restore old state
    state.pos = oldPos;
    return labelEnd;
};

});

parcelRegister("1Bt2k", function(module, exports) {
// Parse link destination
//
'use strict';

var $1hHFA = parcelRequire("1hHFA");
var $12afc52d523c4faa$require$unescapeAll = $1hHFA.unescapeAll;
module.exports = function parseLinkDestination(str, start, max) {
    var code, level, pos = start, result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ''
    };
    if (str.charCodeAt(pos) === 0x3C /* < */ ) {
        pos++;
        while(pos < max){
            code = str.charCodeAt(pos);
            if (code === 0x0A /* \n */ ) return result;
            if (code === 0x3C /* < */ ) return result;
            if (code === 0x3E /* > */ ) {
                result.pos = pos + 1;
                result.str = $12afc52d523c4faa$require$unescapeAll(str.slice(start + 1, pos));
                result.ok = true;
                return result;
            }
            if (code === 0x5C /* \ */  && pos + 1 < max) {
                pos += 2;
                continue;
            }
            pos++;
        }
        // no closing '>'
        return result;
    }
    // this should be ... } else { ... branch
    level = 0;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === 0x20) break;
        // ascii control characters
        if (code < 0x20 || code === 0x7F) break;
        if (code === 0x5C /* \ */  && pos + 1 < max) {
            if (str.charCodeAt(pos + 1) === 0x20) break;
            pos += 2;
            continue;
        }
        if (code === 0x28 /* ( */ ) {
            level++;
            if (level > 32) return result;
        }
        if (code === 0x29 /* ) */ ) {
            if (level === 0) break;
            level--;
        }
        pos++;
    }
    if (start === pos) return result;
    if (level !== 0) return result;
    result.str = $12afc52d523c4faa$require$unescapeAll(str.slice(start, pos));
    result.pos = pos;
    result.ok = true;
    return result;
};

});

parcelRegister("7VVHa", function(module, exports) {
// Parse link title
//
'use strict';

var $1hHFA = parcelRequire("1hHFA");
var $5c6a9c5821d31c5c$require$unescapeAll = $1hHFA.unescapeAll;
module.exports = function parseLinkTitle(str, start, max) {
    var code, marker, lines = 0, pos = start, result = {
        ok: false,
        pos: 0,
        lines: 0,
        str: ''
    };
    if (pos >= max) return result;
    marker = str.charCodeAt(pos);
    if (marker !== 0x22 /* " */  && marker !== 0x27 /* ' */  && marker !== 0x28 /* ( */ ) return result;
    pos++;
    // if opening marker is "(", switch it to closing marker ")"
    if (marker === 0x28) marker = 0x29;
    while(pos < max){
        code = str.charCodeAt(pos);
        if (code === marker) {
            result.pos = pos + 1;
            result.lines = lines;
            result.str = $5c6a9c5821d31c5c$require$unescapeAll(str.slice(start + 1, pos));
            result.ok = true;
            return result;
        } else if (code === 0x28 /* ( */  && marker === 0x29 /* ) */ ) return result;
        else if (code === 0x0A) lines++;
        else if (code === 0x5C /* \ */  && pos + 1 < max) {
            pos++;
            if (str.charCodeAt(pos) === 0x0A) lines++;
        }
        pos++;
    }
    return result;
};

});


parcelRegister("69SbI", function(module, exports) {
/**
 * class Renderer
 *
 * Generates HTML from parsed token stream. Each instance has independent
 * copy of rules. Those can be rewritten with ease. Also, you can add new
 * rules if you create plugin and adds new token types.
 **/ 'use strict';

var $1hHFA = parcelRequire("1hHFA");
var $47bd9df5cb728097$require$assign = $1hHFA.assign;

var $1hHFA = parcelRequire("1hHFA");
var $47bd9df5cb728097$require$unescapeAll = $1hHFA.unescapeAll;

var $1hHFA = parcelRequire("1hHFA");
var $47bd9df5cb728097$require$escapeHtml = $1hHFA.escapeHtml;
////////////////////////////////////////////////////////////////////////////////
var $47bd9df5cb728097$var$default_rules = {};
$47bd9df5cb728097$var$default_rules.code_inline = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    return '<code' + slf.renderAttrs(token) + '>' + $47bd9df5cb728097$require$escapeHtml(token.content) + '</code>';
};
$47bd9df5cb728097$var$default_rules.code_block = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    return '<pre' + slf.renderAttrs(token) + '><code>' + $47bd9df5cb728097$require$escapeHtml(tokens[idx].content) + '</code></pre>\n';
};
$47bd9df5cb728097$var$default_rules.fence = function(tokens, idx, options, env, slf) {
    var token = tokens[idx], info = token.info ? $47bd9df5cb728097$require$unescapeAll(token.info).trim() : '', langName = '', langAttrs = '', highlighted, i, arr, tmpAttrs, tmpToken;
    if (info) {
        arr = info.split(/(\s+)/g);
        langName = arr[0];
        langAttrs = arr.slice(2).join('');
    }
    if (options.highlight) highlighted = options.highlight(token.content, langName, langAttrs) || $47bd9df5cb728097$require$escapeHtml(token.content);
    else highlighted = $47bd9df5cb728097$require$escapeHtml(token.content);
    if (highlighted.indexOf('<pre') === 0) return highlighted + '\n';
    // If language exists, inject class gently, without modifying original token.
    // May be, one day we will add .deepClone() for token and simplify this part, but
    // now we prefer to keep things local.
    if (info) {
        i = token.attrIndex('class');
        tmpAttrs = token.attrs ? token.attrs.slice() : [];
        if (i < 0) tmpAttrs.push([
            'class',
            options.langPrefix + langName
        ]);
        else {
            tmpAttrs[i] = tmpAttrs[i].slice();
            tmpAttrs[i][1] += ' ' + options.langPrefix + langName;
        }
        // Fake token just to render attributes
        tmpToken = {
            attrs: tmpAttrs
        };
        return '<pre><code' + slf.renderAttrs(tmpToken) + '>' + highlighted + '</code></pre>\n';
    }
    return '<pre><code' + slf.renderAttrs(token) + '>' + highlighted + '</code></pre>\n';
};
$47bd9df5cb728097$var$default_rules.image = function(tokens, idx, options, env, slf) {
    var token = tokens[idx];
    // "alt" attr MUST be set, even if empty. Because it's mandatory and
    // should be placed on proper position for tests.
    //
    // Replace content with actual value
    token.attrs[token.attrIndex('alt')][1] = slf.renderInlineAsText(token.children, options, env);
    return slf.renderToken(tokens, idx, options);
};
$47bd9df5cb728097$var$default_rules.hardbreak = function(tokens, idx, options /*, env */ ) {
    return options.xhtmlOut ? '<br />\n' : '<br>\n';
};
$47bd9df5cb728097$var$default_rules.softbreak = function(tokens, idx, options /*, env */ ) {
    return options.breaks ? options.xhtmlOut ? '<br />\n' : '<br>\n' : '\n';
};
$47bd9df5cb728097$var$default_rules.text = function(tokens, idx /*, options, env */ ) {
    return $47bd9df5cb728097$require$escapeHtml(tokens[idx].content);
};
$47bd9df5cb728097$var$default_rules.html_block = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
$47bd9df5cb728097$var$default_rules.html_inline = function(tokens, idx /*, options, env */ ) {
    return tokens[idx].content;
};
/**
 * new Renderer()
 *
 * Creates new [[Renderer]] instance and fill [[Renderer#rules]] with defaults.
 **/ function $47bd9df5cb728097$var$Renderer() {
    /**
   * Renderer#rules -> Object
   *
   * Contains render rules for tokens. Can be updated and extended.
   *
   * ##### Example
   *
   * ```javascript
   * var md = require('markdown-it')();
   *
   * md.renderer.rules.strong_open  = function () { return '<b>'; };
   * md.renderer.rules.strong_close = function () { return '</b>'; };
   *
   * var result = md.renderInline(...);
   * ```
   *
   * Each rule is called as independent static function with fixed signature:
   *
   * ```javascript
   * function my_token_render(tokens, idx, options, env, renderer) {
   *   // ...
   *   return renderedHTML;
   * }
   * ```
   *
   * See [source code](https://github.com/markdown-it/markdown-it/blob/master/lib/renderer.js)
   * for more details and examples.
   **/ this.rules = $47bd9df5cb728097$require$assign({}, $47bd9df5cb728097$var$default_rules);
}
/**
 * Renderer.renderAttrs(token) -> String
 *
 * Render token attributes to string.
 **/ $47bd9df5cb728097$var$Renderer.prototype.renderAttrs = function renderAttrs(token) {
    var i, l, result;
    if (!token.attrs) return '';
    result = '';
    for(i = 0, l = token.attrs.length; i < l; i++)result += ' ' + $47bd9df5cb728097$require$escapeHtml(token.attrs[i][0]) + '="' + $47bd9df5cb728097$require$escapeHtml(token.attrs[i][1]) + '"';
    return result;
};
/**
 * Renderer.renderToken(tokens, idx, options) -> String
 * - tokens (Array): list of tokens
 * - idx (Numbed): token index to render
 * - options (Object): params of parser instance
 *
 * Default token renderer. Can be overriden by custom function
 * in [[Renderer#rules]].
 **/ $47bd9df5cb728097$var$Renderer.prototype.renderToken = function renderToken(tokens, idx, options) {
    var nextToken, result = '', needLf = false, token = tokens[idx];
    // Tight list paragraphs
    if (token.hidden) return '';
    // Insert a newline between hidden paragraph and subsequent opening
    // block-level tag.
    //
    // For example, here we should insert a newline before blockquote:
    //  - a
    //    >
    //
    if (token.block && token.nesting !== -1 && idx && tokens[idx - 1].hidden) result += '\n';
    // Add token name, e.g. `<img`
    result += (token.nesting === -1 ? '</' : '<') + token.tag;
    // Encode attributes, e.g. `<img src="foo"`
    result += this.renderAttrs(token);
    // Add a slash for self-closing tags, e.g. `<img src="foo" /`
    if (token.nesting === 0 && options.xhtmlOut) result += ' /';
    // Check if we need to add a newline after this tag
    if (token.block) {
        needLf = true;
        if (token.nesting === 1) {
            if (idx + 1 < tokens.length) {
                nextToken = tokens[idx + 1];
                if (nextToken.type === 'inline' || nextToken.hidden) // Block-level tag containing an inline tag.
                //
                needLf = false;
                else if (nextToken.nesting === -1 && nextToken.tag === token.tag) // Opening tag + closing tag of the same type. E.g. `<li></li>`.
                //
                needLf = false;
            }
        }
    }
    result += needLf ? '>\n' : '>';
    return result;
};
/**
 * Renderer.renderInline(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * The same as [[Renderer.render]], but for single token of `inline` type.
 **/ $47bd9df5cb728097$var$Renderer.prototype.renderInline = function(tokens, options, env) {
    var type, result = '', rules = this.rules;
    for(var i = 0, len = tokens.length; i < len; i++){
        type = tokens[i].type;
        if (typeof rules[type] !== 'undefined') result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options);
    }
    return result;
};
/** internal
 * Renderer.renderInlineAsText(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Special kludge for image `alt` attributes to conform CommonMark spec.
 * Don't try to use it! Spec requires to show `alt` content with stripped markup,
 * instead of simple escaping.
 **/ $47bd9df5cb728097$var$Renderer.prototype.renderInlineAsText = function(tokens, options, env) {
    var result = '';
    for(var i = 0, len = tokens.length; i < len; i++){
        if (tokens[i].type === 'text') result += tokens[i].content;
        else if (tokens[i].type === 'image') result += this.renderInlineAsText(tokens[i].children, options, env);
        else if (tokens[i].type === 'softbreak') result += '\n';
    }
    return result;
};
/**
 * Renderer.render(tokens, options, env) -> String
 * - tokens (Array): list on block tokens to render
 * - options (Object): params of parser instance
 * - env (Object): additional data from parsed input (references, for example)
 *
 * Takes token stream and generates HTML. Probably, you will never need to call
 * this method directly.
 **/ $47bd9df5cb728097$var$Renderer.prototype.render = function(tokens, options, env) {
    var i, len, type, result = '', rules = this.rules;
    for(i = 0, len = tokens.length; i < len; i++){
        type = tokens[i].type;
        if (type === 'inline') result += this.renderInline(tokens[i].children, options, env);
        else if (typeof rules[type] !== 'undefined') result += rules[type](tokens, i, options, env, this);
        else result += this.renderToken(tokens, i, options, env);
    }
    return result;
};
module.exports = $47bd9df5cb728097$var$Renderer;

});

parcelRegister("6TpVm", function(module, exports) {
/** internal
 * class Core
 *
 * Top-level rules executor. Glues block/inline parsers and does intermediate
 * transformations.
 **/ 'use strict';

var $1zIbC = parcelRequire("1zIbC");







var $504bfd1c7a793597$var$_rules = [
    [
        'normalize',
        (parcelRequire("hhGGw"))
    ],
    [
        'block',
        (parcelRequire("7cDia"))
    ],
    [
        'inline',
        (parcelRequire("8kW23"))
    ],
    [
        'linkify',
        (parcelRequire("uH9oV"))
    ],
    [
        'replacements',
        (parcelRequire("6Mwvm"))
    ],
    [
        'smartquotes',
        (parcelRequire("iqrgq"))
    ],
    // `text_join` finds `text_special` tokens (for escape sequences)
    // and joins them with the rest of the text
    [
        'text_join',
        (parcelRequire("k18Xo"))
    ]
];
/**
 * new Core()
 **/ function $504bfd1c7a793597$var$Core() {
    /**
   * Core#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of core rules.
   **/ this.ruler = new $1zIbC();
    for(var i = 0; i < $504bfd1c7a793597$var$_rules.length; i++)this.ruler.push($504bfd1c7a793597$var$_rules[i][0], $504bfd1c7a793597$var$_rules[i][1]);
}
/**
 * Core.process(state)
 *
 * Executes core chain rules.
 **/ $504bfd1c7a793597$var$Core.prototype.process = function(state) {
    var i, l, rules;
    rules = this.ruler.getRules('');
    for(i = 0, l = rules.length; i < l; i++)rules[i](state);
};

$504bfd1c7a793597$var$Core.prototype.State = (parcelRequire("jCV7e"));
module.exports = $504bfd1c7a793597$var$Core;

});
parcelRegister("1zIbC", function(module, exports) {
/**
 * class Ruler
 *
 * Helper class, used by [[MarkdownIt#core]], [[MarkdownIt#block]] and
 * [[MarkdownIt#inline]] to manage sequences of functions (rules):
 *
 * - keep rules in defined order
 * - assign the name to each rule
 * - enable/disable rules
 * - add/replace rules
 * - allow assign rules to additional named chains (in the same)
 * - cacheing lists of active rules
 *
 * You will not need use this class directly until write plugins. For simple
 * rules control use [[MarkdownIt.disable]], [[MarkdownIt.enable]] and
 * [[MarkdownIt.use]].
 **/ 'use strict';
/**
 * new Ruler()
 **/ function $125b55d9e7ef92fe$var$Ruler() {
    // List of added rules. Each element is:
    //
    // {
    //   name: XXX,
    //   enabled: Boolean,
    //   fn: Function(),
    //   alt: [ name2, name3 ]
    // }
    //
    this.__rules__ = [];
    // Cached rule chains.
    //
    // First level - chain name, '' for default.
    // Second level - diginal anchor for fast filtering by charcodes.
    //
    this.__cache__ = null;
}
////////////////////////////////////////////////////////////////////////////////
// Helper methods, should not be used directly
// Find rule index by name
//
$125b55d9e7ef92fe$var$Ruler.prototype.__find__ = function(name) {
    for(var i = 0; i < this.__rules__.length; i++){
        if (this.__rules__[i].name === name) return i;
    }
    return -1;
};
// Build rules lookup cache
//
$125b55d9e7ef92fe$var$Ruler.prototype.__compile__ = function() {
    var self = this;
    var chains = [
        ''
    ];
    // collect unique names
    self.__rules__.forEach(function(rule) {
        if (!rule.enabled) return;
        rule.alt.forEach(function(altName) {
            if (chains.indexOf(altName) < 0) chains.push(altName);
        });
    });
    self.__cache__ = {};
    chains.forEach(function(chain) {
        self.__cache__[chain] = [];
        self.__rules__.forEach(function(rule) {
            if (!rule.enabled) return;
            if (chain && rule.alt.indexOf(chain) < 0) return;
            self.__cache__[chain].push(rule.fn);
        });
    });
};
/**
 * Ruler.at(name, fn [, options])
 * - name (String): rule name to replace.
 * - fn (Function): new rule function.
 * - options (Object): new rule options (not mandatory).
 *
 * Replace rule by name with new function & options. Throws error if name not
 * found.
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * Replace existing typographer replacement rule with new one:
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.at('replacements', function replace(state) {
 *   //...
 * });
 * ```
 **/ $125b55d9e7ef92fe$var$Ruler.prototype.at = function(name, fn, options) {
    var index = this.__find__(name);
    var opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + name);
    this.__rules__[index].fn = fn;
    this.__rules__[index].alt = opt.alt || [];
    this.__cache__ = null;
};
/**
 * Ruler.before(beforeName, ruleName, fn [, options])
 * - beforeName (String): new rule will be added before this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain before one with given name. See also
 * [[Ruler.after]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.block.ruler.before('paragraph', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $125b55d9e7ef92fe$var$Ruler.prototype.before = function(beforeName, ruleName, fn, options) {
    var index = this.__find__(beforeName);
    var opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + beforeName);
    this.__rules__.splice(index, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.after(afterName, ruleName, fn [, options])
 * - afterName (String): new rule will be added after this one.
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Add new rule to chain after one with given name. See also
 * [[Ruler.before]], [[Ruler.push]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.inline.ruler.after('text', 'my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $125b55d9e7ef92fe$var$Ruler.prototype.after = function(afterName, ruleName, fn, options) {
    var index = this.__find__(afterName);
    var opt = options || {};
    if (index === -1) throw new Error('Parser rule not found: ' + afterName);
    this.__rules__.splice(index + 1, 0, {
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.push(ruleName, fn [, options])
 * - ruleName (String): name of added rule.
 * - fn (Function): rule function.
 * - options (Object): rule options (not mandatory).
 *
 * Push new rule to the end of chain. See also
 * [[Ruler.before]], [[Ruler.after]].
 *
 * ##### Options:
 *
 * - __alt__ - array with names of "alternate" chains.
 *
 * ##### Example
 *
 * ```javascript
 * var md = require('markdown-it')();
 *
 * md.core.ruler.push('my_rule', function replace(state) {
 *   //...
 * });
 * ```
 **/ $125b55d9e7ef92fe$var$Ruler.prototype.push = function(ruleName, fn, options) {
    var opt = options || {};
    this.__rules__.push({
        name: ruleName,
        enabled: true,
        fn: fn,
        alt: opt.alt || []
    });
    this.__cache__ = null;
};
/**
 * Ruler.enable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to enable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.disable]], [[Ruler.enableOnly]].
 **/ $125b55d9e7ef92fe$var$Ruler.prototype.enable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    var result = [];
    // Search by name and enable
    list.forEach(function(name) {
        var idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error('Rules manager: invalid rule name ' + name);
        }
        this.__rules__[idx].enabled = true;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.enableOnly(list [, ignoreInvalid])
 * - list (String|Array): list of rule names to enable (whitelist).
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Enable rules with given names, and disable everything else. If any rule name
 * not found - throw Error. Errors can be disabled by second param.
 *
 * See also [[Ruler.disable]], [[Ruler.enable]].
 **/ $125b55d9e7ef92fe$var$Ruler.prototype.enableOnly = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    this.__rules__.forEach(function(rule) {
        rule.enabled = false;
    });
    this.enable(list, ignoreInvalid);
};
/**
 * Ruler.disable(list [, ignoreInvalid]) -> Array
 * - list (String|Array): list of rule names to disable.
 * - ignoreInvalid (Boolean): set `true` to ignore errors when rule not found.
 *
 * Disable rules with given names. If any rule name not found - throw Error.
 * Errors can be disabled by second param.
 *
 * Returns list of found rule names (if no exception happened).
 *
 * See also [[Ruler.enable]], [[Ruler.enableOnly]].
 **/ $125b55d9e7ef92fe$var$Ruler.prototype.disable = function(list, ignoreInvalid) {
    if (!Array.isArray(list)) list = [
        list
    ];
    var result = [];
    // Search by name and disable
    list.forEach(function(name) {
        var idx = this.__find__(name);
        if (idx < 0) {
            if (ignoreInvalid) return;
            throw new Error('Rules manager: invalid rule name ' + name);
        }
        this.__rules__[idx].enabled = false;
        result.push(name);
    }, this);
    this.__cache__ = null;
    return result;
};
/**
 * Ruler.getRules(chainName) -> Array
 *
 * Return array of active functions (rules) for given chain name. It analyzes
 * rules configuration, compiles caches if not exists and returns result.
 *
 * Default chain name is `''` (empty string). It can't be skipped. That's
 * done intentionally, to keep signature monomorphic for high speed.
 **/ $125b55d9e7ef92fe$var$Ruler.prototype.getRules = function(chainName) {
    if (this.__cache__ === null) this.__compile__();
    // Chain can be empty, if rules disabled. But we still have to return Array.
    return this.__cache__[chainName] || [];
};
module.exports = $125b55d9e7ef92fe$var$Ruler;

});

parcelRegister("hhGGw", function(module, exports) {
// Normalize input string
'use strict';
// https://spec.commonmark.org/0.29/#line-ending
var $c95522817ff6c635$var$NEWLINES_RE = /\r\n?|\n/g;
var $c95522817ff6c635$var$NULL_RE = /\0/g;
module.exports = function normalize(state) {
    var str;
    // Normalize newlines
    str = state.src.replace($c95522817ff6c635$var$NEWLINES_RE, '\n');
    // Replace NULL characters
    str = str.replace($c95522817ff6c635$var$NULL_RE, '\uFFFD');
    state.src = str;
};

});

parcelRegister("7cDia", function(module, exports) {
'use strict';
module.exports = function block(state) {
    var token;
    if (state.inlineMode) {
        token = new state.Token('inline', '', 0);
        token.content = state.src;
        token.map = [
            0,
            1
        ];
        token.children = [];
        state.tokens.push(token);
    } else state.md.block.parse(state.src, state.md, state.env, state.tokens);
};

});

parcelRegister("8kW23", function(module, exports) {
'use strict';
module.exports = function inline(state) {
    var tokens = state.tokens, tok, i, l;
    // Parse inlines
    for(i = 0, l = tokens.length; i < l; i++){
        tok = tokens[i];
        if (tok.type === 'inline') state.md.inline.parse(tok.content, state.md, state.env, tok.children);
    }
};

});

parcelRegister("uH9oV", function(module, exports) {
// Replace link-like texts with link nodes.
//
// Currently restricted by `md.validateLink()` to http/https/ftp
//
'use strict';

var $1hHFA = parcelRequire("1hHFA");
var $05c44645e0c5e0cb$require$arrayReplaceAt = $1hHFA.arrayReplaceAt;
function $05c44645e0c5e0cb$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $05c44645e0c5e0cb$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
module.exports = function linkify(state) {
    var i, j, l, tokens, token, currentToken, nodes, ln, text, pos, lastPos, level, htmlLinkLevel, url, fullUrl, urlText, blockTokens = state.tokens, links;
    if (!state.md.options.linkify) return;
    for(j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline' || !state.md.linkify.pretest(blockTokens[j].content)) continue;
        tokens = blockTokens[j].children;
        htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(i = tokens.length - 1; i >= 0; i--){
            currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === 'link_close') {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === 'html_inline') {
                if ($05c44645e0c5e0cb$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($05c44645e0c5e0cb$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === 'text' && state.md.linkify.test(currentToken.content)) {
                text = currentToken.content;
                links = state.md.linkify.match(text);
                // Now split string to nodes
                nodes = [];
                level = currentToken.level;
                lastPos = 0;
                // forbid escape sequence at the start of the string,
                // this avoids http\://example.com/ from being linkified as
                // http:<a href="//example.com/">//example.com/</a>
                if (links.length > 0 && links[0].index === 0 && i > 0 && tokens[i - 1].type === 'text_special') links = links.slice(1);
                for(ln = 0; ln < links.length; ln++){
                    url = links[ln].url;
                    fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                    else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                    else urlText = state.md.normalizeLinkText(urlText);
                    pos = links[ln].index;
                    if (pos > lastPos) {
                        token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    token = new state.Token('link_open', 'a', 1);
                    token.attrs = [
                        [
                            'href',
                            fullUrl
                        ]
                    ];
                    token.level = level++;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    token = new state.Token('text', '', 0);
                    token.content = urlText;
                    token.level = level;
                    nodes.push(token);
                    token = new state.Token('link_close', 'a', -1);
                    token.level = --level;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    token = new state.Token('text', '', 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = $05c44645e0c5e0cb$require$arrayReplaceAt(tokens, i, nodes);
            }
        }
    }
};

});

parcelRegister("6Mwvm", function(module, exports) {
// Simple typographic replacements
//
// (c) (C) → ©
// (tm) (TM) → ™
// (r) (R) → ®
// +- → ±
// ... → … (also ?.... → ?.., !.... → !..)
// ???????? → ???, !!!!! → !!!, `,,` → `,`
// -- → &ndash;, --- → &mdash;
//
'use strict';
// TODO:
// - fractionals 1/2, 1/4, 3/4 -> ½, ¼, ¾
// - multiplications 2 x 4 -> 2 × 4
var $4f00708c71ea50cf$var$RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;
// Workaround for phantomjs - need regex without /g flag,
// or root check will fail every second time
var $4f00708c71ea50cf$var$SCOPED_ABBR_TEST_RE = /\((c|tm|r)\)/i;
var $4f00708c71ea50cf$var$SCOPED_ABBR_RE = /\((c|tm|r)\)/ig;
var $4f00708c71ea50cf$var$SCOPED_ABBR = {
    c: "\xa9",
    r: "\xae",
    tm: "\u2122"
};
function $4f00708c71ea50cf$var$replaceFn(match, name) {
    return $4f00708c71ea50cf$var$SCOPED_ABBR[name.toLowerCase()];
}
function $4f00708c71ea50cf$var$replace_scoped(inlineTokens) {
    var i, token, inside_autolink = 0;
    for(i = inlineTokens.length - 1; i >= 0; i--){
        token = inlineTokens[i];
        if (token.type === 'text' && !inside_autolink) token.content = token.content.replace($4f00708c71ea50cf$var$SCOPED_ABBR_RE, $4f00708c71ea50cf$var$replaceFn);
        if (token.type === 'link_open' && token.info === 'auto') inside_autolink--;
        if (token.type === 'link_close' && token.info === 'auto') inside_autolink++;
    }
}
function $4f00708c71ea50cf$var$replace_rare(inlineTokens) {
    var i, token, inside_autolink = 0;
    for(i = inlineTokens.length - 1; i >= 0; i--){
        token = inlineTokens[i];
        if (token.type === 'text' && !inside_autolink) {
            if ($4f00708c71ea50cf$var$RARE_RE.test(token.content)) token.content = token.content.replace(/\+-/g, "\xb1")// .., ..., ....... -> …
            // but ?..... & !..... -> ?.. & !..
            .replace(/\.{2,}/g, "\u2026").replace(/([?!])…/g, '$1..').replace(/([?!]){4,}/g, '$1$1$1').replace(/,{2,}/g, ',')// em-dash
            .replace(/(^|[^-])---(?=[^-]|$)/mg, '$1\u2014')// en-dash
            .replace(/(^|\s)--(?=\s|$)/mg, '$1\u2013').replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, '$1\u2013');
        }
        if (token.type === 'link_open' && token.info === 'auto') inside_autolink--;
        if (token.type === 'link_close' && token.info === 'auto') inside_autolink++;
    }
}
module.exports = function replace(state) {
    var blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== 'inline') continue;
        if ($4f00708c71ea50cf$var$SCOPED_ABBR_TEST_RE.test(state.tokens[blkIdx].content)) $4f00708c71ea50cf$var$replace_scoped(state.tokens[blkIdx].children);
        if ($4f00708c71ea50cf$var$RARE_RE.test(state.tokens[blkIdx].content)) $4f00708c71ea50cf$var$replace_rare(state.tokens[blkIdx].children);
    }
};

});

parcelRegister("iqrgq", function(module, exports) {
// Convert straight quotation marks to typographic ones
//
'use strict';

var $1hHFA = parcelRequire("1hHFA");
var $d69fcdc39a910594$require$isWhiteSpace = $1hHFA.isWhiteSpace;

var $1hHFA = parcelRequire("1hHFA");
var $d69fcdc39a910594$require$isPunctChar = $1hHFA.isPunctChar;

var $1hHFA = parcelRequire("1hHFA");
var $d69fcdc39a910594$require$isMdAsciiPunct = $1hHFA.isMdAsciiPunct;
var $d69fcdc39a910594$var$QUOTE_TEST_RE = /['"]/;
var $d69fcdc39a910594$var$QUOTE_RE = /['"]/g;
var $d69fcdc39a910594$var$APOSTROPHE = '\u2019'; /* ’ */ 
function $d69fcdc39a910594$var$replaceAt(str, index, ch) {
    return str.slice(0, index) + ch + str.slice(index + 1);
}
function $d69fcdc39a910594$var$process_inlines(tokens, state) {
    var i, token, text, t, pos, max, thisLevel, item, lastChar, nextChar, isLastPunctChar, isNextPunctChar, isLastWhiteSpace, isNextWhiteSpace, canOpen, canClose, j, isSingle, stack, openQuote, closeQuote;
    stack = [];
    for(i = 0; i < tokens.length; i++){
        token = tokens[i];
        thisLevel = tokens[i].level;
        for(j = stack.length - 1; j >= 0; j--){
            if (stack[j].level <= thisLevel) break;
        }
        stack.length = j + 1;
        if (token.type !== 'text') continue;
        text = token.content;
        pos = 0;
        max = text.length;
        /*eslint no-labels:0,block-scoped-var:0*/ OUTER: while(pos < max){
            $d69fcdc39a910594$var$QUOTE_RE.lastIndex = pos;
            t = $d69fcdc39a910594$var$QUOTE_RE.exec(text);
            if (!t) break;
            canOpen = canClose = true;
            pos = t.index + 1;
            isSingle = t[0] === "'";
            // Find previous character,
            // default to space if it's the beginning of the line
            //
            lastChar = 0x20;
            if (t.index - 1 >= 0) lastChar = text.charCodeAt(t.index - 1);
            else for(j = i - 1; j >= 0; j--){
                if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // lastChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                lastChar = tokens[j].content.charCodeAt(tokens[j].content.length - 1);
                break;
            }
            // Find next character,
            // default to space if it's the end of the line
            //
            nextChar = 0x20;
            if (pos < max) nextChar = text.charCodeAt(pos);
            else for(j = i + 1; j < tokens.length; j++){
                if (tokens[j].type === 'softbreak' || tokens[j].type === 'hardbreak') break; // nextChar defaults to 0x20
                if (!tokens[j].content) continue; // should skip all tokens except 'text', 'html_inline' or 'code_inline'
                nextChar = tokens[j].content.charCodeAt(0);
                break;
            }
            isLastPunctChar = $d69fcdc39a910594$require$isMdAsciiPunct(lastChar) || $d69fcdc39a910594$require$isPunctChar(String.fromCharCode(lastChar));
            isNextPunctChar = $d69fcdc39a910594$require$isMdAsciiPunct(nextChar) || $d69fcdc39a910594$require$isPunctChar(String.fromCharCode(nextChar));
            isLastWhiteSpace = $d69fcdc39a910594$require$isWhiteSpace(lastChar);
            isNextWhiteSpace = $d69fcdc39a910594$require$isWhiteSpace(nextChar);
            if (isNextWhiteSpace) canOpen = false;
            else if (isNextPunctChar) {
                if (!(isLastWhiteSpace || isLastPunctChar)) canOpen = false;
            }
            if (isLastWhiteSpace) canClose = false;
            else if (isLastPunctChar) {
                if (!(isNextWhiteSpace || isNextPunctChar)) canClose = false;
            }
            if (nextChar === 0x22 /* " */  && t[0] === '"') {
                if (lastChar >= 0x30 /* 0 */  && lastChar <= 0x39 /* 9 */ ) // special case: 1"" - count first quote as an inch
                canClose = canOpen = false;
            }
            if (canOpen && canClose) {
                // Replace quotes in the middle of punctuation sequence, but not
                // in the middle of the words, i.e.:
                //
                // 1. foo " bar " baz - not replaced
                // 2. foo-"-bar-"-baz - replaced
                // 3. foo"bar"baz     - not replaced
                //
                canOpen = isLastPunctChar;
                canClose = isNextPunctChar;
            }
            if (!canOpen && !canClose) {
                // middle of word
                if (isSingle) token.content = $d69fcdc39a910594$var$replaceAt(token.content, t.index, $d69fcdc39a910594$var$APOSTROPHE);
                continue;
            }
            if (canClose) // this could be a closing quote, rewind the stack to get a match
            for(j = stack.length - 1; j >= 0; j--){
                item = stack[j];
                if (stack[j].level < thisLevel) break;
                if (item.single === isSingle && stack[j].level === thisLevel) {
                    item = stack[j];
                    if (isSingle) {
                        openQuote = state.md.options.quotes[2];
                        closeQuote = state.md.options.quotes[3];
                    } else {
                        openQuote = state.md.options.quotes[0];
                        closeQuote = state.md.options.quotes[1];
                    }
                    // replace token.content *before* tokens[item.token].content,
                    // because, if they are pointing at the same token, replaceAt
                    // could mess up indices when quote length != 1
                    token.content = $d69fcdc39a910594$var$replaceAt(token.content, t.index, closeQuote);
                    tokens[item.token].content = $d69fcdc39a910594$var$replaceAt(tokens[item.token].content, item.pos, openQuote);
                    pos += closeQuote.length - 1;
                    if (item.token === i) pos += openQuote.length - 1;
                    text = token.content;
                    max = text.length;
                    stack.length = j;
                    continue OUTER;
                }
            }
            if (canOpen) stack.push({
                token: i,
                pos: t.index,
                single: isSingle,
                level: thisLevel
            });
            else if (canClose && isSingle) token.content = $d69fcdc39a910594$var$replaceAt(token.content, t.index, $d69fcdc39a910594$var$APOSTROPHE);
        }
    }
}
module.exports = function smartquotes(state) {
    /*eslint max-depth:0*/ var blkIdx;
    if (!state.md.options.typographer) return;
    for(blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--){
        if (state.tokens[blkIdx].type !== 'inline' || !$d69fcdc39a910594$var$QUOTE_TEST_RE.test(state.tokens[blkIdx].content)) continue;
        $d69fcdc39a910594$var$process_inlines(state.tokens[blkIdx].children, state);
    }
};

});

parcelRegister("k18Xo", function(module, exports) {
// Join raw text tokens with the rest of the text
//
// This is set as a separate rule to provide an opportunity for plugins
// to run text replacements after text join, but before escape join.
//
// For example, `\:)` shouldn't be replaced with an emoji.
//
'use strict';
module.exports = function text_join(state) {
    var j, l, tokens, curr, max, last, blockTokens = state.tokens;
    for(j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline') continue;
        tokens = blockTokens[j].children;
        max = tokens.length;
        for(curr = 0; curr < max; curr++)if (tokens[curr].type === 'text_special') tokens[curr].type = 'text';
        for(curr = last = 0; curr < max; curr++)if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
        if (curr !== last) tokens.length = last;
    }
};

});

parcelRegister("jCV7e", function(module, exports) {
// Core state object
//
'use strict';

var $jvz50 = parcelRequire("jvz50");
function $e49ddee1f177a740$var$StateCore(src, md, env) {
    this.src = src;
    this.env = env;
    this.tokens = [];
    this.inlineMode = false;
    this.md = md; // link to parser instance
}
// re-export Token class to use in core rules
$e49ddee1f177a740$var$StateCore.prototype.Token = $jvz50;
module.exports = $e49ddee1f177a740$var$StateCore;

});
parcelRegister("jvz50", function(module, exports) {
// Token class
'use strict';
/**
 * class Token
 **/ /**
 * new Token(type, tag, nesting)
 *
 * Create new token and fill passed properties.
 **/ function $e33c1face6e61bfd$var$Token(type, tag, nesting) {
    /**
   * Token#type -> String
   *
   * Type of the token (string, e.g. "paragraph_open")
   **/ this.type = type;
    /**
   * Token#tag -> String
   *
   * html tag name, e.g. "p"
   **/ this.tag = tag;
    /**
   * Token#attrs -> Array
   *
   * Html attributes. Format: `[ [ name1, value1 ], [ name2, value2 ] ]`
   **/ this.attrs = null;
    /**
   * Token#map -> Array
   *
   * Source map info. Format: `[ line_begin, line_end ]`
   **/ this.map = null;
    /**
   * Token#nesting -> Number
   *
   * Level change (number in {-1, 0, 1} set), where:
   *
   * -  `1` means the tag is opening
   * -  `0` means the tag is self-closing
   * - `-1` means the tag is closing
   **/ this.nesting = nesting;
    /**
   * Token#level -> Number
   *
   * nesting level, the same as `state.level`
   **/ this.level = 0;
    /**
   * Token#children -> Array
   *
   * An array of child nodes (inline and img tokens)
   **/ this.children = null;
    /**
   * Token#content -> String
   *
   * In a case of self-closing tag (code, html, fence, etc.),
   * it has contents of this tag.
   **/ this.content = '';
    /**
   * Token#markup -> String
   *
   * '*' or '_' for emphasis, fence string for fence, etc.
   **/ this.markup = '';
    /**
   * Token#info -> String
   *
   * Additional information:
   *
   * - Info string for "fence" tokens
   * - The value "auto" for autolink "link_open" and "link_close" tokens
   * - The string value of the item marker for ordered-list "list_item_open" tokens
   **/ this.info = '';
    /**
   * Token#meta -> Object
   *
   * A place for plugins to store an arbitrary data
   **/ this.meta = null;
    /**
   * Token#block -> Boolean
   *
   * True for block-level tokens, false for inline tokens.
   * Used in renderer to calculate line breaks
   **/ this.block = false;
    /**
   * Token#hidden -> Boolean
   *
   * If it's true, ignore this element when rendering. Used for tight lists
   * to hide paragraphs.
   **/ this.hidden = false;
}
/**
 * Token.attrIndex(name) -> Number
 *
 * Search attribute index by name.
 **/ $e33c1face6e61bfd$var$Token.prototype.attrIndex = function attrIndex(name) {
    var attrs, i, len;
    if (!this.attrs) return -1;
    attrs = this.attrs;
    for(i = 0, len = attrs.length; i < len; i++){
        if (attrs[i][0] === name) return i;
    }
    return -1;
};
/**
 * Token.attrPush(attrData)
 *
 * Add `[ name, value ]` attribute to list. Init attrs if necessary
 **/ $e33c1face6e61bfd$var$Token.prototype.attrPush = function attrPush(attrData) {
    if (this.attrs) this.attrs.push(attrData);
    else this.attrs = [
        attrData
    ];
};
/**
 * Token.attrSet(name, value)
 *
 * Set `name` attribute to `value`. Override old value if exists.
 **/ $e33c1face6e61bfd$var$Token.prototype.attrSet = function attrSet(name, value) {
    var idx = this.attrIndex(name), attrData = [
        name,
        value
    ];
    if (idx < 0) this.attrPush(attrData);
    else this.attrs[idx] = attrData;
};
/**
 * Token.attrGet(name)
 *
 * Get the value of attribute `name`, or null if it does not exist.
 **/ $e33c1face6e61bfd$var$Token.prototype.attrGet = function attrGet(name) {
    var idx = this.attrIndex(name), value = null;
    if (idx >= 0) value = this.attrs[idx][1];
    return value;
};
/**
 * Token.attrJoin(name, value)
 *
 * Join value to existing attribute via space. Or create new attribute if not
 * exists. Useful to operate with token classes.
 **/ $e33c1face6e61bfd$var$Token.prototype.attrJoin = function attrJoin(name, value) {
    var idx = this.attrIndex(name);
    if (idx < 0) this.attrPush([
        name,
        value
    ]);
    else this.attrs[idx][1] = this.attrs[idx][1] + ' ' + value;
};
module.exports = $e33c1face6e61bfd$var$Token;

});



parcelRegister("y5nz9", function(module, exports) {
/** internal
 * class ParserBlock
 *
 * Block-level tokenizer.
 **/ 'use strict';

var $1zIbC = parcelRequire("1zIbC");











var $066759444633b75d$var$_rules = [
    // First 2 params - rule name & source. Secondary array - list of rules,
    // which can be terminated by this one.
    [
        'table',
        (parcelRequire("gAu1B")),
        [
            'paragraph',
            'reference'
        ]
    ],
    [
        'code',
        (parcelRequire("csp3e"))
    ],
    [
        'fence',
        (parcelRequire("ifVk6")),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'blockquote',
        (parcelRequire("epAvq")),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'hr',
        (parcelRequire("KfMuL")),
        [
            'paragraph',
            'reference',
            'blockquote',
            'list'
        ]
    ],
    [
        'list',
        (parcelRequire("8aArk")),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'reference',
        (parcelRequire("k5n8c"))
    ],
    [
        'html_block',
        (parcelRequire("jqlLt")),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'heading',
        (parcelRequire("5cRNI")),
        [
            'paragraph',
            'reference',
            'blockquote'
        ]
    ],
    [
        'lheading',
        (parcelRequire("dAykE"))
    ],
    [
        'paragraph',
        (parcelRequire("4lp3x"))
    ]
];
/**
 * new ParserBlock()
 **/ function $066759444633b75d$var$ParserBlock() {
    /**
   * ParserBlock#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of block rules.
   **/ this.ruler = new $1zIbC();
    for(var i = 0; i < $066759444633b75d$var$_rules.length; i++)this.ruler.push($066759444633b75d$var$_rules[i][0], $066759444633b75d$var$_rules[i][1], {
        alt: ($066759444633b75d$var$_rules[i][2] || []).slice()
    });
}
// Generate tokens for input range
//
$066759444633b75d$var$ParserBlock.prototype.tokenize = function(state, startLine, endLine) {
    var ok, i, prevLine, rules = this.ruler.getRules(''), len = rules.length, line = startLine, hasEmptyLines = false, maxNesting = state.md.options.maxNesting;
    while(line < endLine){
        state.line = line = state.skipEmptyLines(line);
        if (line >= endLine) break;
        // Termination condition for nested calls.
        // Nested calls currently used for blockquotes & lists
        if (state.sCount[line] < state.blkIndent) break;
        // If nesting level exceeded - skip tail to the end. That's not ordinary
        // situation and we should not care about content.
        if (state.level >= maxNesting) {
            state.line = endLine;
            break;
        }
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.line`
        // - update `state.tokens`
        // - return true
        prevLine = state.line;
        for(i = 0; i < len; i++){
            ok = rules[i](state, line, endLine, false);
            if (ok) {
                if (prevLine >= state.line) throw new Error("block rule didn't increment state.line");
                break;
            }
        }
        // this can only happen if user disables paragraph rule
        if (!ok) throw new Error('none of the block rules matched');
        // set state.tight if we had an empty line before current tag
        // i.e. latest empty line should not count
        state.tight = !hasEmptyLines;
        // paragraph might "eat" one newline after it in nested lists
        if (state.isEmpty(state.line - 1)) hasEmptyLines = true;
        line = state.line;
        if (line < endLine && state.isEmpty(line)) {
            hasEmptyLines = true;
            line++;
            state.line = line;
        }
    }
};
/**
 * ParserBlock.parse(str, md, env, outTokens)
 *
 * Process input string and push block tokens into `outTokens`
 **/ $066759444633b75d$var$ParserBlock.prototype.parse = function(src, md, env, outTokens) {
    var state;
    if (!src) return;
    state = new this.State(src, md, env, outTokens);
    this.tokenize(state, state.line, state.lineMax);
};

$066759444633b75d$var$ParserBlock.prototype.State = (parcelRequire("lh2ek"));
module.exports = $066759444633b75d$var$ParserBlock;

});
parcelRegister("gAu1B", function(module, exports) {
// GFM table, https://github.github.com/gfm/#tables-extension-
'use strict';

var $1hHFA = parcelRequire("1hHFA");
var $c1374c77c7ae8320$require$isSpace = $1hHFA.isSpace;
function $c1374c77c7ae8320$var$getLine(state, line) {
    var pos = state.bMarks[line] + state.tShift[line], max = state.eMarks[line];
    return state.src.slice(pos, max);
}
function $c1374c77c7ae8320$var$escapedSplit(str) {
    var result = [], pos = 0, max = str.length, ch, isEscaped = false, lastPos = 0, current = '';
    ch = str.charCodeAt(pos);
    while(pos < max){
        if (ch === 0x7c /* | */ ) {
            if (!isEscaped) {
                // pipe separating cells, '|'
                result.push(current + str.substring(lastPos, pos));
                current = '';
                lastPos = pos + 1;
            } else {
                // escaped pipe, '\|'
                current += str.substring(lastPos, pos - 1);
                lastPos = pos;
            }
        }
        isEscaped = ch === 0x5c /* \ */ ;
        pos++;
        ch = str.charCodeAt(pos);
    }
    result.push(current + str.substring(lastPos));
    return result;
}
module.exports = function table(state, startLine, endLine, silent) {
    var ch, lineText, pos, i, l, nextLine, columns, columnCount, token, aligns, t, tableLines, tbodyLines, oldParentType, terminate, terminatorRules, firstCh, secondCh;
    // should have at least two lines
    if (startLine + 2 > endLine) return false;
    nextLine = startLine + 1;
    if (state.sCount[nextLine] < state.blkIndent) return false;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // first character of the second line should be '|', '-', ':',
    // and no other characters are allowed but spaces;
    // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp
    pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    firstCh = state.src.charCodeAt(pos++);
    if (firstCh !== 0x7C /* | */  && firstCh !== 0x2D /* - */  && firstCh !== 0x3A /* : */ ) return false;
    if (pos >= state.eMarks[nextLine]) return false;
    secondCh = state.src.charCodeAt(pos++);
    if (secondCh !== 0x7C /* | */  && secondCh !== 0x2D /* - */  && secondCh !== 0x3A /* : */  && !$c1374c77c7ae8320$require$isSpace(secondCh)) return false;
    // if first character is '-', then second character must not be a space
    // (due to parsing ambiguity with list)
    if (firstCh === 0x2D /* - */  && $c1374c77c7ae8320$require$isSpace(secondCh)) return false;
    while(pos < state.eMarks[nextLine]){
        ch = state.src.charCodeAt(pos);
        if (ch !== 0x7C /* | */  && ch !== 0x2D /* - */  && ch !== 0x3A /* : */  && !$c1374c77c7ae8320$require$isSpace(ch)) return false;
        pos++;
    }
    lineText = $c1374c77c7ae8320$var$getLine(state, startLine + 1);
    columns = lineText.split('|');
    aligns = [];
    for(i = 0; i < columns.length; i++){
        t = columns[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === columns.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3A /* : */ ) aligns.push(t.charCodeAt(0) === 0x3A /* : */  ? 'center' : 'right');
        else if (t.charCodeAt(0) === 0x3A /* : */ ) aligns.push('left');
        else aligns.push('');
    }
    lineText = $c1374c77c7ae8320$var$getLine(state, startLine).trim();
    if (lineText.indexOf('|') === -1) return false;
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    columns = $c1374c77c7ae8320$var$escapedSplit(lineText);
    if (columns.length && columns[0] === '') columns.shift();
    if (columns.length && columns[columns.length - 1] === '') columns.pop();
    // header row will define an amount of columns in the entire table,
    // and align row should be exactly the same (the rest of the rows can differ)
    columnCount = columns.length;
    if (columnCount === 0 || columnCount !== aligns.length) return false;
    if (silent) return true;
    oldParentType = state.parentType;
    state.parentType = 'table';
    // use 'blockquote' lists for termination because it's
    // the most similar to tables
    terminatorRules = state.md.block.ruler.getRules('blockquote');
    token = state.push('table_open', 'table', 1);
    token.map = tableLines = [
        startLine,
        0
    ];
    token = state.push('thead_open', 'thead', 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    token = state.push('tr_open', 'tr', 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    for(i = 0; i < columns.length; i++){
        token = state.push('th_open', 'th', 1);
        if (aligns[i]) token.attrs = [
            [
                'style',
                'text-align:' + aligns[i]
            ]
        ];
        token = state.push('inline', '', 0);
        token.content = columns[i].trim();
        token.children = [];
        token = state.push('th_close', 'th', -1);
    }
    token = state.push('tr_close', 'tr', -1);
    token = state.push('thead_close', 'thead', -1);
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        lineText = $c1374c77c7ae8320$var$getLine(state, nextLine).trim();
        if (!lineText) break;
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        columns = $c1374c77c7ae8320$var$escapedSplit(lineText);
        if (columns.length && columns[0] === '') columns.shift();
        if (columns.length && columns[columns.length - 1] === '') columns.pop();
        if (nextLine === startLine + 2) {
            token = state.push('tbody_open', 'tbody', 1);
            token.map = tbodyLines = [
                startLine + 2,
                0
            ];
        }
        token = state.push('tr_open', 'tr', 1);
        token.map = [
            nextLine,
            nextLine + 1
        ];
        for(i = 0; i < columnCount; i++){
            token = state.push('td_open', 'td', 1);
            if (aligns[i]) token.attrs = [
                [
                    'style',
                    'text-align:' + aligns[i]
                ]
            ];
            token = state.push('inline', '', 0);
            token.content = columns[i] ? columns[i].trim() : '';
            token.children = [];
            token = state.push('td_close', 'td', -1);
        }
        token = state.push('tr_close', 'tr', -1);
    }
    if (tbodyLines) {
        token = state.push('tbody_close', 'tbody', -1);
        tbodyLines[1] = nextLine;
    }
    token = state.push('table_close', 'table', -1);
    tableLines[1] = nextLine;
    state.parentType = oldParentType;
    state.line = nextLine;
    return true;
};

});

parcelRegister("csp3e", function(module, exports) {
// Code block (4 spaces padded)
'use strict';
module.exports = function code(state, startLine, endLine /*, silent*/ ) {
    var nextLine, last, token;
    if (state.sCount[startLine] - state.blkIndent < 4) return false;
    last = nextLine = startLine + 1;
    while(nextLine < endLine){
        if (state.isEmpty(nextLine)) {
            nextLine++;
            continue;
        }
        if (state.sCount[nextLine] - state.blkIndent >= 4) {
            nextLine++;
            last = nextLine;
            continue;
        }
        break;
    }
    state.line = last;
    token = state.push('code_block', 'code', 0);
    token.content = state.getLines(startLine, last, 4 + state.blkIndent, false) + '\n';
    token.map = [
        startLine,
        state.line
    ];
    return true;
};

});

parcelRegister("ifVk6", function(module, exports) {
// fences (``` lang, ~~~ lang)
'use strict';
module.exports = function fence(state, startLine, endLine, silent) {
    var marker, len, params, nextLine, mem, token, markup, haveEndMarker = false, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (pos + 3 > max) return false;
    marker = state.src.charCodeAt(pos);
    if (marker !== 0x7E /* ~ */  && marker !== 0x60 /* ` */ ) return false;
    // scan marker length
    mem = pos;
    pos = state.skipChars(pos, marker);
    len = pos - mem;
    if (len < 3) return false;
    markup = state.src.slice(mem, pos);
    params = state.src.slice(pos, max);
    if (marker === 0x60 /* ` */ ) {
        if (params.indexOf(String.fromCharCode(marker)) >= 0) return false;
    }
    // Since start is found, we can report success here in validation mode
    if (silent) return true;
    // search end of block
    nextLine = startLine;
    for(;;){
        nextLine++;
        if (nextLine >= endLine) break;
        pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos < max && state.sCount[nextLine] < state.blkIndent) break;
        if (state.src.charCodeAt(pos) !== marker) continue;
        if (state.sCount[nextLine] - state.blkIndent >= 4) continue;
        pos = state.skipChars(pos, marker);
        // closing code fence must be at least as long as the opening one
        if (pos - mem < len) continue;
        // make sure tail has spaces only
        pos = state.skipSpaces(pos);
        if (pos < max) continue;
        haveEndMarker = true;
        break;
    }
    // If a fence has heading spaces, they should be removed from its inner block
    len = state.sCount[startLine];
    state.line = nextLine + (haveEndMarker ? 1 : 0);
    token = state.push('fence', 'code', 0);
    token.info = params;
    token.content = state.getLines(startLine + 1, nextLine, len, true);
    token.markup = markup;
    token.map = [
        startLine,
        state.line
    ];
    return true;
};

});

parcelRegister("epAvq", function(module, exports) {
// Block quotes
'use strict';

var $1hHFA = parcelRequire("1hHFA");
var $a7dfb7cf43976678$require$isSpace = $1hHFA.isSpace;
module.exports = function blockquote(state, startLine, endLine, silent) {
    var adjustTab, ch, i, initial, l, lastLineEmpty, lines, nextLine, offset, oldBMarks, oldBSCount, oldIndent, oldParentType, oldSCount, oldTShift, spaceAfterMarker, terminate, terminatorRules, token, isOutdented, oldLineMax = state.lineMax, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    // check the block quote marker
    if (state.src.charCodeAt(pos) !== 0x3E /* > */ ) return false;
    // we know that it's going to be a valid blockquote,
    // so no point trying to find the end of it in silent mode
    if (silent) return true;
    oldBMarks = [];
    oldBSCount = [];
    oldSCount = [];
    oldTShift = [];
    terminatorRules = state.md.block.ruler.getRules('blockquote');
    oldParentType = state.parentType;
    state.parentType = 'blockquote';
    // Search the end of the block
    //
    // Block ends with either:
    //  1. an empty line outside:
    //     ```
    //     > test
    //
    //     ```
    //  2. an empty line inside:
    //     ```
    //     >
    //     test
    //     ```
    //  3. another tag:
    //     ```
    //     > test
    //      - - -
    //     ```
    for(nextLine = startLine; nextLine < endLine; nextLine++){
        // check if it's outdented, i.e. it's inside list item and indented
        // less than said list item:
        //
        // ```
        // 1. anything
        //    > current blockquote
        // 2. checking this line
        // ```
        isOutdented = state.sCount[nextLine] < state.blkIndent;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        if (pos >= max) break;
        if (state.src.charCodeAt(pos++) === 0x3E /* > */  && !isOutdented) {
            // This line is inside the blockquote.
            // set offset past spaces and ">"
            initial = state.sCount[nextLine] + 1;
            // skip one optional space after '>'
            if (state.src.charCodeAt(pos) === 0x20 /* space */ ) {
                // ' >   test '
                //     ^ -- position start of line here:
                pos++;
                initial++;
                adjustTab = false;
                spaceAfterMarker = true;
            } else if (state.src.charCodeAt(pos) === 0x09 /* tab */ ) {
                spaceAfterMarker = true;
                if ((state.bsCount[nextLine] + initial) % 4 === 3) {
                    // '  >\t  test '
                    //       ^ -- position start of line here (tab has width===1)
                    pos++;
                    initial++;
                    adjustTab = false;
                } else // ' >\t  test '
                //    ^ -- position start of line here + shift bsCount slightly
                //         to make extra space appear
                adjustTab = true;
            } else spaceAfterMarker = false;
            offset = initial;
            oldBMarks.push(state.bMarks[nextLine]);
            state.bMarks[nextLine] = pos;
            while(pos < max){
                ch = state.src.charCodeAt(pos);
                if ($a7dfb7cf43976678$require$isSpace(ch)) {
                    if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine] + (adjustTab ? 1 : 0)) % 4;
                    else offset++;
                } else break;
                pos++;
            }
            lastLineEmpty = pos >= max;
            oldBSCount.push(state.bsCount[nextLine]);
            state.bsCount[nextLine] = state.sCount[nextLine] + 1 + (spaceAfterMarker ? 1 : 0);
            oldSCount.push(state.sCount[nextLine]);
            state.sCount[nextLine] = offset - initial;
            oldTShift.push(state.tShift[nextLine]);
            state.tShift[nextLine] = pos - state.bMarks[nextLine];
            continue;
        }
        // Case 2: line is not inside the blockquote, and the last line was empty.
        if (lastLineEmpty) break;
        // Case 3: another tag found.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) {
            // Quirk to enforce "hard termination mode" for paragraphs;
            // normally if you call `tokenize(state, startLine, nextLine)`,
            // paragraphs will look below nextLine for paragraph continuation,
            // but if blockquote is terminated by another tag, they shouldn't
            state.lineMax = nextLine;
            if (state.blkIndent !== 0) {
                // state.blkIndent was non-zero, we now set it to zero,
                // so we need to re-calculate all offsets to appear as
                // if indent wasn't changed
                oldBMarks.push(state.bMarks[nextLine]);
                oldBSCount.push(state.bsCount[nextLine]);
                oldTShift.push(state.tShift[nextLine]);
                oldSCount.push(state.sCount[nextLine]);
                state.sCount[nextLine] -= state.blkIndent;
            }
            break;
        }
        oldBMarks.push(state.bMarks[nextLine]);
        oldBSCount.push(state.bsCount[nextLine]);
        oldTShift.push(state.tShift[nextLine]);
        oldSCount.push(state.sCount[nextLine]);
        // A negative indentation means that this is a paragraph continuation
        //
        state.sCount[nextLine] = -1;
    }
    oldIndent = state.blkIndent;
    state.blkIndent = 0;
    token = state.push('blockquote_open', 'blockquote', 1);
    token.markup = '>';
    token.map = lines = [
        startLine,
        0
    ];
    state.md.block.tokenize(state, startLine, nextLine);
    token = state.push('blockquote_close', 'blockquote', -1);
    token.markup = '>';
    state.lineMax = oldLineMax;
    state.parentType = oldParentType;
    lines[1] = state.line;
    // Restore original tShift; this might not be necessary since the parser
    // has already been here, but just to make sure we can do that.
    for(i = 0; i < oldTShift.length; i++){
        state.bMarks[i + startLine] = oldBMarks[i];
        state.tShift[i + startLine] = oldTShift[i];
        state.sCount[i + startLine] = oldSCount[i];
        state.bsCount[i + startLine] = oldBSCount[i];
    }
    state.blkIndent = oldIndent;
    return true;
};

});

parcelRegister("KfMuL", function(module, exports) {
// Horizontal rule
'use strict';

var $1hHFA = parcelRequire("1hHFA");
var $08b089ce6baff7b6$require$isSpace = $1hHFA.isSpace;
module.exports = function hr(state, startLine, endLine, silent) {
    var marker, cnt, ch, token, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    marker = state.src.charCodeAt(pos++);
    // Check hr marker
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x5F /* _ */ ) return false;
    // markers can be mixed with spaces, but there should be at least 3 of them
    cnt = 1;
    while(pos < max){
        ch = state.src.charCodeAt(pos++);
        if (ch !== marker && !$08b089ce6baff7b6$require$isSpace(ch)) return false;
        if (ch === marker) cnt++;
    }
    if (cnt < 3) return false;
    if (silent) return true;
    state.line = startLine + 1;
    token = state.push('hr', 'hr', 0);
    token.map = [
        startLine,
        state.line
    ];
    token.markup = Array(cnt + 1).join(String.fromCharCode(marker));
    return true;
};

});

parcelRegister("8aArk", function(module, exports) {
// Lists
'use strict';

var $1hHFA = parcelRequire("1hHFA");
var $5f2b86195f70d047$require$isSpace = $1hHFA.isSpace;
// Search `[-+*][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $5f2b86195f70d047$var$skipBulletListMarker(state, startLine) {
    var marker, pos, max, ch;
    pos = state.bMarks[startLine] + state.tShift[startLine];
    max = state.eMarks[startLine];
    marker = state.src.charCodeAt(pos++);
    // Check bullet
    if (marker !== 0x2A /* * */  && marker !== 0x2D /* - */  && marker !== 0x2B /* + */ ) return -1;
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!$5f2b86195f70d047$require$isSpace(ch)) // " -test " - is not a list item
        return -1;
    }
    return pos;
}
// Search `\d+[.)][\n ]`, returns next pos after marker on success
// or -1 on fail.
function $5f2b86195f70d047$var$skipOrderedListMarker(state, startLine) {
    var ch, start = state.bMarks[startLine] + state.tShift[startLine], pos = start, max = state.eMarks[startLine];
    // List marker should have at least 2 chars (digit + dot)
    if (pos + 1 >= max) return -1;
    ch = state.src.charCodeAt(pos++);
    if (ch < 0x30 /* 0 */  || ch > 0x39 /* 9 */ ) return -1;
    for(;;){
        // EOL -> fail
        if (pos >= max) return -1;
        ch = state.src.charCodeAt(pos++);
        if (ch >= 0x30 /* 0 */  && ch <= 0x39 /* 9 */ ) {
            // List marker should have no more than 9 digits
            // (prevents integer overflow in browsers)
            if (pos - start >= 10) return -1;
            continue;
        }
        // found valid marker
        if (ch === 0x29 /* ) */  || ch === 0x2e /* . */ ) break;
        return -1;
    }
    if (pos < max) {
        ch = state.src.charCodeAt(pos);
        if (!$5f2b86195f70d047$require$isSpace(ch)) // " 1.test " - is not a list item
        return -1;
    }
    return pos;
}
function $5f2b86195f70d047$var$markTightParagraphs(state, idx) {
    var i, l, level = state.level + 2;
    for(i = idx + 2, l = state.tokens.length - 2; i < l; i++)if (state.tokens[i].level === level && state.tokens[i].type === 'paragraph_open') {
        state.tokens[i + 2].hidden = true;
        state.tokens[i].hidden = true;
        i += 2;
    }
}
module.exports = function list(state, startLine, endLine, silent) {
    var ch, contentStart, i, indent, indentAfterMarker, initial, isOrdered, itemLines, l, listLines, listTokIdx, markerCharCode, markerValue, max, offset, oldListIndent, oldParentType, oldSCount, oldTShift, oldTight, pos, posAfterMarker, prevEmptyEnd, start, terminate, terminatorRules, token, nextLine = startLine, isTerminatingParagraph = false, tight = true;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // Special case:
    //  - item 1
    //   - item 2
    //    - item 3
    //     - item 4
    //      - this one is a paragraph continuation
    if (state.listIndent >= 0 && state.sCount[nextLine] - state.listIndent >= 4 && state.sCount[nextLine] < state.blkIndent) return false;
    // limit conditions when list can interrupt
    // a paragraph (validation mode only)
    if (silent && state.parentType === 'paragraph') // Next list item should still terminate previous list item;
    //
    // This code can fail if plugins use blkIndent as well as lists,
    // but I hope the spec gets fixed long before that happens.
    //
    {
        if (state.sCount[nextLine] >= state.blkIndent) isTerminatingParagraph = true;
    }
    // Detect list type and position after marker
    if ((posAfterMarker = $5f2b86195f70d047$var$skipOrderedListMarker(state, nextLine)) >= 0) {
        isOrdered = true;
        start = state.bMarks[nextLine] + state.tShift[nextLine];
        markerValue = Number(state.src.slice(start, posAfterMarker - 1));
        // If we're starting a new ordered list right after
        // a paragraph, it should start with 1.
        if (isTerminatingParagraph && markerValue !== 1) return false;
    } else if ((posAfterMarker = $5f2b86195f70d047$var$skipBulletListMarker(state, nextLine)) >= 0) isOrdered = false;
    else return false;
    // If we're starting a new unordered list right after
    // a paragraph, first line should not be empty.
    if (isTerminatingParagraph) {
        if (state.skipSpaces(posAfterMarker) >= state.eMarks[nextLine]) return false;
    }
    // For validation mode we can terminate immediately
    if (silent) return true;
    // We should terminate list on style change. Remember first one to compare.
    markerCharCode = state.src.charCodeAt(posAfterMarker - 1);
    // Start list
    listTokIdx = state.tokens.length;
    if (isOrdered) {
        token = state.push('ordered_list_open', 'ol', 1);
        if (markerValue !== 1) token.attrs = [
            [
                'start',
                markerValue
            ]
        ];
    } else token = state.push('bullet_list_open', 'ul', 1);
    token.map = listLines = [
        nextLine,
        0
    ];
    token.markup = String.fromCharCode(markerCharCode);
    //
    // Iterate list items
    //
    prevEmptyEnd = false;
    terminatorRules = state.md.block.ruler.getRules('list');
    oldParentType = state.parentType;
    state.parentType = 'list';
    while(nextLine < endLine){
        pos = posAfterMarker;
        max = state.eMarks[nextLine];
        initial = offset = state.sCount[nextLine] + posAfterMarker - (state.bMarks[nextLine] + state.tShift[nextLine]);
        while(pos < max){
            ch = state.src.charCodeAt(pos);
            if (ch === 0x09) offset += 4 - (offset + state.bsCount[nextLine]) % 4;
            else if (ch === 0x20) offset++;
            else break;
            pos++;
        }
        contentStart = pos;
        if (contentStart >= max) // trimming space in "-    \n  3" case, indent is 1 here
        indentAfterMarker = 1;
        else indentAfterMarker = offset - initial;
        // If we have more than 4 spaces, the indent is 1
        // (the rest is just indented code block)
        if (indentAfterMarker > 4) indentAfterMarker = 1;
        // "  -  test"
        //  ^^^^^ - calculating total length of this thing
        indent = initial + indentAfterMarker;
        // Run subparser & write tokens
        token = state.push('list_item_open', 'li', 1);
        token.markup = String.fromCharCode(markerCharCode);
        token.map = itemLines = [
            nextLine,
            0
        ];
        if (isOrdered) token.info = state.src.slice(start, posAfterMarker - 1);
        // change current state, then restore it after parser subcall
        oldTight = state.tight;
        oldTShift = state.tShift[nextLine];
        oldSCount = state.sCount[nextLine];
        //  - example list
        // ^ listIndent position will be here
        //   ^ blkIndent position will be here
        //
        oldListIndent = state.listIndent;
        state.listIndent = state.blkIndent;
        state.blkIndent = indent;
        state.tight = true;
        state.tShift[nextLine] = contentStart - state.bMarks[nextLine];
        state.sCount[nextLine] = offset;
        if (contentStart >= max && state.isEmpty(nextLine + 1)) // workaround for this case
        // (list item is empty, list terminates before "foo"):
        // ~~~~~~~~
        //   -
        //
        //     foo
        // ~~~~~~~~
        state.line = Math.min(state.line + 2, endLine);
        else state.md.block.tokenize(state, nextLine, endLine, true);
        // If any of list item is tight, mark list as tight
        if (!state.tight || prevEmptyEnd) tight = false;
        // Item become loose if finish with empty line,
        // but we should filter last element, because it means list finish
        prevEmptyEnd = state.line - nextLine > 1 && state.isEmpty(state.line - 1);
        state.blkIndent = state.listIndent;
        state.listIndent = oldListIndent;
        state.tShift[nextLine] = oldTShift;
        state.sCount[nextLine] = oldSCount;
        state.tight = oldTight;
        token = state.push('list_item_close', 'li', -1);
        token.markup = String.fromCharCode(markerCharCode);
        nextLine = state.line;
        itemLines[1] = nextLine;
        if (nextLine >= endLine) break;
        //
        // Try to check if list is terminated or continued.
        //
        if (state.sCount[nextLine] < state.blkIndent) break;
        // if it's indented more than 3 spaces, it should be a code block
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        // fail if terminating block found
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
        // fail if list has another type
        if (isOrdered) {
            posAfterMarker = $5f2b86195f70d047$var$skipOrderedListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
            start = state.bMarks[nextLine] + state.tShift[nextLine];
        } else {
            posAfterMarker = $5f2b86195f70d047$var$skipBulletListMarker(state, nextLine);
            if (posAfterMarker < 0) break;
        }
        if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) break;
    }
    // Finalize list
    if (isOrdered) token = state.push('ordered_list_close', 'ol', -1);
    else token = state.push('bullet_list_close', 'ul', -1);
    token.markup = String.fromCharCode(markerCharCode);
    listLines[1] = nextLine;
    state.line = nextLine;
    state.parentType = oldParentType;
    // mark paragraphs tight if needed
    if (tight) $5f2b86195f70d047$var$markTightParagraphs(state, listTokIdx);
    return true;
};

});

parcelRegister("k5n8c", function(module, exports) {
'use strict';

var $1hHFA = parcelRequire("1hHFA");
var $e9f637a8dc4aa546$require$normalizeReference = $1hHFA.normalizeReference;

var $1hHFA = parcelRequire("1hHFA");
var $e9f637a8dc4aa546$require$isSpace = $1hHFA.isSpace;
module.exports = function reference(state, startLine, _endLine, silent) {
    var ch, destEndPos, destEndLineNo, endLine, href, i, l, label, labelEnd, oldParentType, res, start, str, terminate, terminatorRules, title, lines = 0, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine], nextLine = startLine + 1;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (state.src.charCodeAt(pos) !== 0x5B /* [ */ ) return false;
    // Simple check to quickly interrupt scan on [link](url) at the start of line.
    // Can be useful on practice: https://github.com/markdown-it/markdown-it/issues/54
    while(++pos < max)if (state.src.charCodeAt(pos) === 0x5D /* ] */  && state.src.charCodeAt(pos - 1) !== 0x5C /* \ */ ) {
        if (pos + 1 === max) return false;
        if (state.src.charCodeAt(pos + 1) !== 0x3A /* : */ ) return false;
        break;
    }
    endLine = state.lineMax;
    // jump line-by-line until empty one or EOF
    terminatorRules = state.md.block.ruler.getRules('reference');
    oldParentType = state.parentType;
    state.parentType = 'reference';
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    str = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    max = str.length;
    for(pos = 1; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x5B /* [ */ ) return false;
        else if (ch === 0x5D /* ] */ ) {
            labelEnd = pos;
            break;
        } else if (ch === 0x0A /* \n */ ) lines++;
        else if (ch === 0x5C /* \ */ ) {
            pos++;
            if (pos < max && str.charCodeAt(pos) === 0x0A) lines++;
        }
    }
    if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A /* : */ ) return false;
    // [label]:   destination   'title'
    //         ^^^ skip optional whitespace here
    for(pos = labelEnd + 2; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x0A) lines++;
        else if ($e9f637a8dc4aa546$require$isSpace(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //            ^^^^^^^^^^^ parse this
    res = state.md.helpers.parseLinkDestination(str, pos, max);
    if (!res.ok) return false;
    href = state.md.normalizeLink(res.str);
    if (!state.md.validateLink(href)) return false;
    pos = res.pos;
    lines += res.lines;
    // save cursor state, we could require to rollback later
    destEndPos = pos;
    destEndLineNo = lines;
    // [label]:   destination   'title'
    //                       ^^^ skipping those spaces
    start = pos;
    for(; pos < max; pos++){
        ch = str.charCodeAt(pos);
        if (ch === 0x0A) lines++;
        else if ($e9f637a8dc4aa546$require$isSpace(ch)) ;
        else break;
    }
    // [label]:   destination   'title'
    //                          ^^^^^^^ parse this
    res = state.md.helpers.parseLinkTitle(str, pos, max);
    if (pos < max && start !== pos && res.ok) {
        title = res.str;
        pos = res.pos;
        lines += res.lines;
    } else {
        title = '';
        pos = destEndPos;
        lines = destEndLineNo;
    }
    // skip trailing spaces until the rest of the line
    while(pos < max){
        ch = str.charCodeAt(pos);
        if (!$e9f637a8dc4aa546$require$isSpace(ch)) break;
        pos++;
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) {
        if (title) {
            // garbage at the end of the line after title,
            // but it could still be a valid reference if we roll back
            title = '';
            pos = destEndPos;
            lines = destEndLineNo;
            while(pos < max){
                ch = str.charCodeAt(pos);
                if (!$e9f637a8dc4aa546$require$isSpace(ch)) break;
                pos++;
            }
        }
    }
    if (pos < max && str.charCodeAt(pos) !== 0x0A) // garbage at the end of the line
    return false;
    label = $e9f637a8dc4aa546$require$normalizeReference(str.slice(1, labelEnd));
    if (!label) // CommonMark 0.20 disallows empty labels
    return false;
    // Reference can not terminate anything. This check is for safety only.
    /*istanbul ignore if*/ if (silent) return true;
    if (typeof state.env.references === 'undefined') state.env.references = {};
    if (typeof state.env.references[label] === 'undefined') state.env.references[label] = {
        title: title,
        href: href
    };
    state.parentType = oldParentType;
    state.line = startLine + lines + 1;
    return true;
};

});

parcelRegister("jqlLt", function(module, exports) {
// HTML block
'use strict';

var $9kI4Z = parcelRequire("9kI4Z");

var $9GprV = parcelRequire("9GprV");
var $e241540efaf10deb$require$HTML_OPEN_CLOSE_TAG_RE = $9GprV.HTML_OPEN_CLOSE_TAG_RE;
// An array of opening and corresponding closing sequences for html tags,
// last argument defines whether it can terminate a paragraph or not
//
var $e241540efaf10deb$var$HTML_SEQUENCES = [
    [
        /^<(script|pre|style|textarea)(?=(\s|>|$))/i,
        /<\/(script|pre|style|textarea)>/i,
        true
    ],
    [
        /^<!--/,
        /-->/,
        true
    ],
    [
        /^<\?/,
        /\?>/,
        true
    ],
    [
        /^<![A-Z]/,
        />/,
        true
    ],
    [
        /^<!\[CDATA\[/,
        /\]\]>/,
        true
    ],
    [
        new RegExp('^</?(' + $9kI4Z.join('|') + ')(?=(\\s|/?>|$))', 'i'),
        /^$/,
        true
    ],
    [
        new RegExp($e241540efaf10deb$require$HTML_OPEN_CLOSE_TAG_RE.source + '\\s*$'),
        /^$/,
        false
    ]
];
module.exports = function html_block(state, startLine, endLine, silent) {
    var i, nextLine, token, lineText, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    if (!state.md.options.html) return false;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    lineText = state.src.slice(pos, max);
    for(i = 0; i < $e241540efaf10deb$var$HTML_SEQUENCES.length; i++){
        if ($e241540efaf10deb$var$HTML_SEQUENCES[i][0].test(lineText)) break;
    }
    if (i === $e241540efaf10deb$var$HTML_SEQUENCES.length) return false;
    if (silent) // true if this sequence can be a terminator, false otherwise
    return $e241540efaf10deb$var$HTML_SEQUENCES[i][2];
    nextLine = startLine + 1;
    // If we are here - we detected HTML block.
    // Let's roll down till block end.
    if (!$e241540efaf10deb$var$HTML_SEQUENCES[i][1].test(lineText)) for(; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        pos = state.bMarks[nextLine] + state.tShift[nextLine];
        max = state.eMarks[nextLine];
        lineText = state.src.slice(pos, max);
        if ($e241540efaf10deb$var$HTML_SEQUENCES[i][1].test(lineText)) {
            if (lineText.length !== 0) nextLine++;
            break;
        }
    }
    state.line = nextLine;
    token = state.push('html_block', '', 0);
    token.map = [
        startLine,
        nextLine
    ];
    token.content = state.getLines(startLine, nextLine, state.blkIndent, true);
    return true;
};

});
parcelRegister("9kI4Z", function(module, exports) {
// List of valid html blocks names, accorting to commonmark spec
// http://jgm.github.io/CommonMark/spec.html#html-blocks
'use strict';
module.exports = [
    'address',
    'article',
    'aside',
    'base',
    'basefont',
    'blockquote',
    'body',
    'caption',
    'center',
    'col',
    'colgroup',
    'dd',
    'details',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hr',
    'html',
    'iframe',
    'legend',
    'li',
    'link',
    'main',
    'menu',
    'menuitem',
    'nav',
    'noframes',
    'ol',
    'optgroup',
    'option',
    'p',
    'param',
    'section',
    'source',
    'summary',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'title',
    'tr',
    'track',
    'ul'
];

});

parcelRegister("9GprV", function(module, exports) {

$parcel$export(module.exports, "HTML_TAG_RE", () => $70cbc70b4375c1c4$export$6db61d2c3a16e419, (v) => $70cbc70b4375c1c4$export$6db61d2c3a16e419 = v);
$parcel$export(module.exports, "HTML_OPEN_CLOSE_TAG_RE", () => $70cbc70b4375c1c4$export$cd48660d06f74639, (v) => $70cbc70b4375c1c4$export$cd48660d06f74639 = v);
// Regexps to match html elements
var $70cbc70b4375c1c4$export$6db61d2c3a16e419;
var $70cbc70b4375c1c4$export$cd48660d06f74639;
'use strict';
var $70cbc70b4375c1c4$var$attr_name = '[a-zA-Z_:][a-zA-Z0-9:._-]*';
var $70cbc70b4375c1c4$var$unquoted = '[^"\'=<>`\\x00-\\x20]+';
var $70cbc70b4375c1c4$var$single_quoted = "'[^']*'";
var $70cbc70b4375c1c4$var$double_quoted = '"[^"]*"';
var $70cbc70b4375c1c4$var$attr_value = '(?:' + $70cbc70b4375c1c4$var$unquoted + '|' + $70cbc70b4375c1c4$var$single_quoted + '|' + $70cbc70b4375c1c4$var$double_quoted + ')';
var $70cbc70b4375c1c4$var$attribute = '(?:\\s+' + $70cbc70b4375c1c4$var$attr_name + '(?:\\s*=\\s*' + $70cbc70b4375c1c4$var$attr_value + ')?)';
var $70cbc70b4375c1c4$var$open_tag = '<[A-Za-z][A-Za-z0-9\\-]*' + $70cbc70b4375c1c4$var$attribute + '*\\s*\\/?>';
var $70cbc70b4375c1c4$var$close_tag = '<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>';
var $70cbc70b4375c1c4$var$comment = '<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->';
var $70cbc70b4375c1c4$var$processing = '<[?][\\s\\S]*?[?]>';
var $70cbc70b4375c1c4$var$declaration = '<![A-Z]+\\s+[^>]*>';
var $70cbc70b4375c1c4$var$cdata = '<!\\[CDATA\\[[\\s\\S]*?\\]\\]>';
var $70cbc70b4375c1c4$var$HTML_TAG_RE = new RegExp('^(?:' + $70cbc70b4375c1c4$var$open_tag + '|' + $70cbc70b4375c1c4$var$close_tag + '|' + $70cbc70b4375c1c4$var$comment + '|' + $70cbc70b4375c1c4$var$processing + '|' + $70cbc70b4375c1c4$var$declaration + '|' + $70cbc70b4375c1c4$var$cdata + ')');
var $70cbc70b4375c1c4$var$HTML_OPEN_CLOSE_TAG_RE = new RegExp('^(?:' + $70cbc70b4375c1c4$var$open_tag + '|' + $70cbc70b4375c1c4$var$close_tag + ')');
$70cbc70b4375c1c4$export$6db61d2c3a16e419 = $70cbc70b4375c1c4$var$HTML_TAG_RE;
$70cbc70b4375c1c4$export$cd48660d06f74639 = $70cbc70b4375c1c4$var$HTML_OPEN_CLOSE_TAG_RE;

});


parcelRegister("5cRNI", function(module, exports) {
// heading (#, ##, ...)
'use strict';

var $1hHFA = parcelRequire("1hHFA");
var $3ca7ce7d693510ce$require$isSpace = $1hHFA.isSpace;
module.exports = function heading(state, startLine, endLine, silent) {
    var ch, level, tmp, token, pos = state.bMarks[startLine] + state.tShift[startLine], max = state.eMarks[startLine];
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    ch = state.src.charCodeAt(pos);
    if (ch !== 0x23 /* # */  || pos >= max) return false;
    // count heading level
    level = 1;
    ch = state.src.charCodeAt(++pos);
    while(ch === 0x23 /* # */  && pos < max && level <= 6){
        level++;
        ch = state.src.charCodeAt(++pos);
    }
    if (level > 6 || pos < max && !$3ca7ce7d693510ce$require$isSpace(ch)) return false;
    if (silent) return true;
    // Let's cut tails like '    ###  ' from the end of string
    max = state.skipSpacesBack(max, pos);
    tmp = state.skipCharsBack(max, 0x23, pos); // #
    if (tmp > pos && $3ca7ce7d693510ce$require$isSpace(state.src.charCodeAt(tmp - 1))) max = tmp;
    state.line = startLine + 1;
    token = state.push('heading_open', 'h' + String(level), 1);
    token.markup = '########'.slice(0, level);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = state.src.slice(pos, max).trim();
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push('heading_close', 'h' + String(level), -1);
    token.markup = '########'.slice(0, level);
    return true;
};

});

parcelRegister("dAykE", function(module, exports) {
// lheading (---, ===)
'use strict';
module.exports = function lheading(state, startLine, endLine /*, silent*/ ) {
    var content, terminate, i, l, token, pos, max, level, marker, nextLine = startLine + 1, oldParentType, terminatorRules = state.md.block.ruler.getRules('paragraph');
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    oldParentType = state.parentType;
    state.parentType = 'paragraph'; // use paragraph to match terminatorRules
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        //
        // Check for underline in setext header
        //
        if (state.sCount[nextLine] >= state.blkIndent) {
            pos = state.bMarks[nextLine] + state.tShift[nextLine];
            max = state.eMarks[nextLine];
            if (pos < max) {
                marker = state.src.charCodeAt(pos);
                if (marker === 0x2D /* - */  || marker === 0x3D /* = */ ) {
                    pos = state.skipChars(pos, marker);
                    pos = state.skipSpaces(pos);
                    if (pos >= max) {
                        level = marker === 0x3D /* = */  ? 1 : 2;
                        break;
                    }
                }
            }
        }
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    if (!level) // Didn't find valid underline
    return false;
    content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine + 1;
    token = state.push('heading_open', 'h' + String(level), 1);
    token.markup = String.fromCharCode(marker);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = content;
    token.map = [
        startLine,
        state.line - 1
    ];
    token.children = [];
    token = state.push('heading_close', 'h' + String(level), -1);
    token.markup = String.fromCharCode(marker);
    state.parentType = oldParentType;
    return true;
};

});

parcelRegister("4lp3x", function(module, exports) {
// Paragraph
'use strict';
module.exports = function paragraph(state, startLine, endLine) {
    var content, terminate, i, l, token, oldParentType, nextLine = startLine + 1, terminatorRules = state.md.block.ruler.getRules('paragraph');
    oldParentType = state.parentType;
    state.parentType = 'paragraph';
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();
    state.line = nextLine;
    token = state.push('paragraph_open', 'p', 1);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = content;
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push('paragraph_close', 'p', -1);
    state.parentType = oldParentType;
    return true;
};

});

parcelRegister("lh2ek", function(module, exports) {
// Parser state class
'use strict';

var $jvz50 = parcelRequire("jvz50");

var $1hHFA = parcelRequire("1hHFA");
var $f7ccea5e46e0f534$require$isSpace = $1hHFA.isSpace;
function $f7ccea5e46e0f534$var$StateBlock(src, md, env, tokens) {
    var ch, s, start, pos, len, indent, offset, indent_found;
    this.src = src;
    // link to parser instance
    this.md = md;
    this.env = env;
    //
    // Internal state vartiables
    //
    this.tokens = tokens;
    this.bMarks = []; // line begin offsets for fast jumps
    this.eMarks = []; // line end offsets for fast jumps
    this.tShift = []; // offsets of the first non-space characters (tabs not expanded)
    this.sCount = []; // indents for each line (tabs expanded)
    // An amount of virtual spaces (tabs expanded) between beginning
    // of each line (bMarks) and real beginning of that line.
    //
    // It exists only as a hack because blockquotes override bMarks
    // losing information in the process.
    //
    // It's used only when expanding tabs, you can think about it as
    // an initial tab length, e.g. bsCount=21 applied to string `\t123`
    // means first tab should be expanded to 4-21%4 === 3 spaces.
    //
    this.bsCount = [];
    // block parser variables
    this.blkIndent = 0; // required block content indent (for example, if we are
    // inside a list, it would be positioned after list marker)
    this.line = 0; // line index in src
    this.lineMax = 0; // lines count
    this.tight = false; // loose/tight mode for lists
    this.ddIndent = -1; // indent of the current dd block (-1 if there isn't any)
    this.listIndent = -1; // indent of the current list block (-1 if there isn't any)
    // can be 'blockquote', 'list', 'root', 'paragraph' or 'reference'
    // used in lists to determine if they interrupt a paragraph
    this.parentType = 'root';
    this.level = 0;
    // renderer
    this.result = '';
    // Create caches
    // Generate markers.
    s = this.src;
    indent_found = false;
    for(start = pos = indent = offset = 0, len = s.length; pos < len; pos++){
        ch = s.charCodeAt(pos);
        if (!indent_found) {
            if ($f7ccea5e46e0f534$require$isSpace(ch)) {
                indent++;
                if (ch === 0x09) offset += 4 - offset % 4;
                else offset++;
                continue;
            } else indent_found = true;
        }
        if (ch === 0x0A || pos === len - 1) {
            if (ch !== 0x0A) pos++;
            this.bMarks.push(start);
            this.eMarks.push(pos);
            this.tShift.push(indent);
            this.sCount.push(offset);
            this.bsCount.push(0);
            indent_found = false;
            indent = 0;
            offset = 0;
            start = pos + 1;
        }
    }
    // Push fake entry to simplify cache bounds checks
    this.bMarks.push(s.length);
    this.eMarks.push(s.length);
    this.tShift.push(0);
    this.sCount.push(0);
    this.bsCount.push(0);
    this.lineMax = this.bMarks.length - 1; // don't count last fake line
}
// Push new token to "stream".
//
$f7ccea5e46e0f534$var$StateBlock.prototype.push = function(type, tag, nesting) {
    var token = new $jvz50(type, tag, nesting);
    token.block = true;
    if (nesting < 0) this.level--; // closing tag
    token.level = this.level;
    if (nesting > 0) this.level++; // opening tag
    this.tokens.push(token);
    return token;
};
$f7ccea5e46e0f534$var$StateBlock.prototype.isEmpty = function isEmpty(line) {
    return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
};
$f7ccea5e46e0f534$var$StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
    for(var max = this.lineMax; from < max; from++){
        if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) break;
    }
    return from;
};
// Skip spaces from given position.
$f7ccea5e46e0f534$var$StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
    var ch;
    for(var max = this.src.length; pos < max; pos++){
        ch = this.src.charCodeAt(pos);
        if (!$f7ccea5e46e0f534$require$isSpace(ch)) break;
    }
    return pos;
};
// Skip spaces from given position in reverse.
$f7ccea5e46e0f534$var$StateBlock.prototype.skipSpacesBack = function skipSpacesBack(pos, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (!$f7ccea5e46e0f534$require$isSpace(this.src.charCodeAt(--pos))) return pos + 1;
    }
    return pos;
};
// Skip char codes from given position
$f7ccea5e46e0f534$var$StateBlock.prototype.skipChars = function skipChars(pos, code) {
    for(var max = this.src.length; pos < max; pos++){
        if (this.src.charCodeAt(pos) !== code) break;
    }
    return pos;
};
// Skip char codes reverse from given position - 1
$f7ccea5e46e0f534$var$StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
    if (pos <= min) return pos;
    while(pos > min){
        if (code !== this.src.charCodeAt(--pos)) return pos + 1;
    }
    return pos;
};
// cut lines range from source.
$f7ccea5e46e0f534$var$StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
    var i, lineIndent, ch, first, last, queue, lineStart, line = begin;
    if (begin >= end) return '';
    queue = new Array(end - begin);
    for(i = 0; line < end; line++, i++){
        lineIndent = 0;
        lineStart = first = this.bMarks[line];
        if (line + 1 < end || keepLastLF) // No need for bounds check because we have fake entry on tail.
        last = this.eMarks[line] + 1;
        else last = this.eMarks[line];
        while(first < last && lineIndent < indent){
            ch = this.src.charCodeAt(first);
            if ($f7ccea5e46e0f534$require$isSpace(ch)) {
                if (ch === 0x09) lineIndent += 4 - (lineIndent + this.bsCount[line]) % 4;
                else lineIndent++;
            } else if (first - lineStart < this.tShift[line]) // patched tShift masked characters to look like spaces (blockquotes, list markers)
            lineIndent++;
            else break;
            first++;
        }
        if (lineIndent > indent) // partially expanding tabs in code blocks, e.g '\t\tfoobar'
        // with indent=2 becomes '  \tfoobar'
        queue[i] = new Array(lineIndent - indent + 1).join(' ') + this.src.slice(first, last);
        else queue[i] = this.src.slice(first, last);
    }
    return queue.join('');
};
// re-export Token class to use in block rules
$f7ccea5e46e0f534$var$StateBlock.prototype.Token = $jvz50;
module.exports = $f7ccea5e46e0f534$var$StateBlock;

});


parcelRegister("kYTqE", function(module, exports) {
/** internal
 * class ParserInline
 *
 * Tokenizes paragraph content.
 **/ 'use strict';

var $1zIbC = parcelRequire("1zIbC");












////////////////////////////////////////////////////////////////////////////////
// Parser rules
var $f4646840e5b2c6b8$var$_rules = [
    [
        'text',
        (parcelRequire("7ZC7n"))
    ],
    [
        'linkify',
        (parcelRequire("1A3cX"))
    ],
    [
        'newline',
        (parcelRequire("8yMPd"))
    ],
    [
        'escape',
        (parcelRequire("c161X"))
    ],
    [
        'backticks',
        (parcelRequire("3svte"))
    ],
    [
        'strikethrough',
        (parcelRequire("QVEel")).tokenize
    ],
    [
        'emphasis',
        (parcelRequire("iCLcE")).tokenize
    ],
    [
        'link',
        (parcelRequire("elHHC"))
    ],
    [
        'image',
        (parcelRequire("cU6P9"))
    ],
    [
        'autolink',
        (parcelRequire("8SXJW"))
    ],
    [
        'html_inline',
        (parcelRequire("evSjh"))
    ],
    [
        'entity',
        (parcelRequire("b5PPU"))
    ]
];




// `rule2` ruleset was created specifically for emphasis/strikethrough
// post-processing and may be changed in the future.
//
// Don't use this for anything except pairs (plugins working with `balance_pairs`).
//
var $f4646840e5b2c6b8$var$_rules2 = [
    [
        'balance_pairs',
        (parcelRequire("6aCLk"))
    ],
    [
        'strikethrough',
        (parcelRequire("QVEel")).postProcess
    ],
    [
        'emphasis',
        (parcelRequire("iCLcE")).postProcess
    ],
    // rules for pairs separate '**' into its own text tokens, which may be left unused,
    // rule below merges unused segments back with the rest of the text
    [
        'fragments_join',
        (parcelRequire("i0ozs"))
    ]
];
/**
 * new ParserInline()
 **/ function $f4646840e5b2c6b8$var$ParserInline() {
    var i;
    /**
   * ParserInline#ruler -> Ruler
   *
   * [[Ruler]] instance. Keep configuration of inline rules.
   **/ this.ruler = new $1zIbC();
    for(i = 0; i < $f4646840e5b2c6b8$var$_rules.length; i++)this.ruler.push($f4646840e5b2c6b8$var$_rules[i][0], $f4646840e5b2c6b8$var$_rules[i][1]);
    /**
   * ParserInline#ruler2 -> Ruler
   *
   * [[Ruler]] instance. Second ruler used for post-processing
   * (e.g. in emphasis-like rules).
   **/ this.ruler2 = new $1zIbC();
    for(i = 0; i < $f4646840e5b2c6b8$var$_rules2.length; i++)this.ruler2.push($f4646840e5b2c6b8$var$_rules2[i][0], $f4646840e5b2c6b8$var$_rules2[i][1]);
}
// Skip single token by running all rules in validation mode;
// returns `true` if any rule reported success
//
$f4646840e5b2c6b8$var$ParserInline.prototype.skipToken = function(state) {
    var ok, i, pos = state.pos, rules = this.ruler.getRules(''), len = rules.length, maxNesting = state.md.options.maxNesting, cache = state.cache;
    if (typeof cache[pos] !== 'undefined') {
        state.pos = cache[pos];
        return;
    }
    if (state.level < maxNesting) for(i = 0; i < len; i++){
        // Increment state.level and decrement it later to limit recursion.
        // It's harmless to do here, because no tokens are created. But ideally,
        // we'd need a separate private state variable for this purpose.
        //
        state.level++;
        ok = rules[i](state, true);
        state.level--;
        if (ok) {
            if (pos >= state.pos) throw new Error("inline rule didn't increment state.pos");
            break;
        }
    }
    else // Too much nesting, just skip until the end of the paragraph.
    //
    // NOTE: this will cause links to behave incorrectly in the following case,
    //       when an amount of `[` is exactly equal to `maxNesting + 1`:
    //
    //       [[[[[[[[[[[[[[[[[[[[[foo]()
    //
    // TODO: remove this workaround when CM standard will allow nested links
    //       (we can replace it by preventing links from being parsed in
    //       validation mode)
    //
    state.pos = state.posMax;
    if (!ok) state.pos++;
    cache[pos] = state.pos;
};
// Generate tokens for input range
//
$f4646840e5b2c6b8$var$ParserInline.prototype.tokenize = function(state) {
    var ok, i, prevPos, rules = this.ruler.getRules(''), len = rules.length, end = state.posMax, maxNesting = state.md.options.maxNesting;
    while(state.pos < end){
        // Try all possible rules.
        // On success, rule should:
        //
        // - update `state.pos`
        // - update `state.tokens`
        // - return true
        prevPos = state.pos;
        if (state.level < maxNesting) for(i = 0; i < len; i++){
            ok = rules[i](state, false);
            if (ok) {
                if (prevPos >= state.pos) throw new Error("inline rule didn't increment state.pos");
                break;
            }
        }
        if (ok) {
            if (state.pos >= end) break;
            continue;
        }
        state.pending += state.src[state.pos++];
    }
    if (state.pending) state.pushPending();
};
/**
 * ParserInline.parse(str, md, env, outTokens)
 *
 * Process input string and push inline tokens into `outTokens`
 **/ $f4646840e5b2c6b8$var$ParserInline.prototype.parse = function(str, md, env, outTokens) {
    var i, rules, len;
    var state = new this.State(str, md, env, outTokens);
    this.tokenize(state);
    rules = this.ruler2.getRules('');
    len = rules.length;
    for(i = 0; i < len; i++)rules[i](state);
};

$f4646840e5b2c6b8$var$ParserInline.prototype.State = (parcelRequire("eRtu8"));
module.exports = $f4646840e5b2c6b8$var$ParserInline;

});
parcelRegister("7ZC7n", function(module, exports) {
// Skip text characters for text token, place those to pending buffer
// and increment current pos
'use strict';
// Rule to skip pure text
// '{}$%@~+=:' reserved for extentions
// !, ", #, $, %, &, ', (, ), *, +, ,, -, ., /, :, ;, <, =, >, ?, @, [, \, ], ^, _, `, {, |, }, or ~
// !!!! Don't confuse with "Markdown ASCII Punctuation" chars
// http://spec.commonmark.org/0.15/#ascii-punctuation-character
function $5d1bcc570b2de406$var$isTerminatorChar(ch) {
    switch(ch){
        case 0x0A /* \n */ :
        case 0x21 /* ! */ :
        case 0x23 /* # */ :
        case 0x24 /* $ */ :
        case 0x25 /* % */ :
        case 0x26 /* & */ :
        case 0x2A /* * */ :
        case 0x2B /* + */ :
        case 0x2D /* - */ :
        case 0x3A /* : */ :
        case 0x3C /* < */ :
        case 0x3D /* = */ :
        case 0x3E /* > */ :
        case 0x40 /* @ */ :
        case 0x5B /* [ */ :
        case 0x5C /* \ */ :
        case 0x5D /* ] */ :
        case 0x5E /* ^ */ :
        case 0x5F /* _ */ :
        case 0x60 /* ` */ :
        case 0x7B /* { */ :
        case 0x7D /* } */ :
        case 0x7E /* ~ */ :
            return true;
        default:
            return false;
    }
}
module.exports = function text(state, silent) {
    var pos = state.pos;
    while(pos < state.posMax && !$5d1bcc570b2de406$var$isTerminatorChar(state.src.charCodeAt(pos)))pos++;
    if (pos === state.pos) return false;
    if (!silent) state.pending += state.src.slice(state.pos, pos);
    state.pos = pos;
    return true;
}; // Alternative implementation, for memory.
 //
 // It costs 10% of performance, but allows extend terminators list, if place it
 // to `ParcerInline` property. Probably, will switch to it sometime, such
 // flexibility required.
 /*
var TERMINATOR_RE = /[\n!#$%&*+\-:<=>@[\\\]^_`{}~]/;

module.exports = function text(state, silent) {
  var pos = state.pos,
      idx = state.src.slice(pos).search(TERMINATOR_RE);

  // first char is terminator -> empty text
  if (idx === 0) { return false; }

  // no terminator -> text till end of string
  if (idx < 0) {
    if (!silent) { state.pending += state.src.slice(pos); }
    state.pos = state.src.length;
    return true;
  }

  if (!silent) { state.pending += state.src.slice(pos, pos + idx); }

  state.pos += idx;

  return true;
};*/ 

});

parcelRegister("1A3cX", function(module, exports) {
// Process links like https://example.org/
'use strict';
// RFC3986: scheme = ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )
var $126ba44b83848503$var$SCHEME_RE = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
module.exports = function linkify(state, silent) {
    var pos, max, match, proto, link, url, fullUrl, token;
    if (!state.md.options.linkify) return false;
    if (state.linkLevel > 0) return false;
    pos = state.pos;
    max = state.posMax;
    if (pos + 3 > max) return false;
    if (state.src.charCodeAt(pos) !== 0x3A /* : */ ) return false;
    if (state.src.charCodeAt(pos + 1) !== 0x2F /* / */ ) return false;
    if (state.src.charCodeAt(pos + 2) !== 0x2F /* / */ ) return false;
    match = state.pending.match($126ba44b83848503$var$SCHEME_RE);
    if (!match) return false;
    proto = match[1];
    link = state.md.linkify.matchAtStart(state.src.slice(pos - proto.length));
    if (!link) return false;
    url = link.url;
    // invalid link, but still detected by linkify somehow;
    // need to check to prevent infinite loop below
    if (url.length <= proto.length) return false;
    // disallow '*' at the end of the link (conflicts with emphasis)
    url = url.replace(/\*+$/, '');
    fullUrl = state.md.normalizeLink(url);
    if (!state.md.validateLink(fullUrl)) return false;
    if (!silent) {
        state.pending = state.pending.slice(0, -proto.length);
        token = state.push('link_open', 'a', 1);
        token.attrs = [
            [
                'href',
                fullUrl
            ]
        ];
        token.markup = 'linkify';
        token.info = 'auto';
        token = state.push('text', '', 0);
        token.content = state.md.normalizeLinkText(url);
        token = state.push('link_close', 'a', -1);
        token.markup = 'linkify';
        token.info = 'auto';
    }
    state.pos += url.length - proto.length;
    return true;
};

});

parcelRegister("8yMPd", function(module, exports) {
// Proceess '\n'
'use strict';

var $1hHFA = parcelRequire("1hHFA");
var $63b75f562b32b08e$require$isSpace = $1hHFA.isSpace;
module.exports = function newline(state, silent) {
    var pmax, max, ws, pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x0A /* \n */ ) return false;
    pmax = state.pending.length - 1;
    max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
                // Find whitespaces tail of pending chars.
                ws = pmax - 1;
                while(ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20)ws--;
                state.pending = state.pending.slice(0, ws);
                state.push('hardbreak', 'br', 0);
            } else {
                state.pending = state.pending.slice(0, -1);
                state.push('softbreak', 'br', 0);
            }
        } else state.push('softbreak', 'br', 0);
    }
    pos++;
    // skip heading spaces for next line
    while(pos < max && $63b75f562b32b08e$require$isSpace(state.src.charCodeAt(pos)))pos++;
    state.pos = pos;
    return true;
};

});

parcelRegister("c161X", function(module, exports) {
// Process escaped chars and hardbreaks
'use strict';

var $1hHFA = parcelRequire("1hHFA");
var $8bfa419a12fc74eb$require$isSpace = $1hHFA.isSpace;
var $8bfa419a12fc74eb$var$ESCAPED = [];
for(var $8bfa419a12fc74eb$var$i = 0; $8bfa419a12fc74eb$var$i < 256; $8bfa419a12fc74eb$var$i++)$8bfa419a12fc74eb$var$ESCAPED.push(0);
'\\!"#$%&\'()*+,./:;<=>?@[]^_`{|}~-'.split('').forEach(function(ch) {
    $8bfa419a12fc74eb$var$ESCAPED[ch.charCodeAt(0)] = 1;
});
module.exports = function escape(state, silent) {
    var ch1, ch2, origStr, escapedStr, token, pos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x5C /* \ */ ) return false;
    pos++;
    // '\' at the end of the inline block
    if (pos >= max) return false;
    ch1 = state.src.charCodeAt(pos);
    if (ch1 === 0x0A) {
        if (!silent) state.push('hardbreak', 'br', 0);
        pos++;
        // skip leading whitespaces from next line
        while(pos < max){
            ch1 = state.src.charCodeAt(pos);
            if (!$8bfa419a12fc74eb$require$isSpace(ch1)) break;
            pos++;
        }
        state.pos = pos;
        return true;
    }
    escapedStr = state.src[pos];
    if (ch1 >= 0xD800 && ch1 <= 0xDBFF && pos + 1 < max) {
        ch2 = state.src.charCodeAt(pos + 1);
        if (ch2 >= 0xDC00 && ch2 <= 0xDFFF) {
            escapedStr += state.src[pos + 1];
            pos++;
        }
    }
    origStr = '\\' + escapedStr;
    if (!silent) {
        token = state.push('text_special', '', 0);
        if (ch1 < 256 && $8bfa419a12fc74eb$var$ESCAPED[ch1] !== 0) token.content = escapedStr;
        else token.content = origStr;
        token.markup = origStr;
        token.info = 'escape';
    }
    state.pos = pos + 1;
    return true;
};

});

parcelRegister("3svte", function(module, exports) {
// Parse backticks
'use strict';
module.exports = function backtick(state, silent) {
    var start, max, marker, token, matchStart, matchEnd, openerLength, closerLength, pos = state.pos, ch = state.src.charCodeAt(pos);
    if (ch !== 0x60 /* ` */ ) return false;
    start = pos;
    pos++;
    max = state.posMax;
    // scan marker length
    while(pos < max && state.src.charCodeAt(pos) === 0x60 /* ` */ )pos++;
    marker = state.src.slice(start, pos);
    openerLength = marker.length;
    if (state.backticksScanned && (state.backticks[openerLength] || 0) <= start) {
        if (!silent) state.pending += marker;
        state.pos += openerLength;
        return true;
    }
    matchEnd = pos;
    // Nothing found in the cache, scan until the end of the line (or until marker is found)
    while((matchStart = state.src.indexOf('`', matchEnd)) !== -1){
        matchEnd = matchStart + 1;
        // scan marker length
        while(matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60 /* ` */ )matchEnd++;
        closerLength = matchEnd - matchStart;
        if (closerLength === openerLength) {
            // Found matching closer length.
            if (!silent) {
                token = state.push('code_inline', 'code', 0);
                token.markup = marker;
                token.content = state.src.slice(pos, matchStart).replace(/\n/g, ' ').replace(/^ (.+) $/, '$1');
            }
            state.pos = matchEnd;
            return true;
        }
        // Some different length found, put it in cache as upper limit of where closer can be found
        state.backticks[closerLength] = matchStart;
    }
    // Scanned through the end, didn't find anything
    state.backticksScanned = true;
    if (!silent) state.pending += marker;
    state.pos += openerLength;
    return true;
};

});

parcelRegister("QVEel", function(module, exports) {

$parcel$export(module.exports, "tokenize", () => $09f1931c7d43a84c$export$660b2ee2d4fb4eff, (v) => $09f1931c7d43a84c$export$660b2ee2d4fb4eff = v);
$parcel$export(module.exports, "postProcess", () => $09f1931c7d43a84c$export$7b804a0e0ce836d9, (v) => $09f1931c7d43a84c$export$7b804a0e0ce836d9 = v);
// ~~strike through~~
//
// Insert each marker as a separate text token, and add it to delimiter list
//
var $09f1931c7d43a84c$export$660b2ee2d4fb4eff;
// Walk through delimiter list and replace text tokens with tags
//
var $09f1931c7d43a84c$export$7b804a0e0ce836d9;
'use strict';
$09f1931c7d43a84c$export$660b2ee2d4fb4eff = function strikethrough(state, silent) {
    var i, scanned, token, len, ch, start = state.pos, marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x7E /* ~ */ ) return false;
    scanned = state.scanDelims(state.pos, true);
    len = scanned.length;
    ch = String.fromCharCode(marker);
    if (len < 2) return false;
    if (len % 2) {
        token = state.push('text', '', 0);
        token.content = ch;
        len--;
    }
    for(i = 0; i < len; i += 2){
        token = state.push('text', '', 0);
        token.content = ch + ch;
        state.delimiters.push({
            marker: marker,
            length: 0,
            token: state.tokens.length - 1,
            end: -1,
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
};
function $09f1931c7d43a84c$var$postProcess(state, delimiters) {
    var i, j, startDelim, endDelim, token, loneMarkers = [], max = delimiters.length;
    for(i = 0; i < max; i++){
        startDelim = delimiters[i];
        if (startDelim.marker !== 0x7E /* ~ */ ) continue;
        if (startDelim.end === -1) continue;
        endDelim = delimiters[startDelim.end];
        token = state.tokens[startDelim.token];
        token.type = 's_open';
        token.tag = 's';
        token.nesting = 1;
        token.markup = '~~';
        token.content = '';
        token = state.tokens[endDelim.token];
        token.type = 's_close';
        token.tag = 's';
        token.nesting = -1;
        token.markup = '~~';
        token.content = '';
        if (state.tokens[endDelim.token - 1].type === 'text' && state.tokens[endDelim.token - 1].content === '~') loneMarkers.push(endDelim.token - 1);
    }
    // If a marker sequence has an odd number of characters, it's splitted
    // like this: `~~~~~` -> `~` + `~~` + `~~`, leaving one marker at the
    // start of the sequence.
    //
    // So, we have to move all those markers after subsequent s_close tags.
    //
    while(loneMarkers.length){
        i = loneMarkers.pop();
        j = i + 1;
        while(j < state.tokens.length && state.tokens[j].type === 's_close')j++;
        j--;
        if (i !== j) {
            token = state.tokens[j];
            state.tokens[j] = state.tokens[i];
            state.tokens[i] = token;
        }
    }
}
$09f1931c7d43a84c$export$7b804a0e0ce836d9 = function strikethrough(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $09f1931c7d43a84c$var$postProcess(state, state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $09f1931c7d43a84c$var$postProcess(state, tokens_meta[curr].delimiters);
};

});

parcelRegister("iCLcE", function(module, exports) {

$parcel$export(module.exports, "tokenize", () => $d8f0642bd6bf2766$export$660b2ee2d4fb4eff, (v) => $d8f0642bd6bf2766$export$660b2ee2d4fb4eff = v);
$parcel$export(module.exports, "postProcess", () => $d8f0642bd6bf2766$export$7b804a0e0ce836d9, (v) => $d8f0642bd6bf2766$export$7b804a0e0ce836d9 = v);
// Process *this* and _that_
//
// Insert each marker as a separate text token, and add it to delimiter list
//
var $d8f0642bd6bf2766$export$660b2ee2d4fb4eff;
// Walk through delimiter list and replace text tokens with tags
//
var $d8f0642bd6bf2766$export$7b804a0e0ce836d9;
'use strict';
$d8f0642bd6bf2766$export$660b2ee2d4fb4eff = function emphasis(state, silent) {
    var i, scanned, token, start = state.pos, marker = state.src.charCodeAt(start);
    if (silent) return false;
    if (marker !== 0x5F /* _ */  && marker !== 0x2A /* * */ ) return false;
    scanned = state.scanDelims(state.pos, marker === 0x2A);
    for(i = 0; i < scanned.length; i++){
        token = state.push('text', '', 0);
        token.content = String.fromCharCode(marker);
        state.delimiters.push({
            // Char code of the starting marker (number).
            //
            marker: marker,
            // Total length of these series of delimiters.
            //
            length: scanned.length,
            // A position of the token this delimiter corresponds to.
            //
            token: state.tokens.length - 1,
            // If this delimiter is matched as a valid opener, `end` will be
            // equal to its position, otherwise it's `-1`.
            //
            end: -1,
            // Boolean flags that determine if this delimiter could open or close
            // an emphasis.
            //
            open: scanned.can_open,
            close: scanned.can_close
        });
    }
    state.pos += scanned.length;
    return true;
};
function $d8f0642bd6bf2766$var$postProcess(state, delimiters) {
    var i, startDelim, endDelim, token, ch, isStrong, max = delimiters.length;
    for(i = max - 1; i >= 0; i--){
        startDelim = delimiters[i];
        if (startDelim.marker !== 0x5F /* _ */  && startDelim.marker !== 0x2A /* * */ ) continue;
        // Process only opening markers
        if (startDelim.end === -1) continue;
        endDelim = delimiters[startDelim.end];
        // If the previous delimiter has the same marker and is adjacent to this one,
        // merge those into one strong delimiter.
        //
        // `<em><em>whatever</em></em>` -> `<strong>whatever</strong>`
        //
        isStrong = i > 0 && delimiters[i - 1].end === startDelim.end + 1 && // check that first two markers match and adjacent
        delimiters[i - 1].marker === startDelim.marker && delimiters[i - 1].token === startDelim.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
        delimiters[startDelim.end + 1].token === endDelim.token + 1;
        ch = String.fromCharCode(startDelim.marker);
        token = state.tokens[startDelim.token];
        token.type = isStrong ? 'strong_open' : 'em_open';
        token.tag = isStrong ? 'strong' : 'em';
        token.nesting = 1;
        token.markup = isStrong ? ch + ch : ch;
        token.content = '';
        token = state.tokens[endDelim.token];
        token.type = isStrong ? 'strong_close' : 'em_close';
        token.tag = isStrong ? 'strong' : 'em';
        token.nesting = -1;
        token.markup = isStrong ? ch + ch : ch;
        token.content = '';
        if (isStrong) {
            state.tokens[delimiters[i - 1].token].content = '';
            state.tokens[delimiters[startDelim.end + 1].token].content = '';
            i--;
        }
    }
}
$d8f0642bd6bf2766$export$7b804a0e0ce836d9 = function emphasis(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $d8f0642bd6bf2766$var$postProcess(state, state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $d8f0642bd6bf2766$var$postProcess(state, tokens_meta[curr].delimiters);
};

});

parcelRegister("elHHC", function(module, exports) {
// Process [link](<to> "stuff")
'use strict';

var $1hHFA = parcelRequire("1hHFA");
var $a724ed45b3a765af$require$normalizeReference = $1hHFA.normalizeReference;

var $1hHFA = parcelRequire("1hHFA");
var $a724ed45b3a765af$require$isSpace = $1hHFA.isSpace;
module.exports = function link(state, silent) {
    var attrs, code, label, labelEnd, labelStart, pos, res, ref, token, href = '', title = '', oldPos = state.pos, max = state.posMax, start = state.pos, parseReference = true;
    if (state.src.charCodeAt(state.pos) !== 0x5B /* [ */ ) return false;
    labelStart = state.pos + 1;
    labelEnd = state.md.helpers.parseLinkLabel(state, state.pos, true);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // might have found a valid shortcut link, disable reference parsing
        parseReference = false;
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$a724ed45b3a765af$require$isSpace(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = '';
            // [link](  <href>  "title"  )
            //                ^^ skipping these spaces
            start = pos;
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!$a724ed45b3a765af$require$isSpace(code) && code !== 0x0A) break;
            }
            // [link](  <href>  "title"  )
            //                  ^^^^^^^ parsing link title
            res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
            if (pos < max && start !== pos && res.ok) {
                title = res.str;
                pos = res.pos;
                // [link](  <href>  "title"  )
                //                         ^^ skipping these spaces
                for(; pos < max; pos++){
                    code = state.src.charCodeAt(pos);
                    if (!$a724ed45b3a765af$require$isSpace(code) && code !== 0x0A) break;
                }
            }
        }
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) // parsing a valid shortcut link failed, fallback to reference
        parseReference = true;
        pos++;
    }
    if (parseReference) {
        //
        // Link reference
        //
        if (typeof state.env.references === 'undefined') return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[$a724ed45b3a765af$require$normalizeReference(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        state.pos = labelStart;
        state.posMax = labelEnd;
        token = state.push('link_open', 'a', 1);
        token.attrs = attrs = [
            [
                'href',
                href
            ]
        ];
        if (title) attrs.push([
            'title',
            title
        ]);
        state.linkLevel++;
        state.md.inline.tokenize(state);
        state.linkLevel--;
        token = state.push('link_close', 'a', -1);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
};

});

parcelRegister("cU6P9", function(module, exports) {
// Process ![image](<src> "title")
'use strict';

var $1hHFA = parcelRequire("1hHFA");
var $9650021fa18575dc$require$normalizeReference = $1hHFA.normalizeReference;

var $1hHFA = parcelRequire("1hHFA");
var $9650021fa18575dc$require$isSpace = $1hHFA.isSpace;
module.exports = function image(state, silent) {
    var attrs, code, content, label, labelEnd, labelStart, pos, ref, res, title, token, tokens, start, href = '', oldPos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(state.pos) !== 0x21 /* ! */ ) return false;
    if (state.src.charCodeAt(state.pos + 1) !== 0x5B /* [ */ ) return false;
    labelStart = state.pos + 2;
    labelEnd = state.md.helpers.parseLinkLabel(state, state.pos + 1, false);
    // parser failed to find ']', so it's not a valid link
    if (labelEnd < 0) return false;
    pos = labelEnd + 1;
    if (pos < max && state.src.charCodeAt(pos) === 0x28 /* ( */ ) {
        //
        // Inline link
        //
        // [link](  <href>  "title"  )
        //        ^^ skipping these spaces
        pos++;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$9650021fa18575dc$require$isSpace(code) && code !== 0x0A) break;
        }
        if (pos >= max) return false;
        // [link](  <href>  "title"  )
        //          ^^^^^^ parsing link destination
        start = pos;
        res = state.md.helpers.parseLinkDestination(state.src, pos, state.posMax);
        if (res.ok) {
            href = state.md.normalizeLink(res.str);
            if (state.md.validateLink(href)) pos = res.pos;
            else href = '';
        }
        // [link](  <href>  "title"  )
        //                ^^ skipping these spaces
        start = pos;
        for(; pos < max; pos++){
            code = state.src.charCodeAt(pos);
            if (!$9650021fa18575dc$require$isSpace(code) && code !== 0x0A) break;
        }
        // [link](  <href>  "title"  )
        //                  ^^^^^^^ parsing link title
        res = state.md.helpers.parseLinkTitle(state.src, pos, state.posMax);
        if (pos < max && start !== pos && res.ok) {
            title = res.str;
            pos = res.pos;
            // [link](  <href>  "title"  )
            //                         ^^ skipping these spaces
            for(; pos < max; pos++){
                code = state.src.charCodeAt(pos);
                if (!$9650021fa18575dc$require$isSpace(code) && code !== 0x0A) break;
            }
        } else title = '';
        if (pos >= max || state.src.charCodeAt(pos) !== 0x29 /* ) */ ) {
            state.pos = oldPos;
            return false;
        }
        pos++;
    } else {
        //
        // Link reference
        //
        if (typeof state.env.references === 'undefined') return false;
        if (pos < max && state.src.charCodeAt(pos) === 0x5B /* [ */ ) {
            start = pos + 1;
            pos = state.md.helpers.parseLinkLabel(state, pos);
            if (pos >= 0) label = state.src.slice(start, pos++);
            else pos = labelEnd + 1;
        } else pos = labelEnd + 1;
        // covers label === '' and label === undefined
        // (collapsed reference link and shortcut reference link respectively)
        if (!label) label = state.src.slice(labelStart, labelEnd);
        ref = state.env.references[$9650021fa18575dc$require$normalizeReference(label)];
        if (!ref) {
            state.pos = oldPos;
            return false;
        }
        href = ref.href;
        title = ref.title;
    }
    //
    // We found the end of the link, and know for a fact it's a valid link;
    // so all that's left to do is to call tokenizer.
    //
    if (!silent) {
        content = state.src.slice(labelStart, labelEnd);
        state.md.inline.parse(content, state.md, state.env, tokens = []);
        token = state.push('image', 'img', 0);
        token.attrs = attrs = [
            [
                'src',
                href
            ],
            [
                'alt',
                ''
            ]
        ];
        token.children = tokens;
        token.content = content;
        if (title) attrs.push([
            'title',
            title
        ]);
    }
    state.pos = pos;
    state.posMax = max;
    return true;
};

});

parcelRegister("8SXJW", function(module, exports) {
// Process autolinks '<protocol:...>'
'use strict';
/*eslint max-len:0*/ var $6781b502463c0f06$var$EMAIL_RE = /^([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/;
var $6781b502463c0f06$var$AUTOLINK_RE = /^([a-zA-Z][a-zA-Z0-9+.\-]{1,31}):([^<>\x00-\x20]*)$/;
module.exports = function autolink(state, silent) {
    var url, fullUrl, token, ch, start, max, pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */ ) return false;
    start = state.pos;
    max = state.posMax;
    for(;;){
        if (++pos >= max) return false;
        ch = state.src.charCodeAt(pos);
        if (ch === 0x3C /* < */ ) return false;
        if (ch === 0x3E /* > */ ) break;
    }
    url = state.src.slice(start + 1, pos);
    if ($6781b502463c0f06$var$AUTOLINK_RE.test(url)) {
        fullUrl = state.md.normalizeLink(url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            token = state.push('link_open', 'a', 1);
            token.attrs = [
                [
                    'href',
                    fullUrl
                ]
            ];
            token.markup = 'autolink';
            token.info = 'auto';
            token = state.push('text', '', 0);
            token.content = state.md.normalizeLinkText(url);
            token = state.push('link_close', 'a', -1);
            token.markup = 'autolink';
            token.info = 'auto';
        }
        state.pos += url.length + 2;
        return true;
    }
    if ($6781b502463c0f06$var$EMAIL_RE.test(url)) {
        fullUrl = state.md.normalizeLink('mailto:' + url);
        if (!state.md.validateLink(fullUrl)) return false;
        if (!silent) {
            token = state.push('link_open', 'a', 1);
            token.attrs = [
                [
                    'href',
                    fullUrl
                ]
            ];
            token.markup = 'autolink';
            token.info = 'auto';
            token = state.push('text', '', 0);
            token.content = state.md.normalizeLinkText(url);
            token = state.push('link_close', 'a', -1);
            token.markup = 'autolink';
            token.info = 'auto';
        }
        state.pos += url.length + 2;
        return true;
    }
    return false;
};

});

parcelRegister("evSjh", function(module, exports) {
// Process html tags
'use strict';

var $9GprV = parcelRequire("9GprV");
var $a90e16c33a30fe41$require$HTML_TAG_RE = $9GprV.HTML_TAG_RE;
function $a90e16c33a30fe41$var$isLinkOpen(str) {
    return /^<a[>\s]/i.test(str);
}
function $a90e16c33a30fe41$var$isLinkClose(str) {
    return /^<\/a\s*>/i.test(str);
}
function $a90e16c33a30fe41$var$isLetter(ch) {
    /*eslint no-bitwise:0*/ var lc = ch | 0x20; // to lower case
    return lc >= 0x61 /* a */  && lc <= 0x7a /* z */ ;
}
module.exports = function html_inline(state, silent) {
    var ch, match, max, token, pos = state.pos;
    if (!state.md.options.html) return false;
    // Check start
    max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x3C /* < */  || pos + 2 >= max) return false;
    // Quick fail on second char
    ch = state.src.charCodeAt(pos + 1);
    if (ch !== 0x21 /* ! */  && ch !== 0x3F /* ? */  && ch !== 0x2F /* / */  && !$a90e16c33a30fe41$var$isLetter(ch)) return false;
    match = state.src.slice(pos).match($a90e16c33a30fe41$require$HTML_TAG_RE);
    if (!match) return false;
    if (!silent) {
        token = state.push('html_inline', '', 0);
        token.content = match[0];
        if ($a90e16c33a30fe41$var$isLinkOpen(token.content)) state.linkLevel++;
        if ($a90e16c33a30fe41$var$isLinkClose(token.content)) state.linkLevel--;
    }
    state.pos += match[0].length;
    return true;
};

});

parcelRegister("b5PPU", function(module, exports) {
// Process html entity - &#123;, &#xAF;, &quot;, ...
'use strict';

var $3gFDb = parcelRequire("3gFDb");

var $1hHFA = parcelRequire("1hHFA");
var $81385ef1c8443d3d$require$has = $1hHFA.has;

var $1hHFA = parcelRequire("1hHFA");
var $81385ef1c8443d3d$require$isValidEntityCode = $1hHFA.isValidEntityCode;

var $1hHFA = parcelRequire("1hHFA");
var $81385ef1c8443d3d$require$fromCodePoint = $1hHFA.fromCodePoint;
var $81385ef1c8443d3d$var$DIGITAL_RE = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i;
var $81385ef1c8443d3d$var$NAMED_RE = /^&([a-z][a-z0-9]{1,31});/i;
module.exports = function entity(state, silent) {
    var ch, code, match, token, pos = state.pos, max = state.posMax;
    if (state.src.charCodeAt(pos) !== 0x26 /* & */ ) return false;
    if (pos + 1 >= max) return false;
    ch = state.src.charCodeAt(pos + 1);
    if (ch === 0x23 /* # */ ) {
        match = state.src.slice(pos).match($81385ef1c8443d3d$var$DIGITAL_RE);
        if (match) {
            if (!silent) {
                code = match[1][0].toLowerCase() === 'x' ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
                token = state.push('text_special', '', 0);
                token.content = $81385ef1c8443d3d$require$isValidEntityCode(code) ? $81385ef1c8443d3d$require$fromCodePoint(code) : $81385ef1c8443d3d$require$fromCodePoint(0xFFFD);
                token.markup = match[0];
                token.info = 'entity';
            }
            state.pos += match[0].length;
            return true;
        }
    } else {
        match = state.src.slice(pos).match($81385ef1c8443d3d$var$NAMED_RE);
        if (match) {
            if ($81385ef1c8443d3d$require$has($3gFDb, match[1])) {
                if (!silent) {
                    token = state.push('text_special', '', 0);
                    token.content = $3gFDb[match[1]];
                    token.markup = match[0];
                    token.info = 'entity';
                }
                state.pos += match[0].length;
                return true;
            }
        }
    }
    return false;
};

});

parcelRegister("6aCLk", function(module, exports) {
// For each opening emphasis-like marker find a matching closing one
//
'use strict';
function $47e1beabf38b67f2$var$processDelimiters(delimiters) {
    var closerIdx, openerIdx, closer, opener, minOpenerIdx, newMinOpenerIdx, isOddMatch, lastJump, openersBottom = {}, max = delimiters.length;
    if (!max) return;
    // headerIdx is the first delimiter of the current (where closer is) delimiter run
    var headerIdx = 0;
    var lastTokenIdx = -2; // needs any value lower than -1
    var jumps = [];
    for(closerIdx = 0; closerIdx < max; closerIdx++){
        closer = delimiters[closerIdx];
        jumps.push(0);
        // markers belong to same delimiter run if:
        //  - they have adjacent tokens
        //  - AND markers are the same
        //
        if (delimiters[headerIdx].marker !== closer.marker || lastTokenIdx !== closer.token - 1) headerIdx = closerIdx;
        lastTokenIdx = closer.token;
        // Length is only used for emphasis-specific "rule of 3",
        // if it's not defined (in strikethrough or 3rd party plugins),
        // we can default it to 0 to disable those checks.
        //
        closer.length = closer.length || 0;
        if (!closer.close) continue;
        // Previously calculated lower bounds (previous fails)
        // for each marker, each delimiter length modulo 3,
        // and for whether this closer can be an opener;
        // https://github.com/commonmark/cmark/commit/34250e12ccebdc6372b8b49c44fab57c72443460
        if (!openersBottom.hasOwnProperty(closer.marker)) openersBottom[closer.marker] = [
            -1,
            -1,
            -1,
            -1,
            -1,
            -1
        ];
        minOpenerIdx = openersBottom[closer.marker][(closer.open ? 3 : 0) + closer.length % 3];
        openerIdx = headerIdx - jumps[headerIdx] - 1;
        newMinOpenerIdx = openerIdx;
        for(; openerIdx > minOpenerIdx; openerIdx -= jumps[openerIdx] + 1){
            opener = delimiters[openerIdx];
            if (opener.marker !== closer.marker) continue;
            if (opener.open && opener.end < 0) {
                isOddMatch = false;
                // from spec:
                //
                // If one of the delimiters can both open and close emphasis, then the
                // sum of the lengths of the delimiter runs containing the opening and
                // closing delimiters must not be a multiple of 3 unless both lengths
                // are multiples of 3.
                //
                if (opener.close || closer.open) {
                    if ((opener.length + closer.length) % 3 === 0) {
                        if (opener.length % 3 !== 0 || closer.length % 3 !== 0) isOddMatch = true;
                    }
                }
                if (!isOddMatch) {
                    // If previous delimiter cannot be an opener, we can safely skip
                    // the entire sequence in future checks. This is required to make
                    // sure algorithm has linear complexity (see *_*_*_*_*_... case).
                    //
                    lastJump = openerIdx > 0 && !delimiters[openerIdx - 1].open ? jumps[openerIdx - 1] + 1 : 0;
                    jumps[closerIdx] = closerIdx - openerIdx + lastJump;
                    jumps[openerIdx] = lastJump;
                    closer.open = false;
                    opener.end = closerIdx;
                    opener.close = false;
                    newMinOpenerIdx = -1;
                    // treat next token as start of run,
                    // it optimizes skips in **<...>**a**<...>** pathological case
                    lastTokenIdx = -2;
                    break;
                }
            }
        }
        if (newMinOpenerIdx !== -1) // If match for this delimiter run failed, we want to set lower bound for
        // future lookups. This is required to make sure algorithm has linear
        // complexity.
        //
        // See details here:
        // https://github.com/commonmark/cmark/issues/178#issuecomment-270417442
        //
        openersBottom[closer.marker][(closer.open ? 3 : 0) + (closer.length || 0) % 3] = newMinOpenerIdx;
    }
}
module.exports = function link_pairs(state) {
    var curr, tokens_meta = state.tokens_meta, max = state.tokens_meta.length;
    $47e1beabf38b67f2$var$processDelimiters(state.delimiters);
    for(curr = 0; curr < max; curr++)if (tokens_meta[curr] && tokens_meta[curr].delimiters) $47e1beabf38b67f2$var$processDelimiters(tokens_meta[curr].delimiters);
};

});

parcelRegister("i0ozs", function(module, exports) {
// Clean up tokens after emphasis and strikethrough postprocessing:
// merge adjacent text nodes into one and re-calculate all token levels
//
// This is necessary because initially emphasis delimiter markers (*, _, ~)
// are treated as their own separate text tokens. Then emphasis rule either
// leaves them as text (needed to merge with adjacent text) or turns them
// into opening/closing tags (which messes up levels inside).
//
'use strict';
module.exports = function fragments_join(state) {
    var curr, last, level = 0, tokens = state.tokens, max = state.tokens.length;
    for(curr = last = 0; curr < max; curr++){
        // re-calculate levels after emphasis/strikethrough turns some text nodes
        // into opening/closing tags
        if (tokens[curr].nesting < 0) level--; // closing tag
        tokens[curr].level = level;
        if (tokens[curr].nesting > 0) level++; // opening tag
        if (tokens[curr].type === 'text' && curr + 1 < max && tokens[curr + 1].type === 'text') // collapse two adjacent text nodes
        tokens[curr + 1].content = tokens[curr].content + tokens[curr + 1].content;
        else {
            if (curr !== last) tokens[last] = tokens[curr];
            last++;
        }
    }
    if (curr !== last) tokens.length = last;
};

});

parcelRegister("eRtu8", function(module, exports) {
// Inline parser state
'use strict';

var $jvz50 = parcelRequire("jvz50");

var $1hHFA = parcelRequire("1hHFA");
var $ad1ce3113ffbb205$require$isWhiteSpace = $1hHFA.isWhiteSpace;

var $1hHFA = parcelRequire("1hHFA");
var $ad1ce3113ffbb205$require$isPunctChar = $1hHFA.isPunctChar;

var $1hHFA = parcelRequire("1hHFA");
var $ad1ce3113ffbb205$require$isMdAsciiPunct = $1hHFA.isMdAsciiPunct;
function $ad1ce3113ffbb205$var$StateInline(src, md, env, outTokens) {
    this.src = src;
    this.env = env;
    this.md = md;
    this.tokens = outTokens;
    this.tokens_meta = Array(outTokens.length);
    this.pos = 0;
    this.posMax = this.src.length;
    this.level = 0;
    this.pending = '';
    this.pendingLevel = 0;
    // Stores { start: end } pairs. Useful for backtrack
    // optimization of pairs parse (emphasis, strikes).
    this.cache = {};
    // List of emphasis-like delimiters for current tag
    this.delimiters = [];
    // Stack of delimiter lists for upper level tags
    this._prev_delimiters = [];
    // backtick length => last seen position
    this.backticks = {};
    this.backticksScanned = false;
    // Counter used to disable inline linkify-it execution
    // inside <a> and markdown links
    this.linkLevel = 0;
}
// Flush pending text
//
$ad1ce3113ffbb205$var$StateInline.prototype.pushPending = function() {
    var token = new $jvz50('text', '', 0);
    token.content = this.pending;
    token.level = this.pendingLevel;
    this.tokens.push(token);
    this.pending = '';
    return token;
};
// Push new token to "stream".
// If pending text exists - flush it as text token
//
$ad1ce3113ffbb205$var$StateInline.prototype.push = function(type, tag, nesting) {
    if (this.pending) this.pushPending();
    var token = new $jvz50(type, tag, nesting);
    var token_meta = null;
    if (nesting < 0) {
        // closing tag
        this.level--;
        this.delimiters = this._prev_delimiters.pop();
    }
    token.level = this.level;
    if (nesting > 0) {
        // opening tag
        this.level++;
        this._prev_delimiters.push(this.delimiters);
        this.delimiters = [];
        token_meta = {
            delimiters: this.delimiters
        };
    }
    this.pendingLevel = this.level;
    this.tokens.push(token);
    this.tokens_meta.push(token_meta);
    return token;
};
// Scan a sequence of emphasis-like markers, and determine whether
// it can start an emphasis sequence or end an emphasis sequence.
//
//  - start - position to scan from (it should point at a valid marker);
//  - canSplitWord - determine if these markers can be found inside a word
//
$ad1ce3113ffbb205$var$StateInline.prototype.scanDelims = function(start, canSplitWord) {
    var pos = start, lastChar, nextChar, count, can_open, can_close, isLastWhiteSpace, isLastPunctChar, isNextWhiteSpace, isNextPunctChar, left_flanking = true, right_flanking = true, max = this.posMax, marker = this.src.charCodeAt(start);
    // treat beginning of the line as a whitespace
    lastChar = start > 0 ? this.src.charCodeAt(start - 1) : 0x20;
    while(pos < max && this.src.charCodeAt(pos) === marker)pos++;
    count = pos - start;
    // treat end of the line as a whitespace
    nextChar = pos < max ? this.src.charCodeAt(pos) : 0x20;
    isLastPunctChar = $ad1ce3113ffbb205$require$isMdAsciiPunct(lastChar) || $ad1ce3113ffbb205$require$isPunctChar(String.fromCharCode(lastChar));
    isNextPunctChar = $ad1ce3113ffbb205$require$isMdAsciiPunct(nextChar) || $ad1ce3113ffbb205$require$isPunctChar(String.fromCharCode(nextChar));
    isLastWhiteSpace = $ad1ce3113ffbb205$require$isWhiteSpace(lastChar);
    isNextWhiteSpace = $ad1ce3113ffbb205$require$isWhiteSpace(nextChar);
    if (isNextWhiteSpace) left_flanking = false;
    else if (isNextPunctChar) {
        if (!(isLastWhiteSpace || isLastPunctChar)) left_flanking = false;
    }
    if (isLastWhiteSpace) right_flanking = false;
    else if (isLastPunctChar) {
        if (!(isNextWhiteSpace || isNextPunctChar)) right_flanking = false;
    }
    if (!canSplitWord) {
        can_open = left_flanking && (!right_flanking || isLastPunctChar);
        can_close = right_flanking && (!left_flanking || isNextPunctChar);
    } else {
        can_open = left_flanking;
        can_close = right_flanking;
    }
    return {
        can_open: can_open,
        can_close: can_close,
        length: count
    };
};
// re-export Token class to use in block rules
$ad1ce3113ffbb205$var$StateInline.prototype.Token = $jvz50;
module.exports = $ad1ce3113ffbb205$var$StateInline;

});


parcelRegister("6nCWf", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $4a53186f5e9c6ae9$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $4a53186f5e9c6ae9$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $4a53186f5e9c6ae9$var$isString(obj) {
    return $4a53186f5e9c6ae9$var$_class(obj) === '[object String]';
}
function $4a53186f5e9c6ae9$var$isObject(obj) {
    return $4a53186f5e9c6ae9$var$_class(obj) === '[object Object]';
}
function $4a53186f5e9c6ae9$var$isRegExp(obj) {
    return $4a53186f5e9c6ae9$var$_class(obj) === '[object RegExp]';
}
function $4a53186f5e9c6ae9$var$isFunction(obj) {
    return $4a53186f5e9c6ae9$var$_class(obj) === '[object Function]';
}
function $4a53186f5e9c6ae9$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $4a53186f5e9c6ae9$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $4a53186f5e9c6ae9$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $4a53186f5e9c6ae9$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $4a53186f5e9c6ae9$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $4a53186f5e9c6ae9$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $4a53186f5e9c6ae9$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $4a53186f5e9c6ae9$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $4a53186f5e9c6ae9$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $4a53186f5e9c6ae9$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $4a53186f5e9c6ae9$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("cbSjd"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($4a53186f5e9c6ae9$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($4a53186f5e9c6ae9$var$isObject(val)) {
            if ($4a53186f5e9c6ae9$var$isRegExp(val.validate)) compiled.validate = $4a53186f5e9c6ae9$var$createValidator(val.validate);
            else if ($4a53186f5e9c6ae9$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($4a53186f5e9c6ae9$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $4a53186f5e9c6ae9$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($4a53186f5e9c6ae9$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $4a53186f5e9c6ae9$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($4a53186f5e9c6ae9$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.schema_at_start = RegExp('^' + self.re.schema_search.source, 'i');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $4a53186f5e9c6ae9$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $4a53186f5e9c6ae9$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $4a53186f5e9c6ae9$var$createMatch(self, shift) {
    var match = new $4a53186f5e9c6ae9$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $4a53186f5e9c6ae9$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $4a53186f5e9c6ae9$var$LinkifyIt)) return new $4a53186f5e9c6ae9$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($4a53186f5e9c6ae9$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $4a53186f5e9c6ae9$var$assign({}, $4a53186f5e9c6ae9$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $4a53186f5e9c6ae9$var$assign({}, $4a53186f5e9c6ae9$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $4a53186f5e9c6ae9$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $4a53186f5e9c6ae9$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $4a53186f5e9c6ae9$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $4a53186f5e9c6ae9$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $4a53186f5e9c6ae9$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $4a53186f5e9c6ae9$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $4a53186f5e9c6ae9$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $4a53186f5e9c6ae9$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $4a53186f5e9c6ae9$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $4a53186f5e9c6ae9$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($4a53186f5e9c6ae9$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($4a53186f5e9c6ae9$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/**
 * LinkifyIt#matchAtStart(text) -> Match|null
 *
 * Returns fully-formed (not fuzzy) link if it starts at the beginning
 * of the string, and null otherwise.
 **/ $4a53186f5e9c6ae9$var$LinkifyIt.prototype.matchAtStart = function matchAtStart(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return null;
    var m = this.re.schema_at_start.exec(text);
    if (!m) return null;
    var len = this.testSchemaAt(text, m[2], m[0].length);
    if (!len) return null;
    this.__schema__ = m[2];
    this.__index__ = m.index + m[1].length;
    this.__last_index__ = m.index + m[0].length + len;
    return $4a53186f5e9c6ae9$var$createMatch(this, 0);
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $4a53186f5e9c6ae9$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $4a53186f5e9c6ae9$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $4a53186f5e9c6ae9$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $4a53186f5e9c6ae9$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $4a53186f5e9c6ae9$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $4a53186f5e9c6ae9$var$LinkifyIt;

});
parcelRegister("cbSjd", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    opts = opts || {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("4NOMA")).source;
    re.src_Cc = (parcelRequire("jvFHg")).source;
    re.src_Z = (parcelRequire("8UCq2")).source;
    re.src_P = (parcelRequire("aUAJj")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')' + '(?!' + (opts['---'] ? '-(?!--)|' : '-|') + '_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-])|' + // allow `I'm_king` if no pair found
    '\\.{2,}[a-zA-Z0-9%/&]|' + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]|$)|' + (opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + ',(?!' + re.src_ZCc + '|$)|' + // allow `,,,` in paths
    ';(?!' + re.src_ZCc + '|$)|' + // allow `;` if not followed by space-like char
    '\\!+(?!' + re.src_ZCc + '|[!]|$)|' + // allow `!!!` in paths, but not at the end
    '\\?(?!' + re.src_ZCc + '|[?]|$)' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});


parcelRegister("1s3qa", function(module, exports) {
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == 'object' && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = '-', /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        'overflow': 'Overflow: input needs wider integers to process',
        'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
        'invalid-input': 'Invalid input'
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split('@');
        var result = '';
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + '@';
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, '\x2E');
        var labels = string.split('.');
        var encoded = map(labels, fn).join('.');
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = '';
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join('');
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error('not-basic');
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error('invalid-input');
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error('overflow');
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error('overflow');
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error('overflow');
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error('overflow');
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error('overflow');
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join('');
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ 'version': '1.4.1',
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ 'ucs2': {
            'decode': ucs2decode,
            'encode': ucs2encode
        },
        'decode': decode,
        'encode': encode,
        'toASCII': toASCII,
        'toUnicode': toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) define('punycode', function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

});

parcelRegister("a3CyB", function(module, exports) {
// markdown-it default options
'use strict';
module.exports = {
    options: {
        html: false,
        xhtmlOut: false,
        breaks: false,
        langPrefix: 'language-',
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 100 // Internal protection, recursion limit
    },
    components: {
        core: {},
        block: {},
        inline: {}
    }
};

});

parcelRegister("lwtXx", function(module, exports) {
// "Zero" preset, with nothing enabled. Useful for manual configuring of simple
// modes. For example, to parse bold/italic only.
'use strict';
module.exports = {
    options: {
        html: false,
        xhtmlOut: false,
        breaks: false,
        langPrefix: 'language-',
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20 // Internal protection, recursion limit
    },
    components: {
        core: {
            rules: [
                'normalize',
                'block',
                'inline',
                'text_join'
            ]
        },
        block: {
            rules: [
                'paragraph'
            ]
        },
        inline: {
            rules: [
                'text'
            ],
            rules2: [
                'balance_pairs',
                'fragments_join'
            ]
        }
    }
};

});

parcelRegister("83lxA", function(module, exports) {
// Commonmark default options
'use strict';
module.exports = {
    options: {
        html: true,
        xhtmlOut: true,
        breaks: false,
        langPrefix: 'language-',
        linkify: false,
        // Enable some language-neutral replacements + quotes beautification
        typographer: false,
        // Double + single quotes replacement pairs, when typographer enabled,
        // and smartquotes on. Could be either a String or an Array.
        //
        // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
        // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
        quotes: '\u201c\u201d\u2018\u2019',
        /* “”‘’ */ // Highlighter function. Should return escaped HTML,
        // or '' if the source string is not changed and should be escaped externaly.
        // If result starts with <pre... internal wrapper is skipped.
        //
        // function (/*str, lang*/) { return ''; }
        //
        highlight: null,
        maxNesting: 20 // Internal protection, recursion limit
    },
    components: {
        core: {
            rules: [
                'normalize',
                'block',
                'inline',
                'text_join'
            ]
        },
        block: {
            rules: [
                'blockquote',
                'code',
                'fence',
                'heading',
                'hr',
                'html_block',
                'lheading',
                'list',
                'reference',
                'paragraph'
            ]
        },
        inline: {
            rules: [
                'autolink',
                'backticks',
                'emphasis',
                'entity',
                'escape',
                'html_inline',
                'image',
                'link',
                'newline',
                'text'
            ],
            rules2: [
                'balance_pairs',
                'emphasis',
                'fragments_join'
            ]
        }
    }
};

});



parcelRegister("hhJg2", function(module, exports) {

$parcel$export(module.exports, "markdownItTable", () => $c95721705815d4d4$export$26a6b72a65821214);

var $5SHP6 = parcelRequire("5SHP6");
var $c95721705815d4d4$export$26a6b72a65821214 = function markdownItTable(md, options) {
    md.block.ruler.before('paragraph', 'table', (0, (/*@__PURE__*/$parcel$interopDefault($5SHP6))), {
        alt: [
            'paragraph',
            'reference'
        ]
    });
};

});
parcelRegister("5SHP6", function(module, exports) {
// Copied from https://github.com/markdown-it/markdown-it/blob/master/lib/rules_block/table.js
function $4483fd48534751c6$var$isSpace(code) {
    switch(code){
        case 0x09:
        case 0x20:
            return true;
    }
    return false;
}
function $4483fd48534751c6$var$getLine(state, line) {
    var pos = state.bMarks[line] + state.blkIndent, max = state.eMarks[line];
    return state.src.substr(pos, max - pos);
}
function $4483fd48534751c6$var$escapedSplit(str) {
    var result = [], pos = 0, max = str.length, ch, escapes = 0, lastPos = 0, backTicked = false, lastBackTick = 0;
    ch = str.charCodeAt(pos);
    while(pos < max){
        if (ch === 0x60 /* ` */ ) {
            if (backTicked) {
                // make \` close code sequence, but not open it;
                // the reason is: `\` is correct code block
                backTicked = false;
                lastBackTick = pos;
            } else if (escapes % 2 === 0) {
                backTicked = true;
                lastBackTick = pos;
            }
        } else if (ch === 0x7c /* | */  && escapes % 2 === 0 && !backTicked) {
            result.push(str.substring(lastPos, pos));
            lastPos = pos + 1;
        }
        if (ch === 0x5c /* \ */ ) escapes++;
        else escapes = 0;
        pos++;
        // If there was an un-closed backtick, go back to just after
        // the last backtick, but as if it was a normal character
        if (pos === max && backTicked) {
            backTicked = false;
            pos = lastBackTick + 1;
        }
        ch = str.charCodeAt(pos);
    }
    result.push(str.substring(lastPos));
    return result;
}
module.exports = function table(state, startLine, endLine, silent) {
    var ch, lineText, pos, i, nextLine, columns, columnCount, token, aligns, t, tableLines, tbodyLines;
    // should have at least two lines
    if (startLine + 2 > endLine) return false;
    nextLine = startLine + 1;
    if (state.sCount[nextLine] < state.blkIndent) return false;
    // if it's indented more than 3 spaces, it should be a code block
    if (state.sCount[nextLine] - state.blkIndent >= 4) return false;
    // first character of the second line should be '|', '-', ':',
    // and no other characters are allowed but spaces;
    // basically, this is the equivalent of /^[-:|][-:|\s]*$/ regexp
    pos = state.bMarks[nextLine] + state.tShift[nextLine];
    if (pos >= state.eMarks[nextLine]) return false;
    ch = state.src.charCodeAt(pos++);
    if (ch !== 0x7c /* | */  && ch !== 0x2d /* - */  && ch !== 0x3a /* : */ ) return false;
    while(pos < state.eMarks[nextLine]){
        ch = state.src.charCodeAt(pos);
        if (ch !== 0x7c /* | */  && ch !== 0x2d /* - */  && ch !== 0x3a /* : */  && !$4483fd48534751c6$var$isSpace(ch)) return false;
        pos++;
    }
    lineText = $4483fd48534751c6$var$getLine(state, startLine + 1);
    columns = lineText.split('|');
    aligns = [];
    for(i = 0; i < columns.length; i++){
        t = columns[i].trim();
        if (!t) {
            // allow empty columns before and after table, but not in between columns;
            // e.g. allow ` |---| `, disallow ` ---||--- `
            if (i === 0 || i === columns.length - 1) continue;
            else return false;
        }
        if (!/^:?-+:?$/.test(t)) return false;
        if (t.charCodeAt(t.length - 1) === 0x3a /* : */ ) aligns.push(t.charCodeAt(0) === 0x3a /* : */  ? 'center' : 'right');
        else if (t.charCodeAt(0) === 0x3a /* : */ ) aligns.push('left');
        else aligns.push('');
    }
    lineText = $4483fd48534751c6$var$getLine(state, startLine).trim();
    if (lineText.indexOf('|') === -1) return false;
    if (state.sCount[startLine] - state.blkIndent >= 4) return false;
    columns = $4483fd48534751c6$var$escapedSplit(lineText.replace(/^\||\|$/g, ''));
    // header row will define an amount of columns in the entire table,
    // and align row shouldn't be smaller than that (the rest of the rows can)
    columnCount = columns.length;
    if (columnCount > aligns.length) return false;
    if (silent) return true;
    token = state.push('table_open', 'table', 1);
    token.map = tableLines = [
        startLine,
        0
    ];
    // token     = state.push('thead_open', 'thead', 1);
    // token.map = [ startLine, startLine + 1 ];
    token = state.push('tr_open', 'tr', 1);
    token.map = [
        startLine,
        startLine + 1
    ];
    for(i = 0; i < columns.length; i++){
        token = state.push('th_open', 'th', 1);
        token.map = [
            startLine,
            startLine + 1
        ];
        if (aligns[i]) token.attrs = [
            [
                'style',
                'text-align:' + aligns[i]
            ]
        ];
        token = state.push('paragraph_open', 'p', 1);
        token = state.push('inline', '', 0);
        token.content = columns[i].trim();
        token.map = [
            startLine,
            startLine + 1
        ];
        token.children = [];
        token = state.push('paragraph_close', 'p', -1);
        token = state.push('th_close', 'th', -1);
    }
    token = state.push('tr_close', 'tr', -1);
    // token     = state.push('thead_close', 'thead', -1);
    // token     = state.push('tbody_open', 'tbody', 1);
    token.map = tbodyLines = [
        startLine + 2,
        0
    ];
    var oldLineMax = state.lineMax;
    for(nextLine = startLine + 2; nextLine < endLine; nextLine++){
        if (state.sCount[nextLine] < state.blkIndent) break;
        lineText = $4483fd48534751c6$var$getLine(state, nextLine).trim();
        if (lineText.indexOf('|') === -1) break;
        if (state.sCount[nextLine] - state.blkIndent >= 4) break;
        columns = $4483fd48534751c6$var$escapedSplit(lineText.replace(/^\||\|$/g, ''));
        token = state.push('tr_open', 'tr', 1);
        for(var _i = 0, offset = 1; _i < columns.length; _i++){
            token = state.push('td_open', 'td', 1);
            if (aligns[_i]) token.attrs = [
                [
                    'style',
                    'text-align:' + aligns[_i]
                ]
            ];
            // https://github.com/markdown-it/markdown-it/blob/e6f19eab4204122e85e4a342e0c1c8486ff40c2d/lib/rules_block/state_block.js#L25
            // bMarks => line begin offsets for fast jumps
            // eMarks => line end offsets for fast jumps
            // tShift => offsets of the first non-space characters (tabs not expanded)
            // sCount => indents for each line (tabs expanded)
            // Move bMarks when first char is ' ' for > to work
            var shift = columns[_i][0] === ' ' || /^(\d+\.|\*|-)$/.test(columns[_i].trim()) ? 1 : 0;
            state.bMarks[nextLine] += offset + shift;
            offset = (columns[_i] || '').length + (shift ? 0 : 1);
            state.eMarks[nextLine] = state.bMarks[nextLine] + offset - 1;
            state.lineMax = 1;
            state.md.block.tokenize(state, nextLine, nextLine + 1);
            token = state.push('td_close', 'td', -1);
        }
        token = state.push('tr_close', 'tr', -1);
    }
    // token = state.push('tbody_close', 'tbody', -1);
    state.lineMax = oldLineMax;
    token = state.push('table_close', 'table', -1);
    tableLines[1] = tbodyLines[1] = nextLine;
    state.line = nextLine;
    return true;
};

});


parcelRegister("1RkS8", function(module, exports) {

$parcel$export(module.exports, "getFragmentBackingArray", () => $6b89dab6337b20cd$export$7b8536c35e9eb7d2);
$parcel$export(module.exports, "mapFragment", () => $6b89dab6337b20cd$export$81fe6b3b714fd0bf);
$parcel$export(module.exports, "mapSlice", () => $6b89dab6337b20cd$export$d8264570c5933bbf);
$parcel$export(module.exports, "flatmap", () => $6b89dab6337b20cd$export$c575791007f9dbd1);
$parcel$export(module.exports, "mapChildren", () => $6b89dab6337b20cd$export$e0baa27f47733a4a);

var $7dkLM = parcelRequire("7dkLM");
function $6b89dab6337b20cd$export$7b8536c35e9eb7d2(fragment) {
    return fragment.content;
}
function $6b89dab6337b20cd$export$81fe6b3b714fd0bf(content, callback, parent = null) {
    const children = [];
    for(let i = 0, size = content.childCount; i < size; i++){
        const node = content.child(i);
        const transformed = node.isLeaf ? callback(node, parent, i) : callback(node.copy($6b89dab6337b20cd$export$81fe6b3b714fd0bf(node.content, callback, node)), parent, i);
        if (transformed) {
            if (transformed instanceof (0, $7dkLM.Fragment)) children.push(...$6b89dab6337b20cd$export$7b8536c35e9eb7d2(transformed));
            else if (Array.isArray(transformed)) children.push(...transformed);
            else children.push(transformed);
        }
    }
    return (0, $7dkLM.Fragment).fromArray(children);
}
function $6b89dab6337b20cd$export$d8264570c5933bbf(slice, callback) {
    const fragment = $6b89dab6337b20cd$export$81fe6b3b714fd0bf(slice.content, callback);
    return new (0, $7dkLM.Slice)(fragment, slice.openStart, slice.openEnd);
}
function $6b89dab6337b20cd$export$c575791007f9dbd1(fragment, callback) {
    const fragmentContent = [];
    for(let i = 0; i < fragment.childCount; i++){
        const child = callback(fragment.child(i), i, fragment);
        if (Array.isArray(child)) fragmentContent.push(...child);
        else fragmentContent.push(child);
    }
    return (0, $7dkLM.Fragment).fromArray(fragmentContent);
}
function $6b89dab6337b20cd$export$e0baa27f47733a4a(node, callback) {
    const array = [];
    for(let i = 0; i < node.childCount; i++)array.push(callback(node.child(i), i, node instanceof (0, $7dkLM.Fragment) ? node : node.content));
    return array;
}

});

parcelRegister("dzYNe", function(module, exports) {

$parcel$export(module.exports, "MarkdownParser", () => $9e2db37dbfa373e9$export$a64f782182dea128);
$parcel$export(module.exports, "MarkdownSerializer", () => $9e2db37dbfa373e9$export$ae9f6f04acb6c60c);
$parcel$export(module.exports, "MarkdownSerializerState", () => $9e2db37dbfa373e9$export$61055fa707e69319);

var $7dkLM = parcelRequire("7dkLM");

var $k8wSn = parcelRequire("k8wSn");
/**
Document schema for the data model used by CommonMark.
*/ const $9e2db37dbfa373e9$export$4902baddc787debb = new (0, $7dkLM.Schema)({
    nodes: {
        doc: {
            content: "block+"
        },
        paragraph: {
            content: "inline*",
            group: "block",
            parseDOM: [
                {
                    tag: "p"
                }
            ],
            toDOM () {
                return [
                    "p",
                    0
                ];
            }
        },
        blockquote: {
            content: "block+",
            group: "block",
            parseDOM: [
                {
                    tag: "blockquote"
                }
            ],
            toDOM () {
                return [
                    "blockquote",
                    0
                ];
            }
        },
        horizontal_rule: {
            group: "block",
            parseDOM: [
                {
                    tag: "hr"
                }
            ],
            toDOM () {
                return [
                    "div",
                    [
                        "hr"
                    ]
                ];
            }
        },
        heading: {
            attrs: {
                level: {
                    default: 1
                }
            },
            content: "(text | image)*",
            group: "block",
            defining: true,
            parseDOM: [
                {
                    tag: "h1",
                    attrs: {
                        level: 1
                    }
                },
                {
                    tag: "h2",
                    attrs: {
                        level: 2
                    }
                },
                {
                    tag: "h3",
                    attrs: {
                        level: 3
                    }
                },
                {
                    tag: "h4",
                    attrs: {
                        level: 4
                    }
                },
                {
                    tag: "h5",
                    attrs: {
                        level: 5
                    }
                },
                {
                    tag: "h6",
                    attrs: {
                        level: 6
                    }
                }
            ],
            toDOM (node) {
                return [
                    "h" + node.attrs.level,
                    0
                ];
            }
        },
        code_block: {
            content: "text*",
            group: "block",
            code: true,
            defining: true,
            marks: "",
            attrs: {
                params: {
                    default: ""
                }
            },
            parseDOM: [
                {
                    tag: "pre",
                    preserveWhitespace: "full",
                    getAttrs: (node)=>({
                            params: node.getAttribute("data-params") || ""
                        })
                }
            ],
            toDOM (node) {
                return [
                    "pre",
                    node.attrs.params ? {
                        "data-params": node.attrs.params
                    } : {},
                    [
                        "code",
                        0
                    ]
                ];
            }
        },
        ordered_list: {
            content: "list_item+",
            group: "block",
            attrs: {
                order: {
                    default: 1
                },
                tight: {
                    default: false
                }
            },
            parseDOM: [
                {
                    tag: "ol",
                    getAttrs (dom) {
                        return {
                            order: dom.hasAttribute("start") ? +dom.getAttribute("start") : 1,
                            tight: dom.hasAttribute("data-tight")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "ol",
                    {
                        start: node.attrs.order == 1 ? null : node.attrs.order,
                        "data-tight": node.attrs.tight ? "true" : null
                    },
                    0
                ];
            }
        },
        bullet_list: {
            content: "list_item+",
            group: "block",
            attrs: {
                tight: {
                    default: false
                }
            },
            parseDOM: [
                {
                    tag: "ul",
                    getAttrs: (dom)=>({
                            tight: dom.hasAttribute("data-tight")
                        })
                }
            ],
            toDOM (node) {
                return [
                    "ul",
                    {
                        "data-tight": node.attrs.tight ? "true" : null
                    },
                    0
                ];
            }
        },
        list_item: {
            content: "block+",
            defining: true,
            parseDOM: [
                {
                    tag: "li"
                }
            ],
            toDOM () {
                return [
                    "li",
                    0
                ];
            }
        },
        text: {
            group: "inline"
        },
        image: {
            inline: true,
            attrs: {
                src: {},
                alt: {
                    default: null
                },
                title: {
                    default: null
                }
            },
            group: "inline",
            draggable: true,
            parseDOM: [
                {
                    tag: "img[src]",
                    getAttrs (dom) {
                        return {
                            src: dom.getAttribute("src"),
                            title: dom.getAttribute("title"),
                            alt: dom.getAttribute("alt")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "img",
                    node.attrs
                ];
            }
        },
        hard_break: {
            inline: true,
            group: "inline",
            selectable: false,
            parseDOM: [
                {
                    tag: "br"
                }
            ],
            toDOM () {
                return [
                    "br"
                ];
            }
        }
    },
    marks: {
        em: {
            parseDOM: [
                {
                    tag: "i"
                },
                {
                    tag: "em"
                },
                {
                    style: "font-style=italic"
                },
                {
                    style: "font-style=normal",
                    clearMark: (m)=>m.type.name == "em"
                }
            ],
            toDOM () {
                return [
                    "em"
                ];
            }
        },
        strong: {
            parseDOM: [
                {
                    tag: "strong"
                },
                {
                    tag: "b",
                    getAttrs: (node)=>node.style.fontWeight != "normal" && null
                },
                {
                    style: "font-weight=400",
                    clearMark: (m)=>m.type.name == "strong"
                },
                {
                    style: "font-weight",
                    getAttrs: (value)=>/^(bold(er)?|[5-9]\d{2,})$/.test(value) && null
                }
            ],
            toDOM () {
                return [
                    "strong"
                ];
            }
        },
        link: {
            attrs: {
                href: {},
                title: {
                    default: null
                }
            },
            inclusive: false,
            parseDOM: [
                {
                    tag: "a[href]",
                    getAttrs (dom) {
                        return {
                            href: dom.getAttribute("href"),
                            title: dom.getAttribute("title")
                        };
                    }
                }
            ],
            toDOM (node) {
                return [
                    "a",
                    node.attrs
                ];
            }
        },
        code: {
            parseDOM: [
                {
                    tag: "code"
                }
            ],
            toDOM () {
                return [
                    "code"
                ];
            }
        }
    }
});
// @ts-ignore
function $9e2db37dbfa373e9$var$maybeMerge(a, b) {
    if (a.isText && b.isText && (0, $7dkLM.Mark).sameSet(a.marks, b.marks)) return a.withText(a.text + b.text);
}
// Object used to track the context of a running parse.
class $9e2db37dbfa373e9$var$MarkdownParseState {
    constructor(schema, tokenHandlers){
        this.schema = schema;
        this.tokenHandlers = tokenHandlers;
        this.stack = [
            {
                type: schema.topNodeType,
                attrs: null,
                content: [],
                marks: (0, $7dkLM.Mark).none
            }
        ];
    }
    top() {
        return this.stack[this.stack.length - 1];
    }
    push(elt) {
        if (this.stack.length) this.top().content.push(elt);
    }
    // Adds the given text to the current position in the document,
    // using the current marks as styling.
    addText(text) {
        if (!text) return;
        let top = this.top(), nodes = top.content, last = nodes[nodes.length - 1];
        let node = this.schema.text(text, top.marks), merged;
        if (last && (merged = $9e2db37dbfa373e9$var$maybeMerge(last, node))) nodes[nodes.length - 1] = merged;
        else nodes.push(node);
    }
    // Adds the given mark to the set of active marks.
    openMark(mark) {
        let top = this.top();
        top.marks = mark.addToSet(top.marks);
    }
    // Removes the given mark from the set of active marks.
    closeMark(mark) {
        let top = this.top();
        top.marks = mark.removeFromSet(top.marks);
    }
    parseTokens(toks) {
        for(let i = 0; i < toks.length; i++){
            let tok = toks[i];
            let handler = this.tokenHandlers[tok.type];
            if (!handler) throw new Error("Token type `" + tok.type + "` not supported by Markdown parser");
            handler(this, tok, toks, i);
        }
    }
    // Add a node at the current position.
    addNode(type, attrs, content) {
        let top = this.top();
        let node = type.createAndFill(attrs, content, top ? top.marks : []);
        if (!node) return null;
        this.push(node);
        return node;
    }
    // Wrap subsequent content in a node of the given type.
    openNode(type, attrs) {
        this.stack.push({
            type: type,
            attrs: attrs,
            content: [],
            marks: (0, $7dkLM.Mark).none
        });
    }
    // Close and return the node that is currently on top of the stack.
    closeNode() {
        let info = this.stack.pop();
        return this.addNode(info.type, info.attrs, info.content);
    }
}
function $9e2db37dbfa373e9$var$attrs(spec, token, tokens, i) {
    if (spec.getAttrs) return spec.getAttrs(token, tokens, i);
    else if (spec.attrs instanceof Function) return spec.attrs(token);
    else return spec.attrs;
}
// Code content is represented as a single token with a `content`
// property in Markdown-it.
function $9e2db37dbfa373e9$var$noCloseToken(spec, type) {
    return spec.noCloseToken || type == "code_inline" || type == "code_block" || type == "fence";
}
function $9e2db37dbfa373e9$var$withoutTrailingNewline(str) {
    return str[str.length - 1] == "\n" ? str.slice(0, str.length - 1) : str;
}
function $9e2db37dbfa373e9$var$noOp() {}
function $9e2db37dbfa373e9$var$tokenHandlers(schema, tokens) {
    let handlers = Object.create(null);
    for(let type in tokens){
        let spec = tokens[type];
        if (spec.block) {
            let nodeType = schema.nodeType(spec.block);
            if ($9e2db37dbfa373e9$var$noCloseToken(spec, type)) handlers[type] = (state, tok, tokens, i)=>{
                state.openNode(nodeType, $9e2db37dbfa373e9$var$attrs(spec, tok, tokens, i));
                state.addText($9e2db37dbfa373e9$var$withoutTrailingNewline(tok.content));
                state.closeNode();
            };
            else {
                handlers[type + "_open"] = (state, tok, tokens, i)=>state.openNode(nodeType, $9e2db37dbfa373e9$var$attrs(spec, tok, tokens, i));
                handlers[type + "_close"] = (state)=>state.closeNode();
            }
        } else if (spec.node) {
            let nodeType = schema.nodeType(spec.node);
            handlers[type] = (state, tok, tokens, i)=>state.addNode(nodeType, $9e2db37dbfa373e9$var$attrs(spec, tok, tokens, i));
        } else if (spec.mark) {
            let markType = schema.marks[spec.mark];
            if ($9e2db37dbfa373e9$var$noCloseToken(spec, type)) handlers[type] = (state, tok, tokens, i)=>{
                state.openMark(markType.create($9e2db37dbfa373e9$var$attrs(spec, tok, tokens, i)));
                state.addText($9e2db37dbfa373e9$var$withoutTrailingNewline(tok.content));
                state.closeMark(markType);
            };
            else {
                handlers[type + "_open"] = (state, tok, tokens, i)=>state.openMark(markType.create($9e2db37dbfa373e9$var$attrs(spec, tok, tokens, i)));
                handlers[type + "_close"] = (state)=>state.closeMark(markType);
            }
        } else if (spec.ignore) {
            if ($9e2db37dbfa373e9$var$noCloseToken(spec, type)) handlers[type] = $9e2db37dbfa373e9$var$noOp;
            else {
                handlers[type + "_open"] = $9e2db37dbfa373e9$var$noOp;
                handlers[type + "_close"] = $9e2db37dbfa373e9$var$noOp;
            }
        } else throw new RangeError("Unrecognized parsing spec " + JSON.stringify(spec));
    }
    handlers.text = (state, tok)=>state.addText(tok.content);
    handlers.inline = (state, tok)=>state.parseTokens(tok.children);
    handlers.softbreak = handlers.softbreak || ((state)=>state.addText(" "));
    return handlers;
}
/**
A configuration of a Markdown parser. Such a parser uses
[markdown-it](https://github.com/markdown-it/markdown-it) to
tokenize a file, and then runs the custom rules it is given over
the tokens to create a ProseMirror document tree.
*/ class $9e2db37dbfa373e9$export$a64f782182dea128 {
    /**
    Create a parser with the given configuration. You can configure
    the markdown-it parser to parse the dialect you want, and provide
    a description of the ProseMirror entities those tokens map to in
    the `tokens` object, which maps token names to descriptions of
    what to do with them. Such a description is an object, and may
    have the following properties:
    */ constructor(/**
    The parser's document schema.
    */ schema, /**
    This parser's markdown-it tokenizer.
    */ tokenizer, /**
    The value of the `tokens` object used to construct this
    parser. Can be useful to copy and modify to base other parsers
    on.
    */ tokens){
        this.schema = schema;
        this.tokenizer = tokenizer;
        this.tokens = tokens;
        this.tokenHandlers = $9e2db37dbfa373e9$var$tokenHandlers(schema, tokens);
    }
    /**
    Parse a string as [CommonMark](http://commonmark.org/) markup,
    and create a ProseMirror document as prescribed by this parser's
    rules.
    
    The second argument, when given, is passed through to the
    [Markdown
    parser](https://markdown-it.github.io/markdown-it/#MarkdownIt.parse).
    */ parse(text, markdownEnv = {}) {
        let state = new $9e2db37dbfa373e9$var$MarkdownParseState(this.schema, this.tokenHandlers), doc;
        state.parseTokens(this.tokenizer.parse(text, markdownEnv));
        do doc = state.closeNode();
        while (state.stack.length);
        return doc || this.schema.topNodeType.createAndFill();
    }
}
function $9e2db37dbfa373e9$var$listIsTight(tokens, i) {
    while(++i < tokens.length)if (tokens[i].type != "list_item_open") return tokens[i].hidden;
    return false;
}
/**
A parser parsing unextended [CommonMark](http://commonmark.org/),
without inline HTML, and producing a document in the basic schema.
*/ const $9e2db37dbfa373e9$export$7517583227ad0cb8 = new $9e2db37dbfa373e9$export$a64f782182dea128($9e2db37dbfa373e9$export$4902baddc787debb, (0, (/*@__PURE__*/$parcel$interopDefault($k8wSn)))("commonmark", {
    html: false
}), {
    blockquote: {
        block: "blockquote"
    },
    paragraph: {
        block: "paragraph"
    },
    list_item: {
        block: "list_item"
    },
    bullet_list: {
        block: "bullet_list",
        getAttrs: (_, tokens, i)=>({
                tight: $9e2db37dbfa373e9$var$listIsTight(tokens, i)
            })
    },
    ordered_list: {
        block: "ordered_list",
        getAttrs: (tok, tokens, i)=>({
                order: +tok.attrGet("start") || 1,
                tight: $9e2db37dbfa373e9$var$listIsTight(tokens, i)
            })
    },
    heading: {
        block: "heading",
        getAttrs: (tok)=>({
                level: +tok.tag.slice(1)
            })
    },
    code_block: {
        block: "code_block",
        noCloseToken: true
    },
    fence: {
        block: "code_block",
        getAttrs: (tok)=>({
                params: tok.info || ""
            }),
        noCloseToken: true
    },
    hr: {
        node: "horizontal_rule"
    },
    image: {
        node: "image",
        getAttrs: (tok)=>({
                src: tok.attrGet("src"),
                title: tok.attrGet("title") || null,
                alt: tok.children[0] && tok.children[0].content || null
            })
    },
    hardbreak: {
        node: "hard_break"
    },
    em: {
        mark: "em"
    },
    strong: {
        mark: "strong"
    },
    link: {
        mark: "link",
        getAttrs: (tok)=>({
                href: tok.attrGet("href"),
                title: tok.attrGet("title") || null
            })
    },
    code_inline: {
        mark: "code",
        noCloseToken: true
    }
});
/**
A specification for serializing a ProseMirror document as
Markdown/CommonMark text.
*/ class $9e2db37dbfa373e9$export$ae9f6f04acb6c60c {
    /**
    Construct a serializer with the given configuration. The `nodes`
    object should map node names in a given schema to function that
    take a serializer state and such a node, and serialize the node.
    */ constructor(/**
    The node serializer functions for this serializer.
    */ nodes, /**
    The mark serializer info.
    */ marks, options = {}){
        this.nodes = nodes;
        this.marks = marks;
        this.options = options;
    }
    /**
    Serialize the content of the given node to
    [CommonMark](http://commonmark.org/).
    */ serialize(content, options = {}) {
        options = Object.assign({}, this.options, options);
        let state = new $9e2db37dbfa373e9$export$61055fa707e69319(this.nodes, this.marks, options);
        state.renderContent(content);
        return state.out;
    }
}
/**
A serializer for the [basic schema](https://prosemirror.net/docs/ref/#schema).
*/ const $9e2db37dbfa373e9$export$f996452ca6e9a0ae = new $9e2db37dbfa373e9$export$ae9f6f04acb6c60c({
    blockquote (state, node) {
        state.wrapBlock("> ", null, node, ()=>state.renderContent(node));
    },
    code_block (state, node) {
        // Make sure the front matter fences are longer than any dash sequence within it
        const backticks = node.textContent.match(/`{3,}/gm);
        const fence = backticks ? backticks.sort().slice(-1)[0] + "`" : "```";
        state.write(fence + (node.attrs.params || "") + "\n");
        state.text(node.textContent, false);
        // Add a newline to the current content before adding closing marker
        state.write("\n");
        state.write(fence);
        state.closeBlock(node);
    },
    heading (state, node) {
        state.write(state.repeat("#", node.attrs.level) + " ");
        state.renderInline(node, false);
        state.closeBlock(node);
    },
    horizontal_rule (state, node) {
        state.write(node.attrs.markup || "---");
        state.closeBlock(node);
    },
    bullet_list (state, node) {
        state.renderList(node, "  ", ()=>(node.attrs.bullet || "*") + " ");
    },
    ordered_list (state, node) {
        let start = node.attrs.order || 1;
        let maxW = String(start + node.childCount - 1).length;
        let space = state.repeat(" ", maxW + 2);
        state.renderList(node, space, (i)=>{
            let nStr = String(start + i);
            return state.repeat(" ", maxW - nStr.length) + nStr + ". ";
        });
    },
    list_item (state, node) {
        state.renderContent(node);
    },
    paragraph (state, node) {
        state.renderInline(node);
        state.closeBlock(node);
    },
    image (state, node) {
        state.write("![" + state.esc(node.attrs.alt || "") + "](" + node.attrs.src.replace(/[\(\)]/g, "\\$&") + (node.attrs.title ? ' "' + node.attrs.title.replace(/"/g, '\\"') + '"' : "") + ")");
    },
    hard_break (state, node, parent, index) {
        for(let i = index + 1; i < parent.childCount; i++)if (parent.child(i).type != node.type) {
            state.write("\\\n");
            return;
        }
    },
    text (state, node) {
        state.text(node.text, !state.inAutolink);
    }
}, {
    em: {
        open: "*",
        close: "*",
        mixable: true,
        expelEnclosingWhitespace: true
    },
    strong: {
        open: "**",
        close: "**",
        mixable: true,
        expelEnclosingWhitespace: true
    },
    link: {
        open (state, mark, parent, index) {
            state.inAutolink = $9e2db37dbfa373e9$var$isPlainURL(mark, parent, index);
            return state.inAutolink ? "<" : "[";
        },
        close (state, mark, parent, index) {
            let { inAutolink: inAutolink } = state;
            state.inAutolink = undefined;
            return inAutolink ? ">" : "](" + mark.attrs.href.replace(/[\(\)"]/g, "\\$&") + (mark.attrs.title ? ` "${mark.attrs.title.replace(/"/g, '\\"')}"` : "") + ")";
        },
        mixable: true
    },
    code: {
        open (_state, _mark, parent, index) {
            return $9e2db37dbfa373e9$var$backticksFor(parent.child(index), -1);
        },
        close (_state, _mark, parent, index) {
            return $9e2db37dbfa373e9$var$backticksFor(parent.child(index - 1), 1);
        },
        escape: false
    }
});
function $9e2db37dbfa373e9$var$backticksFor(node, side) {
    let ticks = /`+/g, m, len = 0;
    if (node.isText) while(m = ticks.exec(node.text))len = Math.max(len, m[0].length);
    let result = len > 0 && side > 0 ? " `" : "`";
    for(let i = 0; i < len; i++)result += "`";
    if (len > 0 && side < 0) result += " ";
    return result;
}
function $9e2db37dbfa373e9$var$isPlainURL(link, parent, index) {
    if (link.attrs.title || !/^\w+:/.test(link.attrs.href)) return false;
    let content = parent.child(index);
    if (!content.isText || content.text != link.attrs.href || content.marks[content.marks.length - 1] != link) return false;
    return index == parent.childCount - 1 || !link.isInSet(parent.child(index + 1).marks);
}
/**
This is an object used to track state and expose
methods related to markdown serialization. Instances are passed to
node and mark serialization methods (see `toMarkdown`).
*/ class $9e2db37dbfa373e9$export$61055fa707e69319 {
    /**
    @internal
    */ constructor(/**
    @internal
    */ nodes, /**
    @internal
    */ marks, /**
    The options passed to the serializer.
    */ options){
        this.nodes = nodes;
        this.marks = marks;
        this.options = options;
        /**
        @internal
        */ this.delim = "";
        /**
        @internal
        */ this.out = "";
        /**
        @internal
        */ this.closed = null;
        /**
        @internal
        */ this.inAutolink = undefined;
        /**
        @internal
        */ this.atBlockStart = false;
        /**
        @internal
        */ this.inTightList = false;
        if (typeof this.options.tightLists == "undefined") this.options.tightLists = false;
        if (typeof this.options.hardBreakNodeName == "undefined") this.options.hardBreakNodeName = "hard_break";
    }
    /**
    @internal
    */ flushClose(size = 2) {
        if (this.closed) {
            if (!this.atBlank()) this.out += "\n";
            if (size > 1) {
                let delimMin = this.delim;
                let trim = /\s+$/.exec(delimMin);
                if (trim) delimMin = delimMin.slice(0, delimMin.length - trim[0].length);
                for(let i = 1; i < size; i++)this.out += delimMin + "\n";
            }
            this.closed = null;
        }
    }
    /**
    Render a block, prefixing each line with `delim`, and the first
    line in `firstDelim`. `node` should be the node that is closed at
    the end of the block, and `f` is a function that renders the
    content of the block.
    */ wrapBlock(delim, firstDelim, node, f) {
        let old = this.delim;
        this.write(firstDelim != null ? firstDelim : delim);
        this.delim += delim;
        f();
        this.delim = old;
        this.closeBlock(node);
    }
    /**
    @internal
    */ atBlank() {
        return /(^|\n)$/.test(this.out);
    }
    /**
    Ensure the current content ends with a newline.
    */ ensureNewLine() {
        if (!this.atBlank()) this.out += "\n";
    }
    /**
    Prepare the state for writing output (closing closed paragraphs,
    adding delimiters, and so on), and then optionally add content
    (unescaped) to the output.
    */ write(content) {
        this.flushClose();
        if (this.delim && this.atBlank()) this.out += this.delim;
        if (content) this.out += content;
    }
    /**
    Close the block for the given node.
    */ closeBlock(node) {
        this.closed = node;
    }
    /**
    Add the given text to the document. When escape is not `false`,
    it will be escaped.
    */ text(text, escape = true) {
        let lines = text.split("\n");
        for(let i = 0; i < lines.length; i++){
            this.write();
            // Escape exclamation marks in front of links
            if (!escape && lines[i][0] == "[" && /(^|[^\\])\!$/.test(this.out)) this.out = this.out.slice(0, this.out.length - 1) + "\\!";
            this.out += escape ? this.esc(lines[i], this.atBlockStart) : lines[i];
            if (i != lines.length - 1) this.out += "\n";
        }
    }
    /**
    Render the given node as a block.
    */ render(node, parent, index) {
        if (!this.nodes[node.type.name]) throw new Error("Token type `" + node.type.name + "` not supported by Markdown renderer");
        this.nodes[node.type.name](this, node, parent, index);
    }
    /**
    Render the contents of `parent` as block nodes.
    */ renderContent(parent) {
        parent.forEach((node, _, i)=>this.render(node, parent, i));
    }
    /**
    Render the contents of `parent` as inline content.
    */ renderInline(parent, fromBlockStart = true) {
        this.atBlockStart = fromBlockStart;
        let active = [], trailing = "";
        let progress = (node, offset, index)=>{
            let marks = node ? node.marks : [];
            // Remove marks from `hard_break` that are the last node inside
            // that mark to prevent parser edge cases with new lines just
            // before closing marks.
            if (node && node.type.name === this.options.hardBreakNodeName) marks = marks.filter((m)=>{
                if (index + 1 == parent.childCount) return false;
                let next = parent.child(index + 1);
                return m.isInSet(next.marks) && (!next.isText || /\S/.test(next.text));
            });
            let leading = trailing;
            trailing = "";
            // If whitespace has to be expelled from the node, adjust
            // leading and trailing accordingly.
            if (node && node.isText && marks.some((mark)=>{
                let info = this.marks[mark.type.name];
                return info && info.expelEnclosingWhitespace && !mark.isInSet(active);
            })) {
                let [_, lead, rest] = /^(\s*)(.*)$/m.exec(node.text);
                if (lead) {
                    leading += lead;
                    node = rest ? node.withText(rest) : null;
                    if (!node) marks = active;
                }
            }
            if (node && node.isText && marks.some((mark)=>{
                let info = this.marks[mark.type.name];
                return info && info.expelEnclosingWhitespace && (index == parent.childCount - 1 || !mark.isInSet(parent.child(index + 1).marks));
            })) {
                let [_, rest, trail] = /^(.*?)(\s*)$/m.exec(node.text);
                if (trail) {
                    trailing = trail;
                    node = rest ? node.withText(rest) : null;
                    if (!node) marks = active;
                }
            }
            let inner = marks.length ? marks[marks.length - 1] : null;
            let noEsc = inner && this.marks[inner.type.name].escape === false;
            let len = marks.length - (noEsc ? 1 : 0);
            // Try to reorder 'mixable' marks, such as em and strong, which
            // in Markdown may be opened and closed in different order, so
            // that order of the marks for the token matches the order in
            // active.
            outer: for(let i = 0; i < len; i++){
                let mark = marks[i];
                if (!this.marks[mark.type.name].mixable) break;
                for(let j = 0; j < active.length; j++){
                    let other = active[j];
                    if (!this.marks[other.type.name].mixable) break;
                    if (mark.eq(other)) {
                        if (i > j) marks = marks.slice(0, j).concat(mark).concat(marks.slice(j, i)).concat(marks.slice(i + 1, len));
                        else if (j > i) marks = marks.slice(0, i).concat(marks.slice(i + 1, j)).concat(mark).concat(marks.slice(j, len));
                        continue outer;
                    }
                }
            }
            // Find the prefix of the mark set that didn't change
            let keep = 0;
            while(keep < Math.min(active.length, len) && marks[keep].eq(active[keep]))++keep;
            // Close the marks that need to be closed
            while(keep < active.length)this.text(this.markString(active.pop(), false, parent, index), false);
            // Output any previously expelled trailing whitespace outside the marks
            if (leading) this.text(leading);
            // Open the marks that need to be opened
            if (node) {
                while(active.length < len){
                    let add = marks[active.length];
                    active.push(add);
                    this.text(this.markString(add, true, parent, index), false);
                    this.atBlockStart = false;
                }
                // Render the node. Special case code marks, since their content
                // may not be escaped.
                if (noEsc && node.isText) this.text(this.markString(inner, true, parent, index) + node.text + this.markString(inner, false, parent, index + 1), false);
                else this.render(node, parent, index);
                this.atBlockStart = false;
            }
            // After the first non-empty text node is rendered, the end of output
            // is no longer at block start.
            //
            // FIXME: If a non-text node writes something to the output for this
            // block, the end of output is also no longer at block start. But how
            // can we detect that?
            if ((node === null || node === void 0 ? void 0 : node.isText) && node.nodeSize > 0) this.atBlockStart = false;
        };
        parent.forEach(progress);
        progress(null, 0, parent.childCount);
        this.atBlockStart = false;
    }
    /**
    Render a node's content as a list. `delim` should be the extra
    indentation added to all lines except the first in an item,
    `firstDelim` is a function going from an item index to a
    delimiter for the first line of the item.
    */ renderList(node, delim, firstDelim) {
        if (this.closed && this.closed.type == node.type) this.flushClose(3);
        else if (this.inTightList) this.flushClose(1);
        let isTight = typeof node.attrs.tight != "undefined" ? node.attrs.tight : this.options.tightLists;
        let prevTight = this.inTightList;
        this.inTightList = isTight;
        node.forEach((child, _, i)=>{
            if (i && isTight) this.flushClose(1);
            this.wrapBlock(delim, firstDelim(i), node, ()=>this.render(child, node, i));
        });
        this.inTightList = prevTight;
    }
    /**
    Escape the given string so that it can safely appear in Markdown
    content. If `startOfLine` is true, also escape characters that
    have special meaning only at the start of the line.
    */ esc(str, startOfLine = false) {
        str = str.replace(/[`*\\~\[\]_]/g, (m, i)=>m == "_" && i > 0 && i + 1 < str.length && str[i - 1].match(/\w/) && str[i + 1].match(/\w/) ? m : "\\" + m);
        if (startOfLine) str = str.replace(/^(\+[ ]|[\-*>])/, "\\$&").replace(/^(\s*)(#{1,6})(\s|$)/, '$1\\$2$3').replace(/^(\s*\d+)\.\s/, "$1\\. ");
        if (this.options.escapeExtraCharacters) str = str.replace(this.options.escapeExtraCharacters, "\\$&");
        return str;
    }
    /**
    @internal
    */ quote(str) {
        let wrap = str.indexOf('"') == -1 ? '""' : str.indexOf("'") == -1 ? "''" : "()";
        return wrap[0] + str + wrap[1];
    }
    /**
    Repeat the given string `n` times.
    */ repeat(str, n) {
        let out = "";
        for(let i = 0; i < n; i++)out += str;
        return out;
    }
    /**
    Get the markdown string for a given opening or closing mark.
    */ markString(mark, open, parent, index) {
        let info = this.marks[mark.type.name];
        let value = open ? info.open : info.close;
        return typeof value == "string" ? value : value(this, mark, parent, index);
    }
    /**
    Get leading and trailing whitespace from a string. Values of
    leading or trailing property of the return object will be undefined
    if there is no match.
    */ getEnclosingWhitespace(text) {
        return {
            leading: (text.match(/^(\s+)/) || [
                undefined
            ])[0],
            trailing: (text.match(/(\s+)$/) || [
                undefined
            ])[0]
        };
    }
}

});

parcelRegister("6jrty", function(module, exports) {

$parcel$export(module.exports, "filterMdToPmSchemaMapping", () => $4989d482dc29998e$export$a9d25ff08f358d72);
$parcel$export(module.exports, "PM_SCHEMA_TO_MD_MAPPING", () => $4989d482dc29998e$export$b535e2638dcce02);
$parcel$export(module.exports, "getMdToPmMapping", () => $4989d482dc29998e$export$8f853a1c35ed8bbe);
function $4989d482dc29998e$export$a9d25ff08f358d72(schema, map) {
    return Object.keys(map).reduce((newMap, key)=>{
        const value = map[key];
        const block = value.block || value.node;
        const mark = value.mark;
        if (block && schema.nodes[block] || mark && schema.marks[mark]) newMap[key] = value;
        return newMap;
    }, {});
}
const $4989d482dc29998e$export$b535e2638dcce02 = {
    nodes: {
        blockquote: 'blockquote',
        paragraph: 'paragraph',
        rule: 'hr',
        // lheading (---, ===)
        heading: [
            'heading',
            'lheading'
        ],
        codeBlock: [
            'code',
            'fence'
        ],
        listItem: 'list',
        image: 'image'
    },
    marks: {
        em: 'emphasis',
        strong: 'text',
        link: [
            'link',
            'autolink',
            'reference',
            'linkify'
        ],
        strike: 'strikethrough',
        code: 'backticks'
    }
};
const $4989d482dc29998e$export$8f853a1c35ed8bbe = (extendMarkdownSupport)=>({
        blockquote: {
            block: 'blockquote'
        },
        paragraph: {
            block: 'paragraph'
        },
        em: {
            mark: 'em'
        },
        strong: {
            mark: 'strong'
        },
        link: {
            mark: 'link',
            attrs: (tok)=>{
                // @ts-ignore
                if (tok.pmAttrs) // @ts-ignore
                return tok.pmAttrs;
                else return {
                    href: tok.attrGet('href'),
                    title: tok.attrGet('title') || null
                };
            }
        },
        hr: {
            node: 'rule'
        },
        heading: {
            block: 'heading',
            attrs: (tok)=>({
                    level: +tok.tag.slice(1)
                })
        },
        softbreak: {
            node: 'hardBreak'
        },
        hardbreak: {
            node: 'hardBreak'
        },
        code_block: {
            block: 'codeBlock'
        },
        list_item: {
            block: 'listItem'
        },
        bullet_list: {
            block: 'bulletList'
        },
        ordered_list: {
            block: 'orderedList',
            attrs: (tok)=>({
                    order: typeof tok.attrGet('start') === 'number' ? tok.attrGet('start') : 1
                })
        },
        code_inline: {
            mark: 'code'
        },
        code: {
            mark: 'code'
        },
        fence: {
            block: 'codeBlock',
            // we trim any whitespaces around language definition
            attrs: (tok)=>({
                    language: tok.info && tok.info.trim() || null
                })
        },
        mediaInline: {
            node: 'mediaInline',
            attrs: (token)=>{
                if (extendMarkdownSupport) // @ts-ignore
                return token.pmAttrs;
                return {};
            }
        },
        media_single: {
            block: 'mediaSingle',
            attrs: (token)=>{
                if (extendMarkdownSupport) // @ts-ignore
                return token.pmAttrs;
                return {};
            }
        },
        media: {
            node: 'media',
            attrs: (token)=>{
                if (extendMarkdownSupport) // @ts-ignore
                return token.pmAttrs;
                return {
                    url: token.attrGet('url'),
                    type: 'external'
                };
            }
        },
        caption: {
            block: 'caption',
            attrs: (token)=>{
                // @ts-ignore
                return token.pmAttrs;
            }
        },
        alignment: {
            mark: 'alignment',
            attrs: (token)=>{
                // @ts-ignore
                return token.pmAttrs;
            }
        },
        breakout: {
            mark: 'breakout',
            attrs: (token)=>{
                // @ts-ignore
                return token.pmAttrs;
            }
        },
        border: {
            mark: 'border',
            attrs: (token)=>{
                // @ts-ignore
                return token.pmAttrs;
            }
        },
        textColor: {
            mark: 'textColor',
            attrs: (token)=>{
                // @ts-ignore
                return token.pmAttrs;
            }
        },
        underline: {
            mark: 'underline',
            attrs: (token)=>{
                // @ts-ignore
                return token.pmAttrs;
            }
        },
        subsup: {
            mark: 'subsup',
            attrs: (token)=>{
                // @ts-ignore
                return token.pmAttrs;
            }
        },
        emoji: {
            node: 'emoji',
            attrs: (token)=>{
                if (extendMarkdownSupport) // @ts-ignore
                return token.pmAttrs;
                return {
                    shortName: `:${token.markup}:`,
                    text: token.content
                };
            }
        },
        inlineCard: {
            node: 'inlineCard',
            attrs: (token)=>{
                // @ts-ignore
                return token.pmAttrs;
            }
        },
        date: {
            node: 'date',
            attrs: (token)=>{
                // @ts-ignore
                return token.pmAttrs;
            }
        },
        status: {
            node: 'status',
            attrs: (token)=>{
                // @ts-ignore
                return token.pmAttrs;
            }
        },
        mention: {
            node: 'mention',
            attrs: (token)=>{
                // @ts-ignore
                return token.pmAttrs;
            }
        },
        table: {
            block: 'table',
            attrs: (token)=>{
                // @ts-ignore
                return token.pmAttrs;
            }
        },
        tr: {
            block: 'tableRow',
            attrs: (token)=>{
                // @ts-ignore
                return token.pmAttrs;
            }
        },
        th: {
            block: 'tableHeader',
            attrs: (token)=>{
                // @ts-ignore
                return token.pmAttrs;
            }
        },
        td: {
            block: 'tableCell',
            attrs: (token)=>{
                // @ts-ignore
                return token.pmAttrs;
            }
        },
        s: {
            mark: 'strike'
        },
        strike: {
            mark: 'strike'
        },
        task_list: {
            block: 'taskList'
        },
        task_item: {
            block: 'taskItem',
            attrs: (tok)=>({
                    state: tok.meta
                })
        },
        layoutSection: {
            block: 'layoutSection',
            attrs: (token)=>{
                // @ts-ignore
                return token.pmAttrs;
            }
        },
        layoutColumn: {
            block: 'layoutColumn',
            attrs: (token)=>{
                // @ts-ignore
                return token.pmAttrs;
            }
        },
        panel: {
            block: 'panel',
            attrs: (token)=>{
                // @ts-ignore
                return token.pmAttrs;
            }
        },
        decisionList: {
            block: 'decisionList',
            attrs: (token)=>{
                // @ts-ignore
                return token.pmAttrs;
            }
        },
        decisionItem: {
            block: 'decisionItem',
            attrs: (token)=>{
                // @ts-ignore
                return token.pmAttrs;
            }
        },
        expand: {
            block: 'expand',
            attrs: (token)=>{
                // @ts-ignore
                return token.pmAttrs;
            }
        },
        extension: {
            node: 'extension',
            attrs: (token)=>{
                // @ts-ignore
                return token.pmAttrs;
            }
        },
        bodiedExtension: {
            block: 'bodiedExtension',
            attrs: (token)=>{
                // @ts-ignore
                return token.pmAttrs;
            }
        },
        nestedExpand: {
            block: 'nestedExpand',
            attrs: (token)=>{
                // @ts-ignore
                return token.pmAttrs;
            }
        },
        inlineExtension: {
            node: 'inlineExtension',
            attrs: (token)=>{
                // @ts-ignore
                return token.pmAttrs;
            }
        }
    });

});

parcelRegister("9GnoM", function(module, exports) {

$parcel$export(module.exports, "default", () => $70ca2fcad1d9c1c1$export$2e2bcd8739ae039);
const $70ca2fcad1d9c1c1$var$captionOpen = 'caption_open';
const $70ca2fcad1d9c1c1$var$paragraphOpen = 'paragraph_open';
const $70ca2fcad1d9c1c1$var$paragraphClose = 'paragraph_close';
function $70ca2fcad1d9c1c1$export$eee367902819022(index, tokens) {
    var _tokens$index, _tokens, _tokens2;
    // make sure we have an opening and closing paragraph token
    if (((_tokens$index = tokens[index]) === null || _tokens$index === void 0 ? void 0 : _tokens$index.type) !== $70ca2fcad1d9c1c1$var$paragraphOpen && ((_tokens = tokens[index + 2]) === null || _tokens === void 0 ? void 0 : _tokens.type) !== $70ca2fcad1d9c1c1$var$paragraphClose) return;
    // remove the closing paragraph token from state.tokens so we don't add it into the acc
    // when we loop through the tokens
    ((_tokens2 = tokens[index + 2]) === null || _tokens2 === void 0 ? void 0 : _tokens2.type) === $70ca2fcad1d9c1c1$var$paragraphClose && tokens.splice(index + 2, 1);
    // return empty to prevent adding the opening token to the acc
    return;
}
function $70ca2fcad1d9c1c1$export$2e2bcd8739ae039(md, idMap) {
    md.core.ruler.after('custom-block', 'caption', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            var _acc;
            const { type: type } = token;
            const isWithinCaption = ((_acc = acc[acc.length - 1]) === null || _acc === void 0 ? void 0 : _acc.type) === $70ca2fcad1d9c1c1$var$captionOpen;
            if (type === $70ca2fcad1d9c1c1$var$paragraphOpen && isWithinCaption) /**
         * paragraph_open and paragraph_close tokens get automatically added by markdown-it
         * around text content. caption nodes do not allow paragraph nodes as children
         * so we need to prevent these tokens from being added to the acc
         */ $70ca2fcad1d9c1c1$export$eee367902819022(index, state.tokens);
            else acc.push(token);
            return acc;
        }, []);
    });
}

});

parcelRegister("696i6", function(module, exports) {

$parcel$export(module.exports, "default", () => $4798769da14d6577$export$2e2bcd8739ae039);

var $cSopm = parcelRequire("cSopm");
// Some nodes will be inline but it's content will be empty.
// That's why, don't remove paragraphs wrapping it.
// For example, inlineExtension is inline node, so there should be no content inside it.
//  So it's custom element is represented by <custom data-type="inlineExtension" ... />
const $4798769da14d6577$var$emptyInlineCustomNodes = [
    'inlineExtension'
];
function $4798769da14d6577$export$2e2bcd8739ae039(md, idMap, htmlConversionCounts) {
    md.core.ruler.after('inline', 'custom-block', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            var _match$groups;
            const match = token.content.match(/**
       * Matches the following:
       * <custom data-type="smartlink" data-id="123" />
       * <custom data-type="smartlink" />
       */ /<custom\s+data-type="(?<dataType>.*?)"\s*(data-id="(?<dataId>.*?)"\s*)?\/>/);
            const dataType = match === null || match === void 0 ? void 0 : (_match$groups = match.groups) === null || _match$groups === void 0 ? void 0 : _match$groups.dataType;
            if (match && dataType && !$4798769da14d6577$var$emptyInlineCustomNodes.includes(dataType)) {
                var _match$groups2;
                const dataId = (_match$groups2 = match.groups) === null || _match$groups2 === void 0 ? void 0 : _match$groups2.dataId;
                if (dataType) {
                    htmlConversionCounts.htmlConvertedToNodes++;
                    const customElementToken = (0, $cSopm.createToken)(state, dataType);
                    if (dataId && idMap[dataId]) // @ts-ignore
                    customElementToken.pmAttrs = idMap[dataId].attributes;
                    /**
           * When the custom tag goes through the tokenizer it is transformed into this structure:
           * paragraph_open
           * inline
           * paragraph_close
           *
           * so the following section removes the wrapping paragraph tokens
           */ acc.splice(acc.length - 1, 1);
                    state.tokens.splice(index + 1, 1);
                    // We then push replace the inline token with our custom token
                    acc.push(customElementToken);
                } else {
                    htmlConversionCounts.htmlConvertedToFallbackNodes++;
                    acc.push(token);
                }
            } else acc.push(token);
            return acc;
        }, []);
    });
}

});
parcelRegister("cSopm", function(module, exports) {

$parcel$export(module.exports, "createToken", () => $95fd761fed4774dd$export$c255480b061bd6aa);
function $95fd761fed4774dd$export$c255480b061bd6aa(state, type, level) {
    let nesting;
    if (type.includes('_open')) nesting = 1;
    else if (type.includes('_close')) nesting = -1;
    else nesting = 0;
    const token = new state.Token(type, '', nesting);
    if (level) token.level = level;
    return token;
}

});


parcelRegister("9dukA", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b5cdb0e86d98b0c$export$2e2bcd8739ae039);

var $jvz50 = parcelRequire("jvz50");
function $6b5cdb0e86d98b0c$export$2e2bcd8739ae039(md, idMap, featureToggles, htmlConversionCounts) {
    const rule = md.inline.ruler.before('text', 'custom', function(state, silent) {
        var _match$groups, _match$groups2, _match$groups3;
        const start = state.pos;
        const origSrc = state.src;
        const match = state.src.slice(start).match(/**
     * Matches the following:
     * <custom data-type="smartlink" data-id="123">content</custom>
     * <custom data-id="123">content</custom>
     * <custom data-type="emoji">content</custom>
     * <custom>content</custom>
     */ /<custom(\sdata-(type|id)="(?<dataType>.*?)")?(\sdata-(type|id)="(?<dataId>.*?)")?>(?<dataContent>.*?)<\/custom>/);
        if (!match) return false;
        const tagLength = match[0].length;
        const beforeTag = state.src.slice(start, state.src.indexOf(match[0]));
        const dataType = (_match$groups = match.groups) === null || _match$groups === void 0 ? void 0 : _match$groups.dataType;
        const dataId = (_match$groups2 = match.groups) === null || _match$groups2 === void 0 ? void 0 : _match$groups2.dataId;
        const dataContent = (_match$groups3 = match.groups) === null || _match$groups3 === void 0 ? void 0 : _match$groups3.dataContent;
        const afterTag = state.src.slice(start + beforeTag.length + tagLength);
        function mapCustomDataTypeToNodeType(customDataType) {
            switch(customDataType){
                case 'smartlink':
                    return 'inlineCard';
                case 'date':
                case 'emoji':
                case 'status':
                case 'mention':
                    return customDataType;
                // Just move below case alongside mention above to remove markdownPlusExtensions FF.
                case 'inlineExtension':
                    return featureToggles.markdownPlusV2 && featureToggles.markdownPlusExtensions ? 'inlineExtension' : false;
                case 'mediaInline':
                    return featureToggles.markdownPlusMedia ? 'mediaInline' : false;
                default:
                    // TODO track invalid cards
                    return false;
            }
        }
        const customDataType = mapCustomDataTypeToNodeType(dataType);
        if (!silent) {
            var _idMap$dataId, _idMap$dataId2, _idMap$dataId2$marks;
            // tokenize beforeTag
            if (beforeTag) {
                state.src = beforeTag;
                // @ts-ignore
                state.md.inline.tokenize(state, beforeTag);
            }
            if (dataId && idMap !== null && idMap !== void 0 && (_idMap$dataId = idMap[dataId]) !== null && _idMap$dataId !== void 0 && _idMap$dataId.attributes && customDataType) {
                htmlConversionCounts.htmlConvertedToNodes++;
                const customDataToken = state.push(customDataType, '', 0);
                // @ts-ignore
                customDataToken.pmAttrs = idMap[dataId].attributes;
            // Handle marks for text nodes
            } else if (featureToggles.markdownPlusMarks && dataId && idMap !== null && idMap !== void 0 && (_idMap$dataId2 = idMap[dataId]) !== null && _idMap$dataId2 !== void 0 && (_idMap$dataId2$marks = _idMap$dataId2.marks) !== null && _idMap$dataId2$marks !== void 0 && _idMap$dataId2$marks.length && dataType === 'text') {
                const { marks: marks } = idMap === null || idMap === void 0 ? void 0 : idMap[dataId];
                const openingTokens = [];
                const closingTokens = [];
                marks.forEach((mark)=>{
                    const markName = mark.type.name || mark.type;
                    const openingToken = new (0, (/*@__PURE__*/$parcel$interopDefault($jvz50)))(`${markName}_open`, '', 1);
                    const closingToken = new (0, (/*@__PURE__*/$parcel$interopDefault($jvz50)))(`${markName}_close`, '', -1);
                    // @ts-ignore
                    openingToken.pmAttrs = mark.attrs;
                    openingTokens.push(openingToken);
                    closingTokens.unshift(closingToken);
                });
                let textToken = new (0, (/*@__PURE__*/$parcel$interopDefault($jvz50)))('text', '', 0);
                if (match && (match[0] || dataContent)) textToken.content = dataContent || match[0];
                state.tokens.push(...openingTokens, textToken, ...closingTokens);
            } else {
                htmlConversionCounts.htmlConvertedToFallbackNodes++;
                const textToken = state.push('text', '', 0);
                // If there is no data content we want to hide the custom tags as the AI has hallucinated something
                if (!dataContent) textToken.content = '';
                else textToken.content = dataContent || match[0];
            }
            if (afterTag) {
                state.src = afterTag;
                state.pos = 0;
                // @ts-ignore
                state.md.inline.tokenize(state, afterTag);
            }
        }
        state.src = origSrc;
        state.pos = start + state.src.length;
        return true;
    });
    return rule;
}

});

parcelRegister("dTcF8", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1ca3beba652f2ed$export$2e2bcd8739ae039);
const $a1ca3beba652f2ed$var$decisionItemOpen = 'decisionItem_open';
const $a1ca3beba652f2ed$var$paragraphOpen = 'paragraph_open';
const $a1ca3beba652f2ed$var$paragraphClose = 'paragraph_close';
const $a1ca3beba652f2ed$var$inline = 'inline';
function $a1ca3beba652f2ed$var$handleParagraphs(acc, token) {
    var _acc;
    /**
   * Traverse up the acc token array, and if a chain of one or more inline tokens are under
   * a decisionItem_open token, then it is considered to be a paragraph_close token within
   * a decision item.
   *
   * This also works for a paragraph_open token as inlineCount would be zero meaning that
   * the conditional applies to when decisionItem_open is right above paragraph_open.
   */ let inlineCount = 0;
    let inlineChainEnded = false;
    for(let i = acc.length - 1; i >= 0; i--){
        var _acc$i;
        const type = (_acc$i = acc[i]) === null || _acc$i === void 0 ? void 0 : _acc$i.type;
        if (!inlineChainEnded) {
            if (type === $a1ca3beba652f2ed$var$inline) inlineCount += 1;
            else inlineChainEnded = true;
        }
    }
    const isWithinDecisionItem = ((_acc = acc[acc.length - (inlineCount + 1)]) === null || _acc === void 0 ? void 0 : _acc.type) === $a1ca3beba652f2ed$var$decisionItemOpen;
    if (!isWithinDecisionItem) acc.push(token);
}
function $a1ca3beba652f2ed$export$2e2bcd8739ae039(md, idMap) {
    md.core.ruler.after('custom-block', 'decision-list', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const { type: type } = token;
            if (type === $a1ca3beba652f2ed$var$paragraphOpen || type === $a1ca3beba652f2ed$var$paragraphClose) $a1ca3beba652f2ed$var$handleParagraphs(acc, token);
            else acc.push(token);
            return acc;
        }, []);
    });
}

});

parcelRegister("6gudU", function(module, exports) {

$parcel$export(module.exports, "default", () => $48fbae6ecefae96d$export$2e2bcd8739ae039);
// File copied from packages/editor/editor-core/src/plugins/paste/linkify-md-plugin.ts

var $dVFtG = parcelRequire("dVFtG");

var $4N6cH = parcelRequire("4N6cH");

var $7rHFe = parcelRequire("7rHFe");
// modified version of the original Linkify plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js
const $48fbae6ecefae96d$var$arrayReplaceAt = (src, pos, newElements)=>{
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
};
const $48fbae6ecefae96d$var$isLinkOpen = (str)=>{
    return /^<a[>\s]/i.test(str);
};
const $48fbae6ecefae96d$var$isLinkClose = (str)=>{
    return /^<\/a\s*>/i.test(str);
};
const $48fbae6ecefae96d$var$linkify = (state)=>{
    const blockTokens = state.tokens;
    const linkify = new (0, (/*@__PURE__*/$parcel$interopDefault($dVFtG)))();
    for(let j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline' || !linkify.pretest(blockTokens[j].content)) continue;
        let tokens = blockTokens[j].children;
        let htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(let i = tokens.length - 1; i >= 0; i--){
            const currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === 'link_close') {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === 'html_inline') {
                if ($48fbae6ecefae96d$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($48fbae6ecefae96d$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === 'text' && linkify.test(currentToken.content)) {
                const text = currentToken.content;
                let links = (0, $4N6cH.linkifyMatch)(text);
                if (!links.length) links = linkify.match(text) || [];
                // Now split string to nodes
                const nodes = [];
                let level = currentToken.level;
                let lastPos = 0;
                const filepaths = (0, $7rHFe.findFilepaths)(text);
                for(let ln = 0; ln < links.length; ln++){
                    if ((0, $7rHFe.isLinkInMatches)(links[ln].index, filepaths)) continue;
                    const { url: url } = links[ln];
                    const fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    let urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) urlText = state.md.normalizeLinkText('http://' + urlText).replace(/^http:\/\//, '');
                    else if (links[ln].schema === 'mailto:' && !/^mailto:/i.test(urlText)) urlText = state.md.normalizeLinkText('mailto:' + urlText).replace(/^mailto:/, '');
                    else urlText = state.md.normalizeLinkText(urlText);
                    const pos = links[ln].index;
                    if (pos > lastPos) {
                        const token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    let token = new state.Token('link_open', 'a', 1);
                    token.attrs = [
                        [
                            'href',
                            fullUrl
                        ]
                    ];
                    token.level = level++;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    token = new state.Token('text', '', 0);
                    token.content = urlText;
                    token.level = level;
                    nodes.push(token);
                    token = new state.Token('link_close', 'a', -1);
                    token.level = --level;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    const token = new state.Token('text', '', 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = $48fbae6ecefae96d$var$arrayReplaceAt(tokens, i, nodes);
            }
        }
    }
};
var $48fbae6ecefae96d$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('custom-linkify', $48fbae6ecefae96d$var$linkify);

});
parcelRegister("7rHFe", function(module, exports) {

$parcel$export(module.exports, "findFilepaths", () => $56bcecce313dfa4c$export$d37783fe63e2f0fe);
$parcel$export(module.exports, "isLinkInMatches", () => $56bcecce313dfa4c$export$5e652e74655163e5);
$parcel$export(module.exports, "escapeLinks", () => $56bcecce313dfa4c$export$8acd10161c5f8b07);
// File copied from packages/editor/editor-core/src/plugins/hyperlink/utils.ts
// Regular expression for a windows filepath in the format <DRIVE LETTER>:\<folder name>\
const $56bcecce313dfa4c$export$893fccbed37586dd = /([a-zA-Z]:|\\)([^\/:*?<>"|]+\\)?([^\/:*?<>"| ]+(?=\s?))?/gim;
const $56bcecce313dfa4c$export$d37783fe63e2f0fe = (text, offset = 0)=>{
    // Creation of a copy of the RegExp is necessary as lastIndex is stored on it when we run .exec()
    const localRegExp = new RegExp($56bcecce313dfa4c$export$893fccbed37586dd);
    let match;
    const matchesList = [];
    const maxFilepathSize = 260;
    while((match = localRegExp.exec(text)) !== null){
        const start = match.index + offset;
        let end = localRegExp.lastIndex + offset;
        if (end - start > maxFilepathSize) end = start + maxFilepathSize;
         // We don't care about big strings of text that are pretending to be filepaths!!
        matchesList.push({
            startIndex: start,
            endIndex: end
        });
    }
    return matchesList;
};
const $56bcecce313dfa4c$export$5e652e74655163e5 = (linkStart, matchesList)=>{
    for(let i = 0; i < matchesList.length; i++){
        if (linkStart >= matchesList[i].startIndex && linkStart < matchesList[i].endIndex) return true;
    }
    return false;
};
function $56bcecce313dfa4c$export$8acd10161c5f8b07(text) {
    return text.replace(/(\[([^\]]+)\]\()?((https?|ftp|jamfselfservice):\/\/[^\s]+)/g, (str)=>{
        return str.match(/^(https?|ftp|jamfselfservice):\/\/[^\s]+$/) ? `<${str}>` : str;
    });
}

});


parcelRegister("aGE35", function(module, exports) {

$parcel$export(module.exports, "markdownItMedia", () => $7c7ce47d16eb66c0$export$c8dcbd316b71f8cf);
// File copied from packages/editor/editor-markdown-transformer/src/media.ts
function $7c7ce47d16eb66c0$var$createRule() {
    const regx = /!\[[^\]]*\]\([^)]+\)/g;
    const validParentTokens = [
        'th_open',
        'td_open',
        'list_item_open'
    ];
    /**
   * This function looks for strings that matches ![description](url) inside Inline-tokens.
   * It will then split the Inline-token with content before and after the image, example:
   *
   * Input (tokens):
   *   paragraph_open
   *   inline - content: Hello ![](image.jpg) World!
   *   paragraph_close
   * Output (tokens):
   *   paragraph_open
   *   inline - content: Hello
   *   paragraph_close
   *   media_single_open
   *   media
   *   media_single_close
   *   paragraph_open
   *   inline - content: World!
   *   paragraph_close
   *
   * This is applied before the inline content is parsed, to ensure that the formatting of
   * remaining inline content (bold, links, etc.) is kept intact!
   */ return function media(State) {
        const getUrl = (str)=>{
            const res = State.md.helpers.parseLinkDestination(str, str.indexOf('(') + 1, str.length);
            if (res.ok) {
                const href = State.md.normalizeLink(res.str);
                if (State.md.validateLink(href)) return href;
            }
            return '';
        };
        const createMediaTokens = (url)=>{
            const mediaSingleOpen = new State.Token('media_single_open', '', 1);
            const media = new State.Token('media', '', 0);
            media.attrs = [
                [
                    'url',
                    getUrl(url)
                ],
                [
                    'type',
                    'external'
                ]
            ];
            const mediaSingleClose = new State.Token('media_single_close', '', -1);
            return [
                mediaSingleOpen,
                media,
                mediaSingleClose
            ];
        };
        const createInlineTokens = (str, openingTokens, closingTokens)=>{
            if (!str || str.length === 0) return [];
            const inlineBefore = new State.Token('inline', '', 1);
            inlineBefore.content = str;
            inlineBefore.children = [];
            return [
                ...openingTokens,
                inlineBefore,
                ...closingTokens
            ];
        };
        let processedTokens = [];
        const newTokens = State.tokens.reduce((tokens, token, i, arr)=>{
            if (token.type === 'inline' && regx.test(token.content)) {
                const openingTokens = [];
                let cursor = i - 1;
                let previousToken = arr[cursor];
                let subTree = [];
                while(previousToken && previousToken.level > 0 && validParentTokens.indexOf(previousToken.type) === -1){
                    openingTokens.unshift(previousToken);
                    cursor--;
                    previousToken = arr[cursor];
                }
                if (validParentTokens.indexOf(previousToken.type) === -1) openingTokens.unshift(previousToken);
                else cursor++;
                const closingTokens = openingTokens.map((token)=>new State.Token(token.type.replace('_open', '_close'), token.tag, -1)).reverse();
                const matches = token.content.match(regx);
                let inlineContentStack = token.content;
                matches.forEach((match)=>{
                    const start = inlineContentStack.indexOf(match);
                    const contentBefore = inlineContentStack.substr(0, start);
                    inlineContentStack = inlineContentStack.substr(start + match.length);
                    subTree = [
                        ...subTree,
                        ...createInlineTokens(contentBefore, openingTokens, closingTokens),
                        ...createMediaTokens(match)
                    ];
                });
                if (inlineContentStack.length) subTree = [
                    ...subTree,
                    ...createInlineTokens(inlineContentStack, openingTokens, closingTokens)
                ];
                processedTokens = [
                    ...processedTokens,
                    ...closingTokens.map((c)=>c.type)
                ];
                tokens = [
                    ...tokens.slice(0, cursor),
                    ...subTree
                ];
            } else if (processedTokens.indexOf(token.type) !== -1) // Ignore token if it's already processed
            processedTokens.splice(processedTokens.indexOf(token.type), 1);
            else tokens.push(token);
            return tokens;
        }, []);
        State.tokens = newTokens;
        return true;
    };
}
const $7c7ce47d16eb66c0$export$c8dcbd316b71f8cf = (md)=>{
    md.core.ruler.before('inline', 'media', $7c7ce47d16eb66c0$var$createRule());
};

});

parcelRegister("e0eRy", function(module, exports) {

$parcel$export(module.exports, "default", () => $a31c983884e73c77$export$2e2bcd8739ae039);
// file copied from packages/editor/editor-core/src/plugins/paste/newline-md-plugin.ts
// ED-15363: modified version of the original newline plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_inline/newline.js
const $a31c983884e73c77$var$newline = (state, silent)=>{
    let pmax, // ED-15363: unread variables
    // max,
    // ws,
    pos = state.pos;
    if (state.src.charCodeAt(pos) !== 0x0a /* \n */ ) return false;
    pmax = state.pending.length - 1;
    // ED-15363: unread variable
    // max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) // ED-15363: We commented out this logic to preserve trailing whitespaces
            // for each line of text when pasting plain text
            // // Find whitespaces tail of pending chars.
            // ws = pmax - 1;
            // while (ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20) {
            //   ws--;
            // }
            // state.pending = state.pending.slice(0, ws);
            state.push('hardbreak', 'br', 0);
            else {
                state.pending = state.pending.slice(0, -1);
                state.push('softbreak', 'br', 0);
            }
        } else state.push('softbreak', 'br', 0);
    }
    pos++;
    // ED-15363: We commented out this logic from the original library to
    // preserve leading whitespaces for each line of text when pasting plain
    // text (to preserve whitespace-based indentation).
    // // skip heading spaces for next line
    // while (pos < max && isSpace(state.src.charCodeAt(pos))) {
    //   pos++;
    // }
    state.pos = pos;
    return true;
};
var $a31c983884e73c77$export$2e2bcd8739ae039 = (md)=>md.inline.ruler.at('newline', $a31c983884e73c77$var$newline);

});

parcelRegister("kgeKs", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec00bdf8b1b03eef$export$2e2bcd8739ae039);
// File copied from packages/editor/editor-core/src/plugins/paste/paragraph-md-plugin.ts
// ED-15363: modified version of the original paragraph plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_block/paragraph.js
const $ec00bdf8b1b03eef$var$paragraph = (state, startLine)=>{
    let content, terminate, i, l, token, oldParentType, nextLine = startLine + 1, terminatorRules = state.md.block.ruler.getRules('paragraph'), endLine = state.lineMax;
    oldParentType = state.parentType;
    state.parentType = 'paragraph';
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    // ED-15363: We removed .trim() from this logic from the original library to
    // preserve leading whitespaces at the beginning and end of paragraph blocks
    // when pasting plain text (to preserve whitespace-based indentation, at the
    // beginning and end of paragraphs).
    // content = state.getLines(startLine, nextLine, state.blkIndent, false) .trim()
    content = state.getLines(startLine, nextLine, state.blkIndent, false);
    state.line = nextLine;
    token = state.push('paragraph_open', 'p', 1);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = content;
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push('paragraph_close', 'p', -1);
    state.parentType = oldParentType;
    return true;
};
var $ec00bdf8b1b03eef$export$2e2bcd8739ae039 = (md)=>md.block.ruler.at('paragraph', $ec00bdf8b1b03eef$var$paragraph);

});

parcelRegister("4BHv5", function(module, exports) {

$parcel$export(module.exports, "default", () => $35ac5c6c08086f68$export$2e2bcd8739ae039);

var $cSopm = parcelRequire("cSopm");
const $35ac5c6c08086f68$var$bulletListOpen = 'bullet_list_open';
const $35ac5c6c08086f68$var$bulletListClose = 'bullet_list_close';
const $35ac5c6c08086f68$var$listItemOpen = 'list_item_open';
const $35ac5c6c08086f68$var$listItemClose = 'list_item_close';
const $35ac5c6c08086f68$var$taskListOpen = 'task_list_open';
const $35ac5c6c08086f68$var$taskListClose = 'task_list_close';
const $35ac5c6c08086f68$var$taskItemOpen = 'task_item_open';
const $35ac5c6c08086f68$var$taskItemClose = 'task_item_close';
const $35ac5c6c08086f68$var$paragraphOpen = 'paragraph_open';
const $35ac5c6c08086f68$var$paragraphClose = 'paragraph_close';
function $35ac5c6c08086f68$var$checkTypeByIndex(acc, type, indexOffset = -1) {
    var _acc;
    return ((_acc = acc[acc.length + indexOffset]) === null || _acc === void 0 ? void 0 : _acc.type) === type;
}
function $35ac5c6c08086f68$var$getTokenByIndex(acc, indexOffset = -1) {
    return acc[acc.length + indexOffset];
}
function $35ac5c6c08086f68$var$handleBulletListOpen(state, token, acc, index) {
    const isPreviousTokenInline = $35ac5c6c08086f68$var$checkTypeByIndex(acc, 'inline');
    const isStartOfTaskList = state.tokens[index + 3].type === 'inline' && $35ac5c6c08086f68$var$startsWithTodoMarkdown(state.tokens[index + 3]);
    // If the previous token is inline and our current token is a bullet_list_open that
    // means we have found the start of a nested list, due to current ADF limitations task items
    // cannot contain new task lists so first we must close the task item and then convert the
    // bullet_list_open to task_list_open
    if (isPreviousTokenInline) {
        acc.push((0, $cSopm.createToken)(state, $35ac5c6c08086f68$var$taskItemClose, $35ac5c6c08086f68$var$getTokenByIndex(acc).level - 1));
        acc.push((0, $cSopm.createToken)(state, $35ac5c6c08086f68$var$taskListOpen, $35ac5c6c08086f68$var$getTokenByIndex(acc).level));
    } else if (isStartOfTaskList) acc.push((0, $cSopm.createToken)(state, $35ac5c6c08086f68$var$taskListOpen));
    else acc.push(token);
}
function $35ac5c6c08086f68$var$handleBulletListClose(state, token, acc) {
    const isPreviousTokenTaskItemClose = $35ac5c6c08086f68$var$checkTypeByIndex(acc, $35ac5c6c08086f68$var$taskItemClose);
    const isPreviousTokenTaskListClose = $35ac5c6c08086f68$var$checkTypeByIndex(acc, $35ac5c6c08086f68$var$taskListClose);
    if (isPreviousTokenTaskItemClose || isPreviousTokenTaskListClose) acc.push((0, $cSopm.createToken)(state, $35ac5c6c08086f68$var$taskListClose, $35ac5c6c08086f68$var$getTokenByIndex(acc).level - 1));
    else acc.push(token);
}
function $35ac5c6c08086f68$var$handleListItemOpen(state, token, acc, index) {
    const newTaskItemOpen = (0, $cSopm.createToken)(state, $35ac5c6c08086f68$var$taskItemOpen);
    const isTaskItem = state.tokens[index + 2].type === 'inline' && $35ac5c6c08086f68$var$startsWithTodoMarkdown(state.tokens[index + 2]);
    const isPreviousTokenTaskItemClose = $35ac5c6c08086f68$var$checkTypeByIndex(acc, $35ac5c6c08086f68$var$taskItemClose);
    const isPreviousTokenListItemClose = $35ac5c6c08086f68$var$checkTypeByIndex(acc, $35ac5c6c08086f68$var$listItemClose);
    const isPreviousTokenTaskListClose = $35ac5c6c08086f68$var$checkTypeByIndex(acc, $35ac5c6c08086f68$var$taskListClose);
    if (isTaskItem) {
        // If the previous token is a list item close then we have run into some incorrect task list / list markdown
        // We need to complete the previous bullet list and then open a new task list
        if (isPreviousTokenListItemClose) {
            acc.push((0, $cSopm.createToken)(state, $35ac5c6c08086f68$var$bulletListClose));
            acc.push((0, $cSopm.createToken)(state, $35ac5c6c08086f68$var$taskListOpen));
        }
        newTaskItemOpen.meta = $35ac5c6c08086f68$var$isDone(state.tokens[index + 2]);
        newTaskItemOpen.level = $35ac5c6c08086f68$var$getTokenByIndex(acc).level + (isPreviousTokenTaskListClose ? 0 : 1);
        acc.push(newTaskItemOpen);
    } else {
        // If the previous token is a task item close but the current token is not a task item we need to
        // close the current task item list and then open a new bullet list
        if (isPreviousTokenTaskItemClose) {
            acc.push((0, $cSopm.createToken)(state, $35ac5c6c08086f68$var$taskListClose));
            acc.push((0, $cSopm.createToken)(state, $35ac5c6c08086f68$var$bulletListOpen));
        }
        acc.push(token);
    }
}
function $35ac5c6c08086f68$var$handleListItemClose(state, token, acc) {
    const isWithinTaskList = $35ac5c6c08086f68$var$checkTypeByIndex(acc, 'inline') && $35ac5c6c08086f68$var$checkTypeByIndex(acc, $35ac5c6c08086f68$var$taskItemOpen, -2);
    if (isWithinTaskList) acc.push((0, $cSopm.createToken)(state, $35ac5c6c08086f68$var$taskItemClose, $35ac5c6c08086f68$var$getTokenByIndex(acc, -2).level));
    else if (!$35ac5c6c08086f68$var$checkTypeByIndex(acc, $35ac5c6c08086f68$var$taskListClose)) acc.push(token);
}
function $35ac5c6c08086f68$var$handleInline(token, acc) {
    var _token$children;
    if ((_token$children = token.children) !== null && _token$children !== void 0 && _token$children[0]) token.children[0].content = $35ac5c6c08086f68$var$removeTodoMarkdown(token.children[0].content);
    token.content = $35ac5c6c08086f68$var$removeTodoMarkdown(token.content);
    token.level = $35ac5c6c08086f68$var$getTokenByIndex(acc).level + 1;
    acc.push(token);
}
function $35ac5c6c08086f68$var$handleParagraphs(token, acc) {
    const isWithinTaskItem = $35ac5c6c08086f68$var$checkTypeByIndex(acc, $35ac5c6c08086f68$var$taskItemOpen) || $35ac5c6c08086f68$var$checkTypeByIndex(acc, $35ac5c6c08086f68$var$taskItemOpen, -2);
    if (!isWithinTaskItem) acc.push(token);
}
function $35ac5c6c08086f68$var$isInlineAfterTaskItemOpen(token, acc) {
    return token.type === 'inline' && acc[acc.length - 1].type === $35ac5c6c08086f68$var$taskItemOpen;
}
function $35ac5c6c08086f68$var$startsWithTodoMarkdown(token) {
    // leading whitespace in a list item is already trimmed off by markdown-it
    return token.content.indexOf('[ ] ') === 0 || token.content.indexOf('[x] ') === 0 || token.content.indexOf('[X] ') === 0;
}
function $35ac5c6c08086f68$var$removeTodoMarkdown(content) {
    const regex = /(\[x\]\s)|(\[\s\]\s)/;
    return content.replace(regex, '');
}
function $35ac5c6c08086f68$var$isDone(token) {
    if (token.content.indexOf('[ ] ') === 0) return 'TODO';
    else return 'DONE';
}
function $35ac5c6c08086f68$export$2e2bcd8739ae039(md) {
    md.core.ruler.after('inline', 'github-task-lists', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const { type: type } = token;
            if (type === $35ac5c6c08086f68$var$bulletListOpen) $35ac5c6c08086f68$var$handleBulletListOpen(state, token, acc, index);
            else if (type === $35ac5c6c08086f68$var$bulletListClose) $35ac5c6c08086f68$var$handleBulletListClose(state, token, acc);
            else if (type === $35ac5c6c08086f68$var$listItemOpen) $35ac5c6c08086f68$var$handleListItemOpen(state, token, acc, index);
            else if ($35ac5c6c08086f68$var$isInlineAfterTaskItemOpen(token, acc)) $35ac5c6c08086f68$var$handleInline(token, acc);
            else if (type === $35ac5c6c08086f68$var$listItemClose) $35ac5c6c08086f68$var$handleListItemClose(state, token, acc);
            else if (type === $35ac5c6c08086f68$var$paragraphOpen || type === $35ac5c6c08086f68$var$paragraphClose) $35ac5c6c08086f68$var$handleParagraphs(token, acc);
            else acc.push(token);
            return acc;
        }, []);
    });
}

});



parcelRegister("e32NX", function(module, exports) {

$parcel$export(module.exports, "convertPMFragmentToPreview", () => $a3a3857576346e72$export$f5e3af6d625de7a);

var $eUqFw = parcelRequire("eUqFw");

var $3M3qX = parcelRequire("3M3qX");

var $epQu3 = parcelRequire("epQu3");

var $aJ1kv = parcelRequire("aJ1kv");
const $a3a3857576346e72$var$jsonTransformer = new (0, $3M3qX.JSONTransformer)();
function $a3a3857576346e72$export$f5e3af6d625de7a({ schema: schema, pmFragment: pmFragment, showTelepointer: showTelepointer, providerFactory: providerFactory }) {
    let jsonDocument;
    const prosemirrorDocument = schema.nodes.doc.createAndFill({}, pmFragment);
    // If a failure has occured creating this, we don't know what's happened
    // and so should trigger the error boundary
    if (!prosemirrorDocument) throw new (0, $epQu3.MarkdownConversionError)({
        message: 'Unable to transform markdown into a valid prosemirror document',
        type: 'noProseMirrorDoc'
    });
    if (prosemirrorDocument.content.size === 0) throw new (0, $epQu3.MarkdownConversionError)({
        message: 'Transforming markdown returns an empty prosemirror document',
        type: 'emptyProseMirrorDoc'
    });
    try {
        // Warning -- this is asserted due to a mismatch in the editor-json-transformer
        // and renderer types.
        // jsonTransformer.encode returns a "JSONDocNode" which _should_ be runtime
        // compatible with DocNode -- but does not have compatible types.
        // See the following files for more details
        // - packages/editor/editor-json-transformer/src/types.ts
        // - packages/editor/adf-schema/src/schema/nodes/doc.ts
        jsonDocument = $a3a3857576346e72$var$jsonTransformer.encode(prosemirrorDocument);
    } catch  {
        throw new (0, $epQu3.MarkdownConversionError)({
            message: 'Unable to transform markdown into a valid prosemirror document',
            type: 'invalidProseMirrorDoc'
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aJ1kv.PreviewRenderer), {
        jsonDocument: jsonDocument,
        showTelepointer: showTelepointer,
        providerFactory: providerFactory
    });
}

});
parcelRegister("aJ1kv", function(module, exports) {

$parcel$export(module.exports, "PreviewRenderer", () => $7cef236c69f1b8fb$export$8ce5f720dc007208);
/* @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $PdmhA = parcelRequire("PdmhA");

var $7Y6sw = parcelRequire("7Y6sw");

var $jRfpS = parcelRequire("jRfpS");

var $c5I31 = parcelRequire("c5I31");
const $7cef236c69f1b8fb$export$8ce5f720dc007208 = ({ jsonDocument: jsonDocument, showTelepointer: showTelepointer, providerFactory: providerFactory })=>{
    const analyticsFlow = (0, $jRfpS.useAnalyticsFlow)();
    const previewRendererRef = (0, $eUqFw.useRef)(null);
    const copiedOnceRef = (0, $eUqFw.useRef)(false);
    const onCopyHandler = (0, $eUqFw.useCallback)(async ()=>{
        const previewRendererElement = previewRendererRef.current;
        if (!analyticsFlow || !previewRendererElement) return;
        if (!(0, $c5I31.isSelectionWithinElement)(previewRendererElement)) return;
        if ((0, $c5I31.isPartialCopy)(previewRendererRef.current)) analyticsFlow.addAttributes({
            contentCopiedPartially: true
        });
        // exit if copied already for this preview
        if (copiedOnceRef.current) return;
        analyticsFlow.addAttributes({
            contentCopied: true
        });
        copiedOnceRef.current = true;
    }, [
        analyticsFlow
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const unbind = (0, $74BVL.bind)(document, {
            type: 'copy',
            listener: onCopyHandler
        });
        return unbind;
    }, [
        onCopyHandler,
        analyticsFlow
    ]);
    // override renderer's syntax highlighting styles so it appears consistent with the editor
    const styles = (0, $byn9U.css)({
        '.code-block .token.token': {
            fontStyle: 'normal',
            fontWeight: 'normal',
            color: `var(--ds-text, ${(0, $PdmhA.N800)})`
        }
    });
    return (0, $byn9U.jsx)("div", {
        "data-testid": "preview-renderer",
        css: styles,
        ref: previewRendererRef
    }, (0, $byn9U.jsx)((0, $7Y6sw.default), {
        document: jsonDocument,
        media: {
            // We don't currently support images with captions
            allowLinking: false
        },
        useSpecBasedValidator: true,
        addTelepointer: showTelepointer,
        dataProviders: providerFactory
    }));
};

});
parcelRegister("c5I31", function(module, exports) {

$parcel$export(module.exports, "copyResponseToClipboard", () => $8cd81ea30f2f7e9c$export$12165218b356df9f);
$parcel$export(module.exports, "isPartialCopy", () => $8cd81ea30f2f7e9c$export$d109786c97a20f08);
$parcel$export(module.exports, "isSelectionWithinElement", () => $8cd81ea30f2f7e9c$export$60519e70a23320fb);

var $dr9dc = parcelRequire("dr9dc");

var $7dkLM = parcelRequire("7dkLM");
/**  Copied from packages/editor/editor-core/src/utils/clipboard.ts */ const $8cd81ea30f2f7e9c$var$isClipboardApiSupported = ()=>!!navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
const $8cd81ea30f2f7e9c$export$8b344d2a6a3e9af3 = async (elementToCopy, plainTextToCopy)=>{
    // @ts-ignore
    if ($8cd81ea30f2f7e9c$var$isClipboardApiSupported() && typeof ClipboardItem !== 'undefined') try {
        const data = new ClipboardItem({
            'text/plain': new Blob([
                plainTextToCopy || elementToCopy.innerText
            ], {
                type: 'text/plain'
            }),
            'text/html': new Blob([
                elementToCopy.innerHTML
            ], {
                type: 'text/html'
            })
        });
        // @ts-ignore
        await navigator.clipboard.write([
            data
        ]);
    } catch (error) {
        throw new Error('Clipboard api is not supported');
    }
    else {
        // At the time of development, Firefox doesn't support ClipboardItem API
        // Hence of use of this polyfill
        const dt = new $dr9dc.ClipboardItem({
            'text/html': new Blob([
                elementToCopy.innerHTML
            ], {
                type: 'text/html'
            }),
            'text/plain': new Blob([
                plainTextToCopy || elementToCopy.innerText
            ], {
                type: 'text/plain'
            })
        });
        await $dr9dc.write([
            dt
        ]);
    }
};
/**
 * Copied from packages/editor/editor-core/src/plugins/copy-button/utils.ts
 * and slightly amended to accept a PM Fragment instead of a node
 */ const $8cd81ea30f2f7e9c$var$toDOM = (fragment, schema)=>{
    return (0, $7dkLM.DOMSerializer).fromSchema(schema).serializeFragment(fragment);
};
/**
 * Copied from packages/editor/editor-core/src/plugins/paste/pm-plugins/clipboard-text-serializer.ts
 * and slightly amended to accept a PM Fragment instead of a slice
 */ function $8cd81ea30f2f7e9c$var$clipboardTextSerializer(fragment) {
    let text = '';
    const blockSeparater = '\n\n';
    fragment.nodesBetween(0, fragment.size, (node)=>{
        if (node.type.isBlock) text += blockSeparater;
        if (node.type.name === 'paragraph') return true;
        else if (node.type.name === 'hardBreak') text += '\n';
        else if (node.type.name === 'text') text += node.text;
        else if (node.type.name === 'inlineCard') text += node.attrs.url;
        else if (node.type.name === 'blockCard') text += node.attrs.url;
        else text += node.textBetween(0, node.content.size, '\n\n');
        return false;
    });
    return text.trim();
}
function $8cd81ea30f2f7e9c$export$12165218b356df9f({ editorView: editorView, pmFragment: pmFragment }) {
    const transaction = editorView.state.tr;
    const domNode = $8cd81ea30f2f7e9c$var$toDOM(pmFragment, editorView.state.schema);
    if (domNode) {
        const div = document.createElement('div');
        div.appendChild(domNode);
        // The "0 0" refers to the start and end depth of the slice
        // since we're copying the block node only, it will always be 0 0
        // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
        div.firstChild.setAttribute('data-pm-slice', '0 0 []');
        /**
     * ED-18062: override the plain text in
     * copyHTMLToClipboard using clipboardTextSerializer(pmFragment)
     * because HTML to plain text is formatted without new lines
     * in certain nodes such as lists
     */ $8cd81ea30f2f7e9c$export$8b344d2a6a3e9af3(div, $8cd81ea30f2f7e9c$var$clipboardTextSerializer(pmFragment));
    }
    transaction.setMeta('scrollIntoView', false);
    editorView.dispatch(transaction);
}
function $8cd81ea30f2f7e9c$export$d109786c97a20f08(targetElement) {
    const selection = window.getSelection();
    const selectionText = selection === null || selection === void 0 ? void 0 : selection.toString();
    // If there is no current selection, we don't want to send the event.
    if (!selectionText) return false;
    // Remove new lines and trailing spaces from the text to compare as innerText may have unecessary newlines.
    const strippedPreviewResponseText = targetElement.innerText.replace(/\n/g, '').trim();
    const strippedSelectionText = selectionText.replace(/\n/g, '').trim();
    let isSelectionOutsideTargetElement = false;
    let isSelectionWholeAndMore = false;
    if (selection) {
        var _focusNode$textConten;
        const { anchorNode: anchorNode, focusNode: focusNode } = selection;
        // Cases where the selection may be outside the node but are considered a whole copy:
        // Starts and ends outside the node.
        // Note: The anchor and focus nodes might be text nodes, not necessarily elements themselves,
        // but the `contains` method works for any node type.
        const selectionStartsOutside = !targetElement.contains(anchorNode);
        const selectionEndsOutside = !targetElement.contains(focusNode);
        isSelectionOutsideTargetElement = selectionStartsOutside && selectionEndsOutside;
        // Starts outside, ends at the end of the node.
        // OR Ends outside, starts at the start of the node.
        // Verify start and end locations.
        const selectionStartsAtStart = selection.anchorOffset === 0;
        const selectionEndsAtEnd = selection.focusOffset === (focusNode === null || focusNode === void 0 ? void 0 : (_focusNode$textConten = focusNode.textContent) === null || _focusNode$textConten === void 0 ? void 0 : _focusNode$textConten.length);
        // Verify if the selection is a whole copy and more.
        const startsOutsideAndEndsAtEnd = selectionStartsOutside && selectionEndsAtEnd;
        const startsAtStartAndEndsOutside = selectionEndsOutside && selectionStartsAtStart;
        if (startsOutsideAndEndsAtEnd || startsAtStartAndEndsOutside) isSelectionWholeAndMore = true;
    }
    if (isSelectionOutsideTargetElement || isSelectionWholeAndMore) return false;
    return strippedPreviewResponseText !== strippedSelectionText;
}
function $8cd81ea30f2f7e9c$export$60519e70a23320fb(element) {
    const selection = window.getSelection();
    if (!(selection !== null && selection !== void 0 && selection.rangeCount) || !selection.toString()) return false;
    const { anchorNode: anchorNode, focusNode: focusNode } = selection;
    if (!anchorNode || !focusNode) return false;
    // if start or end of the selection is within element no need in further checks
    if ([
        anchorNode,
        focusNode
    ].some((node)=>element.contains(node))) return true;
    // detect start and end node based on the direction of the selection
    const isLTRSelection = anchorNode.compareDocumentPosition(focusNode) & Node.DOCUMENT_POSITION_FOLLOWING;
    const startNode = isLTRSelection ? selection.anchorNode : selection.focusNode;
    const endNode = isLTRSelection ? selection.focusNode : selection.anchorNode;
    if (!startNode || !endNode) return false;
    // Check if the selection starts before and ends after the element
    if (startNode.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_FOLLOWING && endNode.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_PRECEDING) return true;
    // Check if the selection starts after and ends before the element
    if (startNode.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_PRECEDING && endNode.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_FOLLOWING) return true;
    return false;
}

});
parcelRegister("dr9dc", function(module, exports) {

$parcel$export(module.exports, "ClipboardItem", () => $9c84f147ea4beec6$export$3b1380c0957dc8fe);
$parcel$export(module.exports, "write", () => $9c84f147ea4beec6$export$68d8715fc104d294);
// src/clipboard-polyfill/ClipboardItem/data-types.ts
var $9c84f147ea4beec6$var$TEXT_PLAIN = "text/plain";
var $9c84f147ea4beec6$var$TEXT_HTML = "text/html";
// src/clipboard-polyfill/debug.ts
var $9c84f147ea4beec6$var$debugLogImpl = (s)=>{};
function $9c84f147ea4beec6$var$debugLog(s) {
    $9c84f147ea4beec6$var$debugLogImpl(s);
}
function $9c84f147ea4beec6$export$e014146e87162c32(logFn) {
    $9c84f147ea4beec6$var$debugLogImpl = logFn;
}
var $9c84f147ea4beec6$var$showWarnings = true;
function $9c84f147ea4beec6$export$ba5c9528becaaf25() {
    $9c84f147ea4beec6$var$showWarnings = false;
}
function $9c84f147ea4beec6$var$shouldShowWarnings() {
    return $9c84f147ea4beec6$var$showWarnings;
}
function $9c84f147ea4beec6$var$warnOrLog() {
    (console.warn || console.log).apply(console, arguments);
}
var $9c84f147ea4beec6$var$warn = $9c84f147ea4beec6$var$warnOrLog.bind("[clipboard-polyfill]");
// src/clipboard-polyfill/builtins/window-globalThis.ts
var $9c84f147ea4beec6$var$originalWindow = typeof window === "undefined" ? void 0 : window;
var $9c84f147ea4beec6$var$originalGlobalThis = typeof globalThis === "undefined" ? void 0 : globalThis;
// src/clipboard-polyfill/builtins/promise-constructor.ts
var $9c84f147ea4beec6$var$_a, $9c84f147ea4beec6$var$_b, $9c84f147ea4beec6$var$_c;
var $9c84f147ea4beec6$var$promiseConstructorImpl = ($9c84f147ea4beec6$var$_c = ($9c84f147ea4beec6$var$_a = $9c84f147ea4beec6$var$originalWindow) == null ? void 0 : $9c84f147ea4beec6$var$_a.Promise) != null ? $9c84f147ea4beec6$var$_c : ($9c84f147ea4beec6$var$_b = $9c84f147ea4beec6$var$originalGlobalThis) == null ? void 0 : $9c84f147ea4beec6$var$_b.Promise;
function $9c84f147ea4beec6$var$getPromiseConstructor() {
    if (!$9c84f147ea4beec6$var$promiseConstructorImpl) throw new Error("No `Promise` implementation available for `clipboard-polyfill`. Consider using: https://github.com/lgarron/clipboard-polyfill#flat-file-version-with-promise-included");
    return $9c84f147ea4beec6$var$promiseConstructorImpl;
}
// src/clipboard-polyfill/builtins/builtin-globals.ts
var $9c84f147ea4beec6$var$originalNavigator = typeof navigator === "undefined" ? void 0 : navigator;
var $9c84f147ea4beec6$var$originalNavigatorClipboard = $9c84f147ea4beec6$var$originalNavigator == null ? void 0 : $9c84f147ea4beec6$var$originalNavigator.clipboard;
var $9c84f147ea4beec6$var$_a2;
var $9c84f147ea4beec6$var$originalNavigatorClipboardRead = ($9c84f147ea4beec6$var$_a2 = $9c84f147ea4beec6$var$originalNavigatorClipboard == null ? void 0 : $9c84f147ea4beec6$var$originalNavigatorClipboard.read) == null ? void 0 : $9c84f147ea4beec6$var$_a2.bind($9c84f147ea4beec6$var$originalNavigatorClipboard);
var $9c84f147ea4beec6$var$_a3;
var $9c84f147ea4beec6$var$originalNavigatorClipboardReadText = ($9c84f147ea4beec6$var$_a3 = $9c84f147ea4beec6$var$originalNavigatorClipboard == null ? void 0 : $9c84f147ea4beec6$var$originalNavigatorClipboard.readText) == null ? void 0 : $9c84f147ea4beec6$var$_a3.bind($9c84f147ea4beec6$var$originalNavigatorClipboard);
var $9c84f147ea4beec6$var$_a4;
var $9c84f147ea4beec6$var$originalNavigatorClipboardWrite = ($9c84f147ea4beec6$var$_a4 = $9c84f147ea4beec6$var$originalNavigatorClipboard == null ? void 0 : $9c84f147ea4beec6$var$originalNavigatorClipboard.write) == null ? void 0 : $9c84f147ea4beec6$var$_a4.bind($9c84f147ea4beec6$var$originalNavigatorClipboard);
var $9c84f147ea4beec6$var$_a5;
var $9c84f147ea4beec6$var$originalNavigatorClipboardWriteText = ($9c84f147ea4beec6$var$_a5 = $9c84f147ea4beec6$var$originalNavigatorClipboard == null ? void 0 : $9c84f147ea4beec6$var$originalNavigatorClipboard.writeText) == null ? void 0 : $9c84f147ea4beec6$var$_a5.bind($9c84f147ea4beec6$var$originalNavigatorClipboard);
var $9c84f147ea4beec6$var$_a6;
var $9c84f147ea4beec6$var$originalWindowClipboardItem = ($9c84f147ea4beec6$var$_a6 = $9c84f147ea4beec6$var$originalWindow) == null ? void 0 : $9c84f147ea4beec6$var$_a6.ClipboardItem;
var $9c84f147ea4beec6$var$promiseConstructor = $9c84f147ea4beec6$var$getPromiseConstructor();
// src/clipboard-polyfill/strategies/internet-explorer.ts
var $9c84f147ea4beec6$var$ieWindow = $9c84f147ea4beec6$var$originalWindow;
function $9c84f147ea4beec6$var$seemToBeInIE() {
    return typeof ClipboardEvent === "undefined" && typeof ($9c84f147ea4beec6$var$ieWindow == null ? void 0 : $9c84f147ea4beec6$var$ieWindow.clipboardData) !== "undefined" && typeof ($9c84f147ea4beec6$var$ieWindow == null ? void 0 : $9c84f147ea4beec6$var$ieWindow.clipboardData.setData) !== "undefined";
}
function $9c84f147ea4beec6$var$writeTextIE(text) {
    if (!$9c84f147ea4beec6$var$ieWindow.clipboardData) return false;
    var success = $9c84f147ea4beec6$var$ieWindow.clipboardData.setData("Text", text);
    if (success) $9c84f147ea4beec6$var$debugLog("writeTextIE worked");
    return success;
}
function $9c84f147ea4beec6$var$readTextIE() {
    if (!$9c84f147ea4beec6$var$ieWindow.clipboardData) throw new Error("Cannot read IE clipboard Data ");
    var text = $9c84f147ea4beec6$var$ieWindow.clipboardData.getData("Text");
    if (text === "") throw new Error("Empty clipboard or could not read plain text from clipboard");
    return text;
}
// src/clipboard-polyfill/strategies/dom.ts
function $9c84f147ea4beec6$var$copyListener(tracker, data, e) {
    $9c84f147ea4beec6$var$debugLog("listener called");
    tracker.success = true;
    for(var type in data){
        var value = data[type];
        var clipboardData = e.clipboardData;
        clipboardData.setData(type, value);
        if (type === $9c84f147ea4beec6$var$TEXT_PLAIN && clipboardData.getData(type) !== value) {
            $9c84f147ea4beec6$var$debugLog("setting text/plain failed");
            tracker.success = false;
        }
    }
    e.preventDefault();
}
function $9c84f147ea4beec6$var$execCopy(data) {
    var tracker = {
        success: false
    };
    var listener = $9c84f147ea4beec6$var$copyListener.bind(this, tracker, data);
    document.addEventListener("copy", listener);
    try {
        document.execCommand("copy");
    } finally{
        document.removeEventListener("copy", listener);
    }
    return tracker.success;
}
function $9c84f147ea4beec6$var$copyUsingTempSelection(e, data) {
    $9c84f147ea4beec6$var$selectionSet(e);
    var success = $9c84f147ea4beec6$var$execCopy(data);
    $9c84f147ea4beec6$var$selectionClear();
    return success;
}
function $9c84f147ea4beec6$var$copyUsingTempElem(data) {
    var tempElem = document.createElement("div");
    tempElem.setAttribute("style", "-webkit-user-select: text !important");
    tempElem.textContent = "temporary element";
    document.body.appendChild(tempElem);
    var success = $9c84f147ea4beec6$var$copyUsingTempSelection(tempElem, data);
    document.body.removeChild(tempElem);
    return success;
}
function $9c84f147ea4beec6$var$copyTextUsingDOM(str) {
    $9c84f147ea4beec6$var$debugLog("copyTextUsingDOM");
    var tempElem = document.createElement("div");
    tempElem.setAttribute("style", "-webkit-user-select: text !important");
    var spanParent = tempElem;
    if (tempElem.attachShadow) {
        $9c84f147ea4beec6$var$debugLog("Using shadow DOM.");
        spanParent = tempElem.attachShadow({
            mode: "open"
        });
    }
    var span = document.createElement("span");
    span.innerText = str;
    spanParent.appendChild(span);
    document.body.appendChild(tempElem);
    $9c84f147ea4beec6$var$selectionSet(span);
    var result = document.execCommand("copy");
    $9c84f147ea4beec6$var$selectionClear();
    document.body.removeChild(tempElem);
    return result;
}
function $9c84f147ea4beec6$var$selectionSet(elem) {
    var sel = document.getSelection();
    if (sel) {
        var range = document.createRange();
        range.selectNodeContents(elem);
        sel.removeAllRanges();
        sel.addRange(range);
    }
}
function $9c84f147ea4beec6$var$selectionClear() {
    var sel = document.getSelection();
    if (sel) sel.removeAllRanges();
}
// src/clipboard-polyfill/implementations/write-fallback.ts
function $9c84f147ea4beec6$var$writeFallback(stringItem) {
    var hasTextPlain = $9c84f147ea4beec6$var$TEXT_PLAIN in stringItem;
    if ($9c84f147ea4beec6$var$seemToBeInIE()) {
        if (!hasTextPlain) throw new Error("No `text/plain` value was specified.");
        if ($9c84f147ea4beec6$var$writeTextIE(stringItem[$9c84f147ea4beec6$var$TEXT_PLAIN])) return true;
        else throw new Error("Copying failed, possibly because the user rejected it.");
    }
    if ($9c84f147ea4beec6$var$execCopy(stringItem)) {
        $9c84f147ea4beec6$var$debugLog("regular execCopy worked");
        return true;
    }
    if (navigator.userAgent.indexOf("Edge") > -1) {
        $9c84f147ea4beec6$var$debugLog('UA "Edge" => assuming success');
        return true;
    }
    if ($9c84f147ea4beec6$var$copyUsingTempSelection(document.body, stringItem)) {
        $9c84f147ea4beec6$var$debugLog("copyUsingTempSelection worked");
        return true;
    }
    if ($9c84f147ea4beec6$var$copyUsingTempElem(stringItem)) {
        $9c84f147ea4beec6$var$debugLog("copyUsingTempElem worked");
        return true;
    }
    if ($9c84f147ea4beec6$var$copyTextUsingDOM(stringItem[$9c84f147ea4beec6$var$TEXT_PLAIN])) {
        $9c84f147ea4beec6$var$debugLog("copyTextUsingDOM worked");
        return true;
    }
    return false;
}
// src/clipboard-polyfill/promise/promise-compat.ts
function $9c84f147ea4beec6$var$promiseRecordMap(keys, f) {
    var promiseList = [];
    for(var i in keys){
        var key = keys[i];
        promiseList.push(f(key));
    }
    return $9c84f147ea4beec6$var$promiseConstructor.all(promiseList).then((vList)=>{
        var dataOut = {};
        for(var i2 = 0; i2 < keys.length; i2++)dataOut[keys[i2]] = vList[i2];
        return dataOut;
    });
}
var $9c84f147ea4beec6$var$voidPromise = $9c84f147ea4beec6$var$promiseConstructor.resolve();
var $9c84f147ea4beec6$var$truePromiseFn = ()=>$9c84f147ea4beec6$var$promiseConstructor.resolve(true);
var $9c84f147ea4beec6$var$falsePromise = $9c84f147ea4beec6$var$promiseConstructor.resolve(false);
function $9c84f147ea4beec6$var$rejectThrownErrors(executor) {
    return new $9c84f147ea4beec6$var$promiseConstructor((resolve, reject)=>{
        try {
            resolve(executor());
        } catch (e) {
            reject(e);
        }
    });
}
// src/clipboard-polyfill/implementations/text.ts
function $9c84f147ea4beec6$var$stringToStringItem(s) {
    var stringItem = {};
    stringItem[$9c84f147ea4beec6$var$TEXT_PLAIN] = s;
    return stringItem;
}
function $9c84f147ea4beec6$export$bec150f75a9b8f11(s) {
    return $9c84f147ea4beec6$var$rejectThrownErrors(()=>{
        if ($9c84f147ea4beec6$var$originalNavigatorClipboardWriteText) {
            $9c84f147ea4beec6$var$debugLog("Using `navigator.clipboard.writeText()`.");
            return $9c84f147ea4beec6$var$originalNavigatorClipboardWriteText(s).catch($9c84f147ea4beec6$var$writeTextStringFallback);
        }
        return $9c84f147ea4beec6$var$promiseConstructor.resolve($9c84f147ea4beec6$var$writeTextStringFallback(s));
    });
}
function $9c84f147ea4beec6$var$writeTextStringFallback(s) {
    if (!$9c84f147ea4beec6$var$writeFallback($9c84f147ea4beec6$var$stringToStringItem(s))) throw new Error("writeText() failed");
}
function $9c84f147ea4beec6$export$bee0113684d8879b() {
    return $9c84f147ea4beec6$var$rejectThrownErrors(()=>{
        if ($9c84f147ea4beec6$var$originalNavigatorClipboardReadText) {
            $9c84f147ea4beec6$var$debugLog("Using `navigator.clipboard.readText()`.");
            return $9c84f147ea4beec6$var$originalNavigatorClipboardReadText();
        }
        if ($9c84f147ea4beec6$var$seemToBeInIE()) {
            var result = $9c84f147ea4beec6$var$readTextIE();
            return $9c84f147ea4beec6$var$promiseConstructor.resolve(result);
        }
        throw new Error("Read is not supported in your browser.");
    });
}
// src/clipboard-polyfill/ClipboardItem/check.ts
function $9c84f147ea4beec6$var$hasItemWithType(clipboardItems, typeName) {
    for(var i in clipboardItems){
        var item = clipboardItems[i];
        if (item.types.indexOf(typeName) !== -1) return true;
    }
    return false;
}
// src/clipboard-polyfill/ClipboardItem/ClipboardItemPolyfill.ts
function $9c84f147ea4beec6$var$ClipboardItemPolyfillImpl(items, options) {
    var _a7;
    var types = Object.keys(items);
    var _items = {};
    for(var type in items){
        var item = items[type];
        if (typeof item === "string") _items[type] = $9c84f147ea4beec6$var$stringToBlob(type, item);
        else _items[type] = item;
    }
    var presentationStyle = (_a7 = options == null ? void 0 : options.presentationStyle) != null ? _a7 : "unspecified";
    function getType(type2) {
        return $9c84f147ea4beec6$var$promiseConstructor.resolve(_items[type2]);
    }
    return {
        types: types,
        presentationStyle: presentationStyle,
        getType: getType
    };
}
var $9c84f147ea4beec6$export$3b1380c0957dc8fe = $9c84f147ea4beec6$var$ClipboardItemPolyfillImpl;
// src/clipboard-polyfill/ClipboardItem/convert.ts
function $9c84f147ea4beec6$var$stringToBlob(type, str) {
    return new Blob([
        str
    ], {
        type: type
    });
}
function $9c84f147ea4beec6$var$blobToString(blob) {
    return new $9c84f147ea4beec6$var$promiseConstructor((resolve, reject)=>{
        var fileReader = new FileReader();
        fileReader.addEventListener("load", ()=>{
            var result = fileReader.result;
            if (typeof result === "string") resolve(result);
            else reject("could not convert blob to string");
        });
        fileReader.readAsText(blob);
    });
}
function $9c84f147ea4beec6$var$clipboardItemToGlobalClipboardItem(clipboardItem) {
    return $9c84f147ea4beec6$var$promiseRecordMap(clipboardItem.types, function(type) {
        return clipboardItem.getType(type);
    }).then((items)=>{
        return new Promise((resolve, reject)=>{
            var options = {};
            if (clipboardItem.presentationStyle) options.presentationStyle = clipboardItem.presentationStyle;
            if ($9c84f147ea4beec6$var$originalWindowClipboardItem) resolve(new $9c84f147ea4beec6$var$originalWindowClipboardItem(items, options));
            else reject("window.ClipboardItem is not defined");
        });
    });
}
function $9c84f147ea4beec6$var$textToClipboardItem(text) {
    var items = {};
    items[$9c84f147ea4beec6$var$TEXT_PLAIN] = $9c84f147ea4beec6$var$stringToBlob(text, $9c84f147ea4beec6$var$TEXT_PLAIN);
    return new $9c84f147ea4beec6$export$3b1380c0957dc8fe(items);
}
function $9c84f147ea4beec6$var$getTypeAsString(clipboardItem, type) {
    return clipboardItem.getType(type).then((text)=>{
        return $9c84f147ea4beec6$var$blobToString(text);
    });
}
function $9c84f147ea4beec6$var$toStringItem(data) {
    return $9c84f147ea4beec6$var$promiseRecordMap(data.types, function(type) {
        return $9c84f147ea4beec6$var$getTypeAsString(data, type);
    });
}
// src/clipboard-polyfill/implementations/blob.ts
function $9c84f147ea4beec6$export$68d8715fc104d294(data) {
    return $9c84f147ea4beec6$var$rejectThrownErrors(()=>{
        if ($9c84f147ea4beec6$var$originalNavigatorClipboardWrite && $9c84f147ea4beec6$var$originalWindowClipboardItem) {
            var originalNavigatorClipboardWriteCached = $9c84f147ea4beec6$var$originalNavigatorClipboardWrite;
            $9c84f147ea4beec6$var$debugLog("Using `navigator.clipboard.write()`.");
            return $9c84f147ea4beec6$var$promiseConstructor.all(data.map($9c84f147ea4beec6$var$clipboardItemToGlobalClipboardItem)).then((globalClipboardItems)=>{
                return originalNavigatorClipboardWriteCached(globalClipboardItems).then($9c84f147ea4beec6$var$truePromiseFn).catch((e)=>{
                    if (!$9c84f147ea4beec6$var$hasItemWithType(data, $9c84f147ea4beec6$var$TEXT_PLAIN) && !$9c84f147ea4beec6$var$hasItemWithType(data, $9c84f147ea4beec6$var$TEXT_HTML)) throw e;
                    return $9c84f147ea4beec6$var$falsePromise;
                });
            });
        }
        return $9c84f147ea4beec6$var$falsePromise;
    }).then((success)=>{
        if (success) return $9c84f147ea4beec6$var$voidPromise;
        var hasTextPlain = $9c84f147ea4beec6$var$hasItemWithType(data, $9c84f147ea4beec6$var$TEXT_PLAIN);
        if ($9c84f147ea4beec6$var$shouldShowWarnings() && !hasTextPlain) $9c84f147ea4beec6$var$debugLog("clipboard.write() was called without a `text/plain` data type. On some platforms, this may result in an empty clipboard. Call suppressWarnings() to suppress this warning.");
        return $9c84f147ea4beec6$var$toStringItem(data[0]).then((stringItem)=>{
            if (!$9c84f147ea4beec6$var$writeFallback(stringItem)) throw new Error("write() failed");
        });
    });
}
function $9c84f147ea4beec6$export$aafa59e2e03f2942() {
    return $9c84f147ea4beec6$var$rejectThrownErrors(()=>{
        if ($9c84f147ea4beec6$var$originalNavigatorClipboardRead) {
            $9c84f147ea4beec6$var$debugLog("Using `navigator.clipboard.read()`.");
            return $9c84f147ea4beec6$var$originalNavigatorClipboardRead();
        }
        return $9c84f147ea4beec6$export$bee0113684d8879b().then((text)=>{
            return [
                $9c84f147ea4beec6$var$textToClipboardItem(text)
            ];
        });
    });
}

});




parcelRegister("gZGlT", function(module, exports) {

$parcel$export(module.exports, "isMarkdownEndingWithCustomTag", () => $03315784926ed567$export$bde720e3489117f9);
/**
 * This will match markdown which appears to end with a custom tag,
 * e.g.
 * * Something something <
 * * Something something <c
 * * Something something <cust
 * * Something something <custom
 * and will match content until a closing tag (</custom>) has been found.
 *
 * This won't match non-custom tags e.g.
 * <custard
 * <status
 * etc.
 */ const $03315784926ed567$export$bde720e3489117f9 = (markdown, streamingV2)=>{
    if (streamingV2) return !!markdown.match(/<(c(u(s(t(o(m(?!.*<\/custom>|.*\/>).*?)?)?)?)?)?)?$/g);
    else return !!markdown.match(/<(c(u(s(t(o(m(?!.*<\/custom>).*?)?)?)?)?)?)?$/g);
};

});


parcelRegister("gm3e9", function(module, exports) {

$parcel$export(module.exports, "RateLimitScreenWithLogic", () => $be8134423461cb95$export$8fa79a5d1f8aae60);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $kaZdl = parcelRequire("kaZdl");

var $aska3 = parcelRequire("aska3");

var $8uD7Y = parcelRequire("8uD7Y");

var $jRfpS = parcelRequire("jRfpS");
function $be8134423461cb95$export$8fa79a5d1f8aae60({ loadingState: loadingState, endExperience: endExperience, send: send, errorInfo: errorInfo }) {
    // TODO AIFOLLOWUP
    // analytics events should be hit when entering the failed state
    const documentationLink = `https://support.atlassian.com/organization-administration/docs/excessive-use-in-atlassian-intelligence/`;
    // https://developer.atlassian.com/platform/localization/i18n-formatting/avoiding-concatenation/#links
    const errorMsg = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kU09D.default)({}, (0, $aska3.default).rateLimitEnforced, {
        values: {
            link: (message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                    href: documentationLink,
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, message)
        }
    }));
    (0, $jRfpS.useAnalyticsFlowEventsQueue)({
        stepName: 'apiError',
        attributes: {
            errorType: loadingState === 'rate limit active' ? 'rate limit enforced' : 'rate limit lifted',
            ...errorInfo
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kaZdl.ErrorScreen), {
        text: errorMsg,
        onCancel: ()=>{
            endExperience();
        },
        showRetryButton: false,
        onRetry: ()=>{
            send({
                type: 'api retry'
            });
        }
    });
}

});
parcelRegister("kaZdl", function(module, exports) {

$parcel$export(module.exports, "ErrorScreen", () => $eb0439b6eb7ba7d6$export$42f84e610f279c31);
/* @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");
parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $lkPEe = parcelRequire("lkPEe");

var $c3u17 = parcelRequire("c3u17");

var $bFJ7u = parcelRequire("bFJ7u");

var $2fOPm = parcelRequire("2fOPm");
const $eb0439b6eb7ba7d6$export$42f84e610f279c31 = ({ onCancel: onCancel, onRetry: onRetry, text: text, showRetryButton: showRetryButton = true })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { ref: ref, breakpoint: breakpoint } = (0, $bFJ7u.useContainerBreakpoints)();
    return (0, $byn9U.jsx)((0, $2fOPm.ErrorFloatingContainer), {
        ref: ref,
        breakpoint: breakpoint
    }, (0, $byn9U.jsx)((0, $lkPEe.default), null, formatMessage((0, $c3u17.default).ariaErrorTitle)), (0, $byn9U.jsx)((0, $2fOPm.ErrorMessage), {
        breakpoint: breakpoint
    }, text), (0, $byn9U.jsx)((0, $2fOPm.ErrorButtonContainer), null, (0, $byn9U.jsx)((0, $2fOPm.ErrorButton), {
        autoFocus: true,
        testId: "cancel-button",
        onClick: onCancel,
        appearance: onRetry && showRetryButton ? 'subtle' : 'primary'
    }, formatMessage((0, $c3u17.default).cancelLabel)), onRetry && showRetryButton && (0, $byn9U.jsx)((0, $2fOPm.ErrorButton), {
        testId: 'retry',
        onClick: onRetry,
        appearance: "primary"
    }, formatMessage((0, $c3u17.default).retryLabel))));
};

});


parcelRegister("g4i45", function(module, exports) {

$parcel$export(module.exports, "ApiFailedScreenWithLogic", () => $bb2b086382c64265$export$929cbbe95530ce6a);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $kaZdl = parcelRequire("kaZdl");

var $aska3 = parcelRequire("aska3");

var $jRfpS = parcelRequire("jRfpS");
function $bb2b086382c64265$export$929cbbe95530ce6a({ endExperience: endExperience, send: send, errorInfo: errorInfo }) {
    (0, $jRfpS.useAnalyticsFlowEventsQueue)({
        stepName: 'apiError',
        attributes: {
            errorType: (0, $aska3.default).apiError.defaultMessage,
            ...errorInfo
        }
    });
    const isConvoAIServerError = [
        'FEATURE_DISABLED',
        'FEATURE_DISABLED_ON_SITE',
        'NO_AGENT'
    ].includes((errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.errorKey) || '');
    const is5xxErrorRange = typeof (errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.statusCode) === 'number' && errorInfo.statusCode >= 500 && errorInfo.statusCode < 600;
    const isRetryEnabled = // 500 status codes should not be retryable
    !is5xxErrorRange && // 9001 is a special case for elevate where we disable generate until
    // Q3
    (errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.statusCode) !== 9001;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const documentationUrl = 'https://status.atlassian.com/';
    const errorMsg = is5xxErrorRange || isConvoAIServerError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $kU09D.default)({}, (0, $aska3.default).internalServerError, {
        values: {
            link: (message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                    href: documentationUrl,
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, message)
        }
    })) : (errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.statusCode) === 9001 ? formatMessage((0, $aska3.default).elevateDisabledGenetateError) : formatMessage((0, $aska3.default).apiError);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kaZdl.ErrorScreen), {
        text: errorMsg,
        showRetryButton: isRetryEnabled,
        onRetry: function() {
            send({
                type: 'api retry'
            });
        },
        onCancel: function() {
            endExperience();
        }
    });
}

});

parcelRegister("c4X6r", function(module, exports) {

$parcel$export(module.exports, "FailedScreenWithLogic", () => $8cb3b4572e96864e$export$556ec0aa8adf4864);

var $eUqFw = parcelRequire("eUqFw");

var $kaZdl = parcelRequire("kaZdl");

var $aska3 = parcelRequire("aska3");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jRfpS = parcelRequire("jRfpS");
function $8cb3b4572e96864e$export$556ec0aa8adf4864({ failureReason: failureReason, endExperience: endExperience, errorInfo: errorInfo }) {
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    // TODO AIFOLLOWUP
    // analytics events should be hit when entering the failed state
    const knownErrorMessages = {
        'unknown fail': (0, $aska3.default).documentInsertError,
        'token limit fail': (0, $aska3.default).tokenLimitExceeded,
        'insert failure': (0, $aska3.default).documentInsertError,
        'input too short fail': (0, $aska3.default).inputTooShortError,
        'hipaa content fail': (0, $aska3.default).hipaaContentError
    };
    const errorType = failureReason || 'unknown fail';
    const errorMessage = formatMessage(knownErrorMessages[errorType]);
    (0, $jRfpS.useAnalyticsFlowEventsQueue)({
        stepName: 'failed',
        attributes: {
            errorType: errorType,
            ...errorInfo
        }
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kaZdl.ErrorScreen), {
        text: errorMessage,
        onCancel: function() {
            endExperience();
        }
    });
}

});

parcelRegister("huA1W", function(module, exports) {

$parcel$export(module.exports, "PreviewScreenWithLogic", () => $cbc12fdcfd735541$export$705df12804ca7004);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7dkLM = parcelRequire("7dkLM");

var $ln5HZ = parcelRequire("ln5HZ");

var $jRfpS = parcelRequire("jRfpS");

var $lcglt = parcelRequire("lcglt");

var $e32NX = parcelRequire("e32NX");

var $aFbB0 = parcelRequire("aFbB0");

var $c5I31 = parcelRequire("c5I31");

var $8PT7T = parcelRequire("8PT7T");

var $8pKer = parcelRequire("8pKer");

var $138p3 = parcelRequire("138p3");

var $3Ycnu = parcelRequire("3Ycnu");

var $iypWf = parcelRequire("iypWf");

var $XHGTv = parcelRequire("XHGTv");

var $5HLgB = parcelRequire("5HLgB");

var $66XPt = parcelRequire("66XPt");

var $iEDa2 = parcelRequire("iEDa2");

var $3QQwc = parcelRequire("3QQwc");

var $dwVev = parcelRequire("dwVev");
function $cbc12fdcfd735541$export$705df12804ca7004({ latestPrompt: latestPrompt, aupViolation: aupViolation, markdown: markdown, schema: schema, editorPluginAIProvider: editorPluginAIProvider, providerFactory: providerFactory, editorView: editorView, positions: positions, configItem: configItem, endExperience: endExperience, isInputActive: isInputActive, userInput: userInput, userADFInput: userADFInput, send: send, appearance: appearance, product: product, lastTriggeredFrom: lastTriggeredFrom, editCount: editCount, retryPromptCount: retryPromptCount, idMap: idMap, history: history, contextStatistics: contextStatistics, backendModel: backendModel, errorInfo: errorInfo, promptTrigger: promptTrigger }) {
    var _configItem$disableIn;
    /**
   * Please check with Ethan/PM upon removing onExperienceEvent
   * calls, to confirm it is no longer used in any ongoing experiments.
   */ (0, $eUqFw.useEffect)(()=>{
        var _editorPluginAIProvid;
        (_editorPluginAIProvid = editorPluginAIProvider.onExperienceEvent) === null || _editorPluginAIProvid === void 0 || _editorPluginAIProvid.REVIEW_STATE_ENTERED();
    }, [
        editorPluginAIProvider
    ]);
    const { formatMessage: formatMessage, locale: locale } = (0, $5JgJ2.default)();
    const clearInputRef = (0, $eUqFw.useRef)();
    const lastHistoryEvent = history.entries[history.positionFromEnd];
    const responseTooSimilar = lastHistoryEvent.responseTooSimilar;
    const inputOutputDiffRatio = lastHistoryEvent.inputOutputDiffRatio;
    /**
   * This should not be treated as a fact we are attempting
   * to match as many responses with acceptable use warnings
   * however, we may get false positives or false negatives
   *
   * TODO POST EAP
   * Modify 'getHasAcceptableUseWarning' when the backend is
   * able to return acceptable-use-warning flags to the frontend
   */ const hasAcceptableUseWarning = (0, $8PT7T.getHasAcceptableUseWarning)({
        markdown: markdown,
        locale: locale
    });
    const fireAIAnalyticsEvent = (0, $aFbB0.useFireAIAnalyticsEvent)();
    const analyticsFlow = (0, $jRfpS.useAnalyticsFlow)();
    const enqueuedPreviewStep = (0, $eUqFw.useRef)(false);
    const errorReported = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(false);
    if (markdown && (0, $66XPt.isConfluenceTitleToolbarSuggestTitle)({
        configItem: configItem,
        lastTriggeredFrom: lastTriggeredFrom
    })) markdown = (0, $5HLgB.stripMatchingOuterQuotes)(markdown);
    // no need to try convert markdown into pmFragment in case of aupViolation
    const pmFragmentPreviewData = aupViolation ? undefined : (0, $ln5HZ.getPMFragmentWithFallback)({
        markdown: markdown || '',
        schema: schema,
        source: 'preview',
        fireAIAnalyticsEvent: (event)=>{
            if (!errorReported.current) {
                errorReported.current = true;
                fireAIAnalyticsEvent(event);
            }
        },
        idMap: idMap
    });
    const pmFragment = (pmFragmentPreviewData === null || pmFragmentPreviewData === void 0 ? void 0 : pmFragmentPreviewData.pmFragment) || (0, $7dkLM.Fragment).empty;
    const preview = getPreviewElement(pmFragment);
    /**
   * gets preview JSX element based on fragment
   */ function getPreviewElement(pmFragment) {
        if (aupViolation) {
            // fire analytics if we get an AUP violation from convoAI
            if (errorInfo && errorInfo.apiName === 'assistance-service') analyticsFlow.enqueueStep({
                stepName: 'apiError',
                attributes: {
                    errorType: 'AUP violation detected',
                    ...errorInfo
                }
            });
            const aupViolationMessage = formatMessage((0, $iypWf.messages).aupViolationMessage, {
                // This is based on guidance at
                // https://developer.atlassian.com/platform/localization/i18n-formatting/avoiding-concatenation/#links
                auplink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                        href: "https://www.atlassian.com/legal/acceptable-use-policy",
                        target: "_blank"
                    }, chunks)
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, aupViolationMessage);
        }
        if (responseTooSimilar) {
            const responseTooSimilarMessage = formatMessage((0, $iypWf.messages).responseTooSimilarMessage);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, responseTooSimilarMessage);
        }
        return (0, $e32NX.convertPMFragmentToPreview)({
            schema: schema,
            pmFragment: pmFragment,
            showTelepointer: false,
            providerFactory: providerFactory
        });
    }
    (0, $eUqFw.useEffect)(()=>{
        analyticsFlow.fireQueuedStep('preview');
        let modelIO;
        if (pmFragmentPreviewData) {
            var _lastHistoryEvent$mod, _localizedLatestPromp;
            const stats = new (0, $138p3.ProseMirrorContentStatistics)(pmFragment);
            const contentStatistics = stats.collectStatistics();
            modelIO = {
                selectionSize: (_lastHistoryEvent$mod = lastHistoryEvent.modelInput.selection) === null || _lastHistoryEvent$mod === void 0 ? void 0 : _lastHistoryEvent$mod.length,
                nodesConvertedToHTMLInput: idMap ? Object.keys(idMap).length : undefined,
                outputHTMLConvertedToNodes: pmFragmentPreviewData.htmlConvertedToNodes,
                outputHTMLConvertedToFallbackNodes: pmFragmentPreviewData.htmlConvertedToFallbackNodes,
                isTextFallbackUsed: pmFragmentPreviewData.isTextFallbackUsed,
                previewNodeCounts: contentStatistics.nodeCounts,
                previewMarkCounts: contentStatistics.markCounts,
                previewTotalCharacterCounts: contentStatistics.totalCharacterCount,
                userInputCharacterCount: (_localizedLatestPromp = localizedLatestPrompt.userInput) === null || _localizedLatestPromp === void 0 ? void 0 : _localizedLatestPromp.length
            };
        }
        analyticsFlow.addAttributes({
            editCount: editCount,
            isAupViolation: aupViolation,
            responseTooSimilar: responseTooSimilar,
            modelIO: {
                contextStatistics: contextStatistics,
                ...modelIO
            },
            inputOutputDiffRatio: inputOutputDiffRatio
        });
        return ()=>{
            // We only want to enqueue the preview step if it hasn't been enqueued
            // already. This is to handle the case where the user clicks on an
            // ai action button where we manually enqueue the analytics event,
            // and then seperately fire a complete step.
            if (enqueuedPreviewStep.current === false) analyticsFlow.enqueueStep({
                stepName: 'preview',
                attributes: undefined
            });
        };
    // expecting to enqueue step only once on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const isTextColorSupported = 'textColor' in schema.marks;
    const isVisualDiffPreviewEnabled = isTextColorSupported && (0, $3Ycnu.isExperimentEnabled)('editor_ai_-_visual_diff_preview_experiment') && (0, $3Ycnu.getExperimentCohort)('editor_ai_-_visual_diff_preview_experiment') === 'visual-diff-preview';
    const [diffPreview, setDiffPreview] = (0, $eUqFw.useState)();
    const isTranslations = (0, $dwVev.isTranslationPrompt)(latestPrompt);
    const { selectionType: selectionType } = configItem;
    (0, $eUqFw.useEffect)(()=>{
        if (isVisualDiffPreviewEnabled && !aupViolation && !responseTooSimilar && pmFragmentPreviewData !== null && pmFragmentPreviewData !== void 0 && pmFragmentPreviewData.pmFragment && !isTranslations) {
            const diff = (0, $iEDa2.createDiffPreview)({
                editorView: editorView,
                pmFragment: pmFragment,
                positions: positions,
                providerFactory: providerFactory
            });
            if (diff) {
                analyticsFlow.addAttributes({
                    hasShowDiff: true,
                    hasUserHighlightedDifferences: true
                });
                if (selectionType === 'range' && !(0, $dwVev.isTranslationPrompt)(latestPrompt)) analyticsFlow.addAttributes({
                    hasShowDiffEnabled: true
                });
                setDiffPreview(diff);
            }
        }
    }, // We only need to calculate the diff once
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        isVisualDiffPreviewEnabled,
        analyticsFlow,
        selectionType,
        isTranslations
    ]);
    const fireResponseFeedbackEvent = (sentiment, productSuccessState)=>{
        fireAIAnalyticsEvent({
            payload: {
                action: 'click',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'responseFeedbackButton',
                attributes: {
                    sentiment: sentiment,
                    hasAcceptableUseWarning: hasAcceptableUseWarning,
                    appearance: appearance,
                    product: product,
                    configItemTitle: configItemDefaultTitle,
                    lastTriggeredFrom: lastTriggeredFrom,
                    productSuccessStatus: productSuccessState,
                    inputOutputDiffRatio: inputOutputDiffRatio,
                    retryPromptCount: retryPromptCount,
                    responseTooSimilar: responseTooSimilar,
                    aiInteractionID: analyticsFlow.getLastAiInteractionId()
                },
                eventType: 'ui'
            }
        });
    };
    const handleFiringFeedbackEvent = async (feedbackMetadata)=>{
        analyticsFlow.addAttributes({
            userFeedbackSentiment: feedbackMetadata.sentiment
        });
        // handleFeedbackSubmission is intended to be implemented
        // by all products -- there will be a period where products won't have
        // it implemented (and will be relying on THUMBS_UP/THUMBS_DOWN)
        // in these cases -- we don't know the product response status
        if (!editorPluginAIProvider.handleFeedbackSubmission) {
            fireResponseFeedbackEvent(feedbackMetadata.sentiment, 'unknown');
            return;
        } else try {
            const productResponse = await editorPluginAIProvider.handleFeedbackSubmission(feedbackMetadata);
            fireResponseFeedbackEvent(feedbackMetadata.sentiment, productResponse.status);
        } catch  {
            fireResponseFeedbackEvent(feedbackMetadata.sentiment, 'failed');
        }
    };
    // preset prompt or base generate / interrogation
    const localizedLatestPrompt = (0, $eUqFw.useMemo)(()=>{
        return latestPrompt !== null && latestPrompt !== void 0 && latestPrompt.presetTitle ? {
            presetTitle: latestPrompt.presetTitle({
                formatMessage: formatMessage
            }),
            userInput: latestPrompt === null || latestPrompt === void 0 ? void 0 : latestPrompt.userInput,
            userADFInput: latestPrompt === null || latestPrompt === void 0 ? void 0 : latestPrompt.userADFInput
        } : {
            userInput: (latestPrompt === null || latestPrompt === void 0 ? void 0 : latestPrompt.userInput) || '',
            userADFInput: latestPrompt === null || latestPrompt === void 0 ? void 0 : latestPrompt.userADFInput
        };
    }, [
        latestPrompt,
        formatMessage
    ]);
    const onEditPromptClick = (0, $eUqFw.useCallback)(()=>{
        const { userInput: userInput, userADFInput: userADFInput, presetTitle: presetTitle } = localizedLatestPrompt;
        analyticsFlow.addAttributes({
            actionTaken: 'edit-prompt'
        });
        fireAIAnalyticsEvent({
            payload: {
                action: 'click',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'editPromptButton',
                attributes: {
                    experienceType: configItem.title({
                        formatMessage: (0, $3QQwc.analyticsFormatMessage)
                    }),
                    editCount: editCount
                },
                eventType: 'ui'
            }
        });
        send({
            type: 'edit prompt',
            userInput: userInput,
            userADFInput: userADFInput,
            presetTitle: presetTitle
        });
    }, [
        localizedLatestPrompt,
        send,
        editCount,
        configItem,
        fireAIAnalyticsEvent,
        analyticsFlow
    ]);
    const onShowDiffPreview = (0, $eUqFw.useCallback)((enabled)=>{
        analyticsFlow.addAttributes({
            hasUserHighlightedDifferences: enabled
        });
    }, [
        analyticsFlow
    ]);
    const configItemDefaultTitle = (0, $eUqFw.useMemo)(()=>configItem.title({
            formatMessage: (0, $3QQwc.analyticsFormatMessage)
        }), [
        configItem
    ]);
    const aiExperienceMetadata = {
        hasAcceptableUseWarning: hasAcceptableUseWarning,
        configItemTitle: configItemDefaultTitle,
        lastTriggeredFrom: lastTriggeredFrom,
        inputOutputDiffRatio: inputOutputDiffRatio,
        backendModel: backendModel
    };
    const getAIExperience = (hasUserConsent)=>({
            ...aiExperienceMetadata,
            ...hasUserConsent && {
                userPrompt: localizedLatestPrompt.userInput,
                markdownResponse: markdown
            }
        });
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        /**
     * When userInput is empty, we need to clear interrogate editor
     *  as setting empty userInput as defaultValue won't clear editor.
     */ if (!userInput) {
            var _clearInputRef$curren;
            (_clearInputRef$curren = clearInputRef.current) === null || _clearInputRef$curren === void 0 || _clearInputRef$curren.call(clearInputRef);
        }
    }, [
        userInput
    ]);
    const onInputChange = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((inputValue)=>{
        send({
            type: 'update user input',
            input: inputValue
        });
    }, [
        send
    ]);
    const onADFChange = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((inputValue)=>{
        send({
            type: 'update user input adf',
            adf: inputValue
        });
    }, [
        send
    ]);
    const disableInterrogation = ((_configItem$disableIn = configItem.disableInterrogation) === null || _configItem$disableIn === void 0 ? void 0 : _configItem$disableIn.call(configItem)) || editorPluginAIProvider.disableInterrogation;
    // if convoAI related FF is enabled
    const convoAIBeta = (0, $XHGTv.getBooleanFF)('platform.editor.ai-assistance-service-free-generate') || (0, $XHGTv.getBooleanFF)('platform.editor.ai-interrogate-with-convo-ai');
    // if it is generate or interrogate
    const isGenerateOrInterrogatePrompt = promptTrigger && [
        'interrogate',
        'generate'
    ].includes(promptTrigger);
    let additionalFooterText;
    if (isGenerateOrInterrogatePrompt && convoAIBeta && latestPrompt !== null && latestPrompt !== void 0 && latestPrompt.userInput) {
        // if the prompt includes a link
        const containsURL = latestPrompt.userInput.includes('http://') || latestPrompt.userInput.includes('https://');
        if (containsURL) additionalFooterText = formatMessage((0, $iypWf.messages).convoAIBeta);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lcglt.PreviewScreen), {
        latestPrompt: localizedLatestPrompt,
        diffPreview: diffPreview,
        canShowDiffPreview: selectionType === 'range' && !isTranslations,
        preview: preview,
        disableActions: aupViolation || !!responseTooSimilar,
        inputValue: userInput,
        inputADFValue: userADFInput,
        isInputActive: isInputActive,
        product: editorPluginAIProvider.product,
        onCancel: ()=>{
            if (isInputActive) send({
                type: 'cancel refinement'
            });
            else send({
                type: 'enable discard'
            });
        },
        onInputChange: onInputChange,
        onADFChange: onADFChange,
        onInputFocus: ()=>{
            send({
                type: 'start refinement'
            });
        },
        onInputBlur: ()=>{
            if (!userInput) send({
                type: 'cancel refinement'
            });
        },
        onSubmit: ()=>{
            /**
       * Do we really need to pass userInput and userADFInput
       *  on firing interrogate event.
       * We should have latest userInput and userADFInput
       *  set by onInputChange and onADFChange.
       */ send({
                type: 'interrogate',
                userInput: userInput,
                userADFInput: userADFInput,
                latestPromptResponse: markdown
            });
        },
        onCopy: ()=>{
            fireAIAnalyticsEvent({
                payload: {
                    action: 'click',
                    actionSubject: 'editorPluginAI',
                    actionSubjectId: 'copyButton',
                    attributes: {
                        experienceType: configItem.title({
                            formatMessage: (0, $3QQwc.analyticsFormatMessage)
                        }),
                        editCount: editCount
                    },
                    eventType: 'ui'
                }
            });
            analyticsFlow.addAttributes({
                contentCopied: true
            });
            (0, $c5I31.copyResponseToClipboard)({
                editorView: editorView,
                pmFragment: pmFragment
            });
        },
        onRetry: ()=>{
            fireAIAnalyticsEvent({
                payload: {
                    action: 'click',
                    actionSubject: 'editorPluginAI',
                    actionSubjectId: 'retryPromptButton',
                    attributes: {
                        experienceType: configItemDefaultTitle
                    },
                    eventType: 'ui'
                }
            });
            send({
                type: 'retry prompt',
                input: localizedLatestPrompt.userInput,
                adf: localizedLatestPrompt.userADFInput
            });
        },
        onGoodResponseButtonClick: ()=>{
            const feedbackMetadata = {
                sentiment: 'good',
                getAIExperience: getAIExperience,
                editorAttributes: {
                    appearance: appearance,
                    product: product
                }
            };
            // Now deprecated - migrate to handleFeedbackSubmission
            editorPluginAIProvider.onExperienceEvent && editorPluginAIProvider.onExperienceEvent.THUMBS_UP();
            handleFiringFeedbackEvent(feedbackMetadata);
        },
        onBadResponseButtonClick: ()=>{
            const feedbackMetadata = {
                sentiment: 'bad',
                getAIExperience: getAIExperience,
                editorAttributes: {
                    appearance: appearance,
                    product: product
                }
            };
            // Now deprecated - migrate to handleFeedbackSubmission
            editorPluginAIProvider.onExperienceEvent && editorPluginAIProvider.onExperienceEvent.THUMBS_DOWN();
            handleFiringFeedbackEvent(feedbackMetadata);
        },
        onEditPromptClick: onEditPromptClick,
        onShowDiffPreview: onShowDiffPreview,
        applications: configItem.actions.map((unformattedAction)=>{
            const action = unformattedAction({
                formatMessage: formatMessage
            });
            return {
                label: action.title,
                appearance: action.appearance,
                onClick: ()=>{
                    try {
                        var _editorPluginAIProvid2;
                        analyticsFlow.addAttributes({
                            actionTaken: action.analyticsTitle
                        });
                        analyticsFlow.enqueueStep({
                            stepName: 'preview',
                            attributes: undefined
                        });
                        // We set this to true to prevent the preview step from being
                        // enqueued again on unmount
                        // Note -- in future -- we expect the complete step to be deprecated
                        // an replaced with a "content highlighted" step
                        enqueuedPreviewStep.current = true;
                        analyticsFlow.fireQueuedStep('complete');
                        const beforeActionRun = performance.now();
                        action.run({
                            editorView: editorView,
                            positions: positions,
                            markdown: markdown,
                            pmFragment: pmFragment
                        });
                        analyticsFlow.enqueueStep({
                            stepName: 'complete',
                            attributes: {
                                actionTaken: action.analyticsTitle,
                                duration: Math.round(performance.now() - beforeActionRun),
                                editCount: editCount,
                                retryPromptCount: retryPromptCount,
                                inputOutputDiffRatio: inputOutputDiffRatio
                            }
                        });
                        /**
             * Please check with Ethan/PM upon removing onExperienceEvent
             * calls, to confirm it is no longer used in any ongoing experiments.
             */ (_editorPluginAIProvid2 = editorPluginAIProvider.onExperienceEvent) === null || _editorPluginAIProvid2 === void 0 || _editorPluginAIProvid2.EXPERIENCE_COMPLETE();
                        endExperience();
                    } catch (error) {
                        fireAIAnalyticsEvent({
                            payload: {
                                action: 'unhandledErrorCaught',
                                actionSubject: 'editorPluginAI',
                                actionSubjectId: 'experienceApplication',
                                attributes: {
                                    errorType: 'actionRunError',
                                    actionTitle: action.analyticsTitle,
                                    errorMessage: (0, $8pKer.ErrorUtils).extractErrorMessage(error)
                                },
                                eventType: 'operational'
                            }
                        });
                        send({
                            type: 'unknown fail',
                            failureReason: 'unknown fail',
                            errorInfo: {}
                        });
                    }
                },
                id: 'insert-button'
            };
        }),
        PromptEditor: editorPluginAIProvider.PromptEditor,
        clearInputRef: clearInputRef,
        additionalFooterText: additionalFooterText,
        providerFactory: providerFactory,
        schema: schema,
        disableInterrogation: disableInterrogation
    });
}

});
parcelRegister("lcglt", function(module, exports) {

$parcel$export(module.exports, "PreviewScreen", () => $f6e765d040c0a3e7$export$9f3706359963c421);
/* @jsx jsx */ /** @jsxFrag */ 
var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $byn9U = parcelRequire("byn9U");

var $dBH6i = parcelRequire("dBH6i");

var $du2tZ = parcelRequire("du2tZ");

var $ffiyv = parcelRequire("ffiyv");

var $XHGTv = parcelRequire("XHGTv");

var $lkPEe = parcelRequire("lkPEe");

var $e270j = parcelRequire("e270j");

var $44BNi = parcelRequire("44BNi");
var $bJeU6 = parcelRequire("bJeU6");
var $8ceJs = parcelRequire("8ceJs");

var $8cU5f = parcelRequire("8cU5f");

var $l1XHJ = parcelRequire("l1XHJ");

var $6wpGq = parcelRequire("6wpGq");

var $2GXlj = parcelRequire("2GXlj");

var $liRQN = parcelRequire("liRQN");

var $7NBW6 = parcelRequire("7NBW6");

var $3exJh = parcelRequire("3exJh");

var $6goUb = parcelRequire("6goUb");

var $9KI99 = parcelRequire("9KI99");

var $2vnaW = parcelRequire("2vnaW");


var $jjK5n = parcelRequire("jjK5n");

var $3Ycnu = parcelRequire("3Ycnu");
// Copied from packages/editor/editor-plugin-ai/src/config-items/config-items.tsx
/**
 * Could be either:
 * - userInput only (free form generate / interrogate)
 * - presetTitle only (summarize)
 * - both presetTitle and userInput (brainstorm)
 */ const $f6e765d040c0a3e7$var$mapActionAppearanceToButtonAppearance = {
    primary: 'primary',
    secondary: 'default',
    cancel: 'subtle'
};
const $f6e765d040c0a3e7$export$9f3706359963c421 = ({ latestPrompt: latestPrompt, preview: preview, diffPreview: diffPreview, canShowDiffPreview: canShowDiffPreview, disableActions: disableActions = false, disableInterrogation: disableInterrogation = false, onSubmit: onSubmit, onCancel: onCancel, onCopy: onCopy, onRetry: onRetry, onInputFocus: onInputFocus, onInputBlur: onInputBlur, onInputChange: onInputChange, onADFChange: onADFChange, onGoodResponseButtonClick: onGoodResponseButtonClick, onBadResponseButtonClick: onBadResponseButtonClick, onEditPromptClick: onEditPromptClick, onShowDiffPreview: onShowDiffPreview, applications: applications, isInputActive: isInputActive, inputValue: inputValue, inputADFValue: inputADFValue, product: product, PromptEditor: PromptEditor, clearInputRef: clearInputRef, additionalFooterText: additionalFooterText, providerFactory: providerFactory, schema: schema })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const focusInputRef = (0, $eUqFw.useRef)(undefined);
    const initialPlaceholder = formatMessage((0, $l1XHJ.default).defaultInputPlaceholder);
    const [placeholder, setPlaceholder] = (0, $eUqFw.useState)(initialPlaceholder);
    const [isDiffPreviewVisible, setIsDiffPreviewVisible] = (0, $eUqFw.useState)(true);
    const hasValidDiffPreview = !!diffPreview;
    (0, $eUqFw.useEffect)(()=>{
        setPlaceholder(isInputActive ? '' : initialPlaceholder);
    }, [
        isInputActive,
        initialPlaceholder
    ]);
    const handleToggleDiffPreviewVisibility = (0, $eUqFw.useCallback)(()=>{
        setIsDiffPreviewVisible((value)=>{
            onShowDiffPreview === null || onShowDiffPreview === void 0 || onShowDiffPreview(!value);
            return !value;
        });
    }, [
        setIsDiffPreviewVisible,
        onShowDiffPreview
    ]);
    const removeBetaLozenge = product === 'JPD' ? (0, $XHGTv.getBooleanFF)('platform.editor.ai-remove-beta-lozenge-jpd_1t8rt') : (0, $XHGTv.getBooleanFF)('platform.editor.ai-remove-beta-lozenge_s5yrq');
    const convoAIBetaLozenge = (0, $XHGTv.getBooleanFF)('platform.editor.ai-assistance-service-free-generate') || (0, $XHGTv.getBooleanFF)('platform.editor.ai-interrogate-with-convo-ai');
    const showBetaLozenge = !removeBetaLozenge || convoAIBetaLozenge;
    const usePromptEditorInInterrogate = !!(0, $XHGTv.getBooleanFF)('platform.editor.ai-lightweight-editor-interrogate_x356n');
    const enableLinksInPromptEditor = !!(0, $XHGTv.getBooleanFF)('platform.editor.ai-interrogate-with-convo-ai');
    const isTextColorSupported = 'textColor' in schema.marks;
    const isVisualDiffPreviewEnabled = isTextColorSupported && (0, $3Ycnu.isExperimentEnabled)('editor_ai_-_visual_diff_preview_experiment') && (0, $3Ycnu.getExperimentCohort)('editor_ai_-_visual_diff_preview_experiment') === 'visual-diff-preview';
    const ActionsWrapper = (0, $eUqFw.useCallback)(({ children: children })=>isVisualDiffPreviewEnabled ? (0, $byn9U.jsx)("div", {
            css: (0, $6wpGq.actionsContainerWrapper)
        }, children) : (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children), [
        isVisualDiffPreviewEnabled
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    (0, $byn9U.jsx)("div", {
        css: (0, $6wpGq.columnLayout),
        className: "preview-screen"
    }, (0, $byn9U.jsx)((0, $2GXlj.FloatingContainer), {
        disablePadding: true,
        "data-testid": "preview-screen",
        className: `preview-screen ${(0, $64ce3526fe10ea0e$export$9df59400d72ad68f)}`,
        css: (0, $6wpGq.containerLayout)
    }, (0, $byn9U.jsx)((0, $lkPEe.default), null, formatMessage((0, $l1XHJ.default).previewScreenLabel)), (0, $byn9U.jsx)((0, $liRQN.LatestPromptHeader), {
        prompt: latestPrompt === null || latestPrompt === void 0 ? void 0 : latestPrompt.userInput,
        promptADF: latestPrompt === null || latestPrompt === void 0 ? void 0 : latestPrompt.userADFInput,
        presetTitle: latestPrompt === null || latestPrompt === void 0 ? void 0 : latestPrompt.presetTitle,
        providerFactory: providerFactory,
        schema: schema,
        onEditPromptClick: onEditPromptClick
    }), (0, $byn9U.jsx)("div", {
        css: [
            (0, $6wpGq.previewContainer),
            (0, $7NBW6.defaultPaddingStyles)
        ]
    }, isVisualDiffPreviewEnabled && isDiffPreviewVisible && hasValidDiffPreview ? diffPreview : preview, (0, $byn9U.jsx)(ActionsWrapper, null, isVisualDiffPreviewEnabled && canShowDiffPreview && (0, $byn9U.jsx)("div", {
        css: (0, $6wpGq.diffToggleWrapper)
    }, (0, $byn9U.jsx)((0, $8cU5f.default), {
        content: !hasValidDiffPreview && formatMessage((0, $l1XHJ.default).highlightDifferencesDisabledTooltip)
    }, (0, $byn9U.jsx)((0, $bJeU6.default), {
        alignBlock: "center"
    }, (0, $byn9U.jsx)((0, $e270j.default), {
        isDisabled: !hasValidDiffPreview,
        label: formatMessage((0, $l1XHJ.default).highlightDifferencesLabel),
        id: "diff-preview-toggle",
        testId: "diff-preview-toggle",
        isChecked: isDiffPreviewVisible,
        onChange: handleToggleDiffPreviewVisibility
    }), (0, $byn9U.jsx)((0, $44BNi.default), {
        xcss: (0, $8ceJs.xcss)({
            ...!hasValidDiffPreview && {
                color: 'color.text.disabled',
                cursor: 'not-allowed'
            }
        }),
        as: "label",
        htmlFor: "diff-preview-toggle"
    }, (0, $byn9U.jsx)("span", null, formatMessage((0, $l1XHJ.default).highlightDifferencesLabel)))))), (0, $byn9U.jsx)("div", {
        css: (0, $6wpGq.actionsContainer)
    }, (0, $byn9U.jsx)((0, $dBH6i.default), {
        testId: "cancel-button",
        onClick: onCancel,
        css: (0, $jjK5n.buttonAutoFocusRingFix),
        autoFocus: true,
        type: "button",
        appearance: disableActions ? 'primary' : 'subtle'
    }, formatMessage((0, $l1XHJ.default).cancelLabel)), disableActions ? null : (0, $byn9U.jsx)("div", {
        css: (0, $6wpGq.actionsButtonGroup)
    }, (0, $byn9U.jsx)((0, $9KI99.RetryIconButton), {
        onClick: onRetry
    }), (0, $byn9U.jsx)((0, $6goUb.CopyIconButton), {
        onClick: onCopy
    }), applications.map(({ onClick: onClick, label: label, appearance: appearance })=>(0, $byn9U.jsx)((0, $du2tZ.default), {
            key: label,
            testId: "insert-response-button",
            onClick: onClick,
            type: "button",
            appearance: $f6e765d040c0a3e7$var$mapActionAppearanceToButtonAppearance[appearance]
        }, label)))))), disableActions || disableInterrogation ? null : (0, $byn9U.jsx)("div", {
        css: (0, $7NBW6.defaultPaddingStyles)
    }, (0, $byn9U.jsx)((0, $3exJh.PromptForm), {
        showButtons: isInputActive,
        autoFocus: false,
        placeholder: placeholder,
        ariaLabel: initialPlaceholder,
        value: inputValue,
        adfValue: inputADFValue,
        onFormSubmit: onSubmit,
        onCancel: onCancel,
        onInputChange: onInputChange,
        onADFChange: onADFChange,
        onInputFocus: onInputFocus,
        onInputBlur: onInputBlur,
        focusInputRef: focusInputRef,
        clearInputRef: clearInputRef,
        PromptEditor: usePromptEditorInInterrogate ? PromptEditor : undefined,
        enableLinks: enableLinksInPromptEditor
    })), (0, $byn9U.jsx)("div", {
        css: (0, $6wpGq.footerStyles)
    }, (0, $byn9U.jsx)("div", {
        css: (0, $6wpGq.footerInformationStyles)
    }, showBetaLozenge && (0, $byn9U.jsx)((0, $ffiyv.default), {
        testId: "beta-lozenge",
        appearance: "inprogress"
    }, formatMessage((0, $l1XHJ.default).betaLabel)), (0, $byn9U.jsx)("p", null, formatMessage((0, $l1XHJ.default).disclaimer) + ' ', (0, $byn9U.jsx)("a", {
        href: "https://www.atlassian.com/trust/atlassian-intelligence",
        target: "_blank"
    }, formatMessage((0, $l1XHJ.default).disclaimerLink)), additionalFooterText && (0, $byn9U.jsx)("strong", null, ". ", additionalFooterText))), (0, $byn9U.jsx)((0, $2vnaW.FeedbackForm), {
        onGoodResponseButtonClick: onGoodResponseButtonClick,
        onBadResponseButtonClick: onBadResponseButtonClick
    })))));
};

});
parcelRegister("du2tZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d1000bcbb41385c$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $XHGTv = parcelRequire("XHGTv");

var $6u7Y2 = parcelRequire("6u7Y2");

var $dAnCN = parcelRequire("dAnCN");
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ const $9d1000bcbb41385c$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(function Button({ analyticsContext: analyticsContext, appearance: appearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus, children: children, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, overlay: overlay, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, type: type = 'button', UNSAFE_iconAfter_size: UNSAFE_iconAfter_size, UNSAFE_iconBefore_size: UNSAFE_iconBefore_size, ...unsafeRest }, ref) {
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const rest = (0, $XHGTv.getBooleanFF)('platform.design-system-team.remove-unsafe-spread-from-new-button_a2xhw') ? saferRest : unsafeRest;
    const baseProps = (0, $dAnCN.default)({
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        buttonType: 'button',
        children: children,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        overlay: overlay,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId,
        UNSAFE_iconAfter_size: UNSAFE_iconAfter_size,
        UNSAFE_iconBefore_size: UNSAFE_iconBefore_size
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6u7Y2.default), (0, $kU09D.default)({}, rest, {
        "aria-label": baseProps['aria-label'],
        "aria-labelledby": baseProps['aria-labelledby'],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        isDisabled: baseProps.isDisabled,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        type: type,
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "Button"
    }), baseProps.children);
}));
$9d1000bcbb41385c$var$Button.displayName = 'Button';
var $9d1000bcbb41385c$export$2e2bcd8739ae039 = $9d1000bcbb41385c$var$Button;

});
parcelRegister("dAnCN", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e40f68bbfb14c43$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7YhM7 = parcelRequire("7YhM7");

var $hcjID = parcelRequire("hcjID");

var $4ZT6G = parcelRequire("4ZT6G");

var $khvg1 = parcelRequire("khvg1");
/**
 * __Use default button base__
 *
 * A React hook that accepts a set of default Button props,
 * and processes them to return consistent base props for usage
 * across Button and LinkButton variants.
 *
 * @private
 */ const $9e40f68bbfb14c43$var$useDefaultButton = ({ analyticsContext: analyticsContext, appearance: appearance, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, autoFocus: autoFocus, buttonType: buttonType, children: children, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, overlay: overlay, ref: ref, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, UNSAFE_iconAfter_size: UNSAFE_iconAfter_size, UNSAFE_iconBefore_size: UNSAFE_iconBefore_size })=>{
    const hasOverlay = Boolean(overlay || isLoading);
    const baseProps = (0, $khvg1.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        buttonType: buttonType,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, iconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7YhM7.default), {
            type: "icon",
            position: "before",
            hasOverlay: hasOverlay
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hcjID.default), {
            icon: iconBefore,
            size: UNSAFE_iconBefore_size
        })), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7YhM7.default), {
            hasOverlay: hasOverlay
        }, children), iconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7YhM7.default), {
            type: "icon",
            position: "after",
            hasOverlay: hasOverlay
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hcjID.default), {
            icon: iconAfter,
            size: UNSAFE_iconAfter_size
        }))),
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        overlay: isLoading ? (0, $4ZT6G.default)({
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected,
            testId: testId
        }) : overlay,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter)
    });
    return baseProps;
};
var $9e40f68bbfb14c43$export$2e2bcd8739ae039 = $9e40f68bbfb14c43$var$useDefaultButton;

});


parcelRegister("44BNi", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f74da42e2c973ec$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $snE9y = parcelRequire("snE9y");

var $8ceJs = parcelRequire("8ceJs");

var $8nikQ = parcelRequire("8nikQ");
const $2f74da42e2c973ec$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $8ceJs.parseXcss)(xcss);
    const node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $byn9U.jsx)(Component, (0, $kU09D.default)({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $2f74da42e2c973ec$var$baseStyles,
            backgroundColor && (0, $snE9y.backgroundColorStylesMap)[backgroundColor],
            (0, $snE9y.isSurfaceColorToken)(backgroundColor) && (0, $snE9y.surfaceColorStylesMap)[backgroundColor],
            padding && (0, $snE9y.paddingStylesMap).padding[padding],
            paddingBlock && (0, $snE9y.paddingStylesMap).paddingBlock[paddingBlock],
            paddingBlockStart && (0, $snE9y.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            paddingBlockEnd && (0, $snE9y.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            paddingInline && (0, $snE9y.paddingStylesMap).paddingInline[paddingInline],
            paddingInlineStart && (0, $snE9y.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            paddingInlineEnd && (0, $snE9y.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $byn9U.jsx)((0, $8nikQ.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $2f74da42e2c973ec$export$2e2bcd8739ae039 = $2f74da42e2c973ec$export$e71c4d32a2263218;
const $2f74da42e2c973ec$var$baseStyles = (0, $byn9U.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});

});

parcelRegister("bJeU6", function(module, exports) {

$parcel$export(module.exports, "default", () => $889f75456da04bec$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/styles/no-exported-styles */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8ceJs = parcelRequire("8ceJs");

var $3yyVA = parcelRequire("3yyVA");
const $889f75456da04bec$var$flexGrowMap = {
    hug: (0, $8ceJs.xcss)({
        flexGrow: 0
    }),
    fill: (0, $8ceJs.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
const $889f75456da04bec$var$separatorStyles = (0, $byn9U.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: `${"var(--ds-space-negative-025, -2px)"}`,
    pointerEvents: 'none',
    userSelect: 'none'
});
const $889f75456da04bec$var$Separator = ({ children: children })=>(0, $byn9U.jsx)("span", {
        css: $889f75456da04bec$var$separatorStyles
    }, children);
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ const $889f75456da04bec$var$Inline = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, children: rawChildren }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? (0, $byn9U.jsx)($889f75456da04bec$var$Separator, null, separator) : separator;
    const children = separatorComponent ? (0, $eUqFw.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return (0, $byn9U.jsx)((0, $eUqFw.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    const justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    const styles = grow ? [
        $889f75456da04bec$var$flexGrowMap[grow],
        ...Array.isArray(xcss) ? xcss : [
            xcss
        ]
    ] : xcss;
    return (0, $byn9U.jsx)((0, $3yyVA.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$889f75456da04bec$var$Inline.displayName = 'Inline';
var $889f75456da04bec$export$2e2bcd8739ae039 = $889f75456da04bec$var$Inline;

});

parcelRegister("l1XHJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4f800fd97962bc5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f4f800fd97962bc5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    logoAltText: {
        id: 'fabric.editor.ai.screens.prompt.logoAltText',
        defaultMessage: 'Atlassian Intelligence Logo',
        description: 'Atlassian Intelligence logo alt text of the Prompt screen'
    },
    logoText: {
        id: 'fabric.editor.ai.screens.prompt.logoText',
        defaultMessage: 'Atlassian Intelligence',
        description: 'Atlassian Intelligence Logo text of the Prompt screen'
    },
    betaLabel: {
        id: 'fabric.editor.ai.screens.preview.betaLabel',
        defaultMessage: 'Beta',
        description: 'The label describing the beta status of the Atlassian Intelligence feature'
    },
    cancelLabel: {
        id: 'fabric.editor.ai.screens.preview.cancelLabel',
        defaultMessage: 'Cancel',
        description: 'The action text for the cancel button to discard the previewed generated content'
    },
    defaultInputPlaceholder: {
        id: 'fabric.editor.ai.screens.preview.defaultAIPlaceholder',
        defaultMessage: 'Tell AI what to do next',
        description: 'The default placeholder text for the prompt input field within the Preview screen'
    },
    disclaimer: {
        id: 'fabric.editor.ai.screens.preview.disclaimer',
        defaultMessage: 'Information quality may vary.',
        description: 'The text for the generated content disclaimer'
    },
    disclaimerLink: {
        id: 'fabric.editor.ai.screens.preview.disclaimerLink',
        defaultMessage: 'Learn why',
        description: 'The text for the generated content disclaimer link'
    },
    previewScreenLabel: {
        id: 'fabric.editor.ai.experience.previewScreenLabel',
        defaultMessage: 'Preview',
        description: 'Accessible label for the AI response preview screen of the AI modal'
    },
    highlightDifferencesLabel: {
        id: 'fabric.editor.ai.screens.preview.highlightDifferencesLabel',
        defaultMessage: 'Highlight differences',
        description: 'The label for the toggle to highlight differences between the user selection and the generated response'
    },
    highlightDifferencesDisabledTooltip: {
        id: 'fabric.editor.ai.screens.preview.highlightDifferencesDisabledTooltip',
        defaultMessage: 'This feature is not available for this AI generated response.',
        description: 'The tooltip text when the toggle to highlight differences between the user selection and the generated response is disabled'
    }
});

});

parcelRegister("6wpGq", function(module, exports) {

$parcel$export(module.exports, "containerLayout", () => $4bf9a767d70a20cb$export$a4e80cd8d85917bb);
$parcel$export(module.exports, "previewContainer", () => $4bf9a767d70a20cb$export$8aade8ce2b5d7e87);
$parcel$export(module.exports, "actionsContainer", () => $4bf9a767d70a20cb$export$2ecf5991ce6f67a6);
$parcel$export(module.exports, "actionsButtonGroup", () => $4bf9a767d70a20cb$export$4a295b3126c7469c);
$parcel$export(module.exports, "columnLayout", () => $4bf9a767d70a20cb$export$f8ce731bdfd45dc7);
$parcel$export(module.exports, "footerStyles", () => $4bf9a767d70a20cb$export$c19244d3e10df333);
$parcel$export(module.exports, "footerInformationStyles", () => $4bf9a767d70a20cb$export$913d9555a421572b);
$parcel$export(module.exports, "actionsContainerWrapper", () => $4bf9a767d70a20cb$export$76bad61b7f254858);
$parcel$export(module.exports, "diffToggleWrapper", () => $4bf9a767d70a20cb$export$353bc745b689e320);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
const $4bf9a767d70a20cb$export$a4e80cd8d85917bb = (0, $byn9U.css)({
    display: 'flex',
    flexDirection: 'column'
});
const $4bf9a767d70a20cb$export$8aade8ce2b5d7e87 = (0, $byn9U.css)({
    padding: "var(--ds-space-150, 12px)",
    borderTop: `1px solid ${`var(--ds-border, ${(0, $PdmhA.N40A)})`}`,
    borderBottom: `1px solid ${`var(--ds-border, ${(0, $PdmhA.N40A)})`}`
});
const $4bf9a767d70a20cb$export$2ecf5991ce6f67a6 = (0, $byn9U.css)({
    display: 'flex',
    flexWrap: 'wrap-reverse',
    justifyContent: 'flex-end',
    gap: "var(--ds-space-100, 8px)",
    paddingTop: "var(--ds-space-150, 12px)"
});
const $4bf9a767d70a20cb$export$4a295b3126c7469c = (0, $byn9U.css)({
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    gap: "var(--ds-space-100, 8px)"
});
const $4bf9a767d70a20cb$export$f8ce731bdfd45dc7 = (0, $byn9U.css)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: "var(--ds-space-050, 4px)"
});
const $4bf9a767d70a20cb$export$c19244d3e10df333 = (0, $byn9U.css)({
    display: 'flex',
    flexWrap: 'wrap',
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-150, 12px)"}`,
    gap: "var(--ds-space-050, 4px)",
    borderTopLeftRadius: 'unset',
    borderTopRightRadius: 'unset',
    backgroundColor: `var(--ds-background-accent-gray-subtlest, ${(0, $PdmhA.N20)})`,
    alignItems: 'center',
    justifyContent: 'space-between'
});
const $4bf9a767d70a20cb$export$913d9555a421572b = (0, $byn9U.css)({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    minWidth: 0,
    minHeight: "var(--ds-space-300, 24px)",
    '& > p': {
        color: `var(--ds-text-subtle, ${(0, $PdmhA.N500)})`,
        fontSize: '11px',
        marginTop: 0
    },
    '& > span': {
        marginTop: "var(--ds-space-050, 4px)",
        marginRight: "var(--ds-space-050, 4px)",
        marginBottom: "var(--ds-space-050, 4px)"
    }
});
const $4bf9a767d70a20cb$export$76bad61b7f254858 = (0, $byn9U.css)({
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    gap: "var(--ds-space-100, 8px)",
    alignItems: 'flex-end',
    flex: 1
});
const $4bf9a767d70a20cb$export$353bc745b689e320 = (0, $byn9U.css)({
    display: 'flex',
    flexWrap: 'wrap',
    flex: 1,
    gap: "var(--ds-space-100, 8px)",
    marginTop: "var(--ds-space-150, 12px)"
});

});

parcelRegister("3exJh", function(module, exports) {

$parcel$export(module.exports, "PromptForm", () => $25acd7da85b14ff9$export$416523684d97c4ad);
/* @jsx jsx */ /** @jsxfrag */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $XHGTv = parcelRequire("XHGTv");

var $9cMat = parcelRequire("9cMat");

var $kIeme = parcelRequire("kIeme");

var $5zCrB = parcelRequire("5zCrB");

var $jeBAC = parcelRequire("jeBAC");

var $7nPJR = parcelRequire("7nPJR");

var $bFJ7u = parcelRequire("bFJ7u");

var $1LDNt = parcelRequire("1LDNt");

var $2yFAL = parcelRequire("2yFAL");
const $25acd7da85b14ff9$export$416523684d97c4ad = ({ onFormSubmit: onFormSubmit, onCancel: onCancel, value: value = '', showButtons: showButtons = true, tag: tag, autoFocus: autoFocus = true, onInputChange: onInputChange, onADFChange: onADFChange, onInputFocus: onInputFocus, onInputBlur: onInputBlur, placeholder: placeholder, ariaLabel: ariaLabel, focusInputRef: focusInputRef, clearInputRef: clearInputRef, showLogo: showLogo = true, onInputKeyDown: onInputKeyDown, adfValue: adfValue, enableLinks: enableLinks, PromptEditor: PromptEditor, inputControlsLayout: inputControlsLayout = 'row' })=>{
    const { ref: ref, breakpoint: breakpoint } = (0, $bFJ7u.useContainerBreakpoints)();
    const blurInputRef = (0, $eUqFw.useRef)(undefined);
    const [hasMutipleRows, setHasMutipleRows] = (0, $eUqFw.useState)(false);
    const [buttonWidth, setButtonWidth] = (0, $eUqFw.useState)(0);
    const [isComposing, setIsComposing] = (0, $eUqFw.useState)(false);
    const handleSubmit = (event)=>{
        event.preventDefault();
        event.stopPropagation();
        onFormSubmit(value);
    };
    const handleSetButtonWidth = (0, $eUqFw.useCallback)((el)=>{
        if (el) setButtonWidth(el.getBoundingClientRect().width);
    }, [
        setButtonWidth
    ]);
    const handleOnCompositionStart = (0, $eUqFw.useCallback)(()=>{
        setIsComposing(true);
    }, []);
    const handleOnCompositionEnd = (0, $eUqFw.useCallback)(()=>{
        setIsComposing(false);
    }, []);
    const handleKeyDown = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((event)=>{
        if (event.key === 'Enter') {
            var _target$getAttribute;
            event.stopPropagation();
            const target = event.target;
            if (isComposing) return;
            // Handles a case where the user presses enter if refinement tag's close button or the
            // cancel button is focused
            if ([
                'close-button-refinement-tag',
                'cancel-icon-button',
                'cancel-esc-button'
            ].includes((_target$getAttribute = target.getAttribute('data-testid')) !== null && _target$getAttribute !== void 0 ? _target$getAttribute : '')) return;
            // Handles every other case that is not a "shift + enter"
            if (!event.shiftKey) {
                event.preventDefault();
                onFormSubmit(value);
            }
        }
    }, [
        onFormSubmit,
        value,
        isComposing
    ]);
    const usePromptEditor = (0, $XHGTv.getBooleanFF)('platform.editor.ai-lightweight-editor-prompt_f92x1') && !!PromptEditor;
    const onADFChange_ = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((input)=>{
        if (onADFChange) onADFChange(input);
    }, [
        onADFChange
    ]);
    const onInputChange_ = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((value)=>{
        if (onInputChange) onInputChange(value);
    }, [
        onInputChange
    ]);
    return (0, $byn9U.jsx)("div", {
        // ED-19496: We avoid propagating enter keypresses
        // since products like Bitbucket might have parent forms
        // that listen for keydown events to trigger form submission
        onKeyDown: handleKeyDown,
        css: (0, $9cMat.formContainerStyles),
        ref: ref
    }, showLogo && (0, $byn9U.jsx)("div", {
        css: (0, $9cMat.logoContainerStyles)(breakpoint)
    }, (0, $byn9U.jsx)((0, $7nPJR.AtlassianIntelligenceLogo), null)), (0, $byn9U.jsx)("form", {
        "data-layout": inputControlsLayout,
        css: (0, $9cMat.formStyles)(breakpoint),
        onSubmit: handleSubmit,
        className: "ai-modal-prompt-form",
        "data-testid": "ai-modal-prompt-form"
    }, tag, (0, $byn9U.jsx)("div", {
        "data-multiline": hasMutipleRows,
        css: [
            (0, $kIeme.commonTextStyles),
            (0, $9cMat.formInnerStyles)
        ]
    }, usePromptEditor && (0, $byn9U.jsx)((0, $1LDNt.PromptEditorWrapper), {
        PromptEditor: PromptEditor,
        focusInputRef: focusInputRef,
        blurInputRef: blurInputRef,
        clearInputRef: clearInputRef,
        autoFocus: autoFocus,
        defaultValue: adfValue,
        onInputChange: onInputChange_,
        onADFChange: onADFChange_,
        placeholder: placeholder,
        onFocus: onInputFocus,
        onBlur: onInputBlur,
        onKeyDown: onInputKeyDown,
        onCompositionStart: handleOnCompositionStart,
        onCompositionEnd: handleOnCompositionEnd,
        enableLinks: enableLinks
    }), !usePromptEditor && (0, $byn9U.jsx)((0, $2yFAL.PromptMultilineInput), {
        focusInputRef: focusInputRef,
        blurInputRef: blurInputRef,
        value: value,
        autoFocus: autoFocus,
        onInputChange: onInputChange_,
        placeholder: placeholder,
        "aria-label": ariaLabel || placeholder,
        onFocus: onInputFocus,
        onBlur: onInputBlur,
        buttonWidth: buttonWidth,
        hasMultipleRows: hasMutipleRows,
        setHasMultipleRows: setHasMutipleRows,
        onKeyDown: onInputKeyDown,
        onCompositionStart: handleOnCompositionStart,
        onCompositionEnd: handleOnCompositionEnd
    }), showButtons && (0, $byn9U.jsx)("div", {
        "data-multiline": hasMutipleRows,
        css: [
            (0, $9cMat.buttonWrapperStyles)
        ],
        ref: handleSetButtonWidth
    }, (0, $byn9U.jsx)((0, $jeBAC.SubmitButton), {
        disabled: !value
    }), (0, $byn9U.jsx)((0, $5zCrB.CancelIconButton), {
        onCancel: ()=>{
            var _blurInputRef$current;
            onCancel();
            (_blurInputRef$current = blurInputRef.current) === null || _blurInputRef$current === void 0 || _blurInputRef$current.call(blurInputRef);
        }
    })))));
};

});
parcelRegister("9cMat", function(module, exports) {

$parcel$export(module.exports, "formContainerStyles", () => $6b3a99338faad9eb$export$51f8df1eaf0be4cd);
$parcel$export(module.exports, "formStyles", () => $6b3a99338faad9eb$export$e1b615d0557d2f42);
$parcel$export(module.exports, "formInnerStyles", () => $6b3a99338faad9eb$export$27b9ff0951a9fa9f);
$parcel$export(module.exports, "buttonWrapperStyles", () => $6b3a99338faad9eb$export$af008dcc7d3b031e);
$parcel$export(module.exports, "logoContainerStyles", () => $6b3a99338faad9eb$export$6b0f8f6d4f0787a9);

var $byn9U = parcelRequire("byn9U");

var $bFJ7u = parcelRequire("bFJ7u");
const $6b3a99338faad9eb$export$51f8df1eaf0be4cd = (0, $byn9U.css)({
    display: 'flex',
    justifyContent: 'flex-start',
    flex: 1,
    alignItems: 'flex-start'
});
const $6b3a99338faad9eb$export$e1b615d0557d2f42 = (breakpoint)=>(0, $byn9U.css)({
        // by default, form elements seem to pick up 12px
        // top margin so we clear it
        margin: 0,
        flex: 1,
        justifyContent: 'left',
        display: breakpoint <= (0, $bFJ7u.Breakpoint).Small ? 'block' : 'flex',
        alignItems: 'flex-start',
        '&[data-layout="column"]': {
            flexDirection: 'column',
            rowGap: "var(--ds-space-100, 8px)",
            '> *': {
                width: '100%'
            }
        }
    });
const $6b3a99338faad9eb$export$27b9ff0951a9fa9f = (0, $byn9U.css)({
    display: 'flex',
    flex: 1,
    "&[data-multiline='true']": {
        display: 'block'
    }
});
const $6b3a99338faad9eb$export$af008dcc7d3b031e = (0, $byn9U.css)({
    float: 'right',
    display: 'flex',
    "&[data-multiline='true']": {
        paddingTop: "var(--ds-space-100, 8px)"
    }
});
const $6b3a99338faad9eb$export$6b0f8f6d4f0787a9 = (breakpoint)=>(0, $byn9U.css)({
        display: 'flex',
        flexDirection: 'row',
        marginRight: "var(--ds-space-050, 4px)",
        alignItems: 'center',
        alignSelf: breakpoint <= (0, $bFJ7u.Breakpoint).Small ? 'self-start' : 'initial'
    });

});

parcelRegister("5zCrB", function(module, exports) {

$parcel$export(module.exports, "CancelIconButton", () => $40ee0adee72fdf33$export$4d9f00b191df2f99);
/* @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8cU5f = parcelRequire("8cU5f");

var $dBH6i = parcelRequire("dBH6i");

var $je5kZ = parcelRequire("je5kZ");

var $fb8yb = parcelRequire("fb8yb");

var $jjK5n = parcelRequire("jjK5n");
const $40ee0adee72fdf33$export$4d9f00b191df2f99 = ({ onCancel: onCancel, tabIndex: tabIndex, autoFocus: autoFocus })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return (0, $byn9U.jsx)((0, $8cU5f.default), {
        content: formatMessage((0, $fb8yb.default).cancelTooltip),
        position: "top"
    }, (0, $byn9U.jsx)((0, $dBH6i.default), {
        css: (0, $jjK5n.buttonAutoFocusRingFix),
        "aria-label": formatMessage((0, $fb8yb.default).cancelLabel),
        testId: "cancel-icon-button",
        type: "button",
        onClick: onCancel,
        autoFocus: autoFocus,
        iconBefore: (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($je5kZ))), {
            label: formatMessage((0, $fb8yb.default).cancelTooltip)
        }),
        appearance: "subtle",
        spacing: "compact",
        tabIndex: tabIndex
    }));
};

});
parcelRegister("fb8yb", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0ce83fe1283411c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b0ce83fe1283411c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    cancelLabel: {
        id: 'fabric.editor.ai.components.cancelIconButton.cancelLabel',
        defaultMessage: 'Cancel',
        description: 'Cancel button label'
    },
    cancelTooltip: {
        id: 'fabric.editor.ai.components.cancelIconButton.cancelTooltip',
        defaultMessage: 'Cancel',
        description: 'Cancel button tooltip'
    }
});

});


parcelRegister("jeBAC", function(module, exports) {

$parcel$export(module.exports, "SubmitButton", () => $e00c7ba89ef4ec85$export$8b7b7cdfb85d78c5);
/* @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8cU5f = parcelRequire("8cU5f");

var $dBH6i = parcelRequire("dBH6i");

var $9zKyk = parcelRequire("9zKyk");

var $4BmAi = parcelRequire("4BmAi");

var $7b4Zs = parcelRequire("7b4Zs");
const $e00c7ba89ef4ec85$export$8b7b7cdfb85d78c5 = ({ disabled: disabled, tabIndex: tabIndex })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return (0, $byn9U.jsx)((0, $8cU5f.default), {
        content: formatMessage((0, $4BmAi.default).submitTooltip),
        hideTooltipOnClick: true,
        position: "top"
    }, (0, $byn9U.jsx)((0, $dBH6i.default), {
        "aria-label": formatMessage((0, $4BmAi.default).submitLabel),
        css: (0, $7b4Zs.submitButtonStyles),
        type: "submit",
        appearance: "subtle",
        spacing: "compact",
        isDisabled: disabled,
        iconBefore: (0, $byn9U.jsx)((0, $9zKyk.default), null),
        tabIndex: tabIndex
    }));
};

});
parcelRegister("9zKyk", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f8b7e57fd400731$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $6f8b7e57fd400731$var$Enter = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "14",
        height: "12",
        viewBox: "0 0 14 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M4.63477 11.2256C5.12012 11.2256 5.44141 10.8906 5.44141 10.4326C5.44141 10.1729 5.33203 9.98828 5.18164 9.83789L4.18359 8.86719L3.41113 8.24512L4.61426 8.2998H10.9102C12.4688 8.2998 13.1387 7.62988 13.1387 6.07129V2.89258C13.1387 1.33398 12.4688 0.657227 10.9102 0.657227H8.06641C7.58105 0.657227 7.21875 1.0332 7.21875 1.49121C7.21875 1.95605 7.58105 2.33203 8.06641 2.33203H10.835C11.3135 2.33203 11.5049 2.5166 11.5049 3.00195V5.96191C11.5049 6.44043 11.3135 6.63184 10.835 6.63184H4.61426L3.41113 6.68652L4.18359 6.06445L5.18164 5.10059C5.33203 4.94336 5.44141 4.76562 5.44141 4.50586C5.44141 4.04785 5.12012 3.70605 4.63477 3.70605C4.42285 3.70605 4.19727 3.80176 4.0332 3.96582L1.10742 6.85059C0.950195 7.00781 0.861328 7.24023 0.861328 7.46582C0.861328 7.69141 0.950195 7.93066 1.10742 8.08105L4.0332 10.9658C4.19727 11.1367 4.42285 11.2256 4.63477 11.2256Z",
        fill: "currentColor"
    }));
var $6f8b7e57fd400731$export$2e2bcd8739ae039 = $6f8b7e57fd400731$var$Enter;

});

parcelRegister("4BmAi", function(module, exports) {

$parcel$export(module.exports, "default", () => $359c22ed655556e7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $359c22ed655556e7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    submitLabel: {
        id: 'fabric.editor.ai.screens.prompt.submitLabel',
        defaultMessage: 'Submit',
        description: 'Submit button label within the Prompt screen'
    },
    submitTooltip: {
        id: 'fabric.editor.ai.screens.prompt.submitTooltip',
        defaultMessage: 'Send to AI',
        description: 'Submit button tooltip within the Prompt screen'
    }
});

});

parcelRegister("7b4Zs", function(module, exports) {

$parcel$export(module.exports, "submitButtonStyles", () => $539d6e74e44980f4$export$6b9d11903a3fd596);

var $byn9U = parcelRequire("byn9U");
const $539d6e74e44980f4$export$6b9d11903a3fd596 = (0, $byn9U.css)({
    marginLeft: 'auto',
    paddingRight: "var(--ds-space-100, 8px)",
    paddingLeft: "var(--ds-space-100, 8px)",
    marginRight: "var(--ds-space-075, 6px)"
});

});


parcelRegister("1LDNt", function(module, exports) {

$parcel$export(module.exports, "PromptEditorWrapper", () => $14990d18245c5409$export$b0a649d08575ac09);
/* @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $hompL = parcelRequire("hompL");
const $14990d18245c5409$var$promptEditorWrapperStyles = (0, $byn9U.css)({
    display: 'grid',
    position: 'relative',
    flex: 1,
    'div > .ProseMirror': {
        '> p:last-child': {
            marginBottom: 0,
            paddingBottom: 0
        },
        /**
     * Minimum height is set to 125px for confluence inline comment editor (ProseMirror element)
     * When Editor AI is invoked in inline comments, same css rule applies here as well.
     * So overriding it here.
     */ minHeight: 'auto'
    },
    // Smart link's inline card view has 0.5em padding (7px or 8px)
    // Because of that scrollbar appearts in prompt input because of limited height available.
    // More details here https://product-fabric.atlassian.net/browse/EDF-455
    // So removed this top and bottom padding here.
    '.ProseMirror .inlineCardView-content-wrap .card': {
        paddingTop: 0,
        paddingBottom: 0
    }
});
const $14990d18245c5409$export$b0a649d08575ac09 = ({ PromptEditor: PromptEditor, defaultValue: defaultValue, autoFocus: autoFocus, focusInputRef: focusInputRef, blurInputRef: blurInputRef, clearInputRef: clearInputRef, placeholder: placeholder, enableLinks: enableLinks, onInputChange: onInputChange, onADFChange: onADFChange, onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, onCompositionStart: onCompositionStart, onCompositionEnd: onCompositionEnd })=>{
    const setFocusHandlers = (0, $eUqFw.useCallback)((blur, focus)=>{
        if (blurInputRef) blurInputRef.current = blur;
        if (focusInputRef) focusInputRef.current = focus;
    }, [
        blurInputRef,
        focusInputRef
    ]);
    const setClearHandler = (0, $eUqFw.useCallback)((clear)=>{
        if (clearInputRef) clearInputRef.current = clear;
    }, [
        clearInputRef
    ]);
    const componentId = (0, $eUqFw.useMemo)(()=>(0, $hompL.v4)(), []);
    return(// eslint-disable-next-line @atlaskit/design-system/prefer-primitives
    (0, $byn9U.jsx)("div", {
        css: $14990d18245c5409$var$promptEditorWrapperStyles,
        "data-testid": "ai-experience-prompt-input",
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        onBlur: onBlur,
        onCompositionStart: onCompositionStart,
        onCompositionEnd: onCompositionEnd
    }, (0, $byn9U.jsx)(PromptEditor, {
        key: `${placeholder}-${componentId}`,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        placeholder: placeholder,
        onInputChange: onInputChange,
        onADFChange: onADFChange,
        setFocusHandlers: setFocusHandlers,
        setClearHandler: setClearHandler,
        enableLinks: enableLinks
    })));
};

});

parcelRegister("2yFAL", function(module, exports) {

$parcel$export(module.exports, "PromptMultilineInput", () => $1dcf05062583ce4a$export$50c58ceb14a55b4);

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $7a7hd = parcelRequire("7a7hd");

var $6tI0m = parcelRequire("6tI0m");
const $1dcf05062583ce4a$export$50c58ceb14a55b4 = ({ focusInputRef: focusInputRef, blurInputRef: blurInputRef, onBlur: onBlur, onFocus: onFocus, onInputChange: onInputChange, hasMultipleRows: hasMultipleRows, setHasMultipleRows: setHasMultipleRows, value: value, buttonWidth: buttonWidth, onCompositionStart: onCompositionStart, onCompositionEnd: onCompositionEnd, ...rest })=>{
    const setFocusAndBlurInputRef = (0, $6tI0m.useSetInputRef)({
        blurInputRef: blurInputRef,
        focusInputRef: focusInputRef
    });
    const wrapperRef = (0, $eUqFw.useRef)(null);
    const hiddenDivRef = (0, $eUqFw.useRef)(null);
    const hiddenDiv = hiddenDivRef === null || hiddenDivRef === void 0 ? void 0 : hiddenDivRef.current;
    const singleLineHeight = (0, $eUqFw.useMemo)(()=>window && hiddenDiv ? parseFloat(window.getComputedStyle(hiddenDiv).lineHeight) : 0, [
        hiddenDiv
    ]);
    const hiddenDivWidthStyles = (0, $eUqFw.useMemo)(()=>({
            width: hasMultipleRows ? `calc(100% - ${buttonWidth}px)` : `100%`
        }), [
        hasMultipleRows,
        buttonWidth
    ]);
    const onInput = (0, $eUqFw.useCallback)((e)=>{
        onInputChange === null || onInputChange === void 0 || onInputChange(e.target.value);
    }, [
        onInputChange
    ]);
    /**
   * Use resize observer to listen to changes in height of hidden div
   * And update hasMultipleRows state if content spans multiple rows
   * Note: we are listening to changes in a hidden div (with fixed width)
   * because when the horizontal width of textarea increases,
   * it causes flickering as the content only fits in one line if buttons are stacked
   */ (0, $eUqFw.useEffect)(()=>{
        const resizeObserver = new ResizeObserver((entries)=>{
            entries.forEach(()=>{
                if (hiddenDiv) setHasMultipleRows === null || setHasMultipleRows === void 0 || setHasMultipleRows(hiddenDiv.getBoundingClientRect().height > singleLineHeight);
            });
        });
        if (hiddenDiv) resizeObserver.observe(hiddenDiv);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        hiddenDiv,
        singleLineHeight,
        setHasMultipleRows
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (hiddenDiv) setHasMultipleRows === null || setHasMultipleRows === void 0 || setHasMultipleRows(hiddenDiv.getBoundingClientRect().height > singleLineHeight);
    }, [
        hiddenDiv,
        singleLineHeight,
        setHasMultipleRows
    ]);
    return (0, $byn9U.jsx)("div", {
        "data-replicated-value": value,
        css: [
            (0, $7a7hd.multilineInputWrapperStyles)
        ],
        ref: wrapperRef
    }, (0, $byn9U.jsx)("textarea", (0, $kU09D.default)({
        ref: setFocusAndBlurInputRef,
        "aria-label": rest.placeholder,
        "data-testid": "ai-experience-prompt-input",
        name: "prompt-input",
        autoComplete: "off",
        css: (0, $7a7hd.inputStyles),
        onChange: onInput,
        onBlur: onBlur,
        onFocus: onFocus,
        rows: 1,
        value: value,
        maxLength: 4000,
        onCompositionStart: onCompositionStart,
        onCompositionEnd: onCompositionEnd
    }, rest)), (0, $byn9U.jsx)("div", {
        "data-replicated-value": value,
        css: [
            (0, $7a7hd.hiddenDivStyles),
            hiddenDivWidthStyles
        ],
        ref: hiddenDivRef
    }));
};

});
parcelRegister("7a7hd", function(module, exports) {

$parcel$export(module.exports, "inputStyles", () => $536f1c8db321b39b$export$3eeb47dc8e6249d9);
$parcel$export(module.exports, "multilineInputWrapperStyles", () => $536f1c8db321b39b$export$6514c7ca69ae2c80);
$parcel$export(module.exports, "hiddenDivStyles", () => $536f1c8db321b39b$export$c9dfe18c85e0471);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation */ 
var $byn9U = parcelRequire("byn9U");

var $lcnyw = parcelRequire("lcnyw");

var $PdmhA = parcelRequire("PdmhA");
// ED-51: This is to increase the specificity of the input styles
// to override the default input styles applied by Trello
const $536f1c8db321b39b$var$INCREASE_SPECIFICITY = '&&';
const $536f1c8db321b39b$export$3eeb47dc8e6249d9 = (0, $byn9U.css)`
	${$536f1c8db321b39b$var$INCREASE_SPECIFICITY} {
		border: none;
		color: ${`var(--ds-text-accent-gray-bolder, ${(0, $PdmhA.N900)})`};
		background: none;
		font-size: 14px;
		font-family: ${(0, $lcnyw.fontFamily)()};
		&:focus {
			outline: none;
		}
		&:placeholder-shown {
			text-overflow: ellipsis;
		}
		&::placeholder {
			color: ${`var(--ds-text-subtlest, ${(0, $PdmhA.N200)})`};
		}
		width: 100%;
		padding: ${"var(--ds-space-025, 2px)"} 0px;
		resize: none;
		overflow: hidden;
		line-height: inherit;
	}
`;
const $536f1c8db321b39b$export$6514c7ca69ae2c80 = (0, $byn9U.css)`
	display: grid;
	position: relative;
	flex: 1;
	::after {
		content: attr(data-replicated-value) ' ';
		white-space: pre-wrap;
		visibility: hidden;
		${$536f1c8db321b39b$export$3eeb47dc8e6249d9}
	}
	> textarea,
	::after {
		${$536f1c8db321b39b$export$3eeb47dc8e6249d9}

		/* Place on top of each other */
    grid-area: 1 / 1 / 2 / 2;
	}
`;
const $536f1c8db321b39b$export$c9dfe18c85e0471 = (0, $byn9U.css)`
	position: absolute;
	visibility: hidden;
	bottom: 0;
	::after {
		content: attr(data-replicated-value) ' ';
		white-space: pre-wrap;
		visibility: hidden;
		${$536f1c8db321b39b$export$3eeb47dc8e6249d9}
	}
`;

});

parcelRegister("6tI0m", function(module, exports) {

$parcel$export(module.exports, "useSetInputRef", () => $4b7795f389c3b6c4$export$30bc19c62a7f99b9);

var $eUqFw = parcelRequire("eUqFw");
const $4b7795f389c3b6c4$export$30bc19c62a7f99b9 = ({ focusInputRef: focusInputRef, blurInputRef: blurInputRef })=>{
    return (0, $eUqFw.useCallback)((el)=>{
        if (el) {
            if (focusInputRef) focusInputRef.current = ()=>el.focus();
            if (blurInputRef) blurInputRef.current = ()=>el.blur();
            // Set selection to end of the input
            el.selectionStart = el.selectionEnd = el.value.length;
        }
    }, [
        focusInputRef,
        blurInputRef
    ]);
};

});



parcelRegister("6goUb", function(module, exports) {

$parcel$export(module.exports, "CopyIconButton", () => $48f78e5ef47020d9$export$dcd7ef7785e10577);
/* @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8cU5f = parcelRequire("8cU5f");

var $hTyiR = parcelRequire("hTyiR");

var $dmCPj = parcelRequire("dmCPj");

var $j5E9H = parcelRequire("j5E9H");
const $48f78e5ef47020d9$export$dcd7ef7785e10577 = ({ onClick: onClick, tabIndex: tabIndex })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [tooltip, setTooltip] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState(formatMessage((0, $j5E9H.default).copy));
    const updateTooltip = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef();
    const handleOnClick = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((event)=>{
        onClick(event);
        setTooltip(formatMessage((0, $j5E9H.default).copiedToClipboard));
    }, [
        onClick,
        formatMessage
    ]);
    const resetTooltip = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback(()=>setTooltip(formatMessage((0, $j5E9H.default).copy)), [
        formatMessage
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useLayoutEffect(()=>{
        var _updateTooltip$curren;
        (_updateTooltip$curren = updateTooltip.current) === null || _updateTooltip$curren === void 0 || _updateTooltip$curren.call(updateTooltip);
    }, [
        tooltip
    ]);
    return (0, $byn9U.jsx)((0, $8cU5f.default), {
        content: ({ update: update })=>{
            updateTooltip.current = update;
            return tooltip;
        },
        position: "top",
        onHide: resetTooltip
    }, (0, $byn9U.jsx)((0, $hTyiR.default), {
        testId: "copy-response-button",
        type: "button",
        onClick: handleOnClick,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dmCPj))),
        label: tooltip,
        appearance: "default",
        tabIndex: tabIndex
    }));
};

});
parcelRegister("dmCPj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9bab72963b78cefe$var$_react = $9bab72963b78cefe$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $9bab72963b78cefe$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9bab72963b78cefe$var$CopyIcon = (props)=>/*#__PURE__*/ $9bab72963b78cefe$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor"><path d="M10 19h8V8h-8v11zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2.001 2.001 0 018 19.008V7.992z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13H5zm2 0h8V5H7v11z"/></g></svg>`
    }, props));
$9bab72963b78cefe$var$CopyIcon.displayName = 'CopyIcon';
var $9bab72963b78cefe$var$_default = $9bab72963b78cefe$var$CopyIcon;
module.exports.default = $9bab72963b78cefe$var$_default;

});

parcelRegister("j5E9H", function(module, exports) {

$parcel$export(module.exports, "default", () => $de5da1fdf7303234$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $de5da1fdf7303234$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    copy: {
        id: 'fabric.editor.ai.config.item.action.copyResponse',
        defaultMessage: 'Copy',
        description: 'Copy the response to the clipboard'
    },
    copied: {
        id: 'fabric.editor.ai.config.item.action.responseCopied',
        defaultMessage: 'Copied!',
        description: 'Copied the response to the clipboard'
    },
    copiedToClipboard: {
        id: 'fabric.editor.ai.config.item.action.responseCopiedToClipboard',
        defaultMessage: 'Copied to clipboard',
        description: 'Copied the response to the clipboard'
    }
});

});


parcelRegister("9KI99", function(module, exports) {

$parcel$export(module.exports, "RetryIconButton", () => $719aa78769db4b06$export$6f66175e87cc7542);
/* @jsx jsx */ parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8cU5f = parcelRequire("8cU5f");

var $hTyiR = parcelRequire("hTyiR");

var $8SZxd = parcelRequire("8SZxd");

var $fV3ma = parcelRequire("fV3ma");
const $719aa78769db4b06$export$6f66175e87cc7542 = ({ onClick: onClick, tabIndex: tabIndex })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const tooltip = formatMessage((0, $fV3ma.default).retryPrompt);
    return (0, $byn9U.jsx)((0, $8cU5f.default), {
        content: tooltip,
        position: "top"
    }, (0, $byn9U.jsx)((0, $hTyiR.default), {
        testId: "retry-prompt-button",
        type: "button",
        onClick: onClick,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8SZxd))),
        label: tooltip,
        appearance: "default",
        tabIndex: tabIndex
    }));
};

});
parcelRegister("8SZxd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6783196829040bcb$var$_react = $6783196829040bcb$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $6783196829040bcb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $6783196829040bcb$var$RetryIcon = (props)=>/*#__PURE__*/ $6783196829040bcb$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M6 10h2.954a1 1 0 010 2H5.099A1.1 1.1 0 014 10.9V7a1 1 0 112 0v3z" fill-rule="nonzero"/><path d="M7.39 10.09H5.3a8 8 0 11.818 6H7.84v-1.02a6 6 0 10-.45-4.98z" fill-rule="nonzero"/><circle cx="7" cy="15.61" r="1"/></g></svg>`
    }, props));
$6783196829040bcb$var$RetryIcon.displayName = 'RetryIcon';
var $6783196829040bcb$var$_default = $6783196829040bcb$var$RetryIcon;
module.exports.default = $6783196829040bcb$var$_default;

});

parcelRegister("fV3ma", function(module, exports) {

$parcel$export(module.exports, "default", () => $02fda864daf4594f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $02fda864daf4594f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    retryPrompt: {
        id: 'fabric.editor.ai.config.item.action.retryPrompt',
        defaultMessage: 'Retry',
        description: 'Retry the latest prompt'
    }
});

});


parcelRegister("2vnaW", function(module, exports) {

$parcel$export(module.exports, "FeedbackForm", () => $1d307436151be6bc$export$ce859c56062f484c);
/* @jsx jsx */ /** @jsxfrag */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8cU5f = parcelRequire("8cU5f");

var $hTyiR = parcelRequire("hTyiR");

var $bJeU6 = parcelRequire("bJeU6");

var $fvQWm = parcelRequire("fvQWm");

var $ffiyv = parcelRequire("ffiyv");

var $PdmhA = parcelRequire("PdmhA");

var $inOd6 = parcelRequire("inOd6");

var $fZlRj = parcelRequire("fZlRj");
const $1d307436151be6bc$export$ce859c56062f484c = ({ onGoodResponseButtonClick: onGoodResponseButtonClick, onBadResponseButtonClick: onBadResponseButtonClick, tabIndex: tabIndex })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const feedbackWasSentLabel = formatMessage((0, $inOd6.default).feedbackSent);
    const goodResponseLabel = formatMessage((0, $inOd6.default).goodResponse);
    const badResponseLabel = formatMessage((0, $inOd6.default).badResponse);
    const [isFeedbackDisabled, setIsFeedbackDisabled] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState(false);
    const iconColor = `var(--ds-icon, ${(0, $PdmhA.N100)})`;
    const handleOnClick = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((onClick)=>()=>{
            onClick();
            setIsFeedbackDisabled(true);
        }, []);
    const likeButton = ()=>(0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fvQWm))), {
            label: goodResponseLabel,
            primaryColor: iconColor
        });
    return (0, $byn9U.jsx)("div", {
        css: (0, $fZlRj.buttonGroupStyles)
    }, isFeedbackDisabled && (0, $byn9U.jsx)("p", {
        "aria-atomic": "false",
        "aria-live": "polite"
    }, (0, $byn9U.jsx)((0, $ffiyv.default), {
        appearance: "success",
        testId: "feedback-success"
    }, feedbackWasSentLabel)), (0, $byn9U.jsx)((0, $bJeU6.default), {
        space: "space.100"
    }, (0, $byn9U.jsx)((0, $8cU5f.default), {
        content: goodResponseLabel,
        position: "top"
    }, (0, $byn9U.jsx)((0, $hTyiR.default), {
        testId: "good-response-feedback-button",
        type: "button",
        isDisabled: isFeedbackDisabled,
        onClick: handleOnClick(onGoodResponseButtonClick),
        icon: likeButton,
        label: goodResponseLabel,
        appearance: "subtle",
        tabIndex: tabIndex,
        spacing: "compact"
    })), (0, $byn9U.jsx)((0, $8cU5f.default), {
        content: badResponseLabel,
        position: "top"
    }, (0, $byn9U.jsx)("div", {
        css: (0, $fZlRj.dislikeButtonStyles)
    }, (0, $byn9U.jsx)((0, $hTyiR.default), {
        testId: "bad-response-feedback-button",
        type: "button",
        isDisabled: isFeedbackDisabled,
        onClick: handleOnClick(onBadResponseButtonClick),
        icon: likeButton,
        label: badResponseLabel,
        appearance: "subtle",
        tabIndex: tabIndex,
        spacing: "compact"
    })))));
};

});
parcelRegister("inOd6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d62152b34a9a07a9$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d62152b34a9a07a9$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    goodResponse: {
        id: 'fabric.editor.ai.components.feedbackForm.goodResponse',
        defaultMessage: 'Good response',
        description: 'The AI response was good'
    },
    badResponse: {
        id: 'fabric.editor.ai.components.feedbackForm.badResponse',
        defaultMessage: 'Bad response',
        description: 'The AI response was bad'
    },
    feedbackSent: {
        id: 'fabric.editor.ai.components.feedbackForm.feedbackSent',
        defaultMessage: 'Feedback sent',
        description: 'A message that appears to users when they click the thumbs up or thumbs down button'
    }
});

});

parcelRegister("fZlRj", function(module, exports) {

$parcel$export(module.exports, "buttonGroupStyles", () => $ba3d82416a89640f$export$736f4af154dbe4e7);
$parcel$export(module.exports, "dislikeButtonStyles", () => $ba3d82416a89640f$export$f76cf5db9fc0ba1d);

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
const $ba3d82416a89640f$export$736f4af154dbe4e7 = (0, $byn9U.css)({
    display: 'flex',
    alignItems: 'center',
    p: {
        marginRight: "var(--ds-space-050, 4px)"
    }
});
const $ba3d82416a89640f$export$19a3970fbcd4ca20 = (isSelected)=>(0, $byn9U.css)({
        svg: {
            color: isSelected ? `var(--ds-icon-selected, ${0, $PdmhA.N20})` : `var(--ds-icon-accent-gray, ${0, $PdmhA.N100})`
        },
        '&[disabled]': {
            backgroundColor: isSelected ? `var(--ds-background-selected, ${0, $PdmhA.N700})` : undefined
        }
    });
const $ba3d82416a89640f$export$f76cf5db9fc0ba1d = (0, $byn9U.css)({
    transform: 'rotate(180deg)'
});

});


parcelRegister("3Ycnu", function(module, exports) {

$parcel$export(module.exports, "isExperimentEnabled", () => $2e4093ac9bb7267c$export$336b018592dc9972);
$parcel$export(module.exports, "getExperimentCohort", () => $2e4093ac9bb7267c$export$d297da143e393306);

var $8tM2T = parcelRequire("8tM2T");
const $2e4093ac9bb7267c$export$5f7b1bbd236815cb = {
    // Replaces "platform.editor.ai-floating-ai-button_yax3u" and "platform.editor.ai-floating-ai-button-tiptap-mode_40m30"
    'editor_ai_-_persistent_button_experiment': [
        'control',
        'floating-button',
        'tip-tap-menu'
    ],
    // Replaces "platform.editor.ai-persistent-placeholder"
    'editor_ai_-_persistent_placeholder_experiment': [
        'control',
        'persistent-placeholder'
    ],
    'editor_ai_-_gpt4_experiment': [
        'control',
        'einstein'
    ],
    'editor_ai_-_visual_diff_preview_experiment': [
        'control',
        'visual-diff-preview'
    ]
};
const $2e4093ac9bb7267c$export$336b018592dc9972 = (experimentKey)=>{
    const getExperimentValue = (0, $8tM2T.default).getExperimentValue;
    return getExperimentValue(experimentKey, 'isEnabled', false);
};
const $2e4093ac9bb7267c$export$d297da143e393306 = (experimentKey)=>{
    const getExperimentValue = (0, $8tM2T.default).getExperimentValue;
    return getExperimentValue(experimentKey, 'cohort', 'not-enrolled');
};
const $2e4093ac9bb7267c$export$5df36d7293aa5a68 = (key, cohort)=>(experimentKey, parameter, defaultValue = null)=>{
        if (experimentKey === key) {
            if (parameter === 'cohort') return cohort;
            else if (parameter === 'isEnabled') return true;
        }
        return defaultValue;
    };

});


parcelRegister("8PT7T", function(module, exports) {

$parcel$export(module.exports, "getHasAcceptableUseWarning", () => $66edd916474e0526$export$429132ba9db86af9);
/**
 * This should not be treated as a fact we are attempting
 * to match as many responses with acceptable use warnings
 * however, we may get false positives or false negatives
 *
 * TODO POST EAP
 * Modify this when the backend is able to return
 * acceptable-use-warning flags to the frontend
 *
 * @markdown string to check for acceptable use warning
 * @returns boolean | undefined if the users locale is not english
 */ const $66edd916474e0526$export$429132ba9db86af9 = ({ markdown: markdown = '', locale: locale })=>{
    const isEnglishLocale = locale.startsWith('en');
    if (!isEnglishLocale) return;
    const markdownLowercase = markdown.toLowerCase();
    return $66edd916474e0526$var$getHasSearchString(markdownLowercase);
};
const $66edd916474e0526$var$getHasSearchString = (stringToSearch)=>{
    const acceptableUsePolicySearchStrings = [
        "i'm sorry, but i can't fulfil",
        "i'm sorry, but i cannot fulfil",
        "i am sorry, but i can't fulfil",
        'i am sorry, but i cannot fulfil',
        "atlassian's acceptable use",
        'i apologise, but i cannot fulfil',
        "i apologise, but i can't fulfil",
        'i apologize, but i cannot fulfil',
        "i apologize, but i can't fulfil"
    ];
    const hasSearchString = acceptableUsePolicySearchStrings.some((searchString)=>{
        return stringToSearch.includes(searchString);
    });
    return hasSearchString;
};

});

parcelRegister("138p3", function(module, exports) {

$parcel$export(module.exports, "ProseMirrorContentStatistics", () => $0c3c96eb8ce70f5d$export$acf14785d7d5b1be);

var $7dkLM = parcelRequire("7dkLM");
class $0c3c96eb8ce70f5d$export$acf14785d7d5b1be {
    constructor(content){
        this.content = content;
    }
    /**
   * Calculate statistics for the ProseMirror content such as node counts, mark counts and total character count.
   */ collectStatistics() {
        const { nodeCounts: nodeCounts, markCounts: markCounts } = this.countNodesAndMarks();
        const { totalCharacterCount: totalCharacterCount } = this.calculateCharacterCounts();
        return {
            nodeCounts: nodeCounts,
            markCounts: markCounts,
            totalCharacterCount: totalCharacterCount,
            contextSelectionScope: undefined
        };
    }
    countNodesAndMarks() {
        let nodeCounts = new Map();
        let markCounts = new Map();
        this.content.descendants((node)=>{
            nodeCounts.set(node.type.name, (nodeCounts.get(node.type.name) || 0) + 1);
            node.marks.forEach((mark)=>{
                markCounts.set(mark.type.name, (markCounts.get(mark.type.name) || 0) + 1);
            });
        });
        return {
            nodeCounts: Object.fromEntries(nodeCounts),
            markCounts: Object.fromEntries(markCounts)
        };
    }
    calculateCharacterCounts() {
        let allTextContent = '';
        if (this.content instanceof (0, $7dkLM.Node)) allTextContent = this.content.textContent;
        else this.content.forEach((child)=>{
            allTextContent += child.textContent;
        });
        return {
            totalCharacterCount: allTextContent.length
        };
    }
}

});

parcelRegister("5HLgB", function(module, exports) {

$parcel$export(module.exports, "stripMatchingOuterQuotes", () => $4275a21b7665515a$export$8850f5fc4cad5830);
const $4275a21b7665515a$export$8850f5fc4cad5830 = (markdown)=>{
    markdown = markdown.trim(); // Trim whitespace to ensure quotes at start/end are detected
    const firstChar = markdown.charAt(0);
    const lastChar = markdown.charAt(markdown.length - 1);
    // Check if the first and last characters are matching quotes (either ' or ")
    if (firstChar === '"' && lastChar === '"' || firstChar === "'" && lastChar === "'") // Remove the first and last character
    return markdown.substring(1, markdown.length - 1);
    // Return the original string if no matching outer quotes are found
    return markdown;
};

});

parcelRegister("iEDa2", function(module, exports) {

$parcel$export(module.exports, "createDiffPreview", () => $d94a56f8a63f9fd6$export$6fcd0247dc325b03);
/* @jsx jsx */ parcelRequire("eUqFw");

var $dFBS3 = parcelRequire("dFBS3");

var $3M3qX = parcelRequire("3M3qX");

var $d6JJW = parcelRequire("d6JJW");

var $7Y6sw = parcelRequire("7Y6sw");

var $byn9U = parcelRequire("byn9U");

var $gfOPY = parcelRequire("gfOPY");

var $1YM8X = parcelRequire("1YM8X");
const $d94a56f8a63f9fd6$var$RED_SUBSTITUTE_HEX = '#AAAAA0';
const $d94a56f8a63f9fd6$var$BLUE_SUBSTITUTE_HEX = '#AAAAA1';
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
const $d94a56f8a63f9fd6$var$styles = (0, $byn9U.css)`
	span[data-text-custom-color='${$d94a56f8a63f9fd6$var$RED_SUBSTITUTE_HEX}'] {
		background-color: ${"var(--ds-background-accent-red-subtlest, #FFEBE6)"};
		text-decoration: line-through;

		--custom-palette-color: inherit !important;
		user-select: none;
	}
	span[data-text-custom-color='${$d94a56f8a63f9fd6$var$BLUE_SUBSTITUTE_HEX}'] {
		background-color: ${"var(--ds-background-accent-blue-subtlest, #DEEBFF)"};
		text-decoration: underline;
		text-decoration-style: dashed;

		--custom-palette-color: inherit !important;
	}
`;
/**
 * Helper function to trim empty paragraphs as there isn't much value in
 * diffing empty paragraphs.
 */ function $d94a56f8a63f9fd6$var$trimEmptyParagraphs(paragraphs) {
    if (!paragraphs.length) return paragraphs;
    const trimmedParagraphs = [
        ...paragraphs
    ];
    while(trimmedParagraphs.length > 0 && trimmedParagraphs[0].text === '')trimmedParagraphs.shift();
    while(trimmedParagraphs.length > 0 && trimmedParagraphs[trimmedParagraphs.length - 1].text === '')trimmedParagraphs.pop();
    return trimmedParagraphs;
}
const $d94a56f8a63f9fd6$var$jsonTransformer = new (0, $3M3qX.JSONTransformer)();
function $d94a56f8a63f9fd6$export$6fcd0247dc325b03({ editorView: editorView, pmFragment: pmFragment, positions: positions, providerFactory: providerFactory }) {
    var _schema$marks, _content$firstChild, _content$lastChild;
    const { schema: schema } = editorView.state;
    // If schema doesn't have textColor, underline, or strike, we won't be able to render the highlights
    if (!((_schema$marks = schema.marks) !== null && _schema$marks !== void 0 && _schema$marks.textColor)) return;
    const slice = (0, $gfOPY.getSlice)(editorView, positions);
    if (slice.openStart !== slice.openEnd) return;
    const paragraphType = schema.nodes.paragraph;
    let content = slice.content;
    /**
   * Edge case for when the slice is a single line - the content will begin and end
   * with inline nodes - to make it convertable to a document we wrap it in a paragraph
   */ if ((_content$firstChild = content.firstChild) !== null && _content$firstChild !== void 0 && _content$firstChild.isInline && (_content$lastChild = content.lastChild) !== null && _content$lastChild !== void 0 && _content$lastChild.isInline) {
        const wrappedContent = schema.nodes.doc.createAndFill({}, schema.nodes.paragraph.create({}, content));
        if (wrappedContent) content = wrappedContent;
    }
    if (!content) return;
    const inputParagraphs = [];
    content.descendants((node, pos)=>{
        if (node.type === paragraphType) {
            const inlineNodePositions = [];
            node.descendants((node, pos)=>{
                if (node.isInline && !node.isText) inlineNodePositions.push(pos);
            });
            inputParagraphs.push({
                id: (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))(),
                text: node.textContent,
                from: pos,
                to: pos + node.nodeSize,
                inlineNodePositions: inlineNodePositions
            });
        }
    });
    const outputParagraphs = [];
    pmFragment.descendants((node, pos)=>{
        if (node.type === paragraphType) {
            const inlineNodePositions = [];
            node.descendants((node, pos)=>{
                if (node.isInline && !node.isText) inlineNodePositions.push(pos);
            });
            outputParagraphs.push({
                id: (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))(),
                text: node.textContent,
                from: pos,
                to: pos + node.nodeSize,
                inlineNodePositions: inlineNodePositions
            });
        }
    });
    const trimmedInputParagraphs = $d94a56f8a63f9fd6$var$trimEmptyParagraphs(inputParagraphs);
    const trimmedOutputParagraphs = $d94a56f8a63f9fd6$var$trimEmptyParagraphs(outputParagraphs);
    if (trimmedInputParagraphs.length !== trimmedOutputParagraphs.length) return;
    const diffObjects = (0, $1YM8X.getDiffObjectsBetweenParagraphs)(trimmedOutputParagraphs, trimmedInputParagraphs);
    const docFrom = schema.nodes.doc.createAndFill({}, pmFragment);
    if (!docFrom) return;
    const transform = new (0, $d6JJW.Transform)(docFrom);
    let offset = 0;
    diffObjects.forEach(({ from: from, to: to, text: text, type: type })=>{
        switch(type){
            case 'ADDITION':
            case 'REPLACEMENT':
                transform.addMark(offset + from, offset + to, schema.marks.textColor.create({
                    color: $d94a56f8a63f9fd6$var$BLUE_SUBSTITUTE_HEX
                }));
                return;
            case 'DELETION':
                transform.insert(offset + to, schema.text(text));
                transform.addMark(offset + to, offset + to + text.length, schema.marks.textColor.create({
                    color: $d94a56f8a63f9fd6$var$RED_SUBSTITUTE_HEX
                }));
                offset += text.length;
                return;
            default:
                return;
        }
    });
    let document;
    try {
        document = $d94a56f8a63f9fd6$var$jsonTransformer.encode(transform.doc);
    } catch (e) {}
    if (!document) return;
    return (0, $byn9U.jsx)("div", {
        "data-testid": "diff-renderer",
        css: $d94a56f8a63f9fd6$var$styles
    }, (0, $byn9U.jsx)((0, $7Y6sw.default), {
        document: document,
        adfStage: "stage0",
        media: {
            // We don't currently support images with captions
            allowLinking: false
        },
        schema: schema,
        useSpecBasedValidator: true,
        dataProviders: providerFactory
    }));
}

});
parcelRegister("gfOPY", function(module, exports) {

$parcel$export(module.exports, "getSlice", () => $bd557b41f082e144$export$9899dbe95982df9a);
/**
 * If there is an empty selection (no content is selected) then we
 * return a slice that contains the entire document. Else if there is a
 * range selection then we return a slice that contains the range selection.
 */ function $bd557b41f082e144$export$9899dbe95982df9a(editorView, positions) {
    // If the positions are the same, then we know we don't have a normal range
    // selection, so we want to send the full document
    if (positions[0] === positions[1]) return editorView.state.doc.slice(0, editorView.state.doc.content.size);
    else return editorView.state.doc.slice(positions[0], positions[1]);
}

});


parcelRegister("dwVev", function(module, exports) {

$parcel$export(module.exports, "isTranslationPrompt", () => $9d9aa8c7c3f53358$export$f54f1bab33a30a3f);

var $XHGTv = parcelRequire("XHGTv");

var $3gizi = parcelRequire("3gizi");
const $9d9aa8c7c3f53358$export$a288aff1b8104a05 = ()=>{
    if ((0, $XHGTv.getBooleanFF)('platform.editor.ai-multi-lang-translations-popular-sort-order')) return 0, $3gizi.supportedTranslationLanguagesPopularOrder;
    return 0, $3gizi.supportedTranslationLanguagesEnglishAlphabeticalOrder;
};
const $9d9aa8c7c3f53358$export$f54f1bab33a30a3f = (latestPrompt)=>{
    var _latestPrompt$presetT;
    return Boolean(latestPrompt === null || latestPrompt === void 0 ? void 0 : (_latestPrompt$presetT = latestPrompt.presetTitle) === null || _latestPrompt$presetT === void 0 ? void 0 : _latestPrompt$presetT.call(latestPrompt, {
        formatMessage: (descriptor)=>{
            var _descriptor$defaultMe;
            return typeof descriptor.defaultMessage === 'string' && ((_descriptor$defaultMe = descriptor.defaultMessage) === null || _descriptor$defaultMe === void 0 ? void 0 : _descriptor$defaultMe.includes('Translate to'));
        }
    }));
};

});
parcelRegister("3gizi", function(module, exports) {

$parcel$export(module.exports, "supportedTranslationLanguagesEnglishAlphabeticalOrder", () => $260145008ee73ad8$export$e9659c4331e661);
$parcel$export(module.exports, "supportedTranslationLanguagesPopularOrder", () => $260145008ee73ad8$export$20cfed69f1ef38ea);
// For Localized Language Support, which we're aiming parity with, see: https://hello.atlassian.net/wiki/spaces/i18n/pages/647802766/Localized+Language+Support+Coverage+and+Strategy#What-languages-do-we-support/localize-at-Atlassian?
let $260145008ee73ad8$export$c5e4fced70735903 = /*#__PURE__*/ function(SupportedTranslationLanguages) {
    SupportedTranslationLanguages["ChineseSimplified"] = "chineseSimplified";
    SupportedTranslationLanguages["ChineseTraditional"] = "chineseTraditional";
    SupportedTranslationLanguages["Czech"] = "czech";
    SupportedTranslationLanguages["Danish"] = "danish";
    SupportedTranslationLanguages["Dutch"] = "dutch";
    SupportedTranslationLanguages["English"] = "english";
    SupportedTranslationLanguages["Finnish"] = "finnish";
    SupportedTranslationLanguages["French"] = "french";
    SupportedTranslationLanguages["German"] = "german";
    SupportedTranslationLanguages["Hungarian"] = "hungarian";
    SupportedTranslationLanguages["Italian"] = "italian";
    SupportedTranslationLanguages["Japanese"] = "japanese";
    SupportedTranslationLanguages["Korean"] = "korean";
    SupportedTranslationLanguages["Norwegian"] = "norwegian";
    SupportedTranslationLanguages["Polish"] = "polish";
    SupportedTranslationLanguages["PortugueseBrazilian"] = "portugueseBrazilian";
    SupportedTranslationLanguages["Russian"] = "russian";
    SupportedTranslationLanguages["Spanish"] = "spanish";
    SupportedTranslationLanguages["Swedish"] = "swedish";
    SupportedTranslationLanguages["Turkish"] = "turkish";
    SupportedTranslationLanguages["Thai"] = "thai";
    SupportedTranslationLanguages["Ukrainian"] = "ukrainian";
    SupportedTranslationLanguages["Vietnamese"] = "vietnamese";
    return SupportedTranslationLanguages;
}({});
const $260145008ee73ad8$export$e9659c4331e661 = Object.values($260145008ee73ad8$export$c5e4fced70735903);
const $260145008ee73ad8$export$20cfed69f1ef38ea = [
    $260145008ee73ad8$export$c5e4fced70735903.English,
    $260145008ee73ad8$export$c5e4fced70735903.German,
    $260145008ee73ad8$export$c5e4fced70735903.Japanese,
    $260145008ee73ad8$export$c5e4fced70735903.French,
    $260145008ee73ad8$export$c5e4fced70735903.Korean,
    $260145008ee73ad8$export$c5e4fced70735903.Spanish,
    $260145008ee73ad8$export$c5e4fced70735903.PortugueseBrazilian,
    $260145008ee73ad8$export$c5e4fced70735903.Russian,
    $260145008ee73ad8$export$c5e4fced70735903.Dutch,
    $260145008ee73ad8$export$c5e4fced70735903.ChineseSimplified,
    $260145008ee73ad8$export$c5e4fced70735903.Polish,
    $260145008ee73ad8$export$c5e4fced70735903.Italian,
    $260145008ee73ad8$export$c5e4fced70735903.ChineseTraditional,
    $260145008ee73ad8$export$c5e4fced70735903.Norwegian,
    $260145008ee73ad8$export$c5e4fced70735903.Swedish,
    $260145008ee73ad8$export$c5e4fced70735903.Czech,
    $260145008ee73ad8$export$c5e4fced70735903.Finnish,
    $260145008ee73ad8$export$c5e4fced70735903.Danish,
    $260145008ee73ad8$export$c5e4fced70735903.Hungarian,
    $260145008ee73ad8$export$c5e4fced70735903.Turkish,
    $260145008ee73ad8$export$c5e4fced70735903.Thai,
    $260145008ee73ad8$export$c5e4fced70735903.Ukrainian,
    $260145008ee73ad8$export$c5e4fced70735903.Vietnamese
];

});



parcelRegister("1KeVc", function(module, exports) {

$parcel$export(module.exports, "DiscardScreenWithLogic", () => $1455a972b2d4f1c3$export$643e9e046f871343);

var $eUqFw = parcelRequire("eUqFw");

var $j8BVQ = parcelRequire("j8BVQ");

var $jRfpS = parcelRequire("jRfpS");

var $5JgJ2 = parcelRequire("5JgJ2");

var $iypWf = parcelRequire("iypWf");
const $1455a972b2d4f1c3$export$28146c614df26dc4 = ({ formatMessage: formatMessage, experienceState: experienceState })=>{
    const discardPrompt = formatMessage((0, $iypWf.messages).discardMessagePrompt);
    const discardResponse = formatMessage((0, $iypWf.messages).discardMessageResponse);
    if (typeof experienceState === 'object' && 'user input state' in experienceState) return discardPrompt;
    if (experienceState === 'review state' || typeof experienceState === 'object' && 'loading state' in experienceState) return discardResponse;
    return discardResponse;
};
function $1455a972b2d4f1c3$export$643e9e046f871343({ state: state, endExperience: endExperience, send: send, editCount: editCount, retryPromptCount: retryPromptCount, history: history }) {
    const lastHistoryEvent = history.entries[history.positionFromEnd];
    const inputOutputDiffRatio = history.entries.length === 0 ? '' : lastHistoryEvent.inputOutputDiffRatio;
    (0, $jRfpS.useAnalyticsFlowEventsQueue)({
        stepName: 'discard',
        attributes: {
            editCount: editCount,
            retryPromptCount: retryPromptCount,
            inputOutputDiffRatio: inputOutputDiffRatio
        }
    });
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j8BVQ.DiscardScreen), {
        text: $1455a972b2d4f1c3$export$28146c614df26dc4({
            formatMessage: formatMessage,
            experienceState: state
        }),
        onCancel: function() {
            send({
                type: 'disable discard'
            });
        },
        onDiscard: function() {
            endExperience();
        }
    });
}

});
parcelRegister("j8BVQ", function(module, exports) {

$parcel$export(module.exports, "DiscardScreen", () => $deec302f53c27605$export$453c0e2ebf820c66);
/* @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5YsMl = parcelRequire("5YsMl");

var $lkPEe = parcelRequire("lkPEe");

var $86ADt = parcelRequire("86ADt");

var $5a6Qy = parcelRequire("5a6Qy");

var $2GXlj = parcelRequire("2GXlj");

var $7NBW6 = parcelRequire("7NBW6");

var $dBH6i = parcelRequire("dBH6i");

var $bFJ7u = parcelRequire("bFJ7u");


var $jjK5n = parcelRequire("jjK5n");
const $deec302f53c27605$export$453c0e2ebf820c66 = ({ onCancel: onCancel, onDiscard: onDiscard, text: text })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { ref: ref, breakpoint: breakpoint } = (0, $bFJ7u.useContainerBreakpoints)();
    // Scroll the discard screen into view if it's not fully visible
    (0, $eUqFw.useEffect)(()=>{
        if (ref.current) ref.current.scrollIntoView({
            block: 'nearest'
        });
    }, [
        ref
    ]);
    return (0, $byn9U.jsx)((0, $2GXlj.FloatingContainer), {
        ref: ref,
        "data-testid": "discard-screen",
        className: `discard-screen ${(0, $64ce3526fe10ea0e$export$9df59400d72ad68f)}`,
        css: [
            (0, $5a6Qy.getContainerStyles)(breakpoint),
            (0, $7NBW6.scrollMarginStyles)
        ],
        paddingAdjustments: {
            top: 1,
            bottom: 1
        }
    }, (0, $byn9U.jsx)((0, $lkPEe.default), null, formatMessage((0, $86ADt.default).warningIconLabel)), (0, $byn9U.jsx)("div", {
        css: (0, $5a6Qy.getTextContainerStyles)(breakpoint)
    }, (0, $byn9U.jsx)("span", {
        css: (0, $5a6Qy.getIconStyles)(breakpoint)
    }, (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
        label: formatMessage((0, $86ADt.default).warningIconLabel),
        primaryColor: (0, $5a6Qy.iconColor)
    })), (0, $byn9U.jsx)("p", {
        css: (0, $5a6Qy.textStyles)
    }, text)), (0, $byn9U.jsx)("div", {
        css: (0, $5a6Qy.buttonContainerStyles)
    }, (0, $byn9U.jsx)((0, $dBH6i.default), {
        testId: "cancel-button",
        spacing: "compact",
        onClick: onCancel,
        type: "button",
        appearance: "subtle"
    }, formatMessage((0, $86ADt.default).cancelLabel)), (0, $byn9U.jsx)((0, $dBH6i.default), {
        autoFocus: true,
        css: (0, $jjK5n.buttonAutoFocusRingFix),
        testId: "discard-button",
        spacing: "compact",
        onClick: onDiscard,
        type: "button",
        appearance: "warning"
    }, formatMessage((0, $86ADt.default).discardLabel))));
};

});
parcelRegister("86ADt", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e6b4d5ba6a17ffa$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $5e6b4d5ba6a17ffa$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    cancelLabel: {
        id: 'fabric.editor.ai.screens.discard.cancelLabel',
        defaultMessage: 'Back',
        description: 'Text for the "Back" button on the "Discard Warning" screen, used to prevent discarding changes and return to the previous screen'
    },
    discardLabel: {
        id: 'fabric.editor.ai.screens.discard.discardLabel',
        defaultMessage: 'Discard',
        description: 'Text for the "Discard" button on the "Discard Warning" screen, used to confirm the user intention to discard unsaved changes, whether in relation to prompt input or a generated response. The term should convey the meaning of intentionally discarding or abandoning the modifications made or the generated content.'
    },
    warningIconLabel: {
        id: 'fabric.editor.ai.screens.discard.warningIconLabel',
        defaultMessage: 'Warning',
        description: 'Aria label for the warning icon on the "Discard Warning" screen'
    }
});

});

parcelRegister("5a6Qy", function(module, exports) {

$parcel$export(module.exports, "getTextContainerStyles", () => $3c2332889bded4a9$export$6d3ae856f3ad1a39);
$parcel$export(module.exports, "textStyles", () => $3c2332889bded4a9$export$6a54c24d15b0f6ba);
$parcel$export(module.exports, "iconColor", () => $3c2332889bded4a9$export$3797a580396e3639);
$parcel$export(module.exports, "getIconStyles", () => $3c2332889bded4a9$export$85b8da3d52ee4014);
$parcel$export(module.exports, "buttonContainerStyles", () => $3c2332889bded4a9$export$98120bf687c4a90f);
$parcel$export(module.exports, "getContainerStyles", () => $3c2332889bded4a9$export$8947b11ec08f5f9d);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $bFJ7u = parcelRequire("bFJ7u");

var $kIeme = parcelRequire("kIeme");
const $3c2332889bded4a9$var$textContainerLayoutStyles = (breakpoint)=>(0, $byn9U.css)({
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: breakpoint <= (0, $bFJ7u.Breakpoint).Small ? 'flex-start' : 'center',
        flex: 1,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
        gap: '10px'
    });
const $3c2332889bded4a9$export$6d3ae856f3ad1a39 = (breakpoint)=>[
        $3c2332889bded4a9$var$textContainerLayoutStyles(breakpoint)
    ];
const $3c2332889bded4a9$var$textSpacingStyles = (0, $byn9U.css)({
    margin: 0
});
const $3c2332889bded4a9$export$6a54c24d15b0f6ba = [
    $3c2332889bded4a9$var$textSpacingStyles,
    (0, $kIeme.commonTextStyles)
];
const $3c2332889bded4a9$export$3797a580396e3639 = `var(--ds-icon-warning, ${(0, $PdmhA.Y500)})`;
const $3c2332889bded4a9$var$ICON_TEXT_ALIGNMENT_OFFSET = '-2px';
const $3c2332889bded4a9$export$85b8da3d52ee4014 = (breakpoint)=>(0, $byn9U.css)({
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        lineHeight: 1,
        position: 'relative',
        flexShrink: 0,
        // 2px top offset at small breakpoints for better icon-text alignment
        top: breakpoint <= (0, $bFJ7u.Breakpoint).Small ? $3c2332889bded4a9$var$ICON_TEXT_ALIGNMENT_OFFSET : '0'
    });
const $3c2332889bded4a9$export$98120bf687c4a90f = (0, $byn9U.css)({
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: "var(--ds-space-100, 8px)"
});
const $3c2332889bded4a9$export$8947b11ec08f5f9d = (breakpoint)=>(0, $byn9U.css)({
        display: 'flex',
        flexDirection: breakpoint <= (0, $bFJ7u.Breakpoint).Small ? 'column' : 'row',
        gap: breakpoint <= (0, $bFJ7u.Breakpoint).Small ? '16px' : '8px'
    });

});



parcelRegister("8EeGs", function(module, exports) {

$parcel$export(module.exports, "UserInputCommandPaletteWithLogic", () => $64bd730da938df59$export$751495e555be6bbc);

var $XHGTv = parcelRequire("XHGTv");

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $fWZ8N = parcelRequire("fWZ8N");

var $89WgX = parcelRequire("89WgX");

var $jRfpS = parcelRequire("jRfpS");

var $j0bEH = parcelRequire("j0bEH");

var $3QQwc = parcelRequire("3QQwc");

var $hk7qZ = parcelRequire("hk7qZ");

var $iypWf = parcelRequire("iypWf");
function $64bd730da938df59$export$751495e555be6bbc({ send: sendToAiExperience, endExperience: endExperience, editorPluginAIProvider: editorPluginAIProvider, context: experienceAppContext }) {
    var _startingConfig$promp, _configItem$promptLab2, _configItem$promptHin;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { configItem: startingConfig, baseGenerate: baseGenerate, userInput: startingUserInput, userADFInput: startingUserADFInput, editCount: editCount, positions: positions, editorView: editorView, latestPromptResponse: latestPromptResponse, agents: agents } = experienceAppContext;
    const { context: commandPaletteContext, send: sendToCommandPalette } = (0, $hk7qZ.useCommandPaletteStateMachine)({
        baseGenerate: baseGenerate,
        startingConfig: startingConfig,
        startingPresetPromptLabel: (_startingConfig$promp = startingConfig.promptLabel) === null || _startingConfig$promp === void 0 ? void 0 : _startingConfig$promp.call(startingConfig, {
            formatMessage: formatMessage
        }),
        startingUserInput: startingUserInput,
        startingUserADFInput: startingUserADFInput
    });
    const { textInput: textInput, adfInput: adfInput, configItem: configItem, presetPromptLabel: presetPromptLabel } = commandPaletteContext;
    const focusInputRef = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(undefined);
    const handleCancel = ()=>{
        const isInputEmpty = !commandPaletteContext.textInput ? true : commandPaletteContext.textInput.trim().length === 0;
        if (isInputEmpty) endExperience();
        else {
            sendToAiExperience({
                type: 'update context',
                context: {
                    configItem: configItem,
                    userInput: textInput || '',
                    userADFInput: adfInput || ''
                }
            });
            sendToAiExperience({
                type: 'cancel'
            });
        }
    };
    const kickoffAiExperience = (0, $eUqFw.useCallback)(({ configItem: configItem, userInput: userInput, userADFInput: userADFInput })=>sendToAiExperience({
            type: 'kickoff with command palette input',
            context: {
                configItem: configItem,
                userInput: userInput,
                userADFInput: userADFInput
            }
        }), [
        sendToAiExperience
    ]);
    const onPartialPresetSelected = (0, $eUqFw.useCallback)((configItem)=>{
        var _configItem$promptLab, _focusInputRef$curren;
        // If partial prompt is selected we want to update the command palette
        // And focus the text input
        sendToCommandPalette({
            type: 'onPartialPresetSelected',
            configItem: configItem,
            presetPromptLabel: (_configItem$promptLab = configItem.promptLabel) === null || _configItem$promptLab === void 0 ? void 0 : _configItem$promptLab.call(configItem, {
                formatMessage: formatMessage
            })
        });
        (_focusInputRef$curren = focusInputRef.current) === null || _focusInputRef$curren === void 0 || _focusInputRef$curren.call(focusInputRef);
    }, [
        sendToCommandPalette,
        formatMessage
    ]);
    const analyticsFlow = (0, $jRfpS.useAnalyticsFlowEventsQueue)({
        stepName: 'prompt',
        attributes: {
            experienceName: configItem.title({
                formatMessage: (0, $3QQwc.analyticsFormatMessage)
            }),
            promptTitle: (_configItem$promptLab2 = configItem.promptLabel) === null || _configItem$promptLab2 === void 0 ? void 0 : _configItem$promptLab2.call(configItem, {
                formatMessage: (message)=>message.defaultMessage
            }),
            // !TODO AIFOLLOWUP - Remove this
            // This attribute only made sense when we had two different entry points
            // 'custom' or 'generate'
            // This should likely change to respresent the actual prompt types:
            // 'full-prompt' = when there is no user input (e.g. 'Summarize this page')
            // 'partial-prompt' = when there is user input and a prompt (e.g. 'Brainstorm: "Titles for this page"')
            // 'generate' = there is only user input, and no preset prompt
            promptType: 'generate',
            usingCommandPalette: true,
            editCount: editCount
        }
    });
    const updateAnalytics = (0, $eUqFw.useCallback)((configItem)=>{
        var _configItem$getBacken;
        /**
     * Update the backendModel common attribute whenever the configItem changes
     */ analyticsFlow.updateCommonAttributes({
            backendModel: configItem === null || configItem === void 0 ? void 0 : (_configItem$getBacken = configItem.getBackendModel) === null || _configItem$getBacken === void 0 ? void 0 : _configItem$getBacken.call(configItem, !!latestPromptResponse)
        });
        // update experiencename and title as it changes on selecting suggestion
        analyticsFlow.addAttributes({
            experienceName: configItem.title({
                formatMessage: (0, $3QQwc.analyticsFormatMessage)
            }),
            promptTitle: (configItem.promptLabel || configItem.title)({
                formatMessage: (0, $3QQwc.analyticsFormatMessage)
            })
        });
    }, [
        analyticsFlow,
        latestPromptResponse
    ]);
    const updateTextInput = (textInputValue)=>{
        sendToCommandPalette({
            type: 'onTextEntered',
            input: textInputValue
        });
    };
    const updateADFInput = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((text)=>{
        sendToCommandPalette({
            type: 'onADFEntered',
            adf: text
        });
    }, [
        sendToCommandPalette
    ]);
    const onSubmit = (0, $eUqFw.useCallback)(()=>{
        kickoffAiExperience({
            configItem: commandPaletteContext.configItem,
            userInput: commandPaletteContext.textInput || '',
            userADFInput: commandPaletteContext.adfInput || ''
        });
    }, [
        kickoffAiExperience,
        commandPaletteContext.configItem,
        commandPaletteContext.textInput,
        commandPaletteContext.adfInput
    ]);
    const __getSuggestions = (0, $eUqFw.useMemo)(()=>{
        return configItem.selectionType === 'range' ? editorPluginAIProvider.rangeConfig.getSuggestions : editorPluginAIProvider.emptyConfig.getSuggestions;
    }, [
        configItem.selectionType,
        editorPluginAIProvider.emptyConfig.getSuggestions,
        editorPluginAIProvider.rangeConfig.getSuggestions
    ]);
    /**
   * This function is responsible for highlighting the entire document
   * when particular prompts are selected.
   *
   * This only happens if the user has not already made a selection.
   *
   * Currently all prompts highlight the whole document except partial prompts like:
   * - Brainstorm
   * - Ask Search
   */ const handleHighlight = (0, $eUqFw.useCallback)(({ configItem: configItem, promptLabel: promptLabel })=>{
        // Remove all decorations if the prompt is 'Tell AI' or that it is not defined (brainstorm)
        if (configItem.promptLabel !== undefined || promptLabel === 'tell-ai') {
            const removeTransaction = editorView.state.tr;
            removeTransaction.setMeta('hideSelectionPreview', true);
            editorView.dispatch(removeTransaction);
            return;
        }
        // Highlight the entire document for all other prompts
        const setTransaction = editorView.state.tr;
        setTransaction.setMeta('showSelectionPreview', true);
        editorView.dispatch(setTransaction);
    }, [
        editorView
    ]);
    const getSuggestions = (0, $eUqFw.useCallback)((inputValue)=>{
        return __getSuggestions({
            inputValue: inputValue
        }).filter((configItem)=>{
            return configItem.isVisible({
                editorView: editorView,
                positions: positions
            });
        }).map((configItem)=>{
            var _configItem$icon;
            return {
                icon: (_configItem$icon = configItem.icon) === null || _configItem$icon === void 0 ? void 0 : _configItem$icon.call(configItem, {
                    formatMessage: formatMessage,
                    shownAt: 'suggestions'
                }),
                label: configItem.title({
                    formatMessage: formatMessage
                }),
                statusLozengeType: configItem.statusLozengeType,
                // Note -- we can probably delete value
                // appears to only be used internally for a react key
                // not appear to be getting used)
                value: configItem.title({
                    formatMessage: formatMessage
                }),
                onSuggestionFocused: ()=>{
                    handleHighlight({
                        configItem: configItem
                    });
                },
                onSelect: ()=>{
                    var _configItem$promptLab3;
                    handleHighlight({
                        configItem: configItem
                    });
                    updateAnalytics(configItem);
                    // If full prompt is selected we want to kickoff the AI experience
                    if (!((_configItem$promptLab3 = configItem.promptLabel) !== null && _configItem$promptLab3 !== void 0 && _configItem$promptLab3.call(configItem, {
                        formatMessage: formatMessage
                    }))) kickoffAiExperience({
                        userInput: '',
                        userADFInput: '',
                        configItem: configItem
                    });
                    else onPartialPresetSelected(configItem);
                }
            };
        }).filter((configItem)=>configItem.label.toLowerCase().includes((inputValue || '').toLowerCase())).concat(!(0, $XHGTv.getBooleanFF)('platform.editor.ai-rovo-agents') ? [] : agents.map((agent)=>{
            const agentConfigItem = (0, $j0bEH.createAgentConfigItem)(startingConfig.selectionType, agent);
            return {
                value: `agent:${agent.id}`,
                label: agent.name,
                description: agent.description,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fWZ8N.RovoAgentIcon), {
                    label: agent.name
                }),
                group: formatMessage((0, $iypWf.messages).agentsSuggestionGroupHeading),
                onSelect: ()=>{
                    handleHighlight({
                        configItem: agentConfigItem
                    });
                    updateAnalytics(agentConfigItem);
                    onPartialPresetSelected(agentConfigItem);
                },
                onSuggestionFocused: ()=>{
                    handleHighlight({
                        configItem: agentConfigItem
                    });
                }
            };
        })).concat(inputValue ? [
            {
                value: 'tell-ai',
                label: inputValue,
                onSelect: ()=>{
                    handleHighlight({
                        configItem: configItem
                    });
                    updateAnalytics(configItem);
                    onSubmit();
                },
                onSuggestionFocused: ()=>{
                    handleHighlight({
                        configItem: configItem,
                        promptLabel: 'tell-ai'
                    });
                }
            }
        ] : []);
    }, [
        configItem,
        __getSuggestions,
        onSubmit,
        formatMessage,
        editorView,
        positions,
        handleHighlight,
        kickoffAiExperience,
        agents,
        startingConfig,
        onPartialPresetSelected,
        updateAnalytics
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $89WgX.UserInputCommandPalette), {
        presetPromptLabel: presetPromptLabel,
        inputValue: textInput || '',
        inputADFValue: adfInput,
        onInputUpdate: updateTextInput,
        onADFUpdate: updateADFInput,
        onCancel: handleCancel,
        onEscapeKeyPressed: handleCancel,
        onSubmit: onSubmit,
        onRefinementTagRemove: ()=>{
            var _baseGenerate$promptL, _baseGenerate$getBack, _focusInputRef$curren2;
            // Set experienceName and promptTitle to default values
            analyticsFlow.addAttributes({
                experienceName: baseGenerate === null || baseGenerate === void 0 ? void 0 : baseGenerate.title({
                    formatMessage: (message)=>message.defaultMessage
                }),
                promptTitle: baseGenerate === null || baseGenerate === void 0 ? void 0 : (_baseGenerate$promptL = baseGenerate.promptLabel) === null || _baseGenerate$promptL === void 0 ? void 0 : _baseGenerate$promptL.call(baseGenerate, {
                    formatMessage: (message)=>message.defaultMessage
                })
            });
            analyticsFlow.updateCommonAttributes({
                backendModel: baseGenerate === null || baseGenerate === void 0 ? void 0 : (_baseGenerate$getBack = baseGenerate.getBackendModel) === null || _baseGenerate$getBack === void 0 ? void 0 : _baseGenerate$getBack.call(baseGenerate, !!latestPromptResponse)
            });
            sendToCommandPalette({
                type: 'onPartialPresetRemoved'
            });
            (_focusInputRef$curren2 = focusInputRef.current) === null || _focusInputRef$curren2 === void 0 || _focusInputRef$curren2.call(focusInputRef);
        },
        placeholder: ((_configItem$promptHin = configItem.promptHint) === null || _configItem$promptHin === void 0 ? void 0 : _configItem$promptHin.call(configItem, {
            formatMessage: formatMessage
        })) || '',
        getSuggestions: getSuggestions,
        focusInputRef: focusInputRef,
        PromptEditor: editorPluginAIProvider.PromptEditor,
        agent: configItem.agent
    });
}

});
parcelRegister("fWZ8N", function(module, exports) {

$parcel$export(module.exports, "RovoAgentIcon", () => $b9cbb31e81b19a6a$export$e331edd80bbc26a2);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");

var $44BNi = parcelRequire("44BNi");
var $8ceJs = parcelRequire("8ceJs");
const $b9cbb31e81b19a6a$var$wrapperStyles = (0, $8ceJs.xcss)({
    marginInline: 'space.050',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
const $b9cbb31e81b19a6a$var$CustomGlyph = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", (0, $kU09D.default)({
        width: "23",
        height: "26",
        viewBox: "0 0 23 26",
        fill: "none"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M10.512 1.06137C11.1247 0.713259 11.8753 0.713259 12.488 1.06137L21.488 6.17501C22.1136 6.53043 22.5 7.19446 22.5 7.91392V18.0861C22.5 18.8055 22.1136 19.4696 21.488 19.825L12.488 24.9386C11.8753 25.2867 11.1247 25.2867 10.512 24.9386L1.51198 19.825C0.886437 19.4696 0.5 18.8055 0.5 18.0861V7.91392C0.5 7.19446 0.886437 6.53043 1.51198 6.17501L10.512 1.06137Z",
        fill: props.primaryColor || '#0C66E4'
    }), !props.primaryColor && !props.excludeOverlay && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M15.3711 9.12845C15.7263 9.30173 16.1726 9.00581 16.3843 9.37104C16.1136 9.2564 16.1496 10.7306 16.5959 10.3814C16.6497 10.1521 16.7793 10.1801 16.551 10.1015C16.9344 10.0988 16.5779 9.84556 16.5907 9.80957C16.7998 9.80424 16.5266 9.68161 16.7254 9.72427C16.8408 9.70027 16.5035 9.39637 16.7318 9.47768C16.8049 9.14711 17.1615 9.14976 17.0819 8.94849C17.0858 9.08578 18.2708 9.11778 17.9425 8.59261C17.7347 8.60328 17.7617 8.36068 17.7309 8.67659C17.668 8.28471 17.5283 8.67658 17.4949 8.66725C17.4641 8.44731 17.4026 8.75122 17.4115 8.53662C17.3808 8.42066 17.1807 8.79121 17.2204 8.54861C16.5292 8.36067 17.096 8.15807 16.6972 7.75019C16.6574 7.56092 16.7549 6.94644 16.3278 7.00376C15.7661 7.17171 16.4214 8.22072 16.088 8.40333C15.9392 8.54195 15.7276 8.71656 15.4467 8.59793C15.3082 8.59527 15.13 9.1831 15.3698 9.12979L15.3711 9.12845Z",
        fill: "#579DFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.3218 15.6931L14.5291 14.9004C12.9326 16.1142 11.4765 17.4318 10.1783 18.8662C8.3402 17.3566 6.68445 15.6005 5.18662 13.6303L11.4518 7.36515C12.9665 10.1168 15.0426 12.0855 17.5196 13.4953L15.3218 15.6931ZM10.7452 13.7518L10.7452 15.6016L10.7454 15.6016L11.6857 15.6016L11.6857 13.7518L13.4285 13.7518L11.2154 11.5387L9.00236 13.7518L10.7452 13.7518ZM14.5291 14.9007L15.3217 15.6934L11.2855 19.7296C10.9092 19.4518 10.5403 19.1639 10.1783 18.8665C11.4764 17.4323 12.9325 16.1146 14.5291 14.9007Z",
        fill: "#CCE0FF"
    })));
};
const $b9cbb31e81b19a6a$var$CustomIcon = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), (0, $kU09D.default)({
        glyph: (glyphProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b9cbb31e81b19a6a$var$CustomGlyph, (0, $kU09D.default)({}, props, glyphProps))
    }, props));
};
const $b9cbb31e81b19a6a$export$e331edd80bbc26a2 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $44BNi.default), {
        xcss: $b9cbb31e81b19a6a$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b9cbb31e81b19a6a$var$CustomIcon, props));
};

});

parcelRegister("89WgX", function(module, exports) {

$parcel$export(module.exports, "UserInputCommandPalette", () => $5f0c5db99a6fbcda$export$9491b5d7f967f421);

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $74BVL = parcelRequire("74BVL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $XHGTv = parcelRequire("XHGTv");

var $lkPEe = parcelRequire("lkPEe");

var $dVNkz = parcelRequire("dVNkz");

var $zVmD6 = parcelRequire("zVmD6");

var $b2hnG = parcelRequire("b2hnG");

var $eUqFw = parcelRequire("eUqFw");

var $3exJh = parcelRequire("3exJh");

var $2GXlj = parcelRequire("2GXlj");

var $7NBW6 = parcelRequire("7NBW6");

var $cC52a = parcelRequire("cC52a");


var $7nPJR = parcelRequire("7nPJR");

var $gq1nI = parcelRequire("gq1nI");

var $cp9TA = parcelRequire("cp9TA");

var $bFJ7u = parcelRequire("bFJ7u");

var $fWZ8N = parcelRequire("fWZ8N");
var $8QGgC = parcelRequire("8QGgC");
const $5f0c5db99a6fbcda$export$9491b5d7f967f421 = ({ inputValue: inputValue, inputADFValue: inputADFValue, onInputUpdate: onInputUpdate, onADFUpdate: onADFUpdate, presetPromptLabel: presetPromptLabel, onSubmit: onSubmit, onCancel: onCancel, onEscapeKeyPressed: onEscapeKeyPressed, onRefinementTagRemove: onRefinementTagRemove, placeholder: placeholder, getSuggestions: getSuggestions, suggestionsHeading: suggestionsHeading, focusInputRef: focusInputRef, PromptEditor: PromptEditor, agent: agent })=>{
    const { ref: ref, breakpoint: breakpoint } = (0, $bFJ7u.useContainerBreakpoints)();
    const promptWithSuggestionsRef = (0, $eUqFw.useRef)(null);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    /**
   * Scroll prompt into view as suggestions are not always fully visible
   * when PromptInput is autofocused.
   */ (0, $eUqFw.useEffect)(()=>{
        // Add event listener to handle escape key press
        const { current: element } = promptWithSuggestionsRef;
        // If the element is not mounted, do nothing
        if (!element) return;
        // setTimeout is for Safari so that it scrolls even with the
        // PromptInput autoFocus scroll behaviour.
        setTimeout(()=>{
            if (promptWithSuggestionsRef.current) promptWithSuggestionsRef.current.scrollIntoView({
                block: 'nearest'
            });
        }, 0);
        /**
     * KeyDown (as opposed to KeyPress) event is used to handle the escape key so that
     * other escape key handlers will not override this behaviour.
     * Additionally this aligns with other escape listeners e.g. for closing typeahead popup.
     */ const handleEscapeKeyDown = (event)=>{
            if (event.key === 'Escape') {
                event.preventDefault();
                event.stopPropagation();
                onEscapeKeyPressed();
            }
        };
        /**
     * Handle KeyUp event to prevent unexpected escape behaviours when
     * there are other escape handlers outside of component (e.g. in product)
     */ const handleEscapeKeyUp = (event)=>{
            if (event.key !== 'Escape') return;
            event.preventDefault();
            event.stopPropagation();
        };
        return (0, $74BVL.bindAll)(element, [
            {
                type: 'keydown',
                listener: handleEscapeKeyDown
            },
            {
                type: 'keyup',
                listener: handleEscapeKeyUp
            }
        ]);
    }, [
        promptWithSuggestionsRef,
        onEscapeKeyPressed
    ]);
    /*
   * If there is no refinement tag, show the suggestions.
   * Otherwise, show the refinement tag and no suggestions.
   */ let suggestions = (0, $eUqFw.useMemo)(()=>{
        return presetPromptLabel === undefined ? getSuggestions(inputValue) : [];
    }, [
        presetPromptLabel,
        getSuggestions,
        inputValue
    ]);
    const agentTagProps = {
        elemBefore: (0, $byn9U.jsx)((0, $fWZ8N.RovoAgentIcon), {
            label: "",
            size: "small",
            testId: "command-palette-rovo-agent-icon"
        }),
        appearance: 'rounded'
    };
    let tag = presetPromptLabel === undefined ? undefined : (0, $byn9U.jsx)((0, $b2hnG.RefinementTag), (0, $kU09D.default)({}, agent ? agentTagProps : {}, {
        label: presetPromptLabel,
        onClick: onRefinementTagRemove
    }));
    const suggestionValues = (0, $eUqFw.useMemo)(()=>{
        return (suggestions || []).map((suggestion)=>suggestion.value);
    }, [
        suggestions
    ]);
    const [currentSuggestion, _setCurrentSuggestion] = (0, $eUqFw.useState)(suggestionValues.length > 0 ? suggestionValues[0] : '');
    /**
   * Handles the behaviour for when a user changes the suggestion.
   *
   * At the moment this is used to highlight the entire editor document for
   * relevant suggestions.
   */ const handleSuggestionChanged = (0, $eUqFw.useCallback)((suggestion)=>{
        const suggestionObject = suggestions.find((s)=>s.value === suggestion);
        suggestionObject === null || suggestionObject === void 0 || suggestionObject.onSuggestionFocused();
    }, [
        suggestions
    ]);
    const setCurrentSuggestion = (0, $eUqFw.useCallback)((newValue)=>{
        handleSuggestionChanged(newValue);
        _setCurrentSuggestion(newValue);
    }, [
        _setCurrentSuggestion,
        handleSuggestionChanged
    ]);
    // Select first option by default
    (0, $eUqFw.useEffect)(()=>{
        if (suggestionValues.includes(currentSuggestion) || suggestionValues.length === 0) return;
        setCurrentSuggestion(suggestionValues[0]);
    }, [
        currentSuggestion,
        suggestionValues,
        setCurrentSuggestion
    ]);
    const onArrowKeyDown = (0, $eUqFw.useCallback)((event)=>{
        // Ignore if any key modifiers are held
        if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
        // If theres one or less suggestions, no need to navigate and allow normal
        // multiline text traversal
        if (suggestionValues.length <= 1) return;
        switch(event.key){
            case 'ArrowUp':
            case 'ArrowDown':
                {
                    const nextSuggestion = (0, $gq1nI.getNextSuggestion)(suggestionValues, currentSuggestion, event.key);
                    setCurrentSuggestion(nextSuggestion);
                    event.preventDefault();
                    event.stopPropagation();
                    break;
                }
            default:
                return;
        }
    }, [
        currentSuggestion,
        setCurrentSuggestion,
        suggestionValues
    ]);
    const setSuggestion = (0, $eUqFw.useCallback)((suggestion)=>{
        setCurrentSuggestion(suggestion.value);
    }, [
        setCurrentSuggestion
    ]);
    const suggestionDiv = (0, $byn9U.jsx)((0, $cC52a.Suggestions), {
        suggestions: suggestions,
        suggestionsHeading: suggestionsHeading,
        value: currentSuggestion,
        setSuggestion: setSuggestion
    });
    const onFormSubmit = (0, $eUqFw.useCallback)(()=>{
        const isRefinementPrompt = !!presetPromptLabel;
        if (currentSuggestion === '' || isRefinementPrompt) {
            onSubmit();
            return;
        }
        const suggestion = (suggestions || []).find((suggestion)=>suggestion.value === currentSuggestion);
        if (suggestion) suggestion.onSelect();
        setCurrentSuggestion('');
    }, [
        suggestions,
        currentSuggestion,
        setCurrentSuggestion,
        onSubmit,
        presetPromptLabel
    ]);
    // if a refinement tag like brainstorm was selected, we continue showing these legacy buttons
    const showLegacySubmitCancelButtons = Boolean(presetPromptLabel && !agent);
    const enableLinksInPromptEditor = !!(0, $XHGTv.getBooleanFF)('platform.editor.ai-assistance-service-free-generate');
    const promptForm = (0, $byn9U.jsx)((0, $3exJh.PromptForm), {
        inputControlsLayout: agent ? 'column' : 'row',
        showButtons: showLegacySubmitCancelButtons,
        placeholder: agent ? formatMessage((0, $zVmD6.default).rovoAgentsPalettePlaceholder) : placeholder,
        value: inputValue,
        adfValue: inputADFValue,
        onFormSubmit: onFormSubmit,
        onCancel: onCancel,
        onInputChange: onInputUpdate,
        onADFChange: onADFUpdate,
        tag: tag,
        focusInputRef: focusInputRef,
        showLogo: false,
        onInputKeyDown: onArrowKeyDown,
        PromptEditor: PromptEditor,
        enableLinks: enableLinksInPromptEditor
    });
    return(// Need div for css composition
    // https://atlassian.design/components/eslint-plugin-design-system/usage#prefer-primitives
    // eslint-disable-next-line
    (0, $byn9U.jsx)("div", {
        ref: promptWithSuggestionsRef,
        "data-testid": "user-input-command-palette-screen",
        className: `user-input-command-palette-screen ${(0, $64ce3526fe10ea0e$export$9df59400d72ad68f)}`,
        css: [
            (0, $dVNkz.columnLayout),
            (0, $7NBW6.scrollMarginStyles)
        ]
    }, (0, $byn9U.jsx)((0, $lkPEe.default), null, formatMessage((0, $zVmD6.default).commandPaletteAriaName)), (0, $byn9U.jsx)((0, $2GXlj.FloatingContainer), {
        ref: ref,
        css: (0, $dVNkz.floatingContainerStyles),
        "data-testid": "prompt-form-screen"
    }, (0, $byn9U.jsx)("div", {
        css: (0, $dVNkz.promptPaddingStyles)
    }, promptForm), (!tag || agent) && (suggestions || inputValue) ? suggestionDiv : null, agent && (0, $byn9U.jsx)("div", null, "Agent selected: ", agent.name), (0, $byn9U.jsx)("div", {
        "data-testid": "command-palette-footer",
        css: (0, $dVNkz.footerSectionStyles)
    }, agent ? (0, $byn9U.jsx)((0, $8QGgC.RovoLogo), {
        label: formatMessage((0, $zVmD6.default).rovoProductLogoAltText),
        primaryColor: "var(--ds-icon-subtle, #626F86)",
        size: "large",
        testId: "rovo-product-logo"
    }) : (0, $byn9U.jsx)((0, $7nPJR.AtlassianIntelligenceLogo), null), (0, $byn9U.jsx)("div", {
        "data-testid": "footer-brand-text",
        css: (0, $dVNkz.footerTextStyles)(breakpoint)
    }, formatMessage(agent ? (0, $zVmD6.default).rovoProductLabel : (0, $zVmD6.default).footerText)), !showLegacySubmitCancelButtons && (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)("div", {
        css: (0, $dVNkz.footerSectionSpacerStyles)
    }), (0, $byn9U.jsx)("div", null, (0, $byn9U.jsx)((0, $cp9TA.CancelEscButton), {
        onCancel: onCancel
    })))))));
};

});
parcelRegister("dVNkz", function(module, exports) {

$parcel$export(module.exports, "floatingContainerStyles", () => $a246dd46c8adb7f4$export$8833ec6a339f43a0);
$parcel$export(module.exports, "columnLayout", () => $a246dd46c8adb7f4$export$f8ce731bdfd45dc7);
$parcel$export(module.exports, "promptPaddingStyles", () => $a246dd46c8adb7f4$export$19bd060cecb6fe16);
$parcel$export(module.exports, "footerTextStyles", () => $a246dd46c8adb7f4$export$35b4a37ddeeb439f);
$parcel$export(module.exports, "footerSectionStyles", () => $a246dd46c8adb7f4$export$f0855824549edef5);
$parcel$export(module.exports, "footerSectionSpacerStyles", () => $a246dd46c8adb7f4$export$5baeafd9a1b3f7d6);

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $bFJ7u = parcelRequire("bFJ7u");
const $a246dd46c8adb7f4$export$8833ec6a339f43a0 = (0, $byn9U.css)({
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    '> :not(:last-child)': {
        borderBottom: `1px solid ${`var(--ds-border, ${(0, $PdmhA.N40A)})`}`
    }
});
const $a246dd46c8adb7f4$export$f8ce731bdfd45dc7 = (0, $byn9U.css)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: "var(--ds-space-050, 4px)"
});
const $a246dd46c8adb7f4$export$19bd060cecb6fe16 = (0, $byn9U.css)({
    padding: "var(--ds-space-150, 12px)"
});
const $a246dd46c8adb7f4$export$35b4a37ddeeb439f = (breakpoint)=>(0, $byn9U.css)({
        color: "var(--ds-text-subtlest, #626F86)",
        display: breakpoint <= (0, $bFJ7u.Breakpoint).Small ? 'none' : undefined
    });
const $a246dd46c8adb7f4$export$f0855824549edef5 = (0, $byn9U.css)({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: "var(--ds-space-150, 12px)",
    gap: "var(--ds-space-150, 12px)"
});
const $a246dd46c8adb7f4$export$5baeafd9a1b3f7d6 = (0, $byn9U.css)({
    flexGrow: 1
});

});

parcelRegister("zVmD6", function(module, exports) {

$parcel$export(module.exports, "default", () => $06bfc44b10cff5cf$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $06bfc44b10cff5cf$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    footerText: {
        id: 'fabric.editor.ai.screens.UserInputCommamdPalette.footerText',
        defaultMessage: 'Atlassian Intelligence',
        description: 'Atlassian Intelligence footer text for user input command palette screen'
    },
    rovoProductLabel: {
        id: 'fabric.editor.ai.experience.rovoAgents.productLabel',
        defaultMessage: 'Rovo',
        description: 'Name of the Atlassian service and product that provides AI agents'
    },
    rovoProductLogoAltText: {
        id: 'fabric.editor.ai.experience.rovoAgents.productLogoAltText',
        defaultMessage: 'Rovo Logo',
        description: 'Rovo logo alt text'
    },
    rovoAgentsPalettePlaceholder: {
        id: 'fabric.editor.ai.experience.rovoAgents.agentPalette.placeholder',
        defaultMessage: 'Tell Agent to write anything or choose from the below',
        description: 'Placeholder text visible when input field in the Agent command palette is empty'
    },
    commandPaletteAriaName: {
        id: 'fabric.editor.ai.experience.commandPaletteAriaName',
        defaultMessage: 'Atlassian Intelligence',
        description: 'Accessible label for the user input dialog'
    }
});

});

parcelRegister("cC52a", function(module, exports) {

$parcel$export(module.exports, "Suggestions", () => $92ecf0459a9fcccc$export$7463f42be087e7d6);
/* eslint-disable @atlaskit/design-system/prefer-primitives */ /* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ /* @jsx jsx */ /** @jsxfrag */ 
var $byn9U = parcelRequire("byn9U");

var $dxIU5 = parcelRequire("dxIU5");

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5Gk6i = parcelRequire("5Gk6i");

var $8g58l = parcelRequire("8g58l");

var $dd1fJ = parcelRequire("dd1fJ");

var $kBdjw = parcelRequire("kBdjw");
const $92ecf0459a9fcccc$export$7463f42be087e7d6 = ({ suggestionsHeading: suggestionsHeading, suggestions: suggestions, value: value, setSuggestion: setSuggestion })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    /**
   * While scrolling with the mouse, the setSuggestion() function can still be
   * called by the mousemove event in ListItem.
   *
   * So while the scrolling is happening, another scrollTo() is started and
   * conflicts with the current scrolling momentum, causing the experience to
   * jitter and feel clunky.
   *
   * While scrolling with just the mouse, this is the order of events:
   * - (multiple) scroll
   * - mousemove
   * - (multiple) scroll
   * - mousemove
   * - scrollend
   *
   * However, if the user leaves the cursor over the list while navigating with
   * the keyboard and it scrolls to ensure items are visible, the order of
   * events is:
   * - (multiple) on scroll
   * - scrollend
   * - mousemove
   *
   * So to avoid the mousemove from triggering a change, we set a flag to
   * ignore mousemove events until a bit after its over.
   */ const ignoreMouseMoveRef = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(false);
    const scrollerRef = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(null);
    const smoothSetSuggestion = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((suggestion, eventName)=>{
        if (!setSuggestion) return;
        // Ignore mousemove
        if (eventName === 'mousemove' && ignoreMouseMoveRef.current) return;
        setSuggestion(suggestion);
    }, [
        setSuggestion
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        if (!scrollerRef.current) return;
        // Debounced handler to restore tracking after scrolling
        const allowMouseTracking = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(()=>{
            ignoreMouseMoveRef.current = false;
        }, 75);
        const onScrollEvent = ()=>{
            ignoreMouseMoveRef.current = true;
            allowMouseTracking();
        };
        const scroller = scrollerRef.current;
        scroller.addEventListener('scroll', onScrollEvent);
        scroller.addEventListener('scrollend', onScrollEvent);
        return ()=>{
            scroller.removeEventListener('scroll', onScrollEvent);
            scroller.removeEventListener('scrollend', onScrollEvent);
        };
    }, [
        scrollerRef
    ]);
    const renderedGroupSuggestions = (0, $eUqFw.useMemo)(()=>{
        return (suggestions || []).reduce((updatedSuggestions, suggestion, index, originalArray)=>{
            const previousRecord = originalArray[index - 1];
            // @TODO EDF-840: Improve HTML structure with suggestion grouping for a11y
            // We will need to put children under a nested <ul> but this also
            // comes with all the implication of extra testing and updating tests
            if (suggestion.group && previousRecord && previousRecord.group !== suggestion.group) updatedSuggestions.push((0, $byn9U.jsx)((0, $8g58l.ListHeading), {
                key: `group_${suggestion.group}`,
                heading: suggestion.group
            }));
            updatedSuggestions.push((0, $byn9U.jsx)((0, $dd1fJ.ListItem), {
                key: suggestion.value,
                suggestion: suggestion,
                customLabel: suggestion.value === 'tell-ai' ? formatMessage((0, $5Gk6i.messages).tellAILabel) : undefined,
                highlighted: suggestion.value === value,
                setSuggestion: smoothSetSuggestion
            }));
            return updatedSuggestions;
        }, []);
    }, [
        formatMessage,
        smoothSetSuggestion,
        suggestions,
        value
    ]);
    if (!renderedGroupSuggestions.length) return null;
    return (0, $byn9U.jsx)("div", {
        "data-testid": "suggestions-container",
        css: (0, $kBdjw.suggestionsScrollerStyles),
        ref: scrollerRef
    }, suggestionsHeading && (0, $byn9U.jsx)("h2", {
        css: (0, $kBdjw.suggestionsHeadingStyles)
    }, suggestionsHeading), (0, $byn9U.jsx)("ul", {
        "data-testid": "editor-plugin-ai-suggestion-list",
        id: "suggestion-list",
        css: (0, $kBdjw.suggestionsContainerStyles)
    }, renderedGroupSuggestions));
};

});
parcelRegister("5Gk6i", function(module, exports) {

$parcel$export(module.exports, "messages", () => $42307790893cd9d6$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $42307790893cd9d6$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    tellAILabel: {
        id: 'fabric.editor.ai.ui.components.suggestions.tellAILabel',
        defaultMessage: 'Tell AI',
        description: 'Label for default suggestion option'
    },
    suggestionStatusBeta: {
        id: 'fabric.editor.ai.ui.components.suggestions.betaLozenge',
        defaultMessage: 'BETA',
        description: 'Lozenge text to indicate that the feature is in beta stage'
    },
    suggestionStatusNew: {
        id: 'fabric.editor.ai.ui.components.suggestions.newLozenge',
        defaultMessage: 'NEW',
        description: 'Lozenge text to indicate that the feature is in new'
    }
});

});

parcelRegister("8g58l", function(module, exports) {

$parcel$export(module.exports, "ListHeading", () => $6033cccc5ac503b4$export$b7bc1538a6ef0630);
/* @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $kBdjw = parcelRequire("kBdjw");
const $6033cccc5ac503b4$export$b7bc1538a6ef0630 = ({ heading: heading })=>{
    const listHeadingRef = (0, $eUqFw.useRef)(null);
    return (0, $byn9U.jsx)("li", {
        css: (0, $kBdjw.suggestionsGroupHeadingStyles),
        ref: listHeadingRef
    }, (0, $byn9U.jsx)("h3", {
        "data-testid": heading
    }, heading));
};

});
parcelRegister("kBdjw", function(module, exports) {

$parcel$export(module.exports, "suggestionsContainerStyles", () => $eff197343a1ca891$export$bee0538348139ee);
$parcel$export(module.exports, "suggestionButtonStyles", () => $eff197343a1ca891$export$3566db75f01c8086);
$parcel$export(module.exports, "enterIconStyles", () => $eff197343a1ca891$export$6ba7aecaee480acc);
$parcel$export(module.exports, "suggestionListItemStyles", () => $eff197343a1ca891$export$dcf23b903c1acc22);
$parcel$export(module.exports, "suggestionLabelStyles", () => $eff197343a1ca891$export$902aee21085730f4);
$parcel$export(module.exports, "suggestionDescriptionStyles", () => $eff197343a1ca891$export$1de09905263f25dd);
$parcel$export(module.exports, "tellAILabelStyles", () => $eff197343a1ca891$export$605049c8e4c230cb);
$parcel$export(module.exports, "suggestionsHeadingStyles", () => $eff197343a1ca891$export$6a54060c43fb4fb4);
$parcel$export(module.exports, "suggestionsGroupHeadingStyles", () => $eff197343a1ca891$export$29a039cec2e00523);
$parcel$export(module.exports, "suggestionIconStyles", () => $eff197343a1ca891$export$59c65dafb28fb2f5);
$parcel$export(module.exports, "suggestionsScrollerStyles", () => $eff197343a1ca891$export$664084bdd27c7691);

var $byn9U = parcelRequire("byn9U");
const $eff197343a1ca891$export$bee0538348139ee = (0, $byn9U.css)({
    width: '100%',
    height: '100%',
    margin: '0px',
    padding: '0px',
    listStyle: 'none',
    display: 'inline-block',
    position: 'relative',
    'li:first-of-type': {
        borderTopLeftRadius: 'inherit',
        borderTopRightRadius: 'inherit'
    },
    'li:last-of-type': {
        borderBottomLeftRadius: 'inherit',
        borderBottomRightRadius: 'inherit'
    }
});
const $eff197343a1ca891$export$3566db75f01c8086 = (0, $byn9U.css)({
    width: '100%',
    minHeight: '40px',
    padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"} ${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
    marginTop: '0px',
    border: 0,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'start',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    gap: '13px',
    textAlign: 'left',
    fontWeight: 400,
    lineHeight: '18px',
    color: "var(--ds-text, #172b4d)",
    fontFamily: 'inherit',
    fontSize: 'inherit',
    background: 'none',
    '&:not([disabled])': {
        cursor: 'pointer',
        '&:active': {
            backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
        },
        "&[data-highlighted='true']": {
            '&:not(:active)': {
                backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
            }
        },
        '&:focus': {
            outline: `2px solid ${"var(--ds-border-focused, #4C9AFF)"}`,
            outlineOffset: "var(--ds-space-negative-025, -2px)"
        }
    },
    '&[disabled]': {
        background: "var(--ds-background-disabled, #091e420a)",
        color: "var(--ds-text-disabled, #A5ADBA)",
        cursor: 'not-allowed'
    }
});
const $eff197343a1ca891$export$6ba7aecaee480acc = (0, $byn9U.css)({
    // with '&', the following selector applies only if this icon style is under a highlighted button
    "button[data-highlighted='true'] &": {
        display: 'inline'
    },
    display: 'none',
    padding: '5px 5px 3px 5px',
    borderRadius: '3px',
    color: "var(--ds-text-subtle, #44546F)",
    backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
});
const $eff197343a1ca891$export$dcf23b903c1acc22 = (0, $byn9U.css)({
    marginTop: '0px',
    listStyle: 'none'
});
const $eff197343a1ca891$export$902aee21085730f4 = (0, $byn9U.css)({
    hyphens: 'auto',
    wordWrap: 'break-word',
    flex: 1,
    minWidth: '90px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});
const $eff197343a1ca891$export$1de09905263f25dd = (0, $byn9U.css)({
    hyphens: 'auto',
    wordWrap: 'break-word',
    flex: 1,
    minWidth: '90px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    fontSize: '12px',
    lineHeight: '16px',
    color: "var(--ds-text-subtlest, #626F86)",
    paddingTop: "var(--ds-space-050, 4px)",
    display: 'inline-block'
});
const $eff197343a1ca891$export$605049c8e4c230cb = (0, $byn9U.css)({
    fontWeight: 500
});
const $eff197343a1ca891$export$6a54060c43fb4fb4 = (0, $byn9U.css)({
    '&&': {
        margin: '0px',
        padding: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"} ${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
        fontSize: '11px',
        lineHeight: '16px',
        fontWeight: 700,
        textTransform: 'uppercase',
        color: "var(--ds-text-subtle, #42526E)"
    }
});
const $eff197343a1ca891$export$29a039cec2e00523 = (0, $byn9U.css)({
    margin: '0px',
    padding: `${"var(--ds-space-075, 18px)"} ${"var(--ds-space-150, 12px)"} ${"var(--ds-space-075, 6px)"} ${"var(--ds-space-150, 12px)"}`,
    '& h3': {
        margin: 0,
        fontSize: '11px',
        lineHeight: '16px',
        fontWeight: 700,
        textTransform: 'uppercase',
        color: "var(--ds-text-subtle, #42526E)"
    }
});
const $eff197343a1ca891$export$59c65dafb28fb2f5 = (0, $byn9U.css)({
    height: '24px',
    width: '24px',
    textAlign: 'center',
    // Increase the size of default icon a little so it looks better
    '& > .default-icon': {
        height: '20px',
        width: '20px'
    }
});
const $eff197343a1ca891$export$664084bdd27c7691 = (0, $byn9U.css)({
    maxHeight: '144px',
    overflowY: 'auto'
});

});


parcelRegister("dd1fJ", function(module, exports) {

$parcel$export(module.exports, "ListItem", () => $99dd760c8cf82d71$export$a7b06bfba60a8a78);
/* @jsx jsx */ /* @jsxFrag React.Fragment */ 
var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $byn9U = parcelRequire("byn9U");

var $5Gk6i = parcelRequire("5Gk6i");

var $kBdjw = parcelRequire("kBdjw");

var $9zKyk = parcelRequire("9zKyk");

var $izdMb = parcelRequire("izdMb");

var $ffiyv = parcelRequire("ffiyv");

var $XHGTv = parcelRequire("XHGTv");
const $99dd760c8cf82d71$var$ensureElementIsVisibleInScrollContainer = (listItem)=>{
    var _listItem$offsetParen;
    // ensure the structure of suggestions li element > ul (position relative) > scrollable div (overflow auto)
    const scrollContainer = (_listItem$offsetParen = listItem.offsetParent) === null || _listItem$offsetParen === void 0 ? void 0 : _listItem$offsetParen.parentElement;
    if (!scrollContainer || scrollContainer.tagName !== 'DIV') return;
    const scrollContainerRect = scrollContainer.getBoundingClientRect();
    const itemRect = listItem.getBoundingClientRect();
    // if highlighted item is above/below the current scroll viewport
    const itemNotVisible = listItem.offsetTop < scrollContainer.scrollTop || listItem.offsetTop + itemRect.height > scrollContainer.scrollTop + scrollContainerRect.height;
    if (itemNotVisible) // Can't use item.scrollIntoView() because it moves the whole page too
    scrollContainer.scrollTo({
        top: listItem.offsetTop,
        behavior: 'smooth'
    });
};
const $99dd760c8cf82d71$var$statusLozengeMessages = {
    beta: (0, $5Gk6i.messages).suggestionStatusBeta,
    new: (0, $5Gk6i.messages).suggestionStatusNew
};
const $99dd760c8cf82d71$export$a7b06bfba60a8a78 = ({ suggestion: suggestion, customLabel: customLabel, highlighted: highlighted, setSuggestion: setSuggestion })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const listItemRef = (0, $eUqFw.useRef)(null);
    const updateSuggestion = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback((eventName)=>{
        if (setSuggestion) setSuggestion(suggestion, eventName);
    }, [
        setSuggestion,
        suggestion
    ]);
    const onFocus = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback(()=>{
        updateSuggestion('focus');
        suggestion.onSuggestionFocused();
    }, [
        updateSuggestion,
        suggestion
    ]);
    const onMouseMove = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback(()=>{
        updateSuggestion('mousemove');
    }, [
        updateSuggestion
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // If the item is highlighted and not hovered, scroll it into view
        if (highlighted && listItemRef.current && !listItemRef.current.matches(':hover')) $99dd760c8cf82d71$var$ensureElementIsVisibleInScrollContainer(listItemRef.current);
    }, [
        listItemRef,
        highlighted
    ]);
    const statusLozengeText = (0, $XHGTv.getBooleanFF)('platform.gravity.enable-the-support-for-status-labels-for-editor-ai-suggestions_em3y4') && suggestion.statusLozengeType && $99dd760c8cf82d71$var$statusLozengeMessages[suggestion.statusLozengeType] ? formatMessage($99dd760c8cf82d71$var$statusLozengeMessages[suggestion.statusLozengeType]) : null;
    return (0, $byn9U.jsx)("li", {
        css: (0, $kBdjw.suggestionListItemStyles),
        ref: listItemRef
    }, (0, $byn9U.jsx)("button", {
        css: (0, $kBdjw.suggestionButtonStyles),
        type: "button",
        onClick: suggestion.onSelect,
        onMouseMove: onMouseMove,
        "data-testid": customLabel ? `tell-ai` : suggestion.label,
        "data-highlighted": highlighted,
        onFocus: onFocus
    }, suggestion.value !== 'tell-ai' && (0, $byn9U.jsx)("span", {
        css: (0, $kBdjw.suggestionIconStyles)
    }, suggestion.icon || (0, $byn9U.jsx)((0, $izdMb.LogoSvg), {
        className: "default-icon",
        alt: ''
    })), (0, $byn9U.jsx)("span", {
        css: (0, $kBdjw.suggestionLabelStyles)
    }, !customLabel ? suggestion.label : (0, $byn9U.jsx)("span", null, (0, $byn9U.jsx)("span", {
        css: (0, $kBdjw.tellAILabelStyles)
    }, customLabel), " \"", suggestion.label, "\""), suggestion.description && (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, (0, $byn9U.jsx)("br", null), (0, $byn9U.jsx)("span", {
        css: (0, $kBdjw.suggestionDescriptionStyles)
    }, suggestion.description)), statusLozengeText && (0, $byn9U.jsx)("span", {
        css: $99dd760c8cf82d71$var$lozengeStyles
    }, (0, $byn9U.jsx)((0, $ffiyv.default), {
        appearance: "new"
    }, statusLozengeText))), (0, $byn9U.jsx)("span", {
        className: "enterIcon",
        css: (0, $kBdjw.enterIconStyles)
    }, (0, $byn9U.jsx)((0, $9zKyk.default), null))));
};
const $99dd760c8cf82d71$var$lozengeStyles = (0, $byn9U.css)({
    paddingLeft: "var(--ds-space-050, 4px)"
});

});


parcelRegister("gq1nI", function(module, exports) {

$parcel$export(module.exports, "getNextSuggestion", () => $bf4025643511dbf8$export$98f66d46dcfe73ca);
/**
 * This function will return the next suggestion to highlight based on the
 * direction requested.
 *
 * It determines the next suggestion based off the position of the current
 * suggestion in the suggestions list and the direction requested.
 *
 * If the current suggestion is the first item in the list and the requested
 * direction is up, it will wrap around and return the last item. Similarly,
 * requesting down from the last item will wrap return the first item.
 *
 * - If the current suggestion is not found in the suggestions list, it will
 * default to the first suggestion.
 * - If the suggestions list is empty, it will return an empty string.
 * - If the direction is not recognised, it will throw an error.
 *
 * @param suggestions An array of suggestion values to cycle through.
 * @param current Value of the current suggestion highlighted.
 * @param direction Are we moving up or down the list of suggestions?
 * @returns string The next suggestion value to highlight, depending on the direction requested.
 */ const $bf4025643511dbf8$export$98f66d46dcfe73ca = (suggestions, current, direction)=>{
    const currentIndex = suggestions.indexOf(current);
    const { length: length } = suggestions;
    // Got nothing to do
    if (length === 0) return '';
    if (direction === 'ArrowUp') {
        /**
       * Visualisation of what the scenarios are covering
       * - Left = out of bounds negative indexes
       * - Right = out of bounds positive indexes
       * - 0-9 = example of valid suggestion indexes
       *       Array items
       * -----[0123456789]++++++
       * <----DCB------>A-->
               Scenarios
       */ // A: Out of bounds
        if (currentIndex > length - 1) return suggestions[0];
        else if (currentIndex > 0) return suggestions[currentIndex - 1];
        else if (currentIndex === 0) return suggestions[length - 1];
        else return suggestions[0];
    } else if (direction === 'ArrowDown') {
        /**
       * Visualisation of what the scenarios are covering
       * - Left = out of bounds negative indexes
       * - Right = out of bounds positive indexes
       * - 0-9 = example of valid suggestion indexes
       *       Array items
       * -----[0123456789]++++++
       * <----BC------->A-->
               Scenarios
       */ // A: Last item or out of bounds
        if (currentIndex >= length - 1) return suggestions[0];
        else if (currentIndex < 0) return suggestions[0];
        else if (currentIndex < length - 1) return suggestions[currentIndex + 1];
    } else throw new Error('Unknown direction');
    return '';
};

});

parcelRegister("8QGgC", function(module, exports) {

$parcel$export(module.exports, "RovoLogo", () => $6713f7659dad51c0$export$a0f6cb8061290bbb);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $6713f7659dad51c0$var$CustomGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", (0, $kU09D.default)({
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.8859 4.24256C12.3462 3.92351 11.6816 3.91921 11.1385 4.22964C11.1307 4.23541 11.1226 4.24083 11.1141 4.24585L11.114 4.2459L11.1129 4.24659C10.7631 4.45372 10.4987 4.77394 10.3536 5.14702C10.2734 5.35552 10.2305 5.58075 10.2305 5.81255V8.20867L13.1599 9.94087L13.1601 9.94098C13.8796 10.3649 14.3207 11.1485 14.3207 11.9983L14.3207 18.1841C14.3207 18.4616 14.2732 18.7325 14.1841 18.9861L18.1141 16.6613L18.1145 16.661C18.6633 16.3377 19 15.7403 19 15.0912V8.90544C19 8.25896 18.6614 7.6589 18.1142 7.33545L18.1141 7.33541L12.8859 4.24256Z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.7695 18.1875C13.7695 18.4196 13.7265 18.645 13.6461 18.8537C13.5008 19.2269 13.2361 19.5472 12.8859 19.7542L12.8859 19.7542C12.8774 19.7592 12.8693 19.7646 12.8615 19.7704C12.3184 20.0808 11.6538 20.0765 11.1141 19.7575L11.114 19.7575L5.88586 16.6646L5.88579 16.6646C5.33861 16.3411 5 15.7411 5 15.0946L5 8.90882C5 8.25978 5.33663 7.66233 5.88543 7.33904L9.81585 5.01392C9.72678 5.26758 9.67926 5.53842 9.67926 5.81593V12.0017C9.67926 12.8514 10.1203 13.635 10.8397 14.059L10.8401 14.0592L13.7695 15.7914V18.1875Z",
        fill: "currentColor"
    }));
const $6713f7659dad51c0$export$a0f6cb8061290bbb = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), (0, $kU09D.default)({
        glyph: $6713f7659dad51c0$var$CustomGlyph,
        primaryColor: "var(--ds-icon-brand, #0C66E4)"
    }, props));

});


parcelRegister("j0bEH", function(module, exports) {

$parcel$export(module.exports, "createAgentConfigItem", () => $dd570ef2f6925836$export$23164faf8d4f39a5);
// import React from 'react';

var $EZ9eX = parcelRequire("EZ9eX");

var $ce6Jg = parcelRequire("ce6Jg");

var $vQfEF = parcelRequire("vQfEF");

var $6mnRu = parcelRequire("6mnRu");
const $dd570ef2f6925836$export$23164faf8d4f39a5 = (selectionType, agent)=>{
    return (0, $EZ9eX.createEditorPluginAIConfigItemMarkdown)({
        title: ()=>agent.name,
        description: ()=>agent.description || 'No description',
        selectionType: selectionType,
        agent: agent,
        // icon: () => (
        //   <AgentIcon
        //     size="small"
        //     agent={{ name: agent.name, named_id: agent.namedId }}
        //   />
        // ),
        getInitialContext: ({ editorView: editorView, positions: positions, intl: intl, updateIdMap: updateIdMap })=>{
            const selection = (0, $6mnRu.sliceOrNodeToMarkdown)({
                slice: editorView.state.doc.slice(positions[0], positions[1]),
                intl: intl,
                editorView: editorView,
                convertTo: 'markdown-plus',
                updateIdMap: updateIdMap,
                selectionType: selectionType
            });
            const document = (0, $6mnRu.sliceOrNodeToMarkdown)({
                node: editorView.state.doc,
                intl: intl,
                editorView: editorView,
                convertTo: 'markdown-plus',
                updateIdMap: updateIdMap,
                selectionType: selectionType
            });
            return {
                selection: selection.markdown,
                document: document.markdown,
                userLocale: intl.locale,
                intentSchemaId: 'DISABLED'
            };
        },
        triggerPromptRequest ({ initialContext: initialContext, editorSchema: editorSchema, promptInput: promptInput, promptInputADF: promptInputADF }) {
            return (0, $ce6Jg.rovoChatWithAgent)({
                agent: agent,
                customPrompt: promptInput || '',
                customPromptADF: promptInputADF ? JSON.parse(promptInputADF) : undefined,
                fullDocument: initialContext.document,
                currentSelection: (0, $EZ9eX.isInitialContextSelectionRange)(initialContext) ? initialContext.selection : ''
            });
        },
        promptLabel: ()=>agent.name,
        promptHint: ()=>'Tell the Agent to write anything or choose from below',
        // promptConversationStarters: (kickoffAiExperience, updateTextInput, updateADFInput) => input => {
        //     if (input.length > 0) {
        //       return [];
        //     }
        //     return (agent.conversation_starters || []).map((cs, idx) => ({
        //       label: cs,
        //       value: `conversation-starter-${idx}`,
        //       onSelect: () => {
        //         const csAdf = JSON.stringify({
        //           version: 1,
        //           type: 'doc',
        //           content: [
        //             {
        //               type: 'paragraph',
        //               content: [
        //                 {
        //                   type: 'text',
        //                   text: cs,
        //                 },
        //               ],
        //             },
        //           ],
        //         });
        //         updateTextInput(cs);
        //         updateADFInput(csAdf);
        //         kickoffAiExperience({
        //           configItem,
        //           userInput: cs,
        //           userADFInput: csAdf,
        //         });
        //       },
        //       onSuggestionFocused: () => { },
        //     }));
        //   },
        isVisible: ()=>true,
        getBackendModel: ()=>'assistance-service',
        statusLozengeType: 'beta',
        disableInterrogation: ()=>true,
        actions: selectionType === 'empty' ? [
            (0, $vQfEF.createInsertAtTop)({
                appearance: 'secondary'
            }),
            (0, $vQfEF.createInsertAtCurrentPosition)({
                appearance: 'primary'
            })
        ] : [
            (0, $vQfEF.createReplace)({
                appearance: 'primary'
            }),
            (0, $vQfEF.createInsertBelow)({
                appearance: 'secondary'
            })
        ]
    });
};

});
parcelRegister("ce6Jg", function(module, exports) {

$parcel$export(module.exports, "rovoChatWithAgent", () => $8e6c031e86cc4ea1$export$b37580d695bdbc25);
// import type { Schema as PMSchema } from '@atlaskit/editor-prosemirror/model';

var $9LezI = parcelRequire("9LezI");

var $g6Vmo = parcelRequire("g6Vmo");

var $8ae7G = parcelRequire("8ae7G");
const $8e6c031e86cc4ea1$export$b37580d695bdbc25 = (input)=>{
    const { agent: agent } = input;
    return function promptRequest(requestOptions) {
        var _requestOptions$getCh, _requestOptions$getCh2, _requestOptions$getCh3;
        const promptADF = input.customPromptADF || {
            version: 1,
            type: 'doc',
            content: [
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: input.customPrompt
                        }
                    ]
                }
            ]
        };
        // Just the main URL, remove the extra stuff like hashes/query params
        const browserUrl = (_requestOptions$getCh = (_requestOptions$getCh2 = requestOptions.getChannelVariables) === null || _requestOptions$getCh2 === void 0 ? void 0 : (_requestOptions$getCh3 = _requestOptions$getCh2.call(requestOptions, 'rovo-agent')) === null || _requestOptions$getCh3 === void 0 ? void 0 : _requestOptions$getCh3.contentURL) !== null && _requestOptions$getCh !== void 0 ? _requestOptions$getCh : window.location.origin + window.location.pathname;
        const streamingResponseGenerator = (0, $9LezI.startStreamingResponse)({
            endpoint: (0, $8ae7G.convoAIStatefulApiURL),
            isStatefulEndpoint: true,
            experienceId: 'ai-mate',
            agentNameId: agent.namedId,
            getChannelVariables: requestOptions.getChannelVariables,
            // For payload spec, see https://hello.atlassian.net/wiki/spaces/CONVAI/pages/3783312372/Actions+Contract+for+Confluence+Content+Suggestion
            payload: JSON.stringify({
                content: promptADF,
                // Is this meant to be `agent_input_context` in the future?
                context: {
                    browser_url: browserUrl,
                    editor: {
                        document: {
                            type: 'text/markdown',
                            content: input.fullDocument
                        },
                        selection: {
                            type: 'text/markdown',
                            content: input.currentSelection
                        }
                    }
                },
                recipient_agent_named_id: agent.namedId,
                mimeType: 'text/adf',
                store_message: true
            }),
            // Hardcoded for now?
            // getFetchCustomHeaders: () => {
            // 	return {
            // 		"x-issynthetic-traffic": "false",
            // 	};
            // },
            ...requestOptions
        });
        return (0, $g6Vmo.streamResponsePreview)({
            streamingResponseGenerator: streamingResponseGenerator,
            isConvoAI: true
        });
    };
};

});
parcelRegister("9LezI", function(module, exports) {

$parcel$export(module.exports, "startStreamingResponse", () => $71b3cf2090834196$export$9cc8017e39eb96a2);

var $aHQJS = parcelRequire("aHQJS");

var $jwqez = parcelRequire("jwqez");

var $jGqUd = parcelRequire("jGqUd");
const $71b3cf2090834196$export$46d5228a079b1d3 = (product)=>{
    return {
        'X-Product': (0, $jGqUd.mapToConvoAIProductName)(product)
    };
};
const $71b3cf2090834196$export$d465dc01cd90521 = (context)=>{
    const { contentURL: contentURL, agentId: agentId, cloudId: cloudId, userId: userId } = context;
    const input = `${contentURL}-${agentId}-${cloudId}-${userId}`;
    // Rifat's voodoo to replicate Java's hashing implementation
    // @see https://atlassian.slack.com/archives/C075C6PPJ01/p1716960655383639?thread_ts=1716957128.598589&cid=C075C6PPJ01
    const md5Bytes = (0, (/*@__PURE__*/$parcel$interopDefault($aHQJS))).createHash('md5').update(input).digest();
    md5Bytes[6] &= 0x0f; // clear version
    md5Bytes[6] |= 0x30; // set to version 3
    md5Bytes[8] &= 0x3f; // clear variant
    md5Bytes[8] |= 0x80; // set to IETF variant
    return (0, (/*@__PURE__*/$parcel$interopDefault($jwqez)))(md5Bytes.toString('hex'));
};
async function* $71b3cf2090834196$export$9cc8017e39eb96a2({ endpoint: endpoint, payload: payload, abortController: abortController, getFetchCustomHeaders: getFetchCustomHeaders, product: product, isStatefulEndpoint: // These are for convoai/assistance-service
isStatefulEndpoint = false, experienceId: experienceId = 'editor', agentNameId: agentNameId = 'editor_agent', getChannelVariables: getChannelVariables }) {
    try {
        // create channelId if needed
        let channelId;
        let actualEndpoint = endpoint;
        if (isStatefulEndpoint) {
            if (!getChannelVariables) // This shouldn't happen as it is checked early on
            throw new Error('getChannelVariables is required for stateful endpoints');
            const channelVariables = getChannelVariables('rovo-agent');
            if (!channelVariables) throw new Error('getChannelVariables returned null for rovo-agent context');
            channelId = $71b3cf2090834196$export$d465dc01cd90521({
                ...channelVariables,
                agentId: agentNameId
            });
            actualEndpoint = `${endpoint}/${channelId}/message/stream`;
        // TODO: clean this up + move creation of channelID earlier into UX
        // For some reason this blocks the stream
        // yield {
        // 	state: 'created-channel',
        // 	data: { channelId },
        // };
        }
        const fetchInit = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'X-Experience-Id': experienceId,
                ...$71b3cf2090834196$export$46d5228a079b1d3(product)
            },
            // When we move to a single api endpoint we will be able to collapse
            // the current logic spread across;
            // - api-fetch
            // - generate, transform, summarise
            // - mapResponseForSingleKeyToMarkdown
            // - and various config items
            // In the meantime -- have opted into this stringify -> parse -> stringify
            // to keep the shapes of startStreamingResponse and startSingleResponse aligned.
            body: payload,
            credentials: 'include',
            signal: abortController.signal,
            mode: 'cors'
        };
        const fetchCustomHeaders = (getFetchCustomHeaders === null || getFetchCustomHeaders === void 0 ? void 0 : getFetchCustomHeaders(endpoint, fetchInit)) || {};
        const response = await fetch(actualEndpoint, {
            ...fetchInit,
            headers: {
                ...fetchInit.headers,
                ...fetchCustomHeaders
            }
        });
        if (!response.ok) {
            // For non 200 status codes
            // https://atlassian.slack.com/archives/C055QF79V7W/p1684881764142449?thread_ts=1684802293.771169&cid=C055QF79V7W
            if (response.status === 400) try {
                // TODO PREEAP
                // At the time of writing, the api returns the following:
                // { "error": { "key": "ERROR_KEY", ... } }
                // See
                // - https://hello.atlassian.net/wiki/spaces/CA3/pages/2485466879/Generative+AI+API+Specs#Error-Codes
                // - https://hello.atlassian.net/wiki/spaces/CA3/pages/2485466879/Generative+AI+API+Specs#Error-Codes.1
                // - https://hello.atlassian.net/wiki/spaces/CA3/pages/2485466879/Generative+AI+API+Specs#Error-codes
                // for details
                // Errors with special handling
                const knownErrors = [
                    // We have soft alignment with the BE that for inputs that are not suitable
                    // for prompts -- we want to rely on openai providing a suitable message for
                    // the user. And not have manually maintained guards/user feedback messages.
                    // https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3573548013/Introducing+AI+Dev+Documentation+TODO+AIFOLLOWUP+audit
                    'INPUT_TOO_SHORT_TO_SUMMARIZE',
                    'INPUT_TOO_SHORT_TO_PROCESS',
                    'INPUT_EXCEEDS_TOKEN_LIMIT'
                ];
                const { error: error } = await response.json();
                if (error) {
                    if (typeof error === 'object' && 'key' in error && knownErrors.includes(error.key)) return yield {
                        state: 'failed',
                        reason: 'backend-input-guard',
                        guard: error.key,
                        statusCode: response.status
                    };
                    return yield {
                        state: 'failed',
                        reason: 'backend',
                        error: 'Unhandled error response received',
                        statusCode: response.status
                    };
                }
            } catch (backendError) {
                return yield {
                    state: 'failed',
                    reason: 'backend',
                    error: backendError,
                    statusCode: response.status
                };
            }
            // TODO PREEAP -- ensure our handling matches eventual backend implementation
            // https://hello.atlassian.net/browse/CCSMART-371
            // TODO POSTEAP -- revisit guard handling to have remove backend guards
            // and instead have the backend return an openai response describing why
            // the request was unable to be handled. (Potentially with a flag indicating
            // the response was unable to be handled for some custom FE treatment/handling).
            if (response.status === 429) {
                // TODO POSTEAP
                // https://product-fabric.atlassian.net/browse/ED-18777
                // The BE are unable to add the header due to constraints with the service proxy
                // There is a ticket to add this via feature request
                // https://sdog.jira-dev.com/jira/servicedesk/projects/SPHELP/queues/custom/262/SPHELP-93
                // For now we are just hard coding the value
                let retryAfter = response.headers.get('Retry-After');
                if (!retryAfter) retryAfter = '60';
                return yield {
                    state: 'failed',
                    reason: 'rate-limited',
                    retryAfter: Number(retryAfter),
                    statusCode: response.status
                };
            }
            if (response.status === 451) // This status code is being used to indicate that the request was unable to be handled
            // due to the content not meeting the Acceptable Use Policy.
            return yield {
                state: 'aup-violation',
                statusCode: 451
            };
            return yield {
                state: 'failed',
                reason: 'backend',
                error: `unexpected response status: ${response.status}`,
                statusCode: response.status
            };
        }
        if (!response.body) {
            yield {
                state: 'failed',
                reason: 'network',
                error: 'response.body missing',
                statusCode: response.status
            };
            return;
        }
        try {
            const reader = response.body.getReader();
            const decoder = new TextDecoder('utf-8');
            let buffer = '';
            let done = false;
            while(!done){
                const { value: value, done: doneReading } = await reader.read();
                done = doneReading;
                const chunkValue = decoder.decode(value);
                buffer = buffer + chunkValue;
                // Split the buffer by line breaks
                const lines = buffer.split('\n');
                // Process all complete lines, except for the last one (which might be incomplete)
                while(lines.length > 1){
                    const line = lines.shift();
                    const parsedData = JSON.parse(line);
                    if (parsedData.generatedContent === null) {
                        var _parsedData$error, _parsedData$error2;
                        if (((_parsedData$error = parsedData.error) === null || _parsedData$error === void 0 ? void 0 : _parsedData$error.statusCode) === 429) {
                            yield {
                                state: 'failed',
                                reason: 'rate-limited',
                                retryAfter: 60,
                                statusCode: 429
                            };
                            return;
                        }
                        if (((_parsedData$error2 = parsedData.error) === null || _parsedData$error2 === void 0 ? void 0 : _parsedData$error2.key) === 'RESPONSE_TOO_SIMILAR') {
                            yield {
                                state: 'failed',
                                reason: 'response-too-similar',
                                statusCode: 208,
                                data: parsedData
                            };
                            return;
                        }
                    }
                    yield {
                        state: 'loading',
                        data: parsedData
                    };
                }
                // Keep the last (potentially incomplete) line in the buffer
                buffer = lines[0];
            }
            yield {
                state: 'loaded-stream'
            };
            return;
        } catch (parsingError) {
            yield {
                state: 'failed',
                reason: 'parsing',
                error: parsingError,
                statusCode: response.status
            };
            return;
        }
    } catch (error) {
        if (error.name === 'AbortError') yield {
            state: 'failed',
            reason: 'aborted',
            error: error,
            statusCode: error.status
        };
        else if (error.cause === 'ConvoAIChannelCreationError') yield {
            state: 'failed',
            reason: 'backend',
            error: error,
            statusCode: error.status
        };
        else yield {
            state: 'failed',
            reason: 'network',
            error: error,
            statusCode: error.status
        };
        return;
    }
}

});
parcelRegister("jwqez", function(module, exports) {

var $aul3P = parcelRequire("aul3P");
var $e3655afcc814640a$require$Buffer = $aul3P.Buffer;
"use strict";

var $7s9Kp = parcelRequire("7s9Kp");

var $33JIm = parcelRequire("33JIm");
module.exports = (hexString)=>{
    const parsedHexString = hexString.replace(new RegExp('^0x'), '');
    if (!$33JIm(parsedHexString)) throw new Error('hexString is not valid hexadecimal number', 0);
    //Allocate 16 bytes for the uuid bytes representation
    let hexBuffer = $e3655afcc814640a$require$Buffer.from(parsedHexString, 'hex');
    //Parse uuid string representation and send bytes into buffer
    const uuidResultBuffer = $7s9Kp.unparse(hexBuffer);
    //Create uuid utf8 string representation
    return uuidResultBuffer.toString('utf8');
};

});
parcelRegister("7s9Kp", function(module, exports) {
'use strict';
// Maps for number <-> hex string conversion
var $56d2b5951918e5cc$var$_byteToHex = [];
var $56d2b5951918e5cc$var$_hexToByte = {};
for(var $56d2b5951918e5cc$var$i = 0; $56d2b5951918e5cc$var$i < 256; $56d2b5951918e5cc$var$i++){
    $56d2b5951918e5cc$var$_byteToHex[$56d2b5951918e5cc$var$i] = ($56d2b5951918e5cc$var$i + 0x100).toString(16).substr(1);
    $56d2b5951918e5cc$var$_hexToByte[$56d2b5951918e5cc$var$_byteToHex[$56d2b5951918e5cc$var$i]] = $56d2b5951918e5cc$var$i;
}
// **`parse()` - Parse a UUID into it's component bytes**
function $56d2b5951918e5cc$var$parse(s, buf, offset) {
    var i = buf && offset || 0;
    var ii = 0;
    buf = buf || [];
    s.toLowerCase().replace(/[0-9a-f]{2}/g, function(oct) {
        if (ii < 16) buf[i + ii++] = $56d2b5951918e5cc$var$_hexToByte[oct];
    });
    // Zero out remaining bytes if string was short
    while(ii < 16)buf[i + ii++] = 0;
    return buf;
}
// **`unparse()` - Convert UUID byte array (ala parse()) into a string**
function $56d2b5951918e5cc$var$unparse(buf, offset) {
    var i = offset || 0;
    var bth = $56d2b5951918e5cc$var$_byteToHex;
    return bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + '-' + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]] + bth[buf[i++]];
}
module.exports = {
    parse: $56d2b5951918e5cc$var$parse,
    unparse: $56d2b5951918e5cc$var$unparse
};

});

parcelRegister("33JIm", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $23a51cdbedfcd906$var$isHexadecimal;

var $bG6ZT = parcelRequire("bG6ZT");
var $23a51cdbedfcd906$var$_assertString2 = $23a51cdbedfcd906$var$_interopRequireDefault($bG6ZT);
function $23a51cdbedfcd906$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $23a51cdbedfcd906$var$hexadecimal = /^[0-9A-F]+$/i;
function $23a51cdbedfcd906$var$isHexadecimal(str) {
    (0, $23a51cdbedfcd906$var$_assertString2.default)(str);
    return $23a51cdbedfcd906$var$hexadecimal.test(str);
}
module.exports = module.exports['default'];

});
parcelRegister("bG6ZT", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0231b1bbcf16d21a$var$assertString;
function $0231b1bbcf16d21a$var$assertString(input) {
    var isString = typeof input === 'string' || input instanceof String;
    if (!isString) throw new TypeError('This library (validator.js) validates strings only');
}
module.exports = module.exports['default'];

});



parcelRegister("jGqUd", function(module, exports) {

$parcel$export(module.exports, "mapToConvoAIProductName", () => $e546cf77120c107c$export$6d6f1fb6f25ca9c);
// Supported products in ConvoAI: https://bitbucket.org/atlassian/assistance-service/src/858045b3f075c307787f393c34807eec5a04260b/src/schema/base.py#lines-21
const $e546cf77120c107c$export$6d6f1fb6f25ca9c = (product)=>{
    switch(product){
        case 'CONFLUENCE':
            return 'confluence';
        case 'JSW':
            return 'jira-software';
        case 'JWM':
            return 'jira-core';
        case 'JSM':
            return 'jsm';
        case 'JPD':
            return 'jpd';
        case 'ATLAS':
            return 'atlas';
        case 'JIRA_FAMILY':
            return 'jira';
        default:
            return 'unknown';
    }
};

});


parcelRegister("g6Vmo", function(module, exports) {

$parcel$export(module.exports, "streamResponsePreview", () => $bba9b36b0b2b5380$export$d1c9051d0b6a8fff);
function $bba9b36b0b2b5380$var$parsedHasExpectedKey(key, parsed) {
    if (typeof parsed !== 'object' || parsed === null || !(key in parsed)) return false;
    return true;
}
async function* $bba9b36b0b2b5380$export$d1c9051d0b6a8fff({ streamingResponseGenerator: streamingResponseGenerator, isConvoAI: isConvoAI, streamingListener: streamingListener }) {
    let partialMeta = {
        inputOutputDiffRatio: ''
    };
    let partial = {
        type: 'markdown',
        content: '',
        meta: partialMeta
    };
    for await (const yieldedResponse of streamingResponseGenerator){
        if (yieldedResponse.state === 'loaded-stream') return yield {
            state: 'loaded',
            data: partial
        };
        if (yieldedResponse.state === 'created-channel') return yield {
            state: 'created-channel',
            data: yieldedResponse.data
        };
        if (yieldedResponse.state === 'loading' || yieldedResponse.state === 'loaded') {
            if ($bba9b36b0b2b5380$var$parsedHasExpectedKey('generatedContent', yieldedResponse.data)) {
                partial = {
                    type: 'markdown',
                    content: partial.content + yieldedResponse.data['generatedContent'],
                    meta: $bba9b36b0b2b5380$var$parsedHasExpectedKey('meta', yieldedResponse.data) && $bba9b36b0b2b5380$var$parsedHasExpectedKey('inputOutputDiffRatio', yieldedResponse.data.meta) ? {
                        inputOutputDiffRatio: yieldedResponse.data['meta']['inputOutputDiffRatio'],
                        loadingStatus: ''
                    } : partial.meta
                };
                if (streamingListener) streamingListener(partial.content, yieldedResponse.state);
                yield {
                    state: yieldedResponse.state,
                    data: partial
                };
            } else if (isConvoAI) {
                if ($bba9b36b0b2b5380$var$parsedHasExpectedKey('type', yieldedResponse.data)) {
                    if (yieldedResponse.data.type === 'TRACE') {
                        const loadingStatus = $bba9b36b0b2b5380$var$parsedHasExpectedKey('message', yieldedResponse.data) && $bba9b36b0b2b5380$var$parsedHasExpectedKey('message_template', yieldedResponse.data.message) ? yieldedResponse.data.message.message_template : '';
                        partial = {
                            ...partial,
                            type: 'markdown',
                            content: partial.content,
                            meta: {
                                inputOutputDiffRatio: '',
                                loadingStatus: loadingStatus
                            }
                        };
                    }
                    if (yieldedResponse.data.type === 'ANSWER_PART') partial = {
                        ...partial,
                        type: 'markdown',
                        content: partial.content + yieldedResponse.data.message.content,
                        meta: {
                            inputOutputDiffRatio: '',
                            loadingStatus: ''
                        }
                    };
                    if (yieldedResponse.data.type === 'FINAL_RESPONSE') {
                        var _message$message2, _message$message2$mes;
                        const { message: message } = yieldedResponse.data;
                        if ($bba9b36b0b2b5380$var$parsedHasExpectedKey('message_metadata', message.message) && $bba9b36b0b2b5380$var$parsedHasExpectedKey('response_too_similar', message.message.message_metadata) && message.message.message_metadata.response_too_similar) {
                            var _message$message, _message$message$mess;
                            return yield {
                                state: 'failed',
                                statusCode: message.status_code,
                                reason: 'response-too-similar',
                                data: {
                                    meta: {
                                        inputOutputDiffRatio: ((_message$message = message.message) === null || _message$message === void 0 ? void 0 : (_message$message$mess = _message$message.message_metadata) === null || _message$message$mess === void 0 ? void 0 : _message$message$mess.diff_ratio) || ''
                                    }
                                }
                            };
                        }
                        partial = {
                            ...partial,
                            type: 'markdown',
                            content: message.message.content,
                            meta: {
                                inputOutputDiffRatio: ((_message$message2 = message.message) === null || _message$message2 === void 0 ? void 0 : (_message$message2$mes = _message$message2.message_metadata) === null || _message$message2$mes === void 0 ? void 0 : _message$message2$mes.diff_ratio) || '',
                                loadingStatus: ''
                            }
                        };
                    }
                    if (yieldedResponse.data.type === 'ERROR') {
                        let statusCode;
                        let guard;
                        let error;
                        let retryAfter;
                        if ($bba9b36b0b2b5380$var$parsedHasExpectedKey('message', yieldedResponse.data)) {
                            // Get status code
                            if ($bba9b36b0b2b5380$var$parsedHasExpectedKey('status_code', yieldedResponse.data.message) && typeof yieldedResponse.data.message.status_code === 'number') statusCode = yieldedResponse.data.message.status_code;
                            // Get reason
                            if ($bba9b36b0b2b5380$var$parsedHasExpectedKey('message_template', yieldedResponse.data.message)) guard = yieldedResponse.data.message.message_template;
                            // Get error
                            if ($bba9b36b0b2b5380$var$parsedHasExpectedKey('content', yieldedResponse.data.message)) error = yieldedResponse.data.message.content;
                            // Get retryAfter
                            if ($bba9b36b0b2b5380$var$parsedHasExpectedKey('headers', yieldedResponse.data) && $bba9b36b0b2b5380$var$parsedHasExpectedKey('Retry-After', yieldedResponse.data.headers)) retryAfter = Number(yieldedResponse.data.headers['Retry-After']);
                        }
                        if (guard) {
                            if (statusCode === 429) return yield {
                                state: 'failed',
                                apiName: 'assistance-service',
                                statusCode: statusCode,
                                guard: guard,
                                error: error,
                                retryAfter: retryAfter
                            };
                            return yield {
                                state: 'failed',
                                apiName: 'assistance-service',
                                statusCode: statusCode,
                                guard: guard,
                                error: error
                            };
                        }
                        return yield {
                            state: 'failed',
                            apiName: 'assistance-service',
                            statusCode: statusCode,
                            guard: 'UNHANDLED_ERROR',
                            error: error
                        };
                    }
                    yield {
                        state: yieldedResponse.state,
                        data: partial
                    };
                } else // If there are any unexpected loading responses,
                // We should return the current data
                yield {
                    state: yieldedResponse.state,
                    data: partial
                };
            } else return yield {
                state: 'failed',
                reason: 'parsing'
            };
        } else {
            if (yieldedResponse.state === 'failed' && yieldedResponse.reason !== 'response-too-similar' || yieldedResponse.state === 'aup-violation') return yield yieldedResponse;
            else {
                let responseTooSimilarData = {
                    meta: $bba9b36b0b2b5380$var$parsedHasExpectedKey('meta', yieldedResponse.data) && $bba9b36b0b2b5380$var$parsedHasExpectedKey('inputOutputDiffRatio', yieldedResponse.data.meta) ? {
                        inputOutputDiffRatio: yieldedResponse.data['meta']['inputOutputDiffRatio']
                    } : partialMeta
                };
                return yield {
                    state: 'failed',
                    statusCode: 208,
                    reason: 'response-too-similar',
                    data: responseTooSimilarData
                };
            }
        }
    }
}

});

parcelRegister("8ae7G", function(module, exports) {

$parcel$export(module.exports, "_getFetchCustomHeaders", () => $5f1a366a9a8f449e$export$bd1a8b310b130c9d);
$parcel$export(module.exports, "deriveProactiveAIConfig", () => $5f1a366a9a8f449e$export$57fcb528e9e98e56);
$parcel$export(module.exports, "convoAIStatelessApiURL", () => $5f1a366a9a8f449e$export$4388fb67ca0987b2);
$parcel$export(module.exports, "convoAIStatefulApiURL", () => $5f1a366a9a8f449e$export$4d6359d758c27a3e);
$parcel$export(module.exports, "getBackendModelExperiment", () => $5f1a366a9a8f449e$export$27b98fe13582296e);

var $3Ycnu = parcelRequire("3Ycnu");

var $XHGTv = parcelRequire("XHGTv");
function $5f1a366a9a8f449e$export$bd1a8b310b130c9d() {
    const currentHost = window.location.origin;
    switch(true){
        case currentHost === 'https://statlas.prod.atl-paas.net':
            // Update this to add custom headers when run in atlaskit branch deploys
            // ie.
            // {
            //   'X-CloudID': 'Magic string'
            // }
            return {};
        default:
            return {};
    }
}
function $5f1a366a9a8f449e$export$9167f99f9be83b24() {
    const currentHost = typeof window.location !== 'undefined' ? window.location.origin : '';
    if ([
        'http://localhost',
        'https://atlaskit-website-staging.stg-east.frontend.public.atl-paas.net',
        'https://statlas.prod.atl-paas.net',
        'https://atlaskit.atlassian.com'
    ].some((host)=>currentHost.startsWith(host))) return 'https://pug.jira-dev.com';
    return currentHost;
}
function $5f1a366a9a8f449e$export$fb4af722000bf4fd() {
    return `${$5f1a366a9a8f449e$export$9167f99f9be83b24()}/gateway/api/editor-ai/v1/generative/ai`;
}
function $5f1a366a9a8f449e$export$2f9e5a704d3d0517() {
    if ((0, $XHGTv.getBooleanFF)('platform.editor.ai-proactive-ai-api-url_k6yy7')) /**
     * Tech Spec for the final endpoint documented at
     * https://hello.atlassian.net/wiki/spaces/CA3/pages/3611700626/BE+Techspec+API+spec+Spelling+and+Grammar#API-spec
     */ return `${$5f1a366a9a8f449e$export$9167f99f9be83b24()}/gateway/api/v1/grammar`;
    else /**
     * Currently we are using the MVP endpoint
     * Spec is documented at https://hello.atlassian.net/wiki/spaces/CA3/pages/3716942544/Tech+Spec+POC+Sagemaker+Endpoint+for+Spelling+Grammar
     */ return `${$5f1a366a9a8f449e$export$9167f99f9be83b24()}/gateway/api/experimental/cc-smarts/sagemaker`;
}
const $5f1a366a9a8f449e$var$DEFAULT_CURRENT_CHUNKS_DEBOUNCED_TIME = 4000;
const $5f1a366a9a8f449e$var$DEFAULT_CURRENT_CHUNKS_DEBOUNCED_WAIT_TIME = 30000;
const $5f1a366a9a8f449e$var$DEFAULT_NON_CURRENT_CHUNKS_THROTTLED_TIME = 2000;
function $5f1a366a9a8f449e$export$57fcb528e9e98e56(overrides) {
    return {
        enabled: false,
        apiUrl: $5f1a366a9a8f449e$export$2f9e5a704d3d0517(),
        timings: {
            currentChunks: $5f1a366a9a8f449e$var$DEFAULT_CURRENT_CHUNKS_DEBOUNCED_TIME,
            currentChunksMaxWait: $5f1a366a9a8f449e$var$DEFAULT_CURRENT_CHUNKS_DEBOUNCED_WAIT_TIME,
            nonCurrentChunks: $5f1a366a9a8f449e$var$DEFAULT_NON_CURRENT_CHUNKS_THROTTLED_TIME
        },
        ...overrides
    };
}
const $5f1a366a9a8f449e$export$4388fb67ca0987b2 = `${$5f1a366a9a8f449e$export$9167f99f9be83b24()}/gateway/api/assist/chat/v1/invoke_agent/stream`;
const $5f1a366a9a8f449e$export$4d6359d758c27a3e = `${$5f1a366a9a8f449e$export$9167f99f9be83b24()}/gateway/api/assist/chat/v1/channel`; // + `/${channelID}/message/stream` at the end;
function $5f1a366a9a8f449e$export$4e62c701997796c1(value) {
    return value !== undefined;
}
function $5f1a366a9a8f449e$export$27b98fe13582296e() {
    const isGPT4Enabled = (0, $3Ycnu.isExperimentEnabled)('editor_ai_-_gpt4_experiment');
    const isEinsteinCohort = (0, $3Ycnu.getExperimentCohort)('editor_ai_-_gpt4_experiment') === 'einstein';
    if (isGPT4Enabled && isEinsteinCohort) return 'einstein';
    return 'xp-gen-ai';
}

});


parcelRegister("vQfEF", function(module, exports) {

$parcel$export(module.exports, "createInsertAtTop", () => $05fb6d6c967c8199$export$9e309baaf0e9d41b);
$parcel$export(module.exports, "createInsertBelow", () => $05fb6d6c967c8199$export$2a99e23257616a3);
$parcel$export(module.exports, "createInsertAtCurrentPosition", () => $05fb6d6c967c8199$export$6641dbc1b651cf28);
$parcel$export(module.exports, "createReplace", () => $05fb6d6c967c8199$export$ab7194c13d7567bc);
$parcel$export(module.exports, "createReplaceExistingConfluenceTitle", () => $05fb6d6c967c8199$export$bac6a2ed25caf91c);

var $7dkLM = parcelRequire("7dkLM");

var $2zbl1 = parcelRequire("2zbl1");

var $aFbB0 = parcelRequire("aFbB0");

var $5x6zB = parcelRequire("5x6zB");

var $CQIxF = parcelRequire("CQIxF");

var $4nc7v = parcelRequire("4nc7v");
function $05fb6d6c967c8199$var$isSelectionAtParagraphStart($pos) {
    const node = $pos.parent;
    return !!node && (node.type.name === 'paragraph' || node.type.name === 'heading') && !$pos.parentOffset;
}
function $05fb6d6c967c8199$var$isFragmentSingleParagraph(fragment) {
    return fragment.childCount === 1 && fragment.firstChild.type.name === 'paragraph';
}
function $05fb6d6c967c8199$var$isSelectionInTaskOrDecisionNode($pos) {
    const node = $pos.parent;
    return !!node && (node.type.name === 'decisionList' || node.type.name === 'decisionItem' || node.type.name === 'taskList' || node.type.name === 'taskItem');
}
const $05fb6d6c967c8199$export$9e309baaf0e9d41b = ({ appearance: appearance })=>({ formatMessage: formatMessage })=>({
            title: formatMessage((0, $5x6zB.messages).insertAtTop),
            analyticsTitle: (0, $5x6zB.messages).insertAtTop.defaultMessage,
            appearance: appearance,
            run ({ editorView: editorView, pmFragment: pmFragment }) {
                const transaction = editorView.state.tr;
                const slice = new (0, $7dkLM.Slice)(pmFragment, 0, 0);
                transaction.replace(0, 0, slice);
                (0, $CQIxF.beforeDispatchAITransaction)(transaction);
                editorView.dispatch(transaction);
            }
        });
const $05fb6d6c967c8199$export$2a99e23257616a3 = ({ appearance: appearance })=>({ formatMessage: formatMessage })=>({
            title: formatMessage((0, $5x6zB.messages).insertBelow),
            appearance: appearance,
            analyticsTitle: (0, $5x6zB.messages).insertBelow.defaultMessage,
            run ({ editorView: editorView, positions: positions, pmFragment: pmFragment }) {
                const transaction = editorView.state.tr;
                const insertPos = editorView.state.doc.resolve(positions[1]).after();
                (0, $2zbl1.safeInsert)(pmFragment, insertPos)(transaction);
                (0, $CQIxF.beforeDispatchAITransaction)(transaction);
                editorView.dispatch(transaction);
            }
        });
const $05fb6d6c967c8199$export$6641dbc1b651cf28 = ({ appearance: appearance })=>({ formatMessage: formatMessage })=>({
            title: formatMessage((0, $5x6zB.messages).insert),
            analyticsTitle: (0, $5x6zB.messages).insert.defaultMessage,
            appearance: appearance,
            run ({ editorView: editorView, positions: positions, pmFragment: pmFragment }) {
                const { state: state } = editorView;
                const transaction = state.tr;
                const pos = positions[0];
                const $pos = state.doc.resolve(pos);
                const isParagraphStart = $05fb6d6c967c8199$var$isSelectionAtParagraphStart($pos);
                // if selection is at the beginning of paragraph,
                // insert before the cursor so that it inserts without an extra new line
                const insertPos = isParagraphStart ? pos - 1 : pos;
                // if selection is inside decision or task node AND pmFragment is a single paragraph
                // strip the paragraph so it can insert inside the decision/task
                let fragmentToInsert = pmFragment;
                if ($05fb6d6c967c8199$var$isSelectionInTaskOrDecisionNode($pos) && $05fb6d6c967c8199$var$isFragmentSingleParagraph(pmFragment)) fragmentToInsert = pmFragment.firstChild.content;
                transaction.insert(insertPos, fragmentToInsert);
                (0, $CQIxF.beforeDispatchAITransaction)(transaction);
                editorView.dispatch(transaction);
            }
        });
function $05fb6d6c967c8199$var$getLastContentDepth({ pmFragment: pmFragment }) {
    let depth = 0;
    let currentNode = pmFragment;
    while(currentNode.firstChild){
        depth++;
        currentNode = currentNode.firstChild;
    }
    return depth;
}
const $05fb6d6c967c8199$export$ab7194c13d7567bc = ({ appearance: appearance })=>({ formatMessage: formatMessage })=>({
            title: formatMessage((0, $5x6zB.messages).replace),
            appearance: appearance,
            analyticsTitle: (0, $5x6zB.messages).replace.defaultMessage,
            run ({ editorView: editorView, positions: positions, pmFragment: pmFragment }) {
                const transaction = editorView.state.tr;
                const endPositionDepth = editorView.state.doc.resolve(positions[1]).depth;
                const lastFragmentDepth = $05fb6d6c967c8199$var$getLastContentDepth({
                    pmFragment: pmFragment
                });
                const sliceOpenEnd = Math.min(endPositionDepth, lastFragmentDepth);
                const slice = new (0, $7dkLM.Slice)(pmFragment, 1, sliceOpenEnd);
                // We check if the positions are the same if so we replace the whole document
                // This is a quick spike so real implementation might need to be different
                // You might need to create a new replace action
                if (positions[0] === positions[1]) transaction.replaceRange(0, editorView.state.doc.content.size, slice);
                else try {
                    transaction.replaceRange(positions[0], positions[1], slice);
                // If you can't replace the range, use safeInsert
                } catch  {
                    (0, $2zbl1.safeInsert)(pmFragment, undefined, true)(transaction);
                    const tr = (0, $aFbB0.addAnalytics)({
                        editorState: editorView.state,
                        tr: editorView.state.tr,
                        payload: {
                            action: 'fallback',
                            actionSubject: 'editorPluginAI',
                            actionSubjectId: 'proseMirrorReplace',
                            eventType: 'operational',
                            attributes: {}
                        }
                    });
                    editorView.dispatch(tr);
                }
                (0, $CQIxF.beforeDispatchAITransaction)(transaction);
                editorView.dispatch(transaction);
            }
        });
const $05fb6d6c967c8199$export$bac6a2ed25caf91c = ({ appearance: appearance })=>({ formatMessage: formatMessage })=>({
            title: formatMessage((0, $5x6zB.messages).replaceTitle),
            analyticsTitle: (0, $5x6zB.messages).replaceTitle.defaultMessage,
            appearance: appearance,
            run ({ pmFragment: pmFragment }) {
                let fragmentToInsert = pmFragment;
                let textContent = '';
                fragmentToInsert.forEach((node)=>{
                    textContent += node.textContent;
                });
                const confluenceTitle = document.querySelector('textarea[data-test-id="editor-title"]');
                if (confluenceTitle) {
                    const event = new CustomEvent((0, $4nc7v.SuggestTitleEvents).ReplaceConfluenceTitle, {
                        detail: {
                            title: textContent
                        }
                    });
                    document.dispatchEvent(event);
                    confluenceTitle.scrollIntoView();
                }
            }
        });

});
parcelRegister("5x6zB", function(module, exports) {

$parcel$export(module.exports, "messages", () => $4075221f8fbd60cf$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $4075221f8fbd60cf$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    insert: {
        id: 'fabric.editor.ai.config.item.action.insert',
        defaultMessage: 'Insert',
        description: 'Inserts the response at the current location'
    },
    insertAtTop: {
        id: 'fabric.editor.ai.config.item.action.insertAtTop',
        defaultMessage: 'Insert at top',
        description: 'Inserts the response at the start of the content'
    },
    insertBelow: {
        id: 'fabric.editor.ai.config.item.action.insertBelow',
        defaultMessage: 'Insert below',
        description: 'Inserts the response below the current location'
    },
    replace: {
        id: 'fabric.editor.ai.config.item.action.replace',
        defaultMessage: 'Replace',
        description: 'Replaces the existing or selected content with the response'
    },
    replaceTitle: {
        id: 'fabric.editor.ai.config.item.action.replaceTitle',
        defaultMessage: 'Replace title',
        description: 'Replaces the existing Confluence document title with the generated title'
    }
});

});

parcelRegister("CQIxF", function(module, exports) {

$parcel$export(module.exports, "beforeDispatchAITransaction", () => $074c714e5cd54d52$export$336eb673e6d24058);

var $kpTIW = parcelRequire("kpTIW");

var $bhF7K = parcelRequire("bhF7K");
function $074c714e5cd54d52$export$336eb673e6d24058(tr) {
    /**
   * DO NOT REMOVE isAiContentTransformation from transaciton meta.
   * Proactive AI S+G rely on isAiContentTransformation meta to
   * 	ignore changes in document made by AI modal.
   * Why ignore it?
   * - Response returned from AI does not require Spelling and Grammer check.
   * - We have assumed that it's already correct from S+G perspective.
   */ tr.setMeta('isAiContentTransformation', true);
    const firstReplaceStep = (0, $bhF7K.findFirstReplaceStep)(tr.steps);
    if (!firstReplaceStep) {
        // eslint-disable-next-line no-console
        console.error('missing transformation step in an AI transaction');
        return tr;
    /**
     * TODO PREEAP handle this case which should never happen
     */ // throw new Error("There's no new content to set selection to?");
    }
    const validPositionToSet = (0, $bhF7K.getValidEndTextPosition)({
        step: firstReplaceStep,
        doc: tr.doc
    });
    if (validPositionToSet !== 0) tr.setSelection((0, $kpTIW.TextSelection).create(tr.doc, validPositionToSet));
    return tr;
}

});

parcelRegister("4nc7v", function(module, exports) {

$parcel$export(module.exports, "SuggestTitleEvents", () => $32f2b6343ca37258$export$2e2fd3edda02f5b4);
let $32f2b6343ca37258$export$2e2fd3edda02f5b4 = /*#__PURE__*/ function(SuggestTitleEvents) {
    SuggestTitleEvents["GenerateSuggestedTitle"] = "editor_ai:start_suggest_a_title";
    SuggestTitleEvents["ReplaceConfluenceTitle"] = "editor_ai:replace_confluence_title";
    return SuggestTitleEvents;
}({});

});


parcelRegister("6mnRu", function(module, exports) {

$parcel$export(module.exports, "sliceOrNodeToMarkdown", () => $4a174e9dffeae8d4$export$ae9f8b78c9fe6ae0);

var $XHGTv = parcelRequire("XHGTv");

var $138p3 = parcelRequire("138p3");

var $45diW = parcelRequire("45diW");

var $aFbB0 = parcelRequire("aFbB0");

var $8pKer = parcelRequire("8pKer");

var $2KzXN = parcelRequire("2KzXN");
function $4a174e9dffeae8d4$export$ae9f8b78c9fe6ae0({ slice: slice, node: node, editorView: editorView, intl: intl, convertTo: convertTo, updateIdMap: updateIdMap, selectionType: selectionType }) {
    let fragment = (slice || node).content;
    try {
        // we track whether the context is a whole document or a partial selection
        const contextSelectionScope = (0, $2KzXN.getContextSelectionScope)({
            editorView: editorView,
            slice: slice,
            node: node
        });
        if ((0, $XHGTv.getBooleanFF)('platform.editor.ai-markdown-plus_9v1w7') && convertTo === 'markdown-plus') {
            const { markdown: markdown, idMap: idMap, fallbackState: fallbackState, contentStatistics: contentStatistics } = (0, $45diW.convertProsemirrorToMarkdown)({
                editorView: editorView,
                fragment: fragment,
                featureToggles: {
                    markdownPlus: true,
                    // This ternary is needed because feature flags can only be called as part of
                    // an expression or we get a lint error & ignoring the error prevents the
                    // cleanup script from finding the flag.
                    markdownPlusV2: (0, $XHGTv.getBooleanFF)('platform.editor.ai-markdown-plus-v2_j5m0c') ? true : false,
                    markdownPlusMedia: (0, $XHGTv.getBooleanFF)('platform.editor.ai-markdown-plus-media_svrli') ? true : false,
                    markdownPlusExtensions: (0, $XHGTv.getBooleanFF)('platform.editor.ai-markdown-plus-extension_m8eb1') ? true : false,
                    markdownPlusExpands: (0, $XHGTv.getBooleanFF)('platform.editor.ai-markdown-plus-expands_5h7qa') ? true : false,
                    markdownPlusPanels: (0, $XHGTv.getBooleanFF)('platform.editor.ai-markdown-plus-panels_veh92') ? true : false,
                    markdownPlusDecisions: (0, $XHGTv.getBooleanFF)('platform.editor.ai-markdown-plus-decisions_4lriq') ? true : false,
                    markdownPlusTables: (0, $XHGTv.getBooleanFF)('platform.editor.ai-markdown-plus-tables_ipb1h') ? true : false,
                    markdownPlusLayouts: (0, $XHGTv.getBooleanFF)('platform.editor.ai-markdown-plus-layouts_jw2zj') ? true : false,
                    markdownPlusNestedExpands: (0, $XHGTv.getBooleanFF)('platform.editor.ai-markdown-plus-nested-expands_ru5xx') ? true : false,
                    markdownPlusMarks: (0, $XHGTv.getBooleanFF)('platform.editor.ai-markdown-plus-marks_eitjo') ? true : false
                }
            });
            if (!!Object.keys(fallbackState).length) {
                const tr = (0, $aFbB0.addAnalytics)({
                    editorState: editorView.state,
                    tr: editorView.state.tr,
                    payload: {
                        action: 'fallback',
                        actionSubject: 'editorPluginAI',
                        actionSubjectId: 'markdownSerializer',
                        attributes: {
                            fallbackState: fallbackState
                        },
                        eventType: 'operational'
                    }
                });
                editorView.dispatch(tr);
            }
            // This ID map is used to map the markdown back to the original ProseMirror
            // when we receive transformed content back from the llm.
            updateIdMap({
                idMap: idMap,
                selectionType: selectionType
            });
            return {
                markdown: markdown,
                contentStatistics: {
                    ...contentStatistics,
                    contextSelectionScope: contextSelectionScope
                }
            };
        }
        if (convertTo === 'markdown' || convertTo === 'markdown-plus') {
            const { markdown: markdown, contentStatistics: contentStatistics } = (0, $45diW.convertProsemirrorToMarkdown)({
                editorView: editorView,
                fragment: fragment,
                featureToggles: {}
            });
            return {
                markdown: markdown,
                contentStatistics: {
                    ...contentStatistics,
                    contextSelectionScope: contextSelectionScope
                }
            };
        }
        const markdown = $4a174e9dffeae8d4$var$getTextFromNode(fragment, intl);
        // Wrap the fragment in a temporary doc node so we can use ProseMirrorContentStatistics
        const tempNode = editorView.state.schema.nodes.doc.createAndFill(null, fragment);
        let contentStatistics;
        if (tempNode) {
            const pmStats = new (0, $138p3.ProseMirrorContentStatistics)(tempNode);
            contentStatistics = pmStats.collectStatistics();
        }
        return {
            markdown: markdown,
            contentStatistics: contentStatistics && {
                ...contentStatistics,
                contextSelectionScope: contextSelectionScope
            }
        };
    } catch (e) {
        const tr = (0, $aFbB0.addAnalytics)({
            editorState: editorView.state,
            tr: editorView.state.tr,
            payload: {
                action: 'failed',
                actionSubject: 'editorPluginAI',
                actionSubjectId: 'markdownSerializer',
                attributes: {
                    errorMessage: (0, $8pKer.ErrorUtils).extractErrorMessage(e)
                },
                eventType: 'operational'
            }
        });
        editorView.dispatch(tr);
        return {
            markdown: '',
            contentStatistics: undefined
        };
    }
}
// Note -- plain text use without markdown support is expected to be
// deprecated following feature roll out.
const $4a174e9dffeae8d4$var$getTextFromNode = (fragment, intl)=>{
    let markdown = '';
    // Iterate through the content of the fragment
    fragment.forEach(extractTextFromNode);
    return markdown;
    // Helper function to recursively extract text from nodes and their children
    function extractTextFromNode(node) {
        if (node.isText) {
            const linkMarkIndex = node.marks.findIndex((x)=>x.type.name === 'link');
            if (linkMarkIndex !== -1) {
                var _node$marks$linkMarkI, _node$marks$linkMarkI2;
                const href = (_node$marks$linkMarkI = node.marks[linkMarkIndex]) === null || _node$marks$linkMarkI === void 0 ? void 0 : (_node$marks$linkMarkI2 = _node$marks$linkMarkI.attrs) === null || _node$marks$linkMarkI2 === void 0 ? void 0 : _node$marks$linkMarkI2.href;
                markdown += `${href} `;
            } else markdown += `${node.text} `;
        } else switch(node.type.name){
            case 'inlineCard':
            case 'blockCard':
            case 'embedCard':
                markdown += `${node.attrs.url} `;
                break;
            case 'emoji':
                markdown += `${node.attrs.text || node.attrs.shortName} `;
                break;
            case 'date':
                markdown += `${intl.formatDate(Number(node.attrs.timestamp))} `;
                break;
            case 'status':
            case 'mention':
                markdown += `${node.attrs.text} `;
                break;
            default:
                node.forEach(extractTextFromNode);
        }
    }
};

});
parcelRegister("45diW", function(module, exports) {

$parcel$export(module.exports, "convertProsemirrorToMarkdown", () => $2f91f30c636cdc99$export$cc6cac500a4da966);

var $2zbl1 = parcelRequire("2zbl1");

var $138p3 = parcelRequire("138p3");

var $c94le = parcelRequire("c94le");
/**
 * If the first node is a paragraph we need to wrap it in a paragraph node for the markdown conversion to work properly
 */ function $2f91f30c636cdc99$var$createTextWrapper(editorView, fragment) {
    var _findParentNodeCloses;
    const { schema: schema } = editorView.state;
    const { $from: $from } = editorView.state.selection;
    const parent = (_findParentNodeCloses = (0, $2zbl1.findParentNodeClosestToPos)($from, (node)=>{
        return node.type.name === 'paragraph' || node.type.name === 'heading';
    })) === null || _findParentNodeCloses === void 0 ? void 0 : _findParentNodeCloses.node;
    if (parent) return schema.nodes.doc.createChecked(null, schema.nodes[parent.type.name].createChecked(parent.attrs, fragment));
    else // If the node is a paragraph we need the parent to be a doc for the conversion to work correctly
    return schema.nodes.doc.createChecked(null, schema.nodes.paragraph.createChecked(null, fragment));
}
/**
 * This finds the closest list item parent to the current selection
 * Once found it will create a new list with the current fragment as its children
 */ function $2f91f30c636cdc99$var$createListItemWrapper(editorView, fragment) {
    var _findParentNodeCloses2;
    const { schema: schema } = editorView.state;
    const { $from: $from } = editorView.state.selection;
    const parent = (_findParentNodeCloses2 = (0, $2zbl1.findParentNodeClosestToPos)($from, (node)=>node.type.name === 'bulletList' || node.type.name === 'orderedList')) === null || _findParentNodeCloses2 === void 0 ? void 0 : _findParentNodeCloses2.node;
    if (parent) return schema.nodes[parent.type.name].createChecked(parent.attrs, fragment);
    return fragment;
}
/**
 * If the first node is a task item we need to wrap it in a task list node for the markdown conversion to work properly
 */ function $2f91f30c636cdc99$var$createTaskItemWrapper(schema, fragment) {
    return schema.nodes.doc.createChecked(null, schema.nodes.taskList.createChecked(null, fragment));
}
function $2f91f30c636cdc99$var$createLayoutColumnWrapper(editorView, fragment) {
    const { schema: schema } = editorView.state;
    const parentSection = (0, $2zbl1.findParentNodeOfType)(schema.nodes.layoutSection)(editorView.state.selection);
    if (parentSection) // Needs to be a doc for the serializer to work as it
    // loops through the fragments children to render
    return schema.nodes.doc.createChecked(null, schema.nodes.layoutSection.createChecked(parentSection.node.attrs, fragment));
    return fragment;
}
/**
 * This function handles partial selections and it will fix any incomplete fragments that won't be converted properly
 * If you do a partial selection, it will not select the parent node of certain nodes text, listItems etc so once it hits the serializer
 * the serializer will just fallback to plain text and not convert the node properly.
 *
 * This function checks the first child of the current selection, if its a node that needs a parent it will find the closest parent
 * and create a new fragment that will be converted properly by the serializer
 */ function $2f91f30c636cdc99$var$checkFragment(editorView, schema, fragment) {
    var _fragment$firstChild, _fragment$firstChild$;
    switch(fragment === null || fragment === void 0 ? void 0 : (_fragment$firstChild = fragment.firstChild) === null || _fragment$firstChild === void 0 ? void 0 : (_fragment$firstChild$ = _fragment$firstChild.type) === null || _fragment$firstChild$ === void 0 ? void 0 : _fragment$firstChild$.name){
        case 'text':
            return $2f91f30c636cdc99$var$createTextWrapper(editorView, fragment);
        case 'listItem':
            return $2f91f30c636cdc99$var$createListItemWrapper(editorView, fragment);
        case 'taskItem':
            return $2f91f30c636cdc99$var$createTaskItemWrapper(schema, fragment);
        case 'layoutColumn':
            return $2f91f30c636cdc99$var$createLayoutColumnWrapper(editorView, fragment);
        default:
            return fragment;
    }
}
function $2f91f30c636cdc99$export$cc6cac500a4da966({ editorView: editorView, fragment: fragment, featureToggles: featureToggles = {} }) {
    fragment = $2f91f30c636cdc99$var$checkFragment(editorView, editorView.state.schema, fragment);
    return $2f91f30c636cdc99$export$3d24004275aefeab({
        node: fragment,
        featureToggles: featureToggles
    });
}
function $2f91f30c636cdc99$export$3d24004275aefeab({ node: node, featureToggles: featureToggles = {} }) {
    const markdownSerializerState = new (0, $c94le.MarkdownSerializerState)(featureToggles);
    markdownSerializerState.renderContent(node);
    const pmStats = new (0, $138p3.ProseMirrorContentStatistics)(node);
    const contentStatistics = pmStats.collectStatistics();
    const markdown = // @ts-ignore
    markdownSerializerState.out === '\u200c' ? '' : // Return empty string if editor only contains a zero-non-width character
    // @ts-ignore
    markdownSerializerState.out;
    return {
        markdown: markdown,
        fallbackState: markdownSerializerState.fallbackState,
        idMap: markdownSerializerState.idMap,
        contentStatistics: contentStatistics
    };
}

});
parcelRegister("c94le", function(module, exports) {

$parcel$export(module.exports, "MarkdownSerializerState", () => $8d79b171e7bb1c73$export$61055fa707e69319);

var $5zQU9 = parcelRequire("5zQU9");

var $dzYNe = parcelRequire("dzYNe");

var $7dkLM = parcelRequire("7dkLM");

var $ckgA7 = parcelRequire("ckgA7");

var $ec6VX = parcelRequire("ec6VX");

var $god4W = parcelRequire("god4W");
const $8d79b171e7bb1c73$export$1c401dbe379e8c65 = (()=>{
    function getMaxLength(text) {
        const matches = text.match(/`+/g) || [];
        return matches.reduce((prev, val)=>val.length > prev.length ? val : prev, '').length;
    }
    return function(text, minLength = 1) {
        const length = Math.max(minLength, getMaxLength(text) + 1);
        return (0, $god4W.stringRepeat)('`', length);
    };
})();
class $8d79b171e7bb1c73$export$61055fa707e69319 extends (0, $dzYNe.MarkdownSerializerState) {
    constructor(featureToggles){
        // ignoring as generated types for node serializer is inaccurate (typings/prosemirror-markdown.d.ts)
        // parent and index in node serializers should be optional
        // if markdownPlusMarks feature toggle is enabled, we don't want to pass marks to the super constructor
        // to prevent markdown mark syntax from being rendered
        // @ts-ignore-next-line
        super($8d79b171e7bb1c73$export$695720b7e7a61533, featureToggles !== null && featureToggles !== void 0 && featureToggles.markdownPlusMarks ? {} : $8d79b171e7bb1c73$export$3a8025f2f3e0c64, {});
        // ignoring as generated types for node serializer is inaccurate (typings/prosemirror-markdown.d.ts)
        // parent and index in node serializers should be optional
        // Typing this as a string -- to override the PMMarkdownSerializerState type of any
        // In the confluence build -- this results in the out property being set to undefined in the constructor
        // whereas in the dev server this is stripped when the code is transpiled.
        // When it is used in transpilation -- "undefined" is added to the start of the generated text
        // out: string;
        (0, $5zQU9.default)(this, "idMap", {});
        (0, $5zQU9.default)(this, "idCounter", 0);
        (0, $5zQU9.default)(this, "featureToggles", {});
        /**
     * This is used to track the number of times a node has failed to render
     * This is useful for debugging purposes
     * - the key is the node type name
     * - the value is an object with
     *   - the error message as the key
     *   - and the number of times it has failed to render with that message as the value.
     */ (0, $5zQU9.default)(this, "fallbackState", {});
        (0, $5zQU9.default)(this, "context", {
            insideTable: false
        });
        this.nodes = $8d79b171e7bb1c73$export$695720b7e7a61533;
        this.featureToggles = featureToggles || {};
    }
    updateFallbackState(error, child) {
        if (error instanceof Error) {
            var _this$fallbackState;
            const childTypeName = child.type.name;
            const errorMessage = error.message;
            const childFallbackState = (_this$fallbackState = this.fallbackState) === null || _this$fallbackState === void 0 ? void 0 : _this$fallbackState[childTypeName];
            Object.assign(this.fallbackState, {
                [childTypeName]: {
                    ...childFallbackState,
                    [errorMessage]: ((childFallbackState === null || childFallbackState === void 0 ? void 0 : childFallbackState[errorMessage]) || 0) + 1
                }
            });
        } else throw error;
    }
    /**
   * This method overide adds support for "options"
   * options is an object that can be used to pass additional information to the node serializer
   *
   * This is useful when a grandparent node has information that needs to be passed to a grandchild node
   *
   * For example, a table node has information about whether or not the table has a header row
   * This information needs to be passed to the tableRow and tableCell node serializers so that it can render the correct markdown
   * @see node_modules/prosemirror-markdown/src/to_markdown.js
   * @see MarkdownSerializerState.render()
   */ render(node, parent, index, options) {
        if (!this.nodes[node.type.name]) throw new Error(`Token type \`${node.type.name}\` not supported by Markdown renderer`);
        if (options !== null && options !== void 0 && options.skipFallback) this.nodes[node.type.name](this, node, parent, index, options);
        else try {
            this.nodes[node.type.name](this, node, parent, index, options);
        } catch (error) {
            this.updateFallbackState(error, node);
            return this.nodes.fallback(this, node);
        }
    }
    renderContent(parent) {
        parent.forEach((child, _offset, index)=>{
            if (// If child is an empty Textblock we need to insert a zwnj-character in order to preserve that line in markdown
            child.isTextblock && !child.textContent && // If child is a Codeblock we need to handle this separately as we want to preserve empty code blocks
            !(child.type.name === 'codeBlock') && !(child.content && child.content.size > 0)) return this.nodes.empty_line(this, child);
            try {
                return this.render(child, parent, index);
            } catch (error) {
                this.updateFallbackState(error, child);
                return this.nodes.fallback(this, child);
            }
        });
    }
    /**
   * This method override will properly escape backticks in text nodes with "code" mark enabled.
   * Bitbucket uses python-markdown which does not honor escaped backtick escape sequences \`
   * inside a backtick fence.
   *
   * @see node_modules/prosemirror-markdown/src/to_markdown.js
   * @see MarkdownSerializerState.renderInline()
   */ renderInline(parent, options) {
        const active = [];
        let trailing = '';
        const progress = (node, _, index)=>{
            let marks = node ? // @ts-ignore
            node.marks.filter((mark)=>this.marks[mark.type.name]) : [];
            let leading = trailing;
            trailing = '';
            // If whitespace has to be expelled from the node, adjust
            // leading and trailing accordingly.
            if (node && node.isText && marks.some((mark)=>{
                // @ts-ignore
                let info = this.marks[mark.type.name];
                return info && info.expelEnclosingWhitespace;
            })) {
                let [, lead, inner, trail] = /^(\s*)(.*?)(\s*)$/m.exec(node.text);
                leading += lead;
                trailing = trail;
                if (lead || trail) {
                    node = inner ? node.withText(inner) : null;
                    if (!node) marks = active;
                }
            }
            const code = marks.length && marks[marks.length - 1].type.name === 'code' && marks[marks.length - 1];
            const len = marks.length - (code ? 1 : 0);
            // Try to reorder 'mixable' marks, such as em and strong, which
            // in Markdown may be opened and closed in different order, so
            // that order of the marks for the token matches the order in
            // active.
            outer: for(let i = 0; i < len; i++){
                const mark = marks[i];
                // @ts-ignore
                if (!this.marks[mark.type.name].mixable) break;
                for(let j = 0; j < active.length; j++){
                    const other = active[j];
                    // @ts-ignore
                    if (!this.marks[other.type.name].mixable) break;
                    if (mark.eq(other)) {
                        if (i > j) marks = marks.slice(0, j).concat(mark).concat(marks.slice(j, i)).concat(marks.slice(i + 1, len));
                        else if (j > i) marks = marks.slice(0, i).concat(marks.slice(i + 1, j)).concat(mark).concat(marks.slice(j, len));
                        continue outer;
                    }
                }
            }
            // Find the prefix of the mark set that didn't change
            let keep = 0;
            while(keep < Math.min(active.length, len) && marks[keep].eq(active[keep]))++keep;
            // Close the marks that need to be closed
            while(keep < active.length)// @ts-ignore
            this.text(this.markString(active.pop(), false), false);
            // Output any previously expelled trailing whitespace outside the marks
            if (leading) this.text(leading);
            // Open the marks that need to be opened
            while(active.length < len){
                const add = marks[active.length];
                active.push(add);
                // @ts-ignore
                this.text(this.markString(add, true), false);
            }
            if (node) {
                if (!code || !node.isText) this.render(node, parent, index);
                else if (node.text) {
                    // Generate valid monospace, fenced with series of backticks longer that backtick series inside it.
                    let text = node.text;
                    const backticks = $8d79b171e7bb1c73$export$1c401dbe379e8c65(node.text, 1);
                    // Make sure there is a space between fences, otherwise python-markdown renderer will get confused
                    if (text.match(/^`/)) text = ' ' + text;
                    if (text.match(/`$/)) text += ' ';
                    this.text(backticks + text + backticks, false);
                }
            }
        };
        parent.forEach((child, _offset, index)=>{
            if (options !== null && options !== void 0 && options.skipFallback) progress(child, parent, index);
            else try {
                progress(child, parent, index);
            } catch (error) {
                this.updateFallbackState(error, child);
            }
        });
        progress(null);
    }
    addBlockMarks(state, node, renderFunction) {
        const closingTags = [];
        // This is temporary, only adding the marks that we support, once we get full support this will be removed
        const markFilters = [
            'alignment',
            'breakout',
            'border'
        ];
        const marks = node.marks.filter((mark)=>markFilters.includes(mark.type.name));
        if (marks.length === 0) {
            renderFunction();
            return;
        }
        marks.forEach((mark)=>{
            const id = `id-${state.idCounter++}`;
            state.idMap[id] = {
                type: mark.type.name,
                attributes: mark.attrs
            };
            state.write(`<custom data-type="${mark.type.name}_open" data-id="${id}" />\n\n`);
            closingTags.unshift(`<custom data-type="${mark.type.name}_close" />\n\n`);
        });
        renderFunction();
        state.write(closingTags.join(''));
    }
}
const $8d79b171e7bb1c73$var$editorNodes = {
    blockquote (state, node) {
        // @ts-ignore
        state.wrapBlock('> ', undefined, node, ()=>state.renderContent(node));
    },
    codeBlock (state, node) {
        const backticks = $8d79b171e7bb1c73$export$1c401dbe379e8c65(node.textContent, 3);
        state.write(backticks + (node.attrs.language || '') + '\n');
        state.text(node.textContent ? node.textContent : '\u200c', false);
        state.ensureNewLine();
        state.write(backticks);
        state.closeBlock(node);
    },
    heading (state, node) {
        state.write(state.repeat('#', node.attrs.level) + ' ');
        state.renderInline(node);
        state.closeBlock(node);
    },
    rule (state, node) {
        state.write(node.attrs.markup || '---');
        state.closeBlock(node);
    },
    bulletList (state, node) {
        for(let i = 0; i < node.childCount; i++){
            const child = node.child(i);
            state.render(child, node, i);
        }
    },
    orderedList (state, node) {
        for(let i = 0; i < node.childCount; i++){
            const child = node.child(i);
            state.render(child, node, i);
        }
    },
    listItem (state, node, parent, index) {
        const order = (0, $ec6VX.getOrderFromMaybeOrderedListNode)(parent);
        const delimiter = parent.type.name === 'bulletList' ? '* ' : `${order + index}. `;
        for(let i = 0; i < node.childCount; i++){
            const child = node.child(i);
            // if  at second child or more of list item, add a newline
            if (i > 0) state.write('\n');
            // if at first child of list item, add delimiter (e.g "1.").
            // if at second child or more of list item, only add spacing (not delimiter)
            if (i === 0) state.wrapBlock('  ', delimiter, node, ()=>state.render(child, parent, i));
            else // @ts-ignore
            state.wrapBlock('    ', undefined, node, ()=>state.render(child, parent, i));
            if (child.type.name === 'paragraph' && i > 0) state.write('\n');
            // @ts-ignore
            state.flushClose(1);
        }
        // if we're at the final list item, add a final closing newline
        if (index === parent.childCount - 1) state.write('\n');
    },
    taskList (state, node) {
        for(let i = 0; i < node.childCount; i++){
            const child = node.child(i);
            state.render(child, node, i);
            state.write('\n');
        }
        state.write('\n');
    },
    taskItem (state, node, parent) {
        const taskItemState = node.attrs.state;
        state.write(taskItemState === 'TODO' ? '- [ ] ' : '- [x] ');
        state.renderInline(node);
    },
    paragraph (state, node) {
        if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusV2 && state.featureToggles.markdownPlusMarks) state.addBlockMarks(state, node, ()=>{
            state.renderInline(node);
            if (node.marks.length > 0) state.write('\n\n');
            else state.closeBlock(node);
        });
        else {
            state.renderInline(node);
            state.closeBlock(node);
        }
    },
    mediaGroup (state, node) {
        for(let i = 0; i < node.childCount; i++){
            const child = node.child(i);
            state.render(child, node, i);
        }
    },
    mediaInline (state, node) {
        if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusV2 && state.featureToggles.markdownPlusMedia) state.addBlockMarks(state, node, ()=>{
            const id = `id-${state.idCounter++}`;
            state.idMap[id] = {
                type: 'mediaInline',
                attributes: node.attrs
            };
            state.write(`<custom data-type="mediaInline" data-id="${id}"></custom>`);
        });
    },
    mediaSingle (state, node, parent) {
        if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusV2 && state.featureToggles.markdownPlusMedia) state.addBlockMarks(state, node, ()=>{
            const id = `id-${state.idCounter++}`;
            state.idMap[id] = {
                type: 'mediaSingle',
                attributes: node.attrs
            };
            state.write(`<custom data-type="media_single_open" data-id="${id}" />\n\n`);
            node.content.forEach((child, i)=>{
                try {
                    state.render(child, node, i, {
                        skipFallback: true
                    });
                } catch (error) {
                    state.updateFallbackState(error, node);
                    state.nodes.fallback(state, node);
                }
            });
            state.write(`<custom data-type="media_single_close" />\n\n`);
        });
        else {
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
            /**
       * Currently, if the parent is a node we assume that mediaSingle is nested (e.g. inside a
       * table or list). In these cases we only output \n as there is often already new lines added
       * by the parent node.
       * Otherwise, if mediaSingle is not nested we add an extra new line.
       */ if (parent instanceof (0, $7dkLM.Node)) state.write('\n');
            else state.write('\n\n');
        }
    },
    caption (state, node) {
        if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusV2 && state.featureToggles.markdownPlusMedia) {
            const id = `id-${state.idCounter++}`;
            state.idMap[id] = {
                type: 'caption',
                attributes: node.attrs
            };
            state.write(`<custom data-type="caption_open" data-id="${id}" />\n\n`);
            try {
                state.renderInline(node, {
                    skipFallback: true
                });
            } catch (error) {
                state.updateFallbackState(error, node);
                state.nodes.fallback(state, node);
            }
            // captions do not contain paragraphs, so we need to add a newline after the content
            state.write(`\n\n<custom data-type="caption_close" />\n\n`);
        } else state.write(node.textContent);
    },
    media (state, node) {
        if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusV2 && state.featureToggles.markdownPlusMedia) state.addBlockMarks(state, node, ()=>{
            const id = `id-${state.idCounter++}`;
            state.idMap[id] = {
                type: 'media',
                attributes: node.attrs
            };
            state.write(`<custom data-type="media" data-id="${id}" />\n\n`);
        });
        else state.write('![](' + node.attrs.url + ')');
    },
    image (state, node) {
        // Note: the 'title' is not escaped in this flavor of markdown.
        state.write('![' + (0, $god4W.escapeMarkdown)(node.attrs.alt) + '](' + node.attrs.src + (node.attrs.title ? ` '${(0, $god4W.escapeMarkdown)(node.attrs.title)}'` : '') + ')');
    },
    hardBreak (state) {
        state.write('  \n');
    },
    text (state, node, parent, index) {
        const previousNode = index === 0 ? null : parent.child(index - 1);
        let text = node.textContent;
        // BB converts 4 spaces at the beginning of the line to code block
        // that's why we escape 4 spaces with zero-width-non-joiner
        const fourSpaces = '    ';
        if (!previousNode && /^\s{4}/.test(node.textContent)) text = node.textContent.replace(fourSpaces, '\u200c' + fourSpaces);
        if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusV2 && state.featureToggles.markdownPlusMarks && node.marks.length) {
            const id = `id-${state.idCounter++}`;
            state.idMap[id] = {
                type: 'text',
                attributes: node.attrs,
                marks: node.marks
            };
            text = `<custom data-type="text" data-id="${id}">${text}</custom>`;
        }
        const lines = text.split('\n');
        for(let i = 0; i < lines.length; i++){
            // @ts-ignore
            const startOfLine = state.atBlank() || !!state.closed;
            state.write();
            // @ts-ignore
            state.out += (0, $god4W.escapeMarkdown)(lines[i], startOfLine, state.context.insideTable);
            if (i !== lines.length - 1) {
                if (lines[i] && lines[i].length && lines[i + 1] && lines[i + 1].length) // @ts-ignore
                state.out += '  ';
                // @ts-ignore
                state.out += '\n';
            }
        }
    },
    empty_line (state, node) {
        state.write('\u200c'); // zero-width-non-joiner
        state.closeBlock(node);
    },
    mention (state, node, parent, index) {
        const isLastNode = parent.childCount === index + 1;
        let delimiter = '';
        if (!isLastNode) {
            const nextNode = parent.child(index + 1);
            const nextNodeHasLeadingSpace = nextNode.textContent.indexOf(' ') === 0;
            delimiter = nextNodeHasLeadingSpace ? '' : ' ';
        }
        if (state.featureToggles.markdownPlus) {
            const id = `id-${state.idCounter++}`;
            state.idMap[id] = {
                type: 'mention',
                attributes: node.attrs
            };
            state.write(`<custom data-type="mention" data-id="${id}">${node.attrs.text}</custom>`);
        } else // Note: This implementation differs from packages/editor/editor-bitbucket-transformer/src/serializer.ts
        state.write(`${node.attrs.text}${delimiter}`);
    },
    date (state, node) {
        if (state.featureToggles.markdownPlus) {
            const id = `id-${state.idCounter++}`;
            state.idMap[id] = {
                type: 'date',
                attributes: node.attrs
            };
            state.write(// TODO -- pass intl through
            `<custom data-type="date" data-id="${id}">${new Intl.DateTimeFormat().format(Number(node.attrs.timestamp))}</custom>`);
        } else // this will trigger the fallback conversion (text)
        throw new Error('Token type `date` not supported by Markdown renderer');
    },
    emoji (state, node) {
        if (state.featureToggles.markdownPlus) {
            const id = `id-${state.idCounter++}`;
            state.idMap[id] = {
                type: 'emoji',
                attributes: node.attrs
            };
            state.write(`<custom data-type="emoji" data-id="${id}">${node.attrs.shortName}</custom>`);
        } else state.write(node.attrs.shortName);
    },
    inlineCard (state, node) {
        if (state.featureToggles.markdownPlus) {
            const id = `id-${state.idCounter++}`;
            state.idMap[id] = {
                type: 'inlineCard',
                attributes: node.attrs
            };
            state.write(`<custom data-type="smartlink" data-id="${id}">${node.attrs.url}</custom>`);
        } else state.write(`[${node.attrs.url}](${node.attrs.url})`);
    },
    status (state, node) {
        if (state.featureToggles.markdownPlus) {
            const id = `id-${state.idCounter++}`;
            state.idMap[id] = {
                type: 'status',
                attributes: node.attrs
            };
            state.write(`<custom data-type="status" data-id="${id}">${node.attrs.text}</custom>`);
        } else // this will trigger the fallback conversion (text)
        throw new Error('Token type `status` not supported by Markdown renderer');
    },
    layoutSection (state, node) {
        if (state.featureToggles.markdownPlusV2 && state.featureToggles.markdownPlus && state.featureToggles.markdownPlusLayouts) state.addBlockMarks(state, node, ()=>{
            const id = `id-${state.idCounter++}`;
            state.idMap[id] = {
                type: 'layoutSection',
                attributes: node.attrs
            };
            state.write(`<custom data-type="layoutSection_open" data-id="${id}" />\n\n`);
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                try {
                    state.render(child, node, i, {
                        skipFallback: true
                    });
                } catch (error) {
                    state.updateFallbackState(error, node);
                    state.nodes.fallback(state, node);
                }
            }
            state.write(`<custom data-type="layoutSection_close" />\n\n`);
        });
        else for(let i = 0; i < node.childCount; i++){
            const child = node.child(i);
            state.render(child, node, i);
        }
    },
    layoutColumn (state, node) {
        if (state.featureToggles.markdownPlusV2 && state.featureToggles.markdownPlus && state.featureToggles.markdownPlusLayouts) {
            const id = `id-${state.idCounter++}`;
            state.idMap[id] = {
                type: 'layoutColumn',
                attributes: node.attrs
            };
            state.write(`<custom data-type="layoutColumn_open" data-id="${id}" />\n\n`);
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                try {
                    state.render(child, node, i, {
                        skipFallback: true
                    });
                } catch (error) {
                    state.updateFallbackState(error, node);
                    state.nodes.fallback(state, node);
                }
            }
            state.write(`<custom data-type="layoutColumn_close" />\n\n`);
        } else for(let i = 0; i < node.childCount; i++){
            const child = node.child(i);
            state.render(child, node, i);
        }
    },
    expand (state, node) {
        if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusV2 && state.featureToggles.markdownPlusExpands) state.addBlockMarks(state, node, ()=>{
            const id = `id-${state.idCounter++}`;
            state.idMap[id] = {
                type: 'expand',
                attributes: node.attrs
            };
            state.write(`<custom data-type="expand_open" data-id="${id}" />\n\n`);
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                try {
                    state.render(child, node, i, {
                        skipFallback: true
                    });
                } catch (error) {
                    state.updateFallbackState(error, node);
                    state.nodes.fallback(state, node);
                }
            }
            state.write(`<custom data-type="expand_close" />\n\n`);
        });
        else for(let i = 0; i < node.childCount; i++){
            const child = node.child(i);
            state.render(child, node, i);
        }
    },
    panel (state, node) {
        if (state.featureToggles.markdownPlusV2 && state.featureToggles.markdownPlus && state.featureToggles.markdownPlusPanels) {
            const id = `id-${state.idCounter++}`;
            state.idMap[id] = {
                type: 'panel',
                attributes: node.attrs
            };
            state.write(`<custom data-type="panel_open" data-id="${id}" />\n\n`);
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                try {
                    state.render(child, node, i, {
                        skipFallback: true
                    });
                } catch (error) {
                    state.updateFallbackState(error, node);
                    state.nodes.fallback(state, node);
                }
            }
            state.write(`<custom data-type="panel_close" />\n\n`);
        } else for(let i = 0; i < node.childCount; i++){
            const child = node.child(i);
            state.render(child, node, i);
        }
    },
    nestedExpand (state, node) {
        if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusV2 && state.featureToggles.markdownPlusNestedExpands) {
            const id = `id-${state.idCounter++}`;
            state.idMap[id] = {
                type: 'nestedExpand',
                attributes: node.attrs
            };
            state.write(`<custom data-type="nestedExpand_open" data-id="${id}" />\n\n`);
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                try {
                    state.render(child, node, i, {
                        skipFallback: true
                    });
                } catch (error) {
                    state.updateFallbackState(error, node);
                    state.nodes.fallback(state, node);
                }
            }
            state.write(`<custom data-type="nestedExpand_close" />\n\n`);
        } else for(let i = 0; i < node.childCount; i++){
            const child = node.child(i);
            state.render(child, node, i);
        }
    },
    blockCard (state, node) {
        state.write(`[${node.attrs.url}](${node.attrs.url})`);
    },
    embedCard (state, node) {
        state.write(`[${node.attrs.url}](${node.attrs.url})`);
    },
    decisionList (state, node) {
        if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusV2 && state.featureToggles.markdownPlusDecisions) {
            const id = `id-${state.idCounter++}`;
            state.idMap[id] = {
                type: 'decisionList',
                attributes: node.attrs
            };
            state.write(`<custom data-type="decisionList_open" data-id="${id}" />\n\n`);
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
            state.write(`<custom data-type="decisionList_close" />\n\n`);
        } else {
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                state.render(child, node, i);
            }
            state.write(`\n\n`);
        }
    },
    decisionItem (state, node) {
        if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusV2 && state.featureToggles.markdownPlusDecisions) {
            const id = `id-${state.idCounter++}`;
            state.idMap[id] = {
                type: 'decisionItem',
                attributes: node.attrs
            };
            state.write(`<custom data-type="decisionItem_open" data-id="${id}" />\n\n`);
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                try {
                    state.render(child, node, i, {
                        skipFallback: true
                    });
                } catch (error) {
                    state.updateFallbackState(error, node);
                    state.nodes.fallback(state, node);
                }
            }
            state.write(`\n\n<custom data-type="decisionItem_close" />\n\n`);
        } else for(let i = 0; i < node.childCount; i++){
            const child = node.child(i);
            state.render(child, node, i);
        }
    },
    extension (state, node) {
        if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusV2 && state.featureToggles.markdownPlusExtensions) {
            const id = `id-${state.idCounter++}`;
            state.idMap[id] = {
                type: 'extension',
                attributes: node.attrs
            };
            state.write(`<custom data-type="extension" data-id="${id}" />\n\n`);
        }
    },
    inlineExtension (state, node) {
        if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusV2 && state.featureToggles.markdownPlusExtensions) {
            const id = `id-${state.idCounter++}`;
            state.idMap[id] = {
                type: 'inlineExtension',
                attributes: node.attrs
            };
            state.write(`<custom data-type="inlineExtension" data-id="${id}"></custom>`);
        }
    },
    bodiedExtension (state, node) {
        if (state.featureToggles.markdownPlus && state.featureToggles.markdownPlusV2 && state.featureToggles.markdownPlusExtensions) {
            const id = `id-${state.idCounter++}`;
            state.idMap[id] = {
                type: 'bodiedExtension',
                attributes: node.attrs
            };
            state.write(`<custom data-type="bodiedExtension_open" data-id="${id}" />\n\n`);
            for(let i = 0; i < node.childCount; i++){
                const child = node.child(i);
                try {
                    state.render(child, node, i, {
                        skipFallback: true
                    });
                } catch (error) {
                    state.updateFallbackState(error, node);
                    state.nodes.fallback(state, node);
                }
            }
            state.write(`<custom data-type="bodiedExtension_close" />\n\n`);
        } else for(let i = 0; i < node.childCount; i++){
            const child = node.child(i);
            state.render(child, node, i);
        }
    },
    fallback (state, node) {
        // If PMNode is an unhandled block node, we need to add a newline
        // after the content to prevent the next line from being rendered as
        // part of the block node.
        if (node.isBlock) state.write(`${node.textContent || node.attrs.text || ''}\n\n`);
        else state.write(node.textContent || node.attrs.text || '');
    }
};
const $8d79b171e7bb1c73$export$695720b7e7a61533 = {
    ...$8d79b171e7bb1c73$var$editorNodes,
    ...(0, $ckgA7.default)
};
const $8d79b171e7bb1c73$export$3a8025f2f3e0c64 = {
    em: {
        open: '_',
        close: '_',
        mixable: true,
        expelEnclosingWhitespace: true
    },
    strong: {
        open: '**',
        close: '**',
        mixable: true,
        expelEnclosingWhitespace: true
    },
    strike: {
        open: '~~',
        close: '~~',
        mixable: true,
        expelEnclosingWhitespace: true
    },
    link: {
        open: '[',
        close (_state, mark) {
            return '](' + mark.attrs['href'] + ')';
        }
    },
    code: {
        open: '`',
        close: '`'
    }
};

});
parcelRegister("ckgA7", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f9437081e4a9e9a$export$2e2bcd8739ae039);
const $8f9437081e4a9e9a$var$isHeaderRow = (row)=>row.child(0).type.name === 'tableHeader';
const $8f9437081e4a9e9a$var$isHeaderRowPresent = (table)=>{
    let headerRowPresent = false;
    table.content.forEach((row)=>{
        if ($8f9437081e4a9e9a$var$isHeaderRow(row)) headerRowPresent = true;
    });
    return headerRowPresent;
};
const $8f9437081e4a9e9a$var$renderNode = (state, node, index)=>{
    if (index > 0) state.write(' ');
    node.content.forEach((child, i)=>{
        if (child.isTextblock || child.type.name === 'mediaSingle') {
            if (i > 0) state.write(' ');
            state.context.insideTable = true;
            state.renderInline(child);
            state.context.insideTable = false;
        } else $8f9437081e4a9e9a$var$renderNode(state, child, i);
    });
};
const $8f9437081e4a9e9a$var$renderInlineContent = (state, node, _parent, _index, options)=>{
    options.headerRowPresent && state.write('| ');
    $8f9437081e4a9e9a$var$renderNode(state, node, 0);
    state.write(' ');
};
var $8f9437081e4a9e9a$export$2e2bcd8739ae039 = {
    table (state, node) {
        if (state.featureToggles.markdownPlusV2 && state.featureToggles.markdownPlus && state.featureToggles.markdownPlusTables) {
            const id = `id-${state.idCounter++}`;
            state.idMap[id] = {
                type: 'table',
                attributes: node.attrs
            };
            state.write(`<custom data-type="table_open" data-id="${id}" />\n\n`);
            node.content.forEach((child, i)=>state.render(child, node, i));
            state.write(`<custom data-type="table_close" />\n\n`);
        } else {
            const headerRowPresent = $8f9437081e4a9e9a$var$isHeaderRowPresent(node);
            node.content.forEach((child, i)=>{
                try {
                    state.render(child, node, i, {
                        headerRowPresent: headerRowPresent,
                        skipFallback: true
                    });
                } catch (error) {
                    state.updateFallbackState(error, node);
                    state.nodes.fallback(state, node);
                }
            });
            state.closeBlock(node);
        }
    },
    tableRow (state, node, _parent, _index, options) {
        if (state.featureToggles.markdownPlusV2 && state.featureToggles.markdownPlus && state.featureToggles.markdownPlusTables) {
            const id = `id-${state.idCounter++}`;
            state.idMap[id] = {
                type: 'table',
                attributes: node.attrs
            };
            state.write(`<custom data-type="tr_open" data-id="${id}" />\n\n`);
            node.content.forEach((child, i)=>{
                try {
                    state.render(child, node, i, {
                        skipFallback: true
                    });
                } catch (error) {
                    state.updateFallbackState(error, node);
                    state.nodes.fallback(state, node);
                }
            });
            state.write(`<custom data-type="tr_close" />\n\n`);
        } else {
            node.content.forEach((child, i)=>{
                try {
                    state.render(child, node, i, {
                        ...options,
                        skipFallback: true
                    });
                } catch (error) {
                    state.updateFallbackState(error, node);
                    state.nodes.fallback(state, node);
                }
            });
            if (options.headerRowPresent) {
                state.write('|');
                state.ensureNewLine();
                if ($8f9437081e4a9e9a$var$isHeaderRow(node)) {
                    for(let i = 0; i < node.childCount; i++)state.write('| --- ');
                    state.write('|');
                    state.ensureNewLine();
                }
            }
        }
    },
    tableHeader (state, node, _parent, _index, options) {
        if (state.featureToggles.markdownPlusV2 && state.featureToggles.markdownPlus && state.featureToggles.markdownPlusTables) {
            const id = `id-${state.idCounter++}`;
            state.idMap[id] = {
                type: 'table',
                attributes: node.attrs
            };
            state.write(`<custom data-type="th_open" data-id="${id}" />\n\n`);
            node.content.forEach((child, i)=>{
                try {
                    state.render(child, node, i, {
                        skipFallback: true
                    });
                } catch (error) {
                    state.updateFallbackState(error, node);
                    state.nodes.fallback(state, node);
                }
            });
            state.write(`<custom data-type="th_close" />\n\n`);
        } else $8f9437081e4a9e9a$var$renderInlineContent(state, node, _parent, _index, options);
    },
    tableCell (state, node, _parent, _index, options) {
        if (state.featureToggles.markdownPlusV2 && state.featureToggles.markdownPlus && state.featureToggles.markdownPlusTables) {
            const id = `id-${state.idCounter++}`;
            state.idMap[id] = {
                type: 'table',
                attributes: node.attrs
            };
            state.write(`<custom data-type="td_open" data-id="${id}" />\n\n`);
            node.content.forEach((child, i)=>{
                try {
                    state.render(child, node, i, {
                        skipFallback: true
                    });
                } catch (error) {
                    state.updateFallbackState(error, node);
                    state.nodes.fallback(state, node);
                }
            });
            state.write(`<custom data-type="td_close" />\n\n`);
        } else $8f9437081e4a9e9a$var$renderInlineContent(state, node, _parent, _index, options);
    }
};

});

parcelRegister("ec6VX", function(module, exports) {

$parcel$export(module.exports, "getOrderFromMaybeOrderedListNode", () => $a55790970625ea8b$export$4ea3c6bbdf8f7944);

var $7dkLM = parcelRequire("7dkLM");
const $a55790970625ea8b$export$8ef94ae42a3729bd = 1;
const $a55790970625ea8b$export$d445360e2a3c026b = (order)=>{
    const num = Number(order);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $a55790970625ea8b$export$4ea3c6bbdf8f7944 = (maybeOrderedListNode)=>{
    var _maybeOrderedListNode, _resolveOrder;
    if (!(maybeOrderedListNode instanceof (0, $7dkLM.Node))) return $a55790970625ea8b$export$8ef94ae42a3729bd;
    const order = maybeOrderedListNode === null || maybeOrderedListNode === void 0 ? void 0 : (_maybeOrderedListNode = maybeOrderedListNode.attrs) === null || _maybeOrderedListNode === void 0 ? void 0 : _maybeOrderedListNode.order;
    return (_resolveOrder = $a55790970625ea8b$export$d445360e2a3c026b(order)) !== null && _resolveOrder !== void 0 ? _resolveOrder : $a55790970625ea8b$export$8ef94ae42a3729bd;
};

});

parcelRegister("god4W", function(module, exports) {

$parcel$export(module.exports, "stringRepeat", () => $bee908627bc1d582$export$345d822805ab3239);
$parcel$export(module.exports, "escapeMarkdown", () => $bee908627bc1d582$export$560888d6fe0cfe97);
/**
 * A replacement for `String.repeat` until it becomes widely available.
 */ function $bee908627bc1d582$export$345d822805ab3239(text, length) {
    let result = '';
    for(let x = 0; x < length; x++)result += text;
    return result;
}
function $bee908627bc1d582$export$560888d6fe0cfe97(str, startOfLine, insideTable) {
    let strToEscape = str || '';
    strToEscape = strToEscape.replace(/[`*\\+_()\[\]{}]/g, '\\$&');
    if (startOfLine) strToEscape = strToEscape.replace(/^[#-&(-*]/, '\\$&') // Don't escape ' character
    .replace(/^(\d+)\./, '$1\\.');
    if (insideTable) strToEscape = strToEscape.replace(/[|]/g, '\\$&');
    return strToEscape;
}
const $bee908627bc1d582$var$SPECIAL_CHARACTERS = /\u200c|↵/g;
function $bee908627bc1d582$var$removeSpecialCharacters(node) {
    if (node.nodeType === 3 && node.textContent) node.textContent = node.textContent.replace($bee908627bc1d582$var$SPECIAL_CHARACTERS, '');
    Array.from(node.childNodes).forEach((child)=>$bee908627bc1d582$var$removeSpecialCharacters(child));
}
function $bee908627bc1d582$export$9c95763b5a419f4c(html, options) {
    const el = document.createElement('div');
    el.innerHTML = html;
    // Remove zero-width-non-joiner
    Array.from(el.querySelectorAll('p')).forEach((p)=>{
        $bee908627bc1d582$var$removeSpecialCharacters(p);
    });
    // Convert mention containers, i.e.:
    //   <a href="/abodera/" rel="nofollow" title="@abodera" class="mention mention-me">Artur Bodera</a>
    Array.from(el.querySelectorAll('a.mention, a.ap-mention')).forEach((a)=>{
        const span = document.createElement('span');
        span.setAttribute('class', 'editor-entity-mention');
        span.setAttribute('contenteditable', 'false');
        const atlassianId = a.getAttribute('data-atlassian-id') || '';
        if (atlassianId) // Atlassian ID is wrapped in curlies so that it get serialized as @{aid-id} instead of @aid-id
        span.setAttribute('data-mention-id', `{${atlassianId}}`);
        else {
            const title = a.getAttribute('title') || '';
            if (title) {
                const usernameMatch = title.match(/^@(.*?)$/);
                if (usernameMatch) {
                    const username = usernameMatch[1];
                    span.setAttribute('data-mention-id', username);
                }
            }
        }
        const text = a.textContent || '';
        if (text.indexOf('@') === 0) span.textContent = a.textContent;
        else span.textContent = `@${a.textContent}`;
        a.parentNode.insertBefore(span, a);
        a.parentNode.removeChild(a);
    });
    // Convert mention containers, i.e.:
    //   <span class="ap-mention" data-atlassian-id="5c09bf77ec71bd223bbe866f">@Scott Demo</span>
    Array.from(el.querySelectorAll('span.ap-mention')).forEach((s)=>{
        const span = document.createElement('span');
        span.setAttribute('class', 'editor-entity-mention');
        span.setAttribute('contenteditable', 'false');
        const atlassianId = s.getAttribute('data-atlassian-id') || '';
        span.setAttribute('data-mention-id', `{${atlassianId}}`);
        const text = s.textContent || '';
        span.textContent = text.indexOf('@') === 0 ? text : `@${text}`;
        s.parentNode.insertBefore(span, s);
        s.parentNode.removeChild(s);
    });
    // Parse emojis i.e.
    //     <img src="https://d301sr5gafysq2.cloudfront.net/207268dc597d/emoji/img/diamond_shape_with_a_dot_inside.svg" alt="diamond shape with a dot inside" title="diamond shape with a dot inside" class="emoji">
    Array.from(el.querySelectorAll('img.emoji')).forEach((img)=>{
        const span = document.createElement('span');
        let shortName = img.getAttribute('data-emoji-short-name') || '';
        if (!shortName) {
            // Fallback to parsing Bitbucket's src attributes to find the
            // short name
            const src = img.getAttribute('src');
            const idMatch = !src ? false : src.match(/([^\/]+)\.[^\/]+$/);
            if (idMatch) shortName = `:${decodeURIComponent(idMatch[1])}:`;
        }
        if (shortName) span.setAttribute('data-emoji-short-name', shortName);
        img.parentNode.insertBefore(span, img);
        img.parentNode.removeChild(img);
    });
    if (!options.disableBitbucketLinkStripping) // Convert all automatic links to plain text, because they will be re-created on render by the server
    Array.from(el.querySelectorAll('a'))// Don't convert external links (i.e. not automatic links)
    .filter((a)=>a.getAttribute('data-is-external-link') !== 'true' && a.getAttribute('data-inline-card') === null).forEach((a)=>{
        Array.from(a.childNodes).forEach((child)=>{
            a.parentNode.insertBefore(child, a);
        });
        a.parentNode.removeChild(a);
    });
    // Parse images
    // Not using :pseudo because of IE11 bug:
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/16104908/
    Array.from(el.querySelectorAll('img')).filter((img)=>!img.classList.contains('emoji')).forEach((img)=>{
        const { parentNode: parentNode } = img;
        if (!parentNode) return;
        /**
     * Lift image node if parent isn't the root-element
     */ if (parentNode !== el) {
            const isValidPath = validateImageNodeParent(parentNode);
            if (!isValidPath) liftImageNode(parentNode, img);
        }
        /**
     * Replace image with media node
     */ const mediaSingle = document.createElement('div');
        mediaSingle.setAttribute('data-node-type', 'mediaSingle');
        const media = document.createElement('div');
        media.setAttribute('data-node-type', 'media');
        media.setAttribute('data-type', 'external');
        media.setAttribute('data-alt', img.getAttribute('alt') || '');
        media.setAttribute('data-url', img.getAttribute('src'));
        mediaSingle.appendChild(media);
        img.parentNode.insertBefore(mediaSingle, img);
        img.parentNode.removeChild(img);
    });
    function validateImageNodeParent(node) {
        const ALLOWED_PARENTS = [
            'LI',
            'UL',
            'OL',
            'TD',
            'TH',
            'TR',
            'TBODY',
            'THEAD',
            'TABLE'
        ];
        if (node === el) return true;
        if (ALLOWED_PARENTS.indexOf(node.nodeName) === -1) return false;
        if (!node.parentNode) return false;
        return validateImageNodeParent(node.parentNode);
    }
    function liftImageNode(node, img) {
        let foundParent = false;
        let parent = node;
        while(!foundParent){
            foundParent = validateImageNodeParent(parent.parentNode);
            if (!foundParent) parent = parent.parentNode;
        }
        const cloned = parent.cloneNode();
        const target = parent !== el ? parent.parentNode : el;
        while(img.nextSibling)cloned.appendChild(img.nextSibling);
        if (node !== parent) while(node.nextSibling)cloned.appendChild(node.nextSibling);
        if (parent.nextSibling) {
            target.insertBefore(cloned, parent.nextSibling);
            target.insertBefore(img, cloned);
        } else {
            target.appendChild(img);
            target.appendChild(cloned);
        }
        /**
     * If the splitting operation results in
     * the old parent being empty, remove it
     */ if (node.childNodes.length === 0) node.parentNode.removeChild(node);
        /**
     * Remove cloned element if it's empty.
     */ if (cloned.childNodes.length === 0) cloned.parentNode.removeChild(cloned);
    }
    return el;
}

});



parcelRegister("2KzXN", function(module, exports) {

$parcel$export(module.exports, "getContextSelectionScope", () => $200bc644689602f6$export$19bde12812d70545);
/**
 * Returns whether selection is full document, partial selection or none.
 */ const $200bc644689602f6$export$19bde12812d70545 = ({ editorView: editorView, slice: slice, node: node })=>{
    var _node$content;
    const hasContent = node ? (((_node$content = node.content) === null || _node$content === void 0 ? void 0 : _node$content.size) || 0) > 2 : slice ? slice.size >= 1 : false;
    if (hasContent) {
        var _slice$content, _slice$content$eq, _node$eq;
        if (slice !== null && slice !== void 0 && (_slice$content = slice.content) !== null && _slice$content !== void 0 && (_slice$content$eq = _slice$content.eq) !== null && _slice$content$eq !== void 0 && _slice$content$eq.call(_slice$content, editorView.state.doc.content) || node !== null && node !== void 0 && (_node$eq = node.eq) !== null && _node$eq !== void 0 && _node$eq.call(node, editorView.state.doc)) return 'fullDocument';
        else return 'partialSelection';
    }
    return 'none';
};

});



parcelRegister("hk7qZ", function(module, exports) {

$parcel$export(module.exports, "useCommandPaletteStateMachine", () => $c9ca123f0aaf1ec8$export$6d6b44d5fef51d81);

var $eUqFw = parcelRequire("eUqFw");

var $lLbOi = parcelRequire("lLbOi");

var $gOVGh = parcelRequire("gOVGh");
function $c9ca123f0aaf1ec8$export$6d6b44d5fef51d81({ startingConfig: startingConfig, startingPresetPromptLabel: startingPresetPromptLabel, baseGenerate: baseGenerate, startingUserInput: startingUserInput, startingUserADFInput: startingUserADFInput }) {
    const machineRef = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(null);
    if (machineRef.current === null) machineRef.current = (0, $gOVGh.commandPaletteStateMachine)({
        context: {
            textInput: startingUserInput,
            adfInput: startingUserADFInput,
            configItem: startingConfig,
            presetPromptLabel: startingPresetPromptLabel,
            baseGenerate: baseGenerate
        }
    });
    const [state, send] = (0, $lLbOi.useMachine)(machineRef.current);
    return {
        // In a later version of xstate -- the type gen means the machine
        // has good types, so these assertions are not required
        state: state.value,
        context: state.context,
        // Out of the box -- the type of the event received by the xstate send
        // will allow any "payload".
        // ie. `send("correct event type", {incorrect: "event payload"})`
        //
        // To avoid related issues -- we've limited the type to only allow
        // sending the full event.
        // ie. `send({type: "correct event type", correct: "event payload"})`
        send: send
    };
}

});
parcelRegister("gOVGh", function(module, exports) {

$parcel$export(module.exports, "commandPaletteStateMachine", () => $c3ee0f1018dd0c8f$export$43aa9d313c05e1e6);
/*
 * !!! Please see for more details:
 * https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3732210222/Dev+Documentation+Editor+AI+Command+Palette#Current-Implementation
 *
 * This file contains the state machine that models the command palette.
 *
 *
 * If you modify this machine in any way, please look at the visual editor
 * and make sure that it is clear and readable.
 *
 * Include a screenshot of the visual editor in your pull request.
 *
 * If you add a new state to the machine -- you will need to update the
 * CommandPaletteState union type.
 *
 * If you add a new transition to the machine -- you will need to update the
 * CommandPaletteEvent union type.
 */ parcelRequire("i1LcY");
var $7LdyK = parcelRequire("7LdyK");
var $8O42R = parcelRequire("8O42R");
const $c3ee0f1018dd0c8f$export$43aa9d313c05e1e6 = ({ context: context })=>// ! TODO: When xstate v5+ is adopted remove the ts-expect-error
    // This will swallow ts-errors, take care
    // @ts-expect-error(TS2769) "No overload matches this call"
    // This occurs because createMachine's options input does not include state.description
    // However the state.description field is useful for the visual editor
    // Tested 2023-07-06 on xstate@5.0.0-beta.15 and this problem will be resolved
    (0, $8O42R.createMachine)({
        /** @xstate-layout N4IgpgJg5mDOIC5QGMD2BbdBDAdhABAA5YA2YALuWPrOVlftsgBYCWOYAxKjgCpgAPcgFEcVAE6QA2gAYAuolCFUsVuVY9FIAYgBsAdgCsAOgBMAZkMBOKzJm7zVgBymrAGhABPRAFoLx8ydzU10nK30XJyDDXQBfWI80TFwCYjJKalp6aiY2DmNicXVSIklYChowMmR1HnwU-CTsPHxUQlqcWHwSVloaOipjHFQiLCLWEsIyivLqqgIAMwBXEhJW9o1O7t7ybhwABTHikn3p8gBlKrAa6XktZVUOrR0EABYnXWMnV9eZV-0ZE4ZABGQKWDzeN6g4yGfTmYGhYH6XRWUxOQzxRIYZqpUgUBhZBi5dhgApHCZrKZwGZXGqbeotJoNNodLo9PqE0nDUbjSZnSpzSD4SQkbIEFmbNk7PaHXknM6XQUQWQKJAgB5qTbPRBo4FmMJWXTAmTmV7mULuLyIIKfQym+zA9HGwyuTEgJktNL4zIDHJYFgksly0rU8gC64dBkED3ijY8KUc31B44h8ph2YRoXciXx7a0GXk0inUMAJTA6FQADdbqqlCpNZo1S8gZ8WzJ9K9QnZ9PpgRC9DITOZkXaTfDDDFXm6Y6N0gTfYx-XlSYUU1S0+G6XUGjOc1t2emk6uKamaUr8Nm4-vpTxZcdi2myxXq8rgbX1fWnk3EMCkXr7LYjqvIY-xIuY-YILog4BCO5hjsCE66FOCTutiDRehk-TZIuAb5MefKhpukY7mhLR7gmh7ZMY7CaqQvT0JsnAqvcn5at+CC-k4MIuu2VhgcagIQQ4MgBHaxpGoODjAshWLJJ6eKYZyOHLsmJ7rmeEb0iRcmxqyeaUYMNHHPRHRMW+LGPGxoAvKYjrGHCZoAqYvZwc5+gQXBrzGIOnZRO2Pw9vEKHDBAcBaDOGHzthxIcBZDY4NqCA+D8MJmvYILvHx1ivBBthfH8KKvL+PwIaC06kbic4+tFS6BvhlL8hmW44FGjQVesekHlhVBxV+1mIOYxjASijhOoCvyGOiEFIlxnmhGatl2KYPzlTps7et1fq4SuhYNYRTXEYy7Xkfpm1DCM9WnumtLzPgyyrB1kr6b1VnaIgRUiaavzAfCpggmiOVWggIQmEC-wyKYrgITEHarTi62KQuMU7cG6nXXMWlHWtJ1dZy508mujU3UKIpio9uYHi9jb9Qg8JWMY0kdo6SK9iChi5YaxhGj2E62FYE0yaha2RdVRK1Xhu1XURmPRsdV4UWdl1o0RWYjDjOxUwl7GdqYMK2fz4Rjoa5jgUDk265YcH88aQRhMCcPoQpUVi9tqkERuB0y212Py6deNGRSJmvRqfVvQghh6sNVijRH432B5IL5eDwJooYJoOMh8RAA */ states: {
            'partial preset selection and command options list state': {
                states: {
                    'no partial preset selected full options list': {
                        description: `If no partial preset is selected and there is no text input:
- Show the full options list`,
                        on: {
                            onPartialPresetSelected: {
                                target: 'partial preset selected no options list',
                                actions: [
                                    'removeInputText',
                                    'partialPresetSelected'
                                ]
                            }
                        }
                    },
                    'no partial preset selected related options list': {
                        description: `If no partial preset is selected and the user has entered text:
- Show the related options list`,
                        on: {
                            onPartialPresetSelected: {
                                target: 'partial preset selected no options list',
                                actions: [
                                    'removeInputText',
                                    'partialPresetSelected'
                                ]
                            }
                        }
                    },
                    'partial preset selected no options list': {
                        on: {
                            onPartialPresetRemoved: [
                                {
                                    target: 'no partial preset selected related options list',
                                    cond: 'hasInputText',
                                    actions: 'partialPresetRemoved'
                                },
                                {
                                    target: 'no partial preset selected full options list',
                                    actions: 'partialPresetRemoved'
                                }
                            ]
                        },
                        description: `If a partial preset is already selected:
- Don't show the options list
- Show the selected preset`
                    },
                    initialisation: {
                        always: [
                            {
                                target: 'partial preset selected no options list',
                                cond: 'hasInitialPreset'
                            },
                            'no partial preset selected full options list'
                        ]
                    }
                },
                initial: 'initialisation'
            }
        },
        context: context,
        schema: {
            events: {}
        },
        type: 'parallel',
        id: 'command palette state machine',
        on: {
            onTextEntered: {
                actions: 'updateTextInput',
                internal: true
            },
            onADFEntered: {
                actions: 'updateADFInput',
                internal: true
            }
        }
    }, {
        guards: {
            /*
     * There are test cases for this guard in the test suite.
     * They ensure that the guard is working as expected as
     * the simulation is not able to test this.
     */ ['hasInputText']: (context)=>{
                // context.textInput can be undefined, an empty string, or a non-empty string
                // empty strings are considered to be false in this guard
                return !!context.textInput;
            },
            ['hasInitialPreset']: (context)=>{
                const hasInitialPreset = context.configItem.promptLabel !== undefined;
                return hasInitialPreset;
            }
        },
        actions: {
            updateTextInput: (0, $7LdyK.assign)((_context, event)=>{
                if ('onTextEntered' === event.type) {
                    if ('input' in event) return {
                        textInput: event.input
                    };
                    return {
                        textInput: ''
                    };
                }
                return {};
            }),
            updateADFInput: (0, $7LdyK.assign)((_context, event)=>{
                if ('onADFEntered' === event.type) {
                    if ('adf' in event) return {
                        adfInput: event.adf
                    };
                    return {
                        adfInput: ''
                    };
                }
                return {};
            }),
            partialPresetSelected: (0, $7LdyK.assign)((_context, event)=>{
                if (event.type === 'onPartialPresetSelected') return {
                    configItem: event.configItem,
                    presetPromptLabel: event.presetPromptLabel
                };
                return {};
            }),
            partialPresetRemoved: (0, $7LdyK.assign)((context, event)=>{
                if (event.type === 'onPartialPresetRemoved') return {
                    configItem: context.baseGenerate,
                    presetPromptLabel: undefined
                };
                return {
                    presetPromptLabel: undefined
                };
            }),
            removeInputText: (0, $7LdyK.assign)(()=>{
                return {
                    textInput: '',
                    adfInput: ''
                };
            })
        }
    });

});



parcelRegister("5laZa", function(module, exports) {

$parcel$export(module.exports, "mapLoadingStatusToMessageTemplate", () => $3e376f6935c1095d$export$1e9814631e2193d4);

var $iypWf = parcelRequire("iypWf");
const $3e376f6935c1095d$export$1e9814631e2193d4 = (messageTemplate)=>{
    switch(messageTemplate){
        case 'ANALYSING_QUERY':
            return (0, $iypWf.messages).messageTemplateAnalysingQuery;
        case 'CONTENT_SEARCH':
            return (0, $iypWf.messages).messageTemplateContentSearch;
        case 'PAGE_HYDRATION':
            return (0, $iypWf.messages).messageTemplatePageHydration;
        case 'NEXT_BEST_TASK':
            return (0, $iypWf.messages).messageTemplateNextBestTask;
        case 'WRITING':
            return (0, $iypWf.messages).loadingTitle;
        default:
            return;
    }
};

});


parcelRegister("iTCOg", function(module, exports) {

$parcel$export(module.exports, "ModalRegion", () => $dc1b77d775c10836$export$bd71f7a11db32a15);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $9jzX6 = parcelRequire("9jzX6");

var $ebMIO = parcelRequire("ebMIO");

var $fBDHJ = parcelRequire("fBDHJ");

var $cM5Qn = parcelRequire("cM5Qn");

var $i3fEa = parcelRequire("i3fEa");

var $9O1Gs = parcelRequire("9O1Gs");
const $dc1b77d775c10836$export$bd71f7a11db32a15 = ({ children: children, decoration: decoration, editorView: editorView, editorRelativeWrapper: editorRelativeWrapper, modalDecorationElement: modalDecorationElement, appearance: appearance, endExperience: endExperience })=>{
    const editorViewElement = editorView.dom;
    const modalRef = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useRef(null);
    const [modalLeft, setModalLeft] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState(0);
    const [modalTop, setModalTop] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState((0, $ebMIO.getDecorationBottom)(modalDecorationElement, editorRelativeWrapper));
    const [modalWidth, setModalWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState(0);
    const [transition, setTransition] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState('');
    // get nearest resizable wrapper or breakout container looking up from the ai decoration position
    const resizableOrBreakoutWrapper = (0, $eUqFw.useMemo)(()=>(0, $ebMIO.getResizableOrBreakoutWrapper)(editorView, decoration.to), [
        editorView,
        decoration
    ]);
    // EDF-161: https://product-fabric.atlassian.net/browse/EDF-161
    // If the editor has a max-height set, we need to set position relative for .ak-editor-content-area
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        if (appearance === 'comment') {
            // editorRelativeWrapper is the closest but can be null
            // fallback to modalDecorationElement if editorRelativeWrapper is null
            let editorContentArea = null;
            if (editorRelativeWrapper) editorContentArea = editorRelativeWrapper.querySelector('.ak-editor-content-area');
            else editorContentArea = modalDecorationElement.closest('.ak-editor-content-area');
            if (editorContentArea) {
                const computedStyle = getComputedStyle(editorContentArea);
                const editorHasMaxHeight = computedStyle.maxHeight !== 'none';
                const originalPosition = computedStyle.position;
                if (editorHasMaxHeight) editorContentArea.style.position = 'relative';
                return ()=>{
                    if (editorHasMaxHeight && editorContentArea) editorContentArea.style.position = originalPosition;
                };
            }
        }
    }, [
        modalDecorationElement,
        appearance,
        editorRelativeWrapper
    ]);
    // listen for editor resize and update modal size and position
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        const setModalPosition = ()=>{
            // When layout resizes / breakout changes, resizableOrBreakoutWrapper remounts
            // We need to wait for resizableOrBreakoutWrapper to update before we can calculate modal positions
            // Return if resizableOrBreakoutWrapper doesn't exist in view as it hasn't been updated yet to avoid flickering
            if (resizableOrBreakoutWrapper && !editorViewElement.contains(resizableOrBreakoutWrapper)) return;
            // position relative to breakout element when its available, or otherwise relative to editor view
            const relativePositionElement = resizableOrBreakoutWrapper || editorViewElement;
            setModalLeft(relativePositionElement.offsetLeft);
            setModalTop((0, $ebMIO.getDecorationBottom)(modalDecorationElement, editorRelativeWrapper));
            setModalWidth(relativePositionElement.offsetWidth);
            //setting width to be animated here to make animation happen only after first positioning
            if (!transition) setTransition('all 0.1s ease-in');
        };
        setModalPosition();
        const [setModalPositionDebounced, clearModalPositionDebounced] = (0, $cM5Qn.debounce)(()=>{
            setModalPosition();
        }, 20);
        const resizeObserver = new ResizeObserver(setModalPositionDebounced);
        resizeObserver.observe(editorViewElement);
        // editorViewOffsetParent can be undefined when editor is set to display: none
        // (when Confluence switches to Preview mode)
        const editorViewOffsetParent = editorViewElement.offsetParent;
        if (editorViewOffsetParent) // This resize observer is intended to fix the position of the modal region
        // when the config panel (for extensions or templates) is opened/closed
        resizeObserver.observe(editorViewOffsetParent);
        // listen to any changes in the resizableOrBreakoutWrapper if modal was triggered in
        // layout or table with breakout / resizable table
        if (resizableOrBreakoutWrapper) resizeObserver.observe(resizableOrBreakoutWrapper);
        return ()=>{
            resizeObserver.disconnect();
            //clearing any potentially running debounced reposition
            clearModalPositionDebounced();
        };
    // no need to rerun due to transition change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        editorViewElement,
        modalDecorationElement,
        editorRelativeWrapper,
        resizableOrBreakoutWrapper
    ]);
    // sync modal height with editor content area height
    (0, $i3fEa.default)({
        modalElement: modalRef.current,
        editorViewElement: editorViewElement
    });
    // Check for the modal decoration which is used for positioning
    // If there is none the modal should be removed from the DOM & return early
    // This is intended to make the code more resilient to bugs caused by the
    // editor AI plugin not being reinstantiated correctly when the editor is closed/opened
    // See https://product-fabric.atlassian.net/browse/EDITOR-52
    const pluginState = (0, $9O1Gs.getPluginState)(editorView.state);
    const modalDecorationSet = pluginState.modalDecorationSet;
    if (modalDecorationSet === (0, $fBDHJ.DecorationSet).empty) {
        endExperience();
        return null;
    }
    const style = {
        top: modalTop,
        left: modalLeft,
        '--content-width': `${modalWidth}px`,
        transition: transition,
        display: modalWidth ? 'block' : 'none'
    };
    return (0, $byn9U.jsx)("div", {
        "data-testid": "ai-plugin-modal",
        css: (0, $9jzX6.modalStyles),
        style: style,
        ref: modalRef,
        "data-editor-popup": true
    }, children);
};

});
parcelRegister("9jzX6", function(module, exports) {

$parcel$export(module.exports, "modalStyles", () => $6c81c6ca145dc529$export$367b0302f2a047a4);
$parcel$export(module.exports, "globalStyles", () => $6c81c6ca145dc529$export$aa0e86c7c0d2f400);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression */ // Styles have been copied to packages/editor/generative-ai-modal/examples/utils/components/Modals.tsx
// Updates to this file should also be copied to there.

var $byn9U = parcelRequire("byn9U");

var $25FYC = parcelRequire("25FYC");

var $XHGTv = parcelRequire("XHGTv");
// Where do we get this magic number 500?
// - The lowest product z-index we need to be below is 500 from the Feedback Collector.
// As well as the Editor toolbar popup menu, which is also 500.
// This allows us to be above the floating toolbar, but below the feedback collector.
// +2 because tables floating toolbar is +1.
const $6c81c6ca145dc529$var$MAX_Z_INDEX = 500;
// Where do we get this magic number 401?
// - The highest product z-index we need to be above is 401 from the floating toolbar*.
// *in Confluence and Bitbucket. It is 600px in Atlas & 511 in Jira, however that is a more niche case than the Feedback Collector,
// so this is a known trade-off until we have a better solution.
const $6c81c6ca145dc529$var$MIN_Z_INDEX = 402;
// Sets the z-index so it is not greater than the maximum, and less than the minimum.
let $6c81c6ca145dc529$var$akAiModalRegionZIndex = Math.min($6c81c6ca145dc529$var$MAX_Z_INDEX, Math.max($6c81c6ca145dc529$var$MIN_Z_INDEX, (0, $25FYC.akEditorFloatingPanelZIndex) + 2));
const $6c81c6ca145dc529$export$74b525449cc7cbd1 = 'ai-streaming-telepointer';
const $6c81c6ca145dc529$var$slideFadeIn = (0, $byn9U.keyframes)({
    from: {
        opacity: 0,
        transform: 'translateY(1rem)'
    },
    to: {
        opacity: 1,
        transform: 'translateY(0)'
    }
});
const $6c81c6ca145dc529$export$367b0302f2a047a4 = (0, $byn9U.css)`
	margin-top: 1rem;
	position: absolute;
	z-index: ${$6c81c6ca145dc529$var$akAiModalRegionZIndex};
	margin-right: -1rem;
	margin-left: -1rem;
	width: calc(var(--content-width) + 2rem);
	animation: ${$6c81c6ca145dc529$var$slideFadeIn} 0.2s ease-out;
	animation-fill-mode: forwards;

	@media (prefers-reduced-motion) {
		animation: none;
	}
`;
const $6c81c6ca145dc529$var$highlightStyles = (0, $byn9U.css)`
	background-color: ${"var(--ds-background-accent-blue-subtlest, #E9F2FF)"};

	border-bottom: 2px solid ${"var(--ds-background-accent-blue-subtler, #cce0ff)"};
`;
const $6c81c6ca145dc529$var$spellingErrorStyles = (0, $byn9U.css)`
	border-bottom: 2px solid ${"var(--ds-background-accent-magenta-subtle-hovered, #F797D2)"};
	border-bottom-style: dashed;
`;
const $6c81c6ca145dc529$var$autoCorrectStyles = (0, $byn9U.css)`
	border-bottom: 2px solid ${"var(--ds-text-accent-teal, #206A83)"};
	border-bottom-style: dotted;
`;
const $6c81c6ca145dc529$var$suggestionStyles = (0, $byn9U.css)`
	border-bottom: 2px solid ${"var(--ds-chart-red-bolder, #E2483D)"};
	cursor: pointer;
`;
const $6c81c6ca145dc529$var$suggestionSelectedStyles = (0, $byn9U.css)`
	border-bottom: 2px solid ${"var(--ds-chart-red-bolder, #E2483D)"};
	background-color: ${"var(--ds-background-accent-red-subtlest, #FFECEB)"};
	cursor: pointer;
`;
// override standard dropdown max-height 90vh to accomodate for long list of translation languages
const $6c81c6ca145dc529$var$translationsFloaingToolbarDropdownStyles = (0, $byn9U.css)`
	${(0, $XHGTv.getBooleanFF)('platform.editor.ai-translate-in-floating-toolbar_7dqkh') && (0, $XHGTv.getBooleanFF)('platform.editor.ai-enable-multi-lang-translation-prompts') ? `
  [aria-label="Annotation toolbar"], [aria-label="Selection toolbar"] {
    [data-role="droplistContent"] {
      max-height: 312px;
      overflow-x: hidden;
      [data-testid^="ak-editor-ai-selection-toolbar-translate-button"] [data-item-elem-before] > span {
        padding: 0;
      }
    }
    
  }
  
  ` : ''};
`;
const $6c81c6ca145dc529$export$aa0e86c7c0d2f400 = (aiThemeColor)=>{
    return (0, $byn9U.css)`
		${$6c81c6ca145dc529$var$translationsFloaingToolbarDropdownStyles}
		.akEditor div.ProseMirror {
			.ai-modal-start-widget,
			.ai-modal-end-widget {
				position: relative;

				&::before {
					content: '';
					background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMyIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDMgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMSAxSDBMMSAxLjg1NzE0VjE4LjE0MzNMMCAxOS4wMDA0SDNMMiAxOC4xNDMzVjEuODU3MTRMMyAxSDJIMVoiIGZpbGw9IiM1NzlERkYiLz4KPHJlY3QgeT0iMTkiIHdpZHRoPSIzIiBoZWlnaHQ9IjEiIGZpbGw9IiM1NzlERkYiLz4KPHJlY3Qgd2lkdGg9IjMiIGhlaWdodD0iMSIgZmlsbD0iIzU3OURGRiIvPgo8L3N2Zz4K');
					z-index: 1;
					display: block;
					position: absolute;
					top: 0;
					bottom: ${"var(--ds-space-negative-025, -2px)"}; // match highlight height + border
					background-repeat: no-repeat;
					background-position-x: center;
					background-position-y: center;
					background-size: contain;
					aspect-ratio: 3/20; // svg (width / height)
				}
			}

			.ai-modal-start-widget::before {
				left: 0px;
				margin-left: -0.1em;
			}

			.ai-modal-end-widget::before {
				right: 0px;
				margin-right: -0.1em;
			}

			.ai-generated-content-highlight {
				${$6c81c6ca145dc529$var$highlightStyles}
			}

			.ai-selection-highlight {
				${$6c81c6ca145dc529$var$highlightStyles}

				// selection from the right
      &.ak-editor-annotation-draft,
      &.ak-editor-annotation-focus,
      &.ak-editor-annotation-blur {
					all: unset;

					${$6c81c6ca145dc529$var$highlightStyles}
				}
			}

			// selection from the left
			.annotationView-content-wrap {
				.ak-editor-annotation-draft,
				.ak-editor-annotation-focus,
				.ak-editor-annotation-blur {
					&:has(.ai-selection-highlight) {
						all: unset;

						${$6c81c6ca145dc529$var$highlightStyles}
					}
				}
			}

			// Spelling grammar styles
			.ai-spelling-error {
				${$6c81c6ca145dc529$var$spellingErrorStyles}
			}

			.ai-auto-correct {
				${$6c81c6ca145dc529$var$autoCorrectStyles}
			}

			.ai-suggestions {
				${$6c81c6ca145dc529$var$suggestionStyles}
				.ak-editor-annotation-draft,
        .ak-editor-annotation-blur,
        .ak-editor-annotation-focus {
					border-bottom: inherit;
					box-shadow: inherit;
				}
			}

			.ai-suggestions-selected {
				${$6c81c6ca145dc529$var$suggestionSelectedStyles}
				.ak-editor-annotation-draft,
        .ak-editor-annotation-blur,
        .ak-editor-annotation-focus {
					border-bottom: inherit;
					box-shadow: inherit;
					background-color: inherit;
				}
			}
		}

		// Reduce annotation button padding as per designs
		button[data-testid='ak-editor-ai-selection-toolbar-ai-button'],
		button[data-testid='ak-editor-ai-selection-toolbar-ai-button']:disabled,
		button[data-testid='ak-editor-ai-selection-toolbar-ai-button']:hover,
		button[data-testid='ak-editor-ai-selection-toolbar-ai-button']:focus,
		button[data-testid='ak-editor-annotation-toolbar-create-button'],
		button[data-testid='ak-editor-annotation-toolbar-create-button']:disabled,
		button[data-testid='ak-editor-annotation-toolbar-create-button']:hover,
		button[data-testid='ak-editor-annotation-toolbar-create-button']:focus {
			padding: 0px ${"var(--ds-space-100, 8px)"};
		}

		button[data-testid='ak-editor-ai-selection-toolbar-ai-button'] svg {
			padding-right: ${"var(--ds-space-050, 4px)"};
		}

		button[data-testid='ak-editor-ai-selection-toolbar-ai-button'] > span:only-child {
			svg {
				padding: 0px ${"var(--ds-space-100, 8px)"};
			}
		}
	`;
};

});

parcelRegister("ebMIO", function(module, exports) {

$parcel$export(module.exports, "getDecorationBottom", () => $a547e2e0fa3dfe86$export$e5c90390ba23af34);
$parcel$export(module.exports, "getResizableOrBreakoutWrapper", () => $a547e2e0fa3dfe86$export$9e4eede810cdf154);

var $mJhHc = parcelRequire("mJhHc");

var $2zbl1 = parcelRequire("2zbl1");

var $XHGTv = parcelRequire("XHGTv");
const $a547e2e0fa3dfe86$export$e5c90390ba23af34 = (modalDecorationElement, targetWrapper)=>{
    let decorationBottom = modalDecorationElement.offsetTop;
    let tempOffsetParent = modalDecorationElement.offsetParent;
    if (!targetWrapper || !tempOffsetParent) return decorationBottom + modalDecorationElement.offsetHeight;
    while(tempOffsetParent !== targetWrapper){
        if (!tempOffsetParent.classList.contains('fabric-editor-popup-scroll-parent')) decorationBottom = decorationBottom + tempOffsetParent.offsetTop;
        tempOffsetParent = tempOffsetParent.offsetParent;
    }
    return decorationBottom + modalDecorationElement.offsetHeight;
};
function $a547e2e0fa3dfe86$export$9e4eede810cdf154(editorView, position) {
    let resolvedPos = editorView.state.doc.resolve(position);
    const { nodes: nodes, marks: marks } = editorView.state.schema;
    const domAtPos = editorView.domAtPos.bind(editorView);
    /**
   * At the moment, the table node is the only resizable node
   * which can trigger the AI modal.
   */ const resizableNode = (0, $2zbl1.findParentNodeClosestToPos)(resolvedPos, (currentNode)=>currentNode.type === nodes.table);
    if (resizableNode) {
        const resizableDomNode = (0, $2zbl1.findDomRefAtPos)(resizableNode.start, domAtPos);
        if ((0, $XHGTv.getBooleanFF)('platform.editor.explicit-html-element-check')) {
            if (resizableDomNode instanceof HTMLElement) {
                /**
         * At the moment this only resizable tables need to be handled
         * hence why we use the table resizer class name specifically.
         */ const resizableWrapper = resizableDomNode.closest(`.${(0, $mJhHc.TableSharedCssClassName).TABLE_RESIZER_CONTAINER}`);
                if (resizableWrapper instanceof HTMLElement) return resizableWrapper;
            }
        } else if (resizableDomNode) {
            /**
         * At the moment this only resizable tables need to be handled
         * hence why we use the table resizer class name specifically.
         */ const resizableWrapper = resizableDomNode.closest(`.${(0, $mJhHc.TableSharedCssClassName).TABLE_RESIZER_CONTAINER}`);
            if (resizableWrapper) return resizableWrapper;
        }
    }
    const nodeWithBreakout = (0, $2zbl1.findParentNodeClosestToPos)(resolvedPos, (currentNode)=>{
        return currentNode.type === nodes.table && currentNode.attrs.layout !== 'default' || currentNode.marks.some((mark)=>mark.type === marks.breakout);
    });
    if (!nodeWithBreakout) return;
    const domNodeWithBreakout = (0, $2zbl1.findDomRefAtPos)(nodeWithBreakout.start, domAtPos);
    if ((0, $XHGTv.getBooleanFF)('platform.editor.explicit-html-element-check') && !(domNodeWithBreakout instanceof HTMLElement)) return;
    if (!domNodeWithBreakout) return;
    if ([
        nodes.layoutSection,
        nodes.expand
    ].includes(nodeWithBreakout.node.type)) return domNodeWithBreakout.parentElement || undefined;
    if (nodeWithBreakout.node.type === nodes.table) {
        if ((0, $XHGTv.getBooleanFF)('platform.editor.explicit-html-element-check')) {
            const closest = domNodeWithBreakout.closest(`.${(0, $mJhHc.TableSharedCssClassName).TABLE_CONTAINER}`);
            return closest instanceof HTMLElement ? closest : undefined;
        } else return domNodeWithBreakout.closest(`.${(0, $mJhHc.TableSharedCssClassName).TABLE_CONTAINER}`) || undefined;
    }
}

});

parcelRegister("cM5Qn", function(module, exports) {

$parcel$export(module.exports, "debounce", () => $94ce80309fed71e1$export$61fc7d43ac8f84b0);
/**
 *
 * debounces the function to be called once before or after specified interval
 *
 * @param {DebounceFunction} func - function to be debounced
 * @param {number} wait - time interval in milliseconds
 * @param {boolean} immediate - defines whether debounced function is called in the beginning or end of the interval
 * if true: The wrapped function is called immediately and then waits for the debounce interval before allowing further calls.
 * if false: The wrapped function is called after the debounce interval has elapsed since the last call to the wrapped function.
 *
 * Usage:
 * ```typescript
 *    const myFunction = () => {  };
 *    const [ myFunctionDebounced, clear ] = debounce(myFunction, 200);
 *    // calling the debounced function few times
 *    for (let i = 0; i < 3; i++) { myFunctionDebounced(); }
 *    // myFunction will be called only once, 200ms after the last call
 *
 *    clear(); //clears timeout to stop any remaining functions from calling
 * ```
 */ /**
 * @param  {DebounceFunction} func
 * @param  {number} wait
 * @param  {} immediate=false
 * @returns DebounceResult
 */ function $94ce80309fed71e1$export$61fc7d43ac8f84b0(func, wait, immediate = false) {
    let timeout;
    const debouncedFunction = function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const context = this;
        const later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
    const clear = function() {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
    };
    return [
        debouncedFunction,
        clear
    ];
}

});

parcelRegister("i3fEa", function(module, exports) {

$parcel$export(module.exports, "default", () => $d244a4f263d42237$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $d244a4f263d42237$export$91249d6c9b15807 = 'ai-height-div';
/**
 * whenever we update modal size - we want to update editor size to accommodate for it
 * This hook listens for modal size changes, and updates editor content area height accordingly
 */ function $d244a4f263d42237$var$useUpdateEditorHeight({ modalElement: modalElement, editorViewElement: editorViewElement }) {
    const heightDivRef = (0, $eUqFw.useRef)(null);
    // listen to changes to modal size
    (0, $eUqFw.useEffect)(()=>{
        if (!modalElement) return;
        const resizeObserver = new ResizeObserver((entries)=>{
            if (!heightDivRef.current || !modalElement) return;
            const modalEntry = entries.find((e)=>e.target === modalElement);
            // entry should always exist for modaRef as we're observing on it, this check makes ts happy
            if (!modalEntry) return;
            const modalBottom = modalEntry.target.offsetTop + modalEntry.contentRect.height;
            const editorBottom = editorViewElement.offsetTop + editorViewElement.offsetHeight;
            // The height of the extra div should be expanded to reach
            // the bottom of the modal -- so that no modal content is outside
            // the editor
            const heightToSet = Math.max(modalBottom - editorBottom, 0);
            heightDivRef.current.style.height = `${heightToSet}px`;
        });
        resizeObserver.observe(modalElement);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        modalElement,
        editorViewElement
    ]);
    // Create an element for adjusting height of editor when modal is visible
    (0, $eUqFw.useEffect)(()=>{
        if (heightDivRef.current) // In future react will fire useEffect twice in dev mode
        // this early exit avoids issues with this
        return;
        const newDiv = document.createElement('div');
        newDiv.className = $d244a4f263d42237$export$91249d6c9b15807;
        newDiv.style.height = `0px`;
        editorViewElement.parentNode.appendChild(newDiv);
        heightDivRef.current = newDiv;
        return ()=>{
            var _editorViewElement$pa;
            (_editorViewElement$pa = editorViewElement.parentNode) === null || _editorViewElement$pa === void 0 || _editorViewElement$pa.removeChild(newDiv);
        };
    }, [
        editorViewElement
    ]);
}
var $d244a4f263d42237$export$2e2bcd8739ae039 = $d244a4f263d42237$var$useUpdateEditorHeight;

});


parcelRegister("b6fWz", function(module, exports) {

$parcel$export(module.exports, "aiActorCache", () => $814c9f519849dca8$export$eca6b7572eaa53aa);

var $a4kch = parcelRequire("a4kch");

var $cXnmp = parcelRequire("cXnmp");
/**
 * Weakmap cache for caching an [actor](https://xstate.js.org/docs/guides/actors.html#actor-api)
 * per EditorView.
 *
 * It contains a convenience function for returning an actor if it exists in the cache (`getActor`)
 */ class $814c9f519849dca8$var$AIActorCache extends WeakMap {
    /**
   * Returns an actor if it exists in the cache or creates and starts a new one.
   *
   * @param editorView
   * @returns [actor](https://xstate.js.org/docs/guides/actors.html#actor-api)
   */ getActor(editorView) {
        if (this.has(editorView)) return this.get(editorView);
        const editorPluginAIActor = (0, $a4kch.interpret)((0, $cXnmp.editorPluginAIMachine));
        editorPluginAIActor.start();
        $814c9f519849dca8$export$eca6b7572eaa53aa.set(editorView, editorPluginAIActor);
        return editorPluginAIActor;
    }
}
const $814c9f519849dca8$export$eca6b7572eaa53aa = new $814c9f519849dca8$var$AIActorCache();

});
parcelRegister("cXnmp", function(module, exports) {

$parcel$export(module.exports, "editorPluginAIMachine", () => $96ed1da38223158b$export$da9fe52c4382b67d);

var $8O42R = parcelRequire("8O42R");
const $96ed1da38223158b$export$da9fe52c4382b67d = (0, $8O42R.createMachine)({
    /** @xstate-layout N4IgpgJg5mDOIC5QFEIEsAuB7ATgBQBsBXKNAOwEEBJAYgGUAVCgJQYH1q3kANPZZqsgByAYWQBtAAwBdRKAAOWWJjRYyckAA9EAWgCMkgKwAOAHQBmAEzHJAFmOWrtgGx7LAGhABPXc9OWATlsAdj1zY2cAy2dDMOMAX3jPVExcQhJyalNqAAIAWSwIAEMCHKKAYww0ADcwGk4RAHkhBmF2KiE6flaAESlZJBBFZSq1DW0EHXtg0z1bEODDcwDJZ0tDTx8EPWMzG0t14xMdw0MYxOT0bHxiUkoqbKp8wpKyypq6vMaeigAZNh6VDoIhYPWQfRkGmGKjGgwmOmCtkM-ii6xMKyRRk2uj0zhmlkkK0swRW5nCkiMFxAKWu6TuWVyBWKpQqVVqNC+P3+HQAan8qD9ev0oUoYeo4bpzCZTMFzLY9EtjMFic5drZsZM9FFZrtLEjlUjzJFnFSaWlbpkHrkRGoMGAyBgcgAJNBQAAWBFdbrtEHoyF+yBEDCozTYIidFCEAHFwcLBtDRuLQBN7KYzs41qtJNYAgEMxr9HoZWtbOZJFLVnLYsFEkkQGRCnANGabhl7iKRqok1ocQY-FYbPZHHrXB5vL5s6Y8UFgs5bI4DAk6y26ZbTEIsDlcmBNPIwDg0PbymA3mywB2xeNfLj-MFFkrjCs1htx5Nln49CSXEsAm5c7ZTSuc02wZJ4mVeVkPgvRMr0mVw-GJe9gkfVZ1g1ZxzBlAJFkMQIkSiZxJBrZcgNbekrSeG0HXtR0XXdT13R9aCu1gnR4NvWcwnlAlcT0DVoksUwHEkT9Vi1O9sPMWt4iAA */ id: 'EditorPluginAI',
    description: `This machine models the high level functionality of the EditorPluginAI.

Currently this logic is split across prosemirror, xstate, and elsewhere.

The intention is to migrate to a single source of truth, backed by a state machine.`,
    states: {
        'No AI experience active': {
            description: `When an Editor is first started up with an editor-plugin-ai EditorPlugin - it will start in this state.

This state will be returned to when an ai experience is either discarded or completed.`
        },
        'AI Modal active': {
            on: {
                AI_CONTENT_INSERTED: 'AI Content Highlighted',
                MODAL_DISCARDED: {
                    target: 'No AI experience active',
                    description: `This transition is intended to model when a user makes an explicit decision to clear the modal.`
                },
                MODAL_INVALIDATED: {
                    target: 'No AI experience active',
                    description: `This transition is intended to model when an AI experience is ended due to the modal no longer being valid.

For example, if it's been linked to a selection, and another user collaborating on the document deletes the selected content.

In future we might expect this to go to an alternate state.`
                }
            },
            description: `Currently there is a seperate xstate state machine which is run when the ai modal is active.
Over time we can expect to link these state machines.`
        },
        'AI Content Highlighted': {
            on: {
                SELECTION_CHANGED: {
                    target: 'No AI experience active',
                    description: `This transition models when a user interacts with a document following the insertion of content via AI.`
                }
            },
            description: `Following content being inserted, the inserted content is highlighted so the user is able to understand the impact of inserting the generated content into the document.

This highlight is persisted either until the user changes makes a selection change in the document or the content is removed from the document (ie. via collab editing sessions)`
        }
    },
    on: {
        START_AI_EXPERIENCE: {
            target: 'AI Modal active',
            description: `We expect AI Experiences to be started in a variety of ways including;
- via the slash command/typeahead
- via the toolbar quick insert menu
- via the toolbar ai button
- via external actions (ie. atlas have a button outside the editor which starts an ai experience)

Only one AI experience can be active at a single time in an Editor.  If another AI experience is active when the user starts a new AI experience, the prior experience is replaced/reset with the new experience details.`
        }
    },
    initial: 'No AI experience active'
});

});


parcelRegister("9PopJ", function(module, exports) {

$parcel$export(module.exports, "createSelectionPreviewPlugin", () => $727bd0983c593841$export$6b0a857b1a5189ef);

var $fBDHJ = parcelRequire("fBDHJ");

var $8dq9E = parcelRequire("8dq9E");

var $R7bnX = parcelRequire("R7bnX");

var $2KDKi = parcelRequire("2KDKi");

var $9O1Gs = parcelRequire("9O1Gs");
const $727bd0983c593841$export$6b0a857b1a5189ef = ()=>{
    return new (0, $R7bnX.SafePlugin)({
        key: (0, $8dq9E.selectionPreviewPluginKey),
        state: {
            init: (_, state)=>({
                    selectionPreview: false
                }),
            apply: (tr, _pluginState, _oldEditorState)=>{
                if (tr.getMeta('showSelectionPreview')) return {
                    selectionPreview: true
                };
                if (tr.getMeta('hideSelectionPreview')) return {
                    selectionPreview: false
                };
                return _pluginState;
            }
        },
        props: {
            decorations: (editorState)=>{
                const pluginState = (0, $8dq9E.selectionPreviewPluginKey).getState(editorState);
                if (pluginState.selectionPreview) {
                    const { modalDecorationSet: modalDecorationSet } = (0, $9O1Gs.getPluginState)(editorState);
                    const modalDecorations = modalDecorationSet.find(0, editorState.doc.content.size);
                    const existingHighlightDecoration = modalDecorations.filter((x)=>{
                        var _x$spec;
                        return (x === null || x === void 0 ? void 0 : (_x$spec = x.spec) === null || _x$spec === void 0 ? void 0 : _x$spec.key) === 'inlineDecoration';
                    })[0];
                    if (!existingHighlightDecoration) {
                        const highlightDecoration = (0, $2KDKi.createInlineDecoration)(0, editorState.doc.content.size);
                        return (0, $fBDHJ.DecorationSet).create(editorState.doc, [
                            highlightDecoration
                        ]);
                    }
                }
                return (0, $fBDHJ.DecorationSet).empty;
            }
        }
    });
};

});
parcelRegister("8dq9E", function(module, exports) {

$parcel$export(module.exports, "selectionPreviewPluginKey", () => $5fb3d3652d6a2459$export$382457814c88610e);

var $kpTIW = parcelRequire("kpTIW");
const $5fb3d3652d6a2459$export$382457814c88610e = new (0, $kpTIW.PluginKey)('aiExperienceSelectionPreview');

});


parcelRegister("dWb99", function(module, exports) {

$parcel$export(module.exports, "createAIPlaceholderPlugin", () => $a25956a4a8e18dc3$export$6f4310b671fff937);

var $jMQbs = parcelRequire("jMQbs");
var $gTPew = parcelRequire("gTPew");
var $fS4LS = parcelRequire("fS4LS");

var $fBDHJ = parcelRequire("fBDHJ");

var $R7bnX = parcelRequire("R7bnX");

var $c64AB = parcelRequire("c64AB");

var $hja73 = parcelRequire("hja73");
const $a25956a4a8e18dc3$export$a76584009ca8faeb = {
    hasPlaceholder: false
};
const $a25956a4a8e18dc3$export$53e9a5af7ff64f3e = 'ai-placeholder-test-id';
function $a25956a4a8e18dc3$var$getPlaceholderState(editorState) {
    return (0, $c64AB.aiPlaceholderPluginKey).getState(editorState);
}
function $a25956a4a8e18dc3$export$980ea07f18fbfea9(editorState, placeholderText, pos = 1) {
    const placeholderDecoration = document.createElement('span');
    let placeholderNodeWithText = placeholderDecoration;
    placeholderDecoration.setAttribute('data-testid', $a25956a4a8e18dc3$export$53e9a5af7ff64f3e);
    placeholderDecoration.setAttribute('aria-hidden', 'true');
    placeholderDecoration.className = 'placeholder-decoration';
    // PM sets contenteditable to false on Decorations so Firefox doesn't display the flashing cursor
    // So adding an extra span which will contain the placeholder text
    if ((0, $jMQbs.default).gecko) {
        const placeholderNode = document.createElement('span');
        placeholderNode.setAttribute('contenteditable', 'true'); // explicitly overriding the default Decoration behaviour
        placeholderDecoration.appendChild(placeholderNode);
        placeholderNodeWithText = placeholderNode;
    }
    placeholderNodeWithText.textContent = placeholderText || ' ';
    // ME-2289 Tapping on backspace in empty editor hides and displays the keyboard
    // Add a editable buff node as the cursor moving forward is inevitable
    // when backspace in GBoard composition
    if ((0, $jMQbs.default).android && (0, $jMQbs.default).chrome) {
        const buffNode = document.createElement('span');
        buffNode.setAttribute('class', 'placeholder-android');
        buffNode.setAttribute('contenteditable', 'true');
        buffNode.textContent = ' ';
        placeholderDecoration.appendChild(buffNode);
    }
    return (0, $fBDHJ.DecorationSet).create(editorState.doc, [
        (0, $fBDHJ.Decoration).widget(pos, placeholderDecoration, {
            side: 0,
            key: 'placeholder'
        })
    ]);
}
function $a25956a4a8e18dc3$export$994f2cc3924c6a0c(placeholder, editorState, removePlaceholder) {
    if (!removePlaceholder && $a25956a4a8e18dc3$export$a5bdf43f7dda8fe1(editorState) && editorState.selection.$from.depth === 1 && !(0, $gTPew.isEmptyDocument)(editorState.doc) && (0, $fS4LS.isParagraphNode)(editorState.selection.$from.node())) return $a25956a4a8e18dc3$var$setPlaceholderState(placeholder, editorState.selection.$from.pos);
    return $a25956a4a8e18dc3$export$a76584009ca8faeb;
}
function $a25956a4a8e18dc3$var$setPlaceholderState(placeholderText, pos) {
    return {
        hasPlaceholder: true,
        placeholderText: placeholderText,
        pos: pos ? pos : 1
    };
}
function $a25956a4a8e18dc3$export$a5bdf43f7dda8fe1(state) {
    const { $from: $from, empty: empty } = state.selection;
    return empty && $from.parentOffset === 0 && $from.parent.content.size === 0;
}
function $a25956a4a8e18dc3$var$shouldRemovePlaceholder(state, api) {
    var _api$editorViewMode, _api$editorViewMode$s, _api$editorViewMode$s2, _api$typeAhead, _api$typeAhead$action;
    // check if editorViewMode plugin exists, and if it's in view mode
    const isViewMode = (api === null || api === void 0 ? void 0 : api.editorViewMode) && (api === null || api === void 0 ? void 0 : (_api$editorViewMode = api.editorViewMode) === null || _api$editorViewMode === void 0 ? void 0 : (_api$editorViewMode$s = _api$editorViewMode.sharedState) === null || _api$editorViewMode$s === void 0 ? void 0 : (_api$editorViewMode$s2 = _api$editorViewMode$s.currentState()) === null || _api$editorViewMode$s2 === void 0 ? void 0 : _api$editorViewMode$s2.mode) === 'view';
    // check if api is available and if typeAhead plugin exists
    const isTypeAheadOpen = api === null || api === void 0 ? void 0 : (_api$typeAhead = api.typeAhead) === null || _api$typeAhead === void 0 ? void 0 : (_api$typeAhead$action = _api$typeAhead.actions) === null || _api$typeAhead$action === void 0 ? void 0 : _api$typeAhead$action.isOpen(state);
    const placeholderState = $a25956a4a8e18dc3$var$getPlaceholderState(state);
    return (placeholderState === null || placeholderState === void 0 ? void 0 : placeholderState.hasPlaceholder) && (isViewMode || isTypeAheadOpen);
}
/**
 * @deprecated This method is deprecated and should be cleaned up once all products using AI
 * are on composable editor.
 */ function $a25956a4a8e18dc3$var$deprecatedShouldRemovePlaceholder(state) {
    var _typeAheadPlugin$getS, _typeAheadPlugin$getS2;
    const editorViewModePlugin = state.plugins.find((plugin)=>plugin.key === 'editorViewMode$');
    const editorViewModePluginState = editorViewModePlugin === null || editorViewModePlugin === void 0 ? void 0 : editorViewModePlugin.getState(state);
    // check if api is available and if editorViewMode plugin exists
    const isViewMode = editorViewModePluginState && (editorViewModePluginState === null || editorViewModePluginState === void 0 ? void 0 : editorViewModePluginState.mode) === 'view';
    // check if typeahead is open -> dispatch a tr that removes the placeholder
    const typeAheadPlugin = state.plugins.find((plugin)=>plugin.key === 'typeAheadPlugin$');
    // check if api is available and if typeAhead plugin exists
    const isTypeAheadOpen = typeAheadPlugin && ((_typeAheadPlugin$getS = typeAheadPlugin.getState(state)) === null || _typeAheadPlugin$getS === void 0 ? void 0 : (_typeAheadPlugin$getS2 = _typeAheadPlugin$getS.decorationSet) === null || _typeAheadPlugin$getS2 === void 0 ? void 0 : _typeAheadPlugin$getS2.find().length) > 0;
    const placeholderState = $a25956a4a8e18dc3$var$getPlaceholderState(state);
    return (placeholderState === null || placeholderState === void 0 ? void 0 : placeholderState.hasPlaceholder) && (isViewMode || isTypeAheadOpen);
}
function $a25956a4a8e18dc3$export$6f4310b671fff937({ getIntl: getIntl, api: api }) {
    const persistentPlaceholderText = getIntl().formatMessage((0, $hja73.default).persistentPlaceholderText);
    return new (0, $R7bnX.SafePlugin)({
        key: (0, $c64AB.aiPlaceholderPluginKey),
        state: {
            init: (_, state)=>{
                return $a25956a4a8e18dc3$export$994f2cc3924c6a0c(persistentPlaceholderText, state, // TODO Clean up deprecated usage once it is expected that all
                // products are using composable editor
                api ? $a25956a4a8e18dc3$var$shouldRemovePlaceholder(state, api) : $a25956a4a8e18dc3$var$deprecatedShouldRemovePlaceholder(state));
            },
            apply: (tr, _pluginState, _oldEditorState, newEditorState)=>{
                var _tr$getMeta;
                return $a25956a4a8e18dc3$export$994f2cc3924c6a0c(persistentPlaceholderText, newEditorState, Boolean((_tr$getMeta = tr.getMeta((0, $c64AB.aiPlaceholderPluginKey))) === null || _tr$getMeta === void 0 ? void 0 : _tr$getMeta.aiPlaceholderRemove));
            }
        },
        appendTransaction: (_transactions, _oldState, newState)=>{
            if (// TODO Clean up deprecated usage once it is expected that all
            // products are using composable editor
            api ? $a25956a4a8e18dc3$var$shouldRemovePlaceholder(newState, api) : $a25956a4a8e18dc3$var$deprecatedShouldRemovePlaceholder(newState)) return newState.tr.setMeta((0, $c64AB.aiPlaceholderPluginKey), {
                aiPlaceholderRemove: true
            });
            return;
        },
        props: {
            decorations (editorState) {
                const placeholderState = $a25956a4a8e18dc3$var$getPlaceholderState(editorState);
                if (placeholderState.hasPlaceholder && placeholderState.placeholderText && placeholderState.pos !== undefined) return $a25956a4a8e18dc3$export$980ea07f18fbfea9(editorState, placeholderState.placeholderText, placeholderState.pos);
                return;
            }
        }
    });
}

});
parcelRegister("gTPew", function(module, exports) {

$parcel$export(module.exports, "getStepRange", () => $3ab08e030258eab5$export$c8e611b6ac095e6d);
$parcel$export(module.exports, "hasDocAsParent", () => $3ab08e030258eab5$export$f76a7d770092ea11);
$parcel$export(module.exports, "isEmptyDocument", () => $3ab08e030258eab5$export$2da47a16c0b6bcb);
$parcel$export(module.exports, "bracketTyped", () => $3ab08e030258eab5$export$df0539d254c75c33);
$parcel$export(module.exports, "nodesBetweenChanged", () => $3ab08e030258eab5$export$f9e52d2e832a6aae);
$parcel$export(module.exports, "processRawValue", () => $3ab08e030258eab5$export$f1a0a61081c3ed62);
$parcel$export(module.exports, "hasVisibleContent", () => $3ab08e030258eab5$export$c9083db5521330d3);
$parcel$export(module.exports, "isSelectionEndOfParagraph", () => $3ab08e030258eab5$export$435c1d4e61a8723b);
$parcel$export(module.exports, "getChangedNodes", () => $3ab08e030258eab5$export$fd9c3e0f31aab835);

var $lcbyi = parcelRequire("lcbyi");
var $be9hM = parcelRequire("be9hM");
var $kYqSX = parcelRequire("kYqSX");
var $8RPsP = parcelRequire("8RPsP");
var $1vRU4 = parcelRequire("1vRU4");
var $rjHJO = parcelRequire("rjHJO");

var $7dkLM = parcelRequire("7dkLM");

var $auyn4 = parcelRequire("auyn4");

var $1ufWw = parcelRequire("1ufWw");

var $g9J6K = parcelRequire("g9J6K");

var $2pBoL = parcelRequire("2pBoL");

var $9EOM6 = parcelRequire("9EOM6");
const $3ab08e030258eab5$export$c8e611b6ac095e6d = (transaction)=>{
    let from = -1;
    let to = -1;
    transaction.mapping.maps.forEach((stepMap, index)=>{
        stepMap.forEach((oldStart, oldEnd)=>{
            const newStart = transaction.mapping.slice(index).map(oldStart, -1);
            const newEnd = transaction.mapping.slice(index).map(oldEnd);
            from = newStart < from || from === -1 ? newStart : from;
            to = newEnd > to || to === -1 ? newEnd : to;
        });
    });
    if (from !== -1) return {
        from: from,
        to: to
    };
    return null;
};
function $3ab08e030258eab5$export$f76a7d770092ea11($anchor) {
    return $anchor.depth === 1;
}
function $3ab08e030258eab5$export$2da47a16c0b6bcb(node) {
    const nodeChild = node.content.firstChild;
    if (node.childCount !== 1 || !nodeChild) return false;
    return (0, $1ufWw.isEmptyParagraph)(nodeChild);
}
function $3ab08e030258eab5$export$df0539d254c75c33(state) {
    const { selection: selection } = state;
    const { $cursor: $cursor, $anchor: $anchor } = selection;
    if (!$cursor) return false;
    const node = $cursor.nodeBefore;
    if (!node) return false;
    if (node.type.name === 'text' && node.text === '{') {
        const paragraphNode = $anchor.node();
        return paragraphNode.marks.length === 0 && $3ab08e030258eab5$export$f76a7d770092ea11($anchor);
    }
    return false;
}
function $3ab08e030258eab5$export$f9e52d2e832a6aae(tr, f, startPos) {
    const stepRange = $3ab08e030258eab5$export$c8e611b6ac095e6d(tr);
    if (!stepRange) return;
    tr.doc.nodesBetween(stepRange.from, stepRange.to, f, startPos);
}
function $3ab08e030258eab5$export$f1a0a61081c3ed62(schema, value, providerFactory, sanitizePrivateContent, contentTransformer, dispatchAnalyticsEvent) {
    if (!value) return;
    let node;
    if (typeof value === 'string') try {
        if (contentTransformer) {
            const doc = contentTransformer.parse(value);
            node = doc.toJSON();
        } else node = JSON.parse(value);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(`Error processing value: ${value} isn't a valid JSON`);
        return;
    }
    else node = value;
    if (Array.isArray(node)) {
        // eslint-disable-next-line no-console
        console.error(`Error processing value: ${node} is an array, but it must be an object.`);
        return;
    }
    try {
        // ProseMirror always require a child under doc
        if (node.type === 'doc') {
            if (Array.isArray(node.content) && node.content.length === 0) node.content.push({
                type: 'paragraph',
                content: []
            });
            // Just making sure doc is always valid
            if (!node.version) node.version = 1;
        }
        if (contentTransformer) return (0, $7dkLM.Node).fromJSON(schema, node);
        // link mark on mediaSingle is deprecated, need to move link mark to child media node
        // https://product-fabric.atlassian.net/browse/ED-14043
        let { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $8RPsP.transformMediaLinkMarks)(node);
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $auyn4.ACTION).MEDIA_LINK_TRANSFORMED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
        });
        // See: HOT-97965 https://product-fabric.atlassian.net/browse/ED-14400
        // We declared in code mark spec that links and marks should not co-exist on
        // text nodes. This util strips code marks from bad text nodes and preserves links.
        // Otherwise, prosemirror will try to repair the invalid document by stripping links
        // and preserving code marks during content changes.
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $rjHJO.transformTextLinkCodeMarks)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $auyn4.ACTION).TEXT_LINK_MARK_TRANSFORMED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
        });
        let discardedMarks = [];
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed, discardedMarks: discardedMarks } = (0, $lcbyi.transformDedupeMarks)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $auyn4.ACTION).DEDUPE_MARKS_TRANSFORMED_V2,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL,
            attributes: {
                /** UGC WARNING
					 *
					 * DO NOT include the `mark` attributes inside, we map here to only
					 * extract the mark type as that is the only non-UGC safe information
					 * that we can add to event-attributes
					 *
					 */ discardedMarkTypes: discardedMarks.map((mark)=>mark.type)
            }
        });
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $1vRU4.transformNodesMissingContent)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $auyn4.ACTION).NODES_MISSING_CONTENT_TRANSFORMED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
        });
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $be9hM.transformIndentationMarks)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $auyn4.ACTION).INDENTATION_MARKS_TRANSFORMED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
        });
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $kYqSX.transformInvalidMediaContent)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $auyn4.ACTION).INVALID_MEDIA_CONTENT_TRANSFORMED,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
        });
        const entity = (0, $9EOM6.validateADFEntity)(schema, transformedAdf || node, dispatchAnalyticsEvent);
        let newEntity = $3ab08e030258eab5$var$maySanitizePrivateContent(entity, providerFactory, sanitizePrivateContent);
        const parsedDoc = (0, $7dkLM.Node).fromJSON(schema, newEntity);
        // throws an error if the document is invalid
        try {
            parsedDoc.check();
        } catch (err) {
            if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                action: (0, $auyn4.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
                actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
                eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
            });
            throw err;
        }
        if (dispatchAnalyticsEvent) (0, $2pBoL.findAndTrackUnsupportedContentNodes)(parsedDoc, schema, dispatchAnalyticsEvent);
        return parsedDoc;
    } catch (e) {
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $auyn4.ACTION).DOCUMENT_PROCESSING_ERROR,
            actionSubject: (0, $auyn4.ACTION_SUBJECT).EDITOR,
            eventType: (0, $auyn4.EVENT_TYPE).OPERATIONAL
        });
        // eslint-disable-next-line no-console
        console.error(`Error processing document:\n${e instanceof Error ? e.message : String(e)}\n\n`, JSON.stringify(node));
        if ($3ab08e030258eab5$var$isProseMirrorSchemaCheckError(e)) throw e;
        return;
    }
}
function $3ab08e030258eab5$var$isProseMirrorSchemaCheckError(error) {
    return error instanceof RangeError && (!!error.message.match(/^Invalid collection of marks for node/) || !!error.message.match(/^Invalid content for node/));
}
const $3ab08e030258eab5$var$maySanitizePrivateContent = (entity, providerFactory, sanitizePrivateContent)=>{
    if (sanitizePrivateContent && providerFactory) return (0, $g9J6K.sanitizeNodeForPrivacy)(entity, providerFactory);
    return entity;
};
function $3ab08e030258eab5$export$c9083db5521330d3(node) {
    const isInlineNodeHasVisibleContent = (inlineNode)=>{
        return inlineNode.isText ? !!inlineNode.textContent.trim() : inlineNode.type.name !== 'hardBreak';
    };
    if (node.isInline) return isInlineNodeHasVisibleContent(node);
    else if (node.isBlock && (node.isLeaf || node.isAtom)) return true;
    else if (!node.childCount) return false;
    for(let index = 0; index < node.childCount; index++){
        const child = node.child(index);
        const invisibleNodeTypes = [
            'paragraph',
            'text',
            'hardBreak'
        ];
        if (!invisibleNodeTypes.includes(child.type.name) || $3ab08e030258eab5$export$c9083db5521330d3(child)) return true;
    }
    return false;
}
const $3ab08e030258eab5$export$435c1d4e61a8723b = (state)=>state.selection.$to.parent.type === state.schema.nodes.paragraph && state.selection.$to.pos === state.doc.resolve(state.selection.$to.pos).end();
function $3ab08e030258eab5$var$getChangedNodesIn({ tr: tr, doc: doc }) {
    const nodes = [];
    const stepRange = $3ab08e030258eab5$export$c8e611b6ac095e6d(tr);
    if (!stepRange) return nodes;
    const from = Math.min(doc.nodeSize - 2, stepRange.from);
    const to = Math.min(doc.nodeSize - 2, stepRange.to);
    doc.nodesBetween(from, to, (node, pos)=>{
        nodes.push({
            node: node,
            pos: pos
        });
    });
    return nodes;
}
function $3ab08e030258eab5$export$fd9c3e0f31aab835(tr) {
    return $3ab08e030258eab5$var$getChangedNodesIn({
        tr: tr,
        doc: tr.doc
    });
}

});
parcelRegister("lcbyi", function(module, exports) {

$parcel$export(module.exports, "transformDedupeMarks", () => $1926ffe65a54494e$export$af4e387303482581);

var $hYZXM = parcelRequire("hYZXM");
// This is the set of marks that we wont allow in duplicate to
// exist on a given node, regardless of their attributes. We do
// not include annotations here, because we do allow duplicate
// annotations as long as they have unique id attributes (valid scenario)
const $1926ffe65a54494e$var$markDuplicatesDisallowed = new Set([
    'strong',
    'underline',
    'textColor',
    'link',
    'em',
    'subsup',
    'strike',
    'backgroundColor'
]);
const $1926ffe65a54494e$var$maybeHasDisallowedDuplicateMarks = (node)=>{
    const markTypes = node.marks?.map((mark)=>mark.type)?.filter((markType)=>// For annotations, we are performing the same cheap check
        // for duplicates by type, without considering IDs, to quickly determine
        // whether there may be potential deduping targets.
        // In the actual deduping logic in maybeRemoveDisallowedDuplicateMarks,
        // we correctly/safely dedupe annotations by their unique IDs.
        $1926ffe65a54494e$var$markDuplicatesDisallowed.has(markType) || markType === 'annotation');
    if (!markTypes?.length) return false;
    return new Set(markTypes).size !== markTypes.length;
};
const $1926ffe65a54494e$var$maybeRemoveDisallowedDuplicateMarks = (node)=>{
    const quota = new Map();
    const annotationsQuota = new Map();
    const discardedMarks = [];
    $1926ffe65a54494e$var$markDuplicatesDisallowed.forEach((mark)=>{
        quota.set(mark, false);
    });
    if (!node.marks) return {
        discardedMarks: discardedMarks
    };
    let dedupedMarks = node.marks.filter((mark)=>{
        const markType = mark.type;
        if (markType === 'annotation') {
            const id = mark.attrs?.id;
            if (annotationsQuota.has(id)) {
                discardedMarks.push(mark);
                return false;
            } else {
                annotationsQuota.set(id, true);
                return true;
            }
        }
        if (quota.has(markType)) {
            if (!quota.get(markType)) {
                quota.set(markType, true);
                return true;
            } else {
                discardedMarks.push(mark);
                return false;
            }
        }
        return true;
    });
    return {
        node: {
            ...node,
            marks: dedupedMarks
        },
        discardedMarks: discardedMarks
    };
};
const $1926ffe65a54494e$export$af4e387303482581 = (adf)=>{
    let isTransformed = false;
    let discardedMarks = [];
    const transformedAdf = (0, $hYZXM.traverse)(adf, {
        text: (node)=>{
            if ($1926ffe65a54494e$var$maybeHasDisallowedDuplicateMarks(node)) {
                const result = $1926ffe65a54494e$var$maybeRemoveDisallowedDuplicateMarks(node);
                const resultDiscardedMarks = result.discardedMarks;
                if (resultDiscardedMarks.length) {
                    discardedMarks.push(...resultDiscardedMarks);
                    isTransformed = true;
                    return result.node;
                }
            }
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed,
        discardedMarks: discardedMarks
    };
};

});

parcelRegister("be9hM", function(module, exports) {

$parcel$export(module.exports, "transformIndentationMarks", () => $91a5ba4a526ddce7$export$c06e4b521519af22);

var $hYZXM = parcelRequire("hYZXM");
const $91a5ba4a526ddce7$var$hasChildHeadingWithIndentation = (node)=>node.content?.some((childNode)=>childNode?.type === 'heading' && childNode?.marks?.some((mark)=>mark.type === 'indentation')) ?? false;
const $91a5ba4a526ddce7$var$removeIndentationFromHeadings = (node)=>{
    return {
        ...node,
        content: node.content?.map((childNode)=>{
            if (childNode?.type === 'heading') return {
                ...childNode,
                marks: childNode.marks?.filter((mark)=>mark.type !== 'indentation')
            };
            return childNode;
        })
    };
};
const $91a5ba4a526ddce7$export$c06e4b521519af22 = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $hYZXM.traverse)(adf, {
        tableCell: (node)=>{
            if ($91a5ba4a526ddce7$var$hasChildHeadingWithIndentation(node)) {
                isTransformed = true;
                return $91a5ba4a526ddce7$var$removeIndentationFromHeadings(node);
            }
        },
        tableHeader: (node)=>{
            if ($91a5ba4a526ddce7$var$hasChildHeadingWithIndentation(node)) {
                isTransformed = true;
                return $91a5ba4a526ddce7$var$removeIndentationFromHeadings(node);
            }
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});

parcelRegister("kYqSX", function(module, exports) {

$parcel$export(module.exports, "transformInvalidMediaContent", () => $b233c2c5f4449714$export$1c8c16d74c7a63bf);

var $hYZXM = parcelRequire("hYZXM");

var $3o7y4 = parcelRequire("3o7y4");
const $b233c2c5f4449714$var$getChildrenTypeCounts = (nodeContent, allowedTypes)=>{
    let childrenTypes = {};
    nodeContent.forEach((childNode, index)=>{
        if (!childNode?.type || !allowedTypes.includes(childNode.type)) return;
        if (!childrenTypes[childNode.type]) {
            childrenTypes[childNode.type] = 1;
            return;
        }
        childrenTypes[childNode.type]++;
    });
    return childrenTypes;
};
const $b233c2c5f4449714$var$removeDuplicatedNodes = (type, content, predicate)=>{
    let maxIterations = 10;
    let childrenTypeCounts = $b233c2c5f4449714$var$getChildrenTypeCounts(content, [
        type
    ])[type];
    let firstPredicateNodeIndex = content.findIndex(predicate);
    while(childrenTypeCounts > 1 && firstPredicateNodeIndex > -1 && maxIterations-- > 0){
        content.splice(firstPredicateNodeIndex, 1);
        firstPredicateNodeIndex = content.findIndex(predicate);
        childrenTypeCounts = $b233c2c5f4449714$var$getChildrenTypeCounts(content, [
            type
        ])[type];
    }
};
/**
 * @param  {{[type:string]:number}} allowedTypes - array types allowed to deduplicate
 */ const $b233c2c5f4449714$var$deduplicateMediaSingleChildren = (node, allowedTypes)=>{
    if (!node.content) return;
    const content = [
        ...node.content
    ];
    Object.keys(allowedTypes).forEach((type)=>{
        //prioritise removing empty nodes first
        $b233c2c5f4449714$var$removeDuplicatedNodes(type, content, (node)=>node?.type === type && (0, $3o7y4.isEmpty)(node));
        //remove other remaining dupicates
        $b233c2c5f4449714$var$removeDuplicatedNodes(type, content, (node)=>node?.type === type);
    });
    return {
        ...node,
        content: content
    };
};
const $b233c2c5f4449714$export$1c8c16d74c7a63bf = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $hYZXM.traverse)(adf, {
        mediaSingle: (node)=>{
            if (!node?.content?.length) return;
            const disallowedDuplicateTypes = [
                'media',
                'caption'
            ];
            const childrenTypes = $b233c2c5f4449714$var$getChildrenTypeCounts(node.content, disallowedDuplicateTypes);
            if (Object.values(childrenTypes).some((occurences)=>occurences > 1)) {
                isTransformed = true;
                return $b233c2c5f4449714$var$deduplicateMediaSingleChildren(node, childrenTypes);
            }
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});
parcelRegister("3o7y4", function(module, exports) {

$parcel$export(module.exports, "isEmpty", () => $e439d27de8d77afc$export$dd1bc94b04021eeb);
const $e439d27de8d77afc$export$dd1bc94b04021eeb = (node)=>!node?.content?.length;

});


parcelRegister("1vRU4", function(module, exports) {

$parcel$export(module.exports, "transformNodesMissingContent", () => $81d3e6e3139a4ab4$export$652814b83c30d251);

var $hYZXM = parcelRequire("hYZXM");

var $bIcQH = parcelRequire("bIcQH");
var $cSalc = parcelRequire("cSalc");
var $kCavp = parcelRequire("kCavp");
var $8ArEg = parcelRequire("8ArEg");

var $3o7y4 = parcelRequire("3o7y4");
const $81d3e6e3139a4ab4$var$getMaxColumnsCountForTable = (tableNode)=>{
    let colsInRow = 1;
    tableNode.content?.forEach((childNode)=>{
        if (childNode?.type === 'tableRow' && typeof childNode.content?.length === 'number' && childNode.content.length > colsInRow) colsInRow = childNode.content.length;
    });
    return colsInRow;
};
const $81d3e6e3139a4ab4$var$createValidEmptyContent = (node)=>{
    switch(node.type){
        case 'tableCell':
            return [
                (0, $cSalc.paragraph)()
            ];
        default:
            return [];
    }
};
const $81d3e6e3139a4ab4$var$fixIfTableCellInvalidEmpty = (reportTransform)=>(node)=>{
        if ((0, $3o7y4.isEmpty)(node)) {
            reportTransform();
            return {
                ...node,
                content: $81d3e6e3139a4ab4$var$createValidEmptyContent(node)
            };
        }
    };
const $81d3e6e3139a4ab4$var$hasNonListItemChildren = (node)=>node.content?.some((node)=>node?.type !== 'listItem');
const $81d3e6e3139a4ab4$var$hasEmptyListItemChildren = (node)=>node.content?.some((childNode)=>childNode?.type === 'listItem' && !childNode.content?.length);
const $81d3e6e3139a4ab4$var$tryCreateValidListItemWrappedChildren = (parentListNode)=>{
    return parentListNode.content?.map((childNode)=>{
        if (childNode) switch(childNode.type){
            case 'listItem':
                if ((0, $3o7y4.isEmpty)(childNode)) {
                    const result = (0, $bIcQH.listItem)([
                        (0, $cSalc.paragraph)()
                    ]);
                    return result;
                }
                return childNode;
            case 'text':
                return (0, $bIcQH.listItem)([
                    (0, $cSalc.paragraph)(childNode)
                ]);
            default:
                return (0, $bIcQH.listItem)([
                    childNode
                ]);
        }
        return childNode;
    });
};
const $81d3e6e3139a4ab4$var$fixIfListParentWithInvalidListItemChildren = (reportTransform)=>(node)=>{
        if ($81d3e6e3139a4ab4$var$hasNonListItemChildren(node) || $81d3e6e3139a4ab4$var$hasEmptyListItemChildren(node)) {
            reportTransform();
            return {
                ...node,
                content: $81d3e6e3139a4ab4$var$tryCreateValidListItemWrappedChildren(node)
            };
        }
    };
const $81d3e6e3139a4ab4$var$hasNonTableRowChildren = (node)=>node.content?.some((node)=>node?.type !== 'tableRow');
const $81d3e6e3139a4ab4$var$tryCreateValidTableRowWrappedChildren = (parentTableNode)=>{
    const maxColsCount = $81d3e6e3139a4ab4$var$getMaxColumnsCountForTable(parentTableNode);
    return parentTableNode.content?.map((childNode)=>{
        if (childNode) switch(childNode.type){
            case 'text':
                return (0, $8ArEg.tableRow)([
                    (0, $kCavp.tableCell)({})((0, $cSalc.paragraph)(childNode)),
                    ...new Array(maxColsCount - 1).fill((0, $kCavp.tableCell)({})((0, $cSalc.paragraph)()))
                ]);
            case 'tableCell':
                return (0, $8ArEg.tableRow)([
                    childNode
                ]);
            case 'tableRow':
                if ((0, $3o7y4.isEmpty)(childNode)) return (0, $8ArEg.tableRow)([
                    ...new Array(maxColsCount).fill((0, $kCavp.tableCell)({})((0, $cSalc.paragraph)()))
                ]);
                return childNode;
            default:
                return childNode;
        }
        return childNode;
    });
};
const $81d3e6e3139a4ab4$var$hasEmptyTableRowChildren = (node)=>node?.content?.some((node)=>node?.type === 'tableRow' && node?.content?.length === 0);
const $81d3e6e3139a4ab4$var$fixIfTableParentWithInvalidTableRowChildren = (reportTransform)=>(node)=>{
        if ($81d3e6e3139a4ab4$var$hasEmptyTableRowChildren(node) || $81d3e6e3139a4ab4$var$hasNonTableRowChildren(node)) {
            reportTransform();
            return {
                ...node,
                content: $81d3e6e3139a4ab4$var$tryCreateValidTableRowWrappedChildren(node)
            };
        }
    };
const $81d3e6e3139a4ab4$var$removeMediaSingleWithNoContent = (reportTransform)=>(node)=>{
        if ((0, $3o7y4.isEmpty)(node)) {
            reportTransform();
            return false;
        }
    };
const $81d3e6e3139a4ab4$export$652814b83c30d251 = (adf)=>{
    let isTransformed = false;
    const reportTransform = ()=>{
        isTransformed = true;
    };
    let transformedAdf = (0, $hYZXM.traverse)(adf, {
        tableCell: $81d3e6e3139a4ab4$var$fixIfTableCellInvalidEmpty(reportTransform)
    });
    // Empty mediaSingle nodes get stripped from the document and so this transform
    // will create an empty listItem if the media node is in a list. Empty listItems
    // are invalid adf, so we need to transform the mediaSingle nodes first.
    transformedAdf = (0, $hYZXM.traverse)(transformedAdf || adf, {
        mediaSingle: $81d3e6e3139a4ab4$var$removeMediaSingleWithNoContent(reportTransform)
    });
    transformedAdf = (0, $hYZXM.traverse)(transformedAdf || adf, {
        bulletList: $81d3e6e3139a4ab4$var$fixIfListParentWithInvalidListItemChildren(reportTransform),
        orderedList: $81d3e6e3139a4ab4$var$fixIfListParentWithInvalidListItemChildren(reportTransform),
        table: $81d3e6e3139a4ab4$var$fixIfTableParentWithInvalidTableRowChildren(reportTransform)
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});
parcelRegister("bIcQH", function(module, exports) {

$parcel$export(module.exports, "listItem", () => $07ccabdedd1d128f$export$76c7e83ecc9cdf05);
const $07ccabdedd1d128f$export$76c7e83ecc9cdf05 = (content)=>({
        type: 'listItem',
        content: content
    });

});

parcelRegister("kCavp", function(module, exports) {

$parcel$export(module.exports, "tableCell", () => $0dcef6502e9dee54$export$e1e720e5f4603e6a);
const $0dcef6502e9dee54$export$e1e720e5f4603e6a = (attrs)=>(...content)=>({
            type: 'tableCell',
            attrs: attrs,
            content: content
        });

});

parcelRegister("8ArEg", function(module, exports) {

$parcel$export(module.exports, "tableRow", () => $65f5f3f0fc8ca37f$export$ce666bf02318c957);
const $65f5f3f0fc8ca37f$export$ce666bf02318c957 = (content)=>({
        type: 'tableRow',
        content: content
    });

});


parcelRegister("rjHJO", function(module, exports) {

$parcel$export(module.exports, "transformTextLinkCodeMarks", () => $c298c2234c6af387$export$3d531d2daf0e8a14);

var $hYZXM = parcelRequire("hYZXM");
const $c298c2234c6af387$var$hasLinkAndCodeMarks = (node)=>{
    const marks = node.marks?.map((mark)=>mark.type);
    return marks?.includes('link') && marks?.includes('code');
};
const $c298c2234c6af387$var$removeCodeMarks = (node)=>{
    if (node.marks) return {
        ...node,
        marks: node.marks.filter((mark)=>mark.type !== 'code')
    };
    return node;
};
const $c298c2234c6af387$export$3d531d2daf0e8a14 = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $hYZXM.traverse)(adf, {
        text: (node)=>{
            if ($c298c2234c6af387$var$hasLinkAndCodeMarks(node)) {
                isTransformed = true;
                return $c298c2234c6af387$var$removeCodeMarks(node);
            }
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});

parcelRegister("1ufWw", function(module, exports) {

$parcel$export(module.exports, "isEmptyParagraph", () => $a675ec2ec4a0f570$export$b648602b09795358);
$parcel$export(module.exports, "stepHasSlice", () => $a675ec2ec4a0f570$export$53780b185b887309);
$parcel$export(module.exports, "stepAddsOneOf", () => $a675ec2ec4a0f570$export$f4d51ccab05f55c9);
$parcel$export(module.exports, "extractSliceFromStep", () => $a675ec2ec4a0f570$export$d0a9dfe2556a9577);
$parcel$export(module.exports, "isTextSelection", () => $a675ec2ec4a0f570$export$38b50bf35e79aaf3);
$parcel$export(module.exports, "isElementInTableCell", () => $a675ec2ec4a0f570$export$5588122b9eea7733);
$parcel$export(module.exports, "isLastItemMediaGroup", () => $a675ec2ec4a0f570$export$142c0ee6457f50d6);
$parcel$export(module.exports, "setNodeSelection", () => $a675ec2ec4a0f570$export$a367515ca2c9ace1);
$parcel$export(module.exports, "setTextSelection", () => $a675ec2ec4a0f570$export$1df6d14df6b0b758);
$parcel$export(module.exports, "nonNullable", () => $a675ec2ec4a0f570$export$26128561c93f5847);
$parcel$export(module.exports, "isValidPosition", () => $a675ec2ec4a0f570$export$de0495c7bd37bf4e);
$parcel$export(module.exports, "isInLayoutColumn", () => $a675ec2ec4a0f570$export$2de06a6e688827fd);
$parcel$export(module.exports, "filterChildrenBetween", () => $a675ec2ec4a0f570$export$e46323d96cf32194);
$parcel$export(module.exports, "removeBlockMarks", () => $a675ec2ec4a0f570$export$fba8af3b998832b9);

var $kpTIW = parcelRequire("kpTIW");

var $d6JJW = parcelRequire("d6JJW");

var $2zbl1 = parcelRequire("2zbl1");

var $2L5G5 = parcelRequire("2L5G5");

var $7Dnt4 = parcelRequire("7Dnt4");
function $a675ec2ec4a0f570$export$b648602b09795358(node) {
    return !!node && node.type.name === 'paragraph' && !node.childCount;
}
const $a675ec2ec4a0f570$export$53780b185b887309 = (step)=>step && step.hasOwnProperty('slice');
function $a675ec2ec4a0f570$export$f4d51ccab05f55c9(step, nodeTypes) {
    let adds = false;
    if (!$a675ec2ec4a0f570$export$53780b185b887309(step)) return adds;
    step.slice.content.descendants((node)=>{
        if (nodeTypes.has(node.type)) adds = true;
        return !adds;
    });
    return adds;
}
const $a675ec2ec4a0f570$export$d0a9dfe2556a9577 = (step)=>{
    if (!(step instanceof (0, $d6JJW.ReplaceStep)) && !(step instanceof (0, $d6JJW.ReplaceAroundStep))) return null;
    // @ts-ignore This is by design. Slice is a private property, but accesible, from ReplaceStep.
    // However, we need to read it to found if the step was adding a newline
    const slice = step.slice;
    return slice;
};
const $a675ec2ec4a0f570$export$38b50bf35e79aaf3 = (selection)=>selection instanceof (0, $kpTIW.TextSelection);
const $a675ec2ec4a0f570$export$5588122b9eea7733 = (element)=>{
    return (0, $7Dnt4.closest)(element, 'td') || (0, $7Dnt4.closest)(element, 'th');
};
const $a675ec2ec4a0f570$export$142c0ee6457f50d6 = (node)=>{
    const { content: content } = node;
    return !!content.lastChild && content.lastChild.type.name === 'mediaGroup';
};
const $a675ec2ec4a0f570$export$a367515ca2c9ace1 = (view, pos)=>{
    const { state: state, dispatch: dispatch } = view;
    if (!isFinite(pos)) return;
    const tr = state.tr.setSelection((0, $kpTIW.NodeSelection).create(state.doc, pos));
    dispatch(tr);
};
function $a675ec2ec4a0f570$export$1df6d14df6b0b758(view, anchor, head) {
    const { state: state, dispatch: dispatch } = view;
    const tr = state.tr.setSelection((0, $kpTIW.TextSelection).create(state.doc, anchor, head));
    dispatch(tr);
}
function $a675ec2ec4a0f570$export$abad69d764760c05(view) {
    const { state: state, dispatch: dispatch } = view;
    const tr = state.tr.setSelection(new (0, $kpTIW.AllSelection)(view.state.doc));
    dispatch(tr);
}
function $a675ec2ec4a0f570$export$8f10f8581a0e9ba2(view, anchor, head) {
    const { state: state, dispatch: dispatch } = view;
    dispatch(state.tr.setSelection((0, $2L5G5.CellSelection).create(state.doc, anchor, head)));
}
function $a675ec2ec4a0f570$export$26128561c93f5847(value) {
    return value !== null && value !== undefined;
}
const $a675ec2ec4a0f570$export$de0495c7bd37bf4e = (pos, state)=>{
    if (typeof pos !== 'number') return false;
    if (pos >= 0 && pos <= state.doc.resolve(0).end()) return true;
    return false;
};
const $a675ec2ec4a0f570$export$2de06a6e688827fd = (state)=>{
    return (0, $2zbl1.hasParentNodeOfType)(state.schema.nodes.layoutSection)(state.selection);
};
function $a675ec2ec4a0f570$export$e46323d96cf32194(doc, from, to, predicate) {
    const results = [];
    doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (predicate(node, pos, parent)) results.push({
            node: node,
            pos: pos
        });
    });
    return results;
}
const $a675ec2ec4a0f570$export$fba8af3b998832b9 = (state, marks)=>{
    const { selection: selection, schema: schema } = state;
    let { tr: tr } = state;
    // Marks might not exist in Schema
    const marksToRemove = marks.filter(Boolean);
    if (marksToRemove.length === 0) return undefined;
    /** Saves an extra dispatch */ let blockMarksExists = false;
    const hasMark = (mark)=>marksToRemove.indexOf(mark.type) > -1;
    /**
	 * When you need to toggle the selection
	 * when another type which does not allow alignment is applied
	 */ state.doc.nodesBetween(selection.from, selection.to, (node, pos)=>{
        if (node.type === schema.nodes.paragraph && node.marks.some(hasMark)) {
            blockMarksExists = true;
            const resolvedPos = state.doc.resolve(pos);
            const withoutBlockMarks = node.marks.filter($a675ec2ec4a0f570$var$not(hasMark));
            tr = tr.setNodeMarkup(resolvedPos.pos, undefined, node.attrs, withoutBlockMarks);
        }
    });
    return blockMarksExists ? tr : undefined;
};
const $a675ec2ec4a0f570$var$not = (fn)=>(arg)=>!fn(arg);

});
parcelRegister("2L5G5", function(module, exports) {

$parcel$export(module.exports, "CellSelection", () => $fe0390ba92701c19$export$831cc7e2a83afa94);
// Was copied from https://github.com/ProseMirror/prosemirror-tables/blob/master/src/cellselection.js
// This file defines a ProseMirror selection subclass that models
// table cell selections. The table plugin needs to be active to wire
// in the user interaction part of table selections (so that you
// actually get such selections when you select across cells).

var $7dkLM = parcelRequire("7dkLM");

var $kpTIW = parcelRequire("kpTIW");

var $eE0VI = parcelRequire("eE0VI");

var $ffWI7 = parcelRequire("ffWI7");

var $3At5r = parcelRequire("3At5r");

var $gwlOK = parcelRequire("gwlOK");

var $kZm1T = parcelRequire("kZm1T");

var $QAkuK = parcelRequire("QAkuK");
class $fe0390ba92701c19$export$831cc7e2a83afa94 extends (0, $kpTIW.Selection) {
    constructor($anchorCell, $headCell = $anchorCell){
        const ranges = (0, $kZm1T.getCellSelectionRanges)($anchorCell, $headCell);
        super(ranges[0].$from, ranges[0].$to, ranges);
        // :: ResolvedPos
        // A resolved position pointing _in front of_ the anchor cell (the one
        // that doesn't move when extending the selection).
        this.$anchorCell = $anchorCell;
        // :: ResolvedPos
        // A resolved position pointing in front of the head cell (the one
        // moves when extending the selection).
        this.$headCell = $headCell;
        this.visible = false;
    }
    map(doc, mapping) {
        const $anchorCell = doc.resolve(mapping.map(this.$anchorCell.pos));
        const $headCell = doc.resolve(mapping.map(this.$headCell.pos));
        if ((0, $3At5r.pointsAtCell)($anchorCell) && (0, $3At5r.pointsAtCell)($headCell) && (0, $QAkuK.inSameTable)($anchorCell, $headCell)) {
            const tableChanged = this.$anchorCell.node(-1) !== $anchorCell.node(-1);
            if (tableChanged && this.isRowSelection()) return $fe0390ba92701c19$export$831cc7e2a83afa94.rowSelection($anchorCell, $headCell);
            if (tableChanged && this.isColSelection()) return $fe0390ba92701c19$export$831cc7e2a83afa94.colSelection($anchorCell, $headCell);
            return new $fe0390ba92701c19$export$831cc7e2a83afa94($anchorCell, $headCell);
        }
        return (0, $kpTIW.TextSelection).between($anchorCell, $headCell);
    }
    // :: () → Slice
    // Returns a rectangular slice of table rows containing the selected
    // cells.
    content() {
        const table = this.$anchorCell.node(-1);
        const map = (0, $ffWI7.TableMap).get(table);
        const start = this.$anchorCell.start(-1);
        const rect = map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start);
        const seen = {};
        const rows = [];
        for(let row = rect.top; row < rect.bottom; row++){
            const rowContent = [];
            for(let index = row * map.width + rect.left, col = rect.left; col < rect.right; col++, index++){
                const pos = map.map[index];
                if (!seen[pos]) {
                    seen[pos] = true;
                    const cellRect = map.findCell(pos);
                    let cell = table.nodeAt(pos);
                    if (cell === null || cell === undefined) throw new Error(`No cell at position ${pos}`);
                    const extraLeft = rect.left - cellRect.left;
                    const extraRight = cellRect.right - rect.right;
                    if (extraLeft > 0 || extraRight > 0) {
                        let { attrs: attrs } = cell;
                        if (!attrs) throw new Error(`No cell at position ${pos}`);
                        if (extraLeft > 0) attrs = (0, $gwlOK.removeColSpan)(attrs, 0, extraLeft);
                        if (extraRight > 0) attrs = (0, $gwlOK.removeColSpan)(attrs, attrs.colspan - extraRight, extraRight);
                        if (cellRect.left < rect.left) cell = cell.type.createAndFill(attrs);
                        else cell = cell.type.create(attrs, cell.content);
                    }
                    if (cell === null || cell === undefined) throw new Error(`No cell at position after create/createAndFill`);
                    if (cellRect.top < rect.top || cellRect.bottom > rect.bottom) {
                        const attrs = {
                            ...cell.attrs,
                            rowspan: Math.min(cellRect.bottom, rect.bottom) - Math.max(cellRect.top, rect.top)
                        };
                        if (cellRect.top < rect.top) cell = cell.type.createAndFill(attrs);
                        else cell = cell.type.create(attrs, cell.content);
                    }
                    if (cell === null || cell === undefined) throw new Error(`No cell at position before rowContent.push`);
                    rowContent.push(cell);
                }
            }
            rows.push(table.child(row).copy((0, $7dkLM.Fragment).from(rowContent)));
        }
        const fragment = this.isColSelection() && this.isRowSelection() ? table : rows;
        return new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(fragment), 1, 1);
    }
    replace(tr, content = (0, $7dkLM.Slice).empty) {
        const mapFrom = tr.steps.length;
        const { ranges: ranges } = this;
        for(let i = 0; i < ranges.length; i++){
            const { $from: $from, $to: $to } = ranges[i];
            const mapping = tr.mapping.slice(mapFrom);
            tr.replace(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $7dkLM.Slice).empty : content);
        }
        const sel = (0, $kpTIW.Selection).findFrom(tr.doc.resolve(tr.mapping.slice(mapFrom).map(this.to)), -1);
        if (sel) tr.setSelection(sel);
    }
    replaceWith(tr, node) {
        this.replace(tr, new (0, $7dkLM.Slice)((0, $7dkLM.Fragment).from(node), 0, 0));
    }
    forEachCell(f) {
        const table = this.$anchorCell.node(-1);
        const map = (0, $ffWI7.TableMap).get(table);
        const start = this.$anchorCell.start(-1);
        const cells = map.cellsInRect(map.rectBetween(this.$anchorCell.pos - start, this.$headCell.pos - start));
        for(let i = 0; i < cells.length; i++){
            const cell = table.nodeAt(cells[i]);
            if (cell === null || cell === undefined) throw new Error(`undefined cell at pos ${cells[i]}`);
            f(cell, start + cells[i]);
        }
    }
    // :: () → bool
    // True if this selection goes all the way from the top to the
    // bottom of the table.
    isColSelection() {
        if (!this.$anchorCell || !this.$headCell) throw new Error('invalid $anchorCell or $headCell');
        const anchorTop = this.$anchorCell.index(-1);
        const headTop = this.$headCell.index(-1);
        if (Math.min(anchorTop, headTop) > 0) return false;
        const anchorBot = anchorTop + this.$anchorCell.nodeAfter.attrs.rowspan;
        const headBot = headTop + this.$headCell.nodeAfter.attrs.rowspan;
        return Math.max(anchorBot, headBot) === this.$headCell.node(-1).childCount;
    }
    // :: (ResolvedPos, ?ResolvedPos) → CellSelection
    // Returns the smallest column selection that covers the given anchor
    // and head cell.
    static colSelection($anchorCell, $headCell = $anchorCell) {
        let $calculatedAnchorCell = $anchorCell;
        let $calculatedHeadCell = $headCell;
        const map = (0, $ffWI7.TableMap).get($calculatedAnchorCell.node(-1));
        const start = $calculatedAnchorCell.start(-1);
        const anchorRect = map.findCell($calculatedAnchorCell.pos - start);
        const headRect = map.findCell($calculatedHeadCell.pos - start);
        const doc = $calculatedAnchorCell.node(0);
        if (anchorRect.top <= headRect.top) {
            if (anchorRect.top > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.left]);
            if (headRect.bottom < map.height) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (map.height - 1) + headRect.right - 1]);
        } else {
            if (headRect.top > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.left]);
            if (anchorRect.bottom < map.height) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (map.height - 1) + anchorRect.right - 1]);
        }
        return new $fe0390ba92701c19$export$831cc7e2a83afa94($calculatedAnchorCell, $calculatedHeadCell);
    }
    // :: () → bool
    // True if this selection goes all the way from the left to the
    // right of the table.
    isRowSelection() {
        if (!this.$anchorCell || !this.$headCell) return false;
        const start = this.$anchorCell.start(-1);
        const map = (0, $ffWI7.TableMap).get(this.$anchorCell.node(-1));
        const rowAtAnchorCell = map.rowCount(this.$anchorCell.pos - start);
        const rowAtHeadCell = map.rowCount(this.$headCell.pos - start);
        const isSelectionSameRow = rowAtAnchorCell === rowAtHeadCell;
        // if anchor and head in the same line, counting how many cells
        // should be in the row except merged cell
        let maxColumnInSelectedRow = map.getMaxColInRow(this.$anchorCell);
        // if selected cells less than table max column amount, and
        // the anchor/head not in a merged cell
        // it should be select maxColumnInSelectedRow to be TRUE
        if (isSelectionSameRow && this.ranges.length <= map.width && !map.isPosMerged(this.$anchorCell.pos - start) && !map.isPosMerged(this.$headCell.pos - start)) return this.ranges.length === maxColumnInSelectedRow;
        // If anchor and head in different row, it should be always in first and
        // last column to select the whole row.
        const anchorLeft = map.colCount(this.$anchorCell.pos - start);
        const headLeft = map.colCount(this.$headCell.pos - start);
        if (Math.min(anchorLeft, headLeft) > 0) return false;
        const anchorRight = anchorLeft + this.$anchorCell.nodeAfter.attrs.colspan;
        const headRight = headLeft + this.$headCell.nodeAfter.attrs.colspan;
        return Math.max(anchorRight, headRight) === map.width;
    }
    eq(other) {
        return other instanceof $fe0390ba92701c19$export$831cc7e2a83afa94 && other.$anchorCell.pos === this.$anchorCell.pos && other.$headCell.pos === this.$headCell.pos;
    }
    // :: (ResolvedPos, ?ResolvedPos) → CellSelection
    // Returns the smallest row selection that covers the given anchor
    // and head cell.
    static rowSelection($anchorCell, $headCell = $anchorCell) {
        let $calculatedAnchorCell = $anchorCell;
        let $calculatedHeadCell = $headCell;
        const map = (0, $ffWI7.TableMap).get($calculatedAnchorCell.node(-1));
        const start = $calculatedAnchorCell.start(-1);
        const anchorRect = map.findCell($calculatedAnchorCell.pos - start);
        const headRect = map.findCell($calculatedHeadCell.pos - start);
        const doc = $calculatedAnchorCell.node(0);
        if (anchorRect.left <= headRect.left) {
            if (anchorRect.left > 0) $calculatedAnchorCell = doc.resolve(start + map.map[anchorRect.top * map.width]);
            if (headRect.right < map.width) $calculatedHeadCell = doc.resolve(start + map.map[map.width * (headRect.top + 1) - 1]);
        } else {
            if (headRect.left > 0) $calculatedHeadCell = doc.resolve(start + map.map[headRect.top * map.width]);
            if (anchorRect.right < map.width) $calculatedAnchorCell = doc.resolve(start + map.map[map.width * (anchorRect.top + 1) - 1]);
        }
        return new $fe0390ba92701c19$export$831cc7e2a83afa94($calculatedAnchorCell, $calculatedHeadCell);
    }
    toJSON() {
        return {
            type: 'cell',
            anchor: this.$anchorCell.pos,
            head: this.$headCell.pos
        };
    }
    static fromJSON(doc, json) {
        return new $fe0390ba92701c19$export$831cc7e2a83afa94(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    // :: (Node, number, ?number) → CellSelection
    static create(doc, anchorCell, headCell = anchorCell) {
        return new $fe0390ba92701c19$export$831cc7e2a83afa94(doc.resolve(anchorCell), doc.resolve(headCell));
    }
    getBookmark() {
        return new (0, $eE0VI.CellBookmark)(this.$anchorCell.pos, this.$headCell.pos);
    }
}
(0, $kpTIW.Selection).jsonID('cell', $fe0390ba92701c19$export$831cc7e2a83afa94);

});
parcelRegister("eE0VI", function(module, exports) {

$parcel$export(module.exports, "CellBookmark", () => $50cfe205e29acb7d$export$ca751a6394ad160e);

var $kpTIW = parcelRequire("kpTIW");

var $QAkuK = parcelRequire("QAkuK");
class $50cfe205e29acb7d$export$ca751a6394ad160e {
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
    map(mapping) {
        return new $50cfe205e29acb7d$export$ca751a6394ad160e(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        const $anchorCell = doc.resolve(this.anchor);
        const $headCell = doc.resolve(this.head);
        if ($anchorCell.parent.type.spec.tableRole === 'row' && $headCell.parent.type.spec.tableRole === 'row' && $anchorCell.index() < $anchorCell.parent.childCount && $headCell.index() < $headCell.parent.childCount && (0, $QAkuK.inSameTable)($anchorCell, $headCell)) {
            const data = {
                type: 'cell',
                anchor: $anchorCell.pos,
                head: $headCell.pos
            };
            return (0, $kpTIW.Selection).fromJSON(doc, data);
        }
        return (0, $kpTIW.Selection).near($headCell, 1);
    }
}

});
parcelRegister("QAkuK", function(module, exports) {

$parcel$export(module.exports, "isInTable", () => $9e22e76e5cdf2a93$export$217a88ad224d1b11);
$parcel$export(module.exports, "inSameTable", () => $9e22e76e5cdf2a93$export$debd62b44eb7e281);
function $9e22e76e5cdf2a93$export$217a88ad224d1b11(state) {
    const { $head: $head } = state.selection;
    for(let d = $head.depth; d > 0; d--){
        if ($head.node(d).type.spec.tableRole === 'row') return true;
    }
    return false;
}
function $9e22e76e5cdf2a93$export$debd62b44eb7e281($a, $b) {
    return $a.depth === $b.depth && $a.pos >= $b.start(-1) && $a.pos <= $b.end(-1);
}

});


parcelRegister("ffWI7", function(module, exports) {

$parcel$export(module.exports, "Rect", () => $97388ccb1d6b8a53$export$c79fc6492f3af13d);
$parcel$export(module.exports, "TableProblemTypes", () => $97388ccb1d6b8a53$export$d8cd393a71edca79);
$parcel$export(module.exports, "TableMap", () => $97388ccb1d6b8a53$export$493da463fed0a57a);
// Because working with row and column-spanning cells is not quite
// trivial, this code builds up a descriptive structure for a given
// table node. The structures are cached with the (persistent) table
// nodes as key, so that they only have to be recomputed when the
// content of the table changes.
//
// This does mean that they have to store table-relative, not
// document-relative positions. So code that uses them will typically
// compute the start position of the table and offset positions passed
// to or gotten from this structure by that amount.
let $97388ccb1d6b8a53$var$readFromCache, $97388ccb1d6b8a53$var$addToCache;
// Prefer using a weak map to cache table maps. Fall back on a
// fixed-size cache if that's not supported.
if (typeof WeakMap !== 'undefined') {
    let cache = new WeakMap();
    $97388ccb1d6b8a53$var$readFromCache = (key)=>cache.get(key);
    $97388ccb1d6b8a53$var$addToCache = (key, value)=>{
        cache.set(key, value);
        return value;
    };
} else {
    let cache = [];
    let cacheSize = 10;
    let cachePos = 0;
    $97388ccb1d6b8a53$var$readFromCache = (key)=>{
        for(let i = 0; i < cache.length; i += 2){
            if (cache[i] === key) return cache[i + 1];
        }
    };
    $97388ccb1d6b8a53$var$addToCache = (key, value)=>{
        if (cachePos === cacheSize) cachePos = 0;
        cache[cachePos++] = key;
        return cache[cachePos++] = value;
    };
}
class $97388ccb1d6b8a53$export$c79fc6492f3af13d {
    constructor(left, top, right, bottom){
        this.left = left;
        this.top = top;
        this.right = right;
        this.bottom = bottom;
    }
}
var $97388ccb1d6b8a53$export$d8cd393a71edca79;
(function(TableProblemTypes) {
    TableProblemTypes["COLLISION"] = "collision";
    TableProblemTypes["OVERLONG_ROWSPAN"] = "overlong_rowspan";
    TableProblemTypes["MISSING"] = "missing";
    TableProblemTypes["COLWIDTH_MISMATCH"] = "colwidth mismatch";
})($97388ccb1d6b8a53$export$d8cd393a71edca79 || ($97388ccb1d6b8a53$export$d8cd393a71edca79 = {}));
const $97388ccb1d6b8a53$export$c60fae4049791eae = 140;
class $97388ccb1d6b8a53$export$493da463fed0a57a {
    constructor(width, height, map, problems, mapByColumn, mapByRow){
        this.mapByColumn = [];
        this.mapByRow = [];
        this.width = width;
        this.height = height;
        this.mapByColumn = mapByColumn || [];
        this.mapByRow = mapByRow || [];
        // :: [number] A width * height array with the start position of
        // the cell covering that part of the table in each slot
        this.map = map;
        // An optional array of problems (cell overlap or non-rectangular
        // shape) for the table, used by the table normalizer.
        this.problems = problems;
    }
    // :: (number) → Rect
    // Find the dimensions of the cell at the given position.
    findCell(pos) {
        for(let i = 0; i < this.map.length; i++){
            let curPos = this.map[i];
            if (curPos !== pos) continue;
            let left = i % this.width;
            let top = i / this.width | 0;
            let right = left + 1;
            let bottom = top + 1;
            for(let j = 1; right < this.width && this.map[i + j] === curPos; j++)right++;
            for(let j = 1; bottom < this.height && this.map[i + this.width * j] === curPos; j++)bottom++;
            return new $97388ccb1d6b8a53$export$c79fc6492f3af13d(left, top, right, bottom);
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    // Find the left side of the cell at the given position.
    colCount(pos) {
        for(let i = 0; i < this.map.length; i++){
            if (this.map[i] === pos) return i % this.width;
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    // Find the top side of the cell at the given position.
    rowCount(pos) {
        if (this.width <= 0) throw new RangeError('Wrong table width found');
        for(let i = 0; i < this.map.length; i++){
            if (this.map[i] === pos) return Math.floor(i / this.width);
        }
        throw new RangeError('No cell with offset ' + pos + ' found');
    }
    isPosMerged(pos) {
        return this.map.includes(pos, this.map.indexOf(pos) + 1);
    }
    isCellMerged(row, col) {
        return this.isCellMergedTopLeft(row, col) || this.isCellMergedBottomRight(row, col);
    }
    isCellMergedTopLeft(row, col) {
        const pos = this.map[row * this.width + col];
        return(// top
        row > 0 && pos === this.map[(row - 1) * this.width + col] || // left
        col > 0 && pos === this.map[row * this.width + (col - 1)]);
    }
    isCellMergedBottomRight(row, col) {
        const pos = this.map[row * this.width + col];
        return(// bottom
        row < this.height - 1 && pos === this.map[(row + 1) * this.width + col] || // right
        col < this.width - 1 && pos === this.map[row * this.width + (col + 1)]);
    }
    // :: (number, string, number) → ?number
    // Find the next cell in the given direction, starting from the cell
    // at `pos`, if any.
    nextCell(pos, axis, dir) {
        let { left: left, right: right, top: top, bottom: bottom } = this.findCell(pos);
        if (axis === 'horiz') {
            if (dir < 0 ? left === 0 : right === this.width) return null;
            return this.map[top * this.width + (dir < 0 ? left - 1 : right)];
        } else {
            if (dir < 0 ? top === 0 : bottom === this.height) return null;
            return this.map[left + this.width * (dir < 0 ? top - 1 : bottom)];
        }
    }
    // :: (number, number) → Rect
    // Get the rectangle spanning the two given cells.
    rectBetween(a, b) {
        let { left: leftA, right: rightA, top: topA, bottom: bottomA } = this.findCell(a);
        let { left: leftB, right: rightB, top: topB, bottom: bottomB } = this.findCell(b);
        return new $97388ccb1d6b8a53$export$c79fc6492f3af13d(Math.min(leftA, leftB), Math.min(topA, topB), Math.max(rightA, rightB), Math.max(bottomA, bottomB));
    }
    // :: (Rect) → [number]
    // Return the position of all cells that have the top left corner in
    // the given rectangle.
    cellsInRect(rect) {
        let result = [];
        let seen = {};
        for(let row = rect.top; row < rect.bottom; row++)for(let col = rect.left; col < rect.right; col++){
            let index = row * this.width + col;
            let pos = this.map[index];
            if (seen[pos]) continue;
            seen[pos] = true;
            if ((col !== rect.left || !col || this.map[index - 1] !== pos) && (row !== rect.top || !row || this.map[index - this.width] !== pos)) result.push(pos);
        }
        return result;
    }
    // :: (number, number, Node) → number
    // Return the position at which the cell at the given row and column
    // starts, or would start, if a cell started there.
    positionAt(row, col, table) {
        for(let i = 0, rowStart = 0;; i++){
            let rowEnd = rowStart + table.child(i).nodeSize;
            if (i === row) {
                let index = col + row * this.width;
                let rowEndIndex = (row + 1) * this.width;
                // Skip past cells from previous rows (via rowspan)
                while(index < rowEndIndex && this.map[index] < rowStart)index++;
                return index === rowEndIndex ? rowEnd - 1 : this.map[index];
            }
            rowStart = rowEnd;
        }
    }
    getMaxColInRow(pos) {
        let parentRowNode = pos.parent;
        if (parentRowNode.type.name === 'tableRow') return parentRowNode.childCount;
    }
    hasMergedCells() {
        const uniquePositions = new Set(this.map);
        return uniquePositions.size !== this.map.length;
    }
    // :: (Node) → TableMap
    // Find the table map for the given table node.
    static get(table) {
        return $97388ccb1d6b8a53$var$readFromCache(table) || $97388ccb1d6b8a53$var$addToCache(table, $97388ccb1d6b8a53$var$computeMap(table));
    }
}
// Compute a table map.
function $97388ccb1d6b8a53$var$computeMap(table) {
    if (table.type.spec.tableRole !== 'table') throw new RangeError('Not a table node: ' + table.type.name);
    let width = $97388ccb1d6b8a53$var$findWidth(table);
    let height = table.childCount;
    let map = [], mapPos = 0, problems = null, colWidths = [];
    for(let i = 0, e = width * height; i < e; i++)map[i] = 0;
    for(let row = 0, pos = 0; row < height; row++){
        let rowNode = table.child(row);
        pos++;
        for(let i = 0;; i++){
            while(mapPos < map.length && map[mapPos] !== 0)mapPos++;
            if (i === rowNode.childCount) break;
            let cellNode = rowNode.child(i), { colspan: colspan, rowspan: rowspan, colwidth: colwidth } = cellNode.attrs;
            for(let h = 0; h < rowspan; h++){
                if (h + row >= height) {
                    (problems || (problems = [])).push({
                        type: "overlong_rowspan",
                        pos: pos,
                        n: rowspan - h
                    });
                    break;
                }
                let start = mapPos + h * width;
                for(let w = 0; w < colspan; w++){
                    if (map[start + w] === 0) map[start + w] = pos;
                    else (problems || (problems = [])).push({
                        type: "collision",
                        row: row,
                        pos: pos,
                        n: colspan - w
                    });
                    let colW = colwidth && colwidth[w];
                    if (colW) {
                        let widthIndex = (start + w) % width * 2, prev = colWidths[widthIndex];
                        if (prev == null || prev !== colW && colWidths[widthIndex + 1] === 1) {
                            colWidths[widthIndex] = colW;
                            colWidths[widthIndex + 1] = 1;
                        } else if (prev === colW) colWidths[widthIndex + 1]++;
                    }
                }
            }
            mapPos += colspan;
            pos += cellNode.nodeSize;
        }
        let expectedPos = (row + 1) * width;
        let missing = 0;
        while(mapPos < expectedPos)if (map[mapPos++] === 0) missing++;
        if (missing) (problems || (problems = [])).push({
            type: "missing",
            row: row,
            n: missing
        });
        pos++;
    }
    let mapByRow = Array(height);
    let mapByColumn = Array(width);
    for(let i = 0; i < map.length; i++){
        const columnIndex = i % width;
        mapByColumn[columnIndex] = mapByColumn[columnIndex] ?? [];
        mapByColumn[columnIndex].push(map[i]);
        const rowIndex = Math.trunc(i / width);
        mapByRow[rowIndex] = mapByRow[rowIndex] ?? [];
        mapByRow[rowIndex].push(map[i]);
    }
    let tableMap = new $97388ccb1d6b8a53$export$493da463fed0a57a(width, height, map, problems, mapByColumn, mapByRow);
    let badWidths = false;
    // For columns that have defined widths, but whose widths disagree
    // between rows, fix up the cells whose width doesn't match the
    // computed one.
    for(let i = 0; !badWidths && i < colWidths.length; i += 2)if (colWidths[i] != null && colWidths[i + 1] < height) badWidths = true;
    // colWidths is an array of numbers, it can look like this
    // const colWidths = [255, 3, 125, 3, 150, 2, 130, 1];
    // 255 is a colWidth and 3 is a number of cells with this colwidth.
    // This check exists to make sure that the table has been resized,
    // which means there will be elements in the colWidths array.
    if (colWidths.length > 0 && colWidths.length !== width * 2) {
        for(let i = 0; i < width * 2 - colWidths.length; i++)colWidths.push($97388ccb1d6b8a53$export$c60fae4049791eae, 0);
        badWidths = true;
    }
    if (badWidths) $97388ccb1d6b8a53$var$findBadColWidths(tableMap, colWidths, table);
    return tableMap;
}
function $97388ccb1d6b8a53$var$findWidth(table) {
    let width = -1;
    let hasRowSpan = false;
    for(let row = 0; row < table.childCount; row++){
        let rowNode = table.child(row);
        let rowWidth = 0;
        if (hasRowSpan) for(let j = 0; j < row; j++){
            let prevRow = table.child(j);
            for(let i = 0; i < prevRow.childCount; i++){
                let cell = prevRow.child(i);
                if (j + cell.attrs.rowspan > row) rowWidth += cell.attrs.colspan;
            }
        }
        for(let i = 0; i < rowNode.childCount; i++){
            let cell = rowNode.child(i);
            rowWidth += cell.attrs.colspan;
            if (cell.attrs.rowspan > 1) hasRowSpan = true;
        }
        if (width === -1) width = rowWidth;
        else if (width !== rowWidth) width = Math.max(width, rowWidth);
    }
    return width;
}
function $97388ccb1d6b8a53$var$findBadColWidths(map, colWidths, table) {
    if (!map.problems) map.problems = [];
    let seen = {};
    for(let i = 0; i < map.map.length; i++){
        let pos = map.map[i];
        if (seen[pos]) continue;
        seen[pos] = true;
        let node = table.nodeAt(pos), updated = null;
        for(let j = 0; j < node.attrs.colspan; j++){
            let col = (i + j) % map.width, colWidth = colWidths[col * 2];
            if (colWidth != null && (!node.attrs.colwidth || node.attrs.colwidth[j] !== colWidth)) (updated || (updated = $97388ccb1d6b8a53$var$freshColWidth(node.attrs)))[j] = colWidth;
        }
        if (updated) map.problems.unshift({
            type: "colwidth mismatch",
            pos: pos,
            colwidth: updated
        });
    }
}
function $97388ccb1d6b8a53$var$freshColWidth(attrs) {
    if (attrs.colwidth) return attrs.colwidth.slice();
    let result = [];
    for(let i = 0; i < attrs.colspan; i++)result.push(0);
    return result;
}

});

parcelRegister("3At5r", function(module, exports) {

$parcel$export(module.exports, "pointsAtCell", () => $080c6ad60f1b4bff$export$3c89e45c7dff9619);
$parcel$export(module.exports, "cellNear", () => $080c6ad60f1b4bff$export$7a283ef453dbae9e);
$parcel$export(module.exports, "cellAround", () => $080c6ad60f1b4bff$export$1f482d92c57578ce);
$parcel$export(module.exports, "nextCell", () => $080c6ad60f1b4bff$export$172699367bb25225);

var $ffWI7 = parcelRequire("ffWI7");
function $080c6ad60f1b4bff$export$3c89e45c7dff9619($pos) {
    return $pos.parent.type.spec.tableRole === 'row' && $pos.nodeAfter;
}
function $080c6ad60f1b4bff$export$7a283ef453dbae9e($pos) {
    for(let after = $pos.nodeAfter, { pos: pos } = $pos; after; after = after.firstChild, pos++){
        const role = after.type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.doc.resolve(pos);
    }
    for(let before = $pos.nodeBefore, { pos: pos } = $pos; before; before = before.lastChild, pos--){
        const role = before.type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.doc.resolve(pos - before.nodeSize);
    }
    return null;
}
function $080c6ad60f1b4bff$export$1f482d92c57578ce($pos) {
    for(let d = $pos.depth - 1; d > 0; d--){
        if ($pos.node(d).type.spec.tableRole === 'row') return $pos.node(0).resolve($pos.before(d + 1));
    }
    return null;
}
function $080c6ad60f1b4bff$export$172699367bb25225($pos, axis, dir) {
    const start = $pos.start(-1);
    const map = (0, $ffWI7.TableMap).get($pos.node(-1));
    const moved = map.nextCell($pos.pos - start, axis, dir);
    return moved == null ? null : $pos.node(0).resolve(start + moved);
}

});

parcelRegister("gwlOK", function(module, exports) {

$parcel$export(module.exports, "removeColSpan", () => $740759f7f195eda9$export$b24d9c3cc95412e0);
$parcel$export(module.exports, "assertColspan", () => $740759f7f195eda9$export$6fccdf7cee1b5201);
$parcel$export(module.exports, "addColSpan", () => $740759f7f195eda9$export$147ee78a1321ac36);
function $740759f7f195eda9$export$b24d9c3cc95412e0(attrs, pos, n = 1) {
    if (!attrs.colspan) throw new Error('removeColSpan(): attrs.colspan not defined');
    const result = {
        ...attrs,
        colspan: attrs.colspan - n
    };
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        result.colwidth.splice(pos, n);
        if (!result.colwidth.some((w)=>w > 0)) result.colwidth = undefined;
    }
    return result;
}
function $740759f7f195eda9$export$6fccdf7cee1b5201(attrs) {
    if (typeof attrs.colspan === 'undefined') throw new Error('addColSpan: attrs.colspan is not defined');
    if (typeof attrs.colspan !== 'number' || Number.isNaN(attrs.colspan) || attrs.colspan < 1) throw new Error(`addColSpan: attrs.colspan must be number >= 1, received: ${attrs.colspan}`);
}
function $740759f7f195eda9$export$147ee78a1321ac36(attrs, pos, n = 1) {
    $740759f7f195eda9$export$6fccdf7cee1b5201(attrs);
    const result = {
        ...attrs,
        colspan: attrs.colspan + n
    };
    if (result.colwidth) {
        result.colwidth = result.colwidth.slice();
        for(let i = 0; i < n; i++)result.colwidth.splice(pos, 0, 0);
    }
    return result;
}

});

parcelRegister("kZm1T", function(module, exports) {

$parcel$export(module.exports, "getCellSelectionRanges", () => $b354256bee330629$export$a60a444208fd5099);

var $kpTIW = parcelRequire("kpTIW");

var $ffWI7 = parcelRequire("ffWI7");
function $b354256bee330629$export$a60a444208fd5099($anchorCell, $headCell) {
    const table = $anchorCell.node(-1);
    const map = (0, $ffWI7.TableMap).get(table);
    const start = $anchorCell.start(-1);
    const rect = map.rectBetween($anchorCell.pos - start, $headCell.pos - start);
    const doc = $anchorCell.node(0);
    const cells = map.cellsInRect(rect).filter((p)=>p !== $headCell.pos - start);
    // Make the head cell the first range, so that it counts as the
    // primary part of the selection
    cells.unshift($headCell.pos - start);
    return cells.map((pos)=>{
        const cell = table.nodeAt(pos);
        if (cell === null) throw new Error(`No cell at position ${pos}`);
        const from = pos + start + 1;
        return new (0, $kpTIW.SelectionRange)(doc.resolve(from), doc.resolve(from + cell.content.size));
    });
}

});



parcelRegister("g9J6K", function(module, exports) {

$parcel$export(module.exports, "sanitizeNodeForPrivacy", () => $f8db9aa1f6c9a08a$export$8a32f625580e0a06);

var $hYZXM = parcelRequire("hYZXM");

var $44HQw = parcelRequire("44HQw");
function $f8db9aa1f6c9a08a$export$8a32f625580e0a06(json, providerFactory) {
    const mentionNames = new Map();
    let hasCacheableMentions = false;
    const sanitizedJSON = (0, $hYZXM.traverse)(json, {
        mention: (node)=>{
            if (node.attrs && node.attrs.text) {
                hasCacheableMentions = true;
                // Remove @ prefix
                const text = node.attrs.text;
                const name = text.startsWith('@') ? text.slice(1) : text;
                mentionNames.set(node.attrs.id, name);
            }
            return {
                ...node,
                attrs: {
                    ...node.attrs,
                    text: ''
                }
            };
        }
    });
    if (hasCacheableMentions && providerFactory) {
        const handler = (_name, providerPromise)=>{
            if (providerPromise) providerPromise.then((provider)=>{
                if ((0, $44HQw.isResolvingMentionProvider)(provider)) {
                    mentionNames.forEach((name, id)=>{
                        provider.cacheMentionName(id, name);
                    });
                    mentionNames.clear();
                    providerFactory.unsubscribe('mentionProvider', handler);
                }
            });
        };
        providerFactory.subscribe('mentionProvider', handler);
    }
    return sanitizedJSON;
}

});


parcelRegister("c64AB", function(module, exports) {

$parcel$export(module.exports, "aiPlaceholderPluginKey", () => $8ce99aee7b6360b8$export$cde829c6dc02d52e);

var $kpTIW = parcelRequire("kpTIW");
const $8ce99aee7b6360b8$export$cde829c6dc02d52e = new (0, $kpTIW.PluginKey)('aiPlaceholderPlugin');

});

parcelRegister("hja73", function(module, exports) {

$parcel$export(module.exports, "default", () => $c99c0e30a38fcd61$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $c99c0e30a38fcd61$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    persistentPlaceholderText: {
        id: 'fabric.editor.ai.persistentPlaceholder.text',
        defaultMessage: `Type /ai for writing assistance`,
        description: 'Message to users that displays in placeholder text when users cursor is inside the editor on an empty line'
    }
});

});


parcelRegister("7NjJC", function(module, exports) {

$parcel$export(module.exports, "createAISpellingGrammarPlugin", () => $5acc6af158b56814$export$709e3bf8b2cd00bb);

var $fBDHJ = parcelRequire("fBDHJ");

var $8BfgW = parcelRequire("8BfgW");

var $R7bnX = parcelRequire("R7bnX");

var $2fbrZ = parcelRequire("2fbrZ");

var $eUgBc = parcelRequire("eUgBc");
function $5acc6af158b56814$export$709e3bf8b2cd00bb(options) {
    const { triggerSpellingAndGrammerCheck: triggerSpellingAndGrammerCheck, cancelDebouncedAndThrottledSpellingAndGrammerCheck: cancelDebouncedAndThrottledSpellingAndGrammerCheck } = (0, $eUgBc.createTriggerSpellingAndGrammerCheck)(options.proactiveAIConfig.timings);
    return new (0, $R7bnX.SafePlugin)({
        key: (0, $2fbrZ.aiSpellingGrammarPluginKey),
        state: (0, $8BfgW.createPluginState)(options.dispatch, (0, $8BfgW.createInitialState)(options.proactiveAIConfig.apiUrl)),
        view () {
            return {
                update: (view, prevState)=>{
                    const { locale: locale } = options.getIntl();
                    const { isSpellingAndGrammarEnabled: isSpellingAndGrammarEnabled } = (0, $8BfgW.getPluginState)(view.state);
                    if (isSpellingAndGrammarEnabled && (!prevState.doc.eq(view.state.doc) || !prevState.selection.eq(view.state.selection))) triggerSpellingAndGrammerCheck(view, locale);
                },
                destroy: cancelDebouncedAndThrottledSpellingAndGrammerCheck
            };
        },
        props: {
            decorations: (state)=>{
                const { isSpellingAndGrammarEnabled: isSpellingAndGrammarEnabled, decorationSet: decorationSet } = (0, $8BfgW.getPluginState)(state);
                if (!isSpellingAndGrammarEnabled) return (0, $fBDHJ.DecorationSet).empty;
                return decorationSet;
            },
            attributes: {
                spellcheck: 'false'
            }
        }
    });
}

});

parcelRegister("2VOb5", function(module, exports) {

$parcel$export(module.exports, "createAskAIButtonTrackerPlugin", () => $2227d3ea96acc67a$export$2d3703ce1068320e);

var $cSjNj = parcelRequire("cSjNj");

var $R7bnX = parcelRequire("R7bnX");
const $2227d3ea96acc67a$export$2d3703ce1068320e = (options)=>{
    const { dispatch: dispatch } = options;
    const initialState = {
        position: {
            from: 0,
            to: 0
        },
        shouldShowAskAIButton: false
    };
    return new (0, $R7bnX.SafePlugin)({
        key: (0, $cSjNj.floatingAiButtonTrackerPluginKey),
        state: {
            init: (_, state)=>initialState,
            apply: (tr, _pluginState, _oldEditorState, newEditorState)=>{
                if (tr.selectionSet || tr.docChanged) {
                    const { selection: selection } = tr;
                    const $currentNode = tr.doc.resolve(selection.from);
                    const isEmptySelection = selection.empty;
                    const { schema: schema } = newEditorState;
                    const { paragraph: paragraph, heading: heading } = schema.nodes;
                    const shouldShowAskAIButton = // Only allowed for top level nodes
                    $currentNode.depth === 1 && isEmptySelection && [
                        paragraph,
                        heading
                    ].includes($currentNode.node().type);
                    const newPluginState = {
                        position: {
                            from: selection.from,
                            to: selection.to
                        },
                        shouldShowAskAIButton: shouldShowAskAIButton
                    };
                    // We need to dispatch state change
                    // As we use WithPluginState to enable/disable AI button.
                    dispatch((0, $cSjNj.floatingAiButtonTrackerPluginKey), newPluginState);
                    return newPluginState;
                }
                return _pluginState;
            }
        }
    });
};

});
parcelRegister("cSjNj", function(module, exports) {

$parcel$export(module.exports, "floatingAiButtonTrackerPluginKey", () => $95f9e1eabcc8a576$export$29a8254ccda17ccc);

var $kpTIW = parcelRequire("kpTIW");
const $95f9e1eabcc8a576$export$29a8254ccda17ccc = new (0, $kpTIW.PluginKey)('floatingAiButtonTracker');

});


parcelRegister("iFWYD", function(module, exports) {

$parcel$export(module.exports, "AskAIButtonWrapper", () => $d989cdf0c1f3c2c8$export$2cc514fe28d37deb);

var $eUqFw = parcelRequire("eUqFw");

var $2KDKi = parcelRequire("2KDKi");

var $l09pD = parcelRequire("l09pD");

var $hoQ4u = parcelRequire("hoQ4u");
const $d989cdf0c1f3c2c8$export$2cc514fe28d37deb = (props)=>{
    var _contentArea$offsetLe, _contentArea$offsetLe2;
    const { editorView: editorView, selection: selection, editorPluginAIProvider: editorPluginAIProvider, showButton: showButton, aiGlobalOptIn: aiGlobalOptIn, appearance: appearance } = props;
    const onButtonClick = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useCallback(()=>{
        const { state: state, dispatch: dispatch } = editorView;
        const configItem = state.selection.empty ? editorPluginAIProvider.emptyConfig.baseGenerate : editorPluginAIProvider.rangeConfig.baseGenerate;
        const openAIModalCommand = (0, $2KDKi.createOpenAIModalCommand)({
            state: state,
            configItem: configItem,
            lastTriggeredFrom: 'floatingAiButton',
            aiGlobalOptIn: aiGlobalOptIn
        });
        openAIModalCommand(state, dispatch);
    }, [
        editorView,
        editorPluginAIProvider,
        aiGlobalOptIn
    ]);
    // Left positioning of the button
    const contentArea = editorView.dom.closest('.ak-editor-content-area');
    const [positionLeft, setUpdatedPositionLeft] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState((_contentArea$offsetLe = contentArea === null || contentArea === void 0 ? void 0 : contentArea.offsetLeft) !== null && _contentArea$offsetLe !== void 0 ? _contentArea$offsetLe : 0);
    const [editorLeft, setEditorLeft] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState((_contentArea$offsetLe2 = contentArea === null || contentArea === void 0 ? void 0 : contentArea.offsetLeft) !== null && _contentArea$offsetLe2 !== void 0 ? _contentArea$offsetLe2 : 0);
    // Handle resizing of the content area
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useEffect(()=>{
        if (!editorView) return;
        const scrollParent = editorView.dom.closest('.fabric-editor-popup-scroll-parent');
        const resizeObserver = new ResizeObserver(()=>{
            var _editorView$dom2;
            if (appearance === 'tip-tap-menu') {
                var _editorView$dom;
                setEditorLeft(((_editorView$dom = editorView.dom) === null || _editorView$dom === void 0 ? void 0 : _editorView$dom.offsetLeft) || 0);
                return;
            }
            setUpdatedPositionLeft(((_editorView$dom2 = editorView.dom) === null || _editorView$dom2 === void 0 ? void 0 : _editorView$dom2.offsetLeft) - (0, $hoQ4u.FLOATING_AI_BUTTON_SIZE) - 8 || 0);
        });
        resizeObserver.observe(scrollParent || editorView.dom);
        if (contentArea) resizeObserver.observe(contentArea);
        return ()=>{
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        editorView,
        appearance,
        contentArea
    ]);
    const domElement = editorView.domAtPos(selection.from).node;
    // we've landed on text instead of a paragraph/heading node
    const nodeElement = domElement.nodeName === '#text' ? domElement.parentElement : domElement;
    if (nodeElement === null) return null;
    let shouldShowAskAIButton = showButton;
    let buttonLeft = positionLeft;
    if (appearance === 'tip-tap-menu') {
        const buttonOffsetPx = 10; // button offset from the cursor
        buttonLeft = editorLeft + buttonOffsetPx;
        // check additional conditions to display tiptap menu
        // need also check for any content not applied yet
        // e.g. with quickinsert we can have text overlapping with button while no content insterted
        // Check if editor page placeholder is present
        // Note: this doesn't check for AI persistent placeholder
        const placeholderPluginKeyName = 'placeholderPlugin$';
        const placeholderPlugin = editorView.state.plugins.find((plugin)=>plugin.key === placeholderPluginKeyName);
        const placeholderPluginState = placeholderPlugin === null || placeholderPlugin === void 0 ? void 0 : placeholderPlugin.getState(editorView.state);
        shouldShowAskAIButton = editorView.state.selection.$from.depth <= 1 && editorView.hasFocus() && editorView.state.selection.$from.parent.isTextblock && editorView.state.selection.$from.parent.content.size === 0 && !Boolean(placeholderPluginState === null || placeholderPluginState === void 0 ? void 0 : placeholderPluginState.hasPlaceholder);
    }
    // don't show floating ai button if there is not enough space on left
    if (shouldShowAskAIButton && buttonLeft >= 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l09pD.FloatingAiButton), {
        positionTop: nodeElement.offsetTop,
        positionLeft: buttonLeft,
        contentHeight: nodeElement.getBoundingClientRect().height,
        onClick: onButtonClick
    });
    return null;
};

});
parcelRegister("l09pD", function(module, exports) {

$parcel$export(module.exports, "FloatingAiButton", () => $f4a0e631ffeeb9fe$export$d27276fe41575bf0);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $aska3 = parcelRequire("aska3");

var $izdMb = parcelRequire("izdMb");

var $hoQ4u = parcelRequire("hoQ4u");

var $8cU5f = parcelRequire("8cU5f");
const $f4a0e631ffeeb9fe$export$d27276fe41575bf0 = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { positionLeft: positionLeft, positionTop: positionTop, onClick: onClick, contentHeight: contentHeight } = props;
    const logoAltmessage = (0, $eUqFw.useMemo)(()=>formatMessage((0, $aska3.default).logoAltText), [
        formatMessage
    ]);
    const style = {
        '--position-top': `${positionTop}px`,
        '--position-left': `${positionLeft}px`,
        '--content-height': `${contentHeight}px`
    };
    const tooltipContent = formatMessage((0, $aska3.default).floatingAiButtonTooltip);
    return (0, $byn9U.jsx)("div", {
        "data-testid": "floating-ai-button",
        css: (0, $hoQ4u.floatingAIButtonWrapperStyles),
        style: style
    }, (0, $byn9U.jsx)((0, $8cU5f.default), {
        content: tooltipContent,
        truncate: true
    }, (0, $byn9U.jsx)("button", {
        type: "button",
        onClick: onClick,
        css: (0, $hoQ4u.floatingAIButtonStyles)
    }, (0, $byn9U.jsx)((0, $izdMb.LogoSvg), {
        alt: logoAltmessage,
        size: (0, $hoQ4u.FLOATING_AI_ICON_SIZE)
    }))));
};

});
parcelRegister("hoQ4u", function(module, exports) {

$parcel$export(module.exports, "FLOATING_AI_BUTTON_SIZE", () => $caad11d5e53ff26d$export$78d6317ccd04e254);
$parcel$export(module.exports, "FLOATING_AI_ICON_SIZE", () => $caad11d5e53ff26d$export$a9b87d8aa8cc0ba0);
$parcel$export(module.exports, "floatingAIButtonWrapperStyles", () => $caad11d5e53ff26d$export$475017a989c555dc);
$parcel$export(module.exports, "floatingAIButtonStyles", () => $caad11d5e53ff26d$export$ade224ad2800ca07);
// Styles have been copied to packages/editor/generative-ai-modal/examples/utils/components/Modals.tsx
// Updates to this file should also be copied to there.

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
const $caad11d5e53ff26d$export$78d6317ccd04e254 = 24;
const $caad11d5e53ff26d$export$a9b87d8aa8cc0ba0 = 14;
const $caad11d5e53ff26d$export$475017a989c555dc = (0, $byn9U.css)({
    position: 'absolute',
    top: 'var(--position-top)',
    left: 'var(--position-left)',
    height: 'var(--content-height)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $caad11d5e53ff26d$export$ade224ad2800ca07 = (0, $byn9U.css)({
    cursor: 'pointer',
    border: `1px solid ${`var(--ds-surface, ${(0, $PdmhA.N0)})`}`,
    boxShadow: `var(--ds-shadow-raised, ${`0 1px 1px ${(0, $PdmhA.N60A)}`})`,
    borderRadius: '50%',
    width: `${$caad11d5e53ff26d$export$78d6317ccd04e254}px`,
    height: `${$caad11d5e53ff26d$export$78d6317ccd04e254}px`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    ':hover': {
        backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${(0, $PdmhA.N20A)})`
    },
    ':active': {
        backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $PdmhA.N40A)})`
    },
    transition: 'background 200ms ease 0s, border 200ms ease 0s',
    padding: "var(--ds-space-050, 4px)",
    backgroundColor: `var(--ds-surface-overlay, ${(0, $PdmhA.N0)})`,
    // disable pointer events to avoid default tooltip since we are adding custom one
    '> svg': {
        pointerEvents: 'none'
    }
});

});



parcelRegister("2eiCd", function(module, exports) {

$parcel$export(module.exports, "createAISuggestTitleFromTitleToolbarPlugin", () => $19fb54384ae3a3a4$export$3c3dfc5bbacd023e);

var $drmHr = parcelRequire("drmHr");

var $R7bnX = parcelRequire("R7bnX");

var $2KDKi = parcelRequire("2KDKi");

var $iJe2d = parcelRequire("iJe2d");

var $4nc7v = parcelRequire("4nc7v");
const $19fb54384ae3a3a4$export$3c3dfc5bbacd023e = (options)=>{
    const { aiGlobalOptIn: aiGlobalOptIn } = options;
    return new (0, $R7bnX.SafePlugin)({
        key: (0, $drmHr.createAISuggestTitleFromTitleToolbarPluginKey),
        view: (editorView)=>{
            let currentEditorView = editorView;
            const handleConfluenceTitleToolbarSuggestTitleClick = (_event)=>{
                const { state: state, dispatch: dispatch } = currentEditorView;
                const openAIModalCommand = (0, $2KDKi.createOpenAIModalCommand)({
                    state: state,
                    configItem: (0, $iJe2d.suggestConfigItemForConfluenceTitleToolbar),
                    lastTriggeredFrom: 'confluenceTitleToolbar',
                    aiGlobalOptIn: aiGlobalOptIn
                });
                openAIModalCommand(state, dispatch);
                return false;
            };
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener((0, $4nc7v.SuggestTitleEvents).GenerateSuggestedTitle, handleConfluenceTitleToolbarSuggestTitleClick);
            return {
                update: (newEditorView)=>{
                    currentEditorView = newEditorView;
                },
                destroy: ()=>{
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    document.removeEventListener((0, $4nc7v.SuggestTitleEvents).GenerateSuggestedTitle, handleConfluenceTitleToolbarSuggestTitleClick);
                }
            };
        }
    });
};

});
parcelRegister("drmHr", function(module, exports) {

$parcel$export(module.exports, "createAISuggestTitleFromTitleToolbarPluginKey", () => $9c8f67aef785871f$export$e7b009d059cc24b9);

var $kpTIW = parcelRequire("kpTIW");
const $9c8f67aef785871f$export$e7b009d059cc24b9 = new (0, $kpTIW.PluginKey)('aiSuggestTitleFromTitleToolbar');

});

parcelRegister("iJe2d", function(module, exports) {

$parcel$export(module.exports, "suggestConfigItemForConfluenceTitleToolbar", () => $da2750fa8a6127c4$export$1cda52810d955d8d);

var $eUqFw = parcelRequire("eUqFw");

var $6mnRu = parcelRequire("6mnRu");

var $EZ9eX = parcelRequire("EZ9eX");

var $iRpdu = parcelRequire("iRpdu");

var $da8jY = parcelRequire("da8jY");

var $vQfEF = parcelRequire("vQfEF");

var $k6cmI = parcelRequire("k6cmI");

var $fNCiF = parcelRequire("fNCiF");

var $gfOPY = parcelRequire("gfOPY");

var $dextO = parcelRequire("dextO");

var $XHGTv = parcelRequire("XHGTv");

var $8ae7G = parcelRequire("8ae7G");
const $da2750fa8a6127c4$var$SELECTION_TYPE = 'range';
const $da2750fa8a6127c4$export$91dbca81a2af6bab = (0, $EZ9eX.createEditorPluginAIConfigItemMarkdown)({
    title: ({ formatMessage: formatMessage })=>formatMessage((0, $k6cmI.messages).title),
    description: ({ formatMessage: formatMessage })=>formatMessage((0, $k6cmI.messages).description),
    selectionType: $da2750fa8a6127c4$var$SELECTION_TYPE,
    getInitialContext: ({ editorView: editorView, positions: positions, intl: intl, updateIdMap: updateIdMap })=>{
        const selection = (0, $6mnRu.sliceOrNodeToMarkdown)({
            slice: (0, $gfOPY.getSlice)(editorView, positions),
            intl: intl,
            editorView: editorView,
            convertTo: 'markdown',
            updateIdMap: updateIdMap,
            selectionType: $da2750fa8a6127c4$var$SELECTION_TYPE
        });
        const document = (0, $6mnRu.sliceOrNodeToMarkdown)({
            node: editorView.state.doc,
            intl: intl,
            editorView: editorView,
            convertTo: 'markdown',
            updateIdMap: updateIdMap,
            selectionType: $da2750fa8a6127c4$var$SELECTION_TYPE
        });
        return {
            selection: selection.markdown,
            document: document.markdown,
            userLocale: intl.locale,
            intentSchemaId: 'suggest_title_intent_schema.json',
            contentStatistics: selection.contentStatistics
        };
    },
    triggerPromptRequest ({ initialContext: initialContext, editorSchema: editorSchema, backendModel: backendModel }) {
        if ((0, $XHGTv.getBooleanFF)('platform.editor.ai-assistance-service-suggest-title')) return (0, $da8jY.summaryConvoAI)({
            userLocale: initialContext.userLocale,
            intentSchemaId: initialContext.intentSchemaId,
            editorSchema: editorSchema,
            currentSelection: initialContext.selection,
            fullDocument: initialContext.document,
            backendModel: backendModel
        });
        return (0, $iRpdu.generate)({
            userLocale: initialContext.userLocale,
            intentSchemaId: initialContext.intentSchemaId,
            editorSchema: editorSchema,
            contextList: [
                {
                    type: 'text',
                    entity: initialContext.selection,
                    relationship: 'SELECTION'
                }
            ],
            backendModel: backendModel
        });
    },
    isVisible: ({ editorView: editorView, positions: positions })=>(0, $fNCiF.isMinLength)({
            editorView: editorView,
            minLength: 1,
            positions: positions
        }),
    icon: ({ shownAt: shownAt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dextO.Icon), {
            shownAt: shownAt
        }),
    actions: [
        (0, $vQfEF.createInsertAtCurrentPosition)({
            appearance: 'secondary'
        }),
        (0, $vQfEF.createInsertAtTop)({
            appearance: 'primary'
        })
    ],
    getBackendModel: ()=>{
        if ((0, $XHGTv.getBooleanFF)('platform.editor.ai-assistance-service-suggest-title')) return 'assistance-service';
        return (0, $8ae7G.getBackendModelExperiment)();
    }
});
const $da2750fa8a6127c4$export$1cda52810d955d8d = (0, $EZ9eX.createEditorPluginAIConfigItemMarkdown)({
    title: ({ formatMessage: formatMessage })=>formatMessage((0, $k6cmI.messages).title),
    description: ({ formatMessage: formatMessage })=>formatMessage((0, $k6cmI.messages).description),
    selectionType: 'range',
    getInitialContext: ({ editorView: editorView, positions: positions, intl: intl, updateIdMap: updateIdMap })=>{
        const { markdown: markdown, contentStatistics: contentStatistics } = (0, $6mnRu.sliceOrNodeToMarkdown)({
            slice: (0, $gfOPY.getSlice)(editorView, positions),
            intl: intl,
            editorView: editorView,
            convertTo: 'markdown',
            updateIdMap: updateIdMap,
            selectionType: 'range'
        });
        return {
            selection: markdown,
            userLocale: intl.locale,
            intentSchemaId: 'suggest_title_intent_schema.json',
            contentStatistics: contentStatistics
        };
    },
    triggerPromptRequest ({ initialContext: initialContext, editorSchema: editorSchema }) {
        return (0, $iRpdu.generate)({
            userLocale: initialContext.userLocale,
            intentSchemaId: initialContext.intentSchemaId,
            editorSchema: editorSchema,
            contextList: [
                {
                    type: 'text',
                    entity: initialContext.selection,
                    relationship: 'SELECTION'
                }
            ]
        });
    },
    isVisible: ({ editorView: editorView, positions: positions })=>(0, $fNCiF.isMinLength)({
            editorView: editorView,
            minLength: 1,
            positions: positions
        }),
    icon: ({ shownAt: shownAt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dextO.Icon), {
            shownAt: shownAt
        }),
    actions: [
        (0, $vQfEF.createReplaceExistingConfluenceTitle)({
            appearance: 'primary'
        })
    ],
    getBackendModel: ()=>{
        if ((0, $XHGTv.getBooleanFF)('platform.editor.ai-assistance-service-suggest-title')) return 'assistance-service';
        return (0, $8ae7G.getBackendModelExperiment)();
    }
});

});
parcelRegister("iRpdu", function(module, exports) {

$parcel$export(module.exports, "generate", () => $dbb0bcb53dab3013$export$80d376111cc09ad7);
$parcel$export(module.exports, "generateConvoAI", () => $dbb0bcb53dab3013$export$f6c182b0ec546e2c);

var $9LezI = parcelRequire("9LezI");

var $4Dk05 = parcelRequire("4Dk05");

var $g6Vmo = parcelRequire("g6Vmo");

var $kgZDI = parcelRequire("kgZDI");

var $8ae7G = parcelRequire("8ae7G");
const $dbb0bcb53dab3013$export$80d376111cc09ad7 = (input)=>{
    return function promptRequest(requestOptions) {
        const contextList = (0, $kgZDI.runContextListAgainstFFs)(input.contextList);
        const streamingResponseGenerator = (0, $9LezI.startStreamingResponse)({
            endpoint: requestOptions.generativeAIApiUrl,
            payload: JSON.stringify({
                intentSchemaId: input.intentSchemaId,
                userInstruction: input.customPrompt,
                contextList: contextList,
                modelPlatform: 'OPENAI',
                outputLocale: input.userLocale,
                streaming: true,
                outputFormat: {
                    outputFormatType: 'MARKDOWN',
                    markdowns: (0, $4Dk05.getSupportedMarkdowns)(input.editorSchema)
                },
                product: requestOptions.product,
                ...input.backendModel === 'einstein' && {
                    backendExperiment: 'EINSTEIN'
                }
            }),
            ...requestOptions
        });
        return (0, $g6Vmo.streamResponsePreview)({
            streamingResponseGenerator: streamingResponseGenerator
        });
    };
};
const $dbb0bcb53dab3013$export$f6c182b0ec546e2c = (input)=>{
    return function promptRequest(requestOptions) {
        const streamingResponseGenerator = (0, $9LezI.startStreamingResponse)({
            // This is the Convo AI 'stateless' endpoint (i.e. no session is maintained between requests)
            endpoint: (0, $8ae7G.convoAIStatelessApiURL),
            payload: JSON.stringify({
                agent_input_prompt: input.customPrompt,
                recipient_agent_named_id: 'editor_agent',
                agent_input_context: {
                    content: input.customPrompt,
                    writing_intent: input.intentSchemaId,
                    draft_full_content: input.fullDocument,
                    draft_selected_content: input.latestPromptResponse ? input.latestPromptResponse : input.currentSelection,
                    supported_markdown_nodes: (0, $4Dk05.getSupportedMarkdowns)(input.editorSchema),
                    input_mime_type: 'text/markdown',
                    output_mime_type: 'text/markdown',
                    locale: input.userLocale,
                    product: requestOptions.product
                }
            }),
            ...requestOptions
        });
        return (0, $g6Vmo.streamResponsePreview)({
            streamingResponseGenerator: streamingResponseGenerator,
            isConvoAI: true
        });
    };
};

});
parcelRegister("4Dk05", function(module, exports) {

$parcel$export(module.exports, "getSupportedMarkdowns", () => $35fa519a5d53ae67$export$64c88b3c322e3de4);
/**
 * BE supported markdowns are defined in https://bitbucket.org/atlassian/cc-smarts/src/master/src/main/java/io/atlassian/micros/smarts/model/Markdown.java
 * BE support is based on https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3632267938/Mapping+node+and+mark+names+to+markdown+features
 */ const $35fa519a5d53ae67$export$a02ea4309dad57bb = {
    blockquote: 'BLOCKQUOTES',
    paragraph: 'PARAGRAPH',
    rule: 'HORIZONTAL_RULE',
    heading: 'HEADING',
    hardbreak: 'HARD_LINE_BREAK',
    codeBlock: 'CODEBLOCKS',
    bulletList: 'BULLET_LISTS',
    orderedList: 'NUMBERED_LISTS',
    media: 'IMAGES',
    table: 'TABLE',
    taskList: 'TASK_LIST',
    code: 'CODE_SPAN',
    em: 'ITALICS',
    strong: 'BOLD',
    link: 'LINK',
    strike: 'STRIKETHROUGH'
};
const $35fa519a5d53ae67$export$64c88b3c322e3de4 = (schema)=>{
    if (!(schema !== null && schema !== void 0 && schema.nodes) && !(schema !== null && schema !== void 0 && schema.marks)) return [];
    const schemaNodesAndMarks = [
        ...Object.keys(schema.nodes),
        ...Object.keys(schema.marks)
    ];
    return schemaNodesAndMarks.map((nodeOrMark)=>$35fa519a5d53ae67$export$a02ea4309dad57bb[nodeOrMark]).filter(Boolean);
};

});

parcelRegister("kgZDI", function(module, exports) {

$parcel$export(module.exports, "runContextListAgainstFFs", () => $ec251d95f6018a4f$export$c25858a5cb8c13ab);

var $XHGTv = parcelRequire("XHGTv");
function $ec251d95f6018a4f$export$c25858a5cb8c13ab(contextList) {
    const transformedContextList = contextList.map((contextEntry)=>{
        if (!(0, $XHGTv.getBooleanFF)('platform.editor.ai-send-full-content_r1qpp')) // Ignoring the type error here to keep the code simple
        // this is sent as json -- so will be stripped away by setting to undefined
        // @ts-ignore
        contextEntry.relationship = undefined;
        if (!(0, $XHGTv.getBooleanFF)('platform.editor.ai-markdown-plus_9v1w7')) // Ignoring the type error here to keep the code simple
        // when the markdown plus feature flag is not turned on -- the only valid
        // type is 'text'
        // @ts-ignore
        contextEntry.type = 'text';
        return contextEntry;
    });
    return transformedContextList;
}

});


parcelRegister("da8jY", function(module, exports) {

$parcel$export(module.exports, "summary", () => $9952a9eea8c8a9f2$export$9a2dbef7a17e2e58);
$parcel$export(module.exports, "summaryConvoAI", () => $9952a9eea8c8a9f2$export$115a19ad0d1d46d8);

var $9LezI = parcelRequire("9LezI");

var $g6Vmo = parcelRequire("g6Vmo");

var $4Dk05 = parcelRequire("4Dk05");

var $kgZDI = parcelRequire("kgZDI");

var $8ae7G = parcelRequire("8ae7G");
const $9952a9eea8c8a9f2$export$9a2dbef7a17e2e58 = (input, customEndpoint)=>{
    return function promptRequest(requestOptions) {
        const streamingResponseGenerator = (0, $9LezI.startStreamingResponse)({
            endpoint: customEndpoint || requestOptions.generativeAIApiUrl,
            payload: JSON.stringify({
                intentSchemaId: input.intentSchemaId,
                contextList: (0, $kgZDI.runContextListAgainstFFs)(input.contextList),
                modelPlatform: 'OPENAI',
                outputLocale: input.userLocale,
                streaming: true,
                outputFormat: {
                    outputFormatType: 'MARKDOWN',
                    markdowns: (0, $4Dk05.getSupportedMarkdowns)(input.editorSchema)
                },
                product: requestOptions.product,
                ...input.backendModel === 'einstein' && {
                    backendExperiment: 'EINSTEIN'
                }
            }),
            ...requestOptions
        });
        return (0, $g6Vmo.streamResponsePreview)({
            streamingResponseGenerator: streamingResponseGenerator,
            streamingListener: input.streamingListener
        });
    };
};
const $9952a9eea8c8a9f2$export$115a19ad0d1d46d8 = (input, customEndpoint)=>{
    return function promptRequest(requestOptions) {
        const streamingResponseGenerator = (0, $9LezI.startStreamingResponse)({
            endpoint: customEndpoint || (0, $8ae7G.convoAIStatelessApiURL),
            payload: JSON.stringify({
                recipient_agent_named_id: 'editor_intent_agent',
                agent_input_context: {
                    writing_intent: input.intentSchemaId,
                    draft_full_content: input.fullDocument,
                    draft_selected_content: input.currentSelection,
                    supported_markdown_nodes: (0, $4Dk05.getSupportedMarkdowns)(input.editorSchema),
                    input_mime_type: 'text/markdown',
                    output_mime_type: 'text/markdown',
                    locale: input.userLocale,
                    product: requestOptions.product
                }
            }),
            ...requestOptions
        });
        return (0, $g6Vmo.streamResponsePreview)({
            streamingResponseGenerator: streamingResponseGenerator,
            isConvoAI: true
        });
    };
};

});

parcelRegister("k6cmI", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ea1df5b4a1f3edcb$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $ea1df5b4a1f3edcb$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        id: 'fabric.editor.ai.config.item.range.suggest.title',
        defaultMessage: 'Suggest a title',
        description: 'Describes an option to use Atlassian Intellgience to suggest an appropriate title for the content currently selected by the user'
    },
    description: {
        id: 'fabric.editor.ai.config.item.range.suggest.description',
        defaultMessage: 'Suggests a title for content you provide',
        description: 'Describes "Suggest a Title" Atlassian Intelligence feature to suggest an appropriate title for the content currently selected by the user'
    }
});

});

parcelRegister("fNCiF", function(module, exports) {

$parcel$export(module.exports, "isMinLength", () => $b809243aa62009eb$export$9db96a5522993877);
/**
 * Checks if the selection is equal to or longer than the minimum length.
 *
 * If no selection exists it will check if the document is equal too or longer than the minimum length.
 * Includes whitespace, like empty paragraphs, when calculating the length.
 */ // NOTE: To match the backend minimum length we should parse
// to markdown and check the length of the markdown string.
function $b809243aa62009eb$export$9db96a5522993877({ editorView: editorView, minLength: minLength, positions: positions }) {
    // If there is no selection
    // Or there is an empty selection and the FF is enabled
    if (!positions || positions && positions[0] === positions[1]) {
        const doc = editorView.state.doc;
        // Size of the doc with a single empty paragraph is 4
        const positionDiff = doc.nodeSize - 4;
        return positionDiff >= minLength;
    } else if (positions && positions[0] !== positions[1]) {
        const positionDiff = positions[1] - positions[0];
        return positionDiff >= minLength;
    } else return 0 >= minLength;
}

});

parcelRegister("dextO", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $9a268d8b4b71404c$export$f04a61298a47a40f);

var $eUqFw = parcelRequire("eUqFw");

var $8DZnH = parcelRequire("8DZnH");
const $9a268d8b4b71404c$export$f04a61298a47a40f = (props)=>{
    const { shownAt: shownAt } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8DZnH.RainbowBorder), {
        shownAt: shownAt
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "var(--ds-icon, #44546F)",
        xmlns: "http://www.w3.org/2000/svg",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8V17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17V8Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M17 6H7C6.44772 6 6 6.44772 6 7C6 7.55228 6.44772 8 7 8H17C17.5523 8 18 7.55228 18 7C18 6.44772 17.5523 6 17 6Z"
    })));
};

});
parcelRegister("8DZnH", function(module, exports) {

$parcel$export(module.exports, "RainbowBorder", () => $64b194478c32dac4$export$36738bc14a47b579);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $eUqFw = parcelRequire("eUqFw");

var $eaNHE = parcelRequire("eaNHE");

var $hkwTa = parcelRequire("hkwTa");
const $64b194478c32dac4$export$36738bc14a47b579 = (props)=>{
    const { children: children, shownAt: shownAt } = props;
    const id = (0, $eUqFw.useMemo)(()=>`aiIcon_radial_${new Date().getTime()}`, []);
    if (shownAt === 'suggestions') return children;
    return (0, $byn9U.jsx)("div", {
        css: [
            (0, $hkwTa.styleDiv),
            (0, $hkwTa.styleIconBackground)
        ]
    }, (0, $byn9U.jsx)("svg", {
        css: (0, $hkwTa.styleBorder),
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, (0, $byn9U.jsx)("rect", {
        x: "0.5",
        y: "1.5",
        width: "37",
        height: "37.5",
        rx: "1.5",
        stroke: `url(#${id})`
    }), (0, $byn9U.jsx)("defs", null, (0, $byn9U.jsx)("radialGradient", {
        id: id,
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(1 1.5) rotate(44.5937) scale(49.8523)"
    }, (0, $byn9U.jsx)((0, $eaNHE.Border), null)))), children);
};

});
parcelRegister("eaNHE", function(module, exports) {

$parcel$export(module.exports, "Border", () => $a5188ddc4b4578c7$export$d8e9c9d63e86d41e);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $eUqFw = parcelRequire("eUqFw");

var $epPZ1 = parcelRequire("epPZ1");
const $a5188ddc4b4578c7$export$d8e9c9d63e86d41e = ()=>{
    const aiThemeColor = (0, $epPZ1.useAIThemeColor)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: aiThemeColor('prism.border.step.1')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.25",
        stopColor: aiThemeColor('prism.border.step.1')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.41",
        stopColor: aiThemeColor('prism.border.step.2')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.73",
        stopColor: aiThemeColor('prism.border.step.3')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.86",
        stopColor: aiThemeColor('prism.border.step.4')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: aiThemeColor('prism.border.step.4')
    }));
};

});

parcelRegister("hkwTa", function(module, exports) {

$parcel$export(module.exports, "styleDiv", () => $c9ddd0f8dd7be7af$export$e3954c8d3eea2d73);
$parcel$export(module.exports, "styleIconBackground", () => $c9ddd0f8dd7be7af$export$6bed1d6e2b9a9393);
$parcel$export(module.exports, "styleBorder", () => $c9ddd0f8dd7be7af$export$25bdff09c381b13a);
// Styles have been copied to packages/editor/generative-ai-modal/examples/utils/components/Modals.tsx
// Updates to this file should also be copied to there.

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
const $c9ddd0f8dd7be7af$export$e3954c8d3eea2d73 = (0, $byn9U.css)({
    position: 'relative',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center'
});
const $c9ddd0f8dd7be7af$export$6bed1d6e2b9a9393 = (0, $byn9U.css)({
    backgroundColor: `var(--ds-surface-overlay, ${(0, $PdmhA.N0)})`
});
const $c9ddd0f8dd7be7af$export$25bdff09c381b13a = (0, $byn9U.css)({
    position: 'absolute',
    left: '0px',
    top: '0px',
    right: 0,
    bottom: 0
});

});





parcelRegister("cDGhz", function(module, exports) {

$parcel$export(module.exports, "getAIPanelContext", () => $9339ecf74e3e370e$export$7e9e198df6480b71);
$parcel$export(module.exports, "summarisePage", () => $9339ecf74e3e370e$export$ecf2ec6e5395625c);
$parcel$export(module.exports, "findActionItems", () => $9339ecf74e3e370e$export$acf0f0fea45f23f0);
$parcel$export(module.exports, "regenerateExtension", () => $9339ecf74e3e370e$export$7246b4335959ec58);
$parcel$export(module.exports, "convertExtension", () => $9339ecf74e3e370e$export$7c598a791aec5c81);
$parcel$export(module.exports, "triggerAIPanelFeedbackCollector", () => $9339ecf74e3e370e$export$a96f428565c29386);

var $5Ldsf = parcelRequire("5Ldsf");

var $ln5HZ = parcelRequire("ln5HZ");

var $7dkLM = parcelRequire("7dkLM");

var $iydfr = parcelRequire("iydfr");

var $56bKX = parcelRequire("56bKX");

var $aFbB0 = parcelRequire("aFbB0");

var $8PT7T = parcelRequire("8PT7T");
const $9339ecf74e3e370e$export$efb69f1fe7577739 = async (streaming, callback)=>{
    for await (const streamItem of streaming){
        if (streamItem.state === 'failed') {
            var _streamItem$guard;
            if ('reason' in streamItem) {
                if (streamItem.reason === 'rate-limited') {
                    callback('RATE_LIMIT', streamItem.state);
                    continue;
                }
            }
            // @ts-ignore-next-line
            callback((_streamItem$guard = streamItem === null || streamItem === void 0 ? void 0 : streamItem.guard) !== null && _streamItem$guard !== void 0 ? _streamItem$guard : 'API_FAILED', streamItem.state);
            continue;
        } else if (streamItem.state === 'aup-violation') {
            callback('ACCEPTABLE_USE_VIOLATIONS', streamItem.state);
            continue;
        } else if ((streamItem === null || streamItem === void 0 ? void 0 : streamItem.state) === 'created-channel') ;
        else {
            var _streamItem$data;
            callback((_streamItem$data = streamItem.data) === null || _streamItem$data === void 0 ? void 0 : _streamItem$data.content, streamItem.state);
            continue;
        }
    }
};
const $9339ecf74e3e370e$export$7e9e198df6480b71 = ({ configItem: configItem, intentSchemaId: intentSchemaId, editorView: editorView, providerFactory: providerFactory, idMap: idMap, intl: intl, updateIdMap: updateIdMap })=>{
    var _configItem$getInitia;
    if (!editorView) return;
    const positions = [
        editorView.state.selection.$from.pos,
        editorView.state.selection.$to.pos
    ];
    const initialContext = (_configItem$getInitia = configItem.getInitialContext) === null || _configItem$getInitia === void 0 ? void 0 : _configItem$getInitia.call(configItem, {
        editorView: editorView,
        positions: positions,
        intl: intl,
        updateIdMap: updateIdMap,
        intentSchemaId: intentSchemaId
    });
    return {
        schema: editorView.state.schema,
        providerFactory: providerFactory,
        idMap: idMap,
        initialContext: initialContext
    };
};
const $9339ecf74e3e370e$export$ecf2ec6e5395625c = ({ editorView: editorView, generativeAIApiUrl: generativeAIApiUrl, product: product, callback: callback, intl: intl, initialContext: initialContext })=>{
    if (!editorView) return;
    const promptRequest = (0, $56bKX.summarizePageConfigItem).triggerPromptRequest({
        initialContext: initialContext !== null && initialContext !== void 0 ? initialContext : {
            userLocale: 'en',
            intentSchemaId: 'summarize_intent_schema.json',
            document: editorView.state.doc.toString()
        },
        editorSchema: editorView.state.schema,
        formatMessage: intl.formatMessage,
        streamingListener: callback
    });
    const streaming = promptRequest({
        generativeAIApiUrl: generativeAIApiUrl,
        product: product,
        abortController: new AbortController()
    });
    $9339ecf74e3e370e$export$efb69f1fe7577739(streaming, callback);
};
const $9339ecf74e3e370e$export$acf0f0fea45f23f0 = ({ editorView: editorView, generativeAIApiUrl: generativeAIApiUrl, product: product, callback: callback, intl: intl, initialContext: initialContext })=>{
    if (!editorView) return;
    const promptRequest = (0, $iydfr.findActionItemsConfigItem).triggerPromptRequest({
        initialContext: initialContext !== null && initialContext !== void 0 ? initialContext : {
            userLocale: 'en',
            intentSchemaId: 'action_items_intent_schema.json',
            document: editorView.state.doc.toString()
        },
        editorSchema: editorView.state.schema,
        formatMessage: intl.formatMessage,
        streamingListener: callback
    });
    const streaming = promptRequest({
        generativeAIApiUrl: generativeAIApiUrl,
        product: product,
        abortController: new AbortController()
    });
    $9339ecf74e3e370e$export$efb69f1fe7577739(streaming, callback);
};
const $9339ecf74e3e370e$export$7246b4335959ec58 = ({ editorView: editorView, localId: localId, extensionKey: extensionKey, idMap: idMap })=>{
    const tr = editorView === null || editorView === void 0 ? void 0 : editorView.state.tr;
    if (editorView && tr) (0, $aFbB0.addAnalytics)({
        editorState: editorView === null || editorView === void 0 ? void 0 : editorView.state,
        tr: tr,
        payload: {
            action: 'click',
            actionSubject: 'editorPluginAI',
            actionSubjectId: 'AIPanels',
            eventType: 'ui',
            attributes: {
                extensionType: 'com.atlassian.ai-blocks',
                extensionKey: extensionKey,
                action: 'regenerate'
            }
        }
    });
    $9339ecf74e3e370e$export$7c598a791aec5c81({
        editorView: editorView,
        localId: localId,
        extensionKey: extensionKey,
        idMap: idMap,
        tr: tr
    });
};
const $9339ecf74e3e370e$export$7c598a791aec5c81 = ({ editorView: editorView, localId: localId, extensionKey: extensionKey, idMap: idMap, tr: tr, addToHistory: addToHistory })=>{
    if (!editorView) return;
    const nodes = (0, $5Ldsf.findNodePosByLocalIds)(editorView.state, [
        localId
    ]);
    if (!tr) tr = editorView.state.tr;
    const nodeToReplace = nodes[0];
    if (!nodeToReplace) return;
    const { pmFragment: pmFragment } = (0, $ln5HZ.getPMFragmentWithFallback)({
        markdown: nodeToReplace.node.attrs.parameters.content,
        schema: editorView.state.schema,
        source: 'ai-blocks',
        fireAIAnalyticsEvent: ()=>{},
        idMap: idMap
    });
    let newNode;
    if (extensionKey.includes('BodiedExtension')) {
        newNode = editorView.state.schema.node('bodiedExtension', {
            ...nodeToReplace.node.attrs,
            extensionType: 'com.atlassian.ai-blocks',
            extensionKey: extensionKey
        }, pmFragment);
        tr.replaceWith(nodeToReplace.pos, nodeToReplace.pos + nodeToReplace.node.nodeSize, newNode);
        if (typeof addToHistory === 'boolean') tr.setMeta('addToHistory', addToHistory);
        editorView.dispatch(tr);
    } else {
        // We want to delete the original node first and then create the new node and insert it
        // This way if we call regenerate whilst on the extension view, the state will be updated correctly
        // and retrigger the regenerate
        let tr = editorView.state.tr.delete(nodeToReplace.pos, nodeToReplace.pos + nodeToReplace.node.nodeSize);
        if (typeof addToHistory === 'boolean') tr.setMeta('addToHistory', addToHistory);
        editorView.dispatch(tr);
        newNode = editorView.state.schema.node('extension', {
            ...nodeToReplace.node.attrs,
            extensionType: 'com.atlassian.ai-blocks',
            extensionKey: extensionKey,
            parameters: {
                ...nodeToReplace.node.attrs.parameters,
                content: ''
            }
        }, (0, $7dkLM.Fragment).from([]));
        tr = editorView.state.tr.insert(nodeToReplace.pos, newNode);
        if (typeof addToHistory === 'boolean') tr.setMeta('addToHistory', addToHistory);
        editorView.dispatch(tr);
    }
};
const $9339ecf74e3e370e$var$trackAnalyticsEvent = (fireAnalyticsEvent, product, extensionKey, productSuccessStatus, hasAcceptableUseWarning)=>{
    const payload = {
        action: 'click',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'AIPanelsFeedbackButton',
        attributes: {
            extensionKey: extensionKey,
            sentiment: 'unknown',
            hasAcceptableUseWarning: hasAcceptableUseWarning,
            appearance: 'unknown',
            product: product,
            productSuccessStatus: productSuccessStatus
        },
        eventType: 'ui'
    };
    // @ts-ignore
    fireAnalyticsEvent(payload);
};
const $9339ecf74e3e370e$export$a96f428565c29386 = async ({ extensionKey: extensionKey, markdown: markdown, locale: locale, editorPluginAIProvider: editorPluginAIProvider, fireAnalyticsEvent: fireAnalyticsEvent })=>{
    const hasAcceptableUseWarning = (0, $8PT7T.getHasAcceptableUseWarning)({
        markdown: markdown,
        locale: locale
    });
    if (!editorPluginAIProvider || !fireAnalyticsEvent) return;
    try {
        var _editorPluginAIProvid;
        const productResponse = await ((_editorPluginAIProvid = editorPluginAIProvider.handleFeedbackSubmission) === null || _editorPluginAIProvid === void 0 ? void 0 : _editorPluginAIProvid.call(editorPluginAIProvider, {
            sentiment: 'unknown',
            getAIExperience: (hasUserConsent)=>({
                    hasAcceptableUseWarning: hasAcceptableUseWarning,
                    extensionKey: extensionKey,
                    ...hasUserConsent ? {
                        markdownResponse: markdown
                    } : {}
                }),
            editorAttributes: {
                appearance: 'unknown',
                product: editorPluginAIProvider.product
            }
        }));
        $9339ecf74e3e370e$var$trackAnalyticsEvent(fireAnalyticsEvent, editorPluginAIProvider.product, extensionKey, productResponse === null || productResponse === void 0 ? void 0 : productResponse.status, hasAcceptableUseWarning);
    } catch (err) {
        $9339ecf74e3e370e$var$trackAnalyticsEvent(fireAnalyticsEvent, editorPluginAIProvider.product, extensionKey, 'failed', hasAcceptableUseWarning);
    }
};

});
parcelRegister("5Ldsf", function(module, exports) {

$parcel$export(module.exports, "findNodePosByLocalIds", () => $28d991eb0005ca77$export$947fc26275418e36);
const $28d991eb0005ca77$export$947fc26275418e36 = (state, ids, option = {})=>{
    if (ids.length === 0) return [];
    const nodes = [];
    const localIdSet = new Set(ids);
    if (option.includeDocNode && localIdSet.has(state.doc.attrs?.localId)) nodes.push({
        node: state.doc,
        pos: 0
    });
    state.doc.descendants((node, pos)=>{
        if (localIdSet.has(node.attrs?.localId)) nodes.push({
            node: node,
            pos: pos
        });
        // stop traversing once we found all the nodes
        return localIdSet.size !== nodes.length;
    });
    return nodes;
};

});

parcelRegister("iydfr", function(module, exports) {

$parcel$export(module.exports, "findActionItemsConfigItem", () => $d815adbde1bf7d6e$export$3a51e82d90f30f07);

var $eUqFw = parcelRequire("eUqFw");

var $EZ9eX = parcelRequire("EZ9eX");

var $iRpdu = parcelRequire("iRpdu");

var $da8jY = parcelRequire("da8jY");

var $vQfEF = parcelRequire("vQfEF");

var $6mnRu = parcelRequire("6mnRu");

var $6tWhH = parcelRequire("6tWhH");

var $vNgaK = parcelRequire("vNgaK");

var $fNCiF = parcelRequire("fNCiF");

var $XHGTv = parcelRequire("XHGTv");

var $8ae7G = parcelRequire("8ae7G");
const $d815adbde1bf7d6e$var$SELECTION_TYPE = 'empty';
const $d815adbde1bf7d6e$export$3a51e82d90f30f07 = (0, $EZ9eX.createEditorPluginAIConfigItemMarkdown)({
    title: ({ formatMessage: formatMessage })=>formatMessage((0, $6tWhH.messages).title),
    description: ({ formatMessage: formatMessage })=>formatMessage((0, $6tWhH.messages).description),
    selectionType: $d815adbde1bf7d6e$var$SELECTION_TYPE,
    getInitialContext: ({ editorView: editorView, intl: intl, updateIdMap: updateIdMap })=>{
        const { markdown: markdown, contentStatistics: contentStatistics } = (0, $6mnRu.sliceOrNodeToMarkdown)({
            node: editorView.state.doc,
            intl: intl,
            editorView: editorView,
            convertTo: 'markdown-plus',
            updateIdMap: updateIdMap,
            selectionType: $d815adbde1bf7d6e$var$SELECTION_TYPE
        });
        return {
            document: markdown,
            userLocale: intl.locale,
            intentSchemaId: 'action_items_intent_schema.json',
            contentStatistics: contentStatistics
        };
    },
    icon: ({ shownAt: shownAt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $vNgaK.Icon), {
            shownAt: shownAt
        }),
    triggerPromptRequest ({ initialContext: initialContext, editorSchema: editorSchema, backendModel: backendModel }) {
        if ((0, $XHGTv.getBooleanFF)('platform.editor.ai-assistance-service-find-action-items')) return (0, $da8jY.summaryConvoAI)({
            userLocale: initialContext.userLocale,
            intentSchemaId: 'action_items_intent_schema.json',
            editorSchema: editorSchema,
            fullDocument: initialContext.document,
            backendModel: backendModel
        });
        return (0, $iRpdu.generate)({
            userLocale: initialContext.userLocale,
            editorSchema: editorSchema,
            intentSchemaId: initialContext.intentSchemaId,
            contextList: [
                {
                    type: 'ADF_MARKDOWN_V1',
                    entity: initialContext.document,
                    relationship: 'FULL_CONTENT'
                }
            ]
        });
    },
    isVisible: ({ editorView: editorView })=>(0, $fNCiF.isMinLength)({
            editorView: editorView,
            minLength: 1
        }),
    actions: [
        (0, $vQfEF.createInsertAtTop)({
            appearance: 'secondary'
        }),
        (0, $vQfEF.createInsertAtCurrentPosition)({
            appearance: 'primary'
        })
    ],
    getBackendModel: ()=>{
        if ((0, $XHGTv.getBooleanFF)('platform.editor.ai-assistance-service-find-action-items')) return 'assistance-service';
        return (0, $8ae7G.getBackendModelExperiment)();
    }
});

});
parcelRegister("6tWhH", function(module, exports) {

$parcel$export(module.exports, "messages", () => $4b82a99b9e460e27$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $4b82a99b9e460e27$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        id: 'fabric.editor.ai.config.item.empty.findActionItems.title',
        defaultMessage: 'Find action items',
        description: 'Title for "Find Action Items" Atlassian Intelligence feature shown in editor typeahead and element browser.'
    },
    description: {
        id: 'fabric.editor.ai.config.item.empty.findActionItems.description',
        defaultMessage: 'Finds action items in the content you provide',
        description: 'Describes the "Find Action Items" Atlassian Intelligence feature shown in editor typeahead and element browser.'
    }
});

});

parcelRegister("vNgaK", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $05f91b582d0ac044$export$f04a61298a47a40f);

var $eUqFw = parcelRequire("eUqFw");

var $8DZnH = parcelRequire("8DZnH");
const $05f91b582d0ac044$export$f04a61298a47a40f = (props)=>{
    const { shownAt: shownAt } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8DZnH.RainbowBorder), {
        shownAt: shownAt
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "var(--ds-icon, #44546F)",
        xmlns: "http://www.w3.org/2000/svg",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M18 16H11C10.4477 16 10 16.4477 10 17C10 17.5523 10.4477 18 11 18H18C18.5523 18 19 17.5523 19 17C19 16.4477 18.5523 16 18 16Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M18 11H11C10.4477 11 10 11.4477 10 12C10 12.5523 10.4477 13 11 13H18C18.5523 13 19 12.5523 19 12C19 11.4477 18.5523 11 18 11Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M18 6H11C10.4477 6 10 6.44772 10 7C10 7.55228 10.4477 8 11 8H18C18.5523 8 19 7.55228 19 7C19 6.44772 18.5523 6 18 6Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.207 10.293C9.39448 10.4805 9.49979 10.7348 9.49979 11C9.49979 11.2652 9.39448 11.5195 9.207 11.707L6.707 14.207C6.51948 14.3945 6.26517 14.4998 6 14.4998C5.73484 14.4998 5.48053 14.3945 5.29301 14.207L4.29301 13.207C4.19749 13.1148 4.12131 13.0044 4.0689 12.8824C4.01649 12.7604 3.98891 12.6292 3.98775 12.4964C3.9866 12.3636 4.0119 12.2319 4.06218 12.109C4.11246 11.9861 4.18672 11.8745 4.28061 11.7806C4.3745 11.6867 4.48615 11.6125 4.60905 11.5622C4.73195 11.5119 4.86363 11.4866 4.99641 11.4877C5.12919 11.4889 5.26041 11.5165 5.38241 11.5689C5.50441 11.6213 5.61476 11.6975 5.707 11.793L6 12.086L7.793 10.293C7.98053 10.1055 8.23484 10.0002 8.5 10.0002C8.76517 10.0002 9.01948 10.1055 9.207 10.293ZM9.207 15.293C9.39448 15.4805 9.49979 15.7348 9.49979 16C9.49979 16.2652 9.39448 16.5195 9.207 16.707L6.707 19.207C6.51948 19.3945 6.26517 19.4998 6 19.4998C5.73484 19.4998 5.48053 19.3945 5.29301 19.207L4.29301 18.207C4.19749 18.1148 4.12131 18.0044 4.0689 17.8824C4.01649 17.7604 3.98891 17.6292 3.98775 17.4964C3.9866 17.3636 4.0119 17.2319 4.06218 17.109C4.11246 16.9862 4.18672 16.8745 4.28061 16.7806C4.3745 16.6867 4.48615 16.6125 4.60905 16.5622C4.73195 16.5119 4.86363 16.4866 4.99641 16.4877C5.12919 16.4889 5.26041 16.5165 5.38241 16.5689C5.50441 16.6213 5.61476 16.6975 5.707 16.793L6 17.086L7.793 15.293C7.98053 15.1055 8.23484 15.0002 8.5 15.0002C8.76517 15.0002 9.01948 15.1055 9.207 15.293ZM9.207 5.293C9.39448 5.48053 9.49979 5.73484 9.49979 6C9.49979 6.26516 9.39448 6.51947 9.207 6.707L6.707 9.207C6.51948 9.39447 6.26517 9.49979 6 9.49979C5.73484 9.49979 5.48053 9.39447 5.29301 9.207L4.29301 8.207C4.11085 8.0184 4.01005 7.7658 4.01233 7.5036C4.01461 7.2414 4.11978 6.99059 4.30519 6.80518C4.49059 6.61977 4.74141 6.5146 5.0036 6.51233C5.2658 6.51005 5.5184 6.61084 5.707 6.793L6 7.086L7.793 5.293C7.98053 5.10553 8.23484 5.00021 8.5 5.00021C8.76517 5.00021 9.01948 5.10553 9.207 5.293Z"
    })));
};

});


parcelRegister("56bKX", function(module, exports) {

$parcel$export(module.exports, "summarizePageConfigItem", () => $3b66a1e0cf235c60$export$8328a332670792a);

var $eUqFw = parcelRequire("eUqFw");

var $6mnRu = parcelRequire("6mnRu");

var $EZ9eX = parcelRequire("EZ9eX");

var $da8jY = parcelRequire("da8jY");

var $vQfEF = parcelRequire("vQfEF");

var $2TCZo = parcelRequire("2TCZo");

var $6F3Ol = parcelRequire("6F3Ol");

var $fNCiF = parcelRequire("fNCiF");

var $8ae7G = parcelRequire("8ae7G");

var $XHGTv = parcelRequire("XHGTv");
const $3b66a1e0cf235c60$var$SELECTION_TYPE = 'empty';
const $3b66a1e0cf235c60$export$8328a332670792a = (0, $EZ9eX.createEditorPluginAIConfigItemMarkdown)({
    title: ({ formatMessage: formatMessage })=>formatMessage((0, $2TCZo.messages).title),
    description: ({ formatMessage: formatMessage })=>formatMessage((0, $2TCZo.messages).description),
    selectionType: $3b66a1e0cf235c60$var$SELECTION_TYPE,
    icon: ({ shownAt: shownAt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6F3Ol.Icon), {
            shownAt: shownAt
        }),
    getInitialContext: ({ editorView: editorView, intl: intl, updateIdMap: updateIdMap })=>{
        const { markdown: markdown, contentStatistics: contentStatistics } = (0, $6mnRu.sliceOrNodeToMarkdown)({
            node: editorView.state.doc,
            intl: intl,
            editorView: editorView,
            convertTo: 'markdown-plus',
            updateIdMap: updateIdMap,
            selectionType: $3b66a1e0cf235c60$var$SELECTION_TYPE
        });
        return {
            document: markdown,
            userLocale: intl.locale,
            intentSchemaId: 'summarize_intent_schema.json',
            contentStatistics: contentStatistics
        };
    },
    triggerPromptRequest ({ initialContext: initialContext, editorSchema: editorSchema, backendModel: backendModel, streamingListener: streamingListener }) {
        if ((0, $XHGTv.getBooleanFF)('platform.editor.ai-assistance-service-summarise-writing')) return (0, $da8jY.summaryConvoAI)({
            userLocale: initialContext.userLocale,
            intentSchemaId: initialContext.intentSchemaId,
            editorSchema: editorSchema,
            fullDocument: initialContext.document,
            backendModel: backendModel
        });
        return (0, $da8jY.summary)({
            userLocale: initialContext.userLocale,
            intentSchemaId: initialContext.intentSchemaId,
            editorSchema: editorSchema,
            contextList: [
                {
                    type: 'ADF_MARKDOWN_V1',
                    entity: initialContext.document,
                    relationship: 'FULL_CONTENT'
                }
            ],
            backendModel: backendModel,
            streamingListener: streamingListener
        });
    },
    isVisible: ({ editorView: editorView })=>(0, $fNCiF.isMinLength)({
            editorView: editorView,
            minLength: 1
        }),
    actions: [
        (0, $vQfEF.createInsertAtCurrentPosition)({
            appearance: 'primary'
        })
    ],
    getBackendModel: ()=>{
        if ((0, $XHGTv.getBooleanFF)('platform.editor.ai-assistance-service-summarise-writing')) return 'assistance-service';
        return (0, $8ae7G.getBackendModelExperiment)();
    }
});

});
parcelRegister("2TCZo", function(module, exports) {

$parcel$export(module.exports, "messages", () => $21bef644955b7921$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $21bef644955b7921$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        id: 'fabric.editor.ai.config.item.empty.summarizePage.title',
        defaultMessage: 'Summarize writing',
        description: 'Title for "Summarize writing" Atlassian Intelligence feature shown in editor typeahead and element browser.'
    },
    description: {
        id: 'fabric.editor.ai.config.item.empty.summarizePage.description',
        defaultMessage: "Creates a summary of the text you're working on, highlighting key points",
        description: 'Describes "Summarize writing" Atlassian Intelligence feature shown in the editor typeahead and element browser.'
    }
});

});

parcelRegister("6F3Ol", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $4d998736ec85958a$export$f04a61298a47a40f);

var $eUqFw = parcelRequire("eUqFw");

var $8DZnH = parcelRequire("8DZnH");
const $4d998736ec85958a$export$f04a61298a47a40f = (props)=>{
    const { shownAt: shownAt } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8DZnH.RainbowBorder), {
        shownAt: shownAt
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "25",
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M18 16.5H6C5.44772 16.5 5 16.9477 5 17.5C5 18.0523 5.44772 18.5 6 18.5H18C18.5523 18.5 19 18.0523 19 17.5C19 16.9477 18.5523 16.5 18 16.5Z",
        fill: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M18 6.5H14C13.4477 6.5 13 6.94772 13 7.5C13 8.05228 13.4477 8.5 14 8.5H18C18.5523 8.5 19 8.05228 19 7.5C19 6.94772 18.5523 6.5 18 6.5Z",
        fill: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M18 11.5H6C5.44772 11.5 5 11.9477 5 12.5C5 13.0523 5.44772 13.5 6 13.5H18C18.5523 13.5 19 13.0523 19 12.5C19 11.9477 18.5523 11.5 18 11.5Z",
        fill: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M5.375 7.661C5.375 8.14424 5.76675 8.536 6.25 8.536C6.73325 8.536 7.125 8.14424 7.125 7.661C7.125 7.17775 6.73325 6.786 6.25 6.786C5.76675 6.786 5.375 7.17775 5.375 7.661Z",
        fill: "var(--ds-icon, #44546F)",
        stroke: "var(--ds-icon, #44546F)",
        strokeWidth: "1.75"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M9.375 7.661C9.375 8.14424 9.76675 8.536 10.25 8.536C10.7332 8.536 11.125 8.14424 11.125 7.661C11.125 7.17775 10.7332 6.786 10.25 6.786C9.76675 6.786 9.375 7.17775 9.375 7.661Z",
        fill: "var(--ds-icon, #44546F)",
        stroke: "var(--ds-icon, #44546F)",
        strokeWidth: "1.75"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M5.07 7.989C4.682 6.493 5.481 5.164 6.77 4.955M9.07 7.989C8.682 6.493 9.481 5.164 10.77 4.955",
        fill: "var(--ds-icon, #44546F)",
        strokeLinecap: "round"
    })));
};

});



parcelRegister("iGVse", function(module, exports) {

$parcel$export(module.exports, "getFloatingToolbarConfig", () => $d9b8b77fa84de5a1$export$add2b8f99d5aac);

var $2zbl1 = parcelRequire("2zbl1");

var $25FYC = parcelRequire("25FYC");

var $je5kZ = parcelRequire("je5kZ");

var $XHGTv = parcelRequire("XHGTv");

var $eUgBc = parcelRequire("eUgBc");

var $8BfgW = parcelRequire("8BfgW");

var $hbs2r = parcelRequire("hbs2r");

var $fvNBs = parcelRequire("fvNBs");
const $d9b8b77fa84de5a1$export$add2b8f99d5aac = ()=>(state, intl)=>{
        if ((0, $XHGTv.getBooleanFF)('platform.editor.ai-real-time-spelling-and-grammar_mtaik')) {
            const { isSpellingAndGrammarEnabled: isSpellingAndGrammarEnabled, allDiffObjects: allDiffObjects } = (0, $8BfgW.getPluginState)(state) || {};
            if (isSpellingAndGrammarEnabled && allDiffObjects && state.selection.from === state.selection.to) {
                const selectedDiff = allDiffObjects === null || allDiffObjects === void 0 ? void 0 : allDiffObjects.find(({ from: from, to: to })=>state.selection.from <= to && state.selection.from >= from);
                if (!selectedDiff) return;
                const nodeType = [
                    state.schema.nodes.paragraph,
                    state.schema.nodes.text,
                    state.schema.nodes.heading,
                    state.schema.nodes.taskItem,
                    state.schema.nodes.decisionItem
                ];
                const { id: id, from: from, to: to, text: text, originalText: originalText } = selectedDiff;
                /**
       * TODO: Currently the decoration can be split by other decorations and marks
       * e.g. editor-plugin-selection-marker decoration widget, or any marks e.g. bold / italics
       */ const getDomRef = (editorView)=>{
                    let element;
                    const domAtPos = editorView.domAtPos.bind(editorView);
                    const parent = (0, $2zbl1.findParentDomRefOfType)(nodeType, domAtPos)(state.selection);
                    if (parent) element = parent.querySelector(`#ai-sg-${id}`) || undefined;
                    return element;
                };
                return {
                    title: 'Spelling & Grammar controls',
                    getDomRef: getDomRef,
                    nodeType: nodeType,
                    zIndex: (0, $25FYC.akEditorFloatingPanelZIndex) + 1,
                    // Place the context menu slightly above the others
                    items: [
                        {
                            id: 'editor.ai.sg-suggestion',
                            type: 'button',
                            showTitle: true,
                            testId: 'ak-editor-ai-suggestion-toolbar-suggestion-button',
                            onClick: (0, $eUgBc.insertSuggestion)(from, to),
                            title: text,
                            focusEditoronEnter: true
                        },
                        (0, $fvNBs.separator)(),
                        {
                            id: 'editor.ai.sg-dismiss',
                            type: 'button',
                            testId: 'ak-editor-ai-suggestion-toolbar-dismiss-button',
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($je5kZ))),
                            onClick: (0, $eUgBc.removeSuggestion)(from, to, originalText),
                            title: intl.formatMessage((0, $hbs2r.messages).dismissSuggestion),
                            focusEditoronEnter: true
                        }
                    ],
                    scrollable: false,
                    align: 'left'
                };
            }
        }
        return;
    };

});
parcelRegister("hbs2r", function(module, exports) {

$parcel$export(module.exports, "messages", () => $c829369a6a140bdb$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $c829369a6a140bdb$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    dismissSuggestion: {
        id: 'fabric.editor.ai.spellingAndGrammar.suggestions.dismiss',
        defaultMessage: 'Dismiss Suggestion',
        description: 'The tooltip message display for the dismiss icon button in the suggestion toolbar'
    }
});

});

parcelRegister("fvNBs", function(module, exports) {

$parcel$export(module.exports, "separator", () => $b4b03a6a228c8055$export$3e523c77c1f23f8c);
const $b4b03a6a228c8055$export$3e523c77c1f23f8c = (hidden)=>{
    return {
        type: 'separator',
        hidden: hidden
    };
};

});


parcelRegister("fmQ5E", function(module, exports) {

$parcel$export(module.exports, "createAIPanelsPlugin", () => $b301511a00444a5a$export$8e50cf166685b6a8);

var $kz9Sf = parcelRequire("kz9Sf");

var $R7bnX = parcelRequire("R7bnX");

var $hIF64 = parcelRequire("hIF64");

var $aFbB0 = parcelRequire("aFbB0");
const $b301511a00444a5a$export$8e50cf166685b6a8 = ()=>{
    return new (0, $R7bnX.SafePlugin)({
        key: (0, $kz9Sf.aiPanelsPluginKey),
        state: {
            init: (_, _state)=>({
                    editedPanelIds: {}
                }),
            apply: (tr, pluginState)=>{
                const meta = tr.getMeta((0, $kz9Sf.aiPanelsPluginKey));
                if (!meta || !meta.localIdsPanelTypes) return pluginState;
                const newEditedState = {
                    ...pluginState.editedPanelIds,
                    ...meta.localIdsPanelTypes
                };
                return {
                    ...pluginState,
                    editedPanelIds: newEditedState
                };
            }
        },
        appendTransaction: (transactions, _oldState, newState)=>{
            let tr = newState.tr;
            let edited = false;
            const aiPluginState = (0, $kz9Sf.aiPanelsPluginKey).getState(newState);
            const localIdsPanelTypes = (0, $hIF64.getNewlyEditedAIPanels)({
                transactions: transactions,
                knownEditedPanelIds: aiPluginState.editedPanelIds
            });
            if (Object.keys(localIdsPanelTypes).length) {
                tr = tr.setMeta((0, $kz9Sf.aiPanelsPluginKey), {
                    localIdsPanelTypes: localIdsPanelTypes
                });
                edited = true;
                for (const [_, panelTypes] of Object.entries(localIdsPanelTypes))tr = (0, $aFbB0.addAnalytics)({
                    editorState: newState,
                    tr: tr,
                    payload: {
                        action: 'edited',
                        actionSubject: 'editorPluginAI',
                        actionSubjectId: 'AIPanels',
                        attributes: {
                            extensionKey: panelTypes.extensionKey,
                            extensionType: panelTypes.extensionType
                        },
                        eventType: 'ui'
                    }
                });
            }
            return edited ? tr : null;
        }
    });
};

});
parcelRegister("kz9Sf", function(module, exports) {

$parcel$export(module.exports, "aiPanelsPluginKey", () => $ef8ebc4ef5790de7$export$2e190432eaef4cac);

var $kpTIW = parcelRequire("kpTIW");
const $ef8ebc4ef5790de7$export$2e190432eaef4cac = new (0, $kpTIW.PluginKey)('aiPanelsPluginKey');

});

parcelRegister("hIF64", function(module, exports) {

$parcel$export(module.exports, "getNewlyEditedAIPanels", () => $ce666cb8d004c184$export$88908bad79e2ba35);

var $lDhir = parcelRequire("lDhir");
const $ce666cb8d004c184$var$isEditableAIPanel = (node)=>{
    var _node$type, _node$attrs;
    return ((_node$type = node.type) === null || _node$type === void 0 ? void 0 : _node$type.name) === 'bodiedExtension' && [
        (0, $lDhir.ExtensionKeys).AISummaryBodiedExtension,
        (0, $lDhir.ExtensionKeys).AIActionItemsBodiedExtension
    ].includes((_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.extensionKey);
};
const $ce666cb8d004c184$var$canHostAIPanel = (node)=>{
    var _node$type2, _node$type3;
    return ((_node$type2 = node.type) === null || _node$type2 === void 0 ? void 0 : _node$type2.name) === 'layoutSection' || ((_node$type3 = node.type) === null || _node$type3 === void 0 ? void 0 : _node$type3.name) === 'layoutColumn';
};
const $ce666cb8d004c184$export$88908bad79e2ba35 = ({ transactions: transactions, knownEditedPanelIds: knownEditedPanelIds })=>{
    const changed = [];
    transactions.forEach((tr)=>{
        var _tr$getMeta;
        if (tr.docChanged && !((_tr$getMeta = tr.getMeta) !== null && _tr$getMeta !== void 0 && _tr$getMeta.call(tr, 'appendedTransaction'))) {
            let olds = [];
            let news = [];
            tr.before.descendants((node)=>{
                if ($ce666cb8d004c184$var$isEditableAIPanel(node)) olds.push(node);
                else if ($ce666cb8d004c184$var$canHostAIPanel(node)) return true;
                return false;
            });
            tr.doc.descendants((node)=>{
                if ($ce666cb8d004c184$var$isEditableAIPanel(node)) news.push(node);
                else if ($ce666cb8d004c184$var$canHostAIPanel(node)) return true;
                return false;
            });
            if (olds.length !== news.length) return;
            olds.forEach((old, i)=>{
                if (!old.content.eq(news[i].content)) changed.push(news[i]);
            });
        }
    });
    if (changed.length) return changed.reduce((accum, node)=>{
        if (!knownEditedPanelIds[node.attrs.localId]) accum[node.attrs.localId] = {
            extensionKey: node.attrs.extensionKey,
            extensionType: 'com.atlassian.ai-blocks'
        };
        return accum;
    }, {});
    else return {};
};

});
parcelRegister("lDhir", function(module, exports) {

$parcel$export(module.exports, "ExtensionKeys", () => $fbfaa83223b2f5ec$export$58e73926f5e33721);
// TODO: When manifest and confluence backend is updated we need to update the extension keys
// Please make sure to do a search for all the extension keys and update them
let $fbfaa83223b2f5ec$export$58e73926f5e33721 = /*#__PURE__*/ function(ExtensionKeys) {
    ExtensionKeys["AISummaryExtension"] = "ai-summary-block:aiSummaryExtension";
    ExtensionKeys["AISummaryBodiedExtension"] = "ai-summary-block:aiSummaryBodiedExtension";
    ExtensionKeys["AIActionItemsExtension"] = "ai-action-items-block:aiActionItemsExtension";
    ExtensionKeys["AIActionItemsBodiedExtension"] = "ai-action-items-block:aiActionItemsBodiedExtension";
    return ExtensionKeys;
}({});

});



parcelRegister("bAoVQ", function(module, exports) {

$parcel$export(module.exports, "isAIPanelsEnabled", () => $86f665758f73a7f6$export$96df8d9a130694de);

var $eUqFw = parcelRequire("eUqFw");

var $aska3 = parcelRequire("aska3");

var $iypWf = parcelRequire("iypWf");

var $XHGTv = parcelRequire("XHGTv");
const $86f665758f73a7f6$export$82f46aa4e6535a45 = (content)=>{
    switch(content){
        case 'INPUT_EXCEEDS_TOKEN_LIMIT':
            return (0, $aska3.default).tokenLimitExceeded;
        case 'INPUT_TOO_SHORT_TO_SUMMARIZE':
            return (0, $aska3.default).inputTooShortError;
        case 'INPUT_TOO_SHORT_TO_PROCESS':
            return (0, $aska3.default).inputTooShortError;
        case 'RATE_LIMIT':
            return (0, $aska3.default).rateLimitEnforced;
        case 'OPENAI_RATE_LIMIT_USER_ABUSE':
            return (0, $aska3.default).rateLimitEnforced;
        case 'NO_AGENT':
            return (0, $aska3.default).internalServerError;
        case 'FEATURE_DISABLED_ON_SITE':
            return (0, $aska3.default).internalServerError;
        case 'FEATURE_DISABLED':
            return (0, $aska3.default).internalServerError;
        case 'INTERNAL_SERVER_ERROR':
            return (0, $aska3.default).internalServerError;
        case 'PLUGIN_ERRORED':
            return (0, $aska3.default).internalServerError;
        case 'HIPAA_CONTENT_DETECTED':
            return (0, $aska3.default).hipaaContentError;
        case 'EXCEEDING_CONTEXT_LENGTH_ERROR':
            return (0, $aska3.default).tokenLimitExceeded;
        default:
            return (0, $aska3.default).apiError;
    }
};
const $86f665758f73a7f6$export$b3199784470a824d = (formatMessage)=>{
    return formatMessage((0, $iypWf.messages).aupViolationMessage, {
        auplink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                href: "https://www.atlassian.com/legal/acceptable-use-policy",
                target: "_blank"
            }, chunks)
    });
};
const $86f665758f73a7f6$export$3c9530b6fa51254f = (formatMessage)=>{
    return formatMessage((0, $aska3.default).internalServerError, {
        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                href: "https://status.atlassian.com/",
                target: "_blank"
            }, chunks)
    });
};
const $86f665758f73a7f6$export$93f9f2a0033ee0e6 = (formatMessage)=>{
    return formatMessage((0, $aska3.default).rateLimitEnforced, {
        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                href: "https://support.atlassian.com/organization-administration/docs/excessive-use-in-atlassian-intelligence/",
                target: "_blank"
            }, chunks)
    });
};

const $86f665758f73a7f6$export$451fa989593f2959 = (intl, api, extensionKey, messages)=>{
    return {
        key: 'regenerate-button',
        label: intl.formatMessage(messages.regenerateButtonLabel),
        display: 'icon-and-label',
        tooltip: intl.formatMessage(messages.regenerateButtonTooltip),
        icon: ()=>Promise.resolve((parcelRequire("8SZxd"))).then((mod)=>mod.default),
        action: async (adf)=>{
            var _adf$attrs;
            if (!((_adf$attrs = adf.attrs) !== null && _adf$attrs !== void 0 && _adf$attrs.localId) || !api || !api.aiExperience) return;
            api.aiExperience.actions.regenerateExtension(adf.attrs.localId, extensionKey);
        },
        disabled: !api || !api.aiExperience
    };
};
const $86f665758f73a7f6$export$96df8d9a130694de = ()=>{
    let aiPanelsEnabled = false;
    if ((0, $XHGTv.getBooleanFF)('platform.editor.ai.enable-ai-summary-blocks_r040m')) aiPanelsEnabled = true;
    if ((0, $XHGTv.getBooleanFF)('platform.editor.ai.enable-ai-action-items-block_vctyf')) aiPanelsEnabled = true;
    return aiPanelsEnabled;
};

const $86f665758f73a7f6$export$b6dcd2a392556c07 = (intl, api, messages)=>{
    return {
        key: 'feedback-button',
        label: intl.formatMessage(messages.feedbackButtonLabelTooltip),
        display: 'icon',
        tooltip: intl.formatMessage(messages.feedbackButtonLabelTooltip),
        icon: ()=>(parcelRequire("jz5sn")).then((mod)=>mod.default),
        action: async (adf)=>{
            var _adf$attrs2, _adf$attrs3, _adf$attrs4, _adf$attrs4$parameter, _api$analytics, _api$analytics$action;
            if (!((_adf$attrs2 = adf.attrs) !== null && _adf$attrs2 !== void 0 && _adf$attrs2.localId) || !api || !api.aiExperience) return;
            api.aiExperience.actions.triggerAIPanelFeedbackCollector(adf === null || adf === void 0 ? void 0 : (_adf$attrs3 = adf.attrs) === null || _adf$attrs3 === void 0 ? void 0 : _adf$attrs3.extensionKey, adf === null || adf === void 0 ? void 0 : (_adf$attrs4 = adf.attrs) === null || _adf$attrs4 === void 0 ? void 0 : (_adf$attrs4$parameter = _adf$attrs4.parameters) === null || _adf$attrs4$parameter === void 0 ? void 0 : _adf$attrs4$parameter.content, intl.locale, api === null || api === void 0 ? void 0 : (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : (_api$analytics$action = _api$analytics.actions) === null || _api$analytics$action === void 0 ? void 0 : _api$analytics$action.fireAnalyticsEvent);
        },
        disabled: !api || !api.aiExperience
    };
};

});
parcelRegister("jz5sn", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('1uF4U');
        const value = parcelRequire('eFKPp');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("1uF4U").then(()=>parcelRequire('eFKPp'));
}

});



parcelRegister("4wVbQ", function(module, exports) {

$parcel$export(module.exports, "generateContentConfigItem", () => $34c683548ebec2d2$export$149bbbc5e9d18a46);

var $eUqFw = parcelRequire("eUqFw");

var $6eWD6 = parcelRequire("6eWD6");

var $XHGTv = parcelRequire("XHGTv");

var $EZ9eX = parcelRequire("EZ9eX");

var $6mnRu = parcelRequire("6mnRu");

var $iRpdu = parcelRequire("iRpdu");

var $vQfEF = parcelRequire("vQfEF");

var $9EpOz = parcelRequire("9EpOz");

var $6T3yX = parcelRequire("6T3yX");

var $8ae7G = parcelRequire("8ae7G");
const $34c683548ebec2d2$var$SELECTION_TYPE = 'empty';
const $34c683548ebec2d2$export$149bbbc5e9d18a46 = (0, $EZ9eX.createEditorPluginAIConfigItemMarkdown)({
    title: ({ formatMessage: formatMessage })=>formatMessage((0, $6eWD6.default).aiButtonTitle),
    description: ({ formatMessage: formatMessage })=>formatMessage((0, $6eWD6.default).aiUniversalLongCallToAction),
    promptHint: ({ formatMessage: formatMessage })=>formatMessage((0, $9EpOz.messages).promptHint),
    selectionType: $34c683548ebec2d2$var$SELECTION_TYPE,
    getInitialContext: ({ editorView: editorView, intl: intl, updateIdMap: updateIdMap })=>{
        const { markdown: markdown, contentStatistics: contentStatistics } = (0, $6mnRu.sliceOrNodeToMarkdown)({
            node: editorView.state.doc,
            intl: intl,
            editorView: editorView,
            convertTo: 'markdown-plus',
            updateIdMap: updateIdMap,
            selectionType: $34c683548ebec2d2$var$SELECTION_TYPE
        });
        return {
            document: markdown,
            userLocale: intl.locale,
            intentSchemaId: 'custom_free_generate_intent_schema.json',
            contentStatistics: contentStatistics
        };
    },
    icon: ({ formatMessage: formatMessage })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6T3yX.default), {
            alt: formatMessage((0, $6eWD6.default).aiButtonTitle)
        }),
    // No prompt label is required -- as this is intended to be set via the
    // the baseGenerate
    triggerPromptRequest ({ initialContext: initialContext, promptInput: promptInput, latestPromptResponse: latestPromptResponse, editorSchema: editorSchema, backendModel: backendModel }) {
        // This config item is overloaded to support both the interrogation prompt and the free generate prompt
        // we distinguish which one we're in by checking if we have a latestPromptResponse
        let contextList;
        if (latestPromptResponse) // If we have a latestPromptResponse, we don't want to add the document to the contextList
        // as it's an interrogation prompt
        contextList = [
            {
                type: 'ADF_MARKDOWN_V1',
                entity: latestPromptResponse,
                relationship: 'PREVIOUS_RESPONSE'
            }
        ];
        else // We only add the full content based on a feature flag
        if ((0, $XHGTv.getBooleanFF)('platform.editor.ai-send-full-content_r1qpp')) contextList = !initialContext.document ? [] : [
            {
                type: 'ADF_MARKDOWN_V1',
                entity: initialContext.document,
                relationship: 'FULL_CONTENT'
            }
        ];
        else // When the feature flag is off, we send this as an empty string as the backend expects this
        // to be present
        // see https://atlassian.slack.com/archives/C055QF79V7W/p1692262267702639 for context
        contextList = [
            {
                type: 'text',
                entity: '',
                relationship: undefined
            }
        ];
        // Use Convo AI api for free generate if flag is on and it's not interrogate
        // Have kept this separate to interrogate in case they need to be toggled separately
        // for whatever reason (eg. generate works well but interrogate does not)
        if ((0, $XHGTv.getBooleanFF)('platform.editor.ai-assistance-service-free-generate') && !latestPromptResponse) return (0, $iRpdu.generateConvoAI)({
            customPrompt: promptInput,
            userLocale: initialContext.userLocale,
            intentSchemaId: 'custom_free_generate_intent_schema.json',
            editorSchema: editorSchema,
            fullDocument: initialContext.document,
            backendModel: backendModel
        });
        // Use Convo AI api for interrogate if flag is on
        if ((0, $XHGTv.getBooleanFF)('platform.editor.ai-interrogate-with-convo-ai') && latestPromptResponse) return (0, $iRpdu.generateConvoAI)({
            customPrompt: promptInput,
            userLocale: initialContext.userLocale,
            intentSchemaId: 'custom_with_interrogation_intent_schema.json',
            editorSchema: editorSchema,
            latestPromptResponse: latestPromptResponse,
            fullDocument: initialContext.document,
            backendModel: backendModel
        });
        // Else use xp-gen-ai api
        return (0, $iRpdu.generate)({
            customPrompt: promptInput,
            userLocale: initialContext.userLocale,
            intentSchemaId: latestPromptResponse ? 'custom_with_interrogation_intent_schema.json' : 'custom_free_generate_intent_schema.json',
            editorSchema: editorSchema,
            contextList: contextList,
            backendModel: backendModel
        });
    },
    isVisible: ()=>true,
    actions: [
        (0, $vQfEF.createInsertAtCurrentPosition)({
            appearance: 'primary'
        })
    ],
    quickInsertPriority: Number.NEGATIVE_INFINITY,
    getBackendModel: (isInterrogate)=>{
        if (isInterrogate && (0, $XHGTv.getBooleanFF)('platform.editor.ai-interrogate-with-convo-ai')) return 'assistance-service';
        if (!isInterrogate && (0, $XHGTv.getBooleanFF)('platform.editor.ai-assistance-service-free-generate')) return 'assistance-service';
        // If we're not interrogating, we use xp-gen-ai
        if (!isInterrogate) return 'xp-gen-ai';
        return (0, $8ae7G.getBackendModelExperiment)();
    }
});

});
parcelRegister("9EpOz", function(module, exports) {

$parcel$export(module.exports, "messages", () => $706bdfbad86748c8$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $706bdfbad86748c8$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    promptHint: {
        id: 'fabric.editor.ai.config.item.empty.generateContent.promptHint',
        defaultMessage: 'Write with AI or select from below',
        description: 'Placeholder text in the prompt input guiding user interaction.'
    }
});

});

parcelRegister("6T3yX", function(module, exports) {

$parcel$export(module.exports, "default", () => $503aa49e210a6c31$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $eaNHE = parcelRequire("eaNHE");

var $hkwTa = parcelRequire("hkwTa");
const $503aa49e210a6c31$var$Icon = ({ alt: alt })=>{
    return (0, $byn9U.jsx)("svg", {
        width: "38",
        height: "38",
        viewBox: "0 0 38 38",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        css: (0, $hkwTa.styleIconBackground)
    }, (0, $byn9U.jsx)("title", null, alt), ";", (0, $byn9U.jsx)("rect", {
        x: "0.5",
        y: "0.5",
        width: "37",
        height: "37",
        rx: "1.5",
        stroke: "url(#paint0_radial_2130_45344)"
    }), (0, $byn9U.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24.17 19C24.17 18.4477 24.6178 18 25.17 18H27C27.5523 18 28 18.4477 28 19C28 19.5523 27.5523 20 27 20H25.17C24.6178 20 24.17 19.5523 24.17 19Z",
        fill: "var(--ds-icon, #44546F)"
    }), (0, $byn9U.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19 10C19.5523 10 20 10.4477 20 11V12.83C20 13.3823 19.5523 13.83 19 13.83C18.4477 13.83 18 13.3823 18 12.83V11C18 10.4477 18.4477 10 19 10Z",
        fill: "var(--ds-icon, #44546F)"
    }), (0, $byn9U.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 19C10 18.4477 10.4477 18 11 18H12.83C13.3823 18 13.83 18.4477 13.83 19C13.83 19.5523 13.3823 20 12.83 20H11C10.4477 20 10 19.5523 10 19Z",
        fill: "var(--ds-icon, #44546F)"
    }), (0, $byn9U.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19 24.17C19.5523 24.17 20 24.6177 20 25.17V27C20 27.5523 19.5523 28 19 28C18.4477 28 18 27.5523 18 27V25.17C18 24.6177 18.4477 24.17 19 24.17Z",
        fill: "var(--ds-icon, #44546F)"
    }), (0, $byn9U.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.2929 21.2929C21.6834 20.9024 22.3166 20.9024 22.7071 21.2929L26.7071 25.2929C27.0976 25.6834 27.0976 26.3166 26.7071 26.7071C26.3166 27.0976 25.6834 27.0976 25.2929 26.7071L21.2929 22.7071C20.9024 22.3166 20.9024 21.6834 21.2929 21.2929Z",
        fill: "var(--ds-icon, #44546F)"
    }), (0, $byn9U.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M26.7071 11.2929C27.0976 11.6834 27.0976 12.3166 26.7071 12.7071L22.7071 16.7071C22.3166 17.0976 21.6834 17.0976 21.2929 16.7071C20.9024 16.3166 20.9024 15.6834 21.2929 15.2929L25.2929 11.2929C25.6834 10.9024 26.3166 10.9024 26.7071 11.2929Z",
        fill: "var(--ds-icon, #44546F)"
    }), (0, $byn9U.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.2929 11.2929C11.6834 10.9024 12.3166 10.9024 12.7071 11.2929L16.7071 15.2929C17.0976 15.6834 17.0976 16.3166 16.7071 16.7071C16.3166 17.0976 15.6834 17.0976 15.2929 16.7071L11.2929 12.7071C10.9024 12.3166 10.9024 11.6834 11.2929 11.2929Z",
        fill: "var(--ds-icon, #44546F)"
    }), (0, $byn9U.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.7071 21.2929C17.0976 21.6834 17.0976 22.3166 16.7071 22.7071L12.7071 26.7071C12.3166 27.0976 11.6834 27.0976 11.2929 26.7071C10.9024 26.3166 10.9024 25.6834 11.2929 25.2929L15.2929 21.2929C15.6834 20.9024 16.3166 20.9024 16.7071 21.2929Z",
        fill: "var(--ds-icon, #44546F)"
    }), (0, $byn9U.jsx)("defs", null, (0, $byn9U.jsx)("radialGradient", {
        id: "paint0_radial_2130_45344",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(1 1.5) rotate(44.5937) scale(49.8523)"
    }, (0, $byn9U.jsx)((0, $eaNHE.Border), null))));
};
var $503aa49e210a6c31$export$2e2bcd8739ae039 = $503aa49e210a6c31$var$Icon;

});


parcelRegister("47oBW", function(module, exports) {

$parcel$export(module.exports, "shortenConfigItem", () => $2ffae8162a512b6f$export$8f482ff8373a6623);

var $eUqFw = parcelRequire("eUqFw");

var $6mnRu = parcelRequire("6mnRu");

var $EZ9eX = parcelRequire("EZ9eX");

var $7ZRIZ = parcelRequire("7ZRIZ");

var $vQfEF = parcelRequire("vQfEF");

var $6Ig0V = parcelRequire("6Ig0V");

var $fNCiF = parcelRequire("fNCiF");

var $gfOPY = parcelRequire("gfOPY");

var $8ae7G = parcelRequire("8ae7G");

var $idZBA = parcelRequire("idZBA");

var $XHGTv = parcelRequire("XHGTv");
const $2ffae8162a512b6f$var$SELECTION_TYPE = 'range';
const $2ffae8162a512b6f$export$8f482ff8373a6623 = (0, $EZ9eX.createEditorPluginAIConfigItemMarkdown)({
    title: ({ formatMessage: formatMessage })=>formatMessage((0, $6Ig0V.messages).title),
    description: ({ formatMessage: formatMessage })=>formatMessage((0, $6Ig0V.messages).description),
    selectionType: $2ffae8162a512b6f$var$SELECTION_TYPE,
    getInitialContext: ({ editorView: editorView, positions: positions, intl: intl, updateIdMap: updateIdMap })=>{
        const selection = (0, $6mnRu.sliceOrNodeToMarkdown)({
            slice: (0, $gfOPY.getSlice)(editorView, positions),
            intl: intl,
            editorView: editorView,
            convertTo: 'markdown-plus',
            updateIdMap: updateIdMap,
            selectionType: $2ffae8162a512b6f$var$SELECTION_TYPE
        });
        return {
            selection: selection.markdown,
            userLocale: intl.locale,
            intentSchemaId: 'shorten_intent_schema.json',
            contentStatistics: selection.contentStatistics
        };
    },
    triggerPromptRequest ({ initialContext: initialContext, editorSchema: editorSchema, backendModel: backendModel }) {
        if ((0, $XHGTv.getBooleanFF)('platform.editor.ai-assistance-service-make-shorter')) return (0, $7ZRIZ.transformConvoAI)({
            transformationType: 'shorten',
            userLocale: initialContext.userLocale,
            intentSchemaId: initialContext.intentSchemaId,
            editorSchema: editorSchema,
            fullDocument: initialContext.document,
            currentSelection: initialContext.selection,
            backendModel: backendModel
        });
        return (0, $7ZRIZ.transform)({
            transformationType: 'shorten',
            userLocale: initialContext.userLocale,
            intentSchemaId: initialContext.intentSchemaId,
            editorSchema: editorSchema,
            contextList: [
                {
                    type: 'ADF_MARKDOWN_V1',
                    entity: initialContext.selection,
                    relationship: 'SELECTION'
                }
            ],
            backendModel: backendModel
        });
    },
    isVisible: ({ editorView: editorView, positions: positions })=>(0, $fNCiF.isMinLength)({
            editorView: editorView,
            minLength: 1,
            positions: positions
        }),
    icon: ({ shownAt: shownAt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $idZBA.Icon), {
            shownAt: shownAt
        }),
    actions: [
        (0, $vQfEF.createInsertBelow)({
            appearance: 'secondary'
        }),
        (0, $vQfEF.createReplace)({
            appearance: 'primary'
        })
    ],
    getBackendModel: ()=>{
        if ((0, $XHGTv.getBooleanFF)('platform.editor.ai-assistance-service-make-shorter')) return 'assistance-service';
        return (0, $8ae7G.getBackendModelExperiment)();
    }
});

});
parcelRegister("7ZRIZ", function(module, exports) {

$parcel$export(module.exports, "transform", () => $5d27e78588205548$export$51186ad6e864892a);
$parcel$export(module.exports, "transformConvoAI", () => $5d27e78588205548$export$29b7d20f34ab3a6e);
$parcel$export(module.exports, "unstable_transformConvoAI_IssueReformat", () => $5d27e78588205548$export$c8bae436a21c9f8f);

var $9LezI = parcelRequire("9LezI");

var $g6Vmo = parcelRequire("g6Vmo");

var $4Dk05 = parcelRequire("4Dk05");

var $kgZDI = parcelRequire("kgZDI");

var $8ae7G = parcelRequire("8ae7G");
const $5d27e78588205548$export$51186ad6e864892a = (input)=>{
    return function promptRequest(requestOptions) {
        const streamingResponseGenerator = (0, $9LezI.startStreamingResponse)({
            endpoint: requestOptions.generativeAIApiUrl,
            payload: JSON.stringify({
                intentSchemaId: input.intentSchemaId,
                contextList: (0, $kgZDI.runContextListAgainstFFs)(input.contextList),
                modelPlatform: 'OPENAI',
                outputLocale: input.userLocale,
                streaming: true,
                outputFormat: {
                    outputFormatType: 'MARKDOWN',
                    markdowns: (0, $4Dk05.getSupportedMarkdowns)(input.editorSchema)
                },
                product: requestOptions.product,
                ...input.backendModel === 'einstein' && {
                    backendExperiment: 'EINSTEIN'
                },
                targetTranslationLanguage: input.intentSchemaId === 'translate_intent_schema.json' ? input.targetTranslationLanguage : undefined
            }),
            ...requestOptions
        });
        return (0, $g6Vmo.streamResponsePreview)({
            streamingResponseGenerator: streamingResponseGenerator
        });
    };
};
const $5d27e78588205548$export$29b7d20f34ab3a6e = (input)=>{
    return function promptRequest(requestOptions) {
        // If the current selection is the same as the full document we don't
        // need to send it to the backend as it will get it from the full document
        let draft_selected_content = input.currentSelection;
        if (input.fullDocument === input.currentSelection) draft_selected_content = undefined;
        const streamingResponseGenerator = (0, $9LezI.startStreamingResponse)({
            endpoint: (0, $8ae7G.convoAIStatelessApiURL),
            payload: JSON.stringify({
                recipient_agent_named_id: 'editor_intent_agent',
                agent_input_context: {
                    transformation_type: input.transformationType,
                    transformation_subtype: 'transformationSubType' in input ? input.transformationSubType : undefined,
                    writing_intent: input.intentSchemaId,
                    draft_full_content: input.fullDocument,
                    draft_selected_content: draft_selected_content,
                    supported_markdown_nodes: (0, $4Dk05.getSupportedMarkdowns)(input.editorSchema),
                    input_mime_type: 'text/markdown',
                    output_mime_type: 'text/markdown',
                    locale: input.userLocale,
                    product: requestOptions.product
                }
            }),
            ...requestOptions
        });
        return (0, $g6Vmo.streamResponsePreview)({
            streamingResponseGenerator: streamingResponseGenerator,
            isConvoAI: true
        });
    };
};
const $5d27e78588205548$export$c8bae436a21c9f8f = (input)=>{
    return function promptRequest(requestOptions) {
        let issue_description = input.fullDocument;
        const streamingResponseGenerator = (0, $9LezI.startStreamingResponse)({
            endpoint: (0, $8ae7G.convoAIStatelessApiURL),
            experienceId: 'issue-reformatter',
            agentNameId: input.agentNamedId,
            payload: JSON.stringify({
                recipient_agent_named_id: input.agentNamedId,
                agent_input_context: {
                    locale: input.userLocale,
                    issue_description: issue_description,
                    ...input === null || input === void 0 ? void 0 : input.additionalPayload
                }
            }),
            ...requestOptions
        });
        return (0, $g6Vmo.streamResponsePreview)({
            streamingResponseGenerator: streamingResponseGenerator,
            isConvoAI: true
        });
    };
};

});

parcelRegister("6Ig0V", function(module, exports) {

$parcel$export(module.exports, "messages", () => $4e334631d9032778$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $4e334631d9032778$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        id: 'fabric.editor.ai.config.item.range.shorten.title',
        defaultMessage: 'Make shorter',
        description: 'Describes an option to use Atlassian Intellgience to shorten the content currently selected by the user'
    },
    description: {
        id: 'fabric.editor.ai.config.item.range.shorten.description',
        defaultMessage: 'Shortens the content to make it more concise',
        description: 'Description for the the Atlassian Intelligence "Shorten".'
    },
    selectionToolbarDropdownItemTitle: {
        id: 'fabric.editor.ai.config.item.range.shorten.selectionToolbar.dropdownItem.title',
        defaultMessage: 'Make shorter',
        description: 'Title for Atlassian Intelligence "Shorten" in editor selection floating toolbar'
    }
});

});

parcelRegister("idZBA", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $d4493a699bfd6555$export$f04a61298a47a40f);

var $eUqFw = parcelRequire("eUqFw");

var $8DZnH = parcelRequire("8DZnH");
const $d4493a699bfd6555$export$f04a61298a47a40f = (props)=>{
    const { shownAt: shownAt } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8DZnH.RainbowBorder), {
        shownAt: shownAt
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "var(--ds-icon, #44546F)",
        xmlns: "http://www.w3.org/2000/svg",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M11 13H7C6.44772 13 6 13.4477 6 14C6 14.5523 6.44772 15 7 15H11C11.5523 15 12 14.5523 12 14C12 13.4477 11.5523 13 11 13Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M17 9H7C6.44772 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11H17C17.5523 11 18 10.5523 18 10C18 9.44772 17.5523 9 17 9Z"
    })));
};

});


parcelRegister("atNpT", function(module, exports) {

$parcel$export(module.exports, "summarizeConfigItem", () => $7a12f1f0b441732b$export$2c3d09ca61ac103b);

var $eUqFw = parcelRequire("eUqFw");

var $6mnRu = parcelRequire("6mnRu");

var $EZ9eX = parcelRequire("EZ9eX");

var $da8jY = parcelRequire("da8jY");

var $8ae7G = parcelRequire("8ae7G");

var $vQfEF = parcelRequire("vQfEF");

var $xc52N = parcelRequire("xc52N");

var $fNCiF = parcelRequire("fNCiF");

var $gfOPY = parcelRequire("gfOPY");

var $6F3Ol = parcelRequire("6F3Ol");

var $XHGTv = parcelRequire("XHGTv");
const $7a12f1f0b441732b$var$SELECTION_TYPE = 'range';
const $7a12f1f0b441732b$export$2c3d09ca61ac103b = (0, $EZ9eX.createEditorPluginAIConfigItemMarkdown)({
    title: ({ formatMessage: formatMessage })=>formatMessage((0, $xc52N.messages).title),
    description: ({ formatMessage: formatMessage })=>formatMessage((0, $xc52N.messages).description),
    selectionType: $7a12f1f0b441732b$var$SELECTION_TYPE,
    getInitialContext: ({ editorView: editorView, positions: positions, intl: intl, updateIdMap: updateIdMap })=>{
        const selection = (0, $6mnRu.sliceOrNodeToMarkdown)({
            slice: (0, $gfOPY.getSlice)(editorView, positions),
            intl: intl,
            editorView: editorView,
            convertTo: 'markdown-plus',
            updateIdMap: updateIdMap,
            selectionType: $7a12f1f0b441732b$var$SELECTION_TYPE
        });
        const document = (0, $6mnRu.sliceOrNodeToMarkdown)({
            node: editorView.state.doc,
            intl: intl,
            editorView: editorView,
            convertTo: 'markdown-plus',
            updateIdMap: updateIdMap,
            selectionType: $7a12f1f0b441732b$var$SELECTION_TYPE
        });
        return {
            selection: selection.markdown,
            document: document.markdown,
            userLocale: intl.locale,
            intentSchemaId: 'summarize_intent_schema.json',
            contentStatistics: selection.contentStatistics,
            getBackendModel: (0, $8ae7G.getBackendModelExperiment)
        };
    },
    triggerPromptRequest ({ initialContext: initialContext, editorSchema: editorSchema, backendModel: backendModel }) {
        if ((0, $XHGTv.getBooleanFF)('platform.editor.ai-assistance-service-summarise-writing')) return (0, $da8jY.summaryConvoAI)({
            userLocale: initialContext.userLocale,
            intentSchemaId: initialContext.intentSchemaId,
            editorSchema: editorSchema,
            currentSelection: initialContext.selection,
            fullDocument: initialContext.document,
            backendModel: backendModel
        });
        return (0, $da8jY.summary)({
            userLocale: initialContext.userLocale,
            intentSchemaId: initialContext.intentSchemaId,
            editorSchema: editorSchema,
            contextList: [
                {
                    type: 'ADF_MARKDOWN_V1',
                    entity: initialContext.selection,
                    relationship: 'SELECTION'
                }
            ],
            backendModel: backendModel
        });
    },
    isVisible: ({ editorView: editorView, positions: positions })=>(0, $fNCiF.isMinLength)({
            editorView: editorView,
            minLength: 1,
            positions: positions
        }),
    icon: ({ shownAt: shownAt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6F3Ol.Icon), {
            shownAt: shownAt
        }),
    actions: [
        (0, $vQfEF.createInsertBelow)({
            appearance: 'secondary'
        }),
        (0, $vQfEF.createReplace)({
            appearance: 'primary'
        })
    ],
    getBackendModel: ()=>{
        if ((0, $XHGTv.getBooleanFF)('platform.editor.ai-assistance-service-summarise-writing')) return 'assistance-service';
        return (0, $8ae7G.getBackendModelExperiment)();
    }
});

});
parcelRegister("xc52N", function(module, exports) {

$parcel$export(module.exports, "messages", () => $063c7416d19a482d$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $063c7416d19a482d$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        id: 'fabric.editor.ai.config.item.range.summarize.title',
        defaultMessage: 'Summarize writing',
        description: 'Describes an option to use Atlassian Intellgience to summarize the content currently selected by the user'
    },
    description: {
        id: 'fabric.editor.ai.config.item.range.summarize.description',
        defaultMessage: "Creates a summary of the text you're working on, highlighting key points",
        description: 'Describes "Summarize writing" Atlassian Intelligence feature to summarize the content currently selected by the user'
    },
    selectionToolbarDropdownItemTitle: {
        id: 'fabric.editor.ai.config.item.range.summarize.dropdownItem.title',
        defaultMessage: 'Summarize writing',
        description: 'Title for Atlassian Intelligence "Summarize writing" in editor selection floating toolbar'
    }
});

});


parcelRegister("3w1uM", function(module, exports) {

$parcel$export(module.exports, "improveWriting", () => $28f5853395f07a22$export$144a75c8acc1ab6b);
$parcel$export(module.exports, "fixSpellingAndGrammar", () => $28f5853395f07a22$export$f6fbbd65001c33d0);

var $eUqFw = parcelRequire("eUqFw");

var $6mnRu = parcelRequire("6mnRu");

var $EZ9eX = parcelRequire("EZ9eX");

var $7ZRIZ = parcelRequire("7ZRIZ");

var $vQfEF = parcelRequire("vQfEF");

var $6PFHm = parcelRequire("6PFHm");

var $fNCiF = parcelRequire("fNCiF");

var $gfOPY = parcelRequire("gfOPY");

var $8ae7G = parcelRequire("8ae7G");

var $fibx3 = parcelRequire("fibx3");

var $lXs67 = parcelRequire("lXs67");

var $XHGTv = parcelRequire("XHGTv");
const $28f5853395f07a22$var$SELECTION_TYPE = 'range';
function $28f5853395f07a22$var$createEnhanceOption({ title: title, description: description, transformationType: transformationType, actions: actions, intentSchemaId: intentSchemaId, icon: icon, getBackendModel: getBackendModel }) {
    return (0, $EZ9eX.createEditorPluginAIConfigItemMarkdown)({
        title: title,
        description: description,
        selectionType: $28f5853395f07a22$var$SELECTION_TYPE,
        getInitialContext: ({ editorView: editorView, positions: positions, intl: intl, updateIdMap: updateIdMap })=>{
            const selection = (0, $6mnRu.sliceOrNodeToMarkdown)({
                slice: (0, $gfOPY.getSlice)(editorView, positions),
                intl: intl,
                editorView: editorView,
                convertTo: 'markdown-plus',
                updateIdMap: updateIdMap,
                selectionType: $28f5853395f07a22$var$SELECTION_TYPE
            });
            const document = (0, $6mnRu.sliceOrNodeToMarkdown)({
                node: editorView.state.doc,
                intl: intl,
                editorView: editorView,
                convertTo: 'markdown-plus',
                updateIdMap: updateIdMap,
                selectionType: $28f5853395f07a22$var$SELECTION_TYPE
            });
            return {
                selection: selection.markdown,
                document: document.markdown,
                userLocale: intl.locale,
                intentSchemaId: intentSchemaId,
                contentStatistics: selection.contentStatistics
            };
        },
        triggerPromptRequest ({ initialContext: initialContext, editorSchema: editorSchema, backendModel: backendModel }) {
            if (transformationType === 'improve_quality' && (0, $XHGTv.getBooleanFF)('platform.editor.ai-assistance-service-improve-writing')) return (0, $7ZRIZ.transformConvoAI)({
                transformationType: transformationType,
                userLocale: initialContext.userLocale,
                intentSchemaId: initialContext.intentSchemaId,
                editorSchema: editorSchema,
                fullDocument: initialContext.document,
                currentSelection: initialContext.selection,
                backendModel: backendModel
            });
            if (transformationType === 'grammar_spelling' && (0, $XHGTv.getBooleanFF)('platform.editor.ai-assistance-service-fix-spelling-grammar')) return (0, $7ZRIZ.transformConvoAI)({
                transformationType: transformationType,
                userLocale: initialContext.userLocale,
                intentSchemaId: initialContext.intentSchemaId,
                editorSchema: editorSchema,
                fullDocument: initialContext.document,
                currentSelection: initialContext.selection,
                backendModel: backendModel
            });
            return (0, $7ZRIZ.transform)({
                transformationType: transformationType,
                userLocale: initialContext.userLocale,
                intentSchemaId: initialContext.intentSchemaId,
                editorSchema: editorSchema,
                contextList: [
                    {
                        type: 'ADF_MARKDOWN_V1',
                        entity: initialContext.selection,
                        relationship: 'SELECTION'
                    }
                ],
                backendModel: backendModel
            });
        },
        isVisible: ({ editorView: editorView, positions: positions })=>(0, $fNCiF.isMinLength)({
                editorView: editorView,
                minLength: 1,
                positions: positions
            }),
        icon: icon,
        actions: actions,
        getBackendModel: getBackendModel
    });
}
const $28f5853395f07a22$export$144a75c8acc1ab6b = $28f5853395f07a22$var$createEnhanceOption({
    title: ({ formatMessage: formatMessage })=>formatMessage((0, $6PFHm.messages).improveWritingTitle),
    description: ({ formatMessage: formatMessage })=>formatMessage((0, $6PFHm.messages).improveWritingDescription),
    transformationType: 'improve_quality',
    actions: [
        (0, $vQfEF.createInsertBelow)({
            appearance: 'secondary'
        }),
        (0, $vQfEF.createReplace)({
            appearance: 'primary'
        })
    ],
    intentSchemaId: 'improve_quality_intent_schema.json',
    icon: ({ shownAt: shownAt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lXs67.Icon), {
            shownAt: shownAt
        }),
    getBackendModel: ()=>{
        if ((0, $XHGTv.getBooleanFF)('platform.editor.ai-assistance-service-improve-writing')) return 'assistance-service';
        return (0, $8ae7G.getBackendModelExperiment)();
    }
});
const $28f5853395f07a22$export$f6fbbd65001c33d0 = $28f5853395f07a22$var$createEnhanceOption({
    title: ({ formatMessage: formatMessage })=>formatMessage((0, $6PFHm.messages).fixSpellingGrammarTitle),
    description: ({ formatMessage: formatMessage })=>formatMessage((0, $6PFHm.messages).fixSpellingGrammarDescription),
    transformationType: 'grammar_spelling',
    actions: [
        (0, $vQfEF.createReplace)({
            appearance: 'primary'
        })
    ],
    intentSchemaId: 'grammar_spelling_intent_schema.json',
    icon: ({ shownAt: shownAt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fibx3.Icon), {
            shownAt: shownAt
        }),
    getBackendModel: ()=>{
        if ((0, $XHGTv.getBooleanFF)('platform.editor.ai-assistance-service-fix-spelling-grammar')) return 'assistance-service';
        return (0, $8ae7G.getBackendModelExperiment)();
    }
});

});
parcelRegister("6PFHm", function(module, exports) {

$parcel$export(module.exports, "messages", () => $4f97d9e948abca92$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $4f97d9e948abca92$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    improveWritingTitle: {
        id: 'fabric.editor.ai.config.item.range.enhance.improveWriting.title',
        defaultMessage: 'Improve writing',
        description: 'Describes an option to use Atlassian Intellgience to improve the writing of content currently selected by the user'
    },
    improveWritingSelectionToolbarDropdownItemTitle: {
        id: 'fabric.editor.ai.config.item.range.enhance.improveWriting.selectionToolbar.dropdownItem.title',
        defaultMessage: 'Improve writing',
        description: 'Title for Atlassian Intelligence "improve writing" in editor selection floating toolbar'
    },
    fixSpellingGrammarTitle: {
        id: 'fabric.editor.ai.config.item.range.enhance.fixSpellingGrammar.title',
        defaultMessage: 'Fix spelling & grammar',
        description: 'Describes an option to use Atlassian Intellgience to improve the writing of content currently selected by the user'
    },
    improveWritingDescription: {
        id: 'fabric.editor.ai.config.item.range.enhance.improveWriting.description',
        defaultMessage: 'Enhances clarity, structure, and tone for better engagement and comprehension',
        description: 'Description for the the Atlassian Intelligence "Improve Writing".'
    },
    improveWritingSelectionToolbarButtonTooltip: {
        id: 'fabric.editor.ai.config.item.range.enhance.improveWriting.selectionToolbar.tooltip',
        defaultMessage: 'Tell Atlassian Intelligence to improve the writing of your selection',
        description: 'Tooltip text for an option to use Atlassian Intellgience to improve the writing of content currently selected by the user'
    },
    fixSpellingGrammarDescription: {
        id: 'fabric.editor.ai.config.item.range.enhance.fixSpellingGrammar.description',
        defaultMessage: 'Fixes spelling and grammar mistakes',
        description: 'Description for the the Atlassian Intelligence "Fix Spelling & Grammar".'
    },
    fixSpellingGrammarSelectionToolbarDropdownItemTitle: {
        id: 'fabric.editor.ai.config.item.range.enhance.fixSpellingGrammar.selectionToolbar.dropdownItem.title',
        defaultMessage: 'Spelling & grammar',
        description: 'Title for Atlassian Intelligence "fix spelling grammar" in editor selection floating toolbar'
    }
});

});

parcelRegister("fibx3", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $b2217b78f23ddec3$export$f04a61298a47a40f);

var $eUqFw = parcelRequire("eUqFw");

var $8DZnH = parcelRequire("8DZnH");
const $b2217b78f23ddec3$export$f04a61298a47a40f = (props)=>{
    const { shownAt: shownAt } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8DZnH.RainbowBorder), {
        shownAt: shownAt
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12 4C12.676 4 13.284 4.399 13.556 5.008L13.609 5.142L16.944 14.67C17.0283 14.9108 17.0173 15.1748 16.9134 15.4078C16.8094 15.6408 16.6203 15.8252 16.3848 15.9234C16.1493 16.0215 15.8851 16.0259 15.6465 15.9357C15.4078 15.8455 15.2127 15.6674 15.101 15.438L15.056 15.33L14.232 12.973L14.117 12.993L14 13H10C9.92255 12.9999 9.84536 12.9909 9.77 12.973L8.944 15.33C8.86313 15.5614 8.70011 15.755 8.4859 15.8741C8.27169 15.9932 8.0212 16.0294 7.782 15.976L7.67 15.944C7.43863 15.8631 7.24502 15.7001 7.12593 15.4859C7.00684 15.2717 6.97057 15.0212 7.024 14.782L7.056 14.67L10.391 5.142C10.5078 4.80818 10.7255 4.51893 11.0139 4.31432C11.3024 4.10971 11.6473 3.99987 12.001 4H12ZM12 6.598L10.46 11H13.542L12.002 6.598H12Z",
        fill: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M14 17L16 19L20 15",
        stroke: "var(--ds-icon, #44546F)",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    })));
};

});

parcelRegister("lXs67", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $ffc4e74a2a37647a$export$f04a61298a47a40f);

var $eUqFw = parcelRequire("eUqFw");

var $8DZnH = parcelRequire("8DZnH");
const $ffc4e74a2a37647a$export$f04a61298a47a40f = (props)=>{
    const { shownAt: shownAt } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8DZnH.RainbowBorder), {
        shownAt: shownAt
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "var(--ds-icon, #44546F)",
        xmlns: "http://www.w3.org/2000/svg",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M8.45366 7.76225L6.37618 5.68477C6.16881 5.4774 5.8326 5.4774 5.62524 5.68477L5.62453 5.68548C5.41716 5.89284 5.41716 6.22906 5.62453 6.43642L7.70201 8.5139C7.90938 8.72127 8.24559 8.72127 8.45296 8.5139L8.45366 8.5132C8.66103 8.30583 8.66103 7.96962 8.45366 7.76225Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M17.6911 5.69892L15.5853 7.80468C15.3858 8.00424 15.3858 8.32779 15.5853 8.52735C15.7849 8.7269 16.1084 8.7269 16.308 8.52735L18.4138 6.42158C18.6133 6.22203 18.6133 5.89848 18.4138 5.69892C18.2142 5.49936 17.8907 5.49936 17.6911 5.69892Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7.64164 15.6144L5.58538 17.6706C5.37215 17.8838 5.37215 18.2296 5.58538 18.4428L5.58608 18.4435C5.79931 18.6567 6.14502 18.6567 6.35824 18.4435L8.41451 16.3872C8.62774 16.174 8.62774 15.8283 8.41451 15.6151L8.4138 15.6144C8.20058 15.4011 7.85487 15.4011 7.64164 15.6144Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M6.5 11.5H3.5C3.22386 11.5 3 11.7239 3 12C3 12.2761 3.22386 12.5 3.5 12.5H6.5C6.77614 12.5 7 12.2761 7 12C7 11.7239 6.77614 11.5 6.5 11.5Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M20.5 11.5H17.5C17.2239 11.5 17 11.7239 17 12C17 12.2761 17.2239 12.5 17.5 12.5H20.5C20.7761 12.5 21 12.2761 21 12C21 11.7239 20.7761 11.5 20.5 11.5Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12.5 6.5V3.5C12.5 3.22386 12.2761 3 12 3C11.7239 3 11.5 3.22386 11.5 3.5V6.5C11.5 6.77614 11.7239 7 12 7C12.2761 7 12.5 6.77614 12.5 6.5Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M12.5 20.5V17.5C12.5 17.2239 12.2761 17 12 17C11.7239 17 11.5 17.2239 11.5 17.5V20.5C11.5 20.7761 11.7239 21 12 21C12.2761 21 12.5 20.7761 12.5 20.5Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.62 12.913L11.854 11.146C11.7602 11.0521 11.633 10.9993 11.5004 10.9992C11.3677 10.9991 11.2404 11.0517 11.1465 11.1455C11.0526 11.2392 10.9998 11.3665 10.9997 11.4991C10.9996 11.6318 11.0522 11.7591 11.146 11.853L12.913 13.62L13.62 12.913ZM12.56 10.439C12.277 10.1659 11.898 10.0149 11.5047 10.0185C11.1114 10.0221 10.7353 10.18 10.4573 10.4582C10.1793 10.7365 10.0217 11.1128 10.0185 11.5061C10.0153 11.8994 10.1666 12.2782 10.44 12.561L17.51 19.631C17.6483 19.7743 17.8138 19.8887 17.9967 19.9674C18.1797 20.0461 18.3765 20.0875 18.5757 20.0894C18.7748 20.0912 18.9724 20.0533 19.1568 19.978C19.3411 19.9027 19.5087 19.7914 19.6496 19.6506C19.7905 19.5098 19.9019 19.3424 19.9774 19.1581C20.053 18.9738 20.091 18.7763 20.0894 18.5771C20.0877 18.3779 20.0464 18.1811 19.9679 17.998C19.8894 17.815 19.7752 17.6494 19.632 17.511L12.56 10.439Z"
    })));
};

});


parcelRegister("fHj8R", function(module, exports) {

$parcel$export(module.exports, "neutralTone", () => $b6d9b85516c9be15$export$a1ce45391086f9e8);
$parcel$export(module.exports, "professionalTone", () => $b6d9b85516c9be15$export$9d1bdb60a3d217e);
$parcel$export(module.exports, "casualTone", () => $b6d9b85516c9be15$export$f482a4b6f54abf37);
$parcel$export(module.exports, "educationalTone", () => $b6d9b85516c9be15$export$af9eb666150af102);
$parcel$export(module.exports, "empatheticTone", () => $b6d9b85516c9be15$export$1719f8ca52167b9c);

var $eUqFw = parcelRequire("eUqFw");

var $6mnRu = parcelRequire("6mnRu");

var $EZ9eX = parcelRequire("EZ9eX");

var $7ZRIZ = parcelRequire("7ZRIZ");

var $vQfEF = parcelRequire("vQfEF");

var $dvMh7 = parcelRequire("dvMh7");

var $fNCiF = parcelRequire("fNCiF");

var $gfOPY = parcelRequire("gfOPY");

var $8ae7G = parcelRequire("8ae7G");

var $eEXvl = parcelRequire("eEXvl");

var $8Aaih = parcelRequire("8Aaih");

var $a6K1I = parcelRequire("a6K1I");

var $fVyuy = parcelRequire("fVyuy");

var $l1lF4 = parcelRequire("l1lF4");

var $XHGTv = parcelRequire("XHGTv");
const $b6d9b85516c9be15$var$SELECTION_TYPE = 'range';
function $b6d9b85516c9be15$var$createChangeToneOption({ title: title, description: description, transformationSubType: transformationSubType, intentSchemaId: intentSchemaId, icon: icon }) {
    return (0, $EZ9eX.createEditorPluginAIConfigItemMarkdown)({
        title: title,
        description: description,
        selectionType: $b6d9b85516c9be15$var$SELECTION_TYPE,
        getInitialContext: ({ editorView: editorView, positions: positions, intl: intl, updateIdMap: updateIdMap })=>{
            const { markdown: markdown, contentStatistics: contentStatistics } = (0, $6mnRu.sliceOrNodeToMarkdown)({
                slice: (0, $gfOPY.getSlice)(editorView, positions),
                intl: intl,
                editorView: editorView,
                convertTo: 'markdown-plus',
                updateIdMap: updateIdMap,
                selectionType: $b6d9b85516c9be15$var$SELECTION_TYPE
            });
            return {
                selection: markdown,
                userLocale: intl.locale,
                intentSchemaId: intentSchemaId,
                contentStatistics: contentStatistics
            };
        },
        triggerPromptRequest ({ initialContext: initialContext, editorSchema: editorSchema, backendModel: backendModel }) {
            if ((0, $XHGTv.getBooleanFF)('platform.editor.ai-assistance-service-change-tone')) return (0, $7ZRIZ.transformConvoAI)({
                transformationType: 'change_tone',
                transformationSubType: transformationSubType,
                userLocale: initialContext.userLocale,
                intentSchemaId: initialContext.intentSchemaId,
                editorSchema: editorSchema,
                fullDocument: initialContext.document,
                currentSelection: initialContext.selection,
                backendModel: backendModel
            });
            return (0, $7ZRIZ.transform)({
                transformationType: 'change_tone',
                transformationSubType: transformationSubType,
                userLocale: initialContext.userLocale,
                intentSchemaId: initialContext.intentSchemaId,
                editorSchema: editorSchema,
                contextList: [
                    {
                        type: 'ADF_MARKDOWN_V1',
                        entity: initialContext.selection,
                        relationship: 'SELECTION'
                    }
                ],
                backendModel: backendModel
            });
        },
        isVisible: ({ editorView: editorView, positions: positions })=>(0, $fNCiF.isMinLength)({
                editorView: editorView,
                minLength: 1,
                positions: positions
            }),
        icon: icon,
        actions: [
            (0, $vQfEF.createInsertBelow)({
                appearance: 'secondary'
            }),
            (0, $vQfEF.createReplace)({
                appearance: 'primary'
            })
        ],
        getBackendModel: ()=>{
            if ((0, $XHGTv.getBooleanFF)('platform.editor.ai-assistance-service-change-tone')) return 'assistance-service';
            return (0, $8ae7G.getBackendModelExperiment)();
        }
    });
}
const $b6d9b85516c9be15$export$a1ce45391086f9e8 = $b6d9b85516c9be15$var$createChangeToneOption({
    title: ({ formatMessage: formatMessage })=>formatMessage((0, $dvMh7.messages).neutralToneTitle),
    description: ({ formatMessage: formatMessage })=>formatMessage((0, $dvMh7.messages).neutralToneDescription),
    transformationSubType: 'neutral',
    intentSchemaId: 'change_tone_neutral_intent_schema.json',
    icon: ({ shownAt: shownAt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eEXvl.Icon), {
            shownAt: shownAt
        })
});
const $b6d9b85516c9be15$export$9d1bdb60a3d217e = $b6d9b85516c9be15$var$createChangeToneOption({
    title: ({ formatMessage: formatMessage })=>formatMessage((0, $dvMh7.messages).professionalToneTitle),
    description: ({ formatMessage: formatMessage })=>formatMessage((0, $dvMh7.messages).professionalToneDescription),
    transformationSubType: 'professional',
    intentSchemaId: 'change_tone_professional_intent_schema.json',
    icon: ({ shownAt: shownAt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8Aaih.Icon), {
            shownAt: shownAt
        })
});
const $b6d9b85516c9be15$export$f482a4b6f54abf37 = $b6d9b85516c9be15$var$createChangeToneOption({
    title: ({ formatMessage: formatMessage })=>formatMessage((0, $dvMh7.messages).casualToneTitle),
    description: ({ formatMessage: formatMessage })=>formatMessage((0, $dvMh7.messages).casualToneDescription),
    transformationSubType: 'casual',
    intentSchemaId: 'change_tone_business_casual_intent_schema.json',
    icon: ({ shownAt: shownAt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a6K1I.Icon), {
            shownAt: shownAt
        })
});
const $b6d9b85516c9be15$export$af9eb666150af102 = $b6d9b85516c9be15$var$createChangeToneOption({
    title: ({ formatMessage: formatMessage })=>formatMessage((0, $dvMh7.messages).educationalToneTitle),
    description: ({ formatMessage: formatMessage })=>formatMessage((0, $dvMh7.messages).educationalToneDescription),
    transformationSubType: 'educational',
    intentSchemaId: 'change_tone_educational_intent_schema.json',
    icon: ({ shownAt: shownAt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fVyuy.Icon), {
            shownAt: shownAt
        })
});
const $b6d9b85516c9be15$export$1719f8ca52167b9c = $b6d9b85516c9be15$var$createChangeToneOption({
    title: ({ formatMessage: formatMessage })=>formatMessage((0, $dvMh7.messages).empatheticToneTitle),
    description: ({ formatMessage: formatMessage })=>formatMessage((0, $dvMh7.messages).empatheticToneDescription),
    transformationSubType: 'empathetic',
    intentSchemaId: 'change_tone_empathetic_intent_schema.json',
    icon: ({ shownAt: shownAt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l1lF4.Icon), {
            shownAt: shownAt
        })
});

});
parcelRegister("dvMh7", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9d639e073edc3c15$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $9d639e073edc3c15$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    neutralToneTitle: {
        id: 'fabric.editor.ai.config.item.range.changeTone.neutralTone.title',
        defaultMessage: 'Change tone to neutral',
        description: 'Describes an option to use Atlassian Intellgience to change the tone of content currently selected by the user'
    },
    neutralToneDescription: {
        id: 'fabric.editor.ai.config.item.range.changeTone.neutralTone.description',
        defaultMessage: 'Changes the tone of the content to neutral',
        description: 'Desciption for the Atlassian Intellgience "Change tone to neutral" option'
    },
    neutralToneSelectionToolbarDropdownItemTitle: {
        id: 'fabric.editor.ai.config.item.range.changeTone.neutralTone.selectionToolbar.dropdownItem.title',
        defaultMessage: 'Neutral',
        description: 'Title for Atlassian Intelligence "Change tone to neutral" in editor selection floating toolbar'
    },
    professionalToneTitle: {
        id: 'fabric.editor.ai.config.item.range.changeTone.professionalTone.title',
        defaultMessage: 'Change tone to professional',
        description: 'Describes an option to use Atlassian Intellgience to change the tone of content currently selected by the user'
    },
    professionalToneDescription: {
        id: 'fabric.editor.ai.config.item.range.changeTone.professionalTone.description',
        defaultMessage: 'Changes the tone of the content to professional',
        description: 'Desciption for the Atlassian Intellgience "Change tone to professional" option'
    },
    professionalToneSelectionToolbarDropdownItemTitle: {
        id: 'fabric.editor.ai.config.item.range.changeTone.professionalTone.selectionToolbar.dropdownItem.title',
        defaultMessage: 'Professional',
        description: 'Title for Atlassian Intelligence "Change tone to professional" in editor selection floating toolbar'
    },
    casualToneTitle: {
        id: 'fabric.editor.ai.config.item.range.changeTone.casualTone.title',
        defaultMessage: 'Change tone to casual',
        description: 'Describes an option to use Atlassian Intellgience to change the tone of content currently selected by the user'
    },
    casualToneDescription: {
        id: 'fabric.editor.ai.config.item.range.changeTone.casualTone.description',
        defaultMessage: 'Changes the tone of the content to casual',
        description: 'Desciption for the Atlassian Intellgience "Change tone to casual" option'
    },
    casualToneSelectionToolbarDropdownItemTitle: {
        id: 'fabric.editor.ai.config.item.range.changeTone.casualTone.selectionToolbar.dropdownItem.title',
        defaultMessage: 'Casual',
        description: 'Title for Atlassian Intelligence "Change tone to casual" in editor selection floating toolbar'
    },
    educationalToneTitle: {
        id: 'fabric.editor.ai.config.item.range.changeTone.educationalTone.title',
        defaultMessage: 'Change tone to educational',
        description: 'Describes an option to use Atlassian Intellgience to change the tone of content currently selected by the user'
    },
    educationalToneDescription: {
        id: 'fabric.editor.ai.config.item.range.changeTone.educationalTone.description',
        defaultMessage: 'Changes the tone of the content to educational',
        description: 'Desciption for the Atlassian Intellgience "Change tone to educational" option'
    },
    educationalToneSelectionToolbarDropdownItemTitle: {
        id: 'fabric.editor.ai.config.item.range.changeTone.educationalTone.selectionToolbar.dropdownItem.title',
        defaultMessage: 'Educational',
        description: 'Title for Atlassian Intelligence "Change tone to educational" in editor selection floating toolbar'
    },
    empatheticToneTitle: {
        id: 'fabric.editor.ai.config.item.range.changeTone.empatheticTone.title',
        defaultMessage: 'Change tone to empathetic',
        description: 'Describes an option to use Atlassian Intellgience to change the tone of content currently selected by the user'
    },
    empatheticToneDescription: {
        id: 'fabric.editor.ai.config.item.range.changeTone.empatheticTone.description',
        defaultMessage: 'Changes the tone of the content to empathetic',
        description: 'Desciption for the Atlassian Intellgience "Change tone to empathetic" option'
    },
    empatheticToneSelectionToolbarDropdownItemTitle: {
        id: 'fabric.editor.ai.config.item.range.changeTone.empatheticTone.selectionToolbar.dropdownItem.title',
        defaultMessage: 'Empathetic',
        description: 'Title for Atlassian Intelligence "Change tone to empathetic" in editor selection floating toolbar'
    }
});

});

parcelRegister("eEXvl", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $aac2f57c52ed7290$export$f04a61298a47a40f);

var $eUqFw = parcelRequire("eUqFw");

var $8DZnH = parcelRequire("8DZnH");
const $aac2f57c52ed7290$export$f04a61298a47a40f = (props)=>{
    const { shownAt: shownAt } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8DZnH.RainbowBorder), {
        shownAt: shownAt
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12Z",
        stroke: "var(--ds-icon, #44546F)",
        strokeWidth: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M11 9.5C11 8.67157 10.3284 8 9.5 8C8.67157 8 8 8.67157 8 9.5C8 10.3284 8.67157 11 9.5 11C10.3284 11 11 10.3284 11 9.5Z",
        fill: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M16 9.5C16 8.67157 15.3284 8 14.5 8C13.6716 8 13 8.67157 13 9.5C13 10.3284 13.6716 11 14.5 11C15.3284 11 16 10.3284 16 9.5Z",
        fill: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M15 13.5H9C8.44772 13.5 8 13.9477 8 14.5C8 15.0523 8.44772 15.5 9 15.5H15C15.5523 15.5 16 15.0523 16 14.5C16 13.9477 15.5523 13.5 15 13.5Z",
        fill: "var(--ds-icon, #44546F)"
    })));
};

});

parcelRegister("8Aaih", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $63f9abad0765c3bf$export$f04a61298a47a40f);

var $eUqFw = parcelRequire("eUqFw");

var $8DZnH = parcelRequire("8DZnH");
const $63f9abad0765c3bf$export$f04a61298a47a40f = (props)=>{
    const { shownAt: shownAt } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8DZnH.RainbowBorder), {
        shownAt: shownAt
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "var(--ds-icon, #44546F)",
        xmlns: "http://www.w3.org/2000/svg",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M6 20C5.49542 20.0002 5.00943 19.8096 4.63945 19.4665C4.26947 19.1234 4.04284 18.6532 4.005 18.15L4 18V10C3.99984 9.49542 4.19041 9.00943 4.5335 8.63945C4.87659 8.26947 5.34684 8.04284 5.85 8.005L6 8H8V6C7.99984 5.49542 8.19041 5.00943 8.5335 4.63945C8.87659 4.26947 9.34685 4.04284 9.85 4.005L10 4H14C14.5046 3.99984 14.9906 4.19041 15.3605 4.5335C15.7305 4.87659 15.9572 5.34684 15.995 5.85L16 6V8H18C18.5044 8.00009 18.9901 8.19077 19.3599 8.53384C19.7297 8.8769 19.9562 9.34702 19.994 9.85L20 10V18C19.9999 18.5044 19.8092 18.9901 19.4662 19.3599C19.1231 19.7297 18.653 19.9562 18.15 19.994L18 20H6ZM8 10H6V18H7.999L8 10ZM14 10H10L9.999 18H14V10ZM18 10H16V18H18V10ZM14 6H10V8H14V6Z"
    })));
};

});

parcelRegister("a6K1I", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $75be2ae0a5d15a11$export$f04a61298a47a40f);

var $eUqFw = parcelRequire("eUqFw");

var $8DZnH = parcelRequire("8DZnH");
const $75be2ae0a5d15a11$export$f04a61298a47a40f = (props)=>{
    const { shownAt: shownAt } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8DZnH.RainbowBorder), {
        shownAt: shownAt
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        clipPath: "url(#clip0_11_3586)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("mask", {
        id: "mask0_11_3586",
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "24",
        height: "24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M0 0H24V24H0V0Z",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        mask: "url(#mask0_11_3586)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 21C10.8181 21 9.64778 20.7672 8.55585 20.3149C7.46392 19.8626 6.47177 19.1997 5.63604 18.364C4.80031 17.5282 4.13738 16.5361 3.68508 15.4442C3.23279 14.3522 3 13.1819 3 12C3 10.8181 3.23279 9.64778 3.68508 8.55585C4.13738 7.46392 4.80031 6.47177 5.63604 5.63604C6.47177 4.80031 7.46392 4.13738 8.55585 3.68508C9.64778 3.23279 10.8181 3 12 3C14.3869 3 16.6761 3.94821 18.364 5.63604C20.0518 7.32387 21 9.61305 21 12C21 14.3869 20.0518 16.6761 18.364 18.364C16.6761 20.0518 14.3869 21 12 21ZM12 19C13.3843 18.9996 14.7375 18.5889 15.8884 17.8196C17.0393 17.0504 17.9364 15.9572 18.4661 14.6782C18.9959 13.3993 19.1346 11.992 18.8648 10.6342C18.5949 9.27645 17.9286 8.02916 16.95 7.05C16.136 6.23608 15.1338 5.63546 14.0323 5.30135C12.9307 4.96723 11.7637 4.90994 10.6347 5.13453C9.50574 5.35913 8.44955 5.85868 7.55973 6.58895C6.6699 7.31922 5.9739 8.25766 5.53338 9.32115C5.09285 10.3846 4.92139 11.5404 5.03419 12.6859C5.14699 13.8315 5.54057 14.9316 6.18006 15.8888C6.81955 16.8459 7.68521 17.6306 8.70038 18.1733C9.71554 18.716 10.8489 18.9999 12 19ZM8.05 14.197C7.883 13.72 8.152 13.206 8.651 13.047C9.151 12.888 9.69 13.146 9.856 13.622C9.916 13.796 10.081 14.109 10.351 14.418C10.777 14.906 11.307 15.182 12 15.182C12.693 15.182 13.223 14.906 13.65 14.418C13.92 14.108 14.083 13.796 14.144 13.622C14.31 13.146 14.85 12.888 15.349 13.047C15.848 13.206 16.117 13.72 15.951 14.197C15.76 14.707 15.475 15.177 15.112 15.582C14.348 16.458 13.306 17 12 17C10.694 17 9.652 16.458 8.888 15.582C8.5247 15.1765 8.24017 14.7068 8.049 14.197H8.05ZM9.5 11C9.10218 11 8.72064 10.842 8.43934 10.5607C8.15804 10.2794 8 9.89782 8 9.5C8 9.10218 8.15804 8.72064 8.43934 8.43934C8.72064 8.15804 9.10218 8 9.5 8C9.89782 8 10.2794 8.15804 10.5607 8.43934C10.842 8.72064 11 9.10218 11 9.5C11 9.89782 10.842 10.2794 10.5607 10.5607C10.2794 10.842 9.89782 11 9.5 11ZM14.5 11C14.1022 11 13.7206 10.842 13.4393 10.5607C13.158 10.2794 13 9.89782 13 9.5C13 9.10218 13.158 8.72064 13.4393 8.43934C13.7206 8.15804 14.1022 8 14.5 8C14.8978 8 15.2794 8.15804 15.5607 8.43934C15.842 8.72064 16 9.10218 16 9.5C16 9.89782 15.842 10.2794 15.5607 10.5607C15.2794 10.842 14.8978 11 14.5 11Z",
        fill: "var(--ds-icon, #44546F)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M5.503 8.957C5.503 8.55917 5.66103 8.17764 5.94234 7.89634C6.22364 7.61503 6.60517 7.457 7.003 7.457H9.826C10.0367 7.45714 10.2451 7.50168 10.4374 7.58772C10.6298 7.67377 10.8019 7.79938 10.9425 7.95637C11.083 8.11337 11.189 8.29822 11.2533 8.49888C11.3177 8.69955 11.339 8.91153 11.316 9.121L11.147 10.664C11.1066 11.0312 10.9321 11.3706 10.657 11.6171C10.3819 11.8637 10.0254 12 9.656 12H7.003C6.60517 12 6.22364 11.842 5.94234 11.5607C5.66103 11.2794 5.503 10.8978 5.503 10.5V8.957ZM12.678 9.013C12.6556 8.80375 12.6774 8.59213 12.7421 8.39188C12.8068 8.19163 12.9129 8.00723 13.0535 7.85066C13.1941 7.6941 13.3661 7.56888 13.5583 7.48314C13.7505 7.3974 13.9586 7.35306 14.169 7.353H16.979C17.3768 7.353 17.7584 7.51103 18.0397 7.79234C18.321 8.07364 18.479 8.45517 18.479 8.853V10.5C18.479 10.8978 18.321 11.2794 18.0397 11.5607C17.7584 11.842 17.3768 12 16.979 12H14.346C13.976 11.9999 13.619 11.863 13.3438 11.6156C13.0686 11.3683 12.8945 11.0279 12.855 10.66L12.678 9.013Z",
        fill: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M10.5 8H13.5V9.5H10.5V8Z",
        fill: "var(--ds-icon, #44546F)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("clipPath", {
        id: "clip0_11_3586"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white"
    })))));
};

});

parcelRegister("fVyuy", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $b986ef3ed22aefbb$export$f04a61298a47a40f);

var $eUqFw = parcelRequire("eUqFw");

var $8DZnH = parcelRequire("8DZnH");
const $b986ef3ed22aefbb$export$f04a61298a47a40f = (props)=>{
    const { shownAt: shownAt } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8DZnH.RainbowBorder), {
        shownAt: shownAt
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M18.636 15H7C6.46957 15 5.96086 15.2107 5.58579 15.5858C5.21071 15.9609 5 16.4696 5 17C5 17.5304 5.21071 18.0391 5.58579 18.4142C5.96086 18.7893 6.46957 19 7 19H19",
        stroke: "var(--ds-icon, #44546F)",
        strokeWidth: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19 15V5H7C6.46957 5 5.96086 5.21071 5.58579 5.58579C5.21071 5.96086 5 6.46957 5 7V17",
        stroke: "var(--ds-icon, #44546F)",
        strokeWidth: "2",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M19 19C18.4696 19 17.9609 18.7893 17.5858 18.4142C17.2107 18.0391 17 17.5304 17 17C17 16.4696 17.2107 15.9609 17.5858 15.5858C17.9609 15.2107 18.4696 15 19 15",
        stroke: "var(--ds-icon, #44546F)",
        strokeWidth: "2",
        strokeLinecap: "round"
    })));
};

});

parcelRegister("l1lF4", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $f4da7e802df320e1$export$f04a61298a47a40f);

var $eUqFw = parcelRequire("eUqFw");

var $8DZnH = parcelRequire("8DZnH");
const $f4da7e802df320e1$export$f04a61298a47a40f = (props)=>{
    const { shownAt: shownAt } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8DZnH.RainbowBorder), {
        shownAt: shownAt
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "var(--ds-icon, #44546F)",
        xmlns: "http://www.w3.org/2000/svg",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M11.121 5.385L11.278 5.535L11.985 6.242L12.692 5.536C13.6168 4.61388 14.8658 4.09021 16.1717 4.07699C17.4777 4.06378 18.7369 4.56205 19.6803 5.46527C20.6236 6.36848 21.1761 7.60494 21.2195 8.91022C21.263 10.2155 20.7941 11.486 19.913 12.45L19.763 12.607L18.352 14.018L12.71 19.704C12.5359 19.8796 12.3028 19.9845 12.0559 19.9983C11.809 20.0122 11.5657 19.934 11.373 19.779L11.292 19.706L5.62 14.02L4.207 12.607C3.27965 11.6833 2.75151 10.4327 2.73597 9.12391C2.72044 7.81509 3.21875 6.55236 4.12391 5.60688C5.02907 4.6614 6.26889 4.10856 7.57714 4.06707C8.8854 4.02559 10.1578 4.49877 11.121 5.385ZM18.349 11.192C18.8975 10.6395 19.2097 9.89545 19.2197 9.11701C19.2297 8.33857 18.9367 7.58673 18.4026 7.02032C17.8686 6.45391 17.1352 6.1173 16.3575 6.0816C15.5798 6.0459 14.8187 6.31391 14.235 6.829L14.107 6.949L12.692 8.364C12.5592 8.49619 12.3921 8.58855 12.2095 8.63062C12.0269 8.67268 11.8362 8.66277 11.659 8.602C11.5158 8.55271 11.3858 8.47129 11.279 8.364L9.863 6.95C9.31051 6.40153 8.56645 6.08931 7.78801 6.0793C7.00958 6.0693 6.25773 6.36228 5.69132 6.89637C5.12492 7.43045 4.7883 8.1638 4.7526 8.94148C4.7169 9.71916 4.98491 10.4803 5.5 11.064L5.621 11.192L7.036 12.607L11.998 17.582L16.932 12.609L18.349 11.192Z"
    })));
};

});


parcelRegister("eeljI", function(module, exports) {

$parcel$export(module.exports, "createEditorPluginAIProvider", () => $a5c2e89ba1a4dc23$export$d6cef3fb84829841);
// Note: The intention of this function was to;
// 1. provide a nice DX around ensuring consumers are passing the right things
// ie.
// ```diff
// - const editorPluginAIProvider: EditorPluginAIProvider = {/** */}
// + const editorPluginAIProvider = createEditorPluginAIProvider({/** */})
// ```
// 2. Provide an easy to follow/find seam for defaults
// ie. defaults could have been done deeper on consumption -- but it would be
// harder for consumers to track that down and see the defaults occurring.
function $a5c2e89ba1a4dc23$export$d6cef3fb84829841({ disableAISelectionToolbar: disableAISelectionToolbar, getFetchCustomHeaders: getFetchCustomHeaders, getChannelVariables: getChannelVariables, emptyConfig: emptyConfig, rangeConfig: rangeConfig, generativeAIApiUrl: generativeAIApiUrl, proactiveAIConfig: proactiveAIConfig, product: product, onExperienceEvent: onExperienceEvent, AIButtonWrapper: AIButtonWrapper, handleFeedbackSubmission: handleFeedbackSubmission, isFullPageExperimentsEnabled: isFullPageExperimentsEnabled, PromptEditor: PromptEditor, disableInterrogation: disableInterrogation }) {
    return {
        disableAISelectionToolbar: disableAISelectionToolbar,
        disableInterrogation: disableInterrogation,
        getFetchCustomHeaders: getFetchCustomHeaders,
        getChannelVariables: getChannelVariables,
        emptyConfig: emptyConfig,
        rangeConfig: rangeConfig,
        generativeAIApiUrl: generativeAIApiUrl,
        proactiveAIConfig: proactiveAIConfig,
        product: product,
        onExperienceEvent: onExperienceEvent,
        AIButtonWrapper: AIButtonWrapper,
        handleFeedbackSubmission: handleFeedbackSubmission,
        isFullPageExperimentsEnabled: isFullPageExperimentsEnabled,
        PromptEditor: PromptEditor
    };
}

});

parcelRegister("6BHl7", function(module, exports) {

$parcel$export(module.exports, "brainstormConfigItem", () => $4cf7d11ee5c6d06b$export$d1e9d60c4002b5d0);

var $eUqFw = parcelRequire("eUqFw");

var $EZ9eX = parcelRequire("EZ9eX");

var $iRpdu = parcelRequire("iRpdu");

var $vQfEF = parcelRequire("vQfEF");

var $bbcJp = parcelRequire("bbcJp");

var $9dVgv = parcelRequire("9dVgv");

var $XHGTv = parcelRequire("XHGTv");

var $8ae7G = parcelRequire("8ae7G");
const $4cf7d11ee5c6d06b$var$SELECTION_TYPE = 'empty';
const $4cf7d11ee5c6d06b$export$d1e9d60c4002b5d0 = (0, $EZ9eX.createEditorPluginAIConfigItemMarkdown)({
    title: ({ formatMessage: formatMessage })=>formatMessage((0, $bbcJp.messages).title),
    description: ({ formatMessage: formatMessage })=>formatMessage((0, $bbcJp.messages).description),
    selectionType: $4cf7d11ee5c6d06b$var$SELECTION_TYPE,
    getInitialContext: ({ intl: intl })=>({
            userLocale: intl.locale,
            intentSchemaId: 'brainstorm_intent_schema.json',
            document: ''
        }),
    promptLabel: ({ formatMessage: formatMessage })=>formatMessage((0, $bbcJp.messages).promptLabel),
    promptHint: ({ formatMessage: formatMessage })=>formatMessage((0, $bbcJp.messages).promptHint),
    icon: ({ shownAt: shownAt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9dVgv.Icon), {
            shownAt: shownAt
        }),
    triggerPromptRequest ({ initialContext: initialContext, promptInput: promptInput, editorSchema: editorSchema, backendModel: backendModel }) {
        if ((0, $XHGTv.getBooleanFF)('platform.editor.ai-assistance-service-brainstorm')) return (0, $iRpdu.generateConvoAI)({
            customPrompt: promptInput,
            userLocale: initialContext.userLocale,
            intentSchemaId: 'brainstorm_intent_schema.json',
            editorSchema: editorSchema,
            currentSelection: initialContext.document,
            backendModel: backendModel
        });
        return (0, $iRpdu.generate)({
            customPrompt: promptInput,
            userLocale: initialContext.userLocale,
            intentSchemaId: initialContext.intentSchemaId,
            editorSchema: editorSchema,
            contextList: [
                {
                    type: 'text',
                    entity: '',
                    relationship: undefined
                }
            ]
        });
    },
    isVisible: ()=>true,
    actions: [
        (0, $vQfEF.createInsertAtCurrentPosition)({
            appearance: 'primary'
        })
    ],
    getBackendModel: ()=>{
        if ((0, $XHGTv.getBooleanFF)('platform.editor.ai-assistance-service-brainstorm')) return 'assistance-service';
        return (0, $8ae7G.getBackendModelExperiment)();
    }
});

});
parcelRegister("bbcJp", function(module, exports) {

$parcel$export(module.exports, "messages", () => $823a98fc88b81f79$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $823a98fc88b81f79$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        id: 'fabric.editor.ai.config.item.empty.brainstorm.title',
        defaultMessage: 'Brainstorm',
        description: 'Title for "Brainstorm" Atlassian Intelligence feature shown in editor typeahead and element browser.'
    },
    description: {
        id: 'fabric.editor.ai.config.item.empty.brainstorm.description',
        defaultMessage: 'Generates a list of ideas for a topic you provide',
        description: 'Describes the "Brainstorm" Atlassian Intelligence feature shown in editor typeahead and element browser.'
    },
    promptLabel: {
        id: 'fabric.editor.ai.config.item.empty.brainstorm.promptLabel',
        defaultMessage: 'Brainstorm',
        description: 'Label text in the prompt input.'
    },
    promptHint: {
        id: 'fabric.editor.ai.config.item.empty.brainstorm.promptHint',
        defaultMessage: 'Tell me the topic...',
        description: 'Placeholder text in the prompt input guiding user interaction.'
    }
});

});

parcelRegister("9dVgv", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $6b71bf9e1c3befe6$export$f04a61298a47a40f);

var $eUqFw = parcelRequire("eUqFw");

var $8DZnH = parcelRequire("8DZnH");
const $6b71bf9e1c3befe6$export$f04a61298a47a40f = (props)=>{
    const { shownAt: shownAt } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8DZnH.RainbowBorder), {
        shownAt: shownAt
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "var(--ds-icon, #44546F)",
        xmlns: "http://www.w3.org/2000/svg",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7.04101 4.052C8.35608 2.73768 10.1392 1.99937 11.9985 1.99937C13.8578 1.99937 15.6409 2.73768 16.956 4.052C17.581 4.67653 18.0768 5.4181 18.415 6.23433C18.7533 7.05056 18.9274 7.92545 18.9274 8.809C18.9274 9.69254 18.7533 10.5674 18.415 11.3837C18.0768 12.1999 17.581 12.9415 16.956 13.566L16.841 13.678L16.724 13.787L15.998 14.446L16 15.83L15.998 15.862V18.001C15.9976 18.7657 15.7051 19.5014 15.1804 20.0577C14.6557 20.6139 13.9384 20.9489 13.175 20.994L12.998 20.999H10.998C10.2333 20.9988 9.49752 20.7066 8.94104 20.1821C8.38455 19.6576 8.04938 18.9404 8.00401 18.177L7.99801 18.001V14.445L7.27301 13.785C6.01548 12.6426 5.23697 11.0665 5.09394 9.37352C4.95091 7.68057 5.45397 5.99622 6.50201 4.659L6.66401 4.46L6.82001 4.283C6.89182 4.20392 6.96551 4.12756 7.04101 4.052ZM13.998 16.83H9.99801V18.002C9.99831 18.2469 10.0885 18.4832 10.2514 18.666C10.4144 18.8489 10.6387 18.9656 10.882 18.994L10.998 19.001H12.998C13.2431 19.0012 13.4798 18.9114 13.663 18.7486C13.8462 18.5858 13.9633 18.3614 13.992 18.118L13.998 18.002V16.83ZM15.54 5.466C15.0613 4.98771 14.4907 4.61131 13.8626 4.3595C13.2345 4.10769 12.5619 3.98567 11.8854 4.00081C11.2089 4.01595 10.5424 4.16792 9.92623 4.44758C9.31003 4.72724 8.75684 5.12878 8.30001 5.628C7.48334 6.52552 7.04311 7.70273 7.07048 8.91589C7.09784 10.129 7.5907 11.2852 8.44701 12.145L8.61701 12.308L9.67001 13.264C9.84765 13.4255 9.96123 13.6456 9.99001 13.884L9.99701 14.004V14.831H13.997V14.004C13.9971 13.7638 14.0838 13.5316 14.241 13.35L14.325 13.264L15.46 12.231L15.54 12.153C15.9793 11.714 16.3277 11.1928 16.5654 10.6191C16.8032 10.0454 16.9255 9.43049 16.9255 8.80949C16.9255 8.1885 16.8032 7.57358 16.5654 6.99989C16.3277 6.4262 15.9793 5.90497 15.54 5.466Z"
    })));
};

});


parcelRegister("bF9YU", function(module, exports) {

$parcel$export(module.exports, "generateFromSelectionConfigItem", () => $87db442b3bfb3b0a$export$28d59d206d6a320c);

var $6mnRu = parcelRequire("6mnRu");

var $EZ9eX = parcelRequire("EZ9eX");

var $iRpdu = parcelRequire("iRpdu");

var $fNCiF = parcelRequire("fNCiF");

var $vQfEF = parcelRequire("vQfEF");

var $8ae7G = parcelRequire("8ae7G");

var $hH0tQ = parcelRequire("hH0tQ");

var $XHGTv = parcelRequire("XHGTv");
const $87db442b3bfb3b0a$var$SELECTION_TYPE = 'range';
const $87db442b3bfb3b0a$export$28d59d206d6a320c = (0, $EZ9eX.createEditorPluginAIConfigItemMarkdown)({
    title: ({ formatMessage: formatMessage })=>formatMessage((0, $hH0tQ.messages).title),
    description: ({ formatMessage: formatMessage })=>formatMessage((0, $hH0tQ.messages).description),
    selectionType: $87db442b3bfb3b0a$var$SELECTION_TYPE,
    getInitialContext: ({ editorView: editorView, positions: positions, intl: intl, updateIdMap: updateIdMap })=>{
        const selection = (0, $6mnRu.sliceOrNodeToMarkdown)({
            slice: editorView.state.doc.slice(positions[0], positions[1]),
            intl: intl,
            editorView: editorView,
            convertTo: 'markdown-plus',
            updateIdMap: updateIdMap,
            selectionType: $87db442b3bfb3b0a$var$SELECTION_TYPE
        });
        const document = (0, $6mnRu.sliceOrNodeToMarkdown)({
            node: editorView.state.doc,
            intl: intl,
            editorView: editorView,
            convertTo: 'markdown-plus',
            updateIdMap: updateIdMap,
            selectionType: $87db442b3bfb3b0a$var$SELECTION_TYPE
        });
        return {
            selection: selection.markdown,
            document: document.markdown,
            userLocale: intl.locale,
            intentSchemaId: 'custom_with_interrogation_intent_schema.json',
            contentStatistics: selection.contentStatistics
        };
    },
    promptHint: ({ formatMessage: formatMessage })=>formatMessage((0, $hH0tQ.messages).promptHint),
    // No prompt label is required -- as this is intended to be set via the
    // the baseGenerate
    triggerPromptRequest ({ promptInput: promptInput, initialContext: initialContext, latestPromptResponse: latestPromptResponse, editorSchema: editorSchema, backendModel: backendModel }) {
        // This config item is overloaded to support both the interrogation prompt and the free generate prompt
        // we distinguish which one we're in by checking if we have a latestPromptResponse
        let contextList;
        if (latestPromptResponse) // If we have a latestPromptResponse, we don't want to add the document to the contextList
        // as it's an interrogation prompt
        contextList = [
            {
                type: 'ADF_MARKDOWN_V1',
                entity: latestPromptResponse,
                // when stringifying -- this will be stripped when the value is undefined
                relationship: 'PREVIOUS_RESPONSE'
            }
        ];
        else contextList = [
            {
                type: 'ADF_MARKDOWN_V1',
                entity: initialContext.selection,
                relationship: 'SELECTION'
            }
        ];
        // Use Convo AI api for free generate if flag is on and it's not interrogate
        // Have kept this separate to interrogate in case they need to be toggled separately
        // for whatever reason (eg. generate works well but interrogate does not)
        if ((0, $XHGTv.getBooleanFF)('platform.editor.ai-assistance-service-free-generate') && !latestPromptResponse) return (0, $iRpdu.generateConvoAI)({
            customPrompt: promptInput,
            userLocale: initialContext.userLocale,
            intentSchemaId: 'custom_free_generate_intent_schema.json',
            editorSchema: editorSchema,
            currentSelection: initialContext.selection,
            fullDocument: initialContext.document,
            backendModel: backendModel
        });
        // Use Convo AI api for interrogate if flag is on
        if ((0, $XHGTv.getBooleanFF)('platform.editor.ai-interrogate-with-convo-ai') && latestPromptResponse) return (0, $iRpdu.generateConvoAI)({
            customPrompt: promptInput,
            userLocale: initialContext.userLocale,
            intentSchemaId: 'custom_with_interrogation_intent_schema.json',
            editorSchema: editorSchema,
            latestPromptResponse: latestPromptResponse,
            currentSelection: initialContext.selection,
            fullDocument: initialContext.document,
            backendModel: backendModel
        });
        return (0, $iRpdu.generate)({
            customPrompt: promptInput,
            userLocale: initialContext.userLocale,
            editorSchema: editorSchema,
            contextList: contextList,
            intentSchemaId: initialContext.intentSchemaId,
            backendModel: backendModel
        });
    },
    isVisible: ({ editorView: editorView, positions: positions })=>(0, $fNCiF.isMinLength)({
            editorView: editorView,
            minLength: 1,
            positions: positions
        }),
    actions: [
        (0, $vQfEF.createInsertBelow)({
            appearance: 'secondary'
        }),
        (0, $vQfEF.createReplace)({
            appearance: 'primary'
        })
    ],
    getBackendModel: ()=>{
        if ((0, $XHGTv.getBooleanFF)('platform.editor.ai-assistance-service-free-generate')) return 'assistance-service';
        return (0, $8ae7G.getBackendModelExperiment)();
    }
});

});
parcelRegister("hH0tQ", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ce16d33602e30257$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $ce16d33602e30257$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        id: 'fabric.editor.ai.config.item.range.generateFromSelection.title',
        defaultMessage: 'Atlassian Intelligence',
        description: '...'
    },
    promptHint: {
        id: 'fabric.editor.ai.config.item.range.generateFromSelection.promptHint',
        defaultMessage: 'Tell AI to write anything or choose from below',
        description: 'Placeholder text in the prompt input guiding user interaction.'
    },
    description: {
        id: 'fabric.editor.ai.config.item.range.generateFromSelection.description',
        defaultMessage: 'Generate from selection',
        description: 'Placeholder text in the prompt input guiding user interaction.'
    }
});

});


parcelRegister("ix5LP", function(module, exports) {

$parcel$export(module.exports, "reformatWithTemplateConfigItem", () => $d7dfc8ef2a7238e4$export$8c3ef55aa901b0eb);

var $eUqFw = parcelRequire("eUqFw");

var $6mnRu = parcelRequire("6mnRu");

var $EZ9eX = parcelRequire("EZ9eX");

var $7ZRIZ = parcelRequire("7ZRIZ");

var $vQfEF = parcelRequire("vQfEF");

var $6MZrb = parcelRequire("6MZrb");

var $fNCiF = parcelRequire("fNCiF");

var $gfOPY = parcelRequire("gfOPY");

var $8ae7G = parcelRequire("8ae7G");

var $7cn8N = parcelRequire("7cn8N");

var $XHGTv = parcelRequire("XHGTv");
const $d7dfc8ef2a7238e4$var$SELECTION_TYPE = 'range';
function $d7dfc8ef2a7238e4$var$createOption({ title: title, description: description, icon: icon, getAdditionalProps: getAdditionalProps }) {
    return (0, $EZ9eX.createEditorPluginAIConfigItemMarkdown)({
        title: title,
        description: description,
        selectionType: $d7dfc8ef2a7238e4$var$SELECTION_TYPE,
        getInitialContext: ({ editorView: editorView, positions: positions, intl: intl, updateIdMap: updateIdMap })=>{
            const selection = (0, $6mnRu.sliceOrNodeToMarkdown)({
                slice: (0, $gfOPY.getSlice)(editorView, positions),
                intl: intl,
                editorView: editorView,
                convertTo: 'markdown-plus',
                updateIdMap: updateIdMap,
                selectionType: $d7dfc8ef2a7238e4$var$SELECTION_TYPE
            });
            const document = (0, $6mnRu.sliceOrNodeToMarkdown)({
                node: editorView.state.doc,
                intl: intl,
                editorView: editorView,
                convertTo: 'markdown-plus',
                updateIdMap: updateIdMap,
                selectionType: $d7dfc8ef2a7238e4$var$SELECTION_TYPE
            });
            return {
                selection: selection.markdown,
                document: document.markdown,
                userLocale: intl.locale,
                intentSchemaId: 'issue_reformatter_intent_schema.json',
                // TODO https://jplat.jira.atlassian.cloud/browse/JNLIS-898
                contentStatistics: selection.contentStatistics
            };
        },
        triggerPromptRequest ({ initialContext: initialContext, editorSchema: editorSchema }) {
            return (0, $7ZRIZ.unstable_transformConvoAI_IssueReformat)({
                agentNamedId: 'jira_issue_reformatter_agent',
                transformationType: 'issue_reformatter',
                userLocale: initialContext.userLocale,
                editorSchema: editorSchema,
                currentSelection: initialContext.selection,
                // TODO https://jplat.jira.atlassian.cloud/browse/JNLIS-899
                fullDocument: initialContext.document,
                // TODO https://jplat.jira.atlassian.cloud/browse/JNLIS-899
                additionalPayload: {
                    ...getAdditionalProps === null || getAdditionalProps === void 0 ? void 0 : getAdditionalProps()
                }
            });
        },
        isVisible: ({ editorView: editorView, positions: positions })=>(0, $fNCiF.isMinLength)({
                editorView: editorView,
                minLength: 1,
                positions: positions
            }),
        icon: icon,
        actions: [
            (0, $vQfEF.createInsertBelow)({
                appearance: 'secondary'
            }),
            (0, $vQfEF.createReplace)({
                appearance: 'primary'
            })
        ],
        getBackendModel: (0, $8ae7G.getBackendModelExperiment),
        ...(0, $XHGTv.getBooleanFF)('platform.gravity.enable-the-support-for-status-labels-for-editor-ai-suggestions_em3y4') && {
            statusLozengeType: 'beta'
        }
    });
}
const $d7dfc8ef2a7238e4$export$8c3ef55aa901b0eb = (options)=>$d7dfc8ef2a7238e4$var$createOption({
        title: ({ formatMessage: formatMessage })=>formatMessage((0, $6MZrb.messages).reformatWithTemplateTitle),
        description: ({ formatMessage: formatMessage })=>formatMessage((0, $6MZrb.messages).reformatWithTemplateDescription),
        icon: ({ shownAt: shownAt })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7cn8N.Icon), {
                shownAt: shownAt
            }),
        getAdditionalProps: options.getAdditionalProps
    });

});
parcelRegister("6MZrb", function(module, exports) {

$parcel$export(module.exports, "messages", () => $4f16e1f6253febfc$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $4f16e1f6253febfc$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    reformatWithTemplateDescription: {
        id: 'fabric.editor.ai.config.item.range.reformatWithTemplate.default.description',
        defaultMessage: 'Restructure the issue description based on the issue type',
        description: 'Description for the Atlassian Intelligence "Add structure" feature.'
    },
    reformatWithTemplateTitle: {
        id: 'fabric.editor.ai.config.item.range.reformatWithTemplate.default.title',
        defaultMessage: 'Add structure',
        description: 'Describes an option to use Atlassian Intelligence to add structure to the issue description currently selected by the user.'
    }
});

});

parcelRegister("7cn8N", function(module, exports) {

$parcel$export(module.exports, "Icon", () => $53db9aad347b8136$export$f04a61298a47a40f);

var $eUqFw = parcelRequire("eUqFw");

var $8DZnH = parcelRequire("8DZnH");
const $53db9aad347b8136$export$f04a61298a47a40f = (props)=>{
    const { shownAt: shownAt } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8DZnH.RainbowBorder), {
        shownAt: shownAt
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "var(--ds-icon, #44546F)",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M15 6H9C8.44772 6 8 6.44772 8 7C8 7.55228 8.44772 8 9 8H15C15.5523 8 16 7.55228 16 7C16 6.44772 15.5523 6 15 6Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M15 9H9C8.44772 9 8 9.44772 8 10C8 10.5523 8.44772 11 9 11H15C15.5523 11 16 10.5523 16 10C16 9.44772 15.5523 9 15 9Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M11 12H9C8.44772 12 8 12.4477 8 13C8 13.5523 8.44772 14 9 14H11C11.5523 14 12 13.5523 12 13C12 12.4477 11.5523 12 11 12Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M7 4V20H17V4H7ZM5 3.99C5 2.892 5.897 2 7.006 2H16.994C18.102 2 19 2.898 19 3.99V20.01C19 21.109 18.103 22 16.994 22H7.006C6.4765 22.0008 5.96822 21.7919 5.59231 21.419C5.21639 21.0461 5.00344 20.5395 5 20.01V3.99Z"
    })));
};

});



parcelRegister("2ujsF", function(module, exports) {

$parcel$export(module.exports, "default", () => $174fd1eba3c5e13c$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $174fd1eba3c5e13c$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    feedBackTitle: {
        "id": "platform-utils-shared-editor-config.feed-back-title",
        "defaultMessage": "Help us make Atlassian Intelligence even better"
    },
    summaryPlaceholder: {
        "id": "platform-utils-shared-editor-config.summary-placeholder",
        "defaultMessage": "Let us know what you were trying to do and how it could be better"
    },
    userConsentCheckboxLabel: {
        "id": "platform-utils-shared-editor-config.user-consent-checkbox-label",
        "defaultMessage": "Include my last prompt and response in the feedback."
    },
    canContactText: {
        "id": "platform-utils-shared-editor-config.can-contact-text",
        "defaultMessage": "Atlassian can contact me about this feedback. See our <a>privacy policy</a>."
    },
    improveAtlassianText: {
        "id": "platform-utils-shared-editor-config.improve-atlassian-text",
        "defaultMessage": "I\u2019d like to help improve Atlassian products by joining the <a>Atlassian Research Group</a>."
    }
});

});

parcelRegister("7cir5", function(module, exports) {

$parcel$export(module.exports, "Product", () => $ae87d7e3fa4b31ad$export$264ad599d7cef668);
var $ae87d7e3fa4b31ad$export$264ad599d7cef668;
(function(Product) {
    Product["JSW"] = "JSW";
    Product["JWM"] = "JWM";
    Product["JSM"] = "JSM";
    Product["JPD"] = "JPD";
})($ae87d7e3fa4b31ad$export$264ad599d7cef668 || ($ae87d7e3fa4b31ad$export$264ad599d7cef668 = {}));

});


parcelRegister("fokXx", function(module, exports) {

$parcel$export(module.exports, "mutateADFField", () => $546a5424a75c23f6$export$82a40b3982cf31c4);
$parcel$export(module.exports, "validateDescriptionField", () => $546a5424a75c23f6$export$78b1417f15a51a4f);

var $esUXI = parcelRequire("esUXI");

var $dEMIg = parcelRequire("dEMIg");

const $546a5424a75c23f6$var$emptyADFString = JSON.stringify((0, $esUXI.getEmptyADF)());
const $546a5424a75c23f6$export$82a40b3982cf31c4 = (adfValue, fieldId)=>{
    // stringify to compare with emptyADF
    const adfValueString = JSON.stringify(adfValue);
    // emptyADF is special case where input retention should not happen
    return $546a5424a75c23f6$var$emptyADFString === adfValueString ? null : {
        fieldId: fieldId,
        mutationGroup: (0, $e55e59cae09d4189$export$31fd86f8f183952c),
        richText: {
            adfValue: adfValue
        }
    };
};
const $546a5424a75c23f6$export$78b1417f15a51a4f = (adfValue, isRequired)=>{
    if (!isRequired) return undefined;
    const isAdfEmptyOrUndefined = !adfValue || JSON.stringify(adfValue) === JSON.stringify((0, $esUXI.getEmptyADF)());
    if (isAdfEmptyOrUndefined) return 0, $dEMIg.REQUIRED;
    const hardBreakNodeType = 'hardBreak';
    // Users can bypass the required field validation for the description field by pressing shift + enter. shift + enter creates a 'hardBreak' block inside the value. If only hardBreaks exist then treat the description field as empty
    let isAnythingThereApartFromHardBreaks = false;
    if (adfValue?.content?.length > 0) for(let i = 0; i < adfValue.content.length; i += 1){
        const block = adfValue.content[i];
        // @ts-expect-error - TS2339 - Property 'content' does not exist on type 'BlockContent | LayoutSectionDefinition | CodeBlockWithMarksDefinition | ExpandWithBreakoutDefinition | ParagraphWithIndentationDefinition'.
        const blockContent = block.content;
        isAnythingThereApartFromHardBreaks = blockContent?.some(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (blockItem)=>blockItem.type !== hardBreakNodeType);
        if (isAnythingThereApartFromHardBreaks) break;
    }
    if (isAnythingThereApartFromHardBreaks) return undefined;
    return 0, $dEMIg.REQUIRED;
};

});
const $e55e59cae09d4189$export$31fd86f8f183952c = 'richTextFields';



parcelRegister("l8UTV", function(module, exports) {

$parcel$export(module.exports, "EpicLinkField", () => $83f0175da81eeb68$export$7929a33274a9f9f);

var $eUqFw = parcelRequire("eUqFw");

var $7UGh6 = parcelRequire("7UGh6");
const $83f0175da81eeb68$export$7929a33274a9f9f = (props)=>{
    const { useFormContext: useFormContext, ...commonEpicLinkFieldProps } = props;
    const [, { setIsEpicLinkSelected: setIsEpicLinkSelected }] = useFormContext();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7UGh6.default), {
        ...commonEpicLinkFieldProps,
        setIsEpicLinkSelected: setIsEpicLinkSelected
    });
};

});
parcelRegister("7UGh6", function(module, exports) {

$parcel$export(module.exports, "default", () => $159c1833e1d641c7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");

var $1ybV0 = parcelRequire("1ybV0");

var $4HxVc = parcelRequire("4HxVc");

var $icPhQ = parcelRequire("icPhQ");
var $6HoNR = parcelRequire("6HoNR");

var $6mXeo = parcelRequire("6mXeo");

var $7TaJX = parcelRequire("7TaJX");

var $dLN4D = parcelRequire("dLN4D");
const $159c1833e1d641c7$export$7929a33274a9f9f = (props)=>{
    const { autoCompleteUrl: autoCompleteUrl, width: width, selectedProject: selectedProject, fieldProps: { value: value, onChange: onChange, ...fieldProps }, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $7TaJX.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, setIsEpicLinkSelected: setIsEpicLinkSelected, nonEditableReason: nonEditableReason, isEditable: isEditable = true } = props;
    (0, $eUqFw.useEffect)(()=>{
        if (setIsEpicLinkSelected) setIsEpicLinkSelected(!!value);
    }, [
        value,
        setIsEpicLinkSelected
    ]);
    const onChangeHandler = (0, $eUqFw.useCallback)((epicLinkValue)=>{
        if (epicLinkValue) onChange({
            id: epicLinkValue.id,
            label: epicLinkValue.label,
            value: epicLinkValue.value
        });
        else onChange(epicLinkValue);
    }, [
        onChange
    ]);
    const getEpicLinkEditField = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4HxVc.EpicLinkEdit), {
            ...fieldProps,
            autoCompleteUrl: autoCompleteUrl,
            onChange: onChangeHandler,
            autoFocus: autoFocus,
            value: value,
            isDisabled: isEditable === false,
            isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
            projectKey: selectedProject?.projectKey || '',
            onCloseMenuOnScroll: onCloseMenuOnScroll
        });
    // We are disabling the Epic Link and Parent Link fields for taking input and instead displaying that the user should
    // use the Parent field to set the Parent of the issue as part of migrating to a single way of representing Jira's hierarchy.
    return (0, $1ybV0.ff)('disable-epic-link-and-parent-link-fields-in-issue-view-and-gic_zixrt') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6mXeo.DisabledEpicLinkParentLinkField), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, isEditable === false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: nonEditableReason?.message || ''
    }, getEpicLinkEditField()) : getEpicLinkEditField());
};
var $159c1833e1d641c7$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    transformDefaultValue: (0, $dLN4D.transformDefaultEpicValue)
})($159c1833e1d641c7$export$7929a33274a9f9f);

});
parcelRegister("4HxVc", function(module, exports) {

$parcel$export(module.exports, "EpicLinkEdit", () => $8d2290282c35c458$export$f416ca81dc7764ba);

var $eUqFw = parcelRequire("eUqFw");

var $dxIU5 = parcelRequire("dxIU5");

var $5wCDk = parcelRequire("5wCDk");

var $lRmyA = parcelRequire("lRmyA");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4NcaX = parcelRequire("4NcaX");
var $g6sIQ = parcelRequire("g6sIQ");

var $g0g8z = parcelRequire("g0g8z");

var $hpg8f = parcelRequire("hpg8f");

var $cfxst = parcelRequire("cfxst");

var $dclpo = parcelRequire("dclpo");

var $e6t0U = parcelRequire("e6t0U");
const $8d2290282c35c458$export$251bdbdbce9550ea = 300;
const $8d2290282c35c458$export$f416ca81dc7764ba = (props)=>{
    const { onFocus: onFocus, onBlur: onBlur, value: value, onChange: onChange, autoCompleteUrl: autoCompleteUrl, projectKey: projectKey, isInvalid: isInvalid, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, isDisabled: isDisabled = false, classNamePrefix: classNamePrefix, ...fieldProps } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [suggestions, setSuggestions] = (0, $eUqFw.useState)();
    const [defaultSuggestions, setDefaultSuggestions] = (0, $eUqFw.useState)();
    const [hasLastFetchFailed, setHasLastFetchFailed] = (0, $eUqFw.useState)(false);
    const [excludeDone, setExcludeDone] = (0, $eUqFw.useState)(true);
    const isInitialMount = (0, $eUqFw.useRef)(true);
    const lastQuery = (0, $eUqFw.useRef)('');
    const onCheckboxClick = (0, $eUqFw.useCallback)(()=>{
        setExcludeDone(!excludeDone);
    }, [
        excludeDone
    ]);
    const componentProps = (0, $eUqFw.useMemo)(()=>({
            isChecked: !excludeDone,
            onChange: onCheckboxClick
        }), [
        excludeDone,
        onCheckboxClick
    ]);
    const formatOptionLabel = (0, $eUqFw.useCallback)((option, { context: context })=>{
        if (context === 'menu') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dclpo.default), {
            option: option
        });
        return option.label;
    }, []);
    /** Fetching and transforming results logic below * */ const handleSuggestions = (0, $eUqFw.useCallback)((results, query)=>{
        if (lastQuery.current === query) {
            const response = (0, $e6t0U.transformSuggestions)(results, formatMessage);
            setSuggestions(response);
            if (query === '') setDefaultSuggestions(response);
        }
    }, [
        formatMessage
    ]);
    const requestSuggestions = (0, $eUqFw.useCallback)(async (query = '')=>{
        try {
            const response = await (0, $lRmyA.performGetRequest)(`${autoCompleteUrl}?excludeDone=${String(excludeDone)}&projectKey=${projectKey}&maxResults=20&query=${query}`);
            setIsLoading(false);
            handleSuggestions(response, query);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            setIsLoading(false);
            setHasLastFetchFailed(true);
            setSuggestions([]);
        }
    }, [
        autoCompleteUrl,
        excludeDone,
        handleSuggestions,
        projectKey
    ]);
    // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debouncedRequestSuggestions = (0, $eUqFw.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(requestSuggestions, $8d2290282c35c458$export$251bdbdbce9550ea), [
        excludeDone
    ]);
    const onQueryChange = (0, $eUqFw.useCallback)((query)=>{
        debouncedRequestSuggestions.cancel();
        setHasLastFetchFailed(false);
        if (query) {
            lastQuery.current = query;
            setIsLoading(true);
            debouncedRequestSuggestions(query);
        } else {
            lastQuery.current = '';
            setIsLoading(false);
            setSuggestions(defaultSuggestions);
        }
    }, [
        debouncedRequestSuggestions,
        defaultSuggestions
    ]);
    const handleFocus = (0, $eUqFw.useCallback)((e)=>{
        if (lastQuery.current === '' && !defaultSuggestions) {
            setIsLoading(true);
            requestSuggestions();
        }
        onFocus && onFocus(e);
    }, [
        defaultSuggestions,
        onFocus,
        requestSuggestions
    ]);
    const filterOption = (0, $eUqFw.useCallback)((option)=>{
        if (hasLastFetchFailed) // If the fetch has failed, we will show a disabled option to indicate the error to users
        return true;
        return (0, $g6sIQ.filterOptionByLabelAndFilterValues)(option, lastQuery.current || '');
    }, [
        hasLastFetchFailed
    ]);
    const getNoOptionsMessage = (0, $eUqFw.useCallback)(()=>hasLastFetchFailed ? formatMessage((0, $cfxst.default).failedFetch) : formatMessage((0, $cfxst.default).noOptionsMessage), [
        formatMessage,
        hasLastFetchFailed
    ]);
    const getLoadingMessage = (0, $eUqFw.useCallback)(()=>formatMessage((0, $cfxst.default).loadingMessage), [
        formatMessage
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isInitialMount.current) {
            setIsLoading(true);
            requestSuggestions(lastQuery.current);
        }
        isInitialMount.current = false;
    }, [
        excludeDone,
        requestSuggestions
    ]);
    const placeholder = (0, $g0g8z.isEpicLinkFieldRenamedToParent)() ? formatMessage((0, $cfxst.default).placeholderRenamedParent) : formatMessage((0, $cfxst.default).placeholder);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
        ...fieldProps,
        classNamePrefix: classNamePrefix,
        options: suggestions,
        value: value,
        formatOptionLabel: formatOptionLabel,
        onBlur: onBlur,
        onFocus: handleFocus,
        // @ts-expect-error - TS2322 - Type '(arg1: EpicOption) => void' is not assignable to type '(value: EpicOption | null, action: ActionMeta<EpicOption>) => void'.
        onChange: onChange,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        styles: (0, $4NcaX.defaultSelectStyles),
        closeMenuOnScroll: onCloseMenuOnScroll,
        isMulti: false,
        isLoading: isLoading,
        onInputChange: onQueryChange,
        loadingMessage: getLoadingMessage,
        noOptionsMessage: getNoOptionsMessage,
        placeholder: placeholder,
        // @ts-expect-error - TS2322 - Type '(props: Props) => JSX.Element' is not assignable to type 'ComponentType<MenuProps<EpicOption, false, GroupTypeBase<EpicOption>>> | undefined'.
        components: {
            Menu: $hpg8f.default
        },
        componentsProps: componentProps,
        autoFocus: autoFocus,
        filterOption: filterOption,
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        hideSelectedOptions: true,
        isClearable: true,
        isDisabled: isDisabled
    });
};
var $8d2290282c35c458$export$2e2bcd8739ae039 = $8d2290282c35c458$export$f416ca81dc7764ba;

});
parcelRegister("hpg8f", function(module, exports) {

$parcel$export(module.exports, "default", () => $2931c86883502dec$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bT7k5 = parcelRequire("bT7k5");

var $jQxSL = parcelRequire("jQxSL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $g0g8z = parcelRequire("g0g8z");

var $3NImY = parcelRequire("3NImY");

var $gTlS8 = parcelRequire("gTlS8");
const $2931c86883502dec$var$Menu = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { children: children, ...restProps } = props;
    const isChecked = props.selectProps?.componentsProps?.isChecked || false;
    const label = (0, $g0g8z.isEpicLinkFieldRenamedToParent)() ? formatMessage((0, $3NImY.default).checkboxLabelRenamedParent) : formatMessage((0, $3NImY.default).checkboxLabel);
    return(// @ts-expect-error - TS2746 - This JSX tag's 'children' prop expects a single child of type 'ReactElement<any, string | JSXElementConstructor<any>>', but multiple children were provided.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jQxSL.c).Menu, restProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gTlS8.CheckboxWrapper), {
        onClick: props.selectProps?.componentsProps?.onChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
        isChecked: isChecked,
        size: "medium",
        testId: "issue-field-epic-link.ui.edit.menu.issue-field-epic-link-checkbox"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gTlS8.CheckboxLabel), null, label)), children));
};
var $2931c86883502dec$export$2e2bcd8739ae039 = $2931c86883502dec$var$Menu;

});
parcelRegister("3NImY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b759e575e75819ac$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b759e575e75819ac$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    checkboxLabel: {
        "id": "issue-field-epic-link.edit.menu.checkbox-label",
        "defaultMessage": "Include done epics"
    },
    checkboxLabelRenamedParent: {
        "id": "issue-field-epic-link.edit.menu.checkbox-label-renamed-parent",
        "defaultMessage": "Include done issues"
    }
});

});

parcelRegister("gTlS8", function(module, exports) {

$parcel$export(module.exports, "CheckboxWrapper", () => $bddbe5597f00a7ed$export$eef12940a6696c78);
$parcel$export(module.exports, "CheckboxLabel", () => $bddbe5597f00a7ed$export$fc9014afe1b6db0);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $bddbe5597f00a7ed$export$eef12940a6696c78 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1bahesu3 _1yt41bs6 _n7zlpe8f _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $bddbe5597f00a7ed$export$fc9014afe1b6db0 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vwz4kb7n",
            __cmplp.className
        ])
    });
});

});


parcelRegister("dclpo", function(module, exports) {

$parcel$export(module.exports, "default", () => $c694eb62afe92c04$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $k9Z3M = parcelRequire("k9Z3M");

var $PdmhA = parcelRequire("PdmhA");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dSy8I = parcelRequire("dSy8I");
const $c694eb62afe92c04$export$9c93efdee841b45c = (option, doneEpicLabel)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c694eb62afe92c04$var$OptionDescriptionWrapper, null, option.description != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c694eb62afe92c04$var$Description, null, option.description) : null, option.isDone === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($k9Z3M))), {
        primaryColor: `var(--ds-text-success, ${(0, $PdmhA).G500})`,
        label: "include-done-epics"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, doneEpicLabel)) : null);
const $c694eb62afe92c04$var$CustomOption = ({ option: option })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c694eb62afe92c04$var$OptionWrapper, null, option.elemBefore != null ? option.elemBefore : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c694eb62afe92c04$var$OptionTextContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c694eb62afe92c04$var$OptionLabel, null, option.label), $c694eb62afe92c04$export$9c93efdee841b45c(option, formatMessage((0, $dSy8I.default).doneEpicLabel))));
};
var $c694eb62afe92c04$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $c694eb62afe92c04$var$CustomOption;
const $c694eb62afe92c04$var$OptionDescriptionWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o _syaz1rc1 _1wyb1crf _19pk1b66",
            __cmplp.className
        ])
    });
});
const $c694eb62afe92c04$var$Description = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bto1l2s _p12f1osq",
            __cmplp.className
        ])
    });
});
const $c694eb62afe92c04$var$OptionWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $c694eb62afe92c04$var$OptionTextContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _18s8h8dc _1yt4x7n9 _1reo15vq _18m915vq _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $c694eb62afe92c04$var$OptionLabel = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bto1l2s _1reo15vq _18m915vq _o5721q9c _16jlkb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dSy8I", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdff7500949407b6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $fdff7500949407b6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    doneEpicLabel: {
        "id": "issue-field-epic-link.edit.option.done-epic-label",
        "defaultMessage": "Done"
    }
});

});



parcelRegister("6mXeo", function(module, exports) {

$parcel$export(module.exports, "DisabledEpicLinkParentLinkField", () => $815f76a5f972054d$export$eb9d1bb510274e3);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8uD7Y = parcelRequire("8uD7Y");

var $cN08W = parcelRequire("cN08W");
const $815f76a5f972054d$export$eb9d1bb510274e3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($815f76a5f972054d$var$DisabledEpicLinkParentLinkFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $cN08W.default).replacedByParentField,
        values: {
            strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, chunks)
        }
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $815f76a5f972054d$var$DisabledEpicLinkParentLinkFieldWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5721jtm _syaz1wmz",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cN08W", function(module, exports) {

$parcel$export(module.exports, "default", () => $78668661a1cbd085$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $78668661a1cbd085$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    replacedByParentField: {
        "id": "issue-create-commons.common.fields.epic-link-parent-link-disabled.replaced-by-parent-field",
        "defaultMessage": "Replaced by <strong>Parent</strong> field"
    }
});

});




parcelRegister("lnewE", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fe73c06776598b9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $lRvnl = parcelRequire("lRvnl");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7TaJX = parcelRequire("7TaJX");
var $icPhQ = parcelRequire("icPhQ");
var $5i7Lk = parcelRequire("5i7Lk");
var $6HoNR = parcelRequire("6HoNR");

var $j5uQO = parcelRequire("j5uQO");

var $chMRi = parcelRequire("chMRi");
const $6fe73c06776598b9$var$IssueRestrictionField = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { fieldProps: { value: value = [], onChange: onChange, ...fieldProps }, selectedProject: selectedProject, error: error, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $7TaJX.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isMini: isMini, description: description, fieldName: fieldName, width: width } = props;
    const [shouldShowAccessWarning, setAccessWarningDisplay] = (0, $eUqFw.useState)(false);
    const convertToFieldType = (roles)=>{
        onChange(roles.map(({ roleId: roleId })=>({
                roleId: roleId
            })));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j5uQO.RolePickerEdit), {
        ...fieldProps,
        selectedProjectId: selectedProject?.value || '',
        selectedRoles: value,
        onChange: convertToFieldType,
        autoFocus: autoFocus,
        isDisabled: false,
        classNamePrefix: "issue-restriction-select",
        isInvalid: Boolean(error),
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        setAccessWarningDisplay: setAccessWarningDisplay
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5i7Lk.FieldMessage), {
        description: description,
        error: error,
        fieldName: fieldName,
        isMini: isMini
    }), shouldShowAccessWarning ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $6fe73c06776598b9$var$messageContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        appearance: "warning"
    }, formatMessage((0, $chMRi.default).noAccessOnIssueCreatedWarning))) : null);
};
var $6fe73c06776598b9$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    shouldRenderFieldMessage: false
})($6fe73c06776598b9$var$IssueRestrictionField);
const $6fe73c06776598b9$var$messageContainerStyles = (0, $1ZAYh.xcss)({
    marginTop: 'space.050'
});

});
parcelRegister("j5uQO", function(module, exports) {

$parcel$export(module.exports, "RolePickerEdit", () => $80fd179aff8600b4$export$61efdb1b7765b92e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5wCDk = parcelRequire("5wCDk");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4NcaX = parcelRequire("4NcaX");

var $NnTcB = parcelRequire("NnTcB");

var $3uMBt = parcelRequire("3uMBt");

var $77LFF = parcelRequire("77LFF");

var $lKd2p = parcelRequire("lKd2p");
const $80fd179aff8600b4$export$ab4a55465dcdd21b = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { currentUserRole: currentUserRole } = props;
    return currentUserRole ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($80fd179aff8600b4$var$FlexRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $77LFF.CurrentUserRole), null, formatMessage((0, $3uMBt.default).currentUserRole))) : null;
};
// @ts-expect-error - TS7031 - Binding element 'context' implicitly has an 'any' type.
const $80fd179aff8600b4$var$formatOptionLabel = (option, { context: context })=>{
    if (context === 'menu') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($80fd179aff8600b4$var$FlexBody, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($80fd179aff8600b4$var$FlexColumn, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($80fd179aff8600b4$var$RoleName, null, option.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($80fd179aff8600b4$var$SelectDescription, null, option.description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($80fd179aff8600b4$export$ab4a55465dcdd21b, {
        currentUserRole: !!option.currentUserRole
    }));
    return option.name;
};
const $80fd179aff8600b4$export$61efdb1b7765b92e = (props)=>{
    const { classNamePrefix: classNamePrefix, selectedRoles: selectedRoles, selectedProjectId: selectedProjectId, onChange: onChange, isDisabled: isDisabled, onFocus: onFocus, onBlur: onBlur, autoFocus: autoFocus, isInvalid: isInvalid, onCloseMenuOnScroll: onCloseMenuOnScroll, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, setAccessWarningDisplay: setAccessWarningDisplay, ariaLabel: ariaLabel, ...fieldProps } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { data: allRoles } = (0, $NnTcB.default)(selectedProjectId);
    const rolesWithCurrentUserAccess = (0, $eUqFw.useMemo)(()=>allRoles.filter(({ currentUserRole: currentUserRole })=>currentUserRole === true), [
        allRoles
    ]);
    const shouldShowIssueAccessWarning = (0, $eUqFw.useMemo)(()=>!(0, $lKd2p.isUserRoleIncludedInRestrictedRoles)(selectedRoles, rolesWithCurrentUserAccess), [
        rolesWithCurrentUserAccess,
        selectedRoles
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (setAccessWarningDisplay) setAccessWarningDisplay(shouldShowIssueAccessWarning);
    }, [
        setAccessWarningDisplay,
        shouldShowIssueAccessWarning
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
        ...fieldProps,
        classNamePrefix: classNamePrefix,
        options: allRoles,
        isMulti: true,
        onBlur: onBlur,
        onFocus: onFocus,
        formatOptionLabel: $80fd179aff8600b4$var$formatOptionLabel,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        styles: (0, $4NcaX.defaultSelectStyles),
        isSearchable: false,
        placeholder: formatMessage((0, $3uMBt.default).placeholder),
        getOptionValue: (0, $lKd2p.getOptionValue),
        getOptionLabel: (0, $lKd2p.getOptionLabel),
        value: (0, $lKd2p.convertRolesToCurrentRole)(selectedRoles, allRoles),
        onChange: (roles)=>(0, $lKd2p.transformRolesToArrayIfNull)(roles, onChange),
        isDisabled: isDisabled,
        autoFocus: autoFocus,
        validationState: isInvalid === true ? 'error' : null,
        closeMenuOnScroll: onCloseMenuOnScroll,
        "aria-label": ariaLabel
    });
};
var $80fd179aff8600b4$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $80fd179aff8600b4$export$61efdb1b7765b92e;
const $80fd179aff8600b4$var$SelectDescription = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5724jg8 _1wyb1skh _syaz1rc1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $80fd179aff8600b4$var$FlexBody = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $80fd179aff8600b4$var$FlexColumn = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2lx21bp4 _1e0c1txw _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/design-system/no-empty-styled-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $80fd179aff8600b4$var$RoleName = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $80fd179aff8600b4$var$FlexRow = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _19bvv47k",
            __cmplp.className
        ])
    });
});

});
parcelRegister("NnTcB", function(module, exports) {

$parcel$export(module.exports, "default", () => $17eeb1ddff9bda6e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lRmyA = parcelRequire("lRmyA");

var $03vkS = parcelRequire("03vkS");
const $17eeb1ddff9bda6e$var$useFetchRoles = (projectKeyOrId)=>{
    const [data, setData] = (0, $eUqFw.useState)([]);
    const [error, setError] = (0, $eUqFw.useState)(null);
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        (async ()=>{
            setLoading(true);
            try {
                const response = await (0, $lRmyA.performGetRequest)((0, $03vkS.getFetchRolesURL)(projectKeyOrId));
                setLoading(false);
                setData((0, $03vkS.transformRoleIdToString)(response));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (httpError) {
                setLoading(false);
                setError(httpError.message);
            }
        })();
    }, [
        projectKeyOrId
    ]);
    return {
        loading: loading,
        error: error,
        data: data
    };
};
var $17eeb1ddff9bda6e$export$2e2bcd8739ae039 = $17eeb1ddff9bda6e$var$useFetchRoles;

});
parcelRegister("03vkS", function(module, exports) {

$parcel$export(module.exports, "getFetchRolesURL", () => $99f692fd58eb1fb9$export$e39189e7b2114aa1);
$parcel$export(module.exports, "transformRoleIdToString", () => $99f692fd58eb1fb9$export$25aa9a2b001fbb5e);
const $99f692fd58eb1fb9$export$e39189e7b2114aa1 = (projectKeyOrId)=>`/rest/api/3/project/${projectKeyOrId}/internal/roledetails?excludeConnectAddons=true`;
const $99f692fd58eb1fb9$export$25aa9a2b001fbb5e = (roles)=>roles.map(({ id: id, ...role })=>({
            roleId: id.toString(),
            ...role
        }));

});


parcelRegister("3uMBt", function(module, exports) {

$parcel$export(module.exports, "default", () => $65f6b2bfc8333593$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $65f6b2bfc8333593$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    currentUserRole: {
        "id": "issue-field-role-picker.edit.current-user-role",
        "defaultMessage": "You"
    },
    placeholder: {
        "id": "issue-field-role-picker.edit.placeholder",
        "defaultMessage": "Select Roles"
    }
});

});

parcelRegister("77LFF", function(module, exports) {

$parcel$export(module.exports, "CurrentUserRole", () => $a777d87c74053082$export$2e227818a70e412c);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $a777d87c74053082$export$2e227818a70e412c = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_zg8l1m30",
            __cmplp.className
        ])
    });
});

});


parcelRegister("chMRi", function(module, exports) {

$parcel$export(module.exports, "default", () => $8af7fede6e2d6a69$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8af7fede6e2d6a69$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noAccessOnIssueCreatedWarning: {
        "id": "issue-create.common.fields.issue-restriction.no-access-on-issue-created-warning",
        "defaultMessage": "Select the roles that you're a part of to avoid losing access to this issue."
    }
});

});


parcelRegister("1BCWe", function(module, exports) {

$parcel$export(module.exports, "default", () => $141ee696a1477421$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $dEMIg = parcelRequire("dEMIg");

var $jdk8J = parcelRequire("jdk8J");

var $fswni = parcelRequire("fswni");
const $141ee696a1477421$var$LogWorkField = ({ additionalData: additionalData, ...props })=>{
    const { mediaContext: mediaContext, timeTrackingSettings: timeTrackingSettings } = additionalData;
    const [mediaUploadContext, setMediaUploadContext] = (0, $eUqFw.useState)(null);
    const [viewContext, setViewContext] = (0, $eUqFw.useState)(null);
    (0, $eUqFw.useEffect)(()=>{
        const uploadToken = mediaContext?.uploadToken;
        if (uploadToken) {
            const { clientId: clientId, endpointUrl: endpointUrl, targetCollection: targetCollection, token: token, tokenDurationInMin: tokenDurationInMin } = uploadToken;
            const tokenIssueTimestamp = Date.now();
            const tokenLifespanInMs = tokenDurationInMin * 60000;
            setMediaUploadContext({
                clientId: clientId,
                serviceHost: endpointUrl,
                collection: targetCollection,
                tokenLifespanInMs: tokenLifespanInMs,
                token: token,
                tokenIssueTimestamp: tokenIssueTimestamp
            });
            setViewContext({
                clientId: clientId,
                serviceHost: endpointUrl,
                token: token,
                tokenLifespanInMs: tokenLifespanInMs,
                areTokenPermissionsUpToDate: true,
                collection: targetCollection,
                tokenIssueTimestamp: tokenIssueTimestamp
            });
        }
    }, [
        mediaContext?.uploadToken
    ]);
    const mediaProvider = {
        userAuth: null,
        viewContext: viewContext,
        uploadContext: mediaUploadContext
    };
    const [{ timeTrackingValue: timeTrackingValue, meta: { submitFieldwiseErrors: submitFieldwiseErrors } }] = (0, $fswni.useFormContext)();
    const getLogWorkFieldErrors = (0, $eUqFw.useCallback)(()=>{
        if (submitFieldwiseErrors) {
            const logWorkFieldWiseErrors = {};
            [
                (0, $dEMIg.LOG_WORK_DATE_ERROR_KEY),
                (0, $dEMIg.LOG_WORK_DESCRIPTION_ERROR_KEY),
                (0, $dEMIg.LOG_WORK_TIME_REMAINING_ERROR_KEY),
                (0, $dEMIg.LOG_WORK_TIME_SPENT_ERROR_KEY)
            ].forEach((errorKey)=>{
                if (submitFieldwiseErrors[errorKey]) logWorkFieldWiseErrors[errorKey] = submitFieldwiseErrors[errorKey];
            });
            const logWorkOtherErrors = [];
            (0, $dEMIg.COMMON_LOG_WORK_ERROR_KEYS).forEach((key)=>{
                if (submitFieldwiseErrors[key]) logWorkOtherErrors.push(submitFieldwiseErrors[key]);
            });
            return {
                ...logWorkFieldWiseErrors,
                logWorkOtherErrors: logWorkOtherErrors
            };
        }
        return undefined;
    }, [
        submitFieldwiseErrors
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jdk8J.default), {
        ...props,
        additionalData: {
            timeTrackingSettings: timeTrackingSettings
        },
        mediaContext: mediaProvider,
        timeTrackingValue: timeTrackingValue,
        errors: getLogWorkFieldErrors()
    });
};
var $141ee696a1477421$export$2e2bcd8739ae039 = $141ee696a1477421$var$LogWorkField;

});
parcelRegister("jdk8J", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd86f9598973a1b6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5Okns = parcelRequire("5Okns");

var $7u4fN = parcelRequire("7u4fN");

var $i3lFv = parcelRequire("i3lFv");

var $7jPhn = parcelRequire("7jPhn");
var $4LhB6 = parcelRequire("4LhB6");

var $dwj4T = parcelRequire("dwj4T");

var $ajCg0 = parcelRequire("ajCg0");

var $9VPEO = parcelRequire("9VPEO");

var $iPvRp = parcelRequire("iPvRp");

var $c9TLT = parcelRequire("c9TLT");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dEMIg = parcelRequire("dEMIg");

var $9KxVf = parcelRequire("9KxVf");

var $bmG61 = parcelRequire("bmG61");

var $gGtKh = parcelRequire("gGtKh");

var $8K9kM = parcelRequire("8K9kM");

var $4xHig = parcelRequire("4xHig");

var $icPhQ = parcelRequire("icPhQ");
var $6HoNR = parcelRequire("6HoNR");


var $2kIWF = parcelRequire("2kIWF");

var $6BUcO = parcelRequire("6BUcO");
const $bd86f9598973a1b6$var$skeletonHeight = `${(0, $c9TLT.gridSize) * 18.75}px`;
const $bd86f9598973a1b6$export$c128706c0bbc8993 = (props)=>{
    const currentDateTime = (0, $eUqFw.useMemo)(()=>(0, $5Okns.default)(new Date()), []);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [timeFieldInFocus, setTimeFieldInFocus] = (0, $eUqFw.useState)('');
    const isDefaultValueSetInFormStateForDateField = (0, $eUqFw.useRef)(false);
    const [areLogWorkFieldsVisible, showLogWorkFields] = (0, $eUqFw.useState)(false);
    const [estimateExceededWarning, setEstimateExceededWarning] = (0, $eUqFw.useState)('');
    const { width: width = 350, fieldProps: { value: value = {
        timeRemaining: '',
        timeSpent: '',
        dateValue: '',
        description: undefined
    }, onChange: onChange }, timeTrackingValue: timeTrackingValue = '', mediaContext: mediaContext, autoFocus: autoFocus = false, additionalData: additionalData, isRequired: isRequired, errors: errors, fieldName: fieldName } = props;
    const { description: description, timeRemaining: timeRemaining, timeSpent: timeSpent, dateValue: dateValue } = value;
    const { timeTrackingSettings: config } = additionalData;
    const locale = (0, $4xHig.useLocale)();
    const onChangeFieldValue = (0, $eUqFw.useCallback)((partialFieldValue)=>{
        onChange({
            ...value,
            ...partialFieldValue
        });
    }, [
        onChange,
        value
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (timeTrackingValue) {
            const isTimeEstimateExceeded = (0, $6BUcO.getIsTimeEstimateExceeded)({
                config: config,
                timeRemaining: timeRemaining,
                timeSpent: timeSpent,
                timeTrackingValue: timeTrackingValue
            });
            setEstimateExceededWarning(isTimeEstimateExceeded ? formatMessage((0, $2kIWF.default).originalEstimateExceededNonFinal) : '');
        } else if (estimateExceededWarning) setEstimateExceededWarning('');
    }, [
        timeRemaining,
        timeSpent,
        timeTrackingValue,
        config,
        formatMessage,
        estimateExceededWarning
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isDefaultValueSetInFormStateForDateField.current && !dateValue && areLogWorkFieldsVisible) {
            isDefaultValueSetInFormStateForDateField.current = true;
            onChangeFieldValue({
                dateValue: currentDateTime
            });
        }
    }, [
        dateValue,
        currentDateTime,
        onChangeFieldValue,
        areLogWorkFieldsVisible
    ]);
    const onChangeTimeSpent = (0, $eUqFw.useCallback)((newTimeSpent)=>{
        let newTimeRemaining = timeRemaining;
        if (timeTrackingValue) {
            const calculatedTimeRemainingIfAny = (0, $6BUcO.getCalculatedTimeRemainingIfAny)({
                timeSpent: newTimeSpent,
                timeTrackingValue: timeTrackingValue,
                config: config
            });
            if (calculatedTimeRemainingIfAny !== null) newTimeRemaining = calculatedTimeRemainingIfAny;
        }
        setTimeFieldInFocus((0, $4ba72bd5105a797f$export$81fee17d19007357));
        onChangeFieldValue({
            timeSpent: newTimeSpent,
            timeRemaining: newTimeRemaining
        });
    }, [
        config,
        onChangeFieldValue,
        timeRemaining,
        timeTrackingValue
    ]);
    const onChangeTimeRemaining = (0, $eUqFw.useCallback)((newTimeRemaining)=>{
        setTimeFieldInFocus((0, $4ba72bd5105a797f$export$d7ed3a061805d786));
        onChangeFieldValue({
            timeRemaining: newTimeRemaining
        });
    }, [
        onChangeFieldValue
    ]);
    const onToggleLogWorkFieldsVisibility = (0, $eUqFw.useCallback)(()=>{
        showLogWorkFields((current)=>!current);
    }, []);
    const onChangeDatePicker = (0, $eUqFw.useCallback)((newDateValue)=>{
        onChangeFieldValue({
            dateValue: newDateValue
        });
    }, [
        onChangeFieldValue
    ]);
    const onChangeEditorValue = (0, $eUqFw.useCallback)((newEditorValue)=>{
        onChangeFieldValue({
            description: newEditorValue
        });
    }, [
        onChangeFieldValue
    ]);
    const isEstimateExceeded = estimateExceededWarning !== '';
    const weekStartDay = (0, $8K9kM.getLocale)(locale)?.options?.weekStartsOn;
    const buttonLabel = formatMessage((0, $2kIWF.default).logWorkLabel);
    const dateTimeLabel = formatMessage((0, $2kIWF.default).dateStarted);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bd86f9598973a1b6$var$LogWorkHeader, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        iconBefore: areLogWorkFieldsVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ajCg0))), {
            label: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dwj4T))), {
            label: ""
        }),
        appearance: "subtle",
        spacing: "none",
        onClick: onToggleLogWorkFieldsVisibility,
        testId: "issue-create-commons.ui.log-work-field.next-button",
        "aria-label": buttonLabel,
        "aria-expanded": areLogWorkFieldsVisible
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", null, buttonLabel, " ", isRequired === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bd86f9598973a1b6$var$RequiredDot, null, "*") : '')), areLogWorkFieldsVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        name: (0, $4ba72bd5105a797f$export$81fee17d19007357),
        label: formatMessage((0, $2kIWF.default).timeSpent),
        isRequired: isRequired
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bmG61.TimeEstimate), {
            ...fieldProps,
            autoFocus: autoFocus,
            value: timeSpent,
            onChange: onChangeTimeSpent,
            shouldShowWarning: isEstimateExceeded && timeFieldInFocus === (0, $4ba72bd5105a797f$export$81fee17d19007357),
            config: config
        }), errors && errors[0, $dEMIg.LOG_WORK_TIME_SPENT_ERROR_KEY] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, errors[0, $dEMIg.LOG_WORK_TIME_SPENT_ERROR_KEY]) : null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        name: (0, $4ba72bd5105a797f$export$d7ed3a061805d786),
        label: formatMessage((0, $2kIWF.default).timeRemaining)
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bmG61.TimeEstimate), {
            ...fieldProps,
            value: timeRemaining,
            onChange: onChangeTimeRemaining,
            shouldShowWarning: isEstimateExceeded && timeFieldInFocus === (0, $4ba72bd5105a797f$export$d7ed3a061805d786),
            config: config
        }), errors && errors[0, $dEMIg.LOG_WORK_TIME_REMAINING_ERROR_KEY] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, errors[0, $dEMIg.LOG_WORK_TIME_REMAINING_ERROR_KEY]) : null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        name: (0, $4ba72bd5105a797f$export$ade7f171d00a976f),
        label: dateTimeLabel,
        isRequired: isRequired
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i3lFv.default), {
            onChange: onChangeDatePicker,
            value: dateValue,
            locale: locale,
            isClearable: !isRequired,
            times: (0, $iPvRp.default),
            datePickerProps: {
                weekStartDay: weekStartDay
            },
            datePickerSelectProps: {
                'aria-label': dateTimeLabel,
                inputId: fieldProps.id
            }
        }), errors && errors[0, $dEMIg.LOG_WORK_DATE_ERROR_KEY] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, errors[0, $dEMIg.LOG_WORK_DATE_ERROR_KEY]) : null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        name: (0, $4ba72bd5105a797f$export$caca24db5cb49b68),
        label: formatMessage((0, $2kIWF.default).description)
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
            name: "rich-text-edit-view",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9VPEO.Skeleton), {
                height: $bd86f9598973a1b6$var$skeletonHeight
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9KxVf.AsyncRichTextEditView), {
            onChange: onChangeEditorValue,
            defaultValue: description,
            mediaContext: mediaContext,
            // @ts-expect-error - TS2739 - Type '{ unsubscribe: () => void; }' is missing the following properties from type 'MentionProvider': filter, recordMentionSelection, shouldHighlightMention, isFiltering, subscribe
            mentionProvider: {
                // was throwing a console error on unmouting so added this
                // Replace with lodash/noop
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                unsubscribe: ()=>{}
            },
            assistiveLabel: fieldName
        })), errors && errors[0, $dEMIg.LOG_WORK_DESCRIPTION_ERROR_KEY] ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, errors[0, $dEMIg.LOG_WORK_DESCRIPTION_ERROR_KEY]) : null)), errors && errors.logWorkOtherErrors?.map((error, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), {
            key: `logwork-${index}-common-error`
        }, error))));
};
var $bd86f9598973a1b6$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $6HoNR.withFormField)({
    shouldHideLabel: true // @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<LogWorkFieldConfig, FieldValue>, any>'.
})($bd86f9598973a1b6$export$c128706c0bbc8993);
const $bd86f9598973a1b6$var$RequiredDot = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1ick _11c8qk37",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bd86f9598973a1b6$var$LogWorkHeader = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("i3lFv", function(module, exports) {

$parcel$export(module.exports, "default", () => $7573777ddd7b85e1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $EN9B6 = parcelRequire("EN9B6");
var $7ueqz = parcelRequire("7ueqz");
var $3xcI8 = parcelRequire("3xcI8");

var $8dloj = parcelRequire("8dloj");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $hUbUe = parcelRequire("hUbUe");

var $cEc3i = parcelRequire("cEc3i");

var $PdmhA = parcelRequire("PdmhA");

var $7i5dr = parcelRequire("7i5dr");

var $gXOCi = parcelRequire("gXOCi");

var $jP55W = parcelRequire("jP55W");

var $jXg8H = parcelRequire("jXg8H");

var $9DlWJ = parcelRequire("9DlWJ");
function $7573777ddd7b85e1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7573777ddd7b85e1$var$packageName = undefined;
const $7573777ddd7b85e1$var$packageVersion = undefined;
// Make DatePicker 50% the width of DateTimePicker
// If rendering an icon container, shrink the TimePicker
const $7573777ddd7b85e1$var$datePickerContainerStyles = {
    name: "d1cmrh",
    styles: "flex-basis:50%;flex-grow:1;flex-shrink:0"
};
const $7573777ddd7b85e1$var$timePickerContainerStyles = {
    name: "zwso5s",
    styles: "flex-basis:50%;flex-grow:1"
};
const $7573777ddd7b85e1$var$iconContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: "var(--ds-border-width, 1px)",
    alignItems: 'center',
    flexBasis: 'inherit',
    backgroundColor: 'inherit',
    border: 'none',
    color: `var(--ds-text-subtlest, ${(0, $PdmhA.N70)})`,
    paddingBlockEnd: "var(--ds-space-075, 6px)",
    paddingBlockStart: "var(--ds-space-075, 6px)",
    paddingInlineEnd: "var(--ds-space-100, 8px)",
    paddingInlineStart: "var(--ds-space-050, 4px)",
    transition: `color 150ms`,
    '&:hover': {
        color: `var(--ds-text-subtle, ${(0, $PdmhA.N500)})`
    }
});
// react-select overrides (via @atlaskit/select).
const $7573777ddd7b85e1$var$styles = {
    control: (style)=>({
            ...style,
            backgroundColor: 'transparent',
            border: 2,
            borderRadius: 0,
            paddingLeft: 0,
            ':hover': {
                backgroundColor: 'transparent',
                cursor: 'inherit'
            }
        })
};
const $7573777ddd7b85e1$var$dateTimePickerDefaultProps = {
    appearance: 'default',
    autoFocus: false,
    isDisabled: false,
    name: '',
    // These disables are here for proper typing when used as defaults. They
    // should *not* use the `noop` function.
    /* eslint-disable @repo/internal/react/use-noop */ onBlur: (_event)=>{},
    onChange: (_value)=>{},
    onFocus: (_event)=>{},
    /* eslint-enable @repo/internal/react/use-noop */ innerProps: {},
    id: '',
    defaultValue: '',
    timeIsEditable: false,
    isInvalid: false,
    datePickerProps: {},
    timePickerProps: {},
    datePickerSelectProps: {},
    timePickerSelectProps: {},
    times: (0, $7i5dr.defaultTimes),
    spacing: 'default',
    locale: 'en-US'
};
const $7573777ddd7b85e1$export$3b559a1219cb3c27 = 'Date';
const $7573777ddd7b85e1$export$d82cc7e53d68a428 = 'Time';
class $7573777ddd7b85e1$export$732a1726f0a3523b extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.defaultProps = $7573777ddd7b85e1$var$dateTimePickerDefaultProps;
    }
    parseValue(value, dateValue, timeValue, zoneValue) {
        if (this.props.parseValue) return this.props.parseValue(value, dateValue, timeValue, zoneValue);
        const parsed = (0, $3xcI8.default)(value);
        return (0, $7ueqz.default)(parsed) ? {
            dateValue: (0, $EN9B6.default)(parsed, (0, $jP55W.convertTokens)('YYYY-MM-DD')),
            timeValue: (0, $EN9B6.default)(parsed, (0, $jP55W.convertTokens)('HH:mm')),
            zoneValue: (0, $EN9B6.default)(parsed, (0, $jP55W.convertTokens)('ZZ'))
        } : {
            dateValue: dateValue,
            timeValue: timeValue,
            zoneValue: zoneValue
        };
    }
    onValueChange({ dateValue: dateValue, timeValue: timeValue, zoneValue: zoneValue }) {
        this.setState({
            dateValue: dateValue,
            timeValue: timeValue,
            zoneValue: zoneValue
        });
        if (dateValue && timeValue) {
            const value = (0, $7i5dr.formatDateTimeZoneIntoIso)(dateValue, timeValue, zoneValue);
            const { zoneValue: parsedZone } = this.parseValue(value, dateValue, timeValue, zoneValue);
            const valueWithValidZone = (0, $7i5dr.formatDateTimeZoneIntoIso)(dateValue, timeValue, parsedZone);
            this.setState({
                value: valueWithValidZone
            });
            this.props.onChange(valueWithValidZone);
        // If the date or time value was cleared when there is an existing datetime value, then clear the value.
        } else if (this.getSafeState().value) {
            this.setState({
                value: ''
            });
            this.props.onChange('');
        }
    }
    render() {
        const { autoFocus: autoFocus, id: id, innerProps: innerProps, isDisabled: isDisabled, name: name, timeIsEditable: timeIsEditable, dateFormat: dateFormat, datePickerProps: datePickerProps, datePickerSelectProps: datePickerSelectProps, timePickerProps: timePickerProps, timePickerSelectProps: timePickerSelectProps, times: times, timeFormat: timeFormat, locale: locale, testId: testId } = this.props;
        const { isFocused: isFocused, value: value, dateValue: dateValue, timeValue: timeValue } = this.getSafeState();
        const bothProps = {
            isDisabled: isDisabled,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            isInvalid: this.props.isInvalid,
            appearance: this.props.appearance,
            spacing: this.props.spacing
        };
        const { styles: datePickerStyles = {} } = datePickerSelectProps;
        const { styles: timePickerStyles = {} } = timePickerSelectProps;
        const mergedDatePickerSelectProps = {
            ...datePickerSelectProps,
            'aria-label': datePickerProps['label'] || datePickerSelectProps['aria-label'] || $7573777ddd7b85e1$export$3b559a1219cb3c27,
            styles: (0, $cEc3i.m)($7573777ddd7b85e1$var$styles, datePickerStyles)
        };
        const mergedTimePickerSelectProps = {
            ...timePickerSelectProps,
            'aria-label': timePickerProps['label'] || timePickerSelectProps['aria-label'] || $7573777ddd7b85e1$export$d82cc7e53d68a428,
            styles: (0, $cEc3i.m)($7573777ddd7b85e1$var$styles, timePickerStyles)
        };
        // Render DateTimePicker's IconContainer when a value has been filled
        // Don't use Date or TimePicker's because they can't be customised
        const isClearable = Boolean(dateValue || timeValue);
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $gXOCi.DateTimePickerContainer), {
            appearance: bothProps.appearance,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isInvalid: bothProps.isInvalid,
            testId: testId,
            innerProps: innerProps
        }, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
            name: name,
            type: "hidden",
            value: value,
            "data-testid": testId && `${testId}--input`
        }), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $7573777ddd7b85e1$var$datePickerContainerStyles
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $jXg8H.default), {
            ...bothProps,
            autoFocus: autoFocus,
            dateFormat: dateFormat,
            hideIcon: true,
            id: id,
            onChange: this.onDateChange,
            selectProps: mergedDatePickerSelectProps,
            value: dateValue,
            locale: locale,
            testId: testId && `${testId}--datepicker`,
            ...datePickerProps
        })), /*#__PURE__*/ (0, $byn9U.jsx)("div", {
            css: $7573777ddd7b85e1$var$timePickerContainerStyles
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9DlWJ.default), {
            ...bothProps,
            hideIcon: true,
            onChange: this.onTimeChange,
            selectProps: mergedTimePickerSelectProps,
            value: timeValue,
            timeIsEditable: timeIsEditable,
            times: times,
            timeFormat: timeFormat,
            locale: locale,
            testId: testId && `${testId}--timepicker`,
            ...timePickerProps
        })), isClearable && !isDisabled ? /*#__PURE__*/ (0, $byn9U.jsx)("button", {
            css: $7573777ddd7b85e1$var$iconContainerStyles,
            onClick: this.onClear,
            "data-testid": testId && `${testId}--icon--container`,
            tabIndex: -1,
            type: "button"
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hUbUe))), {
            size: "small",
            primaryColor: "inherit",
            label: "clear"
        })) : null);
    }
    constructor(...args){
        super(...args);
        this.state = {
            dateValue: '',
            isFocused: false,
            timeValue: '',
            value: this.props.defaultValue,
            zoneValue: ''
        };
        // All state needs to be accessed via this function so that the state is mapped from props
        // correctly to allow controlled/uncontrolled usage.
        this.getSafeState = ()=>{
            const mappedState = {
                ...this.state,
                ...(0, (/*@__PURE__*/$parcel$interopDefault($8dloj)))(this.props, [
                    'value'
                ])
            };
            return {
                ...mappedState,
                ...this.parseValue(mappedState.value, mappedState.dateValue, mappedState.timeValue, mappedState.zoneValue)
            };
        };
        this.onBlur = (event)=>{
            this.setState({
                isFocused: false
            });
            this.props.onBlur(event);
        };
        this.onFocus = (event)=>{
            this.setState({
                isFocused: true
            });
            this.props.onFocus(event);
        };
        this.onDateChange = (dateValue)=>{
            this.onValueChange({
                ...this.getSafeState(),
                dateValue: dateValue
            });
        };
        this.onTimeChange = (timeValue)=>{
            this.onValueChange({
                ...this.getSafeState(),
                timeValue: timeValue
            });
        };
        this.onClear = ()=>{
            this.onValueChange({
                ...this.getSafeState(),
                timeValue: '',
                dateValue: ''
            });
        };
    }
}
var $7573777ddd7b85e1$export$2e2bcd8739ae039 = (0, $1ngde.default)({
    componentName: 'dateTimePicker',
    packageName: $7573777ddd7b85e1$var$packageName,
    packageVersion: $7573777ddd7b85e1$var$packageVersion
})((0, $2jDha.default)({
    onChange: (0, $hM7RE.default)('atlaskit')({
        action: 'changed',
        actionSubject: 'dateTimePicker',
        attributes: {
            componentName: 'dateTimePicker',
            packageName: $7573777ddd7b85e1$var$packageName,
            packageVersion: $7573777ddd7b85e1$var$packageVersion
        }
    })
})($7573777ddd7b85e1$export$732a1726f0a3523b));

});
parcelRegister("gXOCi", function(module, exports) {

$parcel$export(module.exports, "DateTimePickerContainer", () => $3e6ee5dd922d0b45$export$83034b1f07ab0b20);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");
function $3e6ee5dd922d0b45$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3e6ee5dd922d0b45$var$isInvalidBorderStyles = /*#__PURE__*/ (0, $byn9U.css)({
    borderColor: `var(--ds-border-danger, ${(0, $PdmhA.R400)})`
});
const $3e6ee5dd922d0b45$var$isFocusedBorderStyles = /*#__PURE__*/ (0, $byn9U.css)({
    borderColor: `var(--ds-border-focused, ${(0, $PdmhA.B100)})`,
    boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${(0, $PdmhA.B100)})`}`
});
const $3e6ee5dd922d0b45$var$isFocusedStyles = /*#__PURE__*/ (0, $byn9U.css)({
    backgroundColor: `var(--ds-background-input-pressed, ${(0, $PdmhA.N0)})`
});
const $3e6ee5dd922d0b45$var$subtleBgStyles = {
    name: "1wrome1",
    styles: "background-color:transparent;border-color:transparent"
};
const $3e6ee5dd922d0b45$var$subtleFocusedBgStyles = {
    name: "17swi1q",
    styles: "background-color:var(--ds-background-input-pressed, transparent);border-color:transparent"
};
const $3e6ee5dd922d0b45$var$noBgStyles = {
    name: "14n6qpm",
    styles: "background-color:transparent;border-color:transparent;&:hover{background-color:transparent;border-color:transparent;}"
};
const $3e6ee5dd922d0b45$var$hoverStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:hover': {
        backgroundColor: `var(--ds-background-input-hovered, ${(0, $PdmhA.N30)})`,
        borderColor: `var(--ds-border-input, ${(0, $PdmhA.N100)})`
    }
});
const $3e6ee5dd922d0b45$var$isInvalidHoverStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:hover': {
        backgroundColor: `var(--ds-background-input-hovered, ${(0, $PdmhA.N0)})`,
        borderColor: `var(--ds-border-danger, ${(0, $PdmhA.R400)})`
    }
});
const $3e6ee5dd922d0b45$var$isDisabledStyles = {
    name: "1xp4bos",
    styles: "&:hover{cursor:default;}"
};
const $3e6ee5dd922d0b45$var$newBorderStyles = /*#__PURE__*/ (0, $byn9U.css)({
    border: `${"var(--ds-border-width, 1px)"} solid ${`var(--ds-border-input, ${(0, $PdmhA.N100)})`}`
});
const $3e6ee5dd922d0b45$var$baseContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    backgroundColor: `var(--ds-background-input, ${(0, $PdmhA.N20)})`,
    border: `2px solid ${`var(--ds-border-input, ${(0, $PdmhA.N20)})`}`,
    borderRadius: "var(--ds-border-radius, 3px)",
    transition: 'background-color 200ms ease-in-out, border-color 200ms ease-in-out',
    '&:hover': {
        cursor: 'pointer'
    }
});
const $3e6ee5dd922d0b45$export$83034b1f07ab0b20 = ({ isDisabled: isDisabled, isFocused: isFocused, appearance: appearance, isInvalid: isInvalid, innerProps: innerProps, testId: testId, children: children })=>{
    const notFocusedOrIsDisabled = !(isFocused || isDisabled);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $3e6ee5dd922d0b45$var$baseContainerStyles,
            $3e6ee5dd922d0b45$var$newBorderStyles,
            isDisabled && $3e6ee5dd922d0b45$var$isDisabledStyles,
            isFocused && $3e6ee5dd922d0b45$var$isFocusedStyles,
            appearance === 'subtle' && (isFocused ? $3e6ee5dd922d0b45$var$subtleFocusedBgStyles : $3e6ee5dd922d0b45$var$subtleBgStyles),
            isFocused && $3e6ee5dd922d0b45$var$isFocusedBorderStyles,
            isInvalid && $3e6ee5dd922d0b45$var$isInvalidBorderStyles,
            notFocusedOrIsDisabled && (isInvalid ? $3e6ee5dd922d0b45$var$isInvalidHoverStyles : $3e6ee5dd922d0b45$var$hoverStyles),
            appearance === 'none' && $3e6ee5dd922d0b45$var$noBgStyles
        ],
        ...innerProps,
        "data-testid": testId
    }, children);
};

});

parcelRegister("9DlWJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $645cfbe307315b4f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $EN9B6 = parcelRequire("EN9B6");
var $7ueqz = parcelRequire("7ueqz");

var $8dloj = parcelRequire("8dloj");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $5cS2Y = parcelRequire("5cS2Y");

var $28t3A = parcelRequire("28t3A");
var $5wCDk = parcelRequire("5wCDk");
var $cEc3i = parcelRequire("cEc3i");

var $lcnyw = parcelRequire("lcnyw");

var $7i5dr = parcelRequire("7i5dr");

var $bvbsM = parcelRequire("bvbsM");

var $2sLgt = parcelRequire("2sLgt");

var $jP55W = parcelRequire("jP55W");

var $cJOhG = parcelRequire("cJOhG");
const $645cfbe307315b4f$var$packageName = undefined;
const $645cfbe307315b4f$var$packageVersion = undefined;
const $645cfbe307315b4f$var$menuStyles = {
    /* Need to remove default absolute positioning as that causes issues with position fixed */ position: 'static',
    /* Need to add overflow to the element with max-height, otherwise causes overflow issues in IE11 */ overflowY: 'auto',
    /* React-Popper has already offset the menu so we need to reset the margin, otherwise the offset value is doubled */ margin: 0
};
const $645cfbe307315b4f$var$timePickerDefaultProps = {
    appearance: 'default',
    autoFocus: false,
    defaultIsOpen: false,
    defaultValue: '',
    hideIcon: false,
    id: '',
    innerProps: {},
    isDisabled: false,
    isInvalid: false,
    label: '',
    name: '',
    // These disables are here for proper typing when used as defaults. They
    // should *not* use the `noop` function.
    /* eslint-disable @repo/internal/react/use-noop */ onBlur: (_event)=>{},
    onChange: (_value)=>{},
    onFocus: (_event)=>{},
    /* eslint-enable @repo/internal/react/use-noop */ parseInputValue: (time, _timeFormat)=>(0, $2sLgt.default)(time),
    selectProps: {},
    spacing: 'default',
    times: (0, $7i5dr.defaultTimes),
    timeIsEditable: false,
    locale: 'en-US'
};
class $645cfbe307315b4f$export$8cc1aba0d1f32313 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    static{
        this.defaultProps = $645cfbe307315b4f$var$timePickerDefaultProps;
    }
    render() {
        const { appearance: appearance, autoFocus: autoFocus, formatDisplayLabel: formatDisplayLabel, hideIcon: hideIcon, id: id, innerProps: innerProps, isDisabled: isDisabled, label: label, locale: locale, name: name, placeholder: placeholder, selectProps: selectProps, spacing: spacing, testId: testId, isInvalid: isInvalid, timeIsEditable: timeIsEditable, timeFormat: timeFormat, times: times } = this.props;
        const ICON_PADDING = 2;
        const l10n = (0, $5cS2Y.createLocalizationProvider)(locale);
        const { value: value = '', isOpen: isOpen } = this.getSafeState();
        const { styles: selectStyles = {}, ...otherSelectProps } = selectProps;
        const SelectComponent = timeIsEditable ? (0, $28t3A.default) : (0, $5wCDk.default);
        /**
		 * There are multiple props that can change how the time is formatted.
		 * The priority of props used is:
		 *   1. formatDisplayLabel
		 *   2. timeFormat
		 *   3. locale
		 */ const formatTime = (time)=>{
            if (formatDisplayLabel) return formatDisplayLabel(time, timeFormat || (0, $7i5dr.defaultTimeFormat));
            const date = (0, $2sLgt.default)(time);
            if (!(date instanceof Date)) return '';
            if (!(0, $7ueqz.default)(date)) return time;
            if (timeFormat) return (0, $EN9B6.default)(date, (0, $jP55W.convertTokens)(timeFormat));
            return l10n.formatTime(date);
        };
        const options = times.map((time)=>{
            return {
                label: formatTime(time),
                value: time
            };
        });
        const labelAndValue = value && {
            label: formatTime(value),
            value: value
        };
        const SingleValue = (0, $cJOhG.makeSingleValue)({
            lang: this.props.locale
        });
        const selectComponents = {
            DropdownIndicator: (0, $7i5dr.EmptyComponent),
            Menu: (0, $bvbsM.FixedLayerMenu),
            SingleValue: SingleValue,
            ...hideIcon && {
                ClearIndicator: (0, $7i5dr.EmptyComponent)
            }
        };
        const renderIconContainer = Boolean(!hideIcon && value);
        const mergedStyles = (0, $cEc3i.m)(selectStyles, {
            control: (base)=>({
                    ...base
                }),
            menu: (base)=>({
                    ...base,
                    ...$645cfbe307315b4f$var$menuStyles,
                    // Fixed positioned elements no longer inherit width from their parent, so we must explicitly set the
                    // menu width to the width of our container
                    width: this.containerRef ? this.containerRef.getBoundingClientRect().width : 'auto'
                }),
            indicatorsContainer: (base)=>({
                    ...base,
                    paddingLeft: renderIconContainer ? ICON_PADDING : 0,
                    paddingRight: renderIconContainer ? (0, $lcnyw.gridSize)() - ICON_PADDING : 0
                })
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ...innerProps,
            ref: this.setContainerRef,
            "data-testid": testId && `${testId}--container`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("input", {
            name: name,
            type: "hidden",
            value: value,
            "data-testid": testId && `${testId}--input`,
            onKeyDown: this.onSelectKeyDown
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SelectComponent, {
            "aria-label": label || undefined,
            appearance: appearance,
            autoFocus: autoFocus,
            components: selectComponents,
            inputId: id,
            isClearable: true,
            isDisabled: isDisabled,
            menuIsOpen: isOpen && !isDisabled,
            menuPlacement: "auto",
            openMenuOnFocus: true,
            onBlur: this.onBlur,
            onCreateOption: this.onCreateOption,
            onChange: this.onChange,
            options: options,
            onFocus: this.onFocus,
            onMenuOpen: this.onMenuOpen,
            onMenuClose: this.onMenuClose,
            placeholder: placeholder || l10n.formatTime((0, $7i5dr.placeholderDatetime)),
            styles: mergedStyles,
            value: labelAndValue,
            spacing: spacing,
            // @ts-ignore caused by prop not part of @atlaskit/select
            fixedLayerRef: this.containerRef,
            isInvalid: isInvalid,
            testId: testId,
            ...otherSelectProps
        }));
    }
    constructor(...args){
        super(...args);
        this.containerRef = null;
        this.state = {
            isOpen: this.props.defaultIsOpen,
            clearingFromIcon: false,
            value: this.props.defaultValue,
            isFocused: false
        };
        // All state needs to be accessed via this function so that the state is mapped from props
        // correctly to allow controlled/uncontrolled usage.
        this.getSafeState = ()=>{
            return {
                ...this.state,
                ...(0, (/*@__PURE__*/$parcel$interopDefault($8dloj)))(this.props, [
                    'value',
                    'isOpen'
                ])
            };
        };
        this.onChange = (newValue, action)=>{
            const rawValue = newValue ? newValue.value || newValue : '';
            const value = rawValue.toString();
            let changedState = {
                value: value
            };
            if (action && action.action === 'clear') changedState = {
                ...changedState,
                clearingFromIcon: true
            };
            this.setState(changedState);
            this.props.onChange(value);
        };
        /**
	 * Only allow custom times if timeIsEditable prop is true
	 */ this.onCreateOption = (inputValue)=>{
            if (this.props.timeIsEditable) {
                const { parseInputValue: parseInputValue, timeFormat: timeFormat } = this.props;
                let sanitizedInput;
                try {
                    sanitizedInput = parseInputValue(inputValue, timeFormat || (0, $7i5dr.defaultTimeFormat));
                } catch (e) {
                    return; // do nothing, the main validation should happen in the form
                }
                const includesSeconds = !!(timeFormat && /[:.]?(s|ss)/.test(timeFormat));
                const formatFormat = includesSeconds ? 'HH:mm:ss' : 'HH:mm';
                const formattedValue = (0, $EN9B6.default)(sanitizedInput, formatFormat) || '';
                this.setState({
                    value: formattedValue
                });
                this.props.onChange(formattedValue);
            } else this.onChange(inputValue);
        };
        this.onMenuOpen = ()=>{
            // Don't open menu after the user has clicked clear
            if (this.getSafeState().clearingFromIcon) this.setState({
                clearingFromIcon: false
            });
            else this.setState({
                isOpen: true
            });
        };
        this.onMenuClose = ()=>{
            // Don't close menu after the user has clicked clear
            if (this.getSafeState().clearingFromIcon) this.setState({
                clearingFromIcon: false
            });
            else this.setState({
                isOpen: false
            });
        };
        this.setContainerRef = (ref)=>{
            const oldRef = this.containerRef;
            this.containerRef = ref;
            // Cause a re-render if we're getting the container ref for the first time
            // as the layered menu requires it for dimension calculation
            if (oldRef == null && ref != null) this.forceUpdate();
        };
        this.onBlur = (event)=>{
            this.setState({
                isFocused: false
            });
            this.props.onBlur(event);
        };
        this.onFocus = (event)=>{
            this.setState({
                isFocused: true
            });
            this.props.onFocus(event);
        };
        this.onSelectKeyDown = (event)=>{
            const { key: key } = event;
            const keyPressed = key.toLowerCase();
            if (this.getSafeState().clearingFromIcon && (keyPressed === 'backspace' || keyPressed === 'delete')) // If being cleared from keyboard, don't change behaviour
            this.setState({
                clearingFromIcon: false
            });
        };
    }
}
var $645cfbe307315b4f$export$2e2bcd8739ae039 = (0, $1ngde.default)({
    componentName: 'timePicker',
    packageName: $645cfbe307315b4f$var$packageName,
    packageVersion: $645cfbe307315b4f$var$packageVersion
})((0, $2jDha.default)({
    onChange: (0, $hM7RE.default)('atlaskit')({
        action: 'selectedTime',
        actionSubject: 'timePicker',
        attributes: {
            componentName: 'timePicker',
            packageName: $645cfbe307315b4f$var$packageName,
            packageVersion: $645cfbe307315b4f$var$packageVersion
        }
    })
})($645cfbe307315b4f$export$8cc1aba0d1f32313));

});
parcelRegister("bvbsM", function(module, exports) {

$parcel$export(module.exports, "FixedLayerMenu", () => $a097a917e7430d98$export$982ad994195b4356);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $jQxSL = parcelRequire("jQxSL");

var $isGDw = parcelRequire("isGDw");
const $a097a917e7430d98$export$982ad994195b4356 = ({ selectProps: selectProps, ...rest })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $isGDw.default), {
        inputValue: selectProps.inputValue,
        containerRef: selectProps.fixedLayerRef,
        content: /*#__PURE__*/ (0, $byn9U.jsx)((0, $jQxSL.c).Menu, {
            ...rest,
            menuShouldScrollIntoView: false
        }),
        testId: selectProps.testId
    });

});

parcelRegister("2sLgt", function(module, exports) {

$parcel$export(module.exports, "default", () => $092a929414a015af$export$2e2bcd8739ae039);
const $092a929414a015af$var$map24 = {
    '12': '12',
    '01': '13',
    '02': '14',
    '03': '15',
    '04': '16',
    '05': '17',
    '06': '18',
    '07': '19',
    '08': '20',
    '09': '21',
    '10': '22',
    '11': '23'
};
function $092a929414a015af$export$1ea939691cdc45b8(timeString) {
    /**
	 * Regex match for `12:34`, `12:34:56`, `1:23:56 p`, `1:23:56PM`, and a bit more…
	 */ const time = timeString.trim().match(/([012]?[\d])(?::([0-5][\d]))?(?::([0-5][\d]))?\s*([ap]m?)?/i);
    /**
	 * Regex match for `1234`, `12:34`, `12.34`, `123456`, `12:34:56`, `12.34.56`
	 */ const time24hr = timeString.trim().match(/([012][\d])[:.]?([0-5][\d])([:.]?([0-5][\d]))?/);
    /**
	 * Convert `2:34:56 pm` down to `23456`
	 */ const num = timeString.replace(/[^0-9]/g, '');
    const includesSeconds = time && time[1] !== undefined && time[2] !== undefined && time[3] !== undefined || time24hr && time24hr[1] !== undefined && time24hr[2] !== undefined && time24hr[4] !== undefined;
    if (!time && !time24hr) return false;
    if (time && !time[1]) return false;
    if (num.length > 6) return false;
    if (num.length > 4 && !includesSeconds) return false;
    if (num.length === 2 && parseInt(num, 10) > 12) return false;
    return true;
}
function $092a929414a015af$export$49c81d9f91c512ce(time) {
    return time.replace(/[:.]/g, '');
}
function $092a929414a015af$export$c38a243baf9c6083(time) {
    if (time.length === 1) return `0${time}00`;
    if (time.length === 2) return `${time}00`;
    if (time.length === 3 || time.length === 5) return `0${time}`;
    return time;
}
function $092a929414a015af$export$ed20539f7181c701(hour, meridiem) {
    if (hour > '24') return null;
    if (hour === '12' && meridiem === 'a') return '00';
    if (hour < '12' && meridiem === 'p') return $092a929414a015af$var$map24[hour];
    return hour;
}
function $092a929414a015af$export$4077529dfc44a251(value) {
    if (value > '59') return null;
    return value;
}
function $092a929414a015af$export$6137ce2c9c5166bb(time) {
    const timeArray = time.toLowerCase().split(/(p|a)/i);
    const meridiem = timeArray[1];
    const semi24 = $092a929414a015af$export$c38a243baf9c6083(timeArray[0].trim());
    const hour = $092a929414a015af$export$ed20539f7181c701(semi24.substring(0, 2), meridiem);
    const minute = $092a929414a015af$export$4077529dfc44a251(semi24.substring(2, 4));
    const seconds = semi24.length === 6 && $092a929414a015af$export$4077529dfc44a251(semi24.substring(4, 6));
    if (!hour || !minute) return null;
    return {
        hour: parseInt(hour, 10),
        minute: parseInt(minute, 10),
        seconds: parseInt(seconds || '0', 10) || 0
    };
}
function $092a929414a015af$export$865db99128311580(time) {
    const dateTime = new Date();
    dateTime.setHours(time.hour);
    dateTime.setMinutes(time.minute);
    // milliseconds is not supported
    dateTime.setSeconds(time.seconds || 0, 0);
    return dateTime;
}
function $092a929414a015af$export$2e2bcd8739ae039(time) {
    const trimmedTime = time.toString().trim();
    if (!$092a929414a015af$export$1ea939691cdc45b8(trimmedTime)) throw RangeError('invalid time format');
    const time1 = $092a929414a015af$export$49c81d9f91c512ce(trimmedTime);
    const time2 = $092a929414a015af$export$6137ce2c9c5166bb(time1);
    if (!time2) throw RangeError('invalid time format');
    return $092a929414a015af$export$865db99128311580(time2);
}

});



parcelRegister("iPvRp", function(module, exports) {

$parcel$export(module.exports, "default", () => $602440b5c7905892$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $602440b5c7905892$export$2e2bcd8739ae039 = [
    '00:00',
    '00:30',
    '01:00',
    '01:30',
    '02:00',
    '02:30',
    '03:00',
    '03:30',
    '04:00',
    '04:30',
    '05:00',
    '05:30',
    '06:00',
    '06:30',
    '07:00',
    '07:30',
    '08:00',
    '08:30',
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00',
    '18:30',
    '19:00',
    '19:30',
    '20:00',
    '20:30',
    '21:00',
    '21:30',
    '22:00',
    '22:30',
    '23:00',
    '23:30'
];

});

parcelRegister("bmG61", function(module, exports) {

$parcel$export(module.exports, "TimeEstimate", () => $c369b045954c6d99$export$ad441edf1beb0bda);

var $eUqFw = parcelRequire("eUqFw");

var $7jPhn = parcelRequire("7jPhn");

var $5YsMl = parcelRequire("5YsMl");

var $cf2Y4 = parcelRequire("cf2Y4");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7Ymv3 = parcelRequire("7Ymv3");

var $2jdHI = parcelRequire("2jdHI");

var $jqduH = parcelRequire("jqduH");

var $2MRyB = parcelRequire("2MRyB");
const $c369b045954c6d99$export$ad441edf1beb0bda = (props)=>{
    const { value: value, placeholder: placeholder = '2w 1d 5h 4m', onChange: onChange, config: config, shouldShowWarning: shouldShowWarning, fieldId: fieldId, ...fieldProps } = props;
    const [isIncorrectTimeFormat, setIsIncorrectTimeFormat] = (0, $eUqFw.useState)(false);
    const [debouncedIsValidTimeString] = (0, $2jdHI.default)((inputValue)=>setIsIncorrectTimeFormat(!(0, $7Ymv3.isValidTimeString)(config)(inputValue)), 500);
    (0, $eUqFw.useEffect)(()=>{
        debouncedIsValidTimeString(value);
    }, [
        value,
        debouncedIsValidTimeString
    ]);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onValueChange = (e)=>{
        const { value: inputValue } = e.target;
        onChange(inputValue);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
        ...fieldProps,
        testId: (0, $2MRyB.DATA_TEST_IDS).TEXT_FIELD,
        ...fieldId && {
            'aria-describedby': `${fieldId}-field-message`
        },
        type: "text",
        value: value,
        placeholder: placeholder,
        onChange: onValueChange,
        isInvalid: isIncorrectTimeFormat,
        elemAfterInput: shouldShowWarning === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
            content: formatMessage((0, $jqduH.default).timeLoggedExceeded),
            testId: (0, $2MRyB.DATA_TEST_IDS).TOOLTIP
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
            size: "medium",
            label: formatMessage((0, $jqduH.default).warning),
            primaryColor: `var(--ds-icon-warning, ${(0, $PdmhA).Y300})`,
            testId: (0, $2MRyB.DATA_TEST_IDS).WARNING_ICON
        })) : null
    }), isIncorrectTimeFormat && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), {
        testId: (0, $2MRyB.DATA_TEST_IDS).ERROR_MESSAGE
    }, formatMessage((0, $jqduH.default).invalidDateFormat)));
};

});
parcelRegister("jqduH", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bd461af00482493$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0bd461af00482493$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    invalidDateFormat: {
        "id": "issue-time-estimate.edit.invalid-date-format",
        "defaultMessage": "Please enter date in the correct format"
    },
    warning: {
        "id": "issue-time-estimate.edit.warning",
        "defaultMessage": "warning"
    },
    timeLoggedExceeded: {
        "id": "issue-time-estimate.edit.time-logged-exceeded",
        "defaultMessage": "Time logged has exceeded the limit"
    }
});

});

parcelRegister("2MRyB", function(module, exports) {

$parcel$export(module.exports, "DATA_TEST_IDS", () => $9a7955bbf6a6bcc3$export$3e5d0cbd910e9c20);

const $9a7955bbf6a6bcc3$var$getItemDataTestId = (itemId)=>`${0, $4561b6c706592e98$export$7c86105e5fb6a1ce}${itemId}`;
const $9a7955bbf6a6bcc3$export$96f42c00fe93c7cb = (itemDataTestId)=>`[data-testid="${itemDataTestId}"]`;
const $9a7955bbf6a6bcc3$export$3e5d0cbd910e9c20 = {
    TEXT_FIELD: $9a7955bbf6a6bcc3$var$getItemDataTestId('text-field'),
    TOOLTIP: $9a7955bbf6a6bcc3$var$getItemDataTestId('tooltip'),
    WARNING_ICON: $9a7955bbf6a6bcc3$var$getItemDataTestId('warning_icon'),
    ERROR_MESSAGE: $9a7955bbf6a6bcc3$var$getItemDataTestId('error-message')
};

});
const $4561b6c706592e98$export$94514aa565518249 = '1w 1m';
const $4561b6c706592e98$export$38009905af1d42b = 'Invalid data';
const $4561b6c706592e98$export$7c86105e5fb6a1ce = 'issue-time-estimate.ui.edit.';



const $4ba72bd5105a797f$export$d7ed3a061805d786 = 'log-work-time-remaining';
const $4ba72bd5105a797f$export$81fee17d19007357 = 'log-work-time-spent';
const $4ba72bd5105a797f$export$ade7f171d00a976f = 'log-work-date-field';
const $4ba72bd5105a797f$export$caca24db5cb49b68 = 'log-work-description';

parcelRegister("2kIWF", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3672e1eff23f1d8$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $a3672e1eff23f1d8$var$messages = (0, $90IgZ.defineMessages)({
    timeSpent: {
        "id": "issue-create-commons.log-work-field.time-spent",
        "defaultMessage": "Time Spent"
    },
    timeRemaining: {
        "id": "issue-create-commons.log-work-field.time-remaining",
        "defaultMessage": "Time Remaining"
    },
    dateStarted: {
        "id": "issue-create-commons.log-work-field.date-started",
        "defaultMessage": "Date Started"
    },
    description: {
        "id": "issue-create-commons.log-work-field.description",
        "defaultMessage": "Work Description"
    },
    originalEstimateExceededNonFinal: {
        "id": "issue-create-commons.log-work-field.original-estimate-exceeded-non-final",
        "defaultMessage": "Time logged has exceeded the original estimate"
    },
    logWorkLabel: {
        "id": "issue-create-commons.log-work-field.log-work-label",
        "defaultMessage": "Log Work"
    }
});
var $a3672e1eff23f1d8$export$2e2bcd8739ae039 = $a3672e1eff23f1d8$var$messages;

});



parcelRegister("bXFdm", function(module, exports) {

$parcel$export(module.exports, "ParentLinkField", () => $bb06b239441201ed$export$79fe3354f3cc0f9b);

var $eUqFw = parcelRequire("eUqFw");

var $96Bq5 = parcelRequire("96Bq5");
const $bb06b239441201ed$export$79fe3354f3cc0f9b = ({ useFormContext: useFormContext, ...commonParentLinkFieldProps })=>{
    const [{ isEpicLinkSelected: isEpicLinkSelected, selectedIssueType: selectedIssueType, requestBackedIssueType: requestBackedIssueType }] = useFormContext();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $96Bq5.default), {
        ...commonParentLinkFieldProps,
        isEpicLinkSelected: isEpicLinkSelected,
        selectedIssueTypeLabel: requestBackedIssueType?.label ?? selectedIssueType?.label ?? '',
        selectedIssueTypeId: requestBackedIssueType?.value ?? selectedIssueType?.value ?? ''
    });
};

});
parcelRegister("96Bq5", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a1219cc09006596$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7DOGj = parcelRequire("7DOGj");

var $icPhQ = parcelRequire("icPhQ");
var $5i7Lk = parcelRequire("5i7Lk");
var $6HoNR = parcelRequire("6HoNR");

var $6mXeo = parcelRequire("6mXeo");

var $7TaJX = parcelRequire("7TaJX");

var $1CAsi = parcelRequire("1CAsi");

var $g9RGQ = parcelRequire("g9RGQ");
const $8a1219cc09006596$var$ParentLinkField = (props)=>{
    const { fieldId: fieldId, fieldName: fieldName, autoCompleteUrl: autoCompleteUrl = '', fieldProps: { value: value = null, onChange: onChange }, width: width, autoFocus: autoFocus = false, onCloseMenuOnScroll: // @ts-expect-error - TS2339 - Property 'onCloseMenuOnScroll' does not exist on type 'Props'.
    onCloseMenuOnScroll = (0, $7TaJX.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, selectedProject: selectedProject, selectedIssueTypeLabel: selectedIssueTypeLabel, selectedIssueTypeId: selectedIssueTypeId, isEpicLinkSelected: isEpicLinkSelected, isEditable: isEditable = true, nonEditableReason: nonEditableReason, isMini: isMini } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [description, setDescription] = (0, $eUqFw.useState)('');
    (0, $eUqFw.useEffect)(()=>{
        if (isEpicLinkSelected) setDescription(formatMessage((0, $1CAsi.default).tooltip));
        else if (isEditable === false) setDescription(nonEditableReason?.message || '');
    }, [
        description,
        isEditable,
        isEpicLinkSelected,
        formatMessage,
        nonEditableReason?.message
    ]);
    const shouldDisableParentLink = ()=>isEditable === false || isEpicLinkSelected === true;
    // We are disabling the Epic Link and Parent Link fields for taking input and instead displaying that the user should
    // use the Parent field to set the Parent of the issue as part of migrating to a single way of representing Jira's hierarchy.
    return (0, $1ybV0.ff)('disable-epic-link-and-parent-link-fields-in-issue-view-and-gic_zixrt') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6mXeo.DisabledEpicLinkParentLinkField), null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7DOGj.ParentLinkFieldEdit), {
        fieldId: fieldId,
        value: value,
        onChange: onChange,
        isDisabled: shouldDisableParentLink(),
        autoFocus: autoFocus,
        autoCompleteUrl: autoCompleteUrl,
        onCloseMenuOnScroll: onCloseMenuOnScroll,
        isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered,
        selectedProjectId: selectedProject ? selectedProject.value : '',
        selectedIssueTypeLabel: selectedIssueTypeLabel,
        selectedIssueTypeId: selectedIssueTypeId,
        fetchSuggestionsOnFocus: true
    }), shouldDisableParentLink() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5i7Lk.FieldMessage), {
        fieldName: fieldName,
        description: description,
        isMini: isMini
    }));
};
var $8a1219cc09006596$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    validator: (0, $g9RGQ.validateParentLinkField)
})($8a1219cc09006596$var$ParentLinkField);

});
parcelRegister("7DOGj", function(module, exports) {

$parcel$export(module.exports, "ParentLinkFieldEdit", () => $b5661fa789317657$export$c08d12ab41b389e);

var $eUqFw = parcelRequire("eUqFw");

var $fm9CZ = parcelRequire("fm9CZ");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4NcaX = parcelRequire("4NcaX");
var $bKilX = parcelRequire("bKilX");

var $fO0l8 = parcelRequire("fO0l8");

var $23m7R = parcelRequire("23m7R");

var $d9J6H = parcelRequire("d9J6H");
const $b5661fa789317657$var$LOAD_OPTIONS_DEBOUNCE_TIMER = 300;
const $b5661fa789317657$export$c08d12ab41b389e = (props)=>{
    const { classNamePrefix: classNamePrefix, fieldId: fieldId, autoCompleteUrl: autoCompleteUrl, autoFocus: autoFocus, value: value = null, onChange: onChange, onCloseMenuOnScroll: onCloseMenuOnScroll, isDisabled: isDisabled, isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered, isInvalid: isInvalid = false, selectedProjectId: selectedProjectId, selectedIssueTypeLabel: selectedIssueTypeLabel, selectedIssueTypeId: selectedIssueTypeId, fetchSuggestionsOnFocus: fetchSuggestionsOnFocus = false } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [lastFetchFailed, setLastFetchFailed] = (0, $eUqFw.useState)(false);
    const [defaultOptions, setDefaultOptions] = (0, $eUqFw.useState)([]);
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const shouldFetchDefaultOptions = (0, $eUqFw.useRef)(true);
    const searchParentLinks = (0, $eUqFw.useCallback)(async (query = '')=>{
        setLastFetchFailed(false);
        try {
            const fetchedOptions = await (0, $d9J6H.fetchParentLinks)({
                query: query,
                autoCompleteUrl: autoCompleteUrl,
                selectedProjectId: selectedProjectId,
                selectedIssueTypeLabel: selectedIssueTypeLabel,
                selectedIssueTypeId: selectedIssueTypeId
            });
            return fetchedOptions;
        } catch  {
            setLastFetchFailed(true);
            return [];
        }
    }, [
        autoCompleteUrl,
        selectedProjectId,
        selectedIssueTypeLabel,
        selectedIssueTypeId
    ]);
    const loadOptionsDebounced = (0, $fO0l8.default)(searchParentLinks, $b5661fa789317657$var$LOAD_OPTIONS_DEBOUNCE_TIMER);
    const getNoOptionsMessage = (0, $eUqFw.useCallback)(()=>formatMessage(lastFetchFailed ? (0, $23m7R.default).failedFetch : (0, $23m7R.default).noMatches), [
        formatMessage,
        lastFetchFailed
    ]);
    const onFocus = async ()=>{
        if (shouldFetchDefaultOptions && defaultOptions && shouldFetchDefaultOptions.current && !defaultOptions.length) {
            shouldFetchDefaultOptions.current = false;
            setIsLoading && setIsLoading(true);
            const options = await searchParentLinks();
            setDefaultOptions && setDefaultOptions(options);
            setIsLoading && setIsLoading(false);
        }
    };
    const defaultOptionsProps = ()=>{
        if (fetchSuggestionsOnFocus) return {
            onFocus: onFocus,
            isLoading: isLoading,
            defaultOptions: defaultOptions
        };
        return {};
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fm9CZ.default), {
        classNamePrefix: classNamePrefix,
        fieldId: fieldId,
        autoFocus: autoFocus,
        ...defaultOptionsProps(),
        loadOptions: loadOptionsDebounced,
        isClearable: true,
        isDisabled: isDisabled,
        value: value,
        // @ts-expect-error - TS2322 - Type '(value: Option) => void' is not assignable to type '(value: Option | null, action: ActionMeta<Option>) => void'.
        onChange: onChange,
        // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
        validationState: isInvalid === true ? 'error' : null,
        noOptionsMessage: getNoOptionsMessage,
        placeholder: formatMessage((0, $23m7R.default).placeholder),
        // @ts-expect-error - TS2322 - Type '((e: ChangeEvent<HTMLElement>) => boolean) | undefined' is not assignable to type 'boolean | EventListener | undefined'.
        closeMenuOnScroll: onCloseMenuOnScroll,
        menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        styles: (0, $4NcaX.defaultSelectStyles),
        formatOptionLabel: (0, $bKilX.formatOptionLabel)
    });
};

});
parcelRegister("23m7R", function(module, exports) {

$parcel$export(module.exports, "default", () => $80c9fbb263f91ffc$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $80c9fbb263f91ffc$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noMatches: {
        "id": "issue-field-parent-link.edit.no-matches",
        "defaultMessage": "No matches"
    },
    failedFetch: {
        "id": "issue-field-parent-link.edit.failed-fetch",
        "defaultMessage": "Search failed. Please try again."
    },
    placeholder: {
        "id": "issue-field-parent-link.edit.placeholder",
        "defaultMessage": "Select parent link"
    },
    loading: {
        "id": "issue-field-parent-link.edit.loading",
        "defaultMessage": "Searching..."
    }
});

});

parcelRegister("d9J6H", function(module, exports) {

$parcel$export(module.exports, "fetchParentLinks", () => $2fd46107c73c3080$export$d26b267ed079ac07);

var $guiFP = parcelRequire("guiFP");

var $7byHA = parcelRequire("7byHA");
var $lRmyA = parcelRequire("lRmyA");

var $aFVOZ = parcelRequire("aFVOZ");
const $2fd46107c73c3080$export$d26b267ed079ac07 = async (props)=>{
    const { query: query, autoCompleteUrl: autoCompleteUrl, selectedProjectId: selectedProjectId, selectedIssueTypeLabel: selectedIssueTypeLabel, selectedIssueTypeId: selectedIssueTypeId } = props;
    const requestPayloadWithIssueTypeName = {
        query: query,
        issueTypeName: selectedIssueTypeLabel,
        projectId: selectedProjectId,
        maxResults: 50
    };
    const requestPayloadWithIssueTypeId = {
        query: query,
        issueTypeId: selectedIssueTypeId,
        projectId: selectedProjectId,
        maxResults: 50
    };
    try {
        const response = await (0, $lRmyA.performPostRequest)(autoCompleteUrl, {
            body: JSON.stringify(selectedIssueTypeId !== '' ? requestPayloadWithIssueTypeId : requestPayloadWithIssueTypeName)
        });
        return (0, $aFVOZ.mapDataToOptions)(response);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.trackFetchErrors)({
            error: error,
            id: 'fetchParentLinks',
            packageName: 'jiraIssueFieldParentLink',
            logToSentry: !(0, $7byHA.isValidationError)(error),
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});


parcelRegister("1CAsi", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfe10e7ba11d805b$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $dfe10e7ba11d805b$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    tooltip: {
        "id": "issue-create-commons.parent-link-field.tooltip",
        "defaultMessage": "Can only link a parent to issues without a linked epic."
    }
});

});

parcelRegister("g9RGQ", function(module, exports) {

$parcel$export(module.exports, "validateParentLinkField", () => $770421b06f8a53e9$export$7c8f88cf8f7b8100);

var $dEMIg = parcelRequire("dEMIg");
const $770421b06f8a53e9$export$7c8f88cf8f7b8100 = (data, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (!data) return 0, $dEMIg.REQUIRED;
    }
    return undefined;
};

});



parcelRegister("2RvjE", function(module, exports) {

$parcel$export(module.exports, "default", () => $921a9c8183ad9cc4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5wCDk = parcelRequire("5wCDk");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7TaJX = parcelRequire("7TaJX");
var $icPhQ = parcelRequire("icPhQ");
var $6HoNR = parcelRequire("6HoNR");

var $4NcaX = parcelRequire("4NcaX");
var $bKilX = parcelRequire("bKilX");

var $8JFzp = parcelRequire("8JFzp");

var $1S8gB = parcelRequire("1S8gB");
const $921a9c8183ad9cc4$var$SecurityLevelField = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { fieldId: fieldId, fieldProps: { value: value = [], onChange: onChange, ...fieldProps }, error: error, allowedValues: allowedValues, width: width, autoFocus: autoFocus = false, onCloseMenuOnScroll: onCloseMenuOnScroll = (0, $7TaJX.closeMenuOnScroll), isDropdownMenuFixedAndLayered: isDropdownMenuFixedAndLayered = false, isEditable: isEditable = true, nonEditableReason: nonEditableReason, inputId: inputId } = props;
    const option = (0, $1S8gB.mapOptionsToData)(allowedValues);
    const isInvalid = Boolean(error);
    const getSecurityLevelField = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
            inputId: inputId,
            ...fieldProps,
            options: option,
            // @ts-expect-error - TS2322 - Type '(value: SecurityLevelOption) => void' is not assignable to type '(value: Option | null, action: ActionMeta<Option>) => void'.
            onChange: onChange,
            value: value,
            placeholder: formatMessage((0, $8JFzp.default).securityLevelFieldPlaceHolder),
            isClearable: true,
            formatOptionLabel: (0, $bKilX.formatOptionLabel),
            menuPosition: isDropdownMenuFixedAndLayered === true ? 'fixed' : undefined,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            styles: (0, $4NcaX.defaultSelectStyles),
            hideSelectedOptions: false,
            isMulti: false,
            autoFocus: autoFocus,
            // @ts-expect-error - TS2322 - Type '"error" | null' is not assignable to type 'ValidationState | undefined'.
            validationState: isInvalid === true ? 'error' : null,
            classNamePrefix: `select-${fieldId}`,
            // @ts-expect-error - TS2322 - Type '(e: ChangeEvent<HTMLElement>) => boolean' is not assignable to type 'boolean | EventListener | undefined'.
            closeMenuOnScroll: onCloseMenuOnScroll,
            isDisabled: isEditable === false
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, isEditable === false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: nonEditableReason?.message || ''
    }, getSecurityLevelField()) : getSecurityLevelField());
};
var $921a9c8183ad9cc4$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    transformDefaultValue: (0, $1S8gB.mapOptionToData)
})($921a9c8183ad9cc4$var$SecurityLevelField);

});
parcelRegister("8JFzp", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd2ef5933324fafd$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $cd2ef5933324fafd$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    securityLevelFieldPlaceHolder: {
        "id": "issue-create.common.fields.security-level-field.security-level-field-place-holder",
        "defaultMessage": "Select Security Level"
    }
});

});

parcelRegister("1S8gB", function(module, exports) {

$parcel$export(module.exports, "transformOnSubmit", () => $944051eb3bdd6988$export$33ec7c3df92f1cc6);
$parcel$export(module.exports, "mapOptionsToData", () => $944051eb3bdd6988$export$ffef3a401aef987b);
$parcel$export(module.exports, "mapOptionToData", () => $944051eb3bdd6988$export$fc800909123977f3);
$parcel$export(module.exports, "mutateSecurityLevelField", () => $944051eb3bdd6988$export$f62a060ad7017e66);
const $944051eb3bdd6988$export$33ec7c3df92f1cc6 = (option)=>{
    const { label: label, value: value } = option;
    return {
        name: label,
        id: value
    };
};
const $944051eb3bdd6988$export$ffef3a401aef987b = (options)=>options.map(({ name: name, id: id, description: description })=>({
            label: name,
            value: id,
            description: description
        }));
const $944051eb3bdd6988$export$fc800909123977f3 = (option)=>{
    if (option) {
        const { name: name, id: id, description: description } = option;
        return {
            label: name,
            value: id,
            description: description
        };
    }
    return null;
};
const $944051eb3bdd6988$export$f62a060ad7017e66 = (selectedSecurityLevel)=>({
        security: {
            securityLevelId: selectedSecurityLevel.value
        }
    });

});


parcelRegister("bjDIF", function(module, exports) {

$parcel$export(module.exports, "default", () => $aecb8a8a6941b970$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $icPhQ = parcelRequire("icPhQ");
var $1MvT6 = parcelRequire("1MvT6");

var $fswni = parcelRequire("fswni");
parcelRequire("7Ymv3");
var $734NL = parcelRequire("734NL");

var $i8z7b = parcelRequire("i8z7b");

var $f34jc = parcelRequire("f34jc");
const $aecb8a8a6941b970$var$TimeTrackingField = (props)=>{
    // the reason we are transforming the default value here instead of options object in the with form field wrapper is because time tracking settings also need to be passed to transform the default value. Right now, there is no way to pass props to the generic transformDefaultValue invocation in with form field
    const [transformedDefaultValue, setTransformedDefaultValue] = (0, $eUqFw.useState)(undefined);
    const { defaultValue: defaultValue, additionalData: { timeTrackingSettings: timeTrackingSettings }, width: width = 350, isMini: isMini, isFieldResponsive: isFieldResponsive } = props;
    (0, $eUqFw.useEffect)(()=>{
        if (typeof defaultValue === 'string') setTransformedDefaultValue(defaultValue.trim());
        else if (defaultValue?.timeInSeconds) setTransformedDefaultValue((0, $734NL.default)(timeTrackingSettings.daysPerWeek, timeTrackingSettings.hoursPerDay)(defaultValue.timeInSeconds));
    }, [
        defaultValue,
        timeTrackingSettings.hoursPerDay,
        timeTrackingSettings.daysPerWeek
    ]);
    const [, { setTimeTrackingValue: setTimeTrackingValue }] = (0, $fswni.useFormContext)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const shouldSetWidth = (0, $1ybV0.ff)('gic-smart-fields-jira-labs_8uwvr') ? isMini || isFieldResponsive : isMini;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: shouldSetWidth ? '100%' : width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1MvT6.default), {
        ...props,
        fieldName: formatMessage((0, $i8z7b.default).timeTrackingFieldName),
        defaultValue: transformedDefaultValue,
        setValueExternal: setTimeTrackingValue
    }));
};
var $aecb8a8a6941b970$export$2e2bcd8739ae039 = $aecb8a8a6941b970$var$TimeTrackingField;

});
parcelRegister("1MvT6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1edd56ace3502a9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $bmG61 = parcelRequire("bmG61");

var $6HoNR = parcelRequire("6HoNR");

var $3m7PU = parcelRequire("3m7PU");
const $a1edd56ace3502a9$export$1c882bff9d1eb3f8 = (props)=>{
    const { fieldProps: { value: value = '', onChange: onChange, ...fieldProps }, setValueExternal: setValueExternal, additionalData: { timeTrackingSettings: config }, fieldId: fieldId } = props;
    const onTimeEstimateChange = (timeEstimateValue)=>{
        onChange(timeEstimateValue);
        setValueExternal(timeEstimateValue);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bmG61.TimeEstimate), {
        ...fieldProps,
        fieldId: fieldId,
        value: value,
        onChange: onTimeEstimateChange,
        config: config
    });
};
var $a1edd56ace3502a9$export$2e2bcd8739ae039 = (0, $6HoNR.withFormField)({
    validator: (0, $3m7PU.validateTimeTrackingField)
})($a1edd56ace3502a9$export$1c882bff9d1eb3f8);

});
parcelRegister("3m7PU", function(module, exports) {

$parcel$export(module.exports, "validateTimeTrackingField", () => $dcba93f8a6e86714$export$8efa03d1ab1ed811);

var $dEMIg = parcelRequire("dEMIg");
const $dcba93f8a6e86714$export$8efa03d1ab1ed811 = (value, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
isRequired)=>{
    if (isRequired) {
        if (value === '' || value === undefined) return 0, $dEMIg.REQUIRED;
    }
    return undefined;
};

});


parcelRegister("i8z7b", function(module, exports) {

$parcel$export(module.exports, "default", () => $abd21485727d40f9$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $abd21485727d40f9$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    timeTrackingFieldName: {
        "id": "issue-create.common.fields.time-tracking-field.time-tracking-field-name",
        "defaultMessage": "Original Estimate"
    }
});

});

parcelRegister("f34jc", function(module, exports) {

$parcel$export(module.exports, "transformTimeTrackingValueToSubmitFormat", () => $51539e6d072a9606$export$d089c9dd815e4fcf);
$parcel$export(module.exports, "mutateTimeTrackingField", () => $51539e6d072a9606$export$9b1f0b2fd734a97);
const $51539e6d072a9606$export$d089c9dd815e4fcf = (value)=>({
        originalEstimate: value
    });
const $51539e6d072a9606$export$9b1f0b2fd734a97 = (estimate)=>({
        timeTrackingField: {
            originalEstimate: estimate
        }
    });

});



parcelRegister("aJRvJ", function(module, exports) {

$parcel$export(module.exports, "transformProjects", () => $c35bd42c33d9df9d$export$227473965d2e27db);
$parcel$export(module.exports, "transformProjectField", () => $c35bd42c33d9df9d$export$1fd74e5690ffdae3);
$parcel$export(module.exports, "transformIssueTypeField", () => $c35bd42c33d9df9d$export$ab55267390bbb31a);
$parcel$export(module.exports, "transformRequestTypeField", () => $c35bd42c33d9df9d$export$fdb2672a21ca2149);

var $illlw = parcelRequire("illlw");


var $fFvAc = parcelRequire("fFvAc");
const $c35bd42c33d9df9d$export$b4c0e0af0a6f8454 = ({ id: id, name: name, avatar: avatar, projectType: projectType, simplified: simplified, key: key, classificationTags: classificationTags = [] })=>({
        label: `${name} (${key})`,
        value: id,
        iconUrl: avatar.large,
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'ProjectType'.
        projectType: projectType && projectType.toLowerCase(),
        projectKey: key,
        isSimplified: simplified,
        classificationTags: classificationTags
    });
const $c35bd42c33d9df9d$export$227473965d2e27db = (projects)=>projects.map((project)=>$c35bd42c33d9df9d$export$b4c0e0af0a6f8454(project));
const $c35bd42c33d9df9d$export$1fd74e5690ffdae3 = (projectResponse)=>{
    const { project: project, ...rest } = projectResponse;
    return {
        ...rest,
        selectedProject: project ? $c35bd42c33d9df9d$export$b4c0e0af0a6f8454(project) : null
    };
};
const $c35bd42c33d9df9d$export$b1a9eea64f6538d1 = ({ id: id, name: name, avatar: avatar })=>({
        label: name,
        value: id,
        iconUrl: avatar.large,
        type: (0, $8b8bfa076f313cc4$export$ebb48b08205007c5)
    });
const $c35bd42c33d9df9d$export$4c05e2584b34e4d8 = (issueTypes)=>issueTypes.map((issueType)=>$c35bd42c33d9df9d$export$b1a9eea64f6538d1(issueType));
const $c35bd42c33d9df9d$export$ab55267390bbb31a = (issueTypeResponse)=>{
    const { issueType: issueType, ...rest } = issueTypeResponse;
    const issueTypes = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(issueTypeResponse, 'issueTypes.nodes', []);
    return {
        ...rest,
        selectedIssueType: issueType ? $c35bd42c33d9df9d$export$b1a9eea64f6538d1(issueType) : null,
        issueTypes: $c35bd42c33d9df9d$export$4c05e2584b34e4d8(issueTypes)
    };
};
const $c35bd42c33d9df9d$export$566fd29819ab2bab = ({ requestTypeId: requestTypeId, name: name, description: description, helpText: helpText, key: key, avatar: avatar, issueType: { issueTypeId: issueTypeId, issueTypeName: issueTypeName }, practices: practices }, hasPractice)=>({
        label: name,
        description: description || '',
        helpText: helpText || '',
        value: `${issueTypeId}-${requestTypeId}`,
        iconUrl: (0, $fFvAc.transformStargateUrl)(avatar.large || ''),
        requestTypeKey: key,
        issueTypeId: issueTypeId,
        issueTypeName: issueTypeName,
        practice: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(practices, '0.key', hasPractice ? (0, $8b8bfa076f313cc4$export$c835df30ebbd529d) : (0, $8b8bfa076f313cc4$export$92ab80c1dc9baf44)),
        type: (0, $8b8bfa076f313cc4$export$92ab80c1dc9baf44)
    });
const $c35bd42c33d9df9d$export$d3b8217e83b5a13c = (requestTypes)=>{
    const hasPractice = requestTypes.some((rt)=>rt.practices.length > 0);
    // sort request types alphabetically
    return requestTypes.map((requestType)=>$c35bd42c33d9df9d$export$566fd29819ab2bab(requestType, hasPractice)).sort((a, b)=>a.label.localeCompare(b.label));
};
const $c35bd42c33d9df9d$export$fdb2672a21ca2149 = (requestTypeResponse)=>{
    const { requestType: requestType, ...rest } = requestTypeResponse;
    const requestTypes = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(requestTypeResponse, 'requestTypes.nodes', []);
    const hasPractice = requestTypes.some((rt)=>rt.practices.length > 0);
    return {
        ...rest,
        selectedRequestType: requestType ? $c35bd42c33d9df9d$export$566fd29819ab2bab(requestType, hasPractice) : null,
        requestTypes: $c35bd42c33d9df9d$export$d3b8217e83b5a13c(requestTypes)
    };
};

});

parcelRegister("2yhuM", function(module, exports) {

$parcel$export(module.exports, "getGqlUnsupportedFields", () => $fb4d11b207745e0b$export$3e4be29f4f96b2d7);
$parcel$export(module.exports, "getQueryErrorMessage", () => $fb4d11b207745e0b$export$778f621df988f2dc);

var $illlw = parcelRequire("illlw");

const $fb4d11b207745e0b$export$3e4be29f4f96b2d7 = (errors)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const unsupportedFields = {};
    let isRequiredFieldTypeSupported = true;
    errors.forEach(({ identifier: identifier, extensions: extensions })=>{
        const { __typename: gqlType } = extensions[0] || {};
        if (gqlType === (0, $8b8bfa076f313cc4$export$b171488d52070cb3) && // @ts-expect-error - TS2339 - Property 'fieldName' does not exist on type '{ fieldName: string; fieldType: string; isRequiredField: boolean; isUserPreferredField: boolean; __typename: "JiraIssueFieldUnsupportedErrorExtension"; } | { errorType: string; message: string; __typename: "JiraIssueFieldValueValidationErrorExtension"; }'.
        typeof extensions[0].fieldName === 'string' && // @ts-expect-error - TS2339 - Property 'isRequiredField' does not exist on type '{ fieldName: string; fieldType: string; isRequiredField: boolean; isUserPreferredField: boolean; __typename: "JiraIssueFieldUnsupportedErrorExtension"; } | { errorType: string; message: string; __typename: "JiraIssueFieldValueValidationErrorExtension"; }'.
        typeof extensions[0].isRequiredField === 'boolean' && // @ts-expect-error - TS2339 - Property 'fieldType' does not exist on type '{ fieldName: string; fieldType: string; isRequiredField: boolean; isUserPreferredField: boolean; __typename: "JiraIssueFieldUnsupportedErrorExtension"; } | { errorType: string; message: string; __typename: "JiraIssueFieldValueValidationErrorExtension"; }'.
        typeof extensions[0].fieldType === 'string') {
            // @ts-expect-error - TS2339 - Property 'fieldName' does not exist on type '{ fieldName: string; fieldType: string; isRequiredField: boolean; isUserPreferredField: boolean; __typename: "JiraIssueFieldUnsupportedErrorExtension"; } | { errorType: string; message: string; __typename: "JiraIssueFieldValueValidationErrorExtension"; }'. | TS2339 - Property 'fieldType' does not exist on type '{ fieldName: string; fieldType: string; isRequiredField: boolean; isUserPreferredField: boolean; __typename: "JiraIssueFieldUnsupportedErrorExtension"; } | { errorType: string; message: string; __typename: "JiraIssueFieldValueValidationErrorExtension"; }'. | TS2339 - Property 'isRequiredField' does not exist on type '{ fieldName: string; fieldType: string; isRequiredField: boolean; isUserPreferredField: boolean; __typename: "JiraIssueFieldUnsupportedErrorExtension"; } | { errorType: string; message: string; __typename: "JiraIssueFieldValueValidationErrorExtension"; }'.
            const { fieldName: fieldName, fieldType: fieldType, isRequiredField: isRequiredField } = extensions[0];
            unsupportedFields[identifier] = {
                gqlType: gqlType,
                fieldId: identifier,
                fieldName: fieldName,
                fieldType: fieldType,
                isRequired: isRequiredField
            };
            if (isRequiredField) isRequiredFieldTypeSupported = false;
        }
    });
    return {
        unsupportedFields: unsupportedFields,
        isRequiredFieldTypeSupported: isRequiredFieldTypeSupported
    };
};
const $fb4d11b207745e0b$export$778f621df988f2dc = (data)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const gqlIssueCreateFieldsType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(data, 'jiraIssueCreateFields.__typename', '');
    const queryErrorMessage = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(data, 'jiraIssueCreateFields.message', '');
    if (gqlIssueCreateFieldsType === (0, $8b8bfa076f313cc4$export$6c8cb487d6ffc522) && Boolean(queryErrorMessage)) return queryErrorMessage;
    const gqlIssueCreateLayoutType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(data, 'jiraIssueCreateLayout.__typename', '');
    const issueCreateFieldsQueryErrorMessage = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(data, 'jiraIssueCreateFields.errors[0].extensions[0].message', '');
    if (gqlIssueCreateLayoutType === (0, $8b8bfa076f313cc4$export$6c8cb487d6ffc522) && Boolean(issueCreateFieldsQueryErrorMessage)) return issueCreateFieldsQueryErrorMessage;
    return '';
};

});

parcelRegister("amtY1", function(module, exports) {

$parcel$export(module.exports, "overrideGqlTypes", () => $51316a4f3cd741dc$export$f03f31ea9e8359e8);

var $1ybV0 = parcelRequire("1ybV0");

var $lO4Or = parcelRequire("lO4Or");

const $51316a4f3cd741dc$export$f03f31ea9e8359e8 = (fieldData)=>{
    const { type: type, __typename: gqlType, renderer: renderer } = fieldData || {};
    if (gqlType === (0, $b1ba189bc6d9d9ad$export$3849bb04b4eee607) && type === (0, $lO4Or.ASSIGNEE_TYPE)) return 0, $b1ba189bc6d9d9ad$export$f7a08bf17a7ac661;
    if (gqlType === (0, $b1ba189bc6d9d9ad$export$3849bb04b4eee607) && type === (0, $lO4Or.REPORTER_TYPE)) return 0, $b1ba189bc6d9d9ad$export$d64150fd9c66969c;
    if (gqlType === (0, $b1ba189bc6d9d9ad$export$1070aada56fcaec9) && type === (0, $lO4Or.EPIC_COLOR_TYPE)) return 0, $b1ba189bc6d9d9ad$export$f57941b9c1949a82;
    if (gqlType === (0, $b1ba189bc6d9d9ad$export$31a6c27df1f927b2) && type === (0, $lO4Or.MESSAGE_EDIT_CF_TYPE)) return 0, $b1ba189bc6d9d9ad$export$a138d5648dda03f0;
    if (gqlType === (0, $b1ba189bc6d9d9ad$export$31a6c27df1f927b2) || gqlType === (0, $b1ba189bc6d9d9ad$export$7a583e2ae9052377)) return renderer === 'atlassian-wiki-renderer' ? (0, $b1ba189bc6d9d9ad$export$31a6c27df1f927b2) : (0, $b1ba189bc6d9d9ad$export$95433ac963f4aebe);
    // we want to keep "JiraParentIssueField" jql name for PARENT_FIELD long term when PARENT_LINK_FIELD is depricated hence this override
    if ((0, $1ybV0.ff)('parent-field-in-gic_d3b3n') && gqlType === (0, $b1ba189bc6d9d9ad$export$670384150af5f49e) && type === (0, $lO4Or.PARENT_FIELD_TYPE)) return 0, $b1ba189bc6d9d9ad$export$bf9df74e065af482;
    return gqlType;
};

});


parcelRegister("9Oxdn", function(module, exports) {

$parcel$export(module.exports, "getCreateConfigUserPreferredQuery", () => $a89499ac81454cad$export$5181d52929b93430);
// eslint-disable-next-line jira/restricted/graphql-tag

var $9ypom = parcelRequire("9ypom");

var $1ybV0 = parcelRequire("1ybV0");

var $frihL = parcelRequire("frihL");
// eslint-disable-next-line jira/ff/inline-usage
const $a89499ac81454cad$var$isJsmRespondersFieldEnabled = ()=>(0, $1ybV0.ff)('jsm-responders-field-in-gicx-ui', false);
// eslint-disable-next-line jira/ff/inline-usage
const $a89499ac81454cad$var$isParentFieldInGicEnabled = ()=>(0, $1ybV0.ff)('parent-field-in-gic_d3b3n', false);
const $a89499ac81454cad$var$isDataClassificationFieldInGicEnabled = ()=>{
    const isEnabled = (0, $1ybV0.ff)('support-data-classification-field-in-gic_x6lda');
    return isEnabled;
};
const $a89499ac81454cad$export$5181d52929b93430 = (withML)=>(0, $9ypom.default)`
    query JiraGlobalIssueCreateModalLoad(
        $project: JiraProjectInput
        $issueType: JiraIssueTypeInput
        $requestType: JiraRequestTypeInput
        $defaultValues: JiraIssueFieldsInput
        $issueTypes: String
        $requestTypes: String

    ) {
        ${withML ? 'jiraIssueCreateLayoutWithML' : 'jiraIssueCreateLayout'}(
            layoutFilter: USER_CONFIGURED_LAYOUT
            project: $project
            issueType: $issueType
            requestType: $requestType
        ) {
            ...LayoutFragment
        }
        jiraIssueCreateFields(
            fieldsFilter: USER_CONFIGURED_FIELDS
            project: $project
            issueType: $issueType
            requestType: $requestType
            defaultValues: $defaultValues
        ) {
            ... on JiraIssueCreateFields {
                fields {
                    nodes {
                        ...BaseFieldFragment
                        ...ProjectFieldFragment
                        ...IssueTypeFieldSearchFragment
                        ...RequestTypeFieldSearchFragment
                        ...TextFieldFragment
                        ...RichTextFieldFragment
                        ...ComponentsFieldFragment
                        ...VersionFieldFragment
                        ...MultiVersionFieldFragment
                        ...PriorityFieldFragment
                        ...SprintFieldFragment
                        ...LabelFieldFragment
                        ...SingleUserPickerFieldFragment
                        ...MultiUserPickerFieldFragment
                        ...PeopleFieldFragment
                        ...SecurityFieldFragment
                        ...IssueRestrictionFieldFragment
                        ...ColorFieldFragment
                        ...ResolutionFieldFragment
                        ...SingleSelectFieldFragment
                        ...MultiSelectFieldFragment
                        ...NumberFieldFragment
                        ...UrlFieldFragment
                        ...EpicLinkFieldFragment
                        ...DatePickerFieldFragment
                        ...DateTimePickerFieldFragment
                        ...CascadingSelectFieldFragment
                        ...AttachmentsFieldFragment
                        ...CheckboxFieldFragment
                        ...IssueLinksFieldFragment
                        ...SingleGroupPickerFieldFragment
                        ...MultiGroupPickerFieldFragment
                        ...TeamFieldFragment
                        ...AtlassianTeamFieldFragment
                        ...RadioSelectFieldFragment
                        ...AffectedServicesFieldFragment
                        ...CMDBFieldFragment
                        ...OrganizationsFieldFragment
                        ...ConnectTextFieldFragment
                        ...ConnectNumberFieldFragment
                        ...ConnectSingleSelectFieldFragment
                        ...ConnectMultiSelectFieldFragment
                        ...ConnectRichTextFieldFragment
                        ...AssetFieldFragment
                        ...ForgeStringFieldFragment
                        ...ForgeNumberFieldFragment
                        ...ForgeSingleUserPickerFieldFragment
                        ...ForgeMultiUserPickerFieldFragment
                        ...ForgeGroupPickerFieldFragment
                        ...ForgeMultiGroupPickerFieldFragment
                        ...ForgeStringsFieldFragment
                        ...ForgeObjectFieldFragment
                        ...ForgeDateTimePickerFieldFragment
                        ...TimeTrackingFieldFragment
                        ...WorkLogFieldFragment
                        ...JsmMultiUserPickerFieldFragment
                        ...JsmPeopleFieldFragment
                        ...ParentLinkFieldFragment
                        ${$a89499ac81454cad$var$isDataClassificationFieldInGicEnabled() ? '...DataClassificationFieldFragment' : ''}
                        ${$a89499ac81454cad$var$isParentFieldInGicEnabled() ? '...ParentFieldFragment' : ''}
                        ...StatusFieldFragment
                        ${$a89499ac81454cad$var$isJsmRespondersFieldEnabled() ? '...JiraServiceManagementRespondersFieldFragment' : ''}
                    }
                }
                errors {
                    identifier
                    extensions {
                        ... on JiraIssueFieldUnsupportedErrorExtension {
                            fieldName
                            fieldType
                            isRequiredField
                        }
                        ... on JiraIssueFieldValueValidationErrorExtension {
                            errorType
                            message
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
        jiraIssueCreateAdditionalServices(project: $project, issueType: $issueType, requestType: $requestType) {
            ... on JiraIssueCreateAdditionalServices {
                services {
                    edges {
                        node {
                            ...WatchersConfigFragment
                            ...ProformaConfigFragment
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
    }
    ${withML ? (0, $frihL.LAYOUT_FRAGMENT_WITH_ML) : (0, $frihL.LAYOUT_FRAGMENT)}
    ${0, $frihL.BASE_FIELD_FRAGMENT}
    ${0, $frihL.PROJECT_FIELD_FRAGMENT}
    ${0, $frihL.ISSUE_TYPE_FIELD_SEARCH_BY_FRAGMENT}
    ${0, $frihL.REQUEST_TYPE_FIELD_SEARCH_BY_FRAGMENT}
    ${0, $frihL.TEXT_FIELD_FRAGMENT}
    ${0, $frihL.RICH_TEXT_FIELD_FRAGMENT}
    ${0, $frihL.COMPONENTS_FIELD_FRAGMENT}
    ${0, $frihL.VERSION_FIELD_FRAGMENT}
    ${0, $frihL.MULTI_VERSION_FIELD_FRAGMENT}
    ${0, $frihL.PRIORITY_FIELD_FRAGMENT}
    ${0, $frihL.SPRINT_FIELD_FRAGMENT}
    ${0, $frihL.LABEL_FIELD_FRAGMENT}
    ${0, $frihL.SINGLE_USER_PICKER_FIELD_FRAGMENT}
    ${0, $frihL.MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, $frihL.SECURITY_FIELD_FRAGMENT}
    ${0, $frihL.ISSUE_RESTRICTION_FIELD_FRAGMENT}
    ${0, $frihL.COLOR_FIELD_FRAGMENT}
    ${0, $frihL.RESOLUTION_FIELD_FRAGMENT}
    ${0, $frihL.SINGLE_SELECT_FIELD_FRAGMENT}
    ${0, $frihL.MULTI_SELECT_FIELD_FRAGMENT}
    ${0, $frihL.NUMBER_FIELD_FRAGMENT}
    ${0, $frihL.URL_FIELD_FRAGMENT}
    ${0, $frihL.EPIC_LINK_FIELD_FRAGMENT}
    ${0, $frihL.DATE_FIELD_FRAGMENT}
    ${0, $frihL.DATE_TIME_FIELD_FRAGMENT}
    ${0, $frihL.CASCADING_SELECT_FIELD_FRAGMENT}
    ${0, $frihL.ATTACHMENTS_FIELD_FRAGMENT}
    ${0, $frihL.CHECKBOX_FIELD_FRAGMENT}
    ${0, $frihL.ISSUE_LINKS_FIELD_FRAGMENT}
    ${0, $frihL.SINGLE_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $frihL.MULTI_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $frihL.PEOPLE_FIELD_FRAGMENT}
    ${0, $frihL.TEAM_FIELD_FRAGMENT}
    ${0, $frihL.ATLASSIAN_TEAM_FIELD_FRAGMENT}
    ${0, $frihL.RADIO_SELECT_FIELD_FRAGMENT}
    ${0, $frihL.AFFECTED_SERVICES_FIELD_FRAGMENT}
    ${0, $frihL.CMDB_FIELD_FRAGMENT}
    ${0, $frihL.ORGANIZATIONS_FIELD_FRAGMENT}
    ${0, $frihL.CONNECT_TEXT_FIELD_FRAGMENT}
    ${0, $frihL.CONNECT_NUMBER_FIELD_FRAGMENT}
    ${0, $frihL.CONNECT_SINGLE_SELECT_FIELD_FRAGMENT}
    ${0, $frihL.CONNECT_MULTI_SELECT_FIELD_FRAGMENT}
    ${0, $frihL.CONNECT_RICH_TEXT_FIELD_FRAGMENT}
    ${0, $frihL.ASSET_FIELD_FRAGMENT}
    ${0, $frihL.FORGE_STRING_FIELD_FRAGMENT}
    ${0, $frihL.FORGE_NUMBER_FIELD_FRAGMENT}
    ${0, $frihL.FORGE_SINGLE_USER_PICKER_FIELD_FRAGMENT}
    ${0, $frihL.FORGE_MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, $frihL.FORGE_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $frihL.FORGE_MULTI_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $frihL.FORGE_STRINGS_FIELD_FRAGMENT}
    ${0, $frihL.FORGE_DATETIME_FIELD_FRAGMENT}
    ${0, $frihL.FORGE_OBJECT_FIELD_FRAGMENT}
    ${0, $frihL.TIME_TRACKING_FIELD_FRAGMENT}
    ${0, $frihL.WORK_LOG_FIELD_FRAGMENT}
    ${0, $frihL.JSM_MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, $frihL.JSM_PEOPLE_FIELD_FRAGMENT}
    ${0, $frihL.PARENT_LINK_FIELD_FRAGMENT}
    ${$a89499ac81454cad$var$isParentFieldInGicEnabled() ? (0, $frihL.PARENT_FIELD_FRAGMENT) : ''}
    ${0, $frihL.PROFORMA_CONFIG_FRAGMENT}
    ${0, $frihL.STATUS_FIELD_FRAGMENT}
    ${$a89499ac81454cad$var$isJsmRespondersFieldEnabled() ? (0, $frihL.RESPONDERS_FIELD_FRAGMENT) : ''}
    ${0, $frihL.WATCHERS_CONFIG_FRAGMENT}
    ${$a89499ac81454cad$var$isDataClassificationFieldInGicEnabled() ? (0, $frihL.DATA_CLASSIFICATION_FIELD_FRAGMENT) : ''}
`;

});
parcelRegister("frihL", function(module, exports) {

$parcel$export(module.exports, "LAYOUT_FRAGMENT", () => $2cc4d2f8ff258e4f$export$f625f330d228b694);
$parcel$export(module.exports, "LAYOUT_FRAGMENT_WITH_ML", () => $2cc4d2f8ff258e4f$export$c62f67b4f409a5c6);
$parcel$export(module.exports, "BASE_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$e61b49f54d551a76);
$parcel$export(module.exports, "PROJECT", () => $2cc4d2f8ff258e4f$export$fe791c4fa892e400);
$parcel$export(module.exports, "PROJECT_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$d5bb466f0c1673ed);
$parcel$export(module.exports, "ISSUE_TYPE_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$5b50a50ed83e9899);
$parcel$export(module.exports, "ISSUE_TYPE_FIELD_SEARCH_BY_FRAGMENT", () => $2cc4d2f8ff258e4f$export$410d36690ebc2ef6);
$parcel$export(module.exports, "TEXT_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$636915305cba61ee);
$parcel$export(module.exports, "CONNECT_TEXT_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$3cd5b2049171ec4c);
$parcel$export(module.exports, "FORGE_STRING_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$ebc024aa691e4d85);
$parcel$export(module.exports, "RICH_TEXT_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$5b0963f21dba94f8);
$parcel$export(module.exports, "CONNECT_RICH_TEXT_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$7f0a2ff1b7c9ca01);
$parcel$export(module.exports, "FORGE_OBJECT_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$689ca997bd170b37);
$parcel$export(module.exports, "COMPONENTS_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$ab0555e54f8994f9);
$parcel$export(module.exports, "SINGLE_USER_PICKER_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$28f68e0bae1ee7f3);
$parcel$export(module.exports, "FORGE_SINGLE_USER_PICKER_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$1f16b392b8d9b666);
$parcel$export(module.exports, "MULTI_USER_PICKER_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$b2adb4bd3df183ed);
$parcel$export(module.exports, "JSM_MULTI_USER_PICKER_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$fffb689cf69ab0a2);
$parcel$export(module.exports, "FORGE_MULTI_USER_PICKER_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$c43dfb9e201b83a2);
$parcel$export(module.exports, "PEOPLE_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$2b791aa6cca603ee);
$parcel$export(module.exports, "JSM_PEOPLE_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$b043dc06c0d2d4f8);
$parcel$export(module.exports, "NUMBER_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$874202730a4f96be);
$parcel$export(module.exports, "CONNECT_NUMBER_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$82ff38b10f06144a);
$parcel$export(module.exports, "FORGE_NUMBER_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$87f4b71855b27f75);
$parcel$export(module.exports, "DATE_TIME_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$bbf5ba5f74471361);
$parcel$export(module.exports, "ISSUE_LINKS_FIELD_FRAGMENT_WITH_COPY_LINKS_AND_ATTACHMENTS", () => $2cc4d2f8ff258e4f$export$9ef617a537d543ae);
$parcel$export(module.exports, "ISSUE_LINKS_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$dd6b1aecfb7f1473);
$parcel$export(module.exports, "FORGE_DATETIME_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$7009d41cc723dac);
$parcel$export(module.exports, "DATE_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$bb1ac816b515a7c);
$parcel$export(module.exports, "EPIC_LINK_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$47036e8bdf2c9326);
$parcel$export(module.exports, "LABEL_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$85cf307e24504b19);
$parcel$export(module.exports, "FORGE_STRINGS_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$9255ce322dbd4481);
$parcel$export(module.exports, "VERSION_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$37deee440fbd3c5);
$parcel$export(module.exports, "MULTI_VERSION_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$ffdfaa2ab8110c87);
$parcel$export(module.exports, "PRIORITY_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$63d6d00b6349a8fd);
$parcel$export(module.exports, "ATTACHMENTS_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$8ca944b20979f689);
$parcel$export(module.exports, "SECURITY_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$e0034adc460157a3);
$parcel$export(module.exports, "ISSUE_RESTRICTION_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$a4e0bff5a9855a6a);
$parcel$export(module.exports, "URL_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$55232ce79978fe60);
$parcel$export(module.exports, "CHECKBOX_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$2a0a6d36d97ce992);
$parcel$export(module.exports, "SINGLE_SELECT_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$2bba3db49a112c62);
$parcel$export(module.exports, "CONNECT_SINGLE_SELECT_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$f63043138eca54b8);
$parcel$export(module.exports, "MULTI_SELECT_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$494028c0baaef0a5);
$parcel$export(module.exports, "CONNECT_MULTI_SELECT_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$a5740cd9553dc3be);
$parcel$export(module.exports, "RADIO_SELECT_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$8a8492487a98fdaa);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$c525f571cbe1dcbb);
$parcel$export(module.exports, "SINGLE_GROUP_PICKER_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$1507bfa8951ee68d);
$parcel$export(module.exports, "FORGE_GROUP_PICKER_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$51d039d4ec21f704);
$parcel$export(module.exports, "MULTI_GROUP_PICKER_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$4c4a76b99fc5f54e);
$parcel$export(module.exports, "FORGE_MULTI_GROUP_PICKER_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$ae231dc96d2638ab);
$parcel$export(module.exports, "SPRINT_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$aba335b21420357f);
$parcel$export(module.exports, "COLOR_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$585571cdf68c55a1);
$parcel$export(module.exports, "REQUEST_TYPE_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$201be0ff29129622);
$parcel$export(module.exports, "REQUEST_TYPE_FIELD_SEARCH_BY_FRAGMENT", () => $2cc4d2f8ff258e4f$export$589a6183e9780424);
$parcel$export(module.exports, "RESOLUTION_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$31c88001934c2e15);
$parcel$export(module.exports, "CASCADING_SELECT_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$2f9cfac026740bd3);
$parcel$export(module.exports, "TEAM_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$cb70b12f3de3f41c);
$parcel$export(module.exports, "ATLASSIAN_TEAM_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$1173888d99fd7ae6);
$parcel$export(module.exports, "ASSET_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$97cdf1e4b8832240);
$parcel$export(module.exports, "AFFECTED_SERVICES_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$3480d890dca64b9e);
$parcel$export(module.exports, "CMDB_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$c1864cedbeda248a);
$parcel$export(module.exports, "ORGANIZATIONS_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$e0f3793fd890e0);
$parcel$export(module.exports, "TIME_TRACKING_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$f9e6189fd786f6);
$parcel$export(module.exports, "WORK_LOG_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$c6c1a1f3d6f49ea4);
$parcel$export(module.exports, "PARENT_LINK_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$fa778835050523e6);
$parcel$export(module.exports, "PARENT_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$f75050611ceb9d35);
$parcel$export(module.exports, "STATUS_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$f89396a6b77b653f);
$parcel$export(module.exports, "RESPONDERS_FIELD_FRAGMENT", () => $2cc4d2f8ff258e4f$export$335dcd5b86a25a15);
$parcel$export(module.exports, "PROFORMA_CONFIG_FRAGMENT", () => $2cc4d2f8ff258e4f$export$5f06542accc83cb5);
$parcel$export(module.exports, "WATCHERS_CONFIG_FRAGMENT", () => $2cc4d2f8ff258e4f$export$eda8fbd7533aaac1);
// eslint-disable-next-line jira/restricted/graphql-tag

var $9ypom = parcelRequire("9ypom");
const $2cc4d2f8ff258e4f$export$f625f330d228b694 = (0, $9ypom.default)`
	fragment LayoutFragment on JiraIssueCreateLayout {
		contentSection {
			items {
				... on JiraTabLayout {
					id
					name
					items {
						... on JiraFieldLayoutItem {
							fieldId
						}
					}
				}
			}
		}
	}
`;
const $2cc4d2f8ff258e4f$export$c62f67b4f409a5c6 = (0, $9ypom.default)`
	fragment LayoutFragment on JiraIssueCreateLayout {
		contentSection {
			items {
				... on JiraTabLayout {
					id
					name
					items {
						... on JiraFieldLayoutItem {
							fieldId
						}
					}
					collapsedItems {
						... on JiraFieldLayoutItem {
							fieldId
						}
					}
				}
			}
		}
	}
`;
const $2cc4d2f8ff258e4f$export$e61b49f54d551a76 = (0, $9ypom.default)`
	fragment BaseFieldFragment on JiraIssueField {
		fieldId
		name
		type
		description
		... on JiraIssueFieldConfiguration {
			fieldConfig {
				isRequired
				isEditable
				nonEditableReason {
					message
				}
			}
		}
	}
`;
const $2cc4d2f8ff258e4f$export$fe791c4fa892e400 = (0, $9ypom.default)`
	fragment Project on JiraProject {
		id: projectId
		name
		avatar {
			large
		}
		projectType
		simplified
		key
		classificationTags
	}
`;
const $2cc4d2f8ff258e4f$export$d5bb466f0c1673ed = (0, $9ypom.default)`
	fragment ProjectFieldFragment on JiraProjectField {
		project {
			...Project
		}
		searchUrl
	}
	${$2cc4d2f8ff258e4f$export$fe791c4fa892e400}
`;
/* issuetype field */ const $2cc4d2f8ff258e4f$var$ISSUE_TYPE = (0, $9ypom.default)`
	fragment IssueType on JiraIssueType {
		id: issueTypeId
		name
		avatar {
			large
		}
	}
`;
const $2cc4d2f8ff258e4f$export$5b50a50ed83e9899 = (0, $9ypom.default)`
	fragment IssueTypeFieldFragment on JiraIssueTypeField {
		issueType {
			...IssueType
		}
		issueTypes {
			nodes {
				...IssueType
			}
		}
	}
	${$2cc4d2f8ff258e4f$var$ISSUE_TYPE}
`;
const $2cc4d2f8ff258e4f$export$410d36690ebc2ef6 = (0, $9ypom.default)`
	fragment IssueTypeFieldSearchFragment on JiraIssueTypeField {
		issueType {
			...IssueType
		}
		issueTypes(searchBy: $issueTypes) {
			nodes {
				...IssueType
			}
		}
	}
	${$2cc4d2f8ff258e4f$var$ISSUE_TYPE}
`;
const $2cc4d2f8ff258e4f$export$636915305cba61ee = (0, $9ypom.default)`
	fragment TextFieldFragment on JiraSingleLineTextField {
		text
	}
`;
const $2cc4d2f8ff258e4f$export$3cd5b2049171ec4c = (0, $9ypom.default)`
	fragment ConnectTextFieldFragment on JiraConnectTextField {
		text
	}
`;
const $2cc4d2f8ff258e4f$export$ebc024aa691e4d85 = (0, $9ypom.default)`
	fragment ForgeStringFieldFragment on JiraForgeStringField {
		text
	}
`;
const $2cc4d2f8ff258e4f$var$MEDIA_CONTEXT_FRAGMENT = (0, $9ypom.default)`
	fragment JiraMediaContextFragment on JiraMediaContext {
		uploadToken {
			... on JiraMediaUploadToken {
				endpointUrl
				clientId
				targetCollection
				token
				tokenDurationInMin
			}
			... on QueryError {
				message
			}
		}
	}
`;
const $2cc4d2f8ff258e4f$export$b9abb6c941d637fd = (0, $9ypom.default)`
	fragment JiraAdminRichTextFieldConfigFragment on JiraRichTextField {
		adminRichTextConfig {
			aiEnabledByProject
		}
	}
`;
const $2cc4d2f8ff258e4f$export$5b0963f21dba94f8 = (0, $9ypom.default)`
	fragment RichTextFieldFragment on JiraRichTextField {
		richText {
			plainText
			adfValue {
				json
			}
		}
		renderer
		mediaContext {
			...JiraMediaContextFragment
		}
		...JiraAdminRichTextFieldConfigFragment
	}
	${$2cc4d2f8ff258e4f$var$MEDIA_CONTEXT_FRAGMENT}
	${$2cc4d2f8ff258e4f$export$b9abb6c941d637fd}
`;
const $2cc4d2f8ff258e4f$export$7f0a2ff1b7c9ca01 = (0, $9ypom.default)`
	fragment ConnectRichTextFieldFragment on JiraConnectRichTextField {
		richText {
			plainText
			adfValue {
				json
			}
		}
		renderer
		mediaContext {
			...JiraMediaContextFragment
		}
	}
	${$2cc4d2f8ff258e4f$var$MEDIA_CONTEXT_FRAGMENT}
`;
const $2cc4d2f8ff258e4f$export$689ca997bd170b37 = (0, $9ypom.default)`
	fragment ForgeObjectFieldFragment on JiraForgeObjectField {
		object
	}
`;
/* components field */ const $2cc4d2f8ff258e4f$var$COMPONENT = (0, $9ypom.default)`
	fragment Component on JiraComponent {
		id: componentId
		name
	}
`;
const $2cc4d2f8ff258e4f$export$ab0555e54f8994f9 = (0, $9ypom.default)`
	fragment ComponentsFieldFragment on JiraComponentsField {
		selectedComponents {
			...Component
		}
		components {
			nodes {
				...Component
			}
		}
	}
	${$2cc4d2f8ff258e4f$var$COMPONENT}
`;
const $2cc4d2f8ff258e4f$export$ff09b90989b21a8 = (0, $9ypom.default)`
	fragment UserFragment on User {
		accountId
		name
		picture
	}
`;
const $2cc4d2f8ff258e4f$export$28f68e0bae1ee7f3 = (0, $9ypom.default)`
	fragment SingleUserPickerFieldFragment on JiraSingleSelectUserPickerField {
		user {
			...UserFragment
		}
		searchUrl
	}
	${$2cc4d2f8ff258e4f$export$ff09b90989b21a8}
`;
const $2cc4d2f8ff258e4f$export$1f16b392b8d9b666 = (0, $9ypom.default)`
	fragment ForgeSingleUserPickerFieldFragment on JiraForgeUserField {
		user {
			...UserFragment
		}
		searchUrl
	}
	${$2cc4d2f8ff258e4f$export$ff09b90989b21a8}
`;
const $2cc4d2f8ff258e4f$export$b2adb4bd3df183ed = (0, $9ypom.default)`
	fragment MultiUserPickerFieldFragment on JiraMultipleSelectUserPickerField {
		selectedUsers {
			...UserFragment
		}
		searchUrl
	}
	${$2cc4d2f8ff258e4f$export$ff09b90989b21a8}
`;
const $2cc4d2f8ff258e4f$export$fffb689cf69ab0a2 = (0, $9ypom.default)`
	fragment JsmMultiUserPickerFieldFragment on JsmMultipleSelectUserPickerField {
		selectedUsers {
			...UserFragment
		}
		searchUrl
	}
	${$2cc4d2f8ff258e4f$export$ff09b90989b21a8}
`;
const $2cc4d2f8ff258e4f$export$c43dfb9e201b83a2 = (0, $9ypom.default)`
	fragment ForgeMultiUserPickerFieldFragment on JiraForgeUsersField {
		selectedUsers {
			...UserFragment
		}
		searchUrl
	}
	${$2cc4d2f8ff258e4f$export$ff09b90989b21a8}
`;
const $2cc4d2f8ff258e4f$export$2b791aa6cca603ee = (0, $9ypom.default)`
	fragment PeopleFieldFragment on JiraPeopleField {
		selectedUsers {
			...UserFragment
		}
		searchUrl
		isMulti
	}
	${$2cc4d2f8ff258e4f$export$ff09b90989b21a8}
`;
const $2cc4d2f8ff258e4f$export$b043dc06c0d2d4f8 = (0, $9ypom.default)`
	fragment JsmPeopleFieldFragment on JsmPeopleField {
		selectedUsers {
			...UserFragment
		}
		searchUrl
		isMulti
	}
	${$2cc4d2f8ff258e4f$export$ff09b90989b21a8}
`;
const $2cc4d2f8ff258e4f$export$874202730a4f96be = (0, $9ypom.default)`
	fragment NumberFieldFragment on JiraNumberField {
		number
	}
`;
const $2cc4d2f8ff258e4f$export$82ff38b10f06144a = (0, $9ypom.default)`
	fragment ConnectNumberFieldFragment on JiraConnectNumberField {
		number
	}
`;
const $2cc4d2f8ff258e4f$export$87f4b71855b27f75 = (0, $9ypom.default)`
	fragment ForgeNumberFieldFragment on JiraForgeNumberField {
		number
	}
`;
const $2cc4d2f8ff258e4f$export$bbf5ba5f74471361 = (0, $9ypom.default)`
	fragment DateTimePickerFieldFragment on JiraDateTimePickerField {
		dateTime
	}
`;
const $2cc4d2f8ff258e4f$export$9ef617a537d543ae = (0, $9ypom.default)`
	fragment IssueLinksFieldFragmentWithCopyLinksAndAttachments on JiraIssueLinkField {
		name
		searchUrl
		issueLinks {
			id
			relatedBy {
				relationName
				linkTypeId
				linkTypeName
				direction
			}
			issue {
				id
				issueId
				key
				avatar {
					small
					medium
				}
			}
		}
		issueLinkTypeRelations {
			nodes {
				relationName
				linkTypeId
				linkTypeName
				direction
			}
		}
		copyLinksAndAttachments {
			copyLinks
			copyAttachments
		}
	}
`;
const $2cc4d2f8ff258e4f$export$dd6b1aecfb7f1473 = (0, $9ypom.default)`
	fragment IssueLinksFieldFragment on JiraIssueLinkField {
		name
		searchUrl
		issueLinks {
			id
			relatedBy {
				relationName
				linkTypeId
				linkTypeName
				direction
			}
			issue {
				id
				issueId
				key
				avatar {
					small
					medium
				}
			}
		}
		issueLinkTypeRelations {
			nodes {
				relationName
				linkTypeId
				linkTypeName
				direction
			}
		}
	}
`;
const $2cc4d2f8ff258e4f$export$7009d41cc723dac = (0, $9ypom.default)`
	fragment ForgeDateTimePickerFieldFragment on JiraForgeDatetimeField {
		dateTime
	}
`;
const $2cc4d2f8ff258e4f$export$bb1ac816b515a7c = (0, $9ypom.default)`
	fragment DatePickerFieldFragment on JiraDatePickerField {
		date
	}
`;
const $2cc4d2f8ff258e4f$export$3cb4a99a332e4186 = (0, $9ypom.default)`
	fragment Epic on JiraEpic {
		name
		key
		summary
	}
`;
const $2cc4d2f8ff258e4f$export$47036e8bdf2c9326 = (0, $9ypom.default)`
	fragment EpicLinkFieldFragment on JiraEpicLinkField {
		epic {
			...Epic
		}
		searchUrl
	}
	${$2cc4d2f8ff258e4f$export$3cb4a99a332e4186}
`;
const $2cc4d2f8ff258e4f$export$37aee82a3cb1e8f7 = (0, $9ypom.default)`
	fragment Label on JiraLabel {
		id: labelId
		name
	}
`;
const $2cc4d2f8ff258e4f$export$85cf307e24504b19 = (0, $9ypom.default)`
	fragment LabelFieldFragment on JiraLabelsField {
		selectedLabels {
			...Label
		}
		searchUrl
	}
	${$2cc4d2f8ff258e4f$export$37aee82a3cb1e8f7}
`;
const $2cc4d2f8ff258e4f$export$9255ce322dbd4481 = (0, $9ypom.default)`
	fragment ForgeStringsFieldFragment on JiraForgeStringsField {
		selectedLabels {
			...Label
		}
		searchUrl
	}
	${$2cc4d2f8ff258e4f$export$37aee82a3cb1e8f7}
`;
/* versions field */ const $2cc4d2f8ff258e4f$var$VERSION = (0, $9ypom.default)`
	fragment Version on JiraVersion {
		id: versionId
		name
		status
	}
`;
const $2cc4d2f8ff258e4f$export$37deee440fbd3c5 = (0, $9ypom.default)`
	fragment VersionFieldFragment on JiraSingleVersionPickerField {
		version {
			...Version
		}
		versions {
			nodes {
				...Version
			}
		}
	}
	${$2cc4d2f8ff258e4f$var$VERSION}
`;
const $2cc4d2f8ff258e4f$export$ffdfaa2ab8110c87 = (0, $9ypom.default)`
	fragment MultiVersionFieldFragment on JiraMultipleVersionPickerField {
		selectedVersions {
			...Version
		}
		versions {
			nodes {
				...Version
			}
		}
	}
	${$2cc4d2f8ff258e4f$var$VERSION}
`;
/* priority field */ const $2cc4d2f8ff258e4f$var$PRIORITY = (0, $9ypom.default)`
	fragment Priority on JiraPriority {
		name
		id: priorityId
		iconUrl
	}
`;
const $2cc4d2f8ff258e4f$export$63d6d00b6349a8fd = (0, $9ypom.default)`
	fragment PriorityFieldFragment on JiraPriorityField {
		priority {
			...Priority
		}
		priorities {
			nodes {
				...Priority
			}
		}
	}
	${$2cc4d2f8ff258e4f$var$PRIORITY}
`;
/* issue link field */ // schema needs to be updated
/* security field */ const $2cc4d2f8ff258e4f$var$SECURITY_LEVEL = (0, $9ypom.default)`
	fragment SecurityLevel on JiraSecurityLevel {
		id: securityId
		name
		description
	}
`;
const $2cc4d2f8ff258e4f$export$8ca944b20979f689 = (0, $9ypom.default)`
	fragment AttachmentsFieldFragment on JiraAttachmentsField {
		maxAllowedTotalAttachmentsSize
		mediaContext {
			...JiraMediaContextFragment
		}
	}
	${$2cc4d2f8ff258e4f$var$MEDIA_CONTEXT_FRAGMENT}
`;
const $2cc4d2f8ff258e4f$export$e0034adc460157a3 = (0, $9ypom.default)`
	fragment SecurityFieldFragment on JiraSecurityLevelField {
		securityLevel {
			...SecurityLevel
		}
		securityLevels {
			nodes {
				...SecurityLevel
			}
		}
	}
	${$2cc4d2f8ff258e4f$var$SECURITY_LEVEL}
`;
/* issue restriction field */ const $2cc4d2f8ff258e4f$var$USER_ROLES = (0, $9ypom.default)`
	fragment UserRoles on JiraRole {
		roleId
	}
`;
const $2cc4d2f8ff258e4f$export$a4e0bff5a9855a6a = (0, $9ypom.default)`
	fragment IssueRestrictionFieldFragment on JiraIssueRestrictionField {
		selectedRoles {
			...UserRoles
		}
	}
	${$2cc4d2f8ff258e4f$var$USER_ROLES}
`;
const $2cc4d2f8ff258e4f$export$55232ce79978fe60 = (0, $9ypom.default)`
	fragment UrlFieldFragment on JiraUrlField {
		url
	}
`;
/* checkbox field */ const $2cc4d2f8ff258e4f$var$OPTION = (0, $9ypom.default)`
	fragment Option on JiraOption {
		id: optionId
		value
	}
`;
const $2cc4d2f8ff258e4f$export$2a0a6d36d97ce992 = (0, $9ypom.default)`
	fragment CheckboxFieldFragment on JiraCheckboxesField {
		selectedFieldOptions {
			...Option
		}
		fieldOptions {
			nodes {
				...Option
			}
		}
	}
	${$2cc4d2f8ff258e4f$var$OPTION}
`;
const $2cc4d2f8ff258e4f$export$2bba3db49a112c62 = (0, $9ypom.default)`
	fragment SingleSelectFieldFragment on JiraSingleSelectField {
		fieldOption {
			...Option
		}
		fieldOptions {
			nodes {
				...Option
			}
		}
	}
	${$2cc4d2f8ff258e4f$var$OPTION}
`;
const $2cc4d2f8ff258e4f$export$f63043138eca54b8 = (0, $9ypom.default)`
	fragment ConnectSingleSelectFieldFragment on JiraConnectSingleSelectField {
		fieldOption {
			...Option
		}
		fieldOptions {
			nodes {
				...Option
			}
		}
	}
	${$2cc4d2f8ff258e4f$var$OPTION}
`;
const $2cc4d2f8ff258e4f$export$494028c0baaef0a5 = (0, $9ypom.default)`
	fragment MultiSelectFieldFragment on JiraMultipleSelectField {
		selectedFieldOptions {
			...Option
		}
		fieldOptions {
			nodes {
				...Option
			}
		}
		searchUrl
	}
	${$2cc4d2f8ff258e4f$var$OPTION}
`;
const $2cc4d2f8ff258e4f$export$a5740cd9553dc3be = (0, $9ypom.default)`
	fragment ConnectMultiSelectFieldFragment on JiraConnectMultipleSelectField {
		selectedFieldOptions {
			...Option
		}
		fieldOptions {
			nodes {
				...Option
			}
		}
	}
	${$2cc4d2f8ff258e4f$var$OPTION}
`;
const $2cc4d2f8ff258e4f$export$8a8492487a98fdaa = (0, $9ypom.default)`
	fragment RadioSelectFieldFragment on JiraRadioSelectField {
		selectedOption {
			...Option
		}
		fieldOptions {
			nodes {
				...Option
			}
		}
	}
	${$2cc4d2f8ff258e4f$var$OPTION}
`;
/* data classification field */ const $2cc4d2f8ff258e4f$var$CLASSIFICATION_OPTION = (0, $9ypom.default)`
	fragment ClassificationLevel on JiraClassificationLevel {
		id
		name
		color {
			colorKey
		}
		guidelines
		definition
		status
	}
`;
const $2cc4d2f8ff258e4f$export$c525f571cbe1dcbb = (0, $9ypom.default)`
	fragment DataClassificationFieldFragment on JiraDataClassificationField {
		classificationLevel {
			...ClassificationLevel
		}
		defaultClassificationLevel {
			...ClassificationLevel
		}
		classificationLevels(filterByCriteria: { filterByStatus: [PUBLISHED], filterByType: [USER] }) {
			edges {
				node {
					...ClassificationLevel
				}
			}
		}
	}
	${$2cc4d2f8ff258e4f$var$CLASSIFICATION_OPTION}
`;
/* group picker field fragment */ const $2cc4d2f8ff258e4f$var$GROUP = (0, $9ypom.default)`
	fragment Group on JiraGroup {
		groupId
		name
	}
`;
const $2cc4d2f8ff258e4f$export$1507bfa8951ee68d = (0, $9ypom.default)`
	fragment SingleGroupPickerFieldFragment on JiraSingleGroupPickerField {
		selectedGroup {
			...Group
		}
		searchUrl
	}
	${$2cc4d2f8ff258e4f$var$GROUP}
`;
const $2cc4d2f8ff258e4f$export$51d039d4ec21f704 = (0, $9ypom.default)`
	fragment ForgeGroupPickerFieldFragment on JiraForgeGroupField {
		selectedGroup {
			...Group
		}
		searchUrl
	}
	${$2cc4d2f8ff258e4f$var$GROUP}
`;
const $2cc4d2f8ff258e4f$export$4c4a76b99fc5f54e = (0, $9ypom.default)`
	fragment MultiGroupPickerFieldFragment on JiraMultipleGroupPickerField {
		selectedGroups {
			...Group
		}
		searchUrl
	}
	${$2cc4d2f8ff258e4f$var$GROUP}
`;
const $2cc4d2f8ff258e4f$export$ae231dc96d2638ab = (0, $9ypom.default)`
	fragment ForgeMultiGroupPickerFieldFragment on JiraForgeGroupsField {
		selectedGroups {
			...Group
		}
		searchUrl
	}
	${$2cc4d2f8ff258e4f$var$GROUP}
`;
const $2cc4d2f8ff258e4f$export$d9b12eb20c31129b = (0, $9ypom.default)`
	fragment MultiLineTextFieldFragment on JiraMultiLineTextField {
		text
	}
`;
/* sprint field */ const $2cc4d2f8ff258e4f$var$SPRINT = (0, $9ypom.default)`
	fragment Sprint on JiraSprint {
		sprintId
		name
		state
	}
`;
const $2cc4d2f8ff258e4f$export$aba335b21420357f = (0, $9ypom.default)`
	fragment SprintFieldFragment on JiraSprintField {
		selectedSprints {
			...Sprint
		}
		searchUrl
	}
	${$2cc4d2f8ff258e4f$var$SPRINT}
`;
const $2cc4d2f8ff258e4f$export$585571cdf68c55a1 = (0, $9ypom.default)`
	fragment ColorFieldFragment on JiraColorField {
		color {
			colorKey
		}
	}
`;
/* request type field */ const $2cc4d2f8ff258e4f$var$REQUEST_TYPE = (0, $9ypom.default)`
	fragment RequestType on JsmRequestType {
		requestTypeId
		name
		description
		helpText
		key
		issueType {
			issueTypeId
		}
		avatar {
			large
		}
		practices {
			key
		}
	}
`;
const $2cc4d2f8ff258e4f$export$201be0ff29129622 = (0, $9ypom.default)`
	fragment RequestTypeFieldFragment on JsmRequestTypeField {
		requestType {
			...RequestType
		}
		requestTypes {
			nodes {
				...RequestType
			}
		}
	}
	${$2cc4d2f8ff258e4f$var$REQUEST_TYPE}
`;
const $2cc4d2f8ff258e4f$export$589a6183e9780424 = (0, $9ypom.default)`
	fragment RequestTypeFieldSearchFragment on JsmRequestTypeField {
		requestType {
			...RequestType
		}
		requestTypes(searchBy: $requestTypes) {
			nodes {
				...RequestType
			}
		}
	}
	${$2cc4d2f8ff258e4f$var$REQUEST_TYPE}
`;
/* resolution field */ const $2cc4d2f8ff258e4f$var$RESOLUTION = (0, $9ypom.default)`
	fragment Resolution on JiraResolution {
		name
		id: resolutionId
	}
`;
const $2cc4d2f8ff258e4f$export$31c88001934c2e15 = (0, $9ypom.default)`
	fragment ResolutionFieldFragment on JiraResolutionField {
		resolution {
			...Resolution
		}
		resolutions {
			nodes {
				...Resolution
			}
		}
	}
	${$2cc4d2f8ff258e4f$var$RESOLUTION}
`;
const $2cc4d2f8ff258e4f$export$2f9cfac026740bd3 = (0, $9ypom.default)`
	fragment CascadingSelectFieldFragment on JiraCascadingSelectField {
		cascadingOption {
			parentOptionValue {
				...Option
			}
			childOptionValue {
				...Option
			}
		}
		cascadingOptions {
			nodes {
				parentOptionValue {
					...Option
				}
				childOptionValues {
					...Option
				}
			}
		}
	}
	${$2cc4d2f8ff258e4f$var$OPTION}
`;
/* team field */ const $2cc4d2f8ff258e4f$var$TEAM = (0, $9ypom.default)`
	fragment Team on JiraTeam {
		name
		teamId
	}
`;
const $2cc4d2f8ff258e4f$export$cb70b12f3de3f41c = (0, $9ypom.default)`
	fragment TeamFieldFragment on JiraTeamField {
		selectedTeam {
			...Team
		}
		searchUrl
	}
	${$2cc4d2f8ff258e4f$var$TEAM}
`;
/* Atlassian Team field */ const $2cc4d2f8ff258e4f$var$ATLASSIAN_TEAM = (0, $9ypom.default)`
	fragment AtlassianTeam on JiraAtlassianTeam {
		name
		teamId
		avatar {
			small
		}
	}
`;
const $2cc4d2f8ff258e4f$export$1173888d99fd7ae6 = (0, $9ypom.default)`
	fragment AtlassianTeamFieldFragment on JiraAtlassianTeamField {
		JiraAtlassianTeamField: selectedTeam {
			...AtlassianTeam
		}
		searchUrl
	}
	${$2cc4d2f8ff258e4f$var$ATLASSIAN_TEAM}
`;
/* affected services field */ const $2cc4d2f8ff258e4f$var$AFFECTED_SERVICE = (0, $9ypom.default)`
	fragment AffectedService on JiraAffectedService {
		serviceId
	}
`;
const $2cc4d2f8ff258e4f$var$ASSET = (0, $9ypom.default)`
	fragment Asset on JiraAsset {
		serializedOrigin
		appKey
		originId
		value
	}
`;
const $2cc4d2f8ff258e4f$export$97cdf1e4b8832240 = (0, $9ypom.default)`
	fragment AssetFieldFragment on JiraAssetField {
		selectedAssets {
			...Asset
		}
		searchUrl
	}
	${$2cc4d2f8ff258e4f$var$ASSET}
`;
const $2cc4d2f8ff258e4f$export$3480d890dca64b9e = (0, $9ypom.default)`
	fragment AffectedServicesFieldFragment on JiraAffectedServicesField {
		selectedAffectedServices {
			...AffectedService
		}
		searchUrl
	}
	${$2cc4d2f8ff258e4f$var$AFFECTED_SERVICE}
`;
const $2cc4d2f8ff258e4f$export$c1864cedbeda248a = (0, $9ypom.default)`
	fragment CMDBFieldFragment on JiraCMDBField {
		searchUrl
		isMulti
		attributesIncludedInAutoCompleteSearch
		selectedCmdbObjects {
			id
			objectId
			workspaceId
			label
		}
	}
`;
/* organizations field */ const $2cc4d2f8ff258e4f$var$ORGANIZATION = (0, $9ypom.default)`
	fragment Organization on JsmOrganization {
		organizationId
		organizationName
		domain
		__typename
	}
`;
const $2cc4d2f8ff258e4f$export$e0f3793fd890e0 = (0, $9ypom.default)`
	fragment OrganizationsFieldFragment on JsmOrganizationField {
		selectedOrganizations {
			...Organization
		}
		searchUrl
	}
	${$2cc4d2f8ff258e4f$var$ORGANIZATION}
`;
const $2cc4d2f8ff258e4f$export$f9e6189fd786f6 = (0, $9ypom.default)`
	fragment TimeTrackingFieldFragment on JiraTimeTrackingField {
		timeTrackingSettings {
			workingDaysPerWeek
			workingHoursPerDay
			defaultFormat
			defaultUnit
			isJiraConfiguredTimeTrackingEnabled
		}
		originalEstimate {
			timeInSeconds
		}
	}
`;
const $2cc4d2f8ff258e4f$export$c6c1a1f3d6f49ea4 = (0, $9ypom.default)`
	fragment WorkLogFieldFragment on JiraWorkLogField {
		timeTrackingSettings {
			workingDaysPerWeek
			workingHoursPerDay
			defaultFormat
			defaultUnit
			isJiraConfiguredTimeTrackingEnabled
		}
		mediaContext {
			...JiraMediaContextFragment
		}
	}
	${$2cc4d2f8ff258e4f$var$MEDIA_CONTEXT_FRAGMENT}
`;
const $2cc4d2f8ff258e4f$export$825c869f7cd85da3 = (0, $9ypom.default)`
	fragment Issue on JiraIssue {
		key
		issueId
		avatar {
			large
		}
	}
`;
const $2cc4d2f8ff258e4f$export$fa778835050523e6 = (0, $9ypom.default)`
	fragment ParentLinkFieldFragment on JiraParentIssueField {
		searchUrl
		parentIssue {
			...Issue
		}
	}
	${$2cc4d2f8ff258e4f$export$825c869f7cd85da3}
`;
const $2cc4d2f8ff258e4f$export$4561a4960baf1b2b = (0, $9ypom.default)`
	fragment ParentIssue on JiraIssue {
		key
		issueId
		avatar {
			large
		}
		issueColorField {
			color {
				colorKey
			}
		}
		fieldsById(ids: ["summary", "issuetype"]) {
			edges {
				node {
					... on JiraSingleLineTextField {
						text
					}
					... on JiraIssueTypeField {
						issueType {
							name
							avatar {
								xsmall
							}
						}
					}
				}
			}
		}
	}
`;
const $2cc4d2f8ff258e4f$export$f75050611ceb9d35 = (0, $9ypom.default)`
	fragment ParentFieldFragment on JiraParentIssueField {
		parentIssue {
			...ParentIssue
		}
	}
	${$2cc4d2f8ff258e4f$export$4561a4960baf1b2b}
`;
const $2cc4d2f8ff258e4f$export$f89396a6b77b653f = (0, $9ypom.default)`
	fragment StatusFieldFragment on JiraStatusField {
		name
		description
		aliasFieldId
		__typename
	}
`;
const $2cc4d2f8ff258e4f$export$335dcd5b86a25a15 = (0, $9ypom.default)`
	fragment JiraServiceManagementRespondersFieldFragment on JiraServiceManagementRespondersField {
		searchUrl
	}
`;
const $2cc4d2f8ff258e4f$export$5f06542accc83cb5 = (0, $9ypom.default)`
	fragment ProformaConfigFragment on JiraIssueCreateProformaConfiguration {
		serviceId
		proforma {
			portalLink
			hasProformaForm
		}
	}
`;
const $2cc4d2f8ff258e4f$export$eda8fbd7533aaac1 = (0, $9ypom.default)`
	fragment WatchersConfigFragment on JiraIssueCreateWatchersConfiguration {
		serviceId
		permissions {
			canManageWatchers
			canViewWatchers
			isAutoWatchEnabled
			isWatchersEnabled
		}
		__typename
	}
`;

});


parcelRegister("9QCcq", function(module, exports) {

$parcel$export(module.exports, "CREATE_CONFIG_USER_PREFERRED_QUERY", () => $f4cd86abc883182e$export$61c4e8e4bb09225e);
// TODO Delete this file when cleaning gic-smart-fields-jira-labs_8uwvr
// eslint-disable-next-line jira/restricted/graphql-tag

var $9ypom = parcelRequire("9ypom");

var $1ybV0 = parcelRequire("1ybV0");

var $frihL = parcelRequire("frihL");
// eslint-disable-next-line jira/ff/inline-usage
const $f4cd86abc883182e$var$isJsmRespondersFieldEnabled = ()=>(0, $1ybV0.ff)('jsm-responders-field-in-gicx-ui', false);
// eslint-disable-next-line jira/ff/inline-usage
const $f4cd86abc883182e$var$isParentFieldInGicEnabled = ()=>(0, $1ybV0.ff)('parent-field-in-gic_d3b3n', false);
const $f4cd86abc883182e$var$isDataClassificationFieldInGicEnabled = ()=>{
    const isEnabled = (0, $1ybV0.ff)('support-data-classification-field-in-gic_x6lda');
    return isEnabled;
};
const $f4cd86abc883182e$export$61c4e8e4bb09225e = (0, $9ypom.default)`
    query JiraGlobalIssueCreateModalLoad(
        $project: JiraProjectInput
        $issueType: JiraIssueTypeInput
        $requestType: JiraRequestTypeInput
        $defaultValues: JiraIssueFieldsInput
        $issueTypes: String
        $requestTypes: String

    ) {
        jiraIssueCreateLayout(
            layoutFilter: USER_CONFIGURED_LAYOUT
            project: $project
            issueType: $issueType
            requestType: $requestType
        ) {
            ...LayoutFragment
        }
        jiraIssueCreateFields(
            fieldsFilter: USER_CONFIGURED_FIELDS
            project: $project
            issueType: $issueType
            requestType: $requestType
            defaultValues: $defaultValues
        ) {
            ... on JiraIssueCreateFields {
                fields {
                    nodes {
                        ...BaseFieldFragment
                        ...ProjectFieldFragment
                        ...IssueTypeFieldSearchFragment
                        ...RequestTypeFieldSearchFragment
                        ...TextFieldFragment
                        ...RichTextFieldFragment
                        ...ComponentsFieldFragment
                        ...VersionFieldFragment
                        ...MultiVersionFieldFragment
                        ...PriorityFieldFragment
                        ...SprintFieldFragment
                        ...LabelFieldFragment
                        ...SingleUserPickerFieldFragment
                        ...MultiUserPickerFieldFragment
                        ...PeopleFieldFragment
                        ...SecurityFieldFragment
                        ...IssueRestrictionFieldFragment
                        ...ColorFieldFragment
                        ...ResolutionFieldFragment
                        ...SingleSelectFieldFragment
                        ...MultiSelectFieldFragment
                        ...NumberFieldFragment
                        ...UrlFieldFragment
                        ...EpicLinkFieldFragment
                        ...DatePickerFieldFragment
                        ...DateTimePickerFieldFragment
                        ...CascadingSelectFieldFragment
                        ...AttachmentsFieldFragment
                        ...CheckboxFieldFragment
                        ...IssueLinksFieldFragment
                        ...SingleGroupPickerFieldFragment
                        ...MultiGroupPickerFieldFragment
                        ...TeamFieldFragment
                        ...AtlassianTeamFieldFragment
                        ...RadioSelectFieldFragment
                        ...AffectedServicesFieldFragment
                        ...CMDBFieldFragment
                        ...OrganizationsFieldFragment
                        ...ConnectTextFieldFragment
                        ...ConnectNumberFieldFragment
                        ...ConnectSingleSelectFieldFragment
                        ...ConnectMultiSelectFieldFragment
                        ...ConnectRichTextFieldFragment
                        ...AssetFieldFragment
                        ...ForgeStringFieldFragment
                        ...ForgeNumberFieldFragment
                        ...ForgeSingleUserPickerFieldFragment
                        ...ForgeMultiUserPickerFieldFragment
                        ...ForgeGroupPickerFieldFragment
                        ...ForgeMultiGroupPickerFieldFragment
                        ...ForgeStringsFieldFragment
                        ...ForgeObjectFieldFragment
                        ...ForgeDateTimePickerFieldFragment
                        ...TimeTrackingFieldFragment
                        ...WorkLogFieldFragment
                        ...JsmMultiUserPickerFieldFragment
                        ...JsmPeopleFieldFragment
                        ...ParentLinkFieldFragment
                        ${$f4cd86abc883182e$var$isDataClassificationFieldInGicEnabled() ? '...DataClassificationFieldFragment' : ''}
                        ${$f4cd86abc883182e$var$isParentFieldInGicEnabled() ? '...ParentFieldFragment' : ''}
                        ...StatusFieldFragment
                        ${$f4cd86abc883182e$var$isJsmRespondersFieldEnabled() ? '...JiraServiceManagementRespondersFieldFragment' : ''}
                    }
                }
                errors {
                    identifier
                    extensions {
                        ... on JiraIssueFieldUnsupportedErrorExtension {
                            fieldName
                            fieldType
                            isRequiredField
                        }
                        ... on JiraIssueFieldValueValidationErrorExtension {
                            errorType
                            message
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
        jiraIssueCreateAdditionalServices(project: $project, issueType: $issueType, requestType: $requestType) {
            ... on JiraIssueCreateAdditionalServices {
                services {
                    edges {
                        node {
                            ...WatchersConfigFragment
                            ...ProformaConfigFragment
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
    }
    ${(0, $frihL.LAYOUT_FRAGMENT)}
    ${(0, $frihL.BASE_FIELD_FRAGMENT)}
    ${(0, $frihL.PROJECT_FIELD_FRAGMENT)}
    ${(0, $frihL.ISSUE_TYPE_FIELD_SEARCH_BY_FRAGMENT)}
    ${(0, $frihL.REQUEST_TYPE_FIELD_SEARCH_BY_FRAGMENT)}
    ${(0, $frihL.TEXT_FIELD_FRAGMENT)}
    ${(0, $frihL.RICH_TEXT_FIELD_FRAGMENT)}
    ${(0, $frihL.COMPONENTS_FIELD_FRAGMENT)}
    ${(0, $frihL.VERSION_FIELD_FRAGMENT)}
    ${(0, $frihL.MULTI_VERSION_FIELD_FRAGMENT)}
    ${(0, $frihL.PRIORITY_FIELD_FRAGMENT)}
    ${(0, $frihL.SPRINT_FIELD_FRAGMENT)}
    ${(0, $frihL.LABEL_FIELD_FRAGMENT)}
    ${(0, $frihL.SINGLE_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, $frihL.MULTI_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, $frihL.SECURITY_FIELD_FRAGMENT)}
    ${(0, $frihL.ISSUE_RESTRICTION_FIELD_FRAGMENT)}
    ${(0, $frihL.COLOR_FIELD_FRAGMENT)}
    ${(0, $frihL.RESOLUTION_FIELD_FRAGMENT)}
    ${(0, $frihL.SINGLE_SELECT_FIELD_FRAGMENT)}
    ${(0, $frihL.MULTI_SELECT_FIELD_FRAGMENT)}
    ${(0, $frihL.NUMBER_FIELD_FRAGMENT)}
    ${(0, $frihL.URL_FIELD_FRAGMENT)}
    ${(0, $frihL.EPIC_LINK_FIELD_FRAGMENT)}
    ${(0, $frihL.DATE_FIELD_FRAGMENT)}
    ${(0, $frihL.DATE_TIME_FIELD_FRAGMENT)}
    ${(0, $frihL.CASCADING_SELECT_FIELD_FRAGMENT)}
    ${(0, $frihL.ATTACHMENTS_FIELD_FRAGMENT)}
    ${(0, $frihL.CHECKBOX_FIELD_FRAGMENT)}
    ${(0, $frihL.ISSUE_LINKS_FIELD_FRAGMENT)}
    ${(0, $frihL.SINGLE_GROUP_PICKER_FIELD_FRAGMENT)}
    ${(0, $frihL.MULTI_GROUP_PICKER_FIELD_FRAGMENT)}
    ${(0, $frihL.PEOPLE_FIELD_FRAGMENT)}
    ${(0, $frihL.TEAM_FIELD_FRAGMENT)}
    ${(0, $frihL.ATLASSIAN_TEAM_FIELD_FRAGMENT)}
    ${(0, $frihL.RADIO_SELECT_FIELD_FRAGMENT)}
    ${(0, $frihL.AFFECTED_SERVICES_FIELD_FRAGMENT)}
    ${(0, $frihL.CMDB_FIELD_FRAGMENT)}
    ${(0, $frihL.ORGANIZATIONS_FIELD_FRAGMENT)}
    ${(0, $frihL.CONNECT_TEXT_FIELD_FRAGMENT)}
    ${(0, $frihL.CONNECT_NUMBER_FIELD_FRAGMENT)}
    ${(0, $frihL.CONNECT_SINGLE_SELECT_FIELD_FRAGMENT)}
    ${(0, $frihL.CONNECT_MULTI_SELECT_FIELD_FRAGMENT)}
    ${(0, $frihL.CONNECT_RICH_TEXT_FIELD_FRAGMENT)}
    ${(0, $frihL.ASSET_FIELD_FRAGMENT)}
    ${(0, $frihL.FORGE_STRING_FIELD_FRAGMENT)}
    ${(0, $frihL.FORGE_NUMBER_FIELD_FRAGMENT)}
    ${(0, $frihL.FORGE_SINGLE_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, $frihL.FORGE_MULTI_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, $frihL.FORGE_GROUP_PICKER_FIELD_FRAGMENT)}
    ${(0, $frihL.FORGE_MULTI_GROUP_PICKER_FIELD_FRAGMENT)}
    ${(0, $frihL.FORGE_STRINGS_FIELD_FRAGMENT)}
    ${(0, $frihL.FORGE_DATETIME_FIELD_FRAGMENT)}
    ${(0, $frihL.FORGE_OBJECT_FIELD_FRAGMENT)}
    ${(0, $frihL.TIME_TRACKING_FIELD_FRAGMENT)}
    ${(0, $frihL.WORK_LOG_FIELD_FRAGMENT)}
    ${(0, $frihL.JSM_MULTI_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, $frihL.JSM_PEOPLE_FIELD_FRAGMENT)}
    ${(0, $frihL.PARENT_LINK_FIELD_FRAGMENT)}
    ${$f4cd86abc883182e$var$isParentFieldInGicEnabled() ? (0, $frihL.PARENT_FIELD_FRAGMENT) : ''}
    ${(0, $frihL.PROFORMA_CONFIG_FRAGMENT)}
    ${(0, $frihL.STATUS_FIELD_FRAGMENT)}
    ${$f4cd86abc883182e$var$isJsmRespondersFieldEnabled() ? (0, $frihL.RESPONDERS_FIELD_FRAGMENT) : ''}
    ${(0, $frihL.WATCHERS_CONFIG_FRAGMENT)}
    ${$f4cd86abc883182e$var$isDataClassificationFieldInGicEnabled() ? (0, $frihL.DATA_CLASSIFICATION_FIELD_FRAGMENT) : ''}
`;

});


parcelRegister("g9dzQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7df52c219fdc872f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $dRkzf = parcelRequire("dRkzf");

var $6JePA = parcelRequire("6JePA");

var $deodO = parcelRequire("deodO");

var $grydk = parcelRequire("grydk");

var $6HW6N = parcelRequire("6HW6N");
const $7df52c219fdc872f$var$useFetchCreateConfigQueryInContext = (props = {})=>{
    const { displayOnlyRequiredFields: displayOnlyRequiredFields = false, triggerPointKey: triggerPointKey } = props;
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const [fetchError, setFetchError] = (0, $eUqFw.useState)(null);
    const apiStartTime = (0, $eUqFw.useRef)(0);
    const [apiLatency, setApiLatency] = (0, $eUqFw.useState)(0);
    const [data, setData] = (0, $eUqFw.useState)({
        fieldTabs: [],
        fieldConfig: {},
        contextFields: {},
        meta: {
            areRequiredFieldsSupported: true,
            queryErrorMessage: ''
        },
        additionalServices: {}
    });
    const { withMachineLearning: withMachineLearning } = (0, $1ybV0.ff)('gic-smart-fields-jira-labs_8uwvr') ? (0, $deodO.useSmartFieldsMachineLearning)() : {
        withMachineLearning: false
    };
    const [fetchConfigInContext] = (0, $iZuDo.useLazyQuery)((0, $1ybV0.ff)('gic-smart-fields-jira-labs_8uwvr') ? (0, $grydk.getCreateConfigUserPreferredQueryInContext)(withMachineLearning) : (0, $6HW6N.CREATE_CONFIG_USER_PREFERRED_QUERY_IN_CONTEXT), {
        fetchPolicy: 'no-cache',
        onCompleted: (queryData)=>{
            setApiLatency(Math.floor(performance.now() - apiStartTime.current));
            setData((0, $6JePA.transformQueryResults)((0, $6JePA.tranformModalLoadDataInContext)(queryData), displayOnlyRequiredFields));
            setLoading(false);
        },
        onError: (error)=>{
            setFetchError(error);
            (0, $guiFP.default)({
                meta: {
                    id: 'useFetchCreateConfigQueryInContext',
                    packageName: 'jiraIssueCreate',
                    teamName: 'gryffindor'
                },
                error: error,
                attributes: {
                    errorType: (0, $dRkzf.handleApolloError)(error),
                    triggerPointKey: triggerPointKey
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    });
    const handleFetch = (0, $eUqFw.useRef)((queryVariables)=>{
        setLoading(true);
        apiStartTime.current = performance.now();
        fetchConfigInContext(queryVariables);
    });
    return [
        {
            isLoading: loading,
            fieldTabs: data.fieldTabs,
            fieldConfig: data.fieldConfig,
            contextFields: data.contextFields,
            meta: data.meta,
            error: fetchError,
            apiLatency: apiLatency,
            additionalServices: data.additionalServices
        },
        handleFetch.current
    ];
};
var $7df52c219fdc872f$export$2e2bcd8739ae039 = $7df52c219fdc872f$var$useFetchCreateConfigQueryInContext;

});
parcelRegister("grydk", function(module, exports) {

$parcel$export(module.exports, "getCreateConfigUserPreferredQueryInContext", () => $e36e4a45a2b75358$export$edf18d1585c23939);
// eslint-disable-next-line jira/restricted/graphql-tag

var $9ypom = parcelRequire("9ypom");

var $1ybV0 = parcelRequire("1ybV0");

var $frihL = parcelRequire("frihL");
// eslint-disable-next-line jira/ff/inline-usage
const $e36e4a45a2b75358$var$isJsmRespondersFieldEnabled = ()=>(0, $1ybV0.ff)('jsm-responders-field-in-gicx-ui', false);
// eslint-disable-next-line jira/ff/inline-usage
const $e36e4a45a2b75358$var$isParentFieldInGicEnabled = ()=>(0, $1ybV0.ff)('parent-field-in-gic_d3b3n', false);
// eslint-disable-next-line jira/ff/inline-usage
const $e36e4a45a2b75358$var$isCreateLinkedIssueTriggerPointEnabled = ()=>(0, $1ybV0.ff)('create-linked-issues-trigger-point-issue-view', false);
const $e36e4a45a2b75358$export$edf18d1585c23939 = (withML)=>(0, $9ypom.default)`
    query JiraGlobalIssueCreateInContext(
        $project: JiraProjectInput
        $issueType: JiraIssueTypeInput
        $requestType: JiraRequestTypeInput
        $defaultValues: JiraIssueFieldsInput
        $additionalContext: JiraIssueCreateContextInput!
        ${$e36e4a45a2b75358$var$isCreateLinkedIssueTriggerPointEnabled() ? '$issueCreateType: IssueCreateTypeFilter' : ''}
    ) {
        ${withML ? 'jiraIssueCreateLayoutInContextWithML' : 'jiraIssueCreateLayoutInContext'}(
            layoutFilter: USER_CONFIGURED_LAYOUT
            project: $project
            issueType: $issueType
            additionalContext: $additionalContext
            ${$e36e4a45a2b75358$var$isCreateLinkedIssueTriggerPointEnabled() ? 'issueCreateType: $issueCreateType' : ''}
        ) {
            ...LayoutFragment
        }
        jiraIssueCreateFieldsInContext(
            fieldsFilter: USER_CONFIGURED_FIELDS
            project: $project
            issueType: $issueType
            additionalContext: $additionalContext
            requestType: $requestType
            defaultValues: $defaultValues
            ${$e36e4a45a2b75358$var$isCreateLinkedIssueTriggerPointEnabled() ? 'issueCreateType: $issueCreateType' : ''}
        ) {
            ... on JiraIssueCreateFields {
                fields {
                    nodes {
                        ...BaseFieldFragment
                        ...ProjectFieldFragment
                        ...IssueTypeFieldFragment
                        ...RequestTypeFieldFragment
                        ...TextFieldFragment
                        ...RichTextFieldFragment
                        ...ComponentsFieldFragment
                        ...VersionFieldFragment
                        ...MultiVersionFieldFragment
                        ...PriorityFieldFragment
                        ...SprintFieldFragment
                        ...LabelFieldFragment
                        ...SingleUserPickerFieldFragment
                        ...MultiUserPickerFieldFragment
                        ...PeopleFieldFragment
                        ...SecurityFieldFragment
                        ...IssueRestrictionFieldFragment
                        ...ColorFieldFragment
                        ...ResolutionFieldFragment
                        ...SingleSelectFieldFragment
                        ...MultiSelectFieldFragment
                        ...NumberFieldFragment
                        ...UrlFieldFragment
                        ...EpicLinkFieldFragment
                        ...DatePickerFieldFragment
                        ...DateTimePickerFieldFragment
                        ...CascadingSelectFieldFragment
                        ...AttachmentsFieldFragment
                        ...CheckboxFieldFragment
                        ${$e36e4a45a2b75358$var$isCreateLinkedIssueTriggerPointEnabled() ? '...IssueLinksFieldFragmentWithCopyLinksAndAttachments' : '...IssueLinksFieldFragment'}
                        ...SingleGroupPickerFieldFragment
                        ...MultiGroupPickerFieldFragment
                        ...TeamFieldFragment
                        ...AtlassianTeamFieldFragment
                        ...RadioSelectFieldFragment
                        ...AffectedServicesFieldFragment
                        ...CMDBFieldFragment
                        ...OrganizationsFieldFragment
                        ...ConnectTextFieldFragment
                        ...ConnectNumberFieldFragment
                        ...ConnectSingleSelectFieldFragment
                        ...ConnectMultiSelectFieldFragment
                        ...ConnectRichTextFieldFragment
                        ...AssetFieldFragment
                        ...ForgeStringFieldFragment
                        ...ForgeNumberFieldFragment
                        ...ForgeSingleUserPickerFieldFragment
                        ...ForgeMultiUserPickerFieldFragment
                        ...ForgeGroupPickerFieldFragment
                        ...ForgeMultiGroupPickerFieldFragment
                        ...ForgeStringsFieldFragment
                        ...ForgeObjectFieldFragment
                        ...ForgeDateTimePickerFieldFragment
                        ...TimeTrackingFieldFragment
                        ...WorkLogFieldFragment
                        ...JsmMultiUserPickerFieldFragment
                        ...JsmPeopleFieldFragment
                        ...ParentLinkFieldFragment
                        ${$e36e4a45a2b75358$var$isParentFieldInGicEnabled() ? '...ParentFieldFragment' : ''}
                        ...StatusFieldFragment
                        ${$e36e4a45a2b75358$var$isJsmRespondersFieldEnabled() ? '...JiraServiceManagementRespondersFieldFragment' : ''}
                    }
                }
                errors {
                    identifier
                    extensions {
                        ... on JiraIssueFieldUnsupportedErrorExtension {
                            fieldName
                            fieldType
                            isRequiredField
                        }
                        ... on JiraIssueFieldValueValidationErrorExtension {
                            errorType
                            message
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
        jiraIssueCreateAdditionalServices(project: $project, issueType: $issueType, requestType: $requestType) {
            ... on JiraIssueCreateAdditionalServices {
                services {
                    edges {
                        node {
                            ...WatchersConfigFragment
                            ...ProformaConfigFragment
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
    }
    ${withML ? (0, $frihL.LAYOUT_FRAGMENT_WITH_ML) : (0, $frihL.LAYOUT_FRAGMENT)}
    ${0, $frihL.BASE_FIELD_FRAGMENT}
    ${0, $frihL.PROJECT_FIELD_FRAGMENT}
    ${0, $frihL.ISSUE_TYPE_FIELD_FRAGMENT}
    ${0, $frihL.REQUEST_TYPE_FIELD_FRAGMENT}
    ${0, $frihL.TEXT_FIELD_FRAGMENT}
    ${0, $frihL.RICH_TEXT_FIELD_FRAGMENT}
    ${0, $frihL.COMPONENTS_FIELD_FRAGMENT}
    ${0, $frihL.VERSION_FIELD_FRAGMENT}
    ${0, $frihL.MULTI_VERSION_FIELD_FRAGMENT}
    ${0, $frihL.PRIORITY_FIELD_FRAGMENT}
    ${0, $frihL.SPRINT_FIELD_FRAGMENT}
    ${0, $frihL.LABEL_FIELD_FRAGMENT}
    ${0, $frihL.SINGLE_USER_PICKER_FIELD_FRAGMENT}
    ${0, $frihL.MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, $frihL.SECURITY_FIELD_FRAGMENT}
    ${0, $frihL.ISSUE_RESTRICTION_FIELD_FRAGMENT}
    ${0, $frihL.COLOR_FIELD_FRAGMENT}
    ${0, $frihL.RESOLUTION_FIELD_FRAGMENT}
    ${0, $frihL.SINGLE_SELECT_FIELD_FRAGMENT}
    ${0, $frihL.MULTI_SELECT_FIELD_FRAGMENT}
    ${0, $frihL.NUMBER_FIELD_FRAGMENT}
    ${0, $frihL.URL_FIELD_FRAGMENT}
    ${0, $frihL.EPIC_LINK_FIELD_FRAGMENT}
    ${0, $frihL.DATE_FIELD_FRAGMENT}
    ${0, $frihL.DATE_TIME_FIELD_FRAGMENT}
    ${0, $frihL.CASCADING_SELECT_FIELD_FRAGMENT}
    ${0, $frihL.ATTACHMENTS_FIELD_FRAGMENT}
    ${0, $frihL.CHECKBOX_FIELD_FRAGMENT}
    ${$e36e4a45a2b75358$var$isCreateLinkedIssueTriggerPointEnabled() ? (0, $frihL.ISSUE_LINKS_FIELD_FRAGMENT_WITH_COPY_LINKS_AND_ATTACHMENTS) : (0, $frihL.ISSUE_LINKS_FIELD_FRAGMENT)}
    ${0, $frihL.SINGLE_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $frihL.MULTI_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $frihL.PEOPLE_FIELD_FRAGMENT}
    ${0, $frihL.TEAM_FIELD_FRAGMENT}
    ${0, $frihL.ATLASSIAN_TEAM_FIELD_FRAGMENT}
    ${0, $frihL.RADIO_SELECT_FIELD_FRAGMENT}
    ${0, $frihL.AFFECTED_SERVICES_FIELD_FRAGMENT}
    ${0, $frihL.CMDB_FIELD_FRAGMENT}
    ${0, $frihL.ORGANIZATIONS_FIELD_FRAGMENT}
    ${0, $frihL.CONNECT_TEXT_FIELD_FRAGMENT}
    ${0, $frihL.CONNECT_NUMBER_FIELD_FRAGMENT}
    ${0, $frihL.CONNECT_SINGLE_SELECT_FIELD_FRAGMENT}
    ${0, $frihL.CONNECT_MULTI_SELECT_FIELD_FRAGMENT}
    ${0, $frihL.CONNECT_RICH_TEXT_FIELD_FRAGMENT}
    ${0, $frihL.ASSET_FIELD_FRAGMENT}
    ${0, $frihL.FORGE_STRING_FIELD_FRAGMENT}
    ${0, $frihL.FORGE_NUMBER_FIELD_FRAGMENT}
    ${0, $frihL.FORGE_SINGLE_USER_PICKER_FIELD_FRAGMENT}
    ${0, $frihL.FORGE_MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, $frihL.FORGE_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $frihL.FORGE_MULTI_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $frihL.FORGE_STRINGS_FIELD_FRAGMENT}
    ${0, $frihL.FORGE_DATETIME_FIELD_FRAGMENT}
    ${0, $frihL.FORGE_OBJECT_FIELD_FRAGMENT}
    ${0, $frihL.TIME_TRACKING_FIELD_FRAGMENT}
    ${0, $frihL.WORK_LOG_FIELD_FRAGMENT}
    ${0, $frihL.JSM_MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, $frihL.JSM_PEOPLE_FIELD_FRAGMENT}
    ${0, $frihL.PARENT_LINK_FIELD_FRAGMENT}
    ${$e36e4a45a2b75358$var$isParentFieldInGicEnabled() ? (0, $frihL.PARENT_FIELD_FRAGMENT) : ''}
    ${0, $frihL.PROFORMA_CONFIG_FRAGMENT}
    ${0, $frihL.STATUS_FIELD_FRAGMENT}
    ${$e36e4a45a2b75358$var$isJsmRespondersFieldEnabled() ? (0, $frihL.RESPONDERS_FIELD_FRAGMENT) : ''}
    ${0, $frihL.WATCHERS_CONFIG_FRAGMENT}
`;

});

parcelRegister("6HW6N", function(module, exports) {

$parcel$export(module.exports, "CREATE_CONFIG_USER_PREFERRED_QUERY_IN_CONTEXT", () => $7c3173caf1f6ed90$export$e53f901243688733);
// TODO Delete this file when cleaning gic-smart-fields-jira-labs_8uwvr
// eslint-disable-next-line jira/restricted/graphql-tag

var $9ypom = parcelRequire("9ypom");

var $1ybV0 = parcelRequire("1ybV0");

var $frihL = parcelRequire("frihL");
// eslint-disable-next-line jira/ff/inline-usage
const $7c3173caf1f6ed90$var$isJsmRespondersFieldEnabled = ()=>(0, $1ybV0.ff)('jsm-responders-field-in-gicx-ui', false);
// eslint-disable-next-line jira/ff/inline-usage
const $7c3173caf1f6ed90$var$isParentFieldInGicEnabled = ()=>(0, $1ybV0.ff)('parent-field-in-gic_d3b3n', false);
// eslint-disable-next-line jira/ff/inline-usage
const $7c3173caf1f6ed90$var$isCreateLinkedIssueTriggerPointEnabled = ()=>(0, $1ybV0.ff)('create-linked-issues-trigger-point-issue-view', false);
const $7c3173caf1f6ed90$export$e53f901243688733 = (0, $9ypom.default)`
    query JiraGlobalIssueCreateInContext(
        $project: JiraProjectInput
        $issueType: JiraIssueTypeInput
        $requestType: JiraRequestTypeInput
        $defaultValues: JiraIssueFieldsInput
        $additionalContext: JiraIssueCreateContextInput!
        ${$7c3173caf1f6ed90$var$isCreateLinkedIssueTriggerPointEnabled() ? '$issueCreateType: IssueCreateTypeFilter' : ''}
    ) {
        jiraIssueCreateLayoutInContext(
            layoutFilter: USER_CONFIGURED_LAYOUT
            project: $project
            issueType: $issueType
            additionalContext: $additionalContext
            ${$7c3173caf1f6ed90$var$isCreateLinkedIssueTriggerPointEnabled() ? 'issueCreateType: $issueCreateType' : ''}
        ) {
            ...LayoutFragment
        }
        jiraIssueCreateFieldsInContext(
            fieldsFilter: USER_CONFIGURED_FIELDS
            project: $project
            issueType: $issueType
            additionalContext: $additionalContext
            requestType: $requestType
            defaultValues: $defaultValues
            ${$7c3173caf1f6ed90$var$isCreateLinkedIssueTriggerPointEnabled() ? 'issueCreateType: $issueCreateType' : ''}
        ) {
            ... on JiraIssueCreateFields {
                fields {
                    nodes {
                        ...BaseFieldFragment
                        ...ProjectFieldFragment
                        ...IssueTypeFieldFragment
                        ...RequestTypeFieldFragment
                        ...TextFieldFragment
                        ...RichTextFieldFragment
                        ...ComponentsFieldFragment
                        ...VersionFieldFragment
                        ...MultiVersionFieldFragment
                        ...PriorityFieldFragment
                        ...SprintFieldFragment
                        ...LabelFieldFragment
                        ...SingleUserPickerFieldFragment
                        ...MultiUserPickerFieldFragment
                        ...PeopleFieldFragment
                        ...SecurityFieldFragment
                        ...IssueRestrictionFieldFragment
                        ...ColorFieldFragment
                        ...ResolutionFieldFragment
                        ...SingleSelectFieldFragment
                        ...MultiSelectFieldFragment
                        ...NumberFieldFragment
                        ...UrlFieldFragment
                        ...EpicLinkFieldFragment
                        ...DatePickerFieldFragment
                        ...DateTimePickerFieldFragment
                        ...CascadingSelectFieldFragment
                        ...AttachmentsFieldFragment
                        ...CheckboxFieldFragment
                        ${$7c3173caf1f6ed90$var$isCreateLinkedIssueTriggerPointEnabled() ? '...IssueLinksFieldFragmentWithCopyLinksAndAttachments' : '...IssueLinksFieldFragment'}
                        ...SingleGroupPickerFieldFragment
                        ...MultiGroupPickerFieldFragment
                        ...TeamFieldFragment
                        ...AtlassianTeamFieldFragment
                        ...RadioSelectFieldFragment
                        ...AffectedServicesFieldFragment
                        ...CMDBFieldFragment
                        ...OrganizationsFieldFragment
                        ...ConnectTextFieldFragment
                        ...ConnectNumberFieldFragment
                        ...ConnectSingleSelectFieldFragment
                        ...ConnectMultiSelectFieldFragment
                        ...ConnectRichTextFieldFragment
                        ...AssetFieldFragment
                        ...ForgeStringFieldFragment
                        ...ForgeNumberFieldFragment
                        ...ForgeSingleUserPickerFieldFragment
                        ...ForgeMultiUserPickerFieldFragment
                        ...ForgeGroupPickerFieldFragment
                        ...ForgeMultiGroupPickerFieldFragment
                        ...ForgeStringsFieldFragment
                        ...ForgeObjectFieldFragment
                        ...ForgeDateTimePickerFieldFragment
                        ...TimeTrackingFieldFragment
                        ...WorkLogFieldFragment
                        ...JsmMultiUserPickerFieldFragment
                        ...JsmPeopleFieldFragment
                        ...ParentLinkFieldFragment
                        ${$7c3173caf1f6ed90$var$isParentFieldInGicEnabled() ? '...ParentFieldFragment' : ''}
                        ...StatusFieldFragment
                        ${$7c3173caf1f6ed90$var$isJsmRespondersFieldEnabled() ? '...JiraServiceManagementRespondersFieldFragment' : ''}
                    }
                }
                errors {
                    identifier
                    extensions {
                        ... on JiraIssueFieldUnsupportedErrorExtension {
                            fieldName
                            fieldType
                            isRequiredField
                        }
                        ... on JiraIssueFieldValueValidationErrorExtension {
                            errorType
                            message
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
        jiraIssueCreateAdditionalServices(project: $project, issueType: $issueType, requestType: $requestType) {
            ... on JiraIssueCreateAdditionalServices {
                services {
                    edges {
                        node {
                            ...WatchersConfigFragment
                            ...ProformaConfigFragment
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
    }
    ${(0, $frihL.LAYOUT_FRAGMENT)}
    ${(0, $frihL.BASE_FIELD_FRAGMENT)}
    ${(0, $frihL.PROJECT_FIELD_FRAGMENT)}
    ${(0, $frihL.ISSUE_TYPE_FIELD_FRAGMENT)}
    ${(0, $frihL.REQUEST_TYPE_FIELD_FRAGMENT)}
    ${(0, $frihL.TEXT_FIELD_FRAGMENT)}
    ${(0, $frihL.RICH_TEXT_FIELD_FRAGMENT)}
    ${(0, $frihL.COMPONENTS_FIELD_FRAGMENT)}
    ${(0, $frihL.VERSION_FIELD_FRAGMENT)}
    ${(0, $frihL.MULTI_VERSION_FIELD_FRAGMENT)}
    ${(0, $frihL.PRIORITY_FIELD_FRAGMENT)}
    ${(0, $frihL.SPRINT_FIELD_FRAGMENT)}
    ${(0, $frihL.LABEL_FIELD_FRAGMENT)}
    ${(0, $frihL.SINGLE_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, $frihL.MULTI_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, $frihL.SECURITY_FIELD_FRAGMENT)}
    ${(0, $frihL.ISSUE_RESTRICTION_FIELD_FRAGMENT)}
    ${(0, $frihL.COLOR_FIELD_FRAGMENT)}
    ${(0, $frihL.RESOLUTION_FIELD_FRAGMENT)}
    ${(0, $frihL.SINGLE_SELECT_FIELD_FRAGMENT)}
    ${(0, $frihL.MULTI_SELECT_FIELD_FRAGMENT)}
    ${(0, $frihL.NUMBER_FIELD_FRAGMENT)}
    ${(0, $frihL.URL_FIELD_FRAGMENT)}
    ${(0, $frihL.EPIC_LINK_FIELD_FRAGMENT)}
    ${(0, $frihL.DATE_FIELD_FRAGMENT)}
    ${(0, $frihL.DATE_TIME_FIELD_FRAGMENT)}
    ${(0, $frihL.CASCADING_SELECT_FIELD_FRAGMENT)}
    ${(0, $frihL.ATTACHMENTS_FIELD_FRAGMENT)}
    ${(0, $frihL.CHECKBOX_FIELD_FRAGMENT)}
    ${$7c3173caf1f6ed90$var$isCreateLinkedIssueTriggerPointEnabled() ? (0, $frihL.ISSUE_LINKS_FIELD_FRAGMENT_WITH_COPY_LINKS_AND_ATTACHMENTS) : (0, $frihL.ISSUE_LINKS_FIELD_FRAGMENT)}
    ${(0, $frihL.SINGLE_GROUP_PICKER_FIELD_FRAGMENT)}
    ${(0, $frihL.MULTI_GROUP_PICKER_FIELD_FRAGMENT)}
    ${(0, $frihL.PEOPLE_FIELD_FRAGMENT)}
    ${(0, $frihL.TEAM_FIELD_FRAGMENT)}
    ${(0, $frihL.ATLASSIAN_TEAM_FIELD_FRAGMENT)}
    ${(0, $frihL.RADIO_SELECT_FIELD_FRAGMENT)}
    ${(0, $frihL.AFFECTED_SERVICES_FIELD_FRAGMENT)}
    ${(0, $frihL.CMDB_FIELD_FRAGMENT)}
    ${(0, $frihL.ORGANIZATIONS_FIELD_FRAGMENT)}
    ${(0, $frihL.CONNECT_TEXT_FIELD_FRAGMENT)}
    ${(0, $frihL.CONNECT_NUMBER_FIELD_FRAGMENT)}
    ${(0, $frihL.CONNECT_SINGLE_SELECT_FIELD_FRAGMENT)}
    ${(0, $frihL.CONNECT_MULTI_SELECT_FIELD_FRAGMENT)}
    ${(0, $frihL.CONNECT_RICH_TEXT_FIELD_FRAGMENT)}
    ${(0, $frihL.ASSET_FIELD_FRAGMENT)}
    ${(0, $frihL.FORGE_STRING_FIELD_FRAGMENT)}
    ${(0, $frihL.FORGE_NUMBER_FIELD_FRAGMENT)}
    ${(0, $frihL.FORGE_SINGLE_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, $frihL.FORGE_MULTI_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, $frihL.FORGE_GROUP_PICKER_FIELD_FRAGMENT)}
    ${(0, $frihL.FORGE_MULTI_GROUP_PICKER_FIELD_FRAGMENT)}
    ${(0, $frihL.FORGE_STRINGS_FIELD_FRAGMENT)}
    ${(0, $frihL.FORGE_DATETIME_FIELD_FRAGMENT)}
    ${(0, $frihL.FORGE_OBJECT_FIELD_FRAGMENT)}
    ${(0, $frihL.TIME_TRACKING_FIELD_FRAGMENT)}
    ${(0, $frihL.WORK_LOG_FIELD_FRAGMENT)}
    ${(0, $frihL.JSM_MULTI_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, $frihL.JSM_PEOPLE_FIELD_FRAGMENT)}
    ${(0, $frihL.PARENT_LINK_FIELD_FRAGMENT)}
    ${$7c3173caf1f6ed90$var$isParentFieldInGicEnabled() ? (0, $frihL.PARENT_FIELD_FRAGMENT) : ''}
    ${(0, $frihL.PROFORMA_CONFIG_FRAGMENT)}
    ${(0, $frihL.STATUS_FIELD_FRAGMENT)}
    ${$7c3173caf1f6ed90$var$isJsmRespondersFieldEnabled() ? (0, $frihL.RESPONDERS_FIELD_FRAGMENT) : ''}
    ${(0, $frihL.WATCHERS_CONFIG_FRAGMENT)}
`;

});


parcelRegister("1vkQL", function(module, exports) {

$parcel$export(module.exports, "default", () => $77462808e2493a7a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iZuDo = parcelRequire("iZuDo");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $dRkzf = parcelRequire("dRkzf");

var $6JePA = parcelRequire("6JePA");

var $deodO = parcelRequire("deodO");

var $fRm57 = parcelRequire("fRm57");

var $7aVD8 = parcelRequire("7aVD8");
const $77462808e2493a7a$var$useFetchSubtaskCreateConfigQuery = (props = {})=>{
    const { displayOnlyRequiredFields: displayOnlyRequiredFields = false, triggerPointKey: triggerPointKey } = props;
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const [fetchError, setFetchError] = (0, $eUqFw.useState)(null);
    const apiStartTime = (0, $eUqFw.useRef)(0);
    const [apiLatency, setApiLatency] = (0, $eUqFw.useState)(0);
    const [data, setData] = (0, $eUqFw.useState)({
        fieldTabs: [],
        fieldConfig: {},
        contextFields: {},
        meta: {
            areRequiredFieldsSupported: true,
            queryErrorMessage: ''
        },
        additionalServices: {}
    });
    const { withMachineLearning: withMachineLearning } = (0, $1ybV0.ff)('gic-smart-fields-jira-labs_8uwvr') ? (0, $deodO.useSmartFieldsMachineLearning)() : {
        withMachineLearning: false
    };
    const [fetchSubtaskConfig] = (0, $iZuDo.useLazyQuery)((0, $1ybV0.ff)('gic-smart-fields-jira-labs_8uwvr') ? (0, $fRm57.getCreateSubtaskConfigUserPreferredQuery)(withMachineLearning) : (0, $7aVD8.CREATE_SUBTASK_CONFIG_USER_PREFERRED_QUERY), {
        fetchPolicy: 'no-cache',
        onCompleted: (queryData)=>{
            setApiLatency(Math.floor(performance.now() - apiStartTime.current));
            setData((0, $6JePA.transformQueryResults)((0, $6JePA.tranformSubtaskData)(queryData), displayOnlyRequiredFields));
            setLoading(false);
        },
        onError: (error)=>{
            setFetchError(error);
            (0, $guiFP.default)({
                meta: {
                    id: 'useFetchSubtaskCreateConfigQuery',
                    packageName: 'jiraIssueCreate',
                    teamName: 'gryffindor'
                },
                error: error,
                attributes: {
                    errorType: (0, $dRkzf.handleApolloError)(error),
                    triggerPointKey: triggerPointKey
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    });
    const handleFetch = (0, $eUqFw.useRef)((queryVariables)=>{
        setLoading(true);
        apiStartTime.current = performance.now();
        fetchSubtaskConfig(queryVariables);
    });
    return [
        {
            isLoading: loading,
            fieldTabs: data.fieldTabs,
            fieldConfig: data.fieldConfig,
            contextFields: data.contextFields,
            meta: data.meta,
            error: fetchError,
            apiLatency: apiLatency,
            additionalServices: data.additionalServices
        },
        handleFetch.current
    ];
};
var $77462808e2493a7a$export$2e2bcd8739ae039 = $77462808e2493a7a$var$useFetchSubtaskCreateConfigQuery;

});
parcelRegister("fRm57", function(module, exports) {

$parcel$export(module.exports, "getCreateSubtaskConfigUserPreferredQuery", () => $aa3d6e251ebb8ec6$export$466926765053d2bb);
// eslint-disable-next-line jira/restricted/graphql-tag

var $9ypom = parcelRequire("9ypom");

var $1ybV0 = parcelRequire("1ybV0");

var $frihL = parcelRequire("frihL");
// eslint-disable-next-line jira/ff/inline-usage
const $aa3d6e251ebb8ec6$var$isJsmRespondersFieldEnabled = ()=>(0, $1ybV0.ff)('jsm-responders-field-in-gicx-ui', false);
// eslint-disable-next-line jira/ff/inline-usage
const $aa3d6e251ebb8ec6$var$isParentFieldInGicEnabled = ()=>(0, $1ybV0.ff)('parent-field-in-gic_d3b3n', false);
const $aa3d6e251ebb8ec6$export$466926765053d2bb = (withML)=>(0, $9ypom.default)`
    query JiraGlobalSubtaskIssueCreateModalLoad(
        $project: JiraProjectInput
        $issueType: JiraIssueTypeInput
        $requestType: JiraRequestTypeInput
        $parentId: JiraParentIdInput!
        $defaultValues: JiraIssueFieldsInput
    ) {
        ${withML ? 'jiraSubtaskCreationLayoutWithML' : 'jiraSubtaskCreationLayout'}(
            layoutFilter: USER_CONFIGURED_LAYOUT
            project: $project
            issueType: $issueType
            parentId: $parentId
        ) {
            ...LayoutFragment
        }
        jiraSubtaskCreationFields(
            fieldsFilter: USER_CONFIGURED_FIELDS
            project: $project
            issueType: $issueType
            parentId: $parentId
            requestType: $requestType
            defaultValues: $defaultValues
        ) {
            ... on JiraIssueCreateFields {
                fields {
                    nodes {
                        ...BaseFieldFragment
                        ...ProjectFieldFragment
                        ...IssueTypeFieldFragment
                        ...RequestTypeFieldFragment
                        ...TextFieldFragment
                        ...RichTextFieldFragment
                        ...ComponentsFieldFragment
                        ...VersionFieldFragment
                        ...MultiVersionFieldFragment
                        ...PriorityFieldFragment
                        ...SprintFieldFragment
                        ...LabelFieldFragment
                        ...SingleUserPickerFieldFragment
                        ...MultiUserPickerFieldFragment
                        ...PeopleFieldFragment
                        ...SecurityFieldFragment
                        ...IssueRestrictionFieldFragment
                        ...ColorFieldFragment
                        ...ResolutionFieldFragment
                        ...SingleSelectFieldFragment
                        ...MultiSelectFieldFragment
                        ...NumberFieldFragment
                        ...UrlFieldFragment
                        ...EpicLinkFieldFragment
                        ...DatePickerFieldFragment
                        ...DateTimePickerFieldFragment
                        ...CascadingSelectFieldFragment
                        ...AttachmentsFieldFragment
                        ...CheckboxFieldFragment
                        ...IssueLinksFieldFragment
                        ...SingleGroupPickerFieldFragment
                        ...MultiGroupPickerFieldFragment
                        ...TeamFieldFragment
                        ...AtlassianTeamFieldFragment
                        ...RadioSelectFieldFragment
                        ...AffectedServicesFieldFragment
                        ...CMDBFieldFragment
                        ...OrganizationsFieldFragment
                        ...ConnectTextFieldFragment
                        ...ConnectNumberFieldFragment
                        ...ConnectSingleSelectFieldFragment
                        ...ConnectMultiSelectFieldFragment
                        ...ConnectRichTextFieldFragment
                        ...AssetFieldFragment
                        ...ForgeStringFieldFragment
                        ...ForgeNumberFieldFragment
                        ...ForgeSingleUserPickerFieldFragment
                        ...ForgeMultiUserPickerFieldFragment
                        ...ForgeGroupPickerFieldFragment
                        ...ForgeMultiGroupPickerFieldFragment
                        ...ForgeStringsFieldFragment
                        ...ForgeObjectFieldFragment
                        ...ForgeDateTimePickerFieldFragment
                        ...TimeTrackingFieldFragment
                        ...WorkLogFieldFragment
                        ...JsmMultiUserPickerFieldFragment
                        ...JsmPeopleFieldFragment
                        ...ParentLinkFieldFragment
                        ${$aa3d6e251ebb8ec6$var$isParentFieldInGicEnabled() ? '...ParentFieldFragment' : ''}
                        ...StatusFieldFragment
                        ${$aa3d6e251ebb8ec6$var$isJsmRespondersFieldEnabled() ? '...JiraServiceManagementRespondersFieldFragment' : ''}
                    }
                }
                errors {
                    identifier
                    extensions {
                        ... on JiraIssueFieldUnsupportedErrorExtension {
                            fieldName
                            fieldType
                            isRequiredField
                        }
                        ... on JiraIssueFieldValueValidationErrorExtension {
                            errorType
                            message
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
        jiraSubtaskCreationAdditionalServices(project: $project, issueType: $issueType, requestType: $requestType, parentId: $parentId) {
            ... on JiraIssueCreateAdditionalServices {
                services {
                    edges {
                        node {
                            ...WatchersConfigFragment
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
    }
    ${withML ? (0, $frihL.LAYOUT_FRAGMENT_WITH_ML) : (0, $frihL.LAYOUT_FRAGMENT)}
    ${0, $frihL.BASE_FIELD_FRAGMENT}
    ${0, $frihL.PROJECT_FIELD_FRAGMENT}
    ${0, $frihL.ISSUE_TYPE_FIELD_FRAGMENT}
    ${0, $frihL.REQUEST_TYPE_FIELD_FRAGMENT}
    ${0, $frihL.TEXT_FIELD_FRAGMENT}
    ${0, $frihL.RICH_TEXT_FIELD_FRAGMENT}
    ${0, $frihL.COMPONENTS_FIELD_FRAGMENT}
    ${0, $frihL.VERSION_FIELD_FRAGMENT}
    ${0, $frihL.MULTI_VERSION_FIELD_FRAGMENT}
    ${0, $frihL.PRIORITY_FIELD_FRAGMENT}
    ${0, $frihL.SPRINT_FIELD_FRAGMENT}
    ${0, $frihL.LABEL_FIELD_FRAGMENT}
    ${0, $frihL.SINGLE_USER_PICKER_FIELD_FRAGMENT}
    ${0, $frihL.MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, $frihL.SECURITY_FIELD_FRAGMENT}
    ${0, $frihL.ISSUE_RESTRICTION_FIELD_FRAGMENT}
    ${0, $frihL.COLOR_FIELD_FRAGMENT}
    ${0, $frihL.RESOLUTION_FIELD_FRAGMENT}
    ${0, $frihL.SINGLE_SELECT_FIELD_FRAGMENT}
    ${0, $frihL.MULTI_SELECT_FIELD_FRAGMENT}
    ${0, $frihL.NUMBER_FIELD_FRAGMENT}
    ${0, $frihL.URL_FIELD_FRAGMENT}
    ${0, $frihL.EPIC_LINK_FIELD_FRAGMENT}
    ${0, $frihL.DATE_FIELD_FRAGMENT}
    ${0, $frihL.DATE_TIME_FIELD_FRAGMENT}
    ${0, $frihL.CASCADING_SELECT_FIELD_FRAGMENT}
    ${0, $frihL.ATTACHMENTS_FIELD_FRAGMENT}
    ${0, $frihL.CHECKBOX_FIELD_FRAGMENT}
    ${0, $frihL.ISSUE_LINKS_FIELD_FRAGMENT}
    ${0, $frihL.SINGLE_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $frihL.MULTI_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $frihL.PEOPLE_FIELD_FRAGMENT}
    ${0, $frihL.TEAM_FIELD_FRAGMENT}
    ${0, $frihL.ATLASSIAN_TEAM_FIELD_FRAGMENT}
    ${0, $frihL.RADIO_SELECT_FIELD_FRAGMENT}
    ${0, $frihL.AFFECTED_SERVICES_FIELD_FRAGMENT}
    ${0, $frihL.CMDB_FIELD_FRAGMENT}
    ${0, $frihL.ORGANIZATIONS_FIELD_FRAGMENT}
    ${0, $frihL.CONNECT_TEXT_FIELD_FRAGMENT}
    ${0, $frihL.CONNECT_NUMBER_FIELD_FRAGMENT}
    ${0, $frihL.CONNECT_SINGLE_SELECT_FIELD_FRAGMENT}
    ${0, $frihL.CONNECT_MULTI_SELECT_FIELD_FRAGMENT}
    ${0, $frihL.CONNECT_RICH_TEXT_FIELD_FRAGMENT}
    ${0, $frihL.ASSET_FIELD_FRAGMENT}
    ${0, $frihL.FORGE_STRING_FIELD_FRAGMENT}
    ${0, $frihL.FORGE_NUMBER_FIELD_FRAGMENT}
    ${0, $frihL.FORGE_SINGLE_USER_PICKER_FIELD_FRAGMENT}
    ${0, $frihL.FORGE_MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, $frihL.FORGE_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $frihL.FORGE_MULTI_GROUP_PICKER_FIELD_FRAGMENT}
    ${0, $frihL.FORGE_STRINGS_FIELD_FRAGMENT}
    ${0, $frihL.FORGE_DATETIME_FIELD_FRAGMENT}
    ${0, $frihL.FORGE_OBJECT_FIELD_FRAGMENT}
    ${0, $frihL.TIME_TRACKING_FIELD_FRAGMENT}
    ${0, $frihL.WORK_LOG_FIELD_FRAGMENT}
    ${0, $frihL.JSM_MULTI_USER_PICKER_FIELD_FRAGMENT}
    ${0, $frihL.JSM_PEOPLE_FIELD_FRAGMENT}
    ${0, $frihL.PARENT_LINK_FIELD_FRAGMENT}
    ${$aa3d6e251ebb8ec6$var$isParentFieldInGicEnabled() ? (0, $frihL.PARENT_FIELD_FRAGMENT) : ''}
    ${0, $frihL.STATUS_FIELD_FRAGMENT}
    ${$aa3d6e251ebb8ec6$var$isJsmRespondersFieldEnabled() ? (0, $frihL.RESPONDERS_FIELD_FRAGMENT) : ''}
    ${0, $frihL.WATCHERS_CONFIG_FRAGMENT}
`;

});

parcelRegister("7aVD8", function(module, exports) {

$parcel$export(module.exports, "CREATE_SUBTASK_CONFIG_USER_PREFERRED_QUERY", () => $ba7be233185cd2bd$export$2eaff1450330d724);
// TODO Delete this file when cleaning gic-smart-fields-jira-labs_8uwvr
// eslint-disable-next-line jira/restricted/graphql-tag

var $9ypom = parcelRequire("9ypom");

var $1ybV0 = parcelRequire("1ybV0");

var $frihL = parcelRequire("frihL");
// eslint-disable-next-line jira/ff/inline-usage
const $ba7be233185cd2bd$var$isJsmRespondersFieldEnabled = ()=>(0, $1ybV0.ff)('jsm-responders-field-in-gicx-ui', false);
// eslint-disable-next-line jira/ff/inline-usage
const $ba7be233185cd2bd$var$isParentFieldInGicEnabled = ()=>(0, $1ybV0.ff)('parent-field-in-gic_d3b3n', false);
const $ba7be233185cd2bd$export$2eaff1450330d724 = (0, $9ypom.default)`
    query JiraGlobalSubtaskIssueCreateModalLoad(
        $project: JiraProjectInput
        $issueType: JiraIssueTypeInput
        $requestType: JiraRequestTypeInput
        $parentId: JiraParentIdInput!
        $defaultValues: JiraIssueFieldsInput
    ) {
        jiraSubtaskCreationLayout(
            layoutFilter: USER_CONFIGURED_LAYOUT
            project: $project
            issueType: $issueType
            parentId: $parentId
        ) {
            ...LayoutFragment
        }
        jiraSubtaskCreationFields(
            fieldsFilter: USER_CONFIGURED_FIELDS
            project: $project
            issueType: $issueType
            parentId: $parentId
            requestType: $requestType
            defaultValues: $defaultValues
        ) {
            ... on JiraIssueCreateFields {
                fields {
                    nodes {
                        ...BaseFieldFragment
                        ...ProjectFieldFragment
                        ...IssueTypeFieldFragment
                        ...RequestTypeFieldFragment
                        ...TextFieldFragment
                        ...RichTextFieldFragment
                        ...ComponentsFieldFragment
                        ...VersionFieldFragment
                        ...MultiVersionFieldFragment
                        ...PriorityFieldFragment
                        ...SprintFieldFragment
                        ...LabelFieldFragment
                        ...SingleUserPickerFieldFragment
                        ...MultiUserPickerFieldFragment
                        ...PeopleFieldFragment
                        ...SecurityFieldFragment
                        ...IssueRestrictionFieldFragment
                        ...ColorFieldFragment
                        ...ResolutionFieldFragment
                        ...SingleSelectFieldFragment
                        ...MultiSelectFieldFragment
                        ...NumberFieldFragment
                        ...UrlFieldFragment
                        ...EpicLinkFieldFragment
                        ...DatePickerFieldFragment
                        ...DateTimePickerFieldFragment
                        ...CascadingSelectFieldFragment
                        ...AttachmentsFieldFragment
                        ...CheckboxFieldFragment
                        ...IssueLinksFieldFragment
                        ...SingleGroupPickerFieldFragment
                        ...MultiGroupPickerFieldFragment
                        ...TeamFieldFragment
                        ...AtlassianTeamFieldFragment
                        ...RadioSelectFieldFragment
                        ...AffectedServicesFieldFragment
                        ...CMDBFieldFragment
                        ...OrganizationsFieldFragment
                        ...ConnectTextFieldFragment
                        ...ConnectNumberFieldFragment
                        ...ConnectSingleSelectFieldFragment
                        ...ConnectMultiSelectFieldFragment
                        ...ConnectRichTextFieldFragment
                        ...AssetFieldFragment
                        ...ForgeStringFieldFragment
                        ...ForgeNumberFieldFragment
                        ...ForgeSingleUserPickerFieldFragment
                        ...ForgeMultiUserPickerFieldFragment
                        ...ForgeGroupPickerFieldFragment
                        ...ForgeMultiGroupPickerFieldFragment
                        ...ForgeStringsFieldFragment
                        ...ForgeObjectFieldFragment
                        ...ForgeDateTimePickerFieldFragment
                        ...TimeTrackingFieldFragment
                        ...WorkLogFieldFragment
                        ...JsmMultiUserPickerFieldFragment
                        ...JsmPeopleFieldFragment
                        ...ParentLinkFieldFragment
                        ${$ba7be233185cd2bd$var$isParentFieldInGicEnabled() ? '...ParentFieldFragment' : ''}
                        ...StatusFieldFragment
                        ${$ba7be233185cd2bd$var$isJsmRespondersFieldEnabled() ? '...JiraServiceManagementRespondersFieldFragment' : ''}
                    }
                }
                errors {
                    identifier
                    extensions {
                        ... on JiraIssueFieldUnsupportedErrorExtension {
                            fieldName
                            fieldType
                            isRequiredField
                        }
                        ... on JiraIssueFieldValueValidationErrorExtension {
                            errorType
                            message
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
        jiraSubtaskCreationAdditionalServices(project: $project, issueType: $issueType, requestType: $requestType, parentId: $parentId) {
            ... on JiraIssueCreateAdditionalServices {
                services {
                    edges {
                        node {
                            ...WatchersConfigFragment
                        }
                    }
                }
            }
            ... on QueryError {
                message
            }
        }
    }
    ${(0, $frihL.LAYOUT_FRAGMENT)}
    ${(0, $frihL.BASE_FIELD_FRAGMENT)}
    ${(0, $frihL.PROJECT_FIELD_FRAGMENT)}
    ${(0, $frihL.ISSUE_TYPE_FIELD_FRAGMENT)}
    ${(0, $frihL.REQUEST_TYPE_FIELD_FRAGMENT)}
    ${(0, $frihL.TEXT_FIELD_FRAGMENT)}
    ${(0, $frihL.RICH_TEXT_FIELD_FRAGMENT)}
    ${(0, $frihL.COMPONENTS_FIELD_FRAGMENT)}
    ${(0, $frihL.VERSION_FIELD_FRAGMENT)}
    ${(0, $frihL.MULTI_VERSION_FIELD_FRAGMENT)}
    ${(0, $frihL.PRIORITY_FIELD_FRAGMENT)}
    ${(0, $frihL.SPRINT_FIELD_FRAGMENT)}
    ${(0, $frihL.LABEL_FIELD_FRAGMENT)}
    ${(0, $frihL.SINGLE_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, $frihL.MULTI_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, $frihL.SECURITY_FIELD_FRAGMENT)}
    ${(0, $frihL.ISSUE_RESTRICTION_FIELD_FRAGMENT)}
    ${(0, $frihL.COLOR_FIELD_FRAGMENT)}
    ${(0, $frihL.RESOLUTION_FIELD_FRAGMENT)}
    ${(0, $frihL.SINGLE_SELECT_FIELD_FRAGMENT)}
    ${(0, $frihL.MULTI_SELECT_FIELD_FRAGMENT)}
    ${(0, $frihL.NUMBER_FIELD_FRAGMENT)}
    ${(0, $frihL.URL_FIELD_FRAGMENT)}
    ${(0, $frihL.EPIC_LINK_FIELD_FRAGMENT)}
    ${(0, $frihL.DATE_FIELD_FRAGMENT)}
    ${(0, $frihL.DATE_TIME_FIELD_FRAGMENT)}
    ${(0, $frihL.CASCADING_SELECT_FIELD_FRAGMENT)}
    ${(0, $frihL.ATTACHMENTS_FIELD_FRAGMENT)}
    ${(0, $frihL.CHECKBOX_FIELD_FRAGMENT)}
    ${(0, $frihL.ISSUE_LINKS_FIELD_FRAGMENT)}
    ${(0, $frihL.SINGLE_GROUP_PICKER_FIELD_FRAGMENT)}
    ${(0, $frihL.MULTI_GROUP_PICKER_FIELD_FRAGMENT)}
    ${(0, $frihL.PEOPLE_FIELD_FRAGMENT)}
    ${(0, $frihL.TEAM_FIELD_FRAGMENT)}
    ${(0, $frihL.ATLASSIAN_TEAM_FIELD_FRAGMENT)}
    ${(0, $frihL.RADIO_SELECT_FIELD_FRAGMENT)}
    ${(0, $frihL.AFFECTED_SERVICES_FIELD_FRAGMENT)}
    ${(0, $frihL.CMDB_FIELD_FRAGMENT)}
    ${(0, $frihL.ORGANIZATIONS_FIELD_FRAGMENT)}
    ${(0, $frihL.CONNECT_TEXT_FIELD_FRAGMENT)}
    ${(0, $frihL.CONNECT_NUMBER_FIELD_FRAGMENT)}
    ${(0, $frihL.CONNECT_SINGLE_SELECT_FIELD_FRAGMENT)}
    ${(0, $frihL.CONNECT_MULTI_SELECT_FIELD_FRAGMENT)}
    ${(0, $frihL.CONNECT_RICH_TEXT_FIELD_FRAGMENT)}
    ${(0, $frihL.ASSET_FIELD_FRAGMENT)}
    ${(0, $frihL.FORGE_STRING_FIELD_FRAGMENT)}
    ${(0, $frihL.FORGE_NUMBER_FIELD_FRAGMENT)}
    ${(0, $frihL.FORGE_SINGLE_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, $frihL.FORGE_MULTI_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, $frihL.FORGE_GROUP_PICKER_FIELD_FRAGMENT)}
    ${(0, $frihL.FORGE_MULTI_GROUP_PICKER_FIELD_FRAGMENT)}
    ${(0, $frihL.FORGE_STRINGS_FIELD_FRAGMENT)}
    ${(0, $frihL.FORGE_DATETIME_FIELD_FRAGMENT)}
    ${(0, $frihL.FORGE_OBJECT_FIELD_FRAGMENT)}
    ${(0, $frihL.TIME_TRACKING_FIELD_FRAGMENT)}
    ${(0, $frihL.WORK_LOG_FIELD_FRAGMENT)}
    ${(0, $frihL.JSM_MULTI_USER_PICKER_FIELD_FRAGMENT)}
    ${(0, $frihL.JSM_PEOPLE_FIELD_FRAGMENT)}
    ${(0, $frihL.PARENT_LINK_FIELD_FRAGMENT)}
    ${$ba7be233185cd2bd$var$isParentFieldInGicEnabled() ? (0, $frihL.PARENT_FIELD_FRAGMENT) : ''}
    ${(0, $frihL.STATUS_FIELD_FRAGMENT)}
    ${$ba7be233185cd2bd$var$isJsmRespondersFieldEnabled() ? (0, $frihL.RESPONDERS_FIELD_FRAGMENT) : ''}
    ${(0, $frihL.WATCHERS_CONFIG_FRAGMENT)}
`;

});



parcelRegister("7CMF8", function(module, exports) {

$parcel$export(module.exports, "DISCARD_MODAL_TYPE", () => $0c77e239446f8070$export$e9e476c40233a8a5);
$parcel$export(module.exports, "DiscardSuggestionsModal", () => $0c77e239446f8070$export$49a288a94f6fff7b);
$parcel$export(module.exports, "useConfirmDismissAiSuggestedModal", () => $0c77e239446f8070$export$75de84fe5faa6a41);

var $eUqFw = parcelRequire("eUqFw");

var $dxopF = parcelRequire("dxopF");

var $87u4E = parcelRequire("87u4E");

var $6NP0P = parcelRequire("6NP0P");
const $0c77e239446f8070$export$e9e476c40233a8a5 = {
    // DISCARD_ALL modal is part of ai-issue-breakdown/ui/issue-breakdown-draft-list/discard-suggestions
    DISCARD_ALL_FROM_GLOBAL_CREATE: 'DISCARD_ALL_FROM_GLOBAL_CREATE',
    DISCARD_CURRENT_SUGGESTED: 'DISCARD_CURRENT_SUGGESTED',
    DISCARD_CURRENT_EDITED: 'DISCARD_CURRENT_EDITED'
};
const $0c77e239446f8070$export$49a288a94f6fff7b = ({ modalType: modalType, onDiscard: onDiscard, onClose: onClose })=>{
    const onDiscardClick = (0, $eUqFw.useCallback)((_, analyticsEvent)=>{
        modalType && onDiscard(_, analyticsEvent, modalType);
    }, [
        onDiscard,
        modalType
    ]);
    const renderDiscardModal = (0, $eUqFw.useCallback)(()=>{
        switch(modalType){
            case $0c77e239446f8070$export$e9e476c40233a8a5.DISCARD_ALL_FROM_GLOBAL_CREATE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $87u4E.DiscardSuggestionsAllFromGlobalCreateModal), {
                    onClose: onClose,
                    onContinue: onDiscardClick
                });
            case $0c77e239446f8070$export$e9e476c40233a8a5.DISCARD_CURRENT_SUGGESTED:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $87u4E.DiscardSuggestionsCurrentSuggested), {
                    onClose: onClose,
                    onContinue: onDiscardClick
                });
            case $0c77e239446f8070$export$e9e476c40233a8a5.DISCARD_CURRENT_EDITED:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $87u4E.DiscardSuggestionsCurrentEdited), {
                    onClose: onClose,
                    onContinue: onDiscardClick
                });
            default:
                return null;
        }
    }, [
        modalType,
        onClose,
        onDiscardClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, modalType && renderDiscardModal());
};
const $0c77e239446f8070$export$75de84fe5faa6a41 = ()=>{
    const [visibleModal, setVisibleModal] = (0, $eUqFw.useState)();
    const setVisibleModalTo = (0, $eUqFw.useCallback)((modalType)=>{
        setVisibleModal(modalType);
    }, [
        setVisibleModal
    ]);
    return [
        visibleModal,
        setVisibleModalTo
    ];
};

});
parcelRegister("87u4E", function(module, exports) {

$parcel$export(module.exports, "DiscardSuggestionsAllFromGlobalCreateModal", () => $8b6695df8e1a0256$export$d324b82525470e10);
$parcel$export(module.exports, "DiscardSuggestionsCurrentSuggested", () => $8b6695df8e1a0256$export$38b3d190f16d6dda);
$parcel$export(module.exports, "DiscardSuggestionsCurrentEdited", () => $8b6695df8e1a0256$export$ec1d02c85fcc8756);

var $eUqFw = parcelRequire("eUqFw");

var $6zOB7 = parcelRequire("6zOB7");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $5JgJ2 = parcelRequire("5JgJ2");

var $daMgG = parcelRequire("daMgG");
const $8b6695df8e1a0256$export$474939764a73e1c4 = ({ onClose: onClose, onContinue: onContinue, titleText: titleText, bodyText: bodyText, cancelText: cancelText, continueText: continueText })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        testId: "issue-create.ui.modal.confirm-dismiss-ai-suggested-modal.modal",
        onClose: onClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), {
        appearance: "warning",
        isMultiline: true
    }, formatMessage(titleText))), bodyText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), {
        testId: "issue-create.ui.modal.confirm-dismiss-ai-suggested-modal.body"
    }, formatMessage(bodyText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        appearance: "subtle",
        "aria-label": formatMessage(cancelText),
        testId: "issue-create.ui.modal.confirm-dismiss-ai-suggested-modal.cancel-button",
        onClick: onClose
    }, formatMessage(cancelText)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6zOB7.default), {
        appearance: "warning",
        testId: "issue-create.ui.modal.confirm-dismiss-ai-suggested-modal.discard-button",
        "aria-label": formatMessage(continueText),
        onClick: onContinue
    }, formatMessage(continueText))));
};
const $8b6695df8e1a0256$export$d324b82525470e10 = ({ onClose: onClose, onContinue: onContinue })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8b6695df8e1a0256$export$474939764a73e1c4, {
        onClose: onClose,
        onContinue: onContinue,
        titleText: (0, $daMgG.default).modalTitleDiscardAllFromGlobalCreate,
        bodyText: (0, $daMgG.default).modalBodyDiscardAllFromGlobalCreate,
        cancelText: (0, $daMgG.default).modalCancelButton,
        continueText: (0, $daMgG.default).modalDiscardButton
    });
const $8b6695df8e1a0256$export$38b3d190f16d6dda = ({ onClose: onClose, onContinue: onContinue })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8b6695df8e1a0256$export$474939764a73e1c4, {
        onClose: onClose,
        onContinue: onContinue,
        titleText: (0, $daMgG.default).modalTitleDiscardCurrentSuggested,
        bodyText: (0, $daMgG.default).modalBodyDiscardCurrentSuggested,
        cancelText: (0, $daMgG.default).modalCancelButton,
        continueText: (0, $daMgG.default).modalDiscardButton
    });
const $8b6695df8e1a0256$export$ec1d02c85fcc8756 = ({ onClose: onClose, onContinue: onContinue })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8b6695df8e1a0256$export$474939764a73e1c4, {
        onClose: onClose,
        onContinue: onContinue,
        titleText: (0, $daMgG.default).modalTitleDiscardCurrentEdited,
        bodyText: (0, $daMgG.default).modalBodyDiscardCurrentEdited,
        cancelText: (0, $daMgG.default).modalCancelButton,
        continueText: (0, $daMgG.default).modalContinueButton
    });

});
parcelRegister("daMgG", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3338b3d30924250$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e3338b3d30924250$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    modalTitleDiscardAllFromGlobalCreate: {
        "id": "issue-create.modal.confirm-dismiss-ai-suggested-modal.modal-title-discard-all-from-global-create",
        "defaultMessage": "Are you sure you want to discard and close?"
    },
    modalBodyDiscardAllFromGlobalCreate: {
        "id": "issue-create.modal.confirm-dismiss-ai-suggested-modal.modal-body-discard-all-from-global-create",
        "defaultMessage": "You're going to lose all suggestions if you continue."
    },
    modalTitleDiscardCurrentSuggested: {
        "id": "issue-create.modal.confirm-dismiss-ai-suggested-modal.modal-title-discard-current-suggested",
        "defaultMessage": "Discard suggestion"
    },
    modalBodyDiscardCurrentSuggested: {
        "id": "issue-create.modal.confirm-dismiss-ai-suggested-modal.modal-body-discard-current-suggested",
        "defaultMessage": "Are you sure you want to discard this suggestion?"
    },
    modalTitleDiscardCurrentEdited: {
        "id": "issue-create.modal.confirm-dismiss-ai-suggested-modal.modal-title-discard-current-edited",
        "defaultMessage": "The changes you've made won't be saved"
    },
    modalBodyDiscardCurrentEdited: {
        "id": "issue-create.modal.confirm-dismiss-ai-suggested-modal.modal-body-discard-current-edited",
        "defaultMessage": "Are you sure you want to open another suggestion?"
    },
    modalDiscardButton: {
        "id": "issue-create.modal.confirm-dismiss-ai-suggested-modal.modal-discard-button",
        "defaultMessage": "Discard"
    },
    modalContinueButton: {
        "id": "issue-create.modal.confirm-dismiss-ai-suggested-modal.modal-continue-button",
        "defaultMessage": "Continue"
    },
    modalCancelButton: {
        "id": "issue-create.modal.confirm-dismiss-ai-suggested-modal.modal-cancel-button",
        "defaultMessage": "Cancel"
    }
});

});


parcelRegister("6NP0P", function(module, exports) {

$parcel$export(module.exports, "useShouldShowConfirmDismissAiSuggestedModal", () => $539fc9f34f228cb0$export$4e01ba05e9b9143a);

var $eUqFw = parcelRequire("eUqFw");

var $fswni = parcelRequire("fswni");

var $ctR9z = parcelRequire("ctR9z");
const $539fc9f34f228cb0$export$4e01ba05e9b9143a = ()=>{
    const [currentState, { resetWasModalRetriggered: resetWasModalRetriggered, setMinimizableModalView: setMinimizableModalView, restoreState: restoreState }] = (0, $ctR9z.useTriggerIssueCreateModal)();
    const [{ selectedProject: selectedProject, isFormDirty: isFormDirty }] = (0, $fswni.useFormContext)();
    const { wasModalRetriggered: wasModalRetriggered, minimizableModalView: minimizableModalView, openIssueCreateModalNextState: openIssueCreateModalNextState } = currentState;
    // Conditions for AI Suggested Discard modal visibility
    const isAiEnabledAndRetriggered = minimizableModalView === 'ai-enabled' && wasModalRetriggered;
    const isGlobalCreateTriggered = openIssueCreateModalNextState && openIssueCreateModalNextState.triggerPointKey === 'global-create-button';
    const shouldShowConfirmDismissFromGlobalCreate = isAiEnabledAndRetriggered && isGlobalCreateTriggered;
    const shouldShowConfirmDismissFromCurrentlyEditedIssue = isAiEnabledAndRetriggered && isFormDirty && !!selectedProject;
    // Interupt the Global Issue Create dialog flow, that re-triggers form
    // fields config fetch.
    (0, $eUqFw.useEffect)(()=>{
        if (shouldShowConfirmDismissFromGlobalCreate) restoreState({
            ...currentState,
            openIssueCreateModalNextState: undefined
        });
    }, [
        shouldShowConfirmDismissFromGlobalCreate,
        currentState,
        restoreState
    ]);
    const handleNextModalState = (0, $eUqFw.useCallback)(()=>{
        // Make sure the view doesn't flip to full modal while the confirmation
        // modal is displayed.
        resetWasModalRetriggered(false);
        setMinimizableModalView('ai-enabled');
    }, [
        resetWasModalRetriggered,
        setMinimizableModalView
    ]);
    return [
        {
            shouldShowConfirmDismissFromGlobalCreate: shouldShowConfirmDismissFromGlobalCreate,
            shouldShowConfirmDismissFromCurrentlyEditedIssue: shouldShowConfirmDismissFromCurrentlyEditedIssue
        },
        {
            handleNextModalState: handleNextModalState
        }
    ];
};

});


parcelRegister("jc4Bb", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bb71d31e73fa2aa$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $7u4fN = parcelRequire("7u4fN");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $kGQen = parcelRequire("kGQen");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4r5oC = parcelRequire("4r5oC");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $2qZHF = parcelRequire("2qZHF");


var $5Hor7 = parcelRequire("5Hor7");
const $1bb71d31e73fa2aa$var$ConfirmDismissModal = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { project: project, onCancel: onCancel = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onConfirm: onConfirm = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), sessionId: sessionId } = props;
    const { projectId: projectId, projectType: projectType } = project;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onClickCancelButton = (_, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'cancelCloseCreateModal', {
            projectType: (0, $4r5oC.transformProjectType)(projectType)
        });
        onCancel();
    };
    const onClickConfirmButton = (event, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'continueCloseCreateModal', {
            projectType: (0, $4r5oC.transformProjectType)(projectType),
            gicSessionId: sessionId
        });
        onConfirm(event, analyticsEvent);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa),
        sourceName: "cancelIssueCreate",
        containerType: "project",
        containerId: projectId || '',
        attributes: {
            projectType: (0, $4r5oC.transformProjectType)(projectType)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
        onMount: (0, $jMP2a.fireScreenAnalyticsDeferred)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onClose: onCancel,
        width: "small"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage((0, $5Hor7.default).title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, formatMessage((0, $5Hor7.default).description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle-link",
        onClick: onClickCancelButton
    }, formatMessage((0, $5Hor7.default).cancelButtonLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "primary",
        onClick: onClickConfirmButton,
        testId: (0, $18011c889fa9555c$export$565ca47ee76ce81a)
    }, formatMessage((0, $5Hor7.default).confirmButtonLabel))))));
};
var $1bb71d31e73fa2aa$export$2e2bcd8739ae039 = $1bb71d31e73fa2aa$var$ConfirmDismissModal;

});
const $18011c889fa9555c$export$e5ea02c7e88c47a3 = 'issue-create.common.ui.footer.create-button';
const $18011c889fa9555c$export$2bb7a43aba04c7df = 'issue-create.common.ui.footer.cancel-button';
const $18011c889fa9555c$export$822eda80d997eca0 = 'issue-create.common.ui.footer.created-issue-link';
const $18011c889fa9555c$export$9184b2de35f96256 = 'issue-create.ui.modal.header.import-issues-button';
const $18011c889fa9555c$export$2d077da71c26c1c5 = 'issue-create.ui.modal.create-form';
const $18011c889fa9555c$export$108d230a18c70c1b = 'issue-create.ui.modal.create-form.section-messages.required-fields-message';
const $18011c889fa9555c$export$f0c65883f24e857a = 'issue-create.ui.modal.create-form.section-messages.query-error-message';
const $18011c889fa9555c$export$d72a09102cf8602a = 'issue-create.ui.modal.create-form.section-messages.submit-error-message';
const $18011c889fa9555c$export$8cdb63e5b4deba55 = 'issue-create.ui.modal.create-form.section-messages.ui-modifications-error-message';
const $18011c889fa9555c$export$59cdc95a37abd627 = 'issue-create.common.ui.incompatible-fields-actions.learn-more';
const $18011c889fa9555c$export$1ec63f57bc2aa892 = 'issue-create.ui.modal.create-form.section-messages.inline-create-errors';
const $18011c889fa9555c$export$e80c59cc84dd232e = 'issue-create.common.ui.incompatible-fields-actions.switch-old-experience';
const $18011c889fa9555c$export$565ca47ee76ce81a = 'issue-create.ui.modal.confirm-dismiss-modal.discard-issue-button';

parcelRegister("5Hor7", function(module, exports) {

$parcel$export(module.exports, "default", () => $788a2796def37f01$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $788a2796def37f01$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "issue-create.modal.confirm-dismiss-modal.modal.title",
        "defaultMessage": "Your changes won\u2019t be saved"
    },
    cancelButtonLabel: {
        "id": "issue-create.modal.confirm-dismiss-modal.modal.cancel-button-label",
        "defaultMessage": "Go back"
    },
    confirmButtonLabel: {
        "id": "issue-create.modal.confirm-dismiss-modal.modal.confirm-button-label",
        "defaultMessage": "Discard issue"
    },
    description: {
        "id": "issue-create.modal.confirm-dismiss-modal.modal.description",
        "defaultMessage": "We won\u2019t be able to save your data if you move away from this page."
    }
});

});


parcelRegister("8cxU3", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fe899ce142059d8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8blac = parcelRequire("8blac");

var $hTLlD = parcelRequire("hTLlD");

var $k7cZh = parcelRequire("k7cZh");

var $lzLxZ = parcelRequire("lzLxZ");
var $jeetE = parcelRequire("jeetE");

var $l2Sum = parcelRequire("l2Sum");

var $7ZZxN = parcelRequire("7ZZxN");

var $aUSBv = parcelRequire("aUSBv");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");

var $7byHA = parcelRequire("7byHA");

var $7byHA = parcelRequire("7byHA");

var $k8Qyf = parcelRequire("k8Qyf");

var $iEhdM = parcelRequire("iEhdM");
var $18to0 = parcelRequire("18to0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3G9wl = parcelRequire("3G9wl");
var $1ttZy = parcelRequire("1ttZy");


var $dEMIg = parcelRequire("dEMIg");

var $5hR1J = parcelRequire("5hR1J");
var $icPhQ = parcelRequire("icPhQ");
var $5VJL3 = parcelRequire("5VJL3");

var $ewDib = parcelRequire("ewDib");

var $gys0Y = parcelRequire("gys0Y");

var $dNWQB = parcelRequire("dNWQB");
var $2gOs4 = parcelRequire("2gOs4");

var $fswni = parcelRequire("fswni");

var $lxOVE = parcelRequire("lxOVE");

var $gR74I = parcelRequire("gR74I");

var $48mPv = parcelRequire("48mPv");
var $d7Wfe = parcelRequire("d7Wfe");
var $bsdZ2 = parcelRequire("bsdZ2");

var $ctR9z = parcelRequire("ctR9z");

var $cWiVr = parcelRequire("cWiVr");

var $jMP2a = parcelRequire("jMP2a");
var $2qZHF = parcelRequire("2qZHF");
var $bFzGY = parcelRequire("bFzGY");

var $eIp1n = parcelRequire("eIp1n");
var $6WXNs = parcelRequire("6WXNs");

var $7LoO9 = parcelRequire("7LoO9");

var $ab6rA = parcelRequire("ab6rA");


var $hFagV = parcelRequire("hFagV");

var $6JJvA = parcelRequire("6JJvA");

var $6Rz1S = parcelRequire("6Rz1S");

var $kNatw = parcelRequire("kNatw");

var $0GqmM = parcelRequire("0GqmM");

var $3IsCV = parcelRequire("3IsCV");

var $683RD = parcelRequire("683RD");

var $a7qpF = parcelRequire("a7qpF");

var $64AaJ = parcelRequire("64AaJ");

var $dtUd8 = parcelRequire("dtUd8");

var $hXuDv = parcelRequire("hXuDv");

var $7s0Sp = parcelRequire("7s0Sp");

var $46CAS = parcelRequire("46CAS");

var $jbgmS = parcelRequire("jbgmS");

var $kF8Vn = parcelRequire("kF8Vn");

var $O5CDc = parcelRequire("O5CDc");

var $1rYBS = parcelRequire("1rYBS");
const $7fe899ce142059d8$var$isEcClientEnabled = ()=>{
    const experiences = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $1ybV0.getFeatureFlagValue)('odin.ec.client.integration.cbb', '').split(',');
    return Array.isArray(experiences) && experiences.includes('modern-gic');
};
const $7fe899ce142059d8$var$CreateFormBase = (props)=>{
    const [{ sectionMessage: sectionMessage, payload: triggerIssueCreatePayload, alertsToBeLinked: alertsToBeLinked, isSubTaskCreationOpen: isSubTaskCreationOpen, disableProjectDropdown: disableProjectDropdown, disableIssueTypeDropdown: disableIssueTypeDropdown, displayHeaderActionContainer: displayHeaderActionContainer, displaySitePicker: displaySitePicker, context: context, triggerPointKey: triggerPointKey, isCreateLinkedIssue: isCreateLinkedIssue, isModalLoadInContext: isModalLoadInContext, wasStateRestored: wasStateRestored, minimizableModalView: minimizableModalView, submitErrorMessage: presetSubmitErrorMessage, overrideUseRequestTypeFieldsToggleState: overrideUseRequestTypeFieldsToggleState, isMiniDesignEnabled: isMiniDesignEnabled, sessionId: sessionId }, { clearSectionMessage: clearSectionMessage, removeAlertFromAlertsToBeLinked: removeAlertFromAlertsToBeLinked }] = (0, $ctR9z.useTriggerIssueCreateModal)();
    const { onIssueCreateSuccess: onIssueCreateSuccess, canCreateAnotherIssue: canCreateAnotherIssue = false, isLoading: isLoading, fieldConfig: fieldConfig, fieldTabs: fieldTabs, contextFields: contextFields, filteredOutModules: filteredOutModules, meta: meta, error: error, apiLatency: apiLatency, onFetchConfig: fetchConfig, dirtyFieldsCurrentSession: dirtyFieldsCurrentSession, getFormState: getFormState, onFormFieldsReset: onFormFieldsReset, statusFieldProps: statusFieldProps, classificationFieldProps: classificationFieldProps, proformaConfiguration: proformaConfiguration, watchersConfigurations: watchersConfigurations, onResetApolloCache: onResetApolloCache } = props;
    const isMini = minimizableModalView === 'mini' || isMiniDesignEnabled;
    const isGICPositioningEnabled = (0, $hFagV.useIsGICPositioningEnabled)(); // TODO Add this field with the fields on previous line when cleaning FF
    const fieldPropsExtensions = isGICPositioningEnabled() ? props.fieldPropsExtensions : undefined;
    const { data: { user: currentUser } } = (0, $cWiVr.useCurrentUser)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { publish: publish } = (0, $2gOs4.useGICLifeCycleEvents)();
    const { interactedFields: interactedFields } = (0, $6JJvA.useInteractedFields)();
    const appEditions = (0, $ab6rA.useAppEditions)();
    const [{ watchers: watchers, ecosystem: { forge: { issueAdjustmentModules: issueAdjustmentModules, hasFinishedLoading: hasFinishedLoading } } }, { setIsForgeFieldsDetected: setIsForgeFieldsDetected, resetExpandedCollapsedArea: resetExpandedCollapsedArea }] = (0, $fswni.useFormContext)();
    const uiModificationsStatus = (0, $1ybV0.ff)('gic-smart-fields-remove-required-sentry-error_9jlqp') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $1ttZy.useUiModificationsEnabledStatus)(hasFinishedLoading) : undefined;
    const [{ selectedProject: selectedProject, selectedIssueType: selectedIssueType, meta: formMeta, areConfiguredFieldsModified: areConfiguredFieldsModified }, { setSelectedProject: setSelectedProject, setSelectedIssueType: setSelectedIssueType, setRequestBackedIssueType: setRequestBackedIssueType, setIsEpicLinkSelected: setIsEpicLinkSelected, setSubmitting: setSubmitting, setMeta: setMeta, setSubmitErrorMessage: setSubmitErrorMessage, setSubmitFieldwiseErrors: setSubmitFieldwiseErrors, setDataFetchError: setDataFetchError, setInlineErrorMessage: setInlineErrorMessage, setIsFormDirty: setIsFormDirty, setAreConfiguredFieldsModified: setAreConfiguredFieldsModified, setCurrentActiveTabIndex: setCurrentActiveTabIndex, setResetFormAction: setResetFormAction, setShouldAutoFocus: setShouldAutoFocus }] = (0, $fswni.useCreateFormState)();
    const [{ selectedCloudId: selectedCloudId }] = (0, $kNatw.useSitePickerContext)();
    const [createIssue] = (0, $0GqmM.default)(selectedCloudId);
    const [fields, { dispatchFormSubmits: dispatchFormSubmits, resetState: resetState }] = (0, $18to0.useInlineFields)(); // This useRef needs to be first in order for shouldUseRequestTypeDefault tests to work
    const shouldUseRequestTypeDefault = (0, $eUqFw.useRef)(true);
    const retainedFieldsData = (0, $eUqFw.useRef)([]);
    const [forgeFieldBlockStatus, setForgeFieldBlockStatus] = (0, $eUqFw.useState)((0, $e456ec6df0e2a730$export$f86e250f1a7b07c8));
    const { formatMessage: formatMessage, formatList: formatList } = (0, $5JgJ2.default)();
    const [hasCreatedAnotherIssue, setHasCreatedAnotherIssue] = (0, $eUqFw.useState)(false);
    const { initialClassification: initialClassification } = classificationFieldProps || {};
    const [selectedClassification, setSelectedClassification, onClassificationOptionChange] = (0, $gys0Y.useClassificationState)(initialClassification);
    const createFormScrollRef = (0, $eUqFw.useCallback)((node)=>{
        if (!node) return;
        if (formMeta?.submitErrorMessage || hasCreatedAnotherIssue) (0, $k7cZh.default)(node, (0, $dEMIg.DEFAULT_SCROLL_OPTIONS));
    }, [
        formMeta?.submitErrorMessage,
        hasCreatedAnotherIssue
    ]);
    const resetSummary = (0, $eUqFw.useRef)(null);
    const formRef = (0, $eUqFw.useRef)();
    const previousForgeFieldsState = (0, $eUqFw.useRef)(null);
    const isRestoring = (0, $eUqFw.useRef)(wasStateRestored);
    const [selectedTransition, setSelectedTransition] = (0, $eUqFw.useState)(null);
    const { saveIssueMutationToCache: saveIssueMutationToCache } = (0, $bsdZ2.useEcClient)();
    const onChangeSelectedTransition = (t)=>{
        const analyticsEvent = createAnalyticsEvent({});
        setSelectedTransition(t);
        (0, $jMP2a.fireTrackAnalyticsDeferred)(analyticsEvent, 'statusInGic changed');
        publish((0, $dNWQB.GIC_LIFECYCLE_EVENTS).STATUS_FIELD_STATE_CHANGE, {
            selectedTransition: t
        });
    };
    const { showEnforcementIfStorageIsFull: showEnforcementIfStorageIsFull } = (0, $7LoO9.useStorageEnforcement)();
    const shouldShowStatus = (0, $eUqFw.useMemo)(()=>(0, $1rYBS.shouldShowStatusField)(selectedProject?.projectType, fieldConfig), [
        selectedProject,
        fieldConfig
    ]);
    const shouldShowLinkedAlerts = (0, $eUqFw.useMemo)(()=>(0, $1rYBS.shouldShowLinkedAlertsField)(selectedProject?.projectType, selectedIssueType, alertsToBeLinked), [
        selectedProject?.projectType,
        selectedIssueType,
        alertsToBeLinked
    ]); // NOTE: JPD has no ability to manage watchers at the time of release, this is a workaround to prevent watchers being added for JPD.
    const shouldShowWatchers = selectedProject?.projectType !== (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT);
    const reloadForm = (0, $eUqFw.useCallback)((project, issueType, includeIssueTypesAndRequestTypes)=>{
        const userInputForRetentionParams = {
            formState: getFormState.current(),
            fieldConfig: fieldConfig,
            dirtyFieldsCurrentSession: dirtyFieldsCurrentSession,
            retainedFieldsData: retainedFieldsData,
            initialDefaultValues: triggerIssueCreatePayload?.defaultValues,
            selectedClassification: selectedClassification
        };
        const issueCreateTypeFilter = ()=>{
            const { issuelinks: issuelinks } = getFormState.current()?.values || {};
            return (0, $1ybV0.ff)('create-linked-issues-trigger-point-issue-view') && isModalLoadInContext && isCreateLinkedIssue ? {
                issueCreateType: isCreateLinkedIssue ? (0, $dEMIg.ISSUE_CREATE_TYPE).linkedIssue : (0, $dEMIg.ISSUE_CREATE_TYPE).standard,
                additionalContext: {
                    linkedIssue: {
                        sourceIssueId: triggerIssueCreatePayload?.additionalContext?.linkedIssue?.sourceIssueId || '',
                        includeLinks: issuelinks?.includeLinks,
                        includeAttachments: issuelinks?.includeAttachments
                    }
                }
            } : {};
        };
        fetchConfig({
            variables: {
                ...(0, $1rYBS.getQueryVariables)(project, issueType, (0, $1rYBS.getUserInputForRetention)(userInputForRetentionParams)),
                ...includeIssueTypesAndRequestTypes ? {
                    issueTypes: triggerIssueCreatePayload?.issueTypes,
                    requestTypes: triggerIssueCreatePayload?.requestTypes
                } : {},
                ...isModalLoadInContext && {
                    additionalContext: triggerIssueCreatePayload?.additionalContext
                },
                parentId: triggerIssueCreatePayload?.parentId,
                ...issueCreateTypeFilter()
            }
        });
    }, [
        getFormState,
        fieldConfig,
        dirtyFieldsCurrentSession,
        fetchConfig,
        triggerIssueCreatePayload?.issueTypes,
        triggerIssueCreatePayload?.requestTypes,
        triggerIssueCreatePayload?.additionalContext,
        triggerIssueCreatePayload?.parentId,
        triggerIssueCreatePayload?.defaultValues,
        isModalLoadInContext,
        isCreateLinkedIssue,
        selectedClassification
    ]);
    const onProjectChange = (0, $eUqFw.useCallback)((project)=>{
        setSubmitErrorMessage('');
        setSubmitFieldwiseErrors({});
        setSelectedProject(project);
        setSelectedIssueType(null);
        setSelectedTransition(null);
        setRequestBackedIssueType(null);
        setInlineErrorMessage(null);
        setShouldAutoFocus(false);
        if ((0, $1ybV0.ff)('gic-smart-fields-jira-labs_8uwvr')) resetExpandedCollapsedArea(); // when issue-type and request-type is null always honor request type
        shouldUseRequestTypeDefault.current = true;
        const userInputForRetentionParams = {
            formState: getFormState.current(),
            fieldConfig: fieldConfig,
            dirtyFieldsCurrentSession: dirtyFieldsCurrentSession,
            retainedFieldsData: retainedFieldsData,
            initialDefaultValues: triggerIssueCreatePayload?.defaultValues,
            selectedClassification: selectedClassification
        };
        const issueCreateTypeFilter = ()=>{
            const { issuelinks: issuelinks } = getFormState.current()?.values || {};
            return (0, $1ybV0.ff)('create-linked-issues-trigger-point-issue-view') && isModalLoadInContext && isCreateLinkedIssue ? {
                issueCreateType: isCreateLinkedIssue ? (0, $dEMIg.ISSUE_CREATE_TYPE).linkedIssue : (0, $dEMIg.ISSUE_CREATE_TYPE).standard,
                additionalContext: {
                    linkedIssue: {
                        sourceIssueId: triggerIssueCreatePayload?.additionalContext?.linkedIssue?.sourceIssueId || '',
                        includeLinks: issuelinks?.includeLinks,
                        includeAttachments: issuelinks?.includeAttachments
                    }
                }
            } : {};
        };
        fetchConfig({
            variables: {
                ...(0, $1rYBS.getQueryVariables)(project, null, (0, $1rYBS.getUserInputForRetention)(userInputForRetentionParams)),
                parentId: triggerIssueCreatePayload?.parentId,
                ...isModalLoadInContext && {
                    additionalContext: triggerIssueCreatePayload?.additionalContext
                },
                ...issueCreateTypeFilter()
            }
        });
        setIsEpicLinkSelected(false); // Reevaulate if forge fields are detected
        setIsForgeFieldsDetected(false);
        publish((0, $dNWQB.GIC_LIFECYCLE_EVENTS).PROJECT_FIELD_VALUE_CHANGE, {
            project: project
        });
    }, [
        dirtyFieldsCurrentSession,
        fetchConfig,
        fieldConfig,
        getFormState,
        isCreateLinkedIssue,
        isModalLoadInContext,
        publish,
        setInlineErrorMessage,
        setIsEpicLinkSelected,
        setIsForgeFieldsDetected,
        setRequestBackedIssueType,
        setSelectedIssueType,
        setSelectedProject,
        setSubmitErrorMessage,
        setSubmitFieldwiseErrors,
        triggerIssueCreatePayload?.additionalContext,
        triggerIssueCreatePayload?.parentId,
        triggerIssueCreatePayload?.defaultValues,
        setShouldAutoFocus,
        resetExpandedCollapsedArea,
        selectedClassification
    ]);
    const onIssueTypeSelected = (0, $eUqFw.useCallback)((issueType)=>{
        if (selectedProject && issueType) {
            setSubmitErrorMessage('');
            setSubmitFieldwiseErrors({});
            setShouldAutoFocus(false);
            setRequestBackedIssueType(null);
            setInlineErrorMessage(null);
            if ((0, $1ybV0.ff)('gic-smart-fields-jira-labs_8uwvr')) resetExpandedCollapsedArea(); // when issue-type is non-null always honor issue type
            shouldUseRequestTypeDefault.current = issueType.type === (0, $8b8bfa076f313cc4$export$92ab80c1dc9baf44);
            const userInputForRetentionParams = {
                formState: getFormState.current(),
                fieldConfig: fieldConfig,
                dirtyFieldsCurrentSession: dirtyFieldsCurrentSession,
                retainedFieldsData: retainedFieldsData,
                initialDefaultValues: triggerIssueCreatePayload?.defaultValues,
                selectedClassification: selectedClassification
            };
            const payloadDefaultValues = ()=>{
                const { projectType: projectType } = selectedProject || {};
                if (projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT)) return (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(getFormState.current()?.dirtyFields) ? {
                    defaultValues: triggerIssueCreatePayload?.defaultValues || {}
                } : {};
                return {};
            };
            const issueCreateTypeFilter = ()=>{
                const { issuelinks: issuelinks } = getFormState.current()?.values || {};
                return (0, $1ybV0.ff)('create-linked-issues-trigger-point-issue-view') && isModalLoadInContext && isCreateLinkedIssue ? {
                    issueCreateType: isCreateLinkedIssue ? (0, $dEMIg.ISSUE_CREATE_TYPE).linkedIssue : (0, $dEMIg.ISSUE_CREATE_TYPE).standard,
                    additionalContext: {
                        linkedIssue: {
                            sourceIssueId: triggerIssueCreatePayload?.additionalContext?.linkedIssue?.sourceIssueId || '',
                            includeLinks: issuelinks?.includeLinks,
                            includeAttachments: issuelinks?.includeAttachments
                        }
                    },
                    ...payloadDefaultValues()
                } : {};
            };
            fetchConfig({
                variables: {
                    ...(0, $1rYBS.getQueryVariables)(selectedProject, issueType, (0, $1rYBS.getUserInputForRetention)(userInputForRetentionParams)),
                    issueTypes: triggerIssueCreatePayload?.issueTypes,
                    requestTypes: triggerIssueCreatePayload?.requestTypes,
                    parentId: triggerIssueCreatePayload?.parentId,
                    ...isModalLoadInContext && {
                        additionalContext: triggerIssueCreatePayload?.additionalContext
                    },
                    ...issueCreateTypeFilter()
                }
            });
            setIsEpicLinkSelected(false); // Reevaulate if forge fields are detected
            setIsForgeFieldsDetected(false);
            publish((0, $dNWQB.GIC_LIFECYCLE_EVENTS).ISSUE_TYPE_FIELD_VALUE_CHANGE, {
                issueType: issueType
            });
        }
    }, [
        selectedProject,
        setSubmitErrorMessage,
        setSubmitFieldwiseErrors,
        setRequestBackedIssueType,
        setInlineErrorMessage,
        getFormState,
        fieldConfig,
        dirtyFieldsCurrentSession,
        fetchConfig,
        triggerIssueCreatePayload?.issueTypes,
        triggerIssueCreatePayload?.requestTypes,
        triggerIssueCreatePayload?.parentId,
        triggerIssueCreatePayload?.additionalContext,
        triggerIssueCreatePayload?.defaultValues,
        isModalLoadInContext,
        setIsEpicLinkSelected,
        setIsForgeFieldsDetected,
        publish,
        isCreateLinkedIssue,
        setShouldAutoFocus,
        resetExpandedCollapsedArea,
        selectedClassification
    ]);
    const project = contextFields.project?.selectedProject;
    const issueType = contextFields.issuetype?.selectedIssueType;
    const requestType = contextFields.requestType?.selectedRequestType;
    const inlineError = (0, $eUqFw.useMemo)(()=>(0, $1rYBS.transformInlineErrorMessage)(sectionMessage), [
        sectionMessage
    ]);
    (0, $eUqFw.useEffect)(()=>{
        publish((0, $dNWQB.GIC_LIFECYCLE_EVENTS).CREATE_FORM_FIELD_CONFIG_UPDATE, {
            fieldConfig: fieldConfig
        });
    }, [
        publish,
        fieldConfig
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (areConfiguredFieldsModified && selectedProject && selectedIssueType) {
            setAreConfiguredFieldsModified(false);
            const userInputForRetentionParams = {
                formState: getFormState.current(),
                fieldConfig: fieldConfig,
                dirtyFieldsCurrentSession: dirtyFieldsCurrentSession,
                retainedFieldsData: retainedFieldsData,
                initialDefaultValues: triggerIssueCreatePayload?.defaultValues,
                selectedClassification: selectedClassification
            };
            const issueCreateTypeFilter = ()=>{
                const { issuelinks: issuelinks } = getFormState.current()?.values || {};
                return (0, $1ybV0.ff)('create-linked-issues-trigger-point-issue-view') && isModalLoadInContext && isCreateLinkedIssue ? {
                    issueCreateType: isCreateLinkedIssue ? (0, $dEMIg.ISSUE_CREATE_TYPE).linkedIssue : (0, $dEMIg.ISSUE_CREATE_TYPE).standard,
                    additionalContext: {
                        linkedIssue: {
                            sourceIssueId: triggerIssueCreatePayload?.additionalContext?.linkedIssue?.sourceIssueId || '',
                            includeLinks: issuelinks?.includeLinks,
                            includeAttachments: issuelinks?.includeAttachments
                        }
                    }
                } : {};
            };
            fetchConfig({
                variables: {
                    ...(0, $1rYBS.getQueryVariables)(selectedProject, selectedIssueType, (0, $1rYBS.getUserInputForRetention)(userInputForRetentionParams)),
                    parentId: triggerIssueCreatePayload?.parentId,
                    ...isModalLoadInContext && {
                        additionalContext: triggerIssueCreatePayload?.additionalContext
                    },
                    ...issueCreateTypeFilter()
                }
            });
            setIsEpicLinkSelected(false);
        }
    }, [
        isModalLoadInContext,
        fetchConfig,
        fieldConfig,
        selectedProject,
        selectedIssueType,
        areConfiguredFieldsModified,
        setAreConfiguredFieldsModified,
        dirtyFieldsCurrentSession,
        retainedFieldsData,
        setIsEpicLinkSelected,
        triggerIssueCreatePayload?.parentId,
        triggerIssueCreatePayload?.additionalContext,
        triggerIssueCreatePayload?.defaultValues,
        getFormState,
        isCreateLinkedIssue,
        selectedClassification
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (isRestoring.current) {
            /**
       * Wait for the field config to load before setting isRestoring to false
       * otherwise we will set it false before the project field config loads,
       * so once the field config loads we dont skip sine isRestoring would be false
       */ if (project || issueType) isRestoring.current = false;
            return;
        }
        if (project) setSelectedProject(project);
        if (issueType) {
            setSelectedIssueType(shouldUseRequestTypeDefault.current === true && requestType ? requestType : issueType);
            setRequestBackedIssueType(shouldUseRequestTypeDefault.current === true && requestType ? issueType : null);
        }
    }, [
        issueType,
        project,
        requestType,
        setSelectedIssueType,
        setSelectedProject,
        setRequestBackedIssueType
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const newMeta = {
            ...formMeta,
            ...meta
        };
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(formMeta, newMeta)) setMeta(newMeta);
    }, [
        formMeta,
        meta,
        setMeta
    ]);
    const { initialTransition: initialTransition, preselectedTransition: preselectedTransition } = statusFieldProps || {};
    (0, $eUqFw.useEffect)(()=>{
        setSelectedTransition(preselectedTransition || initialTransition || null);
    }, [
        initialTransition,
        preselectedTransition,
        setSelectedTransition
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if ((0, $1ybV0.ff)('support-data-classification-field-in-gic_x6lda')) setSelectedClassification(initialClassification || undefined);
    }, [
        initialClassification,
        setSelectedClassification
    ]); // for error handling we need to set dataFetchError in formContext
    (0, $eUqFw.useEffect)(()=>{
        setDataFetchError(error);
    }, [
        error,
        setDataFetchError
    ]);
    (0, $eUqFw.useEffect)(()=>{
        setInlineErrorMessage(inlineError);
    }, [
        inlineError,
        setInlineErrorMessage
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (presetSubmitErrorMessage) setSubmitErrorMessage(presetSubmitErrorMessage);
    }, [
        presetSubmitErrorMessage,
        setSubmitErrorMessage
    ]);
    (0, $3IsCV.useDescriptionAnalytics)();
    const currentUIModificationsConsentState = (0, $3G9wl.useUIModificationsConsentStatus)();
    const onUIModificationsConsentRequiredMount = (analyticsEvent)=>(0, $jMP2a.fireOperationalAnalyticsDeferred)(analyticsEvent, 'jiraUiModificationsObligatoryConsent gicHidden');
    const areForgeInlineFieldsStoredOrIdle = (0, $eUqFw.useCallback)(()=>Object.values(fields).every((fieldData)=>fieldData.status === (0, $e456ec6df0e2a730$export$9956c6a700e724c4) || fieldData.status === (0, $e456ec6df0e2a730$export$bbf78c43fa5268c8)), [
        fields
    ]);
    const isForgeInlineFieldsError = (0, $eUqFw.useCallback)(()=>Object.values(fields).some((fieldData)=>fieldData.status === (0, $e456ec6df0e2a730$export$742c877aeb0f3dbd)), [
        fields
    ]);
    const showInvitePrompt = (0, $6Rz1S.useInvitePrompt)(selectedProject?.projectKey);
    const onCreateSuccess = ({ issueCreateResponse: issueCreateResponse, issueCreateFieldsUsed: issueCreateFieldsUsed, issueCreateContextUsed: issueCreateContextUsed, mentionedUserIds: mentionedUserIds, telemetryAttributes: telemetryAttributes = {}, collapsedFieldsLength: collapsedFieldsLength })=>{
        const { key: issueKey, id: issueId, watchers: watchersResponse } = issueCreateResponse;
        onIssueCreateSuccess({
            issueKey: issueKey,
            issueId: Number(issueId)
        }, shouldShowWatchers ? watchersResponse : undefined);
        const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('invite_prompt_on_link_insert_v2');
        const cohort = expConfig.get('cohort', 'not-enrolled');
        if (cohort !== 'not-enrolled') showInvitePrompt(getFormState.current()?.values?.description);
        setSubmitting(false);
        const boardId = (0, $aUSBv.getBoardId)(window.location.href);
        const analyticsEvent = createAnalyticsEvent({});
        const attributes = {
            sessionId: sessionId,
            issueCreateFieldsUsed: issueCreateFieldsUsed,
            issueCreateContextUsed: issueCreateContextUsed,
            mentionedUserIds: mentionedUserIds,
            boardId: boardId !== null ? Number(boardId) : undefined,
            projectType: selectedProject?.projectType,
            issueType: (0, $1rYBS.getAnalyticsIssueType)(selectedIssueType),
            ...!!selectedIssueType?.value && {
                issueTypeId: selectedIssueType?.value
            },
            ...selectedIssueType?.type === (0, $8b8bfa076f313cc4$export$92ab80c1dc9baf44) ? {
                hasRequestType: true,
                requestTypeKey: selectedIssueType?.requestTypeKey
            } : {
                hasRequestType: false
            },
            triggerPointKey: triggerPointKey,
            ...shouldShowWatchers && {
                watchers: {
                    count: watchers?.length,
                    used: (0, $1rYBS.isWatchersUsed)({
                        watchers: watchers,
                        isAutoWatchEnabled: watchersConfigurations?.isAutoWatchEnabled,
                        currentUserAccountId: currentUser.accountId
                    }),
                    ...watchersConfigurations
                }
            },
            ...shouldShowLinkedAlerts && {
                linkedAlerts: alertsToBeLinked
            },
            edition: selectedProject?.projectType && (0, $6WXNs.getEditionForProject)(selectedProject.projectType, appEditions),
            ...(0, $1ybV0.ff)('gic-smart-fields-remove-required-sentry-error_9jlqp') && {
                collapsedFieldsLength: collapsedFieldsLength
            }
        };
        if (shouldShowStatus) {
            attributes.statusInGicEnabled = true;
            if (selectedTransition && !selectedTransition.isInitial) attributes.userChangedStatusTo = selectedTransition.to?.statusCategory?.name;
        }
        if ($7fe899ce142059d8$var$isEcClientEnabled()) {
            const analyticsEventObj = {
                analyticsEventObj: createAnalyticsEvent({}),
                analyticsMetadata: {
                    scenario: 'global-issue-create',
                    boardId: boardId
                }
            };
            saveIssueMutationToCache(new (0, $48mPv.default)(issueId.toString(), (0, $d7Wfe.MutationSource).CREATE, '1', []), analyticsEventObj, {
                errorMsg: 'FAILED_GIC',
                error: true
            });
        }
        (0, $jMP2a.fireTrackAnalyticsDeferred)(analyticsEvent, 'issue created', attributes);
        (0, $jMP2a.fireOperationalAnalyticsDeferred)(createAnalyticsEvent({}), 'ui taskSuccess', {
            task: 'createIssue',
            isNewGIC: true,
            isCreated: true,
            triggerPointKey: triggerPointKey,
            edition: selectedProject?.projectType && (0, $6WXNs.getEditionForProject)(selectedProject.projectType, appEditions),
            application: selectedProject?.projectType && (0, $eIp1n.getApplicationForProject)(selectedProject.projectType),
            ...telemetryAttributes
        });
    };
    const findFirstTabIndexWithErrors = (0, $eUqFw.useCallback)((errors = {})=>{
        const index = fieldTabs.findIndex((tab)=>tab.items.find((item)=>errors && item === Object.keys(errors)[0]));
        return index > -1 ? index : 0;
    }, [
        fieldTabs
    ]);
    const onCreateFailure = ({ issueCreateError: err, telemetryAttributes: telemetryAttributes })=>{
        setSubmitting(false); // on 4xx
        if ((0, $7byHA.isValidationError)(err)) {
            const { message: message } = err;
            if (message && message.length) setSubmitErrorMessage(message.split('; ').join('\r\n'));
            const errors = 'errors' in err ? (0, $1rYBS.transformValidationErrors)(err.errors) : undefined;
            setSubmitFieldwiseErrors(errors);
            setCurrentActiveTabIndex(findFirstTabIndexWithErrors(errors));
            const customFieldError = (0, $1rYBS.isDisplayConditionCFCausingError)('errors' in err ? err.errors : [], fieldConfig, filteredOutModules);
            if (customFieldError) {
                const errorMessage = customFieldError.length > 1 ? formatMessage((0, $64AaJ.default).multipleRequiredCustomFieldsIssueCreationBlock, {
                    fieldsName: formatList(customFieldError, {
                        style: 'long',
                        type: 'conjunction'
                    })
                }) : formatMessage((0, $64AaJ.default).singleRequiredCustomFieldIssueCreationBlock, {
                    fieldName: formatList(customFieldError, {
                        style: 'short',
                        type: 'conjunction'
                    })
                });
                setSubmitErrorMessage(String(errorMessage));
            }
            return errors;
        } // on 5xx
        showFlag({
            type: 'error',
            title: (0, $64AaJ.default).createErrorFlagTitle,
            description: (0, $64AaJ.default).createErrorFlagDescription,
            testId: 'jira-issue-create.modal.create-form.error-flag'
        });
        (0, $jMP2a.fireOperationalAnalyticsDeferred)(createAnalyticsEvent({}), 'ui taskFail', {
            task: 'createIssue',
            isNewGIC: true,
            isCreated: true,
            triggerPointKey: triggerPointKey,
            edition: selectedProject?.projectType && (0, $6WXNs.getEditionForProject)(selectedProject.projectType, appEditions),
            application: selectedProject?.projectType && (0, $eIp1n.getApplicationForProject)(selectedProject.projectType),
            ...telemetryAttributes
        });
        return undefined;
    }; // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onSubmit = async (formData)=>{
        if (selectedProject && selectedIssueType) {
            setSubmitting(true);
            setSubmitErrorMessage('');
            setSubmitFieldwiseErrors({});
            const telemetryAttributes = {
                wasIssueCreatedWithCreateAnotherIssue: hasCreatedAnotherIssue,
                view: minimizableModalView
            };
            if (isForgeInlineFieldsError()) {
                const forgeInlineError = new (0, $7byHA.ValidationError)('', Object.keys(fields).map((key)=>({
                        field: key,
                        error: formatMessage((0, $64AaJ.default).createErrorForgeInlineField)
                    })));
                return onCreateFailure({
                    issueCreateError: forgeInlineError,
                    telemetryAttributes: telemetryAttributes
                });
            }
            const isForgeFieldFocused = Object.values(fields).some((field)=>field.status === (0, $e456ec6df0e2a730$export$32bbcfb76243a487));
            const isForgeIframe = (el)=>el.dataset?.forgeIframe === 'true';
            const activeElement = window.document?.activeElement;
            const isForgeIframeActive = activeElement instanceof HTMLElement && isForgeIframe(activeElement); // When the user is focused on a Forge field when clicking on "submit" button in GIC
            // we need to manually trigger focus event on form button and block the form submission
            // because the fields rely on blur events to submit the value. For the UI kit fields
            // we rely on isForgeFieldFocused value, however for the custom ui fields we don't change
            // the fields state on focus events so we need to check it with isForgeIframeActive
            const shouldFocusFormButton = (0, $1ybV0.ff)('custom-ui-custom-fields-blur-fix_ommll') ? isForgeFieldFocused || isForgeIframeActive : isForgeFieldFocused;
            if (shouldFocusFormButton || !areForgeInlineFieldsStoredOrIdle() && forgeFieldBlockStatus !== (0, $e456ec6df0e2a730$export$e784a07a62e2e0e5)) {
                if (shouldFocusFormButton) {
                    previousForgeFieldsState.current = fields;
                    (0, $5VJL3.focusFormButton)((0, $18011c889fa9555c$export$2d077da71c26c1c5));
                }
                setForgeFieldBlockStatus((0, $e456ec6df0e2a730$export$30daef8830f2505d));
                const timeout = setTimeout(()=>{
                    setForgeFieldBlockStatus((0, $e456ec6df0e2a730$export$e784a07a62e2e0e5));
                    clearTimeout(timeout);
                }, (0, $e456ec6df0e2a730$export$ae7c16bdba5e2e15));
                return undefined;
            }
            try {
                const payload = {
                    formData: {
                        ...(0, $1rYBS.getContextFieldsForSubmit)(selectedProject, selectedIssueType, contextFields.requestType?.fieldId),
                        ...(0, $1rYBS.getParentIdForSubmit)(triggerIssueCreatePayload?.parentId),
                        ...formData
                    },
                    onSuccess: (issueCreateSuccessProps)=>onCreateSuccess({
                            ...issueCreateSuccessProps,
                            telemetryAttributes: telemetryAttributes
                        }),
                    fieldConfig: fieldConfig,
                    ...(0, $1ybV0.ff)('gic-smart-fields-jira-labs_8uwvr') && {
                        fieldTabs: fieldTabs,
                        ...(0, $1ybV0.ff)('gic-smart-fields-remove-required-sentry-error_9jlqp') ? {
                            hasIssueAdjustmentModules: uiModificationsStatus === 'enabled'
                        } : {
                            hasIssueAdjustmentModules: !!issueAdjustmentModules.length
                        }
                    },
                    ...(0, $1rYBS.canSetContextForSubmit)(selectedProject, context) && {
                        context: context
                    },
                    ...(0, $1ybV0.ff)('create-linked-issues-trigger-point-issue-view') && {
                        createLinkedIssuePayload: {
                            isCreateLinkedIssue: isCreateLinkedIssue,
                            sourceIssueKey: isCreateLinkedIssue ? triggerIssueCreatePayload?.defaultValues?.issueLinks?.linkedIssueKeys[0] : null
                        }
                    },
                    isSubTaskCreationOpen: isSubTaskCreationOpen,
                    triggerPointKey: triggerPointKey,
                    sessionId: sessionId,
                    interactedFields: interactedFields,
                    shouldShowStatus: shouldShowStatus
                };
                try {
                    if ((0, $1ybV0.ff)('support-data-classification-field-in-gic_x6lda') && selectedClassification) payload.formData.dataclassification = {
                        id: selectedClassification?.id ? (0, $l2Sum.PlatformClassificationTagAri).parse(selectedClassification.id)?.tagId : null
                    };
                } catch (e) {}
                if (shouldShowStatus && selectedTransition && !selectedTransition.isInitial) payload.transition = {
                    id: selectedTransition.id
                };
                if (shouldShowWatchers && watchersConfigurations?.canManageWatchers) {
                    payload.watchers = watchers?.map((watcher)=>watcher.accountId);
                    payload.skipAutoWatch = true;
                }
                await createIssue(payload);
                setHasCreatedAnotherIssue(false);
                if (forgeFieldBlockStatus === (0, $e456ec6df0e2a730$export$e784a07a62e2e0e5)) {
                    const timedoutCFS = [];
                    Object.entries(fields).forEach(([key, value])=>{
                        if (value.status === (0, $e456ec6df0e2a730$export$f81c1d6b9217380c)) timedoutCFS.push(fieldConfig[key].fieldName);
                    });
                    if (timedoutCFS.length) showFlag({
                        type: 'warning',
                        title: (0, $64AaJ.default).timeoutForgeInlineFieldTitle,
                        description: [
                            (0, $64AaJ.default).timeoutForgeInlineFieldDescription,
                            {
                                fields: timedoutCFS.join(', '),
                                bold: (str)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, str)
                            }
                        ],
                        testId: 'jira-issue-create.modal.create-form.forge-timeout-flag'
                    });
                }
                if (canCreateAnotherIssue) {
                    setShouldAutoFocus(true);
                    sectionMessage && clearSectionMessage();
                    setTimeout(()=>{
                        // reset is used instead of setFieldValue because we want to reset the summary field to it's pristine state. setFieldValue only sets the value and the fields remains dirty causing a validation error when create another issue option is checked
                        // resetSummary.current({
                        //     ...formData,
                        //     summary: '',
                        // });
                        if (resetSummary.current) {
                            const fieldsReset = (0, $1rYBS.resetFormFieldsForCreateAnother)(formData, fieldConfig, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                            resetSummary);
                            publish((0, $dNWQB.GIC_LIFECYCLE_EVENTS).RESET_FORM_FIELDS_FOR_CREATE_ANOTHER, {
                                fieldsReset: fieldsReset ?? {}
                            });
                        }
                        setSelectedTransition(statusFieldProps?.initialTransition || null);
                        if ((0, $1ybV0.ff)('support-data-classification-field-in-gic_x6lda')) setSelectedClassification(classificationFieldProps?.initialClassification || undefined);
                        onFormFieldsReset?.();
                        setHasCreatedAnotherIssue(true);
                    }, 0);
                } // Show enforcement if created JSW issue and it was a success
                const isSoftwareProjectSelected = selectedProject.projectType === 'software';
                if (isSoftwareProjectSelected) showEnforcementIfStorageIsFull({
                    delayShow: minimizableModalView === 'modal' && canCreateAnotherIssue,
                    // We only care if the issue was created for a JSW project or not
                    // rather than if the user is currently viewing a JSW project
                    shouldOnlyShowInJSWContext: false,
                    touchpoint: 'global-issue-create'
                });
                 // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                return onCreateFailure({
                    issueCreateError: err,
                    telemetryAttributes: telemetryAttributes
                });
            }
        }
        resetState();
        return undefined;
    };
    (0, $eUqFw.useEffect)(()=>{
        if (forgeFieldBlockStatus !== (0, $e456ec6df0e2a730$export$f86e250f1a7b07c8)) {
            const isTimeout = forgeFieldBlockStatus === (0, $e456ec6df0e2a730$export$e784a07a62e2e0e5); // for CustomUI inline edit we need to compare fieldState in case of forced blur effect
            const customUIFieldStateCheck = previousForgeFieldsState.current !== fields;
            if (areForgeInlineFieldsStoredOrIdle() && customUIFieldStateCheck || isTimeout) {
                previousForgeFieldsState.current = fields;
                setForgeFieldBlockStatus((0, $e456ec6df0e2a730$export$f86e250f1a7b07c8));
                (0, $iEhdM.submitForgeFormField)(formRef);
            } else dispatchFormSubmits();
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        areForgeInlineFieldsStoredOrIdle,
        getFormState,
        forgeFieldBlockStatus,
        selectedTransition
    ]);
    const onIssueCreateFormMount = (analyticsEvent)=>(0, $jMP2a.fireOperationalAnalyticsDeferred)(analyticsEvent, 'IssueCreateForm rendered');
    const handleFormDirty = (dirty)=>{
        let isDirty = dirty;
        if (dirtyFieldsCurrentSession && dirtyFieldsCurrentSession.current && Object.keys(dirtyFieldsCurrentSession.current).length) isDirty = true;
        setIsFormDirty(isDirty);
    };
    const getForm = ()=>{
        if (currentUIModificationsConsentState === (0, $e4bc45ef063f6e5f$export$d67d63332ce3ce38)) {
            resetSummary.current = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
                onMount: onUIModificationsConsentRequiredMount
            });
        }
        if (!isLoading && meta.queryErrorMessage) {
            resetSummary.current = null;
            return null;
        }
        if (isLoading || !(selectedProject && selectedIssueType)) {
            resetSummary.current = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ewDib.default), {
                skeletonCount: 6
            });
        }
        if (fieldConfig && !meta.queryErrorMessage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lzLxZ.default), {
            key: `${selectedProject.value}-${selectedIssueType.value}`,
            onSubmit: onSubmit,
            isDisabled: !meta.areRequiredFieldsSupported
        }, ({ formProps: formProps, getState: getState, dirty: dirty, reset: reset, setFieldValue: setFieldValue })=>{
            getFormState.current = getState; /**
                                              * isFormDirty is the actual value we should use to tell if the form
                                              * is dirty. isFormDirty comes from form-context, and is updated
                                              * in handleFormDirty.
                                              *
                                              * We pass the AKForm's dirty so that handleFormDirty can use both
                                              * AKForm's dirty and dirtyFieldsCurrentSession (from props) to set
                                              * isFormDirty correctly by taking both into account.
                                              *
                                              * Note - we are using this isFormDirty in issue-create-restore to block nav there
                                              * src/packages/issue-create/issue-create-restore/src/controllers/should-show-browser-warning/index.tsx
                                              */ 
            handleFormDirty(dirty);
            if (!resetSummary.current) {
                resetSummary.current = reset;
                setResetFormAction(reset);
            }
            const getLayoutRenderer = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a7qpF.default), {
                    fieldConfig: fieldConfig,
                    fieldTabs: fieldTabs,
                    setFieldValue: setFieldValue,
                    getFormState: getState,
                    apiLatency: apiLatency,
                    fieldPropsExtensions: isGICPositioningEnabled() ? fieldPropsExtensions : undefined
                });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fe899ce142059d8$var$WrapperDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("form", {
                ...formProps,
                id: "issue-create.ui.modal.create-form",
                ref: (ref)=>{
                    // @ts-expect-error - TS2322 - Type 'HTMLFormElement | null' is not assignable to type 'HTMLFormElement | undefined'.
                    formRef.current = ref;
                },
                noValidate: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gR74I.FormApiProvider), {
                getFormState: getState,
                setFieldValue: setFieldValue
            }, getLayoutRenderer()))));
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
            onMount: onIssueCreateFormMount
        }));
        return null;
    };
    const getRequestTypeFieldsLayoutPreference = ()=>// if we have request types (JSM CMP only) then we want to show the toggle
        contextFields.requestType?.requestTypes && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7s0Sp.RequestTypeFieldsLayoutPreference), {
            isRequestTypeSelected: selectedIssueType?.type === (0, $8b8bfa076f313cc4$export$92ab80c1dc9baf44),
            onChange: ()=>selectedProject && reloadForm(selectedProject, selectedIssueType, false),
            overrideIsEnabled: overrideUseRequestTypeFieldsToggleState
        });
    const getProformaBanner = ()=>!isLoading && proformaConfiguration?.hasProformaForm && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dtUd8.ProformaBanner), {
            portalLink: proformaConfiguration.portalLink
        });
    const getClassificationField = ()=>classificationFieldProps?.availableClassifications?.length && classificationFieldProps.availableClassifications.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5hR1J.default), {
            allowedValues: classificationFieldProps?.availableClassifications || [],
            value: selectedClassification,
            onChange: onClassificationOptionChange,
            width: isMini ? '100%' : undefined,
            nonEditableReason: classificationFieldProps.nonEditableMessage,
            ...classificationFieldProps,
            errorMessage: formMeta?.submitFieldwiseErrors?.dataclassification
        }) : null; // memoise the issueTypes value so that a new `[]` is not passed into TypePicker per render
    const issueTypes = contextFields.issuetype?.issueTypes;
    const issueTypesMemoised = (0, $eUqFw.useMemo)(()=>issueTypes || [], [
        issueTypes
    ]);
    const projectPickerIsDisabled = isSubTaskCreationOpen || disableProjectDropdown;
    const oldContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hXuDv.default), {
        onChange: onProjectChange,
        value: selectedProject,
        renderOptionsLimit: 25,
        skipFetchProjects: !!meta.queryErrorMessage,
        disableFetchProject: projectPickerIsDisabled,
        isDisabled: projectPickerIsDisabled,
        width: isMini ? '100%' : undefined
    }), isMini && selectedProject?.projectType !== (0, $7ZZxN.SERVICE_DESK_PROJECT) && shouldShowStatus && statusFieldProps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fe899ce142059d8$var$MiniIssueTypeStatusWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $O5CDc.default), {
        issueTypes: issueTypesMemoised,
        requestTypes: contextFields.requestType?.requestTypes,
        onChange: onIssueTypeSelected,
        value: selectedIssueType,
        projectType: selectedProject?.projectType,
        isDisabled: disableIssueTypeDropdown
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kF8Vn.default), {
        isLoading: !!statusFieldProps.isTransitionsLoading,
        error: statusFieldProps.transitionsError,
        transitions: statusFieldProps.availableTransitions || [],
        isMini: true,
        value: selectedTransition,
        onChange: onChangeSelectedTransition
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $O5CDc.default), {
        issueTypes: issueTypesMemoised,
        requestTypes: contextFields.requestType?.requestTypes,
        onChange: onIssueTypeSelected,
        value: selectedIssueType,
        projectType: selectedProject?.projectType,
        isDisabled: disableIssueTypeDropdown,
        isMini: isMini
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.Divider), null), shouldShowStatus && statusFieldProps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kF8Vn.default), {
        isLoading: !!statusFieldProps.isTransitionsLoading,
        error: statusFieldProps.transitionsError,
        transitions: statusFieldProps.availableTransitions || [],
        isMini: false,
        value: selectedTransition,
        onChange: onChangeSelectedTransition
    })), getRequestTypeFieldsLayoutPreference(), getClassificationField(), shouldShowLinkedAlerts && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lxOVE.LinkedAlertsField), {
        value: alertsToBeLinked || [],
        onRemoveButtonClick: removeAlertFromAlertsToBeLinked
    }), getProformaBanner(), getForm()); // Move this into the return statement when cleaning up gic.positioning
    const newContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fe899ce142059d8$var$RelativeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fe899ce142059d8$var$FlexWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fe899ce142059d8$var$RequiredMessage, {
        "aria-hidden": "true",
        isMini: !!isMini
    }, formatMessage((0, $64AaJ.default).requiredFieldsSummary), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jeetE.default), null)), displayHeaderActionContainer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $683RD.ActionsContainer), {
        watchersConfigurations: watchersConfigurations,
        fieldConfig: fieldConfig
    })), displaySitePicker && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jbgmS.default), {
        onChange: onResetApolloCache,
        width: isMini ? '100%' : undefined
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hXuDv.default), {
        onChange: onProjectChange,
        value: selectedProject,
        renderOptionsLimit: 25,
        skipFetchProjects: !!meta.queryErrorMessage,
        disableFetchProject: projectPickerIsDisabled,
        isDisabled: projectPickerIsDisabled,
        width: isMini ? '100%' : undefined
    }), minimizableModalView === 'mini' && selectedProject?.projectType !== (0, $7ZZxN.SERVICE_DESK_PROJECT) && shouldShowStatus && statusFieldProps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fe899ce142059d8$var$MiniIssueTypeStatusWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $O5CDc.default), {
        issueTypes: issueTypesMemoised,
        requestTypes: contextFields.requestType?.requestTypes,
        onChange: onIssueTypeSelected,
        value: selectedIssueType,
        projectType: selectedProject?.projectType,
        isDisabled: disableIssueTypeDropdown
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kF8Vn.default), {
        isLoading: !!statusFieldProps.isTransitionsLoading,
        error: statusFieldProps.transitionsError,
        transitions: statusFieldProps.availableTransitions || [],
        isMini: true,
        value: selectedTransition,
        onChange: onChangeSelectedTransition
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $O5CDc.default), {
        issueTypes: issueTypesMemoised,
        requestTypes: contextFields.requestType?.requestTypes,
        onChange: onIssueTypeSelected,
        value: selectedIssueType,
        projectType: selectedProject?.projectType,
        isDisabled: disableIssueTypeDropdown,
        isMini: isMini
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.Divider), null), shouldShowStatus && statusFieldProps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kF8Vn.default), {
        isLoading: !!statusFieldProps.isTransitionsLoading,
        error: statusFieldProps.transitionsError,
        transitions: statusFieldProps.availableTransitions || [],
        isMini: false,
        value: selectedTransition,
        onChange: onChangeSelectedTransition
    })), getRequestTypeFieldsLayoutPreference(), getClassificationField(), shouldShowLinkedAlerts && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lxOVE.LinkedAlertsField), {
        value: alertsToBeLinked || [],
        onRemoveButtonClick: removeAlertFromAlertsToBeLinked
    }), getProformaBanner(), getForm());
    (0, $eUqFw.useEffect)(()=>{
        let forgeCustomFieldDetected = false;
        Object.values(fieldConfig).forEach((field)=>{
            if ((0, $5VJL3.isForgeCustomField)(field.fieldType)) forgeCustomFieldDetected = true;
        });
        setIsForgeFieldsDetected(forgeCustomFieldDetected);
    }, [
        fieldConfig,
        setIsForgeFieldsDetected
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: createFormScrollRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        id: (0, $dEMIg.FORM_DROPZONE_CONTAINER_ID)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $46CAS.default), null), isGICPositioningEnabled() ? newContent : oldContent));
};
const $7fe899ce142059d8$var$CreateForm = /*#__PURE__*/ (0, $eUqFw.memo)($7fe899ce142059d8$var$CreateFormBase);
var $7fe899ce142059d8$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $7fe899ce142059d8$var$CreateForm;
const $7fe899ce142059d8$var$WrapperDiv = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_35md1bgi _z6i1glyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7fe899ce142059d8$var$RelativeWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7fe899ce142059d8$var$MiniIssueTypeStatusWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1q9y _jw0lu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7fe899ce142059d8$var$RequiredMessage = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isMini: isMini, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1n3s",
            __cmplp.isMini ? "_1wyb1crf" : "_1wybdlk8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7fe899ce142059d8$var$FlexWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("l2Sum", function(module, exports) {

$parcel$export(module.exports, "PlatformClassificationTagAri", () => $64e586ed5269060d$export$1810bec01081467);

var $qk8Sv = parcelRequire("qk8Sv");

var $v8cEo = parcelRequire("v8cEo");

var $hkoEN = parcelRequire("hkoEN");
// src/platform/classification-tag/manifest.ts
var $64e586ed5269060d$var$platformClassificationTagAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    resourceOwner: (0, $qk8Sv.PlatformClassificationTagAriResourceOwner),
    resourceType: (0, $qk8Sv.PlatformClassificationTagAriResourceType),
    resourceIdSlug: "{tagId}",
    resourceIdSegmentFormats: {
        tagId: /[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}/
    }
};
// src/platform/classification-tag/index.ts
var $64e586ed5269060d$export$1810bec01081467 = class _PlatformClassificationTagAri extends (0, $v8cEo.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._tagId = opts.resourceIdSegmentValues.tagId;
    }
    get tagId() {
        return this._tagId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $64e586ed5269060d$var$platformClassificationTagAriStaticOpts.qualifier,
            platformQualifier: $64e586ed5269060d$var$platformClassificationTagAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $64e586ed5269060d$var$platformClassificationTagAriStaticOpts.resourceOwner,
            resourceType: $64e586ed5269060d$var$platformClassificationTagAriStaticOpts.resourceType,
            resourceId: `${opts.tagId}`,
            resourceIdSegmentValues: {
                tagId: opts.tagId
            }
        }, ariOpts = (0, $hkoEN.AriParser).fromOpts(derivedOpts, $64e586ed5269060d$var$platformClassificationTagAriStaticOpts);
        return new _PlatformClassificationTagAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $hkoEN.AriParser).fromString(maybeAri, $64e586ed5269060d$var$platformClassificationTagAriStaticOpts);
        return new _PlatformClassificationTagAri(opts);
    }
    getVariables() {
        return {
            tagId: this.tagId
        };
    }
};

});
parcelRegister("qk8Sv", function(module, exports) {

$parcel$export(module.exports, "PlatformClassificationTagAriResourceOwner", () => $8186d62ffe2d2ffd$export$ee6dbd2071d3ea9f);
$parcel$export(module.exports, "PlatformClassificationTagAriResourceType", () => $8186d62ffe2d2ffd$export$8a038be1370dff6c);
// src/platform/classification-tag/types.ts
var $8186d62ffe2d2ffd$export$ee6dbd2071d3ea9f = "platform", $8186d62ffe2d2ffd$export$8a038be1370dff6c = "classification-tag";

});


parcelRegister("aUSBv", function(module, exports) {

$parcel$export(module.exports, "getBoardId", () => $fde559e96dd48090$export$557c2f222778cea6);
$parcel$export(module.exports, "default", () => $fde559e96dd48090$export$2e2bcd8739ae039);

var $k4nIh = parcelRequire("k4nIh");

var $kdp9J = parcelRequire("kdp9J");

var $hmtwd = parcelRequire("hmtwd");

var $fpsBI = parcelRequire("fpsBI");

var $7l8eu = parcelRequire("7l8eu");
const $fde559e96dd48090$var$projectScopeDataMap = {
    routes: [
        // Query string
        /[&?]projectKey=(\w+)/i,
        // Service desk, business and some software
        /\/projects\/(\w+)/i,
        // Issue page (not root)
        /\/browse\/(\w+)-\d+\??((?!(filter=|jql=)).)*$/i,
        // Project settings
        /\/plugins\/servlet\/project-config\/(\w+)/i,
        // Service Desk project settings
        /\/servicedesk\/admin\/(\w+)/i,
        // Browse project
        /\/browse\/(\w+)\/?(\?.*)?$/i
    ],
    meta: [
        // Software
        'ghx-project-key',
        // Settings
        'projectKey',
        // Reports
        'ajs-project-key'
    ]
};
const $fde559e96dd48090$var$getProjectId = (url)=>{
    const projectIdRoutes = [
        // Query string - reports
        /[&?]selectedProjectId=(\w+)/i,
        // Query string - edit project, delete project
        /[&?]pid=(\w+)/i,
        // Query string - release notes
        /[&?]projectId=(\w+)/i,
        // Query string - connect items
        /[&?]project\.id=(\w+)/i
    ];
    return projectIdRoutes.reduce((foundId, route)=>{
        if (foundId) return foundId;
        const match = url.match(route);
        if (match != null) {
            const [, projectId] = match;
            if (projectId) return projectId;
        }
        return null;
    }, null);
};
/**
 * Extracts certain data out of the URL that is required by other data providers.
 */ const $fde559e96dd48090$var$getProjectKey = (url, getMeta)=>{
    let projectKey = null;
    $fde559e96dd48090$var$projectScopeDataMap.meta.forEach((tagName)=>{
        const value = getMeta(tagName);
        if (value && projectKey == null) projectKey = value;
    });
    $fde559e96dd48090$var$projectScopeDataMap.routes.forEach((route)=>{
        const match = url.match(route);
        if (match != null && projectKey == null) [, projectKey] = match;
    });
    return projectKey || undefined;
};
const $fde559e96dd48090$export$557c2f222778cea6 = (url)=>{
    try {
        const parsed = (0, (/*@__PURE__*/$parcel$interopDefault($k4nIh)))(url, true);
        let boardId = parsed.query ? parsed.query.rapidView : null;
        if (boardId == null) {
            const match = url.match(/\/boards\/(\d+)/i);
            boardId = match ? match[1] : null;
        }
        return boardId;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        return null;
    }
};
const $fde559e96dd48090$var$isProjectSettingsConnectRoute = ({ getMeta: getMeta, url: url })=>getMeta('ajs-in-admin-mode') === 'true' && (0, $hmtwd.default).some((regex)=>regex.test(url)) || (0, $7l8eu.default).some((regex)=>regex.test(url));
const $fde559e96dd48090$var$isProjectPage = ({ getMeta: getMeta, projectId: projectId, projectKey: projectKey, url: url })=>{
    // Project routes that have a project id in the URL
    const isProject = ()=>{
        const routes = [
            /\/secure\/ConfigureReport(!default)?\.jspa.+selectedProjectId/i,
            /\/secure\/project\/(DeleteProject|EditProject)!default\.jspa.+pid/i,
            /\/secure\/ReleaseNote.jspa.+projectId/i,
            /\/secure\/ConfigureReleaseNote.jspa.+projectId/i
        ];
        return $fde559e96dd48090$var$isProjectSettingsConnectRoute({
            getMeta: getMeta,
            url: url
        }) || routes.some((regex)=>regex.test(url));
    };
    return projectKey || projectId && isProject();
};
const $fde559e96dd48090$var$isProjectSettingsPage = ({ getMeta: getMeta, url: url })=>(0, $fpsBI.default).some((route)=>url.match(route)) || $fde559e96dd48090$var$isProjectSettingsConnectRoute({
        getMeta: getMeta,
        url: url
    });
const $fde559e96dd48090$var$getProjectPageType = (getMeta, url)=>{
    if ($fde559e96dd48090$var$isProjectSettingsPage({
        getMeta: getMeta,
        url: url
    })) return 'settings';
    const decorator = getMeta('decorator');
    const isSettings = getMeta('is-settings-page') === 'true';
    return decorator === 'admin' || decorator === 'atl.admin' || isSettings ? 'settings' : undefined;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fde559e96dd48090$export$2e2bcd8739ae039 = (url, getMeta)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const extractedData = {};
    const boardId = $fde559e96dd48090$export$557c2f222778cea6(url);
    if (boardId) extractedData.boardId = boardId;
    const projectKey = url.includes('/plugins/servlet/ac/') || url.includes('/settings/projects/') ? undefined : $fde559e96dd48090$var$getProjectKey(url, getMeta);
    if (projectKey) extractedData.projectKey = projectKey;
    const projectId = $fde559e96dd48090$var$getProjectId(url);
    if (projectId) extractedData.projectId = projectId;
    const isProject = $fde559e96dd48090$var$isProjectPage({
        getMeta: getMeta,
        projectId: projectId,
        projectKey: projectKey,
        url: url
    });
    extractedData.pageType = isProject ? $fde559e96dd48090$var$getProjectPageType(getMeta, url) : undefined;
    const identifier = (0, $kdp9J.getScopeIdentifier)({
        boardId: boardId,
        projectKey: projectKey,
        projectId: isProject ? projectId : null
    });
    // This gets around a flow inexact type error
    return {
        ...extractedData,
        ...identifier
    };
};

});
parcelRegister("hmtwd", function(module, exports) {

$parcel$export(module.exports, "default", () => $be3da143f23d41f2$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $be3da143f23d41f2$export$2e2bcd8739ae039 = [
    // Regex groups: addonKey, pageKey
    /\/plugins\/servlet\/ac\/(.+)\/([^?\s]+)/i
];

});

parcelRegister("fpsBI", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac811ac050e5d76c$export$2e2bcd8739ae039);

var $7l8eu = parcelRequire("7l8eu");
const $ac811ac050e5d76c$var$commonClassicProjectSettingsRoutes = [
    /\/plugins\/servlet\/project-config/i,
    /\/jira\/software\/c\/projects\/.+\/settings\/code/i,
    /\/jira\/software\/c\/projects\/.+\/settings\/deployments/i,
    /\/plugins\/servlet\/project-config\/.+\/administer-components/i,
    /\/plugins\/servlet\/project-config\/.+\/administer-versions/i,
    /\/plugins\/servlet\/project-config\/.+\/fields/i,
    /\/plugins\/servlet\/project-config\/.+\/issuesecurity/i,
    /\/plugins\/servlet\/project-config\/.+\/issuetypes/i,
    /\/plugins\/servlet\/project-config\/.+\/notifications/i,
    /\/plugins\/servlet\/project-config\/.+\/permissions/i,
    /\/plugins\/servlet\/project-config\/.+\/screens/i,
    /\/plugins\/servlet\/project-config\/.+\/workflows/i,
    /\/project\/DeleteProject!default\.jspa/i,
    /\/secure\/project\/EditProject!default\.jspa/i,
    // Collectors
    /\/secure\/AddCollector/i,
    /\/secure\/InsertCollectorHelp/i,
    /\/ViewCollector!default\.jspa\?projectKey=/i,
    /\/ViewCollectors!default\.jspa\?projectKey=/i,
    // Development tools
    /\/secure\/ConfigureDevStatus.jspa\?projectKey=/i,
    // Hipchat
    /\/InstallHipChat\.jspa\?projectKey=/i,
    /\/secure\/ConfigureHipChat\.jspa\?projectKey=(.+)/i,
    // Forge
    /\/jira\/software\/c\/projects\/.+\/settings\/apps\/([a-z0-9-]+)\/([a-z0-9-]+)(\/*)?/i
];
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ac811ac050e5d76c$export$2e2bcd8739ae039 = [
    ...$ac811ac050e5d76c$var$commonClassicProjectSettingsRoutes,
    /\/plugins\/servlet\/project-config\/.+\/issuelayout/i,
    ...(0, $7l8eu.default),
    // Service Desk project settings
    /\/servicedesk\/admin\/(\w+)/i,
    // SPA settings
    /\/projects\/\w+\/settings(\/\w+)*/i
];

});
parcelRegister("7l8eu", function(module, exports) {

$parcel$export(module.exports, "default", () => $840bada481eacc3a$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $840bada481eacc3a$export$2e2bcd8739ae039 = [
    /\/plugins\/servlet\/ac\/com\.xpandit\.plugins\.jiraxporter\/jira-xporter-manage-project/i,
    /\/plugins\/servlet\/ac\/com\.xpandit\.plugins\.xray\/xray-project-settings-all/i
];

});



parcelRegister("1ttZy", function(module, exports) {

$parcel$export(module.exports, "useHasFinishedLoading", () => $cf1379fb257ebd41$export$282f17c8d715e155);
$parcel$export(module.exports, "useUiModificationsEnabledStatus", () => $cf1379fb257ebd41$export$408eb757ebd7e139);

var $ggKAj = parcelRequire("ggKAj");

var $ig7wC = parcelRequire("ig7wC");
const $cf1379fb257ebd41$export$282f17c8d715e155 = (0, $ggKAj.createStateHook)((0, $ig7wC.store), {
    selector: (state)=>state.hasFinishedLoading
});
const $cf1379fb257ebd41$export$10b49abde6eddf71 = (0, $ggKAj.createStateHook)((0, $ig7wC.store), {
    selector: (state)=>state.shouldUiModificationsLoad
});
const $cf1379fb257ebd41$export$408eb757ebd7e139 = (hasForgeFinishedLoading)=>{
    const shouldUiModificationsLoad = $cf1379fb257ebd41$export$10b49abde6eddf71();
    const hasFinishedLoading = $cf1379fb257ebd41$export$282f17c8d715e155();
    const adjustmentsAreEnabled = (0, $ig7wC.useAdjustmentsEnabled)();
    const uimIsEnabled = hasForgeFinishedLoading && shouldUiModificationsLoad === 'yes' && hasFinishedLoading && adjustmentsAreEnabled;
    const uimIsDisabled = hasForgeFinishedLoading && (shouldUiModificationsLoad === 'no' || hasFinishedLoading && !adjustmentsAreEnabled);
    if (uimIsEnabled) return 'enabled';
    if (uimIsDisabled) return 'disabled';
    return 'unknown';
};

});

parcelRegister("lxOVE", function(module, exports) {

$parcel$export(module.exports, "LinkedAlertsField", () => $f9ccacf38d885702$export$9fb52de2628d6fe0);

var $eUqFw = parcelRequire("eUqFw");

var $WtC7F = parcelRequire("WtC7F");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $icPhQ = parcelRequire("icPhQ");
var $dibFF = parcelRequire("dibFF");

var $gGtKh = parcelRequire("gGtKh");

var $eRDf0 = parcelRequire("eRDf0");
const $f9ccacf38d885702$export$9fb52de2628d6fe0 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "issue.fields.linked-alerts",
        packageName: "AsyncLinkedAlertsField"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $WtC7F.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        "data-testid": "issue-field-linked-alerts.field-container",
        width: "100%"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "linked-alerts-field",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dibFF.FieldLoader), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eRDf0.AsyncLinkedAlertsField), props)))));

});
parcelRegister("WtC7F", function(module, exports) {

$parcel$export(module.exports, "default", () => $0afc639817e4e203$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $cNoZ8 = parcelRequire("cNoZ8");

var $eYrUd = parcelRequire("eYrUd");

var $f2LYo = parcelRequire("f2LYo");
/**
 * Wrapper should live on the root level since it uses glocal scoped container.
 */ const $0afc639817e4e203$var$ResponderNamesWrapper = ({ scope: scope, isGlobal: isGlobal = true, children: children })=>{
    const flagApi = (0, $eYrUd.default)();
    const intl = (0, $5JgJ2.default)();
    const defaultCatch = (0, $cNoZ8.useDefaultCatch)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f2LYo.ResponderNamesContainer), {
        flagApi: flagApi,
        intlApi: intl,
        isGlobal: isGlobal,
        scope: scope,
        defaultCatch: defaultCatch,
        displayName: "ResponderNamesWrapper"
    }, children);
};
var $0afc639817e4e203$export$2e2bcd8739ae039 = $0afc639817e4e203$var$ResponderNamesWrapper;

});
parcelRegister("cNoZ8", function(module, exports) {

$parcel$export(module.exports, "useDefaultCatch", () => $57cfbd343da24417$export$3ab31fcc1d7c2589);

var $eUqFw = parcelRequire("eUqFw");

var $1xlT8 = parcelRequire("1xlT8");

var $hmoo5 = parcelRequire("hmoo5");
var $7JEKn = parcelRequire("7JEKn");
var $6ECEN = parcelRequire("6ECEN");
function $57cfbd343da24417$export$3ab31fcc1d7c2589() {
    const reportError = (0, $6ECEN.useReportError)();
    const [error, setError] = (0, $eUqFw.useState)();
    if (error) throw error;
    return (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($1xlT8)))(({ id: id, httpErrorHandler: httpErrorHandler, reporter: customReporter, attributes: attributes }, error)=>{
            if (!(0, $7JEKn.isNetworkError)(error)) return setError(new (0, $hmoo5.EocError)(id, error));
            if (customReporter !== null) {
                const reporter = customReporter ?? reportError;
                reporter(id, error, attributes);
            }
            try {
                return httpErrorHandler?.(error);
            } catch (handlerError) {
                if (!(0, $7JEKn.isNetworkError)(handlerError)) setError(new (0, $hmoo5.EocError)(id, handlerError));
                throw handlerError;
            }
        }), [
        reportError
    ]);
}

});
parcelRegister("1xlT8", function(module, exports) {

var $4dERK = parcelRequire("4dERK");

var $fPP09 = parcelRequire("fPP09");
/**
 * Returns a curried equivalent of the provided function. The curried function
 * has two unusual capabilities. First, its arguments needn't be provided one
 * at a time. If `f` is a ternary function and `g` is `R.curry(f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * Please note that default parameters don't count towards a [function arity](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/length)
 * and therefore `curry` won't work well with those:
 *
 * ```
 * const h = R.curry((a, b, c = 2) => a + b + c);
 *
 * h(40);
 * //=> function (waits for `b`)
 *
 * h(39)(1);
 * //=> 42
 *
 * h(1)(2, 3);
 * //=> 6
 *
 * h(1)(2)(7);
 * //=> Error! (`3` is not a function!)
 * ```
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (* -> a) -> (* -> a)
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curryN, R.partial
 * @example
 *
 *      const addFourNumbers = (a, b, c, d) => a + b + c + d;
 *
 *      const curriedAddFourNumbers = R.curry(addFourNumbers);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */ var $11e9da124d814c57$var$curry = /*#__PURE__*/ $4dERK(function curry(fn) {
    return $fPP09(fn.length, fn);
});
module.exports = $11e9da124d814c57$var$curry;

});
parcelRegister("4dERK", function(module, exports) {

var $1I8Ul = parcelRequire("1I8Ul");
/**
 * Optimized internal one-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $312813723f9a8dfa$var$_curry1(fn) {
    return function f1(a) {
        if (arguments.length === 0 || $1I8Ul(a)) return f1;
        else return fn.apply(this, arguments);
    };
}
module.exports = $312813723f9a8dfa$var$_curry1;

});
parcelRegister("1I8Ul", function(module, exports) {
function $13f0cf61ab9af0f6$var$_isPlaceholder(a) {
    return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
}
module.exports = $13f0cf61ab9af0f6$var$_isPlaceholder;

});


parcelRegister("fPP09", function(module, exports) {

var $4o4l6 = parcelRequire("4o4l6");

var $4dERK = parcelRequire("4dERK");

var $36yyD = parcelRequire("36yyD");

var $ezPBC = parcelRequire("ezPBC");
/**
 * Returns a curried equivalent of the provided function, with the specified
 * arity. The curried function has two unusual capabilities. First, its
 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curry
 * @example
 *
 *      const sumArgs = (...args) => R.sum(args);
 *
 *      const curriedAddFourNumbers = R.curryN(4, sumArgs);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */ var $b8732e3c667e42bb$var$curryN = /*#__PURE__*/ $36yyD(function curryN(length, fn) {
    if (length === 1) return $4dERK(fn);
    return $4o4l6(length, $ezPBC(length, [], fn));
});
module.exports = $b8732e3c667e42bb$var$curryN;

});
parcelRegister("4o4l6", function(module, exports) {
function $331cc501958ac5dd$var$_arity(n, fn) {
    /* eslint-disable no-unused-vars */ switch(n){
        case 0:
            return function() {
                return fn.apply(this, arguments);
            };
        case 1:
            return function(a0) {
                return fn.apply(this, arguments);
            };
        case 2:
            return function(a0, a1) {
                return fn.apply(this, arguments);
            };
        case 3:
            return function(a0, a1, a2) {
                return fn.apply(this, arguments);
            };
        case 4:
            return function(a0, a1, a2, a3) {
                return fn.apply(this, arguments);
            };
        case 5:
            return function(a0, a1, a2, a3, a4) {
                return fn.apply(this, arguments);
            };
        case 6:
            return function(a0, a1, a2, a3, a4, a5) {
                return fn.apply(this, arguments);
            };
        case 7:
            return function(a0, a1, a2, a3, a4, a5, a6) {
                return fn.apply(this, arguments);
            };
        case 8:
            return function(a0, a1, a2, a3, a4, a5, a6, a7) {
                return fn.apply(this, arguments);
            };
        case 9:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
                return fn.apply(this, arguments);
            };
        case 10:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
                return fn.apply(this, arguments);
            };
        default:
            throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
    }
}
module.exports = $331cc501958ac5dd$var$_arity;

});

parcelRegister("36yyD", function(module, exports) {

var $4dERK = parcelRequire("4dERK");

var $1I8Ul = parcelRequire("1I8Ul");
/**
 * Optimized internal two-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $242cbd0f1514987d$var$_curry2(fn) {
    return function f2(a, b) {
        switch(arguments.length){
            case 0:
                return f2;
            case 1:
                return $1I8Ul(a) ? f2 : $4dERK(function(_b) {
                    return fn(a, _b);
                });
            default:
                return $1I8Ul(a) && $1I8Ul(b) ? f2 : $1I8Ul(a) ? $4dERK(function(_a) {
                    return fn(_a, b);
                }) : $1I8Ul(b) ? $4dERK(function(_b) {
                    return fn(a, _b);
                }) : fn(a, b);
        }
    };
}
module.exports = $242cbd0f1514987d$var$_curry2;

});

parcelRegister("ezPBC", function(module, exports) {

var $4o4l6 = parcelRequire("4o4l6");

var $1I8Ul = parcelRequire("1I8Ul");
/**
 * Internal curryN function.
 *
 * @private
 * @category Function
 * @param {Number} length The arity of the curried function.
 * @param {Array} received An array of arguments received thus far.
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $a9cc5d6cdf6ff3d8$var$_curryN(length, received, fn) {
    return function() {
        var combined = [];
        var argsIdx = 0;
        var left = length;
        var combinedIdx = 0;
        while(combinedIdx < received.length || argsIdx < arguments.length){
            var result;
            if (combinedIdx < received.length && (!$1I8Ul(received[combinedIdx]) || argsIdx >= arguments.length)) result = received[combinedIdx];
            else {
                result = arguments[argsIdx];
                argsIdx += 1;
            }
            combined[combinedIdx] = result;
            if (!$1I8Ul(result)) left -= 1;
            combinedIdx += 1;
        }
        return left <= 0 ? fn.apply(this, combined) : $4o4l6(left, $a9cc5d6cdf6ff3d8$var$_curryN(length, combined, fn));
    };
}
module.exports = $a9cc5d6cdf6ff3d8$var$_curryN;

});



parcelRegister("hmoo5", function(module, exports) {

$parcel$export(module.exports, "EocError", () => $73e49bfad87ab049$export$e76fc0e0bc06f4df);
function $73e49bfad87ab049$var$hasMessage(cause) {
    return typeof cause === 'object' && cause !== null && 'message' in cause;
}
class $73e49bfad87ab049$export$e76fc0e0bc06f4df extends Error {
    constructor(id, cause){
        super(`[${id}] ${$73e49bfad87ab049$var$hasMessage(cause) ? cause.message : cause}`);
        this.id = id;
        this.cause = cause;
        this.name = 'EocError';
    }
}

});

parcelRegister("6ECEN", function(module, exports) {

$parcel$export(module.exports, "useReportError", () => $2c30e1304b44f553$export$5a5695b638d078e7);

var $eUqFw = parcelRequire("eUqFw");

var $7JEKn = parcelRequire("7JEKn");

var $8Y9XZ = parcelRequire("8Y9XZ");
function $2c30e1304b44f553$export$cad78388f408899e(error) {
    if (!(0, $7JEKn.isNetworkError)(error)) return true;
    return !(0, $7JEKn.isHTTPError)(error);
}
const $2c30e1304b44f553$export$5a5695b638d078e7 = ()=>{
    const { reporterAction: reporterAction } = (0, $8Y9XZ.useGlobalContextActions)();
    return (0, $eUqFw.useMemo)(()=>(id, error, attributes)=>{
            if (!$2c30e1304b44f553$export$cad78388f408899e(error)) return;
            reporterAction({
                id: id,
                error: error,
                attributes: attributes
            });
        }, [
        reporterAction
    ]);
};

});
parcelRegister("8Y9XZ", function(module, exports) {

$parcel$export(module.exports, "GlobalContextContainer", () => $1d9e59b4a8adbc9e$export$8a0b5f75aa4dc446);
$parcel$export(module.exports, "useExternalFlagService", () => $1d9e59b4a8adbc9e$export$6b9ad8a324c94098);
$parcel$export(module.exports, "useGlobalContextActions", () => $1d9e59b4a8adbc9e$export$8a9eff51cb8da29e);

var $eUqFw = parcelRequire("eUqFw");

var $3dpxL = parcelRequire("3dpxL");
var $5JgJ2 = parcelRequire("5JgJ2");

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");

var $2Gop2 = parcelRequire("2Gop2");
const $1d9e59b4a8adbc9e$export$390f32400eaf98c9 = (0, $a61MH.createStore)({
    name: 'global-context',
    initialState: {
        reporter: undefined
    },
    actions: $2Gop2
});
const $1d9e59b4a8adbc9e$export$8a0b5f75aa4dc446 = ({ flagService: flagService, reporter: reporter, children: children, messages: messages })=>{
    const { locale: locale } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1d9e59b4a8adbc9e$var$OriginalGlobalContextContainer, {
        reporter: reporter,
        isGlobal: true,
        flagService: flagService
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
        locale: locale,
        messages: messages && messages[locale]
    }, children));
};
const $1d9e59b4a8adbc9e$var$OriginalGlobalContextContainer = (0, $heB5U.createContainer)($1d9e59b4a8adbc9e$export$390f32400eaf98c9, {
    onInit: ()=>async ({ getState: getState, setState: setState }, { flagService: flagService })=>{
            !getState().flagService && setState({
                flagService: flagService
            });
        }
});
const $1d9e59b4a8adbc9e$export$2041a7a7b51b1fce = (0, $dYfll.createSubscriber)($1d9e59b4a8adbc9e$export$390f32400eaf98c9);
const $1d9e59b4a8adbc9e$export$6b9ad8a324c94098 = (0, $ggKAj.createHook)($1d9e59b4a8adbc9e$export$390f32400eaf98c9, {
    selector: (state)=>state.flagService
});
const $1d9e59b4a8adbc9e$export$8a9eff51cb8da29e = (0, $ggKAj.createActionsHook)($1d9e59b4a8adbc9e$export$390f32400eaf98c9);

});
parcelRegister("2Gop2", function(module, exports) {

$parcel$export(module.exports, "reporterAction", () => $199e61b56e681f87$export$f3910000817a36c2);
const $199e61b56e681f87$export$f3910000817a36c2 = ({ id: id, error: error, attributes: attributes })=>({}, { reporter: reporter })=>{
        if (reporter) {
            reporter({
                id: id,
                error: error,
                attributes: attributes
            });
            return;
        }
    };

});




parcelRegister("eYrUd", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a56fd115ec8d174$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hompL = parcelRequire("hompL");

var $3Oaez = parcelRequire("3Oaez");
var $4GEic = parcelRequire("4GEic");
var $f86rB = parcelRequire("f86rB");

var $6nbVQ = parcelRequire("6nbVQ");
var $1bJvm = parcelRequire("1bJvm");

var $8Y9XZ = parcelRequire("8Y9XZ");
const $0a56fd115ec8d174$var$useFlags = ()=>{
    const [flagService] = (0, $8Y9XZ.useExternalFlagService)();
    const serviceRef = (0, $eUqFw.useRef)(flagService);
    (0, $6nbVQ.assert)(!serviceRef.current || !!flagService, new (0, $1bJvm.AssertionError)('GlobalContext', 'flagService was destroyed.'));
    return serviceRef.current !== undefined ? {
        showFlag: ({ isAutoDismiss: isAutoDismiss, ...props })=>{
            const Component = ({ id: id, onDismissed: onDismissed })=>{
                if (isAutoDismiss) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Oaez.default), {
                    ...props,
                    id: id,
                    onDismissed: (id, e)=>{
                        onDismissed(id.toString());
                        props.onDismissed?.(id, e);
                    }
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4GEic.default), {
                    ...props,
                    id: id,
                    onDismissed: (id, e)=>{
                        onDismissed(id.toString());
                        props.onDismissed?.(id, e);
                    }
                });
            };
            const id = (0, $hompL.v4)();
            Component.id = id;
            serviceRef.current.showFlag(Component);
            return ()=>{
                serviceRef.current.dismissFlag({
                    id: id,
                    command: 'DISMISS'
                });
            };
        }
    } : //eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $f86rB.useFlags)();
};
var $0a56fd115ec8d174$export$2e2bcd8739ae039 = $0a56fd115ec8d174$var$useFlags;

});
parcelRegister("6nbVQ", function(module, exports) {

$parcel$export(module.exports, "assert", () => $d9834c637c2554ee$export$a7a9523472993e97);

var $1bJvm = parcelRequire("1bJvm");
/**
 * Throws when the condition is true
 * @param condition Condition to assert - can use type assertions thanks to ts's "asserts condition"
 * @param err An AssertionError object extending js error object
 */ const $d9834c637c2554ee$export$a7a9523472993e97 = function(condition, err) {
    if (!condition) throw err;
};

});
parcelRegister("1bJvm", function(module, exports) {

$parcel$export(module.exports, "AssertionError", () => $a0c746e7a19d2631$export$7750cdfb4db2c3d);
class $a0c746e7a19d2631$export$7750cdfb4db2c3d extends Error {
    constructor(id, message){
        super(`[${id}] ${message}`);
        this.id = id;
    }
}

});



parcelRegister("f2LYo", function(module, exports) {

$parcel$export(module.exports, "ResponderNamesContainer", () => $af3c4164a806a067$export$ae46960d51ae2b7);
$parcel$export(module.exports, "useResponderNamesStore", () => $af3c4164a806a067$export$d2c212d52c0e4d25);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $6dPuN = parcelRequire("6dPuN");

var $e0ds0 = parcelRequire("e0ds0");
const $af3c4164a806a067$export$cd391a137954b857 = (0, $a61MH.createStore)({
    initialState: (0, $e0ds0.initialState),
    actions: $6dPuN.actions,
    name: 'ResponderNamesStore'
});
const $af3c4164a806a067$export$ae46960d51ae2b7 = (0, $heB5U.createContainer)($af3c4164a806a067$export$cd391a137954b857);
const $af3c4164a806a067$export$d2c212d52c0e4d25 = (0, $ggKAj.createHook)($af3c4164a806a067$export$cd391a137954b857);

});
parcelRegister("6dPuN", function(module, exports) {

$parcel$export(module.exports, "actions", () => $487be6eeb44a28bd$export$e324594224ef24da);

var $6nbVQ = parcelRequire("6nbVQ");
var $1bJvm = parcelRequire("1bJvm");
var $kZ1gK = parcelRequire("kZ1gK");

var $4SzXS = parcelRequire("4SzXS");

var $gFohH = parcelRequire("gFohH");

var $9IqXI = parcelRequire("9IqXI");
const $487be6eeb44a28bd$var$fetchResponders = (missingResponders)=>({ setState: setState, getState: getState, dispatch: dispatch }, { flagApi: flagApi, intlApi: intlApi, defaultCatch: defaultCatch })=>{
        const { responders: responders } = getState();
        if (!Object.keys(missingResponders).length) return Promise.resolve();
        const errorItems = (0, $4SzXS.mapErrorForResponder)(missingResponders);
        setState({
            responders: {
                ...responders,
                ...missingResponders
            }
        });
        //TODO: How to handle if BE returns [], what will be the behaviour?
        return (0, $gFohH.getResponderNames)(Object.values(missingResponders).map(({ id: id, type: type })=>({
                id: id,
                type: type
            }))).then((response)=>{
            const responseMap = response.values.map((r)=>({
                    isError: false,
                    isLoading: false,
                    acknowledged: true,
                    ...r
                })).reduce((acc, r)=>{
                acc[r.id] = r;
                return acc;
            }, {});
            const responderItemMap = Object.keys(missingResponders).reduce((acc, key)=>{
                const itemByEmail = Object.values(responseMap).find((res)=>res.email === key);
                if (itemByEmail) {
                    acc[key] = {
                        ...errorItems[key],
                        ...itemByEmail
                    };
                    return acc;
                }
                const itemByAtlassianIdentifier = Object.values(responseMap).find((res)=>res.atlassianIdentifier === key);
                if (itemByAtlassianIdentifier) {
                    acc[key] = {
                        ...errorItems[key],
                        ...itemByAtlassianIdentifier
                    };
                    return acc;
                }
                acc[key] = {
                    ...errorItems[key],
                    ...responseMap[key]
                };
                return acc;
            }, {});
            setState({
                responders: {
                    ...getState().responders,
                    ...responderItemMap
                }
            });
        }).catch(defaultCatch({
            id: 'fetchResponders',
            httpErrorHandler: ()=>{
                //Retry will be shown on the toast message
                const dismiss = flagApi.showFlag({
                    ...(0, $kZ1gK.errorToastProps)(),
                    title: intlApi.formatMessage((0, $9IqXI.messages).fetchError),
                    isAutoDismiss: true,
                    actions: [
                        {
                            content: intlApi.formatMessage((0, $9IqXI.messages).retry),
                            onClick: ()=>{
                                dispatch($487be6eeb44a28bd$var$fetchResponders(missingResponders));
                                dismiss();
                            }
                        }
                    ]
                });
                const responders = Object.assign({}, getState().responders, errorItems);
                setState({
                    responders: responders
                });
            }
        }));
    };
/**
 * It takes missingResponders and updates the store with additional parameters
 * when it is called on the useResponderNames() hook.
 * It sets isLoading to true for every responder item.
 * This function is implemented to batch requests coming from different components.
 */ const $487be6eeb44a28bd$var$batchResponders = (requestedResponders)=>({ setState: setState, getState: getState, dispatch: dispatch }, { displayName: displayName })=>{
        (0, $6nbVQ.assert)(displayName === 'ResponderNamesWrapper', new (0, $1bJvm.AssertionError)('useResponderNames', 'Unable to find ResponderNamesWrapper'));
        const missingResponders = requestedResponders.filter((responder)=>!getState().responders[responder.id]);
        if (!missingResponders.length) return;
        const requestedRespondersMap = requestedResponders.reduce((acc, r)=>{
            acc[r.id] = {
                id: r.id,
                type: r.type,
                acknowledged: false,
                isError: false,
                isLoading: true
            };
            return acc;
        }, {});
        const existingResponders = getState().responders;
        const allResponderIds = [
            ...Object.keys(existingResponders),
            ...Object.keys(requestedRespondersMap)
        ];
        const allResponders = allResponderIds.reduce((acc, key)=>{
            acc[key] = {
                ...requestedRespondersMap[key],
                ...existingResponders[key]
            };
            return acc;
        }, {});
        setState({
            responders: allResponders
        });
        const timeoutState = getState().timeout;
        if (timeoutState !== undefined) clearTimeout(timeoutState);
        //It debounces the requested responders(batching)
        const timeout = setTimeout(()=>{
            const missingResponders = Object.fromEntries(Object.entries(getState().responders).filter(([key, value])=>(0, $4SzXS.isNotLoaded)(value)).map(([key, value])=>[
                    key,
                    {
                        ...value,
                        acknowledged: true
                    }
                ]));
            if (Object.keys(missingResponders).length) dispatch($487be6eeb44a28bd$var$fetchResponders(missingResponders));
        }, 10);
        setState({
            timeout: timeout
        });
    };
const $487be6eeb44a28bd$export$e324594224ef24da = {
    fetchResponders: $487be6eeb44a28bd$var$fetchResponders,
    batchResponders: $487be6eeb44a28bd$var$batchResponders
};

});
parcelRegister("kZ1gK", function(module, exports) {

$parcel$export(module.exports, "errorToastProps", () => $6fc64424292c70f4$export$c37f1e5051cd0bbc);
$parcel$export(module.exports, "warningToastProps", () => $6fc64424292c70f4$export$fe81a150e4e6ac02);
$parcel$export(module.exports, "infoToastProps", () => $6fc64424292c70f4$export$e70d6574d157a39b);
$parcel$export(module.exports, "successToastProps", () => $6fc64424292c70f4$export$b56198a940066d8f);

var $eUqFw = parcelRequire("eUqFw");

var $2qhQi = parcelRequire("2qhQi");

var $aWvIp = parcelRequire("aWvIp");

var $96IgR = parcelRequire("96IgR");

var $2bv8J = parcelRequire("2bv8J");

var $5YsMl = parcelRequire("5YsMl");

var $PdmhA = parcelRequire("PdmhA");

var $ir7af = parcelRequire("ir7af");
const $6fc64424292c70f4$var$ErrorWithIntl = (0, $2qhQi.default)(({ intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
        primaryColor: `var(--ds-icon-danger, ${(0, $PdmhA.R300)})`,
        size: "medium",
        label: intl.formatMessage((0, $ir7af.default).error)
    }));
const $6fc64424292c70f4$var$WarningWithIntl = (0, $2qhQi.default)(({ intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
        primaryColor: `var(--ds-icon-warning, ${(0, $PdmhA.Y300)})`,
        size: "medium",
        label: intl.formatMessage((0, $ir7af.default).warning)
    }));
const $6fc64424292c70f4$var$InfoWithIntl = (0, $2qhQi.default)(({ intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2bv8J))), {
        primaryColor: `var(--ds-icon-discovery, ${(0, $PdmhA.P300)})`,
        size: "medium",
        label: intl.formatMessage((0, $ir7af.default).info)
    }));
const $6fc64424292c70f4$var$SuccessWithIntl = (0, $2qhQi.default)(({ intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))), {
        primaryColor: `var(--ds-icon-success, ${(0, $PdmhA.G300)})`,
        size: "medium",
        label: intl.formatMessage((0, $ir7af.default).success)
    }));
const $6fc64424292c70f4$export$c37f1e5051cd0bbc = ()=>({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6fc64424292c70f4$var$ErrorWithIntl, null),
        appearance: 'normal'
    });
const $6fc64424292c70f4$export$fe81a150e4e6ac02 = ()=>({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6fc64424292c70f4$var$WarningWithIntl, null),
        appearance: 'normal'
    });
const $6fc64424292c70f4$export$e70d6574d157a39b = ()=>({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6fc64424292c70f4$var$InfoWithIntl, null),
        appearance: 'normal'
    });
const $6fc64424292c70f4$export$b56198a940066d8f = ()=>({
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6fc64424292c70f4$var$SuccessWithIntl, null),
        appearance: 'normal',
        isAutoDismiss: true
    });

});
parcelRegister("ir7af", function(module, exports) {

$parcel$export(module.exports, "default", () => $9eb81bee64935431$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $9eb81bee64935431$var$messages = (0, $90IgZ.defineMessages)({
    error: {
        id: 'eoc.common.toast.error',
        defaultMessage: 'Error',
        description: 'The title for an error as a single word.'
    },
    warning: {
        id: 'eoc.common.toast.warning',
        defaultMessage: 'Warning',
        description: 'The title for a warning as a single word.'
    },
    success: {
        id: 'eoc.common.toast.success',
        defaultMessage: 'Success',
        description: 'The title for success as a single word.'
    },
    info: {
        id: 'eoc.common.toast.info',
        defaultMessage: 'Information',
        description: 'The title for an information as a single word.'
    }
});
var $9eb81bee64935431$export$2e2bcd8739ae039 = $9eb81bee64935431$var$messages;

});


parcelRegister("4SzXS", function(module, exports) {

$parcel$export(module.exports, "mapErrorForResponder", () => $38d81a6d96018073$export$245cebe8a9527ff0);
$parcel$export(module.exports, "isNotLoaded", () => $38d81a6d96018073$export$ea78f980ad0c92fe);
const $38d81a6d96018073$export$245cebe8a9527ff0 = (requestedResponders)=>Object.entries(requestedResponders).reduce((acc, [key, value])=>{
        acc[key] = {
            id: value.id,
            type: value.type,
            isError: true,
            acknowledged: true,
            isLoading: false
        };
        return acc;
    }, {});
const $38d81a6d96018073$export$ea78f980ad0c92fe = (responder)=>!Boolean(responder === null || responder === void 0 ? void 0 : responder.isError) && !Boolean(responder === null || responder === void 0 ? void 0 : responder.acknowledged);

});

parcelRegister("gFohH", function(module, exports) {

$parcel$export(module.exports, "getResponderNames", () => $c223501348cb804b$export$7345ec3bad54e226);

var $kRdYM = parcelRequire("kRdYM");
const $c223501348cb804b$export$7345ec3bad54e226 = (requestedResponders)=>{
    const responders = requestedResponders.reduce((acc, curr)=>{
        // any is intentional here we don't want to add
        // unknown to the ResponderType because we don't want it to be public
        if (curr.type === 'unknown') return [
            ...acc,
            {
                id: curr.id,
                type: 'schedule'
            },
            {
                id: curr.id,
                type: 'user'
            },
            {
                id: curr.id,
                type: 'team'
            },
            {
                id: curr.id,
                type: 'escalation'
            }
        ];
        return [
            ...acc,
            curr
        ];
    }, []);
    return (0, $kRdYM.eocFetch)(`/v1/alerts/responders/names`, {
        method: 'POST',
        body: {
            responders: responders
        }
    });
};

});

parcelRegister("9IqXI", function(module, exports) {

$parcel$export(module.exports, "messages", () => $712d233b4c9eb9fa$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $712d233b4c9eb9fa$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    fetchError: {
        id: `eoc.responder-names-fetch-error`,
        defaultMessage: "We couldn't fetch the responder names.",
        description: 'The text will be displayed when there is error'
    },
    retry: {
        id: `eoc.responder-names-retry`,
        defaultMessage: 'Retry',
        description: 'The title for retry as a single word.'
    }
});

});


parcelRegister("e0ds0", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $a31b7fd1e3db8013$export$d4c72bab9d6cc13a);
const $a31b7fd1e3db8013$export$d4c72bab9d6cc13a = {
    responders: {}
};

});



parcelRegister("eRDf0", function(module, exports) {

$parcel$export(module.exports, "AsyncLinkedAlertsField", () => $f6af975bac18c3f3$export$5dd38ea4ae79439a);

var $7rh0R = parcelRequire("7rh0R");

const $f6af975bac18c3f3$export$5dd38ea4ae79439a = (0, $7rh0R.lazy)(()=>(parcelRequire("6bhS5")).then((module)=>module.LinkedAlertsField), {
    moduleId: "./src/packages/issue/fields/linked-alerts/src/ui/index.tsx"
});

});
parcelRegister("6bhS5", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hfvK9');
        const value = parcelRequire('7SC1w');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hfvK9").then(()=>parcelRequire('7SC1w'));
}

});



parcelRegister("48mPv", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce578c493ad96d9e$export$2e2bcd8739ae039);
class $ce578c493ad96d9e$export$2e2bcd8739ae039 {
    constructor(issueId, mutationType, version = '1', matchStatus = [], // eslint-disable-next-line @typescript-eslint/no-unused-vars
    lastModified){
        this.issueId = issueId;
        this.mutationType = mutationType;
        this.version = version;
        this.matchStatus = matchStatus;
        // create a new timeStamp whenever an object is initialized
        this.lastModified = new Date().toISOString();
    }
}

});

parcelRegister("d7Wfe", function(module, exports) {

$parcel$export(module.exports, "MutationSource", () => $598bd411eca1df87$export$17f28c4c94a74282);
$parcel$export(module.exports, "CacheType", () => $598bd411eca1df87$export$ba193b555633db78);
const $598bd411eca1df87$export$17f28c4c94a74282 = {
    CREATE: 0,
    UPDATE: 1,
    DELETE: 2
};
const $598bd411eca1df87$export$ba193b555633db78 = {
    LOCAL: 'local',
    SESSION: 'session'
};

});

parcelRegister("bsdZ2", function(module, exports) {

$parcel$export(module.exports, "useEcClient", () => $b40c4387cd757cd5$export$9da409beb25e67da);

var $eUqFw = parcelRequire("eUqFw");

var $gUUjF = parcelRequire("gUUjF");

var $gd0Sp = parcelRequire("gd0Sp");

var $65uQX = parcelRequire("65uQX");
const $b40c4387cd757cd5$export$9da409beb25e67da = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let tenantContext;
    try {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        tenantContext = (0, $gd0Sp.useTenantContext)();
    } catch (e) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('jsis-ec-client', `tenant context : ${e?.toString() || ''}`);
    }
    (0, $eUqFw.useEffect)(()=>{
        (0, $65uQX.EcClient).setTenantDetails(tenantContext?.activationId, tenantContext?.cloudId, tenantContext?.atlassianAccountId);
    }, [
        tenantContext
    ]);
    const saveIssueMutationToCache = (0, $eUqFw.useCallback)((issueMutation, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, analyticsFailureEventObj = {})=>(0, $65uQX.default).saveIssueMutationToCache(issueMutation, key, analyticsFailureEventObj), []);
    const saveIssueMutationsToCache = (0, $eUqFw.useCallback)((issueMutations, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, analyticsFailureEventObj = {})=>(0, $65uQX.default).saveIssueMutationsToCache(issueMutations, key, analyticsFailureEventObj), []);
    const searchAndReconcile = (0, $eUqFw.useCallback)((matchApiUrl, jqlMatchingKey, search, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parseIssueData, capability)=>(0, $65uQX.default).searchAndReconcile(matchApiUrl, jqlMatchingKey, search, parseIssueData, capability), []);
    const getIssueMutationFromCache = (key)=>(0, $65uQX.default).getIssueMutationFromCache(key);
    return {
        saveIssueMutationToCache: saveIssueMutationToCache,
        saveIssueMutationsToCache: saveIssueMutationsToCache,
        searchAndReconcile: searchAndReconcile,
        getIssueMutationFromCache: getIssueMutationFromCache
    };
};

});
parcelRegister("65uQX", function(module, exports) {

$parcel$export(module.exports, "EcClient", () => $9d182d4720e39d79$export$a736992aaac2307a);
$parcel$export(module.exports, "getEcClient", () => $9d182d4720e39d79$export$c9342bd32f51406b);
$parcel$export(module.exports, "default", () => $9d182d4720e39d79$export$2e2bcd8739ae039);

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $2OdyW = parcelRequire("2OdyW");

var $jMP2a = parcelRequire("jMP2a");

var $3FyZ4 = parcelRequire("3FyZ4");

var $7S3WE = parcelRequire("7S3WE");

var $d7Wfe = parcelRequire("d7Wfe");

var $4qvSX = parcelRequire("4qvSX");
class $9d182d4720e39d79$export$a736992aaac2307a {
    #issueCache;
    #config;
    constructor(){
        this.#issueCache = new (0, $7S3WE.default)('issue-cache-v1');
        this.#config = {};
    }
    /**
	 * A method to set tenant level details.
	 * These details include activation id, cloud id and user id
	 */ static setTenantDetails(activationID, cloudID, atlassianAccountId) {
        (0, $7S3WE.default).setTenantDetails(activationID, cloudID, atlassianAccountId);
    }
    /**
	 * A method to fire analytics events for both success and failure
	 */ static fireAnalyticsEvents(issueMutations, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, isSaved, analyticsFailureEventObj = {}) {
        try {
            // let mutationAnalyticsObj: any = [];
            let trackingId = '-1';
            if (Array.isArray(issueMutations)) //   mutationAnalyticsObj = issueMutations.map((item: IssueMutation) => item.issueId);
            trackingId = String(new Date(issueMutations[0]?.lastModified).valueOf()) + (0, $7S3WE.default).userID;
            else trackingId = String(new Date(issueMutations.lastModified).valueOf()) + (0, $7S3WE.default).userID;
            const payload = {
                action: 'mutated',
                actionSubject: 'issue',
                source: key?.analyticsMetadata?.scenario || 'unknown',
                attributes: {
                    ...key.analyticsMetadata,
                    trackingId: // issueMutationDetails: mutationAnalyticsObj,
                    trackingId
                }
            };
            // Error condition
            if (!isSaved) {
                if (!analyticsFailureEventObj) // eslint-disable-next-line no-param-reassign
                analyticsFailureEventObj = {
                    error: true,
                    errorMsg: payload.source
                };
                payload.attributes = {
                    ...payload.attributes,
                    ...analyticsFailureEventObj
                };
            }
            if (Object.prototype.hasOwnProperty.call(key, 'analyticsEventObj')) (0, $jMP2a.fireTrackAnalytics)(// @ts-expect-error - Argument of type 'Object' is not assignable to parameter of type 'UIAnalyticsEvent'.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            key.analyticsEventObj, `${payload.actionSubject} ${payload.action}`, payload.attributes);
            else // if there is no UI component that triggers the event then we manually fire the event
            (0, $3FyZ4.getAnalyticsWebClientPromise)().then((client)=>{
                client.getInstance().sendTrackEvent(payload);
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('jsis-ec-client', e);
        }
    }
    /**
	 * A method to save a single issue mutations in cache
	 */ async saveIssueMutationToCache(issueMutation, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, analyticsFailureEventObj = {}) {
        if ((0, $1ybV0.ff)('odin.enable.backend.cache.ec.client')) {
            const isSaved = (0, $7S3WE.default).setBackendCache(issueMutation);
            $9d182d4720e39d79$export$a736992aaac2307a.fireAnalyticsEvents(issueMutation, key, isSaved, analyticsFailureEventObj);
            return isSaved;
        }
        return this.#issueCache.isPresent(issueMutation.issueId).then(async (result)=>{
            let isSaved = false;
            if (issueMutation.mutationType === (0, $d7Wfe.MutationSource).DELETE) isSaved = await this.#issueCache.delete(issueMutation.issueId);
            else if (result || issueMutation.mutationType === (0, $d7Wfe.MutationSource).UPDATE) isSaved = await this.#issueCache.update(issueMutation.issueId);
            else isSaved = await this.#issueCache.create(issueMutation.issueId);
            $9d182d4720e39d79$export$a736992aaac2307a.fireAnalyticsEvents(issueMutation, key, isSaved, analyticsFailureEventObj);
            return new Promise((resolve)=>resolve(isSaved));
        });
    }
    /**
	 * A method to save multiple issue mutations in cache
	 */ async saveIssueMutationsToCache(issueMutations, key = {
        analyticsMetadata: {
            scenario: 'unknown'
        }
    }, analyticsFailureEventObj = {}) {
        const data = [];
        if ((0, $1ybV0.ff)('odin.enable.backend.cache.ec.client')) {
            const isSaved = (0, $7S3WE.default).setBackendCache(issueMutations);
            $9d182d4720e39d79$export$a736992aaac2307a.fireAnalyticsEvents(issueMutations, key, isSaved, analyticsFailureEventObj);
            return [
                isSaved
            ];
        }
        issueMutations.forEach(async (issueMutation)=>{
            this.#issueCache.isPresent(issueMutation.issueId).then(async (result)=>{
                let isSaved = false;
                if (issueMutation.mutationType === (0, $d7Wfe.MutationSource).DELETE) isSaved = await this.#issueCache.delete(issueMutation.issueId);
                else if (result || issueMutation.mutationType === (0, $d7Wfe.MutationSource).UPDATE) isSaved = await this.#issueCache.update(issueMutation.issueId);
                else isSaved = await this.#issueCache.create(issueMutation.issueId);
                data.push(isSaved);
                $9d182d4720e39d79$export$a736992aaac2307a.fireAnalyticsEvents(issueMutations, key, isSaved, analyticsFailureEventObj);
            });
        });
        return new Promise((resolve)=>resolve(data));
    }
    /**
	 * A method to get issue mutations in saved in cache
	 */ getIssueMutationFromCache(key) {
        return this.#issueCache.get(key);
    }
    /**
	 * A method to remove the deleted issues from the search API
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async filterData(data) {
        const localStorageData = await this.getIssueMutationFromCache(null);
        const deletedData = new Set();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.values(localStorageData).forEach((element)=>{
            if (element.mutationType === (0, $d7Wfe.MutationSource).DELETE) deletedData.add(element.issueId);
        });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredData = [];
        let success = true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.values(data).forEach((element)=>{
            if (!element.id || typeof element.id !== 'number') success = false;
            else if (!deletedData.has(element.id.toString())) filteredData.push(element);
        });
        return new Promise((// eslint-disable-next-line @typescript-eslint/no-explicit-any
        resolve, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        reject)=>{
            if (success) resolve(filteredData);
            else reject(new Error());
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    async constructMatchRequest() {
        const issueData = {
            issues: [],
            hydrationMode: 0
        };
        const data = await this.getIssueMutationFromCache(null);
        Object.values(data).forEach((issueMutation)=>{
            const element = {
                issueId: issueMutation.issueId,
                version: issueMutation.version
            };
            issueData.issues.push(element);
        });
        const options = {
            method: 'POST',
            headers: {
                content_type: 'application/json',
                // @ts-expect-error - TS2339 - Property 'capability' does not exist on type 'object'.
                'x-atlassian-capability': this.#config.capability
            },
            body: JSON.stringify(issueData)
        };
        return new Promise((resolve)=>resolve(options));
    }
    /**
	 * A method to get the relevant search data from the parsing function that the user has provided
	 */ static getIssueDataFromSearch(data, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parseIssueData) {
        const result = parseIssueData(data);
        if (result == null) return [];
        return result;
    }
    /**
	 * A method to get the search data and reconcile it with the data present in cache
	 */ async searchAndReconcile(matchApiUrl, jqlMatchingKey, search, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    parseIssueData, capability) {
        // @ts-expect-error - TS2339 - Property 'capability' does not exist on type 'object'.
        this.#config.capability = capability;
        const matchRequest = await this.constructMatchRequest();
        if (matchRequest && matchRequest.body && matchRequest.body.issues && matchRequest.body.issues.length === 0) return search.then((data)=>new Promise((resolve)=>resolve({
                    reconciledIssues: $9d182d4720e39d79$export$a736992aaac2307a.getIssueDataFromSearch(data, parseIssueData),
                    matchAPIResponse: {
                        response: {
                            resultsByIssueId: {}
                        },
                        issue: {
                            issuesResponse: {}
                        }
                    }
                })));
        const matchPromise = (0, $2OdyW.default)(matchApiUrl, matchRequest);
        return Promise.all([
            search,
            matchPromise
        ]).then(([data, response])=>{
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const structuredData = $9d182d4720e39d79$export$a736992aaac2307a.getIssueDataFromSearch(data, parseIssueData);
            return this.filterData(structuredData) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .then((filteredSearchData)=>{
                if (response == null || response.response == null || response.response.resultsByIssueId == null) throw new Error('Match response is invalid!');
                const matchedIssueIds = response.response.resultsByIssueId;
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const filteredMatchedIssueIdsData = [];
                Object.entries(matchedIssueIds).forEach(([key, value])=>{
                    if (value === 'RESULT_MATCH') filteredMatchedIssueIdsData.push({
                        id: parseInt(key, 10)
                    });
                });
                return new Promise((resolve)=>{
                    resolve({
                        reconciledIssues: (0, $4qvSX.mergeResponseData)(filteredSearchData, filteredMatchedIssueIdsData),
                        matchAPIResponse: response
                    });
                });
            }).catch(()=>new Promise((resolve)=>resolve({
                        reconciledIssues: structuredData,
                        matchAPIResponse: response
                    })));
        });
    }
}
const $9d182d4720e39d79$var$ecClient = new $9d182d4720e39d79$export$a736992aaac2307a();
function $9d182d4720e39d79$export$c9342bd32f51406b(tenantContext = {}) {
    $9d182d4720e39d79$export$a736992aaac2307a.setTenantDetails(tenantContext?.activationId, tenantContext?.cloudId, tenantContext?.atlassianAccountId);
    return $9d182d4720e39d79$var$ecClient;
}
var $9d182d4720e39d79$export$2e2bcd8739ae039 = $9d182d4720e39d79$var$ecClient;

});
parcelRegister("7S3WE", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed861ad8bfcfb81a$export$2e2bcd8739ae039);
// Issue Cache API is an internal tool and this file should not be edited. Please contact Odin team for any modifications.

var $kBiqn = parcelRequire("kBiqn");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $2OdyW = parcelRequire("2OdyW");

var $48mPv = parcelRequire("48mPv");

var $d7Wfe = parcelRequire("d7Wfe");

var $4qvSX = parcelRequire("4qvSX");
const $ed861ad8bfcfb81a$var$MAX_AGE_MIN = 5;
const $ed861ad8bfcfb81a$var$MAX_AGE = $ed861ad8bfcfb81a$var$MAX_AGE_MIN * 60000;
const $ed861ad8bfcfb81a$var$CACHE_SIZE = 100;
const $ed861ad8bfcfb81a$var$CACHE_KEY_PREFIX = '__storejs';
const $ed861ad8bfcfb81a$var$BE_CACHE_SAVE_ISSUE_MUTATION = '/gateway/api/jira-jql-service/api/v1/issue-mutation';
class $ed861ad8bfcfb81a$export$2e2bcd8739ae039 {
    #localCache;
    #sessionCache;
    constructor(namespace, maxAge = $ed861ad8bfcfb81a$var$MAX_AGE){
        this.maxAge = maxAge;
        this.namespace = namespace;
        // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
        this.#localCache = new (0, $kBiqn.Cache)({
            size: $ed861ad8bfcfb81a$var$CACHE_SIZE,
            storageType: (0, $d7Wfe.CacheType).LOCAL,
            cacheKey: namespace
        });
        // @ts-expect-error - TS7009 - 'new' expression, whose target lacks a construct signature, implicitly has an 'any' type.
        this.#sessionCache = new (0, $kBiqn.Cache)({
            size: $ed861ad8bfcfb81a$var$CACHE_SIZE,
            storageType: (0, $d7Wfe.CacheType).SESSION,
            cacheKey: namespace
        });
    }
    /**
	 * A method to set tenant level details.
	 * These details include activation id, cloud id and user id
	 */ static setTenantDetails(activationID, cloudID, userID) {
        if (activationID && activationID !== $ed861ad8bfcfb81a$export$2e2bcd8739ae039.activationID) $ed861ad8bfcfb81a$export$2e2bcd8739ae039.activationID = activationID;
        if (cloudID && cloudID !== $ed861ad8bfcfb81a$export$2e2bcd8739ae039.cloudID) $ed861ad8bfcfb81a$export$2e2bcd8739ae039.cloudID = cloudID;
        if (userID && userID !== $ed861ad8bfcfb81a$export$2e2bcd8739ae039.userID) $ed861ad8bfcfb81a$export$2e2bcd8739ae039.userID = userID;
    }
    /**
	 * A util method to decide whether an issue mutation in cache is stale or not
	 */ static isIssueMutationStale(issueMutation) {
        const lastModified = new Date(issueMutation.lastModified).getTime();
        return Date.now() - lastModified < $ed861ad8bfcfb81a$var$MAX_AGE;
    }
    /**
	 * A util method to generate partial key containing username for storing in cache
	 */ static generateKey() {
        let anonymousId = window.localStorage.getItem('ajs_anonymous_id');
        anonymousId = anonymousId ? `.${anonymousId}` : '';
        anonymousId = anonymousId.replace(/["]+/g, '');
        // TODO : Replace this with something more generic
        return `jsis.ecCache.data${anonymousId}.newIssuesMutationList`;
    }
    /**
	 * A method to generate key containing username as well as namespace for storing in cache
	 */ generateReadKey() {
        return `${$ed861ad8bfcfb81a$var$CACHE_KEY_PREFIX}_${this.namespace}_${$ed861ad8bfcfb81a$export$2e2bcd8739ae039.generateKey()}`;
    }
    /**
	 * A method to get the issue mutations stored in the cache
	 * Accepts issueIds or array of issuesIds and returns corresponding issue mutations
	 * Returns all the issue mutations when provided with null argument in form of an array
	 * Cleans the cache before accessing issue mutations in order to avoid stale data
	 */ async get(key) {
        return this.cleanCache().then(()=>this.getWithoutClean(key));
    }
    /**
	 * A method to get the issue mutations stored in the cache
	 * Accepts issueIds or array of issuesIds to return selective issue mutations
	 * Returns all the issue mutations when provided with null argument
	 */ async getWithoutClean(key) {
        if (key == null) return new Promise((resolve)=>{
            this.#localCache.get(this.generateReadKey()).then((data)=>data ? resolve(data) : resolve({}));
        });
        return new Promise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (resolve)=>{
            this.#localCache.get(this.generateReadKey()).then((data)=>{
                if (!data) resolve({});
                else {
                    const iterableData = data;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const newData = {};
                    if (typeof key === 'string') newData[key] = iterableData[key];
                    else if (Array.isArray(key)) key.forEach((issueId)=>{
                        newData[issueId] = iterableData[issueId];
                    });
                    resolve(newData);
                }
            });
        });
    }
    /**
	 * A method to construct object to be stored in backend cache
	 * Can receive an issue mutation or an array of issue mutations to be saved in cache
	 */ static constructBackendCacheObject(value) {
        if (value instanceof (0, $48mPv.default)) return {
            issueId: value.issueId,
            mutationType: value.mutationType,
            mutationTimestamp: value.lastModified
        };
        const result = [];
        value.forEach((data)=>{
            result.push($ed861ad8bfcfb81a$export$2e2bcd8739ae039.constructBackendCacheObject(data));
        });
        return result;
    }
    /**
	 * A method to save the issue mutations in the backend cache
	 * Can receive an issue mutation or an array of issue mutations to be saved in cache
	 */ static setBackendCache(data) {
        try {
            let issueBody = $ed861ad8bfcfb81a$export$2e2bcd8739ae039.constructBackendCacheObject(data);
            let trackingId = '-1';
            if (data instanceof (0, $48mPv.default)) {
                trackingId = String(new Date(data.lastModified).valueOf()) + ($ed861ad8bfcfb81a$export$2e2bcd8739ae039.userID || '');
                issueBody = [
                    issueBody
                ];
            } else trackingId = String(new Date(data[0].lastModified).valueOf()) + ($ed861ad8bfcfb81a$export$2e2bcd8739ae039.userID || '');
            (0, $2OdyW.default)($ed861ad8bfcfb81a$var$BE_CACHE_SAVE_ISSUE_MUTATION, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'ATL-activationId': $ed861ad8bfcfb81a$export$2e2bcd8739ae039.activationID || '',
                    'atl-CloudId': $ed861ad8bfcfb81a$export$2e2bcd8739ae039.cloudID || '',
                    trackingId: trackingId
                },
                body: JSON.stringify({
                    issueMutations: issueBody
                })
            });
            return true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('jsis-ec-client', `${e?.toString() || ''}mutationObj: ${data}`);
            return false;
        }
    }
    /**
	 * A method to save the issue mutations in the cache
	 * Can receive an issue mutation or an array of issue mutations to be saved in cache
	 */ async set(value) {
        return this.getWithoutClean().then(async (cacheData)=>{
            if (value instanceof (0, $48mPv.default)) {
                const storeValue = {
                    [value.issueId]: value
                };
                return new Promise((resolve)=>{
                    try {
                        this.#localCache.set(this.generateReadKey(), (0, $4qvSX.mergeData)(cacheData, storeValue));
                        resolve(true);
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    } catch (e) {
                        resolve(false);
                    }
                });
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const storeData = {};
            value.forEach((data)=>{
                storeData[data.issueId] = data;
            });
            return new Promise((resolve)=>{
                try {
                    this.#localCache.set(this.generateReadKey(), (0, $4qvSX.mergeData)(cacheData, storeData));
                    resolve(true);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (e) {
                    resolve(false);
                }
            });
        });
    }
    /**
	 * A method to create a new issue mutation in cache
	 * Can receive an issue ids or an array of issue ids to be created in cache
	 */ async create(value) {
        return this.cleanCache().then(()=>{
            if (!Array.isArray(value)) return this.set(new (0, $48mPv.default)(value, (0, $d7Wfe.MutationSource).CREATE, '1', [], new Date().toISOString()));
            const storeData = value.map((data)=>new (0, $48mPv.default)(data, (0, $d7Wfe.MutationSource).CREATE, '1', [], new Date().toISOString()));
            return this.set(storeData);
        });
    }
    /**
	 * A method to update an already existing issue mutation in cache
	 * Can receive an issue ids or an array of issue ids to be updated in cache
	 */ async update(value) {
        if ((0, $1ybV0.ff)('odin.enable.backend.cache.ec.client')) {
            if (typeof value === 'string') return this.set(new (0, $48mPv.default)(value, (0, $d7Wfe.MutationSource).UPDATE, '1', []));
            return this.set(value.map((issueId)=>new (0, $48mPv.default)(issueId, (0, $d7Wfe.MutationSource).UPDATE, '1', [])));
        }
        return this.getWithoutClean(value).then((data)=>{
            const valueToUpdate = [];
            Object.entries(data).forEach(([issueId, issueMutationObj])=>{
                if (issueMutationObj instanceof (0, $48mPv.default)) {
                    if ($ed861ad8bfcfb81a$export$2e2bcd8739ae039.isIssueMutationStale(issueMutationObj)) valueToUpdate.push(new (0, $48mPv.default)(String(issueId), (0, $d7Wfe.MutationSource).UPDATE, issueMutationObj.version, issueMutationObj.matchStatus, new Date().toISOString()));
                    else valueToUpdate.push(new (0, $48mPv.default)(String(issueId), (0, $d7Wfe.MutationSource).CREATE, '1', issueMutationObj.matchStatus, new Date().toISOString()));
                } else valueToUpdate.push(new (0, $48mPv.default)(String(issueId), (0, $d7Wfe.MutationSource).UPDATE, // TODO: Incorporate the version and match status and change the update method signature
                '1', [], new Date().toISOString()));
            });
            return this.set(valueToUpdate);
        });
    }
    /**
	 * A method to delete an issue mutation in cache
	 */ async delete(key) {
        if (typeof key === 'string') return this.set(new (0, $48mPv.default)(key, (0, $d7Wfe.MutationSource).DELETE, '', [], new Date().toISOString()));
        const storeData = key.map((data)=>new (0, $48mPv.default)(data, (0, $d7Wfe.MutationSource).DELETE, '', [], new Date().toISOString()));
        return this.set(storeData);
    }
    /**
	 * A method to clear the cache
	 */ async clear() {
        return this.#localCache.clear();
    }
    /**
	 * A method that selectively deletes the stale cache entries
	 */ async cleanCache() {
        // We don't clean the backend cache
        if ((0, $1ybV0.ff)('odin.enable.backend.cache.ec.client')) return Promise.resolve(true);
        return this.getWithoutClean(null).then((data)=>{
            const issuesToKeep = [];
            if (data && Object.keys(data).length !== 0 && Object.getPrototypeOf(data) === Object.prototype) Object.keys(data).forEach((issueId)=>{
                const issueMutationObj = data[issueId];
                if ($ed861ad8bfcfb81a$export$2e2bcd8739ae039.isIssueMutationStale(issueMutationObj)) issuesToKeep.push(issueMutationObj);
            });
            return this.clear().then(()=>this.set(issuesToKeep));
        });
    }
    /**
	 * A method to check if an issue id is present in the cache
	 */ isPresent(issueId) {
        return this.get(issueId).then((data)=>!!data && !!Object.values(data)[0]);
    }
    /**
	 * A method to check if any mutation is present in the cache
	 */ isEmpty() {
        return this.get(null).then((data)=>Object.keys(data).length === 0);
    }
    /**
	 * A method to find the size of the local storage for any given key
	 */ static getLocalStorageSizeForGivenKey(key) {
        const value = localStorage.getItem(key);
        if (value != null) {
            const keySize = value.length;
            return keySize;
        }
        return 0;
    }
    /**
	 * A method to find the size of the local storage for any given key
	 * It returns size of all the keys when provided with no key
	 */ static getLocalStorageSize(key) {
        if (key != null) return $ed861ad8bfcfb81a$export$2e2bcd8739ae039.getLocalStorageSizeForGivenKey(key);
        let totalSize = 0;
        Object.keys(localStorage).forEach((keys)=>{
            totalSize += $ed861ad8bfcfb81a$export$2e2bcd8739ae039.getLocalStorageSizeForGivenKey(keys);
        });
        return totalSize;
    }
}

});
parcelRegister("4qvSX", function(module, exports) {

$parcel$export(module.exports, "mergeData", () => $1b463beed4d472c8$export$696bf4df45a0ddde);
$parcel$export(module.exports, "mergeResponseData", () => $1b463beed4d472c8$export$71923bad28063cb1);
$parcel$export(module.exports, "createAnalyticsMetadata", () => $1b463beed4d472c8$export$eeaad9fa1f02ef4a);

var $6rW04 = parcelRequire("6rW04");
function $1b463beed4d472c8$export$696bf4df45a0ddde(oldData, newData) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    Object.keys(oldData).forEach((issueId)=>{
        result[issueId] = oldData[issueId];
    });
    Object.keys(newData).forEach((issueId)=>{
        result[issueId] = newData[issueId];
    });
    return result;
}
function $1b463beed4d472c8$export$71923bad28063cb1(searchData, matchData) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const mergedData = [];
    const issueData = new Map();
    if (matchData.length) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    matchData.forEach((element)=>{
        issueData.set(element.id, element);
    });
    if (searchData.length) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    searchData.forEach((element)=>{
        // TODO: if issueVersion in Match is less than Search, we should not be overwriting that issueID.
        if (issueData.has(element.id)) {
            mergedData.push(issueData.get(element.id));
            issueData.delete(element.id);
        } else mergedData.push(element);
    });
    if (issueData.size) issueData.forEach((value)=>{
        mergedData.push(value);
    });
    return mergedData;
}
function $1b463beed4d472c8$export$eeaad9fa1f02ef4a(customKeys) {
    return {
        shard: (0, $6rW04.default)('ajs-shard') || '',
        userId: (0, $6rW04.default)('ajs-atlassian-account-id') || '',
        projectId: (0, $6rW04.default)('ajs-project-key') || '',
        ...customKeys
    };
}

});




parcelRegister("6JJvA", function(module, exports) {

$parcel$export(module.exports, "useInteractedFields", () => $105084084820b6a4$export$d5ae3b2773429294);

var $eUqFw = parcelRequire("eUqFw");

var $dNWQB = parcelRequire("dNWQB");
var $2gOs4 = parcelRequire("2gOs4");

var $fswni = parcelRequire("fswni");
const $105084084820b6a4$export$d5ae3b2773429294 = ()=>{
    const [interactedFields, { setInteractedWithField: setInteractedWithField }] = (0, $fswni.useFormContextInteractedFields)();
    const { subscribe: subscribe } = (0, $2gOs4.useGICLifeCycleEvents)();
    (0, $eUqFw.useEffect)(()=>subscribe((0, $dNWQB.GIC_LIFECYCLE_EVENTS).CREATE_FORM_FIELD_VALUE_CHANGE, ({ fieldId: fieldId })=>{
            setInteractedWithField(fieldId);
        }), [
        setInteractedWithField,
        subscribe
    ]);
    return {
        interactedFields: interactedFields
    };
};

});

parcelRegister("6Rz1S", function(module, exports) {

$parcel$export(module.exports, "useInvitePrompt", () => $e42300ea47fa1aae$export$2d68d3093301b7c3);

var $eUqFw = parcelRequire("eUqFw");

var $gqldc = parcelRequire("gqldc");

var $6Dw6K = parcelRequire("6Dw6K");
var $3AxvH = parcelRequire("3AxvH");
var $9OlhM = parcelRequire("9OlhM");

var $dWLk9 = parcelRequire("dWLk9");
var $gd0Sp = parcelRequire("gd0Sp");
const $e42300ea47fa1aae$export$2d68d3093301b7c3 = (projectKey)=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const { cloudName: cloudName } = (0, $gd0Sp.useTenantContext)();
    const triggerInviteExperiment = (0, $9OlhM.useInvitePromptExperimentV2)(projectKey);
    const { store: store } = (0, $eUqFw.useContext)((0, $gqldc.SmartCardContext)) || {};
    return (0, $eUqFw.useCallback)(async (description)=>{
        if (description && store && projectKey) {
            const links = (0, $6Dw6K.getAllProductLinks)(description, store, cloudId, cloudName);
            for (const [link, data] of Object.entries(links)){
                // https://eslint.org/docs/latest/rules/no-await-in-loop#when-not-to-use-it
                /* eslint-disable no-await-in-loop */ if (await triggerInviteExperiment(link, data, (0, $3AxvH.SOURCE).CREATE_ISSUE)) return;
            }
        }
    }, [
        cloudId,
        cloudName,
        projectKey,
        store,
        triggerInviteExperiment
    ]);
};

});
parcelRegister("6Dw6K", function(module, exports) {

$parcel$export(module.exports, "isConfluenceLink", () => $37a6fcf55dd47405$export$313baaa1c3261c49);
$parcel$export(module.exports, "getAllLinks", () => $37a6fcf55dd47405$export$776644da31ab517e);
$parcel$export(module.exports, "getAllProductLinks", () => $37a6fcf55dd47405$export$577f918d7821fd77);
$parcel$export(module.exports, "generateId", () => $37a6fcf55dd47405$export$567fc7097e064344);
$parcel$export(module.exports, "clampString", () => $37a6fcf55dd47405$export$96ce25bdd1856c70);
$parcel$export(module.exports, "getProductDisplayName", () => $37a6fcf55dd47405$export$44fea6589b7ddc92);
$parcel$export(module.exports, "getSiteAri", () => $37a6fcf55dd47405$export$792aeacb7990bc6);
$parcel$export(module.exports, "getCoreInviteSubProduct", () => $37a6fcf55dd47405$export$dcec5226018a2c73);
$parcel$export(module.exports, "useCurrentProduct", () => $37a6fcf55dd47405$export$495654df2a5da4a0);

var $hYZXM = parcelRequire("hYZXM");

var $2futN = parcelRequire("2futN");

var $huI7r = parcelRequire("huI7r");

const $37a6fcf55dd47405$export$69caceff42c0da80 = {
    [(0, $2edfd53057852e41$export$c811f21c9ad05dc2)]: 'Confluence',
    [(0, $2edfd53057852e41$export$db515c8cec1e6f79)]: 'Jira',
    [(0, $2edfd53057852e41$export$202f50ee62667e32)]: 'Jira Product Discovery',
    [(0, $2edfd53057852e41$export$c8c1c8c3f8ddba61)]: 'Jira Service Management',
    [(0, $2edfd53057852e41$export$1346c9aa3cbb477d)]: 'Jira'
};
const $37a6fcf55dd47405$var$getProductFromSubproduct = (subproduct)=>{
    switch(subproduct){
        case 'software':
        case 'jira_software':
            return 0, $2edfd53057852e41$export$1346c9aa3cbb477d;
        case 'servicedesk':
        case 'jira_service_management':
            return 0, $2edfd53057852e41$export$c8c1c8c3f8ddba61;
        case 'core':
        case 'jira_work_management':
            return 0, $2edfd53057852e41$export$db515c8cec1e6f79;
        case 'polaris':
        case 'jira_product_discovery':
            return 0, $2edfd53057852e41$export$202f50ee62667e32;
        default:
            return null;
    }
};
const $37a6fcf55dd47405$export$313baaa1c3261c49 = (url, cloudName)=>{
    if (!url || !cloudName) return false;
    const regex = new RegExp(`^https?://${cloudName}.atlassian.net/wiki`);
    return regex.test(url);
};
const $37a6fcf55dd47405$export$776644da31ab517e = (doc)=>{
    const links = new Set();
    const handleLink = (link)=>{
        link && links.add(link);
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleSmartLink = (node)=>handleLink(node.attrs?.url);
    (0, $hYZXM.traverse)(doc, {
        text: (node)=>{
            if ((node.marks || []).some((mark)=>mark.type === 'link')) handleLink(node.text);
        },
        inlineCard: handleSmartLink,
        blockCard: handleSmartLink,
        embedCard: handleSmartLink
    });
    return links;
};
const $37a6fcf55dd47405$var$getSmartLinkData = (details)=>{
    if (!details) return;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { name: name } = details.data;
    const { tenantId: tenantId, subproduct: subproduct } = details.meta;
    let { product: product } = details.meta;
    if (tenantId) {
        product = product === 'jira' ? $37a6fcf55dd47405$var$getProductFromSubproduct(subproduct) : product;
        if (!Object.keys($37a6fcf55dd47405$export$69caceff42c0da80).includes(product)) return;
        return {
            name: name,
            tenantId: tenantId,
            product: product
        };
    }
};
const $37a6fcf55dd47405$export$577f918d7821fd77 = (doc, store, cloudId, cloudName)=>{
    const links = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleSmartLink = (node)=>{
        // Check URL is on the ADF node
        const { url: url } = node?.attrs;
        if (!url) return;
        // Check URL is in the Smart Links Store
        const details = store.getState()[url]?.details;
        const linkdata = $37a6fcf55dd47405$var$getSmartLinkData(details);
        if (linkdata) links[url] = linkdata;
    };
    const handleRawConfluenceLink = (url)=>{
        if ($37a6fcf55dd47405$export$313baaa1c3261c49(url, cloudName)) links[url] = {
            tenantId: cloudId,
            product: (0, $2edfd53057852e41$export$c811f21c9ad05dc2)
        };
    };
    (0, $hYZXM.traverse)(doc, {
        text: (node)=>{
            if ((node.marks || []).some((mark)=>mark.type === 'link')) handleRawConfluenceLink(node.text);
        },
        inlineCard: handleSmartLink,
        blockCard: handleSmartLink,
        embedCard: handleSmartLink
    });
    return links;
};
let $37a6fcf55dd47405$var$id = 0;
const $37a6fcf55dd47405$export$567fc7097e064344 = ()=>{
    $37a6fcf55dd47405$var$id += 1;
    return String($37a6fcf55dd47405$var$id);
};
const $37a6fcf55dd47405$export$96ce25bdd1856c70 = (string, maxLength)=>{
    if (string.length > maxLength) return string.slice(0, maxLength).concat('...');
    return string;
};
const $37a6fcf55dd47405$export$44fea6589b7ddc92 = (product)=>$37a6fcf55dd47405$export$69caceff42c0da80[product];
const $37a6fcf55dd47405$export$792aeacb7990bc6 = (tenantId, product)=>(0, $huI7r.createAri)({
        resourceOwner: product,
        resourceType: 'site',
        resourceId: tenantId
    }).toString();
const $37a6fcf55dd47405$export$dcec5226018a2c73 = (product)=>{
    switch(product){
        case 0, $2edfd53057852e41$export$db515c8cec1e6f79:
        case 0, $2edfd53057852e41$export$202f50ee62667e32:
        case 0, $2edfd53057852e41$export$c8c1c8c3f8ddba61:
        case 0, $2edfd53057852e41$export$1346c9aa3cbb477d:
            return product.replace('jira-', '');
        default:
            return undefined;
    }
};
const $37a6fcf55dd47405$export$495654df2a5da4a0 = ()=>{
    const { data: data } = (0, $2futN.useProjectSidebarNavigation)();
    return $37a6fcf55dd47405$var$getProductFromSubproduct(data?.projectType) || (0, $2edfd53057852e41$export$1346c9aa3cbb477d);
};

});
const $2edfd53057852e41$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $2edfd53057852e41$export$e9c56aa3b027d98f = 'jira-customer-service';
const $2edfd53057852e41$export$1346c9aa3cbb477d = 'jira-software';
const $2edfd53057852e41$export$202f50ee62667e32 = 'jira-product-discovery';
const $2edfd53057852e41$export$db515c8cec1e6f79 = 'jira-core';
const $2edfd53057852e41$export$c811f21c9ad05dc2 = 'confluence';
const $2edfd53057852e41$export$961148c98d198270 = 'opsgenie';


parcelRegister("3AxvH", function(module, exports) {

$parcel$export(module.exports, "SOURCE", () => $45a4e6eebfb087c9$export$83c8d7110915321e);
$parcel$export(module.exports, "isInviteOnLinkInsertV3Enabled", () => $45a4e6eebfb087c9$export$bbac70b4535f5e90);

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");
const $45a4e6eebfb087c9$export$4212fcd2a914820a = 'invite_prompt_on_link_insert';
const $45a4e6eebfb087c9$export$6da7477ef7936f33 = 'invite_prompt_on_link_insert_v2';
const $45a4e6eebfb087c9$export$77fdb497fdef89d2 = 'invite_prompt_on_link_insert_v3';
const $45a4e6eebfb087c9$export$83c8d7110915321e = {
    ISSUE_VIEW: 'issue-view',
    CREATE_ISSUE: 'create-issue',
    CREATE_LINK: 'create-link'
};
const $45a4e6eebfb087c9$export$bbac70b4535f5e90 = (shouldFireExposure = false)=>{
    if (!(0, $1ybV0.ff)('statsig-guard-invite-prompt-on-link-insert-v-3', false)) return false;
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expConfig, fireExposure] = (0, $79xbN.UNSAFE_noExposureExp)('invite_prompt_on_link_insert_v3');
    const cohort = expConfig.get('cohort', 'not-enrolled');
    if (shouldFireExposure) fireExposure();
    return cohort === 'variation';
};

});

parcelRegister("9OlhM", function(module, exports) {

$parcel$export(module.exports, "useInvitePromptExperimentV1", () => $f6f6665809f41402$export$62cced24b892983a);
$parcel$export(module.exports, "useInvitePromptExperimentV2", () => $f6f6665809f41402$export$8551517136fa22af);
$parcel$export(module.exports, "useInviteOnCreateLink", () => $f6f6665809f41402$export$90eafb1d75365ab4);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $79xbN = parcelRequire("79xbN");

var $1ybV0 = parcelRequire("1ybV0");


var $dWLk9 = parcelRequire("dWLk9");
var $gd0Sp = parcelRequire("gd0Sp");

var $eeXze = parcelRequire("eeXze");

var $3sudU = parcelRequire("3sudU");

var $3AxvH = parcelRequire("3AxvH");

var $NHjLT = parcelRequire("NHjLT");

var $jaOn1 = parcelRequire("jaOn1");

var $lo9pc = parcelRequire("lo9pc");

var $4tmxg = parcelRequire("4tmxg");

var $hc9fz = parcelRequire("hc9fz");

var $6Dw6K = parcelRequire("6Dw6K");

var $codfX = parcelRequire("codfX");

var $iAekE = parcelRequire("iAekE");

var $h7mRL = parcelRequire("h7mRL");

var $94ERq = parcelRequire("94ERq");
const $f6f6665809f41402$export$62cced24b892983a = (createIssueProjectKey)=>{
    const canInvite = (0, $4tmxg.useCanInvite)();
    const getInvitees = (0, $NHjLT.useInvitees)(createIssueProjectKey);
    const showInvitePromptFlag = (0, $h7mRL.useInvitePromptFlag)();
    const showSuccessFlag = (0, $94ERq.useInviteSuccessFlag)();
    const showErrorFlag = (0, $iAekE.useInviteErrorFlag)();
    const inviteUsers = (0, $lo9pc.useInviteUsers)();
    const { getOptOutStatus: getOptOutStatus, setOptOutStatus: setOptOutStatus, incrementViewCount: incrementViewCount, shouldShowOptOutOption: shouldShowOptOutOption } = (0, $hc9fz.useOptOut)();
    const fireFeatureExposed = (0, $3sudU.useFeatureExposedV1)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const openInviteModal = (0, $eeXze.default)();
    return (0, $eUqFw.useCallback)(async (continueUrl, data, source = (0, $3AxvH.SOURCE).ISSUE_VIEW)=>{
        try {
            (0, $codfX.invitePromptOnLinkInsertExperience).start();
            const { tenantId: tenantId, product: product, name: name } = data;
            const attributes = {
                source: source,
                product: product,
                isSameSite: tenantId === cloudId
            };
            const hasOptedOut = await getOptOutStatus();
            if (hasOptedOut) {
                fireFeatureExposed((0, $3sudU.IneligibilityReasons).OPTED_OUT, attributes);
                return;
            }
            const canInviteToProduct = await canInvite(tenantId, product);
            if (!canInviteToProduct) {
                fireFeatureExposed((0, $3sudU.IneligibilityReasons).MISSING_INVITE_CAPABILITY, attributes);
                return;
            }
            // V3 only works with V1 of AIOLI
            const enableThirtyInvitees = (0, $3AxvH.isInviteOnLinkInsertV3Enabled)() && (0, $1ybV0.ff)('aioli-v3-allow-30-users-from-core-invites', false);
            const inviteesLimit = enableThirtyInvitees ? 30 : 10;
            const users = await getInvitees(tenantId, product, inviteesLimit);
            if (users.length === 0) {
                fireFeatureExposed((0, $3sudU.IneligibilityReasons).NO_ELIGIBLE_INVITEES, attributes);
                return;
            }
            const targetPageLabel = name || await (0, $jaOn1.getPageTitle)(continueUrl);
            fireFeatureExposed((0, $3sudU.IneligibilityReasons).ELIGIBLE, attributes);
            if (!(0, $79xbN.expValEquals)('invite_prompt_on_link_insert', 'cohort', 'variation')) return;
            const shouldOpenCoreInvites = false;
            const onOpenCoreInvites = ()=>{
                if (shouldOpenCoreInvites) openInviteModal(continueUrl, data, users);
            };
            showInvitePromptFlag({
                targetPageLabel: targetPageLabel,
                product: product,
                users: users,
                allowOptOut: await shouldShowOptOutOption(),
                onSubmit: async (getRecaptchaToken)=>{
                    try {
                        const recaptchaToken = await getRecaptchaToken('v1_invitations_invite').catch(()=>undefined);
                        await inviteUsers({
                            continueUrl: continueUrl,
                            users: users,
                            tenantId: tenantId,
                            product: product
                        }, recaptchaToken);
                        showSuccessFlag({
                            users: users,
                            product: product
                        });
                    } catch  {
                        showErrorFlag();
                    }
                },
                onDismiss: incrementViewCount,
                onOptOut: setOptOutStatus,
                shouldOpenCoreInvites: shouldOpenCoreInvites,
                onOpenCoreInvites: onOpenCoreInvites
            });
            (0, $codfX.invitePromptOnLinkInsertExperience).success();
            return true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'useInvitePromptExperiment',
                    packageName: 'jiraInvitePromptOnLinkInsert'
                },
                error: error
            });
            (0, $codfX.invitePromptOnLinkInsertExperience).failure();
        }
    }, [
        canInvite,
        cloudId,
        fireFeatureExposed,
        getInvitees,
        getOptOutStatus,
        incrementViewCount,
        inviteUsers,
        openInviteModal,
        setOptOutStatus,
        shouldShowOptOutOption,
        showErrorFlag,
        showInvitePromptFlag,
        showSuccessFlag
    ]);
};
const $f6f6665809f41402$export$8551517136fa22af = (createIssueProjectKey)=>{
    const canInvite = (0, $4tmxg.useCanInvite)();
    const getInvitees = (0, $NHjLT.useInvitees)(createIssueProjectKey);
    const showInvitePromptFlag = (0, $h7mRL.useInvitePromptFlag)();
    const showSuccessFlag = (0, $94ERq.useInviteSuccessFlag)();
    const showErrorFlag = (0, $iAekE.useInviteErrorFlag)();
    const inviteUsers = (0, $lo9pc.useInviteUsers)();
    const { getOptOutStatus: getOptOutStatus, setOptOutStatus: setOptOutStatus, incrementViewCount: incrementViewCount, shouldShowOptOutOption: shouldShowOptOutOption } = (0, $hc9fz.useOptOut)();
    const fireFeatureExposed = (0, $3sudU.useFeatureExposedV2)();
    const cloudId = (0, $dWLk9.useCloudId)();
    const openInviteModal = (0, $eeXze.default)();
    return (0, $eUqFw.useCallback)(async (continueUrl, data, source = (0, $3AxvH.SOURCE).ISSUE_VIEW)=>{
        try {
            (0, $codfX.invitePromptOnLinkInsertExperience).start();
            const { tenantId: tenantId, product: product, name: name } = data;
            const attributes = {
                source: source,
                product: product,
                isSameSite: tenantId === cloudId
            };
            const hasOptedOut = await getOptOutStatus();
            if (hasOptedOut) {
                fireFeatureExposed((0, $3sudU.IneligibilityReasons).OPTED_OUT, attributes);
                return;
            }
            const canInviteToProduct = await canInvite(tenantId, product);
            if (!canInviteToProduct) {
                fireFeatureExposed((0, $3sudU.IneligibilityReasons).MISSING_INVITE_CAPABILITY, attributes);
                return;
            }
            const inviteesLimit = 10;
            const users = await getInvitees(tenantId, product, inviteesLimit);
            if (users.length === 0) {
                fireFeatureExposed((0, $3sudU.IneligibilityReasons).NO_ELIGIBLE_INVITEES, attributes);
                return;
            }
            const targetPageLabel = name || await (0, $jaOn1.getPageTitle)(continueUrl);
            fireFeatureExposed((0, $3sudU.IneligibilityReasons).ELIGIBLE, attributes);
            if (!(0, $79xbN.expValEquals)('invite_prompt_on_link_insert_v2', 'cohort', 'variation')) return;
            const shouldOpenCoreInvites = false;
            const onOpenCoreInvites = ()=>{
                if (shouldOpenCoreInvites) openInviteModal(continueUrl, data, users);
            };
            showInvitePromptFlag({
                targetPageLabel: targetPageLabel,
                product: product,
                users: users,
                allowOptOut: await shouldShowOptOutOption(),
                onSubmit: async (getRecaptchaToken)=>{
                    try {
                        const recaptchaToken = await getRecaptchaToken('v1_invitations_invite').catch(()=>undefined);
                        await inviteUsers({
                            continueUrl: continueUrl,
                            users: users,
                            tenantId: tenantId,
                            product: product
                        }, recaptchaToken);
                        showSuccessFlag({
                            users: users,
                            product: product
                        });
                    } catch  {
                        showErrorFlag();
                    }
                },
                onDismiss: incrementViewCount,
                onOptOut: setOptOutStatus,
                shouldOpenCoreInvites: shouldOpenCoreInvites,
                onOpenCoreInvites: onOpenCoreInvites
            });
            (0, $codfX.invitePromptOnLinkInsertExperience).success();
            return true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'useInvitePromptExperiment',
                    packageName: 'jiraInvitePromptOnLinkInsert'
                },
                error: error
            });
            (0, $codfX.invitePromptOnLinkInsertExperience).failure();
        }
    }, [
        canInvite,
        cloudId,
        fireFeatureExposed,
        getInvitees,
        getOptOutStatus,
        incrementViewCount,
        inviteUsers,
        openInviteModal,
        setOptOutStatus,
        shouldShowOptOutOption,
        showErrorFlag,
        showInvitePromptFlag,
        showSuccessFlag
    ]);
};
const $f6f6665809f41402$export$90eafb1d75365ab4 = (link)=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const cloudName = (0, $gd0Sp.useTenantContext)()?.cloudName;
    const triggerInviteExperiment = $f6f6665809f41402$export$8551517136fa22af();
    return (0, $eUqFw.useCallback)(()=>{
        if ((0, $6Dw6K.isConfluenceLink)(link, cloudName)) triggerInviteExperiment(link, {
            tenantId: cloudId,
            product: (0, $2edfd53057852e41$export$c811f21c9ad05dc2)
        }, (0, $3AxvH.SOURCE).CREATE_LINK);
    }, [
        cloudId,
        cloudName,
        link,
        triggerInviteExperiment
    ]);
};

});
parcelRegister("eeXze", function(module, exports) {

$parcel$export(module.exports, "default", () => $d035599d32cd3ff8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $k8Qyf = parcelRequire("k8Qyf");

var $3Y2Y8 = parcelRequire("3Y2Y8");

var $Gz4Lz = parcelRequire("Gz4Lz");

var $82rJa = parcelRequire("82rJa");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hiBi9 = parcelRequire("hiBi9");

var $bFzGY = parcelRequire("bFzGY");

var $6Dw6K = parcelRequire("6Dw6K");

var $hvkzj = parcelRequire("hvkzj");
const $d035599d32cd3ff8$var$useOpenInvitePeopleModal = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const addFlag = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7031 - Binding element 'appearance' implicitly has an 'any' type.
    ({ appearance: appearance, ...flagProps })=>{
        if (appearance === 'success' || appearance === 'normal') // @ts-expect-error Type error after Flag props have been fixed globally, to be fixed by owning team
        showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $Gz4Lz.default), {
                ...flagProps,
                ...serviceProps
            }));
        if (appearance === 'warning') // @ts-expect-error Type error after Flag props have been fixed globally, to be fixed by owning team
        showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $82rJa.default), {
                ...flagProps,
                ...serviceProps
            }));
        if (appearance === 'error') // @ts-expect-error Type error after Flag props have been fixed globally, to be fixed by owning team
        showFlag((serviceProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3Y2Y8.default), {
                ...flagProps,
                ...serviceProps
            }));
    }, [
        showFlag
    ]);
    const [, { openDrawer: openDrawer }] = (0, $hiBi9.useInvitePeopleDrawer)();
    return (0, $eUqFw.useCallback)((insertedLink, { name: name, product: product, tenantId: tenantId }, invitees)=>{
        openDrawer(createAnalyticsEvent ?? null, {
            inviteFlow: 'inviteLinkInsert',
            analyticsSource: 'inviteLinkInsert'
        }, undefined, {
            continueUrl: insertedLink,
            experimental_formTitleByline: name ? formatMessage((0, $hvkzj.messages).coreInvitesTitleByline, {
                title: name
            }) : undefined,
            experimental_userPickerByline: formatMessage((0, $hvkzj.messages).coreInvitesUserPickerByline, {
                productDisplayName: (0, $6Dw6K.getProductDisplayName)(product)
            }),
            experimentalFeatures: {
                invitePromptOnLinkV3: true,
                inviteThirdPartyTeams: 'variation'
            },
            initialInvitees: invitees,
            showFlag: addFlag,
            source: 'inviteLinkInsert',
            subProduct: (0, $6Dw6K.getCoreInviteSubProduct)(product),
            resourceAri: (0, $6Dw6K.getSiteAri)(tenantId, product),
            maxNumberOfInputs: (0, $1ybV0.ff)('aioli-v3-allow-30-users-from-core-invites', false) ? 30 : 10
        });
    }, [
        addFlag,
        createAnalyticsEvent,
        formatMessage,
        openDrawer
    ]);
};
var $d035599d32cd3ff8$export$2e2bcd8739ae039 = $d035599d32cd3ff8$var$useOpenInvitePeopleModal;

});
parcelRegister("hvkzj", function(module, exports) {

$parcel$export(module.exports, "messages", () => $957c099cdc439706$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $957c099cdc439706$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    coreInvitesTitleByline: {
        "id": "invite-prompt-on-link-insert.common.use-invite-people-modal.core-invites-title-byline",
        "defaultMessage": "to access {title}"
    },
    coreInvitesUserPickerByline: {
        "id": "invite-prompt-on-link-insert.common.use-invite-people-modal.core-invites-user-picker-byline",
        "defaultMessage": "These people don't have access to {productDisplayName}"
    }
});

});


parcelRegister("3sudU", function(module, exports) {

$parcel$export(module.exports, "IneligibilityReasons", () => $8f91be790f3ac023$export$e5ad17c39dfb6a42);
$parcel$export(module.exports, "useFeatureExposedV1", () => $8f91be790f3ac023$export$86dfe1f97ac4d001);
$parcel$export(module.exports, "useFeatureExposedV2", () => $8f91be790f3ac023$export$3a011ced5c2da647);

var $eUqFw = parcelRequire("eUqFw");

var $79xbN = parcelRequire("79xbN");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $8f91be790f3ac023$export$e5ad17c39dfb6a42 = {
    OPTED_OUT: 'opted-out',
    NO_ELIGIBLE_INVITEES: 'no-eligible-invitees',
    MISSING_INVITE_CAPABILITY: 'missing-invite-capability',
    ELIGIBLE: 'eligible'
};
const $8f91be790f3ac023$export$86dfe1f97ac4d001 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (0, $eUqFw.useCallback)((ineligibilityReason, attributes)=>{
        const isIneligible = ineligibilityReason !== $8f91be790f3ac023$export$e5ad17c39dfb6a42.ELIGIBLE;
        const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('invite_prompt_on_link_insert');
        const cohort = isIneligible ? 'not-enrolled' : expConfig.get('cohort', 'not-enrolled');
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', {
            flagKey: 'invite_prompt_on_link_insert',
            cohort: cohort,
            ineligibilityReason: ineligibilityReason,
            ...attributes
        });
    }, [
        createAnalyticsEvent
    ]);
};
const $8f91be790f3ac023$export$3a011ced5c2da647 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (0, $eUqFw.useCallback)((ineligibilityReason, attributes)=>{
        const isIneligible = ineligibilityReason !== $8f91be790f3ac023$export$e5ad17c39dfb6a42.ELIGIBLE;
        const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('invite_prompt_on_link_insert_v2');
        const cohort = isIneligible ? 'not-enrolled' : expConfig.get('cohort', 'not-enrolled');
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'feature exposed', {
            flagKey: 'invite_prompt_on_link_insert_v2',
            cohort: cohort,
            ineligibilityReason: ineligibilityReason,
            ...attributes
        });
    }, [
        createAnalyticsEvent
    ]);
};

});

parcelRegister("NHjLT", function(module, exports) {

$parcel$export(module.exports, "useInvitees", () => $1514dc8ffad58a49$export$e2a3b21407d97a53);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $hJ992 = parcelRequire("hJ992");

var $guDlK = parcelRequire("guDlK");

var $dWLk9 = parcelRequire("dWLk9");

var $6Dw6K = parcelRequire("6Dw6K");

var $3AxvH = parcelRequire("3AxvH");

var $4hvuU = parcelRequire("4hvuU");

var $kut51 = parcelRequire("kut51");
const $1514dc8ffad58a49$export$e2a3b21407d97a53 = (createIssueProjectKey)=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const currentProjectKey = (0, $guDlK.useProjectKey)(issueKey);
    const projectKey = createIssueProjectKey || currentProjectKey;
    const currentProduct = (0, $6Dw6K.useCurrentProduct)();
    const cloudId = (0, $dWLk9.useCloudId)();
    return (0, $eUqFw.useCallback)((tenantId, destinationProduct, inviteesLimit = 10)=>$1514dc8ffad58a49$export$31f1797930c2d46c(tenantId, destinationProduct, currentProduct, cloudId, projectKey, inviteesLimit), [
        cloudId,
        currentProduct,
        projectKey
    ]);
};
const $1514dc8ffad58a49$export$31f1797930c2d46c = async (tenantId, destinationProduct, currentProduct, cloudId, projectKey, inviteesLimit = 10)=>{
    const isInvitingToCurrentProduct = tenantId === cloudId && destinationProduct === currentProduct;
    if (isInvitingToCurrentProduct) return [];
    const projectAssignees = await (0, $4hvuU.getProjectAssignees)(projectKey);
    if (projectAssignees.length === 0) return [];
    const accountIds = projectAssignees.map(({ id: id })=>id);
    const [usersWithoutAccessToCurrentProduct, usersWithoutAccessToDestinationProduct] = await Promise.all([
        (0, $kut51.getUsersWithoutProductAccess)(cloudId, currentProduct, accountIds),
        (0, $kut51.getUsersWithoutProductAccess)(tenantId, destinationProduct, accountIds)
    ]);
    const potentialInvitees = projectAssignees.filter(({ id: id })=>!usersWithoutAccessToCurrentProduct.includes(id)).filter(({ id: id })=>usersWithoutAccessToDestinationProduct.includes(id));
    const invitees = !(0, $3AxvH.isInviteOnLinkInsertV3Enabled)() && (0, $1ybV0.ff)('invite-aaid-within-org') ? potentialInvitees : potentialInvitees.filter(({ email: email })=>!!email);
    return invitees.slice(0, inviteesLimit);
};

});
parcelRegister("4hvuU", function(module, exports) {

$parcel$export(module.exports, "getProjectAssignees", () => $28bc119511f71ec1$export$b49ddf91eddfcea9);

var $2OdyW = parcelRequire("2OdyW");
const $28bc119511f71ec1$var$getAssigneesUrl = (projectKey)=>`/rest/api/3/user/search/query?query=is assignee of ${projectKey}&maxResults=50`;
const $28bc119511f71ec1$export$b49ddf91eddfcea9 = async (projectKey)=>{
    const users = await (0, $2OdyW.default)($28bc119511f71ec1$var$getAssigneesUrl(projectKey));
    return users.values.filter(({ active: active })=>active).map(({ accountId: accountId, emailAddress: emailAddress, displayName: displayName, avatarUrls: avatarUrls })=>({
            id: accountId,
            email: emailAddress,
            name: displayName || '',
            avatar: avatarUrls['48x48'] || avatarUrls['32x32'] || avatarUrls['24x24'] || Object.values(avatarUrls).pop() || ''
        }));
};

});

parcelRegister("kut51", function(module, exports) {

$parcel$export(module.exports, "getUsersWithoutProductAccess", () => $d749ed04d16223f1$export$7121af075bd652a4);

var $2OdyW = parcelRequire("2OdyW");
const $d749ed04d16223f1$var$getInviteesUrl = '/gateway/api/growth/invite-on-link-insert/get-invitees';
const $d749ed04d16223f1$export$7121af075bd652a4 = (cloudId, product, accountIds)=>(0, $2OdyW.default)($d749ed04d16223f1$var$getInviteesUrl, {
        method: 'POST',
        body: JSON.stringify({
            cloudId: cloudId,
            product: product,
            accountIds: accountIds
        })
    });

});


parcelRegister("jaOn1", function(module, exports) {

$parcel$export(module.exports, "getPageTitle", () => $9adca1c2f8986df3$export$23286240952da4c9);

var $2OdyW = parcelRequire("2OdyW");
const $9adca1c2f8986df3$var$resolverUrl = '/gateway/api/object-resolver/resolve';
const $9adca1c2f8986df3$export$23286240952da4c9 = async (resourceUrl)=>{
    try {
        const response = await (0, $2OdyW.default)($9adca1c2f8986df3$var$resolverUrl, {
            method: 'POST',
            body: JSON.stringify({
                resourceUrl: resourceUrl
            })
        });
        return response.data?.name;
    } catch  {
        return undefined;
    }
};

});

parcelRegister("lo9pc", function(module, exports) {

$parcel$export(module.exports, "useInviteUsers", () => $8ef25a6f6b1222c1$export$6162654a9c7a7b9a);

var $eUqFw = parcelRequire("eUqFw");

var $jkH4Q = parcelRequire("jkH4Q");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6Dw6K = parcelRequire("6Dw6K");

var $4S2A8 = parcelRequire("4S2A8");

var $128HT = parcelRequire("128HT");
const $8ef25a6f6b1222c1$var$RECAPTCHA_VALIDATION_ERROR = 'ValidationError';
const $8ef25a6f6b1222c1$export$6162654a9c7a7b9a = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (0, $eUqFw.useCallback)(async ({ users: users, continueUrl: continueUrl, tenantId: tenantId, product: product }, recaptchaToken)=>{
        try {
            const origin = new (0, $jkH4Q.default)({
                product: (0, $128HT.getOriginProduct)(product)
            });
            const continueUrlWithOrigin = origin.addToUrl(continueUrl);
            const originAttributes = origin.toAnalyticsAttributes({
                hasGeneratedId: true
            });
            const isInviteWithinOrg = (0, $1ybV0.ff)('invite-aaid-within-org');
            const invite = isInviteWithinOrg ? (0, $4S2A8.inviteWithinOrg) : (0, $4S2A8.inviteUsers);
            const inviteApiResponse = await invite({
                users: users,
                continueUrl: continueUrlWithOrigin,
                recaptchaToken: recaptchaToken,
                tenantId: tenantId,
                product: product
            });
            const response = (0, $128HT.handleInviteUsersSuccessResponse)(inviteApiResponse);
            [
                ...response.invited,
                ...response.accessRequested
            ].forEach((invited)=>{
                const resourceAri = (0, $6Dw6K.getSiteAri)(tenantId, product);
                const result = invited.results[resourceAri];
                const userId = invited.id;
                const analyticsAttributes = {
                    ...originAttributes,
                    userId: userId,
                    products: [
                        product
                    ],
                    inviteResult: [
                        {
                            resourceAri: resourceAri,
                            status: result
                        }
                    ],
                    integration: 'invitePromptOnLink',
                    isInviteWithinOrg: isInviteWithinOrg
                };
                if (result === 'INVITED') (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'user invited', userId, analyticsAttributes);
                else if (result === 'INVITED_PENDING_APPROVAL') (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'productAccess requested', userId, analyticsAttributes);
            });
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'promptOnLinkInvite succeeded', {
                invited: response.invited.length,
                requested: response.accessRequested.length,
                errored: response.error.length
            });
            return response;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: error.statusCode === 400 && error.name === $8ef25a6f6b1222c1$var$RECAPTCHA_VALIDATION_ERROR ? 'useInviteUsers-recaptcha' : 'useInviteUsers',
                    packageName: 'jiraInvitePromptOnLinkInsert'
                },
                error: error
            });
            throw error;
        }
    }, [
        createAnalyticsEvent
    ]);
};

});
parcelRegister("4S2A8", function(module, exports) {

$parcel$export(module.exports, "inviteUsers", () => $4433eb7ef708b0d5$export$da08225bbae46b1);
$parcel$export(module.exports, "inviteWithinOrg", () => $4433eb7ef708b0d5$export$a106ce8e40b3d224);

var $lRmyA = parcelRequire("lRmyA");

var $6Dw6K = parcelRequire("6Dw6K");

const $4433eb7ef708b0d5$export$da08225bbae46b1 = async ({ users: users, continueUrl: continueUrl, recaptchaToken: recaptchaToken, tenantId: tenantId, product: product })=>{
    const resources = [
        (0, $6Dw6K.getSiteAri)(tenantId, product)
    ];
    const response = await (0, $lRmyA.performPostRequest)((0, $5e73a293ce667688$export$ff111916f5a23b5a), {
        headers: {
            'Content-Type': 'application/json',
            ...recaptchaToken ? {
                'G-Recaptcha-Token': recaptchaToken
            } : {}
        },
        body: JSON.stringify({
            continueUrl: continueUrl,
            resources: resources,
            users: users.map(({ email: email })=>({
                    email: email
                }))
        })
    });
    return response;
};
const $4433eb7ef708b0d5$export$a106ce8e40b3d224 = async ({ users: users, continueUrl: continueUrl, tenantId: tenantId, product: product })=>{
    const resources = [
        (0, $6Dw6K.getSiteAri)(tenantId, product)
    ];
    const response = await (0, $lRmyA.performPostRequest)((0, $5e73a293ce667688$export$f87741d20d2a10fb), {
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            continueUrl: continueUrl,
            resources: resources,
            userIds: users.map(({ id: id })=>id),
            cloudId: tenantId,
            experience: 'invite-on-link-insert'
        })
    });
    return response;
};

});
const $5e73a293ce667688$export$ff111916f5a23b5a = '/gateway/api/invitations/invite';
const $5e73a293ce667688$export$f87741d20d2a10fb = '/gateway/api/growth/groot-invite-within-org/invite';


parcelRegister("128HT", function(module, exports) {

$parcel$export(module.exports, "getRecaptchaSiteKey", () => $2e22da079b3b9bd1$export$f6c02f8ff560b96f);
$parcel$export(module.exports, "handleInviteUsersSuccessResponse", () => $2e22da079b3b9bd1$export$bf7ed6f1f1b884e);
$parcel$export(module.exports, "getOriginProduct", () => $2e22da079b3b9bd1$export$e4853a500db4c6bf);


const $2e22da079b3b9bd1$export$f6c02f8ff560b96f = (environment)=>{
    switch(environment){
        case 'prod':
            return 0, $812813ba71586c24$export$2c2f58a9d84da733;
        case 'staging':
            return 0, $812813ba71586c24$export$cd719d3567d9b31d;
        default:
            return 0, $812813ba71586c24$export$34c3413ecdf1b634;
    }
};
const $2e22da079b3b9bd1$export$bf7ed6f1f1b884e = (response)=>response.reduce((accumulator, userResponse)=>{
        const user = {
            id: userResponse.id,
            email: userResponse.email
        };
        Object.keys(userResponse.results).forEach((resource)=>{
            switch(userResponse.results[resource]){
                case 'INVITED':
                case 'USER_EXISTS':
                    accumulator.invited.push({
                        ...user,
                        results: userResponse.results
                    });
                    break;
                case 'INVITED_PENDING_APPROVAL':
                case 'PENDING_INVITE_EXISTS':
                    accumulator.accessRequested.push({
                        ...user,
                        results: userResponse.results
                    });
                    break;
                case 'NOT_INVITED':
                case 'ERROR':
                    accumulator.error.push({
                        ...user,
                        error: userResponse.errorReasons[resource]
                    });
                    break;
                default:
                    throw new Error('Unexpected return type from invite user response');
            }
        });
        return accumulator;
    }, {
        invited: [],
        accessRequested: [],
        error: []
    });
const $2e22da079b3b9bd1$export$e4853a500db4c6bf = (product)=>{
    switch(product){
        case 0, $2edfd53057852e41$export$1346c9aa3cbb477d:
        case 0, $2edfd53057852e41$export$c8c1c8c3f8ddba61:
        case 0, $2edfd53057852e41$export$db515c8cec1e6f79:
        case 0, $2edfd53057852e41$export$202f50ee62667e32:
            return 'jira';
        default:
            return product;
    }
};

});
const $812813ba71586c24$export$2c2f58a9d84da733 = '6LfOcIYhAAAAADBS5OnBllme06dW9vyW4Zgowiru';
const $812813ba71586c24$export$cd719d3567d9b31d = '6LebaYYhAAAAAKFQt-KH6vVkTJQqwZddT-HJCIM3';
const $812813ba71586c24$export$34c3413ecdf1b634 = '6Le_DxYiAAAAABV8BsFSj3AmZf3OkP9Fh9lfbZOZ';



parcelRegister("4tmxg", function(module, exports) {

$parcel$export(module.exports, "useCanInvite", () => $2d41802e21ddeb06$export$4fa512abf5d2ba5e);

var $eUqFw = parcelRequire("eUqFw");

var $2OdyW = parcelRequire("2OdyW");

var $huI7r = parcelRequire("huI7r");
const $2d41802e21ddeb06$export$4fa512abf5d2ba5e = ()=>(0, $eUqFw.useCallback)((cloudId, product)=>$2d41802e21ddeb06$export$39ebdf2aa7e6d740(cloudId, product), []);
const $2d41802e21ddeb06$export$8a4a12ca67f0b223 = (cloudId)=>`/gateway/api/v3/invitations/capabilities?resource=ari:cloud:platform::site/${cloudId}`;
const $2d41802e21ddeb06$export$39ebdf2aa7e6d740 = async (cloudId, product)=>{
    const capabilities = await (0, $2OdyW.default)($2d41802e21ddeb06$export$8a4a12ca67f0b223(cloudId));
    const capability = capabilities.find((cap)=>{
        const ari = (0, $huI7r.getAriConfig)(cap.resourceARI);
        return ari.resourceOwner === product;
    });
    if (!capability) return false;
    return capability.directInvite?.mode === 'ANYONE' || capability.invitePendingApproval?.mode === 'ANYONE';
};

});

parcelRegister("hc9fz", function(module, exports) {

$parcel$export(module.exports, "useOptOut", () => $f0a3e6c42dfc021c$export$7f94797c6e99faf3);

var $eUqFw = parcelRequire("eUqFw");

var $guiFP = parcelRequire("guiFP");

var $dxcfv = parcelRequire("dxcfv");

var $hWZxL = parcelRequire("hWZxL");
const $f0a3e6c42dfc021c$var$INVITE_PROMPT_ON_LINK_INSERT_VIEW = 'invite-prompt-on-link-insert-view';
const $f0a3e6c42dfc021c$var$INVITE_PROMPT_ON_LINK_INSERT_OPT_OUT = 'invite-prompt-on-link-insert-opt-out';
const $f0a3e6c42dfc021c$var$MAX_VIEW_COUNT = 2;
const $f0a3e6c42dfc021c$var$shouldShowOptOutOption = async (accountId)=>{
    if (!accountId) return false;
    const viewCount = await $f0a3e6c42dfc021c$var$getViewCount(accountId);
    return viewCount >= $f0a3e6c42dfc021c$var$MAX_VIEW_COUNT;
};
const $f0a3e6c42dfc021c$var$incrementViewCount = async (accountId)=>{
    if (!accountId) return;
    const viewCount = await $f0a3e6c42dfc021c$var$getViewCount(accountId);
    if (viewCount < $f0a3e6c42dfc021c$var$MAX_VIEW_COUNT) try {
        await (0, $hWZxL.setUserProperty)({
            accountId: accountId,
            propertyKey: $f0a3e6c42dfc021c$var$INVITE_PROMPT_ON_LINK_INSERT_VIEW,
            propertyValue: viewCount + 1
        });
    // TODO: shall we fire an event here to record the user has viewed the flag?
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'incrementViewCount',
                packageName: 'jiraInvitePromptOnLinkInsert'
            },
            error: error
        });
    }
};
const $f0a3e6c42dfc021c$var$getViewCount = async (accountId)=>(await (0, $hWZxL.getUserProperty)({
        accountId: accountId,
        propertyKey: $f0a3e6c42dfc021c$var$INVITE_PROMPT_ON_LINK_INSERT_VIEW,
        defaultValue: 0
    })).value;
const $f0a3e6c42dfc021c$var$getOptOutInvitePrompt = async (accountId)=>{
    if (!accountId) return false;
    return (await (0, $hWZxL.getUserProperty)({
        accountId: accountId,
        propertyKey: $f0a3e6c42dfc021c$var$INVITE_PROMPT_ON_LINK_INSERT_OPT_OUT,
        defaultValue: false
    })).value;
};
const $f0a3e6c42dfc021c$var$setOptOutInvitePrompt = async (accountId)=>{
    if (!accountId) return;
    try {
        await (0, $hWZxL.setUserProperty)({
            accountId: accountId,
            propertyKey: $f0a3e6c42dfc021c$var$INVITE_PROMPT_ON_LINK_INSERT_OPT_OUT,
            propertyValue: true
        });
    // TODO: shall we fire an event here to record the user has opted out?
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'setOptOutInvitePrompt',
                packageName: 'jiraInvitePromptOnLinkInsert'
            },
            error: error
        });
    }
};
const $f0a3e6c42dfc021c$export$7f94797c6e99faf3 = ()=>{
    const accountId = (0, $dxcfv.useAccountId)();
    return (0, $eUqFw.useMemo)(()=>({
            shouldShowOptOutOption: ()=>$f0a3e6c42dfc021c$var$shouldShowOptOutOption(accountId),
            incrementViewCount: ()=>$f0a3e6c42dfc021c$var$incrementViewCount(accountId),
            getOptOutStatus: ()=>$f0a3e6c42dfc021c$var$getOptOutInvitePrompt(accountId),
            setOptOutStatus: ()=>$f0a3e6c42dfc021c$var$setOptOutInvitePrompt(accountId)
        }), [
        accountId
    ]);
};

});
parcelRegister("hWZxL", function(module, exports) {

$parcel$export(module.exports, "setUserProperty", () => $406ec895657cfded$export$ba821ce5e177c7ef);
$parcel$export(module.exports, "getUserProperty", () => $406ec895657cfded$export$b3126db2ef6e34ed);

var $lRmyA = parcelRequire("lRmyA");
const $406ec895657cfded$var$getUserUrl = (accountId, propertyKey)=>`/rest/api/3/user/properties/${propertyKey}?accountId=${accountId}`;
const $406ec895657cfded$export$ba821ce5e177c7ef = async ({ accountId: accountId, propertyKey: propertyKey, propertyValue: propertyValue })=>{
    const url = $406ec895657cfded$var$getUserUrl(accountId, propertyKey);
    try {
        await (0, $lRmyA.performPutRequest)(url, {
            body: JSON.stringify(propertyValue)
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw new Error(`Saving ${propertyKey} user property failed. Error: ${error}`);
    }
};
const $406ec895657cfded$export$b3126db2ef6e34ed = async ({ accountId: accountId, propertyKey: propertyKey, defaultValue: defaultValue })=>{
    const url = $406ec895657cfded$var$getUserUrl(accountId, propertyKey);
    try {
        const response = await (0, $lRmyA.performGetRequest)(url);
        return response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return {
            key: propertyKey,
            value: defaultValue
        };
    }
};

});


parcelRegister("codfX", function(module, exports) {

$parcel$export(module.exports, "invitePromptOnLinkInsertExperience", () => $93366d77c0732a4c$export$adb25c37e478fcbe);

var $12kyE = parcelRequire("12kyE");
var $kDfSL = parcelRequire("kDfSL");
const $93366d77c0732a4c$export$adb25c37e478fcbe = new (0, $kDfSL.UFOExperience)('invite-prompt-on-link-insert', {
    type: (0, $12kyE.ExperienceTypes).Experience,
    performanceType: (0, $12kyE.ExperiencePerformanceTypes).PageLoad
});

});

parcelRegister("iAekE", function(module, exports) {

$parcel$export(module.exports, "useInviteErrorFlag", () => $6c353f4fb7ab217f$export$e6d35b1c4e81af0e);

var $eUqFw = parcelRequire("eUqFw");

var $8vPhU = parcelRequire("8vPhU");
var $kQ0RL = parcelRequire("kQ0RL");
var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6Dw6K = parcelRequire("6Dw6K");

var $01Ijb = parcelRequire("01Ijb");
const $6c353f4fb7ab217f$export$e6d35b1c4e81af0e = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagService)();
    return (0, $eUqFw.useCallback)(()=>{
        const id = `error-${(0, $6Dw6K.generateId)()}`;
        const dismiss = ()=>dismissFlag((0, $8vPhU.dismissFlag)(id));
        showFlag({
            id: id,
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6c353f4fb7ab217f$export$92c0939d1a977673, {
                    ...props,
                    id: id,
                    onDismiss: dismiss
                })
        });
    }, [
        dismissFlag,
        showFlag
    ]);
};
const $6c353f4fb7ab217f$var$JIRA_SUPPORT_LINK = 'https://support.atlassian.com/contact/';
const $6c353f4fb7ab217f$export$92c0939d1a977673 = ({ onDismiss: onDismiss, ...props })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.ErrorFlag), {
        ...props,
        onDismissed: onDismiss,
        title: formatMessage((0, $01Ijb.messages).title),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $01Ijb.messages).description))),
        actions: [
            {
                content: formatMessage((0, $01Ijb.messages).action),
                href: $6c353f4fb7ab217f$var$JIRA_SUPPORT_LINK,
                target: '_blank'
            }
        ]
    });
};

});
parcelRegister("01Ijb", function(module, exports) {

$parcel$export(module.exports, "messages", () => $490567766fce628a$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $490567766fce628a$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        "id": "invite-prompt-on-link-insert.invite-error-flag.title",
        "defaultMessage": "Something went wrong"
    },
    description: {
        "id": "invite-prompt-on-link-insert.invite-error-flag.description",
        "defaultMessage": "Try inviting your teammates again. If the problem persists, contact support."
    },
    action: {
        "id": "invite-prompt-on-link-insert.invite-error-flag.action",
        "defaultMessage": "Contact support"
    }
});

});


parcelRegister("h7mRL", function(module, exports) {

$parcel$export(module.exports, "useInvitePromptFlag", () => $7dba77502abc6172$export$ce7c2ea6d33a7cf4);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");
var $7opLA = parcelRequire("7opLA");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $8vPhU = parcelRequire("8vPhU");
var $kQ0RL = parcelRequire("kQ0RL");
var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6Dw6K = parcelRequire("6Dw6K");

var $aa1dQ = parcelRequire("aa1dQ");

var $cBUBp = parcelRequire("cBUBp");

var $8EYjY = parcelRequire("8EYjY");
const $7dba77502abc6172$export$ce7c2ea6d33a7cf4 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    return (0, $eUqFw.useCallback)(({ targetPageLabel: targetPageLabel, product: product, users: users, allowOptOut: allowOptOut, onSubmit: onSubmit, onDismiss: onDismiss, onOptOut: onOptOut, shouldOpenCoreInvites: shouldOpenCoreInvites, onOpenCoreInvites: onOpenCoreInvites })=>{
        const id = `invite-${(0, $6Dw6K.generateId)()}`;
        const dismissTheFlag = ()=>dismissFlag((0, $8vPhU.dismissFlag)(id));
        const attributes = {
            invitees: users.length,
            renderedPageTitle: !!targetPageLabel,
            allowOptOut: allowOptOut
        };
        const submit = async (getRecaptchaToken)=>{
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'addPeopleButtonInviteOnLinkInsert', attributes);
            await onSubmit(getRecaptchaToken);
            dismissTheFlag();
        };
        const openCoreInvites = ()=>{
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'selectPeopleButtonInviteOnLinkInsert', attributes);
            onOpenCoreInvites();
            dismissTheFlag();
        };
        const optOut = ()=>{
            dismissTheFlag();
            onOptOut();
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'optOutButtonInviteOnLinkInsert', attributes);
        };
        const dismiss = ()=>{
            dismissTheFlag();
            onDismiss();
            (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'flag dismissed', 'inviteOnLinkInsert', attributes);
        };
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'flag shown', 'inviteOnLinkInsert', attributes);
        showFlag({
            id: id,
            isLowPriority: true,
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7dba77502abc6172$export$d6bef3efd7271258, {
                    ...props,
                    id: id,
                    users: users,
                    targetPageLabel: targetPageLabel,
                    onDismiss: dismiss,
                    onSubmit: submit,
                    onOptOut: allowOptOut ? optOut : undefined,
                    product: product,
                    shouldOpenCoreInvites: shouldOpenCoreInvites,
                    onOpenCoreInvites: openCoreInvites
                })
        });
    }, [
        createAnalyticsEvent,
        dismissFlag,
        showFlag
    ]);
};
const $7dba77502abc6172$export$d6bef3efd7271258 = ({ users: users, onSubmit: onSubmit, onDismiss: onDismiss, onOptOut: onOptOut, targetPageLabel: targetPageLabel, product: product, shouldOpenCoreInvites: shouldOpenCoreInvites, onOpenCoreInvites: onOpenCoreInvites, ...props })=>{
    const { isRecaptchaLoaded: isRecaptchaLoaded, getRecaptchaToken: getRecaptchaToken, recaptchaLoadErrorReason: recaptchaLoadErrorReason } = (0, $8EYjY.useRecaptcha)();
    const isInviteDisabled = !isRecaptchaLoaded && recaptchaLoadErrorReason === undefined;
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const productDisplayName = (0, $6Dw6K.getProductDisplayName)(product);
    const handleOnSubmit = (0, $eUqFw.useCallback)(async ()=>{
        setIsLoading(true);
        await onSubmit(getRecaptchaToken);
    }, [
        onSubmit,
        getRecaptchaToken
    ]);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const optOutEnabled = onOptOut !== undefined;
    const customFlagFooterProps = (0, $eUqFw.useMemo)(()=>({
            // Workaround to achieve primary button + avatars in the footer.
            //
            // How this works:
            // We pass a dummy `action` that gets displayed in the Flag's footer
            // by the custom `linkComponent`. The component displays our actual footer.
            // This way, we don't occupy the limited space inside `description`.
            //
            // Why not use `actions` normally?
            // Because our Avatar Group is not an action, and even our Submit button
            // should be bold & blue (appearance="primary") which is not supported
            // by the AK Flag.
            //
            // Why not put this in `description`?
            // Because that one has a max height equivalent to 5 lines of text,
            // and our footer is taller than 2, causing an unwanted scrollbar
            // to show.
            actions: [
                {
                    content: '',
                    // Replace with lodash/noop
                    // eslint-disable-next-line @typescript-eslint/no-empty-function
                    onClick: ()=>{}
                }
            ],
            linkComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, !shouldOpenCoreInvites && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8EYjY.RecaptchaTerms), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7dba77502abc6172$var$ButtonsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7dba77502abc6172$var$ButtonItem, {
                    optOutEnabled: optOutEnabled
                }, shouldOpenCoreInvites ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                    appearance: "primary",
                    spacing: "compact",
                    onClick: onOpenCoreInvites
                }, formatMessage((0, $cBUBp.messages).selectPeopleButton)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
                    appearance: "primary",
                    onClick: handleOnSubmit,
                    spacing: "compact",
                    isDisabled: isInviteDisabled,
                    isLoading: isLoading
                }, formatMessage((0, $cBUBp.messages).addPeopleButton, {
                    inviteeCount: users.length
                }))), optOutEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7dba77502abc6172$var$ButtonItem, {
                    optOutEnabled: optOutEnabled
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                    appearance: "subtle-link",
                    onClick: onOptOut,
                    spacing: "compact",
                    isDisabled: isLoading
                }, formatMessage((0, $cBUBp.messages).dismiss, {})))))
        }), [
        onOptOut,
        optOutEnabled,
        handleOnSubmit,
        users,
        formatMessage,
        isInviteDisabled,
        isLoading,
        shouldOpenCoreInvites,
        onOpenCoreInvites
    ]);
    const maxLength = 20;
    const clampedTargetPageLabel = (0, $6Dw6K.clampString)(targetPageLabel || '', maxLength);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.InfoFlag), {
        ...props,
        ...customFlagFooterProps,
        onDismissed: onDismiss,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
            xcss: $7dba77502abc6172$var$avatarsContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aa1dQ.FlagCompatibleAvatarGroup), {
            data: users.map((user)=>({
                    name: user.name,
                    src: user.avatar,
                    appearance: 'circle',
                    size: 'medium'
                })),
            boundariesElement: "scrollParent"
        })), formatMessage((0, $cBUBp.messages).titleGeneric, {
            inviteeCount: users.length,
            displayName: users[0].name,
            productDisplayName: productDisplayName
        })),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7dba77502abc6172$var$MainContentContainer, null, targetPageLabel ? formatMessage((0, $cBUBp.messages).descriptionWithPageTitleGeneric, {
            strong: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, chunks.join('')),
            inviteeCount: users.length,
            title: clampedTargetPageLabel,
            productDisplayName: productDisplayName
        }) : formatMessage((0, $cBUBp.messages).descriptionWithoutPageTitleGeneric, {
            inviteeCount: users.length,
            productDisplayName: productDisplayName
        }))
    });
};
const $7dba77502abc6172$var$avatarsContainerStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.negative.025',
    // Aligns avatars with the rest of the text
    marginTop: 'space.negative.025',
    marginBottom: 'space.050'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7dba77502abc6172$var$MainContentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0ccj1k _1yyj11wp _sudp1e54 _1reo15vq _18m915vq _18s8ze3t",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7dba77502abc6172$var$ButtonsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2hwxmgjw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7dba77502abc6172$var$ButtonItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { optOutEnabled: optOutEnabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.optOutEnabled ? "_p12f1lit" : "_p12fsb0t",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aa1dQ", function(module, exports) {

$parcel$export(module.exports, "FlagCompatibleAvatarGroup", () => $ad3c4cb8bc523c66$export$29beada2d5f93289);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4XQdE = parcelRequire("4XQdE");
const $ad3c4cb8bc523c66$export$29beada2d5f93289 = ({ data: data, ...props })=>{
    const { data: customData, overrides: customOverrides } = (0, $eUqFw.useMemo)(()=>$ad3c4cb8bc523c66$export$bc55c1ff86d63c4d({
            data: data
        }), [
        data
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4XQdE.default), {
        maxCount: 999,
        data: customData,
        overrides: customOverrides,
        boundariesElement: "scrollParent",
        tooltipPosition: "top",
        // Prevents the More popup. XXX: The popup has the wrong zIndex and displays under the flag
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onMoreClick: ()=>{},
        ...props
    });
};
const $ad3c4cb8bc523c66$var$MAX_AVATARS_FEATURED = 5;
const $ad3c4cb8bc523c66$var$MAX_OVERFLOW_USER_COUNT_DISPLAYED = 99;
const $ad3c4cb8bc523c66$var$OVERFLOW_USER_MARKER = '$$$overflow-user-marker';
const $ad3c4cb8bc523c66$export$bc55c1ff86d63c4d = ({ data: users })=>{
    const overflows = users.length > $ad3c4cb8bc523c66$var$MAX_AVATARS_FEATURED;
    const lastFeaturedUser = $ad3c4cb8bc523c66$var$MAX_AVATARS_FEATURED - 1;
    const featuredUsers = users.slice(0, lastFeaturedUser);
    const overflowUsers = users.slice(lastFeaturedUser);
    const overflowMarkerDummyUser = $ad3c4cb8bc523c66$export$1b8d8867a2d1ffbd(overflowUsers);
    const processedUsers = overflows ? [
        ...featuredUsers,
        overflowMarkerDummyUser
    ] : users;
    const overrides = {
        Avatar: {
            render: (AvatarComponent, avatarProps)=>{
                if (avatarProps.name === overflowMarkerDummyUser.name && avatarProps.key === overflowMarkerDummyUser.key) return $ad3c4cb8bc523c66$var$renderAvatarWithOverflowCount(AvatarComponent, avatarProps, overflowUsers.length);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AvatarComponent, avatarProps);
            }
        }
    };
    return {
        overrides: overrides,
        data: processedUsers
    };
};
const $ad3c4cb8bc523c66$export$1b8d8867a2d1ffbd = (overflowUsers)=>({
        name: overflowUsers.map((u)=>u.name).join(', '),
        key: $ad3c4cb8bc523c66$var$OVERFLOW_USER_MARKER
    });
const $ad3c4cb8bc523c66$var$renderAvatarWithOverflowCount = (AvatarComponent, avatarProps, overflowCount)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(AvatarComponent, {
        name: avatarProps.name,
        appearance: avatarProps.appearance,
        size: avatarProps.size,
        borderColor: avatarProps.borderColor,
        stackIndex: 0
    }, (avatarChildrenProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ad3c4cb8bc523c66$var$AvatarOverflowCountContainer, avatarChildrenProps, `+${Math.min(overflowCount, $ad3c4cb8bc523c66$var$MAX_OVERFLOW_USER_COUNT_DISPLAYED)}`));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ad3c4cb8bc523c66$var$AvatarOverflowCountContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkj6p2 _syaz1ktl _y3gn1s23 _k48p124r",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4XQdE", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b6346b768779c72$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $74BVL = parcelRequire("74BVL");

var $iJlfe = parcelRequire("iJlfe");


var $5Q9wj = parcelRequire("5Q9wj");

var $7PTrT = parcelRequire("7PTrT");

var $8BKky = parcelRequire("8BKky");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $8cU5f = parcelRequire("8cU5f");

var $hCcWD = parcelRequire("hCcWD");

var $3Czko = parcelRequire("3Czko");

var $6cUPN = parcelRequire("6cUPN");

var $h5NqH = parcelRequire("h5NqH");

var $5TioN = parcelRequire("5TioN");

var $33ZPs = parcelRequire("33ZPs");

var $bLnyK = parcelRequire("bLnyK");
const $3b6346b768779c72$var$MAX_COUNT = {
    grid: 11,
    stack: 5
};
function $3b6346b768779c72$var$getOverrides(overrides) {
    return {
        AvatarGroupItem: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $byn9U.jsx)(Component, {
                    ...props,
                    key: (0, $bLnyK.composeUniqueKey)(props.avatar, index)
                }),
            ...overrides && overrides.AvatarGroupItem
        },
        Avatar: {
            render: (Component, props, index)=>/*#__PURE__*/ (0, $byn9U.jsx)(Component, {
                    ...props,
                    key: (0, $bLnyK.composeUniqueKey)(props, index)
                }),
            ...overrides && overrides.Avatar
        }
    };
}
/**
 * __Avatar group__
 *
 * An avatar group displays a number of avatars grouped together in a stack or grid.
 *
 * - [Examples](https://atlassian.design/components/avatar-group/examples)
 * - [Code](https://atlassian.design/components/avatar-group/code)
 * - [Usage](https://atlassian.design/components/avatar-group/usage)
 */ const $3b6346b768779c72$var$AvatarGroup = ({ appearance: appearance = 'stack', avatar: avatar = (0, $iJlfe.default), borderColor: borderColor, boundariesElement: boundariesElement, data: data, isTooltipDisabled: isTooltipDisabled, maxCount: maxCount, onAvatarClick: onAvatarClick, onMoreClick: onMoreClick, overrides: overrides, showMoreButtonProps: showMoreButtonProps = {}, size: size = 'medium', testId: testId, label: label = 'avatar group', tooltipPosition: tooltipPosition = 'bottom', shouldPopupRenderToParent: shouldPopupRenderToParent = false })=>{
    const [isTriggeredUsingKeyboard, setTriggeredUsingKeyboard] = (0, $eUqFw.useState)(false);
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const onClose = (0, $eUqFw.useCallback)(()=>setIsOpen(false), []);
    const handleTriggerClicked = (0, $eUqFw.useCallback)((event)=>{
        const { clientX: clientX, clientY: clientY, type: type } = event;
        // Hitting enter/space is registered as a click with both clientX and clientY === 0
        if (type === 'keydown' || clientX === 0 || clientY === 0) setTriggeredUsingKeyboard(true);
        setIsOpen((isOpen)=>!isOpen);
    }, []);
    const { isFocused: isFocused, bindFocus: bindFocus } = (0, $7PTrT.default)();
    // When a trigger is focused, we want to open the popup
    // the user presses the DownArrow
    (0, $eUqFw.useEffect)(()=>{
        // Set initial value if popup is closed
        if (!isOpen) setTriggeredUsingKeyboard(false);
        // Only need to listen for keydown when focused
        if (!isFocused) return 0, $5Q9wj.default;
        // Being safe: we don't want to open the popup if it is already open
        // Note: This shouldn't happen as the trigger should not be able to get focus
        if (isOpen) return 0, $5Q9wj.default;
        (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: function openOnKeyDown(e) {
                if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe)) {
                    // prevent page scroll
                    e.preventDefault();
                    handleTriggerClicked(e);
                }
            }
        });
        const unbind = ()=>{
            (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: function openOnKeyDown(e) {
                    if (e.key === (0, $54717ce5fa2c74b1$export$a80636c6f41931fe)) {
                        // prevent page scroll
                        e.preventDefault();
                        handleTriggerClicked(e);
                    }
                }
            });
        };
        return unbind;
    }, [
        isFocused,
        isOpen,
        handleTriggerClicked
    ]);
    function renderMoreDropdown(max, total) {
        if (total <= max) return null;
        const renderMoreButton = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $5TioN.default), {
                buttonProps: showMoreButtonProps,
                borderColor: borderColor,
                count: total - max,
                size: size,
                testId: testId && `${testId}--overflow-menu--trigger`,
                isActive: isOpen,
                ...props
            });
        // bail if the consumer wants to handle onClick
        if (typeof onMoreClick === 'function') return renderMoreButton({
            onClick: onMoreClick
        });
        // split boundariesElement into `boundary` and `rootBoundary` props for Popup
        const boundary = boundariesElement === 'scrollParent' ? 'clippingParents' : undefined;
        const rootBoundary = (()=>{
            if (boundariesElement === 'scrollParent') return undefined;
            return boundariesElement === 'window' ? 'document' : 'viewport';
        })();
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $3MV1G.default), {
            isOpen: isOpen,
            onClose: onClose,
            placement: "bottom-end",
            boundary: boundary,
            rootBoundary: rootBoundary,
            shouldFlip: true,
            zIndex: (0, $lcnyw.layers).modal(),
            shouldRenderToParent: shouldPopupRenderToParent,
            content: ({ setInitialFocusRef: setInitialFocusRef })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $6cUPN.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $h5NqH.default), {
                    onClick: (e)=>e.stopPropagation(),
                    minWidth: 250,
                    maxHeight: 300,
                    setInitialFocusRef: isTriggeredUsingKeyboard ? setInitialFocusRef : undefined
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $8BKky.default), null, data.slice(max).map((avatar, index)=>$3b6346b768779c72$var$getOverrides(overrides).AvatarGroupItem.render((0, $hCcWD.default), {
                        avatar: avatar,
                        onAvatarClick: onAvatarClick,
                        testId: testId && `${testId}--avatar-group-item-${index + max}`,
                        index: index + max
                    }, // This index holds the true index,
                    // adding up the index of non-overflowed avatars and overflowed avatars.
                    index + max))))),
            trigger: (triggerProps)=>renderMoreButton({
                    ...triggerProps,
                    ...bindFocus,
                    onClick: handleTriggerClicked
                }),
            testId: testId && `${testId}--overflow-menu`
        });
    }
    const max = maxCount === undefined || maxCount === 0 ? $3b6346b768779c72$var$MAX_COUNT[appearance] : maxCount;
    const total = data.length;
    const maxAvatar = total > max ? max - 1 : max;
    const Group = appearance === 'stack' ? (0, $33ZPs.default) : (0, $3Czko.default);
    return /*#__PURE__*/ (0, $byn9U.jsx)(Group, {
        testId: testId && `${testId}--avatar-group`,
        "aria-label": label
    }, data.slice(0, maxAvatar).map((avatarData, idx)=>{
        const callback = avatarData.onClick || onAvatarClick;
        const finalAvatar = $3b6346b768779c72$var$getOverrides(overrides).Avatar.render(avatar, {
            ...avatarData,
            size: size,
            borderColor: borderColor,
            testId: testId && `${testId}--avatar-${idx}`,
            onClick: callback ? (event, analyticsEvent)=>{
                callback(event, analyticsEvent, idx);
            } : undefined,
            stackIndex: max - idx
        }, idx);
        return !isTooltipDisabled && !avatarData.isDisabled ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $8cU5f.default), {
            key: (0, $bLnyK.composeUniqueKey)(avatarData, idx),
            content: avatarData.name,
            testId: testId && `${testId}--tooltip-${idx}`,
            position: tooltipPosition
        }, finalAvatar) : finalAvatar;
    }), renderMoreDropdown(+maxAvatar, total));
};
var $3b6346b768779c72$export$2e2bcd8739ae039 = $3b6346b768779c72$var$AvatarGroup;

});
parcelRegister("hCcWD", function(module, exports) {

$parcel$export(module.exports, "default", () => $19ec5414b121adc7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $iJlfe = parcelRequire("iJlfe");

var $1lQG9 = parcelRequire("1lQG9");

var $bULPy = parcelRequire("bULPy");
var $e7PSD = parcelRequire("e7PSD");
var $bo4OB = parcelRequire("bo4OB");

var $jXJS5 = parcelRequire("jXJS5");
const $19ec5414b121adc7$var$AvatarGroupItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { avatar: avatar, onAvatarClick: onAvatarClick, testId: testId, index: index } = props;
    const { href: href, onClick: onClick, ...rest } = avatar;
    const itemRef = (0, $jXJS5.default)();
    const CustomComponent = ({ children: children, ...props })=>{
        return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
            type: "button",
            ...props
        }, children));
    };
    const AvatarIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJlfe.default), {
        ...rest,
        testId: testId && `${testId}--avatar`,
        borderColor: "transparent",
        size: "small",
        name: ""
    });
    // onClick handler provided with avatar data takes precedence, same as with the normal avatar item
    const callback = onClick || onAvatarClick;
    if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bo4OB.default), {
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        href: href,
        target: avatar.target,
        rel: avatar.target === '_blank' ? 'noopener noreferrer' : undefined,
        iconBefore: AvatarIcon,
        testId: testId,
        onClick: (event)=>callback && callback(event, undefined, index)
    }, avatar.name);
    if (typeof callback === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bULPy.default), {
        ref: (0, $1lQG9.default)([
            ref,
            itemRef
        ]),
        onClick: (event)=>callback && callback(event, undefined, index),
        iconBefore: AvatarIcon,
        testId: testId
    }, avatar.name);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e7PSD.default), {
        iconBefore: AvatarIcon,
        component: CustomComponent,
        testId: testId
    }, avatar.name);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$19ec5414b121adc7$export$2e2bcd8739ae039 = $19ec5414b121adc7$var$AvatarGroupItem;

});
parcelRegister("jXJS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $47a822a3bf76dc75$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6cUPN = parcelRequire("6cUPN");
// The refs stored in the context are used to programatically
// control focus on a user navigates using the keyboard.
function $47a822a3bf76dc75$var$useRegisterItemWithFocusManager() {
    const { registerRef: registerRef } = (0, $eUqFw.useContext)((0, $6cUPN.FocusManagerContext));
    const itemRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (itemRef.current !== null) registerRef(itemRef.current);
    }, [
        registerRef
    ]);
    return itemRef;
}
var $47a822a3bf76dc75$export$2e2bcd8739ae039 = $47a822a3bf76dc75$var$useRegisterItemWithFocusManager;

});
parcelRegister("6cUPN", function(module, exports) {

$parcel$export(module.exports, "FocusManagerContext", () => $c9e49b704731182e$export$f18c1d4fc7326096);
$parcel$export(module.exports, "default", () => $c9e49b704731182e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $5Q9wj = parcelRequire("5Q9wj");

var $HPlWp = parcelRequire("HPlWp");
const $c9e49b704731182e$export$f18c1d4fc7326096 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    menuItemRefs: [],
    registerRef: (0, $5Q9wj.default)
});
/**
 * Focus manager logic
 */ const $c9e49b704731182e$var$FocusManager = ({ children: children })=>{
    const menuItemRefs = (0, $eUqFw.useRef)([]);
    const registerRef = (0, $eUqFw.useCallback)((ref)=>{
        if (ref && !menuItemRefs.current.includes(ref)) menuItemRefs.current.push(ref);
    }, []);
    // set focus and intentionally rebinding listener and clean up listener on each render
    (0, $eUqFw.useEffect)(()=>{
        (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: (0, $HPlWp.default)(menuItemRefs.current)
        });
        const unbind = ()=>{
            (0, $74BVL.bind)(window, {
                type: 'keydown',
                listener: (0, $HPlWp.default)(menuItemRefs.current)
            });
        };
        return unbind;
    }, []);
    const contextValue = {
        menuItemRefs: menuItemRefs.current,
        registerRef: registerRef
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c9e49b704731182e$export$f18c1d4fc7326096.Provider, {
        value: contextValue
    }, children);
};
var $c9e49b704731182e$export$2e2bcd8739ae039 = $c9e49b704731182e$var$FocusManager;

});
parcelRegister("HPlWp", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2eeb0b24006473e$export$2e2bcd8739ae039);

const $b2eeb0b24006473e$var$actionMap = {
    [(0, $54717ce5fa2c74b1$export$a80636c6f41931fe)]: 'next',
    [(0, $54717ce5fa2c74b1$export$390330c10ff2b9a1)]: 'prev',
    [(0, $54717ce5fa2c74b1$export$4af703091671bc)]: 'first',
    [(0, $54717ce5fa2c74b1$export$e2bc30913faa5db7)]: 'last'
};
/**
 * currentFocusedIdx + 1 will not work if the next focusable element
 * is disabled. So, we need to iterate through the following menu items
 * to find one that isn't disabled. If all following elements are disabled,
 * return undefined.
 */ const $b2eeb0b24006473e$var$getNextFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx + 1 < refs.length){
        const isDisabled = refs[currentFocusedIdx + 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx + 1];
        currentFocusedIdx++;
    }
};
/**
 * currentFocusedIdx - 1 will not work if the prev focusable element
 * is disabled. So, we need to iterate through the previous menu items
 * to find one that isn't disabled. If all previous elements are disabled,
 * return undefined.
 */ const $b2eeb0b24006473e$var$getPrevFocusableElement = (refs, currentFocusedIdx)=>{
    while(currentFocusedIdx > 0){
        const isDisabled = refs[currentFocusedIdx - 1].getAttribute('disabled') !== null;
        if (!isDisabled) return refs[currentFocusedIdx - 1];
        currentFocusedIdx--;
    }
};
function $b2eeb0b24006473e$export$2e2bcd8739ae039(refs) {
    return (e)=>{
        const currentFocusedIdx = refs.findIndex((el)=>document.activeElement?.isSameNode(el));
        const action = $b2eeb0b24006473e$var$actionMap[e.key];
        switch(action){
            case 'next':
                if (currentFocusedIdx < refs.length - 1) {
                    e.preventDefault();
                    const nextFocusableElement = $b2eeb0b24006473e$var$getNextFocusableElement(refs, currentFocusedIdx);
                    nextFocusableElement && nextFocusableElement.focus();
                }
                break;
            case 'prev':
                if (currentFocusedIdx > 0) {
                    e.preventDefault();
                    const prevFocusableElement = $b2eeb0b24006473e$var$getPrevFocusableElement(refs, currentFocusedIdx);
                    prevFocusableElement && prevFocusableElement.focus();
                }
                break;
            case 'first':
                e.preventDefault();
                // Search for first non-disabled element if first element is disabled
                const nextFocusableElement = $b2eeb0b24006473e$var$getNextFocusableElement(refs, -1);
                nextFocusableElement && nextFocusableElement.focus();
                break;
            case 'last':
                e.preventDefault();
                // Search for last non-disabled element if last element is disabled
                const prevFocusableElement = $b2eeb0b24006473e$var$getPrevFocusableElement(refs, refs.length);
                prevFocusableElement && prevFocusableElement.focus();
                break;
            default:
                return;
        }
    };
}

});




parcelRegister("3Czko", function(module, exports) {

$parcel$export(module.exports, "default", () => $f319fa8ea8cddd21$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
function $f319fa8ea8cddd21$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f319fa8ea8cddd21$var$gutter = "var(--ds-space-negative-050, -4px)";
const $f319fa8ea8cddd21$var$listStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
    listStyleType: 'none !important',
    marginInlineEnd: $f319fa8ea8cddd21$var$gutter,
    marginInlineStart: $f319fa8ea8cddd21$var$gutter
});
const $f319fa8ea8cddd21$var$listItemStyles = {
    name: "3unxte",
    styles: "margin:var(--ds-space-0, 0px);margin-block-end:var(--ds-space-100, 8px);padding-inline-end:var(--ds-space-050, 4px);padding-inline-start:var(--ds-space-050, 4px)"
};
const $f319fa8ea8cddd21$var$Grid = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        css: $f319fa8ea8cddd21$var$listStyles
    }, (0, $eUqFw.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $byn9U.jsx)("li", {
            css: $f319fa8ea8cddd21$var$listItemStyles
        }, child)));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f319fa8ea8cddd21$export$2e2bcd8739ae039 = $f319fa8ea8cddd21$var$Grid;

});

parcelRegister("h5NqH", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ffca550571fe4d8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8PFhw = parcelRequire("8PFhw");

var $6cUPN = parcelRequire("6cUPN");
/**
 * It sets focus to the first avatar when popup is open.
 */ const $4ffca550571fe4d8$var$PopupAvatarGroup = ({ maxWidth: maxWidth = 800, minWidth: minWidth = 320, setInitialFocusRef: setInitialFocusRef, ...rest })=>{
    const { menuItemRefs: menuItemRefs } = (0, $eUqFw.useContext)((0, $6cUPN.FocusManagerContext));
    (0, $eUqFw.useEffect)(()=>{
        setInitialFocusRef?.(menuItemRefs[0]);
    }, [
        menuItemRefs,
        setInitialFocusRef
    ]);
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $8PFhw.default), {
        maxWidth: maxWidth,
        minWidth: minWidth,
        ...rest
    }));
};
var $4ffca550571fe4d8$export$2e2bcd8739ae039 = $4ffca550571fe4d8$var$PopupAvatarGroup;

});

parcelRegister("5TioN", function(module, exports) {

$parcel$export(module.exports, "default", () => $80bc7348cf05a7b7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $eri7S = parcelRequire("eri7S");
var $iJlfe = parcelRequire("iJlfe");

var $XHGTv = parcelRequire("XHGTv");

var $PdmhA = parcelRequire("PdmhA");
const $80bc7348cf05a7b7$var$buttonSizes = {
    xsmall: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    medium: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    xlarge: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    xxlarge: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
const $80bc7348cf05a7b7$var$buttonActiveStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        backgroundColor: `var(--ds-background-selected, ${(0, $PdmhA.B50)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        boxShadow: `0 0 0 ${(0, $eri7S.BORDER_WIDTH)}px ${`var(--ds-border-selected, ${(0, $PdmhA.B300)})`}`,
        color: `var(--ds-text-selected, ${(0, $PdmhA.B400)})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transform: `scale(${(0, $eri7S.ACTIVE_SCALE_FACTOR)})`,
        '&:hover': {
            backgroundColor: `var(--ds-background-selected-hovered, ${(0, $PdmhA.N30)})`,
            color: `var(--ds-text-selected, ${(0, $PdmhA.N500)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-selected-pressed, ${(0, $PdmhA.B50)})`,
            color: `var(--ds-text-selected, ${(0, $PdmhA.B400)})`
        }
    }
});
const $80bc7348cf05a7b7$var$buttonStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&': {
        backgroundColor: `var(--ds-background-neutral, ${(0, $PdmhA.N20)})`,
        color: `var(--ds-text, ${(0, $PdmhA.N500)})`,
        '&:hover': {
            backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $PdmhA.N30)})`,
            color: `var(--ds-text, ${(0, $PdmhA.N500)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-background-neutral-pressed, ${(0, $PdmhA.B50)})`,
            color: `var(--ds-text, ${(0, $PdmhA.B400)})`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&::after': {
            display: 'none'
        }
    }
});
const $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT = 99;
const $80bc7348cf05a7b7$var$MoreIndicator = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ appearance: appearance = 'circle', borderColor: borderColor = (0, $XHGTv.fg)('platform.design-system-team.component-visual-refresh_t8zbo') ? "var(--ds-surface, #FFFFFF)" : `var(--ds-border-inverse, ${0, $PdmhA.N0})`, size: size = 'medium', count: count = 0, testId: testId, onClick: onClick, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHaspopup, buttonProps: buttonProps = {}, isActive: isActive }, ref)=>{
    const onClickHander = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        if (buttonProps.onClick) buttonProps.onClick(event);
        onClick(event, analyticsEvent);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        buttonProps.onClick,
        onClick
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $iJlfe.default), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        ref: ref,
        onClick: onClickHander
    }, ({ testId: _, className: className, ref: ref, ...props })=>// eslint-disable-next-line @atlaskit/design-system/no-html-button
        /*#__PURE__*/ (0, $byn9U.jsx)("button", {
            type: "submit",
            ...buttonProps,
            ...props,
            ref: ref,
            "data-testid": testId,
            "aria-controls": ariaControls,
            "aria-expanded": ariaExpanded,
            "aria-haspopup": ariaHaspopup,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                font: $80bc7348cf05a7b7$var$buttonSizes[size]
            },
            css: [
                $80bc7348cf05a7b7$var$buttonStyles,
                isActive && $80bc7348cf05a7b7$var$buttonActiveStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className
        }, "+", count > $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT ? $80bc7348cf05a7b7$var$MAX_DISPLAY_COUNT : count));
});
$80bc7348cf05a7b7$var$MoreIndicator.displayName = 'MoreIndicator';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$80bc7348cf05a7b7$export$2e2bcd8739ae039 = $80bc7348cf05a7b7$var$MoreIndicator;

});

parcelRegister("33ZPs", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e31b31f1a588aba$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $eri7S = parcelRequire("eri7S");

var $lcnyw = parcelRequire("lcnyw");
const $9e31b31f1a588aba$var$gutter = (0, $eri7S.BORDER_WIDTH) * 2 + (0, $lcnyw.gridSize)() / 2;
const $9e31b31f1a588aba$var$listStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
    listStyleType: 'none !important',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineEnd: $9e31b31f1a588aba$var$gutter
});
const $9e31b31f1a588aba$var$listItemStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: "var(--ds-space-0, 0px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineEnd: -$9e31b31f1a588aba$var$gutter
});
const $9e31b31f1a588aba$var$Stack = ({ children: children, testId: testId, 'aria-label': label })=>/*#__PURE__*/ (0, $byn9U.jsx)("ul", {
        "data-testid": testId,
        "aria-label": label,
        css: $9e31b31f1a588aba$var$listStyles
    }, (0, $eUqFw.Children).map(children, (child)=>child && /*#__PURE__*/ (0, $byn9U.jsx)("li", {
            css: $9e31b31f1a588aba$var$listItemStyles
        }, child)));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9e31b31f1a588aba$export$2e2bcd8739ae039 = $9e31b31f1a588aba$var$Stack;

});

parcelRegister("bLnyK", function(module, exports) {

$parcel$export(module.exports, "composeUniqueKey", () => $009108df95df64ca$export$b067756944994c79);
const $009108df95df64ca$export$b067756944994c79 = (props, index)=>{
    if (props.key) return props.key;
    return index;
};

});



parcelRegister("cBUBp", function(module, exports) {

$parcel$export(module.exports, "messages", () => $1b7f42f074d2ba44$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $1b7f42f074d2ba44$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    addPeopleButton: {
        "id": "invite-prompt-on-link-insert.invite-prompt-flag.add-people-button",
        "defaultMessage": "{inviteeCount, plural, one {Add # person} other {Add # people}}"
    },
    dismiss: {
        "id": "invite-prompt-on-link-insert.invite-prompt-flag.dismiss",
        "defaultMessage": "Don't show again"
    },
    titleGeneric: {
        "id": "invite-prompt-on-link-insert.invite-prompt-flag.title-generic",
        "defaultMessage": "{inviteeCount, plural, one {{displayName} needs access to {productDisplayName}} other {People need access to {productDisplayName}}}"
    },
    descriptionWithoutPageTitleGeneric: {
        "id": "invite-prompt-on-link-insert.invite-prompt-flag.description-without-page-title-generic",
        "defaultMessage": "{inviteeCount, plural, one {Invite 1 person who needs access to collaborate with you.} other {Invite people who need access to collaborate with you.}}"
    },
    descriptionWithPageTitleGeneric: {
        "id": "invite-prompt-on-link-insert.invite-prompt-flag.description-with-page-title-generic",
        "defaultMessage": "{inviteeCount, plural, one {Invite 1 person who needs access to collaborate with you on <strong>{title}</strong>.} other {Invite people who need access to collaborate with you on <strong>{title}</strong>.}}"
    },
    selectPeopleButton: {
        "id": "invite-prompt-on-link-insert.invite-prompt-flag.select-people-button",
        "defaultMessage": "Select people"
    }
});

});

parcelRegister("8EYjY", function(module, exports) {

$parcel$export(module.exports, "useRecaptcha", () => $8435994fb5671e15$export$f7242fdfba1703e8);
$parcel$export(module.exports, "RecaptchaTerms", () => $8435994fb5671e15$export$f393864b6f4d4337);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $3RwyL = parcelRequire("3RwyL");
var $dkpfu = parcelRequire("dkpfu");

var $3e9vj = parcelRequire("3e9vj");

var $128HT = parcelRequire("128HT");
const $8435994fb5671e15$export$f7242fdfba1703e8 = ()=>{
    const environment = (0, $3e9vj.useEnvironment)();
    return (0, $dkpfu.useInvisibleRecaptcha)({
        siteKey: (0, $128HT.getRecaptchaSiteKey)(environment),
        displayBadge: false,
        analyticsChannel: 'jira',
        analyticsSource: 'inviteOnLinkInsert'
    });
};
const $8435994fb5671e15$export$f393864b6f4d4337 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8435994fb5671e15$var$RecaptchaContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3RwyL.default), null));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8435994fb5671e15$var$RecaptchaContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyb19bv _syaz1rc1 _19pk12x7 _otyr1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3RwyL", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a80c488a616bf8d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");

var $4zu1b = parcelRequire("4zu1b");

var $lQcgu = parcelRequire("lQcgu");
const $5a80c488a616bf8d$var$RecaptchaTermsAndPolicy = ({ tagName: tagName = 'span' })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4zu1b.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $lQcgu.default).termsAndPolicy,
        tagName: tagName,
        values: {
            privacyPolicy: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                href: "https://policies.google.com/privacy",
                target: "_blank",
                rel: "noopener noreferrer"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $lQcgu.default).privacyPolicy)),
            termsOfService: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                href: "https://policies.google.com/terms",
                target: "_blank",
                rel: "noopener noreferrer"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $lQcgu.default).termsOfService))
        }
    }));
var $5a80c488a616bf8d$export$2e2bcd8739ae039 = $5a80c488a616bf8d$var$RecaptchaTermsAndPolicy;

});
parcelRegister("4zu1b", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa427c799391f6fe$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3dpxL = parcelRequire("3dpxL");
var $5JgJ2 = parcelRequire("5JgJ2");

var $5TxOv = parcelRequire("5TxOv");
const $fa427c799391f6fe$var$IntlProvider = ({ children: children })=>{
    const { locale: locale } = (0, $5JgJ2.default)();
    const { messages: messages } = (0, $5TxOv.useFetchMessagesByLocale)(locale);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
        messages: messages,
        key: locale,
        locale: locale
    }, children);
};
var $fa427c799391f6fe$export$2e2bcd8739ae039 = $fa427c799391f6fe$var$IntlProvider;

});
parcelRegister("5TxOv", function(module, exports) {

$parcel$export(module.exports, "useFetchMessagesByLocale", () => $cdb4dd95d5c8394a$export$5ac26fa9b941854e);
/* eslint-disable import/dynamic-import-chunkname */ 
var $eUqFw = parcelRequire("eUqFw");
























function $cdb4dd95d5c8394a$export$c08b58fa4727b0d2(locale) {
    switch(locale){
        case 'cs-CZ':
        case 'cs':
            return (parcelRequire("3oBOZ"));
        case 'da-DK':
        case 'da':
            return (parcelRequire("5gje7"));
        case 'de-DE':
        case 'de':
            return (parcelRequire("9k7SG"));
        case 'en-GB':
            return (parcelRequire("bAzto"));
        case 'en-US':
        case 'en':
            return (parcelRequire("g1eJX"));
        case 'es-ES':
        case 'es':
            return (parcelRequire("4J0fv"));
        case 'fi-FI':
        case 'fi':
            return (parcelRequire("k2nVi"));
        case 'fr-FR':
        case 'fr':
            return (parcelRequire("5eAkW"));
        case 'hu-HU':
        case 'hu':
            return (parcelRequire("1ZYWf"));
        case 'it-IT':
        case 'it':
            return (parcelRequire("9XloO"));
        case 'ja-JP':
        case 'ja':
            return (parcelRequire("fQUga"));
        case 'ko-KR':
        case 'ko':
            return (parcelRequire("3xE7F"));
        case 'nb-NB':
        case 'nb':
            return (parcelRequire("aR7XE"));
        case 'nl-NL':
        case 'nl':
            return (parcelRequire("jORmO"));
        case 'pl-PL':
        case 'pl':
            return (parcelRequire("8DE2b"));
        case 'pt-BR':
        case 'pt':
            return (parcelRequire("1oNdw"));
        case 'ru-RU':
        case 'ru':
            return (parcelRequire("gscxq"));
        case 'sv-SE':
        case 'sv':
            return (parcelRequire("2yx9g"));
        case 'tr-TR':
        case 'tr':
            return (parcelRequire("dtJPq"));
        case 'th-TH':
        case 'th':
            return (parcelRequire("8Y4Zz"));
        case 'uk-UK':
        case 'uk':
            return (parcelRequire("b6a1h"));
        case 'vi-VI':
        case 'vi':
            return (parcelRequire("8prpY"));
        case 'zh-TW':
        case 'zh-HK':
            return (parcelRequire("hQitB"));
        case 'zh-ZH':
        case 'zh-CN':
        case 'zh':
            return (parcelRequire("dSrFw"));
    }
    return Promise.resolve({
        default: {}
    });
}
function $cdb4dd95d5c8394a$export$5ac26fa9b941854e(locale) {
    const [messages, setMessages] = (0, $eUqFw.useState)({});
    (0, $eUqFw.useEffect)(()=>{
        let isMounted = true;
        async function startToFetchMessagesByLocale() {
            // Intl.Locale doesn't like underscores
            const finalLocale = new Intl.Locale(locale.replace('_', '-')).toString();
            try {
                const module = await $cdb4dd95d5c8394a$export$c08b58fa4727b0d2(finalLocale);
                const newMessages = module.default || module;
                if (isMounted) setMessages(newMessages);
            } catch (e) {
            // fail to download message and do nothing because UI will use default language (English) to render
            }
        }
        startToFetchMessagesByLocale();
        return ()=>{
            isMounted = false;
        };
    }, [
        locale
    ]);
    return {
        messages: messages
    };
}

});
parcelRegister("3oBOZ", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('llrdp');
        const value = parcelRequire('3yfB2');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("llrdp").then(()=>parcelRequire('3yfB2'));
}

});

parcelRegister("5gje7", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('3bY4G');
        const value = parcelRequire('8uYTb');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("3bY4G").then(()=>parcelRequire('8uYTb'));
}

});

parcelRegister("9k7SG", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('6OM46');
        const value = parcelRequire('84R0k');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("6OM46").then(()=>parcelRequire('84R0k'));
}

});

parcelRegister("bAzto", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('ltulP');
        const value = parcelRequire('3Hn5E');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("ltulP").then(()=>parcelRequire('3Hn5E'));
}

});

parcelRegister("g1eJX", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('cmB7Y');
        const value = parcelRequire('3rnT6');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("cmB7Y").then(()=>parcelRequire('3rnT6'));
}

});

parcelRegister("4J0fv", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hXF3T');
        const value = parcelRequire('97Hoj');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hXF3T").then(()=>parcelRequire('97Hoj'));
}

});

parcelRegister("k2nVi", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('b421E');
        const value = parcelRequire('6MSnI');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("b421E").then(()=>parcelRequire('6MSnI'));
}

});

parcelRegister("5eAkW", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('8jFzE');
        const value = parcelRequire('74WBs');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("8jFzE").then(()=>parcelRequire('74WBs'));
}

});

parcelRegister("1ZYWf", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('j4gFh');
        const value = parcelRequire('7fy0p');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("j4gFh").then(()=>parcelRequire('7fy0p'));
}

});

parcelRegister("9XloO", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('d4VDo');
        const value = parcelRequire('gYYj2');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("d4VDo").then(()=>parcelRequire('gYYj2'));
}

});

parcelRegister("fQUga", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('brj24');
        const value = parcelRequire('5htf1');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("brj24").then(()=>parcelRequire('5htf1'));
}

});

parcelRegister("3xE7F", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('8n70c');
        const value = parcelRequire('2kgka');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("8n70c").then(()=>parcelRequire('2kgka'));
}

});

parcelRegister("aR7XE", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('8rgFf');
        const value = parcelRequire('7G7ek');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("8rgFf").then(()=>parcelRequire('7G7ek'));
}

});

parcelRegister("jORmO", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hEjlB');
        const value = parcelRequire('go2ML');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hEjlB").then(()=>parcelRequire('go2ML'));
}

});

parcelRegister("8DE2b", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('fB0wF');
        const value = parcelRequire('5j1Bz');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("fB0wF").then(()=>parcelRequire('5j1Bz'));
}

});

parcelRegister("1oNdw", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('fdx6C');
        const value = parcelRequire('kNjzy');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("fdx6C").then(()=>parcelRequire('kNjzy'));
}

});

parcelRegister("gscxq", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('8GYGC');
        const value = parcelRequire('7Kehb');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("8GYGC").then(()=>parcelRequire('7Kehb'));
}

});

parcelRegister("2yx9g", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('kvXRN');
        const value = parcelRequire('6VoWV');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("kvXRN").then(()=>parcelRequire('6VoWV'));
}

});

parcelRegister("dtJPq", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('aFaUN');
        const value = parcelRequire('3qsb8');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("aFaUN").then(()=>parcelRequire('3qsb8'));
}

});

parcelRegister("8Y4Zz", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('9dfun');
        const value = parcelRequire('6E9f9');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("9dfun").then(()=>parcelRequire('6E9f9'));
}

});

parcelRegister("b6a1h", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('2qgCv');
        const value = parcelRequire('3Cae8');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("2qgCv").then(()=>parcelRequire('3Cae8'));
}

});

parcelRegister("8prpY", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('ko9VK');
        const value = parcelRequire('9VPup');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("ko9VK").then(()=>parcelRequire('9VPup'));
}

});

parcelRegister("hQitB", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('2EDEf');
        const value = parcelRequire('7oPi9');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("2EDEf").then(()=>parcelRequire('7oPi9'));
}

});

parcelRegister("dSrFw", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('fwywV');
        const value = parcelRequire('8DSFF');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("fwywV").then(()=>parcelRequire('8DSFF'));
}

});



parcelRegister("lQcgu", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4a6b875ff05ebc6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
const $e4a6b875ff05ebc6$var$messages = (0, $90IgZ.defineMessages)({
    termsAndPolicy: {
        id: 'growth.google-recaptcha.terms-and-policy.text',
        description: 'Text substitute for reCAPTCHA branding when badge is visibly hidden',
        defaultMessage: 'This site is protected by reCAPTCHA and the Google {privacyPolicy} and {termsOfService} apply.'
    },
    privacyPolicy: {
        id: 'growth.google-recaptcha.terms-and-policy.privacy-policy',
        description: 'Privacy Policy link text',
        defaultMessage: 'Privacy Policy'
    },
    termsOfService: {
        id: 'growth.google-recaptcha.terms-and-policy.terms-of-service',
        description: 'Terms of Service link text',
        defaultMessage: 'Terms of Service'
    }
});
var $e4a6b875ff05ebc6$export$2e2bcd8739ae039 = $e4a6b875ff05ebc6$var$messages;

});


parcelRegister("dkpfu", function(module, exports) {

$parcel$export(module.exports, "useInvisibleRecaptcha", () => $6ff235a9f1da7c07$export$9a22eec761fce66);

var $eUqFw = parcelRequire("eUqFw");

var $e0mW9 = parcelRequire("e0mW9");

var $hRXOT = parcelRequire("hRXOT");
const $6ff235a9f1da7c07$export$9a22eec761fce66 = ({ siteKey: siteKey, displayBadge: displayBadge = true, analyticsChannel: analyticsChannel, analyticsSource: analyticsSource })=>{
    const triggerEvent = (0, $e0mW9.useAnalytics)(analyticsChannel, analyticsSource);
    const [isRecaptchaLoaded, setIsRecaptchaLoaded] = (0, $eUqFw.useState)(false);
    const [recaptchaLoadErrorReason, setRecaptchaLoadErrorReason] = (0, $eUqFw.useState)();
    (0, $eUqFw.useEffect)(()=>{
        let isMounted = true;
        const initRecaptcha = async ()=>{
            try {
                await (0, $hRXOT.loadRecaptcha)(siteKey);
                if (!displayBadge) (0, $hRXOT.hideRecaptchaBadge)(siteKey);
                triggerEvent((0, $e0mW9.recaptchaLoaded));
                if (isMounted) {
                    setIsRecaptchaLoaded(true);
                    setRecaptchaLoadErrorReason(undefined);
                }
            } catch (err) {
                const errorMessage = String(err);
                triggerEvent((0, $e0mW9.recaptchaLoadFailed), errorMessage);
                if (isMounted) setRecaptchaLoadErrorReason(errorMessage);
            }
        };
        initRecaptcha();
        return ()=>{
            (0, $hRXOT.unloadRecaptcha)(siteKey);
            setRecaptchaLoadErrorReason(undefined);
            isMounted = false;
        };
    }, [
        displayBadge,
        siteKey,
        triggerEvent
    ]);
    const getRecaptchaToken = (0, $eUqFw.useCallback)(async (action)=>{
        try {
            if (!isRecaptchaLoaded || !window?.grecaptcha?.enterprise?.execute) throw new (0, $hRXOT.RecaptchaError)('Execute function not ready');
            return await window.grecaptcha.enterprise.execute(siteKey, {
                action: action
            });
        } catch (err) {
            triggerEvent((0, $e0mW9.recaptchaExecuteFailed), String(err));
            throw err;
        }
    }, [
        isRecaptchaLoaded,
        siteKey,
        triggerEvent
    ]);
    return {
        isRecaptchaLoaded: isRecaptchaLoaded,
        getRecaptchaToken: getRecaptchaToken,
        recaptchaLoadErrorReason: recaptchaLoadErrorReason
    };
};

});
parcelRegister("e0mW9", function(module, exports) {

$parcel$export(module.exports, "useAnalytics", () => $1cb079902f0169d6$export$e955abb82869dc84);
$parcel$export(module.exports, "recaptchaLoaded", () => $1cb079902f0169d6$export$b97b16bc7fe47920);
$parcel$export(module.exports, "recaptchaLoadFailed", () => $1cb079902f0169d6$export$3a46331396e3fda);
$parcel$export(module.exports, "recaptchaExecuteFailed", () => $1cb079902f0169d6$export$ea782407790eb26c);

var $eUqFw = parcelRequire("eUqFw");


var $hM7RE = parcelRequire("hM7RE");
var $bFzGY = parcelRequire("bFzGY");
const $1cb079902f0169d6$var$ACTION_SUBJECT = 'recaptcha';
const $1cb079902f0169d6$export$e955abb82869dc84 = (channel, source)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const triggerEvent = (0, $eUqFw.useCallback)((eventFactory, ...args)=>{
        const analyticsEvent = {
            source: source,
            ...eventFactory(...args)
        };
        (0, $hM7RE.default)(channel)(analyticsEvent)(createAnalyticsEvent);
    }, [
        source,
        channel,
        createAnalyticsEvent
    ]);
    return triggerEvent;
};
const $1cb079902f0169d6$export$b97b16bc7fe47920 = ()=>({
        eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
        actionSubject: $1cb079902f0169d6$var$ACTION_SUBJECT,
        action: 'loaded'
    });
const $1cb079902f0169d6$export$3a46331396e3fda = (errorMessage)=>({
        eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
        actionSubject: $1cb079902f0169d6$var$ACTION_SUBJECT,
        actionSubjectId: 'load',
        action: 'failed',
        attributes: {
            error: errorMessage
        }
    });
const $1cb079902f0169d6$export$ea782407790eb26c = (errorMessage)=>({
        eventType: (0, $662e33bb7444ae33$export$12346a674644c156),
        actionSubject: $1cb079902f0169d6$var$ACTION_SUBJECT,
        actionSubjectId: 'execute',
        action: 'failed',
        attributes: {
            error: errorMessage
        }
    });

});

parcelRegister("hRXOT", function(module, exports) {

$parcel$export(module.exports, "loadRecaptcha", () => $70fd2f2a7ce6e3ca$export$29933d84054794ee);
$parcel$export(module.exports, "unloadRecaptcha", () => $70fd2f2a7ce6e3ca$export$cfad80fecff3cb16);
$parcel$export(module.exports, "hideRecaptchaBadge", () => $70fd2f2a7ce6e3ca$export$924e44702e93d253);
$parcel$export(module.exports, "RecaptchaError", () => $70fd2f2a7ce6e3ca$export$e037dc82f45cc746);
const $70fd2f2a7ce6e3ca$var$FAIL_LOAD_CAPTCHA_ERROR_MESSAGE = 'Failed to load grecaptcha enterprise';
const $70fd2f2a7ce6e3ca$export$b8e8ecca99719d00 = 'https://www.recaptcha.net/recaptcha/enterprise.js';
const $70fd2f2a7ce6e3ca$var$RECAPTCHA_BADGE_SELECTOR = '.grecaptcha-badge';
const $70fd2f2a7ce6e3ca$export$29933d84054794ee = (siteKey)=>new Promise((resolve, reject)=>{
        if ($70fd2f2a7ce6e3ca$var$isRecaptchaLoaded(siteKey)) {
            resolve();
            return;
        }
        const scriptElement = document.createElement('script');
        scriptElement.src = `${$70fd2f2a7ce6e3ca$export$b8e8ecca99719d00}?render=${siteKey}`;
        scriptElement.async = true;
        scriptElement.defer = true;
        scriptElement.id = siteKey;
        scriptElement.onload = ()=>{
            if (!window?.grecaptcha?.enterprise) reject($70fd2f2a7ce6e3ca$var$FAIL_LOAD_CAPTCHA_ERROR_MESSAGE);
            else window.grecaptcha.enterprise.ready(resolve);
        };
        scriptElement.onerror = (error)=>{
            reject(typeof error === 'string' ? error : error.message ?? $70fd2f2a7ce6e3ca$var$FAIL_LOAD_CAPTCHA_ERROR_MESSAGE);
        };
        document.body.appendChild(scriptElement);
    });
const $70fd2f2a7ce6e3ca$var$isRecaptchaLoaded = (siteKey)=>Boolean(document.getElementById(siteKey));
const $70fd2f2a7ce6e3ca$export$cfad80fecff3cb16 = (siteKey)=>{
    $70fd2f2a7ce6e3ca$var$removeRecaptchaScriptElement(siteKey);
    $70fd2f2a7ce6e3ca$var$removeRecaptchaBadgeStyleElement(siteKey);
    $70fd2f2a7ce6e3ca$var$removeRecaptchaBadge();
};
const $70fd2f2a7ce6e3ca$export$924e44702e93d253 = (siteKey)=>{
    const id = `${siteKey}-styles`;
    if (document.getElementById(id)) return;
    const styleElement = document.createElement('style');
    styleElement.id = `${siteKey}-styles`;
    styleElement.innerText = `${$70fd2f2a7ce6e3ca$var$RECAPTCHA_BADGE_SELECTOR} { visibility: hidden; }`;
    document.head.appendChild(styleElement);
};
const $70fd2f2a7ce6e3ca$var$removeRecaptchaScriptElement = (siteKey)=>{
    const scriptElement = document.getElementById(siteKey);
    if (scriptElement) scriptElement.remove();
};
const $70fd2f2a7ce6e3ca$var$removeRecaptchaBadgeStyleElement = (siteKey)=>{
    const styleElement = document.getElementById(`${siteKey}-styles`);
    if (styleElement) styleElement.remove();
};
const $70fd2f2a7ce6e3ca$var$removeRecaptchaBadge = ()=>{
    const badgeElements = document.querySelectorAll($70fd2f2a7ce6e3ca$var$RECAPTCHA_BADGE_SELECTOR);
    // @ts-ignore "TS2488: Type 'NodeListOf<Element>' must have a '[Symbol.iterator]()' method that returns an iterator." occurs within Jira due to missing DOM.Iterable. We've dropped IE support so we shouldn't need it.
    for (const el of badgeElements)el.remove();
};
class $70fd2f2a7ce6e3ca$export$e037dc82f45cc746 extends Error {
    constructor(message){
        super(message);
        // fixing the `instanceof` operators, see https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $70fd2f2a7ce6e3ca$export$e037dc82f45cc746.prototype);
    }
}

});




parcelRegister("94ERq", function(module, exports) {

$parcel$export(module.exports, "useInviteSuccessFlag", () => $1ee7b642921c554b$export$c323779e5ddf45d0);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $8vPhU = parcelRequire("8vPhU");
var $kQ0RL = parcelRequire("kQ0RL");
var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6Dw6K = parcelRequire("6Dw6K");

var $4nJFz = parcelRequire("4nJFz");
const $1ee7b642921c554b$export$c323779e5ddf45d0 = ()=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagService)();
    return (0, $eUqFw.useCallback)(({ users: users, product: product })=>{
        const id = `success-${(0, $6Dw6K.generateId)()}`;
        const dismiss = ()=>dismissFlag((0, $8vPhU.dismissFlag)(id));
        showFlag({
            id: id,
            render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1ee7b642921c554b$export$6c436beee6e5593, {
                    ...props,
                    id: id,
                    users: users,
                    onDismiss: dismiss,
                    product: product
                })
        });
    }, [
        dismissFlag,
        showFlag
    ]);
};
const $1ee7b642921c554b$export$6c436beee6e5593 = ({ users: users, onDismiss: onDismiss, product: product, ...props })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const maxLength = 25;
    const invitedEmail = (0, $6Dw6K.clampString)(users[0]?.email || users[0].name, maxLength);
    const productDisplayName = (0, $6Dw6K.getProductDisplayName)(product);
    const customFlagFooterProps = (0, $eUqFw.useMemo)(()=>({
            actions: [
                {
                    content: '',
                    // Replace with lodash/noop
                    // eslint-disable-next-line @typescript-eslint/no-empty-function
                    onClick: ()=>{}
                }
            ],
            linkComponent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1ee7b642921c554b$var$FooterParagraph, null, formatMessage((0, $4nJFz.messages).additionalInfoGeneric, {
                    productDisplayName: productDisplayName
                }))
        }), [
        formatMessage,
        productDisplayName
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.SuccessFlag), {
        ...props,
        ...customFlagFooterProps,
        onDismissed: onDismiss,
        title: formatMessage((0, $4nJFz.messages).title, {
            inviteeCount: users.length
        }),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $4nJFz.messages).descriptionGeneric, {
            strong: (...chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("strong", null, chunks.join('')),
            inviteeCount: users.length,
            email: invitedEmail,
            productDisplayName: productDisplayName
        }))
    });
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1ee7b642921c554b$var$FooterParagraph = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syazjjyb _t9ec1gty",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4nJFz", function(module, exports) {

$parcel$export(module.exports, "messages", () => $17bbccf2d88ab8c2$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $17bbccf2d88ab8c2$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    title: {
        "id": "invite-prompt-on-link-insert.invite-success-flag.title",
        "defaultMessage": "{inviteeCount, plural, one {Invite successfully sent} other {Invites successfully sent}}"
    },
    dismiss: {
        "id": "invite-prompt-on-link-insert.invite-success-flag.dismiss",
        "defaultMessage": "Ok, got it"
    },
    descriptionGeneric: {
        "id": "invite-prompt-on-link-insert.invite-success-flag.description-generic",
        "defaultMessage": "{inviteeCount, plural, one {We emailed <strong>{email}</strong> inviting them to {productDisplayName}.} other {We emailed <strong># people</strong> inviting them to {productDisplayName}.}}"
    },
    additionalInfoGeneric: {
        "id": "invite-prompt-on-link-insert.invite-success-flag.additional-info-generic",
        "defaultMessage": "Some people might need your admin's approval before they can join {productDisplayName}."
    }
});

});




parcelRegister("0GqmM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5986f1578fb1af4$export$2e2bcd8739ae039);

var $8blac = parcelRequire("8blac");

var $kFGm5 = parcelRequire("kFGm5");

var $8dloj = parcelRequire("8dloj");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $7byHA = parcelRequire("7byHA");
var $lRmyA = parcelRequire("lRmyA");

var $dfh7z = parcelRequire("dfh7z");

var $fFvAc = parcelRequire("fFvAc");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $ccbnZ = parcelRequire("ccbnZ");

var $aEMSD = parcelRequire("aEMSD");

var $6U4bW = parcelRequire("6U4bW");
const $b5986f1578fb1af4$var$useCreateIssueService = (selectedCloudId = '')=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const createIssue = ({ onSuccess: onSuccess, formData: formData, transition: inputTransition, watchers: watchers, skipAutoWatch: skipAutoWatch, fieldConfig: fieldConfig, fieldTabs: fieldTabs, hasIssueAdjustmentModules: hasIssueAdjustmentModules, context: context, createLinkedIssuePayload: createLinkedIssuePayload, interactedFields: interactedFields = {}, shouldShowStatus: shouldShowStatus = false, isSubTaskCreationOpen: isSubTaskCreationOpen, triggerPointKey: triggerPointKey })=>{
        let transformedData = (0, $6U4bW.transformData)(formData, fieldConfig);
        const additionalFields = context?.submitApiData?.additionalFields || {};
        const issueList = context?.submitApiData?.issueList || null;
        const transition = inputTransition ?? context?.submitApiData?.transition;
        const { isCreateLinkedIssue: isCreateLinkedIssue, sourceIssueKey: sourceIssueKey } = createLinkedIssuePayload || {};
        // add copy links and attachments data to issuelinks and attachment field submit payload
        if ((0, $1ybV0.ff)('create-linked-issues-trigger-point-issue-view') && isCreateLinkedIssue && sourceIssueKey) transformedData = (0, $6U4bW.handleCopyLinksAndAttachments)({
            transformedData: transformedData,
            formData: formData,
            sourceIssueKey: sourceIssueKey
        });
        const performPostRequestNew = (0, $1ybV0.ff)('show-422-and-409-errors-as-validation-error-messages_wg377') ? (0, $aEMSD.performPost) : (0, $lRmyA.performPostRequest);
        const updateFields = (0, $6U4bW.getUpdateFields)((0, $1ybV0.ff)('create-linked-issues-trigger-point-issue-view') && isCreateLinkedIssue && Boolean(sourceIssueKey));
        const payload = {
            fields: {
                ...additionalFields,
                ...(0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(transformedData, updateFields)
            },
            update: (0, (/*@__PURE__*/$parcel$interopDefault($8dloj)))(transformedData, updateFields),
            ...!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(issueList) && {
                issueList: issueList
            },
            transition: undefined,
            watchers: watchers,
            externalToken: (0, $ccbnZ.default)().toString()
        };
        // @ts-expect-error - TS2322 - Type '{ id: string; }' is not assignable to type 'undefined'.
        if (transition) payload.transition = transition;
        (0, $dfh7z.GlobalIssueCreateModalSubmitUFOExperience).start();
        const getCollapsedFields = (0, $1ybV0.ff)('gic-smart-fields-remove-required-sentry-error_9jlqp') ? ()=>!hasIssueAdjustmentModules && fieldTabs ? fieldTabs.flatMap((tab)=>tab.collapsedItems || []) : [] : undefined;
        const MAX_RETRIES = 1;
        const performPostRequestRetry = (retryCount)=>{
            const analyticsEvent = createAnalyticsEvent({});
            return performPostRequestNew((0, $fFvAc.transformCreateIssueUrl)({
                issueUrl: (0, $6U4bW.getCreateIssueUrl)({
                    isCreateLinkedIssue: isCreateLinkedIssue || false,
                    skipAutoWatch: skipAutoWatch
                }),
                selectedCloudId: selectedCloudId
            }), {
                body: JSON.stringify(payload)
            }).then((issueCreateResponse)=>{
                let issueCreateFieldsUsed; // TODO Delete this and create const when cleaning gic-smart-fields-jira-labs_8uwvr
                const statusWasSet = issueCreateResponse && issueCreateResponse.transition !== undefined;
                // TODO Remove check for getCollapsedFields when cleaning gic-smart-fields-remove-required-sentry-error_9jlqp
                const collapsedFields = (0, $1ybV0.ff)('gic-smart-fields-remove-required-sentry-error_9jlqp') && getCollapsedFields ? getCollapsedFields() : [];
                if (!(0, $1ybV0.ff)('gic-smart-fields-remove-required-sentry-error_9jlqp') && (0, $1ybV0.ff)('gic-smart-fields-jira-labs_8uwvr') && !hasIssueAdjustmentModules && fieldTabs) fieldTabs.forEach((tab)=>{
                    tab.collapsedItems && tab.collapsedItems.forEach((field)=>{
                        collapsedFields.push(field);
                    });
                });
                let modifiedFieldConfig = fieldConfig;
                let modifiedFormData = formData;
                let modifiedInteractedFields = interactedFields;
                // If the form has a status field provided, the formConfig and formData
                // will be modified on `transformDataToIssueCreateFieldsUsed` to have the
                // hasDefaultValue and isPopulated attributes set to true for status. If the user
                // has modified the status field, the response of the API will return a transition props
                // which is used to modify the interactedFields to set hasInteractedWith to true for status.
                if (shouldShowStatus) {
                    modifiedFieldConfig = {
                        ...fieldConfig,
                        status: {
                            ...fieldConfig.status,
                            defaultValue: true
                        }
                    };
                    modifiedFormData = {
                        ...formData,
                        status: true
                    };
                    if (statusWasSet) modifiedInteractedFields = {
                        ...interactedFields,
                        status: true
                    };
                }
                if ((0, $1ybV0.ff)('gic-smart-fields-jira-labs_8uwvr')) issueCreateFieldsUsed = (0, $6U4bW.transformDataToIssueCreateFieldsUsed)(modifiedFormData, modifiedFieldConfig, modifiedInteractedFields, collapsedFields);
                else issueCreateFieldsUsed = (0, $6U4bW.transformDataToIssueCreateFieldsUsed)(modifiedFormData, modifiedFieldConfig, modifiedInteractedFields);
                const mentionedUserIds = (0, $1ybV0.ff)('sea-2642-mentions-additional-analytics') ? (0, $6U4bW.getMentionedUserIds)(formData) : [];
                const issueCreateContextUsed = (0, $6U4bW.transformContextDataUsedForCreate)(context);
                (0, $dfh7z.CreateIssueUFOExperience).success();
                (0, $dfh7z.GlobalIssueCreateModalSubmitUFOExperience).success();
                if (issueCreateResponse?.transition?.status && issueCreateResponse.transition.status !== 200) (0, $guiFP.default)({
                    meta: {
                        id: 'transitionIssue',
                        packageName: 'jiraIssueCreate',
                        teamName: 'gryffindor'
                    },
                    attributes: {
                        status: issueCreateResponse.transition.status,
                        message: (issueCreateResponse.transition.errorCollection?.errorMessages || []).join('\n')
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                const collapsedFieldsLength = (0, $1ybV0.ff)('gic-smart-fields-remove-required-sentry-error_9jlqp') ? collapsedFields.length : undefined;
                onSuccess({
                    issueCreateResponse: issueCreateResponse,
                    issueCreateFieldsUsed: issueCreateFieldsUsed,
                    issueCreateContextUsed: issueCreateContextUsed,
                    mentionedUserIds: mentionedUserIds,
                    ...(0, $1ybV0.ff)('gic-smart-fields-remove-required-sentry-error_9jlqp') && {
                        collapsedFieldsLength: collapsedFieldsLength
                    }
                });
                const attributes = {
                    isRetry: retryCount < MAX_RETRIES,
                    statusCode: '2xx'
                };
                (0, $jMP2a.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreate retry', attributes);
            }).catch((error)=>{
                if (String(error.statusCode).startsWith('5')) {
                    if (retryCount < MAX_RETRIES) {
                        const attributes = {
                            isRetry: true,
                            statusCode: '5xx'
                        };
                        (0, $jMP2a.fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreate retry', attributes);
                    }
                    if (retryCount > 0) return performPostRequestRetry(retryCount - 1);
                }
                let statusCode;
                if (error instanceof (0, $7byHA.default)) statusCode = error?.statusCode;
                (0, $guiFP.default)({
                    meta: {
                        id: 'useCreateIssueService',
                        packageName: 'jiraIssueCreate',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    attributes: {
                        isSubtask: isSubTaskCreationOpen,
                        triggerPointKey: triggerPointKey,
                        statusCode: statusCode
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                (0, $dfh7z.CreateIssueUFOExperience).failure();
                (0, $dfh7z.GlobalIssueCreateModalSubmitUFOExperience).failure();
                throw error;
            });
        };
        return performPostRequestRetry(MAX_RETRIES);
    };
    return [
        createIssue
    ];
};
var $b5986f1578fb1af4$export$2e2bcd8739ae039 = $b5986f1578fb1af4$var$useCreateIssueService;

});
parcelRegister("ccbnZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a64beea14693e11c$export$2e2bcd8739ae039);
// code-reaper-ignore-file -- Alternative implementation of random numbers for the browser.
const $a64beea14693e11c$var$MAX_UINT32 = 4294967296;
function $a64beea14693e11c$export$2e2bcd8739ae039() {
    try {
        const buf = new Uint32Array(1);
        // buf now has a random uint32 value
        window.crypto.getRandomValues(buf);
        // Turn it back into a value in [0,1)
        return buf[0] / $a64beea14693e11c$var$MAX_UINT32;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return Math.random();
    }
}

});

parcelRegister("aEMSD", function(module, exports) {

$parcel$export(module.exports, "performPost", () => $1b868d8c710bc355$export$8fc3e0df78e1e7f5);

var $fVqUX = parcelRequire("fVqUX");


var $etaBp = parcelRequire("etaBp");
var $7byHA = parcelRequire("7byHA");
var $jxATW = parcelRequire("jxATW");
var $lRmyA = parcelRequire("lRmyA");
const $1b868d8c710bc355$var$postOptions = {
    ...(0, $fVqUX.default),
    method: 'POST'
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1b868d8c710bc355$var$processResponseFromServer = (response)=>{
    if (response.status === (0, $1c3fbb431a173cc6$export$3288b14b6745c572)) return Promise.resolve(null);
    return response.text().then((text)=>text ? JSON.parse(text) : null);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1b868d8c710bc355$var$handleNetworkErrors = (err)=>{
    if (err instanceof TypeError) throw new Error('Failed to fetch', {
        cause: err
    });
    throw err;
};
const $1b868d8c710bc355$var$handleErrors = async (response)=>{
    const res = await response.json();
    const traceId = (0, $jxATW.getTraceId)(response);
    // handle CONFLICT and TOO_MANY_REQUESTS using validation erorr handlers.
    if ([
        (0, $1c3fbb431a173cc6$export$9de493bcd9b1d977),
        (0, $1c3fbb431a173cc6$export$c09e7ea0fc79f34f),
        (0, $1c3fbb431a173cc6$export$6763168a631449a2),
        (0, $1c3fbb431a173cc6$export$67d19e9a991baa07),
        (0, $1c3fbb431a173cc6$export$a3269a3914b007e3),
        (0, $1c3fbb431a173cc6$export$a447d0a965e16776)
    ].find((i)=>i === response.status)) throw (0, $lRmyA.transformValidationErrorFromServer)(res, response.status, traceId);
    if (res?.errorMessages) throw res.errorMessages.join('\n');
    if (!response.ok) {
        if (traceId !== undefined && traceId.length > 0) throw new (0, $7byHA.default)(response.status, `Error server response: ${response.status}`, traceId);
        else throw new (0, $7byHA.default)(response.status, `Error server response: ${response.status}`);
    }
    return response;
};
const $1b868d8c710bc355$export$8fc3e0df78e1e7f5 = (url, options = {})=>fetch(url, (0, $etaBp.applyObservabilityHeaders)(url, {
        ...$1b868d8c710bc355$var$postOptions,
        ...options
    })).then($1b868d8c710bc355$var$handleErrors).then($1b868d8c710bc355$var$processResponseFromServer).catch($1b868d8c710bc355$var$handleNetworkErrors);

});

parcelRegister("6U4bW", function(module, exports) {

$parcel$export(module.exports, "getCreateIssueUrl", () => $22938e2d733067f2$export$a92012cc19d68266);
$parcel$export(module.exports, "transformData", () => $22938e2d733067f2$export$3ceb62baab058c6b);
$parcel$export(module.exports, "transformDataToIssueCreateFieldsUsed", () => $22938e2d733067f2$export$cd0a7e468fa77da3);
$parcel$export(module.exports, "transformContextDataUsedForCreate", () => $22938e2d733067f2$export$59dd9eec92eadfdd);
$parcel$export(module.exports, "handleCopyLinksAndAttachments", () => $22938e2d733067f2$export$16a7d356b78628b0);
$parcel$export(module.exports, "getUpdateFields", () => $22938e2d733067f2$export$3312ec73143db50);
$parcel$export(module.exports, "getMentionedUserIds", () => $22938e2d733067f2$export$47eba31424474e1f);

var $8blac = parcelRequire("8blac");

var $1ybV0 = parcelRequire("1ybV0");

var $bm1XB = parcelRequire("bm1XB");

var $lO4Or = parcelRequire("lO4Or");

var $7Vbpp = parcelRequire("7Vbpp");

var $lG4nv = parcelRequire("lG4nv");
const $22938e2d733067f2$export$a92012cc19d68266 = ({ isCreateLinkedIssue: isCreateLinkedIssue = false, skipAutoWatch: skipAutoWatch = false })=>{
    const urlSearchParams = new URLSearchParams('updateHistory=true&applyDefaultValues=false');
    if ((0, $1ybV0.ff)('create-linked-issues-trigger-point-issue-view') && isCreateLinkedIssue) urlSearchParams.append('fromCreateLinkedIssueScreen', 'true');
    if (skipAutoWatch) urlSearchParams.append('skipAutoWatch', 'true');
    return `/rest/api/3/issue?${urlSearchParams.toString()}`;
};
const $22938e2d733067f2$export$3ceb62baab058c6b = (formData, fieldConfig)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(formData).reduce((acc, fieldId)=>{
        // context fields are not part of field config
        const fieldData = fieldConfig[fieldId];
        if (fieldData) {
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly JiraAffectedServicesField: { readonly Component: AbstractComponent<ReturnComponentProps<AffectedServicesFieldConfig>, any>; readonly defaultValueKey: "selectedAffectedServices"; readonly submitTransform: (options: AffectedServiceOption[]) => ServiceEntity[]; readonly retainUserInputTransform: (selectedAff...'.
            const transformFunction = (0, $lG4nv.getGqlFieldMap)()[fieldData.gqlType]?.submitTransform;
            const transformedData = transformFunction && formData[fieldId] !== null && formData[fieldId] !== undefined ? transformFunction(formData[fieldId]) : formData[fieldId];
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            return {
                ...acc,
                [fieldId]: transformedData
            };
        }
        // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
        return {
            ...acc,
            [fieldId]: formData[fieldId]
        };
    }, {});
const $22938e2d733067f2$export$95572daab36eec17 = (fieldValue)=>{
    if (typeof fieldValue === 'object' && fieldValue !== null) {
        // check for linked issue field
        if ('issues' in fieldValue) return fieldValue.issues.length > 0;
        // check for rich text field
        if ('content' in fieldValue && 'version' in fieldValue && 'type' in fieldValue) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return !(0, $7Vbpp.isOnlyWhitespaceAdf)(fieldValue);
    }
    return typeof fieldValue === 'number' || typeof fieldValue === 'boolean' || !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(fieldValue);
};
const $22938e2d733067f2$export$cd0a7e468fa77da3 = (formData, fieldConfig, interactedFields, collapsedFields)=>{
    const issueCreateFieldsUsed = [];
    Object.keys(fieldConfig).forEach((fieldId)=>{
        const fieldValue = formData[fieldId];
        issueCreateFieldsUsed.push({
            issueFieldId: fieldId,
            issueFieldType: fieldConfig[fieldId].fieldType,
            gqlType: fieldConfig[fieldId].gqlType,
            isPopulated: $22938e2d733067f2$export$95572daab36eec17(fieldValue),
            isRequired: !!fieldConfig[fieldId].isRequired,
            hasDefaultValue: !!fieldConfig[fieldId].defaultValue,
            wasInteractedWith: !!interactedFields?.[fieldId],
            ...(0, $1ybV0.ff)('gic-smart-fields-jira-labs_8uwvr') && collapsedFields && collapsedFields.length > 0 && {
                wasCollapsed: collapsedFields.includes(fieldId)
            }
        });
    });
    // @ts-expect-error - TS7005 - Variable 'issueCreateFieldsUsed' implicitly has an 'any[]' type.
    return issueCreateFieldsUsed;
};
const $22938e2d733067f2$export$59dd9eec92eadfdd = (context)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(context)) return {};
    return {
        wereAdditionalFieldsProvided: !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(context?.submitApiData?.additionalFields),
        isIssueListProvided: !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(context?.submitApiData?.issueList?.addTo)
    };
};
const $22938e2d733067f2$export$4c4230f34434cbdf = ({ attachments: attachments, issueLinksValue: issueLinksValue, sourceIssueKey: sourceIssueKey })=>[
        ...attachments ? [
            {
                set: attachments
            }
        ] : [],
        ...issueLinksValue?.includeAttachments ? [
            {
                copy: {
                    sourceIssues: [
                        {
                            key: sourceIssueKey
                        }
                    ]
                }
            }
        ] : []
    ];
const $22938e2d733067f2$export$8310c11186fc8627 = ({ issueLinksTransformedData: issueLinksTransformedData, issueLinksValue: issueLinksValue, sourceIssueKey: sourceIssueKey })=>[
        ...issueLinksTransformedData || [],
        ...issueLinksValue?.includeLinks ? [
            {
                copy: {
                    sourceIssues: [
                        {
                            key: sourceIssueKey
                        }
                    ]
                }
            }
        ] : []
    ];
const $22938e2d733067f2$export$16a7d356b78628b0 = ({ transformedData: transformedData, formData: formData, sourceIssueKey: sourceIssueKey })=>{
    const issueLinksValue = formData[0, $lO4Or.ISSUE_LINKS_TYPE];
    return {
        ...transformedData,
        [(0, $lO4Or.ATTACHMENT_TYPE)]: $22938e2d733067f2$export$4c4230f34434cbdf({
            attachments: transformedData[0, $lO4Or.ATTACHMENT_TYPE],
            issueLinksValue: issueLinksValue,
            sourceIssueKey: sourceIssueKey
        }),
        [(0, $lO4Or.ISSUE_LINKS_TYPE)]: $22938e2d733067f2$export$8310c11186fc8627({
            issueLinksTransformedData: transformedData[0, $lO4Or.ISSUE_LINKS_TYPE],
            issueLinksValue: issueLinksValue,
            sourceIssueKey: sourceIssueKey
        })
    };
};
const $22938e2d733067f2$export$3312ec73143db50 = (isCreateLinkedIssue = false)=>isCreateLinkedIssue ? (0, $lG4nv.UPDATE_FIELDS_CREATE_LINKED_ISSUE) : (0, $lG4nv.UPDATE_FIELDS);
const $22938e2d733067f2$export$47eba31424474e1f = (formData)=>{
    const mentionedUserIds = [];
    const mentions = (0, $bm1XB.findMentionsInAdfContent)(formData.description?.content);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(mentions)) mentions.forEach((mention)=>{
        if (!mentionedUserIds.includes(mention.attrs.id)) mentionedUserIds.push(mention.attrs.id);
    });
    return mentionedUserIds;
};

});
parcelRegister("bm1XB", function(module, exports) {

$parcel$export(module.exports, "findMentionsInAdfContent", () => $480b84f51fed2351$export$d300fdcf6968c7ca);

var $5Yqat = parcelRequire("5Yqat");

var $h0sZe = parcelRequire("h0sZe");
const $480b84f51fed2351$export$d300fdcf6968c7ca = (elements)=>{
    if (!elements) return [];
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, (/*@__PURE__*/$parcel$interopDefault($5Yqat)))((0, (/*@__PURE__*/$parcel$interopDefault($h0sZe)))(elements, (element)=>{
        if (element?.type && element.type === 'mention') return element;
        if (element?.content) return $480b84f51fed2351$export$d300fdcf6968c7ca(element.content);
        return null;
    }));
};

});
parcelRegister("5Yqat", function(module, exports) {
/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */ function $4596dac18914dac8$var$compact(array) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (value) result[resIndex++] = value;
    }
    return result;
}
module.exports = $4596dac18914dac8$var$compact;

});

parcelRegister("h0sZe", function(module, exports) {

var $hKE3p = parcelRequire("hKE3p");

var $eo8NR = parcelRequire("eo8NR");
/** Used as references for various `Number` constants. */ var $c618ebe283af6d5e$var$INFINITY = 1 / 0;
/**
 * This method is like `_.flatMap` except that it recursively flattens the
 * mapped results.
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [[[n, n]]];
 * }
 *
 * _.flatMapDeep([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $c618ebe283af6d5e$var$flatMapDeep(collection, iteratee) {
    return $hKE3p($eo8NR(collection, iteratee), $c618ebe283af6d5e$var$INFINITY);
}
module.exports = $c618ebe283af6d5e$var$flatMapDeep;

});


parcelRegister("7Vbpp", function(module, exports) {

$parcel$export(module.exports, "emptyAdfObject", () => $e11eab7652408d68$export$202742e99f678c60);
$parcel$export(module.exports, "removeCollectionFromAdf", () => $e11eab7652408d68$export$9e9311e676291037);
$parcel$export(module.exports, "convertAdfStringToObject", () => $e11eab7652408d68$export$ee70d4eb14697455);
$parcel$export(module.exports, "isOnlyWhitespaceAdf", () => $e11eab7652408d68$export$cf4bde415465976c);
$parcel$export(module.exports, "removeNewLineCharactersFromAdf", () => $e11eab7652408d68$export$d6ce0667c33b94ff);
$parcel$export(module.exports, "removeTrailingNewLineCharacters", () => $e11eab7652408d68$export$3688e35a300432d6);
$parcel$export(module.exports, "simplifyAdf", () => $e11eab7652408d68$export$def86d25f0c7f0bc);
$parcel$export(module.exports, "hasMediaFileNodes", () => $e11eab7652408d68$export$9a632b58fb9b287c);
$parcel$export(module.exports, "hasMediaFileNodesUpdated", () => $e11eab7652408d68$export$80a6e90c7b29d88c);

var $6qhKX = parcelRequire("6qhKX");
var $hYZXM = parcelRequire("hYZXM");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");
const $e11eab7652408d68$export$202742e99f678c60 = {
    type: 'doc',
    version: 1,
    content: []
};
const $e11eab7652408d68$export$9e9311e676291037 = (adf)=>{
    if (adf === null || adf === undefined) return null;
    if (adf.type === 'media' && adf.attrs) return {
        ...adf,
        attrs: {
            ...adf.attrs,
            collection: ''
        }
    };
    if ((0, $1ybV0.ff)('issue.details.media-inline') && adf.type === 'mediaInline' && adf.attrs) return {
        ...adf,
        attrs: {
            ...adf.attrs,
            collection: ''
        }
    };
    if (adf.content) return {
        ...adf,
        content: adf.content.map($e11eab7652408d68$export$9e9311e676291037)
    };
    return adf;
};
const $e11eab7652408d68$export$ee70d4eb14697455 = (adf)=>{
    if (typeof adf === 'string') try {
        return $e11eab7652408d68$export$9e9311e676291037(JSON.parse(adf));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $gUUjF.default).safeErrorWithoutCustomerData('rich-content.convert-adf-to-object', 'Failed to parse rich content', error);
        return null;
    }
    return $e11eab7652408d68$export$9e9311e676291037(adf);
};
const $e11eab7652408d68$export$cf4bde415465976c = (adf)=>adf && adf.content ? adf.content.every((content)=>{
        if (content.type === 'paragraph') return !content.content || content.content.length === 0 || content.content.every((innerContent)=>innerContent.type === 'text' ? (innerContent.text || '').match(/^\s*$/) !== null : false);
        return false;
    }) : false;
const $e11eab7652408d68$export$d6ce0667c33b94ff = (adf)=>{
    if (!adf || !adf.content) return $e11eab7652408d68$export$202742e99f678c60;
    let len;
    for(len = adf.content.length - 1; len >= 0 && adf.content[len].content && adf.content[len].type === 'paragraph' && adf.content[len].content.length === 0; len -= 1){
        // if the last item of the node is of type mediaGroup, we don't want to strip newline character as
        // it practically makes it unclickable. Leave a new line character so there is still some space for ppl to click
        if (len > 0 && adf.content[len - 1].type === 'mediaGroup') break;
    }
    return {
        ...adf,
        content: adf.content.slice(0, len + 1)
    };
};
const $e11eab7652408d68$export$3688e35a300432d6 = (text)=>text.replace(/[\r\n]+$/, '');
const $e11eab7652408d68$export$def86d25f0c7f0bc = (adf)=>$e11eab7652408d68$export$cf4bde415465976c(adf) ? $e11eab7652408d68$export$202742e99f678c60 : adf;
const $e11eab7652408d68$export$9a632b58fb9b287c = (doc)=>{
    if ((0, $1ybV0.ff)('issue.details.media-inline')) {
        const mediaNodes = new Map();
        (0, $hYZXM.traverse)(doc, {
            media: (node)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const mediaNode = node;
                if (mediaNode.attrs.type === 'external') return;
                mediaNodes.set(mediaNode.attrs.id, node);
            },
            mediaInline: (node)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const mediaInlineNode = node;
                mediaNodes.set(mediaInlineNode.attrs.id, node);
            }
        });
        return mediaNodes.size > 0;
    }
    const mediaNodes = new Map();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $hYZXM.traverse)(doc, {
        media: (node)=>{
            if (!node.attrs.id || node.attrs.collection === undefined) return;
            mediaNodes.set(node.attrs.id, node);
        }
    });
    return mediaNodes.size > 0;
};
const $e11eab7652408d68$export$80a6e90c7b29d88c = (currentDoc, newDoc)=>{
    if ((0, $1ybV0.ff)('issue.details.media-inline')) {
        const currentMediaNodes = new Set();
        const newMediaNodes = new Set();
        const updatedMediaNodes = new Set();
        if (newDoc) (0, $hYZXM.traverse)(newDoc, {
            media: (node)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const mediaNode = node;
                if (mediaNode.attrs.type === 'external') return;
                newMediaNodes.add(mediaNode.attrs.id);
            },
            mediaInline: (node)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const mediaInlineNode = node;
                newMediaNodes.add(mediaInlineNode.attrs.id);
            }
        });
        if (currentDoc) (0, $hYZXM.traverse)(currentDoc, {
            media: (node)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const mediaNode = node;
                if (mediaNode.attrs.type === 'external') return;
                currentMediaNodes.add(mediaNode.attrs.id);
                if (newMediaNodes.size) {
                    const matchedNode = newMediaNodes.has(mediaNode.attrs.id);
                    if (!matchedNode) updatedMediaNodes.add(mediaNode.attrs.id);
                }
            },
            mediaInline: (node)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const mediaInlineNode = node;
                currentMediaNodes.add(mediaInlineNode.attrs.id);
                if (newMediaNodes.size) {
                    const matchedNode = newMediaNodes.has(mediaInlineNode.attrs.id);
                    if (!matchedNode) updatedMediaNodes.add(mediaInlineNode.attrs.id);
                }
            }
        });
        return currentMediaNodes.size !== newMediaNodes.size || !!updatedMediaNodes.size;
    }
    const currentMediaNodes = new Set();
    const newMediaNodes = new Set();
    const updatedMediaNodes = new Set();
    if (newDoc) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $hYZXM.traverse)(newDoc, {
        media: (node)=>{
            if (!node.attrs.id || node.attrs.collection === undefined) return;
            newMediaNodes.add(node.attrs.id);
        }
    });
    if (currentDoc) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $hYZXM.traverse)(currentDoc, {
        media: (node)=>{
            if (!node.attrs.id || node.attrs.collection === undefined) return;
            currentMediaNodes.add(node.attrs.id);
            if (newMediaNodes.size) {
                const matchedNode = newMediaNodes.has(node.attrs.id);
                if (!matchedNode) updatedMediaNodes.add(node.attrs.id);
            }
        }
    });
    return currentMediaNodes.size !== newMediaNodes.size || !!updatedMediaNodes.size;
};
const $e11eab7652408d68$export$ddf077301434502d = (doc)=>{
    if (doc === null || doc === undefined) return false;
    const nonSimpleTextNodes = (0, $6qhKX.filter)(doc, (node)=>node.type !== 'paragraph' && node.type !== 'doc' && node.type !== 'text');
    return nonSimpleTextNodes.length === 0;
};



const $e11eab7652408d68$export$2277e89f0b6d4ed = async (node)=>{
    // the imports here were kept async so as not to blow the bundle sizes for everyone
    const { defaultSchema: defaultSchema } = await Promise.resolve((parcelRequire("9wcjJ")));
    const { WikiMarkupTransformer: WikiMarkupTransformer } = await Promise.resolve((parcelRequire("fjUC0")));
    const { JSONTransformer: JSONTransformer } = await Promise.resolve((parcelRequire("3M3qX")));
    const jsonTransformer = new JSONTransformer();
    const wikiMarkupTransformer = new WikiMarkupTransformer(defaultSchema);
    if (node === null || node === undefined) return '';
    const pmNode = jsonTransformer.parse(node);
    return wikiMarkupTransformer.encode(pmNode);
};

});
parcelRegister("6qhKX", function(module, exports) {

$parcel$export(module.exports, "filter", () => $d1e7bd2dc2348b7c$export$3dea766d36a8935f);

var $hYZXM = parcelRequire("hYZXM");
function $d1e7bd2dc2348b7c$export$3dea766d36a8935f(adf, callback) {
    const result = [];
    (0, $hYZXM.traverse)(adf, {
        any: (node)=>{
            if (callback(node)) result.push(node);
        }
    });
    return result;
}

});




parcelRegister("3IsCV", function(module, exports) {

$parcel$export(module.exports, "useDescriptionAnalytics", () => $11a31d7bde9afe55$export$df0e1df705c71ad);

var $eUqFw = parcelRequire("eUqFw");

var $dNWQB = parcelRequire("dNWQB");
var $2gOs4 = parcelRequire("2gOs4");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
const $11a31d7bde9afe55$export$df0e1df705c71ad = ()=>{
    const { subscribe: subscribe } = (0, $2gOs4.useGICLifeCycleEvents)();
    const [hasSent, setHasSent] = (0, $eUqFw.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        const unsubscribeFromChange = subscribe((0, $dNWQB.GIC_LIFECYCLE_EVENTS).CREATE_FORM_FIELD_VALUE_CHANGE, (data)=>{
            if (!hasSent && data.fieldId === 'description') {
                const analyticsEvent = createAnalyticsEvent({
                    actionSubject: 'description',
                    action: 'editStarted'
                });
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'createIssueDescriptionTouched');
                setHasSent(true);
            }
        });
        const unsubscribeFromBlur = subscribe((0, $dNWQB.GIC_LIFECYCLE_EVENTS).CREATE_FORM_FIELD_BLUR, (data)=>{
            if (data.fieldId === 'description') setHasSent(false);
        });
        return ()=>{
            unsubscribeFromChange();
            unsubscribeFromBlur();
        };
    }, [
        createAnalyticsEvent,
        subscribe,
        hasSent,
        setHasSent
    ]);
};

});

parcelRegister("683RD", function(module, exports) {

$parcel$export(module.exports, "ActionsContainer", () => $580b6d2079ff6057$export$48377ae1c677702b);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4r5oC = parcelRequire("4r5oC");

var $fswni = parcelRequire("fswni");

var $gya0p = parcelRequire("gya0p");
parcelRequire("gya0p");
var $9Pqox = parcelRequire("9Pqox");

var $jMP2a = parcelRequire("jMP2a");

var $04KnN = parcelRequire("04KnN");

var $f9Boa = parcelRequire("f9Boa");


var $lm5nq = parcelRequire("lm5nq");

var $lptaG = parcelRequire("lptaG");

var $6duQa = parcelRequire("6duQa");
const $580b6d2079ff6057$export$48377ae1c677702b = (props)=>{
    const hasWatchersInitialized = (0, $eUqFw.useRef)(false);
    const [{ dataFetchError: dataFetchError, selectedProject: selectedProject }] = (0, $fswni.useFormContext)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { view: view, isTransitionInState: isTransitionInState, onClose: onClose } = (0, $gya0p.useMinimizableModal)();
    const { setDeferredNavigationLink: setDeferredNavigationLink } = (0, $04KnN.useNavigationDiscardChangesActions)();
    const { shouldShowX2CModal: shouldShowX2CModal, openModal: openModal, setProject: setProject } = (0, $f9Boa.useX2CModal)();
    (0, $eUqFw.useEffect)(()=>{
        if (selectedProject !== null) setProject((0, $f9Boa.transformSelectedProject)(selectedProject));
    }, [
        selectedProject,
        setProject
    ]);
    // Delete callback when cleaning up gic-remove-import-issues-button
    const onImportIssues = (e, analyticsEvent)=>{
        e.preventDefault();
        if (shouldShowX2CModal) {
            openModal();
            onClose && onClose(e, analyticsEvent);
        } else setDeferredNavigationLink((0, $b5f18941ecd44195$export$92614df4bfc0bfa8));
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'importIssues', {
            projectType: selectedProject ? (0, $4r5oC.transformProjectType)(selectedProject.projectType) : 'none'
        });
    };
    const shouldDisableActions = dataFetchError !== null;
    const shouldDisableHeaderDropdown = Boolean(shouldDisableActions || selectedProject === null);
    const shouldRenderActionsContainer = view === 'modal' && isTransitionInState([
        'mini'
    ], (0, $9Pqox.TransitionState).EXITED);
    if (!shouldRenderActionsContainer) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($580b6d2079ff6057$var$ActionsContainerWrapper, {
        "data-testid": "issue-create.ui.modal.create-form.actions-container.actions-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6duQa.default), {
        configs: props.watchersConfigurations,
        hasWatchersInitialized: hasWatchersInitialized
    }), (0, $1ybV0.ff)('gic-remove-import-issues-button') ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        href: (0, $b5f18941ecd44195$export$92614df4bfc0bfa8),
        testId: "issue-create.ui.modal.create-form.actions-container.import-issues-button",
        onClick: onImportIssues,
        isDisabled: shouldDisableActions,
        component: "button"
    }, formatMessage((0, $lptaG.default).importIssues)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $580b6d2079ff6057$var$dropdownContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lm5nq.HeaderDropdown), {
        isDisabled: shouldDisableHeaderDropdown,
        fieldConfig: props.fieldConfig
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $580b6d2079ff6057$var$ActionsContainerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _kqswh2mm _1pbykb7n",
            __cmplp.className
        ])
    });
});
const $580b6d2079ff6057$var$dropdownContainerStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.100'
});

});
const $b5f18941ecd44195$export$92614df4bfc0bfa8 = '/secure/BulkCreateSetupPage!default.jspa?externalSystem=com.atlassian.jira.plugins.jim-plugin%3AbulkCreateCsv';

parcelRegister("lm5nq", function(module, exports) {

$parcel$export(module.exports, "HeaderDropdown", () => $67cf66acb179f05d$export$e93b0271171ef3a);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $jG1wZ = parcelRequire("jG1wZ");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4r5oC = parcelRequire("4r5oC");

var $fswni = parcelRequire("fswni");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $c7H0g = parcelRequire("c7H0g");

var $bxXwH = parcelRequire("bxXwH");
const $67cf66acb179f05d$var$testId = 'issue-create.ui.modal.create-form.actions-container.dropdown-menu.dropdown-menu';
const $67cf66acb179f05d$var$buttonTestId = 'issue-create.ui.modal.create-form.actions-container.dropdown-menu.button';
const $67cf66acb179f05d$export$e93b0271171ef3a = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const { isDisabled: isDisabled = false } = props;
    const [{ selectedProject: selectedProject, selectedIssueType: selectedIssueType }, { toggleConfigureFieldsModalVisibility: toggleConfigureFieldsModalVisibility, toggleFindFieldsModalVisibility: toggleFindFieldsModalVisibility }] = (0, $fswni.useFormContext)();
    const showConfigureFieldsModal = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        toggleConfigureFieldsModalVisibility(true);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'configureFields', {
            projectType: selectedProject ? (0, $4r5oC.transformProjectType)(selectedProject.projectType) : 'none'
        });
    };
    const showFindFieldModal = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        toggleFindFieldsModalVisibility(true);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'findYourField', {
            projectType: selectedProject ? (0, $4r5oC.transformProjectType)(selectedProject.projectType) : 'none'
        });
    };
    const showFindFieldOption = ()=>Boolean(isAdmin && selectedProject && selectedIssueType && !selectedProject.isSimplified);
    // @ts-expect-error - TS7006 - Parameter 'attributes' implicitly has an 'any' type.
    const onOpenChange = (attributes)=>{
        if (attributes.isOpen) {
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'meatballMenu');
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        placement: "bottom-end",
        shouldRenderToParent: true,
        trigger: ({ triggerRef: triggerRef, ...dropdownProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...dropdownProps,
                testId: $67cf66acb179f05d$var$buttonTestId,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
                    label: ""
                }),
                appearance: "subtle",
                isDisabled: isDisabled,
                ref: triggerRef,
                "aria-label": formatMessage((0, $bxXwH.default).moreActions)
            }),
        onOpenChange: onOpenChange,
        testId: $67cf66acb179f05d$var$testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        onClick: showConfigureFieldsModal
    }, formatMessage((0, $bxXwH.default).showFields)), showFindFieldOption() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        onClick: showFindFieldModal
    }, formatMessage((0, $bxXwH.default).findField))));
};

});
parcelRegister("bxXwH", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b1b4bfba1d45029$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $1b1b4bfba1d45029$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    showFields: {
        "id": "issue-create.modal.create-form.actions-container.dropdown-menu.show-fields",
        "defaultMessage": "Show fields"
    },
    findField: {
        "id": "issue-create.modal.create-form.actions-container.dropdown-menu.find-field",
        "defaultMessage": "Find your field"
    },
    moreActions: {
        "id": "issue-create.modal.create-form.actions-container.dropdown-menu.more-actions",
        "defaultMessage": "More actions for this issue"
    }
});

});


parcelRegister("lptaG", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a97eb314a6d9d13$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7a97eb314a6d9d13$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    // Delete this when cleaning up gic-remove-import-issues-button
    importIssues: {
        "id": "issue-create.modal.create-form.actions-container.import-issues",
        "defaultMessage": "Import issues"
    }
});

});

parcelRegister("6duQa", function(module, exports) {

$parcel$export(module.exports, "default", () => $21a16fe4f0916082$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4Zh4h = parcelRequire("4Zh4h");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$21a16fe4f0916082$export$2e2bcd8739ae039 = (props)=>{
    if (!props.configs?.canManageWatchers) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Zh4h.default), props);
};

});
parcelRegister("4Zh4h", function(module, exports) {

$parcel$export(module.exports, "default", () => $eacf7b90502ba69b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kGQen = parcelRequire("kGQen");

var $7ZZxN = parcelRequire("7ZZxN");

var $fswni = parcelRequire("fswni");

var $5CGTf = parcelRequire("5CGTf");
var $h3CUr = parcelRequire("h3CUr");

var $cWiVr = parcelRequire("cWiVr");
const $eacf7b90502ba69b$var$Watchers = ({ configs: configs, hasWatchersInitialized: hasWatchersInitializedForNewModal })=>{
    const hasWatchersInitializedForOldModal = (0, $eUqFw.useRef)(false);
    /**
	 * For new modal, the modal can be minimized due to 3-stage-create, and if it is minimized the component
	 * is completely unmounted. un-minimizing the modal would lead to the default users being added again if
	 * they have remove themselves earlier. Which means keeping track of that only within this component is
	 * impossible, so that we have to declare the ref one level up which would not be unmounted on `modal-view-change`.
	 *
	 * For old modal tho, the `hasWatchersInitializedForNewModal` would be `undefined` because the old modal is rendered from
	 * a complete different place. And for old modal, having a ref within this component is more than enough.
	 */ const hasWatchersInitialized = hasWatchersInitializedForNewModal || hasWatchersInitializedForOldModal;
    const { isAutoWatchEnabled: isAutoWatchEnabled, isWatchersEnabled: isWatchersEnabled } = configs || {};
    const { data: { user: currentUser }, loading: loading, error: error } = (0, $cWiVr.useCurrentUser)(); // eslint-disable-line @typescript-eslint/consistent-type-assertions
    const [{ watchers: watchers, selectedProject: selectedProject }, { setWatchers: setWatchers }] = (0, $fswni.useFormContext)();
    const shouldShowWatchers = selectedProject && configs && !currentUser.isAnonymous && !loading && !error && // NOTE: JPD has no ability to manage watchers at the time of release, this is a workaround to prevent watchers being added for JPD.
    selectedProject.projectType !== (0, $7ZZxN.PRODUCT_DISCOVERY_PROJECT);
    const isWatching = watchers.some((watcher)=>watcher.accountId === currentUser.accountId);
    /**
	 * The current user is the default user in the list because isAutoWatchEnabled is turned on
	 * so the current user would be added to the list on init.
	 */ (0, $eUqFw.useEffect)(()=>{
        if (isAutoWatchEnabled && shouldShowWatchers && currentUser && !hasWatchersInitialized.current && !isWatching) {
            setWatchers([
                ...watchers,
                currentUser
            ]);
            hasWatchersInitialized.current = true;
        }
    }, [
        currentUser,
        shouldShowWatchers,
        isAutoWatchEnabled,
        setWatchers,
        watchers,
        isWatching,
        hasWatchersInitialized
    ]);
    if (!shouldShowWatchers) return null;
    if (!isWatchersEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5CGTf.default), {
        isDisabled: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h3CUr.default), {
        watchers: watchers,
        projectKey: selectedProject.projectKey,
        setWatchers: setWatchers,
        isWatching: isWatching,
        currentUser: currentUser,
        ...configs
    }));
};
var $eacf7b90502ba69b$export$2e2bcd8739ae039 = $eacf7b90502ba69b$var$Watchers;

});
parcelRegister("5CGTf", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fd34a3cf8207ac6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react-component-props

var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $jHMvH = parcelRequire("jHMvH");
const $6fd34a3cf8207ac6$var$BaseButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6fd34a3cf8207ac6$var$Container, {
        "data-testid": "issue-create-watchers.ui.watchers-trigger-button.base-button.root"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        ...props,
        appearance: "subtle",
        spacing: "default",
        ref: ref
    }, children || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6fd34a3cf8207ac6$var$ButtonContent, {
        "data-testid": "issue-create-watchers.ui.watchers-trigger-button.base-button.watch-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6fd34a3cf8207ac6$var$ButtonIcon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jHMvH))), {
        size: "medium",
        label: ""
    }))))));
var $6fd34a3cf8207ac6$export$2e2bcd8739ae039 = $6fd34a3cf8207ac6$var$BaseButton;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6fd34a3cf8207ac6$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bahesu3 _2hwxu2gc _hyh1otz2 _a7a01txw _18iz1h6o",
            __cmplp.className
        ])
    });
});
const $6fd34a3cf8207ac6$var$ButtonContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $6fd34a3cf8207ac6$var$ButtonIcon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("h3CUr", function(module, exports) {

$parcel$export(module.exports, "default", () => $420a7a96f296ff29$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $420a7a96f296ff29$var$AsyncWatchers = (0, $7rh0R.lazyAfterPaint)(()=>(parcelRequire("jnJPu")), {
    ssr: false,
    moduleId: "./src/packages/issue-create/issue-create-watchers/src/ui/main.tsx"
});
const $420a7a96f296ff29$var$Watchers = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "async.jira-issue-create-watchers",
        packageName: "jiraIssueCreateWatchers"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "issue-create-watchers-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($420a7a96f296ff29$var$AsyncWatchers, props)));
var $420a7a96f296ff29$export$2e2bcd8739ae039 = $420a7a96f296ff29$var$Watchers;

});
parcelRegister("jnJPu", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('hkKUo');
        const value = parcelRequire('bQfx4');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("hkKUo").then(()=>parcelRequire('bQfx4'));
}

});





parcelRegister("a7qpF", function(module, exports) {

$parcel$export(module.exports, "default", () => $d93e7881a85a3d9f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $asu8X = parcelRequire("asu8X");

var $5dpJB = parcelRequire("5dpJB");
var $c9awd = parcelRequire("c9awd");
var $6xBtK = parcelRequire("6xBtK");

var $1ybV0 = parcelRequire("1ybV0");

var $9zysr = parcelRequire("9zysr");

var $fswni = parcelRequire("fswni");

var $7q1yA = parcelRequire("7q1yA");

var $hFagV = parcelRequire("hFagV");

var $7uLmC = parcelRequire("7uLmC");

var $5WjjC = parcelRequire("5WjjC");

var $htrX0 = parcelRequire("htrX0");
const $d93e7881a85a3d9f$export$31d936b98297daf0 = (props)=>{
    // eslint-disable-next-line jira/react-magnetic-di/no-unneeded -- magnetic-di does not work automatically with ternary components. it needs to have the `di`
    (0, $asu8X.di)((0, $5WjjC.default), (0, $htrX0.FieldsContainer));
    const { fieldTabs: fieldTabs, fieldConfig: fieldConfig, getFormState: getFormState, setFieldValue: setFieldValue, apiLatency: apiLatency } = props;
    const isGICPositioningEnabled = (0, $hFagV.useIsGICPositioningEnabled)();
    // TODO Add this field with the fields on previous line when cleaning FF
    const fieldPropsExtensions = isGICPositioningEnabled() ? props.fieldPropsExtensions : undefined;
    const [{ currentActiveTabIndex: currentActiveTabIndex }, { setCurrentActiveTabIndex: setCurrentActiveTabIndex }] = (0, $fswni.useFormContext)();
    const { onFieldRendered: onFieldRendered } = !(0, $1ybV0.ff)('gic-remove-unused-fieldstorender-events_o3mhl') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $7uLmC.useRenderedFields)(fieldTabs) : {
        onFieldRendered: undefined
    };
    const tabs = fieldTabs.map(({ id: id, name: name })=>({
            label: name,
            content: null,
            key: id,
            testId: id
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onSelect = (_, selectedIndex)=>{
        setCurrentActiveTabIndex(selectedIndex);
    };
    const handleChange = (index)=>{
        onSelect(null, index);
    };
    if (!fieldTabs.length) return null;
    // TODO When cleaning gic-smart-fields-jira-labs_8uwvr, move FieldsContainer to inline instead of using ComponentToRender
    const ComponentToRender = (0, $1ybV0.ff)('gic-smart-fields-jira-labs_8uwvr') ? (0, $htrX0.FieldsContainer) : (0, $5WjjC.default);
    return fieldTabs.length === 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ComponentToRender, {
        fieldConfig: fieldConfig,
        fields: fieldTabs[0].items,
        ...(0, $1ybV0.ff)('gic-smart-fields-jira-labs_8uwvr') && {
            collapsedFields: fieldTabs[0].collapsedItems,
            FieldRenderer: $5WjjC.default,
            tabIndex: 0
        },
        apiLatency: apiLatency,
        getFormState: getFormState,
        setFieldValue: setFieldValue,
        fieldPropsExtensions: isGICPositioningEnabled() ? fieldPropsExtensions : undefined,
        onFieldRendered: onFieldRendered
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5dpJB.default), {
        testId: "issue-create.ui.modal.create-form.layout-renderer.layout-rerender-tabs",
        selected: currentActiveTabIndex,
        onChange: handleChange,
        id: "issue-create-modal-tabs",
        shouldUnmountTabPanelOnChange: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6xBtK.default), null, tabs.map((tab)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c9awd.default), {
            testId: tab.testId,
            key: tab.key
        }, tab.label)))), fieldTabs.map(({ id: id, items: items, collapsedItems: collapsedItems }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d93e7881a85a3d9f$var$Container, {
            key: id,
            isHidden: index !== currentActiveTabIndex
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ComponentToRender, {
            fieldConfig: fieldConfig,
            fields: items,
            ...(0, $1ybV0.ff)('gic-smart-fields-jira-labs_8uwvr') && {
                collapsedFields: collapsedItems,
                FieldRenderer: $5WjjC.default,
                tabIndex: index
            },
            getFormState: getFormState,
            setFieldValue: setFieldValue,
            apiLatency: apiLatency,
            fieldPropsExtensions: isGICPositioningEnabled() ? fieldPropsExtensions : undefined,
            onFieldRendered: onFieldRendered
        }))));
};
const $d93e7881a85a3d9f$export$d919d8b7913413b3 = (props)=>{
    // eslint-disable-next-line jira/react-magnetic-di/no-unneeded -- magnetic-di does not work automatically with ternary components. it needs to have the `di`
    (0, $asu8X.di)((0, $5WjjC.default), (0, $htrX0.FieldsContainer));
    const { fieldTabs: fieldTabs, fieldConfig: fieldConfig, getFormState: getFormState, setFieldValue: setFieldValue, apiLatency: apiLatency } = props;
    const isGICPositioningEnabled = (0, $hFagV.useIsGICPositioningEnabled)();
    // TODO Add this field with the fields on previous line when cleaning FF
    const fieldPropsExtensions = isGICPositioningEnabled() ? props.fieldPropsExtensions : undefined;
    const [{ currentActiveTabIndex: currentActiveTabIndex }, { setCurrentActiveTabIndex: setCurrentActiveTabIndex }] = (0, $fswni.useFormContext)();
    const { onFieldRendered: onFieldRendered } = !(0, $1ybV0.ff)('gic-remove-unused-fieldstorender-events_o3mhl') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $7uLmC.useRenderedFields)(fieldTabs) : {
        onFieldRendered: undefined
    };
    const tabs = (0, $eUqFw.useMemo)(()=>fieldTabs.map(({ id: id, name: name, items: items, collapsedItems: collapsedItems })=>({
                id: id,
                name: name,
                content: null,
                testId: id,
                items: items,
                collapsedItems: collapsedItems
            })), [
        fieldTabs
    ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onSelect = (_, selectedIndex)=>{
        setCurrentActiveTabIndex(selectedIndex);
    };
    const handleChange = (index)=>{
        onSelect(null, index);
    };
    const { controlledTabs: controlledTabs, controlledSelected: controlledSelected, controlledOnChange: controlledOnChange } = (0, $7q1yA.useUimScreenTabs)({
        formState: getFormState(),
        tabs: tabs,
        selected: currentActiveTabIndex,
        onChange: handleChange
    });
    (0, $eUqFw.useEffect)(()=>{
        if (typeof controlledSelected === 'number' && controlledSelected !== currentActiveTabIndex) setCurrentActiveTabIndex(controlledSelected);
    }, [
        controlledSelected,
        currentActiveTabIndex,
        setCurrentActiveTabIndex
    ]);
    if (!fieldTabs.length) return null;
    // TODO When cleaning gic-smart-fields-jira-labs_8uwvr, move FieldsContainer to inline instead of using ComponentToRender
    const ComponentToRender = (0, $1ybV0.ff)('gic-smart-fields-jira-labs_8uwvr') ? (0, $htrX0.FieldsContainer) : (0, $5WjjC.default);
    if (fieldTabs.length === 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ComponentToRender, {
        fieldConfig: fieldConfig,
        fields: fieldTabs[0].items,
        ...(0, $1ybV0.ff)('gic-smart-fields-jira-labs_8uwvr') && {
            collapsedFields: fieldTabs[0].collapsedItems,
            FieldRenderer: $5WjjC.default,
            tabIndex: 0
        },
        apiLatency: apiLatency,
        getFormState: getFormState,
        setFieldValue: setFieldValue,
        fieldPropsExtensions: isGICPositioningEnabled() ? fieldPropsExtensions : undefined,
        onFieldRendered: onFieldRendered
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5dpJB.default), {
        testId: "issue-create.ui.modal.create-form.layout-renderer.layout-rerender-tabs",
        selected: controlledSelected,
        onChange: controlledOnChange,
        id: "issue-create-modal-tabs",
        shouldUnmountTabPanelOnChange: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6xBtK.default), null, controlledTabs.map((tab)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d93e7881a85a3d9f$var$ConditionallyVisibleDiv, {
            key: tab.id,
            isVisible: tab.isVisible
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c9awd.default), {
            testId: tab.testId,
            key: tab.id
        }, tab.name))))), controlledTabs.map(({ id: id, items: items, collapsedItems: collapsedItems, testId: testId }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d93e7881a85a3d9f$var$ConditionallyVisibleDiv, {
            key: id,
            isVisible: index === controlledSelected,
            "data-testid": `tab-content-${testId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ComponentToRender, {
            fieldConfig: fieldConfig,
            fields: items,
            ...(0, $1ybV0.ff)('gic-smart-fields-jira-labs_8uwvr') && {
                collapsedFields: collapsedItems,
                FieldRenderer: $5WjjC.default,
                tabIndex: index
            },
            getFormState: getFormState,
            setFieldValue: setFieldValue,
            apiLatency: apiLatency,
            fieldPropsExtensions: isGICPositioningEnabled() ? fieldPropsExtensions : undefined,
            onFieldRendered: onFieldRendered
        }))));
};
const $d93e7881a85a3d9f$var$LayoutRenderer = (0, $9zysr.componentWithCondition)(()=>(0, $1ybV0.ff)('forge-ui-modifications-screentabs_qoa33'), $d93e7881a85a3d9f$export$d919d8b7913413b3, $d93e7881a85a3d9f$export$31d936b98297daf0);
var $d93e7881a85a3d9f$export$2e2bcd8739ae039 = $d93e7881a85a3d9f$var$LayoutRenderer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d93e7881a85a3d9f$var$ConditionallyVisibleDiv = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisible: isVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.isVisible ? "_1e0c1ule" : "_1e0cglyw",
            __cmplp.className
        ])
    });
});
const $d93e7881a85a3d9f$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isHidden: isHidden, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.isHidden ? "_1e0cglyw" : "_1e0c1ule",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5dpJB", function(module, exports) {

$parcel$export(module.exports, "default", () => $86fff1fa4f16d75d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lUFyV = parcelRequire("lUFyV");

var $hcuCm = parcelRequire("hcuCm");

var $9qnib = parcelRequire("9qnib");
function $86fff1fa4f16d75d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $86fff1fa4f16d75d$var$baseStyles = {
    name: "7i0hsw",
    styles: "display:flex;max-width:100%;min-height:0%;flex-basis:100%;flex-direction:column;flex-grow:1"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $86fff1fa4f16d75d$var$tabsStyles = (0, $9qnib.getTabsStyles)();
const $86fff1fa4f16d75d$var$analyticsAttributes = {
    componentName: 'tabs',
    packageName: undefined,
    packageVersion: undefined
};
const $86fff1fa4f16d75d$var$getTabPanelWithContext = ({ tabPanel: tabPanel, index: index, isSelected: isSelected, tabsId: tabsId })=>// Ensure tabPanel exists in case it has been removed
    tabPanel && /*#__PURE__*/ (0, $byn9U.jsx)((0, $hcuCm.TabPanelContext).Provider, {
        value: {
            role: 'tabpanel',
            id: `${tabsId}-${index}-tab`,
            hidden: isSelected ? undefined : true,
            'aria-labelledby': `${tabsId}-${index}`,
            tabIndex: isSelected ? 0 : -1
        },
        key: index
    }, tabPanel);
/**
 * __Tabs__
 *
 * Tabs acts as a container for all Tab components.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $86fff1fa4f16d75d$var$Tabs = (props)=>{
    const { shouldUnmountTabPanelOnChange: shouldUnmountTabPanelOnChange = false, selected: SelectedType, defaultSelected: defaultSelected, onChange: onChangeProp, id: id, analyticsContext: analyticsContext, children: children, testId: testId } = props;
    const [selectedState, setSelected] = (0, $eUqFw.useState)(SelectedType || defaultSelected || 0);
    const selected = SelectedType === undefined ? selectedState : SelectedType;
    const childrenArray = (0, $eUqFw.Children).toArray(children)// Don't include any conditional children
    .filter((child)=>Boolean(child));
    // First child should be a tabList followed by tab panels
    const [tabList, ...tabPanels] = childrenArray;
    // Keep track of visited and add to a set
    const visited = (0, $eUqFw.useRef)(new Set([
        selected
    ]));
    if (!visited.current.has(selected)) visited.current.add(selected);
    const onChange = (0, $eUqFw.useCallback)((index, analyticsEvent)=>{
        if (onChangeProp) onChangeProp(index, analyticsEvent);
        setSelected(index);
    }, [
        onChangeProp
    ]);
    const onChangeAnalytics = (0, $lUFyV.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$86fff1fa4f16d75d$var$analyticsAttributes
    });
    const tabPanelsWithContext = shouldUnmountTabPanelOnChange ? $86fff1fa4f16d75d$var$getTabPanelWithContext({
        tabPanel: tabPanels[selected],
        index: selected,
        isSelected: true,
        tabsId: id
    }) : // If a panel has already been visited, don't unmount it
    Array.from(visited.current).map((tabIndex)=>$86fff1fa4f16d75d$var$getTabPanelWithContext({
            tabPanel: tabPanels[tabIndex],
            index: tabIndex,
            isSelected: tabIndex === selected,
            tabsId: id
        }));
    return(// Only styles that affect the Tabs container itself have been applied via primitives.
    // The other styles applied through the CSS prop are there for styling children
    // through inheritance. This is important for custom cases that use the useTabPanel(),
    // which applies accessibility attributes that we use as a styling hook.
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: [
            $86fff1fa4f16d75d$var$baseStyles,
            $86fff1fa4f16d75d$var$tabsStyles
        ]
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $hcuCm.TabListContext).Provider, {
        value: {
            selected: selected,
            onChange: onChangeAnalytics,
            tabsId: id
        }
    }, tabList), /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, tabPanelsWithContext)));
};
var $86fff1fa4f16d75d$export$2e2bcd8739ae039 = $86fff1fa4f16d75d$var$Tabs;

});
parcelRegister("hcuCm", function(module, exports) {

$parcel$export(module.exports, "TabContext", () => $3a21d9894028b7fb$export$5a5d356ca5f10a0a);
$parcel$export(module.exports, "TabListContext", () => $3a21d9894028b7fb$export$aa6907f9fd69e93b);
$parcel$export(module.exports, "TabPanelContext", () => $3a21d9894028b7fb$export$2054129d247c3102);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $eUqFw = parcelRequire("eUqFw");
const $3a21d9894028b7fb$export$5a5d356ca5f10a0a = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $3a21d9894028b7fb$export$aa6907f9fd69e93b = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $3a21d9894028b7fb$export$2054129d247c3102 = /*#__PURE__*/ (0, $eUqFw.createContext)(null);

});

parcelRegister("9qnib", function(module, exports) {

$parcel$export(module.exports, "getTabsStyles", () => $f50084288d7b85a1$export$dd5afd2190fb792c);
$parcel$export(module.exports, "getTabListStyles", () => $f50084288d7b85a1$export$42a3c683c377bcb2);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $4xRua = parcelRequire("4xRua");
const $f50084288d7b85a1$var$tabInlinePadding = "var(--ds-space-100, 8px)";
const $f50084288d7b85a1$var$tabBlockPadding = "var(--ds-space-075, 6px)";
const $f50084288d7b85a1$var$tabInlineMargin = "var(--ds-space-negative-100, -8px)";
// TODO this should probably be `border.width.indicator`
const $f50084288d7b85a1$var$underlineHeight = "var(--ds-border-width-outline, 2px)";
const $f50084288d7b85a1$var$getTabPanelStyles = ()=>({
        flexGrow: 1,
        /*
     NOTE min-height set to 0% because of Firefox bug
     FF http://stackoverflow.com/questions/28636832/firefox-overflow-y-not-working-with-nested-flexbox
   */ minHeight: '0%',
        display: 'flex'
    });
const $f50084288d7b85a1$export$dd5afd2190fb792c = ()=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        '& [role="tabpanel"]': $f50084288d7b85a1$var$getTabPanelStyles(),
        // The hidden attribute doesn't work on flex elements
        // Change display to be none
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > [hidden]': {
            display: 'none'
        }
    });
const $f50084288d7b85a1$var$tabLineStyles = {
    content: '""',
    borderRadius: "var(--ds-border-radius-050, 2px)",
    bottom: 0,
    margin: 0,
    position: 'absolute',
    width: 'inherit',
    insetInlineStart: $f50084288d7b85a1$var$tabInlinePadding,
    insetInlineEnd: 0
};
const $f50084288d7b85a1$export$42a3c683c377bcb2 = ()=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        '& [role="tab"]': $f50084288d7b85a1$export$916c8b0fccbb37d2(),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        marginInlineStart: $f50084288d7b85a1$var$tabInlineMargin,
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            ...$f50084288d7b85a1$var$tabLineStyles,
            height: $f50084288d7b85a1$var$underlineHeight,
            // This line is not a border so the selected line is visible in high contrast mode
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $4xRua.tabLineColors).lineColor
        }
    });
const $f50084288d7b85a1$export$916c8b0fccbb37d2 = ()=>{
    const colors = (0, $4xRua.tabColors);
    return {
        color: colors.labelColor,
        cursor: 'pointer',
        margin: 0,
        padding: `${$f50084288d7b85a1$var$tabBlockPadding} ${$f50084288d7b85a1$var$tabInlinePadding}`,
        position: 'relative',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '&:hover': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.hoverLabelColor,
            '&::after': {
                ...$f50084288d7b85a1$var$tabLineStyles,
                insetInlineEnd: $f50084288d7b85a1$var$tabInlinePadding,
                borderBottom: `${$f50084288d7b85a1$var$underlineHeight} solid ${(0, $4xRua.tabLineColors).hoveredColor}`,
                height: 0
            }
        },
        '&:active': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.activeLabelColor,
            '&::after': {
                ...$f50084288d7b85a1$var$tabLineStyles,
                insetInlineEnd: $f50084288d7b85a1$var$tabInlinePadding,
                borderBottom: `${$f50084288d7b85a1$var$underlineHeight} solid ${(0, $4xRua.tabLineColors).activeColor}`,
                height: 0
            }
        },
        '&[aria-selected="true"]': {
            color: colors.selectedColor,
            '&::after': {
                ...$f50084288d7b85a1$var$tabLineStyles,
                insetInlineEnd: $f50084288d7b85a1$var$tabInlinePadding,
                // This line is a border so it is visible in high contrast mode
                borderBottom: `${$f50084288d7b85a1$var$underlineHeight} solid ${(0, $4xRua.tabLineColors).selectedColor}`,
                height: 0
            }
        }
    };
};

});
parcelRegister("4xRua", function(module, exports) {

$parcel$export(module.exports, "tabColors", () => $d893d977d51d4780$export$5159a1ad8efe50bc);
$parcel$export(module.exports, "tabLineColors", () => $d893d977d51d4780$export$6be6fa4649b31472);

var $PdmhA = parcelRequire("PdmhA");
const $d893d977d51d4780$export$5159a1ad8efe50bc = {
    labelColor: `var(--ds-text-subtle, ${(0, $PdmhA.N500)})`,
    activeLabelColor: `var(--ds-text, ${(0, $PdmhA.B500)})`,
    hoverLabelColor: `var(--ds-text-subtle, ${(0, $PdmhA.B400)})`,
    selectedColor: `var(--ds-text-selected, ${(0, $PdmhA.B400)})`,
    focusBorderColor: `var(--ds-border-focused, ${(0, $PdmhA.B100)})`
};
const $d893d977d51d4780$export$6be6fa4649b31472 = {
    lineColor: `var(--ds-border, ${(0, $PdmhA.N30)})`,
    hoveredColor: "var(--ds-border, transparent)",
    activeColor: "var(--ds-border, transparent)",
    selectedColor: `var(--ds-border-selected, ${(0, $PdmhA.B400)})`
};

});



parcelRegister("c9awd", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d17b011d788c2ed$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $51sCz = parcelRequire("51sCz");

var $1Yimi = parcelRequire("1Yimi");

var $kgCsd = parcelRequire("kgCsd");
function $4d17b011d788c2ed$export$2e2bcd8739ae039({ children: children, testId: testId }) {
    const { onClick: onClick, id: id, 'aria-controls': ariaControls, 'aria-posinset': ariaPosinset, 'aria-selected': ariaSelected, 'aria-setsize': ariaSetsize, onKeyDown: onKeyDown, role: role, tabIndex: tabIndex } = (0, $kgCsd.useTab)();
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $51sCz.default), {
        isInset: true
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        onClick: onClick,
        id: id,
        "aria-controls": ariaControls,
        "aria-posinset": ariaPosinset,
        "aria-selected": ariaSelected,
        "aria-setsize": ariaSetsize,
        onKeyDown: onKeyDown,
        role: role,
        tabIndex: tabIndex
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $1Yimi.default), {
        weight: "medium",
        color: "inherit",
        maxLines: 1
    }, children)));
}

});
parcelRegister("kgCsd", function(module, exports) {

$parcel$export(module.exports, "useTab", () => $87f26a44f88daafa$export$fdf4756d5b8ef90a);
$parcel$export(module.exports, "useTabList", () => $87f26a44f88daafa$export$773e389e644c5874);
$parcel$export(module.exports, "useTabPanel", () => $87f26a44f88daafa$export$fae0121b5afe572d);

var $eUqFw = parcelRequire("eUqFw");

var $hcuCm = parcelRequire("hcuCm");
const $87f26a44f88daafa$export$fdf4756d5b8ef90a = ()=>{
    const tabData = (0, $eUqFw.useContext)((0, $hcuCm.TabContext));
    if (tabData == null || typeof tabData === 'undefined') throw Error('@atlaskit/tabs: A Tab must have a TabList parent.');
    return tabData;
};
const $87f26a44f88daafa$export$773e389e644c5874 = ()=>{
    const tabListData = (0, $eUqFw.useContext)((0, $hcuCm.TabListContext));
    if (tabListData === null || typeof tabListData === 'undefined') throw Error('@atlaskit/tabs: A TabList must have a Tabs parent.');
    return tabListData;
};
const $87f26a44f88daafa$export$fae0121b5afe572d = ()=>{
    const tabPanelData = (0, $eUqFw.useContext)((0, $hcuCm.TabPanelContext));
    if (tabPanelData === null || typeof tabPanelData === 'undefined') throw Error('@atlaskit/tabs:  A TabPanel must have a Tabs parent.');
    return tabPanelData;
};

});


parcelRegister("6xBtK", function(module, exports) {

$parcel$export(module.exports, "default", () => $b552637a2f5925a8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $kgCsd = parcelRequire("kgCsd");

var $hcuCm = parcelRequire("hcuCm");

var $9qnib = parcelRequire("9qnib");
function $b552637a2f5925a8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b552637a2f5925a8$var$baseStyles = {
    name: "g0wsdz",
    styles: "display:flex;padding:var(--ds-space-0, 0px);position:relative"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $b552637a2f5925a8$var$tabListStyles = (0, $9qnib.getTabListStyles)();
/**
 * __TabList__
 *
 * A TabList groups `Tab` components together.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $b552637a2f5925a8$var$TabList = ({ children: children })=>{
    const { tabsId: tabsId, selected: selected, onChange: onChange } = (0, $kgCsd.useTabList)();
    const ref = /*#__PURE__*/ (0, $eUqFw.createRef)();
    // Don't include any conditional children
    const childrenArray = (0, $eUqFw.Children).toArray(children).filter(Boolean);
    const length = childrenArray.length;
    const selectTabByIndex = (0, $eUqFw.useCallback)((index)=>{
        const newSelectedNode = ref.current?.querySelector(`[id='${tabsId}-${index}']`);
        if (newSelectedNode) newSelectedNode.focus();
        onChange(index);
    }, [
        tabsId,
        ref,
        onChange
    ]);
    const onKeyDown = (0, $eUqFw.useCallback)((e)=>{
        if (![
            'ArrowRight',
            'ArrowLeft',
            'Home',
            'End'
        ].includes(e.key)) return;
        // preventing horizontal or vertical scroll
        e.preventDefault();
        const lastTabIndex = length - 1;
        if ([
            'Home',
            'End'
        ].includes(e.key)) {
            const newSelected = e.key === 'Home' ? 0 : lastTabIndex;
            selectTabByIndex(newSelected);
            return;
        }
        // We use aria-posinset so we don't rely on the selected variable
        // If we used the selected variable this would regenerate each time
        // and create an unstable reference
        const selectedIndex = parseInt(e.currentTarget.getAttribute('aria-posinset') || '0') - 1;
        const modifier = e.key === 'ArrowRight' ? 1 : -1;
        let newSelected = selectedIndex + modifier;
        if (newSelected < 0 || newSelected >= length) // Cycling focus to move from last to first and from first to last
        newSelected = newSelected < 0 ? lastTabIndex : 0;
        selectTabByIndex(newSelected);
    }, [
        length,
        selectTabByIndex
    ]);
    // Memoized so the function isn't recreated each time
    const getTabWithContext = (0, $eUqFw.useCallback)(({ tab: tab, isSelected: isSelected, index: index })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $hcuCm.TabContext).Provider, {
            value: {
                onClick: ()=>onChange(index),
                onKeyDown: onKeyDown,
                'aria-setsize': length,
                role: 'tab',
                id: `${tabsId}-${index}`,
                'aria-posinset': index + 1,
                'aria-selected': isSelected,
                'aria-controls': `${tabsId}-${index}-tab`,
                tabIndex: isSelected ? 0 : -1
            },
            key: index
        }, tab), [
        length,
        onKeyDown,
        onChange,
        tabsId
    ]);
    return(// Only styles that affect the TabList itself have been applied via primitives.
    // The other styles applied through the CSS prop are there for styling children
    // through inheritance. This is important for custom cases that use the useTab(),
    // which applies accessibility atributes that we use as a styling hook.
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "tablist",
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: [
            $b552637a2f5925a8$var$baseStyles,
            $b552637a2f5925a8$var$tabListStyles
        ]
    }, childrenArray.map((child, index)=>getTabWithContext({
            tab: child,
            index: index,
            isSelected: index === selected
        }))));
};
var $b552637a2f5925a8$export$2e2bcd8739ae039 = $b552637a2f5925a8$var$TabList;

});

parcelRegister("7q1yA", function(module, exports) {

$parcel$export(module.exports, "useUimScreenTabs", () => $36635bdf003af4af$export$d3f6e8d2ae2516f1);

var $eUqFw = parcelRequire("eUqFw");

var $fcNlw = parcelRequire("fcNlw");
var $ig7wC = parcelRequire("ig7wC");
var $elOAM = parcelRequire("elOAM");
const $36635bdf003af4af$export$d3f6e8d2ae2516f1 = ({ formState: formState, tabs: tabs, selected: selected, onChange: onChange })=>{
    const adjustmentsAreEnabled = (0, $ig7wC.useAdjustmentsEnabled)();
    const [adjustedScreenTabs, { initializeScreenTabs: initializeScreenTabs, updateActiveScreenTab: updateActiveScreenTab }] = (0, $fcNlw.useAdjustedScreenTabs)();
    const [triggerFieldInitializationKey] = (0, $elOAM.useTriggerFieldInitialization)();
    const selectedRef = (0, $eUqFw.useRef)(selected);
    // Always refreshes `selectedRef` value using `selected` prop value
    selectedRef.current = selected;
    // Initialize screen tabs (or re-initialize when deps change) in UIM store
    (0, $eUqFw.useEffect)(()=>{
        if (adjustmentsAreEnabled) {
            if (tabs.length === 1) // receiving single tab means there's no screen tab visible on view
            initializeScreenTabs({
                tabs: [],
                selected: 0
            });
            else // receiving undefined selected props means we whould default to the first tab
            initializeScreenTabs({
                tabs: tabs,
                selected: selectedRef.current ?? 0
            });
        }
    /**
		 * Because of how the GIC works between subsequent modal openings, UI modifications state is persisted.
		 * That's why want to run initializeScreenTabs when triggerFieldInitializationKey changes.
		 */ }, [
        adjustmentsAreEnabled,
        initializeScreenTabs,
        tabs,
        triggerFieldInitializationKey
    ]);
    // Controlled tabs are synced with UIM store
    const controlledTabs = (0, $eUqFw.useMemo)(()=>{
        if (adjustmentsAreEnabled && Array.isArray(adjustedScreenTabs)) {
            const adjustedVisibilityMap = {};
            for (const adjustedScreenTab of adjustedScreenTabs)adjustedVisibilityMap[adjustedScreenTab.id] = adjustedScreenTab.isVisible;
            return tabs.map((inputTab)=>({
                    ...inputTab,
                    // isVisible is determined by the UIM store, but if not, default to true
                    isVisible: adjustedVisibilityMap[inputTab.id] ?? true
                }));
        }
        // default all tabs to be visible
        return tabs.map((inputTab)=>({
                ...inputTab,
                isVisible: true
            }));
    }, [
        adjustmentsAreEnabled,
        adjustedScreenTabs,
        tabs
    ]);
    // Controlled selected is synced with UIM store unless there are errors to fix on the form
    const controlledSelected = (0, $eUqFw.useMemo)(()=>{
        const shouldHighlightFormError = formState.hasValidationErrors && formState.submitFailed;
        if (!adjustmentsAreEnabled || !Array.isArray(adjustedScreenTabs) || shouldHighlightFormError) return selected;
        const activeAdjustedTab = adjustedScreenTabs.find((tab)=>tab.isActive);
        if (activeAdjustedTab) return tabs.findIndex((tab)=>tab.id === activeAdjustedTab.id);
    }, [
        adjustmentsAreEnabled,
        adjustedScreenTabs,
        formState,
        tabs,
        selected
    ]);
    // Controlled onChange is propagating user changing tabs to the UIM store
    const controlledOnChange = (0, $eUqFw.useCallback)((...args)=>{
        const [userNewSelected] = args;
        if (adjustmentsAreEnabled) updateActiveScreenTab({
            selected: userNewSelected
        });
        onChange?.(...args);
    }, [
        adjustmentsAreEnabled,
        onChange,
        updateActiveScreenTab
    ]);
    return {
        controlledTabs: controlledTabs,
        controlledSelected: controlledSelected,
        controlledOnChange: controlledOnChange
    };
};

});
parcelRegister("elOAM", function(module, exports) {

$parcel$export(module.exports, "useTriggerFieldInitialization", () => $a837e1452cb7c8e1$export$1c69013aaf9112f0);

var $ggKAj = parcelRequire("ggKAj");

var $fcNlw = parcelRequire("fcNlw");
const $a837e1452cb7c8e1$var$selectTriggerFieldInitializationKey = (state)=>state.triggerFieldInitializationKey;
const $a837e1452cb7c8e1$export$1c69013aaf9112f0 = (0, $ggKAj.createHook)((0, $fcNlw.store), {
    selector: $a837e1452cb7c8e1$var$selectTriggerFieldInitializationKey
});

});


parcelRegister("7uLmC", function(module, exports) {

$parcel$export(module.exports, "useRenderedFields", () => $cdbcf3581a8efb85$export$fec5749d9635c3da);
$parcel$export(module.exports, "MarkFieldAsRendered", () => $cdbcf3581a8efb85$export$74c98e1398c4fb2a);
// TODO Delete the entire render-fields-analytics-old folder when cleaning gic-remove-unused-fieldstorender-events_o3mhl

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");

var $ctR9z = parcelRequire("ctR9z");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $hBkQt = parcelRequire("hBkQt");
const $cdbcf3581a8efb85$export$fec5749d9635c3da = (fieldTabs)=>{
    const [{ isModalOpen: isModalOpen }] = (0, $ctR9z.useTriggerIssueCreateModal)();
    const fieldsRendered = (0, $eUqFw.useRef)([]);
    const fieldUnmounted = (0, $eUqFw.useRef)(false);
    const allFields = (0, $eUqFw.useMemo)(()=>fieldTabs.flatMap((tab)=>tab.items), [
        fieldTabs
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, $jMP2a.fireTrackAnalyticsDeferred)(analyticsEvent, 'gic fieldsToRender', {
            fields: allFields
        });
    }, [
        allFields,
        createAnalyticsEvent
    ]);
    const checkIfAllFieldsRendered = (0, $eUqFw.useCallback)(()=>{
        const flattenedFields = fieldsRendered.current.flat();
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(flattenedFields.sort(), allFields.sort())) {
            fieldUnmounted.current = false;
            const analyticsEvent = createAnalyticsEvent({});
            (0, $jMP2a.fireTrackAnalyticsDeferred)(analyticsEvent, 'gic fieldsRendered', {
                fields: allFields
            });
            // The last call to `mark` is the time used in the final metric
            // We use this fact to obtain when the final field was mounted
            (0, $hBkQt.globalIssueCreateTTIWithAdjustments).mark('gic-all-fields-rendered');
        }
    }, [
        allFields,
        createAnalyticsEvent
    ]);
    const onFieldRendered = (0, $eUqFw.useCallback)((fieldId)=>{
        const mountedField = [
            fieldId
        ];
        fieldsRendered.current.push(mountedField);
        checkIfAllFieldsRendered();
        return ()=>{
            fieldsRendered.current = fieldsRendered.current.filter((currentField)=>mountedField !== currentField);
            if (!fieldUnmounted.current && isModalOpen) {
                fieldUnmounted.current = true;
                const analyticsEvent = createAnalyticsEvent({});
                (0, $jMP2a.fireTrackAnalyticsDeferred)(analyticsEvent, 'gic fieldUnmounted', {
                    field: fieldId
                });
            }
        };
    }, [
        checkIfAllFieldsRendered,
        createAnalyticsEvent,
        isModalOpen
    ]);
    return {
        onFieldRendered: onFieldRendered
    };
};
const $cdbcf3581a8efb85$export$74c98e1398c4fb2a = ({ onFieldRendered: onFieldRendered, fieldId: fieldId })=>{
    (0, $eUqFw.useEffect)(()=>{
        const unmount = onFieldRendered(fieldId);
        return unmount;
    }, [
        onFieldRendered,
        fieldId
    ]);
    return null;
};

});

parcelRegister("5WjjC", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee206569d1cf266a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $illlw = parcelRequire("illlw");

var $hompL = parcelRequire("hompL");

var $0cdA8 = parcelRequire("0cdA8");

var $1ybV0 = parcelRequire("1ybV0");

var $eTZsp = parcelRequire("eTZsp");

var $5JgJ2 = parcelRequire("5JgJ2");
parcelRequire("fryuC");
var $aBj0i = parcelRequire("aBj0i");

var $fqKjL = parcelRequire("fqKjL");

var $5VJL3 = parcelRequire("5VJL3");

var $fswni = parcelRequire("fswni");

var $ctR9z = parcelRequire("ctR9z");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $hBkQt = parcelRequire("hBkQt");

var $bKI0B = parcelRequire("bKI0B");

var $418AI = parcelRequire("418AI");

var $3WQZN = parcelRequire("3WQZN");

var $lG4nv = parcelRequire("lG4nv");


var $gnD2V = parcelRequire("gnD2V");

var $aqi5n = parcelRequire("aqi5n");

var $hFagV = parcelRequire("hFagV");

var $7uLmC = parcelRequire("7uLmC");

var $4EOWx = parcelRequire("4EOWx");

var $eiR7Y = parcelRequire("eiR7Y");

var $699UQ = parcelRequire("699UQ");
const $ee206569d1cf266a$var$useMemoizedGetFormState = (getFormState)=>{
    const ref = (0, $eUqFw.useRef)(getFormState); // Initialise with getFormState
    (0, $eUqFw.useMemo)(()=>{
        // If there's a valid value already, we keep using it. We can assume that getFormState doesn't get stale since it is a function which returns state
        if (ref.current) return;
         // Use new value if previous ref.current is not valid
        ref.current = getFormState;
    }, [
        getFormState
    ]);
    return ref.current;
};
const $ee206569d1cf266a$export$90edc2cad754ca2e = (props)=>{
    const { onFieldMount: onFieldMount, onKeyDown: onKeyDown, fieldId: fieldId, componentProps: componentProps, Component: Component, apiLatency: apiLatency, isSubsequentLoad: isSubsequentLoad, issueAdjustmentModules: issueAdjustmentModules, wasStateRestored: wasStateRestored } = props;
    const [, { setIsFormLoaded: setIsFormLoaded }] = (0, $fswni.useFormContext)();
    const isMountEventFired = (0, $eUqFw.useRef)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (isMountEventFired.current === false) {
            isMountEventFired.current = true;
            if ('requestIdleCallback' in window) window.requestIdleCallback(()=>onFieldMount(fieldId), {
                timeout: 50
            });
            else setTimeout(()=>{
                onFieldMount(fieldId);
            }, 50);
        }
    }, [
        onFieldMount,
        fieldId
    ]);
    const onLayoutDone = (0, $eUqFw.useCallback)(()=>{
        const globalIssueCreateModalLoadMetric = isSubsequentLoad ? (0, $fqKjL.globalIssueCreateModalLoadSubsequent) : (0, $fqKjL.globalIssueCreateModalLoad); // @ts-expect-error - TS2445 - Property 'state' is protected and only accessible within class 'BaseMetric' and its subclasses.
        if (globalIssueCreateModalLoadMetric.state === 'started') {
            const stopTime = Math.floor(performance.now());
            const customData = {
                apiLatency: apiLatency,
                featureFlags: Object.fromEntries((0, $3WQZN.allFeatureFlagsAccessed)),
                // TODO: Need to understand & update logic code to fix this issue, e.g. checking null and return a default value
                // @ts-expect-error - TS2531 - Object is possibly 'null'. | TS2445 - Property 'startTime' is protected and only accessible within class 'BaseMetric' and its subclasses.
                tti: Math.floor(stopTime - globalIssueCreateModalLoadMetric.startTime),
                isFirstTime: !isSubsequentLoad,
                wasStateRestored: wasStateRestored
            };
            globalIssueCreateModalLoadMetric.stop({
                customData: // @ts-expect-error - TS2322 - Type '{ apiLatency: number | null; tti: number; isFirstTime: boolean; }' is not assignable to type 'CustomValues'.
                customData
            });
            (0, $hBkQt.markGicTti)();
        }
        if ((0, $1ybV0.ff)('gic-modal-js-error-boundary-post-load-errors_qh9ev')) setIsFormLoaded(true);
    }, [
        apiLatency,
        isSubsequentLoad,
        setIsFormLoaded,
        wasStateRestored
    ]);
    const extendedComponentProps = {
        ...componentProps,
        onLayoutDone: onLayoutDone
    };
    if ((0, $1ybV0.ff)('parent-field-changeboarding_4ljdy')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ee206569d1cf266a$var$FieldContainer, {
        onKeyDown: onKeyDown,
        key: fieldId,
        id: `${fieldId}-container`,
        "data-testid": `issue-create.ui.modal.create-form.layout-renderer.field-renderer.field.${fieldId}`
    }, issueAdjustmentModules.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "globalIssueCreateIssueAdjustmentsAdapter" // eslint-disable-next-line jira/js/package-name-enforcer-for-error-boundary
        ,
        packageName: "issueCreateModal",
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aBj0i.IssueAdjustmentsErrorHandler), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, extendedComponentProps)),
        sendToPrivacyUnsafeSplunk: true,
        attributes: (error)=>({
                errorType: (0, $eTZsp.getErrorType)(error),
                viewType: (0, $bKI0B.GIC_VIEW_TYPE),
                fieldType: extendedComponentProps.fieldType,
                fieldId: fieldId
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $418AI.FieldDecoratorAsync), {
        Component: Component,
        componentProps: extendedComponentProps
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, extendedComponentProps));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ee206569d1cf266a$var$FieldContainerOld, {
        onKeyDown: onKeyDown,
        key: fieldId,
        id: `${fieldId}-container`,
        "data-testid": `issue-create.ui.modal.create-form.layout-renderer.field-renderer.field.${fieldId}`
    }, issueAdjustmentModules.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "globalIssueCreateIssueAdjustmentsAdapter" // eslint-disable-next-line jira/js/package-name-enforcer-for-error-boundary
        ,
        packageName: "issueCreateModal",
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aBj0i.IssueAdjustmentsErrorHandler), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, extendedComponentProps)),
        sendToPrivacyUnsafeSplunk: true,
        attributes: (error)=>({
                errorType: (0, $eTZsp.getErrorType)(error),
                viewType: (0, $bKI0B.GIC_VIEW_TYPE),
                fieldType: extendedComponentProps.fieldType,
                fieldId: fieldId
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $418AI.FieldDecoratorAsync), {
        Component: Component,
        componentProps: extendedComponentProps
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, extendedComponentProps));
};
const $ee206569d1cf266a$var$renderedAllFieldsFFOff = {
    current: false
};
const $ee206569d1cf266a$var$FieldRendererBase = (props)=>{
    const isGICPositioningEnabled = (0, $hFagV.useIsGICPositioningEnabled)();
    const [{ isSubTaskCreationOpen: isSubTaskCreationOpen, isCreateLinkedIssue: isCreateLinkedIssue, isSubsequentLoad: isSubsequentLoad, minimizableModalView: minimizableModalView, wasStateRestored: wasStateRestored, isMiniDesignEnabled: isMiniDesignEnabled, FieldWrapperComponent: FieldWrapperComponent, isModalOpen: isModalOpen }] = (0, $ctR9z.useTriggerIssueCreateModal)();
    const { fieldConfig: fieldConfig, fields: fields, getFormState: getFormState, apiLatency: apiLatency, setFieldValue: setFieldValue, isCollapsed: isCollapsed, isFieldResponsive: isFieldResponsive, onFieldRendered: onFieldRendered } = props; // TODO Add this field with the fields on previous line when cleaning FF
    const fieldPropsExtensions = isGICPositioningEnabled() ? props.fieldPropsExtensions : undefined;
    const [{ selectedProject: selectedProject, selectedIssueType: selectedIssueType, shouldAutoFocus: shouldAutoFocus, ecosystem: { forge: { customFields: customFields, filteredOutModules: filteredOutModules, issueAdjustmentModules: issueAdjustmentModules, hasFinishedLoading: hasFinishedLoading } }, currentActiveTabIndex: currentActiveTabIndex }, { openTempSwitchModal: openTempSwitchModal, setIsOperationInProgress: setIsOperationInProgress }] = (0, $fswni.useFormContext)();
    const renderAllFieldsInTabStartTime = (0, $eUqFw.useRef)(0); // Start by rendering the first field alone to give the user some visual feedback quickly
    // should be increased to a full "batch" of ~10 fields when field rendering performance is improved
    const [fieldsToRenderCount, setFieldsToRenderCount] = (0, $eUqFw.useState)(1);
    const fieldsMountedCount = (0, $eUqFw.useRef)(0);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const isMini = minimizableModalView === 'mini' || isMiniDesignEnabled;
    const renderedAllFields = (0, $1ybV0.ff)('gic-fix-loading-progress_v389p') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $eUqFw.useRef)(false) : $ee206569d1cf266a$var$renderedAllFieldsFFOff;
    const getFormStateMemoized = $ee206569d1cf266a$var$useMemoizedGetFormState(getFormState);
    (0, $eUqFw.useEffect)(()=>{
        renderAllFieldsInTabStartTime.current = performance.now();
        setIsOperationInProgress(true);
        const analyticsEvent = createAnalyticsEvent({});
        (0, $jMP2a.fireTrackAnalyticsDeferred)(analyticsEvent, 'gic renderAllFieldsInTabStart', {});
        if ((0, $1ybV0.ff)('gic-fix-loading-progress_v389p')) renderedAllFields.current = false;
    }, [
        setIsOperationInProgress,
        createAnalyticsEvent,
        renderedAllFields
    ]); // TODO Remove renderedAllFields from deps when cleaning gic-fix-loading-progress_v389p
    const fieldsLength = fields.length;
    const fieldsRendererSessionId = (0, $eUqFw.useRef)('');
    const fieldsAlreadyFullyLoaded = (0, $eUqFw.useRef)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (!isModalOpen) return;
        fieldsRendererSessionId.current = (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4();
        fieldsAlreadyFullyLoaded.current = false;
        const analyticsEvent = createAnalyticsEvent({});
        (0, $jMP2a.fireTrackAnalyticsDeferred)(analyticsEvent, 'gic fieldsToRenderTab', {
            fieldsLength: fieldsLength,
            fieldsRendererSessionId: fieldsRendererSessionId.current
        });
    }, [
        createAnalyticsEvent,
        fieldsLength,
        isModalOpen
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isModalOpen || fieldsToRenderCount < fieldsLength || fieldsAlreadyFullyLoaded.current) return;
        fieldsAlreadyFullyLoaded.current = true;
        const analyticsEvent = createAnalyticsEvent({});
        (0, $jMP2a.fireTrackAnalyticsDeferred)(analyticsEvent, 'gic fieldsFullyRenderedTab', {
            fieldsLength: fieldsLength,
            fieldsRendererSessionId: fieldsRendererSessionId.current
        });
    }, [
        createAnalyticsEvent,
        fieldsLength,
        fieldsToRenderCount,
        isModalOpen
    ]);
    const onFieldMount = (mountedFieldId)=>{
        const fieldIndex = fields.findIndex((fieldId)=>fieldId === mountedFieldId);
        fieldsMountedCount.current += 1;
        if (fieldsMountedCount.current >= fieldsToRenderCount) setFieldsToRenderCount((currentCount)=>currentCount + (0, $699UQ.getFieldsToRenderInOneBatch)(fields.length));
        const condition = (0, $1ybV0.ff)('gic-fix-loading-progress_v389p') ? fieldsMountedCount.current >= fields.length && !renderedAllFields.current : fieldIndex === fields.length - 1;
        if (condition) {
            setIsOperationInProgress(false); // send event to monitor in different browsers that the fields rendered successfully
            const analyticsEvent = createAnalyticsEvent({});
            const attributes = {
                timeToRenderAllFieldsInTabMs: Math.floor(performance.now() - renderAllFieldsInTabStartTime.current),
                fields: fields
            };
            (0, $jMP2a.fireTrackAnalyticsDeferred)(analyticsEvent, 'gic renderedAllFieldsInTab', attributes);
            if ((0, $1ybV0.ff)('gic-fix-loading-progress_v389p')) renderedAllFields.current = true;
        } // The last call to `mark` is the time used in the final metric
        // We use this fact to obtain when the final field was mounted
        (0, $hBkQt.globalIssueCreateTTIWithAdjustments).mark('gic-all-fields-loaded');
    };
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const fieldsToRender = fields.slice(0, fieldsToRenderCount).map((fieldId, index)=>{
        let content = null; // @ts-expect-error - TS2339 - Property 'gqlType' does not exist on type '(BaseField & FieldConfigValueWithoutBaseField) | {}'.
        const { gqlType: gqlType, ...rest } = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig, fieldId, {}); // @ts-expect-error - TS2339 - Property 'fieldName' does not exist on type '{ fieldId: string; fieldName: string; description?: string | undefined; isRequired?: boolean | undefined; isEditable?: boolean | undefined; nonEditableReason?: { message?: string | undefined; } | undefined; ... 6 more ...; onLayoutDone?: (() => void) | undefined; } | {}'. | TS2339 - Property 'description' does not exist on type '{ fieldId: string; fieldName: string; description?: string | undefined; isRequired?: boolean | undefined; isEditable?: boolean | undefined; nonEditableReason?: { message?: string | undefined; } | undefined; ... 6 more ...; onLayoutDone?: (() => void) | undefined; } | {}'. | TS2339 - Property 'isRequired' does not exist on type '{ fieldId: string; fieldName: string; description?: string | undefined; isRequired?: boolean | undefined; isEditable?: boolean | undefined; nonEditableReason?: { message?: string | undefined; } | undefined; ... 6 more ...; onLayoutDone?: (() => void) | undefined; } | {}'. | TS2339 - Property 'fieldType' does not exist on type '{ fieldId: string; fieldName: string; description?: string | undefined; isRequired?: boolean | undefined; isEditable?: boolean | undefined; nonEditableReason?: { message?: string | undefined; } | undefined; ... 6 more ...; onLayoutDone?: (() => void) | undefined; } | {}'.
        const { fieldName: fieldName, description: description, isRequired: isRequired, fieldType: fieldType } = rest; // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly JiraAffectedServicesField: { readonly Component: AbstractComponent<ReturnComponentProps<AffectedServicesFieldConfig>, any>; readonly defaultValueKey: "selectedAffectedServices"; readonly submitTransform: (options: AffectedServiceOption[]) => ServiceEntity[]; readonly retainUserInputTransform: (selectedAff...'.
        const FieldDetails = (0, $lG4nv.getGqlFieldMap)()[gqlType];
        let name = fieldName;
        let fieldDescription = description;
        if ((0, $1ybV0.ff)('rename-epic-link-field-to-parent-in-gic-epic-renaming-beta_pwfm1') && gqlType === (0, $b1ba189bc6d9d9ad$export$8723b724f0b3ac65)) {
            name = formatMessage((0, $eiR7Y.default).parentFieldLabel);
            fieldDescription = formatMessage((0, $eiR7Y.default).parentFieldDescription);
        }
        const extraProps = {
            autoFocus: index === 0 && currentActiveTabIndex === 0 && (0, $4EOWx.FIELDS_WITHOUT_DROPDOWN_MENU).includes(gqlType) && shouldAutoFocus,
            isSubTaskCreationOpen: isSubTaskCreationOpen,
            isDropdownMenuFixedAndLayered: true,
            selectedProject: (0, $4EOWx.FIELDS_WITH_SELECTED_PROJECT).includes(gqlType) ? selectedProject : undefined,
            selectedIssueType: (0, $4EOWx.FIELDS_WITH_SELECTED_ISSUE_TYPE).includes(gqlType) ? selectedIssueType : undefined,
            // @ts-expect-error - TS2322 - Type 'HookFunction<State, BoundActions<State, { readonly setCurrentActiveTabIndex: (tabIndex: number) => Action<State, void, void | Promise<void>>; readonly setSelectedProject: (project: Project) => Action<...>; ... 20 more ...; readonly setSummaryValue: (summary: string) => Action<...>; }>, void> | undefined' is not assignable to type 'HookFunction<State, { readonly setCurrentActiveTabIndex: (tabIndex: number) => Action<State, void, void | Promise<void>>; readonly setSelectedProject: (project: Project) => Action<...>; ... 20 more ...; readonly setSummaryValue: (summary: string) => Action<...>; }, undefined> | undefined'.
            useFormContext: (0, $4EOWx.FIELDS_NEEDING_FORM_CONTEXT).includes(gqlType) ? (0, $fswni.useFormContext) : undefined,
            componentKey: (0, $4EOWx.FORCE_RENDER_ON_TAB_CHANGE).includes(gqlType) ? `${fieldId}-${currentActiveTabIndex}` : undefined,
            contextAndValuesOfIssueBeingCreated: (0, $4EOWx.FIELDS_NEEDING_COMPLETE_FORM_STATE).includes(gqlType) ? {
                getFormState: getFormState,
                selectedIssueType: selectedIssueType,
                fieldConfig: fieldConfig
            } : undefined,
            getFormState: (0, $4EOWx.FIELDS_NEEDING_GET_FORM_STATE).includes(gqlType) ? getFormStateMemoized : undefined,
            onInProgressChange: (0, $4EOWx.FIELDS_WITH_ON_INPROGRESS_CHANGE).includes(gqlType) ? setIsOperationInProgress : undefined,
            forge: fieldType !== undefined && (0, $5VJL3.isForgeCustomField)(fieldType) ? {
                selectedProject: selectedProject,
                selectedIssueType: selectedIssueType,
                modules: customFields,
                filteredOutModules: filteredOutModules,
                hasFinishedLoading: hasFinishedLoading
            } : undefined,
            fieldHelpTextUrl: (0, $699UQ.getHelpTextUrl)(gqlType),
            onLinkClickEvent: (0, $699UQ.getOnLinkClickEvent)(gqlType),
            isCreateLinkedIssue: (0, $1ybV0.ff)('create-linked-issues-trigger-point-issue-view') && (0, $4EOWx.FIELDS_NEEDING_CREATE_LINKED_ISSUE_INFO).includes(gqlType) ? isCreateLinkedIssue : false,
            isMini: isMini,
            ...(0, $1ybV0.ff)('gic-smart-fields-jira-labs_8uwvr') && {
                isCollapsed: isCollapsed,
                isFieldResponsive: isFieldResponsive
            }
        };
        if (isGICPositioningEnabled() && fieldPropsExtensions?.[fieldType] && (0, $4EOWx.FIELDS_WITH_EXTENSION_PROPS).includes(gqlType)) Object.assign(extraProps, fieldPropsExtensions[fieldType]);
        if (FieldDetails) {
            const { Component: Component, defaultValueKey: defaultValueKey } = FieldDetails;
            const fieldContainerWrapperProps = {
                ...defaultValueKey === 'parentIssue' ? {} : {
                    onKeyDown: (0, $aqi5n.preventEscKeyPropagationKeyPressHandler)
                },
                fieldId: fieldId,
                componentProps: {
                    ...rest,
                    ...extraProps,
                    fieldName: name,
                    description: fieldDescription,
                    gqlType: gqlType,
                    fieldWrapperElement: FieldWrapperComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FieldWrapperComponent, {
                        fieldId: fieldId,
                        field: (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig, fieldId),
                        setFieldValue: setFieldValue
                    }) : null
                },
                Component: Component,
                onFieldMount: onFieldMount,
                apiLatency: apiLatency,
                isSubsequentLoad: isSubsequentLoad,
                issueAdjustmentModules: issueAdjustmentModules,
                setFieldValue: setFieldValue,
                wasStateRestored: wasStateRestored
            }; // @ts-expect-error - TS2322 - Type '{ onKeyDown: (e: KeyboardEvent<Element> | KeyboardEvent<EventTarget>) => void; fieldId: string; componentProps: { fieldName: any; ... 24 more ...; onLayoutDone?: (() => void) | undefined; }; ... 7 more ...; key: string; }' is not assignable to type 'FieldContainerWrapperProps'.
            content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ee206569d1cf266a$export$90edc2cad754ca2e, {
                key: fieldId,
                ...fieldContainerWrapperProps
            });
        } else content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ee206569d1cf266a$var$FieldContainer, {
            key: fieldId,
            "data-testid": `issue-create.ui.modal.create-form.layout-renderer.field-renderer.field.${fieldId}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gnD2V.default), {
            fieldId: fieldId,
            fieldName: fieldName,
            isRequired: isRequired,
            description: description,
            onSwitchExperienceClick: openTempSwitchModal,
            projectType: selectedProject?.projectType,
            gqlType: gqlType,
            fieldType: fieldType,
            onFieldMount: onFieldMount,
            isMini: isMini
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
            id: `globalIssueCreateIssue-field-renderer-${fieldId}`,
            key: `field-renderer-${fieldId}`,
            packageName: "jiraIssueCreateModal",
            fallback: "unmount",
            onError: ()=>{
                onFieldMount(fieldId);
            },
            sendToPrivacyUnsafeSplunk: true
        }, !(0, $1ybV0.ff)('gic-remove-unused-fieldstorender-events_o3mhl') && onFieldRendered && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7uLmC.MarkFieldAsRendered), {
            fieldId: fieldId,
            onFieldRendered: onFieldRendered
        }), content);
    });
    return fieldsToRender;
};
const $ee206569d1cf266a$var$FieldRenderer = /*#__PURE__*/ (0, $eUqFw.memo)($ee206569d1cf266a$var$FieldRendererBase);
var $ee206569d1cf266a$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $ee206569d1cf266a$var$FieldRenderer;
const $ee206569d1cf266a$var$FieldContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _19pkv47k _1rys1caa",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ee206569d1cf266a$var$FieldContainerOld = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkv47k _1rys1caa",
            __cmplp.className
        ])
    });
});

});
parcelRegister("418AI", function(module, exports) {

$parcel$export(module.exports, "FieldDecoratorAsync", () => $c332a307c33f1512$export$7bf1fdc8d847e1ea);

var $eUqFw = parcelRequire("eUqFw");

var $ig7wC = parcelRequire("ig7wC");

var $bKI0B = parcelRequire("bKI0B");

var $8ibkc = parcelRequire("8ibkc");

var $gCVN7 = parcelRequire("gCVN7");
const $c332a307c33f1512$var$FieldDecoratorAsyncNoMemo = ({ Component: Component, componentProps: componentProps })=>{
    const adjustmentsAreEnabled = (0, $ig7wC.useAdjustmentsEnabled)();
    const undecoratedComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, componentProps);
    // Render FieldDecorator only when field type is supported
    // and adjustments are enabled
    if ((0, $8ibkc.isFieldTypeSupported)((0, $bKI0B.GIC_VIEW_TYPE), componentProps.fieldType) && adjustmentsAreEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gCVN7.EnabledFieldDecorator), {
        // @ts-expect-error - TS2322 - Type 'ComponentType<T>' is not assignable to type 'ComponentType<DecoratedField>'.
        Component: Component,
        componentProps: componentProps
    });
    return undecoratedComponent;
};
const $c332a307c33f1512$export$7bf1fdc8d847e1ea = /*#__PURE__*/ (0, $eUqFw.memo)($c332a307c33f1512$var$FieldDecoratorAsyncNoMemo);

});
parcelRegister("gCVN7", function(module, exports) {

$parcel$export(module.exports, "EnabledFieldDecorator", () => $490bb1b26cf7b35a$export$a39682472306ffd4);

var $eUqFw = parcelRequire("eUqFw");

var $fcNlw = parcelRequire("fcNlw");
var $elOAM = parcelRequire("elOAM");

var $7TRB4 = parcelRequire("7TRB4");

var $gR74I = parcelRequire("gR74I");

var $cBQME = parcelRequire("cBQME");

var $9iDn2 = parcelRequire("9iDn2");
const $490bb1b26cf7b35a$var$EnabledFieldDecoratorNoMemo = ({ Component: Component, componentProps: componentProps })=>{
    const { fieldId: fieldId, fieldName: fieldName, description: description, fieldType: fieldType, isRequired: isRequired = false, gqlType: fieldRenderer, allowedValues: allowedValues } = componentProps;
    const { setFieldValue: setFieldValue, getFieldValue: getFieldValue } = (0, $gR74I.useFormApi)();
    const [state, { initializeField: initializeField, clearAppliedValue: clearAppliedValue }] = (0, $fcNlw.useAdjustedField)(fieldId);
    const [triggerFieldInitializationKey] = (0, $elOAM.useTriggerFieldInitialization)();
    const isBusy = (0, $7TRB4.useFieldIsBusy)(fieldId);
    const isVisible = state.isVisible ?? true;
    const isReadOnly = state.isReadOnly ?? false;
    const isRequiredFromUIM = state.isRequired ?? false;
    (0, $eUqFw.useEffect)(()=>{
        const field = {
            fieldName: fieldName,
            fieldId: fieldId,
            description: description,
            isVisible: isVisible,
            fieldType: fieldType,
            isReadOnly: isReadOnly,
            isRequired: isRequired,
            allowedValues: allowedValues,
            value: getFieldValue(fieldId)
        };
        initializeField({
            field: field,
            metadata: {
                fieldRenderer: fieldRenderer
            }
        });
    /**
		 * Because of how the GIC works between subsequent modal openings, UI modifications state is persisted.
		 * That's why want to run initializeField only when triggerFieldInitializationKey change and mounting.
		 */ // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        triggerFieldInitializationKey,
        getFieldValue
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (state.value !== undefined) {
            setFieldValue(fieldId, state.value);
            // Once we have applied the value, we clear it from the state, so we don't apply it again
            // in the future and overwrite whatever the user has changed between now and then
            clearAppliedValue(fieldId);
        }
    }, [
        state.value,
        clearAppliedValue,
        fieldId,
        setFieldValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cBQME.ConditionallyVisibleDiv), {
        key: fieldId,
        isVisible: isVisible,
        "data-testid": `ui-modifications-view-gic.ui.field-decorator.enabled-field-decorator.visibility-wrapper.${fieldId}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, {
        ...componentProps,
        ...(0, $9iDn2.pickPropertiesToOverwrite)(state),
        ...isBusy ? {
            isReadOnly: true
        } : {},
        areUiModificationsBusy: isBusy,
        isRequiredFromUIM: isRequiredFromUIM
    }));
};
const $490bb1b26cf7b35a$export$a39682472306ffd4 = /*#__PURE__*/ (0, $eUqFw.memo)($490bb1b26cf7b35a$var$EnabledFieldDecoratorNoMemo);

});
parcelRegister("7TRB4", function(module, exports) {

$parcel$export(module.exports, "useFieldIsBusy", () => $437ae02f2f2b76eb$export$b4ae28da91c35ed4);

var $1ybV0 = parcelRequire("1ybV0");

var $8LJqN = parcelRequire("8LJqN");

var $3G9wl = parcelRequire("3G9wl");


var $dvQud = parcelRequire("dvQud");
const $437ae02f2f2b76eb$export$ff04c0f3c2623b5f = (fieldId)=>{
    const [isBusy] = (0, $dvQud.useFieldIsProcessingOld)(fieldId);
    const currentUIModificationsConsentStatus = (0, $3G9wl.useUIModificationsConsentStatus)();
    if (currentUIModificationsConsentStatus === (0, $e4bc45ef063f6e5f$export$d67d63332ce3ce38)) return false;
    return isBusy;
};
const $437ae02f2f2b76eb$export$3b3523eb1f597b08 = (fieldId)=>{
    const [isBusyData] = (0, $dvQud.useFieldIsProcessingV2)(fieldId);
    const uimConsentMap = (0, $3G9wl.useUIModificationsConsentStatusForApps)();
    const { isBusy: isBusy, appsIds: appsIds } = isBusyData;
    if (!isBusy) return false;
    return appsIds.some((appId)=>uimConsentMap[appId] !== (0, $e4bc45ef063f6e5f$export$d67d63332ce3ce38));
};
const $437ae02f2f2b76eb$export$b4ae28da91c35ed4 = (0, $8LJqN.functionWithCondition)(()=>(0, $1ybV0.ff)('ui-modifications-multi-app-experience_ud4yw'), $437ae02f2f2b76eb$export$3b3523eb1f597b08, $437ae02f2f2b76eb$export$ff04c0f3c2623b5f);

});
parcelRegister("dvQud", function(module, exports) {

$parcel$export(module.exports, "useFieldIsProcessingOld", () => $f5c447ce6e9bd7f5$export$ec0aa14c1e4bcb95);
$parcel$export(module.exports, "useFieldIsProcessingV2", () => $f5c447ce6e9bd7f5$export$fd447cdc5de90a78);

var $ldoFd = parcelRequire("ldoFd");

var $ggKAj = parcelRequire("ggKAj");
var $bj4JM = parcelRequire("bj4JM");

var $fcNlw = parcelRequire("fcNlw");
const $f5c447ce6e9bd7f5$export$b58fa93ff3e11506 = (0, $bj4JM.createSelector)((state)=>state.registeredFieldsDeprecated, (state)=>state.error, (_, fieldId)=>fieldId, (registeredChanges, error, fieldId)=>{
    // When there is an error in any part of UI modifications
    // we need to ensure that fields from the Jira view are not blocked by reacting on an error here.
    // e.g. GIC fields will not be blocked anymore when error occurs in one of the decorators.
    if (error) return false;
    return !!Object.values(registeredChanges).find((registeredChange)=>registeredChange?.includes(fieldId));
});
const $f5c447ce6e9bd7f5$export$faa2043a29f9e75e = (0, $bj4JM.createSelector)((state)=>state.registeredFields, (state)=>state.error, (_, fieldId)=>fieldId, (registeredChangesMap, error, fieldId)=>{
    if (error) return {
        isBusy: false,
        appsIds: []
    };
    const appsIds = Object.entries(registeredChangesMap).filter(([_, registeredFields])=>!(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(registeredFields) && Object.values(registeredFields).flat().includes(fieldId)).map(([appId])=>appId);
    return {
        isBusy: appsIds.length > 0,
        appsIds: appsIds
    };
});
const $f5c447ce6e9bd7f5$export$ec0aa14c1e4bcb95 = (0, $ggKAj.createHook)((0, $fcNlw.store), {
    selector: $f5c447ce6e9bd7f5$export$b58fa93ff3e11506
});
const $f5c447ce6e9bd7f5$export$fd447cdc5de90a78 = (0, $ggKAj.createHook)((0, $fcNlw.store), {
    selector: $f5c447ce6e9bd7f5$export$faa2043a29f9e75e
});

});


parcelRegister("cBQME", function(module, exports) {

$parcel$export(module.exports, "ConditionallyVisibleDiv", () => $71b01ee5256a7af5$export$f154ce6a32df6563);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
const $71b01ee5256a7af5$export$f154ce6a32df6563 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisible: isVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.isVisible ? "_1e0c1bgi" : "_1e0cglyw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("9iDn2", function(module, exports) {

$parcel$export(module.exports, "pickPropertiesToOverwrite", () => $fb240047b28c7e95$export$7aa61edf4d7c035e);
const $fb240047b28c7e95$export$7aa61edf4d7c035e = (field)=>{
    const overwriteProperties = [
        'fieldName',
        'description',
        'isReadOnly',
        'isRequired',
        'allowedValues'
    ];
    return overwriteProperties.reduce((acc, propertyName)=>{
        const propertyValue = field[propertyName];
        if (propertyValue !== undefined) acc[propertyName] = propertyValue;
        return acc;
    }, {});
};

});



parcelRegister("gnD2V", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb630dff043a5d25$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $4LhB6 = parcelRequire("4LhB6");

var $96IgR = parcelRequire("96IgR");

var $29yDk = parcelRequire("29yDk");

var $cf2Y4 = parcelRequire("cf2Y4");

var $PdmhA = parcelRequire("PdmhA");

var $8uD7Y = parcelRequire("8uD7Y");

var $5i7Lk = parcelRequire("5i7Lk");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $hizof = parcelRequire("hizof");

var $4wW4l = parcelRequire("4wW4l");
const $fb630dff043a5d25$var$IncompatibleField = (props)=>{
    const isMountEventFired = (0, $eUqFw.useRef)(false);
    const [isInfoMessageOpen, setInfoMessageOpen] = (0, $eUqFw.useState)(false);
    const { fieldId: fieldId, fieldName: fieldName, isRequired: isRequired = false, description: description, projectType: projectType, gqlType: gqlType, fieldType: fieldType, onFieldMount: onFieldMount, isMini: isMini } = props;
    (0, $eUqFw.useEffect)(()=>{
        if (isMountEventFired.current === false) {
            isMountEventFired.current = true;
            onFieldMount(fieldId);
        }
    }, [
        onFieldMount,
        fieldId
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const closeInfoMessage = ()=>{
        setInfoMessageOpen(false);
    };
    const toggleInfoMessageVisibility = ()=>{
        if (isInfoMessageOpen === true) {
            closeInfoMessage();
            return;
        }
        setInfoMessageOpen(true);
        const analyticsEvent = createAnalyticsEvent({
            actionSubject: 'inlineDialog',
            action: 'viewed'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'globalIssueCreateFieldUnsupported');
    };
    (0, $eUqFw.useEffect)(()=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, $jMP2a.fireTrackAnalyticsDeferred)(analyticsEvent, 'unsupported newGicField', {
            gqlType: gqlType,
            projectType: projectType,
            fieldType: fieldType
        });
    }, [
        createAnalyticsEvent,
        projectType,
        gqlType,
        fieldType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        id: fieldId,
        label: fieldName,
        isRequired: isRequired,
        name: fieldId
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fb630dff043a5d25$var$InlineMessageContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fb630dff043a5d25$var$FieldContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cf2Y4.default), {
            isDisabled: true
        })), !(0, $hizof.UNSUPPORTED_FIELD_TYPES).includes(fieldType) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
            sourceType: (0, $41ea3621645e2acc$export$cae2783c9279926),
            sourceName: "globalIssueCreateFieldUnsupported"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29yDk.default), {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($fb630dff043a5d25$var$MessageContainer, {
                "data-testid": (0, $hizof.MESSAGE_CONTAINER_TEST_ID)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                ...(0, $4wW4l.default).incompatibleFieldMessageNoOptionToSwitchToOldModal,
                values: {
                    fieldName: fieldName,
                    b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, chunks)
                }
            })),
            isOpen: isInfoMessageOpen,
            onClose: closeInfoMessage
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            spacing: "none",
            appearance: "subtle",
            onClick: toggleInfoMessageVisibility,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
                label: "incompatible-field-info",
                size: "medium",
                primaryColor: `var(--ds-icon-subtle, ${(0, $PdmhA).N200})`
            }),
            testId: (0, $hizof.ERROR_ICON_TEST_ID)
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5i7Lk.FieldMessage), {
            description: description,
            fieldName: fieldName,
            isMini: isMini
        })));
};
var $fb630dff043a5d25$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $fb630dff043a5d25$var$IncompatibleField;
const $fb630dff043a5d25$var$InlineMessageContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fb630dff043a5d25$var$FieldContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1edt _2hwxu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fb630dff043a5d25$var$MessageContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1sum",
            __cmplp.className
        ])
    });
});

});
parcelRegister("29yDk", function(module, exports) {

$parcel$export(module.exports, "default", () => $99fb58582e83d080$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $74BVL = parcelRequire("74BVL");

var $lbDTY = parcelRequire("lbDTY");

var $hM7RE = parcelRequire("hM7RE");
var $1ngde = parcelRequire("1ngde");
var $2jDha = parcelRequire("2jDha");

var $5Q9wj = parcelRequire("5Q9wj");

var $etCs9 = parcelRequire("etCs9");
var $eN43R = parcelRequire("eN43R");

var $XHGTv = parcelRequire("XHGTv");

var $8nlzU = parcelRequire("8nlzU");
var $i6BC8 = parcelRequire("i6BC8");
var $6frYP = parcelRequire("6frYP");

var $1GZRB = parcelRequire("1GZRB");
const $99fb58582e83d080$var$packageName = undefined;
const $99fb58582e83d080$var$packageVersion = undefined;
const $99fb58582e83d080$var$checkIsChildOfPortal = (node)=>{
    if (!node) return false;
    return node.classList && node.classList.contains('atlaskit-portal-container') || $99fb58582e83d080$var$checkIsChildOfPortal(node.parentElement);
};
// escape close manager for layering
const $99fb58582e83d080$var$EscapeCloseManager = ({ handleClose: handleClose })=>{
    (0, $eN43R.useCloseOnEscapePress)({
        onClose: handleClose
    });
    // only create a dummy component for using ths hook in class component
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", null);
};
const $99fb58582e83d080$export$513033cc22e3bc20 = /*#__PURE__*/ (0, $eUqFw.memo)(function InlineDialog({ isOpen: isOpen = false, onContentBlur: onContentBlur = (0, $5Q9wj.default), onContentClick: onContentClick = (0, $5Q9wj.default), onContentFocus: onContentFocus = (0, $5Q9wj.default), onClose: onClose = (0, $5Q9wj.default), placement: placement = 'bottom-start', strategy: strategy = 'fixed', testId: testId, content: content, children: children }) {
    const containerRef = (0, $eUqFw.useRef)(null);
    const triggerRef = (0, $eUqFw.useRef)(null);
    // we put this into a ref to avoid handleCloseRequest having this as a dependency
    const onCloseRef = (0, $eUqFw.useRef)(onClose);
    const isLayeringEnabled = (0, $XHGTv.fg)('platform.design-system-team.inline-message-layering_wfp1p') && isOpen;
    (0, $eUqFw.useEffect)(()=>{
        onCloseRef.current = onClose;
    });
    const handleCloseRequest = (0, $eUqFw.useCallback)((event)=>{
        const { target: target } = event;
        // checks for when target is not HTMLElement
        if (!(target instanceof HTMLElement)) return;
        // TODO: This is to handle the case where the target is no longer in the DOM.
        // This happens with react-select in datetime picker. There might be other
        // edge cases for this.
        if (!document.body.contains(target)) return;
        if (isLayeringEnabled) {
            onCloseRef.current?.({
                isOpen: false,
                event: event
            });
            return;
        }
        // handles the case where inline dialog opens portalled elements such as modal
        if ($99fb58582e83d080$var$checkIsChildOfPortal(target)) return;
        // call onClose if the click originated from outside the dialog
        if (containerRef.current && !containerRef.current.contains(target)) onCloseRef.current?.({
            isOpen: false,
            event: event
        });
    }, [
        isLayeringEnabled
    ]);
    const handleClick = (0, $eUqFw.useCallback)((event)=>{
        // exit if we click outside but on the trigger — it can handle the clicks itself
        if (triggerRef.current && triggerRef.current.contains(event.target)) return;
        // if feature flag is enabled we won't file the close event when clicking inside dialog
        if (isLayeringEnabled && containerRef.current?.contains(event.target)) return;
        handleCloseRequest(event);
    }, [
        handleCloseRequest,
        isLayeringEnabled
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isOpen) return;
        return (0, $74BVL.bind)(window, {
            type: 'click',
            listener: handleClick,
            options: {
                capture: true
            }
        });
    }, [
        isOpen,
        handleClick
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Escape') handleCloseRequest(event);
    }, [
        handleCloseRequest
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // if layering is enabled, we will use useCloseOnEscapePress hook instead
        if (!isOpen || isLayeringEnabled) return;
        const unbind = (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: handleKeyDown,
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        isOpen,
        handleKeyDown,
        isLayeringEnabled
    ]);
    const popper = isOpen ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $i6BC8.Popper), {
        placement: placement,
        strategy: strategy
    }, ({ ref: ref, style: style })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $1GZRB.Container), {
            onBlur: onContentBlur,
            onFocus: onContentFocus,
            onClick: onContentClick,
            ref: (node)=>{
                if (node) {
                    containerRef.current = node;
                    if (typeof ref === 'function') ref(node);
                    else ref.current = node;
                }
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: style,
            testId: testId
        }, content)) : null;
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $8nlzU.Manager), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $6frYP.Reference), null, ({ ref: ref })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lbDTY))), {
            innerRef: (node)=>{
                triggerRef.current = node;
                if (typeof ref === 'function') ref(node);
                else ref.current = node;
            }
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children))), isLayeringEnabled ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $etCs9.UNSAFE_LAYERING), {
        isDisabled: false
    }, popper, /*#__PURE__*/ (0, $byn9U.jsx)($99fb58582e83d080$var$EscapeCloseManager, {
        handleClose: handleCloseRequest
    })) : popper);
});
$99fb58582e83d080$export$513033cc22e3bc20.displayName = 'InlineDialog';
const $99fb58582e83d080$var$createAndFireEventOnAtlaskit = (0, $hM7RE.default)('atlaskit');
var $99fb58582e83d080$export$2e2bcd8739ae039 = (0, $1ngde.default)({
    componentName: 'inlineDialog',
    packageName: $99fb58582e83d080$var$packageName,
    packageVersion: $99fb58582e83d080$var$packageVersion
})((0, $2jDha.default)({
    onClose: $99fb58582e83d080$var$createAndFireEventOnAtlaskit({
        action: 'closed',
        actionSubject: 'inlineDialog',
        attributes: {
            componentName: 'inlineDialog',
            packageName: $99fb58582e83d080$var$packageName,
            packageVersion: $99fb58582e83d080$var$packageVersion
        }
    })
})($99fb58582e83d080$export$513033cc22e3bc20));

});
parcelRegister("1GZRB", function(module, exports) {

$parcel$export(module.exports, "Container", () => $9db71f94672a5c3a$export$42a852a2b6b56249);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $PdmhA = parcelRequire("PdmhA");

var $lcnyw = parcelRequire("lcnyw");
const $9db71f94672a5c3a$var$CSS_THEME_BACKGROUND = '--theme-background';
const $9db71f94672a5c3a$var$CSS_THEME_COLOR = '--theme-color';
const $9db71f94672a5c3a$var$CSS_THEME_BOX_SHADOW = '--theme-box-shadow';
const $9db71f94672a5c3a$var$containerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    boxSizing: 'content-box',
    maxWidth: `${448}px`,
    maxHeight: `${448}px`,
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-300, 24px)"}`,
    zIndex: (0, $lcnyw.layers).dialog(),
    background: `var(${$9db71f94672a5c3a$var$CSS_THEME_BACKGROUND})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(${$9db71f94672a5c3a$var$CSS_THEME_BOX_SHADOW})`,
    color: `var(${$9db71f94672a5c3a$var$CSS_THEME_COLOR})`,
    '&:focus': {
        outline: 'none'
    }
});
const $9db71f94672a5c3a$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, onBlur: onBlur, onClick: onClick, onFocus: onFocus, style: style, testId: testId }, ref)=>{
    return(// Unfortunately, these are used for products to pass through. Inline Dialog is being deprecated anyway
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $9db71f94672a5c3a$var$containerStyles,
        "data-testid": testId,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$9db71f94672a5c3a$var$CSS_THEME_BACKGROUND]: `var(--ds-surface-overlay, ${(0, $PdmhA.N0)})`,
            [$9db71f94672a5c3a$var$CSS_THEME_COLOR]: `var(--ds-text, ${(0, $PdmhA.N900)})`,
            [$9db71f94672a5c3a$var$CSS_THEME_BOX_SHADOW]: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $PdmhA.N50A)}, 0 0 1px ${(0, $PdmhA.N60A)}`})`,
            ...style
        }
    }, children));
});

});


parcelRegister("hizof", function(module, exports) {

$parcel$export(module.exports, "UNSUPPORTED_FIELD_TYPES", () => $2783f06d31904e57$export$50417837a224cc14);
$parcel$export(module.exports, "ERROR_ICON_TEST_ID", () => $2783f06d31904e57$export$373c21cf926631ed);
$parcel$export(module.exports, "MESSAGE_CONTAINER_TEST_ID", () => $2783f06d31904e57$export$b8c8ab4bbeae7cb);
// These fields are not supported in the old issue create modal
const $2783f06d31904e57$export$50417837a224cc14 = [
    'com.atlassian.jira.modules.servicemanagement.major-incident-entity:major-incident-entity-field-cftype'
];
const $2783f06d31904e57$export$373c21cf926631ed = 'issue-create.common.ui.fields.incompatible-field.error-button';
const $2783f06d31904e57$export$b8c8ab4bbeae7cb = 'issue-create.common.ui.fields.incompatible-field.message-container';

});

parcelRegister("4wW4l", function(module, exports) {

$parcel$export(module.exports, "default", () => $a194edc4aced3c6e$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $a194edc4aced3c6e$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    incompatibleFieldMessageNoOptionToSwitchToOldModal: {
        "id": "issue-create.common.fields.incompatible-field.incompatible-field-message-no-option-to-switch-to-old-modal",
        "defaultMessage": "The <b>{fieldName}</b> field is not supported on this screen."
    }
});

});


parcelRegister("4EOWx", function(module, exports) {

$parcel$export(module.exports, "FIELDS_WITH_SELECTED_PROJECT", () => $a7043d035c7bbf1d$export$dd0837d091307e0f);
$parcel$export(module.exports, "FIELDS_WITH_SELECTED_ISSUE_TYPE", () => $a7043d035c7bbf1d$export$389f9f87389af956);
$parcel$export(module.exports, "FIELDS_NEEDING_FORM_CONTEXT", () => $a7043d035c7bbf1d$export$f6b349b9a22679bc);
$parcel$export(module.exports, "FIELDS_WITH_ON_INPROGRESS_CHANGE", () => $a7043d035c7bbf1d$export$f014d1ea91bf0c23);
$parcel$export(module.exports, "FORCE_RENDER_ON_TAB_CHANGE", () => $a7043d035c7bbf1d$export$27466286b235cb0f);
$parcel$export(module.exports, "FIELDS_NEEDING_COMPLETE_FORM_STATE", () => $a7043d035c7bbf1d$export$9af9321e2bc27e84);
$parcel$export(module.exports, "FIELDS_NEEDING_GET_FORM_STATE", () => $a7043d035c7bbf1d$export$249f6ad3f1dce1f);
$parcel$export(module.exports, "RENDER_BATCH_SIZE_DENOMINATOR", () => $a7043d035c7bbf1d$export$397fe8aa4d206ed5);
$parcel$export(module.exports, "FIELDS_WITH_EXTENSION_PROPS", () => $a7043d035c7bbf1d$export$88f0fb0471bfaaff);
$parcel$export(module.exports, "FIELDS_NEEDING_CREATE_LINKED_ISSUE_INFO", () => $a7043d035c7bbf1d$export$9ff19636928638c9);
$parcel$export(module.exports, "FIELDS_WITHOUT_DROPDOWN_MENU", () => $a7043d035c7bbf1d$export$bd64b3c9a1b1c867);

const $a7043d035c7bbf1d$export$dd0837d091307e0f = [
    (0, $b1ba189bc6d9d9ad$export$8723b724f0b3ac65),
    (0, $b1ba189bc6d9d9ad$export$31a6c27df1f927b2),
    (0, $b1ba189bc6d9d9ad$export$30b2c2de5e3007a4),
    (0, $b1ba189bc6d9d9ad$export$76d811609080a7aa),
    (0, $b1ba189bc6d9d9ad$export$a9b3195cbef5c5ad),
    (0, $b1ba189bc6d9d9ad$export$597fa240de2bfd92),
    (0, $b1ba189bc6d9d9ad$export$3e8dded8d83b5d95),
    (0, $b1ba189bc6d9d9ad$export$670384150af5f49e),
    (0, $b1ba189bc6d9d9ad$export$bf9df74e065af482),
    (0, $b1ba189bc6d9d9ad$export$d64150fd9c66969c),
    (0, $b1ba189bc6d9d9ad$export$64238d76a1dc0703),
    (0, $b1ba189bc6d9d9ad$export$eca94ae30cb92d8),
    (0, $b1ba189bc6d9d9ad$export$3849bb04b4eee607),
    (0, $b1ba189bc6d9d9ad$export$2bb9d057bad89bfa)
];
const $a7043d035c7bbf1d$export$389f9f87389af956 = [
    (0, $b1ba189bc6d9d9ad$export$3e8dded8d83b5d95),
    (0, $b1ba189bc6d9d9ad$export$bf9df74e065af482),
    (0, $b1ba189bc6d9d9ad$export$31a6c27df1f927b2)
];
const $a7043d035c7bbf1d$export$f6b349b9a22679bc = [
    (0, $b1ba189bc6d9d9ad$export$670384150af5f49e),
    (0, $b1ba189bc6d9d9ad$export$8723b724f0b3ac65)
];
const $a7043d035c7bbf1d$export$f014d1ea91bf0c23 = [
    (0, $b1ba189bc6d9d9ad$export$a9b3195cbef5c5ad)
];
const $a7043d035c7bbf1d$export$27466286b235cb0f = [
    (0, $b1ba189bc6d9d9ad$export$64c7789e86344de5),
    (0, $b1ba189bc6d9d9ad$export$5bb498d4f2f54799),
    (0, $b1ba189bc6d9d9ad$export$d10237d945259f96),
    (0, $b1ba189bc6d9d9ad$export$2055419ff013de79),
    (0, $b1ba189bc6d9d9ad$export$3a1ae3e0f2d9b1b9),
    (0, $b1ba189bc6d9d9ad$export$eca94ae30cb92d8),
    (0, $b1ba189bc6d9d9ad$export$30b2c2de5e3007a4),
    (0, $b1ba189bc6d9d9ad$export$76d811609080a7aa)
];
const $a7043d035c7bbf1d$export$9af9321e2bc27e84 = [
    (0, $b1ba189bc6d9d9ad$export$597fa240de2bfd92),
    (0, $b1ba189bc6d9d9ad$export$fc69de49ba08ae77)
];
const $a7043d035c7bbf1d$export$249f6ad3f1dce1f = [
    (0, $b1ba189bc6d9d9ad$export$31a6c27df1f927b2)
];
const $a7043d035c7bbf1d$export$397fe8aa4d206ed5 = 10;
const $a7043d035c7bbf1d$export$88f0fb0471bfaaff = [
    (0, $b1ba189bc6d9d9ad$export$31a6c27df1f927b2)
];
const $a7043d035c7bbf1d$export$9ff19636928638c9 = [
    (0, $b1ba189bc6d9d9ad$export$47af4d6f62c134cf)
];
const $a7043d035c7bbf1d$export$bd64b3c9a1b1c867 = [
    (0, $b1ba189bc6d9d9ad$export$23ca38ad884e35f1),
    (0, $b1ba189bc6d9d9ad$export$7e5590c7c7a403c0),
    (0, $b1ba189bc6d9d9ad$export$8643f0b9cefed538),
    (0, $b1ba189bc6d9d9ad$export$31a6c27df1f927b2),
    (0, $b1ba189bc6d9d9ad$export$e4d5e04bc56680dc),
    (0, $b1ba189bc6d9d9ad$export$d854193d90dc547d),
    (0, $b1ba189bc6d9d9ad$export$e0ece81bd398c799),
    (0, $b1ba189bc6d9d9ad$export$95433ac963f4aebe),
    (0, $b1ba189bc6d9d9ad$export$a138d5648dda03f0),
    (0, $b1ba189bc6d9d9ad$export$aecc734a7c3591d7)
];

});

parcelRegister("eiR7Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $faefad2cef1b1365$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $faefad2cef1b1365$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    parentFieldLabel: {
        "id": "issue-create.modal.create-form.layout-renderer.field-renderer.parent-field-label",
        "defaultMessage": "Parent"
    },
    parentFieldDescription: {
        "id": "issue-create.modal.create-form.layout-renderer.field-renderer.parent-field-description",
        "defaultMessage": "Choose a parent to assign this issue to"
    }
});

});

parcelRegister("699UQ", function(module, exports) {

$parcel$export(module.exports, "getHelpTextUrl", () => $c344c7ca20975057$export$6d35186636f2563a);
$parcel$export(module.exports, "getOnLinkClickEvent", () => $c344c7ca20975057$export$ac33bccf00c7d438);
$parcel$export(module.exports, "getFieldsToRenderInOneBatch", () => $c344c7ca20975057$export$e76bcc0cbf9cc086);

var $jK8t4 = parcelRequire("jK8t4");

var $j2Myn = parcelRequire("j2Myn");

var $4EOWx = parcelRequire("4EOWx");
const $c344c7ca20975057$var$isFieldWithLearnMoreLink = (gqlType)=>Object.keys((0, $jK8t4.FIELDS_LEARN_MORE_LINKS)).includes(gqlType);
const $c344c7ca20975057$export$6d35186636f2563a = (gqlType)=>{
    if ($c344c7ca20975057$var$isFieldWithLearnMoreLink(gqlType)) return (0, $jK8t4.FIELDS_LEARN_MORE_LINKS)[gqlType];
    return undefined;
};
const $c344c7ca20975057$export$ac33bccf00c7d438 = (gqlType)=>{
    if ($c344c7ca20975057$var$isFieldWithLearnMoreLink(gqlType)) return 0, $j2Myn.openInNewTabLinkClickEventHandler;
    return undefined;
};
const $c344c7ca20975057$export$e76bcc0cbf9cc086 = (totalFields)=>Math.max(Math.floor(totalFields / (0, $4EOWx.RENDER_BATCH_SIZE_DENOMINATOR)), 10);

});


parcelRegister("htrX0", function(module, exports) {

$parcel$export(module.exports, "FieldsContainer", () => $679a9ba22fb618ed$export$8cdf7afbd261e53d);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $1ttZy = parcelRequire("1ttZy");

var $fswni = parcelRequire("fswni");

var $jMP2a = parcelRequire("jMP2a");

var $7uxUn = parcelRequire("7uxUn");

var $2daeC = parcelRequire("2daeC");

var $l9zVu = parcelRequire("l9zVu");
const $679a9ba22fb618ed$export$8cdf7afbd261e53d = (props)=>{
    const { fields: propFields, collapsedFields: propsCollapsedFields = [], FieldRenderer: FieldRenderer, tabIndex: tabIndex = 0, // TODO Remove "= 0" when cleaning gic-smart-fields-jira-labs_8uwvr
    ...rest } = props;
    const [{ ecosystem: { forge: { hasFinishedLoading: hasFinishedLoading } } }] = (0, $fswni.useFormContext)();
    const uiModificationsStatus = (0, $1ttZy.useUiModificationsEnabledStatus)(hasFinishedLoading);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { collapsedFields: collapsedFields, fields: fields } = (0, $eUqFw.useMemo)(()=>{
        let collapsedFieldsFound = uiModificationsStatus !== 'enabled' ? propsCollapsedFields : [];
        let fieldsFound = propFields.filter((field)=>!collapsedFieldsFound.includes(field));
        if (!fieldsFound.length && collapsedFieldsFound.length) {
            fieldsFound = collapsedFieldsFound;
            collapsedFieldsFound = [];
        }
        return {
            collapsedFields: collapsedFieldsFound,
            fields: fieldsFound
        };
    }, [
        propFields,
        propsCollapsedFields,
        uiModificationsStatus
    ]);
    const [isExpanded, { setExpandedCollapsedArea: setExpandedCollapsedArea }] = (0, $fswni.useIsCollapsedAreaExpanded)(tabIndex);
    // isCollapsed is only true once. When it's false, it should never get back to true
    const isCollapsed = (0, $eUqFw.useRef)(!isExpanded);
    // TODO Remove this condition when cleaning gic-smart-fields-jira-labs_8uwvr
    if (!FieldRenderer) return null;
    const handleOnClick = (_, analyticsEvent)=>{
        isCollapsed.current = false;
        const isExpandedNewValue = !isExpanded;
        setExpandedCollapsedArea(tabIndex, isExpandedNewValue);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'moreFields', {
            isExpanded: isExpandedNewValue
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $679a9ba22fb618ed$var$fieldsContainerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FieldRenderer, {
        ...rest,
        fields: fields
    }), !!collapsedFields.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($679a9ba22fb618ed$var$CollapsibleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2daeC.CollapsibleAreaHeader), {
        totalFields: collapsedFields.length,
        isExpanded: isExpanded,
        onClick: handleOnClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($679a9ba22fb618ed$var$CollapsibleArea, {
        isExpanded: isExpanded
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $l9zVu.default).smartFieldsReadMore, {
        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                href: "/jira/settings/personal/general#smart-fields-preference",
                target: "_blank",
                rel: "noopener noreferrer"
            }, chunks)
    })), isCollapsed.current ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FieldRenderer, {
        ...rest,
        fields: collapsedFields,
        isCollapsed: isCollapsed.current
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($679a9ba22fb618ed$export$b533c285325ee313, {
        ...rest,
        FieldRenderer: FieldRenderer,
        fields: collapsedFields
    }))));
};
const $679a9ba22fb618ed$export$b533c285325ee313 = ({ FieldRenderer: FieldRenderer, ...rest })=>{
    const [loaded, setLoaded] = (0, $eUqFw.useState)(false);
    const [isFieldResponsive, setIsFieldResponsive] = (0, $eUqFw.useState)(false);
    const collapsibleAreaRef = (0, $eUqFw.useRef)(null);
    (0, $7uxUn.useResizeObserver)({
        ref: collapsibleAreaRef,
        onResize () {
            setIsFieldResponsive(window.innerWidth < 560);
        }
    });
    (0, $eUqFw.useEffect)(()=>{
        setLoaded(true);
    }, []);
    if (!loaded) return null;
    if (!FieldRenderer) return null; // TODO Delete this condition when cleaning gic-smart-fields-jira-labs_8uwvr
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: collapsibleAreaRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(FieldRenderer, {
        ...rest,
        isFieldResponsive: isFieldResponsive
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $679a9ba22fb618ed$var$CollapsibleWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19it1pvm _2rko1y44 _19pkpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $679a9ba22fb618ed$var$CollapsibleArea = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isExpanded: isExpanded, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            !__cmplp.isExpanded ? "_1e0cglyw" : "_18u01f4h _otyrpxbi _1yt4u2gc _u5f3pxbi _ca0qidpf",
            __cmplp.className
        ])
    });
});
const $679a9ba22fb618ed$var$fieldsContainerWrapperStyles = (0, $1ZAYh.xcss)({
    paddingBottom: 'space.200'
});

});
parcelRegister("7uxUn", function(module, exports) {

$parcel$export(module.exports, "createResizeObserverHook", () => $dc839ec384d19a4a$export$87a9d3e287304ae4);
$parcel$export(module.exports, "useResizeObserver", () => $dc839ec384d19a4a$export$683480f191c0e3ea);
$parcel$export(module.exports, "flushResizeObservers", () => $dc839ec384d19a4a$export$a181ef2a6d0a1bb6);
$parcel$export(module.exports, "useRectObserver", () => $dc839ec384d19a4a$export$e58143dc89297272);

var $eUqFw = parcelRequire("eUqFw");

var $gDQs6 = parcelRequire("gDQs6");
function $dc839ec384d19a4a$export$87a9d3e287304ae4(params) {
    const group = new (0, $gDQs6.ResizeObserverGroup)(params?.debouncePeriod);
    /**
	 * This hook uses a shared ResizeObserver instance.
	 *
	 * When a resize notification comes in, a single batched React update will be
	 * dispatched after a debounce period only for the elements that have been
	 * resized.
	 *
	 * This does NOT react to updates to REF
	 */ function useResizeObserver({ ref: ref, onResize: onResize }) {
        const onResizeRef = (0, $eUqFw.useRef)(onResize);
        (0, $eUqFw.useEffect)(()=>{
            onResizeRef.current = onResize;
        });
        const stableOnResize = (0, $eUqFw.useCallback)(()=>onResizeRef.current(), []);
        (0, $eUqFw.useLayoutEffect)(()=>group.observe(ref, stableOnResize), [
            ref,
            stableOnResize
        ]);
    }
    return {
        useResizeObserver: useResizeObserver,
        flushResizeObservers: ()=>group.flush()
    };
}
const { useResizeObserver: $dc839ec384d19a4a$export$683480f191c0e3ea, flushResizeObservers: $dc839ec384d19a4a$export$a181ef2a6d0a1bb6 } = $dc839ec384d19a4a$export$87a9d3e287304ae4();
function $dc839ec384d19a4a$export$e58143dc89297272({ ref: ref, useResizeObserverDI: useResizeObserverDI = $dc839ec384d19a4a$export$683480f191c0e3ea }) {
    const [rect, setRect] = (0, $eUqFw.useState)(null);
    const onResize = ()=>{
        if (ref.current) setRect(ref.current.getBoundingClientRect());
    };
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (!ref.current) throw new Error([
            'useRectObserver: ref is not available on mount.',
            'This means you are attaching refs conditionally onto your elements, for example in with an early return.',
            'This will not work properly. Please update your code so that refs are always attached to components on mount.'
        ].join('\n'));
        setRect(ref.current.getBoundingClientRect());
    }, [
        ref
    ]);
    useResizeObserverDI({
        ref: ref,
        onResize: onResize
    });
    return rect;
}

});
parcelRegister("gDQs6", function(module, exports) {

$parcel$export(module.exports, "ResizeObserverGroup", () => $91e461fbc4ab66c0$export$607798bbe2869c0);

var $lEfVV = parcelRequire("lEfVV");

var $dxIU5 = parcelRequire("dxIU5");
class $91e461fbc4ab66c0$export$607798bbe2869c0 {
    constructor(debouncePeriod = 16){
        this.subscribers = new Map();
        this.pendingUpdates = new Map();
        this.onResize = (entries)=>{
            entries.forEach((entry)=>{
                const subscriber = this.subscribers.get(entry.target);
                if (subscriber) this.pendingUpdates.set(subscriber.element, subscriber);
            });
            this.scheduleFlush();
        };
        this.observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(this.onResize) : null;
        this.scheduleFlush = debouncePeriod > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(()=>{
            this.flush();
        }, debouncePeriod, {
            trailing: true,
            maxWait: 32
        }) : ()=>{
            this.flush();
        };
    }
    observe(ref, callback) {
        if (!ref.current) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        this.subscribers.set(ref.current, {
            element: ref.current,
            callback: callback
        });
        this.observer?.observe(ref.current);
        return ()=>{
            if (!ref.current) return;
            this.subscribers.delete(ref.current);
            this.pendingUpdates.delete(ref.current);
            this.observer?.unobserve(ref.current);
        };
    }
    flush() {
        const entries = Array.from(this.pendingUpdates.values()).filter((entry)=>this.subscribers.has(entry.element));
        this.pendingUpdates.clear();
        (0, $lEfVV.unstable_batchedUpdates)(()=>{
            entries.forEach(({ callback: callback })=>{
                callback();
            });
        });
    }
}

});


parcelRegister("2daeC", function(module, exports) {

$parcel$export(module.exports, "CollapsibleAreaHeader", () => $1db09c38a2aeb773$export$8761b26214731920);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $86Ndv = parcelRequire("86Ndv");

var $dtaN9 = parcelRequire("dtaN9");

var $ffiyv = parcelRequire("ffiyv");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $5JgJ2 = parcelRequire("5JgJ2");

var $63pq8 = parcelRequire("63pq8");

var $eYIhO = parcelRequire("eYIhO");
const $1db09c38a2aeb773$export$875f349363bf5c2a = 'issue-create.ui.modal.create-form.layout-renderer.fields-container.collapsible-area-header.collapsible-area-header';
const $1db09c38a2aeb773$export$8761b26214731920 = ({ totalFields: totalFields, isExpanded: isExpanded, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const buttonAlt = isExpanded ? (0, $63pq8.messages).hideMoreFields : (0, $63pq8.messages).showMoreFields;
    const { isSmartFieldsNew: isSmartFieldsNew } = (0, $eYIhO.useSyncNewLozenge)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $1db09c38a2aeb773$var$buttonContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1db09c38a2aeb773$var$HeaderButton, {
        iconBefore: isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
            label: ""
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))), {
            label: ""
        }),
        appearance: "subtle-link",
        title: formatMessage(buttonAlt, {
            totalFields: totalFields
        }),
        onClick: onClick,
        testId: $1db09c38a2aeb773$export$875f349363bf5c2a,
        shouldFitContainer: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1db09c38a2aeb773$var$HeaderButtonContent, null, formatMessage((0, $63pq8.messages).moreFields, {
        totalFields: totalFields
    }), isSmartFieldsNew && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
        appearance: "new"
    }, formatMessage((0, $63pq8.messages).newLozenge))))));
};
const $1db09c38a2aeb773$var$buttonHeight = '40px';
const $1db09c38a2aeb773$var$buttonContainerStyles = (0, $1ZAYh.xcss)({
    // Button ring outline displays outside collapsible area. This padding is used to make them the same position
    padding: 'space.025'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1db09c38a2aeb773$var$HeaderButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1ylp _y3gn1e5h",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1db09c38a2aeb773$var$HeaderButtonContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vwz41ylp _18u012x7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("63pq8", function(module, exports) {

$parcel$export(module.exports, "messages", () => $e7a913f71f9b39b1$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $e7a913f71f9b39b1$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    moreFields: {
        "id": "issue-create.modal.create-form.layout-renderer.fields-container.collapsible-area-header.more-fields",
        "defaultMessage": "More fields ({totalFields})"
    },
    showMoreFields: {
        "id": "issue-create.modal.create-form.layout-renderer.fields-container.collapsible-area-header.show-more-fields",
        "defaultMessage": "{totalFields, plural, one {Show one more field} other {Show # more fields}}"
    },
    hideMoreFields: {
        "id": "issue-create.modal.create-form.layout-renderer.fields-container.collapsible-area-header.hide-more-fields",
        "defaultMessage": "{totalFields, plural, one {Hide one more field} other {Hide # more fields}}"
    },
    newLozenge: {
        "id": "issue-create.modal.create-form.layout-renderer.fields-container.collapsible-area-header.new-lozenge",
        "defaultMessage": "New"
    }
});

});

parcelRegister("eYIhO", function(module, exports) {

$parcel$export(module.exports, "useSyncNewLozenge", () => $f89e208f8e993487$export$2eb02503266aeaa2);

var $eUqFw = parcelRequire("eUqFw");

var $fswni = parcelRequire("fswni");

var $8ARYh = parcelRequire("8ARYh");

var $jlBE2 = parcelRequire("jlBE2");
const $f89e208f8e993487$export$2eb02503266aeaa2 = ()=>{
    const { isSmartFieldsOptIn: isSmartFieldsOptIn, isSmartFieldDismissedReadMore: isSmartFieldDismissedReadMore, dismissReadMore: dismissReadMore } = (0, $jlBE2.useIsSmartFieldsOptIn)();
    const { updatePreferences: updatePreferences } = (0, $8ARYh.useSmartFieldsUpdateUserPreference)();
    const dismissLozenge = (0, $eUqFw.useCallback)(async ()=>{
        dismissReadMore();
        await updatePreferences({
            hasUserOptedOut: !isSmartFieldsOptIn,
            hasUserDismissedReadMore: true
        });
    }, [
        dismissReadMore,
        isSmartFieldsOptIn,
        updatePreferences
    ]);
    const [isSmartFieldsNew, { setIsSmartFieldsNew: setIsSmartFieldsNew }] = (0, $fswni.useIsSmartFieldsNew)();
    (0, $eUqFw.useEffect)(()=>{
        if (isSmartFieldsNew === undefined && !isSmartFieldDismissedReadMore) {
            setIsSmartFieldsNew(true);
            dismissLozenge();
        }
    }, [
        isSmartFieldsNew,
        isSmartFieldDismissedReadMore,
        setIsSmartFieldsNew,
        dismissLozenge
    ]);
    return {
        isSmartFieldsNew: isSmartFieldsNew
    };
};

});


parcelRegister("l9zVu", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfd85ec08e50fea5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $cfd85ec08e50fea5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    smartFieldsReadMore: {
        "id": "issue-create.modal.create-form.layout-renderer.fields-container.smart-fields-read-more",
        "defaultMessage": "Fields you don\u2019t use often are automatically listed here. <link>Read more about the fields available when creating issues</link>"
    }
});

});



parcelRegister("64AaJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c3129e1df871548$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $6c3129e1df871548$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    projectFieldLabel: {
        "id": "issue-create.modal.create-form.project-field-label",
        "defaultMessage": "Projects"
    },
    createSuccessFlagTitle: {
        "id": "issue-create.modal.create-form.create-success-flag-title",
        "defaultMessage": "Issue created"
    },
    createSuccessFlagDescription: {
        "id": "issue-create.modal.create-form.create-success-flag-description",
        "defaultMessage": "Issue \"{issueKey}\" has been successfully created."
    },
    createSuccessFlagCta: {
        "id": "issue-create.modal.create-form.create-success-flag-cta",
        "defaultMessage": "View issue"
    },
    createErrorFlagTitle: {
        "id": "issue-create.modal.create-form.create-error-flag-title",
        "defaultMessage": "Couldn't create the issue"
    },
    createErrorFlagDescription: {
        "id": "issue-create.modal.create-form.create-error-flag-description",
        "defaultMessage": "We're having some trouble creating the issue. Refresh the page and try again."
    },
    createErrorForgeInlineField: {
        "id": "issue-create.modal.create-form.create-error-forge-inline-field",
        "defaultMessage": "Unable to save the value for this custom field."
    },
    timeoutForgeInlineFieldTitle: {
        "id": "issue-create.modal.create-form.timeout-forge-inline-field-title",
        "defaultMessage": "Issue created with exceptions"
    },
    timeoutForgeInlineFieldDescription: {
        "id": "issue-create.modal.create-form.timeout-forge-inline-field-description",
        "defaultMessage": "We created your issue but couldn't save the value of <bold>{fields}</bold>. If this happens again, contact your Jira admin"
    },
    requiredFieldsSummary: {
        "id": "issue-create.modal.create-form.required-fields-summary",
        "defaultMessage": "Required fields are marked with an asterisk"
    },
    singleRequiredCustomFieldIssueCreationBlock: {
        "id": "issue-create.modal.create-form.single-required-custom-field-issue-creation-block",
        "defaultMessage": "You can\u2019t create this issue because the required field {fieldName} is hidden. Contact your admin to fix this."
    },
    multipleRequiredCustomFieldsIssueCreationBlock: {
        "id": "issue-create.modal.create-form.multiple-required-custom-fields-issue-creation-block",
        "defaultMessage": "You can\u2019t create this issue because the required fields are hidden: {fieldsName}. Contact your admin to fix this."
    }
});

});

parcelRegister("dtUd8", function(module, exports) {

$parcel$export(module.exports, "ProformaBanner", () => $bdb1847932244ef9$export$d53a0bf1f2b6e7a6);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $23NQ5 = parcelRequire("23NQ5");

var $lRvnl = parcelRequire("lRvnl");
var $cEUHb = parcelRequire("cEUHb");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $d6f6c = parcelRequire("d6f6c");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $jU5O4 = parcelRequire("jU5O4");
const $bdb1847932244ef9$export$d53a0bf1f2b6e7a6 = ({ portalLink: portalLink })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onOpenPortalLinkClick = ()=>{
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'gicProformaBannerOpenPortalButton clicked');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "gicProforma",
        sourceType: (0, $41ea3621645e2acc$export$238d30785c4bca84)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bdb1847932244ef9$export$f316edcbf748c37b, {
        "data-testid": "issue-create.ui.modal.create-form.proforma-banner.banner-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        appearance: "information",
        title: formatMessage((0, $jU5O4.default).title),
        actions: [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cEUHb.default), {
                key: "openPortalLink"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                appearance: "link",
                href: portalLink,
                target: "_blank",
                spacing: "none",
                onClick: onOpenPortalLinkClick,
                onAuxClick: onOpenPortalLinkClick,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bdb1847932244ef9$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($23NQ5))), {
                    label: formatMessage((0, $jU5O4.default).newTabIconDescription),
                    size: "small"
                }))
            }, formatMessage((0, $jU5O4.default).openPortal)))
        ]
    }, formatMessage((0, $jU5O4.default).text))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $d6f6c.FireScreenAnalytics), null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bdb1847932244ef9$var$IconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01b66 _k48p1nn1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $bdb1847932244ef9$export$f316edcbf748c37b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1ejb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jU5O4", function(module, exports) {

$parcel$export(module.exports, "default", () => $971f38cc96c8dbd9$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $971f38cc96c8dbd9$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "issue-create.modal.create-form.proforma-banner.title",
        "defaultMessage": "This request type includes a form that can\u2019t be seen in this view"
    },
    text: {
        "id": "issue-create.modal.create-form.proforma-banner.text",
        "defaultMessage": "Create an issue using all fields on this request type and its form in the portal."
    },
    openPortal: {
        "id": "issue-create.modal.create-form.proforma-banner.open-portal",
        "defaultMessage": "Open portal"
    },
    newTabIconDescription: {
        "id": "issue-create.modal.create-form.proforma-banner.new-tab-icon-description",
        "defaultMessage": "This link will be opened in a new tab"
    }
});

});


parcelRegister("hXuDv", function(module, exports) {

$parcel$export(module.exports, "default", () => $46d85864ff0e2b75$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $illlw = parcelRequire("illlw");

var $iZuDo = parcelRequire("iZuDo");

var $7jPhn = parcelRequire("7jPhn");
var $4LhB6 = parcelRequire("4LhB6");

var $5wCDk = parcelRequire("5wCDk");

var $5JgJ2 = parcelRequire("5JgJ2");

var $icPhQ = parcelRequire("icPhQ");

var $fFvAc = parcelRequire("fFvAc");

var $fswni = parcelRequire("fswni");

var $bKilX = parcelRequire("bKilX");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $aqi5n = parcelRequire("aqi5n");

var $aJRvJ = parcelRequire("aJRvJ");


var $Hsrj4 = parcelRequire("Hsrj4");

var $jOrZH = parcelRequire("jOrZH");

var $8t3S6 = parcelRequire("8t3S6");
const $46d85864ff0e2b75$var$ProjectPicker = (props)=>{
    const { onChange: onChange, value: selectedProjectValue, renderOptionsLimit: renderOptionsLimit, skipFetchProjects: skipFetchProjects = false, isDisabled: isDisabled = false, disableFetchProject: disableFetchProject = false, width: width } = props;
    const [{ meta: { submitFieldwiseErrors: submitFieldwiseErrors } }] = (0, $fswni.useFormContext)();
    const [recentProjects, setRecentProjects] = (0, $eUqFw.useState)([]);
    const [filterQuery, setFilterQuery] = (0, $eUqFw.useState)('');
    const [allProjects, setAllProjects] = (0, $eUqFw.useState)([]);
    const [isLoading, setLoading] = (0, $eUqFw.useState)(true);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const shouldFetchProjects = (0, $eUqFw.useRef)(true);
    const [fetchProjects] = (0, $iZuDo.useLazyQuery)((0, $Hsrj4.PROJECTS_LIST_QUERY), {
        fetchPolicy: 'no-cache',
        onCompleted: (data)=>{
            setRecentProjects((0, $aJRvJ.transformProjects)((0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(data, 'recentProjects.nodes', [])));
            setAllProjects((0, $aJRvJ.transformProjects)((0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(data, 'allProjects.nodes', [])));
            setLoading(false);
        }
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onProjectPickerInputChange = (query)=>{
        setFilterQuery(query);
    };
    (0, $eUqFw.useEffect)(()=>{
        if (selectedProjectValue && shouldFetchProjects.current || skipFetchProjects) {
            shouldFetchProjects.current = false;
            disableFetchProject ? setLoading(false) : fetchProjects();
        }
    }, [
        fetchProjects,
        selectedProjectValue,
        skipFetchProjects,
        disableFetchProject
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (submitFieldwiseErrors?.project) (0, $aqi5n.scrollToElement)((0, $64c826ca9a56ba8f$export$e2b449031137335a));
    }, [
        submitFieldwiseErrors?.project
    ]);
    const onOptionSelect = (project)=>{
        if (project?.value === projectValue?.value) return;
        const analyticsEvent = createAnalyticsEvent({
            action: 'selected',
            actionSubject: 'option'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'project');
        onChange(project);
    };
    const filteredOptions = (0, $eUqFw.useMemo)(()=>{
        const { filteredAllProjects: filteredAllProjects, filteredRecentProjects: filteredRecentProjects } = (0, $8t3S6.getFilteredOptions)({
            recentProjects: recentProjects,
            allProjects: allProjects,
            filterQuery: filterQuery,
            renderOptionsLimit: renderOptionsLimit
        });
        return [
            {
                label: formatMessage((0, $jOrZH.default).recentProjects),
                options: filteredRecentProjects
            },
            {
                label: formatMessage((0, $jOrZH.default).allProjects),
                options: filteredAllProjects
            }
        ];
    }, [
        recentProjects,
        allProjects,
        filterQuery,
        formatMessage,
        renderOptionsLimit
    ]);
    const projectValue = (0, $eUqFw.useMemo)(()=>selectedProjectValue && {
            ...selectedProjectValue,
            iconUrl: (0, $fFvAc.transformStargateUrl)(selectedProjectValue?.iconUrl || '')
        }, [
        selectedProjectValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        name: "project",
        label: formatMessage((0, $jOrZH.default).projectFieldLabel),
        isRequired: true
    }, ({ fieldProps: { id: id, isRequired: isRequired } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
            inputId: id,
            required: isRequired,
            options: filteredOptions,
            onInputChange: onProjectPickerInputChange,
            filterOption: null,
            // @ts-expect-error - TS2322 - Type '(project: Project) => void' is not assignable to type '(value: Option | null, action: ActionMeta<Option>) => void'.
            onChange: onOptionSelect,
            value: projectValue,
            isClearable: false,
            formatOptionLabel: (0, $bKilX.formatOptionLabel),
            hideSelectedOptions: false,
            placeholder: "",
            isLoading: isLoading,
            isDisabled: isDisabled,
            id: (0, $64c826ca9a56ba8f$export$e2b449031137335a),
            onKeyDown: (0, $aqi5n.preventEscKeyPropagationKeyPressHandler)
        }), submitFieldwiseErrors?.project && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, submitFieldwiseErrors.project))));
};
var $46d85864ff0e2b75$export$2e2bcd8739ae039 = $46d85864ff0e2b75$var$ProjectPicker;

});
const $64c826ca9a56ba8f$export$e2b449031137335a = 'issue-create.ui.modal.create-form.project-picker.project-select';

parcelRegister("Hsrj4", function(module, exports) {

$parcel$export(module.exports, "PROJECTS_LIST_QUERY", () => $c7ebbf1e87a55b0a$export$5ea959507154c1b9);
// eslint-disable-next-line jira/restricted/graphql-tag

var $9ypom = parcelRequire("9ypom");

var $frihL = parcelRequire("frihL");
const $c7ebbf1e87a55b0a$export$5ea959507154c1b9 = (0, $9ypom.default)`
	query JiraProjects {
		recentProjects: jiraProjects(context: CREATE_ISSUE, recent: true) {
			nodes {
				...Project
			}
		}
		allProjects: jiraProjects(context: CREATE_ISSUE, recent: false) {
			nodes {
				...Project
			}
		}
	}
	${(0, $frihL.PROJECT)}
`;

});

parcelRegister("jOrZH", function(module, exports) {

$parcel$export(module.exports, "default", () => $50e56d8bc37834f4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $50e56d8bc37834f4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    projectFieldLabel: {
        "id": "issue-create.modal.create-form.project-picker.project-field-label",
        "defaultMessage": "Project"
    },
    recentProjects: {
        "id": "issue-create.modal.create-form.project-picker.recent-projects",
        "defaultMessage": "Recent Projects"
    },
    allProjects: {
        "id": "issue-create.modal.create-form.project-picker.all-projects",
        "defaultMessage": "All Projects"
    }
});

});

parcelRegister("8t3S6", function(module, exports) {

$parcel$export(module.exports, "getFilteredOptions", () => $1364a0fa3310fc3a$export$25a7cbafb6ed84cb);
const $1364a0fa3310fc3a$export$25a7cbafb6ed84cb = ({ recentProjects: recentProjects, allProjects: allProjects, filterQuery: filterQuery, renderOptionsLimit: renderOptionsLimit })=>{
    const filteredRecentProjects = recentProjects.filter((project)=>project.label.toLowerCase().includes(filterQuery.toLowerCase()) || project.projectKey.toLowerCase().includes(filterQuery.toLowerCase()));
    const filteredAllProjects = allProjects.filter((project, index)=>{
        // if query string is there, don't limit options by limit
        if (filterQuery) return project.label.toLowerCase().includes(filterQuery.toLowerCase()) || project.projectKey.toLowerCase().includes(filterQuery.toLowerCase());
        return index < renderOptionsLimit;
    });
    return {
        filteredRecentProjects: filteredRecentProjects,
        filteredAllProjects: filteredAllProjects
    };
};

});


parcelRegister("7s0Sp", function(module, exports) {

$parcel$export(module.exports, "RequestTypeFieldsLayoutPreference", () => $22dfbc8d2ed9c572$export$c35a954354cf6eee);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $7u4fN = parcelRequire("7u4fN");

var $aUqTb = parcelRequire("aUqTb");

var $3MV1G = parcelRequire("3MV1G");

var $e270j = parcelRequire("e270j");

var $c9TLT = parcelRequire("c9TLT");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $gd0Sp = parcelRequire("gd0Sp");

var $4NPAT = parcelRequire("4NPAT");

var $2ffdv = parcelRequire("2ffdv");
const $22dfbc8d2ed9c572$export$c35a954354cf6eee = ({ isRequestTypeSelected: isRequestTypeSelected, overrideIsEnabled: overrideIsEnabled, onChange: onChangeCallback })=>{
    const { atlassianAccountId: atlassianAccountId } = (0, $gd0Sp.useTenantContext)();
    const [{ data: isEnabled, isLoading: isLoading }, { setPreference: setPreference }] = (0, $4NPAT.useRequestTypeFieldsLayoutPreference)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const [toggleWasClicked, setToggleWasClicked] = (0, $eUqFw.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const isChecked = !toggleWasClicked && overrideIsEnabled !== undefined ? !!overrideIsEnabled : isEnabled;
    const onToggleChanged = (0, $eUqFw.useCallback)(()=>{
        const newValue = !isChecked;
        setToggleWasClicked(true);
        atlassianAccountId && setPreference(atlassianAccountId, newValue, createAnalyticsEvent, onChangeCallback);
    }, [
        atlassianAccountId,
        createAnalyticsEvent,
        isChecked,
        onChangeCallback,
        setPreference
    ]);
    const togglePopup = (0, $eUqFw.useCallback)(()=>{
        if (!isOpen) (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'gicRequestTypeToggleLabelButton clicked');
        setIsOpen(!isOpen);
    }, [
        createAnalyticsEvent,
        isOpen
    ]);
    const popupContent = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($22dfbc8d2ed9c572$export$cca08eed9de89ba9, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($22dfbc8d2ed9c572$var$PopupParagraph, null, formatMessage(isRequestTypeSelected ? (0, $2ffdv.default).createFormPopupTextWhenRequestTypeSelected : (0, $2ffdv.default).createFormPopupTextWhenNoRequestTypeSelected))), [
        formatMessage,
        isRequestTypeSelected
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1y6m _4cvr1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $e270j.default), {
        isDisabled: isLoading || !isRequestTypeSelected,
        onChange: onToggleChanged,
        isChecked: isChecked,
        id: "use-request-type-fields-toggle"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("label" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    , {
        htmlFor: "use-request-type-fields-toggle",
        className: (0, $7JEyt.default)([
            "_syaz1ifp _1wybutpp"
        ])
    }, formatMessage((0, $2ffdv.default).toggleLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        placement: "right",
        shouldUseCaptureOnOutsideClick: true,
        isOpen: isOpen,
        onClose: togglePopup,
        content: popupContent,
        zIndex: (0, $c9TLT.layers).tooltip,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            , {
                className: (0, $7JEyt.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _2lx2vrvc _19bv1b66 _nzz51skh _1kd31nn1"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...triggerProps,
                appearance: "subtle-link",
                spacing: "none",
                onClick: togglePopup
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            , {
                className: (0, $7JEyt.default)([
                    "_x5v9sv3s _1b3i658d _syaz149c _30l31kum"
                ]),
                style: {
                    "--_qswcdb": (0, $9t7rW.default)(isOpen ? 'var(--icon-accent-color)' : 'var(--icon-color)')
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aUqTb))), {
                label: "info",
                size: "small"
            }))))
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $22dfbc8d2ed9c572$var$PopupParagraph = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48p1nn1 _1wyb1crf _vwz4gktf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $22dfbc8d2ed9c572$export$cca08eed9de89ba9 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1178 _1yt4pxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2ffdv", function(module, exports) {

$parcel$export(module.exports, "default", () => $629ca5e054f50c1d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $629ca5e054f50c1d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    toggleLabel: {
        "id": "issue-create.modal.create-form.request-type-fields-layout-preference.toggle-label",
        "defaultMessage": "Use request type fields"
    },
    createFormPopupTextWhenRequestTypeSelected: {
        "id": "issue-create.modal.create-form.request-type-fields-layout-preference.create-form-popup-text-when-request-type-selected",
        "defaultMessage": "When this feature is on, you\u2019ll see the fields connected to the request type you\u2019ve selected. When it\u2019s off, you\u2019ll see issue type fields instead."
    },
    createFormPopupTextWhenNoRequestTypeSelected: {
        "id": "issue-create.modal.create-form.request-type-fields-layout-preference.create-form-popup-text-when-no-request-type-selected",
        "defaultMessage": "Select a request type to enable this feature."
    }
});

});


parcelRegister("46CAS", function(module, exports) {

$parcel$export(module.exports, "default", () => $97c4f51abfe03f30$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $96IgR = parcelRequire("96IgR");

var $lRvnl = parcelRequire("lRvnl");

var $PdmhA = parcelRequire("PdmhA");

var $8uD7Y = parcelRequire("8uD7Y");

var $fswni = parcelRequire("fswni");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $gd0Sp = parcelRequire("gd0Sp");

var $47Bba = parcelRequire("47Bba");

var $bqjx6 = parcelRequire("bqjx6");

var $jdzhw = parcelRequire("jdzhw");
const $97c4f51abfe03f30$var$SectionMessages = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [{ meta: meta }] = (0, $fswni.useFormContext)();
    const [issueAdjustmentError] = (0, $47Bba.useUiModificationsErrors)();
    const { isSiteAdmin: isSiteAdmin } = (0, $gd0Sp.useTenantContext)();
    (0, $eUqFw.useEffect)(()=>{
        if (!meta.areRequiredFieldsSupported) {
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'banner',
                action: 'viewed'
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'globalIssueCreateMandatoryFieldsUnsupported');
        }
    }, [
        createAnalyticsEvent,
        meta.areRequiredFieldsSupported
    ]);
    if (meta.queryErrorMessage !== '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        appearance: "error",
        testId: "issue-create.ui.modal.create-form.section-messages.query-error-message"
    }, meta.queryErrorMessage);
    if (meta.submitErrorMessage !== undefined && meta.submitErrorMessage !== '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        appearance: "error",
        testId: "issue-create.ui.modal.create-form.section-messages.submit-error-message"
    }, (0, $jdzhw.getDisplayErrorString)(meta.submitErrorMessage).map((error, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($97c4f51abfe03f30$var$MessageWrapper, {
            key: index
        }, error)));
    if (!meta.areRequiredFieldsSupported) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceName: "globalIssueCreateMandatoryFieldsUnsupported",
        sourceType: (0, $41ea3621645e2acc$export$238d30785c4bca84)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        appearance: "error",
        testId: "issue-create.ui.modal.create-form.section-messages.required-fields-message"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...isSiteAdmin ? (0, $bqjx6.default).requiredFieldsUnsupportedForAdmin : (0, $bqjx6.default).requiredFieldsUnsupportedForUser,
        values: {
            a: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                    href: "/jira/contact-administrator"
                }, chunks),
            button: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($96IgR))), {
                    label: "incompatible-field-error",
                    size: "medium",
                    primaryColor: `var(--ds-icon-subtle, ${(0, $PdmhA).N200})`
                })
        }
    })));
    if (meta.inlineCreateError && meta.inlineCreateError?.errors.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        appearance: "error",
        testId: "issue-create.ui.modal.create-form.section-messages.inline-create-errors",
        title: meta.inlineCreateError.title || ''
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("ul", null, meta.inlineCreateError.errors.map((error, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("li", {
            key: `inline-error-${index}`
        }, error))));
    if (issueAdjustmentError !== null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        appearance: "error",
        testId: "issue-create.ui.modal.create-form.section-messages.ui-modifications-error-message"
    }, issueAdjustmentError.message);
    return null;
};
var $97c4f51abfe03f30$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $97c4f51abfe03f30$var$SectionMessages;
const $97c4f51abfe03f30$var$MessageWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "pre", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ect41kw7 _1wyb1kw7 _o5721jtm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("47Bba", function(module, exports) {

$parcel$export(module.exports, "useUiModificationsErrors", () => $494457c891f1fbeb$export$72f28c8f041a8bab);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $56Q41 = parcelRequire("56Q41");

var $SXhMX = parcelRequire("SXhMX");
const $494457c891f1fbeb$export$72f28c8f041a8bab = ()=>{
    const error = (0, $56Q41.useError)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [errorMessage, setErrorMessage] = (0, $eUqFw.useState)(null);
    (0, $eUqFw.useEffect)(()=>{
        if (!error) setErrorMessage(null);
        else {
            const message = (0, $SXhMX.errorCodeToErrorMessageMap)[error.errorCode];
            const formattedMessage = formatMessage(message);
            setErrorMessage(formattedMessage);
        }
    }, [
        error,
        formatMessage
    ]);
    return errorMessage ? [
        {
            message: errorMessage
        }
    ] : [
        null
    ];
};

});
parcelRegister("56Q41", function(module, exports) {

$parcel$export(module.exports, "useError", () => $73f0395d1582326f$export$5027865de34f9ec6);

var $ggKAj = parcelRequire("ggKAj");

var $fcNlw = parcelRequire("fcNlw");
const $73f0395d1582326f$export$5027865de34f9ec6 = (0, $ggKAj.createStateHook)((0, $fcNlw.store), {
    selector: (state)=>state.error
});

});

parcelRegister("SXhMX", function(module, exports) {

$parcel$export(module.exports, "errorCodeToErrorMessageMap", () => $1e1c13f830772e92$export$c36ca6969b1c2a38);

var $72J3V = parcelRequire("72J3V");
const $1e1c13f830772e92$export$c36ca6969b1c2a38 = {
    ON_BRIDGE_ERROR_ERROR_CODE: (0, $72J3V.default).applyingUimFailed,
    USE_REGISTER_FIELDS_ERROR_CODE: (0, $72J3V.default).applyingUimFailed,
    USE_SUBMIT_ERROR_CODE: (0, $72J3V.default).applyingUimFailed,
    APPLY_BUFFER_CHANGES_ERROR: (0, $72J3V.default).applyingUimFailed,
    MULTI_APP_CONFLICT: (0, $72J3V.default).multiAppConflict,
    BUFFERING_TIMEOUT: (0, $72J3V.default).bufferTimeout,
    UIM_FETCH_FAILED_ERROR_CODE: (0, $72J3V.default).loadingUimDataFailed,
    PER_FIELD_HOOK_ERROR_CODE: (0, $72J3V.default).applyingUimFailed,
    SCOPES_MISSING_ERROR_CODE: (0, $72J3V.default).appDoesNotHaveRequiredScopes,
    ERROR_BOUNDARY_HANDLER_ERROR_CODE: (0, $72J3V.default).applyingUimFailed,
    ON_INIT_FIELDS_INITIALIZATION_TIMEOUT: (0, $72J3V.default).loadingUimFailed
};

});
parcelRegister("72J3V", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f8058b2115dc722$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7f8058b2115dc722$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    loadingUimFailed: {
        "id": "ui-modifications-view-gic.use-ui-modifications-errors.loading-uim-failed",
        "defaultMessage": "We couldn't load the UI modifications for this form."
    },
    loadingUimDataFailed: {
        "id": "ui-modifications-view-gic.use-ui-modifications-errors.loading-uim-data-failed",
        "defaultMessage": "We couldn't load the UI modifications configuration for this form."
    },
    applyingUimFailed: {
        "id": "ui-modifications-view-gic.use-ui-modifications-errors.applying-uim-failed",
        "defaultMessage": "We encountered an error while applying UI modifications to this form."
    },
    appDoesNotHaveRequiredScopes: {
        "id": "ui-modifications-view-gic.use-ui-modifications-errors.app-does-not-have-required-scopes",
        "defaultMessage": "We couldn\u2019t load some of the UI modifications apps for this page, because they don\u2019t have required scopes."
    },
    multiAppConflict: {
        "id": "ui-modifications-view-gic.use-ui-modifications-errors.multi-app-conflict",
        "defaultMessage": "Multiple UI modifications apps tried to call the same API method on the same field. All customizations have been dismissed."
    },
    bufferTimeout: {
        "id": "ui-modifications-view-gic.use-ui-modifications-errors.buffer-timeout",
        "defaultMessage": "Some of the UI modifications apps did not apply changes before the timeout and have been dismissed."
    }
});

});



parcelRegister("bqjx6", function(module, exports) {

$parcel$export(module.exports, "default", () => $db4fd48dc5b91708$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $db4fd48dc5b91708$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    requiredFieldsUnsupportedForAdmin: {
        "id": "issue-create.modal.create-form.section-messages.required-fields-unsupported-for-admin",
        "defaultMessage": "Field(s) marked with <button></button> aren't supported. To continue creating issues, make the field(s) optional and remove the field(s) from this screen."
    },
    requiredFieldsUnsupportedForUser: {
        "id": "issue-create.modal.create-form.section-messages.required-fields-unsupported-for-user",
        "defaultMessage": "Field(s) marked with <button></button> aren't supported. To continue creating issues, <a>reach out to your Jira admin</a> to make the field(s) optional and remove the field(s) from this screen."
    }
});

});

parcelRegister("jdzhw", function(module, exports) {

$parcel$export(module.exports, "getDisplayErrorString", () => $eb33011663bd2805$export$3455fb62ca5e4ef7);
const $eb33011663bd2805$export$3455fb62ca5e4ef7 = (submitErrorMessage)=>{
    try {
        // Error in json:
        // "{\"errorMessages\":[],\"errors\":{\"assignee\":\"The default assignee does NOT have ASSIGNABLE permission OR Unassigned issues are turned off.\",\"othererror\":\"xxxx.\"}}";
        const errsObj = JSON.parse(submitErrorMessage);
        if (errsObj.errors) {
            const values = Object.values(errsObj.errors).filter((value)=>typeof value === 'string');
            if (values.length > 0) return values;
        }
    } catch (error) {
    /* empty */ }
    return [
        submitErrorMessage
    ];
};

});


parcelRegister("jbgmS", function(module, exports) {

$parcel$export(module.exports, "default", () => $92e290ee801b73b3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7jPhn = parcelRequire("7jPhn");
var $4LhB6 = parcelRequire("4LhB6");

var $5wCDk = parcelRequire("5wCDk");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $aR8n6 = parcelRequire("aR8n6");

var $5JgJ2 = parcelRequire("5JgJ2");

var $icPhQ = parcelRequire("icPhQ");

var $kNatw = parcelRequire("kNatw");

var $eiTYw = parcelRequire("eiTYw");

var $dFQsk = parcelRequire("dFQsk");
const $92e290ee801b73b3$var$SitePicker = (props)=>{
    const { classNamePrefix: classNamePrefix, onChange: onChange, width: width = 350 } = props;
    const [, { setSitePickerState: setSitePickerState }] = (0, $kNatw.useSitePickerContext)();
    const { sites: sites, error: error, isLoading: isLoading } = (0, $eiTYw.default)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [selectedValue, setSelectedValue] = (0, $eUqFw.useState)({});
    (0, $eUqFw.useEffect)(()=>{
        if (!sites) return;
        const currentSite = window.location.hostname.split('.')[0];
        const prefilledValue = sites?.filter((site)=>site.label === currentSite)?.[0] || {};
        setSitePickerState({
            siteDomain: prefilledValue.url || ''
        });
        setSelectedValue(prefilledValue);
    }, [
        setSitePickerState,
        sites
    ]);
    const _onChange = (0, $eUqFw.useCallback)((option)=>{
        setSitePickerState({
            siteDomain: option?.url || '',
            selectedCloudId: option?.value || ''
        });
        onChange?.();
        setSelectedValue(option || {});
    }, [
        setSitePickerState,
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aR8n6.default), {
        packageName: "jiraIssueCreate",
        id: "JiraSitePickerSelect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        width: width
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
        name: "site",
        label: formatMessage((0, $dFQsk.default).sitePickerFieldLabel)
    }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
            inputId: fieldProps?.id,
            value: selectedValue,
            options: sites,
            // @ts-expect-error - TS2322 - Type '(option: SelectOption | null) => void' is not assignable to type '(value: Option | null, action: ActionMeta<Option>) => void'.
            onChange: _onChange,
            classNamePrefix: classNamePrefix,
            isLoading: isLoading
        }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, formatMessage((0, $dFQsk.default).sitePickerError)))))));
};
var $92e290ee801b73b3$export$2e2bcd8739ae039 = $92e290ee801b73b3$var$SitePicker;

});
parcelRegister("eiTYw", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d76e0869de25637$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $eEzyV = parcelRequire("eEzyV");

var $lRmyA = parcelRequire("lRmyA");
const $8d76e0869de25637$var$AVAILABLE_SITES_ENDPOINT = '/gateway/api/available-sites';
const $8d76e0869de25637$export$8f93d3ef836534e6 = ()=>[
        'jira-product-discovery'
    ];
const $8d76e0869de25637$var$fetchJiraAppLink = async ()=>(0, $lRmyA.performPostRequest)($8d76e0869de25637$var$AVAILABLE_SITES_ENDPOINT, {
        body: JSON.stringify({
            products: [
                'jira-software.ondemand',
                'jira-core.ondemand',
                'jira-servicedesk.ondemand',
                ...$8d76e0869de25637$export$8f93d3ef836534e6()
            ]
        })
    });
const $8d76e0869de25637$export$9d182d381b792de6 = (item)=>({
        label: item.displayName,
        value: item.cloudId,
        url: item.url
    });
const $8d76e0869de25637$export$905fc72a68d660cf = (sites)=>sites.map($8d76e0869de25637$export$9d182d381b792de6);
const $8d76e0869de25637$var$useFetchJiraAvailableSites = ()=>{
    const { loading: loading, error: error, data: data, fetch: fetch } = (0, $eEzyV.useService)($8d76e0869de25637$var$fetchJiraAppLink);
    (0, $eUqFw.useEffect)(()=>{
        fetch();
    }, [
        fetch
    ]);
    const sites = (0, $eUqFw.useMemo)(()=>{
        if (data && data.sites && data.sites.length) return $8d76e0869de25637$export$905fc72a68d660cf(data.sites);
        return [];
    }, [
        data
    ]);
    return {
        isLoading: loading,
        error: error,
        sites: sites
    };
};
var $8d76e0869de25637$export$2e2bcd8739ae039 = $8d76e0869de25637$var$useFetchJiraAvailableSites;

});

parcelRegister("dFQsk", function(module, exports) {

$parcel$export(module.exports, "default", () => $599d39cfdfd23127$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $599d39cfdfd23127$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    sitePickerFieldLabel: {
        "id": "issue-create.modal.create-form.site-picker.site-picker-field-label",
        "defaultMessage": "Site"
    },
    sitePickerError: {
        "id": "issue-create.modal.create-form.site-picker.site-picker-error",
        "defaultMessage": "Error in fetching the site options"
    }
});

});


parcelRegister("kF8Vn", function(module, exports) {

$parcel$export(module.exports, "default", () => $cda1203cfa3f6554$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7jPhn = parcelRequire("7jPhn");
var $6ROLN = parcelRequire("6ROLN");

var $5YsMl = parcelRequire("5YsMl");

var $PdmhA = parcelRequire("PdmhA");

var $9VPEO = parcelRequire("9VPEO");

var $c9TLT = parcelRequire("c9TLT");

var $5JgJ2 = parcelRequire("5JgJ2");

var $icPhQ = parcelRequire("icPhQ");

var $3BadD = parcelRequire("3BadD");

var $gM8m3 = parcelRequire("gM8m3");

var $27rq3 = parcelRequire("27rq3");
const $cda1203cfa3f6554$var$statusFieldMargin = (0, $c9TLT.gridSize) * 2.25;
const $cda1203cfa3f6554$var$StatusField = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const defaultProps = {
        isLoading: false,
        footer: undefined,
        fieldId: 'gic-status-field'
    };
    const getEnabledTransitions = (transitions)=>transitions.filter((transition)=>transition.isDisabled === false);
    const getFieldContent = ()=>{
        if (props.isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cda1203cfa3f6554$var$FieldSkeleton, {
            isMini: props.isMini,
            "aria-busy": true
        });
        if (!props.value?.to) // error state
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cda1203cfa3f6554$var$FieldErrorSkeleton, {
            isMini: props.isMini
        });
        if (props.error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cda1203cfa3f6554$var$FieldErrorSkeleton, {
            isMini: props.isMini
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3BadD.StatusView), {
            ...defaultProps,
            appearance: "button",
            value: props.value?.to,
            selectedTransition: props.value,
            transitions: getEnabledTransitions(props.transitions),
            forceNoLabels: true,
            isDefaultSelect: props.isMini,
            onChange: props.onChange,
            customNoOptionsMessage: formatMessage((0, $27rq3.default).noEnabledTransitionsMessage),
            shouldFitContainer: false
        });
    };
    const getHelpOrWarningText = ()=>{
        if (props.error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.HelperMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5YsMl))), {
            size: "small",
            primaryColor: `var(--ds-icon-warning, ${(0, $PdmhA).Y500})`,
            label: formatMessage((0, $27rq3.default).warningIconLabel)
        }), formatMessage((0, $27rq3.default).warningMessage));
        if (props.isMini) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cda1203cfa3f6554$var$HelperText, null, formatMessage((0, $27rq3.default).helperText));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
        marginTop: $cda1203cfa3f6554$var$statusFieldMargin
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ROLN.Label), {
        htmlFor: defaultProps.fieldId,
        id: "gic-status-field-label"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cda1203cfa3f6554$var$LabelFlex, null, formatMessage((0, $27rq3.default).statusFieldLabel), !props.isMini && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gM8m3.InfoIcon), null))), getFieldContent(), getHelpOrWarningText());
};
var $cda1203cfa3f6554$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $cda1203cfa3f6554$var$StatusField;
const $cda1203cfa3f6554$var$HelperText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1wmz _1wyb19bv _vwz47vkz _19pk12x7 _otyru2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cda1203cfa3f6554$var$FieldSkeleton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $9VPEO.Skeleton), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyri2wt",
            __cmplp.isMini ? "_4t3i1ylp _1bsb1osq" : "_4t3izwfg _1bsb68cl",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cda1203cfa3f6554$var$FieldErrorSkeleton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isMini: isMini, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyr12x7 _bfhkqrzy",
            __cmplp.isMini ? "_4t3i1ylp _1bsb1osq" : "_4t3izwfg _1bsb68cl",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cda1203cfa3f6554$var$LabelFlex = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1y6m",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3BadD", function(module, exports) {

$parcel$export(module.exports, "StatusView", () => $d882b3ccfb1ea465$export$a11134e1462e763);
$parcel$export(module.exports, "default", () => $d882b3ccfb1ea465$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2vzCR = parcelRequire("2vzCR");

var $jG2Eu = parcelRequire("jG2Eu");

var $5wCDk = parcelRequire("5wCDk");
var $l44HT = parcelRequire("l44HT");

var $kNcnV = parcelRequire("kNcnV");

var $f8Yej = parcelRequire("f8Yej");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hzcvF = parcelRequire("hzcvF");

var $g8JvH = parcelRequire("g8JvH");
var $jMP2a = parcelRequire("jMP2a");

var $2GJ4g = parcelRequire("2GJ4g");

var $50D0V = parcelRequire("50D0V");

var $99Syk = parcelRequire("99Syk");

var $f3qzK = parcelRequire("f3qzK");

var $5x3wA = parcelRequire("5x3wA");

var $fr49r = parcelRequire("fr49r");

var $dSoqn = parcelRequire("dSoqn");
const $d882b3ccfb1ea465$var$defaultPopperProps = {
    modifiers: [
        {
            name: 'offset',
            options: {
                offset: [
                    0,
                    8
                ]
            }
        },
        {
            name: 'preventOverflow',
            options: {
                padding: 5,
                rootBoundary: 'document'
            }
        }
    ],
    // makes it work inside modal-dialog
    strategy: 'fixed'
};
const $d882b3ccfb1ea465$export$d5aa018254c8c065 = (0, $g8JvH.AnalyticsEventToProps)('statusField', {
    onOpen: 'openDropdown',
    onChange: 'transitionSelected'
})((0, $l44HT.default));
const $d882b3ccfb1ea465$export$f35c79a5a21cbec1 = (0, $g8JvH.AnalyticsEventToProps)('statusField', {
    onOpen: 'openDropdown',
    onChange: 'transitionSelected'
})((0, $5wCDk.default));
const $d882b3ccfb1ea465$var$isOptionDisabled = (option)=>option.transition.isDisabled;
const $d882b3ccfb1ea465$export$a11134e1462e763 = ({ forceNoLabels: forceNoLabels = false, isEditable: isEditable = true, isSaving: isSaving = false, isLoading: isLoading, error: error, value: value, transitions: transitions, appearance: appearance, footer: footer, isDefaultSelect: isDefaultSelect = false, selectedTransition: selectedTransition, onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onOpen: onOpen = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onClose: onClose = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onSuccess: onSuccess, customNoOptionsMessage: customNoOptionsMessage, statusButtonRef: statusButtonRef, popperProps: popperProps, registerInCommandPalette: registerInCommandPalette, onFetch: onFetch, fieldId: fieldId, defaultOpen: // for testing
defaultOpen = false, shouldFitContainer: shouldFitContainer = true })=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const childWrapperRef = (0, $eUqFw.useRef)(null);
    const wasChanged = (0, $eUqFw.useRef)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const previousIsSaving = (0, $hzcvF.usePrevious)(isSaving);
    const previousTransitions = (0, $hzcvF.usePrevious)(transitions);
    const previousIsOpen = (0, $hzcvF.usePrevious)(isOpen);
    const wasFetchSuccessful = transitions != null;
    const filteredAndOrderedTransitions = (0, $50D0V.getFilteredOrderedTransitions)(transitions, value.id);
    const isGlobalOnly = (0, $50D0V.isOnlyGlobalTransitions)(filteredAndOrderedTransitions || []);
    const showLabel = !(forceNoLabels || isGlobalOnly);
    const formatTransitionOptionLabel = (0, $eUqFw.useCallback)((option, transitionProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            "data-testid": "issue-field-status.ui.status-view.transition"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dSoqn.Transition), {
            transition: option.transition,
            hasLabel: showLabel,
            addTransitionArrowSpacing: transitionProps?.addTransitionArrowSpacing
        })), [
        showLabel
    ]);
    // specifically for screen readers
    const getTransitionOptionLabel = (option)=>option.transition.isGlobal ? formatMessage((0, $f3qzK.default).transitionTo, {
            statusName: option.label
        }) : `${option.transition.name} \u{2192} ${option.transition.to.name}`;
    const mergedPopperProps = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))($d882b3ccfb1ea465$var$defaultPopperProps, popperProps), [
        popperProps
    ]);
    // componentWillUpdate
    (0, $eUqFw.useEffect)(()=>{
        if (previousIsSaving === true && isSaving === false) childWrapperRef.current && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        childWrapperRef.current.children.length > 0 && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        childWrapperRef.current.children[0].focus();
    }, [
        isOpen,
        isSaving,
        previousIsOpen,
        previousIsSaving,
        previousTransitions,
        transitions
    ]);
    const handleChangeStatus = (0, $eUqFw.useCallback)((transition, analyticsEvent)=>{
        const { hasScreen: hasScreen } = transition;
        wasChanged.current = true;
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'transitionSelectedStatusField', {
            hasScreen: hasScreen
        });
        onChange?.(transition, analyticsEvent);
    }, [
        onChange
    ]);
    const handleChange = (0, $eUqFw.useCallback)((option, action, analyticsEvent)=>{
        handleChangeStatus(option.transition, analyticsEvent);
    }, [
        handleChangeStatus
    ]);
    const handleOpen = (0, $eUqFw.useCallback)((analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'openDropdownStatusField');
        onOpen?.(analyticsEvent);
        setIsOpen(true);
    }, [
        onOpen
    ]);
    const handleClose = (0, $eUqFw.useCallback)(()=>{
        wasChanged.current = false;
        onClose?.();
        setIsOpen(false);
    }, [
        onClose
    ]);
    const renderLozenge = (0, $eUqFw.useCallback)(({ isEditable: editable, isSaving: saving, error: err, targetRef: targetRef })=>{
        if (saving) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kNcnV.default), {
            border: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2GJ4g.WrappedStatusLozenge), {
            targetRef: targetRef,
            status: value,
            error: error
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2GJ4g.WrappedStatusLozenge), {
            ariaLabel: `${value.name} - ${formatMessage((0, $f3qzK.default).changeStatus)}`,
            error: err,
            hasHoverState: true,
            isEditable: editable,
            isOpen: isOpen,
            status: value,
            targetRef: targetRef
        });
    }, [
        error,
        formatMessage,
        isOpen,
        value
    ]);
    const renderButton = (0, $eUqFw.useCallback)(({ isEditable: editable, isSaving: saving, targetRef: targetRef })=>{
        const statusButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fr49r.StatusButton), {
            ariaLabel: `${value.name} - ${formatMessage((0, $f3qzK.default).changeStatus)}`,
            isEditable: editable,
            isOpen: isOpen,
            status: value,
            targetRef: targetRef,
            statusButtonRef: statusButtonRef,
            shouldFitContainer: shouldFitContainer
        });
        return saving ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kNcnV.default), null, statusButton) : statusButton;
    }, [
        formatMessage,
        isOpen,
        shouldFitContainer,
        statusButtonRef,
        value
    ]);
    const renderCommandPalette = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $99Syk.CommandPaletteStatusView), {
            transitions: filteredAndOrderedTransitions,
            currentStatus: value,
            onSuccess: onSuccess,
            wasFetchSuccessful: wasFetchSuccessful,
            renderTransition: formatTransitionOptionLabel,
            onFetch: onFetch,
            isLoading: isLoading
        }), [
        filteredAndOrderedTransitions,
        value,
        onSuccess,
        wasFetchSuccessful,
        formatTransitionOptionLabel,
        onFetch,
        isLoading
    ]);
    const renderWithFocusWrapper = (0, $eUqFw.useCallback)(// @ts-expect-error - TS2322 - Type 'MutableRefObject<unknown>' is not assignable to type 'LegacyRef<HTMLDivElement> | undefined'.
    (children)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            ref: childWrapperRef
        }, children), []);
    const renderTarget = (0, $eUqFw.useCallback)(({ isEditable: editable, isSaving: saving, error: err, targetRef: targetRef })=>{
        if (value) {
            if (appearance === 'lozenge') return renderWithFocusWrapper(renderLozenge({
                isEditable: editable,
                isSaving: saving,
                error: err,
                targetRef: targetRef
            }));
            if (appearance === 'button') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, renderWithFocusWrapper(renderButton({
                isEditable: editable,
                isSaving: saving,
                targetRef: targetRef
            })), registerInCommandPalette && renderCommandPalette());
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null);
    }, [
        appearance,
        registerInCommandPalette,
        renderButton,
        renderCommandPalette,
        renderLozenge,
        renderWithFocusWrapper,
        value
    ]);
    /* This prevents the dropdown from being accessible while saving/not editable,
   * because for the underlying PopupSelect, the `isDisabled` prop only prevents
   * the actual dropdown items from being selectable - the dropdown itself still
   * pops up/down.
   */ if (isSaving || !isEditable) return renderTarget({
        isSaving: isSaving,
        isEditable: isEditable,
        error: error
    });
    const getNoOptionsMessage = ()=>{
        if (customNoOptionsMessage) return customNoOptionsMessage;
        return formatMessage(wasFetchSuccessful ? (0, $f3qzK.default).noPermission : (0, $f3qzK.default).cannotLoadTransitions);
    };
    const statusPopup = isDefaultSelect && selectedTransition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d882b3ccfb1ea465$export$f35c79a5a21cbec1, {
        inputId: fieldId,
        noOptionsMessage: getNoOptionsMessage,
        formatOptionLabel: formatTransitionOptionLabel,
        getOptionLabel: getTransitionOptionLabel,
        options: (0, $50D0V.transformOptions)(filteredAndOrderedTransitions || []),
        isLoading: isLoading,
        isDisabled: !isEditable,
        isOptionDisabled: $d882b3ccfb1ea465$var$isOptionDisabled,
        onChange: handleChange,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        value: (0, $50D0V.transformOptions)([
            selectedTransition
        ])[0],
        isSearchable: false,
        onOpen: handleOpen,
        onClose: handleClose,
        closeMenuOnSelect: true,
        components: {
            LoadingMessage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5x3wA.LoadingSpinner), null)
        },
        popperProps: mergedPopperProps,
        footer: footer
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d882b3ccfb1ea465$export$d5aa018254c8c065, {
        inputId: fieldId,
        noOptionsMessage: getNoOptionsMessage,
        formatOptionLabel: formatTransitionOptionLabel,
        getOptionLabel: getTransitionOptionLabel,
        options: (0, $50D0V.transformOptions)(filteredAndOrderedTransitions || []),
        target: ({ ref: ref })=>renderTarget({
                isEditable: isEditable,
                isSaving: isSaving,
                error: error,
                targetRef: ref
            }),
        isLoading: isLoading,
        isDisabled: !isEditable,
        isOptionDisabled: $d882b3ccfb1ea465$var$isOptionDisabled,
        searchThreshold: 99999,
        onChange: handleChange,
        onOpen: handleOpen,
        onClose: handleClose,
        closeMenuOnSelect: true,
        components: {
            LoadingMessage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5x3wA.LoadingSpinner), null)
        },
        popperProps: mergedPopperProps,
        footer: footer,
        defaultIsOpen: defaultOpen
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f8Yej.default), {
        onEscape: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
    }, statusPopup);
};
var $d882b3ccfb1ea465$export$2e2bcd8739ae039 = $d882b3ccfb1ea465$export$a11134e1462e763;

});
parcelRegister("kNcnV", function(module, exports) {

$parcel$export(module.exports, "default", () => $615c2b2f32d9571c$export$2e2bcd8739ae039);

var $5oqGi = parcelRequire("5oqGi");
var $615c2b2f32d9571c$export$2e2bcd8739ae039 = (0, $5oqGi.default);

});
parcelRegister("5oqGi", function(module, exports) {

$parcel$export(module.exports, "default", () => $33d7187de9305cdc$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4Bees = parcelRequire("4Bees");
function $33d7187de9305cdc$export$2e2bcd8739ae039(props) {
    const { border: border, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($33d7187de9305cdc$var$BlanketContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($33d7187de9305cdc$var$BackgroundContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($33d7187de9305cdc$var$Background, {
        border: border
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($33d7187de9305cdc$var$ComponentContainer, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($33d7187de9305cdc$var$SpinnerContainer, {
        role: "status",
        "aria-label": "Loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), null)));
}
$33d7187de9305cdc$export$2e2bcd8739ae039.defaultProps = {
    border: true
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $33d7187de9305cdc$var$BlanketContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1e0c116y _2lx2vrvc _4t3i1wug",
            __cmplp.className
        ])
    });
});
const $33d7187de9305cdc$var$SpinnerContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iidpf _1ltvidpf _4t3i1osq _1bsb1osq _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _u5f3u2gc _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $33d7187de9305cdc$var$BackgroundContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _4t3i1osq _1bsb1osq _vchhusvi _1yt483op _1reo1wug _18m91wug",
            __cmplp.className
        ])
    });
});
const $33d7187de9305cdc$var$Background = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { border: border, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _4t3i1osq _1bsb1osq _vchhusvi _bfhk14n2 _2rko1l7b",
            __cmplp.border ? "_19it1qih" : "_19itglyw",
            __cmplp.className
        ])
    });
});
const $33d7187de9305cdc$var$ComponentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_tzy4sxj9 _16jlkb7n _1o9zkb7n _i0dl1wug",
            __cmplp.className
        ])
    });
});

});


parcelRegister("f8Yej", function(module, exports) {

$parcel$export(module.exports, "default", () => $874373505540c4d3$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gtzuR = parcelRequire("gtzuR");
class $874373505540c4d3$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            onEscape: null,
            onEnter: null,
            onBlur: null,
            className: undefined
        };
    }
    componentDidMount() {
        // AK Modal uses document.addEventListener() so we also have to use addEventListener.
        // We can't rely on React Synthetic events as stopPropagation won't work
        // This is due to the way React handles events
        // https://github.com/facebook/react/issues/7094
        if (this.ref) this.ref.addEventListener('keydown', this.handleKeyDown);
    }
    componentWillUnmount() {
        if (this.ref) this.ref.removeEventListener('keydown', this.handleKeyDown);
    }
    render() {
        return(// @ts-expect-error - TS2322 - Type '(() => void) | null' is not assignable to type 'FocusEventHandler<HTMLDivElement> | undefined'.
        // eslint-disable-next-line jira/react/no-classname-attribute, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
            onBlur: this.props.onBlur,
            ref: this.setRef,
            className: this.props.className
        }, this.props.children));
    }
    constructor(...args){
        super(...args);
        this.setRef = (ref)=>{
            this.ref = ref;
        };
        this.handleKeyDown = (event)=>{
            switch(event.keyCode){
                case (0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('escape'):
                    if (this.props.onEscape) {
                        this.props.onEscape(event);
                        event.stopPropagation();
                    }
                    break;
                case (0, (/*@__PURE__*/$parcel$interopDefault($gtzuR)))('enter'):
                    if (this.props.onEnter) {
                        this.props.onEnter(event);
                        event.stopPropagation();
                    }
                    break;
                default:
                    break;
            }
        };
    }
}

});
parcelRegister("gtzuR", function(module, exports) {
// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */ function keyCode(searchInput) {
    // Keyboard Events
    if (searchInput && 'object' === typeof searchInput) {
        var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode;
        if (hasKeyCode) searchInput = hasKeyCode;
    }
    // Numbers
    if ('number' === typeof searchInput) return names[searchInput];
    // Everything else (cast to string)
    var search = String(searchInput);
    // check codes
    var foundNamedKey = codes[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // check aliases
    var foundNamedKey = aliases[search.toLowerCase()];
    if (foundNamedKey) return foundNamedKey;
    // weird character?
    if (search.length === 1) return search.charCodeAt(0);
    return undefined;
}
/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */ keyCode.isEventKey = function isEventKey(event, nameOrCode) {
    if (event && 'object' === typeof event) {
        var keyCode = event.which || event.keyCode || event.charCode;
        if (keyCode === null || keyCode === undefined) return false;
        if (typeof nameOrCode === 'string') {
            // check codes
            var foundNamedKey = codes[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
            // check aliases
            var foundNamedKey = aliases[nameOrCode.toLowerCase()];
            if (foundNamedKey) return foundNamedKey === keyCode;
        } else if (typeof nameOrCode === 'number') return nameOrCode === keyCode;
        return false;
    }
};
exports = module.exports = keyCode;
/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */ var codes = exports.code = exports.codes = {
    'backspace': 8,
    'tab': 9,
    'enter': 13,
    'shift': 16,
    'ctrl': 17,
    'alt': 18,
    'pause/break': 19,
    'caps lock': 20,
    'esc': 27,
    'space': 32,
    'page up': 33,
    'page down': 34,
    'end': 35,
    'home': 36,
    'left': 37,
    'up': 38,
    'right': 39,
    'down': 40,
    'insert': 45,
    'delete': 46,
    'command': 91,
    'left command': 91,
    'right command': 93,
    'numpad *': 106,
    'numpad +': 107,
    'numpad -': 109,
    'numpad .': 110,
    'numpad /': 111,
    'num lock': 144,
    'scroll lock': 145,
    'my computer': 182,
    'my calculator': 183,
    ';': 186,
    '=': 187,
    ',': 188,
    '-': 189,
    '.': 190,
    '/': 191,
    '`': 192,
    '[': 219,
    '\\': 220,
    ']': 221,
    "'": 222
};
// Helper aliases
var aliases = exports.aliases = {
    'windows': 91,
    "\u21E7": 16,
    "\u2325": 18,
    "\u2303": 17,
    "\u2318": 91,
    'ctl': 17,
    'control': 17,
    'option': 18,
    'pause': 19,
    'break': 19,
    'caps': 20,
    'return': 13,
    'escape': 27,
    'spc': 32,
    'spacebar': 32,
    'pgup': 33,
    'pgdn': 34,
    'ins': 45,
    'del': 46,
    'cmd': 91
};
/*!
 * Programatically add the following
 */ // lower case chars
for(i = 97; i < 123; i++)codes[String.fromCharCode(i)] = i - 32;
// numbers
for(var i = 48; i < 58; i++)codes[i - 48] = i;
// function keys
for(i = 1; i < 13; i++)codes['f' + i] = i + 111;
// numpad keys
for(i = 0; i < 10; i++)codes['numpad ' + i] = i + 96;
/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */ var names = exports.names = exports.title = {} // title for backward compat
;
// Create reverse mapping
for(i in codes)names[codes[i]] = i;
// Add aliases
for(var alias in aliases)codes[alias] = aliases[alias];

});


parcelRegister("2GJ4g", function(module, exports) {

$parcel$export(module.exports, "TEST_ID_PREFIX", () => $0211a3ed28924b4c$export$9cbc201c09a37b3f);
$parcel$export(module.exports, "StatusLozenge", () => $0211a3ed28924b4c$export$f72db4ad1e9b3e6d);
$parcel$export(module.exports, "WrappedStatusLozenge", () => $0211a3ed28924b4c$export$69ea4907eefa8e7b);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $bbaTG = parcelRequire("bbaTG");

var $2ziLQ = parcelRequire("2ziLQ");

var $PdmhA = parcelRequire("PdmhA");

var $bR5MV = parcelRequire("bR5MV");

var $iccsh = parcelRequire("iccsh");

var $a8LdG = parcelRequire("a8LdG");
const $0211a3ed28924b4c$export$9cbc201c09a37b3f = 'issue.fields.status.common.ui.status-lozenge.';
const $0211a3ed28924b4c$var$CustomChevronDownGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        width: 12,
        height: 12,
        viewBox: "5 5 13 13"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M8.292 10.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $0211a3ed28924b4c$var$EditableLozenge = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a8LdG.Lozenge), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0211a3ed28924b4c$var$StyledLozengeContentWrapper, null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $0211a3ed28924b4c$var$CustomChevronDownGlyph,
        label: ""
    })));
const $0211a3ed28924b4c$export$f72db4ad1e9b3e6d = ({ status: { name: name, statusCategory: statusCategory }, isEditable: isEditable, hasHoverState: hasHoverState, targetRef: targetRef, shouldShowDropdownIndication: shouldShowDropdownIndication, isDisabled: isDisabled = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0211a3ed28924b4c$var$StyledLozenge, {
        hasHoverState: hasHoverState,
        statusCategoryId: statusCategory.id,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0211a3ed28924b4c$var$StatusContentWrapper, {
        ref: targetRef,
        "data-testid": `${$0211a3ed28924b4c$export$9cbc201c09a37b3f}${statusCategory.id}`
    }, isEditable === true || shouldShowDropdownIndication === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0211a3ed28924b4c$var$EditableLozenge, null, name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $a8LdG.Lozenge), null, name)));
const $0211a3ed28924b4c$export$69ea4907eefa8e7b = (props)=>{
    const { ariaLabel: ariaLabel, error: error, isEditable: isEditable, isOpen: isOpen, targetRef: targetRef, ...other } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
        ref: targetRef,
        appearance: "subtle",
        "aria-label": ariaLabel,
        "aria-expanded": isOpen,
        isDisabled: !isEditable,
        theme: (currentTheme, themeProps)=>{
            const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
            return {
                buttonStyles: {
                    ...buttonStyles,
                    backgroundColor: 'transparent',
                    margin: 0,
                    width: 'auto',
                    height: 'auto',
                    padding: 0,
                    border: `2px solid ${error ? `var(--ds-border-danger, ${(0, $PdmhA).R300})` : 'transparent'}`,
                    borderRadius: '5px',
                    ...isEditable === true ? undefined : {
                        cursor: 'auto'
                    },
                    outline: 0,
                    boxShadow: `0 0 0 2px ${isOpen === true ? `var(--ds-border-focused, ${(0, $PdmhA).B200})` : 'transparent'}`,
                    '& > span': {
                        margin: 0
                    },
                    '&:focus, &:focus-within': {
                        boxShadow: `0 0 0 2px ${`var(--ds-border-focused, ${(0, $PdmhA).B200})`}`
                    }
                },
                spinnerStyles: spinnerStyles
            };
        },
        interactionName: "auto-generated.jira-issue-field-status.common.ui.status-lozenge.button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0211a3ed28924b4c$export$f72db4ad1e9b3e6d, {
        ...other,
        isEditable: isEditable
    }));
};
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0211a3ed28924b4c$var$StyledLozenge = /*#__PURE__*/ (0, $kwce8.default).span.withConfig({
    componentId: "wv585u-0"
})`display:flex;align-items:center;> div{display:flex;line-height:initial;outline:0;> span{padding:${"var(--ds-space-025, 2px)"} 0;vertical-align:text-bottom;color:${(props)=>props.isDisabled ? (0, $bR5MV.disabledColor).text : (0, $bR5MV.textColor)[(0, $bR5MV.statusCategoryToThemeMap)[props.statusCategoryId]]};background-color:${(props)=>props.isDisabled ? (0, $bR5MV.disabledColor).bg : (0, $bR5MV.bgColor)[(0, $bR5MV.statusCategoryToThemeMap)[props.statusCategoryId]]};${(props)=>props.hasHoverState ? `&:hover {
                        color: ${props.isDisabled ? (0, $bR5MV.disabledColor).text : (0, $bR5MV.textHoverColor)[(0, $bR5MV.statusCategoryToThemeMap)[props.statusCategoryId]]};
                        background-color: ${props.isDisabled ? (0, $bR5MV.disabledColor).bg : (0, $bR5MV.bgHoverColor)[(0, $bR5MV.statusCategoryToThemeMap)[props.statusCategoryId]]};
                    }` : ''};${(props)=>props.isDisabled && // eslint-disable-next-line jira/compiled/styled-components-usages
    (0, $kwce8.css)({
        pointerEvents: 'none'
    })}}}`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0211a3ed28924b4c$var$StyledLozengeContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o",
            (0, $iccsh.isTabularGridFieldsEnabled)() ? "_1e0c1bgi" : "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0211a3ed28924b4c$var$StatusContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            (0, $iccsh.isTabularGridFieldsEnabled)() ? "_1bsb1osq" : "_1bsb1wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bR5MV", function(module, exports) {

$parcel$export(module.exports, "STATUS_THEME_DEFAULT", () => $0bd810462bafa4a2$export$61137dce61763ec3);
$parcel$export(module.exports, "STATUS_THEME_SUCCESS", () => $0bd810462bafa4a2$export$132676d06d92ad48);
$parcel$export(module.exports, "STATUS_THEME_IN_PROGRESS", () => $0bd810462bafa4a2$export$5c1f3b72419aa125);
$parcel$export(module.exports, "statusCategoryToThemeMap", () => $0bd810462bafa4a2$export$d9e35f42afe1e488);
$parcel$export(module.exports, "bgColor", () => $0bd810462bafa4a2$export$7dcbec377a25efc6);
$parcel$export(module.exports, "textColor", () => $0bd810462bafa4a2$export$32f78bffcd82ff28);
$parcel$export(module.exports, "bgHoverColor", () => $0bd810462bafa4a2$export$69fdf3ba928b4c77);
$parcel$export(module.exports, "textHoverColor", () => $0bd810462bafa4a2$export$99ec0cf2cf1b2082);
$parcel$export(module.exports, "disabledColor", () => $0bd810462bafa4a2$export$b70f10fc4a6ba453);

var $PdmhA = parcelRequire("PdmhA");
const $0bd810462bafa4a2$export$61137dce61763ec3 = 'default';
const $0bd810462bafa4a2$export$132676d06d92ad48 = 'success';
const $0bd810462bafa4a2$export$5c1f3b72419aa125 = 'inprogress';
const $0bd810462bafa4a2$export$d9e35f42afe1e488 = {
    '1': $0bd810462bafa4a2$export$61137dce61763ec3,
    '2': $0bd810462bafa4a2$export$61137dce61763ec3,
    '3': $0bd810462bafa4a2$export$132676d06d92ad48,
    '4': $0bd810462bafa4a2$export$5c1f3b72419aa125
};
const $0bd810462bafa4a2$export$7dcbec377a25efc6 = {
    [$0bd810462bafa4a2$export$61137dce61763ec3]: `var(--ds-background-neutral, ${(0, $PdmhA.N40)})`,
    [$0bd810462bafa4a2$export$132676d06d92ad48]: `var(--ds-background-success, ${(0, $PdmhA.G50)})`,
    [$0bd810462bafa4a2$export$5c1f3b72419aa125]: `var(--ds-background-information, ${(0, $PdmhA.B50)})`
};
const $0bd810462bafa4a2$export$32f78bffcd82ff28 = {
    [$0bd810462bafa4a2$export$61137dce61763ec3]: `var(--ds-text, ${(0, $PdmhA.N500)})`,
    [$0bd810462bafa4a2$export$132676d06d92ad48]: `var(--ds-text-success, ${(0, $PdmhA.G500)})`,
    [$0bd810462bafa4a2$export$5c1f3b72419aa125]: `var(--ds-text-information, ${(0, $PdmhA.B500)})`
};
const $0bd810462bafa4a2$export$69fdf3ba928b4c77 = {
    [$0bd810462bafa4a2$export$61137dce61763ec3]: `var(--ds-background-neutral-hovered, ${(0, $PdmhA.N70)})`,
    [$0bd810462bafa4a2$export$132676d06d92ad48]: `var(--ds-background-success-hovered, ${(0, $PdmhA.G400)})`,
    [$0bd810462bafa4a2$export$5c1f3b72419aa125]: `var(--ds-background-information-hovered, ${(0, $PdmhA.B400)})`
};
const $0bd810462bafa4a2$export$99ec0cf2cf1b2082 = {
    [$0bd810462bafa4a2$export$61137dce61763ec3]: `var(--ds-text, ${(0, $PdmhA.N800)})`,
    [$0bd810462bafa4a2$export$132676d06d92ad48]: `var(--ds-text-success, ${(0, $PdmhA.N0)})`,
    [$0bd810462bafa4a2$export$5c1f3b72419aa125]: `var(--ds-text-information, ${(0, $PdmhA.N0)})`
};
const $0bd810462bafa4a2$export$b70f10fc4a6ba453 = {
    bg: `var(--ds-background-neutral, ${(0, $PdmhA.N40)})`,
    text: `var(--ds-text-disabled, ${(0, $PdmhA.N200)})`
};

});

parcelRegister("iccsh", function(module, exports) {

$parcel$export(module.exports, "isTabularGridFieldsEnabled", () => $96fedf0b1762860e$export$9605b1d5fe0c238b);
$parcel$export(module.exports, "isWorkflowDataServiceHookEnabled", () => $96fedf0b1762860e$export$60184d6d974595a9);

var $1ybV0 = parcelRequire("1ybV0");
const $96fedf0b1762860e$export$455240e4be839479 = 'jsw.uif.tmp.card.tabular.grid';
const $96fedf0b1762860e$export$9605b1d5fe0c238b = ()=>(0, $1ybV0.ff)($96fedf0b1762860e$export$455240e4be839479, false);
const $96fedf0b1762860e$export$60184d6d974595a9 = ()=>(0, $1ybV0.ff)('use-view-workflow-service-hook_8y6bk', false); // </bento>

});

parcelRegister("a8LdG", function(module, exports) {

$parcel$export(module.exports, "Lozenge", () => $c24adb58350b577e$export$a31cbe1bf5463979);

var $eUqFw = parcelRequire("eUqFw");

var $c9TLT = parcelRequire("c9TLT");

var $1ybV0 = parcelRequire("1ybV0");
const $c24adb58350b577e$var$containerStylesNew = {
    borderRadius: "var(--ds-border-radius, 3px)",
    boxSizing: 'border-box',
    display: 'inline-block',
    // Hardcoded font size and line height to match @atlaskit/lozenge. This may change in the future due to ADS design decisions
    fontSize: '11px',
    lineHeight: '16px',
    fontWeight: "var(--ds-font-weight-bold, 700)",
    maxWidth: '100%',
    padding: 0,
    textTransform: 'uppercase',
    verticalAlign: 'top'
};
const $c24adb58350b577e$var$containerStylesOld = {
    borderRadius: $c9TLT.borderRadius,
    boxSizing: 'border-box',
    display: 'inline-block',
    fontSize: '11px',
    fontWeight: 700,
    lineHeight: 1,
    maxWidth: '100%',
    padding: `${"var(--ds-space-025, 2px)"} 0`,
    textTransform: 'uppercase',
    verticalAlign: 'baseline'
};
const $c24adb58350b577e$var$contentStyles = {
    boxSizing: 'border-box',
    display: 'inline-block',
    maxWidth: 200,
    overflow: 'hidden',
    padding: `0 ${"var(--ds-space-050, 4px)"}`,
    textOverflow: 'ellipsis',
    verticalAlign: 'top',
    whiteSpace: 'nowrap',
    width: '100%'
};
const $c24adb58350b577e$export$a31cbe1bf5463979 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: (0, $1ybV0.ff)('jsw.backlog.improve-styling-issues-with-browser-font-size-settings') ? $c24adb58350b577e$var$containerStylesNew : $c24adb58350b577e$var$containerStylesOld
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: $c24adb58350b577e$var$contentStyles
    }, children));
$c24adb58350b577e$export$a31cbe1bf5463979.displayName = 'Lozenge';

});


parcelRegister("50D0V", function(module, exports) {

$parcel$export(module.exports, "isOnlyGlobalTransitions", () => $eb8c09ff04a7e642$export$10992041bf7e444a);
$parcel$export(module.exports, "getFilteredOrderedTransitions", () => $eb8c09ff04a7e642$export$707115549202b9e4);
$parcel$export(module.exports, "getLoopedTransitionsForStatus", () => $eb8c09ff04a7e642$export$38146914a8d06579);
$parcel$export(module.exports, "transformOptions", () => $eb8c09ff04a7e642$export$8f4ed8ef83bcbf04);
$parcel$export(module.exports, "getStatusShape", () => $eb8c09ff04a7e642$export$e2dafe47b17b2cfc);

var $5iWql = parcelRequire("5iWql");

var $8Qd0L = parcelRequire("8Qd0L");
const $eb8c09ff04a7e642$var$isGlobalSelfTransition = (transition, currentStatusId)=>transition.isGlobal && transition.to.id === currentStatusId;
const $eb8c09ff04a7e642$var$isInitialSelfTransition = (transition, currentStatusId)=>transition.isInitial && transition.to.id === currentStatusId;
const $eb8c09ff04a7e642$var$isLoopedTransitionToSelf = (transition, currentStatusId)=>transition.to.id === currentStatusId && transition.isLooped === true;
const $eb8c09ff04a7e642$var$filterLoopedTransitionsToSelf = (0, $5iWql.default)((transitions, currentStatusId)=>transitions.filter((transition)=>!$eb8c09ff04a7e642$var$isLoopedTransitionToSelf(transition, currentStatusId) && !$eb8c09ff04a7e642$var$isGlobalSelfTransition(transition, currentStatusId) && !$eb8c09ff04a7e642$var$isInitialSelfTransition(transition, currentStatusId)));
const $eb8c09ff04a7e642$export$10992041bf7e444a = (transitions)=>transitions.every((t)=>t.isGlobal);
const $eb8c09ff04a7e642$export$707115549202b9e4 = (transitions, currentStatusId)=>$eb8c09ff04a7e642$var$filterLoopedTransitionsToSelf(transitions || [], currentStatusId);
const $eb8c09ff04a7e642$export$38146914a8d06579 = (0, $5iWql.default)((transitions, currentStatusId)=>{
    if (transitions === null) return null;
    return transitions.filter((transition)=>$eb8c09ff04a7e642$var$isLoopedTransitionToSelf(transition, currentStatusId));
});
const $eb8c09ff04a7e642$var$formatOptions = (options)=>options.map((t)=>({
            label: t.to.name,
            value: t.id,
            transition: t
        }));
const $eb8c09ff04a7e642$var$memoizedTranformOptions = (0, $5iWql.default)($eb8c09ff04a7e642$var$formatOptions);
const $eb8c09ff04a7e642$export$8f4ed8ef83bcbf04 = (options)=>$eb8c09ff04a7e642$var$memoizedTranformOptions(options);
const $eb8c09ff04a7e642$export$e2dafe47b17b2cfc = (id, name, category)=>{
    const statusCategoryId = (0, $8Qd0L.StatusCategoryIds)[category] || (0, $8Qd0L.StatusCategoryIds)[(0, $8Qd0L.StatusCategoryTypes).UNDEFINED];
    return {
        id: id,
        name: name,
        statusCategory: {
            id: statusCategoryId,
            name: name
        }
    };
};

});

parcelRegister("99Syk", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteStatusView", () => $0668685bfe518e32$export$d907a4132fe8618c);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $jG2Eu = parcelRequire("jG2Eu");

var $bFzGY = parcelRequire("bFzGY");

var $eRawo = parcelRequire("eRawo");

var $ffiyv = parcelRequire("ffiyv");

var $6jiFZ = parcelRequire("6jiFZ");
var $LddR2 = parcelRequire("LddR2");
var $gCtL7 = parcelRequire("gCtL7");

var $9zALC = parcelRequire("9zALC");
var $46gH8 = parcelRequire("46gH8");
var $36mrL = parcelRequire("36mrL");
var $gfXKy = parcelRequire("gfXKy");

var $bT6OI = parcelRequire("bT6OI");

var $fmmnJ = parcelRequire("fmmnJ");
var $dK5FP = parcelRequire("dK5FP");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $hJ992 = parcelRequire("hJ992");

var $3Tszs = parcelRequire("3Tszs");

var $jMP2a = parcelRequire("jMP2a");


var $igSdB = parcelRequire("igSdB");

var $aaWu9 = parcelRequire("aaWu9");

var $hiXJ2 = parcelRequire("hiXJ2");
const $0668685bfe518e32$export$3b70c533639eedc2 = ({ childrenProps: childrenProps, statusViewProps: statusViewProps })=>{
    const { setLoading: setLoading, setChildResult: setChildResult } = childrenProps;
    const { wasFetchSuccessful: wasFetchSuccessful, currentStatus: currentStatus, transitions: transitions, isLoading: isLoading, renderTransition: renderTransition, onSuccess: onSuccess } = statusViewProps;
    const issueKey = (0, $hJ992.useIssueKey)();
    const issueId = (0, $3Tszs.useIssueAri)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { saveStatusField: saveStatusField } = (0, $aaWu9.useSaveStatusField)(issueKey, issueId);
    const loadTransitions = (0, $eUqFw.useCallback)(()=>{
        if (!wasFetchSuccessful) return {
            commands: []
        };
        const transitionCommands = transitions.map((transition)=>({
                id: `${0, $c7e109b9d85e3c97$export$5252a6a6e4e4a774}-${transition.id}`,
                name: transition.name,
                components: {
                    Name: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0668685bfe518e32$var$TransitionWrapper, null, renderTransition({
                            transition: transition
                        }, {
                            addTransitionArrowSpacing: true
                        }))
                },
                keywords: (0, $hiXJ2.getTransitionKeywords)(transition),
                primaryAction: {
                    type: (0, $6jiFZ.CommandActionType).PERFORM,
                    perform: ()=>{
                        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueStatus updated', {
                            oldValId: currentStatus.id,
                            oldStatusCategoryId: currentStatus.statusCategory.id,
                            newValId: transition.to.id,
                            newStatusCategoryId: transition.to.statusCategory.id,
                            hasScreen: transition.hasScreen,
                            isConditional: transition.isConditional
                        });
                        saveStatusField(transition, ()=>{
                            onSuccess?.(transition.to, false, createAnalyticsEvent({}));
                        });
                    }
                },
                analytics: {
                    action: 'changeStatus',
                    actionCategory: (0, $9zALC.COMMAND_PALETTE_ISSUE_ACTIONS)
                }
            }));
        const commands = [
            {
                id: `${(0, $c7e109b9d85e3c97$export$5252a6a6e4e4a774)}-${currentStatus.id}-current`,
                name: currentStatus.name,
                components: {
                    Name: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0668685bfe518e32$var$TransitionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0668685bfe518e32$var$SelectedStatusContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ffiyv.default), {
                            isBold: true
                        }, currentStatus.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0668685bfe518e32$var$CurrentStatusContainer, null, formatMessage((0, $igSdB.messages).currentStatus)))
                },
                primaryAction: {
                    type: (0, $6jiFZ.CommandActionType).PERFORM,
                    perform: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
                }
            },
            ...transitionCommands
        ];
        return {
            commands: commands
        };
    }, [
        createAnalyticsEvent,
        currentStatus.id,
        currentStatus.name,
        currentStatus.statusCategory.id,
        formatMessage,
        onSuccess,
        renderTransition,
        saveStatusField,
        transitions,
        wasFetchSuccessful
    ]);
    (0, $eUqFw.useEffect)(()=>{
        setLoading(isLoading);
    }, [
        isLoading,
        setLoading
    ]);
    (0, $eUqFw.useEffect)(()=>{
        setChildResult(loadTransitions());
    }, [
        loadTransitions,
        setChildResult
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $LddR2.components).Body, childrenProps);
};
const $0668685bfe518e32$export$d907a4132fe8618c = (props)=>{
    const issueKey = (0, $hJ992.useIssueKey)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { getKeywords: getKeywords } = (0, $gfXKy.useCommandKeywords)();
    const subscribeCommands = (0, $dK5FP.useSubscribeCommands)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [{ expandedCommand: expandedCommand, isOpen: isOpen }] = (0, $gCtL7.useCommandPaletteExpandedCommand)();
    const { onFetch: onFetch } = props;
    const renderChildren = (0, $eUqFw.useCallback)((childrenProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0668685bfe518e32$export$3b70c533639eedc2, {
            childrenProps: childrenProps,
            statusViewProps: props
        }), [
        props
    ]);
    const renderHeader = (0, $eUqFw.useCallback)((base)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT6OI.CommandFieldHeader), {
            ...base,
            issueKey: issueKey
        }), [
        issueKey
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const statusCommand = {
            id: (0, $c7e109b9d85e3c97$export$5252a6a6e4e4a774),
            name: (0, $1ybV0.ff)('compal-issue-actions-follow-up-improvements_y49xu') ? formatMessage((0, $igSdB.messages).editStatus) : formatMessage((0, $igSdB.messages).changeStatus),
            shortcut: 'd',
            placeholder: formatMessage((0, $igSdB.messages).searchTransition),
            keywords: getKeywords('changeStatusSynonyms'),
            section: (0, $46gH8.getCommandPaletteIssueActionsHeader)(issueKey),
            priority: (0, $36mrL.getCommandPaletteIssueActionsPriority)('STATUS'),
            components: {
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eRawo))), {
                        label: formatMessage((0, $igSdB.messages).changeStatus)
                    })
            },
            primaryAction: {
                type: (0, $6jiFZ.CommandActionType).COMMAND_LIST,
                fallback: {
                    onNoResults: {
                        label: formatMessage((0, $igSdB.messages).fallbackNoResults)
                    }
                },
                components: {
                    Body: renderChildren,
                    ...(0, $1ybV0.ff)('compal-issue-actions-very-high-priority_f5w5r') && {
                        Header: renderHeader
                    }
                }
            },
            analytics: {
                action: 'changeStatusMenu'
            }
        };
        const unsubscribe = subscribeCommands((0, $fmmnJ.COMMAND_PALETTE_REGISTRY_IDS).STATUS, [
            statusCommand
        ]);
        return ()=>unsubscribe();
    }, [
        formatMessage,
        getKeywords,
        issueKey,
        renderChildren,
        renderHeader,
        subscribeCommands
    ]);
    const expandedCommandId = expandedCommand?.id;
    (0, $eUqFw.useEffect)(()=>{
        if (isOpen && expandedCommandId === (0, $c7e109b9d85e3c97$export$5252a6a6e4e4a774) && onFetch) onFetch(createAnalyticsEvent({}));
    }, [
        expandedCommandId,
        isOpen,
        onFetch,
        createAnalyticsEvent
    ]);
    return null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0668685bfe518e32$var$TransitionWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4 _18u01b66 _4t3i1tcg _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0668685bfe518e32$var$SelectedStatusContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0668685bfe518e32$var$CurrentStatusContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1a45",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eRawo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ad0e2d491eada4f5$var$_react = $ad0e2d491eada4f5$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $ad0e2d491eada4f5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $ad0e2d491eada4f5$var$TaskIcon = (props)=>/*#__PURE__*/ $ad0e2d491eada4f5$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M3 3.993C3 3.445 3.445 3 3.993 3h16.014c.548 0 .993.445.993.993v16.014a.994.994 0 01-.993.993H3.993A.994.994 0 013 20.007V3.993zM5 5v14h14V5H5z"/><path d="M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z" fill-rule="nonzero"/></g></svg>`
    }, props));
$ad0e2d491eada4f5$var$TaskIcon.displayName = 'TaskIcon';
var $ad0e2d491eada4f5$var$_default = $ad0e2d491eada4f5$var$TaskIcon;
module.exports.default = $ad0e2d491eada4f5$var$_default;

});

parcelRegister("LddR2", function(module, exports) {

$parcel$export(module.exports, "components", () => $de43b6bd284ffa0f$export$9b5ac10f59f76296);

var $eUqFw = parcelRequire("eUqFw");

var $73ZV3 = parcelRequire("73ZV3");

var $gwWoQ = parcelRequire("gwWoQ");

var $b4qUd = parcelRequire("b4qUd");

var $48xUp = parcelRequire("48xUp");
const $de43b6bd284ffa0f$export$9b5ac10f59f76296 = {
    CommandRow: $gwWoQ.CommandRow,
    Name: (0, $eUqFw.Fragment),
    LeftIcon: (0, $eUqFw.Fragment),
    Wrapper: (0, $eUqFw.Fragment),
    Footer: $b4qUd.Footer,
    Body: (0, $73ZV3.CommandPaletteBody),
    Header: $48xUp.Header
};

});
parcelRegister("73ZV3", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteBody", () => $d0ddd4262a5c5e52$export$b1023de69a8756e6);
$parcel$export(module.exports, "NoResultsContainer", () => $d0ddd4262a5c5e52$export$2ab569a6937cb4e4);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $bFzGY = parcelRequire("bFzGY");

var $bKxX9 = parcelRequire("bKxX9");

var $gCtL7 = parcelRequire("gCtL7");

var $8FbYY = parcelRequire("8FbYY");

var $5IPbY = parcelRequire("5IPbY");

var $80x7h = parcelRequire("80x7h");

var $f9a4v = parcelRequire("f9a4v");

var $1c3Ul = parcelRequire("1c3Ul");

var $985MX = parcelRequire("985MX");

var $dDiRc = parcelRequire("dDiRc");

var $4PPUt = parcelRequire("4PPUt");
const $d0ddd4262a5c5e52$export$b1023de69a8756e6 = ({ results: results, total: total, fallback: fallback, renderAfterCommands: renderAfterCommands })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [{ activeIndex: activeIndex, isSearchFieldFocused: isSearchFieldFocused, loadingList: loadingList, expandedCommand: expandedCommand, search: search, registry: registry, activeRegistry: activeRegistry }, { setActiveIndex: setActiveIndex, executeCommand: executeCommand, removeCommandsById: removeCommandsById }] = (0, $gCtL7.useCommandPalette)();
    const [prevActiveIndex, setPrevActiveIndex] = (0, $eUqFw.useState)(activeIndex);
    const onHoverCommand = (index)=>{
        if (index === undefined) return;
        setActiveIndex(index);
    };
    const onClickCommand = (0, $eUqFw.useCallback)((event, result)=>{
        executeCommand(result.command, {
            method: 'mouse',
            createAnalyticsEvent: createAnalyticsEvent,
            attributes: {
                ...(0, $8FbYY.getAnalyticsAttributesFromResult)(result),
                ...(0, $8FbYY.getRegistryData)(registry, activeRegistry, result?.command.id)
            }
        }, (0, $8FbYY.isSecondaryTrigger)(event));
    }, [
        activeRegistry,
        createAnalyticsEvent,
        executeCommand,
        registry
    ]);
    const onMouseDownCommand = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
    }, []);
    const resultsRefs = (0, $eUqFw.useRef)([]);
    const modalBodyRef = (0, $eUqFw.useRef)(null);
    const onArrowScroll = (0, $eUqFw.useCallback)((newActiveIndex)=>{
        setActiveIndex(newActiveIndex);
    }, [
        setActiveIndex
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!modalBodyRef.current || prevActiveIndex === activeIndex) return;
        setPrevActiveIndex(activeIndex);
        const scrollTo = activeIndex > prevActiveIndex ? (0, $dDiRc.SCROLL_DIRECTION).END : (0, $dDiRc.SCROLL_DIRECTION).START;
        const scrollToIndex = (0, $4PPUt.getScrollToIndex)(results, activeIndex, scrollTo);
        const scrolledToResult = resultsRefs.current[scrollToIndex];
        if (scrolledToResult && !(0, $4PPUt.isElementVisibleInContainer)(scrolledToResult, modalBodyRef.current)) {
            const lastIndex = results.length - 1;
            const firstIndex = results.findIndex((result)=>!result.isGroup);
            if (lastIndex === scrollToIndex) modalBodyRef.current.scrollTo(0, modalBodyRef.current.scrollHeight);
            else if (firstIndex === scrollToIndex) modalBodyRef.current.scrollTo(0, 0);
            else (0, $4PPUt.scrollResultIntoView)(scrolledToResult, scrollTo);
        }
    }, [
        activeIndex,
        prevActiveIndex,
        results
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!modalBodyRef.current?.scrollTo) return;
        modalBodyRef.current.scrollTo(0, 0);
    }, [
        expandedCommand,
        search
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        if (!isSearchFieldFocused) return ()=>{};
        const handleArrowScroll = (ev)=>{
            if (ev.key === 'ArrowUp') {
                ev.preventDefault();
                activeIndex > 0 && onArrowScroll(activeIndex - 1);
            }
            if (ev.key === 'ArrowDown') {
                ev.preventDefault();
                activeIndex < total - 1 && onArrowScroll(activeIndex + 1);
            }
        };
        window.addEventListener('keydown', handleArrowScroll);
        return ()=>{
            window.removeEventListener('keydown', handleArrowScroll);
        };
    }, [
        isSearchFieldFocused,
        total,
        activeIndex,
        setActiveIndex,
        onArrowScroll
    ]);
    const noResultsFallback = (0, $eUqFw.useMemo)(()=>fallback?.onNoResults?.renderLabel?.() || fallback?.onNoResults?.label, [
        fallback
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $f9a4v.CommandPaletteSearchResultListWrapper), {
        ref: modalBodyRef
    }, !loadingList && noResultsFallback && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d0ddd4262a5c5e52$export$2ab569a6937cb4e4, {
        "data-testid": (0, $dDiRc.NO_RESULTS_TEST_ID)
    }, noResultsFallback), results.map((result, index)=>{
        if (result.isGroup) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5IPbY.CommandPaletteSearchResultGroupItem), {
            ref: (commandRef)=>{
                if (commandRef) resultsRefs.current[index] = commandRef;
            },
            group: result.group,
            key: index
        }, (0, $bKxX9.ff)('compal-issue-actions-very-high-priority_f5w5r') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d0ddd4262a5c5e52$var$GroupContainer, {
            "data-testid": (0, $dDiRc.GROUP_TEST_ID),
            isFirstResult: index === 0
        }, result.renderGroup ? result.renderGroup() : result.group) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d0ddd4262a5c5e52$var$GroupContainerOld, {
            "data-testid": (0, $dDiRc.GROUP_TEST_ID),
            isFirstResult: index === 0
        }, result.renderGroup ? result.renderGroup() : result.group));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $985MX.CommandRowErrorBoundary), {
            key: index,
            teamName: typeof registry?.teamName === 'string' ? registry.teamName : 'deliveroo',
            onError: ()=>removeCommandsById([
                    result.command.id
                ]),
            attributes: (0, $8FbYY.getRegistryData)(registry, activeRegistry, result?.command.id)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $80x7h.CommandPaletteSearchResultListItem), {
            ref: (commandRef)=>{
                if (commandRef) resultsRefs.current[index] = commandRef;
            },
            id: result.command.id,
            active: result.active,
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1c3Ul.CommandRow), {
            index: index,
            isSearchFieldFocused: isSearchFieldFocused,
            result: result,
            onHoverCommand: (ev)=>{
                // Safari is weird and likes to fire mouseover events when the mouse is not moving
                if (ev.movementX === 0 && ev.movementY === 0) return;
                onHoverCommand(result.index);
            },
            onClickCommand: (event)=>onClickCommand(event, result),
            onMouseDownCommand: onMouseDownCommand
        })));
    }), (0, $bKxX9.ff)('compal-issue-actions') ? renderAfterCommands?.({}) : !loadingList && renderAfterCommands && renderAfterCommands({}));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d0ddd4262a5c5e52$var$GroupContainerOld = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFirstResult: isFirstResult, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_h2xaw7": (0, $9t7rW.default)(`${__cmplp.isFirstResult ? "var(--ds-space-100, 8px)" : "var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-300, 24px)"}`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyb1skh _k48p1nn1 _syaz1wmz _1p1dangw _1yt41f6d",
            __cmplp.className
        ])
    });
});
const $d0ddd4262a5c5e52$var$GroupContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFirstResult: isFirstResult, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_h2xaw7": (0, $9t7rW.default)(`${__cmplp.isFirstResult ? "var(--ds-space-100, 8px)" : "var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-300, 24px)"}`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyb1oud _k48p1nn1 _syaz1wmz _1yt41f6d",
            __cmplp.className
        ])
    });
});
const $d0ddd4262a5c5e52$export$2ab569a6937cb4e4 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1h6o _syaz1e9r _1yt4wd81",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5IPbY", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteSearchResultGroupItem", () => $43e423a37776a525$export$591c26128e5fd757);

var $eUqFw = parcelRequire("eUqFw");

const $43e423a37776a525$export$591c26128e5fd757 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ group: group, ...rest }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: ref,
        "data-testid": (0, $d08d4eae9e022dcf$export$617744f059bfc3ba),
        id: group ? `${0, $d08d4eae9e022dcf$export$f24a36b1556217a1}-${group}` : undefined,
        ...rest
    }));

});
const $d08d4eae9e022dcf$export$5758a25d98c7bb27 = 'compal-listbox';
const $d08d4eae9e022dcf$export$f61172db5aff4b22 = `${$d08d4eae9e022dcf$export$5758a25d98c7bb27}-item`;
const $d08d4eae9e022dcf$export$f24a36b1556217a1 = `${$d08d4eae9e022dcf$export$5758a25d98c7bb27}-group`;
const $d08d4eae9e022dcf$export$85eefac753ab5bdb = 'command-palette.ui.modal.body.command-body-container';
const $d08d4eae9e022dcf$export$617744f059bfc3ba = 'command-palette.ui.modal.body.command-container-row';
const $d08d4eae9e022dcf$export$d3cd230e107fbce = 'command-palette.ui.modal.header.search-input';
const $d08d4eae9e022dcf$export$65eac2e53f304ab6 = 'compal-listbox-screen-reader';


parcelRegister("80x7h", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteSearchResultListItem", () => $55b21d7cef5b1dbb$export$1f8fa9d1eef77b32);

var $eUqFw = parcelRequire("eUqFw");

const $55b21d7cef5b1dbb$export$1f8fa9d1eef77b32 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ id: id, active: active, ...rest }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: ref,
        "data-testid": (0, $d08d4eae9e022dcf$export$617744f059bfc3ba),
        role: "option",
        id: `${(0, $d08d4eae9e022dcf$export$f61172db5aff4b22)}-${id}`,
        "aria-selected": active,
        ...rest
    }));

});

parcelRegister("f9a4v", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteSearchResultListWrapper", () => $d3691614f8dde395$export$95554f6fb39a83c2);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");


var $ezG3R = parcelRequire("ezG3R");
const $d3691614f8dde395$export$95554f6fb39a83c2 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($d3691614f8dde395$var$Wrapper, {
        "data-testid": (0, $d08d4eae9e022dcf$export$85eefac753ab5bdb),
        role: "listbox",
        id: (0, $d08d4eae9e022dcf$export$5758a25d98c7bb27),
        ref: ref,
        "aria-label": (0, $1ybV0.ff)('compal-issue-actions-follow-up-improvements_y49xu') ? formatMessage((0, $ezG3R.messages).commandPaletteSearchResultListBoxLabel) : undefined,
        ...props
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d3691614f8dde395$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_c71l4u42 _18m91wug _vchhusvi _1yt41bpf _1e0c1txw _2lx21bp4 _zulp1b66 _1tke8vuz",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ezG3R", function(module, exports) {

$parcel$export(module.exports, "messages", () => $dae431d5b55d597f$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $dae431d5b55d597f$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    commandPaletteSearchResultListBoxLabel: {
        "id": "command-palette.common.command-palette-search-dropdown.command-palette-search-result-list-wrapper.command-palette-search-result-list-box-label",
        "defaultMessage": "List of commands"
    }
});

});


parcelRegister("1c3Ul", function(module, exports) {

$parcel$export(module.exports, "CommandRow", () => $673add314e0db490$export$3ef5d254c3c573e3);

var $eUqFw = parcelRequire("eUqFw");

var $8FbYY = parcelRequire("8FbYY");

var $gwWoQ = parcelRequire("gwWoQ");
const $673add314e0db490$export$3ef5d254c3c573e3 = ({ index: index, result: result, isSearchFieldFocused: isSearchFieldFocused, onHoverCommand: onHoverCommand, onClickCommand: onClickCommand, onMouseDownCommand: onMouseDownCommand })=>{
    const { command: command } = result;
    const isActive = !!(result.active && isSearchFieldFocused);
    const isFirstCommand = result.index === 0;
    const rowProps = {
        index: index,
        isActive: isActive,
        command: command,
        isFirstCommand: isFirstCommand,
        onMouseMove: onHoverCommand,
        onClick: onClickCommand,
        onMouseDown: onMouseDownCommand,
        analyticsAttributes: (0, $8FbYY.getAnalyticsAttributesFromResult)(result)
    };
    if (command.components?.CommandRow) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(command.components.CommandRow, rowProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gwWoQ.CommandRow), rowProps);
};

});
parcelRegister("gwWoQ", function(module, exports) {

$parcel$export(module.exports, "CommandRow", () => $6e9750c220ca1b53$export$3ef5d254c3c573e3);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5t8Df = parcelRequire("5t8Df");


var $8LHLg = parcelRequire("8LHLg");

var $7cPAX = parcelRequire("7cPAX");
const $6e9750c220ca1b53$export$3ef5d254c3c573e3 = ({ index: index, command: command, isActive: isActive, isFirstCommand: isFirstCommand, analyticsAttributes: analyticsAttributes, ...rest })=>{
    const InnerContainer = $6e9750c220ca1b53$var$CommandContainerInner;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e9750c220ca1b53$var$CommandContainerWrapper, {
        "data-testid": command.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e9750c220ca1b53$var$CommandContainer, {
        index: index,
        active: isActive,
        "data-active": isActive,
        "data-testid": (0, $d665202372e0655f$export$b0017db5728101cc)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(InnerContainer, {
        "data-testid": (0, $d665202372e0655f$export$47c379a40b00a339),
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e9750c220ca1b53$var$CommandLeftIconAndNameContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e9750c220ca1b53$var$CommandIconsContainer, {
        "data-testid": (0, $d665202372e0655f$export$d6dd1cf63aae711c)
    }, command.components?.LeftIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6e9750c220ca1b53$var$CommandLeftIconContainer, {
        "data-testid": (0, $d665202372e0655f$export$7b41978523c7dd4a),
        active: isActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(command.components.LeftIcon, null)), command.mode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5t8Df.OutlinedLozenge), {
        "data-testid": (0, $d665202372e0655f$export$72c5368f559dd523)
    }, command.mode)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8LHLg.RenderCommandName), {
        command: command,
        isActive: isActive
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7cPAX.RightContent), {
        command: command,
        isFirstCommand: isFirstCommand,
        isActive: isActive
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6e9750c220ca1b53$var$CommandContainerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $6e9750c220ca1b53$var$CommandContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wybdlk8 _k48p1nn1 _syazjjyb _1yt4swc3",
            !!__cmplp.active && "_syazaj1x _bfhk29zg _kqswh2mm _1kt9b3bt _1cs8stnw _1aukidpf _qnecidpf _19woidpf _1mp4v77o _1rus194a",
            __cmplp.className
        ])
    });
});
const $6e9750c220ca1b53$var$CommandContainerInner = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt467l7 _1e0c1txw _4cvr1h6o _80omtlke _lcxv1wug",
            __cmplp.className
        ])
    });
});
const $6e9750c220ca1b53$var$CommandIconsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwx1b66 _zulp1b66 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $6e9750c220ca1b53$var$CommandLeftIconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bsb1tcg _4t3i1tcg _vwz41tcg _1bah1h6o _1wpz1y6m _1f027vkz _nbgx7vkz",
            __cmplp.active ? "_syaz2zfp" : "_syazbkuv",
            __cmplp.className
        ])
    });
});
const $6e9750c220ca1b53$var$CommandLeftIconAndNameContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _16jlkb7n _1o9zkb7n _i0dlf1ug _vwz41tcg _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5t8Df", function(module, exports) {

$parcel$export(module.exports, "OutlinedLozenge", () => $cfdd8a3faf592ae6$export$224f9ad7f31e0de6);
$parcel$export(module.exports, "FilledLozenge", () => $cfdd8a3faf592ae6$export$586a428fe10f5ae0);
$parcel$export(module.exports, "SearchLozenge", () => $cfdd8a3faf592ae6$export$2ccc7861eeb7b337);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ // eslint-disable-next-line jira/restricted/@atlaskit+theme -- Avoid using jira specific components to make this component easier to export to atlaskit later - https://hello.atlassian.net/browse/DEE-1558

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cfdd8a3faf592ae6$var$Lozenge = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _2rko1l7b _1o9zidpf _4t3igktf _1bsbgktf _1wyb1crf _vwz41crf _syaz1aqp",
            __cmplp.className
        ])
    });
});
const $cfdd8a3faf592ae6$export$224f9ad7f31e0de6 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $cfdd8a3faf592ae6$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ect485st _1p1dangw _bfhk1j9a _19it1x8r _syazuxqy _k48pni7l _vchhusvi",
            __cmplp.className
        ])
    });
});
const $cfdd8a3faf592ae6$export$586a428fe10f5ae0 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $cfdd8a3faf592ae6$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _ect485st _1p1dangw _1pbykb7n _1cs8stnw _1kt9b3bt _1s6k1d2d _154psxj9 _rfx31l7b _1aukidpf _19woidpf _oounidpf _qnecidpf _1g0v1mrw",
            __cmplp.className
        ])
    });
});
const $cfdd8a3faf592ae6$export$2ccc7861eeb7b337 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $cfdd8a3faf592ae6$var$Lozenge, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4otz2 _1bsb1ris _1wybdlk8 _vwz4dlk8 _bfhk1yrq",
            __cmplp.className
        ])
    });
});

});

const $d665202372e0655f$export$b0017db5728101cc = 'command-palette.ui.modal.body.command-container';
const $d665202372e0655f$export$47c379a40b00a339 = 'command-palette.common.ui.command-palette-row-view.inner-container';
const $d665202372e0655f$export$7b41978523c7dd4a = 'command-palette.ui.modal.body.command-left-icon-container';
const $d665202372e0655f$export$72c5368f559dd523 = 'command-palette.ui.modal.body.command-mode';
const $d665202372e0655f$export$d6dd1cf63aae711c = 'command-palette.ui.modal.body.command-icon-container';

parcelRegister("8LHLg", function(module, exports) {

$parcel$export(module.exports, "RenderCommandName", () => $6ee7061fe3a2c77e$export$931d3f1d35f6c058);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $dtaN9 = parcelRequire("dtaN9");

var $PdmhA = parcelRequire("PdmhA");

var $jCRsd = parcelRequire("jCRsd");

const $6ee7061fe3a2c77e$export$931d3f1d35f6c058 = ({ command: command, isActive: isActive })=>{
    const renderCommandName = (0, $eUqFw.useCallback)(()=>{
        if (command.components?.Name) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(command.components.Name, {
            isActive: isActive
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jCRsd.TruncateWithTooltipOnActive), {
            isActive: isActive
        }, command.name);
    }, [
        command,
        isActive
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ee7061fe3a2c77e$var$CommandNameContainer, {
        "data-testid": (0, $1095276f0211050b$export$1858c2a91b8b53ba),
        active: isActive
    }, command.breadcrumb?.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ee7061fe3a2c77e$var$CommandBreadcrumbContainer, {
        "data-testid": (0, $1095276f0211050b$export$5e3a644e2bbe06f3)
    }, command.breadcrumb.map((BreadCrumb, index, arr)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ee7061fe3a2c77e$var$CommandBreadcrumbItem, {
            isParent: index !== arr.length - 1,
            "data-testid": (0, $1095276f0211050b$export$fb5462105b23e3e5),
            active: isActive
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(BreadCrumb, {
            isActive: isActive
        })), index !== arr.length - 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($6ee7061fe3a2c77e$var$CommandChevronContainer, {
            "data-testid": (0, $1095276f0211050b$export$4675b4d60d9881d4)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dtaN9))), {
            label: "separator"
        }))))) : renderCommandName());
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6ee7061fe3a2c77e$var$CommandNameContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf _vwz41tcg",
            __cmplp.active ? "_syaz1qfn" : "_syaz1a45",
            __cmplp.className
        ])
    });
});
const $6ee7061fe3a2c77e$var$CommandBreadcrumbContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $6ee7061fe3a2c77e$var$CommandBreadcrumbItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isParent: isParent, active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_zek046": (0, $9t7rW.default)(__cmplp.active ? `var(--ds-text-subtle, ${(0, $PdmhA).N400})` : `var(--ds-text-subtlest, ${(0, $PdmhA).N200})`)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            !!__cmplp.isParent && "_syaz1bu1",
            __cmplp.className
        ])
    });
});
const $6ee7061fe3a2c77e$var$CommandChevronContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vwz4kb7n _syazjwct",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jCRsd", function(module, exports) {

$parcel$export(module.exports, "TruncateWithTooltipOnActive", () => $57c74f3e056e4b78$export$4495aca3d261add0);

var $eUqFw = parcelRequire("eUqFw");

var $3MV1G = parcelRequire("3MV1G");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $lcnyw = parcelRequire("lcnyw");

var $1ybV0 = parcelRequire("1ybV0");

var $bAQOb = parcelRequire("bAQOb");

var $lXgc2 = parcelRequire("lXgc2");


var $lDcdk = parcelRequire("lDcdk");
const $57c74f3e056e4b78$var$TooltipRenderer = ({ children: children, containerRef: containerRef, shouldShowTooltip: shouldShowTooltip })=>{
    let shouldShowTruncatedTooltip = false;
    if (!(0, $1ybV0.ff)('compal-update-active-tooltip')) // eslint-disable-next-line react-hooks/rules-of-hooks
    ({ shouldShowTruncatedTooltip: shouldShowTruncatedTooltip } = (0, $lDcdk.useTruncatedTooltip)({
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        containerRef: containerRef,
        tooltipDelay: (0, $79f2d7e0eace9088$export$f9e3e7ede9ba929d)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: (0, $1ybV0.ff)('compal-update-active-tooltip') ? !!shouldShowTooltip : shouldShowTruncatedTooltip,
        autoFocus: false,
        placement: "bottom-end",
        popupComponent: (0, $lXgc2.PopupComponent),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lXgc2.TooltipContent), {
                "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.tooltip-content"
            }, children),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lXgc2.TriggerComponent), {
                "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.trigger-component",
                ...triggerProps
            }),
        zIndex: (0, $lcnyw.layers).tooltip()
    });
};
const $57c74f3e056e4b78$export$70f47de153e915ed = ()=>(0, $eUqFw.useRef)(null);
const $57c74f3e056e4b78$var$TruncateWithTooltipOnActiveOld = ({ children: children, isActive: isActive })=>{
    const containerRef = $57c74f3e056e4b78$export$70f47de153e915ed();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lXgc2.TruncateWithTooltipContainer), {
        ref: containerRef
    }, children), isActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($57c74f3e056e4b78$var$TooltipRenderer, {
        containerRef: containerRef
    }, children));
};
const $57c74f3e056e4b78$var$TruncateWithTooltipOnActiveNew = ({ children: children, isActive: isActive, customTooltip: customTooltip, showTooltip: showTooltip, preventTruncate: preventTruncate })=>{
    const containerRef = $57c74f3e056e4b78$export$70f47de153e915ed();
    const { shouldShowTruncatedTooltip: shouldShowTruncatedTooltip } = (0, $lDcdk.useTruncatedTooltip)({
        containerRef: containerRef,
        tooltipDelay: (0, $79f2d7e0eace9088$export$f9e3e7ede9ba929d)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        ref: containerRef,
        xcss: [
            $57c74f3e056e4b78$var$tooltipContainerStyles,
            !preventTruncate && $57c74f3e056e4b78$var$truncateTooltipStyles
        ]
    }, children), isActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($57c74f3e056e4b78$var$TooltipRenderer, {
        shouldShowTooltip: showTooltip || shouldShowTruncatedTooltip
    }, showTooltip && customTooltip ? customTooltip : children));
};
const $57c74f3e056e4b78$export$4495aca3d261add0 = (0, $bAQOb.componentWithFF)('compal-update-active-tooltip', $57c74f3e056e4b78$var$TruncateWithTooltipOnActiveNew, $57c74f3e056e4b78$var$TruncateWithTooltipOnActiveOld);
const $57c74f3e056e4b78$var$tooltipContainerStyles = (0, $1ZAYh.xcss)({
    position: 'relative',
    flexGrow: 1,
    textTransform: 'none'
});
const $57c74f3e056e4b78$var$truncateTooltipStyles = (0, $1ZAYh.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});

});
parcelRegister("lXgc2", function(module, exports) {

$parcel$export(module.exports, "TooltipComponent", () => $50856cc63ccf025e$export$e18e2f8e82cdc428);
$parcel$export(module.exports, "TriggerComponent", () => $50856cc63ccf025e$export$534fc570264a52a4);
$parcel$export(module.exports, "TooltipTrigger", () => $50856cc63ccf025e$export$8c610744efcf8a1d);
$parcel$export(module.exports, "PopupComponent", () => $50856cc63ccf025e$export$9fac2d040f3ed438);
$parcel$export(module.exports, "TruncateWithTooltipContainer", () => $50856cc63ccf025e$export$8cae238d61c8405a);
$parcel$export(module.exports, "TooltipContent", () => $50856cc63ccf025e$export$e9003e2be37ec060);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $g3tFP = parcelRequire("g3tFP");
const $50856cc63ccf025e$export$e18e2f8e82cdc428 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($50856cc63ccf025e$var$StyledTooltipPrimitive, {
        ...props,
        ref: ref
    }));
const $50856cc63ccf025e$export$534fc570264a52a4 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($50856cc63ccf025e$export$8c610744efcf8a1d, {
        ...props,
        ref: ref
    }));
const $50856cc63ccf025e$export$9fac2d040f3ed438 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($50856cc63ccf025e$var$StyledPopupPrimitive, {
        ...props,
        ref: ref
    }, children));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $50856cc63ccf025e$var$StyledTooltipPrimitive = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $g3tFP.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1pbydx66 _1bsbp3fh _1yt41ppf _bfhk1j9a _16qsacve",
            __cmplp.className
        ])
    });
});
const $50856cc63ccf025e$var$StyledPopupPrimitive = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1pbydx66 _1bsbp3fh _1yt41ppf _bfhk1j9a _16qsacve",
            __cmplp.className
        ])
    });
});
const $50856cc63ccf025e$export$8cae238d61c8405a = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _o5721q9c _1reo15vq _18m915vq _1bto1l2s _1p1dglyw",
            __cmplp.className
        ])
    });
});
const $50856cc63ccf025e$export$e9003e2be37ec060 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1jfi _11c8qk37",
            __cmplp.className
        ])
    });
});
const $50856cc63ccf025e$export$8c610744efcf8a1d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});

const $79f2d7e0eace9088$export$f9e3e7ede9ba929d = 400;

parcelRegister("lDcdk", function(module, exports) {

$parcel$export(module.exports, "useTruncatedTooltip", () => $8c918be484ad3aec$export$94b118b3187f12c);

var $eUqFw = parcelRequire("eUqFw");

var $8FbYY = parcelRequire("8FbYY");
const $8c918be484ad3aec$export$22c0312879c61300 = ()=>(0, $eUqFw.useState)(false);
const $8c918be484ad3aec$export$1ac6e474a0163418 = ()=>(0, $eUqFw.useState)(false);
const $8c918be484ad3aec$export$94b118b3187f12c = ({ containerRef: containerRef, tooltipDelay: tooltipDelay })=>{
    const [shouldShowTruncatedTooltip, setShouldShowTruncatedTooltip] = $8c918be484ad3aec$export$22c0312879c61300();
    const [isTruncated, setIsTruncated] = $8c918be484ad3aec$export$1ac6e474a0163418();
    const { setTimeoutAutoClear: setTimeoutAutoClear } = (0, $8FbYY.useSetTimeoutAutoClear)();
    const setTimeoutFunc = setTimeoutAutoClear;
    (0, $eUqFw.useEffect)(()=>{
        const container = containerRef.current;
        if (!container) return;
        if (container.offsetWidth < container.scrollWidth) setIsTruncated(true);
        else setIsTruncated(false);
    }, [
        setIsTruncated,
        containerRef
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (isTruncated && tooltipDelay === 0) {
            setShouldShowTruncatedTooltip(true);
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return ()=>{};
        }
        if (isTruncated && tooltipDelay > 0) {
            setTimeoutFunc(()=>setShouldShowTruncatedTooltip(true), tooltipDelay);
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return ()=>{};
        }
        setShouldShowTruncatedTooltip(false);
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
    }, [
        isTruncated,
        setShouldShowTruncatedTooltip,
        tooltipDelay,
        setTimeoutFunc
    ]);
    return {
        shouldShowTruncatedTooltip: shouldShowTruncatedTooltip
    };
};

});


const $1095276f0211050b$export$1858c2a91b8b53ba = 'command-palette.ui.modal.body.command-name-container';
const $1095276f0211050b$export$5e3a644e2bbe06f3 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.breadcrumb-container';
const $1095276f0211050b$export$fb5462105b23e3e5 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.breadcrumb-item';
const $1095276f0211050b$export$4675b4d60d9881d4 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.separator';


parcelRegister("7cPAX", function(module, exports) {

$parcel$export(module.exports, "RightContent", () => $b3a3550b1d4e6bec$export$11dbab4b39f15d6b);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $dwj4T = parcelRequire("dwj4T");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8FbYY = parcelRequire("8FbYY");


var $hBQBI = parcelRequire("hBQBI");

var $iMtOt = parcelRequire("iMtOt");

var $6gNFs = parcelRequire("6gNFs");

var $cAOzG = parcelRequire("cAOzG");
const $b3a3550b1d4e6bec$export$11dbab4b39f15d6b = ({ command: command, isActive: isActive, isFirstCommand: isFirstCommand = false })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const transitionStep = (0, $6gNFs.useHoverTransitionStep)(command, isActive, isFirstCommand);
    const commandHasChildren = (0, $eUqFw.useMemo)(()=>(0, $8FbYY.hasChildren)(command), [
        command
    ]);
    const shouldRenderRightContent = commandHasChildren || !!command.shortcut;
    if (!shouldRenderRightContent) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b3a3550b1d4e6bec$var$RightContentWrapper, null, commandHasChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b3a3550b1d4e6bec$var$CommandRightChevronContainer, {
        "data-testid": (0, $d5b555147cabbe39$export$e3e144c17be58a44),
        transitionStep: transitionStep
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dwj4T))), {
        label: formatMessage((0, $hBQBI.messages).rightChevronLabel)
    })), !!command.shortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b3a3550b1d4e6bec$var$ShortcutContainer, {
        "data-testid": (0, $d5b555147cabbe39$export$f3036e9d26f81cd9),
        shouldHaveTransition: commandHasChildren,
        transitionStep: transitionStep
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iMtOt.Shortcuts), {
        shortcut: command.shortcut
    })));
};
const $b3a3550b1d4e6bec$var$animationFadeIn = null;
const $b3a3550b1d4e6bec$var$animationFadeOut = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b3a3550b1d4e6bec$var$RightContentWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswh2mm _1e0c11p5 _18u01b66 _syaz1a45",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b3a3550b1d4e6bec$var$CommandRightChevronContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { transitionStep: transitionStep, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ii7kb7n _yyhykb7n _4cvr1h6o _1e0c1txw _1bsb1tcg _4t3i1tcg _vwz41tcg _5sag1ttt _1pgl1ytf _1o51q7pw _tzy4idpf _syazbkuv",
            __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING && "",
            __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING && "_j7hq1wwu",
            __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "",
            __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "_j7hq1sbx",
            (__cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).FINISHED || __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).DELAYING_FADE_OUT) && "_tzy4kb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b3a3550b1d4e6bec$var$ShortcutContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldHaveTransition: shouldHaveTransition, transitionStep: transitionStep, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ii7kb7n _yyhykb7n _5sag1ttt _1pgl1ytf _1o51q7pw _1e0c1txw _1bahesu3",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "_j7hq1wwu",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING && "",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).TRANSITIONING && "_j7hq1sbx",
            (__cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).FINISHED || __cmplp.transitionStep === (0, $cAOzG.TRANSITION_STEP).DELAYING_FADE_OUT) && "_tzy4idpf",
            __cmplp.className
        ])
    });
});

});
const $d5b555147cabbe39$export$f3036e9d26f81cd9 = 'command-palette.ui.modal.body.command-shortcut-container';
const $d5b555147cabbe39$export$e3e144c17be58a44 = 'command-palette.ui.modal.body.command-chevron-container';
const $d5b555147cabbe39$export$e792b5b2b6c9ee7 = 'command-palette.ui.modal.body.command-right-icon-container';

parcelRegister("hBQBI", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2fa0ed9a30870185$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $2fa0ed9a30870185$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    rightChevronLabel: {
        "id": "command-palette.common.components.command-row.right-content.right-chevron-label",
        "defaultMessage": "Command with children icon"
    }
});

});

parcelRegister("iMtOt", function(module, exports) {

$parcel$export(module.exports, "Shortcuts", () => $7fcd400f64ed3fa3$export$b326d77e4b8b7664);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $5JgJ2 = parcelRequire("5JgJ2");

var $ftpwV = parcelRequire("ftpwV");

var $8FbYY = parcelRequire("8FbYY");

var $5t8Df = parcelRequire("5t8Df");


var $ff5gx = parcelRequire("ff5gx");
const $7fcd400f64ed3fa3$var$KeyElement = ({ shortcut: shortcut })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$export$cde89099db64abe3, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5t8Df.FilledLozenge), {
        "data-testid": (0, $258bfb6c4afc66c3$export$cd62afa4691c297)
    }, shortcut));
const $7fcd400f64ed3fa3$var$DivisorElement = ({ divisor: divisor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$var$ShortcutDivider, {
        "data-testid": (0, $258bfb6c4afc66c3$export$e06ad7c09a29974b)
    }, divisor);
/**
 * Transform shortcut string into object
 */ const $7fcd400f64ed3fa3$var$parseShortcut = (shortcut, replacers, acc = [], types = [])=>{
    const replacer = replacers.shift();
    if (!replacer) {
        acc.push({
            type: (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).KEY,
            key: shortcut
        });
        types.push((0, $ftpwV.SHORTCUT_ELEMENT_TYPES).KEY);
        return [
            acc,
            types
        ];
    }
    shortcut.split(replacer.char).forEach((str, index, self)=>{
        $7fcd400f64ed3fa3$var$parseShortcut(str, replacers.slice(0), acc, types);
        if (index < self.length - 1) {
            acc.push({
                type: replacer.replacement
            });
            types.push(replacer.replacement);
        }
    });
    return [
        acc,
        types
    ];
};
const $7fcd400f64ed3fa3$export$cfaeb054b183bb20 = ()=>(0, $5JgJ2.default)();
const $7fcd400f64ed3fa3$export$b326d77e4b8b7664 = ({ shortcut: shortcut })=>{
    const { formatMessage: formatMessage } = $7fcd400f64ed3fa3$export$cfaeb054b183bb20();
    const [shortcuts, types] = (0, $eUqFw.useMemo)(()=>$7fcd400f64ed3fa3$var$parseShortcut(shortcut, (0, $8FbYY.getShortcutSpecialCharacters)()), [
        shortcut
    ]);
    const basicShortcutMessage = (0, $eUqFw.useMemo)(()=>{
        if (types.length === 3) {
            if (types[0] === (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).KEY && types[2] === (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).KEY) {
                if (types[1] === (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).THEN) return (0, $ff5gx.messages).shortcutThen;
                if (types[1] === (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).OR) return (0, $ff5gx.messages).shortcutOr;
                if (types[1] === (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).PLUS) return (0, $ff5gx.messages).shortcutPlus;
            }
        }
        return null;
    }, [
        types
    ]);
    const formatTypeToMessage = (0, $eUqFw.useCallback)((type)=>{
        switch(type){
            case (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).THEN:
                return formatMessage((0, $ff5gx.messages).divisorThen);
            case (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).OR:
                return formatMessage((0, $ff5gx.messages).divisorOr);
            default:
                return formatMessage((0, $ff5gx.messages).divisorPlus);
        }
    }, [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$var$ShortcutContainer, {
        "data-testid": (0, $258bfb6c4afc66c3$export$ec8260df4f23714c),
        "aria-hidden": true
    }, basicShortcutMessage ? formatMessage(basicShortcutMessage, {
        shortcutA: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$var$KeyElement, {
            shortcut: shortcuts[0].key
        }),
        shortcutB: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$var$KeyElement, {
            shortcut: shortcuts[2].key
        }),
        divisor: (chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$var$DivisorElement, {
                divisor: chunk
            })
    }) : shortcuts.map((obj, index)=>{
        if (obj.type === (0, $ftpwV.SHORTCUT_ELEMENT_TYPES).KEY) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$var$KeyElement, {
            key: index,
            shortcut: obj.key
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7fcd400f64ed3fa3$var$DivisorElement, {
            key: index,
            divisor: formatTypeToMessage(obj.type)
        });
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7fcd400f64ed3fa3$var$ShortcutDivider = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8otz2",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7fcd400f64ed3fa3$var$ShortcutContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlidpf _1o9zkb7n _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $7fcd400f64ed3fa3$export$cde89099db64abe3 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1tcg _4t3i1tcg _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
const $258bfb6c4afc66c3$export$cd62afa4691c297 = 'command-palette.ui.modal.body.shortcuts-icons.shortcut-icon';
const $258bfb6c4afc66c3$export$e06ad7c09a29974b = 'command-palette.ui.modal.body.shortcuts-icons.shortcut-divider';
const $258bfb6c4afc66c3$export$ec8260df4f23714c = 'command-palette.ui.modal.modal-content.body.command-row.shortcuts.shortcut-container';

parcelRegister("ff5gx", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9663167573e5dde6$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $9663167573e5dde6$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    shortcutThen: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-then",
        "defaultMessage": "{shortcutA} <divisor>then</divisor> {shortcutB}"
    },
    shortcutOr: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-or",
        "defaultMessage": "{shortcutA} <divisor>or</divisor> {shortcutB}"
    },
    shortcutPlus: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-plus",
        "defaultMessage": "{shortcutA} <divisor>+</divisor> {shortcutB}"
    },
    divisorThen: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-then",
        "defaultMessage": "then"
    },
    divisorOr: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-or",
        "defaultMessage": "or"
    },
    divisorPlus: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-plus",
        "defaultMessage": "+"
    }
});

});


parcelRegister("6gNFs", function(module, exports) {

$parcel$export(module.exports, "useHoverTransitionStep", () => $a5599ff6bbc2ab8e$export$eefd045a02bab4c6);

var $eUqFw = parcelRequire("eUqFw");

var $8YJjX = parcelRequire("8YJjX");

var $guiFP = parcelRequire("guiFP");

var $8FbYY = parcelRequire("8FbYY");

var $cAOzG = parcelRequire("cAOzG");
const $a5599ff6bbc2ab8e$export$eefd045a02bab4c6 = (command, isActive, isFirstCommand)=>{
    const [hasTransitionedFirstCommand, setHasTransitionedFirstCommand] = (0, $eUqFw.useState)(false);
    const [transitionStep, setTransitionStep] = (0, $eUqFw.useState)((0, $cAOzG.TRANSITION_STEP).INITIAL);
    const timerRef = (0, $eUqFw.useRef)(null);
    const isReducedMotion = (0, $8YJjX.useIsReducedMotion)();
    const commandHasChildren = (0, $8FbYY.hasChildren)(command);
    (0, $eUqFw.useEffect)(()=>{
        setTransitionStep((0, $cAOzG.TRANSITION_STEP).INITIAL);
        if (timerRef.current) clearTimeout(timerRef.current);
    }, [
        command
    ]);
    const startTimerForNextStep = (nextStep, durationMs)=>{
        timerRef.current = setTimeout(()=>{
            setTransitionStep(nextStep);
            timerRef.current = null;
        }, durationMs);
    };
    const handleReducedMotionTransition = (0, $eUqFw.useCallback)(()=>{
        if (isActive) setTransitionStep((0, $cAOzG.TRANSITION_STEP).FINISHED);
        else setTransitionStep((0, $cAOzG.TRANSITION_STEP).INITIAL);
    }, [
        isActive
    ]);
    const handleWithMotionTransition = (0, $eUqFw.useCallback)(()=>{
        switch(transitionStep){
            case (0, $cAOzG.TRANSITION_STEP).INITIAL:
                if (isActive) {
                    setTransitionStep((0, $cAOzG.TRANSITION_STEP).DELAYING);
                    startTimerForNextStep((0, $cAOzG.TRANSITION_STEP).TRANSITIONING, isFirstCommand && !!command.shortcut && !hasTransitionedFirstCommand ? (0, $cAOzG.TRANSITION_INITIAL_DELAY_TIME_MS) : (0, $cAOzG.TRANSITION_HOVER_DELAY_TIME_MS));
                }
                break;
            case (0, $cAOzG.TRANSITION_STEP).DELAYING:
                if (!isActive) {
                    timerRef.current && clearTimeout(timerRef.current);
                    timerRef.current = null;
                    setTransitionStep((0, $cAOzG.TRANSITION_STEP).INITIAL);
                }
                break;
            case (0, $cAOzG.TRANSITION_STEP).TRANSITIONING:
                if (isActive) {
                    if (isFirstCommand && !!command.shortcut && !hasTransitionedFirstCommand) setHasTransitionedFirstCommand(true);
                    if (!timerRef.current) startTimerForNextStep((0, $cAOzG.TRANSITION_STEP).FINISHED, (0, $cAOzG.TRANSITION_DURATION_MS));
                }
                break;
            case (0, $cAOzG.TRANSITION_STEP).FINISHED:
                if (!isActive) setTransitionStep((0, $cAOzG.TRANSITION_STEP).DELAYING_FADE_OUT);
                break;
            case (0, $cAOzG.TRANSITION_STEP).DELAYING_FADE_OUT:
                if (!timerRef.current) startTimerForNextStep((0, $cAOzG.TRANSITION_STEP).TRANSITIONING_FADE_OUT, (0, $cAOzG.TRANSITION_HOVER_DELAY_TIME_MS));
                break;
            case (0, $cAOzG.TRANSITION_STEP).TRANSITIONING_FADE_OUT:
                if (!timerRef.current) startTimerForNextStep((0, $cAOzG.TRANSITION_STEP).INITIAL, (0, $cAOzG.TRANSITION_DURATION_MS));
                break;
            default:
                (0, $guiFP.default)({
                    error: new Error('Invalid transition step for command'),
                    meta: {
                        id: 'useTransitionStep',
                        packageName: 'jiraCommandPalette',
                        teamName: 'deliveroo'
                    }
                });
        }
    }, [
        command.shortcut,
        hasTransitionedFirstCommand,
        isActive,
        isFirstCommand,
        transitionStep
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (commandHasChildren) {
            if (isReducedMotion) handleReducedMotionTransition();
            else handleWithMotionTransition();
        }
    }, [
        commandHasChildren,
        isReducedMotion,
        handleReducedMotionTransition,
        handleWithMotionTransition
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isFirstCommand) setHasTransitionedFirstCommand(false);
    }, [
        isFirstCommand
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            if (timerRef.current) clearTimeout(timerRef.current);
        }, []);
    return transitionStep;
};

});
parcelRegister("cAOzG", function(module, exports) {

$parcel$export(module.exports, "TRANSITION_STEP", () => $2290b1f6fafc03ce$export$42d8d7c94c5a11e9);
$parcel$export(module.exports, "TRANSITION_INITIAL_DELAY_TIME_MS", () => $2290b1f6fafc03ce$export$82cfc253a6c33f59);
$parcel$export(module.exports, "TRANSITION_HOVER_DELAY_TIME_MS", () => $2290b1f6fafc03ce$export$e092796a9af3633b);
$parcel$export(module.exports, "TRANSITION_DURATION_MS", () => $2290b1f6fafc03ce$export$1cad4f611a1c0229);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $2290b1f6fafc03ce$export$42d8d7c94c5a11e9;
(function(TRANSITION_STEP) {
    TRANSITION_STEP["INITIAL"] = "initial";
    TRANSITION_STEP["DELAYING"] = "delaying";
    TRANSITION_STEP["TRANSITIONING"] = "transitioning";
    TRANSITION_STEP["FINISHED"] = "finished";
    TRANSITION_STEP["DELAYING_FADE_OUT"] = "delaying-fade-out";
    TRANSITION_STEP["TRANSITIONING_FADE_OUT"] = "transitioning-fade-out";
})($2290b1f6fafc03ce$export$42d8d7c94c5a11e9 || ($2290b1f6fafc03ce$export$42d8d7c94c5a11e9 = {}));
const $2290b1f6fafc03ce$export$82cfc253a6c33f59 = 600;
const $2290b1f6fafc03ce$export$e092796a9af3633b = 300;
const $2290b1f6fafc03ce$export$1cad4f611a1c0229 = 350;

});





parcelRegister("985MX", function(module, exports) {

$parcel$export(module.exports, "CommandRowErrorBoundary", () => $5142cc04bb4fcd8a$export$223f3c3c93a14a83);

var $eUqFw = parcelRequire("eUqFw");

var $0cdA8 = parcelRequire("0cdA8");
const $5142cc04bb4fcd8a$export$223f3c3c93a14a83 = ({ children: children, teamName: teamName, onError: onError, attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "command-palette-row",
        packageName: "jiraCommandPalette",
        fallback: "unmount",
        teamName: teamName,
        onError: onError,
        attributes: attributes
    }, children);

});

parcelRegister("dDiRc", function(module, exports) {

$parcel$export(module.exports, "GROUP_TEST_ID", () => $1d3aece513b288cb$export$d83f892940e54128);
$parcel$export(module.exports, "NO_RESULTS_TEST_ID", () => $1d3aece513b288cb$export$bf182a53106ca02e);
$parcel$export(module.exports, "SCROLL_DIRECTION", () => $1d3aece513b288cb$export$a6d65a8fb7b912d6);
const $1d3aece513b288cb$export$85eefac753ab5bdb = 'command-palette.ui.modal.body.command-body-container';
const $1d3aece513b288cb$export$617744f059bfc3ba = 'command-palette.ui.modal.body.command-container-row';
const $1d3aece513b288cb$export$d83f892940e54128 = 'command-palette.ui.modal.body.group-container';
const $1d3aece513b288cb$export$707f57180c76458e = 'command-palette.ui.modal.body.spinner-container';
const $1d3aece513b288cb$export$bf182a53106ca02e = 'command-palette.ui.modal.body.no-results-container';
var $1d3aece513b288cb$export$a6d65a8fb7b912d6;
(function(SCROLL_DIRECTION) {
    SCROLL_DIRECTION["START"] = "start";
    SCROLL_DIRECTION["END"] = "end";
})($1d3aece513b288cb$export$a6d65a8fb7b912d6 || ($1d3aece513b288cb$export$a6d65a8fb7b912d6 = {}));

});

parcelRegister("4PPUt", function(module, exports) {

$parcel$export(module.exports, "isElementVisibleInContainer", () => $4d787935cca8e899$export$b9dc8b6556026098);
$parcel$export(module.exports, "getScrollToIndex", () => $4d787935cca8e899$export$56068eb4c4e3a63c);
$parcel$export(module.exports, "scrollResultIntoView", () => $4d787935cca8e899$export$6be8a7238febd54f);

var $8FbYY = parcelRequire("8FbYY");

var $dDiRc = parcelRequire("dDiRc");
const $4d787935cca8e899$export$b9dc8b6556026098 = (element, container)=>{
    const modalBodyRect = container.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();
    return elementRect.top >= modalBodyRect.top && elementRect.bottom <= modalBodyRect.bottom;
};
const $4d787935cca8e899$export$56068eb4c4e3a63c = (results, newActiveIndex, scrollTo)=>{
    const commandResultIndex = results.findIndex((result)=>!result.isGroup && result.index === newActiveIndex);
    if (scrollTo === (0, $dDiRc.SCROLL_DIRECTION).START && commandResultIndex > 0) {
        // Verify if there is any active command before this id
        const prevActiveCommandIndex = results.findIndex((result, index)=>index < commandResultIndex && !result.isGroup && (0, $8FbYY.hasAction)(result.command));
        if (prevActiveCommandIndex === -1) return 0;
    }
    if (scrollTo === (0, $dDiRc.SCROLL_DIRECTION).END) {
        // Verify if there is any active command after this id
        const afterActiveCommandIndex = results.findIndex((result, index)=>index > commandResultIndex && !result.isGroup && (0, $8FbYY.hasAction)(result.command));
        if (afterActiveCommandIndex === -1) return results.length - 1;
        // Scrolling down, so group headings don't need to be taken into account
        return commandResultIndex;
    }
    const isCommandAfterGroupHeading = commandResultIndex > 0 && results[commandResultIndex - 1].isGroup;
    return isCommandAfterGroupHeading ? commandResultIndex - 1 : commandResultIndex;
};
const $4d787935cca8e899$export$6be8a7238febd54f = (scrollToResult, scrollTo)=>{
    if (!scrollToResult?.parentElement) return;
    const parent = scrollToResult.parentElement;
    const elemRect = scrollToResult.getBoundingClientRect();
    const parentRect = parent.getBoundingClientRect();
    const gapScroll = 4;
    if (scrollTo === (0, $dDiRc.SCROLL_DIRECTION).END) {
        const commandPosition = elemRect.bottom - parentRect.top;
        const amountToScroll = commandPosition - parentRect.height;
        const pos = amountToScroll + gapScroll + parent.scrollTop;
        scrollToResult.parentElement.scrollTo({
            top: pos
        });
    } else {
        const commandPosition = parentRect.top - elemRect.top;
        const amountToScroll = parent.scrollTop - commandPosition;
        const pos = amountToScroll - gapScroll;
        scrollToResult.parentElement.scrollTo({
            top: pos
        });
    }
};

});


parcelRegister("b4qUd", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $846e4b3bae55c666$export$a06f1c675e846f6f);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

const $846e4b3bae55c666$export$a06f1c675e846f6f = ({ defaultFooterContent: defaultFooterContent, children: children })=>{
    const footerChildren = children || defaultFooterContent;
    if (!footerChildren) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($846e4b3bae55c666$var$ModalFooter, {
        "data-testid": (0, $933f109161dc97b5$export$aca3e1b45b29f2bb)
    }, footerChildren);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $846e4b3bae55c666$var$ModalFooter = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_mrkb1kw7 _1o0z1kw7 _x3doh6cr _1yt49l6b",
            __cmplp.className
        ])
    });
});

});
const $933f109161dc97b5$export$aca3e1b45b29f2bb = 'command-palette.ui.modal.footer.footer';


parcelRegister("48xUp", function(module, exports) {

$parcel$export(module.exports, "Header", () => $3708226beef9cde7$export$8b251419efc915eb);

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $PdmhA = parcelRequire("PdmhA");

const $3708226beef9cde7$export$8b251419efc915eb = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $3708226beef9cde7$var$headerStyles,
        testId: (0, $baf314009244cc15$export$bf5b960a2e79e6cf)
    }, children);
const $3708226beef9cde7$var$headerStyles = (0, $1ZAYh.xcss)({
    borderTopLeftRadius: 'inherit',
    borderTopRightRadius: 'inherit',
    padding: 'space.200',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    borderBottom: `solid 1px ${`var(--ds-border, ${(0, $PdmhA).N40})`}`
});

});
const $baf314009244cc15$export$bf5b960a2e79e6cf = 'command-palette.ui.modal.header.modal-header';



parcelRegister("46gH8", function(module, exports) {

$parcel$export(module.exports, "getCommandPaletteIssueActionsHeader", () => $1d28d9547f2aa59c$export$cd9931655a8cfb04);

var $9zALC = parcelRequire("9zALC");

var $36mrL = parcelRequire("36mrL");

var $2NY3y = parcelRequire("2NY3y");
const $1d28d9547f2aa59c$export$cd9931655a8cfb04 = (issueKey)=>`${0, $9zALC.COMMAND_PALETTE_ISSUE_ACTIONS}-${issueKey || ''}`;

});
parcelRegister("36mrL", function(module, exports) {

$parcel$export(module.exports, "getCommandPaletteIssueActionsPriority", () => $58e6fffac6029e83$export$5164bb42fa883371);
const $58e6fffac6029e83$var$COMMAND_PALETTE_ISSUE_ACTIONS_PRIORITY = {
    STATUS: 10,
    SUMMARY: 20,
    PARENT: 30,
    LINK_ISSUE: 40,
    CONTENT_FIRST_TAB: 50,
    PINNED_FIELDS: 60,
    DETAILS: 70,
    CONTENT_OTHER_TABS: 80,
    MORE_FIELDS: 90,
    OLD_ISSUE_FIELDS: 95,
    ADD_COMMENT: 100,
    GQL_FIELDS: 105,
    SUB_HEADER_ITEMS: 110,
    ISSUE_HEADER_ITEMS: 120
};
const $58e6fffac6029e83$export$5164bb42fa883371 = (key)=>$58e6fffac6029e83$var$COMMAND_PALETTE_ISSUE_ACTIONS_PRIORITY[key];

});

parcelRegister("2NY3y", function(module, exports) {

$parcel$export(module.exports, "noSortNoFilterOverride", () => $94f67465bbdaf727$export$78d30e5b661ceee3);
const $94f67465bbdaf727$export$78d30e5b661ceee3 = (_search, selectedCommands)=>selectedCommands;

});


parcelRegister("gfXKy", function(module, exports) {

$parcel$export(module.exports, "useCommandKeywords", () => $59897234799b31c8$export$4d8fe3ef6385358);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3iBHM = parcelRequire("3iBHM");
const $59897234799b31c8$export$4d8fe3ef6385358 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const getKeywords = (0, $eUqFw.useCallback)((keywordGroup)=>(0, $3iBHM.messages)[keywordGroup] ? formatMessage((0, $3iBHM.messages)[keywordGroup]) : undefined, [
        formatMessage
    ]);
    return {
        getKeywords: getKeywords
    };
};

});
parcelRegister("3iBHM", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2f74b9c3b50ad31d$export$defe85febe8b728c);
/* eslint-disable jira/i18n/id-named-by-package */ 
var $90IgZ = parcelRequire("90IgZ");
const $2f74b9c3b50ad31d$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    searchYourIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.search-your-issues-synonyms",
        "defaultMessage": "Find my ideas tickets requests tasks work"
    },
    changeStatusSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.change-status-synonyms",
        "defaultMessage": "Move through workflow  Progress Done Complete transition"
    },
    assignToMeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.assign-to-me-synonyms",
        "defaultMessage": "self"
    },
    assignIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.assign-issue-synonyms",
        "defaultMessage": "Choose person Give work Pick assignee Select ticket idea"
    },
    startWatchingIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.start-watching-issue-synonyms",
        "defaultMessage": "Follow work Track Unwatch Unfollow"
    },
    backlogSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.backlog-synonyms",
        "defaultMessage": "Inventory Go"
    },
    boardSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.board-synonyms",
        "defaultMessage": "Boards Sprint Kanban Swimlanes Do Go"
    },
    reportsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.reports-synonyms",
        "defaultMessage": "Summary Insights Burndown Go"
    },
    timelineSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.timeline-synonyms",
        "defaultMessage": "Plan Work calendar Schedule Overview Delivery Go Roadmap"
    },
    // TODO cleanup isCommandPaletteQuickSearchEnabled
    quickSearchSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.quick-search-synonyms",
        "defaultMessage": "Search products across Atlassian Go to"
    },
    pageSearchSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.page-search-synonyms",
        "defaultMessage": "Control f Command cmd cntrl Go find ctrl"
    },
    createIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.create-issue-synonyms",
        "defaultMessage": "work Start idea New ticket task"
    },
    switchDarkThemeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.switch-dark-theme-synonyms",
        "defaultMessage": "light Darkmode lightmode Change Appearance Colours colors nightmode daymode"
    },
    matchSystemThemeSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.match-system-theme-synonyms",
        "defaultMessage": "Sync settings Darkmode lightmode Change Appearance Colours colors nightmode daymode"
    },
    copyCurrentPageUrlSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.copy-current-page-url-synonyms",
        "defaultMessage": "link website address"
    },
    getHelpSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.get-help-synonyms",
        "defaultMessage": "In-product Support Documentation Questions Answers"
    },
    viewKeyboardShortcutsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-keyboard-shortcuts-synonyms",
        "defaultMessage": "Hotkeys Show See"
    },
    editDescriptionSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.edit-description-synonyms",
        "defaultMessage": "Completion criteria Info Information Details Add Write"
    },
    addAttachmentSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-attachment-synonyms",
        "defaultMessage": "Attach Upload Document Media"
    },
    addCommentSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-comment-synonyms",
        "defaultMessage": "Write Message"
    },
    logWorkSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.log-work-synonyms",
        "defaultMessage": "Track Record hours Time spent"
    },
    addRemoveFlagSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-remove-flag-synonyms",
        "defaultMessage": "Unflag Mark Unmark Star Unstar"
    },
    cloneIssueSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.clone-issue-synonyms",
        "defaultMessage": "Copy Duplicate Task Idea Request"
    },
    linkConfluencePageSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.link-confluence-page-synonyms",
        "defaultMessage": "Relate Add Connect"
    },
    addAUrlSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.add-a-url-synonyms",
        "defaultMessage": "Connect Weblink Link Website Domain"
    },
    goToIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-issues-synonyms",
        "defaultMessage": "Advanced issue search Project Filter JQL search list View all"
    },
    goToPersonalSettingsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-personal-settings-synonyms",
        "defaultMessage": "Preferences Notifications Theme Jira labs"
    },
    goToAccountSettingsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-account-settings-synonyms",
        "defaultMessage": "Preferences Privacy Profile Your details Personal information"
    },
    viewAllIssuesSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-issues-synonyms",
        "defaultMessage": "Site issues JQL View all"
    },
    viewAllProjectsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-projects-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllPlansSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-plans-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllBoardsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-boards-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllFiltersSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-filters-synonyms",
        "defaultMessage": "List Go"
    },
    viewAllDashboardsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.view-all-dashboards-synonyms",
        "defaultMessage": "List Go"
    },
    checkNotificationsSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.check-notifications-synonyms",
        "defaultMessage": "window See Updates"
    },
    goToUserManagementSynonyms: {
        "id": "command-palette-integration.controllers.use-command-keywords.go-to-user-management-synonyms",
        "defaultMessage": "Permissions"
    }
});

});


parcelRegister("bT6OI", function(module, exports) {

$parcel$export(module.exports, "CommandFieldHeader", () => $f484a350daa785aa$export$c6444eb1c6f44b2d);

var $eUqFw = parcelRequire("eUqFw");

var $1zbEq = parcelRequire("1zbEq");

var $LddR2 = parcelRequire("LddR2");

var $70Z2O = parcelRequire("70Z2O");
const $f484a350daa785aa$export$c6444eb1c6f44b2d = ({ children: children, issueKey: issueKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $LddR2.components).Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zbEq.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $70Z2O.IssueTag), {
        issueKey: issueKey
    }), children));

});
parcelRegister("70Z2O", function(module, exports) {

$parcel$export(module.exports, "IssueTag", () => $f2e2061572377f16$export$a342a0ad2c552031);

var $eUqFw = parcelRequire("eUqFw");

var $9Amv1 = parcelRequire("9Amv1");
var $1ZAYh = parcelRequire("1ZAYh");

var $h2IaY = parcelRequire("h2IaY");

var $b5tfU = parcelRequire("b5tfU");

var $8xsZc = parcelRequire("8xsZc");

var $fWeG1 = parcelRequire("fWeG1");
const $f2e2061572377f16$export$a342a0ad2c552031 = ({ issueKey: issueKey })=>{
    const [{ value: summary }] = (0, $fWeG1.useSummaryField)({
        issueKey: issueKey
    });
    const [{ value: issueType }] = (0, $8xsZc.useIssueTypeField)({
        issueKey: issueKey
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: $f2e2061572377f16$var$issueTagContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9Amv1.default), {
        xcss: $f2e2061572377f16$var$issueTagStyles,
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5tfU.IssueLeftIcon), {
        issueTypeName: issueType?.name,
        iconUrl: issueType?.iconUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $h2IaY.TruncateWithTooltipOnHover), null, `${issueKey} ${summary}`)));
};
const $f2e2061572377f16$var$issueTagContainerStyles = (0, $1ZAYh.xcss)({
    width: '100%',
    minWidth: '0'
});
const $f2e2061572377f16$var$issueTagStyles = (0, $1ZAYh.xcss)({
    maxWidth: '100%',
    padding: 'space.050',
    backgroundColor: 'color.background.neutral',
    borderRadius: 'border.radius.100',
    fontSize: '14px',
    color: 'color.text.subtle',
    lineHeight: 1
});

});
parcelRegister("h2IaY", function(module, exports) {

$parcel$export(module.exports, "TruncateWithTooltipOnHover", () => $dae903da6e3f2851$export$b2323503daaefa);

var $eUqFw = parcelRequire("eUqFw");

var $8cU5f = parcelRequire("8cU5f");

var $lXgc2 = parcelRequire("lXgc2");


var $lDcdk = parcelRequire("lDcdk");
const $dae903da6e3f2851$export$70f47de153e915ed = ()=>(0, $eUqFw.useRef)(null);
const $dae903da6e3f2851$export$b2323503daaefa = ({ children: children })=>{
    const containerRef = $dae903da6e3f2851$export$70f47de153e915ed();
    const { shouldShowTruncatedTooltip: shouldShowTruncatedTooltip } = (0, $lDcdk.useTruncatedTooltip)({
        containerRef: containerRef,
        // Tooltip delay is set on the tooltip component
        tooltipDelay: 0
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: shouldShowTruncatedTooltip ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lXgc2.TooltipContent), {
                "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-hover.tooltip-content"
            }, children) : '',
        component: (0, $lXgc2.TooltipComponent),
        position: "bottom-end",
        delay: (0, $79f2d7e0eace9088$export$f9e3e7ede9ba929d)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lXgc2.TooltipTrigger), {
            "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-hover.tooltip-trigger",
            ...tooltipProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lXgc2.TruncateWithTooltipContainer), {
            ref: containerRef
        }, children)));
};

});

parcelRegister("b5tfU", function(module, exports) {

$parcel$export(module.exports, "IssueLeftIcon", () => $1622fc3f30429d58$export$b1b562672a76ad84);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4SlOI = parcelRequire("4SlOI");
const $1622fc3f30429d58$export$b1b562672a76ad84 = ({ iconUrl: iconUrl, issueTypeName: issueTypeName })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("img", {
        src: iconUrl,
        alt: formatMessage((0, $4SlOI.messages).issueIconAltText, {
            issueTypeName: issueTypeName
        }),
        height: "16"
    });
};

});
parcelRegister("4SlOI", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9a3b0db79e5e3d34$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $9a3b0db79e5e3d34$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    issueIconAltText: {
        "id": "command-palette-common.common.command.issue.issue-left-icon.issue-icon-alt-text",
        "defaultMessage": "Icon for the issue type {issueTypeName}"
    }
});

});


parcelRegister("8xsZc", function(module, exports) {

$parcel$export(module.exports, "useIssueTypeField", () => $d6d526ec7a011453$export$3da96c4009e089ca);

var $illlw = parcelRequire("illlw");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $lO4Or = parcelRequire("lO4Or");
const $d6d526ec7a011453$export$3da96c4009e089ca = ({ issueKey: issueKey, onSuccess: onSuccess, onFailure: onFailure })=>{
    const [{ value: fieldConfig }] = (0, $8411R.useFieldConfig)(issueKey, (0, $lO4Or.ISSUE_TYPE));
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig, 'schema.type', (0, $lO4Or.ISSUE_TYPE));
    const [{ value: value, error: error, loading: loading }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: (0, $lO4Or.ISSUE_TYPE),
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig,
            loading: loading
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});
parcelRegister("gGiWF", function(module, exports) {

$parcel$export(module.exports, "useEditField", () => $04407df9ae6d3d74$export$343e962d356c0af1);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $5oStv = parcelRequire("5oStv");

var $gUUjF = parcelRequire("gUUjF");

var $1ybV0 = parcelRequire("1ybV0");

var $JRB5w = parcelRequire("JRB5w");

var $7byHA = parcelRequire("7byHA");

var $hJ992 = parcelRequire("hJ992");

var $8wbQu = parcelRequire("8wbQu");

var $7eDnP = parcelRequire("7eDnP");

var $8p8vy = parcelRequire("8p8vy");

var $3koWU = parcelRequire("3koWU");

var $jMP2a = parcelRequire("jMP2a");

var $kmr29 = parcelRequire("kmr29");

var $fecbI = parcelRequire("fecbI");
/**
 * Some responses contain `fields` property without `fieldKey`.
 * We must avoid changing the state of this fields by checking `fieldKey` property in the `fields`.
 * @param response
 * @param fieldKey
 */ const $04407df9ae6d3d74$var$getFieldValue = (response, fieldKey)=>{
    if (!response) return null;
    if (response.fields) {
        if (Object.hasOwnProperty.call(response.fields, fieldKey)) return response.fields[fieldKey];
        return null;
    }
    return response;
};
const $04407df9ae6d3d74$var$shouldCallSetFieldValue = (response, fieldKey)=>{
    if (!response) return false;
    if (response.fields) return !!Object.hasOwnProperty.call(response.fields, fieldKey);
    return true;
};
const $04407df9ae6d3d74$export$3796d3fdbc2e6b54 = (fieldOptions)=>{
    // di-ignore - Please fix parent-switcher examples
    const baseUrl = '';
    const { issueKey: issueKey, issueId: issueId, fieldKey: fieldKey, fieldType: fieldType, initialValue: initialValue, analyticsFieldKeyAlias: analyticsFieldKeyAlias, analyticsFieldTypeAlias: analyticsFieldTypeAlias, mapNonOptimisticResponse: mapNonOptimisticResponse = $04407df9ae6d3d74$var$getFieldValue, saveField: saveField = (0, $fecbI.defaultSaveField), saveFieldById: saveFieldById = (0, $fecbI.defaultSaveFieldById), addValuesToField: addValuesToField = (0, $fecbI.defaultAddValuesToField), removeValuesFromField: removeValuesFromField = (0, $fecbI.defaultRemoveValuesFromField), onSubmit: onSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onSuccess: onSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onFailure: onFailure = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) } = fieldOptions;
    // We need to track the mounted state as it is possible that a component
    // using this hook can be unmounted before the async edit operation is completed.
    // Causing a react warning about setting state on an unmounted component.
    const isMounted = (0, $3koWU.useIsMounted)();
    const [fieldPersistedValue, { setFieldValue: setFieldValue }] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const fieldValue = fieldPersistedValue !== undefined ? fieldPersistedValue : initialValue;
    const [error, setError] = (0, $eUqFw.useState)(null);
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    const resetError = (0, $eUqFw.useCallback)(()=>{
        if (isMounted.current) setError(null);
    }, [
        setError,
        isMounted
    ]);
    const editFieldValue = (0, $eUqFw.useCallback)(async (editOperation, editOperationType, valuesForOperation, valuesForUI, meta, analyticsEvent, options = {
        isOptimistic: true
    })=>{
        let result;
        const analyticsData = {
            editOperationType: editOperationType,
            issueId: issueId,
            fieldKey: analyticsFieldKeyAlias ?? fieldKey,
            fieldType: analyticsFieldTypeAlias ?? fieldType
        };
        if (isMounted.current) {
            setLoading(true);
            setError(null);
        }
        try {
            onSubmit(fieldValue, valuesForOperation, meta, analyticsEvent);
            if (options.isOptimistic) setFieldValue(issueKey, fieldKey, valuesForUI);
            result = await editOperation(issueKey, fieldKey, valuesForOperation, baseUrl, meta);
            const fieldValueResponse = mapNonOptimisticResponse(result, fieldKey);
            $04407df9ae6d3d74$var$shouldCallSetFieldValue(result, fieldKey) && setFieldValue(issueKey, fieldKey, fieldValueResponse);
            onSuccess(fieldValueResponse ?? valuesForOperation, analyticsEvent);
            (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'field updated', analyticsData);
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'field updateSucceeded', analyticsData);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (ex) {
            result = Promise.reject(ex);
            onFailure(ex, valuesForOperation);
            setFieldValue(issueKey, fieldKey, fieldValue);
            if (isMounted.current) setError(ex);
            const isValidationError = ex instanceof (0, $7byHA.ValidationError);
            if (!isValidationError) (0, $gUUjF.default).safeErrorWithoutCustomerData('issue-field.save-value', `Failed to update field ${fieldKey} of type ${fieldType}`, ex);
            (0, $jMP2a.fireOperationalAnalytics)(analyticsEvent, 'field updateFailed', {
                fieldKey: fieldKey,
                fieldType: (0, $1ybV0.ff)('issue.detail.issue-view-story-point-field-type-analytics_n9ha6') ? analyticsFieldTypeAlias ?? fieldType : fieldType,
                isValidationError: isValidationError,
                isClientFetchError: (0, $JRB5w.isClientFetchError)(ex)
            });
        }
        if (isMounted.current) setLoading(false);
        return result;
    }, [
        issueId,
        analyticsFieldKeyAlias,
        fieldKey,
        analyticsFieldTypeAlias,
        fieldType,
        isMounted,
        onSubmit,
        fieldValue,
        setFieldValue,
        issueKey,
        onSuccess,
        onFailure,
        mapNonOptimisticResponse
    ]);
    const saveValue = (0, $eUqFw.useCallback)(async (newValue, meta, analyticsEvent)=>editFieldValue(saveField, 'set', newValue, newValue, meta, analyticsEvent), [
        editFieldValue,
        saveField
    ]);
    const saveById = (0, $eUqFw.useCallback)(async (newValue, meta, analyticsEvent)=>editFieldValue(saveFieldById, 'set', newValue, newValue, meta, analyticsEvent, {
            isOptimistic: false
        }), [
        editFieldValue,
        saveFieldById
    ]);
    const addValues = (0, $eUqFw.useCallback)(async (valuesToAdd, expectedValuesAfterAdding, meta, analyticsEvent)=>editFieldValue(addValuesToField, 'add', valuesToAdd, expectedValuesAfterAdding, meta, analyticsEvent), [
        editFieldValue,
        addValuesToField
    ]);
    const removeValues = (0, $eUqFw.useCallback)(async (valuesToRemove, expectedValuesAfterRemoval, meta, analyticsEvent)=>editFieldValue(removeValuesFromField, 'remove', valuesToRemove, expectedValuesAfterRemoval, meta, analyticsEvent), [
        editFieldValue,
        removeValuesFromField
    ]);
    return [
        {
            value: fieldValue,
            loading: loading,
            error: error
        },
        {
            saveById: saveById,
            saveValue: saveValue,
            addValues: addValues,
            removeValues: removeValues,
            resetError: resetError
        }
    ];
};
const $04407df9ae6d3d74$export$76d937477b5f784a = (issueKey)=>{
    const contextualIssueId = (0, $hJ992.useIssueId)();
    const contextualIssueKey = (0, $hJ992.useIssueKey)();
    return contextualIssueKey === issueKey ? contextualIssueId : null;
};
const $04407df9ae6d3d74$export$343e962d356c0af1 = (fieldOptions)=>{
    const { fieldKey: fieldKey, issueId: issueIdFromFieldOptions, issueKey: issueKey, onSubmit: onSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onSuccess: onSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))), onFailure: onFailure = (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu))) } = fieldOptions;
    const [, { fieldChanged: fieldChanged, fieldChangeFailed: fieldChangeFailed, fieldChangeRequested: fieldChangeRequested }] = (0, $8p8vy.useIssueViewFieldUpdateEvents)();
    const contextualIssueId = $04407df9ae6d3d74$export$76d937477b5f784a(issueKey);
    const issueId = issueIdFromFieldOptions ?? contextualIssueId;
    const isEditFromIssueView = (0, $8wbQu.useIsEditFromIssueView);
    const onSubmitFn = (0, $eUqFw.useCallback)((oldValue, newValue, meta, event)=>{
        onSubmit(oldValue, newValue, meta, event);
        issueId && fieldChangeRequested(issueId, fieldKey, newValue, meta);
    }, [
        fieldChangeRequested,
        fieldKey,
        issueId,
        onSubmit
    ]);
    const onSuccessFn = (0, $eUqFw.useCallback)(async (fieldValue, event)=>{
        onSuccess(fieldValue);
        issueId && fieldChanged(issueId, fieldKey, fieldValue);
        if (!isEditFromIssueView(event)) try {
            const reason = (0, $7eDnP.Reason).SoftRefresh;
            // eslint-disable-next-line jira/wrm/no-load-bridge
            await (0, $5oStv.default).refreshIssuePageThrowable(issueKey, reason);
        } catch (error) {
            (0, $gUUjF.default).safeErrorWithoutCustomerData('issue.fields.use-edit-field.refresh', error instanceof Error ? error.message : 'useEditField issue refresh failed');
        }
    }, [
        fieldChanged,
        fieldKey,
        isEditFromIssueView,
        issueId,
        issueKey,
        onSuccess
    ]);
    const onFailureFn = (0, $eUqFw.useCallback)((error, failedValue)=>{
        onFailure(error, failedValue);
        issueId && fieldChangeFailed(issueId, fieldKey);
    }, [
        fieldChangeFailed,
        fieldKey,
        issueId,
        onFailure
    ]);
    return $04407df9ae6d3d74$export$3796d3fdbc2e6b54({
        ...fieldOptions,
        onSubmit: onSubmitFn,
        onSuccess: onSuccessFn,
        onFailure: onFailureFn
    });
};

});
parcelRegister("5oStv", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdea36b35279d86d$export$2e2bcd8739ae039);

var $7eDnP = parcelRequire("7eDnP");
const $bdea36b35279d86d$var$REFRESH_ISSUE_PAGE_EVENT = 'legacy_refreshIssuePage';
const $bdea36b35279d86d$var$UPDATE_ISSUE_GLANCE_EVENT = 'legacy_updateIssueGlance';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$addEventListener = (event, callback)=>{
    document.addEventListener(event, callback);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$removeEventListener = (event, callback)=>{
    document.removeEventListener(event, callback);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$addRefreshIssueListener = (callback)=>$bdea36b35279d86d$var$addEventListener($bdea36b35279d86d$var$REFRESH_ISSUE_PAGE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$removeRefreshIssueListener = (callback)=>$bdea36b35279d86d$var$removeEventListener($bdea36b35279d86d$var$REFRESH_ISSUE_PAGE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$addUpdateIssueGlanceListener = (callback)=>$bdea36b35279d86d$var$addEventListener($bdea36b35279d86d$var$UPDATE_ISSUE_GLANCE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bdea36b35279d86d$var$removeUpdateIssueGlanceListener = (callback)=>$bdea36b35279d86d$var$removeEventListener($bdea36b35279d86d$var$UPDATE_ISSUE_GLANCE_EVENT, callback);
const $bdea36b35279d86d$var$refreshIssuePageThrowable = (issueKey, reason = (0, $7eDnP.Reason).OnDemand)=>{
    try {
        document.dispatchEvent(new CustomEvent($bdea36b35279d86d$var$REFRESH_ISSUE_PAGE_EVENT, {
            detail: [
                issueKey,
                {
                    mergeIntoCurrent: false,
                    reason: reason
                }
            ]
        }));
        return Promise.resolve();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return Promise.reject(e);
    }
};
const $bdea36b35279d86d$var$refreshIssuePage = (issueKey)=>// Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    $bdea36b35279d86d$var$refreshIssuePageThrowable(issueKey).catch(()=>{});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bdea36b35279d86d$export$2e2bcd8739ae039 = {
    addRefreshIssueListener: $bdea36b35279d86d$var$addRefreshIssueListener,
    removeRefreshIssueListener: $bdea36b35279d86d$var$removeRefreshIssueListener,
    addUpdateIssueGlanceListener: $bdea36b35279d86d$var$addUpdateIssueGlanceListener,
    removeUpdateIssueGlanceListener: $bdea36b35279d86d$var$removeUpdateIssueGlanceListener,
    refreshIssuePageThrowable: $bdea36b35279d86d$var$refreshIssuePageThrowable,
    refreshIssuePage: $bdea36b35279d86d$var$refreshIssuePage
};

});
parcelRegister("7eDnP", function(module, exports) {

$parcel$export(module.exports, "Reason", () => $501d104507444a18$export$fe867595c4640fb1);
const $501d104507444a18$export$fe867595c4640fb1 = {
    /**
	 * Aka hard refresh, used by Ecosystem apps to refresh issue view on demand
	 * 1) Full issue view refresh
	 * 2) Hard Ecosystem apps refresh (causes remounting of the apps)
	 */ OnDemand: 'ON_DEMAND',
    /**
	 * Used by Jira internally to update issue view on demand without forcing Ecosystem apps to rerender
	 * 1) Full issue view refresh only
	 * 2) Ecosystem app aren't hard refreshed, however, if field's value has changed, Forge custom field will rerender
	 */ SoftRefresh: 'SOFT_REFRESH',
    /**
	 * Issue view refresh caused by Realtime service (Jirt)
	 */ Realtime: 'REALTIME'
};

});


parcelRegister("8wbQu", function(module, exports) {

$parcel$export(module.exports, "useIsEditFromIssueView", () => $e05e50438955dd5a$export$870b996a6c1c7896);

var $hRcYT = parcelRequire("hRcYT");

var $iKlrz = parcelRequire("iKlrz");
const $e05e50438955dd5a$export$870b996a6c1c7896 = (event)=>{
    const ISSUE_VIEW_SOURCES = [
        'fullIssueScreen',
        'boardIssueViewScreen',
        'backlogScreen',
        'agility-backlogScreen',
        'issueNavigatorEmbeddedIssueViewScreen',
        'globalIssueNavigatorIssueScreen',
        'mobileIssueScreen',
        'classicRoadmapScreen',
        'roadmapScreen',
        'versionDetailsIssueScreen',
        'bitbucketIssueScreen',
        'jsmQueueAgentViewSidebarScreen',
        'viewQueueIssueScreen',
        'jswModalIssueAppScreen',
        'jwmModalIssueAppScreen',
        'jswSidebarIssueAppScreen',
        'jwmSidebarIssueAppScreen'
    ];
    const { payload: { source: source } } = (0, $iKlrz.getEvent)(event);
    if (!source) return false;
    if (ISSUE_VIEW_SOURCES.includes(source)) // event originated from issue view location
    return true;
    if (source.startsWith((0, $hRcYT.PACKAGE_NAME_GASV3))) // event originated from forge app, which can only be mounted in issue view for field editing
    return true;
    return false;
};

});

parcelRegister("8p8vy", function(module, exports) {

$parcel$export(module.exports, "useIssueViewFieldUpdateEvents", () => $0829b81e40dd527a$export$444af741f6d8f512);
$parcel$export(module.exports, "IssueViewFieldUpdateEventContainer", () => $0829b81e40dd527a$export$f9eb49cc2f0e28ce);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");

var $k3tie = parcelRequire("k3tie");
const $0829b81e40dd527a$var$registerEventHandler = (type, eventHandler)=>({ getState: getState, setState: setState })=>{
        if (typeof eventHandler !== 'function') // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        const { eventHandlers: eventHandlers } = getState();
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ onChange: OnChangeHandler[]; }'.
        const typeEventHandlers = eventHandlers[type];
        setState({
            eventHandlers: {
                ...eventHandlers,
                [type]: typeEventHandlers.concat([
                    eventHandler
                ])
            }
        });
        return ()=>{
            const { eventHandlers: eventHandlersForUnregister } = getState();
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ onChange: OnChangeHandler[]; }'.
            const typeEventHandlersForUnregister = eventHandlersForUnregister[type];
            const newTypeEventHandlers = typeEventHandlersForUnregister.filter(// @ts-expect-error - TS7006 - Parameter 'handler' implicitly has an 'any' type.
            (handler)=>handler !== eventHandler);
            setState({
                eventHandlers: {
                    ...eventHandlersForUnregister,
                    [type]: newTypeEventHandlers
                }
            });
        };
    };
const $0829b81e40dd527a$var$fieldChanged = (issueId, fieldId, fieldValue)=>({ getState: getState })=>{
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                fieldId: // field id is required to be compatible with v1 onChange API
                fieldId,
                meta: {
                    fieldId: fieldId,
                    fieldValue: fieldValue
                },
                type: (0, $k3tie.ChangeEventTypes).FIELD_CHANGED
            });
        });
    };
const $0829b81e40dd527a$var$fieldChangeFailed = (issueId, fieldId)=>({ getState: getState })=>{
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                meta: {
                    fieldId: fieldId
                },
                type: (0, $k3tie.ChangeEventTypes).FIELD_CHANGE_FAILED
            });
        });
    };
const $0829b81e40dd527a$var$fieldChangeRequested = (issueId, fieldId, fieldValue, additionalProperties)=>({ getState: getState })=>{
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                meta: {
                    fieldId: fieldId,
                    fieldValue: fieldValue,
                    additionalProperties: additionalProperties
                },
                type: (0, $k3tie.ChangeEventTypes).FIELD_CHANGE_REQUESTED
            });
        });
    };
const $0829b81e40dd527a$var$actions = {
    fieldChanged: $0829b81e40dd527a$var$fieldChanged,
    fieldChangeFailed: $0829b81e40dd527a$var$fieldChangeFailed,
    fieldChangeRequested: $0829b81e40dd527a$var$fieldChangeRequested,
    registerEventHandler: $0829b81e40dd527a$var$registerEventHandler
};
// this is a global state
const $0829b81e40dd527a$var$store = (0, $a61MH.createStore)({
    name: 'issue-view-field-update-events',
    initialState: {
        eventHandlers: {
            onChange: []
        }
    },
    actions: $0829b81e40dd527a$var$actions
});
const $0829b81e40dd527a$export$444af741f6d8f512 = (0, $ggKAj.createHook)($0829b81e40dd527a$var$store, {
    selector: null
});
const $0829b81e40dd527a$export$f9eb49cc2f0e28ce = (0, $heB5U.createContainer)($0829b81e40dd527a$var$store);

});
parcelRegister("k3tie", function(module, exports) {

$parcel$export(module.exports, "ChangeEventTypes", () => $8f27d9da737621d3$export$8db21fc94823e1cc);
// Copied over from `src/packages/issue/issue-view/src/model/change-type.js`
const $8f27d9da737621d3$export$8b9b8ed7fbac313c = 'FIELD_CHANGE_REQUESTED';
const $8f27d9da737621d3$export$f567ac9d3526e5ce = 'FIELD_CHANGED';
const $8f27d9da737621d3$export$7c15aaba9a26f469 = 'FIELD_CHANGE_FAILED';
const $8f27d9da737621d3$export$8db21fc94823e1cc = {
    [$8f27d9da737621d3$export$8b9b8ed7fbac313c]: $8f27d9da737621d3$export$8b9b8ed7fbac313c,
    [$8f27d9da737621d3$export$7c15aaba9a26f469]: $8f27d9da737621d3$export$7c15aaba9a26f469,
    [$8f27d9da737621d3$export$f567ac9d3526e5ce]: $8f27d9da737621d3$export$f567ac9d3526e5ce
};

});


parcelRegister("3koWU", function(module, exports) {

$parcel$export(module.exports, "useIsMounted", () => $c314bd343c8e5174$export$80c2a3957bcb42ea);

var $eUqFw = parcelRequire("eUqFw");
const $c314bd343c8e5174$export$80c2a3957bcb42ea = ()=>{
    const isMounted = (0, $eUqFw.useRef)(true);
    (0, $eUqFw.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, [
        isMounted
    ]);
    return isMounted;
};

});

parcelRegister("kmr29", function(module, exports) {

$parcel$export(module.exports, "useFieldValue", () => $da19d1ee706d4a81$export$b79fae7fbe3ac392);
$parcel$export(module.exports, "useFieldsValues", () => $da19d1ee706d4a81$export$25b73e671fe7a8fa);
$parcel$export(module.exports, "useFieldValuesForIssues", () => $da19d1ee706d4a81$export$ac289b84121829df);
$parcel$export(module.exports, "useMultiFieldValuesForIssues", () => $da19d1ee706d4a81$export$915cdeec521b54f7);
$parcel$export(module.exports, "FieldValueSubscriber", () => $da19d1ee706d4a81$export$4e5f1f4ed08d155e);
$parcel$export(module.exports, "useFieldsValuesActions", () => $da19d1ee706d4a81$export$612d9bcb0c9d8976);

var $eUqFw = parcelRequire("eUqFw");

var $2vzCR = parcelRequire("2vzCR");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
var $dYfll = parcelRequire("dYfll");
const $da19d1ee706d4a81$var$setIssue = (issueKey, fields)=>({ setState: setState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: fields
        });
    };
const $da19d1ee706d4a81$var$setIssues = (issues)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState(newIssues);
    };
const $da19d1ee706d4a81$var$setFieldValue = (issueKey, fieldKey, value)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: value
            }
        });
    };
const $da19d1ee706d4a81$var$getFieldValue = (issueKey, fieldKey)=>({ getState: getState })=>{
        const issueFieldValues = getState()[issueKey];
        return issueFieldValues && issueFieldValues[fieldKey];
    };
const $da19d1ee706d4a81$var$mergeIssue = (issueKey, fields)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, getState()[issueKey], fields)
        });
    };
const $da19d1ee706d4a81$export$11aa02e14fdf7753 = (issues)=>({ setState: setState, getState: getState })=>{
        if (issues.length === 0) return;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, getState(), newIssues));
    };
const $da19d1ee706d4a81$var$actions = {
    setFieldValue: $da19d1ee706d4a81$var$setFieldValue,
    getFieldValue: $da19d1ee706d4a81$var$getFieldValue,
    setIssue: $da19d1ee706d4a81$var$setIssue,
    mergeIssue: $da19d1ee706d4a81$var$mergeIssue,
    setIssues: $da19d1ee706d4a81$var$setIssues,
    mergeIssues: $da19d1ee706d4a81$export$11aa02e14fdf7753
};
// this is a global store
const $da19d1ee706d4a81$var$store = (0, $a61MH.createStore)({
    name: 'issue-fields',
    initialState: {},
    actions: $da19d1ee706d4a81$var$actions
});
const $da19d1ee706d4a81$var$getFieldValueSelector = (state, { issueKey: issueKey, fieldKey: fieldKey })=>{
    const issueFieldValues = state[issueKey];
    return issueFieldValues && issueFieldValues[fieldKey];
};
const $da19d1ee706d4a81$var$getFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKey: fieldKey })=>(issueKeys || []).map((issueKey)=>$da19d1ee706d4a81$var$getFieldValueSelector(state, {
            fieldKey: fieldKey,
            issueKey: issueKey
        }));
const $da19d1ee706d4a81$var$getMultiFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKeys: fieldKeys })=>(issueKeys || []).reduce((accumulator, issueKey)=>{
        if (!state[issueKey]) return accumulator;
        const fieldValue = fieldKeys.reduce((acc, fieldKey)=>{
            acc[fieldKey] = $da19d1ee706d4a81$var$getFieldValueSelector(state, {
                fieldKey: fieldKey,
                issueKey: issueKey
            });
            return acc;
        }, {});
        accumulator[issueKey] = fieldValue;
        return accumulator;
    }, {});
const $da19d1ee706d4a81$var$getAllFields = (state, issueKey)=>state[issueKey];
const $da19d1ee706d4a81$export$b79fae7fbe3ac392 = (0, $ggKAj.createHook)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getFieldValueSelector
});
const $da19d1ee706d4a81$export$25b73e671fe7a8fa = (0, $ggKAj.createHook)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getAllFields
});
const $da19d1ee706d4a81$export$ac289b84121829df = (0, $ggKAj.createHook)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getFieldValuesForIssuesSelector
});
const $da19d1ee706d4a81$export$915cdeec521b54f7 = (0, $ggKAj.createHook)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getMultiFieldValuesForIssuesSelector
});
const $da19d1ee706d4a81$export$4e5f1f4ed08d155e = (0, $dYfll.createSubscriber)($da19d1ee706d4a81$var$store, {
    selector: $da19d1ee706d4a81$var$getFieldValueSelector
});
const $da19d1ee706d4a81$var$useFieldValueStoreActions = (0, $ggKAj.createHook)($da19d1ee706d4a81$var$store, {
    selector: null
});
const $da19d1ee706d4a81$export$612d9bcb0c9d8976 = ()=>{
    const [, fieldValueStoreActions] = $da19d1ee706d4a81$var$useFieldValueStoreActions();
    const fieldsValuesActions = (0, $eUqFw.useMemo)(()=>{
        const setIssueAction = (issueKey, fields)=>fieldValueStoreActions.setIssue(issueKey, fields);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const setFieldValueAction = (issueKey, fieldKey, value)=>fieldValueStoreActions.setFieldValue(issueKey, fieldKey, value);
        const getFieldValueAction = (issueKey, fieldKey)=>fieldValueStoreActions.getFieldValue(issueKey, fieldKey);
        const mergeIssueAction = (issueKey, fields)=>fieldValueStoreActions.mergeIssue(issueKey, fields);
        const setIssuesAction = (issues)=>fieldValueStoreActions.setIssues(issues);
        const mergeIssuesAction = (issues)=>fieldValueStoreActions.mergeIssues(issues);
        return {
            setIssue: setIssueAction,
            setFieldValue: setFieldValueAction,
            getFieldValue: getFieldValueAction,
            mergeIssue: mergeIssueAction,
            setIssues: setIssuesAction,
            mergeIssues: mergeIssuesAction
        };
    }, [
        fieldValueStoreActions
    ]);
    return [
        null,
        fieldsValuesActions
    ];
};

});

parcelRegister("fecbI", function(module, exports) {

$parcel$export(module.exports, "defaultSaveField", () => $4eca3d717c3df3ee$export$b74e6b7f831f1cb2);
$parcel$export(module.exports, "defaultSaveFieldById", () => $4eca3d717c3df3ee$export$b2c49aae5d84cced);
$parcel$export(module.exports, "defaultAddValuesToField", () => $4eca3d717c3df3ee$export$c46c7284cd9c5d3);
$parcel$export(module.exports, "defaultRemoveValuesFromField", () => $4eca3d717c3df3ee$export$33b78476f5d734b3);

var $lRmyA = parcelRequire("lRmyA");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4eca3d717c3df3ee$var$getFieldUpdate = (fieldKey, value)=>({
        fields: {
            [fieldKey]: value
        }
    });
const $4eca3d717c3df3ee$export$b74e6b7f831f1cb2 = async (issueKey, fieldKey, newValue, baseUrl)=>(0, $lRmyA.performPutRequest)(`${baseUrl}/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify($4eca3d717c3df3ee$var$getFieldUpdate(fieldKey, newValue))
    });
const $4eca3d717c3df3ee$export$b2c49aae5d84cced = async (issueKey, fieldKey, newValue, baseUrl)=>(0, $lRmyA.performPutRequest)(`${baseUrl}/rest/api/3/issue/${issueKey}/?returnIssue=true`, {
        body: JSON.stringify($4eca3d717c3df3ee$var$getFieldUpdate(fieldKey, newValue))
    });
const $4eca3d717c3df3ee$export$c46c7284cd9c5d3 = async (issueKey, fieldKey, valuesToAdd, baseUrl)=>{
    const updateParam = {
        update: {
            [fieldKey]: [
                {
                    operation: 'add',
                    value: valuesToAdd
                }
            ]
        }
    };
    return (0, $lRmyA.performPutRequest)(`${baseUrl}/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify(updateParam)
    });
};
const $4eca3d717c3df3ee$export$33b78476f5d734b3 = async (issueKey, fieldKey, valuesToRemove, baseUrl)=>{
    const updateParam = {
        update: {
            [fieldKey]: [
                {
                    operation: 'remove',
                    value: valuesToRemove
                }
            ]
        }
    };
    return (0, $lRmyA.performPutRequest)(`${baseUrl}/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify(updateParam)
    });
};

});


parcelRegister("8411R", function(module, exports) {

$parcel$export(module.exports, "useIssueFieldConfig", () => $7e02dfdf3441382d$export$5406c21e0d275680);
$parcel$export(module.exports, "useIssueFieldConfigWithoutRefetch", () => $7e02dfdf3441382d$export$217a0e2f2962f4ae);
$parcel$export(module.exports, "useIssueFieldConfigWithoutUimOverrides", () => $7e02dfdf3441382d$export$5f641a998c6dfa06);
$parcel$export(module.exports, "useFieldConfig", () => $7e02dfdf3441382d$export$70da50df1be2dbe1);
$parcel$export(module.exports, "useFieldConfigWithoutRefetch", () => $7e02dfdf3441382d$export$1eed575f8f3334eb);
$parcel$export(module.exports, "useFieldConfigActions", () => $7e02dfdf3441382d$export$28a22fd0dedf31b7);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $lRmyA = parcelRequire("lRmyA");

var $3koWU = parcelRequire("3koWU");

var $6rkLV = parcelRequire("6rkLV");
const $7e02dfdf3441382d$export$9715ac6597e498fd = ()=>`
  query fieldConfigurationQuery($issueKey: String) {
    issue(issueIdOrKey: $issueKey, latestVersion: true, screen: "view") {
      fields {
        key
        schema {
          type
          custom
          customId
          system
          renderer
        }
        autoCompleteUrl
        allowedValues
        operations
        required
        editable
        title
        description
      }
    }
  }`;
const $7e02dfdf3441382d$var$fetchData = async (issueKey)=>{
    const response = await (0, $lRmyA.performPostRequest)('/rest/graphql/1/', {
        body: JSON.stringify({
            query: $7e02dfdf3441382d$export$9715ac6597e498fd(),
            variables: {
                issueKey: issueKey
            }
        })
    });
    if (response && response.data && response.data.issue && response.data.issue.fields) return response.data.issue.fields.reduce(// @ts-expect-error - TS7006 - Parameter 'result' implicitly has an 'any' type. | TS7006 - Parameter 'field' implicitly has an 'any' type.
    (result, field)=>({
            // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
            ...result,
            [field.key]: {
                autoCompleteUrl: field.autoCompleteUrl,
                allowedValues: field.allowedValues,
                isEditable: field.editable,
                isRequired: field.required,
                schema: field.schema,
                title: field.title,
                ...field.description ? {
                    description: field.description
                } : {}
            }
        }), {});
    return null;
};
const $7e02dfdf3441382d$var$requestSet = new Set();
const $7e02dfdf3441382d$var$issueFieldConfigServiceDefaultOptions = {
    skipRefresh: false
};
const $7e02dfdf3441382d$var$useIssueFieldConfigRefetch = (issueKey, value, { skipRefresh: skipRefresh } = $7e02dfdf3441382d$var$issueFieldConfigServiceDefaultOptions)=>{
    const isMounted = (0, $3koWU.useIsMounted)();
    const [, { setIssueConfig: setIssueConfig }] = (0, $6rkLV.useFieldConfigStoreActions)();
    const [loading, setLoading] = (0, $eUqFw.useState)(()=>!skipRefresh && value === undefined && !$7e02dfdf3441382d$var$requestSet.has(issueKey));
    const getData = (0, $eUqFw.useCallback)(async ()=>{
        setLoading(true);
        $7e02dfdf3441382d$var$requestSet.add(issueKey);
        const result = await $7e02dfdf3441382d$var$fetchData(issueKey);
        setIssueConfig(issueKey, result);
        $7e02dfdf3441382d$var$requestSet.delete(issueKey);
        if (isMounted.current) setLoading(false);
    }, [
        isMounted,
        issueKey,
        setIssueConfig
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const shouldGetData = !skipRefresh && !$7e02dfdf3441382d$var$requestSet.has(issueKey) && value === undefined;
        if (shouldGetData) getData();
    }, [
        issueKey,
        value,
        getData,
        skipRefresh
    ]);
    return [
        {
            loading: loading
        }
    ];
};
const $7e02dfdf3441382d$var$useIssueFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey })=>{
    const [value] = (0, $6rkLV.useIssueFieldConfigStore)({
        issueKey: issueKey
    });
    const [overrides] = (0, $6rkLV.useIssueOverridesStore)({
        issueKey: issueKey
    });
    return (0, $eUqFw.useMemo)(()=>{
        if (// When fields configurations are not valid, we don't want overrides
        !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(value) && // We should not override if UI modifications is not available in general or for the field
        overrides !== undefined) {
            // Iteration over the base fields (`value`) prevents creation of partial configs with just UIM overrides.
            const issueWithOverrides = Object.entries(value).reduce((acc, [fieldKey, fieldValues])=>{
                acc[fieldKey] = {
                    ...fieldValues,
                    ...overrides[fieldKey]
                };
                return acc;
            }, {});
            return [
                issueWithOverrides
            ];
        }
        return [
            value
        ];
    }, [
        value,
        overrides
    ]);
};
const $7e02dfdf3441382d$var$useFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey, fieldKey: fieldKey })=>{
    const [value] = (0, $6rkLV.useFieldConfigStore)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const [overrides] = (0, $6rkLV.useFieldOverridesStore)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    if (// When fields configurations are not valid, we don't want overrides
    !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(value) && // We should not override if UI modifications is not available in general or for the field
    overrides !== undefined) return [
        {
            ...value,
            ...overrides
        }
    ];
    return [
        value
    ];
};
const $7e02dfdf3441382d$export$5406c21e0d275680 = (issueKey)=>{
    const [value] = $7e02dfdf3441382d$var$useIssueFieldConfigStoreWithUimOverrides({
        issueKey: issueKey
    });
    const [{ loading: loading }] = $7e02dfdf3441382d$var$useIssueFieldConfigRefetch(issueKey, value);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $7e02dfdf3441382d$export$217a0e2f2962f4ae = (issueKey)=>{
    const [value] = $7e02dfdf3441382d$var$useIssueFieldConfigStoreWithUimOverrides({
        issueKey: issueKey
    });
    return [
        {
            value: value
        }
    ];
};
const $7e02dfdf3441382d$export$5f641a998c6dfa06 = ({ issueKey: issueKey })=>{
    const [value] = (0, $6rkLV.useIssueFieldConfigStore)({
        issueKey: issueKey
    });
    const [{ loading: loading }] = $7e02dfdf3441382d$var$useIssueFieldConfigRefetch(issueKey, value);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $7e02dfdf3441382d$export$70da50df1be2dbe1 = (issueKey, fieldKey, options = $7e02dfdf3441382d$var$issueFieldConfigServiceDefaultOptions)=>{
    const [value] = $7e02dfdf3441382d$var$useFieldConfigStoreWithUimOverrides({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const [{ loading: loading }] = $7e02dfdf3441382d$var$useIssueFieldConfigRefetch(issueKey, value, options);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $7e02dfdf3441382d$export$1eed575f8f3334eb = (issueKey, fieldKey)=>{
    const [value] = $7e02dfdf3441382d$var$useFieldConfigStoreWithUimOverrides({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    return [
        {
            value: value
        }
    ];
};
const $7e02dfdf3441382d$export$28a22fd0dedf31b7 = ()=>{
    const [, setIssueConfigActions] = (0, $6rkLV.useFieldConfigStoreActions)();
    const actions = (0, $eUqFw.useMemo)(()=>{
        const setIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.setIssueConfig(issueKey, issueConfig);
        const setIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.setIssuesConfig(issuesWithConfigurations);
        const mergeIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.mergeIssueConfig(issueKey, issueConfig);
        const mergeIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.mergeIssuesConfig(issuesWithConfigurations);
        const setFieldConfigValue = (issueKey, fieldKey, fieldConfigValue)=>setIssueConfigActions.setFieldConfigValue(issueKey, fieldKey, fieldConfigValue);
        return {
            setIssueConfig: setIssueConfig,
            setIssuesConfig: setIssuesConfig,
            mergeIssueConfig: mergeIssueConfig,
            mergeIssuesConfig: mergeIssuesConfig,
            setFieldConfigValue: setFieldConfigValue
        };
    }, [
        setIssueConfigActions
    ]);
    return [
        null,
        actions
    ];
};

});
parcelRegister("6rkLV", function(module, exports) {

$parcel$export(module.exports, "useIssueFieldConfigStore", () => $2581b610ec8db8fc$export$52f51db4e2b3da57);
$parcel$export(module.exports, "useFieldConfigStore", () => $2581b610ec8db8fc$export$f9beb98c7488fd61);
$parcel$export(module.exports, "useFieldConfigStoreActions", () => $2581b610ec8db8fc$export$314199caf05d245);
$parcel$export(module.exports, "useIssueOverridesStore", () => $2581b610ec8db8fc$export$ff357cf5a96ec0c6);
$parcel$export(module.exports, "useFieldOverridesStore", () => $2581b610ec8db8fc$export$6e41e9c34587d557);
$parcel$export(module.exports, "useFieldOverridesStoreWithLabel", () => $2581b610ec8db8fc$export$e704d739927bd1d6);
$parcel$export(module.exports, "useOverridesStoreActions", () => $2581b610ec8db8fc$export$d94ae842140da412);
$parcel$export(module.exports, "useFieldOptionsOverrides", () => $2581b610ec8db8fc$export$bfea9bb9bad7bc8f);
$parcel$export(module.exports, "useIsFieldBusy", () => $2581b610ec8db8fc$export$982ff1008c2e2780);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $df4Sl = parcelRequire("df4Sl");

var $2vzCR = parcelRequire("2vzCR");

var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $2581b610ec8db8fc$var$setIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState })=>{
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: IssueConfiguration | null; }' is not assignable to parameter of type 'Partial<Partial<Record<string, IssueConfiguration>>>'.
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: issueConfiguration
        });
    };
const $2581b610ec8db8fc$var$mergeIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, getState()[issueKey], issueConfiguration)
        });
    };
const $2581b610ec8db8fc$var$setIssuesConfig = (issuesWithConfigurations)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = issuesWithConfigurations.reduce((acc, issue)=>({
                ...acc,
                ...issue
            }), {});
        setState(newIssues);
    };
const $2581b610ec8db8fc$var$mergeIssuesConfig = (issuesWithConfigurations)=>({ setState: setState, getState: getState })=>{
        if (issuesWithConfigurations.length === 0) return;
        const newIssues = {};
        issuesWithConfigurations.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, getState(), newIssues));
    };
const $2581b610ec8db8fc$var$setFieldConfigValue = (issueKey, fieldKey, fieldConfiguration)=>({ setState: setState, getState: getState })=>{
        const issueKeyFieldConfiguration = getState()[issueKey];
        if (issueKeyFieldConfiguration && issueKeyFieldConfiguration[fieldKey]) setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: {
                    ...getState()[issueKey][fieldKey],
                    ...fieldConfiguration
                }
            }
        });
    };
const $2581b610ec8db8fc$var$actions = {
    setIssueConfig: $2581b610ec8db8fc$var$setIssueConfig,
    setIssuesConfig: $2581b610ec8db8fc$var$setIssuesConfig,
    mergeIssueConfig: $2581b610ec8db8fc$var$mergeIssueConfig,
    mergeIssuesConfig: $2581b610ec8db8fc$var$mergeIssuesConfig,
    setFieldConfigValue: $2581b610ec8db8fc$var$setFieldConfigValue
};
// this is a global state
const $2581b610ec8db8fc$var$store = (0, $a61MH.createStore)({
    name: 'issue-field-config',
    initialState: {},
    actions: $2581b610ec8db8fc$var$actions
});
const $2581b610ec8db8fc$var$getIssueFieldConfig = (0, $df4Sl.createSelector)((state, props)=>state[props.issueKey], (issue)=>issue);
const $2581b610ec8db8fc$export$52f51db4e2b3da57 = (0, $ggKAj.createHook)($2581b610ec8db8fc$var$store, {
    selector: $2581b610ec8db8fc$var$getIssueFieldConfig
});
const $2581b610ec8db8fc$var$getFieldConfig = (0, $df4Sl.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
    // issue being undefined means we haven't fetched it yet
    // issue being null means it doesn't exist.
    // either way we just return that value
    if (issue == null) return issue;
    // if we have the field key, return it. Otherwise return null to show
    // we have done a data fetch of the issue but the field doesn't exist
    return issue[fieldKey] ? issue[fieldKey] : null;
});
const $2581b610ec8db8fc$var$getFieldConfigWithLabel = (0, $df4Sl.createSelector)($2581b610ec8db8fc$var$getFieldConfig, (fieldConfig)=>{
    if (fieldConfig?.title === undefined) return fieldConfig;
    return {
        ...fieldConfig,
        label: fieldConfig.title
    };
});
const $2581b610ec8db8fc$var$getFieldOptionsOverrides = (0, $df4Sl.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
    // issue being undefined means we haven't fetched it yet
    // issue being null means it doesn't exist.
    // either way we just return that value
    if (issue == null) return issue;
    // if we have the field key, return it. Otherwise return null to show
    // we have done a data fetch of the issue but the field doesn't exist
    return issue[fieldKey] ? issue[fieldKey].allowedValuesOverrides : null;
});
const $2581b610ec8db8fc$export$f9beb98c7488fd61 = (0, $ggKAj.createHook)($2581b610ec8db8fc$var$store, {
    selector: $2581b610ec8db8fc$var$getFieldConfig
});
const $2581b610ec8db8fc$export$314199caf05d245 = (0, $ggKAj.createHook)($2581b610ec8db8fc$var$store, {
    selector: null
});
const $2581b610ec8db8fc$var$setOverrides = (issueKey, fieldKey, fieldConfigOverrides)=>({ setState: setState, getState: getState })=>{
        const issueKeyFieldConfigurationWithOverrides = getState()[issueKey] ?? {};
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...issueKeyFieldConfigurationWithOverrides,
                [fieldKey]: {
                    ...issueKeyFieldConfigurationWithOverrides[fieldKey],
                    ...fieldConfigOverrides
                }
            }
        });
    };
const $2581b610ec8db8fc$var$resetOverridesStore = (issueKey)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [issueKey]: undefined
        });
    };
const $2581b610ec8db8fc$var$overridesActions = {
    setFieldConfigOverridesValue: $2581b610ec8db8fc$var$setOverrides,
    resetOverridesStore: $2581b610ec8db8fc$var$resetOverridesStore
};
// Store contains overrides to the field config. It is used by UI modifications to override field config properties by apps.
// UI modifications is a Forge extension point providing apps JS API to override field's properties: name, description, isEditable
// and limit visibility of select fields options.
const $2581b610ec8db8fc$var$overridesStore = (0, $a61MH.createStore)({
    name: 'issue-field-overrides',
    initialState: {},
    actions: $2581b610ec8db8fc$var$overridesActions
});
const $2581b610ec8db8fc$export$ff357cf5a96ec0c6 = (0, $ggKAj.createHook)($2581b610ec8db8fc$var$overridesStore, {
    selector: $2581b610ec8db8fc$var$getIssueFieldConfig
});
const $2581b610ec8db8fc$export$6e41e9c34587d557 = (0, $ggKAj.createHook)($2581b610ec8db8fc$var$overridesStore, {
    selector: $2581b610ec8db8fc$var$getFieldConfig
});
const $2581b610ec8db8fc$export$e704d739927bd1d6 = (0, $ggKAj.createStateHook)($2581b610ec8db8fc$var$overridesStore, {
    selector: $2581b610ec8db8fc$var$getFieldConfigWithLabel
});
const $2581b610ec8db8fc$export$d94ae842140da412 = (0, $ggKAj.createActionsHook)($2581b610ec8db8fc$var$overridesStore);
const $2581b610ec8db8fc$export$bfea9bb9bad7bc8f = (0, $ggKAj.createHook)($2581b610ec8db8fc$var$overridesStore, {
    selector: $2581b610ec8db8fc$var$getFieldOptionsOverrides
});
const $2581b610ec8db8fc$var$getIsFieldBusySelector = (state, args)=>{
    const { fieldId: fieldId, issueKey: issueKey } = args;
    return fieldId !== undefined && !!state[issueKey]?.[fieldId]?.isBusy;
};
const $2581b610ec8db8fc$export$982ff1008c2e2780 = (0, $ggKAj.createStateHook)($2581b610ec8db8fc$var$overridesStore, {
    selector: $2581b610ec8db8fc$var$getIsFieldBusySelector
});

});



parcelRegister("fWeG1", function(module, exports) {

$parcel$export(module.exports, "useSummaryField", () => $6c5f7158a1132680$export$a01f0885983ceff0);

var $illlw = parcelRequire("illlw");

var $1ybV0 = parcelRequire("1ybV0");

var $gGiWF = parcelRequire("gGiWF");
var $8411R = parcelRequire("8411R");

var $lO4Or = parcelRequire("lO4Or");
const $6c5f7158a1132680$export$a01f0885983ceff0 = ({ issueKey: issueKey, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure, onSaveField: onSaveField })=>{
    const [fieldConfig] = (0, $8411R.useFieldConfig)(issueKey, (0, $lO4Or.SUMMARY_TYPE));
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($illlw)))(fieldConfig.value, 'schema.type', 'string');
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $gGiWF.useEditField)({
        fieldKey: (0, $lO4Or.SUMMARY_TYPE),
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        onSubmit: onSubmit,
        onSuccess: onSuccess,
        onFailure: onFailure,
        // delete this condition and keep code inside when removing the isIncrementPlanningEnabled FF
        ...(0, $1ybV0.ff)('com.atlassian.rm.jpo.jpo3cloud.increment-planning-board-m1') && onSaveField && {
            saveField: onSaveField
        }
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});



parcelRegister("fmmnJ", function(module, exports) {

$parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY_IDS", () => $2688cae36ed8d4f6$export$689de18177335e39);
$parcel$export(module.exports, "COMMAND_PALETTE_REGISTRY", () => $2688cae36ed8d4f6$export$96f61eb1261e42c3);
// Documentation for contributing to command palette: go/compal
const $2688cae36ed8d4f6$export$689de18177335e39 = {
    ADD_CHILD_ISSUE: 'ADD_CHILD_ISSUE',
    ADMIN_NAVIGATION: 'ADMIN_NAVIGATION',
    CHECK_NOTIFICATIONS: 'CHECK_NOTIFICATIONS',
    COPY_URL: 'COPY_URL',
    DESCRIPTION: 'DESCRIPTION',
    ISSUE_ACTIONS: 'ISSUE_ACTIONS',
    ISSUE_FIELD_ASSIGN: 'ISSUE_FIELD_ASSIGN',
    ISSUE_HEADER_ACTIONS: 'ISSUE_HEADER_ACTIONS',
    ISSUE_SUB_HEADER_ACTIONS: 'ISSUE_SUB_HEADER_ACTIONS',
    LOG_WORK: 'LOG_WORK',
    NAVIGATION_COMMANDS: 'NAVIGATION_COMMANDS',
    PARENT: 'PARENT',
    PROJECT_NAVIGATION: 'PROJECT_NAVIGATION',
    QUICK_ADD: 'QUICK_ADD',
    QUICK_SEARCH: 'QUICK_SEARCH',
    SHORTCUTS: 'SHORTCUTS',
    STATUS: 'STATUS',
    STORY_POINTS: 'STORY_POINTS',
    TEST: 'TEST',
    THEME_MODE: 'THEME_MODE'
};
// Alphabetical order please
// Update the teamName enum to include your team in the following:
// https://data-portal.internal.atlassian.com/analytics/registry/49626?tabIndex=Attributes
// https://data-portal.internal.atlassian.com/analytics/registry/49627?tabIndex=Attributes
const $2688cae36ed8d4f6$var$teams = {
    Deliveroo: 'Deliveroo'
};
const $2688cae36ed8d4f6$export$96f61eb1261e42c3 = {
    ADMIN_NAVIGATION: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ADMIN_NAVIGATION,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    CHECK_NOTIFICATIONS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.CHECK_NOTIFICATIONS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    COPY_URL: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.COPY_URL,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    DESCRIPTION: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.DESCRIPTION,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    ISSUE_ACTIONS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ISSUE_ACTIONS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    ISSUE_FIELD_ASSIGN: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ISSUE_FIELD_ASSIGN,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    ISSUE_HEADER_ACTIONS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ISSUE_HEADER_ACTIONS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    ISSUE_SUB_HEADER_ACTIONS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.ISSUE_SUB_HEADER_ACTIONS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    LOG_WORK: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.LOG_WORK,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    NAVIGATION_COMMANDS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.NAVIGATION_COMMANDS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    PARENT: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.PARENT,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    PROJECT_NAVIGATION: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.PROJECT_NAVIGATION,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    QUICK_ADD: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.QUICK_ADD,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    QUICK_SEARCH: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.QUICK_SEARCH,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    SHORTCUTS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.SHORTCUTS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    STATUS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.STATUS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    STORY_POINTS: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.STORY_POINTS,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    },
    THEME_MODE: {
        registryId: $2688cae36ed8d4f6$export$689de18177335e39.THEME_MODE,
        teamName: $2688cae36ed8d4f6$var$teams.Deliveroo
    }
};

});

parcelRegister("dK5FP", function(module, exports) {

$parcel$export(module.exports, "useSubscribeCommands", () => $882c857bed4a7f74$export$c13b008422be19c7);

var $7Xm2s = parcelRequire("7Xm2s");
const $882c857bed4a7f74$export$c13b008422be19c7 = (0, $7Xm2s.useSubscribeCommandsWithRegistry);

});
parcelRegister("7Xm2s", function(module, exports) {

$parcel$export(module.exports, "useSubscribeCommandsWithRegistry", () => $ed5a0599e1840fb5$export$880fc01e31710b27);

var $eUqFw = parcelRequire("eUqFw");

var $gCtL7 = parcelRequire("gCtL7");
function $ed5a0599e1840fb5$export$880fc01e31710b27() {
    const { addCommands: addCommands, removeCommands: removeCommands, updateActiveRegistry: updateActiveRegistry, removeFromActiveRegistry: removeFromActiveRegistry } = (0, $gCtL7.useActionsCommandPalette)();
    const subscribe = (0, $eUqFw.useCallback)((registrationId, commands)=>{
        updateActiveRegistry(registrationId, commands);
        addCommands(commands);
        return ()=>{
            removeCommands(commands);
            removeFromActiveRegistry(registrationId, commands);
        };
    }, [
        addCommands,
        removeCommands,
        removeFromActiveRegistry,
        updateActiveRegistry
    ]);
    return subscribe;
}

});


parcelRegister("3Tszs", function(module, exports) {

$parcel$export(module.exports, "useIssueAri", () => $81b7cb64c6be6c5d$export$f56776f1b409b56d);

var $hJ992 = parcelRequire("hJ992");

var $huI7r = parcelRequire("huI7r");

var $dWLk9 = parcelRequire("dWLk9");
const $81b7cb64c6be6c5d$export$f56776f1b409b56d = ()=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const issueId = (0, $hJ992.useIssueId)();
    return (0, $huI7r.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'issue',
        resourceId: issueId ?? ''
    });
};

});

const $c7e109b9d85e3c97$export$5252a6a6e4e4a774 = 'issue-field-status.ui.status-view.command-palette.issue-status';

parcelRegister("igSdB", function(module, exports) {

$parcel$export(module.exports, "messages", () => $aaccf3a6ecd0d922$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $aaccf3a6ecd0d922$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    changeStatus: {
        "id": "issue-field-status.status-view.command-palette.change-status",
        "defaultMessage": "Change status"
    },
    // TODO delete on compal-issue-actions-follow-up-improvements_y49xu cleanup
    editStatus: {
        "id": "issue-field-status.status-view.command-palette.edit-status",
        "defaultMessage": "Edit status"
    },
    searchTransition: {
        "id": "issue-field-status.status-view.command-palette.search-transition",
        "defaultMessage": "Search a status or transition"
    },
    currentStatus: {
        "id": "issue-field-status.status-view.command-palette.current-status",
        "defaultMessage": "Current status"
    },
    fallbackNoResults: {
        "id": "issue-field-status.status-view.command-palette.fallback-no-results",
        "defaultMessage": "No results match your search."
    },
    fallbackError: {
        "id": "issue-field-status.status-view.command-palette.fallback-error",
        "defaultMessage": "We're having trouble loading this data. Wait a few moments, then try again."
    }
});

});

parcelRegister("aaWu9", function(module, exports) {

$parcel$export(module.exports, "useSaveStatusField", () => $4cf7bb6b63008adb$export$c6a3d42f97df89c9);

var $eUqFw = parcelRequire("eUqFw");

var $gCtL7 = parcelRequire("gCtL7");

var $guiFP = parcelRequire("guiFP");

var $lRmyA = parcelRequire("lRmyA");

var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kmr29 = parcelRequire("kmr29");

var $1a3la = parcelRequire("1a3la");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");


var $ebWv6 = parcelRequire("ebWv6");
const $4cf7bb6b63008adb$export$c6a3d42f97df89c9 = (issueKey, issueId)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ commandPaletteSessionId: commandPaletteSessionId }] = (0, $gCtL7.useCommandPaletteSessionId)();
    const { showFlag: showFlag } = (0, $k8Qyf.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [, { setFieldValue: setFieldValue }] = (0, $kmr29.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $ebc098a76317be78$export$4420b7468f889692)
    });
    const onSaveSuccessfully = (0, $eUqFw.useCallback)((transition, callback)=>{
        const action = 'commandPalette';
        const actionSubject = 'changeStatus';
        const eventActionAndSubject = `${actionSubject} ${action}`;
        const event = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject
        });
        setFieldValue(issueKey, (0, $ebc098a76317be78$export$4420b7468f889692), transition.to);
        callback?.();
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $jMP2a.fireTrackAnalytics)(event, eventActionAndSubject, {
            transitionId: transition.id,
            commandPaletteSessionId: commandPaletteSessionId
        });
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'statusField transitioned', 'statusField');
        showFlag({
            type: 'success',
            title: formatMessage((0, $ebWv6.messages).successFlagMessage)
        });
    }, [
        commandPaletteSessionId,
        createAnalyticsEvent,
        formatMessage,
        issueKey,
        setFieldValue,
        showFlag
    ]);
    const onFailSave = (0, $eUqFw.useCallback)((error)=>{
        (0, $guiFP.default)({
            error: error,
            meta: {
                id: 'commandPaletteIssueStatus',
                packageName: 'jiraIssueFieldStatus',
                // eslint-disable-next-line jira/js/team-name-enforcer-for-error-analytics
                teamName: 'deliveroo'
            }
        });
        showFlag({
            type: 'error',
            title: formatMessage((0, $ebWv6.messages).errorFlagTitle),
            description: formatMessage((0, $ebWv6.messages).errorFlagDescription)
        });
    }, [
        formatMessage,
        showFlag
    ]);
    const openIssueTransitionModal = (0, $1a3la.useOpenIssueTransitionModal)();
    const saveStatusField = (0, $eUqFw.useCallback)(async (transition, callback)=>{
        try {
            if (transition.hasScreen) {
                const handleDialogSuccess = ()=>onSaveSuccessfully(transition, callback);
                const handleDialogError = (err)=>onFailSave(err instanceof Error ? err : new Error('Something went wrong trying to update the status with screen using the command palette'));
                const transitionId = transition.id;
                openIssueTransitionModal({
                    payload: {
                        issueId: issueId,
                        issueKey: issueKey,
                        transitionId: transitionId
                    },
                    triggerPointKey: 'issue-transition-command-palette-status-field-transition',
                    onDialogSuccess: handleDialogSuccess,
                    onDialogError: handleDialogError
                });
            } else {
                await (0, $lRmyA.performPostRequest)(`/rest/api/3/issue/${issueKey}/transitions`, {
                    body: JSON.stringify({
                        transition: transition
                    })
                });
                onSaveSuccessfully(transition, callback);
            }
        } catch (err) {
            const error = err instanceof Error ? err : new Error('Something went wrong trying to update the status using the command palette');
            onFailSave(error);
        }
    }, [
        issueId,
        issueKey,
        onFailSave,
        onSaveSuccessfully,
        openIssueTransitionModal
    ]);
    return {
        saveStatusField: saveStatusField
    };
};

});
const $ebc098a76317be78$export$e18419056f3d184a = 'assignee';
const $ebc098a76317be78$export$45cafdfd629c3ca1 = 'reporter';
const $ebc098a76317be78$export$d5bc879e3b748593 = 'description';
const $ebc098a76317be78$export$a68dbc90211df1a8 = 'fixVersions';
const $ebc098a76317be78$export$93605f2a09aa8d26 = 'labels';
const $ebc098a76317be78$export$4420b7468f889692 = 'status';
const $ebc098a76317be78$export$e7cf1830fe735d1f = 'summary';
const $ebc098a76317be78$export$5fbd3b15555b9ef2 = 'timeoriginalestimate';
const $ebc098a76317be78$export$a5fc282ab2bf9b89 = 'issuelinks';
const $ebc098a76317be78$export$b52547457d714bc0 = 'epic-issues';
const $ebc098a76317be78$export$3cca6e37a5823d5a = 'children-issues';
const $ebc098a76317be78$export$98a935eb30de54ab = 'components';

parcelRegister("ebWv6", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f7580a2b91879afa$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $f7580a2b91879afa$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    successFlagMessage: {
        "id": "issue-field-status.status-view.command-palette.use-save-status-field.success-flag-message",
        "defaultMessage": "Status updated"
    },
    errorFlagTitle: {
        "id": "issue-field-status.status-view.command-palette.use-save-status-field.error-flag-title",
        "defaultMessage": "We couldn\u2019t update the status"
    },
    errorFlagDescription: {
        "id": "issue-field-status.status-view.command-palette.use-save-status-field.error-flag-description",
        "defaultMessage": "Wait a few moments, then try again."
    }
});

});


parcelRegister("hiXJ2", function(module, exports) {

$parcel$export(module.exports, "getTransitionKeywords", () => $374b7ef282a2f0ed$export$258538e0d3d46460);
const $374b7ef282a2f0ed$export$258538e0d3d46460 = (transition)=>{
    if (transition.name !== transition.to.name) return `${transition.name} ${transition.to.name}`;
    return transition.name;
};

});


parcelRegister("f3qzK", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1612899557cfea6$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $b1612899557cfea6$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noPermission: {
        "id": "issue-field-status.status-view.no-permission",
        "defaultMessage": "You don't have permission to transition this issue"
    },
    cannotLoadTransitions: {
        "id": "issue-field-status.status-view.cannot-load-transitions",
        "defaultMessage": "We couldn't load the statuses and transitions"
    },
    changeStatus: {
        "id": "issue-field-status.status-view.change-status",
        "defaultMessage": "Change status"
    },
    transitionTo: {
        "id": "issue-field-status.status-view.transition-to",
        "defaultMessage": "Transition to {statusName}"
    }
});

});

parcelRegister("5x3wA", function(module, exports) {

$parcel$export(module.exports, "LoadingSpinner", () => $b8a1cf0cb2a35870$export$b08b517936747730);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4Bees = parcelRequire("4Bees");
const $b8a1cf0cb2a35870$export$b08b517936747730 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b8a1cf0cb2a35870$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4Bees.default), null));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b8a1cf0cb2a35870$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4u2gc _y3gn1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("fr49r", function(module, exports) {

$parcel$export(module.exports, "StatusButton", () => $c8103b4d0a327bcd$export$517b7ecb2da8e76d);

var $eUqFw = parcelRequire("eUqFw");

var $86Ndv = parcelRequire("86Ndv");

var $8cU5f = parcelRequire("8cU5f");

var $fAI2G = parcelRequire("fAI2G");

var $3xvgo = parcelRequire("3xvgo");
const $c8103b4d0a327bcd$var$getButton = (categoryId)=>{
    switch(categoryId){
        case 2:
            return 0, $3xvgo.ToDoButton;
        case 3:
            return 0, $3xvgo.DoneButton;
        case 4:
            return 0, $3xvgo.InProgressButton;
        default:
            return 0, $3xvgo.DefaultButton;
    }
};
const $c8103b4d0a327bcd$export$517b7ecb2da8e76d = (props)=>{
    const { ariaLabel: ariaLabel, isEditable: isEditable, isOpen: isOpen, status: status, targetRef: targetRef, statusButtonRef: statusButtonRef, shouldFitContainer: shouldFitContainer = true } = props;
    const Button = $c8103b4d0a327bcd$var$getButton(status.statusCategory.id);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: targetRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        position: "top",
        content: status.name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fAI2G.default), {
        status: status
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Button, {
        id: "issue.fields.status-view.status-button",
        ref: statusButtonRef,
        "aria-label": ariaLabel,
        "aria-expanded": isOpen,
        isDisabled: !isEditable,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($86Ndv))), {
            label: ""
        }),
        testId: "issue-field-status.ui.status-view.status-button.status-button",
        shouldFitContainer: shouldFitContainer
    }, status.name))));
};

});
parcelRegister("fAI2G", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9e72f26e10429da$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $kwce8 = parcelRequire("kwce8");
// TODO consolidate status id's
const $e9e72f26e10429da$var$DONE_ID = 3;
class $e9e72f26e10429da$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    componentDidUpdate(prevProps) {
        if (prevProps.status.statusCategory.id !== this.props.status.statusCategory.id) this.setState({
            shouldShow: this.props.status.statusCategory.id === $e9e72f26e10429da$var$DONE_ID
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e9e72f26e10429da$var$PulseContainer, {
            shouldShow: this.state.shouldShow
        }, this.props.children);
    }
    constructor(...args){
        super(...args);
        this.state = {
            shouldShow: false
        };
    }
}
const $e9e72f26e10429da$var$PulseAnimation = /*#__PURE__*/ (0, $kwce8.keyframes)({
    to: {
        boxShadow: '0 0 0 10px rgba(0, 0, 0, 0)'
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $e9e72f26e10429da$var$PulseContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldShow: shouldShow, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1qbqnkm": (0, $9t7rW.default)($e9e72f26e10429da$var$PulseAnimation)
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _1bsb1osq _2rko1l7b _16qs13jn",
            __cmplp.shouldShow ? "_y44v1upg" : "_y44vglyw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("3xvgo", function(module, exports) {

$parcel$export(module.exports, "DefaultButton", () => $9c0535c8db535606$export$b7c3a2f69225ecf);
$parcel$export(module.exports, "ToDoButton", () => $9c0535c8db535606$export$97f73b7c6e2328e5);
$parcel$export(module.exports, "InProgressButton", () => $9c0535c8db535606$export$8c94aeefd701630d);
$parcel$export(module.exports, "DoneButton", () => $9c0535c8db535606$export$e6559310cd173125);
/* styled.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");
const $9c0535c8db535606$export$b7c3a2f69225ecf = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_12r2ni7l",
            !__cmplp.isSelected && "_193g10pm _11a410pm _dntbyv3a _cp4gyv3a _5xmd8ldq _11smyv3a",
            __cmplp.className
        ])
    });
});
const $9c0535c8db535606$export$97f73b7c6e2328e5 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_12r2ni7l",
            !__cmplp.isSelected && "_193guicy _11a4uicy _dntb16l4 _cp4g16l4 _5xmd1psz _11sm16l4",
            __cmplp.className
        ])
    });
});
const $9c0535c8db535606$export$8c94aeefd701630d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_12r2ni7l",
            !__cmplp.isSelected && "_193gsxa6 _11a4sxa6 _dntb1gfe _cp4g1gfe _5xmdi36s _11sm1gfe",
            __cmplp.className
        ])
    });
});
const $9c0535c8db535606$export$e6559310cd173125 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eUqFw.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_12r2ni7l",
            !__cmplp.isSelected && "_193g147y _11a4147y _dntb1gfe _cp4g1gfe _5xmdihng _11sm1gfe",
            __cmplp.className
        ])
    });
});

});


parcelRegister("dSoqn", function(module, exports) {

$parcel$export(module.exports, "Transition", () => $ae69ed3744ea99b9$export$be58926105124dd4);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $aUqTb = parcelRequire("aUqTb");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $5jCbl = parcelRequire("5jCbl");

var $dRdDe = parcelRequire("dRdDe");
const $ae69ed3744ea99b9$export$be58926105124dd4 = ({ hasLabel: hasLabel, transition: transition, addTransitionArrowSpacing: addTransitionArrowSpacing })=>{
    if (transition.isDisabled === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ae69ed3744ea99b9$var$DisabledTransition, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRdDe.TransitionWithoutLabel), {
        transition: transition,
        isDisabled: true
    }), transition.unavailableReasonText != null && transition.unavailableReasonText !== '' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        content: transition.unavailableReasonText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ae69ed3744ea99b9$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aUqTb))), {
        label: "",
        primaryColor: `var(--ds-text-disabled, ${(0, $PdmhA).N200})`
    }))));
    return hasLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5jCbl.TransitionWithLabel), {
        transition: transition,
        addTransitionArrowSpacing: addTransitionArrowSpacing
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dRdDe.TransitionWithoutLabel), {
        transition: transition
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ae69ed3744ea99b9$var$DisabledTransition = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1bah1yb4",
            __cmplp.className
        ])
    });
});
const $ae69ed3744ea99b9$var$IconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3io7ao _1reoewfl _18m9ewfl _19pkr5cr",
            __cmplp.className
        ])
    });
});
const $ae69ed3744ea99b9$export$7ed12d2a5241e393 = {
    IconWrapper: $ae69ed3744ea99b9$var$IconWrapper
};

});
parcelRegister("5jCbl", function(module, exports) {

$parcel$export(module.exports, "TransitionWithLabel", () => $31534da1e06e6efb$export$20d2722b94f01359);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $cSu9v = parcelRequire("cSu9v");

var $4ksts = parcelRequire("4ksts");

var $2GJ4g = parcelRequire("2GJ4g");

var $Pk7Yy = parcelRequire("Pk7Yy");
const $31534da1e06e6efb$var$getLabel = (transition, intl)=>{
    if (transition.isGlobal) {
        if (transition.name !== transition.to.name) return transition.name;
        return intl.formatMessage((0, $Pk7Yy.default).globalTransition);
    }
    return transition.name;
};
const $31534da1e06e6efb$export$20d2722b94f01359 = (props)=>{
    const intl = (0, $4ksts.useIntlV2)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($31534da1e06e6efb$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($31534da1e06e6efb$export$147422f7450ccfac, null, $31534da1e06e6efb$var$getLabel(props.transition, intl)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($31534da1e06e6efb$export$da4545fe0ca096cf, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($31534da1e06e6efb$var$VerticalCenter, {
        addTransitionArrowSpacing: props.addTransitionArrowSpacing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cSu9v))), {
        label: "",
        size: "small"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2GJ4g.StatusLozenge), {
        status: props.transition.to,
        isDisabled: props.isDisabled
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $31534da1e06e6efb$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $31534da1e06e6efb$export$147422f7450ccfac = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
});
const $31534da1e06e6efb$export$da4545fe0ca096cf = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1o9zidpf _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $31534da1e06e6efb$var$VerticalCenter = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { addTransitionArrowSpacing: addTransitionArrowSpacing, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _4cvr1h6o",
            __cmplp.addTransitionArrowSpacing ? "_18s8s8vo" : "_19pk1kw7 _2hwx1kw7 _otyr1kw7 _18u01kw7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("Pk7Yy", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca438c42f301b049$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $ca438c42f301b049$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    globalTransition: {
        "id": "issue-field-status.status-view.transition.with-label.global-transition",
        "defaultMessage": "Transition to"
    }
});

});


parcelRegister("dRdDe", function(module, exports) {

$parcel$export(module.exports, "TransitionWithoutLabel", () => $3bc4861a1c7d5985$export$4cf2c7e5a408120e);

var $eUqFw = parcelRequire("eUqFw");

var $2GJ4g = parcelRequire("2GJ4g");
const $3bc4861a1c7d5985$export$4cf2c7e5a408120e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2GJ4g.StatusLozenge), {
        status: props.transition.to,
        isDisabled: props.isDisabled
    });

});



parcelRegister("gM8m3", function(module, exports) {

$parcel$export(module.exports, "InfoIcon", () => $2afc30b03af64fd5$export$2957fc44b3d2481);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bbaTG = parcelRequire("bbaTG");

var $aUqTb = parcelRequire("aUqTb");

var $3MV1G = parcelRequire("3MV1G");

var $lcnyw = parcelRequire("lcnyw");

var $3x4sL = parcelRequire("3x4sL");

var $5JgJ2 = parcelRequire("5JgJ2");

var $gd0Sp = parcelRequire("gd0Sp");

var $1PD1y = parcelRequire("1PD1y");
const $2afc30b03af64fd5$export$2957fc44b3d2481 = ()=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const { isSiteAdmin: isSiteAdmin } = (0, $gd0Sp.useTenantContext)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const toggleDialog = (0, $eUqFw.useCallback)(()=>{
        setIsOpen((oldState)=>!oldState);
    }, [
        setIsOpen
    ]);
    const onCloseDialog = (0, $eUqFw.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    const content = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2afc30b03af64fd5$var$DialogContent, {
            "data-testId": "issue-create.ui.modal.create-form.status-field.tooltip"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, isSiteAdmin ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3x4sL.FormattedI18nMessage), {
            componentsMapping: {
                bold: $2afc30b03af64fd5$var$BoldFont
            },
            message: formatMessage((0, $1PD1y.default).changeboardingAdmin, {
                boldStart: '{boldStart}',
                boldEnd: '{boldEnd}'
            })
        }) : formatMessage((0, $1PD1y.default).changeboarding)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2afc30b03af64fd5$var$ChangeboardingWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3MV1G.default), {
        isOpen: isOpen,
        onClose: onCloseDialog,
        placement: "right",
        zIndex: (0, $lcnyw.layers).modal(),
        shouldRenderToParent: true,
        content: content,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bbaTG.default), {
                "data-ds--inline-message--button": true,
                appearance: "subtle-link",
                onClick: toggleDialog,
                spacing: "none",
                testId: "issue-create.ui.modal.create-form.status-field.changeboarding.info-icon",
                ...triggerProps
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2afc30b03af64fd5$var$IconWrapper, {
                isOpen: isOpen
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aUqTb))), {
                label: "info",
                size: "small"
            })))
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2afc30b03af64fd5$var$BoldFont = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48pbfng",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2afc30b03af64fd5$var$DialogContent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48p1nn1 _1yt41pyq _p12f1mjv _syaz1fxt _1wybdlk8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2afc30b03af64fd5$var$IconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isOpen: isOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_x5v9sv3s _1b3i658d _30l31kum",
            __cmplp.isOpen ? "_syaz1kum" : "_syazkr0v",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2afc30b03af64fd5$var$ChangeboardingWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1hbsidpf _1u71idpf _y2qtidpf _fl8bidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1PD1y", function(module, exports) {

$parcel$export(module.exports, "default", () => $055e8fa42a029110$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $055e8fa42a029110$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    changeboarding: {
        "id": "issue-create.modal.create-form.status-field.changeboarding.changeboarding",
        "defaultMessage": "You can now choose the status of your issue while creating it. For example, select In progress if you\u2019ve started the work. You\u2019ll only see statuses you have permission to use."
    },
    changeboardingAdmin: {
        "id": "issue-create.modal.create-form.status-field.changeboarding.changeboarding-admin",
        "defaultMessage": "Choose the status of your issue while creating it. For example, select In progress if you\u2019ve started the work. You can manage this field in {boldStart}System settings{boldEnd}."
    }
});

});


parcelRegister("27rq3", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c8c8247b622a058$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $7c8c8247b622a058$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    statusFieldLabel: {
        "id": "issue-create.modal.create-form.status-field.status-field-label",
        "defaultMessage": "Status"
    },
    unavailableStatusText: {
        "id": "issue-create.modal.create-form.status-field.unavailable-status-text",
        "defaultMessage": "Your workflow doesn't allow issues to be created in this status"
    },
    helperText: {
        "id": "issue-create.modal.create-form.status-field.helper-text",
        "defaultMessage": "This is the issue's initial status upon creation"
    },
    noEnabledTransitionsMessage: {
        "id": "issue-create.modal.create-form.status-field.no-enabled-transitions-message",
        "defaultMessage": "There are no statuses available for you to use"
    },
    warningIconLabel: {
        "id": "issue-create.modal.create-form.status-field.warning-icon-label",
        "defaultMessage": "Warning"
    },
    warningMessage: {
        "id": "issue-create.modal.create-form.status-field.warning-message",
        "defaultMessage": "This field isn\u2019t working right now. You can still create your issue and update the status later."
    }
});

});


parcelRegister("O5CDc", function(module, exports) {

$parcel$export(module.exports, "default", () => $e74865ecc8dadc4b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $7jPhn = parcelRequire("7jPhn");
var $4LhB6 = parcelRequire("4LhB6");

var $5wCDk = parcelRequire("5wCDk");

var $7ZZxN = parcelRequire("7ZZxN");

var $c9TLT = parcelRequire("c9TLT");

var $0cdA8 = parcelRequire("0cdA8");

var $eTZsp = parcelRequire("eTZsp");

var $5JgJ2 = parcelRequire("5JgJ2");

var $dWh83 = parcelRequire("dWh83");
var $6LDal = parcelRequire("6LDal");parcelRequire("fryuC");
var $aBj0i = parcelRequire("aBj0i");


var $icPhQ = parcelRequire("icPhQ");
var $5i7Lk = parcelRequire("5i7Lk");

var $fswni = parcelRequire("fswni");

var $bKilX = parcelRequire("bKilX");

var $gR74I = parcelRequire("gR74I");

var $lO4Or = parcelRequire("lO4Or");

var $hzcvF = parcelRequire("hzcvF");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $bKI0B = parcelRequire("bKI0B");

var $418AI = parcelRequire("418AI");
var $lVewy = parcelRequire("lVewy");

var $j2Myn = parcelRequire("j2Myn");
var $aqi5n = parcelRequire("aqi5n");


var $iQjnk = parcelRequire("iQjnk");

var $38WQ0 = parcelRequire("38WQ0");

var $997tk = parcelRequire("997tk");

var $9QNYX = parcelRequire("9QNYX");

var $4h3KB = parcelRequire("4h3KB");
const $e74865ecc8dadc4b$var$typePickerMargin = (0, $c9TLT.gridSize) * 2.25;
const $e74865ecc8dadc4b$var$TypePicker = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { onChange: onChange, issueTypes: issueTypes, requestTypes: requestTypes, value: selectedRequestOrIssueType, projectType: projectType, isDisabled: isDisabled = false, isMini: isMini } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const previousSelectedRequestOrIssueType = (0, $hzcvF.usePrevious)(selectedRequestOrIssueType);
    (0, $eUqFw.useEffect)(()=>{
        // if the default selection has request type of "none"
        // then we will change it to select the first matching request type
        if (// we have request type data
        requestTypes && // previously data was loading
        previousSelectedRequestOrIssueType === null && // an issue type is selected
        // i.e. this is the default selection
        // and it has a "none" request type
        selectedRequestOrIssueType && selectedRequestOrIssueType.type === (0, $8b8bfa076f313cc4$export$ebb48b08205007c5)) {
            const firstMatchingRequestType = (0, $4h3KB.getFirstMatchingRequestType)({
                issueType: selectedRequestOrIssueType,
                allRequestTypes: requestTypes
            });
            if (firstMatchingRequestType) {
                onChange(firstMatchingRequestType);
                (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), 'gicRequestTypeSelect forceDefaultNotNone');
            }
        }
    }, [
        createAnalyticsEvent,
        onChange,
        previousSelectedRequestOrIssueType,
        requestTypes,
        selectedRequestOrIssueType
    ]);
    const getIssueTypeHelpText = (0, $eUqFw.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5i7Lk.FieldMessage), {
            fieldHelpTextUrl: (0, $dc585212eb99a264$export$4435027827ccff2d),
            fieldName: "Issue Type",
            onLinkClickEvent: (0, $j2Myn.openInNewTabLinkClickEventHandler),
            isMini: isMini
        }), [
        isMini
    ]);
    const [{ meta: { submitFieldwiseErrors: submitFieldwiseErrors } }] = (0, $fswni.useFormContext)();
    (0, $eUqFw.useEffect)(()=>{
        if (submitFieldwiseErrors?.issuetype) (0, $aqi5n.scrollToElement)((0, $dc585212eb99a264$export$f1623876ce3d4391));
    }, [
        submitFieldwiseErrors?.issuetype
    ]);
    const fields = (0, $eUqFw.useMemo)(()=>{
        let fieldsNode;
        if (projectType === (0, $7ZZxN.SERVICE_DESK_PROJECT) && requestTypes !== undefined) {
            // get the options for the 2 select fields
            const { issueTypeOptions: issueTypeOptions, requestTypeOptions: requestTypeOptions } = (0, $4h3KB.getRequestAndIssueTypeOptionsGroup)(issueTypes, requestTypes, formatMessage); // extract the selected option for the 2 select fields from the aggregated value
            const { issueType: selectedIssueType, requestType: selectedRequestType } = (0, $4h3KB.getIssueTypeAndRequestType)({
                allIssueTypes: issueTypeOptions,
                requestOrIssueType: selectedRequestOrIssueType,
                formatMessage: formatMessage
            }); // fire UI events when the selects are opened
            const onIssueTypeSelectOpen = ()=>(0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'gicIssueTypeSelect open');
            const onRequestTypeSelectOpen = ()=>(0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'gicRequestTypeSelect open'); // on issue type selection we want to pre-select a matching request type
            const onIssueTypeChange = (issueType)=>{
                if (issueType.value === selectedIssueType?.value) return;
                const firstMatchingRequestType = (0, $4h3KB.getFirstMatchingRequestType)({
                    issueType: issueType,
                    allRequestTypes: requestTypes
                });
                onChange(firstMatchingRequestType || issueType);
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'gicIssueTypeSelect selected');
            }; // on request type selection we want to select the chosen request type,
            // or if 'none' is selected, we select the issue type
            const onRequestTypeChange = (requestTypeOrNone)=>{
                if (requestTypeOrNone.value === selectedRequestType?.value) return;
                let isNoneSelected = true;
                if (requestTypeOrNone.type === (0, $8b8bfa076f313cc4$export$92ab80c1dc9baf44)) {
                    onChange(requestTypeOrNone);
                    isNoneSelected = false;
                } else if (selectedIssueType !== null) onChange(selectedIssueType);
                (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'gicRequestTypeSelect selected', {
                    isNoneSelected: isNoneSelected
                });
            };
            const requestTypeHelpText = selectedRequestType && selectedRequestType.type === (0, $8b8bfa076f313cc4$export$92ab80c1dc9baf44) ? selectedRequestType.helpText : '';
            fieldsNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
                width: isMini ? '100%' : undefined,
                marginTop: $e74865ecc8dadc4b$var$typePickerMargin
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
                name: "issue-type-picker",
                label: formatMessage((0, $iQjnk.default).issueTypeFieldLabel),
                isRequired: true
            }, ({ fieldProps: { id: id, isRequired: isRequired } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
                    inputId: id,
                    required: isRequired,
                    options: issueTypeOptions,
                    value: selectedIssueType,
                    onChange: onIssueTypeChange,
                    onMenuOpen: onIssueTypeSelectOpen,
                    isClearable: false,
                    formatOptionLabel: (0, $bKilX.formatOptionLabel),
                    placeholder: "",
                    id: (0, $dc585212eb99a264$export$f1623876ce3d4391),
                    isDisabled: isDisabled,
                    onKeyDown: (0, $aqi5n.preventEscKeyPropagationKeyPressHandler)
                }), getIssueTypeHelpText(), submitFieldwiseErrors?.issuetype && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, submitFieldwiseErrors.issuetype)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
                width: "100%",
                marginTop: $e74865ecc8dadc4b$var$typePickerMargin
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e74865ecc8dadc4b$var$RequestTypeFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
                name: "request-type-picker",
                label: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e74865ecc8dadc4b$var$RequestTypeFieldLabelWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, formatMessage((0, $iQjnk.default).requestTypeFieldLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e74865ecc8dadc4b$var$RequiredIndicator, null, "*")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $38WQ0.WhatsThis), null))
            }, ({ fieldProps: { id: id } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9QNYX.RequestTypeSelect), {
                    inputId: id,
                    options: requestTypeOptions,
                    value: selectedRequestType,
                    onChange: onRequestTypeChange,
                    onMenuOpen: onRequestTypeSelectOpen,
                    id: "issue-create.ui.modal.create-form.type-picker.request-type-select"
                }))), requestTypeHelpText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $997tk.RequestTypeHelpText), {
                helpText: requestTypeHelpText
            })));
        } else {
            // there is no request type data, just show issue type select
            const label = (0, $4h3KB.getFieldLabel)(Boolean(requestTypes?.length), formatMessage);
            const onIssueTypeChange = (selectedIssueType)=>{
                if (selectedIssueType.value === selectedRequestOrIssueType?.value) return;
                const analyticsEvent = createAnalyticsEvent({
                    action: 'selected',
                    actionSubject: 'option'
                });
                (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'issueType');
                onChange(selectedIssueType);
            };
            const Component = (componentProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
                    id: "withFormField" // eslint-disable-next-line jira/js/package-name-enforcer-for-error-boundary
                    ,
                    packageName: "jiraIssueCreateModal",
                    sendToPrivacyUnsafeSplunk: true
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4LhB6.default), {
                    name: "type-picker",
                    label: label,
                    isRequired: true,
                    elementAfterLabel: componentProps.areUiModificationsBusy ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6LDal.FieldBusyIndicator), {
                        fieldId: (0, $lO4Or.ISSUE_TYPE)
                    }) : undefined
                }, ({ fieldProps: fieldProps })=>{
                    const renderFieldContent = ({ id: id, isRequired: isRequired // eslint-disable-next-line @typescript-eslint/no-explicit-any
                     })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
                            inputId: id,
                            required: isRequired,
                            options: componentProps.allowedValues,
                            onChange: onIssueTypeChange,
                            value: selectedRequestOrIssueType,
                            isClearable: false,
                            formatOptionLabel: (0, $bKilX.formatOptionLabel),
                            placeholder: "",
                            id: (0, $dc585212eb99a264$export$f1623876ce3d4391),
                            isDisabled: !!(isDisabled || componentProps.isReadOnly),
                            onKeyDown: (0, $aqi5n.preventEscKeyPropagationKeyPressHandler)
                        }), getIssueTypeHelpText(), submitFieldwiseErrors?.issuetype && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7jPhn.ErrorMessage), null, submitFieldwiseErrors.issuetype));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dWh83.ErrorBoundaryBypassProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dWh83.ErrorBoundaryBypassOutput), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
                        id: "issueAdjustmentsFieldValueDecorator" // eslint-disable-next-line jira/js/package-name-enforcer-for-error-boundary
                        ,
                        packageName: "jiraIssueCreateModal",
                        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aBj0i.IssueAdjustmentsErrorHandler), null), renderFieldContent(fieldProps)),
                        sendToPrivacyUnsafeSplunk: true,
                        attributes: (error)=>({
                                errorType: (0, $eTZsp.getErrorType)(error),
                                viewType: (0, $bKI0B.GIC_VIEW_TYPE),
                                fieldId: (0, $lO4Or.ISSUE_TYPE),
                                fieldType: (0, $lO4Or.ISSUE_TYPE)
                            })
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lVewy.FieldValueDecoratorAsync), {
                        fieldId: (0, $lO4Or.ISSUE_TYPE),
                        fieldType: (0, $lO4Or.ISSUE_TYPE),
                        fieldProps: {
                            ...fieldProps,
                            value: selectedRequestOrIssueType
                        }
                    }, (interceptedFieldProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dWh83.ErrorBoundaryBypassInput), null, renderFieldContent(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        interceptedFieldProps)))));
                }));
            const typePickerComponentProps = {
                fieldId: (0, $lO4Or.ISSUE_TYPE),
                fieldName: label,
                fieldType: (0, $lO4Or.ISSUE_TYPE),
                isRequired: true,
                gqlType: '',
                allowedValues: issueTypes
            };
            const setFieldValue = (_, value)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                onIssueTypeChange(value);
            const getFormState = ()=>({
                    values: {
                        [typePickerComponentProps.fieldId]: selectedRequestOrIssueType
                    }
                });
            fieldsNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gR74I.FormApiProvider), {
                setFieldValue: setFieldValue,
                getFormState: getFormState
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $icPhQ.FieldContainer), {
                width: isMini ? '100%' : undefined,
                marginTop: $e74865ecc8dadc4b$var$typePickerMargin
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
                id: "globalIssueCreateIssueAdjustmentsAdapter" // eslint-disable-next-line jira/js/package-name-enforcer-for-error-boundary
                ,
                packageName: "issueCreateModal",
                fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aBj0i.IssueAdjustmentsErrorHandler), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Component, typePickerComponentProps)),
                sendToPrivacyUnsafeSplunk: true,
                attributes: (error)=>({
                        errorType: (0, $eTZsp.getErrorType)(error),
                        viewType: (0, $bKI0B.GIC_VIEW_TYPE),
                        fieldId: typePickerComponentProps.fieldId,
                        fieldType: typePickerComponentProps.fieldType
                    })
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $418AI.FieldDecoratorAsync), {
                Component: Component,
                componentProps: typePickerComponentProps
            }))));
        }
        return fieldsNode;
    }, [
        createAnalyticsEvent,
        formatMessage,
        issueTypes,
        onChange,
        projectType,
        requestTypes,
        selectedRequestOrIssueType,
        getIssueTypeHelpText,
        submitFieldwiseErrors?.issuetype,
        isDisabled,
        isMini
    ]);
    return fields;
};
var $e74865ecc8dadc4b$export$2e2bcd8739ae039 // eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $e74865ecc8dadc4b$var$TypePicker;
const $e74865ecc8dadc4b$var$RequestTypeFieldWrapper = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "cz2iu2-0"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '> div': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> label': {
            width: '100%'
        }
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e74865ecc8dadc4b$var$RequiredIndicator = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1ick _19bvv77o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e74865ecc8dadc4b$var$RequestTypeFieldLabelWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1q9y _1bah1yb4 _1bsb1osq _4t3i1osq _19pk12x7",
            __cmplp.className
        ])
    });
});

});
const $dc585212eb99a264$export$4435027827ccff2d = '/secure/ShowConstantsHelp.jspa?decorator=popup#IssueTypes';
const $dc585212eb99a264$export$f1623876ce3d4391 = 'issue-create.ui.modal.create-form.type-picker.issue-type-select';

parcelRegister("iQjnk", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9d4c3a4275e5cf9$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f9d4c3a4275e5cf9$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    issueTypeFieldLabel: {
        "id": "issue-create.modal.create-form.type-picker.issue-type-field-label",
        "defaultMessage": "Issue type"
    },
    requestTypeFieldLabel: {
        "id": "issue-create.modal.create-form.type-picker.request-type-field-label",
        "defaultMessage": "Request type"
    },
    typeFieldLabel: {
        "id": "issue-create.modal.create-form.type-picker.type-field-label",
        "defaultMessage": "Type"
    },
    issueTypeGroupLabel: {
        "id": "issue-create.modal.create-form.type-picker.issue-type-group-label",
        "defaultMessage": "Issue types"
    },
    requestTypeGroupLabel: {
        "id": "issue-create.modal.create-form.type-picker.request-type-group-label",
        "defaultMessage": "Request types"
    },
    unassignedRequestTypeGroupLabel: {
        "id": "issue-create.modal.create-form.type-picker.unassigned-request-type-group-label",
        "defaultMessage": "Unassigned"
    },
    serviceRequestGroupLabel: {
        "id": "issue-create.modal.create-form.type-picker.service-request-group-label",
        "defaultMessage": "Service requests"
    },
    incidentRequestGroupLabel: {
        "id": "issue-create.modal.create-form.type-picker.incident-request-group-label",
        "defaultMessage": "Incidents"
    },
    postIncidentReviewRequestGroupLabel: {
        "id": "issue-create.modal.create-form.type-picker.post-incident-review-request-group-label",
        "defaultMessage": "Post-incident reviews"
    },
    developerEscalationRequestGroupLabel: {
        "id": "issue-create.modal.create-form.type-picker.developer-escalation-request-group-label",
        "defaultMessage": "Developer escalations"
    },
    problemRequestGroupLabel: {
        "id": "issue-create.modal.create-form.type-picker.problem-request-group-label",
        "defaultMessage": "Problems"
    },
    changeRequestGroupLabel: {
        "id": "issue-create.modal.create-form.type-picker.change-request-group-label",
        "defaultMessage": "Changes"
    },
    noRequestTypeLabel: {
        "id": "issue-create.modal.create-form.type-picker.no-request-type-label",
        "defaultMessage": "No request type"
    },
    issueTypeHelpText: {
        "id": "issue-create.modal.create-form.type-picker.issue-type-help-text",
        "defaultMessage": "Learn more"
    }
});

});

parcelRegister("38WQ0", function(module, exports) {

$parcel$export(module.exports, "WhatsThis", () => $efec860d9ad8e381$export$9fb74911aca1203);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $29yDk = parcelRequire("29yDk");

var $8uD7Y = parcelRequire("8uD7Y");
var $4ksts = parcelRequire("4ksts");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");


var $axAeR = parcelRequire("axAeR");
const $efec860d9ad8e381$export$9fb74911aca1203 = ()=>{
    const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)();
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const toggleDialog = (0, $eUqFw.useCallback)(()=>{
        if (!isOpen) (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'gicRequestTypeHelpDialogButton clicked');
        setIsOpen(!isOpen);
    }, [
        createAnalyticsEvent,
        isOpen
    ]);
    const dialogContent = (0, $eUqFw.useMemo)(()=>{
        const onClickLearnMoreLink = ()=>(0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'gicRequestTypeLearnMoreLink clicked');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($efec860d9ad8e381$var$DialogContainer, {
            "data-testid": "issue-create.ui.modal.create-form.type-picker.request-type-changeboarding.dialog-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($efec860d9ad8e381$var$DialogParagraph, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
            ...(0, $axAeR.default).whatsThisDialogBody,
            values: {
                learnMoreAboutRequestTypesLink: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                    href: (0, $de86b5b2b54e76b0$export$2e27f6d0b2889d14),
                    target: "_blank",
                    onClick: onClickLearnMoreLink,
                    onAuxClick: onClickLearnMoreLink
                }, formatMessage((0, $axAeR.default).learnMoreAboutRequestTypesLink))
            }
        })));
    }, [
        createAnalyticsEvent,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $29yDk.default), {
        content: dialogContent,
        isOpen: isOpen,
        placement: "bottom-end",
        onClose: toggleDialog
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($efec860d9ad8e381$var$WhatsThisButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle-link",
        spacing: "none",
        onClick: toggleDialog
    }, formatMessage((0, $axAeR.default).whatsThisDialogTrigger))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $efec860d9ad8e381$var$WhatsThisButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _2lx2vrvc _1wyb1skh",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $efec860d9ad8e381$var$DialogContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1178",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $efec860d9ad8e381$var$DialogParagraph = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48p4jg8",
            __cmplp.className
        ])
    });
});

});
const $de86b5b2b54e76b0$export$2e27f6d0b2889d14 = 'https://support.atlassian.com/jira-service-management-cloud/docs/what-are-request-types/';

parcelRegister("axAeR", function(module, exports) {

$parcel$export(module.exports, "default", () => $e665f9a0f4db6e44$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $e665f9a0f4db6e44$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    whatsThisDialogTrigger: {
        "id": "issue-create.modal.create-form.type-picker.request-type-changeboarding.whats-this-dialog-trigger",
        "defaultMessage": "What\u2019s this?"
    },
    whatsThisDialogBody: {
        "id": "issue-create.modal.create-form.type-picker.request-type-changeboarding.whats-this-dialog-body",
        "defaultMessage": "Request types allow requests to show in the Help Center, gain additional features in the issue view, and access work categories. {learnMoreAboutRequestTypesLink}."
    },
    learnMoreAboutRequestTypesLink: {
        "id": "issue-create.modal.create-form.type-picker.request-type-changeboarding.learn-more-about-request-types-link",
        "defaultMessage": "Learn more about request types"
    }
});

});


parcelRegister("997tk", function(module, exports) {

$parcel$export(module.exports, "RequestTypeHelpText", () => $08dbbd065b0ee1f1$export$f97ad894319e2545);

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $7u4fN = parcelRequire("7u4fN");

var $PdmhA = parcelRequire("PdmhA");

var $4lTFP = parcelRequire("4lTFP");

var $5JgJ2 = parcelRequire("5JgJ2");

var $5vWUc = parcelRequire("5vWUc");

var $4mYSt = parcelRequire("4mYSt");
const $08dbbd065b0ee1f1$export$6167fae6d6ed332c = (element)=>// https://stackoverflow.com/a/52650163
    // check if the element is being line clamped
    element ? element.scrollHeight !== element.offsetHeight : false;
const $08dbbd065b0ee1f1$export$f97ad894319e2545 = ({ helpText: helpText })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    // this property sets whether or not the show more button will be visible
    const [shouldCollapse, setShouldCollapse] = (0, $eUqFw.useState)(false);
    // this property sets whether the text is expanded or collapsed
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const toggleIsOpen = ()=>setIsOpen(!isOpen);
    const helpTextRef = (0, $eUqFw.useRef)(undefined);
    const [windowWidth, windowHeight] = (0, $5vWUc.useWindowSize)();
    (0, $eUqFw.useEffect)(()=>{
        // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'HTMLElement | undefined'.
        const newShouldCollapse = $08dbbd065b0ee1f1$export$6167fae6d6ed332c(helpTextRef.current);
        setShouldCollapse(newShouldCollapse);
        if (!newShouldCollapse) setIsOpen(false);
    }, [
        shouldCollapse,
        helpText,
        windowWidth,
        windowHeight
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($08dbbd065b0ee1f1$var$Collapser, {
        isOpen: isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($08dbbd065b0ee1f1$var$HelpText, {
        isOpen: isOpen,
        innerRef: helpTextRef
    }, helpText)), shouldCollapse && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($08dbbd065b0ee1f1$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        spacing: "none",
        appearance: "subtle-link",
        onClick: toggleIsOpen
    }, formatMessage(isOpen ? (0, $4mYSt.default).showLess : (0, $4mYSt.default).showMore))));
};
/*
    The webkit styles enable multi-line text-overflow ellipsis.
    See https://stackoverflow.com/a/13924997
    It's a bit of a hack but it works in most browsers -
    worst case, it will fall back to not having the ellipsis.
*/ // eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $08dbbd065b0ee1f1$var$HelpText = /*#__PURE__*/ (0, $kwce8.default).p.withConfig({
    componentId: "jy4tmi-0"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text-subtle, ${(0, $PdmhA).N200})`,
    fontSize: '12px',
    lineHeight: '16px'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ isOpen: isOpen })=>!isOpen ? `
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    ` : '');
// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $08dbbd065b0ee1f1$var$Collapser = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "jy4tmi-1"
})((props)=>({
        marginTop: "var(--ds-space-100, 8px)",
        overflow: 'hidden',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxHeight: props.isOpen ? 'fit-content' : '32px'
    }));
// FIXME: h100() causes a type error because the typing on `fontWeight` keys is too strict
// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $08dbbd065b0ee1f1$var$ButtonWrapper = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "jy4tmi-2"
})`${(0, $4lTFP.h100)()};line-height:16px;font-size:12px;padding:0;margin:0;margin-top:${"var(--ds-space-075, 6px)"};button{padding:0;margin:0;border:0;}`;

});
parcelRegister("4mYSt", function(module, exports) {

$parcel$export(module.exports, "default", () => $8dc190fd70f162d4$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8dc190fd70f162d4$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    showMore: {
        "id": "issue-create.modal.create-form.type-picker.request-type-help-text.show-more",
        "defaultMessage": "Show more\u2026"
    },
    showLess: {
        "id": "issue-create.modal.create-form.type-picker.request-type-help-text.show-less",
        "defaultMessage": "Show less\u2026"
    }
});

});


parcelRegister("9QNYX", function(module, exports) {

$parcel$export(module.exports, "RequestTypeSelect", () => $149443c9ff276ea9$export$3b6e21307c2d4f74);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $5wCDk = parcelRequire("5wCDk");

var $PdmhA = parcelRequire("PdmhA");
var $4lTFP = parcelRequire("4lTFP");

var $85wS8 = parcelRequire("85wS8");

var $5JgJ2 = parcelRequire("5JgJ2");

var $aqi5n = parcelRequire("aqi5n");

var $axbOX = parcelRequire("axbOX");
const $149443c9ff276ea9$var$selectStyles = {
    // @ts-expect-error - TS7006 - Parameter 'supplied' implicitly has an 'any' type.
    control: (supplied)=>({
            ...supplied,
            paddingTop: "var(--ds-space-100, 8px)",
            paddingBottom: "var(--ds-space-100, 8px)"
        }),
    // @ts-expect-error - TS7006 - Parameter 'supplied' implicitly has an 'any' type.
    valueContainer: (supplied)=>({
            ...supplied,
            padding: '0',
            paddingLeft: "var(--ds-space-150, 12px)",
            height: '42px' // specify a static height for the container, because the text container is absolutely positioned
        }),
    // @ts-expect-error - TS7006 - Parameter 'supplied' implicitly has an 'any' type.
    menuList: (supplied)=>({
            ...supplied,
            padding: 0
        }),
    // @ts-expect-error - TS7006 - Parameter 'supplied' implicitly has an 'any' type.
    group: (supplied)=>({
            ...supplied,
            padding: 0
        }),
    // @ts-expect-error - TS7006 - Parameter 'supplied' implicitly has an 'any' type.
    groupHeading: (supplied)=>({
            ...supplied,
            margin: 0,
            paddingTop: "var(--ds-space-200, 16px)",
            paddingBottom: "var(--ds-space-100, 8px)",
            font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            color: `var(--ds-text, ${(0, $PdmhA).N600})`,
            textTransform: 'none'
        }),
    // @ts-expect-error - TS7006 - Parameter 'supplied' implicitly has an 'any' type.
    singleValue: (supplied)=>({
            ...supplied,
            top: 0,
            left: "var(--ds-space-150, 12px)",
            textOverflow: 'ellipsis',
            transform: 'none',
            // default is -50% y
            whiteSpace: 'nowrap',
            width: '100%',
            paddingRight: "var(--ds-space-400, 32px)"
        }),
    // @ts-expect-error - TS7006 - Parameter 'supplied' implicitly has an 'any' type.
    option: (supplied)=>({
            ...supplied,
            cursor: 'pointer',
            paddingLeft: "var(--ds-space-200, 16px)",
            paddingTop: "var(--ds-space-100, 8px)",
            paddingBottom: "var(--ds-space-100, 8px)",
            margin: 0
        })
};
const $149443c9ff276ea9$export$3b6e21307c2d4f74 = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const formatOptionLabel = (0, $eUqFw.useCallback)((option, { context: context })=>{
        const description = option.type === 'NONE' ? formatMessage((0, $axbOX.default).noRequestTypeOptionDescription) : option.description;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($149443c9ff276ea9$var$FlexRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($149443c9ff276ea9$var$IconWrapper, null, option.type === 'NONE' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $85wS8.default), {
            label: ""
        }) : Boolean(option.iconUrl) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($149443c9ff276ea9$var$Icon, {
            src: option.iconUrl,
            alt: option.label
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($149443c9ff276ea9$var$FlexColumn, {
            isMenu: context === 'menu'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($149443c9ff276ea9$var$Label, {
            "data-test-id": "issue-create.ui.modal.create-form.type-picker.request-type-select.label",
            isMenu: context === 'menu'
        }, option.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($149443c9ff276ea9$var$Description, {
            "data-test-id": "issue-create.ui.modal.create-form.type-picker.request-type-select.description",
            isMenu: context === 'menu'
        }, description)));
    }, [
        formatMessage
    ]);
    return(// @ts-expect-error - TS2322 - Type '{ isClearable: false; formatOptionLabel: (option: NoneOption | RequestType, { context }: FormatOptionLabelMeta<NoneOption | RequestType>) => Element; ... 10 more ...;
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5wCDk.default), {
        ...props,
        isClearable: false,
        formatOptionLabel: formatOptionLabel,
        hideSelectedOptions: false,
        placeholder: "",
        maxMenuHeight: 256,
        styles: $149443c9ff276ea9$var$selectStyles,
        onKeyDown: (0, $aqi5n.preventEscKeyPropagationKeyPressHandler)
    }));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $149443c9ff276ea9$var$FlexRow = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1y6m",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $149443c9ff276ea9$var$FlexColumn = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "sc-1l270fi-0"
})((props)=>({
        flexDirection: 'column',
        display: 'flex',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: `calc(100% - ${props.isMenu ? 40 : 14}px)`
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $149443c9ff276ea9$var$IconWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxpxbi _1bsb1tcg _4t3i1tcg",
            __cmplp.className
        ])
    });
}); // FIXME: h100() causes a type error because the typing on `fontWeight` keys is too strict
const $149443c9ff276ea9$var$Label = /*#__PURE__*/ (0, $kwce8.default).p.withConfig({
    componentId: "sc-1l270fi-1"
})`${(0, $4lTFP).h400()};height:18px;line-height:16px;width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $149443c9ff276ea9$var$Icon = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1tcg _1bsb1tcg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $149443c9ff276ea9$var$Description = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3igktf _vwz4gktf _syaz1n3s _19pkidpf _ca0q1b66 _k48p4jg8 _o5721q9c _1reo15vq _18m915vq _1bto1l2s _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("85wS8", function(module, exports) {

$parcel$export(module.exports, "default", () => $b04a33110967303b$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $b04a33110967303b$var$PresenceUnavailableSVG = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line jira/react/no-classname-attribute, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        "fill-opacity": "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12ZM6 12C6 10.4087 6.63214 8.88258 7.75736 7.75736C8.88258 6.63214 10.4087 6 12 6C13.5913 6 15.1174 6.63214 16.2426 7.75736C17.3679 8.88258 18 10.4087 18 12C18 13.5913 17.3679 15.1174 16.2426 16.2426C15.1174 17.3679 13.5913 18 12 18C10.4087 18 8.88258 17.3679 7.75736 16.2426C6.63214 15.1174 6 13.5913 6 12Z",
        fill: "#42526E"
    }));
const $b04a33110967303b$var$PresenceUnavailableIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        ...props,
        glyph: $b04a33110967303b$var$PresenceUnavailableSVG
    });
var $b04a33110967303b$export$2e2bcd8739ae039 = $b04a33110967303b$var$PresenceUnavailableIcon;

});

parcelRegister("axbOX", function(module, exports) {

$parcel$export(module.exports, "default", () => $49ce151594680042$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $49ce151594680042$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    noRequestTypeOptionDescription: {
        "id": "issue-create.modal.create-form.type-picker.request-type-select.no-request-type-option-description",
        "defaultMessage": "Issues can\u2019t be shared with customers, and may not work as expected."
    }
});

});


parcelRegister("4h3KB", function(module, exports) {

$parcel$export(module.exports, "getFieldLabel", () => $ccd14cb7a84b9045$export$da6819d9a95804cf);
$parcel$export(module.exports, "getRequestAndIssueTypeOptionsGroup", () => $ccd14cb7a84b9045$export$37e41f5d9a3e8f14);
$parcel$export(module.exports, "getIssueTypeAndRequestType", () => $ccd14cb7a84b9045$export$2f84784d8e92f69c);
$parcel$export(module.exports, "getFirstMatchingRequestType", () => $ccd14cb7a84b9045$export$f0a2ba1b9d3328b);

var $fcWBJ = parcelRequire("fcWBJ");


var $iQjnk = parcelRequire("iQjnk");
const $ccd14cb7a84b9045$export$da6819d9a95804cf = (hasRequestTypes, formatMessage)=>hasRequestTypes ? formatMessage((0, $iQjnk.default).typeFieldLabel) : formatMessage((0, $iQjnk.default).issueTypeFieldLabel);
const $ccd14cb7a84b9045$export$8e45723e9c86b276 = (practice, formatMessage)=>{
    if (practice === (0, $8b8bfa076f313cc4$export$b92ccb6dc3cdb548)) return formatMessage((0, $iQjnk.default).changeRequestGroupLabel);
    if (practice === (0, $8b8bfa076f313cc4$export$48c144830383423)) return formatMessage((0, $iQjnk.default).incidentRequestGroupLabel);
    if (practice === (0, $8b8bfa076f313cc4$export$1ea6ead7bcee4494)) return formatMessage((0, $iQjnk.default).problemRequestGroupLabel);
    if (practice === (0, $8b8bfa076f313cc4$export$3d1cda9bd50505e8)) return formatMessage((0, $iQjnk.default).serviceRequestGroupLabel);
    if (practice === (0, $8b8bfa076f313cc4$export$a4a741b969f6509c)) return formatMessage((0, $iQjnk.default).postIncidentReviewRequestGroupLabel);
    if (practice === (0, $8b8bfa076f313cc4$export$81e62964cc725098)) return formatMessage((0, $iQjnk.default).developerEscalationRequestGroupLabel);
    if (practice === (0, $8b8bfa076f313cc4$export$c835df30ebbd529d)) return formatMessage((0, $iQjnk.default).unassignedRequestTypeGroupLabel);
    return formatMessage((0, $iQjnk.default).requestTypeGroupLabel);
};
const $ccd14cb7a84b9045$var$reorderRequestTypeGroups = (requestTypeGroupKeys)=>{
    // This is the order we have them for queues, request types and feature page
    const allPractices = [
        (0, $8b8bfa076f313cc4$export$3d1cda9bd50505e8),
        (0, $8b8bfa076f313cc4$export$48c144830383423),
        (0, $8b8bfa076f313cc4$export$1ea6ead7bcee4494),
        (0, $8b8bfa076f313cc4$export$b92ccb6dc3cdb548),
        (0, $8b8bfa076f313cc4$export$a4a741b969f6509c),
        (0, $8b8bfa076f313cc4$export$81e62964cc725098),
        (0, $8b8bfa076f313cc4$export$c835df30ebbd529d),
        (0, $8b8bfa076f313cc4$export$92ab80c1dc9baf44)
    ];
    const groupKeySet = new Set(requestTypeGroupKeys);
    return allPractices.filter((practice)=>groupKeySet.has(practice));
};
const $ccd14cb7a84b9045$var$createNoneOption = (formatMessage)=>({
        label: formatMessage((0, $iQjnk.default).noRequestTypeLabel),
        value: 'none',
        type: 'NONE'
    });
const $ccd14cb7a84b9045$export$37e41f5d9a3e8f14 = (issueTypes, requestTypes, formatMessage)=>{
    // @ts-expect-error(PARTIAL_RECORD) TS2322 | TS2322 - Type 'Dictionary<RequestType[]>' is not assignable to type 'Record<RequestTypePractices, RequestType[]>'. | Type 'Dictionary<RequestType[]>' is not assignable to type 'Record<RequestTypePractices, RequestType[]>'.
    const groupedRequestTypes = (0, (/*@__PURE__*/$parcel$interopDefault($fcWBJ)))(requestTypes, (o)=>o.practice);
    // @ts-expect-error - TS2345 - Argument of type 'string[]' is not assignable to parameter of type 'RequestTypePractices[]'.
    const groupKeys = $ccd14cb7a84b9045$var$reorderRequestTypeGroups(Object.keys(groupedRequestTypes));
    const requestTypesOptions = groupKeys.map((practice)=>({
            label: $ccd14cb7a84b9045$export$8e45723e9c86b276(practice, formatMessage),
            options: groupedRequestTypes[practice]
        }));
    return {
        issueTypeOptions: issueTypes,
        requestTypeOptions: [
            $ccd14cb7a84b9045$var$createNoneOption(formatMessage),
            ...requestTypesOptions
        ]
    };
};
const $ccd14cb7a84b9045$export$2f84784d8e92f69c = ({ requestOrIssueType: requestOrIssueType, allIssueTypes: allIssueTypes, formatMessage: formatMessage })=>{
    const noneOption = $ccd14cb7a84b9045$var$createNoneOption(formatMessage);
    let issueType = null;
    let requestType = null;
    if (requestOrIssueType !== null) switch(requestOrIssueType.type){
        case 0, $8b8bfa076f313cc4$export$ebb48b08205007c5:
            issueType = requestOrIssueType;
            requestType = noneOption;
            break;
        case 0, $8b8bfa076f313cc4$export$92ab80c1dc9baf44:
            issueType = allIssueTypes.find(({ value: value })=>value === requestOrIssueType.issueTypeId) || null;
            requestType = requestOrIssueType;
            break;
        default:
    }
    return {
        issueType: issueType,
        requestType: requestType
    };
};
const $ccd14cb7a84b9045$export$f0a2ba1b9d3328b = ({ issueType: issueType, allRequestTypes: allRequestTypes })=>allRequestTypes.find(({ issueTypeId: issueTypeId })=>issueTypeId === issueType.value);

});


parcelRegister("1rYBS", function(module, exports) {

$parcel$export(module.exports, "transformValidationErrors", () => $db6fd5c8baa76d90$export$8726164bd96601cc);
$parcel$export(module.exports, "getQueryVariables", () => $db6fd5c8baa76d90$export$8c3d6ce16880e58e);
$parcel$export(module.exports, "getContextFieldsForSubmit", () => $db6fd5c8baa76d90$export$2975feebfec7def8);
$parcel$export(module.exports, "getParentIdForSubmit", () => $db6fd5c8baa76d90$export$b208d5bc9f5e315f);
$parcel$export(module.exports, "resetFormFieldsForCreateAnother", () => $db6fd5c8baa76d90$export$d8f1f19cbcdc5ccf);
$parcel$export(module.exports, "getUserInputForRetention", () => $db6fd5c8baa76d90$export$ffde08d8190479bd);
$parcel$export(module.exports, "transformInlineErrorMessage", () => $db6fd5c8baa76d90$export$cc6683ccc73b073);
$parcel$export(module.exports, "getIssueCreateProjectForMount", () => $db6fd5c8baa76d90$export$ce9d0b4bb614f329);
$parcel$export(module.exports, "canSetContextForSubmit", () => $db6fd5c8baa76d90$export$fbc6cb29c318fa3a);
$parcel$export(module.exports, "shouldShowStatusField", () => $db6fd5c8baa76d90$export$3a332740e4aa9440);
$parcel$export(module.exports, "shouldShowLinkedAlertsField", () => $db6fd5c8baa76d90$export$d89be2967c4b3fcf);
$parcel$export(module.exports, "isWatchersUsed", () => $db6fd5c8baa76d90$export$8625e37c02bbfb71);
$parcel$export(module.exports, "getAnalyticsIssueType", () => $db6fd5c8baa76d90$export$385bf01e57223a7c);
$parcel$export(module.exports, "isDisplayConditionCFCausingError", () => $db6fd5c8baa76d90$export$cbe00e1e05a1451f);

var $8blac = parcelRequire("8blac");

var $7ZZxN = parcelRequire("7ZZxN");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");


var $lO4Or = parcelRequire("lO4Or");

var $lG4nv = parcelRequire("lG4nv");

var $4cArj = parcelRequire("4cArj");
const $db6fd5c8baa76d90$export$8726164bd96601cc = (errors)=>{
    let validationErrors;
    if (errors.length) {
        validationErrors = {};
        errors.forEach(({ field: field, error: error })=>{
            validationErrors = {
                ...validationErrors,
                [field]: error
            };
        });
    }
    return validationErrors;
};
const $db6fd5c8baa76d90$export$8c3d6ce16880e58e = (selectedProject, selectedIssueType, defaultValues)=>{
    const projectId = selectedProject?.value || null;
    let issueTypeId = null;
    let requestTypeKey = null;
    if (selectedIssueType) {
        issueTypeId = selectedIssueType.type === (0, $8b8bfa076f313cc4$export$92ab80c1dc9baf44) ? selectedIssueType.issueTypeId : selectedIssueType.value;
        requestTypeKey = // @ts-expect-error - TS2339 - Property 'requestTypeKey' does not exist on type 'IssueType | RequestType'.
        selectedIssueType.requestTypeKey !== undefined ? selectedIssueType.requestTypeKey : null;
    }
    return {
        project: projectId ? {
            projectId: projectId
        } : null,
        issueType: issueTypeId !== null ? {
            issueTypeId: issueTypeId
        } : null,
        requestType: requestTypeKey !== null ? {
            key: requestTypeKey
        } : null,
        defaultValues: defaultValues || null
    };
};
const $db6fd5c8baa76d90$export$2975feebfec7def8 = (selectedProject, selectedIssueType, requestTypeId)=>{
    const projectId = selectedProject.value;
    let issueTypeId;
    let requestTypeKey;
    if (selectedIssueType.type === (0, $8b8bfa076f313cc4$export$92ab80c1dc9baf44)) {
        issueTypeId = selectedIssueType.issueTypeId;
        requestTypeKey = selectedIssueType.requestTypeKey;
    } else issueTypeId = selectedIssueType.value;
    const requestTypePayload = requestTypeId !== undefined ? {
        [requestTypeId]: requestTypeKey
    } : {};
    return {
        project: {
            id: projectId
        },
        issuetype: {
            id: issueTypeId
        },
        ...requestTypePayload
    };
};
const $db6fd5c8baa76d90$export$b208d5bc9f5e315f = (parentId)=>parentId && parentId.parentId ? {
        parent: {
            id: parentId.parentId
        }
    } : {};
const $db6fd5c8baa76d90$export$d8f1f19cbcdc5ccf = (formData, fieldConfig, resetForm)=>{
    const resetFormData = {
        ...formData
    };
    (0, $4cArj.NON_RETAINED_FIELDS_CREATE_ANOTHER).forEach((field)=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(formData[field.fieldId])) resetFormData[field.fieldId] = field.getClearedDefaultValue(fieldConfig);
    });
    const resetObject = {
        ...resetFormData,
        [(0, $lO4Or.SUMMARY_TYPE)]: ''
    };
    resetForm.current(resetObject);
    return resetObject;
};
const $db6fd5c8baa76d90$export$77b34f1a71743196 = (fieldConfig, fieldValues)=>{
    const dirtyCheckboxFieldIds = {};
    Object.keys(fieldValues).forEach((fieldId)=>{
        const fieldData = fieldConfig[fieldId];
        const { gqlType: gqlType } = fieldData || {};
        if ((0, $4cArj.FIELDS_TO_RETAIN_FIELD_VALUE).includes(gqlType) && !(0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(fieldValues[fieldId])) dirtyCheckboxFieldIds[fieldId] = true;
    });
    return dirtyCheckboxFieldIds;
};
const $db6fd5c8baa76d90$export$ffde08d8190479bd = ({ formState: formState, fieldConfig: fieldConfig, dirtyFieldsCurrentSession: dirtyFieldsCurrentSession, retainedFieldsData: retainedFieldsData, initialDefaultValues: initialDefaultValues = {}, selectedClassification: selectedClassification })=>{
    let classificationRetainValue = {};
    if ((0, $1ybV0.ff)('support-data-classification-field-in-gic_x6lda') && selectedClassification?.id) classificationRetainValue = {
        dataClassification: {
            dataClassificationId: selectedClassification.id
        }
    };
    if (!formState) return initialDefaultValues;
    if (!retainedFieldsData || !retainedFieldsData.current) return initialDefaultValues;
    const { dirtyFields: dirtyFields, values: values } = formState;
    /*
        This is a hacky solution for solving field value retention issue for Checkboxes field.

        As fieldIds of the checkboxes fields are not present in the dirtyFileds (getting from formState) even if field values are updated,
        we're fetching all the fieldIds of the Checkboxes field, which has some field values, from formState values and storing those in a variable.
        After that we are appending that data (dirtyCheckboxFields) in dirtyFieldsCurrentSession.
    */ const dirtyCheckboxFieldIds = $db6fd5c8baa76d90$export$77b34f1a71743196(fieldConfig, values);
    // eslint-disable-next-line no-param-reassign
    dirtyFieldsCurrentSession.current = {
        ...dirtyFieldsCurrentSession.current,
        ...dirtyFields,
        ...dirtyCheckboxFieldIds
    };
    Object.keys(dirtyFieldsCurrentSession.current).forEach((fieldId)=>{
        const fieldData = fieldConfig[fieldId];
        // below condition fixes a issue where uncaught exception was throwing when fieldId was not part of fieldConfig
        if (fieldData) {
            const retainUserInputTransform = // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly JiraAffectedServicesField: { readonly Component: AbstractComponent<ReturnComponentProps<AffectedServicesFieldConfig>, any>; readonly defaultValueKey: "selectedAffectedServices"; readonly submitTransform: (options: AffectedServiceOption[]) => ServiceEntity[]; readonly retainUserInputTransform: (selectedAff...'.
            (0, $lG4nv.getGqlFieldMap)()[fieldData.gqlType]?.retainUserInputTransform || null;
            const userInput = values[fieldId];
            if (retainUserInputTransform && userInput) // consumers that want additional checks on data before deciding whether it should be retained can return null in case they don't want to retain it
            try {
                const userInputToBeRetained = retainUserInputTransform(userInput, fieldId);
                if (userInputToBeRetained) {
                    const arrWithoutStaleValues = retainedFieldsData.current.filter((itr)=>{
                        if (itr && itr.fieldId && itr.fieldId === fieldId) return false; // removing stale value
                        return true;
                    });
                    // eslint-disable-next-line no-param-reassign
                    retainedFieldsData.current = [
                        ...arrWithoutStaleValues,
                        userInputToBeRetained
                    ];
                }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $guiFP.default)({
                    meta: {
                        id: 'getUserInputForRetention',
                        packageName: 'jiraIssueCreate',
                        teamName: 'gryffindor'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        }
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const retVal = {};
    retainedFieldsData.current.forEach((fieldData)=>{
        const { mutationGroup: mutationGroup, ...rest } = fieldData;
        if (mutationGroup) {
            if (!retVal[mutationGroup]) retVal[mutationGroup] = [];
            retVal[mutationGroup].push(rest);
        } else Object.keys(rest).forEach((key)=>{
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ fieldId: string; }'.
            retVal[key] = rest[key];
        });
    });
    return {
        ...classificationRetainValue,
        ...initialDefaultValues,
        ...retVal
    };
};
const $db6fd5c8baa76d90$export$cc6683ccc73b073 = (sectionMessage)=>{
    if (sectionMessage && sectionMessage.type === 'error') {
        const { title: title, displayList: errors } = sectionMessage;
        return {
            title: title,
            errors: errors
        };
    }
    return null;
};
const $db6fd5c8baa76d90$export$ce9d0b4bb614f329 = (projectContext)=>{
    if (projectContext?.projectId) return {
        label: projectContext.projectName,
        value: projectContext.projectId.toString(),
        iconUrl: '',
        projectKey: projectContext.projectKey,
        projectType: projectContext.projectType,
        isSimplified: projectContext.simplified
    };
    return null;
};
const $db6fd5c8baa76d90$export$fbc6cb29c318fa3a = (selectedProject, context)=>context?.projectId === selectedProject.value;
const $db6fd5c8baa76d90$export$3a332740e4aa9440 = (projectType, fieldConfig)=>{
    if (projectType !== (0, $7ZZxN.SOFTWARE_PROJECT) && projectType !== (0, $7ZZxN.CORE_PROJECT)) return false;
    return !!fieldConfig.status;
};
const $db6fd5c8baa76d90$export$d89be2967c4b3fcf = (projectType, selectedIssueType, alertsToBeLinked)=>{
    if (!(0, $1ybV0.ff)('linked-alerts-in-gic_onvr6')) return false;
    if (!alertsToBeLinked) return false;
    if (!projectType || projectType !== (0, $7ZZxN.SERVICE_DESK_PROJECT)) return false;
    if (selectedIssueType?.type === (0, $8b8bfa076f313cc4$export$ebb48b08205007c5)) return false;
    return selectedIssueType?.practice === (0, $8b8bfa076f313cc4$export$48c144830383423);
};
const $db6fd5c8baa76d90$export$8625e37c02bbfb71 = ({ currentUserAccountId: currentUserAccountId, isAutoWatchEnabled: isAutoWatchEnabled = false, watchers: watchers = [] })=>{
    if (isAutoWatchEnabled) {
        if (watchers.length !== 1) return true;
        return watchers.every((watcher)=>watcher.accountId !== currentUserAccountId);
    }
    return watchers.length > 0;
};
const $db6fd5c8baa76d90$export$385bf01e57223a7c = (selectedIssueType)=>{
    const allowedIssueTypeValues = [
        'bug',
        'story',
        'task',
        'subtask',
        'epic'
    ];
    const issueTypeLabel = selectedIssueType?.label.toLowerCase();
    if (issueTypeLabel) return allowedIssueTypeValues.includes(issueTypeLabel) ? issueTypeLabel : 'custom';
    return undefined;
};
const $db6fd5c8baa76d90$export$cbe00e1e05a1451f = (errors, fieldConfig, filteredOutModules)=>{
    const customFieldsWithError = [];
    try {
        for (const error of errors){
            const fieldData = fieldConfig[error.field];
            if (fieldData) {
                const { isRequired: isRequired, fieldType: fieldType } = fieldData;
                if (isRequired) filteredOutModules.forEach((customField)=>{
                    if (customField.properties.displayConditions !== undefined && customField.id === fieldType) customFieldsWithError.push(fieldData.fieldName);
                });
            }
        }
        return customFieldsWithError.length !== 0 ? customFieldsWithError : null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $guiFP.default)({
            meta: {
                id: 'isDisplayConditionCFCausingError',
                packageName: 'jiraIssueCreate',
                teamName: 'gryffindor'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
        return null;
    }
};

});
parcelRegister("4cArj", function(module, exports) {

$parcel$export(module.exports, "FIELDS_TO_RETAIN_FIELD_VALUE", () => $c4d4e326f99380ca$export$992fccb91ee5793d);
$parcel$export(module.exports, "NON_RETAINED_FIELDS_CREATE_ANOTHER", () => $c4d4e326f99380ca$export$d36a2604491a5bc6);
parcelRequire("bcUzb");
var $dkhuh = parcelRequire("dkhuh");

var $lO4Or = parcelRequire("lO4Or");

const $c4d4e326f99380ca$export$992fccb91ee5793d = [
    (0, $b1ba189bc6d9d9ad$export$d10237d945259f96)
];
const $c4d4e326f99380ca$export$d36a2604491a5bc6 = [
    {
        fieldId: (0, $lO4Or.DESCRIPTION_TYPE),
        getClearedDefaultValue: (fieldConfig)=>{
            if (fieldConfig) {
                const descriptionFieldData = fieldConfig[0, $lO4Or.DESCRIPTION_TYPE];
                return descriptionFieldData.gqlType === (0, $b1ba189bc6d9d9ad$export$31a6c27df1f927b2) ? {
                    resetRequired: true
                } : descriptionFieldData.defaultValue;
            }
            return undefined;
        }
    },
    {
        fieldId: (0, $lO4Or.ATTACHMENT_TYPE),
        getClearedDefaultValue: ()=>({
                shouldClear: true
            })
    },
    {
        fieldId: (0, $lO4Or.ISSUE_LINKS_TYPE),
        getClearedDefaultValue: (fieldConfig)=>{
            if (fieldConfig) {
                const { defaultValue: defaultValue } = fieldConfig[0, $lO4Or.ISSUE_LINKS_TYPE];
                if (Array.isArray(defaultValue)) {
                    const issueLinks = [];
                    defaultValue.forEach((issueLink)=>{
                        if (issueLink !== undefined && issueLink !== null && (typeof issueLink.id === 'string' || issueLink.id === null) && issueLink.relatedBy !== null && typeof issueLink.relatedBy === 'object' && typeof issueLink.relatedBy.linkTypeName === 'string' && typeof issueLink.relatedBy.relationName === 'string' && typeof issueLink.relatedBy.linkTypeId === 'string' && (issueLink.relatedBy.direction === 'INWARD' || issueLink.relatedBy.direction === 'OUTWARD') && typeof issueLink.issue === 'object' && issueLink.issue !== null && typeof issueLink.issue.avatar === 'object' && issueLink.issue.avatar !== null && typeof issueLink.issue.avatar.small === 'string' && typeof issueLink.issue.avatar.medium === 'string' && typeof issueLink.issue.id === 'string' && typeof issueLink.issue.issueId === 'string' && typeof issueLink.issue.key === 'string') {
                            // for type refinement, cannot pass iterable 'issueLink' directly to transformDefaultIssueLinksValue
                            const issueLinkExact = {
                                id: issueLink.id,
                                relatedBy: {
                                    linkTypeName: issueLink.relatedBy.linkTypeName,
                                    relationName: issueLink.relatedBy.relationName,
                                    linkTypeId: issueLink.relatedBy.linkTypeId,
                                    direction: issueLink.relatedBy.direction
                                },
                                issue: {
                                    avatar: {
                                        medium: issueLink.issue.avatar.medium,
                                        small: issueLink.issue.avatar.small
                                    },
                                    id: issueLink.issue.id,
                                    issueId: issueLink.issue.issueId,
                                    key: issueLink.issue.key
                                }
                            };
                            issueLinks.push(issueLinkExact);
                        }
                    });
                    return (0, $dkhuh.transformDefaultIssueLinksValue)(issueLinks);
                }
            }
            return undefined;
        }
    }
];

});



parcelRegister("eaonO", function(module, exports) {

$parcel$export(module.exports, "default", () => $94c8db2ba207303e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $220ac = parcelRequire("220ac");

var $4Es8k = parcelRequire("4Es8k");

var $lQXqy = parcelRequire("lQXqy");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8SmIh = parcelRequire("8SmIh");
const $94c8db2ba207303e$var$MAX_IMAGE_WIDTH_PX = 188;
const $94c8db2ba207303e$var$MAX_IMAGE_HEIGHT_PX = 250;
const $94c8db2ba207303e$var$IMAGE_WIDTH_PX = 188;
const $94c8db2ba207303e$var$renderImage = ()=>(0, $4Es8k.getAkEmptyStateRenderImageFn)((0, $lQXqy.default))({
        imageWidth: $94c8db2ba207303e$var$IMAGE_WIDTH_PX,
        maxImageWidth: $94c8db2ba207303e$var$MAX_IMAGE_WIDTH_PX,
        maxImageHeight: $94c8db2ba207303e$var$MAX_IMAGE_HEIGHT_PX
    });
const $94c8db2ba207303e$var$ErrorState = /*#__PURE__*/ (0, $eUqFw.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($94c8db2ba207303e$export$412bc65ea3f44cf1, {
        "data-test-id": "issue-create.ui.modal.error-state.fetch-error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $220ac.default), {
        renderImage: $94c8db2ba207303e$var$renderImage,
        header: formatMessage((0, $8SmIh.default).header),
        description: formatMessage((0, $8SmIh.default).description),
        width: "narrow"
    }));
});
var $94c8db2ba207303e$export$2e2bcd8739ae039 // to be wrapped only for components where test-id can't be added on some components
 = $94c8db2ba207303e$var$ErrorState;
const $94c8db2ba207303e$export$412bc65ea3f44cf1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4Es8k", function(module, exports) {

$parcel$export(module.exports, "getAkEmptyStateRenderImageFn", () => $5b95caa215479c6b$export$ebf64b9217c1b2a3);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $gyaWd = parcelRequire("gyaWd");
function $5b95caa215479c6b$export$ebf64b9217c1b2a3(JiraIllustration = (0, $gyaWd.default)) {
    return ({ maxImageWidth: // we strictly follow EmptyState's defaults
    maxImageWidth = 160, maxImageHeight: maxImageHeight = 160, imageWidth: imageWidth, imageHeight: imageHeight })=>{
        // This wrapper emulates EmptyState's private "HeaderImage" styling
        // @see platform/packages/design-system/empty-state/src/empty-state.tsx
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
        const Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
                ...__cmplp,
                style: {
                    ...__cmpls,
                    "--_yv3y2x": (0, $9t7rW.default)(maxImageWidth, "px"),
                    "--_nq7wev": (0, $9t7rW.default)(maxImageHeight, "px")
                },
                ref: __cmplr,
                className: (0, $7JEyt.default)([
                    "_1e0c1ule _p12f1x6a _c71lc3ce _18s81ixx",
                    __cmplp.className
                ])
            });
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(JiraIllustration, {
            alt: "",
            role: "presentation",
            width: imageWidth || 'auto',
            height: imageHeight || 'auto'
        }));
    };
}

});
parcelRegister("gyaWd", function(module, exports) {

$parcel$export(module.exports, "default", () => $f352d69c1b682860$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = tgxxcm73mk6phg9ttfj3rvpf
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/tgxxcm73mk6phg9ttfj3rvpf

var $9TZf5 = parcelRequire("9TZf5");

var $7XfGh = parcelRequire("7XfGh");

var $5deuu = parcelRequire("5deuu");
const $f352d69c1b682860$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($5deuu)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($7XfGh))
});
var $f352d69c1b682860$export$2e2bcd8739ae039 = $f352d69c1b682860$var$Illustration;
// for advanced use only
const $f352d69c1b682860$export$a179c88182cb9d56 = [
    0,
    0,
    235,
    210
];

});
parcelRegister("7XfGh", function(module, exports) {
module.exports = new URL("generic-empty-state-darkmode.27f5dcf1.svg", import.meta.url).toString();

});

parcelRegister("5deuu", function(module, exports) {
module.exports = new URL("generic-empty-state.1b007192.svg", import.meta.url).toString();

});



parcelRegister("lQXqy", function(module, exports) {

$parcel$export(module.exports, "default", () => $30559913302f86cb$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("jhcOe")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("6bGvz")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = m5v37k2r2scm86wgmrk6
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/m5v37k2r2scm86wgmrk6

var $9TZf5 = parcelRequire("9TZf5");

var $6bGvz = parcelRequire("6bGvz");

var $jhcOe = parcelRequire("jhcOe");
const $30559913302f86cb$var$Illustration = (0, $9TZf5.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($jhcOe)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($6bGvz))
});
var $30559913302f86cb$export$2e2bcd8739ae039 = $30559913302f86cb$var$Illustration;
// for advanced use only
const $30559913302f86cb$export$a179c88182cb9d56 = [
    0,
    0,
    164,
    218
];

});
parcelRegister("6bGvz", function(module, exports) {
module.exports = new URL("error-darkmode.9dba78cd.svg", import.meta.url).toString();

});

parcelRegister("jhcOe", function(module, exports) {
module.exports = new URL("error.b7de7f77.svg", import.meta.url).toString();

});


parcelRegister("8SmIh", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c262e535073d694$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $8c262e535073d694$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    header: {
        "id": "issue-create.modal.error-state.header",
        "defaultMessage": "Something's gone wrong"
    },
    description: {
        "id": "issue-create.modal.error-state.description",
        "defaultMessage": "Our team has been notified. If the problem persists, please contact Atlassian support."
    }
});

});


parcelRegister("fYlUn", function(module, exports) {

$parcel$export(module.exports, "ExistingGICWarning", () => $c65d980e1fa8124f$export$e0cf9a7a2f315b80);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $kGQen = parcelRequire("kGQen");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4r5oC = parcelRequire("4r5oC");

var $dNWQB = parcelRequire("dNWQB");
var $2gOs4 = parcelRequire("2gOs4");

var $fswni = parcelRequire("fswni");

var $ctR9z = parcelRequire("ctR9z");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $2qZHF = parcelRequire("2qZHF");

var $a7q8h = parcelRequire("a7q8h");
const $c65d980e1fa8124f$export$e0cf9a7a2f315b80 = ()=>{
    const [{ wasModalRetriggered: wasModalRetriggered }, { resetWasModalRetriggered: resetWasModalRetriggered }] = (0, $ctR9z.useTriggerIssueCreateModal)();
    const [{ resetFormAction: resetFormAction, selectedProject: selectedProject, isFormDirty: isCreateFormDirty }] = (0, $fswni.useFormContext)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const projectId = selectedProject && selectedProject.value;
    const projectType = selectedProject ? (0, $4r5oC.transformProjectType)(selectedProject.projectType) : '';
    const { publish: publish } = (0, $2gOs4.useGICLifeCycleEvents)();
    // Re-initialise context values when create button is clicked and the form is clean
    (0, $eUqFw.useEffect)(()=>{
        if (wasModalRetriggered && !isCreateFormDirty) resetWasModalRetriggered(true);
    }, [
        wasModalRetriggered,
        isCreateFormDirty,
        resetWasModalRetriggered
    ]);
    const onClickDiscardButton = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'discardExistingGicWarning', {
            projectType: projectType
        });
        resetWasModalRetriggered(true);
        resetFormAction && resetFormAction();
        publish((0, $dNWQB.GIC_LIFECYCLE_EVENTS).MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE, {});
    }, [
        publish,
        projectType,
        resetWasModalRetriggered,
        resetFormAction
    ]);
    const onClickKeepEditingButton = (0, $eUqFw.useCallback)(// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type.
    (_, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'keepEditingExistingGicWarning', {
            projectType: projectType
        });
        resetWasModalRetriggered();
        publish((0, $dNWQB.GIC_LIFECYCLE_EVENTS).MODAL_KEEP_EDITING_EXISTING_ISSUE, {});
    }, [
        projectType,
        publish,
        resetWasModalRetriggered
    ]);
    if (!wasModalRetriggered || !isCreateFormDirty || !selectedProject) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa),
        sourceName: "existingGicWarning",
        containerType: "project",
        containerId: projectId || '',
        attributes: {
            projectType: projectType
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
        onMount: (0, $jMP2a.fireScreenAnalyticsDeferred)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onClose: ()=>resetWasModalRetriggered(),
        width: "medium",
        testId: "issue-create.ui.modal.existing-gic-warning.modal-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), {
        appearance: "warning"
    }, formatMessage((0, $a7q8h.default).heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, formatMessage((0, $a7q8h.default).description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: onClickDiscardButton,
        appearance: "subtle",
        testId: "issue-create.ui.modal.existing-gic-warning.discard-button"
    }, formatMessage((0, $a7q8h.default).discardButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        onClick: onClickKeepEditingButton,
        appearance: "warning",
        testId: "issue-create.ui.modal.existing-gic-warning.keep-editing"
    }, formatMessage((0, $a7q8h.default).keepEditingButton))))));
};

});
parcelRegister("a7q8h", function(module, exports) {

$parcel$export(module.exports, "default", () => $311b77efcf71d630$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $311b77efcf71d630$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    heading: {
        "id": "issue-create.modal.existing-gic-warning.heading",
        "defaultMessage": "Draft issue in progress"
    },
    description: {
        "id": "issue-create.modal.existing-gic-warning.description",
        "defaultMessage": "It looks like you\u2019re already creating an issue. Creating a new issue will discard your draft and any changes you\u2019ve made won\u2019t be saved."
    },
    discardButton: {
        "id": "issue-create.modal.existing-gic-warning.discard-button",
        "defaultMessage": "Discard draft"
    },
    keepEditingButton: {
        "id": "issue-create.modal.existing-gic-warning.keep-editing-button",
        "defaultMessage": "Keep editing"
    }
});

});


parcelRegister("eF2ez", function(module, exports) {

$parcel$export(module.exports, "JsmRequestTypeFieldsChangeboarding", () => $9ce37d05bdbe8c71$export$3c3f6e745ff8955);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $lRvnl = parcelRequire("lRvnl");

var $4ksts = parcelRequire("4ksts");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $2qZHF = parcelRequire("2qZHF");
var $bFzGY = parcelRequire("bFzGY");

var $4NPAT = parcelRequire("4NPAT");

var $lavf7 = parcelRequire("lavf7");
const $9ce37d05bdbe8c71$var$learnMoreLink = 'https://support.atlassian.com/jira-service-management-cloud/docs/customize-the-fields-of-a-request-type/';
const $9ce37d05bdbe8c71$export$3c3f6e745ff8955 = ()=>{
    const [{ data: isRequestTypeFieldsLayoutEnabled }] = (0, $4NPAT.useRequestTypeFieldsLayoutPreference)();
    const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onClickLearnMoreLink = ()=>(0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({}), 'jsmRequestTypeFieldsChangeboardingLearnMoreLink clicked');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$238d30785c4bca84),
        sourceName: "jsmRequestTypeFieldsChangeboarding"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
        onMount: (0, $jMP2a.fireScreenAnalyticsDeferred)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lRvnl.default), {
        appearance: "discovery",
        actions: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
            appearance: "link",
            spacing: "none",
            onClick: onClickLearnMoreLink,
            onAuxClick: onClickLearnMoreLink,
            href: $9ce37d05bdbe8c71$var$learnMoreLink,
            target: "_blank"
        }, !isRequestTypeFieldsLayoutEnabled ? formatMessage((0, $lavf7.default).sectionMessageLearnMoreWhenToggleOff) : formatMessage((0, $lavf7.default).sectionMessageLearnMore))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, !isRequestTypeFieldsLayoutEnabled ? formatMessage((0, $lavf7.default).sectionMessageBodyWhenToggleOff, {
        bold: (message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("b", null, message)
    }) : formatMessage((0, $lavf7.default).sectionMessageBody))));
};

});
parcelRegister("lavf7", function(module, exports) {

$parcel$export(module.exports, "default", () => $737c7260d31c4f0a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $737c7260d31c4f0a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    sectionMessageBody: {
        "id": "issue-create.modal.jsm-request-type-fields-changeboarding.section-message-body",
        "defaultMessage": "Since a request type has been selected for this issue, these fields can\u2019t be edited here."
    },
    sectionMessageBodyWhenToggleOff: {
        "id": "issue-create.modal.jsm-request-type-fields-changeboarding.section-message-body-when-toggle-off",
        "defaultMessage": "Turn on the <bold>Use request type fields</bold> toggle to see only request type fields while creating issues."
    },
    sectionMessageLearnMore: {
        "id": "issue-create.modal.jsm-request-type-fields-changeboarding.section-message-learn-more",
        "defaultMessage": "Learn more about editing the fields of a request type"
    },
    sectionMessageLearnMoreWhenToggleOff: {
        "id": "issue-create.modal.jsm-request-type-fields-changeboarding.section-message-learn-more-when-toggle-off",
        "defaultMessage": "Learn more about using request type fields while creating issues"
    }
});

});


parcelRegister("9stBj", function(module, exports) {

$parcel$export(module.exports, "ModalWrapper", () => $cbd87e3b91e134b3$export$858bfd02c3f2fba5);

var $eUqFw = parcelRequire("eUqFw");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");

var $fyk0U = parcelRequire("fyk0U");

var $41WOo = parcelRequire("41WOo");

var $8xcmb = parcelRequire("8xcmb");

var $kGQen = parcelRequire("kGQen");

var $0cdA8 = parcelRequire("0cdA8");

var $1ybV0 = parcelRequire("1ybV0");

var $18to0 = parcelRequire("18to0");

var $eTZsp = parcelRequire("eTZsp");

var $7TaJX = parcelRequire("7TaJX");

var $fswni = parcelRequire("fswni");

var $dQa9h = parcelRequire("dQa9h");
var $3zS1v = parcelRequire("3zS1v");
var $dxjRg = parcelRequire("dxjRg");
var $bG3FB = parcelRequire("bG3FB");
var $bMDI2 = parcelRequire("bMDI2");
var $gya0p = parcelRequire("gya0p");

var $lBwos = parcelRequire("lBwos");
var $1jsll = parcelRequire("1jsll");

var $ctR9z = parcelRequire("ctR9z");

var $jK1pm = parcelRequire("jK1pm");

var $iLTnN = parcelRequire("iLTnN");

var $jUUuq = parcelRequire("jUUuq");
var $hFagV = parcelRequire("hFagV");

var $7cshP = parcelRequire("7cshP");

var $gEI3N = parcelRequire("gEI3N");

var $gMPmc = parcelRequire("gMPmc");

var $RgE7p = parcelRequire("RgE7p");

var $hDWvr = parcelRequire("hDWvr");

var $lkmb6 = parcelRequire("lkmb6");

var $l7AVl = parcelRequire("l7AVl");
var $gqW7X = parcelRequire("gqW7X");

var $97M4F = parcelRequire("97M4F");

var $hmaT3 = parcelRequire("hmaT3");
const $cbd87e3b91e134b3$var$ModalBodyNext = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        id: (0, $7TaJX.ISSUE_CREATE_MODAL_BODY_SELECTOR),
        ref: ref,
        ...props
    })));
const $cbd87e3b91e134b3$var$OldModal = ({ children: children, onModalCloseWithConfirm: onModalCloseWithConfirm, shouldDisableActions: shouldDisableActions, onSubmit: onSubmit, isSubmitting: isSubmitting, isOperationInProgress: isOperationInProgress, canCreateAnotherIssue: canCreateAnotherIssue, onCreateAnotherChange: onCreateAnotherChange, getShouldDisableSubmit: getShouldDisableSubmit, createdIssues: createdIssues, displayCreateAnotherIssueToggle: displayCreateAnotherIssueToggle, showIssuesCreated: showIssuesCreated, watchersConfigurations: watchersConfigurations })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        width: "large",
        height: "100vh",
        autoFocus: false,
        // @ts-expect-error - TS2322 - Type '(_: SyntheticEvent<Element, Event>, analyticsEvent: UIAnalyticsEventInterface) => void' is not assignable to type 'OnCloseHandler'.
        onClose: onModalCloseWithConfirm('issueCreateModalEscapeClick'),
        shouldCloseOnEscapePress: true,
        shouldCloseOnOverlayClick: false,
        testId: "issue-create.ui.modal.modal-wrapper.modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l7AVl.default), {
        shouldDisableActions: shouldDisableActions,
        watchersConfigurations: watchersConfigurations
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cbd87e3b91e134b3$var$ModalBodyNext, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iLTnN.default), {
        onClose: onModalCloseWithConfirm('cancel'),
        onSubmit: onSubmit,
        isSubmitting: isSubmitting,
        isOperationInProgress: isOperationInProgress,
        canCreateAnotherIssue: canCreateAnotherIssue,
        onCreateAnotherChange: onCreateAnotherChange,
        shouldDisableSubmit: getShouldDisableSubmit(),
        createdIssues: createdIssues,
        displayCreateAnotherIssueToggle: displayCreateAnotherIssueToggle,
        showIssuesCreated: showIssuesCreated
    })));
const $cbd87e3b91e134b3$var$WrapWithUserTraitsProvider = ({ children: children })=>(0, $41WOo.isJwmReduceNoiseOnSignupEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fyk0U.UserTraitsProvider), null, children) : children;
const $cbd87e3b91e134b3$var$MinimizableModalContainer = ({ children: children })=>{
    const { initialSummaryValue: initialSummaryValue } = (0, $7cshP.useMinimizableModalWrapperProps)();
    const { view: view } = (0, $gya0p.useMinimizableModal)();
    const summaryValue = (0, $97M4F.useSetSummary)(initialSummaryValue);
    (0, $hmaT3.useViewChangerDisabler)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bMDI2.ModalTransition), {
        renderCondition: view === 'modal'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gqW7X.MinimizableModalModal), {
        "data-testid": "issue-create.ui.modal.modal-wrapper.modal"
    }, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bG3FB.MiniTransition), {
        renderCondition: view === 'mini'
    }, ({ transitionProps: transitionProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cbd87e3b91e134b3$var$WrapWithUserTraitsProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hDWvr.MinimizableModalMini), {
            ...transitionProps,
            summaryValue: summaryValue
        }, children))), (0, $1ybV0.ff)('jira-intelligent-issue-breakdown_18syl') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1jsll.AiEnabledMiniTransition), {
        renderCondition: view === 'ai-enabled'
    }, ({ transitionProps: transitionProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gEI3N.MinimizableAiEnabled), transitionProps, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dQa9h.FullscreenTransition), {
        renderCondition: view === 'fullscreen'
    }, ({ transitionProps: transitionProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $RgE7p.MinimizableFullscreen), transitionProps, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxjRg.MinimizedTransition), {
        renderCondition: view === 'minimized'
    }, ({ transitionProps: transitionProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lkmb6.MinimizableModalMinimized), {
            ...transitionProps,
            summaryValue: summaryValue
        })), (0, $1ybV0.ff)('jira-intelligent-issue-breakdown_18syl') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lBwos.AiEnabledMinimizedTransition), {
        renderCondition: view === 'ai-enabled-minimized'
    }, ({ transitionProps: transitionProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gMPmc.MinimizableAiEnabledMinimized), transitionProps)));
};
const $cbd87e3b91e134b3$var$OldModalWrapper = (props)=>{
    const [{ disableGICPositioning: disableGICPositioning }, { setDisableGICPositioning: setDisableGICPositioning }] = (0, $jUUuq.useGICPositioningEnabledController)();
    (0, $eUqFw.useEffect)(()=>{
        if (!disableGICPositioning) setDisableGICPositioning(true);
    }, [
        disableGICPositioning,
        setDisableGICPositioning
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cbd87e3b91e134b3$var$OldModal, props);
};
const $cbd87e3b91e134b3$export$858bfd02c3f2fba5 = ({ children: children, ...rest })=>{
    const [{ minimizableModalView: minimizableModalView, displayMinimizableButtons: displayMinimizableButtons }, { setMinimizableModalView: setMinimizableModalView }] = (0, $ctR9z.useTriggerIssueCreateModal)();
    const isGICPositioningEnabled = (0, $hFagV.useIsGICPositioningEnabled)();
    const [, { dispatchFormSubmits: dispatchForgeInlineFormSubmits }] = (0, $18to0.useInlineFields)();
    const [{ isFormLoaded: isFormLoaded }] = (0, $fswni.useFormContext)();
    const renderOldModal = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cbd87e3b91e134b3$var$OldModalWrapper, rest, children);
    const onViewChange = (0, $eUqFw.useCallback)((newView)=>{
        setMinimizableModalView(newView);
        dispatchForgeInlineFormSubmits();
    }, [
        setMinimizableModalView,
        dispatchForgeInlineFormSubmits
    ]);
    if (isGICPositioningEnabled()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "issue-create-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: (0, $1ybV0.ff)('gic-modal-js-error-boundary-post-load-errors_qh9ev') && isFormLoaded ? 'issue-create-app-loaded' : 'issue-create-app',
        /* eslint-disable-next-line jira/js/package-name-enforcer-for-error-boundary */ packageName: "jiraIssueCreateModal",
        fallback: renderOldModal,
        sendToPrivacyUnsafeSplunk: true,
        attributes: (error)=>({
                errorType: (0, $eTZsp.getErrorType)(error)
            })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7cshP.MinimizableModalWrapperPropsProvider), rest, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3zS1v.MinimizableModal), {
        view: minimizableModalView,
        onViewChange: onViewChange,
        Container: $cbd87e3b91e134b3$var$MinimizableModalContainer,
        // @ts-expect-error - TS2322 - Type '(_: SyntheticEvent<Element, Event>, analyticsEvent: UIAnalyticsEventInterface) => void' is not assignable to type 'OnCloseHandler'.
        onClose: rest.onModalCloseWithConfirm('cancel'),
        displayMinimizableButtons: displayMinimizableButtons
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8xcmb.ClipboardContextBoundaryContainer), null, children)))));
    return renderOldModal();
};

});
parcelRegister("fyk0U", function(module, exports) {

$parcel$export(module.exports, "useFetchUserTraitsOld", () => $8dca86bbd49a57d4$export$d5a27009aa54a078);
$parcel$export(module.exports, "UserTraitsProvider", () => $8dca86bbd49a57d4$export$23c27d2553d62584);
$parcel$export(module.exports, "UserTraitsStore", () => $8dca86bbd49a57d4$export$6e688ed53ae076d5);
$parcel$export(module.exports, "useUserTraits", () => $8dca86bbd49a57d4$export$49363c8b904e0dc7);
$parcel$export(module.exports, "useUserTraitsActions", () => $8dca86bbd49a57d4$export$4f249a943026a90b);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");

var $lRmyA = parcelRequire("lRmyA");

var $dxcfv = parcelRequire("dxcfv");
var $dWLk9 = parcelRequire("dWLk9");
const $8dca86bbd49a57d4$var$setUserTraits = (newTraits)=>({ getState: getState, setState: setState })=>{
        const currentUserTraits = getState();
        setState({
            ...currentUserTraits,
            attributes: newTraits
        });
    };
const $8dca86bbd49a57d4$var$addUserTrait = (trait)=>({ getState: getState, setState: setState })=>{
        const currentUserTraits = getState();
        if (currentUserTraits.attributes?.some((t)=>t.name === trait.name)) return;
        setState({
            attributes: currentUserTraits.attributes?.concat(trait) ?? [
                trait
            ]
        });
    };
const $8dca86bbd49a57d4$var$fetchUserTraits = (cloudId, accountId)=>async ({ getState: getState, setState: setState })=>{
        if (!accountId) return null;
        const state = getState();
        if (state.attributes !== null) return;
        const getUserTraits = async ()=>{
            try {
                const userTraitsData = await (0, $lRmyA.performGetRequest)(`/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${accountId}`);
                return userTraitsData?.attributes ?? [];
            } catch  {
                return null;
            }
        };
        const userTraits = await getUserTraits();
        setState({
            attributes: userTraits
        });
    };
const $8dca86bbd49a57d4$var$actions = {
    setUserTraits: $8dca86bbd49a57d4$var$setUserTraits,
    fetchUserTraits: $8dca86bbd49a57d4$var$fetchUserTraits,
    addUserTrait: $8dca86bbd49a57d4$var$addUserTrait
};
const $8dca86bbd49a57d4$var$initialState = {
    attributes: null
};
const $8dca86bbd49a57d4$export$d5a27009aa54a078 = ()=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const accountId = (0, $dxcfv.useAccountId)();
    const [loading, setLoading] = (0, $eUqFw.useState)(false);
    return (0, $eUqFw.useCallback)(async ()=>{
        if (!accountId) return null;
        const url = `/gateway/api/tap-delivery/api/v3/personalization/site/${cloudId}/user/${accountId}`;
        const getUserTraits = async ()=>{
            try {
                setLoading(true);
                const userTraitsData = await (0, $lRmyA.performGetRequest)(url);
                // If a user has no attributes on their account, return null so we know
                // not to keep trying to fetch data.
                return !userTraitsData?.attributes?.length ? null : userTraitsData?.attributes;
            } catch  {
                return null;
            } finally{
                setLoading(false);
            }
        };
        if (!loading) {
            const userTraits = await getUserTraits();
            return userTraits;
        }
        return false;
    }, [
        accountId,
        cloudId,
        loading
    ]);
};
const $8dca86bbd49a57d4$export$23c27d2553d62584 = (0, $heB5U.createContainer)();
const $8dca86bbd49a57d4$export$6e688ed53ae076d5 = (0, $a61MH.createStore)({
    initialState: $8dca86bbd49a57d4$var$initialState,
    actions: $8dca86bbd49a57d4$var$actions,
    containedBy: $8dca86bbd49a57d4$export$23c27d2553d62584,
    name: 'UserTraits'
});
const $8dca86bbd49a57d4$export$49363c8b904e0dc7 = (0, $ggKAj.createHook)($8dca86bbd49a57d4$export$6e688ed53ae076d5);
const $8dca86bbd49a57d4$export$4f249a943026a90b = (0, $ggKAj.createActionsHook)($8dca86bbd49a57d4$export$6e688ed53ae076d5);

});

parcelRegister("41WOo", function(module, exports) {

$parcel$export(module.exports, "isJwmMonetizationExperimentEnabled", () => $2d43a89fd1224d6e$export$10ae23b90fb69a2a);
$parcel$export(module.exports, "isVariationOnJwmMonetizationExperiment", () => $2d43a89fd1224d6e$export$157c21c92e1418f2);
$parcel$export(module.exports, "isJwmInlineFieldCreateEnabled", () => $2d43a89fd1224d6e$export$fb2108971c4de07a);
$parcel$export(module.exports, "getJwmInlineFieldCreateCohort", () => $2d43a89fd1224d6e$export$bd44a7b81fbc9090);
$parcel$export(module.exports, "isInAutomationDiscoveryOnBoardColumnsExperimentVariationCohort", () => $2d43a89fd1224d6e$export$7b2cbb525cd1479e);
$parcel$export(module.exports, "isAutomationDiscoveryOnBoardColumnsExperimentEnabled", () => $2d43a89fd1224d6e$export$926c1115b4c28620);
$parcel$export(module.exports, "isJwmTemplateBundlesEnabled", () => $2d43a89fd1224d6e$export$b9595e1ee168b117);
$parcel$export(module.exports, "isLinkedIssuesEnabledInJwmBoardCards", () => $2d43a89fd1224d6e$export$144ea04c193e7769);
$parcel$export(module.exports, "getJwmHelpSampleUsersCreateProjectsCtaType", () => $2d43a89fd1224d6e$export$6df5130e98d74ad2);
$parcel$export(module.exports, "isOnboardingForLinkedIssuesEnabledInJwmBoard", () => $2d43a89fd1224d6e$export$21f160f3ad728081);
$parcel$export(module.exports, "isJwmReduceNoiseOnSignupEnabled", () => $2d43a89fd1224d6e$export$dc89692c53fbc1);

var $79xbN = parcelRequire("79xbN");

var $eI5EY = parcelRequire("eI5EY");
const $2d43a89fd1224d6e$export$10ae23b90fb69a2a = ()=>!(0, $79xbN.expValEquals)('jwm_implicit_user_monetization_experiment', 'cohort', null);
const $2d43a89fd1224d6e$export$157c21c92e1418f2 = ()=>(0, $79xbN.expValEquals)('jwm_implicit_user_monetization_experiment', 'cohort', 'variation');
const $2d43a89fd1224d6e$export$fb2108971c4de07a = ()=>(0, $79xbN.expValEquals)('jwm_inline_field_create', 'cohort', 'variation');
const $2d43a89fd1224d6e$export$bd44a7b81fbc9090 = ()=>(0, $79xbN.expVal)('jwm_inline_field_create', 'cohort', 'not-enrolled');
const $2d43a89fd1224d6e$export$7b2cbb525cd1479e = ()=>{
    // Intentionally not firing exposure here because the user is not yet determined to be eligible.
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jwm_moon_automation_discovery_v2');
    return expConfig.get('cohort', 'not-enrolled') === 'variation';
};
const $2d43a89fd1224d6e$export$926c1115b4c28620 = ()=>{
    // Intentionally not firing exposure here because the user is not yet determined to be eligible.
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jwm_moon_automation_discovery_v2');
    return expConfig.get('cohort', 'not-enrolled') !== 'not-enrolled';
};
const $2d43a89fd1224d6e$export$b9595e1ee168b117 = ()=>(0, $79xbN.expValEquals)('jwm_template_bundles_experiment', 'cohort', 'variation');
const $2d43a89fd1224d6e$export$144ea04c193e7769 = ()=>(0, $79xbN.expValEquals)('jwm_linked_issues_on_the_board_milestone_1', 'cohort', 'variation');
const $2d43a89fd1224d6e$export$6df5130e98d74ad2 = ()=>{
    // Intentionally not firing exposure here because it is yet to be determined whether the engagement platform message has started.
    // eslint-disable-next-line jira/ff/unsafe-no-exposure
    const [expConfig] = (0, $79xbN.UNSAFE_noExposureExp)('jwm_help_sample_users_create_projects');
    return expConfig.get('ctaType', 'none');
};
const $2d43a89fd1224d6e$export$21f160f3ad728081 = ()=>// eslint-disable-next-line jira/ff/no-preconditioning -- Need this preconditioning to make sure can independently control onboarding
    (0, $eI5EY.fg)('jwm_linked_issues_on_the_board_onboarding') && (0, $79xbN.expVal)('jwm_linked_issues_on_the_board_milestone_1', 'isJWMBoardLinkedIssuesEnabled', false);
const $2d43a89fd1224d6e$export$dc89692c53fbc1 = ()=>(0, $79xbN.expValEquals)('jwm_reduce_noise_on_signup', 'cohort', 'variation');

});

parcelRegister("8xcmb", function(module, exports) {

$parcel$export(module.exports, "ClipboardContextBoundaryContainer", () => $aa4cd8d0d241df51$export$fd0a7836bfa6a893);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $7wp7z = parcelRequire("7wp7z");
const $aa4cd8d0d241df51$var$invisibleDivStyles = null;
const $aa4cd8d0d241df51$var$ClipboardContextBoundaryProvider = ({ children: children })=>{
    const { setClipBoardContext: setClipBoardContext } = (0, $7wp7z.useClipboardContextActions)();
    const setRef = (0, $eUqFw.useCallback)((node)=>{
        setClipBoardContext(node);
    }, [
        setClipBoardContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: setRef,
        "data-testid": "clipboard.controllers.boundary.clipboard-boundary",
        className: (0, $7JEyt.default)([
            "_1e0c1bgi _4t3i1kw7 _1bsb1kw7"
        ])
    }, children);
};
const $aa4cd8d0d241df51$export$fd0a7836bfa6a893 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7wp7z.ClipboardStoreContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aa4cd8d0d241df51$var$ClipboardContextBoundaryProvider, null, children));
const $aa4cd8d0d241df51$var$ClipboardContainerSetEffector = ({ container: container })=>{
    const { setClipBoardContext: setClipBoardContext } = (0, $7wp7z.useClipboardContextActions)();
    (0, $eUqFw.useEffect)(()=>setClipBoardContext(container), [
        setClipBoardContext,
        container
    ]);
    return null;
};
const $aa4cd8d0d241df51$export$99c5c2d165547316 = ({ children: children, container: container, intent: intent })=>{
    const currentContainer = (0, $7wp7z.useClipboardContextBoundary)();
    if (!container || currentContainer && intent === 'support') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7wp7z.ClipboardStoreContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($aa4cd8d0d241df51$var$ClipboardContainerSetEffector, {
        container: container
    }), children);
};

});

parcelRegister("dQa9h", function(module, exports) {

$parcel$export(module.exports, "FullscreenTransition", () => $94c3b4ac1763a210$export$d6c32f25d5187e12);

var $eUqFw = parcelRequire("eUqFw");

var $lSV8Z = parcelRequire("lSV8Z");
var $hYDGa = parcelRequire("hYDGa");
var $8YJjX = parcelRequire("8YJjX");


var $cdJmq = parcelRequire("cdJmq");
const $94c3b4ac1763a210$export$d6c32f25d5187e12 = ({ children: children, renderCondition: renderCondition })=>{
    const { onFinishAnimation: onFinishAnimation, shouldRenderView: shouldRenderView } = (0, $cdJmq.useTransitionView)('fullscreen', renderCondition);
    if ((0, $8YJjX.isReducedMotion)()) {
        if (renderCondition) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children({
            transitionProps: {}
        }));
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lSV8Z.default), null, shouldRenderView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hYDGa.default), {
        entranceDirection: "bottom",
        exitDirection: "bottom",
        duration: (0, $06fdedeca8586601$export$3749e1104328fde4),
        onFinish: onFinishAnimation
    }, (fadeInProps)=>children({
            transitionProps: {
                ...fadeInProps
            }
        })));
};

});
const $06fdedeca8586601$export$3749e1104328fde4 = 250;

parcelRegister("cdJmq", function(module, exports) {

$parcel$export(module.exports, "useTransitionView", () => $2a72ed912a8de1fc$export$4ebb8b85ce67f755);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");
parcelRequire("gya0p");
var $9Pqox = parcelRequire("9Pqox");
var $gya0p = parcelRequire("gya0p");
const $2a72ed912a8de1fc$export$4ebb8b85ce67f755 = (view, renderCondition)=>{
    const { setTransitionState: setTransitionState, isTransitionInState: isTransitionInState } = (0, $gya0p.useMinimizableModal)();
    const shouldRenderView = (0, $eUqFw.useMemo)(()=>{
        if (view === 'modal') return renderCondition && isTransitionInState([
            'mini',
            'minimized'
        ], (0, $9Pqox.TransitionState).EXITED);
        if (view === 'mini') return renderCondition && isTransitionInState([
            'modal',
            'minimized'
        ], (0, $9Pqox.TransitionState).EXITED);
        if (view === 'minimized') return renderCondition && isTransitionInState((0, $1ybV0.ff)('jira-intelligent-issue-breakdown_18syl') ? [
            'mini',
            'modal',
            'ai-enabled'
        ] : [
            'mini',
            'modal'
        ], (0, $9Pqox.TransitionState).EXITED);
        if (view === 'fullscreen') return renderCondition && isTransitionInState([], (0, $9Pqox.TransitionState).EXITED);
        if ((0, $1ybV0.ff)('jira-intelligent-issue-breakdown_18syl') && view === 'ai-enabled') return renderCondition && isTransitionInState([
            'ai-enabled-minimized'
        ], (0, $9Pqox.TransitionState).EXITED);
        if ((0, $1ybV0.ff)('jira-intelligent-issue-breakdown_18syl') && view === 'ai-enabled-minimized') return renderCondition && isTransitionInState([
            'ai-enabled'
        ], (0, $9Pqox.TransitionState).EXITED);
        return false;
    }, [
        renderCondition,
        isTransitionInState,
        view
    ]);
    // SlideIn onFinish prop is sometimes called before the useEffect
    // isAnimationComplete is used to control that
    const isAnimationComplete = (0, $eUqFw.useRef)(false);
    const isInitialised = (0, $eUqFw.useRef)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (isInitialised.current) isAnimationComplete.current = false;
    }, [
        shouldRenderView
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (shouldRenderView && !isAnimationComplete.current) {
            isInitialised.current = true;
            setTransitionState(view, (0, $9Pqox.TransitionState).TRANSITIONING);
        } else if (!shouldRenderView && !isAnimationComplete.current && isInitialised.current) setTransitionState(view, (0, $9Pqox.TransitionState).TRANSITIONING);
    }, [
        shouldRenderView,
        setTransitionState,
        view
    ]);
    const onFinishAnimation = (0, $eUqFw.useCallback)((state)=>{
        isAnimationComplete.current = true;
        if (state === 'entering') setTransitionState(view, (0, $9Pqox.TransitionState).ENTERED);
        if (state === 'exiting') setTransitionState(view, (0, $9Pqox.TransitionState).EXITED);
    }, [
        setTransitionState,
        view
    ]);
    return {
        onFinishAnimation: onFinishAnimation,
        shouldRenderView: shouldRenderView
    };
};

});


parcelRegister("3zS1v", function(module, exports) {

$parcel$export(module.exports, "MinimizableModal", () => $83aaa6bfe36e026e$export$fe110805c6d6ede4);

var $eUqFw = parcelRequire("eUqFw");

var $etCs9 = parcelRequire("etCs9");

var $XHGTv = parcelRequire("XHGTv");

var $gya0p = parcelRequire("gya0p");

var $cMZsw = parcelRequire("cMZsw");

var $145Wp = parcelRequire("145Wp");
const $83aaa6bfe36e026e$export$fe110805c6d6ede4 = ({ children: children, Container: Container = (0, $cMZsw.ModalContainer), initialView: initialView, onClose: onClose, view: view, onViewChange: onViewChange })=>// See more details about UNSAFE_LAYERING https://hello.atlassian.net/wiki/spaces/~63ff0a61f00d095406f28492/pages/2984762483/Layering+package+introduction
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $etCs9.UNSAFE_LAYERING), {
        isDisabled: (0, $XHGTv.getBooleanFF)('platform.design-system-team.layering_qmiw3') ? false : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gya0p.MinimizableModalProvider), {
        initialView: initialView,
        onClose: onClose,
        view: view,
        onViewChange: onViewChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $145Wp.ReParenter), {
        Parent: Container
    }, children)));

});
parcelRegister("cMZsw", function(module, exports) {

$parcel$export(module.exports, "ModalContainer", () => $e3ea9b4ecd2611f7$export$c9554889b3e706cd);

var $eUqFw = parcelRequire("eUqFw");

var $gya0p = parcelRequire("gya0p");

var $kgYRM = parcelRequire("kgYRM");

var $dQa9h = parcelRequire("dQa9h");

var $fmKuk = parcelRequire("fmKuk");

var $bG3FB = parcelRequire("bG3FB");

var $bvunr = parcelRequire("bvunr");

var $dxjRg = parcelRequire("dxjRg");

var $jkyV3 = parcelRequire("jkyV3");

var $76zGC = parcelRequire("76zGC");

var $bMDI2 = parcelRequire("bMDI2");
const $e3ea9b4ecd2611f7$var$DefaultHeader = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $76zGC.ModalHeader), props);
const $e3ea9b4ecd2611f7$var$DefaultMiniHeader = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $76zGC.MiniHeader), props);
const $e3ea9b4ecd2611f7$export$c9554889b3e706cd = ({ children: children, components: components })=>{
    const { view: view } = (0, $gya0p.useMinimizableModal)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bMDI2.ModalTransition), {
        renderCondition: view === 'modal'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jkyV3.Modal), {
        components: components || {
            Header: $e3ea9b4ecd2611f7$var$DefaultHeader
        }
    }, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bG3FB.MiniTransition), {
        renderCondition: view === 'mini'
    }, ({ transitionProps: transitionProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fmKuk.Mini), {
            ...transitionProps,
            components: components || {
                Header: $e3ea9b4ecd2611f7$var$DefaultMiniHeader
            }
        }, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dQa9h.FullscreenTransition), {
        renderCondition: view === 'fullscreen'
    }, ({ transitionProps: transitionProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kgYRM.Fullscreen), {
            ...transitionProps,
            components: components || {
                Header: $e3ea9b4ecd2611f7$var$DefaultMiniHeader
            }
        }, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxjRg.MinimizedTransition), {
        renderCondition: view === 'minimized'
    }, ({ transitionProps: transitionProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bvunr.Minimized), transitionProps)));
};

});
parcelRegister("kgYRM", function(module, exports) {

$parcel$export(module.exports, "FullscreenBody", () => $cff81c94711c82f1$export$cf81465aa48f28a8);
$parcel$export(module.exports, "Fullscreen", () => $cff81c94711c82f1$export$159cd03be7087f39);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $jMP2a = parcelRequire("jMP2a");
var $2qZHF = parcelRequire("2qZHF");
parcelRequire("gya0p");
var $9Pqox = parcelRequire("9Pqox");
var $gya0p = parcelRequire("gya0p");

var $6yInD = parcelRequire("6yInD");
const $cff81c94711c82f1$export$cf81465aa48f28a8 = ({ children: children, containerStyle: containerStyle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6yInD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cff81c94711c82f1$var$FullscreenBodyWrapper, {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: containerStyle
    }, children));
const $cff81c94711c82f1$export$159cd03be7087f39 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, className: className, components: components }, ref)=>{
    const { Header: Header = (0, $eUqFw.Fragment), Footer: Footer = (0, $eUqFw.Fragment) } = components || {};
    const { isTransitionInState: isTransitionInState } = (0, $gya0p.useMinimizableModal)();
    const isViewEntered = isTransitionInState([
        'fullscreen'
    ], (0, $9Pqox.TransitionState).ENTERED);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cff81c94711c82f1$export$a07082e2094b8119, {
        ref: ref,
        transitionClass: className,
        "data-testid": !isViewEntered ? undefined : 'minimizable-modal.ui.modal-container.fullscreen'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
        onMount: (0, $jMP2a.fireScreenAnalyticsDeferred)
    }), components ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Header, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cff81c94711c82f1$export$cf81465aa48f28a8, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Footer, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children));
});
const $cff81c94711c82f1$export$a07082e2094b8119 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($cff81c94711c82f1$var$FullscreenWrapperExperimentStyles, {
        // eslint-disable-next-line jira/react/no-classname-attribute, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.transitionClass,
        ...props
    });
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cff81c94711c82f1$var$FullscreenBodyWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4v47k",
            __cmplp.className
        ])
    });
});
const $cff81c94711c82f1$var$FullscreenWrapperExperimentStyles = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _4t3i1osq _kqsw1n9t _154iidpf _1ltvidpf _11q71bhr _1reo15vq _18m915vq _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6yInD", function(module, exports) {

$parcel$export(module.exports, "default", () => $609f968da93a82fd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $eUqFw = parcelRequire("eUqFw");

var $51sCz = parcelRequire("51sCz");

var $dWaVw = parcelRequire("dWaVw");

var $kaIyT = parcelRequire("kaIyT");

var $6vxSC = parcelRequire("6vxSC");

var $8Mpzk = parcelRequire("8Mpzk");

var $9qC0Z = parcelRequire("9qC0Z");
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ const $609f968da93a82fd$var$ScrollContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { testId: testId, children: children, disableAutoTopKeyline: disableAutoTopKeyline = true, disableAutoBottomKeyline: disableAutoBottomKeyline = true } = props;
    const [hasSiblings, setSiblings] = (0, $6vxSC.default)({
        previous: false,
        next: false
    });
    const [showContentFocus, setContentFocus] = (0, $eUqFw.useState)(false);
    const [showTopKeyline, setTopKeyline] = (0, $eUqFw.useState)(false);
    const [showBottomKeyline, setBottomKeyline] = (0, $eUqFw.useState)(false);
    const scrollableRef = (0, $eUqFw.useRef)(null);
    const setLazySiblings = (0, $kaIyT.default)(setSiblings);
    const setLazyContentFocus = (0, $kaIyT.default)((0, $9qC0Z.rafSchedule)(()=>{
        const target = scrollableRef.current;
        target && setContentFocus(target.scrollHeight > target.clientHeight);
    }));
    const setLazyKeylines = (0, $kaIyT.default)((0, $9qC0Z.rafSchedule)(()=>{
        const target = scrollableRef.current;
        if (target) {
            const scrollableDistance = target.scrollHeight - target.clientHeight;
            if (hasSiblings.current.previous) setTopKeyline(target.scrollTop > (0, $8Mpzk.keylineHeight));
            if (hasSiblings.current.next) setBottomKeyline(target.scrollTop <= scrollableDistance - (0, $8Mpzk.keylineHeight));
        }
    }));
    (0, $eUqFw.useEffect)(()=>{
        const target = scrollableRef.current;
        window.addEventListener('resize', setLazyKeylines, false);
        target?.addEventListener('scroll', setLazyKeylines, false);
        setLazyContentFocus();
        setLazyKeylines();
        setLazySiblings({
            previous: Boolean(target?.previousElementSibling),
            next: Boolean(target?.nextElementSibling)
        });
        return ()=>{
            window.removeEventListener('resize', setLazyKeylines, false);
            target?.removeEventListener('scroll', setLazyKeylines, false);
        };
    }, [
        setLazyContentFocus,
        setLazyKeylines,
        setLazySiblings
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $51sCz.default), {
        isInset: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($609f968da93a82fd$var$ScrollContainerWrapper, {
        tabIndex: showContentFocus ? 0 : undefined,
        "data-testid": testId !== null && testId !== undefined && `${testId}--scrollable`,
        ref: (0, $dWaVw.default)([
            ref,
            scrollableRef
        ]),
        showTopKeyline: !disableAutoTopKeyline && showTopKeyline,
        showBottomKeyline: !disableAutoBottomKeyline && showBottomKeyline
    }, children));
});
$609f968da93a82fd$var$ScrollContainer.displayName = 'ScrollContainer';
var $609f968da93a82fd$export$2e2bcd8739ae039 = $609f968da93a82fd$var$ScrollContainer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $609f968da93a82fd$var$ScrollContainerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { showTopKeyline: showTopKeyline, showBottomKeyline: showBottomKeyline, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1dv6fab": (0, $9t7rW.default)((0, $8Mpzk.keylineColor))
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1kw7 _2lx21kw7 _1reo15vq _18m91wug _1d2sn7od _1utt1wug",
            __cmplp.showTopKeyline ? "_x3do9gv1" : "_x3doglyw",
            __cmplp.showBottomKeyline ? "_n7zl9gv1" : "_n7zlglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dWaVw", function(module, exports) {

$parcel$export(module.exports, "default", () => $7cf97669e34bb714$export$2e2bcd8739ae039);
function $7cf97669e34bb714$export$2e2bcd8739ae039(refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-param-reassign
            ref.current = value;
        });
    };
}

});

parcelRegister("kaIyT", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0d9b0d9540fcde5$export$2e2bcd8739ae039);

var $sS8gf = parcelRequire("sS8gf");
function $e0d9b0d9540fcde5$export$2e2bcd8739ae039(callback) {
    const ref = (0, $sS8gf.default)(()=>callback);
    return ref.current;
}

});
parcelRegister("sS8gf", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d357ad4e8e8ac21$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $3d357ad4e8e8ac21$var$uniqueReferencedValue = {};
function $3d357ad4e8e8ac21$export$2e2bcd8739ae039(initializer) {
    const ref = (0, $eUqFw.useRef)($3d357ad4e8e8ac21$var$uniqueReferencedValue);
    if (ref.current === $3d357ad4e8e8ac21$var$uniqueReferencedValue) ref.current = initializer();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ref;
}

});


parcelRegister("6vxSC", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c373be3e990fa8c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $7c373be3e990fa8c$export$2e2bcd8739ae039(initialState) {
    const [value, setValue] = (0, $eUqFw.useState)(initialState);
    const valueRef = (0, $eUqFw.useRef)(value);
    valueRef.current = value;
    return [
        valueRef,
        setValue
    ];
}

});

parcelRegister("8Mpzk", function(module, exports) {

$parcel$export(module.exports, "keylineHeight", () => $b06cefa476e88eba$export$4c317248f944c2a9);
$parcel$export(module.exports, "keylineColor", () => $b06cefa476e88eba$export$d901150a4cc83165);

var $PdmhA = parcelRequire("PdmhA");
const $b06cefa476e88eba$export$4c317248f944c2a9 = 2;
const $b06cefa476e88eba$export$d901150a4cc83165 = `var(--ds-border, ${(0, $PdmhA.N30)})`;

});

parcelRegister("9qC0Z", function(module, exports) {

$parcel$export(module.exports, "rafSchedule", () => $52c224611b6de33b$export$3c6851d470650c35);
// Adapted from https://github.com/alexreardon/raf-schd/blob/master/src/index.js
const $52c224611b6de33b$export$3c6851d470650c35 = (fn)=>{
    let frameId = null;
    const wrapperFn = ()=>{
        // There is already a frame queued
        if (frameId) return;
        // Schedule a new frame
        frameId = requestAnimationFrame(()=>{
            frameId = null;
            fn();
        });
    };
    // Adding cancel property to result function
    wrapperFn.cancel = ()=>{
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};

});



parcelRegister("fmKuk", function(module, exports) {

$parcel$export(module.exports, "MiniBody", () => $a99b57ec38bc7484$export$b7d0c8df4a39a4c7);
$parcel$export(module.exports, "Mini", () => $a99b57ec38bc7484$export$87d5d88f89bf43b);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $kGQen = parcelRequire("kGQen");

var $9pngN = parcelRequire("9pngN");

var $jMP2a = parcelRequire("jMP2a");
var $2qZHF = parcelRequire("2qZHF");
parcelRequire("gya0p");
var $9Pqox = parcelRequire("9Pqox");
var $gya0p = parcelRequire("gya0p");

var $dQqKR = parcelRequire("dQqKR");
const $a99b57ec38bc7484$export$b7d0c8df4a39a4c7 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dQqKR.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a99b57ec38bc7484$var$MiniBodyWrapper, null, children));
const $a99b57ec38bc7484$export$87d5d88f89bf43b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, className: className, components: components }, ref)=>{
    const { Header: Header = (0, $eUqFw.Fragment), Footer: Footer = (0, $eUqFw.Fragment) } = components || {};
    const { isTransitionInState: isTransitionInState } = (0, $gya0p.useMinimizableModal)();
    const isViewEntered = isTransitionInState([
        'mini'
    ], (0, $9Pqox.TransitionState).ENTERED);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9pngN.JiraBottomRightCornerOutlet), {
        orderFromRight: 3,
        id: "issue-create-mini-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a99b57ec38bc7484$var$MiniWrapper, {
        ref: ref,
        // eslint-disable-next-line jira/react/no-classname-attribute, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-testid": !isViewEntered ? undefined : 'minimizable-modal.ui.modal-container.mini'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
        onMount: (0, $jMP2a.fireScreenAnalyticsDeferred)
    }), components ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Header, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a99b57ec38bc7484$export$b7d0c8df4a39a4c7, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Footer, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children))));
});
// eslint-disable-next-line  @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a99b57ec38bc7484$var$MiniWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb12hx _4t3i1diq _11q71bhr _1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _16qszotn _2rkoftgi",
            __cmplp.className
        ])
    });
});
const $a99b57ec38bc7484$var$MiniBodyWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt41azu",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9pngN", function(module, exports) {

$parcel$export(module.exports, "JiraBottomRightCornerOutlet", () => $c006a225e0f72214$export$ee54e6ed235df65e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lEfVV = parcelRequire("lEfVV");

var $ciZ8Y = parcelRequire("ciZ8Y");

var $71g00 = parcelRequire("71g00");
const $c006a225e0f72214$var$OutletWithPortal = ({ orderFromRight: orderFromRight, children: children, id: id })=>{
    const portalWrapper = (0, $eUqFw.useRef)(document.createElement('div'));
    const container = (0, $71g00.useBottomRightCornerContainer)();
    if (!container) throw new Error('GlobalBottomRightContainer could not be found. Please ensure that this container was rendered on the page.');
    const { insertBottomRightCornerPortal: insertBottomRightCornerPortal, removeBottomRightCornerPortal: removeBottomRightCornerPortal } = (0, $71g00.useBottomRightCornerActions)();
    (0, $eUqFw.useEffect)(()=>{
        if (container) {
            const indexToRender = insertBottomRightCornerPortal({
                orderFromRight: orderFromRight,
                id: id
            });
            // @ts-expect-error - TS2538 - Type 'Promise<void>' cannot be used as an index type. | TS2538 - Type 'void' cannot be used as an index type.
            container.insertBefore(portalWrapper.current, container.children[indexToRender]);
        }
        // required as eslint complains about the ref in cleanup function
        const portalCurrent = portalWrapper.current;
        return ()=>{
            container?.removeChild(portalCurrent);
            removeBottomRightCornerPortal(id);
        };
    }, [
        container,
        id,
        orderFromRight,
        insertBottomRightCornerPortal,
        removeBottomRightCornerPortal
    ]);
    return /*#__PURE__*/ (0, $lEfVV.createPortal)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c006a225e0f72214$var$StyledOutlet, null, children), portalWrapper.current);
};
const $c006a225e0f72214$export$ee54e6ed235df65e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ciZ8Y.ErrorBoundary), {
        id: "bottom-right-corner-outlet",
        packageName: "jira-bottom-right-corner-controller",
        extraEventData: {
            portalId: props.id
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c006a225e0f72214$var$OutletWithPortal, props));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c006a225e0f72214$var$StyledOutlet = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1vgl1wug _1ko9pxbi",
            __cmplp.className
        ])
    });
});

});

parcelRegister("dQqKR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b2ecb1c5f7b8029$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $51sCz = parcelRequire("51sCz");

var $1ybV0 = parcelRequire("1ybV0");

var $dWaVw = parcelRequire("dWaVw");

var $kaIyT = parcelRequire("kaIyT");

var $6vxSC = parcelRequire("6vxSC");

var $hYxbS = parcelRequire("hYxbS");

var $8I0fa = parcelRequire("8I0fa");
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ const $8b2ecb1c5f7b8029$var$ScrollContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { testId: testId, children: children, disableAutoTopKeyline: disableAutoTopKeyline = true, disableAutoBottomKeyline: disableAutoBottomKeyline = true } = props;
    const [hasSiblings, setSiblings] = (0, $6vxSC.default)({
        previous: false,
        next: false
    });
    const [showContentFocus, setContentFocus] = (0, $eUqFw.useState)(false);
    const [showTopKeyline, setTopKeyline] = (0, $eUqFw.useState)(false);
    const [showBottomKeyline, setBottomKeyline] = (0, $eUqFw.useState)(false);
    const scrollableRef = (0, $eUqFw.useRef)(null);
    const setLazySiblings = (0, $kaIyT.default)(setSiblings);
    const setLazyContentFocus = (0, $kaIyT.default)((0, $8I0fa.rafSchedule)(()=>{
        const target = scrollableRef.current;
        target && setContentFocus(target.scrollHeight > target.clientHeight);
    }));
    const setLazyKeylines = (0, $kaIyT.default)((0, $8I0fa.rafSchedule)(()=>{
        const target = scrollableRef.current;
        if (target) {
            const scrollableDistance = target.scrollHeight - target.clientHeight;
            if (hasSiblings.current.previous) setTopKeyline(target.scrollTop > (0, $hYxbS.keylineHeight));
            if (hasSiblings.current.next) setBottomKeyline(target.scrollTop <= scrollableDistance - (0, $hYxbS.keylineHeight));
        }
    }));
    (0, $eUqFw.useEffect)(()=>{
        const target = scrollableRef.current;
        window.addEventListener('resize', setLazyKeylines, false);
        target?.addEventListener('scroll', setLazyKeylines, false);
        setLazyContentFocus();
        setLazyKeylines();
        setLazySiblings({
            previous: Boolean(target?.previousElementSibling),
            next: Boolean(target?.nextElementSibling)
        });
        return ()=>{
            window.removeEventListener('resize', setLazyKeylines, false);
            target?.removeEventListener('scroll', setLazyKeylines, false);
        };
    }, [
        setLazyContentFocus,
        setLazyKeylines,
        setLazySiblings
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $51sCz.default), {
        isInset: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8b2ecb1c5f7b8029$var$ScrollContainerWrapper, {
        // eslint-disable-next-line styled-components-a11y/no-noninteractive-tabindex
        tabIndex: showContentFocus ? 0 : undefined,
        "data-testid": testId !== null && testId !== undefined && `${testId}--scrollable`,
        innerRef: (0, $dWaVw.default)([
            ref,
            scrollableRef
        ]),
        showTopKeyline: !disableAutoTopKeyline && showTopKeyline,
        showBottomKeyline: !disableAutoBottomKeyline && showBottomKeyline
    }, children));
});
$8b2ecb1c5f7b8029$var$ScrollContainer.displayName = 'ScrollContainer';
var $8b2ecb1c5f7b8029$export$2e2bcd8739ae039 = $8b2ecb1c5f7b8029$var$ScrollContainer;
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8b2ecb1c5f7b8029$var$ScrollContainerWrapper = /*#__PURE__*/ (0, $kwce8.default).div.attrs({
    // This is a false positive: https://product-fabric.atlassian.net/browse/USS-49
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles
    style: ({ showTopKeyline: showTopKeyline, showBottomKeyline: showBottomKeyline })=>({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            borderTop: `${showTopKeyline ? `${0, $hYxbS.keylineHeight}px solid ${0, $hYxbS.keylineColor}` : 'none'}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            borderBottom: `${showBottomKeyline ? `${0, $hYxbS.keylineHeight}px solid ${0, $hYxbS.keylineColor}` : 'none'}`
        })
}).withConfig({
    componentId: "sc-12dk2la-0"
})`display:inherit;margin:0;flex:inherit;flex-direction:inherit;${()=>(0, $1ybV0.ff)('gic-smart-fields-jira-labs_8uwvr') && 'flex-grow: 1;'} overflow-x:hidden;overflow-y:auto;@media (min-width:480px){height:unset;overflow-y:auto;}`;

});
parcelRegister("hYxbS", function(module, exports) {

$parcel$export(module.exports, "keylineHeight", () => $21149240542d0f7a$export$4c317248f944c2a9);
$parcel$export(module.exports, "keylineColor", () => $21149240542d0f7a$export$d901150a4cc83165);

var $PdmhA = parcelRequire("PdmhA");
const $21149240542d0f7a$export$4c317248f944c2a9 = 2;
const $21149240542d0f7a$export$d901150a4cc83165 = `var(--ds-border, ${(0, $PdmhA.N30)})`;

});

parcelRegister("8I0fa", function(module, exports) {

$parcel$export(module.exports, "rafSchedule", () => $97fd6b57627c1913$export$3c6851d470650c35);
// Adapted from https://github.com/alexreardon/raf-schd/blob/master/src/index.js
const $97fd6b57627c1913$export$3c6851d470650c35 = (fn)=>{
    let frameId = null;
    const wrapperFn = ()=>{
        // There is already a frame queued
        if (frameId) return;
        // Schedule a new frame
        frameId = requestAnimationFrame(()=>{
            frameId = null;
            fn();
        });
    };
    // Adding cancel property to result function
    wrapperFn.cancel = ()=>{
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};

});



parcelRegister("bG3FB", function(module, exports) {

$parcel$export(module.exports, "MiniTransition", () => $9011315634e25a99$export$1f36cb33f56bd06e);

var $eUqFw = parcelRequire("eUqFw");

var $lSV8Z = parcelRequire("lSV8Z");
var $hYDGa = parcelRequire("hYDGa");
var $8YJjX = parcelRequire("8YJjX");


var $cdJmq = parcelRequire("cdJmq");
const $9011315634e25a99$export$1f36cb33f56bd06e = ({ children: children, renderCondition: renderCondition })=>{
    const { onFinishAnimation: onFinishAnimation, shouldRenderView: shouldRenderView } = (0, $cdJmq.useTransitionView)('mini', renderCondition);
    if ((0, $8YJjX.isReducedMotion)()) {
        if (renderCondition) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children({
            transitionProps: {}
        }));
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lSV8Z.default), null, shouldRenderView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hYDGa.default), {
        entranceDirection: "bottom",
        exitDirection: "bottom",
        duration: (0, $06fdedeca8586601$export$3749e1104328fde4),
        onFinish: onFinishAnimation
    }, (fadeInProps)=>children({
            transitionProps: {
                ...fadeInProps
            }
        })));
};

});

parcelRegister("bvunr", function(module, exports) {

$parcel$export(module.exports, "Minimized", () => $2a138dcc9181297a$export$b41d27d203c8df67);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $51sCz = parcelRequire("51sCz");

var $dEMIg = parcelRequire("dEMIg");

var $9pngN = parcelRequire("9pngN");

var $jMP2a = parcelRequire("jMP2a");
var $2qZHF = parcelRequire("2qZHF");
var $bFzGY = parcelRequire("bFzGY");

var $fiNz6 = parcelRequire("fiNz6");
parcelRequire("gya0p");
var $9Pqox = parcelRequire("9Pqox");
var $gya0p = parcelRequire("gya0p");
const $2a138dcc9181297a$export$b41d27d203c8df67 = ({ children: children, isItalic: isItalic, className: className })=>{
    const { unminimizeModal: unminimizeModal, previousView: previousView, isTransitionInState: isTransitionInState, setShouldFocusChanger: setShouldFocusChanger } = (0, $gya0p.useMinimizableModal)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { minimizedButtonRef: minimizedButtonRef, onKeyDown: onKeyDown, wrapperRef: wrapperRef } = (0, $fiNz6.useEnterFocusState)();
    const isViewEntered = isTransitionInState([
        'minimized'
    ], (0, $9Pqox.TransitionState).ENTERED);
    const unminimize = ()=>{
        if (!isViewEntered) return;
        setShouldFocusChanger(true);
        unminimizeModal('modal');
        const analyticsEvent = createAnalyticsEvent({
            action: 'container clicked',
            actionSubject: 'minimized'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
            source: 'globalIssueCreateModal',
            previousGICViewState: previousView
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9pngN.JiraBottomRightCornerOutlet), {
        orderFromRight: 3,
        id: "issue-create-minimised-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2a138dcc9181297a$var$MinimizedOuterWrapper, {
        id: (0, $dEMIg.MINIMISED_DROPZONE_CONTAINER_ID),
        tabIndex: -1,
        ref: wrapperRef,
        "data-testid": // testid should only be available when view is not transitioning
        // otherwise CY tries to click the view before its last position
        isViewEntered ? 'minimizable-modal.ui.modal-container.minimized-outer-wrapper' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
        onMount: (0, $jMP2a.fireScreenAnalyticsDeferred)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $51sCz.default), {
        isInset: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2a138dcc9181297a$var$MinimizedWrapper, {
        // @ts-expect-error - TS2322 - Type '((instance: MinimizedContainerProps | null) => void) | MutableRefObject<MinimizedContainerProps | null> | null' is not assignable to type '((string | ((instance: Component<ThemedOuterStyledProps<DiffBetween<{ className: any; }, ClassAttributes<HTMLButtonElement> & ButtonHTMLAttributes<HTMLButtonElement>>, any>, any, any> | null) => void) | RefObject<...>) & (string | ... 1 more ... | RefObject<...>)) | null | undefined'.
        ref: minimizedButtonRef,
        "data-testid": isViewEntered ? 'minimizable-modal.ui.modal-container.minimized' : undefined,
        onKeyDown: onKeyDown,
        onClick: unminimize,
        isItalic: isItalic,
        // eslint-disable-next-line jira/react/no-classname-attribute, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2a138dcc9181297a$var$MinimizedText, null, children)))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a138dcc9181297a$var$MinimizedWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19itidpf _vchhusvi _11q7hp5a _4t3ickbl _1bsb1mjv _2rkoftgi _1e0c1txw _4cvr1h6o _1yt4119w _80omtlke _v5649dqc _16qs6ae0 _1spjglyw _ymio1r31 _ypr0glyw _zcxs1o36 _19lcxwku _1dit1r31 _ksodglyw _4hz81o36 _j6xtxwku _1q5t1r31 _1ohyglyw _1r9x1o36",
            __cmplp.className
        ])
    });
});
const $2a138dcc9181297a$var$MinimizedText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bto1l2s _o5721q9c _1reo15vq _18m915vq _syaz2l1e _11c81bk4",
            __cmplp.className
        ])
    });
});
const $2a138dcc9181297a$var$MinimizedOuterWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fiNz6", function(module, exports) {

$parcel$export(module.exports, "useEnterFocusState", () => $25d44f2634915764$export$cda941d4347e19b6);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");
parcelRequire("gya0p");
var $9Pqox = parcelRequire("9Pqox");
var $gya0p = parcelRequire("gya0p");
const $25d44f2634915764$var$minimizedViews = [
    'minimized',
    'ai-enabled-minimized'
];
const $25d44f2634915764$export$cda941d4347e19b6 = ()=>{
    const { view: view, setTransitionByKeyboardFrom: setTransitionByKeyboardFrom, transitionByKeyboardFrom: transitionByKeyboardFrom, isTransitionInState: isTransitionInState, shouldFocusChanger: shouldFocusChanger, setShouldFocusChanger: setShouldFocusChanger } = (0, $gya0p.useMinimizableModal)();
    // Keep refs in this order in order not to affect the unit tests
    const minimizedButtonRef = (0, $eUqFw.useRef)(null);
    const modalButtonRef = (0, $eUqFw.useRef)(null);
    const miniButtonRef = (0, $eUqFw.useRef)(null);
    const aiEnabledButtonRef = (0, $eUqFw.useRef)(null);
    const aiEnabledMinimizedButtonRef = (0, $eUqFw.useRef)(null);
    const wrapperRef = (0, $eUqFw.useRef)(null);
    const [init, setInit] = (0, $eUqFw.useState)(false);
    const isViewEntered = isTransitionInState([
        view
    ], (0, $9Pqox.TransitionState).ENTERED);
    const onKeyDown = (0, $eUqFw.useCallback)((ev)=>{
        if (!isViewEntered) return;
        // 13: Enter Key; 32: Space Key
        setTransitionByKeyboardFrom([
            13,
            32
        ].includes(ev.keyCode) ? view : null);
    }, [
        setTransitionByKeyboardFrom,
        isViewEntered,
        view
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!init && isViewEntered && shouldFocusChanger) {
            setInit(true);
            setShouldFocusChanger(false);
            const buttonRef = (0, $1ybV0.ff)('jira-intelligent-issue-breakdown_18syl') ? {
                modal: modalButtonRef.current,
                mini: miniButtonRef.current,
                minimized: minimizedButtonRef.current,
                'ai-enabled': aiEnabledButtonRef.current,
                'ai-enabled-minimized': aiEnabledMinimizedButtonRef.current,
                fullscreen: null
            } : {
                modal: modalButtonRef.current,
                mini: miniButtonRef.current,
                minimized: minimizedButtonRef.current,
                fullscreen: null
            };
            requestAnimationFrame(()=>{
                let buttonToFocus = transitionByKeyboardFrom !== null && view === 'minimized' ? 'minimized' : transitionByKeyboardFrom;
                if ((0, $1ybV0.ff)('jira-intelligent-issue-breakdown_18syl')) buttonToFocus = transitionByKeyboardFrom !== null && $25d44f2634915764$var$minimizedViews.includes(view) ? view : transitionByKeyboardFrom;
                if (buttonToFocus && buttonRef[buttonToFocus]) {
                    // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                    buttonRef[buttonToFocus].focus();
                    setTransitionByKeyboardFrom(null);
                } else if (wrapperRef.current) wrapperRef.current.focus();
            });
        }
    }, [
        transitionByKeyboardFrom,
        setTransitionByKeyboardFrom,
        init,
        view,
        isViewEntered,
        shouldFocusChanger,
        setShouldFocusChanger,
        aiEnabledMinimizedButtonRef
    ]);
    return {
        onKeyDown: onKeyDown,
        minimizedButtonRef: minimizedButtonRef,
        modalButtonRef: modalButtonRef,
        miniButtonRef: miniButtonRef,
        wrapperRef: wrapperRef
    };
};

});


parcelRegister("dxjRg", function(module, exports) {

$parcel$export(module.exports, "MinimizedTransition", () => $3155007f57ccbe54$export$a483cc235b11f289);

var $eUqFw = parcelRequire("eUqFw");

var $lSV8Z = parcelRequire("lSV8Z");
var $hYDGa = parcelRequire("hYDGa");
var $8YJjX = parcelRequire("8YJjX");


var $cdJmq = parcelRequire("cdJmq");
const $3155007f57ccbe54$export$a483cc235b11f289 = ({ children: children, renderCondition: renderCondition })=>{
    const { onFinishAnimation: onFinishAnimation, shouldRenderView: shouldRenderView } = (0, $cdJmq.useTransitionView)('minimized', renderCondition);
    if ((0, $8YJjX.isReducedMotion)()) {
        if (renderCondition) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children({
            transitionProps: {}
        }));
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lSV8Z.default), null, shouldRenderView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hYDGa.default), {
        entranceDirection: "bottom",
        exitDirection: "bottom",
        duration: (0, $06fdedeca8586601$export$3749e1104328fde4),
        onFinish: onFinishAnimation
    }, (fadeInProps)=>children({
            transitionProps: {
                ...fadeInProps
            }
        })));
};

});

parcelRegister("jkyV3", function(module, exports) {

$parcel$export(module.exports, "Modal", () => $c877ea8e6380db4d$export$2b77a92f1a5ad772);

var $eUqFw = parcelRequire("eUqFw");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");

var $8YJjX = parcelRequire("8YJjX");

var $kGQen = parcelRequire("kGQen");

var $1ybV0 = parcelRequire("1ybV0");

var $jMP2a = parcelRequire("jMP2a");
var $2qZHF = parcelRequire("2qZHF");
parcelRequire("gya0p");
var $9Pqox = parcelRequire("9Pqox");
var $gya0p = parcelRequire("gya0p");

var $cdJmq = parcelRequire("cdJmq");
const $c877ea8e6380db4d$export$2b77a92f1a5ad772 = ({ children: children, components: components, onClose: onCloseFromProps, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, 'data-testid': dataTestId, ...rest })=>{
    const { onClose: onClose, isTransitionInState: isTransitionInState } = (0, $gya0p.useMinimizableModal)();
    const { onFinishAnimation: onFinishAnimation } = (0, $cdJmq.useTransitionView)('modal', true);
    const onOpenComplete = ()=>{
        onFinishAnimation('entering');
    };
    const onCloseComplete = ()=>{
        onFinishAnimation('exiting');
    };
    const isViewEntered = isTransitionInState([
        'modal'
    ], (0, $9Pqox.TransitionState).ENTERED);
    const { Header: Header = (0, $eUqFw.Fragment), Body: Body = (0, $lfiOu.default), Footer: Footer = (0, $eUqFw.Fragment) } = components || {};
    const onMount = (0, $eUqFw.useCallback)((event)=>{
        (0, $jMP2a.fireScreenAnalyticsDeferred)(event, {
            isReducedMotion: (0, $8YJjX.isReducedMotion)()
        });
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        width: "large",
        height: (0, $1ybV0.ff)('gic-smart-fields-jira-labs_8uwvr') ? undefined : '100vh',
        autoFocus: false,
        onClose: onCloseFromProps || onClose,
        shouldCloseOnEscapePress: true,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        testId: isViewEntered ? dataTestId || 'minimizable-modal.ui.modal-container.modal' : undefined,
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete,
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
        onMount: onMount
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Header, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Body, null, children === undefined ? null : children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Footer, null)));
};

});

parcelRegister("76zGC", function(module, exports) {

$parcel$export(module.exports, "ModalHeader", () => $ba5470921fadddd5$export$f50a68e3694789ee);
$parcel$export(module.exports, "MiniHeader", () => $ba5470921fadddd5$export$1d38987b2afcba7e);
$parcel$export(module.exports, "ModalTitle", () => $ba5470921fadddd5$export$b26fae16ba5468aa);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $jWuk1 = parcelRequire("jWuk1");

var $22LS1 = parcelRequire("22LS1");

var $dEoAQ = parcelRequire("dEoAQ");

var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $8cU5f = parcelRequire("8cU5f");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $bjdFD = parcelRequire("bjdFD");

var $fiNz6 = parcelRequire("fiNz6");
parcelRequire("gya0p");
var $9Pqox = parcelRequire("9Pqox");
var $gya0p = parcelRequire("gya0p");

var $03e9j = parcelRequire("03e9j");

var $fcSf9 = parcelRequire("fcSf9");
const $ba5470921fadddd5$export$b89ab188a65746a6 = ({ isMini: isMini = false, ViewChangerContainer: ViewChangerContainer })=>{
    const { view: view, setView: setView, onClose: onClose, isTransitionInState: isTransitionInState, setShouldFocusChanger: setShouldFocusChanger, displayMinimizableButtons: displayMinimizableButtons } = (0, $gya0p.useMinimizableModal)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { minimizedButtonRef: minimizedButtonRef, modalButtonRef: modalButtonRef, miniButtonRef: miniButtonRef, wrapperRef: wrapperRef, onKeyDown: onKeyDown } = (0, $fiNz6.useEnterFocusState)();
    const onViewChange = (0, $eUqFw.useCallback)((newView)=>()=>{
            if (!isTransitionInState([
                view
            ], (0, $9Pqox.TransitionState).ENTERED)) return;
            setShouldFocusChanger(true);
            setView(newView);
            const analyticsEvent = createAnalyticsEvent({
                action: 'button clicked',
                actionSubject: newView
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
                source: 'globalIssueCreateModal',
                previousGICViewState: view
            });
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        setView,
        isTransitionInState
    ]);
    const onUpdateView = (0, $eUqFw.useCallback)((newView)=>{
        if (!isTransitionInState([
            view
        ], (0, $9Pqox.TransitionState).ENTERED)) return;
        setShouldFocusChanger(true);
        setView(newView);
        const analyticsEvent = createAnalyticsEvent({
            action: 'button clicked',
            actionSubject: newView
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
            source: 'globalIssueCreateModal',
            previousGICViewState: view
        });
    }, [
        isTransitionInState,
        view,
        setShouldFocusChanger,
        setView,
        createAnalyticsEvent
    ]);
    const onViewChangeToMinimized = (0, $eUqFw.useCallback)(()=>onUpdateView('minimized'), [
        onUpdateView
    ]);
    const onViewChangeToMini = (0, $eUqFw.useCallback)(()=>onUpdateView('mini'), [
        onUpdateView
    ]);
    const onViewChangeToModal = (0, $eUqFw.useCallback)(()=>onUpdateView('modal'), [
        onUpdateView
    ]);
    const { shouldDisableViewChangerButtons: shouldDisableViewChangerButtons, customDisabledViewChangerButtonsMessage: customDisabledViewChangerButtonsMessage } = (0, $gya0p.useMinimizableModal)();
    (0, $eUqFw.useEffect)(()=>{
        if (shouldDisableViewChangerButtons) (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'disabled',
            actionSubject: 'view changer buttons'
        }));
    }, [
        createAnalyticsEvent,
        customDisabledViewChangerButtonsMessage,
        shouldDisableViewChangerButtons
    ]);
    (0, $bjdFD.useNestedModalDetector)();
    const Wrapper = ViewChangerContainer || (0, $eUqFw.Fragment);
    const ButtonWrapper = isMini ? $ba5470921fadddd5$var$MiniButtonWrapper : $ba5470921fadddd5$var$ModalButtonWrapper;
    const expandMessage = (0, $fcSf9.default).fullScreen;
    const dockMessage = (0, $fcSf9.default).fullScreenExit;
    const dockDisabledMessage = (0, $fcSf9.default).fullScreenExitDisabled;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ba5470921fadddd5$var$ViewChangerWrapper, {
        tabIndex: -1,
        ref: wrapperRef,
        isMini: isMini,
        "data-testid": "minimizable-modal.ui.modal-container.modal-header.view-changer-wrapper"
    }, !displayMinimizableButtons ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        "data-testid": "minimizable-modal.ui.modal-container.modal-header.tool-tip",
        position: "top",
        content: shouldDisableViewChangerButtons ? customDisabledViewChangerButtonsMessage || formatMessage((0, $fcSf9.default).minimizeDisabled) : formatMessage((0, $fcSf9.default).minimize)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ba5470921fadddd5$var$ToolbarButton, {
        testId: "minimizable-modal.ui.modal-container.modal-header.minimized-button",
        onClick: (0, $1ybV0.ff)('fix-failed-to-remove-node-error-gic_vifyb') ? onViewChangeToMinimized : onViewChange('minimized'),
        onKeyDown: onKeyDown,
        spacing: "none",
        ref: minimizedButtonRef,
        isDisabled: shouldDisableViewChangerButtons,
        isMini: isMini
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $03e9j.MinimizeIcon), {
        label: formatMessage((0, $fcSf9.default).minimize)
    })))), !isMini && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        "data-testid": "minimizable-modal.ui.modal-container.modal-header.tool-tip",
        position: "top",
        content: shouldDisableViewChangerButtons ? customDisabledViewChangerButtonsMessage || formatMessage(dockDisabledMessage) : formatMessage(dockMessage)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ba5470921fadddd5$var$ToolbarButton, {
        testId: "minimizable-modal.ui.modal-container.modal-header.mini-button",
        onClick: (0, $1ybV0.ff)('fix-failed-to-remove-node-error-gic_vifyb') ? onViewChangeToMini : onViewChange('mini'),
        onKeyDown: onKeyDown,
        spacing: "none",
        ref: miniButtonRef,
        isDisabled: shouldDisableViewChangerButtons
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dEoAQ))), {
        label: formatMessage(dockMessage)
    })))), isMini && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        position: "top",
        content: formatMessage(expandMessage)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ba5470921fadddd5$var$ToolbarButton, {
        testId: "minimizable-modal.ui.modal-container.modal-header.modal-button",
        onClick: (0, $1ybV0.ff)('fix-failed-to-remove-node-error-gic_vifyb') ? onViewChangeToModal : onViewChange('modal'),
        onKeyDown: onKeyDown,
        spacing: "none",
        ref: modalButtonRef,
        isMini: isMini
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($22LS1))), {
        label: formatMessage(expandMessage)
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        position: "top",
        content: formatMessage((0, $fcSf9.default).close)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ba5470921fadddd5$var$ToolbarButton, {
        testId: "minimizable-modal.ui.modal-container.modal-header.close-button",
        onClick: onClose,
        spacing: "none",
        isMini: isMini
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jWuk1))), {
        label: formatMessage((0, $fcSf9.default).close)
    }))))));
};
const $ba5470921fadddd5$export$f50a68e3694789ee = ({ children: children, ViewChangerContainer: ViewChangerContainer, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ba5470921fadddd5$var$HeaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), rest, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ba5470921fadddd5$export$b89ab188a65746a6, {
        ViewChangerContainer: ViewChangerContainer
    })));
const $ba5470921fadddd5$export$1d38987b2afcba7e = ({ children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ba5470921fadddd5$var$MiniHeaderWrapper, rest, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ba5470921fadddd5$export$b89ab188a65746a6, {
        isMini: true
    }));
const $ba5470921fadddd5$export$b26fae16ba5468aa = (props)=>{
    const { view: view } = (0, $gya0p.useMinimizableModal)();
    if (view === 'mini' || view === 'minimized' || (0, $1ybV0.ff)('jira-intelligent-issue-breakdown_18syl') && view === 'ai-enabled') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ba5470921fadddd5$var$MiniTitle, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", props);
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ba5470921fadddd5$var$ViewChangerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isMini: isMini, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1bahesu3 _1o9zidpf _nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.isMini && "_u5f31b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @typescript-eslint/no-explicit-any, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ba5470921fadddd5$var$HeaderWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otcopxbi _17ugpxbi _1eompxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ba5470921fadddd5$var$MiniHeaderWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o _1bahesu3 _syaz1fxt _n7zl1ktc _16qs1bc2 _18s8s8vo _1yt4rd6f",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ba5470921fadddd5$var$MiniTitle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1fxt _1wybdlk8 _k48pni7l _1yt4h8dc _1o9zkb7n _16jlkb7n _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ba5470921fadddd5$var$ModalButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s8n8ld _vwz4kb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ba5470921fadddd5$var$MiniButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vwz4kb7n",
            __cmplp.className
        ])
    });
}); // Setting pointer-events = 'none' to prevent the button from
const $ba5470921fadddd5$var$DISABLED_STYLED_NEW = {
    pointsEvents: 'none'
}; // Atlaskit does not have a solution for using tooltips for disabled buttons.
// Workaround to allow tooltip on disabled buttons, technically a design anti-pattern
// The button must be wrapped in a div and the button must have pointer-events set to none when disabled.
// Setting the pointer-events to none sets the pointer to default state, it will look slightly different than before (accepted by design).
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ba5470921fadddd5$var$ToolbarButtonExperiment = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_17521tcg _w8l51tcg _6q2615yo _gncu15yo _ujqd15yo _t7bl15yo",
            __cmplp.isMini && "_rcujt94y _o81ct94y _1l6ut94y _149mt94y _1dlt1l7b _w8sq1l7b _fjwr1l7b _1yxx1l7b _6q26idpf _gncuidpf _ujqdidpf _t7blidpf",
            __cmplp.className
        ])
    });
}); // styledComponentWithCondition and @compiled returns a functional component so we need to wrap the
const $ba5470921fadddd5$var$ToolbarButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ appearance: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
appearance = 'subtle', ...rest }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ba5470921fadddd5$var$ToolbarButtonExperiment, {
        appearance: appearance,
        ...rest,
        ref: ref
    }));

});
parcelRegister("22LS1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $17d0e6b497755428$var$_react = $17d0e6b497755428$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $17d0e6b497755428$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $17d0e6b497755428$var$MediaServicesActualSizeIcon = (props)=>/*#__PURE__*/ $17d0e6b497755428$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M16.587 6.003H15A1 1 0 0115 4h3.9l.047.001a.975.975 0 01.736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 11-2 0V7.411l-3.309 3.308a.977.977 0 01-1.374-.005l-.032-.032a.976.976 0 01-.005-1.374l3.307-3.305zM7.413 17.997H9A1 1 0 019 20H5.1l-.047-.001a.975.975 0 01-.736-.285l-.032-.032A.977.977 0 014 18.946a1.12 1.12 0 010-.048v-3.896a1 1 0 112 0v1.587l3.309-3.308a.977.977 0 011.374.005l.032.032a.976.976 0 01.005 1.374l-3.307 3.305z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$17d0e6b497755428$var$MediaServicesActualSizeIcon.displayName = 'MediaServicesActualSizeIcon';
var $17d0e6b497755428$var$_default = $17d0e6b497755428$var$MediaServicesActualSizeIcon;
module.exports.default = $17d0e6b497755428$var$_default;

});

parcelRegister("dEoAQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9f02168594689cb7$var$_react = $9f02168594689cb7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $2ziLQ = parcelRequire("2ziLQ");
function $9f02168594689cb7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $9f02168594689cb7$var$VidFullScreenOffIcon = (props)=>/*#__PURE__*/ $9f02168594689cb7$var$_react.default.createElement($2ziLQ.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M9 15.003v2.995a1 1 0 102 0v-3.896C11 13.494 10.507 13 9.9 13H6a1 1 0 000 2.003h3z" fill-rule="nonzero"/><path d="M3.74 20.294a.997.997 0 001.407.005l5.152-5.152a1 1 0 00-.005-1.407l-.034-.034a.997.997 0 00-1.407-.005l-5.152 5.152a1 1 0 00.005 1.407l.034.034z" fill-rule="nonzero"/><path d="M19.067 3.321L13.32 9.066a1.115 1.115 0 00.005 1.57l.036.037a1.112 1.112 0 001.571.005l5.747-5.744a1.116 1.116 0 00-.006-1.57l-.037-.037a1.117 1.117 0 00-1.57-.006z"/><path d="M13 6.002v3.896c0 .608.493 1.102 1.1 1.102H18a1 1 0 000-2.003h-3V6.002a1 1 0 10-2 0z"/></g></svg>`
    }, props));
$9f02168594689cb7$var$VidFullScreenOffIcon.displayName = 'VidFullScreenOffIcon';
var $9f02168594689cb7$var$_default = $9f02168594689cb7$var$VidFullScreenOffIcon;
module.exports.default = $9f02168594689cb7$var$_default;

});

parcelRegister("bjdFD", function(module, exports) {

$parcel$export(module.exports, "useNestedModalDetector", () => $eb9dd753aeab09be$export$d9e46b281508f5e9);

var $eUqFw = parcelRequire("eUqFw");

var $gya0p = parcelRequire("gya0p");
const $eb9dd753aeab09be$export$d9e46b281508f5e9 = ()=>{
    const { setIsNestedModal: setIsNestedModal } = (0, $gya0p.useMinimizableModal)();
    (0, $eUqFw.useEffect)(()=>{
        const modalElements = document.querySelectorAll('div.atlaskit-portal [aria-modal="true"]');
        if (modalElements.length > 1) setIsNestedModal(true);
    }, [
        setIsNestedModal
    ]);
};

});

parcelRegister("03e9j", function(module, exports) {

$parcel$export(module.exports, "MinimizeIcon", () => $5b4ffdb57c95ef8e$export$95300d23f5f56d39);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $5b4ffdb57c95ef8e$export$ab3e03e3b7ae2f0c = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        fillOpacity: "0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M18.6667 16C19.403 16 20 16.4477 20 17C20 17.5128 19.4853 17.9355 18.8221 17.9933L18.6667 18H5.33333C4.59695 18 4 17.5523 4 17C4 16.4872 4.51474 16.0645 5.17786 16.0067L5.33333 16H18.6667Z",
        fill: "currentColor"
    }));
const $5b4ffdb57c95ef8e$export$95300d23f5f56d39 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $5b4ffdb57c95ef8e$export$ab3e03e3b7ae2f0c,
        // @ts-expect-error - TS2322 - Type '"small" | "medium" | "large" | "xlarge" | null' is not assignable to type 'Size | undefined'.
        size: props.size || null,
        label: props.label,
        primaryColor: props.primaryColor
    });

});

parcelRegister("fcSf9", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfde47a73ba9b99d$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $dfde47a73ba9b99d$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    minimize: {
        "id": "minimizable-modal.modal-container.modal-header.minimize",
        "defaultMessage": "Minimize"
    },
    minimizeDisabled: {
        "id": "minimizable-modal.modal-container.modal-header.minimize-disabled",
        "defaultMessage": "Can't minimize this view"
    },
    dock: {
        "id": "minimizable-modal.modal-container.modal-header.dock",
        "defaultMessage": "Dock to bottom"
    },
    dockDisabled: {
        "id": "minimizable-modal.modal-container.modal-header.dock-disabled",
        "defaultMessage": "Can't dock this view"
    },
    fullScreenExit: {
        "id": "minimizable-modal.modal-container.modal-header.full-screen-exit",
        "defaultMessage": "Exit full screen"
    },
    fullScreenExitDisabled: {
        "id": "minimizable-modal.modal-container.modal-header.full-screen-exit-disabled",
        "defaultMessage": "Can't exit full screen"
    },
    expand: {
        "id": "minimizable-modal.modal-container.modal-header.expand",
        "defaultMessage": "Expand"
    },
    fullScreen: {
        "id": "minimizable-modal.modal-container.modal-header.full-screen",
        "defaultMessage": "Go full screen"
    },
    close: {
        "id": "minimizable-modal.modal-container.modal-header.close",
        "defaultMessage": "Close"
    },
    onboardingSpotlightTitle: {
        "id": "minimizable-modal.modal-container.modal-header.onboarding-spotlight-title",
        "defaultMessage": "Welcome to the new issue create experience"
    },
    onboardingSpotlightActionGotIt: {
        "id": "minimizable-modal.modal-container.modal-header.onboarding-spotlight-action-got-it",
        "defaultMessage": "Got it"
    },
    onboardingSpotlightActionLearnMore: {
        "id": "minimizable-modal.modal-container.modal-header.onboarding-spotlight-action-learn-more",
        "defaultMessage": "Learn more"
    },
    onboardingSpotlightDescription: {
        "id": "minimizable-modal.modal-container.modal-header.onboarding-spotlight-description",
        "defaultMessage": "A consistent, fast, and optimized way to capture work in your project."
    }
});

});


parcelRegister("bMDI2", function(module, exports) {

$parcel$export(module.exports, "ModalTransition", () => $f21794bf4ec9d0c2$export$f0a3ab1cc2e7e9a6);

var $eUqFw = parcelRequire("eUqFw");

var $dxopF = parcelRequire("dxopF");

var $8YJjX = parcelRequire("8YJjX");
parcelRequire("gya0p");
var $9Pqox = parcelRequire("9Pqox");
var $gya0p = parcelRequire("gya0p");
const $f21794bf4ec9d0c2$export$f0a3ab1cc2e7e9a6 = ({ children: children, renderCondition: renderCondition })=>{
    const { isTransitionInState: isTransitionInState } = (0, $gya0p.useMinimizableModal)();
    if ((0, $8YJjX.isReducedMotion)()) {
        if (renderCondition) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
        return null;
    }
    const shouldRenderModalView = renderCondition && isTransitionInState([
        'mini',
        'minimized'
    ], (0, $9Pqox.TransitionState).EXITED);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dxopF.default), null, shouldRenderModalView && children);
};

});


parcelRegister("145Wp", function(module, exports) {

$parcel$export(module.exports, "ReParenter", () => $777c3ba6e290a823$export$c74b59dc6ffb3f46);

var $eUqFw = parcelRequire("eUqFw");

var $4fnM8 = parcelRequire("4fnM8");

var $etCs9 = parcelRequire("etCs9");

var $XHGTv = parcelRequire("XHGTv");
const $777c3ba6e290a823$export$c74b59dc6ffb3f46 = ({ children: children, Parent: Parent })=>{
    const portalNode = (0, $eUqFw.useMemo)(()=>(0, $4fnM8.createHtmlPortalNode)(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4fnM8.InPortal), {
        node: portalNode
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $etCs9.UNSAFE_LAYERING), {
        isDisabled: (0, $XHGTv.getBooleanFF)('platform.design-system-team.layering_qmiw3') ? false : undefined
    }, children)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Parent, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4fnM8.OutPortal), {
        node: portalNode
    })));
};

});
parcelRegister("4fnM8", function(module, exports) {

$parcel$export(module.exports, "InPortal", () => $317b0168a876e55d$export$82590d10982cb172);
$parcel$export(module.exports, "OutPortal", () => $317b0168a876e55d$export$6677f336551ad316);
$parcel$export(module.exports, "createHtmlPortalNode", () => $317b0168a876e55d$export$c08cb61f0c65e152);

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");
var $317b0168a876e55d$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
// Internally, the portalNode must be for either HTML or SVG elements
var $317b0168a876e55d$var$ELEMENT_TYPE_HTML = 'html';
var $317b0168a876e55d$var$ELEMENT_TYPE_SVG = 'svg';
// ReactDOM can handle several different namespaces, but they're not exported publicly
// https://github.com/facebook/react/blob/b87aabdfe1b7461e7331abb3601d9e6bb27544bc/packages/react-dom/src/shared/DOMNamespaces.js#L8-L10
var $317b0168a876e55d$var$SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
var $317b0168a876e55d$var$validateElementType = function(domElement, elementType) {
    if (elementType === $317b0168a876e55d$var$ELEMENT_TYPE_HTML) return domElement instanceof HTMLElement;
    if (elementType === $317b0168a876e55d$var$ELEMENT_TYPE_SVG) return domElement instanceof SVGElement;
    throw new Error("Unrecognized element type \"" + elementType + "\" for validateElementType.");
};
// This is the internal implementation: the public entry points set elementType to an appropriate value
var $317b0168a876e55d$var$createPortalNode = function(elementType, options) {
    var initialProps = {};
    var parent;
    var lastPlaceholder;
    var element;
    if (elementType === $317b0168a876e55d$var$ELEMENT_TYPE_HTML) element = document.createElement('div');
    else if (elementType === $317b0168a876e55d$var$ELEMENT_TYPE_SVG) element = document.createElementNS($317b0168a876e55d$var$SVG_NAMESPACE, 'g');
    else throw new Error("Invalid element type \"" + elementType + "\" for createPortalNode: must be \"html\" or \"svg\".");
    if (options && typeof options === "object") for(var _i = 0, _a = Object.entries(options.attributes); _i < _a.length; _i++){
        var _b = _a[_i], key = _b[0], value = _b[1];
        element.setAttribute(key, value);
    }
    var portalNode = {
        element: element,
        elementType: elementType,
        setPortalProps: function(props) {
            initialProps = props;
        },
        getInitialPortalProps: function() {
            return initialProps;
        },
        mount: function(newParent, newPlaceholder) {
            if (newPlaceholder === lastPlaceholder) // Already mounted - noop.
            return;
            portalNode.unmount();
            // To support SVG and other non-html elements, the portalNode's elementType needs to match
            // the elementType it's being rendered into
            if (newParent !== parent) {
                if (!$317b0168a876e55d$var$validateElementType(newParent, elementType)) throw new Error("Invalid element type for portal: \"" + elementType + "\" portalNodes must be used with " + elementType + " elements, but OutPortal is within <" + newParent.tagName + ">.");
            }
            newParent.replaceChild(portalNode.element, newPlaceholder);
            parent = newParent;
            lastPlaceholder = newPlaceholder;
        },
        unmount: function(expectedPlaceholder) {
            if (expectedPlaceholder && expectedPlaceholder !== lastPlaceholder) // Skip unmounts for placeholders that aren't currently mounted
            // They will have been automatically unmounted already by a subsequent mount()
            return;
            if (parent && lastPlaceholder) {
                parent.replaceChild(lastPlaceholder, portalNode.element);
                parent = undefined;
                lastPlaceholder = undefined;
            }
        }
    };
    return portalNode;
};
var $317b0168a876e55d$export$82590d10982cb172 = /** @class */ function(_super) {
    $317b0168a876e55d$var$__extends(InPortal, _super);
    function InPortal(props) {
        var _this = _super.call(this, props) || this;
        _this.addPropsChannel = function() {
            Object.assign(_this.props.node, {
                setPortalProps: function(props) {
                    // Rerender the child node here if/when the out portal props change
                    _this.setState({
                        nodeProps: props
                    });
                }
            });
        };
        _this.state = {
            nodeProps: _this.props.node.getInitialPortalProps()
        };
        return _this;
    }
    InPortal.prototype.componentDidMount = function() {
        this.addPropsChannel();
    };
    InPortal.prototype.componentDidUpdate = function() {
        this.addPropsChannel();
    };
    InPortal.prototype.render = function() {
        var _this = this;
        var _a = this.props, children = _a.children, node = _a.node;
        return $lEfVV.createPortal($eUqFw.Children.map(children, function(child) {
            if (!$eUqFw.isValidElement(child)) return child;
            return $eUqFw.cloneElement(child, _this.state.nodeProps);
        }), node.element);
    };
    return InPortal;
}($eUqFw.PureComponent);
var $317b0168a876e55d$export$6677f336551ad316 = /** @class */ function(_super) {
    $317b0168a876e55d$var$__extends(OutPortal, _super);
    function OutPortal(props) {
        var _this = _super.call(this, props) || this;
        _this.placeholderNode = $eUqFw.createRef();
        _this.passPropsThroughPortal();
        return _this;
    }
    OutPortal.prototype.passPropsThroughPortal = function() {
        var propsForTarget = Object.assign({}, this.props, {
            node: undefined
        });
        this.props.node.setPortalProps(propsForTarget);
    };
    OutPortal.prototype.componentDidMount = function() {
        var node = this.props.node;
        this.currentPortalNode = node;
        var placeholder = this.placeholderNode.current;
        var parent = placeholder.parentNode;
        node.mount(parent, placeholder);
        this.passPropsThroughPortal();
    };
    OutPortal.prototype.componentDidUpdate = function() {
        // We re-mount on update, just in case we were unmounted (e.g. by
        // a second OutPortal, which has now been removed)
        var node = this.props.node;
        // If we're switching portal nodes, we need to clean up the current one first.
        if (this.currentPortalNode && node !== this.currentPortalNode) {
            this.currentPortalNode.unmount(this.placeholderNode.current);
            this.currentPortalNode = node;
        }
        var placeholder = this.placeholderNode.current;
        var parent = placeholder.parentNode;
        node.mount(parent, placeholder);
        this.passPropsThroughPortal();
    };
    OutPortal.prototype.componentWillUnmount = function() {
        var node = this.props.node;
        node.unmount(this.placeholderNode.current);
    };
    OutPortal.prototype.render = function() {
        // Render a placeholder to the DOM, so we can get a reference into
        // our location in the DOM, and swap it out for the portaled node.
        // A <div> placeholder works fine even for SVG.
        return $eUqFw.createElement("div", {
            ref: this.placeholderNode
        });
    };
    return OutPortal;
}($eUqFw.PureComponent);
var $317b0168a876e55d$export$c08cb61f0c65e152 = $317b0168a876e55d$var$createPortalNode.bind(null, $317b0168a876e55d$var$ELEMENT_TYPE_HTML);
var $317b0168a876e55d$export$6ac597db63d00ad3 = $317b0168a876e55d$var$createPortalNode.bind(null, $317b0168a876e55d$var$ELEMENT_TYPE_SVG);

});



parcelRegister("lBwos", function(module, exports) {

$parcel$export(module.exports, "AiEnabledMinimizedTransition", () => $a3b6568216714f19$export$33cbfb24dcb49988);

var $eUqFw = parcelRequire("eUqFw");

var $lSV8Z = parcelRequire("lSV8Z");
var $hYDGa = parcelRequire("hYDGa");
var $8YJjX = parcelRequire("8YJjX");


var $cdJmq = parcelRequire("cdJmq");
const $a3b6568216714f19$export$33cbfb24dcb49988 = ({ children: children, renderCondition: renderCondition })=>{
    const { onFinishAnimation: onFinishAnimation, shouldRenderView: shouldRenderView } = (0, $cdJmq.useTransitionView)('ai-enabled-minimized', renderCondition);
    if ((0, $8YJjX.isReducedMotion)()) {
        if (renderCondition) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children({
            transitionProps: {}
        }));
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lSV8Z.default), null, shouldRenderView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hYDGa.default), {
        entranceDirection: "bottom",
        exitDirection: "bottom",
        duration: (0, $06fdedeca8586601$export$3749e1104328fde4),
        onFinish: onFinishAnimation
    }, (fadeInProps)=>children({
            transitionProps: {
                ...fadeInProps
            }
        })));
};

});

parcelRegister("1jsll", function(module, exports) {

$parcel$export(module.exports, "AiEnabledMiniTransition", () => $261d95c40a763203$export$66269697bbe00b81);

var $eUqFw = parcelRequire("eUqFw");

var $lSV8Z = parcelRequire("lSV8Z");
var $hYDGa = parcelRequire("hYDGa");
var $8YJjX = parcelRequire("8YJjX");


var $cdJmq = parcelRequire("cdJmq");
const $261d95c40a763203$export$66269697bbe00b81 = ({ children: children, renderCondition: renderCondition })=>{
    const { onFinishAnimation: onFinishAnimation, shouldRenderView: shouldRenderView } = (0, $cdJmq.useTransitionView)('ai-enabled', renderCondition);
    if ((0, $8YJjX.isReducedMotion)()) {
        if (renderCondition) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children({
            transitionProps: {}
        }));
        return null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lSV8Z.default), null, shouldRenderView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hYDGa.default), {
        entranceDirection: "bottom",
        exitDirection: "bottom",
        duration: (0, $06fdedeca8586601$export$3749e1104328fde4),
        onFinish: onFinishAnimation
    }, (fadeInProps)=>children({
            transitionProps: {
                ...fadeInProps
            }
        })));
};

});

parcelRegister("iLTnN", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d3920e1b36c090f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "GIC_VARIANTS", () => (parcelRequire("fRHn0")).GIC_VARIANTS);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");
var $7opLA = parcelRequire("7opLA");

var $bT7k5 = parcelRequire("bT7k5");

var $lD2Nx = parcelRequire("lD2Nx");

var $2OJfS = parcelRequire("2OJfS");

var $PdmhA = parcelRequire("PdmhA");

var $8cU5f = parcelRequire("8cU5f");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $ctR9z = parcelRequire("ctR9z");

var $jMP2a = parcelRequire("jMP2a");

var $hFagV = parcelRequire("hFagV");


var $aFWau = parcelRequire("aFWau");

var $fRHn0 = parcelRequire("fRHn0");

var $9mfzP = parcelRequire("9mfzP");
const $2d3920e1b36c090f$var$PassThroughWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
const $2d3920e1b36c090f$var$ModalFooter = (props)=>{
    const { isMiniVariant: isMiniVariant, containerStyle: containerStyle, children: children } = props;
    if (isMiniVariant) /**
     * We need to use our own footer and not the atlaskit one since the atlaskit one
     * needs to be within ModalDialog to get context or else it crashes
     */ // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2d3920e1b36c090f$export$c93769792f0dbc05, {
        style: containerStyle
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, children);
};
const $2d3920e1b36c090f$export$a06f1c675e846f6f = (props)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { onClose: onClose, onSubmit: onSubmit, isSubmitting: isSubmitting, isOperationInProgress: isOperationInProgress = false, onCreateAnotherChange: onCreateAnotherChange, canCreateAnotherIssue: canCreateAnotherIssue, shouldDisableSubmit: shouldDisableSubmit = false, createdIssues: createdIssues, variant: variant = (0, $fRHn0.GIC_VARIANTS).DEFAULT, displayCreateAnotherIssueToggle: newDisplayCreateAnotherIssueToggle, showIssuesCreated: showIssuesCreated, containerStyle: containerStyle, showCancelButton: showCancelButton, showDiscardButton: showDiscardButton = false } = props;
    const numberOfIssuesCreated = createdIssues.length;
    let displayCreateAnotherIssueToggle = newDisplayCreateAnotherIssueToggle;
    const isGICPositioningEnabled = (0, $hFagV.useIsGICPositioningEnabled)();
    const isMiniVariant = isGICPositioningEnabled() && variant === (0, $fRHn0.GIC_VARIANTS).MINI;
    if (!isGICPositioningEnabled()) {
        const [{ displayCreateAnotherIssueToggle: oldDisplayCreateAnotherIssueToggle }] = // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $ctR9z.useTriggerIssueCreateModal)();
        displayCreateAnotherIssueToggle = oldDisplayCreateAnotherIssueToggle;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onViewIssuesLinkClicked = (_, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'viewIssue');
    };
    const getPrimaryButtonCopy = ()=>{
        if (isMiniVariant) return (0, $9mfzP.default).createButtonInMiniView;
        return (0, $9mfzP.default).createButton;
    };
    const IssuesCreatedTooltip = isMiniVariant ? (0, $8cU5f.default) : $2d3920e1b36c090f$var$PassThroughWrapper;
    const showIssueCreatedTooltip = Boolean(numberOfIssuesCreated) && Boolean(showIssuesCreated);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2d3920e1b36c090f$var$ModalFooter, {
        isMiniVariant: isMiniVariant,
        containerStyle: containerStyle
    }, displayCreateAnotherIssueToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bT7k5.default), {
        onChange: onCreateAnotherChange,
        label: formatMessage((0, $9mfzP.default).createAnother),
        isChecked: canCreateAnotherIssue,
        isDisabled: shouldDisableSubmit,
        testId: "issue-create.common.ui.footer.checkbox"
    }), showIssueCreatedTooltip && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IssuesCreatedTooltip, {
        content: formatMessage((0, $9mfzP.default).issuesCreatedLink, {
            issueCount: numberOfIssuesCreated
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2d3920e1b36c090f$var$IssueLinkContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lD2Nx))), {
        label: "",
        size: "medium",
        primaryColor: `var(--ds-icon-success, ${(0, $PdmhA).G400})`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle-link",
        spacing: "none",
        href: (0, $aFWau.getIssueDiscoveryUrl)(createdIssues),
        target: "_blank",
        onClick: onViewIssuesLinkClicked,
        testId: "issue-create.common.ui.footer.created-issue-link",
        interactionName: "global-issue.create-modal.created-issue-link"
    }, isMiniVariant ? numberOfIssuesCreated : formatMessage((0, $9mfzP.default).issuesCreatedLink, {
        issueCount: numberOfIssuesCreated
    })))), (!isMiniVariant || showCancelButton) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2d3920e1b36c090f$var$CloseButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "subtle-link",
        onClick: onClose,
        isDisabled: isSubmitting,
        testId: "issue-create.common.ui.footer.cancel-button",
        interactionName: "global-issue.create-modal.cancel"
    }, formatMessage((0, $9mfzP.default).cancelButton))), (0, $1ybV0.ff)('jira-intelligent-issue-breakdown_18syl') && showDiscardButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2d3920e1b36c090f$var$CloseButtonContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        appearance: "subtle-link",
        onClick: onClose,
        isLoading: isOperationInProgress,
        isDisabled: isSubmitting || isOperationInProgress,
        testId: "issue-create.common.ui.footer.discard-button",
        interactionName: "global-issue.create-modal.discard"
    }, formatMessage((0, $9mfzP.default).discardButton))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        appearance: "primary",
        onClick: onSubmit,
        isLoading: isSubmitting || isOperationInProgress,
        isDisabled: isSubmitting || shouldDisableSubmit,
        type: "submit",
        form: (0, $18011c889fa9555c$export$2d077da71c26c1c5),
        testId: "issue-create.common.ui.footer.create-button",
        interactionName: "global-issue.create-modal.submit"
    }, isGICPositioningEnabled() ? formatMessage(getPrimaryButtonCopy()) : formatMessage((0, $9mfzP.default).createButton)));
};
var $2d3920e1b36c090f$export$2e2bcd8739ae039 = $2d3920e1b36c090f$export$a06f1c675e846f6f;
const $2d3920e1b36c090f$var$CloseButtonContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01wug _2hwxu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2d3920e1b36c090f$var$IssueLinkContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _18u0pxbi _2hwx1wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $2d3920e1b36c090f$export$c93769792f0dbc05 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "footer", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _kqswh2mm _4cvr1h6o _1bah1yb4 _zulp1b66 _16jlidpf _1o9zidpf _i0dl1wug _18s8s8vo _1yt4rd6f _x3do1ktc _16qs1lnm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fRHn0", function(module, exports) {

$parcel$export(module.exports, "GIC_VARIANTS", () => $4466736882255abf$export$409069fd677aa1c3);
const $4466736882255abf$export$409069fd677aa1c3 = {
    DEFAULT: 'default',
    MINI: 'mini'
};

});

parcelRegister("9mfzP", function(module, exports) {

$parcel$export(module.exports, "default", () => $0de78efed5882a7a$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $0de78efed5882a7a$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createButton: {
        "id": "issue-create.common.footer.create-button",
        "defaultMessage": "Create"
    },
    createButtonInMiniView: {
        "id": "issue-create.common.footer.create-button-in-mini-view",
        "defaultMessage": "Create"
    },
    cancelButton: {
        "id": "issue-create.common.footer.cancel-button",
        "defaultMessage": "Cancel"
    },
    discardButton: {
        "id": "issue-create.common.footer.discard-button",
        "defaultMessage": "Discard"
    },
    createAnother: {
        "id": "issue-create.common.footer.create-another",
        "defaultMessage": "Create another issue"
    },
    copyToNextIssue: {
        "id": "issue-create.common.footer.copy-to-next-issue",
        "defaultMessage": "Copy to next issue"
    },
    issuesCreatedLink: {
        "id": "issue-create.common.footer.issues-created-link",
        "defaultMessage": "{issueCount} {issueCount, plural, one {issue} other {issues}} created"
    },
    createDropdownOptionCreateAnother: {
        "id": "issue-create.common.footer.create-dropdown-option-create-another",
        "defaultMessage": "Create and start another"
    },
    createDropdownOptionCopy: {
        "id": "issue-create.common.footer.create-dropdown-option-copy",
        "defaultMessage": "Create and copy"
    },
    toggleOnTooltip: {
        "id": "issue-create.common.footer.toggle-on-tooltip",
        "defaultMessage": "Toggle off to finish creating issues."
    },
    toggleOffTooltip: {
        "id": "issue-create.common.footer.toggle-off-tooltip",
        "defaultMessage": "After selecting {createButton}, immediately start a new issue with these details and fields."
    }
});

});


parcelRegister("7cshP", function(module, exports) {

$parcel$export(module.exports, "useMinimizableModalWrapperProps", () => $2733cf751c01bc9c$export$48c73e38324bf86b);
$parcel$export(module.exports, "MinimizableModalWrapperPropsProvider", () => $2733cf751c01bc9c$export$a81052d98ff4e3f6);

var $eUqFw = parcelRequire("eUqFw");
// Need to use this context to prevent re-render flashes in the modal wrapper
const $2733cf751c01bc9c$var$MinimizableModalWrapperPropsContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $2733cf751c01bc9c$export$48c73e38324bf86b = ()=>{
    const context = (0, $eUqFw.useContext)($2733cf751c01bc9c$var$MinimizableModalWrapperPropsContext);
    if (context === undefined || context === null) throw new Error('No provider for useMinimizableModalWrapperProps');
    return context;
};
const $2733cf751c01bc9c$export$a81052d98ff4e3f6 = ({ children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2733cf751c01bc9c$var$MinimizableModalWrapperPropsContext.Provider, {
        value: rest
    }, children);

});

parcelRegister("gEI3N", function(module, exports) {

$parcel$export(module.exports, "MinimizableAiEnabled", () => $e48d5e6ad237c2f4$export$bd8db7556d341654);

var $eUqFw = parcelRequire("eUqFw");

var $5qJyz = parcelRequire("5qJyz");

var $4mB3q = parcelRequire("4mB3q");

var $iLTnN = parcelRequire("iLTnN");
var $fRHn0 = parcelRequire("fRHn0");

var $7cshP = parcelRequire("7cshP");
const $e48d5e6ad237c2f4$export$bd8db7556d341654 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, ...rest }, ref)=>{
    const { onModalCloseWithConfirm: onModalCloseWithConfirm, onSubmit: onSubmit, isSubmitting: isSubmitting, isOperationInProgress: isOperationInProgress, canCreateAnotherIssue: canCreateAnotherIssue, onCreateAnotherChange: onCreateAnotherChange, getShouldDisableSubmit: getShouldDisableSubmit, createdIssues: createdIssues, displayCreateAnotherIssueToggle: displayCreateAnotherIssueToggle, setShouldRestore: setShouldRestore } = (0, $7cshP.useMinimizableModalWrapperProps)();
    /**
		 * Never restore issue create for ai-enabled as we should not save data that comes from AI.
		 * This should also prevent a reopen when a page is refreshed with an ai-enabled view.
		 */ (0, $eUqFw.useEffect)(()=>{
        if (setShouldRestore) setShouldRestore(false);
    }, [
        setShouldRestore
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5qJyz.AiEnabledMini), {
        ref: ref,
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4mB3q.AiEnabledMiniHeader), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5qJyz.AiEnabledMiniBody), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iLTnN.default), {
        onClose: onModalCloseWithConfirm('cancel'),
        onSubmit: onSubmit,
        isSubmitting: isSubmitting,
        isOperationInProgress: isOperationInProgress,
        canCreateAnotherIssue: canCreateAnotherIssue,
        onCreateAnotherChange: onCreateAnotherChange,
        shouldDisableSubmit: getShouldDisableSubmit(),
        createdIssues: createdIssues,
        variant: (0, $fRHn0.GIC_VARIANTS).MINI,
        displayCreateAnotherIssueToggle: displayCreateAnotherIssueToggle,
        showCancelButton: false,
        containerStyle: $e48d5e6ad237c2f4$var$containerStyle,
        showDiscardButton: true
    }));
});
const $e48d5e6ad237c2f4$var$containerStyle = {
    justifyContent: 'flex-end'
};

});
parcelRegister("5qJyz", function(module, exports) {

$parcel$export(module.exports, "AiEnabledMiniBody", () => $83ff32b420756de4$export$75d23d552461bfa7);
$parcel$export(module.exports, "AiEnabledMini", () => $83ff32b420756de4$export$b70e1207f824c0dc);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $b5IAe = parcelRequire("b5IAe");

var $8ydpf = parcelRequire("8ydpf");

var $8ydpf = parcelRequire("8ydpf");

var $kGQen = parcelRequire("kGQen");

var $9pngN = parcelRequire("9pngN");

var $jMP2a = parcelRequire("jMP2a");
var $2qZHF = parcelRequire("2qZHF");
parcelRequire("gya0p");
var $9Pqox = parcelRequire("9Pqox");
var $gya0p = parcelRequire("gya0p");

var $hAG0O = parcelRequire("hAG0O");
const $83ff32b420756de4$export$75d23d552461bfa7 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hAG0O.default), {
        testId: "minimizable-modal.ui.modal-container.ai-enabled-mini.scroll-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        paddingBlock: "space.100",
        paddingInline: "space.300"
    }, children));
const $83ff32b420756de4$export$b70e1207f824c0dc = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, components: components }, ref)=>{
    const { Header: Header = (0, $eUqFw.Fragment), Footer: Footer = (0, $eUqFw.Fragment) } = components || {};
    const { isTransitionInState: isTransitionInState } = (0, $gya0p.useMinimizableModal)();
    const isViewEntered = isTransitionInState([
        'ai-enabled'
    ], (0, $9Pqox.TransitionState).ENTERED);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9pngN.JiraBottomRightCornerOutlet), {
        orderFromRight: 3,
        id: "issue-create-mini-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8ydpf.default), {
        ref: ref,
        components: {
            ContentComponent: $83ff32b420756de4$var$ContentComponent
        },
        isShadow: true,
        shouldFitContainer: true,
        spacing: "none",
        testId: !isViewEntered ? undefined : 'minimizable-modal.ui.modal-container.ai-enabled'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
        onMount: (0, $jMP2a.fireScreenAnalyticsDeferred)
    }), components ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Header, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($83ff32b420756de4$export$75d23d552461bfa7, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Footer, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children))));
});
const $83ff32b420756de4$var$OriginalContentComponent = (0, $8ydpf.defaultComponents).ContentComponent;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $83ff32b420756de4$var$ContentComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = $83ff32b420756de4$var$OriginalContentComponent, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _kqswh2mm _1bsb12hx _4t3i1diq _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8ydpf", function(module, exports) {

$parcel$export(module.exports, "default", () => $f44c422da244e149$export$2e2bcd8739ae039);
$parcel$export(module.exports, "defaultComponents", () => $f44c422da244e149$export$71abc632aa29e6fe);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4q38b = parcelRequire("4q38b");

var $bKxX9 = parcelRequire("bKxX9");
let $f44c422da244e149$var$namespaceUUID = 0;
// We don't yet have design system tokens representing the AI prism colour palette. We should replace this with
// equivalent tokens when available
const $f44c422da244e149$var$oldPalette = {
    dark: {
        blue: '#0055CC',
        // Blue 800
        teal: '#37B4C3',
        // Teal 500
        yellow: '#CF9F02'
    },
    light: {
        blue: '#1D7AFC',
        // Blue 600
        teal: '#8BDBE5',
        // Teal 300
        yellow: '#F8E6A0'
    }
};
const $f44c422da244e149$var$newPalette = {
    dark: {
        blue: '#0468FF',
        teal: '#BF63F3',
        yellow: '#FFA900'
    },
    light: {
        blue: '#0468FF',
        teal: '#BF63F3',
        yellow: '#FFA900'
    }
};
const $f44c422da244e149$var$AFTER_LOAD_DURATION = 3000;
const $f44c422da244e149$var$AnimatedSvgContainer = ({ isLoading: isLoading, isBlurred: isBlurred, isShadow: isShadow, isBorderGrey: isBorderGrey, hasNewBorderExperience: hasNewBorderExperience })=>{
    const { colorMode: colorMode } = (0, $4q38b.default)();
    const svgRef = (0, $eUqFw.useRef)(null);
    const namespaceId = (0, $eUqFw.useRef)();
    const palette = (0, $bKxX9.ff)('platform.ai-compliance-changes_wvov4') ? $f44c422da244e149$var$newPalette : $f44c422da244e149$var$oldPalette;
    const [showRainbowBorder, setShowRainbowBorder] = (0, $eUqFw.useState)(false);
    const paletteForTheme = colorMode === 'dark' ? palette.dark : palette.light;
    if (namespaceId.current === undefined) {
        namespaceId.current = $f44c422da244e149$var$namespaceUUID;
        $f44c422da244e149$var$namespaceUUID += 1;
    }
    (0, $eUqFw.useEffect)(()=>{
        if (isLoading) {
            const svg = svgRef.current;
            hasNewBorderExperience && setShowRainbowBorder(true);
            // Schedule animation to begin before next browser paint
            const beginReq = requestAnimationFrame(()=>{
                svg?.querySelectorAll('animate').forEach((node)=>node.beginElement());
            });
            return ()=>{
                // Ensure any pending animation frame is cancelled as the element animation does not end properly if it
                // begins in the same event tick, i.e. isLoading synchronously changes to true then false.
                cancelAnimationFrame(beginReq);
                requestAnimationFrame(()=>{
                    svg?.querySelectorAll('animate').forEach((node)=>node.endElement());
                });
            };
        }
        return undefined;
    }, [
        isLoading,
        hasNewBorderExperience
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // we keep the rainbow border without animations for at 3 seconds after load. After that we show the grey border
        if (hasNewBorderExperience && !isLoading && showRainbowBorder) {
            const timeoutId = setTimeout(()=>setShowRainbowBorder(false), $f44c422da244e149$var$AFTER_LOAD_DURATION);
            return ()=>clearTimeout(timeoutId);
        }
    }, [
        hasNewBorderExperience,
        showRainbowBorder,
        isLoading
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f44c422da244e149$var$SvgContainer, {
        isBlurred: isBlurred,
        isShadow: isShadow,
        ref: svgRef,
        viewBox: "0 0 24 24",
        preserveAspectRatio: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: `${namespaceId.current}_lg1`,
        gradientUnits: "userSpaceOnUse",
        x1: "0%",
        y1: "0",
        x2: "400%",
        y2: "0",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("animate", {
        begin: "indefinite",
        attributeName: "x1",
        from: "0%",
        to: "400%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("animate", {
        begin: "indefinite",
        attributeName: "x2",
        from: "400%",
        to: "800%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.25",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.5",
        stopColor: paletteForTheme.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.75",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: paletteForTheme.blue
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: `${namespaceId.current}_lg2`,
        gradientUnits: "userSpaceOnUse",
        x1: "0",
        y1: "-100%",
        x2: "0",
        y2: "300%",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("animate", {
        begin: "indefinite",
        attributeName: "y1",
        from: "-100%",
        to: "300%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("animate", {
        begin: "indefinite",
        attributeName: "y2",
        from: "300%",
        to: "700%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.25",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.5",
        stopColor: paletteForTheme.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.75",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: paletteForTheme.blue
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: `${namespaceId.current}_lg3`,
        gradientUnits: "userSpaceOnUse",
        x1: "300%",
        y1: "0",
        x2: "700%",
        y2: "0",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("animate", {
        begin: "indefinite",
        attributeName: "x1",
        from: "300%",
        to: "-100%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("animate", {
        begin: "indefinite",
        attributeName: "x2",
        from: "700%",
        to: "300%",
        repeatCount: "indefinite",
        dur: "3s"
    }), (0, $bKxX9.ff)('platform.ai-compliance-changes_wvov4') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.25",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.5",
        stopColor: paletteForTheme.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.75",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: paletteForTheme.blue
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.25",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.5",
        stopColor: paletteForTheme.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.75",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: paletteForTheme.blue
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: `${namespaceId.current}_lg4`,
        gradientUnits: "userSpaceOnUse",
        x1: "0",
        y1: "0",
        x2: "0",
        y2: "400%",
        spreadMethod: "reflect"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("animate", {
        begin: "indefinite",
        attributeName: "y1",
        from: "0%",
        to: "-400%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("animate", {
        begin: "indefinite",
        attributeName: "y2",
        from: "400%",
        to: "0%",
        repeatCount: "indefinite",
        dur: "3s"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0",
        stopColor: paletteForTheme.blue
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.25",
        stopColor: (0, $bKxX9.ff)('platform.ai-compliance-changes_wvov4') ? paletteForTheme.blue : paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.5",
        stopColor: paletteForTheme.yellow
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.75",
        stopColor: paletteForTheme.teal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: paletteForTheme.blue
    }))), (0, $bKxX9.ff)('platform.ai-compliance-changes_wvov4') && (isBorderGrey || hasNewBorderExperience && !showRainbowBorder && !isLoading) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        strokeWidth: "16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        stroke: "var(--ds-background-accent-gray-subtler, #DFE1E6)",
        d: "M0 0h24v24H0Z",
        vectorEffect: "non-scaling-stroke"
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", {
        strokeWidth: "16"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        stroke: `url(#${namespaceId.current}_lg1)`,
        d: "M0 0h24",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        stroke: `url(#${namespaceId.current}_lg2)`,
        d: "M24 0v24",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        stroke: `url(#${namespaceId.current}_lg3)`,
        d: "M24 24H0",
        vectorEffect: "non-scaling-stroke"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        stroke: `url(#${namespaceId.current}_lg4)`,
        d: "M0 24V0",
        vectorEffect: "non-scaling-stroke"
    }))));
};
const $f44c422da244e149$var$AIContainer = ({ children: children, isLoading: isLoading, isShadow: isShadow = false, shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', testId: testId, isBorderGrey: isBorderGrey, components: { ContainerComponent: ContainerComponent = $f44c422da244e149$var$Container, ContentComponent: ContentComponent = $f44c422da244e149$var$Content } = {}, ref: ref, hasNewBorderExperience: hasNewBorderExperience = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ContainerComponent, {
        ref: ref,
        "data-testid": testId,
        shouldFitContainer: shouldFitContainer
    }, (0, $bKxX9.ff)('platform.ai-compliance-changes_wvov4') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f44c422da244e149$var$AnimatedSvgContainer, {
        isShadow: isShadow,
        isLoading: isLoading,
        isBorderGrey: isBorderGrey,
        hasNewBorderExperience: hasNewBorderExperience
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f44c422da244e149$var$AnimatedSvgContainer, {
        isShadow: isShadow,
        isLoading: isLoading
    }), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f44c422da244e149$var$AnimatedSvgContainer, {
        isLoading: isLoading,
        isBlurred: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ContentComponent, {
        spacing: spacing
    }, children));
var $f44c422da244e149$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $f44c422da244e149$var$AIContainer;
const $f44c422da244e149$var$Container = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldFitContainer: shouldFitContainer, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _kqswh2mm _1yt4v77o _1pbyb4wl",
            __cmplp.shouldFitContainer ? "_1bsb1wug" : "_1bsb1ns9",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f44c422da244e149$var$Content = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11q7vuon _2rkoi2wt _16jlkb7n _1pbyb4wl _1bsb1osq",
            __cmplp.spacing === 'default' && "_1yt4u2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $f44c422da244e149$export$71abc632aa29e6fe = {
    ContainerComponent: $f44c422da244e149$var$Container,
    ContentComponent: $f44c422da244e149$var$Content
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f44c422da244e149$var$SvgContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "svg", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isShadow: isShadow, isBlurred: isBlurred, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _2rkoftgi",
            __cmplp.isShadow ? "_16qs1ifw" : "_16qsglyw",
            __cmplp.isBlurred ? "_1bsb5cnj _4t3i5cnj _154iu2gc _1ltvu2gc _kdam7b89" : "_1ltvidpf _154iidpf _1bsb1osq _4t3i1osq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("hAG0O", function(module, exports) {

$parcel$export(module.exports, "default", () => $211465a21700bcc3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $eUqFw = parcelRequire("eUqFw");

var $51sCz = parcelRequire("51sCz");

var $dWaVw = parcelRequire("dWaVw");

var $kaIyT = parcelRequire("kaIyT");

var $6vxSC = parcelRequire("6vxSC");

var $lyDbo = parcelRequire("lyDbo");

var $8cBRH = parcelRequire("8cBRH");
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ const $211465a21700bcc3$var$ScrollContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { testId: testId, children: children, disableAutoTopKeyline: disableAutoTopKeyline = true, disableAutoBottomKeyline: disableAutoBottomKeyline = true } = props;
    const [hasSiblings, setSiblings] = (0, $6vxSC.default)({
        previous: false,
        next: false
    });
    const [showContentFocus, setContentFocus] = (0, $eUqFw.useState)(false);
    const [showTopKeyline, setTopKeyline] = (0, $eUqFw.useState)(false);
    const [showBottomKeyline, setBottomKeyline] = (0, $eUqFw.useState)(false);
    const scrollableRef = (0, $eUqFw.useRef)(null);
    const setLazySiblings = (0, $kaIyT.default)(setSiblings);
    const setLazyContentFocus = (0, $kaIyT.default)((0, $8cBRH.rafSchedule)(()=>{
        const target = scrollableRef.current;
        target && setContentFocus(target.scrollHeight > target.clientHeight);
    }));
    const setLazyKeylines = (0, $kaIyT.default)((0, $8cBRH.rafSchedule)(()=>{
        const target = scrollableRef.current;
        if (target) {
            const scrollableDistance = target.scrollHeight - target.clientHeight;
            if (hasSiblings.current.previous) setTopKeyline(target.scrollTop > (0, $lyDbo.keylineHeight));
            if (hasSiblings.current.next) setBottomKeyline(target.scrollTop <= scrollableDistance - (0, $lyDbo.keylineHeight));
        }
    }));
    (0, $eUqFw.useEffect)(()=>{
        const target = scrollableRef.current;
        window.addEventListener('resize', setLazyKeylines, false);
        target?.addEventListener('scroll', setLazyKeylines, false);
        setLazyContentFocus();
        setLazyKeylines();
        setLazySiblings({
            previous: Boolean(target?.previousElementSibling),
            next: Boolean(target?.nextElementSibling)
        });
        return ()=>{
            window.removeEventListener('resize', setLazyKeylines, false);
            target?.removeEventListener('scroll', setLazyKeylines, false);
        };
    }, [
        setLazyContentFocus,
        setLazyKeylines,
        setLazySiblings
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $51sCz.default), {
        isInset: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($211465a21700bcc3$var$ScrollContainerWrapper, {
        tabIndex: showContentFocus ? 0 : undefined,
        "data-testid": testId !== null && testId !== undefined && `${testId}--scrollable`,
        ref: (0, $dWaVw.default)([
            ref,
            scrollableRef
        ]),
        showTopKeyline: !disableAutoTopKeyline && showTopKeyline,
        showBottomKeyline: !disableAutoBottomKeyline && showBottomKeyline
    }, children));
});
$211465a21700bcc3$var$ScrollContainer.displayName = 'ScrollContainer';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $211465a21700bcc3$var$ScrollContainerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { showTopKeyline: showTopKeyline, showBottomKeyline: showBottomKeyline, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1dv6fab": (0, $9t7rW.default)((0, $lyDbo.keylineColor))
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1kw7 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1kw7 _2lx21kw7 _1reo15vq _18m91wug _1d2sn7od _1utt1wug",
            __cmplp.showTopKeyline ? "_x3do9gv1" : "_x3doglyw",
            __cmplp.showBottomKeyline ? "_n7zl9gv1" : "_n7zlglyw",
            __cmplp.className
        ])
    });
});
var $211465a21700bcc3$export$2e2bcd8739ae039 = $211465a21700bcc3$var$ScrollContainer;

});
parcelRegister("lyDbo", function(module, exports) {

$parcel$export(module.exports, "keylineHeight", () => $f74e58af51fee405$export$4c317248f944c2a9);
$parcel$export(module.exports, "keylineColor", () => $f74e58af51fee405$export$d901150a4cc83165);

var $PdmhA = parcelRequire("PdmhA");
const $f74e58af51fee405$export$4c317248f944c2a9 = 2;
const $f74e58af51fee405$export$d901150a4cc83165 = `var(--ds-border, ${(0, $PdmhA.N30)})`;

});

parcelRegister("8cBRH", function(module, exports) {

$parcel$export(module.exports, "rafSchedule", () => $0c87fb5c87ba2190$export$3c6851d470650c35);
// Adapted from https://github.com/alexreardon/raf-schd/blob/master/src/index.js
const $0c87fb5c87ba2190$export$3c6851d470650c35 = (fn)=>{
    let frameId = null;
    const wrapperFn = ()=>{
        // There is already a frame queued
        if (frameId) return;
        // Schedule a new frame
        frameId = requestAnimationFrame(()=>{
            frameId = null;
            fn();
        });
    };
    // Adding cancel property to result function
    wrapperFn.cancel = ()=>{
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};

});



parcelRegister("4mB3q", function(module, exports) {

$parcel$export(module.exports, "AiEnabledMiniHeader", () => $e4fde355a1d249d8$export$754cec3500187835);

var $eUqFw = parcelRequire("eUqFw");

var $21XoC = parcelRequire("21XoC");

var $1myPN = parcelRequire("1myPN");
const $e4fde355a1d249d8$export$754cec3500187835 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $21XoC.AiEnabledHeader), {
        "data-testid": "issue-create.common.ui.ai-enabled.ai-enabled-modal-mini-header.ai-enabled-mini-header"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1myPN.AiEnabledModalTitle), null));

});
parcelRegister("21XoC", function(module, exports) {

$parcel$export(module.exports, "AiEnabledHeader", () => $b4ff3b14f14ef33b$export$25925f3ed0e6de53);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $8cU5f = parcelRequire("8cU5f");

var $5JgJ2 = parcelRequire("5JgJ2");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $bjdFD = parcelRequire("bjdFD");

var $fiNz6 = parcelRequire("fiNz6");
parcelRequire("gya0p");
var $9Pqox = parcelRequire("9Pqox");
var $gya0p = parcelRequire("gya0p");

var $fqX9w = parcelRequire("fqX9w");

var $i3oe6 = parcelRequire("i3oe6");
const $b4ff3b14f14ef33b$export$6dd73e5d06d834e1 = ()=>{
    const { view: view, setView: setView, isTransitionInState: isTransitionInState, setShouldFocusChanger: setShouldFocusChanger } = (0, $gya0p.useMinimizableModal)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { minimizedButtonRef: minimizedButtonRef, wrapperRef: wrapperRef, onKeyDown: onKeyDown } = (0, $fiNz6.useEnterFocusState)();
    const onViewChange = (0, $eUqFw.useCallback)((newView)=>()=>{
            if (!isTransitionInState([
                view
            ], (0, $9Pqox.TransitionState).ENTERED)) return;
            setShouldFocusChanger(true);
            setView(newView);
            const analyticsEvent = createAnalyticsEvent({
                action: 'button clicked',
                actionSubject: newView
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
                source: 'globalIssueCreateModal',
                previousGICViewState: view
            });
        }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        setView,
        isTransitionInState
    ]);
    const { shouldDisableViewChangerButtons: shouldDisableViewChangerButtons, customDisabledViewChangerButtonsMessage: customDisabledViewChangerButtonsMessage } = (0, $gya0p.useMinimizableModal)();
    (0, $eUqFw.useEffect)(()=>{
        if (shouldDisableViewChangerButtons) (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'disabled',
            actionSubject: 'view changer buttons'
        }));
    }, [
        createAnalyticsEvent,
        customDisabledViewChangerButtonsMessage,
        shouldDisableViewChangerButtons
    ]);
    (0, $bjdFD.useNestedModalDetector)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b4ff3b14f14ef33b$var$AiEnabledViewChangerWrapper, {
        tabIndex: -1,
        ref: wrapperRef,
        "data-testid": "minimizable-modal.ui.modal-container.ai-enabled-header.view-changer-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8cU5f.default), {
        "data-testid": "minimizable-modal.ui.modal-container.ai-enabled-header.tool-tip",
        position: "top",
        content: shouldDisableViewChangerButtons ? customDisabledViewChangerButtonsMessage || formatMessage((0, $i3oe6.default).minimizeDisabled) : formatMessage((0, $i3oe6.default).minimize)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b4ff3b14f14ef33b$var$AiEnabledMiniButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b4ff3b14f14ef33b$var$ToolbarButton, {
        testId: "minimizable-modal.ui.modal-container.ai-enabled-header.minimized-button",
        onClick: onViewChange('ai-enabled-minimized'),
        onKeyDown: onKeyDown,
        spacing: "none",
        ref: minimizedButtonRef,
        isDisabled: shouldDisableViewChangerButtons,
        appearance: "subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fqX9w.MinimizeIcon), {
        label: formatMessage((0, $i3oe6.default).minimize),
        size: "medium"
    })))));
};
const $b4ff3b14f14ef33b$export$25925f3ed0e6de53 = ({ children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b4ff3b14f14ef33b$var$AiMiniHeaderWrapper, rest, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($b4ff3b14f14ef33b$export$6dd73e5d06d834e1, null)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b4ff3b14f14ef33b$var$ToolbarButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $7u4fN.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_rcujt94y _o81ct94y _1l6ut94y _149mt94y _1dlt1l7b _w8sq1l7b _fjwr1l7b _1yxx1l7b",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b4ff3b14f14ef33b$var$AiEnabledMiniButtonWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vwz4kb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b4ff3b14f14ef33b$var$AiEnabledViewChangerWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _1bahesu3 _1o9zidpf _u5f31b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b4ff3b14f14ef33b$var$AiMiniHeaderWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o _1bahesu3 _syaz2l1e _n7zl17kj _16qsx4xo _18s8s8vo _1yt4rd6f",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fqX9w", function(module, exports) {

$parcel$export(module.exports, "MinimizeIcon", () => $0e0d9be6ef0b485a$export$95300d23f5f56d39);
// eslint-disable-next-line jira/restricted/react-component-props

var $eUqFw = parcelRequire("eUqFw");

var $2ziLQ = parcelRequire("2ziLQ");
const $0e0d9be6ef0b485a$export$ab3e03e3b7ae2f0c = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("svg", {
        ...props,
        viewBox: "0 4 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        fillOpacity: "0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        d: "M18.6667 16C19.403 16 20 16.4477 20 17C20 17.5128 19.4853 17.9355 18.8221 17.9933L18.6667 18H5.33333C4.59695 18 4 17.5523 4 17C4 16.4872 4.51474 16.0645 5.17786 16.0067L5.33333 16H18.6667Z",
        fill: "currentColor"
    }));
const $0e0d9be6ef0b485a$export$95300d23f5f56d39 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ziLQ.default), {
        glyph: $0e0d9be6ef0b485a$export$ab3e03e3b7ae2f0c,
        // @ts-expect-error - TS2322 - Type '"small" | "medium" | "large" | "xlarge" | null' is not assignable to type 'Size | undefined'.
        size: props.size || null,
        label: props.label,
        primaryColor: props.primaryColor
    });

});

parcelRegister("i3oe6", function(module, exports) {

$parcel$export(module.exports, "default", () => $413857dc2dbc4886$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $413857dc2dbc4886$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    minimize: {
        "id": "minimizable-modal.modal-container.ai-enabled-header.minimize",
        "defaultMessage": "Minimize"
    },
    minimizeDisabled: {
        "id": "minimizable-modal.modal-container.ai-enabled-header.minimize-disabled",
        "defaultMessage": "Can't minimize this view"
    }
});

});


parcelRegister("1myPN", function(module, exports) {

$parcel$export(module.exports, "AiEnabledModalTitle", () => $94ea6d82aa3198aa$export$20aff08cce879c50);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $78led = parcelRequire("78led");


var $5JgJ2 = parcelRequire("5JgJ2");

var $76zGC = parcelRequire("76zGC");

var $gJhhD = parcelRequire("gJhhD");
const $94ea6d82aa3198aa$export$20aff08cce879c50 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $78led.AiIcon), {
        size: "medium",
        label: (0, $2d9e862f10717bb6$export$1a33ff8e70228fd6)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($94ea6d82aa3198aa$var$AiModalTitle, {
        "data-testid": "issue-create.common.ui.ai-enabled.ai-enabled-title.ai-enabled-modal-title"
    }, formatMessage((0, $gJhhD.default).aiEnabledMiniTitle)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $94ea6d82aa3198aa$var$AiModalTitle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $76zGC.ModalTitle), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0ccj1k _syaz2l1e _1wybdlk8 _k48powjs _ca0qidpf _u5f3ftgi _n3tdidpf _19bvftgi _1yyjcs5v _sudp1e54 _o5724jg8 _1bto4jg8 _1reo15vq _18m915vq _16jlkb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("78led", function(module, exports) {

$parcel$export(module.exports, "AiIcon", () => $c929eac1624d8a26$export$762da6f7f5ace732);

var $eUqFw = parcelRequire("eUqFw");

var $ce8OV = parcelRequire("ce8OV");

var $PdmhA = parcelRequire("PdmhA");

var $1ybV0 = parcelRequire("1ybV0");
const $c929eac1624d8a26$export$762da6f7f5ace732 = (props)=>{
    let iconAccentBlueB200;
    let textAccentBlueB400;
    if (props.isDisabled && (0, $1ybV0.ff)('smart-summaries-new-disclaimer_s7l2u')) {
        iconAccentBlueB200 = `var(--ds-text-subtlest, ${(0, $PdmhA).N200})`;
        textAccentBlueB400 = `var(--ds-text-subtlest, ${(0, $PdmhA).N200})`;
    } else if (props.isDisabled) {
        iconAccentBlueB200 = `var(--ds-icon-accent-gray, ${(0, $PdmhA).N300})`;
        textAccentBlueB400 = `var(--ds-text-accent-gray, ${(0, $PdmhA).N300})`;
    } else {
        iconAccentBlueB200 = `var(--ds-icon-accent-blue, ${(0, $PdmhA).B200})`;
        textAccentBlueB400 = `var(--ds-text-accent-blue, ${(0, $PdmhA).B400})`;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ce8OV.default), props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "ai_icon_lg0",
        x1: "21",
        y1: "12",
        x2: "17.5",
        y2: "12",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.270833",
        stopColor: iconAccentBlueB200,
        color: iconAccentBlueB200
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: textAccentBlueB400,
        color: textAccentBlueB400
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "ai_icon_lg1",
        x1: "12.5",
        y1: "3",
        x2: "12.5",
        y2: "6.5",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.1875",
        stopColor: iconAccentBlueB200,
        color: iconAccentBlueB200
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "1",
        stopColor: textAccentBlueB400,
        color: textAccentBlueB400
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "ai_icon_lg2",
        x1: "6.82996",
        y1: "12",
        x2: "3.32996",
        y2: "12",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: textAccentBlueB400,
        color: textAccentBlueB400
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.791667",
        stopColor: iconAccentBlueB200,
        color: iconAccentBlueB200
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("linearGradient", {
        id: "ai_icon_lg3",
        x1: "12.5",
        y1: "17",
        x2: "12.5",
        y2: "21",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        stopColor: textAccentBlueB400,
        color: textAccentBlueB400
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("stop", {
        offset: "0.802083",
        stopColor: iconAccentBlueB200,
        color: iconAccentBlueB200
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.17 12C17.17 11.4477 17.6177 11 18.17 11H20C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13H18.17C17.6177 13 17.17 12.5523 17.17 12Z",
        fill: props.isDisabled && (0, $1ybV0.ff)('smart-summaries-new-disclaimer_s7l2u') ? `var(--ds-text-subtlest, ${(0, $PdmhA).N200})` : 'url(#ai_icon_lg0)'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 3C12.5523 3 13 3.44772 13 4V5.83C13 6.38228 12.5523 6.83 12 6.83C11.4477 6.83 11 6.38228 11 5.83V4C11 3.44772 11.4477 3 12 3Z",
        fill: props.isDisabled && (0, $1ybV0.ff)('smart-summaries-new-disclaimer_s7l2u') ? `var(--ds-text-subtlest, ${(0, $PdmhA).N200})` : 'url(#ai_icon_lg1)'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 12C3 11.4477 3.44772 11 4 11H5.83C6.38228 11 6.83 11.4477 6.83 12C6.83 12.5523 6.38228 13 5.83 13H4C3.44772 13 3 12.5523 3 12Z",
        fill: props.isDisabled && (0, $1ybV0.ff)('smart-summaries-new-disclaimer_s7l2u') ? `var(--ds-text-subtlest, ${(0, $PdmhA).N200})` : 'url(#ai_icon_lg2)'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 17.17C12.5523 17.17 13 17.6177 13 18.17V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V18.17C11 17.6177 11.4477 17.17 12 17.17Z",
        fill: props.isDisabled && (0, $1ybV0.ff)('smart-summaries-new-disclaimer_s7l2u') ? `var(--ds-text-subtlest, ${(0, $PdmhA).N200})` : 'url(#ai_icon_lg3)'
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.2929 14.2929C14.6835 13.9024 15.3166 13.9024 15.7071 14.2929L19.7071 18.2929C20.0977 18.6834 20.0977 19.3166 19.7071 19.7071C19.3166 20.0976 18.6835 20.0976 18.2929 19.7071L14.2929 15.7071C13.9024 15.3166 13.9024 14.6834 14.2929 14.2929Z",
        fill: iconAccentBlueB200
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M19.7071 4.29289C20.0977 4.68342 20.0977 5.31658 19.7071 5.70711L15.7071 9.70711C15.3166 10.0976 14.6835 10.0976 14.2929 9.70711C13.9024 9.31658 13.9024 8.68342 14.2929 8.29289L18.2929 4.29289C18.6835 3.90237 19.3166 3.90237 19.7071 4.29289Z",
        fill: iconAccentBlueB200
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L9.70711 8.29289C10.0976 8.68342 10.0976 9.31658 9.70711 9.70711C9.31658 10.0976 8.68342 10.0976 8.29289 9.70711L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z",
        fill: iconAccentBlueB200
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.70711 14.2929C10.0976 14.6834 10.0976 15.3166 9.70711 15.7071L5.70711 19.7071C5.31658 20.0976 4.68342 20.0976 4.29289 19.7071C3.90237 19.3166 3.90237 18.6834 4.29289 18.2929L8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929Z",
        fill: iconAccentBlueB200
    })));
};

});

const $2d9e862f10717bb6$export$1a33ff8e70228fd6 = 'Atlassian Intelligence';
const $2d9e862f10717bb6$export$9c7ce577b80c2668 = 8;
const $2d9e862f10717bb6$export$d0d4ed81e1ed42ec = 6;
const $2d9e862f10717bb6$export$b6e7a25078ed1a5f = 7;
const $2d9e862f10717bb6$export$d0f488901b85b750 = 'LIKE';
const $2d9e862f10717bb6$export$7ca6708a8b83d828 = 'DISLIKE';
const $2d9e862f10717bb6$export$af6d68522cb370b8 = 'https://support.atlassian.com/organization-administration/docs/get-started-with-atlassian-intelligence/';

parcelRegister("gJhhD", function(module, exports) {

$parcel$export(module.exports, "default", () => $802953d7dbc64a92$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $802953d7dbc64a92$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    aiEnabledMiniTitle: {
        "id": "issue-create.common.ai-enabled.ai-enabled-title.ai-enabled-mini-title",
        "defaultMessage": "Suggestion preview"
    }
});

});




parcelRegister("gMPmc", function(module, exports) {

$parcel$export(module.exports, "MinimizableAiEnabledMinimized", () => $14b1df8ef18400d5$export$8c4d1f13da8a8644);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $78led = parcelRequire("78led");


var $5JgJ2 = parcelRequire("5JgJ2");

var $cbFBf = parcelRequire("cbFBf");

var $gJhhD = parcelRequire("gJhhD");
const $14b1df8ef18400d5$export$8c4d1f13da8a8644 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return(// @ts-expect-error - TS2322 - Property 'ref' does not exist on type 'IntrinsicAttributes & MinimizedContainerProps'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cbFBf.AiEnabledMinimized), {
        ...props,
        ref: ref
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($14b1df8ef18400d5$var$TitleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($14b1df8ef18400d5$var$IconContainer, {
        "data-testid": "issue-create.ui.modal.modal-wrapper.minimizable-ai-enabled-minimized.issue-type-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $78led.AiIcon), {
        size: "medium",
        label: (0, $2d9e862f10717bb6$export$1a33ff8e70228fd6)
    })), formatMessage((0, $gJhhD.default).aiEnabledMiniTitle))));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $14b1df8ef18400d5$var$IconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxiiu2 _1e0c116y",
            __cmplp.className
        ])
    });
});
const $14b1df8ef18400d5$var$TitleContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1wybrkyh",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cbFBf", function(module, exports) {

$parcel$export(module.exports, "AiEnabledMinimized", () => $3ccac63b59e4da7c$export$e24633a04a1b73cc);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $51sCz = parcelRequire("51sCz");

var $dEMIg = parcelRequire("dEMIg");

var $9pngN = parcelRequire("9pngN");

var $jMP2a = parcelRequire("jMP2a");
var $2qZHF = parcelRequire("2qZHF");
var $bFzGY = parcelRequire("bFzGY");

var $fiNz6 = parcelRequire("fiNz6");
parcelRequire("gya0p");
var $9Pqox = parcelRequire("9Pqox");
var $gya0p = parcelRequire("gya0p");
const $3ccac63b59e4da7c$export$e24633a04a1b73cc = ({ children: children, isItalic: isItalic, className: className })=>{
    const { unminimizeModal: unminimizeModal, previousView: previousView, isTransitionInState: isTransitionInState, setShouldFocusChanger: setShouldFocusChanger } = (0, $gya0p.useMinimizableModal)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { minimizedButtonRef: minimizedButtonRef, onKeyDown: onKeyDown, wrapperRef: wrapperRef } = (0, $fiNz6.useEnterFocusState)();
    const isViewEntered = isTransitionInState([
        'ai-enabled-minimized'
    ], (0, $9Pqox.TransitionState).ENTERED);
    const unminimize = ()=>{
        if (!isViewEntered) return;
        setShouldFocusChanger(true);
        unminimizeModal('ai-enabled');
        const analyticsEvent = createAnalyticsEvent({
            action: 'container clicked',
            actionSubject: 'ai-enabled-minimized'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, {
            source: 'globalIssueCreateModal',
            previousGICViewState: previousView
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9pngN.JiraBottomRightCornerOutlet), {
        orderFromRight: 3,
        id: "issue-create-minimised-modal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3ccac63b59e4da7c$var$MinimizedOuterWrapper, {
        id: (0, $dEMIg.MINIMISED_DROPZONE_CONTAINER_ID),
        tabIndex: -1,
        ref: wrapperRef,
        "data-testid": // testid should only be available when view is not transitioning
        // otherwise CY tries to click the view before its last position
        isViewEntered ? 'minimizable-modal.ui.modal-container.minimized-outer-wrapper' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
        onMount: (0, $jMP2a.fireScreenAnalyticsDeferred)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $51sCz.default), {
        isInset: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3ccac63b59e4da7c$var$MinimizedWrapper, {
        // @ts-expect-error - TS2322 - Type '((instance: MinimizedContainerProps | null) => void) | MutableRefObject<MinimizedContainerProps | null> | null' is not assignable to type '((string | ((instance: Component<ThemedOuterStyledProps<DiffBetween<{ className: any; }, ClassAttributes<HTMLButtonElement> & ButtonHTMLAttributes<HTMLButtonElement>>, any>, any, any> | null) => void) | RefObject<...>) & (string | ... 1 more ... | RefObject<...>)) | null | undefined'.
        ref: minimizedButtonRef,
        "data-testid": isViewEntered ? 'minimizable-modal.ui.modal-container.minimized' : undefined,
        onKeyDown: onKeyDown,
        onClick: unminimize,
        isItalic: isItalic,
        // eslint-disable-next-line jira/react/no-classname-attribute, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3ccac63b59e4da7c$var$MinimizedText, null, children)))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3ccac63b59e4da7c$var$MinimizedWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19itidpf _vchhusvi _11q7hp5a _4t3ickbl _1bsb1mjv _2rkoftgi _1e0c1txw _4cvr1h6o _1yt4119w _80omtlke _v5649dqc _16qs6ae0 _1spjglyw _ymio1r31 _ypr0glyw _zcxs1o36 _19lcxwku _1dit1r31 _ksodglyw _4hz81o36 _j6xtxwku _1q5t1r31 _1ohyglyw _1r9x1o36",
            __cmplp.className
        ])
    });
});
const $3ccac63b59e4da7c$var$MinimizedText = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bto1l2s _o5721q9c _1reo15vq _18m915vq _syaz2l1e _1wyb7vkz _k48pni7l",
            __cmplp.className
        ])
    });
});
const $3ccac63b59e4da7c$var$MinimizedOuterWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_nt751r31 _49pcglyw _1hvw1o36",
            __cmplp.className
        ])
    });
});

});


parcelRegister("RgE7p", function(module, exports) {

$parcel$export(module.exports, "MinimizableFullscreen", () => $59d84247ab66ac2a$export$b31191b6904db55b);

var $eUqFw = parcelRequire("eUqFw");

var $kgYRM = parcelRequire("kgYRM");

var $ctR9z = parcelRequire("ctR9z");

var $iLTnN = parcelRequire("iLTnN");
var $fRHn0 = parcelRequire("fRHn0");

var $7cshP = parcelRequire("7cshP");
const $59d84247ab66ac2a$export$b31191b6904db55b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, ...rest }, ref)=>{
    const { onModalCloseWithConfirm: onModalCloseWithConfirm, onSubmit: onSubmit, isSubmitting: isSubmitting, isOperationInProgress: isOperationInProgress, canCreateAnotherIssue: canCreateAnotherIssue, onCreateAnotherChange: onCreateAnotherChange, getShouldDisableSubmit: getShouldDisableSubmit, createdIssues: createdIssues, displayCreateAnotherIssueToggle: displayCreateAnotherIssueToggle } = (0, $7cshP.useMinimizableModalWrapperProps)();
    const [{ containerStyle: containerStyle }] = (0, $ctR9z.useTriggerIssueCreateModal)();
    return(// @ts-expect-error - TS2746 - This JSX tag's 'children' prop expects a single child of type 'HTMLCollection', but multiple children were provided.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kgYRM.Fullscreen), {
        ref: ref,
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kgYRM.FullscreenBody), {
        containerStyle: containerStyle
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iLTnN.default), {
        onClose: onModalCloseWithConfirm('cancel'),
        onSubmit: onSubmit,
        isSubmitting: isSubmitting,
        isOperationInProgress: isOperationInProgress,
        canCreateAnotherIssue: canCreateAnotherIssue,
        onCreateAnotherChange: onCreateAnotherChange,
        shouldDisableSubmit: getShouldDisableSubmit(),
        createdIssues: createdIssues,
        variant: (0, $fRHn0.GIC_VARIANTS).MINI,
        displayCreateAnotherIssueToggle: displayCreateAnotherIssueToggle,
        containerStyle: containerStyle,
        showCancelButton: true
    })));
});

});

parcelRegister("hDWvr", function(module, exports) {

$parcel$export(module.exports, "MinimizableModalMini", () => $f7f3162b9f5dc69c$export$c752bd88450266e0);

var $eUqFw = parcelRequire("eUqFw");

var $jG2Eu = parcelRequire("jG2Eu");

var $fyk0U = parcelRequire("fyk0U");

var $41WOo = parcelRequire("41WOo");

var $7ZZxN = parcelRequire("7ZZxN");

var $guiFP = parcelRequire("guiFP");

var $fmKuk = parcelRequire("fmKuk");

var $ctR9z = parcelRequire("ctR9z");

var $dgsxZ = parcelRequire("dgsxZ");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $bNe1g = parcelRequire("bNe1g");

var $aONhl = parcelRequire("aONhl");

var $iLTnN = parcelRequire("iLTnN");
var $fRHn0 = parcelRequire("fRHn0");

var $hmrBG = parcelRequire("hmrBG");

var $4BBHz = parcelRequire("4BBHz");

var $7cshP = parcelRequire("7cshP");

var $35vCf = parcelRequire("35vCf");
const $f7f3162b9f5dc69c$var$returnNull = ()=>null;
const $f7f3162b9f5dc69c$export$c752bd88450266e0 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, summaryValue: summaryValue, ...rest }, ref)=>{
    const { onModalCloseWithConfirm: onModalCloseWithConfirm, onSubmit: onSubmit, isSubmitting: isSubmitting, isOperationInProgress: isOperationInProgress, canCreateAnotherIssue: canCreateAnotherIssue, onCreateAnotherChange: onCreateAnotherChange, getShouldDisableSubmit: getShouldDisableSubmit, createdIssues: createdIssues, displayCreateAnotherIssueToggle: displayCreateAnotherIssueToggle, selectedIssueType: selectedIssueType, projectType: projectType } = (0, $7cshP.useMinimizableModalWrapperProps)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const issueTypeRef = (0, $eUqFw.useRef)(selectedIssueType);
    const { parseSummaryValue: parseSummaryValue } = (0, $4BBHz.useParseSummaryValue)();
    const [shouldRenderMiniModalSpotlight, setShouldRenderMiniModalSpotlight] = (0, $eUqFw.useState)(false);
    const [{ shouldShowMiniModalSpotlight: shouldShowMiniModalSpotlight, triggerPointKey: triggerPointKey }, { dismissModalSpotlight: dismissModalSpotlight }] = (0, $ctR9z.useTriggerIssueCreateModal)();
    const [userTraits, { setUserTraits: setUserTraits }] = (0, $41WOo.isJwmReduceNoiseOnSignupEnabled)() ? (0, $fyk0U.useUserTraits)() : [
        null,
        {
            setUserTraits: (0, (/*@__PURE__*/$parcel$interopDefault($jG2Eu)))
        }
    ];
    const fetchUserTraits = (0, $41WOo.isJwmReduceNoiseOnSignupEnabled)() ? (0, $fyk0U.useFetchUserTraitsOld)() : $f7f3162b9f5dc69c$var$returnNull;
    const setUserTraitsIfNotAvailable = (0, $eUqFw.useCallback)(async ()=>{
        const newTraits = await fetchUserTraits();
        // We must explicitly check for false because fetchUserTraits returns "false" when pending, and "null" when traits are empty.
        if (newTraits !== false) setUserTraits(newTraits);
    }, [
        fetchUserTraits,
        setUserTraits
    ]);
    const { updateIsDiscoPushComplete: updateIsDiscoPushComplete } = (0, $aONhl.usePersistentIssueCreateModalViewResource)();
    const { data: projectContext } = (0, $bNe1g.useProjectContext)();
    const markMiniModalAsSeen = (0, $eUqFw.useCallback)(()=>{
        try {
            const shouldDismiss = (0, $dgsxZ.isPartOfDiscoverabilityTriggers)(triggerPointKey) && projectContext?.projectType !== (0, $7ZZxN.SERVICE_DESK_PROJECT);
            if (shouldDismiss) {
                updateIsDiscoPushComplete(true);
                dismissModalSpotlight();
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'setMiniModalSpotlightPreference',
                    packageName: 'jiraIssueCreate'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        dismissModalSpotlight,
        triggerPointKey,
        updateIsDiscoPushComplete,
        projectContext?.projectType
    ]);
    (0, $eUqFw.useEffect)(()=>()=>{
            markMiniModalAsSeen();
        }, [
        markMiniModalAsSeen
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (selectedIssueType) issueTypeRef.current = selectedIssueType;
    }, [
        selectedIssueType
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!(0, $41WOo.isJwmReduceNoiseOnSignupEnabled)()) setShouldRenderMiniModalSpotlight(!!shouldShowMiniModalSpotlight);
        else if (!userTraits?.attributes?.length && userTraits?.attributes !== null) setUserTraitsIfNotAvailable();
        else {
            const accountCreationDate = userTraits?.attributes?.find((trait)=>trait?.name === 'jira_first_active')?.value;
            const aWeekAgo = new Date(Date.now() - 604800000);
            let isNewUser = false;
            if (accountCreationDate && typeof accountCreationDate === 'string') isNewUser = new Date(accountCreationDate) > aWeekAgo;
            setShouldRenderMiniModalSpotlight(!!shouldShowMiniModalSpotlight && !isNewUser);
        }
    }, [
        userTraits,
        shouldShowMiniModalSpotlight,
        setUserTraitsIfNotAvailable
    ]);
    (0, $eUqFw.useEffect)(()=>{
        (0, $jMP2a.fireTrackAnalytics)(createAnalyticsEvent({}), shouldRenderMiniModalSpotlight ? 'feature exposed' : 'feature hidden', 'issueCreateMiniModalSpotlight', {
            interruptionType: 'spotlight',
            targetsNewUsers: true,
            jwm_reduce_noise_on_signup_experiment_enabled: (0, $41WOo.isJwmReduceNoiseOnSignupEnabled)()
        });
    }, [
        createAnalyticsEvent,
        shouldRenderMiniModalSpotlight
    ]);
    return(// @ts-expect-error - TS2746 - This JSX tag's 'children' prop expects a single child of type 'HTMLCollection', but multiple children were provided.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fmKuk.Mini), {
        ref: ref,
        ...rest
    }, shouldRenderMiniModalSpotlight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $35vCf.SpotlightContainer), {
        shouldShowSpotlight: shouldRenderMiniModalSpotlight,
        onCloseSpotlight: markMiniModalAsSeen
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hmrBG.MiniHeader), {
        title: parseSummaryValue(summaryValue, issueTypeRef.current?.label),
        isItalic: !summaryValue,
        iconUrl: issueTypeRef.current?.iconUrl,
        showHeaderIcon: projectType !== (0, $7ZZxN.SERVICE_DESK_PROJECT)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fmKuk.MiniBody), null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iLTnN.default), {
        onClose: onModalCloseWithConfirm('cancel'),
        onSubmit: onSubmit,
        isSubmitting: isSubmitting,
        isOperationInProgress: isOperationInProgress,
        canCreateAnotherIssue: canCreateAnotherIssue,
        onCreateAnotherChange: onCreateAnotherChange,
        shouldDisableSubmit: getShouldDisableSubmit(),
        createdIssues: createdIssues,
        variant: (0, $fRHn0.GIC_VARIANTS).MINI,
        displayCreateAnotherIssueToggle: displayCreateAnotherIssueToggle
    })));
});

});
parcelRegister("hmrBG", function(module, exports) {

$parcel$export(module.exports, "MiniHeader", () => $918f537d9f81a86e$export$1d38987b2afcba7e);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hnzPP = parcelRequire("hnzPP");

var $76zGC = parcelRequire("76zGC");
const $918f537d9f81a86e$export$1d38987b2afcba7e = ({ title: title, iconUrl: iconUrl, isItalic: isItalic, showHeaderIcon: showHeaderIcon })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $76zGC.MiniHeader), null, showHeaderIcon && iconUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($918f537d9f81a86e$var$IconContainer, {
        "data-testid": "issue-create.common.ui.minimizable-modal-mini-header.icon-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnzPP.default), {
        width: 16,
        alt: title,
        url: iconUrl
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($918f537d9f81a86e$var$MinimizableModalTitle, {
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        "data-testid": "minimizable-modal.ui.modal-container-mini-header.mini-header",
        // @ts-expect-error - TS2322 - Type '{ children: string; "data-testid": string; isItalic: boolean; }' is not assignable to type 'IntrinsicAttributes & IntrinsicClassAttributes<Component<ThemedOuterStyledProps<WithOptionalTheme<{ children?: ReactNode; }, any>, any>, any, any>> & Readonly<...>'.
        isItalic: isItalic
    }, title));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $918f537d9f81a86e$var$IconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb7vkz _4t3i7vkz _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $918f537d9f81a86e$var$MinimizableModalTitle = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = (0, $76zGC.ModalTitle), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0ccj1k _syaz2l1e _1wybpxbi _k48pni7l _ca0qidpf _u5f3ftgi _n3tdidpf _19bvftgi _1yyjcs5v _sudp1e54 _o5724jg8 _1bto4jg8 _1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hnzPP", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca9fc3da0c774fa7$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.29.1 */ /* eslint-disable jira/react/handler-naming */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kwce8 = parcelRequire("kwce8");

var $PdmhA = parcelRequire("PdmhA");

var $c9TLT = parcelRequire("c9TLT");
const $ca9fc3da0c774fa7$export$c6d2b2df39d78e5b = (0, $c9TLT.gridSize) * 2;
class $ca9fc3da0c774fa7$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            url: undefined,
            title: undefined,
            alt: undefined,
            width: $ca9fc3da0c774fa7$export$c6d2b2df39d78e5b,
            height: $ca9fc3da0c774fa7$export$c6d2b2df39d78e5b,
            fallback: undefined
        };
    }
    render() {
        const { title: title, url: url, alt: alt, fallback: fallback } = this.props;
        const width = this.convertSize(this.props.width);
        const height = this.convertSize(this.props.height);
        if (this.state.isBroken && fallback) return fallback();
        return url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ca9fc3da0c774fa7$var$Image, {
            src: url,
            width: width,
            height: height,
            title: title ?? undefined,
            alt: alt ?? '',
            onError: this.onError,
            draggable: false
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($ca9fc3da0c774fa7$var$ImagePlaceholder, {
            width: width,
            height: height,
            "data-testid": "common-components-async-icon.placeholder"
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            isBroken: false
        };
        this.onError = ()=>{
            this.setState({
                isBroken: true
            });
        };
        this.convertSize = (size)=>size ? `${size}px` : '0';
    }
}
// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ca9fc3da0c774fa7$var$ImagePlaceholder = /*#__PURE__*/ (0, $kwce8.default).span.withConfig({
    componentId: "owe24v-0"
})(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
(props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: props.height,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        width: props.width,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: (0, $PdmhA).N30,
        borderRadius: '3px',
        display: 'flex',
        flex: 'none'
    }));
// Firefox displays the alt text when the image can't load, the narrow provided width
// means this alt text leaks into the summary vertically if overflow is allowed
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ca9fc3da0c774fa7$var$Image = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
});

});


parcelRegister("4BBHz", function(module, exports) {

$parcel$export(module.exports, "useParseSummaryValue", () => $ead799f6e649469d$export$f753c33a187faf7c);

var $5JgJ2 = parcelRequire("5JgJ2");

var $7QQh7 = parcelRequire("7QQh7");
const $ead799f6e649469d$export$f753c33a187faf7c = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    // TODO: remove undefined prop type when cleaning up restore-mini-view-summary_y0gl1
    const parseSummaryValue = (summaryValue, issueType)=>{
        if (summaryValue === null) return issueType ? formatMessage((0, $7QQh7.default).noSummaryWithIssueType, {
            issueType: issueType
        }) : '';
        if (summaryValue) return summaryValue;
        return issueType ? formatMessage((0, $7QQh7.default).noSummaryWithIssueType, {
            issueType: issueType
        }) : formatMessage((0, $7QQh7.default).noSummary);
    };
    return {
        parseSummaryValue: parseSummaryValue
    };
};

});

parcelRegister("35vCf", function(module, exports) {

$parcel$export(module.exports, "SpotlightContainer", () => $7aac7ab90fca68cc$export$d0f55839b708c0a0);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $g9Oms = parcelRequire("g9Oms");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $7QQh7 = parcelRequire("7QQh7");
const $7aac7ab90fca68cc$export$d0f55839b708c0a0 = ({ shouldShowSpotlight: shouldShowSpotlight, onCloseSpotlight: onCloseSpotlight })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7aac7ab90fca68cc$var$SpotlightPopoverWrapper, {
        "data-testid": "issue-create.ui.modal.modal-wrapper.minimizable-modal-mini.modal-spotlight.wrapper"
    }, shouldShowSpotlight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g9Oms.default), {
        heading: formatMessage((0, $7QQh7.default).miniModalSpotlightHeading),
        width: 290,
        actions: [
            {
                onClick: onCloseSpotlight,
                text: formatMessage((0, $7QQh7.default).miniModalSpotlightActionMessage)
            }
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
        ...(0, $7QQh7.default).miniModalSpotlightMessage,
        values: {
            br: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("br", null))
        }
    })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7aac7ab90fca68cc$var$SpotlightPopoverWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _154iidpf _1ltv1vvt",
            __cmplp.className
        ])
    });
});

});


parcelRegister("lkmb6", function(module, exports) {

$parcel$export(module.exports, "MinimizableModalMinimized", () => $318b3baa978894b4$export$72c64a34c513900);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $7JEyt = parcelRequire("7JEyt");

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $hnzPP = parcelRequire("hnzPP");

var $7ZZxN = parcelRequire("7ZZxN");

var $bvunr = parcelRequire("bvunr");

var $4BBHz = parcelRequire("4BBHz");

var $7cshP = parcelRequire("7cshP");
const $318b3baa978894b4$export$72c64a34c513900 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ className: className, summaryValue: summaryValue }, ref)=>{
    const { parseSummaryValue: parseSummaryValue } = (0, $4BBHz.useParseSummaryValue)();
    const { selectedIssueType: selectedIssueType, projectType: projectType } = (0, $7cshP.useMinimizableModalWrapperProps)();
    return(// @ts-expect-error - TS2322 - Type '((instance: MinimizableModalMinimizedProps | null) => void) | MutableRefObject<MinimizableModalMinimizedProps | null> | null' is not assignable to type '((string | ((instance: Component<ThemedOuterStyledProps<DiffBetween<{ className: any; }, Omit<HTMLElement & RefAttributes<MinimizedContainerProps>, "theme"> & { ...; }>, any>, any, any> | null) => void) | RefObject<...>) & (((instance: MinimizedContainerProps | null) => void) | RefObject<...>)) | null | undefined'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($318b3baa978894b4$var$StyledMinimized, {
        ref: ref,
        isItalic: !summaryValue,
        transitionClass: className
    }, selectedIssueType?.iconUrl && projectType !== (0, $7ZZxN.SERVICE_DESK_PROJECT) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($318b3baa978894b4$var$TitleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($318b3baa978894b4$var$IconContainer, {
        "data-testid": "issue-create.ui.modal.modal-wrapper.minimizable-modal-minimized.issue-type-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hnzPP.default), {
        width: 16,
        alt: `${selectedIssueType?.label} icon`,
        url: selectedIssueType?.iconUrl
    })), parseSummaryValue(summaryValue, selectedIssueType?.label)) : parseSummaryValue(summaryValue, selectedIssueType?.label)));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $318b3baa978894b4$var$IconContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxpxbi _1e0c116y",
            __cmplp.className
        ])
    });
});
const $318b3baa978894b4$var$TitleContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $318b3baa978894b4$var$StyledMinimized = /*#__PURE__*/ (0, $kwce8.default)((0, $bvunr.Minimized)).attrs({
    // @ts-expect-error - TS2339 - Property 'transitionClass' does not exist on type 'ThemedStyledProps<HTMLElement & RefAttributes<MinimizedContainerProps>, any>'.
    className: (props)=>props.transitionClass
}).withConfig({
    componentId: "sc-1pohfgc-0"
})``;

});

parcelRegister("l7AVl", function(module, exports) {

$parcel$export(module.exports, "default", () => $3858f942b3017fc2$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7u4fN = parcelRequire("7u4fN");

var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4r5oC = parcelRequire("4r5oC");

var $fswni = parcelRequire("fswni");

var $76zGC = parcelRequire("76zGC");

var $ctR9z = parcelRequire("ctR9z");

var $jMP2a = parcelRequire("jMP2a");

var $hFagV = parcelRequire("hFagV");

var $6duQa = parcelRequire("6duQa");


var $huNeN = parcelRequire("huNeN");

var $9qKk6 = parcelRequire("9qKk6");

var $a22Ft = parcelRequire("a22Ft");
const $3858f942b3017fc2$export$a9dbcd01d58b1c3b = ({ shouldShowChangerSpotlight: shouldShowChangerSpotlight })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ title: title, isSubTaskCreationOpen: isSubTaskCreationOpen, isCreateLinkedIssue: isCreateLinkedIssue }] = (0, $ctR9z.useTriggerIssueCreateModal)();
    let titleMsg = (0, $9qKk6.default).title;
    if (isSubTaskCreationOpen) titleMsg = (0, $9qKk6.default).subtaskTitle;
    else if (isCreateLinkedIssue) titleMsg = (0, $9qKk6.default).createLinkedIssueDialogTitle;
    const shouldShowChangerSpotlightBoolean = !!shouldShowChangerSpotlight;
    const ViewChangerContainer = shouldShowChangerSpotlightBoolean ? (0, $a22Ft.SpotlightContainer) : undefined;
    return(// eslint-disable-next-line jira/react/no-empty-divs
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $76zGC.ModalHeader), {
        ViewChangerContainer: ViewChangerContainer
    }, title !== null && title !== '' ? title : formatMessage(titleMsg))));
};
const $3858f942b3017fc2$var$OldHeader = ({ shouldDisableActions: shouldDisableActions, watchersConfigurations: watchersConfigurations })=>{
    const [{ selectedProject: selectedProject }] = (0, $fswni.useFormContext)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const [{ title: title, isSubTaskCreationOpen: isSubTaskCreationOpen, isCreateLinkedIssue: isCreateLinkedIssue }] = (0, $ctR9z.useTriggerIssueCreateModal)();
    // Delete callback when cleaning up gic-remove-import-issues-button
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onImportIssues = (_, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'importIssues', {
            projectType: selectedProject ? (0, $4r5oC.transformProjectType)(selectedProject.projectType) : 'none'
        });
    };
    const shouldDisableHeaderDropdown = ()=>Boolean(shouldDisableActions || selectedProject === null);
    let titleMsg = (0, $9qKk6.default).title;
    if (isSubTaskCreationOpen) titleMsg = (0, $9qKk6.default).subtaskTitle;
    else if (isCreateLinkedIssue) titleMsg = (0, $9qKk6.default).createLinkedIssueDialogTitle;
    return(// eslint-disable-next-line jira/react/no-empty-divs
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, title !== null && title !== '' ? title : formatMessage(titleMsg))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3858f942b3017fc2$var$ActionsContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6duQa.default), {
        configs: watchersConfigurations
    }), (0, $1ybV0.ff)('gic-remove-import-issues-button') ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        href: (0, $51732085006816a3$export$92614df4bfc0bfa8),
        testId: "issue-create.ui.modal.modal-wrapper.minimizable-modal-modal.header.import-issues-button",
        onClick: onImportIssues,
        isDisabled: shouldDisableActions
    }, formatMessage((0, $9qKk6.default).importIssues)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $3858f942b3017fc2$var$dropdownContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $huNeN.default), {
        isDisabled: shouldDisableHeaderDropdown()
    }))))));
};
const $3858f942b3017fc2$export$8b251419efc915eb = (props)=>{
    const isGICPositioningEnabled = (0, $hFagV.useIsGICPositioningEnabled)();
    if (isGICPositioningEnabled()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3858f942b3017fc2$export$a9dbcd01d58b1c3b, {
        shouldShowChangerSpotlight: props.shouldShowChangerSpotlight
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($3858f942b3017fc2$var$OldHeader, props);
};
var $3858f942b3017fc2$export$2e2bcd8739ae039 = $3858f942b3017fc2$export$8b251419efc915eb;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3858f942b3017fc2$var$ActionsContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01wug _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $3858f942b3017fc2$var$dropdownContainerStyles = (0, $1ZAYh.xcss)({
    marginLeft: 'space.100'
});

});
const $51732085006816a3$export$92614df4bfc0bfa8 = '/secure/BulkCreateSetupPage!default.jspa?externalSystem=com.atlassian.jira.plugins.jim-plugin%3AbulkCreateCsv';

parcelRegister("huNeN", function(module, exports) {

$parcel$export(module.exports, "default", () => $eafdb91fcd56bf0c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $6OfWd = parcelRequire("6OfWd");
var $hD6GJ = parcelRequire("hD6GJ");
var $fEubG = parcelRequire("fEubG");

var $jG1wZ = parcelRequire("jG1wZ");

var $5JgJ2 = parcelRequire("5JgJ2");

var $4r5oC = parcelRequire("4r5oC");

var $fswni = parcelRequire("fswni");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $c7H0g = parcelRequire("c7H0g");

var $cD5gn = parcelRequire("cD5gn");
const $eafdb91fcd56bf0c$var$HeaderDropdown = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isAdmin = (0, $c7H0g.useIsAdmin)();
    const { isDisabled: isDisabled = false } = props;
    const [{ selectedProject: selectedProject, selectedIssueType: selectedIssueType }, { toggleConfigureFieldsModalVisibility: toggleConfigureFieldsModalVisibility, toggleFindFieldsModalVisibility: toggleFindFieldsModalVisibility }] = (0, $fswni.useFormContext)();
    const showConfigureFieldsModal = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        toggleConfigureFieldsModalVisibility(true);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'configureFields', {
            projectType: selectedProject ? (0, $4r5oC.transformProjectType)(selectedProject.projectType) : 'none'
        });
    };
    const showFindFieldModal = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        toggleFindFieldsModalVisibility(true);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'findYourField', {
            projectType: selectedProject ? (0, $4r5oC.transformProjectType)(selectedProject.projectType) : 'none'
        });
    };
    const showFindFieldOption = ()=>Boolean(isAdmin && selectedProject && selectedIssueType && !selectedProject.isSimplified);
    // @ts-expect-error - TS7006 - Parameter 'attributes' implicitly has an 'any' type.
    const onOpenChange = (attributes)=>{
        if (attributes.isOpen) {
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            });
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'meatballMenu');
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6OfWd.default), {
        placement: "bottom-end",
        trigger: ({ triggerRef: triggerRef, ...dropdownProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
                ...dropdownProps,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jG1wZ))), {
                    label: "more"
                }),
                appearance: "subtle",
                ref: triggerRef,
                isDisabled: isDisabled
            }),
        onOpenChange: onOpenChange
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fEubG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        onClick: showConfigureFieldsModal
    }, formatMessage((0, $cD5gn.default).showFields)), showFindFieldOption() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hD6GJ.default), {
        onClick: showFindFieldModal
    }, formatMessage((0, $cD5gn.default).findField))));
};
var $eafdb91fcd56bf0c$export$2e2bcd8739ae039 = $eafdb91fcd56bf0c$var$HeaderDropdown;

});
parcelRegister("cD5gn", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6e1bfca6be642f7$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $f6e1bfca6be642f7$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    showFields: {
        "id": "issue-create.modal.modal-wrapper.minimizable-modal-modal.header.dropdown-menu.show-fields",
        "defaultMessage": "Show fields"
    },
    findField: {
        "id": "issue-create.modal.modal-wrapper.minimizable-modal-modal.header.dropdown-menu.find-field",
        "defaultMessage": "Find your field"
    }
});

});


parcelRegister("9qKk6", function(module, exports) {

$parcel$export(module.exports, "default", () => $4da65e91f31a8e47$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4da65e91f31a8e47$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "issue-create.modal.modal-wrapper.minimizable-modal-modal.header.title",
        "defaultMessage": "Create issue"
    },
    subtaskTitle: {
        "id": "issue-create.modal.modal-wrapper.minimizable-modal-modal.header.subtask-title",
        "defaultMessage": "Create subtask"
    },
    // Delete this when cleaning up gic-remove-import-issues-button
    importIssues: {
        "id": "issue-create.modal.modal-wrapper.minimizable-modal-modal.header.import-issues",
        "defaultMessage": "Import issues"
    },
    createLinkedIssueDialogTitle: {
        "id": "issue-create.modal.modal-wrapper.minimizable-modal-modal.header.create-linked-issue-dialog-title",
        "defaultMessage": "Create linked issue"
    },
    changerButtonsDisabledForgeFields: {
        "id": "issue-create.modal.modal-wrapper.minimizable-modal-modal.header.changer-buttons-disabled-forge-fields",
        "defaultMessage": "Some fields in this project and issue type don\u2019t allow resizing or minimizing"
    }
});

});

parcelRegister("a22Ft", function(module, exports) {

$parcel$export(module.exports, "SpotlightContainer", () => $7ef102bdf593e46c$export$d0f55839b708c0a0);

var $eUqFw = parcelRequire("eUqFw");

var $kwce8 = parcelRequire("kwce8");

var $g9Oms = parcelRequire("g9Oms");
var $8Wt6T = parcelRequire("8Wt6T");

var $lcnyw = parcelRequire("lcnyw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $7QQh7 = parcelRequire("7QQh7");
const $7ef102bdf593e46c$export$d0f55839b708c0a0 = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    /**
   * Atlaskit Popup was not used due to technical limitations of the component in this particular use case.
   * onClose is triggered when the popup is controlled by focussing, which causes the popup to immediately close.
   */ return(// eslint-disable-next-line jira/integration/test-id-by-folder-structure
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7ef102bdf593e46c$var$SpotlightContainerWrapper, {
        "data-testid": "issue-create.ui.modal.header.spotlight-container.wrapper"
    }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($7ef102bdf593e46c$var$SpotlightPopoverWrapper, {
        zIndex: (0, $lcnyw.layers).spotlight()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g9Oms.default), {
        width: 275
    }, formatMessage((0, $7QQh7.default).resizeSpotlightMessage)))));
};
// eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7ef102bdf593e46c$var$SpotlightPopoverWrapper = /*#__PURE__*/ (0, $kwce8.default).div.withConfig({
    componentId: "ovmtxf-0"
})({
    position: 'absolute',
    top: 'calc(100% + 5px)',
    // Size of the border of the SpotlightPulse + 3px from design
    right: "var(--ds-space-negative-025, -2px)" // Size of the border of the SpotlightPulse
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
({ zIndex: zIndex })=>zIndex && // eslint-disable-next-line jira/compiled/styled-components-usages, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $kwce8.css)({
        zIndex: // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        zIndex
    }));
// eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7ef102bdf593e46c$var$SpotlightContainerWrapper = /*#__PURE__*/ (0, $kwce8.default)((0, $8Wt6T.Pulse)).withConfig({
    componentId: "ovmtxf-1"
})({
    position: 'relative'
});

});


parcelRegister("gqW7X", function(module, exports) {

$parcel$export(module.exports, "MinimizableModalModal", () => $e4c254320490cdd7$export$8b041304f822d4d4);

var $eUqFw = parcelRequire("eUqFw");

var $lfiOu = parcelRequire("lfiOu");

var $1ttZy = parcelRequire("1ttZy");

var $7TaJX = parcelRequire("7TaJX");

var $fswni = parcelRequire("fswni");

var $jkyV3 = parcelRequire("jkyV3");
var $gya0p = parcelRequire("gya0p");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $iLTnN = parcelRequire("iLTnN");

var $7cshP = parcelRequire("7cshP");

var $l7AVl = parcelRequire("l7AVl");
const $e4c254320490cdd7$var$HeaderComponent = ()=>{
    const { shouldShowChangerSpotlight: shouldShowChangerSpotlight } = (0, $7cshP.useMinimizableModalWrapperProps)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l7AVl.default), {
        shouldDisableActions: false,
        shouldShowChangerSpotlight: shouldShowChangerSpotlight
    });
};
const $e4c254320490cdd7$var$ModalBodyNext = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        id: (0, $7TaJX.ISSUE_CREATE_MODAL_BODY_SELECTOR),
        ref: ref,
        ...props
    })));
const $e4c254320490cdd7$var$FooterComponent = ()=>{
    const { onModalCloseWithConfirm: onModalCloseWithConfirm, onSubmit: onSubmit, isSubmitting: isSubmitting, isOperationInProgress: isOperationInProgress, canCreateAnotherIssue: canCreateAnotherIssue, onCreateAnotherChange: onCreateAnotherChange, getShouldDisableSubmit: getShouldDisableSubmit, createdIssues: createdIssues, displayCreateAnotherIssueToggle: displayCreateAnotherIssueToggle, showIssuesCreated: showIssuesCreated } = (0, $7cshP.useMinimizableModalWrapperProps)();
    const shouldDisableSubmit = getShouldDisableSubmit();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iLTnN.default), {
        onClose: onModalCloseWithConfirm('cancel'),
        onSubmit: onSubmit,
        isSubmitting: isSubmitting,
        isOperationInProgress: isOperationInProgress,
        canCreateAnotherIssue: canCreateAnotherIssue,
        onCreateAnotherChange: onCreateAnotherChange,
        shouldDisableSubmit: shouldDisableSubmit,
        createdIssues: createdIssues,
        displayCreateAnotherIssueToggle: displayCreateAnotherIssueToggle,
        showIssuesCreated: showIssuesCreated
    });
};
const $e4c254320490cdd7$export$8b041304f822d4d4 = ({ 'data-testid': dataTestId, children: children })=>{
    const [{ isFormDirty: isFormDirty, ecosystem: { forge: { hasFinishedLoading: hasFinishedLoading } } }] = (0, $fswni.useFormContext)();
    const uiModificationsStatus = (0, $1ttZy.useUiModificationsEnabledStatus)(hasFinishedLoading);
    const { setView: setView, shouldDisableViewChangerButtons: shouldDisableViewChangerButtons, onClose: onClose } = (0, $gya0p.useMinimizableModal)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onModalCloseOverride = (0, $eUqFw.useCallback)((event, analyticsEvent)=>{
        const isEscapePress = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        event?.key === 'Escape' || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        event?.key === 'Esc' || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        event?.keyCode === 27;
        const isBlanketClick = !isEscapePress; // Assume it is a blanket click if it isn't an esc event
        if (isBlanketClick && (!hasFinishedLoading || uiModificationsStatus !== 'disabled')) return;
        if (isBlanketClick || isFormDirty) {
            setView('mini');
            const dockAnalyticsEvent = createAnalyticsEvent({
                action: 'docked',
                actionSubject: 'modalDialog'
            });
            (0, $jMP2a.fireUIAnalytics)(dockAnalyticsEvent, 'modalDialog docked', {
                isBlanketClick: isBlanketClick
            });
        } else onClose?.(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        hasFinishedLoading,
        isFormDirty,
        onClose,
        setView,
        uiModificationsStatus
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jkyV3.Modal), {
        "data-testid": dataTestId,
        components: {
            Header: $e4c254320490cdd7$var$HeaderComponent,
            Footer: $e4c254320490cdd7$var$FooterComponent,
            // @ts-expect-error - TS2322 - Type 'ForwardRefExoticComponent<RefAttributes<unknown>>' is not assignable to type 'ComponentType<ModalBodyProps> | undefined'.
            Body: $e4c254320490cdd7$var$ModalBodyNext
        },
        onClose: !shouldDisableViewChangerButtons ? onModalCloseOverride : undefined,
        shouldCloseOnOverlayClick: !shouldDisableViewChangerButtons
    }, children);
};

});

parcelRegister("97M4F", function(module, exports) {

$parcel$export(module.exports, "useSetSummary", () => $c6dccf0272c81431$export$2e036b125a865e82);

var $eUqFw = parcelRequire("eUqFw");

var $ldoFd = parcelRequire("ldoFd");

var $dNWQB = parcelRequire("dNWQB");
var $2gOs4 = parcelRequire("2gOs4");
const $c6dccf0272c81431$export$2e036b125a865e82 = (initialSummaryValue)=>{
    const [summaryValue, setSummary] = (0, $eUqFw.useState)(initialSummaryValue || initialSummaryValue === null ? initialSummaryValue : '');
    const hasSetInitialValue = (0, $eUqFw.useRef)(false);
    if (!hasSetInitialValue.current && !(0, (/*@__PURE__*/$parcel$interopDefault($ldoFd)))(initialSummaryValue)) {
        hasSetInitialValue.current = true;
        setSummary(initialSummaryValue);
    }
    const { subscribe: subscribe } = (0, $2gOs4.useGICLifeCycleEvents)();
    (0, $eUqFw.useEffect)(()=>{
        subscribe((0, $dNWQB.GIC_LIFECYCLE_EVENTS).CREATE_FORM_FIELD_VALUE_CHANGE, async (data)=>{
            if (data.fieldId === 'summary') setSummary(data.value.toString());
        });
        subscribe((0, $dNWQB.GIC_LIFECYCLE_EVENTS).MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE, async ()=>{
            setSummary('');
        });
    }, [
        subscribe,
        setSummary
    ]);
    (0, $eUqFw.useEffect)(()=>subscribe((0, $dNWQB.GIC_LIFECYCLE_EVENTS).ISSUE_CREATE_SUCCESS, async ()=>{
            setSummary('');
        }), [
        subscribe,
        setSummary
    ]);
    return summaryValue;
};

});

parcelRegister("hmaT3", function(module, exports) {

$parcel$export(module.exports, "useViewChangerDisabler", () => $906a6472dd7377b3$export$db29ac8670837568);

var $eUqFw = parcelRequire("eUqFw");

var $1ybV0 = parcelRequire("1ybV0");

var $5JgJ2 = parcelRequire("5JgJ2");

var $ig7wC = parcelRequire("ig7wC");
var $1ttZy = parcelRequire("1ttZy");

var $fswni = parcelRequire("fswni");

var $gya0p = parcelRequire("gya0p");

var $ctR9z = parcelRequire("ctR9z");

var $7cshP = parcelRequire("7cshP");

var $bb81M = parcelRequire("bb81M");
const $906a6472dd7377b3$export$db29ac8670837568 = ()=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    // Global opt-out of minimizable modal
    const [{ disableMinimizableModal: disableMinimizableModal }] = (0, $ctR9z.useTriggerIssueCreateModal)();
    const { isNestedModal: isNestedModal, shouldDisableViewChangerButtons: shouldDisableViewChangerButtons, setShouldDisableViewChangerButtons: setShouldDisableViewChangerButtons, setView: setView, view: view } = (0, $gya0p.useMinimizableModal)();
    const [{ ecosystem: { forge: { hasFinishedLoading: hasFinishedLoading } } }] = (0, $fswni.useFormContext)();
    const adjustmentsAreEnabled = (0, $ig7wC.useAdjustmentsEnabled)();
    const uiModificationsStatus = (0, $1ttZy.useUiModificationsEnabledStatus)(hasFinishedLoading);
    const { setShouldRestore: setShouldRestore } = (0, $7cshP.useMinimizableModalWrapperProps)();
    const disableViewChangerButtonsHandler = (0, $eUqFw.useCallback)((disableViewChangerButtons, customDisabledViewChangerButtonsMessage)=>{
        setShouldDisableViewChangerButtons(disableViewChangerButtons, customDisabledViewChangerButtonsMessage);
        if ((0, $1ybV0.ff)('jira-intelligent-issue-breakdown_18syl') && view === 'ai-enabled') return;
        setShouldRestore?.(!disableViewChangerButtons);
    }, [
        setShouldDisableViewChangerButtons,
        setShouldRestore,
        view
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (disableMinimizableModal || isNestedModal) disableViewChangerButtonsHandler(true);
        else if (uiModificationsStatus === 'enabled' || adjustmentsAreEnabled) disableViewChangerButtonsHandler(true, formatMessage((0, $bb81M.default).changerButtonsDisabledForgeFields));
        else disableViewChangerButtonsHandler(false);
    }, [
        adjustmentsAreEnabled,
        disableMinimizableModal,
        disableViewChangerButtonsHandler,
        formatMessage,
        isNestedModal,
        setShouldDisableViewChangerButtons,
        uiModificationsStatus
    ]);
    (0, $eUqFw.useEffect)(()=>{
        /* 
              force setView to modal view is disabled for the full screen since there will be no transitions allowed from the view.
              this will help us enable the UIM flow in the full screen view as well.
          */ if (view === 'fullscreen') return;
        if (shouldDisableViewChangerButtons) setView('modal', true);
    }, [
        setView,
        view,
        shouldDisableViewChangerButtons
    ]);
};

});
parcelRegister("bb81M", function(module, exports) {

$parcel$export(module.exports, "default", () => $46a19eea98c455a5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $46a19eea98c455a5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    changerButtonsDisabledForgeFields: {
        "id": "issue-create.modal.modal-wrapper.use-view-changer-disabler.changer-buttons-disabled-forge-fields",
        "defaultMessage": "Some fields in this project and issue type don\u2019t allow resizing or minimizing"
    }
});

});



parcelRegister("b1gcq", function(module, exports) {

$parcel$export(module.exports, "NavigateWithoutRestorePrompt", () => $c11fbd2b28522ec8$export$f92d4f53cfa676ca);

var $eUqFw = parcelRequire("eUqFw");

var $fswni = parcelRequire("fswni");

var $kJlBc = parcelRequire("kJlBc");

var $3LZyI = parcelRequire("3LZyI");

var $04KnN = parcelRequire("04KnN");
const $c11fbd2b28522ec8$export$f92d4f53cfa676ca = ({ setShouldRestore: setShouldRestore })=>{
    const [{ deferredNavigationLink: deferredNavigationLink }, { setDeferredNavigationLink: setDeferredNavigationLink }] = (0, $04KnN.useNavigationDiscardChanges)();
    const [{ isFormDirty: isFormDirty }] = (0, $fswni.useFormContext)();
    const { push: push } = (0, $kJlBc.useRouterActions)();
    const onConfirmHandler = (0, $eUqFw.useCallback)(()=>{
        setShouldRestore && setShouldRestore(false);
    }, [
        setShouldRestore
    ]);
    const onCancelHandler = (0, $eUqFw.useCallback)(()=>{
        setDeferredNavigationLink('');
    }, [
        setDeferredNavigationLink
    ]);
    // If the form is then we navigate immediately without showing the prompt
    (0, $eUqFw.useEffect)(()=>{
        if (deferredNavigationLink && !isFormDirty) {
            setShouldRestore && setShouldRestore(false);
            push(deferredNavigationLink);
            setDeferredNavigationLink('');
        }
    }, [
        deferredNavigationLink,
        isFormDirty,
        push,
        setDeferredNavigationLink,
        setShouldRestore
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3LZyI.NavigationDiscardChangesPrompt), {
        navigateLink: isFormDirty ? deferredNavigationLink : '',
        onConfirm: onConfirmHandler,
        onCancel: onCancelHandler
    });
};

});
parcelRegister("3LZyI", function(module, exports) {

$parcel$export(module.exports, "NavigationDiscardChangesPrompt", () => $1ddae9529019919b$export$80c1951973f41e27);

var $eUqFw = parcelRequire("eUqFw");

var $7u4fN = parcelRequire("7u4fN");

var $7opLA = parcelRequire("7opLA");

var $aOw1G = parcelRequire("aOw1G");
var $lfiOu = parcelRequire("lfiOu");
var $2OJfS = parcelRequire("2OJfS");
var $kigFe = parcelRequire("kigFe");
var $boSVF = parcelRequire("boSVF");

var $kGQen = parcelRequire("kGQen");

var $5JgJ2 = parcelRequire("5JgJ2");

var $8WuJm = parcelRequire("8WuJm");
var $jMP2a = parcelRequire("jMP2a");
var $2qZHF = parcelRequire("2qZHF");

var $kJlBc = parcelRequire("kJlBc");

var $beMhR = parcelRequire("beMhR");
const $1ddae9529019919b$export$80c1951973f41e27 = ({ navigateLink: navigateLink, onConfirm: onConfirm, onCancel: onCancel })=>{
    const [isNavigating, setIsNavigating] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { push: push } = (0, $kJlBc.useRouterActions)();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onCancelHandler = (_, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'cancelNavigationDisardChangesPrompt', {
            navigateLink: navigateLink
        });
        onCancel?.();
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onConfirmHandler = (_, analyticsEvent)=>{
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, 'confirmNavigationDisardChangesPrompt', {
            navigateLink: navigateLink
        });
        onConfirm && onConfirm();
        setIsNavigating(true);
        push(navigateLink);
    };
    if (!navigateLink) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8WuJm.ContextualAnalyticsData), {
        sourceType: (0, $41ea3621645e2acc$export$1171103ea9083ffa),
        sourceName: "navigateWithoutRestore"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2qZHF.MountEvent), {
        onMount: (0, $jMP2a.fireScreenAnalyticsDeferred)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kGQen.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aOw1G.default), {
        onClose: onCancelHandler,
        width: "small",
        shouldCloseOnOverlayClick: !isNavigating,
        shouldCloseOnEscapePress: !isNavigating,
        testId: "issue-create.common.ui.navigation-discard-changes-prompt.modal-dialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kigFe.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $boSVF.default), null, formatMessage((0, $beMhR.default).title))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lfiOu.default), null, formatMessage((0, $beMhR.default).description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2OJfS.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        testId: "issue-create.common.ui.navigation-discard-changes-prompt.button",
        appearance: "subtle-link",
        onClick: onCancelHandler,
        isDisabled: isNavigating
    }, formatMessage((0, $beMhR.default).cancelButtonLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7opLA.default), {
        testId: "issue-create.common.ui.navigation-discard-changes-prompt.loading-button",
        appearance: "primary",
        onClick: onConfirmHandler,
        isDisabled: isNavigating,
        isLoading: isNavigating
    }, formatMessage((0, $beMhR.default).confirmButtonLabel))))));
};

});
parcelRegister("beMhR", function(module, exports) {

$parcel$export(module.exports, "default", () => $4583e06c942b37a5$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $4583e06c942b37a5$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    title: {
        "id": "issue-create.common.navigation-discard-changes-prompt.title",
        "defaultMessage": "Your changes won\u2019t be saved"
    },
    cancelButtonLabel: {
        "id": "issue-create.common.navigation-discard-changes-prompt.cancel-button-label",
        "defaultMessage": "Go back"
    },
    confirmButtonLabel: {
        "id": "issue-create.common.navigation-discard-changes-prompt.confirm-button-label",
        "defaultMessage": "Discard issue"
    },
    description: {
        "id": "issue-create.common.navigation-discard-changes-prompt.description",
        "defaultMessage": "We won\u2019t be able to save your data if you move away from this page."
    }
});

});



parcelRegister("4qoRl", function(module, exports) {

$parcel$export(module.exports, "SuccessFlag", () => $c00e9b87b1664321$export$93bd4963a1d00fd5);
$parcel$export(module.exports, "default", () => $c00e9b87b1664321$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $aWvIp = parcelRequire("aWvIp");

var $PdmhA = parcelRequire("PdmhA");


var $cCFSU = parcelRequire("cCFSU");
var $eo17r = parcelRequire("eo17r");
var $k8Qyf = parcelRequire("k8Qyf");

var $5JgJ2 = parcelRequire("5JgJ2");

var $6Vonl = parcelRequire("6Vonl");

var $cJGZN = parcelRequire("cJGZN");


var $94TZV = parcelRequire("94TZV");
const $c00e9b87b1664321$export$93bd4963a1d00fd5 = (props)=>{
    const { flagKey: flagKey, id: id, issueList: issueList, issueDiscoveryUrl: issueDiscoveryUrl, successFlagParams: successFlagParams } = props;
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { dismissFlag: dismissFlag } = (0, $k8Qyf.useFlagsService)();
    const getDynamicFlagType = ()=>{
        if (successFlagParams) {
            const { isRankable: isRankable, isWorkMode: isWorkMode, canManageSprints: canManageSprints, boardType: boardType } = successFlagParams;
            if (isRankable && isWorkMode) {
                if (boardType === (0, $a74d63b8166671c7$export$4498412e32a31fb6) && canManageSprints) return 0, $43f1e8ead7a5a2a9$export$407f3b8bfd90ad8d;
                if (boardType === (0, $a74d63b8166671c7$export$b4e9cdb19cfa0abb)) return 0, $43f1e8ead7a5a2a9$export$256b368007db542a;
            }
        }
        return 0, $43f1e8ead7a5a2a9$export$858ff9c1b12e1d84;
    };
    const getDefaultFlagTitle = ()=>{
        const areMultipleIssuesCreated = issueList.length > 1;
        return areMultipleIssuesCreated ? formatMessage((0, $94TZV.default).multiplesIssuesCreatedSuccessFlagTitle, {
            issueCount: issueList.length
        }) : formatMessage((0, $94TZV.default).createSuccessFlagTitle, {
            issueKey: issueList[0].issueKey
        });
    };
    const FlagConfigs = {
        Default: ()=>({
                flagTitle: getDefaultFlagTitle(),
                flagDescription: '',
                flagActions: (0, $cJGZN.getDefaultFlagActions)({
                    issueList: issueList,
                    issueDiscoveryUrl: issueDiscoveryUrl
                })
            }),
        IssuesNotInSprint: (issuesWithNoSprint, issuesExcludingEpics, sprints)=>({
                flagTitle: formatMessage((0, $94TZV.default).issueCreatedNoSprintOrInBacklogSuccessFlagTitle, {
                    issueCount: issuesExcludingEpics.length
                }),
                flagDescription: formatMessage((0, $94TZV.default).issueCreatedNoSprintSuccessFlagDescription, {
                    issueKey: issuesWithNoSprint[0].issueKey,
                    issueCount: issuesExcludingEpics.length
                }),
                flagActions: (0, $cJGZN.getNewScrumIssuesWithNoSprintsActions)({
                    issueList: issueList,
                    issueDiscoveryUrl: issueDiscoveryUrl,
                    issuesWithNoSprint: issuesWithNoSprint,
                    sprints: sprints
                })
            }),
        IssuesNotInSprintMoreThanTwoActiveSprints: (issuesWithNoSprint, issuesExcludingEpics)=>({
                flagTitle: formatMessage((0, $94TZV.default).issueCreatedNoSprintOrInBacklogSuccessFlagTitle, {
                    issueCount: issuesExcludingEpics.length
                }),
                flagDescription: formatMessage((0, $94TZV.default).issueCreatedNoSprintSuccessFlagDescription, {
                    issueKey: issuesWithNoSprint[0].issueKey,
                    issueCount: issuesExcludingEpics.length
                }),
                flagActions: (0, $cJGZN.getDefaultFlagActions)({
                    issueList: issueList,
                    issueDiscoveryUrl: issueDiscoveryUrl
                })
            }),
        MultipleIssuesSomeNoSprint: ()=>({
                flagTitle: formatMessage((0, $94TZV.default).multiplesIssuesCreatedSomeNoSprintSuccessFlagTitle),
                flagDescription: formatMessage((0, $94TZV.default).multiplesIssuesCreatedSomeNoSprintSuccessFlagDescription),
                flagActions: (0, $cJGZN.getDefaultFlagActions)({
                    issueList: issueList,
                    issueDiscoveryUrl: issueDiscoveryUrl
                })
            }),
        HiddenScrumIssues: (issues, isFiltered)=>({
                flagTitle: formatMessage((0, $94TZV.default).createdHiddenIssueSuccessFlagTitle, {
                    issueCount: issues.length
                }),
                flagDescription: formatMessage((0, $94TZV.default).scrumCreatedHiddenIssueSuccessFlagDescription, {
                    issueCount: issues.length
                }),
                flagActions: (0, $cJGZN.getHiddenIssuesActions)({
                    issueList: issueList,
                    issueDiscoveryUrl: issueDiscoveryUrl,
                    isFiltered: isFiltered
                })
            }),
        IssuesInBacklog: (issues)=>({
                flagTitle: formatMessage((0, $94TZV.default).issueCreatedNoSprintOrInBacklogSuccessFlagTitle, {
                    issueCount: issues.length
                }),
                flagDescription: formatMessage((0, $94TZV.default).issueCreatedInBacklogSuccessFlagDescription, {
                    issueKey: issues[0].issueKey,
                    issueCount: issues.length
                }),
                flagActions: (0, $cJGZN.getDefaultFlagActions)({
                    issueList: issueList,
                    issueDiscoveryUrl: issueDiscoveryUrl
                })
            }),
        MultipleIssuesSomeInBacklog: ()=>({
                flagTitle: formatMessage((0, $94TZV.default).multiplesIssuesCreatedSomeInBacklogSuccessFlagTitle),
                flagDescription: formatMessage((0, $94TZV.default).multiplesIssuesCreatedSomeInBacklogSuccessFlagDescription),
                flagActions: (0, $cJGZN.getDefaultFlagActions)({
                    issueList: issueList,
                    issueDiscoveryUrl: issueDiscoveryUrl
                })
            }),
        HiddenKanbanIssues: (issues, isFiltered)=>({
                flagTitle: formatMessage((0, $94TZV.default).createdHiddenIssueSuccessFlagTitle, {
                    issueCount: issues.length
                }),
                flagDescription: formatMessage((0, $94TZV.default).kanbanCreatedHiddenIssueSuccessFlagDescription, {
                    issueCount: issues.length
                }),
                flagActions: (0, $cJGZN.getHiddenIssuesActions)({
                    issueList: issueList,
                    issueDiscoveryUrl: issueDiscoveryUrl,
                    isFiltered: isFiltered
                })
            })
    };
    const getFlagContent = ()=>{
        if (successFlagParams) {
            if (getDynamicFlagType() === (0, $43f1e8ead7a5a2a9$export$407f3b8bfd90ad8d)) {
                const { issues: issues, isFiltered: isFiltered, invalidIssuesKeys: invalidIssuesKeys, issuesWithNoSprint: issuesWithNoSprint, issuesExcludingEpics: issuesExcludingEpics, sprints: sprints } = successFlagParams;
                if (issuesWithNoSprint.length > 0) {
                    if (issuesWithNoSprint.length === issuesExcludingEpics.length) {
                        if (sprints.length > 2) return FlagConfigs.IssuesNotInSprintMoreThanTwoActiveSprints(issuesWithNoSprint, issuesExcludingEpics);
                        return FlagConfigs.IssuesNotInSprint(issuesWithNoSprint, issuesExcludingEpics, sprints);
                    }
                    return FlagConfigs.MultipleIssuesSomeNoSprint();
                }
                if (invalidIssuesKeys.length > 0) return FlagConfigs.HiddenScrumIssues(issues, isFiltered);
            } else if (getDynamicFlagType() === (0, $43f1e8ead7a5a2a9$export$256b368007db542a)) {
                const { kanbanIssuesInBacklog: kanbanIssuesInBacklog, invalidIssuesKeys: invalidIssuesKeys, issues: issues, isFiltered: isFiltered } = successFlagParams;
                if (kanbanIssuesInBacklog.length > 0) {
                    if (kanbanIssuesInBacklog.length === issues.length) return FlagConfigs.IssuesInBacklog(issues);
                    return FlagConfigs.MultipleIssuesSomeInBacklog();
                }
                if (invalidIssuesKeys.length > 0) return FlagConfigs.HiddenKanbanIssues(issues, isFiltered);
            }
        }
        return FlagConfigs.Default();
    };
    const { flagTitle: flagTitle, flagDescription: flagDescription, flagActions: flagActions } = getFlagContent();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-issue-key": issueList.map((issue)=>issue.issueKey).join(','),
        "data-testid": (0, $43f1e8ead7a5a2a9$export$2e4c8b336846b593)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cCFSU.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aWvIp))), {
            primaryColor: `var(--ds-icon-success, ${(0, $PdmhA.G300)})`,
            label: "Success"
        }),
        id: (0, $eo17r.fromFlagId)(id),
        key: flagKey,
        title: flagTitle,
        description: flagDescription,
        actions: flagActions,
        onDismissed: ()=>{
            dismissFlag(id);
        }
    }));
};
const $c00e9b87b1664321$var$SuccessFlagWithContext = (props)=>{
    const { id: id } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Vonl.AddToSprintActionStatesContainer), {
        scope: id.valueOf(),
        key: id.valueOf()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($c00e9b87b1664321$export$93bd4963a1d00fd5, props));
};
var $c00e9b87b1664321$export$2e2bcd8739ae039 = $c00e9b87b1664321$var$SuccessFlagWithContext;

});
// Backend types
const $a74d63b8166671c7$export$9a958daafd9a03ed = 'agility-board';
const $a74d63b8166671c7$export$de6b9ed6cd36bad1 = 'core-board';
const $a74d63b8166671c7$export$b4e9cdb19cfa0abb = 'kanban';
const $a74d63b8166671c7$export$4498412e32a31fb6 = 'scrum';

parcelRegister("cCFSU", function(module, exports) {

$parcel$export(module.exports, "default", () => $f59aa209343f0b13$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5L0Jp = parcelRequire("5L0Jp");

var $kQ0RL = parcelRequire("kQ0RL");
const $f59aa209343f0b13$var$AkFlag = ({ packageName: packageName = 'flags', ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5L0Jp.FlagsBoundary), {
        packageName: packageName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $kQ0RL.CommonFlag), {
        flagType: "info",
        ...props
    }));
var $f59aa209343f0b13$export$2e2bcd8739ae039 = $f59aa209343f0b13$var$AkFlag;

});

parcelRegister("6Vonl", function(module, exports) {

$parcel$export(module.exports, "AddToSprintActionStatesContainer", () => $f28006145f6a48f2$export$4ae31d89b87a513);
$parcel$export(module.exports, "useAddToSprintFlagActionStateController", () => $f28006145f6a48f2$export$dc7fffa2c4559368);

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $a61MH = parcelRequire("a61MH");
const $f28006145f6a48f2$var$initialState = {
    addToSprintCTAsEnabled: true
};
const $f28006145f6a48f2$var$actions = {
    disableOtherAddToSprintCTAs: ()=>({ setState: setState })=>{
            setState({
                addToSprintCTAsEnabled: false
            });
        }
};
const $f28006145f6a48f2$var$Store = (0, $a61MH.createStore)({
    initialState: $f28006145f6a48f2$var$initialState,
    actions: $f28006145f6a48f2$var$actions,
    name: 'SuccessFlagAddToSprintActionStateController'
});
const $f28006145f6a48f2$export$4ae31d89b87a513 = (0, $heB5U.createContainer)($f28006145f6a48f2$var$Store);
const $f28006145f6a48f2$export$dc7fffa2c4559368 = (0, $ggKAj.createHook)($f28006145f6a48f2$var$Store);

});

parcelRegister("cJGZN", function(module, exports) {

$parcel$export(module.exports, "getDefaultFlagActions", () => $97fbb1036aaa8ee6$export$6de10317e135f24);
$parcel$export(module.exports, "getNewScrumIssuesWithNoSprintsActions", () => $97fbb1036aaa8ee6$export$882355824d3fc905);
$parcel$export(module.exports, "getHiddenIssuesActions", () => $97fbb1036aaa8ee6$export$f5c2849658ba2a03);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $guiFP = parcelRequire("guiFP");

var $4ksts = parcelRequire("4ksts");

var $fqKjL = parcelRequire("fqKjL");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6Vonl = parcelRequire("6Vonl");


var $fFpUU = parcelRequire("fFpUU");
const $97fbb1036aaa8ee6$export$f2011725fe81878a = (issueList, issueDiscoveryUrl)=>{
    const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const fireViewIssueAnalyticsEvent = (0, $eUqFw.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, (0, $d1b814c754593185$export$71ce489a3b20fc93), {
            isNewGIC: true
        });
    }, [
        createAnalyticsEvent
    ]);
    return {
        content: formatMessage((0, $fFpUU.default).viewIssueCta, {
            issueCount: issueList.length
        }),
        href: issueDiscoveryUrl,
        onClick: fireViewIssueAnalyticsEvent
    };
};
const $97fbb1036aaa8ee6$var$CopyLinkCta = (issueDiscoveryUrl)=>{
    const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [isCopied, setCopied] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        let timeoutId;
        if (isCopied) timeoutId = setTimeout(()=>{
            setCopied(false);
        }, 2000);
        return ()=>{
            timeoutId && clearTimeout(timeoutId);
        };
    }, [
        isCopied
    ]);
    const copyToClipboard = (0, $eUqFw.useCallback)(async ()=>{
        try {
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'link'
            });
            await navigator.clipboard.writeText(`${window.location.origin}${issueDiscoveryUrl}`);
            setCopied(true);
            (0, $jMP2a.fireUIAnalytics)(analyticsEvent, (0, $d1b814c754593185$export$3a43d61edae693a9)); // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                error: error,
                meta: {
                    id: 'copyToClipboard',
                    packageName: 'jiraIssueCreate'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        createAnalyticsEvent,
        issueDiscoveryUrl
    ]);
    return {
        content: isCopied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($97fbb1036aaa8ee6$var$ActionSuccess, null, formatMessage((0, $fFpUU.default).linkCopied)) : formatMessage((0, $fFpUU.default).copyLinkCta),
        onClick: copyToClipboard
    };
};
const $97fbb1036aaa8ee6$var$ClearFiltersCta = ()=>{
    const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [isCompleted, setIsCompleted] = (0, $eUqFw.useState)(false);
    const clearFiltersAction = (0, $eUqFw.useCallback)(()=>{
        (0, $fqKjL.successFlagClearFiltersAction).start();
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        const { GH: GH } = window;
        setIsLoading(true);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, (0, $d1b814c754593185$export$bc715896f18417a3), {
            isNewGIC: true
        });
        GH.WorkController.clearFilters().done(()=>{
            (0, $fqKjL.successFlagClearFiltersAction).stop();
            setIsCompleted(true);
            setIsLoading(false);
        }).fail(()=>{
            (0, $fqKjL.successFlagClearFiltersAction).stop();
            (0, $guiFP.default)({
                meta: {
                    id: 'clearFilters',
                    packageName: 'jiraIssueCreate'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        });
    }, [
        createAnalyticsEvent
    ]);
    if (isLoading) return {
        content: formatMessage((0, $fFpUU.default).clearFiltersCtaLoading)
    };
    if (isCompleted) return {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($97fbb1036aaa8ee6$var$ActionSuccess, null, formatMessage((0, $fFpUU.default).clearFiltersCtaCompleted))
    };
    return {
        content: formatMessage((0, $fFpUU.default).clearFiltersCta),
        onClick: clearFiltersAction
    };
};
const $97fbb1036aaa8ee6$export$54ce82bbc60a8f6e = (issuesWithNoSprint, totalCreatedIssuesCount, sprint)=>{
    const { formatMessage: formatMessage } = (0, $4ksts.useIntlV2)();
    const [isLoading, setIsLoading] = (0, $eUqFw.useState)(false);
    const [isCompleted, setIsCompleted] = (0, $eUqFw.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const [{ addToSprintCTAsEnabled: addToSprintCTAsEnabled }, { disableOtherAddToSprintCTAs: disableOtherAddToSprintCTAs }] = (0, $6Vonl.useAddToSprintFlagActionStateController)();
    const addToSprintAction = (0, $eUqFw.useCallback)(()=>{
        (0, $fqKjL.successFlagAddToSprintAction).start();
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        const { GH: GH } = window;
        disableOtherAddToSprintCTAs();
        setIsLoading(true);
        (0, $jMP2a.fireUIAnalytics)(analyticsEvent, (0, $d1b814c754593185$export$31bef7c6ffa89efa), {
            isNewGIC: true
        });
        GH.WorkController.addNewIssuesToSprintFromJFE(sprint, issuesWithNoSprint).done(()=>{
            (0, $fqKjL.successFlagAddToSprintAction).stop();
            setIsCompleted(true);
            setIsLoading(false);
        }).fail(()=>{
            (0, $fqKjL.successFlagAddToSprintAction).stop();
            (0, $guiFP.default)({
                meta: {
                    id: 'addToSprint',
                    packageName: 'jiraIssueCreate'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        });
    }, [
        createAnalyticsEvent,
        sprint,
        issuesWithNoSprint,
        disableOtherAddToSprintCTAs
    ]);
    if (isLoading) return [
        {
            content: formatMessage((0, $fFpUU.default).addIssuesToSprintCtaLoading)
        }
    ];
    if (isCompleted) return [
        {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($97fbb1036aaa8ee6$var$ActionSuccess, null, formatMessage((0, $fFpUU.default).addIssuesToSprintCtaCompleted))
        }
    ];
    if (addToSprintCTAsEnabled) return [
        {
            content: formatMessage((0, $fFpUU.default).addAllIssuesToSprintCta, {
                sprintName: sprint.name
            }),
            onClick: addToSprintAction
        }
    ];
    return [];
};
const $97fbb1036aaa8ee6$var$getAddToSprintsCtas = (issuesWithNoSprint, issueList, sprints)=>{
    const editableSprints = sprints.filter((sprint)=>sprint.canUpdateSprint);
    const totalCreatedIssuesCount = issueList.length;
    let ctaList = [];
    editableSprints.forEach((sprint)=>{
        ctaList = ctaList.concat($97fbb1036aaa8ee6$export$54ce82bbc60a8f6e(issuesWithNoSprint, totalCreatedIssuesCount, sprint));
    });
    return ctaList;
};
const $97fbb1036aaa8ee6$export$6de10317e135f24 = ({ issueList: issueList, issueDiscoveryUrl: issueDiscoveryUrl })=>[
        $97fbb1036aaa8ee6$export$f2011725fe81878a(issueList, issueDiscoveryUrl),
        $97fbb1036aaa8ee6$var$CopyLinkCta(issueDiscoveryUrl)
    ];
const $97fbb1036aaa8ee6$export$882355824d3fc905 = ({ issueList: issueList, issueDiscoveryUrl: issueDiscoveryUrl, issuesWithNoSprint: issuesWithNoSprint, sprints: sprints })=>{
    const ctaList = $97fbb1036aaa8ee6$var$getAddToSprintsCtas(issuesWithNoSprint, issueList, sprints);
    ctaList.push($97fbb1036aaa8ee6$export$f2011725fe81878a(issueList, issueDiscoveryUrl));
    return ctaList;
};
const $97fbb1036aaa8ee6$export$f5c2849658ba2a03 = ({ issueList: issueList, issueDiscoveryUrl: issueDiscoveryUrl, isFiltered: isFiltered })=>{
    const ctaList = [
        $97fbb1036aaa8ee6$export$f2011725fe81878a(issueList, issueDiscoveryUrl)
    ];
    if (isFiltered) ctaList.push($97fbb1036aaa8ee6$var$ClearFiltersCta());
    return ctaList;
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $97fbb1036aaa8ee6$var$ActionSuccess = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syazocqs",
            __cmplp.className
        ])
    });
});

});
const $d1b814c754593185$export$71ce489a3b20fc93 = 'viewIssues';
const $d1b814c754593185$export$3a43d61edae693a9 = 'copyLink';
const $d1b814c754593185$export$31bef7c6ffa89efa = 'addToSprint';
const $d1b814c754593185$export$bc715896f18417a3 = 'clearFilters';

parcelRegister("fFpUU", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a3c8d911e2cb871$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $3a3c8d911e2cb871$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    viewIssueCta: {
        "id": "issue-create.modal.success-flag.actions.view-issue-cta",
        "defaultMessage": "View {issueCount, plural, one {issue} other {issues}}"
    },
    copyLinkCta: {
        "id": "issue-create.modal.success-flag.actions.copy-link-cta",
        "defaultMessage": "Copy link"
    },
    linkCopied: {
        "id": "issue-create.modal.success-flag.actions.link-copied",
        "defaultMessage": "Copied"
    },
    addAllIssuesToSprintCta: {
        "id": "issue-create.modal.success-flag.actions.add-all-issues-to-sprint-cta",
        "defaultMessage": "Add to {sprintName}"
    },
    clearFiltersCta: {
        "id": "issue-create.modal.success-flag.actions.clear-filters-cta",
        "defaultMessage": "Clear filters"
    },
    clearFiltersCtaLoading: {
        "id": "issue-create.modal.success-flag.actions.clear-filters-cta-loading",
        "defaultMessage": "Clearing..."
    },
    clearFiltersCtaCompleted: {
        "id": "issue-create.modal.success-flag.actions.clear-filters-cta-completed",
        "defaultMessage": "Filters cleared"
    },
    addIssuesToSprintCtaLoading: {
        "id": "issue-create.modal.success-flag.actions.add-issues-to-sprint-cta-loading",
        "defaultMessage": "Adding..."
    },
    addIssuesToSprintCtaCompleted: {
        "id": "issue-create.modal.success-flag.actions.add-issues-to-sprint-cta-completed",
        "defaultMessage": "Added to sprint"
    }
});

});


const $43f1e8ead7a5a2a9$export$2e4c8b336846b593 = 'jira-issue-create.modal.create-form.success-flag';
const $43f1e8ead7a5a2a9$export$407f3b8bfd90ad8d = 'cmp-scrum-flag';
const $43f1e8ead7a5a2a9$export$256b368007db542a = 'cmp-kanban-flag';
const $43f1e8ead7a5a2a9$export$858ff9c1b12e1d84 = 'default-success-flag';

parcelRegister("94TZV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2396a99e948b466$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $d2396a99e948b466$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    createSuccessFlagTitle: {
        "id": "issue-create.modal.success-flag.create-success-flag-title",
        "defaultMessage": "You've created \"{issueKey}\" issue"
    },
    multiplesIssuesCreatedSuccessFlagTitle: {
        "id": "issue-create.modal.success-flag.multiples-issues-created-success-flag-title",
        "defaultMessage": "You've created {issueCount, plural, one {# issue} other {# issues}}"
    },
    issueCreatedNoSprintOrInBacklogSuccessFlagTitle: {
        "id": "issue-create.modal.success-flag.issue-created-no-sprint-or-in-backlog-success-flag-title",
        "defaultMessage": "{issueCount, plural, one {Issue} other {Issues}} added to the backlog"
    },
    issueCreatedNoSprintSuccessFlagDescription: {
        "id": "issue-create.modal.success-flag.issue-created-no-sprint-success-flag-description",
        "defaultMessage": "{issueCount, plural, one {Your issue {issueKey} has} other {Your issues have}} been created and added to the backlog."
    },
    multiplesIssuesCreatedSomeNoSprintSuccessFlagTitle: {
        "id": "issue-create.modal.success-flag.multiples-issues-created-some-no-sprint-success-flag-title",
        "defaultMessage": "Issues added to sprint(s) and backlog"
    },
    multiplesIssuesCreatedSomeNoSprintSuccessFlagDescription: {
        "id": "issue-create.modal.success-flag.multiples-issues-created-some-no-sprint-success-flag-description",
        "defaultMessage": "Some of your issues weren't added to a sprint."
    },
    createdHiddenIssueSuccessFlagTitle: {
        "id": "issue-create.modal.success-flag.created-hidden-issue-success-flag-title",
        "defaultMessage": "{issueCount, plural, one {Issue} other {Issues}} created but not visible"
    },
    scrumCreatedHiddenIssueSuccessFlagDescription: {
        "id": "issue-create.modal.success-flag.scrum-created-hidden-issue-success-flag-description",
        "defaultMessage": "{issueCount, plural, one {If the board has active filters, or the issue was added to a different sprint, it may not be visible} other {If the board has active filters, or the issues were added to a different sprint, they may not be visible}}."
    },
    issueCreatedInBacklogSuccessFlagDescription: {
        "id": "issue-create.modal.success-flag.issue-created-in-backlog-success-flag-description",
        "defaultMessage": "{issueCount, plural, one {Your issue {issueKey} has been created, but isn't on the board} other {Your issues have been created, but aren't on the board}}."
    },
    multiplesIssuesCreatedSomeInBacklogSuccessFlagTitle: {
        "id": "issue-create.modal.success-flag.multiples-issues-created-some-in-backlog-success-flag-title",
        "defaultMessage": "Issues added to board and backlog"
    },
    multiplesIssuesCreatedSomeInBacklogSuccessFlagDescription: {
        "id": "issue-create.modal.success-flag.multiples-issues-created-some-in-backlog-success-flag-description",
        "defaultMessage": "Your issues have been created, but some aren't on the board."
    },
    kanbanCreatedHiddenIssueSuccessFlagDescription: {
        "id": "issue-create.modal.success-flag.kanban-created-hidden-issue-success-flag-description",
        "defaultMessage": "{issueCount, plural, one {If the board has active filters, or the issue wasn't added to the board, it may not be visible} other {If the board has active filters, or the issues weren't added to the board, they may not be visible}}."
    }
});

});


parcelRegister("cZzZr", function(module, exports) {

$parcel$export(module.exports, "AsyncTempSwitchExperinceModal", () => $e3fbdca165df8ccd$export$5009835d7a634056);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $0cdA8 = parcelRequire("0cdA8");

var $gGtKh = parcelRequire("gGtKh");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $e3fbdca165df8ccd$var$TempSwitchExperienceModal = (0, $7rh0R.lazy)(()=>(parcelRequire("ca2dO")), {
    moduleId: "./src/packages/issue-create/issue-create-modal/src/ui/modal/temp-switch-experience-modal/modal/index.tsx"
});
const $e3fbdca165df8ccd$export$5009835d7a634056 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "temp-switch-experience-modal",
        packageName: "jiraIssueCreate",
        sendToPrivacyUnsafeSplunk: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gGtKh.default), {
        name: "temp-switch-experience-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e3fbdca165df8ccd$var$TempSwitchExperienceModal, props)));

});
parcelRegister("ca2dO", function(module, exports) {


if (globalThis.featureFlags?.["uip.bundler.dynamic-import-retry"]?.value === true) {
    let load = (parcelRequire("chRvw"));
    async function get() {
        await load('1SlqT');
        const value = parcelRequire('gW9TQ');
        Object.defineProperty(module, 'exports', {
            value: Promise.resolve(value)
        });
        return value;
    }
    Object.defineProperty(module, 'exports', {
        get: get
    });
} else {
    let load = (parcelRequire("chRvw"));
    module.exports = load("1SlqT").then(()=>parcelRequire('gW9TQ'));
}

});


parcelRegister("ajNlY", function(module, exports) {

$parcel$export(module.exports, "getFirstFieldIdWithError", () => $6576b5528b2ea816$export$f15841b83bf0d927);
$parcel$export(module.exports, "publishCreatedIssues", () => $6576b5528b2ea816$export$d46eb3aee2ce61a5);
$parcel$export(module.exports, "getTabIndexWithError", () => $6576b5528b2ea816$export$1d81ee131c803e88);
$parcel$export(module.exports, "getWatchersFlagConfigFromResponse", () => $6576b5528b2ea816$export$47ea475ac70a5697);

var $8blac = parcelRequire("8blac");

var $3aUuh = parcelRequire("3aUuh");

var $7pmxV = parcelRequire("7pmxV");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $lRmyA = parcelRequire("lRmyA");

var $dEMIg = parcelRequire("dEMIg");

var $dNWQB = parcelRequire("dNWQB");

var $aB9d0 = parcelRequire("aB9d0");
const $6576b5528b2ea816$export$8d7a103b266a4496 = '/rest/api/3/search';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $6576b5528b2ea816$var$issueDataTillNow = {};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let $6576b5528b2ea816$var$activePromises = {};
const $6576b5528b2ea816$export$f15841b83bf0d927 = ({ fields: fields, emptyRequiredFields: emptyRequiredFields })=>{
    if (emptyRequiredFields) return fields.find((fieldId)=>{
        if (emptyRequiredFields.includes(fieldId)) return true;
        // handling multi input field errors separately because it contains different error keys
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly worklog: readonly ["worklog_adjustmentAmount", "worklog_adjustEstimate", "worklog_activate", "worklog_timeLogged", "worklog_newEstimate", "worklog_startDate", "worklog_description"]; readonly issuelinks: readonly [...]; }'.
        if ((0, $dEMIg.MULTI_INPUT_FIELDS_ERROR_KEYS)[fieldId]) return emptyRequiredFields.some((key)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly worklog: readonly ["worklog_adjustmentAmount", "worklog_adjustEstimate", "worklog_activate", "worklog_timeLogged", "worklog_newEstimate", "worklog_startDate", "worklog_description"]; readonly issuelinks: readonly [...]; }'.
            (0, $dEMIg.MULTI_INPUT_FIELDS_ERROR_KEYS)[fieldId].includes(key));
        return false;
    });
    return undefined;
};
const $6576b5528b2ea816$var$fetchIssueListPromise = (jql, fieldsToAddInPublishedData)=>{
    if ($6576b5528b2ea816$var$activePromises[jql] === undefined) $6576b5528b2ea816$var$activePromises[jql] = (0, $lRmyA.performPostRequest)($6576b5528b2ea816$export$8d7a103b266a4496, {
        body: JSON.stringify({
            jql: jql,
            fields: [
                ...new Set([
                    'summary',
                    'status',
                    'assignee',
                    'duedate',
                    'project',
                    'issuetype',
                    'priority',
                    'issuelinks',
                    ...fieldsToAddInPublishedData
                ])
            ]
        })
    });
    return $6576b5528b2ea816$var$activePromises[jql];
};
const $6576b5528b2ea816$var$getIssueList = async (createdIssues, fieldsToAddInPublishedData)=>{
    // Get list of issues that have not been fetched before
    const issuesToFetch = createdIssues.filter(({ issueKey: issueKey })=>!$6576b5528b2ea816$var$issueDataTillNow[issueKey]);
    let newIssueDetails = {
        issues: []
    };
    if (issuesToFetch.length) {
        // API call is made only if there are issues that needs to be fetched
        const jql = issuesToFetch.reduce((jqlQuery, { issueKey: issueKey }, index)=>`${jqlQuery}issuekey=${issueKey}${index !== issuesToFetch.length - 1 ? ' OR ' : ''}`, '');
        try {
            newIssueDetails = await $6576b5528b2ea816$var$fetchIssueListPromise(jql, fieldsToAddInPublishedData);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $guiFP.default)({
                meta: {
                    id: 'getIssueList',
                    packageName: 'jiraIssueCreate',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            $6576b5528b2ea816$var$activePromises[jql] = undefined;
        }
    }
    const prefetchedIssueDetails = createdIssues.filter(({ issueKey: issueKey })=>$6576b5528b2ea816$var$issueDataTillNow[issueKey]).map(({ issueKey: issueKey })=>$6576b5528b2ea816$var$issueDataTillNow[issueKey].createdIssueDetails);
    return {
        issues: [
            ...prefetchedIssueDetails,
            ...newIssueDetails.issues
        ]
    };
};
const $6576b5528b2ea816$var$merge = (obj, obj2)=>({
        ...obj,
        ...obj2
    });
const $6576b5528b2ea816$export$d46eb3aee2ce61a5 = async ({ createdIssues: createdIssues, globalEventNamespaces: globalEventNamespaces = [
    (0, $dEMIg.GLOBAL_EVENT_NAMESPACE)
], fieldsToAddInPublishedData: fieldsToAddInPublishedData = [], alertsToBeLinked: alertsToBeLinked = [], isSessionComplete: isSessionComplete = false, onIssueCreate: onIssueCreate, siteDomain: siteDomain, selectedCloudId: selectedCloudId, onClose: onClose, triggerPointKey: triggerPointKey, publishGICLifecycle: publishGICLifecycle, isIssueCreateSuccess: isIssueCreateSuccess, callbackPayload: callbackPayload, jqlSwimlaneId: jqlSwimlaneId }, fireErrorAnalytics = (0, $guiFP.default))=>{
    if (createdIssues.length) {
        /**
		 * We need to unregister the SPA global issue create event handlers so that new issue create can use its
		 * default ones which render the success and error flag in a different place
		 */ let oldFlagUnbindSuccess = false;
        try {
            window.require('jira/common/header').unbind();
            oldFlagUnbindSuccess = true;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            oldFlagUnbindSuccess = false;
        }
        try {
            const issueSearchRequest = $6576b5528b2ea816$var$getIssueList(createdIssues, fieldsToAddInPublishedData);
            const [issueList, Events] = await Promise.all([
                issueSearchRequest,
                (0, $7pmxV.apiReady)()
            ]);
            const issueData = (0, (/*@__PURE__*/$parcel$interopDefault($3aUuh)))(issueList.issues, 'key');
            const createdIssuesWithIssueData = createdIssues.map((createdIssue)=>{
                const createdIssueDetails = issueData[createdIssue.issueKey];
                const summary = createdIssueDetails?.fields?.summary;
                return {
                    ...createdIssue,
                    summary: summary,
                    createdIssueDetails: createdIssueDetails,
                    selectedCloudId: selectedCloudId,
                    ...(0, $1ybV0.ff)('icc-for-query-swimlanes') ? {
                        jqlSwimlaneId: jqlSwimlaneId
                    } : {}
                };
            });
            $6576b5528b2ea816$var$issueDataTillNow = $6576b5528b2ea816$var$merge($6576b5528b2ea816$var$issueDataTillNow, (0, (/*@__PURE__*/$parcel$interopDefault($3aUuh)))(createdIssuesWithIssueData, 'issueKey'));
            if (isIssueCreateSuccess) // ideally createdIssuesWithIssueData will contain a single element
            createdIssuesWithIssueData.forEach((createdIssue)=>{
                if ((0, $1ybV0.ff)('linked-alerts-in-gic_onvr6')) onIssueCreate?.(siteDomain ? {
                    ...createdIssue,
                    siteDomain: siteDomain
                } : createdIssue, alertsToBeLinked);
                else onIssueCreate?.(siteDomain ? {
                    ...createdIssue,
                    siteDomain: siteDomain
                } : createdIssue);
                publishGICLifecycle?.((0, $dNWQB.GIC_LIFECYCLE_EVENTS).ISSUE_CREATE_SUCCESS, {
                    createdIssueData: createdIssue,
                    callbackPayload: callbackPayload
                });
            });
            if (isSessionComplete) {
                globalEventNamespaces.forEach((namespace)=>{
                    if (triggerPointKey !== undefined) Events?.trigger?.(`${namespace}.sessionComplete`, [
                        createdIssuesWithIssueData,
                        triggerPointKey
                    ]);
                    else Events?.trigger?.(`${namespace}.sessionComplete`, [
                        createdIssuesWithIssueData
                    ]);
                });
                onClose?.(createdIssuesWithIssueData);
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            fireErrorAnalytics({
                meta: {
                    id: 'publishCreatedIssues',
                    packageName: 'jiraIssueCreate',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
        if (isSessionComplete) {
            $6576b5528b2ea816$var$issueDataTillNow = {};
            $6576b5528b2ea816$var$activePromises = {};
        }
        /**
		 * On cleanup we need to re-register the legacy issue create event handlers which will override the
		 * allow non-migrated triggers to show flag
		 */ if (oldFlagUnbindSuccess && isSessionComplete) window.require('jira/common/header').initialize();
    } else if (isSessionComplete) onClose && onClose([]);
};
const $6576b5528b2ea816$export$1d81ee131c803e88 = (fieldTabs, fieldValues, requiredFieldsData)=>{
    if (!fieldValues) return -1;
    const emptyRequiredField = Object.keys(fieldValues)?.find((id)=>requiredFieldsData[id] && Boolean(requiredFieldsData[id].isRequired) && fieldValues && (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(fieldValues[id]));
    const tabIndex = fieldTabs?.findIndex((tab)=>tab.items.find((item)=>item === emptyRequiredField));
    return tabIndex > -1 ? tabIndex : -1;
};
const $6576b5528b2ea816$export$47ea475ac70a5697 = (response)=>{
    if (response?.errorCollection && response.errorCollection.errorMessages[0]) return {
        type: 'error',
        title: (0, $aB9d0.default).watchersErrorFlagTitle,
        description: response.errorCollection.errorMessages[0]
    };
    if (response?.warningCollection && response.warningCollection.warnings[0]) return {
        type: 'warning',
        title: (0, $aB9d0.default).watchersWarningFlagTitle,
        description: response.warningCollection.warnings[0]
    };
    return undefined;
};

});
parcelRegister("3aUuh", function(module, exports) {

var $3pSMu = parcelRequire("3pSMu");

var $f2sQe = parcelRequire("f2sQe");
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */ var $24fe1f7ac78dbb37$var$keyBy = $f2sQe(function(result, value, key) {
    $3pSMu(result, key, value);
});
module.exports = $24fe1f7ac78dbb37$var$keyBy;

});

parcelRegister("7pmxV", function(module, exports) {

$parcel$export(module.exports, "apiReady", () => $255e282260d8623a$export$330fb1a04c974aad);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $2BvS3 = parcelRequire("2BvS3");
let $255e282260d8623a$var$currentBridge;
const $255e282260d8623a$export$330fb1a04c974aad = async ()=>{
    if ($255e282260d8623a$var$currentBridge) return $255e282260d8623a$var$currentBridge;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/wrm/no-load-bridge
    const Events = await (0, $2BvS3.loadBridge)({
        name: 'jira/util/events',
        wrmKeys: 'wrc!jira.webresources:jira-events'
    });
    $255e282260d8623a$var$currentBridge = Events;
    return Events;
};

});

parcelRegister("aB9d0", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf369437b80f3431$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $cf369437b80f3431$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    watchersWarningFlagTitle: {
        "id": "issue-create.modal.watchers-warning-flag-title",
        "defaultMessage": "Watchers not added to your issue"
    },
    watchersErrorFlagTitle: {
        "id": "issue-create.modal.watchers-error-flag-title",
        "defaultMessage": "Something went wrong"
    }
});

});



parcelRegister("avcum", function(module, exports) {

$parcel$export(module.exports, "IssueRestoreWrapper", () => $e0a9338e05c2723c$export$c5abd224bc075aa5);

var $eUqFw = parcelRequire("eUqFw");

var $fswni = parcelRequire("fswni");

var $hTrLj = parcelRequire("hTrLj");

var $ctR9z = parcelRequire("ctR9z");
const $e0a9338e05c2723c$export$c5abd224bc075aa5 = ({ children: children })=>{
    const [, { restoreState: restoreTriggerIssueCreateModalState }] = (0, $ctR9z.useTriggerIssueCreateModal)();
    const [, { restoreState: restoreFormContext }] = (0, $fswni.useFormContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hTrLj.IssueRestore), {
        onRestoreTriggerIssueCreateModalState: restoreTriggerIssueCreateModalState,
        onRestoreFormContext: restoreFormContext
    }, children);
};

});
parcelRegister("hTrLj", function(module, exports) {

$parcel$export(module.exports, "IssueRestore", () => $bc767c6e42f4f901$export$20995982965fe5e9);

var $eUqFw = parcelRequire("eUqFw");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $6RCgV = parcelRequire("6RCgV");

var $hgWTX = parcelRequire("hgWTX");

var $678Nu = parcelRequire("678Nu");
var $1QpcB = parcelRequire("1QpcB");

var $g2M7o = parcelRequire("g2M7o");

var $8OXEV = parcelRequire("8OXEV");
const $bc767c6e42f4f901$var$IssueRestoreInner = ({ children: children, ...rest })=>{
    const [{ inProgressIssueMetas: inProgressIssueMetas, isInitialised: isInitialised }, { init: init }] = (0, $hgWTX.useIssueRestoreMeta)();
    const inProgressIssueService = (0, $678Nu.useInProgressIssueService)();
    (0, $eUqFw.useEffect)(()=>{
        if (!isInitialised) init();
    }, [
        isInitialised,
        init
    ]);
    // To future proof for bulk issue create
    const activeInProgressIssueID = inProgressIssueMetas?.[0]?.inProgressIssueID;
    const activeShouldRestore = inProgressIssueMetas?.[0]?.shouldRestore;
    if (isInitialised) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6RCgV.InProgressIssueStoreContainer), {
        inProgressIssueService: inProgressIssueService
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g2M7o.InProgressIssueInitialiser), {
        inProgressIssueID: activeInProgressIssueID,
        shouldRestore: activeShouldRestore,
        ...rest
    }, children));
    return null;
};
const $bc767c6e42f4f901$export$20995982965fe5e9 = ({ children: children, ...rest })=>{
    const issueRestoreMetaService = (0, $1QpcB.useIssueRestoreMetaService)();
    const [indexedDBAvailable] = (0, $eUqFw.useState)((0, $8OXEV.isIndexedDBAvailable)());
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        if (!indexedDBAvailable) (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'indexedDB missing');
    }, [
        createAnalyticsEvent,
        indexedDBAvailable
    ]);
    if (!indexedDBAvailable) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children?.({}));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hgWTX.IssueRestoreMetaContainer), {
        issueRestoreMetaService: issueRestoreMetaService
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($bc767c6e42f4f901$var$IssueRestoreInner, rest, children));
};

});
parcelRegister("6RCgV", function(module, exports) {

$parcel$export(module.exports, "useInProgressIssue", () => $e6c45d74f9b405c3$export$4b6bb26ceba91de6);
$parcel$export(module.exports, "InProgressIssueStoreContainer", () => $e6c45d74f9b405c3$export$bd3e62a8e8bf35);
$parcel$export(module.exports, "useInProgressIssueActions", () => $e6c45d74f9b405c3$export$74b9a754a809ff62);
$parcel$export(module.exports, "useIsFormDirty", () => $e6c45d74f9b405c3$export$99feafa9b9955d05);
$parcel$export(module.exports, "useIsModalOpen", () => $e6c45d74f9b405c3$export$c09953967ff9ffea);

var $hTLlD = parcelRequire("hTLlD");

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");

var $guiFP = parcelRequire("guiFP");

var $hnUIP = parcelRequire("hnUIP");
const $e6c45d74f9b405c3$export$d4c72bab9d6cc13a = {
    isInitialised: false,
    isSavingCounter: 0,
    id: '',
    formData: {},
    formDataDefaultValues: {},
    formContext: {},
    triggerIssueCreateModalState: undefined,
    statusField: {},
    restoreError: undefined
};
let $e6c45d74f9b405c3$var$hasFiredUnexpectedEventErrorAnalytics = false;
const $e6c45d74f9b405c3$export$2cd70be39fa29781 = ()=>{
    $e6c45d74f9b405c3$var$hasFiredUnexpectedEventErrorAnalytics = false;
};
const $e6c45d74f9b405c3$var$fireUnexpectedEventErrorAnalytics = (eventName, state)=>{
    // Prevent errors from firing too often, otherwise we mind fire this on each keypress of field update by accident
    if ($e6c45d74f9b405c3$var$hasFiredUnexpectedEventErrorAnalytics) return;
    $e6c45d74f9b405c3$var$hasFiredUnexpectedEventErrorAnalytics = true;
    (0, $guiFP.default)({
        meta: {
            id: 'useInProgressIssueService',
            packageName: 'jiraIssueCreateRestore'
        },
        attributes: {
            inProgressIssueID: state?.id,
            isModalOpen: state?.triggerIssueCreateModalState?.isModalOpen,
            wasStateRestored: state?.triggerIssueCreateModalState?.wasStateRestored,
            minimizableModalView: state?.triggerIssueCreateModalState?.minimizableModalView,
            eventName: eventName
        },
        error: new Error('InProgressIssue - unexpected event fired'),
        sendToPrivacyUnsafeSplunk: true
    });
};
const $e6c45d74f9b405c3$var$THROTTLE_DELAY = 250;
const $e6c45d74f9b405c3$export$e324594224ef24da = {
    onTriggerIssueCreateModalStateChange: (triggerIssueCreateModalState)=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
            const currentState = getState();
            if (!(currentState.id || triggerIssueCreateModalState.inProgressIssueID) || !(currentState?.triggerIssueCreateModalState?.isModalOpen || triggerIssueCreateModalState?.isModalOpen)) return;
            // Preventing Project, Issue type and Request type from being updated
            const overridePayload = {
                project: currentState?.triggerIssueCreateModalState?.payload?.project,
                issueType: currentState?.triggerIssueCreateModalState?.payload?.issueType,
                requestType: currentState?.triggerIssueCreateModalState?.payload?.requestType
            };
            const newPayload = {
                ...triggerIssueCreateModalState.payload || {},
                ...overridePayload
            };
            setState({
                id: triggerIssueCreateModalState.inProgressIssueID,
                isSavingCounter: currentState.isSavingCounter + 1,
                triggerIssueCreateModalState: {
                    ...triggerIssueCreateModalState,
                    payload: newPayload
                }
            });
            const { updateInProgressIssue: updateInProgressIssue } = inProgressIssueService;
            const newState = getState();
            try {
                await updateInProgressIssue(newState.id, (0, $hnUIP.convertStateToInProgressIssueForStorage)(newState));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $guiFP.default)({
                    meta: {
                        id: 'useInProgressIssueService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    attributes: {
                        eventName: 'onTriggerIssueCreateModalStateChange'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    restoreError: error
                });
            }
            setState({
                isSavingCounter: getState().isSavingCounter - 1
            });
        },
    onFormFieldUpdate: ({ fieldId: fieldId, value: value })=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
            const currentState = getState();
            if (!currentState?.id || !currentState?.triggerIssueCreateModalState?.isModalOpen) {
                $e6c45d74f9b405c3$var$fireUnexpectedEventErrorAnalytics('onFormFieldUpdate', currentState);
                return;
            }
            const newFormData = {
                ...currentState.formData,
                [fieldId]: value
            };
            setState({
                isSavingCounter: currentState.isSavingCounter + 1,
                formData: newFormData
            });
            const { updateInProgressIssue: updateInProgressIssue } = inProgressIssueService;
            try {
                await updateInProgressIssue(currentState.id, (0, $hnUIP.convertStateToInProgressIssueForStorage)(getState()));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $guiFP.default)({
                    meta: {
                        id: 'useInProgressIssueService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    attributes: {
                        eventName: 'onFormFieldUpdate'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    restoreError: error
                });
            }
            // Resetting is saving counter should be delayed until after throttle
            // execution to allow us to show a prompt if page unloads in between
            // invocations
            setTimeout(()=>{
                setState({
                    isSavingCounter: getState().isSavingCounter - 1
                });
            }, $e6c45d74f9b405c3$var$THROTTLE_DELAY + 1);
        },
    onClassificationLevelFieldChange: (classificationLevelField)=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
            const currentState = getState();
            if (!currentState?.id || !currentState?.triggerIssueCreateModalState?.isModalOpen) {
                $e6c45d74f9b405c3$var$fireUnexpectedEventErrorAnalytics('onClassificationLevelFieldChange', currentState);
                return;
            }
            setState({
                isSavingCounter: getState().isSavingCounter + 1,
                classificationLevelField: classificationLevelField
            });
            const { updateInProgressIssue: updateInProgressIssue } = inProgressIssueService;
            const newState = getState();
            try {
                await updateInProgressIssue(newState.id, (0, $hnUIP.convertStateToInProgressIssueForStorage)(newState));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $guiFP.default)({
                    meta: {
                        id: 'useInProgressIssueService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    attributes: {
                        eventName: 'onClassificationLevelFieldChange'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    restoreError: error
                });
            }
            setState({
                isSavingCounter: getState().isSavingCounter - 1
            });
        },
    onStatusFieldChange: (statusField)=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
            const currentState = getState();
            if (!currentState?.id || !currentState?.triggerIssueCreateModalState?.isModalOpen) {
                $e6c45d74f9b405c3$var$fireUnexpectedEventErrorAnalytics('onStatusFieldChange', currentState);
                return;
            }
            setState({
                isSavingCounter: getState().isSavingCounter + 1,
                statusField: statusField
            });
            const { updateInProgressIssue: updateInProgressIssue } = inProgressIssueService;
            const newState = getState();
            try {
                await updateInProgressIssue(newState.id, (0, $hnUIP.convertStateToInProgressIssueForStorage)(newState));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $guiFP.default)({
                    meta: {
                        id: 'useInProgressIssueService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    attributes: {
                        eventName: 'onStatusFieldChange'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    restoreError: error
                });
            }
            setState({
                isSavingCounter: getState().isSavingCounter - 1
            });
        },
    onFormContextUpdate: (formContext)=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
            const currentState = getState();
            const { id: id, triggerIssueCreateModalState: triggerIssueCreateModalState, isSavingCounter: isSavingCounter } = currentState;
            if (!id || !triggerIssueCreateModalState || !triggerIssueCreateModalState.isModalOpen) return;
            const currentFormContext = currentState.formContext;
            const newFormContext = formContext;
            if (triggerIssueCreateModalState && !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(newFormContext, currentFormContext)) {
                const currentPayload = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                triggerIssueCreateModalState.payload;
                const selectedIssueAndRequestType = newFormContext.selectedIssueType ? {
                    issueType: {
                        issueTypeId: (0, $hnUIP.isRequestType)(newFormContext.selectedIssueType) ? newFormContext.selectedIssueType.issueTypeId : newFormContext.selectedIssueType?.value
                    },
                    requestType: (0, $hnUIP.isRequestType)(newFormContext.selectedIssueType) ? {
                        key: newFormContext.selectedIssueType.requestTypeKey
                    } : undefined
                } : undefined;
                const newTriggerIssueCreateModalState = {
                    ...triggerIssueCreateModalState,
                    payload: {
                        ...currentPayload,
                        project: {
                            projectId: newFormContext.selectedProject?.value
                        },
                        ...selectedIssueAndRequestType
                    }
                };
                const newState = {
                    isSavingCounter: isSavingCounter + 1,
                    formContext: newFormContext,
                    triggerIssueCreateModalState: newTriggerIssueCreateModalState
                };
                setState(newState);
                const { updateInProgressIssue: updateInProgressIssue } = inProgressIssueService;
                try {
                    await updateInProgressIssue(id, (0, $hnUIP.convertStateToInProgressIssueForStorage)(getState()));
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    (0, $guiFP.default)({
                        meta: {
                            id: 'useInProgressIssueService',
                            packageName: 'jiraIssueCreateRestore'
                        },
                        error: error,
                        attributes: {
                            eventName: 'onFormContextUpdate'
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                    setState({
                        restoreError: error
                    });
                }
                setState({
                    isSavingCounter: getState().isSavingCounter - 1
                });
            }
        },
    onModalOpened: ({ inProgressIssueID: inProgressIssueID })=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
            const { createInProgressIssue: createInProgressIssue } = inProgressIssueService;
            const newState = {
                ...getState(),
                id: inProgressIssueID
            };
            setState(newState);
            try {
                await createInProgressIssue(inProgressIssueID, (0, $hnUIP.convertStateToInProgressIssueForStorage)(newState));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $guiFP.default)({
                    meta: {
                        id: 'useInProgressIssueService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    attributes: {
                        eventName: 'onModalOpened'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    restoreError: error
                });
            }
        },
    onModalClosed: ({ inProgressIssueID: inProgressIssueID })=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
            if (inProgressIssueID === getState().id) {
                setState({
                    ...$e6c45d74f9b405c3$export$d4c72bab9d6cc13a,
                    isInitialised: true,
                    restoreError: undefined
                });
                const { deleteInProgressIssue: deleteInProgressIssue } = inProgressIssueService;
                try {
                    await deleteInProgressIssue(inProgressIssueID);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    (0, $guiFP.default)({
                        meta: {
                            id: 'useInProgressIssueService',
                            packageName: 'jiraIssueCreateRestore'
                        },
                        error: error,
                        attributes: {
                            eventName: 'onModalClosed'
                        },
                        sendToPrivacyUnsafeSplunk: true
                    });
                    setState({
                        restoreError: error
                    });
                }
            }
        },
    onModalDiscardExistingInProgressIssue: ()=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
            const state = getState();
            setState({
                ...$e6c45d74f9b405c3$export$d4c72bab9d6cc13a,
                isSavingCounter: state.isSavingCounter + 1,
                id: state.id,
                triggerIssueCreateModalState: state.triggerIssueCreateModalState,
                formContext: state.formContext,
                isInitialised: true,
                restoreError: undefined
            });
            const { updateInProgressIssue: updateInProgressIssue } = inProgressIssueService;
            try {
                await updateInProgressIssue(state.id, (0, $hnUIP.convertStateToInProgressIssueForStorage)(getState()));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $guiFP.default)({
                    meta: {
                        id: 'useInProgressIssueService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    attributes: {
                        eventName: 'onModalDiscardExistingInProgressIssue'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    restoreError: error
                });
            }
            setState({
                isSavingCounter: getState().isSavingCounter - 1
            });
        },
    onResetFormFieldsForCreateAnother: (fieldsReset)=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
            const currentState = getState();
            if (!currentState?.id || !currentState?.triggerIssueCreateModalState?.isModalOpen) {
                $e6c45d74f9b405c3$var$fireUnexpectedEventErrorAnalytics('onResetFormFieldsForCreateAnother', currentState);
                return;
            }
            const newFormData = {
                ...currentState.formData,
                ...fieldsReset.fieldsReset
            };
            setState({
                isSavingCounter: currentState.isSavingCounter + 1,
                formData: newFormData
            });
            const { updateInProgressIssue: updateInProgressIssue } = inProgressIssueService;
            try {
                await updateInProgressIssue(currentState.id, (0, $hnUIP.convertStateToInProgressIssueForStorage)(getState()));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $guiFP.default)({
                    meta: {
                        id: 'useInProgressIssueService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    attributes: {
                        eventName: 'onResetFormFieldsForCreateAnother'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    restoreError: error
                });
            }
            setState({
                isSavingCounter: getState().isSavingCounter - 1
            });
        },
    onReinsertIntoBrowserStorage: ()=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
            const currentState = getState();
            if (!currentState?.id || !currentState?.triggerIssueCreateModalState?.isModalOpen) {
                $e6c45d74f9b405c3$var$fireUnexpectedEventErrorAnalytics('onReinsertIntoBrowserStorage', currentState);
                return;
            }
            setState({
                isSavingCounter: currentState.isSavingCounter + 1
            });
            const { createInProgressIssue: createInProgressIssue } = inProgressIssueService;
            try {
                await createInProgressIssue(currentState.id, (0, $hnUIP.convertStateToInProgressIssueForStorage)(currentState));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $guiFP.default)({
                    meta: {
                        id: 'useInProgressIssueService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    attributes: {
                        eventName: 'onReinsertIntoBrowserStorage'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    restoreError: error
                });
            }
            setState({
                isSavingCounter: getState().isSavingCounter - 1
            });
        },
    init: (inProgressIssueID)=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
            if (inProgressIssueID) {
                // Get useTriggerIssueCreateModalState from storage
                const { getInProgressIssue: getInProgressIssue } = inProgressIssueService;
                try {
                    const inProgressIssue = await getInProgressIssue(inProgressIssueID);
                    setState({
                        ...inProgressIssue,
                        triggerIssueCreateModalState: inProgressIssue?.triggerIssueCreateModalState ? {
                            ...inProgressIssue?.triggerIssueCreateModalState,
                            wasStateRestored: true
                        } : undefined,
                        isInitialised: true
                    });
                } catch (error) {
                    setState({
                        restoreError: error
                    });
                }
                return getState();
            }
            setState({
                isInitialised: true
            });
            return getState();
        },
    onFormFieldConfigUpdate: ({ fieldConfig: fieldConfig })=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
            const currentState = getState();
            if (!currentState.id) return;
            let newFormDataDefaultValues = {};
            Object.values(fieldConfig).forEach((fieldData)=>{
                const { fieldId: fieldId, defaultValue: defaultValue } = fieldData;
                newFormDataDefaultValues = {
                    ...newFormDataDefaultValues,
                    [fieldId]: defaultValue
                };
            });
            setState({
                isSavingCounter: currentState.isSavingCounter + 1,
                formDataDefaultValues: newFormDataDefaultValues
            });
            const { updateInProgressIssue: updateInProgressIssue } = inProgressIssueService;
            try {
                await updateInProgressIssue(currentState.id, (0, $hnUIP.convertStateToInProgressIssueForStorage)(getState()));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $guiFP.default)({
                    meta: {
                        id: 'useInProgressIssueService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    attributes: {
                        eventName: 'onFormFieldConfigUpdate'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    restoreError: error
                });
            }
            setState({
                isSavingCounter: getState().isSavingCounter - 1
            });
        },
    onIssueTypeChange: (_)=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
            const currentState = getState();
            if (!currentState?.id || !currentState?.triggerIssueCreateModalState?.isModalOpen) {
                $e6c45d74f9b405c3$var$fireUnexpectedEventErrorAnalytics('onIssueTypeChange', currentState);
                return;
            }
            // reset form fields default values
            const newFormDataDefaultValues = {};
            setState({
                isSavingCounter: currentState.isSavingCounter + 1,
                formDataDefaultValues: newFormDataDefaultValues
            });
            const { updateInProgressIssue: updateInProgressIssue } = inProgressIssueService;
            try {
                await updateInProgressIssue(currentState.id, (0, $hnUIP.convertStateToInProgressIssueForStorage)(getState()));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $guiFP.default)({
                    meta: {
                        id: 'useInProgressIssueService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    attributes: {
                        eventName: 'onIssueTypeChange'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    restoreError: error
                });
            }
            setState({
                isSavingCounter: getState().isSavingCounter - 1
            });
        },
    onProjectFieldChange: (_)=>async ({ setState: setState, getState: getState }, { inProgressIssueService: inProgressIssueService })=>{
            const currentState = getState();
            if (!currentState?.id || !currentState?.triggerIssueCreateModalState?.isModalOpen) {
                $e6c45d74f9b405c3$var$fireUnexpectedEventErrorAnalytics('onProjectFieldChange', currentState);
                return;
            }
            // reset form fields default values
            const newFormDataDefaultValues = {};
            setState({
                isSavingCounter: currentState.isSavingCounter + 1,
                formDataDefaultValues: newFormDataDefaultValues
            });
            const { updateInProgressIssue: updateInProgressIssue } = inProgressIssueService;
            try {
                await updateInProgressIssue(currentState.id, (0, $hnUIP.convertStateToInProgressIssueForStorage)(getState()));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $guiFP.default)({
                    meta: {
                        id: 'useInProgressIssueService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    attributes: {
                        eventName: 'onProjectFieldChange'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    restoreError: error
                });
            }
            setState({
                isSavingCounter: getState().isSavingCounter - 1
            });
        },
    setRestoreError: (// eslint-disable-next-line @typescript-eslint/no-explicit-any
    restoreError)=>async ({ setState: setState })=>{
            setState({
                restoreError: restoreError
            });
        }
};
const $e6c45d74f9b405c3$var$Store = (0, $a61MH.createStore)({
    initialState: $e6c45d74f9b405c3$export$d4c72bab9d6cc13a,
    actions: $e6c45d74f9b405c3$export$e324594224ef24da
});
const $e6c45d74f9b405c3$export$4b6bb26ceba91de6 = (0, $ggKAj.createHook)($e6c45d74f9b405c3$var$Store);
const $e6c45d74f9b405c3$export$bd3e62a8e8bf35 = (0, $heB5U.createContainer)($e6c45d74f9b405c3$var$Store);
const $e6c45d74f9b405c3$export$74b9a754a809ff62 = (0, $ggKAj.createActionsHook)($e6c45d74f9b405c3$var$Store);
// Selectors
const $e6c45d74f9b405c3$var$getIsFormDirty = (state)=>state?.formContext?.isFormDirty;
const $e6c45d74f9b405c3$export$99feafa9b9955d05 = (0, $ggKAj.createHook)($e6c45d74f9b405c3$var$Store, {
    selector: $e6c45d74f9b405c3$var$getIsFormDirty
});
const $e6c45d74f9b405c3$var$getIsModalOpen = (state)=>Boolean(state?.id && state?.triggerIssueCreateModalState?.isModalOpen);
const $e6c45d74f9b405c3$export$c09953967ff9ffea = (0, $ggKAj.createHook)($e6c45d74f9b405c3$var$Store, {
    selector: $e6c45d74f9b405c3$var$getIsModalOpen
});

});
parcelRegister("hnUIP", function(module, exports) {

$parcel$export(module.exports, "convertStateToInProgressIssueForStorage", () => $b755cb970dacde46$export$2f809a820073cf71);
$parcel$export(module.exports, "isRequestType", () => $b755cb970dacde46$export$ff3afd1b5536cfed);

var $kFGm5 = parcelRequire("kFGm5");
function $b755cb970dacde46$export$2f809a820073cf71(state) {
    try {
        return {
            // removing these since they are only in InProgressIssueControllerState not InProgressIssue
            ...(0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(state, [
                'isInitialised',
                'isSavingCounter'
            ]),
            // We need to do this to remove fields that are functions etc that we can't store in indexed-db
            formContext: state?.formContext ? JSON.parse(JSON.stringify(state.formContext)) : undefined,
            triggerIssueCreateModalState: state?.triggerIssueCreateModalState ? JSON.parse(JSON.stringify(state.triggerIssueCreateModalState)) : undefined
        };
    } catch  {
        return state;
    }
}
function $b755cb970dacde46$export$ff3afd1b5536cfed(type) {
    if (!type) return false;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return type.issueTypeId !== undefined;
}

});


parcelRegister("hgWTX", function(module, exports) {

$parcel$export(module.exports, "useIssueRestoreMeta", () => $9523fe14fa549ad5$export$bad3a2f4726801fb);
$parcel$export(module.exports, "IssueRestoreMetaContainer", () => $9523fe14fa549ad5$export$e670c4748122991);
$parcel$export(module.exports, "useIssueRestoreMetaActions", () => $9523fe14fa549ad5$export$2a548b3d17373434);
$parcel$export(module.exports, "useIssueRestoreMetaSubscriptions", () => $9523fe14fa549ad5$export$270e0095f4e57380);

var $eUqFw = parcelRequire("eUqFw");

var $ggKAj = parcelRequire("ggKAj");
var $heB5U = parcelRequire("heB5U");
var $a61MH = parcelRequire("a61MH");

var $guiFP = parcelRequire("guiFP");

var $1ybV0 = parcelRequire("1ybV0");

var $dNWQB = parcelRequire("dNWQB");
var $2gOs4 = parcelRequire("2gOs4");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $bkZW3 = parcelRequire("bkZW3");
const $9523fe14fa549ad5$export$d4c72bab9d6cc13a = {
    isInitialised: false,
    isSavingCounter: 0,
    inProgressIssueMetas: [],
    restoreMetaError: undefined
};
const $9523fe14fa549ad5$export$e324594224ef24da = {
    init: ()=>async ({ setState: setState, getState: getState }, { issueRestoreMetaService: issueRestoreMetaService })=>{
            if (!getState().isInitialised) try {
                const { getIssueRestoreMeta: getIssueRestoreMeta, createIssueRestoreMeta: createIssueRestoreMeta } = issueRestoreMetaService;
                let issueRestoreMeta = await getIssueRestoreMeta();
                if (!issueRestoreMeta) issueRestoreMeta = await createIssueRestoreMeta({
                    inProgressIssueMetas: []
                });
                if (issueRestoreMeta.inProgressIssueMetas !== undefined) {
                    // filter out inProgressIssueMetas that shouldn't be restored
                    const filteredinProgressIssueMetas = issueRestoreMeta.inProgressIssueMetas.filter((inProgressIssueMeta)=>inProgressIssueMeta.shouldRestore === true);
                    issueRestoreMeta.inProgressIssueMetas = filteredinProgressIssueMetas;
                }
                setState({
                    ...issueRestoreMeta,
                    isInitialised: true
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $guiFP.default)({
                    meta: {
                        id: 'useIssueCreateMetaService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    restoreMetaError: error
                });
            }
        },
    onModalOpened: ({ inProgressIssueID: inProgressIssueID, analyticsEvent: analyticsEvent })=>async ({ setState: setState, getState: getState }, { issueRestoreMetaService: issueRestoreMetaService })=>{
            const currentState = getState();
            if (currentState.inProgressIssueMetas !== undefined) {
                if (!currentState.isInitialised || currentState.inProgressIssueMetas.map((inProgressIssueMeta)=>inProgressIssueMeta.inProgressIssueID).includes(inProgressIssueID)) return;
                // TODO this needs to be updated for bulk create
                if (currentState.inProgressIssueMetas.find((inProgressIssueMeta)=>inProgressIssueMeta.shouldRestore)) (0, $1ybV0.ff)('issue-create-restore-sentry-error-fix_exxen') && analyticsEvent ? (0, $jMP2a.fireTrackAnalytics)(analyticsEvent, 'Existing inProgressIssue onModalOpened', {
                    id: 'issueRestoreMetaOnModalOpened',
                    packageName: 'jiraIssueCreateRestore'
                }) : (0, $guiFP.default)({
                    error: new Error('Existing inProgressIssue onModalOpened'),
                    meta: {
                        id: 'issueRestoreMetaOnModalOpened',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    isSavingCounter: currentState.isSavingCounter + 1,
                    inProgressIssueMetas: [
                        {
                            inProgressIssueID: inProgressIssueID,
                            shouldRestore: true
                        }
                    ]
                });
            }
            const { updateIssueRestoreMeta: updateIssueRestoreMeta } = issueRestoreMetaService;
            try {
                await updateIssueRestoreMeta((0, $bkZW3.convertStateToIssueRestoreMeta)(getState()));
                setState({
                    isSavingCounter: getState().isSavingCounter - 1
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $guiFP.default)({
                    meta: {
                        id: 'useIssueCreateMetaService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    restoreMetaError: error
                });
            }
        },
    onModalClosed: ({ inProgressIssueID: inProgressIssueIDToBeRemoved })=>async ({ setState: setState, getState: getState }, { issueRestoreMetaService: issueRestoreMetaService })=>{
            const currentState = getState();
            const newInProgressIssueMetas = currentState.inProgressIssueMetas.filter((inProgressIssueMeta)=>inProgressIssueMeta.inProgressIssueID !== inProgressIssueIDToBeRemoved);
            setState({
                isSavingCounter: currentState.isSavingCounter + 1,
                restoreMetaError: undefined,
                inProgressIssueMetas: newInProgressIssueMetas
            });
            const { updateIssueRestoreMeta: updateIssueRestoreMeta } = issueRestoreMetaService;
            try {
                await updateIssueRestoreMeta((0, $bkZW3.convertStateToIssueRestoreMeta)(getState()));
                setState({
                    isSavingCounter: getState().isSavingCounter - 1
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $guiFP.default)({
                    meta: {
                        id: 'useIssueCreateMetaService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    restoreMetaError: error
                });
            }
        },
    setShouldRestore: (inProgressIssueID, newShouldRestore)=>async ({ getState: getState, setState: setState }, { issueRestoreMetaService: issueRestoreMetaService })=>{
            const currentState = getState();
            const inProgressIssueMetaIndex = currentState.inProgressIssueMetas.findIndex((inProgressIssueMeta)=>inProgressIssueMeta.inProgressIssueID === inProgressIssueID);
            if (inProgressIssueMetaIndex < 0) return;
            const newInProgressIssueMetas = [
                ...currentState.inProgressIssueMetas
            ];
            newInProgressIssueMetas[inProgressIssueMetaIndex] = {
                ...newInProgressIssueMetas[inProgressIssueMetaIndex],
                shouldRestore: newShouldRestore
            };
            setState({
                isSavingCounter: currentState.isSavingCounter + 1,
                inProgressIssueMetas: newInProgressIssueMetas
            });
            const { updateIssueRestoreMeta: updateIssueRestoreMeta } = issueRestoreMetaService;
            try {
                await updateIssueRestoreMeta((0, $bkZW3.convertStateToIssueRestoreMeta)(getState()));
                setState({
                    isSavingCounter: getState().isSavingCounter - 1
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $guiFP.default)({
                    meta: {
                        id: 'useIssueCreateMetaService',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                setState({
                    restoreMetaError: error
                });
            }
        }
};
const $9523fe14fa549ad5$var$Store = (0, $a61MH.createStore)({
    initialState: $9523fe14fa549ad5$export$d4c72bab9d6cc13a,
    actions: $9523fe14fa549ad5$export$e324594224ef24da
});
const $9523fe14fa549ad5$export$bad3a2f4726801fb = (0, $ggKAj.createHook)($9523fe14fa549ad5$var$Store);
const $9523fe14fa549ad5$export$e670c4748122991 = (0, $heB5U.createContainer)($9523fe14fa549ad5$var$Store);
const $9523fe14fa549ad5$export$2a548b3d17373434 = (0, $ggKAj.createActionsHook)($9523fe14fa549ad5$var$Store);
const $9523fe14fa549ad5$export$270e0095f4e57380 = ()=>{
    const { onModalOpened: onModalOpened, onModalClosed: onModalClosed } = $9523fe14fa549ad5$export$2a548b3d17373434();
    const { subscribe: subscribe } = (0, $2gOs4.useGICLifeCycleEvents)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        if (!(0, $1ybV0.ff)('issue-create-restore-sentry-error-fix_exxen')) return subscribe((0, $dNWQB.GIC_LIFECYCLE_EVENTS).MODAL_OPENED, onModalOpened);
        const analyticsEvent = createAnalyticsEvent({});
        const onOpenModal = (params)=>onModalOpened({
                ...params,
                analyticsEvent: analyticsEvent
            });
        return subscribe((0, $dNWQB.GIC_LIFECYCLE_EVENTS).MODAL_OPENED, onOpenModal);
    }, [
        createAnalyticsEvent,
        onModalOpened,
        subscribe
    ]);
    (0, $eUqFw.useEffect)(()=>subscribe((0, $dNWQB.GIC_LIFECYCLE_EVENTS).MODAL_CLOSED, onModalClosed), [
        onModalClosed,
        subscribe
    ]);
};

});
parcelRegister("bkZW3", function(module, exports) {

$parcel$export(module.exports, "convertStateToIssueRestoreMeta", () => $ae3fc6f6b22844a2$export$4494f626031edfc9);

var $kFGm5 = parcelRequire("kFGm5");
function $ae3fc6f6b22844a2$export$4494f626031edfc9(state) {
    // removing these since they are only in IssueRestoreMetaControllerState not IssueRestoreMeta
    return (0, (/*@__PURE__*/$parcel$interopDefault($kFGm5)))(state, [
        'isInitialised',
        'isSavingCounter',
        'restoreMetaError'
    ]);
}

});


parcelRegister("678Nu", function(module, exports) {

$parcel$export(module.exports, "useInProgressIssueService", () => $1404f70765935005$export$6fc1ebae2c6a92c1);

var $eUqFw = parcelRequire("eUqFw");

var $9ENT0 = parcelRequire("9ENT0");

var $guiFP = parcelRequire("guiFP");

const $1404f70765935005$export$6fc1ebae2c6a92c1 = ()=>{
    const [storage] = (0, $eUqFw.useState)(()=>(0, $9ENT0.createIndexedDBStorageProvider)(`${(0, $97b8f59b8f2fa98e$export$8fa5032778cf7801)}in-progress-issue`, {
            shouldAutoReconnect: true
        }));
    return {
        getInProgressIssue: async (inProgressIssueID)=>storage.get(inProgressIssueID),
        createInProgressIssue: async (inProgressIssueID, data)=>{
            await storage.set(inProgressIssueID, data);
            return data;
        },
        updateInProgressIssue: async (inProgressIssueID, data)=>{
            if (await storage.get(inProgressIssueID)) await storage.set(inProgressIssueID, data);
            else {
                (0, $guiFP.default)({
                    meta: {
                        id: 'updateInProgressIssue',
                        packageName: 'jiraIssueCreateRestore',
                        teamName: 'gryffindor'
                    },
                    attributes: {
                        message: "Tried to updateInProgressIssue with an inProgressIssueID that doesn't exist in indexed-db"
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                return data;
            }
            return data;
        },
        deleteInProgressIssue: async (inProgressIssueID)=>{
            await storage.remove(inProgressIssueID);
        }
    };
};

});
parcelRegister("9ENT0", function(module, exports) {

$parcel$export(module.exports, "createIndexedDBStorageProvider", () => $6d438df2aac0e8d6$export$6ba36c4f5fb8919d);

var $jqvCZ = parcelRequire("jqvCZ");

var $gAbZm = parcelRequire("gAbZm");
const $6d438df2aac0e8d6$export$6ba36c4f5fb8919d = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((appPrefix, options)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    const provider = (0, $gAbZm.createStorageProvider)(appPrefix);
    if (options?.shouldAutoReconnect) return (0, $gAbZm.withAutoReconnect)(provider);
    return provider;
});

});
parcelRegister("gAbZm", function(module, exports) {

$parcel$export(module.exports, "createStorageProvider", () => $36fa2b3f05c0cdab$export$8441605555fbd60c);
$parcel$export(module.exports, "withAutoReconnect", () => $36fa2b3f05c0cdab$export$8432fe49db7d8865);

var $k1THV = parcelRequire("k1THV");
const $36fa2b3f05c0cdab$export$7382f85ef4ff4314 = (prefix, key)=>`${prefix.replace(/_*$/, '')}__${key || ''}`;
const $36fa2b3f05c0cdab$var$createCustomStore = ()=>(0, $k1THV.createStore)('keyval-store', 'keyval');
let $36fa2b3f05c0cdab$var$customStore;
const $36fa2b3f05c0cdab$var$getStore = ()=>{
    let store = $36fa2b3f05c0cdab$var$customStore;
    if (!store) {
        $36fa2b3f05c0cdab$var$customStore = $36fa2b3f05c0cdab$var$createCustomStore();
        store = $36fa2b3f05c0cdab$var$customStore;
    }
    return store;
};
const $36fa2b3f05c0cdab$export$8441605555fbd60c = (appPrefix)=>{
    const KEYS_STORE_PREFIX = $36fa2b3f05c0cdab$export$7382f85ef4ff4314(appPrefix);
    const prefix = (key)=>$36fa2b3f05c0cdab$export$7382f85ef4ff4314(appPrefix, key);
    // Runtime check to ensure a key is provided as the prefix without a key
    // holds an array of all the keys that are prefixed by this store
    const assertKey = (key)=>{
        if (!key) throw Error('You must provide a key');
    };
    // Calling `clearAll` would require us to iterate over every key in the
    // indexed-db, filtering by this instance's prefix and subsequently deleting
    // all the filtered keys. As indexed-db gains traction within Jira, this
    // will quickly become an expensive operation. To counteract this, we
    // instead store all the keys that this instance has created so that when it
    // comes time to clear them all, we simply just have to clear every key in
    // this store. This removes the need for iterating and filtering all
    // together.
    const updateStoreKeys = async (key, remove = false)=>(0, $k1THV.update)(KEYS_STORE_PREFIX, (currentKeys)=>{
            const storeKeys = new Set(currentKeys);
            if (remove) {
                storeKeys.delete(key);
                return Array.from(storeKeys.values());
            }
            storeKeys.add(key);
            return Array.from(storeKeys.values());
        }, $36fa2b3f05c0cdab$var$getStore());
    return {
        async get (key) {
            assertKey(key);
            return (0, $k1THV.get)(prefix(key), $36fa2b3f05c0cdab$var$getStore());
        },
        async remove (key) {
            assertKey(key);
            const prefixedKey = prefix(key);
            await (0, $k1THV.del)(prefixedKey, $36fa2b3f05c0cdab$var$getStore());
            return updateStoreKeys(prefixedKey, true);
        },
        async clearAll () {
            const prefixedKeys = await (0, $k1THV.get)(KEYS_STORE_PREFIX, $36fa2b3f05c0cdab$var$getStore());
            if (!prefixedKeys || prefixedKeys.length === 0) return undefined;
            return (0, $k1THV.delMany)(prefixedKeys.concat(KEYS_STORE_PREFIX));
        },
        async set (key, value) {
            assertKey(key);
            const prefixedKey = prefix(key);
            if (typeof value === 'function') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            (0, $k1THV.update)(prefixedKey, value);
            else (0, $k1THV.set)(prefixedKey, value, $36fa2b3f05c0cdab$var$getStore());
            return updateStoreKeys(prefixedKey);
        },
        async reconnect () {
            $36fa2b3f05c0cdab$var$customStore = $36fa2b3f05c0cdab$var$createCustomStore();
        }
    };
};
const $36fa2b3f05c0cdab$export$8432fe49db7d8865 = (storageProvider)=>({
        async get (...args) {
            try {
                return await storageProvider.get(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.get(...args);
                }
                throw e;
            }
        },
        async set (...args) {
            try {
                return await storageProvider.set(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.set(...args);
                }
                throw e;
            }
        },
        async remove (...args) {
            try {
                return await storageProvider.remove(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.remove(...args);
                }
                throw e;
            }
        },
        async clearAll (...args) {
            try {
                return await storageProvider.clearAll(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.clearAll(...args);
                }
                throw e;
            }
        },
        async reconnect () {
            await storageProvider.reconnect?.();
        }
    });

});
parcelRegister("k1THV", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $e94f1cffaec1fb5e$export$f51a9068ac82ea43);
$parcel$export(module.exports, "get", () => $e94f1cffaec1fb5e$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $e94f1cffaec1fb5e$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "update", () => $e94f1cffaec1fb5e$export$722fbec263ad908a);
$parcel$export(module.exports, "del", () => $e94f1cffaec1fb5e$export$1d2f21e549771e67);
$parcel$export(module.exports, "delMany", () => $e94f1cffaec1fb5e$export$c8aa84257229cac8);
function $e94f1cffaec1fb5e$export$b327150396135fe7(request) {
    return new Promise((resolve, reject)=>{
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = ()=>resolve(request.result);
        // @ts-ignore - file size hacks
        request.onabort = request.onerror = ()=>reject(request.error);
    });
}
function $e94f1cffaec1fb5e$export$f51a9068ac82ea43(dbName, storeName) {
    const request = indexedDB.open(dbName);
    request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
    const dbp = $e94f1cffaec1fb5e$export$b327150396135fe7(request);
    return (txMode, callback)=>dbp.then((db)=>callback(db.transaction(storeName, txMode).objectStore(storeName)));
}
let $e94f1cffaec1fb5e$var$defaultGetStoreFunc;
function $e94f1cffaec1fb5e$var$defaultGetStore() {
    if (!$e94f1cffaec1fb5e$var$defaultGetStoreFunc) $e94f1cffaec1fb5e$var$defaultGetStoreFunc = $e94f1cffaec1fb5e$export$f51a9068ac82ea43('keyval-store', 'keyval');
    return $e94f1cffaec1fb5e$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e94f1cffaec1fb5e$export$3988ae62b71be9a3(key, customStore = $e94f1cffaec1fb5e$var$defaultGetStore()) {
    return customStore('readonly', (store)=>$e94f1cffaec1fb5e$export$b327150396135fe7(store.get(key)));
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e94f1cffaec1fb5e$export$adaa4cf7ef1b65be(key, value, customStore = $e94f1cffaec1fb5e$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.put(value, key);
        return $e94f1cffaec1fb5e$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e94f1cffaec1fb5e$export$daa0a5170277c7a8(entries, customStore = $e94f1cffaec1fb5e$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        entries.forEach((entry)=>store.put(entry[1], entry[0]));
        return $e94f1cffaec1fb5e$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e94f1cffaec1fb5e$export$5df405cccea42673(keys, customStore = $e94f1cffaec1fb5e$var$defaultGetStore()) {
    return customStore('readonly', (store)=>Promise.all(keys.map((key)=>$e94f1cffaec1fb5e$export$b327150396135fe7(store.get(key)))));
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e94f1cffaec1fb5e$export$722fbec263ad908a(key, updater, customStore = $e94f1cffaec1fb5e$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>// Need to create the promise manually.
        // If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise((resolve, reject)=>{
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($e94f1cffaec1fb5e$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e94f1cffaec1fb5e$export$1d2f21e549771e67(key, customStore = $e94f1cffaec1fb5e$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.delete(key);
        return $e94f1cffaec1fb5e$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e94f1cffaec1fb5e$export$c8aa84257229cac8(keys, customStore = $e94f1cffaec1fb5e$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        keys.forEach((key)=>store.delete(key));
        return $e94f1cffaec1fb5e$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e94f1cffaec1fb5e$export$42ffd38884aecdac(customStore = $e94f1cffaec1fb5e$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.clear();
        return $e94f1cffaec1fb5e$export$b327150396135fe7(store.transaction);
    });
}
function $e94f1cffaec1fb5e$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $e94f1cffaec1fb5e$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e94f1cffaec1fb5e$export$ed97f33186d4b816(customStore = $e94f1cffaec1fb5e$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        if (store.getAllKeys) return $e94f1cffaec1fb5e$export$b327150396135fe7(store.getAllKeys());
        const items = [];
        return $e94f1cffaec1fb5e$var$eachCursor(store, (cursor)=>items.push(cursor.key)).then(()=>items);
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e94f1cffaec1fb5e$export$68c286be0e7e55b7(customStore = $e94f1cffaec1fb5e$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        if (store.getAll) return $e94f1cffaec1fb5e$export$b327150396135fe7(store.getAll());
        const items = [];
        return $e94f1cffaec1fb5e$var$eachCursor(store, (cursor)=>items.push(cursor.value)).then(()=>items);
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e94f1cffaec1fb5e$export$3e9f948b41964866(customStore = $e94f1cffaec1fb5e$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $e94f1cffaec1fb5e$export$b327150396135fe7(store.getAllKeys()),
            $e94f1cffaec1fb5e$export$b327150396135fe7(store.getAll())
        ]).then(([keys, values])=>keys.map((key, i)=>[
                    key,
                    values[i]
                ]));
        const items = [];
        return customStore('readonly', (store)=>$e94f1cffaec1fb5e$var$eachCursor(store, (cursor)=>items.push([
                    cursor.key,
                    cursor.value
                ])).then(()=>items));
    });
}

});




parcelRegister("g2M7o", function(module, exports) {

$parcel$export(module.exports, "InProgressIssueInitialiser", () => $24992ec8c210e0d6$export$ee6dd146d425cafc);

var $eUqFw = parcelRequire("eUqFw");

var $6RCgV = parcelRequire("6RCgV");

var $hgWTX = parcelRequire("hgWTX");

var $9lDKn = parcelRequire("9lDKn");

var $bQesc = parcelRequire("bQesc");
const $24992ec8c210e0d6$export$ee6dd146d425cafc = ({ onRestoreTriggerIssueCreateModalState: onRestoreTriggerIssueCreateModalState, onRestoreFormContext: onRestoreFormContext, inProgressIssueID: inProgressIssueID, shouldRestore: shouldRestore, children: children })=>{
    const { init: init } = (0, $6RCgV.useInProgressIssueActions)();
    const [isInitialised, setIsInitialised] = (0, $eUqFw.useState)(false);
    const { setShouldRestore: setShouldRestore } = (0, $hgWTX.useIssueRestoreMetaActions)();
    /**
	 * We are storing initialInProgressIssue in state and passing it to IssueModalWrapper to reduce re-renders
	 * so that we don't get a re-render when the InProgressIssueController state changes
	 */ const [initialInProgressIssue, setInitialInProgressIssue] = (0, $eUqFw.useState)();
    const initialiseInProgressIssues = (0, $eUqFw.useCallback)(async ()=>{
        if (!isInitialised) {
            const inProgressIssue = await init(inProgressIssueID);
            if (shouldRestore) {
                if (inProgressIssueID && inProgressIssue) {
                    const { triggerIssueCreateModalState: triggerIssueCreateModalState, formContext: formContext } = inProgressIssue;
                    if (triggerIssueCreateModalState) onRestoreTriggerIssueCreateModalState(triggerIssueCreateModalState);
                    if (formContext) onRestoreFormContext(formContext);
                    setInitialInProgressIssue(inProgressIssue);
                }
            }
            setIsInitialised(true);
        }
    }, [
        isInitialised,
        shouldRestore,
        init,
        inProgressIssueID,
        onRestoreTriggerIssueCreateModalState,
        onRestoreFormContext
    ]);
    const setShouldRestoreForInProgressIssue = (0, $eUqFw.useCallback)((newShouldRestore)=>{
        inProgressIssueID && setShouldRestore(inProgressIssueID, newShouldRestore);
    }, [
        inProgressIssueID,
        setShouldRestore
    ]);
    (0, $eUqFw.useEffect)(()=>{
        initialiseInProgressIssues();
    }, [
        initialiseInProgressIssues
    ]);
    // transform create form props in order to set new default values
    const { onTransformCreateFormProps: onTransformCreateFormProps } = (0, $9lDKn.useRestoreFormFields)(initialInProgressIssue);
    if (!isInitialised) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bQesc.BackgroundActions), null), children?.({
        onTransformCreateFormProps: onTransformCreateFormProps,
        setShouldRestore: setShouldRestoreForInProgressIssue
    }));
};

});
parcelRegister("9lDKn", function(module, exports) {

$parcel$export(module.exports, "useRestoreFormFields", () => $e0d1ed23eda4a2ab$export$c698b427f6c94ae8);

var $eUqFw = parcelRequire("eUqFw");

var $8blac = parcelRequire("8blac");

var $1ybV0 = parcelRequire("1ybV0");

var $dNWQB = parcelRequire("dNWQB");
var $2gOs4 = parcelRequire("2gOs4");

var $St2CV = parcelRequire("St2CV");
function $e0d1ed23eda4a2ab$export$c698b427f6c94ae8(initialInProgressIssue) {
    const { subscribe: subscribe } = (0, $2gOs4.useGICLifeCycleEvents)();
    const inProgressIssue = (0, $eUqFw.useRef)();
    const fieldConfig = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>{
        inProgressIssue.current = initialInProgressIssue;
    }, [
        initialInProgressIssue
    ]);
    const onTransformCreateFormProps = (0, $eUqFw.useCallback)((createFormProps)=>{
        if (!inProgressIssue?.current) return createFormProps;
        if (inProgressIssue?.current?.formData && (0, (/*@__PURE__*/$parcel$interopDefault($8blac)))(fieldConfig.current)) {
            const transformedData = (0, $St2CV.transformFieldConfigAndDirtyFieldsCurrentSession)(inProgressIssue?.current?.formData, inProgressIssue?.current?.formDataDefaultValues, createFormProps);
            fieldConfig.current = transformedData?.fieldConfig;
        }
        return {
            ...createFormProps,
            fieldConfig: fieldConfig.current || createFormProps.fieldConfig,
            ...(0, $1ybV0.ff)('support-data-classification-field-in-gic_x6lda') && {
                classificationFieldProps: (0, $St2CV.transformClassificationLevelFieldProps)(inProgressIssue?.current?.classificationLevelField, createFormProps?.classificationFieldProps)
            },
            statusFieldProps: (0, $St2CV.transformStatusFieldProps)(inProgressIssue?.current?.statusField, createFormProps?.statusFieldProps)
        };
    }, []);
    const onReset = (0, $eUqFw.useCallback)(()=>{
        inProgressIssue.current = undefined;
        fieldConfig.current = undefined;
    }, []);
    // TODO handle for multiple GIC
    (0, $eUqFw.useEffect)(()=>subscribe((0, $dNWQB.GIC_LIFECYCLE_EVENTS).MODAL_CLOSED, onReset), [
        onReset,
        subscribe
    ]);
    (0, $eUqFw.useEffect)(()=>subscribe((0, $dNWQB.GIC_LIFECYCLE_EVENTS).MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE, onReset), [
        onReset,
        subscribe
    ]);
    (0, $eUqFw.useEffect)(()=>subscribe((0, $dNWQB.GIC_LIFECYCLE_EVENTS).PROJECT_FIELD_VALUE_CHANGE, onReset), [
        onReset,
        subscribe
    ]);
    (0, $eUqFw.useEffect)(()=>subscribe((0, $dNWQB.GIC_LIFECYCLE_EVENTS).ISSUE_TYPE_FIELD_VALUE_CHANGE, onReset), [
        onReset,
        subscribe
    ]);
    const resp = (0, $eUqFw.useMemo)(()=>({
            onTransformCreateFormProps: onTransformCreateFormProps
        }), [
        onTransformCreateFormProps
    ]);
    return resp;
}

});
parcelRegister("St2CV", function(module, exports) {

$parcel$export(module.exports, "transformFieldConfigAndDirtyFieldsCurrentSession", () => $48a69c2ac651437b$export$9c7389800790524c);
$parcel$export(module.exports, "transformStatusFieldProps", () => $48a69c2ac651437b$export$561febabfe3c6361);
$parcel$export(module.exports, "transformClassificationLevelFieldProps", () => $48a69c2ac651437b$export$6c4d1d5181504079);
const $48a69c2ac651437b$export$9c7389800790524c = (formData, formDataDefaultValues, createFormProps)=>{
    const { fieldConfig: fieldConfig = {}, dirtyFieldsCurrentSession: dirtyFieldsCurrentSession } = createFormProps;
    const newFieldConfig = {
        ...fieldConfig
    };
    const newDirtyFieldsCurrentSession = {
        ...dirtyFieldsCurrentSession?.current || {}
    };
    if (formDataDefaultValues) // adding all default values that don't already exist to the field config - defaultValueDontTransform false
    Object.keys(formDataDefaultValues).forEach((key)=>{
        // TODO what do if fieldConfig doesn't have the key? eg schema change
        if (newFieldConfig[key]) newFieldConfig[key] = {
            ...newFieldConfig[key],
            defaultValue: formDataDefaultValues[key],
            defaultValueDontTransform: false
        };
    });
    if (formData) // adding/overwriting all changed field values to the field config - defaultValueDontTransform true
    Object.keys(formData).forEach((key)=>{
        // TODO what do if fieldConfig doesn't have the key? eg schema change
        if (newFieldConfig[key]) {
            newFieldConfig[key] = {
                ...newFieldConfig[key],
                defaultValue: formData[key],
                defaultValueDontTransform: true
            };
            newDirtyFieldsCurrentSession[key] = true;
        }
    });
    dirtyFieldsCurrentSession.current = newDirtyFieldsCurrentSession;
    return {
        fieldConfig: newFieldConfig,
        dirtyFieldsCurrentSession: dirtyFieldsCurrentSession
    };
};
const $48a69c2ac651437b$export$561febabfe3c6361 = (statusField, statusFieldProps)=>{
    if (statusField?.selectedTransition) {
        const newStatusFieldProps = {
            ...statusFieldProps
        };
        newStatusFieldProps.initialTransition = statusField.selectedTransition;
        return newStatusFieldProps;
    }
    return statusFieldProps;
};
const $48a69c2ac651437b$export$6c4d1d5181504079 = (classificationLevelField, classificationFieldProps)=>{
    if (classificationLevelField?.selectedClassification) {
        const newClassificationFieldProps = {
            ...classificationFieldProps
        };
        newClassificationFieldProps.initialClassification = classificationLevelField.selectedClassification;
        return newClassificationFieldProps;
    }
    return classificationFieldProps;
};

});


parcelRegister("bQesc", function(module, exports) {

$parcel$export(module.exports, "BackgroundActions", () => $0d140205583c77b7$export$30e6eb305b44f25b);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $kKmQb = parcelRequire("kKmQb");

var $gkeGr = parcelRequire("gkeGr");

var $hgWTX = parcelRequire("hgWTX");

var $2ueSD = parcelRequire("2ueSD");

var $2cwKB = parcelRequire("2cwKB");
const $0d140205583c77b7$export$30e6eb305b44f25b = ()=>{
    // Initialise subscriptions
    (0, $2cwKB.useInProgressIssueSubscriptions)();
    (0, $hgWTX.useIssueRestoreMetaSubscriptions)();
    (0, $kKmQb.useBrowserStorageCleanup)();
    (0, $2ueSD.useShouldShowBrowserWarning)();
    const isSaving = (0, $gkeGr.useIsIssueRestoreSaving)();
    /**
   * This invisible div is to allow cypress tests to know whether or not we are saving data
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0d140205583c77b7$var$InvisibleDiv, {
        "data-testid": isSaving ? 'issue-create-restore.ui.issue-restore.in-progress-initialiser.saving' : 'issue-create-restore.ui.issue-restore.in-progress-initialiser.not-saving'
    });
};
// eslint-disable-next-line  @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $0d140205583c77b7$var$InvisibleDiv = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kKmQb", function(module, exports) {

$parcel$export(module.exports, "useBrowserStorageCleanup", () => $a3d58d181e4ceba3$export$bbca530fb1561128);

var $eUqFw = parcelRequire("eUqFw");

var $MdoH4 = parcelRequire("MdoH4");

var $guiFP = parcelRequire("guiFP");

var $dNWQB = parcelRequire("dNWQB");
var $2gOs4 = parcelRequire("2gOs4");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");

var $678Nu = parcelRequire("678Nu");

var $c09MI = parcelRequire("c09MI");

var $6RCgV = parcelRequire("6RCgV");

var $hgWTX = parcelRequire("hgWTX");

var $55tge = parcelRequire("55tge");
function $a3d58d181e4ceba3$export$95b1d08316d5a401() {
    const browserStorageCleanupService = (0, $c09MI.useBrowserStorageCleanupService)();
    const [{ inProgressIssueMetas: inProgressIssueMetas }] = (0, $hgWTX.useIssueRestoreMeta)();
    const { setRestoreError: setRestoreError } = (0, $6RCgV.useInProgressIssueActions)();
    const sessionInProgressIssueIDs = (0, $eUqFw.useMemo)(()=>inProgressIssueMetas?.filter((item)=>item.shouldRestore).map((item)=>item.inProgressIssueID) || [], [
        inProgressIssueMetas
    ]);
    const [, { onReinsertIntoBrowserStorage: onReinsertIntoBrowserStorage }] = (0, $6RCgV.useInProgressIssue)();
    const inProgressIssueService = (0, $678Nu.useInProgressIssueService)();
    const [isOpen] = (0, $6RCgV.useIsModalOpen)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    const onModalOpened = (0, $eUqFw.useCallback)(async ({ inProgressIssueID: inProgressIssueID })=>{
        const browserStorageCleanup = await browserStorageCleanupService.getBrowserStorageCleanup() // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((error)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'useBrowserStorageCleanupController',
                    packageName: 'jiraIssueCreateRestore'
                },
                error: error,
                attributes: {
                    eventName: 'onModalOpened',
                    stage: 'getBrowserStorageCleanup'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            setRestoreError && setRestoreError(error);
        });
        const newBrowserStorageCleanup = {
            ...browserStorageCleanup || {},
            inProgressIssueIDs: (0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))([
                ...browserStorageCleanup?.inProgressIssueIDs || [],
                inProgressIssueID
            ])
        };
        if (browserStorageCleanup) await browserStorageCleanupService.updateBrowserStorageCleanup(newBrowserStorageCleanup) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((error)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'useBrowserStorageCleanupController',
                    packageName: 'jiraIssueCreateRestore'
                },
                error: error,
                attributes: {
                    eventName: 'onModalOpened',
                    stage: 'updateBrowserStorageCleanup'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            setRestoreError && setRestoreError(error);
        });
        else await browserStorageCleanupService.createBrowserStorageCleanup(newBrowserStorageCleanup) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((error)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'useBrowserStorageCleanupController',
                    packageName: 'jiraIssueCreateRestore'
                },
                error: error,
                attributes: {
                    eventName: 'onModalOpened',
                    stage: 'createBrowserStorageCleanup'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            setRestoreError && setRestoreError(error);
        });
    }, [
        browserStorageCleanupService,
        setRestoreError
    ]);
    const onModalClosed = (0, $eUqFw.useCallback)(async ({ inProgressIssueID: inProgressIssueID })=>{
        const browserStorageCleanup = await browserStorageCleanupService.getBrowserStorageCleanup() // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((error)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'useBrowserStorageCleanupController',
                    packageName: 'jiraIssueCreateRestore'
                },
                error: error,
                attributes: {
                    eventName: 'onModalClosed',
                    stage: 'getBrowserStorageCleanup'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            setRestoreError && setRestoreError(error);
        });
        if (!browserStorageCleanup) return;
        const newBrowserStorageCleanup = {
            ...browserStorageCleanup,
            inProgressIssueIDs: sessionInProgressIssueIDs.filter((id)=>id !== inProgressIssueID)
        };
        // The inProgressIssueID from the onModalClosed event will be cleaned up by the standard in-progress-issue onModalClosed
        const inProgressIssueIDsToRemove = browserStorageCleanup.inProgressIssueIDs.filter((id)=>!sessionInProgressIssueIDs.includes(id));
        await Promise.all([
            browserStorageCleanupService.updateBrowserStorageCleanup(newBrowserStorageCleanup),
            ...inProgressIssueIDsToRemove.map((id)=>inProgressIssueService.deleteInProgressIssue(id))
        ]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch((error)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'useBrowserStorageCleanupController',
                    packageName: 'jiraIssueCreateRestore'
                },
                error: error,
                attributes: {
                    eventName: 'onModalClosed',
                    stage: 'promiseAll'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            setRestoreError && setRestoreError(error);
        });
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'browserStorageCleanup onModalClosed', {
            inProgressIssueIDsToRemoveLength: inProgressIssueIDsToRemove.length
        });
    }, [
        browserStorageCleanupService,
        createAnalyticsEvent,
        inProgressIssueService,
        sessionInProgressIssueIDs,
        setRestoreError
    ]);
    const onFocusWindow = (0, $eUqFw.useCallback)(async ()=>{
        if (!isOpen) return;
        // Bulk Create will need to update this for multiple
        const browserStorageCleanup = await browserStorageCleanupService.getBrowserStorageCleanup().catch((error)=>{
            (0, $guiFP.default)({
                meta: {
                    id: 'useBrowserStorageCleanupController',
                    packageName: 'jiraIssueCreateRestore'
                },
                error: error,
                attributes: {
                    eventName: 'onFocusWindow',
                    stage: 'getBrowserStorageCleanup'
                },
                sendToPrivacyUnsafeSplunk: true
            });
            setRestoreError && setRestoreError(error);
        });
        const missingInProgressIssueIDs = browserStorageCleanup && sessionInProgressIssueIDs.length ? sessionInProgressIssueIDs.filter((id)=>!browserStorageCleanup.inProgressIssueIDs.includes(id)) : [];
        if (missingInProgressIssueIDs.length) {
            await onReinsertIntoBrowserStorage();
            const newBrowserStorageCleanup = {
                ...browserStorageCleanup,
                inProgressIssueIDs: (0, (/*@__PURE__*/$parcel$interopDefault($MdoH4)))([
                    ...browserStorageCleanup?.inProgressIssueIDs || [],
                    ...missingInProgressIssueIDs
                ])
            };
            await browserStorageCleanupService.updateBrowserStorageCleanup(newBrowserStorageCleanup) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .catch((error)=>{
                (0, $guiFP.default)({
                    meta: {
                        id: 'useBrowserStorageCleanupController',
                        packageName: 'jiraIssueCreateRestore'
                    },
                    error: error,
                    attributes: {
                        eventName: 'onFocusWindow',
                        stage: 'updateBrowserStorageCleanup'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                setRestoreError && setRestoreError(error);
            });
        }
        if (missingInProgressIssueIDs.length) (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'browserStorageCleanup onFocusWindow', {
            missingInProgressIssueIDsLength: missingInProgressIssueIDs.length
        });
    }, [
        browserStorageCleanupService,
        sessionInProgressIssueIDs,
        setRestoreError,
        onReinsertIntoBrowserStorage,
        createAnalyticsEvent,
        isOpen
    ]);
    return {
        onModalOpened: onModalOpened,
        onModalClosed: onModalClosed,
        onFocusWindow: onFocusWindow
    };
}
function $a3d58d181e4ceba3$export$bbca530fb1561128() {
    const { subscribe: subscribe } = (0, $2gOs4.useGICLifeCycleEvents)();
    const { onModalOpened: onModalOpened, onModalClosed: onModalClosed, onFocusWindow: onFocusWindow } = $a3d58d181e4ceba3$export$95b1d08316d5a401();
    (0, $eUqFw.useEffect)(()=>subscribe((0, $dNWQB.GIC_LIFECYCLE_EVENTS).MODAL_OPENED, onModalOpened), [
        onModalOpened,
        subscribe
    ]);
    (0, $eUqFw.useEffect)(()=>subscribe((0, $dNWQB.GIC_LIFECYCLE_EVENTS).MODAL_CLOSED, onModalClosed), [
        onModalClosed,
        subscribe
    ]);
    (0, $55tge.useOnWindowFocus)(onFocusWindow);
}

});
parcelRegister("c09MI", function(module, exports) {

$parcel$export(module.exports, "useBrowserStorageCleanupService", () => $65f17e7454aad7eb$export$7129d99907775838);

var $eUqFw = parcelRequire("eUqFw");

var $9ENT0 = parcelRequire("9ENT0");

const $65f17e7454aad7eb$var$KEY = 'browser-storage-cleanup';
const $65f17e7454aad7eb$export$7129d99907775838 = ()=>{
    const [storage] = (0, $eUqFw.useState)((0, $9ENT0.createIndexedDBStorageProvider)(`${(0, $97b8f59b8f2fa98e$export$8fa5032778cf7801)}${$65f17e7454aad7eb$var$KEY}`, {
        shouldAutoReconnect: true
    }));
    return {
        getBrowserStorageCleanup: async ()=>storage.get($65f17e7454aad7eb$var$KEY),
        createBrowserStorageCleanup: async (data)=>{
            await storage.set($65f17e7454aad7eb$var$KEY, data);
            return data;
        },
        updateBrowserStorageCleanup: async (data)=>{
            await storage.set($65f17e7454aad7eb$var$KEY, data);
            return data;
        },
        deleteBrowserStorageCleanup: async ()=>{
            await storage.remove($65f17e7454aad7eb$var$KEY);
        }
    };
};

});

parcelRegister("55tge", function(module, exports) {

$parcel$export(module.exports, "useOnWindowFocus", () => $bdf011958749817b$export$921321d14c966d8f);

var $eUqFw = parcelRequire("eUqFw");
function $bdf011958749817b$export$921321d14c966d8f(onFocus) {
    const onVisibilityChange = (0, $eUqFw.useCallback)(()=>{
        if (document.visibilityState === 'visible') onFocus();
    }, [
        onFocus
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (window?.addEventListener) {
            window.addEventListener('visibilitychange', onVisibilityChange, false);
            window.addEventListener('focus', onFocus, false);
        }
        return ()=>{
            if (window?.removeEventListener) {
                window.removeEventListener('visibilitychange', onVisibilityChange);
                window.removeEventListener('focus', onFocus);
            }
        };
    });
}

});


parcelRegister("gkeGr", function(module, exports) {

$parcel$export(module.exports, "useIsIssueRestoreSaving", () => $a463129f4c551411$export$c3cd53fd21626217);

var $6RCgV = parcelRequire("6RCgV");

var $hgWTX = parcelRequire("hgWTX");
const $a463129f4c551411$export$c3cd53fd21626217 = ()=>{
    const [{ isSavingCounter: isSavingCounterInProgressIssue }] = (0, $6RCgV.useInProgressIssue)();
    const [{ isSavingCounter: isSavingCounterIssueRestoreMeta }] = (0, $hgWTX.useIssueRestoreMeta)();
    return !(isSavingCounterInProgressIssue === 0 && isSavingCounterIssueRestoreMeta === 0);
};

});

parcelRegister("2ueSD", function(module, exports) {

$parcel$export(module.exports, "useShouldShowBrowserWarning", () => $cf3320beabe99880$export$b44a00b70df66767);

var $fJcoT = parcelRequire("fJcoT");

var $6RCgV = parcelRequire("6RCgV");

var $gkeGr = parcelRequire("gkeGr");

var $hB2hV = parcelRequire("hB2hV");
const $cf3320beabe99880$export$b44a00b70df66767 = ()=>{
    const [isModalOpen] = (0, $6RCgV.useIsModalOpen)();
    const [isFormDirty] = (0, $6RCgV.useIsFormDirty)();
    const isFormSavingIssueRestore = (0, $gkeGr.useIsIssueRestoreSaving)();
    const hasRestoreFailed = (0, $fJcoT.useHasRestoreFailed)();
    const shouldForceBlock = isModalOpen && (hasRestoreFailed || isFormSavingIssueRestore);
    (0, $hB2hV.useNavigationBlock)({
        forceBlock: shouldForceBlock,
        shouldAttemptNavigationBlock: Boolean(isModalOpen && isFormDirty)
    });
};

});
parcelRegister("fJcoT", function(module, exports) {

$parcel$export(module.exports, "useHasRestoreFailed", () => $19941aabb6ec188a$export$2f3853c4298a8e98);

var $6RCgV = parcelRequire("6RCgV");

var $hgWTX = parcelRequire("hgWTX");
const $19941aabb6ec188a$export$2f3853c4298a8e98 = ()=>{
    const [{ restoreError: restoreError }] = (0, $6RCgV.useInProgressIssue)();
    const [{ restoreMetaError: restoreMetaError }] = (0, $hgWTX.useIssueRestoreMeta)();
    return Boolean(restoreError || restoreMetaError);
};

});

parcelRegister("hB2hV", function(module, exports) {

$parcel$export(module.exports, "useNavigationBlock", () => $84eb40bf2bc43043$export$6948be8e76411f59);
/**
 * See https://hello.atlassian.net/wiki/spaces/JSDee/pages/2143585806/Faux+Spa+-+Closing+the+tab
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $jMP2a = parcelRequire("jMP2a");
var $bFzGY = parcelRequire("bFzGY");
function $84eb40bf2bc43043$var$isSameOrigin(destination) {
    const destinationOrigin = new URL(destination).origin;
    return window.location.origin === destinationOrigin;
}
const $84eb40bf2bc43043$var$useIsSameOriginNavigationAPI = ({ isNavigatingWithinSameOrigin: isNavigatingWithinSameOrigin, isEnabled: isEnabled })=>{
    const onNavigate = (0, $eUqFw.useCallback)((e)=>{
        if (e.destination.sameDocument) // when we navigate through the same document (spa -> spa) onBeforeUnload won't be called, so we can instead reset isNavigatingWithinSameOrigin
        // eslint-disable-next-line no-param-reassign
        isNavigatingWithinSameOrigin.current = false; // reset
        else // eslint-disable-next-line no-param-reassign
        isNavigatingWithinSameOrigin.current = $84eb40bf2bc43043$var$isSameOrigin(e.destination.url);
        return isNavigatingWithinSameOrigin.current;
    }, [
        isNavigatingWithinSameOrigin
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // only available in newer versions of chrome, opera, and edge
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        const { navigation: navigation } = window;
        if (isEnabled && navigation) {
            navigation.addEventListener('navigate', onNavigate);
            return ()=>navigation.removeEventListener('navigate', onNavigate);
        }
        return undefined;
    }, [
        isEnabled,
        onNavigate
    ]);
    // for testing
    return {
        onNavigate: onNavigate
    };
};
const $84eb40bf2bc43043$export$6948be8e76411f59 = ({ forceBlock: forceBlock = false, shouldAttemptNavigationBlock: shouldAttemptNavigationBlock })=>{
    const isNavigatingWithinSameOrigin = (0, $eUqFw.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bFzGY.useAnalyticsEvents)();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    const hasNavigationApi = Boolean(window.navigation);
    const { onNavigate: onNavigate } = $84eb40bf2bc43043$var$useIsSameOriginNavigationAPI({
        isEnabled: hasNavigationApi,
        isNavigatingWithinSameOrigin: isNavigatingWithinSameOrigin
    });
    const onBeforeUnload = (0, $eUqFw.useCallback)((e)=>{
        const analyticsPayload = {
            hasNavigationApi: hasNavigationApi,
            forceBlock: forceBlock,
            isNavigatingWithinSameOrigin: isNavigatingWithinSameOrigin.current,
            shouldAttemptNavigationBlock: shouldAttemptNavigationBlock
        };
        const shouldBlockNavigation = forceBlock || shouldAttemptNavigationBlock && !isNavigatingWithinSameOrigin.current;
        isNavigatingWithinSameOrigin.current = false; // reset
        if (shouldBlockNavigation) {
            (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'useNavigationBlock showBrowserUnloadPrompt', analyticsPayload);
            e.preventDefault(); // Firefox
            const message = '';
            // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'boolean'.
            e.returnValue = message; // Chrome
            return message; // IE
        }
        (0, $jMP2a.fireOperationalAnalytics)(createAnalyticsEvent({}), 'useNavigationBlock dontShowBrowserUnloadPrompt', analyticsPayload);
        return undefined;
    }, [
        createAnalyticsEvent,
        forceBlock,
        hasNavigationApi,
        shouldAttemptNavigationBlock
    ]);
    /**
	 * Note: beforeunload will not block user closing the tab if
	 * the user has not interacted with the page
	 */ (0, $eUqFw.useEffect)(()=>{
        window.addEventListener('beforeunload', onBeforeUnload);
        return ()=>window.removeEventListener('beforeunload', onBeforeUnload);
    }, [
        onBeforeUnload
    ]);
    /**
	 * Returning these functions to expose them for unit testing
	 */ return {
        onBeforeUnload: onBeforeUnload,
        onNavigate: onNavigate
    };
};

});


parcelRegister("2cwKB", function(module, exports) {

$parcel$export(module.exports, "useInProgressIssueSubscriptions", () => $feb44edf83c4b335$export$9b41c2cd5817917a);

var $eUqFw = parcelRequire("eUqFw");

var $a576Y = parcelRequire("a576Y");

var $1ybV0 = parcelRequire("1ybV0");

var $dNWQB = parcelRequire("dNWQB");
var $2gOs4 = parcelRequire("2gOs4");

var $fJcoT = parcelRequire("fJcoT");

var $6RCgV = parcelRequire("6RCgV");
const $feb44edf83c4b335$var$THROTTLE_DELAY = 250;
const $feb44edf83c4b335$export$9b41c2cd5817917a = ()=>{
    const [, { onFormFieldUpdate: onFormFieldUpdate, onModalOpened: onModalOpened, onModalClosed: onModalClosed, onModalDiscardExistingInProgressIssue: onModalDiscardExistingInProgressIssue, onFormContextUpdate: onFormContextUpdate, onTriggerIssueCreateModalStateChange: onTriggerIssueCreateModalStateChange, onStatusFieldChange: onStatusFieldChange, onClassificationLevelFieldChange: onClassificationLevelFieldChange, onResetFormFieldsForCreateAnother: onResetFormFieldsForCreateAnother, onFormFieldConfigUpdate: onFormFieldConfigUpdate, onIssueTypeChange: onIssueTypeChange, onProjectFieldChange: onProjectFieldChange }] = (0, $6RCgV.useInProgressIssue)();
    const hasRestoreFailed = (0, $fJcoT.useHasRestoreFailed)();
    const shouldSubscribe = !hasRestoreFailed;
    const { subscribe: subscribe } = (0, $2gOs4.useGICLifeCycleEvents)();
    const throttledOnFormFieldUpdate = (0, $eUqFw.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($a576Y)))(onFormFieldUpdate, $feb44edf83c4b335$var$THROTTLE_DELAY, {
            leading: true,
            trailing: true
        }), [
        onFormFieldUpdate
    ]);
    (0, $eUqFw.useEffect)(()=>shouldSubscribe ? subscribe((0, $dNWQB.GIC_LIFECYCLE_EVENTS).CREATE_FORM_FIELD_VALUE_CHANGE, throttledOnFormFieldUpdate) : undefined, [
        throttledOnFormFieldUpdate,
        subscribe,
        shouldSubscribe
    ]);
    (0, $eUqFw.useEffect)(()=>shouldSubscribe ? subscribe((0, $dNWQB.GIC_LIFECYCLE_EVENTS).FORM_CONTEXT_STATE_CHANGE, onFormContextUpdate) : undefined, [
        onFormContextUpdate,
        subscribe,
        shouldSubscribe
    ]);
    (0, $eUqFw.useEffect)(()=>shouldSubscribe ? subscribe((0, $dNWQB.GIC_LIFECYCLE_EVENTS).MODAL_OPENED, onModalOpened) : undefined, [
        onModalOpened,
        subscribe,
        shouldSubscribe
    ]);
    (0, $eUqFw.useEffect)(()=>shouldSubscribe ? subscribe((0, $dNWQB.GIC_LIFECYCLE_EVENTS).MODAL_CLOSED, onModalClosed) : undefined, [
        onModalClosed,
        shouldSubscribe,
        subscribe
    ]);
    (0, $eUqFw.useEffect)(()=>shouldSubscribe ? subscribe((0, $dNWQB.GIC_LIFECYCLE_EVENTS).RESET_FORM_FIELDS_FOR_CREATE_ANOTHER, onResetFormFieldsForCreateAnother) : undefined, [
        onResetFormFieldsForCreateAnother,
        subscribe,
        shouldSubscribe
    ]);
    (0, $eUqFw.useEffect)(()=>{
        shouldSubscribe ? subscribe((0, $dNWQB.GIC_LIFECYCLE_EVENTS).USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE, onTriggerIssueCreateModalStateChange) : undefined;
    }, [
        onTriggerIssueCreateModalStateChange,
        subscribe,
        shouldSubscribe
    ]);
    (0, $eUqFw.useEffect)(()=>shouldSubscribe ? subscribe((0, $dNWQB.GIC_LIFECYCLE_EVENTS).STATUS_FIELD_STATE_CHANGE, onStatusFieldChange) : undefined, [
        onStatusFieldChange,
        subscribe,
        shouldSubscribe
    ]);
    (0, $eUqFw.useEffect)(()=>(0, $1ybV0.ff)('support-data-classification-field-in-gic_x6lda') && shouldSubscribe ? subscribe((0, $dNWQB.GIC_LIFECYCLE_EVENTS).CLASSIFICATION_LEVEL_FIELD_CHANGE, onClassificationLevelFieldChange) : undefined, [
        onClassificationLevelFieldChange,
        subscribe,
        shouldSubscribe
    ]);
    (0, $eUqFw.useEffect)(()=>shouldSubscribe ? subscribe((0, $dNWQB.GIC_LIFECYCLE_EVENTS).CREATE_FORM_FIELD_CONFIG_UPDATE, onFormFieldConfigUpdate) : undefined, [
        onFormFieldConfigUpdate,
        subscribe,
        shouldSubscribe
    ]);
    (0, $eUqFw.useEffect)(()=>shouldSubscribe ? subscribe((0, $dNWQB.GIC_LIFECYCLE_EVENTS).ISSUE_TYPE_FIELD_VALUE_CHANGE, onIssueTypeChange) : undefined, [
        onIssueTypeChange,
        subscribe,
        shouldSubscribe
    ]);
    (0, $eUqFw.useEffect)(()=>shouldSubscribe ? subscribe((0, $dNWQB.GIC_LIFECYCLE_EVENTS).PROJECT_FIELD_VALUE_CHANGE, onProjectFieldChange) : undefined, [
        onProjectFieldChange,
        subscribe,
        shouldSubscribe
    ]);
    (0, $eUqFw.useEffect)(()=>shouldSubscribe ? subscribe((0, $dNWQB.GIC_LIFECYCLE_EVENTS).MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE, onModalDiscardExistingInProgressIssue) : undefined, [
        onModalDiscardExistingInProgressIssue,
        shouldSubscribe,
        subscribe
    ]);
};

});



parcelRegister("8OXEV", function(module, exports) {

$parcel$export(module.exports, "isIndexedDBAvailable", () => $0958e9688d11ecfd$export$3865db50535c2055);
function $0958e9688d11ecfd$export$3865db50535c2055() {
    try {
        // Do a indexedDB.databases check for Firefox incognito (indexedDB will exist but fail to open databases)
        return Boolean('indexedDB' in window) && Boolean(indexedDB?.databases());
    } catch (e) {
        return false;
    }
}

});





//# sourceMappingURL=async-jira-issue-create.eed14191.js.map
